
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$na(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$t(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$t(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$qa = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$ra(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$qa, $0b2e6adb871a3b94$var$ra);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$t(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$qa, $0b2e6adb871a3b94$var$ra);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$t(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$qa, $0b2e6adb871a3b94$var$ra);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$t(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$t("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$t(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$sa(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$pa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ta = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$ua = Symbol.for("react.element"), $0b2e6adb871a3b94$var$va = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$xa = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$za = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ha = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ia = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ja(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ia && a[$0b2e6adb871a3b94$var$Ia] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$Ka;
function $0b2e6adb871a3b94$var$La(a) {
    if (void 0 === $0b2e6adb871a3b94$var$Ka) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$Ka = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$Ka + a;
}
var $0b2e6adb871a3b94$var$Ma = !1;
function $0b2e6adb871a3b94$var$Na(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Ma) return "";
    $0b2e6adb871a3b94$var$Ma = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Ma = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$La(a) : "";
}
function $0b2e6adb871a3b94$var$Oa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$La(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$La("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$La("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$La("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Na(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Na(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Na(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Pa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$wa:
            return "Fragment";
        case $0b2e6adb871a3b94$var$va:
            return "Portal";
        case $0b2e6adb871a3b94$var$za:
            return "Profiler";
        case $0b2e6adb871a3b94$var$xa:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Da:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Ea:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ba:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Aa:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Ca:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Fa:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Pa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ga:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Pa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Qa(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Pa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$xa ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Sa(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = $0b2e6adb871a3b94$var$Sa(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Ua(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ta(a));
}
function $0b2e6adb871a3b94$var$Va(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Sa(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Wa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Xa(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Ra(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$sa(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$$a(a, b) {
    $0b2e6adb871a3b94$var$Za(a, b);
    var c = $0b2e6adb871a3b94$var$Ra(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$bb(a, b.type, $0b2e6adb871a3b94$var$Ra(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$bb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Wa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$db = Array.isArray;
function $0b2e6adb871a3b94$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Ra(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$db(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Ra(c)
    };
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = $0b2e6adb871a3b94$var$Ra(b.value), d = $0b2e6adb871a3b94$var$Ra(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$lb, $0b2e6adb871a3b94$var$mb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$lb = $0b2e6adb871a3b94$var$lb || document.createElement("div");
        $0b2e6adb871a3b94$var$lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$lb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$nb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$ob = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$pb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$ob).forEach(function(a) {
    $0b2e6adb871a3b94$var$pb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$ob[b] = $0b2e6adb871a3b94$var$ob[a];
    });
});
function $0b2e6adb871a3b94$var$qb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$ob.hasOwnProperty(a) && $0b2e6adb871a3b94$var$ob[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$rb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$qb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$sb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$tb(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$sb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$vb = null;
function $0b2e6adb871a3b94$var$wb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$xb = null, $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null;
function $0b2e6adb871a3b94$var$Ab(a) {
    if (a = $0b2e6adb871a3b94$var$Bb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$xb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Cb(b), $0b2e6adb871a3b94$var$xb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Db(a) {
    $0b2e6adb871a3b94$var$yb ? $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$zb.push(a) : $0b2e6adb871a3b94$var$zb = [
        a
    ] : $0b2e6adb871a3b94$var$yb = a;
}
function $0b2e6adb871a3b94$var$Eb() {
    if ($0b2e6adb871a3b94$var$yb) {
        var a = $0b2e6adb871a3b94$var$yb, b = $0b2e6adb871a3b94$var$zb;
        $0b2e6adb871a3b94$var$zb = $0b2e6adb871a3b94$var$yb = null;
        $0b2e6adb871a3b94$var$Ab(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Ab(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Fb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Gb() {}
var $0b2e6adb871a3b94$var$Hb = !1;
function $0b2e6adb871a3b94$var$Ib(a, b, c) {
    if ($0b2e6adb871a3b94$var$Hb) return a(b, c);
    $0b2e6adb871a3b94$var$Hb = !0;
    try {
        return $0b2e6adb871a3b94$var$Fb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Hb = !1, null !== $0b2e6adb871a3b94$var$yb || null !== $0b2e6adb871a3b94$var$zb) $0b2e6adb871a3b94$var$Gb(), $0b2e6adb871a3b94$var$Eb();
    }
}
function $0b2e6adb871a3b94$var$Jb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Cb(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Kb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Lb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Lb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Kb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Lb, $0b2e6adb871a3b94$var$Lb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Lb, $0b2e6adb871a3b94$var$Lb);
} catch (a) {
    $0b2e6adb871a3b94$var$Kb = !1;
}
function $0b2e6adb871a3b94$var$Mb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $0b2e6adb871a3b94$var$Nb = !1, $0b2e6adb871a3b94$var$Ob = null, $0b2e6adb871a3b94$var$Pb = !1, $0b2e6adb871a3b94$var$Qb = null, $0b2e6adb871a3b94$var$Rb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Nb = !0;
        $0b2e6adb871a3b94$var$Ob = a;
    }
};
function $0b2e6adb871a3b94$var$Sb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Nb = !1;
    $0b2e6adb871a3b94$var$Ob = null;
    $0b2e6adb871a3b94$var$Mb.apply($0b2e6adb871a3b94$var$Rb, arguments);
}
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Sb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Nb) {
        if ($0b2e6adb871a3b94$var$Nb) {
            var l = $0b2e6adb871a3b94$var$Ob;
            $0b2e6adb871a3b94$var$Nb = !1;
            $0b2e6adb871a3b94$var$Ob = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Pb || ($0b2e6adb871a3b94$var$Pb = !0, $0b2e6adb871a3b94$var$Qb = l);
    }
}
function $0b2e6adb871a3b94$var$Ub(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Vb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if ($0b2e6adb871a3b94$var$Ub(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Xb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Ub(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Wb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Wb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Yb(a) {
    a = $0b2e6adb871a3b94$var$Xb(a);
    return null !== a ? $0b2e6adb871a3b94$var$Zb(a) : null;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$Zb(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$$b = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$ac = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$jc = null, $0b2e6adb871a3b94$var$kc = null;
function $0b2e6adb871a3b94$var$lc(a) {
    if ($0b2e6adb871a3b94$var$kc && "function" === typeof $0b2e6adb871a3b94$var$kc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$kc.onCommitFiberRoot($0b2e6adb871a3b94$var$jc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$nc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$mc, $0b2e6adb871a3b94$var$oc = Math.log, $0b2e6adb871a3b94$var$pc = Math.LN2;
function $0b2e6adb871a3b94$var$mc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$oc(a) / $0b2e6adb871a3b94$var$pc | 0) | 0;
}
var $0b2e6adb871a3b94$var$qc = 64, $0b2e6adb871a3b94$var$rc = 4194304;
function $0b2e6adb871a3b94$var$sc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$tc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$sc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$sc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$sc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$sc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$nc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$nc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$uc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$xc() {
    var a = $0b2e6adb871a3b94$var$qc;
    $0b2e6adb871a3b94$var$qc <<= 1;
    0 === ($0b2e6adb871a3b94$var$qc & 4194240) && ($0b2e6adb871a3b94$var$qc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$yc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$zc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$nc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Ac(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$nc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$nc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Cc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Dc, $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic = !1, $0b2e6adb871a3b94$var$Jc = [], $0b2e6adb871a3b94$var$Kc = null, $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = new Map, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = [], $0b2e6adb871a3b94$var$Qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Rc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Sc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Bb(b), null !== b && $0b2e6adb871a3b94$var$Ec(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Kc = $0b2e6adb871a3b94$var$Sc($0b2e6adb871a3b94$var$Kc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Sc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Sc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Nc.set(f, $0b2e6adb871a3b94$var$Sc($0b2e6adb871a3b94$var$Nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Sc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Uc(a) {
    var b = $0b2e6adb871a3b94$var$Vc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Ub(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Vb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Hc(a.priority, function() {
                        $0b2e6adb871a3b94$var$Fc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Wc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Xc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$vb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$vb = null;
        } else return b = $0b2e6adb871a3b94$var$Bb(c), null !== b && $0b2e6adb871a3b94$var$Ec(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Yc(a, b, c) {
    $0b2e6adb871a3b94$var$Wc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$Zc() {
    $0b2e6adb871a3b94$var$Ic = !1;
    null !== $0b2e6adb871a3b94$var$Kc && $0b2e6adb871a3b94$var$Wc($0b2e6adb871a3b94$var$Kc) && ($0b2e6adb871a3b94$var$Kc = null);
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Wc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Wc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    $0b2e6adb871a3b94$var$Nc.forEach($0b2e6adb871a3b94$var$Yc);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Yc);
}
function $0b2e6adb871a3b94$var$$c(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Ic || ($0b2e6adb871a3b94$var$Ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Zc)));
}
function $0b2e6adb871a3b94$var$ad(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$$c(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Jc.length) {
        $0b2e6adb871a3b94$var$$c($0b2e6adb871a3b94$var$Jc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Jc.length; c++){
            var d = $0b2e6adb871a3b94$var$Jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Kc && $0b2e6adb871a3b94$var$$c($0b2e6adb871a3b94$var$Kc, a);
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$$c($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$$c($0b2e6adb871a3b94$var$Mc, a);
    $0b2e6adb871a3b94$var$Nc.forEach(b);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Pc.length; c++)d = $0b2e6adb871a3b94$var$Pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Pc.length && (c = $0b2e6adb871a3b94$var$Pc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Uc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Pc.shift();
}
var $0b2e6adb871a3b94$var$bd = $0b2e6adb871a3b94$var$ta.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$cd = !0;
function $0b2e6adb871a3b94$var$dd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$bd.transition;
    $0b2e6adb871a3b94$var$bd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$ed(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$bd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$bd.transition;
    $0b2e6adb871a3b94$var$bd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$ed(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$bd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$cd) {
        var e = $0b2e6adb871a3b94$var$Xc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$gd(a, b, d, $0b2e6adb871a3b94$var$hd, c), $0b2e6adb871a3b94$var$Rc(a, d);
        else if ($0b2e6adb871a3b94$var$Tc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Rc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Qc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Bb(e);
                null !== f && $0b2e6adb871a3b94$var$Dc(f);
                f = $0b2e6adb871a3b94$var$Xc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$gd(a, b, d, $0b2e6adb871a3b94$var$hd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$gd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$hd = null;
function $0b2e6adb871a3b94$var$Xc(a, b, c, d) {
    $0b2e6adb871a3b94$var$hd = null;
    a = $0b2e6adb871a3b94$var$wb(d);
    a = $0b2e6adb871a3b94$var$Vc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Ub(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Vb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$hd = a;
    return null;
}
function $0b2e6adb871a3b94$var$id(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$dc()){
                case $0b2e6adb871a3b94$var$ec:
                    return 1;
                case $0b2e6adb871a3b94$var$fc:
                    return 4;
                case $0b2e6adb871a3b94$var$gc:
                case $0b2e6adb871a3b94$var$hc:
                    return 16;
                case $0b2e6adb871a3b94$var$ic:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$jd = null, $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null;
function $0b2e6adb871a3b94$var$md() {
    if ($0b2e6adb871a3b94$var$ld) return $0b2e6adb871a3b94$var$ld;
    var a, b = $0b2e6adb871a3b94$var$kd, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$jd ? $0b2e6adb871a3b94$var$jd.value : $0b2e6adb871a3b94$var$jd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$ld = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$nd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$od() {
    return !0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !1;
}
function $0b2e6adb871a3b94$var$qd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$od : $0b2e6adb871a3b94$var$pd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$pd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$od);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$od);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$od
    });
    return b;
}
var $0b2e6adb871a3b94$var$rd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$sd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$rd), $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$rd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$td), $0b2e6adb871a3b94$var$vd, $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$zd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$td, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$yd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$xd && ($0b2e6adb871a3b94$var$xd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$vd = a.screenX - $0b2e6adb871a3b94$var$xd.screenX, $0b2e6adb871a3b94$var$wd = a.screenY - $0b2e6adb871a3b94$var$xd.screenY) : $0b2e6adb871a3b94$var$wd = $0b2e6adb871a3b94$var$vd = 0, $0b2e6adb871a3b94$var$xd = a);
        return $0b2e6adb871a3b94$var$vd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$wd;
    }
}), $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$zd), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$zd, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Bd), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$td, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Dd), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$rd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Fd), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$rd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Hd), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$rd, {
    data: 0
}), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Jd), $0b2e6adb871a3b94$var$Ld = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Md = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Nd = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Od(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Nd[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$yd() {
    return $0b2e6adb871a3b94$var$Od;
}
var $0b2e6adb871a3b94$var$Pd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$td, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Ld[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$nd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Md[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$yd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$nd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$nd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Pd), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$zd, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Rd), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$td, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$yd
}), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Td), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$rd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Vd), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$zd, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$qd($0b2e6adb871a3b94$var$Xd), $0b2e6adb871a3b94$var$Zd = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$$d = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$ae = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$ae = document.documentMode);
var $0b2e6adb871a3b94$var$be = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$ae, $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$$d || $0b2e6adb871a3b94$var$ae && 8 < $0b2e6adb871a3b94$var$ae && 11 >= $0b2e6adb871a3b94$var$ae), $0b2e6adb871a3b94$var$de = String.fromCharCode(32), $0b2e6adb871a3b94$var$ee = !1;
function $0b2e6adb871a3b94$var$fe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$Zd.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$ge(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$he = !1;
function $0b2e6adb871a3b94$var$ie(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$ge(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$ee = !0;
            return $0b2e6adb871a3b94$var$de;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$de && $0b2e6adb871a3b94$var$ee ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$je(a, b) {
    if ($0b2e6adb871a3b94$var$he) return "compositionend" === a || !$0b2e6adb871a3b94$var$$d && $0b2e6adb871a3b94$var$fe(a, b) ? (a = $0b2e6adb871a3b94$var$md(), $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = $0b2e6adb871a3b94$var$jd = null, $0b2e6adb871a3b94$var$he = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$ce && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$ke = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$le(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$ke[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$me(a, b, c, d) {
    $0b2e6adb871a3b94$var$Db(d);
    b = $0b2e6adb871a3b94$var$ne(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$sd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$oe = null, $0b2e6adb871a3b94$var$pe = null;
function $0b2e6adb871a3b94$var$qe(a) {
    $0b2e6adb871a3b94$var$re(a, 0);
}
function $0b2e6adb871a3b94$var$se(a) {
    var b = $0b2e6adb871a3b94$var$te(a);
    if ($0b2e6adb871a3b94$var$Va(b)) return a;
}
function $0b2e6adb871a3b94$var$ue(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$ve = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$we;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$xe = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$xe) {
            var $0b2e6adb871a3b94$var$ye = document.createElement("div");
            $0b2e6adb871a3b94$var$ye.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$xe = "function" === typeof $0b2e6adb871a3b94$var$ye.oninput;
        }
        $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe;
    } else $0b2e6adb871a3b94$var$we = !1;
    $0b2e6adb871a3b94$var$ve = $0b2e6adb871a3b94$var$we && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$ze() {
    $0b2e6adb871a3b94$var$oe && ($0b2e6adb871a3b94$var$oe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Ae), $0b2e6adb871a3b94$var$pe = $0b2e6adb871a3b94$var$oe = null);
}
function $0b2e6adb871a3b94$var$Ae(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$se($0b2e6adb871a3b94$var$pe)) {
        var b = [];
        $0b2e6adb871a3b94$var$me(b, $0b2e6adb871a3b94$var$pe, a, $0b2e6adb871a3b94$var$wb(a));
        $0b2e6adb871a3b94$var$Ib($0b2e6adb871a3b94$var$qe, b);
    }
}
function $0b2e6adb871a3b94$var$Be(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$ze(), $0b2e6adb871a3b94$var$oe = b, $0b2e6adb871a3b94$var$pe = c, $0b2e6adb871a3b94$var$oe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Ae)) : "focusout" === a && $0b2e6adb871a3b94$var$ze();
}
function $0b2e6adb871a3b94$var$Ce(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$se($0b2e6adb871a3b94$var$pe);
}
function $0b2e6adb871a3b94$var$De(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$se(b);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$se(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$Ge = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Fe;
function $0b2e6adb871a3b94$var$He(a, b) {
    if ($0b2e6adb871a3b94$var$Ge(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$Ge(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ie(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Je(a, b) {
    var c = $0b2e6adb871a3b94$var$Ie(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Ie(c);
    }
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Ke(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Le() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Wa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Wa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = $0b2e6adb871a3b94$var$Le(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Ke(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Me(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Je(c, f);
                var g = $0b2e6adb871a3b94$var$Je(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Oe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Pe = null, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = !1;
function $0b2e6adb871a3b94$var$Te(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Se || null == $0b2e6adb871a3b94$var$Pe || $0b2e6adb871a3b94$var$Pe !== $0b2e6adb871a3b94$var$Wa(d) || (d = $0b2e6adb871a3b94$var$Pe, "selectionStart" in d && $0b2e6adb871a3b94$var$Me(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Re && $0b2e6adb871a3b94$var$He($0b2e6adb871a3b94$var$Re, d) || ($0b2e6adb871a3b94$var$Re = d, d = $0b2e6adb871a3b94$var$ne($0b2e6adb871a3b94$var$Qe, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$sd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Pe)));
}
function $0b2e6adb871a3b94$var$Ue(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$Ve = {
    animationend: $0b2e6adb871a3b94$var$Ue("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ue("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ue("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ue("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$We = {}, $0b2e6adb871a3b94$var$Xe = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Xe = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$Ve.animationend.animation, delete $0b2e6adb871a3b94$var$Ve.animationiteration.animation, delete $0b2e6adb871a3b94$var$Ve.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$Ve.transitionend.transition);
function $0b2e6adb871a3b94$var$Ye(a) {
    if ($0b2e6adb871a3b94$var$We[a]) return $0b2e6adb871a3b94$var$We[a];
    if (!$0b2e6adb871a3b94$var$Ve[a]) return a;
    var b = $0b2e6adb871a3b94$var$Ve[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Xe) return $0b2e6adb871a3b94$var$We[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$Ze = $0b2e6adb871a3b94$var$Ye("animationend"), $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ye("animationiteration"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ye("animationstart"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ye("transitionend"), $0b2e6adb871a3b94$var$cf = new Map, $0b2e6adb871a3b94$var$df = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ef(a, b) {
    $0b2e6adb871a3b94$var$cf.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$ff = 0; $0b2e6adb871a3b94$var$ff < $0b2e6adb871a3b94$var$df.length; $0b2e6adb871a3b94$var$ff++){
    var $0b2e6adb871a3b94$var$gf = $0b2e6adb871a3b94$var$df[$0b2e6adb871a3b94$var$ff], $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$gf.toLowerCase(), $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$gf[0].toUpperCase() + $0b2e6adb871a3b94$var$gf.slice(1);
    $0b2e6adb871a3b94$var$ef($0b2e6adb871a3b94$var$hf, "on" + $0b2e6adb871a3b94$var$jf);
}
$0b2e6adb871a3b94$var$ef($0b2e6adb871a3b94$var$Ze, "onAnimationEnd");
$0b2e6adb871a3b94$var$ef($0b2e6adb871a3b94$var$$e, "onAnimationIteration");
$0b2e6adb871a3b94$var$ef($0b2e6adb871a3b94$var$af, "onAnimationStart");
$0b2e6adb871a3b94$var$ef("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ef("focusin", "onFocus");
$0b2e6adb871a3b94$var$ef("focusout", "onBlur");
$0b2e6adb871a3b94$var$ef($0b2e6adb871a3b94$var$bf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$kf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$lf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$kf));
function $0b2e6adb871a3b94$var$mf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Tb(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$re(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$mf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$mf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Pb) throw a = $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Pb = !1, $0b2e6adb871a3b94$var$Qb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$nf];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$nf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$of(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$pf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$of(c, a, d, b);
}
var $0b2e6adb871a3b94$var$qf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$rf(a) {
    if (!a[$0b2e6adb871a3b94$var$qf]) {
        a[$0b2e6adb871a3b94$var$qf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$lf.has(b) || $0b2e6adb871a3b94$var$pf(b, !1, a), $0b2e6adb871a3b94$var$pf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$qf] || (b[$0b2e6adb871a3b94$var$qf] = !0, $0b2e6adb871a3b94$var$pf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$of(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$id(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$dd;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$fd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$ed;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Kb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Vc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Ib(function() {
        var d = f, e = $0b2e6adb871a3b94$var$wb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$cf.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$sd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$nd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Qd;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $0b2e6adb871a3b94$var$Ed;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $0b2e6adb871a3b94$var$Ed;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Ed;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Ad;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Cd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Ud;
                        break;
                    case $0b2e6adb871a3b94$var$Ze:
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                        k = $0b2e6adb871a3b94$var$Gd;
                        break;
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Wd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$ud;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Yd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Id;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Sd;
                }
                var w = 0 !== (b & 4), J = !w && "scroll" === a, v = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var x = d, r; null !== x;){
                    r = x;
                    var F = r.stateNode;
                    5 === r.tag && null !== F && (r = F, null !== v && (F = $0b2e6adb871a3b94$var$Jb(x, v), null != F && w.push($0b2e6adb871a3b94$var$sf(x, F, r))));
                    if (J) break;
                    x = x.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$vb && (m = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Vc(m) || m[$0b2e6adb871a3b94$var$tf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $0b2e6adb871a3b94$var$Vc(m) : null, null !== m && (J = $0b2e6adb871a3b94$var$Ub(m), m !== J || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $0b2e6adb871a3b94$var$Ad;
                        F = "onMouseLeave";
                        v = "onMouseEnter";
                        x = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $0b2e6adb871a3b94$var$Sd, F = "onPointerLeave", v = "onPointerEnter", x = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$te(k);
                        r = null == m ? h : $0b2e6adb871a3b94$var$te(m);
                        h = new w(F, x + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = r;
                        F = null;
                        $0b2e6adb871a3b94$var$Vc(e) === d && (w = new w(v, x + "enter", m, c, e), w.target = r, w.relatedTarget = J, F = w);
                        J = F;
                        if (k && m) b: {
                            w = k;
                            v = m;
                            x = 0;
                            for(r = w; r; r = $0b2e6adb871a3b94$var$uf(r))x++;
                            r = 0;
                            for(F = v; F; F = $0b2e6adb871a3b94$var$uf(F))r++;
                            for(; 0 < x - r;)w = $0b2e6adb871a3b94$var$uf(w), x--;
                            for(; 0 < r - x;)v = $0b2e6adb871a3b94$var$uf(v), r--;
                            for(; x--;){
                                if (w === v || null !== v && w === v.alternate) break b;
                                w = $0b2e6adb871a3b94$var$uf(w);
                                v = $0b2e6adb871a3b94$var$uf(v);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $0b2e6adb871a3b94$var$vf(g, h, k, w, !1);
                        null !== m && null !== J && $0b2e6adb871a3b94$var$vf(g, J, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$te(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var Z = $0b2e6adb871a3b94$var$ue;
                else if ($0b2e6adb871a3b94$var$le(h)) {
                    if ($0b2e6adb871a3b94$var$ve) Z = $0b2e6adb871a3b94$var$Ee;
                    else {
                        Z = $0b2e6adb871a3b94$var$Ce;
                        var ya = $0b2e6adb871a3b94$var$Be;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (Z = $0b2e6adb871a3b94$var$De);
                if (Z && (Z = Z(a, d))) {
                    $0b2e6adb871a3b94$var$me(g, Z, c, e);
                    break a;
                }
                ya && ya(a, h, d);
                "focusout" === a && (ya = h._wrapperState) && ya.controlled && "number" === h.type && $0b2e6adb871a3b94$var$bb(h, "number", h.value);
            }
            ya = d ? $0b2e6adb871a3b94$var$te(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$le(ya) || "true" === ya.contentEditable) $0b2e6adb871a3b94$var$Pe = ya, $0b2e6adb871a3b94$var$Qe = d, $0b2e6adb871a3b94$var$Re = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = $0b2e6adb871a3b94$var$Pe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Se = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Se = !1;
                    $0b2e6adb871a3b94$var$Te(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Oe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Te(g, c, e);
            }
            var ab;
            if ($0b2e6adb871a3b94$var$$d) b: {
                switch(a){
                    case "compositionstart":
                        var ca = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ca = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ca = "onCompositionUpdate";
                        break b;
                }
                ca = void 0;
            }
            else $0b2e6adb871a3b94$var$he ? $0b2e6adb871a3b94$var$fe(a, c) && (ca = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ca = "onCompositionStart");
            ca && ($0b2e6adb871a3b94$var$ce && "ko" !== c.locale && ($0b2e6adb871a3b94$var$he || "onCompositionStart" !== ca ? "onCompositionEnd" === ca && $0b2e6adb871a3b94$var$he && (ab = $0b2e6adb871a3b94$var$md()) : ($0b2e6adb871a3b94$var$jd = e, $0b2e6adb871a3b94$var$kd = "value" in $0b2e6adb871a3b94$var$jd ? $0b2e6adb871a3b94$var$jd.value : $0b2e6adb871a3b94$var$jd.textContent, $0b2e6adb871a3b94$var$he = !0)), ya = $0b2e6adb871a3b94$var$ne(d, ca), 0 < ya.length && (ca = new $0b2e6adb871a3b94$var$Kd(ca, a, null, c, e), g.push({
                event: ca,
                listeners: ya
            }), ab ? ca.data = ab : (ab = $0b2e6adb871a3b94$var$ge(c), null !== ab && (ca.data = ab))));
            if (ab = $0b2e6adb871a3b94$var$be ? $0b2e6adb871a3b94$var$ie(a, c) : $0b2e6adb871a3b94$var$je(a, c)) d = $0b2e6adb871a3b94$var$ne(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Kd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = ab);
        }
        $0b2e6adb871a3b94$var$re(g, b);
    });
}
function $0b2e6adb871a3b94$var$sf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$ne(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Jb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$sf(a, f, e)), f = $0b2e6adb871a3b94$var$Jb(a, b), null != f && d.push($0b2e6adb871a3b94$var$sf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$uf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$vf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Jb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$sf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Jb(c, f), null != k && g.push($0b2e6adb871a3b94$var$sf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$wf = /\r\n?/g, $0b2e6adb871a3b94$var$xf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$yf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$wf, "\n").replace($0b2e6adb871a3b94$var$xf, "");
}
function $0b2e6adb871a3b94$var$zf(a, b, c) {
    b = $0b2e6adb871a3b94$var$yf(b);
    if ($0b2e6adb871a3b94$var$yf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Af() {}
var $0b2e6adb871a3b94$var$Bf = null, $0b2e6adb871a3b94$var$Cf = null;
function $0b2e6adb871a3b94$var$Df(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ef = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Ff = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$If = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Gf ? function(a) {
    return $0b2e6adb871a3b94$var$Gf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$Hf);
} : $0b2e6adb871a3b94$var$Ef;
function $0b2e6adb871a3b94$var$Hf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Jf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$ad(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$ad(b);
}
function $0b2e6adb871a3b94$var$Kf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Lf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Mf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Nf = "__reactFiber$" + $0b2e6adb871a3b94$var$Mf, $0b2e6adb871a3b94$var$Of = "__reactProps$" + $0b2e6adb871a3b94$var$Mf, $0b2e6adb871a3b94$var$tf = "__reactContainer$" + $0b2e6adb871a3b94$var$Mf, $0b2e6adb871a3b94$var$nf = "__reactEvents$" + $0b2e6adb871a3b94$var$Mf, $0b2e6adb871a3b94$var$Pf = "__reactListeners$" + $0b2e6adb871a3b94$var$Mf, $0b2e6adb871a3b94$var$Qf = "__reactHandles$" + $0b2e6adb871a3b94$var$Mf;
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = a[$0b2e6adb871a3b94$var$Nf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$tf] || c[$0b2e6adb871a3b94$var$Nf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Lf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Nf]) return c;
                a = $0b2e6adb871a3b94$var$Lf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Bb(a) {
    a = a[$0b2e6adb871a3b94$var$Nf] || a[$0b2e6adb871a3b94$var$tf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$te(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Cb(a) {
    return a[$0b2e6adb871a3b94$var$Of] || null;
}
var $0b2e6adb871a3b94$var$Rf = [], $0b2e6adb871a3b94$var$Sf = -1;
function $0b2e6adb871a3b94$var$Tf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Sf || (a.current = $0b2e6adb871a3b94$var$Rf[$0b2e6adb871a3b94$var$Sf], $0b2e6adb871a3b94$var$Rf[$0b2e6adb871a3b94$var$Sf] = null, $0b2e6adb871a3b94$var$Sf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Sf++;
    $0b2e6adb871a3b94$var$Rf[$0b2e6adb871a3b94$var$Sf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Uf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Tf($0b2e6adb871a3b94$var$Uf), $0b2e6adb871a3b94$var$Vf = $0b2e6adb871a3b94$var$Tf(!1), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf;
function $0b2e6adb871a3b94$var$Xf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Uf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Yf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$Zf() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Vf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$$f(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Uf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Vf, c);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Qa(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$bg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Uf;
    $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Vf, $0b2e6adb871a3b94$var$Vf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$cg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$ag(a, b, $0b2e6adb871a3b94$var$Wf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Vf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Vf, c);
}
var $0b2e6adb871a3b94$var$dg = null, $0b2e6adb871a3b94$var$eg = !1, $0b2e6adb871a3b94$var$fg = !1;
function $0b2e6adb871a3b94$var$gg(a) {
    null === $0b2e6adb871a3b94$var$dg ? $0b2e6adb871a3b94$var$dg = [
        a
    ] : $0b2e6adb871a3b94$var$dg.push(a);
}
function $0b2e6adb871a3b94$var$hg(a) {
    $0b2e6adb871a3b94$var$eg = !0;
    $0b2e6adb871a3b94$var$gg(a);
}
function $0b2e6adb871a3b94$var$ig() {
    if (!$0b2e6adb871a3b94$var$fg && null !== $0b2e6adb871a3b94$var$dg) {
        $0b2e6adb871a3b94$var$fg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$dg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$dg = null;
            $0b2e6adb871a3b94$var$eg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$dg && ($0b2e6adb871a3b94$var$dg = $0b2e6adb871a3b94$var$dg.slice(a + 1)), $0b2e6adb871a3b94$var$$b($0b2e6adb871a3b94$var$ec, $0b2e6adb871a3b94$var$ig), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$fg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$jg = $0b2e6adb871a3b94$var$ta.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$kg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$lg = $0b2e6adb871a3b94$var$Tf(null), $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = null, $0b2e6adb871a3b94$var$og = null;
function $0b2e6adb871a3b94$var$pg() {
    $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$mg = null;
}
function $0b2e6adb871a3b94$var$qg(a) {
    var b = $0b2e6adb871a3b94$var$lg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$lg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$rg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$sg(a, b) {
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$ng = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$tg = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$ug(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$og !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$ng) {
            if (null === $0b2e6adb871a3b94$var$mg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$ng = a;
            $0b2e6adb871a3b94$var$mg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$ng.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$vg = null, $0b2e6adb871a3b94$var$wg = !1;
function $0b2e6adb871a3b94$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = a.updateQueue;
    null !== c && (c = c.shared, $0b2e6adb871a3b94$var$Bg(a) ? (a = c.interleaved, null === a ? (b.next = b, null === $0b2e6adb871a3b94$var$vg ? $0b2e6adb871a3b94$var$vg = [
        c
    ] : $0b2e6adb871a3b94$var$vg.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
}
function $0b2e6adb871a3b94$var$Cg(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Bc(a, c);
    }
}
function $0b2e6adb871a3b94$var$Dg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$Eg(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var u = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var q = h.lane, y = h.eventTime;
            if ((d & q) === q) {
                null !== n && (n = n.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    q = b;
                    y = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                u = m.call(y, u, q);
                                break a;
                            }
                            u = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            q = "function" === typeof m ? m.call(y, u, q) : m;
                            if (null === q || void 0 === q) break a;
                            u = $0b2e6adb871a3b94$var$A({}, u, q);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$wg = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, q = e.effects, null === q ? e.effects = [
                    h
                ] : q.push(h));
            } else y = {
                eventTime: y,
                lane: q,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = y, k = u) : n = n.next = y, g |= q;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else q = h, h = q.next, q.next = null, e.lastBaseUpdate = q, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = u);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$Fg |= g;
        a.lanes = g;
        a.memoizedState = u;
    }
}
function $0b2e6adb871a3b94$var$Gg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$Hg = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$Ig(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Mg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Ub(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Jg(), e = $0b2e6adb871a3b94$var$Kg(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        b = $0b2e6adb871a3b94$var$Lg(a, e, d);
        null !== b && $0b2e6adb871a3b94$var$Cg(b, a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Jg(), e = $0b2e6adb871a3b94$var$Kg(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        b = $0b2e6adb871a3b94$var$Lg(a, e, d);
        null !== b && $0b2e6adb871a3b94$var$Cg(b, a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$Jg(), d = $0b2e6adb871a3b94$var$Kg(a), e = $0b2e6adb871a3b94$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $0b2e6adb871a3b94$var$Ag(a, e);
        b = $0b2e6adb871a3b94$var$Lg(a, d, c);
        null !== b && $0b2e6adb871a3b94$var$Cg(b, a, d);
    }
};
function $0b2e6adb871a3b94$var$Ng(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$He(c, d) || !$0b2e6adb871a3b94$var$He(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Og(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Uf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$ug(f) : (e = $0b2e6adb871a3b94$var$Yf(b) ? $0b2e6adb871a3b94$var$Wf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Xf(a, e) : $0b2e6adb871a3b94$var$Uf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Mg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Pg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Mg.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Qg(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$Hg;
    $0b2e6adb871a3b94$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$ug(f) : (f = $0b2e6adb871a3b94$var$Yf(b) ? $0b2e6adb871a3b94$var$Wf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Xf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Ig(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Mg.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$Eg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
var $0b2e6adb871a3b94$var$Rg = [], $0b2e6adb871a3b94$var$Sg = 0, $0b2e6adb871a3b94$var$Tg = null, $0b2e6adb871a3b94$var$Ug = 0, $0b2e6adb871a3b94$var$Vg = [], $0b2e6adb871a3b94$var$Wg = 0, $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = 1, $0b2e6adb871a3b94$var$Zg = "";
function $0b2e6adb871a3b94$var$$g(a, b) {
    $0b2e6adb871a3b94$var$Rg[$0b2e6adb871a3b94$var$Sg++] = $0b2e6adb871a3b94$var$Ug;
    $0b2e6adb871a3b94$var$Rg[$0b2e6adb871a3b94$var$Sg++] = $0b2e6adb871a3b94$var$Tg;
    $0b2e6adb871a3b94$var$Tg = a;
    $0b2e6adb871a3b94$var$Ug = b;
}
function $0b2e6adb871a3b94$var$ah(a, b, c) {
    $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg++] = $0b2e6adb871a3b94$var$Yg;
    $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg++] = $0b2e6adb871a3b94$var$Zg;
    $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg++] = $0b2e6adb871a3b94$var$Xg;
    $0b2e6adb871a3b94$var$Xg = a;
    var d = $0b2e6adb871a3b94$var$Yg;
    a = $0b2e6adb871a3b94$var$Zg;
    var e = 32 - $0b2e6adb871a3b94$var$nc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$nc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$Yg = 1 << 32 - $0b2e6adb871a3b94$var$nc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$Zg = f + a;
    } else $0b2e6adb871a3b94$var$Yg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$Zg = a;
}
function $0b2e6adb871a3b94$var$bh(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$$g(a, 1), $0b2e6adb871a3b94$var$ah(a, 1, 0));
}
function $0b2e6adb871a3b94$var$ch(a) {
    for(; a === $0b2e6adb871a3b94$var$Tg;)$0b2e6adb871a3b94$var$Tg = $0b2e6adb871a3b94$var$Rg[--$0b2e6adb871a3b94$var$Sg], $0b2e6adb871a3b94$var$Rg[$0b2e6adb871a3b94$var$Sg] = null, $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Rg[--$0b2e6adb871a3b94$var$Sg], $0b2e6adb871a3b94$var$Rg[$0b2e6adb871a3b94$var$Sg] = null;
    for(; a === $0b2e6adb871a3b94$var$Xg;)$0b2e6adb871a3b94$var$Xg = $0b2e6adb871a3b94$var$Vg[--$0b2e6adb871a3b94$var$Wg], $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg] = null, $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Vg[--$0b2e6adb871a3b94$var$Wg], $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg] = null, $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Vg[--$0b2e6adb871a3b94$var$Wg], $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg] = null;
}
var $0b2e6adb871a3b94$var$dh = null, $0b2e6adb871a3b94$var$eh = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a, b) {
    var c = $0b2e6adb871a3b94$var$hh(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$dh = a, $0b2e6adb871a3b94$var$eh = $0b2e6adb871a3b94$var$Kf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$dh = a, $0b2e6adb871a3b94$var$eh = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$Xg ? {
                id: $0b2e6adb871a3b94$var$Yg,
                overflow: $0b2e6adb871a3b94$var$Zg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$hh(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$dh = a, $0b2e6adb871a3b94$var$eh = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$jh(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$kh(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$eh;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$ih(a, b)) {
                if ($0b2e6adb871a3b94$var$jh(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Kf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$dh;
                b && $0b2e6adb871a3b94$var$ih(a, b) ? $0b2e6adb871a3b94$var$gh(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$dh = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$jh(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$dh = a;
        }
    }
}
function $0b2e6adb871a3b94$var$lh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$dh = a;
}
function $0b2e6adb871a3b94$var$mh(a) {
    if (a !== $0b2e6adb871a3b94$var$dh) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$lh(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Df(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$eh)) {
        if ($0b2e6adb871a3b94$var$jh(a)) {
            for(a = $0b2e6adb871a3b94$var$eh; a;)a = $0b2e6adb871a3b94$var$Kf(a.nextSibling);
            throw Error($0b2e6adb871a3b94$var$p(418));
        }
        for(; b;)$0b2e6adb871a3b94$var$gh(a, b), b = $0b2e6adb871a3b94$var$Kf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$lh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$eh = $0b2e6adb871a3b94$var$Kf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$eh = null;
        }
    } else $0b2e6adb871a3b94$var$eh = $0b2e6adb871a3b94$var$dh ? $0b2e6adb871a3b94$var$Kf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$nh() {
    $0b2e6adb871a3b94$var$eh = $0b2e6adb871a3b94$var$dh = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$oh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$Hg && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$qh(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$rh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$sh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$th(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$uh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$wa) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ga && $0b2e6adb871a3b94$var$rh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$ph(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$vh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$ph(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$wh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function u(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$uh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$ua:
                    return c = $0b2e6adb871a3b94$var$vh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$ph(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$va:
                    return b = $0b2e6adb871a3b94$var$wh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ga:
                    var d = b._init;
                    return u(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$db(b) || $0b2e6adb871a3b94$var$Ja(b)) return b = $0b2e6adb871a3b94$var$xh(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$qh(a, b);
        }
        return null;
    }
    function q(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$ua:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ga:
                    return e = c._init, q(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$db(c) || $0b2e6adb871a3b94$var$Ja(c)) return null !== e ? null : n(a, b, c, d, null);
            $0b2e6adb871a3b94$var$qh(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$ua:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ga:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$db(d) || $0b2e6adb871a3b94$var$Ja(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $0b2e6adb871a3b94$var$qh(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, n = null, r = g, m = g = 0, x = null; null !== r && m < h.length; m++){
            r.index > m ? (x = r, r = null) : x = r.sibling;
            var v = q(e, r, h[m], k);
            if (null === v) {
                null === r && (r = x);
                break;
            }
            a && r && null === v.alternate && b(e, r);
            g = f(v, g, m);
            null === n ? l = v : n.sibling = v;
            n = v;
            r = x;
        }
        if (m === h.length) return c(e, r), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$$g(e, m), l;
        if (null === r) {
            for(; m < h.length; m++)r = u(e, h[m], k), null !== r && (g = f(r, g, m), null === n ? l = r : n.sibling = r, n = r);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$$g(e, m);
            return l;
        }
        for(r = d(e, r); m < h.length; m++)x = y(r, e, m, h[m], k), null !== x && (a && null !== x.alternate && r.delete(null === x.key ? m : x.key), g = f(x, g, m), null === n ? l = x : n.sibling = x, n = x);
        a && r.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$$g(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ja(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var n = l = null, m = g, r = g = 0, x = null, v = h.next(); null !== m && !v.done; r++, v = h.next()){
            m.index > r ? (x = m, m = null) : x = m.sibling;
            var w = q(e, m, v.value, k);
            if (null === w) {
                null === m && (m = x);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, r);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = x;
        }
        if (v.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$$g(e, r), l;
        if (null === m) {
            for(; !v.done; r++, v = h.next())v = u(e, v.value, k), null !== v && (g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$$g(e, r);
            return l;
        }
        for(m = d(e, m); !v.done; r++, v = h.next())v = y(m, e, r, v.value, k), null !== v && (a && null !== v.alternate && m.delete(null === v.key ? r : v.key), g = f(v, g, r), null === n ? l = v : n.sibling = v, n = v);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$$g(e, r);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$wa && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$ua:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$wa) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ga && $0b2e6adb871a3b94$var$rh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$ph(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$wa ? (d = $0b2e6adb871a3b94$var$xh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$vh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$ph(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$wh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ga:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$db(f)) return m(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ja(f)) return w(a, d, f, h);
            $0b2e6adb871a3b94$var$qh(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$uh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$yh = $0b2e6adb871a3b94$var$sh(!0), $0b2e6adb871a3b94$var$zh = $0b2e6adb871a3b94$var$sh(!1), $0b2e6adb871a3b94$var$Ah = {}, $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$Tf($0b2e6adb871a3b94$var$Ah), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$Tf($0b2e6adb871a3b94$var$Ah), $0b2e6adb871a3b94$var$Dh = $0b2e6adb871a3b94$var$Tf($0b2e6adb871a3b94$var$Ah);
function $0b2e6adb871a3b94$var$Eh(a) {
    if (a === $0b2e6adb871a3b94$var$Ah) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Fh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Dh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Ch, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Bh, $0b2e6adb871a3b94$var$Ah);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$kb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Bh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Bh, b);
}
function $0b2e6adb871a3b94$var$Gh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Bh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Ch);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Dh);
}
function $0b2e6adb871a3b94$var$Hh(a) {
    $0b2e6adb871a3b94$var$Eh($0b2e6adb871a3b94$var$Dh.current);
    var b = $0b2e6adb871a3b94$var$Eh($0b2e6adb871a3b94$var$Bh.current);
    var c = $0b2e6adb871a3b94$var$kb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Ch, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Bh, c));
}
function $0b2e6adb871a3b94$var$Ih(a) {
    $0b2e6adb871a3b94$var$Ch.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Bh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Ch));
}
var $0b2e6adb871a3b94$var$K = $0b2e6adb871a3b94$var$Tf(0);
function $0b2e6adb871a3b94$var$Jh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Kh = [];
function $0b2e6adb871a3b94$var$Lh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Kh.length; a++)$0b2e6adb871a3b94$var$Kh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Kh.length = 0;
}
var $0b2e6adb871a3b94$var$Mh = $0b2e6adb871a3b94$var$ta.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Nh = $0b2e6adb871a3b94$var$ta.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Oh = 0, $0b2e6adb871a3b94$var$L = null, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$Ph = !1, $0b2e6adb871a3b94$var$Qh = !1, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$Sh = 0;
function $0b2e6adb871a3b94$var$O() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Th(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$Ge(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Uh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Oh = f;
    $0b2e6adb871a3b94$var$L = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Mh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Vh : $0b2e6adb871a3b94$var$Wh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Qh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Qh = !1;
            $0b2e6adb871a3b94$var$Rh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Mh.current = $0b2e6adb871a3b94$var$Xh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Qh);
    }
    $0b2e6adb871a3b94$var$Mh.current = $0b2e6adb871a3b94$var$Yh;
    b = null !== $0b2e6adb871a3b94$var$M && null !== $0b2e6adb871a3b94$var$M.next;
    $0b2e6adb871a3b94$var$Oh = 0;
    $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$L = null;
    $0b2e6adb871a3b94$var$Ph = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Zh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Rh;
    $0b2e6adb871a3b94$var$Rh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$$h() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$N ? $0b2e6adb871a3b94$var$L.memoizedState = $0b2e6adb871a3b94$var$N = a : $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$N.next = a;
    return $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$ai() {
    if (null === $0b2e6adb871a3b94$var$M) {
        var a = $0b2e6adb871a3b94$var$L.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$M.next;
    var b = null === $0b2e6adb871a3b94$var$N ? $0b2e6adb871a3b94$var$L.memoizedState : $0b2e6adb871a3b94$var$N.next;
    if (null !== b) $0b2e6adb871a3b94$var$N = b, $0b2e6adb871a3b94$var$M = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$M = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$M.memoizedState,
            baseState: $0b2e6adb871a3b94$var$M.baseState,
            baseQueue: $0b2e6adb871a3b94$var$M.baseQueue,
            queue: $0b2e6adb871a3b94$var$M.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$N ? $0b2e6adb871a3b94$var$L.memoizedState = $0b2e6adb871a3b94$var$N = a : $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$N.next = a;
    }
    return $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$bi(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$ci(a) {
    var b = $0b2e6adb871a3b94$var$ai(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$M, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($0b2e6adb871a3b94$var$Oh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var u = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = u, g = d) : k = k.next = u;
                $0b2e6adb871a3b94$var$L.lanes |= n;
                $0b2e6adb871a3b94$var$Fg |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$Ge(d, b.memoizedState) || ($0b2e6adb871a3b94$var$tg = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$L.lanes |= f, $0b2e6adb871a3b94$var$Fg |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$di(a) {
    var b = $0b2e6adb871a3b94$var$ai(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$Ge(f, b.memoizedState) || ($0b2e6adb871a3b94$var$tg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$ei() {}
function $0b2e6adb871a3b94$var$fi(a, b) {
    var c = $0b2e6adb871a3b94$var$L, d = $0b2e6adb871a3b94$var$ai(), e = b(), f = !$0b2e6adb871a3b94$var$Ge(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$tg = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$hi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$N && $0b2e6adb871a3b94$var$N.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$ii(9, $0b2e6adb871a3b94$var$ji.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$P) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Oh & 30) || $0b2e6adb871a3b94$var$ki(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$L.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$L.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ji(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$li(b) && $0b2e6adb871a3b94$var$Lg(a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$li(b) && $0b2e6adb871a3b94$var$Lg(a, 1, -1);
    });
}
function $0b2e6adb871a3b94$var$li(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$Ge(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$mi(a) {
    var b = $0b2e6adb871a3b94$var$$h();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$bi,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ni.bind(null, $0b2e6adb871a3b94$var$L, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$ii(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$L.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$L.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$oi() {
    return $0b2e6adb871a3b94$var$ai().memoizedState;
}
function $0b2e6adb871a3b94$var$pi(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$$h();
    $0b2e6adb871a3b94$var$L.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$ii(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$qi(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ai();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$M) {
        var g = $0b2e6adb871a3b94$var$M.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Th(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$ii(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$L.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$ii(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$ri(a, b) {
    return $0b2e6adb871a3b94$var$pi(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$gi(a, b) {
    return $0b2e6adb871a3b94$var$qi(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$si(a, b) {
    return $0b2e6adb871a3b94$var$qi(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    return $0b2e6adb871a3b94$var$qi(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$ui(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$vi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$qi(4, 4, $0b2e6adb871a3b94$var$ui.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$wi() {}
function $0b2e6adb871a3b94$var$xi(a, b) {
    var c = $0b2e6adb871a3b94$var$ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Th(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    var c = $0b2e6adb871a3b94$var$ai();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Th(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Oh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$tg = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$Ge(c, b) || (c = $0b2e6adb871a3b94$var$xc(), $0b2e6adb871a3b94$var$L.lanes |= c, $0b2e6adb871a3b94$var$Fg |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Nh.transition;
    $0b2e6adb871a3b94$var$Nh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Nh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Bi() {
    return $0b2e6adb871a3b94$var$ai().memoizedState;
}
function $0b2e6adb871a3b94$var$Ci(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Kg(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $0b2e6adb871a3b94$var$Di(a) ? $0b2e6adb871a3b94$var$Ei(b, c) : ($0b2e6adb871a3b94$var$Fi(a, b, c), c = $0b2e6adb871a3b94$var$Jg(), a = $0b2e6adb871a3b94$var$Lg(a, d, c), null !== a && $0b2e6adb871a3b94$var$Gi(a, b, d));
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Kg(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Di(a)) $0b2e6adb871a3b94$var$Ei(b, e);
    else {
        $0b2e6adb871a3b94$var$Fi(a, b, e);
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$Ge(h, g)) return;
        } catch (k) {} finally{}
        c = $0b2e6adb871a3b94$var$Jg();
        a = $0b2e6adb871a3b94$var$Lg(a, d, c);
        null !== a && $0b2e6adb871a3b94$var$Gi(a, b, d);
    }
}
function $0b2e6adb871a3b94$var$Di(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$L || null !== b && b === $0b2e6adb871a3b94$var$L;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$Ph = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Fi(a, b, c) {
    $0b2e6adb871a3b94$var$Bg(a) ? (a = b.interleaved, null === a ? (c.next = c, null === $0b2e6adb871a3b94$var$vg ? $0b2e6adb871a3b94$var$vg = [
        b
    ] : $0b2e6adb871a3b94$var$vg.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Bc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$ug,
    useCallback: $0b2e6adb871a3b94$var$O,
    useContext: $0b2e6adb871a3b94$var$O,
    useEffect: $0b2e6adb871a3b94$var$O,
    useImperativeHandle: $0b2e6adb871a3b94$var$O,
    useInsertionEffect: $0b2e6adb871a3b94$var$O,
    useLayoutEffect: $0b2e6adb871a3b94$var$O,
    useMemo: $0b2e6adb871a3b94$var$O,
    useReducer: $0b2e6adb871a3b94$var$O,
    useRef: $0b2e6adb871a3b94$var$O,
    useState: $0b2e6adb871a3b94$var$O,
    useDebugValue: $0b2e6adb871a3b94$var$O,
    useDeferredValue: $0b2e6adb871a3b94$var$O,
    useTransition: $0b2e6adb871a3b94$var$O,
    useMutableSource: $0b2e6adb871a3b94$var$O,
    useSyncExternalStore: $0b2e6adb871a3b94$var$O,
    useId: $0b2e6adb871a3b94$var$O,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Vh = {
    readContext: $0b2e6adb871a3b94$var$ug,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$$h().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$ug,
    useEffect: $0b2e6adb871a3b94$var$ri,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$pi(4194308, 4, $0b2e6adb871a3b94$var$ui.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$pi(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$pi(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$$h();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$$h();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Ci.bind(null, $0b2e6adb871a3b94$var$L, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$$h();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$mi,
    useDebugValue: $0b2e6adb871a3b94$var$wi,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$$h().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$mi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ai.bind(null, a[1]);
        $0b2e6adb871a3b94$var$$h().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$L, e = $0b2e6adb871a3b94$var$$h();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$P) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Oh & 30) || $0b2e6adb871a3b94$var$ki(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$ri($0b2e6adb871a3b94$var$hi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$ii(9, $0b2e6adb871a3b94$var$ji.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$$h(), b = $0b2e6adb871a3b94$var$P.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$Zg;
            var d = $0b2e6adb871a3b94$var$Yg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$nc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Rh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Sh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Wh = {
    readContext: $0b2e6adb871a3b94$var$ug,
    useCallback: $0b2e6adb871a3b94$var$xi,
    useContext: $0b2e6adb871a3b94$var$ug,
    useEffect: $0b2e6adb871a3b94$var$gi,
    useImperativeHandle: $0b2e6adb871a3b94$var$vi,
    useInsertionEffect: $0b2e6adb871a3b94$var$si,
    useLayoutEffect: $0b2e6adb871a3b94$var$ti,
    useMemo: $0b2e6adb871a3b94$var$yi,
    useReducer: $0b2e6adb871a3b94$var$ci,
    useRef: $0b2e6adb871a3b94$var$oi,
    useState: function() {
        return $0b2e6adb871a3b94$var$ci($0b2e6adb871a3b94$var$bi);
    },
    useDebugValue: $0b2e6adb871a3b94$var$wi,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$ai();
        return $0b2e6adb871a3b94$var$zi(b, $0b2e6adb871a3b94$var$M.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$ci($0b2e6adb871a3b94$var$bi)[0], b = $0b2e6adb871a3b94$var$ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$ei,
    useSyncExternalStore: $0b2e6adb871a3b94$var$fi,
    useId: $0b2e6adb871a3b94$var$Bi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Xh = {
    readContext: $0b2e6adb871a3b94$var$ug,
    useCallback: $0b2e6adb871a3b94$var$xi,
    useContext: $0b2e6adb871a3b94$var$ug,
    useEffect: $0b2e6adb871a3b94$var$gi,
    useImperativeHandle: $0b2e6adb871a3b94$var$vi,
    useInsertionEffect: $0b2e6adb871a3b94$var$si,
    useLayoutEffect: $0b2e6adb871a3b94$var$ti,
    useMemo: $0b2e6adb871a3b94$var$yi,
    useReducer: $0b2e6adb871a3b94$var$di,
    useRef: $0b2e6adb871a3b94$var$oi,
    useState: function() {
        return $0b2e6adb871a3b94$var$di($0b2e6adb871a3b94$var$bi);
    },
    useDebugValue: $0b2e6adb871a3b94$var$wi,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$ai();
        return null === $0b2e6adb871a3b94$var$M ? b.memoizedState = a : $0b2e6adb871a3b94$var$zi(b, $0b2e6adb871a3b94$var$M.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$di($0b2e6adb871a3b94$var$bi)[0], b = $0b2e6adb871a3b94$var$ai().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$ei,
    useSyncExternalStore: $0b2e6adb871a3b94$var$fi,
    useId: $0b2e6adb871a3b94$var$Bi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Hi(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Oa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ji = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Li || ($0b2e6adb871a3b94$var$Li = !0, $0b2e6adb871a3b94$var$Mi = d);
        $0b2e6adb871a3b94$var$Ii(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Ii(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Ii(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Oi ? $0b2e6adb871a3b94$var$Oi = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Oi.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Pi(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ji;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Qi.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ri(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Si(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$zg(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$Ag(c, b))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Ti, $0b2e6adb871a3b94$var$Ui, $0b2e6adb871a3b94$var$Vi, $0b2e6adb871a3b94$var$Wi;
$0b2e6adb871a3b94$var$Ti = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Ui = function() {};
$0b2e6adb871a3b94$var$Vi = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Eh($0b2e6adb871a3b94$var$Bh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Xa(a, e);
                d = $0b2e6adb871a3b94$var$Xa(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$fb(a, e);
                d = $0b2e6adb871a3b94$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Af);
        }
        $0b2e6adb871a3b94$var$tb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Wi = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Xi(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$Q(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Yi(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$ch(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$Q(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Yf(b.type) && $0b2e6adb871a3b94$var$Zf(), $0b2e6adb871a3b94$var$Q(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Gh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Vf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Lh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$mh(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$fh && ($0b2e6adb871a3b94$var$Zi($0b2e6adb871a3b94$var$fh), $0b2e6adb871a3b94$var$fh = null));
            $0b2e6adb871a3b94$var$Ui(a, b);
            $0b2e6adb871a3b94$var$Q(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Ih(b);
            var e = $0b2e6adb871a3b94$var$Eh($0b2e6adb871a3b94$var$Dh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Vi(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$Q(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Eh($0b2e6adb871a3b94$var$Bh.current);
                if ($0b2e6adb871a3b94$var$mh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Nf] = b;
                    d[$0b2e6adb871a3b94$var$Of] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$kf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$kf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Ya(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$gb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$tb(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$zf(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$zf(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Ua(d);
                            $0b2e6adb871a3b94$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Ua(d);
                            $0b2e6adb871a3b94$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Af);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Nf] = b;
                    a[$0b2e6adb871a3b94$var$Of] = d;
                    $0b2e6adb871a3b94$var$Ti(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$ub(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$kf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$kf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Ya(a, d);
                                e = $0b2e6adb871a3b94$var$Xa(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$gb(a, d);
                                e = $0b2e6adb871a3b94$var$fb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$tb(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$rb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$nb(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$sa(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Ua(a);
                                $0b2e6adb871a3b94$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Ua(a);
                                $0b2e6adb871a3b94$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Ra(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Af);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$Q(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Wi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Eh($0b2e6adb871a3b94$var$Dh.current);
                $0b2e6adb871a3b94$var$Eh($0b2e6adb871a3b94$var$Bh.current);
                if ($0b2e6adb871a3b94$var$mh(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Nf] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$dh, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$zf(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$zf(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Nf] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$Q(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$K);
            d = b.memoizedState;
            if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$eh && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                for(d = $0b2e6adb871a3b94$var$eh; d;)d = $0b2e6adb871a3b94$var$Kf(d.nextSibling);
                $0b2e6adb871a3b94$var$nh();
                b.flags |= 98560;
                return b;
            }
            if (null !== d && null !== d.dehydrated) {
                d = $0b2e6adb871a3b94$var$mh(b);
                if (null === a) {
                    if (!d) throw Error($0b2e6adb871a3b94$var$p(318));
                    d = b.memoizedState;
                    d = null !== d ? d.dehydrated : null;
                    if (!d) throw Error($0b2e6adb871a3b94$var$p(317));
                    d[$0b2e6adb871a3b94$var$Nf] = b;
                } else $0b2e6adb871a3b94$var$nh(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                $0b2e6adb871a3b94$var$Q(b);
                return null;
            }
            null !== $0b2e6adb871a3b94$var$fh && ($0b2e6adb871a3b94$var$Zi($0b2e6adb871a3b94$var$fh), $0b2e6adb871a3b94$var$fh = null);
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? $0b2e6adb871a3b94$var$mh(b) : c = null !== a.memoizedState;
            d !== c && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$K.current & 1) ? 0 === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$R = 3) : $0b2e6adb871a3b94$var$$i()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$Q(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Gh(), $0b2e6adb871a3b94$var$Ui(a, b), null === a && $0b2e6adb871a3b94$var$rf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$Q(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$qg(b.type._context), $0b2e6adb871a3b94$var$Q(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Yf(b.type) && $0b2e6adb871a3b94$var$Zf(), $0b2e6adb871a3b94$var$Q(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$K);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$Q(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Xi(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$R || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Jh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Xi(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, $0b2e6adb871a3b94$var$K.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$aj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Xi(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Jh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Xi(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Q(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$aj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Xi(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$K.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$Q(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$bj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$cj & 1073741824) && ($0b2e6adb871a3b94$var$Q(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$Q(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
var $0b2e6adb871a3b94$var$dj = $0b2e6adb871a3b94$var$ta.ReactCurrentOwner, $0b2e6adb871a3b94$var$tg = !1;
function $0b2e6adb871a3b94$var$ej(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$zh(b, null, c, d) : $0b2e6adb871a3b94$var$yh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$fj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$sg(b, e);
    d = $0b2e6adb871a3b94$var$Uh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Zh();
    if (null !== a && !$0b2e6adb871a3b94$var$tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$gj(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$bh(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$ej(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$ij(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$jj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$vh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$He;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$gj(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$th(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$He(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$tg = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$tg = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$gj(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$lj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$mj, $0b2e6adb871a3b94$var$cj), $0b2e6adb871a3b94$var$cj |= c;
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, d = null !== f ? f.baseLanes : c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$mj, $0b2e6adb871a3b94$var$cj), $0b2e6adb871a3b94$var$cj |= d;
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a,
            cachePool: null,
            transitions: null
        }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$mj, $0b2e6adb871a3b94$var$cj), $0b2e6adb871a3b94$var$cj |= a, null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$mj, $0b2e6adb871a3b94$var$cj), $0b2e6adb871a3b94$var$cj |= d;
    $0b2e6adb871a3b94$var$ej(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$nj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Yf(c) ? $0b2e6adb871a3b94$var$Wf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Xf(b, f);
    $0b2e6adb871a3b94$var$sg(b, e);
    c = $0b2e6adb871a3b94$var$Uh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Zh();
    if (null !== a && !$0b2e6adb871a3b94$var$tg) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$gj(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$bh(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$ej(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$oj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Yf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$bg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$sg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $0b2e6adb871a3b94$var$Og(b, c, d), $0b2e6adb871a3b94$var$Qg(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$ug(l) : (l = $0b2e6adb871a3b94$var$Yf(c) ? $0b2e6adb871a3b94$var$Wf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Xf(b, l));
        var n = c.getDerivedStateFromProps, u = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        u || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Pg(b, g, d, l);
        $0b2e6adb871a3b94$var$wg = !1;
        var q = b.memoizedState;
        g.state = q;
        $0b2e6adb871a3b94$var$Eg(b, d, g, e);
        k = b.memoizedState;
        h !== d || q !== k || $0b2e6adb871a3b94$var$Vf.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof n && ($0b2e6adb871a3b94$var$Ig(b, c, n, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Ng(b, c, h, d, q, k, l)) ? (u || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$kg(b.type, h);
        g.props = l;
        u = b.pendingProps;
        q = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$ug(k) : (k = $0b2e6adb871a3b94$var$Yf(c) ? $0b2e6adb871a3b94$var$Wf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Xf(b, k));
        var y = c.getDerivedStateFromProps;
        (n = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== u || q !== k) && $0b2e6adb871a3b94$var$Pg(b, g, d, k);
        $0b2e6adb871a3b94$var$wg = !1;
        q = b.memoizedState;
        g.state = q;
        $0b2e6adb871a3b94$var$Eg(b, d, g, e);
        var m = b.memoizedState;
        h !== u || q !== m || $0b2e6adb871a3b94$var$Vf.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Ig(b, c, y, d), m = b.memoizedState), (l = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Ng(b, c, l, d, q, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$pj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$nj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$cg(b, c, !1), $0b2e6adb871a3b94$var$gj(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$dj.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$yh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$yh(b, null, h, f)) : $0b2e6adb871a3b94$var$ej(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$cg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$qj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$$f(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$$f(a, b.context, !1);
    $0b2e6adb871a3b94$var$Fh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$nh();
    $0b2e6adb871a3b94$var$oh(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$ej(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$uj(a, b) {
    return {
        baseLanes: a.baseLanes | b,
        cachePool: null,
        transitions: a.transitions
    };
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$K.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$kh(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        e = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, e = {
            mode: "hidden",
            children: e
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = $0b2e6adb871a3b94$var$wj(e, d, 0, null), a = $0b2e6adb871a3b94$var$xh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$tj(c), b.memoizedState = $0b2e6adb871a3b94$var$sj, a) : $0b2e6adb871a3b94$var$xj(b, e);
    }
    e = a.memoizedState;
    if (null !== e) {
        h = e.dehydrated;
        if (null !== h) {
            if (g) {
                if (b.flags & 256) return b.flags &= -257, $0b2e6adb871a3b94$var$yj(a, b, c, Error($0b2e6adb871a3b94$var$p(422)));
                if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                f = d.fallback;
                e = b.mode;
                d = $0b2e6adb871a3b94$var$wj({
                    mode: "visible",
                    children: d.children
                }, e, 0, null);
                f = $0b2e6adb871a3b94$var$xh(f, e, c, null);
                f.flags |= 2;
                d.return = b;
                f.return = b;
                d.sibling = f;
                b.child = d;
                0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$yh(b, a.child, null, c);
                b.child.memoizedState = $0b2e6adb871a3b94$var$tj(c);
                b.memoizedState = $0b2e6adb871a3b94$var$sj;
                return f;
            }
            if (0 === (b.mode & 1)) b = $0b2e6adb871a3b94$var$yj(a, b, c, null);
            else if ("$!" === h.data) b = $0b2e6adb871a3b94$var$yj(a, b, c, Error($0b2e6adb871a3b94$var$p(419)));
            else if (d = 0 !== (c & a.childLanes), $0b2e6adb871a3b94$var$tg || d) {
                d = $0b2e6adb871a3b94$var$P;
                if (null !== d) {
                    switch(c & -c){
                        case 4:
                            f = 2;
                            break;
                        case 16:
                            f = 8;
                            break;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            f = 32;
                            break;
                        case 536870912:
                            f = 268435456;
                            break;
                        default:
                            f = 0;
                    }
                    d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                    0 !== d && d !== e.retryLane && (e.retryLane = d, $0b2e6adb871a3b94$var$Lg(a, d, -1));
                }
                $0b2e6adb871a3b94$var$$i();
                b = $0b2e6adb871a3b94$var$yj(a, b, c, Error($0b2e6adb871a3b94$var$p(421)));
            } else "$?" === h.data ? (b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$zj.bind(null, a), h._reactRetry = b, b = null) : (c = e.treeContext, $0b2e6adb871a3b94$var$eh = $0b2e6adb871a3b94$var$Kf(h.nextSibling), $0b2e6adb871a3b94$var$dh = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$fh = null, null !== c && ($0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg++] = $0b2e6adb871a3b94$var$Yg, $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg++] = $0b2e6adb871a3b94$var$Zg, $0b2e6adb871a3b94$var$Vg[$0b2e6adb871a3b94$var$Wg++] = $0b2e6adb871a3b94$var$Xg, $0b2e6adb871a3b94$var$Yg = c.id, $0b2e6adb871a3b94$var$Zg = c.overflow, $0b2e6adb871a3b94$var$Xg = b), b = $0b2e6adb871a3b94$var$xj(b, b.pendingProps.children), b.flags |= 4096);
            return b;
        }
        if (f) return d = $0b2e6adb871a3b94$var$Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? $0b2e6adb871a3b94$var$tj(c) : $0b2e6adb871a3b94$var$uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$sj, d;
        c = $0b2e6adb871a3b94$var$Bj(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $0b2e6adb871a3b94$var$Aj(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? $0b2e6adb871a3b94$var$tj(c) : $0b2e6adb871a3b94$var$uj(e, c), f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$sj, d;
    c = $0b2e6adb871a3b94$var$Bj(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $0b2e6adb871a3b94$var$xj(a, b) {
    b = $0b2e6adb871a3b94$var$wj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$Bj(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $0b2e6adb871a3b94$var$th(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 1) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (d = b.deletions, null === d ? (b.deletions = [
        a
    ], b.flags |= 16) : d.push(a));
    return b.child = c;
}
function $0b2e6adb871a3b94$var$Aj(a, b, c, d, e) {
    var f = b.mode;
    a = a.child;
    var g = a.sibling, h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = $0b2e6adb871a3b94$var$th(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
    null !== g ? d = $0b2e6adb871a3b94$var$th(g, d) : (d = $0b2e6adb871a3b94$var$xh(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $0b2e6adb871a3b94$var$yj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$oh(d);
    $0b2e6adb871a3b94$var$yh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$xj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$Cj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$rg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$Dj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$ej(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$K.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$Cj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$Cj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Jh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$Dj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Jh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$Dj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$Dj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$Fg |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$th(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$th(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$qj(b);
            $0b2e6adb871a3b94$var$nh();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Hh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Yf(b.type) && $0b2e6adb871a3b94$var$bg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Fh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$lg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, $0b2e6adb871a3b94$var$K.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$vj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, $0b2e6adb871a3b94$var$K.current & 1);
                a = $0b2e6adb871a3b94$var$gj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, $0b2e6adb871a3b94$var$K.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$Ej(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$K, $0b2e6adb871a3b94$var$K.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$lj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$gj(a, b, c);
}
function $0b2e6adb871a3b94$var$Gj(a, b) {
    $0b2e6adb871a3b94$var$ch(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Yf(b.type) && $0b2e6adb871a3b94$var$Zf(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Gh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Lh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Ih(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$K);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$nh();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$K), null;
        case 4:
            return $0b2e6adb871a3b94$var$Gh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$qg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$bj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Hj = !1, $0b2e6adb871a3b94$var$S = !1, $0b2e6adb871a3b94$var$Ij = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$T = null;
function $0b2e6adb871a3b94$var$Jj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$U(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Kj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$U(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Lj = !1;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    $0b2e6adb871a3b94$var$Bf = $0b2e6adb871a3b94$var$cd;
    a = $0b2e6adb871a3b94$var$Le();
    if ($0b2e6adb871a3b94$var$Me(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (Z) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, u = a, q = null;
                b: for(;;){
                    for(var y;;){
                        u !== c || 0 !== e && 3 !== u.nodeType || (h = g + e);
                        u !== f || 0 !== d && 3 !== u.nodeType || (k = g + d);
                        3 === u.nodeType && (g += u.nodeValue.length);
                        if (null === (y = u.firstChild)) break;
                        q = u;
                        u = y;
                    }
                    for(;;){
                        if (u === a) break b;
                        q === c && ++l === e && (h = g);
                        q === f && ++n === d && (k = g);
                        if (null !== (y = u.nextSibling)) break;
                        u = q;
                        q = u.parentNode;
                    }
                    u = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Cf = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$cd = !1;
    for($0b2e6adb871a3b94$var$T = b; null !== $0b2e6adb871a3b94$var$T;)if (b = $0b2e6adb871a3b94$var$T, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$T = a;
    else for(; null !== $0b2e6adb871a3b94$var$T;){
        b = $0b2e6adb871a3b94$var$T;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, J = m.memoizedState, v = b.stateNode, x = v.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $0b2e6adb871a3b94$var$kg(b.type, w), J);
                        v.__reactInternalSnapshotBeforeUpdate = x;
                    }
                    break;
                case 3:
                    var r = b.stateNode.containerInfo;
                    if (1 === r.nodeType) r.textContent = "";
                    else if (9 === r.nodeType) {
                        var F = r.body;
                        null != F && (F.textContent = "");
                    }
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (Z) {
            $0b2e6adb871a3b94$var$U(b, b.return, Z);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$T = a;
            break;
        }
        $0b2e6adb871a3b94$var$T = b.return;
    }
    m = $0b2e6adb871a3b94$var$Lj;
    $0b2e6adb871a3b94$var$Lj = !1;
    return m;
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Kj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Oj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Pj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Qj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Qj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Nf], delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$nf], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$Qf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Rj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Sj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Rj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Tj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Af));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Tj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Tj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Uj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Uj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Uj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$V = null, $0b2e6adb871a3b94$var$Vj = !1;
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Xj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    if ($0b2e6adb871a3b94$var$kc && "function" === typeof $0b2e6adb871a3b94$var$kc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$kc.onCommitFiberUnmount($0b2e6adb871a3b94$var$jc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$S || $0b2e6adb871a3b94$var$Jj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$V, e = $0b2e6adb871a3b94$var$Vj;
            $0b2e6adb871a3b94$var$V = null;
            $0b2e6adb871a3b94$var$Wj(a, b, c);
            $0b2e6adb871a3b94$var$V = d;
            $0b2e6adb871a3b94$var$Vj = e;
            null !== $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$Vj ? (a = $0b2e6adb871a3b94$var$V, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$V.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$Vj ? (a = $0b2e6adb871a3b94$var$V, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Jf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Jf(a, c), $0b2e6adb871a3b94$var$ad(a)) : $0b2e6adb871a3b94$var$Jf($0b2e6adb871a3b94$var$V, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$V;
            e = $0b2e6adb871a3b94$var$Vj;
            $0b2e6adb871a3b94$var$V = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Vj = !0;
            $0b2e6adb871a3b94$var$Wj(a, b, c);
            $0b2e6adb871a3b94$var$V = d;
            $0b2e6adb871a3b94$var$Vj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Kj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Kj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Wj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$S && ($0b2e6adb871a3b94$var$Jj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$U(c, b, h);
            }
            $0b2e6adb871a3b94$var$Wj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Wj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$S = (d = $0b2e6adb871a3b94$var$S) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Wj(a, b, c), $0b2e6adb871a3b94$var$S = d) : $0b2e6adb871a3b94$var$Wj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Wj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$Yj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Ij);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$Zj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ak(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$V = h.stateNode;
                        $0b2e6adb871a3b94$var$Vj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$V = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Vj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$V = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Vj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$V) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Xj(f, g, e);
            $0b2e6adb871a3b94$var$V = null;
            $0b2e6adb871a3b94$var$Vj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$U(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$bk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Nj(3, a, a.return), $0b2e6adb871a3b94$var$Oj(3, a);
                } catch (m) {
                    $0b2e6adb871a3b94$var$U(a, a.return, m);
                }
                try {
                    $0b2e6adb871a3b94$var$Nj(5, a, a.return);
                } catch (m) {
                    $0b2e6adb871a3b94$var$U(a, a.return, m);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Jj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Jj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$nb(e, "");
                } catch (m) {
                    $0b2e6adb871a3b94$var$U(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$Za(e, f);
                    $0b2e6adb871a3b94$var$ub(h, g);
                    var l = $0b2e6adb871a3b94$var$ub(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], u = k[g + 1];
                        "style" === n ? $0b2e6adb871a3b94$var$rb(e, u) : "dangerouslySetInnerHTML" === n ? $0b2e6adb871a3b94$var$mb(e, u) : "children" === n ? $0b2e6adb871a3b94$var$nb(e, u) : $0b2e6adb871a3b94$var$sa(e, n, u, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$$a(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(e, f);
                            break;
                        case "select":
                            var q = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$eb(e, !!f.multiple, y, !1) : q !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$eb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Of] = f;
                } catch (m) {
                    $0b2e6adb871a3b94$var$U(a, a.return, m);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                l = a.stateNode;
                n = a.memoizedProps;
                try {
                    l.nodeValue = n;
                } catch (m) {
                    $0b2e6adb871a3b94$var$U(a, a.return, m);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$ad(b.containerInfo);
            } catch (m) {
                $0b2e6adb871a3b94$var$U(a, a.return, m);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            l = a.child;
            l.flags & 8192 && null !== l.memoizedState && (null === l.alternate || null === l.alternate.memoizedState) && ($0b2e6adb871a3b94$var$dk = $0b2e6adb871a3b94$var$B());
            d & 4 && $0b2e6adb871a3b94$var$Yj(a);
            break;
        case 22:
            l = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$S = (n = $0b2e6adb871a3b94$var$S) || l, $0b2e6adb871a3b94$var$ak(b, a), $0b2e6adb871a3b94$var$S = n) : $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            if (d & 8192) {
                n = null !== a.memoizedState;
                a: for(u = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === u) {
                            u = q;
                            try {
                                e = q.stateNode, n ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$qb("display", g));
                            } catch (m) {
                                $0b2e6adb871a3b94$var$U(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === u) try {
                            q.stateNode.nodeValue = n ? "" : q.memoizedProps;
                        } catch (m) {
                            $0b2e6adb871a3b94$var$U(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        u === q && (u = null);
                        q = q.return;
                    }
                    u === q && (u = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
                if (n && !l && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$T = a, a = a.child; null !== a;){
                    for(l = $0b2e6adb871a3b94$var$T = a; null !== $0b2e6adb871a3b94$var$T;){
                        n = $0b2e6adb871a3b94$var$T;
                        u = n.child;
                        switch(n.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Nj(4, n, n.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Jj(n, n.return);
                                f = n.stateNode;
                                if ("function" === typeof f.componentWillUnmount) {
                                    q = n;
                                    y = n.return;
                                    try {
                                        e = q, f.props = e.memoizedProps, f.state = e.memoizedState, f.componentWillUnmount();
                                    } catch (m) {
                                        $0b2e6adb871a3b94$var$U(q, y, m);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Jj(n, n.return);
                                break;
                            case 22:
                                if (null !== n.memoizedState) {
                                    $0b2e6adb871a3b94$var$ek(l);
                                    continue;
                                }
                        }
                        null !== u ? (u.return = n, $0b2e6adb871a3b94$var$T = u) : $0b2e6adb871a3b94$var$ek(l);
                    }
                    a = a.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ak(b, a);
            $0b2e6adb871a3b94$var$ck(a);
            d & 4 && $0b2e6adb871a3b94$var$Yj(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ak(b, a), $0b2e6adb871a3b94$var$ck(a);
    }
}
function $0b2e6adb871a3b94$var$ck(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Rj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$nb(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Sj(a);
                    $0b2e6adb871a3b94$var$Uj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Sj(a);
                    $0b2e6adb871a3b94$var$Tj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$U(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$fk(a, b, c) {
    $0b2e6adb871a3b94$var$T = a;
    $0b2e6adb871a3b94$var$gk(a, b, c);
}
function $0b2e6adb871a3b94$var$gk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$T;){
        var e = $0b2e6adb871a3b94$var$T, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Hj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$S;
                h = $0b2e6adb871a3b94$var$Hj;
                var l = $0b2e6adb871a3b94$var$S;
                $0b2e6adb871a3b94$var$Hj = g;
                if (($0b2e6adb871a3b94$var$S = k) && !l) for($0b2e6adb871a3b94$var$T = e; null !== $0b2e6adb871a3b94$var$T;)g = $0b2e6adb871a3b94$var$T, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$hk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$T = k) : $0b2e6adb871a3b94$var$hk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$T = f, $0b2e6adb871a3b94$var$gk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$T = e;
                $0b2e6adb871a3b94$var$Hj = h;
                $0b2e6adb871a3b94$var$S = l;
            }
            $0b2e6adb871a3b94$var$ik(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$T = f) : $0b2e6adb871a3b94$var$ik(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ik(a) {
    for(; null !== $0b2e6adb871a3b94$var$T;){
        var b = $0b2e6adb871a3b94$var$T;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$S || $0b2e6adb871a3b94$var$Oj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$S) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$kg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$Gg(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$Gg(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var n = l.memoizedState;
                                if (null !== n) {
                                    var u = n.dehydrated;
                                    null !== u && $0b2e6adb871a3b94$var$ad(u);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$S || b.flags & 512 && $0b2e6adb871a3b94$var$Pj(b);
            } catch (q) {
                $0b2e6adb871a3b94$var$U(b, b.return, q);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$T = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$T = c;
            break;
        }
        $0b2e6adb871a3b94$var$T = b.return;
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    for(; null !== $0b2e6adb871a3b94$var$T;){
        var b = $0b2e6adb871a3b94$var$T;
        if (b === a) {
            $0b2e6adb871a3b94$var$T = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$T = c;
            break;
        }
        $0b2e6adb871a3b94$var$T = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$T;){
        var b = $0b2e6adb871a3b94$var$T;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Oj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$U(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$U(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Pj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$U(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Pj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$U(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$U(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$T = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$T = h;
            break;
        }
        $0b2e6adb871a3b94$var$T = b.return;
    }
}
var $0b2e6adb871a3b94$var$jk = Math.ceil, $0b2e6adb871a3b94$var$kk = $0b2e6adb871a3b94$var$ta.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$lk = $0b2e6adb871a3b94$var$ta.ReactCurrentOwner, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ta.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$W = 0, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Y = 0, $0b2e6adb871a3b94$var$cj = 0, $0b2e6adb871a3b94$var$mj = $0b2e6adb871a3b94$var$Tf(0), $0b2e6adb871a3b94$var$R = 0, $0b2e6adb871a3b94$var$nk = null, $0b2e6adb871a3b94$var$Fg = 0, $0b2e6adb871a3b94$var$ok = 0, $0b2e6adb871a3b94$var$pk = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$rk = null, $0b2e6adb871a3b94$var$dk = 0, $0b2e6adb871a3b94$var$aj = Infinity, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$Li = !1, $0b2e6adb871a3b94$var$Mi = null, $0b2e6adb871a3b94$var$Oi = null, $0b2e6adb871a3b94$var$tk = !1, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$vk = 0, $0b2e6adb871a3b94$var$wk = 0, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = -1, $0b2e6adb871a3b94$var$zk = 0;
function $0b2e6adb871a3b94$var$Jg() {
    return 0 !== ($0b2e6adb871a3b94$var$W & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$yk ? $0b2e6adb871a3b94$var$yk : $0b2e6adb871a3b94$var$yk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$Kg(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$W & 2) && 0 !== $0b2e6adb871a3b94$var$Y) return $0b2e6adb871a3b94$var$Y & -$0b2e6adb871a3b94$var$Y;
    if (null !== $0b2e6adb871a3b94$var$jg.transition) return 0 === $0b2e6adb871a3b94$var$zk && ($0b2e6adb871a3b94$var$zk = $0b2e6adb871a3b94$var$xc()), $0b2e6adb871a3b94$var$zk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$id(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    if (50 < $0b2e6adb871a3b94$var$wk) throw $0b2e6adb871a3b94$var$wk = 0, $0b2e6adb871a3b94$var$xk = null, Error($0b2e6adb871a3b94$var$p(185));
    var d = $0b2e6adb871a3b94$var$Ak(a, b);
    if (null === d) return null;
    $0b2e6adb871a3b94$var$zc(d, b, c);
    if (0 === ($0b2e6adb871a3b94$var$W & 2) || d !== $0b2e6adb871a3b94$var$P) d === $0b2e6adb871a3b94$var$P && (0 === ($0b2e6adb871a3b94$var$W & 2) && ($0b2e6adb871a3b94$var$ok |= b), 4 === $0b2e6adb871a3b94$var$R && $0b2e6adb871a3b94$var$Bk(d, $0b2e6adb871a3b94$var$Y)), $0b2e6adb871a3b94$var$Ck(d, c), 1 === b && 0 === $0b2e6adb871a3b94$var$W && 0 === (a.mode & 1) && ($0b2e6adb871a3b94$var$aj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$eg && $0b2e6adb871a3b94$var$ig());
    return d;
}
function $0b2e6adb871a3b94$var$Ak(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $0b2e6adb871a3b94$var$Bg(a) {
    return (null !== $0b2e6adb871a3b94$var$P || null !== $0b2e6adb871a3b94$var$vg) && 0 !== (a.mode & 1) && 0 === ($0b2e6adb871a3b94$var$W & 2);
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$vc(a, b);
    var d = $0b2e6adb871a3b94$var$tc(a, a === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$Y : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$ac(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$ac(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Dk.bind(null, a)) : $0b2e6adb871a3b94$var$gg($0b2e6adb871a3b94$var$Dk.bind(null, a)), $0b2e6adb871a3b94$var$If(function() {
            0 === $0b2e6adb871a3b94$var$W && $0b2e6adb871a3b94$var$ig();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Cc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$ec;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$ic;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$gc;
            }
            c = $0b2e6adb871a3b94$var$Ek(c, $0b2e6adb871a3b94$var$Fk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Fk(a, b) {
    $0b2e6adb871a3b94$var$yk = -1;
    $0b2e6adb871a3b94$var$zk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$W & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Gk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$tc(a, a === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$Y : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Hk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$W;
        $0b2e6adb871a3b94$var$W |= 2;
        var f = $0b2e6adb871a3b94$var$Ik();
        if ($0b2e6adb871a3b94$var$P !== a || $0b2e6adb871a3b94$var$Y !== b) $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$aj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Jk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Kk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Lk(a, h);
        }
        $0b2e6adb871a3b94$var$pg();
        $0b2e6adb871a3b94$var$kk.current = f;
        $0b2e6adb871a3b94$var$W = e;
        null !== $0b2e6adb871a3b94$var$X ? b = 0 : ($0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Y = 0, b = $0b2e6adb871a3b94$var$R);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$wc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Mk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$nk, $0b2e6adb871a3b94$var$Jk(a, 0), $0b2e6adb871a3b94$var$Bk(a, d), $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Bk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Nk(e) && (b = $0b2e6adb871a3b94$var$Hk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$wc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Mk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$nk, $0b2e6adb871a3b94$var$Jk(a, 0), $0b2e6adb871a3b94$var$Bk(a, d), $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Ok(a, $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$sk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Bk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$dk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$tc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$Jg();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ef($0b2e6adb871a3b94$var$Ok.bind(null, a, $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$sk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Ok(a, $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$sk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Bk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$nc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$jk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ef($0b2e6adb871a3b94$var$Ok.bind(null, a, $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$sk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Ok(a, $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$sk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Ok(a, $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$sk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Fk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    var c = $0b2e6adb871a3b94$var$qk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Jk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Hk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$rk = c, null !== b && $0b2e6adb871a3b94$var$Zi(b));
    return a;
}
function $0b2e6adb871a3b94$var$Zi(a) {
    null === $0b2e6adb871a3b94$var$rk ? $0b2e6adb871a3b94$var$rk = a : $0b2e6adb871a3b94$var$rk.push.apply($0b2e6adb871a3b94$var$rk, a);
}
function $0b2e6adb871a3b94$var$Nk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$Ge(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Bk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$pk;
    b &= ~$0b2e6adb871a3b94$var$ok;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$nc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Dk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$W & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Gk();
    var b = $0b2e6adb871a3b94$var$tc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Hk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$wc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Mk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$nk, $0b2e6adb871a3b94$var$Jk(a, 0), $0b2e6adb871a3b94$var$Bk(a, b), $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Ok(a, $0b2e6adb871a3b94$var$rk, $0b2e6adb871a3b94$var$sk);
    $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Pk(a, b) {
    var c = $0b2e6adb871a3b94$var$W;
    $0b2e6adb871a3b94$var$W |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$W = c, 0 === $0b2e6adb871a3b94$var$W && ($0b2e6adb871a3b94$var$aj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$eg && $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$Qk(a) {
    null !== $0b2e6adb871a3b94$var$uk && 0 === $0b2e6adb871a3b94$var$uk.tag && 0 === ($0b2e6adb871a3b94$var$W & 6) && $0b2e6adb871a3b94$var$Gk();
    var b = $0b2e6adb871a3b94$var$W;
    $0b2e6adb871a3b94$var$W |= 1;
    var c = $0b2e6adb871a3b94$var$mk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$mk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$mk.transition = c, $0b2e6adb871a3b94$var$W = b, 0 === ($0b2e6adb871a3b94$var$W & 6) && $0b2e6adb871a3b94$var$ig();
    }
}
function $0b2e6adb871a3b94$var$bj() {
    $0b2e6adb871a3b94$var$cj = $0b2e6adb871a3b94$var$mj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$mj);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Ff(c));
    if (null !== $0b2e6adb871a3b94$var$X) for(c = $0b2e6adb871a3b94$var$X.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$ch(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$Zf();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Gh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Vf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Lh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Ih(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Gh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$K);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$K);
                break;
            case 10:
                $0b2e6adb871a3b94$var$qg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$bj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$P = a;
    $0b2e6adb871a3b94$var$X = a = $0b2e6adb871a3b94$var$th(a.current, null);
    $0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$cj = b;
    $0b2e6adb871a3b94$var$R = 0;
    $0b2e6adb871a3b94$var$nk = null;
    $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$Fg = 0;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = null;
    if (null !== $0b2e6adb871a3b94$var$vg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$vg.length; b++)if (c = $0b2e6adb871a3b94$var$vg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$vg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$X;
        try {
            $0b2e6adb871a3b94$var$pg();
            $0b2e6adb871a3b94$var$Mh.current = $0b2e6adb871a3b94$var$Yh;
            if ($0b2e6adb871a3b94$var$Ph) {
                for(var d = $0b2e6adb871a3b94$var$L.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ph = !1;
            }
            $0b2e6adb871a3b94$var$Oh = 0;
            $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$L = null;
            $0b2e6adb871a3b94$var$Qh = !1;
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$lk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$R = 1;
                $0b2e6adb871a3b94$var$nk = b;
                $0b2e6adb871a3b94$var$X = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Y;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, n = h, u = n.tag;
                    if (0 === (n.mode & 1) && (0 === u || 11 === u || 15 === u)) {
                        var q = n.alternate;
                        q ? (n.updateQueue = q.updateQueue, n.memoizedState = q.memoizedState, n.lanes = q.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ri(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Si(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Pi(f, l, b);
                        b = y;
                        k = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(k);
                            b.updateQueue = w;
                        } else m.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Pi(f, l, b);
                            $0b2e6adb871a3b94$var$$i();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ri(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Si(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$oh(k);
                        break a;
                    }
                }
                f = k;
                4 !== $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$R = 2);
                null === $0b2e6adb871a3b94$var$qk ? $0b2e6adb871a3b94$var$qk = [
                    f
                ] : $0b2e6adb871a3b94$var$qk.push(f);
                k = $0b2e6adb871a3b94$var$Hi(k, h);
                h = g;
                do {
                    switch(h.tag){
                        case 3:
                            h.flags |= 65536;
                            b &= -b;
                            h.lanes |= b;
                            var v = $0b2e6adb871a3b94$var$Ki(h, k, b);
                            $0b2e6adb871a3b94$var$Dg(h, v);
                            break a;
                        case 1:
                            f = k;
                            var x = h.type, r = h.stateNode;
                            if (0 === (h.flags & 128) && ("function" === typeof x.getDerivedStateFromError || null !== r && "function" === typeof r.componentDidCatch && (null === $0b2e6adb871a3b94$var$Oi || !$0b2e6adb871a3b94$var$Oi.has(r)))) {
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ni(h, f, b);
                                $0b2e6adb871a3b94$var$Dg(h, F);
                                break a;
                            }
                    }
                    h = h.return;
                }while (null !== h);
            }
            $0b2e6adb871a3b94$var$Rk(c);
        } catch (Z) {
            b = Z;
            $0b2e6adb871a3b94$var$X === c && null !== c && ($0b2e6adb871a3b94$var$X = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Ik() {
    var a = $0b2e6adb871a3b94$var$kk.current;
    $0b2e6adb871a3b94$var$kk.current = $0b2e6adb871a3b94$var$Yh;
    return null === a ? $0b2e6adb871a3b94$var$Yh : a;
}
function $0b2e6adb871a3b94$var$$i() {
    if (0 === $0b2e6adb871a3b94$var$R || 3 === $0b2e6adb871a3b94$var$R || 2 === $0b2e6adb871a3b94$var$R) $0b2e6adb871a3b94$var$R = 4;
    null === $0b2e6adb871a3b94$var$P || 0 === ($0b2e6adb871a3b94$var$Fg & 268435455) && 0 === ($0b2e6adb871a3b94$var$ok & 268435455) || $0b2e6adb871a3b94$var$Bk($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    var c = $0b2e6adb871a3b94$var$W;
    $0b2e6adb871a3b94$var$W |= 2;
    var d = $0b2e6adb871a3b94$var$Ik();
    if ($0b2e6adb871a3b94$var$P !== a || $0b2e6adb871a3b94$var$Y !== b) $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$Jk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Sk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Lk(a, e);
    }
    $0b2e6adb871a3b94$var$pg();
    $0b2e6adb871a3b94$var$W = c;
    $0b2e6adb871a3b94$var$kk.current = d;
    if (null !== $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$P = null;
    $0b2e6adb871a3b94$var$Y = 0;
    return $0b2e6adb871a3b94$var$R;
}
function $0b2e6adb871a3b94$var$Sk() {
    for(; null !== $0b2e6adb871a3b94$var$X;)$0b2e6adb871a3b94$var$Tk($0b2e6adb871a3b94$var$X);
}
function $0b2e6adb871a3b94$var$Kk() {
    for(; null !== $0b2e6adb871a3b94$var$X && !$0b2e6adb871a3b94$var$bc();)$0b2e6adb871a3b94$var$Tk($0b2e6adb871a3b94$var$X);
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = $0b2e6adb871a3b94$var$Uk(a.alternate, a, $0b2e6adb871a3b94$var$cj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Rk(a) : $0b2e6adb871a3b94$var$X = b;
    $0b2e6adb871a3b94$var$lk.current = null;
}
function $0b2e6adb871a3b94$var$Rk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Yi(c, b, $0b2e6adb871a3b94$var$cj), null !== c) {
                $0b2e6adb871a3b94$var$X = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Gj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$X = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$R = 6;
                $0b2e6adb871a3b94$var$X = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$X = b;
            return;
        }
        $0b2e6adb871a3b94$var$X = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$R = 5);
}
function $0b2e6adb871a3b94$var$Ok(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$mk.transition;
    try {
        $0b2e6adb871a3b94$var$mk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Vk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$mk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Vk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Gk();
    while (null !== $0b2e6adb871a3b94$var$uk);
    if (0 !== ($0b2e6adb871a3b94$var$W & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Ac(a, f);
    a === $0b2e6adb871a3b94$var$P && ($0b2e6adb871a3b94$var$X = $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Y = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$tk || ($0b2e6adb871a3b94$var$tk = !0, $0b2e6adb871a3b94$var$Ek($0b2e6adb871a3b94$var$gc, function() {
        $0b2e6adb871a3b94$var$Gk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$mk.transition;
        $0b2e6adb871a3b94$var$mk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$W;
        $0b2e6adb871a3b94$var$W |= 4;
        $0b2e6adb871a3b94$var$lk.current = null;
        $0b2e6adb871a3b94$var$Mj(a, c);
        $0b2e6adb871a3b94$var$bk(c, a);
        $0b2e6adb871a3b94$var$Ne($0b2e6adb871a3b94$var$Cf);
        $0b2e6adb871a3b94$var$cd = !!$0b2e6adb871a3b94$var$Bf;
        $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$Bf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$fk(c, a, e);
        $0b2e6adb871a3b94$var$cc();
        $0b2e6adb871a3b94$var$W = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$mk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$tk && ($0b2e6adb871a3b94$var$tk = !1, $0b2e6adb871a3b94$var$uk = a, $0b2e6adb871a3b94$var$vk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Oi = null);
    $0b2e6adb871a3b94$var$lc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)d(b[c]);
    if ($0b2e6adb871a3b94$var$Li) throw $0b2e6adb871a3b94$var$Li = !1, a = $0b2e6adb871a3b94$var$Mi, $0b2e6adb871a3b94$var$Mi = null, a;
    0 !== ($0b2e6adb871a3b94$var$vk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Gk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$xk ? $0b2e6adb871a3b94$var$wk++ : ($0b2e6adb871a3b94$var$wk = 0, $0b2e6adb871a3b94$var$xk = a) : $0b2e6adb871a3b94$var$wk = 0;
    $0b2e6adb871a3b94$var$ig();
    return null;
}
function $0b2e6adb871a3b94$var$Gk() {
    if (null !== $0b2e6adb871a3b94$var$uk) {
        var a = $0b2e6adb871a3b94$var$Cc($0b2e6adb871a3b94$var$vk), b = $0b2e6adb871a3b94$var$mk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$mk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$uk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$uk;
                $0b2e6adb871a3b94$var$uk = null;
                $0b2e6adb871a3b94$var$vk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$W & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$W;
                $0b2e6adb871a3b94$var$W |= 4;
                for($0b2e6adb871a3b94$var$T = a.current; null !== $0b2e6adb871a3b94$var$T;){
                    var f = $0b2e6adb871a3b94$var$T, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$T.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$T = l; null !== $0b2e6adb871a3b94$var$T;){
                                    var n = $0b2e6adb871a3b94$var$T;
                                    switch(n.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Nj(8, n, f);
                                    }
                                    var u = n.child;
                                    if (null !== u) u.return = n, $0b2e6adb871a3b94$var$T = u;
                                    else for(; null !== $0b2e6adb871a3b94$var$T;){
                                        n = $0b2e6adb871a3b94$var$T;
                                        var q = n.sibling, y = n.return;
                                        $0b2e6adb871a3b94$var$Qj(n);
                                        if (n === l) {
                                            $0b2e6adb871a3b94$var$T = null;
                                            break;
                                        }
                                        if (null !== q) {
                                            q.return = y;
                                            $0b2e6adb871a3b94$var$T = q;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$T = y;
                                    }
                                }
                            }
                            var m = f.alternate;
                            if (null !== m) {
                                var w = m.child;
                                if (null !== w) {
                                    m.child = null;
                                    do {
                                        var J = w.sibling;
                                        w.sibling = null;
                                        w = J;
                                    }while (null !== w);
                                }
                            }
                            $0b2e6adb871a3b94$var$T = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$T = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$T;){
                        f = $0b2e6adb871a3b94$var$T;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Nj(9, f, f.return);
                        }
                        var v = f.sibling;
                        if (null !== v) {
                            v.return = f.return;
                            $0b2e6adb871a3b94$var$T = v;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$T = f.return;
                    }
                }
                var x = a.current;
                for($0b2e6adb871a3b94$var$T = x; null !== $0b2e6adb871a3b94$var$T;){
                    g = $0b2e6adb871a3b94$var$T;
                    var r = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== r) r.return = g, $0b2e6adb871a3b94$var$T = r;
                    else b: for(g = x; null !== $0b2e6adb871a3b94$var$T;){
                        h = $0b2e6adb871a3b94$var$T;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Oj(9, h);
                            }
                        } catch (Z) {
                            $0b2e6adb871a3b94$var$U(h, h.return, Z);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$T = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$T = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$T = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$W = e;
                $0b2e6adb871a3b94$var$ig();
                if ($0b2e6adb871a3b94$var$kc && "function" === typeof $0b2e6adb871a3b94$var$kc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$kc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$jc, a);
                } catch (Z) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$mk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Hi(c, b);
    b = $0b2e6adb871a3b94$var$Ki(a, b, 1);
    $0b2e6adb871a3b94$var$Ag(a, b);
    b = $0b2e6adb871a3b94$var$Jg();
    a = $0b2e6adb871a3b94$var$Ak(a, 1);
    null !== a && ($0b2e6adb871a3b94$var$zc(a, 1, b), $0b2e6adb871a3b94$var$Ck(a, b));
}
function $0b2e6adb871a3b94$var$U(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Wk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Wk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Oi || !$0b2e6adb871a3b94$var$Oi.has(d))) {
                a = $0b2e6adb871a3b94$var$Hi(c, a);
                a = $0b2e6adb871a3b94$var$Ni(b, a, 1);
                $0b2e6adb871a3b94$var$Ag(b, a);
                a = $0b2e6adb871a3b94$var$Jg();
                b = $0b2e6adb871a3b94$var$Ak(b, 1);
                null !== b && ($0b2e6adb871a3b94$var$zc(b, 1, a), $0b2e6adb871a3b94$var$Ck(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$Jg();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$P === a && ($0b2e6adb871a3b94$var$Y & c) === c && (4 === $0b2e6adb871a3b94$var$R || 3 === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y & 130023424) === $0b2e6adb871a3b94$var$Y && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$dk ? $0b2e6adb871a3b94$var$Jk(a, 0) : $0b2e6adb871a3b94$var$pk |= c);
    $0b2e6adb871a3b94$var$Ck(a, b);
}
function $0b2e6adb871a3b94$var$Xk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$rc, $0b2e6adb871a3b94$var$rc <<= 1, 0 === ($0b2e6adb871a3b94$var$rc & 130023424) && ($0b2e6adb871a3b94$var$rc = 4194304)));
    var c = $0b2e6adb871a3b94$var$Jg();
    a = $0b2e6adb871a3b94$var$Ak(a, b);
    null !== a && ($0b2e6adb871a3b94$var$zc(a, b, c), $0b2e6adb871a3b94$var$Ck(a, c));
}
function $0b2e6adb871a3b94$var$zj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Xk(a, c);
}
function $0b2e6adb871a3b94$var$Zj(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Xk(a, c);
}
var $0b2e6adb871a3b94$var$Uk;
$0b2e6adb871a3b94$var$Uk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Vf.current) $0b2e6adb871a3b94$var$tg = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$tg = !1, $0b2e6adb871a3b94$var$Fj(a, b, c);
            $0b2e6adb871a3b94$var$tg = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$tg = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ah(b, $0b2e6adb871a3b94$var$Ug, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Xf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$sg(b, c);
            e = $0b2e6adb871a3b94$var$Uh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Zh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Yf(d) ? (f = !0, $0b2e6adb871a3b94$var$bg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$xg(b), e.updater = $0b2e6adb871a3b94$var$Mg, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Qg(b, d, a, c), b = $0b2e6adb871a3b94$var$pj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$bh(b), $0b2e6adb871a3b94$var$ej(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Yk(d);
                a = $0b2e6adb871a3b94$var$kg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$kj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$oj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$fj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, $0b2e6adb871a3b94$var$kg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$kg(d, e), $0b2e6adb871a3b94$var$kj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$kg(d, e), $0b2e6adb871a3b94$var$oj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$qj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$yg(a, b);
                $0b2e6adb871a3b94$var$Eg(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Error($0b2e6adb871a3b94$var$p(423));
                        b = $0b2e6adb871a3b94$var$rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Error($0b2e6adb871a3b94$var$p(424));
                        b = $0b2e6adb871a3b94$var$rj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$eh = $0b2e6adb871a3b94$var$Kf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$dh = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$fh = null, c = $0b2e6adb871a3b94$var$zh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$nh();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$gj(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$ej(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Hh(b), null === a && $0b2e6adb871a3b94$var$kh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Df(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Df(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$nj(a, b), $0b2e6adb871a3b94$var$ej(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$kh(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$vj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Fh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$yh(b, null, d, c) : $0b2e6adb871a3b94$var$ej(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$kg(d, e), $0b2e6adb871a3b94$var$fj(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$ej(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$ej(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$ej(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$lg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$Ge(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Vf.current) {
                            b = $0b2e6adb871a3b94$var$gj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$zg(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$rg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$rg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$ej(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$sg(b, c), e = $0b2e6adb871a3b94$var$ug(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$ej(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$kg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$kg(d.type, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$jj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$kg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $0b2e6adb871a3b94$var$Yf(d) ? (a = !0, $0b2e6adb871a3b94$var$bg(b)) : a = !1, $0b2e6adb871a3b94$var$sg(b, c), $0b2e6adb871a3b94$var$Og(b, d, e), $0b2e6adb871a3b94$var$Qg(b, d, e, c), $0b2e6adb871a3b94$var$pj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$Ej(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$lj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Ek(a, b) {
    return $0b2e6adb871a3b94$var$$b(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$Zk(a, b, c, d);
}
function $0b2e6adb871a3b94$var$ij(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Yk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$ij(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Ca) return 11;
        if (a === $0b2e6adb871a3b94$var$Fa) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$hh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$vh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$ij(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$wa:
            return $0b2e6adb871a3b94$var$xh(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$xa:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$za:
            return a = $0b2e6adb871a3b94$var$hh(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$za, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Da:
            return a = $0b2e6adb871a3b94$var$hh(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Da, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$hh(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ha:
            return $0b2e6adb871a3b94$var$wj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Aa:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ba:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Fa:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$hh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$xh(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$hh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$hh(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ha;
    a.lanes = c;
    a.stateNode = {};
    return a;
}
function $0b2e6adb871a3b94$var$uh(a, b, c) {
    a = $0b2e6adb871a3b94$var$hh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$wh(a, b, c) {
    b = $0b2e6adb871a3b94$var$hh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$yc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$yc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$yc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$$k(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$hh(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$xg(f);
    return a;
}
function $0b2e6adb871a3b94$var$bl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$va,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$cl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Uf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Ub(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Yf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Yf(c)) return $0b2e6adb871a3b94$var$ag(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$dl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$al(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$cl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$Jg();
    e = $0b2e6adb871a3b94$var$Kg(c);
    f = $0b2e6adb871a3b94$var$zg(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$Ag(c, f);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$zc(a, e, d);
    $0b2e6adb871a3b94$var$Ck(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$Jg(), g = $0b2e6adb871a3b94$var$Kg(e);
    c = $0b2e6adb871a3b94$var$cl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $0b2e6adb871a3b94$var$Ag(e, b);
    a = $0b2e6adb871a3b94$var$Lg(e, g, f);
    null !== a && $0b2e6adb871a3b94$var$Cg(a, e, g);
    return g;
}
function $0b2e6adb871a3b94$var$fl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$gl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    $0b2e6adb871a3b94$var$gl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$gl(a, b);
}
function $0b2e6adb871a3b94$var$il() {
    return null;
}
var $0b2e6adb871a3b94$var$jl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$kl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ll.prototype.render = $0b2e6adb871a3b94$var$kl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$el(a, b, null, null);
};
$0b2e6adb871a3b94$var$ll.prototype.unmount = $0b2e6adb871a3b94$var$kl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Qk(function() {
            $0b2e6adb871a3b94$var$el(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$tf] = null;
    }
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ll.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Gc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Pc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Pc[c].priority; c++);
        $0b2e6adb871a3b94$var$Pc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Uc(a);
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ol() {}
function $0b2e6adb871a3b94$var$pl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$fl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$dl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ol);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$tf] = g.current;
        $0b2e6adb871a3b94$var$rf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Qk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$fl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$al(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ol);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$tf] = k.current;
    $0b2e6adb871a3b94$var$rf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Qk(function() {
        $0b2e6adb871a3b94$var$el(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$fl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$el(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$pl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$fl(g);
}
$0b2e6adb871a3b94$var$Dc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$sc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Bc(b, c | 1), $0b2e6adb871a3b94$var$Ck(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$W & 6) && ($0b2e6adb871a3b94$var$aj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$ig()));
            }
            break;
        case 13:
            var d = $0b2e6adb871a3b94$var$Jg();
            $0b2e6adb871a3b94$var$Qk(function() {
                return $0b2e6adb871a3b94$var$Lg(a, 1, d);
            });
            $0b2e6adb871a3b94$var$hl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Ec = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Jg();
        $0b2e6adb871a3b94$var$Lg(a, 134217728, b);
        $0b2e6adb871a3b94$var$hl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Jg(), c = $0b2e6adb871a3b94$var$Kg(a);
        $0b2e6adb871a3b94$var$Lg(a, c, b);
        $0b2e6adb871a3b94$var$hl(a, c);
    }
};
$0b2e6adb871a3b94$var$Gc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Hc = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$xb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$$a(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Cb(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Va(d);
                        $0b2e6adb871a3b94$var$$a(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$eb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Fb = $0b2e6adb871a3b94$var$Pk;
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
var $0b2e6adb871a3b94$var$rl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Bb,
        $0b2e6adb871a3b94$var$te,
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Pk
    ]
}, $0b2e6adb871a3b94$var$sl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Vc,
    bundleType: 0,
    version: "18.1.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$tl = {
    bundleType: $0b2e6adb871a3b94$var$sl.bundleType,
    version: $0b2e6adb871a3b94$var$sl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$sl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$sl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ta.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Yb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$sl.findFiberByHostInstance || $0b2e6adb871a3b94$var$il,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.1.0-next-22edb9f77-20220426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$ul = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$ul.isDisabled && $0b2e6adb871a3b94$var$ul.supportsFiber) try {
        $0b2e6adb871a3b94$var$jc = $0b2e6adb871a3b94$var$ul.inject($0b2e6adb871a3b94$var$tl), $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$ul;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$rl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ml(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$bl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ml(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$jl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$al(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$tf] = b.current;
    $0b2e6adb871a3b94$var$rf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$kl(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Yb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Qk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$ql(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ml(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$jl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$dl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$tf] = b.current;
    $0b2e6adb871a3b94$var$rf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$ql(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Qk(function() {
        $0b2e6adb871a3b94$var$ql(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$tf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Pk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$nl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$ql(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.1.0-next-22edb9f77-20220426";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("7IZ3O", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $jDabP = parcelRequire("jDabP");

var $hPtJY = parcelRequire("hPtJY");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $jDabP.isBrowserBundle)() && Object.prototype.toString.call(typeof $hPtJY !== "undefined" ? $hPtJY : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("jDabP", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $e4a9904d531a9658$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $e4a9904d531a9658$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $e4a9904d531a9658$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $e4a9904d531a9658$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("jJGJU", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $bGTKO = parcelRequire("bGTKO");
function $e5e35f72a9c91714$var$emptyFunction() {}
function $e5e35f72a9c91714$var$emptyFunctionWithReset() {}
$e5e35f72a9c91714$var$emptyFunctionWithReset.resetWarningCache = $e5e35f72a9c91714$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $bGTKO) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e5e35f72a9c91714$var$emptyFunctionWithReset,
        resetWarningCache: $e5e35f72a9c91714$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("bGTKO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $882edd91751eae52$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $882edd91751eae52$var$ReactPropTypesSecret;

});


parcelRegister("7Ekty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    const Component = (props, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $jTnBY = parcelRequire("jTnBY");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _theme$palette$ownerS, _theme$palette, _theme$palette$ownerS2, _theme$palette2, _theme$palette2$actio, _theme$palette3, _theme$palette3$actio;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_theme$palette$ownerS = (_theme$palette = theme.palette) == null ? void 0 : (_theme$palette$ownerS2 = _theme$palette[ownerState.color]) == null ? void 0 : _theme$palette$ownerS2.main) != null ? _theme$palette$ownerS : ({
            action: (_theme$palette2 = theme.palette) == null ? void 0 : (_theme$palette2$actio = _theme$palette2.action) == null ? void 0 : _theme$palette2$actio.active,
            disabled: (_theme$palette3 = theme.palette) == null ? void 0 : (_theme$palette3$actio = _theme$palette3.action) == null ? void 0 : _theme$palette3$actio.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.muiName = "SvgIcon";
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});

parcelRegister("1SA7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e6d94060e5d8b6$export$2e2bcd8739ae039);
function $15e6d94060e5d8b6$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $15e6d94060e5d8b6$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $15e6d94060e5d8b6$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = "";
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $15e6d94060e5d8b6$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("9971e", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a8a661a1276b3fd$export$2e2bcd8739ae039);
function $6a8a661a1276b3fd$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                if (classes && classes[key]) acc.push(classes[key]);
                acc.push(getUtilityClass(key));
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $6IaFk = parcelRequire("6IaFk");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $6IaFk.default);

});
parcelRegister("6IaFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2f201fa2fbf9f3$export$2e2bcd8739ae039);

var $bUPtf = parcelRequire("bUPtf");
function $4e2f201fa2fbf9f3$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $bUPtf.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("bUPtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8accd9aba21f8e48$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $8accd9aba21f8e48$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("6g9fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $48eb684ebe9272b4$export$2e2bcd8739ae039);

var $7qEX0 = parcelRequire("7qEX0");

var $jR9F1 = parcelRequire("jR9F1");
function $48eb684ebe9272b4$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $7qEX0.default)({
        props: props,
        name: name,
        defaultTheme: $jR9F1.default
    });
}

});
parcelRegister("7qEX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $568aba12ccdf91ea$export$2e2bcd8739ae039);

var $5BtxM = parcelRequire("5BtxM");

var $lJyjx = parcelRequire("lJyjx");
function $568aba12ccdf91ea$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme }) {
    const theme = (0, $lJyjx.default)(defaultTheme);
    const mergedProps = (0, $5BtxM.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("5BtxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $414753394dff993c$export$2e2bcd8739ae039);

var $1vDzc = parcelRequire("1vDzc");
function $414753394dff993c$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $1vDzc.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("1vDzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $119760d6b00d97d7$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $119760d6b00d97d7$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $8nd05.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("lJyjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd286b02fb568257$export$2e2bcd8739ae039);

var $8NnpI = parcelRequire("8NnpI");

var $5aZTU = parcelRequire("5aZTU");
const $fd286b02fb568257$export$35e57303dbd8a66 = (0, $8NnpI.default)();
function $fd286b02fb568257$var$useTheme(defaultTheme = $fd286b02fb568257$export$35e57303dbd8a66) {
    return (0, $5aZTU.default)(defaultTheme);
}
var $fd286b02fb568257$export$2e2bcd8739ae039 = $fd286b02fb568257$var$useTheme;

});
parcelRegister("8NnpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $66750fd06db62b1c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $17r9Q = parcelRequire("17r9Q");

var $2F4pg = parcelRequire("2F4pg");

var $jrZOE = parcelRequire("jrZOE");

var $2YDV9 = parcelRequire("2YDV9");
const $66750fd06db62b1c$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $66750fd06db62b1c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $66750fd06db62b1c$var$_excluded);
    const breakpoints = (0, $2F4pg.default)(breakpointsInput);
    const spacing = (0, $2YDV9.default)(spacingInput);
    let muiTheme = (0, $17r9Q.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $jrZOE.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $17r9Q.default)(acc, argument), muiTheme);
    return muiTheme;
}
var $66750fd06db62b1c$export$2e2bcd8739ae039 = $66750fd06db62b1c$var$createTheme;

});
parcelRegister("17r9Q", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $0d0b82dec42cae84$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $0d0b82dec42cae84$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $0d0b82dec42cae84$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $0d0b82dec42cae84$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($0d0b82dec42cae84$export$53b83ca8eaab0383(target) && $0d0b82dec42cae84$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($0d0b82dec42cae84$export$53b83ca8eaab0383(source[key]) && key in target && $0d0b82dec42cae84$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $0d0b82dec42cae84$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("2F4pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f02d41e88337c5c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $1f02d41e88337c5c$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $1f02d41e88337c5c$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $1f02d41e88337c5c$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || []; // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
}; // Keep in mind that @media is inclusive by the CSS specification.
function $1f02d41e88337c5c$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $1f02d41e88337c5c$var$_excluded);
    const sortedValues = $1f02d41e88337c5c$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("jrZOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2907d4f90ca619b$export$2e2bcd8739ae039);
const $e2907d4f90ca619b$var$shape = {
    borderRadius: 4
};
var $e2907d4f90ca619b$export$2e2bcd8739ae039 = $e2907d4f90ca619b$var$shape;

});

parcelRegister("2YDV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b026ca2499c378$export$2e2bcd8739ae039);

var $fbH80 = parcelRequire("fbH80");
function $22b026ca2499c378$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    const transform = (0, $fbH80.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("fbH80", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $b0e9566e383397d0$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $b0e9566e383397d0$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $b0e9566e383397d0$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "default", () => $b0e9566e383397d0$export$2e2bcd8739ae039);


var $lWAfe = parcelRequire("lWAfe");

var $9liTZ = parcelRequire("9liTZ");

var $aliUM = parcelRequire("aliUM");

var $6MB9o = parcelRequire("6MB9o");
const $b0e9566e383397d0$var$properties = {
    m: "margin",
    p: "padding"
};
const $b0e9566e383397d0$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $b0e9566e383397d0$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b0e9566e383397d0$var$getCssProperties = (0, $6MB9o.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b0e9566e383397d0$var$aliases[prop]) prop = $b0e9566e383397d0$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $b0e9566e383397d0$var$properties[a];
    const direction = $b0e9566e383397d0$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b0e9566e383397d0$var$marginKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $b0e9566e383397d0$var$paddingKeys = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $b0e9566e383397d0$var$spacingKeys = [
    ...$b0e9566e383397d0$var$marginKeys,
    ...$b0e9566e383397d0$var$paddingKeys
];
function $b0e9566e383397d0$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $9liTZ.getPath)(theme, themeKey)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $b0e9566e383397d0$export$1def6f833384e3d1(theme) {
    return $b0e9566e383397d0$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $b0e9566e383397d0$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $b0e9566e383397d0$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b0e9566e383397d0$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b0e9566e383397d0$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b0e9566e383397d0$var$getCssProperties(prop);
    const styleFromPropValue = $b0e9566e383397d0$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $lWAfe.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b0e9566e383397d0$var$style(props, keys) {
    const transformer = $b0e9566e383397d0$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b0e9566e383397d0$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aliUM.default), {});
}
function $b0e9566e383397d0$export$7ede87f9b603dd3c(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$var$marginKeys);
}
$b0e9566e383397d0$export$7ede87f9b603dd3c.propTypes = {};
$b0e9566e383397d0$export$7ede87f9b603dd3c.filterProps = $b0e9566e383397d0$var$marginKeys;
function $b0e9566e383397d0$export$6f98e8eaf0be1996(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$var$paddingKeys);
}
$b0e9566e383397d0$export$6f98e8eaf0be1996.propTypes = {};
$b0e9566e383397d0$export$6f98e8eaf0be1996.filterProps = $b0e9566e383397d0$var$paddingKeys;
function $b0e9566e383397d0$var$spacing(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$var$spacingKeys);
}
$b0e9566e383397d0$var$spacing.propTypes = {};
$b0e9566e383397d0$var$spacing.filterProps = $b0e9566e383397d0$var$spacingKeys;
var $b0e9566e383397d0$export$2e2bcd8739ae039 = $b0e9566e383397d0$var$spacing;

});
parcelRegister("lWAfe", function(module, exports) {

$parcel$export(module.exports, "values", () => $ff9b2135c2bff8b7$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $ff9b2135c2bff8b7$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $ff9b2135c2bff8b7$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $ff9b2135c2bff8b7$export$8922c90b6e020726);
$parcel$export(module.exports, "resolveBreakpointValues", () => $ff9b2135c2bff8b7$export$980e6a259d807490);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("c9Z8w");

var $17r9Q = parcelRequire("17r9Q");

var $aliUM = parcelRequire("aliUM");
const $ff9b2135c2bff8b7$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $ff9b2135c2bff8b7$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$ff9b2135c2bff8b7$export$68c286be0e7e55b7[key]}px)`
};
function $ff9b2135c2bff8b7$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $ff9b2135c2bff8b7$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $ff9b2135c2bff8b7$var$breakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aliUM.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $ff9b2135c2bff8b7$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ff9b2135c2bff8b7$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ff9b2135c2bff8b7$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $ff9b2135c2bff8b7$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $17r9Q.default)(prev, next), {});
    return $ff9b2135c2bff8b7$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
} // compute base for responsive values; e.g.,
function $ff9b2135c2bff8b7$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ff9b2135c2bff8b7$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $ff9b2135c2bff8b7$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous] || breakpointValues;
            previous = breakpoint;
        }
        return acc;
    }, {});
}
var $ff9b2135c2bff8b7$export$2e2bcd8739ae039 = $ff9b2135c2bff8b7$var$breakpoints;

});
parcelRegister("aliUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $787a899efa293fda$export$2e2bcd8739ae039);

var $17r9Q = parcelRequire("17r9Q");
function $787a899efa293fda$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $17r9Q.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $787a899efa293fda$export$2e2bcd8739ae039 = $787a899efa293fda$var$merge;

});


parcelRegister("9liTZ", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $6cd4bcc854268e2d$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "default", () => $6cd4bcc854268e2d$export$2e2bcd8739ae039);

var $6IaFk = parcelRequire("6IaFk");


var $lWAfe = parcelRequire("lWAfe");
function $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(obj, path) {
    if (!path || typeof path !== "string") return null;
     // Check if CSS variables are used
    if (obj && obj.vars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $6cd4bcc854268e2d$var$getValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value);
    return value;
}
function $6cd4bcc854268e2d$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $6cd4bcc854268e2d$var$getValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $6cd4bcc854268e2d$var$getValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $6IaFk.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $6cd4bcc854268e2d$export$2e2bcd8739ae039 = $6cd4bcc854268e2d$var$style;

});

parcelRegister("6MB9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f040b160197e08d$export$2e2bcd8739ae039);
function $4f040b160197e08d$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("5aZTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c4de721067b1c27$export$2e2bcd8739ae039);

var $lT1cX = parcelRequire("lT1cX");
function $3c4de721067b1c27$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $3c4de721067b1c27$var$useTheme(defaultTheme = null) {
    const contextTheme = (0, $lT1cX.default)();
    return !contextTheme || $3c4de721067b1c27$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $3c4de721067b1c27$export$2e2bcd8739ae039 = $3c4de721067b1c27$var$useTheme;

});
parcelRegister("lT1cX", function(module, exports) {

$parcel$export(module.exports, "default", () => $feefabedf550ce3f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fHPaR = parcelRequire("fHPaR");
function $feefabedf550ce3f$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $fHPaR.default));
    return theme;
}

});
parcelRegister("fHPaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f2914bcc222460$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $b6f2914bcc222460$export$2e2bcd8739ae039 = $b6f2914bcc222460$var$ThemeContext;

});





parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $17r9Q = parcelRequire("17r9Q");


var $8NnpI = parcelRequire("8NnpI");

var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");
const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $8NnpI.default)(options);
    let muiTheme = (0, $17r9Q.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, systemTheme.spacing, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $lhXgK.default))
    });
    muiTheme = (0, $17r9Q.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $17r9Q.default)(acc, argument), muiTheme);
    var component;
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [`${breakpoints.up("xs")} and (orientation: landscape)`]: {
                minHeight: 48
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $17r9Q = parcelRequire("17r9Q");
var $bUPtf = parcelRequire("bUPtf");

var $kyRHb = parcelRequire("kyRHb");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dzxhF.default).white,
        default: (0, $dzxhF.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dzxhF.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $dzxhF.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $kyRHb.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $kyRHb.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kyRHb.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $bUPtf.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $bUPtf.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $17r9Q.default)((0, $8nd05.default)({
        common: // A collection of common colors.
        $dzxhF.default,
        mode: // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kyRHb", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $ef80a26abd5cc14c$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $ef80a26abd5cc14c$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "darken", () => $ef80a26abd5cc14c$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $ef80a26abd5cc14c$export$c0816ed86df316af);
$parcel$export(module.exports, "emphasize", () => $ef80a26abd5cc14c$export$e665714f76e581fd);

var $bUPtf = parcelRequire("bUPtf");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ef80a26abd5cc14c$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $ef80a26abd5cc14c$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $ef80a26abd5cc14c$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $ef80a26abd5cc14c$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $ef80a26abd5cc14c$export$677b39864803984e($ef80a26abd5cc14c$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $bUPtf.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $bUPtf.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $ef80a26abd5cc14c$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $ef80a26abd5cc14c$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
function $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $ef80a26abd5cc14c$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $ef80a26abd5cc14c$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$ef80a26abd5cc14c$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $ef80a26abd5cc14c$export$29fb7152bd3f781a(color) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $ef80a26abd5cc14c$export$c852d90bf7403b62(color) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    let rgb = color.type === "hsl" ? $ef80a26abd5cc14c$export$677b39864803984e($ef80a26abd5cc14c$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $ef80a26abd5cc14c$export$d061e26956a60b0a(foreground, background) {
    const lumA = $ef80a26abd5cc14c$export$c852d90bf7403b62(foreground);
    const lumB = $ef80a26abd5cc14c$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $ef80a26abd5cc14c$export$58f0f39f63f3cf42(color, value) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    value = $ef80a26abd5cc14c$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    coefficient = $ef80a26abd5cc14c$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    coefficient = $ef80a26abd5cc14c$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $ef80a26abd5cc14c$export$c852d90bf7403b62(color) > 0.5 ? $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient) : $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient);
}

});

parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: "#000",
    white: "#fff"
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $17r9Q = parcelRequire("17r9Q");
const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps)
    };
    return (0, $17r9Q.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    "none",
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(",");
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});




parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", () => $0277c5e26ff0d56c$export$effb20ecdbf4d6aa);
$parcel$export(module.exports, "slotShouldForwardProp", () => $0277c5e26ff0d56c$export$f10c5a10d27438e5);
$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);

var $8uM0h = parcelRequire("8uM0h");

var $jR9F1 = parcelRequire("jR9F1");
const $0277c5e26ff0d56c$export$effb20ecdbf4d6aa = (prop)=>(0, $8uM0h.shouldForwardProp)(prop) && prop !== "classes";
const $0277c5e26ff0d56c$export$f10c5a10d27438e5 = (0, $8uM0h.shouldForwardProp);
const $0277c5e26ff0d56c$var$styled = (0, $8uM0h.default)({
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $0277c5e26ff0d56c$export$effb20ecdbf4d6aa
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("8uM0h", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", () => $62f65c9151f4e6ef$export$3ba67b570e26eea0);
$parcel$export(module.exports, "default", () => $62f65c9151f4e6ef$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bOOlK = parcelRequire("bOOlK");


var $8NnpI = parcelRequire("8NnpI");

var $3Owly = parcelRequire("3Owly");

var $g91qR = parcelRequire("g91qR");
const $62f65c9151f4e6ef$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
], $62f65c9151f4e6ef$var$_excluded2 = [
    "theme"
], $62f65c9151f4e6ef$var$_excluded3 = [
    "theme"
];
function $62f65c9151f4e6ef$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
const $62f65c9151f4e6ef$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $62f65c9151f4e6ef$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $3Owly.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $62f65c9151f4e6ef$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $3Owly.default)(themeVariant.props)]);
    });
    return variantsStyles;
}; // Update /system/styled/#api in case if this changes
function $62f65c9151f4e6ef$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $62f65c9151f4e6ef$export$35e57303dbd8a66 = (0, $8NnpI.default)();
const $62f65c9151f4e6ef$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $62f65c9151f4e6ef$export$2e2bcd8739ae039(input = {}) {
    const { defaultTheme: defaultTheme = $62f65c9151f4e6ef$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $62f65c9151f4e6ef$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $62f65c9151f4e6ef$export$3ba67b570e26eea0, styleFunctionSx: styleFunctionSx = (0, $g91qR.default) } = input;
    return (tag, inputOptions = {})=>{
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: overridesResolver } = inputOptions, options = (0, $1En50.default)(inputOptions, $62f65c9151f4e6ef$var$_excluded); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $62f65c9151f4e6ef$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                // eslint-disable-next-line no-underscore-dangle
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (_ref)=>{
                    let { theme: themeInput } = _ref, other = (0, $1En50.default)(_ref, $62f65c9151f4e6ef$var$_excluded2);
                    return stylesArg((0, $8nd05.default)({
                        theme: $62f65c9151f4e6ef$var$isEmpty(themeInput) ? defaultTheme : themeInput
                    }, other));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $62f65c9151f4e6ef$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                const styleOverrides = $62f65c9151f4e6ef$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle(props) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $62f65c9151f4e6ef$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                return $62f65c9151f4e6ef$var$variantsResolver(props, $62f65c9151f4e6ef$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push((props)=>{
                const theme = $62f65c9151f4e6ef$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                return styleFunctionSx((0, $8nd05.default)({}, props, {
                    theme: theme
                }));
            });
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill(""); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            // eslint-disable-next-line no-underscore-dangle
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (_ref2)=>{
                let { theme: themeInput } = _ref2, other = (0, $1En50.default)(_ref2, $62f65c9151f4e6ef$var$_excluded3);
                return styleArg((0, $8nd05.default)({
                    theme: $62f65c9151f4e6ef$var$isEmpty(themeInput) ? defaultTheme : themeInput
                }, other));
            };
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("bOOlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $89ab6b9e702438b4$export$2e2bcd8739ae039);
/** @license MUI v5.6.1
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1Bnx5 = parcelRequire("1Bnx5");

var $8zogs = parcelRequire("8zogs");
var $1my5K = parcelRequire("1my5K");


var $bBbjn = parcelRequire("bBbjn");
function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $1Bnx5.default)(tag, options);
    var styles, style;
    return stylesFactory;
}

});
parcelRegister("1Bnx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ab803fa905d303$export$2e2bcd8739ae039);

var $8jRlF = parcelRequire("8jRlF");
parcelRequire("9tmpp");
parcelRequire("acw62");
parcelRequire("1wfXK");

parcelRequire("2Hahg");
parcelRequire("cqnxX");
parcelRequire("2cQcJ");
var $12ab803fa905d303$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $12ab803fa905d303$export$2e2bcd8739ae039 = (0, $8jRlF.default).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$export$2e2bcd8739ae039[tagName] = $12ab803fa905d303$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("8jRlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e97af874e8cdaa$export$2e2bcd8739ae039);

var $fsVeJ = parcelRequire("fsVeJ");

var $acw62 = parcelRequire("acw62");

var $1wfXK = parcelRequire("1wfXK");
parcelRequire("8zogs");
var $1my5K = parcelRequire("1my5K");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $1wfXK.default);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $1my5K.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $1my5K.T));
            }
            if (typeof props.className === "string") className = (0, $2Hahg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $cqnxX.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $fsVeJ.default)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("fsVeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b425de8cd413f5b0$export$2e2bcd8739ae039);
function $b425de8cd413f5b0$export$2e2bcd8739ae039() {
    $b425de8cd413f5b0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b425de8cd413f5b0$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("1wfXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $11b529730d83f0a6$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
var $11b529730d83f0a6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $11b529730d83f0a6$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $11b529730d83f0a6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8zogs", function(module, exports) {

$parcel$export(module.exports, "Global", () => $63d46a01db878c10$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $63d46a01db878c10$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $63d46a01db878c10$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("1my5K")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("1my5K")).w);

var $1my5K = parcelRequire("1my5K");

var $acw62 = parcelRequire("acw62");

var $2Hahg = parcelRequire("2Hahg");

var $2cQcJ = parcelRequire("2cQcJ");

var $cqnxX = parcelRequire("cqnxX");
parcelRequire("lDTld");
parcelRequire("7x827");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $1my5K.h).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $1my5K.E);
    createElementArgArray[1] = (0, $1my5K.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $1my5K.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cqnxX.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $1my5K.T)));
    if (!(0, $1my5K.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2Hahg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cqnxX.serializeStyles)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2Hahg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $2Hahg.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $1my5K.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2Hahg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $1my5K.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;

});
parcelRegister("1my5K", function(module, exports) {

$parcel$export(module.exports, "i", () => $0fe24a6591b39473$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $0fe24a6591b39473$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $0fe24a6591b39473$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $0fe24a6591b39473$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $0fe24a6591b39473$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $0fe24a6591b39473$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $lDTld = parcelRequire("lDTld");

var $8sAjZ = parcelRequire("8sAjZ");

var $iq6RI = parcelRequire("iq6RI");

var $kKN31 = parcelRequire("kKN31");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $lDTld.default)({
    key: "css"
}) : null);
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $lDTld.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8sAjZ.default)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8sAjZ.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $kKN31.default)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $2Hahg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cqnxX.serializeStyles)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;

});
parcelRegister("lDTld", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc182b1f84212d3f$export$2e2bcd8739ae039);

var $jmsCu = parcelRequire("jmsCu");

var $fm8kz = parcelRequire("fm8kz");
parcelRequire("iq6RI");
parcelRequire("9ffXE");
var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($fc182b1f84212d3f$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fm8kz.stringify),
        (0, $fm8kz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jmsCu.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmsCu", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e18645ac1956fbe6$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("8sAjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $628d1cf039ec98d7$export$2e2bcd8739ae039);
function $628d1cf039ec98d7$export$2e2bcd8739ae039() {
    $628d1cf039ec98d7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $628d1cf039ec98d7$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("kKN31", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1be2661c8fac766$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9cCWX"));

});



parcelRegister("2Hahg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $1f6791d0a193b918$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $1f6791d0a193b918$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $1f6791d0a193b918$export$6f077d94b33a01aa);
var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cqnxX", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $90ba2da1f62e5f1b$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $bojqG = parcelRequire("bojqG");

var $9ffXE = parcelRequire("9ffXE");
var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $bojqG.default)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("bojqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b101df16c1118f$export$2e2bcd8739ae039);
var $84b101df16c1118f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2cQcJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $19b532704a3a90e7$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $19b532704a3a90e7$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("7x827", function(module, exports) {
function $57c1d8b49932598a$var$_extends() {
    module.exports = $57c1d8b49932598a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $57c1d8b49932598a$var$_extends.apply(this, arguments);
}
module.exports = $57c1d8b49932598a$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("9tmpp", function(module, exports) {
function $6e583467edc27794$var$_extends() {
    module.exports = $6e583467edc27794$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $6e583467edc27794$var$_extends.apply(this, arguments);
}
module.exports = $6e583467edc27794$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bBbjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $871beca1e2477cf0$export$2e2bcd8739ae039);
parcelRequire("acw62");
parcelRequire("c9Z8w");

var $8zogs = parcelRequire("8zogs");

var $ayMG0 = parcelRequire("ayMG0");
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8zogs.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1b2ls"));

});



parcelRegister("3Owly", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6f21fcf8073cde$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $6IaFk = parcelRequire("6IaFk");
const $2c6f21fcf8073cde$var$_excluded = [
    "variant"
];
function $2c6f21fcf8073cde$var$isEmpty(string) {
    return string.length === 0;
}
function $2c6f21fcf8073cde$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $1En50.default)(props, $2c6f21fcf8073cde$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $2c6f21fcf8073cde$var$isEmpty(classKey) ? props[key] : (0, $6IaFk.default)(props[key]);
        else classKey += `${$2c6f21fcf8073cde$var$isEmpty(classKey) ? key : (0, $6IaFk.default)(key)}${(0, $6IaFk.default)(props[key].toString())}`;
    });
    return classKey;
}

});

parcelRegister("g91qR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0e990868bc4709$export$2e2bcd8739ae039);

var $aliUM = parcelRequire("aliUM");

var $8hKYW = parcelRequire("8hKYW");

var $lWAfe = parcelRequire("lWAfe");
function $bc0e990868bc4709$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $bc0e990868bc4709$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
} // eslint-disable-next-line @typescript-eslint/naming-convention
function $bc0e990868bc4709$export$7d53d8bf2911e013(styleFunctionMapping = (0, $8hKYW.styleFunctionMapping)) {
    const propToStyleFunction = Object.keys(styleFunctionMapping).reduce((acc, styleFnName)=>{
        styleFunctionMapping[styleFnName].filterProps.forEach((propName)=>{
            acc[propName] = styleFunctionMapping[styleFnName];
        });
        return acc;
    }, {});
    function getThemeValue(prop, value, theme) {
        const inputProps = {
            [prop]: value,
            theme: theme
        };
        const styleFunction = propToStyleFunction[prop];
        return styleFunction ? styleFunction(inputProps) : {
            [prop]: value
        };
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // emotion & styled-components will neglect null
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $lWAfe.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $bc0e990868bc4709$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (propToStyleFunction[styleKey]) css = (0, $aliUM.default)(css, getThemeValue(styleKey, value, theme));
                        else {
                            const breakpointsValues = (0, $lWAfe.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($bc0e990868bc4709$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $aliUM.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aliUM.default)(css, getThemeValue(styleKey, value, theme));
                }
            });
            return (0, $lWAfe.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $bc0e990868bc4709$var$styleFunctionSx = $bc0e990868bc4709$export$7d53d8bf2911e013();
$bc0e990868bc4709$var$styleFunctionSx.filterProps = [
    "sx"
];
var $bc0e990868bc4709$export$2e2bcd8739ae039 = $bc0e990868bc4709$var$styleFunctionSx;

});
parcelRegister("8hKYW", function(module, exports) {

$parcel$export(module.exports, "styleFunctionMapping", () => $60845ae7b32278e9$export$40acc74e51be579a);
$parcel$export(module.exports, "propToStyleFunction", () => $60845ae7b32278e9$export$2ec640062268c7c4);

var $876wo = parcelRequire("876wo");

var $hZAuy = parcelRequire("hZAuy");

var $9qmyI = parcelRequire("9qmyI");

var $iqLnQ = parcelRequire("iqLnQ");

var $lr6HA = parcelRequire("lr6HA");

var $35ILh = parcelRequire("35ILh");

var $5l3Ar = parcelRequire("5l3Ar");

var $cvP8g = parcelRequire("cvP8g");

var $fbH80 = parcelRequire("fbH80");

var $rFH2x = parcelRequire("rFH2x");
const $60845ae7b32278e9$var$filterPropsMapping = {
    borders: (0, $876wo.default).filterProps,
    display: (0, $hZAuy.default).filterProps,
    flexbox: (0, $9qmyI.default).filterProps,
    grid: (0, $iqLnQ.default).filterProps,
    positions: (0, $lr6HA.default).filterProps,
    palette: (0, $35ILh.default).filterProps,
    shadows: (0, $5l3Ar.default).filterProps,
    sizing: (0, $cvP8g.default).filterProps,
    spacing: (0, $fbH80.default).filterProps,
    typography: (0, $rFH2x.default).filterProps
};
const $60845ae7b32278e9$export$40acc74e51be579a = {
    borders: $876wo.default,
    display: $hZAuy.default,
    flexbox: $9qmyI.default,
    grid: $iqLnQ.default,
    positions: $lr6HA.default,
    palette: $35ILh.default,
    shadows: $5l3Ar.default,
    sizing: $cvP8g.default,
    spacing: $fbH80.default,
    typography: $rFH2x.default
};
const $60845ae7b32278e9$export$2ec640062268c7c4 = Object.keys($60845ae7b32278e9$var$filterPropsMapping).reduce((acc, styleFnName)=>{
    $60845ae7b32278e9$var$filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = $60845ae7b32278e9$export$40acc74e51be579a[styleFnName];
    });
    return acc;
}, {});
function $60845ae7b32278e9$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $60845ae7b32278e9$export$2ec640062268c7c4[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $60845ae7b32278e9$export$2e2bcd8739ae039 = $60845ae7b32278e9$var$getThemeValue;

});
parcelRegister("876wo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e840933f788805e$export$2e2bcd8739ae039);


var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $fbH80 = parcelRequire("fbH80");

var $lWAfe = parcelRequire("lWAfe");
function $5e840933f788805e$var$getBorder(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $5e840933f788805e$export$1edee58a52776cd9 = (0, $9liTZ.default)({
    prop: "border",
    themeKey: "borders",
    transform: $5e840933f788805e$var$getBorder
});
const $5e840933f788805e$export$f9a7b6bd24892946 = (0, $9liTZ.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $5e840933f788805e$var$getBorder
});
const $5e840933f788805e$export$5abca33e6be905d2 = (0, $9liTZ.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $5e840933f788805e$var$getBorder
});
const $5e840933f788805e$export$e2ce9f12a980a822 = (0, $9liTZ.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $5e840933f788805e$var$getBorder
});
const $5e840933f788805e$export$47658cca1a909427 = (0, $9liTZ.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $5e840933f788805e$var$getBorder
});
const $5e840933f788805e$export$e7fb0694ba2404fc = (0, $9liTZ.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $5e840933f788805e$export$126a92c968acdb85 = (0, $9liTZ.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $5e840933f788805e$export$85cc51cb8fbb8c0e = (0, $9liTZ.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $5e840933f788805e$export$340b0327727f6d1a = (0, $9liTZ.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $5e840933f788805e$export$60beef91a985b4bf = (0, $9liTZ.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $5e840933f788805e$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$5e840933f788805e$export$7a57f79000377ca2.propTypes = {};
$5e840933f788805e$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $5e840933f788805e$var$borders = (0, $hLL0Z.default)($5e840933f788805e$export$1edee58a52776cd9, $5e840933f788805e$export$f9a7b6bd24892946, $5e840933f788805e$export$5abca33e6be905d2, $5e840933f788805e$export$e2ce9f12a980a822, $5e840933f788805e$export$47658cca1a909427, $5e840933f788805e$export$e7fb0694ba2404fc, $5e840933f788805e$export$126a92c968acdb85, $5e840933f788805e$export$85cc51cb8fbb8c0e, $5e840933f788805e$export$340b0327727f6d1a, $5e840933f788805e$export$60beef91a985b4bf, $5e840933f788805e$export$7a57f79000377ca2);
var $5e840933f788805e$export$2e2bcd8739ae039 = $5e840933f788805e$var$borders;

});
parcelRegister("hLL0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $cefb4bab9b5f3b71$export$2e2bcd8739ae039);

var $aliUM = parcelRequire("aliUM");
function $cefb4bab9b5f3b71$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aliUM.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $cefb4bab9b5f3b71$export$2e2bcd8739ae039 = $cefb4bab9b5f3b71$var$compose;

});


parcelRegister("hZAuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19470b37ebf6537$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");
const $d19470b37ebf6537$export$95a5c40fb210fe3e = (0, $9liTZ.default)({
    prop: "displayPrint",
    cssProperty: false,
    transform: (value)=>({
            "@media print": {
                display: value
            }
        })
});
const $d19470b37ebf6537$export$e5efd59aba9975ad = (0, $9liTZ.default)({
    prop: "display"
});
const $d19470b37ebf6537$export$f6530fb6e67e00bd = (0, $9liTZ.default)({
    prop: "overflow"
});
const $d19470b37ebf6537$export$f00f69a6f0e8c5b6 = (0, $9liTZ.default)({
    prop: "textOverflow"
});
const $d19470b37ebf6537$export$91fa9ac3f4021ce4 = (0, $9liTZ.default)({
    prop: "visibility"
});
const $d19470b37ebf6537$export$9ef81298ca34ad41 = (0, $9liTZ.default)({
    prop: "whiteSpace"
});
var $d19470b37ebf6537$export$2e2bcd8739ae039 = (0, $hLL0Z.default)($d19470b37ebf6537$export$95a5c40fb210fe3e, $d19470b37ebf6537$export$e5efd59aba9975ad, $d19470b37ebf6537$export$f6530fb6e67e00bd, $d19470b37ebf6537$export$f00f69a6f0e8c5b6, $d19470b37ebf6537$export$91fa9ac3f4021ce4, $d19470b37ebf6537$export$9ef81298ca34ad41);

});

parcelRegister("9qmyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc80a7992b68a29$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");
const $6dc80a7992b68a29$export$d2ad290394bbc49d = (0, $9liTZ.default)({
    prop: "flexBasis"
});
const $6dc80a7992b68a29$export$84c3c16c9ed6c908 = (0, $9liTZ.default)({
    prop: "flexDirection"
});
const $6dc80a7992b68a29$export$9a4bcd01f5c204bc = (0, $9liTZ.default)({
    prop: "flexWrap"
});
const $6dc80a7992b68a29$export$8dea3061ba53bfd1 = (0, $9liTZ.default)({
    prop: "justifyContent"
});
const $6dc80a7992b68a29$export$898d9006406726bd = (0, $9liTZ.default)({
    prop: "alignItems"
});
const $6dc80a7992b68a29$export$38c32c6918694134 = (0, $9liTZ.default)({
    prop: "alignContent"
});
const $6dc80a7992b68a29$export$aaaeab0fac9a3ccb = (0, $9liTZ.default)({
    prop: "order"
});
const $6dc80a7992b68a29$export$97691fbb80847c19 = (0, $9liTZ.default)({
    prop: "flex"
});
const $6dc80a7992b68a29$export$36c65c169152373d = (0, $9liTZ.default)({
    prop: "flexGrow"
});
const $6dc80a7992b68a29$export$2670ac60b02109d2 = (0, $9liTZ.default)({
    prop: "flexShrink"
});
const $6dc80a7992b68a29$export$4545dd3632cb520b = (0, $9liTZ.default)({
    prop: "alignSelf"
});
const $6dc80a7992b68a29$export$55e6b7a7f0eaa3ff = (0, $9liTZ.default)({
    prop: "justifyItems"
});
const $6dc80a7992b68a29$export$d012640ac9a6446f = (0, $9liTZ.default)({
    prop: "justifySelf"
});
const $6dc80a7992b68a29$var$flexbox = (0, $hLL0Z.default)($6dc80a7992b68a29$export$d2ad290394bbc49d, $6dc80a7992b68a29$export$84c3c16c9ed6c908, $6dc80a7992b68a29$export$9a4bcd01f5c204bc, $6dc80a7992b68a29$export$8dea3061ba53bfd1, $6dc80a7992b68a29$export$898d9006406726bd, $6dc80a7992b68a29$export$38c32c6918694134, $6dc80a7992b68a29$export$aaaeab0fac9a3ccb, $6dc80a7992b68a29$export$97691fbb80847c19, $6dc80a7992b68a29$export$36c65c169152373d, $6dc80a7992b68a29$export$2670ac60b02109d2, $6dc80a7992b68a29$export$4545dd3632cb520b, $6dc80a7992b68a29$export$55e6b7a7f0eaa3ff, $6dc80a7992b68a29$export$d012640ac9a6446f);
var $6dc80a7992b68a29$export$2e2bcd8739ae039 = $6dc80a7992b68a29$var$flexbox;

});

parcelRegister("iqLnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6af691b8c1915a2$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $fbH80 = parcelRequire("fbH80");

var $lWAfe = parcelRequire("lWAfe");

const $d6af691b8c1915a2$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$d6af691b8c1915a2$export$5df9adcb0db95e1e.propTypes = {};
$d6af691b8c1915a2$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $d6af691b8c1915a2$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$d6af691b8c1915a2$export$ec60d70ff941a580.propTypes = {};
$d6af691b8c1915a2$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $d6af691b8c1915a2$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$d6af691b8c1915a2$export$8a833ffa5f5dbeda.propTypes = {};
$d6af691b8c1915a2$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $d6af691b8c1915a2$export$baf44164ca3a34e8 = (0, $9liTZ.default)({
    prop: "gridColumn"
});
const $d6af691b8c1915a2$export$8f7213a1cd01e832 = (0, $9liTZ.default)({
    prop: "gridRow"
});
const $d6af691b8c1915a2$export$b0e0abbc49ba668 = (0, $9liTZ.default)({
    prop: "gridAutoFlow"
});
const $d6af691b8c1915a2$export$bcd8b929d4b4142 = (0, $9liTZ.default)({
    prop: "gridAutoColumns"
});
const $d6af691b8c1915a2$export$e5039a674e14c828 = (0, $9liTZ.default)({
    prop: "gridAutoRows"
});
const $d6af691b8c1915a2$export$42bd9088661ffb03 = (0, $9liTZ.default)({
    prop: "gridTemplateColumns"
});
const $d6af691b8c1915a2$export$920682ae05b999bc = (0, $9liTZ.default)({
    prop: "gridTemplateRows"
});
const $d6af691b8c1915a2$export$1b88fbdd482fd33a = (0, $9liTZ.default)({
    prop: "gridTemplateAreas"
});
const $d6af691b8c1915a2$export$bdb486e40d52d26f = (0, $9liTZ.default)({
    prop: "gridArea"
});
const $d6af691b8c1915a2$var$grid = (0, $hLL0Z.default)($d6af691b8c1915a2$export$5df9adcb0db95e1e, $d6af691b8c1915a2$export$ec60d70ff941a580, $d6af691b8c1915a2$export$8a833ffa5f5dbeda, $d6af691b8c1915a2$export$baf44164ca3a34e8, $d6af691b8c1915a2$export$8f7213a1cd01e832, $d6af691b8c1915a2$export$b0e0abbc49ba668, $d6af691b8c1915a2$export$bcd8b929d4b4142, $d6af691b8c1915a2$export$e5039a674e14c828, $d6af691b8c1915a2$export$42bd9088661ffb03, $d6af691b8c1915a2$export$920682ae05b999bc, $d6af691b8c1915a2$export$1b88fbdd482fd33a, $d6af691b8c1915a2$export$bdb486e40d52d26f);
var $d6af691b8c1915a2$export$2e2bcd8739ae039 = $d6af691b8c1915a2$var$grid;

});

parcelRegister("lr6HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b151778045db5b$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");
const $f9b151778045db5b$export$5880b8b5730aff45 = (0, $9liTZ.default)({
    prop: "position"
});
const $f9b151778045db5b$export$56446adcecbeec34 = (0, $9liTZ.default)({
    prop: "zIndex",
    themeKey: "zIndex"
});
const $f9b151778045db5b$export$1e95b668f3b82d = (0, $9liTZ.default)({
    prop: "top"
});
const $f9b151778045db5b$export$79ffe56a765070d2 = (0, $9liTZ.default)({
    prop: "right"
});
const $f9b151778045db5b$export$40e543e69a8b3fbb = (0, $9liTZ.default)({
    prop: "bottom"
});
const $f9b151778045db5b$export$eabcd2c8791e7bf4 = (0, $9liTZ.default)({
    prop: "left"
});
var $f9b151778045db5b$export$2e2bcd8739ae039 = (0, $hLL0Z.default)($f9b151778045db5b$export$5880b8b5730aff45, $f9b151778045db5b$export$56446adcecbeec34, $f9b151778045db5b$export$1e95b668f3b82d, $f9b151778045db5b$export$79ffe56a765070d2, $f9b151778045db5b$export$40e543e69a8b3fbb, $f9b151778045db5b$export$eabcd2c8791e7bf4);

});

parcelRegister("35ILh", function(module, exports) {

$parcel$export(module.exports, "default", () => $24048f76f475764b$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");
const $24048f76f475764b$export$35e9368ef982300f = (0, $9liTZ.default)({
    prop: "color",
    themeKey: "palette"
});
const $24048f76f475764b$export$2506f56c10355b33 = (0, $9liTZ.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette"
});
const $24048f76f475764b$export$8c5a050822fd698c = (0, $9liTZ.default)({
    prop: "backgroundColor",
    themeKey: "palette"
});
const $24048f76f475764b$var$palette = (0, $hLL0Z.default)($24048f76f475764b$export$35e9368ef982300f, $24048f76f475764b$export$2506f56c10355b33, $24048f76f475764b$export$8c5a050822fd698c);
var $24048f76f475764b$export$2e2bcd8739ae039 = $24048f76f475764b$var$palette;

});

parcelRegister("5l3Ar", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e31b22b70f2a43e$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");
const $3e31b22b70f2a43e$var$boxShadow = (0, $9liTZ.default)({
    prop: "boxShadow",
    themeKey: "shadows"
});
var $3e31b22b70f2a43e$export$2e2bcd8739ae039 = $3e31b22b70f2a43e$var$boxShadow;

});

parcelRegister("cvP8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $91c00b16c070497b$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $lWAfe = parcelRequire("lWAfe");
function $91c00b16c070497b$var$transform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $91c00b16c070497b$export$7e3df82ee760448c = (0, $9liTZ.default)({
    prop: "width",
    transform: $91c00b16c070497b$var$transform
});
const $91c00b16c070497b$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $lWAfe.values)[propValue];
            return {
                maxWidth: breakpoint || $91c00b16c070497b$var$transform(propValue)
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$91c00b16c070497b$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $91c00b16c070497b$export$ee148fbbe8357dd2 = (0, $9liTZ.default)({
    prop: "minWidth",
    transform: $91c00b16c070497b$var$transform
});
const $91c00b16c070497b$export$ac607276a8fe9f0a = (0, $9liTZ.default)({
    prop: "height",
    transform: $91c00b16c070497b$var$transform
});
const $91c00b16c070497b$export$dc0d8bd0b94f8570 = (0, $9liTZ.default)({
    prop: "maxHeight",
    transform: $91c00b16c070497b$var$transform
});
const $91c00b16c070497b$export$a43cf604e12f3b17 = (0, $9liTZ.default)({
    prop: "minHeight",
    transform: $91c00b16c070497b$var$transform
});
const $91c00b16c070497b$export$ffed9f14fb65e276 = (0, $9liTZ.default)({
    prop: "size",
    cssProperty: "width",
    transform: $91c00b16c070497b$var$transform
});
const $91c00b16c070497b$export$905076ed6620e671 = (0, $9liTZ.default)({
    prop: "size",
    cssProperty: "height",
    transform: $91c00b16c070497b$var$transform
});
const $91c00b16c070497b$export$6ccc93f785106a58 = (0, $9liTZ.default)({
    prop: "boxSizing"
});
const $91c00b16c070497b$var$sizing = (0, $hLL0Z.default)($91c00b16c070497b$export$7e3df82ee760448c, $91c00b16c070497b$export$488fda99655ff65a, $91c00b16c070497b$export$ee148fbbe8357dd2, $91c00b16c070497b$export$ac607276a8fe9f0a, $91c00b16c070497b$export$dc0d8bd0b94f8570, $91c00b16c070497b$export$a43cf604e12f3b17, $91c00b16c070497b$export$6ccc93f785106a58);
var $91c00b16c070497b$export$2e2bcd8739ae039 = $91c00b16c070497b$var$sizing;

});

parcelRegister("rFH2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $0532dd217203c03c$export$2e2bcd8739ae039);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");
const $0532dd217203c03c$export$a5975749f0374264 = (0, $9liTZ.default)({
    prop: "fontFamily",
    themeKey: "typography"
});
const $0532dd217203c03c$export$85e3c3ca0c6fb93 = (0, $9liTZ.default)({
    prop: "fontSize",
    themeKey: "typography"
});
const $0532dd217203c03c$export$a827189a08c5a3a3 = (0, $9liTZ.default)({
    prop: "fontStyle",
    themeKey: "typography"
});
const $0532dd217203c03c$export$bc0b29e67df3229e = (0, $9liTZ.default)({
    prop: "fontWeight",
    themeKey: "typography"
});
const $0532dd217203c03c$export$3eb52878e4502ad1 = (0, $9liTZ.default)({
    prop: "letterSpacing"
});
const $0532dd217203c03c$export$d1b52fec4405b471 = (0, $9liTZ.default)({
    prop: "textTransform"
});
const $0532dd217203c03c$export$c9b91427b594e14 = (0, $9liTZ.default)({
    prop: "lineHeight"
});
const $0532dd217203c03c$export$a87999391cd10ae9 = (0, $9liTZ.default)({
    prop: "textAlign"
});
const $0532dd217203c03c$export$60b2982fc282cca6 = (0, $9liTZ.default)({
    prop: "typography",
    cssProperty: false,
    themeKey: "typography"
});
const $0532dd217203c03c$var$typography = (0, $hLL0Z.default)($0532dd217203c03c$export$60b2982fc282cca6, $0532dd217203c03c$export$a5975749f0374264, $0532dd217203c03c$export$85e3c3ca0c6fb93, $0532dd217203c03c$export$a827189a08c5a3a3, $0532dd217203c03c$export$bc0b29e67df3229e, $0532dd217203c03c$export$3eb52878e4502ad1, $0532dd217203c03c$export$c9b91427b594e14, $0532dd217203c03c$export$a87999391cd10ae9, $0532dd217203c03c$export$d1b52fec4405b471);
var $0532dd217203c03c$export$2e2bcd8739ae039 = $0532dd217203c03c$var$typography;

});





parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $9XEW1.default)("MuiSvgIcon", slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $7u6PA.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});
parcelRegister("9XEW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $740960918996ef45$export$2e2bcd8739ae039);

var $fgJxe = parcelRequire("fgJxe");
const $740960918996ef45$var$globalStateClassesMapping = {
    active: "Mui-active",
    checked: "Mui-checked",
    completed: "Mui-completed",
    disabled: "Mui-disabled",
    error: "Mui-error",
    expanded: "Mui-expanded",
    focused: "Mui-focused",
    focusVisible: "Mui-focusVisible",
    required: "Mui-required",
    selected: "Mui-selected"
};
function $740960918996ef45$export$2e2bcd8739ae039(componentName, slot) {
    const globalStateClass = $740960918996ef45$var$globalStateClassesMapping[slot];
    return globalStateClass || `${(0, $fgJxe.default).generate(componentName)}-${slot}`;
}

});
parcelRegister("fgJxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1dbabf22133b509$export$2e2bcd8739ae039);
const $b1dbabf22133b509$var$defaultGenerator = (componentName)=>componentName;
const $b1dbabf22133b509$var$createClassNameGenerator = ()=>{
    let generate = $b1dbabf22133b509$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $b1dbabf22133b509$var$defaultGenerator;
        }
    };
};
const $b1dbabf22133b509$var$ClassNameGenerator = $b1dbabf22133b509$var$createClassNameGenerator();
var $b1dbabf22133b509$export$2e2bcd8739ae039 = $b1dbabf22133b509$var$ClassNameGenerator;

});


parcelRegister("7u6PA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5730a24294b62753$export$2e2bcd8739ae039);

var $9XEW1 = parcelRequire("9XEW1");
function $5730a24294b62753$export$2e2bcd8739ae039(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $9XEW1.default)(componentName, slot);
    });
    return result;
}

});





parcelRegister("cSJDD", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $960dedfd64f242ab$export$a7c73072b1a182ae, (v) => $960dedfd64f242ab$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $960dedfd64f242ab$export$9f27bc3417b4524d, (v) => $960dedfd64f242ab$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $960dedfd64f242ab$export$db77ccec0bb4ccac, (v) => $960dedfd64f242ab$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $960dedfd64f242ab$export$8392c0c9d3dcbd35, (v) => $960dedfd64f242ab$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $960dedfd64f242ab$export$ffb0004e005737fa, (v) => $960dedfd64f242ab$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $960dedfd64f242ab$export$b624eff549462981, (v) => $960dedfd64f242ab$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $960dedfd64f242ab$export$7897aa7841a5380c, (v) => $960dedfd64f242ab$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $960dedfd64f242ab$export$602eac185826482c, (v) => $960dedfd64f242ab$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $960dedfd64f242ab$export$e2c29f18771995cb, (v) => $960dedfd64f242ab$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $960dedfd64f242ab$export$5f8d39834fd61797, (v) => $960dedfd64f242ab$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $960dedfd64f242ab$export$74bf444e3cd11ea5, (v) => $960dedfd64f242ab$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $960dedfd64f242ab$export$92387174baf9b227, (v) => $960dedfd64f242ab$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $960dedfd64f242ab$export$ec112efeb987d9c6, (v) => $960dedfd64f242ab$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $960dedfd64f242ab$export$b706b080d889d2c9, (v) => $960dedfd64f242ab$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $960dedfd64f242ab$export$5be5a87408f70ddc, (v) => $960dedfd64f242ab$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $960dedfd64f242ab$export$45a5e7f76e0caa8d, (v) => $960dedfd64f242ab$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $960dedfd64f242ab$export$455c2e768291efa6, (v) => $960dedfd64f242ab$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $960dedfd64f242ab$export$9522e17588c12572, (v) => $960dedfd64f242ab$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $960dedfd64f242ab$export$2110ac352bb060b9, (v) => $960dedfd64f242ab$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $960dedfd64f242ab$export$56885ab8b9c456ab, (v) => $960dedfd64f242ab$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $960dedfd64f242ab$export$d927fcb6adf8f9de, (v) => $960dedfd64f242ab$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $960dedfd64f242ab$export$b82d16f27459e05a, (v) => $960dedfd64f242ab$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $960dedfd64f242ab$export$522c17b4f5e123e8, (v) => $960dedfd64f242ab$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $960dedfd64f242ab$export$1aabd8a0274ecfd6, (v) => $960dedfd64f242ab$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $960dedfd64f242ab$export$9b621391a187a31a, (v) => $960dedfd64f242ab$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $960dedfd64f242ab$export$f5bbd400c2f4426f, (v) => $960dedfd64f242ab$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $960dedfd64f242ab$export$a7c73072b1a182ae;
var $960dedfd64f242ab$export$9f27bc3417b4524d;
var $960dedfd64f242ab$export$db77ccec0bb4ccac;
var $960dedfd64f242ab$export$8392c0c9d3dcbd35;
var $960dedfd64f242ab$export$ffb0004e005737fa;
var $960dedfd64f242ab$export$b624eff549462981;
var $960dedfd64f242ab$export$7897aa7841a5380c;
var $960dedfd64f242ab$export$602eac185826482c;
var $960dedfd64f242ab$export$e2c29f18771995cb;
var $960dedfd64f242ab$export$5f8d39834fd61797;
var $960dedfd64f242ab$export$74bf444e3cd11ea5;
var $960dedfd64f242ab$export$92387174baf9b227;
var $960dedfd64f242ab$export$ec112efeb987d9c6;
var $960dedfd64f242ab$export$b706b080d889d2c9;
var $960dedfd64f242ab$export$5be5a87408f70ddc;
var $960dedfd64f242ab$export$45a5e7f76e0caa8d;
var $960dedfd64f242ab$export$455c2e768291efa6;
var $960dedfd64f242ab$export$9522e17588c12572;
var $960dedfd64f242ab$export$2110ac352bb060b9;
var $960dedfd64f242ab$export$56885ab8b9c456ab;
var $960dedfd64f242ab$export$d927fcb6adf8f9de;
var $960dedfd64f242ab$export$b82d16f27459e05a;
var $960dedfd64f242ab$export$522c17b4f5e123e8;
var $960dedfd64f242ab$export$1aabd8a0274ecfd6;
var $960dedfd64f242ab$export$9b621391a187a31a;
var $960dedfd64f242ab$export$f5bbd400c2f4426f;
"use strict";
var $960dedfd64f242ab$var$b = 60103, $960dedfd64f242ab$var$c = 60106, $960dedfd64f242ab$var$d = 60107, $960dedfd64f242ab$var$e = 60108, $960dedfd64f242ab$var$f = 60114, $960dedfd64f242ab$var$g = 60109, $960dedfd64f242ab$var$h = 60110, $960dedfd64f242ab$var$k = 60112, $960dedfd64f242ab$var$l = 60113, $960dedfd64f242ab$var$m = 60120, $960dedfd64f242ab$var$n = 60115, $960dedfd64f242ab$var$p = 60116, $960dedfd64f242ab$var$q = 60121, $960dedfd64f242ab$var$r = 60122, $960dedfd64f242ab$var$u = 60117, $960dedfd64f242ab$var$v = 60129, $960dedfd64f242ab$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $960dedfd64f242ab$var$x = Symbol.for;
    $960dedfd64f242ab$var$b = $960dedfd64f242ab$var$x("react.element");
    $960dedfd64f242ab$var$c = $960dedfd64f242ab$var$x("react.portal");
    $960dedfd64f242ab$var$d = $960dedfd64f242ab$var$x("react.fragment");
    $960dedfd64f242ab$var$e = $960dedfd64f242ab$var$x("react.strict_mode");
    $960dedfd64f242ab$var$f = $960dedfd64f242ab$var$x("react.profiler");
    $960dedfd64f242ab$var$g = $960dedfd64f242ab$var$x("react.provider");
    $960dedfd64f242ab$var$h = $960dedfd64f242ab$var$x("react.context");
    $960dedfd64f242ab$var$k = $960dedfd64f242ab$var$x("react.forward_ref");
    $960dedfd64f242ab$var$l = $960dedfd64f242ab$var$x("react.suspense");
    $960dedfd64f242ab$var$m = $960dedfd64f242ab$var$x("react.suspense_list");
    $960dedfd64f242ab$var$n = $960dedfd64f242ab$var$x("react.memo");
    $960dedfd64f242ab$var$p = $960dedfd64f242ab$var$x("react.lazy");
    $960dedfd64f242ab$var$q = $960dedfd64f242ab$var$x("react.block");
    $960dedfd64f242ab$var$r = $960dedfd64f242ab$var$x("react.server.block");
    $960dedfd64f242ab$var$u = $960dedfd64f242ab$var$x("react.fundamental");
    $960dedfd64f242ab$var$v = $960dedfd64f242ab$var$x("react.debug_trace_mode");
    $960dedfd64f242ab$var$w = $960dedfd64f242ab$var$x("react.legacy_hidden");
}
function $960dedfd64f242ab$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $960dedfd64f242ab$var$b:
                switch(a = a.type, a){
                    case $960dedfd64f242ab$var$d:
                    case $960dedfd64f242ab$var$f:
                    case $960dedfd64f242ab$var$e:
                    case $960dedfd64f242ab$var$l:
                    case $960dedfd64f242ab$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $960dedfd64f242ab$var$h:
                            case $960dedfd64f242ab$var$k:
                            case $960dedfd64f242ab$var$p:
                            case $960dedfd64f242ab$var$n:
                            case $960dedfd64f242ab$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $960dedfd64f242ab$var$c:
                return t;
        }
    }
}
var $960dedfd64f242ab$var$z = $960dedfd64f242ab$var$g, $960dedfd64f242ab$var$A = $960dedfd64f242ab$var$b, $960dedfd64f242ab$var$B = $960dedfd64f242ab$var$k, $960dedfd64f242ab$var$C = $960dedfd64f242ab$var$d, $960dedfd64f242ab$var$D = $960dedfd64f242ab$var$p, $960dedfd64f242ab$var$E = $960dedfd64f242ab$var$n, $960dedfd64f242ab$var$F = $960dedfd64f242ab$var$c, $960dedfd64f242ab$var$G = $960dedfd64f242ab$var$f, $960dedfd64f242ab$var$H = $960dedfd64f242ab$var$e, $960dedfd64f242ab$var$I = $960dedfd64f242ab$var$l;
$960dedfd64f242ab$export$a7c73072b1a182ae = $960dedfd64f242ab$var$h;
$960dedfd64f242ab$export$9f27bc3417b4524d = $960dedfd64f242ab$var$z;
$960dedfd64f242ab$export$db77ccec0bb4ccac = $960dedfd64f242ab$var$A;
$960dedfd64f242ab$export$8392c0c9d3dcbd35 = $960dedfd64f242ab$var$B;
$960dedfd64f242ab$export$ffb0004e005737fa = $960dedfd64f242ab$var$C;
$960dedfd64f242ab$export$b624eff549462981 = $960dedfd64f242ab$var$D;
$960dedfd64f242ab$export$7897aa7841a5380c = $960dedfd64f242ab$var$E;
$960dedfd64f242ab$export$602eac185826482c = $960dedfd64f242ab$var$F;
$960dedfd64f242ab$export$e2c29f18771995cb = $960dedfd64f242ab$var$G;
$960dedfd64f242ab$export$5f8d39834fd61797 = $960dedfd64f242ab$var$H;
$960dedfd64f242ab$export$74bf444e3cd11ea5 = $960dedfd64f242ab$var$I;
$960dedfd64f242ab$export$92387174baf9b227 = function() {
    return !1;
};
$960dedfd64f242ab$export$ec112efeb987d9c6 = function() {
    return !1;
};
$960dedfd64f242ab$export$b706b080d889d2c9 = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$h;
};
$960dedfd64f242ab$export$5be5a87408f70ddc = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$g;
};
$960dedfd64f242ab$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $960dedfd64f242ab$var$b;
};
$960dedfd64f242ab$export$455c2e768291efa6 = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$k;
};
$960dedfd64f242ab$export$9522e17588c12572 = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$d;
};
$960dedfd64f242ab$export$2110ac352bb060b9 = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$p;
};
$960dedfd64f242ab$export$56885ab8b9c456ab = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$n;
};
$960dedfd64f242ab$export$d927fcb6adf8f9de = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$c;
};
$960dedfd64f242ab$export$b82d16f27459e05a = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$f;
};
$960dedfd64f242ab$export$522c17b4f5e123e8 = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$e;
};
$960dedfd64f242ab$export$1aabd8a0274ecfd6 = function(a) {
    return $960dedfd64f242ab$var$y(a) === $960dedfd64f242ab$var$l;
};
$960dedfd64f242ab$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $960dedfd64f242ab$var$d || a === $960dedfd64f242ab$var$f || a === $960dedfd64f242ab$var$v || a === $960dedfd64f242ab$var$e || a === $960dedfd64f242ab$var$l || a === $960dedfd64f242ab$var$m || a === $960dedfd64f242ab$var$w || "object" === typeof a && null !== a && (a.$$typeof === $960dedfd64f242ab$var$p || a.$$typeof === $960dedfd64f242ab$var$n || a.$$typeof === $960dedfd64f242ab$var$g || a.$$typeof === $960dedfd64f242ab$var$h || a.$$typeof === $960dedfd64f242ab$var$k || a.$$typeof === $960dedfd64f242ab$var$u || a.$$typeof === $960dedfd64f242ab$var$q || a[0] === $960dedfd64f242ab$var$r) ? !0 : !1;
};
$960dedfd64f242ab$export$f5bbd400c2f4426f = $960dedfd64f242ab$var$y;

});

parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.15";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g, reTrimStart = /^\s+/, reTrimEnd = /\s+$/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            var index = -1;
            iteratees = arrayMap(iteratees.length ? iteratees : [
                identity
            ], baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            value = iteratee(value);
            var low = 0, high = array == null ? 0 : array.length, valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(array);
            if (stacked && stack.get(other)) return stacked == other;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked && stack.get(other)) return stacked == other;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = value.replace(reTrim, "");
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
            // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            // Like with sourceURL, we take care to not check the option's prototype,
            // as this configuration is a code injection vector.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrim, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimEnd, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("llHto", function(module, exports) {

$parcel$export(module.exports, "ssfn_", () => ssfn_);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $f8ad4802022ce868$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $a9oRf = parcelRequire("a9oRf");
function ssfn_(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function init() {
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * (1 + (0, $boTd3.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) //North pole
            //trace('stere:north pole');
            this.con = 1;
            else //South pole
            //trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * this.cons * (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $3xC66.default)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $bi5ZC.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - (0, $gyVUi.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $gyVUi.EPSLN) && Math.abs(lat + this.lat0) <= (0, $gyVUi.EPSLN)) {
        //case of the origine point
        //trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        //trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - (0, $gyVUi.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            ts = (0, $3xC66.default)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            //trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $gyVUi.EPSLN)) {
            //Eq
            //trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            //other case
            //trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    //trace(p.toString());
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $gyVUi.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
        } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
        if (rh <= (0, $gyVUi.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            //trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $2AZR8.default)(this.e, ts);
        lon = this.con * (0, $a9oRf.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y));
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $gyVUi.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
        }
        lat = -1 * (0, $2AZR8.default)(this.e, Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    //trace(p.toString());
    return p;
}
var names = [
    "stere",
    "Stereographic_South_Pole",
    "Polar Stereographic (variant B)"
];
var $f8ad4802022ce868$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    ssfn_: ssfn_
};

});
parcelRegister("gyVUi", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", () => $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27);
$parcel$export(module.exports, "PJD_7PARAM", () => $c0ecbd71ed29ee86$export$8cab19b7f383a7a7);
$parcel$export(module.exports, "PJD_WGS84", () => $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb);
$parcel$export(module.exports, "PJD_NODATUM", () => $c0ecbd71ed29ee86$export$8df4c7729d8ed58d);
$parcel$export(module.exports, "SEC_TO_RAD", () => $c0ecbd71ed29ee86$export$e0b9011552f3b2f7);
$parcel$export(module.exports, "HALF_PI", () => $c0ecbd71ed29ee86$export$f504979d7e0a75c7);
$parcel$export(module.exports, "SIXTH", () => $c0ecbd71ed29ee86$export$d7977f56a0faa834);
$parcel$export(module.exports, "RA4", () => $c0ecbd71ed29ee86$export$9e703428410a9c7b);
$parcel$export(module.exports, "RA6", () => $c0ecbd71ed29ee86$export$bb54dde5565ed6e3);
$parcel$export(module.exports, "EPSLN", () => $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb);
$parcel$export(module.exports, "D2R", () => $c0ecbd71ed29ee86$export$ed6012a68c0f4a70);
$parcel$export(module.exports, "R2D", () => $c0ecbd71ed29ee86$export$456934b8be7498c3);
$parcel$export(module.exports, "FORTPI", () => $c0ecbd71ed29ee86$export$10cb69dd603c11b0);
$parcel$export(module.exports, "TWO_PI", () => $c0ecbd71ed29ee86$export$6eec49b1a6289c4e);
$parcel$export(module.exports, "SPI", () => $c0ecbd71ed29ee86$export$703a92fc6506ffb9);
var $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27 = 1;
var $c0ecbd71ed29ee86$export$8cab19b7f383a7a7 = 2;
var $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $c0ecbd71ed29ee86$export$f504979d7e0a75c7 = Math.PI / 2;
var $c0ecbd71ed29ee86$export$d7977f56a0faa834 = 0.1666666666666666667;
var $c0ecbd71ed29ee86$export$9e703428410a9c7b = 0.04722222222222222222;
var $c0ecbd71ed29ee86$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb = 1.0e-10;
var $c0ecbd71ed29ee86$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $c0ecbd71ed29ee86$export$456934b8be7498c3 = 57.29577951308232088;
var $c0ecbd71ed29ee86$export$10cb69dd603c11b0 = Math.PI / 4;
var $c0ecbd71ed29ee86$export$6eec49b1a6289c4e = Math.PI * 2;
var $c0ecbd71ed29ee86$export$703a92fc6506ffb9 = 3.14159265359;

});

parcelRegister("boTd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ccc316da8510bf$export$2e2bcd8739ae039);
function $84ccc316da8510bf$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});

parcelRegister("bi5ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8386063044328ea8$export$2e2bcd8739ae039);
function $8386063044328ea8$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("3xC66", function(module, exports) {

$parcel$export(module.exports, "default", () => $2942018063c2eff1$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2942018063c2eff1$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) - phi)) / con;
}

});

parcelRegister("2AZR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3eece278ef2a71$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $1e3eece278ef2a71$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("phi2z has NoConvergence");
    return -9999;
}

});

parcelRegister("a9oRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $763e06e438986b6c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $763e06e438986b6c$export$2e2bcd8739ae039(x) {
    return Math.abs(x) <= (0, $gyVUi.SPI) ? x : x - (0, $boTd3.default)(x) * (0, $gyVUi.TWO_PI);
}

});


parcelRegister("deudM", function(module, exports) {

$parcel$export(module.exports, "S_POLE", () => S_POLE);
$parcel$export(module.exports, "N_POLE", () => N_POLE);
$parcel$export(module.exports, "EQUIT", () => EQUIT);
$parcel$export(module.exports, "OBLIQ", () => OBLIQ);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $9a24067d8ab69621$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
    else if (Math.abs(t) < (0, $gyVUi.EPSLN)) this.mode = this.EQUIT;
    else this.mode = this.OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $874JP.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case this.N_POLE:
                this.dd = 1;
                break;
            case this.S_POLE:
                this.dd = 1;
                break;
            case this.EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case this.OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $874JP.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === this.OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      -----------------*/ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $gyVUi.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $gyVUi.EPSLN)) return null;
            y = (0, $gyVUi.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $874JP.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $gyVUi.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $gyVUi.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $gyVUi.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $gyVUi.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $gyVUi.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $gyVUi.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $a9oRf.default)(this.long0 + lam);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    "Lambert Azimuthal Equal Area",
    "Lambert_Azimuthal_Equal_Area",
    "laea"
];
var $9a24067d8ab69621$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("874JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e82a7153665d151$export$2e2bcd8739ae039);
function $5e82a7153665d151$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("8mhgZ", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "phi1z", () => phi1z);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $615dc6dbd83ac6d5$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $874JP.default)(this.e3, this.sin_po, this.cos_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $874JP.default)(this.e3, this.sin_po, this.cos_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $874JP.default)(this.e3, this.sin_po, this.cos_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $874JP.default)(this.e3, this.sin_phi, this.cos_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $a9oRf.default)(lon - this.long0);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $a9oRf.default)(theta / this.ns0 + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $ljPJJ.default)(0.5 * qs);
    if (eccent < (0, $gyVUi.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    "Albers_Conic_Equal_Area",
    "Albers",
    "aea"
];
var $615dc6dbd83ac6d5$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("ljPJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8538120e633ea57$export$2e2bcd8739ae039);
function $f8538120e633ea57$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("6Eu1X", function(module, exports) {

$parcel$export(module.exports, "iterations", () => iterations);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $4d7dc5ed367b221e$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $gyVUi.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $gyVUi.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    "New_Zealand_Map_Grid",
    "nzmg"
];
var $4d7dc5ed367b221e$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});

parcelRegister("jv3NX", function(module, exports) {
/* global exports:true, module:true, require:true, define:true, global:true */ (function(root, name, factory) {
    /* jshint eqeqeq:false */ "use strict";
    // Used to determine if values are of the language type `Object`
    var objectTypes = {
        "function": true,
        "object": true
    }, freeExports = objectTypes["object"] && exports && !exports.nodeType && exports, freeModule = objectTypes["object"] && module && !module.nodeType && module, freeGlobal = freeExports && freeModule && typeof $parcel$global == "object" && $parcel$global, moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) root = freeGlobal;
    // Some AMD build optimizers, like r.js, check for specific condition
    // patterns like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // defined as an anonymous module.
        define([
            "exports"
        ], factory);
        // In case the source has been processed and wrapped in a define module use
        // the supplied `exports` object.
        if (freeExports && moduleExports) factory(freeModule.exports);
    } else if (freeExports && freeModule) {
        // in Node.js or RingoJS v0.8.0+
        if (moduleExports) factory(freeModule.exports);
        else factory(freeExports);
    } else factory(root[name] = {});
})(this, "luaparse", function(exports1) {
    "use strict";
    exports1.version = "0.2.1";
    var input, options, length;
    // Options can be set either globally on the parser object through
    // defaultOptions, or during the parse call.
    var defaultOptions = exports1.defaultOptions = {
        // Explicitly tell the parser when the input ends.
        wait: false,
        comments: true,
        scope: false,
        locations: false,
        ranges: false,
        onCreateNode: null,
        onCreateScope: null,
        onDestroyScope: null
    };
    // The available tokens expressed as enum flags so they can be checked with
    // bitwise operations.
    var EOF = 1, StringLiteral = 2, Keyword = 4, Identifier = 8, NumericLiteral = 16, Punctuator = 32, BooleanLiteral = 64, NilLiteral = 128, VarargLiteral = 256;
    exports1.tokenTypes = {
        EOF: EOF,
        StringLiteral: StringLiteral,
        Keyword: Keyword,
        Identifier: Identifier,
        NumericLiteral: NumericLiteral,
        Punctuator: Punctuator,
        BooleanLiteral: BooleanLiteral,
        NilLiteral: NilLiteral,
        VarargLiteral: VarargLiteral
    };
    // As this parser is a bit different from luas own, the error messages
    // will be different in some situations.
    var errors = exports1.errors = {
        unexpected: "unexpected %1 '%2' near '%3'",
        expected: "'%1' expected near '%2'",
        expectedToken: "%1 expected near '%2'",
        unfinishedString: "unfinished string near '%1'",
        malformedNumber: "malformed number near '%1'",
        invalidVar: "invalid left-hand side of assignment near '%1'"
    };
    // ### Abstract Syntax Tree
    //
    // The default AST structure is inspired by the Mozilla Parser API but can
    // easily be customized by overriding these functions.
    var ast = exports1.ast = {
        labelStatement: function(label) {
            return {
                type: "LabelStatement",
                label: label
            };
        },
        breakStatement: function() {
            return {
                type: "BreakStatement"
            };
        },
        gotoStatement: function(label) {
            return {
                type: "GotoStatement",
                label: label
            };
        },
        returnStatement: function(args) {
            return {
                type: "ReturnStatement",
                "arguments": args
            };
        },
        ifStatement: function(clauses) {
            return {
                type: "IfStatement",
                clauses: clauses
            };
        },
        ifClause: function(condition, body) {
            return {
                type: "IfClause",
                condition: condition,
                body: body
            };
        },
        elseifClause: function(condition, body) {
            return {
                type: "ElseifClause",
                condition: condition,
                body: body
            };
        },
        elseClause: function(body) {
            return {
                type: "ElseClause",
                body: body
            };
        },
        whileStatement: function(condition, body) {
            return {
                type: "WhileStatement",
                condition: condition,
                body: body
            };
        },
        doStatement: function(body) {
            return {
                type: "DoStatement",
                body: body
            };
        },
        repeatStatement: function(condition, body) {
            return {
                type: "RepeatStatement",
                condition: condition,
                body: body
            };
        },
        localStatement: function(variables, init) {
            return {
                type: "LocalStatement",
                variables: variables,
                init: init
            };
        },
        assignmentStatement: function(variables, init) {
            return {
                type: "AssignmentStatement",
                variables: variables,
                init: init
            };
        },
        callStatement: function(expression) {
            return {
                type: "CallStatement",
                expression: expression
            };
        },
        functionStatement: function(identifier, parameters, isLocal, body) {
            return {
                type: "FunctionDeclaration",
                identifier: identifier,
                isLocal: isLocal,
                parameters: parameters,
                body: body
            };
        },
        forNumericStatement: function(variable, start, end, step, body) {
            return {
                type: "ForNumericStatement",
                variable: variable,
                start: start,
                end: end,
                step: step,
                body: body
            };
        },
        forGenericStatement: function(variables, iterators, body) {
            return {
                type: "ForGenericStatement",
                variables: variables,
                iterators: iterators,
                body: body
            };
        },
        chunk: function(body) {
            return {
                type: "Chunk",
                body: body
            };
        },
        identifier: function(name) {
            return {
                type: "Identifier",
                name: name
            };
        },
        literal: function(type, value, raw) {
            type = type === StringLiteral ? "StringLiteral" : type === NumericLiteral ? "NumericLiteral" : type === BooleanLiteral ? "BooleanLiteral" : type === NilLiteral ? "NilLiteral" : "VarargLiteral";
            return {
                type: type,
                value: value,
                raw: raw
            };
        },
        tableKey: function(key, value) {
            return {
                type: "TableKey",
                key: key,
                value: value
            };
        },
        tableKeyString: function(key, value) {
            return {
                type: "TableKeyString",
                key: key,
                value: value
            };
        },
        tableValue: function(value) {
            return {
                type: "TableValue",
                value: value
            };
        },
        tableConstructorExpression: function(fields) {
            return {
                type: "TableConstructorExpression",
                fields: fields
            };
        },
        binaryExpression: function(operator, left, right) {
            var type = "and" === operator || "or" === operator ? "LogicalExpression" : "BinaryExpression";
            return {
                type: type,
                operator: operator,
                left: left,
                right: right
            };
        },
        unaryExpression: function(operator, argument) {
            return {
                type: "UnaryExpression",
                operator: operator,
                argument: argument
            };
        },
        memberExpression: function(base, indexer, identifier) {
            return {
                type: "MemberExpression",
                indexer: indexer,
                identifier: identifier,
                base: base
            };
        },
        indexExpression: function(base, index) {
            return {
                type: "IndexExpression",
                base: base,
                index: index
            };
        },
        callExpression: function(base, args) {
            return {
                type: "CallExpression",
                base: base,
                "arguments": args
            };
        },
        tableCallExpression: function(base, args) {
            return {
                type: "TableCallExpression",
                base: base,
                "arguments": args
            };
        },
        stringCallExpression: function(base, argument) {
            return {
                type: "StringCallExpression",
                base: base,
                argument: argument
            };
        },
        comment: function(value, raw) {
            return {
                type: "Comment",
                value: value,
                raw: raw
            };
        }
    };
    // Wrap up the node object.
    function finishNode(node) {
        // Pop a `Marker` off the location-array and attach its location data.
        if (trackLocations) {
            var location = locations.pop();
            location.complete();
            if (options.locations) node.loc = location.loc;
            if (options.ranges) node.range = location.range;
        }
        if (options.onCreateNode) options.onCreateNode(node);
        return node;
    }
    // Helpers
    // -------
    var slice = Array.prototype.slice, toString = Object.prototype.toString, indexOf = function indexOf(array, element) {
        for(var i = 0, length = array.length; i < length; i++){
            if (array[i] === element) return i;
        }
        return -1;
    };
    // Iterate through an array of objects and return the index of an object
    // with a matching property.
    function indexOfObject(array, property, element) {
        for(var i = 0, length = array.length; i < length; i++){
            if (array[i][property] === element) return i;
        }
        return -1;
    }
    // A sprintf implementation using %index (beginning at 1) to input
    // arguments in the format string.
    //
    // Example:
    //
    //     // Unexpected function in token
    //     sprintf('Unexpected %2 in %1.', 'token', 'function');
    function sprintf(format) {
        var args = slice.call(arguments, 1);
        format = format.replace(/%(\d)/g, function(match, index) {
            return "" + args[index - 1] || "";
        });
        return format;
    }
    // Returns a new object with the properties from all objectes passed as
    // arguments. Last argument takes precedence.
    //
    // Example:
    //
    //     this.options = extend(options, { output: false });
    function extend() {
        var args = slice.call(arguments), dest = {}, src, prop;
        for(var i = 0, length = args.length; i < length; i++){
            src = args[i];
            for(prop in src)if (src.hasOwnProperty(prop)) dest[prop] = src[prop];
        }
        return dest;
    }
    // ### Error functions
    // #### Raise an exception.
    //
    // Raise an exception by passing a token, a string format and its paramters.
    //
    // The passed tokens location will automatically be added to the error
    // message if it exists, if not it will default to the lexers current
    // position.
    //
    // Example:
    //
    //     // [1:0] expected [ near (
    //     raise(token, "expected %1 near %2", '[', token.value);
    function raise(token) {
        var message = sprintf.apply(null, slice.call(arguments, 1)), error, col;
        if ("undefined" !== typeof token.line) {
            col = token.range[0] - token.lineStart;
            error = new SyntaxError(sprintf("[%1:%2] %3", token.line, col, message));
            error.line = token.line;
            error.index = token.range[0];
            error.column = col;
        } else {
            col = index - lineStart + 1;
            error = new SyntaxError(sprintf("[%1:%2] %3", line, col, message));
            error.index = index;
            error.line = line;
            error.column = col;
        }
        throw error;
    }
    // #### Raise an unexpected token error.
    //
    // Example:
    //
    //     // expected <name> near '0'
    //     raiseUnexpectedToken('<name>', token);
    function raiseUnexpectedToken(type, token) {
        raise(token, errors.expectedToken, type, token.value);
    }
    // #### Raise a general unexpected error
    //
    // Usage should pass either a token object or a symbol string which was
    // expected. We can also specify a nearby token such as <eof>, this will
    // default to the currently active token.
    //
    // Example:
    //
    //     // Unexpected symbol 'end' near '<eof>'
    //     unexpected(token);
    //
    // If there's no token in the buffer it means we have reached <eof>.
    function unexpected(found, near) {
        if ("undefined" === typeof near) near = lookahead.value;
        if ("undefined" !== typeof found.type) {
            var type;
            switch(found.type){
                case StringLiteral:
                    type = "string";
                    break;
                case Keyword:
                    type = "keyword";
                    break;
                case Identifier:
                    type = "identifier";
                    break;
                case NumericLiteral:
                    type = "number";
                    break;
                case Punctuator:
                    type = "symbol";
                    break;
                case BooleanLiteral:
                    type = "boolean";
                    break;
                case NilLiteral:
                    return raise(found, errors.unexpected, "symbol", "nil", near);
            }
            return raise(found, errors.unexpected, type, found.value, near);
        }
        return raise(found, errors.unexpected, "symbol", found, near);
    }
    // Lexer
    // -----
    //
    // The lexer, or the tokenizer reads the input string character by character
    // and derives a token left-right. To be as efficient as possible the lexer
    // prioritizes the common cases such as identifiers. It also works with
    // character codes instead of characters as string comparisons was the
    // biggest bottleneck of the parser.
    //
    // If `options.comments` is enabled, all comments encountered will be stored
    // in an array which later will be appended to the chunk object. If disabled,
    // they will simply be disregarded.
    //
    // When the lexer has derived a valid token, it will be returned as an object
    // containing its value and as well as its position in the input string (this
    // is always enabled to provide proper debug messages).
    //
    // `lex()` starts lexing and returns the following token in the stream.
    var index, token, previousToken, lookahead, comments, tokenStart, line, lineStart;
    exports1.lex = lex;
    function lex() {
        skipWhiteSpace();
        // Skip comments beginning with --
        while(45 === input.charCodeAt(index) && 45 === input.charCodeAt(index + 1)){
            scanComment();
            skipWhiteSpace();
        }
        if (index >= length) return {
            type: EOF,
            value: "<eof>",
            line: line,
            lineStart: lineStart,
            range: [
                index,
                index
            ]
        };
        var charCode = input.charCodeAt(index), next = input.charCodeAt(index + 1);
        // Memorize the range index where the token begins.
        tokenStart = index;
        if (isIdentifierStart(charCode)) return scanIdentifierOrKeyword();
        switch(charCode){
            case 39:
            case 34:
                return scanStringLiteral();
            // 0-9
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                return scanNumericLiteral();
            case 46:
                // If the dot is followed by a digit it's a float.
                if (isDecDigit(next)) return scanNumericLiteral();
                if (46 === next) {
                    if (46 === input.charCodeAt(index + 2)) return scanVarargLiteral();
                    return scanPunctuator("..");
                }
                return scanPunctuator(".");
            case 61:
                if (61 === next) return scanPunctuator("==");
                return scanPunctuator("=");
            case 62:
                if (61 === next) return scanPunctuator(">=");
                if (62 === next) return scanPunctuator(">>");
                return scanPunctuator(">");
            case 60:
                if (60 === next) return scanPunctuator("<<");
                if (61 === next) return scanPunctuator("<=");
                return scanPunctuator("<");
            case 126:
                if (61 === next) return scanPunctuator("~=");
                return scanPunctuator("~");
            case 58:
                if (58 === next) return scanPunctuator("::");
                return scanPunctuator(":");
            case 91:
                // Check for a multiline string, they begin with [= or [[
                if (91 === next || 61 === next) return scanLongStringLiteral();
                return scanPunctuator("[");
            case 47:
                // Check for integer division op (//)
                if (47 === next) return scanPunctuator("//");
                return scanPunctuator("/");
            // * ^ % , { } ] ( ) ; & # - + |
            case 42:
            case 94:
            case 37:
            case 44:
            case 123:
            case 124:
            case 125:
            case 93:
            case 40:
            case 41:
            case 59:
            case 38:
            case 35:
            case 45:
            case 43:
                return scanPunctuator(input.charAt(index));
        }
        return unexpected(input.charAt(index));
    }
    // Whitespace has no semantic meaning in lua so simply skip ahead while
    // tracking the encounted newlines. Any kind of eol sequence is counted as a
    // single line.
    function consumeEOL() {
        var charCode = input.charCodeAt(index), peekCharCode = input.charCodeAt(index + 1);
        if (isLineTerminator(charCode)) {
            // Count \n\r and \r\n as one newline.
            if (10 === charCode && 13 === peekCharCode) index++;
            if (13 === charCode && 10 === peekCharCode) index++;
            line++;
            lineStart = ++index;
            return true;
        }
        return false;
    }
    function skipWhiteSpace() {
        while(index < length){
            var charCode = input.charCodeAt(index);
            if (isWhiteSpace(charCode)) index++;
            else if (!consumeEOL()) break;
        }
    }
    // Identifiers, keywords, booleans and nil all look the same syntax wise. We
    // simply go through them one by one and defaulting to an identifier if no
    // previous case matched.
    function scanIdentifierOrKeyword() {
        var value, type;
        // Slicing the input string is prefered before string concatenation in a
        // loop for performance reasons.
        while(isIdentifierPart(input.charCodeAt(++index)));
        value = input.slice(tokenStart, index);
        // Decide on the token type and possibly cast the value.
        if (isKeyword(value)) type = Keyword;
        else if ("true" === value || "false" === value) {
            type = BooleanLiteral;
            value = "true" === value;
        } else if ("nil" === value) {
            type = NilLiteral;
            value = null;
        } else type = Identifier;
        return {
            type: type,
            value: value,
            line: line,
            lineStart: lineStart,
            range: [
                tokenStart,
                index
            ]
        };
    }
    // Once a punctuator reaches this function it should already have been
    // validated so we simply return it as a token.
    function scanPunctuator(value) {
        index += value.length;
        return {
            type: Punctuator,
            value: value,
            line: line,
            lineStart: lineStart,
            range: [
                tokenStart,
                index
            ]
        };
    }
    // A vararg literal consists of three dots.
    function scanVarargLiteral() {
        index += 3;
        return {
            type: VarargLiteral,
            value: "...",
            line: line,
            lineStart: lineStart,
            range: [
                tokenStart,
                index
            ]
        };
    }
    // Find the string literal by matching the delimiter marks used.
    function scanStringLiteral() {
        var delimiter = input.charCodeAt(index++), stringStart = index, string = "", charCode;
        while(index < length){
            charCode = input.charCodeAt(index++);
            if (delimiter === charCode) break;
            if (92 === charCode) {
                string += input.slice(stringStart, index - 1) + readEscapeSequence();
                stringStart = index;
            } else if (index >= length || isLineTerminator(charCode)) {
                string += input.slice(stringStart, index - 1);
                raise({}, errors.unfinishedString, string + String.fromCharCode(charCode));
            }
        }
        string += input.slice(stringStart, index - 1);
        return {
            type: StringLiteral,
            value: string,
            line: line,
            lineStart: lineStart,
            range: [
                tokenStart,
                index
            ]
        };
    }
    // Expect a multiline string literal and return it as a regular string
    // literal, if it doesn't validate into a valid multiline string, throw an
    // exception.
    function scanLongStringLiteral() {
        var string = readLongString();
        // Fail if it's not a multiline literal.
        if (false === string) raise(token, errors.expected, "[", token.value);
        return {
            type: StringLiteral,
            value: string,
            line: line,
            lineStart: lineStart,
            range: [
                tokenStart,
                index
            ]
        };
    }
    // Numeric literals will be returned as floating-point numbers instead of
    // strings. The raw value should be retrieved from slicing the input string
    // later on in the process.
    //
    // If a hexadecimal number is encountered, it will be converted.
    function scanNumericLiteral() {
        var character = input.charAt(index), next = input.charAt(index + 1);
        var value = "0" === character && "xX".indexOf(next || null) >= 0 ? readHexLiteral() : readDecLiteral();
        return {
            type: NumericLiteral,
            value: value,
            line: line,
            lineStart: lineStart,
            range: [
                tokenStart,
                index
            ]
        };
    }
    // Lua hexadecimals have an optional fraction part and an optional binary
    // exoponent part. These are not included in JavaScript so we will compute
    // all three parts separately and then sum them up at the end of the function
    // with the following algorithm.
    //
    //     Digit := toDec(digit)
    //     Fraction := toDec(fraction) / 16 ^ fractionCount
    //     BinaryExp := 2 ^ binaryExp
    //     Number := ( Digit + Fraction ) * BinaryExp
    function readHexLiteral() {
        var fraction = 0 // defaults to 0 as it gets summed
        , binaryExponent = 1 // defaults to 1 as it gets multiplied
        , binarySign = 1 // positive
        , digit, fractionStart, exponentStart, digitStart;
        digitStart = index += 2; // Skip 0x part
        // A minimum of one hex digit is required.
        if (!isHexDigit(input.charCodeAt(index))) raise({}, errors.malformedNumber, input.slice(tokenStart, index));
        while(isHexDigit(input.charCodeAt(index)))index++;
        // Convert the hexadecimal digit to base 10.
        digit = parseInt(input.slice(digitStart, index), 16);
        // Fraction part i optional.
        if ("." === input.charAt(index)) {
            fractionStart = ++index;
            while(isHexDigit(input.charCodeAt(index)))index++;
            fraction = input.slice(fractionStart, index);
            // Empty fraction parts should default to 0, others should be converted
            // 0.x form so we can use summation at the end.
            fraction = fractionStart === index ? 0 : parseInt(fraction, 16) / Math.pow(16, index - fractionStart);
        }
        // Binary exponents are optional
        if ("pP".indexOf(input.charAt(index) || null) >= 0) {
            index++;
            // Sign part is optional and defaults to 1 (positive).
            if ("+-".indexOf(input.charAt(index) || null) >= 0) binarySign = "+" === input.charAt(index++) ? 1 : -1;
            exponentStart = index;
            // The binary exponent sign requires a decimal digit.
            if (!isDecDigit(input.charCodeAt(index))) raise({}, errors.malformedNumber, input.slice(tokenStart, index));
            while(isDecDigit(input.charCodeAt(index)))index++;
            binaryExponent = input.slice(exponentStart, index);
            // Calculate the binary exponent of the number.
            binaryExponent = Math.pow(2, binaryExponent * binarySign);
        }
        return (digit + fraction) * binaryExponent;
    }
    // Decimal numbers are exactly the same in Lua and in JavaScript, because of
    // this we check where the token ends and then parse it with native
    // functions.
    function readDecLiteral() {
        while(isDecDigit(input.charCodeAt(index)))index++;
        // Fraction part is optional
        if ("." === input.charAt(index)) {
            index++;
            // Fraction part defaults to 0
            while(isDecDigit(input.charCodeAt(index)))index++;
        }
        // Exponent part is optional.
        if ("eE".indexOf(input.charAt(index) || null) >= 0) {
            index++;
            // Sign part is optional.
            if ("+-".indexOf(input.charAt(index) || null) >= 0) index++;
            // An exponent is required to contain at least one decimal digit.
            if (!isDecDigit(input.charCodeAt(index))) raise({}, errors.malformedNumber, input.slice(tokenStart, index));
            while(isDecDigit(input.charCodeAt(index)))index++;
        }
        return parseFloat(input.slice(tokenStart, index));
    }
    // Translate escape sequences to the actual characters.
    function readEscapeSequence() {
        var sequenceStart = index;
        switch(input.charAt(index)){
            // Lua allow the following escape sequences.
            // We don't escape the bell sequence.
            case "n":
                index++;
                return "\n";
            case "r":
                index++;
                return "\r";
            case "t":
                index++;
                return "	";
            case "v":
                index++;
                return "\v";
            case "b":
                index++;
                return "\b";
            case "f":
                index++;
                return "\f";
            // Skips the following span of white-space.
            case "z":
                index++;
                skipWhiteSpace();
                return "";
            // Byte representation should for now be returned as is.
            case "x":
                // \xXX, where XX is a sequence of exactly two hexadecimal digits
                if (isHexDigit(input.charCodeAt(index + 1)) && isHexDigit(input.charCodeAt(index + 2))) {
                    index += 3;
                    // Return it as is, without translating the byte.
                    return "\\" + input.slice(sequenceStart, index);
                }
                return "\\" + input.charAt(index++);
            default:
                // \ddd, where ddd is a sequence of up to three decimal digits.
                if (isDecDigit(input.charCodeAt(index))) {
                    while(isDecDigit(input.charCodeAt(++index)));
                    return "\\" + input.slice(sequenceStart, index);
                }
                // Simply return the \ as is, it's not escaping any sequence.
                return input.charAt(index++);
        }
    }
    // Comments begin with -- after which it will be decided if they are
    // multiline comments or not.
    //
    // The multiline functionality works the exact same way as with string
    // literals so we reuse the functionality.
    function scanComment() {
        tokenStart = index;
        index += 2; // --
        var character = input.charAt(index), content = "", isLong = false, commentStart = index, lineStartComment = lineStart, lineComment = line;
        if ("[" === character) {
            content = readLongString();
            // This wasn't a multiline comment after all.
            if (false === content) content = character;
            else isLong = true;
        }
        // Scan until next line as long as it's not a multiline comment.
        if (!isLong) {
            while(index < length){
                if (isLineTerminator(input.charCodeAt(index))) break;
                index++;
            }
            if (options.comments) content = input.slice(commentStart, index);
        }
        if (options.comments) {
            var node = ast.comment(content, input.slice(tokenStart, index));
            // `Marker`s depend on tokens available in the parser and as comments are
            // intercepted in the lexer all location data is set manually.
            if (options.locations) node.loc = {
                start: {
                    line: lineComment,
                    column: tokenStart - lineStartComment
                },
                end: {
                    line: line,
                    column: index - lineStart
                }
            };
            if (options.ranges) node.range = [
                tokenStart,
                index
            ];
            if (options.onCreateNode) options.onCreateNode(node);
            comments.push(node);
        }
    }
    // Read a multiline string by calculating the depth of `=` characters and
    // then appending until an equal depth is found.
    function readLongString() {
        var level = 0, content = "", terminator = false, character, stringStart;
        index++; // [
        // Calculate the depth of the comment.
        while("=" === input.charAt(index + level))level++;
        // Exit, this is not a long string afterall.
        if ("[" !== input.charAt(index + level)) return false;
        index += level + 1;
        // If the first character is a newline, ignore it and begin on next line.
        if (isLineTerminator(input.charCodeAt(index))) consumeEOL();
        stringStart = index;
        while(index < length){
            // To keep track of line numbers run the `consumeEOL()` which increments
            // its counter.
            if (isLineTerminator(input.charCodeAt(index))) consumeEOL();
            character = input.charAt(index++);
            // Once the delimiter is found, iterate through the depth count and see
            // if it matches.
            if ("]" === character) {
                terminator = true;
                for(var i = 0; i < level; i++)if ("=" !== input.charAt(index + i)) terminator = false;
                if ("]" !== input.charAt(index + level)) terminator = false;
            }
            // We reached the end of the multiline string. Get out now.
            if (terminator) break;
        }
        content += input.slice(stringStart, index - 1);
        index += level + 1;
        return content;
    }
    // ## Lex functions and helpers.
    // Read the next token.
    //
    // This is actually done by setting the current token to the lookahead and
    // reading in the new lookahead token.
    function next() {
        previousToken = token;
        token = lookahead;
        lookahead = lex();
    }
    // Consume a token if its value matches. Once consumed or not, return the
    // success of the operation.
    function consume(value) {
        if (value === token.value) {
            next();
            return true;
        }
        return false;
    }
    // Expect the next token value to match. If not, throw an exception.
    function expect(value) {
        if (value === token.value) next();
        else raise(token, errors.expected, value, token.value);
    }
    // ### Validation functions
    function isWhiteSpace(charCode) {
        return 9 === charCode || 32 === charCode || 0xB === charCode || 0xC === charCode;
    }
    function isLineTerminator(charCode) {
        return 10 === charCode || 13 === charCode;
    }
    function isDecDigit(charCode) {
        return charCode >= 48 && charCode <= 57;
    }
    function isHexDigit(charCode) {
        return charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70;
    }
    // From [Lua 5.2](http://www.lua.org/manual/5.2/manual.html#8.1) onwards
    // identifiers cannot use locale-dependet letters.
    function isIdentifierStart(charCode) {
        return charCode >= 65 && charCode <= 90 || charCode >= 97 && charCode <= 122 || 95 === charCode;
    }
    function isIdentifierPart(charCode) {
        return charCode >= 65 && charCode <= 90 || charCode >= 97 && charCode <= 122 || 95 === charCode || charCode >= 48 && charCode <= 57;
    }
    // [3.1 Lexical Conventions](http://www.lua.org/manual/5.2/manual.html#3.1)
    //
    // `true`, `false` and `nil` will not be considered keywords, but literals.
    function isKeyword(id) {
        switch(id.length){
            case 2:
                return "do" === id || "if" === id || "in" === id || "or" === id;
            case 3:
                return "and" === id || "end" === id || "for" === id || "not" === id;
            case 4:
                return "else" === id || "goto" === id || "then" === id;
            case 5:
                return "break" === id || "local" === id || "until" === id || "while" === id;
            case 6:
                return "elseif" === id || "repeat" === id || "return" === id;
            case 8:
                return "function" === id;
        }
        return false;
    }
    function isUnary(token) {
        if (Punctuator === token.type) return "#-~".indexOf(token.value) >= 0;
        if (Keyword === token.type) return "not" === token.value;
        return false;
    }
    // @TODO this needs to be rethought.
    function isCallExpression(expression) {
        switch(expression.type){
            case "CallExpression":
            case "TableCallExpression":
            case "StringCallExpression":
                return true;
        }
        return false;
    }
    // Check if the token syntactically closes a block.
    function isBlockFollow(token) {
        if (EOF === token.type) return true;
        if (Keyword !== token.type) return false;
        switch(token.value){
            case "else":
            case "elseif":
            case "end":
            case "until":
                return true;
            default:
                return false;
        }
    }
    // Scope
    // -----
    // Store each block scope as a an array of identifier names. Each scope is
    // stored in an FILO-array.
    var scopes, scopeDepth, globals;
    // Create a new scope inheriting all declarations from the previous scope.
    function createScope() {
        var scope = Array.apply(null, scopes[scopeDepth++]);
        scopes.push(scope);
        if (options.onCreateScope) options.onCreateScope();
    }
    // Exit and remove the current scope.
    function destroyScope() {
        var scope = scopes.pop();
        scopeDepth--;
        if (options.onDestroyScope) options.onDestroyScope();
    }
    // Add identifier name to the current scope if it doesnt already exist.
    function scopeIdentifierName(name) {
        if (-1 !== indexOf(scopes[scopeDepth], name)) return;
        scopes[scopeDepth].push(name);
    }
    // Add identifier to the current scope
    function scopeIdentifier(node) {
        scopeIdentifierName(node.name);
        attachScope(node, true);
    }
    // Attach scope information to node. If the node is global, store it in the
    // globals array so we can return the information to the user.
    function attachScope(node, isLocal) {
        if (!isLocal && -1 === indexOfObject(globals, "name", node.name)) globals.push(node);
        node.isLocal = isLocal;
    }
    // Is the identifier name available in this scope.
    function scopeHasName(name) {
        return -1 !== indexOf(scopes[scopeDepth], name);
    }
    // Location tracking
    // -----------------
    //
    // Locations are stored in FILO-array as a `Marker` object consisting of both
    // `loc` and `range` data. Once a `Marker` is popped off the list an end
    // location is added and the data is attached to a syntax node.
    var locations = [], trackLocations;
    function createLocationMarker() {
        return new Marker(token);
    }
    function Marker(token) {
        if (options.locations) this.loc = {
            start: {
                line: token.line,
                column: token.range[0] - token.lineStart
            },
            end: {
                line: 0,
                column: 0
            }
        };
        if (options.ranges) this.range = [
            token.range[0],
            0
        ];
    }
    // Complete the location data stored in the `Marker` by adding the location
    // of the *previous token* as an end location.
    Marker.prototype.complete = function() {
        if (options.locations) {
            this.loc.end.line = previousToken.line;
            this.loc.end.column = previousToken.range[1] - previousToken.lineStart;
        }
        if (options.ranges) this.range[1] = previousToken.range[1];
    };
    // Create a new `Marker` and add it to the FILO-array.
    function markLocation() {
        if (trackLocations) locations.push(createLocationMarker());
    }
    // Push an arbitrary `Marker` object onto the FILO-array.
    function pushLocation(marker) {
        if (trackLocations) locations.push(marker);
    }
    // Parse functions
    // ---------------
    // Chunk is the main program object. Syntactically it's the same as a block.
    //
    //     chunk ::= block
    function parseChunk() {
        next();
        markLocation();
        if (options.scope) createScope();
        var body = parseBlock();
        if (options.scope) destroyScope();
        if (EOF !== token.type) unexpected(token);
        // If the body is empty no previousToken exists when finishNode runs.
        if (trackLocations && !body.length) previousToken = token;
        return finishNode(ast.chunk(body));
    }
    // A block contains a list of statements with an optional return statement
    // as its last statement.
    //
    //     block ::= {stat} [retstat]
    function parseBlock(terminator) {
        var block = [], statement;
        while(!isBlockFollow(token)){
            // Return has to be the last statement in a block.
            if ("return" === token.value) {
                block.push(parseStatement());
                break;
            }
            statement = parseStatement();
            // Statements are only added if they are returned, this allows us to
            // ignore some statements, such as EmptyStatement.
            if (statement) block.push(statement);
        }
        // Doesn't really need an ast node
        return block;
    }
    // There are two types of statements, simple and compound.
    //
    //     statement ::= break | goto | do | while | repeat | return
    //          | if | for | function | local | label | assignment
    //          | functioncall | ';'
    function parseStatement() {
        markLocation();
        if (Keyword === token.type) switch(token.value){
            case "local":
                next();
                return parseLocalStatement();
            case "if":
                next();
                return parseIfStatement();
            case "return":
                next();
                return parseReturnStatement();
            case "function":
                next();
                var name = parseFunctionName();
                return parseFunctionDeclaration(name);
            case "while":
                next();
                return parseWhileStatement();
            case "for":
                next();
                return parseForStatement();
            case "repeat":
                next();
                return parseRepeatStatement();
            case "break":
                next();
                return parseBreakStatement();
            case "do":
                next();
                return parseDoStatement();
            case "goto":
                next();
                return parseGotoStatement();
        }
        if (Punctuator === token.type) {
            if (consume("::")) return parseLabelStatement();
        }
        // Assignments memorizes the location and pushes it manually for wrapper
        // nodes. Additionally empty `;` statements should not mark a location.
        if (trackLocations) locations.pop();
        // When a `;` is encounted, simply eat it without storing it.
        if (consume(";")) return;
        return parseAssignmentOrCallStatement();
    }
    // ## Statements
    //     label ::= '::' Name '::'
    function parseLabelStatement() {
        var name = token.value, label = parseIdentifier();
        if (options.scope) {
            scopeIdentifierName("::" + name + "::");
            attachScope(label, true);
        }
        expect("::");
        return finishNode(ast.labelStatement(label));
    }
    //     break ::= 'break'
    function parseBreakStatement() {
        return finishNode(ast.breakStatement());
    }
    //     goto ::= 'goto' Name
    function parseGotoStatement() {
        var name = token.value, label = parseIdentifier();
        return finishNode(ast.gotoStatement(label));
    }
    //     do ::= 'do' block 'end'
    function parseDoStatement() {
        if (options.scope) createScope();
        var body = parseBlock();
        if (options.scope) destroyScope();
        expect("end");
        return finishNode(ast.doStatement(body));
    }
    //     while ::= 'while' exp 'do' block 'end'
    function parseWhileStatement() {
        var condition = parseExpectedExpression();
        expect("do");
        if (options.scope) createScope();
        var body = parseBlock();
        if (options.scope) destroyScope();
        expect("end");
        return finishNode(ast.whileStatement(condition, body));
    }
    //     repeat ::= 'repeat' block 'until' exp
    function parseRepeatStatement() {
        if (options.scope) createScope();
        var body = parseBlock();
        expect("until");
        var condition = parseExpectedExpression();
        if (options.scope) destroyScope();
        return finishNode(ast.repeatStatement(condition, body));
    }
    //     retstat ::= 'return' [exp {',' exp}] [';']
    function parseReturnStatement() {
        var expressions = [];
        if ("end" !== token.value) {
            var expression = parseExpression();
            if (null != expression) expressions.push(expression);
            while(consume(",")){
                expression = parseExpectedExpression();
                expressions.push(expression);
            }
            consume(";"); // grammar tells us ; is optional here.
        }
        return finishNode(ast.returnStatement(expressions));
    }
    //     if ::= 'if' exp 'then' block {elif} ['else' block] 'end'
    //     elif ::= 'elseif' exp 'then' block
    function parseIfStatement() {
        var clauses = [], condition, body, marker;
        // IfClauses begin at the same location as the parent IfStatement.
        // It ends at the start of `end`, `else`, or `elseif`.
        if (trackLocations) {
            marker = locations[locations.length - 1];
            locations.push(marker);
        }
        condition = parseExpectedExpression();
        expect("then");
        if (options.scope) createScope();
        body = parseBlock();
        if (options.scope) destroyScope();
        clauses.push(finishNode(ast.ifClause(condition, body)));
        if (trackLocations) marker = createLocationMarker();
        while(consume("elseif")){
            pushLocation(marker);
            condition = parseExpectedExpression();
            expect("then");
            if (options.scope) createScope();
            body = parseBlock();
            if (options.scope) destroyScope();
            clauses.push(finishNode(ast.elseifClause(condition, body)));
            if (trackLocations) marker = createLocationMarker();
        }
        if (consume("else")) {
            // Include the `else` in the location of ElseClause.
            if (trackLocations) {
                marker = new Marker(previousToken);
                locations.push(marker);
            }
            if (options.scope) createScope();
            body = parseBlock();
            if (options.scope) destroyScope();
            clauses.push(finishNode(ast.elseClause(body)));
        }
        expect("end");
        return finishNode(ast.ifStatement(clauses));
    }
    // There are two types of for statements, generic and numeric.
    //
    //     for ::= Name '=' exp ',' exp [',' exp] 'do' block 'end'
    //     for ::= namelist 'in' explist 'do' block 'end'
    //     namelist ::= Name {',' Name}
    //     explist ::= exp {',' exp}
    function parseForStatement() {
        var variable = parseIdentifier(), body;
        // The start-identifier is local.
        if (options.scope) {
            createScope();
            scopeIdentifier(variable);
        }
        // If the first expression is followed by a `=` punctuator, this is a
        // Numeric For Statement.
        if (consume("=")) {
            // Start expression
            var start = parseExpectedExpression();
            expect(",");
            // End expression
            var end = parseExpectedExpression();
            // Optional step expression
            var step = consume(",") ? parseExpectedExpression() : null;
            expect("do");
            body = parseBlock();
            expect("end");
            if (options.scope) destroyScope();
            return finishNode(ast.forNumericStatement(variable, start, end, step, body));
        } else {
            // The namelist can contain one or more identifiers.
            var variables = [
                variable
            ];
            while(consume(",")){
                variable = parseIdentifier();
                // Each variable in the namelist is locally scoped.
                if (options.scope) scopeIdentifier(variable);
                variables.push(variable);
            }
            expect("in");
            var iterators = [];
            // One or more expressions in the explist.
            do {
                var expression = parseExpectedExpression();
                iterators.push(expression);
            }while (consume(","));
            expect("do");
            body = parseBlock();
            expect("end");
            if (options.scope) destroyScope();
            return finishNode(ast.forGenericStatement(variables, iterators, body));
        }
    }
    // Local statements can either be variable assignments or function
    // definitions. If a function definition is found, it will be delegated to
    // `parseFunctionDeclaration()` with the isLocal flag.
    //
    // This AST structure might change into a local assignment with a function
    // child.
    //
    //     local ::= 'local' 'function' Name funcdecl
    //        | 'local' Name {',' Name} ['=' exp {',' exp}]
    function parseLocalStatement() {
        var name;
        if (Identifier === token.type) {
            var variables = [], init = [];
            do {
                name = parseIdentifier();
                variables.push(name);
            }while (consume(","));
            if (consume("=")) do {
                var expression = parseExpectedExpression();
                init.push(expression);
            }while (consume(","));
            // Declarations doesn't exist before the statement has been evaluated.
            // Therefore assignments can't use their declarator. And the identifiers
            // shouldn't be added to the scope until the statement is complete.
            if (options.scope) for(var i = 0, l = variables.length; i < l; i++)scopeIdentifier(variables[i]);
            return finishNode(ast.localStatement(variables, init));
        }
        if (consume("function")) {
            name = parseIdentifier();
            if (options.scope) {
                scopeIdentifier(name);
                createScope();
            }
            // MemberExpressions are not allowed in local function statements.
            return parseFunctionDeclaration(name, true);
        } else raiseUnexpectedToken("<name>", token);
    }
    function validateVar(node) {
        // @TODO we need something not dependent on the exact AST used. see also isCallExpression()
        if (node.inParens || [
            "Identifier",
            "MemberExpression",
            "IndexExpression"
        ].indexOf(node.type) === -1) raise(token, errors.invalidVar, token.value);
    }
    //     assignment ::= varlist '=' explist
    //     var ::= Name | prefixexp '[' exp ']' | prefixexp '.' Name
    //     varlist ::= var {',' var}
    //     explist ::= exp {',' exp}
    //
    //     call ::= callexp
    //     callexp ::= prefixexp args | prefixexp ':' Name args
    function parseAssignmentOrCallStatement() {
        // Keep a reference to the previous token for better error messages in case
        // of invalid statement
        var previous = token, expression, marker;
        if (trackLocations) marker = createLocationMarker();
        expression = parsePrefixExpression();
        if (null == expression) return unexpected(token);
        if (",=".indexOf(token.value) >= 0) {
            var variables = [
                expression
            ], init = [], exp;
            validateVar(expression);
            while(consume(",")){
                exp = parsePrefixExpression();
                if (null == exp) raiseUnexpectedToken("<expression>", token);
                validateVar(exp);
                variables.push(exp);
            }
            expect("=");
            do {
                exp = parseExpectedExpression();
                init.push(exp);
            }while (consume(","));
            pushLocation(marker);
            return finishNode(ast.assignmentStatement(variables, init));
        }
        if (isCallExpression(expression)) {
            pushLocation(marker);
            return finishNode(ast.callStatement(expression));
        }
        // The prefix expression was neither part of an assignment or a
        // callstatement, however as it was valid it's been consumed, so raise
        // the exception on the previous token to provide a helpful message.
        return unexpected(previous);
    }
    // ### Non-statements
    //     Identifier ::= Name
    function parseIdentifier() {
        markLocation();
        var identifier = token.value;
        if (Identifier !== token.type) raiseUnexpectedToken("<name>", token);
        next();
        return finishNode(ast.identifier(identifier));
    }
    // Parse the functions parameters and body block. The name should already
    // have been parsed and passed to this declaration function. By separating
    // this we allow for anonymous functions in expressions.
    //
    // For local functions there's a boolean parameter which needs to be set
    // when parsing the declaration.
    //
    //     funcdecl ::= '(' [parlist] ')' block 'end'
    //     parlist ::= Name {',' Name} | [',' '...'] | '...'
    function parseFunctionDeclaration(name, isLocal) {
        var parameters = [];
        expect("(");
        // The declaration has arguments
        if (!consume(")")) // Arguments are a comma separated list of identifiers, optionally ending
        // with a vararg.
        while(true){
            if (Identifier === token.type) {
                var parameter = parseIdentifier();
                // Function parameters are local.
                if (options.scope) scopeIdentifier(parameter);
                parameters.push(parameter);
                if (consume(",")) continue;
                else if (consume(")")) break;
            } else if (VarargLiteral === token.type) {
                parameters.push(parsePrimaryExpression());
                expect(")");
                break;
            } else raiseUnexpectedToken("<name> or '...'", token);
        }
        var body = parseBlock();
        expect("end");
        if (options.scope) destroyScope();
        isLocal = isLocal || false;
        return finishNode(ast.functionStatement(name, parameters, isLocal, body));
    }
    // Parse the function name as identifiers and member expressions.
    //
    //     Name {'.' Name} [':' Name]
    function parseFunctionName() {
        var base, name, marker;
        if (trackLocations) marker = createLocationMarker();
        base = parseIdentifier();
        if (options.scope) {
            attachScope(base, scopeHasName(base.name));
            createScope();
        }
        while(consume(".")){
            pushLocation(marker);
            name = parseIdentifier();
            base = finishNode(ast.memberExpression(base, ".", name));
        }
        if (consume(":")) {
            pushLocation(marker);
            name = parseIdentifier();
            base = finishNode(ast.memberExpression(base, ":", name));
            if (options.scope) scopeIdentifierName("self");
        }
        return base;
    }
    //     tableconstructor ::= '{' [fieldlist] '}'
    //     fieldlist ::= field {fieldsep field} fieldsep
    //     field ::= '[' exp ']' '=' exp | Name = 'exp' | exp
    //
    //     fieldsep ::= ',' | ';'
    function parseTableConstructor() {
        var fields = [], key, value;
        while(true){
            markLocation();
            if (Punctuator === token.type && consume("[")) {
                key = parseExpectedExpression();
                expect("]");
                expect("=");
                value = parseExpectedExpression();
                fields.push(finishNode(ast.tableKey(key, value)));
            } else if (Identifier === token.type) {
                if ("=" === lookahead.value) {
                    key = parseIdentifier();
                    next();
                    value = parseExpectedExpression();
                    fields.push(finishNode(ast.tableKeyString(key, value)));
                } else {
                    value = parseExpectedExpression();
                    fields.push(finishNode(ast.tableValue(value)));
                }
            } else {
                if (null == (value = parseExpression())) {
                    locations.pop();
                    break;
                }
                fields.push(finishNode(ast.tableValue(value)));
            }
            if (",;".indexOf(token.value) >= 0) {
                next();
                continue;
            }
            break;
        }
        expect("}");
        return finishNode(ast.tableConstructorExpression(fields));
    }
    // Expression parser
    // -----------------
    //
    // Expressions are evaluated and always return a value. If nothing is
    // matched null will be returned.
    //
    //     exp ::= (unop exp | primary | prefixexp ) { binop exp }
    //
    //     primary ::= nil | false | true | Number | String | '...'
    //          | functiondef | tableconstructor
    //
    //     prefixexp ::= (Name | '(' exp ')' ) { '[' exp ']'
    //          | '.' Name | ':' Name args | args }
    //
    function parseExpression() {
        var expression = parseSubExpression(0);
        return expression;
    }
    // Parse an expression expecting it to be valid.
    function parseExpectedExpression() {
        var expression = parseExpression();
        if (null == expression) raiseUnexpectedToken("<expression>", token);
        else return expression;
    }
    // Return the precedence priority of the operator.
    //
    // As unary `-` can't be distinguished from binary `-`, unary precedence
    // isn't described in this table but in `parseSubExpression()` itself.
    //
    // As this function gets hit on every expression it's been optimized due to
    // the expensive CompareICStub which took ~8% of the parse time.
    function binaryPrecedence(operator) {
        var charCode = operator.charCodeAt(0), length = operator.length;
        if (1 === length) switch(charCode){
            case 94:
                return 12; // ^
            case 42:
            case 47:
            case 37:
                return 10; // * / %
            case 43:
            case 45:
                return 9; // + -
            case 38:
                return 6; // &
            case 126:
                return 5; // ~
            case 124:
                return 4; // |
            case 60:
            case 62:
                return 3; // < >
        }
        else if (2 === length) switch(charCode){
            case 47:
                return 10; // //
            case 46:
                return 8; // ..
            case 60:
            case 62:
                if ("<<" === operator || ">>" === operator) return 7; // << >>
                return 3; // <= >=
            case 61:
            case 126:
                return 3; // == ~=
            case 111:
                return 1; // or
        }
        else if (97 === charCode && "and" === operator) return 2;
        return 0;
    }
    // Implement an operator-precedence parser to handle binary operator
    // precedence.
    //
    // We use this algorithm because it's compact, it's fast and Lua core uses
    // the same so we can be sure our expressions are parsed in the same manner
    // without excessive amounts of tests.
    //
    //     exp ::= (unop exp | primary | prefixexp ) { binop exp }
    function parseSubExpression(minPrecedence) {
        var operator = token.value, expression, marker;
        if (trackLocations) marker = createLocationMarker();
        // UnaryExpression
        if (isUnary(token)) {
            markLocation();
            next();
            var argument = parseSubExpression(10);
            if (argument == null) raiseUnexpectedToken("<expression>", token);
            expression = finishNode(ast.unaryExpression(operator, argument));
        }
        if (null == expression) {
            // PrimaryExpression
            expression = parsePrimaryExpression();
            // PrefixExpression
            if (null == expression) expression = parsePrefixExpression();
        }
        // This is not a valid left hand expression.
        if (null == expression) return null;
        var precedence;
        while(true){
            operator = token.value;
            precedence = Punctuator === token.type || Keyword === token.type ? binaryPrecedence(operator) : 0;
            if (precedence === 0 || precedence <= minPrecedence) break;
            // Right-hand precedence operators
            if ("^" === operator || ".." === operator) precedence--;
            next();
            var right = parseSubExpression(precedence);
            if (null == right) raiseUnexpectedToken("<expression>", token);
            // Push in the marker created before the loop to wrap its entirety.
            if (trackLocations) locations.push(marker);
            expression = finishNode(ast.binaryExpression(operator, expression, right));
        }
        return expression;
    }
    //     prefixexp ::= prefix {suffix}
    //     prefix ::= Name | '(' exp ')'
    //     suffix ::= '[' exp ']' | '.' Name | ':' Name args | args
    //
    //     args ::= '(' [explist] ')' | tableconstructor | String
    function parsePrefixExpression() {
        var base, name, marker;
        if (trackLocations) marker = createLocationMarker();
        // The prefix
        if (Identifier === token.type) {
            name = token.value;
            base = parseIdentifier();
            // Set the parent scope.
            if (options.scope) attachScope(base, scopeHasName(name));
        } else if (consume("(")) {
            base = parseExpectedExpression();
            expect(")");
            base.inParens = true; // XXX: quick and dirty. needed for validateVar
        } else return null;
        // The suffix
        var expression, identifier;
        while(true){
            if (Punctuator === token.type) switch(token.value){
                case "[":
                    pushLocation(marker);
                    next();
                    expression = parseExpectedExpression();
                    base = finishNode(ast.indexExpression(base, expression));
                    expect("]");
                    break;
                case ".":
                    pushLocation(marker);
                    next();
                    identifier = parseIdentifier();
                    base = finishNode(ast.memberExpression(base, ".", identifier));
                    break;
                case ":":
                    pushLocation(marker);
                    next();
                    identifier = parseIdentifier();
                    base = finishNode(ast.memberExpression(base, ":", identifier));
                    // Once a : is found, this has to be a CallExpression, otherwise
                    // throw an error.
                    pushLocation(marker);
                    base = parseCallExpression(base);
                    break;
                case "(":
                case "{":
                    pushLocation(marker);
                    base = parseCallExpression(base);
                    break;
                default:
                    return base;
            }
            else if (StringLiteral === token.type) {
                pushLocation(marker);
                base = parseCallExpression(base);
            } else break;
        }
        return base;
    }
    //     args ::= '(' [explist] ')' | tableconstructor | String
    function parseCallExpression(base) {
        if (Punctuator === token.type) switch(token.value){
            case "(":
                next();
                // List of expressions
                var expressions = [];
                var expression = parseExpression();
                if (null != expression) expressions.push(expression);
                while(consume(",")){
                    expression = parseExpectedExpression();
                    expressions.push(expression);
                }
                expect(")");
                return finishNode(ast.callExpression(base, expressions));
            case "{":
                markLocation();
                next();
                var table = parseTableConstructor();
                return finishNode(ast.tableCallExpression(base, table));
        }
        else if (StringLiteral === token.type) return finishNode(ast.stringCallExpression(base, parsePrimaryExpression()));
        raiseUnexpectedToken("function arguments", token);
    }
    //     primary ::= String | Numeric | nil | true | false
    //          | functiondef | tableconstructor | '...'
    function parsePrimaryExpression() {
        var literals = StringLiteral | NumericLiteral | BooleanLiteral | NilLiteral | VarargLiteral, value = token.value, type = token.type, marker;
        if (trackLocations) marker = createLocationMarker();
        if (type & literals) {
            pushLocation(marker);
            var raw = input.slice(token.range[0], token.range[1]);
            next();
            return finishNode(ast.literal(type, value, raw));
        } else if (Keyword === type && "function" === value) {
            pushLocation(marker);
            next();
            if (options.scope) createScope();
            return parseFunctionDeclaration(null);
        } else if (consume("{")) {
            pushLocation(marker);
            return parseTableConstructor();
        }
    }
    // Parser
    // ------
    // Export the main parser.
    //
    //   - `wait` Hold parsing until end() is called. Defaults to false
    //   - `comments` Store comments. Defaults to true.
    //   - `scope` Track identifier scope. Defaults to false.
    //   - `locations` Store location information. Defaults to false.
    //   - `ranges` Store the start and end character locations. Defaults to
    //     false.
    //   - `onCreateNode` Callback which will be invoked when a syntax node is
    //     created.
    //   - `onCreateScope` Callback which will be invoked when a new scope is
    //     created.
    //   - `onDestroyScope` Callback which will be invoked when the current scope
    //     is destroyed.
    //
    // Example:
    //
    //     var parser = require('luaparser');
    //     parser.parse('i = 0');
    exports1.parse = parse;
    function parse(_input, _options) {
        if ("undefined" === typeof _options && "object" === typeof _input) {
            _options = _input;
            _input = undefined;
        }
        if (!_options) _options = {};
        input = _input || "";
        options = extend(defaultOptions, _options);
        // Rewind the lexer
        index = 0;
        line = 1;
        lineStart = 0;
        length = input.length;
        // When tracking identifier scope, initialize with an empty scope.
        scopes = [
            []
        ];
        scopeDepth = 0;
        globals = [];
        locations = [];
        if (options.comments) comments = [];
        if (!options.wait) return end();
        return exports1;
    }
    // Write to the source code buffer without beginning the parse.
    exports1.write = write;
    function write(_input) {
        input += String(_input);
        length = input.length;
        return exports1;
    }
    // Send an EOF and begin parsing.
    exports1.end = end;
    function end(_input) {
        if ("undefined" !== typeof _input) write(_input);
        // Ignore shebangs.
        if (input && input.substr(0, 2) === "#!") input = input.replace(/^.*/, function(line) {
            return line.replace(/./g, " ");
        });
        length = input.length;
        trackLocations = options.locations || options.ranges;
        // Initialize with a lookahead token.
        lookahead = lex();
        var chunk = parseChunk();
        if (options.comments) chunk.comments = comments;
        if (options.scope) chunk.globals = globals;
        if (locations.length > 0) throw new Error("Location tracking failed. This is most likely a bug in luaparse");
        return chunk;
    }
}); /* vim: set sw=2 ts=2 et tw=79 : */ 

});

parcelRegister("851aL", function(module, exports) {
"use strict";

var $ggeMD = parcelRequire("ggeMD");

var $eBqgu = parcelRequire("eBqgu");

var $9DhCp = parcelRequire("9DhCp");

var $e4VL4 = parcelRequire("e4VL4");

var $798BN = parcelRequire("798BN");

var $xDetb = parcelRequire("xDetb");

var $58CZu = parcelRequire("58CZu");

var $NpFJI = parcelRequire("NpFJI");

var $dppe4 = parcelRequire("dppe4");

var $axbLj = parcelRequire("axbLj");
/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */ var $5e1fb3351029758a$var$fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = $eBqgu.getTypeOf(data), parent;
    /*
     * Correct options.
     */ var o = $eBqgu.extend(originalOptions || {}, $798BN);
    o.date = o.date || new Date();
    if (o.compression !== null) o.compression = o.compression.toUpperCase();
    if (typeof o.unixPermissions === "string") o.unixPermissions = parseInt(o.unixPermissions, 8);
    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && o.unixPermissions & 0x4000) o.dir = true;
    // Bit 4    Directory
    if (o.dosPermissions && o.dosPermissions & 0x0010) o.dir = true;
    if (o.dir) name = $5e1fb3351029758a$var$forceTrailingSlash(name);
    if (o.createFolders && (parent = $5e1fb3351029758a$var$parentFolder(name))) $5e1fb3351029758a$var$folderAdd.call(this, parent, true);
    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") o.binary = !isUnicodeString;
    var isCompressedEmpty = data instanceof $xDetb && data.uncompressedSize === 0;
    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }
    /*
     * Convert content to fit.
     */ var zipObjectContent = null;
    if (data instanceof $xDetb || data instanceof $9DhCp) zipObjectContent = data;
    else if ($dppe4.isNode && $dppe4.isStream(data)) zipObjectContent = new $axbLj(name, data);
    else zipObjectContent = $eBqgu.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    var object = new $58CZu(name, zipObjectContent, o);
    this.files[name] = object;
/*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */ };
/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */ var $5e1fb3351029758a$var$parentFolder = function(path) {
    if (path.slice(-1) === "/") path = path.substring(0, path.length - 1);
    var lastSlash = path.lastIndexOf("/");
    return lastSlash > 0 ? path.substring(0, lastSlash) : "";
};
/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */ var $5e1fb3351029758a$var$forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") path += "/"; // IE doesn't like substr(-1)
    return path;
};
/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */ var $5e1fb3351029758a$var$folderAdd = function(name, createFolders) {
    createFolders = typeof createFolders !== "undefined" ? createFolders : $798BN.createFolders;
    name = $5e1fb3351029758a$var$forceTrailingSlash(name);
    // Does this folder already exist?
    if (!this.files[name]) $5e1fb3351029758a$var$fileAdd.call(this, name, null, {
        dir: true,
        createFolders: createFolders
    });
    return this.files[name];
};
/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/ function $5e1fb3351029758a$var$isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}
// return the actual prototype of JSZip
var $5e1fb3351029758a$var$out = {
    /**
     * @see loadAsync
     */ load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },
    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */ forEach: function(cb) {
        var filename, relativePath, file;
        for(filename in this.files){
            if (!this.files.hasOwnProperty(filename)) continue;
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
        }
    },
    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */ filter: function(search) {
        var result = [];
        this.forEach(function(relativePath, entry) {
            if (search(relativePath, entry)) result.push(entry);
        });
        return result;
    },
    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */ file: function(name, data, o) {
        if (arguments.length === 1) {
            if ($5e1fb3351029758a$var$isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            } else {
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) return obj;
                else return null;
            }
        } else {
            name = this.root + name;
            $5e1fb3351029758a$var$fileAdd.call(this, name, data, o);
        }
        return this;
    },
    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */ folder: function(arg) {
        if (!arg) return this;
        if ($5e1fb3351029758a$var$isRegExp(arg)) return this.filter(function(relativePath, file) {
            return file.dir && arg.test(relativePath);
        });
        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = $5e1fb3351029758a$var$folderAdd.call(this, name);
        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },
    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */ remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") name += "/";
            file = this.files[name];
        }
        if (file && !file.dir) // file
        delete this.files[name];
        else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for(var i = 0; i < kids.length; i++)delete this.files[kids[i].name];
        }
        return this;
    },
    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */ generate: function(options) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },
    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */ generateInternalStream: function(options) {
        var worker, opts = {};
        try {
            opts = $eBqgu.extend(options || {}, {
                streamFiles: false,
                compression: "STORE",
                compressionOptions: null,
                type: "",
                platform: "DOS",
                comment: null,
                mimeType: "application/zip",
                encodeFileName: $ggeMD.utf8encode
            });
            opts.type = opts.type.toLowerCase();
            opts.compression = opts.compression.toUpperCase();
            // "binarystring" is preferred but the internals use "string".
            if (opts.type === "binarystring") opts.type = "string";
            if (!opts.type) throw new Error("No output type specified.");
            $eBqgu.checkSupport(opts.type);
            // accept nodejs `process.platform`
            if (opts.platform === "darwin" || opts.platform === "freebsd" || opts.platform === "linux" || opts.platform === "sunos") opts.platform = "UNIX";
            if (opts.platform === "win32") opts.platform = "DOS";
            var comment = opts.comment || this.comment || "";
            worker = $NpFJI.generateWorker(this, opts, comment);
        } catch (e) {
            worker = new $9DhCp("error");
            worker.error(e);
        }
        return new $e4VL4(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */ generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */ generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) options.type = "nodebuffer";
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = $5e1fb3351029758a$var$out;

});
parcelRegister("ggeMD", function(module, exports) {

$parcel$export(module.exports, "utf8encode", () => $bd699ba0995ce68e$export$787db22dc5223ad6, (v) => $bd699ba0995ce68e$export$787db22dc5223ad6 = v);
$parcel$export(module.exports, "utf8decode", () => $bd699ba0995ce68e$export$29df50c4c5899cac, (v) => $bd699ba0995ce68e$export$29df50c4c5899cac = v);
$parcel$export(module.exports, "Utf8DecodeWorker", () => $bd699ba0995ce68e$export$ff9b2776e27323a, (v) => $bd699ba0995ce68e$export$ff9b2776e27323a = v);
$parcel$export(module.exports, "Utf8EncodeWorker", () => $bd699ba0995ce68e$export$d4f67a366d776476, (v) => $bd699ba0995ce68e$export$d4f67a366d776476 = v);
// That's all for the pako functions.
/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */ var $bd699ba0995ce68e$export$787db22dc5223ad6;
/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */ var $bd699ba0995ce68e$export$29df50c4c5899cac;
var $bd699ba0995ce68e$export$ff9b2776e27323a;
var $bd699ba0995ce68e$export$d4f67a366d776476;
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $4Fiik = parcelRequire("4Fiik");

var $dppe4 = parcelRequire("dppe4");

var $9DhCp = parcelRequire("9DhCp");
/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */ // Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $bd699ba0995ce68e$var$_utf8len = new Array(256);
for(var $bd699ba0995ce68e$var$i = 0; $bd699ba0995ce68e$var$i < 256; $bd699ba0995ce68e$var$i++)$bd699ba0995ce68e$var$_utf8len[$bd699ba0995ce68e$var$i] = $bd699ba0995ce68e$var$i >= 252 ? 6 : $bd699ba0995ce68e$var$i >= 248 ? 5 : $bd699ba0995ce68e$var$i >= 240 ? 4 : $bd699ba0995ce68e$var$i >= 224 ? 3 : $bd699ba0995ce68e$var$i >= 192 ? 2 : 1;
$bd699ba0995ce68e$var$_utf8len[254] = $bd699ba0995ce68e$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $bd699ba0995ce68e$var$string2buf = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    if ($4Fiik.uint8array) buf = new Uint8Array(buf_len);
    else buf = new Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $bd699ba0995ce68e$var$utf8border = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $bd699ba0995ce68e$var$_utf8len[buf[pos]] > max ? pos : max;
};
// convert array to string
var $bd699ba0995ce68e$var$buf2string = function(buf) {
    var str, i, out, c, c_len;
    var len = buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $bd699ba0995ce68e$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if (utf16buf.subarray) utf16buf = utf16buf.subarray(0, out);
        else utf16buf.length = out;
    }
    // return String.fromCharCode.apply(null, utf16buf);
    return $eBqgu.applyFromCharCode(utf16buf);
};
$bd699ba0995ce68e$export$787db22dc5223ad6 = function utf8encode(str) {
    if ($4Fiik.nodebuffer) return $dppe4.newBufferFrom(str, "utf-8");
    return $bd699ba0995ce68e$var$string2buf(str);
};
$bd699ba0995ce68e$export$29df50c4c5899cac = function utf8decode(buf) {
    if ($4Fiik.nodebuffer) return $eBqgu.transformTo("nodebuffer", buf).toString("utf-8");
    buf = $eBqgu.transformTo($4Fiik.uint8array ? "uint8array" : "array", buf);
    return $bd699ba0995ce68e$var$buf2string(buf);
};
/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */ function $bd699ba0995ce68e$var$Utf8DecodeWorker() {
    $9DhCp.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
$eBqgu.inherits($bd699ba0995ce68e$var$Utf8DecodeWorker, $9DhCp);
/**
 * @see GenericWorker.processChunk
 */ $bd699ba0995ce68e$var$Utf8DecodeWorker.prototype.processChunk = function(chunk) {
    var data = $eBqgu.transformTo($4Fiik.uint8array ? "uint8array" : "array", chunk.data);
    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if ($4Fiik.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else data = this.leftOver.concat(data);
        this.leftOver = null;
    }
    var nextBoundary = $bd699ba0995ce68e$var$utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if ($4Fiik.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }
    this.push({
        data: $bd699ba0995ce68e$export$29df50c4c5899cac(usableData),
        meta: chunk.meta
    });
};
/**
 * @see GenericWorker.flush
 */ $bd699ba0995ce68e$var$Utf8DecodeWorker.prototype.flush = function() {
    if (this.leftOver && this.leftOver.length) {
        this.push({
            data: $bd699ba0995ce68e$export$29df50c4c5899cac(this.leftOver),
            meta: {}
        });
        this.leftOver = null;
    }
};
$bd699ba0995ce68e$export$ff9b2776e27323a = $bd699ba0995ce68e$var$Utf8DecodeWorker;
/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */ function $bd699ba0995ce68e$var$Utf8EncodeWorker() {
    $9DhCp.call(this, "utf-8 encode");
}
$eBqgu.inherits($bd699ba0995ce68e$var$Utf8EncodeWorker, $9DhCp);
/**
 * @see GenericWorker.processChunk
 */ $bd699ba0995ce68e$var$Utf8EncodeWorker.prototype.processChunk = function(chunk) {
    this.push({
        data: $bd699ba0995ce68e$export$787db22dc5223ad6(chunk.data),
        meta: chunk.meta
    });
};
$bd699ba0995ce68e$export$d4f67a366d776476 = $bd699ba0995ce68e$var$Utf8EncodeWorker;

});
parcelRegister("eBqgu", function(module, exports) {

$parcel$export(module.exports, "newBlob", () => $aa18e516605be66a$export$f09ece72e2dd0b80, (v) => $aa18e516605be66a$export$f09ece72e2dd0b80 = v);
$parcel$export(module.exports, "checkSupport", () => $aa18e516605be66a$export$c66fe382d9c9ddda, (v) => $aa18e516605be66a$export$c66fe382d9c9ddda = v);
$parcel$export(module.exports, "getTypeOf", () => $aa18e516605be66a$export$14aa4bfa82eac6ec, (v) => $aa18e516605be66a$export$14aa4bfa82eac6ec = v);
$parcel$export(module.exports, "applyFromCharCode", () => $aa18e516605be66a$export$f68099e5efde4c98, (v) => $aa18e516605be66a$export$f68099e5efde4c98 = v);
$parcel$export(module.exports, "transformTo", () => $aa18e516605be66a$export$856d3c5070792a40, (v) => $aa18e516605be66a$export$856d3c5070792a40 = v);
$parcel$export(module.exports, "MAX_VALUE_16BITS", () => $aa18e516605be66a$export$e761db811c56b235, (v) => $aa18e516605be66a$export$e761db811c56b235 = v);
$parcel$export(module.exports, "MAX_VALUE_32BITS", () => $aa18e516605be66a$export$5a735ff9684262bd, (v) => $aa18e516605be66a$export$5a735ff9684262bd = v);
$parcel$export(module.exports, "pretty", () => $aa18e516605be66a$export$ba80a1d24ee8c98f, (v) => $aa18e516605be66a$export$ba80a1d24ee8c98f = v);
$parcel$export(module.exports, "delay", () => $aa18e516605be66a$export$1391212d75b2ee65, (v) => $aa18e516605be66a$export$1391212d75b2ee65 = v);
$parcel$export(module.exports, "inherits", () => $aa18e516605be66a$export$69f1b2dcda23c5f8, (v) => $aa18e516605be66a$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "extend", () => $aa18e516605be66a$export$8b58be045bf06082, (v) => $aa18e516605be66a$export$8b58be045bf06082 = v);
$parcel$export(module.exports, "prepareContent", () => $aa18e516605be66a$export$36595ab25e995ab3, (v) => $aa18e516605be66a$export$36595ab25e995ab3 = v);
/**
 * Create a new blob with the given content and the given type.
 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 *
 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
 * when a large amount of Array is used to create the Blob, the amount of
 * memory consumed is nearly 100 times the original data amount.
 *
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */ var $aa18e516605be66a$export$f09ece72e2dd0b80;
var $aa18e516605be66a$export$f68099e5efde4c98;
/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */ var $aa18e516605be66a$export$856d3c5070792a40;
/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */ var $aa18e516605be66a$export$14aa4bfa82eac6ec;
/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */ var $aa18e516605be66a$export$c66fe382d9c9ddda;
var $aa18e516605be66a$export$e761db811c56b235;
var $aa18e516605be66a$export$5a735ff9684262bd;
/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */ var $aa18e516605be66a$export$ba80a1d24ee8c98f;
/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */ var $aa18e516605be66a$export$1391212d75b2ee65;
/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */ var $aa18e516605be66a$export$69f1b2dcda23c5f8;
/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */ var $aa18e516605be66a$export$8b58be045bf06082;
/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */ var $aa18e516605be66a$export$36595ab25e995ab3;
"use strict";

var $4Fiik = parcelRequire("4Fiik");

var $lAvwW = parcelRequire("lAvwW");

var $dppe4 = parcelRequire("dppe4");

var $1NT4l = parcelRequire("1NT4l");

var $gEpFr = parcelRequire("gEpFr");
/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */ function $aa18e516605be66a$var$string2binary(str) {
    var result = null;
    if ($4Fiik.uint8array) result = new Uint8Array(str.length);
    else result = new Array(str.length);
    return $aa18e516605be66a$var$stringToArrayLike(str, result);
}
$aa18e516605be66a$export$f09ece72e2dd0b80 = function(part, type) {
    $aa18e516605be66a$export$c66fe382d9c9ddda("blob");
    try {
        // Blob constructor
        return new Blob([
            part
        ], {
            type: type
        });
    } catch (e) {
        try {
            // deprecated, browser only, old way
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(part);
            return builder.getBlob(type);
        } catch (e) {
            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }
};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */ function $aa18e516605be66a$var$identity(input) {
    return input;
}
/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */ function $aa18e516605be66a$var$stringToArrayLike(str, array) {
    for(var i = 0; i < str.length; ++i)array[i] = str.charCodeAt(i) & 0xFF;
    return array;
}
/**
 * An helper for the function arrayLikeToString.
 * This contains static information and functions that
 * can be optimized by the browser JIT compiler.
 */ var $aa18e516605be66a$var$arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */ stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) return String.fromCharCode.apply(null, array);
        while(k < len){
            if (type === "array" || type === "nodebuffer") result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            else result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */ stringifyByChar: function(array) {
        var resultStr = "";
        for(var i = 0; i < array.length; i++)resultStr += String.fromCharCode(array[i]);
        return resultStr;
    },
    applyCanBeUsed: {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */ uint8array: function() {
            try {
                return $4Fiik.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        }(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */ nodebuffer: function() {
            try {
                return $4Fiik.nodebuffer && String.fromCharCode.apply(null, $dppe4.allocBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        }()
    }
};
/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */ function $aa18e516605be66a$var$arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536, type = $aa18e516605be66a$export$14aa4bfa82eac6ec(array), canUseApply = true;
    if (type === "uint8array") canUseApply = $aa18e516605be66a$var$arrayToStringHelper.applyCanBeUsed.uint8array;
    else if (type === "nodebuffer") canUseApply = $aa18e516605be66a$var$arrayToStringHelper.applyCanBeUsed.nodebuffer;
    if (canUseApply) {
        while(chunk > 1)try {
            return $aa18e516605be66a$var$arrayToStringHelper.stringifyByChunk(array, type, chunk);
        } catch (e) {
            chunk = Math.floor(chunk / 2);
        }
    }
    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return $aa18e516605be66a$var$arrayToStringHelper.stringifyByChar(array);
}
$aa18e516605be66a$export$f68099e5efde4c98 = $aa18e516605be66a$var$arrayLikeToString;
/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */ function $aa18e516605be66a$var$arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for(var i = 0; i < arrayFrom.length; i++)arrayTo[i] = arrayFrom[i];
    return arrayTo;
}
// a matrix containing functions to transform everything into everything.
var $aa18e516605be66a$var$transform = {};
// string to ?
$aa18e516605be66a$var$transform["string"] = {
    "string": $aa18e516605be66a$var$identity,
    "array": function(input) {
        return $aa18e516605be66a$var$stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return $aa18e516605be66a$var$transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return $aa18e516605be66a$var$stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return $aa18e516605be66a$var$stringToArrayLike(input, $dppe4.allocBuffer(input.length));
    }
};
// array to ?
$aa18e516605be66a$var$transform["array"] = {
    "string": $aa18e516605be66a$var$arrayLikeToString,
    "array": $aa18e516605be66a$var$identity,
    "arraybuffer": function(input) {
        return new Uint8Array(input).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return $dppe4.newBufferFrom(input);
    }
};
// arraybuffer to ?
$aa18e516605be66a$var$transform["arraybuffer"] = {
    "string": function(input) {
        return $aa18e516605be66a$var$arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return $aa18e516605be66a$var$arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": $aa18e516605be66a$var$identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return $dppe4.newBufferFrom(new Uint8Array(input));
    }
};
// uint8array to ?
$aa18e516605be66a$var$transform["uint8array"] = {
    "string": $aa18e516605be66a$var$arrayLikeToString,
    "array": function(input) {
        return $aa18e516605be66a$var$arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": $aa18e516605be66a$var$identity,
    "nodebuffer": function(input) {
        return $dppe4.newBufferFrom(input);
    }
};
// nodebuffer to ?
$aa18e516605be66a$var$transform["nodebuffer"] = {
    "string": $aa18e516605be66a$var$arrayLikeToString,
    "array": function(input) {
        return $aa18e516605be66a$var$arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return $aa18e516605be66a$var$transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return $aa18e516605be66a$var$arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": $aa18e516605be66a$var$identity
};
$aa18e516605be66a$export$856d3c5070792a40 = function(outputType, input) {
    if (!input) // undefined, null, etc
    // an empty string won't harm.
    input = "";
    if (!outputType) return input;
    $aa18e516605be66a$export$c66fe382d9c9ddda(outputType);
    var inputType = $aa18e516605be66a$export$14aa4bfa82eac6ec(input);
    var result = $aa18e516605be66a$var$transform[inputType][outputType](input);
    return result;
};
$aa18e516605be66a$export$14aa4bfa82eac6ec = function(input) {
    if (typeof input === "string") return "string";
    if (Object.prototype.toString.call(input) === "[object Array]") return "array";
    if ($4Fiik.nodebuffer && $dppe4.isBuffer(input)) return "nodebuffer";
    if ($4Fiik.uint8array && input instanceof Uint8Array) return "uint8array";
    if ($4Fiik.arraybuffer && input instanceof ArrayBuffer) return "arraybuffer";
};
$aa18e516605be66a$export$c66fe382d9c9ddda = function(type) {
    var supported = $4Fiik[type.toLowerCase()];
    if (!supported) throw new Error(type + " is not supported by this platform");
};
$aa18e516605be66a$export$e761db811c56b235 = 65535;
$aa18e516605be66a$export$5a735ff9684262bd = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
$aa18e516605be66a$export$ba80a1d24ee8c98f = function(str) {
    var res = "", code, i;
    for(i = 0; i < (str || "").length; i++){
        code = str.charCodeAt(i);
        res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};
$aa18e516605be66a$export$1391212d75b2ee65 = function(callback, args, self1) {
    $1NT4l(function() {
        callback.apply(self1 || null, args || []);
    });
};
$aa18e516605be66a$export$69f1b2dcda23c5f8 = function(ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};
$aa18e516605be66a$export$8b58be045bf06082 = function() {
    var result = {}, i, attr;
    for(i = 0; i < arguments.length; i++){
        for(attr in arguments[i])if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") result[attr] = arguments[i][attr];
    }
    return result;
};
$aa18e516605be66a$export$36595ab25e995ab3 = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {
    // if inputData is already a promise, this flatten it.
    var promise = $gEpFr.Promise.resolve(inputData).then(function(data) {
        var isBlob = $4Fiik.blob && (data instanceof Blob || [
            "[object File]",
            "[object Blob]"
        ].indexOf(Object.prototype.toString.call(data)) !== -1);
        if (isBlob && typeof FileReader !== "undefined") return new $gEpFr.Promise(function(resolve, reject) {
            var reader = new FileReader();
            reader.onload = function(e) {
                resolve(e.target.result);
            };
            reader.onerror = function(e) {
                reject(e.target.error);
            };
            reader.readAsArrayBuffer(data);
        });
        else return data;
    });
    return promise.then(function(data) {
        var dataType = $aa18e516605be66a$export$14aa4bfa82eac6ec(data);
        if (!dataType) return $gEpFr.Promise.reject(new Error("Can't read the data of '" + name + "'. Is it " + "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") data = $aa18e516605be66a$export$856d3c5070792a40("uint8array", data);
        else if (dataType === "string") {
            if (isBase64) data = $lAvwW.decode(data);
            else if (isBinary) // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
            {
                if (isOptimizedBinaryString !== true) // this is a string, not in a base64 format.
                // Be sure that this is a correct "binary string"
                data = $aa18e516605be66a$var$string2binary(data);
            }
        }
        return data;
    });
};

});
parcelRegister("4Fiik", function(module, exports) {

$parcel$export(module.exports, "base64", () => $36592ead2123962a$export$b3b2de96497acc47, (v) => $36592ead2123962a$export$b3b2de96497acc47 = v);
$parcel$export(module.exports, "array", () => $36592ead2123962a$export$2f23118c22fb2630, (v) => $36592ead2123962a$export$2f23118c22fb2630 = v);
$parcel$export(module.exports, "string", () => $36592ead2123962a$export$22b082955e083ec3, (v) => $36592ead2123962a$export$22b082955e083ec3 = v);
$parcel$export(module.exports, "arraybuffer", () => $36592ead2123962a$export$724c4efdc2b90612, (v) => $36592ead2123962a$export$724c4efdc2b90612 = v);
$parcel$export(module.exports, "nodebuffer", () => $36592ead2123962a$export$9a94744e1512da20, (v) => $36592ead2123962a$export$9a94744e1512da20 = v);
$parcel$export(module.exports, "uint8array", () => $36592ead2123962a$export$9b1ae16315fd2871, (v) => $36592ead2123962a$export$9b1ae16315fd2871 = v);
$parcel$export(module.exports, "blob", () => $36592ead2123962a$export$8cf3c1c9f525ba2, (v) => $36592ead2123962a$export$8cf3c1c9f525ba2 = v);
$parcel$export(module.exports, "nodestream", () => $36592ead2123962a$export$c29aa3d9c5137fd2, (v) => $36592ead2123962a$export$c29aa3d9c5137fd2 = v);
var $36592ead2123962a$export$b3b2de96497acc47;
var $36592ead2123962a$export$2f23118c22fb2630;
var $36592ead2123962a$export$22b082955e083ec3;
var $36592ead2123962a$export$724c4efdc2b90612;
var $36592ead2123962a$export$9a94744e1512da20;
// contains true if JSZip can read/generate Uint8Array, false otherwise.
var $36592ead2123962a$export$9b1ae16315fd2871;
var $36592ead2123962a$export$8cf3c1c9f525ba2;
var $36592ead2123962a$export$c29aa3d9c5137fd2;

var $6ZWSX = parcelRequire("6ZWSX");
var $36592ead2123962a$require$Buffer = $6ZWSX.Buffer;
"use strict";
$36592ead2123962a$export$b3b2de96497acc47 = true;
$36592ead2123962a$export$2f23118c22fb2630 = true;
$36592ead2123962a$export$22b082955e083ec3 = true;
$36592ead2123962a$export$724c4efdc2b90612 = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
$36592ead2123962a$export$9a94744e1512da20 = typeof $36592ead2123962a$require$Buffer !== "undefined";
$36592ead2123962a$export$9b1ae16315fd2871 = typeof Uint8Array !== "undefined";
if (typeof ArrayBuffer === "undefined") $36592ead2123962a$export$8cf3c1c9f525ba2 = false;
else {
    var $36592ead2123962a$var$buffer = new ArrayBuffer(0);
    try {
        $36592ead2123962a$export$8cf3c1c9f525ba2 = new Blob([
            $36592ead2123962a$var$buffer
        ], {
            type: "application/zip"
        }).size === 0;
    } catch (e) {
        try {
            var $36592ead2123962a$var$Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var $36592ead2123962a$var$builder = new $36592ead2123962a$var$Builder();
            $36592ead2123962a$var$builder.append($36592ead2123962a$var$buffer);
            $36592ead2123962a$export$8cf3c1c9f525ba2 = $36592ead2123962a$var$builder.getBlob("application/zip").size === 0;
        } catch (e) {
            $36592ead2123962a$export$8cf3c1c9f525ba2 = false;
        }
    }
}

try {
    $36592ead2123962a$export$c29aa3d9c5137fd2 = !!(parcelRequire("7R0Jl")).Readable;
} catch (e) {
    $36592ead2123962a$export$c29aa3d9c5137fd2 = false;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("7R0Jl", function(module, exports) {
/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */ 
module.exports = (parcelRequire("ioRHp"));

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount("data") > 0) self.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $87d792cd1b95f90e$var$ownKeys(Object(source), true).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict"; // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
"use strict";

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});




parcelRegister("lAvwW", function(module, exports) {

$parcel$export(module.exports, "encode", () => $fb756b0b200979da$export$c564cdbbe6da493, (v) => $fb756b0b200979da$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $fb756b0b200979da$export$2f872c0f2117be69, (v) => $fb756b0b200979da$export$2f872c0f2117be69 = v);
// public method for encoding
var $fb756b0b200979da$export$c564cdbbe6da493;
// public method for decoding
var $fb756b0b200979da$export$2f872c0f2117be69;
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $4Fiik = parcelRequire("4Fiik");
// private property
var $fb756b0b200979da$var$_keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
$fb756b0b200979da$export$c564cdbbe6da493 = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;
    var isArray = $eBqgu.getTypeOf(input) !== "string";
    while(i < input.length){
        remainingBytes = len - i;
        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = remainingBytes > 1 ? (chr2 & 15) << 2 | chr3 >> 6 : 64;
        enc4 = remainingBytes > 2 ? chr3 & 63 : 64;
        output.push($fb756b0b200979da$var$_keyStr.charAt(enc1) + $fb756b0b200979da$var$_keyStr.charAt(enc2) + $fb756b0b200979da$var$_keyStr.charAt(enc3) + $fb756b0b200979da$var$_keyStr.charAt(enc4));
    }
    return output.join("");
};
$fb756b0b200979da$export$2f872c0f2117be69 = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;
    var dataUrlPrefix = "data:";
    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) // This is a common error: people give a data url
    // (data:image/png;base64,iVBOR...) with a {base64: true} and
    // wonders why things don't work.
    // We can detect that the string input looks like a data url but we
    // *can't* be sure it is one: removing everything up to the comma would
    // be too dangerous.
    throw new Error("Invalid base64 input, it looks like a data url.");
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    var totalLength = input.length * 3 / 4;
    if (input.charAt(input.length - 1) === $fb756b0b200979da$var$_keyStr.charAt(64)) totalLength--;
    if (input.charAt(input.length - 2) === $fb756b0b200979da$var$_keyStr.charAt(64)) totalLength--;
    if (totalLength % 1 !== 0) // totalLength is not an integer, the length does not match a valid
    // base64 content. That can happen if:
    // - the input is not a base64 content
    // - the input is *almost* a base64 content, with a extra chars at the
    //   beginning or at the end
    // - the input uses a base64 variant (base64url for example)
    throw new Error("Invalid base64 input, bad content length.");
    var output;
    if ($4Fiik.uint8array) output = new Uint8Array(totalLength | 0);
    else output = new Array(totalLength | 0);
    while(i < input.length){
        enc1 = $fb756b0b200979da$var$_keyStr.indexOf(input.charAt(i++));
        enc2 = $fb756b0b200979da$var$_keyStr.indexOf(input.charAt(i++));
        enc3 = $fb756b0b200979da$var$_keyStr.indexOf(input.charAt(i++));
        enc4 = $fb756b0b200979da$var$_keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output[resultIndex++] = chr1;
        if (enc3 !== 64) output[resultIndex++] = chr2;
        if (enc4 !== 64) output[resultIndex++] = chr3;
    }
    return output;
};

});

parcelRegister("dppe4", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $9c312d8746921f5b$require$Buffer = $6ZWSX.Buffer;
"use strict";
module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */ isNode: typeof $9c312d8746921f5b$require$Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer from an existing content.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */ newBufferFrom: function(data, encoding) {
        if ($9c312d8746921f5b$require$Buffer.from && $9c312d8746921f5b$require$Buffer.from !== Uint8Array.from) return $9c312d8746921f5b$require$Buffer.from(data, encoding);
        else {
            if (typeof data === "number") // Safeguard for old Node.js versions. On newer versions,
            // Buffer.from(number) / Buffer(number, encoding) already throw.
            throw new Error('The "data" argument must not be a number');
            return new $9c312d8746921f5b$require$Buffer(data, encoding);
        }
    },
    /**
     * Create a new nodejs Buffer with the specified size.
     * @param {Integer} size the size of the buffer.
     * @return {Buffer} a new Buffer.
     */ allocBuffer: function(size) {
        if ($9c312d8746921f5b$require$Buffer.alloc) return $9c312d8746921f5b$require$Buffer.alloc(size);
        else {
            var buf = new $9c312d8746921f5b$require$Buffer(size);
            buf.fill(0);
            return buf;
        }
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */ isBuffer: function(b) {
        return $9c312d8746921f5b$require$Buffer.isBuffer(b);
    },
    isStream: function(obj) {
        return obj && typeof obj.on === "function" && typeof obj.pause === "function" && typeof obj.resume === "function";
    }
};

});

parcelRegister("1NT4l", function(module, exports) {
"use strict";
module.exports = typeof setImmediate === "function" ? setImmediate : function setImmediate1() {
    var args = [].slice.apply(arguments);
    args.splice(1, 0, 0);
    setTimeout.apply(null, args);
};

});

parcelRegister("gEpFr", function(module, exports) {
/* global Promise */ "use strict";
// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var $c1f44acdb6633ece$var$ES6Promise = null;

if (typeof Promise !== "undefined") $c1f44acdb6633ece$var$ES6Promise = Promise;
else $c1f44acdb6633ece$var$ES6Promise = (parcelRequire("bCGV3"));
/**
 * Let the user use/change some implementations.
 */ module.exports = {
    Promise: $c1f44acdb6633ece$var$ES6Promise
};

});
parcelRegister("bCGV3", function(module, exports) {
"use strict";

var $dxxqI = parcelRequire("dxxqI");
/* istanbul ignore next */ function $8764892a7f25c57c$var$INTERNAL() {}
var $8764892a7f25c57c$var$handlers = {};
var $8764892a7f25c57c$var$REJECTED = [
    "REJECTED"
];
var $8764892a7f25c57c$var$FULFILLED = [
    "FULFILLED"
];
var $8764892a7f25c57c$var$PENDING = [
    "PENDING"
];
module.exports = $8764892a7f25c57c$var$Promise;
function $8764892a7f25c57c$var$Promise(resolver) {
    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
    this.state = $8764892a7f25c57c$var$PENDING;
    this.queue = [];
    this.outcome = void 0;
    if (resolver !== $8764892a7f25c57c$var$INTERNAL) $8764892a7f25c57c$var$safelyResolveThenable(this, resolver);
}
$8764892a7f25c57c$var$Promise.prototype["finally"] = function(callback) {
    if (typeof callback !== "function") return this;
    var p = this.constructor;
    return this.then(resolve, reject);
    function resolve(value) {
        function yes() {
            return value;
        }
        return p.resolve(callback()).then(yes);
    }
    function reject(reason) {
        function no() {
            throw reason;
        }
        return p.resolve(callback()).then(no);
    }
};
$8764892a7f25c57c$var$Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
$8764892a7f25c57c$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    if (typeof onFulfilled !== "function" && this.state === $8764892a7f25c57c$var$FULFILLED || typeof onRejected !== "function" && this.state === $8764892a7f25c57c$var$REJECTED) return this;
    var promise = new this.constructor($8764892a7f25c57c$var$INTERNAL);
    if (this.state !== $8764892a7f25c57c$var$PENDING) {
        var resolver = this.state === $8764892a7f25c57c$var$FULFILLED ? onFulfilled : onRejected;
        $8764892a7f25c57c$var$unwrap(promise, resolver, this.outcome);
    } else this.queue.push(new $8764892a7f25c57c$var$QueueItem(promise, onFulfilled, onRejected));
    return promise;
};
function $8764892a7f25c57c$var$QueueItem(promise, onFulfilled, onRejected) {
    this.promise = promise;
    if (typeof onFulfilled === "function") {
        this.onFulfilled = onFulfilled;
        this.callFulfilled = this.otherCallFulfilled;
    }
    if (typeof onRejected === "function") {
        this.onRejected = onRejected;
        this.callRejected = this.otherCallRejected;
    }
}
$8764892a7f25c57c$var$QueueItem.prototype.callFulfilled = function(value) {
    $8764892a7f25c57c$var$handlers.resolve(this.promise, value);
};
$8764892a7f25c57c$var$QueueItem.prototype.otherCallFulfilled = function(value) {
    $8764892a7f25c57c$var$unwrap(this.promise, this.onFulfilled, value);
};
$8764892a7f25c57c$var$QueueItem.prototype.callRejected = function(value) {
    $8764892a7f25c57c$var$handlers.reject(this.promise, value);
};
$8764892a7f25c57c$var$QueueItem.prototype.otherCallRejected = function(value) {
    $8764892a7f25c57c$var$unwrap(this.promise, this.onRejected, value);
};
function $8764892a7f25c57c$var$unwrap(promise, func, value) {
    $dxxqI(function() {
        var returnValue;
        try {
            returnValue = func(value);
        } catch (e) {
            return $8764892a7f25c57c$var$handlers.reject(promise, e);
        }
        if (returnValue === promise) $8764892a7f25c57c$var$handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
        else $8764892a7f25c57c$var$handlers.resolve(promise, returnValue);
    });
}
$8764892a7f25c57c$var$handlers.resolve = function(self, value) {
    var result = $8764892a7f25c57c$var$tryCatch($8764892a7f25c57c$var$getThen, value);
    if (result.status === "error") return $8764892a7f25c57c$var$handlers.reject(self, result.value);
    var thenable = result.value;
    if (thenable) $8764892a7f25c57c$var$safelyResolveThenable(self, thenable);
    else {
        self.state = $8764892a7f25c57c$var$FULFILLED;
        self.outcome = value;
        var i = -1;
        var len = self.queue.length;
        while(++i < len)self.queue[i].callFulfilled(value);
    }
    return self;
};
$8764892a7f25c57c$var$handlers.reject = function(self, error) {
    self.state = $8764892a7f25c57c$var$REJECTED;
    self.outcome = error;
    var i = -1;
    var len = self.queue.length;
    while(++i < len)self.queue[i].callRejected(error);
    return self;
};
function $8764892a7f25c57c$var$getThen(obj) {
    // Make sure we only access the accessor once as required by the spec
    var then = obj && obj.then;
    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
        then.apply(obj, arguments);
    };
}
function $8764892a7f25c57c$var$safelyResolveThenable(self, thenable) {
    // Either fulfill, reject or reject with error
    var called = false;
    function onError(value) {
        if (called) return;
        called = true;
        $8764892a7f25c57c$var$handlers.reject(self, value);
    }
    function onSuccess(value) {
        if (called) return;
        called = true;
        $8764892a7f25c57c$var$handlers.resolve(self, value);
    }
    function tryToUnwrap() {
        thenable(onSuccess, onError);
    }
    var result = $8764892a7f25c57c$var$tryCatch(tryToUnwrap);
    if (result.status === "error") onError(result.value);
}
function $8764892a7f25c57c$var$tryCatch(func, value) {
    var out = {};
    try {
        out.value = func(value);
        out.status = "success";
    } catch (e) {
        out.status = "error";
        out.value = e;
    }
    return out;
}
$8764892a7f25c57c$var$Promise.resolve = $8764892a7f25c57c$var$resolve;
function $8764892a7f25c57c$var$resolve(value) {
    if (value instanceof this) return value;
    return $8764892a7f25c57c$var$handlers.resolve(new this($8764892a7f25c57c$var$INTERNAL), value);
}
$8764892a7f25c57c$var$Promise.reject = $8764892a7f25c57c$var$reject;
function $8764892a7f25c57c$var$reject(reason) {
    var promise = new this($8764892a7f25c57c$var$INTERNAL);
    return $8764892a7f25c57c$var$handlers.reject(promise, reason);
}
$8764892a7f25c57c$var$Promise.all = $8764892a7f25c57c$var$all;
function $8764892a7f25c57c$var$all(iterable) {
    var self = this;
    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
    var len = iterable.length;
    var called = false;
    if (!len) return this.resolve([]);
    var values = new Array(len);
    var resolved = 0;
    var i = -1;
    var promise = new this($8764892a7f25c57c$var$INTERNAL);
    while(++i < len)allResolver(iterable[i], i);
    return promise;
    function allResolver(value, i) {
        self.resolve(value).then(resolveFromAll, function(error) {
            if (!called) {
                called = true;
                $8764892a7f25c57c$var$handlers.reject(promise, error);
            }
        });
        function resolveFromAll(outValue) {
            values[i] = outValue;
            if (++resolved === len && !called) {
                called = true;
                $8764892a7f25c57c$var$handlers.resolve(promise, values);
            }
        }
    }
}
$8764892a7f25c57c$var$Promise.race = $8764892a7f25c57c$var$race;
function $8764892a7f25c57c$var$race(iterable) {
    var self = this;
    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
    var len = iterable.length;
    var called = false;
    if (!len) return this.resolve([]);
    var i = -1;
    var promise = new this($8764892a7f25c57c$var$INTERNAL);
    while(++i < len)resolver(iterable[i]);
    return promise;
    function resolver(value) {
        self.resolve(value).then(function(response) {
            if (!called) {
                called = true;
                $8764892a7f25c57c$var$handlers.resolve(promise, response);
            }
        }, function(error) {
            if (!called) {
                called = true;
                $8764892a7f25c57c$var$handlers.reject(promise, error);
            }
        });
    }
}

});
parcelRegister("dxxqI", function(module, exports) {
"use strict";
var $028b3aff8ef21417$var$Mutation = $parcel$global.MutationObserver || $parcel$global.WebKitMutationObserver;
var $028b3aff8ef21417$var$scheduleDrain;
if ($028b3aff8ef21417$var$Mutation) {
    var $028b3aff8ef21417$var$called = 0;
    var $028b3aff8ef21417$var$observer = new $028b3aff8ef21417$var$Mutation($028b3aff8ef21417$var$nextTick);
    var $028b3aff8ef21417$var$element = $parcel$global.document.createTextNode("");
    $028b3aff8ef21417$var$observer.observe($028b3aff8ef21417$var$element, {
        characterData: true
    });
    $028b3aff8ef21417$var$scheduleDrain = function() {
        $028b3aff8ef21417$var$element.data = $028b3aff8ef21417$var$called = ++$028b3aff8ef21417$var$called % 2;
    };
} else if (!$parcel$global.setImmediate && typeof $parcel$global.MessageChannel !== "undefined") {
    var $028b3aff8ef21417$var$channel = new $parcel$global.MessageChannel();
    $028b3aff8ef21417$var$channel.port1.onmessage = $028b3aff8ef21417$var$nextTick;
    $028b3aff8ef21417$var$scheduleDrain = function() {
        $028b3aff8ef21417$var$channel.port2.postMessage(0);
    };
} else if ("document" in $parcel$global && "onreadystatechange" in $parcel$global.document.createElement("script")) $028b3aff8ef21417$var$scheduleDrain = function() {
    // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
    // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
    var scriptEl = $parcel$global.document.createElement("script");
    scriptEl.onreadystatechange = function() {
        $028b3aff8ef21417$var$nextTick();
        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
    };
    $parcel$global.document.documentElement.appendChild(scriptEl);
};
else $028b3aff8ef21417$var$scheduleDrain = function() {
    setTimeout($028b3aff8ef21417$var$nextTick, 0);
};
var $028b3aff8ef21417$var$draining;
var $028b3aff8ef21417$var$queue = [];
//named nextTick for less confusing stack traces
function $028b3aff8ef21417$var$nextTick() {
    $028b3aff8ef21417$var$draining = true;
    var i, oldQueue;
    var len = $028b3aff8ef21417$var$queue.length;
    while(len){
        oldQueue = $028b3aff8ef21417$var$queue;
        $028b3aff8ef21417$var$queue = [];
        i = -1;
        while(++i < len)oldQueue[i]();
        len = $028b3aff8ef21417$var$queue.length;
    }
    $028b3aff8ef21417$var$draining = false;
}
module.exports = $028b3aff8ef21417$var$immediate;
function $028b3aff8ef21417$var$immediate(task) {
    if ($028b3aff8ef21417$var$queue.push(task) === 1 && !$028b3aff8ef21417$var$draining) $028b3aff8ef21417$var$scheduleDrain();
}

});




parcelRegister("9DhCp", function(module, exports) {
"use strict";
/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */ function $70356c3df2d06369$var$GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        "data": [],
        "end": [],
        "error": []
    };
    // the previous worker, if any
    this.previous = null;
}
$70356c3df2d06369$var$GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */ push: function(chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */ end: function() {
        if (this.isFinished) return false;
        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */ error: function(e) {
        if (this.isFinished) return false;
        if (this.isPaused) this.generatedError = e;
        else {
            this.isFinished = true;
            this.emit("error", e);
            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if (this.previous) this.previous.error(e);
            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */ on: function(name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */ cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */ emit: function(name, arg) {
        if (this._listeners[name]) for(var i = 0; i < this._listeners[name].length; i++)this._listeners[name][i].call(this, arg);
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */ pipe: function(next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */ registerPrevious: function(previous) {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous = previous;
        var self = this;
        previous.on("data", function(chunk) {
            self.processChunk(chunk);
        });
        previous.on("end", function() {
            self.end();
        });
        previous.on("error", function(e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */ pause: function() {
        if (this.isPaused || this.isFinished) return false;
        this.isPaused = true;
        if (this.previous) this.previous.pause();
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */ resume: function() {
        if (!this.isPaused || this.isFinished) return false;
        this.isPaused = false;
        // if true, the worker tried to resume but failed
        var withError = false;
        if (this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if (this.previous) this.previous.resume();
        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */ flush: function() {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */ processChunk: function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */ withStreamInfo: function(key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */ mergeStreamInfo: function() {
        for(var key in this.extraStreamInfo){
            if (!this.extraStreamInfo.hasOwnProperty(key)) continue;
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },
    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */ lock: function() {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = true;
        if (this.previous) this.previous.lock();
    },
    /**
     *
     * Pretty print the workers chain.
     */ toString: function() {
        var me = "Worker " + this.name;
        if (this.previous) return this.previous + " -> " + me;
        else return me;
    }
};
module.exports = $70356c3df2d06369$var$GenericWorker;

});


parcelRegister("e4VL4", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a3fe3dfdb22e2686$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $l6spT = parcelRequire("l6spT");

var $9DhCp = parcelRequire("9DhCp");

var $lAvwW = parcelRequire("lAvwW");

var $4Fiik = parcelRequire("4Fiik");

var $gEpFr = parcelRequire("gEpFr");
var $a3fe3dfdb22e2686$var$NodejsStreamOutputAdapter = null;

if ($4Fiik.nodestream) try {
    $a3fe3dfdb22e2686$var$NodejsStreamOutputAdapter = (parcelRequire("bTyQB"));
} catch (e) {}
/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} type the name of the final type
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */ function $a3fe3dfdb22e2686$var$transformZipOutput(type, content, mimeType) {
    switch(type){
        case "blob":
            return $eBqgu.newBlob($eBqgu.transformTo("arraybuffer", content), mimeType);
        case "base64":
            return $lAvwW.encode(content);
        default:
            return $eBqgu.transformTo(type, content);
    }
}
/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */ function $a3fe3dfdb22e2686$var$concat(type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++)totalLength += dataArray[i].length;
    switch(type){
        case "string":
            return dataArray.join("");
        case "array":
            return Array.prototype.concat.apply([], dataArray);
        case "uint8array":
            res = new Uint8Array(totalLength);
            for(i = 0; i < dataArray.length; i++){
                res.set(dataArray[i], index);
                index += dataArray[i].length;
            }
            return res;
        case "nodebuffer":
            return $a3fe3dfdb22e2686$require$Buffer.concat(dataArray);
        default:
            throw new Error("concat : unsupported type '" + type + "'");
    }
}
/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */ function $a3fe3dfdb22e2686$var$accumulate(helper, updateCallback) {
    return new $gEpFr.Promise(function(resolve, reject) {
        var dataArray = [];
        var chunkType = helper._internalType, resultType = helper._outputType, mimeType = helper._mimeType;
        helper.on("data", function(data, meta) {
            dataArray.push(data);
            if (updateCallback) updateCallback(meta);
        }).on("error", function(err) {
            dataArray = [];
            reject(err);
        }).on("end", function() {
            try {
                var result = $a3fe3dfdb22e2686$var$transformZipOutput(resultType, $a3fe3dfdb22e2686$var$concat(chunkType, dataArray), mimeType);
                resolve(result);
            } catch (e) {
                reject(e);
            }
            dataArray = [];
        }).resume();
    });
}
/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */ function $a3fe3dfdb22e2686$var$StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType){
        case "blob":
        case "arraybuffer":
            internalType = "uint8array";
            break;
        case "base64":
            internalType = "string";
            break;
    }
    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        $eBqgu.checkSupport(internalType);
        this._worker = worker.pipe(new $l6spT(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch (e) {
        this._worker = new $9DhCp("error");
        this._worker.error(e);
    }
}
$a3fe3dfdb22e2686$var$StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */ accumulate: function(updateCb) {
        return $a3fe3dfdb22e2686$var$accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */ on: function(evt, fn) {
        var self = this;
        if (evt === "data") this._worker.on(evt, function(chunk) {
            fn.call(self, chunk.data, chunk.meta);
        });
        else this._worker.on(evt, function() {
            $eBqgu.delay(fn, arguments, self);
        });
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */ resume: function() {
        $eBqgu.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */ pause: function() {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */ toNodejsStream: function(updateCb) {
        $eBqgu.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") // an object stream containing blob/arraybuffer/uint8array/string
        // is strange and I don't know if it would be useful.
        // I you find this comment and have a good usecase, please open a
        // bug report !
        throw new Error(this._outputType + " is not supported by this method");
        return new $a3fe3dfdb22e2686$var$NodejsStreamOutputAdapter(this, {
            objectMode: this._outputType !== "nodebuffer"
        }, updateCb);
    }
};
module.exports = $a3fe3dfdb22e2686$var$StreamHelper;

});
parcelRegister("l6spT", function(module, exports) {
"use strict";

var $9DhCp = parcelRequire("9DhCp");

var $eBqgu = parcelRequire("eBqgu");
/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */ function $f5d0337afc32d703$var$ConvertWorker(destType) {
    $9DhCp.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
$eBqgu.inherits($f5d0337afc32d703$var$ConvertWorker, $9DhCp);
/**
 * @see GenericWorker.processChunk
 */ $f5d0337afc32d703$var$ConvertWorker.prototype.processChunk = function(chunk) {
    this.push({
        data: $eBqgu.transformTo(this.destType, chunk.data),
        meta: chunk.meta
    });
};
module.exports = $f5d0337afc32d703$var$ConvertWorker;

});

parcelRegister("bTyQB", function(module, exports) {
"use strict";

var $7R0Jl = parcelRequire("7R0Jl");
var $8a8fdcc098ec818e$require$Readable = $7R0Jl.Readable;

var $eBqgu = parcelRequire("eBqgu");
$eBqgu.inherits($8a8fdcc098ec818e$var$NodejsStreamOutputAdapter, $8a8fdcc098ec818e$require$Readable);
/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/ function $8a8fdcc098ec818e$var$NodejsStreamOutputAdapter(helper, options, updateCb) {
    $8a8fdcc098ec818e$require$Readable.call(this, options);
    this._helper = helper;
    var self = this;
    helper.on("data", function(data, meta) {
        if (!self.push(data)) self._helper.pause();
        if (updateCb) updateCb(meta);
    }).on("error", function(e) {
        self.emit("error", e);
    }).on("end", function() {
        self.push(null);
    });
}
$8a8fdcc098ec818e$var$NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};
module.exports = $8a8fdcc098ec818e$var$NodejsStreamOutputAdapter;

});


parcelRegister("798BN", function(module, exports) {

$parcel$export(module.exports, "base64", () => $53400d29c4983090$export$b3b2de96497acc47, (v) => $53400d29c4983090$export$b3b2de96497acc47 = v);
$parcel$export(module.exports, "binary", () => $53400d29c4983090$export$33902b7329277358, (v) => $53400d29c4983090$export$33902b7329277358 = v);
$parcel$export(module.exports, "dir", () => $53400d29c4983090$export$147ec2801e896265, (v) => $53400d29c4983090$export$147ec2801e896265 = v);
$parcel$export(module.exports, "createFolders", () => $53400d29c4983090$export$d1304b216aaaddfd, (v) => $53400d29c4983090$export$d1304b216aaaddfd = v);
$parcel$export(module.exports, "date", () => $53400d29c4983090$export$324d90190a8b822a, (v) => $53400d29c4983090$export$324d90190a8b822a = v);
$parcel$export(module.exports, "compression", () => $53400d29c4983090$export$131856665bc0b7c1, (v) => $53400d29c4983090$export$131856665bc0b7c1 = v);
$parcel$export(module.exports, "compressionOptions", () => $53400d29c4983090$export$71c8c3e1548702d0, (v) => $53400d29c4983090$export$71c8c3e1548702d0 = v);
$parcel$export(module.exports, "comment", () => $53400d29c4983090$export$4a34f930e789283c, (v) => $53400d29c4983090$export$4a34f930e789283c = v);
$parcel$export(module.exports, "unixPermissions", () => $53400d29c4983090$export$167951303c57bd1a, (v) => $53400d29c4983090$export$167951303c57bd1a = v);
$parcel$export(module.exports, "dosPermissions", () => $53400d29c4983090$export$456c30f758283540, (v) => $53400d29c4983090$export$456c30f758283540 = v);
var $53400d29c4983090$export$b3b2de96497acc47;
var $53400d29c4983090$export$33902b7329277358;
var $53400d29c4983090$export$147ec2801e896265;
var $53400d29c4983090$export$d1304b216aaaddfd;
var $53400d29c4983090$export$324d90190a8b822a;
var $53400d29c4983090$export$131856665bc0b7c1;
var $53400d29c4983090$export$71c8c3e1548702d0;
var $53400d29c4983090$export$4a34f930e789283c;
var $53400d29c4983090$export$167951303c57bd1a;
var $53400d29c4983090$export$456c30f758283540;
"use strict";
$53400d29c4983090$export$b3b2de96497acc47 = false;
$53400d29c4983090$export$33902b7329277358 = false;
$53400d29c4983090$export$147ec2801e896265 = false;
$53400d29c4983090$export$d1304b216aaaddfd = true;
$53400d29c4983090$export$324d90190a8b822a = null;
$53400d29c4983090$export$131856665bc0b7c1 = null;
$53400d29c4983090$export$71c8c3e1548702d0 = null;
$53400d29c4983090$export$4a34f930e789283c = null;
$53400d29c4983090$export$167951303c57bd1a = null;
$53400d29c4983090$export$456c30f758283540 = null;

});

parcelRegister("xDetb", function(module, exports) {
"use strict";

var $gEpFr = parcelRequire("gEpFr");

var $JGf3n = parcelRequire("JGf3n");

var $iqzEe = parcelRequire("iqzEe");

var $7MruG = parcelRequire("7MruG");

var $iqzEe = parcelRequire("iqzEe");
/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */ function $065183ea66c1979f$var$CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}
$065183ea66c1979f$var$CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */ getContentWorker: function() {
        var worker = new $JGf3n($gEpFr.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new $iqzEe("data_length"));
        var that = this;
        worker.on("end", function() {
            if (this.streamInfo["data_length"] !== that.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */ getCompressedWorker: function() {
        return new $JGf3n($gEpFr.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
    }
};
/**
 * Chain the given worker with other workers to compress the content with the
 * given compression.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */ $065183ea66c1979f$var$CompressedObject.createWorkerFrom = function(uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker.pipe(new $7MruG()).pipe(new $iqzEe("uncompressedSize")).pipe(compression.compressWorker(compressionOptions)).pipe(new $iqzEe("compressedSize")).withStreamInfo("compression", compression);
};
module.exports = $065183ea66c1979f$var$CompressedObject;

});
parcelRegister("JGf3n", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $9DhCp = parcelRequire("9DhCp");
// the size of the generated chunks
// TODO expose this as a public variable
var $0894f86cbe3a7c27$var$DEFAULT_BLOCK_SIZE = 16384;
/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */ function $0894f86cbe3a7c27$var$DataWorker(dataP) {
    $9DhCp.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";
    this._tickScheduled = false;
    dataP.then(function(data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = $eBqgu.getTypeOf(data);
        if (!self.isPaused) self._tickAndRepeat();
    }, function(e) {
        self.error(e);
    });
}
$eBqgu.inherits($0894f86cbe3a7c27$var$DataWorker, $9DhCp);
/**
 * @see GenericWorker.cleanUp
 */ $0894f86cbe3a7c27$var$DataWorker.prototype.cleanUp = function() {
    $9DhCp.prototype.cleanUp.call(this);
    this.data = null;
};
/**
 * @see GenericWorker.resume
 */ $0894f86cbe3a7c27$var$DataWorker.prototype.resume = function() {
    if (!$9DhCp.prototype.resume.call(this)) return false;
    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        $eBqgu.delay(this._tickAndRepeat, [], this);
    }
    return true;
};
/**
 * Trigger a tick a schedule an other call to this function.
 */ $0894f86cbe3a7c27$var$DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if (this.isPaused || this.isFinished) return;
    this._tick();
    if (!this.isFinished) {
        $eBqgu.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};
/**
 * Read and push a chunk.
 */ $0894f86cbe3a7c27$var$DataWorker.prototype._tick = function() {
    if (this.isPaused || this.isFinished) return false;
    var size = $0894f86cbe3a7c27$var$DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) // EOF
    return this.end();
    else {
        switch(this.type){
            case "string":
                data = this.data.substring(this.index, nextIndex);
                break;
            case "uint8array":
                data = this.data.subarray(this.index, nextIndex);
                break;
            case "array":
            case "nodebuffer":
                data = this.data.slice(this.index, nextIndex);
                break;
        }
        this.index = nextIndex;
        return this.push({
            data: data,
            meta: {
                percent: this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};
module.exports = $0894f86cbe3a7c27$var$DataWorker;

});

parcelRegister("iqzEe", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $9DhCp = parcelRequire("9DhCp");
/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */ function $d6a64e9fc8c8254d$var$DataLengthProbe(propName) {
    $9DhCp.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
$eBqgu.inherits($d6a64e9fc8c8254d$var$DataLengthProbe, $9DhCp);
/**
 * @see GenericWorker.processChunk
 */ $d6a64e9fc8c8254d$var$DataLengthProbe.prototype.processChunk = function(chunk) {
    if (chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    $9DhCp.prototype.processChunk.call(this, chunk);
};
module.exports = $d6a64e9fc8c8254d$var$DataLengthProbe;

});

parcelRegister("7MruG", function(module, exports) {
"use strict";

var $9DhCp = parcelRequire("9DhCp");

var $44wFx = parcelRequire("44wFx");

var $eBqgu = parcelRequire("eBqgu");
/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */ function $5aa257d525f5c100$var$Crc32Probe() {
    $9DhCp.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
$eBqgu.inherits($5aa257d525f5c100$var$Crc32Probe, $9DhCp);
/**
 * @see GenericWorker.processChunk
 */ $5aa257d525f5c100$var$Crc32Probe.prototype.processChunk = function(chunk) {
    this.streamInfo.crc32 = $44wFx(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = $5aa257d525f5c100$var$Crc32Probe;

});
parcelRegister("44wFx", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");
/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */ // Use ordinary array, since untyped makes no boost here
function $2f70e085bb372ebd$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $2f70e085bb372ebd$var$crcTable = $2f70e085bb372ebd$var$makeTable();
function $2f70e085bb372ebd$var$crc32(crc, buf, len, pos) {
    var t = $2f70e085bb372ebd$var$crcTable, end = pos + len;
    crc = crc ^ -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
// That's all for the pako functions.
/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */ function $2f70e085bb372ebd$var$crc32str(crc, str, len, pos) {
    var t = $2f70e085bb372ebd$var$crcTable, end = pos + len;
    crc = crc ^ -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) return 0;
    var isArray = $eBqgu.getTypeOf(input) !== "string";
    if (isArray) return $2f70e085bb372ebd$var$crc32(crc | 0, input, input.length, 0);
    else return $2f70e085bb372ebd$var$crc32str(crc | 0, input, input.length, 0);
};

});



parcelRegister("58CZu", function(module, exports) {
"use strict";

var $e4VL4 = parcelRequire("e4VL4");

var $JGf3n = parcelRequire("JGf3n");

var $ggeMD = parcelRequire("ggeMD");

var $xDetb = parcelRequire("xDetb");

var $9DhCp = parcelRequire("9DhCp");
/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */ var $3bdbf1e13b4e0abf$var$ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;
    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression: options.compression,
        compressionOptions: options.compressionOptions
    };
};
$3bdbf1e13b4e0abf$var$ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */ internalStream: function(type) {
        var result = null, outputType = "string";
        try {
            if (!type) throw new Error("No output type specified.");
            outputType = type.toLowerCase();
            var askUnicodeString = outputType === "string" || outputType === "text";
            if (outputType === "binarystring" || outputType === "text") outputType = "string";
            result = this._decompressWorker();
            var isUnicodeString = !this._dataBinary;
            if (isUnicodeString && !askUnicodeString) result = result.pipe(new $ggeMD.Utf8EncodeWorker());
            if (!isUnicodeString && askUnicodeString) result = result.pipe(new $ggeMD.Utf8DecodeWorker());
        } catch (e) {
            result = new $9DhCp("error");
            result.error(e);
        }
        return new $e4VL4(result, outputType, "");
    },
    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */ async: function(type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },
    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */ nodeStream: function(type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },
    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */ _compressWorker: function(compression, compressionOptions) {
        if (this._data instanceof $xDetb && this._data.compression.magic === compression.magic) return this._data.getCompressedWorker();
        else {
            var result = this._decompressWorker();
            if (!this._dataBinary) result = result.pipe(new $ggeMD.Utf8EncodeWorker());
            return $xDetb.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */ _decompressWorker: function() {
        if (this._data instanceof $xDetb) return this._data.getContentWorker();
        else if (this._data instanceof $9DhCp) return this._data;
        else return new $JGf3n(this._data);
    }
};
var $3bdbf1e13b4e0abf$var$removedMethods = [
    "asText",
    "asBinary",
    "asNodeBuffer",
    "asUint8Array",
    "asArrayBuffer"
];
var $3bdbf1e13b4e0abf$var$removedFn = function() {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};
for(var $3bdbf1e13b4e0abf$var$i = 0; $3bdbf1e13b4e0abf$var$i < $3bdbf1e13b4e0abf$var$removedMethods.length; $3bdbf1e13b4e0abf$var$i++)$3bdbf1e13b4e0abf$var$ZipObject.prototype[$3bdbf1e13b4e0abf$var$removedMethods[$3bdbf1e13b4e0abf$var$i]] = $3bdbf1e13b4e0abf$var$removedFn;
module.exports = $3bdbf1e13b4e0abf$var$ZipObject;

});

parcelRegister("NpFJI", function(module, exports) {

$parcel$export(module.exports, "generateWorker", () => $09487daced0b5322$export$4c005b3e6e6cd15f, (v) => $09487daced0b5322$export$4c005b3e6e6cd15f = v);
/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */ var $09487daced0b5322$export$4c005b3e6e6cd15f;
"use strict";

var $2sj4O = parcelRequire("2sj4O");

var $cZQ0a = parcelRequire("cZQ0a");
/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */ var $09487daced0b5322$var$getCompression = function(fileCompression, zipCompression) {
    var compressionName = fileCompression || zipCompression;
    var compression = $2sj4O[compressionName];
    if (!compression) throw new Error(compressionName + " is not a valid compression method !");
    return compression;
};
$09487daced0b5322$export$4c005b3e6e6cd15f = function(zip, options, comment) {
    var zipFileWorker = new $cZQ0a(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {
        zip.forEach(function(relativePath, file) {
            entriesCount++;
            var compression = $09487daced0b5322$var$getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;
            file._compressWorker(compression, compressionOptions).withStreamInfo("file", {
                name: relativePath,
                dir: dir,
                date: date,
                comment: file.comment || "",
                unixPermissions: file.unixPermissions,
                dosPermissions: file.dosPermissions
            }).pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }
    return zipFileWorker;
};

});
parcelRegister("2sj4O", function(module, exports) {

$parcel$export(module.exports, "STORE", () => $1c9cfe85ef3d3676$export$530776c2ce1cbec2, (v) => $1c9cfe85ef3d3676$export$530776c2ce1cbec2 = v);
$parcel$export(module.exports, "DEFLATE", () => $1c9cfe85ef3d3676$export$35bf3ae2e1e80c81, (v) => $1c9cfe85ef3d3676$export$35bf3ae2e1e80c81 = v);
var $1c9cfe85ef3d3676$export$530776c2ce1cbec2;
var $1c9cfe85ef3d3676$export$35bf3ae2e1e80c81;
"use strict";

var $9DhCp = parcelRequire("9DhCp");
$1c9cfe85ef3d3676$export$530776c2ce1cbec2 = {
    magic: "\0\0",
    compressWorker: function(compressionOptions) {
        return new $9DhCp("STORE compression");
    },
    uncompressWorker: function() {
        return new $9DhCp("STORE decompression");
    }
};

$1c9cfe85ef3d3676$export$35bf3ae2e1e80c81 = (parcelRequire("2Dc1s"));

});
parcelRegister("2Dc1s", function(module, exports) {

$parcel$export(module.exports, "magic", () => $1ea88cbb20bd96c2$export$13db3bb8db75f394, (v) => $1ea88cbb20bd96c2$export$13db3bb8db75f394 = v);
$parcel$export(module.exports, "compressWorker", () => $1ea88cbb20bd96c2$export$3574a5d979ced502, (v) => $1ea88cbb20bd96c2$export$3574a5d979ced502 = v);
$parcel$export(module.exports, "uncompressWorker", () => $1ea88cbb20bd96c2$export$96de150877b8bf94, (v) => $1ea88cbb20bd96c2$export$96de150877b8bf94 = v);
var $1ea88cbb20bd96c2$export$13db3bb8db75f394;
var $1ea88cbb20bd96c2$export$3574a5d979ced502;
var $1ea88cbb20bd96c2$export$96de150877b8bf94;
"use strict";
var $1ea88cbb20bd96c2$var$USE_TYPEDARRAY = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Uint32Array !== "undefined";

var $ckCqy = parcelRequire("ckCqy");

var $eBqgu = parcelRequire("eBqgu");

var $9DhCp = parcelRequire("9DhCp");
var $1ea88cbb20bd96c2$var$ARRAY_TYPE = $1ea88cbb20bd96c2$var$USE_TYPEDARRAY ? "uint8array" : "array";
$1ea88cbb20bd96c2$export$13db3bb8db75f394 = "\b\0";
/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */ function $1ea88cbb20bd96c2$var$FlateWorker(action, options) {
    $9DhCp.call(this, "FlateWorker/" + action);
    this._pako = null;
    this._pakoAction = action;
    this._pakoOptions = options;
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};
}
$eBqgu.inherits($1ea88cbb20bd96c2$var$FlateWorker, $9DhCp);
/**
 * @see GenericWorker.processChunk
 */ $1ea88cbb20bd96c2$var$FlateWorker.prototype.processChunk = function(chunk) {
    this.meta = chunk.meta;
    if (this._pako === null) this._createPako();
    this._pako.push($eBqgu.transformTo($1ea88cbb20bd96c2$var$ARRAY_TYPE, chunk.data), false);
};
/**
 * @see GenericWorker.flush
 */ $1ea88cbb20bd96c2$var$FlateWorker.prototype.flush = function() {
    $9DhCp.prototype.flush.call(this);
    if (this._pako === null) this._createPako();
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */ $1ea88cbb20bd96c2$var$FlateWorker.prototype.cleanUp = function() {
    $9DhCp.prototype.cleanUp.call(this);
    this._pako = null;
};
/**
 * Create the _pako object.
 * TODO: lazy-loading this object isn't the best solution but it's the
 * quickest. The best solution is to lazy-load the worker list. See also the
 * issue #446.
 */ $1ea88cbb20bd96c2$var$FlateWorker.prototype._createPako = function() {
    this._pako = new $ckCqy[this._pakoAction]({
        raw: true,
        level: this._pakoOptions.level || -1 // default compression
    });
    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data: data,
            meta: self.meta
        });
    };
};
$1ea88cbb20bd96c2$export$3574a5d979ced502 = function(compressionOptions) {
    return new $1ea88cbb20bd96c2$var$FlateWorker("Deflate", compressionOptions);
};
$1ea88cbb20bd96c2$export$96de150877b8bf94 = function() {
    return new $1ea88cbb20bd96c2$var$FlateWorker("Inflate", {});
};

});
parcelRegister("ckCqy", function(module, exports) {
// Top level file is just a mixin of submodules & constants
"use strict";

var $9CLQF = parcelRequire("9CLQF");
var $8fa5292818130bae$require$assign = $9CLQF.assign;

var $2wbN5 = parcelRequire("2wbN5");

var $3OYOJ = parcelRequire("3OYOJ");

var $hf4Xu = parcelRequire("hf4Xu");
var $8fa5292818130bae$var$pako = {};
$8fa5292818130bae$require$assign($8fa5292818130bae$var$pako, $2wbN5, $3OYOJ, $hf4Xu);
module.exports = $8fa5292818130bae$var$pako;

});
parcelRegister("9CLQF", function(module, exports) {
"use strict";
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnUntyped);
    }
};
module.exports.setTyped($701cc75d47025217$var$TYPED_OK);

});

parcelRegister("2wbN5", function(module, exports) {

$parcel$export(module.exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export(module.exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export(module.exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
"use strict";

var $lGf86 = parcelRequire("lGf86");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");
var $1d57b756249bc6d3$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d57b756249bc6d3$var$Z_NO_FLUSH = 0;
var $1d57b756249bc6d3$var$Z_FINISH = 4;
var $1d57b756249bc6d3$var$Z_OK = 0;
var $1d57b756249bc6d3$var$Z_STREAM_END = 1;
var $1d57b756249bc6d3$var$Z_SYNC_FLUSH = 2;
var $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION = -1;
var $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY = 0;
var $1d57b756249bc6d3$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    if (!(this instanceof $1d57b756249bc6d3$var$Deflate)) return new $1d57b756249bc6d3$var$Deflate(options);
    this.options = $9CLQF.assign({
        level: $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY,
        to: ""
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $lGf86.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
    if (opt.header) $lGf86.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $iC2HB.string2buf(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $lGf86.deflateSetDictionary(this.strm, dict);
        if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d57b756249bc6d3$var$Z_FINISH : $1d57b756249bc6d3$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $iC2HB.string2buf(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $lGf86.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $1d57b756249bc6d3$var$Z_STREAM_END && status !== $1d57b756249bc6d3$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d57b756249bc6d3$var$Z_FINISH || _mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH)) {
            if (this.options.to === "string") this.onData($iC2HB.buf2binstring($9CLQF.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d57b756249bc6d3$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d57b756249bc6d3$var$Z_FINISH) {
        status = $lGf86.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d57b756249bc6d3$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH) {
        this.onEnd($1d57b756249bc6d3$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    var deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $7gAmB[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;

});
parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateSetHeader", () => $fc8941aa2060205a$export$1cd50f7b2515ba19, (v) => $fc8941aa2060205a$export$1cd50f7b2515ba19 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
"use strict";

var $9CLQF = parcelRequire("9CLQF");

var $hx6dX = parcelRequire("hx6dX");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $7gAmB[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $9CLQF.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $hx6dX._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $9CLQF.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $9CLQF.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $hx6dX._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $9CLQF.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $9CLQF.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $hx6dX._tr_init(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $9CLQF.Buf8(s.w_size * 2);
    s.head = new $9CLQF.Buf16(s.hash_size);
    s.prev = new $9CLQF.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $9CLQF.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $hx6dX._tr_align(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $hx6dX._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $9CLQF.Buf8(s.w_size);
        $9CLQF.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
"use strict";

var $9CLQF = parcelRequire("9CLQF");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $9CLQF.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("iC2HB", function(module, exports) {

$parcel$export(module.exports, "string2buf", () => $d8cddf31faab2448$export$7a4c1b2f775b5a9f, (v) => $d8cddf31faab2448$export$7a4c1b2f775b5a9f = v);
$parcel$export(module.exports, "buf2binstring", () => $d8cddf31faab2448$export$a751fe64af8a9a51, (v) => $d8cddf31faab2448$export$a751fe64af8a9a51 = v);
$parcel$export(module.exports, "binstring2buf", () => $d8cddf31faab2448$export$1d1a7119601ff18c, (v) => $d8cddf31faab2448$export$1d1a7119601ff18c = v);
$parcel$export(module.exports, "buf2string", () => $d8cddf31faab2448$export$49a50563f377746, (v) => $d8cddf31faab2448$export$49a50563f377746 = v);
$parcel$export(module.exports, "utf8border", () => $d8cddf31faab2448$export$53dee3f58a714214, (v) => $d8cddf31faab2448$export$53dee3f58a714214 = v);
// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $d8cddf31faab2448$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $d8cddf31faab2448$export$1d1a7119601ff18c;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
"use strict";

var $9CLQF = parcelRequire("9CLQF");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $d8cddf31faab2448$var$STR_APPLY_OK = true;
var $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $d8cddf31faab2448$var$_utf8len = new $9CLQF.Buf8(256);
for(var $d8cddf31faab2448$var$q = 0; $d8cddf31faab2448$var$q < 256; $d8cddf31faab2448$var$q++)$d8cddf31faab2448$var$_utf8len[$d8cddf31faab2448$var$q] = $d8cddf31faab2448$var$q >= 252 ? 6 : $d8cddf31faab2448$var$q >= 248 ? 5 : $d8cddf31faab2448$var$q >= 240 ? 4 : $d8cddf31faab2448$var$q >= 224 ? 3 : $d8cddf31faab2448$var$q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $9CLQF.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $d8cddf31faab2448$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK || !buf.subarray && $d8cddf31faab2448$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $9CLQF.shrinkBuf(buf, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$d8cddf31faab2448$export$a751fe64af8a9a51 = function(buf) {
    return $d8cddf31faab2448$var$buf2binstring(buf, buf.length);
};
$d8cddf31faab2448$export$1d1a7119601ff18c = function(str) {
    var buf = new $9CLQF.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$d8cddf31faab2448$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("9WDto", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});


parcelRegister("3OYOJ", function(module, exports) {

$parcel$export(module.exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export(module.exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export(module.exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
"use strict";

var $fzvBq = parcelRequire("fzvBq");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $hf4Xu = parcelRequire("hf4Xu");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");

var $9t6AE = parcelRequire("9t6AE");
var $2c8537a6b47169be$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    if (!(this instanceof $2c8537a6b47169be$var$Inflate)) return new $2c8537a6b47169be$var$Inflate(options);
    this.options = $9CLQF.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $fzvBq.inflateInit2(this.strm, opt.windowBits);
    if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
    this.header = new $9t6AE();
    $fzvBq.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $iC2HB.string2buf(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $fzvBq.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $hf4Xu.Z_FINISH : $hf4Xu.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // Only binary strings can be decompressed on practice
    strm.input = $iC2HB.binstring2buf(data);
    else if ($2c8537a6b47169be$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fzvBq.inflate(strm, $hf4Xu.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $hf4Xu.Z_NEED_DICT && dictionary) status = $fzvBq.inflateSetDictionary(this.strm, dictionary);
        if (status === $hf4Xu.Z_BUF_ERROR && allowBufError === true) {
            status = $hf4Xu.Z_OK;
            allowBufError = false;
        }
        if (status !== $hf4Xu.Z_STREAM_END && status !== $hf4Xu.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $hf4Xu.Z_STREAM_END || strm.avail_in === 0 && (_mode === $hf4Xu.Z_FINISH || _mode === $hf4Xu.Z_SYNC_FLUSH)) {
                if (this.options.to === "string") {
                    next_out_utf8 = $iC2HB.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $iC2HB.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $9CLQF.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $hf4Xu.Z_STREAM_END);
    if (status === $hf4Xu.Z_STREAM_END) _mode = $hf4Xu.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $hf4Xu.Z_FINISH) {
        status = $fzvBq.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $hf4Xu.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $hf4Xu.Z_SYNC_FLUSH) {
        this.onEnd($hf4Xu.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $hf4Xu.Z_OK) {
        if (this.options.to === "string") // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join("");
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    var inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $7gAmB[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;

});
parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateGetHeader", () => $b562a383a327bea1$export$6d4647cb9e1c75fc, (v) => $b562a383a327bea1$export$6d4647cb9e1c75fc = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
"use strict";

var $9CLQF = parcelRequire("9CLQF");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $9CLQF.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $9CLQF.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $9CLQF.Buf32(512);
        $b562a383a327bea1$var$distfix = new $9CLQF.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $9CLQF.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $9CLQF.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $9CLQF.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $9CLQF.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $9CLQF.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $9CLQF.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $9CLQF.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
"use strict";

var $9CLQF = parcelRequire("9CLQF");
var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("hf4Xu", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("9t6AE", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $6e4bef2851e6b301$var$GZheader;

});





parcelRegister("cZQ0a", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $9DhCp = parcelRequire("9DhCp");

var $ggeMD = parcelRequire("ggeMD");

var $44wFx = parcelRequire("44wFx");

var $GjXGW = parcelRequire("GjXGW");
/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */ var $9763850125e04168$var$decToHex = function(dec, bytes) {
    var hex = "", i;
    for(i = 0; i < bytes; i++){
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};
/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */ var $9763850125e04168$var$generateUnixExternalFileAttr = function(unixPermissions, isDir) {
    var result = unixPermissions;
    if (!unixPermissions) // I can't use octal values in strict mode, hence the hexa.
    //  040775 => 0x41fd
    // 0100664 => 0x81b4
    result = isDir ? 0x41fd : 0x81b4;
    return (result & 0xFFFF) << 16;
};
/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */ var $9763850125e04168$var$generateDosExternalFileAttr = function(dosPermissions, isDir) {
    // the dir flag is already set for compatibility
    return (dosPermissions || 0) & 0x3F;
};
/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with information about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */ var $9763850125e04168$var$generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo["file"], compression = streamInfo["compression"], useCustomEncoding = encodeFileName !== $ggeMD.utf8encode, encodedFileName = $eBqgu.transformTo("string", encodeFileName(file.name)), utfEncodedFileName = $eBqgu.transformTo("string", $ggeMD.utf8encode(file.name)), comment = file.comment, encodedComment = $eBqgu.transformTo("string", encodeFileName(comment)), utfEncodedComment = $eBqgu.transformTo("string", $ggeMD.utf8encode(comment)), useUTF8ForFileName = utfEncodedFileName.length !== file.name.length, useUTF8ForComment = utfEncodedComment.length !== comment.length, dosTime, dosDate, extraFields = "", unicodePathExtraField = "", unicodeCommentExtraField = "", dir = file.dir, date = file.date;
    var dataInfo = {
        crc32: 0,
        compressedSize: 0,
        uncompressedSize: 0
    };
    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo["crc32"];
        dataInfo.compressedSize = streamInfo["compressedSize"];
        dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
    }
    var bitflag = 0;
    if (streamedContent) // Bit 3: the sizes/crc32 are set to zero in the local header.
    // The correct values are put in the data descriptor immediately
    // following the compressed data.
    bitflag |= 0x0008;
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) // Bit 11: Language encoding flag (EFS).
    bitflag |= 0x0800;
    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) // dos or unix, we set the dos dir flag
    extFileAttr |= 0x00010;
    if (platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= $9763850125e04168$var$generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else {
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= $9763850125e04168$var$generateDosExternalFileAttr(file.dosPermissions, dir);
    }
    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;
    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | date.getUTCMonth() + 1;
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();
    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField = // Version
        $9763850125e04168$var$decToHex(1, 1) + // NameCRC32
        $9763850125e04168$var$decToHex($44wFx(encodedFileName), 4) + // UnicodeName
        utfEncodedFileName;
        extraFields += // Info-ZIP Unicode Path Extra Field
        "up" + // size
        $9763850125e04168$var$decToHex(unicodePathExtraField.length, 2) + // content
        unicodePathExtraField;
    }
    if (useUTF8ForComment) {
        unicodeCommentExtraField = // Version
        $9763850125e04168$var$decToHex(1, 1) + // CommentCRC32
        $9763850125e04168$var$decToHex($44wFx(encodedComment), 4) + // UnicodeName
        utfEncodedComment;
        extraFields += // Info-ZIP Unicode Path Extra Field
        "uc" + // size
        $9763850125e04168$var$decToHex(unicodeCommentExtraField.length, 2) + // content
        unicodeCommentExtraField;
    }
    var header = "";
    // version needed to extract
    header += "\n\0";
    // general purpose bit flag
    header += $9763850125e04168$var$decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += $9763850125e04168$var$decToHex(dosTime, 2);
    // last mod file date
    header += $9763850125e04168$var$decToHex(dosDate, 2);
    // crc-32
    header += $9763850125e04168$var$decToHex(dataInfo.crc32, 4);
    // compressed size
    header += $9763850125e04168$var$decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += $9763850125e04168$var$decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += $9763850125e04168$var$decToHex(encodedFileName.length, 2);
    // extra field length
    header += $9763850125e04168$var$decToHex(extraFields.length, 2);
    var fileRecord = $GjXGW.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
    var dirRecord = $GjXGW.CENTRAL_FILE_HEADER + // version made by (00: DOS)
    $9763850125e04168$var$decToHex(versionMadeBy, 2) + // file header (common to file and central directory)
    header + // file comment length
    $9763850125e04168$var$decToHex(encodedComment.length, 2) + // disk number start
    "\0\0" + // internal file attributes TODO
    "\0\0" + // external file attributes
    $9763850125e04168$var$decToHex(extFileAttr, 4) + // relative offset of local header
    $9763850125e04168$var$decToHex(offset, 4) + // file name
    encodedFileName + // extra field
    extraFields + // file comment
    encodedComment;
    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};
/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */ var $9763850125e04168$var$generateCentralDirectoryEnd = function(entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = $eBqgu.transformTo("string", encodeFileName(comment));
    // end of central dir signature
    dirEnd = $GjXGW.CENTRAL_DIRECTORY_END + // number of this disk
    "\0\0" + // number of the disk with the start of the central directory
    "\0\0" + // total number of entries in the central directory on this disk
    $9763850125e04168$var$decToHex(entriesCount, 2) + // total number of entries in the central directory
    $9763850125e04168$var$decToHex(entriesCount, 2) + // size of the central directory   4 bytes
    $9763850125e04168$var$decToHex(centralDirLength, 4) + // offset of start of central directory with respect to the starting disk number
    $9763850125e04168$var$decToHex(localDirLength, 4) + // .ZIP file comment length
    $9763850125e04168$var$decToHex(encodedComment.length, 2) + // .ZIP file comment
    encodedComment;
    return dirEnd;
};
/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing information
 * on the file entry.
 * @return {String} the data descriptors.
 */ var $9763850125e04168$var$generateDataDescriptors = function(streamInfo) {
    var descriptor = "";
    descriptor = $GjXGW.DATA_DESCRIPTOR + // crc-32                          4 bytes
    $9763850125e04168$var$decToHex(streamInfo["crc32"], 4) + // compressed size                 4 bytes
    $9763850125e04168$var$decToHex(streamInfo["compressedSize"], 4) + // uncompressed size               4 bytes
    $9763850125e04168$var$decToHex(streamInfo["uncompressedSize"], 4);
    return descriptor;
};
/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */ function $9763850125e04168$var$ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    $9DhCp.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emitted metadata.
    this.currentFile = null;
    this._sources = [];
}
$eBqgu.inherits($9763850125e04168$var$ZipFileWorker, $9DhCp);
/**
 * @see GenericWorker.push
 */ $9763850125e04168$var$ZipFileWorker.prototype.push = function(chunk) {
    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;
    if (this.accumulate) this.contentBuffer.push(chunk);
    else {
        this.bytesWritten += chunk.data.length;
        $9DhCp.prototype.push.call(this, {
            data: chunk.data,
            meta: {
                currentFile: this.currentFile,
                percent: entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};
/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */ $9763850125e04168$var$ZipFileWorker.prototype.openedSource = function(streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo["file"].name;
    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
    // don't stream folders (because they don't have any content)
    if (streamedContent) {
        var record = $9763850125e04168$var$generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data: record.fileRecord,
            meta: {
                percent: 0
            }
        });
    } else // we need to wait for the whole file before pushing anything
    this.accumulate = true;
};
/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */ $9763850125e04168$var$ZipFileWorker.prototype.closedSource = function(streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
    var record = $9763850125e04168$var$generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
    this.dirRecords.push(record.dirRecord);
    if (streamedContent) // after the streamed file, we put data descriptors
    this.push({
        data: $9763850125e04168$var$generateDataDescriptors(streamInfo),
        meta: {
            percent: 100
        }
    });
    else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data: record.fileRecord,
            meta: {
                percent: 0
            }
        });
        while(this.contentBuffer.length)this.push(this.contentBuffer.shift());
    }
    this.currentFile = null;
};
/**
 * @see GenericWorker.flush
 */ $9763850125e04168$var$ZipFileWorker.prototype.flush = function() {
    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++)this.push({
        data: this.dirRecords[i],
        meta: {
            percent: 100
        }
    });
    var centralDirLength = this.bytesWritten - localDirLength;
    var dirEnd = $9763850125e04168$var$generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);
    this.push({
        data: dirEnd,
        meta: {
            percent: 100
        }
    });
};
/**
 * Prepare the next source to be read.
 */ $9763850125e04168$var$ZipFileWorker.prototype.prepareNextSource = function() {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) this.previous.pause();
    else this.previous.resume();
};
/**
 * @see GenericWorker.registerPrevious
 */ $9763850125e04168$var$ZipFileWorker.prototype.registerPrevious = function(previous) {
    this._sources.push(previous);
    var self = this;
    previous.on("data", function(chunk) {
        self.processChunk(chunk);
    });
    previous.on("end", function() {
        self.closedSource(self.previous.streamInfo);
        if (self._sources.length) self.prepareNextSource();
        else self.end();
    });
    previous.on("error", function(e) {
        self.error(e);
    });
    return this;
};
/**
 * @see GenericWorker.resume
 */ $9763850125e04168$var$ZipFileWorker.prototype.resume = function() {
    if (!$9DhCp.prototype.resume.call(this)) return false;
    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};
/**
 * @see GenericWorker.error
 */ $9763850125e04168$var$ZipFileWorker.prototype.error = function(e) {
    var sources = this._sources;
    if (!$9DhCp.prototype.error.call(this, e)) return false;
    for(var i = 0; i < sources.length; i++)try {
        sources[i].error(e);
    } catch (e) {
    // the `error` exploded, nothing to do
    }
    return true;
};
/**
 * @see GenericWorker.lock
 */ $9763850125e04168$var$ZipFileWorker.prototype.lock = function() {
    $9DhCp.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++)sources[i].lock();
};
module.exports = $9763850125e04168$var$ZipFileWorker;

});
parcelRegister("GjXGW", function(module, exports) {

$parcel$export(module.exports, "LOCAL_FILE_HEADER", () => $07f3685989a22d4e$export$6e3e201e50b851b7, (v) => $07f3685989a22d4e$export$6e3e201e50b851b7 = v);
$parcel$export(module.exports, "CENTRAL_FILE_HEADER", () => $07f3685989a22d4e$export$5588e1f6b81f9a9c, (v) => $07f3685989a22d4e$export$5588e1f6b81f9a9c = v);
$parcel$export(module.exports, "CENTRAL_DIRECTORY_END", () => $07f3685989a22d4e$export$33b9be5cbdbd9c2, (v) => $07f3685989a22d4e$export$33b9be5cbdbd9c2 = v);
$parcel$export(module.exports, "ZIP64_CENTRAL_DIRECTORY_LOCATOR", () => $07f3685989a22d4e$export$c69a45c4e8b4a70e, (v) => $07f3685989a22d4e$export$c69a45c4e8b4a70e = v);
$parcel$export(module.exports, "ZIP64_CENTRAL_DIRECTORY_END", () => $07f3685989a22d4e$export$dce80172db15dc96, (v) => $07f3685989a22d4e$export$dce80172db15dc96 = v);
$parcel$export(module.exports, "DATA_DESCRIPTOR", () => $07f3685989a22d4e$export$bfbee6c5af81e630, (v) => $07f3685989a22d4e$export$bfbee6c5af81e630 = v);
var $07f3685989a22d4e$export$6e3e201e50b851b7;
var $07f3685989a22d4e$export$5588e1f6b81f9a9c;
var $07f3685989a22d4e$export$33b9be5cbdbd9c2;
var $07f3685989a22d4e$export$c69a45c4e8b4a70e;
var $07f3685989a22d4e$export$dce80172db15dc96;
var $07f3685989a22d4e$export$bfbee6c5af81e630;
"use strict";
$07f3685989a22d4e$export$6e3e201e50b851b7 = "PK\x03\x04";
$07f3685989a22d4e$export$5588e1f6b81f9a9c = "PK\x01\x02";
$07f3685989a22d4e$export$33b9be5cbdbd9c2 = "PK\x05\x06";
$07f3685989a22d4e$export$c69a45c4e8b4a70e = "PK\x06\x07";
$07f3685989a22d4e$export$dce80172db15dc96 = "PK\x06\x06";
$07f3685989a22d4e$export$bfbee6c5af81e630 = "PK\x07\b";

});



parcelRegister("axbLj", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $9DhCp = parcelRequire("9DhCp");
/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */ function $7ab61c2a3c5a9a8c$var$NodejsStreamInputAdapter(filename, stream) {
    $9DhCp.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}
$eBqgu.inherits($7ab61c2a3c5a9a8c$var$NodejsStreamInputAdapter, $9DhCp);
/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */ $7ab61c2a3c5a9a8c$var$NodejsStreamInputAdapter.prototype._bindStream = function(stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream.on("data", function(chunk) {
        self.push({
            data: chunk,
            meta: {
                percent: 0
            }
        });
    }).on("error", function(e) {
        if (self.isPaused) this.generatedError = e;
        else self.error(e);
    }).on("end", function() {
        if (self.isPaused) self._upstreamEnded = true;
        else self.end();
    });
};
$7ab61c2a3c5a9a8c$var$NodejsStreamInputAdapter.prototype.pause = function() {
    if (!$9DhCp.prototype.pause.call(this)) return false;
    this._stream.pause();
    return true;
};
$7ab61c2a3c5a9a8c$var$NodejsStreamInputAdapter.prototype.resume = function() {
    if (!$9DhCp.prototype.resume.call(this)) return false;
    if (this._upstreamEnded) this.end();
    else this._stream.resume();
    return true;
};
module.exports = $7ab61c2a3c5a9a8c$var$NodejsStreamInputAdapter;

});


parcelRegister("i71Qm", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $gEpFr = parcelRequire("gEpFr");

var $ggeMD = parcelRequire("ggeMD");

var $eBqgu = parcelRequire("eBqgu");

var $7aqk3 = parcelRequire("7aqk3");

var $7MruG = parcelRequire("7MruG");

var $dppe4 = parcelRequire("dppe4");
/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */ function $d2fa4f8d3779ceb7$var$checkEntryCRC32(zipEntry) {
    return new $gEpFr.Promise(function(resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new $7MruG());
        worker.on("error", function(e) {
            reject(e);
        }).on("end", function() {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) reject(new Error("Corrupted zip : CRC32 mismatch"));
            else resolve();
        }).resume();
    });
}
module.exports = function(data, options) {
    var zip = this;
    options = $eBqgu.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: $ggeMD.utf8decode
    });
    if ($dppe4.isNode && $dppe4.isStream(data)) return $gEpFr.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    return $eBqgu.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64).then(function(data) {
        var zipEntries = new $7aqk3(options);
        zipEntries.load(data);
        return zipEntries;
    }).then(function checkCRC32(zipEntries) {
        var promises = [
            $gEpFr.Promise.resolve(zipEntries)
        ];
        var files = zipEntries.files;
        if (options.checkCRC32) for(var i = 0; i < files.length; i++)promises.push($d2fa4f8d3779ceb7$var$checkEntryCRC32(files[i]));
        return $gEpFr.Promise.all(promises);
    }).then(function addFiles(results) {
        var zipEntries = results.shift();
        var files = zipEntries.files;
        for(var i = 0; i < files.length; i++){
            var input = files[i];
            zip.file(input.fileNameStr, input.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: input.date,
                dir: input.dir,
                comment: input.fileCommentStr.length ? input.fileCommentStr : null,
                unixPermissions: input.unixPermissions,
                dosPermissions: input.dosPermissions,
                createFolders: options.createFolders
            });
        }
        if (zipEntries.zipComment.length) zip.comment = zipEntries.zipComment;
        return zip;
    });
};

});
parcelRegister("7aqk3", function(module, exports) {
"use strict";

var $bHXQs = parcelRequire("bHXQs");

var $eBqgu = parcelRequire("eBqgu");

var $GjXGW = parcelRequire("GjXGW");

var $7WX9a = parcelRequire("7WX9a");
parcelRequire("ggeMD");

var $4Fiik = parcelRequire("4Fiik");
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */ function $537de2a89de401d4$var$ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
$537de2a89de401d4$var$ZipEntries.prototype = {
    /**
     * Check that the reader is on the specified signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */ checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature (" + $eBqgu.pretty(signature) + ", expected " + $eBqgu.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */ isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */ readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);
        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = $4Fiik.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = $eBqgu.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */ readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);
        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44, index = 0, extraFieldId, extraFieldLength, extraFieldValue;
        while(index < extraDataSize){
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */ readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) throw new Error("Multi-volumes zip are not supported");
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */ readLocalFiles: function() {
        var i, file;
        for(i = 0; i < this.files.length; i++){
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature($GjXGW.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */ readCentralDir: function() {
        var file;
        this.reader.setIndex(this.centralDirOffset);
        while(this.reader.readAndCheckSignature($GjXGW.CENTRAL_FILE_HEADER)){
            file = new $7WX9a({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }
        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) // We expected some records but couldn't find ANY.
            // This is really suspicious, as if something went wrong.
            throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
        }
    },
    /**
     * Read the end of central directory.
     */ readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature($GjXGW.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, $GjXGW.LOCAL_FILE_HEADER);
            if (isGarbage) throw new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            else throw new Error("Corrupted zip: can't find end of central directory");
        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature($GjXGW.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();
        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */ if (this.diskNumber === $eBqgu.MAX_VALUE_16BITS || this.diskWithCentralDirStart === $eBqgu.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === $eBqgu.MAX_VALUE_16BITS || this.centralDirRecords === $eBqgu.MAX_VALUE_16BITS || this.centralDirSize === $eBqgu.MAX_VALUE_32BITS || this.centralDirOffset === $eBqgu.MAX_VALUE_32BITS) {
            this.zip64 = true;
            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */ // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature($GjXGW.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            this.reader.setIndex(offset);
            this.checkSignature($GjXGW.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();
            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, $GjXGW.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature($GjXGW.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature($GjXGW.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }
        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */  + this.zip64EndOfCentralSize;
        }
        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, $GjXGW.CENTRAL_FILE_HEADER)) ;
            else // the offset is wrong, update the "zero" of the reader
            // this happens if data has been prepended (crx files for example)
            this.reader.zero = extraBytes;
        } else if (extraBytes < 0) throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
    },
    prepareReader: function(data) {
        this.reader = $bHXQs(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */ load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = $537de2a89de401d4$var$ZipEntries;

});
parcelRegister("bHXQs", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");

var $4Fiik = parcelRequire("4Fiik");

var $6qV5X = parcelRequire("6qV5X");

var $oYrYo = parcelRequire("oYrYo");

var $kazo3 = parcelRequire("kazo3");

var $dSEyA = parcelRequire("dSEyA");
/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */ module.exports = function(data) {
    var type = $eBqgu.getTypeOf(data);
    $eBqgu.checkSupport(type);
    if (type === "string" && !$4Fiik.uint8array) return new $oYrYo(data);
    if (type === "nodebuffer") return new $kazo3(data);
    if ($4Fiik.uint8array) return new $dSEyA($eBqgu.transformTo("uint8array", data));
    return new $6qV5X($eBqgu.transformTo("array", data));
};

});
parcelRegister("6qV5X", function(module, exports) {
"use strict";

var $kfKPO = parcelRequire("kfKPO");

var $eBqgu = parcelRequire("eBqgu");
function $4af175b46bd207d1$var$ArrayReader(data) {
    $kfKPO.call(this, data);
    for(var i = 0; i < this.data.length; i++)data[i] = data[i] & 0xFF;
}
$eBqgu.inherits($4af175b46bd207d1$var$ArrayReader, $kfKPO);
/**
 * @see DataReader.byteAt
 */ $4af175b46bd207d1$var$ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */ $4af175b46bd207d1$var$ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0), sig1 = sig.charCodeAt(1), sig2 = sig.charCodeAt(2), sig3 = sig.charCodeAt(3);
    for(var i = this.length - 4; i >= 0; --i){
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) return i - this.zero;
    }
    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */ $4af175b46bd207d1$var$ArrayReader.prototype.readAndCheckSignature = function(sig) {
    var sig0 = sig.charCodeAt(0), sig1 = sig.charCodeAt(1), sig2 = sig.charCodeAt(2), sig3 = sig.charCodeAt(3), data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */ $4af175b46bd207d1$var$ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if (size === 0) return [];
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = $4af175b46bd207d1$var$ArrayReader;

});
parcelRegister("kfKPO", function(module, exports) {
"use strict";

var $eBqgu = parcelRequire("eBqgu");
function $ebe989be1da4a908$var$DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
$ebe989be1da4a908$var$DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */ checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specified index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */ checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?");
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */ setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */ skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */ byteAt: function(i) {
    // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */ readInt: function(size) {
        var result = 0, i;
        this.checkOffset(size);
        for(i = this.index + size - 1; i >= this.index; i--)result = (result << 8) + this.byteAt(i);
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */ readString: function(size) {
        return $eBqgu.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */ readData: function(size) {
    // see implementations
    },
    /**
     * Find the last occurrence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurrence, -1 if not found.
     */ lastIndexOfSignature: function(sig) {
    // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */ readAndCheckSignature: function(sig) {
    // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */ readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC((dostime >> 25 & 0x7f) + 1980, (dostime >> 21 & 0x0f) - 1, dostime >> 16 & 0x1f, dostime >> 11 & 0x1f, dostime >> 5 & 0x3f, (dostime & 0x1f) << 1)); // second
    }
};
module.exports = $ebe989be1da4a908$var$DataReader;

});


parcelRegister("oYrYo", function(module, exports) {
"use strict";

var $kfKPO = parcelRequire("kfKPO");

var $eBqgu = parcelRequire("eBqgu");
function $04b12226da9bed51$var$StringReader(data) {
    $kfKPO.call(this, data);
}
$eBqgu.inherits($04b12226da9bed51$var$StringReader, $kfKPO);
/**
 * @see DataReader.byteAt
 */ $04b12226da9bed51$var$StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */ $04b12226da9bed51$var$StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */ $04b12226da9bed51$var$StringReader.prototype.readAndCheckSignature = function(sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */ $04b12226da9bed51$var$StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = $04b12226da9bed51$var$StringReader;

});

parcelRegister("kazo3", function(module, exports) {
"use strict";

var $dSEyA = parcelRequire("dSEyA");

var $eBqgu = parcelRequire("eBqgu");
function $eaf030ee3a6b94e4$var$NodeBufferReader(data) {
    $dSEyA.call(this, data);
}
$eBqgu.inherits($eaf030ee3a6b94e4$var$NodeBufferReader, $dSEyA);
/**
 * @see DataReader.readData
 */ $eaf030ee3a6b94e4$var$NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = $eaf030ee3a6b94e4$var$NodeBufferReader;

});
parcelRegister("dSEyA", function(module, exports) {
"use strict";

var $6qV5X = parcelRequire("6qV5X");

var $eBqgu = parcelRequire("eBqgu");
function $a1afc73f1a258c4a$var$Uint8ArrayReader(data) {
    $6qV5X.call(this, data);
}
$eBqgu.inherits($a1afc73f1a258c4a$var$Uint8ArrayReader, $6qV5X);
/**
 * @see DataReader.readData
 */ $a1afc73f1a258c4a$var$Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if (size === 0) // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
    return new Uint8Array(0);
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = $a1afc73f1a258c4a$var$Uint8ArrayReader;

});



parcelRegister("7WX9a", function(module, exports) {
"use strict";

var $bHXQs = parcelRequire("bHXQs");

var $eBqgu = parcelRequire("eBqgu");

var $xDetb = parcelRequire("xDetb");

var $44wFx = parcelRequire("44wFx");

var $ggeMD = parcelRequire("ggeMD");

var $2sj4O = parcelRequire("2sj4O");

var $4Fiik = parcelRequire("4Fiik");
var $5c9bd48010f04f04$var$MADE_BY_DOS = 0x00;
var $5c9bd48010f04f04$var$MADE_BY_UNIX = 0x03;
/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */ var $5c9bd48010f04f04$var$findCompression = function(compressionMethod) {
    for(var method in $2sj4O){
        if (!$2sj4O.hasOwnProperty(method)) continue;
        if ($2sj4O[method].magic === compressionMethod) return $2sj4O[method];
    }
    return null;
};
// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */ function $5c9bd48010f04f04$var$ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
$5c9bd48010f04f04$var$ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */ isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */ useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;
        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);
        if (this.compressedSize === -1 || this.uncompressedSize === -1) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        compression = $5c9bd48010f04f04$var$findCompression(this.compressionMethod);
        if (compression === null) throw new Error("Corrupted zip : compression " + $eBqgu.pretty(this.compressionMethod) + " unknown (inner file : " + $eBqgu.transformTo("string", this.fileName) + ")");
        this.decompressed = new $xDetb(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);
        if (this.isEncrypted()) throw new Error("Encrypted zip are not supported");
        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },
    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */ processAttributes: function() {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;
        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
        if (madeBy === $5c9bd48010f04f04$var$MADE_BY_DOS) // first 6 bits (0 to 5)
        this.dosPermissions = this.externalFileAttributes & 0x3F;
        if (madeBy === $5c9bd48010f04f04$var$MADE_BY_UNIX) this.unixPermissions = this.externalFileAttributes >> 16 & 0xFFFF;
        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === "/") this.dir = true;
    },
    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */ parseZIP64ExtraField: function(reader) {
        if (!this.extraFields[0x0001]) return;
        // should be something, preparing the extra reader
        var extraReader = $bHXQs(this.extraFields[0x0001].value);
        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === $eBqgu.MAX_VALUE_32BITS) this.uncompressedSize = extraReader.readInt(8);
        if (this.compressedSize === $eBqgu.MAX_VALUE_32BITS) this.compressedSize = extraReader.readInt(8);
        if (this.localHeaderOffset === $eBqgu.MAX_VALUE_32BITS) this.localHeaderOffset = extraReader.readInt(8);
        if (this.diskNumberStart === $eBqgu.MAX_VALUE_32BITS) this.diskNumberStart = extraReader.readInt(4);
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength, extraFieldId, extraFieldLength, extraFieldValue;
        if (!this.extraFields) this.extraFields = {};
        while(reader.index < end){
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);
            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */ handleUTF8: function() {
        var decodeParamType = $4Fiik.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = $ggeMD.utf8decode(this.fileName);
            this.fileCommentStr = $ggeMD.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) this.fileNameStr = upath;
            else {
                // ASCII text or unsupported code page
                var fileNameByteArray = $eBqgu.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) this.fileCommentStr = ucomment;
            else {
                // ASCII text or unsupported code page
                var commentByteArray = $eBqgu.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },
    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */ findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = $bHXQs(upathField.value);
            // wrong version
            if (extraReader.readInt(1) !== 1) return null;
            // the crc of the filename changed, this field is out of date.
            if ($44wFx(this.fileName) !== extraReader.readInt(4)) return null;
            return $ggeMD.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },
    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */ findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = $bHXQs(ucommentField.value);
            // wrong version
            if (extraReader.readInt(1) !== 1) return null;
            // the crc of the comment changed, this field is out of date.
            if ($44wFx(this.fileComment) !== extraReader.readInt(4)) return null;
            return $ggeMD.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = $5c9bd48010f04f04$var$ZipEntry;

});



parcelRegister("sBxfj", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $055fbb5a82eb5281$export$307591e98609eddd, (v) => $055fbb5a82eb5281$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $055fbb5a82eb5281$export$eb3a06aef9e6ee51, (v) => $055fbb5a82eb5281$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $055fbb5a82eb5281$export$b23711c915539651, (v) => $055fbb5a82eb5281$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $055fbb5a82eb5281$export$80e7718417253a51, (v) => $055fbb5a82eb5281$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $055fbb5a82eb5281$export$83d89fbfd8236492, (v) => $055fbb5a82eb5281$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $055fbb5a82eb5281$export$307591e98609eddd;
var $055fbb5a82eb5281$export$eb3a06aef9e6ee51;
var $055fbb5a82eb5281$export$b23711c915539651;
var $055fbb5a82eb5281$export$80e7718417253a51;
var $055fbb5a82eb5281$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $055fbb5a82eb5281$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $055fbb5a82eb5281$var$ba = !1;
function $055fbb5a82eb5281$var$m(a, b) {
    $055fbb5a82eb5281$var$ba && ($055fbb5a82eb5281$var$ba = !1, "<" !== b[0] && a.push("<!-- -->"));
    return "<!-- -->" === b ? $055fbb5a82eb5281$var$ba = !0 : a.push(b);
}
var $055fbb5a82eb5281$var$q = Object.prototype.hasOwnProperty, $055fbb5a82eb5281$var$ca = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $055fbb5a82eb5281$var$da = {}, $055fbb5a82eb5281$var$ea = {};
function $055fbb5a82eb5281$var$fa(a) {
    if ($055fbb5a82eb5281$var$q.call($055fbb5a82eb5281$var$ea, a)) return !0;
    if ($055fbb5a82eb5281$var$q.call($055fbb5a82eb5281$var$da, a)) return !1;
    if ($055fbb5a82eb5281$var$ca.test(a)) return $055fbb5a82eb5281$var$ea[a] = !0;
    $055fbb5a82eb5281$var$da[a] = !0;
    return !1;
}
function $055fbb5a82eb5281$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $055fbb5a82eb5281$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $055fbb5a82eb5281$var$ha = /[\-:]([a-z])/g;
function $055fbb5a82eb5281$var$ia(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ha, $055fbb5a82eb5281$var$ia);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ha, $055fbb5a82eb5281$var$ia);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ha, $055fbb5a82eb5281$var$ia);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$055fbb5a82eb5281$var$t.xlinkHref = new $055fbb5a82eb5281$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $055fbb5a82eb5281$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $055fbb5a82eb5281$var$ja = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($055fbb5a82eb5281$var$u).forEach(function(a) {
    $055fbb5a82eb5281$var$ja.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $055fbb5a82eb5281$var$u[b] = $055fbb5a82eb5281$var$u[a];
    });
});
var $055fbb5a82eb5281$var$ka = /["'&<>]/;
function $055fbb5a82eb5281$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $055fbb5a82eb5281$var$ka.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $055fbb5a82eb5281$var$la = /([A-Z])/g, $055fbb5a82eb5281$var$ma = /^ms-/, $055fbb5a82eb5281$var$na = Array.isArray;
function $055fbb5a82eb5281$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $055fbb5a82eb5281$var$oa(a, b, c) {
    switch(b){
        case "select":
            return $055fbb5a82eb5281$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $055fbb5a82eb5281$var$w(2, null);
        case "math":
            return $055fbb5a82eb5281$var$w(3, null);
        case "foreignObject":
            return $055fbb5a82eb5281$var$w(1, null);
        case "table":
            return $055fbb5a82eb5281$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $055fbb5a82eb5281$var$w(5, null);
        case "colgroup":
            return $055fbb5a82eb5281$var$w(7, null);
        case "tr":
            return $055fbb5a82eb5281$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $055fbb5a82eb5281$var$w(1, null) : a;
}
function $055fbb5a82eb5281$var$pa(a, b) {
    "" !== b && a.push($055fbb5a82eb5281$var$v(b), "<!-- -->");
}
var $055fbb5a82eb5281$var$qa = new Map;
function $055fbb5a82eb5281$var$ra(a, b, c) {
    if ("object" !== typeof c) throw Error($055fbb5a82eb5281$var$k(62));
    b = !0;
    for(var d in c)if ($055fbb5a82eb5281$var$q.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $055fbb5a82eb5281$var$v(d);
                f = $055fbb5a82eb5281$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $055fbb5a82eb5281$var$qa.get(e);
                void 0 !== g ? e = g : (g = $055fbb5a82eb5281$var$v(e.replace($055fbb5a82eb5281$var$la, "-$1").toLowerCase().replace($055fbb5a82eb5281$var$ma, "-ms-")), $055fbb5a82eb5281$var$qa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $055fbb5a82eb5281$var$q.call($055fbb5a82eb5281$var$u, d) ? "" + f : f + "px" : $055fbb5a82eb5281$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $055fbb5a82eb5281$var$y(a, b, c, d) {
    switch(c){
        case "style":
            $055fbb5a82eb5281$var$ra(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $055fbb5a82eb5281$var$t.hasOwnProperty(c) ? $055fbb5a82eb5281$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
            }
        } else if ($055fbb5a82eb5281$var$fa(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
        }
    }
}
function $055fbb5a82eb5281$var$A(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($055fbb5a82eb5281$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($055fbb5a82eb5281$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $055fbb5a82eb5281$var$sa(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $055fbb5a82eb5281$var$ta(a, b, c, d) {
    a.push($055fbb5a82eb5281$var$B(c));
    var f = c = null, e;
    for(e in b)if ($055fbb5a82eb5281$var$q.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $055fbb5a82eb5281$var$y(a, d, e, g);
        }
    }
    a.push(">");
    $055fbb5a82eb5281$var$A(a, f, c);
    return "string" === typeof c ? (a.push($055fbb5a82eb5281$var$v(c)), null) : c;
}
var $055fbb5a82eb5281$var$ua = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $055fbb5a82eb5281$var$va = new Map;
function $055fbb5a82eb5281$var$B(a) {
    var b = $055fbb5a82eb5281$var$va.get(a);
    if (void 0 === b) {
        if (!$055fbb5a82eb5281$var$ua.test(a)) throw Error($055fbb5a82eb5281$var$k(65, a));
        b = "<" + a;
        $055fbb5a82eb5281$var$va.set(a, b);
    }
    return b;
}
function $055fbb5a82eb5281$var$wa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($055fbb5a82eb5281$var$B("select"));
            var e = null, g = null;
            for(n in c)if ($055fbb5a82eb5281$var$q.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $055fbb5a82eb5281$var$y(a, d, n, h);
                }
            }
            a.push(">");
            $055fbb5a82eb5281$var$A(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($055fbb5a82eb5281$var$B("option"));
            var l = h = null, p = null;
            var n = null;
            for(e in c)if ($055fbb5a82eb5281$var$q.call(c, e) && (b = c[e], null != b)) switch(e){
                case "children":
                    h = b;
                    break;
                case "selected":
                    p = b;
                    break;
                case "dangerouslySetInnerHTML":
                    n = b;
                    break;
                case "value":
                    l = b;
                default:
                    $055fbb5a82eb5281$var$y(a, d, e, b);
            }
            if (null != g) {
                if (c = null !== l ? "" + l : $055fbb5a82eb5281$var$sa(h), $055fbb5a82eb5281$var$na(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else p && a.push(' selected=""');
            a.push(">");
            $055fbb5a82eb5281$var$A(a, n, h);
            return h;
        case "textarea":
            a.push($055fbb5a82eb5281$var$B("textarea"));
            n = g = e = null;
            for(h in c)if ($055fbb5a82eb5281$var$q.call(c, h) && (l = c[h], null != l)) switch(h){
                case "children":
                    n = l;
                    break;
                case "value":
                    e = l;
                    break;
                case "defaultValue":
                    g = l;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$k(91));
                default:
                    $055fbb5a82eb5281$var$y(a, d, h, l);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($055fbb5a82eb5281$var$k(92));
                if ($055fbb5a82eb5281$var$na(n) && 1 < n.length) throw Error($055fbb5a82eb5281$var$k(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($055fbb5a82eb5281$var$v("" + e));
            return null;
        case "input":
            a.push($055fbb5a82eb5281$var$B("input"));
            l = n = h = e = null;
            for(g in c)if ($055fbb5a82eb5281$var$q.call(c, g) && (p = c[g], null != p)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$k(399, "input"));
                case "defaultChecked":
                    l = p;
                    break;
                case "defaultValue":
                    h = p;
                    break;
                case "checked":
                    n = p;
                    break;
                case "value":
                    e = p;
                    break;
                default:
                    $055fbb5a82eb5281$var$y(a, d, g, p);
            }
            null !== n ? $055fbb5a82eb5281$var$y(a, d, "checked", n) : null !== l && $055fbb5a82eb5281$var$y(a, d, "checked", l);
            null !== e ? $055fbb5a82eb5281$var$y(a, d, "value", e) : null !== h && $055fbb5a82eb5281$var$y(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($055fbb5a82eb5281$var$B("menuitem"));
            for(var z in c)if ($055fbb5a82eb5281$var$q.call(c, z) && (e = c[z], null != e)) switch(z){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$k(400));
                default:
                    $055fbb5a82eb5281$var$y(a, d, z, e);
            }
            a.push(">");
            return null;
        case "listing":
        case "pre":
            a.push($055fbb5a82eb5281$var$B(b));
            g = e = null;
            for(l in c)if ($055fbb5a82eb5281$var$q.call(c, l) && (h = c[l], null != h)) switch(l){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $055fbb5a82eb5281$var$y(a, d, l, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($055fbb5a82eb5281$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($055fbb5a82eb5281$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($055fbb5a82eb5281$var$B(b));
            for(var C in c)if ($055fbb5a82eb5281$var$q.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$k(399, b));
                default:
                    $055fbb5a82eb5281$var$y(a, d, C, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $055fbb5a82eb5281$var$ta(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $055fbb5a82eb5281$var$ta(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $055fbb5a82eb5281$var$ta(a, c, b, d);
            a.push($055fbb5a82eb5281$var$B(b));
            g = e = null;
            for(p in c)if ($055fbb5a82eb5281$var$q.call(c, p) && (h = c[p], null != h)) switch(p){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $055fbb5a82eb5281$var$ra(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $055fbb5a82eb5281$var$fa(p) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", p, '="', $055fbb5a82eb5281$var$v(h), '"');
            }
            a.push(">");
            $055fbb5a82eb5281$var$A(a, g, e);
            return e;
    }
}
function $055fbb5a82eb5281$var$xa(a, b, c) {
    $055fbb5a82eb5281$var$m(a, '<!--$?--><template id="');
    if (null === c) throw Error($055fbb5a82eb5281$var$k(395));
    $055fbb5a82eb5281$var$m(a, c);
    return $055fbb5a82eb5281$var$m(a, '"></template>');
}
function $055fbb5a82eb5281$var$ya(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $055fbb5a82eb5281$var$m(a, '<div hidden id="'), $055fbb5a82eb5281$var$m(a, b.segmentPrefix), b = d.toString(16), $055fbb5a82eb5281$var$m(a, b), $055fbb5a82eb5281$var$m(a, '">');
        case 2:
            return $055fbb5a82eb5281$var$m(a, '<svg aria-hidden="true" style="display:none" id="'), $055fbb5a82eb5281$var$m(a, b.segmentPrefix), b = d.toString(16), $055fbb5a82eb5281$var$m(a, b), $055fbb5a82eb5281$var$m(a, '">');
        case 3:
            return $055fbb5a82eb5281$var$m(a, '<math aria-hidden="true" style="display:none" id="'), $055fbb5a82eb5281$var$m(a, b.segmentPrefix), b = d.toString(16), $055fbb5a82eb5281$var$m(a, b), $055fbb5a82eb5281$var$m(a, '">');
        case 4:
            return $055fbb5a82eb5281$var$m(a, '<table hidden id="'), $055fbb5a82eb5281$var$m(a, b.segmentPrefix), b = d.toString(16), $055fbb5a82eb5281$var$m(a, b), $055fbb5a82eb5281$var$m(a, '">');
        case 5:
            return $055fbb5a82eb5281$var$m(a, '<table hidden><tbody id="'), $055fbb5a82eb5281$var$m(a, b.segmentPrefix), b = d.toString(16), $055fbb5a82eb5281$var$m(a, b), $055fbb5a82eb5281$var$m(a, '">');
        case 6:
            return $055fbb5a82eb5281$var$m(a, '<table hidden><tr id="'), $055fbb5a82eb5281$var$m(a, b.segmentPrefix), b = d.toString(16), $055fbb5a82eb5281$var$m(a, b), $055fbb5a82eb5281$var$m(a, '">');
        case 7:
            return $055fbb5a82eb5281$var$m(a, '<table hidden><colgroup id="'), $055fbb5a82eb5281$var$m(a, b.segmentPrefix), b = d.toString(16), $055fbb5a82eb5281$var$m(a, b), $055fbb5a82eb5281$var$m(a, '">');
        default:
            throw Error($055fbb5a82eb5281$var$k(397));
    }
}
function $055fbb5a82eb5281$var$za(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $055fbb5a82eb5281$var$m(a, "</div>");
        case 2:
            return $055fbb5a82eb5281$var$m(a, "</svg>");
        case 3:
            return $055fbb5a82eb5281$var$m(a, "</math>");
        case 4:
            return $055fbb5a82eb5281$var$m(a, "</table>");
        case 5:
            return $055fbb5a82eb5281$var$m(a, "</tbody></table>");
        case 6:
            return $055fbb5a82eb5281$var$m(a, "</tr></table>");
        case 7:
            return $055fbb5a82eb5281$var$m(a, "</colgroup></table>");
        default:
            throw Error($055fbb5a82eb5281$var$k(397));
    }
}
function $055fbb5a82eb5281$var$Aa(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
var $055fbb5a82eb5281$var$D = Object.assign, $055fbb5a82eb5281$var$Ba = Symbol.for("react.element"), $055fbb5a82eb5281$var$Ca = Symbol.for("react.portal"), $055fbb5a82eb5281$var$Da = Symbol.for("react.fragment"), $055fbb5a82eb5281$var$Ea = Symbol.for("react.strict_mode"), $055fbb5a82eb5281$var$Fa = Symbol.for("react.profiler"), $055fbb5a82eb5281$var$Ga = Symbol.for("react.provider"), $055fbb5a82eb5281$var$Ha = Symbol.for("react.context"), $055fbb5a82eb5281$var$Ia = Symbol.for("react.forward_ref"), $055fbb5a82eb5281$var$Ja = Symbol.for("react.suspense"), $055fbb5a82eb5281$var$Ka = Symbol.for("react.suspense_list"), $055fbb5a82eb5281$var$La = Symbol.for("react.memo"), $055fbb5a82eb5281$var$Ma = Symbol.for("react.lazy"), $055fbb5a82eb5281$var$Na = Symbol.for("react.scope"), $055fbb5a82eb5281$var$Oa = Symbol.for("react.debug_trace_mode"), $055fbb5a82eb5281$var$Pa = Symbol.for("react.legacy_hidden"), $055fbb5a82eb5281$var$Qa = Symbol.for("react.default_value"), $055fbb5a82eb5281$var$Ra = Symbol.iterator;
function $055fbb5a82eb5281$var$Sa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $055fbb5a82eb5281$var$Da:
            return "Fragment";
        case $055fbb5a82eb5281$var$Ca:
            return "Portal";
        case $055fbb5a82eb5281$var$Fa:
            return "Profiler";
        case $055fbb5a82eb5281$var$Ea:
            return "StrictMode";
        case $055fbb5a82eb5281$var$Ja:
            return "Suspense";
        case $055fbb5a82eb5281$var$Ka:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $055fbb5a82eb5281$var$Ha:
            return (a.displayName || "Context") + ".Consumer";
        case $055fbb5a82eb5281$var$Ga:
            return (a._context.displayName || "Context") + ".Provider";
        case $055fbb5a82eb5281$var$Ia:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $055fbb5a82eb5281$var$La:
            return b = a.displayName || null, null !== b ? b : $055fbb5a82eb5281$var$Sa(a.type) || "Memo";
        case $055fbb5a82eb5281$var$Ma:
            b = a._payload;
            a = a._init;
            try {
                return $055fbb5a82eb5281$var$Sa(a(b));
            } catch (c) {}
    }
    return null;
}
var $055fbb5a82eb5281$var$Ta = {};
function $055fbb5a82eb5281$var$Ua(a, b) {
    a = a.contextTypes;
    if (!a) return $055fbb5a82eb5281$var$Ta;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $055fbb5a82eb5281$var$E = null;
function $055fbb5a82eb5281$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($055fbb5a82eb5281$var$k(401));
        } else {
            if (null === c) throw Error($055fbb5a82eb5281$var$k(401));
            $055fbb5a82eb5281$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $055fbb5a82eb5281$var$Va(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $055fbb5a82eb5281$var$Va(a);
}
function $055fbb5a82eb5281$var$Wa(a) {
    var b = a.parent;
    null !== b && $055fbb5a82eb5281$var$Wa(b);
    a.context._currentValue2 = a.value;
}
function $055fbb5a82eb5281$var$Xa(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($055fbb5a82eb5281$var$k(402));
    a.depth === b.depth ? $055fbb5a82eb5281$var$F(a, b) : $055fbb5a82eb5281$var$Xa(a, b);
}
function $055fbb5a82eb5281$var$Ya(a, b) {
    var c = b.parent;
    if (null === c) throw Error($055fbb5a82eb5281$var$k(402));
    a.depth === c.depth ? $055fbb5a82eb5281$var$F(a, c) : $055fbb5a82eb5281$var$Ya(a, c);
    b.context._currentValue2 = b.value;
}
function $055fbb5a82eb5281$var$G(a) {
    var b = $055fbb5a82eb5281$var$E;
    b !== a && (null === b ? $055fbb5a82eb5281$var$Wa(a) : null === a ? $055fbb5a82eb5281$var$Va(b) : b.depth === a.depth ? $055fbb5a82eb5281$var$F(b, a) : b.depth > a.depth ? $055fbb5a82eb5281$var$Xa(b, a) : $055fbb5a82eb5281$var$Ya(b, a), $055fbb5a82eb5281$var$E = a);
}
var $055fbb5a82eb5281$var$Za = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $055fbb5a82eb5281$var$$a(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $055fbb5a82eb5281$var$Za;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $055fbb5a82eb5281$var$D({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $055fbb5a82eb5281$var$Za.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $055fbb5a82eb5281$var$D({}, e, h)) : $055fbb5a82eb5281$var$D(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $055fbb5a82eb5281$var$ab = {
    id: 1,
    overflow: ""
};
function $055fbb5a82eb5281$var$bb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $055fbb5a82eb5281$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $055fbb5a82eb5281$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $055fbb5a82eb5281$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $055fbb5a82eb5281$var$H = Math.clz32 ? Math.clz32 : $055fbb5a82eb5281$var$cb, $055fbb5a82eb5281$var$db = Math.log, $055fbb5a82eb5281$var$eb = Math.LN2;
function $055fbb5a82eb5281$var$cb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($055fbb5a82eb5281$var$db(a) / $055fbb5a82eb5281$var$eb | 0) | 0;
}
function $055fbb5a82eb5281$var$fb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $055fbb5a82eb5281$var$gb = "function" === typeof Object.is ? Object.is : $055fbb5a82eb5281$var$fb, $055fbb5a82eb5281$var$I = null, $055fbb5a82eb5281$var$hb = null, $055fbb5a82eb5281$var$J = null, $055fbb5a82eb5281$var$K = null, $055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$O = null, $055fbb5a82eb5281$var$P = 0;
function $055fbb5a82eb5281$var$Q() {
    if (null === $055fbb5a82eb5281$var$I) throw Error($055fbb5a82eb5281$var$k(321));
    return $055fbb5a82eb5281$var$I;
}
function $055fbb5a82eb5281$var$ib() {
    if (0 < $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $055fbb5a82eb5281$var$jb() {
    null === $055fbb5a82eb5281$var$K ? null === $055fbb5a82eb5281$var$J ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$J = $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$ib()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$J) : null === $055fbb5a82eb5281$var$K.next ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next = $055fbb5a82eb5281$var$ib()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next);
    return $055fbb5a82eb5281$var$K;
}
function $055fbb5a82eb5281$var$kb() {
    $055fbb5a82eb5281$var$hb = $055fbb5a82eb5281$var$I = null;
    $055fbb5a82eb5281$var$M = !1;
    $055fbb5a82eb5281$var$J = null;
    $055fbb5a82eb5281$var$P = 0;
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$O = null;
}
function $055fbb5a82eb5281$var$lb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $055fbb5a82eb5281$var$mb(a, b, c) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$jb();
    if ($055fbb5a82eb5281$var$L) {
        var d = $055fbb5a82eb5281$var$K.queue;
        b = d.dispatch;
        if (null !== $055fbb5a82eb5281$var$O && (c = $055fbb5a82eb5281$var$O.get(d), void 0 !== c)) {
            $055fbb5a82eb5281$var$O.delete(d);
            d = $055fbb5a82eb5281$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $055fbb5a82eb5281$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $055fbb5a82eb5281$var$K.memoizedState,
            b
        ];
    }
    a = a === $055fbb5a82eb5281$var$lb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $055fbb5a82eb5281$var$K.memoizedState = a;
    a = $055fbb5a82eb5281$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $055fbb5a82eb5281$var$nb.bind(null, $055fbb5a82eb5281$var$I, a);
    return [
        $055fbb5a82eb5281$var$K.memoizedState,
        a
    ];
}
function $055fbb5a82eb5281$var$ob(a, b) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$jb();
    b = void 0 === b ? null : b;
    if (null !== $055fbb5a82eb5281$var$K) {
        var c = $055fbb5a82eb5281$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$055fbb5a82eb5281$var$gb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $055fbb5a82eb5281$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $055fbb5a82eb5281$var$nb(a, b, c) {
    if (25 <= $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$k(301));
    if (a === $055fbb5a82eb5281$var$I) {
        if ($055fbb5a82eb5281$var$M = !0, a = {
            action: c,
            next: null
        }, null === $055fbb5a82eb5281$var$O && ($055fbb5a82eb5281$var$O = new Map), c = $055fbb5a82eb5281$var$O.get(b), void 0 === c) $055fbb5a82eb5281$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $055fbb5a82eb5281$var$pb() {
    throw Error($055fbb5a82eb5281$var$k(394));
}
function $055fbb5a82eb5281$var$R() {}
var $055fbb5a82eb5281$var$qb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a._currentValue2;
    },
    useMemo: $055fbb5a82eb5281$var$ob,
    useReducer: $055fbb5a82eb5281$var$mb,
    useRef: function(a) {
        $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
        $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$jb();
        var b = $055fbb5a82eb5281$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $055fbb5a82eb5281$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $055fbb5a82eb5281$var$mb($055fbb5a82eb5281$var$lb, a);
    },
    useInsertionEffect: $055fbb5a82eb5281$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $055fbb5a82eb5281$var$ob(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $055fbb5a82eb5281$var$R,
    useEffect: $055fbb5a82eb5281$var$R,
    useDebugValue: $055fbb5a82eb5281$var$R,
    useDeferredValue: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a;
    },
    useTransition: function() {
        $055fbb5a82eb5281$var$Q();
        return [
            !1,
            $055fbb5a82eb5281$var$pb
        ];
    },
    useId: function() {
        var a = $055fbb5a82eb5281$var$hb.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $055fbb5a82eb5281$var$H(a) - 1)).toString(32) + b;
        var c = $055fbb5a82eb5281$var$S;
        if (null === c) throw Error($055fbb5a82eb5281$var$k(404));
        b = $055fbb5a82eb5281$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $055fbb5a82eb5281$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($055fbb5a82eb5281$var$k(407));
        return c();
    }
}, $055fbb5a82eb5281$var$S = null, $055fbb5a82eb5281$var$rb = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $055fbb5a82eb5281$var$sb(a) {
    console.error(a);
}
function $055fbb5a82eb5281$var$T() {}
function $055fbb5a82eb5281$var$tb(a, b, c, d, f, e, g, h, l) {
    var p = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: p,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $055fbb5a82eb5281$var$sb : f,
        onAllReady: void 0 === e ? $055fbb5a82eb5281$var$T : e,
        onShellReady: void 0 === g ? $055fbb5a82eb5281$var$T : g,
        onShellError: void 0 === h ? $055fbb5a82eb5281$var$T : h,
        onFatalError: void 0 === l ? $055fbb5a82eb5281$var$T : l
    };
    c = $055fbb5a82eb5281$var$U(b, 0, null, c);
    c.parentFlushed = !0;
    a = $055fbb5a82eb5281$var$ub(b, a, null, c, n, $055fbb5a82eb5281$var$Ta, null, $055fbb5a82eb5281$var$ab);
    p.push(a);
    return b;
}
function $055fbb5a82eb5281$var$ub(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var l = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(l);
            1 === b.length && $055fbb5a82eb5281$var$vb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(l);
    return l;
}
function $055fbb5a82eb5281$var$U(a, b, c, d) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c
    };
}
function $055fbb5a82eb5281$var$V(a, b) {
    a = a.onError;
    a(b);
}
function $055fbb5a82eb5281$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $055fbb5a82eb5281$var$wb(a, b, c, d, f) {
    $055fbb5a82eb5281$var$I = {};
    $055fbb5a82eb5281$var$hb = b;
    $055fbb5a82eb5281$var$N = 0;
    for(a = c(d, f); $055fbb5a82eb5281$var$M;)$055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$P += 1, $055fbb5a82eb5281$var$K = null, a = c(d, f);
    $055fbb5a82eb5281$var$kb();
    return a;
}
function $055fbb5a82eb5281$var$xb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($055fbb5a82eb5281$var$k(108, $055fbb5a82eb5281$var$Sa(d) || "Unknown", h));
            d = $055fbb5a82eb5281$var$D({}, g, c);
        }
        b.legacyContext = d;
        $055fbb5a82eb5281$var$X(a, b, f);
        b.legacyContext = g;
    } else $055fbb5a82eb5281$var$X(a, b, f);
}
function $055fbb5a82eb5281$var$yb(a, b) {
    if (a && a.defaultProps) {
        b = $055fbb5a82eb5281$var$D({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $055fbb5a82eb5281$var$zb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $055fbb5a82eb5281$var$Ua(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $055fbb5a82eb5281$var$$a(e, c, d, f);
            $055fbb5a82eb5281$var$xb(a, b, e, c);
        } else {
            e = $055fbb5a82eb5281$var$Ua(c, b.legacyContext);
            f = $055fbb5a82eb5281$var$wb(a, b, c, d, e);
            var g = 0 !== $055fbb5a82eb5281$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $055fbb5a82eb5281$var$$a(f, c, d, e), $055fbb5a82eb5281$var$xb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $055fbb5a82eb5281$var$bb(d, 1, 0);
                try {
                    $055fbb5a82eb5281$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $055fbb5a82eb5281$var$X(a, b, f);
        }
    } else if ("string" === typeof c) switch(f = b.blockedSegment, e = $055fbb5a82eb5281$var$wa(f.chunks, c, d, a.responseState, f.formatContext), g = f.formatContext, f.formatContext = $055fbb5a82eb5281$var$oa(g, c, d), $055fbb5a82eb5281$var$Ab(a, b, e), f.formatContext = g, c){
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            break;
        default:
            f.chunks.push("</", c, ">");
    }
    else {
        switch(c){
            case $055fbb5a82eb5281$var$Pa:
            case $055fbb5a82eb5281$var$Oa:
            case $055fbb5a82eb5281$var$Ea:
            case $055fbb5a82eb5281$var$Fa:
            case $055fbb5a82eb5281$var$Da:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Ka:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Na:
                throw Error($055fbb5a82eb5281$var$k(343));
            case $055fbb5a82eb5281$var$Ja:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g
                    }, l = $055fbb5a82eb5281$var$U(a, f.chunks.length, h, f.formatContext);
                    f.children.push(l);
                    var p = $055fbb5a82eb5281$var$U(a, 0, null, f.formatContext);
                    p.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = p;
                    try {
                        if ($055fbb5a82eb5281$var$Ab(a, b, d), p.status = 1, $055fbb5a82eb5281$var$Y(h, p), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        p.status = 4, $055fbb5a82eb5281$var$V(a, n), h.forceClientRender = !0;
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $055fbb5a82eb5281$var$ub(a, e, c, l, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Ia:
                d = $055fbb5a82eb5281$var$wb(a, b, c.render, d, f);
                if (0 !== $055fbb5a82eb5281$var$N) {
                    c = b.treeContext;
                    b.treeContext = $055fbb5a82eb5281$var$bb(c, 1, 0);
                    try {
                        $055fbb5a82eb5281$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$La:
                c = c.type;
                d = $055fbb5a82eb5281$var$yb(c, d);
                $055fbb5a82eb5281$var$zb(a, b, c, d, f);
                return;
            case $055fbb5a82eb5281$var$Ga:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $055fbb5a82eb5281$var$E;
                $055fbb5a82eb5281$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $055fbb5a82eb5281$var$X(a, b, f);
                a = $055fbb5a82eb5281$var$E;
                if (null === a) throw Error($055fbb5a82eb5281$var$k(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $055fbb5a82eb5281$var$Qa ? a.context._defaultValue : d;
                a = $055fbb5a82eb5281$var$E = a.parent;
                b.context = a;
                return;
            case $055fbb5a82eb5281$var$Ha:
                d = d.children;
                d = d(c._currentValue2);
                $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$Ma:
                f = c._init;
                c = f(c._payload);
                d = $055fbb5a82eb5281$var$yb(c, d);
                $055fbb5a82eb5281$var$zb(a, b, c, d, void 0);
                return;
        }
        throw Error($055fbb5a82eb5281$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $055fbb5a82eb5281$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Ba:
                $055fbb5a82eb5281$var$zb(a, b, c.type, c.props, c.ref);
                return;
            case $055fbb5a82eb5281$var$Ca:
                throw Error($055fbb5a82eb5281$var$k(257));
            case $055fbb5a82eb5281$var$Ma:
                var d = c._init;
                c = d(c._payload);
                $055fbb5a82eb5281$var$X(a, b, c);
                return;
        }
        if ($055fbb5a82eb5281$var$na(c)) {
            $055fbb5a82eb5281$var$Bb(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $055fbb5a82eb5281$var$Ra && c[$055fbb5a82eb5281$var$Ra] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $055fbb5a82eb5281$var$Bb(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($055fbb5a82eb5281$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (b = b.blockedSegment.chunks, a.responseState.generateStaticMarkup ? b.push($055fbb5a82eb5281$var$v(c)) : $055fbb5a82eb5281$var$pa(b, c)) : "number" === typeof c && (b = b.blockedSegment.chunks, c = "" + c, a.responseState.generateStaticMarkup ? b.push($055fbb5a82eb5281$var$v(c)) : $055fbb5a82eb5281$var$pa(b, c));
}
function $055fbb5a82eb5281$var$Bb(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $055fbb5a82eb5281$var$bb(e, d, f);
        try {
            $055fbb5a82eb5281$var$Ab(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $055fbb5a82eb5281$var$Ab(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $055fbb5a82eb5281$var$X(a, b, c);
    } catch (l) {
        if ($055fbb5a82eb5281$var$kb(), "object" === typeof l && null !== l && "function" === typeof l.then) {
            c = l;
            var g = b.blockedSegment, h = $055fbb5a82eb5281$var$U(a, g.chunks.length, null, g.formatContext);
            g.children.push(h);
            a = $055fbb5a82eb5281$var$ub(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $055fbb5a82eb5281$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $055fbb5a82eb5281$var$G(e), l;
    }
}
function $055fbb5a82eb5281$var$Cb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $055fbb5a82eb5281$var$Db(this, b, a);
}
function $055fbb5a82eb5281$var$Eb(a) {
    var b = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === b ? (this.allPendingTasks--, 2 !== this.status && (this.status = 2, null !== this.destination && this.destination.push(null))) : (b.pendingTasks--, b.forceClientRender || (b.forceClientRender = !0, b.parentFlushed && this.clientRenderedBoundaries.push(b)), b.fallbackAbortableTasks.forEach($055fbb5a82eb5281$var$Eb, this), b.fallbackAbortableTasks.clear(), this.allPendingTasks--, 0 === this.allPendingTasks && (a = this.onAllReady, a()));
}
function $055fbb5a82eb5281$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $055fbb5a82eb5281$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $055fbb5a82eb5281$var$Db(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($055fbb5a82eb5281$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $055fbb5a82eb5281$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $055fbb5a82eb5281$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($055fbb5a82eb5281$var$Cb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($055fbb5a82eb5281$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $055fbb5a82eb5281$var$vb(a) {
    if (2 !== a.status) {
        var b = $055fbb5a82eb5281$var$E, c = $055fbb5a82eb5281$var$rb.current;
        $055fbb5a82eb5281$var$rb.current = $055fbb5a82eb5281$var$qb;
        var d = $055fbb5a82eb5281$var$S;
        $055fbb5a82eb5281$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, l = g.blockedSegment;
                if (0 === l.status) {
                    $055fbb5a82eb5281$var$G(g.context);
                    try {
                        $055fbb5a82eb5281$var$X(h, g, g.node), g.abortSet.delete(g), l.status = 1, $055fbb5a82eb5281$var$Db(h, g.blockedBoundary, l);
                    } catch (x) {
                        if ($055fbb5a82eb5281$var$kb(), "object" === typeof x && null !== x && "function" === typeof x.then) {
                            var p = g.ping;
                            x.then(p, p);
                        } else {
                            g.abortSet.delete(g);
                            l.status = 4;
                            var n = g.blockedBoundary, z = x;
                            $055fbb5a82eb5281$var$V(h, z);
                            null === n ? $055fbb5a82eb5281$var$W(h, z) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var C = h.onAllReady;
                                C();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $055fbb5a82eb5281$var$Fb(a, a.destination);
        } catch (x) {
            $055fbb5a82eb5281$var$V(a, x), $055fbb5a82eb5281$var$W(a, x);
        } finally{
            $055fbb5a82eb5281$var$S = d, $055fbb5a82eb5281$var$rb.current = c, c === $055fbb5a82eb5281$var$qb && $055fbb5a82eb5281$var$G(b);
        }
    }
}
function $055fbb5a82eb5281$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            a = a.responseState;
            $055fbb5a82eb5281$var$m(b, '<template id="');
            $055fbb5a82eb5281$var$m(b, a.placeholderPrefix);
            a = d.toString(16);
            $055fbb5a82eb5281$var$m(b, a);
            return $055fbb5a82eb5281$var$m(b, '"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$055fbb5a82eb5281$var$m(b, d[e]);
                f = $055fbb5a82eb5281$var$Gb(a, b, f);
            }
            for(; e < d.length - 1; e++)$055fbb5a82eb5281$var$m(b, d[e]);
            e < d.length && (f = $055fbb5a82eb5281$var$m(b, d[e]));
            return f;
        default:
            throw Error($055fbb5a82eb5281$var$k(390));
    }
}
function $055fbb5a82eb5281$var$Gb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $055fbb5a82eb5281$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || $055fbb5a82eb5281$var$m(b, "<!--$!-->"), $055fbb5a82eb5281$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : $055fbb5a82eb5281$var$m(b, "<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $055fbb5a82eb5281$var$xa(b, a.responseState, d);
        $055fbb5a82eb5281$var$Z(a, b, c);
        return $055fbb5a82eb5281$var$m(b, "<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $055fbb5a82eb5281$var$xa(b, a.responseState, d.id), $055fbb5a82eb5281$var$Z(a, b, c), $055fbb5a82eb5281$var$m(b, "<!--/$-->");
    a.responseState.generateStaticMarkup || $055fbb5a82eb5281$var$m(b, "<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($055fbb5a82eb5281$var$k(391));
    $055fbb5a82eb5281$var$Gb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : $055fbb5a82eb5281$var$m(b, "<!--/$-->");
    return a;
}
function $055fbb5a82eb5281$var$Hb(a, b, c) {
    $055fbb5a82eb5281$var$ya(b, a.responseState, c.formatContext, c.id);
    $055fbb5a82eb5281$var$Gb(a, b, c);
    return $055fbb5a82eb5281$var$za(b, c.formatContext);
}
function $055fbb5a82eb5281$var$Ib(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$055fbb5a82eb5281$var$Jb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $055fbb5a82eb5281$var$m(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $055fbb5a82eb5281$var$m(b, '$RC("') : (a.sentCompleteBoundaryFunction = !0, $055fbb5a82eb5281$var$m(b, 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($055fbb5a82eb5281$var$k(395));
    c = c.toString(16);
    $055fbb5a82eb5281$var$m(b, d);
    $055fbb5a82eb5281$var$m(b, '","');
    $055fbb5a82eb5281$var$m(b, a.segmentPrefix);
    $055fbb5a82eb5281$var$m(b, c);
    return $055fbb5a82eb5281$var$m(b, '")</script>');
}
function $055fbb5a82eb5281$var$Jb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($055fbb5a82eb5281$var$k(392));
        return $055fbb5a82eb5281$var$Hb(a, b, d);
    }
    $055fbb5a82eb5281$var$Hb(a, b, d);
    a = a.responseState;
    $055fbb5a82eb5281$var$m(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $055fbb5a82eb5281$var$m(b, '$RS("') : (a.sentCompleteSegmentFunction = !0, $055fbb5a82eb5281$var$m(b, 'function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    $055fbb5a82eb5281$var$m(b, a.segmentPrefix);
    f = f.toString(16);
    $055fbb5a82eb5281$var$m(b, f);
    $055fbb5a82eb5281$var$m(b, '","');
    $055fbb5a82eb5281$var$m(b, a.placeholderPrefix);
    $055fbb5a82eb5281$var$m(b, f);
    return $055fbb5a82eb5281$var$m(b, '")</script>');
}
function $055fbb5a82eb5281$var$Fb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $055fbb5a82eb5281$var$Gb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$055fbb5a82eb5281$var$m(b, d[c]);
            c < d.length && $055fbb5a82eb5281$var$m(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            d = b;
            var g = a.responseState, h = f[e].id;
            $055fbb5a82eb5281$var$m(d, g.startInlineScript);
            g.sentClientRenderFunction ? $055fbb5a82eb5281$var$m(d, '$RX("') : (g.sentClientRenderFunction = !0, $055fbb5a82eb5281$var$m(d, 'function $RX(a){if(a=document.getElementById(a))a=a.previousSibling,a.data="$!",a._reactRetry&&a._reactRetry()};$RX("'));
            if (null === h) throw Error($055fbb5a82eb5281$var$k(395));
            $055fbb5a82eb5281$var$m(d, h);
            if (!$055fbb5a82eb5281$var$m(d, '")</script>')) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var l = a.completedBoundaries;
        for(e = 0; e < l.length; e++)if (!$055fbb5a82eb5281$var$Ib(a, b, l[e])) {
            a.destination = null;
            e++;
            l.splice(0, e);
            return;
        }
        l.splice(0, e);
        var p = a.partialBoundaries;
        for(e = 0; e < p.length; e++){
            var n = p[e];
            a: {
                f = a;
                g = b;
                var z = n.completedSegments;
                for(h = 0; h < z.length; h++)if (!$055fbb5a82eb5281$var$Jb(f, g, n, z[h])) {
                    h++;
                    z.splice(0, h);
                    var C = !1;
                    break a;
                }
                z.splice(0, h);
                C = !0;
            }
            if (!C) {
                a.destination = null;
                e++;
                p.splice(0, e);
                return;
            }
        }
        p.splice(0, e);
        var x = a.completedBoundaries;
        for(e = 0; e < x.length; e++)if (!$055fbb5a82eb5281$var$Ib(a, b, x[e])) {
            a.destination = null;
            e++;
            x.splice(0, e);
            return;
        }
        x.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $055fbb5a82eb5281$var$Kb(a) {
    try {
        var b = a.abortableTasks;
        b.forEach($055fbb5a82eb5281$var$Eb, a);
        b.clear();
        null !== a.destination && $055fbb5a82eb5281$var$Fb(a, a.destination);
    } catch (c) {
        $055fbb5a82eb5281$var$V(a, c), $055fbb5a82eb5281$var$W(a, c);
    }
}
function $055fbb5a82eb5281$var$Lb() {}
function $055fbb5a82eb5281$var$Mb(a, b, c) {
    var d = !1, f = null, e = "", g = {
        push: function(a) {
            null !== a && (e += a);
            return !0;
        },
        destroy: function(a) {
            d = !0;
            f = a;
        }
    }, h = !1;
    a = $055fbb5a82eb5281$var$tb(a, $055fbb5a82eb5281$var$Aa(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $055fbb5a82eb5281$var$Lb, void 0, function() {
        h = !0;
    }, void 0, void 0);
    $055fbb5a82eb5281$var$vb(a);
    $055fbb5a82eb5281$var$Kb(a);
    if (1 === a.status) a.status = 2, g.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = g;
        try {
            $055fbb5a82eb5281$var$Fb(a, g);
        } catch (l) {
            $055fbb5a82eb5281$var$V(a, l), $055fbb5a82eb5281$var$W(a, l);
        }
    }
    if (d) throw f;
    if (!h) throw Error($055fbb5a82eb5281$var$k(426));
    return e;
}
$055fbb5a82eb5281$export$307591e98609eddd = function() {
    throw Error($055fbb5a82eb5281$var$k(207));
};
$055fbb5a82eb5281$export$eb3a06aef9e6ee51 = function(a, b) {
    return $055fbb5a82eb5281$var$Mb(a, b, !0);
};
$055fbb5a82eb5281$export$b23711c915539651 = function() {
    throw Error($055fbb5a82eb5281$var$k(208));
};
$055fbb5a82eb5281$export$80e7718417253a51 = function(a, b) {
    return $055fbb5a82eb5281$var$Mb(a, b, !1);
};
$055fbb5a82eb5281$export$83d89fbfd8236492 = "18.1.0";

});

parcelRegister("3odmW", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $277dfbc9b64034b1$export$7020a3240b287705, (v) => $277dfbc9b64034b1$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $277dfbc9b64034b1$export$83d89fbfd8236492, (v) => $277dfbc9b64034b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $277dfbc9b64034b1$export$7020a3240b287705;
var $277dfbc9b64034b1$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $277dfbc9b64034b1$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0;
function $277dfbc9b64034b1$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0), a.enqueue(b);
        else {
            var c = $277dfbc9b64034b1$var$l.length - $277dfbc9b64034b1$var$n;
            c < b.length && (0 === c ? a.enqueue($277dfbc9b64034b1$var$l) : ($277dfbc9b64034b1$var$l.set(b.subarray(0, c), $277dfbc9b64034b1$var$n), a.enqueue($277dfbc9b64034b1$var$l), b = b.subarray(c)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0);
            $277dfbc9b64034b1$var$l.set(b, $277dfbc9b64034b1$var$n);
            $277dfbc9b64034b1$var$n += b.length;
        }
    }
}
function $277dfbc9b64034b1$var$t(a, b) {
    $277dfbc9b64034b1$var$p(a, b);
    return !0;
}
function $277dfbc9b64034b1$var$ba(a) {
    $277dfbc9b64034b1$var$l && 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0);
}
var $277dfbc9b64034b1$var$ca = new TextEncoder;
function $277dfbc9b64034b1$var$u(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$v(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $277dfbc9b64034b1$var$w = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $277dfbc9b64034b1$var$fa = {}, $277dfbc9b64034b1$var$ha = {};
function $277dfbc9b64034b1$var$ia(a) {
    if ($277dfbc9b64034b1$var$w.call($277dfbc9b64034b1$var$ha, a)) return !0;
    if ($277dfbc9b64034b1$var$w.call($277dfbc9b64034b1$var$fa, a)) return !1;
    if ($277dfbc9b64034b1$var$ea.test(a)) return $277dfbc9b64034b1$var$ha[a] = !0;
    $277dfbc9b64034b1$var$fa[a] = !0;
    return !1;
}
function $277dfbc9b64034b1$var$x(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $277dfbc9b64034b1$var$y = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $277dfbc9b64034b1$var$y[b] = new $277dfbc9b64034b1$var$x(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $277dfbc9b64034b1$var$ja = /[\-:]([a-z])/g;
function $277dfbc9b64034b1$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$y[b] = new $277dfbc9b64034b1$var$x(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$y[b] = new $277dfbc9b64034b1$var$x(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$y[b] = new $277dfbc9b64034b1$var$x(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$277dfbc9b64034b1$var$y.xlinkHref = new $277dfbc9b64034b1$var$x("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $277dfbc9b64034b1$var$y[a] = new $277dfbc9b64034b1$var$x(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $277dfbc9b64034b1$var$z = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $277dfbc9b64034b1$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($277dfbc9b64034b1$var$z).forEach(function(a) {
    $277dfbc9b64034b1$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $277dfbc9b64034b1$var$z[b] = $277dfbc9b64034b1$var$z[a];
    });
});
var $277dfbc9b64034b1$var$ma = /["'&<>]/;
function $277dfbc9b64034b1$var$A(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $277dfbc9b64034b1$var$ma.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $277dfbc9b64034b1$var$na = /([A-Z])/g, $277dfbc9b64034b1$var$oa = /^ms-/, $277dfbc9b64034b1$var$pa = Array.isArray, $277dfbc9b64034b1$var$qa = $277dfbc9b64034b1$var$v("<script>"), $277dfbc9b64034b1$var$ra = $277dfbc9b64034b1$var$v("</script>"), $277dfbc9b64034b1$var$sa = $277dfbc9b64034b1$var$v('<script src="'), $277dfbc9b64034b1$var$ta = $277dfbc9b64034b1$var$v('<script type="module" src="'), $277dfbc9b64034b1$var$ua = $277dfbc9b64034b1$var$v('" async=""></script>'), $277dfbc9b64034b1$var$va = /(<\/|<)(s)(cript)/gi;
function $277dfbc9b64034b1$var$wa(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $277dfbc9b64034b1$var$xa(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $277dfbc9b64034b1$var$qa : $277dfbc9b64034b1$var$v('<script nonce="' + $277dfbc9b64034b1$var$A(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $277dfbc9b64034b1$var$u(("" + c).replace($277dfbc9b64034b1$var$va, $277dfbc9b64034b1$var$wa)), $277dfbc9b64034b1$var$ra);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($277dfbc9b64034b1$var$sa, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(d[c])), $277dfbc9b64034b1$var$ua);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($277dfbc9b64034b1$var$ta, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(f[d])), $277dfbc9b64034b1$var$ua);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $277dfbc9b64034b1$var$v(a + "P:"),
        segmentPrefix: $277dfbc9b64034b1$var$v(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $277dfbc9b64034b1$var$B(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $277dfbc9b64034b1$var$ya(a) {
    return $277dfbc9b64034b1$var$B("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $277dfbc9b64034b1$var$za(a, b, c) {
    switch(b){
        case "select":
            return $277dfbc9b64034b1$var$B(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $277dfbc9b64034b1$var$B(2, null);
        case "math":
            return $277dfbc9b64034b1$var$B(3, null);
        case "foreignObject":
            return $277dfbc9b64034b1$var$B(1, null);
        case "table":
            return $277dfbc9b64034b1$var$B(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $277dfbc9b64034b1$var$B(5, null);
        case "colgroup":
            return $277dfbc9b64034b1$var$B(7, null);
        case "tr":
            return $277dfbc9b64034b1$var$B(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $277dfbc9b64034b1$var$B(1, null) : a;
}
var $277dfbc9b64034b1$var$Aa = $277dfbc9b64034b1$var$v("<!-- -->"), $277dfbc9b64034b1$var$Ba = new Map, $277dfbc9b64034b1$var$Ca = $277dfbc9b64034b1$var$v(' style="'), $277dfbc9b64034b1$var$Da = $277dfbc9b64034b1$var$v(":"), $277dfbc9b64034b1$var$Ea = $277dfbc9b64034b1$var$v(";");
function $277dfbc9b64034b1$var$Fa(a, b, c) {
    if ("object" !== typeof c) throw Error($277dfbc9b64034b1$var$k(62));
    b = !0;
    for(var d in c)if ($277dfbc9b64034b1$var$w.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(d));
                f = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(("" + f).trim()));
            } else {
                e = d;
                var g = $277dfbc9b64034b1$var$Ba.get(e);
                void 0 !== g ? e = g : (g = $277dfbc9b64034b1$var$v($277dfbc9b64034b1$var$A(e.replace($277dfbc9b64034b1$var$na, "-$1").toLowerCase().replace($277dfbc9b64034b1$var$oa, "-ms-"))), $277dfbc9b64034b1$var$Ba.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $277dfbc9b64034b1$var$w.call($277dfbc9b64034b1$var$z, d) ? $277dfbc9b64034b1$var$u("" + f) : $277dfbc9b64034b1$var$u(f + "px") : $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(("" + f).trim()));
            }
            b ? (b = !1, a.push($277dfbc9b64034b1$var$Ca, e, $277dfbc9b64034b1$var$Da, f)) : a.push($277dfbc9b64034b1$var$Ea, e, $277dfbc9b64034b1$var$Da, f);
        }
    }
    b || a.push($277dfbc9b64034b1$var$D);
}
var $277dfbc9b64034b1$var$G = $277dfbc9b64034b1$var$v(" "), $277dfbc9b64034b1$var$H = $277dfbc9b64034b1$var$v('="'), $277dfbc9b64034b1$var$D = $277dfbc9b64034b1$var$v('"'), $277dfbc9b64034b1$var$Ga = $277dfbc9b64034b1$var$v('=""');
function $277dfbc9b64034b1$var$I(a, b, c, d) {
    switch(c){
        case "style":
            $277dfbc9b64034b1$var$Fa(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $277dfbc9b64034b1$var$y.hasOwnProperty(c) ? $277dfbc9b64034b1$var$y[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $277dfbc9b64034b1$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($277dfbc9b64034b1$var$G, c, $277dfbc9b64034b1$var$Ga);
                    break;
                case 4:
                    !0 === d ? a.push($277dfbc9b64034b1$var$G, c, $277dfbc9b64034b1$var$Ga) : !1 !== d && a.push($277dfbc9b64034b1$var$G, c, $277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(d)), $277dfbc9b64034b1$var$D);
                    break;
                case 5:
                    isNaN(d) || a.push($277dfbc9b64034b1$var$G, c, $277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(d)), $277dfbc9b64034b1$var$D);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($277dfbc9b64034b1$var$G, c, $277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(d)), $277dfbc9b64034b1$var$D);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($277dfbc9b64034b1$var$G, c, $277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(d)), $277dfbc9b64034b1$var$D);
            }
        } else if ($277dfbc9b64034b1$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($277dfbc9b64034b1$var$G, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(d)), $277dfbc9b64034b1$var$D);
        }
    }
}
var $277dfbc9b64034b1$var$J = $277dfbc9b64034b1$var$v(">"), $277dfbc9b64034b1$var$Ha = $277dfbc9b64034b1$var$v("/>");
function $277dfbc9b64034b1$var$K(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($277dfbc9b64034b1$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($277dfbc9b64034b1$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($277dfbc9b64034b1$var$u("" + b));
    }
}
function $277dfbc9b64034b1$var$Ia(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $277dfbc9b64034b1$var$Ja = $277dfbc9b64034b1$var$v(' selected=""');
function $277dfbc9b64034b1$var$Ka(a, b, c, d) {
    a.push($277dfbc9b64034b1$var$L(c));
    var f = c = null, e;
    for(e in b)if ($277dfbc9b64034b1$var$w.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $277dfbc9b64034b1$var$I(a, d, e, g);
        }
    }
    a.push($277dfbc9b64034b1$var$J);
    $277dfbc9b64034b1$var$K(a, f, c);
    return "string" === typeof c ? (a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(c))), null) : c;
}
var $277dfbc9b64034b1$var$La = $277dfbc9b64034b1$var$v("\n"), $277dfbc9b64034b1$var$Ma = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $277dfbc9b64034b1$var$Na = new Map;
function $277dfbc9b64034b1$var$L(a) {
    var b = $277dfbc9b64034b1$var$Na.get(a);
    if (void 0 === b) {
        if (!$277dfbc9b64034b1$var$Ma.test(a)) throw Error($277dfbc9b64034b1$var$k(65, a));
        b = $277dfbc9b64034b1$var$v("<" + a);
        $277dfbc9b64034b1$var$Na.set(a, b);
    }
    return b;
}
var $277dfbc9b64034b1$var$Oa = $277dfbc9b64034b1$var$v("<!DOCTYPE html>");
function $277dfbc9b64034b1$var$Pa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($277dfbc9b64034b1$var$L("select"));
            var e = null, g = null;
            for(r in c)if ($277dfbc9b64034b1$var$w.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $277dfbc9b64034b1$var$I(a, d, r, h);
                }
            }
            a.push($277dfbc9b64034b1$var$J);
            $277dfbc9b64034b1$var$K(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($277dfbc9b64034b1$var$L("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($277dfbc9b64034b1$var$w.call(c, e) && (b = c[e], null != b)) switch(e){
                case "children":
                    h = b;
                    break;
                case "selected":
                    q = b;
                    break;
                case "dangerouslySetInnerHTML":
                    r = b;
                    break;
                case "value":
                    m = b;
                default:
                    $277dfbc9b64034b1$var$I(a, d, e, b);
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $277dfbc9b64034b1$var$Ia(h), $277dfbc9b64034b1$var$pa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($277dfbc9b64034b1$var$Ja);
                        break;
                    }
                } else "" + g === c && a.push($277dfbc9b64034b1$var$Ja);
            } else q && a.push($277dfbc9b64034b1$var$Ja);
            a.push($277dfbc9b64034b1$var$J);
            $277dfbc9b64034b1$var$K(a, r, h);
            return h;
        case "textarea":
            a.push($277dfbc9b64034b1$var$L("textarea"));
            r = g = e = null;
            for(h in c)if ($277dfbc9b64034b1$var$w.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(91));
                default:
                    $277dfbc9b64034b1$var$I(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($277dfbc9b64034b1$var$J);
            if (null != r) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(92));
                if ($277dfbc9b64034b1$var$pa(r) && 1 < r.length) throw Error($277dfbc9b64034b1$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$La);
            null !== e && a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A("" + e)));
            return null;
        case "input":
            a.push($277dfbc9b64034b1$var$L("input"));
            m = r = h = e = null;
            for(g in c)if ($277dfbc9b64034b1$var$w.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $277dfbc9b64034b1$var$I(a, d, g, q);
            }
            null !== r ? $277dfbc9b64034b1$var$I(a, d, "checked", r) : null !== m && $277dfbc9b64034b1$var$I(a, d, "checked", m);
            null !== e ? $277dfbc9b64034b1$var$I(a, d, "value", e) : null !== h && $277dfbc9b64034b1$var$I(a, d, "value", h);
            a.push($277dfbc9b64034b1$var$Ha);
            return null;
        case "menuitem":
            a.push($277dfbc9b64034b1$var$L("menuitem"));
            for(var E in c)if ($277dfbc9b64034b1$var$w.call(c, E) && (e = c[E], null != e)) switch(E){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(400));
                default:
                    $277dfbc9b64034b1$var$I(a, d, E, e);
            }
            a.push($277dfbc9b64034b1$var$J);
            return null;
        case "listing":
        case "pre":
            a.push($277dfbc9b64034b1$var$L(b));
            g = e = null;
            for(m in c)if ($277dfbc9b64034b1$var$w.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $277dfbc9b64034b1$var$I(a, d, m, h);
            }
            a.push($277dfbc9b64034b1$var$J);
            if (null != g) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($277dfbc9b64034b1$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($277dfbc9b64034b1$var$La, $277dfbc9b64034b1$var$u(c)) : a.push($277dfbc9b64034b1$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$La);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($277dfbc9b64034b1$var$L(b));
            for(var F in c)if ($277dfbc9b64034b1$var$w.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, b));
                default:
                    $277dfbc9b64034b1$var$I(a, d, F, e);
            }
            a.push($277dfbc9b64034b1$var$Ha);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $277dfbc9b64034b1$var$Ka(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($277dfbc9b64034b1$var$Oa), $277dfbc9b64034b1$var$Ka(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $277dfbc9b64034b1$var$Ka(a, c, b, d);
            a.push($277dfbc9b64034b1$var$L(b));
            g = e = null;
            for(q in c)if ($277dfbc9b64034b1$var$w.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $277dfbc9b64034b1$var$Fa(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $277dfbc9b64034b1$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($277dfbc9b64034b1$var$G, $277dfbc9b64034b1$var$u(q), $277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(h)), $277dfbc9b64034b1$var$D);
            }
            a.push($277dfbc9b64034b1$var$J);
            $277dfbc9b64034b1$var$K(a, g, e);
            return e;
    }
}
var $277dfbc9b64034b1$var$Qa = $277dfbc9b64034b1$var$v("</"), $277dfbc9b64034b1$var$Ra = $277dfbc9b64034b1$var$v(">"), $277dfbc9b64034b1$var$Sa = $277dfbc9b64034b1$var$v('<template id="'), $277dfbc9b64034b1$var$Ta = $277dfbc9b64034b1$var$v('"></template>'), $277dfbc9b64034b1$var$Ua = $277dfbc9b64034b1$var$v("<!--$-->"), $277dfbc9b64034b1$var$Va = $277dfbc9b64034b1$var$v('<!--$?--><template id="'), $277dfbc9b64034b1$var$Wa = $277dfbc9b64034b1$var$v('"></template>'), $277dfbc9b64034b1$var$Xa = $277dfbc9b64034b1$var$v("<!--$!-->"), $277dfbc9b64034b1$var$Ya = $277dfbc9b64034b1$var$v("<!--/$-->");
function $277dfbc9b64034b1$var$Za(a, b, c) {
    $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$Va);
    if (null === c) throw Error($277dfbc9b64034b1$var$k(395));
    $277dfbc9b64034b1$var$p(a, c);
    return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$Wa);
}
var $277dfbc9b64034b1$var$$a = $277dfbc9b64034b1$var$v('<div hidden id="'), $277dfbc9b64034b1$var$ab = $277dfbc9b64034b1$var$v('">'), $277dfbc9b64034b1$var$bb = $277dfbc9b64034b1$var$v("</div>"), $277dfbc9b64034b1$var$cb = $277dfbc9b64034b1$var$v('<svg aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$db = $277dfbc9b64034b1$var$v('">'), $277dfbc9b64034b1$var$eb = $277dfbc9b64034b1$var$v("</svg>"), $277dfbc9b64034b1$var$fb = $277dfbc9b64034b1$var$v('<math aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$gb = $277dfbc9b64034b1$var$v('">'), $277dfbc9b64034b1$var$hb = $277dfbc9b64034b1$var$v("</math>"), $277dfbc9b64034b1$var$ib = $277dfbc9b64034b1$var$v('<table hidden id="'), $277dfbc9b64034b1$var$jb = $277dfbc9b64034b1$var$v('">'), $277dfbc9b64034b1$var$kb = $277dfbc9b64034b1$var$v("</table>"), $277dfbc9b64034b1$var$lb = $277dfbc9b64034b1$var$v('<table hidden><tbody id="'), $277dfbc9b64034b1$var$mb = $277dfbc9b64034b1$var$v('">'), $277dfbc9b64034b1$var$nb = $277dfbc9b64034b1$var$v("</tbody></table>"), $277dfbc9b64034b1$var$ob = $277dfbc9b64034b1$var$v('<table hidden><tr id="'), $277dfbc9b64034b1$var$pb = $277dfbc9b64034b1$var$v('">'), $277dfbc9b64034b1$var$qb = $277dfbc9b64034b1$var$v("</tr></table>"), $277dfbc9b64034b1$var$rb = $277dfbc9b64034b1$var$v('<table hidden><colgroup id="'), $277dfbc9b64034b1$var$sb = $277dfbc9b64034b1$var$v('">'), $277dfbc9b64034b1$var$tb = $277dfbc9b64034b1$var$v("</colgroup></table>");
function $277dfbc9b64034b1$var$ub(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$$a), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ab);
        case 2:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$cb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$db);
        case 3:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$fb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$gb);
        case 4:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$ib), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$jb);
        case 5:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$lb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$mb);
        case 6:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$ob), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$pb);
        case 7:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$rb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$sb);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
function $277dfbc9b64034b1$var$vb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$bb);
        case 2:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$eb);
        case 3:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$hb);
        case 4:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$kb);
        case 5:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$nb);
        case 6:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$qb);
        case 7:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$tb);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
var $277dfbc9b64034b1$var$wb = $277dfbc9b64034b1$var$v('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $277dfbc9b64034b1$var$xb = $277dfbc9b64034b1$var$v('$RS("'), $277dfbc9b64034b1$var$yb = $277dfbc9b64034b1$var$v('","'), $277dfbc9b64034b1$var$zb = $277dfbc9b64034b1$var$v('")</script>'), $277dfbc9b64034b1$var$Ab = $277dfbc9b64034b1$var$v('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $277dfbc9b64034b1$var$Bb = $277dfbc9b64034b1$var$v('$RC("'), $277dfbc9b64034b1$var$Cb = $277dfbc9b64034b1$var$v('","'), $277dfbc9b64034b1$var$Db = $277dfbc9b64034b1$var$v('")</script>'), $277dfbc9b64034b1$var$Eb = $277dfbc9b64034b1$var$v('function $RX(a){if(a=document.getElementById(a))a=a.previousSibling,a.data="$!",a._reactRetry&&a._reactRetry()};$RX("'), $277dfbc9b64034b1$var$Fb = $277dfbc9b64034b1$var$v('$RX("'), $277dfbc9b64034b1$var$Gb = $277dfbc9b64034b1$var$v('")</script>'), $277dfbc9b64034b1$var$M = Object.assign, $277dfbc9b64034b1$var$Hb = Symbol.for("react.element"), $277dfbc9b64034b1$var$Ib = Symbol.for("react.portal"), $277dfbc9b64034b1$var$Jb = Symbol.for("react.fragment"), $277dfbc9b64034b1$var$Kb = Symbol.for("react.strict_mode"), $277dfbc9b64034b1$var$Lb = Symbol.for("react.profiler"), $277dfbc9b64034b1$var$Mb = Symbol.for("react.provider"), $277dfbc9b64034b1$var$Nb = Symbol.for("react.context"), $277dfbc9b64034b1$var$Ob = Symbol.for("react.forward_ref"), $277dfbc9b64034b1$var$Pb = Symbol.for("react.suspense"), $277dfbc9b64034b1$var$Qb = Symbol.for("react.suspense_list"), $277dfbc9b64034b1$var$Rb = Symbol.for("react.memo"), $277dfbc9b64034b1$var$Sb = Symbol.for("react.lazy"), $277dfbc9b64034b1$var$Tb = Symbol.for("react.scope"), $277dfbc9b64034b1$var$Ub = Symbol.for("react.debug_trace_mode"), $277dfbc9b64034b1$var$Vb = Symbol.for("react.legacy_hidden"), $277dfbc9b64034b1$var$Wb = Symbol.for("react.default_value"), $277dfbc9b64034b1$var$Xb = Symbol.iterator;
function $277dfbc9b64034b1$var$Yb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $277dfbc9b64034b1$var$Jb:
            return "Fragment";
        case $277dfbc9b64034b1$var$Ib:
            return "Portal";
        case $277dfbc9b64034b1$var$Lb:
            return "Profiler";
        case $277dfbc9b64034b1$var$Kb:
            return "StrictMode";
        case $277dfbc9b64034b1$var$Pb:
            return "Suspense";
        case $277dfbc9b64034b1$var$Qb:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $277dfbc9b64034b1$var$Nb:
            return (a.displayName || "Context") + ".Consumer";
        case $277dfbc9b64034b1$var$Mb:
            return (a._context.displayName || "Context") + ".Provider";
        case $277dfbc9b64034b1$var$Ob:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $277dfbc9b64034b1$var$Rb:
            return b = a.displayName || null, null !== b ? b : $277dfbc9b64034b1$var$Yb(a.type) || "Memo";
        case $277dfbc9b64034b1$var$Sb:
            b = a._payload;
            a = a._init;
            try {
                return $277dfbc9b64034b1$var$Yb(a(b));
            } catch (c) {}
    }
    return null;
}
var $277dfbc9b64034b1$var$Zb = {};
function $277dfbc9b64034b1$var$$b(a, b) {
    a = a.contextTypes;
    if (!a) return $277dfbc9b64034b1$var$Zb;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $277dfbc9b64034b1$var$N = null;
function $277dfbc9b64034b1$var$O(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($277dfbc9b64034b1$var$k(401));
        } else {
            if (null === c) throw Error($277dfbc9b64034b1$var$k(401));
            $277dfbc9b64034b1$var$O(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $277dfbc9b64034b1$var$ac(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $277dfbc9b64034b1$var$ac(a);
}
function $277dfbc9b64034b1$var$bc(a) {
    var b = a.parent;
    null !== b && $277dfbc9b64034b1$var$bc(b);
    a.context._currentValue = a.value;
}
function $277dfbc9b64034b1$var$cc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === b.depth ? $277dfbc9b64034b1$var$O(a, b) : $277dfbc9b64034b1$var$cc(a, b);
}
function $277dfbc9b64034b1$var$dc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === c.depth ? $277dfbc9b64034b1$var$O(a, c) : $277dfbc9b64034b1$var$dc(a, c);
    b.context._currentValue = b.value;
}
function $277dfbc9b64034b1$var$P(a) {
    var b = $277dfbc9b64034b1$var$N;
    b !== a && (null === b ? $277dfbc9b64034b1$var$bc(a) : null === a ? $277dfbc9b64034b1$var$ac(b) : b.depth === a.depth ? $277dfbc9b64034b1$var$O(b, a) : b.depth > a.depth ? $277dfbc9b64034b1$var$cc(b, a) : $277dfbc9b64034b1$var$dc(b, a), $277dfbc9b64034b1$var$N = a);
}
var $277dfbc9b64034b1$var$ec = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $277dfbc9b64034b1$var$fc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $277dfbc9b64034b1$var$ec;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $277dfbc9b64034b1$var$M({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $277dfbc9b64034b1$var$ec.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $277dfbc9b64034b1$var$M({}, e, h)) : $277dfbc9b64034b1$var$M(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $277dfbc9b64034b1$var$gc = {
    id: 1,
    overflow: ""
};
function $277dfbc9b64034b1$var$hc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $277dfbc9b64034b1$var$Q(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $277dfbc9b64034b1$var$Q(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $277dfbc9b64034b1$var$Q(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $277dfbc9b64034b1$var$Q = Math.clz32 ? Math.clz32 : $277dfbc9b64034b1$var$ic, $277dfbc9b64034b1$var$jc = Math.log, $277dfbc9b64034b1$var$kc = Math.LN2;
function $277dfbc9b64034b1$var$ic(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($277dfbc9b64034b1$var$jc(a) / $277dfbc9b64034b1$var$kc | 0) | 0;
}
function $277dfbc9b64034b1$var$lc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $277dfbc9b64034b1$var$mc = "function" === typeof Object.is ? Object.is : $277dfbc9b64034b1$var$lc, $277dfbc9b64034b1$var$R = null, $277dfbc9b64034b1$var$nc = null, $277dfbc9b64034b1$var$oc = null, $277dfbc9b64034b1$var$S = null, $277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$pc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$V = null, $277dfbc9b64034b1$var$qc = 0;
function $277dfbc9b64034b1$var$W() {
    if (null === $277dfbc9b64034b1$var$R) throw Error($277dfbc9b64034b1$var$k(321));
    return $277dfbc9b64034b1$var$R;
}
function $277dfbc9b64034b1$var$rc() {
    if (0 < $277dfbc9b64034b1$var$qc) throw Error($277dfbc9b64034b1$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $277dfbc9b64034b1$var$sc() {
    null === $277dfbc9b64034b1$var$S ? null === $277dfbc9b64034b1$var$oc ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$oc = $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$rc()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$oc) : null === $277dfbc9b64034b1$var$S.next ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next = $277dfbc9b64034b1$var$rc()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next);
    return $277dfbc9b64034b1$var$S;
}
function $277dfbc9b64034b1$var$tc() {
    $277dfbc9b64034b1$var$nc = $277dfbc9b64034b1$var$R = null;
    $277dfbc9b64034b1$var$pc = !1;
    $277dfbc9b64034b1$var$oc = null;
    $277dfbc9b64034b1$var$qc = 0;
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$V = null;
}
function $277dfbc9b64034b1$var$uc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $277dfbc9b64034b1$var$vc(a, b, c) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$sc();
    if ($277dfbc9b64034b1$var$T) {
        var d = $277dfbc9b64034b1$var$S.queue;
        b = d.dispatch;
        if (null !== $277dfbc9b64034b1$var$V && (c = $277dfbc9b64034b1$var$V.get(d), void 0 !== c)) {
            $277dfbc9b64034b1$var$V.delete(d);
            d = $277dfbc9b64034b1$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $277dfbc9b64034b1$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $277dfbc9b64034b1$var$S.memoizedState,
            b
        ];
    }
    a = a === $277dfbc9b64034b1$var$uc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $277dfbc9b64034b1$var$S.memoizedState = a;
    a = $277dfbc9b64034b1$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $277dfbc9b64034b1$var$wc.bind(null, $277dfbc9b64034b1$var$R, a);
    return [
        $277dfbc9b64034b1$var$S.memoizedState,
        a
    ];
}
function $277dfbc9b64034b1$var$xc(a, b) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$sc();
    b = void 0 === b ? null : b;
    if (null !== $277dfbc9b64034b1$var$S) {
        var c = $277dfbc9b64034b1$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$277dfbc9b64034b1$var$mc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $277dfbc9b64034b1$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $277dfbc9b64034b1$var$wc(a, b, c) {
    if (25 <= $277dfbc9b64034b1$var$qc) throw Error($277dfbc9b64034b1$var$k(301));
    if (a === $277dfbc9b64034b1$var$R) {
        if ($277dfbc9b64034b1$var$pc = !0, a = {
            action: c,
            next: null
        }, null === $277dfbc9b64034b1$var$V && ($277dfbc9b64034b1$var$V = new Map), c = $277dfbc9b64034b1$var$V.get(b), void 0 === c) $277dfbc9b64034b1$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $277dfbc9b64034b1$var$yc() {
    throw Error($277dfbc9b64034b1$var$k(394));
}
function $277dfbc9b64034b1$var$zc() {}
var $277dfbc9b64034b1$var$Bc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $277dfbc9b64034b1$var$W();
        return a._currentValue;
    },
    useMemo: $277dfbc9b64034b1$var$xc,
    useReducer: $277dfbc9b64034b1$var$vc,
    useRef: function(a) {
        $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
        $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$sc();
        var b = $277dfbc9b64034b1$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $277dfbc9b64034b1$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $277dfbc9b64034b1$var$vc($277dfbc9b64034b1$var$uc, a);
    },
    useInsertionEffect: $277dfbc9b64034b1$var$zc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $277dfbc9b64034b1$var$xc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $277dfbc9b64034b1$var$zc,
    useEffect: $277dfbc9b64034b1$var$zc,
    useDebugValue: $277dfbc9b64034b1$var$zc,
    useDeferredValue: function(a) {
        $277dfbc9b64034b1$var$W();
        return a;
    },
    useTransition: function() {
        $277dfbc9b64034b1$var$W();
        return [
            !1,
            $277dfbc9b64034b1$var$yc
        ];
    },
    useId: function() {
        var a = $277dfbc9b64034b1$var$nc.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $277dfbc9b64034b1$var$Q(a) - 1)).toString(32) + b;
        var c = $277dfbc9b64034b1$var$Ac;
        if (null === c) throw Error($277dfbc9b64034b1$var$k(404));
        b = $277dfbc9b64034b1$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $277dfbc9b64034b1$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($277dfbc9b64034b1$var$k(407));
        return c();
    }
}, $277dfbc9b64034b1$var$Ac = null, $277dfbc9b64034b1$var$Cc = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $277dfbc9b64034b1$var$Dc(a) {
    console.error(a);
}
function $277dfbc9b64034b1$var$X() {}
function $277dfbc9b64034b1$var$Ec(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $277dfbc9b64034b1$var$Dc : f,
        onAllReady: void 0 === e ? $277dfbc9b64034b1$var$X : e,
        onShellReady: void 0 === g ? $277dfbc9b64034b1$var$X : g,
        onShellError: void 0 === h ? $277dfbc9b64034b1$var$X : h,
        onFatalError: void 0 === m ? $277dfbc9b64034b1$var$X : m
    };
    c = $277dfbc9b64034b1$var$Fc(b, 0, null, c);
    c.parentFlushed = !0;
    a = $277dfbc9b64034b1$var$Gc(b, a, null, c, r, $277dfbc9b64034b1$var$Zb, null, $277dfbc9b64034b1$var$gc);
    q.push(a);
    return b;
}
function $277dfbc9b64034b1$var$Gc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $277dfbc9b64034b1$var$Hc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $277dfbc9b64034b1$var$Fc(a, b, c, d) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c
    };
}
function $277dfbc9b64034b1$var$Y(a, b) {
    a = a.onError;
    a(b);
}
function $277dfbc9b64034b1$var$Ic(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $277dfbc9b64034b1$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $277dfbc9b64034b1$var$Jc(a, b, c, d, f) {
    $277dfbc9b64034b1$var$R = {};
    $277dfbc9b64034b1$var$nc = b;
    $277dfbc9b64034b1$var$U = 0;
    for(a = c(d, f); $277dfbc9b64034b1$var$pc;)$277dfbc9b64034b1$var$pc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$qc += 1, $277dfbc9b64034b1$var$S = null, a = c(d, f);
    $277dfbc9b64034b1$var$tc();
    return a;
}
function $277dfbc9b64034b1$var$Kc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($277dfbc9b64034b1$var$k(108, $277dfbc9b64034b1$var$Yb(d) || "Unknown", h));
            d = $277dfbc9b64034b1$var$M({}, g, c);
        }
        b.legacyContext = d;
        $277dfbc9b64034b1$var$Z(a, b, f);
        b.legacyContext = g;
    } else $277dfbc9b64034b1$var$Z(a, b, f);
}
function $277dfbc9b64034b1$var$Lc(a, b) {
    if (a && a.defaultProps) {
        b = $277dfbc9b64034b1$var$M({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $277dfbc9b64034b1$var$Mc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $277dfbc9b64034b1$var$$b(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $277dfbc9b64034b1$var$fc(e, c, d, f);
            $277dfbc9b64034b1$var$Kc(a, b, e, c);
        } else {
            e = $277dfbc9b64034b1$var$$b(c, b.legacyContext);
            f = $277dfbc9b64034b1$var$Jc(a, b, c, d, e);
            var g = 0 !== $277dfbc9b64034b1$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $277dfbc9b64034b1$var$fc(f, c, d, e), $277dfbc9b64034b1$var$Kc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $277dfbc9b64034b1$var$hc(d, 1, 0);
                try {
                    $277dfbc9b64034b1$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $277dfbc9b64034b1$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) switch(f = b.blockedSegment, e = $277dfbc9b64034b1$var$Pa(f.chunks, c, d, a.responseState, f.formatContext), g = f.formatContext, f.formatContext = $277dfbc9b64034b1$var$za(g, c, d), $277dfbc9b64034b1$var$Nc(a, b, e), f.formatContext = g, c){
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            break;
        default:
            f.chunks.push($277dfbc9b64034b1$var$Qa, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$Ra);
    }
    else {
        switch(c){
            case $277dfbc9b64034b1$var$Vb:
            case $277dfbc9b64034b1$var$Ub:
            case $277dfbc9b64034b1$var$Kb:
            case $277dfbc9b64034b1$var$Lb:
            case $277dfbc9b64034b1$var$Jb:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$Qb:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$Tb:
                throw Error($277dfbc9b64034b1$var$k(343));
            case $277dfbc9b64034b1$var$Pb:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g
                    }, m = $277dfbc9b64034b1$var$Fc(a, f.chunks.length, h, f.formatContext);
                    f.children.push(m);
                    var q = $277dfbc9b64034b1$var$Fc(a, 0, null, f.formatContext);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($277dfbc9b64034b1$var$Nc(a, b, d), q.status = 1, $277dfbc9b64034b1$var$Oc(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, $277dfbc9b64034b1$var$Y(a, r), h.forceClientRender = !0;
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $277dfbc9b64034b1$var$Gc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $277dfbc9b64034b1$var$Ob:
                d = $277dfbc9b64034b1$var$Jc(a, b, c.render, d, f);
                if (0 !== $277dfbc9b64034b1$var$U) {
                    c = b.treeContext;
                    b.treeContext = $277dfbc9b64034b1$var$hc(c, 1, 0);
                    try {
                        $277dfbc9b64034b1$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$Rb:
                c = c.type;
                d = $277dfbc9b64034b1$var$Lc(c, d);
                $277dfbc9b64034b1$var$Mc(a, b, c, d, f);
                return;
            case $277dfbc9b64034b1$var$Mb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $277dfbc9b64034b1$var$N;
                $277dfbc9b64034b1$var$N = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $277dfbc9b64034b1$var$Z(a, b, f);
                a = $277dfbc9b64034b1$var$N;
                if (null === a) throw Error($277dfbc9b64034b1$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $277dfbc9b64034b1$var$Wb ? a.context._defaultValue : d;
                a = $277dfbc9b64034b1$var$N = a.parent;
                b.context = a;
                return;
            case $277dfbc9b64034b1$var$Nb:
                d = d.children;
                d = d(c._currentValue);
                $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$Sb:
                f = c._init;
                c = f(c._payload);
                d = $277dfbc9b64034b1$var$Lc(c, d);
                $277dfbc9b64034b1$var$Mc(a, b, c, d, void 0);
                return;
        }
        throw Error($277dfbc9b64034b1$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $277dfbc9b64034b1$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $277dfbc9b64034b1$var$Hb:
                $277dfbc9b64034b1$var$Mc(a, b, c.type, c.props, c.ref);
                return;
            case $277dfbc9b64034b1$var$Ib:
                throw Error($277dfbc9b64034b1$var$k(257));
            case $277dfbc9b64034b1$var$Sb:
                var d = c._init;
                c = d(c._payload);
                $277dfbc9b64034b1$var$Z(a, b, c);
                return;
        }
        if ($277dfbc9b64034b1$var$pa(c)) {
            $277dfbc9b64034b1$var$Pc(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $277dfbc9b64034b1$var$Xb && c[$277dfbc9b64034b1$var$Xb] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $277dfbc9b64034b1$var$Pc(a, b, f);
            }
            return;
        }
        b = Object.prototype.toString.call(c);
        throw Error($277dfbc9b64034b1$var$k(31, "[object Object]" === b ? "object with keys {" + Object.keys(c).join(", ") + "}" : b));
    }
    "string" === typeof c ? "" !== c && b.blockedSegment.chunks.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(c)), $277dfbc9b64034b1$var$Aa) : "number" === typeof c && (a = "" + c, "" !== a && b.blockedSegment.chunks.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$A(a)), $277dfbc9b64034b1$var$Aa));
}
function $277dfbc9b64034b1$var$Pc(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $277dfbc9b64034b1$var$hc(e, d, f);
        try {
            $277dfbc9b64034b1$var$Nc(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $277dfbc9b64034b1$var$Nc(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $277dfbc9b64034b1$var$Z(a, b, c);
    } catch (m) {
        if ($277dfbc9b64034b1$var$tc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $277dfbc9b64034b1$var$Fc(a, g.chunks.length, null, g.formatContext);
            g.children.push(h);
            a = $277dfbc9b64034b1$var$Gc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $277dfbc9b64034b1$var$P(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $277dfbc9b64034b1$var$P(e), m;
    }
}
function $277dfbc9b64034b1$var$Qc(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $277dfbc9b64034b1$var$Rc(this, b, a);
}
function $277dfbc9b64034b1$var$Sc(a) {
    var b = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === b ? (this.allPendingTasks--, 2 !== this.status && (this.status = 2, null !== this.destination && this.destination.close())) : (b.pendingTasks--, b.forceClientRender || (b.forceClientRender = !0, b.parentFlushed && this.clientRenderedBoundaries.push(b)), b.fallbackAbortableTasks.forEach($277dfbc9b64034b1$var$Sc, this), b.fallbackAbortableTasks.clear(), this.allPendingTasks--, 0 === this.allPendingTasks && (a = this.onAllReady, a()));
}
function $277dfbc9b64034b1$var$Oc(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $277dfbc9b64034b1$var$Oc(a, c);
    } else a.completedSegments.push(b);
}
function $277dfbc9b64034b1$var$Rc(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($277dfbc9b64034b1$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $277dfbc9b64034b1$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $277dfbc9b64034b1$var$Oc(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($277dfbc9b64034b1$var$Qc, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($277dfbc9b64034b1$var$Oc(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $277dfbc9b64034b1$var$Hc(a) {
    if (2 !== a.status) {
        var b = $277dfbc9b64034b1$var$N, c = $277dfbc9b64034b1$var$Cc.current;
        $277dfbc9b64034b1$var$Cc.current = $277dfbc9b64034b1$var$Bc;
        var d = $277dfbc9b64034b1$var$Ac;
        $277dfbc9b64034b1$var$Ac = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $277dfbc9b64034b1$var$P(g.context);
                    try {
                        $277dfbc9b64034b1$var$Z(h, g, g.node), g.abortSet.delete(g), m.status = 1, $277dfbc9b64034b1$var$Rc(h, g.blockedBoundary, m);
                    } catch (C) {
                        if ($277dfbc9b64034b1$var$tc(), "object" === typeof C && null !== C && "function" === typeof C.then) {
                            var q = g.ping;
                            C.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, E = C;
                            $277dfbc9b64034b1$var$Y(h, E);
                            null === r ? $277dfbc9b64034b1$var$Ic(h, E) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $277dfbc9b64034b1$var$Tc(a, a.destination);
        } catch (C) {
            $277dfbc9b64034b1$var$Y(a, C), $277dfbc9b64034b1$var$Ic(a, C);
        } finally{
            $277dfbc9b64034b1$var$Ac = d, $277dfbc9b64034b1$var$Cc.current = c, c === $277dfbc9b64034b1$var$Bc && $277dfbc9b64034b1$var$P(b);
        }
    }
}
function $277dfbc9b64034b1$var$Uc(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            a = a.responseState;
            $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Sa);
            $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
            a = $277dfbc9b64034b1$var$u(d.toString(16));
            $277dfbc9b64034b1$var$p(b, a);
            return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Ta);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$277dfbc9b64034b1$var$p(b, d[e]);
                f = $277dfbc9b64034b1$var$Vc(a, b, f);
            }
            for(; e < d.length - 1; e++)$277dfbc9b64034b1$var$p(b, d[e]);
            e < d.length && (f = $277dfbc9b64034b1$var$t(b, d[e]));
            return f;
        default:
            throw Error($277dfbc9b64034b1$var$k(390));
    }
}
function $277dfbc9b64034b1$var$Vc(a, b, c) {
    var d = c.boundary;
    if (null === d) return $277dfbc9b64034b1$var$Uc(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Xa), $277dfbc9b64034b1$var$Uc(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $277dfbc9b64034b1$var$v(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $277dfbc9b64034b1$var$Za(b, a.responseState, d);
        $277dfbc9b64034b1$var$Uc(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $277dfbc9b64034b1$var$Za(b, a.responseState, d.id), $277dfbc9b64034b1$var$Uc(a, b, c);
    else {
        $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Ua);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($277dfbc9b64034b1$var$k(391));
        $277dfbc9b64034b1$var$Vc(a, b, c[0]);
    }
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Ya);
}
function $277dfbc9b64034b1$var$Wc(a, b, c) {
    $277dfbc9b64034b1$var$ub(b, a.responseState, c.formatContext, c.id);
    $277dfbc9b64034b1$var$Vc(a, b, c);
    return $277dfbc9b64034b1$var$vb(b, c.formatContext);
}
function $277dfbc9b64034b1$var$Xc(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$277dfbc9b64034b1$var$Yc(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Bb) : (a.sentCompleteBoundaryFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Ab));
    if (null === d) throw Error($277dfbc9b64034b1$var$k(395));
    c = $277dfbc9b64034b1$var$u(c.toString(16));
    $277dfbc9b64034b1$var$p(b, d);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Cb);
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    $277dfbc9b64034b1$var$p(b, c);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Db);
}
function $277dfbc9b64034b1$var$Yc(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($277dfbc9b64034b1$var$k(392));
        return $277dfbc9b64034b1$var$Wc(a, b, d);
    }
    $277dfbc9b64034b1$var$Wc(a, b, d);
    a = a.responseState;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$xb) : (a.sentCompleteSegmentFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$wb));
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    f = $277dfbc9b64034b1$var$u(f.toString(16));
    $277dfbc9b64034b1$var$p(b, f);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$yb);
    $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
    $277dfbc9b64034b1$var$p(b, f);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$zb);
}
function $277dfbc9b64034b1$var$Tc(a, b) {
    $277dfbc9b64034b1$var$l = new Uint8Array(512);
    $277dfbc9b64034b1$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $277dfbc9b64034b1$var$Vc(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$277dfbc9b64034b1$var$p(b, d[c]);
            c < d.length && $277dfbc9b64034b1$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            d = b;
            var g = a.responseState, h = f[e].id;
            $277dfbc9b64034b1$var$p(d, g.startInlineScript);
            g.sentClientRenderFunction ? $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Fb) : (g.sentClientRenderFunction = !0, $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Eb));
            if (null === h) throw Error($277dfbc9b64034b1$var$k(395));
            $277dfbc9b64034b1$var$p(d, h);
            if (!$277dfbc9b64034b1$var$t(d, $277dfbc9b64034b1$var$Gb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var m = a.completedBoundaries;
        for(e = 0; e < m.length; e++)if (!$277dfbc9b64034b1$var$Xc(a, b, m[e])) {
            a.destination = null;
            e++;
            m.splice(0, e);
            return;
        }
        m.splice(0, e);
        $277dfbc9b64034b1$var$ba(b);
        $277dfbc9b64034b1$var$l = new Uint8Array(512);
        $277dfbc9b64034b1$var$n = 0;
        var q = a.partialBoundaries;
        for(e = 0; e < q.length; e++){
            var r = q[e];
            a: {
                f = a;
                g = b;
                var E = r.completedSegments;
                for(h = 0; h < E.length; h++)if (!$277dfbc9b64034b1$var$Yc(f, g, r, E[h])) {
                    h++;
                    E.splice(0, h);
                    var F = !1;
                    break a;
                }
                E.splice(0, h);
                F = !0;
            }
            if (!F) {
                a.destination = null;
                e++;
                q.splice(0, e);
                return;
            }
        }
        q.splice(0, e);
        var C = a.completedBoundaries;
        for(e = 0; e < C.length; e++)if (!$277dfbc9b64034b1$var$Xc(a, b, C[e])) {
            a.destination = null;
            e++;
            C.splice(0, e);
            return;
        }
        C.splice(0, e);
    } finally{
        $277dfbc9b64034b1$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $277dfbc9b64034b1$var$Zc(a) {
    try {
        var b = a.abortableTasks;
        b.forEach($277dfbc9b64034b1$var$Sc, a);
        b.clear();
        null !== a.destination && $277dfbc9b64034b1$var$Tc(a, a.destination);
    } catch (c) {
        $277dfbc9b64034b1$var$Y(a, c), $277dfbc9b64034b1$var$Ic(a, c);
    }
}
$277dfbc9b64034b1$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $277dfbc9b64034b1$var$Ec(a, $277dfbc9b64034b1$var$xa(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $277dfbc9b64034b1$var$ya(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $277dfbc9b64034b1$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $277dfbc9b64034b1$var$Tc(h, a);
                        } catch (F) {
                            $277dfbc9b64034b1$var$Y(h, F), $277dfbc9b64034b1$var$Ic(h, F);
                        }
                    }
                },
                cancel: function() {
                    $277dfbc9b64034b1$var$Zc(h);
                }
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $277dfbc9b64034b1$var$Zc(h);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $277dfbc9b64034b1$var$Hc(h);
    });
};
$277dfbc9b64034b1$export$83d89fbfd8236492 = "18.1.0";

});

parcelRegister("fLVpN", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof global !== "undefined") return global;
    throw new Error("unable to locate global object");
};
var global = getGlobal();
module.exports = exports = global.fetch;
// Needed for TypeScript and Webpack.
if (global.fetch) exports.default = global.fetch.bind(global);
exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

});

parcelRegister("eJrNq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e04b57bbd53084ac$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Lodash implementation of `get`
const charCodeOfDot = ".".charCodeAt(0);
const reEscapeChar = /\\(\\)?/g;
const rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
const reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const reIsPlainProp = /^\w*$/;
const getTag = function(value) {
    return Object.prototype.toString.call(value);
};
const isSymbol = function(value) {
    const type = typeof value;
    return type === "symbol" || type === "object" && value && getTag(value) === "[object Symbol]";
};
const isKey = function(value, object) {
    if (Array.isArray(value)) return false;
    const type = typeof value;
    if (type === "number" || type === "symbol" || type === "boolean" || !value || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
};
const stringToPath = function(string) {
    const result = [];
    if (string.charCodeAt(0) === charCodeOfDot) result.push("");
    string.replace(rePropName, function(match, expression, quote, subString) {
        let key = match;
        if (quote) key = subString.replace(reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
const castPath = function(value, object) {
    if (Array.isArray(value)) return value;
    else return isKey(value, object) ? [
        value
    ] : stringToPath(value);
};
const toKey = function(value) {
    if (typeof value === "string" || isSymbol(value)) return value;
    const result = `${value}`;
    // eslint-disable-next-line
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
};
const get = function(object, path) {
    path = castPath(path, object);
    let index = 0;
    const length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index === length ? object : undefined;
};
const is_object = function(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};
const normalize_columns = function(columns) {
    if (columns === undefined || columns === null) return [
        undefined,
        undefined
    ];
    if (typeof columns !== "object") return [
        Error('Invalid option "columns": expect an array or an object')
    ];
    if (!Array.isArray(columns)) {
        const newcolumns = [];
        for(const k in columns)newcolumns.push({
            key: k,
            header: columns[k]
        });
        columns = newcolumns;
    } else {
        const newcolumns = [];
        for (const column of columns){
            if (typeof column === "string") newcolumns.push({
                key: column,
                header: column
            });
            else if (typeof column === "object" && column !== null && !Array.isArray(column)) {
                if (!column.key) return [
                    Error('Invalid column definition: property "key" is required')
                ];
                if (column.header === undefined) column.header = column.key;
                newcolumns.push(column);
            } else return [
                Error("Invalid column definition: expect a string or an object")
            ];
        }
        columns = newcolumns;
    }
    return [
        undefined,
        columns
    ];
};
class CsvError extends Error {
    constructor(code, message, ...contexts){
        if (Array.isArray(message)) message = message.join(" ");
        super(message);
        if (Error.captureStackTrace !== undefined) Error.captureStackTrace(this, CsvError);
        this.code = code;
        for (const context of contexts)for(const key in context){
            const value = context[key];
            this[key] = $e04b57bbd53084ac$require$Buffer.isBuffer(value) ? value.toString() : value == null ? value : JSON.parse(JSON.stringify(value));
        }
    }
}
const underscore = function(str) {
    return str.replace(/([A-Z])/g, function(_, match) {
        return "_" + match.toLowerCase();
    });
};
const normalize_options = function(opts) {
    const options = {};
    // Merge with user options
    for(const opt in opts)options[underscore(opt)] = opts[opt];
    // Normalize option `bom`
    if (options.bom === undefined || options.bom === null || options.bom === false) options.bom = false;
    else if (options.bom !== true) return [
        new CsvError("CSV_OPTION_BOOLEAN_INVALID_TYPE", [
            "option `bom` is optional and must be a boolean value,",
            `got ${JSON.stringify(options.bom)}`
        ])
    ];
    // Normalize option `delimiter`
    if (options.delimiter === undefined || options.delimiter === null) options.delimiter = ",";
    else if ($e04b57bbd53084ac$require$Buffer.isBuffer(options.delimiter)) options.delimiter = options.delimiter.toString();
    else if (typeof options.delimiter !== "string") return [
        new CsvError("CSV_OPTION_DELIMITER_INVALID_TYPE", [
            "option `delimiter` must be a buffer or a string,",
            `got ${JSON.stringify(options.delimiter)}`
        ])
    ];
    // Normalize option `quote`
    if (options.quote === undefined || options.quote === null) options.quote = '"';
    else if (options.quote === true) options.quote = '"';
    else if (options.quote === false) options.quote = "";
    else if ($e04b57bbd53084ac$require$Buffer.isBuffer(options.quote)) options.quote = options.quote.toString();
    else if (typeof options.quote !== "string") return [
        new CsvError("CSV_OPTION_QUOTE_INVALID_TYPE", [
            "option `quote` must be a boolean, a buffer or a string,",
            `got ${JSON.stringify(options.quote)}`
        ])
    ];
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `escape_formulas`
    if (options.escape_formulas === undefined || options.escape_formulas === null) options.escape_formulas = false;
    else if (typeof options.escape_formulas !== "boolean") return [
        new CsvError("CSV_OPTION_ESCAPE_FORMULAS_INVALID_TYPE", [
            "option `escape_formulas` must be a boolean,",
            `got ${JSON.stringify(options.escape_formulas)}`
        ])
    ];
    // Normalize option `quoted_empty`
    if (options.quoted_empty === undefined || options.quoted_empty === null) options.quoted_empty = undefined;
    // Normalize option `quoted_match`
    if (options.quoted_match === undefined || options.quoted_match === null || options.quoted_match === false) options.quoted_match = null;
    else if (!Array.isArray(options.quoted_match)) options.quoted_match = [
        options.quoted_match
    ];
    if (options.quoted_match) for (const quoted_match of options.quoted_match){
        const isString = typeof quoted_match === "string";
        const isRegExp = quoted_match instanceof RegExp;
        if (!isString && !isRegExp) return [
            Error(`Invalid Option: quoted_match must be a string or a regex, got ${JSON.stringify(quoted_match)}`)
        ];
    }
    // Normalize option `quoted_string`
    if (options.quoted_string === undefined || options.quoted_string === null) options.quoted_string = false;
    // Normalize option `eof`
    if (options.eof === undefined || options.eof === null) options.eof = true;
    // Normalize option `escape`
    if (options.escape === undefined || options.escape === null) options.escape = '"';
    else if ($e04b57bbd53084ac$require$Buffer.isBuffer(options.escape)) options.escape = options.escape.toString();
    else if (typeof options.escape !== "string") return [
        Error(`Invalid Option: escape must be a buffer or a string, got ${JSON.stringify(options.escape)}`)
    ];
    if (options.escape.length > 1) return [
        Error(`Invalid Option: escape must be one character, got ${options.escape.length} characters`)
    ];
    // Normalize option `header`
    if (options.header === undefined || options.header === null) options.header = false;
    // Normalize option `columns`
    const [errColumns, columns] = normalize_columns(options.columns);
    if (errColumns !== undefined) return [
        errColumns
    ];
    options.columns = columns;
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `cast`
    if (options.cast === undefined || options.cast === null) options.cast = {};
    // Normalize option cast.bigint
    if (options.cast.bigint === undefined || options.cast.bigint === null) // Cast boolean to string by default
    options.cast.bigint = (value)=>"" + value;
    // Normalize option cast.boolean
    if (options.cast.boolean === undefined || options.cast.boolean === null) // Cast boolean to string by default
    options.cast.boolean = (value)=>value ? "1" : "";
    // Normalize option cast.date
    if (options.cast.date === undefined || options.cast.date === null) // Cast date to timestamp string by default
    options.cast.date = (value)=>"" + value.getTime();
    // Normalize option cast.number
    if (options.cast.number === undefined || options.cast.number === null) // Cast number to string using native casting by default
    options.cast.number = (value)=>"" + value;
    // Normalize option cast.object
    if (options.cast.object === undefined || options.cast.object === null) // Stringify object as JSON by default
    options.cast.object = (value)=>JSON.stringify(value);
    // Normalize option cast.string
    if (options.cast.string === undefined || options.cast.string === null) // Leave string untouched
    options.cast.string = function(value) {
        return value;
    };
    // Normalize option `on_record`
    if (options.on_record !== undefined && typeof options.on_record !== "function") return [
        Error(`Invalid Option: "on_record" must be a function.`)
    ];
    // Normalize option `record_delimiter`
    if (options.record_delimiter === undefined || options.record_delimiter === null) options.record_delimiter = "\n";
    else if ($e04b57bbd53084ac$require$Buffer.isBuffer(options.record_delimiter)) options.record_delimiter = options.record_delimiter.toString();
    else if (typeof options.record_delimiter !== "string") return [
        Error(`Invalid Option: record_delimiter must be a buffer or a string, got ${JSON.stringify(options.record_delimiter)}`)
    ];
    switch(options.record_delimiter){
        case "unix":
            options.record_delimiter = "\n";
            break;
        case "mac":
            options.record_delimiter = "\r";
            break;
        case "windows":
            options.record_delimiter = "\r\n";
            break;
        case "ascii":
            options.record_delimiter = "\x1e";
            break;
        case "unicode":
            options.record_delimiter = "\u2028";
            break;
    }
    return [
        undefined,
        options
    ];
};
const bom_utf8 = $e04b57bbd53084ac$require$Buffer.from([
    239,
    187,
    191
]);
const stringifier = function(options, state, info) {
    return {
        options: options,
        state: state,
        info: info,
        __transform: function(chunk, push) {
            // Chunk validation
            if (!Array.isArray(chunk) && typeof chunk !== "object") return Error(`Invalid Record: expect an array or an object, got ${JSON.stringify(chunk)}`);
            // Detect columns from the first record
            if (this.info.records === 0) {
                if (Array.isArray(chunk)) {
                    if (this.options.header === true && this.options.columns === undefined) return Error("Undiscoverable Columns: header option requires column option or object records");
                } else if (this.options.columns === undefined) {
                    const [err, columns] = normalize_columns(Object.keys(chunk));
                    if (err) return;
                    this.options.columns = columns;
                }
            }
            // Emit the header
            if (this.info.records === 0) {
                this.bom(push);
                const err = this.headers(push);
                if (err) return err;
            }
            // Emit and stringify the record if an object or an array
            try {
                // this.emit('record', chunk, this.info.records);
                if (this.options.on_record) this.options.on_record(chunk, this.info.records);
            } catch (err) {
                return err;
            }
            // Convert the record into a string
            let err, chunk_string;
            if (this.options.eof) {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else chunk_string = chunk_string + this.options.record_delimiter;
            } else {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else if (this.options.header || this.info.records) chunk_string = this.options.record_delimiter + chunk_string;
            }
            // Emit the csv
            this.info.records++;
            push(chunk_string);
        },
        stringify: function(chunk, chunkIsHeader = false) {
            if (typeof chunk !== "object") return [
                undefined,
                chunk
            ];
            const { columns } = this.options;
            const record = [];
            // Record is an array
            if (Array.isArray(chunk)) {
                // We are getting an array but the user has specified output columns. In
                // this case, we respect the columns indexes
                if (columns) chunk.splice(columns.length);
                // Cast record elements
                for(let i = 0; i < chunk.length; i++){
                    const field = chunk[i];
                    const [err, value] = this.__cast(field, {
                        index: i,
                        column: i,
                        records: this.info.records,
                        header: chunkIsHeader
                    });
                    if (err) return [
                        err
                    ];
                    record[i] = [
                        value,
                        field
                    ];
                }
            // Record is a literal object
            // `columns` is always defined: it is either provided or discovered.
            } else for(let i = 0; i < columns.length; i++){
                const field = get(chunk, columns[i].key);
                const [err, value] = this.__cast(field, {
                    index: i,
                    column: columns[i].key,
                    records: this.info.records,
                    header: chunkIsHeader
                });
                if (err) return [
                    err
                ];
                record[i] = [
                    value,
                    field
                ];
            }
            let csvrecord = "";
            for(let i = 0; i < record.length; i++){
                let options, err;
                // eslint-disable-next-line
                let [value, field] = record[i];
                if (typeof value === "string") options = this.options;
                else if (is_object(value)) {
                    options = value;
                    value = options.value;
                    delete options.value;
                    if (typeof value !== "string" && value !== undefined && value !== null) {
                        if (err) return [
                            Error(`Invalid Casting Value: returned value must return a string, null or undefined, got ${JSON.stringify(value)}`)
                        ];
                    }
                    options = {
                        ...this.options,
                        ...options
                    };
                    [err, options] = normalize_options(options);
                    if (err !== undefined) return [
                        err
                    ];
                } else if (value === undefined || value === null) options = this.options;
                else return [
                    Error(`Invalid Casting Value: returned value must return a string, an object, null or undefined, got ${JSON.stringify(value)}`)
                ];
                const { delimiter, escape, quote, quoted, quoted_empty, quoted_string, quoted_match, record_delimiter, escape_formulas } = options;
                if ("" === value && "" === field) {
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === "string") return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    const shouldQuote = quotedMatch || true === quoted_empty || true === quoted_string && false !== quoted_empty;
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (value) {
                    if (typeof value !== "string") return [
                        Error(`Formatter must return a string, null or undefined, got ${JSON.stringify(value)}`)
                    ];
                    const containsdelimiter = delimiter.length && value.indexOf(delimiter) >= 0;
                    const containsQuote = quote !== "" && value.indexOf(quote) >= 0;
                    const containsEscape = value.indexOf(escape) >= 0 && escape !== quote;
                    const containsRecordDelimiter = value.indexOf(record_delimiter) >= 0;
                    const quotedString = quoted_string && typeof field === "string";
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === "string") return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    // See https://github.com/adaltas/node-csv/pull/387
                    // More about CSV injection or formula injection, when websites embed
                    // untrusted input inside CSV files:
                    // https://owasp.org/www-community/attacks/CSV_Injection
                    // http://georgemauer.net/2017/10/07/csv-injection.html
                    // Apple Numbers unicode normalization is empirical from testing
                    if (escape_formulas) switch(value[0]){
                        case "=":
                        case "+":
                        case "-":
                        case "@":
                        case "	":
                        case "\r":
                        case "\uFF1D":
                        case "\uFF0B":
                        case "\uFF0D":
                        case "\uFF20":
                            value = `'${value}`;
                            break;
                    }
                    const shouldQuote = containsQuote === true || containsdelimiter || containsRecordDelimiter || quoted || quotedString || quotedMatch;
                    if (shouldQuote === true && containsEscape === true) {
                        const regexp = escape === "\\" ? new RegExp(escape + escape, "g") : new RegExp(escape, "g");
                        value = value.replace(regexp, escape + escape);
                    }
                    if (containsQuote === true) {
                        const regexp = new RegExp(quote, "g");
                        value = value.replace(regexp, escape + quote);
                    }
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (quoted_empty === true || field === "" && quoted_string === true && quoted_empty !== false) csvrecord += quote + quote;
                if (i !== record.length - 1) csvrecord += delimiter;
            }
            return [
                undefined,
                csvrecord
            ];
        },
        bom: function(push) {
            if (this.options.bom !== true) return;
            push(bom_utf8);
        },
        headers: function(push) {
            if (this.options.header === false) return;
            if (this.options.columns === undefined) return;
            let err;
            let headers = this.options.columns.map((column)=>column.header);
            if (this.options.eof) {
                [err, headers] = this.stringify(headers, true);
                headers += this.options.record_delimiter;
            } else [err, headers] = this.stringify(headers);
            if (err) return err;
            push(headers);
        },
        __cast: function(value, context) {
            const type = typeof value;
            try {
                if (type === "string") return [
                    undefined,
                    this.options.cast.string(value, context)
                ];
                else if (type === "bigint") return [
                    undefined,
                    this.options.cast.bigint(value, context)
                ];
                else if (type === "number") return [
                    undefined,
                    this.options.cast.number(value, context)
                ];
                else if (type === "boolean") return [
                    undefined,
                    this.options.cast.boolean(value, context)
                ];
                else if (value instanceof Date) return [
                    undefined,
                    this.options.cast.date(value, context)
                ];
                else if (type === "object" && value !== null) return [
                    undefined,
                    this.options.cast.object(value, context)
                ];
                else return [
                    undefined,
                    value,
                    value
                ];
            } catch (err) {
                return [
                    err
                ];
            }
        }
    };
};
const stringify = function(records, opts = {}) {
    const data = [];
    const [err, options] = normalize_options(opts);
    if (err !== undefined) throw err;
    const state = {
        stop: false
    };
    // Information
    const info = {
        records: 0
    };
    const api = stringifier(options, state, info);
    for (const record of records){
        const err = api.__transform(record, function(record) {
            data.push(record);
        });
        if (err !== undefined) throw err;
    }
    if (data.length === 0) {
        api.bom((d)=>{
            data.push(d);
        });
        const err = api.headers((headers)=>{
            data.push(headers);
        });
        if (err !== undefined) throw err;
    }
    return data.join("");
};
exports.stringify = stringify;

});

parcelRegister("3JxLy", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $efbdd6c6c3875edb$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $ioRHp = parcelRequire("ioRHp");
class CsvError extends Error {
    constructor(code, message, ...contexts){
        if (Array.isArray(message)) message = message.join(" ");
        super(message);
        if (Error.captureStackTrace !== undefined) Error.captureStackTrace(this, CsvError);
        this.code = code;
        for (const context of contexts)for(const key in context){
            const value = context[key];
            this[key] = $efbdd6c6c3875edb$require$Buffer.isBuffer(value) ? value.toString() : value == null ? value : JSON.parse(JSON.stringify(value));
        }
    }
}
const is_object = function(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};
// Lodash implementation of `get`
const charCodeOfDot = ".".charCodeAt(0);
const reEscapeChar = /\\(\\)?/g;
const rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
const reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const reIsPlainProp = /^\w*$/;
const getTag = function(value) {
    return Object.prototype.toString.call(value);
};
const isSymbol = function(value) {
    const type = typeof value;
    return type === "symbol" || type === "object" && value && getTag(value) === "[object Symbol]";
};
const isKey = function(value, object) {
    if (Array.isArray(value)) return false;
    const type = typeof value;
    if (type === "number" || type === "symbol" || type === "boolean" || !value || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
};
const stringToPath = function(string) {
    const result = [];
    if (string.charCodeAt(0) === charCodeOfDot) result.push("");
    string.replace(rePropName, function(match, expression, quote, subString) {
        let key = match;
        if (quote) key = subString.replace(reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
const castPath = function(value, object) {
    if (Array.isArray(value)) return value;
    else return isKey(value, object) ? [
        value
    ] : stringToPath(value);
};
const toKey = function(value) {
    if (typeof value === "string" || isSymbol(value)) return value;
    const result = `${value}`;
    // eslint-disable-next-line
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
};
const get = function(object, path) {
    path = castPath(path, object);
    let index = 0;
    const length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index === length ? object : undefined;
};
const normalize_columns = function(columns) {
    if (columns === undefined || columns === null) return [
        undefined,
        undefined
    ];
    if (typeof columns !== "object") return [
        Error('Invalid option "columns": expect an array or an object')
    ];
    if (!Array.isArray(columns)) {
        const newcolumns = [];
        for(const k in columns)newcolumns.push({
            key: k,
            header: columns[k]
        });
        columns = newcolumns;
    } else {
        const newcolumns = [];
        for (const column of columns){
            if (typeof column === "string") newcolumns.push({
                key: column,
                header: column
            });
            else if (typeof column === "object" && column !== null && !Array.isArray(column)) {
                if (!column.key) return [
                    Error('Invalid column definition: property "key" is required')
                ];
                if (column.header === undefined) column.header = column.key;
                newcolumns.push(column);
            } else return [
                Error("Invalid column definition: expect a string or an object")
            ];
        }
        columns = newcolumns;
    }
    return [
        undefined,
        columns
    ];
};
const underscore = function(str) {
    return str.replace(/([A-Z])/g, function(_, match) {
        return "_" + match.toLowerCase();
    });
};
const normalize_options = function(opts) {
    const options = {};
    // Merge with user options
    for(const opt in opts)options[underscore(opt)] = opts[opt];
    // Normalize option `bom`
    if (options.bom === undefined || options.bom === null || options.bom === false) options.bom = false;
    else if (options.bom !== true) return [
        new CsvError("CSV_OPTION_BOOLEAN_INVALID_TYPE", [
            "option `bom` is optional and must be a boolean value,",
            `got ${JSON.stringify(options.bom)}`
        ])
    ];
    // Normalize option `delimiter`
    if (options.delimiter === undefined || options.delimiter === null) options.delimiter = ",";
    else if ($efbdd6c6c3875edb$require$Buffer.isBuffer(options.delimiter)) options.delimiter = options.delimiter.toString();
    else if (typeof options.delimiter !== "string") return [
        new CsvError("CSV_OPTION_DELIMITER_INVALID_TYPE", [
            "option `delimiter` must be a buffer or a string,",
            `got ${JSON.stringify(options.delimiter)}`
        ])
    ];
    // Normalize option `quote`
    if (options.quote === undefined || options.quote === null) options.quote = '"';
    else if (options.quote === true) options.quote = '"';
    else if (options.quote === false) options.quote = "";
    else if ($efbdd6c6c3875edb$require$Buffer.isBuffer(options.quote)) options.quote = options.quote.toString();
    else if (typeof options.quote !== "string") return [
        new CsvError("CSV_OPTION_QUOTE_INVALID_TYPE", [
            "option `quote` must be a boolean, a buffer or a string,",
            `got ${JSON.stringify(options.quote)}`
        ])
    ];
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `escape_formulas`
    if (options.escape_formulas === undefined || options.escape_formulas === null) options.escape_formulas = false;
    else if (typeof options.escape_formulas !== "boolean") return [
        new CsvError("CSV_OPTION_ESCAPE_FORMULAS_INVALID_TYPE", [
            "option `escape_formulas` must be a boolean,",
            `got ${JSON.stringify(options.escape_formulas)}`
        ])
    ];
    // Normalize option `quoted_empty`
    if (options.quoted_empty === undefined || options.quoted_empty === null) options.quoted_empty = undefined;
    // Normalize option `quoted_match`
    if (options.quoted_match === undefined || options.quoted_match === null || options.quoted_match === false) options.quoted_match = null;
    else if (!Array.isArray(options.quoted_match)) options.quoted_match = [
        options.quoted_match
    ];
    if (options.quoted_match) for (const quoted_match of options.quoted_match){
        const isString = typeof quoted_match === "string";
        const isRegExp = quoted_match instanceof RegExp;
        if (!isString && !isRegExp) return [
            Error(`Invalid Option: quoted_match must be a string or a regex, got ${JSON.stringify(quoted_match)}`)
        ];
    }
    // Normalize option `quoted_string`
    if (options.quoted_string === undefined || options.quoted_string === null) options.quoted_string = false;
    // Normalize option `eof`
    if (options.eof === undefined || options.eof === null) options.eof = true;
    // Normalize option `escape`
    if (options.escape === undefined || options.escape === null) options.escape = '"';
    else if ($efbdd6c6c3875edb$require$Buffer.isBuffer(options.escape)) options.escape = options.escape.toString();
    else if (typeof options.escape !== "string") return [
        Error(`Invalid Option: escape must be a buffer or a string, got ${JSON.stringify(options.escape)}`)
    ];
    if (options.escape.length > 1) return [
        Error(`Invalid Option: escape must be one character, got ${options.escape.length} characters`)
    ];
    // Normalize option `header`
    if (options.header === undefined || options.header === null) options.header = false;
    // Normalize option `columns`
    const [errColumns, columns] = normalize_columns(options.columns);
    if (errColumns !== undefined) return [
        errColumns
    ];
    options.columns = columns;
    // Normalize option `quoted`
    if (options.quoted === undefined || options.quoted === null) options.quoted = false;
    // Normalize option `cast`
    if (options.cast === undefined || options.cast === null) options.cast = {};
    // Normalize option cast.bigint
    if (options.cast.bigint === undefined || options.cast.bigint === null) // Cast boolean to string by default
    options.cast.bigint = (value)=>"" + value;
    // Normalize option cast.boolean
    if (options.cast.boolean === undefined || options.cast.boolean === null) // Cast boolean to string by default
    options.cast.boolean = (value)=>value ? "1" : "";
    // Normalize option cast.date
    if (options.cast.date === undefined || options.cast.date === null) // Cast date to timestamp string by default
    options.cast.date = (value)=>"" + value.getTime();
    // Normalize option cast.number
    if (options.cast.number === undefined || options.cast.number === null) // Cast number to string using native casting by default
    options.cast.number = (value)=>"" + value;
    // Normalize option cast.object
    if (options.cast.object === undefined || options.cast.object === null) // Stringify object as JSON by default
    options.cast.object = (value)=>JSON.stringify(value);
    // Normalize option cast.string
    if (options.cast.string === undefined || options.cast.string === null) // Leave string untouched
    options.cast.string = function(value) {
        return value;
    };
    // Normalize option `on_record`
    if (options.on_record !== undefined && typeof options.on_record !== "function") return [
        Error(`Invalid Option: "on_record" must be a function.`)
    ];
    // Normalize option `record_delimiter`
    if (options.record_delimiter === undefined || options.record_delimiter === null) options.record_delimiter = "\n";
    else if ($efbdd6c6c3875edb$require$Buffer.isBuffer(options.record_delimiter)) options.record_delimiter = options.record_delimiter.toString();
    else if (typeof options.record_delimiter !== "string") return [
        Error(`Invalid Option: record_delimiter must be a buffer or a string, got ${JSON.stringify(options.record_delimiter)}`)
    ];
    switch(options.record_delimiter){
        case "unix":
            options.record_delimiter = "\n";
            break;
        case "mac":
            options.record_delimiter = "\r";
            break;
        case "windows":
            options.record_delimiter = "\r\n";
            break;
        case "ascii":
            options.record_delimiter = "\x1e";
            break;
        case "unicode":
            options.record_delimiter = "\u2028";
            break;
    }
    return [
        undefined,
        options
    ];
};
const bom_utf8 = $efbdd6c6c3875edb$require$Buffer.from([
    239,
    187,
    191
]);
const stringifier = function(options, state, info) {
    return {
        options: options,
        state: state,
        info: info,
        __transform: function(chunk, push) {
            // Chunk validation
            if (!Array.isArray(chunk) && typeof chunk !== "object") return Error(`Invalid Record: expect an array or an object, got ${JSON.stringify(chunk)}`);
            // Detect columns from the first record
            if (this.info.records === 0) {
                if (Array.isArray(chunk)) {
                    if (this.options.header === true && this.options.columns === undefined) return Error("Undiscoverable Columns: header option requires column option or object records");
                } else if (this.options.columns === undefined) {
                    const [err, columns] = normalize_columns(Object.keys(chunk));
                    if (err) return;
                    this.options.columns = columns;
                }
            }
            // Emit the header
            if (this.info.records === 0) {
                this.bom(push);
                const err = this.headers(push);
                if (err) return err;
            }
            // Emit and stringify the record if an object or an array
            try {
                // this.emit('record', chunk, this.info.records);
                if (this.options.on_record) this.options.on_record(chunk, this.info.records);
            } catch (err) {
                return err;
            }
            // Convert the record into a string
            let err, chunk_string;
            if (this.options.eof) {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else chunk_string = chunk_string + this.options.record_delimiter;
            } else {
                [err, chunk_string] = this.stringify(chunk);
                if (err) return err;
                if (chunk_string === undefined) return;
                else if (this.options.header || this.info.records) chunk_string = this.options.record_delimiter + chunk_string;
            }
            // Emit the csv
            this.info.records++;
            push(chunk_string);
        },
        stringify: function(chunk, chunkIsHeader = false) {
            if (typeof chunk !== "object") return [
                undefined,
                chunk
            ];
            const { columns } = this.options;
            const record = [];
            // Record is an array
            if (Array.isArray(chunk)) {
                // We are getting an array but the user has specified output columns. In
                // this case, we respect the columns indexes
                if (columns) chunk.splice(columns.length);
                // Cast record elements
                for(let i = 0; i < chunk.length; i++){
                    const field = chunk[i];
                    const [err, value] = this.__cast(field, {
                        index: i,
                        column: i,
                        records: this.info.records,
                        header: chunkIsHeader
                    });
                    if (err) return [
                        err
                    ];
                    record[i] = [
                        value,
                        field
                    ];
                }
            // Record is a literal object
            // `columns` is always defined: it is either provided or discovered.
            } else for(let i = 0; i < columns.length; i++){
                const field = get(chunk, columns[i].key);
                const [err, value] = this.__cast(field, {
                    index: i,
                    column: columns[i].key,
                    records: this.info.records,
                    header: chunkIsHeader
                });
                if (err) return [
                    err
                ];
                record[i] = [
                    value,
                    field
                ];
            }
            let csvrecord = "";
            for(let i = 0; i < record.length; i++){
                let options, err;
                // eslint-disable-next-line
                let [value, field] = record[i];
                if (typeof value === "string") options = this.options;
                else if (is_object(value)) {
                    options = value;
                    value = options.value;
                    delete options.value;
                    if (typeof value !== "string" && value !== undefined && value !== null) {
                        if (err) return [
                            Error(`Invalid Casting Value: returned value must return a string, null or undefined, got ${JSON.stringify(value)}`)
                        ];
                    }
                    options = {
                        ...this.options,
                        ...options
                    };
                    [err, options] = normalize_options(options);
                    if (err !== undefined) return [
                        err
                    ];
                } else if (value === undefined || value === null) options = this.options;
                else return [
                    Error(`Invalid Casting Value: returned value must return a string, an object, null or undefined, got ${JSON.stringify(value)}`)
                ];
                const { delimiter, escape, quote, quoted, quoted_empty, quoted_string, quoted_match, record_delimiter, escape_formulas } = options;
                if ("" === value && "" === field) {
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === "string") return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    const shouldQuote = quotedMatch || true === quoted_empty || true === quoted_string && false !== quoted_empty;
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (value) {
                    if (typeof value !== "string") return [
                        Error(`Formatter must return a string, null or undefined, got ${JSON.stringify(value)}`)
                    ];
                    const containsdelimiter = delimiter.length && value.indexOf(delimiter) >= 0;
                    const containsQuote = quote !== "" && value.indexOf(quote) >= 0;
                    const containsEscape = value.indexOf(escape) >= 0 && escape !== quote;
                    const containsRecordDelimiter = value.indexOf(record_delimiter) >= 0;
                    const quotedString = quoted_string && typeof field === "string";
                    let quotedMatch = quoted_match && quoted_match.filter((quoted_match)=>{
                        if (typeof quoted_match === "string") return value.indexOf(quoted_match) !== -1;
                        else return quoted_match.test(value);
                    });
                    quotedMatch = quotedMatch && quotedMatch.length > 0;
                    // See https://github.com/adaltas/node-csv/pull/387
                    // More about CSV injection or formula injection, when websites embed
                    // untrusted input inside CSV files:
                    // https://owasp.org/www-community/attacks/CSV_Injection
                    // http://georgemauer.net/2017/10/07/csv-injection.html
                    // Apple Numbers unicode normalization is empirical from testing
                    if (escape_formulas) switch(value[0]){
                        case "=":
                        case "+":
                        case "-":
                        case "@":
                        case "	":
                        case "\r":
                        case "\uFF1D":
                        case "\uFF0B":
                        case "\uFF0D":
                        case "\uFF20":
                            value = `'${value}`;
                            break;
                    }
                    const shouldQuote = containsQuote === true || containsdelimiter || containsRecordDelimiter || quoted || quotedString || quotedMatch;
                    if (shouldQuote === true && containsEscape === true) {
                        const regexp = escape === "\\" ? new RegExp(escape + escape, "g") : new RegExp(escape, "g");
                        value = value.replace(regexp, escape + escape);
                    }
                    if (containsQuote === true) {
                        const regexp = new RegExp(quote, "g");
                        value = value.replace(regexp, escape + quote);
                    }
                    if (shouldQuote === true) value = quote + value + quote;
                    csvrecord += value;
                } else if (quoted_empty === true || field === "" && quoted_string === true && quoted_empty !== false) csvrecord += quote + quote;
                if (i !== record.length - 1) csvrecord += delimiter;
            }
            return [
                undefined,
                csvrecord
            ];
        },
        bom: function(push) {
            if (this.options.bom !== true) return;
            push(bom_utf8);
        },
        headers: function(push) {
            if (this.options.header === false) return;
            if (this.options.columns === undefined) return;
            let err;
            let headers = this.options.columns.map((column)=>column.header);
            if (this.options.eof) {
                [err, headers] = this.stringify(headers, true);
                headers += this.options.record_delimiter;
            } else [err, headers] = this.stringify(headers);
            if (err) return err;
            push(headers);
        },
        __cast: function(value, context) {
            const type = typeof value;
            try {
                if (type === "string") return [
                    undefined,
                    this.options.cast.string(value, context)
                ];
                else if (type === "bigint") return [
                    undefined,
                    this.options.cast.bigint(value, context)
                ];
                else if (type === "number") return [
                    undefined,
                    this.options.cast.number(value, context)
                ];
                else if (type === "boolean") return [
                    undefined,
                    this.options.cast.boolean(value, context)
                ];
                else if (value instanceof Date) return [
                    undefined,
                    this.options.cast.date(value, context)
                ];
                else if (type === "object" && value !== null) return [
                    undefined,
                    this.options.cast.object(value, context)
                ];
                else return [
                    undefined,
                    value,
                    value
                ];
            } catch (err) {
                return [
                    err
                ];
            }
        }
    };
};
class Stringifier extends $ioRHp.Transform {
    constructor(opts = {}){
        super({
            writableObjectMode: true,
            ...opts
        });
        const [err, options] = normalize_options(opts);
        if (err !== undefined) throw err;
        // Expose options
        this.options = options;
        // Internal state
        this.state = {
            stop: false
        };
        // Information
        this.info = {
            records: 0
        };
        this.api = stringifier(this.options, this.state, this.info);
        this.api.options.on_record = (...args)=>{
            this.emit("record", ...args);
        };
    }
    _transform(chunk, encoding, callback) {
        if (this.state.stop === true) return;
        const err = this.api.__transform(chunk, this.push.bind(this));
        if (err !== undefined) this.state.stop = true;
        callback(err);
    }
    _flush(callback) {
        if (this.state.stop === true) // Note, Node.js 12 call flush even after an error, we must prevent
        // `callback` from being called in flush without any error.
        return;
        if (this.info.records === 0) {
            this.api.bom(this.push.bind(this));
            const err = this.api.headers(this.push.bind(this));
            if (err) callback(err);
        }
        callback();
    }
}
const stringify = function() {
    let data, options, callback;
    for(const i in arguments){
        const argument = arguments[i];
        const type = typeof argument;
        if (data === undefined && Array.isArray(argument)) data = argument;
        else if (options === undefined && is_object(argument)) options = argument;
        else if (callback === undefined && type === "function") callback = argument;
        else throw new CsvError("CSV_INVALID_ARGUMENT", [
            "Invalid argument:",
            `got ${JSON.stringify(argument)} at index ${i}`
        ]);
    }
    const stringifier = new Stringifier(options);
    if (callback) {
        const chunks = [];
        stringifier.on("readable", function() {
            let chunk;
            while((chunk = this.read()) !== null)chunks.push(chunk);
        });
        stringifier.on("error", function(err) {
            callback(err);
        });
        stringifier.on("end", function() {
            try {
                callback(undefined, chunks.join(""));
            } catch (err) {
                // This can happen if the `chunks` is extremely long; it may throw
                // "Cannot create a string longer than 0x1fffffe8 characters"
                // See [#386](https://github.com/adaltas/node-csv/pull/386)
                callback(err);
                return;
            }
        });
    }
    if (data !== undefined) {
        const writer = function() {
            for (const record of data)stringifier.write(record);
            stringifier.end();
        };
        // Support Deno, Rollup doesnt provide a shim for setImmediate
        if (typeof setImmediate === "function") setImmediate(writer);
        else setTimeout(writer, 0);
    }
    return stringifier;
};
exports.CsvError = CsvError;
exports.Stringifier = Stringifier;
exports.stringify = stringify;

});

parcelRegister("eRV67", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ad324e565f74e0a8$export$2e2bcd8739ae039);
/**
 * WinBox.js
 * Copyright 2022 Nextapps GmbH
 * Author: Thomas Wilkerling
 * Licence: Apache-2.0
 * https://github.com/nextapps-de/winbox
 */ 
var $juxAT = parcelRequire("juxAT");

var $2lfy6 = parcelRequire("2lfy6");
//const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window["MSStream"];
const $ad324e565f74e0a8$var$use_raf = false;
const $ad324e565f74e0a8$var$stack_min = [];
// use passive for touch and mouse wheel
const $ad324e565f74e0a8$var$eventOptions = {
    "capture": true,
    "passive": true
};
let $ad324e565f74e0a8$var$body;
let $ad324e565f74e0a8$var$id_counter = 0;
let $ad324e565f74e0a8$var$index_counter = 10;
let $ad324e565f74e0a8$var$is_fullscreen;
let $ad324e565f74e0a8$var$last_focus;
let $ad324e565f74e0a8$var$prefix_request;
let $ad324e565f74e0a8$var$prefix_exit;
let $ad324e565f74e0a8$var$root_w, $ad324e565f74e0a8$var$root_h;
/**
 * @param {string|Object=} params
 * @param {Object=} _title
 * @constructor
 * @this WinBox
 */ function $ad324e565f74e0a8$var$WinBox(params, _title) {
    if (!(this instanceof $ad324e565f74e0a8$var$WinBox)) return new $ad324e565f74e0a8$var$WinBox(params);
    $ad324e565f74e0a8$var$body || $ad324e565f74e0a8$var$setup();
    let id, index, root, tpl, title, icon, mount, html, url, width, height, minwidth, minheight, maxwidth, maxheight, autosize, x, y, top, left, bottom, right, min, max, hidden, modal, background, border, header, classname, oncreate, onclose, onfocus, onblur, onmove, onresize, onfullscreen, onmaximize, onminimize, onrestore, onhide, onshow, onload;
    if (params) {
        if (_title) {
            title = params;
            params = _title;
        }
        if (typeof params === "string") title = params;
        else {
            id = params["id"];
            index = params["index"];
            root = params["root"];
            tpl = params["template"];
            title = title || params["title"];
            icon = params["icon"];
            mount = params["mount"];
            html = params["html"];
            url = params["url"];
            width = params["width"];
            height = params["height"];
            minwidth = params["minwidth"];
            minheight = params["minheight"];
            maxwidth = params["maxwidth"];
            maxheight = params["maxheight"];
            autosize = params["autosize"];
            min = params["min"];
            max = params["max"];
            hidden = params["hidden"];
            modal = params["modal"];
            x = params["x"] || (modal ? "center" : 0);
            y = params["y"] || (modal ? "center" : 0);
            top = params["top"];
            left = params["left"];
            bottom = params["bottom"];
            right = params["right"];
            background = params["background"];
            border = params["border"];
            header = params["header"];
            classname = params["class"];
            onclose = params["onclose"];
            onfocus = params["onfocus"];
            onblur = params["onblur"];
            onmove = params["onmove"];
            onresize = params["onresize"];
            onfullscreen = params["onfullscreen"];
            onmaximize = params["onmaximize"];
            onminimize = params["onminimize"];
            onrestore = params["onrestore"];
            onhide = params["onhide"];
            onshow = params["onshow"];
            onload = params["onload"];
        }
    }
    this.dom = (0, $juxAT.default)(tpl);
    this.dom.id = this.id = id || "winbox-" + ++$ad324e565f74e0a8$var$id_counter;
    this.dom.className = "winbox" + (classname ? " " + (typeof classname === "string" ? classname : classname.join(" ")) : "") + (modal ? " modal" : "");
    this.dom["winbox"] = this;
    this.window = this.dom;
    this.body = (0, $2lfy6.getByClass)(this.dom, "wb-body");
    this.header = header || 35;
    //this.plugins = [];
    if (background) this.setBackground(background);
    if (border) (0, $2lfy6.setStyle)(this.body, "margin", border + (isNaN(border) ? "" : "px"));
    else border = 0;
    if (header) {
        const node = (0, $2lfy6.getByClass)(this.dom, "wb-header");
        (0, $2lfy6.setStyle)(node, "height", header + "px");
        (0, $2lfy6.setStyle)(node, "line-height", header + "px");
        (0, $2lfy6.setStyle)(this.body, "top", header + "px");
    }
    if (title) this.setTitle(title);
    if (icon) this.setIcon(icon);
    if (mount) this.mount(mount);
    else if (html) this.body.innerHTML = html;
    else if (url) this.setUrl(url, onload);
    top = top ? $ad324e565f74e0a8$var$parse(top, $ad324e565f74e0a8$var$root_h) : 0;
    bottom = bottom ? $ad324e565f74e0a8$var$parse(bottom, $ad324e565f74e0a8$var$root_h) : 0;
    left = left ? $ad324e565f74e0a8$var$parse(left, $ad324e565f74e0a8$var$root_w) : 0;
    right = right ? $ad324e565f74e0a8$var$parse(right, $ad324e565f74e0a8$var$root_w) : 0;
    const viewport_w = $ad324e565f74e0a8$var$root_w - left - right;
    const viewport_h = $ad324e565f74e0a8$var$root_h - top - bottom;
    maxwidth = maxwidth ? $ad324e565f74e0a8$var$parse(maxwidth, viewport_w) : viewport_w;
    maxheight = maxheight ? $ad324e565f74e0a8$var$parse(maxheight, viewport_h) : viewport_h;
    minwidth = minwidth ? $ad324e565f74e0a8$var$parse(minwidth, maxwidth) : 150;
    minheight = minheight ? $ad324e565f74e0a8$var$parse(minheight, maxheight) : this.header;
    if (autosize) {
        (root || $ad324e565f74e0a8$var$body).appendChild(this.body);
        width = Math.max(Math.min(this.body.clientWidth + border * 2 + 1, maxwidth), minwidth);
        height = Math.max(Math.min(this.body.clientHeight + this.header + border + 1, maxheight), minheight);
        this.dom.appendChild(this.body);
    } else {
        width = width ? $ad324e565f74e0a8$var$parse(width, maxwidth) : Math.max(maxwidth / 2, minwidth) | 0;
        height = height ? $ad324e565f74e0a8$var$parse(height, maxheight) : Math.max(maxheight / 2, minheight) | 0;
    }
    x = x ? $ad324e565f74e0a8$var$parse(x, viewport_w, width) : left;
    y = y ? $ad324e565f74e0a8$var$parse(y, viewport_h, height) : top;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.minwidth = minwidth;
    this.minheight = minheight;
    this.maxwidth = maxwidth;
    this.maxheight = maxheight;
    this.top = top;
    this.right = right;
    this.bottom = bottom;
    this.left = left;
    this.index = index;
    //this.border = border;
    this.min = false;
    this.max = false;
    this.full = false;
    this.hidden = false;
    this.focused = false;
    this.onclose = onclose;
    this.onfocus = onfocus;
    this.onblur = onblur;
    this.onmove = onmove;
    this.onresize = onresize;
    this.onfullscreen = onfullscreen;
    this.onmaximize = onmaximize;
    this.onminimize = onminimize;
    this.onrestore = onrestore;
    this.onhide = onhide;
    this.onshow = onshow;
    if (max) this.maximize();
    else if (min) this.minimize();
    else this.resize().move();
    if (hidden) this.hide();
    else {
        this.focus();
        if (index || index === 0) {
            this.index = index;
            (0, $2lfy6.setStyle)(this.dom, "z-index", index);
            if (index > $ad324e565f74e0a8$var$index_counter) $ad324e565f74e0a8$var$index_counter = index;
        }
    }
    $ad324e565f74e0a8$var$register(this);
    (root || $ad324e565f74e0a8$var$body).appendChild(this.dom);
    (oncreate = params["oncreate"]) && oncreate.call(this, params);
}
$ad324e565f74e0a8$var$WinBox["new"] = function(params) {
    return new $ad324e565f74e0a8$var$WinBox(params);
};
var $ad324e565f74e0a8$export$2e2bcd8739ae039 = $ad324e565f74e0a8$var$WinBox;
/**
 * @param {number|string} num
 * @param {number} base
 * @param {number=} center
 * @return number
 */ function $ad324e565f74e0a8$var$parse(num, base, center) {
    if (typeof num === "string") {
        if (num === "center") num = (base - center) / 2 | 0;
        else if (num === "right" || num === "bottom") num = base - center;
        else {
            const value = parseFloat(num);
            const unit = "" + value !== num && num.substring(("" + value).length);
            if (unit === "%") num = base / 100 * value | 0;
            else num = value;
        }
    }
    return num;
}
function $ad324e565f74e0a8$var$setup() {
    $ad324e565f74e0a8$var$body = document.body;
    $ad324e565f74e0a8$var$body[$ad324e565f74e0a8$var$prefix_request = "requestFullscreen"] || $ad324e565f74e0a8$var$body[$ad324e565f74e0a8$var$prefix_request = "msRequestFullscreen"] || $ad324e565f74e0a8$var$body[$ad324e565f74e0a8$var$prefix_request = "webkitRequestFullscreen"] || $ad324e565f74e0a8$var$body[$ad324e565f74e0a8$var$prefix_request = "mozRequestFullscreen"] || ($ad324e565f74e0a8$var$prefix_request = "");
    $ad324e565f74e0a8$var$prefix_exit = $ad324e565f74e0a8$var$prefix_request && $ad324e565f74e0a8$var$prefix_request.replace("request", "exit").replace("mozRequest", "mozCancel").replace("Request", "Exit");
    (0, $2lfy6.addListener)(window, "resize", function() {
        $ad324e565f74e0a8$var$init();
        $ad324e565f74e0a8$var$update_min_stack();
    });
    $ad324e565f74e0a8$var$init();
}
/**
 * @param {WinBox} self
 */ function $ad324e565f74e0a8$var$register(self) {
    $ad324e565f74e0a8$var$addWindowListener(self, "drag");
    $ad324e565f74e0a8$var$addWindowListener(self, "n");
    $ad324e565f74e0a8$var$addWindowListener(self, "s");
    $ad324e565f74e0a8$var$addWindowListener(self, "w");
    $ad324e565f74e0a8$var$addWindowListener(self, "e");
    $ad324e565f74e0a8$var$addWindowListener(self, "nw");
    $ad324e565f74e0a8$var$addWindowListener(self, "ne");
    $ad324e565f74e0a8$var$addWindowListener(self, "se");
    $ad324e565f74e0a8$var$addWindowListener(self, "sw");
    (0, $2lfy6.addListener)((0, $2lfy6.getByClass)(self.dom, "wb-min"), "click", function(event) {
        (0, $2lfy6.preventEvent)(event);
        self.min ? self.focus().restore() : self.blur().minimize();
    });
    (0, $2lfy6.addListener)((0, $2lfy6.getByClass)(self.dom, "wb-max"), "click", function(event) {
        self.max ? self.restore() : self.maximize();
    });
    if ($ad324e565f74e0a8$var$prefix_request) (0, $2lfy6.addListener)((0, $2lfy6.getByClass)(self.dom, "wb-full"), "click", function(event) {
        self.fullscreen();
    });
    else self.addClass("no-full");
    (0, $2lfy6.addListener)((0, $2lfy6.getByClass)(self.dom, "wb-close"), "click", function(event) {
        (0, $2lfy6.preventEvent)(event);
        self.close() || (self = null);
    });
    (0, $2lfy6.addListener)(self.dom, "click", function(event) {
        // stop propagation would disable global listeners used inside window contents
        // use event bubbling for this listener to skip this handler by the other click listeners
        self.focus();
    });
}
/**
 * @param {WinBox} self
 */ function $ad324e565f74e0a8$var$remove_min_stack(self) {
    $ad324e565f74e0a8$var$stack_min.splice($ad324e565f74e0a8$var$stack_min.indexOf(self), 1);
    $ad324e565f74e0a8$var$update_min_stack();
    self.removeClass("min");
    self.min = false;
    self.dom.title = "";
}
function $ad324e565f74e0a8$var$update_min_stack() {
    const length = $ad324e565f74e0a8$var$stack_min.length;
    const splitscreen_index = {};
    const splitscreen_length = {};
    for(let i = 0, self, key; i < length; i++){
        self = $ad324e565f74e0a8$var$stack_min[i];
        key = (self.left || self.right) + ":" + (self.top || self.bottom);
        if (splitscreen_length[key]) splitscreen_length[key]++;
        else {
            splitscreen_index[key] = 0;
            splitscreen_length[key] = 1;
        }
    }
    for(let i = 0, self, key, width; i < length; i++){
        self = $ad324e565f74e0a8$var$stack_min[i];
        key = (self.left || self.right) + ":" + (self.top || self.bottom);
        width = Math.min(($ad324e565f74e0a8$var$root_w - self.left - self.right) / splitscreen_length[key], 250);
        //splitscreen_index[key] || (splitscreen_index[key] = 0);
        self.resize(width + 1 | 0, self.header, true).move(self.left + splitscreen_index[key] * width | 0, $ad324e565f74e0a8$var$root_h - self.bottom - self.header, true);
        splitscreen_index[key]++;
    }
}
/**
 * @param {WinBox} self
 * @param {string} dir
 */ function $ad324e565f74e0a8$var$addWindowListener(self, dir) {
    const node = (0, $2lfy6.getByClass)(self.dom, "wb-" + dir);
    if (!node) return;
    let touch, x, y;
    let raf_timer, raf_move, raf_resize;
    let dblclick_timer = 0;
    (0, $2lfy6.addListener)(node, "mousedown", mousedown);
    (0, $2lfy6.addListener)(node, "touchstart", mousedown, $ad324e565f74e0a8$var$eventOptions);
    function loop() {
        raf_timer = requestAnimationFrame(loop);
        if (raf_resize) {
            self.resize();
            raf_resize = false;
        }
        if (raf_move) {
            self.move();
            raf_move = false;
        }
    }
    function mousedown(event) {
        // prevent the full iteration through the fallback chain of a touch event (touch > mouse > click)
        (0, $2lfy6.preventEvent)(event);
        self.focus();
        if (dir === "drag") {
            if (self.min) {
                self.restore();
                return;
            }
            const now = Date.now();
            const diff = now - dblclick_timer;
            dblclick_timer = now;
            if (diff < 300) {
                self.max ? self.restore() : self.maximize();
                return;
            }
        }
        if (!self.max && !self.min) {
            (0, $2lfy6.addClass)($ad324e565f74e0a8$var$body, "wb-lock");
            $ad324e565f74e0a8$var$use_raf && loop();
            if ((touch = event.touches) && (touch = touch[0])) {
                event = touch;
                // TODO: fix when touch events bubbles up to the document body
                //addListener(self.dom, "touchmove", preventEvent);
                (0, $2lfy6.addListener)(window, "touchmove", handler_mousemove, $ad324e565f74e0a8$var$eventOptions);
                (0, $2lfy6.addListener)(window, "touchend", handler_mouseup, $ad324e565f74e0a8$var$eventOptions);
            } else {
                //addListener(this, "mouseleave", handler_mouseup);
                (0, $2lfy6.addListener)(window, "mousemove", handler_mousemove);
                (0, $2lfy6.addListener)(window, "mouseup", handler_mouseup);
            }
            x = event.pageX;
            y = event.pageY;
        // appearing scrollbars on the root element does not trigger "window.onresize",
        // force refresh window size via init(), also force layout recalculation (layout trashing)
        // it is probably very rare that the body overflow changes between window open and close
        //init();
        }
    }
    function handler_mousemove(event) {
        (0, $2lfy6.preventEvent)(event);
        if (touch) event = event.touches[0];
        const pageX = event.pageX;
        const pageY = event.pageY;
        const offsetX = pageX - x;
        const offsetY = pageY - y;
        const old_w = self.width;
        const old_h = self.height;
        const old_x = self.x;
        const old_y = self.y;
        let resize_w, resize_h, move_x, move_y;
        if (dir === "drag") {
            self.x += offsetX;
            self.y += offsetY;
            move_x = move_y = 1;
        } else {
            if (dir === "e" || dir === "se" || dir === "ne") {
                self.width += offsetX;
                resize_w = 1;
            } else if (dir === "w" || dir === "sw" || dir === "nw") {
                self.x += offsetX;
                self.width -= offsetX;
                resize_w = 1;
                move_x = 1;
            }
            if (dir === "s" || dir === "se" || dir === "sw") {
                self.height += offsetY;
                resize_h = 1;
            } else if (dir === "n" || dir === "ne" || dir === "nw") {
                self.y += offsetY;
                self.height -= offsetY;
                resize_h = 1;
                move_y = 1;
            }
        }
        if (resize_w) {
            self.width = Math.max(Math.min(self.width, self.maxwidth, $ad324e565f74e0a8$var$root_w - self.x - self.right), self.minwidth);
            resize_w = self.width !== old_w;
        }
        if (resize_h) {
            self.height = Math.max(Math.min(self.height, self.maxheight, $ad324e565f74e0a8$var$root_h - self.y - self.bottom), self.minheight);
            resize_h = self.height !== old_h;
        }
        if (resize_w || resize_h) $ad324e565f74e0a8$var$use_raf ? raf_resize = true : self.resize();
        if (move_x) {
            self.x = Math.max(Math.min(self.x, $ad324e565f74e0a8$var$root_w - self.width - self.right), self.left);
            move_x = self.x !== old_x;
        }
        if (move_y) {
            self.y = Math.max(Math.min(self.y, $ad324e565f74e0a8$var$root_h - self.height - self.bottom), self.top);
            move_y = self.y !== old_y;
        }
        if (move_x || move_y) $ad324e565f74e0a8$var$use_raf ? raf_move = true : self.move();
        if (resize_w || move_x) x = pageX;
        if (resize_h || move_y) y = pageY;
    }
    function handler_mouseup(event) {
        (0, $2lfy6.preventEvent)(event);
        (0, $2lfy6.removeClass)($ad324e565f74e0a8$var$body, "wb-lock");
        $ad324e565f74e0a8$var$use_raf && cancelAnimationFrame(raf_timer);
        if (touch) {
            //removeListener(self.dom, "touchmove", preventEvent);
            (0, $2lfy6.removeListener)(window, "touchmove", handler_mousemove, $ad324e565f74e0a8$var$eventOptions);
            (0, $2lfy6.removeListener)(window, "touchend", handler_mouseup, $ad324e565f74e0a8$var$eventOptions);
        } else {
            //removeListener(this, "mouseleave", handler_mouseup);
            (0, $2lfy6.removeListener)(window, "mousemove", handler_mousemove);
            (0, $2lfy6.removeListener)(window, "mouseup", handler_mouseup);
        }
    }
}
function $ad324e565f74e0a8$var$init() {
    // TODO: the window height of iOS isn't determined correctly when the bottom toolbar disappears
    // the bounding rect provides more precise dimensions (float values)
    // //const rect = doc.getBoundingClientRect();
    // this.root_w = doc.clientWidth; //rect.width || (rect.right - rect.left);
    // this.root_h = doc.clientHeight; //rect.height || (rect.top - rect.bottom);
    // if(ios){
    //     this.root_h = window.innerHeight * (this.root_w / window.innerWidth);
    // }
    // root_w = doc.clientWidth;
    // root_h = doc.clientHeight;
    // root_w = body.clientWidth;
    // root_h = body.clientHeight;
    const doc = document.documentElement;
    $ad324e565f74e0a8$var$root_w = doc.clientWidth;
    $ad324e565f74e0a8$var$root_h = doc.clientHeight;
}
/**
 * @param {Element=} src
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.mount = function(src) {
    // handles mounting over:
    this.unmount();
    src._backstore || (src._backstore = src.parentNode);
    this.body.textContent = "";
    this.body.appendChild(src);
    return this;
};
/**
 * @param {Element=} dest
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.unmount = function(dest) {
    const node = this.body.firstChild;
    if (node) {
        const root = dest || node._backstore;
        root && root.appendChild(node);
        node._backstore = dest;
    }
    return this;
};
/**
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.setTitle = function(title) {
    const node = (0, $2lfy6.getByClass)(this.dom, "wb-title");
    (0, $2lfy6.setText)(node, this.title = title);
    return this;
};
/**
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.setIcon = function(src) {
    const img = (0, $2lfy6.getByClass)(this.dom, "wb-icon");
    (0, $2lfy6.setStyle)(img, "background-image", "url(" + src + ")");
    (0, $2lfy6.setStyle)(img, "display", "inline-block");
    return this;
};
/**
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.setBackground = function(background) {
    (0, $2lfy6.setStyle)(this.dom, "background", background);
    return this;
};
/**
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.setUrl = function(url, onload) {
    const node = this.body.firstChild;
    if (node && node.tagName.toLowerCase() === "iframe") node.src = url;
    else {
        this.body.innerHTML = '<iframe src="' + url + '"></iframe>';
        onload && (this.body.firstChild.onload = onload);
    }
    return this;
};
/**
 * @param {boolean=} state
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.focus = function(state) {
    if (state === false) return this.blur();
    if ($ad324e565f74e0a8$var$last_focus !== this && this.dom) {
        $ad324e565f74e0a8$var$last_focus && $ad324e565f74e0a8$var$last_focus.blur();
        (0, $2lfy6.setStyle)(this.dom, "z-index", ++$ad324e565f74e0a8$var$index_counter);
        this.index = $ad324e565f74e0a8$var$index_counter;
        this.addClass("focus");
        $ad324e565f74e0a8$var$last_focus = this;
        this.focused = true;
        this.onfocus && this.onfocus();
    }
    return this;
};
/**
 * @param {boolean=} state
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.blur = function(state) {
    if (state === false) return this.focus();
    if ($ad324e565f74e0a8$var$last_focus === this) {
        this.removeClass("focus");
        this.focused = false;
        this.onblur && this.onblur();
        // TODO focus next window
        $ad324e565f74e0a8$var$last_focus = null;
    }
    return this;
};
/**
 * @param {boolean=} state
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.hide = function(state) {
    if (state === false) return this.show();
    if (!this.hidden) {
        this.onhide && this.onhide();
        this.hidden = true;
        return this.addClass("hide");
    }
};
/**
 * @param {boolean=} state
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.show = function(state) {
    if (state === false) return this.hide();
    if (this.hidden) {
        this.onshow && this.onshow();
        this.hidden = false;
        return this.removeClass("hide");
    }
};
/**
 * @param {boolean=} state
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.minimize = function(state) {
    if (state === false) return this.restore();
    if ($ad324e565f74e0a8$var$is_fullscreen) $ad324e565f74e0a8$var$cancel_fullscreen();
    if (this.max) {
        this.removeClass("max");
        this.max = false;
    }
    if (!this.min) {
        $ad324e565f74e0a8$var$stack_min.push(this);
        $ad324e565f74e0a8$var$update_min_stack();
        this.dom.title = this.title;
        this.addClass("min");
        this.min = true;
        this.onminimize && this.onminimize();
    }
    return this;
};
/**
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.restore = function() {
    if ($ad324e565f74e0a8$var$is_fullscreen) $ad324e565f74e0a8$var$cancel_fullscreen();
    if (this.min) {
        $ad324e565f74e0a8$var$remove_min_stack(this);
        this.resize().move();
        this.onrestore && this.onrestore();
    }
    if (this.max) {
        this.max = false;
        this.removeClass("max").resize().move();
        this.onrestore && this.onrestore();
    }
    return this;
};
/**
 * @param {boolean=} state
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.maximize = function(state) {
    if (state === false) return this.restore();
    if ($ad324e565f74e0a8$var$is_fullscreen) $ad324e565f74e0a8$var$cancel_fullscreen();
    if (this.min) $ad324e565f74e0a8$var$remove_min_stack(this);
    if (!this.max) {
        this.addClass("max").resize($ad324e565f74e0a8$var$root_w - this.left - this.right, $ad324e565f74e0a8$var$root_h - this.top - this.bottom /* - 1 */ , true).move(this.left, this.top, true);
        this.max = true;
        this.onmaximize && this.onmaximize();
    }
    return this;
};
/**
 * @param {boolean=} state
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.fullscreen = function(state) {
    if (this.min) {
        $ad324e565f74e0a8$var$remove_min_stack(this);
        this.resize().move();
    }
    // fullscreen could be changed by user manually!
    if (!$ad324e565f74e0a8$var$is_fullscreen || !$ad324e565f74e0a8$var$cancel_fullscreen()) {
        // requestFullscreen is executed as async and returns promise.
        // in this case it is better to set the state to "this.full" after the requestFullscreen was fired,
        // because it may break when browser does not support fullscreen properly and bypass it silently.
        this.body[$ad324e565f74e0a8$var$prefix_request]();
        $ad324e565f74e0a8$var$is_fullscreen = this;
        this.full = true;
        this.onfullscreen && this.onfullscreen();
    } else if (state === false) return this.restore();
    return this;
};
function $ad324e565f74e0a8$var$has_fullscreen() {
    return document["fullscreen"] || document["fullscreenElement"] || document["webkitFullscreenElement"] || document["mozFullScreenElement"];
}
/**
 * @return {boolean|void}
 */ function $ad324e565f74e0a8$var$cancel_fullscreen() {
    $ad324e565f74e0a8$var$is_fullscreen.full = false;
    if ($ad324e565f74e0a8$var$has_fullscreen()) {
        // exitFullscreen is executed as async and returns promise.
        // the important part is that the promise callback runs before the event "onresize" was fired!
        document[$ad324e565f74e0a8$var$prefix_exit]();
        return true;
    }
}
/**
 * @param {boolean=} force
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.close = function(force) {
    if (this.onclose && this.onclose(force)) return true;
    if (this.min) $ad324e565f74e0a8$var$remove_min_stack(this);
    this.unmount();
    this.dom.remove();
    this.dom.textContent = "";
    this.dom["winbox"] = null;
    this.body = null;
    this.dom = null;
    if ($ad324e565f74e0a8$var$last_focus === this) $ad324e565f74e0a8$var$last_focus = null;
};
/**
 * @param {number|string=} x
 * @param {number|string=} y
 * @param {boolean=} _skip_update
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.move = function(x, y, _skip_update) {
    if (!x && x !== 0) {
        x = this.x;
        y = this.y;
    } else if (!_skip_update) {
        this.x = x ? x = $ad324e565f74e0a8$var$parse(x, $ad324e565f74e0a8$var$root_w - this.left - this.right, this.width) : 0;
        this.y = y ? y = $ad324e565f74e0a8$var$parse(y, $ad324e565f74e0a8$var$root_h - this.top - this.bottom, this.height) : 0;
    }
    //setStyle(this.dom, "transform", "translate(" + x + "px," + y + "px)");
    (0, $2lfy6.setStyle)(this.dom, "left", x + "px");
    (0, $2lfy6.setStyle)(this.dom, "top", y + "px");
    this.onmove && this.onmove(x, y);
    return this;
};
/**
 * @param {number|string=} w
 * @param {number|string=} h
 * @param {boolean=} _skip_update
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.resize = function(w, h, _skip_update) {
    if (!w && w !== 0) {
        w = this.width;
        h = this.height;
    } else if (!_skip_update) {
        this.width = w ? w = $ad324e565f74e0a8$var$parse(w, this.maxwidth /*- this.left - this.right*/ ) : 0;
        this.height = h ? h = $ad324e565f74e0a8$var$parse(h, this.maxheight /*- this.top - this.bottom*/ ) : 0;
        w = Math.max(w, this.minwidth);
        h = Math.max(h, this.minheight);
    }
    (0, $2lfy6.setStyle)(this.dom, "width", w + "px");
    (0, $2lfy6.setStyle)(this.dom, "height", h + "px");
    this.onresize && this.onresize(w, h);
    return this;
};
/**
 * @param {{ class:string?, image:string?, click:Function?, index:number? }} control
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.addControl = function(control) {
    const classname = control["class"];
    const image = control.image;
    const click = control.click;
    const index = control.index;
    const node = document.createElement("span");
    const icons = (0, $2lfy6.getByClass)(this.dom, "wb-control");
    const self = this;
    if (classname) node.className = classname;
    if (image) (0, $2lfy6.setStyle)(node, "background-image", "url(" + image + ")");
    if (click) node.onclick = function(event) {
        click.call(this, event, self);
    };
    icons.insertBefore(node, icons.childNodes[index || 0]);
    return this;
};
/**
 * @param {string} control
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.removeControl = function(control) {
    control = (0, $2lfy6.getByClass)(this.dom, control);
    control && control.remove();
    return this;
};
/**
 * @param {string} classname
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.addClass = function(classname) {
    (0, $2lfy6.addClass)(this.dom, classname);
    return this;
};
/**
 * @param {string} classname
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.removeClass = function(classname) {
    (0, $2lfy6.removeClass)(this.dom, classname);
    return this;
};
/**
 * @param {string} classname
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.hasClass = function(classname) {
    return (0, $2lfy6.hasClass)(this.dom, classname);
};
/**
 * @param {string} classname
 * @this WinBox
 */ $ad324e565f74e0a8$var$WinBox.prototype.toggleClass = function(classname) {
    return this.hasClass(classname) ? this.removeClass(classname) : this.addClass(classname);
}; /*
WinBox.prototype.use = function(plugin){

    this.plugins.push(plugin);
    return this;
};
*/ 

});
parcelRegister("juxAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e30ae0b939719996$export$2e2bcd8739ae039);
const $e30ae0b939719996$var$template = document.createElement("div");
$e30ae0b939719996$var$template.innerHTML = //'<div class=winbox>' +
"<div class=wb-header><div class=wb-control><span class=wb-min></span><span class=wb-max></span><span class=wb-full></span><span class=wb-close></span></div><div class=wb-drag><div class=wb-icon></div><div class=wb-title></div></div></div><div class=wb-body></div><div class=wb-n></div><div class=wb-s></div><div class=wb-w></div><div class=wb-e></div><div class=wb-nw></div><div class=wb-ne></div><div class=wb-se></div><div class=wb-sw></div>";
function $e30ae0b939719996$export$2e2bcd8739ae039(tpl) {
    return (tpl || $e30ae0b939719996$var$template).cloneNode(true);
}

});

parcelRegister("2lfy6", function(module, exports) {

$parcel$export(module.exports, "addListener", () => $1b499aa633494656$export$f03a6b845d3fb58b);
$parcel$export(module.exports, "removeListener", () => $1b499aa633494656$export$b03e9483f936dccb);
$parcel$export(module.exports, "preventEvent", () => $1b499aa633494656$export$bec0ecf7678008);
$parcel$export(module.exports, "getByClass", () => $1b499aa633494656$export$2bf3f394345fe593);
$parcel$export(module.exports, "addClass", () => $1b499aa633494656$export$d2cf6cd1dc7067d3);
$parcel$export(module.exports, "hasClass", () => $1b499aa633494656$export$4ea3d958472af68f);
$parcel$export(module.exports, "removeClass", () => $1b499aa633494656$export$c2255604a80b4506);
$parcel$export(module.exports, "setStyle", () => $1b499aa633494656$export$37a5fde709c1db82);
$parcel$export(module.exports, "setText", () => $1b499aa633494656$export$cbe0d99836e1498f);
/**
 * @param {Window|Element} node
 * @param {string} event
 * @param {Function} fn
 * @param {AddEventListenerOptions|boolean=} opt
 */ function $1b499aa633494656$export$f03a6b845d3fb58b(node, event, fn, opt) {
    node && node.addEventListener(event, fn, opt || false);
}
function $1b499aa633494656$export$b03e9483f936dccb(node, event, fn, opt) {
    node && node.removeEventListener(event, fn, opt || false);
}
function $1b499aa633494656$export$bec0ecf7678008(event, prevent) {
    event.stopPropagation();
    /*prevent &&*/ event.cancelable && event.preventDefault();
//event.stopImmediatePropagation();
//event.returnValue = false;
}
function $1b499aa633494656$export$2bf3f394345fe593(root, name) {
    return root.getElementsByClassName(name)[0];
}
function $1b499aa633494656$export$d2cf6cd1dc7067d3(node, classname) {
    node.classList.add(classname);
}
function $1b499aa633494656$export$4ea3d958472af68f(node, classname) {
    return node.classList.contains(classname);
}
function $1b499aa633494656$export$c2255604a80b4506(node, classname) {
    node.classList.remove(classname);
}
function $1b499aa633494656$export$37a5fde709c1db82(node, style, value) {
    value = "" + value;
    if (node["_s_" + style] !== value) {
        node.style.setProperty(style, value);
        node["_s_" + style] = value;
    }
}
function $1b499aa633494656$export$9fec4d97f1922e0b(node, key, value) {
    value = "" + value;
    if (node["_a_" + key] !== value) {
        node.setAttribute(key, value);
        node["_a_" + key] = value;
    }
}
function $1b499aa633494656$export$6399f3bb52316b2c(node, key) {
    if (node["_a_" + key] !== null) {
        node.removeAttribute(key);
        node["_a_" + key] = null;
    }
}
function $1b499aa633494656$export$cbe0d99836e1498f(node, value) {
    const textnode = node.firstChild;
    textnode ? textnode.nodeValue = value : node.textContent = value;
}

});


parcelRegister("5z5Bz", function(module, exports) {

$parcel$export(module.exports, "DataSet", () => DataSet);
$parcel$export(module.exports, "Timeline", () => Timeline);
/**
 * vis-timeline and vis-graph2d
 * https://visjs.github.io/vis-timeline/
 *
 * Create a fully customizable, interactive timeline with items and ranges.
 *
 * @version 7.7.3
 * @date    2023-10-27T17:57:57.604Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */ var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function commonjsRequire(path) {
    throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var moment$5 = {
    exports: {}
};
var hasRequiredMoment;
function requireMoment() {
    if (hasRequiredMoment) return moment$5.exports;
    hasRequiredMoment = 1;
    (function(module, exports) {
        (function(global1, factory) {
            module.exports = factory();
        })(commonjsGlobal, function() {
            var hookCallback;
            function hooks() {
                return hookCallback.apply(null, arguments);
            }
            // This is done to register the method called with moment()
            // without creating circular dependencies.
            function setHookCallback(callback) {
                hookCallback = callback;
            }
            function isArray(input) {
                return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
            }
            function isObject(input) {
                // IE8 will treat undefined and null as object if it wasn't for
                // input != null
                return input != null && Object.prototype.toString.call(input) === "[object Object]";
            }
            function hasOwnProp(a, b) {
                return Object.prototype.hasOwnProperty.call(a, b);
            }
            function isObjectEmpty(obj) {
                if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
                else {
                    var k;
                    for(k in obj){
                        if (hasOwnProp(obj, k)) return false;
                    }
                    return true;
                }
            }
            function isUndefined(input) {
                return input === void 0;
            }
            function isNumber(input) {
                return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
            }
            function isDate(input) {
                return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
            }
            function map(arr, fn) {
                var res = [], i1, arrLen = arr.length;
                for(i1 = 0; i1 < arrLen; ++i1)res.push(fn(arr[i1], i1));
                return res;
            }
            function extend(a, b) {
                for(var i1 in b)if (hasOwnProp(b, i1)) a[i1] = b[i1];
                if (hasOwnProp(b, "toString")) a.toString = b.toString;
                if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
                return a;
            }
            function createUTC(input, format, locale, strict) {
                return createLocalOrUTC(input, format, locale, strict, true).utc();
            }
            function defaultParsingFlags() {
                // We need to deep clone this object.
                return {
                    empty: false,
                    unusedTokens: [],
                    unusedInput: [],
                    overflow: -2,
                    charsLeftOver: 0,
                    nullInput: false,
                    invalidEra: null,
                    invalidMonth: null,
                    invalidFormat: false,
                    userInvalidated: false,
                    iso: false,
                    parsedDateParts: [],
                    era: null,
                    meridiem: null,
                    rfc2822: false,
                    weekdayMismatch: false
                };
            }
            function getParsingFlags(m) {
                if (m._pf == null) m._pf = defaultParsingFlags();
                return m._pf;
            }
            var some;
            if (Array.prototype.some) some = Array.prototype.some;
            else some = function(fun) {
                var t = Object(this), len = t.length >>> 0, i1;
                for(i1 = 0; i1 < len; i1++){
                    if (i1 in t && fun.call(this, t[i1], i1, t)) return true;
                }
                return false;
            };
            function isValid(m) {
                if (m._isValid == null) {
                    var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i1) {
                        return i1 != null;
                    }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
                    if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
                    if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
                    else return isNowValid;
                }
                return m._isValid;
            }
            function createInvalid(flags) {
                var m = createUTC(NaN);
                if (flags != null) extend(getParsingFlags(m), flags);
                else getParsingFlags(m).userInvalidated = true;
                return m;
            }
            // Plugins that add properties should also add the key here (null value),
            // so we can properly clone ourselves.
            var momentProperties = hooks.momentProperties = [], updateInProgress = false;
            function copyConfig(to, from) {
                var i1, prop, val, momentPropertiesLen = momentProperties.length;
                if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
                if (!isUndefined(from._i)) to._i = from._i;
                if (!isUndefined(from._f)) to._f = from._f;
                if (!isUndefined(from._l)) to._l = from._l;
                if (!isUndefined(from._strict)) to._strict = from._strict;
                if (!isUndefined(from._tzm)) to._tzm = from._tzm;
                if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
                if (!isUndefined(from._offset)) to._offset = from._offset;
                if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
                if (!isUndefined(from._locale)) to._locale = from._locale;
                if (momentPropertiesLen > 0) for(i1 = 0; i1 < momentPropertiesLen; i1++){
                    prop = momentProperties[i1];
                    val = from[prop];
                    if (!isUndefined(val)) to[prop] = val;
                }
                return to;
            }
            // Moment prototype object
            function Moment(config) {
                copyConfig(this, config);
                this._d = new Date(config._d != null ? config._d.getTime() : NaN);
                if (!this.isValid()) this._d = new Date(NaN);
                // Prevent infinite loop in case updateOffset creates new moment
                // objects.
                if (updateInProgress === false) {
                    updateInProgress = true;
                    hooks.updateOffset(this);
                    updateInProgress = false;
                }
            }
            function isMoment(obj) {
                return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
            }
            function warn(msg) {
                if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
            }
            function deprecate(msg, fn) {
                var firstTime = true;
                return extend(function() {
                    if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
                    if (firstTime) {
                        var args = [], arg, i1, key, argLen = arguments.length;
                        for(i1 = 0; i1 < argLen; i1++){
                            arg = "";
                            if (typeof arguments[i1] === "object") {
                                arg += "\n[" + i1 + "] ";
                                for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                                arg = arg.slice(0, -2); // Remove trailing comma and space
                            } else arg = arguments[i1];
                            args.push(arg);
                        }
                        warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                        firstTime = false;
                    }
                    return fn.apply(this, arguments);
                }, fn);
            }
            var deprecations = {};
            function deprecateSimple(name, msg) {
                if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
                if (!deprecations[name]) {
                    warn(msg);
                    deprecations[name] = true;
                }
            }
            hooks.suppressDeprecationWarnings = false;
            hooks.deprecationHandler = null;
            function isFunction(input) {
                return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
            }
            function set(config) {
                var prop, i1;
                for(i1 in config)if (hasOwnProp(config, i1)) {
                    prop = config[i1];
                    if (isFunction(prop)) this[i1] = prop;
                    else this["_" + i1] = prop;
                }
                this._config = config;
                // Lenient ordinal parsing accepts just a number in addition to
                // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
                // TODO: Remove "ordinalParse" fallback in next major release.
                this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
            }
            function mergeConfigs(parentConfig, childConfig) {
                var res = extend({}, parentConfig), prop;
                for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
                    if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                        res[prop] = {};
                        extend(res[prop], parentConfig[prop]);
                        extend(res[prop], childConfig[prop]);
                    } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
                    else delete res[prop];
                }
                for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
                return res;
            }
            function Locale(config) {
                if (config != null) this.set(config);
            }
            var keys;
            if (Object.keys) keys = Object.keys;
            else keys = function(obj) {
                var i1, res = [];
                for(i1 in obj)if (hasOwnProp(obj, i1)) res.push(i1);
                return res;
            };
            var defaultCalendar = {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            };
            function calendar(key, mom, now) {
                var output = this._calendar[key] || this._calendar["sameElse"];
                return isFunction(output) ? output.call(mom, now) : output;
            }
            function zeroFill(number, targetLength, forceSign) {
                var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
                return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
            }
            var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
            // token:    'M'
            // padded:   ['MM', 2]
            // ordinal:  'Mo'
            // callback: function () { this.month() + 1 }
            function addFormatToken(token, padded, ordinal, callback) {
                var func = callback;
                if (typeof callback === "string") func = function() {
                    return this[callback]();
                };
                if (token) formatTokenFunctions[token] = func;
                if (padded) formatTokenFunctions[padded[0]] = function() {
                    return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
                };
                if (ordinal) formatTokenFunctions[ordinal] = function() {
                    return this.localeData().ordinal(func.apply(this, arguments), token);
                };
            }
            function removeFormattingTokens(input) {
                if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
                return input.replace(/\\/g, "");
            }
            function makeFormatFunction(format) {
                var array = format.match(formattingTokens), i1, length;
                for(i1 = 0, length = array.length; i1 < length; i1++)if (formatTokenFunctions[array[i1]]) array[i1] = formatTokenFunctions[array[i1]];
                else array[i1] = removeFormattingTokens(array[i1]);
                return function(mom) {
                    var output = "", i1;
                    for(i1 = 0; i1 < length; i1++)output += isFunction(array[i1]) ? array[i1].call(mom, format) : array[i1];
                    return output;
                };
            }
            // format date using native date object
            function formatMoment(m, format) {
                if (!m.isValid()) return m.localeData().invalidDate();
                format = expandFormat(format, m.localeData());
                formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
                return formatFunctions[format](m);
            }
            function expandFormat(format, locale) {
                var i1 = 5;
                function replaceLongDateFormatTokens(input) {
                    return locale.longDateFormat(input) || input;
                }
                localFormattingTokens.lastIndex = 0;
                while(i1 >= 0 && localFormattingTokens.test(format)){
                    format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
                    localFormattingTokens.lastIndex = 0;
                    i1 -= 1;
                }
                return format;
            }
            var defaultLongDateFormat = {
                LTS: "h:mm:ss A",
                LT: "h:mm A",
                L: "MM/DD/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A"
            };
            function longDateFormat(key) {
                var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
                if (format || !formatUpper) return format;
                this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
                    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
                    return tok;
                }).join("");
                return this._longDateFormat[key];
            }
            var defaultInvalidDate = "Invalid date";
            function invalidDate() {
                return this._invalidDate;
            }
            var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
            function ordinal(number) {
                return this._ordinal.replace("%d", number);
            }
            var defaultRelativeTime = {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                w: "a week",
                ww: "%d weeks",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            };
            function relativeTime(number, withoutSuffix, string, isFuture) {
                var output = this._relativeTime[string];
                return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
            }
            function pastFuture(diff, output) {
                var format = this._relativeTime[diff > 0 ? "future" : "past"];
                return isFunction(format) ? format(output) : format.replace(/%s/i, output);
            }
            var aliases = {};
            function addUnitAlias(unit, shorthand) {
                var lowerCase = unit.toLowerCase();
                aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
            }
            function normalizeUnits(units) {
                return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
            }
            function normalizeObjectUnits(inputObject) {
                var normalizedInput = {}, normalizedProp, prop;
                for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
                    normalizedProp = normalizeUnits(prop);
                    if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
                }
                return normalizedInput;
            }
            var priorities = {};
            function addUnitPriority(unit, priority) {
                priorities[unit] = priority;
            }
            function getPrioritizedUnits(unitsObj) {
                var units = [], u;
                for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
                    unit: u,
                    priority: priorities[u]
                });
                units.sort(function(a, b) {
                    return a.priority - b.priority;
                });
                return units;
            }
            function isLeapYear(year) {
                return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
            }
            function absFloor(number) {
                if (number < 0) // -0 -> 0
                return Math.ceil(number) || 0;
                else return Math.floor(number);
            }
            function toInt(argumentForCoercion) {
                var coercedNumber = +argumentForCoercion, value = 0;
                if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
                return value;
            }
            function makeGetSet(unit, keepTime) {
                return function(value) {
                    if (value != null) {
                        set$1(this, unit, value);
                        hooks.updateOffset(this, keepTime);
                        return this;
                    } else return get(this, unit);
                };
            }
            function get(mom, unit) {
                return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
            }
            function set$1(mom, unit, value) {
                if (mom.isValid() && !isNaN(value)) {
                    if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                        value = toInt(value);
                        mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
                    } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
                }
            }
            // MOMENTS
            function stringGet(units) {
                units = normalizeUnits(units);
                if (isFunction(this[units])) return this[units]();
                return this;
            }
            function stringSet(units, value) {
                if (typeof units === "object") {
                    units = normalizeObjectUnits(units);
                    var prioritized = getPrioritizedUnits(units), i1, prioritizedLen = prioritized.length;
                    for(i1 = 0; i1 < prioritizedLen; i1++)this[prioritized[i1].unit](units[prioritized[i1].unit]);
                } else {
                    units = normalizeUnits(units);
                    if (isFunction(this[units])) return this[units](value);
                }
                return this;
            }
            var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
            // includes scottish gaelic two word and hyphenated months
            matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
            regexes = {};
            function addRegexToken(token, regex, strictRegex) {
                regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
                    return isStrict && strictRegex ? strictRegex : regex;
                };
            }
            function getParseRegexForToken(token, config) {
                if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
                return regexes[token](config._strict, config._locale);
            }
            // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
            function unescapeFormat(s) {
                return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
                    return p1 || p2 || p3 || p4;
                }));
            }
            function regexEscape(s) {
                return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            }
            var tokens = {};
            function addParseToken(token, callback) {
                var i1, func = callback, tokenLen;
                if (typeof token === "string") token = [
                    token
                ];
                if (isNumber(callback)) func = function(input, array) {
                    array[callback] = toInt(input);
                };
                tokenLen = token.length;
                for(i1 = 0; i1 < tokenLen; i1++)tokens[token[i1]] = func;
            }
            function addWeekParseToken(token, callback) {
                addParseToken(token, function(input, array, config, token) {
                    config._w = config._w || {};
                    callback(input, config._w, config, token);
                });
            }
            function addTimeToArrayFromToken(token, input, config) {
                if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
            }
            var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
            function mod(n, x) {
                return (n % x + x) % x;
            }
            var indexOf;
            if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
            else indexOf = function(o) {
                // I know
                var i1;
                for(i1 = 0; i1 < this.length; ++i1){
                    if (this[i1] === o) return i1;
                }
                return -1;
            };
            function daysInMonth(year, month) {
                if (isNaN(year) || isNaN(month)) return NaN;
                var modMonth = mod(month, 12);
                year += (month - modMonth) / 12;
                return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
            }
            // FORMATTING
            addFormatToken("M", [
                "MM",
                2
            ], "Mo", function() {
                return this.month() + 1;
            });
            addFormatToken("MMM", 0, 0, function(format) {
                return this.localeData().monthsShort(this, format);
            });
            addFormatToken("MMMM", 0, 0, function(format) {
                return this.localeData().months(this, format);
            });
            // ALIASES
            addUnitAlias("month", "M");
            // PRIORITY
            addUnitPriority("month", 8);
            // PARSING
            addRegexToken("M", match1to2);
            addRegexToken("MM", match1to2, match2);
            addRegexToken("MMM", function(isStrict, locale) {
                return locale.monthsShortRegex(isStrict);
            });
            addRegexToken("MMMM", function(isStrict, locale) {
                return locale.monthsRegex(isStrict);
            });
            addParseToken([
                "M",
                "MM"
            ], function(input, array) {
                array[MONTH] = toInt(input) - 1;
            });
            addParseToken([
                "MMM",
                "MMMM"
            ], function(input, array, config, token) {
                var month = config._locale.monthsParse(input, token, config._strict);
                // if we didn't find a month name, mark the date as invalid.
                if (month != null) array[MONTH] = month;
                else getParsingFlags(config).invalidMonth = input;
            });
            // LOCALES
            var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
            function localeMonths(m, format) {
                if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
                return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
            }
            function localeMonthsShort(m, format) {
                if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
                return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
            }
            function handleStrictParse(monthName, format, strict) {
                var i1, ii, mom, llc = monthName.toLocaleLowerCase();
                if (!this._monthsParse) {
                    // this is not used
                    this._monthsParse = [];
                    this._longMonthsParse = [];
                    this._shortMonthsParse = [];
                    for(i1 = 0; i1 < 12; ++i1){
                        mom = createUTC([
                            2000,
                            i1
                        ]);
                        this._shortMonthsParse[i1] = this.monthsShort(mom, "").toLocaleLowerCase();
                        this._longMonthsParse[i1] = this.months(mom, "").toLocaleLowerCase();
                    }
                }
                if (strict) {
                    if (format === "MMM") {
                        ii = indexOf.call(this._shortMonthsParse, llc);
                        return ii !== -1 ? ii : null;
                    } else {
                        ii = indexOf.call(this._longMonthsParse, llc);
                        return ii !== -1 ? ii : null;
                    }
                } else if (format === "MMM") {
                    ii = indexOf.call(this._shortMonthsParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._longMonthsParse, llc);
                    return ii !== -1 ? ii : null;
                } else {
                    ii = indexOf.call(this._longMonthsParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._shortMonthsParse, llc);
                    return ii !== -1 ? ii : null;
                }
            }
            function localeMonthsParse(monthName, format, strict) {
                var i1, mom, regex;
                if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
                if (!this._monthsParse) {
                    this._monthsParse = [];
                    this._longMonthsParse = [];
                    this._shortMonthsParse = [];
                }
                // TODO: add sorting
                // Sorting makes sure if one month (or abbr) is a prefix of another
                // see sorting in computeMonthsParse
                for(i1 = 0; i1 < 12; i1++){
                    // make the regex if we don't have it already
                    mom = createUTC([
                        2000,
                        i1
                    ]);
                    if (strict && !this._longMonthsParse[i1]) {
                        this._longMonthsParse[i1] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                        this._shortMonthsParse[i1] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
                    }
                    if (!strict && !this._monthsParse[i1]) {
                        regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                        this._monthsParse[i1] = new RegExp(regex.replace(".", ""), "i");
                    }
                    // test the regex
                    if (strict && format === "MMMM" && this._longMonthsParse[i1].test(monthName)) return i1;
                    else if (strict && format === "MMM" && this._shortMonthsParse[i1].test(monthName)) return i1;
                    else if (!strict && this._monthsParse[i1].test(monthName)) return i1;
                }
            }
            // MOMENTS
            function setMonth(mom, value) {
                var dayOfMonth;
                if (!mom.isValid()) // No op
                return mom;
                if (typeof value === "string") {
                    if (/^\d+$/.test(value)) value = toInt(value);
                    else {
                        value = mom.localeData().monthsParse(value);
                        // TODO: Another silent failure?
                        if (!isNumber(value)) return mom;
                    }
                }
                dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
                mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
                return mom;
            }
            function getSetMonth(value) {
                if (value != null) {
                    setMonth(this, value);
                    hooks.updateOffset(this, true);
                    return this;
                } else return get(this, "Month");
            }
            function getDaysInMonth() {
                return daysInMonth(this.year(), this.month());
            }
            function monthsShortRegex(isStrict) {
                if (this._monthsParseExact) {
                    if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
                    if (isStrict) return this._monthsShortStrictRegex;
                    else return this._monthsShortRegex;
                } else {
                    if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
                    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
                }
            }
            function monthsRegex(isStrict) {
                if (this._monthsParseExact) {
                    if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
                    if (isStrict) return this._monthsStrictRegex;
                    else return this._monthsRegex;
                } else {
                    if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
                    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
                }
            }
            function computeMonthsParse() {
                function cmpLenRev(a, b) {
                    return b.length - a.length;
                }
                var shortPieces = [], longPieces = [], mixedPieces = [], i1, mom;
                for(i1 = 0; i1 < 12; i1++){
                    // make the regex if we don't have it already
                    mom = createUTC([
                        2000,
                        i1
                    ]);
                    shortPieces.push(this.monthsShort(mom, ""));
                    longPieces.push(this.months(mom, ""));
                    mixedPieces.push(this.months(mom, ""));
                    mixedPieces.push(this.monthsShort(mom, ""));
                }
                // Sorting makes sure if one month (or abbr) is a prefix of another it
                // will match the longer piece.
                shortPieces.sort(cmpLenRev);
                longPieces.sort(cmpLenRev);
                mixedPieces.sort(cmpLenRev);
                for(i1 = 0; i1 < 12; i1++){
                    shortPieces[i1] = regexEscape(shortPieces[i1]);
                    longPieces[i1] = regexEscape(longPieces[i1]);
                }
                for(i1 = 0; i1 < 24; i1++)mixedPieces[i1] = regexEscape(mixedPieces[i1]);
                this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
                this._monthsShortRegex = this._monthsRegex;
                this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
                this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
            }
            // FORMATTING
            addFormatToken("Y", 0, 0, function() {
                var y = this.year();
                return y <= 9999 ? zeroFill(y, 4) : "+" + y;
            });
            addFormatToken(0, [
                "YY",
                2
            ], 0, function() {
                return this.year() % 100;
            });
            addFormatToken(0, [
                "YYYY",
                4
            ], 0, "year");
            addFormatToken(0, [
                "YYYYY",
                5
            ], 0, "year");
            addFormatToken(0, [
                "YYYYYY",
                6,
                true
            ], 0, "year");
            // ALIASES
            addUnitAlias("year", "y");
            // PRIORITIES
            addUnitPriority("year", 1);
            // PARSING
            addRegexToken("Y", matchSigned);
            addRegexToken("YY", match1to2, match2);
            addRegexToken("YYYY", match1to4, match4);
            addRegexToken("YYYYY", match1to6, match6);
            addRegexToken("YYYYYY", match1to6, match6);
            addParseToken([
                "YYYYY",
                "YYYYYY"
            ], YEAR);
            addParseToken("YYYY", function(input, array) {
                array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
            });
            addParseToken("YY", function(input, array) {
                array[YEAR] = hooks.parseTwoDigitYear(input);
            });
            addParseToken("Y", function(input, array) {
                array[YEAR] = parseInt(input, 10);
            });
            // HELPERS
            function daysInYear(year) {
                return isLeapYear(year) ? 366 : 365;
            }
            // HOOKS
            hooks.parseTwoDigitYear = function(input) {
                return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
            };
            // MOMENTS
            var getSetYear = makeGetSet("FullYear", true);
            function getIsLeapYear() {
                return isLeapYear(this.year());
            }
            function createDate(y, m, d, h, M, s, ms) {
                // can't just apply() to create a date:
                // https://stackoverflow.com/q/181348
                var date;
                // the date constructor remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) {
                    // preserve leap years using a full 400 year cycle, then reset
                    date = new Date(y + 400, m, d, h, M, s, ms);
                    if (isFinite(date.getFullYear())) date.setFullYear(y);
                } else date = new Date(y, m, d, h, M, s, ms);
                return date;
            }
            function createUTCDate(y) {
                var date, args;
                // the Date.UTC function remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) {
                    args = Array.prototype.slice.call(arguments);
                    // preserve leap years using a full 400 year cycle, then reset
                    args[0] = y + 400;
                    date = new Date(Date.UTC.apply(null, args));
                    if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
                } else date = new Date(Date.UTC.apply(null, arguments));
                return date;
            }
            // start-of-first-week - start-of-year
            function firstWeekOffset(year, dow, doy) {
                var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
                fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
                return -fwdlw + fwd - 1;
            }
            // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
            function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
                var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
                if (dayOfYear <= 0) {
                    resYear = year - 1;
                    resDayOfYear = daysInYear(resYear) + dayOfYear;
                } else if (dayOfYear > daysInYear(year)) {
                    resYear = year + 1;
                    resDayOfYear = dayOfYear - daysInYear(year);
                } else {
                    resYear = year;
                    resDayOfYear = dayOfYear;
                }
                return {
                    year: resYear,
                    dayOfYear: resDayOfYear
                };
            }
            function weekOfYear(mom, dow, doy) {
                var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
                if (week < 1) {
                    resYear = mom.year() - 1;
                    resWeek = week + weeksInYear(resYear, dow, doy);
                } else if (week > weeksInYear(mom.year(), dow, doy)) {
                    resWeek = week - weeksInYear(mom.year(), dow, doy);
                    resYear = mom.year() + 1;
                } else {
                    resYear = mom.year();
                    resWeek = week;
                }
                return {
                    week: resWeek,
                    year: resYear
                };
            }
            function weeksInYear(year, dow, doy) {
                var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
                return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
            }
            // FORMATTING
            addFormatToken("w", [
                "ww",
                2
            ], "wo", "week");
            addFormatToken("W", [
                "WW",
                2
            ], "Wo", "isoWeek");
            // ALIASES
            addUnitAlias("week", "w");
            addUnitAlias("isoWeek", "W");
            // PRIORITIES
            addUnitPriority("week", 5);
            addUnitPriority("isoWeek", 5);
            // PARSING
            addRegexToken("w", match1to2);
            addRegexToken("ww", match1to2, match2);
            addRegexToken("W", match1to2);
            addRegexToken("WW", match1to2, match2);
            addWeekParseToken([
                "w",
                "ww",
                "W",
                "WW"
            ], function(input, week, config, token) {
                week[token.substr(0, 1)] = toInt(input);
            });
            // HELPERS
            // LOCALES
            function localeWeek(mom) {
                return weekOfYear(mom, this._week.dow, this._week.doy).week;
            }
            var defaultLocaleWeek = {
                dow: 0,
                doy: 6
            };
            function localeFirstDayOfWeek() {
                return this._week.dow;
            }
            function localeFirstDayOfYear() {
                return this._week.doy;
            }
            // MOMENTS
            function getSetWeek(input) {
                var week = this.localeData().week(this);
                return input == null ? week : this.add((input - week) * 7, "d");
            }
            function getSetISOWeek(input) {
                var week = weekOfYear(this, 1, 4).week;
                return input == null ? week : this.add((input - week) * 7, "d");
            }
            // FORMATTING
            addFormatToken("d", 0, "do", "day");
            addFormatToken("dd", 0, 0, function(format) {
                return this.localeData().weekdaysMin(this, format);
            });
            addFormatToken("ddd", 0, 0, function(format) {
                return this.localeData().weekdaysShort(this, format);
            });
            addFormatToken("dddd", 0, 0, function(format) {
                return this.localeData().weekdays(this, format);
            });
            addFormatToken("e", 0, 0, "weekday");
            addFormatToken("E", 0, 0, "isoWeekday");
            // ALIASES
            addUnitAlias("day", "d");
            addUnitAlias("weekday", "e");
            addUnitAlias("isoWeekday", "E");
            // PRIORITY
            addUnitPriority("day", 11);
            addUnitPriority("weekday", 11);
            addUnitPriority("isoWeekday", 11);
            // PARSING
            addRegexToken("d", match1to2);
            addRegexToken("e", match1to2);
            addRegexToken("E", match1to2);
            addRegexToken("dd", function(isStrict, locale) {
                return locale.weekdaysMinRegex(isStrict);
            });
            addRegexToken("ddd", function(isStrict, locale) {
                return locale.weekdaysShortRegex(isStrict);
            });
            addRegexToken("dddd", function(isStrict, locale) {
                return locale.weekdaysRegex(isStrict);
            });
            addWeekParseToken([
                "dd",
                "ddd",
                "dddd"
            ], function(input, week, config, token) {
                var weekday = config._locale.weekdaysParse(input, token, config._strict);
                // if we didn't get a weekday name, mark the date as invalid
                if (weekday != null) week.d = weekday;
                else getParsingFlags(config).invalidWeekday = input;
            });
            addWeekParseToken([
                "d",
                "e",
                "E"
            ], function(input, week, config, token) {
                week[token] = toInt(input);
            });
            // HELPERS
            function parseWeekday(input, locale) {
                if (typeof input !== "string") return input;
                if (!isNaN(input)) return parseInt(input, 10);
                input = locale.weekdaysParse(input);
                if (typeof input === "number") return input;
                return null;
            }
            function parseIsoWeekday(input, locale) {
                if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
                return isNaN(input) ? null : input;
            }
            // LOCALES
            function shiftWeekdays(ws, n) {
                return ws.slice(n, 7).concat(ws.slice(0, n));
            }
            var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
            function localeWeekdays(m, format) {
                var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
                return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
            }
            function localeWeekdaysShort(m) {
                return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
            }
            function localeWeekdaysMin(m) {
                return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
            }
            function handleStrictParse$1(weekdayName, format, strict) {
                var i1, ii, mom, llc = weekdayName.toLocaleLowerCase();
                if (!this._weekdaysParse) {
                    this._weekdaysParse = [];
                    this._shortWeekdaysParse = [];
                    this._minWeekdaysParse = [];
                    for(i1 = 0; i1 < 7; ++i1){
                        mom = createUTC([
                            2000,
                            1
                        ]).day(i1);
                        this._minWeekdaysParse[i1] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                        this._shortWeekdaysParse[i1] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                        this._weekdaysParse[i1] = this.weekdays(mom, "").toLocaleLowerCase();
                    }
                }
                if (strict) {
                    if (format === "dddd") {
                        ii = indexOf.call(this._weekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else if (format === "ddd") {
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else {
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    }
                } else {
                    if (format === "dddd") {
                        ii = indexOf.call(this._weekdaysParse, llc);
                        if (ii !== -1) return ii;
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        if (ii !== -1) return ii;
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else if (format === "ddd") {
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        if (ii !== -1) return ii;
                        ii = indexOf.call(this._weekdaysParse, llc);
                        if (ii !== -1) return ii;
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    } else {
                        ii = indexOf.call(this._minWeekdaysParse, llc);
                        if (ii !== -1) return ii;
                        ii = indexOf.call(this._weekdaysParse, llc);
                        if (ii !== -1) return ii;
                        ii = indexOf.call(this._shortWeekdaysParse, llc);
                        return ii !== -1 ? ii : null;
                    }
                }
            }
            function localeWeekdaysParse(weekdayName, format, strict) {
                var i1, mom, regex;
                if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
                if (!this._weekdaysParse) {
                    this._weekdaysParse = [];
                    this._minWeekdaysParse = [];
                    this._shortWeekdaysParse = [];
                    this._fullWeekdaysParse = [];
                }
                for(i1 = 0; i1 < 7; i1++){
                    // make the regex if we don't have it already
                    mom = createUTC([
                        2000,
                        1
                    ]).day(i1);
                    if (strict && !this._fullWeekdaysParse[i1]) {
                        this._fullWeekdaysParse[i1] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                        this._shortWeekdaysParse[i1] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                        this._minWeekdaysParse[i1] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
                    }
                    if (!this._weekdaysParse[i1]) {
                        regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                        this._weekdaysParse[i1] = new RegExp(regex.replace(".", ""), "i");
                    }
                    // test the regex
                    if (strict && format === "dddd" && this._fullWeekdaysParse[i1].test(weekdayName)) return i1;
                    else if (strict && format === "ddd" && this._shortWeekdaysParse[i1].test(weekdayName)) return i1;
                    else if (strict && format === "dd" && this._minWeekdaysParse[i1].test(weekdayName)) return i1;
                    else if (!strict && this._weekdaysParse[i1].test(weekdayName)) return i1;
                }
            }
            // MOMENTS
            function getSetDayOfWeek(input) {
                if (!this.isValid()) return input != null ? this : NaN;
                var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                if (input != null) {
                    input = parseWeekday(input, this.localeData());
                    return this.add(input - day, "d");
                } else return day;
            }
            function getSetLocaleDayOfWeek(input) {
                if (!this.isValid()) return input != null ? this : NaN;
                var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
                return input == null ? weekday : this.add(input - weekday, "d");
            }
            function getSetISODayOfWeek(input) {
                if (!this.isValid()) return input != null ? this : NaN;
                // behaves the same as moment#day except
                // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
                // as a setter, sunday should belong to the previous week.
                if (input != null) {
                    var weekday = parseIsoWeekday(input, this.localeData());
                    return this.day(this.day() % 7 ? weekday : weekday - 7);
                } else return this.day() || 7;
            }
            function weekdaysRegex(isStrict) {
                if (this._weekdaysParseExact) {
                    if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
                    if (isStrict) return this._weekdaysStrictRegex;
                    else return this._weekdaysRegex;
                } else {
                    if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
                    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
                }
            }
            function weekdaysShortRegex(isStrict) {
                if (this._weekdaysParseExact) {
                    if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
                    if (isStrict) return this._weekdaysShortStrictRegex;
                    else return this._weekdaysShortRegex;
                } else {
                    if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
                    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
                }
            }
            function weekdaysMinRegex(isStrict) {
                if (this._weekdaysParseExact) {
                    if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
                    if (isStrict) return this._weekdaysMinStrictRegex;
                    else return this._weekdaysMinRegex;
                } else {
                    if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
                    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
                }
            }
            function computeWeekdaysParse() {
                function cmpLenRev(a, b) {
                    return b.length - a.length;
                }
                var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i1, mom, minp, shortp, longp;
                for(i1 = 0; i1 < 7; i1++){
                    // make the regex if we don't have it already
                    mom = createUTC([
                        2000,
                        1
                    ]).day(i1);
                    minp = regexEscape(this.weekdaysMin(mom, ""));
                    shortp = regexEscape(this.weekdaysShort(mom, ""));
                    longp = regexEscape(this.weekdays(mom, ""));
                    minPieces.push(minp);
                    shortPieces.push(shortp);
                    longPieces.push(longp);
                    mixedPieces.push(minp);
                    mixedPieces.push(shortp);
                    mixedPieces.push(longp);
                }
                // Sorting makes sure if one weekday (or abbr) is a prefix of another it
                // will match the longer piece.
                minPieces.sort(cmpLenRev);
                shortPieces.sort(cmpLenRev);
                longPieces.sort(cmpLenRev);
                mixedPieces.sort(cmpLenRev);
                this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
                this._weekdaysShortRegex = this._weekdaysRegex;
                this._weekdaysMinRegex = this._weekdaysRegex;
                this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
                this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
                this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
            }
            // FORMATTING
            function hFormat() {
                return this.hours() % 12 || 12;
            }
            function kFormat() {
                return this.hours() || 24;
            }
            addFormatToken("H", [
                "HH",
                2
            ], 0, "hour");
            addFormatToken("h", [
                "hh",
                2
            ], 0, hFormat);
            addFormatToken("k", [
                "kk",
                2
            ], 0, kFormat);
            addFormatToken("hmm", 0, 0, function() {
                return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
            });
            addFormatToken("hmmss", 0, 0, function() {
                return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
            });
            addFormatToken("Hmm", 0, 0, function() {
                return "" + this.hours() + zeroFill(this.minutes(), 2);
            });
            addFormatToken("Hmmss", 0, 0, function() {
                return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
            });
            function meridiem(token, lowercase) {
                addFormatToken(token, 0, 0, function() {
                    return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
                });
            }
            meridiem("a", true);
            meridiem("A", false);
            // ALIASES
            addUnitAlias("hour", "h");
            // PRIORITY
            addUnitPriority("hour", 13);
            // PARSING
            function matchMeridiem(isStrict, locale) {
                return locale._meridiemParse;
            }
            addRegexToken("a", matchMeridiem);
            addRegexToken("A", matchMeridiem);
            addRegexToken("H", match1to2);
            addRegexToken("h", match1to2);
            addRegexToken("k", match1to2);
            addRegexToken("HH", match1to2, match2);
            addRegexToken("hh", match1to2, match2);
            addRegexToken("kk", match1to2, match2);
            addRegexToken("hmm", match3to4);
            addRegexToken("hmmss", match5to6);
            addRegexToken("Hmm", match3to4);
            addRegexToken("Hmmss", match5to6);
            addParseToken([
                "H",
                "HH"
            ], HOUR);
            addParseToken([
                "k",
                "kk"
            ], function(input, array, config) {
                var kInput = toInt(input);
                array[HOUR] = kInput === 24 ? 0 : kInput;
            });
            addParseToken([
                "a",
                "A"
            ], function(input, array, config) {
                config._isPm = config._locale.isPM(input);
                config._meridiem = input;
            });
            addParseToken([
                "h",
                "hh"
            ], function(input, array, config) {
                array[HOUR] = toInt(input);
                getParsingFlags(config).bigHour = true;
            });
            addParseToken("hmm", function(input, array, config) {
                var pos = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos));
                array[MINUTE] = toInt(input.substr(pos));
                getParsingFlags(config).bigHour = true;
            });
            addParseToken("hmmss", function(input, array, config) {
                var pos1 = input.length - 4, pos2 = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos1));
                array[MINUTE] = toInt(input.substr(pos1, 2));
                array[SECOND] = toInt(input.substr(pos2));
                getParsingFlags(config).bigHour = true;
            });
            addParseToken("Hmm", function(input, array, config) {
                var pos = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos));
                array[MINUTE] = toInt(input.substr(pos));
            });
            addParseToken("Hmmss", function(input, array, config) {
                var pos1 = input.length - 4, pos2 = input.length - 2;
                array[HOUR] = toInt(input.substr(0, pos1));
                array[MINUTE] = toInt(input.substr(pos1, 2));
                array[SECOND] = toInt(input.substr(pos2));
            });
            // LOCALES
            function localeIsPM(input) {
                // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
                // Using charAt should be more compatible.
                return (input + "").toLowerCase().charAt(0) === "p";
            }
            var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
            // specified which hour they want. So trying to maintain the same hour (in
            // a new timezone) makes sense. Adding/subtracting hours does not follow
            // this rule.
            getSetHour = makeGetSet("Hours", true);
            function localeMeridiem(hours, minutes, isLower) {
                if (hours > 11) return isLower ? "pm" : "PM";
                else return isLower ? "am" : "AM";
            }
            var baseConfig = {
                calendar: defaultCalendar,
                longDateFormat: defaultLongDateFormat,
                invalidDate: defaultInvalidDate,
                ordinal: defaultOrdinal,
                dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
                relativeTime: defaultRelativeTime,
                months: defaultLocaleMonths,
                monthsShort: defaultLocaleMonthsShort,
                week: defaultLocaleWeek,
                weekdays: defaultLocaleWeekdays,
                weekdaysMin: defaultLocaleWeekdaysMin,
                weekdaysShort: defaultLocaleWeekdaysShort,
                meridiemParse: defaultLocaleMeridiemParse
            };
            // internal storage for locale config files
            var locales = {}, localeFamilies = {}, globalLocale;
            function commonPrefix(arr1, arr2) {
                var i1, minl = Math.min(arr1.length, arr2.length);
                for(i1 = 0; i1 < minl; i1 += 1){
                    if (arr1[i1] !== arr2[i1]) return i1;
                }
                return minl;
            }
            function normalizeLocale(key) {
                return key ? key.toLowerCase().replace("_", "-") : key;
            }
            // pick the locale from the array
            // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
            // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
            function chooseLocale(names) {
                var i1 = 0, j, next, locale, split;
                while(i1 < names.length){
                    split = normalizeLocale(names[i1]).split("-");
                    j = split.length;
                    next = normalizeLocale(names[i1 + 1]);
                    next = next ? next.split("-") : null;
                    while(j > 0){
                        locale = loadLocale(split.slice(0, j).join("-"));
                        if (locale) return locale;
                        if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                        j--;
                    }
                    i1++;
                }
                return globalLocale;
            }
            function isLocaleNameSane(name) {
                // Prevent names that look like filesystem paths, i.e contain '/' or '\'
                return name.match("^[^/\\\\]*$") != null;
            }
            function loadLocale(name) {
                var oldLocale = null, aliasedRequire;
                // TODO: Find a better way to register and load all the locales in Node
                if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
                    oldLocale = globalLocale._abbr;
                    aliasedRequire = commonjsRequire;
                    aliasedRequire("./locale/" + name);
                    getSetGlobalLocale(oldLocale);
                } catch (e) {
                    // mark as not found to avoid repeating expensive file require call causing high CPU
                    // when trying to find en-US, en_US, en-us for every format call
                    locales[name] = null; // null means not found
                }
                return locales[name];
            }
            // This function will load locale and then set the global locale.  If
            // no arguments are passed in, it will simply return the current global
            // locale key.
            function getSetGlobalLocale(key, values) {
                var data;
                if (key) {
                    if (isUndefined(values)) data = getLocale(key);
                    else data = defineLocale(key, values);
                    if (data) // moment.duration._locale = moment._locale = data;
                    globalLocale = data;
                    else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
                    console.warn("Locale " + key + " not found. Did you forget to load it?");
                }
                return globalLocale._abbr;
            }
            function defineLocale(name, config) {
                if (config !== null) {
                    var locale, parentConfig = baseConfig;
                    config.abbr = name;
                    if (locales[name] != null) {
                        deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                        parentConfig = locales[name]._config;
                    } else if (config.parentLocale != null) {
                        if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                        else {
                            locale = loadLocale(config.parentLocale);
                            if (locale != null) parentConfig = locale._config;
                            else {
                                if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                                localeFamilies[config.parentLocale].push({
                                    name: name,
                                    config: config
                                });
                                return null;
                            }
                        }
                    }
                    locales[name] = new Locale(mergeConfigs(parentConfig, config));
                    if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                        defineLocale(x.name, x.config);
                    });
                    // backwards compat for now: also set the locale
                    // make sure we set the locale AFTER all child locales have been
                    // created, so we won't end up with the child locale set.
                    getSetGlobalLocale(name);
                    return locales[name];
                } else {
                    // useful for testing
                    delete locales[name];
                    return null;
                }
            }
            function updateLocale(name, config) {
                if (config != null) {
                    var locale, tmpLocale, parentConfig = baseConfig;
                    if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
                    locales[name].set(mergeConfigs(locales[name]._config, config));
                    else {
                        // MERGE
                        tmpLocale = loadLocale(name);
                        if (tmpLocale != null) parentConfig = tmpLocale._config;
                        config = mergeConfigs(parentConfig, config);
                        if (tmpLocale == null) // updateLocale is called for creating a new locale
                        // Set abbr so it will have a name (getters return
                        // undefined otherwise).
                        config.abbr = name;
                        locale = new Locale(config);
                        locale.parentLocale = locales[name];
                        locales[name] = locale;
                    }
                    // backwards compat for now: also set the locale
                    getSetGlobalLocale(name);
                } else // pass null for config to unupdate, useful for tests
                if (locales[name] != null) {
                    if (locales[name].parentLocale != null) {
                        locales[name] = locales[name].parentLocale;
                        if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
                    } else if (locales[name] != null) delete locales[name];
                }
                return locales[name];
            }
            // returns locale data
            function getLocale(key) {
                var locale;
                if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
                if (!key) return globalLocale;
                if (!isArray(key)) {
                    //short-circuit everything else
                    locale = loadLocale(key);
                    if (locale) return locale;
                    key = [
                        key
                    ];
                }
                return chooseLocale(key);
            }
            function listLocales() {
                return keys(locales);
            }
            function checkOverflow(m) {
                var overflow, a = m._a;
                if (a && getParsingFlags(m).overflow === -2) {
                    overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
                    if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
                    if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
                    if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
                    getParsingFlags(m).overflow = overflow;
                }
                return m;
            }
            // iso 8601 regex
            // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
            var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
                [
                    "YYYYYY-MM-DD",
                    /[+-]\d{6}-\d\d-\d\d/
                ],
                [
                    "YYYY-MM-DD",
                    /\d{4}-\d\d-\d\d/
                ],
                [
                    "GGGG-[W]WW-E",
                    /\d{4}-W\d\d-\d/
                ],
                [
                    "GGGG-[W]WW",
                    /\d{4}-W\d\d/,
                    false
                ],
                [
                    "YYYY-DDD",
                    /\d{4}-\d{3}/
                ],
                [
                    "YYYY-MM",
                    /\d{4}-\d\d/,
                    false
                ],
                [
                    "YYYYYYMMDD",
                    /[+-]\d{10}/
                ],
                [
                    "YYYYMMDD",
                    /\d{8}/
                ],
                [
                    "GGGG[W]WWE",
                    /\d{4}W\d{3}/
                ],
                [
                    "GGGG[W]WW",
                    /\d{4}W\d{2}/,
                    false
                ],
                [
                    "YYYYDDD",
                    /\d{7}/
                ],
                [
                    "YYYYMM",
                    /\d{6}/,
                    false
                ],
                [
                    "YYYY",
                    /\d{4}/,
                    false
                ]
            ], // iso time formats and regexes
            isoTimes = [
                [
                    "HH:mm:ss.SSSS",
                    /\d\d:\d\d:\d\d\.\d+/
                ],
                [
                    "HH:mm:ss,SSSS",
                    /\d\d:\d\d:\d\d,\d+/
                ],
                [
                    "HH:mm:ss",
                    /\d\d:\d\d:\d\d/
                ],
                [
                    "HH:mm",
                    /\d\d:\d\d/
                ],
                [
                    "HHmmss.SSSS",
                    /\d\d\d\d\d\d\.\d+/
                ],
                [
                    "HHmmss,SSSS",
                    /\d\d\d\d\d\d,\d+/
                ],
                [
                    "HHmmss",
                    /\d\d\d\d\d\d/
                ],
                [
                    "HHmm",
                    /\d\d\d\d/
                ],
                [
                    "HH",
                    /\d\d/
                ]
            ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
            rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
                UT: 0,
                GMT: 0,
                EDT: -240,
                EST: -300,
                CDT: -300,
                CST: -360,
                MDT: -360,
                MST: -420,
                PDT: -420,
                PST: -480
            };
            // date from iso format
            function configFromISO(config) {
                var i1, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
                if (match) {
                    getParsingFlags(config).iso = true;
                    for(i1 = 0, l = isoDatesLen; i1 < l; i1++)if (isoDates[i1][1].exec(match[1])) {
                        dateFormat = isoDates[i1][0];
                        allowTime = isoDates[i1][2] !== false;
                        break;
                    }
                    if (dateFormat == null) {
                        config._isValid = false;
                        return;
                    }
                    if (match[3]) {
                        for(i1 = 0, l = isoTimesLen; i1 < l; i1++)if (isoTimes[i1][1].exec(match[3])) {
                            // match[2] should be 'T' or space
                            timeFormat = (match[2] || " ") + isoTimes[i1][0];
                            break;
                        }
                        if (timeFormat == null) {
                            config._isValid = false;
                            return;
                        }
                    }
                    if (!allowTime && timeFormat != null) {
                        config._isValid = false;
                        return;
                    }
                    if (match[4]) {
                        if (tzRegex.exec(match[4])) tzFormat = "Z";
                        else {
                            config._isValid = false;
                            return;
                        }
                    }
                    config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
                    configFromStringAndFormat(config);
                } else config._isValid = false;
            }
            function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
                var result = [
                    untruncateYear(yearStr),
                    defaultLocaleMonthsShort.indexOf(monthStr),
                    parseInt(dayStr, 10),
                    parseInt(hourStr, 10),
                    parseInt(minuteStr, 10)
                ];
                if (secondStr) result.push(parseInt(secondStr, 10));
                return result;
            }
            function untruncateYear(yearStr) {
                var year = parseInt(yearStr, 10);
                if (year <= 49) return 2000 + year;
                else if (year <= 999) return 1900 + year;
                return year;
            }
            function preprocessRFC2822(s) {
                // Remove comments and folding whitespace and replace multiple-spaces with a single space
                return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
            }
            function checkWeekday(weekdayStr, parsedInput, config) {
                if (weekdayStr) {
                    // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
                    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
                    if (weekdayProvided !== weekdayActual) {
                        getParsingFlags(config).weekdayMismatch = true;
                        config._isValid = false;
                        return false;
                    }
                }
                return true;
            }
            function calculateOffset(obsOffset, militaryOffset, numOffset) {
                if (obsOffset) return obsOffsets[obsOffset];
                else if (militaryOffset) // the only allowed military tz is Z
                return 0;
                else {
                    var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
                    return h * 60 + m;
                }
            }
            // date and time from ref 2822 format
            function configFromRFC2822(config) {
                var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
                if (match) {
                    parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
                    if (!checkWeekday(match[1], parsedArray, config)) return;
                    config._a = parsedArray;
                    config._tzm = calculateOffset(match[8], match[9], match[10]);
                    config._d = createUTCDate.apply(null, config._a);
                    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
                    getParsingFlags(config).rfc2822 = true;
                } else config._isValid = false;
            }
            // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
            function configFromString(config) {
                var matched = aspNetJsonRegex.exec(config._i);
                if (matched !== null) {
                    config._d = new Date(+matched[1]);
                    return;
                }
                configFromISO(config);
                if (config._isValid === false) delete config._isValid;
                else return;
                configFromRFC2822(config);
                if (config._isValid === false) delete config._isValid;
                else return;
                if (config._strict) config._isValid = false;
                else // Final attempt, use Input Fallback
                hooks.createFromInputFallback(config);
            }
            hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
                config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
            });
            // Pick the first defined of two or three arguments.
            function defaults(a, b, c) {
                if (a != null) return a;
                if (b != null) return b;
                return c;
            }
            function currentDateArray(config) {
                // hooks is actually the exported moment object
                var nowValue = new Date(hooks.now());
                if (config._useUTC) return [
                    nowValue.getUTCFullYear(),
                    nowValue.getUTCMonth(),
                    nowValue.getUTCDate()
                ];
                return [
                    nowValue.getFullYear(),
                    nowValue.getMonth(),
                    nowValue.getDate()
                ];
            }
            // convert an array to a date.
            // the array should mirror the parameters below
            // note: all values past the year are optional and will default to the lowest possible value.
            // [year, month, day , hour, minute, second, millisecond]
            function configFromArray(config) {
                var i1, date, input = [], currentDate, expectedWeekday, yearToUse;
                if (config._d) return;
                currentDate = currentDateArray(config);
                //compute day of the year from weeks and weekdays
                if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
                //if the day of the year is set, figure out what it is
                if (config._dayOfYear != null) {
                    yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
                    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
                    date = createUTCDate(yearToUse, 0, config._dayOfYear);
                    config._a[MONTH] = date.getUTCMonth();
                    config._a[DATE] = date.getUTCDate();
                }
                // Default to current date.
                // * if no year, month, day of month are given, default to today
                // * if day of month is given, default month and year
                // * if month is given, default only year
                // * if year is given, don't default anything
                for(i1 = 0; i1 < 3 && config._a[i1] == null; ++i1)config._a[i1] = input[i1] = currentDate[i1];
                // Zero out whatever was not defaulted, including time
                for(; i1 < 7; i1++)config._a[i1] = input[i1] = config._a[i1] == null ? i1 === 2 ? 1 : 0 : config._a[i1];
                // Check for 24:00:00.000
                if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
                    config._nextDay = true;
                    config._a[HOUR] = 0;
                }
                config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
                expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
                // Apply timezone offset from input. The actual utcOffset can be changed
                // with parseZone.
                if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
                if (config._nextDay) config._a[HOUR] = 24;
                // check for mismatching day of week
                if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
            }
            function dayOfYearFromWeekInfo(config) {
                var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
                w = config._w;
                if (w.GG != null || w.W != null || w.E != null) {
                    dow = 1;
                    doy = 4;
                    // TODO: We need to take the current isoWeekYear, but that depends on
                    // how we interpret now (local, utc, fixed offset). So create
                    // a now version of current config (take local/utc/offset flags, and
                    // create now).
                    weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
                    week = defaults(w.W, 1);
                    weekday = defaults(w.E, 1);
                    if (weekday < 1 || weekday > 7) weekdayOverflow = true;
                } else {
                    dow = config._locale._week.dow;
                    doy = config._locale._week.doy;
                    curWeek = weekOfYear(createLocal(), dow, doy);
                    weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
                    // Default to current week.
                    week = defaults(w.w, curWeek.week);
                    if (w.d != null) {
                        // weekday -- low day numbers are considered next week
                        weekday = w.d;
                        if (weekday < 0 || weekday > 6) weekdayOverflow = true;
                    } else if (w.e != null) {
                        // local weekday -- counting starts from beginning of week
                        weekday = w.e + dow;
                        if (w.e < 0 || w.e > 6) weekdayOverflow = true;
                    } else // default to beginning of week
                    weekday = dow;
                }
                if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
                else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
                else {
                    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
                    config._a[YEAR] = temp.year;
                    config._dayOfYear = temp.dayOfYear;
                }
            }
            // constant that refers to the ISO standard
            hooks.ISO_8601 = function() {};
            // constant that refers to the RFC 2822 form
            hooks.RFC_2822 = function() {};
            // date from string and format string
            function configFromStringAndFormat(config) {
                // TODO: Move this to another part of the creation flow to prevent circular deps
                if (config._f === hooks.ISO_8601) {
                    configFromISO(config);
                    return;
                }
                if (config._f === hooks.RFC_2822) {
                    configFromRFC2822(config);
                    return;
                }
                config._a = [];
                getParsingFlags(config).empty = true;
                // This array is used to make a Date, either with `new Date` or `Date.UTC`
                var string = "" + config._i, i1, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
                tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
                tokenLen = tokens.length;
                for(i1 = 0; i1 < tokenLen; i1++){
                    token = tokens[i1];
                    parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
                    if (parsedInput) {
                        skipped = string.substr(0, string.indexOf(parsedInput));
                        if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                        totalParsedInputLength += parsedInput.length;
                    }
                    // don't parse if it's not a known token
                    if (formatTokenFunctions[token]) {
                        if (parsedInput) getParsingFlags(config).empty = false;
                        else getParsingFlags(config).unusedTokens.push(token);
                        addTimeToArrayFromToken(token, parsedInput, config);
                    } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
                }
                // add remaining unparsed input length to the string
                getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
                if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
                // clear _12h flag if hour is <= 12
                if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
                getParsingFlags(config).parsedDateParts = config._a.slice(0);
                getParsingFlags(config).meridiem = config._meridiem;
                // handle meridiem
                config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
                // handle era
                era = getParsingFlags(config).era;
                if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
                configFromArray(config);
                checkOverflow(config);
            }
            function meridiemFixWrap(locale, hour, meridiem) {
                var isPm;
                if (meridiem == null) // nothing to do
                return hour;
                if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
                else if (locale.isPM != null) {
                    // Fallback
                    isPm = locale.isPM(meridiem);
                    if (isPm && hour < 12) hour += 12;
                    if (!isPm && hour === 12) hour = 0;
                    return hour;
                } else // this is not supposed to happen
                return hour;
            }
            // date from string and array of format strings
            function configFromStringAndArray(config) {
                var tempConfig, bestMoment, scoreToBeat, i1, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
                if (configfLen === 0) {
                    getParsingFlags(config).invalidFormat = true;
                    config._d = new Date(NaN);
                    return;
                }
                for(i1 = 0; i1 < configfLen; i1++){
                    currentScore = 0;
                    validFormatFound = false;
                    tempConfig = copyConfig({}, config);
                    if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
                    tempConfig._f = config._f[i1];
                    configFromStringAndFormat(tempConfig);
                    if (isValid(tempConfig)) validFormatFound = true;
                    // if there is any input that was not parsed add a penalty for that format
                    currentScore += getParsingFlags(tempConfig).charsLeftOver;
                    //or tokens
                    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
                    getParsingFlags(tempConfig).score = currentScore;
                    if (!bestFormatIsValid) {
                        if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                            scoreToBeat = currentScore;
                            bestMoment = tempConfig;
                            if (validFormatFound) bestFormatIsValid = true;
                        }
                    } else if (currentScore < scoreToBeat) {
                        scoreToBeat = currentScore;
                        bestMoment = tempConfig;
                    }
                }
                extend(config, bestMoment || tempConfig);
            }
            function configFromObject(config) {
                if (config._d) return;
                var i1 = normalizeObjectUnits(config._i), dayOrDate = i1.day === undefined ? i1.date : i1.day;
                config._a = map([
                    i1.year,
                    i1.month,
                    dayOrDate,
                    i1.hour,
                    i1.minute,
                    i1.second,
                    i1.millisecond
                ], function(obj) {
                    return obj && parseInt(obj, 10);
                });
                configFromArray(config);
            }
            function createFromConfig(config) {
                var res = new Moment(checkOverflow(prepareConfig(config)));
                if (res._nextDay) {
                    // Adding is smart enough around DST
                    res.add(1, "d");
                    res._nextDay = undefined;
                }
                return res;
            }
            function prepareConfig(config) {
                var input = config._i, format = config._f;
                config._locale = config._locale || getLocale(config._l);
                if (input === null || format === undefined && input === "") return createInvalid({
                    nullInput: true
                });
                if (typeof input === "string") config._i = input = config._locale.preparse(input);
                if (isMoment(input)) return new Moment(checkOverflow(input));
                else if (isDate(input)) config._d = input;
                else if (isArray(format)) configFromStringAndArray(config);
                else if (format) configFromStringAndFormat(config);
                else configFromInput(config);
                if (!isValid(config)) config._d = null;
                return config;
            }
            function configFromInput(config) {
                var input = config._i;
                if (isUndefined(input)) config._d = new Date(hooks.now());
                else if (isDate(input)) config._d = new Date(input.valueOf());
                else if (typeof input === "string") configFromString(config);
                else if (isArray(input)) {
                    config._a = map(input.slice(0), function(obj) {
                        return parseInt(obj, 10);
                    });
                    configFromArray(config);
                } else if (isObject(input)) configFromObject(config);
                else if (isNumber(input)) // from milliseconds
                config._d = new Date(input);
                else hooks.createFromInputFallback(config);
            }
            function createLocalOrUTC(input, format, locale, strict, isUTC) {
                var c = {};
                if (format === true || format === false) {
                    strict = format;
                    format = undefined;
                }
                if (locale === true || locale === false) {
                    strict = locale;
                    locale = undefined;
                }
                if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
                // object construction must be done this way.
                // https://github.com/moment/moment/issues/1423
                c._isAMomentObject = true;
                c._useUTC = c._isUTC = isUTC;
                c._l = locale;
                c._i = input;
                c._f = format;
                c._strict = strict;
                return createFromConfig(c);
            }
            function createLocal(input, format, locale, strict) {
                return createLocalOrUTC(input, format, locale, strict, false);
            }
            var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) return other < this ? this : other;
                else return createInvalid();
            }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) return other > this ? this : other;
                else return createInvalid();
            });
            // Pick a moment m from moments so that m[fn](other) is true for all
            // other. This relies on the function fn to be transitive.
            //
            // moments should either be an array of moment objects or an array, whose
            // first element is an array of moment objects.
            function pickBy(fn, moments) {
                var res, i1;
                if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
                if (!moments.length) return createLocal();
                res = moments[0];
                for(i1 = 1; i1 < moments.length; ++i1)if (!moments[i1].isValid() || moments[i1][fn](res)) res = moments[i1];
                return res;
            }
            // TODO: Use [].sort instead?
            function min() {
                var args = [].slice.call(arguments, 0);
                return pickBy("isBefore", args);
            }
            function max() {
                var args = [].slice.call(arguments, 0);
                return pickBy("isAfter", args);
            }
            var now = function() {
                return Date.now ? Date.now() : +new Date();
            };
            var ordering = [
                "year",
                "quarter",
                "month",
                "week",
                "day",
                "hour",
                "minute",
                "second",
                "millisecond"
            ];
            function isDurationValid(m) {
                var key, unitHasDecimal = false, i1, orderLen = ordering.length;
                for(key in m){
                    if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
                }
                for(i1 = 0; i1 < orderLen; ++i1)if (m[ordering[i1]]) {
                    if (unitHasDecimal) return false; // only allow non-integers for smallest unit
                    if (parseFloat(m[ordering[i1]]) !== toInt(m[ordering[i1]])) unitHasDecimal = true;
                }
                return true;
            }
            function isValid$1() {
                return this._isValid;
            }
            function createInvalid$1() {
                return createDuration(NaN);
            }
            function Duration(duration) {
                var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
                this._isValid = isDurationValid(normalizedInput);
                // representation for dateAddRemove
                this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
                minutes * 6e4 + // 1000 * 60
                hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
                // Because of dateAddRemove treats 24 hours as different from a
                // day when working around DST, we need to store them separately
                this._days = +days + weeks * 7;
                // It is impossible to translate months into days without knowing
                // which months you are are talking about, so we have to store
                // it separately.
                this._months = +months + quarters * 3 + years * 12;
                this._data = {};
                this._locale = getLocale();
                this._bubble();
            }
            function isDuration(obj) {
                return obj instanceof Duration;
            }
            function absRound(number) {
                if (number < 0) return Math.round(-1 * number) * -1;
                else return Math.round(number);
            }
            // compare two arrays, return the number of differences
            function compareArrays(array1, array2, dontConvert) {
                var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i1;
                for(i1 = 0; i1 < len; i1++)if (dontConvert && array1[i1] !== array2[i1] || !dontConvert && toInt(array1[i1]) !== toInt(array2[i1])) diffs++;
                return diffs + lengthDiff;
            }
            // FORMATTING
            function offset(token, separator) {
                addFormatToken(token, 0, 0, function() {
                    var offset = this.utcOffset(), sign = "+";
                    if (offset < 0) {
                        offset = -offset;
                        sign = "-";
                    }
                    return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
                });
            }
            offset("Z", ":");
            offset("ZZ", "");
            // PARSING
            addRegexToken("Z", matchShortOffset);
            addRegexToken("ZZ", matchShortOffset);
            addParseToken([
                "Z",
                "ZZ"
            ], function(input, array, config) {
                config._useUTC = true;
                config._tzm = offsetFromString(matchShortOffset, input);
            });
            // HELPERS
            // timezone chunker
            // '+10:00' > ['10',  '00']
            // '-1530'  > ['-15', '30']
            var chunkOffset = /([\+\-]|\d\d)/gi;
            function offsetFromString(matcher, string) {
                var matches = (string || "").match(matcher), chunk, parts, minutes;
                if (matches === null) return null;
                chunk = matches[matches.length - 1] || [];
                parts = (chunk + "").match(chunkOffset) || [
                    "-",
                    0,
                    0
                ];
                minutes = +(parts[1] * 60) + toInt(parts[2]);
                return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
            }
            // Return a moment from input, that is local/utc/zone equivalent to model.
            function cloneWithOffset(input, model) {
                var res, diff;
                if (model._isUTC) {
                    res = model.clone();
                    diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
                    // Use low-level api, because this fn is low-level api.
                    res._d.setTime(res._d.valueOf() + diff);
                    hooks.updateOffset(res, false);
                    return res;
                } else return createLocal(input).local();
            }
            function getDateOffset(m) {
                // On Firefox.24 Date#getTimezoneOffset returns a floating point.
                // https://github.com/moment/moment/pull/1871
                return -Math.round(m._d.getTimezoneOffset());
            }
            // HOOKS
            // This function will be called whenever a moment is mutated.
            // It is intended to keep the offset in sync with the timezone.
            hooks.updateOffset = function() {};
            // MOMENTS
            // keepLocalTime = true means only change the timezone, without
            // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
            // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
            // +0200, so we adjust the time as needed, to be valid.
            //
            // Keeping the time actually adds/subtracts (one hour)
            // from the actual represented time. That is why we call updateOffset
            // a second time. In case it wants us to change the offset again
            // _changeInProgress == true case, then we have to adjust, because
            // there is no such time in the given timezone.
            function getSetOffset(input, keepLocalTime, keepMinutes) {
                var offset = this._offset || 0, localAdjust;
                if (!this.isValid()) return input != null ? this : NaN;
                if (input != null) {
                    if (typeof input === "string") {
                        input = offsetFromString(matchShortOffset, input);
                        if (input === null) return this;
                    } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
                    if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
                    this._offset = input;
                    this._isUTC = true;
                    if (localAdjust != null) this.add(localAdjust, "m");
                    if (offset !== input) {
                        if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                        else if (!this._changeInProgress) {
                            this._changeInProgress = true;
                            hooks.updateOffset(this, true);
                            this._changeInProgress = null;
                        }
                    }
                    return this;
                } else return this._isUTC ? offset : getDateOffset(this);
            }
            function getSetZone(input, keepLocalTime) {
                if (input != null) {
                    if (typeof input !== "string") input = -input;
                    this.utcOffset(input, keepLocalTime);
                    return this;
                } else return -this.utcOffset();
            }
            function setOffsetToUTC(keepLocalTime) {
                return this.utcOffset(0, keepLocalTime);
            }
            function setOffsetToLocal(keepLocalTime) {
                if (this._isUTC) {
                    this.utcOffset(0, keepLocalTime);
                    this._isUTC = false;
                    if (keepLocalTime) this.subtract(getDateOffset(this), "m");
                }
                return this;
            }
            function setOffsetToParsedOffset() {
                if (this._tzm != null) this.utcOffset(this._tzm, false, true);
                else if (typeof this._i === "string") {
                    var tZone = offsetFromString(matchOffset, this._i);
                    if (tZone != null) this.utcOffset(tZone);
                    else this.utcOffset(0, true);
                }
                return this;
            }
            function hasAlignedHourOffset(input) {
                if (!this.isValid()) return false;
                input = input ? createLocal(input).utcOffset() : 0;
                return (this.utcOffset() - input) % 60 === 0;
            }
            function isDaylightSavingTime() {
                return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
            }
            function isDaylightSavingTimeShifted() {
                if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
                var c = {}, other;
                copyConfig(c, this);
                c = prepareConfig(c);
                if (c._a) {
                    other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
                    this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
                } else this._isDSTShifted = false;
                return this._isDSTShifted;
            }
            function isLocal() {
                return this.isValid() ? !this._isUTC : false;
            }
            function isUtcOffset() {
                return this.isValid() ? this._isUTC : false;
            }
            function isUtc() {
                return this.isValid() ? this._isUTC && this._offset === 0 : false;
            }
            // ASP.NET json date format regex
            var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
            // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
            // and further modified to allow for strings containing both week and day
            isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
            function createDuration(input, key) {
                var duration = input, // matching against regexp is expensive, do it on demand
                match = null, sign, ret, diffRes;
                if (isDuration(input)) duration = {
                    ms: input._milliseconds,
                    d: input._days,
                    M: input._months
                };
                else if (isNumber(input) || !isNaN(+input)) {
                    duration = {};
                    if (key) duration[key] = +input;
                    else duration.milliseconds = +input;
                } else if (match = aspNetRegex.exec(input)) {
                    sign = match[1] === "-" ? -1 : 1;
                    duration = {
                        y: 0,
                        d: toInt(match[DATE]) * sign,
                        h: toInt(match[HOUR]) * sign,
                        m: toInt(match[MINUTE]) * sign,
                        s: toInt(match[SECOND]) * sign,
                        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
                    };
                } else if (match = isoRegex.exec(input)) {
                    sign = match[1] === "-" ? -1 : 1;
                    duration = {
                        y: parseIso(match[2], sign),
                        M: parseIso(match[3], sign),
                        w: parseIso(match[4], sign),
                        d: parseIso(match[5], sign),
                        h: parseIso(match[6], sign),
                        m: parseIso(match[7], sign),
                        s: parseIso(match[8], sign)
                    };
                } else if (duration == null) // checks for null or undefined
                duration = {};
                else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
                    diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
                    duration = {};
                    duration.ms = diffRes.milliseconds;
                    duration.M = diffRes.months;
                }
                ret = new Duration(duration);
                if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
                if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
                return ret;
            }
            createDuration.fn = Duration.prototype;
            createDuration.invalid = createInvalid$1;
            function parseIso(inp, sign) {
                // We'd normally use ~~inp for this, but unfortunately it also
                // converts floats to ints.
                // inp may be undefined, so careful calling replace on it.
                var res = inp && parseFloat(inp.replace(",", "."));
                // apply sign while we're at it
                return (isNaN(res) ? 0 : res) * sign;
            }
            function positiveMomentsDifference(base, other) {
                var res = {};
                res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
                if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
                res.milliseconds = +other - +base.clone().add(res.months, "M");
                return res;
            }
            function momentsDifference(base, other) {
                var res;
                if (!(base.isValid() && other.isValid())) return {
                    milliseconds: 0,
                    months: 0
                };
                other = cloneWithOffset(other, base);
                if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
                else {
                    res = positiveMomentsDifference(other, base);
                    res.milliseconds = -res.milliseconds;
                    res.months = -res.months;
                }
                return res;
            }
            // TODO: remove 'name' arg after deprecation is removed
            function createAdder(direction, name) {
                return function(val, period) {
                    var dur, tmp;
                    //invert the arguments, but complain about it
                    if (period !== null && !isNaN(+period)) {
                        deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                        tmp = val;
                        val = period;
                        period = tmp;
                    }
                    dur = createDuration(val, period);
                    addSubtract(this, dur, direction);
                    return this;
                };
            }
            function addSubtract(mom, duration, isAdding, updateOffset) {
                var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
                if (!mom.isValid()) // No op
                return;
                updateOffset = updateOffset == null ? true : updateOffset;
                if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
                if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
                if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
                if (updateOffset) hooks.updateOffset(mom, days || months);
            }
            var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
            function isString(input) {
                return typeof input === "string" || input instanceof String;
            }
            // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
            function isMomentInput(input) {
                return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
            }
            function isMomentInputObject(input) {
                var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
                    "years",
                    "year",
                    "y",
                    "months",
                    "month",
                    "M",
                    "days",
                    "day",
                    "d",
                    "dates",
                    "date",
                    "D",
                    "hours",
                    "hour",
                    "h",
                    "minutes",
                    "minute",
                    "m",
                    "seconds",
                    "second",
                    "s",
                    "milliseconds",
                    "millisecond",
                    "ms"
                ], i1, property, propertyLen = properties.length;
                for(i1 = 0; i1 < propertyLen; i1 += 1){
                    property = properties[i1];
                    propertyTest = propertyTest || hasOwnProp(input, property);
                }
                return objectTest && propertyTest;
            }
            function isNumberOrStringArray(input) {
                var arrayTest = isArray(input), dataTypeTest = false;
                if (arrayTest) dataTypeTest = input.filter(function(item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
                return arrayTest && dataTypeTest;
            }
            function isCalendarSpec(input) {
                var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
                    "sameDay",
                    "nextDay",
                    "lastDay",
                    "nextWeek",
                    "lastWeek",
                    "sameElse"
                ], i1, property;
                for(i1 = 0; i1 < properties.length; i1 += 1){
                    property = properties[i1];
                    propertyTest = propertyTest || hasOwnProp(input, property);
                }
                return objectTest && propertyTest;
            }
            function getCalendarFormat(myMoment, now) {
                var diff = myMoment.diff(now, "days", true);
                return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
            }
            function calendar$1(time, formats) {
                // Support for single parameter, formats only overload to the calendar function
                if (arguments.length === 1) {
                    if (!arguments[0]) {
                        time = undefined;
                        formats = undefined;
                    } else if (isMomentInput(arguments[0])) {
                        time = arguments[0];
                        formats = undefined;
                    } else if (isCalendarSpec(arguments[0])) {
                        formats = arguments[0];
                        time = undefined;
                    }
                }
                // We want to compare the start of today, vs this.
                // Getting start-of-today depends on whether we're local/utc/offset or not.
                var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
                return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
            }
            function clone() {
                return new Moment(this);
            }
            function isAfter(input, units) {
                var localInput = isMoment(input) ? input : createLocal(input);
                if (!(this.isValid() && localInput.isValid())) return false;
                units = normalizeUnits(units) || "millisecond";
                if (units === "millisecond") return this.valueOf() > localInput.valueOf();
                else return localInput.valueOf() < this.clone().startOf(units).valueOf();
            }
            function isBefore(input, units) {
                var localInput = isMoment(input) ? input : createLocal(input);
                if (!(this.isValid() && localInput.isValid())) return false;
                units = normalizeUnits(units) || "millisecond";
                if (units === "millisecond") return this.valueOf() < localInput.valueOf();
                else return this.clone().endOf(units).valueOf() < localInput.valueOf();
            }
            function isBetween(from, to, units, inclusivity) {
                var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
                if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
                inclusivity = inclusivity || "()";
                return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
            }
            function isSame(input, units) {
                var localInput = isMoment(input) ? input : createLocal(input), inputMs;
                if (!(this.isValid() && localInput.isValid())) return false;
                units = normalizeUnits(units) || "millisecond";
                if (units === "millisecond") return this.valueOf() === localInput.valueOf();
                else {
                    inputMs = localInput.valueOf();
                    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
                }
            }
            function isSameOrAfter(input, units) {
                return this.isSame(input, units) || this.isAfter(input, units);
            }
            function isSameOrBefore(input, units) {
                return this.isSame(input, units) || this.isBefore(input, units);
            }
            function diff(input, units, asFloat) {
                var that, zoneDelta, output;
                if (!this.isValid()) return NaN;
                that = cloneWithOffset(input, this);
                if (!that.isValid()) return NaN;
                zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
                units = normalizeUnits(units);
                switch(units){
                    case "year":
                        output = monthDiff(this, that) / 12;
                        break;
                    case "month":
                        output = monthDiff(this, that);
                        break;
                    case "quarter":
                        output = monthDiff(this, that) / 3;
                        break;
                    case "second":
                        output = (this - that) / 1e3;
                        break; // 1000
                    case "minute":
                        output = (this - that) / 6e4;
                        break; // 1000 * 60
                    case "hour":
                        output = (this - that) / 36e5;
                        break; // 1000 * 60 * 60
                    case "day":
                        output = (this - that - zoneDelta) / 864e5;
                        break; // 1000 * 60 * 60 * 24, negate dst
                    case "week":
                        output = (this - that - zoneDelta) / 6048e5;
                        break; // 1000 * 60 * 60 * 24 * 7, negate dst
                    default:
                        output = this - that;
                }
                return asFloat ? output : absFloor(output);
            }
            function monthDiff(a, b) {
                if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
                // days than the end month.
                return -monthDiff(b, a);
                // difference in months
                var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
                anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
                if (b - anchor < 0) {
                    anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
                    // linear across the month
                    adjust = (b - anchor) / (anchor - anchor2);
                } else {
                    anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
                    // linear across the month
                    adjust = (b - anchor) / (anchor2 - anchor);
                }
                //check for negative zero, return zero if negative zero
                return -(wholeMonthDiff + adjust) || 0;
            }
            hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
            hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
            function toString() {
                return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
            }
            function toISOString(keepOffset) {
                if (!this.isValid()) return null;
                var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
                if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
                if (isFunction(Date.prototype.toISOString)) {
                    // native implementation is ~50x faster, use it when we can
                    if (utc) return this.toDate().toISOString();
                    else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
                }
                return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
            }
            /**
		     * Return a human readable representation of a moment that can
		     * also be evaluated to get a new moment which is the same
		     *
		     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
		     */ function inspect() {
                if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
                var func = "moment", zone = "", prefix, year, datetime, suffix;
                if (!this.isLocal()) {
                    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
                    zone = "Z";
                }
                prefix = "[" + func + '("]';
                year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
                datetime = "-MM-DD[T]HH:mm:ss.SSS";
                suffix = zone + '[")]';
                return this.format(prefix + year + datetime + suffix);
            }
            function format(inputString) {
                if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
                var output = formatMoment(this, inputString);
                return this.localeData().postformat(output);
            }
            function from(time, withoutSuffix) {
                if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
                    to: this,
                    from: time
                }).locale(this.locale()).humanize(!withoutSuffix);
                else return this.localeData().invalidDate();
            }
            function fromNow(withoutSuffix) {
                return this.from(createLocal(), withoutSuffix);
            }
            function to(time, withoutSuffix) {
                if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
                    from: this,
                    to: time
                }).locale(this.locale()).humanize(!withoutSuffix);
                else return this.localeData().invalidDate();
            }
            function toNow(withoutSuffix) {
                return this.to(createLocal(), withoutSuffix);
            }
            // If passed a locale key, it will set the locale for this
            // instance.  Otherwise, it will return the locale configuration
            // variables for this instance.
            function locale(key) {
                var newLocaleData;
                if (key === undefined) return this._locale._abbr;
                else {
                    newLocaleData = getLocale(key);
                    if (newLocaleData != null) this._locale = newLocaleData;
                    return this;
                }
            }
            var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
                if (key === undefined) return this.localeData();
                else return this.locale(key);
            });
            function localeData() {
                return this._locale;
            }
            var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
            // actual modulo - handles negative numbers (for dates before 1970):
            function mod$1(dividend, divisor) {
                return (dividend % divisor + divisor) % divisor;
            }
            function localStartOfDate(y, m, d) {
                // the date constructor remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
                return new Date(y + 400, m, d) - MS_PER_400_YEARS;
                else return new Date(y, m, d).valueOf();
            }
            function utcStartOfDate(y, m, d) {
                // Date.UTC remaps years 0-99 to 1900-1999
                if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
                return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
                else return Date.UTC(y, m, d);
            }
            function startOf(units) {
                var time, startOfDate;
                units = normalizeUnits(units);
                if (units === undefined || units === "millisecond" || !this.isValid()) return this;
                startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
                switch(units){
                    case "year":
                        time = startOfDate(this.year(), 0, 1);
                        break;
                    case "quarter":
                        time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                        break;
                    case "month":
                        time = startOfDate(this.year(), this.month(), 1);
                        break;
                    case "week":
                        time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                        break;
                    case "isoWeek":
                        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                        break;
                    case "day":
                    case "date":
                        time = startOfDate(this.year(), this.month(), this.date());
                        break;
                    case "hour":
                        time = this._d.valueOf();
                        time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                        break;
                    case "minute":
                        time = this._d.valueOf();
                        time -= mod$1(time, MS_PER_MINUTE);
                        break;
                    case "second":
                        time = this._d.valueOf();
                        time -= mod$1(time, MS_PER_SECOND);
                        break;
                }
                this._d.setTime(time);
                hooks.updateOffset(this, true);
                return this;
            }
            function endOf(units) {
                var time, startOfDate;
                units = normalizeUnits(units);
                if (units === undefined || units === "millisecond" || !this.isValid()) return this;
                startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
                switch(units){
                    case "year":
                        time = startOfDate(this.year() + 1, 0, 1) - 1;
                        break;
                    case "quarter":
                        time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                        break;
                    case "month":
                        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                        break;
                    case "week":
                        time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                        break;
                    case "isoWeek":
                        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                        break;
                    case "day":
                    case "date":
                        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                        break;
                    case "hour":
                        time = this._d.valueOf();
                        time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                        break;
                    case "minute":
                        time = this._d.valueOf();
                        time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                        break;
                    case "second":
                        time = this._d.valueOf();
                        time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                        break;
                }
                this._d.setTime(time);
                hooks.updateOffset(this, true);
                return this;
            }
            function valueOf() {
                return this._d.valueOf() - (this._offset || 0) * 60000;
            }
            function unix() {
                return Math.floor(this.valueOf() / 1000);
            }
            function toDate() {
                return new Date(this.valueOf());
            }
            function toArray() {
                var m = this;
                return [
                    m.year(),
                    m.month(),
                    m.date(),
                    m.hour(),
                    m.minute(),
                    m.second(),
                    m.millisecond()
                ];
            }
            function toObject() {
                var m = this;
                return {
                    years: m.year(),
                    months: m.month(),
                    date: m.date(),
                    hours: m.hours(),
                    minutes: m.minutes(),
                    seconds: m.seconds(),
                    milliseconds: m.milliseconds()
                };
            }
            function toJSON() {
                // new Date(NaN).toJSON() === null
                return this.isValid() ? this.toISOString() : null;
            }
            function isValid$2() {
                return isValid(this);
            }
            function parsingFlags() {
                return extend({}, getParsingFlags(this));
            }
            function invalidAt() {
                return getParsingFlags(this).overflow;
            }
            function creationData() {
                return {
                    input: this._i,
                    format: this._f,
                    locale: this._locale,
                    isUTC: this._isUTC,
                    strict: this._strict
                };
            }
            addFormatToken("N", 0, 0, "eraAbbr");
            addFormatToken("NN", 0, 0, "eraAbbr");
            addFormatToken("NNN", 0, 0, "eraAbbr");
            addFormatToken("NNNN", 0, 0, "eraName");
            addFormatToken("NNNNN", 0, 0, "eraNarrow");
            addFormatToken("y", [
                "y",
                1
            ], "yo", "eraYear");
            addFormatToken("y", [
                "yy",
                2
            ], 0, "eraYear");
            addFormatToken("y", [
                "yyy",
                3
            ], 0, "eraYear");
            addFormatToken("y", [
                "yyyy",
                4
            ], 0, "eraYear");
            addRegexToken("N", matchEraAbbr);
            addRegexToken("NN", matchEraAbbr);
            addRegexToken("NNN", matchEraAbbr);
            addRegexToken("NNNN", matchEraName);
            addRegexToken("NNNNN", matchEraNarrow);
            addParseToken([
                "N",
                "NN",
                "NNN",
                "NNNN",
                "NNNNN"
            ], function(input, array, config, token) {
                var era = config._locale.erasParse(input, token, config._strict);
                if (era) getParsingFlags(config).era = era;
                else getParsingFlags(config).invalidEra = input;
            });
            addRegexToken("y", matchUnsigned);
            addRegexToken("yy", matchUnsigned);
            addRegexToken("yyy", matchUnsigned);
            addRegexToken("yyyy", matchUnsigned);
            addRegexToken("yo", matchEraYearOrdinal);
            addParseToken([
                "y",
                "yy",
                "yyy",
                "yyyy"
            ], YEAR);
            addParseToken([
                "yo"
            ], function(input, array, config, token) {
                var match;
                if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
                if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
                else array[YEAR] = parseInt(input, 10);
            });
            function localeEras(m, format) {
                var i1, l, date, eras = this._eras || getLocale("en")._eras;
                for(i1 = 0, l = eras.length; i1 < l; ++i1){
                    switch(typeof eras[i1].since){
                        case "string":
                            // truncate time
                            date = hooks(eras[i1].since).startOf("day");
                            eras[i1].since = date.valueOf();
                            break;
                    }
                    switch(typeof eras[i1].until){
                        case "undefined":
                            eras[i1].until = Infinity;
                            break;
                        case "string":
                            // truncate time
                            date = hooks(eras[i1].until).startOf("day").valueOf();
                            eras[i1].until = date.valueOf();
                            break;
                    }
                }
                return eras;
            }
            function localeErasParse(eraName, format, strict) {
                var i1, l, eras = this.eras(), name, abbr, narrow;
                eraName = eraName.toUpperCase();
                for(i1 = 0, l = eras.length; i1 < l; ++i1){
                    name = eras[i1].name.toUpperCase();
                    abbr = eras[i1].abbr.toUpperCase();
                    narrow = eras[i1].narrow.toUpperCase();
                    if (strict) switch(format){
                        case "N":
                        case "NN":
                        case "NNN":
                            if (abbr === eraName) return eras[i1];
                            break;
                        case "NNNN":
                            if (name === eraName) return eras[i1];
                            break;
                        case "NNNNN":
                            if (narrow === eraName) return eras[i1];
                            break;
                    }
                    else if ([
                        name,
                        abbr,
                        narrow
                    ].indexOf(eraName) >= 0) return eras[i1];
                }
            }
            function localeErasConvertYear(era, year) {
                var dir = era.since <= era.until ? 1 : -1;
                if (year === undefined) return hooks(era.since).year();
                else return hooks(era.since).year() + (year - era.offset) * dir;
            }
            function getEraName() {
                var i1, l, val, eras = this.localeData().eras();
                for(i1 = 0, l = eras.length; i1 < l; ++i1){
                    // truncate time
                    val = this.clone().startOf("day").valueOf();
                    if (eras[i1].since <= val && val <= eras[i1].until) return eras[i1].name;
                    if (eras[i1].until <= val && val <= eras[i1].since) return eras[i1].name;
                }
                return "";
            }
            function getEraNarrow() {
                var i1, l, val, eras = this.localeData().eras();
                for(i1 = 0, l = eras.length; i1 < l; ++i1){
                    // truncate time
                    val = this.clone().startOf("day").valueOf();
                    if (eras[i1].since <= val && val <= eras[i1].until) return eras[i1].narrow;
                    if (eras[i1].until <= val && val <= eras[i1].since) return eras[i1].narrow;
                }
                return "";
            }
            function getEraAbbr() {
                var i1, l, val, eras = this.localeData().eras();
                for(i1 = 0, l = eras.length; i1 < l; ++i1){
                    // truncate time
                    val = this.clone().startOf("day").valueOf();
                    if (eras[i1].since <= val && val <= eras[i1].until) return eras[i1].abbr;
                    if (eras[i1].until <= val && val <= eras[i1].since) return eras[i1].abbr;
                }
                return "";
            }
            function getEraYear() {
                var i1, l, dir, val, eras = this.localeData().eras();
                for(i1 = 0, l = eras.length; i1 < l; ++i1){
                    dir = eras[i1].since <= eras[i1].until ? 1 : -1;
                    // truncate time
                    val = this.clone().startOf("day").valueOf();
                    if (eras[i1].since <= val && val <= eras[i1].until || eras[i1].until <= val && val <= eras[i1].since) return (this.year() - hooks(eras[i1].since).year()) * dir + eras[i1].offset;
                }
                return this.year();
            }
            function erasNameRegex(isStrict) {
                if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
                return isStrict ? this._erasNameRegex : this._erasRegex;
            }
            function erasAbbrRegex(isStrict) {
                if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
                return isStrict ? this._erasAbbrRegex : this._erasRegex;
            }
            function erasNarrowRegex(isStrict) {
                if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
                return isStrict ? this._erasNarrowRegex : this._erasRegex;
            }
            function matchEraAbbr(isStrict, locale) {
                return locale.erasAbbrRegex(isStrict);
            }
            function matchEraName(isStrict, locale) {
                return locale.erasNameRegex(isStrict);
            }
            function matchEraNarrow(isStrict, locale) {
                return locale.erasNarrowRegex(isStrict);
            }
            function matchEraYearOrdinal(isStrict, locale) {
                return locale._eraYearOrdinalRegex || matchUnsigned;
            }
            function computeErasParse() {
                var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i1, l, eras = this.eras();
                for(i1 = 0, l = eras.length; i1 < l; ++i1){
                    namePieces.push(regexEscape(eras[i1].name));
                    abbrPieces.push(regexEscape(eras[i1].abbr));
                    narrowPieces.push(regexEscape(eras[i1].narrow));
                    mixedPieces.push(regexEscape(eras[i1].name));
                    mixedPieces.push(regexEscape(eras[i1].abbr));
                    mixedPieces.push(regexEscape(eras[i1].narrow));
                }
                this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
                this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
                this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
                this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
            }
            // FORMATTING
            addFormatToken(0, [
                "gg",
                2
            ], 0, function() {
                return this.weekYear() % 100;
            });
            addFormatToken(0, [
                "GG",
                2
            ], 0, function() {
                return this.isoWeekYear() % 100;
            });
            function addWeekYearFormatToken(token, getter) {
                addFormatToken(0, [
                    token,
                    token.length
                ], 0, getter);
            }
            addWeekYearFormatToken("gggg", "weekYear");
            addWeekYearFormatToken("ggggg", "weekYear");
            addWeekYearFormatToken("GGGG", "isoWeekYear");
            addWeekYearFormatToken("GGGGG", "isoWeekYear");
            // ALIASES
            addUnitAlias("weekYear", "gg");
            addUnitAlias("isoWeekYear", "GG");
            // PRIORITY
            addUnitPriority("weekYear", 1);
            addUnitPriority("isoWeekYear", 1);
            // PARSING
            addRegexToken("G", matchSigned);
            addRegexToken("g", matchSigned);
            addRegexToken("GG", match1to2, match2);
            addRegexToken("gg", match1to2, match2);
            addRegexToken("GGGG", match1to4, match4);
            addRegexToken("gggg", match1to4, match4);
            addRegexToken("GGGGG", match1to6, match6);
            addRegexToken("ggggg", match1to6, match6);
            addWeekParseToken([
                "gggg",
                "ggggg",
                "GGGG",
                "GGGGG"
            ], function(input, week, config, token) {
                week[token.substr(0, 2)] = toInt(input);
            });
            addWeekParseToken([
                "gg",
                "GG"
            ], function(input, week, config, token) {
                week[token] = hooks.parseTwoDigitYear(input);
            });
            // MOMENTS
            function getSetWeekYear(input) {
                return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
            }
            function getSetISOWeekYear(input) {
                return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
            }
            function getISOWeeksInYear() {
                return weeksInYear(this.year(), 1, 4);
            }
            function getISOWeeksInISOWeekYear() {
                return weeksInYear(this.isoWeekYear(), 1, 4);
            }
            function getWeeksInYear() {
                var weekInfo = this.localeData()._week;
                return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
            }
            function getWeeksInWeekYear() {
                var weekInfo = this.localeData()._week;
                return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
            }
            function getSetWeekYearHelper(input, week, weekday, dow, doy) {
                var weeksTarget;
                if (input == null) return weekOfYear(this, dow, doy).year;
                else {
                    weeksTarget = weeksInYear(input, dow, doy);
                    if (week > weeksTarget) week = weeksTarget;
                    return setWeekAll.call(this, input, week, weekday, dow, doy);
                }
            }
            function setWeekAll(weekYear, week, weekday, dow, doy) {
                var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
                this.year(date.getUTCFullYear());
                this.month(date.getUTCMonth());
                this.date(date.getUTCDate());
                return this;
            }
            // FORMATTING
            addFormatToken("Q", 0, "Qo", "quarter");
            // ALIASES
            addUnitAlias("quarter", "Q");
            // PRIORITY
            addUnitPriority("quarter", 7);
            // PARSING
            addRegexToken("Q", match1);
            addParseToken("Q", function(input, array) {
                array[MONTH] = (toInt(input) - 1) * 3;
            });
            // MOMENTS
            function getSetQuarter(input) {
                return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
            }
            // FORMATTING
            addFormatToken("D", [
                "DD",
                2
            ], "Do", "date");
            // ALIASES
            addUnitAlias("date", "D");
            // PRIORITY
            addUnitPriority("date", 9);
            // PARSING
            addRegexToken("D", match1to2);
            addRegexToken("DD", match1to2, match2);
            addRegexToken("Do", function(isStrict, locale) {
                // TODO: Remove "ordinalParse" fallback in next major release.
                return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
            });
            addParseToken([
                "D",
                "DD"
            ], DATE);
            addParseToken("Do", function(input, array) {
                array[DATE] = toInt(input.match(match1to2)[0]);
            });
            // MOMENTS
            var getSetDayOfMonth = makeGetSet("Date", true);
            // FORMATTING
            addFormatToken("DDD", [
                "DDDD",
                3
            ], "DDDo", "dayOfYear");
            // ALIASES
            addUnitAlias("dayOfYear", "DDD");
            // PRIORITY
            addUnitPriority("dayOfYear", 4);
            // PARSING
            addRegexToken("DDD", match1to3);
            addRegexToken("DDDD", match3);
            addParseToken([
                "DDD",
                "DDDD"
            ], function(input, array, config) {
                config._dayOfYear = toInt(input);
            });
            // HELPERS
            // MOMENTS
            function getSetDayOfYear(input) {
                var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
                return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
            }
            // FORMATTING
            addFormatToken("m", [
                "mm",
                2
            ], 0, "minute");
            // ALIASES
            addUnitAlias("minute", "m");
            // PRIORITY
            addUnitPriority("minute", 14);
            // PARSING
            addRegexToken("m", match1to2);
            addRegexToken("mm", match1to2, match2);
            addParseToken([
                "m",
                "mm"
            ], MINUTE);
            // MOMENTS
            var getSetMinute = makeGetSet("Minutes", false);
            // FORMATTING
            addFormatToken("s", [
                "ss",
                2
            ], 0, "second");
            // ALIASES
            addUnitAlias("second", "s");
            // PRIORITY
            addUnitPriority("second", 15);
            // PARSING
            addRegexToken("s", match1to2);
            addRegexToken("ss", match1to2, match2);
            addParseToken([
                "s",
                "ss"
            ], SECOND);
            // MOMENTS
            var getSetSecond = makeGetSet("Seconds", false);
            // FORMATTING
            addFormatToken("S", 0, 0, function() {
                return ~~(this.millisecond() / 100);
            });
            addFormatToken(0, [
                "SS",
                2
            ], 0, function() {
                return ~~(this.millisecond() / 10);
            });
            addFormatToken(0, [
                "SSS",
                3
            ], 0, "millisecond");
            addFormatToken(0, [
                "SSSS",
                4
            ], 0, function() {
                return this.millisecond() * 10;
            });
            addFormatToken(0, [
                "SSSSS",
                5
            ], 0, function() {
                return this.millisecond() * 100;
            });
            addFormatToken(0, [
                "SSSSSS",
                6
            ], 0, function() {
                return this.millisecond() * 1000;
            });
            addFormatToken(0, [
                "SSSSSSS",
                7
            ], 0, function() {
                return this.millisecond() * 10000;
            });
            addFormatToken(0, [
                "SSSSSSSS",
                8
            ], 0, function() {
                return this.millisecond() * 100000;
            });
            addFormatToken(0, [
                "SSSSSSSSS",
                9
            ], 0, function() {
                return this.millisecond() * 1000000;
            });
            // ALIASES
            addUnitAlias("millisecond", "ms");
            // PRIORITY
            addUnitPriority("millisecond", 16);
            // PARSING
            addRegexToken("S", match1to3, match1);
            addRegexToken("SS", match1to3, match2);
            addRegexToken("SSS", match1to3, match3);
            var token, getSetMillisecond;
            for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
            function parseMs(input, array) {
                array[MILLISECOND] = toInt(("0." + input) * 1000);
            }
            for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
            getSetMillisecond = makeGetSet("Milliseconds", false);
            // FORMATTING
            addFormatToken("z", 0, 0, "zoneAbbr");
            addFormatToken("zz", 0, 0, "zoneName");
            // MOMENTS
            function getZoneAbbr() {
                return this._isUTC ? "UTC" : "";
            }
            function getZoneName() {
                return this._isUTC ? "Coordinated Universal Time" : "";
            }
            var proto = Moment.prototype;
            proto.add = add;
            proto.calendar = calendar$1;
            proto.clone = clone;
            proto.diff = diff;
            proto.endOf = endOf;
            proto.format = format;
            proto.from = from;
            proto.fromNow = fromNow;
            proto.to = to;
            proto.toNow = toNow;
            proto.get = stringGet;
            proto.invalidAt = invalidAt;
            proto.isAfter = isAfter;
            proto.isBefore = isBefore;
            proto.isBetween = isBetween;
            proto.isSame = isSame;
            proto.isSameOrAfter = isSameOrAfter;
            proto.isSameOrBefore = isSameOrBefore;
            proto.isValid = isValid$2;
            proto.lang = lang;
            proto.locale = locale;
            proto.localeData = localeData;
            proto.max = prototypeMax;
            proto.min = prototypeMin;
            proto.parsingFlags = parsingFlags;
            proto.set = stringSet;
            proto.startOf = startOf;
            proto.subtract = subtract;
            proto.toArray = toArray;
            proto.toObject = toObject;
            proto.toDate = toDate;
            proto.toISOString = toISOString;
            proto.inspect = inspect;
            if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
                return "Moment<" + this.format() + ">";
            };
            proto.toJSON = toJSON;
            proto.toString = toString;
            proto.unix = unix;
            proto.valueOf = valueOf;
            proto.creationData = creationData;
            proto.eraName = getEraName;
            proto.eraNarrow = getEraNarrow;
            proto.eraAbbr = getEraAbbr;
            proto.eraYear = getEraYear;
            proto.year = getSetYear;
            proto.isLeapYear = getIsLeapYear;
            proto.weekYear = getSetWeekYear;
            proto.isoWeekYear = getSetISOWeekYear;
            proto.quarter = proto.quarters = getSetQuarter;
            proto.month = getSetMonth;
            proto.daysInMonth = getDaysInMonth;
            proto.week = proto.weeks = getSetWeek;
            proto.isoWeek = proto.isoWeeks = getSetISOWeek;
            proto.weeksInYear = getWeeksInYear;
            proto.weeksInWeekYear = getWeeksInWeekYear;
            proto.isoWeeksInYear = getISOWeeksInYear;
            proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
            proto.date = getSetDayOfMonth;
            proto.day = proto.days = getSetDayOfWeek;
            proto.weekday = getSetLocaleDayOfWeek;
            proto.isoWeekday = getSetISODayOfWeek;
            proto.dayOfYear = getSetDayOfYear;
            proto.hour = proto.hours = getSetHour;
            proto.minute = proto.minutes = getSetMinute;
            proto.second = proto.seconds = getSetSecond;
            proto.millisecond = proto.milliseconds = getSetMillisecond;
            proto.utcOffset = getSetOffset;
            proto.utc = setOffsetToUTC;
            proto.local = setOffsetToLocal;
            proto.parseZone = setOffsetToParsedOffset;
            proto.hasAlignedHourOffset = hasAlignedHourOffset;
            proto.isDST = isDaylightSavingTime;
            proto.isLocal = isLocal;
            proto.isUtcOffset = isUtcOffset;
            proto.isUtc = isUtc;
            proto.isUTC = isUtc;
            proto.zoneAbbr = getZoneAbbr;
            proto.zoneName = getZoneName;
            proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
            proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
            proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
            proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
            proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
            function createUnix(input) {
                return createLocal(input * 1000);
            }
            function createInZone() {
                return createLocal.apply(null, arguments).parseZone();
            }
            function preParsePostFormat(string) {
                return string;
            }
            var proto$1 = Locale.prototype;
            proto$1.calendar = calendar;
            proto$1.longDateFormat = longDateFormat;
            proto$1.invalidDate = invalidDate;
            proto$1.ordinal = ordinal;
            proto$1.preparse = preParsePostFormat;
            proto$1.postformat = preParsePostFormat;
            proto$1.relativeTime = relativeTime;
            proto$1.pastFuture = pastFuture;
            proto$1.set = set;
            proto$1.eras = localeEras;
            proto$1.erasParse = localeErasParse;
            proto$1.erasConvertYear = localeErasConvertYear;
            proto$1.erasAbbrRegex = erasAbbrRegex;
            proto$1.erasNameRegex = erasNameRegex;
            proto$1.erasNarrowRegex = erasNarrowRegex;
            proto$1.months = localeMonths;
            proto$1.monthsShort = localeMonthsShort;
            proto$1.monthsParse = localeMonthsParse;
            proto$1.monthsRegex = monthsRegex;
            proto$1.monthsShortRegex = monthsShortRegex;
            proto$1.week = localeWeek;
            proto$1.firstDayOfYear = localeFirstDayOfYear;
            proto$1.firstDayOfWeek = localeFirstDayOfWeek;
            proto$1.weekdays = localeWeekdays;
            proto$1.weekdaysMin = localeWeekdaysMin;
            proto$1.weekdaysShort = localeWeekdaysShort;
            proto$1.weekdaysParse = localeWeekdaysParse;
            proto$1.weekdaysRegex = weekdaysRegex;
            proto$1.weekdaysShortRegex = weekdaysShortRegex;
            proto$1.weekdaysMinRegex = weekdaysMinRegex;
            proto$1.isPM = localeIsPM;
            proto$1.meridiem = localeMeridiem;
            function get$1(format, index, field, setter) {
                var locale = getLocale(), utc = createUTC().set(setter, index);
                return locale[field](utc, format);
            }
            function listMonthsImpl(format, index, field) {
                if (isNumber(format)) {
                    index = format;
                    format = undefined;
                }
                format = format || "";
                if (index != null) return get$1(format, index, field, "month");
                var i1, out = [];
                for(i1 = 0; i1 < 12; i1++)out[i1] = get$1(format, i1, field, "month");
                return out;
            }
            // ()
            // (5)
            // (fmt, 5)
            // (fmt)
            // (true)
            // (true, 5)
            // (true, fmt, 5)
            // (true, fmt)
            function listWeekdaysImpl(localeSorted, format, index, field) {
                if (typeof localeSorted === "boolean") {
                    if (isNumber(format)) {
                        index = format;
                        format = undefined;
                    }
                    format = format || "";
                } else {
                    format = localeSorted;
                    index = format;
                    localeSorted = false;
                    if (isNumber(format)) {
                        index = format;
                        format = undefined;
                    }
                    format = format || "";
                }
                var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i1, out = [];
                if (index != null) return get$1(format, (index + shift) % 7, field, "day");
                for(i1 = 0; i1 < 7; i1++)out[i1] = get$1(format, (i1 + shift) % 7, field, "day");
                return out;
            }
            function listMonths(format, index) {
                return listMonthsImpl(format, index, "months");
            }
            function listMonthsShort(format, index) {
                return listMonthsImpl(format, index, "monthsShort");
            }
            function listWeekdays(localeSorted, format, index) {
                return listWeekdaysImpl(localeSorted, format, index, "weekdays");
            }
            function listWeekdaysShort(localeSorted, format, index) {
                return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
            }
            function listWeekdaysMin(localeSorted, format, index) {
                return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
            }
            getSetGlobalLocale("en", {
                eras: [
                    {
                        since: "0001-01-01",
                        until: Infinity,
                        offset: 1,
                        name: "Anno Domini",
                        narrow: "AD",
                        abbr: "AD"
                    },
                    {
                        since: "0000-12-31",
                        until: -Infinity,
                        offset: 1,
                        name: "Before Christ",
                        narrow: "BC",
                        abbr: "BC"
                    }
                ],
                dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                ordinal: function(number) {
                    var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
                    return number + output;
                }
            });
            // Side effect imports
            hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
            hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
            var mathAbs = Math.abs;
            function abs() {
                var data = this._data;
                this._milliseconds = mathAbs(this._milliseconds);
                this._days = mathAbs(this._days);
                this._months = mathAbs(this._months);
                data.milliseconds = mathAbs(data.milliseconds);
                data.seconds = mathAbs(data.seconds);
                data.minutes = mathAbs(data.minutes);
                data.hours = mathAbs(data.hours);
                data.months = mathAbs(data.months);
                data.years = mathAbs(data.years);
                return this;
            }
            function addSubtract$1(duration, input, value, direction) {
                var other = createDuration(input, value);
                duration._milliseconds += direction * other._milliseconds;
                duration._days += direction * other._days;
                duration._months += direction * other._months;
                return duration._bubble();
            }
            // supports only 2.0-style add(1, 's') or add(duration)
            function add$1(input, value) {
                return addSubtract$1(this, input, value, 1);
            }
            // supports only 2.0-style subtract(1, 's') or subtract(duration)
            function subtract$1(input, value) {
                return addSubtract$1(this, input, value, -1);
            }
            function absCeil(number) {
                if (number < 0) return Math.floor(number);
                else return Math.ceil(number);
            }
            function bubble() {
                var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
                // if we have a mix of positive and negative values, bubble down first
                // check: https://github.com/moment/moment/issues/2166
                if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
                    milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
                    days = 0;
                    months = 0;
                }
                // The following code bubbles up values, see the tests for
                // examples of what that means.
                data.milliseconds = milliseconds % 1000;
                seconds = absFloor(milliseconds / 1000);
                data.seconds = seconds % 60;
                minutes = absFloor(seconds / 60);
                data.minutes = minutes % 60;
                hours = absFloor(minutes / 60);
                data.hours = hours % 24;
                days += absFloor(hours / 24);
                // convert days to months
                monthsFromDays = absFloor(daysToMonths(days));
                months += monthsFromDays;
                days -= absCeil(monthsToDays(monthsFromDays));
                // 12 months -> 1 year
                years = absFloor(months / 12);
                months %= 12;
                data.days = days;
                data.months = months;
                data.years = years;
                return this;
            }
            function daysToMonths(days) {
                // 400 years have 146097 days (taking into account leap year rules)
                // 400 years have 12 months === 4800
                return days * 4800 / 146097;
            }
            function monthsToDays(months) {
                // the reverse of daysToMonths
                return months * 146097 / 4800;
            }
            function as(units) {
                if (!this.isValid()) return NaN;
                var days, months, milliseconds = this._milliseconds;
                units = normalizeUnits(units);
                if (units === "month" || units === "quarter" || units === "year") {
                    days = this._days + milliseconds / 864e5;
                    months = this._months + daysToMonths(days);
                    switch(units){
                        case "month":
                            return months;
                        case "quarter":
                            return months / 3;
                        case "year":
                            return months / 12;
                    }
                } else {
                    // handle milliseconds separately because of floating point math errors (issue #1867)
                    days = this._days + Math.round(monthsToDays(this._months));
                    switch(units){
                        case "week":
                            return days / 7 + milliseconds / 6048e5;
                        case "day":
                            return days + milliseconds / 864e5;
                        case "hour":
                            return days * 24 + milliseconds / 36e5;
                        case "minute":
                            return days * 1440 + milliseconds / 6e4;
                        case "second":
                            return days * 86400 + milliseconds / 1000;
                        // Math.floor prevents floating point math errors here
                        case "millisecond":
                            return Math.floor(days * 864e5) + milliseconds;
                        default:
                            throw new Error("Unknown unit " + units);
                    }
                }
            }
            // TODO: Use this.as('ms')?
            function valueOf$1() {
                if (!this.isValid()) return NaN;
                return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
            }
            function makeAs(alias) {
                return function() {
                    return this.as(alias);
                };
            }
            var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
            function clone$1() {
                return createDuration(this);
            }
            function get$2(units) {
                units = normalizeUnits(units);
                return this.isValid() ? this[units + "s"]() : NaN;
            }
            function makeGetter(name) {
                return function() {
                    return this.isValid() ? this._data[name] : NaN;
                };
            }
            var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
            function weeks() {
                return absFloor(this.days() / 7);
            }
            var round = Math.round, thresholds = {
                ss: 44,
                s: 45,
                m: 45,
                h: 22,
                d: 26,
                w: null,
                M: 11
            };
            // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
            function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
                return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
            }
            function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
                var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
                    "s",
                    seconds
                ] || seconds < thresholds.s && [
                    "ss",
                    seconds
                ] || minutes <= 1 && [
                    "m"
                ] || minutes < thresholds.m && [
                    "mm",
                    minutes
                ] || hours <= 1 && [
                    "h"
                ] || hours < thresholds.h && [
                    "hh",
                    hours
                ] || days <= 1 && [
                    "d"
                ] || days < thresholds.d && [
                    "dd",
                    days
                ];
                if (thresholds.w != null) a = a || weeks <= 1 && [
                    "w"
                ] || weeks < thresholds.w && [
                    "ww",
                    weeks
                ];
                a = a || months <= 1 && [
                    "M"
                ] || months < thresholds.M && [
                    "MM",
                    months
                ] || years <= 1 && [
                    "y"
                ] || [
                    "yy",
                    years
                ];
                a[2] = withoutSuffix;
                a[3] = +posNegDuration > 0;
                a[4] = locale;
                return substituteTimeAgo.apply(null, a);
            }
            // This function allows you to set the rounding function for relative time strings
            function getSetRelativeTimeRounding(roundingFunction) {
                if (roundingFunction === undefined) return round;
                if (typeof roundingFunction === "function") {
                    round = roundingFunction;
                    return true;
                }
                return false;
            }
            // This function allows you to set a threshold for relative time strings
            function getSetRelativeTimeThreshold(threshold, limit) {
                if (thresholds[threshold] === undefined) return false;
                if (limit === undefined) return thresholds[threshold];
                thresholds[threshold] = limit;
                if (threshold === "s") thresholds.ss = limit - 1;
                return true;
            }
            function humanize(argWithSuffix, argThresholds) {
                if (!this.isValid()) return this.localeData().invalidDate();
                var withSuffix = false, th = thresholds, locale, output;
                if (typeof argWithSuffix === "object") {
                    argThresholds = argWithSuffix;
                    argWithSuffix = false;
                }
                if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
                if (typeof argThresholds === "object") {
                    th = Object.assign({}, thresholds, argThresholds);
                    if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
                }
                locale = this.localeData();
                output = relativeTime$1(this, !withSuffix, th, locale);
                if (withSuffix) output = locale.pastFuture(+this, output);
                return locale.postformat(output);
            }
            var abs$1 = Math.abs;
            function sign(x) {
                return (x > 0) - (x < 0) || +x;
            }
            function toISOString$1() {
                // for ISO strings we do not use the normal bubbling rules:
                //  * milliseconds bubble up until they become hours
                //  * days do not bubble at all
                //  * months bubble up until they become years
                // This is because there is no context-free conversion between hours and days
                // (think of clock changes)
                // and also not between days and months (28-31 days per month)
                if (!this.isValid()) return this.localeData().invalidDate();
                var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
                if (!total) // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return "P0D";
                // 3600 seconds -> 60 minutes -> 1 hour
                minutes = absFloor(seconds / 60);
                hours = absFloor(minutes / 60);
                seconds %= 60;
                minutes %= 60;
                // 12 months -> 1 year
                years = absFloor(months / 12);
                months %= 12;
                // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
                s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
                totalSign = total < 0 ? "-" : "";
                ymSign = sign(this._months) !== sign(total) ? "-" : "";
                daysSign = sign(this._days) !== sign(total) ? "-" : "";
                hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
                return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
            }
            var proto$2 = Duration.prototype;
            proto$2.isValid = isValid$1;
            proto$2.abs = abs;
            proto$2.add = add$1;
            proto$2.subtract = subtract$1;
            proto$2.as = as;
            proto$2.asMilliseconds = asMilliseconds;
            proto$2.asSeconds = asSeconds;
            proto$2.asMinutes = asMinutes;
            proto$2.asHours = asHours;
            proto$2.asDays = asDays;
            proto$2.asWeeks = asWeeks;
            proto$2.asMonths = asMonths;
            proto$2.asQuarters = asQuarters;
            proto$2.asYears = asYears;
            proto$2.valueOf = valueOf$1;
            proto$2._bubble = bubble;
            proto$2.clone = clone$1;
            proto$2.get = get$2;
            proto$2.milliseconds = milliseconds;
            proto$2.seconds = seconds;
            proto$2.minutes = minutes;
            proto$2.hours = hours;
            proto$2.days = days;
            proto$2.weeks = weeks;
            proto$2.months = months;
            proto$2.years = years;
            proto$2.humanize = humanize;
            proto$2.toISOString = toISOString$1;
            proto$2.toString = toISOString$1;
            proto$2.toJSON = toISOString$1;
            proto$2.locale = locale;
            proto$2.localeData = localeData;
            proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
            proto$2.lang = lang;
            // FORMATTING
            addFormatToken("X", 0, 0, "unix");
            addFormatToken("x", 0, 0, "valueOf");
            // PARSING
            addRegexToken("x", matchSigned);
            addRegexToken("X", matchTimestamp);
            addParseToken("X", function(input, array, config) {
                config._d = new Date(parseFloat(input) * 1000);
            });
            addParseToken("x", function(input, array, config) {
                config._d = new Date(toInt(input));
            });
            //! moment.js
            hooks.version = "2.29.4";
            setHookCallback(createLocal);
            hooks.fn = proto;
            hooks.min = min;
            hooks.max = max;
            hooks.now = now;
            hooks.utc = createUTC;
            hooks.unix = createUnix;
            hooks.months = listMonths;
            hooks.isDate = isDate;
            hooks.locale = getSetGlobalLocale;
            hooks.invalid = createInvalid;
            hooks.duration = createDuration;
            hooks.isMoment = isMoment;
            hooks.weekdays = listWeekdays;
            hooks.parseZone = createInZone;
            hooks.localeData = getLocale;
            hooks.isDuration = isDuration;
            hooks.monthsShort = listMonthsShort;
            hooks.weekdaysMin = listWeekdaysMin;
            hooks.defineLocale = defineLocale;
            hooks.updateLocale = updateLocale;
            hooks.locales = listLocales;
            hooks.weekdaysShort = listWeekdaysShort;
            hooks.normalizeUnits = normalizeUnits;
            hooks.relativeTimeRounding = getSetRelativeTimeRounding;
            hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
            hooks.calendarFormat = getCalendarFormat;
            hooks.prototype = proto;
            // currently HTML5 input type only supports 24-hour formats
            hooks.HTML5_FMT = {
                DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                DATE: "YYYY-MM-DD",
                TIME: "HH:mm",
                TIME_SECONDS: "HH:mm:ss",
                TIME_MS: "HH:mm:ss.SSS",
                WEEK: "GGGG-[W]WW",
                MONTH: "YYYY-MM"
            };
            return hooks;
        });
    })(moment$5);
    return moment$5.exports;
}
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        function processRelativeTime(number, withoutSuffix, key, isFuture) {
            var format = {
                m: [
                    "eine Minute",
                    "einer Minute"
                ],
                h: [
                    "eine Stunde",
                    "einer Stunde"
                ],
                d: [
                    "ein Tag",
                    "einem Tag"
                ],
                dd: [
                    number + " Tage",
                    number + " Tagen"
                ],
                w: [
                    "eine Woche",
                    "einer Woche"
                ],
                M: [
                    "ein Monat",
                    "einem Monat"
                ],
                MM: [
                    number + " Monate",
                    number + " Monaten"
                ],
                y: [
                    "ein Jahr",
                    "einem Jahr"
                ],
                yy: [
                    number + " Jahre",
                    number + " Jahren"
                ]
            };
            return withoutSuffix ? format[key][0] : format[key][1];
        }
        var de = moment.defineLocale("de", {
            months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
            monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
            monthsParseExact: true,
            weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
            weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd, D. MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[heute um] LT [Uhr]",
                sameElse: "L",
                nextDay: "[morgen um] LT [Uhr]",
                nextWeek: "dddd [um] LT [Uhr]",
                lastDay: "[gestern um] LT [Uhr]",
                lastWeek: "[letzten] dddd [um] LT [Uhr]"
            },
            relativeTime: {
                future: "in %s",
                past: "vor %s",
                s: "ein paar Sekunden",
                ss: "%d Sekunden",
                m: processRelativeTime,
                mm: "%d Minuten",
                h: processRelativeTime,
                hh: "%d Stunden",
                d: processRelativeTime,
                dd: processRelativeTime,
                w: processRelativeTime,
                ww: "%d Wochen",
                M: processRelativeTime,
                MM: processRelativeTime,
                y: processRelativeTime,
                yy: processRelativeTime
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        });
        return de;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        var monthsShortDot = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"), monthsShort = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i
        ], monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
        var es = moment.defineLocale("es", {
            months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
            monthsShort: function(m, format) {
                if (!m) return monthsShortDot;
                else if (/-MMM-/.test(format)) return monthsShort[m.month()];
                else return monthsShortDot[m.month()];
            },
            monthsRegex: monthsRegex,
            monthsShortRegex: monthsRegex,
            monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: monthsParse,
            longMonthsParse: monthsParse,
            shortMonthsParse: monthsParse,
            weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
            weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY H:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
            },
            calendar: {
                sameDay: function() {
                    return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
                },
                nextDay: function() {
                    return "[ma\xf1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
                },
                nextWeek: function() {
                    return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
                },
                lastDay: function() {
                    return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
                },
                lastWeek: function() {
                    return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "en %s",
                past: "hace %s",
                s: "unos segundos",
                ss: "%d segundos",
                m: "un minuto",
                mm: "%d minutos",
                h: "una hora",
                hh: "%d horas",
                d: "un d\xeda",
                dd: "%d d\xedas",
                w: "una semana",
                ww: "%d semanas",
                M: "un mes",
                MM: "%d meses",
                y: "un a\xf1o",
                yy: "%d a\xf1os"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%d\xba",
            week: {
                dow: 1,
                doy: 4
            },
            invalidDate: "Fecha inv\xe1lida"
        });
        return es;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i, monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i
        ];
        var fr = moment.defineLocale("fr", {
            months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
            monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
            monthsRegex: monthsRegex,
            monthsShortRegex: monthsRegex,
            monthsStrictRegex: monthsStrictRegex,
            monthsShortStrictRegex: monthsShortStrictRegex,
            monthsParse: monthsParse,
            longMonthsParse: monthsParse,
            shortMonthsParse: monthsParse,
            weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Aujourd\u2019hui \xe0] LT",
                nextDay: "[Demain \xe0] LT",
                nextWeek: "dddd [\xe0] LT",
                lastDay: "[Hier \xe0] LT",
                lastWeek: "dddd [dernier \xe0] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "dans %s",
                past: "il y a %s",
                s: "quelques secondes",
                ss: "%d secondes",
                m: "une minute",
                mm: "%d minutes",
                h: "une heure",
                hh: "%d heures",
                d: "un jour",
                dd: "%d jours",
                w: "une semaine",
                ww: "%d semaines",
                M: "un mois",
                MM: "%d mois",
                y: "un an",
                yy: "%d ans"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
            ordinal: function(number, period) {
                switch(period){
                    // TODO: Return 'e' when day of month > 1. Move this case inside
                    // block for masculine words below.
                    // See https://github.com/moment/moment/issues/3375
                    case "D":
                        return number + (number === 1 ? "er" : "");
                    // Words with masculine grammatical gender: mois, trimestre, jour
                    default:
                    case "M":
                    case "Q":
                    case "DDD":
                    case "d":
                        return number + (number === 1 ? "er" : "e");
                    // Words with feminine grammatical gender: semaine
                    case "w":
                    case "W":
                        return number + (number === 1 ? "re" : "e");
                }
            },
            week: {
                dow: 1,
                doy: 4
            }
        });
        return fr;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        var it = moment.defineLocale("it", {
            months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
            monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
            weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
            weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
            weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: function() {
                    return "[Oggi a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                },
                nextDay: function() {
                    return "[Domani a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                },
                nextWeek: function() {
                    return "dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                },
                lastDay: function() {
                    return "[Ieri a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                },
                lastWeek: function() {
                    switch(this.day()){
                        case 0:
                            return "[La scorsa] dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                        default:
                            return "[Lo scorso] dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "tra %s",
                past: "%s fa",
                s: "alcuni secondi",
                ss: "%d secondi",
                m: "un minuto",
                mm: "%d minuti",
                h: "un'ora",
                hh: "%d ore",
                d: "un giorno",
                dd: "%d giorni",
                w: "una settimana",
                ww: "%d settimane",
                M: "un mese",
                MM: "%d mesi",
                y: "un anno",
                yy: "%d anni"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%d\xba",
            week: {
                dow: 1,
                doy: 4
            }
        });
        return it;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        var ja = moment.defineLocale("ja", {
            eras: [
                {
                    since: "2019-05-01",
                    offset: 1,
                    name: "\u4EE4\u548C",
                    narrow: "\u32FF",
                    abbr: "R"
                },
                {
                    since: "1989-01-08",
                    until: "2019-04-30",
                    offset: 1,
                    name: "\u5E73\u6210",
                    narrow: "\u337B",
                    abbr: "H"
                },
                {
                    since: "1926-12-25",
                    until: "1989-01-07",
                    offset: 1,
                    name: "\u662D\u548C",
                    narrow: "\u337C",
                    abbr: "S"
                },
                {
                    since: "1912-07-30",
                    until: "1926-12-24",
                    offset: 1,
                    name: "\u5927\u6B63",
                    narrow: "\u337D",
                    abbr: "T"
                },
                {
                    since: "1873-01-01",
                    until: "1912-07-29",
                    offset: 6,
                    name: "\u660E\u6CBB",
                    narrow: "\u337E",
                    abbr: "M"
                },
                {
                    since: "0001-01-01",
                    until: "1873-12-31",
                    offset: 1,
                    name: "\u897F\u66A6",
                    narrow: "AD",
                    abbr: "AD"
                },
                {
                    since: "0000-12-31",
                    until: -Infinity,
                    offset: 1,
                    name: "\u7D00\u5143\u524D",
                    narrow: "BC",
                    abbr: "BC"
                }
            ],
            eraYearOrdinalRegex: /(元|\d+)年/,
            eraYearOrdinalParse: function(input, match) {
                return match[1] === "\u5143" ? 1 : parseInt(match[1] || input, 10);
            },
            months: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
            monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
            weekdays: "\u65E5\u66DC\u65E5_\u6708\u66DC\u65E5_\u706B\u66DC\u65E5_\u6C34\u66DC\u65E5_\u6728\u66DC\u65E5_\u91D1\u66DC\u65E5_\u571F\u66DC\u65E5".split("_"),
            weekdaysShort: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split("_"),
            weekdaysMin: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY\u5E74M\u6708D\u65E5",
                LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
                LLLL: "YYYY\u5E74M\u6708D\u65E5 dddd HH:mm",
                l: "YYYY/MM/DD",
                ll: "YYYY\u5E74M\u6708D\u65E5",
                lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
                llll: "YYYY\u5E74M\u6708D\u65E5(ddd) HH:mm"
            },
            meridiemParse: /午前|午後/i,
            isPM: function(input) {
                return input === "\u5348\u5F8C";
            },
            meridiem: function(hour, minute, isLower) {
                if (hour < 12) return "\u5348\u524D";
                else return "\u5348\u5F8C";
            },
            calendar: {
                sameDay: "[\u4ECA\u65E5] LT",
                nextDay: "[\u660E\u65E5] LT",
                nextWeek: function(now) {
                    if (now.week() !== this.week()) return "[\u6765\u9031]dddd LT";
                    else return "dddd LT";
                },
                lastDay: "[\u6628\u65E5] LT",
                lastWeek: function(now) {
                    if (this.week() !== now.week()) return "[\u5148\u9031]dddd LT";
                    else return "dddd LT";
                },
                sameElse: "L"
            },
            dayOfMonthOrdinalParse: /\d{1,2}日/,
            ordinal: function(number, period) {
                switch(period){
                    case "y":
                        return number === 1 ? "\u5143\u5E74" : number + "\u5E74";
                    case "d":
                    case "D":
                    case "DDD":
                        return number + "\u65E5";
                    default:
                        return number;
                }
            },
            relativeTime: {
                future: "%s\u5F8C",
                past: "%s\u524D",
                s: "\u6570\u79D2",
                ss: "%d\u79D2",
                m: "1\u5206",
                mm: "%d\u5206",
                h: "1\u6642\u9593",
                hh: "%d\u6642\u9593",
                d: "1\u65E5",
                dd: "%d\u65E5",
                M: "1\u30F6\u6708",
                MM: "%d\u30F6\u6708",
                y: "1\u5E74",
                yy: "%d\u5E74"
            }
        });
        return ja;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        var monthsShortWithDots = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"), monthsShortWithoutDots = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i
        ], monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
        var nl = moment.defineLocale("nl", {
            months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
            monthsShort: function(m, format) {
                if (!m) return monthsShortWithDots;
                else if (/-MMM-/.test(format)) return monthsShortWithoutDots[m.month()];
                else return monthsShortWithDots[m.month()];
            },
            monthsRegex: monthsRegex,
            monthsShortRegex: monthsRegex,
            monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
            monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
            monthsParse: monthsParse,
            longMonthsParse: monthsParse,
            shortMonthsParse: monthsParse,
            weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
            weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
            weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD-MM-YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[vandaag om] LT",
                nextDay: "[morgen om] LT",
                nextWeek: "dddd [om] LT",
                lastDay: "[gisteren om] LT",
                lastWeek: "[afgelopen] dddd [om] LT",
                sameElse: "L"
            },
            relativeTime: {
                future: "over %s",
                past: "%s geleden",
                s: "een paar seconden",
                ss: "%d seconden",
                m: "\xe9\xe9n minuut",
                mm: "%d minuten",
                h: "\xe9\xe9n uur",
                hh: "%d uur",
                d: "\xe9\xe9n dag",
                dd: "%d dagen",
                w: "\xe9\xe9n week",
                ww: "%d weken",
                M: "\xe9\xe9n maand",
                MM: "%d maanden",
                y: "\xe9\xe9n jaar",
                yy: "%d jaar"
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function(number) {
                return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
            },
            week: {
                dow: 1,
                doy: 4
            }
        });
        return nl;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        var monthsNominative = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split("_"), monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split("_"), monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i
        ];
        function plural(n) {
            return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
        }
        function translate(number, withoutSuffix, key) {
            var result = number + " ";
            switch(key){
                case "ss":
                    return result + (plural(number) ? "sekundy" : "sekund");
                case "m":
                    return withoutSuffix ? "minuta" : "minut\u0119";
                case "mm":
                    return result + (plural(number) ? "minuty" : "minut");
                case "h":
                    return withoutSuffix ? "godzina" : "godzin\u0119";
                case "hh":
                    return result + (plural(number) ? "godziny" : "godzin");
                case "ww":
                    return result + (plural(number) ? "tygodnie" : "tygodni");
                case "MM":
                    return result + (plural(number) ? "miesi\u0105ce" : "miesi\u0119cy");
                case "yy":
                    return result + (plural(number) ? "lata" : "lat");
            }
        }
        var pl = moment.defineLocale("pl", {
            months: function(momentToFormat, format) {
                if (!momentToFormat) return monthsNominative;
                else if (/D MMMM/.test(format)) return monthsSubjective[momentToFormat.month()];
                else return monthsNominative[momentToFormat.month()];
            },
            monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split("_"),
            monthsParse: monthsParse,
            longMonthsParse: monthsParse,
            shortMonthsParse: monthsParse,
            weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split("_"),
            weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split("_"),
            weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm"
            },
            calendar: {
                sameDay: "[Dzi\u015B o] LT",
                nextDay: "[Jutro o] LT",
                nextWeek: function() {
                    switch(this.day()){
                        case 0:
                            return "[W niedziel\u0119 o] LT";
                        case 2:
                            return "[We wtorek o] LT";
                        case 3:
                            return "[W \u015Brod\u0119 o] LT";
                        case 6:
                            return "[W sobot\u0119 o] LT";
                        default:
                            return "[W] dddd [o] LT";
                    }
                },
                lastDay: "[Wczoraj o] LT",
                lastWeek: function() {
                    switch(this.day()){
                        case 0:
                            return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                        case 3:
                            return "[W zesz\u0142\u0105 \u015Brod\u0119 o] LT";
                        case 6:
                            return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                        default:
                            return "[W zesz\u0142y] dddd [o] LT";
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "za %s",
                past: "%s temu",
                s: "kilka sekund",
                ss: translate,
                m: translate,
                mm: translate,
                h: translate,
                hh: translate,
                d: "1 dzie\u0144",
                dd: "%d dni",
                w: "tydzie\u0144",
                ww: translate,
                M: "miesi\u0105c",
                MM: translate,
                y: "rok",
                yy: translate
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: {
                dow: 1,
                doy: 4
            }
        });
        return pl;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        function plural(word, num) {
            var forms = word.split("_");
            return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
        }
        function relativeTimeWithPlural(number, withoutSuffix, key) {
            var format = {
                ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
                mm: withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442",
                hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432",
                dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439",
                ww: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043D\u0435\u0434\u0435\u043B\u0438_\u043D\u0435\u0434\u0435\u043B\u044C",
                MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
                yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442"
            };
            if (key === "m") return withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443";
            else return number + " " + plural(format[key], +number);
        }
        var monthsParse = [
            /^янв/i,
            /^фев/i,
            /^мар/i,
            /^апр/i,
            /^ма[йя]/i,
            /^июн/i,
            /^июл/i,
            /^авг/i,
            /^сен/i,
            /^окт/i,
            /^ноя/i,
            /^дек/i
        ];
        // http://new.gramota.ru/spravka/rules/139-prop : § 103
        // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
        // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
        var ru = moment.defineLocale("ru", {
            months: {
                format: "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split("_"),
                standalone: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split("_")
            },
            monthsShort: {
                // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
                format: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"),
                standalone: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_")
            },
            weekdays: {
                standalone: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split("_"),
                format: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043E\u0442\u0443".split("_"),
                isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
            },
            weekdaysShort: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
            weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
            monthsParse: monthsParse,
            longMonthsParse: monthsParse,
            shortMonthsParse: monthsParse,
            // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
            monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
            // копия предыдущего
            monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
            // полные названия с падежами
            monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
            // Выражение, которое соответствует только сокращённым формам
            monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY \u0433.",
                LLL: "D MMMM YYYY \u0433., H:mm",
                LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
            },
            calendar: {
                sameDay: "[\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432] LT",
                nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
                lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
                nextWeek: function(now) {
                    if (now.week() !== this.week()) switch(this.day()){
                        case 0:
                            return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435] dddd, [\u0432] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439] dddd, [\u0432] LT";
                        case 3:
                        case 5:
                        case 6:
                            return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E] dddd, [\u0432] LT";
                    }
                    else {
                        if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                        else return "[\u0412] dddd, [\u0432] LT";
                    }
                },
                lastWeek: function(now) {
                    if (now.week() !== this.week()) switch(this.day()){
                        case 0:
                            return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u0435] dddd, [\u0432] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439] dddd, [\u0432] LT";
                        case 3:
                        case 5:
                        case 6:
                            return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u0443\u044E] dddd, [\u0432] LT";
                    }
                    else {
                        if (this.day() === 2) return "[\u0412\u043E] dddd, [\u0432] LT";
                        else return "[\u0412] dddd, [\u0432] LT";
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "\u0447\u0435\u0440\u0435\u0437 %s",
                past: "%s \u043D\u0430\u0437\u0430\u0434",
                s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434",
                ss: relativeTimeWithPlural,
                m: relativeTimeWithPlural,
                mm: relativeTimeWithPlural,
                h: "\u0447\u0430\u0441",
                hh: relativeTimeWithPlural,
                d: "\u0434\u0435\u043D\u044C",
                dd: relativeTimeWithPlural,
                w: "\u043D\u0435\u0434\u0435\u043B\u044F",
                ww: relativeTimeWithPlural,
                M: "\u043C\u0435\u0441\u044F\u0446",
                MM: relativeTimeWithPlural,
                y: "\u0433\u043E\u0434",
                yy: relativeTimeWithPlural
            },
            meridiemParse: /ночи|утра|дня|вечера/i,
            isPM: function(input) {
                return /^(дня|вечера)$/.test(input);
            },
            meridiem: function(hour, minute, isLower) {
                if (hour < 4) return "\u043D\u043E\u0447\u0438";
                else if (hour < 12) return "\u0443\u0442\u0440\u0430";
                else if (hour < 17) return "\u0434\u043D\u044F";
                else return "\u0432\u0435\u0447\u0435\u0440\u0430";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
            ordinal: function(number, period) {
                switch(period){
                    case "M":
                    case "d":
                    case "DDD":
                        return number + "-\u0439";
                    case "D":
                        return number + "-\u0433\u043E";
                    case "w":
                    case "W":
                        return number + "-\u044F";
                    default:
                        return number;
                }
            },
            week: {
                dow: 1,
                doy: 4
            }
        });
        return ru;
    });
})();
(function(module, exports) {
    (function(global1, factory) {
        typeof commonjsRequire === "function" ? factory(requireMoment()) : factory(global1.moment);
    })(commonjsGlobal, function(moment) {
        //! moment.js locale configuration
        function plural(word, num) {
            var forms = word.split("_");
            return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
        }
        function relativeTimeWithPlural(number, withoutSuffix, key) {
            var format = {
                ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434",
                mm: withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D",
                hh: withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D" : "\u0433\u043E\u0434\u0438\u043D\u0443_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D",
                dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u0456_\u0434\u043D\u0456\u0432",
                MM: "\u043C\u0456\u0441\u044F\u0446\u044C_\u043C\u0456\u0441\u044F\u0446\u0456_\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
                yy: "\u0440\u0456\u043A_\u0440\u043E\u043A\u0438_\u0440\u043E\u043A\u0456\u0432"
            };
            if (key === "m") return withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443";
            else if (key === "h") return withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430" : "\u0433\u043E\u0434\u0438\u043D\u0443";
            else return number + " " + plural(format[key], +number);
        }
        function weekdaysCaseReplace(m, format) {
            var weekdays = {
                nominative: "\u043D\u0435\u0434\u0456\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F_\u0441\u0443\u0431\u043E\u0442\u0430".split("_"),
                accusative: "\u043D\u0435\u0434\u0456\u043B\u044E_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E_\u0441\u0443\u0431\u043E\u0442\u0443".split("_"),
                genitive: "\u043D\u0435\u0434\u0456\u043B\u0456_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043A\u0430_\u0432\u0456\u0432\u0442\u043E\u0440\u043A\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u0456_\u0441\u0443\u0431\u043E\u0442\u0438".split("_")
            }, nounCase;
            if (m === true) return weekdays["nominative"].slice(1, 7).concat(weekdays["nominative"].slice(0, 1));
            if (!m) return weekdays["nominative"];
            nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? "genitive" : "nominative";
            return weekdays[nounCase][m.day()];
        }
        function processHoursFunction(str) {
            return function() {
                return str + "\u043E" + (this.hours() === 11 ? "\u0431" : "") + "] LT";
            };
        }
        var uk = moment.defineLocale("uk", {
            months: {
                format: "\u0441\u0456\u0447\u043D\u044F_\u043B\u044E\u0442\u043E\u0433\u043E_\u0431\u0435\u0440\u0435\u0437\u043D\u044F_\u043A\u0432\u0456\u0442\u043D\u044F_\u0442\u0440\u0430\u0432\u043D\u044F_\u0447\u0435\u0440\u0432\u043D\u044F_\u043B\u0438\u043F\u043D\u044F_\u0441\u0435\u0440\u043F\u043D\u044F_\u0432\u0435\u0440\u0435\u0441\u043D\u044F_\u0436\u043E\u0432\u0442\u043D\u044F_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043D\u044F".split("_"),
                standalone: "\u0441\u0456\u0447\u0435\u043D\u044C_\u043B\u044E\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C_\u043A\u0432\u0456\u0442\u0435\u043D\u044C_\u0442\u0440\u0430\u0432\u0435\u043D\u044C_\u0447\u0435\u0440\u0432\u0435\u043D\u044C_\u043B\u0438\u043F\u0435\u043D\u044C_\u0441\u0435\u0440\u043F\u0435\u043D\u044C_\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C_\u0436\u043E\u0432\u0442\u0435\u043D\u044C_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043D\u044C".split("_")
            },
            monthsShort: "\u0441\u0456\u0447_\u043B\u044E\u0442_\u0431\u0435\u0440_\u043A\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043B\u0438\u043F_\u0441\u0435\u0440\u043F_\u0432\u0435\u0440_\u0436\u043E\u0432\u0442_\u043B\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split("_"),
            weekdays: weekdaysCaseReplace,
            weekdaysShort: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
            weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY \u0440.",
                LLL: "D MMMM YYYY \u0440., HH:mm",
                LLLL: "dddd, D MMMM YYYY \u0440., HH:mm"
            },
            calendar: {
                sameDay: processHoursFunction("[\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456 "),
                nextDay: processHoursFunction("[\u0417\u0430\u0432\u0442\u0440\u0430 "),
                lastDay: processHoursFunction("[\u0412\u0447\u043E\u0440\u0430 "),
                nextWeek: processHoursFunction("[\u0423] dddd ["),
                lastWeek: function() {
                    switch(this.day()){
                        case 0:
                        case 3:
                        case 5:
                        case 6:
                            return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0457] dddd [").call(this);
                        case 1:
                        case 2:
                        case 4:
                            return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0433\u043E] dddd [").call(this);
                    }
                },
                sameElse: "L"
            },
            relativeTime: {
                future: "\u0437\u0430 %s",
                past: "%s \u0442\u043E\u043C\u0443",
                s: "\u0434\u0435\u043A\u0456\u043B\u044C\u043A\u0430 \u0441\u0435\u043A\u0443\u043D\u0434",
                ss: relativeTimeWithPlural,
                m: relativeTimeWithPlural,
                mm: relativeTimeWithPlural,
                h: "\u0433\u043E\u0434\u0438\u043D\u0443",
                hh: relativeTimeWithPlural,
                d: "\u0434\u0435\u043D\u044C",
                dd: relativeTimeWithPlural,
                M: "\u043C\u0456\u0441\u044F\u0446\u044C",
                MM: relativeTimeWithPlural,
                y: "\u0440\u0456\u043A",
                yy: relativeTimeWithPlural
            },
            // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
            meridiemParse: /ночі|ранку|дня|вечора/,
            isPM: function(input) {
                return /^(дня|вечора)$/.test(input);
            },
            meridiem: function(hour, minute, isLower) {
                if (hour < 4) return "\u043D\u043E\u0447\u0456";
                else if (hour < 12) return "\u0440\u0430\u043D\u043A\u0443";
                else if (hour < 17) return "\u0434\u043D\u044F";
                else return "\u0432\u0435\u0447\u043E\u0440\u0430";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
            ordinal: function(number, period) {
                switch(period){
                    case "M":
                    case "d":
                    case "DDD":
                    case "w":
                    case "W":
                        return number + "-\u0439";
                    case "D":
                        return number + "-\u0433\u043E";
                    default:
                        return number;
                }
            },
            week: {
                dow: 1,
                doy: 7
            }
        });
        return uk;
    });
})();
var fails$y = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var fails$x = fails$y;
var functionBindNative = !fails$x(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var NATIVE_BIND$4 = functionBindNative;
var FunctionPrototype$4 = Function.prototype;
var call$k = FunctionPrototype$4.call;
var uncurryThisWithBind = NATIVE_BIND$4 && FunctionPrototype$4.bind.bind(call$k, call$k);
var functionUncurryThis = NATIVE_BIND$4 ? uncurryThisWithBind : function(fn) {
    return function() {
        return call$k.apply(fn, arguments);
    };
};
var ceil = Math.ceil;
var floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor$1 : ceil)(n);
};
var trunc = mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$5 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};
var check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$q = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || commonjsGlobal || Function("return this")();
var shared$7 = {
    exports: {}
};
var isPure = true;
var global$p = global$q;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$f = Object.defineProperty;
var defineGlobalProperty$1 = function(key, value) {
    try {
        defineProperty$f(global$p, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        global$p[key] = value;
    }
    return value;
};
var global$o = global$q;
var defineGlobalProperty = defineGlobalProperty$1;
var SHARED = "__core-js_shared__";
var store$3 = global$o[SHARED] || defineGlobalProperty(SHARED, {});
var sharedStore = store$3;
var store$2 = sharedStore;
(shared$7.exports = function(key, value) {
    return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.33.0",
    mode: "pure",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var sharedExports = shared$7.exports;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$6 = function(it) {
    return it === null || it === undefined;
};
var isNullOrUndefined$5 = isNullOrUndefined$6;
var $TypeError$h = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function(it) {
    if (isNullOrUndefined$5(it)) throw new $TypeError$h("Can't call method on " + it);
    return it;
};
var requireObjectCoercible$5 = requireObjectCoercible$6;
var $Object$4 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$f = function(argument) {
    return $Object$4(requireObjectCoercible$5(argument));
};
var uncurryThis$x = functionUncurryThis;
var toObject$e = toObject$f;
var hasOwnProperty = uncurryThis$x({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject$e(it), key);
};
var uncurryThis$w = functionUncurryThis;
var id$1 = 0;
var postfix = Math.random();
var toString$e = uncurryThis$w(1.0.toString);
var uid$4 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString$e(++id$1 + postfix, 36);
};
var engineUserAgent = typeof navigator != "undefined" && String(navigator.userAgent) || "";
var global$n = global$q;
var userAgent$5 = engineUserAgent;
var process$3 = global$n.process;
var Deno$1 = global$n.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
    match = userAgent$5.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent$5.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
var engineV8Version = version;
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION$3 = engineV8Version;
var fails$w = fails$y;
var global$m = global$q;
var $String$5 = global$m.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$w(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL$5 = symbolConstructorDetection;
var useSymbolAsUid = NATIVE_SYMBOL$5 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var global$l = global$q;
var shared$6 = sharedExports;
var hasOwn$j = hasOwnProperty_1;
var uid$3 = uid$4;
var NATIVE_SYMBOL$4 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var Symbol$5 = global$l.Symbol;
var WellKnownSymbolsStore$2 = shared$6("wks");
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$5["for"] || Symbol$5 : Symbol$5 && Symbol$5.withoutSetter || uid$3;
var wellKnownSymbol$p = function(name) {
    if (!hasOwn$j(WellKnownSymbolsStore$2, name)) WellKnownSymbolsStore$2[name] = NATIVE_SYMBOL$4 && hasOwn$j(Symbol$5, name) ? Symbol$5[name] : createWellKnownSymbol("Symbol." + name);
    return WellKnownSymbolsStore$2[name];
};
var wellKnownSymbol$o = wellKnownSymbol$p;
var TO_STRING_TAG$4 = wellKnownSymbol$o("toStringTag");
var test$2 = {};
test$2[TO_STRING_TAG$4] = "z";
var toStringTagSupport = String(test$2) === "[object z]";
var documentAll$2 = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == "undefined" && documentAll$2 !== undefined;
var documentAll_1 = {
    all: documentAll$2,
    IS_HTMLDDA: IS_HTMLDDA
};
var $documentAll$1 = documentAll_1;
var documentAll$1 = $documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$m = $documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === documentAll$1;
} : function(argument) {
    return typeof argument == "function";
};
var uncurryThis$v = functionUncurryThis;
var toString$d = uncurryThis$v({}.toString);
var stringSlice$1 = uncurryThis$v("".slice);
var classofRaw$2 = function(it) {
    return stringSlice$1(toString$d(it), 8, -1);
};
var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$l = isCallable$m;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$n = wellKnownSymbol$p;
var TO_STRING_TAG$3 = wellKnownSymbol$n("toStringTag");
var $Object$3 = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var classof$g = TO_STRING_TAG_SUPPORT$2 ? classofRaw$1 : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object$3(it), TO_STRING_TAG$3)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw$1(O) : (result = classofRaw$1(O)) === "Object" && isCallable$l(O.callee) ? "Arguments" : result;
};
var classof$f = classof$g;
var $String$4 = String;
var toString$c = function(argument) {
    if (classof$f(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $String$4(argument);
};
var uncurryThis$u = functionUncurryThis;
var toIntegerOrInfinity$4 = toIntegerOrInfinity$5;
var toString$b = toString$c;
var requireObjectCoercible$4 = requireObjectCoercible$6;
var charAt$3 = uncurryThis$u("".charAt);
var charCodeAt$1 = uncurryThis$u("".charCodeAt);
var stringSlice = uncurryThis$u("".slice);
var createMethod$5 = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = toString$b(requireObjectCoercible$4($this));
        var position = toIntegerOrInfinity$4(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = charCodeAt$1(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$3(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod$5(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod$5(true)
};
var global$k = global$q;
var isCallable$k = isCallable$m;
var WeakMap$1 = global$k.WeakMap;
var weakMapBasicDetection = isCallable$k(WeakMap$1) && /native code/.test(String(WeakMap$1));
var isCallable$j = isCallable$m;
var $documentAll = documentAll_1;
var documentAll = $documentAll.all;
var isObject$j = $documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : isCallable$j(it) || it === documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : isCallable$j(it);
};
var fails$v = fails$y;
// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$v(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});
var objectDefineProperty = {};
var global$j = global$q;
var isObject$i = isObject$j;
var document$3 = global$j.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$i(document$3) && isObject$i(document$3.createElement);
var documentCreateElement$1 = function(it) {
    return EXISTS$1 ? document$3.createElement(it) : {};
};
var DESCRIPTORS$i = descriptors;
var fails$u = fails$y;
var createElement$1 = documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$i && !fails$u(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});
var DESCRIPTORS$h = descriptors;
var fails$t = fails$y;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$h && fails$t(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});
var isObject$h = isObject$j;
var $String$3 = String;
var $TypeError$g = TypeError;
// `Assert: Type(argument) is Object`
var anObject$d = function(argument) {
    if (isObject$h(argument)) return argument;
    throw new $TypeError$g($String$3(argument) + " is not an object");
};
var NATIVE_BIND$3 = functionBindNative;
var call$j = Function.prototype.call;
var functionCall = NATIVE_BIND$3 ? call$j.bind(call$j) : function() {
    return call$j.apply(call$j, arguments);
};
var path$u = {};
var path$t = path$u;
var global$i = global$q;
var isCallable$i = isCallable$m;
var aFunction = function(variable) {
    return isCallable$i(variable) ? variable : undefined;
};
var getBuiltIn$f = function(namespace, method) {
    return arguments.length < 2 ? aFunction(path$t[namespace]) || aFunction(global$i[namespace]) : path$t[namespace] && path$t[namespace][method] || global$i[namespace] && global$i[namespace][method];
};
var uncurryThis$t = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$t({}.isPrototypeOf);
var getBuiltIn$e = getBuiltIn$f;
var isCallable$h = isCallable$m;
var isPrototypeOf$r = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var $Object$2 = Object;
var isSymbol$5 = USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = getBuiltIn$e("Symbol");
    return isCallable$h($Symbol) && isPrototypeOf$r($Symbol.prototype, $Object$2(it));
};
var $String$2 = String;
var tryToString$6 = function(argument) {
    try {
        return $String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var isCallable$g = isCallable$m;
var tryToString$5 = tryToString$6;
var $TypeError$f = TypeError;
// `Assert: IsCallable(argument) is true`
var aCallable$e = function(argument) {
    if (isCallable$g(argument)) return argument;
    throw new $TypeError$f(tryToString$5(argument) + " is not a function");
};
var aCallable$d = aCallable$e;
var isNullOrUndefined$4 = isNullOrUndefined$6;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function(V, P) {
    var func = V[P];
    return isNullOrUndefined$4(func) ? undefined : aCallable$d(func);
};
var call$i = functionCall;
var isCallable$f = isCallable$m;
var isObject$g = isObject$j;
var $TypeError$e = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && isCallable$f(fn = input.toString) && !isObject$g(val = call$i(fn, input))) return val;
    if (isCallable$f(fn = input.valueOf) && !isObject$g(val = call$i(fn, input))) return val;
    if (pref !== "string" && isCallable$f(fn = input.toString) && !isObject$g(val = call$i(fn, input))) return val;
    throw new $TypeError$e("Can't convert object to primitive value");
};
var call$h = functionCall;
var isObject$f = isObject$j;
var isSymbol$4 = isSymbol$5;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$m = wellKnownSymbol$p;
var $TypeError$d = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$m("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$6 = function(input, pref) {
    if (!isObject$f(input) || isSymbol$4(input)) return input;
    var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = call$h(exoticToPrim, input, pref);
        if (!isObject$f(result) || isSymbol$4(result)) return result;
        throw new $TypeError$d("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return ordinaryToPrimitive(input, pref);
};
var toPrimitive$5 = toPrimitive$6;
var isSymbol$3 = isSymbol$5;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$4 = function(argument) {
    var key = toPrimitive$5(argument, "string");
    return isSymbol$3(key) ? key : key + "";
};
var DESCRIPTORS$g = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$c = anObject$d;
var toPropertyKey$3 = toPropertyKey$4;
var $TypeError$c = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty$1 = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE$1 = "configurable";
var WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$g ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    anObject$c(O);
    P = toPropertyKey$3(P);
    anObject$c(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor$2(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty(O, P, Attributes) {
    anObject$c(O);
    P = toPropertyKey$3(P);
    anObject$c(Attributes);
    if (IE8_DOM_DEFINE$1) try {
        return $defineProperty$1(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $TypeError$c("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var createPropertyDescriptor$7 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var DESCRIPTORS$f = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$6 = createPropertyDescriptor$7;
var createNonEnumerableProperty$9 = DESCRIPTORS$f ? function(object, key, value) {
    return definePropertyModule$4.f(object, key, createPropertyDescriptor$6(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var shared$5 = sharedExports;
var uid$2 = uid$4;
var keys$7 = shared$5("keys");
var sharedKey$4 = function(key) {
    return keys$7[key] || (keys$7[key] = uid$2(key));
};
var hiddenKeys$6 = {};
var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$h = global$q;
var isObject$e = isObject$j;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$i = hasOwnProperty_1;
var shared$4 = sharedStore;
var sharedKey$3 = sharedKey$4;
var hiddenKeys$5 = hiddenKeys$6;
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError$3 = global$h.TypeError;
var WeakMap = global$h.WeakMap;
var set$4, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set$4(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject$e(it) || (state = get(it)).type !== TYPE) throw new TypeError$3("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared$4.state) {
    var store$1 = shared$4.state || (shared$4.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store$1.get = store$1.get;
    store$1.has = store$1.has;
    store$1.set = store$1.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set$4 = function(it, metadata) {
        if (store$1.has(it)) throw new TypeError$3(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store$1.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store$1.get(it) || {};
    };
    has = function(it) {
        return store$1.has(it);
    };
} else {
    var STATE = sharedKey$3("state");
    hiddenKeys$5[STATE] = true;
    set$4 = function(it, metadata) {
        if (hasOwn$i(it, STATE)) throw new TypeError$3(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty$8(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn$i(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn$i(it, STATE);
    };
}
var internalState = {
    set: set$4,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};
var NATIVE_BIND$2 = functionBindNative;
var FunctionPrototype$3 = Function.prototype;
var apply$6 = FunctionPrototype$3.apply;
var call$g = FunctionPrototype$3.call;
// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND$2 ? call$g.bind(apply$6) : function() {
    return call$g.apply(apply$6, arguments);
});
var classofRaw = classofRaw$2;
var uncurryThis$s = functionUncurryThis;
var functionUncurryThisClause = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if (classofRaw(fn) === "Function") return uncurryThis$s(fn);
};
var objectGetOwnPropertyDescriptor = {};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable$2 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$7 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$7 && !$propertyIsEnumerable$2.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor$7(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2;
var uncurryThis$r = functionUncurryThis;
var fails$s = fails$y;
var classof$e = classofRaw$2;
var $Object$1 = Object;
var split = uncurryThis$r("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$s(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object$1("z").propertyIsEnumerable(0);
}) ? function(it) {
    return classof$e(it) === "String" ? split(it, "") : $Object$1(it);
} : $Object$1;
// toObject with fallback for non-array-like ES3 strings
var IndexedObject$3 = indexedObject;
var requireObjectCoercible$3 = requireObjectCoercible$6;
var toIndexedObject$b = function(it) {
    return IndexedObject$3(requireObjectCoercible$3(it));
};
var DESCRIPTORS$e = descriptors;
var call$f = functionCall;
var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable;
var createPropertyDescriptor$5 = createPropertyDescriptor$7;
var toIndexedObject$a = toIndexedObject$b;
var toPropertyKey$2 = toPropertyKey$4;
var hasOwn$h = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$e ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject$a(O);
    P = toPropertyKey$2(P);
    if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if (hasOwn$h(O, P)) return createPropertyDescriptor$5(!call$f(propertyIsEnumerableModule$2.f, O, P), O[P]);
};
var fails$r = fails$y;
var isCallable$e = isCallable$m;
var replacement = /#|\.prototype\./;
var isForced$2 = function(feature, detection) {
    var value = data[normalize(feature)];
    return value === POLYFILL ? true : value === NATIVE ? false : isCallable$e(detection) ? fails$r(detection) : !!detection;
};
var normalize = isForced$2.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = "N";
var POLYFILL = isForced$2.POLYFILL = "P";
var isForced_1 = isForced$2;
var uncurryThis$q = functionUncurryThisClause;
var aCallable$c = aCallable$e;
var NATIVE_BIND$1 = functionBindNative;
var bind$i = uncurryThis$q(uncurryThis$q.bind);
// optional / simple context binding
var functionBindContext = function(fn, that) {
    aCallable$c(fn);
    return that === undefined ? fn : NATIVE_BIND$1 ? bind$i(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var global$g = global$q;
var apply$5 = functionApply;
var uncurryThis$p = functionUncurryThisClause;
var isCallable$d = isCallable$m;
var getOwnPropertyDescriptor$6 = objectGetOwnPropertyDescriptor.f;
var isForced$1 = isForced_1;
var path$s = path$u;
var bind$h = functionBindContext;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var hasOwn$g = hasOwnProperty_1;
var wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return apply$5(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var _export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? global$g : STATIC ? global$g[TARGET] : (global$g[TARGET] || {}).prototype;
    var target = GLOBAL ? path$s : path$s[TARGET] || createNonEnumerableProperty$7(path$s, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && hasOwn$g(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = getOwnPropertyDescriptor$6(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = bind$h(sourceProperty, global$g);
        else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
        else if (PROTO && isCallable$d(sourceProperty)) resultProperty = uncurryThis$p(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty$7(resultProperty, "sham", true);
        createNonEnumerableProperty$7(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!hasOwn$g(path$s, VIRTUAL_PROTOTYPE)) createNonEnumerableProperty$7(path$s, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            createNonEnumerableProperty$7(path$s[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) createNonEnumerableProperty$7(targetPrototype, key, sourceProperty);
        }
    }
};
var DESCRIPTORS$d = descriptors;
var hasOwn$f = hasOwnProperty_1;
var FunctionPrototype$2 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$d && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$f(FunctionPrototype$2, "name");
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$d || DESCRIPTORS$d && getDescriptor(FunctionPrototype$2, "name").configurable);
var functionName = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};
var objectDefineProperties = {};
var toIntegerOrInfinity$3 = toIntegerOrInfinity$5;
var max$3 = Math.max;
var min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$5 = function(index, length) {
    var integer = toIntegerOrInfinity$3(index);
    return integer < 0 ? max$3(integer + length, 0) : min$2(integer, length);
};
var toIntegerOrInfinity$2 = toIntegerOrInfinity$5;
var min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function(argument) {
    return argument > 0 ? min$1(toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var toLength = toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$e = function(obj) {
    return toLength(obj.length);
};
var toIndexedObject$9 = toIndexedObject$b;
var toAbsoluteIndex$4 = toAbsoluteIndex$5;
var lengthOfArrayLike$d = lengthOfArrayLike$e;
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$4 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject$9($this);
        var length = lengthOfArrayLike$d(O);
        var index = toAbsoluteIndex$4(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod$4(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod$4(false)
};
var uncurryThis$o = functionUncurryThis;
var hasOwn$e = hasOwnProperty_1;
var toIndexedObject$8 = toIndexedObject$b;
var indexOf$4 = arrayIncludes.indexOf;
var hiddenKeys$4 = hiddenKeys$6;
var push$d = uncurryThis$o([].push);
var objectKeysInternal = function(object, names) {
    var O = toIndexedObject$8(object);
    var i1 = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn$e(hiddenKeys$4, key) && hasOwn$e(O, key) && push$d(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i1)if (hasOwn$e(O, key = names[i1++])) ~indexOf$4(result, key) || push$d(result, key);
    return result;
};
// IE8- don't enum bug keys
var enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$4 = Object.keys || function keys(O) {
    return internalObjectKeys$1(O, enumBugKeys$2);
};
var DESCRIPTORS$c = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$3 = objectDefineProperty;
var anObject$b = anObject$d;
var toIndexedObject$7 = toIndexedObject$b;
var objectKeys$3 = objectKeys$4;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$c && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject$b(O);
    var props = toIndexedObject$7(Properties);
    var keys = objectKeys$3(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule$3.f(O, key = keys[index++], props[key]);
    return O;
};
var getBuiltIn$d = getBuiltIn$f;
var html$2 = getBuiltIn$d("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var anObject$a = anObject$d;
var definePropertiesModule$1 = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$3 = hiddenKeys$6;
var html$1 = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey$2 = sharedKey$4;
var GT = ">";
var LT = "<";
var PROTOTYPE$1 = "prototype";
var SCRIPT = "script";
var IE_PROTO$1 = sharedKey$2("IE_PROTO");
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement("iframe");
    var JS = "java" + SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys$1.length;
    while(length--)delete NullProtoObject[PROTOTYPE$1][enumBugKeys$1[length]];
    return NullProtoObject();
};
hiddenKeys$3[IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE$1] = anObject$a(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE$1] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO$1] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : definePropertiesModule$1.f(result, Properties);
};
var fails$q = fails$y;
var correctPrototypeGetter = !fails$q(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var hasOwn$d = hasOwnProperty_1;
var isCallable$c = isCallable$m;
var toObject$d = toObject$f;
var sharedKey$1 = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER$1 = correctPrototypeGetter;
var IE_PROTO = sharedKey$1("IE_PROTO");
var $Object = Object;
var ObjectPrototype$2 = $Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf$1 = CORRECT_PROTOTYPE_GETTER$1 ? $Object.getPrototypeOf : function(O) {
    var object = toObject$d(O);
    if (hasOwn$d(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;
    if (isCallable$c(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $Object ? ObjectPrototype$2 : null;
};
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var defineBuiltIn$6 = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else createNonEnumerableProperty$6(target, key, value);
    return target;
};
var fails$p = fails$y;
var isCallable$b = isCallable$m;
var isObject$d = isObject$j;
var create$b = objectCreate;
var getPrototypeOf$8 = objectGetPrototypeOf$1;
var defineBuiltIn$5 = defineBuiltIn$6;
var wellKnownSymbol$l = wellKnownSymbol$p;
var ITERATOR$6 = wellKnownSymbol$l("iterator");
var BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$1, PrototypeOfArrayIteratorPrototype, arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf$8(getPrototypeOf$8(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$1 = PrototypeOfArrayIteratorPrototype;
    }
}
var NEW_ITERATOR_PROTOTYPE = !isObject$d(IteratorPrototype$1) || fails$p(function() {
    var test = {};
    // FF44- legacy iterators case
    return IteratorPrototype$1[ITERATOR$6].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$1 = {};
else IteratorPrototype$1 = create$b(IteratorPrototype$1);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$b(IteratorPrototype$1[ITERATOR$6])) defineBuiltIn$5(IteratorPrototype$1, ITERATOR$6, function() {
    return this;
});
var iteratorsCore = {
    IteratorPrototype: IteratorPrototype$1,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};
var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$d = classof$g;
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? ({}).toString : function toString() {
    return "[object " + classof$d(this) + "]";
};
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var defineProperty$e = objectDefineProperty.f;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var hasOwn$c = hasOwnProperty_1;
var toString$a = objectToString;
var wellKnownSymbol$k = wellKnownSymbol$p;
var TO_STRING_TAG$2 = wellKnownSymbol$k("toStringTag");
var setToStringTag$7 = function(it, TAG, STATIC, SET_METHOD) {
    if (it) {
        var target = STATIC ? it : it.prototype;
        if (!hasOwn$c(target, TO_STRING_TAG$2)) defineProperty$e(target, TO_STRING_TAG$2, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !TO_STRING_TAG_SUPPORT) createNonEnumerableProperty$5(target, "toString", toString$a);
    }
};
var iterators = {};
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var create$a = objectCreate;
var createPropertyDescriptor$4 = createPropertyDescriptor$7;
var setToStringTag$6 = setToStringTag$7;
var Iterators$5 = iterators;
var returnThis$1 = function() {
    return this;
};
var iteratorCreateConstructor = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = create$a(IteratorPrototype, {
        next: createPropertyDescriptor$4(+!ENUMERABLE_NEXT, next)
    });
    setToStringTag$6(IteratorConstructor, TO_STRING_TAG, false, true);
    Iterators$5[TO_STRING_TAG] = returnThis$1;
    return IteratorConstructor;
};
var uncurryThis$n = functionUncurryThis;
var aCallable$b = aCallable$e;
var functionUncurryThisAccessor = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return uncurryThis$n(aCallable$b(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};
var isCallable$a = isCallable$m;
var $String$1 = String;
var $TypeError$b = TypeError;
var aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || isCallable$a(argument)) return argument;
    throw new $TypeError$b("Can't set " + $String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$9 = anObject$d;
var aPossiblePrototype = aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = uncurryThisAccessor(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        anObject$9(O);
        aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $$10 = _export;
var call$e = functionCall;
var FunctionName = functionName;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf$7 = objectGetPrototypeOf$1;
var setToStringTag$5 = setToStringTag$7;
var defineBuiltIn$4 = defineBuiltIn$6;
var wellKnownSymbol$j = wellKnownSymbol$p;
var Iterators$4 = iterators;
var IteratorsCore = iteratorsCore;
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
FunctionName.CONFIGURABLE;
IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$5 = wellKnownSymbol$j("iterator");
var KEYS = "keys";
var VALUES = "values";
var ENTRIES = "entries";
var returnThis = function() {
    return this;
};
var iteratorDefine = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR$5] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = getPrototypeOf$7(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag$5(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            Iterators$4[TO_STRING_TAG] = returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
            return call$e(nativeIterator, this);
        };
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) defineBuiltIn$4(IterablePrototype, KEY, methods[KEY]);
        } else $$10({
            target: NAME,
            proto: true,
            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (FORCED && IterablePrototype[ITERATOR$5] !== defaultIterator) defineBuiltIn$4(IterablePrototype, ITERATOR$5, defaultIterator, {
        name: DEFAULT
    });
    Iterators$4[NAME] = defaultIterator;
    return methods;
};
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$3 = function(value, done) {
    return {
        value: value,
        done: done
    };
};
var charAt$2 = stringMultibyte.charAt;
var toString$9 = toString$c;
var InternalStateModule$5 = internalState;
var defineIterator$2 = iteratorDefine;
var createIterResultObject$2 = createIterResultObject$3;
var STRING_ITERATOR = "String Iterator";
var setInternalState$5 = InternalStateModule$5.set;
var getInternalState$2 = InternalStateModule$5.getterFor(STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator$2(String, "String", function(iterated) {
    setInternalState$5(this, {
        type: STRING_ITERATOR,
        string: toString$9(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = getInternalState$2(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return createIterResultObject$2(undefined, true);
    point = charAt$2(string, index);
    state.index += point.length;
    return createIterResultObject$2(point, false);
});
var call$d = functionCall;
var anObject$8 = anObject$d;
var getMethod$1 = getMethod$3;
var iteratorClose$2 = function(iterator, kind, value) {
    var innerResult, innerError;
    anObject$8(iterator);
    try {
        innerResult = getMethod$1(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = call$d(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    anObject$8(innerResult);
    return value;
};
var anObject$7 = anObject$d;
var iteratorClose$1 = iteratorClose$2;
// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn(anObject$7(value)[0], value[1]) : fn(value);
    } catch (error) {
        iteratorClose$1(iterator, "throw", error);
    }
};
var wellKnownSymbol$i = wellKnownSymbol$p;
var Iterators$3 = iterators;
var ITERATOR$4 = wellKnownSymbol$i("iterator");
var ArrayPrototype$l = Array.prototype;
// check on default Array iterator
var isArrayIteratorMethod$2 = function(it) {
    return it !== undefined && (Iterators$3.Array === it || ArrayPrototype$l[ITERATOR$4] === it);
};
var uncurryThis$m = functionUncurryThis;
var isCallable$9 = isCallable$m;
var store = sharedStore;
var functionToString = uncurryThis$m(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$9(store.inspectSource)) store.inspectSource = function(it) {
    return functionToString(it);
};
var inspectSource$2 = store.inspectSource;
var uncurryThis$l = functionUncurryThis;
var fails$o = fails$y;
var isCallable$8 = isCallable$m;
var classof$c = classof$g;
var getBuiltIn$c = getBuiltIn$f;
var inspectSource$1 = inspectSource$2;
var noop = function() {};
var empty = [];
var construct$4 = getBuiltIn$c("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$2 = uncurryThis$l(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
var isConstructorModern = function isConstructor(argument) {
    if (!isCallable$8(argument)) return false;
    try {
        construct$4(noop, empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var isConstructorLegacy = function isConstructor(argument) {
    if (!isCallable$8(argument)) return false;
    switch(classof$c(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return INCORRECT_TO_STRING || !!exec$2(constructorRegExp, inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$4 = !construct$4 || fails$o(function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
        called = true;
    }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var toPropertyKey$1 = toPropertyKey$4;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$7;
var createProperty$6 = function(object, key, value) {
    var propertyKey = toPropertyKey$1(key);
    if (propertyKey in object) definePropertyModule$2.f(object, propertyKey, createPropertyDescriptor$3(0, value));
    else object[propertyKey] = value;
};
var classof$b = classof$g;
var getMethod = getMethod$3;
var isNullOrUndefined$3 = isNullOrUndefined$6;
var Iterators$2 = iterators;
var wellKnownSymbol$h = wellKnownSymbol$p;
var ITERATOR$3 = wellKnownSymbol$h("iterator");
var getIteratorMethod$9 = function(it) {
    if (!isNullOrUndefined$3(it)) return getMethod(it, ITERATOR$3) || getMethod(it, "@@iterator") || Iterators$2[classof$b(it)];
};
var call$c = functionCall;
var aCallable$a = aCallable$e;
var anObject$6 = anObject$d;
var tryToString$4 = tryToString$6;
var getIteratorMethod$8 = getIteratorMethod$9;
var $TypeError$a = TypeError;
var getIterator$8 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? getIteratorMethod$8(argument) : usingIterator;
    if (aCallable$a(iteratorMethod)) return anObject$6(call$c(iteratorMethod, argument));
    throw new $TypeError$a(tryToString$4(argument) + " is not iterable");
};
var bind$g = functionBindContext;
var call$b = functionCall;
var toObject$c = toObject$f;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var isConstructor$3 = isConstructor$4;
var lengthOfArrayLike$c = lengthOfArrayLike$e;
var createProperty$5 = createProperty$6;
var getIterator$7 = getIterator$8;
var getIteratorMethod$7 = getIteratorMethod$9;
var $Array$3 = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = toObject$c(arrayLike);
    var IS_CONSTRUCTOR = isConstructor$3(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = bind$g(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = getIteratorMethod$7(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $Array$3 && isArrayIteratorMethod$1(iteratorMethod))) {
        iterator = getIterator$7(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = call$b(next, iterator)).done; index++){
            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            createProperty$5(result, index, value);
        }
    } else {
        length = lengthOfArrayLike$c(O);
        result = IS_CONSTRUCTOR ? new this(length) : $Array$3(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            createProperty$5(result, index, value);
        }
    }
    result.length = index;
    return result;
};
var wellKnownSymbol$g = wellKnownSymbol$p;
var ITERATOR$2 = wellKnownSymbol$g("iterator");
var SAFE_CLOSING = false;
try {
    var called = 0;
    var iteratorWithReturn = {
        next: function() {
            return {
                done: !!called++
            };
        },
        "return": function() {
            SAFE_CLOSING = true;
        }
    };
    iteratorWithReturn[ITERATOR$2] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from(iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var checkCorrectnessOfIteration$2 = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[ITERATOR$2] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $$$ = _export;
var from$6 = arrayFrom;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$2;
var INCORRECT_ITERATION = !checkCorrectnessOfIteration$1(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$$$({
    target: "Array",
    stat: true,
    forced: INCORRECT_ITERATION
}, {
    from: from$6
});
var path$r = path$u;
var from$5 = path$r.Array.from;
var parent$1k = from$5;
var from$4 = parent$1k;
var from$3 = from$4;
var _Array$from$1 = /*@__PURE__*/ getDefaultExportFromCjs(from$3);
var toIndexedObject$6 = toIndexedObject$b;
var Iterators$1 = iterators;
var InternalStateModule$4 = internalState;
objectDefineProperty.f;
var defineIterator$1 = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$3;
var ARRAY_ITERATOR = "Array Iterator";
var setInternalState$4 = InternalStateModule$4.set;
var getInternalState$1 = InternalStateModule$4.getterFor(ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
defineIterator$1(Array, "Array", function(iterated, kind) {
    setInternalState$4(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject$6(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = getInternalState$1(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return createIterResultObject$1(undefined, true);
    }
    switch(kind){
        case "keys":
            return createIterResultObject$1(index, false);
        case "values":
            return createIterResultObject$1(target[index], false);
    }
    return createIterResultObject$1([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators$1.Arguments = Iterators$1.Array;
var getIteratorMethod$6 = getIteratorMethod$9;
var getIteratorMethod_1 = getIteratorMethod$6;
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
var DOMIterables$4 = domIterables;
var global$f = global$q;
var classof$a = classof$g;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
var Iterators = iterators;
var wellKnownSymbol$f = wellKnownSymbol$p;
var TO_STRING_TAG$1 = wellKnownSymbol$f("toStringTag");
for(var COLLECTION_NAME in DOMIterables$4){
    var Collection = global$f[COLLECTION_NAME];
    var CollectionPrototype = Collection && Collection.prototype;
    if (CollectionPrototype && classof$a(CollectionPrototype) !== TO_STRING_TAG$1) createNonEnumerableProperty$4(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
    Iterators[COLLECTION_NAME] = Iterators.Array;
}
var parent$1j = getIteratorMethod_1;
var getIteratorMethod$5 = parent$1j;
var parent$1i = getIteratorMethod$5;
var getIteratorMethod$4 = parent$1i;
var parent$1h = getIteratorMethod$4;
var getIteratorMethod$3 = parent$1h;
var getIteratorMethod$2 = getIteratorMethod$3;
var _getIteratorMethod$1 = /*@__PURE__*/ getDefaultExportFromCjs(getIteratorMethod$2);
var getIteratorMethod$1 = getIteratorMethod$2;
var _getIteratorMethod = /*@__PURE__*/ getDefaultExportFromCjs(getIteratorMethod$1);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var defineProperty$d = {
    exports: {}
};
var $$_ = _export;
var DESCRIPTORS$b = descriptors;
var defineProperty$c = objectDefineProperty.f;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$$_({
    target: "Object",
    stat: true,
    forced: Object.defineProperty !== defineProperty$c,
    sham: !DESCRIPTORS$b
}, {
    defineProperty: defineProperty$c
});
var path$q = path$u;
var Object$4 = path$q.Object;
var defineProperty$b = defineProperty$d.exports = function defineProperty(it, key, desc) {
    return Object$4.defineProperty(it, key, desc);
};
if (Object$4.defineProperty.sham) defineProperty$b.sham = true;
var definePropertyExports = defineProperty$d.exports;
var parent$1g = definePropertyExports;
var defineProperty$a = parent$1g;
var parent$1f = defineProperty$a;
var defineProperty$9 = parent$1f;
var parent$1e = defineProperty$9;
var defineProperty$8 = parent$1e;
var defineProperty$7 = defineProperty$8;
var _Object$defineProperty$1 = /*@__PURE__*/ getDefaultExportFromCjs(defineProperty$7);
var classof$9 = classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$e = Array.isArray || function isArray(argument) {
    return classof$9(argument) === "Array";
};
var $TypeError$9 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
var doesNotExceedSafeInteger$4 = function(it) {
    if (it > MAX_SAFE_INTEGER) throw $TypeError$9("Maximum allowed index exceeded");
    return it;
};
var isArray$d = isArray$e;
var isConstructor$2 = isConstructor$4;
var isObject$c = isObject$j;
var wellKnownSymbol$e = wellKnownSymbol$p;
var SPECIES$5 = wellKnownSymbol$e("species");
var $Array$2 = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if (isArray$d(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (isConstructor$2(C) && (C === $Array$2 || isArray$d(C.prototype))) C = undefined;
        else if (isObject$c(C)) {
            C = C[SPECIES$5];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $Array$2 : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$4 = function(originalArray, length) {
    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var fails$n = fails$y;
var wellKnownSymbol$d = wellKnownSymbol$p;
var V8_VERSION$2 = engineV8Version;
var SPECIES$4 = wellKnownSymbol$d("species");
var arrayMethodHasSpeciesSupport$5 = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return V8_VERSION$2 >= 51 || !fails$n(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[SPECIES$4] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};
var $$Z = _export;
var fails$m = fails$y;
var isArray$c = isArray$e;
var isObject$b = isObject$j;
var toObject$b = toObject$f;
var lengthOfArrayLike$b = lengthOfArrayLike$e;
var doesNotExceedSafeInteger$3 = doesNotExceedSafeInteger$4;
var createProperty$4 = createProperty$6;
var arraySpeciesCreate$3 = arraySpeciesCreate$4;
var arrayMethodHasSpeciesSupport$4 = arrayMethodHasSpeciesSupport$5;
var wellKnownSymbol$c = wellKnownSymbol$p;
var V8_VERSION$1 = engineV8Version;
var IS_CONCAT_SPREADABLE = wellKnownSymbol$c("isConcatSpreadable");
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION$1 >= 51 || !fails$m(function() {
    var array = [];
    array[IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var isConcatSpreadable = function(O) {
    if (!isObject$b(O)) return false;
    var spreadable = O[IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : isArray$c(O);
};
var FORCED$9 = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport$4("concat");
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$$Z({
    target: "Array",
    proto: true,
    arity: 1,
    forced: FORCED$9
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = toObject$b(this);
        var A = arraySpeciesCreate$3(O, 0);
        var n = 0;
        var i1, k, length, len, E;
        for(i1 = -1, length = arguments.length; i1 < length; i1++){
            E = i1 === -1 ? O : arguments[i1];
            if (isConcatSpreadable(E)) {
                len = lengthOfArrayLike$b(E);
                doesNotExceedSafeInteger$3(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) createProperty$4(A, n, E[k]);
            } else {
                doesNotExceedSafeInteger$3(n + 1);
                createProperty$4(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});
var objectGetOwnPropertyNames = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$2 = enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys$2);
};
var objectGetOwnPropertyNamesExternal = {};
var toAbsoluteIndex$3 = toAbsoluteIndex$5;
var lengthOfArrayLike$a = lengthOfArrayLike$e;
var createProperty$3 = createProperty$6;
var $Array$1 = Array;
var max$2 = Math.max;
var arraySliceSimple = function(O, start, end) {
    var length = lengthOfArrayLike$a(O);
    var k = toAbsoluteIndex$3(start, length);
    var fin = toAbsoluteIndex$3(end === undefined ? length : end, length);
    var result = $Array$1(max$2(fin - k, 0));
    var n = 0;
    for(; k < fin; k++, n++)createProperty$3(result, n, O[k]);
    result.length = n;
    return result;
};
/* eslint-disable es/no-object-getownpropertynames -- safe */ var classof$8 = classofRaw$2;
var toIndexedObject$5 = toIndexedObject$b;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var arraySlice$6 = arraySliceSimple;
var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
    try {
        return $getOwnPropertyNames$1(it);
    } catch (error) {
        return arraySlice$6(windowNames);
    }
};
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
    return windowNames && classof$8(it) === "Window" ? getWindowNames(it) : $getOwnPropertyNames$1(toIndexedObject$5(it));
};
var objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var defineProperty$6 = objectDefineProperty;
var defineBuiltInAccessor$3 = function(target, name, descriptor) {
    return defineProperty$6.f(target, name, descriptor);
};
var wellKnownSymbolWrapped = {};
var wellKnownSymbol$b = wellKnownSymbol$p;
wellKnownSymbolWrapped.f = wellKnownSymbol$b;
var path$p = path$u;
var hasOwn$b = hasOwnProperty_1;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$5 = objectDefineProperty.f;
var wellKnownSymbolDefine = function(NAME) {
    var Symbol1 = path$p.Symbol || (path$p.Symbol = {});
    if (!hasOwn$b(Symbol1, NAME)) defineProperty$5(Symbol1, NAME, {
        value: wrappedWellKnownSymbolModule$1.f(NAME)
    });
};
var call$a = functionCall;
var getBuiltIn$b = getBuiltIn$f;
var wellKnownSymbol$a = wellKnownSymbol$p;
var defineBuiltIn$3 = defineBuiltIn$6;
var symbolDefineToPrimitive = function() {
    var Symbol1 = getBuiltIn$b("Symbol");
    var SymbolPrototype = Symbol1 && Symbol1.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = wellKnownSymbol$a("toPrimitive");
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn$3(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return call$a(valueOf, this);
    }, {
        arity: 1
    });
};
var bind$f = functionBindContext;
var uncurryThis$k = functionUncurryThis;
var IndexedObject$2 = indexedObject;
var toObject$a = toObject$f;
var lengthOfArrayLike$9 = lengthOfArrayLike$e;
var arraySpeciesCreate$2 = arraySpeciesCreate$4;
var push$c = uncurryThis$k([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$3 = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = toObject$a($this);
        var self1 = IndexedObject$2(O);
        var boundFunction = bind$f(callbackfn, that);
        var length = lengthOfArrayLike$9(self1);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate$2;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        push$c(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        push$c(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod$3(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod$3(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod$3(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod$3(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod$3(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod$3(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod$3(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: createMethod$3(7)
};
var $$Y = _export;
var global$e = global$q;
var call$9 = functionCall;
var uncurryThis$j = functionUncurryThis;
var DESCRIPTORS$a = descriptors;
var NATIVE_SYMBOL$3 = symbolConstructorDetection;
var fails$l = fails$y;
var hasOwn$a = hasOwnProperty_1;
var isPrototypeOf$q = objectIsPrototypeOf;
var anObject$5 = anObject$d;
var toIndexedObject$4 = toIndexedObject$b;
var toPropertyKey = toPropertyKey$4;
var $toString = toString$c;
var createPropertyDescriptor$2 = createPropertyDescriptor$7;
var nativeObjectCreate = objectCreate;
var objectKeys$2 = objectKeys$4;
var getOwnPropertyNamesModule$2 = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule$3 = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule$2 = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;
var definePropertiesModule = objectDefineProperties;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var defineBuiltIn$2 = defineBuiltIn$6;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$3;
var shared$3 = sharedExports;
var sharedKey = sharedKey$4;
var hiddenKeys$1 = hiddenKeys$6;
var uid$1 = uid$4;
var wellKnownSymbol$9 = wellKnownSymbol$p;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol$l = wellKnownSymbolDefine;
var defineSymbolToPrimitive$1 = symbolDefineToPrimitive;
var setToStringTag$4 = setToStringTag$7;
var InternalStateModule$3 = internalState;
var $forEach$1 = arrayIteration.forEach;
var HIDDEN = sharedKey("hidden");
var SYMBOL = "Symbol";
var PROTOTYPE = "prototype";
var setInternalState$3 = InternalStateModule$3.set;
var getInternalState = InternalStateModule$3.getterFor(SYMBOL);
var ObjectPrototype$1 = Object[PROTOTYPE];
var $Symbol = global$e.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError$1 = global$e.RangeError;
var TypeError$2 = global$e.TypeError;
var QObject = global$e.QObject;
var nativeGetOwnPropertyDescriptor$1 = getOwnPropertyDescriptorModule$2.f;
var nativeDefineProperty = definePropertyModule$1.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule$1.f;
var push$b = uncurryThis$j([].push);
var AllSymbols = shared$3("symbols");
var ObjectPrototypeSymbols = shared$3("op-symbols");
var WellKnownSymbolsStore$1 = shared$3("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype$1, P);
    if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
    nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
};
var setSymbolDescriptor = DESCRIPTORS$a && fails$l(function() {
    return nativeObjectCreate(nativeDefineProperty({}, "a", {
        get: function() {
            return nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;
var wrap = function(tag, description) {
    var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
    setInternalState$3(symbol, {
        type: SYMBOL,
        tag: tag,
        description: description
    });
    if (!DESCRIPTORS$a) symbol.description = description;
    return symbol;
};
var $defineProperty = function defineProperty(O, P, Attributes) {
    if (O === ObjectPrototype$1) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
    anObject$5(O);
    var key = toPropertyKey(P);
    anObject$5(Attributes);
    if (hasOwn$a(AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!hasOwn$a(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor$2(1, {}));
            O[HIDDEN][key] = true;
        } else {
            if (hasOwn$a(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
            Attributes = nativeObjectCreate(Attributes, {
                enumerable: createPropertyDescriptor$2(0, false)
            });
        }
        return setSymbolDescriptor(O, key, Attributes);
    }
    return nativeDefineProperty(O, key, Attributes);
};
var $defineProperties = function defineProperties(O, Properties) {
    anObject$5(O);
    var properties = toIndexedObject$4(Properties);
    var keys = objectKeys$2(properties).concat($getOwnPropertySymbols(properties));
    $forEach$1(keys, function(key) {
        if (!DESCRIPTORS$a || call$9($propertyIsEnumerable$1, properties, key)) $defineProperty(O, key, properties[key]);
    });
    return O;
};
var $create = function create(O, Properties) {
    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};
var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
    var P = toPropertyKey(V);
    var enumerable = call$9(nativePropertyIsEnumerable, this, P);
    if (this === ObjectPrototype$1 && hasOwn$a(AllSymbols, P) && !hasOwn$a(ObjectPrototypeSymbols, P)) return false;
    return enumerable || !hasOwn$a(this, P) || !hasOwn$a(AllSymbols, P) || hasOwn$a(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = toIndexedObject$4(O);
    var key = toPropertyKey(P);
    if (it === ObjectPrototype$1 && hasOwn$a(AllSymbols, key) && !hasOwn$a(ObjectPrototypeSymbols, key)) return;
    var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);
    if (descriptor && hasOwn$a(AllSymbols, key) && !(hasOwn$a(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = nativeGetOwnPropertyNames(toIndexedObject$4(O));
    var result = [];
    $forEach$1(names, function(key) {
        if (!hasOwn$a(AllSymbols, key) && !hasOwn$a(hiddenKeys$1, key)) push$b(result, key);
    });
    return result;
};
var $getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$4(O));
    var result = [];
    $forEach$1(names, function(key) {
        if (hasOwn$a(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$a(ObjectPrototype$1, key))) push$b(result, AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL$3) {
    $Symbol = function Symbol1() {
        if (isPrototypeOf$q(SymbolPrototype, this)) throw new TypeError$2("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
        var tag = uid$1(description);
        var setter = function(value) {
            if (this === ObjectPrototype$1) call$9(setter, ObjectPrototypeSymbols, value);
            if (hasOwn$a(this, HIDDEN) && hasOwn$a(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            var descriptor = createPropertyDescriptor$2(1, value);
            try {
                setSymbolDescriptor(this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof RangeError$1)) throw error;
                fallbackDefineProperty(this, tag, descriptor);
            }
        };
        if (DESCRIPTORS$a && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, {
            configurable: true,
            set: setter
        });
        return wrap(tag, description);
    };
    SymbolPrototype = $Symbol[PROTOTYPE];
    defineBuiltIn$2(SymbolPrototype, "toString", function toString() {
        return getInternalState(this).tag;
    });
    defineBuiltIn$2($Symbol, "withoutSetter", function(description) {
        return wrap(uid$1(description), description);
    });
    propertyIsEnumerableModule$1.f = $propertyIsEnumerable$1;
    definePropertyModule$1.f = $defineProperty;
    definePropertiesModule.f = $defineProperties;
    getOwnPropertyDescriptorModule$2.f = $getOwnPropertyDescriptor;
    getOwnPropertyNamesModule$2.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
    getOwnPropertySymbolsModule$3.f = $getOwnPropertySymbols;
    wrappedWellKnownSymbolModule.f = function(name) {
        return wrap(wellKnownSymbol$9(name), name);
    };
    if (DESCRIPTORS$a) // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor$2(SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            return getInternalState(this).description;
        }
    });
}
$$Y({
    global: true,
    constructor: true,
    wrap: true,
    forced: !NATIVE_SYMBOL$3,
    sham: !NATIVE_SYMBOL$3
}, {
    Symbol: $Symbol
});
$forEach$1(objectKeys$2(WellKnownSymbolsStore$1), function(name) {
    defineWellKnownSymbol$l(name);
});
$$Y({
    target: SYMBOL,
    stat: true,
    forced: !NATIVE_SYMBOL$3
}, {
    useSetter: function() {
        USE_SETTER = true;
    },
    useSimple: function() {
        USE_SETTER = false;
    }
});
$$Y({
    target: "Object",
    stat: true,
    forced: !NATIVE_SYMBOL$3,
    sham: !DESCRIPTORS$a
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});
$$Y({
    target: "Object",
    stat: true,
    forced: !NATIVE_SYMBOL$3
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive$1();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$4($Symbol, SYMBOL);
hiddenKeys$1[HIDDEN] = true;
var NATIVE_SYMBOL$2 = symbolConstructorDetection;
/* eslint-disable es/no-symbol -- safe */ var symbolRegistryDetection = NATIVE_SYMBOL$2 && !!Symbol["for"] && !!Symbol.keyFor;
var $$X = _export;
var getBuiltIn$a = getBuiltIn$f;
var hasOwn$9 = hasOwnProperty_1;
var toString$8 = toString$c;
var shared$2 = sharedExports;
var NATIVE_SYMBOL_REGISTRY$1 = symbolRegistryDetection;
var StringToSymbolRegistry = shared$2("string-to-symbol-registry");
var SymbolToStringRegistry$1 = shared$2("symbol-to-string-registry");
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$$X({
    target: "Symbol",
    stat: true,
    forced: !NATIVE_SYMBOL_REGISTRY$1
}, {
    "for": function(key) {
        var string = toString$8(key);
        if (hasOwn$9(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
        var symbol = getBuiltIn$a("Symbol")(string);
        StringToSymbolRegistry[string] = symbol;
        SymbolToStringRegistry$1[symbol] = string;
        return symbol;
    }
});
var $$W = _export;
var hasOwn$8 = hasOwnProperty_1;
var isSymbol$2 = isSymbol$5;
var tryToString$3 = tryToString$6;
var shared$1 = sharedExports;
var NATIVE_SYMBOL_REGISTRY = symbolRegistryDetection;
var SymbolToStringRegistry = shared$1("symbol-to-string-registry");
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$$W({
    target: "Symbol",
    stat: true,
    forced: !NATIVE_SYMBOL_REGISTRY
}, {
    keyFor: function keyFor(sym) {
        if (!isSymbol$2(sym)) throw new TypeError(tryToString$3(sym) + " is not a symbol");
        if (hasOwn$8(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
    }
});
var uncurryThis$i = functionUncurryThis;
var arraySlice$5 = uncurryThis$i([].slice);
var uncurryThis$h = functionUncurryThis;
var isArray$b = isArray$e;
var isCallable$7 = isCallable$m;
var classof$7 = classofRaw$2;
var toString$7 = toString$c;
var push$a = uncurryThis$h([].push);
var getJsonReplacerFunction = function(replacer) {
    if (isCallable$7(replacer)) return replacer;
    if (!isArray$b(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i1 = 0; i1 < rawLength; i1++){
        var element = replacer[i1];
        if (typeof element == "string") push$a(keys, element);
        else if (typeof element == "number" || classof$7(element) === "Number" || classof$7(element) === "String") push$a(keys, toString$7(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if (isArray$b(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};
var $$V = _export;
var getBuiltIn$9 = getBuiltIn$f;
var apply$4 = functionApply;
var call$8 = functionCall;
var uncurryThis$g = functionUncurryThis;
var fails$k = fails$y;
var isCallable$6 = isCallable$m;
var isSymbol$1 = isSymbol$5;
var arraySlice$4 = arraySlice$5;
var getReplacerFunction = getJsonReplacerFunction;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var $String = String;
var $stringify = getBuiltIn$9("JSON", "stringify");
var exec$1 = uncurryThis$g(/./.exec);
var charAt$1 = uncurryThis$g("".charAt);
var charCodeAt = uncurryThis$g("".charCodeAt);
var replace$2 = uncurryThis$g("".replace);
var numberToString = uncurryThis$g(1.0.toString);
var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;
var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL$1 || fails$k(function() {
    var symbol = getBuiltIn$9("Symbol")("stringify detection");
    // MS Edge converts symbol values to JSON as {}
    return $stringify([
        symbol
    ]) !== "[null]" || $stringify({
        a: symbol
    }) !== "{}" || $stringify(Object(symbol)) !== "{}";
});
// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails$k(function() {
    return $stringify("\uDF06\uD834") !== '"\udf06\ud834"' || $stringify("\uDEAD") !== '"\udead"';
});
var stringifyWithSymbolsFix = function(it, replacer) {
    var args = arraySlice$4(arguments);
    var $replacer = getReplacerFunction(replacer);
    if (!isCallable$6($replacer) && (it === undefined || isSymbol$1(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if (isCallable$6($replacer)) value = call$8($replacer, this, $String(key), value);
        if (!isSymbol$1(value)) return value;
    };
    return apply$4($stringify, null, args);
};
var fixIllFormed = function(match, offset, string) {
    var prev = charAt$1(string, offset - 1);
    var next = charAt$1(string, offset + 1);
    if (exec$1(low, match) && !exec$1(hi, next) || exec$1(hi, match) && !exec$1(low, prev)) return "\\u" + numberToString(charCodeAt(match, 0), 16);
    return match;
};
if ($stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$$V({
    target: "JSON",
    stat: true,
    arity: 3,
    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = arraySlice$4(arguments);
        var result = apply$4(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
        return ILL_FORMED_UNICODE && typeof result == "string" ? replace$2(result, tester, fixIllFormed) : result;
    }
});
var $$U = _export;
var NATIVE_SYMBOL = symbolConstructorDetection;
var fails$j = fails$y;
var getOwnPropertySymbolsModule$2 = objectGetOwnPropertySymbols;
var toObject$9 = toObject$f;
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED$8 = !NATIVE_SYMBOL || fails$j(function() {
    getOwnPropertySymbolsModule$2.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$$U({
    target: "Object",
    stat: true,
    forced: FORCED$8
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = getOwnPropertySymbolsModule$2.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject$9(it)) : [];
    }
});
var defineWellKnownSymbol$k = wellKnownSymbolDefine;
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol$k("asyncIterator");
var defineWellKnownSymbol$j = wellKnownSymbolDefine;
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol$j("hasInstance");
var defineWellKnownSymbol$i = wellKnownSymbolDefine;
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol$i("isConcatSpreadable");
var defineWellKnownSymbol$h = wellKnownSymbolDefine;
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol$h("iterator");
var defineWellKnownSymbol$g = wellKnownSymbolDefine;
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol$g("match");
var defineWellKnownSymbol$f = wellKnownSymbolDefine;
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol$f("matchAll");
var defineWellKnownSymbol$e = wellKnownSymbolDefine;
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol$e("replace");
var defineWellKnownSymbol$d = wellKnownSymbolDefine;
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol$d("search");
var defineWellKnownSymbol$c = wellKnownSymbolDefine;
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol$c("species");
var defineWellKnownSymbol$b = wellKnownSymbolDefine;
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol$b("split");
var defineWellKnownSymbol$a = wellKnownSymbolDefine;
var defineSymbolToPrimitive = symbolDefineToPrimitive;
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol$a("toPrimitive");
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();
var getBuiltIn$8 = getBuiltIn$f;
var defineWellKnownSymbol$9 = wellKnownSymbolDefine;
var setToStringTag$3 = setToStringTag$7;
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol$9("toStringTag");
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$3(getBuiltIn$8("Symbol"), "Symbol");
var defineWellKnownSymbol$8 = wellKnownSymbolDefine;
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol$8("unscopables");
var global$d = global$q;
var setToStringTag$2 = setToStringTag$7;
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag$2(global$d.JSON, "JSON", true);
var path$o = path$u;
var symbol$5 = path$o.Symbol;
var parent$1d = symbol$5;
var symbol$4 = parent$1d;
var wellKnownSymbol$8 = wellKnownSymbol$p;
var defineProperty$4 = objectDefineProperty.f;
var METADATA$1 = wellKnownSymbol$8("metadata");
var FunctionPrototype$1 = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if (FunctionPrototype$1[METADATA$1] === undefined) defineProperty$4(FunctionPrototype$1, METADATA$1, {
    value: null
});
var defineWellKnownSymbol$7 = wellKnownSymbolDefine;
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
defineWellKnownSymbol$7("asyncDispose");
var defineWellKnownSymbol$6 = wellKnownSymbolDefine;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
defineWellKnownSymbol$6("dispose");
// TODO: Remove from `core-js@4`
var defineWellKnownSymbol$5 = wellKnownSymbolDefine;
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol$5("metadata");
var parent$1c = symbol$4;
var symbol$3 = parent$1c;
var getBuiltIn$7 = getBuiltIn$f;
var uncurryThis$f = functionUncurryThis;
var Symbol$4 = getBuiltIn$7("Symbol");
var keyFor = Symbol$4.keyFor;
var thisSymbolValue$1 = uncurryThis$f(Symbol$4.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
var symbolIsRegistered = Symbol$4.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return keyFor(thisSymbolValue$1(value)) !== undefined;
    } catch (error) {
        return false;
    }
};
var $$T = _export;
var isRegisteredSymbol$1 = symbolIsRegistered;
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$$T({
    target: "Symbol",
    stat: true
}, {
    isRegisteredSymbol: isRegisteredSymbol$1
});
var shared = sharedExports;
var getBuiltIn$6 = getBuiltIn$f;
var uncurryThis$e = functionUncurryThis;
var isSymbol = isSymbol$5;
var wellKnownSymbol$7 = wellKnownSymbol$p;
var Symbol$3 = getBuiltIn$6("Symbol");
var $isWellKnownSymbol = Symbol$3.isWellKnownSymbol;
var getOwnPropertyNames = getBuiltIn$6("Object", "getOwnPropertyNames");
var thisSymbolValue = uncurryThis$e(Symbol$3.prototype.valueOf);
var WellKnownSymbolsStore = shared("wks");
for(var i$1 = 0, symbolKeys = getOwnPropertyNames(Symbol$3), symbolKeysLength = symbolKeys.length; i$1 < symbolKeysLength; i$1++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var symbolKey = symbolKeys[i$1];
    if (isSymbol(Symbol$3[symbolKey])) wellKnownSymbol$7(symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
var symbolIsWellKnown = function isWellKnownSymbol(value) {
    if ($isWellKnownSymbol && $isWellKnownSymbol(value)) return true;
    try {
        var symbol = thisSymbolValue(value);
        for(var j = 0, keys = getOwnPropertyNames(WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            // eslint-disable-next-line eqeqeq -- polyfilled symbols case
            if (WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};
var $$S = _export;
var isWellKnownSymbol$1 = symbolIsWellKnown;
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$$S({
    target: "Symbol",
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: isWellKnownSymbol$1
});
var defineWellKnownSymbol$4 = wellKnownSymbolDefine;
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol$4("matcher");
var defineWellKnownSymbol$3 = wellKnownSymbolDefine;
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol$3("observable");
var $$R = _export;
var isRegisteredSymbol = symbolIsRegistered;
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$$R({
    target: "Symbol",
    stat: true,
    name: "isRegisteredSymbol"
}, {
    isRegistered: isRegisteredSymbol
});
var $$Q = _export;
var isWellKnownSymbol = symbolIsWellKnown;
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$$Q({
    target: "Symbol",
    stat: true,
    name: "isWellKnownSymbol",
    forced: true
}, {
    isWellKnown: isWellKnownSymbol
});
var defineWellKnownSymbol$2 = wellKnownSymbolDefine;
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
defineWellKnownSymbol$2("metadataKey");
// TODO: remove from `core-js@4`
var defineWellKnownSymbol$1 = wellKnownSymbolDefine;
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol$1("patternMatch");
// TODO: remove from `core-js@4`
var defineWellKnownSymbol = wellKnownSymbolDefine;
defineWellKnownSymbol("replaceAll");
var parent$1b = symbol$3;
// TODO: Remove from `core-js@4`
var symbol$2 = parent$1b;
var symbol$1 = symbol$2;
var _Symbol$1 = /*@__PURE__*/ getDefaultExportFromCjs(symbol$1);
var WrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var iterator$5 = WrappedWellKnownSymbolModule$1.f("iterator");
var parent$1a = iterator$5;
var iterator$4 = parent$1a;
var parent$19 = iterator$4;
var iterator$3 = parent$19;
var parent$18 = iterator$3;
var iterator$2 = parent$18;
var iterator$1 = iterator$2;
var _Symbol$iterator$1 = /*@__PURE__*/ getDefaultExportFromCjs(iterator$1);
function _typeof$1(o) {
    "@babel/helpers - typeof";
    return _typeof$1 = "function" == typeof _Symbol$1 && "symbol" == typeof _Symbol$iterator$1 ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof _Symbol$1 && o.constructor === _Symbol$1 && o !== _Symbol$1.prototype ? "symbol" : typeof o;
    }, _typeof$1(o);
}
var WrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var toPrimitive$4 = WrappedWellKnownSymbolModule.f("toPrimitive");
var parent$17 = toPrimitive$4;
var toPrimitive$3 = parent$17;
var parent$16 = toPrimitive$3;
var toPrimitive$2 = parent$16;
var parent$15 = toPrimitive$2;
var toPrimitive$1 = parent$15;
var toPrimitive = toPrimitive$1;
var _Symbol$toPrimitive = /*@__PURE__*/ getDefaultExportFromCjs(toPrimitive);
function _toPrimitive(input, hint) {
    if (_typeof$1(input) !== "object" || input === null) return input;
    var prim = input[_Symbol$toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof$1(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof$1(key) === "symbol" ? key : String(key);
}
function _defineProperties(target, props) {
    for(var i1 = 0; i1 < props.length; i1++){
        var descriptor = props[i1];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        _Object$defineProperty$1(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    _Object$defineProperty$1(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $$P = _export;
var isArray$a = isArray$e;
// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$$P({
    target: "Array",
    stat: true
}, {
    isArray: isArray$a
});
var path$n = path$u;
var isArray$9 = path$n.Array.isArray;
var parent$14 = isArray$9;
var isArray$8 = parent$14;
var parent$13 = isArray$8;
var isArray$7 = parent$13;
var parent$12 = isArray$7;
var isArray$6 = parent$12;
var isArray$5 = isArray$6;
var _Array$isArray$1 = /*@__PURE__*/ getDefaultExportFromCjs(isArray$5);
function _arrayWithHoles(arr) {
    if (_Array$isArray$1(arr)) return arr;
}
var DESCRIPTORS$9 = descriptors;
var isArray$4 = isArray$e;
var $TypeError$8 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$9 && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if (isArray$4(O) && !getOwnPropertyDescriptor$5(O, "length").writable) throw new $TypeError$8("Cannot set read only .length");
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};
var $$O = _export;
var toObject$8 = toObject$f;
var lengthOfArrayLike$8 = lengthOfArrayLike$e;
var setArrayLength$1 = arraySetLength;
var doesNotExceedSafeInteger$2 = doesNotExceedSafeInteger$4;
var fails$i = fails$y;
var INCORRECT_TO_LENGTH = fails$i(function() {
    return [].push.call({
        length: 0x100000000
    }, 1) !== 4294967297;
});
// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function() {
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).push();
    } catch (error) {
        return error instanceof TypeError;
    }
};
var FORCED$7 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();
// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$O({
    target: "Array",
    proto: true,
    arity: 1,
    forced: FORCED$7
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    push: function push(item) {
        var O = toObject$8(this);
        var len = lengthOfArrayLike$8(O);
        var argCount = arguments.length;
        doesNotExceedSafeInteger$2(len + argCount);
        for(var i1 = 0; i1 < argCount; i1++){
            O[len] = arguments[i1];
            len++;
        }
        setArrayLength$1(O, len);
        return len;
    }
});
var path$m = path$u;
var entryVirtual$o = function(CONSTRUCTOR) {
    return path$m[CONSTRUCTOR + "Prototype"];
};
var entryVirtual$n = entryVirtual$o;
var push$9 = entryVirtual$n("Array").push;
var isPrototypeOf$p = objectIsPrototypeOf;
var method$l = push$9;
var ArrayPrototype$k = Array.prototype;
var push$8 = function(it) {
    var own = it.push;
    return it === ArrayPrototype$k || isPrototypeOf$p(ArrayPrototype$k, it) && own === ArrayPrototype$k.push ? method$l : own;
};
var parent$11 = push$8;
var push$7 = parent$11;
var parent$10 = push$7;
var push$6 = parent$10;
var parent$$ = push$6;
var push$5 = parent$$;
var push$4 = push$5;
var _pushInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(push$4);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof _Symbol$1 && _getIteratorMethod$1(r) || r["@@iterator"];
    if (null != t) {
        var e, n, i1, u, a = [], f = !0, o = !1;
        try {
            if (i1 = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i1.call(t)).done) && (_pushInstanceProperty(a).call(a, e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
var $$N = _export;
var isArray$3 = isArray$e;
var isConstructor$1 = isConstructor$4;
var isObject$a = isObject$j;
var toAbsoluteIndex$2 = toAbsoluteIndex$5;
var lengthOfArrayLike$7 = lengthOfArrayLike$e;
var toIndexedObject$3 = toIndexedObject$b;
var createProperty$2 = createProperty$6;
var wellKnownSymbol$6 = wellKnownSymbol$p;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$5;
var nativeSlice = arraySlice$5;
var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$3("slice");
var SPECIES$3 = wellKnownSymbol$6("species");
var $Array = Array;
var max$1 = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$$N({
    target: "Array",
    proto: true,
    forced: !HAS_SPECIES_SUPPORT$3
}, {
    slice: function slice(start, end) {
        var O = toIndexedObject$3(this);
        var length = lengthOfArrayLike$7(O);
        var k = toAbsoluteIndex$2(start, length);
        var fin = toAbsoluteIndex$2(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if (isArray$3(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if (isConstructor$1(Constructor) && (Constructor === $Array || isArray$3(Constructor.prototype))) Constructor = undefined;
            else if (isObject$a(Constructor)) {
                Constructor = Constructor[SPECIES$3];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $Array || Constructor === undefined) return nativeSlice(O, k, fin);
        }
        result = new (Constructor === undefined ? $Array : Constructor)(max$1(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) createProperty$2(result, n, O[k]);
        result.length = n;
        return result;
    }
});
var entryVirtual$m = entryVirtual$o;
var slice$6 = entryVirtual$m("Array").slice;
var isPrototypeOf$o = objectIsPrototypeOf;
var method$k = slice$6;
var ArrayPrototype$j = Array.prototype;
var slice$5 = function(it) {
    var own = it.slice;
    return it === ArrayPrototype$j || isPrototypeOf$o(ArrayPrototype$j, it) && own === ArrayPrototype$j.slice ? method$k : own;
};
var parent$_ = slice$5;
var slice$4 = parent$_;
var parent$Z = slice$4;
var slice$3 = parent$Z;
var parent$Y = slice$3;
var slice$2 = parent$Y;
var slice$1 = slice$2;
var _sliceInstanceProperty$1 = /*@__PURE__*/ getDefaultExportFromCjs(slice$1);
var parent$X = from$4;
var from$2 = parent$X;
var parent$W = from$2;
var from$1 = parent$W;
var from = from$1;
var _Array$from = /*@__PURE__*/ getDefaultExportFromCjs(from);
function _arrayLikeToArray$8(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
function _unsupportedIterableToArray$8(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$8(o, minLen);
    var n = _sliceInstanceProperty$1(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i1) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i1) || _unsupportedIterableToArray$8(arr, i1) || _nonIterableRest();
}
function _arrayWithoutHoles(arr) {
    if (_Array$isArray$1(arr)) return _arrayLikeToArray$8(arr);
}
function _iterableToArray(iter) {
    if (typeof _Symbol$1 !== "undefined" && _getIteratorMethod$1(iter) != null || iter["@@iterator"] != null) return _Array$from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread();
}
var symbol = symbol$4;
var _Symbol = /*@__PURE__*/ getDefaultExportFromCjs(symbol);
var entryVirtual$l = entryVirtual$o;
var concat$6 = entryVirtual$l("Array").concat;
var isPrototypeOf$n = objectIsPrototypeOf;
var method$j = concat$6;
var ArrayPrototype$i = Array.prototype;
var concat$5 = function(it) {
    var own = it.concat;
    return it === ArrayPrototype$i || isPrototypeOf$n(ArrayPrototype$i, it) && own === ArrayPrototype$i.concat ? method$j : own;
};
var parent$V = concat$5;
var concat$4 = parent$V;
var concat$3 = concat$4;
var _concatInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(concat$3);
var slice = slice$4;
var _sliceInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(slice);
var getBuiltIn$5 = getBuiltIn$f;
var uncurryThis$d = functionUncurryThis;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$4 = anObject$d;
var concat$2 = uncurryThis$d([].concat);
// all object keys, includes non-enumerable and symbols
var ownKeys$8 = getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule$1.f(anObject$4(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};
var $$M = _export;
var ownKeys$7 = ownKeys$8;
// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$$M({
    target: "Reflect",
    stat: true
}, {
    ownKeys: ownKeys$7
});
var path$l = path$u;
var ownKeys$6 = path$l.Reflect.ownKeys;
var parent$U = ownKeys$6;
var ownKeys$5 = parent$U;
var ownKeys$4 = ownKeys$5;
var _Reflect$ownKeys = /*@__PURE__*/ getDefaultExportFromCjs(ownKeys$4);
var isArray$2 = isArray$8;
var _Array$isArray = /*@__PURE__*/ getDefaultExportFromCjs(isArray$2);
var $$L = _export;
var $map = arrayIteration.map;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$5;
var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$2("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$L({
    target: "Array",
    proto: true,
    forced: !HAS_SPECIES_SUPPORT$2
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$k = entryVirtual$o;
var map$6 = entryVirtual$k("Array").map;
var isPrototypeOf$m = objectIsPrototypeOf;
var method$i = map$6;
var ArrayPrototype$h = Array.prototype;
var map$5 = function(it) {
    var own = it.map;
    return it === ArrayPrototype$h || isPrototypeOf$m(ArrayPrototype$h, it) && own === ArrayPrototype$h.map ? method$i : own;
};
var parent$T = map$5;
var map$4 = parent$T;
var map$3 = map$4;
var _mapInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(map$3);
var $$K = _export;
var toObject$7 = toObject$f;
var nativeKeys = objectKeys$4;
var fails$h = fails$y;
var FAILS_ON_PRIMITIVES$2 = fails$h(function() {
    nativeKeys(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$$K({
    target: "Object",
    stat: true,
    forced: FAILS_ON_PRIMITIVES$2
}, {
    keys: function keys(it) {
        return nativeKeys(toObject$7(it));
    }
});
var path$k = path$u;
var keys$6 = path$k.Object.keys;
var parent$S = keys$6;
var keys$5 = parent$S;
var keys$4 = keys$5;
var _Object$keys = /*@__PURE__*/ getDefaultExportFromCjs(keys$4);
// TODO: Remove from `core-js@4`
var $$J = _export;
var uncurryThis$c = functionUncurryThis;
var $Date = Date;
var thisTimeValue = uncurryThis$c($Date.prototype.getTime);
// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$$J({
    target: "Date",
    stat: true
}, {
    now: function now() {
        return thisTimeValue(new $Date());
    }
});
var path$j = path$u;
var now$3 = path$j.Date.now;
var parent$R = now$3;
var now$2 = parent$R;
var now$1 = now$2;
var _Date$now = /*@__PURE__*/ getDefaultExportFromCjs(now$1);
var uncurryThis$b = functionUncurryThis;
var aCallable$9 = aCallable$e;
var isObject$9 = isObject$j;
var hasOwn$7 = hasOwnProperty_1;
var arraySlice$3 = arraySlice$5;
var NATIVE_BIND = functionBindNative;
var $Function = Function;
var concat$1 = uncurryThis$b([].concat);
var join = uncurryThis$b([].join);
var factories = {};
var construct$3 = function(C, argsLength, args) {
    if (!hasOwn$7(factories, argsLength)) {
        var list = [];
        var i1 = 0;
        for(; i1 < argsLength; i1++)list[i1] = "a[" + i1 + "]";
        factories[argsLength] = $Function("C,a", "return new C(" + join(list, ",") + ")");
    }
    return factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
var functionBind = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */ ) {
    var F = aCallable$9(this);
    var Prototype = F.prototype;
    var partArgs = arraySlice$3(arguments, 1);
    var boundFunction = function bound() {
        var args = concat$1(partArgs, arraySlice$3(arguments));
        return this instanceof boundFunction ? construct$3(F, args.length, args) : F.apply(that, args);
    };
    if (isObject$9(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};
// TODO: Remove from `core-js@4`
var $$I = _export;
var bind$e = functionBind;
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$$I({
    target: "Function",
    proto: true,
    forced: Function.bind !== bind$e
}, {
    bind: bind$e
});
var entryVirtual$j = entryVirtual$o;
var bind$d = entryVirtual$j("Function").bind;
var isPrototypeOf$l = objectIsPrototypeOf;
var method$h = bind$d;
var FunctionPrototype = Function.prototype;
var bind$c = function(it) {
    var own = it.bind;
    return it === FunctionPrototype || isPrototypeOf$l(FunctionPrototype, it) && own === FunctionPrototype.bind ? method$h : own;
};
var parent$Q = bind$c;
var bind$b = parent$Q;
var bind$a = bind$b;
var _bindInstanceProperty$1 = /*@__PURE__*/ getDefaultExportFromCjs(bind$a);
var fails$g = fails$y;
var arrayMethodIsStrict$6 = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && fails$g(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict$5 = arrayMethodIsStrict$6;
var STRICT_METHOD$3 = arrayMethodIsStrict$5("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$3 ? function forEach(callbackfn /* , thisArg */ ) {
    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;
var $$H = _export;
var forEach$9 = arrayForEach;
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$$H({
    target: "Array",
    proto: true,
    forced: [].forEach !== forEach$9
}, {
    forEach: forEach$9
});
var entryVirtual$i = entryVirtual$o;
var forEach$8 = entryVirtual$i("Array").forEach;
var parent$P = forEach$8;
var forEach$7 = parent$P;
var classof$6 = classof$g;
var hasOwn$6 = hasOwnProperty_1;
var isPrototypeOf$k = objectIsPrototypeOf;
var method$g = forEach$7;
var ArrayPrototype$g = Array.prototype;
var DOMIterables$3 = {
    DOMTokenList: true,
    NodeList: true
};
var forEach$6 = function(it) {
    var own = it.forEach;
    return it === ArrayPrototype$g || isPrototypeOf$k(ArrayPrototype$g, it) && own === ArrayPrototype$g.forEach || hasOwn$6(DOMIterables$3, classof$6(it)) ? method$g : own;
};
var forEach$5 = forEach$6;
var _forEachInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(forEach$5);
var $$G = _export;
var uncurryThis$a = functionUncurryThis;
var isArray$1 = isArray$e;
var nativeReverse = uncurryThis$a([].reverse);
var test$1 = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$$G({
    target: "Array",
    proto: true,
    forced: String(test$1) === String(test$1.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if (isArray$1(this)) this.length = this.length;
        return nativeReverse(this);
    }
});
var entryVirtual$h = entryVirtual$o;
var reverse$6 = entryVirtual$h("Array").reverse;
var isPrototypeOf$j = objectIsPrototypeOf;
var method$f = reverse$6;
var ArrayPrototype$f = Array.prototype;
var reverse$5 = function(it) {
    var own = it.reverse;
    return it === ArrayPrototype$f || isPrototypeOf$j(ArrayPrototype$f, it) && own === ArrayPrototype$f.reverse ? method$f : own;
};
var parent$O = reverse$5;
var reverse$4 = parent$O;
var reverse$3 = reverse$4;
var _reverseInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(reverse$3);
var tryToString$2 = tryToString$6;
var $TypeError$7 = TypeError;
var deletePropertyOrThrow$2 = function(O, P) {
    if (!delete O[P]) throw new $TypeError$7("Cannot delete property " + tryToString$2(P) + " of " + tryToString$2(O));
};
var $$F = _export;
var toObject$6 = toObject$f;
var toAbsoluteIndex$1 = toAbsoluteIndex$5;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$5;
var lengthOfArrayLike$6 = lengthOfArrayLike$e;
var setArrayLength = arraySetLength;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$4;
var arraySpeciesCreate$1 = arraySpeciesCreate$4;
var createProperty$1 = createProperty$6;
var deletePropertyOrThrow$1 = deletePropertyOrThrow$2;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$5;
var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1("splice");
var max = Math.max;
var min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$$F({
    target: "Array",
    proto: true,
    forced: !HAS_SPECIES_SUPPORT$1
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = toObject$6(this);
        var len = lengthOfArrayLike$6(O);
        var actualStart = toAbsoluteIndex$1(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = min(max(toIntegerOrInfinity$1(deleteCount), 0), len - actualStart);
        }
        doesNotExceedSafeInteger$1(len + insertCount - actualDeleteCount);
        A = arraySpeciesCreate$1(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) createProperty$1(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else deletePropertyOrThrow$1(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)deletePropertyOrThrow$1(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else deletePropertyOrThrow$1(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        setArrayLength(O, len - actualDeleteCount + insertCount);
        return A;
    }
});
var entryVirtual$g = entryVirtual$o;
var splice$3 = entryVirtual$g("Array").splice;
var isPrototypeOf$i = objectIsPrototypeOf;
var method$e = splice$3;
var ArrayPrototype$e = Array.prototype;
var splice$2 = function(it) {
    var own = it.splice;
    return it === ArrayPrototype$e || isPrototypeOf$i(ArrayPrototype$e, it) && own === ArrayPrototype$e.splice ? method$e : own;
};
var parent$N = splice$2;
var splice$1 = parent$N;
var splice = splice$1;
var _spliceInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(splice);
var DESCRIPTORS$8 = descriptors;
var uncurryThis$9 = functionUncurryThis;
var call$7 = functionCall;
var fails$f = fails$y;
var objectKeys$1 = objectKeys$4;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$5 = toObject$f;
var IndexedObject$1 = indexedObject;
// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$3 = Object.defineProperty;
var concat = uncurryThis$9([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$f(function() {
    // should have correct order of operations (Edge bug)
    if (DESCRIPTORS$8 && $assign({
        b: 1
    }, $assign(defineProperty$3({}, "a", {
        enumerable: true,
        get: function() {
            defineProperty$3(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = toObject$5(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = IndexedObject$1(arguments[index++]);
        var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!DESCRIPTORS$8 || call$7(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $assign;
var $$E = _export;
var assign$5 = objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$E({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== assign$5
}, {
    assign: assign$5
});
var path$i = path$u;
var assign$4 = path$i.Object.assign;
var parent$M = assign$4;
var assign$3 = parent$M;
var assign$2 = assign$3;
var _Object$assign = /*@__PURE__*/ getDefaultExportFromCjs(assign$2);
var $$D = _export;
var $includes = arrayIncludes.includes;
var fails$e = fails$y;
// FF99+ bug
var BROKEN_ON_SPARSE = fails$e(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$D({
    target: "Array",
    proto: true,
    forced: BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$f = entryVirtual$o;
var includes$4 = entryVirtual$f("Array").includes;
var isObject$8 = isObject$j;
var classof$5 = classofRaw$2;
var wellKnownSymbol$5 = wellKnownSymbol$p;
var MATCH$1 = wellKnownSymbol$5("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function(it) {
    var isRegExp;
    return isObject$8(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$5(it) === "RegExp");
};
var isRegExp = isRegexp;
var $TypeError$6 = TypeError;
var notARegexp = function(it) {
    if (isRegExp(it)) throw new $TypeError$6("The method doesn't accept regular expressions");
    return it;
};
var wellKnownSymbol$4 = wellKnownSymbol$p;
var MATCH = wellKnownSymbol$4("match");
var correctIsRegexpLogic = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $$C = _export;
var uncurryThis$8 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$6;
var toString$6 = toString$c;
var correctIsRegExpLogic = correctIsRegexpLogic;
var stringIndexOf = uncurryThis$8("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$C({
    target: "String",
    proto: true,
    forced: !correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~stringIndexOf(toString$6(requireObjectCoercible$2(this)), toString$6(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$e = entryVirtual$o;
var includes$3 = entryVirtual$e("String").includes;
var isPrototypeOf$h = objectIsPrototypeOf;
var arrayMethod = includes$4;
var stringMethod = includes$3;
var ArrayPrototype$d = Array.prototype;
var StringPrototype$1 = String.prototype;
var includes$2 = function(it) {
    var own = it.includes;
    if (it === ArrayPrototype$d || isPrototypeOf$h(ArrayPrototype$d, it) && own === ArrayPrototype$d.includes) return arrayMethod;
    if (typeof it == "string" || it === StringPrototype$1 || isPrototypeOf$h(StringPrototype$1, it) && own === StringPrototype$1.includes) return stringMethod;
    return own;
};
var parent$L = includes$2;
var includes$1 = parent$L;
var includes = includes$1;
var _includesInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(includes);
var $$B = _export;
var fails$d = fails$y;
var toObject$4 = toObject$f;
var nativeGetPrototypeOf = objectGetPrototypeOf$1;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
var FAILS_ON_PRIMITIVES$1 = fails$d(function() {
    nativeGetPrototypeOf(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$$B({
    target: "Object",
    stat: true,
    forced: FAILS_ON_PRIMITIVES$1,
    sham: !CORRECT_PROTOTYPE_GETTER
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return nativeGetPrototypeOf(toObject$4(it));
    }
});
var path$h = path$u;
var getPrototypeOf$6 = path$h.Object.getPrototypeOf;
var parent$K = getPrototypeOf$6;
var getPrototypeOf$5 = parent$K;
var getPrototypeOf$4 = getPrototypeOf$5;
var _Object$getPrototypeOf$1 = /*@__PURE__*/ getDefaultExportFromCjs(getPrototypeOf$4);
var $$A = _export;
var $filter = arrayIteration.filter;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$5;
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$A({
    target: "Array",
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$d = entryVirtual$o;
var filter$3 = entryVirtual$d("Array").filter;
var isPrototypeOf$g = objectIsPrototypeOf;
var method$d = filter$3;
var ArrayPrototype$c = Array.prototype;
var filter$2 = function(it) {
    var own = it.filter;
    return it === ArrayPrototype$c || isPrototypeOf$g(ArrayPrototype$c, it) && own === ArrayPrototype$c.filter ? method$d : own;
};
var parent$J = filter$2;
var filter$1 = parent$J;
var filter = filter$1;
var _filterInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(filter);
var DESCRIPTORS$7 = descriptors;
var fails$c = fails$y;
var uncurryThis$7 = functionUncurryThis;
var objectGetPrototypeOf = objectGetPrototypeOf$1;
var objectKeys = objectKeys$4;
var toIndexedObject$2 = toIndexedObject$b;
var $propertyIsEnumerable = objectPropertyIsEnumerable.f;
var propertyIsEnumerable = uncurryThis$7($propertyIsEnumerable);
var push$3 = uncurryThis$7([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS$7 && fails$c(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var createMethod$2 = function(TO_ENTRIES) {
    return function(it) {
        var O = toIndexedObject$2(it);
        var keys = objectKeys(O);
        var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
        var length = keys.length;
        var i1 = 0;
        var result = [];
        var key;
        while(length > i1){
            key = keys[i1++];
            if (!DESCRIPTORS$7 || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) push$3(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
var objectToArray = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: createMethod$2(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: createMethod$2(false)
};
var $$z = _export;
var $values = objectToArray.values;
// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$$z({
    target: "Object",
    stat: true
}, {
    values: function values(O) {
        return $values(O);
    }
});
var path$g = path$u;
var values$6 = path$g.Object.values;
var parent$I = values$6;
var values$5 = parent$I;
var values$4 = values$5;
var _Object$values2 = /*@__PURE__*/ getDefaultExportFromCjs(values$4);
// a string of all valid unicode whitespaces
var whitespaces$3 = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var uncurryThis$6 = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var toString$5 = toString$c;
var whitespaces$2 = whitespaces$3;
var replace$1 = uncurryThis$6("".replace);
var ltrim = RegExp("^[" + whitespaces$2 + "]+");
var rtrim = RegExp("(^|[^" + whitespaces$2 + "])[" + whitespaces$2 + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function(TYPE) {
    return function($this) {
        var string = toString$5(requireObjectCoercible$1($this));
        if (TYPE & 1) string = replace$1(string, ltrim, "");
        if (TYPE & 2) string = replace$1(string, rtrim, "$1");
        return string;
    };
};
var stringTrim = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: createMethod$1(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: createMethod$1(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: createMethod$1(3)
};
var global$c = global$q;
var fails$b = fails$y;
var uncurryThis$5 = functionUncurryThis;
var toString$4 = toString$c;
var trim$1 = stringTrim.trim;
var whitespaces$1 = whitespaces$3;
var $parseInt$1 = global$c.parseInt;
var Symbol$2 = global$c.Symbol;
var ITERATOR$1 = Symbol$2 && Symbol$2.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis$5(hex.exec);
var FORCED$6 = $parseInt$1(whitespaces$1 + "08") !== 8 || $parseInt$1(whitespaces$1 + "0x16") !== 22 || ITERATOR$1 && !fails$b(function() {
    $parseInt$1(Object(ITERATOR$1));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$6 ? function parseInt1(string, radix) {
    var S = trim$1(toString$4(string));
    return $parseInt$1(S, radix >>> 0 || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;
var $$y = _export;
var $parseInt = numberParseInt;
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$y({
    global: true,
    forced: parseInt !== $parseInt
}, {
    parseInt: $parseInt
});
var path$f = path$u;
var _parseInt$3 = path$f.parseInt;
var parent$H = _parseInt$3;
var _parseInt$2 = parent$H;
var _parseInt = _parseInt$2;
var _parseInt$1 = /*@__PURE__*/ getDefaultExportFromCjs(_parseInt);
/* eslint-disable es/no-array-prototype-indexof -- required for testing */ var $$x = _export;
var uncurryThis$4 = functionUncurryThisClause;
var $indexOf = arrayIncludes.indexOf;
var arrayMethodIsStrict$4 = arrayMethodIsStrict$6;
var nativeIndexOf = uncurryThis$4([].indexOf);
var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([
    1
], 1, -0) < 0;
var FORCED$5 = NEGATIVE_ZERO || !arrayMethodIsStrict$4("indexOf");
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$$x({
    target: "Array",
    proto: true,
    forced: FORCED$5
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return NEGATIVE_ZERO ? nativeIndexOf(this, searchElement, fromIndex) || 0 : $indexOf(this, searchElement, fromIndex);
    }
});
var entryVirtual$c = entryVirtual$o;
var indexOf$3 = entryVirtual$c("Array").indexOf;
var isPrototypeOf$f = objectIsPrototypeOf;
var method$c = indexOf$3;
var ArrayPrototype$b = Array.prototype;
var indexOf$2 = function(it) {
    var own = it.indexOf;
    return it === ArrayPrototype$b || isPrototypeOf$f(ArrayPrototype$b, it) && own === ArrayPrototype$b.indexOf ? method$c : own;
};
var parent$G = indexOf$2;
var indexOf$1 = parent$G;
var indexOf = indexOf$1;
var _indexOfInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(indexOf);
var $$w = _export;
var $entries = objectToArray.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$$w({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $entries(O);
    }
});
var path$e = path$u;
var entries$6 = path$e.Object.entries;
var parent$F = entries$6;
var entries$5 = parent$F;
var entries$4 = entries$5;
var _Object$entries2 = /*@__PURE__*/ getDefaultExportFromCjs(entries$4);
// TODO: Remove from `core-js@4`
var $$v = _export;
var DESCRIPTORS$6 = descriptors;
var create$9 = objectCreate;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$$v({
    target: "Object",
    stat: true,
    sham: !DESCRIPTORS$6
}, {
    create: create$9
});
var path$d = path$u;
var Object$3 = path$d.Object;
var create$8 = function create(P, D) {
    return Object$3.create(P, D);
};
var parent$E = create$8;
var create$7 = parent$E;
var create$6 = create$7;
var _Object$create$1 = /*@__PURE__*/ getDefaultExportFromCjs(create$6);
var path$c = path$u;
var apply$3 = functionApply;
// eslint-disable-next-line es/no-json -- safe
if (!path$c.JSON) path$c.JSON = {
    stringify: JSON.stringify
};
// eslint-disable-next-line no-unused-vars -- required for `.length`
var stringify$2 = function stringify(it, replacer, space) {
    return apply$3(path$c.JSON.stringify, null, arguments);
};
var parent$D = stringify$2;
var stringify$1 = parent$D;
var stringify = stringify$1;
var _JSON$stringify = /*@__PURE__*/ getDefaultExportFromCjs(stringify);
/* global Bun -- Deno case */ var engineIsBun = typeof Bun == "function" && Bun && typeof Bun.version == "string";
var $TypeError$5 = TypeError;
var validateArgumentsLength$2 = function(passed, required) {
    if (passed < required) throw new $TypeError$5("Not enough arguments");
    return passed;
};
var global$b = global$q;
var apply$2 = functionApply;
var isCallable$5 = isCallable$m;
var ENGINE_IS_BUN = engineIsBun;
var USER_AGENT = engineUserAgent;
var arraySlice$2 = arraySlice$5;
var validateArgumentsLength$1 = validateArgumentsLength$2;
var Function$2 = global$b.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && function() {
    var version = global$b.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
var schedulersFix$2 = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = validateArgumentsLength$1(arguments.length, 1) > firstParamIndex;
        var fn = isCallable$5(handler) ? handler : Function$2(handler);
        var params = boundArgs ? arraySlice$2(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            apply$2(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};
var $$u = _export;
var global$a = global$q;
var schedulersFix$1 = schedulersFix$2;
var setInterval$2 = schedulersFix$1(global$a.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$$u({
    global: true,
    bind: true,
    forced: global$a.setInterval !== setInterval$2
}, {
    setInterval: setInterval$2
});
var $$t = _export;
var global$9 = global$q;
var schedulersFix = schedulersFix$2;
var setTimeout$3 = schedulersFix(global$9.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$$t({
    global: true,
    bind: true,
    forced: global$9.setTimeout !== setTimeout$3
}, {
    setTimeout: setTimeout$3
});
var path$b = path$u;
var setTimeout$2 = path$b.setTimeout;
var setTimeout$1 = setTimeout$2;
var _setTimeout = /*@__PURE__*/ getDefaultExportFromCjs(setTimeout$1);
var toObject$3 = toObject$f;
var toAbsoluteIndex = toAbsoluteIndex$5;
var lengthOfArrayLike$5 = lengthOfArrayLike$e;
// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */ ) {
    var O = toObject$3(this);
    var length = lengthOfArrayLike$5(O);
    var argumentsLength = arguments.length;
    var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};
var $$s = _export;
var fill$4 = arrayFill;
// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$$s({
    target: "Array",
    proto: true
}, {
    fill: fill$4
});
var entryVirtual$b = entryVirtual$o;
var fill$3 = entryVirtual$b("Array").fill;
var isPrototypeOf$e = objectIsPrototypeOf;
var method$b = fill$3;
var ArrayPrototype$a = Array.prototype;
var fill$2 = function(it) {
    var own = it.fill;
    return it === ArrayPrototype$a || isPrototypeOf$e(ArrayPrototype$a, it) && own === ArrayPrototype$a.fill ? method$b : own;
};
var parent$C = fill$2;
var fill$1 = parent$C;
var fill = fill$1;
var _fillInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(fill);
var componentEmitter = {
    exports: {}
};
(function(module) {
    module.exports = Emitter;
    /**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */ function Emitter(obj) {
        if (obj) return mixin(obj);
    }
    /**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */ function mixin(obj) {
        for(var key in Emitter.prototype)obj[key] = Emitter.prototype[key];
        return obj;
    }
    /**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */ Emitter.prototype.on = Emitter.prototype.addEventListener = function(event1, fn) {
        this._callbacks = this._callbacks || {};
        (this._callbacks["$" + event1] = this._callbacks["$" + event1] || []).push(fn);
        return this;
    };
    /**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */ Emitter.prototype.once = function(event1, fn) {
        function on() {
            this.off(event1, on);
            fn.apply(this, arguments);
        }
        on.fn = fn;
        this.on(event1, on);
        return this;
    };
    /**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */ Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event1, fn) {
        this._callbacks = this._callbacks || {};
        // all
        if (0 == arguments.length) {
            this._callbacks = {};
            return this;
        }
        // specific event
        var callbacks = this._callbacks["$" + event1];
        if (!callbacks) return this;
        // remove all handlers
        if (1 == arguments.length) {
            delete this._callbacks["$" + event1];
            return this;
        }
        // remove specific handler
        var cb;
        for(var i1 = 0; i1 < callbacks.length; i1++){
            cb = callbacks[i1];
            if (cb === fn || cb.fn === fn) {
                callbacks.splice(i1, 1);
                break;
            }
        }
        // Remove event specific arrays for event types that no
        // one is subscribed for to avoid memory leak.
        if (callbacks.length === 0) delete this._callbacks["$" + event1];
        return this;
    };
    /**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */ Emitter.prototype.emit = function(event1) {
        this._callbacks = this._callbacks || {};
        var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event1];
        for(var i1 = 1; i1 < arguments.length; i1++)args[i1 - 1] = arguments[i1];
        if (callbacks) {
            callbacks = callbacks.slice(0);
            for(var i1 = 0, len = callbacks.length; i1 < len; ++i1)callbacks[i1].apply(this, args);
        }
        return this;
    };
    /**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */ Emitter.prototype.listeners = function(event1) {
        this._callbacks = this._callbacks || {};
        return this._callbacks["$" + event1] || [];
    };
    /**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */ Emitter.prototype.hasListeners = function(event1) {
        return !!this.listeners(event1).length;
    };
})(componentEmitter);
var componentEmitterExports = componentEmitter.exports;
var Emitter = /*@__PURE__*/ getDefaultExportFromCjs(componentEmitterExports);
/*! Hammer.JS - v2.0.17-rc - 2019-12-16
 * http://naver.github.io/egjs
 *
 * Forked By Naver egjs
 * Copyright (c) hammerjs
 * Licensed under the MIT license */ function _extends() {
    _extends = Object.assign || function(target) {
        for(var i1 = 1; i1 < arguments.length; i1++){
            var source = arguments[i1];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized$1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
if (typeof Object.assign !== "function") assign = function assign(target) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    for(var index = 1; index < arguments.length; index++){
        var source = arguments[index];
        if (source !== undefined && source !== null) {
            for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
        }
    }
    return output;
};
else assign = Object.assign;
var assign$1 = assign;
var VENDOR_PREFIXES = [
    "",
    "webkit",
    "Moz",
    "MS",
    "ms",
    "o"
];
var TEST_ELEMENT = typeof document === "undefined" ? {
    style: {}
} : document.createElement("div");
var TYPE_FUNCTION = "function";
var round = Math.round, abs = Math.abs;
var now = Date.now;
/**
 * @private
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
    var prefix;
    var prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);
    var i1 = 0;
    while(i1 < VENDOR_PREFIXES.length){
        prefix = VENDOR_PREFIXES[i1];
        prop = prefix ? prefix + camelProp : property;
        if (prop in obj) return prop;
        i1++;
    }
    return undefined;
}
/* eslint-disable no-new-func, no-nested-ternary */ var win;
if (typeof window === "undefined") // window is undefined in node.js
win = {};
else win = window;
var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) return false;
    var touchMap = {};
    var cssSupports = win.CSS && win.CSS.supports;
    [
        "auto",
        "manipulation",
        "pan-y",
        "pan-x",
        "pan-x pan-y",
        "none"
    ].forEach(function(val) {
        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        return touchMap[val] = cssSupports ? win.CSS.supports("touch-action", val) : true;
    });
    return touchMap;
}
var TOUCH_ACTION_COMPUTE = "compute";
var TOUCH_ACTION_AUTO = "auto";
var TOUCH_ACTION_MANIPULATION = "manipulation"; // not implemented
var TOUCH_ACTION_NONE = "none";
var TOUCH_ACTION_PAN_X = "pan-x";
var TOUCH_ACTION_PAN_Y = "pan-y";
var TOUCH_ACTION_MAP = getTouchActionProps();
var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
var SUPPORT_TOUCH = "ontouchstart" in win;
var SUPPORT_POINTER_EVENTS = prefixed(win, "PointerEvent") !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
var INPUT_TYPE_TOUCH = "touch";
var INPUT_TYPE_PEN = "pen";
var INPUT_TYPE_MOUSE = "mouse";
var INPUT_TYPE_KINECT = "kinect";
var COMPUTE_INTERVAL = 25;
var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;
var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;
var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
var PROPS_XY = [
    "x",
    "y"
];
var PROPS_CLIENT_XY = [
    "clientX",
    "clientY"
];
/**
 * @private
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
    var i1;
    if (!obj) return;
    if (obj.forEach) obj.forEach(iterator, context);
    else if (obj.length !== undefined) {
        i1 = 0;
        while(i1 < obj.length){
            iterator.call(context, obj[i1], i1, obj);
            i1++;
        }
    } else for(i1 in obj)obj.hasOwnProperty(i1) && iterator.call(context, obj[i1], i1, obj);
}
/**
 * @private
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
    if (typeof val === TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
    return val;
}
/**
 * @private
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
    return str.indexOf(find) > -1;
}
/**
 * @private
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
     // pan-x OR pan-y
    if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
     // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
    return TOUCH_ACTION_AUTO;
}
/**
 * @private
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ var TouchAction = /*#__PURE__*/ function() {
    function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    /**
   * @private
   * set the touchAction value on the element or enable the polyfill
   * @param {String} value
   */ var _proto = TouchAction.prototype;
    _proto.set = function set(value) {
        // find out the touch-action by the event handlers
        if (value === TOUCH_ACTION_COMPUTE) value = this.compute();
        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        this.actions = value.toLowerCase().trim();
    };
    /**
   * @private
   * just re-set the touchAction value
   */ _proto.update = function update() {
        this.set(this.manager.options.touchAction);
    };
    /**
   * @private
   * compute the value for the touchAction property based on the recognizer's settings
   * @returns {String} value
   */ _proto.compute = function compute() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [
                recognizer
            ])) actions = actions.concat(recognizer.getTouchAction());
        });
        return cleanTouchActions(actions.join(" "));
    };
    /**
   * @private
   * this method is called on each input cycle and provides the preventing of the browser behavior
   * @param {Object} input
   */ _proto.preventDefaults = function preventDefaults(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection; // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }
        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
        if (hasNone) {
            // do not prevent defaults if this is a tap gesture
            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;
            if (isTapPointer && isTapMovement && isTapTouchTime) return;
        }
        if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
        return;
        if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
    };
    /**
   * @private
   * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
   * @param {Object} srcEvent
   */ _proto.preventSrc = function preventSrc(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    };
    return TouchAction;
}();
/**
 * @private
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent$1(node, parent) {
    while(node){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
}
/**
 * @private
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
    var pointersLength = pointers.length; // no need to loop when only one touch
    if (pointersLength === 1) return {
        x: round(pointers[0].clientX),
        y: round(pointers[0].clientY)
    };
    var x = 0;
    var y = 0;
    var i1 = 0;
    while(i1 < pointersLength){
        x += pointers[i1].clientX;
        y += pointers[i1].clientY;
        i1++;
    }
    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}
/**
 * @private
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i1 = 0;
    while(i1 < input.pointers.length){
        pointers[i1] = {
            clientX: round(input.pointers[i1].clientX),
            clientY: round(input.pointers[i1].clientY)
        };
        i1++;
    }
    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}
/**
 * @private
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
    if (!props) props = PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.sqrt(x * x + y * y);
}
/**
 * @private
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
    if (!props) props = PROPS_XY;
    var x = p2[props[0]] - p1[props[0]];
    var y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}
/**
 * @private
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
    if (x === y) return DIRECTION_NONE;
    if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}
function computeDeltaXY(session, input) {
    var center = input.center; // let { offsetDelta:offset = {}, prevDelta = {}, prevInput = {} } = session;
    // jscs throwing error on defalut destructured values and without defaults tests fail
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};
    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }
    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}
/**
 * @private
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}
/**
 * @private
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}
/**
 * @private
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}
/**
 * @private
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input;
    var deltaTime = input.timeStamp - last.timeStamp;
    var velocity;
    var velocityX;
    var velocityY;
    var direction;
    if (input.eventType !== INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);
        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }
    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}
/**
* @private
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length; // store the first input to calculate the distance and direction
    if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
     // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
    else if (pointersLength === 1) session.firstMultiple = false;
    var firstInput = session.firstInput, firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;
    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);
    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
    input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
    computeIntervalInputData(session, input); // find the correct target
    var target = manager.element;
    var srcEvent = input.srcEvent;
    var srcEventTarget;
    if (srcEvent.composedPath) srcEventTarget = srcEvent.composedPath()[0];
    else if (srcEvent.path) srcEventTarget = srcEvent.path[0];
    else srcEventTarget = srcEvent.target;
    if (hasParent$1(srcEventTarget, target)) target = srcEventTarget;
    input.target = target;
}
/**
 * @private
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
    var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;
    if (isFirst) manager.session = {};
     // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType; // compute scale, rotation etc
    computeInputData(manager, input); // emit secret event
    manager.emit("hammer.input", input);
    manager.recognize(input);
    manager.session.prevInput = input;
}
/**
 * @private
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
    return str.trim().split(/\s+/g);
}
/**
 * @private
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}
/**
 * @private
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}
/**
 * @private
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return doc.defaultView || doc.parentWindow || window;
}
/**
 * @private
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ var Input = /*#__PURE__*/ function() {
    function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    /**
   * @private
   * should handle the inputEvent data and trigger the callback
   * @virtual
   */ var _proto = Input.prototype;
    _proto.handler = function handler() {};
    /**
   * @private
   * bind the events
   */ _proto.init = function init() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    /**
   * @private
   * unbind the events
   */ _proto.destroy = function destroy() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    };
    return Input;
}();
/**
 * @private
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) return src.indexOf(find);
    else {
        var i1 = 0;
        while(i1 < src.length){
            if (findByKey && src[i1][findByKey] == find || !findByKey && src[i1] === find) // do not use === here, test fails
            return i1;
            i1++;
        }
        return -1;
    }
}
var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
}; // in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};
var POINTER_ELEMENT_EVENTS = "pointerdown";
var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel"; // IE10 has prefixed support, and case-sensitive
if (win.MSPointerEvent && !win.PointerEvent) {
    POINTER_ELEMENT_EVENTS = "MSPointerDown";
    POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
}
/**
 * @private
 * Pointer events input
 * @constructor
 * @extends Input
 */ var PointerEventInput = /*#__PURE__*/ function(_Input) {
    _inheritsLoose(PointerEventInput, _Input);
    function PointerEventInput() {
        var _this;
        var proto = PointerEventInput.prototype;
        proto.evEl = POINTER_ELEMENT_EVENTS;
        proto.evWin = POINTER_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.store = _this.manager.session.pointerEvents = [];
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = PointerEventInput.prototype;
    _proto.handler = function handler(ev) {
        var store = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch = pointerType === INPUT_TYPE_TOUCH; // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, "pointerId"); // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
         // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) return;
         // update the event in the store
        store[storeIndex] = ev;
        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [
                ev
            ],
            pointerType: pointerType,
            srcEvent: ev
        });
        if (removePointer) // remove from the store
        store.splice(storeIndex, 1);
    };
    return PointerEventInput;
}(Input);
/**
 * @private
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray$1(obj) {
    return Array.prototype.slice.call(obj, 0);
}
/**
 * @private
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i1 = 0;
    while(i1 < src.length){
        var val = key ? src[i1][key] : src[i1];
        if (inArray(values, val) < 0) results.push(src[i1]);
        values[i1] = val;
        i1++;
    }
    if (sort) {
        if (!key) results = results.sort();
        else results = results.sort(function(a, b) {
            return a[key] > b[key];
        });
    }
    return results;
}
var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};
var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
/**
 * @private
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ var TouchInput = /*#__PURE__*/ function(_Input) {
    _inheritsLoose(TouchInput, _Input);
    function TouchInput() {
        var _this;
        TouchInput.prototype.evTarget = TOUCH_TARGET_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.targetIds = {}; // this.evTarget = TOUCH_TARGET_EVENTS;
        return _this;
    }
    var _proto = TouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) return;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return TouchInput;
}(Input);
function getTouches(ev, type) {
    var allTouches = toArray$1(ev.touches);
    var targetIds = this.targetIds; // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [
            allTouches,
            allTouches
        ];
    }
    var i1;
    var targetTouches;
    var changedTouches = toArray$1(ev.changedTouches);
    var changedTargetTouches = [];
    var target = this.target; // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent$1(touch.target, target);
    }); // collect touches
    if (type === INPUT_START) {
        i1 = 0;
        while(i1 < targetTouches.length){
            targetIds[targetTouches[i1].identifier] = true;
            i1++;
        }
    } // filter changed touches to only contain touches that exist in the collected target ids
    i1 = 0;
    while(i1 < changedTouches.length){
        if (targetIds[changedTouches[i1].identifier]) changedTargetTouches.push(changedTouches[i1]);
         // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i1].identifier];
        i1++;
    }
    if (!changedTargetTouches.length) return;
    return [
        uniqueArray(targetTouches.concat(changedTargetTouches), "identifier", true),
        changedTargetTouches
    ];
}
var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};
var MOUSE_ELEMENT_EVENTS = "mousedown";
var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
/**
 * @private
 * Mouse events input
 * @constructor
 * @extends Input
 */ var MouseInput = /*#__PURE__*/ function(_Input) {
    _inheritsLoose(MouseInput, _Input);
    function MouseInput() {
        var _this;
        var proto = MouseInput.prototype;
        proto.evEl = MOUSE_ELEMENT_EVENTS;
        proto.evWin = MOUSE_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.pressed = false; // mousedown state
        return _this;
    }
    /**
   * @private
   * handle mouse events
   * @param {Object} ev
   */ var _proto = MouseInput.prototype;
    _proto.handler = function handler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
        if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
         // mouse must be down
        if (!this.pressed) return;
        if (eventType & INPUT_END) this.pressed = false;
        this.callback(this.manager, eventType, {
            pointers: [
                ev
            ],
            changedPointers: [
                ev
            ],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    };
    return MouseInput;
}(Input);
/**
 * @private
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;
function setLastTouch(eventData) {
    var _eventData$changedPoi = eventData.changedPointers, touch = _eventData$changedPoi[0];
    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {
            x: touch.clientX,
            y: touch.clientY
        };
        var lts = this.lastTouches;
        this.lastTouches.push(lastTouch);
        var removeLastTouch = function removeLastTouch() {
            var i1 = lts.indexOf(lastTouch);
            if (i1 > -1) lts.splice(i1, 1);
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}
function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
}
function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX;
    var y = eventData.srcEvent.clientY;
    for(var i1 = 0; i1 < this.lastTouches.length; i1++){
        var t = this.lastTouches[i1];
        var dx = Math.abs(x - t.x);
        var dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
    }
    return false;
}
var TouchMouseInput = /*#__PURE__*/ function() {
    var TouchMouseInput = /*#__PURE__*/ function(_Input) {
        _inheritsLoose(TouchMouseInput, _Input);
        function TouchMouseInput(_manager, callback) {
            var _this;
            _this = _Input.call(this, _manager, callback) || this;
            _this.handler = function(manager, inputEvent, inputData) {
                var isTouch = inputData.pointerType === INPUT_TYPE_TOUCH;
                var isMouse = inputData.pointerType === INPUT_TYPE_MOUSE;
                if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
                 // when we're in a touch event, record touches to  de-dupe synthetic mouse event
                if (isTouch) recordTouches.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputEvent, inputData);
                else if (isMouse && isSyntheticEvent.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputData)) return;
                _this.callback(manager, inputEvent, inputData);
            };
            _this.touch = new TouchInput(_this.manager, _this.handler);
            _this.mouse = new MouseInput(_this.manager, _this.handler);
            _this.primaryTouch = null;
            _this.lastTouches = [];
            return _this;
        }
        /**
     * @private
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ var _proto = TouchMouseInput.prototype;
        /**
     * @private
     * remove the event listeners
     */ _proto.destroy = function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        };
        return TouchMouseInput;
    }(Input);
    return TouchMouseInput;
}();
/**
 * @private
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
    var Type; // let inputClass = manager.options.inputClass;
    var inputClass = manager.options.inputClass;
    if (inputClass) Type = inputClass;
    else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
    else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
    else if (!SUPPORT_TOUCH) Type = MouseInput;
    else Type = TouchMouseInput;
    return new Type(manager, inputHandler);
}
/**
 * @private
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;
/**
 * @private
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}
/**
 * @private
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) return manager.get(otherRecognizer);
    return otherRecognizer;
}
/**
 * @private
 * get a usable string, used as event postfix
 * @param {constant} state
 * @returns {String} state
 */ function stateStr(state) {
    if (state & STATE_CANCELLED) return "cancel";
    else if (state & STATE_ENDED) return "end";
    else if (state & STATE_CHANGED) return "move";
    else if (state & STATE_BEGAN) return "start";
    return "";
}
/**
 * @private
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ /**
 * @private
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ var Recognizer = /*#__PURE__*/ function() {
    function Recognizer(options) {
        if (options === void 0) options = {};
        this.options = _extends({
            enable: true
        }, options);
        this.id = uniqueId();
        this.manager = null; // default is enable true
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @return {Recognizer}
   */ var _proto = Recognizer.prototype;
    _proto.set = function set(options) {
        assign$1(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    };
    /**
   * @private
   * recognize simultaneous with an other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.recognizeWith = function recognizeWith(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) return this;
        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    };
    /**
   * @private
   * drop the simultaneous link. it doesnt remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) return this;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    };
    /**
   * @private
   * recognizer can only run when an other is failing
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.requireFailure = function requireFailure(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "requireFailure", this)) return this;
        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    };
    /**
   * @private
   * drop the requireFailure link. it does not remove the link on the other recognizer.
   * @param {Recognizer} otherRecognizer
   * @returns {Recognizer} this
   */ _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) return this;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) this.requireFail.splice(index, 1);
        return this;
    };
    /**
   * @private
   * has require failures boolean
   * @returns {boolean}
   */ _proto.hasRequireFailures = function hasRequireFailures() {
        return this.requireFail.length > 0;
    };
    /**
   * @private
   * if the recognizer can recognize simultaneous with an other recognizer
   * @param {Recognizer} otherRecognizer
   * @returns {Boolean}
   */ _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    };
    /**
   * @private
   * You should use `tryEmit` instead of `emit` directly to check
   * that all the needed recognizers has failed before emitting.
   * @param {Object} input
   */ _proto.emit = function emit(input) {
        var self1 = this;
        var state = this.state;
        function emit(event1) {
            self1.manager.emit(event1, input);
        } // 'panstart' and 'panmove'
        if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
        emit(self1.options.event); // simple 'eventName' events
        if (input.additionalEvent) // additional event(panleft, panright, pinchin, pinchout...)
        emit(input.additionalEvent);
         // panend and pancancel
        if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
    };
    /**
   * @private
   * Check that all the require failure recognizers has failed,
   * if true, it emits a gesture event,
   * otherwise, setup the state to FAILED.
   * @param {Object} input
   */ _proto.tryEmit = function tryEmit(input) {
        if (this.canEmit()) return this.emit(input);
         // it's failing anyway
        this.state = STATE_FAILED;
    };
    /**
   * @private
   * can we emit?
   * @returns {boolean}
   */ _proto.canEmit = function canEmit() {
        var i1 = 0;
        while(i1 < this.requireFail.length){
            if (!(this.requireFail[i1].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
            i1++;
        }
        return true;
    };
    /**
   * @private
   * update the recognizer
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign$1({}, inputData); // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [
            this,
            inputDataClone
        ])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        } // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
        this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
    };
    /**
   * @private
   * return the state of the recognizer
   * the actual recognizing happens in this method
   * @virtual
   * @param {Object} inputData
   * @returns {constant} STATE
   */ /* jshint ignore:start */ _proto.process = function process(inputData) {};
    /* jshint ignore:end */ /**
   * @private
   * return the preferred touch-action
   * @virtual
   * @returns {Array}
   */ _proto.getTouchAction = function getTouchAction() {};
    /**
   * @private
   * called when the gesture isn't allowed to recognize
   * like when another is being recognized or it is disabled
   * @virtual
   */ _proto.reset = function reset() {};
    return Recognizer;
}();
/**
 * @private
 * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ var TapRecognizer = /*#__PURE__*/ function(_Recognizer) {
    _inheritsLoose(TapRecognizer, _Recognizer);
    function TapRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, _extends({
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            // max time between the multi-tap taps
            time: 250,
            // max time of the pointer to be down (like finger on the screen)
            threshold: 9,
            // a minimal movement is ok, but keep it low
            posThreshold: 10
        }, options)) || this; // previous time and center,
        // used for tap counting
        _this.pTime = false;
        _this.pCenter = false;
        _this._timer = null;
        _this._input = null;
        _this.count = 0;
        return _this;
    }
    var _proto = TapRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            TOUCH_ACTION_MANIPULATION
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();
        if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
         // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType !== INPUT_END) return this.failTimeout();
            var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) this.count = 1;
            else this.count += 1;
            this._input = input; // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                else {
                    this._timer = setTimeout(function() {
                        _this2.state = STATE_RECOGNIZED;
                        _this2.tryEmit();
                    }, options.interval);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    };
    _proto.failTimeout = function failTimeout() {
        var _this3 = this;
        this._timer = setTimeout(function() {
            _this3.state = STATE_FAILED;
        }, this.options.interval);
        return STATE_FAILED;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit() {
        if (this.state === STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    };
    return TapRecognizer;
}(Recognizer);
/**
 * @private
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ var AttrRecognizer = /*#__PURE__*/ function(_Recognizer) {
    _inheritsLoose(AttrRecognizer, _Recognizer);
    function AttrRecognizer(options) {
        if (options === void 0) options = {};
        return _Recognizer.call(this, _extends({
            pointers: 1
        }, options)) || this;
    }
    /**
   * @private
   * Used to check if it the recognizer receives valid input, like input.distance > 10.
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {Boolean} recognized
   */ var _proto = AttrRecognizer.prototype;
    _proto.attrTest = function attrTest(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    };
    /**
   * @private
   * Process the input and return the state for the recognizer
   * @memberof AttrRecognizer
   * @param {Object} input
   * @returns {*} State
   */ _proto.process = function process(input) {
        var state = this.state;
        var eventType = input.eventType;
        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
        else if (isRecognized || isValid) {
            if (eventType & INPUT_END) return state | STATE_ENDED;
            else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    };
    return AttrRecognizer;
}(Recognizer);
/**
 * @private
 * direction cons to string
 * @param {constant} direction
 * @returns {String}
 */ function directionStr(direction) {
    if (direction === DIRECTION_DOWN) return "down";
    else if (direction === DIRECTION_UP) return "up";
    else if (direction === DIRECTION_LEFT) return "left";
    else if (direction === DIRECTION_RIGHT) return "right";
    return "";
}
/**
 * @private
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var PanRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    _inheritsLoose(PanRecognizer, _AttrRecognizer);
    function PanRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _AttrRecognizer.call(this, _extends({
            event: "pan",
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        }, options)) || this;
        _this.pX = null;
        _this.pY = null;
        return _this;
    }
    var _proto = PanRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
        if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
        return actions;
    };
    _proto.directionTest = function directionTest(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY; // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x !== this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y !== this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    };
    _proto.attrTest = function attrTest(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
    };
    _proto.emit = function emit(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = directionStr(input.direction);
        if (direction) input.additionalEvent = this.options.event + direction;
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PanRecognizer;
}(AttrRecognizer);
/**
 * @private
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ var SwipeRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    _inheritsLoose(SwipeRecognizer, _AttrRecognizer);
    function SwipeRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, _extends({
            event: "swipe",
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        }, options)) || this;
    }
    var _proto = SwipeRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    };
    _proto.attrTest = function attrTest(input) {
        var direction = this.options.direction;
        var velocity;
        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
        else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
        else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
        return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    };
    _proto.emit = function emit(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) this.manager.emit(this.options.event + direction, input);
        this.manager.emit(this.options.event, input);
    };
    return SwipeRecognizer;
}(AttrRecognizer);
/**
 * @private
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ var PinchRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    _inheritsLoose(PinchRecognizer, _AttrRecognizer);
    function PinchRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, _extends({
            event: "pinch",
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = PinchRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    };
    _proto.emit = function emit(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? "in" : "out";
            input.additionalEvent = this.options.event + inOut;
        }
        _AttrRecognizer.prototype.emit.call(this, input);
    };
    return PinchRecognizer;
}(AttrRecognizer);
/**
 * @private
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ var RotateRecognizer = /*#__PURE__*/ function(_AttrRecognizer) {
    _inheritsLoose(RotateRecognizer, _AttrRecognizer);
    function RotateRecognizer(options) {
        if (options === void 0) options = {};
        return _AttrRecognizer.call(this, _extends({
            event: "rotate",
            threshold: 0,
            pointers: 2
        }, options)) || this;
    }
    var _proto = RotateRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            TOUCH_ACTION_NONE
        ];
    };
    _proto.attrTest = function attrTest(input) {
        return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    };
    return RotateRecognizer;
}(AttrRecognizer);
/**
 * @private
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ var PressRecognizer = /*#__PURE__*/ function(_Recognizer) {
    _inheritsLoose(PressRecognizer, _Recognizer);
    function PressRecognizer(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _Recognizer.call(this, _extends({
            event: "press",
            pointers: 1,
            time: 251,
            // minimal time of the pointer to be pressed
            threshold: 9
        }, options)) || this;
        _this._timer = null;
        _this._input = null;
        return _this;
    }
    var _proto = PressRecognizer.prototype;
    _proto.getTouchAction = function getTouchAction() {
        return [
            TOUCH_ACTION_AUTO
        ];
    };
    _proto.process = function process(input) {
        var _this2 = this;
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;
        this._input = input; // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
        else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeout(function() {
                _this2.state = STATE_RECOGNIZED;
                _this2.tryEmit();
            }, options.time);
        } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
        return STATE_FAILED;
    };
    _proto.reset = function reset() {
        clearTimeout(this._timer);
    };
    _proto.emit = function emit(input) {
        if (this.state !== STATE_RECOGNIZED) return;
        if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + "up", input);
        else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    };
    return PressRecognizer;
}(Recognizer);
var defaults = {
    /**
   * @private
   * set if DOM events are being triggered.
   * But this is slower and unused by simple implementations, so disabled by default.
   * @type {Boolean}
   * @default false
   */ domEvents: false,
    /**
   * @private
   * The value for the touchAction property/fallback.
   * When set to `compute` it will magically set the correct value based on the added recognizers.
   * @type {String}
   * @default compute
   */ touchAction: TOUCH_ACTION_COMPUTE,
    /**
   * @private
   * @type {Boolean}
   * @default true
   */ enable: true,
    /**
   * @private
   * EXPERIMENTAL FEATURE -- can be removed/changed
   * Change the parent input target element.
   * If Null, then it is being set the to main element.
   * @type {Null|EventTarget}
   * @default null
   */ inputTarget: null,
    /**
   * @private
   * force an input class
   * @type {Null|Function}
   * @default null
   */ inputClass: null,
    /**
   * @private
   * Some CSS properties can be used to improve the working of Hammer.
   * Add them to this method and they will be set when creating a new Manager.
   * @namespace
   */ cssProps: {
        /**
     * @private
     * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userSelect: "none",
        /**
     * @private
     * Disable the Windows Phone grippers when pressing an element.
     * @type {String}
     * @default 'none'
     */ touchSelect: "none",
        /**
     * @private
     * Disables the default callout shown when you touch and hold a touch target.
     * On iOS, when you touch and hold a touch target such as a link, Safari displays
     * a callout containing information about the link. This property allows you to disable that callout.
     * @type {String}
     * @default 'none'
     */ touchCallout: "none",
        /**
     * @private
     * Specifies whether zooming is enabled. Used by IE10>
     * @type {String}
     * @default 'none'
     */ contentZooming: "none",
        /**
     * @private
     * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
     * @type {String}
     * @default 'none'
     */ userDrag: "none",
        /**
     * @private
     * Overrides the highlight color shown when the user taps a link or a JavaScript
     * clickable element in iOS. This property obeys the alpha value, if specified.
     * @type {String}
     * @default 'rgba(0,0,0,0)'
     */ tapHighlightColor: "rgba(0,0,0,0)"
    }
};
/**
 * @private
 * Default recognizer setup when calling `Hammer()`
 * When creating a new Manager these will be skipped.
 * This is separated with other defaults because of tree-shaking.
 * @type {Array}
 */ var preset = [
    [
        RotateRecognizer,
        {
            enable: false
        }
    ],
    [
        PinchRecognizer,
        {
            enable: false
        },
        [
            "rotate"
        ]
    ],
    [
        SwipeRecognizer,
        {
            direction: DIRECTION_HORIZONTAL
        }
    ],
    [
        PanRecognizer,
        {
            direction: DIRECTION_HORIZONTAL
        },
        [
            "swipe"
        ]
    ],
    [
        TapRecognizer
    ],
    [
        TapRecognizer,
        {
            event: "doubletap",
            taps: 2
        },
        [
            "tap"
        ]
    ],
    [
        PressRecognizer
    ]
];
var STOP = 1;
var FORCED_STOP = 2;
/**
 * @private
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) return;
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else element.style[prop] = manager.oldCssProps[prop] || "";
    });
    if (!add) manager.oldCssProps = {};
}
/**
 * @private
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event1, data) {
    var gestureEvent = document.createEvent("Event");
    gestureEvent.initEvent(event1, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}
/**
* @private
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var Manager = /*#__PURE__*/ function() {
    function Manager(element, options) {
        var _this = this;
        this.options = assign$1({}, defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = _this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    /**
   * @private
   * set options
   * @param {Object} options
   * @returns {Manager}
   */ var _proto = Manager.prototype;
    _proto.set = function set(options) {
        assign$1(this.options, options); // Options that need a little more setup
        if (options.touchAction) this.touchAction.update();
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    };
    /**
   * @private
   * stop recognizing for this session.
   * This session will be discarded, when a new [input]start event is fired.
   * When forced, the recognizer cycle is stopped immediately.
   * @param {Boolean} [force]
   */ _proto.stop = function stop(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    };
    /**
   * @private
   * run the recognizers!
   * called by the inputHandler function on every movement of the pointers (touches)
   * it walks through all the recognizers and tries to detect the gesture that is being made
   * @param {Object} inputData
   */ _proto.recognize = function recognize(inputData) {
        var session = this.session;
        if (session.stopped) return;
         // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
            session.curRecognizer = null;
            curRecognizer = null;
        }
        var i1 = 0;
        while(i1 < recognizers.length){
            recognizer = recognizers[i1]; // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer === curRecognizer || // 2
            recognizer.canRecognizeWith(curRecognizer))) // 3
            recognizer.recognize(inputData);
            else recognizer.reset();
             // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                session.curRecognizer = recognizer;
                curRecognizer = recognizer;
            }
            i1++;
        }
    };
    /**
   * @private
   * get a recognizer by its event name.
   * @param {Recognizer|String} recognizer
   * @returns {Recognizer|Null}
   */ _proto.get = function get(recognizer) {
        if (recognizer instanceof Recognizer) return recognizer;
        var recognizers = this.recognizers;
        for(var i1 = 0; i1 < recognizers.length; i1++){
            if (recognizers[i1].options.event === recognizer) return recognizers[i1];
        }
        return null;
    };
    /**
   * @private add a recognizer to the manager
   * existing recognizers with the same event name will be removed
   * @param {Recognizer} recognizer
   * @returns {Recognizer|Manager}
   */ _proto.add = function add(recognizer) {
        if (invokeArrayArg(recognizer, "add", this)) return this;
         // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) this.remove(existing);
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
    };
    /**
   * @private
   * remove a recognizer by name or instance
   * @param {Recognizer|String} recognizer
   * @returns {Manager}
   */ _proto.remove = function remove(recognizer) {
        if (invokeArrayArg(recognizer, "remove", this)) return this;
        var targetRecognizer = this.get(recognizer); // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, targetRecognizer);
            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }
        return this;
    };
    /**
   * @private
   * bind event
   * @param {String} events
   * @param {Function} handler
   * @returns {EventEmitter} this
   */ _proto.on = function on(events, handler) {
        if (events === undefined || handler === undefined) return this;
        var handlers = this.handlers;
        each(splitStr(events), function(event1) {
            handlers[event1] = handlers[event1] || [];
            handlers[event1].push(handler);
        });
        return this;
    };
    /**
   * @private unbind event, leave emit blank to remove all handlers
   * @param {String} events
   * @param {Function} [handler]
   * @returns {EventEmitter} this
   */ _proto.off = function off(events, handler) {
        if (events === undefined) return this;
        var handlers = this.handlers;
        each(splitStr(events), function(event1) {
            if (!handler) delete handlers[event1];
            else handlers[event1] && handlers[event1].splice(inArray(handlers[event1], handler), 1);
        });
        return this;
    };
    /**
   * @private emit event to the listeners
   * @param {String} event
   * @param {Object} data
   */ _proto.emit = function emit(event1, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) triggerDomEvent(event1, data);
         // no handlers, so skip it all
        var handlers = this.handlers[event1] && this.handlers[event1].slice();
        if (!handlers || !handlers.length) return;
        data.type = event1;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };
        var i1 = 0;
        while(i1 < handlers.length){
            handlers[i1](data);
            i1++;
        }
    };
    /**
   * @private
   * destroy the manager and unbinds all events
   * it doesn't unbind dom events, that is the user own responsibility
   */ _proto.destroy = function destroy() {
        this.element && toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    };
    return Manager;
}();
var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};
var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
/**
 * @private
 * Touch events input
 * @constructor
 * @extends Input
 */ var SingleTouchInput = /*#__PURE__*/ function(_Input) {
    _inheritsLoose(SingleTouchInput, _Input);
    function SingleTouchInput() {
        var _this;
        var proto = SingleTouchInput.prototype;
        proto.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        proto.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        _this = _Input.apply(this, arguments) || this;
        _this.started = false;
        return _this;
    }
    var _proto = SingleTouchInput.prototype;
    _proto.handler = function handler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?
        if (type === INPUT_START) this.started = true;
        if (!this.started) return;
        var touches = normalizeSingleTouches.call(this, ev, type); // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    };
    return SingleTouchInput;
}(Input);
function normalizeSingleTouches(ev, type) {
    var all = toArray$1(ev.touches);
    var changed = toArray$1(ev.changedTouches);
    if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), "identifier", true);
    return [
        all,
        changed
    ];
}
/**
 * @private
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
    var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
    return function() {
        var e = new Error("get-stack-trace");
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
        var log = window.console && (window.console.warn || window.console.log);
        if (log) log.call(window.console, deprecationMessage, stack);
        return method.apply(this, arguments);
    };
}
/**
 * @private
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend$1 = deprecate(function(dest, src, merge) {
    var keys = Object.keys(src);
    var i1 = 0;
    while(i1 < keys.length){
        if (!merge || merge && dest[keys[i1]] === undefined) dest[keys[i1]] = src[keys[i1]];
        i1++;
    }
    return dest;
}, "extend", "Use `assign`.");
/**
 * @private
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge$1 = deprecate(function(dest, src) {
    return extend$1(dest, src, true);
}, "merge", "Use `assign`.");
/**
 * @private
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
    var baseP = base.prototype;
    var childP;
    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;
    if (properties) assign$1(childP, properties);
}
/**
 * @private
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}
/**
 * @private
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ var Hammer$3 = /*#__PURE__*/ function() {
    var Hammer = /**
    * @private
    * @const {string}
    */ function Hammer(element, options) {
        if (options === void 0) options = {};
        return new Manager(element, _extends({
            recognizers: preset.concat()
        }, options));
    };
    Hammer.VERSION = "2.0.17-rc";
    Hammer.DIRECTION_ALL = DIRECTION_ALL;
    Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
    Hammer.DIRECTION_LEFT = DIRECTION_LEFT;
    Hammer.DIRECTION_RIGHT = DIRECTION_RIGHT;
    Hammer.DIRECTION_UP = DIRECTION_UP;
    Hammer.DIRECTION_HORIZONTAL = DIRECTION_HORIZONTAL;
    Hammer.DIRECTION_VERTICAL = DIRECTION_VERTICAL;
    Hammer.DIRECTION_NONE = DIRECTION_NONE;
    Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
    Hammer.INPUT_START = INPUT_START;
    Hammer.INPUT_MOVE = INPUT_MOVE;
    Hammer.INPUT_END = INPUT_END;
    Hammer.INPUT_CANCEL = INPUT_CANCEL;
    Hammer.STATE_POSSIBLE = STATE_POSSIBLE;
    Hammer.STATE_BEGAN = STATE_BEGAN;
    Hammer.STATE_CHANGED = STATE_CHANGED;
    Hammer.STATE_ENDED = STATE_ENDED;
    Hammer.STATE_RECOGNIZED = STATE_RECOGNIZED;
    Hammer.STATE_CANCELLED = STATE_CANCELLED;
    Hammer.STATE_FAILED = STATE_FAILED;
    Hammer.Manager = Manager;
    Hammer.Input = Input;
    Hammer.TouchAction = TouchAction;
    Hammer.TouchInput = TouchInput;
    Hammer.MouseInput = MouseInput;
    Hammer.PointerEventInput = PointerEventInput;
    Hammer.TouchMouseInput = TouchMouseInput;
    Hammer.SingleTouchInput = SingleTouchInput;
    Hammer.Recognizer = Recognizer;
    Hammer.AttrRecognizer = AttrRecognizer;
    Hammer.Tap = TapRecognizer;
    Hammer.Pan = PanRecognizer;
    Hammer.Swipe = SwipeRecognizer;
    Hammer.Pinch = PinchRecognizer;
    Hammer.Rotate = RotateRecognizer;
    Hammer.Press = PressRecognizer;
    Hammer.on = addEventListeners;
    Hammer.off = removeEventListeners;
    Hammer.each = each;
    Hammer.merge = merge$1;
    Hammer.extend = extend$1;
    Hammer.bindFn = bindFn;
    Hammer.assign = assign$1;
    Hammer.inherit = inherit;
    Hammer.bindFn = bindFn;
    Hammer.prefixed = prefixed;
    Hammer.toArray = toArray$1;
    Hammer.inArray = inArray;
    Hammer.uniqueArray = uniqueArray;
    Hammer.splitStr = splitStr;
    Hammer.boolOrFn = boolOrFn;
    Hammer.hasParent = hasParent$1;
    Hammer.addEventListeners = addEventListeners;
    Hammer.removeEventListeners = removeEventListeners;
    Hammer.defaults = assign$1({}, defaults, {
        preset: preset
    });
    return Hammer;
}();
//  style loader but by script tag, not by the loader.
Hammer$3.defaults;
var Hammer$4 = Hammer$3;
function _createForOfIteratorHelper$7(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$7(o, minLen) {
    var _context17;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
    var n = _sliceInstanceProperty(_context17 = Object.prototype.toString.call(o)).call(_context17, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}
function _arrayLikeToArray$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
/**
 * Use this symbol to delete properies in deepObjectAssign.
 */ var DELETE = _Symbol("DELETE");
/**
 * Pure version of deepObjectAssign, it doesn't modify any of it's arguments.
 *
 * @param base - The base object that fullfils the whole interface T.
 * @param updates - Updates that may change or delete props.
 * @returns A brand new instance with all the supplied objects deeply merged.
 */ function pureDeepObjectAssign(base) {
    var _context;
    for(var _len = arguments.length, updates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)updates[_key - 1] = arguments[_key];
    return deepObjectAssign.apply(void 0, _concatInstanceProperty(_context = [
        {},
        base
    ]).call(_context, updates));
}
/**
 * Deep version of object assign with additional deleting by the DELETE symbol.
 *
 * @param values - Objects to be deeply merged.
 * @returns The first object from values.
 */ function deepObjectAssign() {
    var merged = deepObjectAssignNonentry.apply(void 0, arguments);
    stripDelete(merged);
    return merged;
}
/**
 * Deep version of object assign with additional deleting by the DELETE symbol.
 *
 * @remarks
 * This doesn't strip the DELETE symbols so they may end up in the final object.
 * @param values - Objects to be deeply merged.
 * @returns The first object from values.
 */ function deepObjectAssignNonentry() {
    for(var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)values[_key2] = arguments[_key2];
    if (values.length < 2) return values[0];
    else if (values.length > 2) {
        var _context2;
        return deepObjectAssignNonentry.apply(void 0, _concatInstanceProperty(_context2 = [
            deepObjectAssign(values[0], values[1])
        ]).call(_context2, _toConsumableArray(_sliceInstanceProperty(values).call(values, 2))));
    }
    var a = values[0];
    var b = values[1];
    if (a instanceof Date && b instanceof Date) {
        a.setTime(b.getTime());
        return a;
    }
    var _iterator = _createForOfIteratorHelper$7(_Reflect$ownKeys(b)), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var prop = _step.value;
            if (!Object.prototype.propertyIsEnumerable.call(b, prop)) ;
            else if (b[prop] === DELETE) delete a[prop];
            else if (a[prop] !== null && b[prop] !== null && _typeof$1(a[prop]) === "object" && _typeof$1(b[prop]) === "object" && !_Array$isArray(a[prop]) && !_Array$isArray(b[prop])) a[prop] = deepObjectAssignNonentry(a[prop], b[prop]);
            else a[prop] = clone(b[prop]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return a;
}
/**
 * Deep clone given object or array. In case of primitive simply return.
 *
 * @param a - Anything.
 * @returns Deep cloned object/array or unchanged a.
 */ function clone(a) {
    if (_Array$isArray(a)) return _mapInstanceProperty(a).call(a, function(value) {
        return clone(value);
    });
    else if (_typeof$1(a) === "object" && a !== null) {
        if (a instanceof Date) return new Date(a.getTime());
        return deepObjectAssignNonentry({}, a);
    } else return a;
}
/**
 * Strip DELETE from given object.
 *
 * @param a - Object which may contain DELETE but won't after this is executed.
 */ function stripDelete(a) {
    for(var _i = 0, _Object$keys$1 = _Object$keys(a); _i < _Object$keys$1.length; _i++){
        var prop = _Object$keys$1[_i];
        if (a[prop] === DELETE) delete a[prop];
        else if (_typeof$1(a[prop]) === "object" && a[prop] !== null) stripDelete(a[prop]);
    }
}
/**
 * Seedable, fast and reasonably good (not crypto but more than okay for our
 * needs) random number generator.
 *
 * @remarks
 * Adapted from {@link https://web.archive.org/web/20110429100736/http://baagoe.com:80/en/RandomMusings/javascript}.
 * Original algorithm created by Johannes Baagøe \<baagoe\@baagoe.com\> in 2010.
 */ /**
 * Create a seeded pseudo random generator based on Alea by Johannes Baagøe.
 *
 * @param seed - All supplied arguments will be used as a seed. In case nothing
 * is supplied the current time will be used to seed the generator.
 * @returns A ready to use seeded generator.
 */ function Alea() {
    for(var _len3 = arguments.length, seed = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)seed[_key3] = arguments[_key3];
    return AleaImplementation(seed.length ? seed : [
        _Date$now()
    ]);
}
/**
 * An implementation of [[Alea]] without user input validation.
 *
 * @param seed - The data that will be used to seed the generator.
 * @returns A ready to use seeded generator.
 */ function AleaImplementation(seed) {
    var _mashSeed = mashSeed(seed), _mashSeed2 = _slicedToArray(_mashSeed, 3), s0 = _mashSeed2[0], s1 = _mashSeed2[1], s2 = _mashSeed2[2];
    var c = 1;
    var random = function random() {
        var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
        s0 = s1;
        s1 = s2;
        return s2 = t - (c = t | 0);
    };
    random.uint32 = function() {
        return random() * 0x100000000;
    }; // 2^32
    random.fract53 = function() {
        return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16;
    }; // 2^-53
    random.algorithm = "Alea";
    random.seed = seed;
    random.version = "0.9";
    return random;
}
/**
 * Turn arbitrary data into values [[AleaImplementation]] can use to generate
 * random numbers.
 *
 * @param seed - Arbitrary data that will be used as the seed.
 * @returns Three numbers to use as initial values for [[AleaImplementation]].
 */ function mashSeed() {
    var mash = Mash();
    var s0 = mash(" ");
    var s1 = mash(" ");
    var s2 = mash(" ");
    for(var i1 = 0; i1 < arguments.length; i1++){
        s0 -= mash(i1 < 0 || arguments.length <= i1 ? undefined : arguments[i1]);
        if (s0 < 0) s0 += 1;
        s1 -= mash(i1 < 0 || arguments.length <= i1 ? undefined : arguments[i1]);
        if (s1 < 0) s1 += 1;
        s2 -= mash(i1 < 0 || arguments.length <= i1 ? undefined : arguments[i1]);
        if (s2 < 0) s2 += 1;
    }
    return [
        s0,
        s1,
        s2
    ];
}
/**
 * Create a new mash function.
 *
 * @returns A nonpure function that takes arbitrary [[Mashable]] data and turns
 * them into numbers.
 */ function Mash() {
    var n = 0xefc8249d;
    return function(data) {
        var string = data.toString();
        for(var i1 = 0; i1 < string.length; i1++){
            n += string.charCodeAt(i1);
            var h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000; // 2^32
        }
        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
    };
}
/**
 * Setup a mock hammer.js object, for unit testing.
 *
 * Inspiration: https://github.com/uber/deck.gl/pull/658
 *
 * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
 */ function hammerMock$1() {
    var noop = function noop() {};
    return {
        on: noop,
        off: noop,
        destroy: noop,
        emit: noop,
        get: function get() {
            return {
                set: noop
            };
        }
    };
}
var Hammer$1 = typeof window !== "undefined" ? window.Hammer || Hammer$4 : function() {
    // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
    return hammerMock$1();
};
/**
 * Turn an element into an clickToUse element.
 * When not active, the element has a transparent overlay. When the overlay is
 * clicked, the mode is changed to active.
 * When active, the element is displayed with a blue border around it, and
 * the interactive contents of the element can be used. When clicked outside
 * the element, the elements mode is changed to inactive.
 *
 * @param {Element} container
 * @class Activator
 */ function Activator$1(container) {
    var _this = this, _context3;
    this._cleanupQueue = [];
    this.active = false;
    this._dom = {
        container: container,
        overlay: document.createElement("div")
    };
    this._dom.overlay.classList.add("vis-overlay");
    this._dom.container.appendChild(this._dom.overlay);
    this._cleanupQueue.push(function() {
        _this._dom.overlay.parentNode.removeChild(_this._dom.overlay);
    });
    var hammer = Hammer$1(this._dom.overlay);
    hammer.on("tap", _bindInstanceProperty$1(_context3 = this._onTapOverlay).call(_context3, this));
    this._cleanupQueue.push(function() {
        hammer.destroy();
    // FIXME: cleaning up hammer instances doesn't work (Timeline not removed
    // from memory)
    });
    // block all touch events (except tap)
    var events = [
        "tap",
        "doubletap",
        "press",
        "pinch",
        "pan",
        "panstart",
        "panmove",
        "panend"
    ];
    _forEachInstanceProperty(events).call(events, function(event1) {
        hammer.on(event1, function(event1) {
            event1.srcEvent.stopPropagation();
        });
    });
    // attach a click event to the window, in order to deactivate when clicking outside the timeline
    if (document && document.body) {
        this._onClick = function(event1) {
            if (!_hasParent$1(event1.target, container)) _this.deactivate();
        };
        document.body.addEventListener("click", this._onClick);
        this._cleanupQueue.push(function() {
            document.body.removeEventListener("click", _this._onClick);
        });
    }
    // prepare escape key listener for deactivating when active
    this._escListener = function(event1) {
        if ("key" in event1 ? event1.key === "Escape" : event1.keyCode === 27 /* the keyCode is for IE11 */ ) _this.deactivate();
    };
}
// turn into an event emitter
Emitter(Activator$1.prototype);
// The currently active activator
Activator$1.current = null;
/**
 * Destroy the activator. Cleans up all created DOM and event listeners
 */ Activator$1.prototype.destroy = function() {
    var _context4, _context5;
    this.deactivate();
    var _iterator2 = _createForOfIteratorHelper$7(_reverseInstanceProperty(_context4 = _spliceInstanceProperty(_context5 = this._cleanupQueue).call(_context5, 0)).call(_context4)), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var callback = _step2.value;
            callback();
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
};
/**
 * Activate the element
 * Overlay is hidden, element is decorated with a blue shadow border
 */ Activator$1.prototype.activate = function() {
    // we allow only one active activator at a time
    if (Activator$1.current) Activator$1.current.deactivate();
    Activator$1.current = this;
    this.active = true;
    this._dom.overlay.style.display = "none";
    this._dom.container.classList.add("vis-active");
    this.emit("change");
    this.emit("activate");
    // ugly hack: bind ESC after emitting the events, as the Network rebinds all
    // keyboard events on a 'change' event
    document.body.addEventListener("keydown", this._escListener);
};
/**
 * Deactivate the element
 * Overlay is displayed on top of the element
 */ Activator$1.prototype.deactivate = function() {
    this.active = false;
    this._dom.overlay.style.display = "block";
    this._dom.container.classList.remove("vis-active");
    document.body.removeEventListener("keydown", this._escListener);
    this.emit("change");
    this.emit("deactivate");
};
/**
 * Handle a tap event: activate the container
 *
 * @param {Event}  event   The event
 * @private
 */ Activator$1.prototype._onTapOverlay = function(event1) {
    // activate the container
    this.activate();
    event1.srcEvent.stopPropagation();
};
/**
 * Test whether the element has the requested parent element somewhere in
 * its chain of parent nodes.
 *
 * @param {HTMLElement} element
 * @param {HTMLElement} parent
 * @returns {boolean} Returns true when the parent is found somewhere in the
 *                    chain of parent nodes.
 * @private
 */ function _hasParent$1(element, parent) {
    while(element){
        if (element === parent) return true;
        element = element.parentNode;
    }
    return false;
}
// utility functions
// parse ASP.Net Date pattern,
// for example '/Date(1198908717056)/' or '/Date(1198908717056-0700)/'
// code from http://momentjs.com/
var ASPDateRegex$1 = /^\/?Date\((-?\d+)/i;
// Color REs
var fullHexRE = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
var shortHexRE = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
var rgbRE = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i;
var rgbaRE = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;
/**
 * Test whether given object is a number.
 *
 * @param value - Input value of unknown type.
 * @returns True if number, false otherwise.
 */ function isNumber(value) {
    return value instanceof Number || typeof value === "number";
}
/**
 * Remove everything in the DOM object.
 *
 * @param DOMobject - Node whose child nodes will be recursively deleted.
 */ function recursiveDOMDelete(DOMobject) {
    if (DOMobject) while(DOMobject.hasChildNodes() === true){
        var child = DOMobject.firstChild;
        if (child) {
            recursiveDOMDelete(child);
            DOMobject.removeChild(child);
        }
    }
}
/**
 * Test whether given object is a string.
 *
 * @param value - Input value of unknown type.
 * @returns True if string, false otherwise.
 */ function isString(value) {
    return value instanceof String || typeof value === "string";
}
/**
 * Test whether given object is a object (not primitive or null).
 *
 * @param value - Input value of unknown type.
 * @returns True if not null object, false otherwise.
 */ function isObject$7(value) {
    return _typeof$1(value) === "object" && value !== null;
}
/**
 * Test whether given object is a Date, or a String containing a Date.
 *
 * @param value - Input value of unknown type.
 * @returns True if Date instance or string date representation, false otherwise.
 */ function isDate(value) {
    if (value instanceof Date) return true;
    else if (isString(value)) {
        // test whether this string contains a date
        var match = ASPDateRegex$1.exec(value);
        if (match) return true;
        else if (!isNaN(Date.parse(value))) return true;
    }
    return false;
}
/**
 * Copy property from b to a if property present in a.
 * If property in b explicitly set to null, delete it if `allowDeletion` set.
 *
 * Internal helper routine, should not be exported. Not added to `exports` for that reason.
 *
 * @param a - Target object.
 * @param b - Source object.
 * @param prop - Name of property to copy from b to a.
 * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
 */ function copyOrDelete(a, b, prop, allowDeletion) {
    var doDeletion = false;
    if (allowDeletion === true) doDeletion = b[prop] === null && a[prop] !== undefined;
    if (doDeletion) delete a[prop];
    else a[prop] = b[prop]; // Remember, this is a reference copy!
}
/**
 * Fill an object with a possibly partially defined other object.
 *
 * Only copies values for the properties already present in a.
 * That means an object is not created on a property if only the b object has it.
 *
 * @param a - The object that will have it's properties updated.
 * @param b - The object with property updates.
 * @param allowDeletion - If true, delete properties in a that are explicitly set to null in b.
 */ function fillIfDefined(a, b) {
    var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // NOTE: iteration of properties of a
    // NOTE: prototype properties iterated over as well
    for(var prop in a)if (b[prop] !== undefined) {
        if (b[prop] === null || _typeof$1(b[prop]) !== "object") // Note: typeof null === 'object'
        copyOrDelete(a, b, prop, allowDeletion);
        else {
            var aProp = a[prop];
            var bProp = b[prop];
            if (isObject$7(aProp) && isObject$7(bProp)) fillIfDefined(aProp, bProp, allowDeletion);
        }
    }
}
/**
 * Copy the values of all of the enumerable own properties from one or more source objects to a
 * target object. Returns the target object.
 *
 * @param target - The target object to copy to.
 * @param source - The source object from which to copy properties.
 * @returns The target object.
 */ var extend = _Object$assign;
/**
 * Extend object a with selected properties of object b or a series of objects.
 *
 * @remarks
 * Only properties with defined values are copied.
 * @param props - Properties to be copied to a.
 * @param a - The target.
 * @param others - The sources.
 * @returns Argument a.
 */ function selectiveExtend(props, a) {
    if (!_Array$isArray(props)) throw new Error("Array with property names expected as first argument");
    for(var _len4 = arguments.length, others = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++)others[_key4 - 2] = arguments[_key4];
    for(var _i2 = 0, _others = others; _i2 < _others.length; _i2++){
        var other = _others[_i2];
        for(var p = 0; p < props.length; p++){
            var prop = props[p];
            if (other && Object.prototype.hasOwnProperty.call(other, prop)) a[prop] = other[prop];
        }
    }
    return a;
}
/**
 * Extend object a with selected properties of object b.
 * Only properties with defined values are copied.
 *
 * @remarks
 * Previous version of this routine implied that multiple source objects could
 * be used; however, the implementation was **wrong**. Since multiple (\>1)
 * sources weren't used anywhere in the `vis.js` code, this has been removed
 * @param props - Names of first-level properties to copy over.
 * @param a - Target object.
 * @param b - Source object.
 * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
 * @returns Argument a.
 */ function selectiveDeepExtend(props, a, b) {
    var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // TODO: add support for Arrays to deepExtend
    if (_Array$isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var p = 0; p < props.length; p++){
        var prop = props[p];
        if (Object.prototype.hasOwnProperty.call(b, prop)) {
            if (b[prop] && b[prop].constructor === Object) {
                if (a[prop] === undefined) a[prop] = {};
                if (a[prop].constructor === Object) deepExtend(a[prop], b[prop], false, allowDeletion);
                else copyOrDelete(a, b, prop, allowDeletion);
            } else if (_Array$isArray(b[prop])) throw new TypeError("Arrays are not supported by deepExtend");
            else copyOrDelete(a, b, prop, allowDeletion);
        }
    }
    return a;
}
/**
 * Extend object `a` with properties of object `b`, ignoring properties which
 * are explicitly specified to be excluded.
 *
 * @remarks
 * The properties of `b` are considered for copying. Properties which are
 * themselves objects are are also extended. Only properties with defined
 * values are copied.
 * @param propsToExclude - Names of properties which should *not* be copied.
 * @param a - Object to extend.
 * @param b - Object to take properties from for extension.
 * @param allowDeletion - If true, delete properties in a that are explicitly
 * set to null in b.
 * @returns Argument a.
 */ function selectiveNotDeepExtend(propsToExclude, a, b) {
    var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // TODO: add support for Arrays to deepExtend
    // NOTE: array properties have an else-below; apparently, there is a problem here.
    if (_Array$isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var prop in b){
        if (!Object.prototype.hasOwnProperty.call(b, prop)) continue;
         // Handle local properties only
        if (_includesInstanceProperty(propsToExclude).call(propsToExclude, prop)) continue;
         // In exclusion list, skip
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop].constructor === Object) deepExtend(a[prop], b[prop]); // NOTE: allowDeletion not propagated!
            else copyOrDelete(a, b, prop, allowDeletion);
        } else if (_Array$isArray(b[prop])) {
            a[prop] = [];
            for(var i1 = 0; i1 < b[prop].length; i1++)a[prop].push(b[prop][i1]);
        } else copyOrDelete(a, b, prop, allowDeletion);
    }
    return a;
}
/**
 * Deep extend an object a with the properties of object b.
 *
 * @param a - Target object.
 * @param b - Source object.
 * @param protoExtend - If true, the prototype values will also be extended.
 * (That is the options objects that inherit from others will also get the
 * inherited options).
 * @param allowDeletion - If true, the values of fields that are null will be deleted.
 * @returns Argument a.
 */ function deepExtend(a, b) {
    var protoExtend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    for(var prop in b)if (Object.prototype.hasOwnProperty.call(b, prop) || protoExtend === true) {
        if (_typeof$1(b[prop]) === "object" && b[prop] !== null && _Object$getPrototypeOf$1(b[prop]) === Object.prototype) {
            if (a[prop] === undefined) a[prop] = deepExtend({}, b[prop], protoExtend); // NOTE: allowDeletion not propagated!
            else if (_typeof$1(a[prop]) === "object" && a[prop] !== null && _Object$getPrototypeOf$1(a[prop]) === Object.prototype) deepExtend(a[prop], b[prop], protoExtend); // NOTE: allowDeletion not propagated!
            else copyOrDelete(a, b, prop, allowDeletion);
        } else if (_Array$isArray(b[prop])) {
            var _context6;
            a[prop] = _sliceInstanceProperty(_context6 = b[prop]).call(_context6);
        } else copyOrDelete(a, b, prop, allowDeletion);
    }
    return a;
}
/**
 * Test whether all elements in two arrays are equal.
 *
 * @param a - First array.
 * @param b - Second array.
 * @returns True if both arrays have the same length and same elements (1 = '1').
 */ function equalArray(a, b) {
    if (a.length !== b.length) return false;
    for(var i1 = 0, len = a.length; i1 < len; i1++){
        if (a[i1] != b[i1]) return false;
    }
    return true;
}
/**
 * Get the type of an object, for example exports.getType([]) returns 'Array'.
 *
 * @param object - Input value of unknown type.
 * @returns Detected type.
 */ function getType(object) {
    var type = _typeof$1(object);
    if (type === "object") {
        if (object === null) return "null";
        if (object instanceof Boolean) return "Boolean";
        if (object instanceof Number) return "Number";
        if (object instanceof String) return "String";
        if (_Array$isArray(object)) return "Array";
        if (object instanceof Date) return "Date";
        return "Object";
    }
    if (type === "number") return "Number";
    if (type === "boolean") return "Boolean";
    if (type === "string") return "String";
    if (type === undefined) return "undefined";
    return type;
}
/**
 * Used to extend an array and copy it. This is used to propagate paths recursively.
 *
 * @param arr - First part.
 * @param newValue - The value to be aadded into the array.
 * @returns A new array with all items from arr and newValue (which is last).
 */ function copyAndExtendArray(arr, newValue) {
    var _context7;
    return _concatInstanceProperty(_context7 = []).call(_context7, _toConsumableArray(arr), [
        newValue
    ]);
}
/**
 * Used to extend an array and copy it. This is used to propagate paths recursively.
 *
 * @param arr - The array to be copied.
 * @returns Shallow copy of arr.
 */ function copyArray(arr) {
    return _sliceInstanceProperty(arr).call(arr);
}
/**
 * Retrieve the absolute left value of a DOM element.
 *
 * @param elem - A dom element, for example a div.
 * @returns The absolute left position of this element in the browser page.
 */ function getAbsoluteLeft(elem) {
    return elem.getBoundingClientRect().left;
}
/**
 * Retrieve the absolute right value of a DOM element.
 *
 * @param elem - A dom element, for example a div.
 * @returns The absolute right position of this element in the browser page.
 */ function getAbsoluteRight(elem) {
    return elem.getBoundingClientRect().right;
}
/**
 * Retrieve the absolute top value of a DOM element.
 *
 * @param elem - A dom element, for example a div.
 * @returns The absolute top position of this element in the browser page.
 */ function getAbsoluteTop(elem) {
    return elem.getBoundingClientRect().top;
}
/**
 * Add a className to the given elements style.
 *
 * @param elem - The element to which the classes will be added.
 * @param classNames - Space separated list of classes.
 */ function addClassName(elem, classNames) {
    var classes = elem.className.split(" ");
    var newClasses = classNames.split(" ");
    classes = _concatInstanceProperty(classes).call(classes, _filterInstanceProperty(newClasses).call(newClasses, function(className) {
        return !_includesInstanceProperty(classes).call(classes, className);
    }));
    elem.className = classes.join(" ");
}
/**
 * Remove a className from the given elements style.
 *
 * @param elem - The element from which the classes will be removed.
 * @param classNames - Space separated list of classes.
 */ function removeClassName(elem, classNames) {
    var classes = elem.className.split(" ");
    var oldClasses = classNames.split(" ");
    classes = _filterInstanceProperty(classes).call(classes, function(className) {
        return !_includesInstanceProperty(oldClasses).call(oldClasses, className);
    });
    elem.className = classes.join(" ");
}
/**
 * For each method for both arrays and objects.
 * In case of an array, the built-in Array.forEach() is applied (**No, it's not!**).
 * In case of an Object, the method loops over all properties of the object.
 *
 * @param object - An Object or Array to be iterated over.
 * @param callback - Array.forEach-like callback.
 */ function forEach$4(object, callback) {
    if (_Array$isArray(object)) {
        // array
        var len = object.length;
        for(var i1 = 0; i1 < len; i1++)callback(object[i1], i1, object);
    } else {
        // object
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) callback(object[key], key, object);
    }
}
/**
 * Convert an object into an array: all objects properties are put into the array. The resulting array is unordered.
 *
 * @param o - Object that contains the properties and methods.
 * @returns An array of unordered values.
 */ var toArray = _Object$values2;
/**
 * Update a property in an object.
 *
 * @param object - The object whose property will be updated.
 * @param key - Name of the property to be updated.
 * @param value - The new value to be assigned.
 * @returns Whether the value was updated (true) or already strictly the same in the original object (false).
 */ function updateProperty(object, key, value) {
    if (object[key] !== value) {
        object[key] = value;
        return true;
    } else return false;
}
/**
 * Throttle the given function to be only executed once per animation frame.
 *
 * @param fn - The original function.
 * @returns The throttled function.
 */ function throttle(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            requestAnimationFrame(function() {
                scheduled = false;
                fn();
            });
        }
    };
}
/**
 * Add and event listener. Works for all browsers.
 *
 * @param element - The element to bind the event listener to.
 * @param action - Same as Element.addEventListener(action, —, —).
 * @param listener - Same as Element.addEventListener(—, listener, —).
 * @param useCapture - Same as Element.addEventListener(—, —, useCapture).
 */ function addEventListener(element, action, listener, useCapture) {
    if (element.addEventListener) {
        var _context8;
        if (useCapture === undefined) useCapture = false;
        if (action === "mousewheel" && _includesInstanceProperty(_context8 = navigator.userAgent).call(_context8, "Firefox")) action = "DOMMouseScroll"; // For Firefox
        element.addEventListener(action, listener, useCapture);
    } else // @TODO: IE types? Does anyone care?
    element.attachEvent("on" + action, listener); // IE browsers
}
/**
 * Remove an event listener from an element.
 *
 * @param element - The element to bind the event listener to.
 * @param action - Same as Element.removeEventListener(action, —, —).
 * @param listener - Same as Element.removeEventListener(—, listener, —).
 * @param useCapture - Same as Element.removeEventListener(—, —, useCapture).
 */ function removeEventListener(element, action, listener, useCapture) {
    if (element.removeEventListener) {
        var _context9;
        // non-IE browsers
        if (useCapture === undefined) useCapture = false;
        if (action === "mousewheel" && _includesInstanceProperty(_context9 = navigator.userAgent).call(_context9, "Firefox")) action = "DOMMouseScroll"; // For Firefox
        element.removeEventListener(action, listener, useCapture);
    } else // @TODO: IE types? Does anyone care?
    element.detachEvent("on" + action, listener); // IE browsers
}
/**
 * Cancels the event's default action if it is cancelable, without stopping further propagation of the event.
 *
 * @param event - The event whose default action should be prevented.
 */ function preventDefault(event1) {
    if (!event1) event1 = window.event;
    if (!event1) ;
    else if (event1.preventDefault) event1.preventDefault(); // non-IE browsers
    else // @TODO: IE types? Does anyone care?
    event1.returnValue = false; // IE browsers
}
/**
 * Get HTML element which is the target of the event.
 *
 * @param event - The event.
 * @returns The element or null if not obtainable.
 */ function getTarget() {
    var event1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
    // code from http://www.quirksmode.org/js/events_properties.html
    // @TODO: EventTarget can be almost anything, is it okay to return only Elements?
    var target = null;
    if (!event1) ;
    else if (event1.target) target = event1.target;
    else if (event1.srcElement) target = event1.srcElement;
    if (!(target instanceof Element)) return null;
    if (target.nodeType != null && target.nodeType == 3) {
        // defeat Safari bug
        target = target.parentNode;
        if (!(target instanceof Element)) return null;
    }
    return target;
}
/**
 * Check if given element contains given parent somewhere in the DOM tree.
 *
 * @param element - The element to be tested.
 * @param parent - The ancestor (not necessarily parent) of the element.
 * @returns True if parent is an ancestor of the element, false otherwise.
 */ function hasParent(element, parent) {
    var elem = element;
    while(elem){
        if (elem === parent) return true;
        else if (elem.parentNode) elem = elem.parentNode;
        else return false;
    }
    return false;
}
var option = {
    /**
   * Convert a value into a boolean.
   *
   * @param value - Value to be converted intoboolean, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding boolean value, if none then the default value, if none then null.
   */ asBoolean: function asBoolean(value, defaultValue) {
        if (typeof value == "function") value = value();
        if (value != null) return value != false;
        return defaultValue || null;
    },
    /**
   * Convert a value into a number.
   *
   * @param value - Value to be converted intonumber, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding **boxed** number value, if none then the default value, if none then null.
   */ asNumber: function asNumber(value, defaultValue) {
        if (typeof value == "function") value = value();
        if (value != null) return Number(value) || defaultValue || null;
        return defaultValue || null;
    },
    /**
   * Convert a value into a string.
   *
   * @param value - Value to be converted intostring, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding **boxed** string value, if none then the default value, if none then null.
   */ asString: function asString(value, defaultValue) {
        if (typeof value == "function") value = value();
        if (value != null) return String(value);
        return defaultValue || null;
    },
    /**
   * Convert a value into a size.
   *
   * @param value - Value to be converted intosize, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns Corresponding string value (number + 'px'), if none then the default value, if none then null.
   */ asSize: function asSize(value, defaultValue) {
        if (typeof value == "function") value = value();
        if (isString(value)) return value;
        else if (isNumber(value)) return value + "px";
        else return defaultValue || null;
    },
    /**
   * Convert a value into a DOM Element.
   *
   * @param value - Value to be converted into DOM Element, a function will be executed as `(() => unknown)`.
   * @param defaultValue - If the value or the return value of the function == null then this will be returned.
   * @returns The DOM Element, if none then the default value, if none then null.
   */ asElement: function asElement(value, defaultValue) {
        if (typeof value == "function") value = value();
        return value || defaultValue || null;
    }
};
/**
 * Convert hex color string into RGB color object.
 *
 * @remarks
 * {@link http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb}
 * @param hex - Hex color string (3 or 6 digits, with or without #).
 * @returns RGB color object.
 */ function hexToRGB(hex) {
    var result;
    switch(hex.length){
        case 3:
        case 4:
            result = shortHexRE.exec(hex);
            return result ? {
                r: _parseInt$1(result[1] + result[1], 16),
                g: _parseInt$1(result[2] + result[2], 16),
                b: _parseInt$1(result[3] + result[3], 16)
            } : null;
        case 6:
        case 7:
            result = fullHexRE.exec(hex);
            return result ? {
                r: _parseInt$1(result[1], 16),
                g: _parseInt$1(result[2], 16),
                b: _parseInt$1(result[3], 16)
            } : null;
        default:
            return null;
    }
}
/**
 * This function takes string color in hex or RGB format and adds the opacity, RGBA is passed through unchanged.
 *
 * @param color - The color string (hex, RGB, RGBA).
 * @param opacity - The new opacity.
 * @returns RGBA string, for example 'rgba(255, 0, 127, 0.3)'.
 */ function overrideOpacity(color, opacity) {
    if (_includesInstanceProperty(color).call(color, "rgba")) return color;
    else if (_includesInstanceProperty(color).call(color, "rgb")) {
        var rgb = color.substr(_indexOfInstanceProperty(color).call(color, "(") + 1).replace(")", "").split(",");
        return "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + opacity + ")";
    } else {
        var _rgb = hexToRGB(color);
        if (_rgb == null) return color;
        else return "rgba(" + _rgb.r + "," + _rgb.g + "," + _rgb.b + "," + opacity + ")";
    }
}
/**
 * Convert RGB \<0, 255\> into hex color string.
 *
 * @param red - Red channel.
 * @param green - Green channel.
 * @param blue - Blue channel.
 * @returns Hex color string (for example: '#0acdc0').
 */ function RGBToHex(red, green, blue) {
    var _context10;
    return "#" + _sliceInstanceProperty(_context10 = (16777216 + (red << 16) + (green << 8) + blue).toString(16)).call(_context10, 1);
}
/**
 * Parse a color property into an object with border, background, and highlight colors.
 *
 * @param inputColor - Shorthand color string or input color object.
 * @param defaultColor - Full color object to fill in missing values in inputColor.
 * @returns Color object.
 */ function parseColor(inputColor, defaultColor) {
    if (isString(inputColor)) {
        var colorStr = inputColor;
        if (isValidRGB(colorStr)) {
            var _context11;
            var rgb = _mapInstanceProperty(_context11 = colorStr.substr(4).substr(0, colorStr.length - 5).split(",")).call(_context11, function(value) {
                return _parseInt$1(value);
            });
            colorStr = RGBToHex(rgb[0], rgb[1], rgb[2]);
        }
        if (isValidHex(colorStr) === true) {
            var hsv = hexToHSV(colorStr);
            var lighterColorHSV = {
                h: hsv.h,
                s: hsv.s * 0.8,
                v: Math.min(1, hsv.v * 1.02)
            };
            var darkerColorHSV = {
                h: hsv.h,
                s: Math.min(1, hsv.s * 1.25),
                v: hsv.v * 0.8
            };
            var darkerColorHex = HSVToHex(darkerColorHSV.h, darkerColorHSV.s, darkerColorHSV.v);
            var lighterColorHex = HSVToHex(lighterColorHSV.h, lighterColorHSV.s, lighterColorHSV.v);
            return {
                background: colorStr,
                border: darkerColorHex,
                highlight: {
                    background: lighterColorHex,
                    border: darkerColorHex
                },
                hover: {
                    background: lighterColorHex,
                    border: darkerColorHex
                }
            };
        } else return {
            background: colorStr,
            border: colorStr,
            highlight: {
                background: colorStr,
                border: colorStr
            },
            hover: {
                background: colorStr,
                border: colorStr
            }
        };
    } else if (defaultColor) {
        var color = {
            background: inputColor.background || defaultColor.background,
            border: inputColor.border || defaultColor.border,
            highlight: isString(inputColor.highlight) ? {
                border: inputColor.highlight,
                background: inputColor.highlight
            } : {
                background: inputColor.highlight && inputColor.highlight.background || defaultColor.highlight.background,
                border: inputColor.highlight && inputColor.highlight.border || defaultColor.highlight.border
            },
            hover: isString(inputColor.hover) ? {
                border: inputColor.hover,
                background: inputColor.hover
            } : {
                border: inputColor.hover && inputColor.hover.border || defaultColor.hover.border,
                background: inputColor.hover && inputColor.hover.background || defaultColor.hover.background
            }
        };
        return color;
    } else {
        var _color = {
            background: inputColor.background || undefined,
            border: inputColor.border || undefined,
            highlight: isString(inputColor.highlight) ? {
                border: inputColor.highlight,
                background: inputColor.highlight
            } : {
                background: inputColor.highlight && inputColor.highlight.background || undefined,
                border: inputColor.highlight && inputColor.highlight.border || undefined
            },
            hover: isString(inputColor.hover) ? {
                border: inputColor.hover,
                background: inputColor.hover
            } : {
                border: inputColor.hover && inputColor.hover.border || undefined,
                background: inputColor.hover && inputColor.hover.background || undefined
            }
        };
        return _color;
    }
}
/**
 * Convert RGB \<0, 255\> into HSV object.
 *
 * @remarks
 * {@link http://www.javascripter.net/faq/rgb2hsv.htm}
 * @param red - Red channel.
 * @param green - Green channel.
 * @param blue - Blue channel.
 * @returns HSV color object.
 */ function RGBToHSV(red, green, blue) {
    red = red / 255;
    green = green / 255;
    blue = blue / 255;
    var minRGB = Math.min(red, Math.min(green, blue));
    var maxRGB = Math.max(red, Math.max(green, blue));
    // Black-gray-white
    if (minRGB === maxRGB) return {
        h: 0,
        s: 0,
        v: minRGB
    };
    // Colors other than black-gray-white:
    var d = red === minRGB ? green - blue : blue === minRGB ? red - green : blue - red;
    var h = red === minRGB ? 3 : blue === minRGB ? 1 : 5;
    var hue = 60 * (h - d / (maxRGB - minRGB)) / 360;
    var saturation = (maxRGB - minRGB) / maxRGB;
    var value = maxRGB;
    return {
        h: hue,
        s: saturation,
        v: value
    };
}
/**
 * Split a string with css styles into an object with key/values.
 *
 * @param cssText - CSS source code to split into key/value object.
 * @returns Key/value object corresponding to {@link cssText}.
 */ function splitCSSText(cssText) {
    var tmpEllement = document.createElement("div");
    var styles = {};
    tmpEllement.style.cssText = cssText;
    for(var i1 = 0; i1 < tmpEllement.style.length; ++i1)styles[tmpEllement.style[i1]] = tmpEllement.style.getPropertyValue(tmpEllement.style[i1]);
    return styles;
}
/**
 * Append a string with css styles to an element.
 *
 * @param element - The element that will receive new styles.
 * @param cssText - The styles to be appended.
 */ function addCssText(element, cssText) {
    var cssStyle = splitCSSText(cssText);
    for(var _i3 = 0, _Object$entries = _Object$entries2(cssStyle); _i3 < _Object$entries.length; _i3++){
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        element.style.setProperty(key, value);
    }
}
/**
 * Remove a string with css styles from an element.
 *
 * @param element - The element from which styles should be removed.
 * @param cssText - The styles to be removed.
 */ function removeCssText(element, cssText) {
    var cssStyle = splitCSSText(cssText);
    for(var _i4 = 0, _Object$keys3 = _Object$keys(cssStyle); _i4 < _Object$keys3.length; _i4++){
        var key = _Object$keys3[_i4];
        element.style.removeProperty(key);
    }
}
/**
 * Convert HSV \<0, 1\> into RGB color object.
 *
 * @remarks
 * {@link https://gist.github.com/mjijackson/5311256}
 * @param h - Hue.
 * @param s - Saturation.
 * @param v - Value.
 * @returns RGB color object.
 */ function HSVToRGB(h, s, v) {
    var r;
    var g;
    var b;
    var i1 = Math.floor(h * 6);
    var f = h * 6 - i1;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    switch(i1 % 6){
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
    }
    return {
        r: Math.floor(r * 255),
        g: Math.floor(g * 255),
        b: Math.floor(b * 255)
    };
}
/**
 * Convert HSV \<0, 1\> into hex color string.
 *
 * @param h - Hue.
 * @param s - Saturation.
 * @param v - Value.
 * @returns Hex color string.
 */ function HSVToHex(h, s, v) {
    var rgb = HSVToRGB(h, s, v);
    return RGBToHex(rgb.r, rgb.g, rgb.b);
}
/**
 * Convert hex color string into HSV \<0, 1\>.
 *
 * @param hex - Hex color string.
 * @returns HSV color object.
 */ function hexToHSV(hex) {
    var rgb = hexToRGB(hex);
    if (!rgb) throw new TypeError("'".concat(hex, "' is not a valid color."));
    return RGBToHSV(rgb.r, rgb.g, rgb.b);
}
/**
 * Validate hex color string.
 *
 * @param hex - Unknown string that may contain a color.
 * @returns True if the string is valid, false otherwise.
 */ function isValidHex(hex) {
    var isOk = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
    return isOk;
}
/**
 * Validate RGB color string.
 *
 * @param rgb - Unknown string that may contain a color.
 * @returns True if the string is valid, false otherwise.
 */ function isValidRGB(rgb) {
    return rgbRE.test(rgb);
}
/**
 * Validate RGBA color string.
 *
 * @param rgba - Unknown string that may contain a color.
 * @returns True if the string is valid, false otherwise.
 */ function isValidRGBA(rgba) {
    return rgbaRE.test(rgba);
}
/**
 * This recursively redirects the prototype of JSON objects to the referenceObject.
 * This is used for default options.
 *
 * @param fields - Names of properties to be bridged.
 * @param referenceObject - The original object.
 * @returns A new object inheriting from the referenceObject.
 */ function selectiveBridgeObject(fields, referenceObject) {
    if (referenceObject !== null && _typeof$1(referenceObject) === "object") {
        // !!! typeof null === 'object'
        var objectTo = _Object$create$1(referenceObject);
        for(var i1 = 0; i1 < fields.length; i1++){
            if (Object.prototype.hasOwnProperty.call(referenceObject, fields[i1])) {
                if (_typeof$1(referenceObject[fields[i1]]) == "object") objectTo[fields[i1]] = bridgeObject(referenceObject[fields[i1]]);
            }
        }
        return objectTo;
    } else return null;
}
/**
 * This recursively redirects the prototype of JSON objects to the referenceObject.
 * This is used for default options.
 *
 * @param referenceObject - The original object.
 * @returns The Element if the referenceObject is an Element, or a new object inheriting from the referenceObject.
 */ function bridgeObject(referenceObject) {
    if (referenceObject === null || _typeof$1(referenceObject) !== "object") return null;
    if (referenceObject instanceof Element) // Avoid bridging DOM objects
    return referenceObject;
    var objectTo = _Object$create$1(referenceObject);
    for(var i1 in referenceObject){
        if (Object.prototype.hasOwnProperty.call(referenceObject, i1)) {
            if (_typeof$1(referenceObject[i1]) == "object") objectTo[i1] = bridgeObject(referenceObject[i1]);
        }
    }
    return objectTo;
}
/**
 * This method provides a stable sort implementation, very fast for presorted data.
 *
 * @param a - The array to be sorted (in-place).
 * @param compare - An order comparator.
 * @returns The argument a.
 */ function insertSort(a, compare) {
    for(var i1 = 0; i1 < a.length; i1++){
        var k = a[i1];
        var j = void 0;
        for(j = i1; j > 0 && compare(k, a[j - 1]) < 0; j--)a[j] = a[j - 1];
        a[j] = k;
    }
    return a;
}
/**
 * This is used to set the options of subobjects in the options object.
 *
 * A requirement of these subobjects is that they have an 'enabled' element
 * which is optional for the user but mandatory for the program.
 *
 * The added value here of the merge is that option 'enabled' is set as required.
 *
 * @param mergeTarget - Either this.options or the options used for the groups.
 * @param options - Options.
 * @param option - Option key in the options argument.
 * @param globalOptions - Global options, passed in to determine value of option 'enabled'.
 */ function mergeOptions(mergeTarget, options, option) {
    var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // Local helpers
    var isPresent = function isPresent(obj) {
        return obj !== null && obj !== undefined;
    };
    var isObject = function isObject(obj) {
        return obj !== null && _typeof$1(obj) === "object";
    };
    // https://stackoverflow.com/a/34491287/1223531
    var isEmpty = function isEmpty(obj) {
        for(var x in obj){
            if (Object.prototype.hasOwnProperty.call(obj, x)) return false;
        }
        return true;
    };
    // Guards
    if (!isObject(mergeTarget)) throw new Error("Parameter mergeTarget must be an object");
    if (!isObject(options)) throw new Error("Parameter options must be an object");
    if (!isPresent(option)) throw new Error("Parameter option must have a value");
    if (!isObject(globalOptions)) throw new Error("Parameter globalOptions must be an object");
    //
    // Actual merge routine, separated from main logic
    // Only a single level of options is merged. Deeper levels are ref'd. This may actually be an issue.
    //
    var doMerge = function doMerge(target, options, option) {
        if (!isObject(target[option])) target[option] = {};
        var src = options[option];
        var dst = target[option];
        for(var prop in src)if (Object.prototype.hasOwnProperty.call(src, prop)) dst[prop] = src[prop];
    };
    // Local initialization
    var srcOption = options[option];
    var globalPassed = isObject(globalOptions) && !isEmpty(globalOptions);
    var globalOption = globalPassed ? globalOptions[option] : undefined;
    var globalEnabled = globalOption ? globalOption.enabled : undefined;
    /////////////////////////////////////////
    // Main routine
    /////////////////////////////////////////
    if (srcOption === undefined) return; // Nothing to do
    if (typeof srcOption === "boolean") {
        if (!isObject(mergeTarget[option])) mergeTarget[option] = {};
        mergeTarget[option].enabled = srcOption;
        return;
    }
    if (srcOption === null && !isObject(mergeTarget[option])) {
        // If possible, explicit copy from globals
        if (isPresent(globalOption)) mergeTarget[option] = _Object$create$1(globalOption);
        else return; // Nothing to do
    }
    if (!isObject(srcOption)) return;
    //
    // Ensure that 'enabled' is properly set. It is required internally
    // Note that the value from options will always overwrite the existing value
    //
    var enabled = true; // default value
    if (srcOption.enabled !== undefined) enabled = srcOption.enabled;
    else // Take from globals, if present
    if (globalEnabled !== undefined) enabled = globalOption.enabled;
    doMerge(mergeTarget, options, option);
    mergeTarget[option].enabled = enabled;
}
/**
 * This function does a binary search for a visible item in a sorted list. If we find a visible item, the code that uses
 * this function will then iterate in both directions over this sorted list to find all visible items.
 *
 * @param orderedItems - Items ordered by start.
 * @param comparator - -1 is lower, 0 is equal, 1 is higher.
 * @param field - Property name on an item (That is item[field]).
 * @param field2 - Second property name on an item (That is item[field][field2]).
 * @returns Index of the found item or -1 if nothing was found.
 */ function binarySearchCustom(orderedItems, comparator, field, field2) {
    var maxIterations = 10000;
    var iteration = 0;
    var low = 0;
    var high = orderedItems.length - 1;
    while(low <= high && iteration < maxIterations){
        var middle = Math.floor((low + high) / 2);
        var item = orderedItems[middle];
        var value = field2 === undefined ? item[field] : item[field][field2];
        var searchResult = comparator(value);
        if (searchResult == 0) // jihaa, found a visible item!
        return middle;
        else if (searchResult == -1) // it is too small --> increase low
        low = middle + 1;
        else // it is too big --> decrease high
        high = middle - 1;
        iteration++;
    }
    return -1;
}
/**
 * This function does a binary search for a specific value in a sorted array.
 * If it does not exist but is in between of two values, we return either the
 * one before or the one after, depending on user input If it is found, we
 * return the index, else -1.
 *
 * @param orderedItems - Sorted array.
 * @param target - The searched value.
 * @param field - Name of the property in items to be searched.
 * @param sidePreference - If the target is between two values, should the index of the before or the after be returned?
 * @param comparator - An optional comparator, returning -1, 0, 1 for \<, ===, \>.
 * @returns The index of found value or -1 if nothing was found.
 */ function binarySearchValue(orderedItems, target, field, sidePreference, comparator) {
    var maxIterations = 10000;
    var iteration = 0;
    var low = 0;
    var high = orderedItems.length - 1;
    var prevValue;
    var value;
    var nextValue;
    var middle;
    comparator = comparator != undefined ? comparator : function(a, b) {
        return a == b ? 0 : a < b ? -1 : 1;
    };
    while(low <= high && iteration < maxIterations){
        // get a new guess
        middle = Math.floor(0.5 * (high + low));
        prevValue = orderedItems[Math.max(0, middle - 1)][field];
        value = orderedItems[middle][field];
        nextValue = orderedItems[Math.min(orderedItems.length - 1, middle + 1)][field];
        if (comparator(value, target) == 0) // we found the target
        return middle;
        else if (comparator(prevValue, target) < 0 && comparator(value, target) > 0) // target is in between of the previous and the current
        return sidePreference == "before" ? Math.max(0, middle - 1) : middle;
        else if (comparator(value, target) < 0 && comparator(nextValue, target) > 0) // target is in between of the current and the next
        return sidePreference == "before" ? middle : Math.min(orderedItems.length - 1, middle + 1);
        else // didnt find the target, we need to change our boundaries.
        if (comparator(value, target) < 0) // it is too small --> increase low
        low = middle + 1;
        else // it is too big --> decrease high
        high = middle - 1;
        iteration++;
    }
    // didnt find anything. Return -1.
    return -1;
}
/*
 * Easing Functions.
 * Only considering the t value for the range [0, 1] => [0, 1].
 *
 * Inspiration: from http://gizma.com/easing/
 * https://gist.github.com/gre/1650294
 */ var easingFunctions = {
    /**
   * Provides no easing and no acceleration.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ linear: function linear(t) {
        return t;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInQuad: function easeInQuad(t) {
        return t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutQuad: function easeOutQuad(t) {
        return t * (2 - t);
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutQuad: function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInCubic: function easeInCubic(t) {
        return t * t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutCubic: function easeOutCubic(t) {
        return --t * t * t + 1;
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutCubic: function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutQuart: function easeOutQuart(t) {
        return 1 - --t * t * t * t;
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutQuart: function easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    /**
   * Accelerate from zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
    },
    /**
   * Decelerate to zero velocity.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeOutQuint: function easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
    },
    /**
   * Accelerate until halfway, then decelerate.
   *
   * @param t - Time.
   * @returns Value at time t.
   */ easeInOutQuint: function easeInOutQuint(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
};
/**
 * Experimentaly compute the width of the scrollbar for this browser.
 *
 * @returns The width in pixels.
 */ function getScrollBarWidth() {
    var inner = document.createElement("p");
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement("div");
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = "scroll";
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;
    document.body.removeChild(outer);
    return w1 - w2;
}
// @TODO: This doesn't work properly.
// It works only for single property objects,
// otherwise it combines all of the types in a union.
// export function topMost<K1 extends string, V1> (
//   pile: Record<K1, undefined | V1>[],
//   accessors: K1 | [K1]
// ): undefined | V1
// export function topMost<K1 extends string, K2 extends string, V1, V2> (
//   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2>>[],
//   accessors: [K1, K2]
// ): undefined | V1 | V2
// export function topMost<K1 extends string, K2 extends string, K3 extends string, V1, V2, V3> (
//   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2 | Record<K3, undefined | V3>>>[],
//   accessors: [K1, K2, K3]
// ): undefined | V1 | V2 | V3
/**
 * Get the top most property value from a pile of objects.
 *
 * @param pile - Array of objects, no required format.
 * @param accessors - Array of property names.
 * For example `object['foo']['bar']` → `['foo', 'bar']`.
 * @returns Value of the property with given accessors path from the first pile item where it's not undefined.
 */ function topMost(pile, accessors) {
    var candidate;
    if (!_Array$isArray(accessors)) accessors = [
        accessors
    ];
    var _iterator3 = _createForOfIteratorHelper$7(pile), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var member = _step3.value;
            if (member) {
                candidate = member[accessors[0]];
                for(var i1 = 1; i1 < accessors.length; i1++)if (candidate) candidate = candidate[accessors[i1]];
                if (typeof candidate !== "undefined") break;
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    return candidate;
}
var htmlColors$1 = {
    black: "#000000",
    navy: "#000080",
    darkblue: "#00008B",
    mediumblue: "#0000CD",
    blue: "#0000FF",
    darkgreen: "#006400",
    green: "#008000",
    teal: "#008080",
    darkcyan: "#008B8B",
    deepskyblue: "#00BFFF",
    darkturquoise: "#00CED1",
    mediumspringgreen: "#00FA9A",
    lime: "#00FF00",
    springgreen: "#00FF7F",
    aqua: "#00FFFF",
    cyan: "#00FFFF",
    midnightblue: "#191970",
    dodgerblue: "#1E90FF",
    lightseagreen: "#20B2AA",
    forestgreen: "#228B22",
    seagreen: "#2E8B57",
    darkslategray: "#2F4F4F",
    limegreen: "#32CD32",
    mediumseagreen: "#3CB371",
    turquoise: "#40E0D0",
    royalblue: "#4169E1",
    steelblue: "#4682B4",
    darkslateblue: "#483D8B",
    mediumturquoise: "#48D1CC",
    indigo: "#4B0082",
    darkolivegreen: "#556B2F",
    cadetblue: "#5F9EA0",
    cornflowerblue: "#6495ED",
    mediumaquamarine: "#66CDAA",
    dimgray: "#696969",
    slateblue: "#6A5ACD",
    olivedrab: "#6B8E23",
    slategray: "#708090",
    lightslategray: "#778899",
    mediumslateblue: "#7B68EE",
    lawngreen: "#7CFC00",
    chartreuse: "#7FFF00",
    aquamarine: "#7FFFD4",
    maroon: "#800000",
    purple: "#800080",
    olive: "#808000",
    gray: "#808080",
    skyblue: "#87CEEB",
    lightskyblue: "#87CEFA",
    blueviolet: "#8A2BE2",
    darkred: "#8B0000",
    darkmagenta: "#8B008B",
    saddlebrown: "#8B4513",
    darkseagreen: "#8FBC8F",
    lightgreen: "#90EE90",
    mediumpurple: "#9370D8",
    darkviolet: "#9400D3",
    palegreen: "#98FB98",
    darkorchid: "#9932CC",
    yellowgreen: "#9ACD32",
    sienna: "#A0522D",
    brown: "#A52A2A",
    darkgray: "#A9A9A9",
    lightblue: "#ADD8E6",
    greenyellow: "#ADFF2F",
    paleturquoise: "#AFEEEE",
    lightsteelblue: "#B0C4DE",
    powderblue: "#B0E0E6",
    firebrick: "#B22222",
    darkgoldenrod: "#B8860B",
    mediumorchid: "#BA55D3",
    rosybrown: "#BC8F8F",
    darkkhaki: "#BDB76B",
    silver: "#C0C0C0",
    mediumvioletred: "#C71585",
    indianred: "#CD5C5C",
    peru: "#CD853F",
    chocolate: "#D2691E",
    tan: "#D2B48C",
    lightgrey: "#D3D3D3",
    palevioletred: "#D87093",
    thistle: "#D8BFD8",
    orchid: "#DA70D6",
    goldenrod: "#DAA520",
    crimson: "#DC143C",
    gainsboro: "#DCDCDC",
    plum: "#DDA0DD",
    burlywood: "#DEB887",
    lightcyan: "#E0FFFF",
    lavender: "#E6E6FA",
    darksalmon: "#E9967A",
    violet: "#EE82EE",
    palegoldenrod: "#EEE8AA",
    lightcoral: "#F08080",
    khaki: "#F0E68C",
    aliceblue: "#F0F8FF",
    honeydew: "#F0FFF0",
    azure: "#F0FFFF",
    sandybrown: "#F4A460",
    wheat: "#F5DEB3",
    beige: "#F5F5DC",
    whitesmoke: "#F5F5F5",
    mintcream: "#F5FFFA",
    ghostwhite: "#F8F8FF",
    salmon: "#FA8072",
    antiquewhite: "#FAEBD7",
    linen: "#FAF0E6",
    lightgoldenrodyellow: "#FAFAD2",
    oldlace: "#FDF5E6",
    red: "#FF0000",
    fuchsia: "#FF00FF",
    magenta: "#FF00FF",
    deeppink: "#FF1493",
    orangered: "#FF4500",
    tomato: "#FF6347",
    hotpink: "#FF69B4",
    coral: "#FF7F50",
    darkorange: "#FF8C00",
    lightsalmon: "#FFA07A",
    orange: "#FFA500",
    lightpink: "#FFB6C1",
    pink: "#FFC0CB",
    gold: "#FFD700",
    peachpuff: "#FFDAB9",
    navajowhite: "#FFDEAD",
    moccasin: "#FFE4B5",
    bisque: "#FFE4C4",
    mistyrose: "#FFE4E1",
    blanchedalmond: "#FFEBCD",
    papayawhip: "#FFEFD5",
    lavenderblush: "#FFF0F5",
    seashell: "#FFF5EE",
    cornsilk: "#FFF8DC",
    lemonchiffon: "#FFFACD",
    floralwhite: "#FFFAF0",
    snow: "#FFFAFA",
    yellow: "#FFFF00",
    lightyellow: "#FFFFE0",
    ivory: "#FFFFF0",
    white: "#FFFFFF"
};
/**
 * @param {number} [pixelRatio=1]
 */ var ColorPicker$1 = /*#__PURE__*/ function() {
    /**
   * @param {number} [pixelRatio=1]
   */ function ColorPicker() {
        var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        _classCallCheck(this, ColorPicker);
        this.pixelRatio = pixelRatio;
        this.generated = false;
        this.centerCoordinates = {
            x: 144.5,
            y: 144.5
        };
        this.r = 289 * 0.49;
        this.color = {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        this.hueCircle = undefined;
        this.initialColor = {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        this.previousColor = undefined;
        this.applied = false;
        // bound by
        this.updateCallback = function() {};
        this.closeCallback = function() {};
        // create all DOM elements
        this._create();
    }
    /**
   * this inserts the colorPicker into a div from the DOM
   *
   * @param {Element} container
   */ _createClass(ColorPicker, [
        {
            key: "insertTo",
            value: function insertTo(container) {
                if (this.hammer !== undefined) {
                    this.hammer.destroy();
                    this.hammer = undefined;
                }
                this.container = container;
                this.container.appendChild(this.frame);
                this._bindHammer();
                this._setSize();
            }
        },
        {
            key: "setUpdateCallback",
            value: function setUpdateCallback(callback) {
                if (typeof callback === "function") this.updateCallback = callback;
                else throw new Error("Function attempted to set as colorPicker update callback is not a function.");
            }
        },
        {
            key: "setCloseCallback",
            value: function setCloseCallback(callback) {
                if (typeof callback === "function") this.closeCallback = callback;
                else throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
            }
        },
        {
            key: "_isColorString",
            value: function _isColorString(color) {
                if (typeof color === "string") return htmlColors$1[color];
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (color === "none") return;
                var rgba;
                // if a html color shorthand is used, convert to hex
                var htmlColor = this._isColorString(color);
                if (htmlColor !== undefined) color = htmlColor;
                // check format
                if (isString(color) === true) {
                    if (isValidRGB(color) === true) {
                        var rgbaArray = color.substr(4).substr(0, color.length - 5).split(",");
                        rgba = {
                            r: rgbaArray[0],
                            g: rgbaArray[1],
                            b: rgbaArray[2],
                            a: 1.0
                        };
                    } else if (isValidRGBA(color) === true) {
                        var _rgbaArray = color.substr(5).substr(0, color.length - 6).split(",");
                        rgba = {
                            r: _rgbaArray[0],
                            g: _rgbaArray[1],
                            b: _rgbaArray[2],
                            a: _rgbaArray[3]
                        };
                    } else if (isValidHex(color) === true) {
                        var rgbObj = hexToRGB(color);
                        rgba = {
                            r: rgbObj.r,
                            g: rgbObj.g,
                            b: rgbObj.b,
                            a: 1.0
                        };
                    }
                } else {
                    if (color instanceof Object) {
                        if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
                            var alpha = color.a !== undefined ? color.a : "1.0";
                            rgba = {
                                r: color.r,
                                g: color.g,
                                b: color.b,
                                a: alpha
                            };
                        }
                    }
                }
                // set color
                if (rgba === undefined) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + _JSON$stringify(color));
                else this._setColor(rgba, setInitial);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.closeCallback !== undefined) {
                    this.closeCallback();
                    this.closeCallback = undefined;
                }
                this.applied = false;
                this.frame.style.display = "block";
                this._generateHueCircle();
            }
        },
        {
            key: "_hide",
            value: function _hide() {
                var _this2 = this;
                var storePrevious = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                // store the previous color for next time;
                if (storePrevious === true) this.previousColor = _Object$assign({}, this.color);
                if (this.applied === true) this.updateCallback(this.initialColor);
                this.frame.style.display = "none";
                // call the closing callback, restoring the onclick method.
                // this is in a setTimeout because it will trigger the show again before the click is done.
                _setTimeout(function() {
                    if (_this2.closeCallback !== undefined) {
                        _this2.closeCallback();
                        _this2.closeCallback = undefined;
                    }
                }, 0);
            }
        },
        {
            key: "_save",
            value: function _save() {
                this.updateCallback(this.color);
                this.applied = false;
                this._hide();
            }
        },
        {
            key: "_apply",
            value: function _apply() {
                this.applied = true;
                this.updateCallback(this.color);
                this._updatePicker(this.color);
            }
        },
        {
            key: "_loadLast",
            value: function _loadLast() {
                if (this.previousColor !== undefined) this.setColor(this.previousColor, false);
                else alert("There is no last color to load...");
            }
        },
        {
            key: "_setColor",
            value: function _setColor(rgba) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                // store the initial color
                if (setInitial === true) this.initialColor = _Object$assign({}, rgba);
                this.color = rgba;
                var hsv = RGBToHSV(rgba.r, rgba.g, rgba.b);
                var angleConvert = 2 * Math.PI;
                var radius = this.r * hsv.s;
                var x = this.centerCoordinates.x + radius * Math.sin(angleConvert * hsv.h);
                var y = this.centerCoordinates.y + radius * Math.cos(angleConvert * hsv.h);
                this.colorPickerSelector.style.left = x - 0.5 * this.colorPickerSelector.clientWidth + "px";
                this.colorPickerSelector.style.top = y - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this._updatePicker(rgba);
            }
        },
        {
            key: "_setOpacity",
            value: function _setOpacity(value) {
                this.color.a = value / 100;
                this._updatePicker(this.color);
            }
        },
        {
            key: "_setBrightness",
            value: function _setBrightness(value) {
                var hsv = RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.v = value / 100;
                var rgba = HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;
                this._updatePicker();
            }
        },
        {
            key: "_updatePicker",
            value: function _updatePicker() {
                var rgba = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.color;
                var hsv = RGBToHSV(rgba.r, rgba.g, rgba.b);
                var ctx = this.colorPickerCanvas.getContext("2d");
                if (this.pixelRation === undefined) this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                // clear the canvas
                var w = this.colorPickerCanvas.clientWidth;
                var h = this.colorPickerCanvas.clientHeight;
                ctx.clearRect(0, 0, w, h);
                ctx.putImageData(this.hueCircle, 0, 0);
                ctx.fillStyle = "rgba(0,0,0," + (1 - hsv.v) + ")";
                ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                _fillInstanceProperty(ctx).call(ctx);
                this.brightnessRange.value = 100 * hsv.v;
                this.opacityRange.value = 100 * rgba.a;
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        },
        {
            key: "_setSize",
            value: function _setSize() {
                this.colorPickerCanvas.style.width = "100%";
                this.colorPickerCanvas.style.height = "100%";
                this.colorPickerCanvas.width = 289 * this.pixelRatio;
                this.colorPickerCanvas.height = 289 * this.pixelRatio;
            }
        },
        {
            key: "_create",
            value: function _create() {
                var _context12, _context13, _context14, _context15;
                this.frame = document.createElement("div");
                this.frame.className = "vis-color-picker";
                this.colorPickerDiv = document.createElement("div");
                this.colorPickerSelector = document.createElement("div");
                this.colorPickerSelector.className = "vis-selector";
                this.colorPickerDiv.appendChild(this.colorPickerSelector);
                this.colorPickerCanvas = document.createElement("canvas");
                this.colorPickerDiv.appendChild(this.colorPickerCanvas);
                if (!this.colorPickerCanvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerText = "Error: your browser does not support HTML canvas";
                    this.colorPickerCanvas.appendChild(noCanvas);
                } else {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                }
                this.colorPickerDiv.className = "vis-color";
                this.opacityDiv = document.createElement("div");
                this.opacityDiv.className = "vis-opacity";
                this.brightnessDiv = document.createElement("div");
                this.brightnessDiv.className = "vis-brightness";
                this.arrowDiv = document.createElement("div");
                this.arrowDiv.className = "vis-arrow";
                this.opacityRange = document.createElement("input");
                try {
                    this.opacityRange.type = "range"; // Not supported on IE9
                    this.opacityRange.min = "0";
                    this.opacityRange.max = "100";
                } catch (err) {
                // TODO: Add some error handling.
                }
                this.opacityRange.value = "100";
                this.opacityRange.className = "vis-range";
                this.brightnessRange = document.createElement("input");
                try {
                    this.brightnessRange.type = "range"; // Not supported on IE9
                    this.brightnessRange.min = "0";
                    this.brightnessRange.max = "100";
                } catch (err) {
                // TODO: Add some error handling.
                }
                this.brightnessRange.value = "100";
                this.brightnessRange.className = "vis-range";
                this.opacityDiv.appendChild(this.opacityRange);
                this.brightnessDiv.appendChild(this.brightnessRange);
                var me = this;
                this.opacityRange.onchange = function() {
                    me._setOpacity(this.value);
                };
                this.opacityRange.oninput = function() {
                    me._setOpacity(this.value);
                };
                this.brightnessRange.onchange = function() {
                    me._setBrightness(this.value);
                };
                this.brightnessRange.oninput = function() {
                    me._setBrightness(this.value);
                };
                this.brightnessLabel = document.createElement("div");
                this.brightnessLabel.className = "vis-label vis-brightness";
                this.brightnessLabel.innerText = "brightness:";
                this.opacityLabel = document.createElement("div");
                this.opacityLabel.className = "vis-label vis-opacity";
                this.opacityLabel.innerText = "opacity:";
                this.newColorDiv = document.createElement("div");
                this.newColorDiv.className = "vis-new-color";
                this.newColorDiv.innerText = "new";
                this.initialColorDiv = document.createElement("div");
                this.initialColorDiv.className = "vis-initial-color";
                this.initialColorDiv.innerText = "initial";
                this.cancelButton = document.createElement("div");
                this.cancelButton.className = "vis-button vis-cancel";
                this.cancelButton.innerText = "cancel";
                this.cancelButton.onclick = _bindInstanceProperty$1(_context12 = this._hide).call(_context12, this, false);
                this.applyButton = document.createElement("div");
                this.applyButton.className = "vis-button vis-apply";
                this.applyButton.innerText = "apply";
                this.applyButton.onclick = _bindInstanceProperty$1(_context13 = this._apply).call(_context13, this);
                this.saveButton = document.createElement("div");
                this.saveButton.className = "vis-button vis-save";
                this.saveButton.innerText = "save";
                this.saveButton.onclick = _bindInstanceProperty$1(_context14 = this._save).call(_context14, this);
                this.loadButton = document.createElement("div");
                this.loadButton.className = "vis-button vis-load";
                this.loadButton.innerText = "load last";
                this.loadButton.onclick = _bindInstanceProperty$1(_context15 = this._loadLast).call(_context15, this);
                this.frame.appendChild(this.colorPickerDiv);
                this.frame.appendChild(this.arrowDiv);
                this.frame.appendChild(this.brightnessLabel);
                this.frame.appendChild(this.brightnessDiv);
                this.frame.appendChild(this.opacityLabel);
                this.frame.appendChild(this.opacityDiv);
                this.frame.appendChild(this.newColorDiv);
                this.frame.appendChild(this.initialColorDiv);
                this.frame.appendChild(this.cancelButton);
                this.frame.appendChild(this.applyButton);
                this.frame.appendChild(this.saveButton);
                this.frame.appendChild(this.loadButton);
            }
        },
        {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this3 = this;
                this.drag = {};
                this.pinch = {};
                this.hammer = new Hammer$1(this.colorPickerCanvas);
                this.hammer.get("pinch").set({
                    enable: true
                });
                this.hammer.on("hammer.input", function(event1) {
                    if (event1.isFirst) _this3._moveSelector(event1);
                });
                this.hammer.on("tap", function(event1) {
                    _this3._moveSelector(event1);
                });
                this.hammer.on("panstart", function(event1) {
                    _this3._moveSelector(event1);
                });
                this.hammer.on("panmove", function(event1) {
                    _this3._moveSelector(event1);
                });
                this.hammer.on("panend", function(event1) {
                    _this3._moveSelector(event1);
                });
            }
        },
        {
            key: "_generateHueCircle",
            value: function _generateHueCircle() {
                if (this.generated === false) {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    if (this.pixelRation === undefined) this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                    // clear the canvas
                    var w = this.colorPickerCanvas.clientWidth;
                    var h = this.colorPickerCanvas.clientHeight;
                    ctx.clearRect(0, 0, w, h);
                    // draw hue circle
                    var x, y, hue, sat;
                    this.centerCoordinates = {
                        x: w * 0.5,
                        y: h * 0.5
                    };
                    this.r = 0.49 * w;
                    var angleConvert = 2 * Math.PI / 360;
                    var hfac = 1 / 360;
                    var sfac = 1 / this.r;
                    var rgb;
                    for(hue = 0; hue < 360; hue++)for(sat = 0; sat < this.r; sat++){
                        x = this.centerCoordinates.x + sat * Math.sin(angleConvert * hue);
                        y = this.centerCoordinates.y + sat * Math.cos(angleConvert * hue);
                        rgb = HSVToRGB(hue * hfac, sat * sfac, 1);
                        ctx.fillStyle = "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
                        ctx.fillRect(x - 0.5, y - 0.5, 2, 2);
                    }
                    ctx.strokeStyle = "rgba(0,0,0,1)";
                    ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                    ctx.stroke();
                    this.hueCircle = ctx.getImageData(0, 0, w, h);
                }
                this.generated = true;
            }
        },
        {
            key: "_moveSelector",
            value: function _moveSelector(event1) {
                var rect = this.colorPickerDiv.getBoundingClientRect();
                var left = event1.center.x - rect.left;
                var top = event1.center.y - rect.top;
                var centerY = 0.5 * this.colorPickerDiv.clientHeight;
                var centerX = 0.5 * this.colorPickerDiv.clientWidth;
                var x = left - centerX;
                var y = top - centerY;
                var angle = Math.atan2(x, y);
                var radius = 0.98 * Math.min(Math.sqrt(x * x + y * y), centerX);
                var newTop = Math.cos(angle) * radius + centerY;
                var newLeft = Math.sin(angle) * radius + centerX;
                this.colorPickerSelector.style.top = newTop - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this.colorPickerSelector.style.left = newLeft - 0.5 * this.colorPickerSelector.clientWidth + "px";
                // set color
                var h = angle / (2 * Math.PI);
                h = h < 0 ? h + 1 : h;
                var s = radius / this.r;
                var hsv = RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.h = h;
                hsv.s = s;
                var rgba = HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;
                // update previews
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        }
    ]);
    return ColorPicker;
}();
/**
 * Wrap given text (last argument) in HTML elements (all preceding arguments).
 *
 * @param {...any} rest - List of tag names followed by inner text.
 * @returns An element or a text node.
 */ function wrapInTag() {
    for(var _len5 = arguments.length, rest = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)rest[_key5] = arguments[_key5];
    if (rest.length < 1) throw new TypeError("Invalid arguments.");
    else if (rest.length === 1) return document.createTextNode(rest[0]);
    else {
        var element = document.createElement(rest[0]);
        element.appendChild(wrapInTag.apply(void 0, _toConsumableArray(_sliceInstanceProperty(rest).call(rest, 1))));
        return element;
    }
}
/**
 * The way this works is for all properties of this.possible options, you can supply the property name in any form to list the options.
 * Boolean options are recognised as Boolean
 * Number options should be written as array: [default value, min value, max value, stepsize]
 * Colors should be written as array: ['color', '#ffffff']
 * Strings with should be written as array: [option1, option2, option3, ..]
 *
 * The options are matched with their counterparts in each of the modules and the values used in the configuration are
 */ var Configurator$1 = /*#__PURE__*/ function() {
    /**
   * @param {object} parentModule        | the location where parentModule.setOptions() can be called
   * @param {object} defaultContainer    | the default container of the module
   * @param {object} configureOptions    | the fully configured and predefined options set found in allOptions.js
   * @param {number} pixelRatio          | canvas pixel ratio
   * @param {Function} hideOption        | custom logic to dynamically hide options
   */ function Configurator(parentModule, defaultContainer, configureOptions) {
        var pixelRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var hideOption = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function() {
            return false;
        };
        _classCallCheck(this, Configurator);
        this.parent = parentModule;
        this.changedOptions = [];
        this.container = defaultContainer;
        this.allowCreation = false;
        this.hideOption = hideOption;
        this.options = {};
        this.initialized = false;
        this.popupCounter = 0;
        this.defaultOptions = {
            enabled: false,
            filter: true,
            container: undefined,
            showButton: true
        };
        _Object$assign(this.options, this.defaultOptions);
        this.configureOptions = configureOptions;
        this.moduleOptions = {};
        this.domElements = [];
        this.popupDiv = {};
        this.popupLimit = 5;
        this.popupHistory = {};
        this.colorPicker = new ColorPicker$1(pixelRatio);
        this.wrapper = undefined;
    }
    /**
   * refresh all options.
   * Because all modules parse their options by themselves, we just use their options. We copy them here.
   *
   * @param {object} options
   */ _createClass(Configurator, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // reset the popup history because the indices may have been changed.
                    this.popupHistory = {};
                    this._removePopup();
                    var enabled = true;
                    if (typeof options === "string") this.options.filter = options;
                    else if (_Array$isArray(options)) this.options.filter = options.join();
                    else if (_typeof$1(options) === "object") {
                        if (options == null) throw new TypeError("options cannot be null");
                        if (options.container !== undefined) this.options.container = options.container;
                        if (_filterInstanceProperty(options) !== undefined) this.options.filter = _filterInstanceProperty(options);
                        if (options.showButton !== undefined) this.options.showButton = options.showButton;
                        if (options.enabled !== undefined) enabled = options.enabled;
                    } else if (typeof options === "boolean") {
                        this.options.filter = true;
                        enabled = options;
                    } else if (typeof options === "function") {
                        this.options.filter = options;
                        enabled = true;
                    }
                    if (_filterInstanceProperty(this.options) === false) enabled = false;
                    this.options.enabled = enabled;
                }
                this._clean();
            }
        },
        {
            key: "setModuleOptions",
            value: function setModuleOptions(moduleOptions) {
                this.moduleOptions = moduleOptions;
                if (this.options.enabled === true) {
                    this._clean();
                    if (this.options.container !== undefined) this.container = this.options.container;
                    this._create();
                }
            }
        },
        {
            key: "_create",
            value: function _create() {
                this._clean();
                this.changedOptions = [];
                var filter = _filterInstanceProperty(this.options);
                var counter = 0;
                var show = false;
                for(var _option in this.configureOptions)if (Object.prototype.hasOwnProperty.call(this.configureOptions, _option)) {
                    this.allowCreation = false;
                    show = false;
                    if (typeof filter === "function") {
                        show = filter(_option, []);
                        show = show || this._handleObject(this.configureOptions[_option], [
                            _option
                        ], true);
                    } else if (filter === true || _indexOfInstanceProperty(filter).call(filter, _option) !== -1) show = true;
                    if (show !== false) {
                        this.allowCreation = true;
                        // linebreak between categories
                        if (counter > 0) this._makeItem([]);
                        // a header for the category
                        this._makeHeader(_option);
                        // get the sub options
                        this._handleObject(this.configureOptions[_option], [
                            _option
                        ]);
                    }
                    counter++;
                }
                this._makeButton();
                this._push();
            //~ this.colorPicker.insertTo(this.container);
            }
        },
        {
            key: "_push",
            value: function _push() {
                this.wrapper = document.createElement("div");
                this.wrapper.className = "vis-configuration-wrapper";
                this.container.appendChild(this.wrapper);
                for(var i1 = 0; i1 < this.domElements.length; i1++)this.wrapper.appendChild(this.domElements[i1]);
                this._showPopupIfNeeded();
            }
        },
        {
            key: "_clean",
            value: function _clean() {
                for(var i1 = 0; i1 < this.domElements.length; i1++)this.wrapper.removeChild(this.domElements[i1]);
                if (this.wrapper !== undefined) {
                    this.container.removeChild(this.wrapper);
                    this.wrapper = undefined;
                }
                this.domElements = [];
                this._removePopup();
            }
        },
        {
            key: "_getValue",
            value: function _getValue(path) {
                var base = this.moduleOptions;
                for(var i1 = 0; i1 < path.length; i1++)if (base[path[i1]] !== undefined) base = base[path[i1]];
                else {
                    base = undefined;
                    break;
                }
                return base;
            }
        },
        {
            key: "_makeItem",
            value: function _makeItem(path) {
                if (this.allowCreation === true) {
                    var item = document.createElement("div");
                    item.className = "vis-configuration vis-config-item vis-config-s" + path.length;
                    for(var _len6 = arguments.length, domElements = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)domElements[_key6 - 1] = arguments[_key6];
                    _forEachInstanceProperty(domElements).call(domElements, function(element) {
                        item.appendChild(element);
                    });
                    this.domElements.push(item);
                    return this.domElements.length;
                }
                return 0;
            }
        },
        {
            key: "_makeHeader",
            value: function _makeHeader(name) {
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-header";
                div.innerText = name;
                this._makeItem([], div);
            }
        },
        {
            key: "_makeLabel",
            value: function _makeLabel(name, path) {
                var objectLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-label vis-config-s" + path.length;
                if (objectLabel === true) {
                    while(div.firstChild)div.removeChild(div.firstChild);
                    div.appendChild(wrapInTag("i", "b", name));
                } else div.innerText = name + ":";
                return div;
            }
        },
        {
            key: "_makeDropdown",
            value: function _makeDropdown(arr, value, path) {
                var select = document.createElement("select");
                select.className = "vis-configuration vis-config-select";
                var selectedValue = 0;
                if (value !== undefined) {
                    if (_indexOfInstanceProperty(arr).call(arr, value) !== -1) selectedValue = _indexOfInstanceProperty(arr).call(arr, value);
                }
                for(var i1 = 0; i1 < arr.length; i1++){
                    var _option2 = document.createElement("option");
                    _option2.value = arr[i1];
                    if (i1 === selectedValue) _option2.selected = "selected";
                    _option2.innerText = arr[i1];
                    select.appendChild(_option2);
                }
                var me = this;
                select.onchange = function() {
                    me._update(this.value, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, select);
            }
        },
        {
            key: "_makeRange",
            value: function _makeRange(arr, value, path) {
                var defaultValue = arr[0];
                var min = arr[1];
                var max = arr[2];
                var step = arr[3];
                var range = document.createElement("input");
                range.className = "vis-configuration vis-config-range";
                try {
                    range.type = "range"; // not supported on IE9
                    range.min = min;
                    range.max = max;
                } catch (err) {
                // TODO: Add some error handling.
                }
                range.step = step;
                // set up the popup settings in case they are needed.
                var popupString = "";
                var popupValue = 0;
                if (value !== undefined) {
                    var factor = 1.2;
                    if (value < 0 && value * factor < min) {
                        range.min = Math.ceil(value * factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    } else if (value / factor < min) {
                        range.min = Math.ceil(value / factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    }
                    if (value * factor > max && max !== 1) {
                        range.max = Math.ceil(value * factor);
                        popupValue = range.max;
                        popupString = "range increased";
                    }
                    range.value = value;
                } else range.value = defaultValue;
                var input = document.createElement("input");
                input.className = "vis-configuration vis-config-rangeinput";
                input.value = range.value;
                var me = this;
                range.onchange = function() {
                    input.value = this.value;
                    me._update(Number(this.value), path);
                };
                range.oninput = function() {
                    input.value = this.value;
                };
                var label = this._makeLabel(path[path.length - 1], path);
                var itemIndex = this._makeItem(path, label, range, input);
                // if a popup is needed AND it has not been shown for this value, show it.
                if (popupString !== "" && this.popupHistory[itemIndex] !== popupValue) {
                    this.popupHistory[itemIndex] = popupValue;
                    this._setupPopup(popupString, itemIndex);
                }
            }
        },
        {
            key: "_makeButton",
            value: function _makeButton() {
                var _this4 = this;
                if (this.options.showButton === true) {
                    var generateButton = document.createElement("div");
                    generateButton.className = "vis-configuration vis-config-button";
                    generateButton.innerText = "generate options";
                    generateButton.onclick = function() {
                        _this4._printOptions();
                    };
                    generateButton.onmouseover = function() {
                        generateButton.className = "vis-configuration vis-config-button hover";
                    };
                    generateButton.onmouseout = function() {
                        generateButton.className = "vis-configuration vis-config-button";
                    };
                    this.optionsContainer = document.createElement("div");
                    this.optionsContainer.className = "vis-configuration vis-config-option-container";
                    this.domElements.push(this.optionsContainer);
                    this.domElements.push(generateButton);
                }
            }
        },
        {
            key: "_setupPopup",
            value: function _setupPopup(string, index) {
                var _this5 = this;
                if (this.initialized === true && this.allowCreation === true && this.popupCounter < this.popupLimit) {
                    var div = document.createElement("div");
                    div.id = "vis-configuration-popup";
                    div.className = "vis-configuration-popup";
                    div.innerText = string;
                    div.onclick = function() {
                        _this5._removePopup();
                    };
                    this.popupCounter += 1;
                    this.popupDiv = {
                        html: div,
                        index: index
                    };
                }
            }
        },
        {
            key: "_removePopup",
            value: function _removePopup() {
                if (this.popupDiv.html !== undefined) {
                    this.popupDiv.html.parentNode.removeChild(this.popupDiv.html);
                    clearTimeout(this.popupDiv.hideTimeout);
                    clearTimeout(this.popupDiv.deleteTimeout);
                    this.popupDiv = {};
                }
            }
        },
        {
            key: "_showPopupIfNeeded",
            value: function _showPopupIfNeeded() {
                var _this6 = this;
                if (this.popupDiv.html !== undefined) {
                    var correspondingElement = this.domElements[this.popupDiv.index];
                    var rect = correspondingElement.getBoundingClientRect();
                    this.popupDiv.html.style.left = rect.left + "px";
                    this.popupDiv.html.style.top = rect.top - 30 + "px"; // 30 is the height;
                    document.body.appendChild(this.popupDiv.html);
                    this.popupDiv.hideTimeout = _setTimeout(function() {
                        _this6.popupDiv.html.style.opacity = 0;
                    }, 1500);
                    this.popupDiv.deleteTimeout = _setTimeout(function() {
                        _this6._removePopup();
                    }, 1800);
                }
            }
        },
        {
            key: "_makeCheckbox",
            value: function _makeCheckbox(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "checkbox";
                checkbox.className = "vis-configuration vis-config-checkbox";
                checkbox.checked = defaultValue;
                if (value !== undefined) {
                    checkbox.checked = value;
                    if (value !== defaultValue) {
                        if (_typeof$1(defaultValue) === "object") {
                            if (value !== defaultValue.enabled) this.changedOptions.push({
                                path: path,
                                value: value
                            });
                        } else this.changedOptions.push({
                            path: path,
                            value: value
                        });
                    }
                }
                var me = this;
                checkbox.onchange = function() {
                    me._update(this.checked, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, checkbox);
            }
        },
        {
            key: "_makeTextInput",
            value: function _makeTextInput(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "text";
                checkbox.className = "vis-configuration vis-config-text";
                checkbox.value = value;
                if (value !== defaultValue) this.changedOptions.push({
                    path: path,
                    value: value
                });
                var me = this;
                checkbox.onchange = function() {
                    me._update(this.value, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, checkbox);
            }
        },
        {
            key: "_makeColorField",
            value: function _makeColorField(arr, value, path) {
                var _this7 = this;
                var defaultColor = arr[1];
                var div = document.createElement("div");
                value = value === undefined ? defaultColor : value;
                if (value !== "none") {
                    div.className = "vis-configuration vis-config-colorBlock";
                    div.style.backgroundColor = value;
                } else div.className = "vis-configuration vis-config-colorBlock none";
                value = value === undefined ? defaultColor : value;
                div.onclick = function() {
                    _this7._showColorPicker(value, div, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, div);
            }
        },
        {
            key: "_showColorPicker",
            value: function _showColorPicker(value, div, path) {
                var _this8 = this;
                // clear the callback from this div
                div.onclick = function() {};
                this.colorPicker.insertTo(div);
                this.colorPicker.show();
                this.colorPicker.setColor(value);
                this.colorPicker.setUpdateCallback(function(color) {
                    var colorString = "rgba(" + color.r + "," + color.g + "," + color.b + "," + color.a + ")";
                    div.style.backgroundColor = colorString;
                    _this8._update(colorString, path);
                });
                // on close of the colorpicker, restore the callback.
                this.colorPicker.setCloseCallback(function() {
                    div.onclick = function() {
                        _this8._showColorPicker(value, div, path);
                    };
                });
            }
        },
        {
            key: "_handleObject",
            value: function _handleObject(obj) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var checkOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var show = false;
                var filter = _filterInstanceProperty(this.options);
                var visibleInSet = false;
                for(var subObj in obj)if (Object.prototype.hasOwnProperty.call(obj, subObj)) {
                    show = true;
                    var item = obj[subObj];
                    var newPath = copyAndExtendArray(path, subObj);
                    if (typeof filter === "function") {
                        show = filter(subObj, path);
                        // if needed we must go deeper into the object.
                        if (show === false) {
                            if (!_Array$isArray(item) && typeof item !== "string" && typeof item !== "boolean" && item instanceof Object) {
                                this.allowCreation = false;
                                show = this._handleObject(item, newPath, true);
                                this.allowCreation = checkOnly === false;
                            }
                        }
                    }
                    if (show !== false) {
                        visibleInSet = true;
                        var value = this._getValue(newPath);
                        if (_Array$isArray(item)) this._handleArray(item, value, newPath);
                        else if (typeof item === "string") this._makeTextInput(item, value, newPath);
                        else if (typeof item === "boolean") this._makeCheckbox(item, value, newPath);
                        else if (item instanceof Object) // skip the options that are not enabled
                        {
                            if (!this.hideOption(path, subObj, this.moduleOptions)) {
                                // initially collapse options with an disabled enabled option.
                                if (item.enabled !== undefined) {
                                    var enabledPath = copyAndExtendArray(newPath, "enabled");
                                    var enabledValue = this._getValue(enabledPath);
                                    if (enabledValue === true) {
                                        var label = this._makeLabel(subObj, newPath, true);
                                        this._makeItem(newPath, label);
                                        visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                    } else this._makeCheckbox(item, enabledValue, newPath);
                                } else {
                                    var _label = this._makeLabel(subObj, newPath, true);
                                    this._makeItem(newPath, _label);
                                    visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                }
                            }
                        } else console.error("dont know how to handle", item, subObj, newPath);
                    }
                }
                return visibleInSet;
            }
        },
        {
            key: "_handleArray",
            value: function _handleArray(arr, value, path) {
                if (typeof arr[0] === "string" && arr[0] === "color") {
                    this._makeColorField(arr, value, path);
                    if (arr[1] !== value) this.changedOptions.push({
                        path: path,
                        value: value
                    });
                } else if (typeof arr[0] === "string") {
                    this._makeDropdown(arr, value, path);
                    if (arr[0] !== value) this.changedOptions.push({
                        path: path,
                        value: value
                    });
                } else if (typeof arr[0] === "number") {
                    this._makeRange(arr, value, path);
                    if (arr[0] !== value) this.changedOptions.push({
                        path: path,
                        value: Number(value)
                    });
                }
            }
        },
        {
            key: "_update",
            value: function _update(value, path) {
                var options = this._constructOptions(value, path);
                if (this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit) this.parent.body.emitter.emit("configChange", options);
                this.initialized = true;
                this.parent.setOptions(options);
            }
        },
        {
            key: "_constructOptions",
            value: function _constructOptions(value, path) {
                var optionsObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var pointer = optionsObj;
                // when dropdown boxes can be string or boolean, we typecast it into correct types
                value = value === "true" ? true : value;
                value = value === "false" ? false : value;
                for(var i1 = 0; i1 < path.length; i1++)if (path[i1] !== "global") {
                    if (pointer[path[i1]] === undefined) pointer[path[i1]] = {};
                    if (i1 !== path.length - 1) pointer = pointer[path[i1]];
                    else pointer[path[i1]] = value;
                }
                return optionsObj;
            }
        },
        {
            key: "_printOptions",
            value: function _printOptions() {
                var options = this.getOptions();
                while(this.optionsContainer.firstChild)this.optionsContainer.removeChild(this.optionsContainer.firstChild);
                this.optionsContainer.appendChild(wrapInTag("pre", "const options = " + _JSON$stringify(options, null, 2)));
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var options = {};
                for(var i1 = 0; i1 < this.changedOptions.length; i1++)this._constructOptions(this.changedOptions[i1].value, this.changedOptions[i1].path, options);
                return options;
            }
        }
    ]);
    return Configurator;
}();
/**
 * Popup is a class to create a popup window with some text
 */ var Popup$1 = /*#__PURE__*/ function() {
    /**
   * @param {Element} container       The container object.
   * @param {string}  overflowMethod  How the popup should act to overflowing ('flip' or 'cap')
   */ function Popup(container, overflowMethod) {
        _classCallCheck(this, Popup);
        this.container = container;
        this.overflowMethod = overflowMethod || "cap";
        this.x = 0;
        this.y = 0;
        this.padding = 5;
        this.hidden = false;
        // create the frame
        this.frame = document.createElement("div");
        this.frame.className = "vis-tooltip";
        this.container.appendChild(this.frame);
    }
    /**
   * @param {number} x   Horizontal position of the popup window
   * @param {number} y   Vertical position of the popup window
   */ _createClass(Popup, [
        {
            key: "setPosition",
            value: function setPosition(x, y) {
                this.x = _parseInt$1(x);
                this.y = _parseInt$1(y);
            }
        },
        {
            key: "setText",
            value: function setText(content) {
                if (content instanceof Element) {
                    while(this.frame.firstChild)this.frame.removeChild(this.frame.firstChild);
                    this.frame.appendChild(content);
                } else // String containing literal text, element has to be used for HTML due to
                // XSS risks associated with innerHTML (i.e. prevent XSS by accident).
                this.frame.innerText = content;
            }
        },
        {
            key: "show",
            value: function show(doShow) {
                if (doShow === undefined) doShow = true;
                if (doShow === true) {
                    var height = this.frame.clientHeight;
                    var width = this.frame.clientWidth;
                    var maxHeight = this.frame.parentNode.clientHeight;
                    var maxWidth = this.frame.parentNode.clientWidth;
                    var left = 0, top = 0;
                    if (this.overflowMethod == "flip") {
                        var isLeft = false, isTop = true; // Where around the position it's located
                        if (this.y - height < this.padding) isTop = false;
                        if (this.x + width > maxWidth - this.padding) isLeft = true;
                        if (isLeft) left = this.x - width;
                        else left = this.x;
                        if (isTop) top = this.y - height;
                        else top = this.y;
                    } else {
                        top = this.y - height;
                        if (top + height + this.padding > maxHeight) top = maxHeight - height - this.padding;
                        if (top < this.padding) top = this.padding;
                        left = this.x;
                        if (left + width + this.padding > maxWidth) left = maxWidth - width - this.padding;
                        if (left < this.padding) left = this.padding;
                    }
                    this.frame.style.left = left + "px";
                    this.frame.style.top = top + "px";
                    this.frame.style.visibility = "visible";
                    this.hidden = false;
                } else this.hide();
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.hidden = true;
                this.frame.style.left = "0";
                this.frame.style.top = "0";
                this.frame.style.visibility = "hidden";
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.frame.parentNode.removeChild(this.frame); // Remove element from DOM
            }
        }
    ]);
    return Popup;
}();
var errorFound$1 = false;
var allOptions$3;
var VALIDATOR_PRINT_STYLE$1 = "background: #FFeeee; color: #dd0000";
/**
 *  Used to validate options.
 */ var Validator$1 = /*#__PURE__*/ function() {
    function Validator() {
        _classCallCheck(this, Validator);
    }
    _createClass(Validator, null, [
        {
            key: "validate",
            value: /**
     * Main function to be called
     *
     * @param {object} options
     * @param {object} referenceOptions
     * @param {object} subObject
     * @returns {boolean}
     * @static
     */ function validate(options, referenceOptions, subObject) {
                errorFound$1 = false;
                allOptions$3 = referenceOptions;
                var usedOptions = referenceOptions;
                if (subObject !== undefined) usedOptions = referenceOptions[subObject];
                Validator.parse(options, usedOptions, []);
                return errorFound$1;
            }
        },
        {
            key: "parse",
            value: function parse(options, referenceOptions, path) {
                for(var _option3 in options)if (Object.prototype.hasOwnProperty.call(options, _option3)) Validator.check(_option3, options, referenceOptions, path);
            }
        },
        {
            key: "check",
            value: function check(option, options, referenceOptions, path) {
                if (referenceOptions[option] === undefined && referenceOptions.__any__ === undefined) {
                    Validator.getSuggestion(option, referenceOptions, path);
                    return;
                }
                var referenceOption = option;
                var is_object = true;
                if (referenceOptions[option] === undefined && referenceOptions.__any__ !== undefined) {
                    // NOTE: This only triggers if the __any__ is in the top level of the options object.
                    //       THAT'S A REALLY BAD PLACE TO ALLOW IT!!!!
                    // TODO: Examine if needed, remove if possible
                    // __any__ is a wildcard. Any value is accepted and will be further analysed by reference.
                    referenceOption = "__any__";
                    // if the any-subgroup is not a predefined object in the configurator,
                    // we do not look deeper into the object.
                    is_object = Validator.getType(options[option]) === "object";
                }
                var refOptionObj = referenceOptions[referenceOption];
                if (is_object && refOptionObj.__type__ !== undefined) refOptionObj = refOptionObj.__type__;
                Validator.checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path);
            }
        },
        {
            key: "checkFields",
            value: function checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path) {
                var log = function log(message) {
                    console.error("%c" + message + Validator.printLocation(path, option), VALIDATOR_PRINT_STYLE$1);
                };
                var optionType = Validator.getType(options[option]);
                var refOptionType = refOptionObj[optionType];
                if (refOptionType !== undefined) {
                    // if the type is correct, we check if it is supposed to be one of a few select values
                    if (Validator.getType(refOptionType) === "array" && _indexOfInstanceProperty(refOptionType).call(refOptionType, options[option]) === -1) {
                        log('Invalid option detected in "' + option + '".' + " Allowed values are:" + Validator.print(refOptionType) + ' not "' + options[option] + '". ');
                        errorFound$1 = true;
                    } else if (optionType === "object" && referenceOption !== "__any__") {
                        path = copyAndExtendArray(path, option);
                        Validator.parse(options[option], referenceOptions[referenceOption], path);
                    }
                } else if (refOptionObj["any"] === undefined) {
                    // type of the field is incorrect and the field cannot be any
                    log('Invalid type received for "' + option + '". Expected: ' + Validator.print(_Object$keys(refOptionObj)) + ". Received [" + optionType + '] "' + options[option] + '"');
                    errorFound$1 = true;
                }
            }
        },
        {
            key: "getType",
            value: function getType(object) {
                var type = _typeof$1(object);
                if (type === "object") {
                    if (object === null) return "null";
                    if (object instanceof Boolean) return "boolean";
                    if (object instanceof Number) return "number";
                    if (object instanceof String) return "string";
                    if (_Array$isArray(object)) return "array";
                    if (object instanceof Date) return "date";
                    if (object.nodeType !== undefined) return "dom";
                    if (object._isAMomentObject === true) return "moment";
                    return "object";
                } else if (type === "number") return "number";
                else if (type === "boolean") return "boolean";
                else if (type === "string") return "string";
                else if (type === undefined) return "undefined";
                return type;
            }
        },
        {
            key: "getSuggestion",
            value: function getSuggestion(option, options, path) {
                var localSearch = Validator.findInOptions(option, options, path, false);
                var globalSearch = Validator.findInOptions(option, allOptions$3, [], true);
                var localSearchThreshold = 8;
                var globalSearchThreshold = 4;
                var msg;
                if (localSearch.indexMatch !== undefined) msg = " in " + Validator.printLocation(localSearch.path, option, "") + 'Perhaps it was incomplete? Did you mean: "' + localSearch.indexMatch + '"?\n\n';
                else if (globalSearch.distance <= globalSearchThreshold && localSearch.distance > globalSearch.distance) msg = " in " + Validator.printLocation(localSearch.path, option, "") + "Perhaps it was misplaced? Matching option found at: " + Validator.printLocation(globalSearch.path, globalSearch.closestMatch, "");
                else if (localSearch.distance <= localSearchThreshold) msg = '. Did you mean "' + localSearch.closestMatch + '"?' + Validator.printLocation(localSearch.path, option);
                else msg = ". Did you mean one of these: " + Validator.print(_Object$keys(options)) + Validator.printLocation(path, option);
                console.error('%cUnknown option detected: "' + option + '"' + msg, VALIDATOR_PRINT_STYLE$1);
                errorFound$1 = true;
            }
        },
        {
            key: "findInOptions",
            value: function findInOptions(option, options, path) {
                var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var min = 1e9;
                var closestMatch = "";
                var closestMatchPath = [];
                var lowerCaseOption = option.toLowerCase();
                var indexMatch = undefined;
                for(var op in options){
                    var distance = void 0;
                    if (options[op].__type__ !== undefined && recursive === true) {
                        var result = Validator.findInOptions(option, options[op], copyAndExtendArray(path, op));
                        if (min > result.distance) {
                            closestMatch = result.closestMatch;
                            closestMatchPath = result.path;
                            min = result.distance;
                            indexMatch = result.indexMatch;
                        }
                    } else {
                        var _context16;
                        if (_indexOfInstanceProperty(_context16 = op.toLowerCase()).call(_context16, lowerCaseOption) !== -1) indexMatch = op;
                        distance = Validator.levenshteinDistance(option, op);
                        if (min > distance) {
                            closestMatch = op;
                            closestMatchPath = copyArray(path);
                            min = distance;
                        }
                    }
                }
                return {
                    closestMatch: closestMatch,
                    path: closestMatchPath,
                    distance: min,
                    indexMatch: indexMatch
                };
            }
        },
        {
            key: "printLocation",
            value: function printLocation(path, option) {
                var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Problem value found at: \n";
                var str = "\n\n" + prefix + "options = {\n";
                for(var i1 = 0; i1 < path.length; i1++){
                    for(var j = 0; j < i1 + 1; j++)str += "  ";
                    str += path[i1] + ": {\n";
                }
                for(var _j = 0; _j < path.length + 1; _j++)str += "  ";
                str += option + "\n";
                for(var _i5 = 0; _i5 < path.length + 1; _i5++){
                    for(var _j2 = 0; _j2 < path.length - _i5; _j2++)str += "  ";
                    str += "}\n";
                }
                return str + "\n\n";
            }
        },
        {
            key: "print",
            value: function print(options) {
                return _JSON$stringify(options).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
            }
        },
        {
            key: "levenshteinDistance",
            value: function levenshteinDistance(a, b) {
                if (a.length === 0) return b.length;
                if (b.length === 0) return a.length;
                var matrix = [];
                // increment along the first column of each row
                var i1;
                for(i1 = 0; i1 <= b.length; i1++)matrix[i1] = [
                    i1
                ];
                // increment each column in the first row
                var j;
                for(j = 0; j <= a.length; j++)matrix[0][j] = j;
                // Fill in the rest of the matrix
                for(i1 = 1; i1 <= b.length; i1++){
                    for(j = 1; j <= a.length; j++)if (b.charAt(i1 - 1) == a.charAt(j - 1)) matrix[i1][j] = matrix[i1 - 1][j - 1];
                    else matrix[i1][j] = Math.min(matrix[i1 - 1][j - 1] + 1, // substitution
                    Math.min(matrix[i1][j - 1] + 1, // insertion
                    matrix[i1 - 1][j] + 1)); // deletion
                }
                return matrix[b.length][a.length];
            }
        }
    ]);
    return Validator;
}();
var Activator$2 = Activator$1;
var ColorPicker$2 = ColorPicker$1;
var Configurator$2 = Configurator$1;
var Hammer$2 = Hammer$1;
var Popup$2 = Popup$1;
var VALIDATOR_PRINT_STYLE = VALIDATOR_PRINT_STYLE$1;
var Validator$2 = Validator$1;
var util$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Activator: Activator$2,
    Alea: Alea,
    ColorPicker: ColorPicker$2,
    Configurator: Configurator$2,
    DELETE: DELETE,
    HSVToHex: HSVToHex,
    HSVToRGB: HSVToRGB,
    Hammer: Hammer$2,
    Popup: Popup$2,
    RGBToHSV: RGBToHSV,
    RGBToHex: RGBToHex,
    VALIDATOR_PRINT_STYLE: VALIDATOR_PRINT_STYLE,
    Validator: Validator$2,
    addClassName: addClassName,
    addCssText: addCssText,
    addEventListener: addEventListener,
    binarySearchCustom: binarySearchCustom,
    binarySearchValue: binarySearchValue,
    bridgeObject: bridgeObject,
    copyAndExtendArray: copyAndExtendArray,
    copyArray: copyArray,
    deepExtend: deepExtend,
    deepObjectAssign: deepObjectAssign,
    easingFunctions: easingFunctions,
    equalArray: equalArray,
    extend: extend,
    fillIfDefined: fillIfDefined,
    forEach: forEach$4,
    getAbsoluteLeft: getAbsoluteLeft,
    getAbsoluteRight: getAbsoluteRight,
    getAbsoluteTop: getAbsoluteTop,
    getScrollBarWidth: getScrollBarWidth,
    getTarget: getTarget,
    getType: getType,
    hasParent: hasParent,
    hexToHSV: hexToHSV,
    hexToRGB: hexToRGB,
    insertSort: insertSort,
    isDate: isDate,
    isNumber: isNumber,
    isObject: isObject$7,
    isString: isString,
    isValidHex: isValidHex,
    isValidRGB: isValidRGB,
    isValidRGBA: isValidRGBA,
    mergeOptions: mergeOptions,
    option: option,
    overrideOpacity: overrideOpacity,
    parseColor: parseColor,
    preventDefault: preventDefault,
    pureDeepObjectAssign: pureDeepObjectAssign,
    recursiveDOMDelete: recursiveDOMDelete,
    removeClassName: removeClassName,
    removeCssText: removeCssText,
    removeEventListener: removeEventListener,
    selectiveBridgeObject: selectiveBridgeObject,
    selectiveDeepExtend: selectiveDeepExtend,
    selectiveExtend: selectiveExtend,
    selectiveNotDeepExtend: selectiveNotDeepExtend,
    throttle: throttle,
    toArray: toArray,
    topMost: topMost,
    updateProperty: updateProperty
});
// DOM utility methods
/**
 * this prepares the JSON container for allocating SVG elements
 * @param {Object} JSONcontainer
 * @private
 */ function prepareElements(JSONcontainer) {
    // cleanup the redundant svgElements;
    for(var elementType in JSONcontainer)if (JSONcontainer.hasOwnProperty(elementType)) {
        JSONcontainer[elementType].redundant = JSONcontainer[elementType].used;
        JSONcontainer[elementType].used = [];
    }
}
/**
 * this cleans up all the unused SVG elements. By asking for the parentNode, we only need to supply the JSON container from
 * which to remove the redundant elements.
 *
 * @param {Object} JSONcontainer
 * @private
 */ function cleanupElements(JSONcontainer) {
    // cleanup the redundant svgElements;
    for(var elementType in JSONcontainer){
        if (JSONcontainer.hasOwnProperty(elementType)) {
            if (JSONcontainer[elementType].redundant) {
                for(var i1 = 0; i1 < JSONcontainer[elementType].redundant.length; i1++)JSONcontainer[elementType].redundant[i1].parentNode.removeChild(JSONcontainer[elementType].redundant[i1]);
                JSONcontainer[elementType].redundant = [];
            }
        }
    }
}
/**
 * Ensures that all elements are removed first up so they can be recreated cleanly
 * @param {Object} JSONcontainer
 */ function resetElements(JSONcontainer) {
    prepareElements(JSONcontainer);
    cleanupElements(JSONcontainer);
    prepareElements(JSONcontainer);
}
/**
 * Allocate or generate an SVG element if needed. Store a reference to it in the JSON container and draw it in the svgContainer
 * the JSON container and the SVG container have to be supplied so other svg containers (like the legend) can use this.
 *
 * @param {string} elementType
 * @param {Object} JSONcontainer
 * @param {Object} svgContainer
 * @returns {Element}
 * @private
 */ function getSVGElement(elementType, JSONcontainer, svgContainer) {
    var element;
    // allocate SVG element, if it doesnt yet exist, create one.
    if (JSONcontainer.hasOwnProperty(elementType)) {
        // this element has been created before
        // check if there is an redundant element
        if (JSONcontainer[elementType].redundant.length > 0) {
            element = JSONcontainer[elementType].redundant[0];
            JSONcontainer[elementType].redundant.shift();
        } else {
            // create a new element and add it to the SVG
            element = document.createElementNS("http://www.w3.org/2000/svg", elementType);
            svgContainer.appendChild(element);
        }
    } else {
        // create a new element and add it to the SVG, also create a new object in the svgElements to keep track of it.
        element = document.createElementNS("http://www.w3.org/2000/svg", elementType);
        JSONcontainer[elementType] = {
            used: [],
            redundant: []
        };
        svgContainer.appendChild(element);
    }
    JSONcontainer[elementType].used.push(element);
    return element;
}
/**
 * Allocate or generate an SVG element if needed. Store a reference to it in the JSON container and draw it in the svgContainer
 * the JSON container and the SVG container have to be supplied so other svg containers (like the legend) can use this.
 *
 * @param {string} elementType
 * @param {Object} JSONcontainer
 * @param {Element} DOMContainer
 * @param {Element} insertBefore
 * @returns {*}
 */ function getDOMElement(elementType, JSONcontainer, DOMContainer, insertBefore) {
    var element;
    // allocate DOM element, if it doesnt yet exist, create one.
    if (JSONcontainer.hasOwnProperty(elementType)) {
        // this element has been created before
        // check if there is an redundant element
        if (JSONcontainer[elementType].redundant.length > 0) {
            element = JSONcontainer[elementType].redundant[0];
            JSONcontainer[elementType].redundant.shift();
        } else {
            // create a new element and add it to the SVG
            element = document.createElement(elementType);
            if (insertBefore !== undefined) DOMContainer.insertBefore(element, insertBefore);
            else DOMContainer.appendChild(element);
        }
    } else {
        // create a new element and add it to the SVG, also create a new object in the svgElements to keep track of it.
        element = document.createElement(elementType);
        JSONcontainer[elementType] = {
            used: [],
            redundant: []
        };
        if (insertBefore !== undefined) DOMContainer.insertBefore(element, insertBefore);
        else DOMContainer.appendChild(element);
    }
    JSONcontainer[elementType].used.push(element);
    return element;
}
/**
 * Draw a point object. This is a separate function because it can also be called by the legend.
 * The reason the JSONcontainer and the target SVG svgContainer have to be supplied is so the legend can use these functions
 * as well.
 *
 * @param {number} x
 * @param {number} y
 * @param {Object} groupTemplate: A template containing the necessary information to draw the datapoint e.g., {style: 'circle', size: 5, className: 'className' }
 * @param {Object} JSONcontainer
 * @param {Object} svgContainer
 * @param {Object} labelObj
 * @returns {vis.PointItem}
 */ function drawPoint(x, y, groupTemplate, JSONcontainer, svgContainer, labelObj) {
    var point;
    if (groupTemplate.style == "circle") {
        point = getSVGElement("circle", JSONcontainer, svgContainer);
        point.setAttributeNS(null, "cx", x);
        point.setAttributeNS(null, "cy", y);
        point.setAttributeNS(null, "r", 0.5 * groupTemplate.size);
    } else {
        point = getSVGElement("rect", JSONcontainer, svgContainer);
        point.setAttributeNS(null, "x", x - 0.5 * groupTemplate.size);
        point.setAttributeNS(null, "y", y - 0.5 * groupTemplate.size);
        point.setAttributeNS(null, "width", groupTemplate.size);
        point.setAttributeNS(null, "height", groupTemplate.size);
    }
    if (groupTemplate.styles !== undefined) point.setAttributeNS(null, "style", groupTemplate.styles);
    point.setAttributeNS(null, "class", groupTemplate.className + " vis-point");
    //handle label
    if (labelObj) {
        var label = getSVGElement("text", JSONcontainer, svgContainer);
        if (labelObj.xOffset) x = x + labelObj.xOffset;
        if (labelObj.yOffset) y = y + labelObj.yOffset;
        if (labelObj.content) label.textContent = labelObj.content;
        if (labelObj.className) label.setAttributeNS(null, "class", labelObj.className + " vis-label");
        label.setAttributeNS(null, "x", x);
        label.setAttributeNS(null, "y", y);
    }
    return point;
}
/**
 * draw a bar SVG element centered on the X coordinate
 *
 * @param {number} x
 * @param {number} y
 * @param {number} width
 * @param {number} height
 * @param {string} className
 * @param {Object} JSONcontainer
 * @param {Object} svgContainer
 * @param {string} style
 */ function drawBar(x, y, width, height, className, JSONcontainer, svgContainer, style) {
    if (height != 0) {
        if (height < 0) {
            height *= -1;
            y -= height;
        }
        var rect = getSVGElement("rect", JSONcontainer, svgContainer);
        rect.setAttributeNS(null, "x", x - 0.5 * width);
        rect.setAttributeNS(null, "y", y);
        rect.setAttributeNS(null, "width", width);
        rect.setAttributeNS(null, "height", height);
        rect.setAttributeNS(null, "class", className);
        if (style) rect.setAttributeNS(null, "style", style);
    }
}
/**
 * get default language
 * @returns {string}
 */ function getNavigatorLanguage() {
    try {
        if (!navigator) return "en";
        if (navigator.languages && navigator.languages.length) return navigator.languages;
        else return navigator.userLanguage || navigator.language || navigator.browserLanguage || "en";
    } catch (error) {
        return "en";
    }
}
var DOMutil = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    cleanupElements: cleanupElements,
    drawBar: drawBar,
    drawPoint: drawPoint,
    getDOMElement: getDOMElement,
    getNavigatorLanguage: getNavigatorLanguage,
    getSVGElement: getSVGElement,
    prepareElements: prepareElements,
    resetElements: resetElements
});
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
var parent$B = create$7;
var create$5 = parent$B;
var parent$A = create$5;
var create$4 = parent$A;
var create$3 = create$4;
var _Object$create = /*@__PURE__*/ getDefaultExportFromCjs(create$3);
var $$r = _export;
var setPrototypeOf$6 = objectSetPrototypeOf;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$$r({
    target: "Object",
    stat: true
}, {
    setPrototypeOf: setPrototypeOf$6
});
var path$a = path$u;
var setPrototypeOf$5 = path$a.Object.setPrototypeOf;
var parent$z = setPrototypeOf$5;
var setPrototypeOf$4 = parent$z;
var parent$y = setPrototypeOf$4;
var setPrototypeOf$3 = parent$y;
var parent$x = setPrototypeOf$3;
var setPrototypeOf$2 = parent$x;
var setPrototypeOf$1 = setPrototypeOf$2;
var _Object$setPrototypeOf = /*@__PURE__*/ getDefaultExportFromCjs(setPrototypeOf$1);
var parent$w = bind$b;
var bind$9 = parent$w;
var parent$v = bind$9;
var bind$8 = parent$v;
var bind$7 = bind$8;
var _bindInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(bind$7);
function _setPrototypeOf(o, p) {
    var _context;
    _setPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$setPrototypeOf).call(_context) : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = _Object$create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    _Object$defineProperty$1(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self1, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self1);
}
var parent$u = getPrototypeOf$5;
var getPrototypeOf$3 = parent$u;
var parent$t = getPrototypeOf$3;
var getPrototypeOf$2 = parent$t;
var getPrototypeOf$1 = getPrototypeOf$2;
var _Object$getPrototypeOf = /*@__PURE__*/ getDefaultExportFromCjs(getPrototypeOf$1);
function _getPrototypeOf(o) {
    var _context;
    _getPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$getPrototypeOf).call(_context) : function _getPrototypeOf(o) {
        return o.__proto__ || _Object$getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) _Object$defineProperty$1(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var regeneratorRuntime$1 = {
    exports: {}
};
var _typeof = {
    exports: {}
};
(function(module) {
    var _Symbol = symbol$1;
    var _Symbol$iterator = iterator$1;
    function _typeof(o) {
        "@babel/helpers - typeof";
        return module.exports = _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof _Symbol && o.constructor === _Symbol && o !== _Symbol.prototype ? "symbol" : typeof o;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
    }
    module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof);
var _typeofExports = _typeof.exports;
var parent$s = forEach$6;
var forEach$3 = parent$s;
var parent$r = forEach$3;
var forEach$2 = parent$r;
var forEach$1 = forEach$2;
var hasOwn$5 = hasOwnProperty_1;
var ownKeys$3 = ownKeys$8;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;
var copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = ownKeys$3(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
    for(var i1 = 0; i1 < keys.length; i1++){
        var key = keys[i1];
        if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var isObject$6 = isObject$j;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function(O, options) {
    if (isObject$6(options) && "cause" in options) createNonEnumerableProperty$3(O, "cause", options.cause);
};
var uncurryThis$3 = functionUncurryThis;
var $Error$1 = Error;
var replace = uncurryThis$3("".replace);
var TEST = function(arg) {
    return String(new $Error$1(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
var errorStackClear = function(stack, dropEntries) {
    if (IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$Error$1.prepareStackTrace) while(dropEntries--)stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};
var fails$a = fails$y;
var createPropertyDescriptor$1 = createPropertyDescriptor$7;
var errorStackInstallable = !fails$a(function() {
    var error = new Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", createPropertyDescriptor$1(1, 7));
    return error.stack !== 7;
});
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;
// non-standard V8
var captureStackTrace = Error.captureStackTrace;
var errorStackInstall = function(error, C, stack, dropEntries) {
    if (ERROR_STACK_INSTALLABLE) {
        if (captureStackTrace) captureStackTrace(error, C);
        else createNonEnumerableProperty$2(error, "stack", clearErrorStack(stack, dropEntries));
    }
};
var bind$6 = functionBindContext;
var call$6 = functionCall;
var anObject$3 = anObject$d;
var tryToString$1 = tryToString$6;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var lengthOfArrayLike$4 = lengthOfArrayLike$e;
var isPrototypeOf$d = objectIsPrototypeOf;
var getIterator$6 = getIterator$8;
var getIteratorMethod = getIteratorMethod$9;
var iteratorClose = iteratorClose$2;
var $TypeError$4 = TypeError;
var Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var ResultPrototype = Result.prototype;
var iterate$7 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = bind$6(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) iteratorClose(iterator, "normal", condition);
        return new Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = getIteratorMethod(iterable);
        if (!iterFn) throw new $TypeError$4(tryToString$1(iterable) + " is not iterable");
        // optimisation for array iterators
        if (isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = lengthOfArrayLike$4(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && isPrototypeOf$d(ResultPrototype, result)) return result;
            }
            return new Result(false);
        }
        iterator = getIterator$6(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = call$6(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && isPrototypeOf$d(ResultPrototype, result)) return result;
    }
    return new Result(false);
};
var toString$3 = toString$c;
var normalizeStringArgument$1 = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : toString$3(argument);
};
var $$q = _export;
var isPrototypeOf$c = objectIsPrototypeOf;
var getPrototypeOf = objectGetPrototypeOf$1;
var setPrototypeOf = objectSetPrototypeOf;
var copyConstructorProperties = copyConstructorProperties$1;
var create$2 = objectCreate;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var createPropertyDescriptor = createPropertyDescriptor$7;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var iterate$6 = iterate$7;
var normalizeStringArgument = normalizeStringArgument$1;
var wellKnownSymbol$3 = wellKnownSymbol$p;
var TO_STRING_TAG = wellKnownSymbol$3("toStringTag");
var $Error = Error;
var push$2 = [].push;
var $AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = isPrototypeOf$c(AggregateErrorPrototype, this);
    var that;
    if (setPrototypeOf) that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
    else {
        that = isInstance ? this : create$2(AggregateErrorPrototype);
        createNonEnumerableProperty$1(that, TO_STRING_TAG, "Error");
    }
    if (message !== undefined) createNonEnumerableProperty$1(that, "message", normalizeStringArgument(message));
    installErrorStack(that, $AggregateError, that.stack, 1);
    if (arguments.length > 2) installErrorCause(that, arguments[2]);
    var errorsArray = [];
    iterate$6(errors, push$2, {
        that: errorsArray
    });
    createNonEnumerableProperty$1(that, "errors", errorsArray);
    return that;
};
if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, {
    name: true
});
var AggregateErrorPrototype = $AggregateError.prototype = create$2($Error.prototype, {
    constructor: createPropertyDescriptor(1, $AggregateError),
    message: createPropertyDescriptor(1, ""),
    name: createPropertyDescriptor(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$$q({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $AggregateError
});
var global$8 = global$q;
var classof$4 = classofRaw$2;
var engineIsNode = classof$4(global$8.process) === "process";
var getBuiltIn$4 = getBuiltIn$f;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$3;
var wellKnownSymbol$2 = wellKnownSymbol$p;
var DESCRIPTORS$5 = descriptors;
var SPECIES$2 = wellKnownSymbol$2("species");
var setSpecies$2 = function(CONSTRUCTOR_NAME) {
    var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);
    if (DESCRIPTORS$5 && Constructor && !Constructor[SPECIES$2]) defineBuiltInAccessor$1(Constructor, SPECIES$2, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var isPrototypeOf$b = objectIsPrototypeOf;
var $TypeError$3 = TypeError;
var anInstance$3 = function(it, Prototype) {
    if (isPrototypeOf$b(Prototype, it)) return it;
    throw new $TypeError$3("Incorrect invocation");
};
var isConstructor = isConstructor$4;
var tryToString = tryToString$6;
var $TypeError$2 = TypeError;
// `Assert: IsConstructor(argument) is true`
var aConstructor$2 = function(argument) {
    if (isConstructor(argument)) return argument;
    throw new $TypeError$2(tryToString(argument) + " is not a constructor");
};
var anObject$2 = anObject$d;
var aConstructor$1 = aConstructor$2;
var isNullOrUndefined$2 = isNullOrUndefined$6;
var wellKnownSymbol$1 = wellKnownSymbol$p;
var SPECIES$1 = wellKnownSymbol$1("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function(O, defaultConstructor) {
    var C = anObject$2(O).constructor;
    var S;
    return C === undefined || isNullOrUndefined$2(S = anObject$2(C)[SPECIES$1]) ? defaultConstructor : aConstructor$1(S);
};
var userAgent$4 = engineUserAgent;
// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);
var global$7 = global$q;
var apply$1 = functionApply;
var bind$5 = functionBindContext;
var isCallable$4 = isCallable$m;
var hasOwn$4 = hasOwnProperty_1;
var fails$9 = fails$y;
var html = html$2;
var arraySlice$1 = arraySlice$5;
var createElement = documentCreateElement$1;
var validateArgumentsLength = validateArgumentsLength$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$4 = engineIsNode;
var set$3 = global$7.setImmediate;
var clear = global$7.clearImmediate;
var process$2 = global$7.process;
var Dispatch = global$7.Dispatch;
var Function$1 = global$7.Function;
var MessageChannel = global$7.MessageChannel;
var String$1 = global$7.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = "onreadystatechange";
var $location, defer, channel, port;
fails$9(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $location = global$7.location;
});
var run = function(id) {
    if (hasOwn$4(queue$2, id)) {
        var fn = queue$2[id];
        delete queue$2[id];
        fn();
    }
};
var runner = function(id) {
    return function() {
        run(id);
    };
};
var eventListener = function(event1) {
    run(event1.data);
};
var globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    global$7.postMessage(String$1(id), $location.protocol + "//" + $location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$3 || !clear) {
    set$3 = function setImmediate(handler) {
        validateArgumentsLength(arguments.length, 1);
        var fn = isCallable$4(handler) ? handler : Function$1(handler);
        var args = arraySlice$1(arguments, 1);
        queue$2[++counter] = function() {
            apply$1(fn, undefined, args);
        };
        defer(counter);
        return counter;
    };
    clear = function clearImmediate(id) {
        delete queue$2[id];
    };
    // Node.js 0.8-
    if (IS_NODE$4) defer = function(id) {
        process$2.nextTick(runner(id));
    };
    else if (Dispatch && Dispatch.now) defer = function(id) {
        Dispatch.now(runner(id));
    };
    else if (MessageChannel && !IS_IOS$1) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = eventListener;
        defer = bind$5(port.postMessage, port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (global$7.addEventListener && isCallable$4(global$7.postMessage) && !global$7.importScripts && $location && $location.protocol !== "file:" && !fails$9(globalPostMessageDefer)) {
        defer = globalPostMessageDefer;
        global$7.addEventListener("message", eventListener, false);
    // IE8-
    } else if (ONREADYSTATECHANGE in createElement("script")) defer = function(id) {
        html.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
            html.removeChild(this);
            run(id);
        };
    };
    else defer = function(id) {
        setTimeout(runner(id), 0);
    };
}
var task$1 = {
    set: set$3,
    clear: clear
};
var Queue$3 = function() {
    this.head = null;
    this.tail = null;
};
Queue$3.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
var queue$1 = Queue$3;
var userAgent$3 = engineUserAgent;
var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != "undefined";
var userAgent$2 = engineUserAgent;
var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);
var global$6 = global$q;
var bind$4 = functionBindContext;
var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var Queue$2 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$3 = engineIsNode;
var MutationObserver = global$6.MutationObserver || global$6.WebKitMutationObserver;
var document$2 = global$6.document;
var process$1 = global$6.process;
var Promise$1 = global$6.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$4(global$6, "queueMicrotask");
var microtask$1 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify$1, toggle, node, promise$5, then;
// modern engines have queueMicrotask method
if (!microtask$1) {
    var queue = new Queue$2();
    var flush = function() {
        var parent, fn;
        if (IS_NODE$3 && (parent = process$1.domain)) parent.exit();
        while(fn = queue.get())try {
            fn();
        } catch (error) {
            if (queue.head) notify$1();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!IS_IOS && !IS_NODE$3 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
        toggle = true;
        node = document$2.createTextNode("");
        new MutationObserver(flush).observe(node, {
            characterData: true
        });
        notify$1 = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        promise$5 = Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        promise$5.constructor = Promise$1;
        then = bind$4(promise$5.then, promise$5);
        notify$1 = function() {
            then(flush);
        };
    // Node.js without promises
    } else if (IS_NODE$3) notify$1 = function() {
        process$1.nextTick(flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        macrotask = bind$4(macrotask, global$6);
        notify$1 = function() {
            macrotask(flush);
        };
    }
    microtask$1 = function(fn) {
        if (!queue.head) notify$1();
        queue.add(fn);
    };
}
var microtask_1 = microtask$1;
var hostReportErrors$1 = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};
var perform$6 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var global$5 = global$q;
var promiseNativeConstructor = global$5.Promise;
/* global Deno -- Deno case */ var engineIsDeno = typeof Deno == "object" && Deno && typeof Deno.version == "object";
var IS_DENO$1 = engineIsDeno;
var IS_NODE$2 = engineIsNode;
var engineIsBrowser = !IS_DENO$1 && !IS_NODE$2 && typeof window == "object" && typeof document == "object";
var global$4 = global$q;
var NativePromiseConstructor$5 = promiseNativeConstructor;
var isCallable$3 = isCallable$m;
var isForced = isForced_1;
var inspectSource = inspectSource$2;
var wellKnownSymbol = wellKnownSymbol$p;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;
var NativePromisePrototype$2 = NativePromiseConstructor$5 && NativePromiseConstructor$5.prototype;
var SPECIES = wellKnownSymbol("species");
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$3(global$4.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR$5 = isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$5);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$5);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if (!(NativePromisePrototype$2["catch"] && NativePromisePrototype$2["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new NativePromiseConstructor$5(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[SPECIES] = FakePromise;
        SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});
var promiseConstructorDetection = {
    CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: SUBCLASSING
};
var newPromiseCapability$2 = {};
var aCallable$8 = aCallable$e;
var $TypeError$1 = TypeError;
var PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $TypeError$1("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = aCallable$8(resolve);
    this.reject = aCallable$8(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function(C) {
    return new PromiseCapability(C);
};
var $$p = _export;
var IS_NODE$1 = engineIsNode;
var global$3 = global$q;
var call$5 = functionCall;
var defineBuiltIn$1 = defineBuiltIn$6;
var setToStringTag$1 = setToStringTag$7;
var setSpecies$1 = setSpecies$2;
var aCallable$7 = aCallable$e;
var isCallable$2 = isCallable$m;
var isObject$5 = isObject$j;
var anInstance$2 = anInstance$3;
var speciesConstructor$1 = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$5 = perform$6;
var Queue$1 = queue$1;
var InternalStateModule$2 = internalState;
var NativePromiseConstructor$4 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$7 = newPromiseCapability$2;
var PROMISE = "Promise";
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
var setInternalState$2 = InternalStateModule$2.set;
var NativePromisePrototype$1 = NativePromiseConstructor$4 && NativePromiseConstructor$4.prototype;
var PromiseConstructor = NativePromiseConstructor$4;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$3.TypeError;
var document$1 = global$3.document;
var process = global$3.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$7.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$3.dispatchEvent);
var UNHANDLED_REJECTION = "unhandledrejection";
var REJECTION_HANDLED = "rejectionhandled";
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper;
// helpers
var isThenable = function(it) {
    var then;
    return isObject$5(it) && isCallable$2(then = it.then) ? then : false;
};
var callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                state.rejection = HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new TypeError$1("Promise-chain cycle"));
            else if (then = isThenable(result)) call$5(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) onUnhandled(state);
    });
};
var dispatchEvent = function(name, promise, reason) {
    var event1, handler;
    if (DISPATCH_EVENT) {
        event1 = document$1.createEvent("Event");
        event1.promise = promise;
        event1.reason = reason;
        event1.initEvent(name, false, true);
        global$3.dispatchEvent(event1);
    } else event1 = {
        promise: promise,
        reason: reason
    };
    if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$3["on" + name])) handler(event1);
    else if (name === UNHANDLED_REJECTION) hostReportErrors("Unhandled promise rejection", reason);
};
var onUnhandled = function(state) {
    call$5(task, global$3, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = perform$5(function() {
                if (IS_NODE$1) process.emit("unhandledRejection", value, promise);
                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var isUnhandled = function(state) {
    return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function(state) {
    call$5(task, global$3, function() {
        var promise = state.facade;
        if (IS_NODE$1) process.emit("rejectionHandled", promise);
        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
    });
};
var bind$3 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = REJECTED;
    notify(state, true);
};
var internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
        var then = isThenable(value);
        if (then) microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                call$5(then, value, bind$3(internalResolve, wrapper, state), bind$3(internalReject, wrapper, state));
            } catch (error) {
                internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = FULFILLED;
            notify(state, false);
        }
    } catch (error) {
        internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    PromiseConstructor = function Promise(executor) {
        anInstance$2(this, PromisePrototype);
        aCallable$7(executor);
        call$5(Internal, this);
        var state = getInternalPromiseState(this);
        try {
            executor(bind$3(internalResolve, state), bind$3(internalReject, state));
        } catch (error) {
            internalReject(state, error);
        }
    };
    PromisePrototype = PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    Internal = function Promise(executor) {
        setInternalState$2(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new Queue$1(),
            rejection: false,
            state: PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    Internal.prototype = defineBuiltIn$1(PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = getInternalPromiseState(this);
        var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
        state.parent = true;
        reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
        reaction.fail = isCallable$2(onRejected) && onRejected;
        reaction.domain = IS_NODE$1 ? process.domain : undefined;
        if (state.state === PENDING) state.reactions.add(reaction);
        else microtask(function() {
            callReaction(reaction, state);
        });
        return reaction.promise;
    });
    OwnPromiseCapability = function() {
        var promise = new Internal();
        var state = getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = bind$3(internalResolve, state);
        this.reject = bind$3(internalReject, state);
    };
    newPromiseCapabilityModule$7.f = newPromiseCapability$1 = function(C) {
        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };
}
$$p({
    global: true,
    constructor: true,
    wrap: true,
    forced: FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: PromiseConstructor
});
setToStringTag$1(PromiseConstructor, PROMISE, false, true);
setSpecies$1(PROMISE);
var NativePromiseConstructor$3 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$2;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;
var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function(iterable) {
    NativePromiseConstructor$3.all(iterable).then(undefined, function() {});
});
var $$o = _export;
var call$4 = functionCall;
var aCallable$6 = aCallable$e;
var newPromiseCapabilityModule$6 = newPromiseCapability$2;
var perform$4 = perform$6;
var iterate$5 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION$3 = promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$o({
    target: "Promise",
    stat: true,
    forced: PROMISE_STATICS_INCORRECT_ITERATION$3
}, {
    all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapabilityModule$6.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform$4(function() {
            var $promiseResolve = aCallable$6(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate$5(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                call$4($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $$n = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor$2 = promiseNativeConstructor;
NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$n({
    target: "Promise",
    proto: true,
    forced: FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
var $$m = _export;
var call$3 = functionCall;
var aCallable$5 = aCallable$e;
var newPromiseCapabilityModule$5 = newPromiseCapability$2;
var perform$3 = perform$6;
var iterate$4 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION$2 = promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$m({
    target: "Promise",
    stat: true,
    forced: PROMISE_STATICS_INCORRECT_ITERATION$2
}, {
    race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapabilityModule$5.f(C);
        var reject = capability.reject;
        var result = perform$3(function() {
            var $promiseResolve = aCallable$5(C.resolve);
            iterate$4(iterable, function(promise) {
                call$3($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $$l = _export;
var call$2 = functionCall;
var newPromiseCapabilityModule$4 = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$l({
    target: "Promise",
    stat: true,
    forced: FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = newPromiseCapabilityModule$4.f(this);
        call$2(capability.reject, undefined, r);
        return capability.promise;
    }
});
var anObject$1 = anObject$d;
var isObject$4 = isObject$j;
var newPromiseCapability = newPromiseCapability$2;
var promiseResolve$2 = function(C, x) {
    anObject$1(C);
    if (isObject$4(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $$k = _export;
var getBuiltIn$3 = getBuiltIn$f;
var IS_PURE = isPure;
var NativePromiseConstructor$1 = promiseNativeConstructor;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve$1 = promiseResolve$2;
var PromiseConstructorWrapper = getBuiltIn$3("Promise");
var CHECK_WRAPPER = !FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$k({
    target: "Promise",
    stat: true,
    forced: IS_PURE
}, {
    resolve: function resolve(x) {
        return promiseResolve$1(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor$1 : this, x);
    }
});
var $$j = _export;
var call$1 = functionCall;
var aCallable$4 = aCallable$e;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;
var perform$2 = perform$6;
var iterate$3 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$$j({
    target: "Promise",
    stat: true,
    forced: PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = newPromiseCapabilityModule$3.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform$2(function() {
            var promiseResolve = aCallable$4(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate$3(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                call$1(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $$i = _export;
var call = functionCall;
var aCallable$3 = aCallable$e;
var getBuiltIn$2 = getBuiltIn$f;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$6;
var iterate$2 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;
var PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$$i({
    target: "Promise",
    stat: true,
    forced: PROMISE_STATICS_INCORRECT_ITERATION
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = getBuiltIn$2("AggregateError");
        var capability = newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform$1(function() {
            var promiseResolve = aCallable$3(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            iterate$2(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                call(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $$h = _export;
var NativePromiseConstructor = promiseNativeConstructor;
var fails$8 = fails$y;
var getBuiltIn$1 = getBuiltIn$f;
var isCallable$1 = isCallable$m;
var speciesConstructor = speciesConstructor$2;
var promiseResolve = promiseResolve$2;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails$8(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$$h({
    target: "Promise",
    proto: true,
    real: true,
    forced: NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = speciesConstructor(this, getBuiltIn$1("Promise"));
        var isFunction = isCallable$1(onFinally);
        return this.then(isFunction ? function(x) {
            return promiseResolve(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return promiseResolve(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
var path$9 = path$u;
var promise$4 = path$9.Promise;
var parent$q = promise$4;
var promise$3 = parent$q;
var $$g = _export;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$$g({
    target: "Promise",
    stat: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = newPromiseCapabilityModule$1.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});
var parent$p = promise$3;
var promise$2 = parent$p;
// TODO: Remove from `core-js@4`
var $$f = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$6;
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$$f({
    target: "Promise",
    stat: true,
    forced: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = newPromiseCapabilityModule.f(this);
        var result = perform(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});
var parent$o = promise$2;
// TODO: Remove from `core-js@4`
var promise$1 = parent$o;
var promise = promise$1;
var parent$n = reverse$4;
var reverse$2 = parent$n;
var parent$m = reverse$2;
var reverse$1 = parent$m;
var reverse = reverse$1;
(function(module) {
    var _typeof = _typeofExports["default"];
    var _Object$defineProperty = defineProperty$7;
    var _Symbol = symbol$1;
    var _Object$create = create$3;
    var _Object$getPrototypeOf = getPrototypeOf$1;
    var _forEachInstanceProperty = forEach$1;
    var _pushInstanceProperty = push$4;
    var _Object$setPrototypeOf = setPrototypeOf$1;
    var _Promise = promise;
    var _reverseInstanceProperty = reverse;
    var _sliceInstanceProperty = slice$1;
    function _regeneratorRuntime() {
        module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
            return e;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports;
        var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = _Object$defineProperty || function(t, e, r) {
            t[e] = r.value;
        }, i1 = "function" == typeof _Symbol ? _Symbol : {}, a = i1.iterator || "@@iterator", c = i1.asyncIterator || "@@asyncIterator", u = i1.toStringTag || "@@toStringTag";
        function define(t, e, r) {
            return _Object$defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }), t[e];
        }
        try {
            define({}, "");
        } catch (t) {
            define = function define(t, e, r) {
                return t[e] = r;
            };
        }
        function wrap(t, e, r, n) {
            var i1 = e && e.prototype instanceof Generator ? e : Generator, a = _Object$create(i1.prototype), c = new Context(n || []);
            return o(a, "_invoke", {
                value: makeInvokeMethod(t, r, c)
            }), a;
        }
        function tryCatch(t, e, r) {
            try {
                return {
                    type: "normal",
                    arg: t.call(e, r)
                };
            } catch (t) {
                return {
                    type: "throw",
                    arg: t
                };
            }
        }
        e.wrap = wrap;
        var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        var p = {};
        define(p, a, function() {
            return this;
        });
        var d = _Object$getPrototypeOf, v = d && d(d(values([])));
        v && v !== r && n.call(v, a) && (p = v);
        var g = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(p);
        function defineIteratorMethods(t) {
            var _context;
            _forEachInstanceProperty(_context = [
                "next",
                "throw",
                "return"
            ]).call(_context, function(e) {
                define(t, e, function(t) {
                    return this._invoke(e, t);
                });
            });
        }
        function AsyncIterator(t, e) {
            function invoke(r, o, i1, a) {
                var c = tryCatch(t[r], t, o);
                if ("throw" !== c.type) {
                    var u = c.arg, h = u.value;
                    return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                        invoke("next", t, i1, a);
                    }, function(t) {
                        invoke("throw", t, i1, a);
                    }) : e.resolve(h).then(function(t) {
                        u.value = t, i1(u);
                    }, function(t) {
                        return invoke("throw", t, i1, a);
                    });
                }
                a(c.arg);
            }
            var r;
            o(this, "_invoke", {
                value: function value(t, n) {
                    function callInvokeWithMethodAndArg() {
                        return new e(function(e, r) {
                            invoke(t, n, e, r);
                        });
                    }
                    return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                }
            });
        }
        function makeInvokeMethod(e, r, n) {
            var o = h;
            return function(i1, a) {
                if (o === f) throw new Error("Generator is already running");
                if (o === s) {
                    if ("throw" === i1) throw a;
                    return {
                        value: t,
                        done: !0
                    };
                }
                for(n.method = i1, n.arg = a;;){
                    var c = n.delegate;
                    if (c) {
                        var u = maybeInvokeDelegate(c, n);
                        if (u) {
                            if (u === y) continue;
                            return u;
                        }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;
                    else if ("throw" === n.method) {
                        if (o === h) throw o = s, n.arg;
                        n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    o = f;
                    var p = tryCatch(e, r, n);
                    if ("normal" === p.type) {
                        if (o = n.done ? s : l, p.arg === y) continue;
                        return {
                            value: p.arg,
                            done: n.done
                        };
                    }
                    "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
                }
            };
        }
        function maybeInvokeDelegate(e, r) {
            var n = r.method, o = e.iterator[n];
            if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
            var i1 = tryCatch(o, e.iterator, r.arg);
            if ("throw" === i1.type) return r.method = "throw", r.arg = i1.arg, r.delegate = null, y;
            var a = i1.arg;
            return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
        }
        function pushTryEntry(t) {
            var _context2;
            var e = {
                tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), _pushInstanceProperty(_context2 = this.tryEntries).call(_context2, e);
        }
        function resetTryEntry(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
        }
        function Context(t) {
            this.tryEntries = [
                {
                    tryLoc: "root"
                }
            ], _forEachInstanceProperty(t).call(t, pushTryEntry, this), this.reset(!0);
        }
        function values(e) {
            if (e || "" === e) {
                var r = e[a];
                if (r) return r.call(e);
                if ("function" == typeof e.next) return e;
                if (!isNaN(e.length)) {
                    var o = -1, i1 = function next() {
                        for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                        return next.value = t, next.done = !0, next;
                    };
                    return i1.next = i1;
                }
            }
            throw new TypeError(_typeof(e) + " is not iterable");
        }
        return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
            value: GeneratorFunctionPrototype,
            configurable: !0
        }), o(GeneratorFunctionPrototype, "constructor", {
            value: GeneratorFunction,
            configurable: !0
        }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
        }, e.mark = function(t) {
            return _Object$setPrototypeOf ? _Object$setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = _Object$create(g), t;
        }, e.awrap = function(t) {
            return {
                __await: t
            };
        }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
            return this;
        }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i1) {
            void 0 === i1 && (i1 = _Promise);
            var a = new AsyncIterator(wrap(t, r, n, o), i1);
            return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                return t.done ? t.value : a.next();
            });
        }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
            return this;
        }), define(g, "toString", function() {
            return "[object Generator]";
        }), e.keys = function(t) {
            var e = Object(t), r = [];
            for(var n in e)_pushInstanceProperty(r).call(r, n);
            return _reverseInstanceProperty(r).call(r), function next() {
                for(; r.length;){
                    var t = r.pop();
                    if (t in e) return next.value = t, next.done = !1, next;
                }
                return next.done = !0, next;
            };
        }, e.values = values, Context.prototype = {
            constructor: Context,
            reset: function reset(e) {
                var _context3;
                if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, _forEachInstanceProperty(_context3 = this.tryEntries).call(_context3, resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+_sliceInstanceProperty(r).call(r, 1)) && (this[r] = t);
            },
            stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
            },
            dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var r = this;
                function handle(n, o) {
                    return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                }
                for(var o = this.tryEntries.length - 1; o >= 0; --o){
                    var i1 = this.tryEntries[o], a = i1.completion;
                    if ("root" === i1.tryLoc) return handle("end");
                    if (i1.tryLoc <= this.prev) {
                        var c = n.call(i1, "catchLoc"), u = n.call(i1, "finallyLoc");
                        if (c && u) {
                            if (this.prev < i1.catchLoc) return handle(i1.catchLoc, !0);
                            if (this.prev < i1.finallyLoc) return handle(i1.finallyLoc);
                        } else if (c) {
                            if (this.prev < i1.catchLoc) return handle(i1.catchLoc, !0);
                        } else {
                            if (!u) throw new Error("try statement without catch or finally");
                            if (this.prev < i1.finallyLoc) return handle(i1.finallyLoc);
                        }
                    }
                }
            },
            abrupt: function abrupt(t, e) {
                for(var r = this.tryEntries.length - 1; r >= 0; --r){
                    var o = this.tryEntries[r];
                    if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                        var i1 = o;
                        break;
                    }
                }
                i1 && ("break" === t || "continue" === t) && i1.tryLoc <= e && e <= i1.finallyLoc && (i1 = null);
                var a = i1 ? i1.completion : {};
                return a.type = t, a.arg = e, i1 ? (this.method = "next", this.next = i1.finallyLoc, y) : this.complete(a);
            },
            complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
            },
            finish: function finish(t) {
                for(var e = this.tryEntries.length - 1; e >= 0; --e){
                    var r = this.tryEntries[e];
                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
                }
            },
            "catch": function _catch(t) {
                for(var e = this.tryEntries.length - 1; e >= 0; --e){
                    var r = this.tryEntries[e];
                    if (r.tryLoc === t) {
                        var n = r.completion;
                        if ("throw" === n.type) {
                            var o = n.arg;
                            resetTryEntry(r);
                        }
                        return o;
                    }
                }
                throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(e, r, n) {
                return this.delegate = {
                    iterator: values(e),
                    resultName: r,
                    nextLoc: n
                }, "next" === this.method && (this.arg = t), y;
            }
        }, e;
    }
    module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(regeneratorRuntime$1);
var regeneratorRuntimeExports = regeneratorRuntime$1.exports;
// TODO(Babel 8): Remove this file.
var runtime = regeneratorRuntimeExports();
var regenerator = runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
    else Function("r", "regeneratorRuntime = r")(runtime);
}
var _regeneratorRuntime = /*@__PURE__*/ getDefaultExportFromCjs(regenerator);
var aCallable$2 = aCallable$e;
var toObject$2 = toObject$f;
var IndexedObject = indexedObject;
var lengthOfArrayLike$3 = lengthOfArrayLike$e;
var $TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        aCallable$2(callbackfn);
        var O = toObject$2(that);
        var self1 = IndexedObject(O);
        var length = lengthOfArrayLike$3(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i1 = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i1;
                break;
            }
            index += i1;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i1)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
};
var arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: createMethod(true)
};
var $$e = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict$3 = arrayMethodIsStrict$6;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$4 = CHROME_BUG || !arrayMethodIsStrict$3("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$e({
    target: "Array",
    proto: true,
    forced: FORCED$4
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$a = entryVirtual$o;
var reduce$3 = entryVirtual$a("Array").reduce;
var isPrototypeOf$a = objectIsPrototypeOf;
var method$a = reduce$3;
var ArrayPrototype$9 = Array.prototype;
var reduce$2 = function(it) {
    var own = it.reduce;
    return it === ArrayPrototype$9 || isPrototypeOf$a(ArrayPrototype$9, it) && own === ArrayPrototype$9.reduce ? method$a : own;
};
var parent$l = reduce$2;
var reduce$1 = parent$l;
var reduce = reduce$1;
var _reduceInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(reduce);
var isArray = isArray$e;
var lengthOfArrayLike$2 = lengthOfArrayLike$e;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$4;
var bind$2 = functionBindContext;
// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? bind$2(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && isArray(element)) {
                elementLen = lengthOfArrayLike$2(element);
                targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                doesNotExceedSafeInteger(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
var flattenIntoArray_1 = flattenIntoArray$1;
var $$d = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$1 = aCallable$e;
var toObject$1 = toObject$f;
var lengthOfArrayLike$1 = lengthOfArrayLike$e;
var arraySpeciesCreate = arraySpeciesCreate$4;
// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$d({
    target: "Array",
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = toObject$1(this);
        var sourceLen = lengthOfArrayLike$1(O);
        var A;
        aCallable$1(callbackfn);
        A = arraySpeciesCreate(O, 0);
        A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});
var entryVirtual$9 = entryVirtual$o;
var flatMap$3 = entryVirtual$9("Array").flatMap;
var isPrototypeOf$9 = objectIsPrototypeOf;
var method$9 = flatMap$3;
var ArrayPrototype$8 = Array.prototype;
var flatMap$2 = function(it) {
    var own = it.flatMap;
    return it === ArrayPrototype$8 || isPrototypeOf$9(ArrayPrototype$8, it) && own === ArrayPrototype$8.flatMap ? method$9 : own;
};
var parent$k = flatMap$2;
var flatMap$1 = parent$k;
var flatMap = flatMap$1;
var _flatMapInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(flatMap);
var internalMetadata = {
    exports: {}
};
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails$7 = fails$y;
var arrayBufferNonExtensible = fails$7(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});
var fails$6 = fails$y;
var isObject$3 = isObject$j;
var classof$3 = classofRaw$2;
var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails$6(function() {
    $isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var objectIsExtensible = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
    if (!isObject$3(it)) return false;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof$3(it) === "ArrayBuffer") return false;
    return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;
var fails$5 = fails$y;
var freezing = !fails$5(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});
var $$c = _export;
var uncurryThis$2 = functionUncurryThis;
var hiddenKeys = hiddenKeys$6;
var isObject$2 = isObject$j;
var hasOwn$3 = hasOwnProperty_1;
var defineProperty$2 = objectDefineProperty.f;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
var isExtensible = objectIsExtensible;
var uid = uid$4;
var FREEZING = freezing;
var REQUIRED = false;
var METADATA = uid("meta");
var id = 0;
var setMetadata = function(it) {
    defineProperty$2(it, METADATA, {
        value: {
            objectID: "O" + id++,
            weakData: {} // weak collections IDs
        }
    });
};
var fastKey$1 = function(it, create) {
    // return a primitive with prefix
    if (!isObject$2(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!hasOwn$3(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        setMetadata(it);
    // return object ID
    }
    return it[METADATA].objectID;
};
var getWeakData = function(it, create) {
    if (!hasOwn$3(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[METADATA].weakData;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it) {
    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn$3(it, METADATA)) setMetadata(it);
    return it;
};
var enable = function() {
    meta.enable = function() {};
    REQUIRED = true;
    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
    var splice = uncurryThis$2([].splice);
    var test = {};
    test[METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        getOwnPropertyNamesModule.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i1 = 0, length = result.length; i1 < length; i1++)if (result[i1] === METADATA) {
                splice(result, i1, 1);
                break;
            }
            return result;
        };
        $$c({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
        });
    }
};
var meta = internalMetadata.exports = {
    enable: enable,
    fastKey: fastKey$1,
    getWeakData: getWeakData,
    onFreeze: onFreeze
};
hiddenKeys[METADATA] = true;
var internalMetadataExports = internalMetadata.exports;
var $$b = _export;
var global$2 = global$q;
var InternalMetadataModule = internalMetadataExports;
var fails$4 = fails$y;
var createNonEnumerableProperty = createNonEnumerableProperty$9;
var iterate$1 = iterate$7;
var anInstance$1 = anInstance$3;
var isCallable = isCallable$m;
var isObject$1 = isObject$j;
var isNullOrUndefined$1 = isNullOrUndefined$6;
var setToStringTag = setToStringTag$7;
var defineProperty$1 = objectDefineProperty.f;
var forEach = arrayIteration.forEach;
var DESCRIPTORS$4 = descriptors;
var InternalStateModule$1 = internalState;
var setInternalState$1 = InternalStateModule$1.set;
var internalStateGetterFor$1 = InternalStateModule$1.getterFor;
var collection$2 = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = global$2[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var exported = {};
    var Constructor;
    if (!DESCRIPTORS$4 || !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails$4(function() {
        new NativeConstructor().entries().next();
    }))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        InternalMetadataModule.enable();
    } else {
        Constructor = wrapper(function(target, iterable) {
            setInternalState$1(anInstance$1(target, Prototype), {
                type: CONSTRUCTOR_NAME,
                collection: new NativeConstructor()
            });
            if (!isNullOrUndefined$1(iterable)) iterate$1(iterable, target[ADDER], {
                that: target,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
        forEach([
            "add",
            "clear",
            "delete",
            "forEach",
            "get",
            "has",
            "set",
            "keys",
            "values",
            "entries"
        ], function(KEY) {
            var IS_ADDER = KEY === "add" || KEY === "set";
            if (KEY in NativePrototype && !(IS_WEAK && KEY === "clear")) createNonEnumerableProperty(Prototype, KEY, function(a, b) {
                var collection = getInternalState(this).collection;
                if (!IS_ADDER && IS_WEAK && !isObject$1(a)) return KEY === "get" ? undefined : false;
                var result = collection[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || defineProperty$1(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).collection.size;
            }
        });
    }
    setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);
    exported[CONSTRUCTOR_NAME] = Constructor;
    $$b({
        global: true,
        forced: true
    }, exported);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};
var defineBuiltIn = defineBuiltIn$6;
var defineBuiltIns$1 = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else defineBuiltIn(target, key, src[key], options);
    return target;
};
var create$1 = objectCreate;
var defineBuiltInAccessor = defineBuiltInAccessor$3;
var defineBuiltIns = defineBuiltIns$1;
var bind$1 = functionBindContext;
var anInstance = anInstance$3;
var isNullOrUndefined = isNullOrUndefined$6;
var iterate = iterate$7;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$3;
var setSpecies = setSpecies$2;
var DESCRIPTORS$3 = descriptors;
var fastKey = internalMetadataExports.fastKey;
var InternalStateModule = internalState;
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var collectionStrong$2 = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            anInstance(that, Prototype);
            setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: create$1(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!DESCRIPTORS$3) that.size = 0;
            if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if (DESCRIPTORS$3) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        defineBuiltIns(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if (DESCRIPTORS$3) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if (DESCRIPTORS$3) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = bind$1(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        defineBuiltIns(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if (DESCRIPTORS$3) defineBuiltInAccessor(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return createIterResultObject(undefined, true);
            }
            // return step by kind
            if (kind === "keys") return createIterResultObject(entry.key, false);
            if (kind === "values") return createIterResultObject(entry.value, false);
            return createIterResultObject([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        setSpecies(CONSTRUCTOR_NAME);
    }
};
var collection$1 = collection$2;
var collectionStrong$1 = collectionStrong$2;
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection$1("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, collectionStrong$1);
var path$8 = path$u;
var map$2 = path$8.Map;
var parent$j = map$2;
var map$1 = parent$j;
var map = map$1;
var _Map = /*@__PURE__*/ getDefaultExportFromCjs(map);
var collection = collection$2;
var collectionStrong = collectionStrong$2;
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, collectionStrong);
var path$7 = path$u;
var set$2 = path$7.Set;
var parent$i = set$2;
var set$1 = parent$i;
var set = set$1;
var _Set = /*@__PURE__*/ getDefaultExportFromCjs(set);
var iterator = iterator$4;
var _Symbol$iterator2 = /*@__PURE__*/ getDefaultExportFromCjs(iterator);
var getIterator$5 = getIterator$8;
var getIterator_1 = getIterator$5;
var parent$h = getIterator_1;
var getIterator$4 = parent$h;
var parent$g = getIterator$4;
var getIterator$3 = parent$g;
var parent$f = getIterator$3;
var getIterator$2 = parent$f;
var getIterator$1 = getIterator$2;
var getIterator = getIterator$1;
var _getIterator = /*@__PURE__*/ getDefaultExportFromCjs(getIterator);
var arraySlice = arraySliceSimple;
var floor = Math.floor;
var mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = floor(length / 2);
    return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice(array, 0, middle), comparefn), mergeSort(arraySlice(array, middle), comparefn), comparefn);
};
var insertionSort = function(array, comparefn) {
    var length = array.length;
    var i1 = 1;
    var element, j;
    while(i1 < length){
        j = i1;
        element = array[i1];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i1++) array[j] = element;
    }
    return array;
};
var merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var arraySort = mergeSort;
var userAgent$1 = engineUserAgent;
var firefox = userAgent$1.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];
var UA = engineUserAgent;
var engineIsIeOrEdge = /MSIE|Trident/.test(UA);
var userAgent = engineUserAgent;
var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];
var $$a = _export;
var uncurryThis$1 = functionUncurryThis;
var aCallable = aCallable$e;
var toObject = toObject$f;
var lengthOfArrayLike = lengthOfArrayLike$e;
var deletePropertyOrThrow = deletePropertyOrThrow$2;
var toString$2 = toString$c;
var fails$3 = fails$y;
var internalSort = arraySort;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$6;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;
var test = [];
var nativeSort = uncurryThis$1(test.sort);
var push$1 = uncurryThis$1(test.push);
// IE8-
var FAILS_ON_UNDEFINED = fails$3(function() {
    test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$3(function() {
    test.sort(null);
});
// Old WebKit
var STRICT_METHOD$2 = arrayMethodIsStrict$2("sort");
var STABLE_SORT = !fails$3(function() {
    // feature detection can be too slow, so check engines versions
    if (V8) return V8 < 70;
    if (FF && FF > 3) return;
    if (IE_OR_EDGE) return true;
    if (WEBKIT) return WEBKIT < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)test.push({
            k: chr + index,
            v: value
        });
    }
    test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < test.length; index++){
        chr = test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var FORCED$3 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$2 || !STABLE_SORT;
var getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return toString$2(x) > toString$2(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$a({
    target: "Array",
    proto: true,
    forced: FORCED$3
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) aCallable(comparefn);
        var array = toObject(this);
        if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
        var items = [];
        var arrayLength = lengthOfArrayLike(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) push$1(items, array[index]);
        internalSort(items, getSortCompare(comparefn));
        itemsLength = lengthOfArrayLike(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)deletePropertyOrThrow(array, index++);
        return array;
    }
});
var entryVirtual$8 = entryVirtual$o;
var sort$3 = entryVirtual$8("Array").sort;
var isPrototypeOf$8 = objectIsPrototypeOf;
var method$8 = sort$3;
var ArrayPrototype$7 = Array.prototype;
var sort$2 = function(it) {
    var own = it.sort;
    return it === ArrayPrototype$7 || isPrototypeOf$8(ArrayPrototype$7, it) && own === ArrayPrototype$7.sort ? method$8 : own;
};
var parent$e = sort$2;
var sort$1 = parent$e;
var sort = sort$1;
var _sortInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(sort);
var $$9 = _export;
var $some = arrayIteration.some;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$6;
var STRICT_METHOD$1 = arrayMethodIsStrict$1("some");
// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$$9({
    target: "Array",
    proto: true,
    forced: !STRICT_METHOD$1
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$7 = entryVirtual$o;
var some$3 = entryVirtual$7("Array").some;
var isPrototypeOf$7 = objectIsPrototypeOf;
var method$7 = some$3;
var ArrayPrototype$6 = Array.prototype;
var some$2 = function(it) {
    var own = it.some;
    return it === ArrayPrototype$6 || isPrototypeOf$7(ArrayPrototype$6, it) && own === ArrayPrototype$6.some ? method$7 : own;
};
var parent$d = some$2;
var some$1 = parent$d;
var some = some$1;
var _someInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(some);
var entryVirtual$6 = entryVirtual$o;
var keys$3 = entryVirtual$6("Array").keys;
var parent$c = keys$3;
var keys$2 = parent$c;
var classof$2 = classof$g;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf$6 = objectIsPrototypeOf;
var method$6 = keys$2;
var ArrayPrototype$5 = Array.prototype;
var DOMIterables$2 = {
    DOMTokenList: true,
    NodeList: true
};
var keys$1 = function(it) {
    var own = it.keys;
    return it === ArrayPrototype$5 || isPrototypeOf$6(ArrayPrototype$5, it) && own === ArrayPrototype$5.keys || hasOwn$2(DOMIterables$2, classof$2(it)) ? method$6 : own;
};
var keys = keys$1;
var _keysInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(keys);
var entryVirtual$5 = entryVirtual$o;
var values$3 = entryVirtual$5("Array").values;
var parent$b = values$3;
var values$2 = parent$b;
var classof$1 = classof$g;
var hasOwn$1 = hasOwnProperty_1;
var isPrototypeOf$5 = objectIsPrototypeOf;
var method$5 = values$2;
var ArrayPrototype$4 = Array.prototype;
var DOMIterables$1 = {
    DOMTokenList: true,
    NodeList: true
};
var values$1 = function(it) {
    var own = it.values;
    return it === ArrayPrototype$4 || isPrototypeOf$5(ArrayPrototype$4, it) && own === ArrayPrototype$4.values || hasOwn$1(DOMIterables$1, classof$1(it)) ? method$5 : own;
};
var values = values$1;
var _valuesInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(values);
var entryVirtual$4 = entryVirtual$o;
var entries$3 = entryVirtual$4("Array").entries;
var parent$a = entries$3;
var entries$2 = parent$a;
var classof = classof$g;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf$4 = objectIsPrototypeOf;
var method$4 = entries$2;
var ArrayPrototype$3 = Array.prototype;
var DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
var entries$1 = function(it) {
    var own = it.entries;
    return it === ArrayPrototype$3 || isPrototypeOf$4(ArrayPrototype$3, it) && own === ArrayPrototype$3.entries || hasOwn(DOMIterables, classof(it)) ? method$4 : own;
};
var entries = entries$1;
var _entriesInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(entries);
var defineProperty = defineProperty$a;
var _Object$defineProperty = /*@__PURE__*/ getDefaultExportFromCjs(defineProperty);
var $$8 = _export;
var getBuiltIn = getBuiltIn$f;
var apply = functionApply;
var bind = functionBind;
var aConstructor = aConstructor$2;
var anObject = anObject$d;
var isObject = isObject$j;
var create = objectCreate;
var fails$2 = fails$y;
var nativeConstruct = getBuiltIn("Reflect", "construct");
var ObjectPrototype = Object.prototype;
var push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails$2(function() {
    function F() {}
    return !(nativeConstruct(function() {}, [], F) instanceof F);
});
var ARGS_BUG = !fails$2(function() {
    nativeConstruct(function() {});
});
var FORCED$2 = NEW_TARGET_BUG || ARGS_BUG;
$$8({
    target: "Reflect",
    stat: true,
    forced: FORCED$2,
    sham: FORCED$2
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        aConstructor(Target);
        anObject(args);
        var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
        if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
        if (Target === newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            apply(push, $args, args);
            return new (apply(bind, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = create(isObject(proto) ? proto : ObjectPrototype);
        var result = apply(Target, instance, args);
        return isObject(result) ? result : instance;
    }
});
var path$6 = path$u;
var construct$2 = path$6.Reflect.construct;
var parent$9 = construct$2;
var construct$1 = parent$9;
var construct = construct$1;
var _Reflect$construct = /*@__PURE__*/ getDefaultExportFromCjs(construct);
var path$5 = path$u;
var getOwnPropertySymbols$2 = path$5.Object.getOwnPropertySymbols;
var parent$8 = getOwnPropertySymbols$2;
var getOwnPropertySymbols$1 = parent$8;
var getOwnPropertySymbols = getOwnPropertySymbols$1;
var _Object$getOwnPropertySymbols = /*@__PURE__*/ getDefaultExportFromCjs(getOwnPropertySymbols);
var getOwnPropertyDescriptor$3 = {
    exports: {}
};
var $$7 = _export;
var fails$1 = fails$y;
var toIndexedObject$1 = toIndexedObject$b;
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var DESCRIPTORS$2 = descriptors;
var FORCED$1 = !DESCRIPTORS$2 || fails$1(function() {
    nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$$7({
    target: "Object",
    stat: true,
    forced: FORCED$1,
    sham: !DESCRIPTORS$2
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return nativeGetOwnPropertyDescriptor(toIndexedObject$1(it), key);
    }
});
var path$4 = path$u;
var Object$2 = path$4.Object;
var getOwnPropertyDescriptor$2 = getOwnPropertyDescriptor$3.exports = function getOwnPropertyDescriptor(it, key) {
    return Object$2.getOwnPropertyDescriptor(it, key);
};
if (Object$2.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor$2.sham = true;
var getOwnPropertyDescriptorExports = getOwnPropertyDescriptor$3.exports;
var parent$7 = getOwnPropertyDescriptorExports;
var getOwnPropertyDescriptor$1 = parent$7;
var getOwnPropertyDescriptor = getOwnPropertyDescriptor$1;
var _Object$getOwnPropertyDescriptor = /*@__PURE__*/ getDefaultExportFromCjs(getOwnPropertyDescriptor);
var $$6 = _export;
var DESCRIPTORS$1 = descriptors;
var ownKeys$2 = ownKeys$8;
var toIndexedObject = toIndexedObject$b;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var createProperty = createProperty$6;
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$$6({
    target: "Object",
    stat: true,
    sham: !DESCRIPTORS$1
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = toIndexedObject(object);
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        var keys = ownKeys$2(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) createProperty(result, key, descriptor);
        }
        return result;
    }
});
var path$3 = path$u;
var getOwnPropertyDescriptors$2 = path$3.Object.getOwnPropertyDescriptors;
var parent$6 = getOwnPropertyDescriptors$2;
var getOwnPropertyDescriptors$1 = parent$6;
var getOwnPropertyDescriptors = getOwnPropertyDescriptors$1;
var _Object$getOwnPropertyDescriptors = /*@__PURE__*/ getDefaultExportFromCjs(getOwnPropertyDescriptors);
var defineProperties$4 = {
    exports: {}
};
var $$5 = _export;
var DESCRIPTORS = descriptors;
var defineProperties$3 = objectDefineProperties.f;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$$5({
    target: "Object",
    stat: true,
    forced: Object.defineProperties !== defineProperties$3,
    sham: !DESCRIPTORS
}, {
    defineProperties: defineProperties$3
});
var path$2 = path$u;
var Object$1 = path$2.Object;
var defineProperties$2 = defineProperties$4.exports = function defineProperties(T, D) {
    return Object$1.defineProperties(T, D);
};
if (Object$1.defineProperties.sham) defineProperties$2.sham = true;
var definePropertiesExports = defineProperties$4.exports;
var parent$5 = definePropertiesExports;
var defineProperties$1 = parent$5;
var defineProperties = defineProperties$1;
var _Object$defineProperties = /*@__PURE__*/ getDefaultExportFromCjs(defineProperties);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
for(let i1 = 0; i1 < 256; ++i1)byteToHex.push((i1 + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
    randomUUID: randomUUID
};
function v4(options, buf, offset) {
    if (native.randomUUID && !buf && !options) return native.randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i1 = 0; i1 < 16; ++i1)buf[offset + i1] = rnds[i1];
        return buf;
    }
    return unsafeStringify(rnds);
}
var _Symbol$iterator;
function ownKeys$1(e, r) {
    var t = _Object$keys(e);
    if (_Object$getOwnPropertySymbols) {
        var o = _Object$getOwnPropertySymbols(e);
        r && (o = _filterInstanceProperty(o).call(o, function(r) {
            return _Object$getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var _context32, _context33;
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? _forEachInstanceProperty(_context32 = ownKeys$1(Object(t), !0)).call(_context32, function(r) {
            _defineProperty(e, r, t[r]);
        }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context33 = ownKeys$1(Object(t))).call(_context33, function(r) {
            _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _createSuper$d(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$d();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$d() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createForOfIteratorHelper$6(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$6(o, minLen) {
    var _context31;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
    var n = _sliceInstanceProperty(_context31 = Object.prototype.toString.call(o)).call(_context31, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}
function _arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
/**
 * Create new data pipe.
 *
 * @param from - The source data set or data view.
 * @remarks
 * Example usage:
 * ```typescript
 * interface AppItem {
 *   whoami: string;
 *   appData: unknown;
 *   visData: VisItem;
 * }
 * interface VisItem {
 *   id: number;
 *   label: string;
 *   color: string;
 *   x: number;
 *   y: number;
 * }
 *
 * const ds1 = new DataSet<AppItem, "whoami">([], { fieldId: "whoami" });
 * const ds2 = new DataSet<VisItem, "id">();
 *
 * const pipe = createNewDataPipeFrom(ds1)
 *   .filter((item): boolean => item.enabled === true)
 *   .map<VisItem, "id">((item): VisItem => item.visData)
 *   .to(ds2);
 *
 * pipe.start();
 * ```
 * @returns A factory whose methods can be used to configure the pipe.
 */ function createNewDataPipeFrom(from) {
    return new DataPipeUnderConstruction(from);
}
/**
 * Internal implementation of the pipe. This should be accessible only through
 * `createNewDataPipeFrom` from the outside.
 *
 * @typeParam SI - Source item type.
 * @typeParam SP - Source item type's id property name.
 * @typeParam TI - Target item type.
 * @typeParam TP - Target item type's id property name.
 */ var SimpleDataPipe = /*#__PURE__*/ function() {
    /**
   * Create a new data pipe.
   *
   * @param _source - The data set or data view that will be observed.
   * @param _transformers - An array of transforming functions to be used to
   * filter or transform the items in the pipe.
   * @param _target - The data set or data view that will receive the items.
   */ function SimpleDataPipe(_source, _transformers, _target) {
        var _context, _context2, _context3;
        _classCallCheck(this, SimpleDataPipe);
        _defineProperty(this, "_source", void 0);
        _defineProperty(this, "_transformers", void 0);
        _defineProperty(this, "_target", void 0);
        /**
     * Bound listeners for use with `DataInterface['on' | 'off']`.
     */ _defineProperty(this, "_listeners", {
            add: _bindInstanceProperty$1(_context = this._add).call(_context, this),
            remove: _bindInstanceProperty$1(_context2 = this._remove).call(_context2, this),
            update: _bindInstanceProperty$1(_context3 = this._update).call(_context3, this)
        });
        this._source = _source;
        this._transformers = _transformers;
        this._target = _target;
    }
    /** @inheritDoc */ _createClass(SimpleDataPipe, [
        {
            key: "all",
            value: function all() {
                this._target.update(this._transformItems(this._source.get()));
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                this._source.on("add", this._listeners.add);
                this._source.on("remove", this._listeners.remove);
                this._source.on("update", this._listeners.update);
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                this._source.off("add", this._listeners.add);
                this._source.off("remove", this._listeners.remove);
                this._source.off("update", this._listeners.update);
                return this;
            }
        },
        {
            key: "_transformItems",
            value: function _transformItems(items) {
                var _context4;
                return _reduceInstanceProperty(_context4 = this._transformers).call(_context4, function(items, transform) {
                    return transform(items);
                }, items);
            }
        },
        {
            key: "_add",
            value: function _add(_name, payload) {
                if (payload == null) return;
                this._target.add(this._transformItems(this._source.get(payload.items)));
            }
        },
        {
            key: "_update",
            value: function _update(_name, payload) {
                if (payload == null) return;
                this._target.update(this._transformItems(this._source.get(payload.items)));
            }
        },
        {
            key: "_remove",
            value: function _remove(_name, payload) {
                if (payload == null) return;
                this._target.remove(this._transformItems(payload.oldData));
            }
        }
    ]);
    return SimpleDataPipe;
}();
/**
 * Internal implementation of the pipe factory. This should be accessible
 * only through `createNewDataPipeFrom` from the outside.
 *
 * @typeParam TI - Target item type.
 * @typeParam TP - Target item type's id property name.
 */ var DataPipeUnderConstruction = /*#__PURE__*/ function() {
    /**
   * Create a new data pipe factory. This is an internal constructor that
   * should never be called from outside of this file.
   *
   * @param _source - The source data set or data view for this pipe.
   */ function DataPipeUnderConstruction(_source) {
        _classCallCheck(this, DataPipeUnderConstruction);
        _defineProperty(this, "_source", void 0);
        /**
     * Array transformers used to transform items within the pipe. This is typed
     * as any for the sake of simplicity.
     */ _defineProperty(this, "_transformers", []);
        this._source = _source;
    }
    /**
   * Filter the items.
   *
   * @param callback - A filtering function that returns true if given item
   * should be piped and false if not.
   * @returns This factory for further configuration.
   */ _createClass(DataPipeUnderConstruction, [
        {
            key: "filter",
            value: function filter(callback) {
                this._transformers.push(function(input) {
                    return _filterInstanceProperty(input).call(input, callback);
                });
                return this;
            }
        },
        {
            key: "map",
            value: function map(callback) {
                this._transformers.push(function(input) {
                    return _mapInstanceProperty(input).call(input, callback);
                });
                return this;
            }
        },
        {
            key: "flatMap",
            value: function flatMap(callback) {
                this._transformers.push(function(input) {
                    return _flatMapInstanceProperty(input).call(input, callback);
                });
                return this;
            }
        },
        {
            key: "to",
            value: function to(target) {
                return new SimpleDataPipe(this._source, this._transformers, target);
            }
        }
    ]);
    return DataPipeUnderConstruction;
}();
/**
 * Determine whether a value can be used as an id.
 *
 * @param value - Input value of unknown type.
 * @returns True if the value is valid id, false otherwise.
 */ function isId(value) {
    return typeof value === "string" || typeof value === "number";
}
/**
 * A queue.
 *
 * @typeParam T - The type of method names to be replaced by queued versions.
 */ var Queue = /*#__PURE__*/ function() {
    /**
   * Construct a new Queue.
   *
   * @param options - Queue configuration.
   */ function Queue(options) {
        _classCallCheck(this, Queue);
        /** Delay in milliseconds. If defined the queue will be periodically flushed. */ _defineProperty(this, "delay", void 0);
        /** Maximum number of entries in the queue before it will be flushed. */ _defineProperty(this, "max", void 0);
        _defineProperty(this, "_queue", []);
        _defineProperty(this, "_timeout", null);
        _defineProperty(this, "_extended", null);
        // options
        this.delay = null;
        this.max = Infinity;
        this.setOptions(options);
    }
    /**
   * Update the configuration of the queue.
   *
   * @param options - Queue configuration.
   */ _createClass(Queue, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options && typeof options.delay !== "undefined") this.delay = options.delay;
                if (options && typeof options.max !== "undefined") this.max = options.max;
                this._flushIfNeeded();
            }
        },
        {
            key: "destroy",
            value: /**
     * Destroy the queue. The queue will first flush all queued actions, and in case it has extended an object, will restore the original object.
     */ function destroy() {
                this.flush();
                if (this._extended) {
                    var object = this._extended.object;
                    var methods = this._extended.methods;
                    for(var i1 = 0; i1 < methods.length; i1++){
                        var method = methods[i1];
                        if (method.original) // @TODO: better solution?
                        object[method.name] = method.original;
                        else // @TODO: better solution?
                        delete object[method.name];
                    }
                    this._extended = null;
                }
            }
        },
        {
            key: "replace",
            value: function replace(object, method) {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias -- Function this is necessary in the function bellow, so class this has to be saved into a variable here. */ var me = this;
                var original = object[method];
                if (!original) throw new Error("Method " + method + " undefined");
                object[method] = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    // add this call to the queue
                    me.queue({
                        args: args,
                        fn: original,
                        context: this
                    });
                };
            }
        },
        {
            key: "queue",
            value: function queue(entry) {
                if (typeof entry === "function") this._queue.push({
                    fn: entry
                });
                else this._queue.push(entry);
                this._flushIfNeeded();
            }
        },
        {
            key: "_flushIfNeeded",
            value: function _flushIfNeeded() {
                var _this = this;
                // flush when the maximum is exceeded.
                if (this._queue.length > this.max) this.flush();
                // flush after a period of inactivity when a delay is configured
                if (this._timeout != null) {
                    clearTimeout(this._timeout);
                    this._timeout = null;
                }
                if (this.queue.length > 0 && typeof this.delay === "number") this._timeout = _setTimeout(function() {
                    _this.flush();
                }, this.delay);
            }
        },
        {
            key: "flush",
            value: function flush() {
                var _context5, _context6;
                _forEachInstanceProperty(_context5 = _spliceInstanceProperty(_context6 = this._queue).call(_context6, 0)).call(_context5, function(entry) {
                    entry.fn.apply(entry.context || entry.fn, entry.args || []);
                });
            }
        }
    ], [
        {
            key: "extend",
            value: function extend(object, options) {
                var queue = new Queue(options);
                if (object.flush !== undefined) throw new Error("Target object already has a property flush");
                object.flush = function() {
                    queue.flush();
                };
                var methods = [
                    {
                        name: "flush",
                        original: undefined
                    }
                ];
                if (options && options.replace) for(var i1 = 0; i1 < options.replace.length; i1++){
                    var name = options.replace[i1];
                    methods.push({
                        name: name,
                        // @TODO: better solution?
                        original: object[name]
                    });
                    // @TODO: better solution?
                    queue.replace(object, name);
                }
                queue._extended = {
                    object: object,
                    methods: methods
                };
                return queue;
            }
        }
    ]);
    return Queue;
}();
/**
 * {@link DataSet} code that can be reused in {@link DataView} or other similar implementations of {@link DataInterface}.
 *
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 */ var DataSetPart = /*#__PURE__*/ function() {
    function DataSetPart() {
        _classCallCheck(this, DataSetPart);
        _defineProperty(this, "_subscribers", {
            "*": [],
            add: [],
            remove: [],
            update: []
        });
        /**
     * @deprecated Use on instead (PS: DataView.subscribe === DataView.on).
     */ _defineProperty(this, "subscribe", DataSetPart.prototype.on);
        /**
     * @deprecated Use off instead (PS: DataView.unsubscribe === DataView.off).
     */ _defineProperty(this, "unsubscribe", DataSetPart.prototype.off);
    }
    _createClass(DataSetPart, [
        {
            key: "_trigger",
            value: /**
     * Trigger an event
     *
     * @param event - Event name.
     * @param payload - Event payload.
     * @param senderId - Id of the sender.
     */ function _trigger(event1, payload, senderId) {
                var _context7, _context8;
                if (event1 === "*") throw new Error("Cannot trigger event *");
                _forEachInstanceProperty(_context7 = _concatInstanceProperty(_context8 = []).call(_context8, _toConsumableArray(this._subscribers[event1]), _toConsumableArray(this._subscribers["*"]))).call(_context7, function(subscriber) {
                    subscriber(event1, payload, senderId != null ? senderId : null);
                });
            }
        },
        {
            key: "on",
            value: function on(event1, callback) {
                if (typeof callback === "function") this._subscribers[event1].push(callback);
            // @TODO: Maybe throw for invalid callbacks?
            }
        },
        {
            key: "off",
            value: function off(event1, callback) {
                var _context9;
                this._subscribers[event1] = _filterInstanceProperty(_context9 = this._subscribers[event1]).call(_context9, function(subscriber) {
                    return subscriber !== callback;
                });
            }
        }
    ]);
    return DataSetPart;
}();
/**
 * Data stream
 *
 * @remarks
 * {@link DataStream} offers an always up to date stream of items from a {@link DataSet} or {@link DataView}.
 * That means that the stream is evaluated at the time of iteration, conversion to another data type or when {@link cache} is called, not when the {@link DataStream} was created.
 * Multiple invocations of for example {@link toItemArray} may yield different results (if the data source like for example {@link DataSet} gets modified).
 * @typeParam Item - The item type this stream is going to work with.
 */ _Symbol$iterator = _Symbol$iterator2;
var DataStream = /*#__PURE__*/ function() {
    /**
   * Create a new data stream.
   *
   * @param pairs - The id, item pairs.
   */ function DataStream(pairs) {
        _classCallCheck(this, DataStream);
        _defineProperty(this, "_pairs", void 0);
        this._pairs = pairs;
    }
    /**
   * Return an iterable of key, value pairs for every entry in the stream.
   */ _createClass(DataStream, [
        {
            key: _Symbol$iterator,
            value: /*#__PURE__*/ _regeneratorRuntime.mark(function value() {
                var _iterator, _step, _step$value, id, item;
                return _regeneratorRuntime.wrap(function value$(_context10) {
                    while(true)switch(_context10.prev = _context10.next){
                        case 0:
                            _iterator = _createForOfIteratorHelper$6(this._pairs);
                            _context10.prev = 1;
                            _iterator.s();
                        case 3:
                            if ((_step = _iterator.n()).done) {
                                _context10.next = 9;
                                break;
                            }
                            _step$value = _slicedToArray(_step.value, 2), id = _step$value[0], item = _step$value[1];
                            _context10.next = 7;
                            return [
                                id,
                                item
                            ];
                        case 7:
                            _context10.next = 3;
                            break;
                        case 9:
                            _context10.next = 14;
                            break;
                        case 11:
                            _context10.prev = 11;
                            _context10.t0 = _context10["catch"](1);
                            _iterator.e(_context10.t0);
                        case 14:
                            _context10.prev = 14;
                            _iterator.f();
                            return _context10.finish(14);
                        case 17:
                        case "end":
                            return _context10.stop();
                    }
                }, value, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "entries",
            value: /*#__PURE__*/ _regeneratorRuntime.mark(function entries() {
                var _iterator2, _step2, _step2$value, id, item;
                return _regeneratorRuntime.wrap(function entries$(_context11) {
                    while(true)switch(_context11.prev = _context11.next){
                        case 0:
                            _iterator2 = _createForOfIteratorHelper$6(this._pairs);
                            _context11.prev = 1;
                            _iterator2.s();
                        case 3:
                            if ((_step2 = _iterator2.n()).done) {
                                _context11.next = 9;
                                break;
                            }
                            _step2$value = _slicedToArray(_step2.value, 2), id = _step2$value[0], item = _step2$value[1];
                            _context11.next = 7;
                            return [
                                id,
                                item
                            ];
                        case 7:
                            _context11.next = 3;
                            break;
                        case 9:
                            _context11.next = 14;
                            break;
                        case 11:
                            _context11.prev = 11;
                            _context11.t0 = _context11["catch"](1);
                            _iterator2.e(_context11.t0);
                        case 14:
                            _context11.prev = 14;
                            _iterator2.f();
                            return _context11.finish(14);
                        case 17:
                        case "end":
                            return _context11.stop();
                    }
                }, entries, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "keys",
            value: /*#__PURE__*/ _regeneratorRuntime.mark(function keys() {
                var _iterator3, _step3, _step3$value, id;
                return _regeneratorRuntime.wrap(function keys$(_context12) {
                    while(true)switch(_context12.prev = _context12.next){
                        case 0:
                            _iterator3 = _createForOfIteratorHelper$6(this._pairs);
                            _context12.prev = 1;
                            _iterator3.s();
                        case 3:
                            if ((_step3 = _iterator3.n()).done) {
                                _context12.next = 9;
                                break;
                            }
                            _step3$value = _slicedToArray(_step3.value, 1), id = _step3$value[0];
                            _context12.next = 7;
                            return id;
                        case 7:
                            _context12.next = 3;
                            break;
                        case 9:
                            _context12.next = 14;
                            break;
                        case 11:
                            _context12.prev = 11;
                            _context12.t0 = _context12["catch"](1);
                            _iterator3.e(_context12.t0);
                        case 14:
                            _context12.prev = 14;
                            _iterator3.f();
                            return _context12.finish(14);
                        case 17:
                        case "end":
                            return _context12.stop();
                    }
                }, keys, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "values",
            value: /*#__PURE__*/ _regeneratorRuntime.mark(function values() {
                var _iterator4, _step4, _step4$value, item;
                return _regeneratorRuntime.wrap(function values$(_context13) {
                    while(true)switch(_context13.prev = _context13.next){
                        case 0:
                            _iterator4 = _createForOfIteratorHelper$6(this._pairs);
                            _context13.prev = 1;
                            _iterator4.s();
                        case 3:
                            if ((_step4 = _iterator4.n()).done) {
                                _context13.next = 9;
                                break;
                            }
                            _step4$value = _slicedToArray(_step4.value, 2), item = _step4$value[1];
                            _context13.next = 7;
                            return item;
                        case 7:
                            _context13.next = 3;
                            break;
                        case 9:
                            _context13.next = 14;
                            break;
                        case 11:
                            _context13.prev = 11;
                            _context13.t0 = _context13["catch"](1);
                            _iterator4.e(_context13.t0);
                        case 14:
                            _context13.prev = 14;
                            _iterator4.f();
                            return _context13.finish(14);
                        case 17:
                        case "end":
                            return _context13.stop();
                    }
                }, values, this, [
                    [
                        1,
                        11,
                        14,
                        17
                    ]
                ]);
            })
        },
        {
            key: "toIdArray",
            value: function toIdArray() {
                var _context14;
                return _mapInstanceProperty(_context14 = _toConsumableArray(this._pairs)).call(_context14, function(pair) {
                    return pair[0];
                });
            }
        },
        {
            key: "toItemArray",
            value: function toItemArray() {
                var _context15;
                return _mapInstanceProperty(_context15 = _toConsumableArray(this._pairs)).call(_context15, function(pair) {
                    return pair[1];
                });
            }
        },
        {
            key: "toEntryArray",
            value: function toEntryArray() {
                return _toConsumableArray(this._pairs);
            }
        },
        {
            key: "toObjectMap",
            value: function toObjectMap() {
                var map = _Object$create$1(null);
                var _iterator5 = _createForOfIteratorHelper$6(this._pairs), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var _step5$value = _slicedToArray(_step5.value, 2), id = _step5$value[0], item = _step5$value[1];
                        map[id] = item;
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
                return map;
            }
        },
        {
            key: "toMap",
            value: function toMap() {
                return new _Map(this._pairs);
            }
        },
        {
            key: "toIdSet",
            value: function toIdSet() {
                return new _Set(this.toIdArray());
            }
        },
        {
            key: "toItemSet",
            value: function toItemSet() {
                return new _Set(this.toItemArray());
            }
        },
        {
            key: "cache",
            value: function cache() {
                return new DataStream(_toConsumableArray(this._pairs));
            }
        },
        {
            key: "distinct",
            value: function distinct(callback) {
                var set = new _Set();
                var _iterator6 = _createForOfIteratorHelper$6(this._pairs), _step6;
                try {
                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                        var _step6$value = _slicedToArray(_step6.value, 2), id = _step6$value[0], item = _step6$value[1];
                        set.add(callback(item, id));
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally{
                    _iterator6.f();
                }
                return set;
            }
        },
        {
            key: "filter",
            value: function filter(callback) {
                var pairs = this._pairs;
                return new DataStream(_defineProperty({}, _Symbol$iterator2, /*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
                    var _iterator7, _step7, _step7$value, id, item;
                    return _regeneratorRuntime.wrap(function _callee$(_context16) {
                        while(true)switch(_context16.prev = _context16.next){
                            case 0:
                                _iterator7 = _createForOfIteratorHelper$6(pairs);
                                _context16.prev = 1;
                                _iterator7.s();
                            case 3:
                                if ((_step7 = _iterator7.n()).done) {
                                    _context16.next = 10;
                                    break;
                                }
                                _step7$value = _slicedToArray(_step7.value, 2), id = _step7$value[0], item = _step7$value[1];
                                if (!callback(item, id)) {
                                    _context16.next = 8;
                                    break;
                                }
                                _context16.next = 8;
                                return [
                                    id,
                                    item
                                ];
                            case 8:
                                _context16.next = 3;
                                break;
                            case 10:
                                _context16.next = 15;
                                break;
                            case 12:
                                _context16.prev = 12;
                                _context16.t0 = _context16["catch"](1);
                                _iterator7.e(_context16.t0);
                            case 15:
                                _context16.prev = 15;
                                _iterator7.f();
                                return _context16.finish(15);
                            case 18:
                            case "end":
                                return _context16.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            12,
                            15,
                            18
                        ]
                    ]);
                })));
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                var _iterator8 = _createForOfIteratorHelper$6(this._pairs), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var _step8$value = _slicedToArray(_step8.value, 2), id = _step8$value[0], item = _step8$value[1];
                        callback(item, id);
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
            }
        },
        {
            key: "map",
            value: function map(callback) {
                var pairs = this._pairs;
                return new DataStream(_defineProperty({}, _Symbol$iterator2, /*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() {
                    var _iterator9, _step9, _step9$value, id, item;
                    return _regeneratorRuntime.wrap(function _callee2$(_context17) {
                        while(true)switch(_context17.prev = _context17.next){
                            case 0:
                                _iterator9 = _createForOfIteratorHelper$6(pairs);
                                _context17.prev = 1;
                                _iterator9.s();
                            case 3:
                                if ((_step9 = _iterator9.n()).done) {
                                    _context17.next = 9;
                                    break;
                                }
                                _step9$value = _slicedToArray(_step9.value, 2), id = _step9$value[0], item = _step9$value[1];
                                _context17.next = 7;
                                return [
                                    id,
                                    callback(item, id)
                                ];
                            case 7:
                                _context17.next = 3;
                                break;
                            case 9:
                                _context17.next = 14;
                                break;
                            case 11:
                                _context17.prev = 11;
                                _context17.t0 = _context17["catch"](1);
                                _iterator9.e(_context17.t0);
                            case 14:
                                _context17.prev = 14;
                                _iterator9.f();
                                return _context17.finish(14);
                            case 17:
                            case "end":
                                return _context17.stop();
                        }
                    }, _callee2, null, [
                        [
                            1,
                            11,
                            14,
                            17
                        ]
                    ]);
                })));
            }
        },
        {
            key: "max",
            value: function max(callback) {
                var iter = _getIterator(this._pairs);
                var curr = iter.next();
                if (curr.done) return null;
                var maxItem = curr.value[1];
                var maxValue = callback(curr.value[1], curr.value[0]);
                while(!(curr = iter.next()).done){
                    var _curr$value = _slicedToArray(curr.value, 2), id = _curr$value[0], item = _curr$value[1];
                    var _value = callback(item, id);
                    if (_value > maxValue) {
                        maxValue = _value;
                        maxItem = item;
                    }
                }
                return maxItem;
            }
        },
        {
            key: "min",
            value: function min(callback) {
                var iter = _getIterator(this._pairs);
                var curr = iter.next();
                if (curr.done) return null;
                var minItem = curr.value[1];
                var minValue = callback(curr.value[1], curr.value[0]);
                while(!(curr = iter.next()).done){
                    var _curr$value2 = _slicedToArray(curr.value, 2), id = _curr$value2[0], item = _curr$value2[1];
                    var _value2 = callback(item, id);
                    if (_value2 < minValue) {
                        minValue = _value2;
                        minItem = item;
                    }
                }
                return minItem;
            }
        },
        {
            key: "reduce",
            value: function reduce(callback, accumulator) {
                var _iterator10 = _createForOfIteratorHelper$6(this._pairs), _step10;
                try {
                    for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                        var _step10$value = _slicedToArray(_step10.value, 2), id = _step10$value[0], item = _step10$value[1];
                        accumulator = callback(accumulator, item, id);
                    }
                } catch (err) {
                    _iterator10.e(err);
                } finally{
                    _iterator10.f();
                }
                return accumulator;
            }
        },
        {
            key: "sort",
            value: function sort(callback) {
                var _this2 = this;
                return new DataStream(_defineProperty({}, _Symbol$iterator2, function() {
                    var _context18;
                    return _getIterator(_sortInstanceProperty(_context18 = _toConsumableArray(_this2._pairs)).call(_context18, function(_ref, _ref2) {
                        var _ref3 = _slicedToArray(_ref, 2), idA = _ref3[0], itemA = _ref3[1];
                        var _ref4 = _slicedToArray(_ref2, 2), idB = _ref4[0], itemB = _ref4[1];
                        return callback(itemA, itemB, idA, idB);
                    }));
                }));
            }
        }
    ]);
    return DataStream;
}();
/**
 * Add an id to given item if it doesn't have one already.
 *
 * @remarks
 * The item will be modified.
 * @param item - The item that will have an id after a call to this function.
 * @param idProp - The key of the id property.
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 * @returns true
 */ function ensureFullItem(item, idProp) {
    if (item[idProp] == null) // generate an id
    item[idProp] = v4();
    return item;
}
/**
 * # DataSet
 *
 * Vis.js comes with a flexible DataSet, which can be used to hold and
 * manipulate unstructured data and listen for changes in the data. The DataSet
 * is key/value based. Data items can be added, updated and removed from the
 * DataSet, and one can subscribe to changes in the DataSet. The data in the
 * DataSet can be filtered and ordered. Data can be normalized when appending it
 * to the DataSet as well.
 *
 * ## Example
 *
 * The following example shows how to use a DataSet.
 *
 * ```javascript
 * // create a DataSet
 * var options = {};
 * var data = new vis.DataSet(options);
 *
 * // add items
 * // note that the data items can contain different properties and data formats
 * data.add([
 *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
 *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
 *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
 *   {id: 4, text: 'item 4'}
 * ]);
 *
 * // subscribe to any change in the DataSet
 * data.on('*', function (event, properties, senderId) {
 *   console.log('event', event, properties);
 * });
 *
 * // update an existing item
 * data.update({id: 2, group: 1});
 *
 * // remove an item
 * data.remove(4);
 *
 * // get all ids
 * var ids = data.getIds();
 * console.log('ids', ids);
 *
 * // get a specific item
 * var item1 = data.get(1);
 * console.log('item1', item1);
 *
 * // retrieve a filtered subset of the data
 * var items = data.get({
 *   filter: function (item) {
 *     return item.group == 1;
 *   }
 * });
 * console.log('filtered items', items);
 * ```
 *
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 */ var DataSet = /*#__PURE__*/ function(_DataSetPart) {
    _inherits(DataSet, _DataSetPart);
    var _super = _createSuper$d(DataSet);
    /**
   * Construct a new DataSet.
   *
   * @param data - Initial data or options.
   * @param options - Options (type error if data is also options).
   */ function DataSet(data, options) {
        var _this3;
        _classCallCheck(this, DataSet);
        _this3 = _super.call(this);
        // correctly read optional arguments
        /** Flush all queued calls. */ _defineProperty(_assertThisInitialized(_this3), "flush", void 0);
        /** @inheritDoc */ _defineProperty(_assertThisInitialized(_this3), "length", void 0);
        _defineProperty(_assertThisInitialized(_this3), "_options", void 0);
        _defineProperty(_assertThisInitialized(_this3), "_data", void 0);
        _defineProperty(_assertThisInitialized(_this3), "_idProp", void 0);
        _defineProperty(_assertThisInitialized(_this3), "_queue", null);
        if (data && !_Array$isArray(data)) {
            options = data;
            data = [];
        }
        _this3._options = options || {};
        _this3._data = new _Map(); // map with data indexed by id
        _this3.length = 0; // number of items in the DataSet
        _this3._idProp = _this3._options.fieldId || "id"; // name of the field containing id
        // add initial data when provided
        if (data && data.length) _this3.add(data);
        _this3.setOptions(options);
        return _this3;
    }
    /**
   * Set new options.
   *
   * @param options - The new options.
   */ _createClass(DataSet, [
        {
            key: "idProp",
            get: /** @inheritDoc */ function get() {
                return this._idProp;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options && options.queue !== undefined) {
                    if (options.queue === false) // delete queue if loaded
                    {
                        if (this._queue) {
                            this._queue.destroy();
                            this._queue = null;
                        }
                    } else {
                        // create queue and update its options
                        if (!this._queue) this._queue = Queue.extend(this, {
                            replace: [
                                "add",
                                "update",
                                "remove"
                            ]
                        });
                        if (options.queue && _typeof$1(options.queue) === "object") this._queue.setOptions(options.queue);
                    }
                }
            }
        },
        {
            key: "add",
            value: function add(data, senderId) {
                var _this4 = this;
                var addedIds = [];
                var id;
                if (_Array$isArray(data)) {
                    // Array
                    var idsToAdd = _mapInstanceProperty(data).call(data, function(d) {
                        return d[_this4._idProp];
                    });
                    if (_someInstanceProperty(idsToAdd).call(idsToAdd, function(id) {
                        return _this4._data.has(id);
                    })) throw new Error("A duplicate id was found in the parameter array.");
                    for(var i1 = 0, len = data.length; i1 < len; i1++){
                        id = this._addItem(data[i1]);
                        addedIds.push(id);
                    }
                } else if (data && _typeof$1(data) === "object") {
                    // Single item
                    id = this._addItem(data);
                    addedIds.push(id);
                } else throw new Error("Unknown dataType");
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                }, senderId);
                return addedIds;
            }
        },
        {
            key: "update",
            value: function update(data, senderId) {
                var _this5 = this;
                var addedIds = [];
                var updatedIds = [];
                var oldData = [];
                var updatedData = [];
                var idProp = this._idProp;
                var addOrUpdate = function addOrUpdate(item) {
                    var origId = item[idProp];
                    if (origId != null && _this5._data.has(origId)) {
                        var fullItem = item; // it has an id, therefore it is a fullitem
                        var oldItem = _Object$assign({}, _this5._data.get(origId));
                        // update item
                        var id = _this5._updateItem(fullItem);
                        updatedIds.push(id);
                        updatedData.push(fullItem);
                        oldData.push(oldItem);
                    } else {
                        // add new item
                        var _id = _this5._addItem(item);
                        addedIds.push(_id);
                    }
                };
                if (_Array$isArray(data)) {
                    // Array
                    for(var i1 = 0, len = data.length; i1 < len; i1++)if (data[i1] && _typeof$1(data[i1]) === "object") addOrUpdate(data[i1]);
                    else console.warn("Ignoring input item, which is not an object at index " + i1);
                } else if (data && _typeof$1(data) === "object") // Single item
                addOrUpdate(data);
                else throw new Error("Unknown dataType");
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                }, senderId);
                if (updatedIds.length) {
                    var props = {
                        items: updatedIds,
                        oldData: oldData,
                        data: updatedData
                    };
                    // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});
                    this._trigger("update", props, senderId);
                }
                return _concatInstanceProperty(addedIds).call(addedIds, updatedIds);
            }
        },
        {
            key: "updateOnly",
            value: function updateOnly(data, senderId) {
                var _context19, _this6 = this;
                if (!_Array$isArray(data)) data = [
                    data
                ];
                var updateEventData = _mapInstanceProperty(_context19 = _mapInstanceProperty(data).call(data, function(update) {
                    var oldData = _this6._data.get(update[_this6._idProp]);
                    if (oldData == null) throw new Error("Updating non-existent items is not allowed.");
                    return {
                        oldData: oldData,
                        update: update
                    };
                })).call(_context19, function(_ref5) {
                    var oldData = _ref5.oldData, update = _ref5.update;
                    var id = oldData[_this6._idProp];
                    var updatedData = pureDeepObjectAssign(oldData, update);
                    _this6._data.set(id, updatedData);
                    return {
                        id: id,
                        oldData: oldData,
                        updatedData: updatedData
                    };
                });
                if (updateEventData.length) {
                    var props = {
                        items: _mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                            return value.id;
                        }),
                        oldData: _mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                            return value.oldData;
                        }),
                        data: _mapInstanceProperty(updateEventData).call(updateEventData, function(value) {
                            return value.updatedData;
                        })
                    };
                    // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});
                    this._trigger("update", props, senderId);
                    return props.items;
                } else return [];
            }
        },
        {
            key: "get",
            value: function get(first, second) {
                // @TODO: Woudn't it be better to split this into multiple methods?
                // parse the arguments
                var id = undefined;
                var ids = undefined;
                var options = undefined;
                if (isId(first)) {
                    // get(id [, options])
                    id = first;
                    options = second;
                } else if (_Array$isArray(first)) {
                    // get(ids [, options])
                    ids = first;
                    options = second;
                } else // get([, options])
                options = first;
                // determine the return type
                var returnType = options && options.returnType === "Object" ? "Object" : "Array";
                // @TODO: WTF is this? Or am I missing something?
                // var returnType
                // if (options && options.returnType) {
                //   var allowedValues = ['Array', 'Object']
                //   returnType =
                //     allowedValues.indexOf(options.returnType) == -1
                //       ? 'Array'
                //       : options.returnType
                // } else {
                //   returnType = 'Array'
                // }
                // build options
                var filter = options && _filterInstanceProperty(options);
                var items = [];
                var item = undefined;
                var itemIds = undefined;
                var itemId = undefined;
                // convert items
                if (id != null) {
                    // return a single item
                    item = this._data.get(id);
                    if (item && filter && !filter(item)) item = undefined;
                } else if (ids != null) // return a subset of items
                for(var i1 = 0, len = ids.length; i1 < len; i1++){
                    item = this._data.get(ids[i1]);
                    if (item != null && (!filter || filter(item))) items.push(item);
                }
                else {
                    var _context20;
                    // return all items
                    itemIds = _toConsumableArray(_keysInstanceProperty(_context20 = this._data).call(_context20));
                    for(var _i = 0, _len2 = itemIds.length; _i < _len2; _i++){
                        itemId = itemIds[_i];
                        item = this._data.get(itemId);
                        if (item != null && (!filter || filter(item))) items.push(item);
                    }
                }
                // order the results
                if (options && options.order && id == undefined) this._sort(items, options.order);
                // filter fields of the items
                if (options && options.fields) {
                    var fields = options.fields;
                    if (id != undefined && item != null) item = this._filterFields(item, fields);
                    else for(var _i2 = 0, _len3 = items.length; _i2 < _len3; _i2++)items[_i2] = this._filterFields(items[_i2], fields);
                }
                // return the results
                if (returnType == "Object") {
                    var result = {};
                    for(var _i3 = 0, _len4 = items.length; _i3 < _len4; _i3++){
                        var resultant = items[_i3];
                        // @TODO: Shoudn't this be this._fieldId?
                        // result[resultant.id] = resultant
                        var _id2 = resultant[this._idProp];
                        result[_id2] = resultant;
                    }
                    return result;
                } else {
                    if (id != null) {
                        var _item;
                        // a single item
                        return (_item = item) !== null && _item !== void 0 ? _item : null;
                    } else // just return our array
                    return items;
                }
            }
        },
        {
            key: "getIds",
            value: function getIds(options) {
                var data = this._data;
                var filter = options && _filterInstanceProperty(options);
                var order = options && options.order;
                var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                var ids = [];
                if (filter) {
                    // get filtered items
                    if (order) {
                        // create ordered list
                        var items = [];
                        for(var i1 = 0, len = itemIds.length; i1 < len; i1++){
                            var id = itemIds[i1];
                            var item = this._data.get(id);
                            if (item != null && filter(item)) items.push(item);
                        }
                        this._sort(items, order);
                        for(var _i4 = 0, _len5 = items.length; _i4 < _len5; _i4++)ids.push(items[_i4][this._idProp]);
                    } else // create unordered list
                    for(var _i5 = 0, _len6 = itemIds.length; _i5 < _len6; _i5++){
                        var _id3 = itemIds[_i5];
                        var _item2 = this._data.get(_id3);
                        if (_item2 != null && filter(_item2)) ids.push(_item2[this._idProp]);
                    }
                } else {
                    // get all items
                    if (order) {
                        // create an ordered list
                        var _items = [];
                        for(var _i6 = 0, _len7 = itemIds.length; _i6 < _len7; _i6++){
                            var _id4 = itemIds[_i6];
                            _items.push(data.get(_id4));
                        }
                        this._sort(_items, order);
                        for(var _i7 = 0, _len8 = _items.length; _i7 < _len8; _i7++)ids.push(_items[_i7][this._idProp]);
                    } else // create unordered list
                    for(var _i8 = 0, _len9 = itemIds.length; _i8 < _len9; _i8++){
                        var _id5 = itemIds[_i8];
                        var _item3 = data.get(_id5);
                        if (_item3 != null) ids.push(_item3[this._idProp]);
                    }
                }
                return ids;
            }
        },
        {
            key: "getDataSet",
            value: function getDataSet() {
                return this;
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, options) {
                var filter = options && _filterInstanceProperty(options);
                var data = this._data;
                var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                if (options && options.order) {
                    // execute forEach on ordered list
                    var items = this.get(options);
                    for(var i1 = 0, len = items.length; i1 < len; i1++){
                        var item = items[i1];
                        var id = item[this._idProp];
                        callback(item, id);
                    }
                } else // unordered
                for(var _i9 = 0, _len10 = itemIds.length; _i9 < _len10; _i9++){
                    var _id6 = itemIds[_i9];
                    var _item4 = this._data.get(_id6);
                    if (_item4 != null && (!filter || filter(_item4))) callback(_item4, _id6);
                }
            }
        },
        {
            key: "map",
            value: function map(callback, options) {
                var filter = options && _filterInstanceProperty(options);
                var mappedItems = [];
                var data = this._data;
                var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                // convert and filter items
                for(var i1 = 0, len = itemIds.length; i1 < len; i1++){
                    var id = itemIds[i1];
                    var item = this._data.get(id);
                    if (item != null && (!filter || filter(item))) mappedItems.push(callback(item, id));
                }
                // order items
                if (options && options.order) this._sort(mappedItems, options.order);
                return mappedItems;
            }
        },
        {
            key: "_filterFields",
            value: function _filterFields(item, fields) {
                var _context21;
                if (!item) // item is null
                return item;
                return _reduceInstanceProperty(_context21 = _Array$isArray(fields) ? // Use the supplied array
                fields : // Use the keys of the supplied object
                _Object$keys(fields)).call(_context21, function(filteredItem, field) {
                    filteredItem[field] = item[field];
                    return filteredItem;
                }, {});
            }
        },
        {
            key: "_sort",
            value: function _sort(items, order) {
                if (typeof order === "string") {
                    // order by provided field name
                    var name = order; // field name
                    _sortInstanceProperty(items).call(items, function(a, b) {
                        // @TODO: How to treat missing properties?
                        var av = a[name];
                        var bv = b[name];
                        return av > bv ? 1 : av < bv ? -1 : 0;
                    });
                } else if (typeof order === "function") // order by sort function
                _sortInstanceProperty(items).call(items, order);
                else // TODO: extend order by an Object {field:string, direction:string}
                //       where direction can be 'asc' or 'desc'
                throw new TypeError("Order must be a function or a string");
            }
        },
        {
            key: "remove",
            value: function remove(id, senderId) {
                var removedIds = [];
                var removedItems = [];
                // force everything to be an array for simplicity
                var ids = _Array$isArray(id) ? id : [
                    id
                ];
                for(var i1 = 0, len = ids.length; i1 < len; i1++){
                    var item = this._remove(ids[i1]);
                    if (item) {
                        var itemId = item[this._idProp];
                        if (itemId != null) {
                            removedIds.push(itemId);
                            removedItems.push(item);
                        }
                    }
                }
                if (removedIds.length) this._trigger("remove", {
                    items: removedIds,
                    oldData: removedItems
                }, senderId);
                return removedIds;
            }
        },
        {
            key: "_remove",
            value: function _remove(id) {
                // @TODO: It origianlly returned the item although the docs say id.
                // The code expects the item, so probably an error in the docs.
                var ident;
                // confirm the id to use based on the args type
                if (isId(id)) ident = id;
                else if (id && _typeof$1(id) === "object") ident = id[this._idProp]; // look for the identifier field using ._idProp
                // do the removing if the item is found
                if (ident != null && this._data.has(ident)) {
                    var item = this._data.get(ident) || null;
                    this._data.delete(ident);
                    --this.length;
                    return item;
                }
                return null;
            }
        },
        {
            key: "clear",
            value: function clear(senderId) {
                var _context22;
                var ids = _toConsumableArray(_keysInstanceProperty(_context22 = this._data).call(_context22));
                var items = [];
                for(var i1 = 0, len = ids.length; i1 < len; i1++)items.push(this._data.get(ids[i1]));
                this._data.clear();
                this.length = 0;
                this._trigger("remove", {
                    items: ids,
                    oldData: items
                }, senderId);
                return ids;
            }
        },
        {
            key: "max",
            value: function max(field) {
                var _context23;
                var max = null;
                var maxField = null;
                var _iterator11 = _createForOfIteratorHelper$6(_valuesInstanceProperty(_context23 = this._data).call(_context23)), _step11;
                try {
                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                        var item = _step11.value;
                        var itemField = item[field];
                        if (typeof itemField === "number" && (maxField == null || itemField > maxField)) {
                            max = item;
                            maxField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator11.e(err);
                } finally{
                    _iterator11.f();
                }
                return max || null;
            }
        },
        {
            key: "min",
            value: function min(field) {
                var _context24;
                var min = null;
                var minField = null;
                var _iterator12 = _createForOfIteratorHelper$6(_valuesInstanceProperty(_context24 = this._data).call(_context24)), _step12;
                try {
                    for(_iterator12.s(); !(_step12 = _iterator12.n()).done;){
                        var item = _step12.value;
                        var itemField = item[field];
                        if (typeof itemField === "number" && (minField == null || itemField < minField)) {
                            min = item;
                            minField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator12.e(err);
                } finally{
                    _iterator12.f();
                }
                return min || null;
            }
        },
        {
            key: "distinct",
            value: function distinct(prop) {
                var data = this._data;
                var itemIds = _toConsumableArray(_keysInstanceProperty(data).call(data));
                var values = [];
                var count = 0;
                for(var i1 = 0, len = itemIds.length; i1 < len; i1++){
                    var id = itemIds[i1];
                    var item = data.get(id);
                    var _value3 = item[prop];
                    var exists = false;
                    for(var j = 0; j < count; j++)if (values[j] == _value3) {
                        exists = true;
                        break;
                    }
                    if (!exists && _value3 !== undefined) {
                        values[count] = _value3;
                        count++;
                    }
                }
                return values;
            }
        },
        {
            key: "_addItem",
            value: function _addItem(item) {
                var fullItem = ensureFullItem(item, this._idProp);
                var id = fullItem[this._idProp];
                // check whether this id is already taken
                if (this._data.has(id)) // item already exists
                throw new Error("Cannot add item: item with id " + id + " already exists");
                this._data.set(id, fullItem);
                ++this.length;
                return id;
            }
        },
        {
            key: "_updateItem",
            value: function _updateItem(update) {
                var id = update[this._idProp];
                if (id == null) throw new Error("Cannot update item: item has no id (item: " + _JSON$stringify(update) + ")");
                var item = this._data.get(id);
                if (!item) // item doesn't exist
                throw new Error("Cannot update item: no item with id " + id + " found");
                this._data.set(id, _objectSpread$1(_objectSpread$1({}, item), update));
                return id;
            }
        },
        {
            key: "stream",
            value: function stream(ids) {
                if (ids) {
                    var data = this._data;
                    return new DataStream(_defineProperty({}, _Symbol$iterator2, /*#__PURE__*/ _regeneratorRuntime.mark(function _callee3() {
                        var _iterator13, _step13, id, item;
                        return _regeneratorRuntime.wrap(function _callee3$(_context25) {
                            while(true)switch(_context25.prev = _context25.next){
                                case 0:
                                    _iterator13 = _createForOfIteratorHelper$6(ids);
                                    _context25.prev = 1;
                                    _iterator13.s();
                                case 3:
                                    if ((_step13 = _iterator13.n()).done) {
                                        _context25.next = 11;
                                        break;
                                    }
                                    id = _step13.value;
                                    item = data.get(id);
                                    if (!(item != null)) {
                                        _context25.next = 9;
                                        break;
                                    }
                                    _context25.next = 9;
                                    return [
                                        id,
                                        item
                                    ];
                                case 9:
                                    _context25.next = 3;
                                    break;
                                case 11:
                                    _context25.next = 16;
                                    break;
                                case 13:
                                    _context25.prev = 13;
                                    _context25.t0 = _context25["catch"](1);
                                    _iterator13.e(_context25.t0);
                                case 16:
                                    _context25.prev = 16;
                                    _iterator13.f();
                                    return _context25.finish(16);
                                case 19:
                                case "end":
                                    return _context25.stop();
                            }
                        }, _callee3, null, [
                            [
                                1,
                                13,
                                16,
                                19
                            ]
                        ]);
                    })));
                } else {
                    var _context26;
                    return new DataStream(_defineProperty({}, _Symbol$iterator2, _bindInstanceProperty$1(_context26 = _entriesInstanceProperty(this._data)).call(_context26, this._data)));
                }
            }
        }
    ]);
    return DataSet;
}(DataSetPart);
/**
 * DataView
 *
 * A DataView offers a filtered and/or formatted view on a DataSet. One can subscribe to changes in a DataView, and easily get filtered or formatted data without having to specify filters and field types all the time.
 *
 * ## Example
 * ```javascript
 * // create a DataSet
 * var data = new vis.DataSet();
 * data.add([
 *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
 *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
 *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
 *   {id: 4, text: 'item 4'}
 * ]);
 *
 * // create a DataView
 * // the view will only contain items having a property group with value 1,
 * // and will only output fields id, text, and date.
 * var view = new vis.DataView(data, {
 *   filter: function (item) {
 *     return (item.group == 1);
 *   },
 *   fields: ['id', 'text', 'date']
 * });
 *
 * // subscribe to any change in the DataView
 * view.on('*', function (event, properties, senderId) {
 *   console.log('event', event, properties);
 * });
 *
 * // update an item in the data set
 * data.update({id: 2, group: 1});
 *
 * // get all ids in the view
 * var ids = view.getIds();
 * console.log('ids', ids); // will output [1, 2]
 *
 * // get all items in the view
 * var items = view.get();
 * ```
 *
 * @typeParam Item - Item type that may or may not have an id.
 * @typeParam IdProp - Name of the property that contains the id.
 */ var DataView = /*#__PURE__*/ function(_DataSetPart2) {
    _inherits(DataView, _DataSetPart2);
    var _super2 = _createSuper$d(DataView);
    /**
   * Create a DataView.
   *
   * @param data - The instance containing data (directly or indirectly).
   * @param options - Options to configure this data view.
   */ function DataView(data, options) {
        var _context27;
        var _this7;
        _classCallCheck(this, DataView);
        _this7 = _super2.call(this);
        /** @inheritDoc */ _defineProperty(_assertThisInitialized(_this7), "length", 0);
        _defineProperty(_assertThisInitialized(_this7), "_listener", void 0);
        _defineProperty(_assertThisInitialized(_this7), "_data", void 0);
        // constructor → setData
        _defineProperty(_assertThisInitialized(_this7), "_ids", new _Set());
        // ids of the items currently in memory (just contains a boolean true)
        _defineProperty(_assertThisInitialized(_this7), "_options", void 0);
        _this7._options = options || {};
        _this7._listener = _bindInstanceProperty$1(_context27 = _this7._onEvent).call(_context27, _assertThisInitialized(_this7));
        _this7.setData(data);
        return _this7;
    }
    // TODO: implement a function .config() to dynamically update things like configured filter
    // and trigger changes accordingly
    /**
   * Set a data source for the view.
   *
   * @param data - The instance containing data (directly or indirectly).
   * @remarks
   * Note that when the data view is bound to a data set it won't be garbage
   * collected unless the data set is too. Use `dataView.setData(null)` or
   * `dataView.dispose()` to enable garbage collection before you lose the last
   * reference.
   */ _createClass(DataView, [
        {
            key: "idProp",
            get: /** @inheritDoc */ function get() {
                return this.getDataSet().idProp;
            }
        },
        {
            key: "setData",
            value: function setData(data) {
                if (this._data) {
                    // unsubscribe from current dataset
                    if (this._data.off) this._data.off("*", this._listener);
                    // trigger a remove of all items in memory
                    var ids = this._data.getIds({
                        filter: _filterInstanceProperty(this._options)
                    });
                    var items = this._data.get(ids);
                    this._ids.clear();
                    this.length = 0;
                    this._trigger("remove", {
                        items: ids,
                        oldData: items
                    });
                }
                if (data != null) {
                    this._data = data;
                    // trigger an add of all added items
                    var _ids = this._data.getIds({
                        filter: _filterInstanceProperty(this._options)
                    });
                    for(var i1 = 0, len = _ids.length; i1 < len; i1++){
                        var id = _ids[i1];
                        this._ids.add(id);
                    }
                    this.length = _ids.length;
                    this._trigger("add", {
                        items: _ids
                    });
                } else this._data = new DataSet();
                // subscribe to new dataset
                if (this._data.on) this._data.on("*", this._listener);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var ids = this._data.getIds({
                    filter: _filterInstanceProperty(this._options)
                });
                var oldIds = _toConsumableArray(this._ids);
                var newIds = {};
                var addedIds = [];
                var removedIds = [];
                var removedItems = [];
                // check for additions
                for(var i1 = 0, len = ids.length; i1 < len; i1++){
                    var id = ids[i1];
                    newIds[id] = true;
                    if (!this._ids.has(id)) {
                        addedIds.push(id);
                        this._ids.add(id);
                    }
                }
                // check for removals
                for(var _i10 = 0, _len11 = oldIds.length; _i10 < _len11; _i10++){
                    var _id7 = oldIds[_i10];
                    var item = this._data.get(_id7);
                    if (item == null) // @TODO: Investigate.
                    // Doesn't happen during tests or examples.
                    // Is it really impossible or could it eventually happen?
                    // How to handle it if it does? The types guarantee non-nullable items.
                    console.error("If you see this, report it please.");
                    else if (!newIds[_id7]) {
                        removedIds.push(_id7);
                        removedItems.push(item);
                        this._ids.delete(_id7);
                    }
                }
                this.length += addedIds.length - removedIds.length;
                // trigger events
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                });
                if (removedIds.length) this._trigger("remove", {
                    items: removedIds,
                    oldData: removedItems
                });
            }
        },
        {
            key: "get",
            value: function get(first, second) {
                if (this._data == null) return null;
                // parse the arguments
                var ids = null;
                var options;
                if (isId(first) || _Array$isArray(first)) {
                    ids = first;
                    options = second;
                } else options = first;
                // extend the options with the default options and provided options
                var viewOptions = _Object$assign({}, this._options, options);
                // create a combined filter method when needed
                var thisFilter = _filterInstanceProperty(this._options);
                var optionsFilter = options && _filterInstanceProperty(options);
                if (thisFilter && optionsFilter) viewOptions.filter = function(item) {
                    return thisFilter(item) && optionsFilter(item);
                };
                if (ids == null) return this._data.get(viewOptions);
                else return this._data.get(ids, viewOptions);
            }
        },
        {
            key: "getIds",
            value: function getIds(options) {
                if (this._data.length) {
                    var defaultFilter = _filterInstanceProperty(this._options);
                    var optionsFilter = options != null ? _filterInstanceProperty(options) : null;
                    var filter;
                    if (optionsFilter) {
                        if (defaultFilter) filter = function filter(item) {
                            return defaultFilter(item) && optionsFilter(item);
                        };
                        else filter = optionsFilter;
                    } else filter = defaultFilter;
                    return this._data.getIds({
                        filter: filter,
                        order: options && options.order
                    });
                } else return [];
            }
        },
        {
            key: "forEach",
            value: function forEach(callback, options) {
                if (this._data) {
                    var _context28;
                    var defaultFilter = _filterInstanceProperty(this._options);
                    var optionsFilter = options && _filterInstanceProperty(options);
                    var filter;
                    if (optionsFilter) {
                        if (defaultFilter) filter = function filter(item) {
                            return defaultFilter(item) && optionsFilter(item);
                        };
                        else filter = optionsFilter;
                    } else filter = defaultFilter;
                    _forEachInstanceProperty(_context28 = this._data).call(_context28, callback, {
                        filter: filter,
                        order: options && options.order
                    });
                }
            }
        },
        {
            key: "map",
            value: function map(callback, options) {
                if (this._data) {
                    var _context29;
                    var defaultFilter = _filterInstanceProperty(this._options);
                    var optionsFilter = options && _filterInstanceProperty(options);
                    var filter;
                    if (optionsFilter) {
                        if (defaultFilter) filter = function filter(item) {
                            return defaultFilter(item) && optionsFilter(item);
                        };
                        else filter = optionsFilter;
                    } else filter = defaultFilter;
                    return _mapInstanceProperty(_context29 = this._data).call(_context29, callback, {
                        filter: filter,
                        order: options && options.order
                    });
                } else return [];
            }
        },
        {
            key: "getDataSet",
            value: function getDataSet() {
                return this._data.getDataSet();
            }
        },
        {
            key: "stream",
            value: function stream(ids) {
                var _context30;
                return this._data.stream(ids || _defineProperty({}, _Symbol$iterator2, _bindInstanceProperty$1(_context30 = _keysInstanceProperty(this._ids)).call(_context30, this._ids)));
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$_data;
                if ((_this$_data = this._data) !== null && _this$_data !== void 0 && _this$_data.off) this._data.off("*", this._listener);
                var message = "This data view has already been disposed of.";
                var replacement = {
                    get: function get() {
                        throw new Error(message);
                    },
                    set: function set() {
                        throw new Error(message);
                    },
                    configurable: false
                };
                var _iterator14 = _createForOfIteratorHelper$6(_Reflect$ownKeys(DataView.prototype)), _step14;
                try {
                    for(_iterator14.s(); !(_step14 = _iterator14.n()).done;){
                        var key = _step14.value;
                        _Object$defineProperty(this, key, replacement);
                    }
                } catch (err) {
                    _iterator14.e(err);
                } finally{
                    _iterator14.f();
                }
            }
        },
        {
            key: "_onEvent",
            value: function _onEvent(event1, params, senderId) {
                if (!params || !params.items || !this._data) return;
                var ids = params.items;
                var addedIds = [];
                var updatedIds = [];
                var removedIds = [];
                var oldItems = [];
                var updatedItems = [];
                var removedItems = [];
                switch(event1){
                    case "add":
                        // filter the ids of the added items
                        for(var i1 = 0, len = ids.length; i1 < len; i1++){
                            var id = ids[i1];
                            var item = this.get(id);
                            if (item) {
                                this._ids.add(id);
                                addedIds.push(id);
                            }
                        }
                        break;
                    case "update":
                        // determine the event from the views viewpoint: an updated
                        // item can be added, updated, or removed from this view.
                        for(var _i11 = 0, _len12 = ids.length; _i11 < _len12; _i11++){
                            var _id8 = ids[_i11];
                            var _item5 = this.get(_id8);
                            if (_item5) {
                                if (this._ids.has(_id8)) {
                                    updatedIds.push(_id8);
                                    updatedItems.push(params.data[_i11]);
                                    oldItems.push(params.oldData[_i11]);
                                } else {
                                    this._ids.add(_id8);
                                    addedIds.push(_id8);
                                }
                            } else if (this._ids.has(_id8)) {
                                this._ids.delete(_id8);
                                removedIds.push(_id8);
                                removedItems.push(params.oldData[_i11]);
                            }
                        }
                        break;
                    case "remove":
                        // filter the ids of the removed items
                        for(var _i12 = 0, _len13 = ids.length; _i12 < _len13; _i12++){
                            var _id9 = ids[_i12];
                            if (this._ids.has(_id9)) {
                                this._ids.delete(_id9);
                                removedIds.push(_id9);
                                removedItems.push(params.oldData[_i12]);
                            }
                        }
                        break;
                }
                this.length += addedIds.length - removedIds.length;
                if (addedIds.length) this._trigger("add", {
                    items: addedIds
                }, senderId);
                if (updatedIds.length) this._trigger("update", {
                    items: updatedIds,
                    oldData: oldItems,
                    data: updatedItems
                }, senderId);
                if (removedIds.length) this._trigger("remove", {
                    items: removedIds,
                    oldData: removedItems
                }, senderId);
            }
        }
    ]);
    return DataView;
}(DataSetPart);
/**
 * Check that given value is compatible with Vis Data Set interface.
 *
 * @param idProp - The expected property to contain item id.
 * @param v - The value to be tested.
 * @returns True if all expected values and methods match, false otherwise.
 */ function isDataSetLike(idProp, v) {
    return _typeof$1(v) === "object" && v !== null && idProp === v.idProp && typeof v.add === "function" && typeof v.clear === "function" && typeof v.distinct === "function" && typeof _forEachInstanceProperty(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof _mapInstanceProperty(v) === "function" && typeof v.max === "function" && typeof v.min === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.remove === "function" && typeof v.setOptions === "function" && typeof v.stream === "function" && typeof v.update === "function" && typeof v.updateOnly === "function";
}
/**
 * Check that given value is compatible with Vis Data View interface.
 *
 * @param idProp - The expected property to contain item id.
 * @param v - The value to be tested.
 * @returns True if all expected values and methods match, false otherwise.
 */ function isDataViewLike$1(idProp, v) {
    return _typeof$1(v) === "object" && v !== null && idProp === v.idProp && typeof _forEachInstanceProperty(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof _mapInstanceProperty(v) === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.stream === "function" && isDataSetLike(idProp, v.getDataSet());
}
// first check if moment.js is already loaded in the browser window, if so,
// use this instance. Else, load via commonjs.
//
// Note: This doesn't work in ESM.
var moment$3 = typeof window !== "undefined" && window["moment"] || requireMoment();
var moment$4 = /*@__PURE__*/ getDefaultExportFromCjs(moment$3);
var momentExports = requireMoment();
var moment$2 = /*@__PURE__*/ getDefaultExportFromCjs(momentExports);
var lib$1 = {
    exports: {}
};
var _default$1 = {};
var lib = {
    exports: {}
};
var _default = {};
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ function getDefaultWhiteList$1() {
    // 白名单值说明：
    // true: 允许该属性
    // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
    // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
    // 除上面列出的值外均表示不允许
    var whiteList = {};
    whiteList["align-content"] = false; // default: auto
    whiteList["align-items"] = false; // default: auto
    whiteList["align-self"] = false; // default: auto
    whiteList["alignment-adjust"] = false; // default: auto
    whiteList["alignment-baseline"] = false; // default: baseline
    whiteList["all"] = false; // default: depending on individual properties
    whiteList["anchor-point"] = false; // default: none
    whiteList["animation"] = false; // default: depending on individual properties
    whiteList["animation-delay"] = false; // default: 0
    whiteList["animation-direction"] = false; // default: normal
    whiteList["animation-duration"] = false; // default: 0
    whiteList["animation-fill-mode"] = false; // default: none
    whiteList["animation-iteration-count"] = false; // default: 1
    whiteList["animation-name"] = false; // default: none
    whiteList["animation-play-state"] = false; // default: running
    whiteList["animation-timing-function"] = false; // default: ease
    whiteList["azimuth"] = false; // default: center
    whiteList["backface-visibility"] = false; // default: visible
    whiteList["background"] = true; // default: depending on individual properties
    whiteList["background-attachment"] = true; // default: scroll
    whiteList["background-clip"] = true; // default: border-box
    whiteList["background-color"] = true; // default: transparent
    whiteList["background-image"] = true; // default: none
    whiteList["background-origin"] = true; // default: padding-box
    whiteList["background-position"] = true; // default: 0% 0%
    whiteList["background-repeat"] = true; // default: repeat
    whiteList["background-size"] = true; // default: auto
    whiteList["baseline-shift"] = false; // default: baseline
    whiteList["binding"] = false; // default: none
    whiteList["bleed"] = false; // default: 6pt
    whiteList["bookmark-label"] = false; // default: content()
    whiteList["bookmark-level"] = false; // default: none
    whiteList["bookmark-state"] = false; // default: open
    whiteList["border"] = true; // default: depending on individual properties
    whiteList["border-bottom"] = true; // default: depending on individual properties
    whiteList["border-bottom-color"] = true; // default: current color
    whiteList["border-bottom-left-radius"] = true; // default: 0
    whiteList["border-bottom-right-radius"] = true; // default: 0
    whiteList["border-bottom-style"] = true; // default: none
    whiteList["border-bottom-width"] = true; // default: medium
    whiteList["border-collapse"] = true; // default: separate
    whiteList["border-color"] = true; // default: depending on individual properties
    whiteList["border-image"] = true; // default: none
    whiteList["border-image-outset"] = true; // default: 0
    whiteList["border-image-repeat"] = true; // default: stretch
    whiteList["border-image-slice"] = true; // default: 100%
    whiteList["border-image-source"] = true; // default: none
    whiteList["border-image-width"] = true; // default: 1
    whiteList["border-left"] = true; // default: depending on individual properties
    whiteList["border-left-color"] = true; // default: current color
    whiteList["border-left-style"] = true; // default: none
    whiteList["border-left-width"] = true; // default: medium
    whiteList["border-radius"] = true; // default: 0
    whiteList["border-right"] = true; // default: depending on individual properties
    whiteList["border-right-color"] = true; // default: current color
    whiteList["border-right-style"] = true; // default: none
    whiteList["border-right-width"] = true; // default: medium
    whiteList["border-spacing"] = true; // default: 0
    whiteList["border-style"] = true; // default: depending on individual properties
    whiteList["border-top"] = true; // default: depending on individual properties
    whiteList["border-top-color"] = true; // default: current color
    whiteList["border-top-left-radius"] = true; // default: 0
    whiteList["border-top-right-radius"] = true; // default: 0
    whiteList["border-top-style"] = true; // default: none
    whiteList["border-top-width"] = true; // default: medium
    whiteList["border-width"] = true; // default: depending on individual properties
    whiteList["bottom"] = false; // default: auto
    whiteList["box-decoration-break"] = true; // default: slice
    whiteList["box-shadow"] = true; // default: none
    whiteList["box-sizing"] = true; // default: content-box
    whiteList["box-snap"] = true; // default: none
    whiteList["box-suppress"] = true; // default: show
    whiteList["break-after"] = true; // default: auto
    whiteList["break-before"] = true; // default: auto
    whiteList["break-inside"] = true; // default: auto
    whiteList["caption-side"] = false; // default: top
    whiteList["chains"] = false; // default: none
    whiteList["clear"] = true; // default: none
    whiteList["clip"] = false; // default: auto
    whiteList["clip-path"] = false; // default: none
    whiteList["clip-rule"] = false; // default: nonzero
    whiteList["color"] = true; // default: implementation dependent
    whiteList["color-interpolation-filters"] = true; // default: auto
    whiteList["column-count"] = false; // default: auto
    whiteList["column-fill"] = false; // default: balance
    whiteList["column-gap"] = false; // default: normal
    whiteList["column-rule"] = false; // default: depending on individual properties
    whiteList["column-rule-color"] = false; // default: current color
    whiteList["column-rule-style"] = false; // default: medium
    whiteList["column-rule-width"] = false; // default: medium
    whiteList["column-span"] = false; // default: none
    whiteList["column-width"] = false; // default: auto
    whiteList["columns"] = false; // default: depending on individual properties
    whiteList["contain"] = false; // default: none
    whiteList["content"] = false; // default: normal
    whiteList["counter-increment"] = false; // default: none
    whiteList["counter-reset"] = false; // default: none
    whiteList["counter-set"] = false; // default: none
    whiteList["crop"] = false; // default: auto
    whiteList["cue"] = false; // default: depending on individual properties
    whiteList["cue-after"] = false; // default: none
    whiteList["cue-before"] = false; // default: none
    whiteList["cursor"] = false; // default: auto
    whiteList["direction"] = false; // default: ltr
    whiteList["display"] = true; // default: depending on individual properties
    whiteList["display-inside"] = true; // default: auto
    whiteList["display-list"] = true; // default: none
    whiteList["display-outside"] = true; // default: inline-level
    whiteList["dominant-baseline"] = false; // default: auto
    whiteList["elevation"] = false; // default: level
    whiteList["empty-cells"] = false; // default: show
    whiteList["filter"] = false; // default: none
    whiteList["flex"] = false; // default: depending on individual properties
    whiteList["flex-basis"] = false; // default: auto
    whiteList["flex-direction"] = false; // default: row
    whiteList["flex-flow"] = false; // default: depending on individual properties
    whiteList["flex-grow"] = false; // default: 0
    whiteList["flex-shrink"] = false; // default: 1
    whiteList["flex-wrap"] = false; // default: nowrap
    whiteList["float"] = false; // default: none
    whiteList["float-offset"] = false; // default: 0 0
    whiteList["flood-color"] = false; // default: black
    whiteList["flood-opacity"] = false; // default: 1
    whiteList["flow-from"] = false; // default: none
    whiteList["flow-into"] = false; // default: none
    whiteList["font"] = true; // default: depending on individual properties
    whiteList["font-family"] = true; // default: implementation dependent
    whiteList["font-feature-settings"] = true; // default: normal
    whiteList["font-kerning"] = true; // default: auto
    whiteList["font-language-override"] = true; // default: normal
    whiteList["font-size"] = true; // default: medium
    whiteList["font-size-adjust"] = true; // default: none
    whiteList["font-stretch"] = true; // default: normal
    whiteList["font-style"] = true; // default: normal
    whiteList["font-synthesis"] = true; // default: weight style
    whiteList["font-variant"] = true; // default: normal
    whiteList["font-variant-alternates"] = true; // default: normal
    whiteList["font-variant-caps"] = true; // default: normal
    whiteList["font-variant-east-asian"] = true; // default: normal
    whiteList["font-variant-ligatures"] = true; // default: normal
    whiteList["font-variant-numeric"] = true; // default: normal
    whiteList["font-variant-position"] = true; // default: normal
    whiteList["font-weight"] = true; // default: normal
    whiteList["grid"] = false; // default: depending on individual properties
    whiteList["grid-area"] = false; // default: depending on individual properties
    whiteList["grid-auto-columns"] = false; // default: auto
    whiteList["grid-auto-flow"] = false; // default: none
    whiteList["grid-auto-rows"] = false; // default: auto
    whiteList["grid-column"] = false; // default: depending on individual properties
    whiteList["grid-column-end"] = false; // default: auto
    whiteList["grid-column-start"] = false; // default: auto
    whiteList["grid-row"] = false; // default: depending on individual properties
    whiteList["grid-row-end"] = false; // default: auto
    whiteList["grid-row-start"] = false; // default: auto
    whiteList["grid-template"] = false; // default: depending on individual properties
    whiteList["grid-template-areas"] = false; // default: none
    whiteList["grid-template-columns"] = false; // default: none
    whiteList["grid-template-rows"] = false; // default: none
    whiteList["hanging-punctuation"] = false; // default: none
    whiteList["height"] = true; // default: auto
    whiteList["hyphens"] = false; // default: manual
    whiteList["icon"] = false; // default: auto
    whiteList["image-orientation"] = false; // default: auto
    whiteList["image-resolution"] = false; // default: normal
    whiteList["ime-mode"] = false; // default: auto
    whiteList["initial-letters"] = false; // default: normal
    whiteList["inline-box-align"] = false; // default: last
    whiteList["justify-content"] = false; // default: auto
    whiteList["justify-items"] = false; // default: auto
    whiteList["justify-self"] = false; // default: auto
    whiteList["left"] = false; // default: auto
    whiteList["letter-spacing"] = true; // default: normal
    whiteList["lighting-color"] = true; // default: white
    whiteList["line-box-contain"] = false; // default: block inline replaced
    whiteList["line-break"] = false; // default: auto
    whiteList["line-grid"] = false; // default: match-parent
    whiteList["line-height"] = false; // default: normal
    whiteList["line-snap"] = false; // default: none
    whiteList["line-stacking"] = false; // default: depending on individual properties
    whiteList["line-stacking-ruby"] = false; // default: exclude-ruby
    whiteList["line-stacking-shift"] = false; // default: consider-shifts
    whiteList["line-stacking-strategy"] = false; // default: inline-line-height
    whiteList["list-style"] = true; // default: depending on individual properties
    whiteList["list-style-image"] = true; // default: none
    whiteList["list-style-position"] = true; // default: outside
    whiteList["list-style-type"] = true; // default: disc
    whiteList["margin"] = true; // default: depending on individual properties
    whiteList["margin-bottom"] = true; // default: 0
    whiteList["margin-left"] = true; // default: 0
    whiteList["margin-right"] = true; // default: 0
    whiteList["margin-top"] = true; // default: 0
    whiteList["marker-offset"] = false; // default: auto
    whiteList["marker-side"] = false; // default: list-item
    whiteList["marks"] = false; // default: none
    whiteList["mask"] = false; // default: border-box
    whiteList["mask-box"] = false; // default: see individual properties
    whiteList["mask-box-outset"] = false; // default: 0
    whiteList["mask-box-repeat"] = false; // default: stretch
    whiteList["mask-box-slice"] = false; // default: 0 fill
    whiteList["mask-box-source"] = false; // default: none
    whiteList["mask-box-width"] = false; // default: auto
    whiteList["mask-clip"] = false; // default: border-box
    whiteList["mask-image"] = false; // default: none
    whiteList["mask-origin"] = false; // default: border-box
    whiteList["mask-position"] = false; // default: center
    whiteList["mask-repeat"] = false; // default: no-repeat
    whiteList["mask-size"] = false; // default: border-box
    whiteList["mask-source-type"] = false; // default: auto
    whiteList["mask-type"] = false; // default: luminance
    whiteList["max-height"] = true; // default: none
    whiteList["max-lines"] = false; // default: none
    whiteList["max-width"] = true; // default: none
    whiteList["min-height"] = true; // default: 0
    whiteList["min-width"] = true; // default: 0
    whiteList["move-to"] = false; // default: normal
    whiteList["nav-down"] = false; // default: auto
    whiteList["nav-index"] = false; // default: auto
    whiteList["nav-left"] = false; // default: auto
    whiteList["nav-right"] = false; // default: auto
    whiteList["nav-up"] = false; // default: auto
    whiteList["object-fit"] = false; // default: fill
    whiteList["object-position"] = false; // default: 50% 50%
    whiteList["opacity"] = false; // default: 1
    whiteList["order"] = false; // default: 0
    whiteList["orphans"] = false; // default: 2
    whiteList["outline"] = false; // default: depending on individual properties
    whiteList["outline-color"] = false; // default: invert
    whiteList["outline-offset"] = false; // default: 0
    whiteList["outline-style"] = false; // default: none
    whiteList["outline-width"] = false; // default: medium
    whiteList["overflow"] = false; // default: depending on individual properties
    whiteList["overflow-wrap"] = false; // default: normal
    whiteList["overflow-x"] = false; // default: visible
    whiteList["overflow-y"] = false; // default: visible
    whiteList["padding"] = true; // default: depending on individual properties
    whiteList["padding-bottom"] = true; // default: 0
    whiteList["padding-left"] = true; // default: 0
    whiteList["padding-right"] = true; // default: 0
    whiteList["padding-top"] = true; // default: 0
    whiteList["page"] = false; // default: auto
    whiteList["page-break-after"] = false; // default: auto
    whiteList["page-break-before"] = false; // default: auto
    whiteList["page-break-inside"] = false; // default: auto
    whiteList["page-policy"] = false; // default: start
    whiteList["pause"] = false; // default: implementation dependent
    whiteList["pause-after"] = false; // default: implementation dependent
    whiteList["pause-before"] = false; // default: implementation dependent
    whiteList["perspective"] = false; // default: none
    whiteList["perspective-origin"] = false; // default: 50% 50%
    whiteList["pitch"] = false; // default: medium
    whiteList["pitch-range"] = false; // default: 50
    whiteList["play-during"] = false; // default: auto
    whiteList["position"] = false; // default: static
    whiteList["presentation-level"] = false; // default: 0
    whiteList["quotes"] = false; // default: text
    whiteList["region-fragment"] = false; // default: auto
    whiteList["resize"] = false; // default: none
    whiteList["rest"] = false; // default: depending on individual properties
    whiteList["rest-after"] = false; // default: none
    whiteList["rest-before"] = false; // default: none
    whiteList["richness"] = false; // default: 50
    whiteList["right"] = false; // default: auto
    whiteList["rotation"] = false; // default: 0
    whiteList["rotation-point"] = false; // default: 50% 50%
    whiteList["ruby-align"] = false; // default: auto
    whiteList["ruby-merge"] = false; // default: separate
    whiteList["ruby-position"] = false; // default: before
    whiteList["shape-image-threshold"] = false; // default: 0.0
    whiteList["shape-outside"] = false; // default: none
    whiteList["shape-margin"] = false; // default: 0
    whiteList["size"] = false; // default: auto
    whiteList["speak"] = false; // default: auto
    whiteList["speak-as"] = false; // default: normal
    whiteList["speak-header"] = false; // default: once
    whiteList["speak-numeral"] = false; // default: continuous
    whiteList["speak-punctuation"] = false; // default: none
    whiteList["speech-rate"] = false; // default: medium
    whiteList["stress"] = false; // default: 50
    whiteList["string-set"] = false; // default: none
    whiteList["tab-size"] = false; // default: 8
    whiteList["table-layout"] = false; // default: auto
    whiteList["text-align"] = true; // default: start
    whiteList["text-align-last"] = true; // default: auto
    whiteList["text-combine-upright"] = true; // default: none
    whiteList["text-decoration"] = true; // default: none
    whiteList["text-decoration-color"] = true; // default: currentColor
    whiteList["text-decoration-line"] = true; // default: none
    whiteList["text-decoration-skip"] = true; // default: objects
    whiteList["text-decoration-style"] = true; // default: solid
    whiteList["text-emphasis"] = true; // default: depending on individual properties
    whiteList["text-emphasis-color"] = true; // default: currentColor
    whiteList["text-emphasis-position"] = true; // default: over right
    whiteList["text-emphasis-style"] = true; // default: none
    whiteList["text-height"] = true; // default: auto
    whiteList["text-indent"] = true; // default: 0
    whiteList["text-justify"] = true; // default: auto
    whiteList["text-orientation"] = true; // default: mixed
    whiteList["text-overflow"] = true; // default: clip
    whiteList["text-shadow"] = true; // default: none
    whiteList["text-space-collapse"] = true; // default: collapse
    whiteList["text-transform"] = true; // default: none
    whiteList["text-underline-position"] = true; // default: auto
    whiteList["text-wrap"] = true; // default: normal
    whiteList["top"] = false; // default: auto
    whiteList["transform"] = false; // default: none
    whiteList["transform-origin"] = false; // default: 50% 50% 0
    whiteList["transform-style"] = false; // default: flat
    whiteList["transition"] = false; // default: depending on individual properties
    whiteList["transition-delay"] = false; // default: 0s
    whiteList["transition-duration"] = false; // default: 0s
    whiteList["transition-property"] = false; // default: all
    whiteList["transition-timing-function"] = false; // default: ease
    whiteList["unicode-bidi"] = false; // default: normal
    whiteList["vertical-align"] = false; // default: baseline
    whiteList["visibility"] = false; // default: visible
    whiteList["voice-balance"] = false; // default: center
    whiteList["voice-duration"] = false; // default: auto
    whiteList["voice-family"] = false; // default: implementation dependent
    whiteList["voice-pitch"] = false; // default: medium
    whiteList["voice-range"] = false; // default: medium
    whiteList["voice-rate"] = false; // default: normal
    whiteList["voice-stress"] = false; // default: normal
    whiteList["voice-volume"] = false; // default: medium
    whiteList["volume"] = false; // default: medium
    whiteList["white-space"] = false; // default: normal
    whiteList["widows"] = false; // default: 2
    whiteList["width"] = true; // default: auto
    whiteList["will-change"] = false; // default: auto
    whiteList["word-break"] = true; // default: normal
    whiteList["word-spacing"] = true; // default: normal
    whiteList["word-wrap"] = true; // default: normal
    whiteList["wrap-flow"] = false; // default: auto
    whiteList["wrap-through"] = false; // default: wrap
    whiteList["writing-mode"] = false; // default: horizontal-tb
    whiteList["z-index"] = false; // default: auto
    return whiteList;
}
/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */ function onAttr(name, value, options) {
// do nothing
}
/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */ function onIgnoreAttr(name, value, options) {
// do nothing
}
var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;
/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */ function safeAttrValue$1(name, value) {
    if (REGEXP_URL_JAVASCRIPT.test(value)) return "";
    return value;
}
_default.whiteList = getDefaultWhiteList$1();
_default.getDefaultWhiteList = getDefaultWhiteList$1;
_default.onAttr = onAttr;
_default.onIgnoreAttr = onIgnoreAttr;
_default.safeAttrValue = safeAttrValue$1;
var util$1 = {
    indexOf: function(arr, item) {
        var i1, j;
        if (Array.prototype.indexOf) return arr.indexOf(item);
        for(i1 = 0, j = arr.length; i1 < j; i1++){
            if (arr[i1] === item) return i1;
        }
        return -1;
    },
    forEach: function(arr, fn, scope) {
        var i1, j;
        if (Array.prototype.forEach) return arr.forEach(fn, scope);
        for(i1 = 0, j = arr.length; i1 < j; i1++)fn.call(scope, arr[i1], i1, arr);
    },
    trim: function(str) {
        if (String.prototype.trim) return str.trim();
        return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    trimRight: function(str) {
        if (String.prototype.trimRight) return str.trimRight();
        return str.replace(/(\s*$)/g, "");
    }
};
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ var _$3 = util$1;
/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */ function parseStyle$1(css, onAttr) {
    css = _$3.trimRight(css);
    if (css[css.length - 1] !== ";") css += ";";
    var cssLength = css.length;
    var isParenthesisOpen = false;
    var lastPos = 0;
    var i1 = 0;
    var retCSS = "";
    function addNewAttr() {
        // 如果没有正常的闭合圆括号，则直接忽略当前属性
        if (!isParenthesisOpen) {
            var source = _$3.trim(css.slice(lastPos, i1));
            var j = source.indexOf(":");
            if (j !== -1) {
                var name = _$3.trim(source.slice(0, j));
                var value = _$3.trim(source.slice(j + 1));
                // 必须有属性名称
                if (name) {
                    var ret = onAttr(lastPos, retCSS.length, name, value, source);
                    if (ret) retCSS += ret + "; ";
                }
            }
        }
        lastPos = i1 + 1;
    }
    for(; i1 < cssLength; i1++){
        var c = css[i1];
        if (c === "/" && css[i1 + 1] === "*") {
            // 备注开始
            var j = css.indexOf("*/", i1 + 2);
            // 如果没有正常的备注结束，则后面的部分全部跳过
            if (j === -1) break;
            // 直接将当前位置调到备注结尾，并且初始化状态
            i1 = j + 1;
            lastPos = i1 + 1;
            isParenthesisOpen = false;
        } else if (c === "(") isParenthesisOpen = true;
        else if (c === ")") isParenthesisOpen = false;
        else if (c === ";") {
            if (isParenthesisOpen) ;
            else addNewAttr();
        } else if (c === "\n") addNewAttr();
    }
    return _$3.trim(retCSS);
}
var parser$2 = parseStyle$1;
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ var DEFAULT$1 = _default;
var parseStyle = parser$2;
/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */ function isNull$1(obj) {
    return obj === undefined || obj === null;
}
/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */ function shallowCopyObject$1(obj) {
    var ret = {};
    for(var i1 in obj)ret[i1] = obj[i1];
    return ret;
}
/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */ function FilterCSS$2(options) {
    options = shallowCopyObject$1(options || {});
    options.whiteList = options.whiteList || DEFAULT$1.whiteList;
    options.onAttr = options.onAttr || DEFAULT$1.onAttr;
    options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT$1.onIgnoreAttr;
    options.safeAttrValue = options.safeAttrValue || DEFAULT$1.safeAttrValue;
    this.options = options;
}
FilterCSS$2.prototype.process = function(css) {
    // 兼容各种奇葩输入
    css = css || "";
    css = css.toString();
    if (!css) return "";
    var me = this;
    var options = me.options;
    var whiteList = options.whiteList;
    var onAttr = options.onAttr;
    var onIgnoreAttr = options.onIgnoreAttr;
    var safeAttrValue = options.safeAttrValue;
    var retCSS = parseStyle(css, function(sourcePosition, position, name, value, source) {
        var check = whiteList[name];
        var isWhite = false;
        if (check === true) isWhite = check;
        else if (typeof check === "function") isWhite = check(value);
        else if (check instanceof RegExp) isWhite = check.test(value);
        if (isWhite !== true) isWhite = false;
        // 如果过滤后 value 为空则直接忽略
        value = safeAttrValue(name, value);
        if (!value) return;
        var opts = {
            position: position,
            sourcePosition: sourcePosition,
            source: source,
            isWhite: isWhite
        };
        if (isWhite) {
            var ret = onAttr(name, value, opts);
            if (isNull$1(ret)) return name + ":" + value;
            else return ret;
        } else {
            var ret = onIgnoreAttr(name, value, opts);
            if (!isNull$1(ret)) return ret;
        }
    });
    return retCSS;
};
var css = FilterCSS$2;
/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */ (function(module, exports) {
    var DEFAULT = _default;
    var FilterCSS = css;
    /**
	 * XSS过滤
	 *
	 * @param {String} css 要过滤的CSS代码
	 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
	 * @return {String}
	 */ function filterCSS(html, options) {
        var xss = new FilterCSS(options);
        return xss.process(html);
    }
    // 输出
    exports = module.exports = filterCSS;
    exports.FilterCSS = FilterCSS;
    for(var i1 in DEFAULT)exports[i1] = DEFAULT[i1];
    // 在浏览器端使用
    if (typeof window !== "undefined") window.filterCSS = module.exports;
})(lib, lib.exports);
var libExports$1 = lib.exports;
var util = {
    indexOf: function(arr, item) {
        var i1, j;
        if (Array.prototype.indexOf) return arr.indexOf(item);
        for(i1 = 0, j = arr.length; i1 < j; i1++){
            if (arr[i1] === item) return i1;
        }
        return -1;
    },
    forEach: function(arr, fn, scope) {
        var i1, j;
        if (Array.prototype.forEach) return arr.forEach(fn, scope);
        for(i1 = 0, j = arr.length; i1 < j; i1++)fn.call(scope, arr[i1], i1, arr);
    },
    trim: function(str) {
        if (String.prototype.trim) return str.trim();
        return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    spaceIndex: function(str) {
        var reg = /\s|\n|\t/;
        var match = reg.exec(str);
        return match ? match.index : -1;
    }
};
/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ var FilterCSS$1 = libExports$1.FilterCSS;
var getDefaultCSSWhiteList = libExports$1.getDefaultWhiteList;
var _$2 = util;
function getDefaultWhiteList() {
    return {
        a: [
            "target",
            "href",
            "title"
        ],
        abbr: [
            "title"
        ],
        address: [],
        area: [
            "shape",
            "coords",
            "href",
            "alt"
        ],
        article: [],
        aside: [],
        audio: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "preload",
            "src"
        ],
        b: [],
        bdi: [
            "dir"
        ],
        bdo: [
            "dir"
        ],
        big: [],
        blockquote: [
            "cite"
        ],
        br: [],
        caption: [],
        center: [],
        cite: [],
        code: [],
        col: [
            "align",
            "valign",
            "span",
            "width"
        ],
        colgroup: [
            "align",
            "valign",
            "span",
            "width"
        ],
        dd: [],
        del: [
            "datetime"
        ],
        details: [
            "open"
        ],
        div: [],
        dl: [],
        dt: [],
        em: [],
        figcaption: [],
        figure: [],
        font: [
            "color",
            "size",
            "face"
        ],
        footer: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        header: [],
        hr: [],
        i: [],
        img: [
            "src",
            "alt",
            "title",
            "width",
            "height"
        ],
        ins: [
            "datetime"
        ],
        li: [],
        mark: [],
        nav: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        section: [],
        small: [],
        span: [],
        sub: [],
        summary: [],
        sup: [],
        strong: [],
        strike: [],
        table: [
            "width",
            "border",
            "align",
            "valign"
        ],
        tbody: [
            "align",
            "valign"
        ],
        td: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        tfoot: [
            "align",
            "valign"
        ],
        th: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        thead: [
            "align",
            "valign"
        ],
        tr: [
            "rowspan",
            "align",
            "valign"
        ],
        tt: [],
        u: [],
        ul: [],
        video: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "playsinline",
            "poster",
            "preload",
            "src",
            "height",
            "width"
        ]
    };
}
var defaultCSSFilter = new FilterCSS$1();
/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */ function onTag(tag, html, options) {
// do nothing
}
/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */ function onIgnoreTag(tag, html, options) {
// do nothing
}
/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */ function onTagAttr(tag, name, value) {
// do nothing
}
/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */ function onIgnoreTagAttr(tag, name, value) {
// do nothing
}
/**
 * default escapeHtml function
 *
 * @param {String} html
 */ function escapeHtml(html) {
    return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}
/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */ function safeAttrValue(tag, name, value, cssFilter) {
    // unescape attribute value firstly
    value = friendlyAttrValue(value);
    if (name === "href" || name === "src") {
        // filter `href` and `src` attribute
        // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
        value = _$2.trim(value);
        if (value === "#") return "#";
        if (!(value.substr(0, 7) === "http://" || value.substr(0, 8) === "https://" || value.substr(0, 7) === "mailto:" || value.substr(0, 4) === "tel:" || value.substr(0, 11) === "data:image/" || value.substr(0, 6) === "ftp://" || value.substr(0, 2) === "./" || value.substr(0, 3) === "../" || value[0] === "#" || value[0] === "/")) return "";
    } else if (name === "background") {
        // filter `background` attribute (maybe no use)
        // `javascript:`
        REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
        if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) return "";
    } else if (name === "style") {
        // `expression()`
        REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
        if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) return "";
        // `url()`
        REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
        if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
            REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
            if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) return "";
        }
        if (cssFilter !== false) {
            cssFilter = cssFilter || defaultCSSFilter;
            value = cssFilter.process(value);
        }
    }
    // escape `<>"` before returns
    value = escapeAttrValue(value);
    return value;
}
// RegExp list
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
// var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
// var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;
/**
 * escape double quote
 *
 * @param {String} str
 * @return {String} str
 */ function escapeQuote(str) {
    return str.replace(REGEXP_QUOTE, "&quot;");
}
/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */ function unescapeQuote(str) {
    return str.replace(REGEXP_QUOTE_2, '"');
}
/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */ function escapeHtmlEntities(str) {
    return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
        return code[0] === "x" || code[0] === "X" ? String.fromCharCode(parseInt(code.substr(1), 16)) : String.fromCharCode(parseInt(code, 10));
    });
}
/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */ function escapeDangerHtml5Entities(str) {
    return str.replace(REGEXP_ATTR_VALUE_COLON, ":").replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}
/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */ function clearNonPrintableCharacter(str) {
    var str2 = "";
    for(var i1 = 0, len = str.length; i1 < len; i1++)str2 += str.charCodeAt(i1) < 32 ? " " : str.charAt(i1);
    return _$2.trim(str2);
}
/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */ function friendlyAttrValue(str) {
    str = unescapeQuote(str);
    str = escapeHtmlEntities(str);
    str = escapeDangerHtml5Entities(str);
    str = clearNonPrintableCharacter(str);
    return str;
}
/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */ function escapeAttrValue(str) {
    str = escapeQuote(str);
    str = escapeHtml(str);
    return str;
}
/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */ function onIgnoreTagStripAll() {
    return "";
}
/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */ function StripTagBody(tags, next) {
    if (typeof next !== "function") next = function() {};
    var isRemoveAllTag = !Array.isArray(tags);
    function isRemoveTag(tag) {
        if (isRemoveAllTag) return true;
        return _$2.indexOf(tags, tag) !== -1;
    }
    var removeList = [];
    var posStart = false;
    return {
        onIgnoreTag: function(tag, html, options) {
            if (isRemoveTag(tag)) {
                if (options.isClosing) {
                    var ret = "[/removed]";
                    var end = options.position + ret.length;
                    removeList.push([
                        posStart !== false ? posStart : options.position,
                        end
                    ]);
                    posStart = false;
                    return ret;
                } else {
                    if (!posStart) posStart = options.position;
                    return "[removed]";
                }
            } else return next(tag, html, options);
        },
        remove: function(html) {
            var rethtml = "";
            var lastPos = 0;
            _$2.forEach(removeList, function(pos) {
                rethtml += html.slice(lastPos, pos[0]);
                lastPos = pos[1];
            });
            rethtml += html.slice(lastPos);
            return rethtml;
        }
    };
}
/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */ function stripCommentTag(html) {
    var retHtml = "";
    var lastPos = 0;
    while(lastPos < html.length){
        var i1 = html.indexOf("<!--", lastPos);
        if (i1 === -1) {
            retHtml += html.slice(lastPos);
            break;
        }
        retHtml += html.slice(lastPos, i1);
        var j = html.indexOf("-->", i1);
        if (j === -1) break;
        lastPos = j + 3;
    }
    return retHtml;
}
/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */ function stripBlankChar(html) {
    var chars = html.split("");
    chars = chars.filter(function(char) {
        var c = char.charCodeAt(0);
        if (c === 127) return false;
        if (c <= 31) {
            if (c === 10 || c === 13) return true;
            return false;
        }
        return true;
    });
    return chars.join("");
}
_default$1.whiteList = getDefaultWhiteList();
_default$1.getDefaultWhiteList = getDefaultWhiteList;
_default$1.onTag = onTag;
_default$1.onIgnoreTag = onIgnoreTag;
_default$1.onTagAttr = onTagAttr;
_default$1.onIgnoreTagAttr = onIgnoreTagAttr;
_default$1.safeAttrValue = safeAttrValue;
_default$1.escapeHtml = escapeHtml;
_default$1.escapeQuote = escapeQuote;
_default$1.unescapeQuote = unescapeQuote;
_default$1.escapeHtmlEntities = escapeHtmlEntities;
_default$1.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
_default$1.clearNonPrintableCharacter = clearNonPrintableCharacter;
_default$1.friendlyAttrValue = friendlyAttrValue;
_default$1.escapeAttrValue = escapeAttrValue;
_default$1.onIgnoreTagStripAll = onIgnoreTagStripAll;
_default$1.StripTagBody = StripTagBody;
_default$1.stripCommentTag = stripCommentTag;
_default$1.stripBlankChar = stripBlankChar;
_default$1.cssFilter = defaultCSSFilter;
_default$1.getDefaultCSSWhiteList = getDefaultCSSWhiteList;
var parser$1 = {};
/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ var _$1 = util;
/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */ function getTagName(html) {
    var i1 = _$1.spaceIndex(html);
    var tagName;
    if (i1 === -1) tagName = html.slice(1, -1);
    else tagName = html.slice(1, i1 + 1);
    tagName = _$1.trim(tagName).toLowerCase();
    if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
    if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
    return tagName;
}
/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */ function isClosing(html) {
    return html.slice(0, 2) === "</";
}
/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */ function parseTag$1(html, onTag, escapeHtml) {
    var rethtml = "";
    var lastPos = 0;
    var tagStart = false;
    var quoteStart = false;
    var currentPos = 0;
    var len = html.length;
    var currentTagName = "";
    var currentHtml = "";
    chariterator: for(currentPos = 0; currentPos < len; currentPos++){
        var c = html.charAt(currentPos);
        if (tagStart === false) {
            if (c === "<") {
                tagStart = currentPos;
                continue;
            }
        } else {
            if (quoteStart === false) {
                if (c === "<") {
                    rethtml += escapeHtml(html.slice(lastPos, currentPos));
                    tagStart = currentPos;
                    lastPos = currentPos;
                    continue;
                }
                if (c === ">" || currentPos === len - 1) {
                    rethtml += escapeHtml(html.slice(lastPos, tagStart));
                    currentHtml = html.slice(tagStart, currentPos + 1);
                    currentTagName = getTagName(currentHtml);
                    rethtml += onTag(tagStart, rethtml.length, currentTagName, currentHtml, isClosing(currentHtml));
                    lastPos = currentPos + 1;
                    tagStart = false;
                    continue;
                }
                if (c === '"' || c === "'") {
                    var i1 = 1;
                    var ic = html.charAt(currentPos - i1);
                    while(ic.trim() === "" || ic === "="){
                        if (ic === "=") {
                            quoteStart = c;
                            continue chariterator;
                        }
                        ic = html.charAt(currentPos - ++i1);
                    }
                }
            } else if (c === quoteStart) {
                quoteStart = false;
                continue;
            }
        }
    }
    if (lastPos < len) rethtml += escapeHtml(html.substr(lastPos));
    return rethtml;
}
var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;
/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */ function parseAttr$1(html, onAttr) {
    var lastPos = 0;
    var lastMarkPos = 0;
    var retAttrs = [];
    var tmpName = false;
    var len = html.length;
    function addAttr(name, value) {
        name = _$1.trim(name);
        name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
        if (name.length < 1) return;
        var ret = onAttr(name, value || "");
        if (ret) retAttrs.push(ret);
    }
    // 逐个分析字符
    for(var i1 = 0; i1 < len; i1++){
        var c = html.charAt(i1);
        var v, j;
        if (tmpName === false && c === "=") {
            tmpName = html.slice(lastPos, i1);
            lastPos = i1 + 1;
            lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i1 + 1);
            continue;
        }
        if (tmpName !== false) {
            if (i1 === lastMarkPos) {
                j = html.indexOf(c, i1 + 1);
                if (j === -1) break;
                else {
                    v = _$1.trim(html.slice(lastMarkPos + 1, j));
                    addAttr(tmpName, v);
                    tmpName = false;
                    i1 = j;
                    lastPos = i1 + 1;
                    continue;
                }
            }
        }
        if (/\s|\n|\t/.test(c)) {
            html = html.replace(/\s|\n|\t/g, " ");
            if (tmpName === false) {
                j = findNextEqual(html, i1);
                if (j === -1) {
                    v = _$1.trim(html.slice(lastPos, i1));
                    addAttr(v);
                    tmpName = false;
                    lastPos = i1 + 1;
                    continue;
                } else {
                    i1 = j - 1;
                    continue;
                }
            } else {
                j = findBeforeEqual(html, i1 - 1);
                if (j === -1) {
                    v = _$1.trim(html.slice(lastPos, i1));
                    v = stripQuoteWrap(v);
                    addAttr(tmpName, v);
                    tmpName = false;
                    lastPos = i1 + 1;
                    continue;
                } else continue;
            }
        }
    }
    if (lastPos < html.length) {
        if (tmpName === false) addAttr(html.slice(lastPos));
        else addAttr(tmpName, stripQuoteWrap(_$1.trim(html.slice(lastPos))));
    }
    return _$1.trim(retAttrs.join(" "));
}
function findNextEqual(str, i1) {
    for(; i1 < str.length; i1++){
        var c = str[i1];
        if (c === " ") continue;
        if (c === "=") return i1;
        return -1;
    }
}
function findNextQuotationMark(str, i1) {
    for(; i1 < str.length; i1++){
        var c = str[i1];
        if (c === " ") continue;
        if (c === "'" || c === '"') return i1;
        return -1;
    }
}
function findBeforeEqual(str, i1) {
    for(; i1 > 0; i1--){
        var c = str[i1];
        if (c === " ") continue;
        if (c === "=") return i1;
        return -1;
    }
}
function isQuoteWrapString(text) {
    if (text[0] === '"' && text[text.length - 1] === '"' || text[0] === "'" && text[text.length - 1] === "'") return true;
    else return false;
}
function stripQuoteWrap(text) {
    if (isQuoteWrapString(text)) return text.substr(1, text.length - 2);
    else return text;
}
parser$1.parseTag = parseTag$1;
parser$1.parseAttr = parseAttr$1;
/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ var FilterCSS = libExports$1.FilterCSS;
var DEFAULT = _default$1;
var parser = parser$1;
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = util;
/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */ function isNull(obj) {
    return obj === undefined || obj === null;
}
/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */ function getAttrs(html) {
    var i1 = _.spaceIndex(html);
    if (i1 === -1) return {
        html: "",
        closing: html[html.length - 2] === "/"
    };
    html = _.trim(html.slice(i1 + 1, -1));
    var isClosing = html[html.length - 1] === "/";
    if (isClosing) html = _.trim(html.slice(0, -1));
    return {
        html: html,
        closing: isClosing
    };
}
/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */ function shallowCopyObject(obj) {
    var ret = {};
    for(var i1 in obj)ret[i1] = obj[i1];
    return ret;
}
function keysToLowerCase(obj) {
    var ret = {};
    for(var i1 in obj)if (Array.isArray(obj[i1])) ret[i1.toLowerCase()] = obj[i1].map(function(item) {
        return item.toLowerCase();
    });
    else ret[i1.toLowerCase()] = obj[i1];
    return ret;
}
/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList (or allowList), onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */ function FilterXSS(options) {
    options = shallowCopyObject(options || {});
    if (options.stripIgnoreTag) {
        if (options.onIgnoreTag) console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time');
        options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
    }
    if (options.whiteList || options.allowList) options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
    else options.whiteList = DEFAULT.whiteList;
    options.onTag = options.onTag || DEFAULT.onTag;
    options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
    options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
    options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
    options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
    options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
    this.options = options;
    if (options.css === false) this.cssFilter = false;
    else {
        options.css = options.css || {};
        this.cssFilter = new FilterCSS(options.css);
    }
}
/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */ FilterXSS.prototype.process = function(html) {
    // compatible with the input
    html = html || "";
    html = html.toString();
    if (!html) return "";
    var me = this;
    var options = me.options;
    var whiteList = options.whiteList;
    var onTag = options.onTag;
    var onIgnoreTag = options.onIgnoreTag;
    var onTagAttr = options.onTagAttr;
    var onIgnoreTagAttr = options.onIgnoreTagAttr;
    var safeAttrValue = options.safeAttrValue;
    var escapeHtml = options.escapeHtml;
    var cssFilter = me.cssFilter;
    // remove invisible characters
    if (options.stripBlankChar) html = DEFAULT.stripBlankChar(html);
    // remove html comments
    if (!options.allowCommentTag) html = DEFAULT.stripCommentTag(html);
    // if enable stripIgnoreTagBody
    var stripIgnoreTagBody = false;
    if (options.stripIgnoreTagBody) {
        stripIgnoreTagBody = DEFAULT.StripTagBody(options.stripIgnoreTagBody, onIgnoreTag);
        onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
    }
    var retHtml = parseTag(html, function(sourcePosition, position, tag, html, isClosing) {
        var info = {
            sourcePosition: sourcePosition,
            position: position,
            isClosing: isClosing,
            isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag)
        };
        // call `onTag()`
        var ret = onTag(tag, html, info);
        if (!isNull(ret)) return ret;
        if (info.isWhite) {
            if (info.isClosing) return "</" + tag + ">";
            var attrs = getAttrs(html);
            var whiteAttrList = whiteList[tag];
            var attrsHtml = parseAttr(attrs.html, function(name, value) {
                // call `onTagAttr()`
                var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
                var ret = onTagAttr(tag, name, value, isWhiteAttr);
                if (!isNull(ret)) return ret;
                if (isWhiteAttr) {
                    // call `safeAttrValue()`
                    value = safeAttrValue(tag, name, value, cssFilter);
                    if (value) return name + '="' + value + '"';
                    else return name;
                } else {
                    // call `onIgnoreTagAttr()`
                    ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
                    if (!isNull(ret)) return ret;
                    return;
                }
            });
            // build new tag html
            html = "<" + tag;
            if (attrsHtml) html += " " + attrsHtml;
            if (attrs.closing) html += " /";
            html += ">";
            return html;
        } else {
            // call `onIgnoreTag()`
            ret = onIgnoreTag(tag, html, info);
            if (!isNull(ret)) return ret;
            return escapeHtml(html);
        }
    }, escapeHtml);
    // if enable stripIgnoreTagBody
    if (stripIgnoreTagBody) retHtml = stripIgnoreTagBody.remove(retHtml);
    return retHtml;
};
var xss = FilterXSS;
/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */ (function(module, exports) {
    var DEFAULT = _default$1;
    var parser = parser$1;
    var FilterXSS = xss;
    /**
	 * filter xss function
	 *
	 * @param {String} html
	 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
	 * @return {String}
	 */ function filterXSS(html, options) {
        var xss = new FilterXSS(options);
        return xss.process(html);
    }
    exports = module.exports = filterXSS;
    exports.filterXSS = filterXSS;
    exports.FilterXSS = FilterXSS;
    (function() {
        for(var i1 in DEFAULT)exports[i1] = DEFAULT[i1];
        for(var j in parser)exports[j] = parser[j];
    })();
    // using `xss` on the browser, output `filterXSS` to the globals
    if (typeof window !== "undefined") window.filterXSS = module.exports;
    // using `xss` on the WebWorker, output `filterXSS` to the globals
    function isWorkerEnv() {
        return typeof self !== "undefined" && typeof DedicatedWorkerGlobalScope !== "undefined" && self instanceof DedicatedWorkerGlobalScope;
    }
    if (isWorkerEnv()) self.filterXSS = module.exports;
})(lib$1, lib$1.exports);
var libExports = lib$1.exports;
var xssFilter = /*@__PURE__*/ getDefaultExportFromCjs(libExports);
function ownKeys(e, r) {
    var t = _Object$keys(e);
    if (_Object$getOwnPropertySymbols) {
        var o = _Object$getOwnPropertySymbols(e);
        r && (o = _filterInstanceProperty(o).call(o, function(r) {
            return _Object$getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var _context8, _context9;
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? _forEachInstanceProperty(_context8 = ownKeys(Object(t), !0)).call(_context8, function(r) {
            _defineProperty(e, r, t[r]);
        }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context9 = ownKeys(Object(t))).call(_context9, function(r) {
            _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Test if an object implements the DataView interface from vis-data.
 * Uses the idProp property instead of expecting a hardcoded id field "id".
 */ function isDataViewLike(obj) {
    var _obj$idProp;
    if (!obj) return false;
    var idProp = (_obj$idProp = obj.idProp) !== null && _obj$idProp !== void 0 ? _obj$idProp : obj._idProp;
    if (!idProp) return false;
    return isDataViewLike$1(idProp, obj);
}
// parse ASP.Net Date pattern,
// for example '/Date(1198908717056)/' or '/Date(1198908717056-0700)/'
// code from http://momentjs.com/
var ASPDateRegex = /^\/?Date\((-?\d+)/i;
var NumericRegex = /^\d+$/;
/**
 * Convert an object into another type
 *
 * @param object - Value of unknown type.
 * @param type - Name of the desired type.
 *
 * @returns Object in the desired type.
 * @throws Error
 */ function convert(object, type) {
    var match;
    if (object === undefined) return undefined;
    if (object === null) return null;
    if (!type) return object;
    if (!(typeof type === "string") && !(type instanceof String)) throw new Error("Type must be a string");
    //noinspection FallthroughInSwitchStatementJS
    switch(type){
        case "boolean":
        case "Boolean":
            return Boolean(object);
        case "number":
        case "Number":
            if (isString(object) && !isNaN(Date.parse(object))) return moment$2(object).valueOf();
            else // @TODO: I don't think that Number and String constructors are a good idea.
            // This could also fail if the object doesn't have valueOf method or if it's redefined.
            // For example: Object.create(null) or { valueOf: 7 }.
            return Number(object.valueOf());
        case "string":
        case "String":
            return String(object);
        case "Date":
            try {
                return convert(object, "Moment").toDate();
            } catch (e) {
                if (e instanceof TypeError) throw new TypeError("Cannot convert object of type " + getType(object) + " to type " + type);
                else throw e;
            }
        case "Moment":
            if (isNumber(object)) return moment$2(object);
            if (object instanceof Date) return moment$2(object.valueOf());
            else if (moment$2.isMoment(object)) return moment$2(object);
            if (isString(object)) {
                match = ASPDateRegex.exec(object);
                if (match) // object is an ASP date
                return moment$2(Number(match[1])); // parse number
                match = NumericRegex.exec(object);
                if (match) return moment$2(Number(object));
                return moment$2(object); // parse string
            } else throw new TypeError("Cannot convert object of type " + getType(object) + " to type " + type);
        case "ISODate":
            if (isNumber(object)) return new Date(object);
            else if (object instanceof Date) return object.toISOString();
            else if (moment$2.isMoment(object)) return object.toDate().toISOString();
            else if (isString(object)) {
                match = ASPDateRegex.exec(object);
                if (match) // object is an ASP date
                return new Date(Number(match[1])).toISOString(); // parse number
                else return moment$2(object).format(); // ISO 8601
            } else throw new Error("Cannot convert object of type " + getType(object) + " to type ISODate");
        case "ASPDate":
            if (isNumber(object)) return "/Date(" + object + ")/";
            else if (object instanceof Date || moment$2.isMoment(object)) return "/Date(" + object.valueOf() + ")/";
            else if (isString(object)) {
                match = ASPDateRegex.exec(object);
                var value;
                if (match) // object is an ASP date
                value = new Date(Number(match[1])).valueOf(); // parse number
                else value = new Date(object).valueOf(); // parse string
                return "/Date(" + value + ")/";
            } else throw new Error("Cannot convert object of type " + getType(object) + " to type ASPDate");
        default:
            throw new Error("Unknown type ".concat(type));
    }
}
/**
 * Create a Data Set like wrapper to seamlessly coerce data types.
 *
 * @param rawDS - The Data Set with raw uncoerced data.
 * @param type - A record assigning a data type to property name.
 *
 * @remarks
 * The write operations (`add`, `remove`, `update` and `updateOnly`) write into
 * the raw (uncoerced) data set. These values are then picked up by a pipe
 * which coerces the values using the [[convert]] function and feeds them into
 * the coerced data set. When querying (`forEach`, `get`, `getIds`, `off` and
 * `on`) the values are then fetched from the coerced data set and already have
 * the required data types. The values are coerced only once when inserted and
 * then the same value is returned each time until it is updated or deleted.
 *
 * For example: `typeCoercedDataSet.add({ id: 7, start: "2020-01-21" })` would
 * result in `typeCoercedDataSet.get(7)` returning `{ id: 7, start: moment(new
 * Date("2020-01-21")).toDate() }`.
 *
 * Use the dispose method prior to throwing a reference to this away. Otherwise
 * the pipe connecting the two Data Sets will keep the unaccessible coerced
 * Data Set alive and updated as long as the raw Data Set exists.
 *
 * @returns A Data Set like object that saves data into the raw Data Set and
 * retrieves them from the coerced Data Set.
 */ function typeCoerceDataSet(rawDS) {
    var _context, _context3, _context4, _context5, _context6, _context7;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        start: "Date",
        end: "Date"
    };
    var idProp = rawDS._idProp;
    var coercedDS = new DataSet({
        fieldId: idProp
    });
    var pipe = _mapInstanceProperty(_context = createNewDataPipeFrom(rawDS)).call(_context, function(item) {
        var _context2;
        return _reduceInstanceProperty(_context2 = _Object$keys(item)).call(_context2, function(acc, key) {
            acc[key] = convert(item[key], type[key]);
            return acc;
        }, {});
    }).to(coercedDS);
    pipe.all().start();
    return {
        // Write only.
        add: function add() {
            var _rawDS$getDataSet;
            return (_rawDS$getDataSet = rawDS.getDataSet()).add.apply(_rawDS$getDataSet, arguments);
        },
        remove: function remove() {
            var _rawDS$getDataSet2;
            return (_rawDS$getDataSet2 = rawDS.getDataSet()).remove.apply(_rawDS$getDataSet2, arguments);
        },
        update: function update() {
            var _rawDS$getDataSet3;
            return (_rawDS$getDataSet3 = rawDS.getDataSet()).update.apply(_rawDS$getDataSet3, arguments);
        },
        updateOnly: function updateOnly() {
            var _rawDS$getDataSet4;
            return (_rawDS$getDataSet4 = rawDS.getDataSet()).updateOnly.apply(_rawDS$getDataSet4, arguments);
        },
        clear: function clear() {
            var _rawDS$getDataSet5;
            return (_rawDS$getDataSet5 = rawDS.getDataSet()).clear.apply(_rawDS$getDataSet5, arguments);
        },
        // Read only.
        forEach: _bindInstanceProperty$1(_context3 = _forEachInstanceProperty(coercedDS)).call(_context3, coercedDS),
        get: _bindInstanceProperty$1(_context4 = coercedDS.get).call(_context4, coercedDS),
        getIds: _bindInstanceProperty$1(_context5 = coercedDS.getIds).call(_context5, coercedDS),
        off: _bindInstanceProperty$1(_context6 = coercedDS.off).call(_context6, coercedDS),
        on: _bindInstanceProperty$1(_context7 = coercedDS.on).call(_context7, coercedDS),
        get length () {
            return coercedDS.length;
        },
        // Non standard.
        idProp: idProp,
        type: type,
        rawDS: rawDS,
        coercedDS: coercedDS,
        dispose: function dispose() {
            return pipe.stop();
        }
    };
}
// Configure XSS protection
var setupXSSCleaner = function setupXSSCleaner(options) {
    var customXSS = new xssFilter.FilterXSS(options);
    return function(string) {
        return customXSS.process(string);
    };
};
var setupNoOpCleaner = function setupNoOpCleaner(string) {
    return string;
};
// when nothing else is configured: filter XSS with the lib's default options
var configuredXSSProtection = setupXSSCleaner();
var setupXSSProtection = function setupXSSProtection(options) {
    // No options? Do nothing.
    if (!options) return;
    // Disable XSS protection completely on request
    if (options.disabled === true) {
        configuredXSSProtection = setupNoOpCleaner;
        console.warn("You disabled XSS protection for vis-Timeline. I sure hope you know what you're doing!");
    } else // Configure XSS protection with some custom options.
    // For a list of valid options check the lib's documentation:
    // https://github.com/leizongmin/js-xss#custom-filter-rules
    if (options.filterOptions) configuredXSSProtection = setupXSSCleaner(options.filterOptions);
};
var availableUtils = _objectSpread(_objectSpread({}, util$2), {}, {
    convert: convert,
    setupXSSProtection: setupXSSProtection
});
_Object$defineProperty(availableUtils, "xss", {
    get: function get() {
        return configuredXSSProtection;
    }
});
var global$1 = global$q;
var fails = fails$y;
var uncurryThis = functionUncurryThis;
var toString$1 = toString$c;
var trim = stringTrim.trim;
var whitespaces = whitespaces$3;
var charAt = uncurryThis("".charAt);
var $parseFloat$1 = global$1.parseFloat;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var FORCED = 1 / $parseFloat$1(whitespaces + "-0") !== -Infinity || ITERATOR && !fails(function() {
    $parseFloat$1(Object(ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED ? function parseFloat1(string) {
    var trimmedString = trim(toString$1(string));
    var result = $parseFloat$1(trimmedString);
    return result === 0 && charAt(trimmedString, 0) === "-" ? -0 : result;
} : $parseFloat$1;
var $$4 = _export;
var $parseFloat = numberParseFloat;
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$$4({
    global: true,
    forced: parseFloat !== $parseFloat
}, {
    parseFloat: $parseFloat
});
var path$1 = path$u;
var _parseFloat$3 = path$1.parseFloat;
var parent$4 = _parseFloat$3;
var _parseFloat$2 = parent$4;
var _parseFloat = _parseFloat$2;
var _parseFloat$1 = /*@__PURE__*/ getDefaultExportFromCjs(_parseFloat);
/** Prototype for visual components */ var Component = /*#__PURE__*/ function() {
    /**
  * @param {{dom: Object, domProps: Object, emitter: Emitter, range: Range}} [body]
  * @param {Object} [options]
  */ function Component(body, options) {
        _classCallCheck(this, Component);
        // eslint-disable-line no-unused-vars
        this.options = null;
        this.props = null;
    }
    /**
   * Set options for the component. The new options will be merged into the
   * current options.
   * @param {Object} options
   */ _createClass(Component, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options) availableUtils.extend(this.options, options);
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                // should be implemented by the component
                return false;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
            // should be implemented by the component
            }
        },
        {
            key: "_isResized",
            value: function _isResized() {
                var resized = this.props._previousWidth !== this.props.width || this.props._previousHeight !== this.props.height;
                this.props._previousWidth = this.props.width;
                this.props._previousHeight = this.props.height;
                return resized;
            }
        }
    ]);
    return Component;
}();
var toIntegerOrInfinity = toIntegerOrInfinity$5;
var toString = toString$c;
var requireObjectCoercible = requireObjectCoercible$6;
var $RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
    var str = toString(requireObjectCoercible(this));
    var result = "";
    var n = toIntegerOrInfinity(count);
    if (n < 0 || n === Infinity) throw new $RangeError("Wrong number of repetitions");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};
var $$3 = _export;
var repeat$4 = stringRepeat;
// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$$3({
    target: "String",
    proto: true
}, {
    repeat: repeat$4
});
var entryVirtual$3 = entryVirtual$o;
var repeat$3 = entryVirtual$3("String").repeat;
var isPrototypeOf$3 = objectIsPrototypeOf;
var method$3 = repeat$3;
var StringPrototype = String.prototype;
var repeat$2 = function(it) {
    var own = it.repeat;
    return typeof it == "string" || it === StringPrototype || isPrototypeOf$3(StringPrototype, it) && own === StringPrototype.repeat ? method$3 : own;
};
var parent$3 = repeat$2;
var repeat$1 = parent$3;
var repeat = repeat$1;
var _repeatInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(repeat);
/**
 * used in Core to convert the options into a volatile variable
 * 
 * @param {function} moment
 * @param {Object} body
 * @param {Array | Object} hiddenDates
 * @returns {number}
 */ function convertHiddenOptions(moment, body, hiddenDates) {
    if (hiddenDates && !_Array$isArray(hiddenDates)) return convertHiddenOptions(moment, body, [
        hiddenDates
    ]);
    body.hiddenDates = [];
    if (hiddenDates) {
        if (_Array$isArray(hiddenDates) == true) {
            var _context;
            for(var i1 = 0; i1 < hiddenDates.length; i1++)if (_repeatInstanceProperty(hiddenDates[i1]) === undefined) {
                var dateItem = {};
                dateItem.start = moment(hiddenDates[i1].start).toDate().valueOf();
                dateItem.end = moment(hiddenDates[i1].end).toDate().valueOf();
                body.hiddenDates.push(dateItem);
            }
            _sortInstanceProperty(_context = body.hiddenDates).call(_context, function(a, b) {
                return a.start - b.start;
            }); // sort by start time
        }
    }
}
/**
 * create new entrees for the repeating hidden dates
 *
 * @param {function} moment
 * @param {Object} body
 * @param {Array | Object} hiddenDates
 * @returns {null}
 */ function updateHiddenDates(moment, body, hiddenDates) {
    if (hiddenDates && !_Array$isArray(hiddenDates)) return updateHiddenDates(moment, body, [
        hiddenDates
    ]);
    if (hiddenDates && body.domProps.centerContainer.width !== undefined) {
        convertHiddenOptions(moment, body, hiddenDates);
        var start = moment(body.range.start);
        var end = moment(body.range.end);
        var totalRange = body.range.end - body.range.start;
        var pixelTime = totalRange / body.domProps.centerContainer.width;
        for(var i1 = 0; i1 < hiddenDates.length; i1++)if (_repeatInstanceProperty(hiddenDates[i1]) !== undefined) {
            var startDate = moment(hiddenDates[i1].start);
            var endDate = moment(hiddenDates[i1].end);
            if (startDate._d == "Invalid Date") throw new Error("Supplied start date is not valid: ".concat(hiddenDates[i1].start));
            if (endDate._d == "Invalid Date") throw new Error("Supplied end date is not valid: ".concat(hiddenDates[i1].end));
            var duration = endDate - startDate;
            if (duration >= 4 * pixelTime) {
                var offset = 0;
                var runUntil = end.clone();
                switch(_repeatInstanceProperty(hiddenDates[i1])){
                    case "daily":
                        // case of time
                        if (startDate.day() != endDate.day()) offset = 1;
                        startDate.dayOfYear(start.dayOfYear());
                        startDate.year(start.year());
                        startDate.subtract(7, "days");
                        endDate.dayOfYear(start.dayOfYear());
                        endDate.year(start.year());
                        endDate.subtract(7 - offset, "days");
                        runUntil.add(1, "weeks");
                        break;
                    case "weekly":
                        var dayOffset = endDate.diff(startDate, "days");
                        var day = startDate.day();
                        // set the start date to the range.start
                        startDate.date(start.date());
                        startDate.month(start.month());
                        startDate.year(start.year());
                        endDate = startDate.clone();
                        // force
                        startDate.day(day);
                        endDate.day(day);
                        endDate.add(dayOffset, "days");
                        startDate.subtract(1, "weeks");
                        endDate.subtract(1, "weeks");
                        runUntil.add(1, "weeks");
                        break;
                    case "monthly":
                        if (startDate.month() != endDate.month()) offset = 1;
                        startDate.month(start.month());
                        startDate.year(start.year());
                        startDate.subtract(1, "months");
                        endDate.month(start.month());
                        endDate.year(start.year());
                        endDate.subtract(1, "months");
                        endDate.add(offset, "months");
                        runUntil.add(1, "months");
                        break;
                    case "yearly":
                        if (startDate.year() != endDate.year()) offset = 1;
                        startDate.year(start.year());
                        startDate.subtract(1, "years");
                        endDate.year(start.year());
                        endDate.subtract(1, "years");
                        endDate.add(offset, "years");
                        runUntil.add(1, "years");
                        break;
                    default:
                        console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", _repeatInstanceProperty(hiddenDates[i1]));
                        return;
                }
                while(startDate < runUntil){
                    body.hiddenDates.push({
                        start: startDate.valueOf(),
                        end: endDate.valueOf()
                    });
                    switch(_repeatInstanceProperty(hiddenDates[i1])){
                        case "daily":
                            startDate.add(1, "days");
                            endDate.add(1, "days");
                            break;
                        case "weekly":
                            startDate.add(1, "weeks");
                            endDate.add(1, "weeks");
                            break;
                        case "monthly":
                            startDate.add(1, "months");
                            endDate.add(1, "months");
                            break;
                        case "yearly":
                            startDate.add(1, "y");
                            endDate.add(1, "y");
                            break;
                        default:
                            console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", _repeatInstanceProperty(hiddenDates[i1]));
                            return;
                    }
                }
                body.hiddenDates.push({
                    start: startDate.valueOf(),
                    end: endDate.valueOf()
                });
            }
        }
        // remove duplicates, merge where possible
        removeDuplicates(body);
        // ensure the new positions are not on hidden dates
        var startHidden = getIsHidden(body.range.start, body.hiddenDates);
        var endHidden = getIsHidden(body.range.end, body.hiddenDates);
        var rangeStart = body.range.start;
        var rangeEnd = body.range.end;
        if (startHidden.hidden == true) rangeStart = body.range.startToFront == true ? startHidden.startDate - 1 : startHidden.endDate + 1;
        if (endHidden.hidden == true) rangeEnd = body.range.endToFront == true ? endHidden.startDate - 1 : endHidden.endDate + 1;
        if (startHidden.hidden == true || endHidden.hidden == true) body.range._applyRange(rangeStart, rangeEnd);
    }
}
/**
 * remove duplicates from the hidden dates list. Duplicates are evil. They mess everything up.
 * Scales with N^2
 *
 * @param {Object} body
 */ function removeDuplicates(body) {
    var _context2;
    var hiddenDates = body.hiddenDates;
    var safeDates = [];
    for(var i1 = 0; i1 < hiddenDates.length; i1++){
        for(var j = 0; j < hiddenDates.length; j++)if (i1 != j && hiddenDates[j].remove != true && hiddenDates[i1].remove != true) {
            // j inside i
            if (hiddenDates[j].start >= hiddenDates[i1].start && hiddenDates[j].end <= hiddenDates[i1].end) hiddenDates[j].remove = true;
            else if (hiddenDates[j].start >= hiddenDates[i1].start && hiddenDates[j].start <= hiddenDates[i1].end) {
                hiddenDates[i1].end = hiddenDates[j].end;
                hiddenDates[j].remove = true;
            } else if (hiddenDates[j].end >= hiddenDates[i1].start && hiddenDates[j].end <= hiddenDates[i1].end) {
                hiddenDates[i1].start = hiddenDates[j].start;
                hiddenDates[j].remove = true;
            }
        }
    }
    for(i1 = 0; i1 < hiddenDates.length; i1++)if (hiddenDates[i1].remove !== true) safeDates.push(hiddenDates[i1]);
    body.hiddenDates = safeDates;
    _sortInstanceProperty(_context2 = body.hiddenDates).call(_context2, function(a, b) {
        return a.start - b.start;
    }); // sort by start time
}
/**
 * Prints dates to console
 * @param {array} dates
 */ function printDates(dates) {
    for(var i1 = 0; i1 < dates.length; i1++)console.log(i1, new Date(dates[i1].start), new Date(dates[i1].end), dates[i1].start, dates[i1].end, dates[i1].remove);
}
/**
 * Used in TimeStep to avoid the hidden times.
 * @param {function} moment
 * @param {TimeStep} timeStep
 * @param {Date} previousTime
 */ function stepOverHiddenDates(moment, timeStep, previousTime) {
    var stepInHidden = false;
    var currentValue = timeStep.current.valueOf();
    for(var i1 = 0; i1 < timeStep.hiddenDates.length; i1++){
        var startDate = timeStep.hiddenDates[i1].start;
        var endDate = timeStep.hiddenDates[i1].end;
        if (currentValue >= startDate && currentValue < endDate) {
            stepInHidden = true;
            break;
        }
    }
    if (stepInHidden == true && currentValue < timeStep._end.valueOf() && currentValue != previousTime) {
        var prevValue = moment(previousTime);
        var newValue = moment(endDate);
        //check if the next step should be major
        if (prevValue.year() != newValue.year()) timeStep.switchedYear = true;
        else if (prevValue.month() != newValue.month()) timeStep.switchedMonth = true;
        else if (prevValue.dayOfYear() != newValue.dayOfYear()) timeStep.switchedDay = true;
        timeStep.current = newValue;
    }
}
///**
// * Used in TimeStep to avoid the hidden times.
// * @param timeStep
// * @param previousTime
// */
//checkFirstStep = function(timeStep) {
//  var stepInHidden = false;
//  var currentValue = timeStep.current.valueOf();
//  for (var i = 0; i < timeStep.hiddenDates.length; i++) {
//    var startDate = timeStep.hiddenDates[i].start;
//    var endDate = timeStep.hiddenDates[i].end;
//    if (currentValue >= startDate && currentValue < endDate) {
//      stepInHidden = true;
//      break;
//    }
//  }
//
//  if (stepInHidden == true && currentValue <= timeStep._end.valueOf()) {
//    var newValue = moment(endDate);
//    timeStep.current = newValue.toDate();
//  }
//};
/**
 * replaces the Core toScreen methods
 *
 * @param {timeline.Core} Core
 * @param {Date} time
 * @param {number} width
 * @returns {number}
 */ function toScreen(Core, time, width) {
    var conversion;
    if (Core.body.hiddenDates.length == 0) {
        conversion = Core.range.conversion(width);
        return (time.valueOf() - conversion.offset) * conversion.scale;
    } else {
        var hidden = getIsHidden(time, Core.body.hiddenDates);
        if (hidden.hidden == true) time = hidden.startDate;
        var duration = getHiddenDurationBetween(Core.body.hiddenDates, Core.range.start, Core.range.end);
        if (time < Core.range.start) {
            conversion = Core.range.conversion(width, duration);
            var hiddenBeforeStart = getHiddenDurationBeforeStart(Core.body.hiddenDates, time, conversion.offset);
            time = Core.options.moment(time).toDate().valueOf();
            time = time + hiddenBeforeStart;
            return -(conversion.offset - time.valueOf()) * conversion.scale;
        } else if (time > Core.range.end) {
            var rangeAfterEnd = {
                start: Core.range.start,
                end: time
            };
            time = correctTimeForHidden(Core.options.moment, Core.body.hiddenDates, rangeAfterEnd, time);
            conversion = Core.range.conversion(width, duration);
            return (time.valueOf() - conversion.offset) * conversion.scale;
        } else {
            time = correctTimeForHidden(Core.options.moment, Core.body.hiddenDates, Core.range, time);
            conversion = Core.range.conversion(width, duration);
            return (time.valueOf() - conversion.offset) * conversion.scale;
        }
    }
}
/**
 * Replaces the core toTime methods
 *
 * @param {timeline.Core} Core
 * @param {number} x
 * @param {number} width
 * @returns {Date}
 */ function toTime(Core, x, width) {
    if (Core.body.hiddenDates.length == 0) {
        var conversion = Core.range.conversion(width);
        return new Date(x / conversion.scale + conversion.offset);
    } else {
        var hiddenDuration = getHiddenDurationBetween(Core.body.hiddenDates, Core.range.start, Core.range.end);
        var totalDuration = Core.range.end - Core.range.start - hiddenDuration;
        var partialDuration = totalDuration * x / width;
        var accumulatedHiddenDuration = getAccumulatedHiddenDuration(Core.body.hiddenDates, Core.range, partialDuration);
        return new Date(accumulatedHiddenDuration + partialDuration + Core.range.start);
    }
}
/**
 * Support function
 *
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {number} start
 * @param {number} end
 * @returns {number}
 */ function getHiddenDurationBetween(hiddenDates, start, end) {
    var duration = 0;
    for(var i1 = 0; i1 < hiddenDates.length; i1++){
        var startDate = hiddenDates[i1].start;
        var endDate = hiddenDates[i1].end;
        // if time after the cutout, and the
        if (startDate >= start && endDate < end) duration += endDate - startDate;
    }
    return duration;
}
/**
 * Support function
 *
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {number} start
 * @param {number} end
 * @returns {number}
 */ function getHiddenDurationBeforeStart(hiddenDates, start, end) {
    var duration = 0;
    for(var i1 = 0; i1 < hiddenDates.length; i1++){
        var startDate = hiddenDates[i1].start;
        var endDate = hiddenDates[i1].end;
        if (startDate >= start && endDate <= end) duration += endDate - startDate;
    }
    return duration;
}
/**
 * Support function
 * @param {function} moment
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {{start: number, end: number}} range
 * @param {Date} time
 * @returns {number}
 */ function correctTimeForHidden(moment, hiddenDates, range, time) {
    time = moment(time).toDate().valueOf();
    time -= getHiddenDurationBefore(moment, hiddenDates, range, time);
    return time;
}
/**
 * Support function
 * @param {function} moment
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {{start: number, end: number}} range
 * @param {Date} time
 * @returns {number}
 */ function getHiddenDurationBefore(moment, hiddenDates, range, time) {
    var timeOffset = 0;
    time = moment(time).toDate().valueOf();
    for(var i1 = 0; i1 < hiddenDates.length; i1++){
        var startDate = hiddenDates[i1].start;
        var endDate = hiddenDates[i1].end;
        // if time after the cutout, and the
        if (startDate >= range.start && endDate < range.end) {
            if (time >= endDate) timeOffset += endDate - startDate;
        }
    }
    return timeOffset;
}
/**
 * sum the duration from start to finish, including the hidden duration,
 * until the required amount has been reached, return the accumulated hidden duration
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {{start: number, end: number}} range
 * @param {number} [requiredDuration=0]
 * @returns {number}
 */ function getAccumulatedHiddenDuration(hiddenDates, range, requiredDuration) {
    var hiddenDuration = 0;
    var duration = 0;
    var previousPoint = range.start;
    //printDates(hiddenDates)
    for(var i1 = 0; i1 < hiddenDates.length; i1++){
        var startDate = hiddenDates[i1].start;
        var endDate = hiddenDates[i1].end;
        // if time after the cutout, and the
        if (startDate >= range.start && endDate < range.end) {
            duration += startDate - previousPoint;
            previousPoint = endDate;
            if (duration >= requiredDuration) break;
            else hiddenDuration += endDate - startDate;
        }
    }
    return hiddenDuration;
}
/**
 * used to step over to either side of a hidden block. Correction is disabled on tablets, might be set to true
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {Date} time
 * @param {number} direction
 * @param {boolean} correctionEnabled
 * @returns {Date|number}
 */ function snapAwayFromHidden(hiddenDates, time, direction, correctionEnabled) {
    var isHidden = getIsHidden(time, hiddenDates);
    if (isHidden.hidden == true) {
        if (direction < 0) {
            if (correctionEnabled == true) return isHidden.startDate - (isHidden.endDate - time) - 1;
            else return isHidden.startDate - 1;
        } else {
            if (correctionEnabled == true) return isHidden.endDate + (time - isHidden.startDate) + 1;
            else return isHidden.endDate + 1;
        }
    } else return time;
}
/**
 * Check if a time is hidden
 *
 * @param {Date} time
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @returns {{hidden: boolean, startDate: Window.start, endDate: *}}
 */ function getIsHidden(time, hiddenDates) {
    for(var i1 = 0; i1 < hiddenDates.length; i1++){
        var startDate = hiddenDates[i1].start;
        var endDate = hiddenDates[i1].end;
        if (time >= startDate && time < endDate) // if the start is entering a hidden zone
        return {
            hidden: true,
            startDate: startDate,
            endDate: endDate
        };
    }
    return {
        hidden: false,
        startDate: startDate,
        endDate: endDate
    };
}
var DateUtil = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    convertHiddenOptions: convertHiddenOptions,
    correctTimeForHidden: correctTimeForHidden,
    getAccumulatedHiddenDuration: getAccumulatedHiddenDuration,
    getHiddenDurationBefore: getHiddenDurationBefore,
    getHiddenDurationBeforeStart: getHiddenDurationBeforeStart,
    getHiddenDurationBetween: getHiddenDurationBetween,
    getIsHidden: getIsHidden,
    printDates: printDates,
    removeDuplicates: removeDuplicates,
    snapAwayFromHidden: snapAwayFromHidden,
    stepOverHiddenDates: stepOverHiddenDates,
    toScreen: toScreen,
    toTime: toTime,
    updateHiddenDates: updateHiddenDates
});
function _createSuper$c(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$c();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$c() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A Range controls a numeric range with a start and end value.
 * The Range adjusts the range based on mouse events or programmatic changes,
 * and triggers events when the range is changing or has been changed.
 */ var Range = /*#__PURE__*/ function(_Component) {
    _inherits(Range, _Component);
    var _super = _createSuper$c(Range);
    /**
  * @param {{dom: Object, domProps: Object, emitter: Emitter}} body
  * @param {Object} [options]    See description at Range.setOptions
  * @constructor Range
  * @extends Component
  */ function Range(body, options) {
        var _context, _context2, _context3, _context4, _context5, _context6, _context7;
        var _this;
        _classCallCheck(this, Range);
        _this = _super.call(this);
        var now = moment$4().hours(0).minutes(0).seconds(0).milliseconds(0);
        var start = now.clone().add(-3, "days").valueOf();
        var end = now.clone().add(3, "days").valueOf();
        _this.millisecondsPerPixelCache = undefined;
        if (options === undefined) {
            _this.start = start;
            _this.end = end;
        } else {
            _this.start = options.start || start;
            _this.end = options.end || end;
        }
        _this.rolling = false;
        _this.body = body;
        _this.deltaDifference = 0;
        _this.scaleOffset = 0;
        _this.startToFront = false;
        _this.endToFront = true;
        // default options
        _this.defaultOptions = {
            rtl: false,
            start: null,
            end: null,
            moment: moment$4,
            direction: "horizontal",
            // 'horizontal' or 'vertical'
            moveable: true,
            zoomable: true,
            min: null,
            max: null,
            zoomMin: 10,
            // milliseconds
            zoomMax: 315360000000000,
            // milliseconds
            rollingMode: {
                follow: false,
                offset: 0.5
            }
        };
        _this.options = availableUtils.extend({}, _this.defaultOptions);
        _this.props = {
            touch: {}
        };
        _this.animationTimer = null;
        // drag listeners for dragging
        _this.body.emitter.on("panstart", _bindInstanceProperty$1(_context = _this._onDragStart).call(_context, _assertThisInitialized(_this)));
        _this.body.emitter.on("panmove", _bindInstanceProperty$1(_context2 = _this._onDrag).call(_context2, _assertThisInitialized(_this)));
        _this.body.emitter.on("panend", _bindInstanceProperty$1(_context3 = _this._onDragEnd).call(_context3, _assertThisInitialized(_this)));
        // mouse wheel for zooming
        _this.body.emitter.on("mousewheel", _bindInstanceProperty$1(_context4 = _this._onMouseWheel).call(_context4, _assertThisInitialized(_this)));
        // pinch to zoom
        _this.body.emitter.on("touch", _bindInstanceProperty$1(_context5 = _this._onTouch).call(_context5, _assertThisInitialized(_this)));
        _this.body.emitter.on("pinch", _bindInstanceProperty$1(_context6 = _this._onPinch).call(_context6, _assertThisInitialized(_this)));
        // on click of rolling mode button
        _this.body.dom.rollingModeBtn.addEventListener("click", _bindInstanceProperty$1(_context7 = _this.startRolling).call(_context7, _assertThisInitialized(_this)));
        _this.setOptions(options);
        return _this;
    }
    /**
   * Set options for the range controller
   * @param {Object} options      Available options:
   *                              {number | Date | String} start  Start date for the range
   *                              {number | Date | String} end    End date for the range
   *                              {number} min    Minimum value for start
   *                              {number} max    Maximum value for end
   *                              {number} zoomMin    Set a minimum value for
   *                                                  (end - start).
   *                              {number} zoomMax    Set a maximum value for
   *                                                  (end - start).
   *                              {boolean} moveable Enable moving of the range
   *                                                 by dragging. True by default
   *                              {boolean} zoomable Enable zooming of the range
   *                                                 by pinching/scrolling. True by default
   */ _createClass(Range, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options) {
                    // copy the options that we know
                    var fields = [
                        "animation",
                        "direction",
                        "min",
                        "max",
                        "zoomMin",
                        "zoomMax",
                        "moveable",
                        "zoomable",
                        "moment",
                        "activate",
                        "hiddenDates",
                        "zoomKey",
                        "zoomFriction",
                        "rtl",
                        "showCurrentTime",
                        "rollingMode",
                        "horizontalScroll"
                    ];
                    availableUtils.selectiveExtend(fields, this.options, options);
                    if (options.rollingMode && options.rollingMode.follow) this.startRolling();
                    if ("start" in options || "end" in options) // apply a new range. both start and end are optional
                    this.setRange(options.start, options.end);
                }
            }
        },
        {
            key: "startRolling",
            value: function startRolling() {
                var me = this;
                /**
       *  Updates the current time.
       */ function update() {
                    me.stopRolling();
                    me.rolling = true;
                    var interval = me.end - me.start;
                    var t = availableUtils.convert(new Date(), "Date").valueOf();
                    var rollingModeOffset = me.options.rollingMode && me.options.rollingMode.offset || 0.5;
                    var start = t - interval * rollingModeOffset;
                    var end = t + interval * (1 - rollingModeOffset);
                    var options = {
                        animation: false
                    };
                    me.setRange(start, end, options);
                    // determine interval to refresh
                    var scale = me.conversion(me.body.domProps.center.width).scale;
                    interval = 1 / scale / 10;
                    if (interval < 30) interval = 30;
                    if (interval > 1000) interval = 1000;
                    me.body.dom.rollingModeBtn.style.visibility = "hidden";
                    // start a renderTimer to adjust for the new time
                    me.currentTimeTimer = _setTimeout(update, interval);
                }
                update();
            }
        },
        {
            key: "stopRolling",
            value: function stopRolling() {
                if (this.currentTimeTimer !== undefined) {
                    clearTimeout(this.currentTimeTimer);
                    this.rolling = false;
                    this.body.dom.rollingModeBtn.style.visibility = "visible";
                }
            }
        },
        {
            key: "setRange",
            value: function setRange(start, end, options, callback, frameCallback) {
                if (!options) options = {};
                if (options.byUser !== true) options.byUser = false;
                var me = this;
                var finalStart = start != undefined ? availableUtils.convert(start, "Date").valueOf() : null;
                var finalEnd = end != undefined ? availableUtils.convert(end, "Date").valueOf() : null;
                this._cancelAnimation();
                this.millisecondsPerPixelCache = undefined;
                if (options.animation) {
                    // true or an Object
                    var initStart = this.start;
                    var initEnd = this.end;
                    var duration = _typeof$1(options.animation) === "object" && "duration" in options.animation ? options.animation.duration : 500;
                    var easingName = _typeof$1(options.animation) === "object" && "easingFunction" in options.animation ? options.animation.easingFunction : "easeInOutQuad";
                    var easingFunction = availableUtils.easingFunctions[easingName];
                    if (!easingFunction) {
                        var _context8;
                        throw new Error(_concatInstanceProperty(_context8 = "Unknown easing function ".concat(_JSON$stringify(easingName), ". Choose from: ")).call(_context8, _Object$keys(availableUtils.easingFunctions).join(", ")));
                    }
                    var initTime = _Date$now();
                    var anyChanged = false;
                    var next = function next() {
                        if (!me.props.touch.dragging) {
                            var now = _Date$now();
                            var time = now - initTime;
                            var ease = easingFunction(time / duration);
                            var done = time > duration;
                            var s = done || finalStart === null ? finalStart : initStart + (finalStart - initStart) * ease;
                            var e = done || finalEnd === null ? finalEnd : initEnd + (finalEnd - initEnd) * ease;
                            changed = me._applyRange(s, e);
                            updateHiddenDates(me.options.moment, me.body, me.options.hiddenDates);
                            anyChanged = anyChanged || changed;
                            var params = {
                                start: new Date(me.start),
                                end: new Date(me.end),
                                byUser: options.byUser,
                                event: options.event
                            };
                            if (frameCallback) frameCallback(ease, changed, done);
                            if (changed) me.body.emitter.emit("rangechange", params);
                            if (done) {
                                if (anyChanged) {
                                    me.body.emitter.emit("rangechanged", params);
                                    if (callback) return callback();
                                }
                            } else // animate with as high as possible frame rate, leave 20 ms in between
                            // each to prevent the browser from blocking
                            me.animationTimer = _setTimeout(next, 20);
                        }
                    };
                    return next();
                } else {
                    var changed = this._applyRange(finalStart, finalEnd);
                    updateHiddenDates(this.options.moment, this.body, this.options.hiddenDates);
                    if (changed) {
                        var params = {
                            start: new Date(this.start),
                            end: new Date(this.end),
                            byUser: options.byUser,
                            event: options.event
                        };
                        this.body.emitter.emit("rangechange", params);
                        clearTimeout(me.timeoutID);
                        me.timeoutID = _setTimeout(function() {
                            me.body.emitter.emit("rangechanged", params);
                        }, 200);
                        if (callback) return callback();
                    }
                }
            }
        },
        {
            key: "getMillisecondsPerPixel",
            value: function getMillisecondsPerPixel() {
                if (this.millisecondsPerPixelCache === undefined) this.millisecondsPerPixelCache = (this.end - this.start) / this.body.dom.center.clientWidth;
                return this.millisecondsPerPixelCache;
            }
        },
        {
            key: "_cancelAnimation",
            value: function _cancelAnimation() {
                if (this.animationTimer) {
                    clearTimeout(this.animationTimer);
                    this.animationTimer = null;
                }
            }
        },
        {
            key: "_applyRange",
            value: function _applyRange(start, end) {
                var newStart = start != null ? availableUtils.convert(start, "Date").valueOf() : this.start;
                var newEnd = end != null ? availableUtils.convert(end, "Date").valueOf() : this.end;
                var max = this.options.max != null ? availableUtils.convert(this.options.max, "Date").valueOf() : null;
                var min = this.options.min != null ? availableUtils.convert(this.options.min, "Date").valueOf() : null;
                var diff;
                // check for valid number
                if (isNaN(newStart) || newStart === null) throw new Error('Invalid start "'.concat(start, '"'));
                if (isNaN(newEnd) || newEnd === null) throw new Error('Invalid end "'.concat(end, '"'));
                // prevent end < start
                if (newEnd < newStart) newEnd = newStart;
                // prevent start < min
                if (min !== null) {
                    if (newStart < min) {
                        diff = min - newStart;
                        newStart += diff;
                        newEnd += diff;
                        // prevent end > max
                        if (max != null) {
                            if (newEnd > max) newEnd = max;
                        }
                    }
                }
                // prevent end > max
                if (max !== null) {
                    if (newEnd > max) {
                        diff = newEnd - max;
                        newStart -= diff;
                        newEnd -= diff;
                        // prevent start < min
                        if (min != null) {
                            if (newStart < min) newStart = min;
                        }
                    }
                }
                // prevent (end-start) < zoomMin
                if (this.options.zoomMin !== null) {
                    var zoomMin = _parseFloat$1(this.options.zoomMin);
                    if (zoomMin < 0) zoomMin = 0;
                    if (newEnd - newStart < zoomMin) {
                        // compensate for a scale of 0.5 ms
                        var compensation = 0.5;
                        if (this.end - this.start === zoomMin && newStart >= this.start - compensation && newEnd <= this.end) {
                            // ignore this action, we are already zoomed to the minimum
                            newStart = this.start;
                            newEnd = this.end;
                        } else {
                            // zoom to the minimum
                            diff = zoomMin - (newEnd - newStart);
                            newStart -= diff / 2;
                            newEnd += diff / 2;
                        }
                    }
                }
                // prevent (end-start) > zoomMax
                if (this.options.zoomMax !== null) {
                    var zoomMax = _parseFloat$1(this.options.zoomMax);
                    if (zoomMax < 0) zoomMax = 0;
                    if (newEnd - newStart > zoomMax) {
                        if (this.end - this.start === zoomMax && newStart < this.start && newEnd > this.end) {
                            // ignore this action, we are already zoomed to the maximum
                            newStart = this.start;
                            newEnd = this.end;
                        } else {
                            // zoom to the maximum
                            diff = newEnd - newStart - zoomMax;
                            newStart += diff / 2;
                            newEnd -= diff / 2;
                        }
                    }
                }
                var changed = this.start != newStart || this.end != newEnd;
                // if the new range does NOT overlap with the old range, emit checkRangedItems to avoid not showing ranged items (ranged meaning has end time, not necessarily of type Range)
                if (!(newStart >= this.start && newStart <= this.end || newEnd >= this.start && newEnd <= this.end) && !(this.start >= newStart && this.start <= newEnd || this.end >= newStart && this.end <= newEnd)) this.body.emitter.emit("checkRangedItems");
                this.start = newStart;
                this.end = newEnd;
                return changed;
            }
        },
        {
            key: "getRange",
            value: function getRange() {
                return {
                    start: this.start,
                    end: this.end
                };
            }
        },
        {
            key: "conversion",
            value: function conversion(width, totalHidden) {
                return Range.conversion(this.start, this.end, width, totalHidden);
            }
        },
        {
            key: "_onDragStart",
            value: /**
     * Start dragging horizontally or vertically
     * @param {Event} event
     * @private
     */ function _onDragStart(event1) {
                this.deltaDifference = 0;
                this.previousDelta = 0;
                // only allow dragging when configured as movable
                if (!this.options.moveable) return;
                // only start dragging when the mouse is inside the current range
                if (!this._isInsideRange(event1)) return;
                // refuse to drag when we where pinching to prevent the timeline make a jump
                // when releasing the fingers in opposite order from the touch screen
                if (!this.props.touch.allowDragging) return;
                this.stopRolling();
                this.props.touch.start = this.start;
                this.props.touch.end = this.end;
                this.props.touch.dragging = true;
                if (this.body.dom.root) this.body.dom.root.style.cursor = "move";
            }
        },
        {
            key: "_onDrag",
            value: function _onDrag(event1) {
                if (!event1) return;
                if (!this.props.touch.dragging) return;
                // only allow dragging when configured as movable
                if (!this.options.moveable) return;
                // TODO: this may be redundant in hammerjs2
                // refuse to drag when we where pinching to prevent the timeline make a jump
                // when releasing the fingers in opposite order from the touch screen
                if (!this.props.touch.allowDragging) return;
                var direction = this.options.direction;
                validateDirection(direction);
                var delta = direction == "horizontal" ? event1.deltaX : event1.deltaY;
                delta -= this.deltaDifference;
                var interval = this.props.touch.end - this.props.touch.start;
                // normalize dragging speed if cutout is in between.
                var duration = getHiddenDurationBetween(this.body.hiddenDates, this.start, this.end);
                interval -= duration;
                var width = direction == "horizontal" ? this.body.domProps.center.width : this.body.domProps.center.height;
                var diffRange;
                if (this.options.rtl) diffRange = delta / width * interval;
                else diffRange = -delta / width * interval;
                var newStart = this.props.touch.start + diffRange;
                var newEnd = this.props.touch.end + diffRange;
                // snapping times away from hidden zones
                var safeStart = snapAwayFromHidden(this.body.hiddenDates, newStart, this.previousDelta - delta, true);
                var safeEnd = snapAwayFromHidden(this.body.hiddenDates, newEnd, this.previousDelta - delta, true);
                if (safeStart != newStart || safeEnd != newEnd) {
                    this.deltaDifference += delta;
                    this.props.touch.start = safeStart;
                    this.props.touch.end = safeEnd;
                    this._onDrag(event1);
                    return;
                }
                this.previousDelta = delta;
                this._applyRange(newStart, newEnd);
                var startDate = new Date(this.start);
                var endDate = new Date(this.end);
                // fire a rangechange event
                this.body.emitter.emit("rangechange", {
                    start: startDate,
                    end: endDate,
                    byUser: true,
                    event: event1
                });
                // fire a panmove event
                this.body.emitter.emit("panmove");
            }
        },
        {
            key: "_onDragEnd",
            value: function _onDragEnd(event1) {
                if (!this.props.touch.dragging) return;
                // only allow dragging when configured as movable
                if (!this.options.moveable) return;
                // TODO: this may be redundant in hammerjs2
                // refuse to drag when we where pinching to prevent the timeline make a jump
                // when releasing the fingers in opposite order from the touch screen
                if (!this.props.touch.allowDragging) return;
                this.props.touch.dragging = false;
                if (this.body.dom.root) this.body.dom.root.style.cursor = "auto";
                // fire a rangechanged event
                this.body.emitter.emit("rangechanged", {
                    start: new Date(this.start),
                    end: new Date(this.end),
                    byUser: true,
                    event: event1
                });
            }
        },
        {
            key: "_onMouseWheel",
            value: function _onMouseWheel(event1) {
                // retrieve delta
                var delta = 0;
                if (event1.wheelDelta) /* IE/Opera. */ delta = event1.wheelDelta / 120;
                else if (event1.detail) /* Mozilla case. */ // In Mozilla, sign of delta is different than in IE.
                // Also, delta is multiple of 3.
                delta = -event1.detail / 3;
                else if (event1.deltaY) delta = -event1.deltaY / 3;
                // don't allow zoom when the according key is pressed and the zoomKey option or not zoomable but movable
                if (this.options.zoomKey && !event1[this.options.zoomKey] && this.options.zoomable || !this.options.zoomable && this.options.moveable) return;
                // only allow zooming when configured as zoomable and moveable
                if (!(this.options.zoomable && this.options.moveable)) return;
                // only zoom when the mouse is inside the current range
                if (!this._isInsideRange(event1)) return;
                // If delta is nonzero, handle it.
                // Basically, delta is now positive if wheel was scrolled up,
                // and negative, if wheel was scrolled down.
                if (delta) {
                    // perform the zoom action. Delta is normally 1 or -1
                    // adjust a negative delta such that zooming in with delta 0.1
                    // equals zooming out with a delta -0.1
                    var zoomFriction = this.options.zoomFriction || 5;
                    var scale;
                    if (delta < 0) scale = 1 - delta / zoomFriction;
                    else scale = 1 / (1 + delta / zoomFriction);
                    // calculate center, the date to zoom around
                    var pointerDate;
                    if (this.rolling) {
                        var rollingModeOffset = this.options.rollingMode && this.options.rollingMode.offset || 0.5;
                        pointerDate = this.start + (this.end - this.start) * rollingModeOffset;
                    } else {
                        var pointer = this.getPointer({
                            x: event1.clientX,
                            y: event1.clientY
                        }, this.body.dom.center);
                        pointerDate = this._pointerToDate(pointer);
                    }
                    this.zoom(scale, pointerDate, delta, event1);
                    // Prevent default actions caused by mouse wheel
                    // (else the page and timeline both scroll)
                    event1.preventDefault();
                }
            }
        },
        {
            key: "_onTouch",
            value: function _onTouch(event1) {
                // eslint-disable-line no-unused-vars
                this.props.touch.start = this.start;
                this.props.touch.end = this.end;
                this.props.touch.allowDragging = true;
                this.props.touch.center = null;
                this.props.touch.centerDate = null;
                this.scaleOffset = 0;
                this.deltaDifference = 0;
                // Disable the browser default handling of this event.
                availableUtils.preventDefault(event1);
            }
        },
        {
            key: "_onPinch",
            value: function _onPinch(event1) {
                // only allow zooming when configured as zoomable and moveable
                if (!(this.options.zoomable && this.options.moveable)) return;
                // Disable the browser default handling of this event.
                availableUtils.preventDefault(event1);
                this.props.touch.allowDragging = false;
                if (!this.props.touch.center) {
                    this.props.touch.center = this.getPointer(event1.center, this.body.dom.center);
                    this.props.touch.centerDate = this._pointerToDate(this.props.touch.center);
                }
                this.stopRolling();
                var scale = 1 / (event1.scale + this.scaleOffset);
                var centerDate = this.props.touch.centerDate;
                var hiddenDuration = getHiddenDurationBetween(this.body.hiddenDates, this.start, this.end);
                var hiddenDurationBefore = getHiddenDurationBefore(this.options.moment, this.body.hiddenDates, this, centerDate);
                var hiddenDurationAfter = hiddenDuration - hiddenDurationBefore;
                // calculate new start and end
                var newStart = centerDate - hiddenDurationBefore + (this.props.touch.start - (centerDate - hiddenDurationBefore)) * scale;
                var newEnd = centerDate + hiddenDurationAfter + (this.props.touch.end - (centerDate + hiddenDurationAfter)) * scale;
                // snapping times away from hidden zones
                this.startToFront = 1 - scale <= 0; // used to do the right auto correction with periodic hidden times
                this.endToFront = scale - 1 <= 0; // used to do the right auto correction with periodic hidden times
                var safeStart = snapAwayFromHidden(this.body.hiddenDates, newStart, 1 - scale, true);
                var safeEnd = snapAwayFromHidden(this.body.hiddenDates, newEnd, scale - 1, true);
                if (safeStart != newStart || safeEnd != newEnd) {
                    this.props.touch.start = safeStart;
                    this.props.touch.end = safeEnd;
                    this.scaleOffset = 1 - event1.scale;
                    newStart = safeStart;
                    newEnd = safeEnd;
                }
                var options = {
                    animation: false,
                    byUser: true,
                    event: event1
                };
                this.setRange(newStart, newEnd, options);
                this.startToFront = false; // revert to default
                this.endToFront = true; // revert to default
            }
        },
        {
            key: "_isInsideRange",
            value: function _isInsideRange(event1) {
                // calculate the time where the mouse is, check whether inside
                // and no scroll action should happen.
                var clientX = event1.center ? event1.center.x : event1.clientX;
                var centerContainerRect = this.body.dom.centerContainer.getBoundingClientRect();
                var x = this.options.rtl ? clientX - centerContainerRect.left : centerContainerRect.right - clientX;
                var time = this.body.util.toTime(x);
                return time >= this.start && time <= this.end;
            }
        },
        {
            key: "_pointerToDate",
            value: function _pointerToDate(pointer) {
                var conversion;
                var direction = this.options.direction;
                validateDirection(direction);
                if (direction == "horizontal") return this.body.util.toTime(pointer.x).valueOf();
                else {
                    var height = this.body.domProps.center.height;
                    conversion = this.conversion(height);
                    return pointer.y / conversion.scale + conversion.offset;
                }
            }
        },
        {
            key: "getPointer",
            value: function getPointer(touch, element) {
                var elementRect = element.getBoundingClientRect();
                if (this.options.rtl) return {
                    x: elementRect.right - touch.x,
                    y: touch.y - elementRect.top
                };
                else return {
                    x: touch.x - elementRect.left,
                    y: touch.y - elementRect.top
                };
            }
        },
        {
            key: "zoom",
            value: function zoom(scale, center, delta, event1) {
                // if centerDate is not provided, take it half between start Date and end Date
                if (center == null) center = (this.start + this.end) / 2;
                var hiddenDuration = getHiddenDurationBetween(this.body.hiddenDates, this.start, this.end);
                var hiddenDurationBefore = getHiddenDurationBefore(this.options.moment, this.body.hiddenDates, this, center);
                var hiddenDurationAfter = hiddenDuration - hiddenDurationBefore;
                // calculate new start and end
                var newStart = center - hiddenDurationBefore + (this.start - (center - hiddenDurationBefore)) * scale;
                var newEnd = center + hiddenDurationAfter + (this.end - (center + hiddenDurationAfter)) * scale;
                // snapping times away from hidden zones
                this.startToFront = delta > 0 ? false : true; // used to do the right autocorrection with periodic hidden times
                this.endToFront = -delta > 0 ? false : true; // used to do the right autocorrection with periodic hidden times
                var safeStart = snapAwayFromHidden(this.body.hiddenDates, newStart, delta, true);
                var safeEnd = snapAwayFromHidden(this.body.hiddenDates, newEnd, -delta, true);
                if (safeStart != newStart || safeEnd != newEnd) {
                    newStart = safeStart;
                    newEnd = safeEnd;
                }
                var options = {
                    animation: false,
                    byUser: true,
                    event: event1
                };
                this.setRange(newStart, newEnd, options);
                this.startToFront = false; // revert to default
                this.endToFront = true; // revert to default
            }
        },
        {
            key: "move",
            value: function move(delta) {
                // zoom start Date and end Date relative to the centerDate
                var diff = this.end - this.start;
                // apply new values
                var newStart = this.start + diff * delta;
                var newEnd = this.end + diff * delta;
                // TODO: reckon with min and max range
                this.start = newStart;
                this.end = newEnd;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(_moveTo) {
                var center = (this.start + this.end) / 2;
                var diff = center - _moveTo;
                // calculate new start and end
                var newStart = this.start - diff;
                var newEnd = this.end - diff;
                var options = {
                    animation: false,
                    byUser: true,
                    event: null
                };
                this.setRange(newStart, newEnd, options);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.stopRolling();
            }
        }
    ], [
        {
            key: "conversion",
            value: function conversion(start, end, width, totalHidden) {
                if (totalHidden === undefined) totalHidden = 0;
                if (width != 0 && end - start != 0) return {
                    offset: start,
                    scale: width / (end - start - totalHidden)
                };
                else return {
                    offset: 0,
                    scale: 1
                };
            }
        }
    ]);
    return Range;
}(Component);
function validateDirection(direction) {
    if (direction != "horizontal" && direction != "vertical") throw new TypeError('Unknown direction "'.concat(direction, '". Choose "horizontal" or "vertical".'));
}
var path = path$u;
var setInterval$1 = path.setInterval;
var setInterval = setInterval$1;
var _setInterval = /*@__PURE__*/ getDefaultExportFromCjs(setInterval);
var _firstTarget = null; // singleton, will contain the target element where the touch event started
/**
 * Extend an Hammer.js instance with event propagation.
 *
 * Features:
 * - Events emitted by hammer will propagate in order from child to parent
 *   elements.
 * - Events are extended with a function `event.stopPropagation()` to stop
 *   propagation to parent elements.
 * - An option `preventDefault` to stop all default browser behavior.
 *
 * Usage:
 *   var hammer = propagatingHammer(new Hammer(element));
 *   var hammer = propagatingHammer(new Hammer(element), {preventDefault: true});
 *
 * @param {Hammer.Manager} hammer   An hammer instance.
 * @param {Object} [options]        Available options:
 *                                  - `preventDefault: true | false | 'mouse' | 'touch' | 'pen'`.
 *                                    Enforce preventing the default browser behavior.
 *                                    Cannot be set to `false`.
 * @return {Hammer.Manager} Returns the same hammer instance with extended
 *                          functionality
 */ function propagating(hammer, options) {
    var _options = options || {
        preventDefault: false
    };
    if (hammer.Manager) {
        // This looks like the Hammer constructor.
        // Overload the constructors with our own.
        var Hammer = hammer;
        var PropagatingHammer = function(element, options) {
            var o = Object.create(_options);
            if (options) Hammer.assign(o, options);
            return propagating(new Hammer(element, o), o);
        };
        Hammer.assign(PropagatingHammer, Hammer);
        PropagatingHammer.Manager = function(element, options) {
            var o = Object.create(_options);
            if (options) Hammer.assign(o, options);
            return propagating(new Hammer.Manager(element, o), o);
        };
        return PropagatingHammer;
    }
    // create a wrapper object which will override the functions
    // `on`, `off`, `destroy`, and `emit` of the hammer instance
    var wrapper = Object.create(hammer);
    // attach to DOM element
    var element = hammer.element;
    if (!element.hammer) element.hammer = [];
    element.hammer.push(wrapper);
    // register an event to catch the start of a gesture and store the
    // target in a singleton
    hammer.on("hammer.input", function(event1) {
        if (_options.preventDefault === true || _options.preventDefault === event1.pointerType) event1.preventDefault();
        if (event1.isFirst) _firstTarget = event1.target;
    });
    /** @type {Object.<String, Array.<function>>} */ wrapper._handlers = {};
    /**
   * Register a handler for one or multiple events
   * @param {String} events    A space separated string with events
   * @param {function} handler A callback function, called as handler(event)
   * @returns {Hammer.Manager} Returns the hammer instance
   */ wrapper.on = function(events, handler) {
        // register the handler
        split(events).forEach(function(event1) {
            var _handlers = wrapper._handlers[event1];
            if (!_handlers) {
                wrapper._handlers[event1] = _handlers = [];
                // register the static, propagated handler
                hammer.on(event1, propagatedHandler);
            }
            _handlers.push(handler);
        });
        return wrapper;
    };
    /**
   * Unregister a handler for one or multiple events
   * @param {String} events      A space separated string with events
   * @param {function} [handler] Optional. The registered handler. If not
   *                             provided, all handlers for given events
   *                             are removed.
   * @returns {Hammer.Manager}   Returns the hammer instance
   */ wrapper.off = function(events, handler) {
        // unregister the handler
        split(events).forEach(function(event1) {
            var _handlers = wrapper._handlers[event1];
            if (_handlers) {
                _handlers = handler ? _handlers.filter(function(h) {
                    return h !== handler;
                }) : [];
                if (_handlers.length > 0) wrapper._handlers[event1] = _handlers;
                else {
                    // remove static, propagated handler
                    hammer.off(event1, propagatedHandler);
                    delete wrapper._handlers[event1];
                }
            }
        });
        return wrapper;
    };
    /**
   * Emit to the event listeners
   * @param {string} eventType
   * @param {Event} event
   */ wrapper.emit = function(eventType, event1) {
        _firstTarget = event1.target;
        hammer.emit(eventType, event1);
    };
    wrapper.destroy = function() {
        // Detach from DOM element
        var hammers = hammer.element.hammer;
        var idx = hammers.indexOf(wrapper);
        if (idx !== -1) hammers.splice(idx, 1);
        if (!hammers.length) delete hammer.element.hammer;
        // clear all handlers
        wrapper._handlers = {};
        // call original hammer destroy
        hammer.destroy();
    };
    // split a string with space separated words
    function split(events) {
        return events.match(/[^ ]+/g);
    }
    /**
   * A static event handler, applying event propagation.
   * @param {Object} event
   */ function propagatedHandler(event1) {
        // let only a single hammer instance handle this event
        if (event1.type !== "hammer.input") {
            // it is possible that the same srcEvent is used with multiple hammer events,
            // we keep track on which events are handled in an object _handled
            if (!event1.srcEvent._handled) event1.srcEvent._handled = {};
            if (event1.srcEvent._handled[event1.type]) return;
            else event1.srcEvent._handled[event1.type] = true;
        }
        // attach a stopPropagation function to the event
        var stopped = false;
        event1.stopPropagation = function() {
            stopped = true;
        };
        //wrap the srcEvent's stopPropagation to also stop hammer propagation:
        var srcStop = event1.srcEvent.stopPropagation.bind(event1.srcEvent);
        if (typeof srcStop == "function") event1.srcEvent.stopPropagation = function() {
            srcStop();
            event1.stopPropagation();
        };
        // attach firstTarget property to the event
        event1.firstTarget = _firstTarget;
        // propagate over all elements (until stopped)
        var elem = _firstTarget;
        while(elem && !stopped){
            var elemHammer = elem.hammer;
            if (elemHammer) {
                var _handlers;
                for(var k = 0; k < elemHammer.length; k++){
                    _handlers = elemHammer[k]._handlers[event1.type];
                    if (_handlers) for(var i1 = 0; i1 < _handlers.length && !stopped; i1++)_handlers[i1](event1);
                }
            }
            elem = elem.parentNode;
        }
    }
    return wrapper;
}
/**
 * Setup a mock hammer.js object, for unit testing.
 *
 * Inspiration: https://github.com/uber/deck.gl/pull/658
 *
 * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
 */ function hammerMock() {
    var noop = function noop() {};
    return {
        on: noop,
        off: noop,
        destroy: noop,
        emit: noop,
        get: function get(m) {
            //eslint-disable-line no-unused-vars
            return {
                set: noop
            };
        }
    };
}
var modifiedHammer;
if (typeof window !== "undefined") {
    var OurHammer = window["Hammer"] || Hammer$4;
    modifiedHammer = propagating(OurHammer, {
        preventDefault: "mouse"
    });
} else modifiedHammer = function modifiedHammer() {
    return(// hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
    hammerMock());
};
var Hammer = modifiedHammer;
/**
 * Register a touch event, taking place before a gesture
 * @param {Hammer} hammer       A hammer instance
 * @param {function} callback   Callback, called as callback(event)
 */ function onTouch(hammer, callback) {
    callback.inputHandler = function(event1) {
        if (event1.isFirst) callback(event1);
    };
    hammer.on("hammer.input", callback.inputHandler);
}
/**
 * Register a release event, taking place after a gesture
 * @param {Hammer} hammer       A hammer instance
 * @param {function} callback   Callback, called as callback(event)
 * @returns {*}
 */ function onRelease(hammer, callback) {
    callback.inputHandler = function(event1) {
        if (event1.isFinal) callback(event1);
    };
    return hammer.on("hammer.input", callback.inputHandler);
}
/**
 * Hack the PinchRecognizer such that it doesn't prevent default behavior
 * for vertical panning.
 *
 * Yeah ... this is quite a hack ... see https://github.com/hammerjs/hammer.js/issues/932
 *
 * @param {Hammer.Pinch} pinchRecognizer
 * @return {Hammer.Pinch} returns the pinchRecognizer
 */ function disablePreventDefaultVertically(pinchRecognizer) {
    var TOUCH_ACTION_PAN_Y = "pan-y";
    pinchRecognizer.getTouchAction = function() {
        // default method returns [TOUCH_ACTION_NONE]
        return [
            TOUCH_ACTION_PAN_Y
        ];
    };
    return pinchRecognizer;
}
/**
 * The class TimeStep is an iterator for dates. You provide a start date and an
 * end date. The class itself determines the best scale (step size) based on the
 * provided start Date, end Date, and minimumStep.
 *
 * If minimumStep is provided, the step size is chosen as close as possible
 * to the minimumStep but larger than minimumStep. If minimumStep is not
 * provided, the scale is set to 1 DAY.
 * The minimumStep should correspond with the onscreen size of about 6 characters
 *
 * Alternatively, you can set a scale by hand.
 * After creation, you can initialize the class by executing first(). Then you
 * can iterate from the start date to the end date via next(). You can check if
 * the end date is reached with the function hasNext(). After each step, you can
 * retrieve the current date via getCurrent().
 * The TimeStep has scales ranging from milliseconds, seconds, minutes, hours,
 * days, to years.
 *
 * Version: 1.2
 *
 */ var TimeStep = /*#__PURE__*/ function() {
    /**
    * @param {Date} [start]         The start date, for example new Date(2010, 9, 21)
    *                               or new Date(2010, 9, 21, 23, 45, 00)
    * @param {Date} [end]           The end date
    * @param {number} [minimumStep] Optional. Minimum step size in milliseconds
    * @param {Date|Array.<Date>} [hiddenDates] Optional.
    * @param {{showMajorLabels: boolean, showWeekScale: boolean}} [options] Optional.
    * @constructor  TimeStep
    */ function TimeStep(start, end, minimumStep, hiddenDates, options) {
        _classCallCheck(this, TimeStep);
        this.moment = options && options.moment || moment$4;
        this.options = options ? options : {};
        // variables
        this.current = this.moment();
        this._start = this.moment();
        this._end = this.moment();
        this.autoScale = true;
        this.scale = "day";
        this.step = 1;
        // initialize the range
        this.setRange(start, end, minimumStep);
        // hidden Dates options
        this.switchedDay = false;
        this.switchedMonth = false;
        this.switchedYear = false;
        if (_Array$isArray(hiddenDates)) this.hiddenDates = hiddenDates;
        else if (hiddenDates != undefined) this.hiddenDates = [
            hiddenDates
        ];
        else this.hiddenDates = [];
        this.format = TimeStep.FORMAT; // default formatting
    }
    /**
   * Set custom constructor function for moment. Can be used to set dates
   * to UTC or to set a utcOffset.
   * @param {function} moment
   */ _createClass(TimeStep, [
        {
            key: "setMoment",
            value: function setMoment(moment) {
                this.moment = moment;
                // update the date properties, can have a new utcOffset
                this.current = this.moment(this.current.valueOf());
                this._start = this.moment(this._start.valueOf());
                this._end = this.moment(this._end.valueOf());
            }
        },
        {
            key: "setFormat",
            value: function setFormat(format) {
                var defaultFormat = availableUtils.deepExtend({}, TimeStep.FORMAT);
                this.format = availableUtils.deepExtend(defaultFormat, format);
            }
        },
        {
            key: "setRange",
            value: function setRange(start, end, minimumStep) {
                if (!(start instanceof Date) || !(end instanceof Date)) throw "No legal start or end date in method setRange";
                this._start = start != undefined ? this.moment(start.valueOf()) : _Date$now();
                this._end = end != undefined ? this.moment(end.valueOf()) : _Date$now();
                if (this.autoScale) this.setMinimumStep(minimumStep);
            }
        },
        {
            key: "start",
            value: function start() {
                this.current = this._start.clone();
                this.roundToMinor();
            }
        },
        {
            key: "roundToMinor",
            value: function roundToMinor() {
                // round to floor
                // to prevent year & month scales rounding down to the first day of week we perform this separately
                if (this.scale == "week") this.current.weekday(0);
                // IMPORTANT: we have no breaks in this switch! (this is no bug)
                // noinspection FallThroughInSwitchStatementJS
                switch(this.scale){
                    case "year":
                        this.current.year(this.step * Math.floor(this.current.year() / this.step));
                        this.current.month(0);
                    // eslint-disable-line no-fallthrough
                    case "month":
                        this.current.date(1);
                    // eslint-disable-line no-fallthrough
                    case "week":
                    case "day":
                    case "weekday":
                        this.current.hours(0);
                    // eslint-disable-line no-fallthrough
                    case "hour":
                        this.current.minutes(0);
                    // eslint-disable-line no-fallthrough
                    case "minute":
                        this.current.seconds(0);
                    // eslint-disable-line no-fallthrough
                    case "second":
                        this.current.milliseconds(0);
                }
                if (this.step != 1) {
                    // round down to the first minor value that is a multiple of the current step size
                    var priorCurrent = this.current.clone();
                    switch(this.scale){
                        case "millisecond":
                            this.current.subtract(this.current.milliseconds() % this.step, "milliseconds");
                            break;
                        case "second":
                            this.current.subtract(this.current.seconds() % this.step, "seconds");
                            break;
                        case "minute":
                            this.current.subtract(this.current.minutes() % this.step, "minutes");
                            break;
                        case "hour":
                            this.current.subtract(this.current.hours() % this.step, "hours");
                            break;
                        case "weekday":
                        case "day":
                            this.current.subtract((this.current.date() - 1) % this.step, "day");
                            break;
                        case "week":
                            this.current.subtract(this.current.week() % this.step, "week");
                            break;
                        case "month":
                            this.current.subtract(this.current.month() % this.step, "month");
                            break;
                        case "year":
                            this.current.subtract(this.current.year() % this.step, "year");
                            break;
                    }
                    if (!priorCurrent.isSame(this.current)) this.current = this.moment(snapAwayFromHidden(this.hiddenDates, this.current.valueOf(), -1, true));
                }
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.current.valueOf() <= this._end.valueOf();
            }
        },
        {
            key: "next",
            value: function next() {
                var prev = this.current.valueOf();
                // Two cases, needed to prevent issues with switching daylight savings
                // (end of March and end of October)
                switch(this.scale){
                    case "millisecond":
                        this.current.add(this.step, "millisecond");
                        break;
                    case "second":
                        this.current.add(this.step, "second");
                        break;
                    case "minute":
                        this.current.add(this.step, "minute");
                        break;
                    case "hour":
                        this.current.add(this.step, "hour");
                        if (this.current.month() < 6) this.current.subtract(this.current.hours() % this.step, "hour");
                        else if (this.current.hours() % this.step !== 0) this.current.add(this.step - this.current.hours() % this.step, "hour");
                        break;
                    case "weekday":
                    case "day":
                        this.current.add(this.step, "day");
                        break;
                    case "week":
                        if (this.current.weekday() !== 0) {
                            // we had a month break not correlating with a week's start before
                            this.current.weekday(0); // switch back to week cycles
                            this.current.add(this.step, "week");
                        } else if (this.options.showMajorLabels === false) this.current.add(this.step, "week"); // the default case
                        else {
                            // first day of the week
                            var nextWeek = this.current.clone();
                            nextWeek.add(1, "week");
                            if (nextWeek.isSame(this.current, "month")) // is the first day of the next week in the same month?
                            this.current.add(this.step, "week"); // the default case
                            else {
                                // inject a step at each first day of the month
                                this.current.add(this.step, "week");
                                this.current.date(1);
                            }
                        }
                        break;
                    case "month":
                        this.current.add(this.step, "month");
                        break;
                    case "year":
                        this.current.add(this.step, "year");
                        break;
                }
                if (this.step != 1) // round down to the correct major value
                switch(this.scale){
                    case "millisecond":
                        if (this.current.milliseconds() > 0 && this.current.milliseconds() < this.step) this.current.milliseconds(0);
                        break;
                    case "second":
                        if (this.current.seconds() > 0 && this.current.seconds() < this.step) this.current.seconds(0);
                        break;
                    case "minute":
                        if (this.current.minutes() > 0 && this.current.minutes() < this.step) this.current.minutes(0);
                        break;
                    case "hour":
                        if (this.current.hours() > 0 && this.current.hours() < this.step) this.current.hours(0);
                        break;
                    case "weekday":
                    case "day":
                        if (this.current.date() < this.step + 1) this.current.date(1);
                        break;
                    case "week":
                        if (this.current.week() < this.step) this.current.week(1);
                        break;
                    // week numbering starts at 1, not 0
                    case "month":
                        if (this.current.month() < this.step) this.current.month(0);
                        break;
                }
                // safety mechanism: if current time is still unchanged, move to the end
                if (this.current.valueOf() == prev) this.current = this._end.clone();
                // Reset switches for year, month and day. Will get set to true where appropriate in DateUtil.stepOverHiddenDates
                this.switchedDay = false;
                this.switchedMonth = false;
                this.switchedYear = false;
                stepOverHiddenDates(this.moment, this, prev);
            }
        },
        {
            key: "getCurrent",
            value: function getCurrent() {
                return this.current.clone();
            }
        },
        {
            key: "setScale",
            value: function setScale(params) {
                if (params && typeof params.scale == "string") {
                    this.scale = params.scale;
                    this.step = params.step > 0 ? params.step : 1;
                    this.autoScale = false;
                }
            }
        },
        {
            key: "setAutoScale",
            value: function setAutoScale(enable) {
                this.autoScale = enable;
            }
        },
        {
            key: "setMinimumStep",
            value: function setMinimumStep(minimumStep) {
                if (minimumStep == undefined) return;
                //var b = asc + ds;
                var stepYear = 31104000000;
                var stepMonth = 2592000000;
                var stepDay = 86400000;
                var stepHour = 3600000;
                var stepMinute = 60000;
                var stepSecond = 1000;
                var stepMillisecond = 1;
                // find the smallest step that is larger than the provided minimumStep
                if (stepYear * 1000 > minimumStep) {
                    this.scale = "year";
                    this.step = 1000;
                }
                if (stepYear * 500 > minimumStep) {
                    this.scale = "year";
                    this.step = 500;
                }
                if (stepYear * 100 > minimumStep) {
                    this.scale = "year";
                    this.step = 100;
                }
                if (stepYear * 50 > minimumStep) {
                    this.scale = "year";
                    this.step = 50;
                }
                if (stepYear * 10 > minimumStep) {
                    this.scale = "year";
                    this.step = 10;
                }
                if (stepYear * 5 > minimumStep) {
                    this.scale = "year";
                    this.step = 5;
                }
                if (stepYear > minimumStep) {
                    this.scale = "year";
                    this.step = 1;
                }
                if (stepMonth * 3 > minimumStep) {
                    this.scale = "month";
                    this.step = 3;
                }
                if (stepMonth > minimumStep) {
                    this.scale = "month";
                    this.step = 1;
                }
                if (stepDay * 7 > minimumStep && this.options.showWeekScale) {
                    this.scale = "week";
                    this.step = 1;
                }
                if (stepDay * 2 > minimumStep) {
                    this.scale = "day";
                    this.step = 2;
                }
                if (stepDay > minimumStep) {
                    this.scale = "day";
                    this.step = 1;
                }
                if (stepDay / 2 > minimumStep) {
                    this.scale = "weekday";
                    this.step = 1;
                }
                if (stepHour * 4 > minimumStep) {
                    this.scale = "hour";
                    this.step = 4;
                }
                if (stepHour > minimumStep) {
                    this.scale = "hour";
                    this.step = 1;
                }
                if (stepMinute * 15 > minimumStep) {
                    this.scale = "minute";
                    this.step = 15;
                }
                if (stepMinute * 10 > minimumStep) {
                    this.scale = "minute";
                    this.step = 10;
                }
                if (stepMinute * 5 > minimumStep) {
                    this.scale = "minute";
                    this.step = 5;
                }
                if (stepMinute > minimumStep) {
                    this.scale = "minute";
                    this.step = 1;
                }
                if (stepSecond * 15 > minimumStep) {
                    this.scale = "second";
                    this.step = 15;
                }
                if (stepSecond * 10 > minimumStep) {
                    this.scale = "second";
                    this.step = 10;
                }
                if (stepSecond * 5 > minimumStep) {
                    this.scale = "second";
                    this.step = 5;
                }
                if (stepSecond > minimumStep) {
                    this.scale = "second";
                    this.step = 1;
                }
                if (stepMillisecond * 200 > minimumStep) {
                    this.scale = "millisecond";
                    this.step = 200;
                }
                if (stepMillisecond * 100 > minimumStep) {
                    this.scale = "millisecond";
                    this.step = 100;
                }
                if (stepMillisecond * 50 > minimumStep) {
                    this.scale = "millisecond";
                    this.step = 50;
                }
                if (stepMillisecond * 10 > minimumStep) {
                    this.scale = "millisecond";
                    this.step = 10;
                }
                if (stepMillisecond * 5 > minimumStep) {
                    this.scale = "millisecond";
                    this.step = 5;
                }
                if (stepMillisecond > minimumStep) {
                    this.scale = "millisecond";
                    this.step = 1;
                }
            }
        },
        {
            key: "isMajor",
            value: /**
     * Check if the current value is a major value (for example when the step
     * is DAY, a major value is each first day of the MONTH)
     * @return {boolean} true if current date is major, else false.
     */ function isMajor() {
                if (this.switchedYear == true) switch(this.scale){
                    case "year":
                    case "month":
                    case "week":
                    case "weekday":
                    case "day":
                    case "hour":
                    case "minute":
                    case "second":
                    case "millisecond":
                        return true;
                    default:
                        return false;
                }
                else if (this.switchedMonth == true) switch(this.scale){
                    case "week":
                    case "weekday":
                    case "day":
                    case "hour":
                    case "minute":
                    case "second":
                    case "millisecond":
                        return true;
                    default:
                        return false;
                }
                else if (this.switchedDay == true) switch(this.scale){
                    case "millisecond":
                    case "second":
                    case "minute":
                    case "hour":
                        return true;
                    default:
                        return false;
                }
                var date = this.moment(this.current);
                switch(this.scale){
                    case "millisecond":
                        return date.milliseconds() == 0;
                    case "second":
                        return date.seconds() == 0;
                    case "minute":
                        return date.hours() == 0 && date.minutes() == 0;
                    case "hour":
                        return date.hours() == 0;
                    case "weekday":
                    case "day":
                        return this.options.showWeekScale ? date.isoWeekday() == 1 : date.date() == 1;
                    case "week":
                        return date.date() == 1;
                    case "month":
                        return date.month() == 0;
                    case "year":
                        return false;
                    default:
                        return false;
                }
            }
        },
        {
            key: "getLabelMinor",
            value: function getLabelMinor(date) {
                if (date == undefined) date = this.current;
                if (date instanceof Date) date = this.moment(date);
                if (typeof this.format.minorLabels === "function") return this.format.minorLabels(date, this.scale, this.step);
                var format = this.format.minorLabels[this.scale];
                // noinspection FallThroughInSwitchStatementJS
                switch(this.scale){
                    case "week":
                        // Don't draw the minor label if this date is the first day of a month AND if it's NOT the start of the week.
                        // The 'date' variable may actually be the 'next' step when called from TimeAxis' _repaintLabels.
                        if (date.date() === 1 && date.weekday() !== 0) return "";
                    default:
                        // eslint-disable-line no-fallthrough
                        return format && format.length > 0 ? this.moment(date).format(format) : "";
                }
            }
        },
        {
            key: "getLabelMajor",
            value: function getLabelMajor(date) {
                if (date == undefined) date = this.current;
                if (date instanceof Date) date = this.moment(date);
                if (typeof this.format.majorLabels === "function") return this.format.majorLabels(date, this.scale, this.step);
                var format = this.format.majorLabels[this.scale];
                return format && format.length > 0 ? this.moment(date).format(format) : "";
            }
        },
        {
            key: "getClassName",
            value: function getClassName() {
                var _context;
                var _moment = this.moment;
                var m = this.moment(this.current);
                var current = m.locale ? m.locale("en") : m.lang("en"); // old versions of moment have .lang() function
                var step = this.step;
                var classNames = [];
                /**
       *
       * @param {number} value
       * @returns {String}
       */ function even(value) {
                    return value / step % 2 == 0 ? " vis-even" : " vis-odd";
                }
                /**
       *
       * @param {Date} date
       * @returns {String}
       */ function today(date) {
                    if (date.isSame(_Date$now(), "day")) return " vis-today";
                    if (date.isSame(_moment().add(1, "day"), "day")) return " vis-tomorrow";
                    if (date.isSame(_moment().add(-1, "day"), "day")) return " vis-yesterday";
                    return "";
                }
                /**
       *
       * @param {Date} date
       * @returns {String}
       */ function currentWeek(date) {
                    return date.isSame(_Date$now(), "week") ? " vis-current-week" : "";
                }
                /**
       *
       * @param {Date} date
       * @returns {String}
       */ function currentMonth(date) {
                    return date.isSame(_Date$now(), "month") ? " vis-current-month" : "";
                }
                /**
       *
       * @param {Date} date
       * @returns {String}
       */ function currentYear(date) {
                    return date.isSame(_Date$now(), "year") ? " vis-current-year" : "";
                }
                switch(this.scale){
                    case "millisecond":
                        classNames.push(today(current));
                        classNames.push(even(current.milliseconds()));
                        break;
                    case "second":
                        classNames.push(today(current));
                        classNames.push(even(current.seconds()));
                        break;
                    case "minute":
                        classNames.push(today(current));
                        classNames.push(even(current.minutes()));
                        break;
                    case "hour":
                        classNames.push(_concatInstanceProperty(_context = "vis-h".concat(current.hours())).call(_context, this.step == 4 ? "-h" + (current.hours() + 4) : ""));
                        classNames.push(today(current));
                        classNames.push(even(current.hours()));
                        break;
                    case "weekday":
                        classNames.push("vis-".concat(current.format("dddd").toLowerCase()));
                        classNames.push(today(current));
                        classNames.push(currentWeek(current));
                        classNames.push(even(current.date()));
                        break;
                    case "day":
                        classNames.push("vis-day".concat(current.date()));
                        classNames.push("vis-".concat(current.format("MMMM").toLowerCase()));
                        classNames.push(today(current));
                        classNames.push(currentMonth(current));
                        classNames.push(this.step <= 2 ? today(current) : "");
                        classNames.push(this.step <= 2 ? "vis-".concat(current.format("dddd").toLowerCase()) : "");
                        classNames.push(even(current.date() - 1));
                        break;
                    case "week":
                        classNames.push("vis-week".concat(current.format("w")));
                        classNames.push(currentWeek(current));
                        classNames.push(even(current.week()));
                        break;
                    case "month":
                        classNames.push("vis-".concat(current.format("MMMM").toLowerCase()));
                        classNames.push(currentMonth(current));
                        classNames.push(even(current.month()));
                        break;
                    case "year":
                        classNames.push("vis-year".concat(current.year()));
                        classNames.push(currentYear(current));
                        classNames.push(even(current.year()));
                        break;
                }
                return _filterInstanceProperty(classNames).call(classNames, String).join(" ");
            }
        }
    ], [
        {
            key: "snap",
            value: function snap(date, scale, step) {
                var clone = moment$4(date);
                if (scale == "year") {
                    var year = clone.year() + Math.round(clone.month() / 12);
                    clone.year(Math.round(year / step) * step);
                    clone.month(0);
                    clone.date(0);
                    clone.hours(0);
                    clone.minutes(0);
                    clone.seconds(0);
                    clone.milliseconds(0);
                } else if (scale == "month") {
                    if (clone.date() > 15) {
                        clone.date(1);
                        clone.add(1, "month");
                    // important: first set Date to 1, after that change the month.
                    } else clone.date(1);
                    clone.hours(0);
                    clone.minutes(0);
                    clone.seconds(0);
                    clone.milliseconds(0);
                } else if (scale == "week") {
                    if (clone.weekday() > 2) {
                        // doing it the momentjs locale aware way
                        clone.weekday(0);
                        clone.add(1, "week");
                    } else clone.weekday(0);
                    clone.hours(0);
                    clone.minutes(0);
                    clone.seconds(0);
                    clone.milliseconds(0);
                } else if (scale == "day") {
                    //noinspection FallthroughInSwitchStatementJS
                    switch(step){
                        case 5:
                        case 2:
                            clone.hours(Math.round(clone.hours() / 24) * 24);
                            break;
                        default:
                            clone.hours(Math.round(clone.hours() / 12) * 12);
                            break;
                    }
                    clone.minutes(0);
                    clone.seconds(0);
                    clone.milliseconds(0);
                } else if (scale == "weekday") {
                    //noinspection FallthroughInSwitchStatementJS
                    switch(step){
                        case 5:
                        case 2:
                            clone.hours(Math.round(clone.hours() / 12) * 12);
                            break;
                        default:
                            clone.hours(Math.round(clone.hours() / 6) * 6);
                            break;
                    }
                    clone.minutes(0);
                    clone.seconds(0);
                    clone.milliseconds(0);
                } else if (scale == "hour") {
                    switch(step){
                        case 4:
                            clone.minutes(Math.round(clone.minutes() / 60) * 60);
                            break;
                        default:
                            clone.minutes(Math.round(clone.minutes() / 30) * 30);
                            break;
                    }
                    clone.seconds(0);
                    clone.milliseconds(0);
                } else if (scale == "minute") {
                    //noinspection FallthroughInSwitchStatementJS
                    switch(step){
                        case 15:
                        case 10:
                            clone.minutes(Math.round(clone.minutes() / 5) * 5);
                            clone.seconds(0);
                            break;
                        case 5:
                            clone.seconds(Math.round(clone.seconds() / 60) * 60);
                            break;
                        default:
                            clone.seconds(Math.round(clone.seconds() / 30) * 30);
                            break;
                    }
                    clone.milliseconds(0);
                } else if (scale == "second") //noinspection FallthroughInSwitchStatementJS
                switch(step){
                    case 15:
                    case 10:
                        clone.seconds(Math.round(clone.seconds() / 5) * 5);
                        clone.milliseconds(0);
                        break;
                    case 5:
                        clone.milliseconds(Math.round(clone.milliseconds() / 1000) * 1000);
                        break;
                    default:
                        clone.milliseconds(Math.round(clone.milliseconds() / 500) * 500);
                        break;
                }
                else if (scale == "millisecond") {
                    var _step = step > 5 ? step / 2 : 1;
                    clone.milliseconds(Math.round(clone.milliseconds() / _step) * _step);
                }
                return clone;
            }
        }
    ]);
    return TimeStep;
}(); // Time formatting
TimeStep.FORMAT = {
    minorLabels: {
        millisecond: "SSS",
        second: "s",
        minute: "HH:mm",
        hour: "HH:mm",
        weekday: "ddd D",
        day: "D",
        week: "w",
        month: "MMM",
        year: "YYYY"
    },
    majorLabels: {
        millisecond: "HH:mm:ss",
        second: "D MMMM HH:mm",
        minute: "ddd D MMMM",
        hour: "ddd D MMMM",
        weekday: "MMMM YYYY",
        day: "MMMM YYYY",
        week: "MMMM YYYY",
        month: "YYYY",
        year: ""
    }
};
function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var css_248z$e = ".vis-time-axis {\n  position: relative;\n  overflow: hidden;\n}\n\n.vis-time-axis.vis-foreground {\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n\n.vis-time-axis.vis-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.vis-time-axis .vis-text {\n  position: absolute;\n  color: #4d4d4d;\n  padding: 3px;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  white-space: nowrap;\n}\n\n.vis-time-axis .vis-text.vis-measure {\n  position: absolute;\n  padding-left: 0;\n  padding-right: 0;\n  margin-left: 0;\n  margin-right: 0;\n  visibility: hidden;\n}\n\n.vis-time-axis .vis-grid.vis-vertical {\n  position: absolute;\n  border-left: 1px solid;\n}\n\n.vis-time-axis .vis-grid.vis-vertical-rtl {\n  position: absolute;\n  border-right: 1px solid;\n}\n\n.vis-time-axis .vis-grid.vis-minor {\n  border-color: #e5e5e5;\n}\n\n.vis-time-axis .vis-grid.vis-major {\n  border-color: #bfbfbf;\n}\n";
styleInject(css_248z$e);
function _createSuper$b(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$b();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$b() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/** A horizontal time axis */ var TimeAxis = /*#__PURE__*/ function(_Component) {
    _inherits(TimeAxis, _Component);
    var _super = _createSuper$b(TimeAxis);
    /**
   * @param {{dom: Object, domProps: Object, emitter: Emitter, range: Range}} body
   * @param {Object} [options]        See TimeAxis.setOptions for the available
   *                                  options.
   * @constructor TimeAxis
   * @extends Component
   */ function TimeAxis(body, options) {
        var _this;
        _classCallCheck(this, TimeAxis);
        _this = _super.call(this);
        _this.dom = {
            foreground: null,
            lines: [],
            majorTexts: [],
            minorTexts: [],
            redundant: {
                lines: [],
                majorTexts: [],
                minorTexts: []
            }
        };
        _this.props = {
            range: {
                start: 0,
                end: 0,
                minimumStep: 0
            },
            lineTop: 0
        };
        _this.defaultOptions = {
            orientation: {
                axis: "bottom"
            },
            // axis orientation: 'top' or 'bottom'
            showMinorLabels: true,
            showMajorLabels: true,
            showWeekScale: false,
            maxMinorChars: 7,
            format: availableUtils.extend({}, TimeStep.FORMAT),
            moment: moment$4,
            timeAxis: null
        };
        _this.options = availableUtils.extend({}, _this.defaultOptions);
        _this.body = body;
        // create the HTML DOM
        _this._create();
        _this.setOptions(options);
        return _this;
    }
    /**
   * Set options for the TimeAxis.
   * Parameters will be merged in current options.
   * @param {Object} options  Available options:
   *                          {string} [orientation.axis]
   *                          {boolean} [showMinorLabels]
   *                          {boolean} [showMajorLabels]
   *                          {boolean} [showWeekScale]
   */ _createClass(TimeAxis, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options) {
                    // copy all options that we know
                    availableUtils.selectiveExtend([
                        "showMinorLabels",
                        "showMajorLabels",
                        "showWeekScale",
                        "maxMinorChars",
                        "hiddenDates",
                        "timeAxis",
                        "moment",
                        "rtl"
                    ], this.options, options);
                    // deep copy the format options
                    availableUtils.selectiveDeepExtend([
                        "format"
                    ], this.options, options);
                    if ("orientation" in options) {
                        if (typeof options.orientation === "string") this.options.orientation.axis = options.orientation;
                        else if (_typeof$1(options.orientation) === "object" && "axis" in options.orientation) this.options.orientation.axis = options.orientation.axis;
                    }
                    // apply locale to moment.js
                    // TODO: not so nice, this is applied globally to moment.js
                    if ("locale" in options) {
                        if (typeof moment$4.locale === "function") // moment.js 2.8.1+
                        moment$4.locale(options.locale);
                        else moment$4.lang(options.locale);
                    }
                }
            }
        },
        {
            key: "_create",
            value: function _create() {
                this.dom.foreground = document.createElement("div");
                this.dom.background = document.createElement("div");
                this.dom.foreground.className = "vis-time-axis vis-foreground";
                this.dom.background.className = "vis-time-axis vis-background";
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                // remove from DOM
                if (this.dom.foreground.parentNode) this.dom.foreground.parentNode.removeChild(this.dom.foreground);
                if (this.dom.background.parentNode) this.dom.background.parentNode.removeChild(this.dom.background);
                this.body = null;
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                var props = this.props;
                var foreground = this.dom.foreground;
                var background = this.dom.background;
                // determine the correct parent DOM element (depending on option orientation)
                var parent = this.options.orientation.axis == "top" ? this.body.dom.top : this.body.dom.bottom;
                var parentChanged = foreground.parentNode !== parent;
                // calculate character width and height
                this._calculateCharSize();
                // TODO: recalculate sizes only needed when parent is resized or options is changed
                var showMinorLabels = this.options.showMinorLabels && this.options.orientation.axis !== "none";
                var showMajorLabels = this.options.showMajorLabels && this.options.orientation.axis !== "none";
                // determine the width and height of the elemens for the axis
                props.minorLabelHeight = showMinorLabels ? props.minorCharHeight : 0;
                props.majorLabelHeight = showMajorLabels ? props.majorCharHeight : 0;
                props.height = props.minorLabelHeight + props.majorLabelHeight;
                props.width = foreground.offsetWidth;
                props.minorLineHeight = this.body.domProps.root.height - props.majorLabelHeight - (this.options.orientation.axis == "top" ? this.body.domProps.bottom.height : this.body.domProps.top.height);
                props.minorLineWidth = 1; // TODO: really calculate width
                props.majorLineHeight = props.minorLineHeight + props.majorLabelHeight;
                props.majorLineWidth = 1; // TODO: really calculate width
                //  take foreground and background offline while updating (is almost twice as fast)
                var foregroundNextSibling = foreground.nextSibling;
                var backgroundNextSibling = background.nextSibling;
                foreground.parentNode && foreground.parentNode.removeChild(foreground);
                background.parentNode && background.parentNode.removeChild(background);
                foreground.style.height = "".concat(this.props.height, "px");
                this._repaintLabels();
                // put DOM online again (at the same place)
                if (foregroundNextSibling) parent.insertBefore(foreground, foregroundNextSibling);
                else parent.appendChild(foreground);
                if (backgroundNextSibling) this.body.dom.backgroundVertical.insertBefore(background, backgroundNextSibling);
                else this.body.dom.backgroundVertical.appendChild(background);
                return this._isResized() || parentChanged;
            }
        },
        {
            key: "_repaintLabels",
            value: function _repaintLabels() {
                var orientation = this.options.orientation.axis;
                // calculate range and step (step such that we have space for 7 characters per label)
                var start = availableUtils.convert(this.body.range.start, "Number");
                var end = availableUtils.convert(this.body.range.end, "Number");
                var timeLabelsize = this.body.util.toTime((this.props.minorCharWidth || 10) * this.options.maxMinorChars).valueOf();
                var minimumStep = timeLabelsize - getHiddenDurationBefore(this.options.moment, this.body.hiddenDates, this.body.range, timeLabelsize);
                minimumStep -= this.body.util.toTime(0).valueOf();
                var step = new TimeStep(new Date(start), new Date(end), minimumStep, this.body.hiddenDates, this.options);
                step.setMoment(this.options.moment);
                if (this.options.format) step.setFormat(this.options.format);
                if (this.options.timeAxis) step.setScale(this.options.timeAxis);
                this.step = step;
                // Move all DOM elements to a "redundant" list, where they
                // can be picked for re-use, and clear the lists with lines and texts.
                // At the end of the function _repaintLabels, left over elements will be cleaned up
                var dom = this.dom;
                dom.redundant.lines = dom.lines;
                dom.redundant.majorTexts = dom.majorTexts;
                dom.redundant.minorTexts = dom.minorTexts;
                dom.lines = [];
                dom.majorTexts = [];
                dom.minorTexts = [];
                var current;
                var next;
                var x;
                var xNext;
                var isMajor;
                var showMinorGrid;
                var width = 0;
                var prevWidth;
                var line;
                var xFirstMajorLabel = undefined;
                var count = 0;
                var MAX = 1000;
                var className;
                step.start();
                next = step.getCurrent();
                xNext = this.body.util.toScreen(next);
                while(step.hasNext() && count < MAX){
                    count++;
                    isMajor = step.isMajor();
                    className = step.getClassName();
                    current = next;
                    x = xNext;
                    step.next();
                    next = step.getCurrent();
                    xNext = this.body.util.toScreen(next);
                    prevWidth = width;
                    width = xNext - x;
                    switch(step.scale){
                        case "week":
                            showMinorGrid = true;
                            break;
                        default:
                            showMinorGrid = width >= prevWidth * 0.4;
                            break;
                    }
                    if (this.options.showMinorLabels && showMinorGrid) {
                        var label = this._repaintMinorText(x, step.getLabelMinor(current), orientation, className);
                        label.style.width = "".concat(width, "px"); // set width to prevent overflow
                    }
                    if (isMajor && this.options.showMajorLabels) {
                        if (x > 0) {
                            if (xFirstMajorLabel == undefined) xFirstMajorLabel = x;
                            label = this._repaintMajorText(x, step.getLabelMajor(current), orientation, className);
                        }
                        line = this._repaintMajorLine(x, width, orientation, className);
                    } else {
                        // minor line
                        if (showMinorGrid) line = this._repaintMinorLine(x, width, orientation, className);
                        else if (line) // adjust the width of the previous grid
                        line.style.width = "".concat(_parseInt$1(line.style.width) + width, "px");
                    }
                }
                if (count === MAX && !warnedForOverflow) {
                    console.warn("Something is wrong with the Timeline scale. Limited drawing of grid lines to ".concat(MAX, " lines."));
                    warnedForOverflow = true;
                }
                // create a major label on the left when needed
                if (this.options.showMajorLabels) {
                    var leftTime = this.body.util.toTime(0); // upper bound estimation
                    var leftText = step.getLabelMajor(leftTime);
                    var widthText = leftText.length * (this.props.majorCharWidth || 10) + 10;
                    if (xFirstMajorLabel == undefined || widthText < xFirstMajorLabel) this._repaintMajorText(0, leftText, orientation, className);
                }
                // Cleanup leftover DOM elements from the redundant list
                _forEachInstanceProperty(availableUtils).call(availableUtils, this.dom.redundant, function(arr) {
                    while(arr.length){
                        var elem = arr.pop();
                        if (elem && elem.parentNode) elem.parentNode.removeChild(elem);
                    }
                });
            }
        },
        {
            key: "_repaintMinorText",
            value: function _repaintMinorText(x, text, orientation, className) {
                // reuse redundant label
                var label = this.dom.redundant.minorTexts.shift();
                if (!label) {
                    // create new label
                    var content = document.createTextNode("");
                    label = document.createElement("div");
                    label.appendChild(content);
                    this.dom.foreground.appendChild(label);
                }
                this.dom.minorTexts.push(label);
                label.innerHTML = availableUtils.xss(text);
                var y = orientation == "top" ? this.props.majorLabelHeight : 0;
                this._setXY(label, x, y);
                label.className = "vis-text vis-minor ".concat(className);
                //label.title = title;  // TODO: this is a heavy operation
                return label;
            }
        },
        {
            key: "_repaintMajorText",
            value: function _repaintMajorText(x, text, orientation, className) {
                // reuse redundant label
                var label = this.dom.redundant.majorTexts.shift();
                if (!label) {
                    // create label
                    var content = document.createElement("div");
                    label = document.createElement("div");
                    label.appendChild(content);
                    this.dom.foreground.appendChild(label);
                }
                label.childNodes[0].innerHTML = availableUtils.xss(text);
                label.className = "vis-text vis-major ".concat(className);
                //label.title = title; // TODO: this is a heavy operation
                var y = orientation == "top" ? 0 : this.props.minorLabelHeight;
                this._setXY(label, x, y);
                this.dom.majorTexts.push(label);
                return label;
            }
        },
        {
            key: "_setXY",
            value: function _setXY(label, x, y) {
                var _context;
                // If rtl is true, inverse x.
                var directionX = this.options.rtl ? x * -1 : x;
                label.style.transform = _concatInstanceProperty(_context = "translate(".concat(directionX, "px, ")).call(_context, y, "px)");
            }
        },
        {
            key: "_repaintMinorLine",
            value: function _repaintMinorLine(left, width, orientation, className) {
                var _context2;
                // reuse redundant line
                var line = this.dom.redundant.lines.shift();
                if (!line) {
                    // create vertical line
                    line = document.createElement("div");
                    this.dom.background.appendChild(line);
                }
                this.dom.lines.push(line);
                var props = this.props;
                line.style.width = "".concat(width, "px");
                line.style.height = "".concat(props.minorLineHeight, "px");
                var y = orientation == "top" ? props.majorLabelHeight : this.body.domProps.top.height;
                var x = left - props.minorLineWidth / 2;
                this._setXY(line, x, y);
                line.className = _concatInstanceProperty(_context2 = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-minor ")).call(_context2, className);
                return line;
            }
        },
        {
            key: "_repaintMajorLine",
            value: function _repaintMajorLine(left, width, orientation, className) {
                var _context3;
                // reuse redundant line
                var line = this.dom.redundant.lines.shift();
                if (!line) {
                    // create vertical line
                    line = document.createElement("div");
                    this.dom.background.appendChild(line);
                }
                this.dom.lines.push(line);
                var props = this.props;
                line.style.width = "".concat(width, "px");
                line.style.height = "".concat(props.majorLineHeight, "px");
                var y = orientation == "top" ? 0 : this.body.domProps.top.height;
                var x = left - props.majorLineWidth / 2;
                this._setXY(line, x, y);
                line.className = _concatInstanceProperty(_context3 = "vis-grid ".concat(this.options.rtl ? "vis-vertical-rtl" : "vis-vertical", " vis-major ")).call(_context3, className);
                return line;
            }
        },
        {
            key: "_calculateCharSize",
            value: function _calculateCharSize() {
                // Note: We calculate char size with every redraw. Size may change, for
                // example when any of the timelines parents had display:none for example.
                // determine the char width and height on the minor axis
                if (!this.dom.measureCharMinor) {
                    this.dom.measureCharMinor = document.createElement("DIV");
                    this.dom.measureCharMinor.className = "vis-text vis-minor vis-measure";
                    this.dom.measureCharMinor.style.position = "absolute";
                    this.dom.measureCharMinor.appendChild(document.createTextNode("0"));
                    this.dom.foreground.appendChild(this.dom.measureCharMinor);
                }
                this.props.minorCharHeight = this.dom.measureCharMinor.clientHeight;
                this.props.minorCharWidth = this.dom.measureCharMinor.clientWidth;
                // determine the char width and height on the major axis
                if (!this.dom.measureCharMajor) {
                    this.dom.measureCharMajor = document.createElement("DIV");
                    this.dom.measureCharMajor.className = "vis-text vis-major vis-measure";
                    this.dom.measureCharMajor.style.position = "absolute";
                    this.dom.measureCharMajor.appendChild(document.createTextNode("0"));
                    this.dom.foreground.appendChild(this.dom.measureCharMajor);
                }
                this.props.majorCharHeight = this.dom.measureCharMajor.clientHeight;
                this.props.majorCharWidth = this.dom.measureCharMajor.clientWidth;
            }
        }
    ]);
    return TimeAxis;
}(Component);
var warnedForOverflow = false;
/**
 * Created by Alex on 11/6/2014.
 */ function keycharm(options) {
    var preventDefault = options && options.preventDefault || false;
    var container = options && options.container || window;
    var _exportFunctions = {};
    var _bound = {
        keydown: {},
        keyup: {}
    };
    var _keys = {};
    var i1;
    // a - z
    for(i1 = 97; i1 <= 122; i1++)_keys[String.fromCharCode(i1)] = {
        code: 65 + (i1 - 97),
        shift: false
    };
    // A - Z
    for(i1 = 65; i1 <= 90; i1++)_keys[String.fromCharCode(i1)] = {
        code: i1,
        shift: true
    };
    // 0 - 9
    for(i1 = 0; i1 <= 9; i1++)_keys["" + i1] = {
        code: 48 + i1,
        shift: false
    };
    // F1 - F12
    for(i1 = 1; i1 <= 12; i1++)_keys["F" + i1] = {
        code: 111 + i1,
        shift: false
    };
    // num0 - num9
    for(i1 = 0; i1 <= 9; i1++)_keys["num" + i1] = {
        code: 96 + i1,
        shift: false
    };
    // numpad misc
    _keys["num*"] = {
        code: 106,
        shift: false
    };
    _keys["num+"] = {
        code: 107,
        shift: false
    };
    _keys["num-"] = {
        code: 109,
        shift: false
    };
    _keys["num/"] = {
        code: 111,
        shift: false
    };
    _keys["num."] = {
        code: 110,
        shift: false
    };
    // arrows
    _keys["left"] = {
        code: 37,
        shift: false
    };
    _keys["up"] = {
        code: 38,
        shift: false
    };
    _keys["right"] = {
        code: 39,
        shift: false
    };
    _keys["down"] = {
        code: 40,
        shift: false
    };
    // extra keys
    _keys["space"] = {
        code: 32,
        shift: false
    };
    _keys["enter"] = {
        code: 13,
        shift: false
    };
    _keys["shift"] = {
        code: 16,
        shift: undefined
    };
    _keys["esc"] = {
        code: 27,
        shift: false
    };
    _keys["backspace"] = {
        code: 8,
        shift: false
    };
    _keys["tab"] = {
        code: 9,
        shift: false
    };
    _keys["ctrl"] = {
        code: 17,
        shift: false
    };
    _keys["alt"] = {
        code: 18,
        shift: false
    };
    _keys["delete"] = {
        code: 46,
        shift: false
    };
    _keys["pageup"] = {
        code: 33,
        shift: false
    };
    _keys["pagedown"] = {
        code: 34,
        shift: false
    };
    // symbols
    _keys["="] = {
        code: 187,
        shift: false
    };
    _keys["-"] = {
        code: 189,
        shift: false
    };
    _keys["]"] = {
        code: 221,
        shift: false
    };
    _keys["["] = {
        code: 219,
        shift: false
    };
    var down = function(event1) {
        handleEvent(event1, "keydown");
    };
    var up = function(event1) {
        handleEvent(event1, "keyup");
    };
    // handle the actualy bound key with the event
    var handleEvent = function(event1, type) {
        if (_bound[type][event1.keyCode] !== undefined) {
            var bound = _bound[type][event1.keyCode];
            for(var i1 = 0; i1 < bound.length; i1++){
                if (bound[i1].shift === undefined) bound[i1].fn(event1);
                else if (bound[i1].shift == true && event1.shiftKey == true) bound[i1].fn(event1);
                else if (bound[i1].shift == false && event1.shiftKey == false) bound[i1].fn(event1);
            }
            if (preventDefault == true) event1.preventDefault();
        }
    };
    // bind a key to a callback
    _exportFunctions.bind = function(key, callback, type) {
        if (type === undefined) type = "keydown";
        if (_keys[key] === undefined) throw new Error("unsupported key: " + key);
        if (_bound[type][_keys[key].code] === undefined) _bound[type][_keys[key].code] = [];
        _bound[type][_keys[key].code].push({
            fn: callback,
            shift: _keys[key].shift
        });
    };
    // bind all keys to a call back (demo purposes)
    _exportFunctions.bindAll = function(callback, type) {
        if (type === undefined) type = "keydown";
        for(var key in _keys)if (_keys.hasOwnProperty(key)) _exportFunctions.bind(key, callback, type);
    };
    // get the key label from an event
    _exportFunctions.getKey = function(event1) {
        for(var key in _keys)if (_keys.hasOwnProperty(key)) {
            if (event1.shiftKey == true && _keys[key].shift == true && event1.keyCode == _keys[key].code) return key;
            else if (event1.shiftKey == false && _keys[key].shift == false && event1.keyCode == _keys[key].code) return key;
            else if (event1.keyCode == _keys[key].code && key == "shift") return key;
        }
        return "unknown key, currently not supported";
    };
    // unbind either a specific callback from a key or all of them (by leaving callback undefined)
    _exportFunctions.unbind = function(key, callback, type) {
        if (type === undefined) type = "keydown";
        if (_keys[key] === undefined) throw new Error("unsupported key: " + key);
        if (callback !== undefined) {
            var newBindings = [];
            var bound = _bound[type][_keys[key].code];
            if (bound !== undefined) {
                for(var i1 = 0; i1 < bound.length; i1++)if (!(bound[i1].fn == callback && bound[i1].shift == _keys[key].shift)) newBindings.push(_bound[type][_keys[key].code][i1]);
            }
            _bound[type][_keys[key].code] = newBindings;
        } else _bound[type][_keys[key].code] = [];
    };
    // reset all bound variables.
    _exportFunctions.reset = function() {
        _bound = {
            keydown: {},
            keyup: {}
        };
    };
    // unbind all listeners and reset all variables.
    _exportFunctions.destroy = function() {
        _bound = {
            keydown: {},
            keyup: {}
        };
        container.removeEventListener("keydown", down, true);
        container.removeEventListener("keyup", up, true);
    };
    // create listeners.
    container.addEventListener("keydown", down, true);
    container.addEventListener("keyup", up, true);
    // return the public functions.
    return _exportFunctions;
}
var css_248z$d = ".vis .overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  /* Must be displayed above for example selected Timeline items */\n  z-index: 10;\n}\n\n.vis-active {\n  box-shadow: 0 0 10px #86d5f8;\n}\n";
styleInject(css_248z$d);
/**
 * Turn an element into an clickToUse element.
 * When not active, the element has a transparent overlay. When the overlay is
 * clicked, the mode is changed to active.
 * When active, the element is displayed with a blue border around it, and
 * the interactive contents of the element can be used. When clicked outside
 * the element, the elements mode is changed to inactive.
 * @param {Element} container
 * @constructor Activator
 */ function Activator(container) {
    var _context, _context2;
    this.active = false;
    this.dom = {
        container: container
    };
    this.dom.overlay = document.createElement("div");
    this.dom.overlay.className = "vis-overlay";
    this.dom.container.appendChild(this.dom.overlay);
    this.hammer = Hammer(this.dom.overlay);
    this.hammer.on("tap", _bindInstanceProperty$1(_context = this._onTapOverlay).call(_context, this));
    // block all touch events (except tap)
    var me = this;
    var events = [
        "tap",
        "doubletap",
        "press",
        "pinch",
        "pan",
        "panstart",
        "panmove",
        "panend"
    ];
    _forEachInstanceProperty(events).call(events, function(event1) {
        me.hammer.on(event1, function(event1) {
            event1.stopPropagation();
        });
    });
    // attach a click event to the window, in order to deactivate when clicking outside the timeline
    if (document && document.body) {
        this.onClick = function(event1) {
            if (!_hasParent(event1.target, container)) me.deactivate();
        };
        document.body.addEventListener("click", this.onClick);
    }
    if (this.keycharm !== undefined) this.keycharm.destroy();
    this.keycharm = keycharm();
    // keycharm listener only bounded when active)
    this.escListener = _bindInstanceProperty$1(_context2 = this.deactivate).call(_context2, this);
}
// turn into an event emitter
Emitter(Activator.prototype);
// The currently active activator
Activator.current = null;
/**
 * Destroy the activator. Cleans up all created DOM and event listeners
 */ Activator.prototype.destroy = function() {
    this.deactivate();
    // remove dom
    this.dom.overlay.parentNode.removeChild(this.dom.overlay);
    // remove global event listener
    if (this.onClick) document.body.removeEventListener("click", this.onClick);
    // remove keycharm
    if (this.keycharm !== undefined) this.keycharm.destroy();
    this.keycharm = null;
    // cleanup hammer instances
    this.hammer.destroy();
    this.hammer = null;
// FIXME: cleaning up hammer instances doesn't work (Timeline not removed from memory)
};
/**
 * Activate the element
 * Overlay is hidden, element is decorated with a blue shadow border
 */ Activator.prototype.activate = function() {
    var _context3;
    // we allow only one active activator at a time
    if (Activator.current) Activator.current.deactivate();
    Activator.current = this;
    this.active = true;
    this.dom.overlay.style.display = "none";
    availableUtils.addClassName(this.dom.container, "vis-active");
    this.emit("change");
    this.emit("activate");
    // ugly hack: bind ESC after emitting the events, as the Network rebinds all
    // keyboard events on a 'change' event
    _bindInstanceProperty$1(_context3 = this.keycharm).call(_context3, "esc", this.escListener);
};
/**
 * Deactivate the element
 * Overlay is displayed on top of the element
 */ Activator.prototype.deactivate = function() {
    if (Activator.current === this) Activator.current = null;
    this.active = false;
    this.dom.overlay.style.display = "";
    availableUtils.removeClassName(this.dom.container, "vis-active");
    this.keycharm.unbind("esc", this.escListener);
    this.emit("change");
    this.emit("deactivate");
};
/**
 * Handle a tap event: activate the container
 * @param {Event}  event   The event
 * @private
 */ Activator.prototype._onTapOverlay = function(event1) {
    // activate the container
    this.activate();
    event1.stopPropagation();
};
/**
 * Test whether the element has the requested parent element somewhere in
 * its chain of parent nodes.
 * @param {HTMLElement} element
 * @param {HTMLElement} parent
 * @returns {boolean} Returns true when the parent is found somewhere in the
 *                    chain of parent nodes.
 * @private
 */ function _hasParent(element, parent) {
    while(element){
        if (element === parent) return true;
        element = element.parentNode;
    }
    return false;
}
/*
 * IMPORTANT: Locales for Moment has to be imported in the legacy and standalone
 * entry points. For the peer build it's users responsibility to do so.
 */ // English
var en = {
    current: "current",
    time: "time",
    deleteSelected: "Delete selected"
};
var en_EN = en;
var en_US = en;
// Italiano
var it = {
    current: "attuale",
    time: "tempo",
    deleteSelected: "Cancella la selezione"
};
var it_IT = it;
var it_CH = it;
// Dutch
var nl = {
    current: "huidige",
    time: "tijd",
    deleteSelected: "Selectie verwijderen"
};
var nl_NL = nl;
var nl_BE = nl;
// German
var de = {
    current: "Aktuelle",
    time: "Zeit",
    deleteSelected: "L\xf6sche Auswahl"
};
var de_DE = de;
// French
var fr = {
    current: "actuel",
    time: "heure",
    deleteSelected: "Effacer la selection"
};
var fr_FR = fr;
var fr_CA = fr;
var fr_BE = fr;
// Espanol
var es = {
    current: "corriente",
    time: "hora",
    deleteSelected: "Eliminar selecci\xf3n"
};
var es_ES = es;
// Ukrainian
var uk = {
    current: "\u043F\u043E\u0442\u043E\u0447\u043D\u0438\u0439",
    time: "\u0447\u0430\u0441",
    deleteSelected: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043E\u0431\u0440\u0430\u043D\u0435"
};
var uk_UA = uk;
// Russian
var ru = {
    current: "\u0442\u0435\u043A\u0443\u0449\u0435\u0435",
    time: "\u0432\u0440\u0435\u043C\u044F",
    deleteSelected: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435"
};
var ru_RU = ru;
// Polish
var pl = {
    current: "aktualny",
    time: "czas",
    deleteSelected: "Usu\u0144 wybrane"
};
var pl_PL = pl;
// Portuguese
var pt = {
    current: "atual",
    time: "data",
    deleteSelected: "Apagar selecionado"
};
var pt_BR = pt;
var pt_PT = pt;
// Japanese
var ja = {
    current: "\u73FE\u5728",
    time: "\u6642\u523B",
    deleteSelected: "\u9078\u629E\u3055\u308C\u305F\u3082\u306E\u3092\u524A\u9664"
};
var ja_JP = ja;
// Swedish
var sv = {
    current: "nuvarande",
    time: "tid",
    deleteSelected: "Radera valda"
};
var sv_SE = sv;
// Norwegian
var nb = {
    current: "n\xe5v\xe6rende",
    time: "tid",
    deleteSelected: "Slett valgte"
};
var nb_NO = nb;
var nn = nb;
var nn_NO = nb;
// Lithuanian
var lt = {
    current: "einamas",
    time: "laikas",
    deleteSelected: "Pa\u0161alinti pasirinkt\u0105"
};
var lt_LT = lt;
var locales = {
    en: en,
    en_EN: en_EN,
    en_US: en_US,
    it: it,
    it_IT: it_IT,
    it_CH: it_CH,
    nl: nl,
    nl_NL: nl_NL,
    nl_BE: nl_BE,
    de: de,
    de_DE: de_DE,
    fr: fr,
    fr_FR: fr_FR,
    fr_CA: fr_CA,
    fr_BE: fr_BE,
    es: es,
    es_ES: es_ES,
    uk: uk,
    uk_UA: uk_UA,
    ru: ru,
    ru_RU: ru_RU,
    pl: pl,
    pl_PL: pl_PL,
    pt: pt,
    pt_BR: pt_BR,
    pt_PT: pt_PT,
    ja: ja,
    ja_JP: ja_JP,
    lt: lt,
    lt_LT: lt_LT,
    sv: sv,
    sv_SE: sv_SE,
    nb: nb,
    nn: nn,
    nb_NO: nb_NO,
    nn_NO: nn_NO
};
var css_248z$c = ".vis-custom-time {\n  background-color: #6E94FF;\n  width: 2px;\n  cursor: move;\n  z-index: 1;\n}\n\n.vis-custom-time > .vis-custom-time-marker {\n  background-color: inherit;\n  color: white;\n  font-size: 12px;\n  white-space: nowrap;\n  padding: 3px 5px;\n  top: 0px;\n  cursor: initial;\n  z-index: inherit;\n}";
styleInject(css_248z$c);
function _createSuper$a(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$a();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$a() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/** A custom time bar */ var CustomTime = /*#__PURE__*/ function(_Component) {
    _inherits(CustomTime, _Component);
    var _super = _createSuper$a(CustomTime);
    /**
  * @param {{range: Range, dom: Object}} body
  * @param {Object} [options]        Available parameters:
  *                                  {number | string} id
  *                                  {string} locales
  *                                  {string} locale
  * @constructor CustomTime
  * @extends Component
  */ function CustomTime(body, options) {
        var _context;
        var _this;
        _classCallCheck(this, CustomTime);
        _this = _super.call(this);
        _this.body = body;
        // default options
        _this.defaultOptions = {
            moment: moment$4,
            locales: locales,
            locale: "en",
            id: undefined,
            title: undefined
        };
        _this.options = availableUtils.extend({}, _this.defaultOptions);
        _this.setOptions(options);
        _this.options.locales = availableUtils.extend({}, locales, _this.options.locales);
        var defaultLocales = _this.defaultOptions.locales[_this.defaultOptions.locale];
        _forEachInstanceProperty(_context = _Object$keys(_this.options.locales)).call(_context, function(locale) {
            _this.options.locales[locale] = availableUtils.extend({}, defaultLocales, _this.options.locales[locale]);
        });
        if (options && options.time != null) _this.customTime = options.time;
        else _this.customTime = new Date();
        _this.eventParams = {}; // stores state parameters while dragging the bar
        // create the DOM
        _this._create();
        return _this;
    }
    /**
   * Set options for the component. Options will be merged in current options.
   * @param {Object} options  Available parameters:
   *                                  {number | string} id
   *                                  {string} locales
   *                                  {string} locale
   */ _createClass(CustomTime, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options) // copy all options that we know
                availableUtils.selectiveExtend([
                    "moment",
                    "locale",
                    "locales",
                    "id",
                    "title",
                    "rtl",
                    "snap"
                ], this.options, options);
            }
        },
        {
            key: "_create",
            value: function _create() {
                var _context2, _context3, _context4;
                var bar = document.createElement("div");
                bar["custom-time"] = this;
                bar.className = "vis-custom-time ".concat(this.options.id || "");
                bar.style.position = "absolute";
                bar.style.top = "0px";
                bar.style.height = "100%";
                this.bar = bar;
                var drag = document.createElement("div");
                drag.style.position = "relative";
                drag.style.top = "0px";
                if (this.options.rtl) drag.style.right = "-10px";
                else drag.style.left = "-10px";
                drag.style.height = "100%";
                drag.style.width = "20px";
                /**
       *
       * @param {WheelEvent} e
       */ function onMouseWheel(e) {
                    this.body.range._onMouseWheel(e);
                }
                if (drag.addEventListener) {
                    // IE9, Chrome, Safari, Opera
                    drag.addEventListener("mousewheel", _bindInstanceProperty$1(onMouseWheel).call(onMouseWheel, this), false);
                    // Firefox
                    drag.addEventListener("DOMMouseScroll", _bindInstanceProperty$1(onMouseWheel).call(onMouseWheel, this), false);
                } else // IE 6/7/8
                drag.attachEvent("onmousewheel", _bindInstanceProperty$1(onMouseWheel).call(onMouseWheel, this));
                bar.appendChild(drag);
                // attach event listeners
                this.hammer = new Hammer(drag);
                this.hammer.on("panstart", _bindInstanceProperty$1(_context2 = this._onDragStart).call(_context2, this));
                this.hammer.on("panmove", _bindInstanceProperty$1(_context3 = this._onDrag).call(_context3, this));
                this.hammer.on("panend", _bindInstanceProperty$1(_context4 = this._onDragEnd).call(_context4, this));
                this.hammer.get("pan").set({
                    threshold: 5,
                    direction: Hammer.DIRECTION_ALL
                });
                // delay addition on item click for trackpads...
                this.hammer.get("press").set({
                    time: 10000
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.hide();
                this.hammer.destroy();
                this.hammer = null;
                this.body = null;
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                var parent = this.body.dom.backgroundVertical;
                if (this.bar.parentNode != parent) {
                    // attach to the dom
                    if (this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
                    parent.appendChild(this.bar);
                }
                var x = this.body.util.toScreen(this.customTime);
                var locale = this.options.locales[this.options.locale];
                if (!locale) {
                    if (!this.warned) {
                        console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization"));
                        this.warned = true;
                    }
                    locale = this.options.locales["en"]; // fall back on english when not available
                }
                var title = this.options.title;
                // To hide the title completely use empty string ''.
                if (title === undefined) {
                    var _context5;
                    title = _concatInstanceProperty(_context5 = "".concat(locale.time, ": ")).call(_context5, this.options.moment(this.customTime).format("dddd, MMMM Do YYYY, H:mm:ss"));
                    title = title.charAt(0).toUpperCase() + title.substring(1);
                } else if (typeof title === "function") title = title.call(this, this.customTime);
                this.options.rtl ? this.bar.style.right = "".concat(x, "px") : this.bar.style.left = "".concat(x, "px");
                this.bar.title = title;
                return false;
            }
        },
        {
            key: "hide",
            value: function hide() {
                // remove the line from the DOM
                if (this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
            }
        },
        {
            key: "setCustomTime",
            value: function setCustomTime(time) {
                this.customTime = availableUtils.convert(time, "Date");
                this.redraw();
            }
        },
        {
            key: "getCustomTime",
            value: function getCustomTime() {
                return new Date(this.customTime.valueOf());
            }
        },
        {
            key: "setCustomMarker",
            value: function setCustomMarker(title, editable) {
                if (this.marker) this.bar.removeChild(this.marker);
                this.marker = document.createElement("div");
                this.marker.className = "vis-custom-time-marker";
                this.marker.innerHTML = availableUtils.xss(title);
                this.marker.style.position = "absolute";
                if (editable) {
                    var _context6, _context7;
                    this.marker.setAttribute("contenteditable", "true");
                    this.marker.addEventListener("pointerdown", function() {
                        this.marker.focus();
                    });
                    this.marker.addEventListener("input", _bindInstanceProperty$1(_context6 = this._onMarkerChange).call(_context6, this));
                    // The editable div element has no change event, so here emulates the change event.
                    this.marker.title = title;
                    this.marker.addEventListener("blur", _bindInstanceProperty$1(_context7 = function _context7(event1) {
                        if (this.title != event1.target.innerHTML) {
                            this._onMarkerChanged(event1);
                            this.title = event1.target.innerHTML;
                        }
                    }).call(_context7, this));
                }
                this.bar.appendChild(this.marker);
            }
        },
        {
            key: "setCustomTitle",
            value: function setCustomTitle(title) {
                this.options.title = title;
            }
        },
        {
            key: "_onDragStart",
            value: function _onDragStart(event1) {
                this.eventParams.dragging = true;
                this.eventParams.customTime = this.customTime;
                event1.stopPropagation();
            }
        },
        {
            key: "_onDrag",
            value: function _onDrag(event1) {
                if (!this.eventParams.dragging) return;
                var deltaX = this.options.rtl ? -1 * event1.deltaX : event1.deltaX;
                var x = this.body.util.toScreen(this.eventParams.customTime) + deltaX;
                var time = this.body.util.toTime(x);
                var scale = this.body.util.getScale();
                var step = this.body.util.getStep();
                var snap = this.options.snap;
                var snappedTime = snap ? snap(time, scale, step) : time;
                this.setCustomTime(snappedTime);
                // fire a timechange event
                this.body.emitter.emit("timechange", {
                    id: this.options.id,
                    time: new Date(this.customTime.valueOf()),
                    event: event1
                });
                event1.stopPropagation();
            }
        },
        {
            key: "_onDragEnd",
            value: function _onDragEnd(event1) {
                if (!this.eventParams.dragging) return;
                // fire a timechanged event
                this.body.emitter.emit("timechanged", {
                    id: this.options.id,
                    time: new Date(this.customTime.valueOf()),
                    event: event1
                });
                event1.stopPropagation();
            }
        },
        {
            key: "_onMarkerChange",
            value: function _onMarkerChange(event1) {
                this.body.emitter.emit("markerchange", {
                    id: this.options.id,
                    title: event1.target.innerHTML,
                    event: event1
                });
                event1.stopPropagation();
            }
        },
        {
            key: "_onMarkerChanged",
            value: function _onMarkerChanged(event1) {
                this.body.emitter.emit("markerchanged", {
                    id: this.options.id,
                    title: event1.target.innerHTML,
                    event: event1
                });
                event1.stopPropagation();
            }
        }
    ], [
        {
            key: "customTimeFromTarget",
            value: function customTimeFromTarget(event1) {
                var target = event1.target;
                while(target){
                    if (target.hasOwnProperty("custom-time")) return target["custom-time"];
                    target = target.parentNode;
                }
                return null;
            }
        }
    ]);
    return CustomTime;
}(Component);
var css_248z$b = ".vis-timeline {\n  /*\n  -webkit-transition: height .4s ease-in-out;\n  transition:         height .4s ease-in-out;\n  */\n}\n\n.vis-panel {\n  /*\n  -webkit-transition: height .4s ease-in-out, top .4s ease-in-out;\n  transition:         height .4s ease-in-out, top .4s ease-in-out;\n  */\n}\n\n.vis-axis {\n  /*\n  -webkit-transition: top .4s ease-in-out;\n  transition:         top .4s ease-in-out;\n  */\n}\n\n/* TODO: get animation working nicely\n\n.vis-item {\n  -webkit-transition: top .4s ease-in-out;\n  transition:         top .4s ease-in-out;\n}\n\n.vis-item.line {\n  -webkit-transition: height .4s ease-in-out, top .4s ease-in-out;\n  transition:         height .4s ease-in-out, top .4s ease-in-out;\n}\n/**/";
styleInject(css_248z$b);
var css_248z$a = '.vis-current-time {\n  background-color: #FF7F6E;\n  width: 2px;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.vis-rolling-mode-btn {\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  top: 7px;\n  right: 20px;\n  border-radius: 50%;\n  font-size: 28px;\n  cursor: pointer;\n  opacity: 0.8;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n  background: #3876c2;\n}\n.vis-rolling-mode-btn:before {\n  content: "\\26F6";\n}\n\n.vis-rolling-mode-btn:hover {\n  opacity: 1;\n}';
styleInject(css_248z$a);
var css_248z$9 = ".vis-panel {\n  position: absolute;\n\n  padding: 0;\n  margin: 0;\n\n  box-sizing: border-box;\n}\n\n.vis-panel.vis-center,\n.vis-panel.vis-left,\n.vis-panel.vis-right,\n.vis-panel.vis-top,\n.vis-panel.vis-bottom {\n  border: 1px #bfbfbf;\n}\n\n.vis-panel.vis-center,\n.vis-panel.vis-left,\n.vis-panel.vis-right {\n  border-top-style: solid;\n  border-bottom-style: solid;\n  overflow: hidden;\n}\n\n.vis-left.vis-panel.vis-vertical-scroll, .vis-right.vis-panel.vis-vertical-scroll {\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: scroll;\n} \n\n.vis-left.vis-panel.vis-vertical-scroll {\n  direction: rtl;\n}\n\n.vis-left.vis-panel.vis-vertical-scroll .vis-content {\n  direction: ltr;\n}\n\n.vis-right.vis-panel.vis-vertical-scroll {\n  direction: ltr;\n}\n\n.vis-right.vis-panel.vis-vertical-scroll .vis-content {\n  direction: rtl;\n}\n\n.vis-panel.vis-center,\n.vis-panel.vis-top,\n.vis-panel.vis-bottom {\n  border-left-style: solid;\n  border-right-style: solid;\n}\n\n.vis-background {\n  overflow: hidden;\n}\n\n.vis-panel > .vis-content {\n  position: relative;\n}\n\n.vis-panel .vis-shadow {\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  box-shadow: 0 0 10px rgba(0,0,0,0.8);\n  /* TODO: find a nice way to ensure vis-shadows are drawn on top of items\n  z-index: 1;\n  */\n}\n\n.vis-panel .vis-shadow.vis-top {\n  top: -1px;\n  left: 0;\n}\n\n.vis-panel .vis-shadow.vis-bottom {\n  bottom: -1px;\n  left: 0;\n}";
styleInject(css_248z$9);
var css_248z$8 = ".vis-graph-group0 {\n    fill:#4f81bd;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #4f81bd;\n}\n\n.vis-graph-group1 {\n    fill:#f79646;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #f79646;\n}\n\n.vis-graph-group2 {\n    fill: #8c51cf;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #8c51cf;\n}\n\n.vis-graph-group3 {\n    fill: #75c841;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #75c841;\n}\n\n.vis-graph-group4 {\n    fill: #ff0100;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #ff0100;\n}\n\n.vis-graph-group5 {\n    fill: #37d8e6;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #37d8e6;\n}\n\n.vis-graph-group6 {\n    fill: #042662;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #042662;\n}\n\n.vis-graph-group7 {\n    fill:#00ff26;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #00ff26;\n}\n\n.vis-graph-group8 {\n    fill:#ff00ff;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #ff00ff;\n}\n\n.vis-graph-group9 {\n    fill: #8f3938;\n    fill-opacity:0;\n    stroke-width:2px;\n    stroke: #8f3938;\n}\n\n.vis-timeline .vis-fill {\n    fill-opacity:0.1;\n    stroke: none;\n}\n\n\n.vis-timeline .vis-bar {\n    fill-opacity:0.5;\n    stroke-width:1px;\n}\n\n.vis-timeline .vis-point {\n    stroke-width:2px;\n    fill-opacity:1.0;\n}\n\n\n.vis-timeline .vis-legend-background {\n    stroke-width:1px;\n    fill-opacity:0.9;\n    fill: #ffffff;\n    stroke: #c2c2c2;\n}\n\n\n.vis-timeline .vis-outline {\n    stroke-width:1px;\n    fill-opacity:1;\n    fill: #ffffff;\n    stroke: #e5e5e5;\n}\n\n.vis-timeline .vis-icon-fill {\n    fill-opacity:0.3;\n    stroke: none;\n}\n";
styleInject(css_248z$8);
var css_248z$7 = "\n.vis-timeline {\n  position: relative;\n  border: 1px solid #bfbfbf;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.vis-loading-screen {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}";
styleInject(css_248z$7);
var css_248z$6 = '/* override some bootstrap styles screwing up the timelines css */\n\n.vis [class*="span"] {\n  min-height: 0;\n  width: auto;\n}\n';
styleInject(css_248z$6);
/**
 * Create a timeline visualization
 * @constructor Core
 */ var Core = /*#__PURE__*/ function() {
    function Core() {
        _classCallCheck(this, Core);
    }
    _createClass(Core, [
        {
            key: "_create",
            value: /**
     * Create the main DOM for the Core: a root panel containing left, right,
     * top, bottom, content, and background panel.
     * @param {Element} container  The container element where the Core will
     *                             be attached.
     * @protected
     */ function _create(container) {
                var _this = this, _context, _context2, _context3;
                this.dom = {};
                this.dom.container = container;
                this.dom.container.style.position = "relative";
                this.dom.root = document.createElement("div");
                this.dom.background = document.createElement("div");
                this.dom.backgroundVertical = document.createElement("div");
                this.dom.backgroundHorizontal = document.createElement("div");
                this.dom.centerContainer = document.createElement("div");
                this.dom.leftContainer = document.createElement("div");
                this.dom.rightContainer = document.createElement("div");
                this.dom.center = document.createElement("div");
                this.dom.left = document.createElement("div");
                this.dom.right = document.createElement("div");
                this.dom.top = document.createElement("div");
                this.dom.bottom = document.createElement("div");
                this.dom.shadowTop = document.createElement("div");
                this.dom.shadowBottom = document.createElement("div");
                this.dom.shadowTopLeft = document.createElement("div");
                this.dom.shadowBottomLeft = document.createElement("div");
                this.dom.shadowTopRight = document.createElement("div");
                this.dom.shadowBottomRight = document.createElement("div");
                this.dom.rollingModeBtn = document.createElement("div");
                this.dom.loadingScreen = document.createElement("div");
                this.dom.root.className = "vis-timeline";
                this.dom.background.className = "vis-panel vis-background";
                this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical";
                this.dom.backgroundHorizontal.className = "vis-panel vis-background vis-horizontal";
                this.dom.centerContainer.className = "vis-panel vis-center";
                this.dom.leftContainer.className = "vis-panel vis-left";
                this.dom.rightContainer.className = "vis-panel vis-right";
                this.dom.top.className = "vis-panel vis-top";
                this.dom.bottom.className = "vis-panel vis-bottom";
                this.dom.left.className = "vis-content";
                this.dom.center.className = "vis-content";
                this.dom.right.className = "vis-content";
                this.dom.shadowTop.className = "vis-shadow vis-top";
                this.dom.shadowBottom.className = "vis-shadow vis-bottom";
                this.dom.shadowTopLeft.className = "vis-shadow vis-top";
                this.dom.shadowBottomLeft.className = "vis-shadow vis-bottom";
                this.dom.shadowTopRight.className = "vis-shadow vis-top";
                this.dom.shadowBottomRight.className = "vis-shadow vis-bottom";
                this.dom.rollingModeBtn.className = "vis-rolling-mode-btn";
                this.dom.loadingScreen.className = "vis-loading-screen";
                this.dom.root.appendChild(this.dom.background);
                this.dom.root.appendChild(this.dom.backgroundVertical);
                this.dom.root.appendChild(this.dom.backgroundHorizontal);
                this.dom.root.appendChild(this.dom.centerContainer);
                this.dom.root.appendChild(this.dom.leftContainer);
                this.dom.root.appendChild(this.dom.rightContainer);
                this.dom.root.appendChild(this.dom.top);
                this.dom.root.appendChild(this.dom.bottom);
                this.dom.root.appendChild(this.dom.rollingModeBtn);
                this.dom.centerContainer.appendChild(this.dom.center);
                this.dom.leftContainer.appendChild(this.dom.left);
                this.dom.rightContainer.appendChild(this.dom.right);
                this.dom.centerContainer.appendChild(this.dom.shadowTop);
                this.dom.centerContainer.appendChild(this.dom.shadowBottom);
                this.dom.leftContainer.appendChild(this.dom.shadowTopLeft);
                this.dom.leftContainer.appendChild(this.dom.shadowBottomLeft);
                this.dom.rightContainer.appendChild(this.dom.shadowTopRight);
                this.dom.rightContainer.appendChild(this.dom.shadowBottomRight);
                // size properties of each of the panels
                this.props = {
                    root: {},
                    background: {},
                    centerContainer: {},
                    leftContainer: {},
                    rightContainer: {},
                    center: {},
                    left: {},
                    right: {},
                    top: {},
                    bottom: {},
                    border: {},
                    scrollTop: 0,
                    scrollTopMin: 0
                };
                this.on("rangechange", function() {
                    if (_this.initialDrawDone === true) _this._redraw();
                });
                this.on("rangechanged", function() {
                    if (!_this.initialRangeChangeDone) _this.initialRangeChangeDone = true;
                });
                this.on("touch", _bindInstanceProperty$1(_context = this._onTouch).call(_context, this));
                this.on("panmove", _bindInstanceProperty$1(_context2 = this._onDrag).call(_context2, this));
                var me = this;
                this._origRedraw = _bindInstanceProperty$1(_context3 = this._redraw).call(_context3, this);
                this._redraw = availableUtils.throttle(this._origRedraw);
                this.on("_change", function(properties) {
                    if (me.itemSet && me.itemSet.initialItemSetDrawn && properties && properties.queue == true) me._redraw();
                    else me._origRedraw();
                });
                // create event listeners for all interesting events, these events will be
                // emitted via emitter
                this.hammer = new Hammer(this.dom.root);
                var pinchRecognizer = this.hammer.get("pinch").set({
                    enable: true
                });
                pinchRecognizer && disablePreventDefaultVertically(pinchRecognizer);
                this.hammer.get("pan").set({
                    threshold: 5,
                    direction: Hammer.DIRECTION_ALL
                });
                this.timelineListeners = {};
                var events = [
                    "tap",
                    "doubletap",
                    "press",
                    "pinch",
                    "pan",
                    "panstart",
                    "panmove",
                    "panend"
                ];
                _forEachInstanceProperty(events).call(events, function(type) {
                    var listener = function listener(event1) {
                        if (me.isActive()) me.emit(type, event1);
                    };
                    me.hammer.on(type, listener);
                    me.timelineListeners[type] = listener;
                });
                // emulate a touch event (emitted before the start of a pan, pinch, tap, or press)
                onTouch(this.hammer, function(event1) {
                    me.emit("touch", event1);
                });
                // emulate a release event (emitted after a pan, pinch, tap, or press)
                onRelease(this.hammer, function(event1) {
                    me.emit("release", event1);
                });
                /**
       *
       * @param {WheelEvent} event
       */ function onMouseWheel(event1) {
                    // Reasonable default wheel deltas
                    var LINE_HEIGHT = 40;
                    var PAGE_HEIGHT = 800;
                    if (this.isActive()) this.emit("mousewheel", event1);
                    // deltaX and deltaY normalization from jquery.mousewheel.js
                    var deltaX = 0;
                    var deltaY = 0;
                    // Old school scrollwheel delta
                    if ("detail" in event1) deltaY = event1.detail * -1;
                    if ("wheelDelta" in event1) deltaY = event1.wheelDelta;
                    if ("wheelDeltaY" in event1) deltaY = event1.wheelDeltaY;
                    if ("wheelDeltaX" in event1) deltaX = event1.wheelDeltaX * -1;
                    // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
                    if ("axis" in event1 && event1.axis === event1.HORIZONTAL_AXIS) {
                        deltaX = deltaY * -1;
                        deltaY = 0;
                    }
                    // New school wheel delta (wheel event)
                    if ("deltaY" in event1) deltaY = event1.deltaY * -1;
                    if ("deltaX" in event1) deltaX = event1.deltaX;
                    // Normalize deltas
                    if (event1.deltaMode) {
                        if (event1.deltaMode === 1) {
                            // delta in LINE units
                            deltaX *= LINE_HEIGHT;
                            deltaY *= LINE_HEIGHT;
                        } else {
                            // delta in PAGE units
                            deltaX *= LINE_HEIGHT;
                            deltaY *= PAGE_HEIGHT;
                        }
                    }
                    // Prevent scrolling when zooming (no zoom key, or pressing zoom key)
                    if (this.options.preferZoom) {
                        if (!this.options.zoomKey || event1[this.options.zoomKey]) return;
                    } else {
                        if (this.options.zoomKey && event1[this.options.zoomKey]) return;
                    }
                    // Don't preventDefault if you can't scroll
                    if (!this.options.verticalScroll && !this.options.horizontalScroll) return;
                    if (this.options.verticalScroll && Math.abs(deltaY) >= Math.abs(deltaX)) {
                        var current = this.props.scrollTop;
                        var adjusted = current + deltaY;
                        if (this.isActive()) {
                            var newScrollTop = this._setScrollTop(adjusted);
                            if (newScrollTop !== current) {
                                this._redraw();
                                this.emit("scroll", event1);
                                // Prevent default actions caused by mouse wheel
                                // (else the page and timeline both scroll)
                                event1.preventDefault();
                            }
                        }
                    } else if (this.options.horizontalScroll) {
                        var delta = Math.abs(deltaX) >= Math.abs(deltaY) ? deltaX : deltaY;
                        // calculate a single scroll jump relative to the range scale
                        var diff = delta / 120 * (this.range.end - this.range.start) / 20;
                        // calculate new start and end
                        var newStart = this.range.start + diff;
                        var newEnd = this.range.end + diff;
                        var options = {
                            animation: false,
                            byUser: true,
                            event: event1
                        };
                        this.range.setRange(newStart, newEnd, options);
                        event1.preventDefault();
                    }
                }
                // Add modern wheel event listener
                var wheelType = "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
                document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
                // DOMMouseScroll - Older Firefox versions use "DOMMouseScroll"
                // onmousewheel - All the use "onmousewheel"
                this.dom.centerContainer.addEventListener ? "DOMMouseScroll" : "onmousewheel";
                this.dom.top.addEventListener;
                this.dom.bottom.addEventListener;
                this.dom.centerContainer.addEventListener(wheelType, _bindInstanceProperty$1(onMouseWheel).call(onMouseWheel, this), false);
                this.dom.top.addEventListener(wheelType, _bindInstanceProperty$1(onMouseWheel).call(onMouseWheel, this), false);
                this.dom.bottom.addEventListener(wheelType, _bindInstanceProperty$1(onMouseWheel).call(onMouseWheel, this), false);
                /**
       *
       * @param {scroll} event
       */ function onMouseScrollSide(event1) {
                    if (!me.options.verticalScroll) return;
                    event1.preventDefault();
                    if (me.isActive()) {
                        var adjusted = -event1.target.scrollTop;
                        me._setScrollTop(adjusted);
                        me._redraw();
                        me.emit("scrollSide", event1);
                    }
                }
                this.dom.left.parentNode.addEventListener("scroll", _bindInstanceProperty$1(onMouseScrollSide).call(onMouseScrollSide, this));
                this.dom.right.parentNode.addEventListener("scroll", _bindInstanceProperty$1(onMouseScrollSide).call(onMouseScrollSide, this));
                var itemAddedToTimeline = false;
                /**
       *
       * @param {dragover} event
       * @returns {boolean}
       */ function handleDragOver(event1) {
                    var _context4;
                    if (event1.preventDefault) {
                        me.emit("dragover", me.getEventProperties(event1));
                        event1.preventDefault(); // Necessary. Allows us to drop.
                    }
                    // make sure your target is a timeline element
                    if (!(_indexOfInstanceProperty(_context4 = event1.target.className).call(_context4, "timeline") > -1)) return;
                    // make sure only one item is added every time you're over the timeline
                    if (itemAddedToTimeline) return;
                    event1.dataTransfer.dropEffect = "move";
                    itemAddedToTimeline = true;
                    return false;
                }
                /**
       *
       * @param {drop} event
       * @returns {boolean}
       */ function handleDrop(event1) {
                    // prevent redirect to blank page - Firefox
                    if (event1.preventDefault) event1.preventDefault();
                    if (event1.stopPropagation) event1.stopPropagation();
                    // return when dropping non-timeline items
                    try {
                        var itemData = JSON.parse(event1.dataTransfer.getData("text"));
                        if (!itemData || !itemData.content) return;
                    } catch (err) {
                        return false;
                    }
                    itemAddedToTimeline = false;
                    event1.center = {
                        x: event1.clientX,
                        y: event1.clientY
                    };
                    if (itemData.target !== "item") me.itemSet._onAddItem(event1);
                    else me.itemSet._onDropObjectOnItem(event1);
                    me.emit("drop", me.getEventProperties(event1));
                    return false;
                }
                this.dom.center.addEventListener("dragover", _bindInstanceProperty$1(handleDragOver).call(handleDragOver, this), false);
                this.dom.center.addEventListener("drop", _bindInstanceProperty$1(handleDrop).call(handleDrop, this), false);
                this.customTimes = [];
                // store state information needed for touch events
                this.touch = {};
                this.redrawCount = 0;
                this.initialDrawDone = false;
                this.initialRangeChangeDone = false;
                // attach the root panel to the provided container
                if (!container) throw new Error("No container provided");
                container.appendChild(this.dom.root);
                container.appendChild(this.dom.loadingScreen);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _context7;
                if (options) {
                    // copy the known options
                    var fields = [
                        "width",
                        "height",
                        "minHeight",
                        "maxHeight",
                        "autoResize",
                        "start",
                        "end",
                        "clickToUse",
                        "dataAttributes",
                        "hiddenDates",
                        "locale",
                        "locales",
                        "moment",
                        "preferZoom",
                        "rtl",
                        "zoomKey",
                        "horizontalScroll",
                        "verticalScroll",
                        "longSelectPressTime",
                        "snap"
                    ];
                    availableUtils.selectiveExtend(fields, this.options, options);
                    this.dom.rollingModeBtn.style.visibility = "hidden";
                    if (this.options.rtl) {
                        this.dom.container.style.direction = "rtl";
                        this.dom.backgroundVertical.className = "vis-panel vis-background vis-vertical-rtl";
                    }
                    if (this.options.verticalScroll) {
                        if (this.options.rtl) this.dom.rightContainer.className = "vis-panel vis-right vis-vertical-scroll";
                        else this.dom.leftContainer.className = "vis-panel vis-left vis-vertical-scroll";
                    }
                    if (_typeof$1(this.options.orientation) !== "object") this.options.orientation = {
                        item: undefined,
                        axis: undefined
                    };
                    if ("orientation" in options) {
                        if (typeof options.orientation === "string") this.options.orientation = {
                            item: options.orientation,
                            axis: options.orientation
                        };
                        else if (_typeof$1(options.orientation) === "object") {
                            if ("item" in options.orientation) this.options.orientation.item = options.orientation.item;
                            if ("axis" in options.orientation) this.options.orientation.axis = options.orientation.axis;
                        }
                    }
                    if (this.options.orientation.axis === "both") {
                        if (!this.timeAxis2) {
                            var timeAxis2 = this.timeAxis2 = new TimeAxis(this.body, this.options);
                            timeAxis2.setOptions = function(options) {
                                var _options = options ? availableUtils.extend({}, options) : {};
                                _options.orientation = "top"; // override the orientation option, always top
                                TimeAxis.prototype.setOptions.call(timeAxis2, _options);
                            };
                            this.components.push(timeAxis2);
                        }
                    } else if (this.timeAxis2) {
                        var _context5;
                        var index = _indexOfInstanceProperty(_context5 = this.components).call(_context5, this.timeAxis2);
                        if (index !== -1) {
                            var _context6;
                            _spliceInstanceProperty(_context6 = this.components).call(_context6, index, 1);
                        }
                        this.timeAxis2.destroy();
                        this.timeAxis2 = null;
                    }
                    // if the graph2d's drawPoints is a function delegate the callback to the onRender property
                    if (typeof options.drawPoints == "function") options.drawPoints = {
                        onRender: options.drawPoints
                    };
                    if ("hiddenDates" in this.options) convertHiddenOptions(this.options.moment, this.body, this.options.hiddenDates);
                    if ("clickToUse" in options) {
                        if (options.clickToUse) {
                            if (!this.activator) this.activator = new Activator(this.dom.root);
                        } else if (this.activator) {
                            this.activator.destroy();
                            delete this.activator;
                        }
                    }
                    // enable/disable autoResize
                    this._initAutoResize();
                }
                // propagate options to all components
                _forEachInstanceProperty(_context7 = this.components).call(_context7, function(component) {
                    return component.setOptions(options);
                });
                // enable/disable configure
                if ("configure" in options) {
                    var _context8;
                    if (!this.configurator) this.configurator = this._createConfigurator();
                    this.configurator.setOptions(options.configure);
                    // collect the settings of all components, and pass them to the configuration system
                    var appliedOptions = availableUtils.deepExtend({}, this.options);
                    _forEachInstanceProperty(_context8 = this.components).call(_context8, function(component) {
                        availableUtils.deepExtend(appliedOptions, component.options);
                    });
                    this.configurator.setModuleOptions({
                        global: appliedOptions
                    });
                }
                this._redraw();
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return !this.activator || this.activator.active;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _context9;
                // unbind datasets
                this.setItems(null);
                this.setGroups(null);
                // remove all event listeners
                this.off();
                // stop checking for changed size
                this._stopAutoResize();
                // remove from DOM
                if (this.dom.root.parentNode) this.dom.root.parentNode.removeChild(this.dom.root);
                this.dom = null;
                // remove Activator
                if (this.activator) {
                    this.activator.destroy();
                    delete this.activator;
                }
                // cleanup hammer touch events
                for(var event1 in this.timelineListeners)if (this.timelineListeners.hasOwnProperty(event1)) delete this.timelineListeners[event1];
                this.timelineListeners = null;
                this.hammer && this.hammer.destroy();
                this.hammer = null;
                // give all components the opportunity to cleanup
                _forEachInstanceProperty(_context9 = this.components).call(_context9, function(component) {
                    return component.destroy();
                });
                this.body = null;
            }
        },
        {
            key: "setCustomTime",
            value: function setCustomTime(time, id) {
                var _context10;
                var customTimes = _filterInstanceProperty(_context10 = this.customTimes).call(_context10, function(component) {
                    return id === component.options.id;
                });
                if (customTimes.length === 0) throw new Error("No custom time bar found with id ".concat(_JSON$stringify(id)));
                if (customTimes.length > 0) customTimes[0].setCustomTime(time);
            }
        },
        {
            key: "getCustomTime",
            value: function getCustomTime(id) {
                var _context11;
                var customTimes = _filterInstanceProperty(_context11 = this.customTimes).call(_context11, function(component) {
                    return component.options.id === id;
                });
                if (customTimes.length === 0) throw new Error("No custom time bar found with id ".concat(_JSON$stringify(id)));
                return customTimes[0].getCustomTime();
            }
        },
        {
            key: "setCustomTimeMarker",
            value: function setCustomTimeMarker(title, id, editable) {
                var _context12;
                var customTimes = _filterInstanceProperty(_context12 = this.customTimes).call(_context12, function(component) {
                    return component.options.id === id;
                });
                if (customTimes.length === 0) throw new Error("No custom time bar found with id ".concat(_JSON$stringify(id)));
                if (customTimes.length > 0) customTimes[0].setCustomMarker(title, editable);
            }
        },
        {
            key: "setCustomTimeTitle",
            value: function setCustomTimeTitle(title, id) {
                var _context13;
                var customTimes = _filterInstanceProperty(_context13 = this.customTimes).call(_context13, function(component) {
                    return component.options.id === id;
                });
                if (customTimes.length === 0) throw new Error("No custom time bar found with id ".concat(_JSON$stringify(id)));
                if (customTimes.length > 0) return customTimes[0].setCustomTitle(title);
            }
        },
        {
            key: "getEventProperties",
            value: function getEventProperties(event1) {
                return {
                    event: event1
                };
            }
        },
        {
            key: "addCustomTime",
            value: function addCustomTime(time, id) {
                var _context14;
                var timestamp = time !== undefined ? availableUtils.convert(time, "Date") : new Date();
                var exists = _someInstanceProperty(_context14 = this.customTimes).call(_context14, function(customTime) {
                    return customTime.options.id === id;
                });
                if (exists) throw new Error("A custom time with id ".concat(_JSON$stringify(id), " already exists"));
                var customTime = new CustomTime(this.body, availableUtils.extend({}, this.options, {
                    time: timestamp,
                    id: id,
                    snap: this.itemSet ? this.itemSet.options.snap : this.options.snap
                }));
                this.customTimes.push(customTime);
                this.components.push(customTime);
                this._redraw();
                return id;
            }
        },
        {
            key: "removeCustomTime",
            value: function removeCustomTime(id) {
                var _context15, _this2 = this;
                var customTimes = _filterInstanceProperty(_context15 = this.customTimes).call(_context15, function(bar) {
                    return bar.options.id === id;
                });
                if (customTimes.length === 0) throw new Error("No custom time bar found with id ".concat(_JSON$stringify(id)));
                _forEachInstanceProperty(customTimes).call(customTimes, function(customTime) {
                    var _context16, _context17, _context18, _context19;
                    _spliceInstanceProperty(_context16 = _this2.customTimes).call(_context16, _indexOfInstanceProperty(_context17 = _this2.customTimes).call(_context17, customTime), 1);
                    _spliceInstanceProperty(_context18 = _this2.components).call(_context18, _indexOfInstanceProperty(_context19 = _this2.components).call(_context19, customTime), 1);
                    customTime.destroy();
                });
            }
        },
        {
            key: "getVisibleItems",
            value: function getVisibleItems() {
                return this.itemSet && this.itemSet.getVisibleItems() || [];
            }
        },
        {
            key: "getItemsAtCurrentTime",
            value: function getItemsAtCurrentTime(timeOfEvent) {
                this.time = timeOfEvent;
                return this.itemSet && this.itemSet.getItemsAtCurrentTime(this.time) || [];
            }
        },
        {
            key: "getVisibleGroups",
            value: function getVisibleGroups() {
                return this.itemSet && this.itemSet.getVisibleGroups() || [];
            }
        },
        {
            key: "fit",
            value: function fit(options, callback) {
                var range = this.getDataRange();
                // skip range set if there is no min and max date
                if (range.min === null && range.max === null) return;
                // apply a margin of 1% left and right of the data
                var interval = range.max - range.min;
                var min = new Date(range.min.valueOf() - interval * 0.01);
                var max = new Date(range.max.valueOf() + interval * 0.01);
                var animation = options && options.animation !== undefined ? options.animation : true;
                this.range.setRange(min, max, {
                    animation: animation
                }, callback);
            }
        },
        {
            key: "getDataRange",
            value: function getDataRange() {
                // must be implemented by Timeline and Graph2d
                throw new Error("Cannot invoke abstract method getDataRange");
            }
        },
        {
            key: "setWindow",
            value: function setWindow(start, end, options, callback) {
                if (typeof arguments[2] == "function") {
                    callback = arguments[2];
                    options = {};
                }
                var animation;
                var range;
                if (arguments.length == 1) {
                    range = arguments[0];
                    animation = range.animation !== undefined ? range.animation : true;
                    this.range.setRange(range.start, range.end, {
                        animation: animation
                    });
                } else if (arguments.length == 2 && typeof arguments[1] == "function") {
                    range = arguments[0];
                    callback = arguments[1];
                    animation = range.animation !== undefined ? range.animation : true;
                    this.range.setRange(range.start, range.end, {
                        animation: animation
                    }, callback);
                } else {
                    animation = options && options.animation !== undefined ? options.animation : true;
                    this.range.setRange(start, end, {
                        animation: animation
                    }, callback);
                }
            }
        },
        {
            key: "moveTo",
            value: function moveTo(time, options, callback) {
                if (typeof arguments[1] == "function") {
                    callback = arguments[1];
                    options = {};
                }
                var interval = this.range.end - this.range.start;
                var t = availableUtils.convert(time, "Date").valueOf();
                var start = t - interval / 2;
                var end = t + interval / 2;
                var animation = options && options.animation !== undefined ? options.animation : true;
                this.range.setRange(start, end, {
                    animation: animation
                }, callback);
            }
        },
        {
            key: "getWindow",
            value: function getWindow() {
                var range = this.range.getRange();
                return {
                    start: new Date(range.start),
                    end: new Date(range.end)
                };
            }
        },
        {
            key: "zoomIn",
            value: function zoomIn(percentage, options, callback) {
                if (!percentage || percentage < 0 || percentage > 1) return;
                if (typeof arguments[1] == "function") {
                    callback = arguments[1];
                    options = {};
                }
                var range = this.getWindow();
                var start = range.start.valueOf();
                var end = range.end.valueOf();
                var interval = end - start;
                var newInterval = interval / (1 + percentage);
                var distance = (interval - newInterval) / 2;
                var newStart = start + distance;
                var newEnd = end - distance;
                this.setWindow(newStart, newEnd, options, callback);
            }
        },
        {
            key: "zoomOut",
            value: function zoomOut(percentage, options, callback) {
                if (!percentage || percentage < 0 || percentage > 1) return;
                if (typeof arguments[1] == "function") {
                    callback = arguments[1];
                    options = {};
                }
                var range = this.getWindow();
                var start = range.start.valueOf();
                var end = range.end.valueOf();
                var interval = end - start;
                var newStart = start - interval * percentage / 2;
                var newEnd = end + interval * percentage / 2;
                this.setWindow(newStart, newEnd, options, callback);
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                this._redraw();
            }
        },
        {
            key: "_redraw",
            value: function _redraw() {
                var _context20;
                this.redrawCount++;
                var dom = this.dom;
                if (!dom || !dom.container || dom.root.offsetWidth == 0) return; // when destroyed, or invisible
                var resized = false;
                var options = this.options;
                var props = this.props;
                updateHiddenDates(this.options.moment, this.body, this.options.hiddenDates);
                // update class names
                if (options.orientation == "top") {
                    availableUtils.addClassName(dom.root, "vis-top");
                    availableUtils.removeClassName(dom.root, "vis-bottom");
                } else {
                    availableUtils.removeClassName(dom.root, "vis-top");
                    availableUtils.addClassName(dom.root, "vis-bottom");
                }
                if (options.rtl) {
                    availableUtils.addClassName(dom.root, "vis-rtl");
                    availableUtils.removeClassName(dom.root, "vis-ltr");
                } else {
                    availableUtils.addClassName(dom.root, "vis-ltr");
                    availableUtils.removeClassName(dom.root, "vis-rtl");
                }
                // update root width and height options
                dom.root.style.maxHeight = availableUtils.option.asSize(options.maxHeight, "");
                dom.root.style.minHeight = availableUtils.option.asSize(options.minHeight, "");
                dom.root.style.width = availableUtils.option.asSize(options.width, "");
                var rootOffsetWidth = dom.root.offsetWidth;
                // calculate border widths
                props.border.left = 1;
                props.border.right = 1;
                props.border.top = 1;
                props.border.bottom = 1;
                // calculate the heights. If any of the side panels is empty, we set the height to
                // minus the border width, such that the border will be invisible
                props.center.height = dom.center.offsetHeight;
                props.left.height = dom.left.offsetHeight;
                props.right.height = dom.right.offsetHeight;
                props.top.height = dom.top.clientHeight || -props.border.top;
                props.bottom.height = Math.round(dom.bottom.getBoundingClientRect().height) || dom.bottom.clientHeight || -props.border.bottom;
                // TODO: compensate borders when any of the panels is empty.
                // apply auto height
                // TODO: only calculate autoHeight when needed (else we cause an extra reflow/repaint of the DOM)
                var contentHeight = Math.max(props.left.height, props.center.height, props.right.height);
                var autoHeight = props.top.height + contentHeight + props.bottom.height + props.border.top + props.border.bottom;
                dom.root.style.height = availableUtils.option.asSize(options.height, "".concat(autoHeight, "px"));
                // calculate heights of the content panels
                props.root.height = dom.root.offsetHeight;
                props.background.height = props.root.height;
                var containerHeight = props.root.height - props.top.height - props.bottom.height;
                props.centerContainer.height = containerHeight;
                props.leftContainer.height = containerHeight;
                props.rightContainer.height = props.leftContainer.height;
                // calculate the widths of the panels
                props.root.width = rootOffsetWidth;
                props.background.width = props.root.width;
                if (!this.initialDrawDone) props.scrollbarWidth = availableUtils.getScrollBarWidth();
                var leftContainerClientWidth = dom.leftContainer.clientWidth;
                var rightContainerClientWidth = dom.rightContainer.clientWidth;
                if (options.verticalScroll) {
                    if (options.rtl) {
                        props.left.width = leftContainerClientWidth || -props.border.left;
                        props.right.width = rightContainerClientWidth + props.scrollbarWidth || -props.border.right;
                    } else {
                        props.left.width = leftContainerClientWidth + props.scrollbarWidth || -props.border.left;
                        props.right.width = rightContainerClientWidth || -props.border.right;
                    }
                } else {
                    props.left.width = leftContainerClientWidth || -props.border.left;
                    props.right.width = rightContainerClientWidth || -props.border.right;
                }
                this._setDOM();
                // update the scrollTop, feasible range for the offset can be changed
                // when the height of the Core or of the contents of the center changed
                var offset = this._updateScrollTop();
                // reposition the scrollable contents
                if (options.orientation.item != "top") offset += Math.max(props.centerContainer.height - props.center.height - props.border.top - props.border.bottom, 0);
                dom.center.style.transform = "translateY(".concat(offset, "px)");
                // show shadows when vertical scrolling is available
                var visibilityTop = props.scrollTop == 0 ? "hidden" : "";
                var visibilityBottom = props.scrollTop == props.scrollTopMin ? "hidden" : "";
                dom.shadowTop.style.visibility = visibilityTop;
                dom.shadowBottom.style.visibility = visibilityBottom;
                dom.shadowTopLeft.style.visibility = visibilityTop;
                dom.shadowBottomLeft.style.visibility = visibilityBottom;
                dom.shadowTopRight.style.visibility = visibilityTop;
                dom.shadowBottomRight.style.visibility = visibilityBottom;
                if (options.verticalScroll) {
                    dom.rightContainer.className = "vis-panel vis-right vis-vertical-scroll";
                    dom.leftContainer.className = "vis-panel vis-left vis-vertical-scroll";
                    dom.shadowTopRight.style.visibility = "hidden";
                    dom.shadowBottomRight.style.visibility = "hidden";
                    dom.shadowTopLeft.style.visibility = "hidden";
                    dom.shadowBottomLeft.style.visibility = "hidden";
                    dom.left.style.top = "0px";
                    dom.right.style.top = "0px";
                }
                if (!options.verticalScroll || props.center.height < props.centerContainer.height) {
                    dom.left.style.top = "".concat(offset, "px");
                    dom.right.style.top = "".concat(offset, "px");
                    dom.rightContainer.className = dom.rightContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " ");
                    dom.leftContainer.className = dom.leftContainer.className.replace(new RegExp("(?:^|\\s)vis-vertical-scroll(?:\\s|$)"), " ");
                    props.left.width = leftContainerClientWidth || -props.border.left;
                    props.right.width = rightContainerClientWidth || -props.border.right;
                    this._setDOM();
                }
                // enable/disable vertical panning
                var contentsOverflow = props.center.height > props.centerContainer.height;
                this.hammer.get("pan").set({
                    direction: contentsOverflow ? Hammer.DIRECTION_ALL : Hammer.DIRECTION_HORIZONTAL
                });
                // set the long press time
                this.hammer.get("press").set({
                    time: this.options.longSelectPressTime
                });
                // redraw all components
                _forEachInstanceProperty(_context20 = this.components).call(_context20, function(component) {
                    resized = component.redraw() || resized;
                });
                var MAX_REDRAW = 5;
                if (resized) {
                    if (this.redrawCount < MAX_REDRAW) {
                        this.body.emitter.emit("_change");
                        return;
                    } else console.log("WARNING: infinite loop in redraw?");
                } else this.redrawCount = 0;
                //Emit public 'changed' event for UI updates, see issue #1592
                this.body.emitter.emit("changed");
            }
        },
        {
            key: "_setDOM",
            value: function _setDOM() {
                var props = this.props;
                var dom = this.dom;
                props.leftContainer.width = props.left.width;
                props.rightContainer.width = props.right.width;
                var centerWidth = props.root.width - props.left.width - props.right.width;
                props.center.width = centerWidth;
                props.centerContainer.width = centerWidth;
                props.top.width = centerWidth;
                props.bottom.width = centerWidth;
                // resize the panels
                dom.background.style.height = "".concat(props.background.height, "px");
                dom.backgroundVertical.style.height = "".concat(props.background.height, "px");
                dom.backgroundHorizontal.style.height = "".concat(props.centerContainer.height, "px");
                dom.centerContainer.style.height = "".concat(props.centerContainer.height, "px");
                dom.leftContainer.style.height = "".concat(props.leftContainer.height, "px");
                dom.rightContainer.style.height = "".concat(props.rightContainer.height, "px");
                dom.background.style.width = "".concat(props.background.width, "px");
                dom.backgroundVertical.style.width = "".concat(props.centerContainer.width, "px");
                dom.backgroundHorizontal.style.width = "".concat(props.background.width, "px");
                dom.centerContainer.style.width = "".concat(props.center.width, "px");
                dom.top.style.width = "".concat(props.top.width, "px");
                dom.bottom.style.width = "".concat(props.bottom.width, "px");
                // reposition the panels
                dom.background.style.left = "0";
                dom.background.style.top = "0";
                dom.backgroundVertical.style.left = "".concat(props.left.width + props.border.left, "px");
                dom.backgroundVertical.style.top = "0";
                dom.backgroundHorizontal.style.left = "0";
                dom.backgroundHorizontal.style.top = "".concat(props.top.height, "px");
                dom.centerContainer.style.left = "".concat(props.left.width, "px");
                dom.centerContainer.style.top = "".concat(props.top.height, "px");
                dom.leftContainer.style.left = "0";
                dom.leftContainer.style.top = "".concat(props.top.height, "px");
                dom.rightContainer.style.left = "".concat(props.left.width + props.center.width, "px");
                dom.rightContainer.style.top = "".concat(props.top.height, "px");
                dom.top.style.left = "".concat(props.left.width, "px");
                dom.top.style.top = "0";
                dom.bottom.style.left = "".concat(props.left.width, "px");
                dom.bottom.style.top = "".concat(props.top.height + props.centerContainer.height, "px");
                dom.center.style.left = "0";
                dom.left.style.left = "0";
                dom.right.style.left = "0";
            }
        },
        {
            key: "setCurrentTime",
            value: function setCurrentTime(time) {
                if (!this.currentTime) throw new Error("Option showCurrentTime must be true");
                this.currentTime.setCurrentTime(time);
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                if (!this.currentTime) throw new Error("Option showCurrentTime must be true");
                return this.currentTime.getCurrentTime();
            }
        },
        {
            key: "_toTime",
            value: function _toTime(x) {
                return toTime(this, x, this.props.center.width);
            }
        },
        {
            key: "_toGlobalTime",
            value: function _toGlobalTime(x) {
                return toTime(this, x, this.props.root.width);
            //var conversion = this.range.conversion(this.props.root.width);
            //return new Date(x / conversion.scale + conversion.offset);
            }
        },
        {
            key: "_toScreen",
            value: function _toScreen(time) {
                return toScreen(this, time, this.props.center.width);
            }
        },
        {
            key: "_toGlobalScreen",
            value: function _toGlobalScreen(time) {
                return toScreen(this, time, this.props.root.width);
            //var conversion = this.range.conversion(this.props.root.width);
            //return (time.valueOf() - conversion.offset) * conversion.scale;
            }
        },
        {
            key: "_initAutoResize",
            value: function _initAutoResize() {
                if (this.options.autoResize == true) this._startAutoResize();
                else this._stopAutoResize();
            }
        },
        {
            key: "_startAutoResize",
            value: function _startAutoResize() {
                var me = this;
                this._stopAutoResize();
                this._onResize = function() {
                    if (me.options.autoResize != true) {
                        // stop watching when the option autoResize is changed to false
                        me._stopAutoResize();
                        return;
                    }
                    if (me.dom.root) {
                        var rootOffsetHeight = me.dom.root.offsetHeight;
                        var rootOffsetWidth = me.dom.root.offsetWidth;
                        // check whether the frame is resized
                        // Note: we compare offsetWidth here, not clientWidth. For some reason,
                        // IE does not restore the clientWidth from 0 to the actual width after
                        // changing the timeline's container display style from none to visible
                        if (rootOffsetWidth != me.props.lastWidth || rootOffsetHeight != me.props.lastHeight) {
                            me.props.lastWidth = rootOffsetWidth;
                            me.props.lastHeight = rootOffsetHeight;
                            me.props.scrollbarWidth = availableUtils.getScrollBarWidth();
                            me.body.emitter.emit("_change");
                        }
                    }
                };
                // add event listener to window resize
                window.addEventListener("resize", this._onResize);
                //Prevent initial unnecessary redraw
                if (me.dom.root) {
                    me.props.lastWidth = me.dom.root.offsetWidth;
                    me.props.lastHeight = me.dom.root.offsetHeight;
                }
                this.watchTimer = _setInterval(this._onResize, 1000);
            }
        },
        {
            key: "_stopAutoResize",
            value: function _stopAutoResize() {
                if (this.watchTimer) {
                    clearInterval(this.watchTimer);
                    this.watchTimer = undefined;
                }
                // remove event listener on window.resize
                if (this._onResize) {
                    window.removeEventListener("resize", this._onResize);
                    this._onResize = null;
                }
            }
        },
        {
            key: "_onTouch",
            value: function _onTouch(event1) {
                // eslint-disable-line no-unused-vars
                this.touch.allowDragging = true;
                this.touch.initialScrollTop = this.props.scrollTop;
            }
        },
        {
            key: "_onPinch",
            value: function _onPinch(event1) {
                // eslint-disable-line no-unused-vars
                this.touch.allowDragging = false;
            }
        },
        {
            key: "_onDrag",
            value: function _onDrag(event1) {
                if (!event1) return;
                // refuse to drag when we where pinching to prevent the timeline make a jump
                // when releasing the fingers in opposite order from the touch screen
                if (!this.touch.allowDragging) return;
                var delta = event1.deltaY;
                var oldScrollTop = this._getScrollTop();
                var newScrollTop = this._setScrollTop(this.touch.initialScrollTop + delta);
                if (this.options.verticalScroll) {
                    this.dom.left.parentNode.scrollTop = -this.props.scrollTop;
                    this.dom.right.parentNode.scrollTop = -this.props.scrollTop;
                }
                if (newScrollTop != oldScrollTop) this.emit("verticalDrag");
            }
        },
        {
            key: "_setScrollTop",
            value: function _setScrollTop(scrollTop) {
                this.props.scrollTop = scrollTop;
                this._updateScrollTop();
                return this.props.scrollTop;
            }
        },
        {
            key: "_updateScrollTop",
            value: function _updateScrollTop() {
                // recalculate the scrollTopMin
                var scrollTopMin = Math.min(this.props.centerContainer.height - this.props.border.top - this.props.border.bottom - this.props.center.height, 0); // is negative or zero
                if (scrollTopMin != this.props.scrollTopMin) {
                    // in case of bottom orientation, change the scrollTop such that the contents
                    // do not move relative to the time axis at the bottom
                    if (this.options.orientation.item != "top") this.props.scrollTop += scrollTopMin - this.props.scrollTopMin;
                    this.props.scrollTopMin = scrollTopMin;
                }
                // limit the scrollTop to the feasible scroll range
                if (this.props.scrollTop > 0) this.props.scrollTop = 0;
                if (this.props.scrollTop < scrollTopMin) this.props.scrollTop = scrollTopMin;
                if (this.options.verticalScroll) {
                    this.dom.left.parentNode.scrollTop = -this.props.scrollTop;
                    this.dom.right.parentNode.scrollTop = -this.props.scrollTop;
                }
                return this.props.scrollTop;
            }
        },
        {
            key: "_getScrollTop",
            value: function _getScrollTop() {
                return this.props.scrollTop;
            }
        },
        {
            key: "_createConfigurator",
            value: function _createConfigurator() {
                throw new Error("Cannot invoke abstract method _createConfigurator");
            }
        }
    ]);
    return Core;
}(); // turn Core into an event emitter
Emitter(Core.prototype);
function _createSuper$9(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$9();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$9() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A current time bar
 */ var CurrentTime = /*#__PURE__*/ function(_Component) {
    _inherits(CurrentTime, _Component);
    var _super = _createSuper$9(CurrentTime);
    /**
   * @param {{range: Range, dom: Object, domProps: Object}} body
   * @param {Object} [options]        Available parameters:
   *                                  {Boolean} [showCurrentTime]
   *                                  {String}  [alignCurrentTime]
   * @constructor CurrentTime
   * @extends Component
   */ function CurrentTime(body, options) {
        var _context;
        var _this;
        _classCallCheck(this, CurrentTime);
        _this = _super.call(this);
        _this.body = body;
        // default options
        _this.defaultOptions = {
            rtl: false,
            showCurrentTime: true,
            alignCurrentTime: undefined,
            moment: moment$4,
            locales: locales,
            locale: "en"
        };
        _this.options = availableUtils.extend({}, _this.defaultOptions);
        _this.setOptions(options);
        _this.options.locales = availableUtils.extend({}, locales, _this.options.locales);
        var defaultLocales = _this.defaultOptions.locales[_this.defaultOptions.locale];
        _forEachInstanceProperty(_context = _Object$keys(_this.options.locales)).call(_context, function(locale) {
            _this.options.locales[locale] = availableUtils.extend({}, defaultLocales, _this.options.locales[locale]);
        });
        _this.offset = 0;
        _this._create();
        return _this;
    }
    /**
   * Create the HTML DOM for the current time bar
   * @private
   */ _createClass(CurrentTime, [
        {
            key: "_create",
            value: function _create() {
                var bar = document.createElement("div");
                bar.className = "vis-current-time";
                bar.style.position = "absolute";
                bar.style.top = "0px";
                bar.style.height = "100%";
                this.bar = bar;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.options.showCurrentTime = false;
                this.redraw(); // will remove the bar from the DOM and stop refreshing
                this.body = null;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options) // copy all options that we know
                availableUtils.selectiveExtend([
                    "rtl",
                    "showCurrentTime",
                    "alignCurrentTime",
                    "moment",
                    "locale",
                    "locales"
                ], this.options, options);
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                if (this.options.showCurrentTime) {
                    var _context2, _context3;
                    var parent = this.body.dom.backgroundVertical;
                    if (this.bar.parentNode != parent) {
                        // attach to the dom
                        if (this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
                        parent.appendChild(this.bar);
                        this.start();
                    }
                    var now = this.options.moment(_Date$now() + this.offset);
                    if (this.options.alignCurrentTime) now = now.startOf(this.options.alignCurrentTime);
                    var x = this.body.util.toScreen(now);
                    var locale = this.options.locales[this.options.locale];
                    if (!locale) {
                        if (!this.warned) {
                            console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization"));
                            this.warned = true;
                        }
                        locale = this.options.locales["en"]; // fall back on english when not available
                    }
                    var title = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(locale.current, " ")).call(_context3, locale.time, ": ")).call(_context2, now.format("dddd, MMMM Do YYYY, H:mm:ss"));
                    title = title.charAt(0).toUpperCase() + title.substring(1);
                    if (this.options.rtl) this.bar.style.transform = "translateX(".concat(x * -1, "px)");
                    else this.bar.style.transform = "translateX(".concat(x, "px)");
                    this.bar.title = title;
                } else {
                    // remove the line from the DOM
                    if (this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
                    this.stop();
                }
                return false;
            }
        },
        {
            key: "start",
            value: function start() {
                var me = this;
                /**
       *  Updates the current time.
       */ function update() {
                    me.stop();
                    // determine interval to refresh
                    var scale = me.body.range.conversion(me.body.domProps.center.width).scale;
                    var interval = 1 / scale / 10;
                    if (interval < 30) interval = 30;
                    if (interval > 1000) interval = 1000;
                    me.redraw();
                    me.body.emitter.emit("currentTimeTick");
                    // start a renderTimer to adjust for the new time
                    me.currentTimeTimer = _setTimeout(update, interval);
                }
                update();
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.currentTimeTimer !== undefined) {
                    clearTimeout(this.currentTimeTimer);
                    delete this.currentTimeTimer;
                }
            }
        },
        {
            key: "setCurrentTime",
            value: function setCurrentTime(time) {
                var t = availableUtils.convert(time, "Date").valueOf();
                var now = _Date$now();
                this.offset = t - now;
                this.redraw();
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return new Date(_Date$now() + this.offset);
            }
        }
    ]);
    return CurrentTime;
}(Component);
var $$2 = _export;
var $find = arrayIteration.find;
var FIND = "find";
var SKIPS_HOLES$1 = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function() {
    SKIPS_HOLES$1 = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$$2({
    target: "Array",
    proto: true,
    forced: SKIPS_HOLES$1
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$2 = entryVirtual$o;
var find$3 = entryVirtual$2("Array").find;
var isPrototypeOf$2 = objectIsPrototypeOf;
var method$2 = find$3;
var ArrayPrototype$2 = Array.prototype;
var find$2 = function(it) {
    var own = it.find;
    return it === ArrayPrototype$2 || isPrototypeOf$2(ArrayPrototype$2, it) && own === ArrayPrototype$2.find ? method$2 : own;
};
var parent$2 = find$2;
var find$1 = parent$2;
var find = find$1;
var _findInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(find);
var $$1 = _export;
var $findIndex = arrayIteration.findIndex;
var FIND_INDEX = "findIndex";
var SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function() {
    SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$$1({
    target: "Array",
    proto: true,
    forced: SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual$1 = entryVirtual$o;
var findIndex$3 = entryVirtual$1("Array").findIndex;
var isPrototypeOf$1 = objectIsPrototypeOf;
var method$1 = findIndex$3;
var ArrayPrototype$1 = Array.prototype;
var findIndex$2 = function(it) {
    var own = it.findIndex;
    return it === ArrayPrototype$1 || isPrototypeOf$1(ArrayPrototype$1, it) && own === ArrayPrototype$1.findIndex ? method$1 : own;
};
var parent$1 = findIndex$2;
var findIndex$1 = parent$1;
var findIndex = findIndex$1;
var _findIndexInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(findIndex);
function _createForOfIteratorHelper$5(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$5(o, minLen) {
    var _context5;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
    var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}
function _arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
// Utility functions for ordering and stacking of items
var EPSILON = 0.001; // used when checking collisions, to prevent round-off errors
/**
 * Order items by their start data
 * @param {Item[]} items
 */ function orderByStart(items) {
    _sortInstanceProperty(items).call(items, function(a, b) {
        return a.data.start - b.data.start;
    });
}
/**
 * Order items by their end date. If they have no end date, their start date
 * is used.
 * @param {Item[]} items
 */ function orderByEnd(items) {
    _sortInstanceProperty(items).call(items, function(a, b) {
        var aTime = "end" in a.data ? a.data.end : a.data.start;
        var bTime = "end" in b.data ? b.data.end : b.data.start;
        return aTime - bTime;
    });
}
/**
 * Adjust vertical positions of the items such that they don't overlap each
 * other.
 * @param {Item[]} items
 *            All visible items
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {boolean} [force=false]
 *            If true, all items will be repositioned. If false (default), only
 *            items having a top===null will be re-stacked
 * @param {function} shouldBailItemsRedrawFunction
 *            bailing function
 * @return {boolean} shouldBail
 */ function stack(items, margin, force, shouldBailItemsRedrawFunction) {
    var stackingResult = performStacking(items, margin.item, false, function(item) {
        return item.stack && (force || item.top === null);
    }, function(item) {
        return item.stack;
    }, function(item) {
        return margin.axis;
    }, shouldBailItemsRedrawFunction);
    // If shouldBail function returned true during stacking calculation
    return stackingResult === null;
}
/**
 * Adjust vertical positions of the items within a single subgroup such that they
 * don't overlap each other.
 * @param {Item[]} items
 *            All items withina subgroup
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {subgroup} subgroup
 *            The subgroup that is being stacked
 */ function substack(items, margin, subgroup) {
    var subgroupHeight = performStacking(items, margin.item, false, function(item) {
        return item.stack;
    }, function(item) {
        return true;
    }, function(item) {
        return item.baseTop;
    });
    subgroup.height = subgroupHeight - subgroup.top + 0.5 * margin.item.vertical;
}
/**
 * Adjust vertical positions of the items without stacking them
 * @param {Item[]} items
 *            All visible items
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {subgroups[]} subgroups
 *            All subgroups
 * @param {boolean} isStackSubgroups
 */ function nostack(items, margin, subgroups, isStackSubgroups) {
    for(var _i = 0; _i < items.length; _i++){
        if (items[_i].data.subgroup == undefined) items[_i].top = margin.item.vertical;
        else if (items[_i].data.subgroup !== undefined && isStackSubgroups) {
            var newTop = 0;
            for(var subgroup in subgroups){
                if (subgroups.hasOwnProperty(subgroup)) {
                    if (subgroups[subgroup].visible == true && subgroups[subgroup].index < subgroups[items[_i].data.subgroup].index) {
                        newTop += subgroups[subgroup].height;
                        subgroups[items[_i].data.subgroup].top = newTop;
                    }
                }
            }
            items[_i].top = newTop + 0.5 * margin.item.vertical;
        }
    }
    if (!isStackSubgroups) stackSubgroups(items, margin, subgroups);
}
/**
 * Adjust vertical positions of the subgroups such that they don't overlap each
 * other.
 * @param {Array.<timeline.Item>} items
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin Margins between items and between items and the axis.
 * @param {subgroups[]} subgroups
 *            All subgroups
 */ function stackSubgroups(items, margin, subgroups) {
    var _context;
    performStacking(_sortInstanceProperty(_context = _Object$values2(subgroups)).call(_context, function(a, b) {
        if (a.index > b.index) return 1;
        if (a.index < b.index) return -1;
        return 0;
    }), {
        vertical: 0
    }, true, function(item) {
        return true;
    }, function(item) {
        return true;
    }, function(item) {
        return 0;
    });
    for(var _i2 = 0; _i2 < items.length; _i2++)if (items[_i2].data.subgroup !== undefined) items[_i2].top = subgroups[items[_i2].data.subgroup].top + 0.5 * margin.item.vertical;
}
/**
 * Adjust vertical positions of the subgroups such that they don't overlap each
 * other, then stacks the contents of each subgroup individually.
 * @param {Item[]} subgroupItems
 *            All the items in a subgroup
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {subgroups[]} subgroups
 *            All subgroups
 */ function stackSubgroupsWithInnerStack(subgroupItems, margin, subgroups) {
    var doSubStack = false;
    // Run subgroups in their order (if any)
    var subgroupOrder = [];
    for(var subgroup in subgroups)if (subgroups[subgroup].hasOwnProperty("index")) subgroupOrder[subgroups[subgroup].index] = subgroup;
    else subgroupOrder.push(subgroup);
    for(var j = 0; j < subgroupOrder.length; j++){
        subgroup = subgroupOrder[j];
        if (subgroups.hasOwnProperty(subgroup)) {
            doSubStack = doSubStack || subgroups[subgroup].stack;
            subgroups[subgroup].top = 0;
            for(var otherSubgroup in subgroups)if (subgroups[otherSubgroup].visible && subgroups[subgroup].index > subgroups[otherSubgroup].index) subgroups[subgroup].top += subgroups[otherSubgroup].height;
            var items = subgroupItems[subgroup];
            for(var _i3 = 0; _i3 < items.length; _i3++)if (items[_i3].data.subgroup !== undefined) {
                items[_i3].top = subgroups[items[_i3].data.subgroup].top + 0.5 * margin.item.vertical;
                if (subgroups[subgroup].stack) items[_i3].baseTop = items[_i3].top;
            }
            if (doSubStack && subgroups[subgroup].stack) substack(subgroupItems[subgroup], margin, subgroups[subgroup]);
        }
    }
}
/**
 * Reusable stacking function
 * 
 * @param {Item[]} items 
 * An array of items to consider during stacking.
 * @param {{horizontal: number, vertical: number}} margins
 * Margins to be used for collision checking and placement of items.
 * @param {boolean} compareTimes
 * By default, horizontal collision is checked based on the spatial position of the items (left/right and width).
 * If this argument is true, horizontal collision will instead be checked based on the start/end times of each item.
 * Vertical collision is always checked spatially.
 * @param {(Item) => number | null} shouldStack
 * A callback function which is called before we start to process an item. The return value indicates whether the item will be processed.
 * @param {(Item) => boolean} shouldOthersStack
 * A callback function which indicates whether other items should consider this item when being stacked.
 * @param {(Item) => number} getInitialHeight
 * A callback function which determines the height items are initially placed at
 * @param {() => boolean} shouldBail 
 * A callback function which should indicate if the stacking process should be aborted.
 * 
 * @returns {null|number}
 * if shouldBail was triggered, returns null
 * otherwise, returns the maximum height
 */ function performStacking(items, margins, compareTimes, shouldStack, shouldOthersStack, getInitialHeight, shouldBail) {
    // Time-based horizontal comparison
    var getItemStart = function getItemStart(item) {
        return item.start;
    };
    var getItemEnd = function getItemEnd(item) {
        return item.end;
    };
    if (!compareTimes) {
        // Spatial horizontal comparisons
        var rtl = !!(items[0] && items[0].options.rtl);
        if (rtl) getItemStart = function getItemStart(item) {
            return item.right;
        };
        else getItemStart = function getItemStart(item) {
            return item.left;
        };
        getItemEnd = function getItemEnd(item) {
            return getItemStart(item) + item.width + margins.horizontal;
        };
    }
    var itemsToPosition = [];
    var itemsAlreadyPositioned = []; // It's vital that this array is kept sorted based on the start of each item
    // If the order we needed to place items was based purely on the start of each item, we could calculate stacking very efficiently.
    // Unfortunately for us, this is not guaranteed. But the order is often based on the start of items at least to some degree, and
    // we can use this to make some optimisations. While items are proceeding in order of start, we can keep moving our search indexes
    // forwards. Then if we encounter an item that's out of order, we reset our indexes and search from the beginning of the array again.
    var previousStart = null;
    var insertionIndex = 0;
    // First let's handle any immoveable items
    var _iterator = _createForOfIteratorHelper$5(items), _step;
    try {
        var _loop2 = function _loop2() {
            var item = _step.value;
            if (shouldStack(item)) itemsToPosition.push(item);
            else if (shouldOthersStack(item)) {
                var itemStart = getItemStart(item);
                // We need to put immoveable items into itemsAlreadyPositioned and ensure that this array is sorted.
                // We could simply insert them, and then use JavaScript's sort function to sort them afterwards.
                // This would achieve an average complexity of O(n log n).
                // 
                // Instead, I'm gambling that the start of each item will usually be the same or later than the
                // start of the previous item. While this holds (best case), we can insert items in O(n).
                // In the worst case (where each item starts before the previous item) this grows to O(n^2).
                // 
                // I am making the assumption that for most datasets, the "order" function will have relatively low cardinality,
                // and therefore this tradeoff should be easily worth it.
                if (previousStart !== null && itemStart < previousStart - EPSILON) insertionIndex = 0;
                previousStart = itemStart;
                insertionIndex = findIndexFrom(itemsAlreadyPositioned, function(i1) {
                    return getItemStart(i1) - EPSILON > itemStart;
                }, insertionIndex);
                _spliceInstanceProperty(itemsAlreadyPositioned).call(itemsAlreadyPositioned, insertionIndex, 0, item);
                insertionIndex++;
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;)_loop2();
    // Now we can loop through each item (in order) and find a position for them
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    previousStart = null;
    var previousEnd = null;
    insertionIndex = 0;
    var horizontalOverlapStartIndex = 0;
    var horizontalOverlapEndIndex = 0;
    var maxHeight = 0;
    var _loop = function _loop() {
        var _context2, _context3;
        var item = itemsToPosition.shift();
        item.top = getInitialHeight(item);
        var itemStart = getItemStart(item);
        var itemEnd = getItemEnd(item);
        if (previousStart !== null && itemStart < previousStart - EPSILON) {
            horizontalOverlapStartIndex = 0;
            horizontalOverlapEndIndex = 0;
            insertionIndex = 0;
            previousEnd = null;
        }
        previousStart = itemStart;
        // Take advantage of the sorted itemsAlreadyPositioned array to narrow down the search
        horizontalOverlapStartIndex = findIndexFrom(itemsAlreadyPositioned, function(i1) {
            return itemStart < getItemEnd(i1) - EPSILON;
        }, horizontalOverlapStartIndex);
        // Since items aren't sorted by end time, it might increase or decrease from one item to the next. In order to keep an efficient search area, we will seek forwards/backwards accordingly.
        if (previousEnd === null || previousEnd < itemEnd - EPSILON) horizontalOverlapEndIndex = findIndexFrom(itemsAlreadyPositioned, function(i1) {
            return itemEnd < getItemStart(i1) - EPSILON;
        }, Math.max(horizontalOverlapStartIndex, horizontalOverlapEndIndex));
        if (previousEnd !== null && previousEnd - EPSILON > itemEnd) horizontalOverlapEndIndex = findLastIndexBetween(itemsAlreadyPositioned, function(i1) {
            return itemEnd + EPSILON >= getItemStart(i1);
        }, horizontalOverlapStartIndex, horizontalOverlapEndIndex) + 1;
        // Sort by vertical position so we don't have to reconsider past items if we move an item
        var horizontallyCollidingItems = _sortInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _sliceInstanceProperty(itemsAlreadyPositioned).call(itemsAlreadyPositioned, horizontalOverlapStartIndex, horizontalOverlapEndIndex)).call(_context3, function(i1) {
            return itemStart < getItemEnd(i1) - EPSILON && itemEnd - EPSILON > getItemStart(i1);
        })).call(_context2, function(a, b) {
            return a.top - b.top;
        });
        // Keep moving the item down until it stops colliding with any other items
        for(var i2 = 0; i2 < horizontallyCollidingItems.length; i2++){
            var otherItem = horizontallyCollidingItems[i2];
            if (checkVerticalSpatialCollision(item, otherItem, margins)) item.top = otherItem.top + otherItem.height + margins.vertical;
        }
        if (shouldOthersStack(item)) {
            // Insert the item into itemsAlreadyPositioned, ensuring itemsAlreadyPositioned remains sorted.
            // In the best case, we can insert an item in constant time O(1). In the worst case, we insert an item in linear time O(n).
            // In both cases, this is better than doing a naive insert and then sort, which would cost on average O(n log n).
            insertionIndex = findIndexFrom(itemsAlreadyPositioned, function(i1) {
                return getItemStart(i1) - EPSILON > itemStart;
            }, insertionIndex);
            _spliceInstanceProperty(itemsAlreadyPositioned).call(itemsAlreadyPositioned, insertionIndex, 0, item);
            insertionIndex++;
        }
        // Keep track of the tallest item we've seen before
        var currentHeight = item.top + item.height;
        if (currentHeight > maxHeight) maxHeight = currentHeight;
        if (shouldBail && shouldBail()) return {
            v: null
        };
    }, _ret;
    while(itemsToPosition.length > 0){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return maxHeight;
}
/**
 * Test if the two provided items collide
 * The items must have parameters left, width, top, and height.
 * @param {Item} a          The first item
 * @param {Item} b          The second item
 * @param {{vertical: number}} margin
 *                          An object containing a horizontal and vertical
 *                          minimum required margin.
 * @return {boolean}        true if a and b collide, else false
 */ function checkVerticalSpatialCollision(a, b, margin) {
    return a.top - margin.vertical + EPSILON < b.top + b.height && a.top + a.height + margin.vertical - EPSILON > b.top;
}
/**
 * Find index of first item to meet predicate after a certain index.
 * If no such item is found, returns the length of the array.
 * 
 * @param {any[]} arr The array
 * @param {(item) => boolean} predicate A function that should return true when a suitable item is found
 * @param {number|undefined} startIndex The index to start search from (inclusive). Optional, if not provided will search from the beginning of the array.
 * 
 * @return {number}
 */ function findIndexFrom(arr, predicate, startIndex) {
    var _context4;
    if (!startIndex) startIndex = 0;
    var matchIndex = _findIndexInstanceProperty(_context4 = _sliceInstanceProperty(arr).call(arr, startIndex)).call(_context4, predicate);
    if (matchIndex === -1) return arr.length;
    return matchIndex + startIndex;
}
/**
 * Find index of last item to meet predicate within a given range.
 * If no such item is found, returns the index prior to the start of the range.
 * 
 * @param {any[]} arr The array
 * @param {(item) => boolean} predicate A function that should return true when a suitable item is found
 * @param {number|undefined} startIndex The earliest index to search to (inclusive). Optional, if not provided will continue until the start of the array.
 * @param {number|undefined} endIndex The end of the search range (exclusive). The search will begin on the index prior to this value. Optional, defaults to the end of array.
 * 
 * @return {number}
 */ function findLastIndexBetween(arr, predicate, startIndex, endIndex) {
    if (!startIndex) startIndex = 0;
    if (!endIndex) endIndex = arr.length;
    for(i = endIndex - 1; i >= startIndex; i--){
        if (predicate(arr[i])) return i;
    }
    return startIndex - 1;
}
var stack$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    nostack: nostack,
    orderByEnd: orderByEnd,
    orderByStart: orderByStart,
    stack: stack,
    stackSubgroups: stackSubgroups,
    stackSubgroupsWithInnerStack: stackSubgroupsWithInnerStack,
    substack: substack
});
var UNGROUPED$3 = "__ungrouped__"; // reserved group id for ungrouped items
var BACKGROUND$2 = "__background__"; // reserved group id for background items without group
var ReservedGroupIds$1 = {
    UNGROUPED: UNGROUPED$3,
    BACKGROUND: BACKGROUND$2
};
/**
 * @constructor Group
 */ var Group = /*#__PURE__*/ function() {
    /**
  * @param {number | string} groupId
  * @param {Object} data
  * @param {ItemSet} itemSet
  * @constructor Group
  */ function Group(groupId, data, itemSet) {
        var _this = this;
        _classCallCheck(this, Group);
        this.groupId = groupId;
        this.subgroups = {};
        this.subgroupStack = {};
        this.subgroupStackAll = false;
        this.subgroupVisibility = {};
        this.doInnerStack = false;
        this.shouldBailStackItems = false;
        this.subgroupIndex = 0;
        this.subgroupOrderer = data && data.subgroupOrder;
        this.itemSet = itemSet;
        this.isVisible = null;
        this.stackDirty = true; // if true, items will be restacked on next redraw
        // This is a stack of functions (`() => void`) that will be executed before
        // the instance is disposed off (method `dispose`). Anything that needs to
        // be manually disposed off before garbage collection happens (or so that
        // garbage collection can happen) should be added to this stack.
        this._disposeCallbacks = [];
        if (data && data.nestedGroups) {
            this.nestedGroups = data.nestedGroups;
            if (data.showNested == false) this.showNested = false;
            else this.showNested = true;
        }
        if (data && data.subgroupStack) {
            if (typeof data.subgroupStack === "boolean") {
                this.doInnerStack = data.subgroupStack;
                this.subgroupStackAll = data.subgroupStack;
            } else // We might be doing stacking on specific sub groups, but only
            // if at least one is set to do stacking
            for(var key in data.subgroupStack){
                this.subgroupStack[key] = data.subgroupStack[key];
                this.doInnerStack = this.doInnerStack || data.subgroupStack[key];
            }
        }
        if (data && data.heightMode) this.heightMode = data.heightMode;
        else this.heightMode = itemSet.options.groupHeightMode;
        this.nestedInGroup = null;
        this.dom = {};
        this.props = {
            label: {
                width: 0,
                height: 0
            }
        };
        this.className = null;
        this.items = {}; // items filtered by groupId of this group
        this.visibleItems = []; // items currently visible in window
        this.itemsInRange = []; // items currently in range
        this.orderedItems = {
            byStart: [],
            byEnd: []
        };
        this.checkRangedItems = false; // needed to refresh the ranged items if the window is programatically changed with NO overlap.
        var handleCheckRangedItems = function handleCheckRangedItems() {
            _this.checkRangedItems = true;
        };
        this.itemSet.body.emitter.on("checkRangedItems", handleCheckRangedItems);
        this._disposeCallbacks.push(function() {
            _this.itemSet.body.emitter.off("checkRangedItems", handleCheckRangedItems);
        });
        this._create();
        this.setData(data);
    }
    /**
   * Create DOM elements for the group
   * @private
   */ _createClass(Group, [
        {
            key: "_create",
            value: function _create() {
                var label = document.createElement("div");
                if (this.itemSet.options.groupEditable.order) label.className = "vis-label draggable";
                else label.className = "vis-label";
                this.dom.label = label;
                var inner = document.createElement("div");
                inner.className = "vis-inner";
                label.appendChild(inner);
                this.dom.inner = inner;
                var foreground = document.createElement("div");
                foreground.className = "vis-group";
                foreground["vis-group"] = this;
                this.dom.foreground = foreground;
                this.dom.background = document.createElement("div");
                this.dom.background.className = "vis-group";
                this.dom.axis = document.createElement("div");
                this.dom.axis.className = "vis-group";
                // create a hidden marker to detect when the Timelines container is attached
                // to the DOM, or the style of a parent of the Timeline is changed from
                // display:none is changed to visible.
                this.dom.marker = document.createElement("div");
                this.dom.marker.style.visibility = "hidden";
                this.dom.marker.style.position = "absolute";
                this.dom.marker.innerHTML = "";
                this.dom.background.appendChild(this.dom.marker);
            }
        },
        {
            key: "setData",
            value: function setData(data) {
                if (this.itemSet.groupTouchParams.isDragging) return;
                // update contents
                var content;
                var templateFunction;
                if (data && data.subgroupVisibility) for(var key in data.subgroupVisibility)this.subgroupVisibility[key] = data.subgroupVisibility[key];
                if (this.itemSet.options && this.itemSet.options.groupTemplate) {
                    var _context;
                    templateFunction = _bindInstanceProperty$1(_context = this.itemSet.options.groupTemplate).call(_context, this);
                    content = templateFunction(data, this.dom.inner);
                } else content = data && data.content;
                if (content instanceof Element) {
                    while(this.dom.inner.firstChild)this.dom.inner.removeChild(this.dom.inner.firstChild);
                    this.dom.inner.appendChild(content);
                } else if (content instanceof Object && content.isReactComponent) ;
                else if (content instanceof Object) templateFunction(data, this.dom.inner);
                else if (content !== undefined && content !== null) this.dom.inner.innerHTML = availableUtils.xss(content);
                else this.dom.inner.innerHTML = availableUtils.xss(this.groupId || ""); // groupId can be null
                // update title
                this.dom.label.title = data && data.title || "";
                if (!this.dom.inner.firstChild) availableUtils.addClassName(this.dom.inner, "vis-hidden");
                else availableUtils.removeClassName(this.dom.inner, "vis-hidden");
                if (data && data.nestedGroups) {
                    if (!this.nestedGroups || this.nestedGroups != data.nestedGroups) this.nestedGroups = data.nestedGroups;
                    if (data.showNested !== undefined || this.showNested === undefined) {
                        if (data.showNested == false) this.showNested = false;
                        else this.showNested = true;
                    }
                    availableUtils.addClassName(this.dom.label, "vis-nesting-group");
                    if (this.showNested) {
                        availableUtils.removeClassName(this.dom.label, "collapsed");
                        availableUtils.addClassName(this.dom.label, "expanded");
                    } else {
                        availableUtils.removeClassName(this.dom.label, "expanded");
                        availableUtils.addClassName(this.dom.label, "collapsed");
                    }
                } else if (this.nestedGroups) {
                    this.nestedGroups = null;
                    availableUtils.removeClassName(this.dom.label, "collapsed");
                    availableUtils.removeClassName(this.dom.label, "expanded");
                    availableUtils.removeClassName(this.dom.label, "vis-nesting-group");
                }
                if (data && (data.treeLevel || data.nestedInGroup)) {
                    availableUtils.addClassName(this.dom.label, "vis-nested-group");
                    if (data.treeLevel) availableUtils.addClassName(this.dom.label, "vis-group-level-" + data.treeLevel);
                    else // Nesting level is unknown, but we're sure it's at least 1
                    availableUtils.addClassName(this.dom.label, "vis-group-level-unknown-but-gte1");
                } else availableUtils.addClassName(this.dom.label, "vis-group-level-0");
                // update className
                var className = data && data.className || null;
                if (className != this.className) {
                    if (this.className) {
                        availableUtils.removeClassName(this.dom.label, this.className);
                        availableUtils.removeClassName(this.dom.foreground, this.className);
                        availableUtils.removeClassName(this.dom.background, this.className);
                        availableUtils.removeClassName(this.dom.axis, this.className);
                    }
                    availableUtils.addClassName(this.dom.label, className);
                    availableUtils.addClassName(this.dom.foreground, className);
                    availableUtils.addClassName(this.dom.background, className);
                    availableUtils.addClassName(this.dom.axis, className);
                    this.className = className;
                }
                // update style
                if (this.style) {
                    availableUtils.removeCssText(this.dom.label, this.style);
                    this.style = null;
                }
                if (data && data.style) {
                    availableUtils.addCssText(this.dom.label, data.style);
                    this.style = data.style;
                }
            }
        },
        {
            key: "getLabelWidth",
            value: function getLabelWidth() {
                return this.props.label.width;
            }
        },
        {
            key: "_didMarkerHeightChange",
            value: function _didMarkerHeightChange() {
                var markerHeight = this.dom.marker.clientHeight;
                if (markerHeight != this.lastMarkerHeight) {
                    this.lastMarkerHeight = markerHeight;
                    var redrawQueue = {};
                    var redrawQueueLength = 0;
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.items, function(item, key) {
                        item.dirty = true;
                        if (item.displayed) {
                            var returnQueue = true;
                            redrawQueue[key] = item.redraw(returnQueue);
                            redrawQueueLength = redrawQueue[key].length;
                        }
                    });
                    var needRedraw = redrawQueueLength > 0;
                    if (needRedraw) {
                        var _loop = function _loop(i1) {
                            _forEachInstanceProperty(availableUtils).call(availableUtils, redrawQueue, function(fns) {
                                fns[i1]();
                            });
                        };
                        // redraw all regular items
                        for(var i1 = 0; i1 < redrawQueueLength; i1++)_loop(i1);
                    }
                    return true;
                } else return false;
            }
        },
        {
            key: "_calculateGroupSizeAndPosition",
            value: function _calculateGroupSizeAndPosition() {
                var _this$dom$foreground = this.dom.foreground, offsetTop = _this$dom$foreground.offsetTop, offsetLeft = _this$dom$foreground.offsetLeft, offsetWidth = _this$dom$foreground.offsetWidth;
                this.top = offsetTop;
                this.right = offsetLeft;
                this.width = offsetWidth;
            }
        },
        {
            key: "_shouldBailItemsRedraw",
            value: function _shouldBailItemsRedraw() {
                var me = this;
                var timeoutOptions = this.itemSet.options.onTimeout;
                var bailOptions = {
                    relativeBailingTime: this.itemSet.itemsSettingTime,
                    bailTimeMs: timeoutOptions && timeoutOptions.timeoutMs,
                    userBailFunction: timeoutOptions && timeoutOptions.callback,
                    shouldBailStackItems: this.shouldBailStackItems
                };
                var bail = null;
                if (!this.itemSet.initialDrawDone) {
                    if (bailOptions.shouldBailStackItems) return true;
                    if (Math.abs(_Date$now() - new Date(bailOptions.relativeBailingTime)) > bailOptions.bailTimeMs) {
                        if (bailOptions.userBailFunction && this.itemSet.userContinueNotBail == null) bailOptions.userBailFunction(function(didUserContinue) {
                            me.itemSet.userContinueNotBail = didUserContinue;
                            bail = !didUserContinue;
                        });
                        else if (me.itemSet.userContinueNotBail == false) bail = true;
                        else bail = false;
                    }
                }
                return bail;
            }
        },
        {
            key: "_redrawItems",
            value: function _redrawItems(forceRestack, lastIsVisible, margin, range) {
                var _this2 = this;
                var restack = forceRestack || this.stackDirty || this.isVisible && !lastIsVisible;
                // if restacking, reposition visible items vertically
                if (restack) {
                    var _context2, _context3, _context4, _context5, _context6, _context7;
                    var orderedItems = {
                        byEnd: _filterInstanceProperty(_context2 = this.orderedItems.byEnd).call(_context2, function(item) {
                            return !item.isCluster;
                        }),
                        byStart: _filterInstanceProperty(_context3 = this.orderedItems.byStart).call(_context3, function(item) {
                            return !item.isCluster;
                        })
                    };
                    var orderedClusters = {
                        byEnd: _toConsumableArray(new _Set(_filterInstanceProperty(_context4 = _mapInstanceProperty(_context5 = this.orderedItems.byEnd).call(_context5, function(item) {
                            return item.cluster;
                        })).call(_context4, function(item) {
                            return !!item;
                        }))),
                        byStart: _toConsumableArray(new _Set(_filterInstanceProperty(_context6 = _mapInstanceProperty(_context7 = this.orderedItems.byStart).call(_context7, function(item) {
                            return item.cluster;
                        })).call(_context6, function(item) {
                            return !!item;
                        })))
                    };
                    /**
        * Get all visible items in range
        * @return {array} items
        */ var getVisibleItems = function getVisibleItems() {
                        var _context8, _context9, _context10;
                        var visibleItems = _this2._updateItemsInRange(orderedItems, _filterInstanceProperty(_context8 = _this2.visibleItems).call(_context8, function(item) {
                            return !item.isCluster;
                        }), range);
                        var visibleClusters = _this2._updateClustersInRange(orderedClusters, _filterInstanceProperty(_context9 = _this2.visibleItems).call(_context9, function(item) {
                            return item.isCluster;
                        }), range);
                        return _concatInstanceProperty(_context10 = []).call(_context10, _toConsumableArray(visibleItems), _toConsumableArray(visibleClusters));
                    };
                    /**
         * Get visible items grouped by subgroup
         * @param {function} orderFn An optional function to order items inside the subgroups
         * @return {Object}
         */ var getVisibleItemsGroupedBySubgroup = function getVisibleItemsGroupedBySubgroup(orderFn) {
                        var visibleSubgroupsItems = {};
                        var _loop2 = function _loop2(subgroup) {
                            var _context11;
                            var items = _filterInstanceProperty(_context11 = _this2.visibleItems).call(_context11, function(item) {
                                return item.data.subgroup === subgroup;
                            });
                            visibleSubgroupsItems[subgroup] = orderFn ? _sortInstanceProperty(items).call(items, function(a, b) {
                                return orderFn(a.data, b.data);
                            }) : items;
                        };
                        for(var subgroup in _this2.subgroups)_loop2(subgroup);
                        return visibleSubgroupsItems;
                    };
                    if (typeof this.itemSet.options.order === "function") {
                        // a custom order function
                        //show all items
                        var me = this;
                        if (this.doInnerStack && this.itemSet.options.stackSubgroups) {
                            // Order the items within each subgroup
                            var visibleSubgroupsItems = getVisibleItemsGroupedBySubgroup(this.itemSet.options.order);
                            stackSubgroupsWithInnerStack(visibleSubgroupsItems, margin, this.subgroups);
                            this.visibleItems = getVisibleItems();
                            this._updateSubGroupHeights(margin);
                        } else {
                            var _context12, _context13, _context14, _context15;
                            this.visibleItems = getVisibleItems();
                            this._updateSubGroupHeights(margin);
                            // order all items and force a restacking
                            // order all items outside clusters and force a restacking
                            var customOrderedItems = _sortInstanceProperty(_context12 = _filterInstanceProperty(_context13 = _sliceInstanceProperty(_context14 = this.visibleItems).call(_context14)).call(_context13, function(item) {
                                return item.isCluster || !item.isCluster && !item.cluster;
                            })).call(_context12, function(a, b) {
                                return me.itemSet.options.order(a.data, b.data);
                            });
                            this.shouldBailStackItems = stack(customOrderedItems, margin, true, _bindInstanceProperty$1(_context15 = this._shouldBailItemsRedraw).call(_context15, this));
                        }
                    } else {
                        // no custom order function, lazy stacking
                        this.visibleItems = getVisibleItems();
                        this._updateSubGroupHeights(margin);
                        if (this.itemSet.options.stack) {
                            if (this.doInnerStack && this.itemSet.options.stackSubgroups) {
                                var _visibleSubgroupsItems = getVisibleItemsGroupedBySubgroup();
                                stackSubgroupsWithInnerStack(_visibleSubgroupsItems, margin, this.subgroups);
                            } else {
                                var _context16;
                                // TODO: ugly way to access options...
                                this.shouldBailStackItems = stack(this.visibleItems, margin, true, _bindInstanceProperty$1(_context16 = this._shouldBailItemsRedraw).call(_context16, this));
                            }
                        } else // no stacking
                        nostack(this.visibleItems, margin, this.subgroups, this.itemSet.options.stackSubgroups);
                    }
                    for(var i1 = 0; i1 < this.visibleItems.length; i1++){
                        this.visibleItems[i1].repositionX();
                        if (this.subgroupVisibility[this.visibleItems[i1].data.subgroup] !== undefined) {
                            if (!this.subgroupVisibility[this.visibleItems[i1].data.subgroup]) this.visibleItems[i1].hide();
                        }
                    }
                    if (this.itemSet.options.cluster) _forEachInstanceProperty(availableUtils).call(availableUtils, this.items, function(item) {
                        if (item.cluster && item.displayed) item.hide();
                    });
                    if (this.shouldBailStackItems) this.itemSet.body.emitter.emit("destroyTimeline");
                    this.stackDirty = false;
                }
            }
        },
        {
            key: "_didResize",
            value: function _didResize(resized, height) {
                resized = availableUtils.updateProperty(this, "height", height) || resized;
                // recalculate size of label
                var labelWidth = this.dom.inner.clientWidth;
                var labelHeight = this.dom.inner.clientHeight;
                resized = availableUtils.updateProperty(this.props.label, "width", labelWidth) || resized;
                resized = availableUtils.updateProperty(this.props.label, "height", labelHeight) || resized;
                return resized;
            }
        },
        {
            key: "_applyGroupHeight",
            value: function _applyGroupHeight(height) {
                this.dom.background.style.height = "".concat(height, "px");
                this.dom.foreground.style.height = "".concat(height, "px");
                this.dom.label.style.height = "".concat(height, "px");
            }
        },
        {
            key: "_updateItemsVerticalPosition",
            value: function _updateItemsVerticalPosition(margin) {
                for(var i1 = 0, ii = this.visibleItems.length; i1 < ii; i1++){
                    var item = this.visibleItems[i1];
                    item.repositionY(margin);
                    if (!this.isVisible && this.groupId != ReservedGroupIds$1.BACKGROUND) {
                        if (item.displayed) item.hide();
                    }
                }
            }
        },
        {
            key: "redraw",
            value: function redraw(range, margin, forceRestack, returnQueue) {
                var _this3 = this, _context17, _context18, _context21, _context23, _context27;
                var resized = false;
                var lastIsVisible = this.isVisible;
                var height;
                var queue = [
                    function() {
                        forceRestack = _this3._didMarkerHeightChange.call(_this3) || forceRestack;
                    },
                    // recalculate the height of the subgroups
                    _bindInstanceProperty$1(_context17 = this._updateSubGroupHeights).call(_context17, this, margin),
                    // calculate actual size and position
                    _bindInstanceProperty$1(_context18 = this._calculateGroupSizeAndPosition).call(_context18, this),
                    function() {
                        var _context19;
                        _this3.isVisible = _bindInstanceProperty$1(_context19 = _this3._isGroupVisible).call(_context19, _this3)(range, margin);
                    },
                    function() {
                        var _context20;
                        _bindInstanceProperty$1(_context20 = _this3._redrawItems).call(_context20, _this3)(forceRestack, lastIsVisible, margin, range);
                    },
                    // update subgroups
                    _bindInstanceProperty$1(_context21 = this._updateSubgroupsSizes).call(_context21, this),
                    function() {
                        var _context22;
                        height = _bindInstanceProperty$1(_context22 = _this3._calculateHeight).call(_context22, _this3)(margin);
                    },
                    // calculate actual size and position again
                    _bindInstanceProperty$1(_context23 = this._calculateGroupSizeAndPosition).call(_context23, this),
                    function() {
                        var _context24;
                        resized = _bindInstanceProperty$1(_context24 = _this3._didResize).call(_context24, _this3)(resized, height);
                    },
                    function() {
                        var _context25;
                        _bindInstanceProperty$1(_context25 = _this3._applyGroupHeight).call(_context25, _this3)(height);
                    },
                    function() {
                        var _context26;
                        _bindInstanceProperty$1(_context26 = _this3._updateItemsVerticalPosition).call(_context26, _this3)(margin);
                    },
                    _bindInstanceProperty$1(_context27 = function _context27() {
                        if (!_this3.isVisible && _this3.height) resized = false;
                        return resized;
                    }).call(_context27, this)
                ];
                if (returnQueue) return queue;
                else {
                    var result;
                    _forEachInstanceProperty(queue).call(queue, function(fn) {
                        result = fn();
                    });
                    return result;
                }
            }
        },
        {
            key: "_updateSubGroupHeights",
            value: function _updateSubGroupHeights(margin) {
                var _this4 = this;
                if (_Object$keys(this.subgroups).length > 0) {
                    var me = this;
                    this._resetSubgroups();
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.visibleItems, function(item) {
                        if (item.data.subgroup !== undefined) {
                            me.subgroups[item.data.subgroup].height = Math.max(me.subgroups[item.data.subgroup].height, item.height + margin.item.vertical);
                            me.subgroups[item.data.subgroup].visible = typeof _this4.subgroupVisibility[item.data.subgroup] === "undefined" ? true : Boolean(_this4.subgroupVisibility[item.data.subgroup]);
                        }
                    });
                }
            }
        },
        {
            key: "_isGroupVisible",
            value: function _isGroupVisible(range, margin) {
                return this.top <= range.body.domProps.centerContainer.height - range.body.domProps.scrollTop + margin.axis && this.top + this.height + margin.axis >= -range.body.domProps.scrollTop;
            }
        },
        {
            key: "_calculateHeight",
            value: function _calculateHeight(margin) {
                // recalculate the height of the group
                var height;
                var items;
                if (this.heightMode === "fixed") items = availableUtils.toArray(this.items);
                else // default or 'auto'
                items = this.visibleItems;
                if (items.length > 0) {
                    var min = items[0].top;
                    var max = items[0].top + items[0].height;
                    _forEachInstanceProperty(availableUtils).call(availableUtils, items, function(item) {
                        min = Math.min(min, item.top);
                        max = Math.max(max, item.top + item.height);
                    });
                    if (min > margin.axis) {
                        // there is an empty gap between the lowest item and the axis
                        var offset = min - margin.axis;
                        max -= offset;
                        _forEachInstanceProperty(availableUtils).call(availableUtils, items, function(item) {
                            item.top -= offset;
                        });
                    }
                    height = Math.ceil(max + margin.item.vertical / 2);
                    if (this.heightMode !== "fitItems") height = Math.max(height, this.props.label.height);
                } else height = this.props.label.height;
                return height;
            }
        },
        {
            key: "show",
            value: function show() {
                if (!this.dom.label.parentNode) this.itemSet.dom.labelSet.appendChild(this.dom.label);
                if (!this.dom.foreground.parentNode) this.itemSet.dom.foreground.appendChild(this.dom.foreground);
                if (!this.dom.background.parentNode) this.itemSet.dom.background.appendChild(this.dom.background);
                if (!this.dom.axis.parentNode) this.itemSet.dom.axis.appendChild(this.dom.axis);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var label = this.dom.label;
                if (label.parentNode) label.parentNode.removeChild(label);
                var foreground = this.dom.foreground;
                if (foreground.parentNode) foreground.parentNode.removeChild(foreground);
                var background = this.dom.background;
                if (background.parentNode) background.parentNode.removeChild(background);
                var axis = this.dom.axis;
                if (axis.parentNode) axis.parentNode.removeChild(axis);
            }
        },
        {
            key: "add",
            value: function add(item) {
                var _context28;
                this.items[item.id] = item;
                item.setParent(this);
                this.stackDirty = true;
                // add to
                if (item.data.subgroup !== undefined) {
                    this._addToSubgroup(item);
                    this.orderSubgroups();
                }
                if (!_includesInstanceProperty(_context28 = this.visibleItems).call(_context28, item)) {
                    var range = this.itemSet.body.range; // TODO: not nice accessing the range like this
                    this._checkIfVisible(item, this.visibleItems, range);
                }
            }
        },
        {
            key: "_addToSubgroup",
            value: function _addToSubgroup(item) {
                var subgroupId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : item.data.subgroup;
                if (subgroupId != undefined && this.subgroups[subgroupId] === undefined) {
                    this.subgroups[subgroupId] = {
                        height: 0,
                        top: 0,
                        start: item.data.start,
                        end: item.data.end || item.data.start,
                        visible: false,
                        index: this.subgroupIndex,
                        items: [],
                        stack: this.subgroupStackAll || this.subgroupStack[subgroupId] || false
                    };
                    this.subgroupIndex++;
                }
                if (new Date(item.data.start) < new Date(this.subgroups[subgroupId].start)) this.subgroups[subgroupId].start = item.data.start;
                var itemEnd = item.data.end || item.data.start;
                if (new Date(itemEnd) > new Date(this.subgroups[subgroupId].end)) this.subgroups[subgroupId].end = itemEnd;
                this.subgroups[subgroupId].items.push(item);
            }
        },
        {
            key: "_updateSubgroupsSizes",
            value: function _updateSubgroupsSizes() {
                var me = this;
                if (me.subgroups) {
                    var _loop3 = function _loop3() {
                        var _context29;
                        var initialEnd = me.subgroups[subgroup].items[0].data.end || me.subgroups[subgroup].items[0].data.start;
                        var newStart = me.subgroups[subgroup].items[0].data.start;
                        var newEnd = initialEnd - 1;
                        _forEachInstanceProperty(_context29 = me.subgroups[subgroup].items).call(_context29, function(item) {
                            if (new Date(item.data.start) < new Date(newStart)) newStart = item.data.start;
                            var itemEnd = item.data.end || item.data.start;
                            if (new Date(itemEnd) > new Date(newEnd)) newEnd = itemEnd;
                        });
                        me.subgroups[subgroup].start = newStart;
                        me.subgroups[subgroup].end = new Date(newEnd - 1); // -1 to compensate for colliding end to start subgroups;
                    };
                    for(var subgroup in me.subgroups)_loop3();
                }
            }
        },
        {
            key: "orderSubgroups",
            value: function orderSubgroups() {
                if (this.subgroupOrderer !== undefined) {
                    var sortArray = [];
                    if (typeof this.subgroupOrderer == "string") {
                        for(var subgroup in this.subgroups)sortArray.push({
                            subgroup: subgroup,
                            sortField: this.subgroups[subgroup].items[0].data[this.subgroupOrderer]
                        });
                        _sortInstanceProperty(sortArray).call(sortArray, function(a, b) {
                            return a.sortField - b.sortField;
                        });
                    } else if (typeof this.subgroupOrderer == "function") {
                        for(var _subgroup in this.subgroups)sortArray.push(this.subgroups[_subgroup].items[0].data);
                        _sortInstanceProperty(sortArray).call(sortArray, this.subgroupOrderer);
                    }
                    if (sortArray.length > 0) for(var i1 = 0; i1 < sortArray.length; i1++)this.subgroups[sortArray[i1].subgroup].index = i1;
                }
            }
        },
        {
            key: "_resetSubgroups",
            value: function _resetSubgroups() {
                for(var subgroup in this.subgroups)if (this.subgroups.hasOwnProperty(subgroup)) {
                    this.subgroups[subgroup].visible = false;
                    this.subgroups[subgroup].height = 0;
                }
            }
        },
        {
            key: "remove",
            value: function remove(item) {
                var _context30, _context31;
                delete this.items[item.id];
                item.setParent(null);
                this.stackDirty = true;
                // remove from visible items
                var index = _indexOfInstanceProperty(_context30 = this.visibleItems).call(_context30, item);
                if (index != -1) _spliceInstanceProperty(_context31 = this.visibleItems).call(_context31, index, 1);
                if (item.data.subgroup !== undefined) {
                    this._removeFromSubgroup(item);
                    this.orderSubgroups();
                }
            }
        },
        {
            key: "_removeFromSubgroup",
            value: function _removeFromSubgroup(item) {
                var subgroupId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : item.data.subgroup;
                if (subgroupId != undefined) {
                    var subgroup = this.subgroups[subgroupId];
                    if (subgroup) {
                        var _context32;
                        var itemIndex = _indexOfInstanceProperty(_context32 = subgroup.items).call(_context32, item);
                        //  Check the item is actually in this subgroup. How should items not in the group be handled?
                        if (itemIndex >= 0) {
                            var _context33;
                            _spliceInstanceProperty(_context33 = subgroup.items).call(_context33, itemIndex, 1);
                            if (!subgroup.items.length) delete this.subgroups[subgroupId];
                            else this._updateSubgroupsSizes();
                        }
                    }
                }
            }
        },
        {
            key: "removeFromDataSet",
            value: function removeFromDataSet(item) {
                this.itemSet.removeItem(item.id);
            }
        },
        {
            key: "order",
            value: function order() {
                var array = availableUtils.toArray(this.items);
                var startArray = [];
                var endArray = [];
                for(var i1 = 0; i1 < array.length; i1++){
                    if (array[i1].data.end !== undefined) endArray.push(array[i1]);
                    startArray.push(array[i1]);
                }
                this.orderedItems = {
                    byStart: startArray,
                    byEnd: endArray
                };
                orderByStart(this.orderedItems.byStart);
                orderByEnd(this.orderedItems.byEnd);
            }
        },
        {
            key: "_updateItemsInRange",
            value: function _updateItemsInRange(orderedItems, oldVisibleItems, range) {
                var visibleItems = [];
                var visibleItemsLookup = {}; // we keep this to quickly look up if an item already exists in the list without using indexOf on visibleItems
                if (!this.isVisible && this.height !== undefined && this.groupId != ReservedGroupIds$1.BACKGROUND) {
                    for(var i1 = 0; i1 < oldVisibleItems.length; i1++){
                        var item = oldVisibleItems[i1];
                        if (item.displayed) item.hide();
                    }
                    return visibleItems;
                }
                var interval = (range.end - range.start) / 4;
                var lowerBound = range.start - interval;
                var upperBound = range.end + interval;
                // this function is used to do the binary search for items having start date only.
                var startSearchFunction = function startSearchFunction(value) {
                    if (value < lowerBound) return -1;
                    else if (value <= upperBound) return 0;
                    else return 1;
                };
                // this function is used to do the binary search for items having start and end dates (range).
                var endSearchFunction = function endSearchFunction(data) {
                    var start = data.start, end = data.end;
                    if (end < lowerBound) return -1;
                    else if (start <= upperBound) return 0;
                    else return 1;
                };
                // first check if the items that were in view previously are still in view.
                // IMPORTANT: this handles the case for the items with startdate before the window and enddate after the window!
                // also cleans up invisible items.
                if (oldVisibleItems.length > 0) for(var _i = 0; _i < oldVisibleItems.length; _i++)this._checkIfVisibleWithReference(oldVisibleItems[_i], visibleItems, visibleItemsLookup, range);
                // we do a binary search for the items that have only start values.
                var initialPosByStart = availableUtils.binarySearchCustom(orderedItems.byStart, startSearchFunction, "data", "start");
                // trace the visible items from the inital start pos both ways until an invisible item is found, we only look at the start values.
                this._traceVisible(initialPosByStart, orderedItems.byStart, visibleItems, visibleItemsLookup, function(item) {
                    return item.data.start < lowerBound || item.data.start > upperBound;
                });
                // if the window has changed programmatically without overlapping the old window, the ranged items with start < lowerBound and end > upperbound are not shown.
                // We therefore have to brute force check all items in the byEnd list
                if (this.checkRangedItems == true) {
                    this.checkRangedItems = false;
                    for(var _i2 = 0; _i2 < orderedItems.byEnd.length; _i2++)this._checkIfVisibleWithReference(orderedItems.byEnd[_i2], visibleItems, visibleItemsLookup, range);
                } else {
                    // we do a binary search for the items that have defined end times.
                    var initialPosByEnd = availableUtils.binarySearchCustom(orderedItems.byEnd, endSearchFunction, "data");
                    // trace the visible items from the inital start pos both ways until an invisible item is found, we only look at the end values.
                    this._traceVisible(initialPosByEnd, orderedItems.byEnd, visibleItems, visibleItemsLookup, function(item) {
                        return item.data.end < lowerBound || item.data.start > upperBound;
                    });
                }
                var redrawQueue = {};
                var redrawQueueLength = 0;
                for(var _i3 = 0; _i3 < visibleItems.length; _i3++){
                    var _item = visibleItems[_i3];
                    if (!_item.displayed) {
                        var returnQueue = true;
                        redrawQueue[_i3] = _item.redraw(returnQueue);
                        redrawQueueLength = redrawQueue[_i3].length;
                    }
                }
                var needRedraw = redrawQueueLength > 0;
                if (needRedraw) {
                    var _loop4 = function _loop4(j) {
                        _forEachInstanceProperty(availableUtils).call(availableUtils, redrawQueue, function(fns) {
                            fns[j]();
                        });
                    };
                    // redraw all regular items
                    for(var j = 0; j < redrawQueueLength; j++)_loop4(j);
                }
                for(var _i4 = 0; _i4 < visibleItems.length; _i4++)visibleItems[_i4].repositionX();
                return visibleItems;
            }
        },
        {
            key: "_traceVisible",
            value: function _traceVisible(initialPos, items, visibleItems, visibleItemsLookup, breakCondition) {
                if (initialPos != -1) {
                    for(var i1 = initialPos; i1 >= 0; i1--){
                        var item = items[i1];
                        if (breakCondition(item)) break;
                        else {
                            if (!(item.isCluster && !item.hasItems()) && !item.cluster) {
                                if (visibleItemsLookup[item.id] === undefined) {
                                    visibleItemsLookup[item.id] = true;
                                    visibleItems.push(item);
                                }
                            }
                        }
                    }
                    for(var _i5 = initialPos + 1; _i5 < items.length; _i5++){
                        var _item2 = items[_i5];
                        if (breakCondition(_item2)) break;
                        else {
                            if (!(_item2.isCluster && !_item2.hasItems()) && !_item2.cluster) {
                                if (visibleItemsLookup[_item2.id] === undefined) {
                                    visibleItemsLookup[_item2.id] = true;
                                    visibleItems.push(_item2);
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            key: "_checkIfVisible",
            value: function _checkIfVisible(item, visibleItems, range) {
                if (item.isVisible(range)) {
                    if (!item.displayed) item.show();
                    // reposition item horizontally
                    item.repositionX();
                    visibleItems.push(item);
                } else if (item.displayed) item.hide();
            }
        },
        {
            key: "_checkIfVisibleWithReference",
            value: function _checkIfVisibleWithReference(item, visibleItems, visibleItemsLookup, range) {
                if (item.isVisible(range)) {
                    if (visibleItemsLookup[item.id] === undefined) {
                        visibleItemsLookup[item.id] = true;
                        visibleItems.push(item);
                    }
                } else if (item.displayed) item.hide();
            }
        },
        {
            key: "_updateClustersInRange",
            value: function _updateClustersInRange(orderedClusters, oldVisibleClusters, range) {
                // Clusters can overlap each other so we cannot use binary search here
                var visibleClusters = [];
                var visibleClustersLookup = {}; // we keep this to quickly look up if an item already exists in the list without using indexOf on visibleItems
                if (oldVisibleClusters.length > 0) for(var i1 = 0; i1 < oldVisibleClusters.length; i1++)this._checkIfVisibleWithReference(oldVisibleClusters[i1], visibleClusters, visibleClustersLookup, range);
                for(var _i6 = 0; _i6 < orderedClusters.byStart.length; _i6++)this._checkIfVisibleWithReference(orderedClusters.byStart[_i6], visibleClusters, visibleClustersLookup, range);
                for(var _i7 = 0; _i7 < orderedClusters.byEnd.length; _i7++)this._checkIfVisibleWithReference(orderedClusters.byEnd[_i7], visibleClusters, visibleClustersLookup, range);
                var redrawQueue = {};
                var redrawQueueLength = 0;
                for(var _i8 = 0; _i8 < visibleClusters.length; _i8++){
                    var item = visibleClusters[_i8];
                    if (!item.displayed) {
                        var returnQueue = true;
                        redrawQueue[_i8] = item.redraw(returnQueue);
                        redrawQueueLength = redrawQueue[_i8].length;
                    }
                }
                var needRedraw = redrawQueueLength > 0;
                if (needRedraw) // redraw all regular items
                for(var j = 0; j < redrawQueueLength; j++)_forEachInstanceProperty(availableUtils).call(availableUtils, redrawQueue, function(fns) {
                    fns[j]();
                });
                for(var _i9 = 0; _i9 < visibleClusters.length; _i9++)visibleClusters[_i9].repositionX();
                return visibleClusters;
            }
        },
        {
            key: "changeSubgroup",
            value: function changeSubgroup(item, oldSubgroup, newSubgroup) {
                this._removeFromSubgroup(item, oldSubgroup);
                this._addToSubgroup(item, newSubgroup);
                this.orderSubgroups();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.hide();
                var disposeCallback;
                while(disposeCallback = this._disposeCallbacks.pop())disposeCallback();
            }
        }
    ]);
    return Group;
}();
function _createSuper$8(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$8();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$8() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @constructor BackgroundGroup
 * @extends Group
 */ var BackgroundGroup = /*#__PURE__*/ function(_Group) {
    _inherits(BackgroundGroup, _Group);
    var _super = _createSuper$8(BackgroundGroup);
    /**
  * @param {number | string} groupId
  * @param {Object} data
  * @param {ItemSet} itemSet
  */ function BackgroundGroup(groupId, data, itemSet) {
        var _this;
        _classCallCheck(this, BackgroundGroup);
        _this = _super.call(this, groupId, data, itemSet);
        // Group.call(this, groupId, data, itemSet);
        _this.width = 0;
        _this.height = 0;
        _this.top = 0;
        _this.left = 0;
        return _this;
    }
    /**
   * Repaint this group
   * @param {{start: number, end: number}} range
   * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
   * @param {boolean} [forceRestack=false]  Force restacking of all items
   * @return {boolean} Returns true if the group is resized
   */ _createClass(BackgroundGroup, [
        {
            key: "redraw",
            value: function redraw(range, margin, forceRestack) {
                // eslint-disable-line no-unused-vars
                var resized = false;
                this.visibleItems = this._updateItemsInRange(this.orderedItems, this.visibleItems, range);
                // calculate actual size
                this.width = this.dom.background.offsetWidth;
                // apply new height (just always zero for BackgroundGroup
                this.dom.background.style.height = "0";
                // update vertical position of items after they are re-stacked and the height of the group is calculated
                for(var i1 = 0, ii = this.visibleItems.length; i1 < ii; i1++){
                    var item = this.visibleItems[i1];
                    item.repositionY(margin);
                }
                return resized;
            }
        },
        {
            key: "show",
            value: function show() {
                if (!this.dom.background.parentNode) this.itemSet.dom.background.appendChild(this.dom.background);
            }
        }
    ]);
    return BackgroundGroup;
}(Group);
var css_248z$5 = '\n.vis-item {\n  position: absolute;\n  color: #1A1A1A;\n  border-color: #97B0F8;\n  border-width: 1px;\n  background-color: #D5DDF6;\n  display: inline-block;\n  z-index: 1;\n  /*overflow: hidden;*/\n}\n\n.vis-item.vis-selected {\n  border-color: #FFC200;\n  background-color: #FFF785;\n\n  /* z-index must be higher than the z-index of custom time bar and current time bar */\n  z-index: 2;\n}\n\n.vis-editable.vis-selected {\n  cursor: move;\n}\n\n.vis-item.vis-point.vis-selected {\n  background-color: #FFF785;\n}\n\n.vis-item.vis-box {\n  text-align: center;\n  border-style: solid;\n  border-radius: 2px;\n}\n\n.vis-item.vis-point {\n  background: none;\n}\n\n.vis-item.vis-dot {\n  position: absolute;\n  padding: 0;\n  border-width: 4px;\n  border-style: solid;\n  border-radius: 4px;\n}\n\n.vis-item.vis-range {\n  border-style: solid;\n  border-radius: 2px;\n  box-sizing: border-box;\n}\n\n.vis-item.vis-background {\n  border: none;\n  background-color: rgba(213, 221, 246, 0.4);\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\n.vis-item .vis-item-overflow {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n}\n\n.vis-item-visible-frame {\n  white-space: nowrap;\n}\n\n.vis-item.vis-range .vis-item-content {\n  position: relative;\n  display: inline-block;\n}\n\n.vis-item.vis-background .vis-item-content {\n  position: absolute;\n  display: inline-block;\n}\n\n.vis-item.vis-line {\n  padding: 0;\n  position: absolute;\n  width: 0;\n  border-left-width: 1px;\n  border-left-style: solid;\n}\n\n.vis-item .vis-item-content {\n  white-space: nowrap;\n  box-sizing: border-box;\n  padding: 5px;\n}\n\n.vis-item .vis-onUpdateTime-tooltip {\n  position: absolute;\n  background: #4f81bd;\n  color: white;\n  width: 200px;\n  text-align: center;\n  white-space: nowrap;\n  padding: 5px;\n  border-radius: 1px;\n  transition: 0.4s;\n  -o-transition: 0.4s;\n  -moz-transition: 0.4s;\n  -webkit-transition: 0.4s;\n}\n\n.vis-item .vis-delete, .vis-item .vis-delete-rtl {\n  position: absolute;\n  top: 0px;\n  width: 24px;\n  height: 24px;\n  box-sizing: border-box;\n  padding: 0px 5px;\n  cursor: pointer;\n\n  -webkit-transition: background 0.2s linear;\n  -moz-transition: background 0.2s linear;\n  -ms-transition: background 0.2s linear;\n  -o-transition: background 0.2s linear;\n  transition: background 0.2s linear;\n}\n\n.vis-item .vis-delete {\n  right: -24px;\n}\n\n.vis-item .vis-delete-rtl {\n  left: -24px;\n}\n\n.vis-item .vis-delete:after, .vis-item .vis-delete-rtl:after {\n  content: "\\00D7"; /* MULTIPLICATION SIGN */\n  color: red;\n  font-family: arial, sans-serif;\n  font-size: 22px;\n  font-weight: bold;\n\n  -webkit-transition: color 0.2s linear;\n  -moz-transition: color 0.2s linear;\n  -ms-transition: color 0.2s linear;\n  -o-transition: color 0.2s linear;\n  transition: color 0.2s linear;\n}\n\n.vis-item .vis-delete:hover, .vis-item .vis-delete-rtl:hover {\n  background: red;\n}\n\n.vis-item .vis-delete:hover:after, .vis-item .vis-delete-rtl:hover:after {\n  color: white;\n}\n\n.vis-item .vis-drag-center {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0px;\n  cursor: move;\n}\n\n.vis-item.vis-range .vis-drag-left {\n  position: absolute;\n  width: 24px;\n  max-width: 20%;\n  min-width: 2px;\n  height: 100%;\n  top: 0;\n  left: -4px;\n\n  cursor: w-resize;\n}\n\n.vis-item.vis-range .vis-drag-right {\n  position: absolute;\n  width: 24px;\n  max-width: 20%;\n  min-width: 2px;\n  height: 100%;\n  top: 0;\n  right: -4px;\n\n  cursor: e-resize;\n}\n\n.vis-range.vis-item.vis-readonly .vis-drag-left,\n.vis-range.vis-item.vis-readonly .vis-drag-right {\n  cursor: auto;\n}\n\n.vis-item.vis-cluster {\n  vertical-align: center;\n  text-align: center;\n  border-style: solid;\n  border-radius: 2px;\n}\n\n.vis-item.vis-cluster-line {\n  padding: 0;\n  position: absolute;\n  width: 0;\n  border-left-width: 1px;\n  border-left-style: solid;\n}\n\n.vis-item.vis-cluster-dot {\n  position: absolute;\n  padding: 0;\n  border-width: 4px;\n  border-style: solid;\n  border-radius: 4px;\n}';
styleInject(css_248z$5);
function _createForOfIteratorHelper$4(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$4(o, minLen) {
    var _context8;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
    var n = _sliceInstanceProperty(_context8 = Object.prototype.toString.call(o)).call(_context8, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
}
function _arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
/**
 * Item
 */ var Item = /*#__PURE__*/ function() {
    /**
  * @constructor Item
  * @param {Object} data             Object containing (optional) parameters type,
  *                                  start, end, content, group, className.
  * @param {{toScreen: function, toTime: function}} conversion
  *                                  Conversion functions from time to screen and vice versa
  * @param {Object} options          Configuration options
  *                                  // TODO: describe available options
  */ function Item(data, conversion, options) {
        var _context, _this = this;
        _classCallCheck(this, Item);
        this.id = null;
        this.parent = null;
        this.data = data;
        this.dom = null;
        this.conversion = conversion || {};
        this.defaultOptions = {
            locales: locales,
            locale: "en"
        };
        this.options = availableUtils.extend({}, this.defaultOptions, options);
        this.options.locales = availableUtils.extend({}, locales, this.options.locales);
        var defaultLocales = this.defaultOptions.locales[this.defaultOptions.locale];
        _forEachInstanceProperty(_context = _Object$keys(this.options.locales)).call(_context, function(locale) {
            _this.options.locales[locale] = availableUtils.extend({}, defaultLocales, _this.options.locales[locale]);
        });
        this.selected = false;
        this.displayed = false;
        this.groupShowing = true;
        this.selectable = options && options.selectable || false;
        this.dirty = true;
        this.top = null;
        this.right = null;
        this.left = null;
        this.width = null;
        this.height = null;
        this.setSelectability(data);
        this.editable = null;
        this._updateEditStatus();
    }
    /**
   * Select current item
   */ _createClass(Item, [
        {
            key: "select",
            value: function select() {
                if (this.selectable) {
                    this.selected = true;
                    this.dirty = true;
                    if (this.displayed) this.redraw();
                }
            }
        },
        {
            key: "unselect",
            value: function unselect() {
                this.selected = false;
                this.dirty = true;
                if (this.displayed) this.redraw();
            }
        },
        {
            key: "setData",
            value: function setData(data) {
                var groupChanged = data.group != undefined && this.data.group != data.group;
                if (groupChanged && this.parent != null) this.parent.itemSet._moveToGroup(this, data.group);
                this.setSelectability(data);
                if (this.parent) this.parent.stackDirty = true;
                var subGroupChanged = data.subgroup != undefined && this.data.subgroup != data.subgroup;
                if (subGroupChanged && this.parent != null) this.parent.changeSubgroup(this, this.data.subgroup, data.subgroup);
                this.data = data;
                this._updateEditStatus();
                this.dirty = true;
                if (this.displayed) this.redraw();
            }
        },
        {
            key: "setSelectability",
            value: function setSelectability(data) {
                if (data) this.selectable = typeof data.selectable === "undefined" ? true : Boolean(data.selectable);
            }
        },
        {
            key: "setParent",
            value: function setParent(parent) {
                if (this.displayed) {
                    this.hide();
                    this.parent = parent;
                    if (this.parent) this.show();
                } else this.parent = parent;
            }
        },
        {
            key: "isVisible",
            value: function isVisible(range) {
                // eslint-disable-line no-unused-vars
                return false;
            }
        },
        {
            key: "show",
            value: function show() {
                return false;
            }
        },
        {
            key: "hide",
            value: function hide() {
                return false;
            }
        },
        {
            key: "redraw",
            value: function redraw() {
            // should be implemented by the item
            }
        },
        {
            key: "repositionX",
            value: function repositionX() {
            // should be implemented by the item
            }
        },
        {
            key: "repositionY",
            value: function repositionY() {
            // should be implemented by the item
            }
        },
        {
            key: "_repaintDragCenter",
            value: function _repaintDragCenter() {
                if (this.selected && this.editable.updateTime && !this.dom.dragCenter) {
                    var _context2, _context3;
                    var me = this;
                    // create and show drag area
                    var dragCenter = document.createElement("div");
                    dragCenter.className = "vis-drag-center";
                    dragCenter.dragCenterItem = this;
                    this.hammerDragCenter = new Hammer(dragCenter);
                    this.hammerDragCenter.on("tap", function(event1) {
                        me.parent.itemSet.body.emitter.emit("click", {
                            event: event1,
                            item: me.id
                        });
                    });
                    this.hammerDragCenter.on("doubletap", function(event1) {
                        event1.stopPropagation();
                        me.parent.itemSet._onUpdateItem(me);
                        me.parent.itemSet.body.emitter.emit("doubleClick", {
                            event: event1,
                            item: me.id
                        });
                    });
                    this.hammerDragCenter.on("panstart", function(event1) {
                        // do not allow this event to propagate to the Range
                        event1.stopPropagation();
                        me.parent.itemSet._onDragStart(event1);
                    });
                    this.hammerDragCenter.on("panmove", _bindInstanceProperty$1(_context2 = me.parent.itemSet._onDrag).call(_context2, me.parent.itemSet));
                    this.hammerDragCenter.on("panend", _bindInstanceProperty$1(_context3 = me.parent.itemSet._onDragEnd).call(_context3, me.parent.itemSet));
                    // delay addition on item click for trackpads...
                    this.hammerDragCenter.get("press").set({
                        time: 10000
                    });
                    if (this.dom.box) {
                        if (this.dom.dragLeft) this.dom.box.insertBefore(dragCenter, this.dom.dragLeft);
                        else this.dom.box.appendChild(dragCenter);
                    } else if (this.dom.point) this.dom.point.appendChild(dragCenter);
                    this.dom.dragCenter = dragCenter;
                } else if (!this.selected && this.dom.dragCenter) {
                    // delete drag area
                    if (this.dom.dragCenter.parentNode) this.dom.dragCenter.parentNode.removeChild(this.dom.dragCenter);
                    this.dom.dragCenter = null;
                    if (this.hammerDragCenter) {
                        this.hammerDragCenter.destroy();
                        this.hammerDragCenter = null;
                    }
                }
            }
        },
        {
            key: "_repaintDeleteButton",
            value: function _repaintDeleteButton(anchor) {
                var editable = (this.options.editable.overrideItems || this.editable == null) && this.options.editable.remove || !this.options.editable.overrideItems && this.editable != null && this.editable.remove;
                if (this.selected && editable && !this.dom.deleteButton) {
                    // create and show button
                    var me = this;
                    var deleteButton = document.createElement("div");
                    if (this.options.rtl) deleteButton.className = "vis-delete-rtl";
                    else deleteButton.className = "vis-delete";
                    var optionsLocale = this.options.locales[this.options.locale];
                    if (!optionsLocale) {
                        if (!this.warned) {
                            console.warn("WARNING: options.locales['".concat(this.options.locale, "'] not found. See https://visjs.github.io/vis-timeline/docs/timeline/#Localization"));
                            this.warned = true;
                        }
                        optionsLocale = this.options.locales["en"]; // fall back on english when not available
                    }
                    deleteButton.title = optionsLocale.deleteSelected;
                    // TODO: be able to destroy the delete button
                    this.hammerDeleteButton = new Hammer(deleteButton).on("tap", function(event1) {
                        event1.stopPropagation();
                        me.parent.removeFromDataSet(me);
                    });
                    anchor.appendChild(deleteButton);
                    this.dom.deleteButton = deleteButton;
                } else if ((!this.selected || !editable) && this.dom.deleteButton) {
                    // remove button
                    if (this.dom.deleteButton.parentNode) this.dom.deleteButton.parentNode.removeChild(this.dom.deleteButton);
                    this.dom.deleteButton = null;
                    if (this.hammerDeleteButton) {
                        this.hammerDeleteButton.destroy();
                        this.hammerDeleteButton = null;
                    }
                }
            }
        },
        {
            key: "_repaintOnItemUpdateTimeTooltip",
            value: function _repaintOnItemUpdateTimeTooltip(anchor) {
                if (!this.options.tooltipOnItemUpdateTime) return;
                var editable = (this.options.editable.updateTime || this.data.editable === true) && this.data.editable !== false;
                if (this.selected && editable && !this.dom.onItemUpdateTimeTooltip) {
                    var onItemUpdateTimeTooltip = document.createElement("div");
                    onItemUpdateTimeTooltip.className = "vis-onUpdateTime-tooltip";
                    anchor.appendChild(onItemUpdateTimeTooltip);
                    this.dom.onItemUpdateTimeTooltip = onItemUpdateTimeTooltip;
                } else if (!this.selected && this.dom.onItemUpdateTimeTooltip) {
                    // remove button
                    if (this.dom.onItemUpdateTimeTooltip.parentNode) this.dom.onItemUpdateTimeTooltip.parentNode.removeChild(this.dom.onItemUpdateTimeTooltip);
                    this.dom.onItemUpdateTimeTooltip = null;
                }
                // position onChange tooltip
                if (this.dom.onItemUpdateTimeTooltip) {
                    // only show when editing
                    this.dom.onItemUpdateTimeTooltip.style.visibility = this.parent.itemSet.touchParams.itemIsDragging ? "visible" : "hidden";
                    // position relative to item's content
                    this.dom.onItemUpdateTimeTooltip.style.transform = "translateX(-50%)";
                    this.dom.onItemUpdateTimeTooltip.style.left = "50%";
                    // position above or below the item depending on the item's position in the window
                    var tooltipOffset = 50; // TODO: should be tooltip height (depends on template)
                    var scrollTop = this.parent.itemSet.body.domProps.scrollTop;
                    // TODO: this.top for orientation:true is actually the items distance from the bottom... 
                    // (should be this.bottom)
                    var itemDistanceFromTop;
                    if (this.options.orientation.item == "top") itemDistanceFromTop = this.top;
                    else itemDistanceFromTop = this.parent.height - this.top - this.height;
                    var isCloseToTop = itemDistanceFromTop + this.parent.top - tooltipOffset < -scrollTop;
                    if (isCloseToTop) {
                        this.dom.onItemUpdateTimeTooltip.style.bottom = "";
                        this.dom.onItemUpdateTimeTooltip.style.top = "".concat(this.height + 2, "px");
                    } else {
                        this.dom.onItemUpdateTimeTooltip.style.top = "";
                        this.dom.onItemUpdateTimeTooltip.style.bottom = "".concat(this.height + 2, "px");
                    }
                    // handle tooltip content
                    var content;
                    var templateFunction;
                    if (this.options.tooltipOnItemUpdateTime && this.options.tooltipOnItemUpdateTime.template) {
                        var _context4;
                        templateFunction = _bindInstanceProperty$1(_context4 = this.options.tooltipOnItemUpdateTime.template).call(_context4, this);
                        content = templateFunction(this.data);
                    } else {
                        content = "start: ".concat(moment$4(this.data.start).format("MM/DD/YYYY hh:mm"));
                        if (this.data.end) content += "<br> end: ".concat(moment$4(this.data.end).format("MM/DD/YYYY hh:mm"));
                    }
                    this.dom.onItemUpdateTimeTooltip.innerHTML = availableUtils.xss(content);
                }
            }
        },
        {
            key: "_getItemData",
            value: function _getItemData() {
                return this.parent.itemSet.itemsData.get(this.id);
            }
        },
        {
            key: "_updateContents",
            value: function _updateContents(element) {
                var content;
                var changed;
                var templateFunction;
                var itemVisibleFrameContent;
                var visibleFrameTemplateFunction;
                var itemData = this._getItemData(); // get a clone of the data from the dataset
                var frameElement = this.dom.box || this.dom.point;
                var itemVisibleFrameContentElement = frameElement.getElementsByClassName("vis-item-visible-frame")[0];
                if (this.options.visibleFrameTemplate) {
                    var _context5;
                    visibleFrameTemplateFunction = _bindInstanceProperty$1(_context5 = this.options.visibleFrameTemplate).call(_context5, this);
                    itemVisibleFrameContent = availableUtils.xss(visibleFrameTemplateFunction(itemData, itemVisibleFrameContentElement));
                } else itemVisibleFrameContent = "";
                if (itemVisibleFrameContentElement) {
                    if (itemVisibleFrameContent instanceof Object && !(itemVisibleFrameContent instanceof Element)) visibleFrameTemplateFunction(itemData, itemVisibleFrameContentElement);
                    else {
                        changed = this._contentToString(this.itemVisibleFrameContent) !== this._contentToString(itemVisibleFrameContent);
                        if (changed) {
                            // only replace the content when changed
                            if (itemVisibleFrameContent instanceof Element) {
                                itemVisibleFrameContentElement.innerHTML = "";
                                itemVisibleFrameContentElement.appendChild(itemVisibleFrameContent);
                            } else if (itemVisibleFrameContent != undefined) itemVisibleFrameContentElement.innerHTML = availableUtils.xss(itemVisibleFrameContent);
                            else {
                                if (!(this.data.type == "background" && this.data.content === undefined)) throw new Error('Property "content" missing in item '.concat(this.id));
                            }
                            this.itemVisibleFrameContent = itemVisibleFrameContent;
                        }
                    }
                }
                if (this.options.template) {
                    var _context6;
                    templateFunction = _bindInstanceProperty$1(_context6 = this.options.template).call(_context6, this);
                    content = templateFunction(itemData, element, this.data);
                } else content = this.data.content;
                if (content instanceof Object && !(content instanceof Element)) templateFunction(itemData, element);
                else {
                    changed = this._contentToString(this.content) !== this._contentToString(content);
                    if (changed) {
                        // only replace the content when changed
                        if (content instanceof Element) {
                            element.innerHTML = "";
                            element.appendChild(content);
                        } else if (content != undefined) element.innerHTML = availableUtils.xss(content);
                        else {
                            if (!(this.data.type == "background" && this.data.content === undefined)) throw new Error('Property "content" missing in item '.concat(this.id));
                        }
                        this.content = content;
                    }
                }
            }
        },
        {
            key: "_updateDataAttributes",
            value: function _updateDataAttributes(element) {
                if (this.options.dataAttributes && this.options.dataAttributes.length > 0) {
                    var attributes = [];
                    if (_Array$isArray(this.options.dataAttributes)) attributes = this.options.dataAttributes;
                    else if (this.options.dataAttributes == "all") attributes = _Object$keys(this.data);
                    else return;
                    var _iterator = _createForOfIteratorHelper$4(attributes), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var value = this.data[name];
                            if (value != null) element.setAttribute("data-".concat(name), value);
                            else element.removeAttribute("data-".concat(name));
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        },
        {
            key: "_updateStyle",
            value: function _updateStyle(element) {
                // remove old styles
                if (this.style) {
                    availableUtils.removeCssText(element, this.style);
                    this.style = null;
                }
                // append new styles
                if (this.data.style) {
                    availableUtils.addCssText(element, this.data.style);
                    this.style = this.data.style;
                }
            }
        },
        {
            key: "_contentToString",
            value: function _contentToString(content) {
                if (typeof content === "string") return content;
                if (content && "outerHTML" in content) return content.outerHTML;
                return content;
            }
        },
        {
            key: "_updateEditStatus",
            value: function _updateEditStatus() {
                if (this.options) {
                    if (typeof this.options.editable === "boolean") this.editable = {
                        updateTime: this.options.editable,
                        updateGroup: this.options.editable,
                        remove: this.options.editable
                    };
                    else if (_typeof$1(this.options.editable) === "object") {
                        this.editable = {};
                        availableUtils.selectiveExtend([
                            "updateTime",
                            "updateGroup",
                            "remove"
                        ], this.editable, this.options.editable);
                    }
                }
                // Item data overrides, except if options.editable.overrideItems is set.
                if (!this.options || !this.options.editable || this.options.editable.overrideItems !== true) {
                    if (this.data) {
                        if (typeof this.data.editable === "boolean") this.editable = {
                            updateTime: this.data.editable,
                            updateGroup: this.data.editable,
                            remove: this.data.editable
                        };
                        else if (_typeof$1(this.data.editable) === "object") {
                            // TODO: in timeline.js 5.0, we should change this to not reset options from the timeline configuration.
                            // Basically just remove the next line...
                            this.editable = {};
                            availableUtils.selectiveExtend([
                                "updateTime",
                                "updateGroup",
                                "remove"
                            ], this.editable, this.data.editable);
                        }
                    }
                }
            }
        },
        {
            key: "getWidthLeft",
            value: function getWidthLeft() {
                return 0;
            }
        },
        {
            key: "getWidthRight",
            value: function getWidthRight() {
                return 0;
            }
        },
        {
            key: "getTitle",
            value: function getTitle() {
                if (this.options.tooltip && this.options.tooltip.template) {
                    var _context7;
                    var templateFunction = _bindInstanceProperty$1(_context7 = this.options.tooltip.template).call(_context7, this);
                    return templateFunction(this._getItemData(), this.data);
                }
                return this.data.title;
            }
        }
    ]);
    return Item;
}();
Item.prototype.stack = true;
function _createSuper$7(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$7() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @constructor BoxItem
 * @extends Item
 */ var BoxItem = /*#__PURE__*/ function(_Item) {
    _inherits(BoxItem, _Item);
    var _super = _createSuper$7(BoxItem);
    /**
  * @param {Object} data             Object containing parameters start
  *                                  content, className.
  * @param {{toScreen: function, toTime: function}} conversion
  *                                  Conversion functions from time to screen and vice versa
  * @param {Object} [options]        Configuration options
  *                                  // TODO: describe available options
  */ function BoxItem(data, conversion, options) {
        var _this;
        _classCallCheck(this, BoxItem);
        _this = _super.call(this, data, conversion, options);
        _this.props = {
            dot: {
                width: 0,
                height: 0
            },
            line: {
                width: 0,
                height: 0
            }
        };
        // validate data
        if (data) {
            if (data.start == undefined) throw new Error('Property "start" missing in item '.concat(data));
        }
        return _this;
    }
    /**
   * Check whether this item is visible inside given range
   * @param {{start: number, end: number}} range with a timestamp for start and end
   * @returns {boolean} True if visible
   */ _createClass(BoxItem, [
        {
            key: "isVisible",
            value: function isVisible(range) {
                if (this.cluster) return false;
                // determine visibility
                var isVisible;
                var align = this.data.align || this.options.align;
                var widthInMs = this.width * range.getMillisecondsPerPixel();
                if (align == "right") isVisible = this.data.start.getTime() > range.start && this.data.start.getTime() - widthInMs < range.end;
                else if (align == "left") isVisible = this.data.start.getTime() + widthInMs > range.start && this.data.start.getTime() < range.end;
                else // default or 'center'
                isVisible = this.data.start.getTime() + widthInMs / 2 > range.start && this.data.start.getTime() - widthInMs / 2 < range.end;
                return isVisible;
            }
        },
        {
            key: "_createDomElement",
            value: function _createDomElement() {
                if (!this.dom) {
                    // create DOM
                    this.dom = {};
                    // create main box
                    this.dom.box = document.createElement("DIV");
                    // contents box (inside the background box). used for making margins
                    this.dom.content = document.createElement("DIV");
                    this.dom.content.className = "vis-item-content";
                    this.dom.box.appendChild(this.dom.content);
                    // line to axis
                    this.dom.line = document.createElement("DIV");
                    this.dom.line.className = "vis-line";
                    // dot on axis
                    this.dom.dot = document.createElement("DIV");
                    this.dom.dot.className = "vis-dot";
                    // attach this item as attribute
                    this.dom.box["vis-item"] = this;
                    this.dirty = true;
                }
            }
        },
        {
            key: "_appendDomElement",
            value: function _appendDomElement() {
                if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                if (!this.dom.box.parentNode) {
                    var foreground = this.parent.dom.foreground;
                    if (!foreground) throw new Error("Cannot redraw item: parent has no foreground container element");
                    foreground.appendChild(this.dom.box);
                }
                if (!this.dom.line.parentNode) {
                    var background = this.parent.dom.background;
                    if (!background) throw new Error("Cannot redraw item: parent has no background container element");
                    background.appendChild(this.dom.line);
                }
                if (!this.dom.dot.parentNode) {
                    var axis = this.parent.dom.axis;
                    if (!background) throw new Error("Cannot redraw item: parent has no axis container element");
                    axis.appendChild(this.dom.dot);
                }
                this.displayed = true;
            }
        },
        {
            key: "_updateDirtyDomComponents",
            value: function _updateDirtyDomComponents() {
                // An item is marked dirty when:
                // - the item is not yet rendered
                // - the item's data is changed
                // - the item is selected/deselected
                if (this.dirty) {
                    this._updateContents(this.dom.content);
                    this._updateDataAttributes(this.dom.box);
                    this._updateStyle(this.dom.box);
                    var editable = this.editable.updateTime || this.editable.updateGroup;
                    // update class
                    var className = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (editable ? " vis-editable" : " vis-readonly");
                    this.dom.box.className = "vis-item vis-box".concat(className);
                    this.dom.line.className = "vis-item vis-line".concat(className);
                    this.dom.dot.className = "vis-item vis-dot".concat(className);
                }
            }
        },
        {
            key: "_getDomComponentsSizes",
            value: function _getDomComponentsSizes() {
                return {
                    previous: {
                        right: this.dom.box.style.right,
                        left: this.dom.box.style.left
                    },
                    dot: {
                        height: this.dom.dot.offsetHeight,
                        width: this.dom.dot.offsetWidth
                    },
                    line: {
                        width: this.dom.line.offsetWidth
                    },
                    box: {
                        width: this.dom.box.offsetWidth,
                        height: this.dom.box.offsetHeight
                    }
                };
            }
        },
        {
            key: "_updateDomComponentsSizes",
            value: function _updateDomComponentsSizes(sizes) {
                if (this.options.rtl) this.dom.box.style.right = "0px";
                else this.dom.box.style.left = "0px";
                // recalculate size
                this.props.dot.height = sizes.dot.height;
                this.props.dot.width = sizes.dot.width;
                this.props.line.width = sizes.line.width;
                this.width = sizes.box.width;
                this.height = sizes.box.height;
                // restore previous position
                if (this.options.rtl) this.dom.box.style.right = sizes.previous.right;
                else this.dom.box.style.left = sizes.previous.left;
                this.dirty = false;
            }
        },
        {
            key: "_repaintDomAdditionals",
            value: function _repaintDomAdditionals() {
                this._repaintOnItemUpdateTimeTooltip(this.dom.box);
                this._repaintDragCenter();
                this._repaintDeleteButton(this.dom.box);
            }
        },
        {
            key: "redraw",
            value: function redraw(returnQueue) {
                var _context, _context2, _context3, _this2 = this, _context5;
                var sizes;
                var queue = [
                    // create item DOM
                    _bindInstanceProperty$1(_context = this._createDomElement).call(_context, this),
                    // append DOM to parent DOM
                    _bindInstanceProperty$1(_context2 = this._appendDomElement).call(_context2, this),
                    // update dirty DOM
                    _bindInstanceProperty$1(_context3 = this._updateDirtyDomComponents).call(_context3, this),
                    function() {
                        if (_this2.dirty) sizes = _this2._getDomComponentsSizes();
                    },
                    function() {
                        if (_this2.dirty) {
                            var _context4;
                            _bindInstanceProperty$1(_context4 = _this2._updateDomComponentsSizes).call(_context4, _this2)(sizes);
                        }
                    },
                    // repaint DOM additionals
                    _bindInstanceProperty$1(_context5 = this._repaintDomAdditionals).call(_context5, this)
                ];
                if (returnQueue) return queue;
                else {
                    var result;
                    _forEachInstanceProperty(queue).call(queue, function(fn) {
                        result = fn();
                    });
                    return result;
                }
            }
        },
        {
            key: "show",
            value: function show(returnQueue) {
                if (!this.displayed) return this.redraw(returnQueue);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.displayed) {
                    var dom = this.dom;
                    if (dom.box.remove) dom.box.remove();
                    else if (dom.box.parentNode) dom.box.parentNode.removeChild(dom.box); // IE11
                    if (dom.line.remove) dom.line.remove();
                    else if (dom.line.parentNode) dom.line.parentNode.removeChild(dom.line); // IE11
                    if (dom.dot.remove) dom.dot.remove();
                    else if (dom.dot.parentNode) dom.dot.parentNode.removeChild(dom.dot); // IE11
                    this.displayed = false;
                }
            }
        },
        {
            key: "repositionXY",
            value: function repositionXY() {
                var rtl = this.options.rtl;
                var repositionXY = function repositionXY(element, x, y) {
                    var _context6;
                    var rtl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                    if (x === undefined && y === undefined) return;
                    // If rtl invert the number.
                    var directionX = rtl ? x * -1 : x;
                    //no y. translate x
                    if (y === undefined) {
                        element.style.transform = "translateX(".concat(directionX, "px)");
                        return;
                    }
                    //no x. translate y
                    if (x === undefined) {
                        element.style.transform = "translateY(".concat(y, "px)");
                        return;
                    }
                    element.style.transform = _concatInstanceProperty(_context6 = "translate(".concat(directionX, "px, ")).call(_context6, y, "px)");
                };
                repositionXY(this.dom.box, this.boxX, this.boxY, rtl);
                repositionXY(this.dom.dot, this.dotX, this.dotY, rtl);
                repositionXY(this.dom.line, this.lineX, this.lineY, rtl);
            }
        },
        {
            key: "repositionX",
            value: function repositionX() {
                var start = this.conversion.toScreen(this.data.start);
                var align = this.data.align === undefined ? this.options.align : this.data.align;
                var lineWidth = this.props.line.width;
                var dotWidth = this.props.dot.width;
                if (align == "right") {
                    // calculate right position of the box
                    this.boxX = start - this.width;
                    this.lineX = start - lineWidth;
                    this.dotX = start - lineWidth / 2 - dotWidth / 2;
                } else if (align == "left") {
                    // calculate left position of the box
                    this.boxX = start;
                    this.lineX = start;
                    this.dotX = start + lineWidth / 2 - dotWidth / 2;
                } else {
                    // default or 'center'
                    this.boxX = start - this.width / 2;
                    this.lineX = this.options.rtl ? start - lineWidth : start - lineWidth / 2;
                    this.dotX = start - dotWidth / 2;
                }
                if (this.options.rtl) this.right = this.boxX;
                else this.left = this.boxX;
                this.repositionXY();
            }
        },
        {
            key: "repositionY",
            value: function repositionY() {
                var orientation = this.options.orientation.item;
                var lineStyle = this.dom.line.style;
                if (orientation == "top") {
                    var lineHeight = this.parent.top + this.top + 1;
                    this.boxY = this.top || 0;
                    lineStyle.height = "".concat(lineHeight, "px");
                    lineStyle.bottom = "";
                    lineStyle.top = "0";
                } else {
                    // orientation 'bottom'
                    var itemSetHeight = this.parent.itemSet.props.height; // TODO: this is nasty
                    var _lineHeight = itemSetHeight - this.parent.top - this.parent.height + this.top;
                    this.boxY = this.parent.height - this.top - (this.height || 0);
                    lineStyle.height = "".concat(_lineHeight, "px");
                    lineStyle.top = "";
                    lineStyle.bottom = "0";
                }
                this.dotY = -this.props.dot.height / 2;
                this.repositionXY();
            }
        },
        {
            key: "getWidthLeft",
            value: function getWidthLeft() {
                return this.width / 2;
            }
        },
        {
            key: "getWidthRight",
            value: function getWidthRight() {
                return this.width / 2;
            }
        }
    ]);
    return BoxItem;
}(Item);
function _createSuper$6(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @constructor PointItem
 * @extends Item
 */ var PointItem = /*#__PURE__*/ function(_Item) {
    _inherits(PointItem, _Item);
    var _super = _createSuper$6(PointItem);
    /**
  * @param {Object} data             Object containing parameters start
  *                                  content, className.
  * @param {{toScreen: function, toTime: function}} conversion
  *                                  Conversion functions from time to screen and vice versa
  * @param {Object} [options]        Configuration options
  *                                  // TODO: describe available options
  */ function PointItem(data, conversion, options) {
        var _this;
        _classCallCheck(this, PointItem);
        _this = _super.call(this, data, conversion, options);
        _this.props = {
            dot: {
                top: 0,
                width: 0,
                height: 0
            },
            content: {
                height: 0,
                marginLeft: 0,
                marginRight: 0
            }
        };
        // validate data
        if (data) {
            if (data.start == undefined) throw new Error('Property "start" missing in item '.concat(data));
        }
        return _this;
    }
    /**
   * Check whether this item is visible inside given range
   * @param {{start: number, end: number}} range with a timestamp for start and end
   * @returns {boolean} True if visible
   */ _createClass(PointItem, [
        {
            key: "isVisible",
            value: function isVisible(range) {
                if (this.cluster) return false;
                // determine visibility
                var widthInMs = this.width * range.getMillisecondsPerPixel();
                return this.data.start.getTime() + widthInMs > range.start && this.data.start < range.end;
            }
        },
        {
            key: "_createDomElement",
            value: function _createDomElement() {
                if (!this.dom) {
                    // create DOM
                    this.dom = {};
                    // background box
                    this.dom.point = document.createElement("div");
                    // className is updated in redraw()
                    // contents box, right from the dot
                    this.dom.content = document.createElement("div");
                    this.dom.content.className = "vis-item-content";
                    this.dom.point.appendChild(this.dom.content);
                    // dot at start
                    this.dom.dot = document.createElement("div");
                    this.dom.point.appendChild(this.dom.dot);
                    // attach this item as attribute
                    this.dom.point["vis-item"] = this;
                    this.dirty = true;
                }
            }
        },
        {
            key: "_appendDomElement",
            value: function _appendDomElement() {
                if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                if (!this.dom.point.parentNode) {
                    var foreground = this.parent.dom.foreground;
                    if (!foreground) throw new Error("Cannot redraw item: parent has no foreground container element");
                    foreground.appendChild(this.dom.point);
                }
                this.displayed = true;
            }
        },
        {
            key: "_updateDirtyDomComponents",
            value: function _updateDirtyDomComponents() {
                // An item is marked dirty when:
                // - the item is not yet rendered
                // - the item's data is changed
                // - the item is selected/deselected
                if (this.dirty) {
                    this._updateContents(this.dom.content);
                    this._updateDataAttributes(this.dom.point);
                    this._updateStyle(this.dom.point);
                    var editable = this.editable.updateTime || this.editable.updateGroup;
                    // update class
                    var className = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (editable ? " vis-editable" : " vis-readonly");
                    this.dom.point.className = "vis-item vis-point".concat(className);
                    this.dom.dot.className = "vis-item vis-dot".concat(className);
                }
            }
        },
        {
            key: "_getDomComponentsSizes",
            value: function _getDomComponentsSizes() {
                return {
                    dot: {
                        width: this.dom.dot.offsetWidth,
                        height: this.dom.dot.offsetHeight
                    },
                    content: {
                        width: this.dom.content.offsetWidth,
                        height: this.dom.content.offsetHeight
                    },
                    point: {
                        width: this.dom.point.offsetWidth,
                        height: this.dom.point.offsetHeight
                    }
                };
            }
        },
        {
            key: "_updateDomComponentsSizes",
            value: function _updateDomComponentsSizes(sizes) {
                // recalculate size of dot and contents
                this.props.dot.width = sizes.dot.width;
                this.props.dot.height = sizes.dot.height;
                this.props.content.height = sizes.content.height;
                // resize contents
                if (this.options.rtl) this.dom.content.style.marginRight = "".concat(this.props.dot.width / 2, "px");
                else this.dom.content.style.marginLeft = "".concat(this.props.dot.width / 2, "px");
                //this.dom.content.style.marginRight = ... + 'px'; // TODO: margin right
                // recalculate size
                this.width = sizes.point.width;
                this.height = sizes.point.height;
                // reposition the dot
                this.dom.dot.style.top = "".concat((this.height - this.props.dot.height) / 2, "px");
                var dotWidth = this.props.dot.width;
                var translateX = this.options.rtl ? dotWidth / 2 : dotWidth / 2 * -1;
                this.dom.dot.style.transform = "translateX(".concat(translateX, "px");
                this.dirty = false;
            }
        },
        {
            key: "_repaintDomAdditionals",
            value: function _repaintDomAdditionals() {
                this._repaintOnItemUpdateTimeTooltip(this.dom.point);
                this._repaintDragCenter();
                this._repaintDeleteButton(this.dom.point);
            }
        },
        {
            key: "redraw",
            value: function redraw(returnQueue) {
                var _context, _context2, _context3, _this2 = this, _context5;
                var sizes;
                var queue = [
                    // create item DOM
                    _bindInstanceProperty$1(_context = this._createDomElement).call(_context, this),
                    // append DOM to parent DOM
                    _bindInstanceProperty$1(_context2 = this._appendDomElement).call(_context2, this),
                    // update dirty DOM
                    _bindInstanceProperty$1(_context3 = this._updateDirtyDomComponents).call(_context3, this),
                    function() {
                        if (_this2.dirty) sizes = _this2._getDomComponentsSizes();
                    },
                    function() {
                        if (_this2.dirty) {
                            var _context4;
                            _bindInstanceProperty$1(_context4 = _this2._updateDomComponentsSizes).call(_context4, _this2)(sizes);
                        }
                    },
                    // repaint DOM additionals
                    _bindInstanceProperty$1(_context5 = this._repaintDomAdditionals).call(_context5, this)
                ];
                if (returnQueue) return queue;
                else {
                    var result;
                    _forEachInstanceProperty(queue).call(queue, function(fn) {
                        result = fn();
                    });
                    return result;
                }
            }
        },
        {
            key: "repositionXY",
            value: function repositionXY() {
                var rtl = this.options.rtl;
                var repositionXY = function repositionXY(element, x, y) {
                    var _context6;
                    var rtl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                    if (x === undefined && y === undefined) return;
                    // If rtl invert the number.
                    var directionX = rtl ? x * -1 : x;
                    //no y. translate x
                    if (y === undefined) {
                        element.style.transform = "translateX(".concat(directionX, "px)");
                        return;
                    }
                    //no x. translate y
                    if (x === undefined) {
                        element.style.transform = "translateY(".concat(y, "px)");
                        return;
                    }
                    element.style.transform = _concatInstanceProperty(_context6 = "translate(".concat(directionX, "px, ")).call(_context6, y, "px)");
                };
                repositionXY(this.dom.point, this.pointX, this.pointY, rtl);
            }
        },
        {
            key: "show",
            value: function show(returnQueue) {
                if (!this.displayed) return this.redraw(returnQueue);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.displayed) {
                    if (this.dom.point.parentNode) this.dom.point.parentNode.removeChild(this.dom.point);
                    this.displayed = false;
                }
            }
        },
        {
            key: "repositionX",
            value: function repositionX() {
                var start = this.conversion.toScreen(this.data.start);
                this.pointX = start;
                if (this.options.rtl) this.right = start - this.props.dot.width;
                else this.left = start - this.props.dot.width;
                this.repositionXY();
            }
        },
        {
            key: "repositionY",
            value: function repositionY() {
                var orientation = this.options.orientation.item;
                if (orientation == "top") this.pointY = this.top;
                else this.pointY = this.parent.height - this.top - this.height;
                this.repositionXY();
            }
        },
        {
            key: "getWidthLeft",
            value: function getWidthLeft() {
                return this.props.dot.width;
            }
        },
        {
            key: "getWidthRight",
            value: function getWidthRight() {
                return this.props.dot.width;
            }
        }
    ]);
    return PointItem;
}(Item);
function _createSuper$5(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @constructor RangeItem
 * @extends Item
 */ var RangeItem = /*#__PURE__*/ function(_Item) {
    _inherits(RangeItem, _Item);
    var _super = _createSuper$5(RangeItem);
    /**
  * @param {Object} data             Object containing parameters start, end
  *                                  content, className.
  * @param {{toScreen: function, toTime: function}} conversion
  *                                  Conversion functions from time to screen and vice versa
  * @param {Object} [options]        Configuration options
  *                                  // TODO: describe options
  */ function RangeItem(data, conversion, options) {
        var _this;
        _classCallCheck(this, RangeItem);
        _this = _super.call(this, data, conversion, options);
        _this.props = {
            content: {
                width: 0
            }
        };
        _this.overflow = false; // if contents can overflow (css styling), this flag is set to true
        // validate data
        if (data) {
            if (data.start == undefined) throw new Error('Property "start" missing in item '.concat(data.id));
            if (data.end == undefined) throw new Error('Property "end" missing in item '.concat(data.id));
        }
        return _this;
    }
    /**
   * Check whether this item is visible inside given range
   *
   * @param {timeline.Range} range with a timestamp for start and end
   * @returns {boolean} True if visible
   */ _createClass(RangeItem, [
        {
            key: "isVisible",
            value: function isVisible(range) {
                if (this.cluster) return false;
                // determine visibility
                return this.data.start < range.end && this.data.end > range.start;
            }
        },
        {
            key: "_createDomElement",
            value: function _createDomElement() {
                if (!this.dom) {
                    // create DOM
                    this.dom = {};
                    // background box
                    this.dom.box = document.createElement("div");
                    // className is updated in redraw()
                    // frame box (to prevent the item contents from overflowing)
                    this.dom.frame = document.createElement("div");
                    this.dom.frame.className = "vis-item-overflow";
                    this.dom.box.appendChild(this.dom.frame);
                    // visible frame box (showing the frame that is always visible)
                    this.dom.visibleFrame = document.createElement("div");
                    this.dom.visibleFrame.className = "vis-item-visible-frame";
                    this.dom.box.appendChild(this.dom.visibleFrame);
                    // contents box
                    this.dom.content = document.createElement("div");
                    this.dom.content.className = "vis-item-content";
                    this.dom.frame.appendChild(this.dom.content);
                    // attach this item as attribute
                    this.dom.box["vis-item"] = this;
                    this.dirty = true;
                }
            }
        },
        {
            key: "_appendDomElement",
            value: function _appendDomElement() {
                if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                if (!this.dom.box.parentNode) {
                    var foreground = this.parent.dom.foreground;
                    if (!foreground) throw new Error("Cannot redraw item: parent has no foreground container element");
                    foreground.appendChild(this.dom.box);
                }
                this.displayed = true;
            }
        },
        {
            key: "_updateDirtyDomComponents",
            value: function _updateDirtyDomComponents() {
                // update dirty DOM. An item is marked dirty when:
                // - the item is not yet rendered
                // - the item's data is changed
                // - the item is selected/deselected
                if (this.dirty) {
                    this._updateContents(this.dom.content);
                    this._updateDataAttributes(this.dom.box);
                    this._updateStyle(this.dom.box);
                    var editable = this.editable.updateTime || this.editable.updateGroup;
                    // update class
                    var className = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + (editable ? " vis-editable" : " vis-readonly");
                    this.dom.box.className = this.baseClassName + className;
                    // turn off max-width to be able to calculate the real width
                    // this causes an extra browser repaint/reflow, but so be it
                    this.dom.content.style.maxWidth = "none";
                }
            }
        },
        {
            key: "_getDomComponentsSizes",
            value: function _getDomComponentsSizes() {
                // determine from css whether this box has overflow
                this.overflow = window.getComputedStyle(this.dom.frame).overflow !== "hidden";
                this.whiteSpace = window.getComputedStyle(this.dom.content).whiteSpace !== "nowrap";
                return {
                    content: {
                        width: this.dom.content.offsetWidth
                    },
                    box: {
                        height: this.dom.box.offsetHeight
                    }
                };
            }
        },
        {
            key: "_updateDomComponentsSizes",
            value: function _updateDomComponentsSizes(sizes) {
                this.props.content.width = sizes.content.width;
                this.height = sizes.box.height;
                this.dom.content.style.maxWidth = "";
                this.dirty = false;
            }
        },
        {
            key: "_repaintDomAdditionals",
            value: function _repaintDomAdditionals() {
                this._repaintOnItemUpdateTimeTooltip(this.dom.box);
                this._repaintDeleteButton(this.dom.box);
                this._repaintDragCenter();
                this._repaintDragLeft();
                this._repaintDragRight();
            }
        },
        {
            key: "redraw",
            value: function redraw(returnQueue) {
                var _context, _context2, _context3, _this2 = this, _context6;
                var sizes;
                var queue = [
                    // create item DOM
                    _bindInstanceProperty$1(_context = this._createDomElement).call(_context, this),
                    // append DOM to parent DOM
                    _bindInstanceProperty$1(_context2 = this._appendDomElement).call(_context2, this),
                    // update dirty DOM 
                    _bindInstanceProperty$1(_context3 = this._updateDirtyDomComponents).call(_context3, this),
                    function() {
                        if (_this2.dirty) {
                            var _context4;
                            sizes = _bindInstanceProperty$1(_context4 = _this2._getDomComponentsSizes).call(_context4, _this2)();
                        }
                    },
                    function() {
                        if (_this2.dirty) {
                            var _context5;
                            _bindInstanceProperty$1(_context5 = _this2._updateDomComponentsSizes).call(_context5, _this2)(sizes);
                        }
                    },
                    // repaint DOM additionals
                    _bindInstanceProperty$1(_context6 = this._repaintDomAdditionals).call(_context6, this)
                ];
                if (returnQueue) return queue;
                else {
                    var result;
                    _forEachInstanceProperty(queue).call(queue, function(fn) {
                        result = fn();
                    });
                    return result;
                }
            }
        },
        {
            key: "show",
            value: function show(returnQueue) {
                if (!this.displayed) return this.redraw(returnQueue);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.displayed) {
                    var box = this.dom.box;
                    if (box.parentNode) box.parentNode.removeChild(box);
                    this.displayed = false;
                }
            }
        },
        {
            key: "repositionX",
            value: function repositionX(limitSize) {
                var parentWidth = this.parent.width;
                var start = this.conversion.toScreen(this.data.start);
                var end = this.conversion.toScreen(this.data.end);
                var align = this.data.align === undefined ? this.options.align : this.data.align;
                var contentStartPosition;
                var contentWidth;
                // limit the width of the range, as browsers cannot draw very wide divs
                // unless limitSize: false is explicitly set in item data
                if (this.data.limitSize !== false && (limitSize === undefined || limitSize === true)) {
                    if (start < -parentWidth) start = -parentWidth;
                    if (end > 2 * parentWidth) end = 2 * parentWidth;
                }
                //round to 3 decimals to compensate floating-point values rounding
                var boxWidth = Math.max(Math.round((end - start) * 1000) / 1000, 1);
                if (this.overflow) {
                    if (this.options.rtl) this.right = start;
                    else this.left = start;
                    this.width = boxWidth + this.props.content.width;
                    contentWidth = this.props.content.width;
                // Note: The calculation of width is an optimistic calculation, giving
                //       a width which will not change when moving the Timeline
                //       So no re-stacking needed, which is nicer for the eye;
                } else {
                    if (this.options.rtl) this.right = start;
                    else this.left = start;
                    this.width = boxWidth;
                    contentWidth = Math.min(end - start, this.props.content.width);
                }
                if (this.options.rtl) this.dom.box.style.transform = "translateX(".concat(this.right * -1, "px)");
                else this.dom.box.style.transform = "translateX(".concat(this.left, "px)");
                this.dom.box.style.width = "".concat(boxWidth, "px");
                if (this.whiteSpace) this.height = this.dom.box.offsetHeight;
                switch(align){
                    case "left":
                        this.dom.content.style.transform = "translateX(0)";
                        break;
                    case "right":
                        if (this.options.rtl) {
                            var translateX = Math.max(boxWidth - contentWidth, 0) * -1;
                            this.dom.content.style.transform = "translateX(".concat(translateX, "px)");
                        } else this.dom.content.style.transform = "translateX(".concat(Math.max(boxWidth - contentWidth, 0), "px)");
                        break;
                    case "center":
                        if (this.options.rtl) {
                            var _translateX = Math.max((boxWidth - contentWidth) / 2, 0) * -1;
                            this.dom.content.style.transform = "translateX(".concat(_translateX, "px)");
                        } else this.dom.content.style.transform = "translateX(".concat(Math.max((boxWidth - contentWidth) / 2, 0), "px)");
                        break;
                    default:
                        // 'auto'
                        // when range exceeds left of the window, position the contents at the left of the visible area
                        if (this.overflow) {
                            if (end > 0) contentStartPosition = Math.max(-start, 0);
                            else contentStartPosition = -contentWidth; // ensure it's not visible anymore
                        } else if (start < 0) contentStartPosition = -start;
                        else contentStartPosition = 0;
                        if (this.options.rtl) {
                            var _translateX2 = contentStartPosition * -1;
                            this.dom.content.style.transform = "translateX(".concat(_translateX2, "px)");
                        } else this.dom.content.style.transform = "translateX(".concat(contentStartPosition, "px)");
                }
            }
        },
        {
            key: "repositionY",
            value: function repositionY() {
                var orientation = this.options.orientation.item;
                var box = this.dom.box;
                if (orientation == "top") box.style.top = "".concat(this.top, "px");
                else box.style.top = "".concat(this.parent.height - this.top - this.height, "px");
            }
        },
        {
            key: "_repaintDragLeft",
            value: function _repaintDragLeft() {
                if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragLeft) {
                    // create and show drag area
                    var dragLeft = document.createElement("div");
                    dragLeft.className = "vis-drag-left";
                    dragLeft.dragLeftItem = this;
                    this.dom.box.appendChild(dragLeft);
                    this.dom.dragLeft = dragLeft;
                } else if (!this.selected && !this.options.itemsAlwaysDraggable.range && this.dom.dragLeft) {
                    // delete drag area
                    if (this.dom.dragLeft.parentNode) this.dom.dragLeft.parentNode.removeChild(this.dom.dragLeft);
                    this.dom.dragLeft = null;
                }
            }
        },
        {
            key: "_repaintDragRight",
            value: function _repaintDragRight() {
                if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.editable.updateTime && !this.dom.dragRight) {
                    // create and show drag area
                    var dragRight = document.createElement("div");
                    dragRight.className = "vis-drag-right";
                    dragRight.dragRightItem = this;
                    this.dom.box.appendChild(dragRight);
                    this.dom.dragRight = dragRight;
                } else if (!this.selected && !this.options.itemsAlwaysDraggable.range && this.dom.dragRight) {
                    // delete drag area
                    if (this.dom.dragRight.parentNode) this.dom.dragRight.parentNode.removeChild(this.dom.dragRight);
                    this.dom.dragRight = null;
                }
            }
        }
    ]);
    return RangeItem;
}(Item);
RangeItem.prototype.baseClassName = "vis-item vis-range";
function _createSuper$4(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @constructor BackgroundItem
 * @extends Item
 */ var BackgroundItem = /*#__PURE__*/ function(_Item) {
    _inherits(BackgroundItem, _Item);
    var _super = _createSuper$4(BackgroundItem);
    /**
  * @constructor BackgroundItem
  * @param {Object} data             Object containing parameters start, end
  *                                  content, className.
  * @param {{toScreen: function, toTime: function}} conversion
  *                                  Conversion functions from time to screen and vice versa
  * @param {Object} [options]        Configuration options
  *                                  // TODO: describe options
  * // TODO: implement support for the BackgroundItem just having a start, then being displayed as a sort of an annotation
  */ function BackgroundItem(data, conversion, options) {
        var _this;
        _classCallCheck(this, BackgroundItem);
        _this = _super.call(this, data, conversion, options);
        _this.props = {
            content: {
                width: 0
            }
        };
        _this.overflow = false; // if contents can overflow (css styling), this flag is set to true
        // validate data
        if (data) {
            if (data.start == undefined) throw new Error('Property "start" missing in item '.concat(data.id));
            if (data.end == undefined) throw new Error('Property "end" missing in item '.concat(data.id));
        }
        return _this;
    }
    /**
   * Check whether this item is visible inside given range
   * @param {timeline.Range} range with a timestamp for start and end
   * @returns {boolean} True if visible
   */ _createClass(BackgroundItem, [
        {
            key: "isVisible",
            value: function isVisible(range) {
                // determine visibility
                return this.data.start < range.end && this.data.end > range.start;
            }
        },
        {
            key: "_createDomElement",
            value: function _createDomElement() {
                if (!this.dom) {
                    // create DOM
                    this.dom = {};
                    // background box
                    this.dom.box = document.createElement("div");
                    // className is updated in redraw()
                    // frame box (to prevent the item contents from overflowing
                    this.dom.frame = document.createElement("div");
                    this.dom.frame.className = "vis-item-overflow";
                    this.dom.box.appendChild(this.dom.frame);
                    // contents box
                    this.dom.content = document.createElement("div");
                    this.dom.content.className = "vis-item-content";
                    this.dom.frame.appendChild(this.dom.content);
                    // Note: we do NOT attach this item as attribute to the DOM,
                    //       such that background items cannot be selected
                    //this.dom.box['vis-item'] = this;
                    this.dirty = true;
                }
            }
        },
        {
            key: "_appendDomElement",
            value: function _appendDomElement() {
                if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                if (!this.dom.box.parentNode) {
                    var background = this.parent.dom.background;
                    if (!background) throw new Error("Cannot redraw item: parent has no background container element");
                    background.appendChild(this.dom.box);
                }
                this.displayed = true;
            }
        },
        {
            key: "_updateDirtyDomComponents",
            value: function _updateDirtyDomComponents() {
                // update dirty DOM. An item is marked dirty when:
                // - the item is not yet rendered
                // - the item's data is changed
                // - the item is selected/deselected
                if (this.dirty) {
                    this._updateContents(this.dom.content);
                    this._updateDataAttributes(this.dom.content);
                    this._updateStyle(this.dom.box);
                    // update class
                    var className = (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "");
                    this.dom.box.className = this.baseClassName + className;
                }
            }
        },
        {
            key: "_getDomComponentsSizes",
            value: function _getDomComponentsSizes() {
                // determine from css whether this box has overflow
                this.overflow = window.getComputedStyle(this.dom.content).overflow !== "hidden";
                return {
                    content: {
                        width: this.dom.content.offsetWidth
                    }
                };
            }
        },
        {
            key: "_updateDomComponentsSizes",
            value: function _updateDomComponentsSizes(sizes) {
                // recalculate size
                this.props.content.width = sizes.content.width;
                this.height = 0; // set height zero, so this item will be ignored when stacking items
                this.dirty = false;
            }
        },
        {
            key: "_repaintDomAdditionals",
            value: function _repaintDomAdditionals() {}
        },
        {
            key: "redraw",
            value: function redraw(returnQueue) {
                var _context, _context2, _context3, _this2 = this, _context6;
                var sizes;
                var queue = [
                    // create item DOM
                    _bindInstanceProperty$1(_context = this._createDomElement).call(_context, this),
                    // append DOM to parent DOM
                    _bindInstanceProperty$1(_context2 = this._appendDomElement).call(_context2, this),
                    _bindInstanceProperty$1(_context3 = this._updateDirtyDomComponents).call(_context3, this),
                    function() {
                        if (_this2.dirty) {
                            var _context4;
                            sizes = _bindInstanceProperty$1(_context4 = _this2._getDomComponentsSizes).call(_context4, _this2)();
                        }
                    },
                    function() {
                        if (_this2.dirty) {
                            var _context5;
                            _bindInstanceProperty$1(_context5 = _this2._updateDomComponentsSizes).call(_context5, _this2)(sizes);
                        }
                    },
                    // repaint DOM additionals
                    _bindInstanceProperty$1(_context6 = this._repaintDomAdditionals).call(_context6, this)
                ];
                if (returnQueue) return queue;
                else {
                    var result;
                    _forEachInstanceProperty(queue).call(queue, function(fn) {
                        result = fn();
                    });
                    return result;
                }
            }
        },
        {
            key: "repositionY",
            value: function repositionY(margin) {
                // eslint-disable-line no-unused-vars
                var height;
                var orientation = this.options.orientation.item;
                // special positioning for subgroups
                if (this.data.subgroup !== undefined) {
                    // TODO: instead of calculating the top position of the subgroups here for every BackgroundItem, calculate the top of the subgroup once in Itemset
                    var itemSubgroup = this.data.subgroup;
                    this.dom.box.style.height = "".concat(this.parent.subgroups[itemSubgroup].height, "px");
                    if (orientation == "top") this.dom.box.style.top = "".concat(this.parent.top + this.parent.subgroups[itemSubgroup].top, "px");
                    else this.dom.box.style.top = "".concat(this.parent.top + this.parent.height - this.parent.subgroups[itemSubgroup].top - this.parent.subgroups[itemSubgroup].height, "px");
                    this.dom.box.style.bottom = "";
                } else // we want backgrounds with groups to only show in groups.
                if (this.parent instanceof BackgroundGroup) {
                    // if the item is not in a group:
                    height = Math.max(this.parent.height, this.parent.itemSet.body.domProps.center.height, this.parent.itemSet.body.domProps.centerContainer.height);
                    this.dom.box.style.bottom = orientation == "bottom" ? "0" : "";
                    this.dom.box.style.top = orientation == "top" ? "0" : "";
                } else {
                    height = this.parent.height;
                    // same alignment for items when orientation is top or bottom
                    this.dom.box.style.top = "".concat(this.parent.top, "px");
                    this.dom.box.style.bottom = "";
                }
                this.dom.box.style.height = "".concat(height, "px");
            }
        }
    ]);
    return BackgroundItem;
}(Item);
BackgroundItem.prototype.baseClassName = "vis-item vis-background";
BackgroundItem.prototype.stack = false;
/**
 * Show the item in the DOM (when not already visible). The items DOM will
 * be created when needed.
 */ BackgroundItem.prototype.show = RangeItem.prototype.show;
/**
 * Hide the item from the DOM (when visible)
 * @return {Boolean} changed
 */ BackgroundItem.prototype.hide = RangeItem.prototype.hide;
/**
 * Reposition the item horizontally
 * @Override
 */ BackgroundItem.prototype.repositionX = RangeItem.prototype.repositionX;
var css_248z$4 = "div.vis-tooltip {\n  position: absolute;\n  visibility: hidden;\n  padding: 5px;\n  white-space: nowrap;\n\n  font-family: verdana;\n  font-size:14px;\n  color:#000000;\n  background-color: #f5f4ed;\n\n  -moz-border-radius: 3px;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n  border: 1px solid #808074;\n\n  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n\n  z-index: 5;\n}\n";
styleInject(css_248z$4);
/**
 * Popup is a class to create a popup window with some text
 */ var Popup = /*#__PURE__*/ function() {
    /**
   * @param {Element} container       The container object.
   * @param {string}  overflowMethod  How the popup should act to overflowing ('flip', 'cap' or 'none')
   */ function Popup(container, overflowMethod) {
        _classCallCheck(this, Popup);
        this.container = container;
        this.overflowMethod = overflowMethod || "cap";
        this.x = 0;
        this.y = 0;
        this.padding = 5;
        this.hidden = false;
        // create the frame
        this.frame = document.createElement("div");
        this.frame.className = "vis-tooltip";
        this.container.appendChild(this.frame);
    }
    /**
   * @param {number} x   Horizontal position of the popup window
   * @param {number} y   Vertical position of the popup window
   */ _createClass(Popup, [
        {
            key: "setPosition",
            value: function setPosition(x, y) {
                this.x = _parseInt$1(x);
                this.y = _parseInt$1(y);
            }
        },
        {
            key: "setText",
            value: function setText(content) {
                if (content instanceof Element) {
                    this.frame.innerHTML = "";
                    this.frame.appendChild(content);
                } else this.frame.innerHTML = availableUtils.xss(content); // string containing text or HTML
            }
        },
        {
            key: "show",
            value: function show(doShow) {
                if (doShow === undefined) doShow = true;
                if (doShow === true) {
                    var height = this.frame.clientHeight;
                    var width = this.frame.clientWidth;
                    var maxHeight = this.frame.parentNode.clientHeight;
                    var maxWidth = this.frame.parentNode.clientWidth;
                    var left = 0, top = 0;
                    if (this.overflowMethod == "flip" || this.overflowMethod == "none") {
                        var isLeft = false, isTop = true; // Where around the position it's located
                        if (this.overflowMethod == "flip") {
                            if (this.y - height < this.padding) isTop = false;
                            if (this.x + width > maxWidth - this.padding) isLeft = true;
                        }
                        if (isLeft) left = this.x - width;
                        else left = this.x;
                        if (isTop) top = this.y - height;
                        else top = this.y;
                    } else {
                        // this.overflowMethod == 'cap'
                        top = this.y - height;
                        if (top + height + this.padding > maxHeight) top = maxHeight - height - this.padding;
                        if (top < this.padding) top = this.padding;
                        left = this.x;
                        if (left + width + this.padding > maxWidth) left = maxWidth - width - this.padding;
                        if (left < this.padding) left = this.padding;
                    }
                    this.frame.style.left = left + "px";
                    this.frame.style.top = top + "px";
                    this.frame.style.visibility = "visible";
                    this.hidden = false;
                } else this.hide();
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.hidden = true;
                this.frame.style.left = "0";
                this.frame.style.top = "0";
                this.frame.style.visibility = "hidden";
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.frame.parentNode.removeChild(this.frame); // Remove element from DOM
            }
        }
    ]);
    return Popup;
}();
var $ = _export;
var $every = arrayIteration.every;
var arrayMethodIsStrict = arrayMethodIsStrict$6;
var STRICT_METHOD = arrayMethodIsStrict("every");
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({
    target: "Array",
    proto: true,
    forced: !STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
var entryVirtual = entryVirtual$o;
var every$3 = entryVirtual("Array").every;
var isPrototypeOf = objectIsPrototypeOf;
var method = every$3;
var ArrayPrototype = Array.prototype;
var every$2 = function(it) {
    var own = it.every;
    return it === ArrayPrototype || isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.every ? method : own;
};
var parent = every$2;
var every$1 = parent;
var every = every$1;
var _everyInstanceProperty = /*@__PURE__*/ getDefaultExportFromCjs(every);
function _createForOfIteratorHelper$3(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$3(o, minLen) {
    var _context14;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
    var n = _sliceInstanceProperty(_context14 = Object.prototype.toString.call(o)).call(_context14, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * ClusterItem
 */ var ClusterItem = /*#__PURE__*/ function(_Item) {
    _inherits(ClusterItem, _Item);
    var _super = _createSuper$3(ClusterItem);
    /**
  * @constructor Item
  * @param {Object} data             Object containing (optional) parameters type,
  *                                  start, end, content, group, className.
  * @param {{toScreen: function, toTime: function}} conversion
  *                                  Conversion functions from time to screen and vice versa
  * @param {Object} options          Configuration options
  *                                  // TODO: describe available options
  */ function ClusterItem(data, conversion, options) {
        var _this;
        _classCallCheck(this, ClusterItem);
        var modifiedOptions = _Object$assign({}, {
            fitOnDoubleClick: true
        }, options, {
            editable: false
        });
        _this = _super.call(this, data, conversion, modifiedOptions);
        _this.props = {
            content: {
                width: 0,
                height: 0
            }
        };
        if (!data || data.uiItems == undefined) throw new Error('Property "uiItems" missing in item ' + data.id);
        _this.id = v4();
        _this.group = data.group;
        _this._setupRange();
        _this.emitter = _this.data.eventEmitter;
        _this.range = _this.data.range;
        _this.attached = false;
        _this.isCluster = true;
        _this.data.isCluster = true;
        return _this;
    }
    /**
   * check if there are items
   * @return {boolean}
   */ _createClass(ClusterItem, [
        {
            key: "hasItems",
            value: function hasItems() {
                return this.data.uiItems && this.data.uiItems.length && this.attached;
            }
        },
        {
            key: "setUiItems",
            value: function setUiItems(items) {
                this.detach();
                this.data.uiItems = items;
                this._setupRange();
                this.attach();
            }
        },
        {
            key: "isVisible",
            value: function isVisible(range) {
                var rangeWidth = this.data.end ? this.data.end - this.data.start : 0;
                var widthInMs = this.width * range.getMillisecondsPerPixel();
                var end = Math.max(this.data.start.getTime() + rangeWidth, this.data.start.getTime() + widthInMs);
                return this.data.start < range.end && end > range.start && this.hasItems();
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    isCluster: true,
                    id: this.id,
                    items: this.data.items || [],
                    data: this.data
                };
            }
        },
        {
            key: "redraw",
            value: function redraw(returnQueue) {
                var _context, _context2, _context3, _context4, _context5, _context7;
                var sizes;
                var queue = [
                    // create item DOM
                    _bindInstanceProperty$1(_context = this._createDomElement).call(_context, this),
                    // append DOM to parent DOM
                    _bindInstanceProperty$1(_context2 = this._appendDomElement).call(_context2, this),
                    // update dirty DOM
                    _bindInstanceProperty$1(_context3 = this._updateDirtyDomComponents).call(_context3, this),
                    _bindInstanceProperty$1(_context4 = function _context4() {
                        if (this.dirty) sizes = this._getDomComponentsSizes();
                    }).call(_context4, this),
                    _bindInstanceProperty$1(_context5 = function _context5() {
                        if (this.dirty) {
                            var _context6;
                            _bindInstanceProperty$1(_context6 = this._updateDomComponentsSizes).call(_context6, this)(sizes);
                        }
                    }).call(_context5, this),
                    // repaint DOM additionals
                    _bindInstanceProperty$1(_context7 = this._repaintDomAdditionals).call(_context7, this)
                ];
                if (returnQueue) return queue;
                else {
                    var result;
                    _forEachInstanceProperty(queue).call(queue, function(fn) {
                        result = fn();
                    });
                    return result;
                }
            }
        },
        {
            key: "show",
            value: function show() {
                if (!this.displayed) this.redraw();
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.displayed) {
                    var dom = this.dom;
                    if (dom.box.parentNode) dom.box.parentNode.removeChild(dom.box);
                    if (this.options.showStipes) {
                        if (dom.line.parentNode) dom.line.parentNode.removeChild(dom.line);
                        if (dom.dot.parentNode) dom.dot.parentNode.removeChild(dom.dot);
                    }
                    this.displayed = false;
                }
            }
        },
        {
            key: "repositionX",
            value: function repositionX() {
                var start = this.conversion.toScreen(this.data.start);
                var end = this.data.end ? this.conversion.toScreen(this.data.end) : 0;
                if (end) this.repositionXWithRanges(start, end);
                else {
                    var align = this.data.align === undefined ? this.options.align : this.data.align;
                    this.repositionXWithoutRanges(start, align);
                }
                if (this.options.showStipes) {
                    this.dom.line.style.display = this._isStipeVisible() ? "block" : "none";
                    this.dom.dot.style.display = this._isStipeVisible() ? "block" : "none";
                    if (this._isStipeVisible()) this.repositionStype(start, end);
                }
            }
        },
        {
            key: "repositionStype",
            value: function repositionStype(start, end) {
                this.dom.line.style.display = "block";
                this.dom.dot.style.display = "block";
                var lineOffsetWidth = this.dom.line.offsetWidth;
                var dotOffsetWidth = this.dom.dot.offsetWidth;
                if (end) {
                    var lineOffset = lineOffsetWidth + start + (end - start) / 2;
                    var dotOffset = lineOffset - dotOffsetWidth / 2;
                    var lineOffsetDirection = this.options.rtl ? lineOffset * -1 : lineOffset;
                    var dotOffsetDirection = this.options.rtl ? dotOffset * -1 : dotOffset;
                    this.dom.line.style.transform = "translateX(".concat(lineOffsetDirection, "px)");
                    this.dom.dot.style.transform = "translateX(".concat(dotOffsetDirection, "px)");
                } else {
                    var _lineOffsetDirection = this.options.rtl ? start * -1 : start;
                    var _dotOffsetDirection = this.options.rtl ? (start - dotOffsetWidth / 2) * -1 : start - dotOffsetWidth / 2;
                    this.dom.line.style.transform = "translateX(".concat(_lineOffsetDirection, "px)");
                    this.dom.dot.style.transform = "translateX(".concat(_dotOffsetDirection, "px)");
                }
            }
        },
        {
            key: "repositionXWithoutRanges",
            value: function repositionXWithoutRanges(start, align) {
                // calculate left position of the box
                if (align == "right") {
                    if (this.options.rtl) {
                        this.right = start - this.width;
                        // reposition box, line, and dot
                        this.dom.box.style.right = this.right + "px";
                    } else {
                        this.left = start - this.width;
                        // reposition box, line, and dot
                        this.dom.box.style.left = this.left + "px";
                    }
                } else if (align == "left") {
                    if (this.options.rtl) {
                        this.right = start;
                        // reposition box, line, and dot
                        this.dom.box.style.right = this.right + "px";
                    } else {
                        this.left = start;
                        // reposition box, line, and dot
                        this.dom.box.style.left = this.left + "px";
                    }
                } else // default or 'center'
                if (this.options.rtl) {
                    this.right = start - this.width / 2;
                    // reposition box, line, and dot
                    this.dom.box.style.right = this.right + "px";
                } else {
                    this.left = start - this.width / 2;
                    // reposition box, line, and dot
                    this.dom.box.style.left = this.left + "px";
                }
            }
        },
        {
            key: "repositionXWithRanges",
            value: function repositionXWithRanges(start, end) {
                var boxWidth = Math.round(Math.max(end - start + 0.5, 1));
                if (this.options.rtl) this.right = start;
                else this.left = start;
                this.width = Math.max(boxWidth, this.minWidth || 0);
                if (this.options.rtl) this.dom.box.style.right = this.right + "px";
                else this.dom.box.style.left = this.left + "px";
                this.dom.box.style.width = boxWidth + "px";
            }
        },
        {
            key: "repositionY",
            value: function repositionY() {
                var orientation = this.options.orientation.item;
                var box = this.dom.box;
                if (orientation == "top") box.style.top = (this.top || 0) + "px";
                else // orientation 'bottom'
                box.style.top = (this.parent.height - this.top - this.height || 0) + "px";
                if (this.options.showStipes) {
                    if (orientation == "top") {
                        this.dom.line.style.top = "0";
                        this.dom.line.style.height = this.parent.top + this.top + 1 + "px";
                        this.dom.line.style.bottom = "";
                    } else {
                        // orientation 'bottom'
                        var itemSetHeight = this.parent.itemSet.props.height;
                        var lineHeight = itemSetHeight - this.parent.top - this.parent.height + this.top;
                        this.dom.line.style.top = itemSetHeight - lineHeight + "px";
                        this.dom.line.style.bottom = "0";
                    }
                    this.dom.dot.style.top = -this.dom.dot.offsetHeight / 2 + "px";
                }
            }
        },
        {
            key: "getWidthLeft",
            value: function getWidthLeft() {
                return this.width / 2;
            }
        },
        {
            key: "getWidthRight",
            value: function getWidthRight() {
                return this.width / 2;
            }
        },
        {
            key: "move",
            value: function move() {
                this.repositionX();
                this.repositionY();
            }
        },
        {
            key: "attach",
            value: function attach() {
                var _context8;
                var _iterator = _createForOfIteratorHelper$3(this.data.uiItems), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        item.cluster = this;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                this.data.items = _mapInstanceProperty(_context8 = this.data.uiItems).call(_context8, function(item) {
                    return item.data;
                });
                this.attached = true;
                this.dirty = true;
            }
        },
        {
            key: "detach",
            value: function detach() {
                var detachFromParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (!this.hasItems()) return;
                var _iterator2 = _createForOfIteratorHelper$3(this.data.uiItems), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var item = _step2.value;
                        delete item.cluster;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                this.attached = false;
                if (detachFromParent && this.group) {
                    this.group.remove(this);
                    this.group = null;
                }
                this.data.items = [];
                this.dirty = true;
            }
        },
        {
            key: "_onDoubleClick",
            value: function _onDoubleClick() {
                this._fit();
            }
        },
        {
            key: "_setupRange",
            value: function _setupRange() {
                var _context9, _context10, _context11;
                var stats = _mapInstanceProperty(_context9 = this.data.uiItems).call(_context9, function(item) {
                    return {
                        start: item.data.start.valueOf(),
                        end: item.data.end ? item.data.end.valueOf() : item.data.start.valueOf()
                    };
                });
                this.data.min = Math.min.apply(Math, _toConsumableArray(_mapInstanceProperty(stats).call(stats, function(s) {
                    return Math.min(s.start, s.end || s.start);
                })));
                this.data.max = Math.max.apply(Math, _toConsumableArray(_mapInstanceProperty(stats).call(stats, function(s) {
                    return Math.max(s.start, s.end || s.start);
                })));
                var centers = _mapInstanceProperty(_context10 = this.data.uiItems).call(_context10, function(item) {
                    return item.center;
                });
                var avg = _reduceInstanceProperty(centers).call(centers, function(sum, value) {
                    return sum + value;
                }, 0) / this.data.uiItems.length;
                if (_someInstanceProperty(_context11 = this.data.uiItems).call(_context11, function(item) {
                    return item.data.end;
                })) {
                    // contains ranges
                    this.data.start = new Date(this.data.min);
                    this.data.end = new Date(this.data.max);
                } else {
                    this.data.start = new Date(avg);
                    this.data.end = null;
                }
            }
        },
        {
            key: "_getUiItems",
            value: function _getUiItems() {
                var _this2 = this;
                if (this.data.uiItems && this.data.uiItems.length) {
                    var _context12;
                    return _filterInstanceProperty(_context12 = this.data.uiItems).call(_context12, function(item) {
                        return item.cluster === _this2;
                    });
                }
                return [];
            }
        },
        {
            key: "_createDomElement",
            value: function _createDomElement() {
                if (!this.dom) {
                    // create DOM
                    this.dom = {};
                    // create main box
                    this.dom.box = document.createElement("DIV");
                    // contents box (inside the background box). used for making margins
                    this.dom.content = document.createElement("DIV");
                    this.dom.content.className = "vis-item-content";
                    this.dom.box.appendChild(this.dom.content);
                    if (this.options.showStipes) {
                        // line to axis
                        this.dom.line = document.createElement("DIV");
                        this.dom.line.className = "vis-cluster-line";
                        this.dom.line.style.display = "none";
                        // dot on axis
                        this.dom.dot = document.createElement("DIV");
                        this.dom.dot.className = "vis-cluster-dot";
                        this.dom.dot.style.display = "none";
                    }
                    if (this.options.fitOnDoubleClick) {
                        var _context13;
                        this.dom.box.ondblclick = _bindInstanceProperty$1(_context13 = ClusterItem.prototype._onDoubleClick).call(_context13, this);
                    }
                    // attach this item as attribute
                    this.dom.box["vis-item"] = this;
                    this.dirty = true;
                }
            }
        },
        {
            key: "_appendDomElement",
            value: function _appendDomElement() {
                if (!this.parent) throw new Error("Cannot redraw item: no parent attached");
                if (!this.dom.box.parentNode) {
                    var foreground = this.parent.dom.foreground;
                    if (!foreground) throw new Error("Cannot redraw item: parent has no foreground container element");
                    foreground.appendChild(this.dom.box);
                }
                var background = this.parent.dom.background;
                if (this.options.showStipes) {
                    if (!this.dom.line.parentNode) {
                        if (!background) throw new Error("Cannot redraw item: parent has no background container element");
                        background.appendChild(this.dom.line);
                    }
                    if (!this.dom.dot.parentNode) {
                        var axis = this.parent.dom.axis;
                        if (!background) throw new Error("Cannot redraw item: parent has no axis container element");
                        axis.appendChild(this.dom.dot);
                    }
                }
                this.displayed = true;
            }
        },
        {
            key: "_updateDirtyDomComponents",
            value: function _updateDirtyDomComponents() {
                // An item is marked dirty when:
                // - the item is not yet rendered
                // - the item's data is changed
                // - the item is selected/deselected
                if (this.dirty) {
                    this._updateContents(this.dom.content);
                    this._updateDataAttributes(this.dom.box);
                    this._updateStyle(this.dom.box);
                    // update class
                    var className = this.baseClassName + " " + (this.data.className ? " " + this.data.className : "") + (this.selected ? " vis-selected" : "") + " vis-readonly";
                    this.dom.box.className = "vis-item " + className;
                    if (this.options.showStipes) {
                        this.dom.line.className = "vis-item vis-cluster-line " + (this.selected ? " vis-selected" : "");
                        this.dom.dot.className = "vis-item vis-cluster-dot " + (this.selected ? " vis-selected" : "");
                    }
                    if (this.data.end) // turn off max-width to be able to calculate the real width
                    // this causes an extra browser repaint/reflow, but so be it
                    this.dom.content.style.maxWidth = "none";
                }
            }
        },
        {
            key: "_getDomComponentsSizes",
            value: function _getDomComponentsSizes() {
                var sizes = {
                    previous: {
                        right: this.dom.box.style.right,
                        left: this.dom.box.style.left
                    },
                    box: {
                        width: this.dom.box.offsetWidth,
                        height: this.dom.box.offsetHeight
                    }
                };
                if (this.options.showStipes) {
                    sizes.dot = {
                        height: this.dom.dot.offsetHeight,
                        width: this.dom.dot.offsetWidth
                    };
                    sizes.line = {
                        width: this.dom.line.offsetWidth
                    };
                }
                return sizes;
            }
        },
        {
            key: "_updateDomComponentsSizes",
            value: function _updateDomComponentsSizes(sizes) {
                if (this.options.rtl) this.dom.box.style.right = "0px";
                else this.dom.box.style.left = "0px";
                // recalculate size
                if (!this.data.end) this.width = sizes.box.width;
                else this.minWidth = sizes.box.width;
                this.height = sizes.box.height;
                // restore previous position
                if (this.options.rtl) this.dom.box.style.right = sizes.previous.right;
                else this.dom.box.style.left = sizes.previous.left;
                this.dirty = false;
            }
        },
        {
            key: "_repaintDomAdditionals",
            value: function _repaintDomAdditionals() {
                this._repaintOnItemUpdateTimeTooltip(this.dom.box);
            }
        },
        {
            key: "_isStipeVisible",
            value: function _isStipeVisible() {
                return this.minWidth >= this.width || !this.data.end;
            }
        },
        {
            key: "_getFitRange",
            value: function _getFitRange() {
                var offset = 0.05 * (this.data.max - this.data.min) / 2;
                return {
                    fitStart: this.data.min - offset,
                    fitEnd: this.data.max + offset
                };
            }
        },
        {
            key: "_fit",
            value: function _fit() {
                if (this.emitter) {
                    var _this$_getFitRange = this._getFitRange(), fitStart = _this$_getFitRange.fitStart, fitEnd = _this$_getFitRange.fitEnd;
                    var fitArgs = {
                        start: new Date(fitStart),
                        end: new Date(fitEnd),
                        animation: true
                    };
                    this.emitter.emit("fit", fitArgs);
                }
            }
        },
        {
            key: "_getItemData",
            value: function _getItemData() {
                return this.data;
            }
        }
    ]);
    return ClusterItem;
}(Item);
ClusterItem.prototype.baseClassName = "vis-item vis-range vis-cluster";
function _createForOfIteratorHelper$2(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$2(o, minLen) {
    var _context4;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
    var n = _sliceInstanceProperty(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
var UNGROUPED$2 = "__ungrouped__"; // reserved group id for ungrouped items
var BACKGROUND$1 = "__background__"; // reserved group id for background items without group
var ReservedGroupIds = {
    UNGROUPED: UNGROUPED$2,
    BACKGROUND: BACKGROUND$1
};
/**
 * An Cluster generator generates cluster items
 */ var ClusterGenerator = /*#__PURE__*/ function() {
    /**
   * @param {ItemSet} itemSet itemsSet instance
   * @constructor ClusterGenerator
  */ function ClusterGenerator(itemSet) {
        _classCallCheck(this, ClusterGenerator);
        this.itemSet = itemSet;
        this.groups = {};
        this.cache = {};
        this.cache[-1] = [];
    }
    /**
   * @param {Object} itemData             Object containing parameters start content, className.
   * @param {{toScreen: function, toTime: function}} conversion
   *                                  Conversion functions from time to screen and vice versa
   * @param {Object} [options]        Configuration options
   * @return {Object} newItem
  */ _createClass(ClusterGenerator, [
        {
            key: "createClusterItem",
            value: function createClusterItem(itemData, conversion, options) {
                var newItem = new ClusterItem(itemData, conversion, options);
                return newItem;
            }
        },
        {
            key: "setItems",
            value: function setItems(items, options) {
                this.items = items || [];
                this.dataChanged = true;
                this.applyOnChangedLevel = false;
                if (options && options.applyOnChangedLevel) this.applyOnChangedLevel = options.applyOnChangedLevel;
            }
        },
        {
            key: "updateData",
            value: function updateData() {
                this.dataChanged = true;
                this.applyOnChangedLevel = false;
            }
        },
        {
            key: "getClusters",
            value: function getClusters(oldClusters, scale, options) {
                var _ref = typeof options === "boolean" ? {} : options, maxItems = _ref.maxItems, clusterCriteria = _ref.clusterCriteria;
                if (!clusterCriteria) clusterCriteria = function clusterCriteria() {
                    return true;
                };
                maxItems = maxItems || 1;
                var level = -1;
                var granularity = 2;
                var timeWindow = 0;
                if (scale > 0) {
                    if (scale >= 1) return [];
                    level = Math.abs(Math.round(Math.log(100 / scale) / Math.log(granularity)));
                    timeWindow = Math.abs(Math.pow(granularity, level));
                }
                // clear the cache when and re-generate groups the data when needed.
                if (this.dataChanged) {
                    var levelChanged = level != this.cacheLevel;
                    var applyDataNow = this.applyOnChangedLevel ? levelChanged : true;
                    if (applyDataNow) {
                        this._dropLevelsCache();
                        this._filterData();
                    }
                }
                this.cacheLevel = level;
                var clusters = this.cache[level];
                if (!clusters) {
                    clusters = [];
                    for(var groupName in this.groups)if (this.groups.hasOwnProperty(groupName)) {
                        var items = this.groups[groupName];
                        var iMax = items.length;
                        var i1 = 0;
                        while(i1 < iMax){
                            // find all items around current item, within the timeWindow
                            var item = items[i1];
                            var neighbors = 1; // start at 1, to include itself)
                            // loop through items left from the current item
                            var j = i1 - 1;
                            while(j >= 0 && item.center - items[j].center < timeWindow / 2){
                                if (!items[j].cluster && clusterCriteria(item.data, items[j].data)) neighbors++;
                                j--;
                            }
                            // loop through items right from the current item
                            var k = i1 + 1;
                            while(k < items.length && items[k].center - item.center < timeWindow / 2){
                                if (clusterCriteria(item.data, items[k].data)) neighbors++;
                                k++;
                            }
                            // loop through the created clusters
                            var l = clusters.length - 1;
                            while(l >= 0 && item.center - clusters[l].center < timeWindow){
                                if (item.group == clusters[l].group && clusterCriteria(item.data, clusters[l].data)) neighbors++;
                                l--;
                            }
                            // aggregate until the number of items is within maxItems
                            if (neighbors > maxItems) {
                                // too busy in this window.
                                var num = neighbors - maxItems + 1;
                                var clusterItems = [];
                                // append the items to the cluster,
                                // and calculate the average start for the cluster
                                var m = i1;
                                while(clusterItems.length < num && m < items.length){
                                    if (clusterCriteria(items[i1].data, items[m].data)) clusterItems.push(items[m]);
                                    m++;
                                }
                                var groupId = this.itemSet.getGroupId(item.data);
                                var group = this.itemSet.groups[groupId] || this.itemSet.groups[ReservedGroupIds.UNGROUPED];
                                var cluster = this._getClusterForItems(clusterItems, group, oldClusters, options);
                                clusters.push(cluster);
                                i1 += num;
                            } else {
                                delete item.cluster;
                                i1 += 1;
                            }
                        }
                    }
                    this.cache[level] = clusters;
                }
                return clusters;
            }
        },
        {
            key: "_filterData",
            value: function _filterData() {
                // filter per group
                var groups = {};
                this.groups = groups;
                // split the items per group
                for(var _i = 0, _Object$values = _Object$values2(this.items); _i < _Object$values.length; _i++){
                    var item = _Object$values[_i];
                    // put the item in the correct group
                    var groupName = item.parent ? item.parent.groupId : "";
                    var group = groups[groupName];
                    if (!group) {
                        group = [];
                        groups[groupName] = group;
                    }
                    group.push(item);
                    // calculate the center of the item
                    if (item.data.start) {
                        if (item.data.end) // range
                        item.center = (item.data.start.valueOf() + item.data.end.valueOf()) / 2;
                        else // box, dot
                        item.center = item.data.start.valueOf();
                    }
                }
                // sort the items per group
                for(var currentGroupName in groups)if (groups.hasOwnProperty(currentGroupName)) {
                    var _context;
                    _sortInstanceProperty(_context = groups[currentGroupName]).call(_context, function(a, b) {
                        return a.center - b.center;
                    });
                }
                this.dataChanged = false;
            }
        },
        {
            key: "_getClusterForItems",
            value: function _getClusterForItems(clusterItems, group, oldClusters, options) {
                var _context2;
                var oldClustersLookup = _mapInstanceProperty(_context2 = oldClusters || []).call(_context2, function(cluster) {
                    var _context3;
                    return {
                        cluster: cluster,
                        itemsIds: new _Set(_mapInstanceProperty(_context3 = cluster.data.uiItems).call(_context3, function(item) {
                            return item.id;
                        }))
                    };
                });
                var cluster;
                if (oldClustersLookup.length) {
                    var _iterator = _createForOfIteratorHelper$2(oldClustersLookup), _step;
                    try {
                        var _loop = function _loop() {
                            var oldClusterData = _step.value;
                            if (oldClusterData.itemsIds.size === clusterItems.length && _everyInstanceProperty(clusterItems).call(clusterItems, function(clusterItem) {
                                return oldClusterData.itemsIds.has(clusterItem.id);
                            })) {
                                cluster = oldClusterData.cluster;
                                return 1; // break
                            }
                        };
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            if (_loop()) break;
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                if (cluster) {
                    cluster.setUiItems(clusterItems);
                    if (cluster.group !== group) {
                        if (cluster.group) cluster.group.remove(cluster);
                        if (group) {
                            group.add(cluster);
                            cluster.group = group;
                        }
                    }
                    return cluster;
                }
                var titleTemplate = options.titleTemplate || "";
                var conversion = {
                    toScreen: this.itemSet.body.util.toScreen,
                    toTime: this.itemSet.body.util.toTime
                };
                var title = titleTemplate.replace(/{count}/, clusterItems.length);
                var clusterContent = '<div title="' + title + '">' + clusterItems.length + "</div>";
                var clusterOptions = _Object$assign({}, options, this.itemSet.options);
                var data = {
                    "content": clusterContent,
                    "title": title,
                    "group": group,
                    "uiItems": clusterItems,
                    "eventEmitter": this.itemSet.body.emitter,
                    "range": this.itemSet.body.range
                };
                cluster = this.createClusterItem(data, conversion, clusterOptions);
                if (group) {
                    group.add(cluster);
                    cluster.group = group;
                }
                cluster.attach();
                return cluster;
            }
        },
        {
            key: "_dropLevelsCache",
            value: function _dropLevelsCache() {
                this.cache = {};
                this.cacheLevel = -1;
                this.cache[this.cacheLevel] = [];
            }
        }
    ]);
    return ClusterGenerator;
}();
var css_248z$3 = '\n.vis-itemset {\n  position: relative;\n  padding: 0;\n  margin: 0;\n\n  box-sizing: border-box;\n}\n\n.vis-itemset .vis-background,\n.vis-itemset .vis-foreground {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.vis-axis {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.vis-foreground .vis-group {\n  position: relative;\n  box-sizing: border-box;\n  border-bottom: 1px solid #bfbfbf;\n}\n\n.vis-foreground .vis-group:last-child {\n  border-bottom: none;\n}\n\n.vis-nesting-group {\n  cursor: pointer;\n}\n\n.vis-label.vis-nested-group.vis-group-level-unknown-but-gte1 {\n  background: #f5f5f5;\n}\n.vis-label.vis-nested-group.vis-group-level-0 {\n  background-color: #ffffff;\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-0 .vis-inner {\n  padding-left: 0;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-0 .vis-inner {\n  padding-right: 0;\n}\n.vis-label.vis-nested-group.vis-group-level-1 {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-1 .vis-inner {\n  padding-left: 15px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-1 .vis-inner {\n  padding-right: 15px;\n}\n.vis-label.vis-nested-group.vis-group-level-2 {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-2 .vis-inner {\n  padding-left: 30px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-2 .vis-inner {\n  padding-right: 30px;\n}\n.vis-label.vis-nested-group.vis-group-level-3 {\n  background-color: rgba(0, 0, 0, 0.15);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-3 .vis-inner {\n  padding-left: 45px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-3 .vis-inner {\n  padding-right: 45px;\n}\n.vis-label.vis-nested-group.vis-group-level-4 {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-4 .vis-inner {\n  padding-left: 60px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-4 .vis-inner {\n  padding-right: 60px;\n}\n.vis-label.vis-nested-group.vis-group-level-5 {\n  background-color: rgba(0, 0, 0, 0.25);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-5 .vis-inner {\n  padding-left: 75px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-5 .vis-inner {\n  padding-right: 75px;\n}\n.vis-label.vis-nested-group.vis-group-level-6 {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-6 .vis-inner {\n  padding-left: 90px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-6 .vis-inner {\n  padding-right: 90px;\n}\n.vis-label.vis-nested-group.vis-group-level-7 {\n  background-color: rgba(0, 0, 0, 0.35);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-7 .vis-inner {\n  padding-left: 105px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-7 .vis-inner {\n  padding-right: 105px;\n}\n.vis-label.vis-nested-group.vis-group-level-8 {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-8 .vis-inner {\n  padding-left: 120px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-8 .vis-inner {\n  padding-right: 120px;\n}\n.vis-label.vis-nested-group.vis-group-level-9 {\n  background-color: rgba(0, 0, 0, 0.45);\n}\n.vis-ltr .vis-label.vis-nested-group.vis-group-level-9 .vis-inner {\n  padding-left: 135px;\n}\n.vis-rtl .vis-label.vis-nested-group.vis-group-level-9 .vis-inner {\n  padding-right: 135px;\n}\n/* default takes over beginning with level-10 (thats why we add .vis-nested-group\n  to the selectors above, to have higher specifity than these rules for the defaults) */\n.vis-label.vis-nested-group {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.vis-ltr .vis-label.vis-nested-group .vis-inner {\n  padding-left: 150px;\n}\n.vis-rtl .vis-label.vis-nested-group .vis-inner {\n  padding-right: 150px;\n}\n\n.vis-group-level-unknown-but-gte1 {\n  border: 1px solid red;\n}\n\n/* expanded/collapsed indicators */\n.vis-label.vis-nesting-group:before,\n.vis-label.vis-nesting-group:before {\n  display: inline-block;\n  width: 15px;\n}\n.vis-label.vis-nesting-group.expanded:before {\n  content: "\\25BC";\n}\n.vis-label.vis-nesting-group.collapsed:before {\n  content: "\\25B6";\n}\n.vis-rtl .vis-label.vis-nesting-group.collapsed:before {\n  content: "\\25C0";\n}\n/* compensate missing expanded/collapsed indicator, but only at levels > 0 */\n.vis-ltr .vis-label:not(.vis-nesting-group):not(.vis-group-level-0) {\n  padding-left: 15px;\n}\n.vis-rtl .vis-label:not(.vis-nesting-group):not(.vis-group-level-0) {\n  padding-right: 15px;\n}\n\n.vis-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}';
styleInject(css_248z$3);
var css_248z$2 = "\n.vis-labelset {\n  position: relative;\n\n  overflow: hidden;\n\n  box-sizing: border-box;\n}\n\n.vis-labelset .vis-label {\n  position: relative;\n  left: 0;\n  top: 0;\n  width: 100%;\n  color: #4d4d4d;\n\n  box-sizing: border-box;\n}\n\n.vis-labelset .vis-label {\n  border-bottom: 1px solid #bfbfbf;\n}\n\n.vis-labelset .vis-label.draggable {\n  cursor: pointer;\n}\n\n.vis-group-is-dragging {\n  background: rgba(0, 0, 0, .1);\n}\n\n.vis-labelset .vis-label:last-child {\n  border-bottom: none;\n}\n\n.vis-labelset .vis-label .vis-inner {\n  display: inline-block;\n  padding: 5px;\n}\n\n.vis-labelset .vis-label .vis-inner.vis-hidden {\n  padding: 0;\n}\n";
styleInject(css_248z$2);
function _createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray$1(o, minLen) {
    var _context34;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = _sliceInstanceProperty(_context34 = Object.prototype.toString.call(o)).call(_context34, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var UNGROUPED$1 = "__ungrouped__"; // reserved group id for ungrouped items
var BACKGROUND = "__background__"; // reserved group id for background items without group
/**
 * An ItemSet holds a set of items and ranges which can be displayed in a
 * range. The width is determined by the parent of the ItemSet, and the height
 * is determined by the size of the items.
 */ var ItemSet = /*#__PURE__*/ function(_Component) {
    _inherits(ItemSet, _Component);
    var _super = _createSuper$2(ItemSet);
    /**
  * @param {{dom: Object, domProps: Object, emitter: Emitter, range: Range}} body
  * @param {Object} [options]      See ItemSet.setOptions for the available options.
  * @constructor ItemSet
  * @extends Component
  */ function ItemSet(body, options) {
        var _this;
        _classCallCheck(this, ItemSet);
        _this = _super.call(this);
        _this.body = body;
        _this.defaultOptions = {
            type: null,
            // 'box', 'point', 'range', 'background'
            orientation: {
                item: "bottom" // item orientation: 'top' or 'bottom'
            },
            align: "auto",
            // alignment of box items
            stack: true,
            stackSubgroups: true,
            groupOrderSwap: function groupOrderSwap(fromGroup, toGroup, groups) {
                // eslint-disable-line no-unused-vars
                var targetOrder = toGroup.order;
                toGroup.order = fromGroup.order;
                fromGroup.order = targetOrder;
            },
            groupOrder: "order",
            selectable: true,
            multiselect: false,
            longSelectPressTime: 251,
            itemsAlwaysDraggable: {
                item: false,
                range: false
            },
            editable: {
                updateTime: false,
                updateGroup: false,
                add: false,
                remove: false,
                overrideItems: false
            },
            groupEditable: {
                order: false,
                add: false,
                remove: false
            },
            snap: TimeStep.snap,
            // Only called when `objectData.target === 'item'.
            onDropObjectOnItem: function onDropObjectOnItem(objectData, item, callback) {
                callback(item);
            },
            onAdd: function onAdd(item, callback) {
                callback(item);
            },
            onUpdate: function onUpdate(item, callback) {
                callback(item);
            },
            onMove: function onMove(item, callback) {
                callback(item);
            },
            onRemove: function onRemove(item, callback) {
                callback(item);
            },
            onMoving: function onMoving(item, callback) {
                callback(item);
            },
            onAddGroup: function onAddGroup(item, callback) {
                callback(item);
            },
            onMoveGroup: function onMoveGroup(item, callback) {
                callback(item);
            },
            onRemoveGroup: function onRemoveGroup(item, callback) {
                callback(item);
            },
            margin: {
                item: {
                    horizontal: 10,
                    vertical: 10
                },
                axis: 20
            },
            showTooltips: true,
            tooltip: {
                followMouse: false,
                overflowMethod: "flip",
                delay: 500
            },
            tooltipOnItemUpdateTime: false
        };
        // options is shared by this ItemSet and all its items
        _this.options = availableUtils.extend({}, _this.defaultOptions);
        _this.options.rtl = options.rtl;
        _this.options.onTimeout = options.onTimeout;
        _this.conversion = {
            toScreen: body.util.toScreen,
            toTime: body.util.toTime
        };
        _this.dom = {};
        _this.props = {};
        _this.hammer = null;
        var me = _assertThisInitialized(_this);
        _this.itemsData = null; // DataSet
        _this.groupsData = null; // DataSet
        _this.itemsSettingTime = null;
        _this.initialItemSetDrawn = false;
        _this.userContinueNotBail = null;
        _this.sequentialSelection = false;
        // listeners for the DataSet of the items
        _this.itemListeners = {
            "add": function add(event1, params, senderId) {
                // eslint-disable-line no-unused-vars
                me._onAdd(params.items);
                if (me.options.cluster) me.clusterGenerator.setItems(me.items, {
                    applyOnChangedLevel: false
                });
                me.redraw();
            },
            "update": function update(event1, params, senderId) {
                // eslint-disable-line no-unused-vars
                me._onUpdate(params.items);
                if (me.options.cluster) me.clusterGenerator.setItems(me.items, {
                    applyOnChangedLevel: false
                });
                me.redraw();
            },
            "remove": function remove(event1, params, senderId) {
                // eslint-disable-line no-unused-vars
                me._onRemove(params.items);
                if (me.options.cluster) me.clusterGenerator.setItems(me.items, {
                    applyOnChangedLevel: false
                });
                me.redraw();
            }
        };
        // listeners for the DataSet of the groups
        _this.groupListeners = {
            "add": function add(event1, params, senderId) {
                // eslint-disable-line no-unused-vars
                me._onAddGroups(params.items);
                if (me.groupsData && me.groupsData.length > 0) {
                    var _context;
                    var groupsData = me.groupsData.getDataSet();
                    _forEachInstanceProperty(_context = groupsData.get()).call(_context, function(groupData) {
                        if (groupData.nestedGroups) {
                            var _context2;
                            if (groupData.showNested != false) groupData.showNested = true;
                            var updatedGroups = [];
                            _forEachInstanceProperty(_context2 = groupData.nestedGroups).call(_context2, function(nestedGroupId) {
                                var updatedNestedGroup = groupsData.get(nestedGroupId);
                                if (!updatedNestedGroup) return;
                                updatedNestedGroup.nestedInGroup = groupData.id;
                                if (groupData.showNested == false) updatedNestedGroup.visible = false;
                                updatedGroups = _concatInstanceProperty(updatedGroups).call(updatedGroups, updatedNestedGroup);
                            });
                            groupsData.update(updatedGroups, senderId);
                        }
                    });
                }
            },
            "update": function update(event1, params, senderId) {
                // eslint-disable-line no-unused-vars
                me._onUpdateGroups(params.items);
            },
            "remove": function remove(event1, params, senderId) {
                // eslint-disable-line no-unused-vars
                me._onRemoveGroups(params.items);
            }
        };
        _this.items = {}; // object with an Item for every data item
        _this.groups = {}; // Group object for every group
        _this.groupIds = [];
        _this.selection = []; // list with the ids of all selected nodes
        _this.popup = null;
        _this.popupTimer = null;
        _this.touchParams = {}; // stores properties while dragging
        _this.groupTouchParams = {
            group: null,
            isDragging: false
        };
        // create the HTML DOM
        _this._create();
        _this.setOptions(options);
        _this.clusters = [];
        return _this;
    }
    /**
   * Create the HTML DOM for the ItemSet
   */ _createClass(ItemSet, [
        {
            key: "_create",
            value: function _create() {
                var _this2 = this, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17;
                var frame = document.createElement("div");
                frame.className = "vis-itemset";
                frame["vis-itemset"] = this;
                this.dom.frame = frame;
                // create background panel
                var background = document.createElement("div");
                background.className = "vis-background";
                frame.appendChild(background);
                this.dom.background = background;
                // create foreground panel
                var foreground = document.createElement("div");
                foreground.className = "vis-foreground";
                frame.appendChild(foreground);
                this.dom.foreground = foreground;
                // create axis panel
                var axis = document.createElement("div");
                axis.className = "vis-axis";
                this.dom.axis = axis;
                // create labelset
                var labelSet = document.createElement("div");
                labelSet.className = "vis-labelset";
                this.dom.labelSet = labelSet;
                // create ungrouped Group
                this._updateUngrouped();
                // create background Group
                var backgroundGroup = new BackgroundGroup(BACKGROUND, null, this);
                backgroundGroup.show();
                this.groups[BACKGROUND] = backgroundGroup;
                // attach event listeners
                // Note: we bind to the centerContainer for the case where the height
                //       of the center container is larger than of the ItemSet, so we
                //       can click in the empty area to create a new item or deselect an item.
                this.hammer = new Hammer(this.body.dom.centerContainer);
                // drag items when selected
                this.hammer.on("hammer.input", function(event1) {
                    if (event1.isFirst) _this2._onTouch(event1);
                });
                this.hammer.on("panstart", _bindInstanceProperty$1(_context3 = this._onDragStart).call(_context3, this));
                this.hammer.on("panmove", _bindInstanceProperty$1(_context4 = this._onDrag).call(_context4, this));
                this.hammer.on("panend", _bindInstanceProperty$1(_context5 = this._onDragEnd).call(_context5, this));
                this.hammer.get("pan").set({
                    threshold: 5,
                    direction: Hammer.ALL
                });
                // delay addition on item click for trackpads...
                this.hammer.get("press").set({
                    time: 10000
                });
                // single select (or unselect) when tapping an item
                this.hammer.on("tap", _bindInstanceProperty$1(_context6 = this._onSelectItem).call(_context6, this));
                // multi select when holding mouse/touch, or on ctrl+click
                this.hammer.on("press", _bindInstanceProperty$1(_context7 = this._onMultiSelectItem).call(_context7, this));
                // delay addition on item click for trackpads...
                this.hammer.get("press").set({
                    time: 10000
                });
                // add item on doubletap
                this.hammer.on("doubletap", _bindInstanceProperty$1(_context8 = this._onAddItem).call(_context8, this));
                if (this.options.rtl) this.groupHammer = new Hammer(this.body.dom.rightContainer);
                else this.groupHammer = new Hammer(this.body.dom.leftContainer);
                this.groupHammer.on("tap", _bindInstanceProperty$1(_context9 = this._onGroupClick).call(_context9, this));
                this.groupHammer.on("panstart", _bindInstanceProperty$1(_context10 = this._onGroupDragStart).call(_context10, this));
                this.groupHammer.on("panmove", _bindInstanceProperty$1(_context11 = this._onGroupDrag).call(_context11, this));
                this.groupHammer.on("panend", _bindInstanceProperty$1(_context12 = this._onGroupDragEnd).call(_context12, this));
                this.groupHammer.get("pan").set({
                    threshold: 5,
                    direction: Hammer.DIRECTION_VERTICAL
                });
                this.body.dom.centerContainer.addEventListener("mouseover", _bindInstanceProperty$1(_context13 = this._onMouseOver).call(_context13, this));
                this.body.dom.centerContainer.addEventListener("mouseout", _bindInstanceProperty$1(_context14 = this._onMouseOut).call(_context14, this));
                this.body.dom.centerContainer.addEventListener("mousemove", _bindInstanceProperty$1(_context15 = this._onMouseMove).call(_context15, this));
                // right-click on timeline 
                this.body.dom.centerContainer.addEventListener("contextmenu", _bindInstanceProperty$1(_context16 = this._onDragEnd).call(_context16, this));
                this.body.dom.centerContainer.addEventListener("mousewheel", _bindInstanceProperty$1(_context17 = this._onMouseWheel).call(_context17, this));
                // attach to the DOM
                this.show();
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _this3 = this;
                if (options) {
                    var _context18, _context20;
                    // copy all options that we know
                    var fields = [
                        "type",
                        "rtl",
                        "align",
                        "order",
                        "stack",
                        "stackSubgroups",
                        "selectable",
                        "multiselect",
                        "sequentialSelection",
                        "multiselectPerGroup",
                        "longSelectPressTime",
                        "groupOrder",
                        "dataAttributes",
                        "template",
                        "groupTemplate",
                        "visibleFrameTemplate",
                        "hide",
                        "snap",
                        "groupOrderSwap",
                        "showTooltips",
                        "tooltip",
                        "tooltipOnItemUpdateTime",
                        "groupHeightMode",
                        "onTimeout"
                    ];
                    availableUtils.selectiveExtend(fields, this.options, options);
                    if ("itemsAlwaysDraggable" in options) {
                        if (typeof options.itemsAlwaysDraggable === "boolean") {
                            this.options.itemsAlwaysDraggable.item = options.itemsAlwaysDraggable;
                            this.options.itemsAlwaysDraggable.range = false;
                        } else if (_typeof$1(options.itemsAlwaysDraggable) === "object") {
                            availableUtils.selectiveExtend([
                                "item",
                                "range"
                            ], this.options.itemsAlwaysDraggable, options.itemsAlwaysDraggable);
                            // only allow range always draggable when item is always draggable as well
                            if (!this.options.itemsAlwaysDraggable.item) this.options.itemsAlwaysDraggable.range = false;
                        }
                    }
                    if ("sequentialSelection" in options) {
                        if (typeof options.sequentialSelection === "boolean") this.options.sequentialSelection = options.sequentialSelection;
                    }
                    if ("orientation" in options) {
                        if (typeof options.orientation === "string") this.options.orientation.item = options.orientation === "top" ? "top" : "bottom";
                        else if (_typeof$1(options.orientation) === "object" && "item" in options.orientation) this.options.orientation.item = options.orientation.item;
                    }
                    if ("margin" in options) {
                        if (typeof options.margin === "number") {
                            this.options.margin.axis = options.margin;
                            this.options.margin.item.horizontal = options.margin;
                            this.options.margin.item.vertical = options.margin;
                        } else if (_typeof$1(options.margin) === "object") {
                            availableUtils.selectiveExtend([
                                "axis"
                            ], this.options.margin, options.margin);
                            if ("item" in options.margin) {
                                if (typeof options.margin.item === "number") {
                                    this.options.margin.item.horizontal = options.margin.item;
                                    this.options.margin.item.vertical = options.margin.item;
                                } else if (_typeof$1(options.margin.item) === "object") availableUtils.selectiveExtend([
                                    "horizontal",
                                    "vertical"
                                ], this.options.margin.item, options.margin.item);
                            }
                        }
                    }
                    _forEachInstanceProperty(_context18 = [
                        "locale",
                        "locales"
                    ]).call(_context18, function(key) {
                        if (key in options) _this3.options[key] = options[key];
                    });
                    if ("editable" in options) {
                        if (typeof options.editable === "boolean") {
                            this.options.editable.updateTime = options.editable;
                            this.options.editable.updateGroup = options.editable;
                            this.options.editable.add = options.editable;
                            this.options.editable.remove = options.editable;
                            this.options.editable.overrideItems = false;
                        } else if (_typeof$1(options.editable) === "object") availableUtils.selectiveExtend([
                            "updateTime",
                            "updateGroup",
                            "add",
                            "remove",
                            "overrideItems"
                        ], this.options.editable, options.editable);
                    }
                    if ("groupEditable" in options) {
                        if (typeof options.groupEditable === "boolean") {
                            this.options.groupEditable.order = options.groupEditable;
                            this.options.groupEditable.add = options.groupEditable;
                            this.options.groupEditable.remove = options.groupEditable;
                        } else if (_typeof$1(options.groupEditable) === "object") availableUtils.selectiveExtend([
                            "order",
                            "add",
                            "remove"
                        ], this.options.groupEditable, options.groupEditable);
                    }
                    // callback functions
                    var addCallback = function addCallback(name) {
                        var fn = options[name];
                        if (fn) {
                            if (!(typeof fn === "function")) {
                                var _context19;
                                throw new Error(_concatInstanceProperty(_context19 = "option ".concat(name, " must be a function ")).call(_context19, name, "(item, callback)"));
                            }
                            _this3.options[name] = fn;
                        }
                    };
                    _forEachInstanceProperty(_context20 = [
                        "onDropObjectOnItem",
                        "onAdd",
                        "onUpdate",
                        "onRemove",
                        "onMove",
                        "onMoving",
                        "onAddGroup",
                        "onMoveGroup",
                        "onRemoveGroup"
                    ]).call(_context20, addCallback);
                    if (options.cluster) {
                        _Object$assign(this.options, {
                            cluster: options.cluster
                        });
                        if (!this.clusterGenerator) this.clusterGenerator = new ClusterGenerator(this);
                        this.clusterGenerator.setItems(this.items, {
                            applyOnChangedLevel: false
                        });
                        this.markDirty({
                            refreshItems: true,
                            restackGroups: true
                        });
                        this.redraw();
                    } else if (this.clusterGenerator) {
                        this._detachAllClusters();
                        this.clusters = [];
                        this.clusterGenerator = null;
                        this.options.cluster = undefined;
                        this.markDirty({
                            refreshItems: true,
                            restackGroups: true
                        });
                        this.redraw();
                    } else // force the itemSet to refresh: options like orientation and margins may be changed
                    this.markDirty();
                }
            }
        },
        {
            key: "markDirty",
            value: function markDirty(options) {
                this.groupIds = [];
                if (options) {
                    if (options.refreshItems) _forEachInstanceProperty(availableUtils).call(availableUtils, this.items, function(item) {
                        item.dirty = true;
                        if (item.displayed) item.redraw();
                    });
                    if (options.restackGroups) _forEachInstanceProperty(availableUtils).call(availableUtils, this.groups, function(group, key) {
                        if (key === BACKGROUND) return;
                        group.stackDirty = true;
                    });
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.clearPopupTimer();
                this.hide();
                this.setItems(null);
                this.setGroups(null);
                this.hammer && this.hammer.destroy();
                this.groupHammer && this.groupHammer.destroy();
                this.hammer = null;
                this.body = null;
                this.conversion = null;
            }
        },
        {
            key: "hide",
            value: function hide() {
                // remove the frame containing the items
                if (this.dom.frame.parentNode) this.dom.frame.parentNode.removeChild(this.dom.frame);
                // remove the axis with dots
                if (this.dom.axis.parentNode) this.dom.axis.parentNode.removeChild(this.dom.axis);
                // remove the labelset containing all group labels
                if (this.dom.labelSet.parentNode) this.dom.labelSet.parentNode.removeChild(this.dom.labelSet);
            }
        },
        {
            key: "show",
            value: function show() {
                // show frame containing the items
                if (!this.dom.frame.parentNode) this.body.dom.center.appendChild(this.dom.frame);
                // show axis with dots
                if (!this.dom.axis.parentNode) this.body.dom.backgroundVertical.appendChild(this.dom.axis);
                // show labelset containing labels
                if (!this.dom.labelSet.parentNode) {
                    if (this.options.rtl) this.body.dom.right.appendChild(this.dom.labelSet);
                    else this.body.dom.left.appendChild(this.dom.labelSet);
                }
            }
        },
        {
            key: "setPopupTimer",
            value: function setPopupTimer(popup) {
                this.clearPopupTimer();
                if (popup) {
                    var delay = this.options.tooltip.delay || typeof this.options.tooltip.delay === "number" ? this.options.tooltip.delay : 500;
                    this.popupTimer = _setTimeout(function() {
                        popup.show();
                    }, delay);
                }
            }
        },
        {
            key: "clearPopupTimer",
            value: function clearPopupTimer() {
                if (this.popupTimer != null) {
                    clearTimeout(this.popupTimer);
                    this.popupTimer = null;
                }
            }
        },
        {
            key: "setSelection",
            value: function setSelection(ids) {
                var _context21;
                if (ids == undefined) ids = [];
                if (!_Array$isArray(ids)) ids = [
                    ids
                ];
                var idsToDeselect = _filterInstanceProperty(_context21 = this.selection).call(_context21, function(id) {
                    return _indexOfInstanceProperty(ids).call(ids, id) === -1;
                });
                // unselect currently selected items
                var _iterator = _createForOfIteratorHelper$1(idsToDeselect), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var selectedId = _step.value;
                        var item = this.getItemById(selectedId);
                        if (item) item.unselect();
                    }
                // select items
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                this.selection = _toConsumableArray(ids);
                var _iterator2 = _createForOfIteratorHelper$1(ids), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var id = _step2.value;
                        var _item2 = this.getItemById(id);
                        if (_item2) _item2.select();
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
        },
        {
            key: "getSelection",
            value: function getSelection() {
                var _context22;
                return _concatInstanceProperty(_context22 = this.selection).call(_context22, []);
            }
        },
        {
            key: "getVisibleItems",
            value: function getVisibleItems() {
                var range = this.body.range.getRange();
                var right;
                var left;
                if (this.options.rtl) {
                    right = this.body.util.toScreen(range.start);
                    left = this.body.util.toScreen(range.end);
                } else {
                    left = this.body.util.toScreen(range.start);
                    right = this.body.util.toScreen(range.end);
                }
                var ids = [];
                for(var groupId in this.groups)if (this.groups.hasOwnProperty(groupId)) {
                    var group = this.groups[groupId];
                    var rawVisibleItems = group.isVisible ? group.visibleItems : [];
                    // filter the "raw" set with visibleItems into a set which is really
                    // visible by pixels
                    var _iterator3 = _createForOfIteratorHelper$1(rawVisibleItems), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var item = _step3.value;
                            // TODO: also check whether visible vertically
                            if (this.options.rtl) {
                                if (item.right < left && item.right + item.width > right) ids.push(item.id);
                            } else if (item.left < right && item.left + item.width > left) ids.push(item.id);
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                }
                return ids;
            }
        },
        {
            key: "getItemsAtCurrentTime",
            value: function getItemsAtCurrentTime(timeOfEvent) {
                var right;
                var left;
                if (this.options.rtl) {
                    right = this.body.util.toScreen(timeOfEvent);
                    left = this.body.util.toScreen(timeOfEvent);
                } else {
                    left = this.body.util.toScreen(timeOfEvent);
                    right = this.body.util.toScreen(timeOfEvent);
                }
                var ids = [];
                for(var groupId in this.groups)if (this.groups.hasOwnProperty(groupId)) {
                    var group = this.groups[groupId];
                    var rawVisibleItems = group.isVisible ? group.visibleItems : [];
                    // filter the "raw" set with visibleItems into a set which is really
                    // visible by pixels
                    var _iterator4 = _createForOfIteratorHelper$1(rawVisibleItems), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var item = _step4.value;
                            if (this.options.rtl) {
                                if (item.right < left && item.right + item.width > right) ids.push(item.id);
                            } else if (item.left < right && item.left + item.width > left) ids.push(item.id);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
                return ids;
            }
        },
        {
            key: "getVisibleGroups",
            value: function getVisibleGroups() {
                var ids = [];
                for(var groupId in this.groups)if (this.groups.hasOwnProperty(groupId)) {
                    var group = this.groups[groupId];
                    if (group.isVisible) ids.push(groupId);
                }
                return ids;
            }
        },
        {
            key: "getItemById",
            value: function getItemById(id) {
                var _context23;
                return this.items[id] || _findInstanceProperty(_context23 = this.clusters).call(_context23, function(cluster) {
                    return cluster.id === id;
                });
            }
        },
        {
            key: "_deselect",
            value: function _deselect(id) {
                var selection = this.selection;
                for(var i1 = 0, ii = selection.length; i1 < ii; i1++)if (selection[i1] == id) {
                    // non-strict comparison!
                    _spliceInstanceProperty(selection).call(selection, i1, 1);
                    break;
                }
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                var margin = this.options.margin;
                var range = this.body.range;
                var asSize = availableUtils.option.asSize;
                var options = this.options;
                var orientation = options.orientation.item;
                var resized = false;
                var frame = this.dom.frame;
                // recalculate absolute position (before redrawing groups)
                this.props.top = this.body.domProps.top.height + this.body.domProps.border.top;
                if (this.options.rtl) this.props.right = this.body.domProps.right.width + this.body.domProps.border.right;
                else this.props.left = this.body.domProps.left.width + this.body.domProps.border.left;
                // update class name
                frame.className = "vis-itemset";
                if (this.options.cluster) this._clusterItems();
                // reorder the groups (if needed)
                resized = this._orderGroups() || resized;
                // check whether zoomed (in that case we need to re-stack everything)
                // TODO: would be nicer to get this as a trigger from Range
                var visibleInterval = range.end - range.start;
                var zoomed = visibleInterval != this.lastVisibleInterval || this.props.width != this.props.lastWidth;
                var scrolled = range.start != this.lastRangeStart;
                var changedStackOption = options.stack != this.lastStack;
                var changedStackSubgroupsOption = options.stackSubgroups != this.lastStackSubgroups;
                var forceRestack = zoomed || scrolled || changedStackOption || changedStackSubgroupsOption;
                this.lastVisibleInterval = visibleInterval;
                this.lastRangeStart = range.start;
                this.lastStack = options.stack;
                this.lastStackSubgroups = options.stackSubgroups;
                this.props.lastWidth = this.props.width;
                var firstGroup = this._firstGroup();
                var firstMargin = {
                    item: margin.item,
                    axis: margin.axis
                };
                var nonFirstMargin = {
                    item: margin.item,
                    axis: margin.item.vertical / 2
                };
                var height = 0;
                var minHeight = margin.axis + margin.item.vertical;
                // redraw the background group
                this.groups[BACKGROUND].redraw(range, nonFirstMargin, forceRestack);
                var redrawQueue = {};
                var redrawQueueLength = 0;
                // collect redraw functions
                _forEachInstanceProperty(availableUtils).call(availableUtils, this.groups, function(group, key) {
                    if (key === BACKGROUND) return;
                    var groupMargin = group == firstGroup ? firstMargin : nonFirstMargin;
                    var returnQueue = true;
                    redrawQueue[key] = group.redraw(range, groupMargin, forceRestack, returnQueue);
                    redrawQueueLength = redrawQueue[key].length;
                });
                var needRedraw = redrawQueueLength > 0;
                if (needRedraw) {
                    var redrawResults = {};
                    var _loop = function _loop(i1) {
                        _forEachInstanceProperty(availableUtils).call(availableUtils, redrawQueue, function(fns, key) {
                            redrawResults[key] = fns[i1]();
                        });
                    };
                    for(var i1 = 0; i1 < redrawQueueLength; i1++)_loop(i1);
                    // redraw all regular groups
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.groups, function(group, key) {
                        if (key === BACKGROUND) return;
                        var groupResized = redrawResults[key];
                        resized = groupResized || resized;
                        height += group.height;
                    });
                    height = Math.max(height, minHeight);
                }
                height = Math.max(height, minHeight);
                // update frame height
                frame.style.height = asSize(height);
                // calculate actual size
                this.props.width = frame.offsetWidth;
                this.props.height = height;
                // reposition axis
                this.dom.axis.style.top = asSize(orientation == "top" ? this.body.domProps.top.height + this.body.domProps.border.top : this.body.domProps.top.height + this.body.domProps.centerContainer.height);
                if (this.options.rtl) this.dom.axis.style.right = "0";
                else this.dom.axis.style.left = "0";
                this.hammer.get("press").set({
                    time: this.options.longSelectPressTime
                });
                this.initialItemSetDrawn = true;
                // check if this component is resized
                resized = this._isResized() || resized;
                return resized;
            }
        },
        {
            key: "_firstGroup",
            value: function _firstGroup() {
                var firstGroupIndex = this.options.orientation.item == "top" ? 0 : this.groupIds.length - 1;
                var firstGroupId = this.groupIds[firstGroupIndex];
                var firstGroup = this.groups[firstGroupId] || this.groups[UNGROUPED$1];
                return firstGroup || null;
            }
        },
        {
            key: "_updateUngrouped",
            value: function _updateUngrouped() {
                var ungrouped = this.groups[UNGROUPED$1];
                var item;
                var itemId;
                if (this.groupsData) // remove the group holding all ungrouped items
                {
                    if (ungrouped) {
                        ungrouped.dispose();
                        delete this.groups[UNGROUPED$1];
                        for(itemId in this.items)if (this.items.hasOwnProperty(itemId)) {
                            item = this.items[itemId];
                            item.parent && item.parent.remove(item);
                            var groupId = this.getGroupId(item.data);
                            var group = this.groups[groupId];
                            group && group.add(item) || item.hide();
                        }
                    }
                } else // create a group holding all (unfiltered) items
                if (!ungrouped) {
                    var id = null;
                    var data = null;
                    ungrouped = new Group(id, data, this);
                    this.groups[UNGROUPED$1] = ungrouped;
                    for(itemId in this.items)if (this.items.hasOwnProperty(itemId)) {
                        item = this.items[itemId];
                        ungrouped.add(item);
                    }
                    ungrouped.show();
                }
            }
        },
        {
            key: "getLabelSet",
            value: function getLabelSet() {
                return this.dom.labelSet;
            }
        },
        {
            key: "setItems",
            value: function setItems(items) {
                this.itemsSettingTime = new Date();
                var me = this;
                var ids;
                var oldItemsData = this.itemsData;
                // replace the dataset
                if (!items) this.itemsData = null;
                else if (isDataViewLike(items)) this.itemsData = typeCoerceDataSet(items);
                else throw new TypeError("Data must implement the interface of DataSet or DataView");
                if (oldItemsData) {
                    // unsubscribe from old dataset
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.itemListeners, function(callback, event1) {
                        oldItemsData.off(event1, callback);
                    });
                    // stop maintaining a coerced version of the old data set
                    oldItemsData.dispose();
                    // remove all drawn items
                    ids = oldItemsData.getIds();
                    this._onRemove(ids);
                }
                if (this.itemsData) {
                    // subscribe to new dataset
                    var id = this.id;
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.itemListeners, function(callback, event1) {
                        me.itemsData.on(event1, callback, id);
                    });
                    // add all new items
                    ids = this.itemsData.getIds();
                    this._onAdd(ids);
                    // update the group holding all ungrouped items
                    this._updateUngrouped();
                }
                this.body.emitter.emit("_change", {
                    queue: true
                });
            }
        },
        {
            key: "getItems",
            value: function getItems() {
                return this.itemsData != null ? this.itemsData.rawDS : null;
            }
        },
        {
            key: "setGroups",
            value: function setGroups(groups) {
                var me = this;
                var ids;
                // unsubscribe from current dataset
                if (this.groupsData) {
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.groupListeners, function(callback, event1) {
                        me.groupsData.off(event1, callback);
                    });
                    // remove all drawn groups
                    ids = this.groupsData.getIds();
                    this.groupsData = null;
                    this._onRemoveGroups(ids); // note: this will cause a redraw
                }
                // replace the dataset
                if (!groups) this.groupsData = null;
                else if (isDataViewLike(groups)) this.groupsData = groups;
                else throw new TypeError("Data must implement the interface of DataSet or DataView");
                if (this.groupsData) {
                    var _context24;
                    // go over all groups nesting
                    var groupsData = this.groupsData.getDataSet();
                    _forEachInstanceProperty(_context24 = groupsData.get()).call(_context24, function(group) {
                        if (group.nestedGroups) {
                            var _context25;
                            _forEachInstanceProperty(_context25 = group.nestedGroups).call(_context25, function(nestedGroupId) {
                                var updatedNestedGroup = groupsData.get(nestedGroupId);
                                updatedNestedGroup.nestedInGroup = group.id;
                                if (group.showNested == false) updatedNestedGroup.visible = false;
                                groupsData.update(updatedNestedGroup);
                            });
                        }
                    });
                    // subscribe to new dataset
                    var id = this.id;
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.groupListeners, function(callback, event1) {
                        me.groupsData.on(event1, callback, id);
                    });
                    // draw all ms
                    ids = this.groupsData.getIds();
                    this._onAddGroups(ids);
                }
                // update the group holding all ungrouped items
                this._updateUngrouped();
                // update the order of all items in each group
                this._order();
                if (this.options.cluster) {
                    this.clusterGenerator.updateData();
                    this._clusterItems();
                    this.markDirty({
                        refreshItems: true,
                        restackGroups: true
                    });
                }
                this.body.emitter.emit("_change", {
                    queue: true
                });
            }
        },
        {
            key: "getGroups",
            value: function getGroups() {
                return this.groupsData;
            }
        },
        {
            key: "removeItem",
            value: function removeItem(id) {
                var _this4 = this;
                var item = this.itemsData.get(id);
                if (item) // confirm deletion
                this.options.onRemove(item, function(item) {
                    if (item) // remove by id here, it is possible that an item has no id defined
                    // itself, so better not delete by the item itself
                    _this4.itemsData.remove(id);
                });
            }
        },
        {
            key: "_getType",
            value: function _getType(itemData) {
                return itemData.type || this.options.type || (itemData.end ? "range" : "box");
            }
        },
        {
            key: "getGroupId",
            value: function getGroupId(itemData) {
                var type = this._getType(itemData);
                if (type == "background" && itemData.group == undefined) return BACKGROUND;
                else return this.groupsData ? itemData.group : UNGROUPED$1;
            }
        },
        {
            key: "_onUpdate",
            value: function _onUpdate(ids) {
                var _this5 = this;
                var me = this;
                _forEachInstanceProperty(ids).call(ids, function(id) {
                    var itemData = me.itemsData.get(id);
                    var item = me.items[id];
                    var type = itemData ? me._getType(itemData) : null;
                    var constructor = ItemSet.types[type];
                    var selected;
                    if (item) {
                        // update item   	
                        if (!constructor || !(item instanceof constructor)) {
                            // item type has changed, delete the item and recreate it
                            selected = item.selected; // preserve selection of this item
                            me._removeItem(item);
                            item = null;
                        } else me._updateItem(item, itemData);
                    }
                    if (!item && itemData) {
                        // create item
                        if (constructor) {
                            item = new constructor(itemData, me.conversion, me.options);
                            item.id = id; // TODO: not so nice setting id afterwards
                            me._addItem(item);
                            if (selected) {
                                _this5.selection.push(id);
                                item.select();
                            }
                        } else throw new TypeError('Unknown item type "'.concat(type, '"'));
                    }
                });
                this._order();
                if (this.options.cluster) {
                    this.clusterGenerator.setItems(this.items, {
                        applyOnChangedLevel: false
                    });
                    this._clusterItems();
                }
                this.body.emitter.emit("_change", {
                    queue: true
                });
            }
        },
        {
            key: "_onRemove",
            value: function _onRemove(ids) {
                var count = 0;
                var me = this;
                _forEachInstanceProperty(ids).call(ids, function(id) {
                    var item = me.items[id];
                    if (item) {
                        count++;
                        me._removeItem(item);
                    }
                });
                if (count) {
                    // update order
                    this._order();
                    this.body.emitter.emit("_change", {
                        queue: true
                    });
                }
            }
        },
        {
            key: "_order",
            value: function _order() {
                // reorder the items in all groups
                // TODO: optimization: only reorder groups affected by the changed items
                _forEachInstanceProperty(availableUtils).call(availableUtils, this.groups, function(group) {
                    group.order();
                });
            }
        },
        {
            key: "_onUpdateGroups",
            value: function _onUpdateGroups(ids) {
                this._onAddGroups(ids);
            }
        },
        {
            key: "_onAddGroups",
            value: function _onAddGroups(ids) {
                var me = this;
                _forEachInstanceProperty(ids).call(ids, function(id) {
                    var groupData = me.groupsData.get(id);
                    var group = me.groups[id];
                    if (!group) {
                        // check for reserved ids
                        if (id == UNGROUPED$1 || id == BACKGROUND) throw new Error("Illegal group id. ".concat(id, " is a reserved id."));
                        var groupOptions = _Object$create$1(me.options);
                        availableUtils.extend(groupOptions, {
                            height: null
                        });
                        group = new Group(id, groupData, me);
                        me.groups[id] = group;
                        // add items with this groupId to the new group
                        for(var itemId in me.items)if (me.items.hasOwnProperty(itemId)) {
                            var item = me.items[itemId];
                            if (item.data.group == id) group.add(item);
                        }
                        group.order();
                        group.show();
                    } else // update group
                    group.setData(groupData);
                });
                this.body.emitter.emit("_change", {
                    queue: true
                });
            }
        },
        {
            key: "_onRemoveGroups",
            value: function _onRemoveGroups(ids) {
                var _this6 = this;
                _forEachInstanceProperty(ids).call(ids, function(id) {
                    var group = _this6.groups[id];
                    if (group) {
                        group.dispose();
                        delete _this6.groups[id];
                    }
                });
                if (this.options.cluster) {
                    this.clusterGenerator.updateData();
                    this._clusterItems();
                }
                this.markDirty({
                    restackGroups: !!this.options.cluster
                });
                this.body.emitter.emit("_change", {
                    queue: true
                });
            }
        },
        {
            key: "_orderGroups",
            value: function _orderGroups() {
                if (this.groupsData) {
                    // reorder the groups
                    var groupIds = this.groupsData.getIds({
                        order: this.options.groupOrder
                    });
                    groupIds = this._orderNestedGroups(groupIds);
                    var changed = !availableUtils.equalArray(groupIds, this.groupIds);
                    if (changed) {
                        // hide all groups, removes them from the DOM
                        var groups = this.groups;
                        _forEachInstanceProperty(groupIds).call(groupIds, function(groupId) {
                            groups[groupId].hide();
                        });
                        // show the groups again, attach them to the DOM in correct order
                        _forEachInstanceProperty(groupIds).call(groupIds, function(groupId) {
                            groups[groupId].show();
                        });
                        this.groupIds = groupIds;
                    }
                    return changed;
                } else return false;
            }
        },
        {
            key: "_orderNestedGroups",
            value: function _orderNestedGroups(groupIds) {
                var _this7 = this;
                /**
       * Recursively order nested groups
       *
       * @param {ItemSet} t
       * @param {Array.<number>} groupIds
       * @returns {Array.<number>}
       * @private
       */ function getOrderedNestedGroups(t, groupIds) {
                    var result = [];
                    _forEachInstanceProperty(groupIds).call(groupIds, function(groupId) {
                        result.push(groupId);
                        var groupData = t.groupsData.get(groupId);
                        if (groupData.nestedGroups) {
                            var _context26;
                            var nestedGroupIds = _mapInstanceProperty(_context26 = t.groupsData.get({
                                filter: function filter(nestedGroup) {
                                    return nestedGroup.nestedInGroup == groupId;
                                },
                                order: t.options.groupOrder
                            })).call(_context26, function(nestedGroup) {
                                return nestedGroup.id;
                            });
                            result = _concatInstanceProperty(result).call(result, getOrderedNestedGroups(t, nestedGroupIds));
                        }
                    });
                    return result;
                }
                var topGroupIds = _filterInstanceProperty(groupIds).call(groupIds, function(groupId) {
                    return !_this7.groupsData.get(groupId).nestedInGroup;
                });
                return getOrderedNestedGroups(this, topGroupIds);
            }
        },
        {
            key: "_addItem",
            value: function _addItem(item) {
                this.items[item.id] = item;
                // add to group
                var groupId = this.getGroupId(item.data);
                var group = this.groups[groupId];
                if (!group) item.groupShowing = false;
                else if (group && group.data && group.data.showNested) item.groupShowing = true;
                if (group) group.add(item);
            }
        },
        {
            key: "_updateItem",
            value: function _updateItem(item, itemData) {
                // update the items data (will redraw the item when displayed)
                item.setData(itemData);
                var groupId = this.getGroupId(item.data);
                var group = this.groups[groupId];
                if (!group) item.groupShowing = false;
                else if (group && group.data && group.data.showNested) item.groupShowing = true;
            }
        },
        {
            key: "_removeItem",
            value: function _removeItem(item) {
                var _context27, _context28;
                // remove from DOM
                item.hide();
                // remove from items
                delete this.items[item.id];
                // remove from selection
                var index = _indexOfInstanceProperty(_context27 = this.selection).call(_context27, item.id);
                if (index != -1) _spliceInstanceProperty(_context28 = this.selection).call(_context28, index, 1);
                // remove from group
                item.parent && item.parent.remove(item);
                // remove Tooltip from DOM
                if (this.popup != null) this.popup.hide();
            }
        },
        {
            key: "_constructByEndArray",
            value: function _constructByEndArray(array) {
                var endArray = [];
                for(var i1 = 0; i1 < array.length; i1++)if (array[i1] instanceof RangeItem) endArray.push(array[i1]);
                return endArray;
            }
        },
        {
            key: "_onTouch",
            value: function _onTouch(event1) {
                // store the touched item, used in _onDragStart
                this.touchParams.item = this.itemFromTarget(event1);
                this.touchParams.dragLeftItem = event1.target.dragLeftItem || false;
                this.touchParams.dragRightItem = event1.target.dragRightItem || false;
                this.touchParams.itemProps = null;
            }
        },
        {
            key: "_getGroupIndex",
            value: function _getGroupIndex(groupId) {
                for(var i1 = 0; i1 < this.groupIds.length; i1++){
                    if (groupId == this.groupIds[i1]) return i1;
                }
            }
        },
        {
            key: "_onDragStart",
            value: function _onDragStart(event1) {
                var _this8 = this;
                if (this.touchParams.itemIsDragging) return;
                var item = this.touchParams.item || null;
                var me = this;
                var props;
                if (item && (item.selected || this.options.itemsAlwaysDraggable.item)) {
                    if (this.options.editable.overrideItems && !this.options.editable.updateTime && !this.options.editable.updateGroup) return;
                    // override options.editable
                    if (item.editable != null && !item.editable.updateTime && !item.editable.updateGroup && !this.options.editable.overrideItems) return;
                    var dragLeftItem = this.touchParams.dragLeftItem;
                    var dragRightItem = this.touchParams.dragRightItem;
                    this.touchParams.itemIsDragging = true;
                    this.touchParams.selectedItem = item;
                    if (dragLeftItem) {
                        props = {
                            item: dragLeftItem,
                            initialX: event1.center.x,
                            dragLeft: true,
                            data: this._cloneItemData(item.data)
                        };
                        this.touchParams.itemProps = [
                            props
                        ];
                    } else if (dragRightItem) {
                        props = {
                            item: dragRightItem,
                            initialX: event1.center.x,
                            dragRight: true,
                            data: this._cloneItemData(item.data)
                        };
                        this.touchParams.itemProps = [
                            props
                        ];
                    } else if (this.options.editable.add && (event1.srcEvent.ctrlKey || event1.srcEvent.metaKey)) // create a new range item when dragging with ctrl key down
                    this._onDragStartAddItem(event1);
                    else {
                        if (this.groupIds.length < 1) // Mitigates a race condition if _onDragStart() is
                        // called after markDirty() without redraw() being called between.
                        this.redraw();
                        var baseGroupIndex = this._getGroupIndex(item.data.group);
                        var itemsToDrag = this.options.itemsAlwaysDraggable.item && !item.selected ? [
                            item.id
                        ] : this.getSelection();
                        this.touchParams.itemProps = _mapInstanceProperty(itemsToDrag).call(itemsToDrag, function(id) {
                            var item = me.items[id];
                            var groupIndex = me._getGroupIndex(item.data.group);
                            return {
                                item: item,
                                initialX: event1.center.x,
                                groupOffset: baseGroupIndex - groupIndex,
                                data: _this8._cloneItemData(item.data)
                            };
                        });
                    }
                    event1.stopPropagation();
                } else if (this.options.editable.add && (event1.srcEvent.ctrlKey || event1.srcEvent.metaKey)) // create a new range item when dragging with ctrl key down
                this._onDragStartAddItem(event1);
            }
        },
        {
            key: "_onDragStartAddItem",
            value: function _onDragStartAddItem(event1) {
                var snap = this.options.snap || null;
                var frameRect = this.dom.frame.getBoundingClientRect();
                // plus (if rtl) 10 to compensate for the drag starting as soon as you've moved 10px
                var x = this.options.rtl ? frameRect.right - event1.center.x + 10 : event1.center.x - frameRect.left - 10;
                var time = this.body.util.toTime(x);
                var scale = this.body.util.getScale();
                var step = this.body.util.getStep();
                var start = snap ? snap(time, scale, step) : time;
                var end = start;
                var itemData = {
                    type: "range",
                    start: start,
                    end: end,
                    content: "new item"
                };
                var id = v4();
                itemData[this.itemsData.idProp] = id;
                var group = this.groupFromTarget(event1);
                if (group) itemData.group = group.groupId;
                var newItem = new RangeItem(itemData, this.conversion, this.options);
                newItem.id = id; // TODO: not so nice setting id afterwards
                newItem.data = this._cloneItemData(itemData);
                this._addItem(newItem);
                this.touchParams.selectedItem = newItem;
                var props = {
                    item: newItem,
                    initialX: event1.center.x,
                    data: newItem.data
                };
                if (this.options.rtl) props.dragLeft = true;
                else props.dragRight = true;
                this.touchParams.itemProps = [
                    props
                ];
                event1.stopPropagation();
            }
        },
        {
            key: "_onDrag",
            value: function _onDrag(event1) {
                var _this9 = this;
                if (this.popup != null && this.options.showTooltips && !this.popup.hidden) {
                    // this.popup.hide();
                    var container = this.body.dom.centerContainer;
                    var containerRect = container.getBoundingClientRect();
                    this.popup.setPosition(event1.center.x - containerRect.left + container.offsetLeft, event1.center.y - containerRect.top + container.offsetTop);
                    this.popup.show(); // redraw
                }
                if (this.touchParams.itemProps) {
                    var _context29;
                    event1.stopPropagation();
                    var me = this;
                    var snap = this.options.snap || null;
                    var domRootOffsetLeft = this.body.dom.root.offsetLeft;
                    var xOffset = this.options.rtl ? domRootOffsetLeft + this.body.domProps.right.width : domRootOffsetLeft + this.body.domProps.left.width;
                    var scale = this.body.util.getScale();
                    var step = this.body.util.getStep();
                    //only calculate the new group for the item that's actually dragged
                    var selectedItem = this.touchParams.selectedItem;
                    var updateGroupAllowed = (this.options.editable.overrideItems || selectedItem.editable == null) && this.options.editable.updateGroup || !this.options.editable.overrideItems && selectedItem.editable != null && selectedItem.editable.updateGroup;
                    var newGroupBase = null;
                    if (updateGroupAllowed && selectedItem) {
                        if (selectedItem.data.group != undefined) {
                            // drag from one group to another
                            var group = me.groupFromTarget(event1);
                            if (group) //we know the offset for all items, so the new group for all items
                            //will be relative to this one.
                            newGroupBase = this._getGroupIndex(group.groupId);
                        }
                    }
                    // move
                    _forEachInstanceProperty(_context29 = this.touchParams.itemProps).call(_context29, function(props) {
                        var current = me.body.util.toTime(event1.center.x - xOffset);
                        var initial = me.body.util.toTime(props.initialX - xOffset);
                        var offset;
                        var initialStart;
                        var initialEnd;
                        var start;
                        var end;
                        if (_this9.options.rtl) offset = -(current - initial); // ms
                        else offset = current - initial; // ms
                        var itemData = _this9._cloneItemData(props.item.data); // clone the data
                        if (props.item.editable != null && !props.item.editable.updateTime && !props.item.editable.updateGroup && !me.options.editable.overrideItems) return;
                        var updateTimeAllowed = (_this9.options.editable.overrideItems || selectedItem.editable == null) && _this9.options.editable.updateTime || !_this9.options.editable.overrideItems && selectedItem.editable != null && selectedItem.editable.updateTime;
                        if (updateTimeAllowed) {
                            if (props.dragLeft) {
                                // drag left side of a range item
                                if (_this9.options.rtl) {
                                    if (itemData.end != undefined) {
                                        initialEnd = availableUtils.convert(props.data.end, "Date");
                                        end = new Date(initialEnd.valueOf() + offset);
                                        // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
                                        itemData.end = snap ? snap(end, scale, step) : end;
                                    }
                                } else if (itemData.start != undefined) {
                                    initialStart = availableUtils.convert(props.data.start, "Date");
                                    start = new Date(initialStart.valueOf() + offset);
                                    // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
                                    itemData.start = snap ? snap(start, scale, step) : start;
                                }
                            } else if (props.dragRight) {
                                // drag right side of a range item
                                if (_this9.options.rtl) {
                                    if (itemData.start != undefined) {
                                        initialStart = availableUtils.convert(props.data.start, "Date");
                                        start = new Date(initialStart.valueOf() + offset);
                                        // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
                                        itemData.start = snap ? snap(start, scale, step) : start;
                                    }
                                } else if (itemData.end != undefined) {
                                    initialEnd = availableUtils.convert(props.data.end, "Date");
                                    end = new Date(initialEnd.valueOf() + offset);
                                    // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
                                    itemData.end = snap ? snap(end, scale, step) : end;
                                }
                            } else // drag both start and end
                            if (itemData.start != undefined) {
                                initialStart = availableUtils.convert(props.data.start, "Date").valueOf();
                                start = new Date(initialStart + offset);
                                if (itemData.end != undefined) {
                                    initialEnd = availableUtils.convert(props.data.end, "Date");
                                    var duration = initialEnd.valueOf() - initialStart.valueOf();
                                    // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
                                    itemData.start = snap ? snap(start, scale, step) : start;
                                    itemData.end = new Date(itemData.start.valueOf() + duration);
                                } else // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
                                itemData.start = snap ? snap(start, scale, step) : start;
                            }
                        }
                        if (updateGroupAllowed && !props.dragLeft && !props.dragRight && newGroupBase != null) {
                            if (itemData.group != undefined) {
                                var newOffset = newGroupBase - props.groupOffset;
                                //make sure we stay in bounds
                                newOffset = Math.max(0, newOffset);
                                newOffset = Math.min(me.groupIds.length - 1, newOffset);
                                itemData.group = me.groupIds[newOffset];
                            }
                        }
                        // confirm moving the item
                        itemData = _this9._cloneItemData(itemData); // convert start and end to the correct type
                        me.options.onMoving(itemData, function(itemData) {
                            if (itemData) props.item.setData(_this9._cloneItemData(itemData, "Date"));
                        });
                    });
                    this.body.emitter.emit("_change");
                }
            }
        },
        {
            key: "_moveToGroup",
            value: function _moveToGroup(item, groupId) {
                var group = this.groups[groupId];
                if (group && group.groupId != item.data.group) {
                    var oldGroup = item.parent;
                    oldGroup.remove(item);
                    oldGroup.order();
                    item.data.group = group.groupId;
                    group.add(item);
                    group.order();
                }
            }
        },
        {
            key: "_onDragEnd",
            value: function _onDragEnd(event1) {
                var _this10 = this;
                this.touchParams.itemIsDragging = false;
                if (this.touchParams.itemProps) {
                    event1.stopPropagation();
                    var me = this;
                    var itemProps = this.touchParams.itemProps;
                    this.touchParams.itemProps = null;
                    _forEachInstanceProperty(itemProps).call(itemProps, function(props) {
                        var id = props.item.id;
                        var exists = me.itemsData.get(id) != null;
                        if (!exists) // add a new item
                        me.options.onAdd(props.item.data, function(itemData) {
                            me._removeItem(props.item); // remove temporary item
                            if (itemData) me.itemsData.add(itemData);
                            // force re-stacking of all items next redraw
                            me.body.emitter.emit("_change");
                        });
                        else {
                            // update existing item
                            var itemData = _this10._cloneItemData(props.item.data); // convert start and end to the correct type
                            me.options.onMove(itemData, function(itemData) {
                                if (itemData) {
                                    // apply changes
                                    itemData[_this10.itemsData.idProp] = id; // ensure the item contains its id (can be undefined)
                                    _this10.itemsData.update(itemData);
                                } else {
                                    // restore original values
                                    props.item.setData(props.data);
                                    me.body.emitter.emit("_change");
                                }
                            });
                        }
                    });
                }
            }
        },
        {
            key: "_onGroupClick",
            value: function _onGroupClick(event1) {
                var _this11 = this;
                var group = this.groupFromTarget(event1);
                _setTimeout(function() {
                    _this11.toggleGroupShowNested(group);
                }, 1);
            }
        },
        {
            key: "toggleGroupShowNested",
            value: function toggleGroupShowNested(group) {
                var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                if (!group || !group.nestedGroups) return;
                var groupsData = this.groupsData.getDataSet();
                if (force != undefined) group.showNested = !!force;
                else group.showNested = !group.showNested;
                var nestingGroup = groupsData.get(group.groupId);
                nestingGroup.showNested = group.showNested;
                var fullNestedGroups = group.nestedGroups;
                var nextLevel = fullNestedGroups;
                while(nextLevel.length > 0){
                    var current = nextLevel;
                    nextLevel = [];
                    for(var i1 = 0; i1 < current.length; i1++){
                        var node = groupsData.get(current[i1]);
                        if (node.nestedGroups) nextLevel = _concatInstanceProperty(nextLevel).call(nextLevel, node.nestedGroups);
                    }
                    if (nextLevel.length > 0) fullNestedGroups = _concatInstanceProperty(fullNestedGroups).call(fullNestedGroups, nextLevel);
                }
                var nestedGroups;
                if (nestingGroup.showNested) {
                    var showNestedGroups = groupsData.get(nestingGroup.nestedGroups);
                    for(var _i = 0; _i < showNestedGroups.length; _i++){
                        var _group = showNestedGroups[_i];
                        if (_group.nestedGroups && _group.nestedGroups.length > 0 && (_group.showNested == undefined || _group.showNested == true)) showNestedGroups.push.apply(showNestedGroups, _toConsumableArray(groupsData.get(_group.nestedGroups)));
                    }
                    nestedGroups = _mapInstanceProperty(showNestedGroups).call(showNestedGroups, function(nestedGroup) {
                        if (nestedGroup.visible == undefined) nestedGroup.visible = true;
                        nestedGroup.visible = !!nestingGroup.showNested;
                        return nestedGroup;
                    });
                } else {
                    var _context30;
                    nestedGroups = _mapInstanceProperty(_context30 = groupsData.get(fullNestedGroups)).call(_context30, function(nestedGroup) {
                        if (nestedGroup.visible == undefined) nestedGroup.visible = true;
                        nestedGroup.visible = !!nestingGroup.showNested;
                        return nestedGroup;
                    });
                }
                groupsData.update(_concatInstanceProperty(nestedGroups).call(nestedGroups, nestingGroup));
                if (nestingGroup.showNested) {
                    availableUtils.removeClassName(group.dom.label, "collapsed");
                    availableUtils.addClassName(group.dom.label, "expanded");
                } else {
                    availableUtils.removeClassName(group.dom.label, "expanded");
                    availableUtils.addClassName(group.dom.label, "collapsed");
                }
            }
        },
        {
            key: "toggleGroupDragClassName",
            value: function toggleGroupDragClassName(group) {
                group.dom.label.classList.toggle("vis-group-is-dragging");
                group.dom.foreground.classList.toggle("vis-group-is-dragging");
            }
        },
        {
            key: "_onGroupDragStart",
            value: function _onGroupDragStart(event1) {
                if (this.groupTouchParams.isDragging) return;
                if (this.options.groupEditable.order) {
                    this.groupTouchParams.group = this.groupFromTarget(event1);
                    if (this.groupTouchParams.group) {
                        event1.stopPropagation();
                        this.groupTouchParams.isDragging = true;
                        this.toggleGroupDragClassName(this.groupTouchParams.group);
                        this.groupTouchParams.originalOrder = this.groupsData.getIds({
                            order: this.options.groupOrder
                        });
                    }
                }
            }
        },
        {
            key: "_onGroupDrag",
            value: function _onGroupDrag(event1) {
                if (this.options.groupEditable.order && this.groupTouchParams.group) {
                    event1.stopPropagation();
                    var groupsData = this.groupsData.getDataSet();
                    // drag from one group to another
                    var group = this.groupFromTarget(event1);
                    // try to avoid toggling when groups differ in height
                    if (group && group.height != this.groupTouchParams.group.height) {
                        var movingUp = group.top < this.groupTouchParams.group.top;
                        var clientY = event1.center ? event1.center.y : event1.clientY;
                        var targetGroup = group.dom.foreground.getBoundingClientRect();
                        var draggedGroupHeight = this.groupTouchParams.group.height;
                        if (movingUp) {
                            // skip swapping the groups when the dragged group is not below clientY afterwards
                            if (targetGroup.top + draggedGroupHeight < clientY) return;
                        } else {
                            var targetGroupHeight = group.height;
                            // skip swapping the groups when the dragged group is not below clientY afterwards
                            if (targetGroup.top + targetGroupHeight - draggedGroupHeight > clientY) return;
                        }
                    }
                    if (group && group != this.groupTouchParams.group) {
                        var _targetGroup = groupsData.get(group.groupId);
                        var draggedGroup = groupsData.get(this.groupTouchParams.group.groupId);
                        // switch groups
                        if (draggedGroup && _targetGroup) {
                            this.options.groupOrderSwap(draggedGroup, _targetGroup, groupsData);
                            groupsData.update(draggedGroup);
                            groupsData.update(_targetGroup);
                        }
                        // fetch current order of groups
                        var newOrder = groupsData.getIds({
                            order: this.options.groupOrder
                        });
                        // in case of changes since _onGroupDragStart
                        if (!availableUtils.equalArray(newOrder, this.groupTouchParams.originalOrder)) {
                            var origOrder = this.groupTouchParams.originalOrder;
                            var draggedId = this.groupTouchParams.group.groupId;
                            var numGroups = Math.min(origOrder.length, newOrder.length);
                            var curPos = 0;
                            var newOffset = 0;
                            var orgOffset = 0;
                            while(curPos < numGroups){
                                // as long as the groups are where they should be step down along the groups order
                                while(curPos + newOffset < numGroups && curPos + orgOffset < numGroups && newOrder[curPos + newOffset] == origOrder[curPos + orgOffset])curPos++;
                                // all ok
                                if (curPos + newOffset >= numGroups) break;
                                // not all ok
                                // if dragged group was move upwards everything below should have an offset
                                if (newOrder[curPos + newOffset] == draggedId) newOffset = 1;
                                else if (origOrder[curPos + orgOffset] == draggedId) orgOffset = 1;
                                else {
                                    var slippedPosition = _indexOfInstanceProperty(newOrder).call(newOrder, origOrder[curPos + orgOffset]);
                                    var switchGroup = groupsData.get(newOrder[curPos + newOffset]);
                                    var shouldBeGroup = groupsData.get(origOrder[curPos + orgOffset]);
                                    this.options.groupOrderSwap(switchGroup, shouldBeGroup, groupsData);
                                    groupsData.update(switchGroup);
                                    groupsData.update(shouldBeGroup);
                                    var switchGroupId = newOrder[curPos + newOffset];
                                    newOrder[curPos + newOffset] = origOrder[curPos + orgOffset];
                                    newOrder[slippedPosition] = switchGroupId;
                                    curPos++;
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            key: "_onGroupDragEnd",
            value: function _onGroupDragEnd(event1) {
                this.groupTouchParams.isDragging = false;
                if (this.options.groupEditable.order && this.groupTouchParams.group) {
                    event1.stopPropagation();
                    // update existing group
                    var me = this;
                    var id = me.groupTouchParams.group.groupId;
                    var dataset = me.groupsData.getDataSet();
                    var groupData = availableUtils.extend({}, dataset.get(id)); // clone the data
                    me.options.onMoveGroup(groupData, function(groupData) {
                        if (groupData) {
                            // apply changes
                            groupData[dataset._idProp] = id; // ensure the group contains its id (can be undefined)
                            dataset.update(groupData);
                        } else {
                            // fetch current order of groups
                            var newOrder = dataset.getIds({
                                order: me.options.groupOrder
                            });
                            // restore original order
                            if (!availableUtils.equalArray(newOrder, me.groupTouchParams.originalOrder)) {
                                var origOrder = me.groupTouchParams.originalOrder;
                                var numGroups = Math.min(origOrder.length, newOrder.length);
                                var curPos = 0;
                                while(curPos < numGroups){
                                    // as long as the groups are where they should be step down along the groups order
                                    while(curPos < numGroups && newOrder[curPos] == origOrder[curPos])curPos++;
                                    // all ok
                                    if (curPos >= numGroups) break;
                                    // found a group that has the wrong position -> switch with the
                                    // group at the position where other one should be, fix index arrays and continue
                                    var slippedPosition = _indexOfInstanceProperty(newOrder).call(newOrder, origOrder[curPos]);
                                    var switchGroup = dataset.get(newOrder[curPos]);
                                    var shouldBeGroup = dataset.get(origOrder[curPos]);
                                    me.options.groupOrderSwap(switchGroup, shouldBeGroup, dataset);
                                    dataset.update(switchGroup);
                                    dataset.update(shouldBeGroup);
                                    var switchGroupId = newOrder[curPos];
                                    newOrder[curPos] = origOrder[curPos];
                                    newOrder[slippedPosition] = switchGroupId;
                                    curPos++;
                                }
                            }
                        }
                    });
                    me.body.emitter.emit("groupDragged", {
                        groupId: id
                    });
                    this.toggleGroupDragClassName(this.groupTouchParams.group);
                    this.groupTouchParams.group = null;
                }
            }
        },
        {
            key: "_onSelectItem",
            value: function _onSelectItem(event1) {
                if (!this.options.selectable) return;
                var ctrlKey = event1.srcEvent && (event1.srcEvent.ctrlKey || event1.srcEvent.metaKey);
                var shiftKey = event1.srcEvent && event1.srcEvent.shiftKey;
                if (ctrlKey || shiftKey) {
                    this._onMultiSelectItem(event1);
                    return;
                }
                var oldSelection = this.getSelection();
                var item = this.itemFromTarget(event1);
                var selection = item && item.selectable ? [
                    item.id
                ] : [];
                this.setSelection(selection);
                var newSelection = this.getSelection();
                // emit a select event,
                // except when old selection is empty and new selection is still empty
                if (newSelection.length > 0 || oldSelection.length > 0) this.body.emitter.emit("select", {
                    items: newSelection,
                    event: event1
                });
            }
        },
        {
            key: "_onMouseOver",
            value: function _onMouseOver(event1) {
                var item = this.itemFromTarget(event1);
                if (!item) return;
                // Item we just left
                var related = this.itemFromRelatedTarget(event1);
                if (item === related) // We haven't changed item, just element in the item
                return;
                var title = item.getTitle();
                if (this.options.showTooltips && title) {
                    if (this.popup == null) this.popup = new Popup(this.body.dom.root, this.options.tooltip.overflowMethod || "flip");
                    this.popup.setText(title);
                    var container = this.body.dom.centerContainer;
                    var containerRect = container.getBoundingClientRect();
                    this.popup.setPosition(event1.clientX - containerRect.left + container.offsetLeft, event1.clientY - containerRect.top + container.offsetTop);
                    this.setPopupTimer(this.popup);
                } else {
                    // Hovering over item without a title, hide popup
                    // Needed instead of _just_ in _onMouseOut due to #2572
                    this.clearPopupTimer();
                    if (this.popup != null) this.popup.hide();
                }
                this.body.emitter.emit("itemover", {
                    item: item.id,
                    event: event1
                });
            }
        },
        {
            key: "_onMouseOut",
            value: function _onMouseOut(event1) {
                var item = this.itemFromTarget(event1);
                if (!item) return;
                // Item we are going to
                var related = this.itemFromRelatedTarget(event1);
                if (item === related) // We aren't changing item, just element in the item
                return;
                this.clearPopupTimer();
                if (this.popup != null) this.popup.hide();
                this.body.emitter.emit("itemout", {
                    item: item.id,
                    event: event1
                });
            }
        },
        {
            key: "_onMouseMove",
            value: function _onMouseMove(event1) {
                var item = this.itemFromTarget(event1);
                if (!item) return;
                if (this.popupTimer != null) // restart timer
                this.setPopupTimer(this.popup);
                if (this.options.showTooltips && this.options.tooltip.followMouse && this.popup && !this.popup.hidden) {
                    var container = this.body.dom.centerContainer;
                    var containerRect = container.getBoundingClientRect();
                    this.popup.setPosition(event1.clientX - containerRect.left + container.offsetLeft, event1.clientY - containerRect.top + container.offsetTop);
                    this.popup.show(); // Redraw
                }
            }
        },
        {
            key: "_onMouseWheel",
            value: function _onMouseWheel(event1) {
                if (this.touchParams.itemIsDragging) this._onDragEnd(event1);
            }
        },
        {
            key: "_onUpdateItem",
            value: function _onUpdateItem(item) {
                if (!this.options.selectable) return;
                if (!this.options.editable.updateTime && !this.options.editable.updateGroup) return;
                var me = this;
                if (item) {
                    // execute async handler to update the item (or cancel it)
                    var itemData = me.itemsData.get(item.id); // get a clone of the data from the dataset
                    this.options.onUpdate(itemData, function(itemData) {
                        if (itemData) me.itemsData.update(itemData);
                    });
                }
            }
        },
        {
            key: "_onDropObjectOnItem",
            value: function _onDropObjectOnItem(event1) {
                var item = this.itemFromTarget(event1);
                var objectData = JSON.parse(event1.dataTransfer.getData("text"));
                this.options.onDropObjectOnItem(objectData, item);
            }
        },
        {
            key: "_onAddItem",
            value: function _onAddItem(event1) {
                if (!this.options.selectable) return;
                if (!this.options.editable.add) return;
                var me = this;
                var snap = this.options.snap || null;
                // add item
                var frameRect = this.dom.frame.getBoundingClientRect();
                var x = this.options.rtl ? frameRect.right - event1.center.x : event1.center.x - frameRect.left;
                var start = this.body.util.toTime(x);
                var scale = this.body.util.getScale();
                var step = this.body.util.getStep();
                var end;
                var newItemData;
                if (event1.type == "drop") {
                    newItemData = JSON.parse(event1.dataTransfer.getData("text"));
                    newItemData.content = newItemData.content ? newItemData.content : "new item";
                    newItemData.start = newItemData.start ? newItemData.start : snap ? snap(start, scale, step) : start;
                    newItemData.type = newItemData.type || "box";
                    newItemData[this.itemsData.idProp] = newItemData.id || v4();
                    if (newItemData.type == "range" && !newItemData.end) {
                        end = this.body.util.toTime(x + this.props.width / 5);
                        newItemData.end = snap ? snap(end, scale, step) : end;
                    }
                } else {
                    newItemData = {
                        start: snap ? snap(start, scale, step) : start,
                        content: "new item"
                    };
                    newItemData[this.itemsData.idProp] = v4();
                    // when default type is a range, add a default end date to the new item
                    if (this.options.type === "range") {
                        end = this.body.util.toTime(x + this.props.width / 5);
                        newItemData.end = snap ? snap(end, scale, step) : end;
                    }
                }
                var group = this.groupFromTarget(event1);
                if (group) newItemData.group = group.groupId;
                // execute async handler to customize (or cancel) adding an item
                newItemData = this._cloneItemData(newItemData); // convert start and end to the correct type
                this.options.onAdd(newItemData, function(item) {
                    if (item) {
                        me.itemsData.add(item);
                        if (event1.type == "drop") me.setSelection([
                            item.id
                        ]);
                    // TODO: need to trigger a redraw?
                    }
                });
            }
        },
        {
            key: "_onMultiSelectItem",
            value: function _onMultiSelectItem(event1) {
                var _this12 = this;
                if (!this.options.selectable) return;
                var item = this.itemFromTarget(event1);
                if (item) {
                    // multi select items (if allowed)
                    var selection = this.options.multiselect ? this.getSelection() // take current selection
                     : []; // deselect current selection
                    var shiftKey = event1.srcEvent && event1.srcEvent.shiftKey || false;
                    if ((shiftKey || this.options.sequentialSelection) && this.options.multiselect) {
                        // select all items between the old selection and the tapped item
                        var itemGroup = this.itemsData.get(item.id).group;
                        // when filtering get the group of the last selected item
                        var lastSelectedGroup = undefined;
                        if (this.options.multiselectPerGroup) {
                            if (selection.length > 0) lastSelectedGroup = this.itemsData.get(selection[0]).group;
                        }
                        // determine the selection range
                        if (!this.options.multiselectPerGroup || lastSelectedGroup == undefined || lastSelectedGroup == itemGroup) selection.push(item.id);
                        var range = ItemSet._getItemRange(this.itemsData.get(selection));
                        if (!this.options.multiselectPerGroup || lastSelectedGroup == itemGroup) {
                            // select all items within the selection range
                            selection = [];
                            for(var id in this.items)if (this.items.hasOwnProperty(id)) {
                                var _item = this.items[id];
                                var start = _item.data.start;
                                var end = _item.data.end !== undefined ? _item.data.end : start;
                                if (start >= range.min && end <= range.max && (!this.options.multiselectPerGroup || lastSelectedGroup == this.itemsData.get(_item.id).group) && !(_item instanceof BackgroundItem)) selection.push(_item.id); // do not use id but item.id, id itself is stringified
                            }
                        }
                    } else {
                        // add/remove this item from the current selection
                        var index = _indexOfInstanceProperty(selection).call(selection, item.id);
                        if (index == -1) // item is not yet selected -> select it
                        selection.push(item.id);
                        else // item is already selected -> deselect it
                        _spliceInstanceProperty(selection).call(selection, index, 1);
                    }
                    var filteredSelection = _filterInstanceProperty(selection).call(selection, function(item) {
                        return _this12.getItemById(item).selectable;
                    });
                    this.setSelection(filteredSelection);
                    this.body.emitter.emit("select", {
                        items: this.getSelection(),
                        event: event1
                    });
                }
            }
        },
        {
            key: "itemFromElement",
            value: /**
     * Find an item from an element:
     * searches for the attribute 'vis-item' in the element's tree
     * @param {HTMLElement} element
     * @return {Item | null} item
     */ function itemFromElement(element) {
                var cur = element;
                while(cur){
                    if (cur.hasOwnProperty("vis-item")) return cur["vis-item"];
                    cur = cur.parentNode;
                }
                return null;
            }
        },
        {
            key: "itemFromTarget",
            value: function itemFromTarget(event1) {
                return this.itemFromElement(event1.target);
            }
        },
        {
            key: "itemFromRelatedTarget",
            value: function itemFromRelatedTarget(event1) {
                return this.itemFromElement(event1.relatedTarget);
            }
        },
        {
            key: "groupFromTarget",
            value: function groupFromTarget(event1) {
                var clientY = event1.center ? event1.center.y : event1.clientY;
                var groupIds = this.groupIds;
                if (groupIds.length <= 0 && this.groupsData) groupIds = this.groupsData.getIds({
                    order: this.options.groupOrder
                });
                for(var i1 = 0; i1 < groupIds.length; i1++){
                    var groupId = groupIds[i1];
                    var group = this.groups[groupId];
                    var foreground = group.dom.foreground;
                    var foregroundRect = foreground.getBoundingClientRect();
                    if (clientY >= foregroundRect.top && clientY < foregroundRect.top + foreground.offsetHeight) return group;
                    if (this.options.orientation.item === "top") {
                        if (i1 === this.groupIds.length - 1 && clientY > foregroundRect.top) return group;
                    } else {
                        if (i1 === 0 && clientY < foregroundRect.top + foreground.offset) return group;
                    }
                }
                return null;
            }
        },
        {
            key: "_cloneItemData",
            value: /**
     * Clone the data of an item, and "normalize" it: convert the start and end date
     * to the type (Date, Moment, ...) configured in the DataSet. If not configured,
     * start and end are converted to Date.
     * @param {Object} itemData, typically `item.data`
     * @param {string} [type]  Optional Date type. If not provided, the type from the DataSet is taken
     * @return {Object} The cloned object
     * @private
     */ function _cloneItemData(itemData, type) {
                var clone = availableUtils.extend({}, itemData);
                if (!type) // convert start and end date to the type (Date, Moment, ...) configured in the DataSet
                type = this.itemsData.type;
                if (clone.start != undefined) clone.start = availableUtils.convert(clone.start, type && type.start || "Date");
                if (clone.end != undefined) clone.end = availableUtils.convert(clone.end, type && type.end || "Date");
                return clone;
            }
        },
        {
            key: "_clusterItems",
            value: function _clusterItems() {
                if (!this.options.cluster) return;
                var _this$body$range$conv = this.body.range.conversion(this.body.domProps.center.width), scale = _this$body$range$conv.scale;
                var clusters = this.clusterGenerator.getClusters(this.clusters, scale, this.options.cluster);
                if (this.clusters != clusters) {
                    this._detachAllClusters();
                    if (clusters) {
                        var _iterator5 = _createForOfIteratorHelper$1(clusters), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var cluster = _step5.value;
                                cluster.attach();
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                        this.clusters = clusters;
                    }
                    this._updateClusters(clusters);
                }
            }
        },
        {
            key: "_detachAllClusters",
            value: function _detachAllClusters() {
                if (this.options.cluster) {
                    if (this.clusters && this.clusters.length) {
                        var _iterator6 = _createForOfIteratorHelper$1(this.clusters), _step6;
                        try {
                            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                var cluster = _step6.value;
                                cluster.detach();
                            }
                        } catch (err) {
                            _iterator6.e(err);
                        } finally{
                            _iterator6.f();
                        }
                    }
                }
            }
        },
        {
            key: "_updateClusters",
            value: function _updateClusters(clusters) {
                if (this.clusters && this.clusters.length) {
                    var _context31;
                    var newClustersIds = new _Set(_mapInstanceProperty(clusters).call(clusters, function(cluster) {
                        return cluster.id;
                    }));
                    var clustersToUnselect = _filterInstanceProperty(_context31 = this.clusters).call(_context31, function(cluster) {
                        return !newClustersIds.has(cluster.id);
                    });
                    var selectionChanged = false;
                    var _iterator7 = _createForOfIteratorHelper$1(clustersToUnselect), _step7;
                    try {
                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                            var _context32;
                            var cluster = _step7.value;
                            var selectedIdx = _indexOfInstanceProperty(_context32 = this.selection).call(_context32, cluster.id);
                            if (selectedIdx !== -1) {
                                var _context33;
                                cluster.unselect();
                                _spliceInstanceProperty(_context33 = this.selection).call(_context33, selectedIdx, 1);
                                selectionChanged = true;
                            }
                        }
                    } catch (err) {
                        _iterator7.e(err);
                    } finally{
                        _iterator7.f();
                    }
                    if (selectionChanged) {
                        var newSelection = this.getSelection();
                        this.body.emitter.emit("select", {
                            items: newSelection,
                            event: event
                        });
                    }
                }
                this.clusters = clusters || [];
            }
        }
    ], [
        {
            key: "_getItemRange",
            value: function _getItemRange(itemsData) {
                var max = null;
                var min = null;
                _forEachInstanceProperty(itemsData).call(itemsData, function(data) {
                    if (min == null || data.start < min) min = data.start;
                    if (data.end != undefined) {
                        if (max == null || data.end > max) max = data.end;
                    } else if (max == null || data.start > max) max = data.start;
                });
                return {
                    min: min,
                    max: max
                };
            }
        },
        {
            key: "itemSetFromTarget",
            value: function itemSetFromTarget(event1) {
                var target = event1.target;
                while(target){
                    if (target.hasOwnProperty("vis-itemset")) return target["vis-itemset"];
                    target = target.parentNode;
                }
                return null;
            }
        }
    ]);
    return ItemSet;
}(Component); // available item types will be registered here
ItemSet.types = {
    background: BackgroundItem,
    box: BoxItem,
    range: RangeItem,
    point: PointItem
};
/**
 * Handle added items
 * @param {number[]} ids
 * @protected
 */ ItemSet.prototype._onAdd = ItemSet.prototype._onUpdate;
var errorFound = false;
var allOptions$2;
var printStyle = "background: #FFeeee; color: #dd0000";
/**
 *  Used to validate options.
 */ var Validator = /*#__PURE__*/ function() {
    /**
   * @ignore
   */ function Validator() {
        _classCallCheck(this, Validator);
    }
    /**
   * Main function to be called
   * @param {Object} options
   * @param {Object} referenceOptions
   * @param {Object} subObject
   * @returns {boolean}
   * @static
   */ _createClass(Validator, null, [
        {
            key: "validate",
            value: function validate(options, referenceOptions, subObject) {
                errorFound = false;
                allOptions$2 = referenceOptions;
                var usedOptions = referenceOptions;
                if (subObject !== undefined) usedOptions = referenceOptions[subObject];
                Validator.parse(options, usedOptions, []);
                return errorFound;
            }
        },
        {
            key: "parse",
            value: function parse(options, referenceOptions, path) {
                for(var option in options)if (options.hasOwnProperty(option)) Validator.check(option, options, referenceOptions, path);
            }
        },
        {
            key: "check",
            value: function check(option, options, referenceOptions, path) {
                if (referenceOptions[option] === undefined && referenceOptions.__any__ === undefined) {
                    Validator.getSuggestion(option, referenceOptions, path);
                    return;
                }
                var referenceOption = option;
                var is_object = true;
                if (referenceOptions[option] === undefined && referenceOptions.__any__ !== undefined) {
                    // NOTE: This only triggers if the __any__ is in the top level of the options object.
                    //       THAT'S A REALLY BAD PLACE TO ALLOW IT!!!!
                    // TODO: Examine if needed, remove if possible
                    // __any__ is a wildcard. Any value is accepted and will be further analysed by reference.
                    referenceOption = "__any__";
                    // if the any-subgroup is not a predefined object in the configurator,
                    // we do not look deeper into the object.
                    is_object = Validator.getType(options[option]) === "object";
                }
                var refOptionObj = referenceOptions[referenceOption];
                if (is_object && refOptionObj.__type__ !== undefined) refOptionObj = refOptionObj.__type__;
                Validator.checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path);
            }
        },
        {
            key: "checkFields",
            value: function checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path) {
                var log = function log(message) {
                    console.log("%c" + message + Validator.printLocation(path, option), printStyle);
                };
                var optionType = Validator.getType(options[option]);
                var refOptionType = refOptionObj[optionType];
                if (refOptionType !== undefined) {
                    // if the type is correct, we check if it is supposed to be one of a few select values
                    if (Validator.getType(refOptionType) === "array" && _indexOfInstanceProperty(refOptionType).call(refOptionType, options[option]) === -1) {
                        log('Invalid option detected in "' + option + '".' + " Allowed values are:" + Validator.print(refOptionType) + ' not "' + options[option] + '". ');
                        errorFound = true;
                    } else if (optionType === "object" && referenceOption !== "__any__") {
                        path = availableUtils.copyAndExtendArray(path, option);
                        Validator.parse(options[option], referenceOptions[referenceOption], path);
                    }
                } else if (refOptionObj["any"] === undefined) {
                    // type of the field is incorrect and the field cannot be any
                    log('Invalid type received for "' + option + '". Expected: ' + Validator.print(_Object$keys(refOptionObj)) + ". Received [" + optionType + '] "' + options[option] + '"');
                    errorFound = true;
                }
            }
        },
        {
            key: "getType",
            value: function getType(object) {
                var type = _typeof$1(object);
                if (type === "object") {
                    if (object === null) return "null";
                    if (object instanceof Boolean) return "boolean";
                    if (object instanceof Number) return "number";
                    if (object instanceof String) return "string";
                    if (_Array$isArray(object)) return "array";
                    if (object instanceof Date) return "date";
                    if (object.nodeType !== undefined) return "dom";
                    if (object._isAMomentObject === true) return "moment";
                    return "object";
                } else if (type === "number") return "number";
                else if (type === "boolean") return "boolean";
                else if (type === "string") return "string";
                else if (type === undefined) return "undefined";
                return type;
            }
        },
        {
            key: "getSuggestion",
            value: function getSuggestion(option, options, path) {
                var localSearch = Validator.findInOptions(option, options, path, false);
                var globalSearch = Validator.findInOptions(option, allOptions$2, [], true);
                var localSearchThreshold = 8;
                var globalSearchThreshold = 4;
                var msg;
                if (localSearch.indexMatch !== undefined) msg = " in " + Validator.printLocation(localSearch.path, option, "") + 'Perhaps it was incomplete? Did you mean: "' + localSearch.indexMatch + '"?\n\n';
                else if (globalSearch.distance <= globalSearchThreshold && localSearch.distance > globalSearch.distance) msg = " in " + Validator.printLocation(localSearch.path, option, "") + "Perhaps it was misplaced? Matching option found at: " + Validator.printLocation(globalSearch.path, globalSearch.closestMatch, "");
                else if (localSearch.distance <= localSearchThreshold) msg = '. Did you mean "' + localSearch.closestMatch + '"?' + Validator.printLocation(localSearch.path, option);
                else msg = ". Did you mean one of these: " + Validator.print(_Object$keys(options)) + Validator.printLocation(path, option);
                console.log('%cUnknown option detected: "' + option + '"' + msg, printStyle);
                errorFound = true;
            }
        },
        {
            key: "findInOptions",
            value: function findInOptions(option, options, path) {
                var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var min = 1e9;
                var closestMatch = "";
                var closestMatchPath = [];
                var lowerCaseOption = option.toLowerCase();
                var indexMatch = undefined;
                for(var op in options){
                    // eslint-disable-line guard-for-in
                    var distance = void 0;
                    if (options[op].__type__ !== undefined && recursive === true) {
                        var result = Validator.findInOptions(option, options[op], availableUtils.copyAndExtendArray(path, op));
                        if (min > result.distance) {
                            closestMatch = result.closestMatch;
                            closestMatchPath = result.path;
                            min = result.distance;
                            indexMatch = result.indexMatch;
                        }
                    } else {
                        var _context;
                        if (_indexOfInstanceProperty(_context = op.toLowerCase()).call(_context, lowerCaseOption) !== -1) indexMatch = op;
                        distance = Validator.levenshteinDistance(option, op);
                        if (min > distance) {
                            closestMatch = op;
                            closestMatchPath = availableUtils.copyArray(path);
                            min = distance;
                        }
                    }
                }
                return {
                    closestMatch: closestMatch,
                    path: closestMatchPath,
                    distance: min,
                    indexMatch: indexMatch
                };
            }
        },
        {
            key: "printLocation",
            value: function printLocation(path, option) {
                var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Problem value found at: \n";
                var str = "\n\n" + prefix + "options = {\n";
                for(var i1 = 0; i1 < path.length; i1++){
                    for(var j = 0; j < i1 + 1; j++)str += "  ";
                    str += path[i1] + ": {\n";
                }
                for(var _j = 0; _j < path.length + 1; _j++)str += "  ";
                str += option + "\n";
                for(var _i = 0; _i < path.length + 1; _i++){
                    for(var _j2 = 0; _j2 < path.length - _i; _j2++)str += "  ";
                    str += "}\n";
                }
                return str + "\n\n";
            }
        },
        {
            key: "print",
            value: function print(options) {
                return _JSON$stringify(options).replace(/(\")|(\[)|(\])|(,"__type__")/g, "").replace(/(\,)/g, ", ");
            }
        },
        {
            key: "levenshteinDistance",
            value: function levenshteinDistance(a, b) {
                if (a.length === 0) return b.length;
                if (b.length === 0) return a.length;
                var matrix = [];
                // increment along the first column of each row
                var i1;
                for(i1 = 0; i1 <= b.length; i1++)matrix[i1] = [
                    i1
                ];
                // increment each column in the first row
                var j;
                for(j = 0; j <= a.length; j++)matrix[0][j] = j;
                // Fill in the rest of the matrix
                for(i1 = 1; i1 <= b.length; i1++){
                    for(j = 1; j <= a.length; j++)if (b.charAt(i1 - 1) == a.charAt(j - 1)) matrix[i1][j] = matrix[i1 - 1][j - 1];
                    else matrix[i1][j] = Math.min(matrix[i1 - 1][j - 1] + 1, // substitution
                    Math.min(matrix[i1][j - 1] + 1, // insertion
                    matrix[i1 - 1][j] + 1)); // deletion
                }
                return matrix[b.length][a.length];
            }
        }
    ]);
    return Validator;
}();
/**
 * This object contains all possible options. It will check if the types are correct, if required if the option is one
 * of the allowed values.
 *
 * __any__ means that the name of the property does not matter.
 * __type__ is a required field for all objects and contains the allowed types of all objects
 */ var string$1 = "string";
var bool$1 = "boolean";
var number$1 = "number";
var array$1 = "array";
var date$1 = "date";
var object$1 = "object"; // should only be in a __type__ property
var dom$1 = "dom";
var moment$1 = "moment";
var any$1 = "any";
var allOptions$1 = {
    configure: {
        enabled: {
            "boolean": bool$1
        },
        filter: {
            "boolean": bool$1,
            "function": "function"
        },
        container: {
            dom: dom$1
        },
        __type__: {
            object: object$1,
            "boolean": bool$1,
            "function": "function"
        }
    },
    //globals :
    align: {
        string: string$1
    },
    alignCurrentTime: {
        string: string$1,
        "undefined": "undefined"
    },
    rtl: {
        "boolean": bool$1,
        "undefined": "undefined"
    },
    rollingMode: {
        follow: {
            "boolean": bool$1
        },
        offset: {
            number: number$1,
            "undefined": "undefined"
        },
        __type__: {
            object: object$1
        }
    },
    onTimeout: {
        timeoutMs: {
            number: number$1
        },
        callback: {
            "function": "function"
        },
        __type__: {
            object: object$1
        }
    },
    verticalScroll: {
        "boolean": bool$1,
        "undefined": "undefined"
    },
    horizontalScroll: {
        "boolean": bool$1,
        "undefined": "undefined"
    },
    autoResize: {
        "boolean": bool$1
    },
    throttleRedraw: {
        number: number$1
    },
    // TODO: DEPRICATED see https://github.com/almende/vis/issues/2511
    clickToUse: {
        "boolean": bool$1
    },
    dataAttributes: {
        string: string$1,
        array: array$1
    },
    editable: {
        add: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        remove: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        updateGroup: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        updateTime: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        overrideItems: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        __type__: {
            "boolean": bool$1,
            object: object$1
        }
    },
    end: {
        number: number$1,
        date: date$1,
        string: string$1,
        moment: moment$1
    },
    format: {
        minorLabels: {
            millisecond: {
                string: string$1,
                "undefined": "undefined"
            },
            second: {
                string: string$1,
                "undefined": "undefined"
            },
            minute: {
                string: string$1,
                "undefined": "undefined"
            },
            hour: {
                string: string$1,
                "undefined": "undefined"
            },
            weekday: {
                string: string$1,
                "undefined": "undefined"
            },
            day: {
                string: string$1,
                "undefined": "undefined"
            },
            week: {
                string: string$1,
                "undefined": "undefined"
            },
            month: {
                string: string$1,
                "undefined": "undefined"
            },
            year: {
                string: string$1,
                "undefined": "undefined"
            },
            __type__: {
                object: object$1,
                "function": "function"
            }
        },
        majorLabels: {
            millisecond: {
                string: string$1,
                "undefined": "undefined"
            },
            second: {
                string: string$1,
                "undefined": "undefined"
            },
            minute: {
                string: string$1,
                "undefined": "undefined"
            },
            hour: {
                string: string$1,
                "undefined": "undefined"
            },
            weekday: {
                string: string$1,
                "undefined": "undefined"
            },
            day: {
                string: string$1,
                "undefined": "undefined"
            },
            week: {
                string: string$1,
                "undefined": "undefined"
            },
            month: {
                string: string$1,
                "undefined": "undefined"
            },
            year: {
                string: string$1,
                "undefined": "undefined"
            },
            __type__: {
                object: object$1,
                "function": "function"
            }
        },
        __type__: {
            object: object$1
        }
    },
    moment: {
        "function": "function"
    },
    groupHeightMode: {
        string: string$1
    },
    groupOrder: {
        string: string$1,
        "function": "function"
    },
    groupEditable: {
        add: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        remove: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        order: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        __type__: {
            "boolean": bool$1,
            object: object$1
        }
    },
    groupOrderSwap: {
        "function": "function"
    },
    height: {
        string: string$1,
        number: number$1
    },
    hiddenDates: {
        start: {
            date: date$1,
            number: number$1,
            string: string$1,
            moment: moment$1
        },
        end: {
            date: date$1,
            number: number$1,
            string: string$1,
            moment: moment$1
        },
        repeat: {
            string: string$1
        },
        __type__: {
            object: object$1,
            array: array$1
        }
    },
    itemsAlwaysDraggable: {
        item: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        range: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        __type__: {
            "boolean": bool$1,
            object: object$1
        }
    },
    limitSize: {
        "boolean": bool$1
    },
    locale: {
        string: string$1
    },
    locales: {
        __any__: {
            any: any$1
        },
        __type__: {
            object: object$1
        }
    },
    longSelectPressTime: {
        number: number$1
    },
    margin: {
        axis: {
            number: number$1
        },
        item: {
            horizontal: {
                number: number$1,
                "undefined": "undefined"
            },
            vertical: {
                number: number$1,
                "undefined": "undefined"
            },
            __type__: {
                object: object$1,
                number: number$1
            }
        },
        __type__: {
            object: object$1,
            number: number$1
        }
    },
    max: {
        date: date$1,
        number: number$1,
        string: string$1,
        moment: moment$1
    },
    maxHeight: {
        number: number$1,
        string: string$1
    },
    maxMinorChars: {
        number: number$1
    },
    min: {
        date: date$1,
        number: number$1,
        string: string$1,
        moment: moment$1
    },
    minHeight: {
        number: number$1,
        string: string$1
    },
    moveable: {
        "boolean": bool$1
    },
    multiselect: {
        "boolean": bool$1
    },
    multiselectPerGroup: {
        "boolean": bool$1
    },
    onAdd: {
        "function": "function"
    },
    onDropObjectOnItem: {
        "function": "function"
    },
    onUpdate: {
        "function": "function"
    },
    onMove: {
        "function": "function"
    },
    onMoving: {
        "function": "function"
    },
    onRemove: {
        "function": "function"
    },
    onAddGroup: {
        "function": "function"
    },
    onMoveGroup: {
        "function": "function"
    },
    onRemoveGroup: {
        "function": "function"
    },
    onInitialDrawComplete: {
        "function": "function"
    },
    order: {
        "function": "function"
    },
    orientation: {
        axis: {
            string: string$1,
            "undefined": "undefined"
        },
        item: {
            string: string$1,
            "undefined": "undefined"
        },
        __type__: {
            string: string$1,
            object: object$1
        }
    },
    selectable: {
        "boolean": bool$1
    },
    sequentialSelection: {
        "boolean": bool$1
    },
    showCurrentTime: {
        "boolean": bool$1
    },
    showMajorLabels: {
        "boolean": bool$1
    },
    showMinorLabels: {
        "boolean": bool$1
    },
    showWeekScale: {
        "boolean": bool$1
    },
    stack: {
        "boolean": bool$1
    },
    stackSubgroups: {
        "boolean": bool$1
    },
    cluster: {
        maxItems: {
            "number": number$1,
            "undefined": "undefined"
        },
        titleTemplate: {
            "string": string$1,
            "undefined": "undefined"
        },
        clusterCriteria: {
            "function": "function",
            "undefined": "undefined"
        },
        showStipes: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        fitOnDoubleClick: {
            "boolean": bool$1,
            "undefined": "undefined"
        },
        __type__: {
            "boolean": bool$1,
            object: object$1
        }
    },
    snap: {
        "function": "function",
        "null": "null"
    },
    start: {
        date: date$1,
        number: number$1,
        string: string$1,
        moment: moment$1
    },
    template: {
        "function": "function"
    },
    loadingScreenTemplate: {
        "function": "function"
    },
    groupTemplate: {
        "function": "function"
    },
    visibleFrameTemplate: {
        string: string$1,
        "function": "function"
    },
    showTooltips: {
        "boolean": bool$1
    },
    tooltip: {
        followMouse: {
            "boolean": bool$1
        },
        overflowMethod: {
            "string": [
                "cap",
                "flip",
                "none"
            ]
        },
        delay: {
            number: number$1
        },
        template: {
            "function": "function"
        },
        __type__: {
            object: object$1
        }
    },
    tooltipOnItemUpdateTime: {
        template: {
            "function": "function"
        },
        __type__: {
            "boolean": bool$1,
            object: object$1
        }
    },
    timeAxis: {
        scale: {
            string: string$1,
            "undefined": "undefined"
        },
        step: {
            number: number$1,
            "undefined": "undefined"
        },
        __type__: {
            object: object$1
        }
    },
    type: {
        string: string$1
    },
    width: {
        string: string$1,
        number: number$1
    },
    preferZoom: {
        "boolean": bool$1
    },
    zoomable: {
        "boolean": bool$1
    },
    zoomKey: {
        string: [
            "ctrlKey",
            "altKey",
            "shiftKey",
            "metaKey",
            ""
        ]
    },
    zoomFriction: {
        number: number$1
    },
    zoomMax: {
        number: number$1
    },
    zoomMin: {
        number: number$1
    },
    xss: {
        disabled: {
            boolean: bool$1
        },
        filterOptions: {
            __any__: {
                any: any$1
            },
            __type__: {
                object: object$1
            }
        },
        __type__: {
            object: object$1
        }
    },
    __type__: {
        object: object$1
    }
};
var configureOptions$1 = {
    global: {
        align: [
            "center",
            "left",
            "right"
        ],
        alignCurrentTime: [
            "none",
            "year",
            "month",
            "quarter",
            "week",
            "isoWeek",
            "day",
            "date",
            "hour",
            "minute",
            "second"
        ],
        direction: false,
        autoResize: true,
        clickToUse: false,
        // dataAttributes: ['all'], // FIXME: can be 'all' or string[]
        editable: {
            add: false,
            remove: false,
            updateGroup: false,
            updateTime: false
        },
        end: "",
        format: {
            minorLabels: {
                millisecond: "SSS",
                second: "s",
                minute: "HH:mm",
                hour: "HH:mm",
                weekday: "ddd D",
                day: "D",
                week: "w",
                month: "MMM",
                year: "YYYY"
            },
            majorLabels: {
                millisecond: "HH:mm:ss",
                second: "D MMMM HH:mm",
                minute: "ddd D MMMM",
                hour: "ddd D MMMM",
                weekday: "MMMM YYYY",
                day: "MMMM YYYY",
                week: "MMMM YYYY",
                month: "YYYY",
                year: ""
            }
        },
        groupHeightMode: [
            "auto",
            "fixed",
            "fitItems"
        ],
        //groupOrder: {string, 'function': 'function'},
        groupsDraggable: false,
        height: "",
        //hiddenDates: {object, array},
        locale: "",
        longSelectPressTime: 251,
        margin: {
            axis: [
                20,
                0,
                100,
                1
            ],
            item: {
                horizontal: [
                    10,
                    0,
                    100,
                    1
                ],
                vertical: [
                    10,
                    0,
                    100,
                    1
                ]
            }
        },
        max: "",
        maxHeight: "",
        maxMinorChars: [
            7,
            0,
            20,
            1
        ],
        min: "",
        minHeight: "",
        moveable: false,
        multiselect: false,
        multiselectPerGroup: false,
        //onAdd: {'function': 'function'},
        //onUpdate: {'function': 'function'},
        //onMove: {'function': 'function'},
        //onMoving: {'function': 'function'},
        //onRename: {'function': 'function'},
        //order: {'function': 'function'},
        orientation: {
            axis: [
                "both",
                "bottom",
                "top"
            ],
            item: [
                "bottom",
                "top"
            ]
        },
        preferZoom: false,
        selectable: true,
        showCurrentTime: false,
        showMajorLabels: true,
        showMinorLabels: true,
        stack: true,
        stackSubgroups: true,
        cluster: false,
        //snap: {'function': 'function', nada},
        start: "",
        //template: {'function': 'function'},
        //timeAxis: {
        //  scale: ['millisecond', 'second', 'minute', 'hour', 'weekday', 'day', 'week', 'month', 'year'],
        //  step: [1, 1, 10, 1]
        //},
        showTooltips: true,
        tooltip: {
            followMouse: false,
            overflowMethod: "flip",
            delay: [
                500,
                0,
                99999,
                100
            ]
        },
        tooltipOnItemUpdateTime: false,
        type: [
            "box",
            "point",
            "range",
            "background"
        ],
        width: "100%",
        zoomable: true,
        zoomKey: [
            "ctrlKey",
            "altKey",
            "shiftKey",
            "metaKey",
            ""
        ],
        zoomMax: [
            315360000000000,
            10,
            315360000000000,
            1
        ],
        zoomMin: [
            10,
            10,
            315360000000000,
            1
        ],
        xss: {
            disabled: false
        }
    }
};
var htmlColors = {
    black: "#000000",
    navy: "#000080",
    darkblue: "#00008B",
    mediumblue: "#0000CD",
    blue: "#0000FF",
    darkgreen: "#006400",
    green: "#008000",
    teal: "#008080",
    darkcyan: "#008B8B",
    deepskyblue: "#00BFFF",
    darkturquoise: "#00CED1",
    mediumspringgreen: "#00FA9A",
    lime: "#00FF00",
    springgreen: "#00FF7F",
    aqua: "#00FFFF",
    cyan: "#00FFFF",
    midnightblue: "#191970",
    dodgerblue: "#1E90FF",
    lightseagreen: "#20B2AA",
    forestgreen: "#228B22",
    seagreen: "#2E8B57",
    darkslategray: "#2F4F4F",
    limegreen: "#32CD32",
    mediumseagreen: "#3CB371",
    turquoise: "#40E0D0",
    royalblue: "#4169E1",
    steelblue: "#4682B4",
    darkslateblue: "#483D8B",
    mediumturquoise: "#48D1CC",
    indigo: "#4B0082",
    darkolivegreen: "#556B2F",
    cadetblue: "#5F9EA0",
    cornflowerblue: "#6495ED",
    mediumaquamarine: "#66CDAA",
    dimgray: "#696969",
    slateblue: "#6A5ACD",
    olivedrab: "#6B8E23",
    slategray: "#708090",
    lightslategray: "#778899",
    mediumslateblue: "#7B68EE",
    lawngreen: "#7CFC00",
    chartreuse: "#7FFF00",
    aquamarine: "#7FFFD4",
    maroon: "#800000",
    purple: "#800080",
    olive: "#808000",
    gray: "#808080",
    skyblue: "#87CEEB",
    lightskyblue: "#87CEFA",
    blueviolet: "#8A2BE2",
    darkred: "#8B0000",
    darkmagenta: "#8B008B",
    saddlebrown: "#8B4513",
    darkseagreen: "#8FBC8F",
    lightgreen: "#90EE90",
    mediumpurple: "#9370D8",
    darkviolet: "#9400D3",
    palegreen: "#98FB98",
    darkorchid: "#9932CC",
    yellowgreen: "#9ACD32",
    sienna: "#A0522D",
    brown: "#A52A2A",
    darkgray: "#A9A9A9",
    lightblue: "#ADD8E6",
    greenyellow: "#ADFF2F",
    paleturquoise: "#AFEEEE",
    lightsteelblue: "#B0C4DE",
    powderblue: "#B0E0E6",
    firebrick: "#B22222",
    darkgoldenrod: "#B8860B",
    mediumorchid: "#BA55D3",
    rosybrown: "#BC8F8F",
    darkkhaki: "#BDB76B",
    silver: "#C0C0C0",
    mediumvioletred: "#C71585",
    indianred: "#CD5C5C",
    peru: "#CD853F",
    chocolate: "#D2691E",
    tan: "#D2B48C",
    lightgrey: "#D3D3D3",
    palevioletred: "#D87093",
    thistle: "#D8BFD8",
    orchid: "#DA70D6",
    goldenrod: "#DAA520",
    crimson: "#DC143C",
    gainsboro: "#DCDCDC",
    plum: "#DDA0DD",
    burlywood: "#DEB887",
    lightcyan: "#E0FFFF",
    lavender: "#E6E6FA",
    darksalmon: "#E9967A",
    violet: "#EE82EE",
    palegoldenrod: "#EEE8AA",
    lightcoral: "#F08080",
    khaki: "#F0E68C",
    aliceblue: "#F0F8FF",
    honeydew: "#F0FFF0",
    azure: "#F0FFFF",
    sandybrown: "#F4A460",
    wheat: "#F5DEB3",
    beige: "#F5F5DC",
    whitesmoke: "#F5F5F5",
    mintcream: "#F5FFFA",
    ghostwhite: "#F8F8FF",
    salmon: "#FA8072",
    antiquewhite: "#FAEBD7",
    linen: "#FAF0E6",
    lightgoldenrodyellow: "#FAFAD2",
    oldlace: "#FDF5E6",
    red: "#FF0000",
    fuchsia: "#FF00FF",
    magenta: "#FF00FF",
    deeppink: "#FF1493",
    orangered: "#FF4500",
    tomato: "#FF6347",
    hotpink: "#FF69B4",
    coral: "#FF7F50",
    darkorange: "#FF8C00",
    lightsalmon: "#FFA07A",
    orange: "#FFA500",
    lightpink: "#FFB6C1",
    pink: "#FFC0CB",
    gold: "#FFD700",
    peachpuff: "#FFDAB9",
    navajowhite: "#FFDEAD",
    moccasin: "#FFE4B5",
    bisque: "#FFE4C4",
    mistyrose: "#FFE4E1",
    blanchedalmond: "#FFEBCD",
    papayawhip: "#FFEFD5",
    lavenderblush: "#FFF0F5",
    seashell: "#FFF5EE",
    cornsilk: "#FFF8DC",
    lemonchiffon: "#FFFACD",
    floralwhite: "#FFFAF0",
    snow: "#FFFAFA",
    yellow: "#FFFF00",
    lightyellow: "#FFFFE0",
    ivory: "#FFFFF0",
    white: "#FFFFFF"
};
/**
 * @param {number} [pixelRatio=1]
 */ var ColorPicker = /*#__PURE__*/ function() {
    /**
   * @param {number} [pixelRatio=1]
   */ function ColorPicker() {
        var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        _classCallCheck(this, ColorPicker);
        this.pixelRatio = pixelRatio;
        this.generated = false;
        this.centerCoordinates = {
            x: 144.5,
            y: 144.5
        };
        this.r = 289 * 0.49;
        this.color = {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        this.hueCircle = undefined;
        this.initialColor = {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        this.previousColor = undefined;
        this.applied = false;
        // bound by
        this.updateCallback = function() {};
        this.closeCallback = function() {};
        // create all DOM elements
        this._create();
    }
    /**
   * this inserts the colorPicker into a div from the DOM
   * @param {Element} container
   */ _createClass(ColorPicker, [
        {
            key: "insertTo",
            value: function insertTo(container) {
                if (this.hammer !== undefined) {
                    this.hammer.destroy();
                    this.hammer = undefined;
                }
                this.container = container;
                this.container.appendChild(this.frame);
                this._bindHammer();
                this._setSize();
            }
        },
        {
            key: "setUpdateCallback",
            value: function setUpdateCallback(callback) {
                if (typeof callback === "function") this.updateCallback = callback;
                else throw new Error("Function attempted to set as colorPicker update callback is not a function.");
            }
        },
        {
            key: "setCloseCallback",
            value: function setCloseCallback(callback) {
                if (typeof callback === "function") this.closeCallback = callback;
                else throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
            }
        },
        {
            key: "_isColorString",
            value: function _isColorString(color) {
                if (typeof color === "string") return htmlColors[color];
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (color === "none") return;
                var rgba;
                // if a html color shorthand is used, convert to hex
                var htmlColor = this._isColorString(color);
                if (htmlColor !== undefined) color = htmlColor;
                // check format
                if (availableUtils.isString(color) === true) {
                    if (availableUtils.isValidRGB(color) === true) {
                        var rgbaArray = color.substr(4).substr(0, color.length - 5).split(",");
                        rgba = {
                            r: rgbaArray[0],
                            g: rgbaArray[1],
                            b: rgbaArray[2],
                            a: 1.0
                        };
                    } else if (availableUtils.isValidRGBA(color) === true) {
                        var _rgbaArray = color.substr(5).substr(0, color.length - 6).split(",");
                        rgba = {
                            r: _rgbaArray[0],
                            g: _rgbaArray[1],
                            b: _rgbaArray[2],
                            a: _rgbaArray[3]
                        };
                    } else if (availableUtils.isValidHex(color) === true) {
                        var rgbObj = availableUtils.hexToRGB(color);
                        rgba = {
                            r: rgbObj.r,
                            g: rgbObj.g,
                            b: rgbObj.b,
                            a: 1.0
                        };
                    }
                } else {
                    if (color instanceof Object) {
                        if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
                            var alpha = color.a !== undefined ? color.a : "1.0";
                            rgba = {
                                r: color.r,
                                g: color.g,
                                b: color.b,
                                a: alpha
                            };
                        }
                    }
                }
                // set color
                if (rgba === undefined) throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + _JSON$stringify(color));
                else this._setColor(rgba, setInitial);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.closeCallback !== undefined) {
                    this.closeCallback();
                    this.closeCallback = undefined;
                }
                this.applied = false;
                this.frame.style.display = "block";
                this._generateHueCircle();
            }
        },
        {
            key: "_hide",
            value: function _hide() {
                var _this = this;
                var storePrevious = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                // store the previous color for next time;
                if (storePrevious === true) this.previousColor = availableUtils.extend({}, this.color);
                if (this.applied === true) this.updateCallback(this.initialColor);
                this.frame.style.display = "none";
                // call the closing callback, restoring the onclick method.
                // this is in a setTimeout because it will trigger the show again before the click is done.
                _setTimeout(function() {
                    if (_this.closeCallback !== undefined) {
                        _this.closeCallback();
                        _this.closeCallback = undefined;
                    }
                }, 0);
            }
        },
        {
            key: "_save",
            value: function _save() {
                this.updateCallback(this.color);
                this.applied = false;
                this._hide();
            }
        },
        {
            key: "_apply",
            value: function _apply() {
                this.applied = true;
                this.updateCallback(this.color);
                this._updatePicker(this.color);
            }
        },
        {
            key: "_loadLast",
            value: function _loadLast() {
                if (this.previousColor !== undefined) this.setColor(this.previousColor, false);
                else alert("There is no last color to load...");
            }
        },
        {
            key: "_setColor",
            value: function _setColor(rgba) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                // store the initial color
                if (setInitial === true) this.initialColor = availableUtils.extend({}, rgba);
                this.color = rgba;
                var hsv = availableUtils.RGBToHSV(rgba.r, rgba.g, rgba.b);
                var angleConvert = 2 * Math.PI;
                var radius = this.r * hsv.s;
                var x = this.centerCoordinates.x + radius * Math.sin(angleConvert * hsv.h);
                var y = this.centerCoordinates.y + radius * Math.cos(angleConvert * hsv.h);
                this.colorPickerSelector.style.left = x - 0.5 * this.colorPickerSelector.clientWidth + "px";
                this.colorPickerSelector.style.top = y - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this._updatePicker(rgba);
            }
        },
        {
            key: "_setOpacity",
            value: function _setOpacity(value) {
                this.color.a = value / 100;
                this._updatePicker(this.color);
            }
        },
        {
            key: "_setBrightness",
            value: function _setBrightness(value) {
                var hsv = availableUtils.RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.v = value / 100;
                var rgba = availableUtils.HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;
                this._updatePicker();
            }
        },
        {
            key: "_updatePicker",
            value: function _updatePicker() {
                var rgba = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.color;
                var hsv = availableUtils.RGBToHSV(rgba.r, rgba.g, rgba.b);
                var ctx = this.colorPickerCanvas.getContext("2d");
                if (this.pixelRation === undefined) this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                // clear the canvas
                var w = this.colorPickerCanvas.clientWidth;
                var h = this.colorPickerCanvas.clientHeight;
                ctx.clearRect(0, 0, w, h);
                ctx.putImageData(this.hueCircle, 0, 0);
                ctx.fillStyle = "rgba(0,0,0," + (1 - hsv.v) + ")";
                ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                _fillInstanceProperty(ctx).call(ctx);
                this.brightnessRange.value = 100 * hsv.v;
                this.opacityRange.value = 100 * rgba.a;
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        },
        {
            key: "_setSize",
            value: function _setSize() {
                this.colorPickerCanvas.style.width = "100%";
                this.colorPickerCanvas.style.height = "100%";
                this.colorPickerCanvas.width = 289 * this.pixelRatio;
                this.colorPickerCanvas.height = 289 * this.pixelRatio;
            }
        },
        {
            key: "_create",
            value: function _create() {
                var _context, _context2, _context3, _context4;
                this.frame = document.createElement("div");
                this.frame.className = "vis-color-picker";
                this.colorPickerDiv = document.createElement("div");
                this.colorPickerSelector = document.createElement("div");
                this.colorPickerSelector.className = "vis-selector";
                this.colorPickerDiv.appendChild(this.colorPickerSelector);
                this.colorPickerCanvas = document.createElement("canvas");
                this.colorPickerDiv.appendChild(this.colorPickerCanvas);
                if (!this.colorPickerCanvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerHTML = "Error: your browser does not support HTML canvas";
                    this.colorPickerCanvas.appendChild(noCanvas);
                } else {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                }
                this.colorPickerDiv.className = "vis-color";
                this.opacityDiv = document.createElement("div");
                this.opacityDiv.className = "vis-opacity";
                this.brightnessDiv = document.createElement("div");
                this.brightnessDiv.className = "vis-brightness";
                this.arrowDiv = document.createElement("div");
                this.arrowDiv.className = "vis-arrow";
                this.opacityRange = document.createElement("input");
                try {
                    this.opacityRange.type = "range"; // Not supported on IE9
                    this.opacityRange.min = "0";
                    this.opacityRange.max = "100";
                } // TODO: Add some error handling and remove this lint exception
                catch (err) {} // eslint-disable-line no-empty
                this.opacityRange.value = "100";
                this.opacityRange.className = "vis-range";
                this.brightnessRange = document.createElement("input");
                try {
                    this.brightnessRange.type = "range"; // Not supported on IE9
                    this.brightnessRange.min = "0";
                    this.brightnessRange.max = "100";
                } // TODO: Add some error handling and remove this lint exception
                catch (err) {} // eslint-disable-line no-empty
                this.brightnessRange.value = "100";
                this.brightnessRange.className = "vis-range";
                this.opacityDiv.appendChild(this.opacityRange);
                this.brightnessDiv.appendChild(this.brightnessRange);
                var me = this;
                this.opacityRange.onchange = function() {
                    me._setOpacity(this.value);
                };
                this.opacityRange.oninput = function() {
                    me._setOpacity(this.value);
                };
                this.brightnessRange.onchange = function() {
                    me._setBrightness(this.value);
                };
                this.brightnessRange.oninput = function() {
                    me._setBrightness(this.value);
                };
                this.brightnessLabel = document.createElement("div");
                this.brightnessLabel.className = "vis-label vis-brightness";
                this.brightnessLabel.innerHTML = "brightness:";
                this.opacityLabel = document.createElement("div");
                this.opacityLabel.className = "vis-label vis-opacity";
                this.opacityLabel.innerHTML = "opacity:";
                this.newColorDiv = document.createElement("div");
                this.newColorDiv.className = "vis-new-color";
                this.newColorDiv.innerHTML = "new";
                this.initialColorDiv = document.createElement("div");
                this.initialColorDiv.className = "vis-initial-color";
                this.initialColorDiv.innerHTML = "initial";
                this.cancelButton = document.createElement("div");
                this.cancelButton.className = "vis-button vis-cancel";
                this.cancelButton.innerHTML = "cancel";
                this.cancelButton.onclick = _bindInstanceProperty$1(_context = this._hide).call(_context, this, false);
                this.applyButton = document.createElement("div");
                this.applyButton.className = "vis-button vis-apply";
                this.applyButton.innerHTML = "apply";
                this.applyButton.onclick = _bindInstanceProperty$1(_context2 = this._apply).call(_context2, this);
                this.saveButton = document.createElement("div");
                this.saveButton.className = "vis-button vis-save";
                this.saveButton.innerHTML = "save";
                this.saveButton.onclick = _bindInstanceProperty$1(_context3 = this._save).call(_context3, this);
                this.loadButton = document.createElement("div");
                this.loadButton.className = "vis-button vis-load";
                this.loadButton.innerHTML = "load last";
                this.loadButton.onclick = _bindInstanceProperty$1(_context4 = this._loadLast).call(_context4, this);
                this.frame.appendChild(this.colorPickerDiv);
                this.frame.appendChild(this.arrowDiv);
                this.frame.appendChild(this.brightnessLabel);
                this.frame.appendChild(this.brightnessDiv);
                this.frame.appendChild(this.opacityLabel);
                this.frame.appendChild(this.opacityDiv);
                this.frame.appendChild(this.newColorDiv);
                this.frame.appendChild(this.initialColorDiv);
                this.frame.appendChild(this.cancelButton);
                this.frame.appendChild(this.applyButton);
                this.frame.appendChild(this.saveButton);
                this.frame.appendChild(this.loadButton);
            }
        },
        {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this2 = this;
                this.drag = {};
                this.pinch = {};
                this.hammer = new Hammer(this.colorPickerCanvas);
                this.hammer.get("pinch").set({
                    enable: true
                });
                onTouch(this.hammer, function(event1) {
                    _this2._moveSelector(event1);
                });
                this.hammer.on("tap", function(event1) {
                    _this2._moveSelector(event1);
                });
                this.hammer.on("panstart", function(event1) {
                    _this2._moveSelector(event1);
                });
                this.hammer.on("panmove", function(event1) {
                    _this2._moveSelector(event1);
                });
                this.hammer.on("panend", function(event1) {
                    _this2._moveSelector(event1);
                });
            }
        },
        {
            key: "_generateHueCircle",
            value: function _generateHueCircle() {
                if (this.generated === false) {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    if (this.pixelRation === undefined) this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                    // clear the canvas
                    var w = this.colorPickerCanvas.clientWidth;
                    var h = this.colorPickerCanvas.clientHeight;
                    ctx.clearRect(0, 0, w, h);
                    // draw hue circle
                    var x, y, hue, sat;
                    this.centerCoordinates = {
                        x: w * 0.5,
                        y: h * 0.5
                    };
                    this.r = 0.49 * w;
                    var angleConvert = 2 * Math.PI / 360;
                    var hfac = 1 / 360;
                    var sfac = 1 / this.r;
                    var rgb;
                    for(hue = 0; hue < 360; hue++)for(sat = 0; sat < this.r; sat++){
                        x = this.centerCoordinates.x + sat * Math.sin(angleConvert * hue);
                        y = this.centerCoordinates.y + sat * Math.cos(angleConvert * hue);
                        rgb = availableUtils.HSVToRGB(hue * hfac, sat * sfac, 1);
                        ctx.fillStyle = "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
                        ctx.fillRect(x - 0.5, y - 0.5, 2, 2);
                    }
                    ctx.strokeStyle = "rgba(0,0,0,1)";
                    ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                    ctx.stroke();
                    this.hueCircle = ctx.getImageData(0, 0, w, h);
                }
                this.generated = true;
            }
        },
        {
            key: "_moveSelector",
            value: function _moveSelector(event1) {
                var rect = this.colorPickerDiv.getBoundingClientRect();
                var left = event1.center.x - rect.left;
                var top = event1.center.y - rect.top;
                var centerY = 0.5 * this.colorPickerDiv.clientHeight;
                var centerX = 0.5 * this.colorPickerDiv.clientWidth;
                var x = left - centerX;
                var y = top - centerY;
                var angle = Math.atan2(x, y);
                var radius = 0.98 * Math.min(Math.sqrt(x * x + y * y), centerX);
                var newTop = Math.cos(angle) * radius + centerY;
                var newLeft = Math.sin(angle) * radius + centerX;
                this.colorPickerSelector.style.top = newTop - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this.colorPickerSelector.style.left = newLeft - 0.5 * this.colorPickerSelector.clientWidth + "px";
                // set color
                var h = angle / (2 * Math.PI);
                h = h < 0 ? h + 1 : h;
                var s = radius / this.r;
                var hsv = availableUtils.RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.h = h;
                hsv.s = s;
                var rgba = availableUtils.HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;
                // update previews
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        }
    ]);
    return ColorPicker;
}();
var css_248z$1 = "div.vis-configuration {\n    position:relative;\n    display:block;\n    float:left;\n    font-size:12px;\n}\n\ndiv.vis-configuration-wrapper {\n    display:block;\n    width:700px;\n}\n\ndiv.vis-configuration-wrapper::after {\n  clear: both;\n  content: \"\";\n  display: block;\n}\n\ndiv.vis-configuration.vis-config-option-container{\n    display:block;\n    width:495px;\n    background-color: #ffffff;\n    border:2px solid #f7f8fa;\n    border-radius:4px;\n    margin-top:20px;\n    left:10px;\n    padding-left:5px;\n}\n\ndiv.vis-configuration.vis-config-button{\n    display:block;\n    width:495px;\n    height:25px;\n    vertical-align: middle;\n    line-height:25px;\n    background-color: #f7f8fa;\n    border:2px solid #ceced0;\n    border-radius:4px;\n    margin-top:20px;\n    left:10px;\n    padding-left:5px;\n    cursor: pointer;\n    margin-bottom:30px;\n}\n\ndiv.vis-configuration.vis-config-button.hover{\n    background-color: #4588e6;\n    border:2px solid #214373;\n    color:#ffffff;\n}\n\ndiv.vis-configuration.vis-config-item{\n    display:block;\n    float:left;\n    width:495px;\n    height:25px;\n    vertical-align: middle;\n    line-height:25px;\n}\n\n\ndiv.vis-configuration.vis-config-item.vis-config-s2{\n    left:10px;\n    background-color: #f7f8fa;\n    padding-left:5px;\n    border-radius:3px;\n}\ndiv.vis-configuration.vis-config-item.vis-config-s3{\n    left:20px;\n    background-color: #e4e9f0;\n    padding-left:5px;\n    border-radius:3px;\n}\ndiv.vis-configuration.vis-config-item.vis-config-s4{\n    left:30px;\n    background-color: #cfd8e6;\n    padding-left:5px;\n    border-radius:3px;\n}\n\ndiv.vis-configuration.vis-config-header{\n    font-size:18px;\n    font-weight: bold;\n}\n\ndiv.vis-configuration.vis-config-label{\n    width:120px;\n    height:25px;\n    line-height: 25px;\n}\n\ndiv.vis-configuration.vis-config-label.vis-config-s3{\n    width:110px;\n}\ndiv.vis-configuration.vis-config-label.vis-config-s4{\n    width:100px;\n}\n\ndiv.vis-configuration.vis-config-colorBlock{\n    top:1px;\n    width:30px;\n    height:19px;\n    border:1px solid #444444;\n    border-radius:2px;\n    padding:0px;\n    margin:0px;\n    cursor:pointer;\n}\n\ninput.vis-configuration.vis-config-checkbox {\n    left:-5px;\n}\n\n\ninput.vis-configuration.vis-config-rangeinput{\n    position:relative;\n    top:-5px;\n    width:60px;\n    /*height:13px;*/\n    padding:1px;\n    margin:0;\n    pointer-events:none;\n}\n\ninput.vis-configuration.vis-config-range{\n    /*removes default webkit styles*/\n    -webkit-appearance: none;\n\n    /*fix for FF unable to apply focus style bug */\n    border: 0px solid white;\n    background-color:rgba(0,0,0,0);\n\n    /*required for proper track sizing in FF*/\n    width: 300px;\n    height:20px;\n}\ninput.vis-configuration.vis-config-range::-webkit-slider-runnable-track {\n    width: 300px;\n    height: 5px;\n    background: #dedede; /* Old browsers */\n    background: -moz-linear-gradient(top,  #dedede 0%, #c8c8c8 99%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#dedede), color-stop(99%,#c8c8c8)); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top,  #dedede 0%,#c8c8c8 99%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top,  #dedede 0%,#c8c8c8 99%); /* IE10+ */\n    background: linear-gradient(to bottom,  #dedede 0%,#c8c8c8 99%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dedede', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n\n    border: 1px solid #999999;\n    box-shadow: #aaaaaa 0px 0px 3px 0px;\n    border-radius: 3px;\n}\ninput.vis-configuration.vis-config-range::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    border: 1px solid #14334b;\n    height: 17px;\n    width: 17px;\n    border-radius: 50%;\n    background: #3876c2; /* Old browsers */\n    background: -moz-linear-gradient(top,  #3876c2 0%, #385380 100%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#3876c2), color-stop(100%,#385380)); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top,  #3876c2 0%,#385380 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top,  #3876c2 0%,#385380 100%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top,  #3876c2 0%,#385380 100%); /* IE10+ */\n    background: linear-gradient(to bottom,  #3876c2 0%,#385380 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3876c2', endColorstr='#385380',GradientType=0 ); /* IE6-9 */\n    box-shadow: #111927 0px 0px 1px 0px;\n    margin-top: -7px;\n}\ninput.vis-configuration.vis-config-range:focus {\n    outline: none;\n}\ninput.vis-configuration.vis-config-range:focus::-webkit-slider-runnable-track {\n    background: #9d9d9d; /* Old browsers */\n    background: -moz-linear-gradient(top, #9d9d9d 0%, #c8c8c8 99%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#9d9d9d), color-stop(99%,#c8c8c8)); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top,  #9d9d9d 0%,#c8c8c8 99%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top,  #9d9d9d 0%,#c8c8c8 99%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top,  #9d9d9d 0%,#c8c8c8 99%); /* IE10+ */\n    background: linear-gradient(to bottom,  #9d9d9d 0%,#c8c8c8 99%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9d9d9d', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n}\n\ninput.vis-configuration.vis-config-range::-moz-range-track {\n    width: 300px;\n    height: 10px;\n    background: #dedede; /* Old browsers */\n    background: -moz-linear-gradient(top,  #dedede 0%, #c8c8c8 99%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#dedede), color-stop(99%,#c8c8c8)); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top,  #dedede 0%,#c8c8c8 99%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top,  #dedede 0%,#c8c8c8 99%); /* IE10+ */\n    background: linear-gradient(to bottom,  #dedede 0%,#c8c8c8 99%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dedede', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n\n    border: 1px solid #999999;\n    box-shadow: #aaaaaa 0px 0px 3px 0px;\n    border-radius: 3px;\n}\ninput.vis-configuration.vis-config-range::-moz-range-thumb {\n    border: none;\n    height: 16px;\n    width: 16px;\n\n    border-radius: 50%;\n    background:  #385380;\n}\n\n/*hide the outline behind the border*/\ninput.vis-configuration.vis-config-range:-moz-focusring{\n    outline: 1px solid white;\n    outline-offset: -1px;\n}\n\ninput.vis-configuration.vis-config-range::-ms-track {\n    width: 300px;\n    height: 5px;\n\n    /*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */\n    background: transparent;\n\n    /*leave room for the larger thumb to overflow with a transparent border */\n    border-color: transparent;\n    border-width: 6px 0;\n\n    /*remove default tick marks*/\n    color: transparent;\n}\ninput.vis-configuration.vis-config-range::-ms-fill-lower {\n    background: #777;\n    border-radius: 10px;\n}\ninput.vis-configuration.vis-config-range::-ms-fill-upper {\n    background: #ddd;\n    border-radius: 10px;\n}\ninput.vis-configuration.vis-config-range::-ms-thumb {\n    border: none;\n    height: 16px;\n    width: 16px;\n    border-radius: 50%;\n    background:  #385380;\n}\ninput.vis-configuration.vis-config-range:focus::-ms-fill-lower {\n    background: #888;\n}\ninput.vis-configuration.vis-config-range:focus::-ms-fill-upper {\n    background: #ccc;\n}\n\n.vis-configuration-popup {\n    position: absolute;\n    background: rgba(57, 76, 89, 0.85);\n    border: 2px solid #f2faff;\n    line-height:30px;\n    height:30px;\n    width:150px;\n    text-align:center;\n    color: #ffffff;\n    font-size:14px;\n    border-radius:4px;\n    -webkit-transition: opacity 0.3s ease-in-out;\n    -moz-transition: opacity 0.3s ease-in-out;\n    transition: opacity 0.3s ease-in-out;\n}\n.vis-configuration-popup:after, .vis-configuration-popup:before {\n    left: 100%;\n    top: 50%;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n}\n\n.vis-configuration-popup:after {\n    border-color: rgba(136, 183, 213, 0);\n    border-left-color: rgba(57, 76, 89, 0.85);\n    border-width: 8px;\n    margin-top: -8px;\n}\n.vis-configuration-popup:before {\n    border-color: rgba(194, 225, 245, 0);\n    border-left-color: #f2faff;\n    border-width: 12px;\n    margin-top: -12px;\n}";
styleInject(css_248z$1);
/**
 * The way this works is for all properties of this.possible options, you can supply the property name in any form to list the options.
 * Boolean options are recognised as Boolean
 * Number options should be written as array: [default value, min value, max value, stepsize]
 * Colors should be written as array: ['color', '#ffffff']
 * Strings with should be written as array: [option1, option2, option3, ..]
 *
 * The options are matched with their counterparts in each of the modules and the values used in the configuration are
 */ var Configurator = /*#__PURE__*/ function() {
    /**
   * @param {Object} parentModule        | the location where parentModule.setOptions() can be called
   * @param {Object} defaultContainer    | the default container of the module
   * @param {Object} configureOptions    | the fully configured and predefined options set found in allOptions.js
   * @param {number} pixelRatio          | canvas pixel ratio
   */ function Configurator(parentModule, defaultContainer, configureOptions) {
        var pixelRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        _classCallCheck(this, Configurator);
        this.parent = parentModule;
        this.changedOptions = [];
        this.container = defaultContainer;
        this.allowCreation = false;
        this.options = {};
        this.initialized = false;
        this.popupCounter = 0;
        this.defaultOptions = {
            enabled: false,
            filter: true,
            container: undefined,
            showButton: true
        };
        availableUtils.extend(this.options, this.defaultOptions);
        this.configureOptions = configureOptions;
        this.moduleOptions = {};
        this.domElements = [];
        this.popupDiv = {};
        this.popupLimit = 5;
        this.popupHistory = {};
        this.colorPicker = new ColorPicker(pixelRatio);
        this.wrapper = undefined;
    }
    /**
   * refresh all options.
   * Because all modules parse their options by themselves, we just use their options. We copy them here.
   *
   * @param {Object} options
   */ _createClass(Configurator, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // reset the popup history because the indices may have been changed.
                    this.popupHistory = {};
                    this._removePopup();
                    var enabled = true;
                    if (typeof options === "string") this.options.filter = options;
                    else if (_Array$isArray(options)) this.options.filter = options.join();
                    else if (_typeof$1(options) === "object") {
                        if (options == null) throw new TypeError("options cannot be null");
                        if (options.container !== undefined) this.options.container = options.container;
                        if (_filterInstanceProperty(options) !== undefined) this.options.filter = _filterInstanceProperty(options);
                        if (options.showButton !== undefined) this.options.showButton = options.showButton;
                        if (options.enabled !== undefined) enabled = options.enabled;
                    } else if (typeof options === "boolean") {
                        this.options.filter = true;
                        enabled = options;
                    } else if (typeof options === "function") {
                        this.options.filter = options;
                        enabled = true;
                    }
                    if (_filterInstanceProperty(this.options) === false) enabled = false;
                    this.options.enabled = enabled;
                }
                this._clean();
            }
        },
        {
            key: "setModuleOptions",
            value: function setModuleOptions(moduleOptions) {
                this.moduleOptions = moduleOptions;
                if (this.options.enabled === true) {
                    this._clean();
                    if (this.options.container !== undefined) this.container = this.options.container;
                    this._create();
                }
            }
        },
        {
            key: "_create",
            value: function _create() {
                this._clean();
                this.changedOptions = [];
                var filter = _filterInstanceProperty(this.options);
                var counter = 0;
                var show = false;
                for(var option in this.configureOptions)if (this.configureOptions.hasOwnProperty(option)) {
                    this.allowCreation = false;
                    show = false;
                    if (typeof filter === "function") {
                        show = filter(option, []);
                        show = show || this._handleObject(this.configureOptions[option], [
                            option
                        ], true);
                    } else if (filter === true || _indexOfInstanceProperty(filter).call(filter, option) !== -1) show = true;
                    if (show !== false) {
                        this.allowCreation = true;
                        // linebreak between categories
                        if (counter > 0) this._makeItem([]);
                        // a header for the category
                        this._makeHeader(option);
                        // get the sub options
                        this._handleObject(this.configureOptions[option], [
                            option
                        ]);
                    }
                    counter++;
                }
                this._makeButton();
                this._push();
            //~ this.colorPicker.insertTo(this.container);
            }
        },
        {
            key: "_push",
            value: function _push() {
                this.wrapper = document.createElement("div");
                this.wrapper.className = "vis-configuration-wrapper";
                this.container.appendChild(this.wrapper);
                for(var i1 = 0; i1 < this.domElements.length; i1++)this.wrapper.appendChild(this.domElements[i1]);
                this._showPopupIfNeeded();
            }
        },
        {
            key: "_clean",
            value: function _clean() {
                for(var i1 = 0; i1 < this.domElements.length; i1++)this.wrapper.removeChild(this.domElements[i1]);
                if (this.wrapper !== undefined) {
                    this.container.removeChild(this.wrapper);
                    this.wrapper = undefined;
                }
                this.domElements = [];
                this._removePopup();
            }
        },
        {
            key: "_getValue",
            value: function _getValue(path) {
                var base = this.moduleOptions;
                for(var i1 = 0; i1 < path.length; i1++)if (base[path[i1]] !== undefined) base = base[path[i1]];
                else {
                    base = undefined;
                    break;
                }
                return base;
            }
        },
        {
            key: "_makeItem",
            value: function _makeItem(path) {
                if (this.allowCreation === true) {
                    var item = document.createElement("div");
                    item.className = "vis-configuration vis-config-item vis-config-s" + path.length;
                    for(var _len = arguments.length, domElements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)domElements[_key - 1] = arguments[_key];
                    _forEachInstanceProperty(domElements).call(domElements, function(element) {
                        item.appendChild(element);
                    });
                    this.domElements.push(item);
                    return this.domElements.length;
                }
                return 0;
            }
        },
        {
            key: "_makeHeader",
            value: function _makeHeader(name) {
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-header";
                div.innerHTML = availableUtils.xss(name);
                this._makeItem([], div);
            }
        },
        {
            key: "_makeLabel",
            value: function _makeLabel(name, path) {
                var objectLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-label vis-config-s" + path.length;
                if (objectLabel === true) div.innerHTML = availableUtils.xss("<i><b>" + name + ":</b></i>");
                else div.innerHTML = availableUtils.xss(name + ":");
                return div;
            }
        },
        {
            key: "_makeDropdown",
            value: function _makeDropdown(arr, value, path) {
                var select = document.createElement("select");
                select.className = "vis-configuration vis-config-select";
                var selectedValue = 0;
                if (value !== undefined) {
                    if (_indexOfInstanceProperty(arr).call(arr, value) !== -1) selectedValue = _indexOfInstanceProperty(arr).call(arr, value);
                }
                for(var i1 = 0; i1 < arr.length; i1++){
                    var option = document.createElement("option");
                    option.value = arr[i1];
                    if (i1 === selectedValue) option.selected = "selected";
                    option.innerHTML = arr[i1];
                    select.appendChild(option);
                }
                var me = this;
                select.onchange = function() {
                    me._update(this.value, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, select);
            }
        },
        {
            key: "_makeRange",
            value: function _makeRange(arr, value, path) {
                var defaultValue = arr[0];
                var min = arr[1];
                var max = arr[2];
                var step = arr[3];
                var range = document.createElement("input");
                range.className = "vis-configuration vis-config-range";
                try {
                    range.type = "range"; // not supported on IE9
                    range.min = min;
                    range.max = max;
                } // TODO: Add some error handling and remove this lint exception
                catch (err) {} // eslint-disable-line no-empty
                range.step = step;
                // set up the popup settings in case they are needed.
                var popupString = "";
                var popupValue = 0;
                if (value !== undefined) {
                    var factor = 1.20;
                    if (value < 0 && value * factor < min) {
                        range.min = Math.ceil(value * factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    } else if (value / factor < min) {
                        range.min = Math.ceil(value / factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    }
                    if (value * factor > max && max !== 1) {
                        range.max = Math.ceil(value * factor);
                        popupValue = range.max;
                        popupString = "range increased";
                    }
                    range.value = value;
                } else range.value = defaultValue;
                var input = document.createElement("input");
                input.className = "vis-configuration vis-config-rangeinput";
                input.value = Number(range.value);
                var me = this;
                range.onchange = function() {
                    input.value = this.value;
                    me._update(Number(this.value), path);
                };
                range.oninput = function() {
                    input.value = this.value;
                };
                var label = this._makeLabel(path[path.length - 1], path);
                var itemIndex = this._makeItem(path, label, range, input);
                // if a popup is needed AND it has not been shown for this value, show it.
                if (popupString !== "" && this.popupHistory[itemIndex] !== popupValue) {
                    this.popupHistory[itemIndex] = popupValue;
                    this._setupPopup(popupString, itemIndex);
                }
            }
        },
        {
            key: "_makeButton",
            value: function _makeButton() {
                var _this = this;
                if (this.options.showButton === true) {
                    var generateButton = document.createElement("div");
                    generateButton.className = "vis-configuration vis-config-button";
                    generateButton.innerHTML = "generate options";
                    generateButton.onclick = function() {
                        _this._printOptions();
                    };
                    generateButton.onmouseover = function() {
                        generateButton.className = "vis-configuration vis-config-button hover";
                    };
                    generateButton.onmouseout = function() {
                        generateButton.className = "vis-configuration vis-config-button";
                    };
                    this.optionsContainer = document.createElement("div");
                    this.optionsContainer.className = "vis-configuration vis-config-option-container";
                    this.domElements.push(this.optionsContainer);
                    this.domElements.push(generateButton);
                }
            }
        },
        {
            key: "_setupPopup",
            value: function _setupPopup(string, index) {
                var _this2 = this;
                if (this.initialized === true && this.allowCreation === true && this.popupCounter < this.popupLimit) {
                    var div = document.createElement("div");
                    div.id = "vis-configuration-popup";
                    div.className = "vis-configuration-popup";
                    div.innerHTML = availableUtils.xss(string);
                    div.onclick = function() {
                        _this2._removePopup();
                    };
                    this.popupCounter += 1;
                    this.popupDiv = {
                        html: div,
                        index: index
                    };
                }
            }
        },
        {
            key: "_removePopup",
            value: function _removePopup() {
                if (this.popupDiv.html !== undefined) {
                    this.popupDiv.html.parentNode.removeChild(this.popupDiv.html);
                    clearTimeout(this.popupDiv.hideTimeout);
                    clearTimeout(this.popupDiv.deleteTimeout);
                    this.popupDiv = {};
                }
            }
        },
        {
            key: "_showPopupIfNeeded",
            value: function _showPopupIfNeeded() {
                var _this3 = this;
                if (this.popupDiv.html !== undefined) {
                    var correspondingElement = this.domElements[this.popupDiv.index];
                    var rect = correspondingElement.getBoundingClientRect();
                    this.popupDiv.html.style.left = rect.left + "px";
                    this.popupDiv.html.style.top = rect.top - 30 + "px"; // 30 is the height;
                    document.body.appendChild(this.popupDiv.html);
                    this.popupDiv.hideTimeout = _setTimeout(function() {
                        _this3.popupDiv.html.style.opacity = 0;
                    }, 1500);
                    this.popupDiv.deleteTimeout = _setTimeout(function() {
                        _this3._removePopup();
                    }, 1800);
                }
            }
        },
        {
            key: "_makeCheckbox",
            value: function _makeCheckbox(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "checkbox";
                checkbox.className = "vis-configuration vis-config-checkbox";
                checkbox.checked = defaultValue;
                if (value !== undefined) {
                    checkbox.checked = value;
                    if (value !== defaultValue) {
                        if (_typeof$1(defaultValue) === "object") {
                            if (value !== defaultValue.enabled) this.changedOptions.push({
                                path: path,
                                value: value
                            });
                        } else this.changedOptions.push({
                            path: path,
                            value: value
                        });
                    }
                }
                var me = this;
                checkbox.onchange = function() {
                    me._update(this.checked, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, checkbox);
            }
        },
        {
            key: "_makeTextInput",
            value: function _makeTextInput(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "text";
                checkbox.className = "vis-configuration vis-config-text";
                checkbox.value = value;
                if (value !== defaultValue) this.changedOptions.push({
                    path: path,
                    value: value
                });
                var me = this;
                checkbox.onchange = function() {
                    me._update(this.value, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, checkbox);
            }
        },
        {
            key: "_makeColorField",
            value: function _makeColorField(arr, value, path) {
                var _this4 = this;
                var defaultColor = arr[1];
                var div = document.createElement("div");
                value = value === undefined ? defaultColor : value;
                if (value !== "none") {
                    div.className = "vis-configuration vis-config-colorBlock";
                    div.style.backgroundColor = value;
                } else div.className = "vis-configuration vis-config-colorBlock none";
                value = value === undefined ? defaultColor : value;
                div.onclick = function() {
                    _this4._showColorPicker(value, div, path);
                };
                var label = this._makeLabel(path[path.length - 1], path);
                this._makeItem(path, label, div);
            }
        },
        {
            key: "_showColorPicker",
            value: function _showColorPicker(value, div, path) {
                var _this5 = this;
                // clear the callback from this div
                div.onclick = function() {};
                this.colorPicker.insertTo(div);
                this.colorPicker.show();
                this.colorPicker.setColor(value);
                this.colorPicker.setUpdateCallback(function(color) {
                    var colorString = "rgba(" + color.r + "," + color.g + "," + color.b + "," + color.a + ")";
                    div.style.backgroundColor = colorString;
                    _this5._update(colorString, path);
                });
                // on close of the colorpicker, restore the callback.
                this.colorPicker.setCloseCallback(function() {
                    div.onclick = function() {
                        _this5._showColorPicker(value, div, path);
                    };
                });
            }
        },
        {
            key: "_handleObject",
            value: function _handleObject(obj) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var checkOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var show = false;
                var filter = _filterInstanceProperty(this.options);
                var visibleInSet = false;
                for(var subObj in obj)if (obj.hasOwnProperty(subObj)) {
                    show = true;
                    var item = obj[subObj];
                    var newPath = availableUtils.copyAndExtendArray(path, subObj);
                    if (typeof filter === "function") {
                        show = filter(subObj, path);
                        // if needed we must go deeper into the object.
                        if (show === false) {
                            if (!_Array$isArray(item) && typeof item !== "string" && typeof item !== "boolean" && item instanceof Object) {
                                this.allowCreation = false;
                                show = this._handleObject(item, newPath, true);
                                this.allowCreation = checkOnly === false;
                            }
                        }
                    }
                    if (show !== false) {
                        visibleInSet = true;
                        var value = this._getValue(newPath);
                        if (_Array$isArray(item)) this._handleArray(item, value, newPath);
                        else if (typeof item === "string") this._makeTextInput(item, value, newPath);
                        else if (typeof item === "boolean") this._makeCheckbox(item, value, newPath);
                        else if (item instanceof Object) {
                            // collapse the physics options that are not enabled
                            var draw = true;
                            if (_indexOfInstanceProperty(path).call(path, "physics") !== -1) {
                                if (this.moduleOptions.physics.solver !== subObj) draw = false;
                            }
                            if (draw === true) {
                                // initially collapse options with an disabled enabled option.
                                if (item.enabled !== undefined) {
                                    var enabledPath = availableUtils.copyAndExtendArray(newPath, "enabled");
                                    var enabledValue = this._getValue(enabledPath);
                                    if (enabledValue === true) {
                                        var label = this._makeLabel(subObj, newPath, true);
                                        this._makeItem(newPath, label);
                                        visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                    } else this._makeCheckbox(item, enabledValue, newPath);
                                } else {
                                    var _label = this._makeLabel(subObj, newPath, true);
                                    this._makeItem(newPath, _label);
                                    visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                }
                            }
                        } else console.error("dont know how to handle", item, subObj, newPath);
                    }
                }
                return visibleInSet;
            }
        },
        {
            key: "_handleArray",
            value: function _handleArray(arr, value, path) {
                if (typeof arr[0] === "string" && arr[0] === "color") {
                    this._makeColorField(arr, value, path);
                    if (arr[1] !== value) this.changedOptions.push({
                        path: path,
                        value: value
                    });
                } else if (typeof arr[0] === "string") {
                    this._makeDropdown(arr, value, path);
                    if (arr[0] !== value) this.changedOptions.push({
                        path: path,
                        value: value
                    });
                } else if (typeof arr[0] === "number") {
                    this._makeRange(arr, value, path);
                    if (arr[0] !== value) this.changedOptions.push({
                        path: path,
                        value: Number(value)
                    });
                }
            }
        },
        {
            key: "_update",
            value: function _update(value, path) {
                var options = this._constructOptions(value, path);
                if (this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit) this.parent.body.emitter.emit("configChange", options);
                this.initialized = true;
                this.parent.setOptions(options);
            }
        },
        {
            key: "_constructOptions",
            value: function _constructOptions(value, path) {
                var optionsObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var pointer = optionsObj;
                // when dropdown boxes can be string or boolean, we typecast it into correct types
                value = value === "true" ? true : value;
                value = value === "false" ? false : value;
                for(var i1 = 0; i1 < path.length; i1++)if (path[i1] !== "global") {
                    if (pointer[path[i1]] === undefined) pointer[path[i1]] = {};
                    if (i1 !== path.length - 1) pointer = pointer[path[i1]];
                    else pointer[path[i1]] = value;
                }
                return optionsObj;
            }
        },
        {
            key: "_printOptions",
            value: function _printOptions() {
                var options = this.getOptions();
                this.optionsContainer.innerHTML = "<pre>var options = " + _JSON$stringify(options, null, 2) + "</pre>";
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var options = {};
                for(var i1 = 0; i1 < this.changedOptions.length; i1++)this._constructOptions(this.changedOptions[i1].value, this.changedOptions[i1].path, options);
                return options;
            }
        }
    ]);
    return Configurator;
}();
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Create a timeline visualization
 * @extends Core
 */ var Timeline = /*#__PURE__*/ function(_Core) {
    _inherits(Timeline, _Core);
    var _super = _createSuper$1(Timeline);
    /**
  * @param {HTMLElement} container
  * @param {vis.DataSet | vis.DataView | Array} [items]
  * @param {vis.DataSet | vis.DataView | Array} [groups]
  * @param {Object} [options]  See Timeline.setOptions for the available options.
  * @constructor Timeline
  */ function Timeline(container, items, groups, options) {
        var _context2, _context3, _context4, _context5, _context6, _context7, _context8;
        var _this;
        _classCallCheck(this, Timeline);
        _this = _super.call(this);
        _this.initTime = new Date();
        _this.itemsDone = false;
        if (!(_assertThisInitialized(_this) instanceof Timeline)) throw new SyntaxError("Constructor must be called with the new operator");
        // if the third element is options, the forth is groups (optionally);
        if (!(_Array$isArray(groups) || isDataViewLike(groups)) && groups instanceof Object) {
            var forthArgument = options;
            options = groups;
            groups = forthArgument;
        }
        // TODO: REMOVE THIS in the next MAJOR release
        // see https://github.com/almende/vis/issues/2511
        if (options && options.throttleRedraw) console.warn('Timeline option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
        var me = _assertThisInitialized(_this);
        _this.defaultOptions = {
            autoResize: true,
            longSelectPressTime: 251,
            orientation: {
                axis: "bottom",
                // axis orientation: 'bottom', 'top', or 'both'
                item: "bottom" // not relevant
            },
            moment: moment$4
        };
        _this.options = availableUtils.deepExtend({}, _this.defaultOptions);
        options && availableUtils.setupXSSProtection(options.xss);
        // Create the DOM, props, and emitter
        _this._create(container);
        if (!options || options && typeof options.rtl == "undefined") {
            _this.dom.root.style.visibility = "hidden";
            var directionFromDom;
            var domNode = _this.dom.root;
            while(!directionFromDom && domNode){
                directionFromDom = window.getComputedStyle(domNode, null).direction;
                domNode = domNode.parentElement;
            }
            _this.options.rtl = directionFromDom && directionFromDom.toLowerCase() == "rtl";
        } else _this.options.rtl = options.rtl;
        if (options) {
            if (options.rollingMode) _this.options.rollingMode = options.rollingMode;
            if (options.onInitialDrawComplete) _this.options.onInitialDrawComplete = options.onInitialDrawComplete;
            if (options.onTimeout) _this.options.onTimeout = options.onTimeout;
            if (options.loadingScreenTemplate) _this.options.loadingScreenTemplate = options.loadingScreenTemplate;
        }
        // Prepare loading screen
        var loadingScreenFragment = document.createElement("div");
        if (_this.options.loadingScreenTemplate) {
            var _context;
            var templateFunction = _bindInstanceProperty$1(_context = _this.options.loadingScreenTemplate).call(_context, _assertThisInitialized(_this));
            var loadingScreen = templateFunction(_this.dom.loadingScreen);
            if (loadingScreen instanceof Object && !(loadingScreen instanceof Element)) templateFunction(loadingScreenFragment);
            else {
                if (loadingScreen instanceof Element) {
                    loadingScreenFragment.innerHTML = "";
                    loadingScreenFragment.appendChild(loadingScreen);
                } else if (loadingScreen != undefined) loadingScreenFragment.innerHTML = availableUtils.xss(loadingScreen);
            }
        }
        _this.dom.loadingScreen.appendChild(loadingScreenFragment);
        // all components listed here will be repainted automatically
        _this.components = [];
        _this.body = {
            dom: _this.dom,
            domProps: _this.props,
            emitter: {
                on: _bindInstanceProperty$1(_context2 = _this.on).call(_context2, _assertThisInitialized(_this)),
                off: _bindInstanceProperty$1(_context3 = _this.off).call(_context3, _assertThisInitialized(_this)),
                emit: _bindInstanceProperty$1(_context4 = _this.emit).call(_context4, _assertThisInitialized(_this))
            },
            hiddenDates: [],
            util: {
                getScale: function getScale() {
                    return me.timeAxis.step.scale;
                },
                getStep: function getStep() {
                    return me.timeAxis.step.step;
                },
                toScreen: _bindInstanceProperty$1(_context5 = me._toScreen).call(_context5, me),
                toGlobalScreen: _bindInstanceProperty$1(_context6 = me._toGlobalScreen).call(_context6, me),
                // this refers to the root.width
                toTime: _bindInstanceProperty$1(_context7 = me._toTime).call(_context7, me),
                toGlobalTime: _bindInstanceProperty$1(_context8 = me._toGlobalTime).call(_context8, me)
            }
        };
        // range
        _this.range = new Range(_this.body, _this.options);
        _this.components.push(_this.range);
        _this.body.range = _this.range;
        // time axis
        _this.timeAxis = new TimeAxis(_this.body, _this.options);
        _this.timeAxis2 = null; // used in case of orientation option 'both'
        _this.components.push(_this.timeAxis);
        // current time bar
        _this.currentTime = new CurrentTime(_this.body, _this.options);
        _this.components.push(_this.currentTime);
        // item set
        _this.itemSet = new ItemSet(_this.body, _this.options);
        _this.components.push(_this.itemSet);
        _this.itemsData = null; // DataSet
        _this.groupsData = null; // DataSet
        function emit(eventName, event1) {
            if (!me.hasListeners(eventName)) return;
            me.emit(eventName, me.getEventProperties(event1));
        }
        _this.dom.root.onclick = function(event1) {
            emit("click", event1);
        };
        _this.dom.root.ondblclick = function(event1) {
            emit("doubleClick", event1);
        };
        _this.dom.root.oncontextmenu = function(event1) {
            emit("contextmenu", event1);
        };
        _this.dom.root.onmouseover = function(event1) {
            emit("mouseOver", event1);
        };
        if (window.PointerEvent) {
            _this.dom.root.onpointerdown = function(event1) {
                emit("mouseDown", event1);
            };
            _this.dom.root.onpointermove = function(event1) {
                emit("mouseMove", event1);
            };
            _this.dom.root.onpointerup = function(event1) {
                emit("mouseUp", event1);
            };
        } else {
            _this.dom.root.onmousemove = function(event1) {
                emit("mouseMove", event1);
            };
            _this.dom.root.onmousedown = function(event1) {
                emit("mouseDown", event1);
            };
            _this.dom.root.onmouseup = function(event1) {
                emit("mouseUp", event1);
            };
        }
        //Single time autoscale/fit
        _this.initialFitDone = false;
        _this.on("changed", function() {
            if (me.itemsData == null) return;
            if (!me.initialFitDone && !me.options.rollingMode) {
                me.initialFitDone = true;
                if (me.options.start != undefined || me.options.end != undefined) {
                    if (me.options.start == undefined || me.options.end == undefined) var range = me.getItemRange();
                    var start = me.options.start != undefined ? me.options.start : range.min;
                    var end = me.options.end != undefined ? me.options.end : range.max;
                    me.setWindow(start, end, {
                        animation: false
                    });
                } else me.fit({
                    animation: false
                });
            }
            if (!me.initialDrawDone && (me.initialRangeChangeDone || !me.options.start && !me.options.end || me.options.rollingMode)) {
                me.initialDrawDone = true;
                me.itemSet.initialDrawDone = true;
                me.dom.root.style.visibility = "visible";
                me.dom.loadingScreen.parentNode.removeChild(me.dom.loadingScreen);
                if (me.options.onInitialDrawComplete) _setTimeout(function() {
                    return me.options.onInitialDrawComplete();
                }, 0);
            }
        });
        _this.on("destroyTimeline", function() {
            me.destroy();
        });
        // apply options
        if (options) _this.setOptions(options);
        _this.body.emitter.on("fit", function(args) {
            _this._onFit(args);
            _this.redraw();
        });
        // IMPORTANT: THIS HAPPENS BEFORE SET ITEMS!
        if (groups) _this.setGroups(groups);
        // create itemset
        if (items) _this.setItems(items);
        // draw for the first time
        _this._redraw();
        return _this;
    }
    /**
   * Load a configurator
   * @return {Object}
   * @private
   */ _createClass(Timeline, [
        {
            key: "_createConfigurator",
            value: function _createConfigurator() {
                return new Configurator(this, this.dom.container, configureOptions$1);
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                this.itemSet && this.itemSet.markDirty({
                    refreshItems: true
                });
                this._redraw();
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                // validate options
                var errorFound = Validator.validate(options, allOptions$1);
                if (errorFound === true) console.log("%cErrors have been found in the supplied options object.", printStyle);
                Core.prototype.setOptions.call(this, options);
                if ("type" in options) {
                    if (options.type !== this.options.type) {
                        this.options.type = options.type;
                        // force recreation of all items
                        var itemsData = this.itemsData;
                        if (itemsData) {
                            var selection = this.getSelection();
                            this.setItems(null); // remove all
                            this.setItems(itemsData.rawDS); // add all
                            this.setSelection(selection); // restore selection
                        }
                    }
                }
            }
        },
        {
            key: "setItems",
            value: function setItems(items) {
                this.itemsDone = false;
                // convert to type DataSet when needed
                var newDataSet;
                if (!items) newDataSet = null;
                else if (isDataViewLike(items)) newDataSet = typeCoerceDataSet(items);
                else // turn an array into a dataset
                newDataSet = typeCoerceDataSet(new DataSet(items));
                // set items
                if (this.itemsData) // stop maintaining a coerced version of the old data set
                this.itemsData.dispose();
                this.itemsData = newDataSet;
                this.itemSet && this.itemSet.setItems(newDataSet != null ? newDataSet.rawDS : null);
            }
        },
        {
            key: "setGroups",
            value: function setGroups(groups) {
                // convert to type DataSet when needed
                var newDataSet;
                var filter = function filter(group) {
                    return group.visible !== false;
                };
                if (!groups) newDataSet = null;
                else {
                    // If groups is array, turn to DataSet & build dataview from that
                    if (_Array$isArray(groups)) groups = new DataSet(groups);
                    newDataSet = new DataView(groups, {
                        filter: filter
                    });
                }
                // This looks weird but it's necessary to prevent memory leaks.
                //
                // The problem is that the DataView will exist as long as the DataSet it's
                // connected to. This will force it to swap the groups DataSet for it's own
                // DataSet. In this arrangement it will become unreferenced from the outside
                // and garbage collected.
                //
                // IMPORTANT NOTE: If `this.groupsData` is a DataView was created in this
                // method. Even if the original is a DataView already a new one has been
                // created and assigned to `this.groupsData`. In case this changes in the
                // future it will be necessary to rework this!!!!
                if (this.groupsData != null && typeof this.groupsData.setData === "function") this.groupsData.setData(null);
                this.groupsData = newDataSet;
                this.itemSet.setGroups(newDataSet);
            }
        },
        {
            key: "setData",
            value: function setData(data) {
                if (data && data.groups) this.setGroups(data.groups);
                if (data && data.items) this.setItems(data.items);
            }
        },
        {
            key: "setSelection",
            value: function setSelection(ids, options) {
                this.itemSet && this.itemSet.setSelection(ids);
                if (options && options.focus) this.focus(ids, options);
            }
        },
        {
            key: "getSelection",
            value: function getSelection() {
                return this.itemSet && this.itemSet.getSelection() || [];
            }
        },
        {
            key: "focus",
            value: function focus(id, options) {
                if (!this.itemsData || id == undefined) return;
                var ids = _Array$isArray(id) ? id : [
                    id
                ];
                // get the specified item(s)
                var itemsData = this.itemsData.get(ids);
                // calculate minimum start and maximum end of specified items
                var start = null;
                var end = null;
                _forEachInstanceProperty(itemsData).call(itemsData, function(itemData) {
                    var s = itemData.start.valueOf();
                    var e = "end" in itemData ? itemData.end.valueOf() : itemData.start.valueOf();
                    if (start === null || s < start) start = s;
                    if (end === null || e > end) end = e;
                });
                if (start !== null && end !== null) {
                    var me = this;
                    // Use the first item for the vertical focus
                    var item = this.itemSet.items[ids[0]];
                    var startPos = this._getScrollTop() * -1;
                    var initialVerticalScroll = null;
                    // Setup a handler for each frame of the vertical scroll
                    var verticalAnimationFrame = function verticalAnimationFrame(ease, willDraw, done) {
                        var verticalScroll = getItemVerticalScroll(me, item);
                        if (verticalScroll === false) return; // We don't need to scroll, so do nothing
                        if (!initialVerticalScroll) initialVerticalScroll = verticalScroll;
                        if (initialVerticalScroll.itemTop == verticalScroll.itemTop && !initialVerticalScroll.shouldScroll) return; // We don't need to scroll, so do nothing
                        else if (initialVerticalScroll.itemTop != verticalScroll.itemTop && verticalScroll.shouldScroll) {
                            // The redraw shifted elements, so reset the animation to correct
                            initialVerticalScroll = verticalScroll;
                            startPos = me._getScrollTop() * -1;
                        }
                        var from = startPos;
                        var to = initialVerticalScroll.scrollOffset;
                        var scrollTop = done ? to : from + (to - from) * ease;
                        me._setScrollTop(-scrollTop);
                        if (!willDraw) me._redraw();
                    };
                    // Enforces the final vertical scroll position
                    var setFinalVerticalPosition = function setFinalVerticalPosition() {
                        var finalVerticalScroll = getItemVerticalScroll(me, item);
                        if (finalVerticalScroll.shouldScroll && finalVerticalScroll.itemTop != initialVerticalScroll.itemTop) {
                            me._setScrollTop(-finalVerticalScroll.scrollOffset);
                            me._redraw();
                        }
                    };
                    // Perform one last check at the end to make sure the final vertical
                    // position is correct
                    var finalVerticalCallback = function finalVerticalCallback() {
                        // Double check we ended at the proper scroll position
                        setFinalVerticalPosition();
                        // Let the redraw settle and finalize the position.
                        _setTimeout(setFinalVerticalPosition, 100);
                    };
                    // calculate the new middle and interval for the window
                    var zoom = options && options.zoom !== undefined ? options.zoom : true;
                    var middle = (start + end) / 2;
                    var interval = zoom ? (end - start) * 1.1 : Math.max(this.range.end - this.range.start, (end - start) * 1.1);
                    var animation = options && options.animation !== undefined ? options.animation : true;
                    if (!animation) // We aren't animating so set a default so that the final callback forces the vertical location
                    initialVerticalScroll = {
                        shouldScroll: false,
                        scrollOffset: -1,
                        itemTop: -1
                    };
                    this.range.setRange(middle - interval / 2, middle + interval / 2, {
                        animation: animation
                    }, finalVerticalCallback, verticalAnimationFrame);
                }
            }
        },
        {
            key: "fit",
            value: function fit(options, callback) {
                var animation = options && options.animation !== undefined ? options.animation : true;
                var range;
                if (this.itemsData.length === 1 && this.itemsData.get()[0].end === undefined) {
                    // a single item -> don't fit, just show a range around the item from -4 to +3 days
                    range = this.getDataRange();
                    this.moveTo(range.min.valueOf(), {
                        animation: animation
                    }, callback);
                } else {
                    // exactly fit the items (plus a small margin)
                    range = this.getItemRange();
                    this.range.setRange(range.min, range.max, {
                        animation: animation
                    }, callback);
                }
            }
        },
        {
            key: "getItemRange",
            value: function getItemRange() {
                var _this2 = this;
                // get a rough approximation for the range based on the items start and end dates
                var range = this.getDataRange();
                var min = range.min !== null ? range.min.valueOf() : null;
                var max = range.max !== null ? range.max.valueOf() : null;
                var minItem = null;
                var maxItem = null;
                if (min != null && max != null) {
                    var interval = max - min; // ms
                    if (interval <= 0) interval = 10;
                    var factor = interval / this.props.center.width;
                    var redrawQueue = {};
                    var redrawQueueLength = 0;
                    // collect redraw functions
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.itemSet.items, function(item, key) {
                        if (item.groupShowing) {
                            var returnQueue = true;
                            redrawQueue[key] = item.redraw(returnQueue);
                            redrawQueueLength = redrawQueue[key].length;
                        }
                    });
                    var needRedraw = redrawQueueLength > 0;
                    if (needRedraw) {
                        var _loop = function _loop(i1) {
                            _forEachInstanceProperty(availableUtils).call(availableUtils, redrawQueue, function(fns) {
                                fns[i1]();
                            });
                        };
                        // redraw all regular items
                        for(var i1 = 0; i1 < redrawQueueLength; i1++)_loop(i1);
                    }
                    // calculate the date of the left side and right side of the items given
                    _forEachInstanceProperty(availableUtils).call(availableUtils, this.itemSet.items, function(item) {
                        var start = getStart(item);
                        var end = getEnd(item);
                        var startSide;
                        var endSide;
                        if (_this2.options.rtl) {
                            startSide = start - (item.getWidthRight() + 10) * factor;
                            endSide = end + (item.getWidthLeft() + 10) * factor;
                        } else {
                            startSide = start - (item.getWidthLeft() + 10) * factor;
                            endSide = end + (item.getWidthRight() + 10) * factor;
                        }
                        if (startSide < min) {
                            min = startSide;
                            minItem = item;
                        }
                        if (endSide > max) {
                            max = endSide;
                            maxItem = item;
                        }
                    });
                    if (minItem && maxItem) {
                        var lhs = minItem.getWidthLeft() + 10;
                        var rhs = maxItem.getWidthRight() + 10;
                        var delta = this.props.center.width - lhs - rhs; // px
                        if (delta > 0) {
                            if (this.options.rtl) {
                                min = getStart(minItem) - rhs * interval / delta; // ms
                                max = getEnd(maxItem) + lhs * interval / delta; // ms
                            } else {
                                min = getStart(minItem) - lhs * interval / delta; // ms
                                max = getEnd(maxItem) + rhs * interval / delta; // ms
                            }
                        }
                    }
                }
                return {
                    min: min != null ? new Date(min) : null,
                    max: max != null ? new Date(max) : null
                };
            }
        },
        {
            key: "getDataRange",
            value: function getDataRange() {
                var min = null;
                var max = null;
                if (this.itemsData) {
                    var _context9;
                    _forEachInstanceProperty(_context9 = this.itemsData).call(_context9, function(item) {
                        var start = availableUtils.convert(item.start, "Date").valueOf();
                        var end = availableUtils.convert(item.end != undefined ? item.end : item.start, "Date").valueOf();
                        if (min === null || start < min) min = start;
                        if (max === null || end > max) max = end;
                    });
                }
                return {
                    min: min != null ? new Date(min) : null,
                    max: max != null ? new Date(max) : null
                };
            }
        },
        {
            key: "getEventProperties",
            value: function getEventProperties(event1) {
                var clientX = event1.center ? event1.center.x : event1.clientX;
                var clientY = event1.center ? event1.center.y : event1.clientY;
                var centerContainerRect = this.dom.centerContainer.getBoundingClientRect();
                var x = this.options.rtl ? centerContainerRect.right - clientX : clientX - centerContainerRect.left;
                var y = clientY - centerContainerRect.top;
                var item = this.itemSet.itemFromTarget(event1);
                var group = this.itemSet.groupFromTarget(event1);
                var customTime = CustomTime.customTimeFromTarget(event1);
                var snap = this.itemSet.options.snap || null;
                var scale = this.body.util.getScale();
                var step = this.body.util.getStep();
                var time = this._toTime(x);
                var snappedTime = snap ? snap(time, scale, step) : time;
                var element = availableUtils.getTarget(event1);
                var what = null;
                if (item != null) what = "item";
                else if (customTime != null) what = "custom-time";
                else if (availableUtils.hasParent(element, this.timeAxis.dom.foreground)) what = "axis";
                else if (this.timeAxis2 && availableUtils.hasParent(element, this.timeAxis2.dom.foreground)) what = "axis";
                else if (availableUtils.hasParent(element, this.itemSet.dom.labelSet)) what = "group-label";
                else if (availableUtils.hasParent(element, this.currentTime.bar)) what = "current-time";
                else if (availableUtils.hasParent(element, this.dom.center)) what = "background";
                return {
                    event: event1,
                    item: item ? item.id : null,
                    isCluster: item ? !!item.isCluster : false,
                    items: item ? item.items || [] : null,
                    group: group ? group.groupId : null,
                    customTime: customTime ? customTime.options.id : null,
                    what: what,
                    pageX: event1.srcEvent ? event1.srcEvent.pageX : event1.pageX,
                    pageY: event1.srcEvent ? event1.srcEvent.pageY : event1.pageY,
                    x: x,
                    y: y,
                    time: time,
                    snappedTime: snappedTime
                };
            }
        },
        {
            key: "toggleRollingMode",
            value: function toggleRollingMode() {
                if (this.range.rolling) this.range.stopRolling();
                else {
                    if (this.options.rollingMode == undefined) this.setOptions(this.options);
                    this.range.startRolling();
                }
            }
        },
        {
            key: "_redraw",
            value: function _redraw() {
                Core.prototype._redraw.call(this);
            }
        },
        {
            key: "_onFit",
            value: function _onFit(args) {
                var start = args.start, end = args.end, animation = args.animation;
                if (!end) this.moveTo(start.valueOf(), {
                    animation: animation
                });
                else this.range.setRange(start, end, {
                    animation: animation
                });
            }
        }
    ]);
    return Timeline;
}(Core);
function getStart(item) {
    return availableUtils.convert(item.data.start, "Date").valueOf();
}
/**
 *
 * @param {timeline.Item} item
 * @returns {number}
 */ function getEnd(item) {
    var end = item.data.end != undefined ? item.data.end : item.data.start;
    return availableUtils.convert(end, "Date").valueOf();
}
/**
 * @param {vis.Timeline} timeline
 * @param {timeline.Item} item
 * @return {{shouldScroll: bool, scrollOffset: number, itemTop: number}}
 */ function getItemVerticalScroll(timeline, item) {
    if (!item.parent) // The item no longer exists, so ignore this focus.
    return false;
    var itemsetHeight = timeline.options.rtl ? timeline.props.rightContainer.height : timeline.props.leftContainer.height;
    var contentHeight = timeline.props.center.height;
    var group = item.parent;
    var offset = group.top;
    var shouldScroll = true;
    var orientation = timeline.timeAxis.options.orientation.axis;
    var itemTop = function itemTop() {
        if (orientation == "bottom") return group.height - item.top - item.height;
        else return item.top;
    };
    var currentScrollHeight = timeline._getScrollTop() * -1;
    var targetOffset = offset + itemTop();
    var height = item.height;
    if (targetOffset < currentScrollHeight) {
        if (offset + itemsetHeight <= offset + itemTop() + height) offset += itemTop() - timeline.itemSet.options.margin.item.vertical;
    } else if (targetOffset + height > currentScrollHeight + itemsetHeight) offset += itemTop() + height - itemsetHeight + timeline.itemSet.options.margin.item.vertical;
    else shouldScroll = false;
    offset = Math.min(offset, contentHeight - itemsetHeight);
    return {
        shouldScroll: shouldScroll,
        scrollOffset: offset,
        itemTop: targetOffset
    };
}
/** DataScale */ var DataScale = /*#__PURE__*/ function() {
    /**
   *
   * @param {number} start
   * @param {number} end
   * @param {boolean} autoScaleStart
   * @param {boolean} autoScaleEnd
   * @param {number} containerHeight
   * @param {number} majorCharHeight
   * @param {boolean} zeroAlign
   * @param {function} formattingFunction
   * @constructor DataScale
   */ function DataScale(start, end, autoScaleStart, autoScaleEnd, containerHeight, majorCharHeight) {
        var zeroAlign = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
        var formattingFunction = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
        _classCallCheck(this, DataScale);
        this.majorSteps = [
            1,
            2,
            5,
            10
        ];
        this.minorSteps = [
            0.25,
            0.5,
            1,
            2
        ];
        this.customLines = null;
        this.containerHeight = containerHeight;
        this.majorCharHeight = majorCharHeight;
        this._start = start;
        this._end = end;
        this.scale = 1;
        this.minorStepIdx = -1;
        this.magnitudefactor = 1;
        this.determineScale();
        this.zeroAlign = zeroAlign;
        this.autoScaleStart = autoScaleStart;
        this.autoScaleEnd = autoScaleEnd;
        this.formattingFunction = formattingFunction;
        if (autoScaleStart || autoScaleEnd) {
            var me = this;
            var roundToMinor = function roundToMinor(value) {
                var rounded = value - value % (me.magnitudefactor * me.minorSteps[me.minorStepIdx]);
                if (value % (me.magnitudefactor * me.minorSteps[me.minorStepIdx]) > 0.5 * (me.magnitudefactor * me.minorSteps[me.minorStepIdx])) return rounded + me.magnitudefactor * me.minorSteps[me.minorStepIdx];
                else return rounded;
            };
            if (autoScaleStart) {
                this._start -= this.magnitudefactor * 2 * this.minorSteps[this.minorStepIdx];
                this._start = roundToMinor(this._start);
            }
            if (autoScaleEnd) {
                this._end += this.magnitudefactor * this.minorSteps[this.minorStepIdx];
                this._end = roundToMinor(this._end);
            }
            this.determineScale();
        }
    }
    /**
   * set chart height
   * @param {number} majorCharHeight 
   */ _createClass(DataScale, [
        {
            key: "setCharHeight",
            value: function setCharHeight(majorCharHeight) {
                this.majorCharHeight = majorCharHeight;
            }
        },
        {
            key: "setHeight",
            value: function setHeight(containerHeight) {
                this.containerHeight = containerHeight;
            }
        },
        {
            key: "determineScale",
            value: function determineScale() {
                var range = this._end - this._start;
                this.scale = this.containerHeight / range;
                var minimumStepValue = this.majorCharHeight / this.scale;
                var orderOfMagnitude = range > 0 ? Math.round(Math.log(range) / Math.LN10) : 0;
                this.minorStepIdx = -1;
                this.magnitudefactor = Math.pow(10, orderOfMagnitude);
                var start = 0;
                if (orderOfMagnitude < 0) start = orderOfMagnitude;
                var solutionFound = false;
                for(var l = start; Math.abs(l) <= Math.abs(orderOfMagnitude); l++){
                    this.magnitudefactor = Math.pow(10, l);
                    for(var j = 0; j < this.minorSteps.length; j++){
                        var stepSize = this.magnitudefactor * this.minorSteps[j];
                        if (stepSize >= minimumStepValue) {
                            solutionFound = true;
                            this.minorStepIdx = j;
                            break;
                        }
                    }
                    if (solutionFound === true) break;
                }
            }
        },
        {
            key: "is_major",
            value: function is_major(value) {
                return value % (this.magnitudefactor * this.majorSteps[this.minorStepIdx]) === 0;
            }
        },
        {
            key: "getStep",
            value: function getStep() {
                return this.magnitudefactor * this.minorSteps[this.minorStepIdx];
            }
        },
        {
            key: "getFirstMajor",
            value: function getFirstMajor() {
                var majorStep = this.magnitudefactor * this.majorSteps[this.minorStepIdx];
                return this.convertValue(this._start + (majorStep - this._start % majorStep) % majorStep);
            }
        },
        {
            key: "formatValue",
            value: function formatValue(current) {
                var returnValue = current.toPrecision(5);
                if (typeof this.formattingFunction === "function") returnValue = this.formattingFunction(current);
                if (typeof returnValue === "number") return "".concat(returnValue);
                else if (typeof returnValue === "string") return returnValue;
                else return current.toPrecision(5);
            }
        },
        {
            key: "getLines",
            value: function getLines() {
                var lines = [];
                var step = this.getStep();
                var bottomOffset = (step - this._start % step) % step;
                for(var i1 = this._start + bottomOffset; this._end - i1 > 0.00001; i1 += step)if (i1 != this._start) //Skip the bottom line
                lines.push({
                    major: this.is_major(i1),
                    y: this.convertValue(i1),
                    val: this.formatValue(i1)
                });
                return lines;
            }
        },
        {
            key: "followScale",
            value: function followScale(other) {
                var oldStepIdx = this.minorStepIdx;
                var oldStart = this._start;
                var oldEnd = this._end;
                var me = this;
                var increaseMagnitude = function increaseMagnitude() {
                    me.magnitudefactor *= 2;
                };
                var decreaseMagnitude = function decreaseMagnitude() {
                    me.magnitudefactor /= 2;
                };
                if (other.minorStepIdx <= 1 && this.minorStepIdx <= 1 || other.minorStepIdx > 1 && this.minorStepIdx > 1) ;
                else if (other.minorStepIdx < this.minorStepIdx) {
                    //I'm 5, they are 4 per major.
                    this.minorStepIdx = 1;
                    if (oldStepIdx == 2) increaseMagnitude();
                    else {
                        increaseMagnitude();
                        increaseMagnitude();
                    }
                } else {
                    //I'm 4, they are 5 per major
                    this.minorStepIdx = 2;
                    if (oldStepIdx == 1) decreaseMagnitude();
                    else {
                        decreaseMagnitude();
                        decreaseMagnitude();
                    }
                }
                //Get masters stats:
                var otherZero = other.convertValue(0);
                var otherStep = other.getStep() * other.scale;
                var done = false;
                var count = 0;
                //Loop until magnitude is correct for given constrains.
                while(!done && count++ < 5){
                    //Get my stats:
                    this.scale = otherStep / (this.minorSteps[this.minorStepIdx] * this.magnitudefactor);
                    var newRange = this.containerHeight / this.scale;
                    //For the case the magnitudefactor has changed:
                    this._start = oldStart;
                    this._end = this._start + newRange;
                    var myOriginalZero = this._end * this.scale;
                    var majorStep = this.magnitudefactor * this.majorSteps[this.minorStepIdx];
                    var majorOffset = this.getFirstMajor() - other.getFirstMajor();
                    if (this.zeroAlign) {
                        var zeroOffset = otherZero - myOriginalZero;
                        this._end += zeroOffset / this.scale;
                        this._start = this._end - newRange;
                    } else if (!this.autoScaleStart) {
                        this._start += majorStep - majorOffset / this.scale;
                        this._end = this._start + newRange;
                    } else {
                        this._start -= majorOffset / this.scale;
                        this._end = this._start + newRange;
                    }
                    if (!this.autoScaleEnd && this._end > oldEnd + 0.00001) {
                        //Need to decrease magnitude to prevent scale overshoot! (end)
                        decreaseMagnitude();
                        done = false;
                        continue;
                    }
                    if (!this.autoScaleStart && this._start < oldStart - 0.00001) {
                        if (this.zeroAlign && oldStart >= 0) console.warn("Can't adhere to given 'min' range, due to zeroalign");
                        else {
                            //Need to decrease magnitude to prevent scale overshoot! (start)
                            decreaseMagnitude();
                            done = false;
                            continue;
                        }
                    }
                    if (this.autoScaleStart && this.autoScaleEnd && newRange < oldEnd - oldStart) {
                        increaseMagnitude();
                        done = false;
                        continue;
                    }
                    done = true;
                }
            }
        },
        {
            key: "convertValue",
            value: function convertValue(value) {
                return this.containerHeight - (value - this._start) * this.scale;
            }
        },
        {
            key: "screenToValue",
            value: function screenToValue(pixels) {
                return (this.containerHeight - pixels) / this.scale + this._start;
            }
        }
    ]);
    return DataScale;
}();
var css_248z = "\n.vis-panel.vis-background.vis-horizontal .vis-grid.vis-horizontal {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  border-bottom: 1px solid;\n}\n\n.vis-panel.vis-background.vis-horizontal .vis-grid.vis-minor {\n  border-color: #e5e5e5;\n}\n\n.vis-panel.vis-background.vis-horizontal .vis-grid.vis-major {\n  border-color: #bfbfbf;\n}\n\n\n.vis-data-axis .vis-y-axis.vis-major {\n  width: 100%;\n  position: absolute;\n  color: #4d4d4d;\n  white-space: nowrap;\n}\n\n.vis-data-axis .vis-y-axis.vis-major.vis-measure {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  visibility: hidden;\n  width: auto;\n}\n\n\n.vis-data-axis .vis-y-axis.vis-minor {\n  position: absolute;\n  width: 100%;\n  color: #bebebe;\n  white-space: nowrap;\n}\n\n.vis-data-axis .vis-y-axis.vis-minor.vis-measure {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  visibility: hidden;\n  width: auto;\n}\n\n.vis-data-axis .vis-y-axis.vis-title {\n  position: absolute;\n  color: #4d4d4d;\n  white-space: nowrap;\n  bottom: 20px;\n  text-align: center;\n}\n\n.vis-data-axis .vis-y-axis.vis-title.vis-measure {\n  padding: 0;\n  margin: 0;\n  visibility: hidden;\n  width: auto;\n}\n\n.vis-data-axis .vis-y-axis.vis-title.vis-left {\n  bottom: 0;\n  -webkit-transform-origin: left top;\n  -moz-transform-origin: left top;\n  -ms-transform-origin: left top;\n  -o-transform-origin: left top;\n  transform-origin: left bottom;\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n\n.vis-data-axis .vis-y-axis.vis-title.vis-right {\n  bottom: 0;\n  -webkit-transform-origin: right bottom;\n  -moz-transform-origin: right bottom;\n  -ms-transform-origin: right bottom;\n  -o-transform-origin: right bottom;\n  transform-origin: right bottom;\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.vis-legend {\n  background-color: rgba(247, 252, 255, 0.65);\n  padding: 5px;\n  border: 1px solid #b3b3b3;\n  box-shadow: 2px 2px 10px rgba(154, 154, 154, 0.55);\n}\n\n.vis-legend-text {\n  /*font-size: 10px;*/\n  white-space: nowrap;\n  display: inline-block\n}";
styleInject(css_248z);
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"];
    if (!it) {
        if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i1 = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i1 >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i1++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return _Array$from$1(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = _Reflect$construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
    if (_Reflect$construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/** A horizontal time axis */ var DataAxis = /*#__PURE__*/ function(_Component) {
    _inherits(DataAxis, _Component);
    var _super = _createSuper(DataAxis);
    /**
  * @param {Object} body
  * @param {Object} [options]        See DataAxis.setOptions for the available
  *                                  options.
  * @param {SVGElement} svg
  * @param {timeline.LineGraph.options} linegraphOptions
  * @constructor DataAxis
  * @extends Component
  */ function DataAxis(body, options, svg, linegraphOptions) {
        var _this;
        _classCallCheck(this, DataAxis);
        _this = _super.call(this);
        _this.id = v4();
        _this.body = body;
        _this.defaultOptions = {
            orientation: "left",
            // supported: 'left', 'right'
            showMinorLabels: true,
            showMajorLabels: true,
            showWeekScale: false,
            icons: false,
            majorLinesOffset: 7,
            minorLinesOffset: 4,
            labelOffsetX: 10,
            labelOffsetY: 2,
            iconWidth: 20,
            width: "40px",
            visible: true,
            alignZeros: true,
            left: {
                range: {
                    min: undefined,
                    max: undefined
                },
                format: function format(value) {
                    return "".concat(_parseFloat$1(value.toPrecision(3)));
                },
                title: {
                    text: undefined,
                    style: undefined
                }
            },
            right: {
                range: {
                    min: undefined,
                    max: undefined
                },
                format: function format(value) {
                    return "".concat(_parseFloat$1(value.toPrecision(3)));
                },
                title: {
                    text: undefined,
                    style: undefined
                }
            }
        };
        _this.linegraphOptions = linegraphOptions;
        _this.linegraphSVG = svg;
        _this.props = {};
        _this.DOMelements = {
            // dynamic elements
            lines: {},
            labels: {},
            title: {}
        };
        _this.dom = {};
        _this.scale = undefined;
        _this.range = {
            start: 0,
            end: 0
        };
        _this.options = availableUtils.extend({}, _this.defaultOptions);
        _this.conversionFactor = 1;
        _this.setOptions(options);
        _this.width = Number("".concat(_this.options.width).replace("px", ""));
        _this.minWidth = _this.width;
        _this.height = _this.linegraphSVG.getBoundingClientRect().height;
        _this.hidden = false;
        _this.stepPixels = 25;
        _this.zeroCrossing = -1;
        _this.amountOfSteps = -1;
        _this.lineOffset = 0;
        _this.master = true;
        _this.masterAxis = null;
        _this.svgElements = {};
        _this.iconsRemoved = false;
        _this.groups = {};
        _this.amountOfGroups = 0;
        // create the HTML DOM
        _this._create();
        if (_this.scale == undefined) _this._redrawLabels();
        _this.framework = {
            svg: _this.svg,
            svgElements: _this.svgElements,
            options: _this.options,
            groups: _this.groups
        };
        var me = _assertThisInitialized(_this);
        _this.body.emitter.on("verticalDrag", function() {
            me.dom.lineContainer.style.top = "".concat(me.body.domProps.scrollTop, "px");
        });
        return _this;
    }
    /**
   * Adds group to data axis
   * @param {string} label 
   * @param {object} graphOptions
   */ _createClass(DataAxis, [
        {
            key: "addGroup",
            value: function addGroup(label, graphOptions) {
                if (!this.groups.hasOwnProperty(label)) this.groups[label] = graphOptions;
                this.amountOfGroups += 1;
            }
        },
        {
            key: "updateGroup",
            value: function updateGroup(label, graphOptions) {
                if (!this.groups.hasOwnProperty(label)) this.amountOfGroups += 1;
                this.groups[label] = graphOptions;
            }
        },
        {
            key: "removeGroup",
            value: function removeGroup(label) {
                if (this.groups.hasOwnProperty(label)) {
                    delete this.groups[label];
                    this.amountOfGroups -= 1;
                }
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options) {
                    var redraw = false;
                    if (this.options.orientation != options.orientation && options.orientation !== undefined) redraw = true;
                    var fields = [
                        "orientation",
                        "showMinorLabels",
                        "showMajorLabels",
                        "icons",
                        "majorLinesOffset",
                        "minorLinesOffset",
                        "labelOffsetX",
                        "labelOffsetY",
                        "iconWidth",
                        "width",
                        "visible",
                        "left",
                        "right",
                        "alignZeros"
                    ];
                    availableUtils.selectiveDeepExtend(fields, this.options, options);
                    this.minWidth = Number("".concat(this.options.width).replace("px", ""));
                    if (redraw === true && this.dom.frame) {
                        this.hide();
                        this.show();
                    }
                }
            }
        },
        {
            key: "_create",
            value: function _create() {
                this.dom.frame = document.createElement("div");
                this.dom.frame.style.width = this.options.width;
                this.dom.frame.style.height = this.height;
                this.dom.lineContainer = document.createElement("div");
                this.dom.lineContainer.style.width = "100%";
                this.dom.lineContainer.style.height = this.height;
                this.dom.lineContainer.style.position = "relative";
                this.dom.lineContainer.style.visibility = "visible";
                this.dom.lineContainer.style.display = "block";
                // create svg element for graph drawing.
                this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                this.svg.style.position = "absolute";
                this.svg.style.top = "0px";
                this.svg.style.height = "100%";
                this.svg.style.width = "100%";
                this.svg.style.display = "block";
                this.dom.frame.appendChild(this.svg);
            }
        },
        {
            key: "_redrawGroupIcons",
            value: function _redrawGroupIcons() {
                prepareElements(this.svgElements);
                var x;
                var iconWidth = this.options.iconWidth;
                var iconHeight = 15;
                var iconOffset = 4;
                var y = iconOffset + 0.5 * iconHeight;
                if (this.options.orientation === "left") x = iconOffset;
                else x = this.width - iconWidth - iconOffset;
                var groupArray = _Object$keys(this.groups);
                _sortInstanceProperty(groupArray).call(groupArray, function(a, b) {
                    return a < b ? -1 : 1;
                });
                var _iterator = _createForOfIteratorHelper(groupArray), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var groupId = _step.value;
                        if (this.groups[groupId].visible === true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] === true)) {
                            this.groups[groupId].getLegend(iconWidth, iconHeight, this.framework, x, y);
                            y += iconHeight + iconOffset;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                cleanupElements(this.svgElements);
                this.iconsRemoved = false;
            }
        },
        {
            key: "_cleanupIcons",
            value: function _cleanupIcons() {
                if (this.iconsRemoved === false) {
                    prepareElements(this.svgElements);
                    cleanupElements(this.svgElements);
                    this.iconsRemoved = true;
                }
            }
        },
        {
            key: "show",
            value: function show() {
                this.hidden = false;
                if (!this.dom.frame.parentNode) {
                    if (this.options.orientation === "left") this.body.dom.left.appendChild(this.dom.frame);
                    else this.body.dom.right.appendChild(this.dom.frame);
                }
                if (!this.dom.lineContainer.parentNode) this.body.dom.backgroundHorizontal.appendChild(this.dom.lineContainer);
                this.dom.lineContainer.style.display = "block";
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.hidden = true;
                if (this.dom.frame.parentNode) this.dom.frame.parentNode.removeChild(this.dom.frame);
                this.dom.lineContainer.style.display = "none";
            }
        },
        {
            key: "setRange",
            value: function setRange(start, end) {
                this.range.start = start;
                this.range.end = end;
            }
        },
        {
            key: "redraw",
            value: function redraw() {
                var resized = false;
                var activeGroups = 0;
                // Make sure the line container adheres to the vertical scrolling.
                this.dom.lineContainer.style.top = "".concat(this.body.domProps.scrollTop, "px");
                for(var groupId in this.groups){
                    if (this.groups.hasOwnProperty(groupId)) {
                        if (this.groups[groupId].visible === true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] === true)) activeGroups++;
                    }
                }
                if (this.amountOfGroups === 0 || activeGroups === 0) this.hide();
                else {
                    this.show();
                    this.height = Number(this.linegraphSVG.style.height.replace("px", ""));
                    // svg offsetheight did not work in firefox and explorer...
                    this.dom.lineContainer.style.height = "".concat(this.height, "px");
                    this.width = this.options.visible === true ? Number("".concat(this.options.width).replace("px", "")) : 0;
                    var props = this.props;
                    var frame = this.dom.frame;
                    // update classname
                    frame.className = "vis-data-axis";
                    // calculate character width and height
                    this._calculateCharSize();
                    var orientation = this.options.orientation;
                    var showMinorLabels = this.options.showMinorLabels;
                    var showMajorLabels = this.options.showMajorLabels;
                    var backgroundHorizontalOffsetWidth = this.body.dom.backgroundHorizontal.offsetWidth;
                    // determine the width and height of the elements for the axis
                    props.minorLabelHeight = showMinorLabels ? props.minorCharHeight : 0;
                    props.majorLabelHeight = showMajorLabels ? props.majorCharHeight : 0;
                    props.minorLineWidth = backgroundHorizontalOffsetWidth - this.lineOffset - this.width + 2 * this.options.minorLinesOffset;
                    props.minorLineHeight = 1;
                    props.majorLineWidth = backgroundHorizontalOffsetWidth - this.lineOffset - this.width + 2 * this.options.majorLinesOffset;
                    props.majorLineHeight = 1;
                    //  take frame offline while updating (is almost twice as fast)
                    if (orientation === "left") {
                        frame.style.top = "0";
                        frame.style.left = "0";
                        frame.style.bottom = "";
                        frame.style.width = "".concat(this.width, "px");
                        frame.style.height = "".concat(this.height, "px");
                        this.props.width = this.body.domProps.left.width;
                        this.props.height = this.body.domProps.left.height;
                    } else {
                        // right
                        frame.style.top = "";
                        frame.style.bottom = "0";
                        frame.style.left = "0";
                        frame.style.width = "".concat(this.width, "px");
                        frame.style.height = "".concat(this.height, "px");
                        this.props.width = this.body.domProps.right.width;
                        this.props.height = this.body.domProps.right.height;
                    }
                    resized = this._redrawLabels();
                    resized = this._isResized() || resized;
                    if (this.options.icons === true) this._redrawGroupIcons();
                    else this._cleanupIcons();
                    this._redrawTitle(orientation);
                }
                return resized;
            }
        },
        {
            key: "_redrawLabels",
            value: function _redrawLabels() {
                var _this2 = this;
                var resized = false;
                prepareElements(this.DOMelements.lines);
                prepareElements(this.DOMelements.labels);
                var orientation = this.options["orientation"];
                var customRange = this.options[orientation].range != undefined ? this.options[orientation].range : {};
                //Override range with manual options:
                var autoScaleEnd = true;
                if (customRange.max != undefined) {
                    this.range.end = customRange.max;
                    autoScaleEnd = false;
                }
                var autoScaleStart = true;
                if (customRange.min != undefined) {
                    this.range.start = customRange.min;
                    autoScaleStart = false;
                }
                this.scale = new DataScale(this.range.start, this.range.end, autoScaleStart, autoScaleEnd, this.dom.frame.offsetHeight, this.props.majorCharHeight, this.options.alignZeros, this.options[orientation].format);
                if (this.master === false && this.masterAxis != undefined) {
                    this.scale.followScale(this.masterAxis.scale);
                    this.dom.lineContainer.style.display = "none";
                } else this.dom.lineContainer.style.display = "block";
                //Is updated in side-effect of _redrawLabel():
                this.maxLabelSize = 0;
                var lines = this.scale.getLines();
                _forEachInstanceProperty(lines).call(lines, function(line) {
                    var y = line.y;
                    var isMajor = line.major;
                    if (_this2.options["showMinorLabels"] && isMajor === false) _this2._redrawLabel(y - 2, line.val, orientation, "vis-y-axis vis-minor", _this2.props.minorCharHeight);
                    if (isMajor) {
                        if (y >= 0) _this2._redrawLabel(y - 2, line.val, orientation, "vis-y-axis vis-major", _this2.props.majorCharHeight);
                    }
                    if (_this2.master === true) {
                        if (isMajor) _this2._redrawLine(y, orientation, "vis-grid vis-horizontal vis-major", _this2.options.majorLinesOffset, _this2.props.majorLineWidth);
                        else _this2._redrawLine(y, orientation, "vis-grid vis-horizontal vis-minor", _this2.options.minorLinesOffset, _this2.props.minorLineWidth);
                    }
                });
                // Note that title is rotated, so we're using the height, not width!
                var titleWidth = 0;
                if (this.options[orientation].title !== undefined && this.options[orientation].title.text !== undefined) titleWidth = this.props.titleCharHeight;
                var offset = this.options.icons === true ? Math.max(this.options.iconWidth, titleWidth) + this.options.labelOffsetX + 15 : titleWidth + this.options.labelOffsetX + 15;
                // this will resize the yAxis to accommodate the labels.
                if (this.maxLabelSize > this.width - offset && this.options.visible === true) {
                    this.width = this.maxLabelSize + offset;
                    this.options.width = "".concat(this.width, "px");
                    cleanupElements(this.DOMelements.lines);
                    cleanupElements(this.DOMelements.labels);
                    this.redraw();
                    resized = true;
                } else if (this.maxLabelSize < this.width - offset && this.options.visible === true && this.width > this.minWidth) {
                    this.width = Math.max(this.minWidth, this.maxLabelSize + offset);
                    this.options.width = "".concat(this.width, "px");
                    cleanupElements(this.DOMelements.lines);
                    cleanupElements(this.DOMelements.labels);
                    this.redraw();
                    resized = true;
                } else {
                    cleanupElements(this.DOMelements.lines);
                    cleanupElements(this.DOMelements.labels);
                    resized = false;
                }
                return resized;
            }
        },
        {
            key: "convertValue",
            value: function convertValue(value) {
                return this.scale.convertValue(value);
            }
        },
        {
            key: "screenToValue",
            value: function screenToValue(x) {
                return this.scale.screenToValue(x);
            }
        },
        {
            key: "_redrawLabel",
            value: function _redrawLabel(y, text, orientation, className, characterHeight) {
                // reuse redundant label
                var label = getDOMElement("div", this.DOMelements.labels, this.dom.frame); //this.dom.redundant.labels.shift();
                label.className = className;
                label.innerHTML = availableUtils.xss(text);
                if (orientation === "left") {
                    label.style.left = "-".concat(this.options.labelOffsetX, "px");
                    label.style.textAlign = "right";
                } else {
                    label.style.right = "-".concat(this.options.labelOffsetX, "px");
                    label.style.textAlign = "left";
                }
                label.style.top = "".concat(y - 0.5 * characterHeight + this.options.labelOffsetY, "px");
                text += "";
                var largestWidth = Math.max(this.props.majorCharWidth, this.props.minorCharWidth);
                if (this.maxLabelSize < text.length * largestWidth) this.maxLabelSize = text.length * largestWidth;
            }
        },
        {
            key: "_redrawLine",
            value: function _redrawLine(y, orientation, className, offset, width) {
                if (this.master === true) {
                    var line = getDOMElement("div", this.DOMelements.lines, this.dom.lineContainer); //this.dom.redundant.lines.shift();
                    line.className = className;
                    line.innerHTML = "";
                    if (orientation === "left") line.style.left = "".concat(this.width - offset, "px");
                    else line.style.right = "".concat(this.width - offset, "px");
                    line.style.width = "".concat(width, "px");
                    line.style.top = "".concat(y, "px");
                }
            }
        },
        {
            key: "_redrawTitle",
            value: function _redrawTitle(orientation) {
                prepareElements(this.DOMelements.title);
                // Check if the title is defined for this axes
                if (this.options[orientation].title !== undefined && this.options[orientation].title.text !== undefined) {
                    var title = getDOMElement("div", this.DOMelements.title, this.dom.frame);
                    title.className = "vis-y-axis vis-title vis-".concat(orientation);
                    title.innerHTML = availableUtils.xss(this.options[orientation].title.text);
                    // Add style - if provided
                    if (this.options[orientation].title.style !== undefined) availableUtils.addCssText(title, this.options[orientation].title.style);
                    if (orientation === "left") title.style.left = "".concat(this.props.titleCharHeight, "px");
                    else title.style.right = "".concat(this.props.titleCharHeight, "px");
                    title.style.width = "".concat(this.height, "px");
                }
                // we need to clean up in case we did not use all elements.
                cleanupElements(this.DOMelements.title);
            }
        },
        {
            key: "_calculateCharSize",
            value: function _calculateCharSize() {
                // determine the char width and height on the minor axis
                if (!("minorCharHeight" in this.props)) {
                    var textMinor = document.createTextNode("0");
                    var measureCharMinor = document.createElement("div");
                    measureCharMinor.className = "vis-y-axis vis-minor vis-measure";
                    measureCharMinor.appendChild(textMinor);
                    this.dom.frame.appendChild(measureCharMinor);
                    this.props.minorCharHeight = measureCharMinor.clientHeight;
                    this.props.minorCharWidth = measureCharMinor.clientWidth;
                    this.dom.frame.removeChild(measureCharMinor);
                }
                if (!("majorCharHeight" in this.props)) {
                    var textMajor = document.createTextNode("0");
                    var measureCharMajor = document.createElement("div");
                    measureCharMajor.className = "vis-y-axis vis-major vis-measure";
                    measureCharMajor.appendChild(textMajor);
                    this.dom.frame.appendChild(measureCharMajor);
                    this.props.majorCharHeight = measureCharMajor.clientHeight;
                    this.props.majorCharWidth = measureCharMajor.clientWidth;
                    this.dom.frame.removeChild(measureCharMajor);
                }
                if (!("titleCharHeight" in this.props)) {
                    var textTitle = document.createTextNode("0");
                    var measureCharTitle = document.createElement("div");
                    measureCharTitle.className = "vis-y-axis vis-title vis-measure";
                    measureCharTitle.appendChild(textTitle);
                    this.dom.frame.appendChild(measureCharTitle);
                    this.props.titleCharHeight = measureCharTitle.clientHeight;
                    this.props.titleCharWidth = measureCharTitle.clientWidth;
                    this.dom.frame.removeChild(measureCharTitle);
                }
            }
        }
    ]);
    return DataAxis;
}(Component);
/**
 *
 * @param {number | string} groupId
 * @param {Object} options   // TODO: Describe options
 *
 * @constructor Points
 */ function Points(groupId, options) {}
/**
 * draw the data points
 *
 * @param {Array} dataset
 * @param {GraphGroup} group
 * @param {Object} framework            | SVG DOM element
 * @param {number} [offset]
 */ Points.draw = function(dataset, group, framework, offset) {
    offset = offset || 0;
    var callback = getCallback(framework, group);
    for(var i1 = 0; i1 < dataset.length; i1++)if (!callback) // draw the point the simple way.
    drawPoint(dataset[i1].screen_x + offset, dataset[i1].screen_y, getGroupTemplate(group), framework.svgElements, framework.svg, dataset[i1].label);
    else {
        var callbackResult = callback(dataset[i1], group); // result might be true, false or an object
        if (callbackResult === true || _typeof$1(callbackResult) === "object") drawPoint(dataset[i1].screen_x + offset, dataset[i1].screen_y, getGroupTemplate(group, callbackResult), framework.svgElements, framework.svg, dataset[i1].label);
    }
};
Points.drawIcon = function(group, x, y, iconWidth, iconHeight, framework) {
    var fillHeight = iconHeight * 0.5;
    var outline = getSVGElement("rect", framework.svgElements, framework.svg);
    outline.setAttributeNS(null, "x", x);
    outline.setAttributeNS(null, "y", y - fillHeight);
    outline.setAttributeNS(null, "width", iconWidth);
    outline.setAttributeNS(null, "height", 2 * fillHeight);
    outline.setAttributeNS(null, "class", "vis-outline");
    //Don't call callback on icon
    drawPoint(x + 0.5 * iconWidth, y, getGroupTemplate(group), framework.svgElements, framework.svg);
};
/**
 *
 * @param {vis.Group} group
 * @param {any} callbackResult
 * @returns {{style: *, styles: (*|string), size: *, className: *}}
 */ function getGroupTemplate(group, callbackResult) {
    callbackResult = typeof callbackResult === "undefined" ? {} : callbackResult;
    return {
        style: callbackResult.style || group.options.drawPoints.style,
        styles: callbackResult.styles || group.options.drawPoints.styles,
        size: callbackResult.size || group.options.drawPoints.size,
        className: callbackResult.className || group.className
    };
}
/**
 *
 * @param {Object} framework            | SVG DOM element
 * @param {vis.Group} group
 * @returns {function}
 */ function getCallback(framework, group) {
    var callback = undefined;
    // check for the graph2d onRender
    if (framework.options && framework.options.drawPoints && framework.options.drawPoints.onRender && typeof framework.options.drawPoints.onRender == "function") callback = framework.options.drawPoints.onRender;
    // override it with the group onRender if defined
    if (group.group.options && group.group.options.drawPoints && group.group.options.drawPoints.onRender && typeof group.group.options.drawPoints.onRender == "function") callback = group.group.options.drawPoints.onRender;
    return callback;
}
/**
 *
 * @param {vis.GraphGroup.id} groupId
 * @param {Object} options   // TODO: Describe options
 * @constructor Bargraph
 */ function Bargraph(groupId, options) {}
Bargraph.drawIcon = function(group, x, y, iconWidth, iconHeight, framework) {
    var fillHeight = iconHeight * 0.5;
    var outline = getSVGElement("rect", framework.svgElements, framework.svg);
    outline.setAttributeNS(null, "x", x);
    outline.setAttributeNS(null, "y", y - fillHeight);
    outline.setAttributeNS(null, "width", iconWidth);
    outline.setAttributeNS(null, "height", 2 * fillHeight);
    outline.setAttributeNS(null, "class", "vis-outline");
    var barWidth = Math.round(0.3 * iconWidth);
    var originalWidth = group.options.barChart.width;
    var scale = originalWidth / barWidth;
    var bar1Height = Math.round(0.4 * iconHeight);
    var bar2Height = Math.round(0.75 * iconHeight);
    var offset = Math.round((iconWidth - 2 * barWidth) / 3);
    drawBar(x + 0.5 * barWidth + offset, y + fillHeight - bar1Height - 1, barWidth, bar1Height, group.className + " vis-bar", framework.svgElements, framework.svg, group.style);
    drawBar(x + 1.5 * barWidth + offset + 2, y + fillHeight - bar2Height - 1, barWidth, bar2Height, group.className + " vis-bar", framework.svgElements, framework.svg, group.style);
    if (group.options.drawPoints.enabled == true) {
        var groupTemplate = {
            style: group.options.drawPoints.style,
            styles: group.options.drawPoints.styles,
            size: group.options.drawPoints.size / scale,
            className: group.className
        };
        drawPoint(x + 0.5 * barWidth + offset, y + fillHeight - bar1Height - 1, groupTemplate, framework.svgElements, framework.svg);
        drawPoint(x + 1.5 * barWidth + offset + 2, y + fillHeight - bar2Height - 1, groupTemplate, framework.svgElements, framework.svg);
    }
};
/**
 * draw a bar graph
 *
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {Object} processedGroupData
 * @param {{svg: Object, svgElements: Array.<Object>, options: Object, groups: Array.<vis.Group>}} framework
 */ Bargraph.draw = function(groupIds, processedGroupData, framework) {
    var combinedData = [];
    var intersections = {};
    var coreDistance;
    var key, drawData;
    var group;
    var i1, j;
    var barPoints = 0;
    // combine all barchart data
    for(i1 = 0; i1 < groupIds.length; i1++){
        group = framework.groups[groupIds[i1]];
        if (group.options.style === "bar") {
            if (group.visible === true && (framework.options.groups.visibility[groupIds[i1]] === undefined || framework.options.groups.visibility[groupIds[i1]] === true)) for(j = 0; j < processedGroupData[groupIds[i1]].length; j++){
                combinedData.push({
                    screen_x: processedGroupData[groupIds[i1]][j].screen_x,
                    screen_end: processedGroupData[groupIds[i1]][j].screen_end,
                    screen_y: processedGroupData[groupIds[i1]][j].screen_y,
                    x: processedGroupData[groupIds[i1]][j].x,
                    end: processedGroupData[groupIds[i1]][j].end,
                    y: processedGroupData[groupIds[i1]][j].y,
                    groupId: groupIds[i1],
                    label: processedGroupData[groupIds[i1]][j].label
                });
                barPoints += 1;
            }
        }
    }
    if (barPoints === 0) return;
    // sort by time and by group
    _sortInstanceProperty(combinedData).call(combinedData, function(a, b) {
        if (a.screen_x === b.screen_x) return a.groupId < b.groupId ? -1 : 1;
        else return a.screen_x - b.screen_x;
    });
    // get intersections
    Bargraph._getDataIntersections(intersections, combinedData);
    // plot barchart
    for(i1 = 0; i1 < combinedData.length; i1++){
        group = framework.groups[combinedData[i1].groupId];
        var minWidth = group.options.barChart.minWidth != undefined ? group.options.barChart.minWidth : 0.1 * group.options.barChart.width;
        key = combinedData[i1].screen_x;
        var heightOffset = 0;
        if (intersections[key] === undefined) {
            if (i1 + 1 < combinedData.length) coreDistance = Math.abs(combinedData[i1 + 1].screen_x - key);
            drawData = Bargraph._getSafeDrawData(coreDistance, group, minWidth);
        } else {
            var nextKey = i1 + (intersections[key].amount - intersections[key].resolved);
            if (nextKey < combinedData.length) coreDistance = Math.abs(combinedData[nextKey].screen_x - key);
            drawData = Bargraph._getSafeDrawData(coreDistance, group, minWidth);
            intersections[key].resolved += 1;
            if (group.options.stack === true && group.options.excludeFromStacking !== true) {
                if (combinedData[i1].screen_y < group.zeroPosition) {
                    heightOffset = intersections[key].accumulatedNegative;
                    intersections[key].accumulatedNegative += group.zeroPosition - combinedData[i1].screen_y;
                } else {
                    heightOffset = intersections[key].accumulatedPositive;
                    intersections[key].accumulatedPositive += group.zeroPosition - combinedData[i1].screen_y;
                }
            } else if (group.options.barChart.sideBySide === true) {
                drawData.width = drawData.width / intersections[key].amount;
                drawData.offset += intersections[key].resolved * drawData.width - 0.5 * drawData.width * (intersections[key].amount + 1);
            }
        }
        var dataWidth = drawData.width;
        var start = combinedData[i1].screen_x;
        // are we drawing explicit boxes? (we supplied an end value)
        if (combinedData[i1].screen_end != undefined) {
            dataWidth = combinedData[i1].screen_end - combinedData[i1].screen_x;
            start += dataWidth * 0.5;
        } else start += drawData.offset;
        drawBar(start, combinedData[i1].screen_y - heightOffset, dataWidth, group.zeroPosition - combinedData[i1].screen_y, group.className + " vis-bar", framework.svgElements, framework.svg, group.style);
        // draw points
        if (group.options.drawPoints.enabled === true) {
            var pointData = {
                screen_x: combinedData[i1].screen_x,
                screen_y: combinedData[i1].screen_y - heightOffset,
                x: combinedData[i1].x,
                y: combinedData[i1].y,
                groupId: combinedData[i1].groupId,
                label: combinedData[i1].label
            };
            Points.draw([
                pointData
            ], group, framework, drawData.offset);
        //DOMutil.drawPoint(combinedData[i].x + drawData.offset, combinedData[i].y, group, framework.svgElements, framework.svg);
        }
    }
};
/**
 * Fill the intersections object with counters of how many datapoints share the same x coordinates
 * @param {Object} intersections
 * @param {Array.<Object>} combinedData
 * @private
 */ Bargraph._getDataIntersections = function(intersections, combinedData) {
    // get intersections
    var coreDistance;
    for(var i1 = 0; i1 < combinedData.length; i1++){
        if (i1 + 1 < combinedData.length) coreDistance = Math.abs(combinedData[i1 + 1].screen_x - combinedData[i1].screen_x);
        if (i1 > 0) coreDistance = Math.min(coreDistance, Math.abs(combinedData[i1 - 1].screen_x - combinedData[i1].screen_x));
        if (coreDistance === 0) {
            if (intersections[combinedData[i1].screen_x] === undefined) intersections[combinedData[i1].screen_x] = {
                amount: 0,
                resolved: 0,
                accumulatedPositive: 0,
                accumulatedNegative: 0
            };
            intersections[combinedData[i1].screen_x].amount += 1;
        }
    }
};
/**
 * Get the width and offset for bargraphs based on the coredistance between datapoints
 *
 * @param {number} coreDistance
 * @param {vis.Group} group
 * @param {number} minWidth
 * @returns {{width: number, offset: number}}
 * @private
 */ Bargraph._getSafeDrawData = function(coreDistance, group, minWidth) {
    var width, offset;
    if (coreDistance < group.options.barChart.width && coreDistance > 0) {
        width = coreDistance < minWidth ? minWidth : coreDistance;
        offset = 0; // recalculate offset with the new width;
        if (group.options.barChart.align === "left") offset -= 0.5 * coreDistance;
        else if (group.options.barChart.align === "right") offset += 0.5 * coreDistance;
    } else {
        // default settings
        width = group.options.barChart.width;
        offset = 0;
        if (group.options.barChart.align === "left") offset -= 0.5 * group.options.barChart.width;
        else if (group.options.barChart.align === "right") offset += 0.5 * group.options.barChart.width;
    }
    return {
        width: width,
        offset: offset
    };
};
Bargraph.getStackedYRange = function(combinedData, groupRanges, groupIds, groupLabel, orientation) {
    if (combinedData.length > 0) {
        // sort by time and by group
        _sortInstanceProperty(combinedData).call(combinedData, function(a, b) {
            if (a.screen_x === b.screen_x) return a.groupId < b.groupId ? -1 : 1;
            else return a.screen_x - b.screen_x;
        });
        var intersections = {};
        Bargraph._getDataIntersections(intersections, combinedData);
        groupRanges[groupLabel] = Bargraph._getStackedYRange(intersections, combinedData);
        groupRanges[groupLabel].yAxisOrientation = orientation;
        groupIds.push(groupLabel);
    }
};
Bargraph._getStackedYRange = function(intersections, combinedData) {
    var key;
    var yMin = combinedData[0].screen_y;
    var yMax = combinedData[0].screen_y;
    for(var i1 = 0; i1 < combinedData.length; i1++){
        key = combinedData[i1].screen_x;
        if (intersections[key] === undefined) {
            yMin = yMin > combinedData[i1].screen_y ? combinedData[i1].screen_y : yMin;
            yMax = yMax < combinedData[i1].screen_y ? combinedData[i1].screen_y : yMax;
        } else if (combinedData[i1].screen_y < 0) intersections[key].accumulatedNegative += combinedData[i1].screen_y;
        else intersections[key].accumulatedPositive += combinedData[i1].screen_y;
    }
    for(var xpos in intersections)if (intersections.hasOwnProperty(xpos)) {
        yMin = yMin > intersections[xpos].accumulatedNegative ? intersections[xpos].accumulatedNegative : yMin;
        yMin = yMin > intersections[xpos].accumulatedPositive ? intersections[xpos].accumulatedPositive : yMin;
        yMax = yMax < intersections[xpos].accumulatedNegative ? intersections[xpos].accumulatedNegative : yMax;
        yMax = yMax < intersections[xpos].accumulatedPositive ? intersections[xpos].accumulatedPositive : yMax;
    }
    return {
        min: yMin,
        max: yMax
    };
};
/**
 *
 * @param {vis.GraphGroup.id} groupId
 * @param {Object} options   // TODO: Describe options
 * @constructor Line
 */ function Line(groupId, options) {}
Line.calcPath = function(dataset, group) {
    if (dataset != null) {
        if (dataset.length > 0) {
            var d = [];
            // construct path from dataset
            if (group.options.interpolation.enabled == true) d = Line._catmullRom(dataset, group);
            else d = Line._linear(dataset);
            return d;
        }
    }
};
Line.drawIcon = function(group, x, y, iconWidth, iconHeight, framework) {
    var fillHeight = iconHeight * 0.5;
    var path, fillPath;
    var outline = getSVGElement("rect", framework.svgElements, framework.svg);
    outline.setAttributeNS(null, "x", x);
    outline.setAttributeNS(null, "y", y - fillHeight);
    outline.setAttributeNS(null, "width", iconWidth);
    outline.setAttributeNS(null, "height", 2 * fillHeight);
    outline.setAttributeNS(null, "class", "vis-outline");
    path = getSVGElement("path", framework.svgElements, framework.svg);
    path.setAttributeNS(null, "class", group.className);
    if (group.style !== undefined) path.setAttributeNS(null, "style", group.style);
    path.setAttributeNS(null, "d", "M" + x + "," + y + " L" + (x + iconWidth) + "," + y + "");
    if (group.options.shaded.enabled == true) {
        fillPath = getSVGElement("path", framework.svgElements, framework.svg);
        if (group.options.shaded.orientation == "top") fillPath.setAttributeNS(null, "d", "M" + x + ", " + (y - fillHeight) + "L" + x + "," + y + " L" + (x + iconWidth) + "," + y + " L" + (x + iconWidth) + "," + (y - fillHeight));
        else fillPath.setAttributeNS(null, "d", "M" + x + "," + y + " " + "L" + x + "," + (y + fillHeight) + " " + "L" + (x + iconWidth) + "," + (y + fillHeight) + "L" + (x + iconWidth) + "," + y);
        fillPath.setAttributeNS(null, "class", group.className + " vis-icon-fill");
        if (group.options.shaded.style !== undefined && group.options.shaded.style !== "") fillPath.setAttributeNS(null, "style", group.options.shaded.style);
    }
    if (group.options.drawPoints.enabled == true) {
        var groupTemplate = {
            style: group.options.drawPoints.style,
            styles: group.options.drawPoints.styles,
            size: group.options.drawPoints.size,
            className: group.className
        };
        drawPoint(x + 0.5 * iconWidth, y, groupTemplate, framework.svgElements, framework.svg);
    }
};
Line.drawShading = function(pathArray, group, subPathArray, framework) {
    // append shading to the path
    if (group.options.shaded.enabled == true) {
        var svgHeight = Number(framework.svg.style.height.replace("px", ""));
        var fillPath = getSVGElement("path", framework.svgElements, framework.svg);
        var type = "L";
        if (group.options.interpolation.enabled == true) type = "C";
        var dFill;
        var zero = 0;
        if (group.options.shaded.orientation == "top") zero = 0;
        else if (group.options.shaded.orientation == "bottom") zero = svgHeight;
        else zero = Math.min(Math.max(0, group.zeroPosition), svgHeight);
        if (group.options.shaded.orientation == "group" && subPathArray != null && subPathArray != undefined) dFill = "M" + pathArray[0][0] + "," + pathArray[0][1] + " " + this.serializePath(pathArray, type, false) + " L" + subPathArray[subPathArray.length - 1][0] + "," + subPathArray[subPathArray.length - 1][1] + " " + this.serializePath(subPathArray, type, true) + subPathArray[0][0] + "," + subPathArray[0][1] + " Z";
        else dFill = "M" + pathArray[0][0] + "," + pathArray[0][1] + " " + this.serializePath(pathArray, type, false) + " V" + zero + " H" + pathArray[0][0] + " Z";
        fillPath.setAttributeNS(null, "class", group.className + " vis-fill");
        if (group.options.shaded.style !== undefined) fillPath.setAttributeNS(null, "style", group.options.shaded.style);
        fillPath.setAttributeNS(null, "d", dFill);
    }
};
/**
 * draw a line graph
 *
 * @param {Array.<Object>} pathArray
 * @param {vis.Group} group
 * @param {{svg: Object, svgElements: Array.<Object>, options: Object, groups: Array.<vis.Group>}} framework
 */ Line.draw = function(pathArray, group, framework) {
    if (pathArray != null && pathArray != undefined) {
        var path = getSVGElement("path", framework.svgElements, framework.svg);
        path.setAttributeNS(null, "class", group.className);
        if (group.style !== undefined) path.setAttributeNS(null, "style", group.style);
        var type = "L";
        if (group.options.interpolation.enabled == true) type = "C";
        // copy properties to path for drawing.
        path.setAttributeNS(null, "d", "M" + pathArray[0][0] + "," + pathArray[0][1] + " " + this.serializePath(pathArray, type, false));
    }
};
Line.serializePath = function(pathArray, type, inverse) {
    if (pathArray.length < 2) //Too little data to create a path.
    return "";
    var d = type;
    var i1;
    if (inverse) for(i1 = pathArray.length - 2; i1 > 0; i1--)d += pathArray[i1][0] + "," + pathArray[i1][1] + " ";
    else for(i1 = 1; i1 < pathArray.length; i1++)d += pathArray[i1][0] + "," + pathArray[i1][1] + " ";
    return d;
};
/**
 * This uses an uniform parametrization of the interpolation algorithm:
 * 'On the Parameterization of Catmull-Rom Curves' by Cem Yuksel et al.
 * @param {Array.<Object>} data
 * @returns {string}
 * @private
 */ Line._catmullRomUniform = function(data) {
    // catmull rom
    var p0, p1, p2, p3, bp1, bp2;
    var d = [];
    d.push([
        Math.round(data[0].screen_x),
        Math.round(data[0].screen_y)
    ]);
    var normalization = 1 / 6;
    var length = data.length;
    for(var i1 = 0; i1 < length - 1; i1++){
        p0 = i1 == 0 ? data[0] : data[i1 - 1];
        p1 = data[i1];
        p2 = data[i1 + 1];
        p3 = i1 + 2 < length ? data[i1 + 2] : p2;
        // Catmull-Rom to Cubic Bezier conversion matrix
        //    0       1       0       0
        //  -1/6      1      1/6      0
        //    0      1/6      1     -1/6
        //    0       0       1       0
        //    bp0 = { x: p1.x,                               y: p1.y };
        bp1 = {
            screen_x: (-p0.screen_x + 6 * p1.screen_x + p2.screen_x) * normalization,
            screen_y: (-p0.screen_y + 6 * p1.screen_y + p2.screen_y) * normalization
        };
        bp2 = {
            screen_x: (p1.screen_x + 6 * p2.screen_x - p3.screen_x) * normalization,
            screen_y: (p1.screen_y + 6 * p2.screen_y - p3.screen_y) * normalization
        };
        //    bp0 = { x: p2.x,                               y: p2.y };
        d.push([
            bp1.screen_x,
            bp1.screen_y
        ]);
        d.push([
            bp2.screen_x,
            bp2.screen_y
        ]);
        d.push([
            p2.screen_x,
            p2.screen_y
        ]);
    }
    return d;
};
/**
 * This uses either the chordal or centripetal parameterization of the catmull-rom algorithm.
 * By default, the centripetal parameterization is used because this gives the nicest results.
 * These parameterizations are relatively heavy because the distance between 4 points have to be calculated.
 *
 * One optimization can be used to reuse distances since this is a sliding window approach.
 * @param {Array.<Object>} data
 * @param {vis.GraphGroup} group
 * @returns {string}
 * @private
 */ Line._catmullRom = function(data, group) {
    var alpha = group.options.interpolation.alpha;
    if (alpha == 0 || alpha === undefined) return this._catmullRomUniform(data);
    else {
        var p0, p1, p2, p3, bp1, bp2, d1, d2, d3, A, B, N, M;
        var d3powA, d2powA, d3pow2A, d2pow2A, d1pow2A, d1powA;
        var d = [];
        d.push([
            Math.round(data[0].screen_x),
            Math.round(data[0].screen_y)
        ]);
        var length = data.length;
        for(var i1 = 0; i1 < length - 1; i1++){
            p0 = i1 == 0 ? data[0] : data[i1 - 1];
            p1 = data[i1];
            p2 = data[i1 + 1];
            p3 = i1 + 2 < length ? data[i1 + 2] : p2;
            d1 = Math.sqrt(Math.pow(p0.screen_x - p1.screen_x, 2) + Math.pow(p0.screen_y - p1.screen_y, 2));
            d2 = Math.sqrt(Math.pow(p1.screen_x - p2.screen_x, 2) + Math.pow(p1.screen_y - p2.screen_y, 2));
            d3 = Math.sqrt(Math.pow(p2.screen_x - p3.screen_x, 2) + Math.pow(p2.screen_y - p3.screen_y, 2));
            // Catmull-Rom to Cubic Bezier conversion matrix
            // A = 2d1^2a + 3d1^a * d2^a + d3^2a
            // B = 2d3^2a + 3d3^a * d2^a + d2^2a
            // [   0             1            0          0          ]
            // [   -d2^2a /N     A/N          d1^2a /N   0          ]
            // [   0             d3^2a /M     B/M        -d2^2a /M  ]
            // [   0             0            1          0          ]
            d3powA = Math.pow(d3, alpha);
            d3pow2A = Math.pow(d3, 2 * alpha);
            d2powA = Math.pow(d2, alpha);
            d2pow2A = Math.pow(d2, 2 * alpha);
            d1powA = Math.pow(d1, alpha);
            d1pow2A = Math.pow(d1, 2 * alpha);
            A = 2 * d1pow2A + 3 * d1powA * d2powA + d2pow2A;
            B = 2 * d3pow2A + 3 * d3powA * d2powA + d2pow2A;
            N = 3 * d1powA * (d1powA + d2powA);
            if (N > 0) N = 1 / N;
            M = 3 * d3powA * (d3powA + d2powA);
            if (M > 0) M = 1 / M;
            bp1 = {
                screen_x: (-d2pow2A * p0.screen_x + A * p1.screen_x + d1pow2A * p2.screen_x) * N,
                screen_y: (-d2pow2A * p0.screen_y + A * p1.screen_y + d1pow2A * p2.screen_y) * N
            };
            bp2 = {
                screen_x: (d3pow2A * p1.screen_x + B * p2.screen_x - d2pow2A * p3.screen_x) * M,
                screen_y: (d3pow2A * p1.screen_y + B * p2.screen_y - d2pow2A * p3.screen_y) * M
            };
            if (bp1.screen_x == 0 && bp1.screen_y == 0) bp1 = p1;
            if (bp2.screen_x == 0 && bp2.screen_y == 0) bp2 = p2;
            d.push([
                bp1.screen_x,
                bp1.screen_y
            ]);
            d.push([
                bp2.screen_x,
                bp2.screen_y
            ]);
            d.push([
                p2.screen_x,
                p2.screen_y
            ]);
        }
        return d;
    }
};
/**
 * this generates the SVG path for a linear drawing between datapoints.
 * @param {Array.<Object>} data
 * @returns {string}
 * @private
 */ Line._linear = function(data) {
    // linear
    var d = [];
    for(var i1 = 0; i1 < data.length; i1++)d.push([
        data[i1].screen_x,
        data[i1].screen_y
    ]);
    return d;
};
/**
 * /**
 * @param {object} group            | the object of the group from the dataset
 * @param {string} groupId          | ID of the group
 * @param {object} options          | the default options
 * @param {array} groupsUsingDefaultStyles  | this array has one entree.
 *                                            It is passed as an array so it is passed by reference.
 *                                            It enumerates through the default styles
 * @constructor GraphGroup
 */ function GraphGroup(group, groupId, options, groupsUsingDefaultStyles) {
    this.id = groupId;
    var fields = [
        "sampling",
        "style",
        "sort",
        "yAxisOrientation",
        "barChart",
        "drawPoints",
        "shaded",
        "interpolation",
        "zIndex",
        "excludeFromStacking",
        "excludeFromLegend"
    ];
    this.options = availableUtils.selectiveBridgeObject(fields, options);
    this.usingDefaultStyle = group.className === undefined;
    this.groupsUsingDefaultStyles = groupsUsingDefaultStyles;
    this.zeroPosition = 0;
    this.update(group);
    if (this.usingDefaultStyle == true) this.groupsUsingDefaultStyles[0] += 1;
    this.itemsData = [];
    this.visible = group.visible === undefined ? true : group.visible;
}
/**
 * this loads a reference to all items in this group into this group.
 * @param {array} items
 */ GraphGroup.prototype.setItems = function(items) {
    if (items != null) {
        this.itemsData = items;
        if (_sortInstanceProperty(this.options) == true) availableUtils.insertSort(this.itemsData, function(a, b) {
            return a.x > b.x ? 1 : -1;
        });
    } else this.itemsData = [];
};
GraphGroup.prototype.getItems = function() {
    return this.itemsData;
};
/**
 * this is used for barcharts and shading, this way, we only have to calculate it once.
 * @param {number} pos
 */ GraphGroup.prototype.setZeroPosition = function(pos) {
    this.zeroPosition = pos;
};
/**
 * set the options of the graph group over the default options.
 * @param {Object} options
 */ GraphGroup.prototype.setOptions = function(options) {
    if (options !== undefined) {
        var fields = [
            "sampling",
            "style",
            "sort",
            "yAxisOrientation",
            "barChart",
            "zIndex",
            "excludeFromStacking",
            "excludeFromLegend"
        ];
        availableUtils.selectiveDeepExtend(fields, this.options, options);
        // if the group's drawPoints is a function delegate the callback to the onRender property
        if (typeof options.drawPoints == "function") options.drawPoints = {
            onRender: options.drawPoints
        };
        availableUtils.mergeOptions(this.options, options, "interpolation");
        availableUtils.mergeOptions(this.options, options, "drawPoints");
        availableUtils.mergeOptions(this.options, options, "shaded");
        if (options.interpolation) {
            if (_typeof$1(options.interpolation) == "object") {
                if (options.interpolation.parametrization) {
                    if (options.interpolation.parametrization == "uniform") this.options.interpolation.alpha = 0;
                    else if (options.interpolation.parametrization == "chordal") this.options.interpolation.alpha = 1.0;
                    else {
                        this.options.interpolation.parametrization = "centripetal";
                        this.options.interpolation.alpha = 0.5;
                    }
                }
            }
        }
    }
};
/**
 * this updates the current group class with the latest group dataset entree, used in _updateGroup in linegraph
 * @param {vis.Group} group
 */ GraphGroup.prototype.update = function(group) {
    this.group = group;
    this.content = group.content || "graph";
    this.className = group.className || this.className || "vis-graph-group" + this.groupsUsingDefaultStyles[0] % 10;
    this.visible = group.visible === undefined ? true : group.visible;
    this.style = group.style;
    this.setOptions(group.options);
};
/**
 * return the legend entree for this group.
 *
 * @param {number} iconWidth
 * @param {number} iconHeight
 * @param {{svg: (*|Element), svgElements: Object, options: Object, groups: Array.<Object>}} framework
 * @param {number} x
 * @param {number} y
 * @returns {{icon: (*|Element), label: (*|string), orientation: *}}
 */ GraphGroup.prototype.getLegend = function(iconWidth, iconHeight, framework, x, y) {
    if (framework == undefined || framework == null) {
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        framework = {
            svg: svg,
            svgElements: {},
            options: this.options,
            groups: [
                this
            ]
        };
    }
    if (x == undefined || x == null) x = 0;
    if (y == undefined || y == null) y = 0.5 * iconHeight;
    switch(this.options.style){
        case "line":
            Line.drawIcon(this, x, y, iconWidth, iconHeight, framework);
            break;
        case "points":
        case "point":
            Points.drawIcon(this, x, y, iconWidth, iconHeight, framework);
            break;
        case "bar":
            Bargraph.drawIcon(this, x, y, iconWidth, iconHeight, framework);
            break;
    }
    return {
        icon: framework.svg,
        label: this.content,
        orientation: this.options.yAxisOrientation
    };
};
GraphGroup.prototype.getYRange = function(groupData) {
    var yMin = groupData[0].y;
    var yMax = groupData[0].y;
    for(var j = 0; j < groupData.length; j++){
        yMin = yMin > groupData[j].y ? groupData[j].y : yMin;
        yMax = yMax < groupData[j].y ? groupData[j].y : yMax;
    }
    return {
        min: yMin,
        max: yMax,
        yAxisOrientation: this.options.yAxisOrientation
    };
};
/**
 * Legend for Graph2d
 *
 * @param {vis.Graph2d.body} body
 * @param {vis.Graph2d.options} options
 * @param {number} side
 * @param {vis.LineGraph.options} linegraphOptions
 * @constructor Legend
 * @extends Component
 */ function Legend(body, options, side, linegraphOptions) {
    this.body = body;
    this.defaultOptions = {
        enabled: false,
        icons: true,
        iconSize: 20,
        iconSpacing: 6,
        left: {
            visible: true,
            position: "top-left" // top/bottom - left,center,right
        },
        right: {
            visible: true,
            position: "top-right" // top/bottom - left,center,right
        }
    };
    this.side = side;
    this.options = availableUtils.extend({}, this.defaultOptions);
    this.linegraphOptions = linegraphOptions;
    this.svgElements = {};
    this.dom = {};
    this.groups = {};
    this.amountOfGroups = 0;
    this._create();
    this.framework = {
        svg: this.svg,
        svgElements: this.svgElements,
        options: this.options,
        groups: this.groups
    };
    this.setOptions(options);
}
Legend.prototype = new Component();
Legend.prototype.clear = function() {
    this.groups = {};
    this.amountOfGroups = 0;
};
Legend.prototype.addGroup = function(label, graphOptions) {
    // Include a group only if the group option 'excludeFromLegend: false' is not set.
    if (graphOptions.options.excludeFromLegend != true) {
        if (!this.groups.hasOwnProperty(label)) this.groups[label] = graphOptions;
        this.amountOfGroups += 1;
    }
};
Legend.prototype.updateGroup = function(label, graphOptions) {
    this.groups[label] = graphOptions;
};
Legend.prototype.removeGroup = function(label) {
    if (this.groups.hasOwnProperty(label)) {
        delete this.groups[label];
        this.amountOfGroups -= 1;
    }
};
Legend.prototype._create = function() {
    this.dom.frame = document.createElement("div");
    this.dom.frame.className = "vis-legend";
    this.dom.frame.style.position = "absolute";
    this.dom.frame.style.top = "10px";
    this.dom.frame.style.display = "block";
    this.dom.textArea = document.createElement("div");
    this.dom.textArea.className = "vis-legend-text";
    this.dom.textArea.style.position = "relative";
    this.dom.textArea.style.top = "0px";
    this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    this.svg.style.position = "absolute";
    this.svg.style.top = "0px";
    this.svg.style.width = this.options.iconSize + 5 + "px";
    this.svg.style.height = "100%";
    this.dom.frame.appendChild(this.svg);
    this.dom.frame.appendChild(this.dom.textArea);
};
/**
 * Hide the component from the DOM
 */ Legend.prototype.hide = function() {
    // remove the frame containing the items
    if (this.dom.frame.parentNode) this.dom.frame.parentNode.removeChild(this.dom.frame);
};
/**
 * Show the component in the DOM (when not already visible).
 */ Legend.prototype.show = function() {
    // show frame containing the items
    if (!this.dom.frame.parentNode) this.body.dom.center.appendChild(this.dom.frame);
};
Legend.prototype.setOptions = function(options) {
    var fields = [
        "enabled",
        "orientation",
        "icons",
        "left",
        "right"
    ];
    availableUtils.selectiveDeepExtend(fields, this.options, options);
};
Legend.prototype.redraw = function() {
    var activeGroups = 0;
    var groupArray = _Object$keys(this.groups);
    _sortInstanceProperty(groupArray).call(groupArray, function(a, b) {
        return a < b ? -1 : 1;
    });
    for(var i1 = 0; i1 < groupArray.length; i1++){
        var groupId = groupArray[i1];
        if (this.groups[groupId].visible == true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] == true)) activeGroups++;
    }
    if (this.options[this.side].visible == false || this.amountOfGroups == 0 || this.options.enabled == false || activeGroups == 0) this.hide();
    else {
        this.show();
        if (this.options[this.side].position == "top-left" || this.options[this.side].position == "bottom-left") {
            this.dom.frame.style.left = "4px";
            this.dom.frame.style.textAlign = "left";
            this.dom.textArea.style.textAlign = "left";
            this.dom.textArea.style.left = this.options.iconSize + 15 + "px";
            this.dom.textArea.style.right = "";
            this.svg.style.left = "0px";
            this.svg.style.right = "";
        } else {
            this.dom.frame.style.right = "4px";
            this.dom.frame.style.textAlign = "right";
            this.dom.textArea.style.textAlign = "right";
            this.dom.textArea.style.right = this.options.iconSize + 15 + "px";
            this.dom.textArea.style.left = "";
            this.svg.style.right = "0px";
            this.svg.style.left = "";
        }
        if (this.options[this.side].position == "top-left" || this.options[this.side].position == "top-right") {
            this.dom.frame.style.top = 4 - Number(this.body.dom.center.style.top.replace("px", "")) + "px";
            this.dom.frame.style.bottom = "";
        } else {
            var scrollableHeight = this.body.domProps.center.height - this.body.domProps.centerContainer.height;
            this.dom.frame.style.bottom = 4 + scrollableHeight + Number(this.body.dom.center.style.top.replace("px", "")) + "px";
            this.dom.frame.style.top = "";
        }
        if (this.options.icons == false) {
            this.dom.frame.style.width = this.dom.textArea.offsetWidth + 10 + "px";
            this.dom.textArea.style.right = "";
            this.dom.textArea.style.left = "";
            this.svg.style.width = "0px";
        } else {
            this.dom.frame.style.width = this.options.iconSize + 15 + this.dom.textArea.offsetWidth + 10 + "px";
            this.drawLegendIcons();
        }
        var content = "";
        for(i1 = 0; i1 < groupArray.length; i1++){
            groupId = groupArray[i1];
            if (this.groups[groupId].visible == true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] == true)) content += this.groups[groupId].content + "<br />";
        }
        this.dom.textArea.innerHTML = availableUtils.xss(content);
        this.dom.textArea.style.lineHeight = 0.75 * this.options.iconSize + this.options.iconSpacing + "px";
    }
};
Legend.prototype.drawLegendIcons = function() {
    if (this.dom.frame.parentNode) {
        var groupArray = _Object$keys(this.groups);
        _sortInstanceProperty(groupArray).call(groupArray, function(a, b) {
            return a < b ? -1 : 1;
        });
        // this resets the elements so the order is maintained
        resetElements(this.svgElements);
        var padding = window.getComputedStyle(this.dom.frame).paddingTop;
        var iconOffset = Number(padding.replace("px", ""));
        var x = iconOffset;
        var iconWidth = this.options.iconSize;
        var iconHeight = 0.75 * this.options.iconSize;
        var y = iconOffset + 0.5 * iconHeight + 3;
        this.svg.style.width = iconWidth + 5 + iconOffset + "px";
        for(var i1 = 0; i1 < groupArray.length; i1++){
            var groupId = groupArray[i1];
            if (this.groups[groupId].visible == true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] == true)) {
                this.groups[groupId].getLegend(iconWidth, iconHeight, this.framework, x, y);
                y += iconHeight + this.options.iconSpacing;
            }
        }
    }
};
var UNGROUPED = "__ungrouped__"; // reserved group id for ungrouped items
/**
 * This is the constructor of the LineGraph. It requires a Timeline body and options.
 *
 * @param {vis.Timeline.body} body
 * @param {Object} options
 * @constructor LineGraph
 * @extends Component
 */ function LineGraph(body, options) {
    this.id = v4();
    this.body = body;
    this.defaultOptions = {
        yAxisOrientation: "left",
        defaultGroup: "default",
        sort: true,
        sampling: true,
        stack: false,
        graphHeight: "400px",
        shaded: {
            enabled: false,
            orientation: "bottom" // top, bottom, zero
        },
        style: "line",
        // line, bar
        barChart: {
            width: 50,
            sideBySide: false,
            align: "center" // left, center, right
        },
        interpolation: {
            enabled: true,
            parametrization: "centripetal",
            // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
            alpha: 0.5
        },
        drawPoints: {
            enabled: true,
            size: 6,
            style: "square" // square, circle
        },
        dataAxis: {},
        //Defaults are done on DataAxis level
        legend: {},
        //Defaults are done on Legend level
        groups: {
            visibility: {}
        }
    };
    // options is shared by this lineGraph and all its items
    this.options = availableUtils.extend({}, this.defaultOptions);
    this.dom = {};
    this.props = {};
    this.hammer = null;
    this.groups = {};
    this.abortedGraphUpdate = false;
    this.updateSVGheight = false;
    this.updateSVGheightOnResize = false;
    this.forceGraphUpdate = true;
    var me = this;
    this.itemsData = null; // DataSet
    this.groupsData = null; // DataSet
    // listeners for the DataSet of the items
    this.itemListeners = {
        "add": function add(event1, params, senderId) {
            // eslint-disable-line no-unused-vars
            me._onAdd(params.items);
        },
        "update": function update(event1, params, senderId) {
            // eslint-disable-line no-unused-vars
            me._onUpdate(params.items);
        },
        "remove": function remove(event1, params, senderId) {
            // eslint-disable-line no-unused-vars
            me._onRemove(params.items);
        }
    };
    // listeners for the DataSet of the groups
    this.groupListeners = {
        "add": function add(event1, params, senderId) {
            // eslint-disable-line no-unused-vars
            me._onAddGroups(params.items);
        },
        "update": function update(event1, params, senderId) {
            // eslint-disable-line no-unused-vars
            me._onUpdateGroups(params.items);
        },
        "remove": function remove(event1, params, senderId) {
            // eslint-disable-line no-unused-vars
            me._onRemoveGroups(params.items);
        }
    };
    this.items = {}; // object with an Item for every data item
    this.selection = []; // list with the ids of all selected nodes
    this.lastStart = this.body.range.start;
    this.touchParams = {}; // stores properties while dragging
    this.svgElements = {};
    this.setOptions(options);
    this.groupsUsingDefaultStyles = [
        0
    ];
    this.body.emitter.on("rangechanged", function() {
        me.svg.style.left = availableUtils.option.asSize(-me.props.width);
        me.forceGraphUpdate = true;
        //Is this local redraw necessary? (Core also does a change event!)
        me.redraw.call(me);
    });
    // create the HTML DOM
    this._create();
    this.framework = {
        svg: this.svg,
        svgElements: this.svgElements,
        options: this.options,
        groups: this.groups
    };
}
LineGraph.prototype = new Component();
/**
 * Create the HTML DOM for the ItemSet
 */ LineGraph.prototype._create = function() {
    var frame = document.createElement("div");
    frame.className = "vis-line-graph";
    this.dom.frame = frame;
    // create svg element for graph drawing.
    this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    this.svg.style.position = "relative";
    this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px";
    this.svg.style.display = "block";
    frame.appendChild(this.svg);
    // data axis
    this.options.dataAxis.orientation = "left";
    this.yAxisLeft = new DataAxis(this.body, this.options.dataAxis, this.svg, this.options.groups);
    this.options.dataAxis.orientation = "right";
    this.yAxisRight = new DataAxis(this.body, this.options.dataAxis, this.svg, this.options.groups);
    delete this.options.dataAxis.orientation;
    // legends
    this.legendLeft = new Legend(this.body, this.options.legend, "left", this.options.groups);
    this.legendRight = new Legend(this.body, this.options.legend, "right", this.options.groups);
    this.show();
};
/**
 * set the options of the LineGraph. the mergeOptions is used for subObjects that have an enabled element.
 * @param {object} options
 */ LineGraph.prototype.setOptions = function(options) {
    if (options) {
        var fields = [
            "sampling",
            "defaultGroup",
            "stack",
            "height",
            "graphHeight",
            "yAxisOrientation",
            "style",
            "barChart",
            "dataAxis",
            "sort",
            "groups"
        ];
        if (options.graphHeight === undefined && options.height !== undefined) {
            this.updateSVGheight = true;
            this.updateSVGheightOnResize = true;
        } else if (this.body.domProps.centerContainer.height !== undefined && options.graphHeight !== undefined) {
            if (_parseInt$1((options.graphHeight + "").replace("px", "")) < this.body.domProps.centerContainer.height) this.updateSVGheight = true;
        }
        availableUtils.selectiveDeepExtend(fields, this.options, options);
        availableUtils.mergeOptions(this.options, options, "interpolation");
        availableUtils.mergeOptions(this.options, options, "drawPoints");
        availableUtils.mergeOptions(this.options, options, "shaded");
        availableUtils.mergeOptions(this.options, options, "legend");
        if (options.interpolation) {
            if (_typeof$1(options.interpolation) == "object") {
                if (options.interpolation.parametrization) {
                    if (options.interpolation.parametrization == "uniform") this.options.interpolation.alpha = 0;
                    else if (options.interpolation.parametrization == "chordal") this.options.interpolation.alpha = 1.0;
                    else {
                        this.options.interpolation.parametrization = "centripetal";
                        this.options.interpolation.alpha = 0.5;
                    }
                }
            }
        }
        if (this.yAxisLeft) {
            if (options.dataAxis !== undefined) {
                this.yAxisLeft.setOptions(this.options.dataAxis);
                this.yAxisRight.setOptions(this.options.dataAxis);
            }
        }
        if (this.legendLeft) {
            if (options.legend !== undefined) {
                this.legendLeft.setOptions(this.options.legend);
                this.legendRight.setOptions(this.options.legend);
            }
        }
        if (this.groups.hasOwnProperty(UNGROUPED)) this.groups[UNGROUPED].setOptions(options);
    }
    // this is used to redraw the graph if the visibility of the groups is changed.
    if (this.dom.frame) {
        //not on initial run?
        this.forceGraphUpdate = true;
        this.body.emitter.emit("_change", {
            queue: true
        });
    }
};
/**
 * Hide the component from the DOM
 */ LineGraph.prototype.hide = function() {
    // remove the frame containing the items
    if (this.dom.frame.parentNode) this.dom.frame.parentNode.removeChild(this.dom.frame);
};
/**
 * Show the component in the DOM (when not already visible).
 */ LineGraph.prototype.show = function() {
    // show frame containing the items
    if (!this.dom.frame.parentNode) this.body.dom.center.appendChild(this.dom.frame);
};
/**
 * Set items
 * @param {vis.DataSet | null} items
 */ LineGraph.prototype.setItems = function(items) {
    var me = this, ids, oldItemsData = this.itemsData;
    // replace the dataset
    if (!items) this.itemsData = null;
    else if (isDataViewLike(items)) this.itemsData = typeCoerceDataSet(items);
    else throw new TypeError("Data must implement the interface of DataSet or DataView");
    if (oldItemsData) {
        // unsubscribe from old dataset
        _forEachInstanceProperty(availableUtils).call(availableUtils, this.itemListeners, function(callback, event1) {
            oldItemsData.off(event1, callback);
        });
        // stop maintaining a coerced version of the old data set
        oldItemsData.dispose();
        // remove all drawn items
        ids = oldItemsData.getIds();
        this._onRemove(ids);
    }
    if (this.itemsData) {
        // subscribe to new dataset
        var id = this.id;
        _forEachInstanceProperty(availableUtils).call(availableUtils, this.itemListeners, function(callback, event1) {
            me.itemsData.on(event1, callback, id);
        });
        // add all new items
        ids = this.itemsData.getIds();
        this._onAdd(ids);
    }
};
/**
 * Set groups
 * @param {vis.DataSet} groups
 */ LineGraph.prototype.setGroups = function(groups) {
    var me = this;
    var ids;
    // unsubscribe from current dataset
    if (this.groupsData) {
        _forEachInstanceProperty(availableUtils).call(availableUtils, this.groupListeners, function(callback, event1) {
            me.groupsData.off(event1, callback);
        });
        // remove all drawn groups
        ids = this.groupsData.getIds();
        this.groupsData = null;
        for(var i1 = 0; i1 < ids.length; i1++)this._removeGroup(ids[i1]);
    }
    // replace the dataset
    if (!groups) this.groupsData = null;
    else if (isDataViewLike(groups)) this.groupsData = groups;
    else throw new TypeError("Data must implement the interface of DataSet or DataView");
    if (this.groupsData) {
        // subscribe to new dataset
        var id = this.id;
        _forEachInstanceProperty(availableUtils).call(availableUtils, this.groupListeners, function(callback, event1) {
            me.groupsData.on(event1, callback, id);
        });
        // draw all ms
        ids = this.groupsData.getIds();
        this._onAddGroups(ids);
    }
};
LineGraph.prototype._onUpdate = function(ids) {
    this._updateAllGroupData(ids);
};
LineGraph.prototype._onAdd = function(ids) {
    this._onUpdate(ids);
};
LineGraph.prototype._onRemove = function(ids) {
    this._onUpdate(ids);
};
LineGraph.prototype._onUpdateGroups = function(groupIds) {
    this._updateAllGroupData(null, groupIds);
};
LineGraph.prototype._onAddGroups = function(groupIds) {
    this._onUpdateGroups(groupIds);
};
/**
 * this cleans the group out off the legends and the dataaxis, updates the ungrouped and updates the graph
 * @param {Array} groupIds
 * @private
 */ LineGraph.prototype._onRemoveGroups = function(groupIds) {
    for(var i1 = 0; i1 < groupIds.length; i1++)this._removeGroup(groupIds[i1]);
    this.forceGraphUpdate = true;
    this.body.emitter.emit("_change", {
        queue: true
    });
};
/**
 * this cleans the group out off the legends and the dataaxis
 * @param {vis.GraphGroup.id} groupId
 * @private
 */ LineGraph.prototype._removeGroup = function(groupId) {
    if (this.groups.hasOwnProperty(groupId)) {
        if (this.groups[groupId].options.yAxisOrientation == "right") {
            this.yAxisRight.removeGroup(groupId);
            this.legendRight.removeGroup(groupId);
            this.legendRight.redraw();
        } else {
            this.yAxisLeft.removeGroup(groupId);
            this.legendLeft.removeGroup(groupId);
            this.legendLeft.redraw();
        }
        delete this.groups[groupId];
    }
};
/**
 * update a group object with the group dataset entree
 *
 * @param {vis.GraphGroup} group
 * @param {vis.GraphGroup.id} groupId
 * @private
 */ LineGraph.prototype._updateGroup = function(group, groupId) {
    if (!this.groups.hasOwnProperty(groupId)) {
        this.groups[groupId] = new GraphGroup(group, groupId, this.options, this.groupsUsingDefaultStyles);
        if (this.groups[groupId].options.yAxisOrientation == "right") {
            this.yAxisRight.addGroup(groupId, this.groups[groupId]);
            this.legendRight.addGroup(groupId, this.groups[groupId]);
        } else {
            this.yAxisLeft.addGroup(groupId, this.groups[groupId]);
            this.legendLeft.addGroup(groupId, this.groups[groupId]);
        }
    } else {
        this.groups[groupId].update(group);
        if (this.groups[groupId].options.yAxisOrientation == "right") {
            this.yAxisRight.updateGroup(groupId, this.groups[groupId]);
            this.legendRight.updateGroup(groupId, this.groups[groupId]);
            //If yAxisOrientation changed, clean out the group from the other axis.
            this.yAxisLeft.removeGroup(groupId);
            this.legendLeft.removeGroup(groupId);
        } else {
            this.yAxisLeft.updateGroup(groupId, this.groups[groupId]);
            this.legendLeft.updateGroup(groupId, this.groups[groupId]);
            //If yAxisOrientation changed, clean out the group from the other axis.
            this.yAxisRight.removeGroup(groupId);
            this.legendRight.removeGroup(groupId);
        }
    }
    this.legendLeft.redraw();
    this.legendRight.redraw();
};
/**
 * this updates all groups, it is used when there is an update the the itemset.
 *
 * @param  {Array} ids
 * @param  {Array} groupIds
 * @private
 */ LineGraph.prototype._updateAllGroupData = function(ids, groupIds) {
    if (this.itemsData != null) {
        var groupsContent = {};
        var items = this.itemsData.get();
        var fieldId = this.itemsData.idProp;
        var idMap = {};
        if (ids) _mapInstanceProperty(ids).call(ids, function(id) {
            idMap[id] = id;
        });
        //pre-Determine array sizes, for more efficient memory claim
        var groupCounts = {};
        for(var i1 = 0; i1 < items.length; i1++){
            var item = items[i1];
            var groupId = item.group;
            if (groupId === null || groupId === undefined) groupId = UNGROUPED;
            groupCounts.hasOwnProperty(groupId) ? groupCounts[groupId]++ : groupCounts[groupId] = 1;
        }
        //Pre-load arrays from existing groups if items are not changed (not in ids)
        var existingItemsMap = {};
        if (!groupIds && ids) {
            for(groupId in this.groups)if (this.groups.hasOwnProperty(groupId)) {
                group = this.groups[groupId];
                var existing_items = group.getItems();
                groupsContent[groupId] = _filterInstanceProperty(existing_items).call(existing_items, function(item) {
                    existingItemsMap[item[fieldId]] = item[fieldId];
                    return item[fieldId] !== idMap[item[fieldId]];
                });
                var newLength = groupCounts[groupId];
                groupCounts[groupId] -= groupsContent[groupId].length;
                if (groupsContent[groupId].length < newLength) groupsContent[groupId][newLength - 1] = {};
            }
        }
        //Now insert data into the arrays.
        for(i1 = 0; i1 < items.length; i1++){
            item = items[i1];
            groupId = item.group;
            if (groupId === null || groupId === undefined) groupId = UNGROUPED;
            if (!groupIds && ids && item[fieldId] !== idMap[item[fieldId]] && existingItemsMap.hasOwnProperty(item[fieldId])) continue;
            if (!groupsContent.hasOwnProperty(groupId)) groupsContent[groupId] = new Array(groupCounts[groupId]);
            //Copy data (because of unmodifiable DataView input.
            var extended = availableUtils.bridgeObject(item);
            extended.x = availableUtils.convert(item.x, "Date");
            extended.end = availableUtils.convert(item.end, "Date");
            extended.orginalY = item.y; //real Y
            extended.y = Number(item.y);
            extended[fieldId] = item[fieldId];
            var index = groupsContent[groupId].length - groupCounts[groupId]--;
            groupsContent[groupId][index] = extended;
        }
        //Make sure all groups are present, to allow removal of old groups
        for(groupId in this.groups){
            if (this.groups.hasOwnProperty(groupId)) {
                if (!groupsContent.hasOwnProperty(groupId)) groupsContent[groupId] = new Array(0);
            }
        }
        //Update legendas, style and axis
        for(groupId in groupsContent)if (groupsContent.hasOwnProperty(groupId)) {
            if (groupsContent[groupId].length == 0) {
                if (this.groups.hasOwnProperty(groupId)) this._removeGroup(groupId);
            } else {
                var group = undefined;
                if (this.groupsData != undefined) group = this.groupsData.get(groupId);
                if (group == undefined) group = {
                    id: groupId,
                    content: this.options.defaultGroup + groupId
                };
                this._updateGroup(group, groupId);
                this.groups[groupId].setItems(groupsContent[groupId]);
            }
        }
        this.forceGraphUpdate = true;
        this.body.emitter.emit("_change", {
            queue: true
        });
    }
};
/**
 * Redraw the component, mandatory function
 * @return {boolean} Returns true if the component is resized
 */ LineGraph.prototype.redraw = function() {
    var resized = false;
    // calculate actual size and position
    this.props.width = this.dom.frame.offsetWidth;
    this.props.height = this.body.domProps.centerContainer.height - this.body.domProps.border.top - this.body.domProps.border.bottom;
    // check if this component is resized
    resized = this._isResized() || resized;
    // check whether zoomed (in that case we need to re-stack everything)
    var visibleInterval = this.body.range.end - this.body.range.start;
    var zoomed = visibleInterval != this.lastVisibleInterval;
    this.lastVisibleInterval = visibleInterval;
    // the svg element is three times as big as the width, this allows for fully dragging left and right
    // without reloading the graph. the controls for this are bound to events in the constructor
    if (resized == true) {
        var _context;
        this.svg.style.width = availableUtils.option.asSize(3 * this.props.width);
        this.svg.style.left = availableUtils.option.asSize(-this.props.width);
        // if the height of the graph is set as proportional, change the height of the svg
        if (_indexOfInstanceProperty(_context = this.options.height + "").call(_context, "%") != -1 || this.updateSVGheightOnResize == true) this.updateSVGheight = true;
    }
    // update the height of the graph on each redraw of the graph.
    if (this.updateSVGheight == true) {
        if (this.options.graphHeight != this.props.height + "px") {
            this.options.graphHeight = this.props.height + "px";
            this.svg.style.height = this.props.height + "px";
        }
        this.updateSVGheight = false;
    } else this.svg.style.height = ("" + this.options.graphHeight).replace("px", "") + "px";
    // zoomed is here to ensure that animations are shown correctly.
    if (resized == true || zoomed == true || this.abortedGraphUpdate == true || this.forceGraphUpdate == true) {
        resized = this._updateGraph() || resized;
        this.forceGraphUpdate = false;
        this.lastStart = this.body.range.start;
        this.svg.style.left = -this.props.width + "px";
    } else // move the whole svg while dragging
    if (this.lastStart != 0) {
        var offset = this.body.range.start - this.lastStart;
        var range = this.body.range.end - this.body.range.start;
        if (this.props.width != 0) {
            var rangePerPixelInv = this.props.width / range;
            var xOffset = offset * rangePerPixelInv;
            this.svg.style.left = -this.props.width - xOffset + "px";
        }
    }
    this.legendLeft.redraw();
    this.legendRight.redraw();
    return resized;
};
LineGraph.prototype._getSortedGroupIds = function() {
    // getting group Ids
    var grouplist = [];
    for(var groupId in this.groups)if (this.groups.hasOwnProperty(groupId)) {
        var group = this.groups[groupId];
        if (group.visible == true && (this.options.groups.visibility[groupId] === undefined || this.options.groups.visibility[groupId] == true)) grouplist.push({
            id: groupId,
            zIndex: group.options.zIndex
        });
    }
    availableUtils.insertSort(grouplist, function(a, b) {
        var az = a.zIndex;
        var bz = b.zIndex;
        if (az === undefined) az = 0;
        if (bz === undefined) bz = 0;
        return az == bz ? 0 : az < bz ? -1 : 1;
    });
    var groupIds = new Array(grouplist.length);
    for(var i1 = 0; i1 < grouplist.length; i1++)groupIds[i1] = grouplist[i1].id;
    return groupIds;
};
/**
 * Update and redraw the graph.
 *
 * @returns {boolean}
 * @private
 */ LineGraph.prototype._updateGraph = function() {
    // reset the svg elements
    prepareElements(this.svgElements);
    if (this.props.width != 0 && this.itemsData != null) {
        var group, i1;
        var groupRanges = {};
        var changeCalled = false;
        // this is the range of the SVG canvas
        var minDate = this.body.util.toGlobalTime(-this.body.domProps.root.width);
        var maxDate = this.body.util.toGlobalTime(2 * this.body.domProps.root.width);
        // getting group Ids
        var groupIds = this._getSortedGroupIds();
        if (groupIds.length > 0) {
            var groupsData = {};
            // fill groups data, this only loads the data we require based on the timewindow
            this._getRelevantData(groupIds, groupsData, minDate, maxDate);
            // apply sampling, if disabled, it will pass through this function.
            this._applySampling(groupIds, groupsData);
            // we transform the X coordinates to detect collisions
            for(i1 = 0; i1 < groupIds.length; i1++)this._convertXcoordinates(groupsData[groupIds[i1]]);
            // now all needed data has been collected we start the processing.
            this._getYRanges(groupIds, groupsData, groupRanges);
            // update the Y axis first, we use this data to draw at the correct Y points
            changeCalled = this._updateYAxis(groupIds, groupRanges);
            //  at changeCalled, abort this update cycle as the graph needs another update with new Width input from the Redraw container.
            //  Cleanup SVG elements on abort.
            if (changeCalled == true) {
                cleanupElements(this.svgElements);
                this.abortedGraphUpdate = true;
                return true;
            }
            this.abortedGraphUpdate = false;
            // With the yAxis scaled correctly, use this to get the Y values of the points.
            var below = undefined;
            for(i1 = 0; i1 < groupIds.length; i1++){
                group = this.groups[groupIds[i1]];
                if (this.options.stack === true && this.options.style === "line") {
                    if (group.options.excludeFromStacking == undefined || !group.options.excludeFromStacking) {
                        if (below != undefined) {
                            this._stack(groupsData[group.id], groupsData[below.id]);
                            if (group.options.shaded.enabled == true && group.options.shaded.orientation !== "group") {
                                if (group.options.shaded.orientation == "top" && below.options.shaded.orientation !== "group") {
                                    below.options.shaded.orientation = "group";
                                    below.options.shaded.groupId = group.id;
                                } else {
                                    group.options.shaded.orientation = "group";
                                    group.options.shaded.groupId = below.id;
                                }
                            }
                        }
                        below = group;
                    }
                }
                this._convertYcoordinates(groupsData[groupIds[i1]], group);
            }
            //Precalculate paths and draw shading if appropriate. This will make sure the shading is always behind any lines.
            var paths = {};
            for(i1 = 0; i1 < groupIds.length; i1++){
                group = this.groups[groupIds[i1]];
                if (group.options.style === "line" && group.options.shaded.enabled == true) {
                    var dataset = groupsData[groupIds[i1]];
                    if (dataset == null || dataset.length == 0) continue;
                    if (!paths.hasOwnProperty(groupIds[i1])) paths[groupIds[i1]] = Line.calcPath(dataset, group);
                    if (group.options.shaded.orientation === "group") {
                        var subGroupId = group.options.shaded.groupId;
                        if (_indexOfInstanceProperty(groupIds).call(groupIds, subGroupId) === -1) {
                            console.log(group.id + ": Unknown shading group target given:" + subGroupId);
                            continue;
                        }
                        if (!paths.hasOwnProperty(subGroupId)) paths[subGroupId] = Line.calcPath(groupsData[subGroupId], this.groups[subGroupId]);
                        Line.drawShading(paths[groupIds[i1]], group, paths[subGroupId], this.framework);
                    } else Line.drawShading(paths[groupIds[i1]], group, undefined, this.framework);
                }
            }
            // draw the groups, calculating paths if still necessary.
            Bargraph.draw(groupIds, groupsData, this.framework);
            for(i1 = 0; i1 < groupIds.length; i1++){
                group = this.groups[groupIds[i1]];
                if (groupsData[groupIds[i1]].length > 0) switch(group.options.style){
                    case "line":
                        if (!paths.hasOwnProperty(groupIds[i1])) paths[groupIds[i1]] = Line.calcPath(groupsData[groupIds[i1]], group);
                        Line.draw(paths[groupIds[i1]], group, this.framework);
                    // eslint-disable-line no-fallthrough
                    case "point":
                    // eslint-disable-line no-fallthrough
                    case "points":
                        if (group.options.style == "point" || group.options.style == "points" || group.options.drawPoints.enabled == true) Points.draw(groupsData[groupIds[i1]], group, this.framework);
                        break;
                }
            }
        }
    }
    // cleanup unused svg elements
    cleanupElements(this.svgElements);
    return false;
};
LineGraph.prototype._stack = function(data, subData) {
    var index, dx, dy, subPrevPoint, subNextPoint;
    index = 0;
    // for each data point we look for a matching on in the set below
    for(var j = 0; j < data.length; j++){
        subPrevPoint = undefined;
        subNextPoint = undefined;
        // we look for time matches or a before-after point
        for(var k = index; k < subData.length; k++){
            // if times match exactly
            if (subData[k].x === data[j].x) {
                subPrevPoint = subData[k];
                subNextPoint = subData[k];
                index = k;
                break;
            } else if (subData[k].x > data[j].x) {
                // overshoot
                subNextPoint = subData[k];
                if (k == 0) subPrevPoint = subNextPoint;
                else subPrevPoint = subData[k - 1];
                index = k;
                break;
            }
        }
        // in case the last data point has been used, we assume it stays like this.
        if (subNextPoint === undefined) {
            subPrevPoint = subData[subData.length - 1];
            subNextPoint = subData[subData.length - 1];
        }
        // linear interpolation
        dx = subNextPoint.x - subPrevPoint.x;
        dy = subNextPoint.y - subPrevPoint.y;
        if (dx == 0) data[j].y = data[j].orginalY + subNextPoint.y;
        else data[j].y = data[j].orginalY + dy / dx * (data[j].x - subPrevPoint.x) + subPrevPoint.y; // ax + b where b is data[j].y
    }
};
/**
 * first select and preprocess the data from the datasets.
 * the groups have their preselection of data, we now loop over this data to see
 * what data we need to draw. Sorted data is much faster.
 * more optimization is possible by doing the sampling before and using the binary search
 * to find the end date to determine the increment.
 *
 * @param {array}  groupIds
 * @param {object} groupsData
 * @param {date}   minDate
 * @param {date}   maxDate
 * @private
 */ LineGraph.prototype._getRelevantData = function(groupIds, groupsData, minDate, maxDate) {
    var group, i1, j, item;
    if (groupIds.length > 0) for(i1 = 0; i1 < groupIds.length; i1++){
        group = this.groups[groupIds[i1]];
        var itemsData = group.getItems();
        // optimization for sorted data
        if (_sortInstanceProperty(group.options) == true) {
            var dateComparator = function dateComparator(a, b) {
                return a.getTime() == b.getTime() ? 0 : a < b ? -1 : 1;
            };
            var first = Math.max(0, availableUtils.binarySearchValue(itemsData, minDate, "x", "before", dateComparator));
            var last = Math.min(itemsData.length, availableUtils.binarySearchValue(itemsData, maxDate, "x", "after", dateComparator) + 1);
            if (last <= 0) last = itemsData.length;
            var dataContainer = new Array(last - first);
            for(j = first; j < last; j++){
                item = group.itemsData[j];
                dataContainer[j - first] = item;
            }
            groupsData[groupIds[i1]] = dataContainer;
        } else // If unsorted data, all data is relevant, just returning entire structure
        groupsData[groupIds[i1]] = group.itemsData;
    }
};
/**
 *
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {vis.DataSet} groupsData
 * @private
 */ LineGraph.prototype._applySampling = function(groupIds, groupsData) {
    var group;
    if (groupIds.length > 0) for(var i1 = 0; i1 < groupIds.length; i1++){
        group = this.groups[groupIds[i1]];
        if (group.options.sampling == true) {
            var dataContainer = groupsData[groupIds[i1]];
            if (dataContainer.length > 0) {
                var increment = 1;
                var amountOfPoints = dataContainer.length;
                // the global screen is used because changing the width of the yAxis may affect the increment, resulting in an endless loop
                // of width changing of the yAxis.
                //TODO: This assumes sorted data, but that's not guaranteed!
                var xDistance = this.body.util.toGlobalScreen(dataContainer[dataContainer.length - 1].x) - this.body.util.toGlobalScreen(dataContainer[0].x);
                var pointsPerPixel = amountOfPoints / xDistance;
                increment = Math.min(Math.ceil(0.2 * amountOfPoints), Math.max(1, Math.round(pointsPerPixel)));
                var sampledData = new Array(amountOfPoints);
                for(var j = 0; j < amountOfPoints; j += increment){
                    var idx = Math.round(j / increment);
                    sampledData[idx] = dataContainer[j];
                }
                groupsData[groupIds[i1]] = _spliceInstanceProperty(sampledData).call(sampledData, 0, Math.round(amountOfPoints / increment));
            }
        }
    }
};
/**
 *
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {vis.DataSet} groupsData
 * @param {object} groupRanges  | this is being filled here
 * @private
 */ LineGraph.prototype._getYRanges = function(groupIds, groupsData, groupRanges) {
    var groupData, group, i1;
    var combinedDataLeft = [];
    var combinedDataRight = [];
    var options;
    if (groupIds.length > 0) {
        for(i1 = 0; i1 < groupIds.length; i1++){
            groupData = groupsData[groupIds[i1]];
            options = this.groups[groupIds[i1]].options;
            if (groupData.length > 0) {
                group = this.groups[groupIds[i1]];
                // if bar graphs are stacked, their range need to be handled differently and accumulated over all groups.
                if (options.stack === true && options.style === "bar") {
                    if (options.yAxisOrientation === "left") combinedDataLeft = _concatInstanceProperty(combinedDataLeft).call(combinedDataLeft, groupData);
                    else combinedDataRight = _concatInstanceProperty(combinedDataRight).call(combinedDataRight, groupData);
                } else groupRanges[groupIds[i1]] = group.getYRange(groupData, groupIds[i1]);
            }
        }
        // if bar graphs are stacked, their range need to be handled differently and accumulated over all groups.
        Bargraph.getStackedYRange(combinedDataLeft, groupRanges, groupIds, "__barStackLeft", "left");
        Bargraph.getStackedYRange(combinedDataRight, groupRanges, groupIds, "__barStackRight", "right");
    }
};
/**
 * this sets the Y ranges for the Y axis. It also determines which of the axis should be shown or hidden.
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {Object} groupRanges
 * @returns {boolean} resized
 * @private
 */ LineGraph.prototype._updateYAxis = function(groupIds, groupRanges) {
    var resized = false;
    var yAxisLeftUsed = false;
    var yAxisRightUsed = false;
    var minLeft = 1e9, minRight = 1e9, maxLeft = -1000000000, maxRight = -1000000000, minVal, maxVal;
    // if groups are present
    if (groupIds.length > 0) {
        // this is here to make sure that if there are no items in the axis but there are groups, that there is no infinite draw/redraw loop.
        for(var i1 = 0; i1 < groupIds.length; i1++){
            var group = this.groups[groupIds[i1]];
            if (group && group.options.yAxisOrientation != "right") {
                yAxisLeftUsed = true;
                minLeft = 1e9;
                maxLeft = -1000000000;
            } else if (group && group.options.yAxisOrientation) {
                yAxisRightUsed = true;
                minRight = 1e9;
                maxRight = -1000000000;
            }
        }
        // if there are items:
        for(i1 = 0; i1 < groupIds.length; i1++){
            if (groupRanges.hasOwnProperty(groupIds[i1])) {
                if (groupRanges[groupIds[i1]].ignore !== true) {
                    minVal = groupRanges[groupIds[i1]].min;
                    maxVal = groupRanges[groupIds[i1]].max;
                    if (groupRanges[groupIds[i1]].yAxisOrientation != "right") {
                        yAxisLeftUsed = true;
                        minLeft = minLeft > minVal ? minVal : minLeft;
                        maxLeft = maxLeft < maxVal ? maxVal : maxLeft;
                    } else {
                        yAxisRightUsed = true;
                        minRight = minRight > minVal ? minVal : minRight;
                        maxRight = maxRight < maxVal ? maxVal : maxRight;
                    }
                }
            }
        }
        if (yAxisLeftUsed == true) this.yAxisLeft.setRange(minLeft, maxLeft);
        if (yAxisRightUsed == true) this.yAxisRight.setRange(minRight, maxRight);
    }
    resized = this._toggleAxisVisiblity(yAxisLeftUsed, this.yAxisLeft) || resized;
    resized = this._toggleAxisVisiblity(yAxisRightUsed, this.yAxisRight) || resized;
    if (yAxisRightUsed == true && yAxisLeftUsed == true) {
        this.yAxisLeft.drawIcons = true;
        this.yAxisRight.drawIcons = true;
    } else {
        this.yAxisLeft.drawIcons = false;
        this.yAxisRight.drawIcons = false;
    }
    this.yAxisRight.master = !yAxisLeftUsed;
    this.yAxisRight.masterAxis = this.yAxisLeft;
    if (this.yAxisRight.master == false) {
        if (yAxisRightUsed == true) this.yAxisLeft.lineOffset = this.yAxisRight.width;
        else this.yAxisLeft.lineOffset = 0;
        resized = this.yAxisLeft.redraw() || resized;
        resized = this.yAxisRight.redraw() || resized;
    } else resized = this.yAxisRight.redraw() || resized;
    // clean the accumulated lists
    var tempGroups = [
        "__barStackLeft",
        "__barStackRight",
        "__lineStackLeft",
        "__lineStackRight"
    ];
    for(i1 = 0; i1 < tempGroups.length; i1++)if (_indexOfInstanceProperty(groupIds).call(groupIds, tempGroups[i1]) != -1) _spliceInstanceProperty(groupIds).call(groupIds, _indexOfInstanceProperty(groupIds).call(groupIds, tempGroups[i1]), 1);
    return resized;
};
/**
 * This shows or hides the Y axis if needed. If there is a change, the changed event is emitted by the updateYAxis function
 *
 * @param {boolean} axisUsed
 * @param {vis.DataAxis}  axis
 * @returns {boolean}
 * @private
 */ LineGraph.prototype._toggleAxisVisiblity = function(axisUsed, axis) {
    var changed = false;
    if (axisUsed == false) {
        if (axis.dom.frame.parentNode && axis.hidden == false) {
            axis.hide();
            changed = true;
        }
    } else if (!axis.dom.frame.parentNode && axis.hidden == true) {
        axis.show();
        changed = true;
    }
    return changed;
};
/**
 * This uses the DataAxis object to generate the correct X coordinate on the SVG window. It uses the
 * util function toScreen to get the x coordinate from the timestamp. It also pre-filters the data and get the minMax ranges for
 * the yAxis.
 *
 * @param {Array.<Object>} datapoints
 * @private
 */ LineGraph.prototype._convertXcoordinates = function(datapoints) {
    var toScreen = this.body.util.toScreen;
    for(var i1 = 0; i1 < datapoints.length; i1++){
        datapoints[i1].screen_x = toScreen(datapoints[i1].x) + this.props.width;
        datapoints[i1].screen_y = datapoints[i1].y; //starting point for range calculations
        if (datapoints[i1].end != undefined) datapoints[i1].screen_end = toScreen(datapoints[i1].end) + this.props.width;
        else datapoints[i1].screen_end = undefined;
    }
};
/**
 * This uses the DataAxis object to generate the correct X coordinate on the SVG window. It uses the
 * util function toScreen to get the x coordinate from the timestamp. It also pre-filters the data and get the minMax ranges for
 * the yAxis.
 *
 * @param {Array.<Object>} datapoints
 * @param {vis.GraphGroup} group
 * @private
 */ LineGraph.prototype._convertYcoordinates = function(datapoints, group) {
    var axis = this.yAxisLeft;
    var svgHeight = Number(this.svg.style.height.replace("px", ""));
    if (group.options.yAxisOrientation == "right") axis = this.yAxisRight;
    for(var i1 = 0; i1 < datapoints.length; i1++)datapoints[i1].screen_y = Math.round(axis.convertValue(datapoints[i1].y));
    group.setZeroPosition(Math.min(svgHeight, axis.convertValue(0)));
};
/**
 * This object contains all possible options. It will check if the types are correct, if required if the option is one
 * of the allowed values.
 *
 * __any__ means that the name of the property does not matter.
 * __type__ is a required field for all objects and contains the allowed types of all objects
 */ var string = "string";
var bool = "boolean";
var number = "number";
var array = "array";
var date = "date";
var object = "object"; // should only be in a __type__ property
var dom = "dom";
var moment = "moment";
var any = "any";
var allOptions = {
    configure: {
        enabled: {
            "boolean": bool
        },
        filter: {
            "boolean": bool,
            "function": "function"
        },
        container: {
            dom: dom
        },
        __type__: {
            object: object,
            "boolean": bool,
            "function": "function"
        }
    },
    //globals :
    alignCurrentTime: {
        string: string,
        "undefined": "undefined"
    },
    yAxisOrientation: {
        string: [
            "left",
            "right"
        ]
    },
    defaultGroup: {
        string: string
    },
    sort: {
        "boolean": bool
    },
    sampling: {
        "boolean": bool
    },
    stack: {
        "boolean": bool
    },
    graphHeight: {
        string: string,
        number: number
    },
    shaded: {
        enabled: {
            "boolean": bool
        },
        orientation: {
            string: [
                "bottom",
                "top",
                "zero",
                "group"
            ]
        },
        // top, bottom, zero, group
        groupId: {
            object: object
        },
        __type__: {
            "boolean": bool,
            object: object
        }
    },
    style: {
        string: [
            "line",
            "bar",
            "points"
        ]
    },
    // line, bar
    barChart: {
        width: {
            number: number
        },
        minWidth: {
            number: number
        },
        sideBySide: {
            "boolean": bool
        },
        align: {
            string: [
                "left",
                "center",
                "right"
            ]
        },
        __type__: {
            object: object
        }
    },
    interpolation: {
        enabled: {
            "boolean": bool
        },
        parametrization: {
            string: [
                "centripetal",
                "chordal",
                "uniform"
            ]
        },
        // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
        alpha: {
            number: number
        },
        __type__: {
            object: object,
            "boolean": bool
        }
    },
    drawPoints: {
        enabled: {
            "boolean": bool
        },
        onRender: {
            "function": "function"
        },
        size: {
            number: number
        },
        style: {
            string: [
                "square",
                "circle"
            ]
        },
        // square, circle
        __type__: {
            object: object,
            "boolean": bool,
            "function": "function"
        }
    },
    dataAxis: {
        showMinorLabels: {
            "boolean": bool
        },
        showMajorLabels: {
            "boolean": bool
        },
        showWeekScale: {
            "boolean": bool
        },
        icons: {
            "boolean": bool
        },
        width: {
            string: string,
            number: number
        },
        visible: {
            "boolean": bool
        },
        alignZeros: {
            "boolean": bool
        },
        left: {
            range: {
                min: {
                    number: number,
                    "undefined": "undefined"
                },
                max: {
                    number: number,
                    "undefined": "undefined"
                },
                __type__: {
                    object: object
                }
            },
            format: {
                "function": "function"
            },
            title: {
                text: {
                    string: string,
                    number: number,
                    "undefined": "undefined"
                },
                style: {
                    string: string,
                    "undefined": "undefined"
                },
                __type__: {
                    object: object
                }
            },
            __type__: {
                object: object
            }
        },
        right: {
            range: {
                min: {
                    number: number,
                    "undefined": "undefined"
                },
                max: {
                    number: number,
                    "undefined": "undefined"
                },
                __type__: {
                    object: object
                }
            },
            format: {
                "function": "function"
            },
            title: {
                text: {
                    string: string,
                    number: number,
                    "undefined": "undefined"
                },
                style: {
                    string: string,
                    "undefined": "undefined"
                },
                __type__: {
                    object: object
                }
            },
            __type__: {
                object: object
            }
        },
        __type__: {
            object: object
        }
    },
    legend: {
        enabled: {
            "boolean": bool
        },
        icons: {
            "boolean": bool
        },
        left: {
            visible: {
                "boolean": bool
            },
            position: {
                string: [
                    "top-right",
                    "bottom-right",
                    "top-left",
                    "bottom-left"
                ]
            },
            __type__: {
                object: object
            }
        },
        right: {
            visible: {
                "boolean": bool
            },
            position: {
                string: [
                    "top-right",
                    "bottom-right",
                    "top-left",
                    "bottom-left"
                ]
            },
            __type__: {
                object: object
            }
        },
        __type__: {
            object: object,
            "boolean": bool
        }
    },
    groups: {
        visibility: {
            any: any
        },
        __type__: {
            object: object
        }
    },
    autoResize: {
        "boolean": bool
    },
    throttleRedraw: {
        number: number
    },
    // TODO: DEPRICATED see https://github.com/almende/vis/issues/2511
    clickToUse: {
        "boolean": bool
    },
    end: {
        number: number,
        date: date,
        string: string,
        moment: moment
    },
    format: {
        minorLabels: {
            millisecond: {
                string: string,
                "undefined": "undefined"
            },
            second: {
                string: string,
                "undefined": "undefined"
            },
            minute: {
                string: string,
                "undefined": "undefined"
            },
            hour: {
                string: string,
                "undefined": "undefined"
            },
            weekday: {
                string: string,
                "undefined": "undefined"
            },
            day: {
                string: string,
                "undefined": "undefined"
            },
            week: {
                string: string,
                "undefined": "undefined"
            },
            month: {
                string: string,
                "undefined": "undefined"
            },
            quarter: {
                string: string,
                "undefined": "undefined"
            },
            year: {
                string: string,
                "undefined": "undefined"
            },
            __type__: {
                object: object
            }
        },
        majorLabels: {
            millisecond: {
                string: string,
                "undefined": "undefined"
            },
            second: {
                string: string,
                "undefined": "undefined"
            },
            minute: {
                string: string,
                "undefined": "undefined"
            },
            hour: {
                string: string,
                "undefined": "undefined"
            },
            weekday: {
                string: string,
                "undefined": "undefined"
            },
            day: {
                string: string,
                "undefined": "undefined"
            },
            week: {
                string: string,
                "undefined": "undefined"
            },
            month: {
                string: string,
                "undefined": "undefined"
            },
            quarter: {
                string: string,
                "undefined": "undefined"
            },
            year: {
                string: string,
                "undefined": "undefined"
            },
            __type__: {
                object: object
            }
        },
        __type__: {
            object: object
        }
    },
    moment: {
        "function": "function"
    },
    height: {
        string: string,
        number: number
    },
    hiddenDates: {
        start: {
            date: date,
            number: number,
            string: string,
            moment: moment
        },
        end: {
            date: date,
            number: number,
            string: string,
            moment: moment
        },
        repeat: {
            string: string
        },
        __type__: {
            object: object,
            array: array
        }
    },
    locale: {
        string: string
    },
    locales: {
        __any__: {
            any: any
        },
        __type__: {
            object: object
        }
    },
    max: {
        date: date,
        number: number,
        string: string,
        moment: moment
    },
    maxHeight: {
        number: number,
        string: string
    },
    maxMinorChars: {
        number: number
    },
    min: {
        date: date,
        number: number,
        string: string,
        moment: moment
    },
    minHeight: {
        number: number,
        string: string
    },
    moveable: {
        "boolean": bool
    },
    multiselect: {
        "boolean": bool
    },
    orientation: {
        string: string
    },
    showCurrentTime: {
        "boolean": bool
    },
    showMajorLabels: {
        "boolean": bool
    },
    showMinorLabels: {
        "boolean": bool
    },
    showWeekScale: {
        "boolean": bool
    },
    snap: {
        "function": "function",
        "null": "null"
    },
    start: {
        date: date,
        number: number,
        string: string,
        moment: moment
    },
    timeAxis: {
        scale: {
            string: string,
            "undefined": "undefined"
        },
        step: {
            number: number,
            "undefined": "undefined"
        },
        __type__: {
            object: object
        }
    },
    width: {
        string: string,
        number: number
    },
    zoomable: {
        "boolean": bool
    },
    zoomKey: {
        string: [
            "ctrlKey",
            "altKey",
            "metaKey",
            ""
        ]
    },
    zoomMax: {
        number: number
    },
    zoomMin: {
        number: number
    },
    zIndex: {
        number: number
    },
    __type__: {
        object: object
    }
};
var configureOptions = {
    global: {
        alignCurrentTime: [
            "none",
            "year",
            "month",
            "quarter",
            "week",
            "isoWeek",
            "day",
            "date",
            "hour",
            "minute",
            "second"
        ],
        //yAxisOrientation: ['left','right'], // TDOO: enable as soon as Grahp2d doesn't crash when changing this on the fly
        sort: true,
        sampling: true,
        stack: false,
        shaded: {
            enabled: false,
            orientation: [
                "zero",
                "top",
                "bottom",
                "group"
            ] // zero, top, bottom
        },
        style: [
            "line",
            "bar",
            "points"
        ],
        // line, bar
        barChart: {
            width: [
                50,
                5,
                100,
                5
            ],
            minWidth: [
                50,
                5,
                100,
                5
            ],
            sideBySide: false,
            align: [
                "left",
                "center",
                "right"
            ] // left, center, right
        },
        interpolation: {
            enabled: true,
            parametrization: [
                "centripetal",
                "chordal",
                "uniform"
            ] // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
        },
        drawPoints: {
            enabled: true,
            size: [
                6,
                2,
                30,
                1
            ],
            style: [
                "square",
                "circle"
            ] // square, circle
        },
        dataAxis: {
            showMinorLabels: true,
            showMajorLabels: true,
            showWeekScale: false,
            icons: false,
            width: [
                40,
                0,
                200,
                1
            ],
            visible: true,
            alignZeros: true,
            left: {
                //range: {min:'undefined': 'undefined'ined,max:'undefined': 'undefined'ined},
                //format: function (value) {return value;},
                title: {
                    text: "",
                    style: ""
                }
            },
            right: {
                //range: {min:'undefined': 'undefined'ined,max:'undefined': 'undefined'ined},
                //format: function (value) {return value;},
                title: {
                    text: "",
                    style: ""
                }
            }
        },
        legend: {
            enabled: false,
            icons: true,
            left: {
                visible: true,
                position: [
                    "top-right",
                    "bottom-right",
                    "top-left",
                    "bottom-left"
                ] // top/bottom - left,right
            },
            right: {
                visible: true,
                position: [
                    "top-right",
                    "bottom-right",
                    "top-left",
                    "bottom-left"
                ] // top/bottom - left,right
            }
        },
        autoResize: true,
        clickToUse: false,
        end: "",
        format: {
            minorLabels: {
                millisecond: "SSS",
                second: "s",
                minute: "HH:mm",
                hour: "HH:mm",
                weekday: "ddd D",
                day: "D",
                week: "w",
                month: "MMM",
                quarter: "[Q]Q",
                year: "YYYY"
            },
            majorLabels: {
                millisecond: "HH:mm:ss",
                second: "D MMMM HH:mm",
                minute: "ddd D MMMM",
                hour: "ddd D MMMM",
                weekday: "MMMM YYYY",
                day: "MMMM YYYY",
                week: "MMMM YYYY",
                month: "YYYY",
                quarter: "YYYY",
                year: ""
            }
        },
        height: "",
        locale: "",
        max: "",
        maxHeight: "",
        maxMinorChars: [
            7,
            0,
            20,
            1
        ],
        min: "",
        minHeight: "",
        moveable: true,
        orientation: [
            "both",
            "bottom",
            "top"
        ],
        showCurrentTime: false,
        showMajorLabels: true,
        showMinorLabels: true,
        showWeekScale: false,
        start: "",
        width: "100%",
        zoomable: true,
        zoomKey: [
            "ctrlKey",
            "altKey",
            "metaKey",
            ""
        ],
        zoomMax: [
            315360000000000,
            10,
            315360000000000,
            1
        ],
        zoomMin: [
            10,
            10,
            315360000000000,
            1
        ],
        zIndex: 0
    }
};
/**
 * Create a timeline visualization
 * @param {HTMLElement} container
 * @param {vis.DataSet | Array} [items]
 * @param {vis.DataSet | Array | vis.DataView | Object} [groups]
 * @param {Object} [options]  See Graph2d.setOptions for the available options.
 * @constructor Graph2d
 * @extends Core
 */ function Graph2d(container, items, groups, options) {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7;
    // if the third element is options, the forth is groups (optionally);
    if (!(_Array$isArray(groups) || isDataViewLike(groups)) && groups instanceof Object) {
        var forthArgument = options;
        options = groups;
        groups = forthArgument;
    }
    // TODO: REMOVE THIS in the next MAJOR release
    // see https://github.com/almende/vis/issues/2511
    if (options && options.throttleRedraw) console.warn('Graph2d option "throttleRedraw" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.');
    var me = this;
    this.defaultOptions = {
        start: null,
        end: null,
        autoResize: true,
        orientation: {
            axis: "bottom",
            // axis orientation: 'bottom', 'top', or 'both'
            item: "bottom" // not relevant for Graph2d
        },
        moment: moment$4,
        width: null,
        height: null,
        maxHeight: null,
        minHeight: null
    };
    this.options = availableUtils.deepExtend({}, this.defaultOptions);
    // Create the DOM, props, and emitter
    this._create(container);
    // all components listed here will be repainted automatically
    this.components = [];
    this.body = {
        dom: this.dom,
        domProps: this.props,
        emitter: {
            on: _bindInstanceProperty$1(_context = this.on).call(_context, this),
            off: _bindInstanceProperty$1(_context2 = this.off).call(_context2, this),
            emit: _bindInstanceProperty$1(_context3 = this.emit).call(_context3, this)
        },
        hiddenDates: [],
        util: {
            getScale: function getScale() {
                return me.timeAxis.step.scale;
            },
            getStep: function getStep() {
                return me.timeAxis.step.step;
            },
            toScreen: _bindInstanceProperty$1(_context4 = me._toScreen).call(_context4, me),
            toGlobalScreen: _bindInstanceProperty$1(_context5 = me._toGlobalScreen).call(_context5, me),
            // this refers to the root.width
            toTime: _bindInstanceProperty$1(_context6 = me._toTime).call(_context6, me),
            toGlobalTime: _bindInstanceProperty$1(_context7 = me._toGlobalTime).call(_context7, me)
        }
    };
    // range
    this.range = new Range(this.body);
    this.components.push(this.range);
    this.body.range = this.range;
    // time axis
    this.timeAxis = new TimeAxis(this.body);
    this.components.push(this.timeAxis);
    //this.body.util.snap = this.timeAxis.snap.bind(this.timeAxis);
    // current time bar
    this.currentTime = new CurrentTime(this.body);
    this.components.push(this.currentTime);
    // item set
    this.linegraph = new LineGraph(this.body);
    this.components.push(this.linegraph);
    this.itemsData = null; // DataSet
    this.groupsData = null; // DataSet
    this.on("tap", function(event1) {
        me.emit("click", me.getEventProperties(event1));
    });
    this.on("doubletap", function(event1) {
        me.emit("doubleClick", me.getEventProperties(event1));
    });
    this.dom.root.oncontextmenu = function(event1) {
        me.emit("contextmenu", me.getEventProperties(event1));
    };
    //Single time autoscale/fit
    this.initialFitDone = false;
    this.on("changed", function() {
        if (me.itemsData == null) return;
        if (!me.initialFitDone && !me.options.rollingMode) {
            me.initialFitDone = true;
            if (me.options.start != undefined || me.options.end != undefined) {
                if (me.options.start == undefined || me.options.end == undefined) var range = me.getItemRange();
                var start = me.options.start != undefined ? me.options.start : range.min;
                var end = me.options.end != undefined ? me.options.end : range.max;
                me.setWindow(start, end, {
                    animation: false
                });
            } else me.fit({
                animation: false
            });
        }
        if (!me.initialDrawDone && (me.initialRangeChangeDone || !me.options.start && !me.options.end || me.options.rollingMode)) {
            me.initialDrawDone = true;
            me.dom.root.style.visibility = "visible";
            me.dom.loadingScreen.parentNode.removeChild(me.dom.loadingScreen);
            if (me.options.onInitialDrawComplete) _setTimeout(function() {
                return me.options.onInitialDrawComplete();
            }, 0);
        }
    });
    // apply options
    if (options) this.setOptions(options);
    // IMPORTANT: THIS HAPPENS BEFORE SET ITEMS!
    if (groups) this.setGroups(groups);
    // create itemset
    if (items) this.setItems(items);
    // draw for the first time
    this._redraw();
}
// Extend the functionality from Core
Graph2d.prototype = new Core();
Graph2d.prototype.setOptions = function(options) {
    // validate options
    var errorFound = Validator.validate(options, allOptions);
    if (errorFound === true) console.log("%cErrors have been found in the supplied options object.", printStyle);
    Core.prototype.setOptions.call(this, options);
};
/**
 * Set items
 * @param {vis.DataSet | Array | null} items
 */ Graph2d.prototype.setItems = function(items) {
    var initialLoad = this.itemsData == null;
    // convert to type DataSet when needed
    var newDataSet;
    if (!items) newDataSet = null;
    else if (isDataViewLike(items)) newDataSet = typeCoerceDataSet(items);
    else // turn an array into a dataset
    newDataSet = typeCoerceDataSet(new DataSet(items));
    // set items
    if (this.itemsData) // stop maintaining a coerced version of the old data set
    this.itemsData.dispose();
    this.itemsData = newDataSet;
    this.linegraph && this.linegraph.setItems(newDataSet != null ? newDataSet.rawDS : null);
    if (initialLoad) {
        if (this.options.start != undefined || this.options.end != undefined) {
            var start = this.options.start != undefined ? this.options.start : null;
            var end = this.options.end != undefined ? this.options.end : null;
            this.setWindow(start, end, {
                animation: false
            });
        } else this.fit({
            animation: false
        });
    }
};
/**
 * Set groups
 * @param {vis.DataSet | Array} groups
 */ Graph2d.prototype.setGroups = function(groups) {
    // convert to type DataSet when needed
    var newDataSet;
    if (!groups) newDataSet = null;
    else if (isDataViewLike(groups)) newDataSet = groups;
    else // turn an array into a dataset
    newDataSet = new DataSet(groups);
    this.groupsData = newDataSet;
    this.linegraph.setGroups(newDataSet);
};
/**
 * Returns an object containing an SVG element with the icon of the group (size determined by iconWidth and iconHeight), the label of the group (content) and the yAxisOrientation of the group (left or right).
 * @param {vis.GraphGroup.id} groupId
 * @param {number} width
 * @param {number} height
 * @returns {{icon: SVGElement, label: string, orientation: string}|string}
 */ Graph2d.prototype.getLegend = function(groupId, width, height) {
    if (width === undefined) width = 15;
    if (height === undefined) height = 15;
    if (this.linegraph.groups[groupId] !== undefined) return this.linegraph.groups[groupId].getLegend(width, height);
    else return "cannot find group:'" + groupId + "'";
};
/**
 * This checks if the visible option of the supplied group (by ID) is true or false.
 * @param {vis.GraphGroup.id} groupId
 * @returns {boolean}
 */ Graph2d.prototype.isGroupVisible = function(groupId) {
    if (this.linegraph.groups[groupId] !== undefined) return this.linegraph.groups[groupId].visible && (this.linegraph.options.groups.visibility[groupId] === undefined || this.linegraph.options.groups.visibility[groupId] == true);
    else return false;
};
/**
 * Get the data range of the item set.
 * @returns {{min: Date, max: Date}} range  A range with a start and end Date.
 *                                          When no minimum is found, min==null
 *                                          When no maximum is found, max==null
 */ Graph2d.prototype.getDataRange = function() {
    var min = null;
    var max = null;
    // calculate min from start filed
    for(var groupId in this.linegraph.groups)if (this.linegraph.groups.hasOwnProperty(groupId)) {
        if (this.linegraph.groups[groupId].visible == true) for(var i1 = 0; i1 < this.linegraph.groups[groupId].itemsData.length; i1++){
            var item = this.linegraph.groups[groupId].itemsData[i1];
            var value = availableUtils.convert(item.x, "Date").valueOf();
            min = min == null ? value : min > value ? value : min;
            max = max == null ? value : max < value ? value : max;
        }
    }
    return {
        min: min != null ? new Date(min) : null,
        max: max != null ? new Date(max) : null
    };
};
/**
 * Generate Timeline related information from an event
 * @param {Event} event
 * @return {Object} An object with related information, like on which area
 *                  The event happened, whether clicked on an item, etc.
 */ Graph2d.prototype.getEventProperties = function(event1) {
    var clientX = event1.center ? event1.center.x : event1.clientX;
    var clientY = event1.center ? event1.center.y : event1.clientY;
    var x = clientX - availableUtils.getAbsoluteLeft(this.dom.centerContainer);
    var y = clientY - availableUtils.getAbsoluteTop(this.dom.centerContainer);
    var time = this._toTime(x);
    var customTime = CustomTime.customTimeFromTarget(event1);
    var element = availableUtils.getTarget(event1);
    var what = null;
    if (availableUtils.hasParent(element, this.timeAxis.dom.foreground)) what = "axis";
    else if (this.timeAxis2 && availableUtils.hasParent(element, this.timeAxis2.dom.foreground)) what = "axis";
    else if (availableUtils.hasParent(element, this.linegraph.yAxisLeft.dom.frame)) what = "data-axis";
    else if (availableUtils.hasParent(element, this.linegraph.yAxisRight.dom.frame)) what = "data-axis";
    else if (availableUtils.hasParent(element, this.linegraph.legendLeft.dom.frame)) what = "legend";
    else if (availableUtils.hasParent(element, this.linegraph.legendRight.dom.frame)) what = "legend";
    else if (customTime != null) what = "custom-time";
    else if (availableUtils.hasParent(element, this.currentTime.bar)) what = "current-time";
    else if (availableUtils.hasParent(element, this.dom.center)) what = "background";
    var value = [];
    var yAxisLeft = this.linegraph.yAxisLeft;
    var yAxisRight = this.linegraph.yAxisRight;
    if (!yAxisLeft.hidden && this.itemsData.length > 0) value.push(yAxisLeft.screenToValue(y));
    if (!yAxisRight.hidden && this.itemsData.length > 0) value.push(yAxisRight.screenToValue(y));
    return {
        event: event1,
        customTime: customTime ? customTime.options.id : null,
        what: what,
        pageX: event1.srcEvent ? event1.srcEvent.pageX : event1.pageX,
        pageY: event1.srcEvent ? event1.srcEvent.pageY : event1.pageY,
        x: x,
        y: y,
        time: time,
        value: value
    };
};
/**
 * Load a configurator
 * @return {Object}
 * @private
 */ Graph2d.prototype._createConfigurator = function() {
    return new Configurator(this, this.dom.container, configureOptions);
};
// locales
// TODO: This should probably be moved somewhere else to ensure that both builds
// behave the same way.
var defaultLanguage = getNavigatorLanguage();
moment$4.locale(defaultLanguage);
var timeline = {
    Core: Core,
    DateUtil: DateUtil,
    Range: Range,
    stack: stack$1,
    TimeStep: TimeStep,
    components: {
        items: {
            Item: Item,
            BackgroundItem: BackgroundItem,
            BoxItem: BoxItem,
            ClusterItem: ClusterItem,
            PointItem: PointItem,
            RangeItem: RangeItem
        },
        BackgroundGroup: BackgroundGroup,
        Component: Component,
        CurrentTime: CurrentTime,
        CustomTime: CustomTime,
        DataAxis: DataAxis,
        DataScale: DataScale,
        GraphGroup: GraphGroup,
        Group: Group,
        ItemSet: ItemSet,
        Legend: Legend,
        LineGraph: LineGraph,
        TimeAxis: TimeAxis
    }
};

});


var $ayMG0 = parcelRequire("ayMG0");
function $a7cfa69ff958aea6$export$2e2bcd8739ae039() {
    $a7cfa69ff958aea6$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a7cfa69ff958aea6$export$2e2bcd8739ae039.apply(this, arguments);
}


function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;


function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;



var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$var$invariant(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    throw new Error($85f606e562c81b96$var$prefix + ": " + (message || ""));
}
var $85f606e562c81b96$export$2e2bcd8739ae039 = $85f606e562c81b96$var$invariant;


function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $a7cfa69ff958aea6$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $0b14391bdc5d7d11$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $6e4c488965e5c6e8$export$2e2bcd8739ae039)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $2756f79476f0245f$var$PopStateEvent = "popstate";
var $2756f79476f0245f$var$HashChangeEvent = "hashchange";
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $a7cfa69ff958aea6$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = "hashchange";
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + "#" + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $a7cfa69ff958aea6$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $a7cfa69ff958aea6$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");


var $fHPaR = parcelRequire("fHPaR");

var $lT1cX = parcelRequire("lT1cX");
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $20a8501e6e2f4912$export$2e2bcd8739ae039 = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $ayMG0 = parcelRequire("ayMG0");
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $lT1cX.default)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $20a8501e6e2f4912$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fHPaR.default).Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$export$2e2bcd8739ae039 = $fff44a152eb20ab0$var$ThemeProvider;



parcelRequire("8zogs");
var $1my5K = parcelRequire("1my5K");

var $lJyjx = parcelRequire("lJyjx");

var $ayMG0 = parcelRequire("ayMG0");
function $12433c9be3a4ac8d$var$InnerThemeProvider(props) {
    const theme = (0, $lJyjx.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1my5K.T).Provider, {
        value: typeof theme === "object" ? theme : {},
        children: props.children
    });
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 */ function $12433c9be3a4ac8d$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff44a152eb20ab0$export$2e2bcd8739ae039), {
        theme: localTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($12433c9be3a4ac8d$var$InnerThemeProvider, {
            children: children
        })
    });
}
var $12433c9be3a4ac8d$export$2e2bcd8739ae039 = $12433c9be3a4ac8d$var$ThemeProvider;


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7a8edf80f542b65c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $54de22820fe8f5c8$export$31499a9cd224b78c = "8.31.0";


/** Get's the global object for the current JavaScript runtime */ const $daf9a5aa340ffc23$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $daf9a5aa340ffc23$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $daf9a5aa340ffc23$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] = __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $eddf779ebbe9b538$var$PREFIX = "Sentry Logger ";
const $eddf779ebbe9b538$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $eddf779ebbe9b538$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $eddf779ebbe9b538$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($eddf779ebbe9b538$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $eddf779ebbe9b538$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $eddf779ebbe9b538$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $7a8edf80f542b65c$export$16a28057038b10ef) $eddf779ebbe9b538$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $eddf779ebbe9b538$export$cda52e2a8927a2ca(()=>{
                (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console[name](`${$eddf779ebbe9b538$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $eddf779ebbe9b538$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $eddf779ebbe9b538$export$af88d00dbe7f521 = (0, $daf9a5aa340ffc23$export$7e223ec222791509)("logger", $eddf779ebbe9b538$var$makeLogger);


const $53d728fa04e56ec9$var$STACKTRACE_FRAME_LIMIT = 50;
const $53d728fa04e56ec9$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $53d728fa04e56ec9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $53d728fa04e56ec9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $53d728fa04e56ec9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $53d728fa04e56ec9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($53d728fa04e56ec9$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $53d728fa04e56ec9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $53d728fa04e56ec9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $53d728fa04e56ec9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $53d728fa04e56ec9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $53d728fa04e56ec9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($53d728fa04e56ec9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($53d728fa04e56ec9$var$STRIP_FRAME_REGEXP.test($53d728fa04e56ec9$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($53d728fa04e56ec9$var$STRIP_FRAME_REGEXP.test($53d728fa04e56ec9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $53d728fa04e56ec9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $53d728fa04e56ec9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $53d728fa04e56ec9$export$27c7e15d453fc0ac
        }));
}
function $53d728fa04e56ec9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $53d728fa04e56ec9$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $53d728fa04e56ec9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $53d728fa04e56ec9$var$defaultFunctionName;
        return fn.name || $53d728fa04e56ec9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $53d728fa04e56ec9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $53d728fa04e56ec9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $3fec3b92cacfb9e4$var$handlers = {};
const $3fec3b92cacfb9e4$var$instrumented = {};
/** Add a handler function. */ function $3fec3b92cacfb9e4$export$a4e09611e30da72e(type, handler) {
    $3fec3b92cacfb9e4$var$handlers[type] = $3fec3b92cacfb9e4$var$handlers[type] || [];
    $3fec3b92cacfb9e4$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $3fec3b92cacfb9e4$export$b17eab759a1cb5fe() {
    Object.keys($3fec3b92cacfb9e4$var$handlers).forEach((key)=>{
        $3fec3b92cacfb9e4$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $3fec3b92cacfb9e4$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$3fec3b92cacfb9e4$var$instrumented[type]) {
        instrumentFn();
        $3fec3b92cacfb9e4$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $3fec3b92cacfb9e4$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $3fec3b92cacfb9e4$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $53d728fa04e56ec9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $9ddc5321bbc17588$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$e6127cc7fe7395c3(wat) {
    switch($9ddc5321bbc17588$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $9ddc5321bbc17588$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$var$isBuiltin(wat, className) {
    return $9ddc5321bbc17588$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$9f9636d330b71954(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$ef9e2056653f0c8e(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$12e869b2a583f783(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$844ec244b1367d54(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$c3825b437cbdea5c(wat) {
    return wat === null || $9ddc5321bbc17588$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$53b83ca8eaab0383(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $9ddc5321bbc17588$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $9ddc5321bbc17588$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$49841c62b9eff15(wat) {
    return $9ddc5321bbc17588$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9ddc5321bbc17588$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$bc2894c7158efbac(wat) {
    return $9ddc5321bbc17588$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9ddc5321bbc17588$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



const $b1794bb8b282584f$var$WINDOW = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
const $b1794bb8b282584f$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b1794bb8b282584f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b1794bb8b282584f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b1794bb8b282584f$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b1794bb8b282584f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($b1794bb8b282584f$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9ddc5321bbc17588$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $b1794bb8b282584f$export$1cfafeee2987818b() {
    try {
        return $b1794bb8b282584f$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b1794bb8b282584f$export$c660c1f3ab49225c(selector) {
    if ($b1794bb8b282584f$var$WINDOW.document && $b1794bb8b282584f$var$WINDOW.document.querySelector) return $b1794bb8b282584f$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precendence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $b1794bb8b282584f$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$b1794bb8b282584f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $ef17463c720dc68b$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $ef17463c720dc68b$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ef17463c720dc68b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9ddc5321bbc17588$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $ef17463c720dc68b$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9ddc5321bbc17588$export$844ec244b1367d54)(value)) return false;
    if ((0, $9ddc5321bbc17588$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9ddc5321bbc17588$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $ef17463c720dc68b$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$ef17463c720dc68b$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $7c0b78736d11cf4a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $7c0b78736d11cf4a$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $7c0b78736d11cf4a$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $7c0b78736d11cf4a$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $7c0b78736d11cf4a$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $7c0b78736d11cf4a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $7c0b78736d11cf4a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $7c0b78736d11cf4a$export$62ff257738bf57f5(value) {
    if ((0, $9ddc5321bbc17588$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$7c0b78736d11cf4a$var$getOwnProperties(value)
    };
    else if ((0, $9ddc5321bbc17588$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $7c0b78736d11cf4a$var$serializeEventTarget(value.target),
            currentTarget: $7c0b78736d11cf4a$var$serializeEventTarget(value.currentTarget),
            ...$7c0b78736d11cf4a$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $9ddc5321bbc17588$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $7c0b78736d11cf4a$var$serializeEventTarget(target) {
    try {
        return (0, $9ddc5321bbc17588$export$45a5e7f76e0caa8d)(target) ? (0, $b1794bb8b282584f$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $7c0b78736d11cf4a$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $7c0b78736d11cf4a$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($7c0b78736d11cf4a$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $ef17463c720dc68b$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $ef17463c720dc68b$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $7c0b78736d11cf4a$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $7c0b78736d11cf4a$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $7c0b78736d11cf4a$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($7c0b78736d11cf4a$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $7c0b78736d11cf4a$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($7c0b78736d11cf4a$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $7c0b78736d11cf4a$var$isPojo(input) {
    if (!(0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $7c0b78736d11cf4a$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $a6e59daa000c77fc$var$WINDOW = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a6e59daa000c77fc$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $a6e59daa000c77fc$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a6e59daa000c77fc$var$WINDOW && !!$a6e59daa000c77fc$var$WINDOW.history.pushState && !!$a6e59daa000c77fc$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);


let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $3d87653da885c31c$var$instrumentHistory);
}
function $3d87653da885c31c$var$instrumentHistory() {
    if (!(0, $a6e59daa000c77fc$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate;
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}




const $f43df6ba426daa1c$export$9ca9946bd449ac06 = "baggage";
const $f43df6ba426daa1c$export$6e69537d67fa20f = "sentry-";
const $f43df6ba426daa1c$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $f43df6ba426daa1c$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $f43df6ba426daa1c$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $f43df6ba426daa1c$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($f43df6ba426daa1c$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($f43df6ba426daa1c$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $f43df6ba426daa1c$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$f43df6ba426daa1c$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $f43df6ba426daa1c$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $f43df6ba426daa1c$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9ddc5321bbc17588$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $f43df6ba426daa1c$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $f43df6ba426daa1c$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $f43df6ba426daa1c$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $f43df6ba426daa1c$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $f43df6ba426daa1c$export$bdd844ddb2def819) {
            (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $f61010b781c81ec1$export$19f53698e68b2496() {
    const gbl = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $f61010b781c81ec1$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $f61010b781c81ec1$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $f61010b781c81ec1$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $f61010b781c81ec1$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $f61010b781c81ec1$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $f61010b781c81ec1$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $f61010b781c81ec1$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $f61010b781c81ec1$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $f61010b781c81ec1$export$d364f2020ab30578(input) {
    const match = input.match($f61010b781c81ec1$var$SEMVER_REGEXP) || [];
    const major = $f61010b781c81ec1$var$_parseInt(match[1]);
    const minor = $f61010b781c81ec1$var$_parseInt(match[2]);
    const patch = $f61010b781c81ec1$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $f61010b781c81ec1$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $ef17463c720dc68b$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $ef17463c720dc68b$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $ef17463c720dc68b$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $f61010b781c81ec1$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $f61010b781c81ec1$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $fb06ed6aa7675875$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $fb06ed6aa7675875$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($fb06ed6aa7675875$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $fb06ed6aa7675875$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $fb06ed6aa7675875$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $f43df6ba426daa1c$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        spanId: (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16),
        spanId: (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $fb06ed6aa7675875$export$f35d907436da45cf(traceId = (0, $f61010b781c81ec1$export$19f53698e68b2496)(), spanId = (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


const $dce7651ce4194f00$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $dce7651ce4194f00$export$7740643b9eeaf0c4() {
    return Date.now() / $dce7651ce4194f00$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $dce7651ce4194f00$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $dce7651ce4194f00$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $dce7651ce4194f00$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $dce7651ce4194f00$export$ee52dced521e3e18 = $dce7651ce4194f00$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $dce7651ce4194f00$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $dce7651ce4194f00$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $dce7651ce4194f00$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $dce7651ce4194f00$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $dce7651ce4194f00$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $dce7651ce4194f00$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1));
    return 0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $54de22820fe8f5c8$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] = __SENTRY__[0, $54de22820fe8f5c8$export$31499a9cd224b78c] || {};
}





/**
 * Returns a new minimal propagation context
 */ function $8cd423ca54f15ed2$export$37f0f2f9cf343e5e() {
    return {
        traceId: (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        spanId: (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16)
    };
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}



const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $33c387bb26fe522d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = (0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)();
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $33c387bb26fe522d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(newScope, (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this._propagationContext = (0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)();
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
// NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)
/**
 * Holds additional event information.
 */ const $33c387bb26fe522d$export$775b6bb06e53a214 = $33c387bb26fe522d$var$ScopeClass;


/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $daf9a5aa340ffc23$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $daf9a5aa340ffc23$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}




/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $4354bb0fac58a6e0$export$6f1b9191db9c4d5)(), (0, $4354bb0fac58a6e0$export$de9862929b76bf57)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ab23dab597a507b7$export$329d4d4d54e42710)();
}







/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $daf9a5aa340ffc23$export$7e223ec222791509)("globalScope", ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}



/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $deb2e427fa07e3b2$var$METRICS_SPAN_FIELD = "_sentryMetrics";
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $deb2e427fa07e3b2$export$2e7205e45c58797d(span) {
    const storage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $deb2e427fa07e3b2$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * The id of the profile that this span occured in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = "sentry.profile_id";
const $068c396dceb690a1$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $068c396dceb690a1$export$b016f89ac1066ec = "cache.hit";
const $068c396dceb690a1$export$3110e4c3f4386399 = "cache.key";
const $068c396dceb690a1$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = "http.request.method";
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = "url.full";


const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { parent_span_id: parent_span_id } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $fb06ed6aa7675875$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
                status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
                op: attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
                origin: attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
                _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $006ad32cdaebe09b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $006ad32cdaebe09b$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $99af9a2b040631ba$export$91f063ebb8eff307)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $36b15c0d755e29f6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $36b15c0d755e29f6$export$1be426a8e585c83e();
    if (span) (0, $deb2e427fa07e3b2$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}



/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $3ed76239c787a980$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) rootSpan.addEvent(name, {
        [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: value,
        [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: unit
    });
}
/**
 * Convert timed events to measurements.
 */ function $3ed76239c787a980$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $068c396dceb690a1$export$f5f95cff026507b5];
        const value = attributes[0, $068c396dceb690a1$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}





/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $a328b345a75725bb$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $a328b345a75725bb$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $a328b345a75725bb$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e426c875bd1d2890$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}





const $3592a0510b526070$export$849dbeeeda01ae98 = "production";





/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3592a0510b526070$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed((0, $36b15c0d755e29f6$export$92d8c23565496537)(span).trace_id || "", client);
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $f43df6ba426daa1c$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const jsonSpan = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $068c396dceb690a1$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== "url" && name) dsc.transaction = name;
    dsc.sampled = String((0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(rootSpan));
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $f43df6ba426daa1c$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $09ada9a941cee5f6$export$2f3d84e767c9592b(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $09ada9a941cee5f6$export$b77c830667a4d630(span) {
    if (!(0, $b776c95debaa4af0$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(msg);
}







/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}


/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $db2bd6d2ef458b60$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)(options)) return [
        false
    ];
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") sampleRate = options.tracesSampler(samplingContext);
    else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $d899755a957e1f50$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being comliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being comliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being comliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}







/** Regular expression used to parse a Dsn. */ const $3a0c11012bdf3bae$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $3a0c11012bdf3bae$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $3a0c11012bdf3bae$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $3a0c11012bdf3bae$export$b892860177f70a30(str) {
    const match = $3a0c11012bdf3bae$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $3a0c11012bdf3bae$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $3a0c11012bdf3bae$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $3a0c11012bdf3bae$var$validateDsn(dsn) {
    if (!(0, $7a8edf80f542b65c$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$3a0c11012bdf3bae$var$isValidProtocol(protocol)) {
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $3a0c11012bdf3bae$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $3a0c11012bdf3bae$export$b892860177f70a30(from) : $3a0c11012bdf3bae$var$dsnFromComponents(from);
    if (!components || !$3a0c11012bdf3bae$var$validateDsn(components)) return undefined;
    return components;
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $a9e7543d7f9a899b$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $95721a1f8e4d79f8$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $95721a1f8e4d79f8$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $95721a1f8e4d79f8$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $95721a1f8e4d79f8$export$a3295358bff77e(object, depth);
    if ($95721a1f8e4d79f8$var$jsonSize(normalized) > maxSize) return $95721a1f8e4d79f8$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $95721a1f8e4d79f8$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $a9e7543d7f9a899b$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $95721a1f8e4d79f8$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $95721a1f8e4d79f8$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $7c0b78736d11cf4a$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $95721a1f8e4d79f8$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $95721a1f8e4d79f8$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $9ddc5321bbc17588$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $9ddc5321bbc17588$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $53d728fa04e56ec9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $95721a1f8e4d79f8$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $95721a1f8e4d79f8$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $95721a1f8e4d79f8$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $95721a1f8e4d79f8$var$jsonSize(value) {
    return $95721a1f8e4d79f8$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $95721a1f8e4d79f8$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $19ddf33da467375a$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $19ddf33da467375a$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $19ddf33da467375a$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $19ddf33da467375a$export$604a45d95a155e2b(envelope, types) {
    return $19ddf33da467375a$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $19ddf33da467375a$var$encodeUTF8(input) {
    return (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $19ddf33da467375a$var$decodeUTF8(input) {
    return (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $19ddf33da467375a$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $19ddf33da467375a$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $19ddf33da467375a$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $95721a1f8e4d79f8$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $19ddf33da467375a$var$concatBuffers(parts);
}
function $19ddf33da467375a$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $19ddf33da467375a$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $19ddf33da467375a$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($19ddf33da467375a$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $19ddf33da467375a$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $19ddf33da467375a$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $19ddf33da467375a$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $19ddf33da467375a$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $19ddf33da467375a$export$b11169581eeaf237(type) {
    return $19ddf33da467375a$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $19ddf33da467375a$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $19ddf33da467375a$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $19ddf33da467375a$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $19ddf33da467375a$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $19ddf33da467375a$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>beforeSendSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(span)) : (span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $19ddf33da467375a$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(headers, items);
}









const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


const $e47c8865bba9bc73$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $e47c8865bba9bc73$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $f61010b781c81ec1$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
        this._attributes = {};
        this.setAttributes({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "manual",
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $36b15c0d755e29f6$export$eb571cd9b5d98de8) : (0, $36b15c0d755e29f6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(endTimestamp);
        (0, $09ada9a941cee5f6$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $36b15c0d755e29f6$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $068c396dceb690a1$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $068c396dceb690a1$export$fea48ba9f4550879],
            measurements: (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Adding an event to span:", name);
        const time = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
        const attributes = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $e47c8865bba9bc73$var$sendSpanEnvelope((0, $b89a3b4f1056006b$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this).scope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$e47c8865bba9bc73$var$isFullFinishedSpan((0, $36b15c0d755e29f6$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const client = scope.getClient() || (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$e47c8865bba9bc73$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span)).filter($e47c8865bba9bc73$var$isFullFinishedSpan);
        const source = this._attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        const transaction = {
            contexts: {
                trace: (0, $36b15c0d755e29f6$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e47c8865bba9bc73$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e47c8865bba9bc73$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $deb2e427fa07e3b2$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e47c8865bba9bc73$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $e47c8865bba9bc73$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $e47c8865bba9bc73$var$isStandaloneSpan(span) {
    return span instanceof $e47c8865bba9bc73$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $e47c8865bba9bc73$var$sendSpanEnvelope(envelope) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    const transport = client.getTransport();
    if (transport) transport.send(envelope).then(null, (reason)=>{
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Error while sending span:", reason);
    });
}




const $038737f78c636108$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$a1bd95187356f372(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$c10292ad04b92aea(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$63dbba021a6b4047(options) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $f106fce27ec076f7$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$038737f78c636108$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
        const parentSpan = $038737f78c636108$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
        return $038737f78c636108$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $038737f78c636108$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $fb06ed6aa7675875$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $038737f78c636108$export$e57ac09b143d92a2(span, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $038737f78c636108$export$869298f9835abc68(callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$038737f78c636108$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $038737f78c636108$export$f90b03291402f553(callback) {
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext((0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)());
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $038737f78c636108$export$e57ac09b143d92a2(null, callback);
    });
}
function $038737f78c636108$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $09ada9a941cee5f6$export$2f3d84e767c9592b)(span);
    (0, $4509d165411fd11c$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $038737f78c636108$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $038737f78c636108$var$getAcs() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    return (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
}
function $038737f78c636108$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {};
    const { name: name = "", attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $db2bd6d2ef458b60$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: "custom",
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $068c396dceb690a1$export$ccfe0a40627cc34b), sampleRate);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? false : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $36b15c0d755e29f6$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $038737f78c636108$var$getParentSpan(scope) {
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $038737f78c636108$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $038737f78c636108$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $cc4acb8fa68987a7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $cc4acb8fa68987a7$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $cc4acb8fa68987a7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $cc4acb8fa68987a7$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $c2017e0e66bad871$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}






const $7f25ffc87954188c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $7f25ffc87954188c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $7f25ffc87954188c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $dd0ab4bb8fd34918$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $44a719e67f846077$export$6431553786c94949 = ()=>{
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $087abae3f457004d$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $21249b77f35afbbd$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering || (0, $087abae3f457004d$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $dd0ab4bb8fd34918$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $3c3fb26ba7f6478b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $02a4610d4ee5af80$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden") cb(event);
    };
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9bb6b2adff68632$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return (arg)=>{
        if (!called) {
            cb(arg);
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bf61d7f7ca9bd10a$var$firstHiddenTime = -1;
const $bf61d7f7ca9bd10a$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    $bf61d7f7ca9bd10a$var$firstHiddenTime = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $bf61d7f7ca9bd10a$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && $bf61d7f7ca9bd10a$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        removeEventListener("visibilitychange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
        removeEventListener("prerenderingchange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    }
};
const $bf61d7f7ca9bd10a$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$export$443f86b2c77012c4 = ()=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && $bf61d7f7ca9bd10a$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bf61d7f7ca9bd10a$var$initHiddenTime();
        $bf61d7f7ca9bd10a$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bf61d7f7ca9bd10a$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6f9bc735dd2b9313$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $c372737293087726$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $c372737293087726$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === "first-contentful-paint") {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c372737293087726$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $c8cc3356aaa35be1$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c8cc3356aaa35be1$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $c372737293087726$export$fe3c86b74e15d5de)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("CLS", 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c8cc3356aaa35be1$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $88c48014ef58cf68$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $88c48014ef58cf68$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("first-input", handleEntries);
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $88c48014ef58cf68$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};








let $cc83e22cb516f528$var$interactionCountEstimate = 0;
let $cc83e22cb516f528$var$minKnownInteractionId = Infinity;
let $cc83e22cb516f528$var$maxKnownInteractionId = 0;
const $cc83e22cb516f528$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $cc83e22cb516f528$var$minKnownInteractionId = Math.min($cc83e22cb516f528$var$minKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$maxKnownInteractionId = Math.max($cc83e22cb516f528$var$maxKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$interactionCountEstimate = $cc83e22cb516f528$var$maxKnownInteractionId ? ($cc83e22cb516f528$var$maxKnownInteractionId - $cc83e22cb516f528$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $cc83e22cb516f528$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $cc83e22cb516f528$export$8a962f2683a476d1 = ()=>{
    return $cc83e22cb516f528$var$po ? $cc83e22cb516f528$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $cc83e22cb516f528$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $cc83e22cb516f528$var$po) return;
    $cc83e22cb516f528$var$po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("event", $cc83e22cb516f528$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $c2ceebba2f8f4181$export$7f4cb060ded9173c = [
    200,
    500
];
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
const $c2ceebba2f8f4181$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $c2ceebba2f8f4181$var$getInteractionCountForNavigation = ()=>{
    return (0, $cc83e22cb516f528$export$8a962f2683a476d1)() - $c2ceebba2f8f4181$var$prevInteractionCount;
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $c2ceebba2f8f4181$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $c2ceebba2f8f4181$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $c2ceebba2f8f4181$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $c2ceebba2f8f4181$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $c2ceebba2f8f4181$var$longestInteractionList[$c2ceebba2f8f4181$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $c2ceebba2f8f4181$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $c2ceebba2f8f4181$var$longestInteractionList.length < $c2ceebba2f8f4181$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $c2ceebba2f8f4181$var$longestInteractionMap[interaction.id] = interaction;
            $c2ceebba2f8f4181$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $c2ceebba2f8f4181$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $c2ceebba2f8f4181$var$longestInteractionList.splice($c2ceebba2f8f4181$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $c2ceebba2f8f4181$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $c2ceebba2f8f4181$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($c2ceebba2f8f4181$var$longestInteractionList.length - 1, Math.floor($c2ceebba2f8f4181$var$getInteractionCountForNavigation() / 50));
    return $c2ceebba2f8f4181$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c2ceebba2f8f4181$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $cc83e22cb516f528$export$67d90cda6b78a2eb)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.interactionId) $c2ceebba2f8f4181$var$processEntry(entry);
                // Entries of type `first-input` don't currently have an `interactionId`,
                // so to consider them in INP we have to first check that an existing
                // entry doesn't match the `duration` and `startTime`.
                // Note that this logic assumes that `event` entries are dispatched
                // before `first-input` entries. This is true in Chrome (the only browser
                // that currently supports INP).
                // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
                if (entry.entryType === "first-input") {
                    const noMatchingEntry = !$c2ceebba2f8f4181$var$longestInteractionList.some((interaction)=>{
                        return interaction.entries.some((prevEntry)=>{
                            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                        });
                    });
                    if (noMatchingEntry) $c2ceebba2f8f4181$var$processEntry(entry);
                }
            });
            const inp = $c2ceebba2f8f4181$var$estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = inp.entries;
                report();
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : 40
        });
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c2ceebba2f8f4181$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // If browser supports interactionId (and so supports INP), also
            // observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            if ("PerformanceEventTiming" in (0, $955496f5d3029976$export$56d8a8a25bd48b81) && "interactionId" in PerformanceEventTiming.prototype) po.observe({
                type: "first-input",
                buffered: true
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                // If the interaction count shows that there were interactions but
                // none were captured by the PerformanceObserver, report a latency of 0.
                if (metric.value < 0 && $c2ceebba2f8f4181$var$getInteractionCountForNavigation() > 0) {
                    metric.value = 0;
                    metric.entries = [];
                }
                report(true);
            });
        }
    });
};











/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $c89cf1e13796625e$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $c89cf1e13796625e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $c89cf1e13796625e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("LCP");
        let report;
        const handleEntries = (entries)=>{
            const lastEntry = entries[entries.length - 1];
            if (lastEntry) // Only report if the page wasn't hidden prior to LCP.
            {
                if (lastEntry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(lastEntry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        lastEntry
                    ];
                    report();
                }
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c89cf1e13796625e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
                if (!$c89cf1e13796625e$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $c89cf1e13796625e$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                "keydown",
                "click"
            ].forEach((type)=>{
                if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                addEventListener(type, ()=>setTimeout(stopListening, 0), true);
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $f3a7825c3a5278be$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $f3a7825c3a5278be$var$whenReady = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>$f3a7825c3a5278be$var$whenReady(callback));
    else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$f3a7825c3a5278be$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $f3a7825c3a5278be$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("TTFB");
    const report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $f3a7825c3a5278be$export$65c59ea8064668fc, opts.reportAllChanges);
    $f3a7825c3a5278be$var$whenReady(()=>{
        const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
        if (navEntry) {
            const responseStart = navEntry.responseStart;
            // In some cases no value is reported by the browser (for
            // privacy/security reasons), and in other cases (bugs) the value is
            // negative or is larger than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            // https://github.com/GoogleChrome/web-vitals/issues/275
            if (responseStart <= 0 || responseStart > performance.now()) return;
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(responseStart - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $31f3d198369e5cbf$var$handlers = {};
const $31f3d198369e5cbf$var$instrumented = {};
let $31f3d198369e5cbf$var$_previousCls;
let $31f3d198369e5cbf$var$_previousFid;
let $31f3d198369e5cbf$var$_previousLcp;
let $31f3d198369e5cbf$var$_previousTtfb;
let $31f3d198369e5cbf$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $31f3d198369e5cbf$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver("cls", callback, $31f3d198369e5cbf$var$instrumentCls, $31f3d198369e5cbf$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $31f3d198369e5cbf$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver("lcp", callback, $31f3d198369e5cbf$var$instrumentLcp, $31f3d198369e5cbf$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$2707d7471c0b918f(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("fid", callback, $31f3d198369e5cbf$var$instrumentFid, $31f3d198369e5cbf$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $31f3d198369e5cbf$export$699d9529c099a797(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("ttfb", callback, $31f3d198369e5cbf$var$instrumentTtfb, $31f3d198369e5cbf$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$da3b76aa2022cbd7(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("inp", callback, $31f3d198369e5cbf$var$instrumentInp, $31f3d198369e5cbf$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$69816c1a049f8db6(type, callback) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        $31f3d198369e5cbf$var$instrumentPerformanceObserver(type);
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $31f3d198369e5cbf$var$triggerHandlers(type, data) {
    const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $53d728fa04e56ec9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $31f3d198369e5cbf$var$instrumentCls() {
    return (0, $c8cc3356aaa35be1$export$a7873055838e5ad8)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("cls", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentFid() {
    return (0, $88c48014ef58cf68$export$39705a25c49af873)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("fid", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousFid = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentLcp() {
    return (0, $c89cf1e13796625e$export$947b1626ab8d5632)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("lcp", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentTtfb() {
    return (0, $f3a7825c3a5278be$export$33a01e6c5f2c7e33)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousTtfb = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentInp() {
    return (0, $c2ceebba2f8f4181$export$7df4b36ecaed99e1)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("inp", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousInp = metric;
    });
}
function $31f3d198369e5cbf$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    let stopListening;
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        stopListening = instrumentFn();
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $31f3d198369e5cbf$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $3c3fb26ba7f6478b$export$d1203567a167490e)(type, (entries)=>{
        $31f3d198369e5cbf$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $31f3d198369e5cbf$var$addHandler(type, handler) {
    $31f3d198369e5cbf$var$handlers[type] = $31f3d198369e5cbf$var$handlers[type] || [];
    $31f3d198369e5cbf$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $31f3d198369e5cbf$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}




/**
 * Checks if a given value is a valid measurement value.
 */ function $b0d1d845a8fb2673$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $b0d1d845a8fb2673$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $36b15c0d755e29f6$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $038737f78c636108$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay && replay.getReplayId();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator && (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator.userAgent,
        ...passedAttributes
    };
    return (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $b0d1d845a8fb2673$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81) && (0, $955496f5d3029976$export$56d8a8a25bd48b81).addEventListener && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $b0d1d845a8fb2673$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $b444d11e9edd543f$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$b444d11e9edd543f$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $b444d11e9edd543f$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        const unsubscribeStartNavigation = (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            client,
            "optionalAccess",
            (_)=>_.on,
            "call",
            (_2)=>_2("startNavigationSpan", ()=>{
                    _collectClsOnce();
                    unsubscribeStartNavigation && unsubscribeStartNavigation();
                })
        ]);
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        const spanJSON = rootSpan && (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
        if (spanJSON && spanJSON.op === "pageload") pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $b444d11e9edd543f$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(((0, $dce7651ce4194f00$export$baf075a948ffc0bf) || 0) + ((0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        entry,
        "optionalAccess",
        (_3)=>_3.startTime
    ]) || 0));
    const routeName = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $b1794bb8b282584f$export$5647df6b7814ac86)((0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        entry,
        "access",
        (_4)=>_4.sources,
        "access",
        (_5)=>_5[0],
        "optionalAccess",
        (_6)=>_6.node
    ])) : "Layout shift";
    const attributes = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            entry,
            "optionalAccess",
            (_7)=>_7.duration
        ]) || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId
    });
    const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        span,
        "optionalAccess",
        (_8)=>_8.addEvent,
        "call",
        (_9)=>_9("cls", {
                [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: "",
                [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: clsValue
            })
    ]);
    // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
    // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
    (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
        span,
        "optionalAccess",
        (_10)=>_10.end,
        "call",
        (_11)=>_11(startTime)
    ]);
}
function $b444d11e9edd543f$var$supportsLayoutShift() {
    try {
        return (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            PerformanceObserver,
            "access",
            (_12)=>_12.supportedEntryTypes,
            "optionalAccess",
            (_13)=>_13.includes,
            "call",
            (_14)=>_14("layout-shift")
        ]);
    } catch (e) {
        return false;
    }
}







/* eslint-disable max-lines */ const $4ca18541755f3f2c$var$MAX_INT_AS_BYTES = 2147483647;
let $4ca18541755f3f2c$var$_performanceCursor = 0;
let $4ca18541755f3f2c$var$_measurements = {};
let $4ca18541755f3f2c$var$_lcpEntry;
let $4ca18541755f3f2c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ca18541755f3f2c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $dce7651ce4194f00$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCleanupCallback = $4ca18541755f3f2c$var$_trackFID();
        const lcpCleanupCallback = $4ca18541755f3f2c$var$_trackLCP();
        const ttfbCleanupCallback = $4ca18541755f3f2c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $b444d11e9edd543f$export$585bab03c6c18c45)() : $4ca18541755f3f2c$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ca18541755f3f2c$export$f396d19077034ad2() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        if (!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) return;
        for (const entry of entries){
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
                name: "Main UI thread blocked",
                op: "ui.long-task",
                startTime: startTime,
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
            if (span) span.end(startTime + duration);
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $4ca18541755f3f2c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        if (!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                startTime: startTime,
                attributes: attributes
            });
            if (span) span.end(startTime + duration);
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $4ca18541755f3f2c$export$e27543e0976315e4() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        if (!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)()) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $b1794bb8b282584f$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $b1794bb8b282584f$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            const span = (0, $038737f78c636108$export$63dbba021a6b4047)(spanOptions);
            if (span) span.end(startTime + duration);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $4ca18541755f3f2c$var$_trackCLS() {
    return (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Measurements] Adding CLS ${metric.value}`);
        $4ca18541755f3f2c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $4ca18541755f3f2c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ca18541755f3f2c$var$_trackLCP() {
    return (0, $31f3d198369e5cbf$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $4ca18541755f3f2c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ca18541755f3f2c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ca18541755f3f2c$var$_trackFID() {
    return (0, $31f3d198369e5cbf$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf));
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $4ca18541755f3f2c$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ca18541755f3f2c$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $4ca18541755f3f2c$var$_trackTtfb() {
    return (0, $31f3d198369e5cbf$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $4ca18541755f3f2c$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
/** Add performance related spans to a transaction */ function $4ca18541755f3f2c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (!performance || !(0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntries || !(0, $dce7651ce4194f00$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($4ca18541755f3f2c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $4ca18541755f3f2c$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $4ca18541755f3f2c$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $4ca18541755f3f2c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ca18541755f3f2c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements($4ca18541755f3f2c$var$_measurements);
        const fidMark = $4ca18541755f3f2c$var$_measurements["mark.fid"];
        if (fidMark && $4ca18541755f3f2c$var$_measurements["fid"]) {
            // create span for FID
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)($4ca18541755f3f2c$var$_measurements["fid"].value), {
                name: "first input delay",
                op: "ui.action",
                attributes: {
                    [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ca18541755f3f2c$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!("fcp" in $4ca18541755f3f2c$var$_measurements) || !options.recordClsOnPageloadSpan) delete $4ca18541755f3f2c$var$_measurements.cls;
        Object.entries($4ca18541755f3f2c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $3ed76239c787a980$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute("performance.timeOrigin", timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute("performance.activationStart", (0, $087abae3f457004d$export$d3e828b3c7b5b845)());
        $4ca18541755f3f2c$var$_setWebVitalAttributes(span);
    }
    $4ca18541755f3f2c$var$_lcpEntry = undefined;
    $4ca18541755f3f2c$var$_clsEntry = undefined;
    $4ca18541755f3f2c$var$_measurements = {};
}
/** Create measure related spans */ function $4ca18541755f3f2c$export$bc93b84e4d45912d(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    const requestTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccruate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, name, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(end), {
        op: "browser",
        name: name || event,
        attributes: {
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
        }
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser",
            name: "request",
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser",
            name: "response",
            attributes: {
                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
/** Create resource-related spans */ function $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "transferSize", "http.response_transfer_size");
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "encodedBodySize", "http.response_content_length");
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) attributes["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin, ""),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ca18541755f3f2c$var$_trackNavigator(span) {
    const navigator = (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute("effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute("connectionType", connection.type);
        if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(connection.rtt)) $4ca18541755f3f2c$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $4ca18541755f3f2c$var$_setWebVitalAttributes(span) {
    if ($4ca18541755f3f2c$var$_lcpEntry) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ca18541755f3f2c$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $b1794bb8b282584f$export$5647df6b7814ac86)($4ca18541755f3f2c$var$_lcpEntry.element));
        if ($4ca18541755f3f2c$var$_lcpEntry.id) span.setAttribute("lcp.id", $4ca18541755f3f2c$var$_lcpEntry.id);
        if ($4ca18541755f3f2c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute("lcp.url", $4ca18541755f3f2c$var$_lcpEntry.url.trim().slice(0, 200));
        span.setAttribute("lcp.size", $4ca18541755f3f2c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ca18541755f3f2c$var$_clsEntry && $4ca18541755f3f2c$var$_clsEntry.sources) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $4ca18541755f3f2c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $b1794bb8b282584f$export$5647df6b7814ac86)(source.node)));
    }
}
function $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ca18541755f3f2c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}





const $751b596e3029fa17$var$LAST_INTERACTIONS = [];
const $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $751b596e3029fa17$export$f17d06681a4744a3() {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $dce7651ce4194f00$export$baf075a948ffc0bf)) {
        const inpCallback = $751b596e3029fa17$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $751b596e3029fa17$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $751b596e3029fa17$var$_trackINP() {
    return (0, $31f3d198369e5cbf$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $dce7651ce4194f00$export$baf075a948ffc0bf) + entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $36b15c0d755e29f6$export$92d8c23565496537)(spanToUse).description : (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().getScopeData().transactionName;
        const name = (0, $b1794bb8b282584f$export$5647df6b7814ac86)(entry.target);
        const attributes = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
            [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: entry.duration
        });
        const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            span,
            "optionalAccess",
            (_)=>_.addEvent,
            "call",
            (_2)=>_2("inp", {
                    [(0, $068c396dceb690a1$export$f5f95cff026507b5)]: "millisecond",
                    [(0, $068c396dceb690a1$export$69cd5c610c7bb96a)]: metric.value
                })
        ]);
        (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            span,
            "optionalAccess",
            (_3)=>_3.end,
            "call",
            (_4)=>_4(startTime + duration)
        ]);
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $751b596e3029fa17$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $31f3d198369e5cbf$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($751b596e3029fa17$var$LAST_INTERACTIONS.length > 10) {
                const last = $751b596e3029fa17$var$LAST_INTERACTIONS.shift();
                $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $751b596e3029fa17$var$LAST_INTERACTIONS.push(interactionId);
            $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("event", handleEntries);
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("first-input", handleEntries);
}




let $18dd1219fff07956$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $18dd1219fff07956$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $18dd1219fff07956$var$instrumentError);
}
function $18dd1219fff07956$var$instrumentError() {
    $18dd1219fff07956$var$_oldOnErrorHandler = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onerror;
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("error", handlerData);
        if ($18dd1219fff07956$var$_oldOnErrorHandler && !$18dd1219fff07956$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $18dd1219fff07956$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $d65fa0065561a897$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d65fa0065561a897$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $d65fa0065561a897$var$instrumentUnhandledRejection);
}
function $d65fa0065561a897$var$instrumentUnhandledRejection() {
    $d65fa0065561a897$var$_oldOnUnhandledRejectionHandler = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($d65fa0065561a897$var$_oldOnUnhandledRejectionHandler && !$d65fa0065561a897$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d65fa0065561a897$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $d4be1d52827a3f28$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $d4be1d52827a3f28$export$b0914730ee1f6c80() {
    if ($d4be1d52827a3f28$var$errorsInstrumented) return;
    $d4be1d52827a3f28$var$errorsInstrumented = true;
    (0, $18dd1219fff07956$export$55b5c3ba2194f0c6)($d4be1d52827a3f28$var$errorCallback);
    (0, $d65fa0065561a897$export$8bf4fc6858821a4e)($d4be1d52827a3f28$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $d4be1d52827a3f28$var$errorCallback() {
    const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = "internal_error";
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occured`);
        rootSpan.setStatus({
            code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d4be1d52827a3f28$var$errorCallback.tag = "sentry_tracingErrorCallback";











const $fd927ea1b5d85956$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $fd927ea1b5d85956$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client || !(0, $e426c875bd1d2890$export$5008da00b1b6dee6)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = $fd927ea1b5d85956$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $36b15c0d755e29f6$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $36b15c0d755e29f6$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $068c396dceb690a1$export$ba73f34502b7a3b3]) span.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), _finishReason);
        (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $36b15c0d755e29f6$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $36b15c0d755e29f6$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $36b15c0d755e29f6$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $36b15c0d755e29f6$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: "deadline_exceeded"
            });
            _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $fd927ea1b5d85956$var$_startIdleSpan(options) {
    const span = (0, $038737f78c636108$export$63dbba021a6b4047)(options);
    (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), span);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("[Tracing] Started span is an idle span");
    return span;
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;











/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $3b138310ed7801df$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($3b138310ed7801df$var$States || ($3b138310ed7801df$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $3b138310ed7801df$export$1fda8aa4d135f8aa(value) {
    return new $3b138310ed7801df$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $3b138310ed7801df$export$78e43115b553f358(reason) {
    return new $3b138310ed7801df$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $3b138310ed7801df$export$6f292d4960313241 {
    constructor(executor){
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init.call(this);
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init2.call(this);
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init3.call(this);
        $3b138310ed7801df$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $3b138310ed7801df$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $3b138310ed7801df$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $3b138310ed7801df$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($3b138310ed7801df$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($3b138310ed7801df$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $3b138310ed7801df$var$States.PENDING) return;
            if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $3b138310ed7801df$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $3b138310ed7801df$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $3b138310ed7801df$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $3b138310ed7801df$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && processor.id && result === null && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}






/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "extra", extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "tags", tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "user", user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "contexts", contexts);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $f61010b781c81ec1$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$var$applyClientOptions(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f106fce27ec076f7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $29ab5181ea4a2c1b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $fa62667502ab5c7a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $3592a0510b526070$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $baba650ac852ba0c$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $baba650ac852ba0c$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $baba650ac852ba0c$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.entries(debugIdMap).reduce((acc, [debugIdStackTrace, debugIdValue])=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdValue;
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $95721a1f8e4d79f8$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $33c387bb26fe522d$export$775b6bb06e53a214) || typeof hint === "function";
}
const $baba650ac852ba0c$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureException(exception, (0, $baba650ac852ba0c$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $f106fce27ec076f7$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $f61010b781c81ec1$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $dce7651ce4194f00$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $f106fce27ec076f7$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, ()=>{
            finishCheckIn("error");
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $3592a0510b526070$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ecc06dd71ed8ff5f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ecc06dd71ed8ff5f$export$56521d9ba90f62ee)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}



const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $7c0b78736d11cf4a$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $f61010b781c81ec1$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $7c0b78736d11cf4a$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}






/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $755e6178fce08d17$export$6f18f55521af71a1() {
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
            if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const startTimestamp = (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9ddc5321bbc17588$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg
                    };
                    (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9ddc5321bbc17588$export$844ec244b1367d54)(header) && (0, $9ddc5321bbc17588$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $63e43e59b4196dc4$var$parseUrl(url) {
    if ((0, $9ddc5321bbc17588$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}













/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $0b4497afe5c251f9$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $0b4497afe5c251f9$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $0b4497afe5c251f9$var$getFullURL(url);
    const host = fullUrl ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: spanOrigin,
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: "http.client"
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        options.headers = $0b4497afe5c251f9$export$6717acf674206871(request, client, scope, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $0b4497afe5c251f9$export$6717acf674206871(request, client, scope, options, span) {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $36b15c0d755e29f6$export$7e9f8ae9e4a328ab)(span) : (0, $fb06ed6aa7675875$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $f43df6ba426daa1c$export$56766feef403f365)(dsc || (span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$366bad00d6815eed)(traceId, client)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $9ddc5321bbc17588$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $9ddc5321bbc17588$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $f43df6ba426daa1c$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $f43df6ba426daa1c$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $0b4497afe5c251f9$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $0b4497afe5c251f9$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $006ad32cdaebe09b$export$f966a0446ece71e),
        message: "internal_error"
    });
    span.end();
}







const $1772a056d037fd67$var$WINDOW = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $1772a056d037fd67$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1772a056d037fd67$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $1772a056d037fd67$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$1772a056d037fd67$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($1772a056d037fd67$export$d5f608b368e73f38($1772a056d037fd67$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $1772a056d037fd67$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $1772a056d037fd67$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $7a8edf80f542b65c$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$531055a6c684a70a() {
    return "ReportingObserver" in $1772a056d037fd67$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $1772a056d037fd67$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$1772a056d037fd67$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $30557b1c7e561fce$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, ()=>$30557b1c7e561fce$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $30557b1c7e561fce$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, ()=>$30557b1c7e561fce$var$instrumentFetch($30557b1c7e561fce$var$streamHandler));
}
function $30557b1c7e561fce$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $1772a056d037fd67$export$c82d238e23c40b21)()) return;
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $30557b1c7e561fce$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // We capture the stack right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualStackTrace = new Error().stack;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $9ddc5321bbc17588$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualStackTrace;
                    (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $30557b1c7e561fce$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body && res.body.getReader) {
        const responseReader = res.body.getReader();
        // eslint-disable-next-line no-inner-declarations
        async function consumeChunks({ done: done }) {
            if (!done) try {
                // abort reading if read op takes more than 5s
                const result = await Promise.race([
                    responseReader.read(),
                    new Promise((res)=>{
                        setTimeout(()=>{
                            res({
                                done: true
                            });
                        }, 5000);
                    })
                ]);
                await consumeChunks(result);
            } catch (error) {
            // handle error if needed
            }
            else return Promise.resolve();
        }
        return responseReader.read().then(consumeChunks).then(onFinishedResolving).catch(()=>undefined);
    }
}
async function $30557b1c7e561fce$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    await $30557b1c7e561fce$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $dce7651ce4194f00$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $30557b1c7e561fce$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $30557b1c7e561fce$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($30557b1c7e561fce$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $30557b1c7e561fce$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $30557b1c7e561fce$var$getUrlFromResource(url),
            method: $30557b1c7e561fce$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $30557b1c7e561fce$var$getUrlFromResource(arg),
        method: $30557b1c7e561fce$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}



/** Options for Request Instrumentation */ const $edec20d6c9712df6$var$responseToSpanId = new WeakMap();
const $edec20d6c9712df6$var$spanIdToEndTimestamp = new Map();
const $edec20d6c9712df6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true
};
/** Registers span creators for xhr and fetch requests  */ function $edec20d6c9712df6$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$edec20d6c9712df6$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the intial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === "transaction" && event.spans) event.spans.forEach((span)=>{
                if (span.op === "http.client") {
                    const updatedTimestamp = $edec20d6c9712df6$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $edec20d6c9712df6$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        (0, $30557b1c7e561fce$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $edec20d6c9712df6$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $edec20d6c9712df6$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $30557b1c7e561fce$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $0b4497afe5c251f9$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $edec20d6c9712df6$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $edec20d6c9712df6$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
            }
            if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
    });
}
function $edec20d6c9712df6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $edec20d6c9712df6$var$addHTTPTimings(span) {
    const { url: url } = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($edec20d6c9712df6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $edec20d6c9712df6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $edec20d6c9712df6$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $edec20d6c9712df6$var$getAbsoluteTime(time = 0) {
    return (((0, $dce7651ce4194f00$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $edec20d6c9712df6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $edec20d6c9712df6$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $dce7651ce4194f00$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $edec20d6c9712df6$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $006ad32cdaebe09b$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $edec20d6c9712df6$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.http.browser",
            [(0, $068c396dceb690a1$export$1a413bd9a88fdb09)]: "http.client"
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, client, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    return span;
}
function $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, client, span) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span && (0, $e426c875bd1d2890$export$5008da00b1b6dee6)() ? (0, $36b15c0d755e29f6$export$7e9f8ae9e4a328ab)(span) : (0, $fb06ed6aa7675875$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $f43df6ba426daa1c$export$56766feef403f365)(dsc || (span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$366bad00d6815eed)(traceId, client)));
    $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
}
function $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $f43df6ba426daa1c$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $edec20d6c9712df6$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $400f75f99113439b$export$bbd2089f30bd3708 = "BrowserTracing";
const $400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $fd927ea1b5d85956$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {},
    ...(0, $edec20d6c9712df6$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $400f75f99113439b$export$b4109253475213e9 = (_options = {})=>{
    (0, $d4be1d52827a3f28$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $4ca18541755f3f2c$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $751b596e3029fa17$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame")) (0, $4ca18541755f3f2c$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $4ca18541755f3f2c$export$f396d19077034ad2)();
    if (enableInteractions) (0, $4ca18541755f3f2c$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === "pageload";
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $068c396dceb690a1$export$d7a7d984b0791405] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        const idleSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $4ca18541755f3f2c$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                "interactive",
                "complete"
            ].includes((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadTransaction && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
            (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $400f75f99113439b$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            client.on("startNavigationSpan", (startSpanOptions)=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan && !(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                activeSpan = _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan && !(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $36b15c0d755e29f6$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                const sentryTrace = traceOptions.sentryTrace || $400f75f99113439b$export$f147b32b03c9cf11("sentry-trace");
                const baggage = traceOptions.baggage || $400f75f99113439b$export$f147b32b03c9cf11("baggage");
                const propagationContext = (0, $fb06ed6aa7675875$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on("spanEnd", (span)=>{
                const op = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
                if (span !== (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span) || op !== "navigation" && op !== "pageload") return;
                const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(span),
                    dsc: oldPropagationContext.dsc || (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span)
                });
            });
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $400f75f99113439b$export$aa44a07f82af519f(client, {
                    name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $dce7651ce4194f00$export$baf075a948ffc0bf) ? (0, $dce7651ce4194f00$export$baf075a948ffc0bf) / 1000 : undefined,
                    attributes: {
                        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: "url",
                        [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.pageload.browser"
                    }
                });
                if (instrumentNavigation) (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $400f75f99113439b$export$7d159749bd9969ad(client, {
                            name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: "url",
                                [(0, $068c396dceb690a1$export$cca8dd30f57f805e)]: "auto.navigation.browser"
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $755e6178fce08d17$export$6f18f55521af71a1)();
            if (enableInteractions) $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $751b596e3029fa17$export$e4e04d43e223cce2)();
            (0, $edec20d6c9712df6$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $400f75f99113439b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $400f75f99113439b$export$7d159749bd9969ad(client, spanOptions) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setPropagationContext((0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)());
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setPropagationContext((0, $8cd423ca54f15ed2$export$37f0f2f9cf343e5e)());
    client.emit("startNavigationSpan", spanOptions);
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
    const op = span && (0, $36b15c0d755e29f6$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $400f75f99113439b$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $b1794bb8b282584f$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeSpan = (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $068c396dceb690a1$export$ba73f34502b7a3b3), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) addEventListener("click", registerInteractionTransaction, {
        once: false,
        capture: true
    });
}





const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $f61010b781c81ec1$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $fbb22756c9507e85$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === "Debug");
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}



const $b99d5bb3db344fdd$var$INTEGRATION_NAME = "Dedupe";
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $53d728fa04e56ec9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $53d728fa04e56ec9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = "FunctionToString";
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $7c0b78736d11cf4a$export$e6cc1e135e2092e5)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);


const $0e303f054920e2b1$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $7c0b78736d11cf4a$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $3a0c11012bdf3bae$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler"
];
/** Options for the InboundFilters integration */ const $67b350191b117f2b$var$INTEGRATION_NAME = "InboundFilters";
const $67b350191b117f2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $67b350191b117f2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $67b350191b117f2b$var$_mergeOptions(options, clientOptions);
            return $67b350191b117f2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $67b350191b117f2b$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)($67b350191b117f2b$var$_inboundFiltersIntegration);
function $67b350191b117f2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $67b350191b117f2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $67b350191b117f2b$var$_isSentryError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isUselessError(event)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$67b350191b117f2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $67b350191b117f2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $67b350191b117f2b$var$_getPossibleEventMessages(event).some((message)=>(0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $67b350191b117f2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $67b350191b117f2b$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $67b350191b117f2b$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $67b350191b117f2b$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $67b350191b117f2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $67b350191b117f2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $67b350191b117f2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $67b350191b117f2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $f61010b781c81ec1$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $67b350191b117f2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b776c95debaa4af0$export$16a28057038b10ef) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setClient(client);
}





/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $54de22820fe8f5c8$export$31499a9cd224b78c)
            })),
        version: (0, $54de22820fe8f5c8$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $9a56b3ff3570ceec$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/** An error emitted by Sentry SDKs and related utilities. */ class $ea7cef744a918cc0$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}











const $4f30d529f2099042$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $4f30d529f2099042$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $3a0c11012bdf3bae$export$128827c3562ec0cb)(options.dsn);
        else (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    captureException(exception, hint, scope) {
        const eventId = (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $f61010b781c81ec1$export$6de4ffac6a2f1098)(exception)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $f61010b781c81ec1$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $9ddc5321bbc17588$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $f61010b781c81ec1$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $f61010b781c81ec1$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $19ddf33da467375a$export$d650323442802f6f)(env, (0, $19ddf33da467375a$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assue the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assue the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Error while sending event:", reason);
            return reason;
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Transport disabled");
        return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $3b138310ed7801df$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $baba650ac852ba0c$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...currentScope ? currentScope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    }),
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $dfdaf30e5fcd5fd9$export$366bad00d6815eed)(trace_id, this);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4f30d529f2099042$var$isTransactionEvent(event);
        const isError = $4f30d529f2099042$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $3b138310ed7801df$export$78e43115b553f358)(new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $4f30d529f2099042$var$processBeforeSend(this, options, prepared, hint);
            return $4f30d529f2099042$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $9a56b3ff3570ceec$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $4f30d529f2099042$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9ddc5321bbc17588$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $4f30d529f2099042$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($4f30d529f2099042$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($4f30d529f2099042$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else client.recordDroppedEvent("before_send", "span");
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $4f30d529f2099042$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $4f30d529f2099042$var$isTransactionEvent(event) {
    return event.type === "transaction";
}



var $jDabP = parcelRequire("jDabP");



/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $23dde874fe12fd4c$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $95721a1f8e4d79f8$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9ddc5321bbc17588$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9ddc5321bbc17588$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9ddc5321bbc17588$export$ef9e2056653f0c8e)(exception) || (0, $9ddc5321bbc17588$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9ddc5321bbc17588$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $f61010b781c81ec1$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $9ddc5321bbc17588$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $9ddc5321bbc17588$export$53b83ca8eaab0383)(exception) || (0, $9ddc5321bbc17588$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $f61010b781c81ec1$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $f61010b781c81ec1$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $9ddc5321bbc17588$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $7c0b78736d11cf4a$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9ddc5321bbc17588$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9ddc5321bbc17588$export$9671ea99bd126ace)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




/**
 * Creates an envelope from a user feedback.
 */ function $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $3a0c11012bdf3bae$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $4f30d529f2099042$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $jDabP.getSDKSource)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
}






const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $3fec3b92cacfb9e4$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const proto = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[target] && (0, $955496f5d3029976$export$56d8a8a25bd48b81)[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $7c0b78736d11cf4a$export$e73679ffaf56810e)(target, "_sentryId", (0, $f61010b781c81ec1$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $dce7651ce4194f00$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}






/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8444b49f56f15ce4$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $3fec3b92cacfb9e4$export$a4e09611e30da72e)(type, handler);
    (0, $3fec3b92cacfb9e4$export$e18d6c5462c01368)(type, $8444b49f56f15ce4$var$instrumentConsole);
}
function $8444b49f56f15ce4$var$instrumentConsole() {
    if (!("console" in (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1))) return;
    (0, $eddf779ebbe9b538$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console)) return;
        (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $eddf779ebbe9b538$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $3fec3b92cacfb9e4$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $eddf779ebbe9b538$export$77c4ce905194557b)[level];
                log && log.apply((0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $575cb5410d2010d0$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $575cb5410d2010d0$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $575cb5410d2010d0$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = "Breadcrumbs";
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $8444b49f56f15ce4$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $30557b1c7e561fce$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $f61010b781c81ec1$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $b1794bb8b282584f$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $b1794bb8b282584f$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $575cb5410d2010d0$export$d771ef054122c30a)(handlerData.level),
            message: (0, $ef17463c720dc68b$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $ef17463c720dc68b$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $cc4acb8fa68987a7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = "BrowserApiErrors";
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "setTimeout", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "setInterval", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "requestAnimationFrame", $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4e018dbe28beb052$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $7c0b78736d11cf4a$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $53d728fa04e56ec9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $53d728fa04e56ec9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}







const $3920039f2d643754$var$INTEGRATION_NAME = "GlobalHandlers";
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $18dd1219fff07956$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $d65fa0065561a897$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $9ddc5321bbc17588$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $9ddc5321bbc17588$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $b1794bb8b282584f$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $bdc874c42642b289$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9ddc5321bbc17588$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $bdc874c42642b289$var$truncateAggregateExceptions($bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9ddc5321bbc17588$export$49034edbe6b62415)(error[key], Error)) {
        $bdc874c42642b289$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $bdc874c42642b289$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9ddc5321bbc17588$export$49034edbe6b62415)(childError, Error)) {
            $bdc874c42642b289$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $bdc874c42642b289$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $bdc874c42642b289$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $bdc874c42642b289$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $bdc874c42642b289$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $bdc874c42642b289$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $ef17463c720dc68b$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = "cause";
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = "LinkedErrors";
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $bdc874c42642b289$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $53d728fa04e56ec9$export$a5739666fb2d03d4)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $53d728fa04e56ec9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $1772a056d037fd67$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("setTimeout")(...rest);
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $bde3819d7b9aaee7$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $bde3819d7b9aaee7$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $bde3819d7b9aaee7$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $bde3819d7b9aaee7$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $bde3819d7b9aaee7$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $bde3819d7b9aaee7$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $bde3819d7b9aaee7$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $bde3819d7b9aaee7$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $bd33167c8fcedc8a$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $3b138310ed7801df$export$78e43115b553f358)(new (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $3b138310ed7801df$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $bd33167c8fcedc8a$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $19ddf33da467375a$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $19ddf33da467375a$export$b11169581eeaf237)(type);
            if ((0, $bde3819d7b9aaee7$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $19ddf33da467375a$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $19ddf33da467375a$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $19ddf33da467375a$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $19ddf33da467375a$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $bde3819d7b9aaee7$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $ea7cef744a918cc0$export$5949942ba2a7c0e2)) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $edfbff9038a67171$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)("fetch");
            return (0, $3b138310ed7801df$export$78e43115b553f358)("No fetch implementation available");
        }
        try {
            // TODO: This may need a `suppresTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $3b138310ed7801df$export$78e43115b553f358)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $67b350191b117f2b$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)()
    ];
}
function $928f566aa50bb77a$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== "undefined" && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$var$applyDefaultOptions(browserOptions);
    if ($928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $7b8b500cb80621bc$export$16a28057038b10ef) {
        if (!(0, $1772a056d037fd67$export$edf3cb81fd7d2a3e)()) (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $53d728fa04e56ec9$export$1d5cf88b347146d4)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    const client = (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $928f566aa50bb77a$var$startSessionTracking();
    return client;
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $f2b90654edf2c0a1$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $928f566aa50bb77a$var$startSessionTracking() {
    if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $928f566aa50bb77a$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $fe334ae3892c74f1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;





var $acw62 = parcelRequire("acw62");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $262dc4fd22993153$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $262dc4fd22993153$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $262dc4fd22993153$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($262dc4fd22993153$export$a87138b73900f5b((0, $acw62.version)) && (0, $9ddc5321bbc17588$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $262dc4fd22993153$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error, {
        ...hint,
        captureContext: {
            contexts: {
                react: {
                    componentStack: componentStack
                }
            }
        }
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $262dc4fd22993153$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $262dc4fd22993153$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


const $8921079907ea55d7$export$6ef4c0367e27f2d5 = "unknown";
const $8921079907ea55d7$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $8921079907ea55d7$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        $8921079907ea55d7$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $8921079907ea55d7$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on("afterSendEvent", (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        // TODO(v9): Remove this check and type `componentStack` to be React.ErrorInfo['componentStack'].
        const passedInComponentStack = componentStack == null ? undefined : componentStack;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, passedInComponentStack);
            const eventId = (0, $262dc4fd22993153$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, passedInComponentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($8921079907ea55d7$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = $acw62.createElement(fallback, {
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($acw62.isValidElement(element)) return element;
            if (fallback) (0, $fe334ae3892c74f1$export$16a28057038b10ef) && (0, $eddf779ebbe9b538$export$af88d00dbe7f521).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8921079907ea55d7$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $8921079907ea55d7$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$acw62.createElement($8921079907ea55d7$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $acw62.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Wrapped, WrappedComponent);
    return Wrapped;
}




var $acw62 = parcelRequire("acw62");
/**
 * Inits the React SDK
 */ function $07b303fd558e140e$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, "react");
    (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)("react", {
        version: $acw62.version
    });
    return (0, $928f566aa50bb77a$export$2cd8252107eb640b)(opts);
}



var $9d8f9caef3f3d2e5$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($9d8f9caef3f3d2e5$var$NodeType || ($9d8f9caef3f3d2e5$var$NodeType = {}));
function $9d8f9caef3f3d2e5$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $9d8f9caef3f3d2e5$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $9d8f9caef3f3d2e5$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $9d8f9caef3f3d2e5$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($9d8f9caef3f3d2e5$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
const $9d8f9caef3f3d2e5$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $9d8f9caef3f3d2e5$var$_mirror = {
    map: {},
    getId () {
        console.error($9d8f9caef3f3d2e5$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($9d8f9caef3f3d2e5$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($9d8f9caef3f3d2e5$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($9d8f9caef3f3d2e5$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($9d8f9caef3f3d2e5$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $9d8f9caef3f3d2e5$var$_mirror = new Proxy($9d8f9caef3f3d2e5$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($9d8f9caef3f3d2e5$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $9d8f9caef3f3d2e5$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $9d8f9caef3f3d2e5$var$setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$9d8f9caef3f3d2e5$var$hookSetter(target, key, original || {}, true);
}
function $9d8f9caef3f3d2e5$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
/[1-9][0-9]{12}/.test(Date.now().toString());
function $9d8f9caef3f3d2e5$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $9d8f9caef3f3d2e5$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $9d8f9caef3f3d2e5$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $9d8f9caef3f3d2e5$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $9d8f9caef3f3d2e5$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $9d8f9caef3f3d2e5$var$distanceToMatch(el, $9d8f9caef3f3d2e5$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
const $9d8f9caef3f3d2e5$var$cachedImplementations = {};
function $9d8f9caef3f3d2e5$var$getImplementation(name) {
    const cached = $9d8f9caef3f3d2e5$var$cachedImplementations[name];
    if (cached) return cached;
    const document = window.document;
    let impl = window[name];
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {}
    return $9d8f9caef3f3d2e5$var$cachedImplementations[name] = impl.bind(window);
}
function $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(...rest) {
    return $9d8f9caef3f3d2e5$var$getImplementation("requestAnimationFrame")(...rest);
}
function $9d8f9caef3f3d2e5$var$setTimeout(...rest) {
    return $9d8f9caef3f3d2e5$var$getImplementation("setTimeout")(...rest);
}
var $9d8f9caef3f3d2e5$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($9d8f9caef3f3d2e5$var$CanvasContext || {});
let $9d8f9caef3f3d2e5$var$errorHandler;
function $9d8f9caef3f3d2e5$var$registerErrorHandler(handler) {
    $9d8f9caef3f3d2e5$var$errorHandler = handler;
}
const $9d8f9caef3f3d2e5$var$callbackWrapper = (cb)=>{
    if (!$9d8f9caef3f3d2e5$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($9d8f9caef3f3d2e5$var$errorHandler && $9d8f9caef3f3d2e5$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $9d8f9caef3f3d2e5$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $9d8f9caef3f3d2e5$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $9d8f9caef3f3d2e5$var$i = 0; $9d8f9caef3f3d2e5$var$i < $9d8f9caef3f3d2e5$var$chars.length; $9d8f9caef3f3d2e5$var$i++)$9d8f9caef3f3d2e5$var$lookup[$9d8f9caef3f3d2e5$var$chars.charCodeAt($9d8f9caef3f3d2e5$var$i)] = $9d8f9caef3f3d2e5$var$i;
var $9d8f9caef3f3d2e5$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $9d8f9caef3f3d2e5$var$chars[bytes[i] >> 2];
        base64 += $9d8f9caef3f3d2e5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $9d8f9caef3f3d2e5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $9d8f9caef3f3d2e5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $9d8f9caef3f3d2e5$var$canvasVarMap = new Map();
function $9d8f9caef3f3d2e5$var$variableListFor(ctx, ctor) {
    let contextMap = $9d8f9caef3f3d2e5$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $9d8f9caef3f3d2e5$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $9d8f9caef3f3d2e5$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($9d8f9caef3f3d2e5$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $9d8f9caef3f3d2e5$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $9d8f9caef3f3d2e5$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$9d8f9caef3f3d2e5$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $9d8f9caef3f3d2e5$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $9d8f9caef3f3d2e5$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $9d8f9caef3f3d2e5$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($9d8f9caef3f3d2e5$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $9d8f9caef3f3d2e5$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $9d8f9caef3f3d2e5$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$9d8f9caef3f3d2e5$var$serializeArg(arg, win, ctx));
};
const $9d8f9caef3f3d2e5$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $9d8f9caef3f3d2e5$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $9d8f9caef3f3d2e5$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$9d8f9caef3f3d2e5$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) $9d8f9caef3f3d2e5$var$setTimeout(()=>{
                    const recordArgs = $9d8f9caef3f3d2e5$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $9d8f9caef3f3d2e5$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        const hookHandler = $9d8f9caef3f3d2e5$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $9d8f9caef3f3d2e5$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $9d8f9caef3f3d2e5$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $9d8f9caef3f3d2e5$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $9d8f9caef3f3d2e5$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$9d8f9caef3f3d2e5$var$isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = $9d8f9caef3f3d2e5$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $9d8f9caef3f3d2e5$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = $9d8f9caef3f3d2e5$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $9d8f9caef3f3d2e5$var$saveWebGLVar(result, win, this);
                    if ("tagName" in this.canvas && !$9d8f9caef3f3d2e5$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                        const recordArgs = $9d8f9caef3f3d2e5$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            const hookHandler = $9d8f9caef3f3d2e5$var$hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $9d8f9caef3f3d2e5$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$9d8f9caef3f3d2e5$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $9d8f9caef3f3d2e5$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$9d8f9caef3f3d2e5$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $9d8f9caef3f3d2e5$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
var $9d8f9caef3f3d2e5$var$r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function $9d8f9caef3f3d2e5$var$t() {
    const t = new Blob([
        $9d8f9caef3f3d2e5$var$r
    ]);
    return URL.createObjectURL(t);
}
class $9d8f9caef3f3d2e5$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.windowsSet = new WeakSet();
        this.windows = [];
        this.shadowDoms = new Set();
        (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            this,
            "access",
            (_)=>_.worker,
            "optionalAccess",
            (_2)=>_2.terminate,
            "call",
            (_3)=>_3()
        ]);
        this.worker = null;
        this.snapshotInProgressMap = new Map();
        if (this.options.recordCanvas && typeof this.options.sampling === "number" || this.options.enableManualSnapshot) this.worker = this.initFPSWorker();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.shadowDoms = new Set();
        this.windowsSet = new WeakSet();
        this.windows = [];
        this.restoreHandlers = [];
        this.frozen = false;
        this.locked = false;
        this.snapshotInProgressMap = new Map();
        this.worker = null;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling: sampling = "all", win: win, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maxCanvasSize: maxCanvasSize, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions, errorHandler: errorHandler } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) $9d8f9caef3f3d2e5$var$registerErrorHandler(errorHandler);
        if (recordCanvas && typeof sampling === "number" || options.enableManualSnapshot) this.worker = this.initFPSWorker();
        this.addWindow(win);
        if (options.enableManualSnapshot) return;
        $9d8f9caef3f3d2e5$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") {
                this.startRAFTimestamping();
                this.startPendingCanvasMutationFlusher();
            }
            if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                dataURLOptions: dataURLOptions
            });
        })();
    }
    addWindow(win) {
        const { sampling: sampling = "all", blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, recordCanvas: recordCanvas, enableManualSnapshot: enableManualSnapshot } = this.options;
        if (this.windowsSet.has(win)) return;
        if (enableManualSnapshot) {
            this.windowsSet.add(win);
            this.windows.push(new WeakRef(win));
            return;
        }
        $9d8f9caef3f3d2e5$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === "number") {
                const canvasContextReset = $9d8f9caef3f3d2e5$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
                this.restoreHandlers.push(()=>{
                    canvasContextReset();
                });
            }
        })();
        this.windowsSet.add(win);
        this.windows.push(new WeakRef(win));
    }
    addShadowRoot(shadowRoot) {
        this.shadowDoms.add(new WeakRef(shadowRoot));
    }
    resetShadowRoots() {
        this.shadowDoms = new Set();
    }
    initFPSWorker() {
        const worker = new Worker($9d8f9caef3f3d2e5$var$t());
        worker.onmessage = (e)=>{
            const data = e.data;
            const { id: id } = data;
            this.snapshotInProgressMap.set(id, false);
            if (!("base64" in data)) return;
            const { base64: base64, type: type, width: width, height: height } = data;
            this.mutationCb({
                id: id,
                type: $9d8f9caef3f3d2e5$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0,
                            width,
                            height
                        ]
                    }
                ]
            });
        };
        return worker;
    }
    initCanvasFPSObserver(fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
        const rafId = this.takeSnapshot(false, fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
        this.restoreHandlers.push(()=>{
            cancelAnimationFrame(rafId);
        });
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        const canvasContextReset = $9d8f9caef3f3d2e5$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = $9d8f9caef3f3d2e5$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = $9d8f9caef3f3d2e5$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.restoreHandlers.push(()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        });
    }
    snapshot(canvasElement) {
        const { options: options } = this;
        const rafId = this.takeSnapshot(true, options.sampling === "all" ? 2 : options.sampling || 2, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
        this.restoreHandlers.push(()=>{
            cancelAnimationFrame(rafId);
        });
    }
    takeSnapshot(isManualSnapshot, fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = (canvasElement)=>{
            if (canvasElement) return [
                canvasElement
            ];
            const matchedCanvas = [];
            const searchCanvas = (root)=>{
                root.querySelectorAll("canvas").forEach((canvas)=>{
                    if (!$9d8f9caef3f3d2e5$var$isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
                });
            };
            for (const item of this.windows){
                const window1 = item.deref();
                if (window1) searchCanvas(window1.document);
            }
            for (const item of this.shadowDoms){
                const shadowRoot = item.deref();
                if (shadowRoot) searchCanvas(shadowRoot);
            }
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (!this.windows.length) return;
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas(canvasElement).forEach((canvas)=>{
                if (!this.mirror.hasNode(canvas)) return;
                const id = this.mirror.getId(canvas);
                if (this.snapshotInProgressMap.get(id)) return;
                if (!canvas.width || !canvas.height) return;
                this.snapshotInProgressMap.set(id, true);
                if (!isManualSnapshot && [
                    "webgl",
                    "webgl2"
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if ((0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
                        context,
                        "optionalAccess",
                        (_4)=>_4.getContextAttributes,
                        "call",
                        (_5)=>_5(),
                        "optionalAccess",
                        (_6)=>_6.preserveDrawingBuffer
                    ]) === false) context.clear(context.COLOR_BUFFER_BIT);
                }
                createImageBitmap(canvas).then((bitmap)=>{
                    (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
                        this,
                        "access",
                        (_7)=>_7.worker,
                        "optionalAccess",
                        (_8)=>_8.postMessage,
                        "call",
                        (_9)=>_9({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: dataURLOptions,
                                maxCanvasSize: maxCanvasSize
                            }, [
                                bitmap
                            ])
                    ]);
                }).catch((error)=>{
                    $9d8f9caef3f3d2e5$var$callbackWrapper(()=>{
                        throw error;
                    })();
                });
            });
            if (!isManualSnapshot) rafId = $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(takeCanvasSnapshots);
        return rafId;
    }
    startPendingCanvasMutationFlusher() {
        $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        $9d8f9caef3f3d2e5$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
const $9d8f9caef3f3d2e5$var$CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.5
        }
    }
};
const $9d8f9caef3f3d2e5$var$INTEGRATION_NAME = "ReplayCanvas";
const $9d8f9caef3f3d2e5$var$DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ const $9d8f9caef3f3d2e5$var$_replayCanvasIntegration = (options = {})=>{
    const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
    const _canvasOptions = {
        quality: options.quality || "medium",
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, $9d8f9caef3f3d2e5$var$DEFAULT_MAX_CANVAS_SIZE) : $9d8f9caef3f3d2e5$var$DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, $9d8f9caef3f3d2e5$var$DEFAULT_MAX_CANVAS_SIZE) : $9d8f9caef3f3d2e5$var$DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: $9d8f9caef3f3d2e5$var$INTEGRATION_NAME,
        getOptions () {
            const { quality: quality, enableManualSnapshot: enableManualSnapshot, maxCanvasSize: maxCanvasSize } = _canvasOptions;
            return {
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (getCanvasManagerOptions)=>{
                    const manager = new $9d8f9caef3f3d2e5$var$CanvasManager({
                        ...getCanvasManagerOptions,
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === "object") err.__rrweb__ = true;
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    });
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...$9d8f9caef3f3d2e5$var$CANVAS_QUALITY[quality || "medium"] || $9d8f9caef3f3d2e5$var$CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement) {
            const canvasManager = await _canvasManager;
            canvasManager.snapshot(canvasElement);
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ const $9d8f9caef3f3d2e5$export$71ba62165d5c834d = (0, $fbb22756c9507e85$export$2323046b9414659f)($9d8f9caef3f3d2e5$var$_replayCanvasIntegration);

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $cdfbe47f64dd4269$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}


var $7IZ3O = parcelRequire("7IZ3O");

/**
 * Returns true if we are in the browser.
 */ function $0410ba75ede19d70$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $7IZ3O.isNodeEnv)() || $0410ba75ede19d70$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $0410ba75ede19d70$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).process !== undefined && (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1).process.type === "renderer");
}


/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $e523a4dfa96cd99a$export$d92e61f5600202af(url, client) {
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $e523a4dfa96cd99a$var$checkDsn(url, dsn) || $e523a4dfa96cd99a$var$checkTunnel(url, tunnel);
}
function $e523a4dfa96cd99a$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $e523a4dfa96cd99a$var$removeTrailingSlash(url) === $e523a4dfa96cd99a$var$removeTrailingSlash(tunnel);
}
function $e523a4dfa96cd99a$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $e523a4dfa96cd99a$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $0ca4f63b79e931bd$var$WINDOW = (0, $daf9a5aa340ffc23$export$f1a6cdb1459e81d1);
const $0ca4f63b79e931bd$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $0ca4f63b79e931bd$var$REPLAY_EVENT_NAME = "replay_event";
const $0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $0ca4f63b79e931bd$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $0ca4f63b79e931bd$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $0ca4f63b79e931bd$var$BUFFER_CHECKOUT_TIME = 60000;
const $0ca4f63b79e931bd$var$RETRY_BASE_INTERVAL = 5000;
const $0ca4f63b79e931bd$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $0ca4f63b79e931bd$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $0ca4f63b79e931bd$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $0ca4f63b79e931bd$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $0ca4f63b79e931bd$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $0ca4f63b79e931bd$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($0ca4f63b79e931bd$var$NodeType$1 || ($0ca4f63b79e931bd$var$NodeType$1 = {}));
function $0ca4f63b79e931bd$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $0ca4f63b79e931bd$var$isShadowRoot(n) {
    const host = $0ca4f63b79e931bd$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($0ca4f63b79e931bd$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $0ca4f63b79e931bd$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $0ca4f63b79e931bd$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $0ca4f63b79e931bd$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $0ca4f63b79e931bd$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $0ca4f63b79e931bd$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $0ca4f63b79e931bd$var$stringifyRule(rule) {
    let importStringified;
    if ($0ca4f63b79e931bd$var$isCSSImportRule(rule)) try {
        importStringified = $0ca4f63b79e931bd$var$stringifyStylesheet(rule.styleSheet) || $0ca4f63b79e931bd$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($0ca4f63b79e931bd$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $0ca4f63b79e931bd$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $0ca4f63b79e931bd$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $0ca4f63b79e931bd$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $0ca4f63b79e931bd$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $0ca4f63b79e931bd$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $0ca4f63b79e931bd$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $0ca4f63b79e931bd$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $0ca4f63b79e931bd$var$createMirror() {
    return new $0ca4f63b79e931bd$var$Mirror();
}
function $0ca4f63b79e931bd$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $0ca4f63b79e931bd$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $0ca4f63b79e931bd$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $0ca4f63b79e931bd$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $0ca4f63b79e931bd$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $0ca4f63b79e931bd$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $0ca4f63b79e931bd$var$toLowerCase(type) : null;
}
function $0ca4f63b79e931bd$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $0ca4f63b79e931bd$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, $0ca4f63b79e931bd$var$_nullishCoalesce$1(baseURL, ()=>window.location.href));
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return $0ca4f63b79e931bd$var$_nullishCoalesce$1($0ca4f63b79e931bd$var$_optionalChain$5([
        match,
        "optionalAccess",
        (_6)=>_6[1]
    ]), ()=>null);
}
const $0ca4f63b79e931bd$var$cachedImplementations$1 = {};
function $0ca4f63b79e931bd$var$getImplementation$1(name) {
    const cached = $0ca4f63b79e931bd$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $0ca4f63b79e931bd$var$cachedImplementations$1[name] = impl.bind(window);
}
function $0ca4f63b79e931bd$var$setTimeout$2(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation$1("setTimeout")(...rest);
}
function $0ca4f63b79e931bd$var$clearTimeout$2(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation$1("clearTimeout")(...rest);
}
let $0ca4f63b79e931bd$var$_id = 1;
const $0ca4f63b79e931bd$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $0ca4f63b79e931bd$var$IGNORED_NODE = -2;
function $0ca4f63b79e931bd$var$genId() {
    return $0ca4f63b79e931bd$var$_id++;
}
function $0ca4f63b79e931bd$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $0ca4f63b79e931bd$var$toLowerCase(element.tagName);
    if ($0ca4f63b79e931bd$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $0ca4f63b79e931bd$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $0ca4f63b79e931bd$var$canvasService;
let $0ca4f63b79e931bd$var$canvasCtx;
const $0ca4f63b79e931bd$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $0ca4f63b79e931bd$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $0ca4f63b79e931bd$var$URL_WWW_MATCH = /^www\..*/i;
const $0ca4f63b79e931bd$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($0ca4f63b79e931bd$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($0ca4f63b79e931bd$var$URL_PROTOCOL_MATCH.test(filePath) || $0ca4f63b79e931bd$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($0ca4f63b79e931bd$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$0ca4f63b79e931bd$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $0ca4f63b79e931bd$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $0ca4f63b79e931bd$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $0ca4f63b79e931bd$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($0ca4f63b79e931bd$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($0ca4f63b79e931bd$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $0ca4f63b79e931bd$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $0ca4f63b79e931bd$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $0ca4f63b79e931bd$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $0ca4f63b79e931bd$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $0ca4f63b79e931bd$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $0ca4f63b79e931bd$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $0ca4f63b79e931bd$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $0ca4f63b79e931bd$var$absoluteToStylesheet(value, $0ca4f63b79e931bd$var$getHref());
    else if (tagName === "object" && name === "data") return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $0ca4f63b79e931bd$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $0ca4f63b79e931bd$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $0ca4f63b79e931bd$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $0ca4f63b79e931bd$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $0ca4f63b79e931bd$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $0ca4f63b79e931bd$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($0ca4f63b79e931bd$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $0ca4f63b79e931bd$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $0ca4f63b79e931bd$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $0ca4f63b79e931bd$var$setTimeout$2(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $0ca4f63b79e931bd$var$clearTimeout$2(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $0ca4f63b79e931bd$var$setTimeout$2(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $0ca4f63b79e931bd$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = $0ca4f63b79e931bd$var$setTimeout$2(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $0ca4f63b79e931bd$var$clearTimeout$2(timer);
        fired = true;
        listener();
    });
}
function $0ca4f63b79e931bd$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $0ca4f63b79e931bd$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $0ca4f63b79e931bd$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $0ca4f63b79e931bd$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $0ca4f63b79e931bd$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $0ca4f63b79e931bd$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $0ca4f63b79e931bd$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $0ca4f63b79e931bd$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($0ca4f63b79e931bd$var$_optionalChain$5([
                n,
                "access",
                (_7)=>_7.parentNode,
                "access",
                (_8)=>_8.sheet,
                "optionalAccess",
                (_9)=>_9.cssRules
            ])) textContent = $0ca4f63b79e931bd$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $0ca4f63b79e931bd$var$absoluteToStylesheet(textContent, $0ca4f63b79e931bd$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $0ca4f63b79e931bd$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $0ca4f63b79e931bd$var$maskInputValue({
            isMasked: $0ca4f63b79e931bd$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $0ca4f63b79e931bd$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $0ca4f63b79e931bd$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $0ca4f63b79e931bd$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $0ca4f63b79e931bd$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$0ca4f63b79e931bd$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $0ca4f63b79e931bd$var$transformAttribute(doc, tagName, $0ca4f63b79e931bd$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $0ca4f63b79e931bd$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $0ca4f63b79e931bd$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, $0ca4f63b79e931bd$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $0ca4f63b79e931bd$var$getInputType(el);
        const value = $0ca4f63b79e931bd$var$getInputValue(el, $0ca4f63b79e931bd$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $0ca4f63b79e931bd$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $0ca4f63b79e931bd$var$shouldMaskInput({
                type: type,
                tagName: $0ca4f63b79e931bd$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $0ca4f63b79e931bd$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$0ca4f63b79e931bd$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$0ca4f63b79e931bd$var$canvasService) {
            $0ca4f63b79e931bd$var$canvasService = doc.createElement("canvas");
            $0ca4f63b79e931bd$var$canvasCtx = $0ca4f63b79e931bd$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $0ca4f63b79e931bd$var$canvasService.width = image.naturalWidth;
                $0ca4f63b79e931bd$var$canvasService.height = image.naturalHeight;
                $0ca4f63b79e931bd$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $0ca4f63b79e931bd$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!needBlock && !n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $0ca4f63b79e931bd$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $0ca4f63b79e931bd$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $0ca4f63b79e931bd$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $0ca4f63b79e931bd$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $0ca4f63b79e931bd$var$NodeType$1.Comment) return true;
    else if (sn.type === $0ca4f63b79e931bd$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $0ca4f63b79e931bd$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "application-name" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === "icon" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "robots" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "googlebot" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "author" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "generator" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "framework" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "publisher" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "progid" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "verification" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $0ca4f63b79e931bd$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $0ca4f63b79e931bd$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($0ca4f63b79e931bd$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $0ca4f63b79e931bd$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $0ca4f63b79e931bd$var$IGNORED_NODE;
    else id = $0ca4f63b79e931bd$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $0ca4f63b79e931bd$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $0ca4f63b79e931bd$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $0ca4f63b79e931bd$var$NodeType$1.Document || serializedNode.type === $0ca4f63b79e931bd$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $0ca4f63b79e931bd$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $0ca4f63b79e931bd$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($0ca4f63b79e931bd$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $0ca4f63b79e931bd$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $0ca4f63b79e931bd$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $0ca4f63b79e931bd$var$isShadowRoot(n.parentNode) && $0ca4f63b79e931bd$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $0ca4f63b79e931bd$var$NodeType$1.Element && serializedNode.tagName === "iframe") $0ca4f63b79e931bd$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $0ca4f63b79e931bd$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $0ca4f63b79e931bd$var$NodeType$1.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $0ca4f63b79e931bd$var$extractFileExtension(serializedNode.attributes.href) === "css")) $0ca4f63b79e931bd$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $0ca4f63b79e931bd$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $0ca4f63b79e931bd$var$snapshot(n, options) {
    const { mirror: mirror = new $0ca4f63b79e931bd$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $0ca4f63b79e931bd$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $0ca4f63b79e931bd$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $0ca4f63b79e931bd$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $0ca4f63b79e931bd$var$_mirror = {
    map: {},
    getId () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $0ca4f63b79e931bd$var$_mirror = new Proxy($0ca4f63b79e931bd$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $0ca4f63b79e931bd$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $0ca4f63b79e931bd$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $0ca4f63b79e931bd$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $0ca4f63b79e931bd$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $0ca4f63b79e931bd$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$0ca4f63b79e931bd$var$hookSetter(target, key, original || {}, true);
}
function $0ca4f63b79e931bd$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $0ca4f63b79e931bd$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $0ca4f63b79e931bd$var$nowTimestamp = ()=>new Date().getTime();
function $0ca4f63b79e931bd$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $0ca4f63b79e931bd$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $0ca4f63b79e931bd$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $0ca4f63b79e931bd$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $0ca4f63b79e931bd$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $0ca4f63b79e931bd$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $0ca4f63b79e931bd$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $0ca4f63b79e931bd$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $0ca4f63b79e931bd$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $0ca4f63b79e931bd$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $0ca4f63b79e931bd$var$IGNORED_NODE;
}
function $0ca4f63b79e931bd$var$isAncestorRemoved(target, mirror) {
    if ($0ca4f63b79e931bd$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $0ca4f63b79e931bd$var$isAncestorRemoved(target.parentNode, mirror);
}
function $0ca4f63b79e931bd$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $0ca4f63b79e931bd$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $0ca4f63b79e931bd$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $0ca4f63b79e931bd$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $0ca4f63b79e931bd$var$hasShadowRoot(n) {
    return Boolean($0ca4f63b79e931bd$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $0ca4f63b79e931bd$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $cdfbe47f64dd4269$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $0ca4f63b79e931bd$var$getShadowHost(n) {
    let shadowHost = null;
    if ($0ca4f63b79e931bd$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $0ca4f63b79e931bd$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $0ca4f63b79e931bd$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $0ca4f63b79e931bd$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $0ca4f63b79e931bd$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $0ca4f63b79e931bd$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $0ca4f63b79e931bd$var$shadowHostInDom(n);
}
const $0ca4f63b79e931bd$var$cachedImplementations = {};
function $0ca4f63b79e931bd$var$getImplementation(name) {
    const cached = $0ca4f63b79e931bd$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $0ca4f63b79e931bd$var$cachedImplementations[name] = impl.bind(window);
}
function $0ca4f63b79e931bd$var$onRequestAnimationFrame(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation("requestAnimationFrame")(...rest);
}
function $0ca4f63b79e931bd$var$setTimeout$1(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation("setTimeout")(...rest);
}
function $0ca4f63b79e931bd$var$clearTimeout$1(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation("clearTimeout")(...rest);
}
var $0ca4f63b79e931bd$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($0ca4f63b79e931bd$var$EventType || {});
var $0ca4f63b79e931bd$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($0ca4f63b79e931bd$var$IncrementalSource || {});
var $0ca4f63b79e931bd$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($0ca4f63b79e931bd$var$MouseInteractions || {});
var $0ca4f63b79e931bd$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($0ca4f63b79e931bd$var$PointerTypes || {});
function $0ca4f63b79e931bd$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $0ca4f63b79e931bd$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $0ca4f63b79e931bd$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $0ca4f63b79e931bd$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $0ca4f63b79e931bd$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $0ca4f63b79e931bd$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $0ca4f63b79e931bd$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $0ca4f63b79e931bd$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $0ca4f63b79e931bd$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $0ca4f63b79e931bd$var$IGNORED_NODE;
                while(nextId === $0ca4f63b79e931bd$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$0ca4f63b79e931bd$var$inDom(n)) return;
                const parentId = $0ca4f63b79e931bd$var$isShadowRoot(n.parentNode) ? this.mirror.getId($0ca4f63b79e931bd$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $0ca4f63b79e931bd$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($0ca4f63b79e931bd$var$isSerializedIframe(currentN, this.mirror) && !$0ca4f63b79e931bd$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($0ca4f63b79e931bd$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($0ca4f63b79e931bd$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($0ca4f63b79e931bd$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) this.canvasManager.addWindow(iframe.contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($0ca4f63b79e931bd$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$0ca4f63b79e931bd$var$isAncestorInSet(this.droppedSet, n) && !$0ca4f63b79e931bd$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($0ca4f63b79e931bd$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($0ca4f63b79e931bd$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $0ca4f63b79e931bd$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $0ca4f63b79e931bd$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $0ca4f63b79e931bd$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $0ca4f63b79e931bd$var$getInputValue(target, tagName, type);
                            const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $0ca4f63b79e931bd$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $0ca4f63b79e931bd$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$0ca4f63b79e931bd$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $0ca4f63b79e931bd$var$transformAttribute(this.doc, $0ca4f63b79e931bd$var$toLowerCase(target.tagName), $0ca4f63b79e931bd$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $0ca4f63b79e931bd$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $0ca4f63b79e931bd$var$isIgnored(n, this.mirror) || !$0ca4f63b79e931bd$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $0ca4f63b79e931bd$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($0ca4f63b79e931bd$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$0ca4f63b79e931bd$var$moveKey(nodeId, parentId)]) $0ca4f63b79e931bd$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $0ca4f63b79e931bd$var$isShadowRoot(m.target) && $0ca4f63b79e931bd$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($0ca4f63b79e931bd$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$0ca4f63b79e931bd$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$0ca4f63b79e931bd$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($0ca4f63b79e931bd$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $0ca4f63b79e931bd$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$0ca4f63b79e931bd$var$deepDelete(addsSet, childN));
}
function $0ca4f63b79e931bd$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $0ca4f63b79e931bd$var$_isParentRemoved(removes, n, mirror);
}
function $0ca4f63b79e931bd$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $0ca4f63b79e931bd$var$_isParentRemoved(removes, parentNode, mirror);
}
function $0ca4f63b79e931bd$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $0ca4f63b79e931bd$var$_isAncestorInSet(set, n);
}
function $0ca4f63b79e931bd$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $0ca4f63b79e931bd$var$_isAncestorInSet(set, parentNode);
}
let $0ca4f63b79e931bd$var$errorHandler;
function $0ca4f63b79e931bd$var$registerErrorHandler(handler) {
    $0ca4f63b79e931bd$var$errorHandler = handler;
}
function $0ca4f63b79e931bd$var$unregisterErrorHandler() {
    $0ca4f63b79e931bd$var$errorHandler = undefined;
}
const $0ca4f63b79e931bd$var$callbackWrapper = (cb)=>{
    if (!$0ca4f63b79e931bd$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($0ca4f63b79e931bd$var$errorHandler && $0ca4f63b79e931bd$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $0ca4f63b79e931bd$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $0ca4f63b79e931bd$var$mutationBuffers = [];
function $0ca4f63b79e931bd$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $0ca4f63b79e931bd$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $0ca4f63b79e931bd$var$MutationBuffer();
    $0ca4f63b79e931bd$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $0ca4f63b79e931bd$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($0ca4f63b79e931bd$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $0ca4f63b79e931bd$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((evt)=>{
        const target = $0ca4f63b79e931bd$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $0ca4f63b79e931bd$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $0ca4f63b79e931bd$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $0ca4f63b79e931bd$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $0ca4f63b79e931bd$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $0ca4f63b79e931bd$var$IncrementalSource.MouseMove : $0ca4f63b79e931bd$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $0ca4f63b79e931bd$var$on("mousemove", updatePosition, doc),
        $0ca4f63b79e931bd$var$on("touchmove", updatePosition, doc),
        $0ca4f63b79e931bd$var$on("drag", updatePosition, doc)
    ];
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $0ca4f63b79e931bd$var$getEventTarget(event);
            if ($0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $0ca4f63b79e931bd$var$PointerTypes.Touch) {
                    if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $0ca4f63b79e931bd$var$PointerTypes.Pen;
            } else if ($0ca4f63b79e931bd$var$legacy_isTouchEvent(event)) pointerType = $0ca4f63b79e931bd$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $0ca4f63b79e931bd$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $0ca4f63b79e931bd$var$PointerTypes.Mouse) pointerType = null;
            } else if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $0ca4f63b79e931bd$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $0ca4f63b79e931bd$var$callbackWrapper(mouseInteractionCb)({
                type: $0ca4f63b79e931bd$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($0ca4f63b79e931bd$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $0ca4f63b79e931bd$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($0ca4f63b79e931bd$var$MouseInteractions[eventKey]){
            case $0ca4f63b79e931bd$var$MouseInteractions.MouseDown:
            case $0ca4f63b79e931bd$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $0ca4f63b79e931bd$var$MouseInteractions.TouchStart:
            case $0ca4f63b79e931bd$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($0ca4f63b79e931bd$var$on(eventName, handler, doc));
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((evt)=>{
        const target = $0ca4f63b79e931bd$var$getEventTarget(evt);
        if (!target || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $0ca4f63b79e931bd$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $0ca4f63b79e931bd$var$on("scroll", updatePosition, doc);
}
function $0ca4f63b79e931bd$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper(()=>{
        const height = $0ca4f63b79e931bd$var$getWindowHeight();
        const width = $0ca4f63b79e931bd$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $0ca4f63b79e931bd$var$on("resize", updateDimension, win);
}
const $0ca4f63b79e931bd$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $0ca4f63b79e931bd$var$lastInputValueMap = new WeakMap();
function $0ca4f63b79e931bd$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $0ca4f63b79e931bd$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $0ca4f63b79e931bd$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $0ca4f63b79e931bd$var$INPUT_TAGS.indexOf(tagName) < 0 || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $0ca4f63b79e931bd$var$getInputType(target);
        let text = $0ca4f63b79e931bd$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $0ca4f63b79e931bd$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $0ca4f63b79e931bd$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $0ca4f63b79e931bd$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $0ca4f63b79e931bd$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $0ca4f63b79e931bd$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $0ca4f63b79e931bd$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $0ca4f63b79e931bd$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$0ca4f63b79e931bd$var$on(eventName, $0ca4f63b79e931bd$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$0ca4f63b79e931bd$var$hookSetter(p[0], p[1], {
            set () {
                $0ca4f63b79e931bd$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($0ca4f63b79e931bd$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $0ca4f63b79e931bd$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $0ca4f63b79e931bd$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $0ca4f63b79e931bd$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $0ca4f63b79e931bd$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $0ca4f63b79e931bd$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $0ca4f63b79e931bd$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $0ca4f63b79e931bd$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $0ca4f63b79e931bd$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($0ca4f63b79e931bd$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $0ca4f63b79e931bd$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $0ca4f63b79e931bd$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $0ca4f63b79e931bd$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId($0ca4f63b79e931bd$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId($0ca4f63b79e931bd$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $0ca4f63b79e931bd$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $0ca4f63b79e931bd$var$callbackWrapper((type)=>$0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((event)=>{
            const target = $0ca4f63b79e931bd$var$getEventTarget(event);
            if (!target || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $0ca4f63b79e931bd$var$on("play", handler(0), doc),
        $0ca4f63b79e931bd$var$on("pause", handler(1), doc),
        $0ca4f63b79e931bd$var$on("seeked", handler(2), doc),
        $0ca4f63b79e931bd$var$on("volumechange", handler(3), doc),
        $0ca4f63b79e931bd$var$on("ratechange", handler(4), doc)
    ];
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $0ca4f63b79e931bd$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $0ca4f63b79e931bd$var$setTimeout$1($0ca4f63b79e931bd$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $0ca4f63b79e931bd$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $0ca4f63b79e931bd$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $0ca4f63b79e931bd$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $0ca4f63b79e931bd$var$on("selectionchange", updateSelection);
}
function $0ca4f63b79e931bd$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $0ca4f63b79e931bd$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $0ca4f63b79e931bd$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o.recordDOM) mutationObserver = $0ca4f63b79e931bd$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $0ca4f63b79e931bd$var$initMoveObserver(o);
    const mouseInteractionHandler = $0ca4f63b79e931bd$var$initMouseInteractionObserver(o);
    const scrollHandler = $0ca4f63b79e931bd$var$initScrollObserver(o);
    const viewportResizeHandler = $0ca4f63b79e931bd$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $0ca4f63b79e931bd$var$initInputObserver(o);
    const mediaInteractionHandler = $0ca4f63b79e931bd$var$initMediaInteractionObserver(o);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o.recordDOM) {
        styleSheetObserver = $0ca4f63b79e931bd$var$initStyleSheetObserver(o, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver(o, o.doc);
        styleDeclarationObserver = $0ca4f63b79e931bd$var$initStyleDeclarationObserver(o, {
            win: currentWindow
        });
        if (o.collectFonts) fontObserver = $0ca4f63b79e931bd$var$initFontObserver(o);
    }
    const selectionObserver = $0ca4f63b79e931bd$var$initSelectionObserver(o);
    const customElementObserver = $0ca4f63b79e931bd$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((b)=>b.reset());
        $0ca4f63b79e931bd$var$_optionalChain$2([
            mutationObserver,
            "optionalAccess",
            (_22)=>_22.disconnect,
            "call",
            (_23)=>_23()
        ]);
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $0ca4f63b79e931bd$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $0ca4f63b79e931bd$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $0ca4f63b79e931bd$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror($0ca4f63b79e931bd$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $0ca4f63b79e931bd$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror($0ca4f63b79e931bd$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $0ca4f63b79e931bd$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $0ca4f63b79e931bd$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $0ca4f63b79e931bd$var$EventType.Meta:
            case $0ca4f63b79e931bd$var$EventType.Load:
            case $0ca4f63b79e931bd$var$EventType.DomContentLoaded:
                return false;
            case $0ca4f63b79e931bd$var$EventType.Plugin:
                return e;
            case $0ca4f63b79e931bd$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $0ca4f63b79e931bd$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Drag:
                    case $0ca4f63b79e931bd$var$IncrementalSource.TouchMove:
                    case $0ca4f63b79e931bd$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.ViewportResize:
                        return false;
                    case $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction:
                    case $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction:
                    case $0ca4f63b79e931bd$var$IncrementalSource.Scroll:
                    case $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation:
                    case $0ca4f63b79e931bd$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule:
                    case $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Font:
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $0ca4f63b79e931bd$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $0ca4f63b79e931bd$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $0ca4f63b79e931bd$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $0ca4f63b79e931bd$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $0ca4f63b79e931bd$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($0ca4f63b79e931bd$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $0ca4f63b79e931bd$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($0ca4f63b79e931bd$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $0ca4f63b79e931bd$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
class $0ca4f63b79e931bd$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
class $0ca4f63b79e931bd$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $0ca4f63b79e931bd$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $0ca4f63b79e931bd$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $0ca4f63b79e931bd$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $0ca4f63b79e931bd$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $0ca4f63b79e931bd$var$wrappedEmit;
let $0ca4f63b79e931bd$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            cleanFrame,
            "access",
            (_)=>_.contentWindow,
            "optionalAccess",
            (_2)=>_2.Array,
            "access",
            (_3)=>_3.from
        ]) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $0ca4f63b79e931bd$var$mirror = $0ca4f63b79e931bd$var$createMirror();
function $0ca4f63b79e931bd$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $0ca4f63b79e931bd$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $0ca4f63b79e931bd$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $0ca4f63b79e931bd$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $0ca4f63b79e931bd$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $0ca4f63b79e931bd$var$nowTimestamp();
        if ((0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            $0ca4f63b79e931bd$var$mutationBuffers,
            "access",
            (_4)=>_4[0],
            "optionalAccess",
            (_5)=>_5.isFrozen,
            "call",
            (_6)=>_6()
        ]) && e.type !== $0ca4f63b79e931bd$var$EventType.FullSnapshot && !(e.type === $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot && e.data.source === $0ca4f63b79e931bd$var$IncrementalSource.Mutation)) $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_7)=>_7(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $0ca4f63b79e931bd$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $0ca4f63b79e931bd$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $0ca4f63b79e931bd$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $0ca4f63b79e931bd$var$IframeManagerNoop() : new $0ca4f63b79e931bd$var$IframeManager({
        mirror: $0ca4f63b79e931bd$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $0ca4f63b79e931bd$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $0ca4f63b79e931bd$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $0ca4f63b79e931bd$var$ProcessedNodeManager();
    const canvasManager = $0ca4f63b79e931bd$var$_getCanvasManager(getCanvasManager, {
        mirror: $0ca4f63b79e931bd$var$mirror,
        win: window,
        mutationCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                data: {
                    source: $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $0ca4f63b79e931bd$var$ShadowDomManagerNoop() : new $0ca4f63b79e931bd$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $0ca4f63b79e931bd$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        if (!recordDOM) return;
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $0ca4f63b79e931bd$var$getWindowWidth(),
                height: $0ca4f63b79e931bd$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $0ca4f63b79e931bd$var$snapshot(document, {
            mirror: $0ca4f63b79e931bd$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($0ca4f63b79e931bd$var$isSerializedIframe(n, $0ca4f63b79e931bd$var$mirror)) iframeManager.addIframe(n);
                if ($0ca4f63b79e931bd$var$isSerializedStylesheet(n, $0ca4f63b79e931bd$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($0ca4f63b79e931bd$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $0ca4f63b79e931bd$var$getWindowScroll(window)
            }
        });
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $0ca4f63b79e931bd$var$mirror.getId(document));
    };
    $0ca4f63b79e931bd$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $0ca4f63b79e931bd$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $c2017e0e66bad871$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_8)=>_8.filter,
                    "call",
                    (_9)=>_9((p)=>p.observer),
                    "optionalAccess",
                    (_10)=>_10.map,
                    "call",
                    (_11)=>_11((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$0ca4f63b79e931bd$var$wrappedEmit({
                                        type: $0ca4f63b79e931bd$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($0ca4f63b79e931bd$var$on("DOMContentLoaded", ()=>{
                $0ca4f63b79e931bd$var$wrappedEmit({
                    type: $0ca4f63b79e931bd$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($0ca4f63b79e931bd$var$on("load", ()=>{
                $0ca4f63b79e931bd$var$wrappedEmit({
                    type: $0ca4f63b79e931bd$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $0ca4f63b79e931bd$var$_takeFullSnapshot = undefined;
            $0ca4f63b79e931bd$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $0ca4f63b79e931bd$var$takeFullSnapshot(isCheckout) {
    if (!$0ca4f63b79e931bd$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $0ca4f63b79e931bd$var$_takeFullSnapshot(isCheckout);
}
$0ca4f63b79e931bd$var$record.mirror = $0ca4f63b79e931bd$var$mirror;
$0ca4f63b79e931bd$var$record.takeFullSnapshot = $0ca4f63b79e931bd$var$takeFullSnapshot;
function $0ca4f63b79e931bd$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $0ca4f63b79e931bd$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $0ca4f63b79e931bd$var$CanvasManagerNoop();
    }
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0ca4f63b79e931bd$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $0ca4f63b79e931bd$var$CONSOLE_LEVELS = [
    "info",
    "warn",
    "error",
    "log"
];
const $0ca4f63b79e931bd$var$PREFIX = "[Replay] ";
function $0ca4f63b79e931bd$var$_addBreadcrumb(message, level = "info") {
    (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: level,
        message: `${$0ca4f63b79e931bd$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $0ca4f63b79e931bd$var$makeReplayLogger() {
    let _capture = false;
    let _trace = false;
    const _logger = {
        exception: ()=>undefined,
        infoTick: ()=>undefined,
        setConfig: (opts)=>{
            _capture = opts.captureExceptions;
            _trace = opts.traceInternals;
        }
    };
    if ($0ca4f63b79e931bd$var$DEBUG_BUILD) {
        $0ca4f63b79e931bd$var$CONSOLE_LEVELS.forEach((name)=>{
            _logger[name] = (...args)=>{
                (0, $eddf779ebbe9b538$export$af88d00dbe7f521)[name]($0ca4f63b79e931bd$var$PREFIX, ...args);
                if (_trace) $0ca4f63b79e931bd$var$_addBreadcrumb(args.join(""), (0, $575cb5410d2010d0$export$d771ef054122c30a)(name));
            };
        });
        _logger.exception = (error, ...message)=>{
            if (message.length && _logger.error) _logger.error(...message);
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).error($0ca4f63b79e931bd$var$PREFIX, error);
            if (_capture) (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error);
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            $0ca4f63b79e931bd$var$_addBreadcrumb(error, "error");
        };
        _logger.infoTick = (...args)=>{
            (0, $eddf779ebbe9b538$export$af88d00dbe7f521).info($0ca4f63b79e931bd$var$PREFIX, ...args);
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(()=>$0ca4f63b79e931bd$var$_addBreadcrumb(args[0]), 0);
        };
    } else $0ca4f63b79e931bd$var$CONSOLE_LEVELS.forEach((name)=>{
        _logger[name] = ()=>undefined;
    });
    return _logger;
}
const $0ca4f63b79e931bd$var$logger = $0ca4f63b79e931bd$var$makeReplayLogger();
const $0ca4f63b79e931bd$var$ReplayEventTypeIncrementalSnapshot = 3;
const $0ca4f63b79e931bd$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $0ca4f63b79e931bd$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $0ca4f63b79e931bd$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $95721a1f8e4d79f8$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $0ca4f63b79e931bd$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $0ca4f63b79e931bd$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($0ca4f63b79e931bd$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $0ca4f63b79e931bd$var$getClickTargetNode(event) {
    const target = $0ca4f63b79e931bd$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $0ca4f63b79e931bd$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $0ca4f63b79e931bd$var$getTargetNode(event) {
    if ($0ca4f63b79e931bd$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $0ca4f63b79e931bd$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $0ca4f63b79e931bd$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $0ca4f63b79e931bd$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$0ca4f63b79e931bd$var$handlers) {
        $0ca4f63b79e931bd$var$handlers = [];
        $0ca4f63b79e931bd$var$monkeyPatchWindowOpen();
    }
    $0ca4f63b79e931bd$var$handlers.push(cb);
    return ()=>{
        const pos = $0ca4f63b79e931bd$var$handlers ? $0ca4f63b79e931bd$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $0ca4f63b79e931bd$var$handlers.splice(pos, 1);
    };
}
function $0ca4f63b79e931bd$var$monkeyPatchWindowOpen() {
    (0, $7c0b78736d11cf4a$export$9563e054e6f787fb)($0ca4f63b79e931bd$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($0ca4f63b79e931bd$var$handlers) try {
                $0ca4f63b79e931bd$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($0ca4f63b79e931bd$var$WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ const $0ca4f63b79e931bd$var$IncrementalMutationSources = new Set([
    $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
    $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule,
    $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration,
    $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet,
    $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
    $0ca4f63b79e931bd$var$IncrementalSource.Selection,
    $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function $0ca4f63b79e931bd$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $0ca4f63b79e931bd$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $0ca4f63b79e931bd$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $0ca4f63b79e931bd$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $0ca4f63b79e931bd$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($0ca4f63b79e931bd$var$ignoreElement(node, this._ignoreSelector) || !$0ca4f63b79e931bd$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $0ca4f63b79e931bd$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $0ca4f63b79e931bd$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $0ca4f63b79e931bd$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $0ca4f63b79e931bd$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $0ca4f63b79e931bd$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $0ca4f63b79e931bd$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $0ca4f63b79e931bd$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1000);
    }
}
const $0ca4f63b79e931bd$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $0ca4f63b79e931bd$var$ignoreElement(node, ignoreSelector) {
    if (!$0ca4f63b79e931bd$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $0ca4f63b79e931bd$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $0ca4f63b79e931bd$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $0ca4f63b79e931bd$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$0ca4f63b79e931bd$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($0ca4f63b79e931bd$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $0ca4f63b79e931bd$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($0ca4f63b79e931bd$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $0ca4f63b79e931bd$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $0ca4f63b79e931bd$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $0ca4f63b79e931bd$var$isIncrementalEvent(event) {
    return event.type === $0ca4f63b79e931bd$var$ReplayEventTypeIncrementalSnapshot;
}
function $0ca4f63b79e931bd$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $0ca4f63b79e931bd$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($0ca4f63b79e931bd$var$NodeType || ($0ca4f63b79e931bd$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $0ca4f63b79e931bd$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $0ca4f63b79e931bd$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) attributes["data-sentry-component"] = attributes["data-sentry-element"];
    for(const key in attributes)if ($0ca4f63b79e931bd$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $0ca4f63b79e931bd$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0ca4f63b79e931bd$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $0ca4f63b79e931bd$var$handleClick(replay.clickDetector, result, $0ca4f63b79e931bd$var$getClickTargetNode(handlerData.event));
        $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $0ca4f63b79e931bd$var$record.mirror.getId(target);
    const node = nodeId && $0ca4f63b79e931bd$var$record.mirror.getNode(nodeId);
    const meta = node && $0ca4f63b79e931bd$var$record.mirror.getMeta(node);
    const element = meta && $0ca4f63b79e931bd$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $0ca4f63b79e931bd$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $0ca4f63b79e931bd$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $0ca4f63b79e931bd$var$handleDom(handlerData) {
    const { target: target, message: message } = $0ca4f63b79e931bd$var$getDomTarget(handlerData);
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message)
    });
}
function $0ca4f63b79e931bd$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $0ca4f63b79e931bd$var$getClickTargetNode(handlerData.event) : $0ca4f63b79e931bd$var$getTargetNode(handlerData.event);
        message = (0, $b1794bb8b282584f$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $0ca4f63b79e931bd$var$isElement(node) {
    return node.type === $0ca4f63b79e931bd$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $0ca4f63b79e931bd$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $0ca4f63b79e931bd$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $0ca4f63b79e931bd$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $0ca4f63b79e931bd$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $b1794bb8b282584f$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message);
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $0ca4f63b79e931bd$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $0ca4f63b79e931bd$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $0ca4f63b79e931bd$var$createResourceEntry,
    paint: $0ca4f63b79e931bd$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $0ca4f63b79e931bd$var$createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function $0ca4f63b79e931bd$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function $0ca4f63b79e931bd$var$createPerformanceEntries(entries) {
    return entries.map($0ca4f63b79e931bd$var$createPerformanceEntry).filter(Boolean);
}
function $0ca4f63b79e931bd$var$createPerformanceEntry(entry) {
    const entryType = $0ca4f63b79e931bd$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $0ca4f63b79e931bd$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $dce7651ce4194f00$export$baf075a948ffc0bf) || $0ca4f63b79e931bd$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $0ca4f63b79e931bd$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $0ca4f63b79e931bd$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $0ca4f63b79e931bd$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $0ca4f63b79e931bd$var$getAbsoluteTime(startTime),
        end: $0ca4f63b79e931bd$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $0ca4f63b79e931bd$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $0ca4f63b79e931bd$var$getAbsoluteTime(startTime),
        end: $0ca4f63b79e931bd$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function $0ca4f63b79e931bd$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.element ? [
        lastEntry.element
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, "largest-contentful-paint", node);
}
function $0ca4f63b79e931bd$var$isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function $0ca4f63b79e931bd$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($0ca4f63b79e931bd$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $0ca4f63b79e931bd$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : undefined
        });
    }
    return $0ca4f63b79e931bd$var$getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
/**
 * Add a FID event to the replay based on a FID metric.
 */ function $0ca4f63b79e931bd$var$getFirstInputDelay(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, "first-input-delay", node);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function $0ca4f63b79e931bd$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry && lastEntry.target ? [
        lastEntry.target
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, "interaction-to-next-paint", node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function $0ca4f63b79e931bd$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $0ca4f63b79e931bd$var$getAbsoluteTime(value);
    return {
        type: "web-vital",
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$0ca4f63b79e931bd$var$record.mirror.getId(node)) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $0ca4f63b79e931bd$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $31f3d198369e5cbf$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $31f3d198369e5cbf$export$3fd4b53331200102)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getLargestContentfulPaint, replay)), (0, $31f3d198369e5cbf$export$861b82818b37ba5b)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getCumulativeLayoutShift, replay)), (0, $31f3d198369e5cbf$export$2707d7471c0b918f)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getFirstInputDelay, replay)), (0, $31f3d198369e5cbf$export$da3b76aa2022cbd7)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
const $0ca4f63b79e931bd$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(J)return J.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $0ca4f63b79e931bd$var$e() {
    const e = new Blob([
        $0ca4f63b79e931bd$var$r
    ]);
    return URL.createObjectURL(e);
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $0ca4f63b79e931bd$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $0ca4f63b79e931bd$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $0ca4f63b79e931bd$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $0ca4f63b79e931bd$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error("Error in compression worker: ", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $0ca4f63b79e931bd$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $0ca4f63b79e931bd$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $0ca4f63b79e931bd$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $0ca4f63b79e931bd$var$EventBufferArray();
        this._compression = new $0ca4f63b79e931bd$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to add events when switching buffers.");
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $0ca4f63b79e931bd$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $0ca4f63b79e931bd$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Using simple buffer");
    return new $0ca4f63b79e931bd$var$EventBufferArray();
}
function $0ca4f63b79e931bd$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $0ca4f63b79e931bd$var$_getWorkerUrl();
        if (!workerUrl) return;
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $0ca4f63b79e931bd$var$EventBufferProxy(worker);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $0ca4f63b79e931bd$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $0ca4f63b79e931bd$var$e();
    return "";
}
/** If sessionStorage is available. */ function $0ca4f63b79e931bd$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $0ca4f63b79e931bd$var$WINDOW && !!$0ca4f63b79e931bd$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $0ca4f63b79e931bd$var$clearSession(replay) {
    $0ca4f63b79e931bd$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $0ca4f63b79e931bd$var$deleteSession() {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return;
    try {
        $0ca4f63b79e931bd$var$WINDOW.sessionStorage.removeItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $0ca4f63b79e931bd$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $0ca4f63b79e931bd$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $f61010b781c81ec1$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $0ca4f63b79e931bd$var$saveSession(session) {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return;
    try {
        $0ca4f63b79e931bd$var$WINDOW.sessionStorage.setItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $0ca4f63b79e931bd$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $0ca4f63b79e931bd$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $0ca4f63b79e931bd$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $0ca4f63b79e931bd$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $0ca4f63b79e931bd$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $0ca4f63b79e931bd$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $0ca4f63b79e931bd$var$fetchSession() {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $0ca4f63b79e931bd$var$WINDOW.sessionStorage.getItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick("Loading existing session");
        return $0ca4f63b79e931bd$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $0ca4f63b79e931bd$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $0ca4f63b79e931bd$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $0ca4f63b79e931bd$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $0ca4f63b79e931bd$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $0ca4f63b79e931bd$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$0ca4f63b79e931bd$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $0ca4f63b79e931bd$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $0ca4f63b79e931bd$var$fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick("Creating new session");
        return $0ca4f63b79e931bd$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$0ca4f63b79e931bd$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick("Session in sessionStorage is expired, creating new one...");
    return $0ca4f63b79e931bd$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $0ca4f63b79e931bd$var$isCustomEvent(event) {
    return event.type === $0ca4f63b79e931bd$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $0ca4f63b79e931bd$var$addEventSync(replay, event, isCheckout) {
    if (!$0ca4f63b79e931bd$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $0ca4f63b79e931bd$var$addEvent(replay, event, isCheckout) {
    if (!$0ca4f63b79e931bd$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout);
}
async function $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $0ca4f63b79e931bd$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $0ca4f63b79e931bd$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $0ca4f63b79e931bd$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $0ca4f63b79e931bd$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $0ca4f63b79e931bd$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $0ca4f63b79e931bd$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "An error occured in the `beforeAddRecordingEvent` callback, skipping the event...");
        return null;
    }
    return event;
}
/** If the event is an error event */ function $0ca4f63b79e931bd$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $0ca4f63b79e931bd$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $0ca4f63b79e931bd$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $0ca4f63b79e931bd$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $0ca4f63b79e931bd$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isErrorEvent(event) && !$0ca4f63b79e931bd$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($0ca4f63b79e931bd$var$isTransactionEvent(event)) {
            $0ca4f63b79e931bd$var$handleTransactionEvent(replay, event);
            return;
        }
        $0ca4f63b79e931bd$var$handleErrorEvent(replay, event);
    };
}
function $0ca4f63b79e931bd$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $0ca4f63b79e931bd$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $0ca4f63b79e931bd$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isErrorEvent(event)) return;
        $0ca4f63b79e931bd$var$handleHydrationError(replay, event);
    };
}
function $0ca4f63b79e931bd$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
            category: "replay.hydrate-error",
            data: {
                url: (0, $b1794bb8b282584f$export$1cfafeee2987818b)()
            }
        });
        $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $0ca4f63b79e931bd$var$handleBreadcrumbs(replay) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$0ca4f63b79e931bd$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $0ca4f63b79e931bd$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $0ca4f63b79e931bd$var$normalizeBreadcrumb(breadcrumb);
    if (result) $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $0ca4f63b79e931bd$var$normalizeBreadcrumb(breadcrumb) {
    if (!$0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $0ca4f63b79e931bd$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $0ca4f63b79e931bd$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $95721a1f8e4d79f8$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $0ca4f63b79e931bd$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $0ca4f63b79e931bd$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $0ca4f63b79e931bd$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $0ca4f63b79e931bd$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $0ca4f63b79e931bd$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($0ca4f63b79e931bd$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$0ca4f63b79e931bd$var$isErrorEvent(event) && !$0ca4f63b79e931bd$var$isTransactionEvent(event) && !$0ca4f63b79e931bd$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($0ca4f63b79e931bd$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $0ca4f63b79e931bd$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($0ca4f63b79e931bd$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.log("Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $0ca4f63b79e931bd$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $0ca4f63b79e931bd$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $0ca4f63b79e931bd$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $0ca4f63b79e931bd$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0ca4f63b79e931bd$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $0ca4f63b79e931bd$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($0ca4f63b79e931bd$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $e523a4dfa96cd99a$export$d92e61f5600202af)(url, (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $0ca4f63b79e931bd$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($0ca4f63b79e931bd$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $0ca4f63b79e931bd$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $0ca4f63b79e931bd$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $0ca4f63b79e931bd$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $0ca4f63b79e931bd$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $0ca4f63b79e931bd$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $0ca4f63b79e931bd$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $7c0b78736d11cf4a$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $0ca4f63b79e931bd$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $0ca4f63b79e931bd$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $0ca4f63b79e931bd$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $0ca4f63b79e931bd$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $0ca4f63b79e931bd$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e2) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $0ca4f63b79e931bd$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $0ca4f63b79e931bd$var$urlMatches(url, urls) {
    const fullUrl = $0ca4f63b79e931bd$var$getFullUrl(url);
    return (0, $ef17463c720dc68b$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $0ca4f63b79e931bd$var$getFullUrl(url, baseURI = $0ca4f63b79e931bd$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($0ca4f63b79e931bd$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $0ca4f63b79e931bd$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $0ca4f63b79e931bd$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $0ca4f63b79e931bd$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to capture fetch breadcrumb");
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $0ca4f63b79e931bd$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? $0ca4f63b79e931bd$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $0ca4f63b79e931bd$var$getBodySize(body);
    const resSize = response ? $0ca4f63b79e931bd$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $0ca4f63b79e931bd$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailAllowUrls) && !$0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $0ca4f63b79e931bd$var$_getRequestInfo(options, hint.input, requestBodySize) : $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $0ca4f63b79e931bd$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $0ca4f63b79e931bd$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $0ca4f63b79e931bd$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $0ca4f63b79e931bd$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $0ca4f63b79e931bd$var$getBodyString(requestBody);
    const data = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $0ca4f63b79e931bd$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $0ca4f63b79e931bd$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $0ca4f63b79e931bd$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $0ca4f63b79e931bd$var$_parseFetchResponseBody(response);
    const result = $0ca4f63b79e931bd$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $0ca4f63b79e931bd$var$mergeWarning(result, warning);
    return result;
}
function $0ca4f63b79e931bd$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $0ca4f63b79e931bd$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to serialize response body");
        // fallback
        return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $0ca4f63b79e931bd$var$_parseFetchResponseBody(response) {
    const res = $0ca4f63b79e931bd$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $0ca4f63b79e931bd$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to get text body from response");
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $0ca4f63b79e931bd$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $0ca4f63b79e931bd$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $0ca4f63b79e931bd$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $0ca4f63b79e931bd$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $0ca4f63b79e931bd$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $0ca4f63b79e931bd$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $0ca4f63b79e931bd$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $0ca4f63b79e931bd$var$getAllowedHeaders(headers, allowedHeaders);
}
function $0ca4f63b79e931bd$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to clone response body");
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $0ca4f63b79e931bd$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $0ca4f63b79e931bd$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $0ca4f63b79e931bd$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $0ca4f63b79e931bd$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $0ca4f63b79e931bd$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $0ca4f63b79e931bd$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to capture xhr breadcrumb");
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $0ca4f63b79e931bd$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $0ca4f63b79e931bd$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $0ca4f63b79e931bd$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $0ca4f63b79e931bd$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $0ca4f63b79e931bd$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailAllowUrls) || $0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $0ca4f63b79e931bd$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $0ca4f63b79e931bd$var$getAllowedHeaders($0ca4f63b79e931bd$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $0ca4f63b79e931bd$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $0ca4f63b79e931bd$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $0ca4f63b79e931bd$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $0ca4f63b79e931bd$var$mergeWarning(response, responseWarning) : response
    };
}
function $0ca4f63b79e931bd$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $0ca4f63b79e931bd$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $0ca4f63b79e931bd$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn("Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $0ca4f63b79e931bd$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, "Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $0ca4f63b79e931bd$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $0ca4f63b79e931bd$var$getBodySize(bodyStr);
    } catch (e2) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $0ca4f63b79e931bd$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$0ca4f63b79e931bd$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $0ca4f63b79e931bd$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($0ca4f63b79e931bd$var$_isXhrBreadcrumb(breadcrumb) && $0ca4f63b79e931bd$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $0ca4f63b79e931bd$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $0ca4f63b79e931bd$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($0ca4f63b79e931bd$var$_isFetchBreadcrumb(breadcrumb) && $0ca4f63b79e931bd$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $0ca4f63b79e931bd$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $0ca4f63b79e931bd$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(e, "Error when enriching network breadcrumb");
    }
}
function $0ca4f63b79e931bd$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $0ca4f63b79e931bd$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $0ca4f63b79e931bd$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $0ca4f63b79e931bd$var$_isFetchHint(hint) {
    return hint && hint.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $0ca4f63b79e931bd$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($0ca4f63b79e931bd$var$handleDomListener(replay));
    (0, $3d87653da885c31c$export$3f18c56c58114e75)($0ca4f63b79e931bd$var$handleHistorySpanListener(replay));
    $0ca4f63b79e931bd$var$handleBreadcrumbs(replay);
    $0ca4f63b79e931bd$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $0ca4f63b79e931bd$var$handleGlobalEventListener(replay);
    (0, $f2b90654edf2c0a1$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on("beforeSendEvent", $0ca4f63b79e931bd$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $0ca4f63b79e931bd$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $0ca4f63b79e931bd$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $0ca4f63b79e931bd$var$createMemoryEntry($0ca4f63b79e931bd$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $0ca4f63b79e931bd$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $0ca4f63b79e931bd$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $0ca4f63b79e931bd$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn("Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $0ca4f63b79e931bd$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$0ca4f63b79e931bd$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            const session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $0ca4f63b79e931bd$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session && session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $0ca4f63b79e931bd$var$saveSession(session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $0ca4f63b79e931bd$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $0ca4f63b79e931bd$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $0ca4f63b79e931bd$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $0ca4f63b79e931bd$var$addEventSync(replay, $0ca4f63b79e931bd$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $0ca4f63b79e931bd$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $19ddf33da467375a$export$f93f7f385160c44e)((0, $19ddf33da467375a$export$92b6093782fe661b)(replayEvent, (0, $19ddf33da467375a$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $0ca4f63b79e931bd$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $0ca4f63b79e931bd$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $baba650ac852ba0c$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $f106fce27ec076f7$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $0ca4f63b79e931bd$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $0ca4f63b79e931bd$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
    const baseEvent = {
        type: $0ca4f63b79e931bd$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $0ca4f63b79e931bd$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("An event processor returned `null`, will not send event.");
        return (0, $3b138310ed7801df$export$1fda8aa4d135f8aa)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $0ca4f63b79e931bd$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $0ca4f63b79e931bd$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $bde3819d7b9aaee7$export$699aff705e0d49d4)({}, response);
    if ((0, $bde3819d7b9aaee7$export$6c91fec22056810a)(rateLimits, "replay")) throw new $0ca4f63b79e931bd$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $0ca4f63b79e931bd$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $0ca4f63b79e931bd$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $0ca4f63b79e931bd$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $0ca4f63b79e931bd$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $0ca4f63b79e931bd$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $0ca4f63b79e931bd$var$TransportStatusCodeError || err instanceof $0ca4f63b79e931bd$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $0ca4f63b79e931bd$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $d09fa7e5070984b9$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $0ca4f63b79e931bd$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $0ca4f63b79e931bd$var$THROTTLED = "__THROTTLED";
const $0ca4f63b79e931bd$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ca4f63b79e931bd$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $0ca4f63b79e931bd$var$SKIPPED : $0ca4f63b79e931bd$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $0ca4f63b79e931bd$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init2.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init3.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init4.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init5.call(this);
        $0ca4f63b79e931bd$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $0ca4f63b79e931bd$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $0ca4f63b79e931bd$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $0ca4f63b79e931bd$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $0ca4f63b79e931bd$var$throttle((event, isCheckout)=>$0ca4f63b79e931bd$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($0ca4f63b79e931bd$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $0ca4f63b79e931bd$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $0ca4f63b79e931bd$var$ClickDetector(this, slowClickConfig);
        // Configure replay logger w/ experimental options
        if ($0ca4f63b79e931bd$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $0ca4f63b79e931bd$var$logger.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Recording is already in progress");
            return;
        }
        if (this._isEnabled && this.recordingMode === "buffer") {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick("Starting replay in session mode");
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Buffering is in progress, call `flush()` to save the replay");
            return;
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick("Starting replay in buffer mode");
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $0ca4f63b79e931bd$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" ? {
                    checkoutEveryNms: $0ca4f63b79e931bd$var$BUFFER_CHECKOUT_TIME
                } : // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                },
                emit: $0ca4f63b79e931bd$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Stopping Replay${reason ? ` triggered by ${reason}` : ""}`);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $0ca4f63b79e931bd$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Pausing replay");
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Resuming replay");
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Converting buffer to session");
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $0ca4f63b79e931bd$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$0ca4f63b79e931bd$var$WINDOW.location.pathname}${$0ca4f63b79e931bd$var$WINDOW.location.hash}${$0ca4f63b79e931bd$var$WINDOW.location.search}`;
        const url = `${$0ca4f63b79e931bd$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $0ca4f63b79e931bd$var$THROTTLED) {
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$0ca4f63b79e931bd$var$addEventSync(this, {
                    type: $0ca4f63b79e931bd$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $36b15c0d755e29f6$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $36b15c0d755e29f6$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $36b15c0d755e29f6$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $0ca4f63b79e931bd$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($0ca4f63b79e931bd$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $0ca4f63b79e931bd$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $0ca4f63b79e931bd$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $0ca4f63b79e931bd$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $0ca4f63b79e931bd$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($0ca4f63b79e931bd$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $0ca4f63b79e931bd$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $0ca4f63b79e931bd$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $0ca4f63b79e931bd$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $0ca4f63b79e931bd$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($0ca4f63b79e931bd$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        // If replay was started manually (=no sample rate was given),
        // We do not want to back-port the initial timestamp
        if (!session || !eventBuffer || this._requiresManualStart) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error("No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $0ca4f63b79e931bd$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $0ca4f63b79e931bd$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
            if (client) {
                const dropReason = err instanceof $0ca4f63b79e931bd$var$RateLimitError ? "ratelimit_backoff" : "send_error";
                client.recordDroppedEvent(dropReason, "replay");
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error("Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info("Flushing initial segment without checkout.");
            const _flushInProgress = !!this._flushLock;
            // this._flushLock acts as a lock so that future calls to `_flush()` will
            // be blocked until current flush is finished (i.e. this promise resolves)
            if (!this._flushLock) this._flushLock = this._runFlush();
            try {
                await this._flushLock;
            } catch (err) {
                this.handleException(err);
            } finally{
                this._flushLock = undefined;
                if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
                // `_flush()`. It's possible there are other flush requests queued and
                // waiting for it to resolve. We want to reduce all outstanding
                // requests (as well as any new flush requests that occur within a
                // second of the locked flush completing) into a single flush.
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $0ca4f63b79e931bd$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $0ca4f63b79e931bd$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $0ca4f63b79e931bd$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $0ca4f63b79e931bd$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $0ca4f63b79e931bd$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $0ca4f63b79e931bd$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $0ca4f63b79e931bd$var$getOption(unblock, []),
        ignoreSelector: $0ca4f63b79e931bd$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $0ca4f63b79e931bd$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $0ca4f63b79e931bd$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $0ca4f63b79e931bd$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $0ca4f63b79e931bd$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $0ca4f63b79e931bd$export$d7706faf7ab354bf = (options)=>{
    return new $0ca4f63b79e931bd$var$Replay(options);
};
/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */ class $0ca4f63b79e931bd$var$Replay {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling } = {}){
        this.name = $0ca4f63b79e931bd$var$Replay.id;
        const privacyOptions = $0ca4f63b79e931bd$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$0ca4f63b79e931bd$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $0ca4f63b79e931bd$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$0ca4f63b79e931bd$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $0410ba75ede19d70$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $0ca4f63b79e931bd$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $0ca4f63b79e931bd$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $0410ba75ede19d70$export$4e09c449d6c407f7)() || this._replay) return;
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        // assuming a session should be recorded in this case
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $0ca4f63b79e931bd$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $0ca4f63b79e931bd$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$0ca4f63b79e931bd$var$Replay.__initStatic();
/** Parse Replay-related options from SDK options */ function $0ca4f63b79e931bd$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $7c0b78736d11cf4a$export$d25f2688db1bb433)(initialOptions)
    };
    const replaysSessionSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $eddf779ebbe9b538$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$0ca4f63b79e931bd$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $0ca4f63b79e931bd$export$b28310b2f161456b() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName("Replay");
}


parcelRequire("acw62");
function $a51d8ff1bd7ea6db$export$2e2bcd8739ae039() {
    $a51d8ff1bd7ea6db$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a51d8ff1bd7ea6db$export$2e2bcd8739ae039.apply(this, arguments);
}



var $4730acf0753ac89a$export$6acf61af03e62db = typeof window === "undefined";
function $4730acf0753ac89a$export$8793edee2d425525() {
    return undefined;
}
function $4730acf0753ac89a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $4730acf0753ac89a$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $4730acf0753ac89a$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $4730acf0753ac89a$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $4730acf0753ac89a$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $4730acf0753ac89a$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $4730acf0753ac89a$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg2, {
        queryKey: arg1
    });
}
function $4730acf0753ac89a$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === "function") return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg1);
}
function $4730acf0753ac89a$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? [
        (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $4730acf0753ac89a$export$42387eeaac09cf54(arg1, arg2) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $4730acf0753ac89a$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return "all";
    else if (active === false && inactive === false) return "none";
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? "active" : "inactive";
    }
}
function $4730acf0753ac89a$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $4730acf0753ac89a$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === "none") return false;
    else if (queryStatusFilter !== "all") {
        var isActive = query.isActive();
        if (queryStatusFilter === "active" && !isActive) return false;
        if (queryStatusFilter === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetching === "boolean" && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $4730acf0753ac89a$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($4730acf0753ac89a$export$5fcb678681417b54(mutation.options.mutationKey) !== $4730acf0753ac89a$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $4730acf0753ac89a$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $4730acf0753ac89a$export$5fcb678681417b54(queryKey) {
    var asArray = $4730acf0753ac89a$export$4d32d63f64b825b9(queryKey);
    return $4730acf0753ac89a$export$e7f2f041280beb00(asArray);
}
function $4730acf0753ac89a$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $4730acf0753ac89a$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $4730acf0753ac89a$export$2f07189bb9fa26a7(a, b) {
    return $4730acf0753ac89a$export$3bc9138b70293839($4730acf0753ac89a$export$4d32d63f64b825b9(a), $4730acf0753ac89a$export$4d32d63f64b825b9(b));
}
function $4730acf0753ac89a$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !$4730acf0753ac89a$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $4730acf0753ac89a$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $4730acf0753ac89a$export$53b83ca8eaab0383(a) && $4730acf0753ac89a$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $4730acf0753ac89a$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $4730acf0753ac89a$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $4730acf0753ac89a$export$53b83ca8eaab0383(o) {
    if (!$4730acf0753ac89a$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$4730acf0753ac89a$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $4730acf0753ac89a$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $4730acf0753ac89a$export$aaae5295ec3351c9(value) {
    return typeof value === "string" || Array.isArray(value);
}
function $4730acf0753ac89a$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $4730acf0753ac89a$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $4730acf0753ac89a$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $4730acf0753ac89a$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
}


function $85b5d5cb2b377543$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}






var $a326eb7faf36b653$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    } /**
   * All calls to the wrapped function will be batched.
   */ ;
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    } /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ ;
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    } /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ ;
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $a326eb7faf36b653$export$520687f44db6e1ab = new $a326eb7faf36b653$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $71a71a329ca2584f$var$logger = console;
function $71a71a329ca2584f$export$2b1d391cd05230fd() {
    return $71a71a329ca2584f$var$logger;
}
function $71a71a329ca2584f$export$3abbd92f765bee58(newLogger) {
    $71a71a329ca2584f$var$logger = newLogger;
}



var $8806d6a418db4b9d$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $dd382c2a22c34b78$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $85b5d5cb2b377543$export$2e2bcd8739ae039)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === "boolean") _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $dd382c2a22c34b78$export$6bf54661be5b02cf = new $dd382c2a22c34b78$export$86f1af424b2ca4de();





var $8283b4ebace21c13$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $85b5d5cb2b377543$export$2e2bcd8739ae039)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener("online", listener, false);
                window.addEventListener("offline", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("online", listener);
                    window.removeEventListener("offline", listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === "boolean") _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $8283b4ebace21c13$export$b113e788b2dd3fdc = new $8283b4ebace21c13$export$58774fb55d5ff7fc();



function $90c5b2b1a5489698$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $90c5b2b1a5489698$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === "function";
}
var $90c5b2b1a5489698$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $90c5b2b1a5489698$export$986cc6445c1d323(value) {
    return value instanceof $90c5b2b1a5489698$export$a8430ed4188f35a9;
} // CLASS
var $90c5b2b1a5489698$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $90c5b2b1a5489698$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $90c5b2b1a5489698$var$defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && _this.failureCount < retry || typeof retry === "function" && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $4730acf0753ac89a$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() || !(0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $b3c5b3b704751c57$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $4730acf0753ac89a$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $4730acf0753ac89a$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $4730acf0753ac89a$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, "signal", {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject("Missing queryFn");
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: "error",
                    error: error
                });
                if (!(0, $90c5b2b1a5489698$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: "queryUpdated",
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== "undefined";
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== "undefined";
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? "success" : "idle"
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case "failed":
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case "pause":
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                    isPaused: true
                });
            case "continue":
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                    isPaused: false
                });
            case "fetch":
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: "loading"
                });
            case "success":
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: "success"
                });
            case "error":
                var error = action.error;
                if ((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, this.revertState);
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: "error"
                });
            case "invalidate":
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                    isInvalidated: true
                });
            case "setState":
                return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $55146b963a737dee$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $85b5d5cb2b377543$export$2e2bcd8739ae039)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $b3c5b3b704751c57$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "queryAdded",
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "queryRemoved",
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));









var $8d56420e30839da2$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $8d56420e30839da2$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === "loading";
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: "loading",
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: "loading",
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: "success",
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: "error",
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject("No mutationFn found");
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $8d56420e30839da2$var$reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $8d56420e30839da2$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}
function $8d56420e30839da2$var$reducer(state, action) {
    switch(action.type){
        case "failed":
            return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                failureCount: state.failureCount + 1
            });
        case "pause":
            return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                isPaused: true
            });
        case "continue":
            return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                isPaused: false
            });
        case "loading":
            return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: "loading",
                variables: action.variables
            });
        case "success":
            return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                data: action.data,
                error: null,
                status: "success",
                isPaused: false
            });
        case "error":
            return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: "error"
            });
        case "setState":
            return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, action.state);
        default:
            return state;
    }
}




var $10b6fdd47d933258$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $85b5d5cb2b377543$export$2e2bcd8739ae039)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $8d56420e30839da2$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $4730acf0753ac89a$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));







function $73df723cfc461e76$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject("Missing queryFn");
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== "undefined";
                    var param = manual ? pageParam : $73df723cfc461e76$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== "undefined";
                    var _param = _manual ? pageParam : $73df723cfc461e76$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === "undefined";
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $73df723cfc461e76$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $73df723cfc461e76$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $73df723cfc461e76$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $73df723cfc461e76$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
}
function $73df723cfc461e76$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
}


var $13e074efb1ecf7c6$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $55146b963a737dee$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $10b6fdd47d933258$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, filters, {
            active: true
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $73df723cfc461e76$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(queryKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(mutationKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $1u0KT = parcelRequire("1u0KT");
var $d0188f2d930898c2$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unstable_batchedUpdates;


(0, $a326eb7faf36b653$export$520687f44db6e1ab).setBatchNotifyFunction((0, $d0188f2d930898c2$export$c78a37762a8d58e1));



var $a9338c6a303143c8$export$af88d00dbe7f521 = console;


(0, $71a71a329ca2584f$export$3abbd92f765bee58)((0, $a9338c6a303143c8$export$af88d00dbe7f521));



var $acw62 = parcelRequire("acw62");
var $ccb8f828cefd6075$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $ccb8f828cefd6075$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $ccb8f828cefd6075$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $ccb8f828cefd6075$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $ccb8f828cefd6075$var$defaultContext;
}
var $ccb8f828cefd6075$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
var $ccb8f828cefd6075$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $ccb8f828cefd6075$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ccb8f828cefd6075$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: client
    }, children));
};







var $acw62 = parcelRequire("acw62");







var $d69ec76a7f524d37$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $85b5d5cb2b377543$export$2e2bcd8739ae039)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, this.options, {
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $8d56420e30839da2$export$a1659b54bac3252a)();
        var result = (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, state, {
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));



function $a92a0ee821c291b8$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === "boolean") return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $0bcdd0ea2a5866d5$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $4730acf0753ac89a$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $d69ec76a7f524d37$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}










var $461f073e5b72a6b1$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $85b5d5cb2b377543$export$2e2bcd8739ae039)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($461f073e5b72a6b1$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp("error");
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.options.enabled === false || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $461f073e5b72a6b1$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = "loading";
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && (status === "loading" || status === "idle")) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        var result = {
            status: status,
            isLoading: status === "loading",
            isSuccess: status === "success",
            isError: status === "error",
            isIdle: status === "idle",
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== "loading",
            isLoadingError: status === "error" && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === "error" && state.dataUpdatedAt !== 0,
            isStale: $461f073e5b72a6b1$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === "tracked" && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === "tracked" ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $4730acf0753ac89a$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $a51d8ff1bd7ea6db$export$2e2bcd8739ae039)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error" && !(0, $90c5b2b1a5489698$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    };
    return QueryObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
function $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $461f073e5b72a6b1$var$shouldFetchOnMount(query, options) {
    return $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $461f073e5b72a6b1$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $461f073e5b72a6b1$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $461f073e5b72a6b1$var$isStale(query, options);
    }
    return false;
}
function $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $461f073e5b72a6b1$var$isStale(query, options);
}
function $461f073e5b72a6b1$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $af499ad4852a56cf$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $af499ad4852a56cf$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($af499ad4852a56cf$var$createValue()); // HOOK
var $af499ad4852a56cf$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($af499ad4852a56cf$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $af499ad4852a56cf$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $af499ad4852a56cf$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($af499ad4852a56cf$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};




function $02303e84e5b435f8$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $af499ad4852a56cf$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === "tracked") result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $369f47a093b8c0cf$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $02303e84e5b435f8$export$fff0865807e996c5)(parsedOptions, (0, $461f073e5b72a6b1$export$a06cf8c0066f0d4c));
}










function $27b7fe48f9317a91$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $d3e83ac8f85d08f0$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d3e83ac8f85d08f0$var$ReactIs, $d3e83ac8f85d08f0$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$d3e83ac8f85d08f0$exports = (parcelRequire("jJGJU"))();



var $20421a8e140fb9ef$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $20421a8e140fb9ef$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
function $20421a8e140fb9ef$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $20421a8e140fb9ef$var$commonjsGlobal[key] = ($20421a8e140fb9ef$var$commonjsGlobal[key] || 0) + 1;
}
function $20421a8e140fb9ef$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $20421a8e140fb9ef$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $20421a8e140fb9ef$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $20421a8e140fb9ef$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $20421a8e140fb9ef$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $20421a8e140fb9ef$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($20421a8e140fb9ef$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $20421a8e140fb9ef$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $acw62.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($d3e83ac8f85d08f0$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $20421a8e140fb9ef$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $20421a8e140fb9ef$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $20421a8e140fb9ef$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $acw62.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($d3e83ac8f85d08f0$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $20421a8e140fb9ef$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $20421a8e140fb9ef$var$createReactContext;
var $20421a8e140fb9ef$export$2e2bcd8739ae039 = $20421a8e140fb9ef$var$index;



function $41ddab6ce1eb565d$export$2e2bcd8739ae039() {
    $41ddab6ce1eb565d$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41ddab6ce1eb565d$export$2e2bcd8739ae039.apply(this, arguments);
}


var $62ddf3174d9df941$exports = {};
var $748a9cdfa4dd7926$exports = {};
$748a9cdfa4dd7926$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $62ddf3174d9df941$exports = $62ddf3174d9df941$var$pathToRegexp;
$62ddf3174d9df941$exports.parse = $62ddf3174d9df941$var$parse;
$62ddf3174d9df941$exports.compile = $62ddf3174d9df941$var$compile;
$62ddf3174d9df941$exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
$62ddf3174d9df941$exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $62ddf3174d9df941$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($748a9cdfa4dd7926$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$748a9cdfa4dd7926$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $62ddf3174d9df941$var$attachKeys(new RegExp("^" + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$748a9cdfa4dd7926$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($748a9cdfa4dd7926$exports(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


parcelRequire("4jPKB");
function $01cf52ade4d720c9$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $9ORqK = parcelRequire("9ORqK");
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $20421a8e140fb9ef$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $20421a8e140fb9ef$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType;
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $2756f79476f0245f$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $2756f79476f0245f$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $2756f79476f0245f$export$c3e8bb440bd55b18)(prevLocation, (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $2756f79476f0245f$export$fe53371bee54353d)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $01cf52ade4d720c9$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $27b7fe48f9317a91$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $01cf52ade4d720c9$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $41ddab6ce1eb565d$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ebf4c3fe5600f7ed$var$global, $ebf4c3fe5600f7ed$var$key, $ebf4c3fe5600f7ed$var$buildNames, $ebf4c3fe5600f7ed$var$initialBuildName, $ebf4c3fe5600f7ed$var$secondaryBuildName;


function $51199134317cb79f$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}



var $acw62 = parcelRequire("acw62");



function $956aac70a989c55e$export$2e2bcd8739ae039() {
    $956aac70a989c55e$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $956aac70a989c55e$export$2e2bcd8739ae039.apply(this, arguments);
}


function $b8b9135e87593c3e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $51199134317cb79f$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $51199134317cb79f$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $2756f79476f0245f$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $b8b9135e87593c3e$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $956aac70a989c55e$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $b8b9135e87593c3e$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $956aac70a989c55e$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType, $3189c83282a9a1c6$var$refType;
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $b8b9135e87593c3e$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $ebf4c3fe5600f7ed$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $3189c83282a9a1c6$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $956aac70a989c55e$export$2e2bcd8739ae039)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $956aac70a989c55e$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
var $3189c83282a9a1c6$var$ariaCurrentType;



var $4jPKB = parcelRequire("4jPKB");

var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;


var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;


function $1b423fa9606bd2e4$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $1b423fa9606bd2e4$export$2e2bcd8739ae039 = $1b423fa9606bd2e4$var$memoize;


var $3ae0d639ed096ebb$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3ae0d639ed096ebb$var$isPropValid = /* #__PURE__ */ (0, $1b423fa9606bd2e4$export$2e2bcd8739ae039)(function(prop) {
    return $3ae0d639ed096ebb$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $3ae0d639ed096ebb$export$2e2bcd8739ae039 = $3ae0d639ed096ebb$var$isPropValid;



var $9ORqK = parcelRequire("9ORqK");

var $hPtJY = parcelRequire("hPtJY");
function $f8dbcd8598db1f0b$var$v() {
    return ($f8dbcd8598db1f0b$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $4jPKB.typeOf)(t);
}, $f8dbcd8598db1f0b$var$w = Object.freeze([]), $f8dbcd8598db1f0b$var$E = Object.freeze({});
function $f8dbcd8598db1f0b$var$b(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$A = ("undefined" != typeof $hPtJY && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.5", $f8dbcd8598db1f0b$var$I = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : (typeof $hPtJY, typeof $hPtJY, false)), $f8dbcd8598db1f0b$var$O = {}, $f8dbcd8598db1f0b$var$R = {};
function $f8dbcd8598db1f0b$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f8dbcd8598db1f0b$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$k = new Map, $f8dbcd8598db1f0b$var$V = 1, $f8dbcd8598db1f0b$var$B = function(e) {
    if ($f8dbcd8598db1f0b$var$x.has(e)) return $f8dbcd8598db1f0b$var$x.get(e);
    for(; $f8dbcd8598db1f0b$var$k.has($f8dbcd8598db1f0b$var$V);)$f8dbcd8598db1f0b$var$V++;
    var t = $f8dbcd8598db1f0b$var$V++;
    return $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e), t;
}, $f8dbcd8598db1f0b$var$z = function(e) {
    return $f8dbcd8598db1f0b$var$k.get(e);
}, $f8dbcd8598db1f0b$var$M = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$V && ($f8dbcd8598db1f0b$var$V = t + 1), $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e);
}, $f8dbcd8598db1f0b$var$G = "style[" + $f8dbcd8598db1f0b$var$A + '][data-styled-version="5.3.5"]', $f8dbcd8598db1f0b$var$L = new RegExp("^" + $f8dbcd8598db1f0b$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$M(u, c), $f8dbcd8598db1f0b$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$q = function() {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$A, "active"), r.setAttribute("data-styled-version", "5.3.5");
    var i = $f8dbcd8598db1f0b$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$J = $f8dbcd8598db1f0b$var$I, $f8dbcd8598db1f0b$var$X = {
    isServer: !$f8dbcd8598db1f0b$var$I,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$P
}, $f8dbcd8598db1f0b$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$E), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$v({}, $f8dbcd8598db1f0b$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$I && $f8dbcd8598db1f0b$var$J && ($f8dbcd8598db1f0b$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$A) && ($f8dbcd8598db1f0b$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$U(o) : r ? new $f8dbcd8598db1f0b$var$$(o) : new $f8dbcd8598db1f0b$var$W(o), new $f8dbcd8598db1f0b$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$K = /(a)(d)/gi, $f8dbcd8598db1f0b$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$Q(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$Q(t % 52) + n).replace($f8dbcd8598db1f0b$var$K, "$1-$2");
}
var $f8dbcd8598db1f0b$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$ne = function(e) {
    return $f8dbcd8598db1f0b$var$te(5381, e);
};
function $f8dbcd8598db1f0b$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$b(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$oe = $f8dbcd8598db1f0b$var$ne("5.3.5"), $f8dbcd8598db1f0b$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$re(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$oe, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$Ne(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$ie = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$E : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$E : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$w : c, l = new (0, $9a1e650477d9d52e$export$2e2bcd8739ae039)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$j(15), $f8dbcd8598db1f0b$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$he = ($f8dbcd8598db1f0b$var$de.Consumer, new $f8dbcd8598db1f0b$var$Z), $f8dbcd8598db1f0b$var$pe = $f8dbcd8598db1f0b$var$ce();
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$var$me() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$de) || $f8dbcd8598db1f0b$var$pe;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$fe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $f8dbcd8598db1f0b$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$pe), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ge = /([A-Z])/, $f8dbcd8598db1f0b$var$Se = /([A-Z])/g, $f8dbcd8598db1f0b$var$we = /^ms-/, $f8dbcd8598db1f0b$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$be(e) {
    return $f8dbcd8598db1f0b$var$ge.test(e) ? e.replace($f8dbcd8598db1f0b$var$Se, $f8dbcd8598db1f0b$var$Ee).replace($f8dbcd8598db1f0b$var$we, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$_e(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f8dbcd8598db1f0b$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$b(t[i]) ? s.push($f8dbcd8598db1f0b$var$be(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $d9263a4c6739b952$export$2e2bcd8739ae039) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$b(e) || $f8dbcd8598db1f0b$var$S(e) ? $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g($f8dbcd8598db1f0b$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g(e, n)));
}
var $f8dbcd8598db1f0b$var$Ie = /invalid hook call/i, $f8dbcd8598db1f0b$var$Pe = new Set, $f8dbcd8598db1f0b$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $f8dbcd8598db1f0b$var$Re = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$je = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$Te(e) {
    return e.replace($f8dbcd8598db1f0b$var$De, "-").replace($f8dbcd8598db1f0b$var$je, "");
}
var $f8dbcd8598db1f0b$var$xe = function(e) {
    return $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$ne(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$ke(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$ze(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$Ve(t) && $f8dbcd8598db1f0b$var$Ve(r) ? $f8dbcd8598db1f0b$var$Me(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$Ve(i)) for(var a in i)$f8dbcd8598db1f0b$var$Be(a) && $f8dbcd8598db1f0b$var$ze(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$j(14);
            if ($f8dbcd8598db1f0b$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$j(8) : t ? $f8dbcd8598db1f0b$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Ye = {};
function $f8dbcd8598db1f0b$var$qe(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$ke(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$Te(e);
        $f8dbcd8598db1f0b$var$Ye[n] = ($f8dbcd8598db1f0b$var$Ye[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$xe("5.3.5" + n + $f8dbcd8598db1f0b$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $f8dbcd8598db1f0b$var$ke(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $f8dbcd8598db1f0b$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$E);
                var r = $f8dbcd8598db1f0b$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Re(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$fe(), s = $f8dbcd8598db1f0b$var$me(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $f8dbcd8598db1f0b$var$ke(_), A = g !== t ? $f8dbcd8598db1f0b$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $3ae0d639ed096ebb$export$2e2bcd8739ae039), _) : !N || (0, $3ae0d639ed096ebb$export$2e2bcd8739ae039)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $f8dbcd8598db1f0b$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $acw62.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$ke(e) ? e : $f8dbcd8598db1f0b$var$Te($f8dbcd8598db1f0b$var$_(e)));
        return $f8dbcd8598db1f0b$var$qe(e, $f8dbcd8598db1f0b$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $f8dbcd8598db1f0b$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$E), !(0, $4jPKB.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$j(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$He[e] = $f8dbcd8598db1f0b$var$He(e);
});
var $f8dbcd8598db1f0b$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$re(e), $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$xe(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$$e(i, a);
    function l(e) {
        var t = $f8dbcd8598db1f0b$var$fe(), n = $f8dbcd8598db1f0b$var$me(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), l = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$O, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$v({}, t, {
                theme: $f8dbcd8598db1f0b$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$xe(o);
    return new $f8dbcd8598db1f0b$var$ve(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$A + '="true"',
                'data-styled-version="5.3.5"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$j(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$A] = "", t["data-styled-version"] = "5.3.5", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$j(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$_(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Z,
    masterSheet: $f8dbcd8598db1f0b$var$he
};
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$He;



var $ayMG0 = parcelRequire("ayMG0");
var $a8fa6a444a800fa7$exports = {};
"use strict";
var $0f49c8ba50dff6ee$exports = {};
function $0f49c8ba50dff6ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$0f49c8ba50dff6ee$exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, $0f49c8ba50dff6ee$exports.__esModule = true, $0f49c8ba50dff6ee$exports["default"] = $0f49c8ba50dff6ee$exports;


Object.defineProperty($a8fa6a444a800fa7$exports, "__esModule", {
    value: true
});
$a8fa6a444a800fa7$exports.default = void 0;

var $a8fa6a444a800fa7$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a8fa6a444a800fa7$var$_default = (0, $a8fa6a444a800fa7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), "OpenInNew");
$a8fa6a444a800fa7$exports.default = $a8fa6a444a800fa7$var$_default;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $9a402a389bd8b499$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $478fe5b437ab8d6f$export$ffd560f22c0ecf04(slot) {
    return (0, $9XEW1.default)("MuiAvatar", slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $7u6PA.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $478fe5b437ab8d6f$export$2e2bcd8739ae039 = $478fe5b437ab8d6f$var$avatarClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $1894f4268467302e$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $9971e.default)(slots, (0, $478fe5b437ab8d6f$export$ffd560f22c0ecf04), classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $d8seH.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && {
        color: theme.palette.background.default,
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    }));
const $1894f4268467302e$var$AvatarImg = (0, $d8seH.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $d8seH.default)((0, $9a402a389bd8b499$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $1En50.default)(props, $1894f4268467302e$var$_excluded);
    let children = null; // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded((0, $8nd05.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $8nd05.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarImg, (0, $8nd05.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarFallback, {
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $1894f4268467302e$export$2e2bcd8739ae039 = $1894f4268467302e$var$Avatar;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $1vDzc = parcelRequire("1vDzc");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $acw62 = parcelRequire("acw62");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $a5536215dd353a4e$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $6fd6e1f605afb988$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refA == null && refB == null) return null;
        return (refValue)=>{
            (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(refA, refValue);
            (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}


var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $f8b7b39c1ae7354b$var$useEnhancedEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $f8b7b39c1ae7354b$export$2e2bcd8739ae039 = $f8b7b39c1ae7354b$var$useEnhancedEffect;


function $7132531a8fc4c99c$export$2e2bcd8739ae039(fn) {
    const ref = $acw62.useRef(fn);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useCallback((...args)=>// tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}


var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039);


// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $acw62 = parcelRequire("acw62");
let $04d6f011ad19b2fc$var$hadKeyboardEvent = true;
let $04d6f011ad19b2fc$var$hadFocusVisibleRecently = false;
let $04d6f011ad19b2fc$var$hadFocusVisibleRecentlyTimeout;
const $04d6f011ad19b2fc$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $04d6f011ad19b2fc$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $04d6f011ad19b2fc$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $04d6f011ad19b2fc$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $04d6f011ad19b2fc$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $04d6f011ad19b2fc$var$handlePointerDown() {
    $04d6f011ad19b2fc$var$hadKeyboardEvent = false;
}
function $04d6f011ad19b2fc$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($04d6f011ad19b2fc$var$hadFocusVisibleRecently) $04d6f011ad19b2fc$var$hadKeyboardEvent = true;
    }
}
function $04d6f011ad19b2fc$var$prepare(doc) {
    doc.addEventListener("keydown", $04d6f011ad19b2fc$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $04d6f011ad19b2fc$var$handleVisibilityChange, true);
}
function $04d6f011ad19b2fc$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $04d6f011ad19b2fc$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $04d6f011ad19b2fc$var$handleVisibilityChange, true);
}
function $04d6f011ad19b2fc$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    } // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $04d6f011ad19b2fc$var$hadKeyboardEvent || $04d6f011ad19b2fc$var$focusTriggersKeyboardModality(target);
}
function $04d6f011ad19b2fc$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $04d6f011ad19b2fc$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $04d6f011ad19b2fc$var$hadFocusVisibleRecently = true;
            window.clearTimeout($04d6f011ad19b2fc$var$hadFocusVisibleRecentlyTimeout);
            $04d6f011ad19b2fc$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $04d6f011ad19b2fc$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($04d6f011ad19b2fc$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $8fc8239a3939454e$export$2e2bcd8739ae039 = (0, $04d6f011ad19b2fc$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");
function $021c7856fd446737$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $36aa01289d8055dd$export$2e2bcd8739ae039() {
    $36aa01289d8055dd$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36aa01289d8055dd$export$2e2bcd8739ae039.apply(this, arguments);
}


function $cec67d431a0ce96e$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $748e63dc9f7e9476$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, "appear", props),
            enter: $04540450bf60efa1$var$getProp(child, "enter", props),
            exit: $04540450bf60efa1$var$getProp(child, "exit", props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $748e63dc9f7e9476$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cec67d431a0ce96e$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $36aa01289d8055dd$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $021c7856fd446737$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $1SA7b = parcelRequire("1SA7b");

var $8zogs = parcelRequire("8zogs");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $ayMG0 = parcelRequire("ayMG0");
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $1SA7b.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $1SA7b.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $9XEW1.default)("MuiTouchRipple", slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $7u6PA.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $855224273a002a0f$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $855224273a002a0f$var$_ = (t)=>t, $855224273a002a0f$var$_t, $855224273a002a0f$var$_t2, $855224273a002a0f$var$_t3, $855224273a002a0f$var$_t4;
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $8zogs.keyframes)($855224273a002a0f$var$_t || ($855224273a002a0f$var$_t = $855224273a002a0f$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $855224273a002a0f$var$exitKeyframe = (0, $8zogs.keyframes)($855224273a002a0f$var$_t2 || ($855224273a002a0f$var$_t2 = $855224273a002a0f$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $855224273a002a0f$var$pulsateKeyframe = (0, $8zogs.keyframes)($855224273a002a0f$var$_t3 || ($855224273a002a0f$var$_t3 = $855224273a002a0f$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
}); // This `styled()` function invokes keyframes. `styled-components` only supports keyframes
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $cb2cd8c78d72bd92$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($855224273a002a0f$var$_t4 || ($855224273a002a0f$var$_t4 = $855224273a002a0f$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible, $855224273a002a0f$var$enterKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving, $855224273a002a0f$var$exitKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate, $855224273a002a0f$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1En50.default)(props, $855224273a002a0f$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $acw62.useRef(null); // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $1SA7b.default)(classes.ripple, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $1SA7b.default)(classes.rippleVisible, (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $1SA7b.default)(classes.ripplePulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $1SA7b.default)(classes.child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $1SA7b.default)(classes.childLeaving, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $1SA7b.default)(classes.childPulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb)=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3); // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $855224273a002a0f$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, (0, $755fb323846f60d4$export$2e2bcd8739ae039).root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $9XEW1.default)("MuiButtonBase", slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $7u6PA.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $4a35786d89db9dda$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $42d7f65840078ec1$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $42d7f65840078ec1$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1En50.default)(props, $4a35786d89db9dda$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleOwnRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, handleOwnRef);
    const ownerState = (0, $8nd05.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, (0, $8nd05.default)({
        as: ComponentProp,
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $855224273a002a0f$export$2e2bcd8739ae039), (0, $8nd05.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;



var $jTnBY = parcelRequire("jTnBY");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $9XEW1.default)("MuiButton", slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $7u6PA.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;



var $ayMG0 = parcelRequire("ayMG0");
const $4a02bab8c70a697b$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $11f546081ba06ace$export$5a6f9035944c8119), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $4a02bab8c70a697b$var$commonIconStyles = (ownerState)=>(0, $8nd05.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $8nd05.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $8nd05.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kyRHb.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kyRHb.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kyRHb.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $8nd05.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: (0, $8nd05.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: (0, $8nd05.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "outlined" && ownerState.color === "secondary" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabled}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kyRHb.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $8639dcef822d5d4c$export$2e2bcd8739ae039));
    const resolvedProps = (0, $1vDzc.default)(contextProps, inProps);
    const props = (0, $6g9fa.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $1En50.default)(props, $4a02bab8c70a697b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $1SA7b.default)(className, contextProps.className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $1SA7b.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $jTnBY = parcelRequire("jTnBY");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $9XEW1.default)("MuiIconButton", slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $7u6PA.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $71c322247f7fbf93$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $e40d2047b7c1e09d$export$5e8702d71474f093), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: theme.palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $8nd05.default)({
        color: theme.palette[ownerState.color].main
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $e40d2047b7c1e09d$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: theme.palette.action.disabled
        }
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $1En50.default)(props, $71c322247f7fbf93$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
var $936e1576c7caee60$exports = {};
"use strict";

$936e1576c7caee60$exports = (parcelRequire("cSJDD"));


parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

parcelRequire("c9Z8w");
function $4cf4482b502c4310$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $4cf4482b502c4310$export$2e2bcd8739ae039);



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $9XEW1.default)("MuiList", slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $7u6PA.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $9971e.default)(slots, (0, $adbbc5717e0d0350$export$c6bd6795ed6e3203), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7a9415d492047f70$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $7a9415d492047f70$export$2e2bcd8739ae039);




var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $0d80e79907b6bdbc$export$2e2bcd8739ae039)((0, $c10afe25107351d9$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $9XEW1.default)("MuiPaper", slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $7u6PA.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $4ec306d48089c2c9$export$29cdb466b9b6f20b), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${theme.palette.divider}`
    }, ownerState.variant === "elevation" && (0, $8nd05.default)({
        boxShadow: theme.shadows[ownerState.elevation]
    }, theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $kyRHb.alpha)("#fff", $595185d0d7275c3b$var$getOverlayAlpha(ownerState.elevation))}, ${(0, $kyRHb.alpha)("#fff", $595185d0d7275c3b$var$getOverlayAlpha(ownerState.elevation))})`
    })));
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other));
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $41c4238d7b0ec499$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $41c4238d7b0ec499$export$2e2bcd8739ae039);




function $230cae465a5568fd$export$2e2bcd8739ae039(node) {
    const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $230cae465a5568fd$export$2e2bcd8739ae039);




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $748e63dc9f7e9476$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $021c7856fd446737$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;


parcelRequire("acw62");

var $lJyjx = parcelRequire("lJyjx");

var $jR9F1 = parcelRequire("jR9F1");
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $lJyjx.default)((0, $jR9F1.default));
    return theme;
}


const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $ayMG0 = parcelRequire("ayMG0");
const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 * Remove this workaround once the WebKit bug fix is released.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)[4-9]/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = $acw62.useRef();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const foreignRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(children.ref, ref);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $93dbc7362e67d1d8$var$isHostComponent(element) {
    return typeof element === "string";
}
var $93dbc7362e67d1d8$export$2e2bcd8739ae039 = $93dbc7362e67d1d8$var$isHostComponent;




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c91b8f922607ad66$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



var $9971e = parcelRequire("9971e");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
parcelRequire("c9Z8w");

function $b2ad7edda02764f6$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ const $b2ad7edda02764f6$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, ref) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? children.ref : null, ref);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($b2ad7edda02764f6$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(ref, mountNode);
            return ()=>{
                (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) return /*#__PURE__*/ $acw62.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode;
});
var $b2ad7edda02764f6$export$2e2bcd8739ae039 = $b2ad7edda02764f6$var$Portal;



// Is a vertical scrollbar displayed?
function $10594cfe2cdcfbe1$var$isOverflowing(container) {
    const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $230cae465a5568fd$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $10594cfe2cdcfbe1$var$getPaddingRight(element) {
    return parseInt((0, $230cae465a5568fd$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $10594cfe2cdcfbe1$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude = [], show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    const blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, (element)=>{
        if (blacklist.indexOf(element) === -1 && blacklistTagNames.indexOf(element.tagName) === -1) $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(element, show);
    });
}
function $10594cfe2cdcfbe1$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $10594cfe2cdcfbe1$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($10594cfe2cdcfbe1$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7a9415d492047f70$export$2e2bcd8739ae039)((0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$10594cfe2cdcfbe1$var$getPaddingRight(container) + scrollbarSize}px`; // .mui-fixed is a global helper.
            const fixedElements = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$10594cfe2cdcfbe1$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        const parent = container.parentElement;
        const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(container);
        const scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $10594cfe2cdcfbe1$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $10594cfe2cdcfbe1$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal); // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $10594cfe2cdcfbe1$var$getHiddenSiblings(container);
        $10594cfe2cdcfbe1$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $10594cfe2cdcfbe1$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $10594cfe2cdcfbe1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $10594cfe2cdcfbe1$var$handleContainer(containerInfo, props);
    }
    remove(modal) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $10594cfe2cdcfbe1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(modal.modalRef, true);
            $10594cfe2cdcfbe1$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");


var $ayMG0 = parcelRequire("ayMG0");
const $98416270a7f6c77a$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $98416270a7f6c77a$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
     // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $98416270a7f6c77a$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $98416270a7f6c77a$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $98416270a7f6c77a$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $98416270a7f6c77a$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($98416270a7f6c77a$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $98416270a7f6c77a$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$98416270a7f6c77a$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $98416270a7f6c77a$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 */ function $98416270a7f6c77a$var$TrapFocus(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $98416270a7f6c77a$var$defaultGetTabbable, isEnabled: isEnabled = $98416270a7f6c77a$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef();
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null); // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        }; // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open TrapFocus
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
             // Make sure the next tab starts from the right place.
            // doc.activeElement referes to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: 0,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-test": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: 0,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-test": "sentinelEnd"
            })
        ]
    });
}
var $98416270a7f6c77a$export$2e2bcd8739ae039 = $98416270a7f6c77a$var$TrapFocus;



var $7u6PA = parcelRequire("7u6PA");

var $9XEW1 = parcelRequire("9XEW1");
function $d4c7e29c21143dc7$export$67960e22b12a638d(slot) {
    return (0, $9XEW1.default)("MuiModal", slot);
}
const $d4c7e29c21143dc7$var$modalUnstyledClasses = (0, $7u6PA.default)("MuiModal", [
    "root",
    "hidden"
]);
var $d4c7e29c21143dc7$export$2e2bcd8739ae039 = $d4c7e29c21143dc7$var$modalUnstyledClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $a8647b5a9242652e$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "children",
    "classes",
    "className",
    "closeAfterTransition",
    "component",
    "components",
    "componentsProps",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "theme",
    "onTransitionEnter",
    "onTransitionExited"
];
const $a8647b5a9242652e$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ]
    };
    return (0, $9971e.default)(slots, (0, $d4c7e29c21143dc7$export$67960e22b12a638d), classes);
};
function $a8647b5a9242652e$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $a8647b5a9242652e$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $a8647b5a9242652e$var$defaultManager = new (0, $10594cfe2cdcfbe1$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a8647b5a9242652e$var$ModalUnstyled = /*#__PURE__*/ $acw62.forwardRef(function ModalUnstyled(props, ref) {
    const { BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, container: container, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, manager: // private
    // eslint-disable-next-line react/prop-types
    manager = $a8647b5a9242652e$var$defaultManager, onBackdropClick: onBackdropClick, onClose: onClose, onKeyDown: onKeyDown, open: open, theme: /* eslint-disable react/prop-types */ theme, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited } = props, other = (0, $1En50.default)(props, $a8647b5a9242652e$var$_excluded);
    const [exited, setExited] = $acw62.useState(true);
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(modalRef, ref);
    const hasTransition = $a8647b5a9242652e$var$getHasTransition(props);
    const getDoc = ()=>(0, $4cf4482b502c4310$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $a8647b5a9242652e$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else (0, $10594cfe2cdcfbe1$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal());
    }, [
        manager
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        classes: classesProp,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $a8647b5a9242652e$var$useUtilityClasses(ownerState);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
         // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $c91b8f922607ad66$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $c91b8f922607ad66$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = components.Root || component;
    const rootProps = componentsProps.root || {};
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2ad7edda02764f6$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({
            role: "presentation"
        }, rootProps, !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(Root) && {
            as: component,
            ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState),
            theme: theme
        }, other, {
            ref: handleRef,
            onKeyDown: handleKeyDown,
            className: (0, $1SA7b.default)(classes.root, rootProps.className, className),
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropComponent, (0, $8nd05.default)({
                    "aria-hidden": true,
                    open: open,
                    onClick: handleBackdropClick
                }, BackdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $98416270a7f6c77a$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a8647b5a9242652e$export$2e2bcd8739ae039 = $a8647b5a9242652e$var$ModalUnstyled;



var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");






var $ayMG0 = parcelRequire("ayMG0");
const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const foreignRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(children.ref, ref);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $9XEW1.default)("MuiBackdrop", slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $7u6PA.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $4838e5a14e330013$var$_excluded = [
    "children",
    "component",
    "components",
    "componentsProps",
    "className",
    "invisible",
    "open",
    "transitionDuration",
    "TransitionComponent"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $9971e.default)(slots, (0, $5c4c540114ae85ab$export$9927a91fd93152bd), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _components$Root, _componentsProps$root;
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, className: className, invisible: invisible = false, open: open, transitionDuration: transitionDuration, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4838e5a14e330013$var$BackdropRoot, {
            "aria-hidden": true,
            as: (_components$Root = components.Root) != null ? _components$Root : component,
            className: (0, $1SA7b.default)(classes.root, className),
            ownerState: (0, $8nd05.default)({}, ownerState, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState),
            classes: classes,
            ref: ref,
            children: children
        })
    }));
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;



var $ayMG0 = parcelRequire("ayMG0");
const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "closeAfterTransition",
    "children",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted"
];
const $0bdcbfecdf3275a2$export$eb211a494147b724 = (0, $d4c7e29c21143dc7$export$2e2bcd8739ae039);
const $0bdcbfecdf3275a2$var$extendUtilityClasses = (ownerState)=>{
    return ownerState.classes;
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: "fixed",
        zIndex: theme.zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _componentsProps$root;
    const props = (0, $6g9fa.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, closeAfterTransition: closeAfterTransition = false, children: children, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const [exited, setExited] = $acw62.useState(true);
    const commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const ownerState = (0, $8nd05.default)({}, props, commonProps, {
        exited: exited
    });
    const classes = $0bdcbfecdf3275a2$var$extendUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8647b5a9242652e$export$2e2bcd8739ae039), (0, $8nd05.default)({
        components: (0, $8nd05.default)({
            Root: $0bdcbfecdf3275a2$var$ModalRoot
        }, components),
        componentsProps: {
            root: (0, $8nd05.default)({}, componentsProps.root, (!components.Root || !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(components.Root)) && {
                ownerState: (0, $8nd05.default)({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
            })
        },
        BackdropComponent: BackdropComponent,
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, {
        classes: classes
    }, commonProps, {
        children: children
    }));
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;




var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $9XEW1.default)("MuiPopover", slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $7u6PA.default)("MuiPopover", [
    "root",
    "paper"
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $9971e.default)(slots, (0, $ea2c25a800e729b1$export$88f455dd56c95edb), classes);
};
const $012baef8dc9ae9d0$var$PopoverRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$var$PopoverPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperProps = {}, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(paperRef, PaperProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        PaperProps: PaperProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $c10afe25107351d9$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset(); // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $c10afe25107351d9$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($012baef8dc9ae9d0$var$PopoverRoot, (0, $8nd05.default)({
        BackdropProps: {
            invisible: true
        },
        className: (0, $1SA7b.default)(classes.root, className),
        container: container,
        open: open,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($012baef8dc9ae9d0$var$PopoverPaper, (0, $8nd05.default)({
                elevation: elevation
            }, PaperProps, {
                ref: handlePaperRef,
                className: (0, $1SA7b.default)(classes.paper, PaperProps.className),
                children: children
            }))
        }))
    }));
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;



var $d8seH = parcelRequire("d8seH");


var $6g9fa = parcelRequire("6g9fa");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $9XEW1.default)("MuiMenu", slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $7u6PA.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $9971e.default)(slots, (0, $fb1e7d0ac8fac824$export$2cf86a63a84fe23d), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$var$MenuPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $fbb3fa0cdc277971$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu" } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        classes: PopoverClasses,
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        PaperProps: (0, $8nd05.default)({
            component: $364f3db28d8d2e79$var$MenuPaper
        }, PaperProps, {
            classes: (0, $8nd05.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $1SA7b.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");





var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $9XEW1.default)("MuiDivider", slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $7u6PA.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $9XEW1.default)("MuiListItemIcon", slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $7u6PA.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $9XEW1.default)("MuiListItemText", slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $7u6PA.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $9XEW1.default)("MuiMenuItem", slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $7u6PA.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $1ac984bce84b2164$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex"
];
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $adff06ac3b11e066$export$515f8c67b5305377), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: theme.palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.palette.action.focus
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).disabled}`]: {
            opacity: theme.palette.action.disabledOpacity
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $8nd05.default)({
        minHeight: 32,
        // https://material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp } = props, other = (0, $1En50.default)(props, $1ac984bce84b2164$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = {
        dense: dense || context.dense || false,
        disableGutters: disableGutters
    };
    const menuItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, (0, $8nd05.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $1SA7b.default)(classes.focusVisible, focusVisibleClassName)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;


var $60313e3b9e75c852$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    return typeof indexedDB === "object";
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || "");
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


var $57d436074e210fb5$exports = {};

$parcel$export($57d436074e210fb5$exports, "_DEFAULT_ENTRY_NAME", () => $57d436074e210fb5$export$9f30fa0c10967f7f);
$parcel$export($57d436074e210fb5$exports, "_apps", () => $57d436074e210fb5$export$b4e3c36c855b14b5);
$parcel$export($57d436074e210fb5$exports, "_components", () => $57d436074e210fb5$export$9566bce3835c0f28);
$parcel$export($57d436074e210fb5$exports, "_addComponent", () => $57d436074e210fb5$export$fa5244b94c62d36a);
$parcel$export($57d436074e210fb5$exports, "_addOrOverwriteComponent", () => $57d436074e210fb5$export$4393112b42e2b41d);
$parcel$export($57d436074e210fb5$exports, "_registerComponent", () => $57d436074e210fb5$export$c930050e7bb63965);
$parcel$export($57d436074e210fb5$exports, "_getProvider", () => $57d436074e210fb5$export$fa0d6da0f5838f50);
$parcel$export($57d436074e210fb5$exports, "_removeServiceInstance", () => $57d436074e210fb5$export$48d18de2ff1c45a5);
$parcel$export($57d436074e210fb5$exports, "_clearComponents", () => $57d436074e210fb5$export$3685d89b9c3cdfaf);
$parcel$export($57d436074e210fb5$exports, "SDK_VERSION", () => $57d436074e210fb5$export$31499a9cd224b78c);
$parcel$export($57d436074e210fb5$exports, "initializeApp", () => $57d436074e210fb5$export$c55cfd413944906d);
$parcel$export($57d436074e210fb5$exports, "getApp", () => $57d436074e210fb5$export$f9962582c9e66d99);
$parcel$export($57d436074e210fb5$exports, "getApps", () => $57d436074e210fb5$export$68ddedf7d44b3bdf);
$parcel$export($57d436074e210fb5$exports, "deleteApp", () => $57d436074e210fb5$export$6eec44aa53d5ea34);
$parcel$export($57d436074e210fb5$exports, "registerVersion", () => $57d436074e210fb5$export$d29d5299a7137abc);
$parcel$export($57d436074e210fb5$exports, "onLog", () => $57d436074e210fb5$export$a82ad227dc8163dc);
$parcel$export($57d436074e210fb5$exports, "setLogLevel", () => $57d436074e210fb5$export$c622e99c0ce7b1c9);
$parcel$export($57d436074e210fb5$exports, "FirebaseError", () => $c38e0f42709c826a$export$dd24e9cd51226c56);

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    "debug": $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    "verbose": $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    "info": $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    "warn": $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    "error": $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    "silent": $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: "log",
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: "info",
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: "warn",
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === "function") return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $da032767b57a4aa4$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */ ;
}
const $57d436074e210fb5$var$name$o = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.7.26";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/app");
const $57d436074e210fb5$var$name$n = "@firebase/app-compat";
const $57d436074e210fb5$var$name$m = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$l = "@firebase/analytics";
const $57d436074e210fb5$var$name$k = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$j = "@firebase/app-check";
const $57d436074e210fb5$var$name$i = "@firebase/auth";
const $57d436074e210fb5$var$name$h = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$g = "@firebase/database";
const $57d436074e210fb5$var$name$f = "@firebase/database-compat";
const $57d436074e210fb5$var$name$e = "@firebase/functions";
const $57d436074e210fb5$var$name$d = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$c = "@firebase/installations";
const $57d436074e210fb5$var$name$b = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$a = "@firebase/messaging";
const $57d436074e210fb5$var$name$9 = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$8 = "@firebase/performance";
const $57d436074e210fb5$var$name$7 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$5 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$4 = "@firebase/storage";
const $57d436074e210fb5$var$name$3 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$2 = "@firebase/firestore";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "9.8.3";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = "[DEFAULT]";
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$o]: "fire-core",
    [$57d436074e210fb5$var$name$n]: "fire-core-compat",
    [$57d436074e210fb5$var$name$l]: "fire-analytics",
    [$57d436074e210fb5$var$name$m]: "fire-analytics-compat",
    [$57d436074e210fb5$var$name$j]: "fire-app-check",
    [$57d436074e210fb5$var$name$k]: "fire-app-check-compat",
    [$57d436074e210fb5$var$name$i]: "fire-auth",
    [$57d436074e210fb5$var$name$h]: "fire-auth-compat",
    [$57d436074e210fb5$var$name$g]: "fire-rtdb",
    [$57d436074e210fb5$var$name$f]: "fire-rtdb-compat",
    [$57d436074e210fb5$var$name$e]: "fire-fn",
    [$57d436074e210fb5$var$name$d]: "fire-fn-compat",
    [$57d436074e210fb5$var$name$c]: "fire-iid",
    [$57d436074e210fb5$var$name$b]: "fire-iid-compat",
    [$57d436074e210fb5$var$name$a]: "fire-fcm",
    [$57d436074e210fb5$var$name$9]: "fire-fcm-compat",
    [$57d436074e210fb5$var$name$8]: "fire-perf",
    [$57d436074e210fb5$var$name$7]: "fire-perf-compat",
    [$57d436074e210fb5$var$name$6]: "fire-rc",
    [$57d436074e210fb5$var$name$5]: "fire-rc-compat",
    [$57d436074e210fb5$var$name$4]: "fire-gcs",
    [$57d436074e210fb5$var$name$3]: "fire-gcs-compat",
    [$57d436074e210fb5$var$name$2]: "fire-fst",
    [$57d436074e210fb5$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$57d436074e210fb5$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* NO_APP */ ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
    ["bad-app-name" /* BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["storage-open" /* STORAGE_OPEN */ ]: "Error thrown when opening storage. Original error: {$originalErrorMessage}.",
    ["storage-get" /* STORAGE_GET */ ]: "Error thrown when reading from storage. Original error: {$originalErrorMessage}.",
    ["storage-set" /* STORAGE_WRITE */ ]: "Error thrown when writing to storage. Original error: {$originalErrorMessage}.",
    ["storage-delete" /* STORAGE_DELETE */ ]: "Error thrown when deleting from storage. Original error: {$originalErrorMessage}."
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("app", "Firebase", $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(options, rawConfig = {}) {
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */ , {
        appName: String(name)
    });
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(" "));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */ );
    (0, $45b460d9de9b230f$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $45b460d9de9b230f$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$DB_NAME = "firebase-heartbeat-database";
const $57d436074e210fb5$var$DB_VERSION = 1;
const $57d436074e210fb5$var$STORE_NAME = "firebase-heartbeat-store";
let $57d436074e210fb5$var$dbPromise = null;
function $57d436074e210fb5$var$getDbPromise() {
    if (!$57d436074e210fb5$var$dbPromise) $57d436074e210fb5$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($57d436074e210fb5$var$DB_NAME, $57d436074e210fb5$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($57d436074e210fb5$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("storage-open" /* STORAGE_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $57d436074e210fb5$var$dbPromise;
}
async function $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(app) {
    var _a;
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        return db.transaction($57d436074e210fb5$var$STORE_NAME).objectStore($57d436074e210fb5$var$STORE_NAME).get($57d436074e210fb5$var$computeKey(app));
    } catch (e) {
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("storage-get" /* STORAGE_GET */ , {
            originalErrorMessage: (_a = e) === null || _a === void 0 ? void 0 : _a.message
        });
    }
}
async function $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    var _a;
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($57d436074e210fb5$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $57d436074e210fb5$var$computeKey(app));
        return tx.done;
    } catch (e) {
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("storage-set" /* STORAGE_WRITE */ , {
            originalErrorMessage: (_a = e) === null || _a === void 0 ? void 0 : _a.message
        });
    }
}
function $57d436074e210fb5$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $57d436074e210fb5$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $57d436074e210fb5$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $57d436074e210fb5$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $57d436074e210fb5$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $57d436074e210fb5$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $c38e0f42709c826a$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $57d436074e210fb5$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $57d436074e210fb5$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $57d436074e210fb5$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $57d436074e210fb5$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
        else return (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $57d436074e210fb5$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $c38e0f42709c826a$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("platform-logger", (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* PRIVATE */ ));
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("heartbeat", (container)=>new $57d436074e210fb5$var$HeartbeatServiceImpl(container), "PRIVATE" /* PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents("");


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}




/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $8eace09cb4780ee7$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $8eace09cb4780ee7$export$ae1af26003f05816 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $8eace09cb4780ee7$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $8eace09cb4780ee7$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $8eace09cb4780ee7$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-multi-factor-info" /* MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."
    };
}
function $8eace09cb4780ee7$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8eace09cb4780ee7$export$ef35774e6d314e91 = $8eace09cb4780ee7$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $8eace09cb4780ee7$export$e7094788287c5e9b = $8eace09cb4780ee7$var$_prodErrorMap;
const $8eace09cb4780ee7$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", $8eace09cb4780ee7$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $8eace09cb4780ee7$export$96f57966bedc81b4 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/auth");
function $8eace09cb4780ee7$var$_logError(msg, ...args) {
    if ($8eace09cb4780ee7$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) $8eace09cb4780ee7$var$logClient.error(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$export$493d36ec626b6698(authOrCode, ...rest) {
    throw $8eace09cb4780ee7$var$createErrorInternal(authOrCode, ...rest);
}
function $8eace09cb4780ee7$export$92108d983e8ee699(authOrCode, ...rest) {
    return $8eace09cb4780ee7$var$createErrorInternal(authOrCode, ...rest);
}
function $8eace09cb4780ee7$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $8eace09cb4780ee7$export$e7094788287c5e9b()), {
        [code]: message
    });
    const factory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $8eace09cb4780ee7$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $8eace09cb4780ee7$export$493d36ec626b6698(auth, "argument-error" /* ARGUMENT_ERROR */ );
        throw $8eace09cb4780ee7$var$_errorWithCustomMessage(auth, "argument-error" /* ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $8eace09cb4780ee7$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $8eace09cb4780ee7$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $8eace09cb4780ee7$export$9fa96a7d116ea3ce(assertion, authOrCode, ...rest) {
    if (!assertion) throw $8eace09cb4780ee7$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $8eace09cb4780ee7$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $8eace09cb4780ee7$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $8eace09cb4780ee7$export$8a5498727ef6be21(assertion, message) {
    if (!assertion) $8eace09cb4780ee7$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$instanceCache = new Map();
function $8eace09cb4780ee7$export$28f7fcd39efa255(cls) {
    $8eace09cb4780ee7$export$8a5498727ef6be21(cls instanceof Function, "Expected a class definition");
    let instance = $8eace09cb4780ee7$var$instanceCache.get(cls);
    if (instance) {
        $8eace09cb4780ee7$export$8a5498727ef6be21(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $8eace09cb4780ee7$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $8eace09cb4780ee7$export$a9c23c6ac3fc3eca(app, deps) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $8eace09cb4780ee7$export$493d36ec626b6698(auth, "already-initialized" /* ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $8eace09cb4780ee7$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($8eace09cb4780ee7$export$28f7fcd39efa255);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $8eace09cb4780ee7$var$_isHttpOrHttps() {
    return $8eace09cb4780ee7$var$_getCurrentScheme() === "http:" || $8eace09cb4780ee7$var$_getCurrentScheme() === "https:";
}
function $8eace09cb4780ee7$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $8eace09cb4780ee7$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($8eace09cb4780ee7$var$_isHttpOrHttps() || (0, $c38e0f42709c826a$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $8eace09cb4780ee7$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $8eace09cb4780ee7$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $8eace09cb4780ee7$export$8a5498727ef6be21(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $c38e0f42709c826a$export$872f8323f01d7ae0)() || (0, $c38e0f42709c826a$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$8eace09cb4780ee7$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$_emulatorUrl(config, path) {
    $8eace09cb4780ee7$export$8a5498727ef6be21(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$export$23ebac1979863676 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        $8eace09cb4780ee7$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        $8eace09cb4780ee7$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        $8eace09cb4780ee7$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $8eace09cb4780ee7$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* INVALID_IDENTIFIER */ ]: "invalid-email" /* INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* MISSING_CONTINUE_URI */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* INVALID_PASSWORD */ ]: "wrong-password" /* INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* MISSING_PASSWORD */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* EMAIL_EXISTS */ ]: "email-already-in-use" /* EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* MISSING_REQ_TYPE */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* EMAIL_NOT_FOUND */ ]: "user-not-found" /* USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* EXPIRED_OOB_CODE */ ]: "expired-action-code" /* EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* INVALID_OOB_CODE */ ]: "invalid-action-code" /* INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* MISSING_OOB_CODE */ ]: "internal-error" /* INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* INVALID_ID_TOKEN */ ]: "invalid-user-token" /* INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* TOKEN_EXPIRED */ ]: "user-token-expired" /* TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */ ]: "user-token-expired" /* TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* INVALID_CODE */ ]: "invalid-verification-code" /* INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* MISSING_SESSION_INFO */ ]: "missing-verification-id" /* MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* SESSION_EXPIRED */ ]: "code-expired" /* CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* INTERNAL_ERROR */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$DEFAULT_API_TIMEOUT_MS = new $8eace09cb4780ee7$var$Delay(30000, 60000);
function $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $8eace09cb4780ee7$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $8eace09cb4780ee7$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $c38e0f42709c826a$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $8eace09cb4780ee7$export$23ebac1979863676.fetch()($8eace09cb4780ee7$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $8eace09cb4780ee7$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $8eace09cb4780ee7$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $8eace09cb4780ee7$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $8eace09cb4780ee7$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $8eace09cb4780ee7$var$_makeTaggedError(auth, "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* EMAIL_EXISTS */ ) throw $8eace09cb4780ee7$var$_makeTaggedError(auth, "email-already-in-use" /* EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* USER_DISABLED */ ) throw $8eace09cb4780ee7$var$_makeTaggedError(auth, "user-disabled" /* USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $8eace09cb4780ee7$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $8eace09cb4780ee7$export$493d36ec626b6698(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) throw e;
        $8eace09cb4780ee7$export$493d36ec626b6698(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ );
    }
}
async function $8eace09cb4780ee7$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $8eace09cb4780ee7$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $8eace09cb4780ee7$export$493d36ec626b6698(auth, "multi-factor-auth-required" /* MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $8eace09cb4780ee7$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $8eace09cb4780ee7$var$_emulatorUrl(auth.config, base);
}
class $8eace09cb4780ee7$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($8eace09cb4780ee7$export$92108d983e8ee699(this.auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            }, $8eace09cb4780ee7$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $8eace09cb4780ee7$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $8eace09cb4780ee7$export$92108d983e8ee699(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$deleteAccount(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:delete" /* DELETE_ACCOUNT */ , request);
}
async function $8eace09cb4780ee7$var$deleteLinkedAccounts(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
async function $8eace09cb4780ee7$var$getAccountInfo(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:lookup" /* GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $8eace09cb4780ee7$export$f38c853ae54ed474(user, forceRefresh = false) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identitfy the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$3b513254972cfc9c(user, forceRefresh = false) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $8eace09cb4780ee7$var$_parseToken(token);
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $8eace09cb4780ee7$var$utcTimestampToDateString($8eace09cb4780ee7$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $8eace09cb4780ee7$var$utcTimestampToDateString($8eace09cb4780ee7$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $8eace09cb4780ee7$var$utcTimestampToDateString($8eace09cb4780ee7$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $8eace09cb4780ee7$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $8eace09cb4780ee7$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $8eace09cb4780ee7$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $c38e0f42709c826a$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $8eace09cb4780ee7$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $8eace09cb4780ee7$var$_logError("Caught error parsing JWT payload as JSON", e);
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $8eace09cb4780ee7$var$_tokenExpiresIn(token) {
    const parsedToken = $8eace09cb4780ee7$var$_parseToken(token);
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(parsedToken, "internal-error" /* INTERNAL_ERROR */ );
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof parsedToken.exp !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof parsedToken.iat !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && $8eace09cb4780ee7$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $8eace09cb4780ee7$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e.code === `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $8eace09cb4780ee7$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $8eace09cb4780ee7$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $8eace09cb4780ee7$var$_logoutIfInvalidated(user, $8eace09cb4780ee7$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $8eace09cb4780ee7$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $8eace09cb4780ee7$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $8eace09cb4780ee7$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$1a82df3d29112e01(user) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $8eace09cb4780ee7$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $8eace09cb4780ee7$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $8eace09cb4780ee7$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$requestStsToken(auth, refreshToken) {
    const response = await $8eace09cb4780ee7$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $c38e0f42709c826a$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $8eace09cb4780ee7$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $8eace09cb4780ee7$export$23ebac1979863676.fetch()(url, {
            method: "POST" /* POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $8eace09cb4780ee7$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(response.idToken, "internal-error" /* INTERNAL_ERROR */ );
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof response.idToken !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof response.refreshToken !== "undefined", "internal-error" /* INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $8eace09cb4780ee7$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $8eace09cb4780ee7$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $8eace09cb4780ee7$var$StsTokenManager();
        if (refreshToken) {
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof refreshToken === "string", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof accessToken === "string", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof expirationTime === "number", "internal-error" /* INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $8eace09cb4780ee7$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $8eace09cb4780ee7$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$assertStringOrUndefined(assertion, appName) {
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $8eace09cb4780ee7$export$cf2f7c5792f80b46 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* FIREBASE */ ;
        this.proactiveRefresh = new $8eace09cb4780ee7$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $8eace09cb4780ee7$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $8eace09cb4780ee7$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(accessToken, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $8eace09cb4780ee7$export$3b513254972cfc9c(this, forceRefresh);
    }
    reload() {
        return $8eace09cb4780ee7$export$1a82df3d29112e01(this);
    }
    _assign(user) {
        if (this === user) return;
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this.uid === user.uid, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        return new $8eace09cb4780ee7$export$cf2f7c5792f80b46(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(!this.reloadListener, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $8eace09cb4780ee7$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $8eace09cb4780ee7$var$_logoutIfInvalidated(this, $8eace09cb4780ee7$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(uid && plainObjectTokenManager, auth, "internal-error" /* INTERNAL_ERROR */ );
        const stsTokenManager = $8eace09cb4780ee7$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof uid === "string", auth, "internal-error" /* INTERNAL_ERROR */ );
        $8eace09cb4780ee7$var$assertStringOrUndefined(displayName, auth.name);
        $8eace09cb4780ee7$var$assertStringOrUndefined(email, auth.name);
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof emailVerified === "boolean", auth, "internal-error" /* INTERNAL_ERROR */ );
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof isAnonymous === "boolean", auth, "internal-error" /* INTERNAL_ERROR */ );
        $8eace09cb4780ee7$var$assertStringOrUndefined(phoneNumber, auth.name);
        $8eace09cb4780ee7$var$assertStringOrUndefined(photoURL, auth.name);
        $8eace09cb4780ee7$var$assertStringOrUndefined(tenantId, auth.name);
        $8eace09cb4780ee7$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $8eace09cb4780ee7$var$assertStringOrUndefined(createdAt, auth.name);
        $8eace09cb4780ee7$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $8eace09cb4780ee7$export$cf2f7c5792f80b46({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $8eace09cb4780ee7$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $8eace09cb4780ee7$export$cf2f7c5792f80b46({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $8eace09cb4780ee7$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$8eace09cb4780ee7$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $8eace09cb4780ee7$export$61196ced6d74a310 = $8eace09cb4780ee7$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$export$3d12bd131bb975d1(key, apiKey, appName) {
    return `${"firebase" /* PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $8eace09cb4780ee7$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $8eace09cb4780ee7$export$3d12bd131bb975d1(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $8eace09cb4780ee7$export$3d12bd131bb975d1("persistence" /* PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $8eace09cb4780ee7$export$cf2f7c5792f80b46._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $8eace09cb4780ee7$var$PersistenceUserManager($8eace09cb4780ee7$export$28f7fcd39efa255($8eace09cb4780ee7$export$61196ced6d74a310), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $8eace09cb4780ee7$export$28f7fcd39efa255($8eace09cb4780ee7$export$61196ced6d74a310);
        const key = $8eace09cb4780ee7$export$3d12bd131bb975d1(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $8eace09cb4780ee7$export$cf2f7c5792f80b46._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $8eace09cb4780ee7$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $8eace09cb4780ee7$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $8eace09cb4780ee7$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* OPERA */ ;
    else if ($8eace09cb4780ee7$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* EDGE */ ;
    else if ($8eace09cb4780ee7$var$_isFirefox(ua)) return "Firefox" /* FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* SILK */ ;
    else if ($8eace09cb4780ee7$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BLACKBERRY */ ;
    else if ($8eace09cb4780ee7$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* WEBOS */ ;
    else if ($8eace09cb4780ee7$var$_isSafari(ua)) return "Safari" /* SAFARI */ ;
    else if ((ua.includes("chrome/") || $8eace09cb4780ee7$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* CHROME */ ;
    else if ($8eace09cb4780ee7$export$6554612db691658e(ua)) // Android stock browser.
    return "Android" /* ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* OTHER */ ;
}
function $8eace09cb4780ee7$var$_isFirefox(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $8eace09cb4780ee7$var$_isSafari(userAgent = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $8eace09cb4780ee7$var$_isChromeIOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $8eace09cb4780ee7$var$_isIEMobile(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $8eace09cb4780ee7$export$6554612db691658e(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $8eace09cb4780ee7$var$_isBlackBerry(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $8eace09cb4780ee7$var$_isWebOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $8eace09cb4780ee7$export$d24c54395ce0c509(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua);
}
function $8eace09cb4780ee7$export$2f6ca3d3b1f80bf5(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $8eace09cb4780ee7$var$_isIOSStandalone(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    var _a;
    return $8eace09cb4780ee7$export$d24c54395ce0c509(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $8eace09cb4780ee7$var$_isIE10() {
    return (0, $c38e0f42709c826a$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $8eace09cb4780ee7$var$_isMobileBrowser(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $8eace09cb4780ee7$export$d24c54395ce0c509(ua) || $8eace09cb4780ee7$export$6554612db691658e(ua) || $8eace09cb4780ee7$var$_isWebOS(ua) || $8eace09cb4780ee7$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $8eace09cb4780ee7$var$_isIEMobile(ua);
}
function $8eace09cb4780ee7$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $8eace09cb4780ee7$export$a33b77bbdbb8366c(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $8eace09cb4780ee7$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
            break;
        case "Worker" /* WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$8eace09cb4780ee7$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* CORE */ }/${0, $57d436074e210fb5$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        var _a;
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {}
            throw this.auth._errorFactory.create("login-blocked" /* LOGIN_BLOCKED */ , {
                originalMessage: (_a = e) === null || _a === void 0 ? void 0 : _a.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$export$53a70dd1ebbae346 {
    constructor(app, heartbeatServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $8eace09cb4780ee7$var$Subscription(this);
        this.idTokenSubscription = new $8eace09cb4780ee7$var$Subscription(this);
        this.beforeStateQueue = new $8eace09cb4780ee7$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $8eace09cb4780ee7$var$_DEFAULT_AUTH_ERROR_FACTORY;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $8eace09cb4780ee7$export$28f7fcd39efa255(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $8eace09cb4780ee7$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {}
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this._popupRedirectResolver, this, "argument-error" /* ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $8eace09cb4780ee7$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e.code !== `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $8eace09cb4780ee7$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $8eace09cb4780ee7$export$9fa96a7d116ea3ce(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($8eace09cb4780ee7$export$28f7fcd39efa255(persistence));
        });
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $8eace09cb4780ee7$export$28f7fcd39efa255(popupRedirectResolver) || this._popupRedirectResolver;
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(resolver, this, "argument-error" /* ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $8eace09cb4780ee7$var$PersistenceUserManager.create(this, [
                $8eace09cb4780ee7$export$28f7fcd39efa255(resolver._redirectPersistence)
            ], "redirectUser" /* REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(promise, this, "internal-error" /* INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>cb(this.currentUser));
        if (typeof nextOrObserver === "function") return subscription.addObserver(nextOrObserver, error, completed);
        else return subscription.addObserver(nextOrObserver);
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) {
            this._currentUser._stopProactiveRefresh();
            if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        }
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this.persistenceManager, this, "internal-error" /* INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $8eace09cb4780ee7$export$a33b77bbdbb8366c(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        return headers;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $8eace09cb4780ee7$export$158acd800e1ef08b(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $8eace09cb4780ee7$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $c38e0f42709c826a$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this.observer, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $8eace09cb4780ee7$export$2329c99376c9d0a4(auth, url, options) {
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* EMULATOR_CONFIG_FAILED */ );
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $8eace09cb4780ee7$var$extractProtocol(url);
    const { host: host, port: port } = $8eace09cb4780ee7$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $8eace09cb4780ee7$var$emitEmulatorWarning();
}
function $8eace09cb4780ee7$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $8eace09cb4780ee7$var$extractHostAndPort(url) {
    const protocol = $8eace09cb4780ee7$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $8eace09cb4780ee7$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $8eace09cb4780ee7$var$parsePort(port)
        };
    }
}
function $8eace09cb4780ee7$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $8eace09cb4780ee7$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8eace09cb4780ee7$export$7f8ddf7c7c20b3cd {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $8eace09cb4780ee7$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $8eace09cb4780ee7$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $8eace09cb4780ee7$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $8eace09cb4780ee7$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$resetPassword(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:resetPassword" /* RESET_PASSWORD */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
async function $8eace09cb4780ee7$var$updateEmailPassword(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
async function $8eace09cb4780ee7$var$applyActionCode$1(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$signInWithPassword(auth, request) {
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPassword" /* SIGN_IN_WITH_PASSWORD */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
async function $8eace09cb4780ee7$var$sendOobCode(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:sendOobCode" /* SEND_OOB_CODE */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
async function $8eace09cb4780ee7$var$sendEmailVerification$1(auth, request) {
    return $8eace09cb4780ee7$var$sendOobCode(auth, request);
}
async function $8eace09cb4780ee7$var$sendPasswordResetEmail$1(auth, request) {
    return $8eace09cb4780ee7$var$sendOobCode(auth, request);
}
async function $8eace09cb4780ee7$var$sendSignInLinkToEmail$1(auth, request) {
    return $8eace09cb4780ee7$var$sendOobCode(auth, request);
}
async function $8eace09cb4780ee7$var$verifyAndChangeEmail(auth, request) {
    return $8eace09cb4780ee7$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$signInWithEmailLink$1(auth, request) {
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
async function $8eace09cb4780ee7$var$signInWithEmailLinkForLinking(auth, request) {
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $8eace09cb4780ee7$export$9bb611d729802a56 extends $8eace09cb4780ee7$export$7f8ddf7c7c20b3cd {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $8eace09cb4780ee7$export$9bb611d729802a56(email, password, "password" /* EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $8eace09cb4780ee7$export$9bb611d729802a56(email, oobCode, "emailLink" /* EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* EMAIL_PASSWORD */ :
                return $8eace09cb4780ee7$var$signInWithPassword(auth, {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */ :
                return $8eace09cb4780ee7$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8eace09cb4780ee7$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* EMAIL_PASSWORD */ :
                return $8eace09cb4780ee7$var$updateEmailPassword(auth, {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */ :
                return $8eace09cb4780ee7$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $8eace09cb4780ee7$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$signInWithIdp(auth, request) {
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithIdp" /* SIGN_IN_WITH_IDP */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $8eace09cb4780ee7$export$b4171a6734a65d42 extends $8eace09cb4780ee7$export$7f8ddf7c7c20b3cd {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $8eace09cb4780ee7$export$b4171a6734a65d42(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $8eace09cb4780ee7$export$493d36ec626b6698("argument-error" /* ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $8eace09cb4780ee7$export$b4171a6734a65d42(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8eace09cb4780ee7$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8eace09cb4780ee7$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8eace09cb4780ee7$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $8eace09cb4780ee7$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $c38e0f42709c826a$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$sendPhoneVerificationCode(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:sendVerificationCode" /* SEND_VERIFICATION_CODE */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
async function $8eace09cb4780ee7$var$signInWithPhoneNumber$1(auth, request) {
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
async function $8eace09cb4780ee7$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $8eace09cb4780ee7$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */ , response);
    return response;
}
const $8eace09cb4780ee7$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */ ]: "user-not-found" /* USER_DELETED */ 
};
async function $8eace09cb4780ee7$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, apiRequest), $8eace09cb4780ee7$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $8eace09cb4780ee7$export$3466f893ebf79586 extends $8eace09cb4780ee7$export$7f8ddf7c7c20b3cd {
    constructor(params){
        super("phone" /* PHONE */ , "phone" /* PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $8eace09cb4780ee7$export$3466f893ebf79586({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $8eace09cb4780ee7$export$3466f893ebf79586({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $8eace09cb4780ee7$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $8eace09cb4780ee7$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $8eace09cb4780ee7$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $8eace09cb4780ee7$export$3466f893ebf79586({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $8eace09cb4780ee7$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $8eace09cb4780ee7$var$parseDeepLink(url) {
    const link = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $8eace09cb4780ee7$export$4c3d22f3d993c33f {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $8eace09cb4780ee7$var$parseMode((_c = searchParams["mode" /* MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(apiKey && code && operation, "argument-error" /* ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $8eace09cb4780ee7$var$parseDeepLink(link);
        try {
            return new $8eace09cb4780ee7$export$4c3d22f3d993c33f(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $8eace09cb4780ee7$export$f787f51d84a910ad(link) {
    return $8eace09cb4780ee7$export$4c3d22f3d993c33f.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $8eace09cb4780ee7$export$3a1a48c8f6ef640e {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $8eace09cb4780ee7$export$3a1a48c8f6ef640e.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $8eace09cb4780ee7$export$9bb611d729802a56._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $8eace09cb4780ee7$export$4c3d22f3d993c33f.parseLink(emailLink);
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(actionCodeUrl, "argument-error" /* ARGUMENT_ERROR */ );
        return $8eace09cb4780ee7$export$9bb611d729802a56._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $8eace09cb4780ee7$export$3a1a48c8f6ef640e.PROVIDER_ID = "password" /* PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $8eace09cb4780ee7$export$3a1a48c8f6ef640e.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $8eace09cb4780ee7$export$3a1a48c8f6ef640e.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $8eace09cb4780ee7$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $8eace09cb4780ee7$var$BaseOAuthProvider extends $8eace09cb4780ee7$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8eace09cb4780ee7$export$3a6d5c9ae78a2c08 extends $8eace09cb4780ee7$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce("providerId" in obj && "signInMethod" in obj, "argument-error" /* ARGUMENT_ERROR */ );
        return $8eace09cb4780ee7$export$b4171a6734a65d42._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(params.idToken || params.accessToken, "argument-error" /* ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $8eace09cb4780ee7$export$b4171a6734a65d42._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8eace09cb4780ee7$export$3a6d5c9ae78a2c08.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8eace09cb4780ee7$export$3a6d5c9ae78a2c08.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $8eace09cb4780ee7$export$3a6d5c9ae78a2c08(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8eace09cb4780ee7$export$a07804094c3ecf2d extends $8eace09cb4780ee7$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $8eace09cb4780ee7$export$b4171a6734a65d42._fromParams({
            providerId: $8eace09cb4780ee7$export$a07804094c3ecf2d.PROVIDER_ID,
            signInMethod: $8eace09cb4780ee7$export$a07804094c3ecf2d.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8eace09cb4780ee7$export$a07804094c3ecf2d.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8eace09cb4780ee7$export$a07804094c3ecf2d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8eace09cb4780ee7$export$a07804094c3ecf2d.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $8eace09cb4780ee7$export$a07804094c3ecf2d.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $8eace09cb4780ee7$export$a07804094c3ecf2d.PROVIDER_ID = "facebook.com" /* FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $8eace09cb4780ee7$export$3722cfe417b6ed86 extends $8eace09cb4780ee7$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $8eace09cb4780ee7$export$b4171a6734a65d42._fromParams({
            providerId: $8eace09cb4780ee7$export$3722cfe417b6ed86.PROVIDER_ID,
            signInMethod: $8eace09cb4780ee7$export$3722cfe417b6ed86.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8eace09cb4780ee7$export$3722cfe417b6ed86.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8eace09cb4780ee7$export$3722cfe417b6ed86.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $8eace09cb4780ee7$export$3722cfe417b6ed86.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $8eace09cb4780ee7$export$3722cfe417b6ed86.GOOGLE_SIGN_IN_METHOD = "google.com" /* GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $8eace09cb4780ee7$export$3722cfe417b6ed86.PROVIDER_ID = "google.com" /* GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $8eace09cb4780ee7$export$971d5caa766a69d7 extends $8eace09cb4780ee7$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $8eace09cb4780ee7$export$b4171a6734a65d42._fromParams({
            providerId: $8eace09cb4780ee7$export$971d5caa766a69d7.PROVIDER_ID,
            signInMethod: $8eace09cb4780ee7$export$971d5caa766a69d7.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8eace09cb4780ee7$export$971d5caa766a69d7.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8eace09cb4780ee7$export$971d5caa766a69d7.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $8eace09cb4780ee7$export$971d5caa766a69d7.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $8eace09cb4780ee7$export$971d5caa766a69d7.GITHUB_SIGN_IN_METHOD = "github.com" /* GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $8eace09cb4780ee7$export$971d5caa766a69d7.PROVIDER_ID = "github.com" /* GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $8eace09cb4780ee7$export$91477dc880baac21 extends $8eace09cb4780ee7$export$7f8ddf7c7c20b3cd {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $8eace09cb4780ee7$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $8eace09cb4780ee7$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $8eace09cb4780ee7$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $8eace09cb4780ee7$export$91477dc880baac21(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $8eace09cb4780ee7$export$91477dc880baac21(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $8eace09cb4780ee7$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $8eace09cb4780ee7$export$e7c866399fa523f5 extends $8eace09cb4780ee7$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(providerId.startsWith($8eace09cb4780ee7$var$SAML_PROVIDER_PREFIX), "argument-error" /* ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8eace09cb4780ee7$export$e7c866399fa523f5.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8eace09cb4780ee7$export$e7c866399fa523f5.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $8eace09cb4780ee7$export$91477dc880baac21.fromJSON(json);
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(credential, "argument-error" /* ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $8eace09cb4780ee7$export$91477dc880baac21._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $8eace09cb4780ee7$export$71cec2538cb2c617 extends $8eace09cb4780ee7$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $8eace09cb4780ee7$export$b4171a6734a65d42._fromParams({
            providerId: $8eace09cb4780ee7$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $8eace09cb4780ee7$export$71cec2538cb2c617.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $8eace09cb4780ee7$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $8eace09cb4780ee7$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $8eace09cb4780ee7$export$71cec2538cb2c617.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $8eace09cb4780ee7$export$71cec2538cb2c617.TWITTER_SIGN_IN_METHOD = "twitter.com" /* TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $8eace09cb4780ee7$export$71cec2538cb2c617.PROVIDER_ID = "twitter.com" /* TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$signUp(auth, request) {
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signUp" /* SIGN_UP */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $8eace09cb4780ee7$export$cf2f7c5792f80b46._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $8eace09cb4780ee7$var$providerIdForResponse(idTokenResponse);
        const userCred = new $8eace09cb4780ee7$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $8eace09cb4780ee7$var$providerIdForResponse(response);
        return new $8eace09cb4780ee7$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $8eace09cb4780ee7$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$78acf4525d8a74c4(auth) {
    var _a;
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $8eace09cb4780ee7$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* SIGN_IN */ 
    });
    const response = await $8eace09cb4780ee7$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $8eace09cb4780ee7$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$MultiFactorError extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $8eace09cb4780ee7$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $8eace09cb4780ee7$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $8eace09cb4780ee7$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* MFA_REQUIRED */ }`) throw $8eace09cb4780ee7$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $8eace09cb4780ee7$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$21579262ef46735b(user, providerId) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $8eace09cb4780ee7$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $8eace09cb4780ee7$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $8eace09cb4780ee7$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $8eace09cb4780ee7$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $8eace09cb4780ee7$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $8eace09cb4780ee7$var$UserCredentialImpl._forOperation(user, "link" /* LINK */ , response);
}
async function $8eace09cb4780ee7$var$_assertLinkedStatus(expected, user, provider) {
    await $8eace09cb4780ee7$var$_reloadWithoutSaving(user);
    const providerIds = $8eace09cb4780ee7$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* NO_SUCH_PROVIDER */ ;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* REAUTHENTICATE */ ;
    try {
        const response = await $8eace09cb4780ee7$var$_logoutIfInvalidated(user, $8eace09cb4780ee7$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(response.idToken, auth, "internal-error" /* INTERNAL_ERROR */ );
        const parsed = $8eace09cb4780ee7$var$_parseToken(response.idToken);
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(parsed, auth, "internal-error" /* INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(user.uid === localId, auth, "user-mismatch" /* USER_MISMATCH */ );
        return $8eace09cb4780ee7$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* USER_DELETED */ }`) $8eace09cb4780ee7$export$493d36ec626b6698(auth, "user-mismatch" /* USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* SIGN_IN */ ;
    const response = await $8eace09cb4780ee7$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $8eace09cb4780ee7$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$8743009a87fcb00f(auth, credential) {
    return $8eace09cb4780ee7$var$_signInWithCredential($8eace09cb4780ee7$export$158acd800e1ef08b(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$dc98b0b04f4c7758(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $8eace09cb4780ee7$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $8eace09cb4780ee7$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$71511d61b312f219(user, credential) {
    return $8eace09cb4780ee7$var$_reauthenticate((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$signInWithCustomToken$1(auth, request) {
    return $8eace09cb4780ee7$var$_performSignInRequest(auth, "POST" /* POST */ , "/v1/accounts:signInWithCustomToken" /* SIGN_IN_WITH_CUSTOM_TOKEN */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$3d8c2f653ac9d0b9(auth, customToken) {
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    const response = await $8eace09cb4780ee7$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $8eace09cb4780ee7$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $8eace09cb4780ee7$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $8eace09cb4780ee7$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
    }
}
class $8eace09cb4780ee7$var$PhoneMultiFactorInfoImpl extends $8eace09cb4780ee7$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $8eace09cb4780ee7$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* INVALID_CONTINUE_URI */ );
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$34aec0b863436764(auth, email, actionCodeSettings) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* PASSWORD_RESET */ ,
        email: email
    };
    if (actionCodeSettings) $8eace09cb4780ee7$var$_setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    await $8eace09cb4780ee7$var$sendPasswordResetEmail$1(authModular, request);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$3c2fa207a37baaea(auth, oobCode, newPassword) {
    await $8eace09cb4780ee7$var$resetPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$ce26c07117d59d6a(auth, oobCode) {
    await $8eace09cb4780ee7$var$applyActionCode$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$6559d589eb85fbb6(auth, oobCode) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const response = await $8eace09cb4780ee7$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(operation, authModular, "internal-error" /* INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ :
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(response.newEmail, authModular, "internal-error" /* INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */ :
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(response.mfaInfo, authModular, "internal-error" /* INTERNAL_ERROR */ );
        // fall through
        default:
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(response.email, authModular, "internal-error" /* INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $8eace09cb4780ee7$var$MultiFactorInfoImpl._fromServerResponse($8eace09cb4780ee7$export$158acd800e1ef08b(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$efca4cbe5dd06740(auth, code) {
    const { data: data } = await $8eace09cb4780ee7$export$6559d589eb85fbb6((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$a8550f7dbe79f93a(auth, email, password) {
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    const response = await $8eace09cb4780ee7$var$signUp(authInternal, {
        returnSecureToken: true,
        email: email,
        password: password
    });
    const userCredential = await $8eace09cb4780ee7$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $8eace09cb4780ee7$export$2e2af4578d910ddf(auth, email, password) {
    return $8eace09cb4780ee7$export$8743009a87fcb00f((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), $8eace09cb4780ee7$export$3a1a48c8f6ef640e.credential(email, password));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$a93c5207d687da10(auth, email, actionCodeSettings) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ,
        email: email
    };
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(actionCodeSettings.handleCodeInApp, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    if (actionCodeSettings) $8eace09cb4780ee7$var$_setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    await $8eace09cb4780ee7$var$sendSignInLinkToEmail$1(authModular, request);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $8eace09cb4780ee7$export$c3950d9923825c02(auth, emailLink) {
    const actionCodeUrl = $8eace09cb4780ee7$export$4c3d22f3d993c33f.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$a9c996f45e5784d0(auth, email, emailLink) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const credential = $8eace09cb4780ee7$export$3a1a48c8f6ef640e.credentialWithLink(email, emailLink || $8eace09cb4780ee7$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */ );
    return $8eace09cb4780ee7$export$8743009a87fcb00f(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$createAuthUri(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:createAuthUri" /* CREATE_AUTH_URI */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$7910e0436ed8d1de(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $8eace09cb4780ee7$var$_isHttpOrHttps() ? $8eace09cb4780ee7$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $8eace09cb4780ee7$var$createAuthUri((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$555508cbc6add439(user, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $8eace09cb4780ee7$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $8eace09cb4780ee7$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$2219238a014317b0(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $8eace09cb4780ee7$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $8eace09cb4780ee7$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$updateProfile$1(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v1/accounts:update" /* SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$c9170ad7d4cd7e57(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $8eace09cb4780ee7$var$_logoutIfInvalidated(userInternal, $8eace09cb4780ee7$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $8eace09cb4780ee7$export$ee7c8ad385a60b7b(user, newEmail) {
    return $8eace09cb4780ee7$var$updateEmailOrPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $8eace09cb4780ee7$export$995eb9fca571757(user, newPassword) {
    return $8eace09cb4780ee7$var$updateEmailOrPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $8eace09cb4780ee7$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $8eace09cb4780ee7$var$_logoutIfInvalidated(user, $8eace09cb4780ee7$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $8eace09cb4780ee7$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $8eace09cb4780ee7$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ANONYMOUS */  && signInProvider !== "custom" /* CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $8eace09cb4780ee7$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* FACEBOOK */ :
            return new $8eace09cb4780ee7$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* GITHUB */ :
            return new $8eace09cb4780ee7$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* GOOGLE */ :
            return new $8eace09cb4780ee7$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* TWITTER */ :
            return new $8eace09cb4780ee7$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* CUSTOM */ :
        case "anonymous" /* ANONYMOUS */ :
            return new $8eace09cb4780ee7$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $8eace09cb4780ee7$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $8eace09cb4780ee7$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $8eace09cb4780ee7$var$FederatedAdditionalUserInfoWithUsername extends $8eace09cb4780ee7$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $8eace09cb4780ee7$var$FacebookAdditionalUserInfo extends $8eace09cb4780ee7$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* FACEBOOK */ , profile);
    }
}
class $8eace09cb4780ee7$var$GithubAdditionalUserInfo extends $8eace09cb4780ee7$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $8eace09cb4780ee7$var$GoogleAdditionalUserInfo extends $8eace09cb4780ee7$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* GOOGLE */ , profile);
    }
}
class $8eace09cb4780ee7$var$TwitterAdditionalUserInfo extends $8eace09cb4780ee7$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $8eace09cb4780ee7$export$ab83b03e4111b1d0(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $8eace09cb4780ee7$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $8eace09cb4780ee7$export$ffb5f4729a158638(auth, persistence) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8eace09cb4780ee7$export$9e5f44173e64f162(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $8eace09cb4780ee7$export$625550452a3fa3ec(auth, callback, onAbort) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $8eace09cb4780ee7$export$90a7f3efeed30595(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8eace09cb4780ee7$export$efccba1c4a2ef57b(auth) {
    (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $8eace09cb4780ee7$export$d141bba7fdc215a3(auth, user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $8eace09cb4780ee7$export$4a5767248b18ef41(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$df995fae86a55f06(user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).delete();
}
class $8eace09cb4780ee7$var$MultiFactorSessionImpl {
    constructor(type, credential){
        this.type = type;
        this.credential = credential;
    }
    static _fromIdtoken(idToken) {
        return new $8eace09cb4780ee7$var$MultiFactorSessionImpl("enroll" /* ENROLL */ , idToken);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $8eace09cb4780ee7$var$MultiFactorSessionImpl("signin" /* SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $8eace09cb4780ee7$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $8eace09cb4780ee7$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $8eace09cb4780ee7$export$158acd800e1ef08b(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$8eace09cb4780ee7$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(serverResponse.mfaPendingCredential, auth, "internal-error" /* INTERNAL_ERROR */ );
        const session = $8eace09cb4780ee7$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $8eace09cb4780ee7$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* SIGN_IN */ :
                    const userCredential = await $8eace09cb4780ee7$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* REAUTHENTICATE */ :
                    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(error.user, auth, "internal-error" /* INTERNAL_ERROR */ );
                    return $8eace09cb4780ee7$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $8eace09cb4780ee7$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $8eace09cb4780ee7$export$306ddfe3a8403e2(auth, error) {
    var _a;
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(error.customData.operationType, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* ARGUMENT_ERROR */ );
    return $8eace09cb4780ee7$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$startEnrollPhoneMfa(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:start" /* START_PHONE_MFA_ENROLLMENT */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
function $8eace09cb4780ee7$var$finalizeEnrollPhoneMfa(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:finalize" /* FINALIZE_PHONE_MFA_ENROLLMENT */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
function $8eace09cb4780ee7$var$withdrawMfa(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* WITHDRAW_MFA */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
class $8eace09cb4780ee7$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$8eace09cb4780ee7$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $8eace09cb4780ee7$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $8eace09cb4780ee7$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken());
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $8eace09cb4780ee7$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        const idTokenResponse = await $8eace09cb4780ee7$var$_logoutIfInvalidated(this.user, $8eace09cb4780ee7$var$withdrawMfa(this.user.auth, {
            idToken: idToken,
            mfaEnrollmentId: mfaEnrollmentId
        }));
        // Remove the second factor from the user's list.
        this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
        // Depending on whether the backend decided to revoke the user's session,
        // the tokenResponse may be empty. If the tokens were not updated (and they
        // are now invalid), reloading the user will discover this and invalidate
        // the user's state accordingly.
        await this.user._updateTokensIfNecessary(idTokenResponse);
        try {
            await this.user.reload();
        } catch (e) {
            if (e.code !== `auth/${"user-token-expired" /* TOKEN_EXPIRED */ }`) throw e;
        }
    }
}
const $8eace09cb4780ee7$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $8eace09cb4780ee7$export$7a38258bbe170828(user) {
    const userModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if (!$8eace09cb4780ee7$var$multiFactorUserCache.has(userModular)) $8eace09cb4780ee7$var$multiFactorUserCache.set(userModular, $8eace09cb4780ee7$var$MultiFactorUserImpl._fromUser(userModular));
    return $8eace09cb4780ee7$var$multiFactorUserCache.get(userModular);
}
const $8eace09cb4780ee7$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $8eace09cb4780ee7$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($8eace09cb4780ee7$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($8eace09cb4780ee7$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)();
    return $8eace09cb4780ee7$var$_isSafari(ua) || $8eace09cb4780ee7$export$d24c54395ce0c509(ua);
}
// The polling period in case events are not supported
const $8eace09cb4780ee7$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $8eace09cb4780ee7$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $8eace09cb4780ee7$var$BrowserLocalPersistence extends $8eace09cb4780ee7$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $8eace09cb4780ee7$var$_iframeCannotSyncWebStorage() && $8eace09cb4780ee7$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $8eace09cb4780ee7$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($8eace09cb4780ee7$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $8eace09cb4780ee7$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $8eace09cb4780ee7$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$8eace09cb4780ee7$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8eace09cb4780ee7$export$8b22cf2602fb60ce = $8eace09cb4780ee7$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$BrowserSessionPersistence extends $8eace09cb4780ee7$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$8eace09cb4780ee7$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $8eace09cb4780ee7$export$407448d2b89b1813 = $8eace09cb4780ee7$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $8eace09cb4780ee7$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $8eace09cb4780ee7$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $8eace09cb4780ee7$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $8eace09cb4780ee7$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$8eace09cb4780ee7$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$export$b9a6b53f9be3734(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $8eace09cb4780ee7$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $8eace09cb4780ee7$export$b9a6b53f9be3734("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* TIMEOUT */ ));
                            }, 3000 /* COMPLETION */ );
                            break;
                        case "done" /* DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $8eace09cb4780ee7$var$_window() {
    return window;
}
function $8eace09cb4780ee7$var$_setWindowLocation(url) {
    $8eace09cb4780ee7$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$_isWorker() {
    return typeof $8eace09cb4780ee7$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $8eace09cb4780ee7$var$_window()["importScripts"] === "function";
}
async function $8eace09cb4780ee7$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $8eace09cb4780ee7$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $8eace09cb4780ee7$var$_getWorkerGlobalScope() {
    return $8eace09cb4780ee7$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$DB_NAME = "firebaseLocalStorageDb";
const $8eace09cb4780ee7$var$DB_VERSION = 1;
const $8eace09cb4780ee7$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $8eace09cb4780ee7$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $8eace09cb4780ee7$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $8eace09cb4780ee7$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $8eace09cb4780ee7$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($8eace09cb4780ee7$var$DB_OBJECTSTORE_NAME);
}
function $8eace09cb4780ee7$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($8eace09cb4780ee7$var$DB_NAME);
    return new $8eace09cb4780ee7$var$DBPromise(request).toPromise();
}
function $8eace09cb4780ee7$var$_openDatabase() {
    const request = indexedDB.open($8eace09cb4780ee7$var$DB_NAME, $8eace09cb4780ee7$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($8eace09cb4780ee7$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $8eace09cb4780ee7$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($8eace09cb4780ee7$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $8eace09cb4780ee7$var$_deleteDatabase();
                resolve(await $8eace09cb4780ee7$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $8eace09cb4780ee7$var$_putObject(db, key, value) {
    const request = $8eace09cb4780ee7$var$getObjectStore(db, true).put({
        [$8eace09cb4780ee7$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $8eace09cb4780ee7$var$DBPromise(request).toPromise();
}
async function $8eace09cb4780ee7$var$getObject(db, key) {
    const request = $8eace09cb4780ee7$var$getObjectStore(db, false).get(key);
    const data = await new $8eace09cb4780ee7$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $8eace09cb4780ee7$var$_deleteObject(db, key) {
    const request = $8eace09cb4780ee7$var$getObjectStore(db, true).delete(key);
    return new $8eace09cb4780ee7$var$DBPromise(request).toPromise();
}
const $8eace09cb4780ee7$var$_POLLING_INTERVAL_MS = 800;
const $8eace09cb4780ee7$var$_TRANSACTION_RETRY_COUNT = 3;
class $8eace09cb4780ee7$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $8eace09cb4780ee7$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $8eace09cb4780ee7$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $8eace09cb4780ee7$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $8eace09cb4780ee7$var$Receiver._getInstance($8eace09cb4780ee7$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $8eace09cb4780ee7$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $8eace09cb4780ee7$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* PING */ , {}, 800 /* LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $8eace09cb4780ee7$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* LONG_ACK */  : 50 /* ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $8eace09cb4780ee7$var$_openDatabase();
            await $8eace09cb4780ee7$var$_putObject(db, $8eace09cb4780ee7$var$STORAGE_AVAILABLE_KEY, "1");
            await $8eace09cb4780ee7$var$_deleteObject(db, $8eace09cb4780ee7$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8eace09cb4780ee7$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$8eace09cb4780ee7$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$8eace09cb4780ee7$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $8eace09cb4780ee7$var$getObjectStore(db, false).getAll();
            return new $8eace09cb4780ee7$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $8eace09cb4780ee7$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$8eace09cb4780ee7$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $8eace09cb4780ee7$export$23f2a1d2818174ef = $8eace09cb4780ee7$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$startSignInPhoneMfa(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaSignIn:start" /* START_PHONE_MFA_SIGN_IN */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
function $8eace09cb4780ee7$var$finalizeSignInPhoneMfa(auth, request) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "POST" /* POST */ , "/v2/accounts/mfaSignIn:finalize" /* FINALIZE_PHONE_MFA_SIGN_IN */ , $8eace09cb4780ee7$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$var$getRecaptchaParams(auth) {
    return (await $8eace09cb4780ee7$var$_performApiRequest(auth, "GET" /* GET */ , "/v1/recaptchaParams" /* GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $8eace09cb4780ee7$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $8eace09cb4780ee7$export$92108d983e8ee699("internal-error" /* INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $8eace09cb4780ee7$var$getScriptParentElement().appendChild(el);
    });
}
function $8eace09cb4780ee7$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$_SOLVE_TIME_MS = 500;
const $8eace09cb4780ee7$var$_EXPIRATION_TIME_MS = 60000;
const $8eace09cb4780ee7$var$_WIDGET_ID_START = 1000000000000;
class $8eace09cb4780ee7$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $8eace09cb4780ee7$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $8eace09cb4780ee7$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $8eace09cb4780ee7$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $8eace09cb4780ee7$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $8eace09cb4780ee7$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $8eace09cb4780ee7$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(container, "argument-error" /* ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $8eace09cb4780ee7$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $8eace09cb4780ee7$var$_EXPIRATION_TIME_MS);
        }, $8eace09cb4780ee7$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $8eace09cb4780ee7$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $8eace09cb4780ee7$var$_JSLOAD_CALLBACK = $8eace09cb4780ee7$var$_generateCallbackName("rcb");
const $8eace09cb4780ee7$var$NETWORK_TIMEOUT_DELAY = new $8eace09cb4780ee7$var$Delay(30000, 60000);
const $8eace09cb4780ee7$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $8eace09cb4780ee7$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = "";
        this.counter = 0;
        this.librarySeparatelyLoaded = !!$8eace09cb4780ee7$var$_window().grecaptcha;
    }
    load(auth, hl = "") {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce($8eace09cb4780ee7$var$isHostLanguageValid(hl), auth, "argument-error" /* ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl)) return Promise.resolve($8eace09cb4780ee7$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $8eace09cb4780ee7$var$_window().setTimeout(()=>{
                reject($8eace09cb4780ee7$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            }, $8eace09cb4780ee7$var$NETWORK_TIMEOUT_DELAY.get());
            $8eace09cb4780ee7$var$_window()[$8eace09cb4780ee7$var$_JSLOAD_CALLBACK] = ()=>{
                $8eace09cb4780ee7$var$_window().clearTimeout(networkTimeout);
                delete $8eace09cb4780ee7$var$_window()[$8eace09cb4780ee7$var$_JSLOAD_CALLBACK];
                const recaptcha = $8eace09cb4780ee7$var$_window().grecaptcha;
                if (!recaptcha) {
                    reject($8eace09cb4780ee7$export$92108d983e8ee699(auth, "internal-error" /* INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$8eace09cb4780ee7$var$RECAPTCHA_BASE}?${(0, $c38e0f42709c826a$export$ac4103b836844853)({
                onload: $8eace09cb4780ee7$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $8eace09cb4780ee7$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($8eace09cb4780ee7$export$92108d983e8ee699(auth, "internal-error" /* INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$8eace09cb4780ee7$var$_window().grecaptcha && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $8eace09cb4780ee7$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $8eace09cb4780ee7$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $8eace09cb4780ee7$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $8eace09cb4780ee7$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @public
 */ class $8eace09cb4780ee7$export$db202ddc8be9136 {
    /**
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @remarks
     * If none is provided, the default Firebase {@link Auth} instance is used. A Firebase {@link Auth} instance
     * must be initialized with an API key, otherwise an error will be thrown.
     */ constructor(containerOrId, parameters = Object.assign({}, $8eace09cb4780ee7$var$DEFAULT_PARAMS), authExtern){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $8eace09cb4780ee7$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $8eace09cb4780ee7$export$158acd800e1ef08b(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(container, this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $8eace09cb4780ee7$var$MockReCaptchaLoaderImpl() : new $8eace09cb4780ee7$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(!this.parameters.sitekey, this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* ARGUMENT_ERROR */ );
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $8eace09cb4780ee7$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(!this.destroyed, this.auth, "internal-error" /* INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce($8eace09cb4780ee7$var$_isHttpOrHttps() && !$8eace09cb4780ee7$var$_isWorker(), this.auth, "internal-error" /* INTERNAL_ERROR */ );
        await $8eace09cb4780ee7$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $8eace09cb4780ee7$var$getRecaptchaParams(this.auth);
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(siteKey, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this.recaptcha, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $8eace09cb4780ee7$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $8eace09cb4780ee7$export$3466f893ebf79586._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    const verificationId = await $8eace09cb4780ee7$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $8eace09cb4780ee7$var$ConfirmationResultImpl(verificationId, (cred)=>$8eace09cb4780ee7$export$8743009a87fcb00f(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $8eace09cb4780ee7$var$_assertLinkedStatus(false, userInternal, "phone" /* PHONE */ );
    const verificationId = await $8eace09cb4780ee7$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $8eace09cb4780ee7$var$ConfirmationResultImpl(verificationId, (cred)=>$8eace09cb4780ee7$export$dc98b0b04f4c7758(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const verificationId = await $8eace09cb4780ee7$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $8eace09cb4780ee7$var$ConfirmationResultImpl(verificationId, (cred)=>$8eace09cb4780ee7$export$71511d61b312f219(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $8eace09cb4780ee7$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(typeof recaptchaToken === "string", auth, "argument-error" /* ARGUMENT_ERROR */ );
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(verifier.type === $8eace09cb4780ee7$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $8eace09cb4780ee7$export$9fa96a7d116ea3ce(session.type === "enroll" /* ENROLL */ , auth, "internal-error" /* INTERNAL_ERROR */ );
                const response = await $8eace09cb4780ee7$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $8eace09cb4780ee7$export$9fa96a7d116ea3ce(session.type === "signin" /* SIGN_IN */ , auth, "internal-error" /* INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $8eace09cb4780ee7$export$9fa96a7d116ea3ce(mfaEnrollmentId, auth, "missing-multi-factor-info" /* MISSING_MFA_INFO */ );
                const response = await $8eace09cb4780ee7$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $8eace09cb4780ee7$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$3b14a55fb2447963(user, credential) {
    await $8eace09cb4780ee7$var$_link$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $8eace09cb4780ee7$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $8eace09cb4780ee7$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $8eace09cb4780ee7$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $8eace09cb4780ee7$export$3466f893ebf79586._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $8eace09cb4780ee7$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if (e.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $8eace09cb4780ee7$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $8eace09cb4780ee7$export$3466f893ebf79586._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $8eace09cb4780ee7$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $8eace09cb4780ee7$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $8eace09cb4780ee7$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $8eace09cb4780ee7$export$28f7fcd39efa255(resolverOverride);
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(auth._popupRedirectResolver, auth, "argument-error" /* ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$IdpCredential extends $8eace09cb4780ee7$export$7f8ddf7c7c20b3cd {
    constructor(params){
        super("custom" /* CUSTOM */ , "custom" /* CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $8eace09cb4780ee7$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $8eace09cb4780ee7$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $8eace09cb4780ee7$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $8eace09cb4780ee7$var$_signIn(params) {
    return $8eace09cb4780ee7$var$_signInWithCredential(params.auth, new $8eace09cb4780ee7$var$IdpCredential(params), params.bypassAuthState);
}
function $8eace09cb4780ee7$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(user, auth, "internal-error" /* INTERNAL_ERROR */ );
    return $8eace09cb4780ee7$var$_reauthenticate(user, new $8eace09cb4780ee7$var$IdpCredential(params), params.bypassAuthState);
}
async function $8eace09cb4780ee7$var$_link(params) {
    const { auth: auth, user: user } = params;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(user, auth, "internal-error" /* INTERNAL_ERROR */ );
    return $8eace09cb4780ee7$var$_link$1(user, new $8eace09cb4780ee7$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $8eace09cb4780ee7$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ :
                return $8eace09cb4780ee7$var$_signIn;
            case "linkViaPopup" /* LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* LINK_VIA_REDIRECT */ :
                return $8eace09cb4780ee7$var$_link;
            case "reauthViaPopup" /* REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ :
                return $8eace09cb4780ee7$var$_reauth;
            default:
                $8eace09cb4780ee7$export$493d36ec626b6698(this.auth, "internal-error" /* INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $8eace09cb4780ee7$export$8a5498727ef6be21(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $8eace09cb4780ee7$export$8a5498727ef6be21(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $8eace09cb4780ee7$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ async function $8eace09cb4780ee7$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    $8eace09cb4780ee7$var$_assertInstanceOf(auth, provider, $8eace09cb4780ee7$var$FederatedAuthProvider);
    const resolverInternal = $8eace09cb4780ee7$var$_withDefaultResolver(authInternal, resolver);
    const action = new $8eace09cb4780ee7$var$PopupOperation(authInternal, "signInViaPopup" /* SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $8eace09cb4780ee7$var$_assertInstanceOf(userInternal.auth, provider, $8eace09cb4780ee7$var$FederatedAuthProvider);
    const resolverInternal = $8eace09cb4780ee7$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8eace09cb4780ee7$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $8eace09cb4780ee7$var$_assertInstanceOf(userInternal.auth, provider, $8eace09cb4780ee7$var$FederatedAuthProvider);
    const resolverInternal = $8eace09cb4780ee7$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $8eace09cb4780ee7$var$PopupOperation(userInternal.auth, "linkViaPopup" /* LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $8eace09cb4780ee7$var$PopupOperation extends $8eace09cb4780ee7$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($8eace09cb4780ee7$var$PopupOperation.currentPopupAction) $8eace09cb4780ee7$var$PopupOperation.currentPopupAction.cancel();
        $8eace09cb4780ee7$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(result, this.auth, "internal-error" /* INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $8eace09cb4780ee7$export$8a5498727ef6be21(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $8eace09cb4780ee7$export$b9a6b53f9be3734();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($8eace09cb4780ee7$export$92108d983e8ee699(this.auth, "web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($8eace09cb4780ee7$export$92108d983e8ee699(this.auth, "cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $8eace09cb4780ee7$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($8eace09cb4780ee7$export$92108d983e8ee699(this.auth, "popup-closed-by-user" /* POPUP_CLOSED_BY_USER */ ));
                }, 2000 /* AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $8eace09cb4780ee7$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$8eace09cb4780ee7$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $8eace09cb4780ee7$var$redirectOutcomeMap = new Map();
class $8eace09cb4780ee7$var$RedirectAction extends $8eace09cb4780ee7$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ ,
            "unknown" /* UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $8eace09cb4780ee7$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $8eace09cb4780ee7$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $8eace09cb4780ee7$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $8eace09cb4780ee7$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $8eace09cb4780ee7$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $8eace09cb4780ee7$var$pendingRedirectKey(auth);
    const persistence = $8eace09cb4780ee7$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $8eace09cb4780ee7$var$_setPendingRedirectStatus(resolver, auth) {
    return $8eace09cb4780ee7$var$resolverPersistence(resolver)._set($8eace09cb4780ee7$var$pendingRedirectKey(auth), "true");
}
function $8eace09cb4780ee7$export$24baa2b76016ce0e() {
    $8eace09cb4780ee7$var$redirectOutcomeMap.clear();
}
function $8eace09cb4780ee7$export$890c4ad488842ce7(auth, result) {
    $8eace09cb4780ee7$var$redirectOutcomeMap.set(auth._key(), result);
}
function $8eace09cb4780ee7$var$resolverPersistence(resolver) {
    return $8eace09cb4780ee7$export$28f7fcd39efa255(resolver._redirectPersistence);
}
function $8eace09cb4780ee7$var$pendingRedirectKey(auth) {
    return $8eace09cb4780ee7$export$3d12bd131bb975d1($8eace09cb4780ee7$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8eace09cb4780ee7$export$2d1720544b23b823(auth, provider, resolver) {
    return $8eace09cb4780ee7$var$_signInWithRedirect(auth, provider, resolver);
}
async function $8eace09cb4780ee7$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    $8eace09cb4780ee7$var$_assertInstanceOf(auth, provider, $8eace09cb4780ee7$var$FederatedAuthProvider);
    const resolverInternal = $8eace09cb4780ee7$var$_withDefaultResolver(authInternal, resolver);
    await $8eace09cb4780ee7$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Link using a redirect.
 * await linkWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $8eace09cb4780ee7$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $8eace09cb4780ee7$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $8eace09cb4780ee7$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $8eace09cb4780ee7$var$_assertInstanceOf(userInternal.auth, provider, $8eace09cb4780ee7$var$FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8eace09cb4780ee7$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8eace09cb4780ee7$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8eace09cb4780ee7$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */ function $8eace09cb4780ee7$export$39b482c5e57630a8(user, provider, resolver) {
    return $8eace09cb4780ee7$var$_linkWithRedirect(user, provider, resolver);
}
async function $8eace09cb4780ee7$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $8eace09cb4780ee7$var$_assertInstanceOf(userInternal.auth, provider, $8eace09cb4780ee7$var$FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $8eace09cb4780ee7$var$_withDefaultResolver(userInternal.auth, resolver);
    await $8eace09cb4780ee7$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $8eace09cb4780ee7$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $8eace09cb4780ee7$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns a {@link UserCredential}
 * with a null `user`.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $8eace09cb4780ee7$export$35e795649ee09318(auth, resolver) {
    await $8eace09cb4780ee7$export$158acd800e1ef08b(auth)._initializationPromise;
    return $8eace09cb4780ee7$export$9d398bebfec1c039(auth, resolver, false);
}
async function $8eace09cb4780ee7$export$9d398bebfec1c039(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $8eace09cb4780ee7$export$158acd800e1ef08b(auth);
    const resolver = $8eace09cb4780ee7$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $8eace09cb4780ee7$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $8eace09cb4780ee7$var$prepareUserForRedirect(user) {
    const eventId = $8eace09cb4780ee7$export$b9a6b53f9be3734(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $8eace09cb4780ee7$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $8eace09cb4780ee7$export$91c6e00c14e7e6fd {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$8eace09cb4780ee7$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$8eace09cb4780ee7$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* INTERNAL_ERROR */ ;
            consumer.onError($8eace09cb4780ee7$export$92108d983e8ee699(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $8eace09cb4780ee7$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($8eace09cb4780ee7$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($8eace09cb4780ee7$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $8eace09cb4780ee7$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $8eace09cb4780ee7$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* NO_AUTH_EVENT */ }`;
}
function $8eace09cb4780ee7$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* UNKNOWN */ :
            return $8eace09cb4780ee7$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $8eace09cb4780ee7$export$d66dc83d8cfc8dd(auth, request = {}) {
    return $8eace09cb4780ee7$var$_performApiRequest(auth, "GET" /* GET */ , "/v1/projects" /* GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $8eace09cb4780ee7$var$HTTP_REGEX = /^https?/;
async function $8eace09cb4780ee7$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $8eace09cb4780ee7$export$d66dc83d8cfc8dd(auth);
    for (const domain of authorizedDomains)try {
        if ($8eace09cb4780ee7$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $8eace09cb4780ee7$export$493d36ec626b6698(auth, "unauthorized-domain" /* INVALID_ORIGIN */ );
}
function $8eace09cb4780ee7$var$matchDomain(expected) {
    const currentUrl = $8eace09cb4780ee7$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$8eace09cb4780ee7$var$HTTP_REGEX.test(protocol)) return false;
    if ($8eace09cb4780ee7$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$NETWORK_TIMEOUT = new $8eace09cb4780ee7$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $8eace09cb4780ee7$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $8eace09cb4780ee7$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $8eace09cb4780ee7$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $8eace09cb4780ee7$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $8eace09cb4780ee7$var$resetUnloadedGapiModules();
                    reject($8eace09cb4780ee7$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $8eace09cb4780ee7$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $8eace09cb4780ee7$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $8eace09cb4780ee7$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $8eace09cb4780ee7$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $8eace09cb4780ee7$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($8eace09cb4780ee7$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $8eace09cb4780ee7$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $8eace09cb4780ee7$var$cachedGApiLoader = null;
        throw error;
    });
}
let $8eace09cb4780ee7$var$cachedGApiLoader = null;
function $8eace09cb4780ee7$var$_loadGapi(auth) {
    $8eace09cb4780ee7$var$cachedGApiLoader = $8eace09cb4780ee7$var$cachedGApiLoader || $8eace09cb4780ee7$var$loadGapi(auth);
    return $8eace09cb4780ee7$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$PING_TIMEOUT = new $8eace09cb4780ee7$var$Delay(5000, 15000);
const $8eace09cb4780ee7$var$IFRAME_PATH = "__/auth/iframe";
const $8eace09cb4780ee7$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $8eace09cb4780ee7$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $8eace09cb4780ee7$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $8eace09cb4780ee7$var$getIframeUrl(auth) {
    const config = auth.config;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $8eace09cb4780ee7$var$_emulatorUrl(config, $8eace09cb4780ee7$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$8eace09cb4780ee7$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c)
    };
    const eid = $8eace09cb4780ee7$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(params).slice(1)}`;
}
async function $8eace09cb4780ee7$var$_openIframe(auth) {
    const context = await $8eace09cb4780ee7$var$_loadGapi(auth);
    const gapi1 = $8eace09cb4780ee7$var$_window().gapi;
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(gapi1, auth, "internal-error" /* INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $8eace09cb4780ee7$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $8eace09cb4780ee7$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $8eace09cb4780ee7$export$92108d983e8ee699(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $8eace09cb4780ee7$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $8eace09cb4780ee7$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $8eace09cb4780ee7$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8eace09cb4780ee7$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $8eace09cb4780ee7$var$DEFAULT_WIDTH = 500;
const $8eace09cb4780ee7$var$DEFAULT_HEIGHT = 600;
const $8eace09cb4780ee7$var$TARGET_BLANK = "_blank";
const $8eace09cb4780ee7$var$FIREFOX_EMPTY_URL = "http://localhost";
class $8eace09cb4780ee7$export$a05254e7c3aeba6e {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $8eace09cb4780ee7$var$_open(auth, url, name, width = $8eace09cb4780ee7$var$DEFAULT_WIDTH, height = $8eace09cb4780ee7$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $8eace09cb4780ee7$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $8eace09cb4780ee7$var$_isChromeIOS(ua) ? $8eace09cb4780ee7$var$TARGET_BLANK : name;
    if ($8eace09cb4780ee7$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $8eace09cb4780ee7$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($8eace09cb4780ee7$var$_isIOSStandalone(ua) && target !== "_self") {
        $8eace09cb4780ee7$var$openAsNewWindowIOS(url || "", target);
        return new $8eace09cb4780ee7$export$a05254e7c3aeba6e(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(newWin, auth, "popup-blocked" /* POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $8eace09cb4780ee7$export$a05254e7c3aeba6e(newWin);
}
function $8eace09cb4780ee7$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $8eace09cb4780ee7$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $8eace09cb4780ee7$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
function $8eace09cb4780ee7$export$1fbe638ecf81657e(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(auth.config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */ );
    $8eace09cb4780ee7$export$9fa96a7d116ea3ce(auth.config.apiKey, auth, "invalid-api-key" /* INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $8eace09cb4780ee7$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $8eace09cb4780ee7$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    return `${$8eace09cb4780ee7$var$getHandlerBase(auth)}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(paramsDict).slice(1)}`;
}
function $8eace09cb4780ee7$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$8eace09cb4780ee7$var$WIDGET_PATH}`;
    return $8eace09cb4780ee7$var$_emulatorUrl(config, $8eace09cb4780ee7$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $8eace09cb4780ee7$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $8eace09cb4780ee7$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $8eace09cb4780ee7$export$407448d2b89b1813;
        this._completeRedirectFn = $8eace09cb4780ee7$export$9d398bebfec1c039;
        this._overrideRedirectResult = $8eace09cb4780ee7$export$890c4ad488842ce7;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $8eace09cb4780ee7$export$8a5498727ef6be21((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = $8eace09cb4780ee7$export$1fbe638ecf81657e(auth, provider, authType, $8eace09cb4780ee7$var$_getCurrentUrl(), eventId);
        return $8eace09cb4780ee7$var$_open(auth, url, $8eace09cb4780ee7$export$b9a6b53f9be3734());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        $8eace09cb4780ee7$var$_setWindowLocation($8eace09cb4780ee7$export$1fbe638ecf81657e(auth, provider, authType, $8eace09cb4780ee7$var$_getCurrentUrl(), eventId));
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $8eace09cb4780ee7$export$8a5498727ef6be21(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $8eace09cb4780ee7$var$_openIframe(auth);
        const manager = new $8eace09cb4780ee7$export$91c6e00c14e7e6fd(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* ACK */  : "ERROR" /* ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($8eace09cb4780ee7$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $8eace09cb4780ee7$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$8eace09cb4780ee7$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $8eace09cb4780ee7$export$493d36ec626b6698(auth, "internal-error" /* INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $8eace09cb4780ee7$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $8eace09cb4780ee7$var$_isMobileBrowser() || $8eace09cb4780ee7$var$_isSafari() || $8eace09cb4780ee7$export$d24c54395ce0c509();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @public
 */ const $8eace09cb4780ee7$export$342063e11d6c3cad = $8eace09cb4780ee7$var$BrowserPopupRedirectResolver;
class $8eace09cb4780ee7$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $8eace09cb4780ee7$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $8eace09cb4780ee7$var$PhoneMultiFactorAssertionImpl extends $8eace09cb4780ee7$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $8eace09cb4780ee7$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $8eace09cb4780ee7$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $8eace09cb4780ee7$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $8eace09cb4780ee7$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $8eace09cb4780ee7$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $8eace09cb4780ee7$export$953cecd6e717a553.FACTOR_ID = "phone";
var $8eace09cb4780ee7$var$name = "@firebase/auth";
var $8eace09cb4780ee7$var$version = "0.20.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8eace09cb4780ee7$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            var _a;
            listener(((_a = user) === null || _a === void 0 ? void 0 : _a.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $8eace09cb4780ee7$export$9fa96a7d116ea3ce(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8eace09cb4780ee7$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* NODE */ :
            return "node";
        case "ReactNative" /* REACT_NATIVE */ :
            return "rn";
        case "Worker" /* WORKER */ :
            return "webworker";
        case "Cordova" /* CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $8eace09cb4780ee7$var$registerAuth(clientPlatform) {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth" /* AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        return ((app, heartbeatServiceProvider)=>{
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(apiKey && !apiKey.includes(":"), "invalid-api-key" /* INVALID_API_KEY */ , {
                appName: app.name
            });
            // Auth domain is optional if IdP sign in isn't being used
            $8eace09cb4780ee7$export$9fa96a7d116ea3ce(!(authDomain === null || authDomain === void 0 ? void 0 : authDomain.includes(":")), "argument-error" /* ARGUMENT_ERROR */ , {
                appName: app.name
            });
            const config = {
                apiKey: apiKey,
                authDomain: authDomain,
                clientPlatform: clientPlatform,
                apiHost: "identitytoolkit.googleapis.com" /* API_HOST */ ,
                tokenApiHost: "securetoken.googleapis.com" /* TOKEN_API_HOST */ ,
                apiScheme: "https" /* API_SCHEME */ ,
                sdkClientVersion: $8eace09cb4780ee7$export$a33b77bbdbb8366c(clientPlatform)
            };
            const authInstance = new $8eace09cb4780ee7$export$53a70dd1ebbae346(app, heartbeatServiceProvider, config);
            $8eace09cb4780ee7$var$_initializeAuthInstance(authInstance, deps);
            return authInstance;
        })(app, heartbeatServiceProvider);
    }, "PUBLIC" /* PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth-internal" /* AUTH_INTERNAL */ , (container)=>{
        const auth = $8eace09cb4780ee7$export$158acd800e1ef08b(container.getProvider("auth" /* AUTH */ ).getImmediate());
        return ((auth)=>new $8eace09cb4780ee7$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* PRIVATE */ ).setInstantiationMode("EXPLICIT" /* EXPLICIT */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($8eace09cb4780ee7$var$name, $8eace09cb4780ee7$var$version, $8eace09cb4780ee7$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($8eace09cb4780ee7$var$name, $8eace09cb4780ee7$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $8eace09cb4780ee7$export$7ccc53e8f1e7dfc5(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    return $8eace09cb4780ee7$export$a9c23c6ac3fc3eca(app, {
        popupRedirectResolver: $8eace09cb4780ee7$export$342063e11d6c3cad,
        persistence: [
            $8eace09cb4780ee7$export$23f2a1d2818174ef,
            $8eace09cb4780ee7$export$8b22cf2602fb60ce,
            $8eace09cb4780ee7$export$407448d2b89b1813
        ]
    });
}
$8eace09cb4780ee7$var$registerAuth("Browser" /* BROWSER */ );











var $3ecb7368762fc268$exports = {};

$parcel$export($3ecb7368762fc268$exports, "extract", () => $3ecb7368762fc268$export$f9380c9a627682d3, (v) => $3ecb7368762fc268$export$f9380c9a627682d3 = v);
$parcel$export($3ecb7368762fc268$exports, "parse", () => $3ecb7368762fc268$export$98e6a39c04603d36, (v) => $3ecb7368762fc268$export$98e6a39c04603d36 = v);
$parcel$export($3ecb7368762fc268$exports, "stringify", () => $3ecb7368762fc268$export$fac44ee5b035f737, (v) => $3ecb7368762fc268$export$fac44ee5b035f737 = v);
$parcel$export($3ecb7368762fc268$exports, "parseUrl", () => $3ecb7368762fc268$export$7a5253c0f62e0150, (v) => $3ecb7368762fc268$export$7a5253c0f62e0150 = v);
$parcel$export($3ecb7368762fc268$exports, "stringifyUrl", () => $3ecb7368762fc268$export$a8c1621ea79325d3, (v) => $3ecb7368762fc268$export$a8c1621ea79325d3 = v);
$parcel$export($3ecb7368762fc268$exports, "pick", () => $3ecb7368762fc268$export$357523c63a2253b9, (v) => $3ecb7368762fc268$export$357523c63a2253b9 = v);
$parcel$export($3ecb7368762fc268$exports, "exclude", () => $3ecb7368762fc268$export$44c361b8ec72ef7f, (v) => $3ecb7368762fc268$export$44c361b8ec72ef7f = v);
var $3ecb7368762fc268$export$f9380c9a627682d3;
var $3ecb7368762fc268$export$98e6a39c04603d36;
var $3ecb7368762fc268$export$fac44ee5b035f737;
var $3ecb7368762fc268$export$7a5253c0f62e0150;
var $3ecb7368762fc268$export$a8c1621ea79325d3;
var $3ecb7368762fc268$export$357523c63a2253b9;
var $3ecb7368762fc268$export$44c361b8ec72ef7f;
"use strict";
var $2854ab6fe5249e91$exports = {};
"use strict";
$2854ab6fe5249e91$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $40bbc24beab9f9b8$exports = {};
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp($40bbc24beab9f9b8$var$token, "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return decodeURIComponent(components.join(""));
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher);
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher);
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$40bbc24beab9f9b8$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};


var $08bd16383ca1ef3d$exports = {};
"use strict";
$08bd16383ca1ef3d$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $fd2084d3c9772587$exports = {};
"use strict";
$fd2084d3c9772587$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $3ecb7368762fc268$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $3ecb7368762fc268$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            $3ecb7368762fc268$var$encode(index, options),
                            "]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $3ecb7368762fc268$var$encode(key, options),
                                keyValueSep,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $3ecb7368762fc268$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $3ecb7368762fc268$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $3ecb7368762fc268$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3ecb7368762fc268$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options)) : value === null ? value : $3ecb7368762fc268$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $3ecb7368762fc268$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ecb7368762fc268$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $3ecb7368762fc268$var$encode(value, options) {
    if (options.encode) return options.strict ? $2854ab6fe5249e91$exports(value) : encodeURIComponent(value);
    return value;
}
function $3ecb7368762fc268$var$decode(value, options) {
    if (options.decode) return $40bbc24beab9f9b8$exports(value);
    return value;
}
function $3ecb7368762fc268$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $3ecb7368762fc268$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3ecb7368762fc268$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3ecb7368762fc268$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3ecb7368762fc268$var$extract(input) {
    input = $3ecb7368762fc268$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $3ecb7368762fc268$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $3ecb7368762fc268$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3ecb7368762fc268$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $08bd16383ca1ef3d$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $3ecb7368762fc268$var$decode(value, options);
        formatter($3ecb7368762fc268$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $3ecb7368762fc268$var$parseValue(value[k], options);
        else ret[key] = $3ecb7368762fc268$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3ecb7368762fc268$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3ecb7368762fc268$export$f9380c9a627682d3 = $3ecb7368762fc268$var$extract;
$3ecb7368762fc268$export$98e6a39c04603d36 = $3ecb7368762fc268$var$parse;
$3ecb7368762fc268$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3ecb7368762fc268$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $3ecb7368762fc268$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $3ecb7368762fc268$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $3ecb7368762fc268$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $3ecb7368762fc268$var$encode(key, options) + "=" + $3ecb7368762fc268$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$3ecb7368762fc268$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $08bd16383ca1ef3d$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $3ecb7368762fc268$var$parse($3ecb7368762fc268$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3ecb7368762fc268$var$decode(hash, options)
    } : {});
};
$3ecb7368762fc268$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $3ecb7368762fc268$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $3ecb7368762fc268$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3ecb7368762fc268$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3ecb7368762fc268$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3ecb7368762fc268$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$3ecb7368762fc268$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$3ecb7368762fc268$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3ecb7368762fc268$export$7a5253c0f62e0150(input, options);
    return $3ecb7368762fc268$export$a8c1621ea79325d3({
        url: url,
        query: $fd2084d3c9772587$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3ecb7368762fc268$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3ecb7368762fc268$export$357523c63a2253b9(input, exclusionFilter, options);
};



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $bf919e292c78caff$export$f8d08dc2abc73598(slot) {
    return (0, $9XEW1.default)("MuiContainer", slot);
}
const $bf919e292c78caff$var$containerClasses = (0, $7u6PA.default)("MuiContainer", [
    "root",
    "disableGutters",
    "fixed",
    "maxWidthXs",
    "maxWidthSm",
    "maxWidthMd",
    "maxWidthLg",
    "maxWidthXl"
]);
var $bf919e292c78caff$export$2e2bcd8739ae039 = $bf919e292c78caff$var$containerClasses;



var $jTnBY = parcelRequire("jTnBY");

var $ayMG0 = parcelRequire("ayMG0");
const $2291beb327d500f8$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth"
];
const $2291beb327d500f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $9971e.default)(slots, (0, $bf919e292c78caff$export$f8d08dc2abc73598), classes);
};
const $2291beb327d500f8$var$ContainerRoot = (0, $d8seH.default)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        width: "100%",
        marginLeft: "auto",
        boxSizing: "border-box",
        marginRight: "auto",
        display: "block"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
        const value = theme.breakpoints.values[breakpoint];
        if (value !== 0) acc[theme.breakpoints.up(breakpoint)] = {
            maxWidth: `${value}${theme.breakpoints.unit}`
        };
        return acc;
    }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.maxWidth === "xs" && {
        [theme.breakpoints.up("xs")]: {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444)
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        [theme.breakpoints.up(ownerState.maxWidth)]: {
            maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
        }
    }));
const $2291beb327d500f8$var$Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiContainer"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = "lg" } = props, other = (0, $1En50.default)(props, $2291beb327d500f8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        fixed: fixed,
        maxWidth: maxWidth
    });
    const classes = $2291beb327d500f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2291beb327d500f8$var$ContainerRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other));
});
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $10469897db0fb9cc$var$Flex({ className: className, children: children, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: style,
        className: className,
        children: children
    });
}
var $10469897db0fb9cc$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($10469897db0fb9cc$var$Flex).attrs({
    className: $10469897db0fb9cc$var$Flex.name
})`
  display: flex;
  flex-direction: ${(props)=>props.column ? "column" : "row"};
  align-items: ${(props)=>props.align ? "center" : "start"};
  ${({ tall: tall })=>tall && `height: 100%`};
  ${({ wide: wide })=>wide && "width: 100%"};
  ${({ wrap: wrap })=>wrap && "flex-wrap: wrap"};
  ${({ start: start })=>start && "justify-content: flex-start"};
  ${({ end: end })=>end && "justify-content: flex-end"};
  ${({ between: between })=>between && "justify-content: space-between"};
  ${({ center: center })=>center && "justify-content: center"};
  ${({ around: around })=>around && "justify-content: space-around"};
`;



function $89e98e2acd277cd3$var$Page(props) {
    if (props.loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                align: true,
                between: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: props.title
                    }),
                    props.actions
                ]
            }),
            props.children
        ]
    });
}
var $89e98e2acd277cd3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($89e98e2acd277cd3$var$Page).attrs({
    className: $89e98e2acd277cd3$var$Page.name
})`
  margin: 0 auto;
  width: 100%;
  max-width: 1024px;

  nav {
    padding: 0 !important;
    padding-bottom: 16px;
  }
`;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $8zogs = parcelRequire("8zogs");

var $jTnBY = parcelRequire("jTnBY");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $9XEW1.default)("MuiCircularProgress", slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $7u6PA.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $19b4ac261663afa8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $19b4ac261663afa8$var$_ = (t)=>t, $19b4ac261663afa8$var$_t, $19b4ac261663afa8$var$_t2, $19b4ac261663afa8$var$_t3, $19b4ac261663afa8$var$_t4;
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $8zogs.keyframes)($19b4ac261663afa8$var$_t || ($19b4ac261663afa8$var$_t = $19b4ac261663afa8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $8zogs.keyframes)($19b4ac261663afa8$var$_t2 || ($19b4ac261663afa8$var$_t2 = $19b4ac261663afa8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $9971e.default)(slots, (0, $b86eb8364bb4993c$export$29cad1383b3f235d), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: theme.palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $8zogs.css)($19b4ac261663afa8$var$_t3 || ($19b4ac261663afa8$var$_t3 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $19b4ac261663afa8$var$circularRotateKeyframe));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $8zogs.css)($19b4ac261663afa8$var$_t4 || ($19b4ac261663afa8$var$_t4 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $19b4ac261663afa8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $1En50.default)(props, $19b4ac261663afa8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;



function $049080dc6d82c9d7$var$LoadingPage() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            center: true,
            align: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {})
        })
    });
}
var $049080dc6d82c9d7$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($049080dc6d82c9d7$var$LoadingPage)``;


var $91a9098e14452db2$export$193e4cdf5c5b208;
(function(Coalition) {
    Coalition["Red"] = "red";
    Coalition["Blue"] = "blue";
    Coalition["Neutrals"] = "neutrals";
})($91a9098e14452db2$export$193e4cdf5c5b208 || ($91a9098e14452db2$export$193e4cdf5c5b208 = {}));
var $91a9098e14452db2$export$325098d3a9c3b991;
(function(WaypointType) {
    WaypointType["TakeOff"] = "TakeOff";
    WaypointType["TakeoffParking"] = "TakeOffParking";
    WaypointType["TurningPoint"] = "Turning Point";
})($91a9098e14452db2$export$325098d3a9c3b991 || ($91a9098e14452db2$export$325098d3a9c3b991 = {}));
var $91a9098e14452db2$export$cd15daf6ba4f571c;
(function(UnitCategory) {
    UnitCategory["Plane"] = "plane";
    UnitCategory["Helicopter"] = "helicopter";
    UnitCategory["Vehicle"] = "vehicle";
    UnitCategory["Ship"] = "ship";
    UnitCategory["Static"] = "static";
})($91a9098e14452db2$export$cd15daf6ba4f571c || ($91a9098e14452db2$export$cd15daf6ba4f571c = {}));
var $91a9098e14452db2$export$4b3b082d0b2e2996;
(function(AltitudeType) {
    AltitudeType["AGL"] = "RADIO";
    AltitudeType["MSL"] = "BARO";
})($91a9098e14452db2$export$4b3b082d0b2e2996 || ($91a9098e14452db2$export$4b3b082d0b2e2996 = {}));
var $91a9098e14452db2$export$b851e513e23ef23b;
(function(WaypointAction) {
    WaypointAction["FromParkingArea"] = "From Parking Area";
    WaypointAction["TurningPoint"] = "Turning Point";
})($91a9098e14452db2$export$b851e513e23ef23b || ($91a9098e14452db2$export$b851e513e23ef23b = {}));
var $91a9098e14452db2$export$459e66e1d1ce05ca;
(function(DCSRadioModulation) {
    DCSRadioModulation[DCSRadioModulation["AM"] = 0] = "AM";
    DCSRadioModulation[DCSRadioModulation["FM"] = 1] = "FM";
})($91a9098e14452db2$export$459e66e1d1ce05ca || ($91a9098e14452db2$export$459e66e1d1ce05ca = {}));
var $91a9098e14452db2$export$307b49132840b0da;
(function(AirbaseType) {
    AirbaseType["Airfield"] = "airfield";
    AirbaseType["Carrier"] = "carrier";
    AirbaseType["FARP"] = "farp";
    AirbaseType["LHA"] = "lha";
})($91a9098e14452db2$export$307b49132840b0da || ($91a9098e14452db2$export$307b49132840b0da = {}));
var $91a9098e14452db2$export$36336b2cf50fd5df;
(function(ZoneType) {
    ZoneType[ZoneType["Circle"] = 0] = "Circle";
    ZoneType[ZoneType["Quad"] = 2] = "Quad";
})($91a9098e14452db2$export$36336b2cf50fd5df || ($91a9098e14452db2$export$36336b2cf50fd5df = {}));
var $91a9098e14452db2$export$37d3279522fbf5e2;
(function(AppRoutes) {
    AppRoutes["Home"] = "/";
    AppRoutes["NewFragOrder"] = "/new_frag_order";
    AppRoutes["FragOrderDetail"] = "/frag_order_detail";
    AppRoutes["PreviewFragOrder"] = "/preview_frag_order";
    AppRoutes["PlanningTemplates"] = "/planning_templates";
    AppRoutes["MyFragOrders"] = "/my_frag_orders";
    AppRoutes["Login"] = "/login";
    AppRoutes["Signup"] = "/signup";
    AppRoutes["Logout"] = "/logout";
    AppRoutes["PublicFragOrder"] = "/public_frag_order";
    AppRoutes["EditFragOrder"] = "/edit_frag_order";
    AppRoutes["BatchOperations"] = "/batch_operations";
    AppRoutes["DiscordOauth"] = "/oauth/discord";
    AppRoutes["UserSettings"] = "/settings";
    AppRoutes["Payment"] = "/payment";
    AppRoutes["StripeCallback"] = "/stripe/callback";
    AppRoutes["SuperAdmin"] = "/__super_admin__";
    AppRoutes["StandaloneSignupsPage"] = "/signups";
    AppRoutes["RedeemCode"] = "/redeem_code";
})($91a9098e14452db2$export$37d3279522fbf5e2 || ($91a9098e14452db2$export$37d3279522fbf5e2 = {}));
var $91a9098e14452db2$export$381ac33b868f60a4;
(function(FreqBand) {
    FreqBand["UHF"] = "UHF";
    FreqBand["VHF"] = "VHF";
    FreqBand["VHF_FM"] = "VHF_FM";
    FreqBand["HF"] = "HF";
})($91a9098e14452db2$export$381ac33b868f60a4 || ($91a9098e14452db2$export$381ac33b868f60a4 = {}));
const $91a9098e14452db2$export$a31389e164b90234 = 0.000539957;
var $91a9098e14452db2$export$b89d56b50e08a256;
(function(DCSDrawingPrimitive) {
    DCSDrawingPrimitive["Line"] = "Line";
    DCSDrawingPrimitive["Polygon"] = "Polygon";
    DCSDrawingPrimitive["TextBox"] = "TextBox";
})($91a9098e14452db2$export$b89d56b50e08a256 || ($91a9098e14452db2$export$b89d56b50e08a256 = {}));
var $91a9098e14452db2$export$fb028bc55343bb1f;
(function(TaskingMapLayerName) {
    TaskingMapLayerName["Bases"] = "Bases";
    TaskingMapLayerName["OPFORBases"] = "OPFOR Bases";
    TaskingMapLayerName["Threats"] = "Threats";
    TaskingMapLayerName["OPFORGroups"] = "OPFOR Groups";
    TaskingMapLayerName["PlayerGroups"] = "Player Groups";
    TaskingMapLayerName["SupportAssets"] = "Support Assets";
    TaskingMapLayerName["Terrain"] = "Terrain";
    TaskingMapLayerName["StreetMap"] = "Map";
    TaskingMapLayerName["Zones"] = "Zones";
    TaskingMapLayerName["Friendlies"] = "Friendlies";
    TaskingMapLayerName["DrawingObjects"] = "Drawing Objects";
    TaskingMapLayerName["OPFORStatics"] = "OPFOR Statics";
    TaskingMapLayerName["ControlPoints"] = "Control Points";
    TaskingMapLayerName["ControlMeasures"] = "Control Measures";
    TaskingMapLayerName["Compass"] = "Compass";
    TaskingMapLayerName["FriendlyShips"] = "Friendly Ships";
    TaskingMapLayerName["OPFORShips"] = "OPFOR Ships";
})($91a9098e14452db2$export$fb028bc55343bb1f || ($91a9098e14452db2$export$fb028bc55343bb1f = {}));
var $91a9098e14452db2$export$589bf38da6f496d9;
(function(FeatureClass) {
    FeatureClass["FlyableGroup"] = "FlyableGroup";
    FeatureClass["SupportAsset"] = "SupportAsset";
    FeatureClass["Airbase"] = "Airbase";
    FeatureClass["OPFORGroups"] = "OPFORGroups";
    FeatureClass["Waypoint"] = "Waypoint";
    FeatureClass["NavPoint"] = "NavPoint";
    FeatureClass["Static"] = "Static";
    FeatureClass["Bullseye"] = "SharedNavPoint";
    FeatureClass["ControlPoint"] = "Control Point";
    FeatureClass["ControlMeasure"] = "Control Measure";
})($91a9098e14452db2$export$589bf38da6f496d9 || ($91a9098e14452db2$export$589bf38da6f496d9 = {}));
var $91a9098e14452db2$export$9098989df19ab765;
(function(ScreenSize) {
    ScreenSize[ScreenSize["Phone"] = 375] = "Phone";
    ScreenSize[ScreenSize["Tablet"] = 768] = "Tablet";
    ScreenSize[ScreenSize["Laptop"] = 1280] = "Laptop";
    ScreenSize[ScreenSize["Desktop"] = 1920] = "Desktop";
})($91a9098e14452db2$export$9098989df19ab765 || ($91a9098e14452db2$export$9098989df19ab765 = {}));
const $91a9098e14452db2$export$895cfaa78f9f7717 = "assetViewerOpen";



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $3090f115e7fbf8a2$var$FirebaseContext = /*#__PURE__*/ $acw62.createContext(null);
function $3090f115e7fbf8a2$export$ce9eae4584165fd1() {
    return $acw62.useContext($3090f115e7fbf8a2$var$FirebaseContext);
}
function $3090f115e7fbf8a2$export$2e2bcd8739ae039({ app: app, db: db, auth: auth, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3090f115e7fbf8a2$var$FirebaseContext.Provider, {
        value: {
            app: app,
            db: db,
            auth: auth
        },
        children: children
    });
}


const $5f078b543969ac27$export$38ee920e59704589 = /*#__PURE__*/ $acw62.createContext({});
function $5f078b543969ac27$export$23bbbc4533528f03() {
    return $acw62.useContext($5f078b543969ac27$export$38ee920e59704589);
}
async function $5f078b543969ac27$export$b0f449737312189d(scope = "identify guilds", permissions = null, intents = null) {
    // Get this from the backend to ensure we always have the right one.
    // The FE env vars are set at build time, but the BE env is set at runtime.
    // We want the runtime env vars to take advantage of deploy-preview environment variables.
    let redirect_uri;
    try {
        const res = await fetch("/.netlify/functions/discord_redirect_url").then((res)=>res.json());
        redirect_uri = res.redirect_uri;
    } catch (e) {
        console.error(e);
        throw e;
    }
    const params = {
        client_id: "962467253801066506",
        response_type: "code",
        redirect_uri: redirect_uri,
        scope: scope,
        permissions: permissions,
        intents: intents
    };
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($3ecb7368762fc268$exports))).stringify(params, {
        skipNull: true
    });
    return `https://discord.com/api/oauth2/authorize?${query}`;
}
async function $5f078b543969ac27$export$1e0d7a6ccb38427f() {
    const params = {
        client_id: "962467253801066506",
        scope: "bot"
    };
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($3ecb7368762fc268$exports))).stringify(params, {
        skipNull: true
    });
    return await `https://discord.com/api/oauth2/authorize?${query}`;
}
async function $5f078b543969ac27$var$fetchUser() {
    const res = await fetch("/.netlify/functions/discord_user");
    if (res.status >= 400) throw {
        code: res.status,
        message: res.statusText
    };
    return await res.json();
}
async function $5f078b543969ac27$var$authFirebase(auth, token) {
    return (0, $8eace09cb4780ee7$export$3d8c2f653ac9d0b9)(auth, token);
}
async function $5f078b543969ac27$export$61bb00ddedae72e4(auth, { code: code }) {
    const oauthRes = await fetch(`/.netlify/functions/discord_oauth?code=${code}`).then((res)=>res.json());
    const res = await $5f078b543969ac27$var$fetchUser();
    await $5f078b543969ac27$var$authFirebase(auth, oauthRes.firebaseToken);
    return res;
}
function $5f078b543969ac27$var$doLogout(history) {
    return fetch("/.netlify/functions/discord_logout").then(()=>history.push((0, $91a9098e14452db2$export$37d3279522fbf5e2).Home));
}
var $5f078b543969ac27$var$ActionType;
(function(ActionType) {
    ActionType[ActionType["fetchUser"] = 0] = "fetchUser";
    ActionType[ActionType["fetchUserSuccess"] = 1] = "fetchUserSuccess";
    ActionType[ActionType["fetchUserError"] = 2] = "fetchUserError";
})($5f078b543969ac27$var$ActionType || ($5f078b543969ac27$var$ActionType = {}));
const $5f078b543969ac27$var$initialState = ()=>({
        loading: true,
        user: null,
        subscription: null,
        error: null
    });
const $5f078b543969ac27$var$reducer = (state, action)=>{
    switch(action.type){
        case 0:
            return {
                ...state,
                loading: true
            };
        case 1:
            return {
                ...state,
                loading: false,
                user: action.user,
                subscription: action.subscription
            };
        case 2:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            break;
    }
};
function $5f078b543969ac27$export$88f24fd8fcfab6ca({ children: children }) {
    const { auth: auth } = (0, $3090f115e7fbf8a2$export$ce9eae4584165fd1)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [state, dispatch] = $acw62.useReducer($5f078b543969ac27$var$reducer, $5f078b543969ac27$var$initialState());
    const doAuthError = (history, dispatch, e)=>{
        dispatch({
            type: 2,
            error: e
        });
    };
    const login = async (code)=>{
        try {
            const { user: user, subscription: subscription } = await $5f078b543969ac27$export$61bb00ddedae72e4(auth, {
                code: code
            });
            dispatch({
                type: 1,
                user: user,
                subscription: subscription
            });
        } catch (e) {
            doAuthError(history, dispatch, e);
            return;
        }
    };
    const logout = async ()=>{
        await $5f078b543969ac27$var$doLogout(history);
        await auth.signOut();
        $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(null);
        dispatch({
            type: 1,
            user: null,
            subscription: null
        });
    };
    const getCurrentUser = async ()=>{
        let res;
        try {
            res = await $5f078b543969ac27$var$fetchUser();
        } catch (e) {
            doAuthError(history, dispatch, e);
            return;
        }
        $f2b90654edf2c0a1$export$8b6bb3dd62a01be2({
            discordID: res.user.id,
            username: res.user.username
        });
        dispatch({
            type: 1,
            ...res
        });
    };
    $acw62.useEffect(()=>{
        getCurrentUser();
    }, []);
    if (state.loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {});
    const value = {
        currentUser: state.user,
        subscription: state.subscription,
        loading: state.loading,
        login: login,
        logout: logout
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5f078b543969ac27$export$38ee920e59704589.Provider, {
        value: value,
        children: children
    });
}
function $5f078b543969ac27$export$6e12a35b5fc14cf8() {
    const { subscription: subscription } = $5f078b543969ac27$export$23bbbc4533528f03();
    return subscription?.enabled;
}





var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");


function $f167d3e4f22a6e20$var$Link({ href: href, to: to = "", ...rest }) {
    return href ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        ...rest,
        href: href
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$a6c7ac8248d6e38a), {
        to: to,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(rest, "innerRef")
    });
}
var $f167d3e4f22a6e20$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($f167d3e4f22a6e20$var$Link)``;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $fae186fb7c5646ee$exports = {};
$fae186fb7c5646ee$exports = new URL("logo.aed67aaa.svg", import.meta.url).toString();


var $06dc07a195eb429d$exports = {};
$06dc07a195eb429d$exports = new URL("fo_solo.c152f81f.svg", import.meta.url).toString();


var $ed173ba6c38830a3$export$aadcd836922b29de;
(function(LogoVariant) {
    LogoVariant["LeftAligned"] = "LeftAligned";
    LogoVariant["Solo"] = "Solo";
})($ed173ba6c38830a3$export$aadcd836922b29de || ($ed173ba6c38830a3$export$aadcd836922b29de = {}));
function $ed173ba6c38830a3$var$Logo({ className: className, variant: variant = "LeftAligned" }) {
    let src = "";
    switch(variant){
        case "LeftAligned":
            src = (0, (/*@__PURE__*/$parcel$interopDefault($fae186fb7c5646ee$exports)));
            break;
        case "Solo":
            src = (0, (/*@__PURE__*/$parcel$interopDefault($06dc07a195eb429d$exports)));
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        column: true,
        center: true,
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: src
        })
    });
}
var $ed173ba6c38830a3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ed173ba6c38830a3$var$Logo).attrs({
    className: $ed173ba6c38830a3$var$Logo.name
})`
  img {
    height: ${(props)=>props.height}px;
    width: ${(props)=>props.width}px;
  }
`;


function $ec614839e381234a$var$AppHeader({ className: className, mode: mode, hide: hide }) {
    const { currentUser: currentUser, logout: logout } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const loginMatch = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)((0, $91a9098e14452db2$export$37d3279522fbf5e2).Login);
    const publicMatch = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)((0, $91a9098e14452db2$export$37d3279522fbf5e2).PublicFragOrder);
    // Hack to remove this from the page when on the sign in page.
    // SignIn page embeds it's own header for more control
    const shouldHide = typeof hide !== "undefined" ? hide : loginMatch?.path === (0, $91a9098e14452db2$export$37d3279522fbf5e2).Login || publicMatch?.path === (0, $91a9098e14452db2$export$37d3279522fbf5e2).PublicFragOrder;
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleLogout = ()=>{
        handleClose();
        logout();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, {
            hide: shouldHide
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            between: true,
            align: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                    to: (0, $91a9098e14452db2$export$37d3279522fbf5e2).Home,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed173ba6c38830a3$export$2e2bcd8739ae039), {
                        width: 140,
                        height: 84
                    })
                }),
                mode === (0, $cd93687958c8007e$export$e5d97828673c2a38).Admin && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                            href: "https://docs.fragorders.com",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a8fa6a444a800fa7$exports))), {}),
                                children: "View the Docs"
                            })
                        }),
                        currentUser ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                    onClick: handleClick,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                                        alt: currentUser.username,
                                        src: `https://cdn.discordapp.com/avatars/${currentUser?.id}/${currentUser.avatar}.png`
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), {
                                    id: "demo-positioned-menu",
                                    "aria-labelledby": "demo-positioned-button",
                                    anchorEl: anchorEl,
                                    open: Boolean(anchorEl),
                                    onClose: handleClose,
                                    anchorOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                history.push((0, $91a9098e14452db2$export$37d3279522fbf5e2).UserSettings);
                                                handleClose();
                                            },
                                            children: "Settings"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            onClick: handleLogout,
                                            children: "Logout"
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
}
var $ec614839e381234a$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ec614839e381234a$var$AppHeader).attrs({
    className: $ec614839e381234a$var$AppHeader.name
})`
  width: 100%;

  /* background: ${(props)=>props.theme.palette.background.paper}; */

  &.hide {
    display: none;
  }

  .menu-item a.active {
    color: white;
  }



  @media only screen and (max-width: 600px) {
    ${(0, $ed173ba6c38830a3$export$2e2bcd8739ae039)} img {
      height: 56px;
      width: 94px;
    }

  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $5510972eca5c3734$var$missionKey = "missionFile";
const $5510972eca5c3734$var$missionNameKey = "missionName";
// https://stackoverflow.com/questions/6850276/how-to-convert-dataurl-to-file-object-in-javascript
function $5510972eca5c3734$var$dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for(let i = 0; i < byteString.length; i++)ia[i] = byteString.charCodeAt(i);
    //New Code
    return new Blob([
        ab
    ], {
        type: mimeString
    });
}
function $5510972eca5c3734$export$899cf3f38be42af(raw, name) {
    const reader = new FileReader();
    reader.addEventListener("load", ()=>{
        try {
            localStorage.setItem($5510972eca5c3734$var$missionKey, reader.result);
            localStorage.setItem($5510972eca5c3734$var$missionNameKey, name);
        } catch (e) {
            // TODO: let the user know
            console.error("Mission file is too big, could not save to browser storage");
        }
    }, false);
    reader.readAsDataURL(raw);
}
function $5510972eca5c3734$export$e94648b987d3c8ca() {
    const dataUrl = localStorage.getItem($5510972eca5c3734$var$missionKey);
    if (!dataUrl) return null;
    return new File([
        $5510972eca5c3734$var$dataURItoBlob(dataUrl)
    ], localStorage.getItem($5510972eca5c3734$var$missionNameKey), {
        type: "application/zip"
    });
}
function $5510972eca5c3734$export$5c5732ea604de450() {
    localStorage.removeItem($5510972eca5c3734$var$missionKey);
    localStorage.removeItem($5510972eca5c3734$var$missionNameKey);
}
function $5510972eca5c3734$export$2cdf1b96a9f86d16(text) {
    // Create a textarea element in which the text of the code will be copied.
    // Set the value of the textarea, select it to set it as the active element,
    // then copy the value of that element to the clipboard.
    // It's 2017 and this is still the best way to copy text on button click...
    const selection = document.getSelection();
    const selectionString = selection.toString();
    // if user has selected text, save that to state so it can be reselected
    if (selectionString !== "") this.setState({
        selectedRange: selection.getRangeAt(0)
    });
    const txtArea = document.createElement("textarea");
    // Safari doesn't allow for assigning an object literal to `style`.
    // @ts-ignore
    txtArea.class = "hidden-textarea";
    // Make sure the code ends in a newline to execute all the commands in multiline code.
    txtArea.value = `${text}\n`;
    document.body.appendChild(txtArea);
    txtArea.select();
    document.execCommand("copy");
    document.body.removeChild(txtArea);
}


const $84a59591ecbdf222$export$122994dc05ba4308 = /*#__PURE__*/ $acw62.createContext(null);
function $84a59591ecbdf222$var$AppStateProvider(props) {
    const [mission, setMissionData] = $acw62.useState();
    const [dictionary, setDictionary] = $acw62.useState();
    const [warehouses, setWarehouses] = $acw62.useState();
    const [zipObj, setMizFile] = $acw62.useState({
        name: "",
        entries: null
    });
    const value = {
        mission: mission,
        zipObj: zipObj,
        dictionary: dictionary,
        warehouses: warehouses,
        setMizFile: setMizFile,
        setMissionData: setMissionData,
        setDictionary: setDictionary,
        setWarehouses: setWarehouses,
        removeMission: ()=>{
            setMissionData(null);
            setDictionary({});
            setMizFile(null);
            (0, $5510972eca5c3734$export$5c5732ea604de450)();
        },
        mode: props.mode
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($84a59591ecbdf222$export$122994dc05ba4308.Provider, {
        value: value,
        ...props
    });
}
var $84a59591ecbdf222$export$2e2bcd8739ae039 = $84a59591ecbdf222$var$AppStateProvider;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



function $84a93f03d5e878eb$export$2e2bcd8739ae039({ component: Component, ...rest }) {
    const { currentUser: currentUser, loading: loading } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
        ...rest,
        render: (props)=>currentUser ? /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                ...props
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e), {
                to: "/login"
            })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $47b3c0eb5fee4469$var$ErrorPage({ className: className, message: message, stack: stack }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        className: className,
        title: "Error",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: "Something went wrong."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                children: message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                children: stack
            })
        ]
    });
}
var $47b3c0eb5fee4469$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($47b3c0eb5fee4469$var$ErrorPage).attrs({
    className: $47b3c0eb5fee4469$var$ErrorPage.name
})``;




const $d99e0e9b4d6f6228$var$Style = (0, $f8dbcd8598db1f0b$export$f0f03736edb61697)`
  html {
    font-family: "Open Sans", sans-serif;
    color: #fff;
    font-size: 16px;
    padding: 0;
    margin: 0;
  }

  nav > div {
    width: 100%;
  }

  body {
    height: 100%;
    width: 100%;
    font-family: 'Roboto', sans-serif;
    padding: 0;
    margin: 0;
    color: ${(props)=>props.theme.palette.text.primary};
    background-color: ${(props)=>{
    return props.theme.palette.background.default;
}}
  }


  nav {
    padding: 60px 0 !important;
  }

  .hidden-textarea {
    visibility: none;
  }


  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 32px;
    left: -50px;
    min-width: 280px;
    z-index: 2;
  }
  .ol-popup:after,
  .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "✖";
  }

  .MuiTooltip-root {
    font-size: 16px;
  }

  #planning-drawer .MuiPaper-root {
    left: 428px !important;
    width: calc(100vw - 428px) !important;
  }

  .wb-header {
    font-family: 'Roboto', sans-serif;

  }
`;
var $d99e0e9b4d6f6228$export$2e2bcd8739ae039 = $d99e0e9b4d6f6228$var$Style;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $bOOlK = parcelRequire("bOOlK");

var $g91qR = parcelRequire("g91qR");
var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $17r9Q = parcelRequire("17r9Q");

var $8hKYW = parcelRequire("8hKYW");
const $4922ab3f1f5ee220$var$_excluded = [
    "sx"
];
const $4922ab3f1f5ee220$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    Object.keys(props).forEach((prop)=>{
        if ((0, $8hKYW.propToStyleFunction)[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $4922ab3f1f5ee220$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $4922ab3f1f5ee220$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $4922ab3f1f5ee220$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $17r9Q.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}



var $lJyjx = parcelRequire("lJyjx");

var $ayMG0 = parcelRequire("ayMG0");
const $6f004ebeb2f93e73$var$_excluded = [
    "className",
    "component"
];
function $6f004ebeb2f93e73$export$2e2bcd8739ae039(options = {}) {
    const { defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName, styleFunctionSx: styleFunctionSx = (0, $g91qR.default) } = options;
    const BoxRoot = (0, $bOOlK.default)("div")(styleFunctionSx);
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $lJyjx.default)(defaultTheme);
        const _extendSxProp = (0, $4922ab3f1f5ee220$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $6f004ebeb2f93e73$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $1SA7b.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: theme
        }, other));
    });
    return Box;
}



var $fgJxe = parcelRequire("fgJxe");

var $ijOKP = parcelRequire("ijOKP");
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $6f004ebeb2f93e73$export$2e2bcd8739ae039)({
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $fgJxe.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $jTnBY = parcelRequire("jTnBY");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");


var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $9XEW1.default)("MuiTab", slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $7u6PA.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $e6a3a0c577f6eee9$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $9971e.default)(slots, (0, $e56e43dd06ac0faa$export$72aef224d6115253), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: (0, $8nd05.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: theme.palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: theme.palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: theme.palette.primary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: theme.palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: theme.palette.secondary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $1En50.default)(props, $e6a3a0c577f6eee9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $1SA7b.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, (0, $8nd05.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $4b4d81ec72297c97$var$cachedType;
function $4b4d81ec72297c97$export$a10970ffb6510128() {
    if ($4b4d81ec72297c97$var$cachedType) return $4b4d81ec72297c97$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $4b4d81ec72297c97$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $4b4d81ec72297c97$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $4b4d81ec72297c97$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $4b4d81ec72297c97$var$cachedType;
} // Based on https://stackoverflow.com/a/24394376
function $4b4d81ec72297c97$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $4b4d81ec72297c97$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");



var $ayMG0 = parcelRequire("ayMG0");
const $f4c90fbbf54d23af$var$_excluded = [
    "onChange"
];
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $1En50.default)(props, $f4c90fbbf54d23af$var$_excluded);
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    $acw62.useEffect(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        style: $f4c90fbbf54d23af$var$styles,
        ref: nodeRef
    }, other));
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");





var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $9XEW1.default)("MuiTabScrollButton", slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $7u6PA.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
var $9e031514df70ea8e$var$_KeyboardArrowLeft, $9e031514df70ea8e$var$_KeyboardArrowRight;
const $9e031514df70ea8e$var$_excluded = [
    "className",
    "direction",
    "orientation",
    "disabled"
];
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $9971e.default)(slots, (0, $35c7816ebadb07c9$export$34861783d3c2eef8), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $35c7816ebadb07c9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, direction: direction } = props, other = (0, $1En50.default)(props, $9e031514df70ea8e$var$_excluded);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $8nd05.default)({
        isRtl: isRtl
    }, props);
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, (0, $8nd05.default)({
        component: "div",
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? $9e031514df70ea8e$var$_KeyboardArrowLeft || ($9e031514df70ea8e$var$_KeyboardArrowLeft = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3ef3be5c947a70a$export$2e2bcd8739ae039), {
            fontSize: "small"
        })) : $9e031514df70ea8e$var$_KeyboardArrowRight || ($9e031514df70ea8e$var$_KeyboardArrowRight = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02d495bb1a743bb2$export$2e2bcd8739ae039), {
            fontSize: "small"
        }))
    }));
});
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;




var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $9XEW1.default)("MuiTabs", slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $7u6PA.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;





var $ayMG0 = parcelRequire("ayMG0");
const $7be483edbed3b474$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $9971e.default)(slots, (0, $8a85ee70c626268d$export$cdd93bd054dec359), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on MacOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $7be483edbed3b474$var$FlexContainer = (0, $d8seH.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: theme.palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: theme.palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $f4c90fbbf54d23af$export$2e2bcd8739ae039), {
    name: "MuiTabs",
    slot: "ScrollbarSize"
})({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on MacOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $9e031514df70ea8e$export$2e2bcd8739ae039), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $1En50.default)(props, $7be483edbed3b474$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayScroll, setDisplayScroll] = $acw62.useState({
        start: false,
        end: false
    });
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $4b4d81ec72297c97$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        }; // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $f2ff3c73ed46b37c$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
            scrollValue *= isRtl && (0, $4b4d81ec72297c97$export$a10970ffb6510128)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) break;
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    }; // TODO Remove <ScrollbarSize /> as browser support for hidding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $1SA7b.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayScroll.start || displayScroll.end;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayScroll.start
        }, TabScrollButtonProps, {
            className: (0, $1SA7b.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayScroll.end
        }, TabScrollButtonProps, {
            className: (0, $1SA7b.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $331f3746e6346411$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) {
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight, scrollWidth: scrollWidth, clientWidth: clientWidth } = tabsRef.current;
            let showStartScroll;
            let showEndScroll;
            if (vertical) {
                showStartScroll = scrollTop > 1;
                showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
            } else {
                const scrollLeft = (0, $4b4d81ec72297c97$export$3c615b88e5d7e4f6)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
                showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
                showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
            }
            if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) setDisplayScroll({
                start: showStartScroll,
                end: showEndScroll
            });
        }
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            updateIndicatorState();
            updateScrollButtonState();
        });
        const win = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const handleTabsScroll = $acw62.useMemo(()=>(0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            updateScrollButtonState();
        }), [
        updateScrollButtonState
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleTabsScroll.clear();
        };
    }, [
        handleTabsScroll
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
        updateScrollButtonState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsIndicator, (0, $8nd05.default)({}, TabIndicatorProps, {
        className: (0, $1SA7b.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $8nd05.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, (0, $8nd05.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement; // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                onScroll: handleTabsScroll,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $jTnBY = parcelRequire("jTnBY");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $9XEW1.default)("MuiTypography", slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $7u6PA.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $9971e.default)(slots, (0, $837556bdf75d281f$export$24c1f8f60cbac79e), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
}; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $4922ab3f1f5ee220$export$2e2bcd8739ae039)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || "span";
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other));
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

const $1bfb465a9f0e47a1$var$FeatureFlagsContext = /*#__PURE__*/ $acw62.createContext(null);
var $1bfb465a9f0e47a1$export$df35587a8f95f16f;
(function(FeatureFlag) {
    FeatureFlag["CoalitionPublish"] = "publish:coalition";
    FeatureFlag["KneeboardGen"] = "jobs:kneeboards";
    FeatureFlag["Signups"] = "signups";
    FeatureFlag["ExternalData"] = "external_data";
    FeatureFlag["VolumeLicense"] = "volume_license";
})($1bfb465a9f0e47a1$export$df35587a8f95f16f || ($1bfb465a9f0e47a1$export$df35587a8f95f16f = {}));
const $1bfb465a9f0e47a1$var$getFlags = ()=>fetch("/.netlify/functions/feature_flags", {
        credentials: "same-origin"
    }).then((res)=>res.json());
function $1bfb465a9f0e47a1$export$6d7e43f2d6e1c7c6({ children: children }) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const [flags, setFlags] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        if (!currentUser) return;
        $1bfb465a9f0e47a1$var$getFlags().then((flags)=>setFlags(flags));
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1bfb465a9f0e47a1$var$FeatureFlagsContext.Provider, {
        value: flags,
        children: children
    });
}
function $1bfb465a9f0e47a1$export$90335b3ff08f335() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get($acw62.useContext($1bfb465a9f0e47a1$var$FeatureFlagsContext), "flags");
}





var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $jTnBY = parcelRequire("jTnBY");


var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $9XEW1.default)("MuiAlert", slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $7u6PA.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;



parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $ayMG0 = parcelRequire("ayMG0");
var $d7b9f0ef25189a24$var$_CloseIcon;
const $d7b9f0ef25189a24$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "variant"
];
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $9971e.default)(slots, (0, $1da0e229d53b4459$export$69aecd24bc2cf7e3), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === "light" ? (0, $kyRHb.darken) : (0, $kyRHb.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $kyRHb.lighten) : (0, $kyRHb.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $8nd05.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px"
    }, color && ownerState.variant === "standard" && {
        color: getColor(theme.palette[color].light, 0.6),
        backgroundColor: getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: {
            color: theme.palette.mode === "dark" ? theme.palette[color].main : theme.palette[color].light
        }
    }, color && ownerState.variant === "outlined" && {
        color: getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${theme.palette[color].light}`,
        [`& .${(0, $1da0e229d53b4459$export$2e2bcd8739ae039).icon}`]: {
            color: theme.palette.mode === "dark" ? theme.palette[color].main : theme.palette[color].light
        }
    }, color && ownerState.variant === "filled" && {
        color: "#fff",
        fontWeight: theme.typography.fontWeightMedium,
        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main
    });
});
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eec239707c48bf2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $611e456547a52fc7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7987087272cca1$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76204164d2201318$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", variant: variant = "standard" } = props, other = (0, $1En50.default)(props, $d7b9f0ef25189a24$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d7b9f0ef25189a24$var$AlertRoot, (0, $8nd05.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    children: $d7b9f0ef25189a24$var$_CloseIcon || ($d7b9f0ef25189a24$var$_CloseIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7280bbf95507cba$export$2e2bcd8739ae039), {
                        fontSize: "small"
                    }))
                })
            }) : null
        ]
    }));
});
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;


parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


function $926fc19b1a64a878$var$Section({ className: className, children: children, title: title, loading: loading, actions: actions }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                style: {
                    width: "100%"
                },
                p: 3,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        style: {
                            padding: 0
                        },
                        marginBottom: 2,
                        p: 0,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            align: true,
                            wide: true,
                            between: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    fontSize: 24,
                                    variant: "h3",
                                    children: title
                                }),
                                actions
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        center: true,
                        align: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {})
                    }) : children
                ]
            })
        })
    });
}
var $926fc19b1a64a878$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($926fc19b1a64a878$var$Section).attrs({
    className: $926fc19b1a64a878$var$Section.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $lWAfe = parcelRequire("lWAfe");

var $9971e = parcelRequire("9971e");


var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $9XEW1.default)("MuiGrid", slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $f35b8acab3fc2f62$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $7u6PA.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "lg",
    "md",
    "rowSpacing",
    "sm",
    "spacing",
    "wrap",
    "xl",
    "xs",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $lWAfe.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
             // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            } // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        } // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $lWAfe.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $lWAfe.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        styles = (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            return {};
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        styles = (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            return {};
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, container, styles = {}) {
    // in case of grid item or undefined/null or `spacing` <= 0
    if (!container || !spacing || spacing <= 0) return [];
     // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`] || `spacing-xs-${String(spacing)}`
    ];
     // in case of object `spacing`
    const { xs: xs, sm: sm, md: md, lg: lg, xl: xl } = spacing;
    return [
        Number(xs) > 0 && (styles[`spacing-xs-${String(xs)}`] || `spacing-xs-${String(xs)}`),
        Number(sm) > 0 && (styles[`spacing-sm-${String(sm)}`] || `spacing-sm-${String(sm)}`),
        Number(md) > 0 && (styles[`spacing-md-${String(md)}`] || `spacing-md-${String(md)}`),
        Number(lg) > 0 && (styles[`spacing-lg-${String(lg)}`] || `spacing-lg-${String(lg)}`),
        Number(xl) > 0 && (styles[`spacing-xl-${String(xl)}`] || `spacing-xl-${String(xl)}`)
    ];
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { container: container, direction: direction, item: item, lg: lg, md: md, sm: sm, spacing: spacing, wrap: wrap, xl: xl, xs: xs, zeroMinWidth: zeroMinWidth } = props.ownerState;
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...$9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, container, styles),
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            xs !== false && styles[`grid-xs-${String(xs)}`],
            sm !== false && styles[`grid-sm-${String(sm)}`],
            md !== false && styles[`grid-md-${String(md)}`],
            lg !== false && styles[`grid-lg-${String(lg)}`],
            xl !== false && styles[`grid-xl-${String(xl)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, lg: lg, md: md, sm: sm, spacing: spacing, wrap: wrap, xl: xl, xs: xs, zeroMinWidth: zeroMinWidth } = ownerState;
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...$9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, container),
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            xs !== false && `grid-xs-${String(xs)}`,
            sm !== false && `grid-sm-${String(sm)}`,
            md !== false && `grid-md-${String(md)}`,
            lg !== false && `grid-lg-${String(lg)}`,
            xl !== false && `grid-xl-${String(xl)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const props = (0, $4922ab3f1f5ee220$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, lg: lg = false, md: md = false, rowSpacing: rowSpacingProp, sm: sm = false, spacing: spacing = 0, wrap: wrap = "wrap", xl: xl = false, xs: xs = false, zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039)); // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        lg: lg,
        md: md,
        sm: sm,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        xl: xl,
        xs: xs,
        zeroMinWidth: zeroMinWidth
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            as: component,
            ref: ref
        }, other))
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;


parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $e1f03c0083d00e9b$var$ServicesContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $e1f03c0083d00e9b$export$b0eb5dd44c72ef97({ subs: subs, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e1f03c0083d00e9b$var$ServicesContext.Provider, {
        value: {
            subs: subs
        },
        children: children
    });
}
function $e1f03c0083d00e9b$export$b20e0e0e34545542() {
    const ctx = $acw62.useContext($e1f03c0083d00e9b$var$ServicesContext);
    return ctx.subs;
}



const $3e8772b7528d3c44$var$subCacheKey = "payment";
function $3e8772b7528d3c44$export$58321a13afb85c65() {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $3e8772b7528d3c44$var$subCacheKey
    ], ()=>{
        return mgr.get();
    }, {
        retry: false,
        retryDelay: 1000,
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false
    });
}
function $3e8772b7528d3c44$export$ebbade5b631a7d1() {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    return (sessionID)=>mgr.getPortalURL(sessionID);
}
function $3e8772b7528d3c44$export$4f4427446da83a71() {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    const { currentUser: currentUser, subscription: subscription } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    return async (priceID)=>{
        return mgr.createCheckoutSession(currentUser.id, priceID, !subscription?.trialCompleted);
    };
}
function $3e8772b7528d3c44$export$dad3cdff3edc5a39(parent) {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "volume"
    ], ()=>{
        return mgr.listVolumeSubs(parent);
    }, {
        refetchOnWindowFocus: true,
        cacheTime: 10000,
        staleTime: 10000
    });
}
function $3e8772b7528d3c44$export$1e8ac4b0c4da1373() {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return async (parent)=>{
        return mgr.generateVolumeRedeemCode(parent).then(()=>{
            qc.invalidateQueries("volume");
        });
    };
}
function $3e8772b7528d3c44$export$53a848f107b70f44(code) {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "volume",
        code
    ], ()=>{
        return mgr.getVolumeRecordByCode(code);
    }, {
        retry: false,
        retryDelay: 1000,
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false
    });
}
function $3e8772b7528d3c44$export$f097d75c1f470982() {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return async (code)=>{
        return mgr.redeemVolumeCode(code).then(()=>{
            qc.invalidateQueries("volume");
        });
    };
}
function $3e8772b7528d3c44$export$f4757fa847ff3a94() {
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return async (subID)=>{
        return mgr.revokeGroupLicense(subID).then(()=>{
            qc.invalidateQueries("volume");
        });
    };
}


const $dbf86a8fe13ef9de$var$StripePriceIDMonthly = "price_1MZUnzJyh4vWqdRZ1f8pJ1RH";
const $dbf86a8fe13ef9de$var$StripePriceIDYearly = "price_1OUc0uJyh4vWqdRZvtKeEc7d";
const $dbf86a8fe13ef9de$var$StripePriceIDVolume = "price_1PHXLqJyh4vWqdRZppyFluVJ";
var $dbf86a8fe13ef9de$export$a6b3daa2792c50f8;
(function(PriceID) {
    PriceID["Monthly"] = "monthly";
    PriceID["Yearly"] = "yearly";
    PriceID["Volume"] = "volume";
})($dbf86a8fe13ef9de$export$a6b3daa2792c50f8 || ($dbf86a8fe13ef9de$export$a6b3daa2792c50f8 = {}));
const $dbf86a8fe13ef9de$export$6ea95f79cb07057b = {
    ["monthly"]: $dbf86a8fe13ef9de$var$StripePriceIDMonthly,
    ["yearly"]: $dbf86a8fe13ef9de$var$StripePriceIDYearly,
    ["volume"]: $dbf86a8fe13ef9de$var$StripePriceIDVolume
};
class $dbf86a8fe13ef9de$var$sub {
    constructor(f){
        this.fetch = f;
    }
    get() {
        return this.fetch.req("/.netlify/functions/get_subscription");
    }
    createCheckoutSession(userID, priceID, trialAvailable) {
        const stripeID = $dbf86a8fe13ef9de$export$6ea95f79cb07057b[priceID];
        if (!stripeID) throw new Error(`Invalid price ID: ${priceID}`);
        return this.fetch.req("/.netlify/functions/create_payment_session", {
            method: "POST",
            body: JSON.stringify({
                userID: userID,
                priceID: stripeID,
                trialAvailable: trialAvailable
            })
        });
    }
    recordSessionResult(sessionID) {
        return this.fetch.req("/.netlify/functions/record_session_result", {
            method: "POST",
            body: JSON.stringify({
                sessionID: sessionID
            })
        });
    }
    getPortalURL(customerID) {
        return this.fetch.req("/.netlify/functions/create_portal_session", {
            method: "POST",
            body: JSON.stringify({
                customerID: customerID
            })
        }).then((res)=>res.url);
    }
    listVolumeSubs(parent) {
        return this.fetch.req(`/.netlify/functions/list_volume_subs?parent=${parent.id}`);
    }
    listReedemCodes(parent) {
        return this.fetch.req(`/.netlify/functions/list_redeem_codes?parent=${parent.id}`);
    }
    generateVolumeRedeemCode(parent) {
        return this.fetch.req(`/.netlify/functions/generate_redeem_code`, {
            method: "POST",
            body: JSON.stringify(parent)
        });
    }
    redeemVolumeCode(code) {
        return this.fetch.req("/.netlify/functions/redeem_code", {
            method: "POST",
            body: JSON.stringify({
                code: code
            })
        });
    }
    getVolumeRecordByCode(code) {
        return this.fetch.req(`/.netlify/functions/get_redeem_by_code?code=${code}`);
    }
    revokeGroupLicense(subscriptionID) {
        return this.fetch.req("/.netlify/functions/revoke_group_license", {
            method: "POST",
            body: JSON.stringify({
                subscriptionID: subscriptionID
            })
        });
    }
}
function $dbf86a8fe13ef9de$export$7540639e9eb63b3b(f) {
    return new $dbf86a8fe13ef9de$var$sub(f);
}



var $f1q41 = parcelRequire("f1q41");

function $390198e472ccb254$export$2e2bcd8739ae039({ flag: flag, children: children }) {
    const userFlags = (0, $1bfb465a9f0e47a1$export$90335b3ff08f335)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(userFlags, flag)) return null;
    return children;
}




var $ayMG0 = parcelRequire("ayMG0");
var $321daf9b005e9cff$export$82e9f45cca5ba907 = "fas";
var $321daf9b005e9cff$export$7af266c3465b1ff2 = {
    prefix: "fas",
    iconName: "ad",
    icon: [
        512,
        512,
        [],
        "f641",
        "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
    ]
};
var $321daf9b005e9cff$export$853fd1561789e3bb = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $321daf9b005e9cff$export$6ea408c7266ed557 = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $321daf9b005e9cff$export$cfa06e4b68edca2d = {
    prefix: "fas",
    iconName: "adjust",
    icon: [
        512,
        512,
        [],
        "f042",
        "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
    ]
};
var $321daf9b005e9cff$export$a5e63e89b5ccee83 = {
    prefix: "fas",
    iconName: "air-freshener",
    icon: [
        384,
        512,
        [],
        "f5d0",
        "M378.94 321.41L284.7 224h49.22c15.3 0 23.66-16.6 13.86-27.53L234.45 69.96c3.43-6.61 5.55-14 5.55-21.96 0-26.51-21.49-48-48-48s-48 21.49-48 48c0 7.96 2.12 15.35 5.55 21.96L36.22 196.47C26.42 207.4 34.78 224 50.08 224H99.3L5.06 321.41C-6.69 333.56 3.34 352 21.7 352H160v32H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16H224v-32h138.3c18.36 0 28.39-18.44 16.64-30.59zM192 31.98c8.85 0 16.02 7.17 16.02 16.02 0 8.84-7.17 16.02-16.02 16.02S175.98 56.84 175.98 48c0-8.85 7.17-16.02 16.02-16.02zM304 432v32H80v-32h224z"
    ]
};
var $321daf9b005e9cff$export$70e29dd05344623e = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
    ]
};
var $321daf9b005e9cff$export$97c42b56d462df72 = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$e490f662af4d1c78 = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$7370f36a39a38737 = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
    ]
};
var $321daf9b005e9cff$export$dcae2101babbffff = {
    prefix: "fas",
    iconName: "allergies",
    icon: [
        448,
        512,
        [],
        "f461",
        "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$f5c7042778b51765 = {
    prefix: "fas",
    iconName: "ambulance",
    icon: [
        640,
        512,
        [],
        "f0f9",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $321daf9b005e9cff$export$23a7517099ab1b86 = {
    prefix: "fas",
    iconName: "american-sign-language-interpreting",
    icon: [
        640,
        512,
        [],
        "f2a3",
        "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
    ]
};
var $321daf9b005e9cff$export$12a35719f889cd1 = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [],
        "f13d",
        "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
    ]
};
var $321daf9b005e9cff$export$fd504117f273ca92 = {
    prefix: "fas",
    iconName: "angle-double-down",
    icon: [
        320,
        512,
        [],
        "f103",
        "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
    ]
};
var $321daf9b005e9cff$export$21b0833b3cf929a7 = {
    prefix: "fas",
    iconName: "angle-double-left",
    icon: [
        448,
        512,
        [],
        "f100",
        "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
    ]
};
var $321daf9b005e9cff$export$792931403404faf0 = {
    prefix: "fas",
    iconName: "angle-double-right",
    icon: [
        448,
        512,
        [],
        "f101",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
    ]
};
var $321daf9b005e9cff$export$9bb51e1a2c07db7c = {
    prefix: "fas",
    iconName: "angle-double-up",
    icon: [
        320,
        512,
        [],
        "f102",
        "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
    ]
};
var $321daf9b005e9cff$export$4b5be0142d10f342 = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        320,
        512,
        [],
        "f107",
        "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    ]
};
var $321daf9b005e9cff$export$3cbcd1b7e35945d2 = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        256,
        512,
        [],
        "f104",
        "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
    ]
};
var $321daf9b005e9cff$export$6bce1afb61f2eb66 = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        256,
        512,
        [],
        "f105",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
    ]
};
var $321daf9b005e9cff$export$887340269e6d6cac = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        320,
        512,
        [],
        "f106",
        "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
    ]
};
var $321daf9b005e9cff$export$3c96c08e234498c5 = {
    prefix: "fas",
    iconName: "angry",
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
    ]
};
var $321daf9b005e9cff$export$8736909014b15ca9 = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [],
        "f644",
        "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
    ]
};
var $321daf9b005e9cff$export$bcdd94f3977a0884 = {
    prefix: "fas",
    iconName: "apple-alt",
    icon: [
        448,
        512,
        [],
        "f5d1",
        "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
    ]
};
var $321daf9b005e9cff$export$26b3e1c454273f34 = {
    prefix: "fas",
    iconName: "archive",
    icon: [
        512,
        512,
        [],
        "f187",
        "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$d56753dd2eb5c323 = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        576,
        512,
        [],
        "f557",
        "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$ff3afbc8c0bc5d59 = {
    prefix: "fas",
    iconName: "arrow-alt-circle-down",
    icon: [
        512,
        512,
        [],
        "f358",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
    ]
};
var $321daf9b005e9cff$export$5460a5b11a24996f = {
    prefix: "fas",
    iconName: "arrow-alt-circle-left",
    icon: [
        512,
        512,
        [],
        "f359",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
    ]
};
var $321daf9b005e9cff$export$88962ffdad8b856d = {
    prefix: "fas",
    iconName: "arrow-alt-circle-right",
    icon: [
        512,
        512,
        [],
        "f35a",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
    ]
};
var $321daf9b005e9cff$export$3747a8ef0995eadf = {
    prefix: "fas",
    iconName: "arrow-alt-circle-up",
    icon: [
        512,
        512,
        [],
        "f35b",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
    ]
};
var $321daf9b005e9cff$export$6cfa36bbb3a057 = {
    prefix: "fas",
    iconName: "arrow-circle-down",
    icon: [
        512,
        512,
        [],
        "f0ab",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
    ]
};
var $321daf9b005e9cff$export$728262abb9f58d0a = {
    prefix: "fas",
    iconName: "arrow-circle-left",
    icon: [
        512,
        512,
        [],
        "f0a8",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
    ]
};
var $321daf9b005e9cff$export$7d3d828103aa3be7 = {
    prefix: "fas",
    iconName: "arrow-circle-right",
    icon: [
        512,
        512,
        [],
        "f0a9",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
    ]
};
var $321daf9b005e9cff$export$a2f6f3baa50af0b1 = {
    prefix: "fas",
    iconName: "arrow-circle-up",
    icon: [
        512,
        512,
        [],
        "f0aa",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
    ]
};
var $321daf9b005e9cff$export$9686eff8d817f770 = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        448,
        512,
        [],
        "f063",
        "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
    ]
};
var $321daf9b005e9cff$export$b7fac681e7d09400 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [],
        "f060",
        "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    ]
};
var $321daf9b005e9cff$export$b4da69a0247f3620 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [],
        "f061",
        "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    ]
};
var $321daf9b005e9cff$export$8e144ed4d52eef49 = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        448,
        512,
        [],
        "f062",
        "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
    ]
};
var $321daf9b005e9cff$export$3cdabfff52cfc73a = {
    prefix: "fas",
    iconName: "arrows-alt",
    icon: [
        512,
        512,
        [],
        "f0b2",
        "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
    ]
};
var $321daf9b005e9cff$export$7937ea574fb1389 = {
    prefix: "fas",
    iconName: "arrows-alt-h",
    icon: [
        512,
        512,
        [],
        "f337",
        "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
    ]
};
var $321daf9b005e9cff$export$138cb56a3f8f7040 = {
    prefix: "fas",
    iconName: "arrows-alt-v",
    icon: [
        256,
        512,
        [],
        "f338",
        "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
    ]
};
var $321daf9b005e9cff$export$8eeef3dc0035b165 = {
    prefix: "fas",
    iconName: "assistive-listening-systems",
    icon: [
        512,
        512,
        [],
        "f2a2",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
    ]
};
var $321daf9b005e9cff$export$19eff32c0fd4f99f = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        512,
        512,
        [],
        "f069",
        "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
    ]
};
var $321daf9b005e9cff$export$c115e8063ee02632 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [],
        "f1fa",
        "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
    ]
};
var $321daf9b005e9cff$export$380a9050e42fe5d7 = {
    prefix: "fas",
    iconName: "atlas",
    icon: [
        448,
        512,
        [],
        "f558",
        "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
    ]
};
var $321daf9b005e9cff$export$b5bb295e8ad4ab31 = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        448,
        512,
        [],
        "f5d2",
        "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
    ]
};
var $321daf9b005e9cff$export$b6b464c98c009494 = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        512,
        512,
        [],
        "f29e",
        "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
    ]
};
var $321daf9b005e9cff$export$f8db2747dadd48f7 = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
    ]
};
var $321daf9b005e9cff$export$8afab767536f59ad = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        384,
        512,
        [],
        "f77c",
        "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
    ]
};
var $321daf9b005e9cff$export$3b3ab4d86bad7d26 = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [],
        "f77d",
        "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
    ]
};
var $321daf9b005e9cff$export$e43e3f67102fc526 = {
    prefix: "fas",
    iconName: "backspace",
    icon: [
        640,
        512,
        [],
        "f55a",
        "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
    ]
};
var $321daf9b005e9cff$export$ae65f96ea7a4078d = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [],
        "f04a",
        "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
    ]
};
var $321daf9b005e9cff$export$ab07061fe21a3a8e = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [],
        "f7e5",
        "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
    ]
};
var $321daf9b005e9cff$export$6d636565b3ec36b4 = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        512,
        512,
        [],
        "f666",
        "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
    ]
};
var $321daf9b005e9cff$export$fec323dcfd81d750 = {
    prefix: "fas",
    iconName: "balance-scale",
    icon: [
        640,
        512,
        [],
        "f24e",
        "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$786cb0c775487f19 = {
    prefix: "fas",
    iconName: "balance-scale-left",
    icon: [
        640,
        512,
        [],
        "f515",
        "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
    ]
};
var $321daf9b005e9cff$export$2238e05f8920005a = {
    prefix: "fas",
    iconName: "balance-scale-right",
    icon: [
        640,
        512,
        [],
        "f516",
        "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
    ]
};
var $321daf9b005e9cff$export$76f704d256def3c7 = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [],
        "f05e",
        "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
    ]
};
var $321daf9b005e9cff$export$b14a1014df2fdf46 = {
    prefix: "fas",
    iconName: "band-aid",
    icon: [
        640,
        512,
        [],
        "f462",
        "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
    ]
};
var $321daf9b005e9cff$export$3825a842b5afc5aa = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
    ]
};
var $321daf9b005e9cff$export$36e9cf7887265da2 = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [],
        "f0c9",
        "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    ]
};
var $321daf9b005e9cff$export$63a3f8ceae07c7f3 = {
    prefix: "fas",
    iconName: "baseball-ball",
    icon: [
        496,
        512,
        [],
        "f433",
        "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
    ]
};
var $321daf9b005e9cff$export$36550ab8ffcc5b28 = {
    prefix: "fas",
    iconName: "basketball-ball",
    icon: [
        496,
        512,
        [],
        "f434",
        "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
    ]
};
var $321daf9b005e9cff$export$1ea66a88b8f620c9 = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [],
        "f2cd",
        "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
    ]
};
var $321daf9b005e9cff$export$1344b64f6e922e12 = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        640,
        512,
        [],
        "f244",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$9338fc4614cfc0cf = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        640,
        512,
        [],
        "f240",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
    ]
};
var $321daf9b005e9cff$export$e6dadc1155c4ee48 = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        640,
        512,
        [],
        "f242",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
    ]
};
var $321daf9b005e9cff$export$acec92052ac2183 = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        640,
        512,
        [],
        "f243",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
    ]
};
var $321daf9b005e9cff$export$cfb37069d38f379e = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        640,
        512,
        [],
        "f241",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
    ]
};
var $321daf9b005e9cff$export$f24e0fce77994d4d = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [],
        "f236",
        "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
    ]
};
var $321daf9b005e9cff$export$f74725691538983b = {
    prefix: "fas",
    iconName: "beer",
    icon: [
        448,
        512,
        [],
        "f0fc",
        "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$9b6162797ab1b255 = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    ]
};
var $321daf9b005e9cff$export$6b31a1e5968b2378 = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var $321daf9b005e9cff$export$a527a6267c55a54c = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$2eac809b0670d139 = {
    prefix: "fas",
    iconName: "bible",
    icon: [
        448,
        512,
        [],
        "f647",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $321daf9b005e9cff$export$36cb1885ad7a570f = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [],
        "f206",
        "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
    ]
};
var $321daf9b005e9cff$export$a5bcf835dbf9c0b = {
    prefix: "fas",
    iconName: "biking",
    icon: [
        640,
        512,
        [],
        "f84a",
        "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
    ]
};
var $321daf9b005e9cff$export$8a910017964bb8c2 = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
    ]
};
var $321daf9b005e9cff$export$ae3a453550dec95 = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [],
        "f780",
        "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$bdcf98f725a7241a = {
    prefix: "fas",
    iconName: "birthday-cake",
    icon: [
        448,
        512,
        [],
        "f1fd",
        "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
    ]
};
var $321daf9b005e9cff$export$db34f7a6de38784f = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
    ]
};
var $321daf9b005e9cff$export$f35a116a762ef8fc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$923de21def6ea9b6 = {
    prefix: "fas",
    iconName: "blind",
    icon: [
        384,
        512,
        [],
        "f29d",
        "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
    ]
};
var $321daf9b005e9cff$export$890d5e011054935a = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
    ]
};
var $321daf9b005e9cff$export$7e0c7fd2a2e88823 = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
    ]
};
var $321daf9b005e9cff$export$6869964aa308dd31 = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        320,
        512,
        [],
        "f0e7",
        "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
    ]
};
var $321daf9b005e9cff$export$d59078f6e80b4a67 = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [],
        "f1e2",
        "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $321daf9b005e9cff$export$5902c007d5703f2d = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        640,
        512,
        [],
        "f5d7",
        "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
    ]
};
var $321daf9b005e9cff$export$e74974fac77c468e = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
    ]
};
var $321daf9b005e9cff$export$c9d7ef726d1a8742 = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [],
        "f02d",
        "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    ]
};
var $321daf9b005e9cff$export$b98a3f8c3941a74a = {
    prefix: "fas",
    iconName: "book-dead",
    icon: [
        448,
        512,
        [],
        "f6b7",
        "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
    ]
};
var $321daf9b005e9cff$export$6feb44fec53ba30d = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
    ]
};
var $321daf9b005e9cff$export$8a3071811b2b7979 = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [],
        "f518",
        "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
    ]
};
var $321daf9b005e9cff$export$cee14fe33262fa7d = {
    prefix: "fas",
    iconName: "book-reader",
    icon: [
        512,
        512,
        [],
        "f5da",
        "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
    ]
};
var $321daf9b005e9cff$export$4ed9da5c3cca0ef1 = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [],
        "f02e",
        "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
    ]
};
var $321daf9b005e9cff$export$93a5eb721c9c0d25 = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
    ]
};
var $321daf9b005e9cff$export$2b488402ec335d97 = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$c2867ca78120d644 = {
    prefix: "fas",
    iconName: "border-style",
    icon: [
        448,
        512,
        [],
        "f853",
        "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$5ee2640fe105312d = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        496,
        512,
        [],
        "f436",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$6e7cf270cda52323 = {
    prefix: "fas",
    iconName: "box",
    icon: [
        512,
        512,
        [],
        "f466",
        "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
    ]
};
var $321daf9b005e9cff$export$9010ed816a8b9c97 = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
    ]
};
var $321daf9b005e9cff$export$f2adc06617bc0c7 = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "f95b",
        "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
    ]
};
var $321daf9b005e9cff$export$2007320dd6cde6db = {
    prefix: "fas",
    iconName: "boxes",
    icon: [
        576,
        512,
        [],
        "f468",
        "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$983e9c27cac7ed1c = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$97fa4f4c1006ab1 = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        576,
        512,
        [],
        "f5dc",
        "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
    ]
};
var $321daf9b005e9cff$export$d78e8b0681279167 = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        576,
        512,
        [],
        "f7ec",
        "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
    ]
};
var $321daf9b005e9cff$export$8da450d063b0eb37 = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [],
        "f0b1",
        "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    ]
};
var $321daf9b005e9cff$export$5000f52ca9819bf5 = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
    ]
};
var $321daf9b005e9cff$export$f68b38d51f5c0ed = {
    prefix: "fas",
    iconName: "broadcast-tower",
    icon: [
        640,
        512,
        [],
        "f519",
        "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
    ]
};
var $321daf9b005e9cff$export$2a533051418ff4ca = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        640,
        512,
        [],
        "f51a",
        "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
    ]
};
var $321daf9b005e9cff$export$5824ffe6f8983c83 = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
    ]
};
var $321daf9b005e9cff$export$a18cfac400116d9f = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
    ]
};
var $321daf9b005e9cff$export$f26673f8b10c3d46 = {
    prefix: "fas",
    iconName: "building",
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
    ]
};
var $321daf9b005e9cff$export$dacae2b4ec565333 = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        576,
        512,
        [],
        "f0a1",
        "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
    ]
};
var $321daf9b005e9cff$export$554720e3bf74fe90 = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        496,
        512,
        [],
        "f140",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
    ]
};
var $321daf9b005e9cff$export$80ed4535efc60402 = {
    prefix: "fas",
    iconName: "burn",
    icon: [
        384,
        512,
        [],
        "f46a",
        "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
    ]
};
var $321daf9b005e9cff$export$ce69441578ff2fdb = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        512,
        512,
        [],
        "f207",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$40616edfab6d332a = {
    prefix: "fas",
    iconName: "bus-alt",
    icon: [
        512,
        512,
        [],
        "f55e",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$694b7e88782dec12 = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [],
        "f64a",
        "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
    ]
};
var $321daf9b005e9cff$export$693bd40950ed2c3a = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        448,
        512,
        [],
        "f1ec",
        "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
    ]
};
var $321daf9b005e9cff$export$34f5c36a3e80efa2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [],
        "f133",
        "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
    ]
};
var $321daf9b005e9cff$export$cbc139f33cff356 = {
    prefix: "fas",
    iconName: "calendar-alt",
    icon: [
        448,
        512,
        [],
        "f073",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$5655108e1162ba45 = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
    ]
};
var $321daf9b005e9cff$export$80968bcfef6481ca = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$23e8b4955c2d951b = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
    ]
};
var $321daf9b005e9cff$export$16768a660ae3ca9d = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
    ]
};
var $321daf9b005e9cff$export$99b20d7352fbcf08 = {
    prefix: "fas",
    iconName: "calendar-times",
    icon: [
        448,
        512,
        [],
        "f273",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
    ]
};
var $321daf9b005e9cff$export$39be5cb4aed5a521 = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$84ffbd7161ca2008 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [],
        "f030",
        "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
    ]
};
var $321daf9b005e9cff$export$41dbdadc07a89b05 = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [],
        "f083",
        "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$295287303c0e9c7c = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        640,
        512,
        [],
        "f6bb",
        "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
    ]
};
var $321daf9b005e9cff$export$14d66ba7571ae0b9 = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
    ]
};
var $321daf9b005e9cff$export$8ec2f752344b69bd = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
    ]
};
var $321daf9b005e9cff$export$ba6fd4a436804a48 = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
    ]
};
var $321daf9b005e9cff$export$9eefe7fcdf123b76 = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [],
        "f1b9",
        "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $321daf9b005e9cff$export$7937ed2462a665c0 = {
    prefix: "fas",
    iconName: "car-alt",
    icon: [
        480,
        512,
        [],
        "f5de",
        "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var $321daf9b005e9cff$export$a44d0c11093d9c1e = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [],
        "f5df",
        "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
    ]
};
var $321daf9b005e9cff$export$8ff55566398404cd = {
    prefix: "fas",
    iconName: "car-crash",
    icon: [
        640,
        512,
        [],
        "f5e1",
        "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
    ]
};
var $321daf9b005e9cff$export$6f7218565b1b8d0e = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [],
        "f5e4",
        "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$afb5d0eee7c1bdb = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
    ]
};
var $321daf9b005e9cff$export$f9395ef707603e40 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    ]
};
var $321daf9b005e9cff$export$85a918a11b7643c2 = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        192,
        512,
        [],
        "f0d9",
        "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
    ]
};
var $321daf9b005e9cff$export$f1011352b01c1c0 = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        192,
        512,
        [],
        "f0da",
        "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    ]
};
var $321daf9b005e9cff$export$61aea18df1c84401 = {
    prefix: "fas",
    iconName: "caret-square-down",
    icon: [
        448,
        512,
        [],
        "f150",
        "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
    ]
};
var $321daf9b005e9cff$export$d0c8ba444f1f9581 = {
    prefix: "fas",
    iconName: "caret-square-left",
    icon: [
        448,
        512,
        [],
        "f191",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
    ]
};
var $321daf9b005e9cff$export$ae86c9de7e0f62fa = {
    prefix: "fas",
    iconName: "caret-square-right",
    icon: [
        448,
        512,
        [],
        "f152",
        "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
    ]
};
var $321daf9b005e9cff$export$307ae80b26533ce5 = {
    prefix: "fas",
    iconName: "caret-square-up",
    icon: [
        448,
        512,
        [],
        "f151",
        "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
    ]
};
var $321daf9b005e9cff$export$7de776bdab4e536d = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
    ]
};
var $321daf9b005e9cff$export$28e93ec9f5e2ddf3 = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [],
        "f787",
        "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
    ]
};
var $321daf9b005e9cff$export$9206260ff0c0c616 = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
    ]
};
var $321daf9b005e9cff$export$6675e2bf21fdb87e = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$6357093f67788b33 = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
    ]
};
var $321daf9b005e9cff$export$ab927dada03be4b3 = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        512,
        512,
        [],
        "f6be",
        "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$a881f37164b11fbf = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
    ]
};
var $321daf9b005e9cff$export$a339864ee3df7e9a = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [],
        "f6c0",
        "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
    ]
};
var $321daf9b005e9cff$export$49a36efd66df775 = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        640,
        512,
        [],
        "f51b",
        "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$443fcf69b0155291 = {
    prefix: "fas",
    iconName: "chalkboard-teacher",
    icon: [
        640,
        512,
        [],
        "f51c",
        "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
    ]
};
var $321daf9b005e9cff$export$bab2cd86f8c65657 = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
    ]
};
var $321daf9b005e9cff$export$2acab8312b7a999b = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [],
        "f1fe",
        "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
    ]
};
var $321daf9b005e9cff$export$b532f5d25de97633 = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [],
        "f080",
        "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$e022f62a119e1d93 = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [],
        "f201",
        "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
    ]
};
var $321daf9b005e9cff$export$1de7b9cf7d1b153b = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        544,
        512,
        [],
        "f200",
        "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
    ]
};
var $321daf9b005e9cff$export$62b2c752fccc6a9c = {
    prefix: "fas",
    iconName: "check",
    icon: [
        512,
        512,
        [],
        "f00c",
        "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    ]
};
var $321daf9b005e9cff$export$be9e388158c74f29 = {
    prefix: "fas",
    iconName: "check-circle",
    icon: [
        512,
        512,
        [],
        "f058",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
    ]
};
var $321daf9b005e9cff$export$f178c8c2ad3cc861 = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        512,
        512,
        [],
        "f560",
        "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
    ]
};
var $321daf9b005e9cff$export$f0c8040f596df7fe = {
    prefix: "fas",
    iconName: "check-square",
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
    ]
};
var $321daf9b005e9cff$export$549b99473b7201e6 = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
    ]
};
var $321daf9b005e9cff$export$442fddbbd741c590 = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
    ]
};
var $321daf9b005e9cff$export$a831eedd2f59c62f = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [],
        "f43a",
        "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$bd301515df6246af = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        512,
        512,
        [],
        "f43c",
        "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
    ]
};
var $321daf9b005e9cff$export$d5713874f8fefe1b = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [],
        "f43f",
        "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
    ]
};
var $321daf9b005e9cff$export$861b1f13085cf122 = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        384,
        512,
        [],
        "f441",
        "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$3db75d5ac9e98468 = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [],
        "f443",
        "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$7b8ce73615739d30 = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [],
        "f445",
        "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
    ]
};
var $321daf9b005e9cff$export$5d65c40a109eb09c = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        384,
        512,
        [],
        "f447",
        "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$9926124d75b2ecab = {
    prefix: "fas",
    iconName: "chevron-circle-down",
    icon: [
        512,
        512,
        [],
        "f13a",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
    ]
};
var $321daf9b005e9cff$export$4a42c8c2451a33fd = {
    prefix: "fas",
    iconName: "chevron-circle-left",
    icon: [
        512,
        512,
        [],
        "f137",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
    ]
};
var $321daf9b005e9cff$export$2a5db4f6eba6f2b = {
    prefix: "fas",
    iconName: "chevron-circle-right",
    icon: [
        512,
        512,
        [],
        "f138",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
    ]
};
var $321daf9b005e9cff$export$b786cf5db03f2c36 = {
    prefix: "fas",
    iconName: "chevron-circle-up",
    icon: [
        512,
        512,
        [],
        "f139",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
    ]
};
var $321daf9b005e9cff$export$8db9bc521720fccd = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        448,
        512,
        [],
        "f078",
        "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    ]
};
var $321daf9b005e9cff$export$75702e3e3dd44a44 = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [],
        "f053",
        "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
    ]
};
var $321daf9b005e9cff$export$930de8c26eb20490 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [],
        "f054",
        "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
    ]
};
var $321daf9b005e9cff$export$877e5ae47a854215 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        448,
        512,
        [],
        "f077",
        "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
    ]
};
var $321daf9b005e9cff$export$60b41e3581d1739a = {
    prefix: "fas",
    iconName: "child",
    icon: [
        384,
        512,
        [],
        "f1ae",
        "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
    ]
};
var $321daf9b005e9cff$export$16a3f12c6ae9650 = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [],
        "f51d",
        "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
    ]
};
var $321daf9b005e9cff$export$4280b2387fbdad12 = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
    ]
};
var $321daf9b005e9cff$export$9429fd8df55155d = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
    ]
};
var $321daf9b005e9cff$export$a9947c2888b3c8fd = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [],
        "f64f",
        "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
    ]
};
var $321daf9b005e9cff$export$20d8a680febc7434 = {
    prefix: "fas",
    iconName: "clinic-medical",
    icon: [
        576,
        512,
        [],
        "f7f2",
        "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
    ]
};
var $321daf9b005e9cff$export$97d84347d71ba297 = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [],
        "f328",
        "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
    ]
};
var $321daf9b005e9cff$export$7babcb2c90eb609a = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
    ]
};
var $321daf9b005e9cff$export$2c5a9d8548d8810e = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var $321daf9b005e9cff$export$95b9968e7fceb821 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [],
        "f017",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
    ]
};
var $321daf9b005e9cff$export$76c1aa4bf9a39458 = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    ]
};
var $321daf9b005e9cff$export$8e047801a8603af7 = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
    ]
};
var $321daf9b005e9cff$export$8bb3c4d5c2f50243 = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [],
        "f0c2",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
    ]
};
var $321daf9b005e9cff$export$351357a14c41f824 = {
    prefix: "fas",
    iconName: "cloud-download-alt",
    icon: [
        640,
        512,
        [],
        "f381",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
    ]
};
var $321daf9b005e9cff$export$5d120e8b87ad33f4 = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
    ]
};
var $321daf9b005e9cff$export$482eb125aaf0fbc2 = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        576,
        512,
        [],
        "f6c3",
        "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
    ]
};
var $321daf9b005e9cff$export$301c3fab0c4545bd = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $321daf9b005e9cff$export$a6c308ee087b4ded = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [],
        "f73d",
        "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
    ]
};
var $321daf9b005e9cff$export$af51c741ee9cc090 = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
    ]
};
var $321daf9b005e9cff$export$dcaadfd9c98e42a1 = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [],
        "f6c4",
        "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
    ]
};
var $321daf9b005e9cff$export$dd9dc9b4227dbe94 = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        576,
        512,
        [],
        "f743",
        "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var $321daf9b005e9cff$export$e73b3e819b9d14a5 = {
    prefix: "fas",
    iconName: "cloud-upload-alt",
    icon: [
        640,
        512,
        [],
        "f382",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
    ]
};
var $321daf9b005e9cff$export$4be708f1e41d387b = {
    prefix: "fas",
    iconName: "cocktail",
    icon: [
        576,
        512,
        [],
        "f561",
        "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
    ]
};
var $321daf9b005e9cff$export$eba095993e51cc97 = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
    ]
};
var $321daf9b005e9cff$export$aa054a78ab078db3 = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        384,
        512,
        [],
        "f126",
        "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
    ]
};
var $321daf9b005e9cff$export$1d24a9e457278011 = {
    prefix: "fas",
    iconName: "coffee",
    icon: [
        640,
        512,
        [],
        "f0f4",
        "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
    ]
};
var $321daf9b005e9cff$export$d6298bbfd1912a78 = {
    prefix: "fas",
    iconName: "cog",
    icon: [
        512,
        512,
        [],
        "f013",
        "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $321daf9b005e9cff$export$af1575770afc9559 = {
    prefix: "fas",
    iconName: "cogs",
    icon: [
        640,
        512,
        [],
        "f085",
        "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
    ]
};
var $321daf9b005e9cff$export$bc5da164799a0e = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
    ]
};
var $321daf9b005e9cff$export$bb861166644ac28a = {
    prefix: "fas",
    iconName: "columns",
    icon: [
        512,
        512,
        [],
        "f0db",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
    ]
};
var $321daf9b005e9cff$export$805cd88398a70581 = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
    ]
};
var $321daf9b005e9cff$export$6e96904d9af0ec4a = {
    prefix: "fas",
    iconName: "comment-alt",
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
    ]
};
var $321daf9b005e9cff$export$7a088030853df12c = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
    ]
};
var $321daf9b005e9cff$export$63ffcb3d4e94cb92 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$101422b773924276 = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
    ]
};
var $321daf9b005e9cff$export$3786a0422a3f33ea = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $321daf9b005e9cff$export$932912e74adb8939 = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        576,
        512,
        [],
        "f086",
        "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
    ]
};
var $321daf9b005e9cff$export$d477129b070e5ac4 = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        576,
        512,
        [],
        "f653",
        "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
    ]
};
var $321daf9b005e9cff$export$84021631df0f831b = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        496,
        512,
        [],
        "f51f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$b4d344633433e50e = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        496,
        512,
        [],
        "f14e",
        "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
    ]
};
var $321daf9b005e9cff$export$83632d1150d3541f = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $321daf9b005e9cff$export$a05650ebe54bede = {
    prefix: "fas",
    iconName: "compress-alt",
    icon: [
        448,
        512,
        [],
        "f422",
        "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
    ]
};
var $321daf9b005e9cff$export$39205db0ea980efd = {
    prefix: "fas",
    iconName: "compress-arrows-alt",
    icon: [
        512,
        512,
        [],
        "f78c",
        "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
    ]
};
var $321daf9b005e9cff$export$ad92ffbbfbc0fcf3 = {
    prefix: "fas",
    iconName: "concierge-bell",
    icon: [
        512,
        512,
        [],
        "f562",
        "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$b3e64f5f68c6623f = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [],
        "f563",
        "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$317dde8664f7de71 = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$e9bd786d30cb716c = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
    ]
};
var $321daf9b005e9cff$export$da61665fff8aebfe = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
    ]
};
var $321daf9b005e9cff$export$ce96e32767a7dd51 = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
    ]
};
var $321daf9b005e9cff$export$3e7437bf6535bef0 = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [],
        "f09d",
        "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
    ]
};
var $321daf9b005e9cff$export$afa58590dfb6fca2 = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$d932915fde4f1010 = {
    prefix: "fas",
    iconName: "crop-alt",
    icon: [
        512,
        512,
        [],
        "f565",
        "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
    ]
};
var $321daf9b005e9cff$export$9d0a89fcd084abb = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [],
        "f654",
        "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$721c101130c40043 = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ]
};
var $321daf9b005e9cff$export$bfa312207b788ed9 = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$dc1083dcd1d7b9d6 = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        640,
        512,
        [],
        "f521",
        "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$e94134641c0e2 = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
    ]
};
var $321daf9b005e9cff$export$973ae4f1e4d2ce78 = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
    ]
};
var $321daf9b005e9cff$export$30523a9441a31e97 = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        512,
        512,
        [],
        "f1b3",
        "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
    ]
};
var $321daf9b005e9cff$export$66847f2a71b260e7 = {
    prefix: "fas",
    iconName: "cut",
    icon: [
        448,
        512,
        [],
        "f0c4",
        "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$24680dede86b1883 = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
    ]
};
var $321daf9b005e9cff$export$4b666adf83f0de01 = {
    prefix: "fas",
    iconName: "deaf",
    icon: [
        512,
        512,
        [],
        "f2a4",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
    ]
};
var $321daf9b005e9cff$export$a1672d808fbed0bd = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
    ]
};
var $321daf9b005e9cff$export$6e6ddc253102e596 = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [],
        "f108",
        "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
    ]
};
var $321daf9b005e9cff$export$45cbd92c28deb2c7 = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [],
        "f655",
        "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
    ]
};
var $321daf9b005e9cff$export$68bad2b52a90d1fa = {
    prefix: "fas",
    iconName: "diagnoses",
    icon: [
        640,
        512,
        [],
        "f470",
        "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$4ed8206e6619cc8f = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [],
        "f522",
        "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$b06003a02c9055bd = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        480,
        512,
        [],
        "f6cf",
        "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
    ]
};
var $321daf9b005e9cff$export$64bfd48ed353c031 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
    ]
};
var $321daf9b005e9cff$export$d9769fb795c2db82 = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [],
        "f523",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$2df6451abf70a6ff = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [],
        "f524",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$d91800b7be5303b0 = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [],
        "f525",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$3397c7b4679acccc = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [],
        "f526",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$221059e0d5fd8958 = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [],
        "f527",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$4d85df590065572f = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [],
        "f528",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$b3bf1994f0fefe98 = {
    prefix: "fas",
    iconName: "digital-tachograph",
    icon: [
        640,
        512,
        [],
        "f566",
        "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
    ]
};
var $321daf9b005e9cff$export$6a6973de44442fe5 = {
    prefix: "fas",
    iconName: "directions",
    icon: [
        512,
        512,
        [],
        "f5eb",
        "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
    ]
};
var $321daf9b005e9cff$export$c7675a37487adc45 = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
    ]
};
var $321daf9b005e9cff$export$89fa217ec5503ac9 = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [],
        "f529",
        "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$89a2b10dabc487e8 = {
    prefix: "fas",
    iconName: "dizzy",
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
    ]
};
var $321daf9b005e9cff$export$c062100d54a2da00 = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [],
        "f471",
        "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
    ]
};
var $321daf9b005e9cff$export$c6406747800cf702 = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [],
        "f6d3",
        "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
    ]
};
var $321daf9b005e9cff$export$fb420d3e4d8c6a18 = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        288,
        512,
        [],
        "f155",
        "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
    ]
};
var $321daf9b005e9cff$export$5879d0bca1aa497b = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [],
        "f472",
        "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$f7c6efb60c53b285 = {
    prefix: "fas",
    iconName: "dolly-flatbed",
    icon: [
        640,
        512,
        [],
        "f474",
        "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$40050ae52860cde7 = {
    prefix: "fas",
    iconName: "donate",
    icon: [
        512,
        512,
        [],
        "f4b9",
        "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$2c79e1a422528bba = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        640,
        512,
        [],
        "f52a",
        "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$41821b9a6fd703de = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        640,
        512,
        [],
        "f52b",
        "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
    ]
};
var $321daf9b005e9cff$export$92bc269cb244d66a = {
    prefix: "fas",
    iconName: "dot-circle",
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
    ]
};
var $321daf9b005e9cff$export$a1ab1e69a300089f = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [],
        "f4ba",
        "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$8f734e51d72ca13a = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $321daf9b005e9cff$export$c8c2b127d13b9d79 = {
    prefix: "fas",
    iconName: "drafting-compass",
    icon: [
        512,
        512,
        [],
        "f568",
        "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
    ]
};
var $321daf9b005e9cff$export$ae1875ba975aa0e9 = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [],
        "f6d5",
        "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
    ]
};
var $321daf9b005e9cff$export$df9bd3777d1154d2 = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$5b9205e1042594b7 = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [],
        "f569",
        "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
    ]
};
var $321daf9b005e9cff$export$48d1206500db2e9d = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
    ]
};
var $321daf9b005e9cff$export$482976e9a4ab10f3 = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
    ]
};
var $321daf9b005e9cff$export$56700074cf37be5c = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$3b934e22d1851a3b = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$25e9b29b3f2230b5 = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
    ]
};
var $321daf9b005e9cff$export$1156dc6acb0058bd = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
    ]
};
var $321daf9b005e9cff$export$7be713e57d023733 = {
    prefix: "fas",
    iconName: "edit",
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
    ]
};
var $321daf9b005e9cff$export$1199a8ce85311ab5 = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [],
        "f7fb",
        "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
    ]
};
var $321daf9b005e9cff$export$8484041d5b209494 = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [],
        "f052",
        "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
    ]
};
var $321daf9b005e9cff$export$c9f2fedd4489a2ee = {
    prefix: "fas",
    iconName: "ellipsis-h",
    icon: [
        512,
        512,
        [],
        "f141",
        "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
    ]
};
var $321daf9b005e9cff$export$e58494c7fcb5380 = {
    prefix: "fas",
    iconName: "ellipsis-v",
    icon: [
        192,
        512,
        [],
        "f142",
        "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
    ]
};
var $321daf9b005e9cff$export$6f095630677adc = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    ]
};
var $321daf9b005e9cff$export$c6c3bd5f7d9b8bf2 = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
    ]
};
var $321daf9b005e9cff$export$f5c53ce8ec380d11 = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
    ]
};
var $321daf9b005e9cff$export$354e159473e73552 = {
    prefix: "fas",
    iconName: "envelope-square",
    icon: [
        448,
        512,
        [],
        "f199",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
    ]
};
var $321daf9b005e9cff$export$a7c5f5e4805fdab = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [],
        "f52c",
        "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$e7fc4fe34e767f28 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        512,
        512,
        [],
        "f12d",
        "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
    ]
};
var $321daf9b005e9cff$export$6bad2c9f317b52e5 = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$902a3969bb113dff = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [],
        "f153",
        "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
    ]
};
var $321daf9b005e9cff$export$f6c6fb20d374b128 = {
    prefix: "fas",
    iconName: "exchange-alt",
    icon: [
        512,
        512,
        [],
        "f362",
        "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$de6218b649cbb6a9 = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        192,
        512,
        [],
        "f12a",
        "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
    ]
};
var $321daf9b005e9cff$export$220e07e14c5d7e5d = {
    prefix: "fas",
    iconName: "exclamation-circle",
    icon: [
        512,
        512,
        [],
        "f06a",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $321daf9b005e9cff$export$3d249b63b52cce7c = {
    prefix: "fas",
    iconName: "exclamation-triangle",
    icon: [
        576,
        512,
        [],
        "f071",
        "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var $321daf9b005e9cff$export$1fe4a9976a241685 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
    ]
};
var $321daf9b005e9cff$export$bcb8d86a3a1d6eb6 = {
    prefix: "fas",
    iconName: "expand-alt",
    icon: [
        448,
        512,
        [],
        "f424",
        "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
    ]
};
var $321daf9b005e9cff$export$6219dcd88b5fa6c2 = {
    prefix: "fas",
    iconName: "expand-arrows-alt",
    icon: [
        448,
        512,
        [],
        "f31e",
        "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
    ]
};
var $321daf9b005e9cff$export$d7f107e456ab0306 = {
    prefix: "fas",
    iconName: "external-link-alt",
    icon: [
        512,
        512,
        [],
        "f35d",
        "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    ]
};
var $321daf9b005e9cff$export$e4cdf2977151ee26 = {
    prefix: "fas",
    iconName: "external-link-square-alt",
    icon: [
        448,
        512,
        [],
        "f360",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$b8c3e79e8c99c95b = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [],
        "f06e",
        "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    ]
};
var $321daf9b005e9cff$export$1bc3e0ad56dc9eb0 = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [],
        "f1fb",
        "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
    ]
};
var $321daf9b005e9cff$export$ed3f2918429d029a = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
    ]
};
var $321daf9b005e9cff$export$55145a3dae4f984a = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $321daf9b005e9cff$export$e6246a3279a379b8 = {
    prefix: "fas",
    iconName: "fast-backward",
    icon: [
        512,
        512,
        [],
        "f049",
        "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
    ]
};
var $321daf9b005e9cff$export$61a8cdc53c2e078d = {
    prefix: "fas",
    iconName: "fast-forward",
    icon: [
        512,
        512,
        [],
        "f050",
        "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
    ]
};
var $321daf9b005e9cff$export$a0856b225f3b0614 = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "f905",
        "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
    ]
};
var $321daf9b005e9cff$export$b5698497901d7197 = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [],
        "f1ac",
        "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
    ]
};
var $321daf9b005e9cff$export$5e19aea195b31816 = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [],
        "f52d",
        "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
    ]
};
var $321daf9b005e9cff$export$68cf766c786bcd78 = {
    prefix: "fas",
    iconName: "feather-alt",
    icon: [
        512,
        512,
        [],
        "f56b",
        "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
    ]
};
var $321daf9b005e9cff$export$70e8e75e61dd7169 = {
    prefix: "fas",
    iconName: "female",
    icon: [
        256,
        512,
        [],
        "f182",
        "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
    ]
};
var $321daf9b005e9cff$export$102b809faf56e033 = {
    prefix: "fas",
    iconName: "fighter-jet",
    icon: [
        640,
        512,
        [],
        "f0fb",
        "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
    ]
};
var $321daf9b005e9cff$export$cad54bead856a678 = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [],
        "f15b",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $321daf9b005e9cff$export$243b47dca32bf0b8 = {
    prefix: "fas",
    iconName: "file-alt",
    icon: [
        384,
        512,
        [],
        "f15c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $321daf9b005e9cff$export$bf2047a9946b5c3f = {
    prefix: "fas",
    iconName: "file-archive",
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
    ]
};
var $321daf9b005e9cff$export$b8d24c57c9e64933 = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $321daf9b005e9cff$export$143d0ca7d2200f20 = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
    ]
};
var $321daf9b005e9cff$export$70fde3f3fdaa6a6a = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $321daf9b005e9cff$export$82cea4f586f6ec9 = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $321daf9b005e9cff$export$1013b9966d758343 = {
    prefix: "fas",
    iconName: "file-download",
    icon: [
        384,
        512,
        [],
        "f56d",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $321daf9b005e9cff$export$77cb1a465c4fe84 = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $321daf9b005e9cff$export$364f19abcfac1b0a = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [],
        "f56e",
        "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
    ]
};
var $321daf9b005e9cff$export$6440b286d3cbac9b = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
    ]
};
var $321daf9b005e9cff$export$d796c05153b1255c = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [],
        "f56f",
        "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
    ]
};
var $321daf9b005e9cff$export$bef39294aed2281a = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
    ]
};
var $321daf9b005e9cff$export$a3dced32d48cb1ea = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
    ]
};
var $321daf9b005e9cff$export$56cbcd962389b090 = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
    ]
};
var $321daf9b005e9cff$export$ef02a0f5b39aa61f = {
    prefix: "fas",
    iconName: "file-medical-alt",
    icon: [
        448,
        512,
        [],
        "f478",
        "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $321daf9b005e9cff$export$38611f1c776aba73 = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
    ]
};
var $321daf9b005e9cff$export$c341daeecdea449a = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
    ]
};
var $321daf9b005e9cff$export$a20cb90865b6beb8 = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $321daf9b005e9cff$export$d0de575ac166712b = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
    ]
};
var $321daf9b005e9cff$export$dd55ded1264643d2 = {
    prefix: "fas",
    iconName: "file-upload",
    icon: [
        384,
        512,
        [],
        "f574",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var $321daf9b005e9cff$export$b44eb38345c6a964 = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
    ]
};
var $321daf9b005e9cff$export$f0858dff6e769cf6 = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var $321daf9b005e9cff$export$d3c2bcfd3b861e4a = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
    ]
};
var $321daf9b005e9cff$export$38320138fc0262d0 = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
    ]
};
var $321daf9b005e9cff$export$c03de0cc616e77bb = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [],
        "f008",
        "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $321daf9b005e9cff$export$f253a38d7142e29f = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    ]
};
var $321daf9b005e9cff$export$614dc068d88655af = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
    ]
};
var $321daf9b005e9cff$export$7b24b34ef6cc130c = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        384,
        512,
        [],
        "f06d",
        "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
    ]
};
var $321daf9b005e9cff$export$70dc26b4926d0b1b = {
    prefix: "fas",
    iconName: "fire-alt",
    icon: [
        448,
        512,
        [],
        "f7e4",
        "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
    ]
};
var $321daf9b005e9cff$export$d75fb6743634a0a = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        448,
        512,
        [],
        "f134",
        "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$5b01ccb2da4c4387 = {
    prefix: "fas",
    iconName: "first-aid",
    icon: [
        576,
        512,
        [],
        "f479",
        "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$24228a855c5f6812 = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [],
        "f578",
        "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$fa0323a4d7489a8d = {
    prefix: "fas",
    iconName: "fist-raised",
    icon: [
        384,
        512,
        [],
        "f6de",
        "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
    ]
};
var $321daf9b005e9cff$export$6591b1ea509be9da = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        512,
        512,
        [],
        "f024",
        "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
    ]
};
var $321daf9b005e9cff$export$92fad97e19a9fea = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        512,
        512,
        [],
        "f11e",
        "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
    ]
};
var $321daf9b005e9cff$export$19357abad396e723 = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        512,
        512,
        [],
        "f74d",
        "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$f9b579ba06048af = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
    ]
};
var $321daf9b005e9cff$export$dfd2bd012685aeac = {
    prefix: "fas",
    iconName: "flushed",
    icon: [
        496,
        512,
        [],
        "f579",
        "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
    ]
};
var $321daf9b005e9cff$export$72b780186370e953 = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$758f1fb3784e4080 = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
    ]
};
var $321daf9b005e9cff$export$ff7e93418af88b78 = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [],
        "f07c",
        "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
    ]
};
var $321daf9b005e9cff$export$e18e05ffa2045d3b = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
    ]
};
var $321daf9b005e9cff$export$a5dc297d3f60936 = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
    ]
};
var $321daf9b005e9cff$export$6e20d421a2e0f320 = {
    prefix: "fas",
    iconName: "font-awesome-logo-full",
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var $321daf9b005e9cff$export$e8fd664711e31704 = {
    prefix: "fas",
    iconName: "football-ball",
    icon: [
        496,
        512,
        [],
        "f44e",
        "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
    ]
};
var $321daf9b005e9cff$export$a8710cdb23198d53 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [],
        "f04e",
        "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
    ]
};
var $321daf9b005e9cff$export$fe2358263efac504 = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$43b7108508aecc5f = {
    prefix: "fas",
    iconName: "frown",
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
    ]
};
var $321daf9b005e9cff$export$c4775e66bed5d96 = {
    prefix: "fas",
    iconName: "frown-open",
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$cebe38ad8f0a143d = {
    prefix: "fas",
    iconName: "funnel-dollar",
    icon: [
        640,
        512,
        [],
        "f662",
        "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
    ]
};
var $321daf9b005e9cff$export$65a345b33858a655 = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [],
        "f1e3",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
    ]
};
var $321daf9b005e9cff$export$6a66b1b639455bef = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
    ]
};
var $321daf9b005e9cff$export$84666c793cb2a347 = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [],
        "f52f",
        "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
    ]
};
var $321daf9b005e9cff$export$c36fb40057e2c3aa = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [],
        "f0e3",
        "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
    ]
};
var $321daf9b005e9cff$export$31ee86ac717db552 = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
    ]
};
var $321daf9b005e9cff$export$c093cc22e88981c2 = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        288,
        512,
        [],
        "f22d",
        "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
    ]
};
var $321daf9b005e9cff$export$1a989eb1919c64c1 = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [],
        "f6e2",
        "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$b2727de8ccdbb5ec = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [],
        "f06b",
        "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $321daf9b005e9cff$export$de9a67b55dbe819a = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
    ]
};
var $321daf9b005e9cff$export$20007d7d74cb98fe = {
    prefix: "fas",
    iconName: "glass-cheers",
    icon: [
        640,
        512,
        [],
        "f79f",
        "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
    ]
};
var $321daf9b005e9cff$export$e96f280e39af4a91 = {
    prefix: "fas",
    iconName: "glass-martini",
    icon: [
        512,
        512,
        [],
        "f000",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
    ]
};
var $321daf9b005e9cff$export$2258439b8f4e7acb = {
    prefix: "fas",
    iconName: "glass-martini-alt",
    icon: [
        512,
        512,
        [],
        "f57b",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
    ]
};
var $321daf9b005e9cff$export$fdec0f5f1a169419 = {
    prefix: "fas",
    iconName: "glass-whiskey",
    icon: [
        512,
        512,
        [],
        "f7a0",
        "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
    ]
};
var $321daf9b005e9cff$export$58d7d709c0a8ca5f = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
    ]
};
var $321daf9b005e9cff$export$b1b1cdce4a19c682 = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        496,
        512,
        [],
        "f0ac",
        "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
    ]
};
var $321daf9b005e9cff$export$64af36f3b403a57c = {
    prefix: "fas",
    iconName: "globe-africa",
    icon: [
        496,
        512,
        [],
        "f57c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
    ]
};
var $321daf9b005e9cff$export$e96bcc7bde9498db = {
    prefix: "fas",
    iconName: "globe-americas",
    icon: [
        496,
        512,
        [],
        "f57d",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
    ]
};
var $321daf9b005e9cff$export$796fdfc909e603f4 = {
    prefix: "fas",
    iconName: "globe-asia",
    icon: [
        496,
        512,
        [],
        "f57e",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
    ]
};
var $321daf9b005e9cff$export$5318b8ede86cc96b = {
    prefix: "fas",
    iconName: "globe-europe",
    icon: [
        496,
        512,
        [],
        "f7a2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
    ]
};
var $321daf9b005e9cff$export$2251487a9a33c682 = {
    prefix: "fas",
    iconName: "golf-ball",
    icon: [
        416,
        512,
        [],
        "f450",
        "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
    ]
};
var $321daf9b005e9cff$export$31f89d8ac1d14ed6 = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $321daf9b005e9cff$export$874e305fd7920cce = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [],
        "f19d",
        "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
    ]
};
var $321daf9b005e9cff$export$da07b6bc24a496ca = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [],
        "f531",
        "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
    ]
};
var $321daf9b005e9cff$export$7bf8dfe2e6661a54 = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$3d08cd36ac1ef231 = {
    prefix: "fas",
    iconName: "grimace",
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
    ]
};
var $321daf9b005e9cff$export$37e1f10b6de76621 = {
    prefix: "fas",
    iconName: "grin",
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $321daf9b005e9cff$export$b4abebfe416d36ba = {
    prefix: "fas",
    iconName: "grin-alt",
    icon: [
        496,
        512,
        [],
        "f581",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $321daf9b005e9cff$export$734da5249381ec7e = {
    prefix: "fas",
    iconName: "grin-beam",
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $321daf9b005e9cff$export$14d0ccc54c5b6826 = {
    prefix: "fas",
    iconName: "grin-beam-sweat",
    icon: [
        504,
        512,
        [],
        "f583",
        "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $321daf9b005e9cff$export$c56cf0e0c3bc5ed2 = {
    prefix: "fas",
    iconName: "grin-hearts",
    icon: [
        496,
        512,
        [],
        "f584",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
    ]
};
var $321daf9b005e9cff$export$243ae757907b1580 = {
    prefix: "fas",
    iconName: "grin-squint",
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $321daf9b005e9cff$export$542206d6a85f3b42 = {
    prefix: "fas",
    iconName: "grin-squint-tears",
    icon: [
        512,
        512,
        [],
        "f586",
        "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
    ]
};
var $321daf9b005e9cff$export$64347a5c8c402ef4 = {
    prefix: "fas",
    iconName: "grin-stars",
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
    ]
};
var $321daf9b005e9cff$export$b2f7512221512b5b = {
    prefix: "fas",
    iconName: "grin-tears",
    icon: [
        640,
        512,
        [],
        "f588",
        "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var $321daf9b005e9cff$export$ef222816a43a4b3a = {
    prefix: "fas",
    iconName: "grin-tongue",
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $321daf9b005e9cff$export$4edf34c3def09a31 = {
    prefix: "fas",
    iconName: "grin-tongue-squint",
    icon: [
        496,
        512,
        [],
        "f58a",
        "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
    ]
};
var $321daf9b005e9cff$export$58099903d50aefb3 = {
    prefix: "fas",
    iconName: "grin-tongue-wink",
    icon: [
        496,
        512,
        [],
        "f58b",
        "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var $321daf9b005e9cff$export$2397fcd34eb12177 = {
    prefix: "fas",
    iconName: "grin-wink",
    icon: [
        496,
        512,
        [],
        "f58c",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
    ]
};
var $321daf9b005e9cff$export$4a45308d6c8decc1 = {
    prefix: "fas",
    iconName: "grip-horizontal",
    icon: [
        448,
        512,
        [],
        "f58d",
        "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$1412f35381064d7d = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        512,
        512,
        [],
        "f7a4",
        "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$523960de087f5198 = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        256,
        512,
        [],
        "f7a5",
        "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
    ]
};
var $321daf9b005e9cff$export$cacbd95c283996ec = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$790dd5b32282b6fb = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
    ]
};
var $321daf9b005e9cff$export$f08bbcf8f59eafc2 = {
    prefix: "fas",
    iconName: "h-square",
    icon: [
        448,
        512,
        [],
        "f0fd",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$bab3bb9f4f59363 = {
    prefix: "fas",
    iconName: "hamburger",
    icon: [
        512,
        512,
        [],
        "f805",
        "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
    ]
};
var $321daf9b005e9cff$export$6310f315e1ebbca5 = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [],
        "f6e3",
        "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
    ]
};
var $321daf9b005e9cff$export$38d20d399463edf9 = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$e6094d25274088ab = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $321daf9b005e9cff$export$97e5ef3e80a0fbef = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $321daf9b005e9cff$export$bb2a6b1b5e852300 = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "f95c",
        "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
    ]
};
var $321daf9b005e9cff$export$47d27bc305b59690 = {
    prefix: "fas",
    iconName: "hand-holding-usd",
    icon: [
        576,
        512,
        [],
        "f4c0",
        "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
    ]
};
var $321daf9b005e9cff$export$4265371b99d38b95 = {
    prefix: "fas",
    iconName: "hand-holding-water",
    icon: [
        576,
        512,
        [],
        "f4c1",
        "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var $321daf9b005e9cff$export$54608d0a883fea4d = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        576,
        512,
        [],
        "f258",
        "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
    ]
};
var $321daf9b005e9cff$export$bd40d3a3a16fb147 = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        512,
        512,
        [],
        "f806",
        "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
    ]
};
var $321daf9b005e9cff$export$6e6216c8b50471bb = {
    prefix: "fas",
    iconName: "hand-paper",
    icon: [
        448,
        512,
        [],
        "f256",
        "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
    ]
};
var $321daf9b005e9cff$export$e49e3cfceea441cc = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        448,
        512,
        [],
        "f25b",
        "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
    ]
};
var $321daf9b005e9cff$export$f6dcbf0a940428f4 = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $321daf9b005e9cff$export$b276ec3dc9760d39 = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
    ]
};
var $321daf9b005e9cff$export$f7bc8714c970afa4 = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var $321daf9b005e9cff$export$cdc9f5e7e94e76da = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [],
        "f0a6",
        "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
    ]
};
var $321daf9b005e9cff$export$d97ff927c450c87f = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
    ]
};
var $321daf9b005e9cff$export$97a81eba394c8c44 = {
    prefix: "fas",
    iconName: "hand-rock",
    icon: [
        512,
        512,
        [],
        "f255",
        "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
    ]
};
var $321daf9b005e9cff$export$c578e919f2c5c135 = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
    ]
};
var $321daf9b005e9cff$export$72e2d874a963de0c = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "f95d",
        "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
    ]
};
var $321daf9b005e9cff$export$2262d6b626de1120 = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        512,
        512,
        [],
        "f259",
        "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
    ]
};
var $321daf9b005e9cff$export$f9712d0cf5150f0c = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$287dbb1632da0d44 = {
    prefix: "fas",
    iconName: "hands-helping",
    icon: [
        640,
        512,
        [],
        "f4c4",
        "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
    ]
};
var $321daf9b005e9cff$export$996b5dea53b124e3 = {
    prefix: "fas",
    iconName: "hands-wash",
    icon: [
        576,
        512,
        [],
        "f95e",
        "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
    ]
};
var $321daf9b005e9cff$export$b4c63e9bfc7906f1 = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
    ]
};
var $321daf9b005e9cff$export$ca302f956ae9f1bf = {
    prefix: "fas",
    iconName: "handshake-alt-slash",
    icon: [
        640,
        512,
        [],
        "f95f",
        "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
    ]
};
var $321daf9b005e9cff$export$2cef3f81ad90fb76 = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "f960",
        "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
    ]
};
var $321daf9b005e9cff$export$3dcd4ca3f7108a82 = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [],
        "f6e6",
        "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
    ]
};
var $321daf9b005e9cff$export$7b72177558a98b6f = {
    prefix: "fas",
    iconName: "hard-hat",
    icon: [
        512,
        512,
        [],
        "f807",
        "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$c92c903bade56844 = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [],
        "f292",
        "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
    ]
};
var $321daf9b005e9cff$export$37672611144b857b = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
    ]
};
var $321daf9b005e9cff$export$ab6f71fd6878da90 = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
    ]
};
var $321daf9b005e9cff$export$7daa48199dcb2ad1 = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
    ]
};
var $321daf9b005e9cff$export$62551e9c5ba7093f = {
    prefix: "fas",
    iconName: "hdd",
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$3cd04b7c1624f598 = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "f961",
        "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
    ]
};
var $321daf9b005e9cff$export$b293ee8fb8e6b0c4 = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "f962",
        "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
    ]
};
var $321daf9b005e9cff$export$280300af4baa1a3e = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        512,
        512,
        [],
        "f963",
        "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
    ]
};
var $321daf9b005e9cff$export$5b64b916710da7c7 = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "f964",
        "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
    ]
};
var $321daf9b005e9cff$export$4805b8d175aeb9fb = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        512,
        512,
        [],
        "f1dc",
        "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
    ]
};
var $321daf9b005e9cff$export$ad02dd8ca5816958 = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [],
        "f025",
        "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
    ]
};
var $321daf9b005e9cff$export$6f0433fa527dd5be = {
    prefix: "fas",
    iconName: "headphones-alt",
    icon: [
        512,
        512,
        [],
        "f58f",
        "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
    ]
};
var $321daf9b005e9cff$export$23b086400a31acfe = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
    ]
};
var $321daf9b005e9cff$export$e4b51a47a2f8b9db = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [],
        "f004",
        "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
    ]
};
var $321daf9b005e9cff$export$4a565395cb65b282 = {
    prefix: "fas",
    iconName: "heart-broken",
    icon: [
        512,
        512,
        [],
        "f7a9",
        "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $321daf9b005e9cff$export$ca880e19206e80aa = {
    prefix: "fas",
    iconName: "heartbeat",
    icon: [
        512,
        512,
        [],
        "f21e",
        "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var $321daf9b005e9cff$export$612d3e1afaf45fa5 = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [],
        "f533",
        "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
    ]
};
var $321daf9b005e9cff$export$73801ed54b42fabe = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        544,
        512,
        [],
        "f591",
        "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
    ]
};
var $321daf9b005e9cff$export$b2ab0105a901499e = {
    prefix: "fas",
    iconName: "hiking",
    icon: [
        384,
        512,
        [],
        "f6ec",
        "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
    ]
};
var $321daf9b005e9cff$export$d4c909619093de2d = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [],
        "f6ed",
        "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$76d1986559ca7b7a = {
    prefix: "fas",
    iconName: "history",
    icon: [
        512,
        512,
        [],
        "f1da",
        "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
    ]
};
var $321daf9b005e9cff$export$a274b02dc75663dc = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
    ]
};
var $321daf9b005e9cff$export$273296afacf93991 = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        448,
        512,
        [],
        "f7aa",
        "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
    ]
};
var $321daf9b005e9cff$export$48f10d71ec526479 = {
    prefix: "fas",
    iconName: "home",
    icon: [
        576,
        512,
        [],
        "f015",
        "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    ]
};
var $321daf9b005e9cff$export$5b05f097fa38352a = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [],
        "f6f0",
        "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$5bcca85203ebd1e8 = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$7a76c9d35b42d691 = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
    ]
};
var $321daf9b005e9cff$export$cea7736417b94a3b = {
    prefix: "fas",
    iconName: "hospital-alt",
    icon: [
        576,
        512,
        [],
        "f47d",
        "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var $321daf9b005e9cff$export$c8a3c78d99c23fed = {
    prefix: "fas",
    iconName: "hospital-symbol",
    icon: [
        512,
        512,
        [],
        "f47e",
        "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
    ]
};
var $321daf9b005e9cff$export$684703c93d630cc5 = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        640,
        512,
        [],
        "f80d",
        "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
    ]
};
var $321daf9b005e9cff$export$4842af92b516c40b = {
    prefix: "fas",
    iconName: "hot-tub",
    icon: [
        512,
        512,
        [],
        "f593",
        "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
    ]
};
var $321daf9b005e9cff$export$9fae219b4d3ce0be = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [],
        "f80f",
        "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
    ]
};
var $321daf9b005e9cff$export$c402efcf01d5ca07 = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        576,
        512,
        [],
        "f594",
        "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $321daf9b005e9cff$export$b9098a890f61e022 = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [],
        "f254",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
    ]
};
var $321daf9b005e9cff$export$52757ecc5b1e25b9 = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [],
        "f253",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
    ]
};
var $321daf9b005e9cff$export$703272eebf5e3eea = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [],
        "f252",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
    ]
};
var $321daf9b005e9cff$export$f0c28584caa8f4b = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [],
        "f251",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
    ]
};
var $321daf9b005e9cff$export$8d7e943005ce0b49 = {
    prefix: "fas",
    iconName: "house-damage",
    icon: [
        576,
        512,
        [],
        "f6f1",
        "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
    ]
};
var $321daf9b005e9cff$export$9a513ee921e8e885 = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [],
        "f965",
        "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
    ]
};
var $321daf9b005e9cff$export$33d5f94bd6f75f59 = {
    prefix: "fas",
    iconName: "hryvnia",
    icon: [
        384,
        512,
        [],
        "f6f2",
        "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
    ]
};
var $321daf9b005e9cff$export$7fddf76ec23943d8 = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
    ]
};
var $321daf9b005e9cff$export$dd52741c60cc638f = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [],
        "f810",
        "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
    ]
};
var $321daf9b005e9cff$export$78792ed87d92a3ad = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
    ]
};
var $321daf9b005e9cff$export$7fe2894454d8eb8a = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [],
        "f86d",
        "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
    ]
};
var $321daf9b005e9cff$export$a75288855ea05282 = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $321daf9b005e9cff$export$782ac893fc22249b = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
    ]
};
var $321daf9b005e9cff$export$dc37ebbac31f6c6c = {
    prefix: "fas",
    iconName: "id-card-alt",
    icon: [
        576,
        512,
        [],
        "f47f",
        "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
    ]
};
var $321daf9b005e9cff$export$4a284575edd6f1af = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
    ]
};
var $321daf9b005e9cff$export$7e9f0928967e03b = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
    ]
};
var $321daf9b005e9cff$export$74f06b41ed2ca28a = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
    ]
};
var $321daf9b005e9cff$export$366b69cbdce46334 = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        576,
        512,
        [],
        "f01c",
        "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
    ]
};
var $321daf9b005e9cff$export$318208bc30aeebcc = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$5548c3eb51060fa8 = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        512,
        512,
        [],
        "f275",
        "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
    ]
};
var $321daf9b005e9cff$export$a590003279d671b8 = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [],
        "f534",
        "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
    ]
};
var $321daf9b005e9cff$export$d469b770895f47ac = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
    ]
};
var $321daf9b005e9cff$export$aa9288aeadf882fa = {
    prefix: "fas",
    iconName: "info-circle",
    icon: [
        512,
        512,
        [],
        "f05a",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    ]
};
var $321daf9b005e9cff$export$16e344bae4d495ed = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        320,
        512,
        [],
        "f033",
        "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
    ]
};
var $321daf9b005e9cff$export$859f204e59641ca4 = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
    ]
};
var $321daf9b005e9cff$export$e5a289fb22ffb8cb = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$66a0d8d45aab6631 = {
    prefix: "fas",
    iconName: "journal-whills",
    icon: [
        448,
        512,
        [],
        "f66a",
        "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
    ]
};
var $321daf9b005e9cff$export$ab1408bfbe914cc9 = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [],
        "f66b",
        "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
    ]
};
var $321daf9b005e9cff$export$fa6ecc35e7315db = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [],
        "f084",
        "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
    ]
};
var $321daf9b005e9cff$export$fb61df5d98785fa8 = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $321daf9b005e9cff$export$8d41d1f1ba3f9217 = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [],
        "f66d",
        "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
    ]
};
var $321daf9b005e9cff$export$c762a77aabf64fd0 = {
    prefix: "fas",
    iconName: "kiss",
    icon: [
        496,
        512,
        [],
        "f596",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$d6ff8a73c0812e63 = {
    prefix: "fas",
    iconName: "kiss-beam",
    icon: [
        496,
        512,
        [],
        "f597",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
    ]
};
var $321daf9b005e9cff$export$ebba617701dfb917 = {
    prefix: "fas",
    iconName: "kiss-wink-heart",
    icon: [
        504,
        512,
        [],
        "f598",
        "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
    ]
};
var $321daf9b005e9cff$export$d9933d91e1314d02 = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
    ]
};
var $321daf9b005e9cff$export$2bebc54c51db6505 = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [],
        "f66f",
        "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$8a7bee49fdf8c954 = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
    ]
};
var $321daf9b005e9cff$export$c2dee3bd177275a2 = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [],
        "f109",
        "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $321daf9b005e9cff$export$94100f4c6ee29932 = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var $321daf9b005e9cff$export$efd983de5e4d6ad3 = {
    prefix: "fas",
    iconName: "laptop-house",
    icon: [
        640,
        512,
        [],
        "f966",
        "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
    ]
};
var $321daf9b005e9cff$export$ba2fa38f7bcc6930 = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$6c74e314e801a4fe = {
    prefix: "fas",
    iconName: "laugh",
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
    ]
};
var $321daf9b005e9cff$export$a88d1f4073ea9369 = {
    prefix: "fas",
    iconName: "laugh-beam",
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $321daf9b005e9cff$export$b206e700cf7084e1 = {
    prefix: "fas",
    iconName: "laugh-squint",
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $321daf9b005e9cff$export$77ac40095f39933e = {
    prefix: "fas",
    iconName: "laugh-wink",
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var $321daf9b005e9cff$export$a137712e11e257dd = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        512,
        512,
        [],
        "f5fd",
        "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
    ]
};
var $321daf9b005e9cff$export$7c497bae2754a087 = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        576,
        512,
        [],
        "f06c",
        "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
    ]
};
var $321daf9b005e9cff$export$4fbda8f64648f3b5 = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        512,
        512,
        [],
        "f094",
        "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
    ]
};
var $321daf9b005e9cff$export$7f24f1bf98af5411 = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [],
        "f536",
        "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
    ]
};
var $321daf9b005e9cff$export$b2c723344cff0d8 = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$c07eb6ff5a382cbd = {
    prefix: "fas",
    iconName: "level-down-alt",
    icon: [
        320,
        512,
        [],
        "f3be",
        "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
    ]
};
var $321daf9b005e9cff$export$d6f21a309b179c3d = {
    prefix: "fas",
    iconName: "level-up-alt",
    icon: [
        320,
        512,
        [],
        "f3bf",
        "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
    ]
};
var $321daf9b005e9cff$export$53dd2cacf674142a = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
    ]
};
var $321daf9b005e9cff$export$1e80f89fe84a215b = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$88bc01ff8dbecc55 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        512,
        512,
        [],
        "f0c1",
        "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
    ]
};
var $321daf9b005e9cff$export$f0f37dbc60110b10 = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        384,
        512,
        [],
        "f195",
        "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
    ]
};
var $321daf9b005e9cff$export$6cfc59842fedbc16 = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [],
        "f03a",
        "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$c6327a203ffc65a3 = {
    prefix: "fas",
    iconName: "list-alt",
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
    ]
};
var $321daf9b005e9cff$export$3db8f67cd0fc963b = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [],
        "f0cb",
        "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
    ]
};
var $321daf9b005e9cff$export$f8a219cf4f516384 = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [],
        "f0ca",
        "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$4ac9c4c370f7b157 = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        512,
        512,
        [],
        "f124",
        "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
    ]
};
var $321daf9b005e9cff$export$7aa08ad5d562578a = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [],
        "f023",
        "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
    ]
};
var $321daf9b005e9cff$export$84b5acad4436d02a = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
    ]
};
var $321daf9b005e9cff$export$8b92530ca6418c2f = {
    prefix: "fas",
    iconName: "long-arrow-alt-down",
    icon: [
        256,
        512,
        [],
        "f309",
        "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
    ]
};
var $321daf9b005e9cff$export$a8b3226b2bf323d = {
    prefix: "fas",
    iconName: "long-arrow-alt-left",
    icon: [
        448,
        512,
        [],
        "f30a",
        "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
    ]
};
var $321daf9b005e9cff$export$533e1f578f74c066 = {
    prefix: "fas",
    iconName: "long-arrow-alt-right",
    icon: [
        448,
        512,
        [],
        "f30b",
        "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
    ]
};
var $321daf9b005e9cff$export$43c8f2a46326c55f = {
    prefix: "fas",
    iconName: "long-arrow-alt-up",
    icon: [
        256,
        512,
        [],
        "f30c",
        "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
    ]
};
var $321daf9b005e9cff$export$7a65d2aa54cb4e93 = {
    prefix: "fas",
    iconName: "low-vision",
    icon: [
        576,
        512,
        [],
        "f2a8",
        "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
    ]
};
var $321daf9b005e9cff$export$bd1e24dd3cde8514 = {
    prefix: "fas",
    iconName: "luggage-cart",
    icon: [
        640,
        512,
        [],
        "f59d",
        "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
    ]
};
var $321daf9b005e9cff$export$ba9b387e84727819 = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [],
        "f604",
        "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
    ]
};
var $321daf9b005e9cff$export$895159d10626af74 = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "f967",
        "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
    ]
};
var $321daf9b005e9cff$export$e58f9b502d4dd52d = {
    prefix: "fas",
    iconName: "magic",
    icon: [
        512,
        512,
        [],
        "f0d0",
        "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
    ]
};
var $321daf9b005e9cff$export$78932e9c9abea6b7 = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        512,
        512,
        [],
        "f076",
        "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
    ]
};
var $321daf9b005e9cff$export$dd24f40c5337e2e1 = {
    prefix: "fas",
    iconName: "mail-bulk",
    icon: [
        576,
        512,
        [],
        "f674",
        "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
    ]
};
var $321daf9b005e9cff$export$2e21f9dba1630651 = {
    prefix: "fas",
    iconName: "male",
    icon: [
        192,
        512,
        [],
        "f183",
        "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$fc82fb79180cd17c = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [],
        "f279",
        "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $321daf9b005e9cff$export$df04458e7e32352c = {
    prefix: "fas",
    iconName: "map-marked",
    icon: [
        576,
        512,
        [],
        "f59f",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $321daf9b005e9cff$export$a977d47c74d8e86c = {
    prefix: "fas",
    iconName: "map-marked-alt",
    icon: [
        576,
        512,
        [],
        "f5a0",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var $321daf9b005e9cff$export$10d360e4f1a554dd = {
    prefix: "fas",
    iconName: "map-marker",
    icon: [
        384,
        512,
        [],
        "f041",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
    ]
};
var $321daf9b005e9cff$export$4be92fa780613f93 = {
    prefix: "fas",
    iconName: "map-marker-alt",
    icon: [
        384,
        512,
        [],
        "f3c5",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    ]
};
var $321daf9b005e9cff$export$184725965b3402dc = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        288,
        512,
        [],
        "f276",
        "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
    ]
};
var $321daf9b005e9cff$export$743f4b1071b3333a = {
    prefix: "fas",
    iconName: "map-signs",
    icon: [
        512,
        512,
        [],
        "f277",
        "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$e6789173649caa25 = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
    ]
};
var $321daf9b005e9cff$export$a9f5c0b9c1e77a6f = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        384,
        512,
        [],
        "f222",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $321daf9b005e9cff$export$2f8a28204bb4b86f = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        512,
        512,
        [],
        "f227",
        "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
    ]
};
var $321daf9b005e9cff$export$aa05fce255a5d269 = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        384,
        512,
        [],
        "f229",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $321daf9b005e9cff$export$5cb0daeafbcdabe3 = {
    prefix: "fas",
    iconName: "mars-stroke-h",
    icon: [
        480,
        512,
        [],
        "f22b",
        "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $321daf9b005e9cff$export$ed7aa1c25104f333 = {
    prefix: "fas",
    iconName: "mars-stroke-v",
    icon: [
        288,
        512,
        [],
        "f22a",
        "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var $321daf9b005e9cff$export$7b028758c03b9655 = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        640,
        512,
        [],
        "f6fa",
        "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
    ]
};
var $321daf9b005e9cff$export$b48a5be96314835a = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [],
        "f5a2",
        "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
    ]
};
var $321daf9b005e9cff$export$e75f02bae5b7d34b = {
    prefix: "fas",
    iconName: "medkit",
    icon: [
        512,
        512,
        [],
        "f0fa",
        "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
    ]
};
var $321daf9b005e9cff$export$6d2db489aaeeecd2 = {
    prefix: "fas",
    iconName: "meh",
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$e945435725f71e88 = {
    prefix: "fas",
    iconName: "meh-blank",
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$fdc62a1bea767cc2 = {
    prefix: "fas",
    iconName: "meh-rolling-eyes",
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
    ]
};
var $321daf9b005e9cff$export$5f9bd9f6df021f93 = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        640,
        512,
        [],
        "f538",
        "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
    ]
};
var $321daf9b005e9cff$export$232452c59d77c56e = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
    ]
};
var $321daf9b005e9cff$export$e134ecd00b622a47 = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        288,
        512,
        [],
        "f223",
        "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $321daf9b005e9cff$export$1439f0d6365138da = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [],
        "f753",
        "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
    ]
};
var $321daf9b005e9cff$export$4a7bb4be15f35178 = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
    ]
};
var $321daf9b005e9cff$export$eed3c491effe6d12 = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        352,
        512,
        [],
        "f130",
        "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$f08ef94fea14f5ac = {
    prefix: "fas",
    iconName: "microphone-alt",
    icon: [
        352,
        512,
        [],
        "f3c9",
        "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
    ]
};
var $321daf9b005e9cff$export$d2a53a388f30780 = {
    prefix: "fas",
    iconName: "microphone-alt-slash",
    icon: [
        640,
        512,
        [],
        "f539",
        "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$843f63d64e6f7951 = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$6a99139787bf9967 = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [],
        "f610",
        "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
    ]
};
var $321daf9b005e9cff$export$fee0376c250cdef = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [],
        "f068",
        "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$f3979b49bf57313c = {
    prefix: "fas",
    iconName: "minus-circle",
    icon: [
        512,
        512,
        [],
        "f056",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
    ]
};
var $321daf9b005e9cff$export$ffe9387966b3e681 = {
    prefix: "fas",
    iconName: "minus-square",
    icon: [
        448,
        512,
        [],
        "f146",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
    ]
};
var $321daf9b005e9cff$export$5030322c5fc886d7 = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
    ]
};
var $321daf9b005e9cff$export$59edacfad04cd121 = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        320,
        512,
        [],
        "f10b",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$e9599bc6cd92234d = {
    prefix: "fas",
    iconName: "mobile-alt",
    icon: [
        320,
        512,
        [],
        "f3cd",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
    ]
};
var $321daf9b005e9cff$export$608138a7337b5d1a = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        640,
        512,
        [],
        "f0d6",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $321daf9b005e9cff$export$a35d573395884c3d = {
    prefix: "fas",
    iconName: "money-bill-alt",
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var $321daf9b005e9cff$export$53e23123cc9a6796 = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        640,
        512,
        [],
        "f53a",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
    ]
};
var $321daf9b005e9cff$export$1613858e873cbb3e = {
    prefix: "fas",
    iconName: "money-bill-wave-alt",
    icon: [
        640,
        512,
        [],
        "f53b",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
    ]
};
var $321daf9b005e9cff$export$be069f641c85d0b3 = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        640,
        512,
        [],
        "f53c",
        "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$8c6ccc9745897cb2 = {
    prefix: "fas",
    iconName: "money-check-alt",
    icon: [
        640,
        512,
        [],
        "f53d",
        "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
    ]
};
var $321daf9b005e9cff$export$6f9b0bfc012deb25 = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var $321daf9b005e9cff$export$c4c2f69a53bab720 = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        512,
        512,
        [],
        "f186",
        "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
    ]
};
var $321daf9b005e9cff$export$55ceb5d0c144580a = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$4999586d7e1087fb = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [],
        "f678",
        "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
    ]
};
var $321daf9b005e9cff$export$f26017bdca99338d = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [],
        "f21c",
        "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
    ]
};
var $321daf9b005e9cff$export$64f9eb99c9749cce = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        640,
        512,
        [],
        "f6fc",
        "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
    ]
};
var $321daf9b005e9cff$export$198b96b894c66074 = {
    prefix: "fas",
    iconName: "mouse",
    icon: [
        384,
        512,
        [],
        "f8cc",
        "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
    ]
};
var $321daf9b005e9cff$export$2e19a69cc26b147 = {
    prefix: "fas",
    iconName: "mouse-pointer",
    icon: [
        320,
        512,
        [],
        "f245",
        "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
    ]
};
var $321daf9b005e9cff$export$47a822c30184e8af = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [],
        "f7b6",
        "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$fcb0647a5340b5b8 = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [],
        "f001",
        "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
    ]
};
var $321daf9b005e9cff$export$882cabd11f4943b8 = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
    ]
};
var $321daf9b005e9cff$export$771cf879fba0cf93 = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        288,
        512,
        [],
        "f22c",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $321daf9b005e9cff$export$d91b374112d4f8c1 = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
    ]
};
var $321daf9b005e9cff$export$6a15ccae09bbaf93 = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
    ]
};
var $321daf9b005e9cff$export$b2d79133c81d6697 = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        384,
        512,
        [],
        "f481",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
    ]
};
var $321daf9b005e9cff$export$40cdac24aa94a57a = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        512,
        512,
        [],
        "f247",
        "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
    ]
};
var $321daf9b005e9cff$export$887f6345573abcac = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        576,
        512,
        [],
        "f248",
        "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
    ]
};
var $321daf9b005e9cff$export$2599126c3a57f727 = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
    ]
};
var $321daf9b005e9cff$export$8de8eb94230028a5 = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [],
        "f679",
        "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
    ]
};
var $321daf9b005e9cff$export$743cce3ca4eb1d7d = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [],
        "f700",
        "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
    ]
};
var $321daf9b005e9cff$export$e21cfc4f23776bff = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [],
        "f03b",
        "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$e1611f373a10a98c = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [],
        "f815",
        "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
    ]
};
var $321daf9b005e9cff$export$594db3339e212bc9 = {
    prefix: "fas",
    iconName: "paint-brush",
    icon: [
        512,
        512,
        [],
        "f1fc",
        "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
    ]
};
var $321daf9b005e9cff$export$d1de8d1b815d6a5 = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
    ]
};
var $321daf9b005e9cff$export$5c390baea5db4f77 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [],
        "f53f",
        "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$d7ff2047dbc34562 = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
    ]
};
var $321daf9b005e9cff$export$b5378818301da1be = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
    ]
};
var $321daf9b005e9cff$export$4b24ca1552f410af = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [],
        "f0c6",
        "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    ]
};
var $321daf9b005e9cff$export$ca9e3368f1d9500a = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
    ]
};
var $321daf9b005e9cff$export$dec46f8df1860e0 = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [],
        "f1dd",
        "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
    ]
};
var $321daf9b005e9cff$export$fda29c8f99573a4e = {
    prefix: "fas",
    iconName: "parking",
    icon: [
        448,
        512,
        [],
        "f540",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$2c31ca0d9bee400f = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
    ]
};
var $321daf9b005e9cff$export$733efdaec97447be = {
    prefix: "fas",
    iconName: "pastafarianism",
    icon: [
        640,
        512,
        [],
        "f67b",
        "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
    ]
};
var $321daf9b005e9cff$export$6f95f90dd1f6d86b = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        448,
        512,
        [],
        "f0ea",
        "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
    ]
};
var $321daf9b005e9cff$export$da79f048408b1722 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        448,
        512,
        [],
        "f04c",
        "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
    ]
};
var $321daf9b005e9cff$export$d8cf08a0362da8db = {
    prefix: "fas",
    iconName: "pause-circle",
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
    ]
};
var $321daf9b005e9cff$export$7bc6e4d977673e69 = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
    ]
};
var $321daf9b005e9cff$export$8614cb1326eacd7a = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        496,
        512,
        [],
        "f67c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
    ]
};
var $321daf9b005e9cff$export$8f4567331fb0d3bc = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [],
        "f304",
        "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
    ]
};
var $321daf9b005e9cff$export$a3d3e92e430d3beb = {
    prefix: "fas",
    iconName: "pen-alt",
    icon: [
        512,
        512,
        [],
        "f305",
        "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
    ]
};
var $321daf9b005e9cff$export$8bdfe14ac72a8b17 = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [],
        "f5ac",
        "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
    ]
};
var $321daf9b005e9cff$export$a82594dcc75a49f5 = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [],
        "f5ad",
        "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
    ]
};
var $321daf9b005e9cff$export$fbb231ccb3d960bc = {
    prefix: "fas",
    iconName: "pen-square",
    icon: [
        448,
        512,
        [],
        "f14b",
        "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
    ]
};
var $321daf9b005e9cff$export$8210adc172262df = {
    prefix: "fas",
    iconName: "pencil-alt",
    icon: [
        512,
        512,
        [],
        "f303",
        "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    ]
};
var $321daf9b005e9cff$export$e3a7a1affea005f5 = {
    prefix: "fas",
    iconName: "pencil-ruler",
    icon: [
        512,
        512,
        [],
        "f5ae",
        "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
    ]
};
var $321daf9b005e9cff$export$804bfc5c390e1a2a = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        576,
        512,
        [],
        "f968",
        "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
    ]
};
var $321daf9b005e9cff$export$35fbd4ff1265acd5 = {
    prefix: "fas",
    iconName: "people-carry",
    icon: [
        640,
        512,
        [],
        "f4ce",
        "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
    ]
};
var $321daf9b005e9cff$export$4894bf28f771e1f3 = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [],
        "f816",
        "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
    ]
};
var $321daf9b005e9cff$export$89a1764fbb7ad2cb = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        448,
        512,
        [],
        "f295",
        "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
    ]
};
var $321daf9b005e9cff$export$89333857fc063a2e = {
    prefix: "fas",
    iconName: "percentage",
    icon: [
        384,
        512,
        [],
        "f541",
        "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
    ]
};
var $321daf9b005e9cff$export$2337c975289bdd84 = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$ddab067855cf34cb = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [],
        "f095",
        "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    ]
};
var $321daf9b005e9cff$export$a07a9b305deebf32 = {
    prefix: "fas",
    iconName: "phone-alt",
    icon: [
        512,
        512,
        [],
        "f879",
        "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
    ]
};
var $321daf9b005e9cff$export$4c60a3aade08b6c2 = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var $321daf9b005e9cff$export$8ba22605a641ebdf = {
    prefix: "fas",
    iconName: "phone-square",
    icon: [
        448,
        512,
        [],
        "f098",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
    ]
};
var $321daf9b005e9cff$export$a41e77f0de98bba7 = {
    prefix: "fas",
    iconName: "phone-square-alt",
    icon: [
        448,
        512,
        [],
        "f87b",
        "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
    ]
};
var $321daf9b005e9cff$export$c377f240bb8b5d74 = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        384,
        512,
        [],
        "f2a0",
        "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
    ]
};
var $321daf9b005e9cff$export$739f6a6a12dfb6ed = {
    prefix: "fas",
    iconName: "photo-video",
    icon: [
        640,
        512,
        [],
        "f87c",
        "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
    ]
};
var $321daf9b005e9cff$export$46d49a6734c4872a = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
    ]
};
var $321daf9b005e9cff$export$6380e2ed6e69d350 = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
    ]
};
var $321daf9b005e9cff$export$c9f93c4667edc585 = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var $321daf9b005e9cff$export$c5a9302c8c13c79a = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
    ]
};
var $321daf9b005e9cff$export$f654c69e66b466c0 = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
    ]
};
var $321daf9b005e9cff$export$9b2dbe133273f284 = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [],
        "f5af",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
    ]
};
var $321daf9b005e9cff$export$6ccbeeccfea6dc8a = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [],
        "f5b0",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
    ]
};
var $321daf9b005e9cff$export$cfee4df0d5df6d21 = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "f969",
        "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
    ]
};
var $321daf9b005e9cff$export$436587205947bca5 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        448,
        512,
        [],
        "f04b",
        "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
    ]
};
var $321daf9b005e9cff$export$cf04333781061c5e = {
    prefix: "fas",
    iconName: "play-circle",
    icon: [
        512,
        512,
        [],
        "f144",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
    ]
};
var $321daf9b005e9cff$export$cae5752c3e3b6545 = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [],
        "f1e6",
        "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
    ]
};
var $321daf9b005e9cff$export$a105e7b44ca0eb9e = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [],
        "f067",
        "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$d9cc3a81499af48c = {
    prefix: "fas",
    iconName: "plus-circle",
    icon: [
        512,
        512,
        [],
        "f055",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $321daf9b005e9cff$export$b6359eebfe900c35 = {
    prefix: "fas",
    iconName: "plus-square",
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var $321daf9b005e9cff$export$5c0b4709125e92f8 = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
    ]
};
var $321daf9b005e9cff$export$bc8ca14ab51f93db = {
    prefix: "fas",
    iconName: "poll",
    icon: [
        448,
        512,
        [],
        "f681",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
    ]
};
var $321daf9b005e9cff$export$456a238f0144d430 = {
    prefix: "fas",
    iconName: "poll-h",
    icon: [
        448,
        512,
        [],
        "f682",
        "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
    ]
};
var $321daf9b005e9cff$export$dd0ede1713d2d2f9 = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [],
        "f2fe",
        "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$48a38da471b097a2 = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [],
        "f75a",
        "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
    ]
};
var $321daf9b005e9cff$export$bb45b6b87d1adf27 = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
    ]
};
var $321daf9b005e9cff$export$e3d25f819c7ee7d7 = {
    prefix: "fas",
    iconName: "portrait",
    icon: [
        384,
        512,
        [],
        "f3e0",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var $321daf9b005e9cff$export$9ce041dfec8319b = {
    prefix: "fas",
    iconName: "pound-sign",
    icon: [
        320,
        512,
        [],
        "f154",
        "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
    ]
};
var $321daf9b005e9cff$export$a1cca9928dcf9798 = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [],
        "f011",
        "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
    ]
};
var $321daf9b005e9cff$export$3b32c982141cad51 = {
    prefix: "fas",
    iconName: "pray",
    icon: [
        384,
        512,
        [],
        "f683",
        "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
    ]
};
var $321daf9b005e9cff$export$95e08e91b0929943 = {
    prefix: "fas",
    iconName: "praying-hands",
    icon: [
        640,
        512,
        [],
        "f684",
        "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
    ]
};
var $321daf9b005e9cff$export$8767bafb19515ee4 = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        384,
        512,
        [],
        "f5b1",
        "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
    ]
};
var $321daf9b005e9cff$export$214f9ce665590486 = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$65d1c884b8581d1a = {
    prefix: "fas",
    iconName: "prescription-bottle-alt",
    icon: [
        384,
        512,
        [],
        "f486",
        "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
    ]
};
var $321daf9b005e9cff$export$ae64371e02ee8e56 = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [],
        "f02f",
        "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$5f9e1870e1866dde = {
    prefix: "fas",
    iconName: "procedures",
    icon: [
        640,
        512,
        [],
        "f487",
        "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var $321daf9b005e9cff$export$30bf9f5b96509df1 = {
    prefix: "fas",
    iconName: "project-diagram",
    icon: [
        640,
        512,
        [],
        "f542",
        "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$f1b881c73328720c = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        384,
        512,
        [],
        "f96a",
        "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
    ]
};
var $321daf9b005e9cff$export$821aeede187f23c9 = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        384,
        512,
        [],
        "f96b",
        "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
    ]
};
var $321daf9b005e9cff$export$7ee0dbd1e92e2859 = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        576,
        512,
        [],
        "f12e",
        "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
    ]
};
var $321daf9b005e9cff$export$fc19ca0fe15e73bc = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
    ]
};
var $321daf9b005e9cff$export$d96973f90e8f6e47 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        384,
        512,
        [],
        "f128",
        "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
    ]
};
var $321daf9b005e9cff$export$5ba67d7f2265c1a5 = {
    prefix: "fas",
    iconName: "question-circle",
    icon: [
        512,
        512,
        [],
        "f059",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
    ]
};
var $321daf9b005e9cff$export$c00c446e6db1605f = {
    prefix: "fas",
    iconName: "quidditch",
    icon: [
        640,
        512,
        [],
        "f458",
        "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
    ]
};
var $321daf9b005e9cff$export$932a67a1b1a7a724 = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        512,
        512,
        [],
        "f10d",
        "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$54e3a80c9875b74c = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        512,
        512,
        [],
        "f10e",
        "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$46f29ea84ed4c5f1 = {
    prefix: "fas",
    iconName: "quran",
    icon: [
        448,
        512,
        [],
        "f687",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var $321daf9b005e9cff$export$4c4e509518093d6d = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        496,
        512,
        [],
        "f7b9",
        "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
    ]
};
var $321daf9b005e9cff$export$2f048fa82bbddf6f = {
    prefix: "fas",
    iconName: "radiation-alt",
    icon: [
        496,
        512,
        [],
        "f7ba",
        "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $321daf9b005e9cff$export$92ab27739d3a91b2 = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        576,
        512,
        [],
        "f75b",
        "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
    ]
};
var $321daf9b005e9cff$export$8357bf8cc666d5f0 = {
    prefix: "fas",
    iconName: "random",
    icon: [
        512,
        512,
        [],
        "f074",
        "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
    ]
};
var $321daf9b005e9cff$export$32b0cd6133c2742 = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [],
        "f543",
        "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
    ]
};
var $321daf9b005e9cff$export$fe2d5012d9982673 = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
    ]
};
var $321daf9b005e9cff$export$a65c441f12cb6bd = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [],
        "f1b8",
        "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
    ]
};
var $321daf9b005e9cff$export$3d9f98aa1c24c776 = {
    prefix: "fas",
    iconName: "redo",
    icon: [
        512,
        512,
        [],
        "f01e",
        "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
    ]
};
var $321daf9b005e9cff$export$50c037520c6cfdc1 = {
    prefix: "fas",
    iconName: "redo-alt",
    icon: [
        512,
        512,
        [],
        "f2f9",
        "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
    ]
};
var $321daf9b005e9cff$export$5f519e9ac15ab8c3 = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [],
        "f25d",
        "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
    ]
};
var $321daf9b005e9cff$export$d91179f327329532 = {
    prefix: "fas",
    iconName: "remove-format",
    icon: [
        640,
        512,
        [],
        "f87d",
        "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
    ]
};
var $321daf9b005e9cff$export$bb06d4a7bb6736fe = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [],
        "f3e5",
        "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
    ]
};
var $321daf9b005e9cff$export$ca6fd367f31ecbc5 = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [],
        "f122",
        "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
    ]
};
var $321daf9b005e9cff$export$929518bb4b66a588 = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$5fbcef35138741a5 = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
    ]
};
var $321daf9b005e9cff$export$cebc76f79478e40e = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        640,
        512,
        [],
        "f079",
        "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
    ]
};
var $321daf9b005e9cff$export$838459d11f3971df = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [],
        "f4d6",
        "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
    ]
};
var $321daf9b005e9cff$export$a95486586631edc7 = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
    ]
};
var $321daf9b005e9cff$export$f224567a4851a5e9 = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [],
        "f018",
        "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
    ]
};
var $321daf9b005e9cff$export$30a5bb4ad3fa716c = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [],
        "f544",
        "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
    ]
};
var $321daf9b005e9cff$export$b24d84ed5657d89a = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
    ]
};
var $321daf9b005e9cff$export$806c0a45a7ecd6e8 = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$7329a1ca27b90c5b = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [],
        "f09e",
        "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
    ]
};
var $321daf9b005e9cff$export$89c9b1cca2c11484 = {
    prefix: "fas",
    iconName: "rss-square",
    icon: [
        448,
        512,
        [],
        "f143",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
    ]
};
var $321daf9b005e9cff$export$1ae0a94c8ba4131a = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [],
        "f158",
        "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
    ]
};
var $321daf9b005e9cff$export$8e90575265a56cfc = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        640,
        512,
        [],
        "f545",
        "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
    ]
};
var $321daf9b005e9cff$export$613f406c1b5802a8 = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$46c6347bff3e04a = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        576,
        512,
        [],
        "f547",
        "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$a6ad5df9d9f29553 = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
    ]
};
var $321daf9b005e9cff$export$5dfd1cb43dc9eadb = {
    prefix: "fas",
    iconName: "running",
    icon: [
        416,
        512,
        [],
        "f70c",
        "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
    ]
};
var $321daf9b005e9cff$export$8bf9e3f7f57d486a = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        320,
        512,
        [],
        "f156",
        "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
    ]
};
var $321daf9b005e9cff$export$8e924e6bd422cef9 = {
    prefix: "fas",
    iconName: "sad-cry",
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
    ]
};
var $321daf9b005e9cff$export$4b5241926f692f91 = {
    prefix: "fas",
    iconName: "sad-tear",
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
    ]
};
var $321daf9b005e9cff$export$da3f1730d013e224 = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [],
        "f7bf",
        "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
    ]
};
var $321daf9b005e9cff$export$219ccae0e4da3c92 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [],
        "f7c0",
        "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
    ]
};
var $321daf9b005e9cff$export$1aaa83ff70706e1e = {
    prefix: "fas",
    iconName: "save",
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
    ]
};
var $321daf9b005e9cff$export$51e9b8434982947d = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [],
        "f549",
        "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$7484ff654cd6474f = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [],
        "f54a",
        "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
    ]
};
var $321daf9b005e9cff$export$7c265716d4399676 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        640,
        512,
        [],
        "f70e",
        "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
    ]
};
var $321daf9b005e9cff$export$303efb6031da122 = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
    ]
};
var $321daf9b005e9cff$export$871a78837687ffe8 = {
    prefix: "fas",
    iconName: "search",
    icon: [
        512,
        512,
        [],
        "f002",
        "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    ]
};
var $321daf9b005e9cff$export$65b49a6767630708 = {
    prefix: "fas",
    iconName: "search-dollar",
    icon: [
        512,
        512,
        [],
        "f688",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
    ]
};
var $321daf9b005e9cff$export$c33aba6c251a898a = {
    prefix: "fas",
    iconName: "search-location",
    icon: [
        512,
        512,
        [],
        "f689",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$efca97eef6a7a17d = {
    prefix: "fas",
    iconName: "search-minus",
    icon: [
        512,
        512,
        [],
        "f010",
        "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $321daf9b005e9cff$export$378f00e6b1a8185 = {
    prefix: "fas",
    iconName: "search-plus",
    icon: [
        512,
        512,
        [],
        "f00e",
        "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var $321daf9b005e9cff$export$d7b60b8dbd03cfe4 = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [],
        "f4d8",
        "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
    ]
};
var $321daf9b005e9cff$export$1bf820d499b6202e = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$b17d50542d1fc340 = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [],
        "f61f",
        "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
    ]
};
var $321daf9b005e9cff$export$c08b4b0e2b0dc027 = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [],
        "f064",
        "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
    ]
};
var $321daf9b005e9cff$export$f8e8bb0b3aa8c658 = {
    prefix: "fas",
    iconName: "share-alt",
    icon: [
        448,
        512,
        [],
        "f1e0",
        "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
    ]
};
var $321daf9b005e9cff$export$3799c2d8fd7e493b = {
    prefix: "fas",
    iconName: "share-alt-square",
    icon: [
        448,
        512,
        [],
        "f1e1",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
    ]
};
var $321daf9b005e9cff$export$ae9e1434571f373c = {
    prefix: "fas",
    iconName: "share-square",
    icon: [
        576,
        512,
        [],
        "f14d",
        "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
    ]
};
var $321daf9b005e9cff$export$3570be7b68efb8db = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [],
        "f20b",
        "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$d6508d18a824f291 = {
    prefix: "fas",
    iconName: "shield-alt",
    icon: [
        512,
        512,
        [],
        "f3ed",
        "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
    ]
};
var $321daf9b005e9cff$export$bea811bbf570f05a = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "f96c",
        "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
    ]
};
var $321daf9b005e9cff$export$6c645741140616af = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        640,
        512,
        [],
        "f21a",
        "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
    ]
};
var $321daf9b005e9cff$export$5e419f47aaeb3c05 = {
    prefix: "fas",
    iconName: "shipping-fast",
    icon: [
        640,
        512,
        [],
        "f48b",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $321daf9b005e9cff$export$cdbdd2118099ae07 = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
    ]
};
var $321daf9b005e9cff$export$5745f8adbc11eb01 = {
    prefix: "fas",
    iconName: "shopping-bag",
    icon: [
        448,
        512,
        [],
        "f290",
        "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$ca6d443595a6578f = {
    prefix: "fas",
    iconName: "shopping-basket",
    icon: [
        576,
        512,
        [],
        "f291",
        "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
    ]
};
var $321daf9b005e9cff$export$51da406e5aa1388c = {
    prefix: "fas",
    iconName: "shopping-cart",
    icon: [
        576,
        512,
        [],
        "f07a",
        "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
    ]
};
var $321daf9b005e9cff$export$f7f7c15f18cc19a1 = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [],
        "f2cc",
        "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
    ]
};
var $321daf9b005e9cff$export$9d63d851db698c09 = {
    prefix: "fas",
    iconName: "shuttle-van",
    icon: [
        640,
        512,
        [],
        "f5b6",
        "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
    ]
};
var $321daf9b005e9cff$export$d21d0d6c8e9e8bf9 = {
    prefix: "fas",
    iconName: "sign",
    icon: [
        512,
        512,
        [],
        "f4d9",
        "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
    ]
};
var $321daf9b005e9cff$export$e6709746115bd2ea = {
    prefix: "fas",
    iconName: "sign-in-alt",
    icon: [
        512,
        512,
        [],
        "f2f6",
        "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
    ]
};
var $321daf9b005e9cff$export$20993813350f9671 = {
    prefix: "fas",
    iconName: "sign-language",
    icon: [
        448,
        512,
        [],
        "f2a7",
        "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
    ]
};
var $321daf9b005e9cff$export$c844d6923b7096c2 = {
    prefix: "fas",
    iconName: "sign-out-alt",
    icon: [
        512,
        512,
        [],
        "f2f5",
        "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    ]
};
var $321daf9b005e9cff$export$79046b073b6c584d = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [],
        "f012",
        "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$afa7b53ac8ebcb5d = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
    ]
};
var $321daf9b005e9cff$export$3bee83bf278fddbe = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
    ]
};
var $321daf9b005e9cff$export$b2ce5e79d0eccaf8 = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        640,
        512,
        [],
        "f0e8",
        "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$21bd1d54bd4f2c5a = {
    prefix: "fas",
    iconName: "skating",
    icon: [
        448,
        512,
        [],
        "f7c5",
        "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $321daf9b005e9cff$export$eae1acab6fb96708 = {
    prefix: "fas",
    iconName: "skiing",
    icon: [
        512,
        512,
        [],
        "f7c9",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
    ]
};
var $321daf9b005e9cff$export$6ea48260d7d09b1b = {
    prefix: "fas",
    iconName: "skiing-nordic",
    icon: [
        576,
        512,
        [],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
    ]
};
var $321daf9b005e9cff$export$138b45e2afb1dfa4 = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [],
        "f54c",
        "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
    ]
};
var $321daf9b005e9cff$export$8717352b90217272 = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [],
        "f714",
        "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
    ]
};
var $321daf9b005e9cff$export$f54d004dd5f1cb5e = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
    ]
};
var $321daf9b005e9cff$export$26a8fd1143d2d6c0 = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
    ]
};
var $321daf9b005e9cff$export$94d4dcb523f95563 = {
    prefix: "fas",
    iconName: "sliders-h",
    icon: [
        512,
        512,
        [],
        "f1de",
        "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$c632b2334f0913bc = {
    prefix: "fas",
    iconName: "smile",
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
    ]
};
var $321daf9b005e9cff$export$54ada6dc9690e0ca = {
    prefix: "fas",
    iconName: "smile-beam",
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
    ]
};
var $321daf9b005e9cff$export$f5dbb37f6801ee3f = {
    prefix: "fas",
    iconName: "smile-wink",
    icon: [
        496,
        512,
        [],
        "f4da",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
    ]
};
var $321daf9b005e9cff$export$aa11b8edb09fed14 = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
    ]
};
var $321daf9b005e9cff$export$c4ab83701fc591a5 = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [],
        "f48d",
        "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
    ]
};
var $321daf9b005e9cff$export$e50452a49dec29f = {
    prefix: "fas",
    iconName: "smoking-ban",
    icon: [
        512,
        512,
        [],
        "f54d",
        "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
    ]
};
var $321daf9b005e9cff$export$9dbcc3443daa7323 = {
    prefix: "fas",
    iconName: "sms",
    icon: [
        512,
        512,
        [],
        "f7cd",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
    ]
};
var $321daf9b005e9cff$export$72683772d587302a = {
    prefix: "fas",
    iconName: "snowboarding",
    icon: [
        512,
        512,
        [],
        "f7ce",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
    ]
};
var $321daf9b005e9cff$export$bab8f3647c394f48 = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
    ]
};
var $321daf9b005e9cff$export$b23df6bafb174693 = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [],
        "f7d0",
        "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$695fae58f55c3a87 = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$64f1c53b21f310ac = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [],
        "f96e",
        "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
    ]
};
var $321daf9b005e9cff$export$8d36a54dbf1e6bce = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [],
        "f696",
        "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
    ]
};
var $321daf9b005e9cff$export$b9c649c5e37017f3 = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
    ]
};
var $321daf9b005e9cff$export$4941c5969d5399b = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [],
        "f0dc",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
    ]
};
var $321daf9b005e9cff$export$7658045270aafde3 = {
    prefix: "fas",
    iconName: "sort-alpha-down",
    icon: [
        448,
        512,
        [],
        "f15d",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $321daf9b005e9cff$export$e12d23d82d5c8a89 = {
    prefix: "fas",
    iconName: "sort-alpha-down-alt",
    icon: [
        448,
        512,
        [],
        "f881",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $321daf9b005e9cff$export$3c4115b156be730d = {
    prefix: "fas",
    iconName: "sort-alpha-up",
    icon: [
        448,
        512,
        [],
        "f15e",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var $321daf9b005e9cff$export$95ef20828693fb0f = {
    prefix: "fas",
    iconName: "sort-alpha-up-alt",
    icon: [
        448,
        512,
        [],
        "f882",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var $321daf9b005e9cff$export$4b2a02d50e417b5f = {
    prefix: "fas",
    iconName: "sort-amount-down",
    icon: [
        512,
        512,
        [],
        "f160",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$e7d80d8c226cb77 = {
    prefix: "fas",
    iconName: "sort-amount-down-alt",
    icon: [
        512,
        512,
        [],
        "f884",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $321daf9b005e9cff$export$28ef3e933e4b5364 = {
    prefix: "fas",
    iconName: "sort-amount-up",
    icon: [
        512,
        512,
        [],
        "f161",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$6e87844b0f151b6a = {
    prefix: "fas",
    iconName: "sort-amount-up-alt",
    icon: [
        512,
        512,
        [],
        "f885",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
    ]
};
var $321daf9b005e9cff$export$58e2577a373e7d4 = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [],
        "f0dd",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    ]
};
var $321daf9b005e9cff$export$835db7eb35b3c29b = {
    prefix: "fas",
    iconName: "sort-numeric-down",
    icon: [
        448,
        512,
        [],
        "f162",
        "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var $321daf9b005e9cff$export$857385fda7a5a98e = {
    prefix: "fas",
    iconName: "sort-numeric-down-alt",
    icon: [
        448,
        512,
        [],
        "f886",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $321daf9b005e9cff$export$d213a3ba3cabed48 = {
    prefix: "fas",
    iconName: "sort-numeric-up",
    icon: [
        448,
        512,
        [],
        "f163",
        "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
    ]
};
var $321daf9b005e9cff$export$d41859f1bbb9e086 = {
    prefix: "fas",
    iconName: "sort-numeric-up-alt",
    icon: [
        448,
        512,
        [],
        "f887",
        "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var $321daf9b005e9cff$export$f9dd5b1410e95035 = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [],
        "f0de",
        "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
    ]
};
var $321daf9b005e9cff$export$f9a38ef7b046ab51 = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
    ]
};
var $321daf9b005e9cff$export$4d1c12ba2b4ca565 = {
    prefix: "fas",
    iconName: "space-shuttle",
    icon: [
        640,
        512,
        [],
        "f197",
        "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
    ]
};
var $321daf9b005e9cff$export$761e747b06ed2e1f = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
    ]
};
var $321daf9b005e9cff$export$6daa96b1986e2ef0 = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        576,
        512,
        [],
        "f717",
        "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
    ]
};
var $321daf9b005e9cff$export$1025ad641edb49c2 = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$d6f21e17ea797702 = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
    ]
};
var $321daf9b005e9cff$export$4952c502f544cf85 = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$90b4406457aae8cc = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$7ec6541fee081990 = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [],
        "f45c",
        "M512 512H0V0h512v512z"
    ]
};
var $321daf9b005e9cff$export$28e4b96627e00057 = {
    prefix: "fas",
    iconName: "square-root-alt",
    icon: [
        576,
        512,
        [],
        "f698",
        "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
    ]
};
var $321daf9b005e9cff$export$722e92d2d93ffc68 = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
    ]
};
var $321daf9b005e9cff$export$a3b0eb2cd7942125 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [],
        "f005",
        "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    ]
};
var $321daf9b005e9cff$export$cafa834c96ebcb1a = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [],
        "f699",
        "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
    ]
};
var $321daf9b005e9cff$export$228008b5e11032fa = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
    ]
};
var $321daf9b005e9cff$export$c13575f42532efb3 = {
    prefix: "fas",
    iconName: "star-half-alt",
    icon: [
        536,
        512,
        [],
        "f5c0",
        "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
    ]
};
var $321daf9b005e9cff$export$f823fee3712b2601 = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        464,
        512,
        [],
        "f69a",
        "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
    ]
};
var $321daf9b005e9cff$export$aa3c4c1c5a47bf98 = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        480,
        512,
        [],
        "f621",
        "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
    ]
};
var $321daf9b005e9cff$export$2884e379aed297d4 = {
    prefix: "fas",
    iconName: "step-backward",
    icon: [
        448,
        512,
        [],
        "f048",
        "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    ]
};
var $321daf9b005e9cff$export$b303329afce5de18 = {
    prefix: "fas",
    iconName: "step-forward",
    icon: [
        448,
        512,
        [],
        "f051",
        "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    ]
};
var $321daf9b005e9cff$export$acb2d72d28cd92d9 = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        512,
        512,
        [],
        "f0f1",
        "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$80889adc5d98bf4a = {
    prefix: "fas",
    iconName: "sticky-note",
    icon: [
        448,
        512,
        [],
        "f249",
        "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
    ]
};
var $321daf9b005e9cff$export$51577929c676143b = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        448,
        512,
        [],
        "f04d",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$47af2aad60ab3e7c = {
    prefix: "fas",
    iconName: "stop-circle",
    icon: [
        512,
        512,
        [],
        "f28d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
    ]
};
var $321daf9b005e9cff$export$b85a7300fc7960b6 = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [],
        "f2f2",
        "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var $321daf9b005e9cff$export$df6244b0501f2112 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "f96f",
        "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
    ]
};
var $321daf9b005e9cff$export$de59c2657a8ace67 = {
    prefix: "fas",
    iconName: "store",
    icon: [
        616,
        512,
        [],
        "f54e",
        "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
    ]
};
var $321daf9b005e9cff$export$1f1871dab9cec9d8 = {
    prefix: "fas",
    iconName: "store-alt",
    icon: [
        640,
        512,
        [],
        "f54f",
        "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
    ]
};
var $321daf9b005e9cff$export$b932a586f6ff48b4 = {
    prefix: "fas",
    iconName: "store-alt-slash",
    icon: [
        640,
        512,
        [],
        "f970",
        "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
    ]
};
var $321daf9b005e9cff$export$4ab2f33219630bad = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "f971",
        "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
    ]
};
var $321daf9b005e9cff$export$ed81ab40fc4e904 = {
    prefix: "fas",
    iconName: "stream",
    icon: [
        512,
        512,
        [],
        "f550",
        "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$6aab6c3359c2554c = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
    ]
};
var $321daf9b005e9cff$export$eff51ea25b4de135 = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
    ]
};
var $321daf9b005e9cff$export$195780ddabd8e0c6 = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
    ]
};
var $321daf9b005e9cff$export$34c1e678c32ed646 = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$4cabc8a12d4e2f9 = {
    prefix: "fas",
    iconName: "subway",
    icon: [
        448,
        512,
        [],
        "f239",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$60710f3921019268 = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [],
        "f0f2",
        "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
    ]
};
var $321daf9b005e9cff$export$957e62a9b80ff4e3 = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
    ]
};
var $321daf9b005e9cff$export$2fa35dcbc038dbe9 = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [],
        "f185",
        "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
    ]
};
var $321daf9b005e9cff$export$4fa56a54e822dd25 = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$46647c72213f53ba = {
    prefix: "fas",
    iconName: "surprise",
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$c74a20c81b957b6a = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
    ]
};
var $321daf9b005e9cff$export$67daf2e2f88c1365 = {
    prefix: "fas",
    iconName: "swimmer",
    icon: [
        640,
        512,
        [],
        "f5c4",
        "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
    ]
};
var $321daf9b005e9cff$export$4dee691631c67d5c = {
    prefix: "fas",
    iconName: "swimming-pool",
    icon: [
        640,
        512,
        [],
        "f5c5",
        "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
    ]
};
var $321daf9b005e9cff$export$20d991385719b5b4 = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [],
        "f69b",
        "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
    ]
};
var $321daf9b005e9cff$export$ff87319002e3dae9 = {
    prefix: "fas",
    iconName: "sync",
    icon: [
        512,
        512,
        [],
        "f021",
        "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
    ]
};
var $321daf9b005e9cff$export$2ff2056be8c281e4 = {
    prefix: "fas",
    iconName: "sync-alt",
    icon: [
        512,
        512,
        [],
        "f2f1",
        "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
    ]
};
var $321daf9b005e9cff$export$1aa9423ec6b1d609 = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [],
        "f48e",
        "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
    ]
};
var $321daf9b005e9cff$export$36583f5d3d5a971f = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
    ]
};
var $321daf9b005e9cff$export$f378fbb4e0ef7edf = {
    prefix: "fas",
    iconName: "table-tennis",
    icon: [
        512,
        512,
        [],
        "f45d",
        "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
    ]
};
var $321daf9b005e9cff$export$1c92b67c45a4b4fc = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$db0cac088255eacc = {
    prefix: "fas",
    iconName: "tablet-alt",
    icon: [
        448,
        512,
        [],
        "f3fa",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
    ]
};
var $321daf9b005e9cff$export$bed2b0ed4ae45e0d = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
    ]
};
var $321daf9b005e9cff$export$38dd17b9f064c10f = {
    prefix: "fas",
    iconName: "tachometer-alt",
    icon: [
        576,
        512,
        [],
        "f3fd",
        "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$cb61f447f29887e = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        512,
        512,
        [],
        "f02b",
        "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$d55778e3ab6c933f = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        640,
        512,
        [],
        "f02c",
        "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
    ]
};
var $321daf9b005e9cff$export$b88ed5e1e0eac4c6 = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        640,
        512,
        [],
        "f4db",
        "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ]
};
var $321daf9b005e9cff$export$2f6d5b2fec286d63 = {
    prefix: "fas",
    iconName: "tasks",
    icon: [
        512,
        512,
        [],
        "f0ae",
        "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$9958afcdfece1b58 = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [],
        "f1ba",
        "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$b4619aeaf0b9d18e = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        640,
        512,
        [],
        "f62e",
        "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
    ]
};
var $321daf9b005e9cff$export$c88ac21fe7c88ae6 = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        640,
        512,
        [],
        "f62f",
        "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
    ]
};
var $321daf9b005e9cff$export$15d012277c3ecf9a = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $321daf9b005e9cff$export$9e9af12b90a1abd2 = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var $321daf9b005e9cff$export$af6ebee83047b793 = {
    prefix: "fas",
    iconName: "tenge",
    icon: [
        384,
        512,
        [],
        "f7d7",
        "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
    ]
};
var $321daf9b005e9cff$export$5e63e8b85b5f119c = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        640,
        512,
        [],
        "f120",
        "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
    ]
};
var $321daf9b005e9cff$export$3313bce3924ea7da = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
    ]
};
var $321daf9b005e9cff$export$d8724cf433389700 = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
    ]
};
var $321daf9b005e9cff$export$4d383c83efc0c819 = {
    prefix: "fas",
    iconName: "th",
    icon: [
        512,
        512,
        [],
        "f00a",
        "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
    ]
};
var $321daf9b005e9cff$export$69782f333e90cdc6 = {
    prefix: "fas",
    iconName: "th-large",
    icon: [
        512,
        512,
        [],
        "f009",
        "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
    ]
};
var $321daf9b005e9cff$export$daf2614a457122c0 = {
    prefix: "fas",
    iconName: "th-list",
    icon: [
        512,
        512,
        [],
        "f00b",
        "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
    ]
};
var $321daf9b005e9cff$export$3dbedc487b0159ac = {
    prefix: "fas",
    iconName: "theater-masks",
    icon: [
        640,
        512,
        [],
        "f630",
        "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
    ]
};
var $321daf9b005e9cff$export$f576739e9b18ea4f = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
    ]
};
var $321daf9b005e9cff$export$81a2f8298cf523f9 = {
    prefix: "fas",
    iconName: "thermometer-empty",
    icon: [
        256,
        512,
        [],
        "f2cb",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $321daf9b005e9cff$export$74e07083cef79a6f = {
    prefix: "fas",
    iconName: "thermometer-full",
    icon: [
        256,
        512,
        [],
        "f2c7",
        "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
    ]
};
var $321daf9b005e9cff$export$2090f040324b4449 = {
    prefix: "fas",
    iconName: "thermometer-half",
    icon: [
        256,
        512,
        [],
        "f2c9",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $321daf9b005e9cff$export$ed05754fcbec6e46 = {
    prefix: "fas",
    iconName: "thermometer-quarter",
    icon: [
        256,
        512,
        [],
        "f2ca",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $321daf9b005e9cff$export$6c632d1dc30d4a77 = {
    prefix: "fas",
    iconName: "thermometer-three-quarters",
    icon: [
        256,
        512,
        [],
        "f2c8",
        "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var $321daf9b005e9cff$export$aba24ca305bbe8c1 = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [],
        "f165",
        "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
    ]
};
var $321daf9b005e9cff$export$47e4e0d519d33497 = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [],
        "f164",
        "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
    ]
};
var $321daf9b005e9cff$export$b6314cdc01bb5c43 = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [],
        "f08d",
        "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
    ]
};
var $321daf9b005e9cff$export$75e38ba471fd89c4 = {
    prefix: "fas",
    iconName: "ticket-alt",
    icon: [
        576,
        512,
        [],
        "f3ff",
        "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
    ]
};
var $321daf9b005e9cff$export$174bd7f477b115b4 = {
    prefix: "fas",
    iconName: "times",
    icon: [
        352,
        512,
        [],
        "f00d",
        "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    ]
};
var $321daf9b005e9cff$export$ab0ec50720a747eb = {
    prefix: "fas",
    iconName: "times-circle",
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
    ]
};
var $321daf9b005e9cff$export$60dd975bd5938c15 = {
    prefix: "fas",
    iconName: "tint",
    icon: [
        352,
        512,
        [],
        "f043",
        "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var $321daf9b005e9cff$export$5d6f0943039b898f = {
    prefix: "fas",
    iconName: "tint-slash",
    icon: [
        640,
        512,
        [],
        "f5c7",
        "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
    ]
};
var $321daf9b005e9cff$export$3d016d62cda18371 = {
    prefix: "fas",
    iconName: "tired",
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
    ]
};
var $321daf9b005e9cff$export$d20aaceb882ca545 = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
    ]
};
var $321daf9b005e9cff$export$5cffc34afa81e517 = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
    ]
};
var $321daf9b005e9cff$export$505476859b9691c0 = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        384,
        512,
        [],
        "f7d8",
        "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
    ]
};
var $321daf9b005e9cff$export$c8cc083ccc72b17 = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        576,
        512,
        [],
        "f71e",
        "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
    ]
};
var $321daf9b005e9cff$export$7a494edbf9b65575 = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "f972",
        "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
    ]
};
var $321daf9b005e9cff$export$b34d64c205c732a9 = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [],
        "f552",
        "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
    ]
};
var $321daf9b005e9cff$export$646e4e7a8c6172aa = {
    prefix: "fas",
    iconName: "tools",
    icon: [
        512,
        512,
        [],
        "f7d9",
        "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$3a1fa2d16f90d635 = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [],
        "f5c9",
        "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
    ]
};
var $321daf9b005e9cff$export$54d07baabd8c2acb = {
    prefix: "fas",
    iconName: "torah",
    icon: [
        640,
        512,
        [],
        "f6a0",
        "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
    ]
};
var $321daf9b005e9cff$export$75825a4c2b3375e = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [],
        "f6a1",
        "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
    ]
};
var $321daf9b005e9cff$export$e87e41787bbedc98 = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [],
        "f722",
        "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
    ]
};
var $321daf9b005e9cff$export$9c9b2fbddd59047d = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [],
        "f25c",
        "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
    ]
};
var $321daf9b005e9cff$export$bf0b19daceaec9c2 = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        384,
        512,
        [],
        "f637",
        "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$3a48b9820e92f5ab = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "f941",
        "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
    ]
};
var $321daf9b005e9cff$export$17cde74bf6f1ee89 = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [],
        "f238",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
    ]
};
var $321daf9b005e9cff$export$a7a36674c079f293 = {
    prefix: "fas",
    iconName: "tram",
    icon: [
        512,
        512,
        [],
        "f7da",
        "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $321daf9b005e9cff$export$7e3f1701aa95ef01 = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        384,
        512,
        [],
        "f224",
        "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $321daf9b005e9cff$export$9c36cf9334c052f = {
    prefix: "fas",
    iconName: "transgender-alt",
    icon: [
        480,
        512,
        [],
        "f225",
        "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $321daf9b005e9cff$export$ed8c149a0ea54bb4 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
    ]
};
var $321daf9b005e9cff$export$88df7ff7eb32f9dc = {
    prefix: "fas",
    iconName: "trash-alt",
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$d32f45a64ed40e8d = {
    prefix: "fas",
    iconName: "trash-restore",
    icon: [
        448,
        512,
        [],
        "f829",
        "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$d075b19b21cb9856 = {
    prefix: "fas",
    iconName: "trash-restore-alt",
    icon: [
        448,
        512,
        [],
        "f82a",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$1744430f718caf6b = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        384,
        512,
        [],
        "f1bb",
        "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
    ]
};
var $321daf9b005e9cff$export$29c432d69ccf85a5 = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [],
        "f091",
        "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
    ]
};
var $321daf9b005e9cff$export$d7895f386f8bd8b8 = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [],
        "f0d1",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var $321daf9b005e9cff$export$f00c152db7d44638 = {
    prefix: "fas",
    iconName: "truck-loading",
    icon: [
        640,
        512,
        [],
        "f4de",
        "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$24b8a0147653649a = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$a06617a1a4ccea67 = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$f846b848b3ba3064 = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [],
        "f63c",
        "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var $321daf9b005e9cff$export$36edce3ba87c2b17 = {
    prefix: "fas",
    iconName: "tshirt",
    icon: [
        640,
        512,
        [],
        "f553",
        "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
    ]
};
var $321daf9b005e9cff$export$7c85aba0f9624b29 = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [],
        "f1e4",
        "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var $321daf9b005e9cff$export$e0cfed4ba2fe562c = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [],
        "f26c",
        "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
    ]
};
var $321daf9b005e9cff$export$9ff64ffae70e08c0 = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
    ]
};
var $321daf9b005e9cff$export$20932e4d438e4e4c = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        640,
        512,
        [],
        "f5ca",
        "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$22346afd6a3cddf8 = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var $321daf9b005e9cff$export$a5e5ba60b1dfe2b2 = {
    prefix: "fas",
    iconName: "undo",
    icon: [
        512,
        512,
        [],
        "f0e2",
        "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
    ]
};
var $321daf9b005e9cff$export$c8197b992c46c4a6 = {
    prefix: "fas",
    iconName: "undo-alt",
    icon: [
        512,
        512,
        [],
        "f2ea",
        "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
    ]
};
var $321daf9b005e9cff$export$e119aada7f690d05 = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
    ]
};
var $321daf9b005e9cff$export$f2e1460ebe1a8cb0 = {
    prefix: "fas",
    iconName: "university",
    icon: [
        512,
        512,
        [],
        "f19c",
        "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
    ]
};
var $321daf9b005e9cff$export$2f546f7d8ba01e18 = {
    prefix: "fas",
    iconName: "unlink",
    icon: [
        512,
        512,
        [],
        "f127",
        "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
    ]
};
var $321daf9b005e9cff$export$db1382cd406cc506 = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [],
        "f09c",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$b19f508797f3d9c3 = {
    prefix: "fas",
    iconName: "unlock-alt",
    icon: [
        448,
        512,
        [],
        "f13e",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
    ]
};
var $321daf9b005e9cff$export$a9578350255b2b79 = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var $321daf9b005e9cff$export$f5699fa0844e0188 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $321daf9b005e9cff$export$ae9b19c2ac726cfc = {
    prefix: "fas",
    iconName: "user-alt",
    icon: [
        512,
        512,
        [],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
    ]
};
var $321daf9b005e9cff$export$46185fab4772ada6 = {
    prefix: "fas",
    iconName: "user-alt-slash",
    icon: [
        640,
        512,
        [],
        "f4fa",
        "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
    ]
};
var $321daf9b005e9cff$export$94363e983c225a04 = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
    ]
};
var $321daf9b005e9cff$export$76de2a120043c9f8 = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
    ]
};
var $321daf9b005e9cff$export$be7d974e9e0dba1a = {
    prefix: "fas",
    iconName: "user-circle",
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    ]
};
var $321daf9b005e9cff$export$b00596a09aa07311 = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
    ]
};
var $321daf9b005e9cff$export$474108c2b86e730e = {
    prefix: "fas",
    iconName: "user-cog",
    icon: [
        640,
        512,
        [],
        "f4fe",
        "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
    ]
};
var $321daf9b005e9cff$export$a68a6960fc8eef82 = {
    prefix: "fas",
    iconName: "user-edit",
    icon: [
        640,
        512,
        [],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
    ]
};
var $321daf9b005e9cff$export$46073bec205635d9 = {
    prefix: "fas",
    iconName: "user-friends",
    icon: [
        640,
        512,
        [],
        "f500",
        "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
    ]
};
var $321daf9b005e9cff$export$10f5839059d22f7e = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
    ]
};
var $321daf9b005e9cff$export$c950c1ba7f227d5b = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
    ]
};
var $321daf9b005e9cff$export$d9b89b5872b67a4f = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
    ]
};
var $321daf9b005e9cff$export$ab0d33a2c03f1794 = {
    prefix: "fas",
    iconName: "user-md",
    icon: [
        448,
        512,
        [],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
    ]
};
var $321daf9b005e9cff$export$d6e17c0df8ed1bf7 = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $321daf9b005e9cff$export$a9174995732e03c5 = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [],
        "f504",
        "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
    ]
};
var $321daf9b005e9cff$export$ab9af5aa013d2162 = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
    ]
};
var $321daf9b005e9cff$export$4c17261776a709f2 = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $321daf9b005e9cff$export$597826232327559b = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [],
        "f21b",
        "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
    ]
};
var $321daf9b005e9cff$export$d1886bc596424e6c = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
    ]
};
var $321daf9b005e9cff$export$3924ab4d3ef9b5ef = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
    ]
};
var $321daf9b005e9cff$export$9eec597148166b36 = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
    ]
};
var $321daf9b005e9cff$export$48c51dda34e9f04c = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
    ]
};
var $321daf9b005e9cff$export$45b996d071667753 = {
    prefix: "fas",
    iconName: "user-times",
    icon: [
        640,
        512,
        [],
        "f235",
        "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var $321daf9b005e9cff$export$e5a8f011aef571ac = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $321daf9b005e9cff$export$5e0b06753fc69b81 = {
    prefix: "fas",
    iconName: "users-cog",
    icon: [
        640,
        512,
        [],
        "f509",
        "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var $321daf9b005e9cff$export$fb7af5d245fb9053 = {
    prefix: "fas",
    iconName: "utensil-spoon",
    icon: [
        512,
        512,
        [],
        "f2e5",
        "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
    ]
};
var $321daf9b005e9cff$export$750d52edc1dafc7 = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        416,
        512,
        [],
        "f2e7",
        "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
    ]
};
var $321daf9b005e9cff$export$567d5631a7b0599f = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        512,
        512,
        [],
        "f5cb",
        "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
    ]
};
var $321daf9b005e9cff$export$f89d028573ffc0a6 = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        288,
        512,
        [],
        "f221",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var $321daf9b005e9cff$export$6a6f9cba7a1e5fe4 = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        512,
        512,
        [],
        "f226",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
    ]
};
var $321daf9b005e9cff$export$63f2d9e5f4689aa8 = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        576,
        512,
        [],
        "f228",
        "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var $321daf9b005e9cff$export$aa014b06d2d70598 = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        480,
        512,
        [],
        "f492",
        "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
    ]
};
var $321daf9b005e9cff$export$507e8edd7676b2e9 = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        640,
        512,
        [],
        "f493",
        "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
    ]
};
var $321daf9b005e9cff$export$5c6bd8729527871b = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [],
        "f03d",
        "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
    ]
};
var $321daf9b005e9cff$export$a714fc79f58cc9ef = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
    ]
};
var $321daf9b005e9cff$export$ee4b92e89fe0dfaf = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
    ]
};
var $321daf9b005e9cff$export$37c67e0b3dc6bd1b = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "f974",
        "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
    ]
};
var $321daf9b005e9cff$export$c4ff5306c5470939 = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "f975",
        "M114,227.56H92.44a28.44,28.44,0,0,0,0,56.88H114c50.68,0,76.06,61.28,40.23,97.12L139,396.81A28.44,28.44,0,1,0,179.19,437l15.25-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-26.61,17-45.91,38.22-53.37l-244.5-189A55.58,55.58,0,0,1,114,227.56ZM633.82,458.09,470.62,332c4.17-25.39,24.91-47.52,55.39-47.52h21.55a28.44,28.44,0,1,0,0-56.88H526c-50.68,0-76.06-61.28-40.23-97.12L501,115.19A28.44,28.44,0,0,0,460.81,75L445.56,90.22c-35.84,35.84-97.11,10.46-97.11-40.23V28.45a28.45,28.45,0,0,0-56.9,0V50c0,50.69-61.27,76.07-97.11,40.23L179.19,75A28.43,28.43,0,0,0,139,75c-.13.14-.15.32-.28.46L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM335.43,227.48l-62.87-48.59A46.55,46.55,0,0,1,288,176a48,48,0,0,1,48,48C336,225.22,335.52,226.29,335.43,227.48Z"
    ]
};
var $321daf9b005e9cff$export$ee194b18f5c6f6b6 = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "f976",
        "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
    ]
};
var $321daf9b005e9cff$export$4f1ce88b2b4cd5cd = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
    ]
};
var $321daf9b005e9cff$export$a15e6fc8e68a76b0 = {
    prefix: "fas",
    iconName: "volleyball-ball",
    icon: [
        512,
        512,
        [],
        "f45f",
        "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
    ]
};
var $321daf9b005e9cff$export$69fdf57632b6cc29 = {
    prefix: "fas",
    iconName: "volume-down",
    icon: [
        384,
        512,
        [],
        "f027",
        "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
    ]
};
var $321daf9b005e9cff$export$aa8decd057dfd29b = {
    prefix: "fas",
    iconName: "volume-mute",
    icon: [
        512,
        512,
        [],
        "f6a9",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
    ]
};
var $321daf9b005e9cff$export$d94ba52e980ea0f1 = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        256,
        512,
        [],
        "f026",
        "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
    ]
};
var $321daf9b005e9cff$export$5940d3e475d90cc4 = {
    prefix: "fas",
    iconName: "volume-up",
    icon: [
        576,
        512,
        [],
        "f028",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
    ]
};
var $321daf9b005e9cff$export$e87bb3db1608b850 = {
    prefix: "fas",
    iconName: "vote-yea",
    icon: [
        640,
        512,
        [],
        "f772",
        "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
    ]
};
var $321daf9b005e9cff$export$248171cb6dad4307 = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
    ]
};
var $321daf9b005e9cff$export$4886811b7174ec35 = {
    prefix: "fas",
    iconName: "walking",
    icon: [
        320,
        512,
        [],
        "f554",
        "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
    ]
};
var $321daf9b005e9cff$export$79204db8777905c8 = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$e3a174a50618c208 = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
    ]
};
var $321daf9b005e9cff$export$efaeddad0a6e901b = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
    ]
};
var $321daf9b005e9cff$export$c38cf504b3bc58a2 = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
    ]
};
var $321daf9b005e9cff$export$cf3bafa68a60bae4 = {
    prefix: "fas",
    iconName: "weight",
    icon: [
        512,
        512,
        [],
        "f496",
        "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
    ]
};
var $321daf9b005e9cff$export$43d1fa6671908715 = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var $321daf9b005e9cff$export$76a9413fbe130a53 = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
    ]
};
var $321daf9b005e9cff$export$1642419fe3db2857 = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [],
        "f1eb",
        "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
    ]
};
var $321daf9b005e9cff$export$cc58cb0f2257a6a9 = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
    ]
};
var $321daf9b005e9cff$export$18b7775f78a3e16 = {
    prefix: "fas",
    iconName: "window-close",
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
    ]
};
var $321daf9b005e9cff$export$703cd98be31ec905 = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
    ]
};
var $321daf9b005e9cff$export$26a3f9d2784b90d8 = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
    ]
};
var $321daf9b005e9cff$export$eccfff9bfd585652 = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
    ]
};
var $321daf9b005e9cff$export$770be8b3d5776043 = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
    ]
};
var $321daf9b005e9cff$export$e06d6607d3577d6e = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        288,
        512,
        [],
        "f4e3",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
    ]
};
var $321daf9b005e9cff$export$b8ff3fe2b78aef2f = {
    prefix: "fas",
    iconName: "wine-glass-alt",
    icon: [
        288,
        512,
        [],
        "f5ce",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
    ]
};
var $321daf9b005e9cff$export$51790ddd26e431bc = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        576,
        512,
        [],
        "f159",
        "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
    ]
};
var $321daf9b005e9cff$export$3c6c0c8185296ac5 = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [],
        "f0ad",
        "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var $321daf9b005e9cff$export$8cf137aceaaf4de0 = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        640,
        512,
        [],
        "f497",
        "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
    ]
};
var $321daf9b005e9cff$export$30f1437f5a4e991d = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        384,
        512,
        [],
        "f157",
        "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
    ]
};
var $321daf9b005e9cff$export$6ec1acbf3f610b8f = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        496,
        512,
        [],
        "f6ad",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var $321daf9b005e9cff$export$da048c47c8dcd50a = {
    faAd: $321daf9b005e9cff$export$7af266c3465b1ff2,
    faAddressBook: $321daf9b005e9cff$export$853fd1561789e3bb,
    faAddressCard: $321daf9b005e9cff$export$6ea408c7266ed557,
    faAdjust: $321daf9b005e9cff$export$cfa06e4b68edca2d,
    faAirFreshener: $321daf9b005e9cff$export$a5e63e89b5ccee83,
    faAlignCenter: $321daf9b005e9cff$export$70e29dd05344623e,
    faAlignJustify: $321daf9b005e9cff$export$97c42b56d462df72,
    faAlignLeft: $321daf9b005e9cff$export$e490f662af4d1c78,
    faAlignRight: $321daf9b005e9cff$export$7370f36a39a38737,
    faAllergies: $321daf9b005e9cff$export$dcae2101babbffff,
    faAmbulance: $321daf9b005e9cff$export$f5c7042778b51765,
    faAmericanSignLanguageInterpreting: $321daf9b005e9cff$export$23a7517099ab1b86,
    faAnchor: $321daf9b005e9cff$export$12a35719f889cd1,
    faAngleDoubleDown: $321daf9b005e9cff$export$fd504117f273ca92,
    faAngleDoubleLeft: $321daf9b005e9cff$export$21b0833b3cf929a7,
    faAngleDoubleRight: $321daf9b005e9cff$export$792931403404faf0,
    faAngleDoubleUp: $321daf9b005e9cff$export$9bb51e1a2c07db7c,
    faAngleDown: $321daf9b005e9cff$export$4b5be0142d10f342,
    faAngleLeft: $321daf9b005e9cff$export$3cbcd1b7e35945d2,
    faAngleRight: $321daf9b005e9cff$export$6bce1afb61f2eb66,
    faAngleUp: $321daf9b005e9cff$export$887340269e6d6cac,
    faAngry: $321daf9b005e9cff$export$3c96c08e234498c5,
    faAnkh: $321daf9b005e9cff$export$8736909014b15ca9,
    faAppleAlt: $321daf9b005e9cff$export$bcdd94f3977a0884,
    faArchive: $321daf9b005e9cff$export$26b3e1c454273f34,
    faArchway: $321daf9b005e9cff$export$d56753dd2eb5c323,
    faArrowAltCircleDown: $321daf9b005e9cff$export$ff3afbc8c0bc5d59,
    faArrowAltCircleLeft: $321daf9b005e9cff$export$5460a5b11a24996f,
    faArrowAltCircleRight: $321daf9b005e9cff$export$88962ffdad8b856d,
    faArrowAltCircleUp: $321daf9b005e9cff$export$3747a8ef0995eadf,
    faArrowCircleDown: $321daf9b005e9cff$export$6cfa36bbb3a057,
    faArrowCircleLeft: $321daf9b005e9cff$export$728262abb9f58d0a,
    faArrowCircleRight: $321daf9b005e9cff$export$7d3d828103aa3be7,
    faArrowCircleUp: $321daf9b005e9cff$export$a2f6f3baa50af0b1,
    faArrowDown: $321daf9b005e9cff$export$9686eff8d817f770,
    faArrowLeft: $321daf9b005e9cff$export$b7fac681e7d09400,
    faArrowRight: $321daf9b005e9cff$export$b4da69a0247f3620,
    faArrowUp: $321daf9b005e9cff$export$8e144ed4d52eef49,
    faArrowsAlt: $321daf9b005e9cff$export$3cdabfff52cfc73a,
    faArrowsAltH: $321daf9b005e9cff$export$7937ea574fb1389,
    faArrowsAltV: $321daf9b005e9cff$export$138cb56a3f8f7040,
    faAssistiveListeningSystems: $321daf9b005e9cff$export$8eeef3dc0035b165,
    faAsterisk: $321daf9b005e9cff$export$19eff32c0fd4f99f,
    faAt: $321daf9b005e9cff$export$c115e8063ee02632,
    faAtlas: $321daf9b005e9cff$export$380a9050e42fe5d7,
    faAtom: $321daf9b005e9cff$export$b5bb295e8ad4ab31,
    faAudioDescription: $321daf9b005e9cff$export$b6b464c98c009494,
    faAward: $321daf9b005e9cff$export$f8db2747dadd48f7,
    faBaby: $321daf9b005e9cff$export$8afab767536f59ad,
    faBabyCarriage: $321daf9b005e9cff$export$3b3ab4d86bad7d26,
    faBackspace: $321daf9b005e9cff$export$e43e3f67102fc526,
    faBackward: $321daf9b005e9cff$export$ae65f96ea7a4078d,
    faBacon: $321daf9b005e9cff$export$ab07061fe21a3a8e,
    faBahai: $321daf9b005e9cff$export$6d636565b3ec36b4,
    faBalanceScale: $321daf9b005e9cff$export$fec323dcfd81d750,
    faBalanceScaleLeft: $321daf9b005e9cff$export$786cb0c775487f19,
    faBalanceScaleRight: $321daf9b005e9cff$export$2238e05f8920005a,
    faBan: $321daf9b005e9cff$export$76f704d256def3c7,
    faBandAid: $321daf9b005e9cff$export$b14a1014df2fdf46,
    faBarcode: $321daf9b005e9cff$export$3825a842b5afc5aa,
    faBars: $321daf9b005e9cff$export$36e9cf7887265da2,
    faBaseballBall: $321daf9b005e9cff$export$63a3f8ceae07c7f3,
    faBasketballBall: $321daf9b005e9cff$export$36550ab8ffcc5b28,
    faBath: $321daf9b005e9cff$export$1ea66a88b8f620c9,
    faBatteryEmpty: $321daf9b005e9cff$export$1344b64f6e922e12,
    faBatteryFull: $321daf9b005e9cff$export$9338fc4614cfc0cf,
    faBatteryHalf: $321daf9b005e9cff$export$e6dadc1155c4ee48,
    faBatteryQuarter: $321daf9b005e9cff$export$acec92052ac2183,
    faBatteryThreeQuarters: $321daf9b005e9cff$export$cfb37069d38f379e,
    faBed: $321daf9b005e9cff$export$f24e0fce77994d4d,
    faBeer: $321daf9b005e9cff$export$f74725691538983b,
    faBell: $321daf9b005e9cff$export$9b6162797ab1b255,
    faBellSlash: $321daf9b005e9cff$export$6b31a1e5968b2378,
    faBezierCurve: $321daf9b005e9cff$export$a527a6267c55a54c,
    faBible: $321daf9b005e9cff$export$2eac809b0670d139,
    faBicycle: $321daf9b005e9cff$export$36cb1885ad7a570f,
    faBiking: $321daf9b005e9cff$export$a5bcf835dbf9c0b,
    faBinoculars: $321daf9b005e9cff$export$8a910017964bb8c2,
    faBiohazard: $321daf9b005e9cff$export$ae3a453550dec95,
    faBirthdayCake: $321daf9b005e9cff$export$bdcf98f725a7241a,
    faBlender: $321daf9b005e9cff$export$db34f7a6de38784f,
    faBlenderPhone: $321daf9b005e9cff$export$f35a116a762ef8fc,
    faBlind: $321daf9b005e9cff$export$923de21def6ea9b6,
    faBlog: $321daf9b005e9cff$export$890d5e011054935a,
    faBold: $321daf9b005e9cff$export$7e0c7fd2a2e88823,
    faBolt: $321daf9b005e9cff$export$6869964aa308dd31,
    faBomb: $321daf9b005e9cff$export$d59078f6e80b4a67,
    faBone: $321daf9b005e9cff$export$5902c007d5703f2d,
    faBong: $321daf9b005e9cff$export$e74974fac77c468e,
    faBook: $321daf9b005e9cff$export$c9d7ef726d1a8742,
    faBookDead: $321daf9b005e9cff$export$b98a3f8c3941a74a,
    faBookMedical: $321daf9b005e9cff$export$6feb44fec53ba30d,
    faBookOpen: $321daf9b005e9cff$export$8a3071811b2b7979,
    faBookReader: $321daf9b005e9cff$export$cee14fe33262fa7d,
    faBookmark: $321daf9b005e9cff$export$4ed9da5c3cca0ef1,
    faBorderAll: $321daf9b005e9cff$export$93a5eb721c9c0d25,
    faBorderNone: $321daf9b005e9cff$export$2b488402ec335d97,
    faBorderStyle: $321daf9b005e9cff$export$c2867ca78120d644,
    faBowlingBall: $321daf9b005e9cff$export$5ee2640fe105312d,
    faBox: $321daf9b005e9cff$export$6e7cf270cda52323,
    faBoxOpen: $321daf9b005e9cff$export$9010ed816a8b9c97,
    faBoxTissue: $321daf9b005e9cff$export$f2adc06617bc0c7,
    faBoxes: $321daf9b005e9cff$export$2007320dd6cde6db,
    faBraille: $321daf9b005e9cff$export$983e9c27cac7ed1c,
    faBrain: $321daf9b005e9cff$export$97fa4f4c1006ab1,
    faBreadSlice: $321daf9b005e9cff$export$d78e8b0681279167,
    faBriefcase: $321daf9b005e9cff$export$8da450d063b0eb37,
    faBriefcaseMedical: $321daf9b005e9cff$export$5000f52ca9819bf5,
    faBroadcastTower: $321daf9b005e9cff$export$f68b38d51f5c0ed,
    faBroom: $321daf9b005e9cff$export$2a533051418ff4ca,
    faBrush: $321daf9b005e9cff$export$5824ffe6f8983c83,
    faBug: $321daf9b005e9cff$export$a18cfac400116d9f,
    faBuilding: $321daf9b005e9cff$export$f26673f8b10c3d46,
    faBullhorn: $321daf9b005e9cff$export$dacae2b4ec565333,
    faBullseye: $321daf9b005e9cff$export$554720e3bf74fe90,
    faBurn: $321daf9b005e9cff$export$80ed4535efc60402,
    faBus: $321daf9b005e9cff$export$ce69441578ff2fdb,
    faBusAlt: $321daf9b005e9cff$export$40616edfab6d332a,
    faBusinessTime: $321daf9b005e9cff$export$694b7e88782dec12,
    faCalculator: $321daf9b005e9cff$export$693bd40950ed2c3a,
    faCalendar: $321daf9b005e9cff$export$34f5c36a3e80efa2,
    faCalendarAlt: $321daf9b005e9cff$export$cbc139f33cff356,
    faCalendarCheck: $321daf9b005e9cff$export$5655108e1162ba45,
    faCalendarDay: $321daf9b005e9cff$export$80968bcfef6481ca,
    faCalendarMinus: $321daf9b005e9cff$export$23e8b4955c2d951b,
    faCalendarPlus: $321daf9b005e9cff$export$16768a660ae3ca9d,
    faCalendarTimes: $321daf9b005e9cff$export$99b20d7352fbcf08,
    faCalendarWeek: $321daf9b005e9cff$export$39be5cb4aed5a521,
    faCamera: $321daf9b005e9cff$export$84ffbd7161ca2008,
    faCameraRetro: $321daf9b005e9cff$export$41dbdadc07a89b05,
    faCampground: $321daf9b005e9cff$export$295287303c0e9c7c,
    faCandyCane: $321daf9b005e9cff$export$14d66ba7571ae0b9,
    faCannabis: $321daf9b005e9cff$export$8ec2f752344b69bd,
    faCapsules: $321daf9b005e9cff$export$ba6fd4a436804a48,
    faCar: $321daf9b005e9cff$export$9eefe7fcdf123b76,
    faCarAlt: $321daf9b005e9cff$export$7937ed2462a665c0,
    faCarBattery: $321daf9b005e9cff$export$a44d0c11093d9c1e,
    faCarCrash: $321daf9b005e9cff$export$8ff55566398404cd,
    faCarSide: $321daf9b005e9cff$export$6f7218565b1b8d0e,
    faCaravan: $321daf9b005e9cff$export$afb5d0eee7c1bdb,
    faCaretDown: $321daf9b005e9cff$export$f9395ef707603e40,
    faCaretLeft: $321daf9b005e9cff$export$85a918a11b7643c2,
    faCaretRight: $321daf9b005e9cff$export$f1011352b01c1c0,
    faCaretSquareDown: $321daf9b005e9cff$export$61aea18df1c84401,
    faCaretSquareLeft: $321daf9b005e9cff$export$d0c8ba444f1f9581,
    faCaretSquareRight: $321daf9b005e9cff$export$ae86c9de7e0f62fa,
    faCaretSquareUp: $321daf9b005e9cff$export$307ae80b26533ce5,
    faCaretUp: $321daf9b005e9cff$export$7de776bdab4e536d,
    faCarrot: $321daf9b005e9cff$export$28e93ec9f5e2ddf3,
    faCartArrowDown: $321daf9b005e9cff$export$9206260ff0c0c616,
    faCartPlus: $321daf9b005e9cff$export$6675e2bf21fdb87e,
    faCashRegister: $321daf9b005e9cff$export$6357093f67788b33,
    faCat: $321daf9b005e9cff$export$ab927dada03be4b3,
    faCertificate: $321daf9b005e9cff$export$a881f37164b11fbf,
    faChair: $321daf9b005e9cff$export$a339864ee3df7e9a,
    faChalkboard: $321daf9b005e9cff$export$49a36efd66df775,
    faChalkboardTeacher: $321daf9b005e9cff$export$443fcf69b0155291,
    faChargingStation: $321daf9b005e9cff$export$bab2cd86f8c65657,
    faChartArea: $321daf9b005e9cff$export$2acab8312b7a999b,
    faChartBar: $321daf9b005e9cff$export$b532f5d25de97633,
    faChartLine: $321daf9b005e9cff$export$e022f62a119e1d93,
    faChartPie: $321daf9b005e9cff$export$1de7b9cf7d1b153b,
    faCheck: $321daf9b005e9cff$export$62b2c752fccc6a9c,
    faCheckCircle: $321daf9b005e9cff$export$be9e388158c74f29,
    faCheckDouble: $321daf9b005e9cff$export$f178c8c2ad3cc861,
    faCheckSquare: $321daf9b005e9cff$export$f0c8040f596df7fe,
    faCheese: $321daf9b005e9cff$export$549b99473b7201e6,
    faChess: $321daf9b005e9cff$export$442fddbbd741c590,
    faChessBishop: $321daf9b005e9cff$export$a831eedd2f59c62f,
    faChessBoard: $321daf9b005e9cff$export$bd301515df6246af,
    faChessKing: $321daf9b005e9cff$export$d5713874f8fefe1b,
    faChessKnight: $321daf9b005e9cff$export$861b1f13085cf122,
    faChessPawn: $321daf9b005e9cff$export$3db75d5ac9e98468,
    faChessQueen: $321daf9b005e9cff$export$7b8ce73615739d30,
    faChessRook: $321daf9b005e9cff$export$5d65c40a109eb09c,
    faChevronCircleDown: $321daf9b005e9cff$export$9926124d75b2ecab,
    faChevronCircleLeft: $321daf9b005e9cff$export$4a42c8c2451a33fd,
    faChevronCircleRight: $321daf9b005e9cff$export$2a5db4f6eba6f2b,
    faChevronCircleUp: $321daf9b005e9cff$export$b786cf5db03f2c36,
    faChevronDown: $321daf9b005e9cff$export$8db9bc521720fccd,
    faChevronLeft: $321daf9b005e9cff$export$75702e3e3dd44a44,
    faChevronRight: $321daf9b005e9cff$export$930de8c26eb20490,
    faChevronUp: $321daf9b005e9cff$export$877e5ae47a854215,
    faChild: $321daf9b005e9cff$export$60b41e3581d1739a,
    faChurch: $321daf9b005e9cff$export$16a3f12c6ae9650,
    faCircle: $321daf9b005e9cff$export$4280b2387fbdad12,
    faCircleNotch: $321daf9b005e9cff$export$9429fd8df55155d,
    faCity: $321daf9b005e9cff$export$a9947c2888b3c8fd,
    faClinicMedical: $321daf9b005e9cff$export$20d8a680febc7434,
    faClipboard: $321daf9b005e9cff$export$97d84347d71ba297,
    faClipboardCheck: $321daf9b005e9cff$export$7babcb2c90eb609a,
    faClipboardList: $321daf9b005e9cff$export$2c5a9d8548d8810e,
    faClock: $321daf9b005e9cff$export$95b9968e7fceb821,
    faClone: $321daf9b005e9cff$export$76c1aa4bf9a39458,
    faClosedCaptioning: $321daf9b005e9cff$export$8e047801a8603af7,
    faCloud: $321daf9b005e9cff$export$8bb3c4d5c2f50243,
    faCloudDownloadAlt: $321daf9b005e9cff$export$351357a14c41f824,
    faCloudMeatball: $321daf9b005e9cff$export$5d120e8b87ad33f4,
    faCloudMoon: $321daf9b005e9cff$export$482eb125aaf0fbc2,
    faCloudMoonRain: $321daf9b005e9cff$export$301c3fab0c4545bd,
    faCloudRain: $321daf9b005e9cff$export$a6c308ee087b4ded,
    faCloudShowersHeavy: $321daf9b005e9cff$export$af51c741ee9cc090,
    faCloudSun: $321daf9b005e9cff$export$dcaadfd9c98e42a1,
    faCloudSunRain: $321daf9b005e9cff$export$dd9dc9b4227dbe94,
    faCloudUploadAlt: $321daf9b005e9cff$export$e73b3e819b9d14a5,
    faCocktail: $321daf9b005e9cff$export$4be708f1e41d387b,
    faCode: $321daf9b005e9cff$export$eba095993e51cc97,
    faCodeBranch: $321daf9b005e9cff$export$aa054a78ab078db3,
    faCoffee: $321daf9b005e9cff$export$1d24a9e457278011,
    faCog: $321daf9b005e9cff$export$d6298bbfd1912a78,
    faCogs: $321daf9b005e9cff$export$af1575770afc9559,
    faCoins: $321daf9b005e9cff$export$bc5da164799a0e,
    faColumns: $321daf9b005e9cff$export$bb861166644ac28a,
    faComment: $321daf9b005e9cff$export$805cd88398a70581,
    faCommentAlt: $321daf9b005e9cff$export$6e96904d9af0ec4a,
    faCommentDollar: $321daf9b005e9cff$export$7a088030853df12c,
    faCommentDots: $321daf9b005e9cff$export$63ffcb3d4e94cb92,
    faCommentMedical: $321daf9b005e9cff$export$101422b773924276,
    faCommentSlash: $321daf9b005e9cff$export$3786a0422a3f33ea,
    faComments: $321daf9b005e9cff$export$932912e74adb8939,
    faCommentsDollar: $321daf9b005e9cff$export$d477129b070e5ac4,
    faCompactDisc: $321daf9b005e9cff$export$84021631df0f831b,
    faCompass: $321daf9b005e9cff$export$b4d344633433e50e,
    faCompress: $321daf9b005e9cff$export$83632d1150d3541f,
    faCompressAlt: $321daf9b005e9cff$export$a05650ebe54bede,
    faCompressArrowsAlt: $321daf9b005e9cff$export$39205db0ea980efd,
    faConciergeBell: $321daf9b005e9cff$export$ad92ffbbfbc0fcf3,
    faCookie: $321daf9b005e9cff$export$b3e64f5f68c6623f,
    faCookieBite: $321daf9b005e9cff$export$317dde8664f7de71,
    faCopy: $321daf9b005e9cff$export$e9bd786d30cb716c,
    faCopyright: $321daf9b005e9cff$export$da61665fff8aebfe,
    faCouch: $321daf9b005e9cff$export$ce96e32767a7dd51,
    faCreditCard: $321daf9b005e9cff$export$3e7437bf6535bef0,
    faCrop: $321daf9b005e9cff$export$afa58590dfb6fca2,
    faCropAlt: $321daf9b005e9cff$export$d932915fde4f1010,
    faCross: $321daf9b005e9cff$export$9d0a89fcd084abb,
    faCrosshairs: $321daf9b005e9cff$export$721c101130c40043,
    faCrow: $321daf9b005e9cff$export$bfa312207b788ed9,
    faCrown: $321daf9b005e9cff$export$dc1083dcd1d7b9d6,
    faCrutch: $321daf9b005e9cff$export$e94134641c0e2,
    faCube: $321daf9b005e9cff$export$973ae4f1e4d2ce78,
    faCubes: $321daf9b005e9cff$export$30523a9441a31e97,
    faCut: $321daf9b005e9cff$export$66847f2a71b260e7,
    faDatabase: $321daf9b005e9cff$export$24680dede86b1883,
    faDeaf: $321daf9b005e9cff$export$4b666adf83f0de01,
    faDemocrat: $321daf9b005e9cff$export$a1672d808fbed0bd,
    faDesktop: $321daf9b005e9cff$export$6e6ddc253102e596,
    faDharmachakra: $321daf9b005e9cff$export$45cbd92c28deb2c7,
    faDiagnoses: $321daf9b005e9cff$export$68bad2b52a90d1fa,
    faDice: $321daf9b005e9cff$export$4ed8206e6619cc8f,
    faDiceD20: $321daf9b005e9cff$export$b06003a02c9055bd,
    faDiceD6: $321daf9b005e9cff$export$64bfd48ed353c031,
    faDiceFive: $321daf9b005e9cff$export$d9769fb795c2db82,
    faDiceFour: $321daf9b005e9cff$export$2df6451abf70a6ff,
    faDiceOne: $321daf9b005e9cff$export$d91800b7be5303b0,
    faDiceSix: $321daf9b005e9cff$export$3397c7b4679acccc,
    faDiceThree: $321daf9b005e9cff$export$221059e0d5fd8958,
    faDiceTwo: $321daf9b005e9cff$export$4d85df590065572f,
    faDigitalTachograph: $321daf9b005e9cff$export$b3bf1994f0fefe98,
    faDirections: $321daf9b005e9cff$export$6a6973de44442fe5,
    faDisease: $321daf9b005e9cff$export$c7675a37487adc45,
    faDivide: $321daf9b005e9cff$export$89fa217ec5503ac9,
    faDizzy: $321daf9b005e9cff$export$89a2b10dabc487e8,
    faDna: $321daf9b005e9cff$export$c062100d54a2da00,
    faDog: $321daf9b005e9cff$export$c6406747800cf702,
    faDollarSign: $321daf9b005e9cff$export$fb420d3e4d8c6a18,
    faDolly: $321daf9b005e9cff$export$5879d0bca1aa497b,
    faDollyFlatbed: $321daf9b005e9cff$export$f7c6efb60c53b285,
    faDonate: $321daf9b005e9cff$export$40050ae52860cde7,
    faDoorClosed: $321daf9b005e9cff$export$2c79e1a422528bba,
    faDoorOpen: $321daf9b005e9cff$export$41821b9a6fd703de,
    faDotCircle: $321daf9b005e9cff$export$92bc269cb244d66a,
    faDove: $321daf9b005e9cff$export$a1ab1e69a300089f,
    faDownload: $321daf9b005e9cff$export$8f734e51d72ca13a,
    faDraftingCompass: $321daf9b005e9cff$export$c8c2b127d13b9d79,
    faDragon: $321daf9b005e9cff$export$ae1875ba975aa0e9,
    faDrawPolygon: $321daf9b005e9cff$export$df9bd3777d1154d2,
    faDrum: $321daf9b005e9cff$export$5b9205e1042594b7,
    faDrumSteelpan: $321daf9b005e9cff$export$48d1206500db2e9d,
    faDrumstickBite: $321daf9b005e9cff$export$482976e9a4ab10f3,
    faDumbbell: $321daf9b005e9cff$export$56700074cf37be5c,
    faDumpster: $321daf9b005e9cff$export$3b934e22d1851a3b,
    faDumpsterFire: $321daf9b005e9cff$export$25e9b29b3f2230b5,
    faDungeon: $321daf9b005e9cff$export$1156dc6acb0058bd,
    faEdit: $321daf9b005e9cff$export$7be713e57d023733,
    faEgg: $321daf9b005e9cff$export$1199a8ce85311ab5,
    faEject: $321daf9b005e9cff$export$8484041d5b209494,
    faEllipsisH: $321daf9b005e9cff$export$c9f2fedd4489a2ee,
    faEllipsisV: $321daf9b005e9cff$export$e58494c7fcb5380,
    faEnvelope: $321daf9b005e9cff$export$6f095630677adc,
    faEnvelopeOpen: $321daf9b005e9cff$export$c6c3bd5f7d9b8bf2,
    faEnvelopeOpenText: $321daf9b005e9cff$export$f5c53ce8ec380d11,
    faEnvelopeSquare: $321daf9b005e9cff$export$354e159473e73552,
    faEquals: $321daf9b005e9cff$export$a7c5f5e4805fdab,
    faEraser: $321daf9b005e9cff$export$e7fc4fe34e767f28,
    faEthernet: $321daf9b005e9cff$export$6bad2c9f317b52e5,
    faEuroSign: $321daf9b005e9cff$export$902a3969bb113dff,
    faExchangeAlt: $321daf9b005e9cff$export$f6c6fb20d374b128,
    faExclamation: $321daf9b005e9cff$export$de6218b649cbb6a9,
    faExclamationCircle: $321daf9b005e9cff$export$220e07e14c5d7e5d,
    faExclamationTriangle: $321daf9b005e9cff$export$3d249b63b52cce7c,
    faExpand: $321daf9b005e9cff$export$1fe4a9976a241685,
    faExpandAlt: $321daf9b005e9cff$export$bcb8d86a3a1d6eb6,
    faExpandArrowsAlt: $321daf9b005e9cff$export$6219dcd88b5fa6c2,
    faExternalLinkAlt: $321daf9b005e9cff$export$d7f107e456ab0306,
    faExternalLinkSquareAlt: $321daf9b005e9cff$export$e4cdf2977151ee26,
    faEye: $321daf9b005e9cff$export$b8c3e79e8c99c95b,
    faEyeDropper: $321daf9b005e9cff$export$1bc3e0ad56dc9eb0,
    faEyeSlash: $321daf9b005e9cff$export$ed3f2918429d029a,
    faFan: $321daf9b005e9cff$export$55145a3dae4f984a,
    faFastBackward: $321daf9b005e9cff$export$e6246a3279a379b8,
    faFastForward: $321daf9b005e9cff$export$61a8cdc53c2e078d,
    faFaucet: $321daf9b005e9cff$export$a0856b225f3b0614,
    faFax: $321daf9b005e9cff$export$b5698497901d7197,
    faFeather: $321daf9b005e9cff$export$5e19aea195b31816,
    faFeatherAlt: $321daf9b005e9cff$export$68cf766c786bcd78,
    faFemale: $321daf9b005e9cff$export$70e8e75e61dd7169,
    faFighterJet: $321daf9b005e9cff$export$102b809faf56e033,
    faFile: $321daf9b005e9cff$export$cad54bead856a678,
    faFileAlt: $321daf9b005e9cff$export$243b47dca32bf0b8,
    faFileArchive: $321daf9b005e9cff$export$bf2047a9946b5c3f,
    faFileAudio: $321daf9b005e9cff$export$b8d24c57c9e64933,
    faFileCode: $321daf9b005e9cff$export$143d0ca7d2200f20,
    faFileContract: $321daf9b005e9cff$export$70fde3f3fdaa6a6a,
    faFileCsv: $321daf9b005e9cff$export$82cea4f586f6ec9,
    faFileDownload: $321daf9b005e9cff$export$1013b9966d758343,
    faFileExcel: $321daf9b005e9cff$export$77cb1a465c4fe84,
    faFileExport: $321daf9b005e9cff$export$364f19abcfac1b0a,
    faFileImage: $321daf9b005e9cff$export$6440b286d3cbac9b,
    faFileImport: $321daf9b005e9cff$export$d796c05153b1255c,
    faFileInvoice: $321daf9b005e9cff$export$bef39294aed2281a,
    faFileInvoiceDollar: $321daf9b005e9cff$export$a3dced32d48cb1ea,
    faFileMedical: $321daf9b005e9cff$export$56cbcd962389b090,
    faFileMedicalAlt: $321daf9b005e9cff$export$ef02a0f5b39aa61f,
    faFilePdf: $321daf9b005e9cff$export$38611f1c776aba73,
    faFilePowerpoint: $321daf9b005e9cff$export$c341daeecdea449a,
    faFilePrescription: $321daf9b005e9cff$export$a20cb90865b6beb8,
    faFileSignature: $321daf9b005e9cff$export$d0de575ac166712b,
    faFileUpload: $321daf9b005e9cff$export$dd55ded1264643d2,
    faFileVideo: $321daf9b005e9cff$export$b44eb38345c6a964,
    faFileWord: $321daf9b005e9cff$export$f0858dff6e769cf6,
    faFill: $321daf9b005e9cff$export$d3c2bcfd3b861e4a,
    faFillDrip: $321daf9b005e9cff$export$38320138fc0262d0,
    faFilm: $321daf9b005e9cff$export$c03de0cc616e77bb,
    faFilter: $321daf9b005e9cff$export$f253a38d7142e29f,
    faFingerprint: $321daf9b005e9cff$export$614dc068d88655af,
    faFire: $321daf9b005e9cff$export$7b24b34ef6cc130c,
    faFireAlt: $321daf9b005e9cff$export$70dc26b4926d0b1b,
    faFireExtinguisher: $321daf9b005e9cff$export$d75fb6743634a0a,
    faFirstAid: $321daf9b005e9cff$export$5b01ccb2da4c4387,
    faFish: $321daf9b005e9cff$export$24228a855c5f6812,
    faFistRaised: $321daf9b005e9cff$export$fa0323a4d7489a8d,
    faFlag: $321daf9b005e9cff$export$6591b1ea509be9da,
    faFlagCheckered: $321daf9b005e9cff$export$92fad97e19a9fea,
    faFlagUsa: $321daf9b005e9cff$export$19357abad396e723,
    faFlask: $321daf9b005e9cff$export$f9b579ba06048af,
    faFlushed: $321daf9b005e9cff$export$dfd2bd012685aeac,
    faFolder: $321daf9b005e9cff$export$72b780186370e953,
    faFolderMinus: $321daf9b005e9cff$export$758f1fb3784e4080,
    faFolderOpen: $321daf9b005e9cff$export$ff7e93418af88b78,
    faFolderPlus: $321daf9b005e9cff$export$e18e05ffa2045d3b,
    faFont: $321daf9b005e9cff$export$a5dc297d3f60936,
    faFontAwesomeLogoFull: $321daf9b005e9cff$export$6e20d421a2e0f320,
    faFootballBall: $321daf9b005e9cff$export$e8fd664711e31704,
    faForward: $321daf9b005e9cff$export$a8710cdb23198d53,
    faFrog: $321daf9b005e9cff$export$fe2358263efac504,
    faFrown: $321daf9b005e9cff$export$43b7108508aecc5f,
    faFrownOpen: $321daf9b005e9cff$export$c4775e66bed5d96,
    faFunnelDollar: $321daf9b005e9cff$export$cebe38ad8f0a143d,
    faFutbol: $321daf9b005e9cff$export$65a345b33858a655,
    faGamepad: $321daf9b005e9cff$export$6a66b1b639455bef,
    faGasPump: $321daf9b005e9cff$export$84666c793cb2a347,
    faGavel: $321daf9b005e9cff$export$c36fb40057e2c3aa,
    faGem: $321daf9b005e9cff$export$31ee86ac717db552,
    faGenderless: $321daf9b005e9cff$export$c093cc22e88981c2,
    faGhost: $321daf9b005e9cff$export$1a989eb1919c64c1,
    faGift: $321daf9b005e9cff$export$b2727de8ccdbb5ec,
    faGifts: $321daf9b005e9cff$export$de9a67b55dbe819a,
    faGlassCheers: $321daf9b005e9cff$export$20007d7d74cb98fe,
    faGlassMartini: $321daf9b005e9cff$export$e96f280e39af4a91,
    faGlassMartiniAlt: $321daf9b005e9cff$export$2258439b8f4e7acb,
    faGlassWhiskey: $321daf9b005e9cff$export$fdec0f5f1a169419,
    faGlasses: $321daf9b005e9cff$export$58d7d709c0a8ca5f,
    faGlobe: $321daf9b005e9cff$export$b1b1cdce4a19c682,
    faGlobeAfrica: $321daf9b005e9cff$export$64af36f3b403a57c,
    faGlobeAmericas: $321daf9b005e9cff$export$e96bcc7bde9498db,
    faGlobeAsia: $321daf9b005e9cff$export$796fdfc909e603f4,
    faGlobeEurope: $321daf9b005e9cff$export$5318b8ede86cc96b,
    faGolfBall: $321daf9b005e9cff$export$2251487a9a33c682,
    faGopuram: $321daf9b005e9cff$export$31f89d8ac1d14ed6,
    faGraduationCap: $321daf9b005e9cff$export$874e305fd7920cce,
    faGreaterThan: $321daf9b005e9cff$export$da07b6bc24a496ca,
    faGreaterThanEqual: $321daf9b005e9cff$export$7bf8dfe2e6661a54,
    faGrimace: $321daf9b005e9cff$export$3d08cd36ac1ef231,
    faGrin: $321daf9b005e9cff$export$37e1f10b6de76621,
    faGrinAlt: $321daf9b005e9cff$export$b4abebfe416d36ba,
    faGrinBeam: $321daf9b005e9cff$export$734da5249381ec7e,
    faGrinBeamSweat: $321daf9b005e9cff$export$14d0ccc54c5b6826,
    faGrinHearts: $321daf9b005e9cff$export$c56cf0e0c3bc5ed2,
    faGrinSquint: $321daf9b005e9cff$export$243ae757907b1580,
    faGrinSquintTears: $321daf9b005e9cff$export$542206d6a85f3b42,
    faGrinStars: $321daf9b005e9cff$export$64347a5c8c402ef4,
    faGrinTears: $321daf9b005e9cff$export$b2f7512221512b5b,
    faGrinTongue: $321daf9b005e9cff$export$ef222816a43a4b3a,
    faGrinTongueSquint: $321daf9b005e9cff$export$4edf34c3def09a31,
    faGrinTongueWink: $321daf9b005e9cff$export$58099903d50aefb3,
    faGrinWink: $321daf9b005e9cff$export$2397fcd34eb12177,
    faGripHorizontal: $321daf9b005e9cff$export$4a45308d6c8decc1,
    faGripLines: $321daf9b005e9cff$export$1412f35381064d7d,
    faGripLinesVertical: $321daf9b005e9cff$export$523960de087f5198,
    faGripVertical: $321daf9b005e9cff$export$cacbd95c283996ec,
    faGuitar: $321daf9b005e9cff$export$790dd5b32282b6fb,
    faHSquare: $321daf9b005e9cff$export$f08bbcf8f59eafc2,
    faHamburger: $321daf9b005e9cff$export$bab3bb9f4f59363,
    faHammer: $321daf9b005e9cff$export$6310f315e1ebbca5,
    faHamsa: $321daf9b005e9cff$export$38d20d399463edf9,
    faHandHolding: $321daf9b005e9cff$export$e6094d25274088ab,
    faHandHoldingHeart: $321daf9b005e9cff$export$97e5ef3e80a0fbef,
    faHandHoldingMedical: $321daf9b005e9cff$export$bb2a6b1b5e852300,
    faHandHoldingUsd: $321daf9b005e9cff$export$47d27bc305b59690,
    faHandHoldingWater: $321daf9b005e9cff$export$4265371b99d38b95,
    faHandLizard: $321daf9b005e9cff$export$54608d0a883fea4d,
    faHandMiddleFinger: $321daf9b005e9cff$export$bd40d3a3a16fb147,
    faHandPaper: $321daf9b005e9cff$export$6e6216c8b50471bb,
    faHandPeace: $321daf9b005e9cff$export$e49e3cfceea441cc,
    faHandPointDown: $321daf9b005e9cff$export$f6dcbf0a940428f4,
    faHandPointLeft: $321daf9b005e9cff$export$b276ec3dc9760d39,
    faHandPointRight: $321daf9b005e9cff$export$f7bc8714c970afa4,
    faHandPointUp: $321daf9b005e9cff$export$cdc9f5e7e94e76da,
    faHandPointer: $321daf9b005e9cff$export$d97ff927c450c87f,
    faHandRock: $321daf9b005e9cff$export$97a81eba394c8c44,
    faHandScissors: $321daf9b005e9cff$export$c578e919f2c5c135,
    faHandSparkles: $321daf9b005e9cff$export$72e2d874a963de0c,
    faHandSpock: $321daf9b005e9cff$export$2262d6b626de1120,
    faHands: $321daf9b005e9cff$export$f9712d0cf5150f0c,
    faHandsHelping: $321daf9b005e9cff$export$287dbb1632da0d44,
    faHandsWash: $321daf9b005e9cff$export$996b5dea53b124e3,
    faHandshake: $321daf9b005e9cff$export$b4c63e9bfc7906f1,
    faHandshakeAltSlash: $321daf9b005e9cff$export$ca302f956ae9f1bf,
    faHandshakeSlash: $321daf9b005e9cff$export$2cef3f81ad90fb76,
    faHanukiah: $321daf9b005e9cff$export$3dcd4ca3f7108a82,
    faHardHat: $321daf9b005e9cff$export$7b72177558a98b6f,
    faHashtag: $321daf9b005e9cff$export$c92c903bade56844,
    faHatCowboy: $321daf9b005e9cff$export$37672611144b857b,
    faHatCowboySide: $321daf9b005e9cff$export$ab6f71fd6878da90,
    faHatWizard: $321daf9b005e9cff$export$7daa48199dcb2ad1,
    faHdd: $321daf9b005e9cff$export$62551e9c5ba7093f,
    faHeadSideCough: $321daf9b005e9cff$export$3cd04b7c1624f598,
    faHeadSideCoughSlash: $321daf9b005e9cff$export$b293ee8fb8e6b0c4,
    faHeadSideMask: $321daf9b005e9cff$export$280300af4baa1a3e,
    faHeadSideVirus: $321daf9b005e9cff$export$5b64b916710da7c7,
    faHeading: $321daf9b005e9cff$export$4805b8d175aeb9fb,
    faHeadphones: $321daf9b005e9cff$export$ad02dd8ca5816958,
    faHeadphonesAlt: $321daf9b005e9cff$export$6f0433fa527dd5be,
    faHeadset: $321daf9b005e9cff$export$23b086400a31acfe,
    faHeart: $321daf9b005e9cff$export$e4b51a47a2f8b9db,
    faHeartBroken: $321daf9b005e9cff$export$4a565395cb65b282,
    faHeartbeat: $321daf9b005e9cff$export$ca880e19206e80aa,
    faHelicopter: $321daf9b005e9cff$export$612d3e1afaf45fa5,
    faHighlighter: $321daf9b005e9cff$export$73801ed54b42fabe,
    faHiking: $321daf9b005e9cff$export$b2ab0105a901499e,
    faHippo: $321daf9b005e9cff$export$d4c909619093de2d,
    faHistory: $321daf9b005e9cff$export$76d1986559ca7b7a,
    faHockeyPuck: $321daf9b005e9cff$export$a274b02dc75663dc,
    faHollyBerry: $321daf9b005e9cff$export$273296afacf93991,
    faHome: $321daf9b005e9cff$export$48f10d71ec526479,
    faHorse: $321daf9b005e9cff$export$5b05f097fa38352a,
    faHorseHead: $321daf9b005e9cff$export$5bcca85203ebd1e8,
    faHospital: $321daf9b005e9cff$export$7a76c9d35b42d691,
    faHospitalAlt: $321daf9b005e9cff$export$cea7736417b94a3b,
    faHospitalSymbol: $321daf9b005e9cff$export$c8a3c78d99c23fed,
    faHospitalUser: $321daf9b005e9cff$export$684703c93d630cc5,
    faHotTub: $321daf9b005e9cff$export$4842af92b516c40b,
    faHotdog: $321daf9b005e9cff$export$9fae219b4d3ce0be,
    faHotel: $321daf9b005e9cff$export$c402efcf01d5ca07,
    faHourglass: $321daf9b005e9cff$export$b9098a890f61e022,
    faHourglassEnd: $321daf9b005e9cff$export$52757ecc5b1e25b9,
    faHourglassHalf: $321daf9b005e9cff$export$703272eebf5e3eea,
    faHourglassStart: $321daf9b005e9cff$export$f0c28584caa8f4b,
    faHouseDamage: $321daf9b005e9cff$export$8d7e943005ce0b49,
    faHouseUser: $321daf9b005e9cff$export$9a513ee921e8e885,
    faHryvnia: $321daf9b005e9cff$export$33d5f94bd6f75f59,
    faICursor: $321daf9b005e9cff$export$7fddf76ec23943d8,
    faIceCream: $321daf9b005e9cff$export$dd52741c60cc638f,
    faIcicles: $321daf9b005e9cff$export$78792ed87d92a3ad,
    faIcons: $321daf9b005e9cff$export$7fe2894454d8eb8a,
    faIdBadge: $321daf9b005e9cff$export$a75288855ea05282,
    faIdCard: $321daf9b005e9cff$export$782ac893fc22249b,
    faIdCardAlt: $321daf9b005e9cff$export$dc37ebbac31f6c6c,
    faIgloo: $321daf9b005e9cff$export$4a284575edd6f1af,
    faImage: $321daf9b005e9cff$export$7e9f0928967e03b,
    faImages: $321daf9b005e9cff$export$74f06b41ed2ca28a,
    faInbox: $321daf9b005e9cff$export$366b69cbdce46334,
    faIndent: $321daf9b005e9cff$export$318208bc30aeebcc,
    faIndustry: $321daf9b005e9cff$export$5548c3eb51060fa8,
    faInfinity: $321daf9b005e9cff$export$a590003279d671b8,
    faInfo: $321daf9b005e9cff$export$d469b770895f47ac,
    faInfoCircle: $321daf9b005e9cff$export$aa9288aeadf882fa,
    faItalic: $321daf9b005e9cff$export$16e344bae4d495ed,
    faJedi: $321daf9b005e9cff$export$859f204e59641ca4,
    faJoint: $321daf9b005e9cff$export$e5a289fb22ffb8cb,
    faJournalWhills: $321daf9b005e9cff$export$66a0d8d45aab6631,
    faKaaba: $321daf9b005e9cff$export$ab1408bfbe914cc9,
    faKey: $321daf9b005e9cff$export$fa6ecc35e7315db,
    faKeyboard: $321daf9b005e9cff$export$fb61df5d98785fa8,
    faKhanda: $321daf9b005e9cff$export$8d41d1f1ba3f9217,
    faKiss: $321daf9b005e9cff$export$c762a77aabf64fd0,
    faKissBeam: $321daf9b005e9cff$export$d6ff8a73c0812e63,
    faKissWinkHeart: $321daf9b005e9cff$export$ebba617701dfb917,
    faKiwiBird: $321daf9b005e9cff$export$d9933d91e1314d02,
    faLandmark: $321daf9b005e9cff$export$2bebc54c51db6505,
    faLanguage: $321daf9b005e9cff$export$8a7bee49fdf8c954,
    faLaptop: $321daf9b005e9cff$export$c2dee3bd177275a2,
    faLaptopCode: $321daf9b005e9cff$export$94100f4c6ee29932,
    faLaptopHouse: $321daf9b005e9cff$export$efd983de5e4d6ad3,
    faLaptopMedical: $321daf9b005e9cff$export$ba2fa38f7bcc6930,
    faLaugh: $321daf9b005e9cff$export$6c74e314e801a4fe,
    faLaughBeam: $321daf9b005e9cff$export$a88d1f4073ea9369,
    faLaughSquint: $321daf9b005e9cff$export$b206e700cf7084e1,
    faLaughWink: $321daf9b005e9cff$export$77ac40095f39933e,
    faLayerGroup: $321daf9b005e9cff$export$a137712e11e257dd,
    faLeaf: $321daf9b005e9cff$export$7c497bae2754a087,
    faLemon: $321daf9b005e9cff$export$4fbda8f64648f3b5,
    faLessThan: $321daf9b005e9cff$export$7f24f1bf98af5411,
    faLessThanEqual: $321daf9b005e9cff$export$b2c723344cff0d8,
    faLevelDownAlt: $321daf9b005e9cff$export$c07eb6ff5a382cbd,
    faLevelUpAlt: $321daf9b005e9cff$export$d6f21a309b179c3d,
    faLifeRing: $321daf9b005e9cff$export$53dd2cacf674142a,
    faLightbulb: $321daf9b005e9cff$export$1e80f89fe84a215b,
    faLink: $321daf9b005e9cff$export$88bc01ff8dbecc55,
    faLiraSign: $321daf9b005e9cff$export$f0f37dbc60110b10,
    faList: $321daf9b005e9cff$export$6cfc59842fedbc16,
    faListAlt: $321daf9b005e9cff$export$c6327a203ffc65a3,
    faListOl: $321daf9b005e9cff$export$3db8f67cd0fc963b,
    faListUl: $321daf9b005e9cff$export$f8a219cf4f516384,
    faLocationArrow: $321daf9b005e9cff$export$4ac9c4c370f7b157,
    faLock: $321daf9b005e9cff$export$7aa08ad5d562578a,
    faLockOpen: $321daf9b005e9cff$export$84b5acad4436d02a,
    faLongArrowAltDown: $321daf9b005e9cff$export$8b92530ca6418c2f,
    faLongArrowAltLeft: $321daf9b005e9cff$export$a8b3226b2bf323d,
    faLongArrowAltRight: $321daf9b005e9cff$export$533e1f578f74c066,
    faLongArrowAltUp: $321daf9b005e9cff$export$43c8f2a46326c55f,
    faLowVision: $321daf9b005e9cff$export$7a65d2aa54cb4e93,
    faLuggageCart: $321daf9b005e9cff$export$bd1e24dd3cde8514,
    faLungs: $321daf9b005e9cff$export$ba9b387e84727819,
    faLungsVirus: $321daf9b005e9cff$export$895159d10626af74,
    faMagic: $321daf9b005e9cff$export$e58f9b502d4dd52d,
    faMagnet: $321daf9b005e9cff$export$78932e9c9abea6b7,
    faMailBulk: $321daf9b005e9cff$export$dd24f40c5337e2e1,
    faMale: $321daf9b005e9cff$export$2e21f9dba1630651,
    faMap: $321daf9b005e9cff$export$fc82fb79180cd17c,
    faMapMarked: $321daf9b005e9cff$export$df04458e7e32352c,
    faMapMarkedAlt: $321daf9b005e9cff$export$a977d47c74d8e86c,
    faMapMarker: $321daf9b005e9cff$export$10d360e4f1a554dd,
    faMapMarkerAlt: $321daf9b005e9cff$export$4be92fa780613f93,
    faMapPin: $321daf9b005e9cff$export$184725965b3402dc,
    faMapSigns: $321daf9b005e9cff$export$743f4b1071b3333a,
    faMarker: $321daf9b005e9cff$export$e6789173649caa25,
    faMars: $321daf9b005e9cff$export$a9f5c0b9c1e77a6f,
    faMarsDouble: $321daf9b005e9cff$export$2f8a28204bb4b86f,
    faMarsStroke: $321daf9b005e9cff$export$aa05fce255a5d269,
    faMarsStrokeH: $321daf9b005e9cff$export$5cb0daeafbcdabe3,
    faMarsStrokeV: $321daf9b005e9cff$export$ed7aa1c25104f333,
    faMask: $321daf9b005e9cff$export$7b028758c03b9655,
    faMedal: $321daf9b005e9cff$export$b48a5be96314835a,
    faMedkit: $321daf9b005e9cff$export$e75f02bae5b7d34b,
    faMeh: $321daf9b005e9cff$export$6d2db489aaeeecd2,
    faMehBlank: $321daf9b005e9cff$export$e945435725f71e88,
    faMehRollingEyes: $321daf9b005e9cff$export$fdc62a1bea767cc2,
    faMemory: $321daf9b005e9cff$export$5f9bd9f6df021f93,
    faMenorah: $321daf9b005e9cff$export$232452c59d77c56e,
    faMercury: $321daf9b005e9cff$export$e134ecd00b622a47,
    faMeteor: $321daf9b005e9cff$export$1439f0d6365138da,
    faMicrochip: $321daf9b005e9cff$export$4a7bb4be15f35178,
    faMicrophone: $321daf9b005e9cff$export$eed3c491effe6d12,
    faMicrophoneAlt: $321daf9b005e9cff$export$f08ef94fea14f5ac,
    faMicrophoneAltSlash: $321daf9b005e9cff$export$d2a53a388f30780,
    faMicrophoneSlash: $321daf9b005e9cff$export$843f63d64e6f7951,
    faMicroscope: $321daf9b005e9cff$export$6a99139787bf9967,
    faMinus: $321daf9b005e9cff$export$fee0376c250cdef,
    faMinusCircle: $321daf9b005e9cff$export$f3979b49bf57313c,
    faMinusSquare: $321daf9b005e9cff$export$ffe9387966b3e681,
    faMitten: $321daf9b005e9cff$export$5030322c5fc886d7,
    faMobile: $321daf9b005e9cff$export$59edacfad04cd121,
    faMobileAlt: $321daf9b005e9cff$export$e9599bc6cd92234d,
    faMoneyBill: $321daf9b005e9cff$export$608138a7337b5d1a,
    faMoneyBillAlt: $321daf9b005e9cff$export$a35d573395884c3d,
    faMoneyBillWave: $321daf9b005e9cff$export$53e23123cc9a6796,
    faMoneyBillWaveAlt: $321daf9b005e9cff$export$1613858e873cbb3e,
    faMoneyCheck: $321daf9b005e9cff$export$be069f641c85d0b3,
    faMoneyCheckAlt: $321daf9b005e9cff$export$8c6ccc9745897cb2,
    faMonument: $321daf9b005e9cff$export$6f9b0bfc012deb25,
    faMoon: $321daf9b005e9cff$export$c4c2f69a53bab720,
    faMortarPestle: $321daf9b005e9cff$export$55ceb5d0c144580a,
    faMosque: $321daf9b005e9cff$export$4999586d7e1087fb,
    faMotorcycle: $321daf9b005e9cff$export$f26017bdca99338d,
    faMountain: $321daf9b005e9cff$export$64f9eb99c9749cce,
    faMouse: $321daf9b005e9cff$export$198b96b894c66074,
    faMousePointer: $321daf9b005e9cff$export$2e19a69cc26b147,
    faMugHot: $321daf9b005e9cff$export$47a822c30184e8af,
    faMusic: $321daf9b005e9cff$export$fcb0647a5340b5b8,
    faNetworkWired: $321daf9b005e9cff$export$882cabd11f4943b8,
    faNeuter: $321daf9b005e9cff$export$771cf879fba0cf93,
    faNewspaper: $321daf9b005e9cff$export$d91b374112d4f8c1,
    faNotEqual: $321daf9b005e9cff$export$6a15ccae09bbaf93,
    faNotesMedical: $321daf9b005e9cff$export$b2d79133c81d6697,
    faObjectGroup: $321daf9b005e9cff$export$40cdac24aa94a57a,
    faObjectUngroup: $321daf9b005e9cff$export$887f6345573abcac,
    faOilCan: $321daf9b005e9cff$export$2599126c3a57f727,
    faOm: $321daf9b005e9cff$export$8de8eb94230028a5,
    faOtter: $321daf9b005e9cff$export$743cce3ca4eb1d7d,
    faOutdent: $321daf9b005e9cff$export$e21cfc4f23776bff,
    faPager: $321daf9b005e9cff$export$e1611f373a10a98c,
    faPaintBrush: $321daf9b005e9cff$export$594db3339e212bc9,
    faPaintRoller: $321daf9b005e9cff$export$d1de8d1b815d6a5,
    faPalette: $321daf9b005e9cff$export$5c390baea5db4f77,
    faPallet: $321daf9b005e9cff$export$d7ff2047dbc34562,
    faPaperPlane: $321daf9b005e9cff$export$b5378818301da1be,
    faPaperclip: $321daf9b005e9cff$export$4b24ca1552f410af,
    faParachuteBox: $321daf9b005e9cff$export$ca9e3368f1d9500a,
    faParagraph: $321daf9b005e9cff$export$dec46f8df1860e0,
    faParking: $321daf9b005e9cff$export$fda29c8f99573a4e,
    faPassport: $321daf9b005e9cff$export$2c31ca0d9bee400f,
    faPastafarianism: $321daf9b005e9cff$export$733efdaec97447be,
    faPaste: $321daf9b005e9cff$export$6f95f90dd1f6d86b,
    faPause: $321daf9b005e9cff$export$da79f048408b1722,
    faPauseCircle: $321daf9b005e9cff$export$d8cf08a0362da8db,
    faPaw: $321daf9b005e9cff$export$7bc6e4d977673e69,
    faPeace: $321daf9b005e9cff$export$8614cb1326eacd7a,
    faPen: $321daf9b005e9cff$export$8f4567331fb0d3bc,
    faPenAlt: $321daf9b005e9cff$export$a3d3e92e430d3beb,
    faPenFancy: $321daf9b005e9cff$export$8bdfe14ac72a8b17,
    faPenNib: $321daf9b005e9cff$export$a82594dcc75a49f5,
    faPenSquare: $321daf9b005e9cff$export$fbb231ccb3d960bc,
    faPencilAlt: $321daf9b005e9cff$export$8210adc172262df,
    faPencilRuler: $321daf9b005e9cff$export$e3a7a1affea005f5,
    faPeopleArrows: $321daf9b005e9cff$export$804bfc5c390e1a2a,
    faPeopleCarry: $321daf9b005e9cff$export$35fbd4ff1265acd5,
    faPepperHot: $321daf9b005e9cff$export$4894bf28f771e1f3,
    faPercent: $321daf9b005e9cff$export$89a1764fbb7ad2cb,
    faPercentage: $321daf9b005e9cff$export$89333857fc063a2e,
    faPersonBooth: $321daf9b005e9cff$export$2337c975289bdd84,
    faPhone: $321daf9b005e9cff$export$ddab067855cf34cb,
    faPhoneAlt: $321daf9b005e9cff$export$a07a9b305deebf32,
    faPhoneSlash: $321daf9b005e9cff$export$4c60a3aade08b6c2,
    faPhoneSquare: $321daf9b005e9cff$export$8ba22605a641ebdf,
    faPhoneSquareAlt: $321daf9b005e9cff$export$a41e77f0de98bba7,
    faPhoneVolume: $321daf9b005e9cff$export$c377f240bb8b5d74,
    faPhotoVideo: $321daf9b005e9cff$export$739f6a6a12dfb6ed,
    faPiggyBank: $321daf9b005e9cff$export$46d49a6734c4872a,
    faPills: $321daf9b005e9cff$export$6380e2ed6e69d350,
    faPizzaSlice: $321daf9b005e9cff$export$c9f93c4667edc585,
    faPlaceOfWorship: $321daf9b005e9cff$export$c5a9302c8c13c79a,
    faPlane: $321daf9b005e9cff$export$f654c69e66b466c0,
    faPlaneArrival: $321daf9b005e9cff$export$9b2dbe133273f284,
    faPlaneDeparture: $321daf9b005e9cff$export$6ccbeeccfea6dc8a,
    faPlaneSlash: $321daf9b005e9cff$export$cfee4df0d5df6d21,
    faPlay: $321daf9b005e9cff$export$436587205947bca5,
    faPlayCircle: $321daf9b005e9cff$export$cf04333781061c5e,
    faPlug: $321daf9b005e9cff$export$cae5752c3e3b6545,
    faPlus: $321daf9b005e9cff$export$a105e7b44ca0eb9e,
    faPlusCircle: $321daf9b005e9cff$export$d9cc3a81499af48c,
    faPlusSquare: $321daf9b005e9cff$export$b6359eebfe900c35,
    faPodcast: $321daf9b005e9cff$export$5c0b4709125e92f8,
    faPoll: $321daf9b005e9cff$export$bc8ca14ab51f93db,
    faPollH: $321daf9b005e9cff$export$456a238f0144d430,
    faPoo: $321daf9b005e9cff$export$dd0ede1713d2d2f9,
    faPooStorm: $321daf9b005e9cff$export$48a38da471b097a2,
    faPoop: $321daf9b005e9cff$export$bb45b6b87d1adf27,
    faPortrait: $321daf9b005e9cff$export$e3d25f819c7ee7d7,
    faPoundSign: $321daf9b005e9cff$export$9ce041dfec8319b,
    faPowerOff: $321daf9b005e9cff$export$a1cca9928dcf9798,
    faPray: $321daf9b005e9cff$export$3b32c982141cad51,
    faPrayingHands: $321daf9b005e9cff$export$95e08e91b0929943,
    faPrescription: $321daf9b005e9cff$export$8767bafb19515ee4,
    faPrescriptionBottle: $321daf9b005e9cff$export$214f9ce665590486,
    faPrescriptionBottleAlt: $321daf9b005e9cff$export$65d1c884b8581d1a,
    faPrint: $321daf9b005e9cff$export$ae64371e02ee8e56,
    faProcedures: $321daf9b005e9cff$export$5f9e1870e1866dde,
    faProjectDiagram: $321daf9b005e9cff$export$30bf9f5b96509df1,
    faPumpMedical: $321daf9b005e9cff$export$f1b881c73328720c,
    faPumpSoap: $321daf9b005e9cff$export$821aeede187f23c9,
    faPuzzlePiece: $321daf9b005e9cff$export$7ee0dbd1e92e2859,
    faQrcode: $321daf9b005e9cff$export$fc19ca0fe15e73bc,
    faQuestion: $321daf9b005e9cff$export$d96973f90e8f6e47,
    faQuestionCircle: $321daf9b005e9cff$export$5ba67d7f2265c1a5,
    faQuidditch: $321daf9b005e9cff$export$c00c446e6db1605f,
    faQuoteLeft: $321daf9b005e9cff$export$932a67a1b1a7a724,
    faQuoteRight: $321daf9b005e9cff$export$54e3a80c9875b74c,
    faQuran: $321daf9b005e9cff$export$46f29ea84ed4c5f1,
    faRadiation: $321daf9b005e9cff$export$4c4e509518093d6d,
    faRadiationAlt: $321daf9b005e9cff$export$2f048fa82bbddf6f,
    faRainbow: $321daf9b005e9cff$export$92ab27739d3a91b2,
    faRandom: $321daf9b005e9cff$export$8357bf8cc666d5f0,
    faReceipt: $321daf9b005e9cff$export$32b0cd6133c2742,
    faRecordVinyl: $321daf9b005e9cff$export$fe2d5012d9982673,
    faRecycle: $321daf9b005e9cff$export$a65c441f12cb6bd,
    faRedo: $321daf9b005e9cff$export$3d9f98aa1c24c776,
    faRedoAlt: $321daf9b005e9cff$export$50c037520c6cfdc1,
    faRegistered: $321daf9b005e9cff$export$5f519e9ac15ab8c3,
    faRemoveFormat: $321daf9b005e9cff$export$d91179f327329532,
    faReply: $321daf9b005e9cff$export$bb06d4a7bb6736fe,
    faReplyAll: $321daf9b005e9cff$export$ca6fd367f31ecbc5,
    faRepublican: $321daf9b005e9cff$export$929518bb4b66a588,
    faRestroom: $321daf9b005e9cff$export$5fbcef35138741a5,
    faRetweet: $321daf9b005e9cff$export$cebc76f79478e40e,
    faRibbon: $321daf9b005e9cff$export$838459d11f3971df,
    faRing: $321daf9b005e9cff$export$a95486586631edc7,
    faRoad: $321daf9b005e9cff$export$f224567a4851a5e9,
    faRobot: $321daf9b005e9cff$export$30a5bb4ad3fa716c,
    faRocket: $321daf9b005e9cff$export$b24d84ed5657d89a,
    faRoute: $321daf9b005e9cff$export$806c0a45a7ecd6e8,
    faRss: $321daf9b005e9cff$export$7329a1ca27b90c5b,
    faRssSquare: $321daf9b005e9cff$export$89c9b1cca2c11484,
    faRubleSign: $321daf9b005e9cff$export$1ae0a94c8ba4131a,
    faRuler: $321daf9b005e9cff$export$8e90575265a56cfc,
    faRulerCombined: $321daf9b005e9cff$export$613f406c1b5802a8,
    faRulerHorizontal: $321daf9b005e9cff$export$46c6347bff3e04a,
    faRulerVertical: $321daf9b005e9cff$export$a6ad5df9d9f29553,
    faRunning: $321daf9b005e9cff$export$5dfd1cb43dc9eadb,
    faRupeeSign: $321daf9b005e9cff$export$8bf9e3f7f57d486a,
    faSadCry: $321daf9b005e9cff$export$8e924e6bd422cef9,
    faSadTear: $321daf9b005e9cff$export$4b5241926f692f91,
    faSatellite: $321daf9b005e9cff$export$da3f1730d013e224,
    faSatelliteDish: $321daf9b005e9cff$export$219ccae0e4da3c92,
    faSave: $321daf9b005e9cff$export$1aaa83ff70706e1e,
    faSchool: $321daf9b005e9cff$export$51e9b8434982947d,
    faScrewdriver: $321daf9b005e9cff$export$7484ff654cd6474f,
    faScroll: $321daf9b005e9cff$export$7c265716d4399676,
    faSdCard: $321daf9b005e9cff$export$303efb6031da122,
    faSearch: $321daf9b005e9cff$export$871a78837687ffe8,
    faSearchDollar: $321daf9b005e9cff$export$65b49a6767630708,
    faSearchLocation: $321daf9b005e9cff$export$c33aba6c251a898a,
    faSearchMinus: $321daf9b005e9cff$export$efca97eef6a7a17d,
    faSearchPlus: $321daf9b005e9cff$export$378f00e6b1a8185,
    faSeedling: $321daf9b005e9cff$export$d7b60b8dbd03cfe4,
    faServer: $321daf9b005e9cff$export$1bf820d499b6202e,
    faShapes: $321daf9b005e9cff$export$b17d50542d1fc340,
    faShare: $321daf9b005e9cff$export$c08b4b0e2b0dc027,
    faShareAlt: $321daf9b005e9cff$export$f8e8bb0b3aa8c658,
    faShareAltSquare: $321daf9b005e9cff$export$3799c2d8fd7e493b,
    faShareSquare: $321daf9b005e9cff$export$ae9e1434571f373c,
    faShekelSign: $321daf9b005e9cff$export$3570be7b68efb8db,
    faShieldAlt: $321daf9b005e9cff$export$d6508d18a824f291,
    faShieldVirus: $321daf9b005e9cff$export$bea811bbf570f05a,
    faShip: $321daf9b005e9cff$export$6c645741140616af,
    faShippingFast: $321daf9b005e9cff$export$5e419f47aaeb3c05,
    faShoePrints: $321daf9b005e9cff$export$cdbdd2118099ae07,
    faShoppingBag: $321daf9b005e9cff$export$5745f8adbc11eb01,
    faShoppingBasket: $321daf9b005e9cff$export$ca6d443595a6578f,
    faShoppingCart: $321daf9b005e9cff$export$51da406e5aa1388c,
    faShower: $321daf9b005e9cff$export$f7f7c15f18cc19a1,
    faShuttleVan: $321daf9b005e9cff$export$9d63d851db698c09,
    faSign: $321daf9b005e9cff$export$d21d0d6c8e9e8bf9,
    faSignInAlt: $321daf9b005e9cff$export$e6709746115bd2ea,
    faSignLanguage: $321daf9b005e9cff$export$20993813350f9671,
    faSignOutAlt: $321daf9b005e9cff$export$c844d6923b7096c2,
    faSignal: $321daf9b005e9cff$export$79046b073b6c584d,
    faSignature: $321daf9b005e9cff$export$afa7b53ac8ebcb5d,
    faSimCard: $321daf9b005e9cff$export$3bee83bf278fddbe,
    faSitemap: $321daf9b005e9cff$export$b2ce5e79d0eccaf8,
    faSkating: $321daf9b005e9cff$export$21bd1d54bd4f2c5a,
    faSkiing: $321daf9b005e9cff$export$eae1acab6fb96708,
    faSkiingNordic: $321daf9b005e9cff$export$6ea48260d7d09b1b,
    faSkull: $321daf9b005e9cff$export$138b45e2afb1dfa4,
    faSkullCrossbones: $321daf9b005e9cff$export$8717352b90217272,
    faSlash: $321daf9b005e9cff$export$f54d004dd5f1cb5e,
    faSleigh: $321daf9b005e9cff$export$26a8fd1143d2d6c0,
    faSlidersH: $321daf9b005e9cff$export$94d4dcb523f95563,
    faSmile: $321daf9b005e9cff$export$c632b2334f0913bc,
    faSmileBeam: $321daf9b005e9cff$export$54ada6dc9690e0ca,
    faSmileWink: $321daf9b005e9cff$export$f5dbb37f6801ee3f,
    faSmog: $321daf9b005e9cff$export$aa11b8edb09fed14,
    faSmoking: $321daf9b005e9cff$export$c4ab83701fc591a5,
    faSmokingBan: $321daf9b005e9cff$export$e50452a49dec29f,
    faSms: $321daf9b005e9cff$export$9dbcc3443daa7323,
    faSnowboarding: $321daf9b005e9cff$export$72683772d587302a,
    faSnowflake: $321daf9b005e9cff$export$bab8f3647c394f48,
    faSnowman: $321daf9b005e9cff$export$b23df6bafb174693,
    faSnowplow: $321daf9b005e9cff$export$695fae58f55c3a87,
    faSoap: $321daf9b005e9cff$export$64f1c53b21f310ac,
    faSocks: $321daf9b005e9cff$export$8d36a54dbf1e6bce,
    faSolarPanel: $321daf9b005e9cff$export$b9c649c5e37017f3,
    faSort: $321daf9b005e9cff$export$4941c5969d5399b,
    faSortAlphaDown: $321daf9b005e9cff$export$7658045270aafde3,
    faSortAlphaDownAlt: $321daf9b005e9cff$export$e12d23d82d5c8a89,
    faSortAlphaUp: $321daf9b005e9cff$export$3c4115b156be730d,
    faSortAlphaUpAlt: $321daf9b005e9cff$export$95ef20828693fb0f,
    faSortAmountDown: $321daf9b005e9cff$export$4b2a02d50e417b5f,
    faSortAmountDownAlt: $321daf9b005e9cff$export$e7d80d8c226cb77,
    faSortAmountUp: $321daf9b005e9cff$export$28ef3e933e4b5364,
    faSortAmountUpAlt: $321daf9b005e9cff$export$6e87844b0f151b6a,
    faSortDown: $321daf9b005e9cff$export$58e2577a373e7d4,
    faSortNumericDown: $321daf9b005e9cff$export$835db7eb35b3c29b,
    faSortNumericDownAlt: $321daf9b005e9cff$export$857385fda7a5a98e,
    faSortNumericUp: $321daf9b005e9cff$export$d213a3ba3cabed48,
    faSortNumericUpAlt: $321daf9b005e9cff$export$d41859f1bbb9e086,
    faSortUp: $321daf9b005e9cff$export$f9dd5b1410e95035,
    faSpa: $321daf9b005e9cff$export$f9a38ef7b046ab51,
    faSpaceShuttle: $321daf9b005e9cff$export$4d1c12ba2b4ca565,
    faSpellCheck: $321daf9b005e9cff$export$761e747b06ed2e1f,
    faSpider: $321daf9b005e9cff$export$6daa96b1986e2ef0,
    faSpinner: $321daf9b005e9cff$export$1025ad641edb49c2,
    faSplotch: $321daf9b005e9cff$export$d6f21e17ea797702,
    faSprayCan: $321daf9b005e9cff$export$4952c502f544cf85,
    faSquare: $321daf9b005e9cff$export$90b4406457aae8cc,
    faSquareFull: $321daf9b005e9cff$export$7ec6541fee081990,
    faSquareRootAlt: $321daf9b005e9cff$export$28e4b96627e00057,
    faStamp: $321daf9b005e9cff$export$722e92d2d93ffc68,
    faStar: $321daf9b005e9cff$export$a3b0eb2cd7942125,
    faStarAndCrescent: $321daf9b005e9cff$export$cafa834c96ebcb1a,
    faStarHalf: $321daf9b005e9cff$export$228008b5e11032fa,
    faStarHalfAlt: $321daf9b005e9cff$export$c13575f42532efb3,
    faStarOfDavid: $321daf9b005e9cff$export$f823fee3712b2601,
    faStarOfLife: $321daf9b005e9cff$export$aa3c4c1c5a47bf98,
    faStepBackward: $321daf9b005e9cff$export$2884e379aed297d4,
    faStepForward: $321daf9b005e9cff$export$b303329afce5de18,
    faStethoscope: $321daf9b005e9cff$export$acb2d72d28cd92d9,
    faStickyNote: $321daf9b005e9cff$export$80889adc5d98bf4a,
    faStop: $321daf9b005e9cff$export$51577929c676143b,
    faStopCircle: $321daf9b005e9cff$export$47af2aad60ab3e7c,
    faStopwatch: $321daf9b005e9cff$export$b85a7300fc7960b6,
    faStopwatch20: $321daf9b005e9cff$export$df6244b0501f2112,
    faStore: $321daf9b005e9cff$export$de59c2657a8ace67,
    faStoreAlt: $321daf9b005e9cff$export$1f1871dab9cec9d8,
    faStoreAltSlash: $321daf9b005e9cff$export$b932a586f6ff48b4,
    faStoreSlash: $321daf9b005e9cff$export$4ab2f33219630bad,
    faStream: $321daf9b005e9cff$export$ed81ab40fc4e904,
    faStreetView: $321daf9b005e9cff$export$6aab6c3359c2554c,
    faStrikethrough: $321daf9b005e9cff$export$eff51ea25b4de135,
    faStroopwafel: $321daf9b005e9cff$export$195780ddabd8e0c6,
    faSubscript: $321daf9b005e9cff$export$34c1e678c32ed646,
    faSubway: $321daf9b005e9cff$export$4cabc8a12d4e2f9,
    faSuitcase: $321daf9b005e9cff$export$60710f3921019268,
    faSuitcaseRolling: $321daf9b005e9cff$export$957e62a9b80ff4e3,
    faSun: $321daf9b005e9cff$export$2fa35dcbc038dbe9,
    faSuperscript: $321daf9b005e9cff$export$4fa56a54e822dd25,
    faSurprise: $321daf9b005e9cff$export$46647c72213f53ba,
    faSwatchbook: $321daf9b005e9cff$export$c74a20c81b957b6a,
    faSwimmer: $321daf9b005e9cff$export$67daf2e2f88c1365,
    faSwimmingPool: $321daf9b005e9cff$export$4dee691631c67d5c,
    faSynagogue: $321daf9b005e9cff$export$20d991385719b5b4,
    faSync: $321daf9b005e9cff$export$ff87319002e3dae9,
    faSyncAlt: $321daf9b005e9cff$export$2ff2056be8c281e4,
    faSyringe: $321daf9b005e9cff$export$1aa9423ec6b1d609,
    faTable: $321daf9b005e9cff$export$36583f5d3d5a971f,
    faTableTennis: $321daf9b005e9cff$export$f378fbb4e0ef7edf,
    faTablet: $321daf9b005e9cff$export$1c92b67c45a4b4fc,
    faTabletAlt: $321daf9b005e9cff$export$db0cac088255eacc,
    faTablets: $321daf9b005e9cff$export$bed2b0ed4ae45e0d,
    faTachometerAlt: $321daf9b005e9cff$export$38dd17b9f064c10f,
    faTag: $321daf9b005e9cff$export$cb61f447f29887e,
    faTags: $321daf9b005e9cff$export$d55778e3ab6c933f,
    faTape: $321daf9b005e9cff$export$b88ed5e1e0eac4c6,
    faTasks: $321daf9b005e9cff$export$2f6d5b2fec286d63,
    faTaxi: $321daf9b005e9cff$export$9958afcdfece1b58,
    faTeeth: $321daf9b005e9cff$export$b4619aeaf0b9d18e,
    faTeethOpen: $321daf9b005e9cff$export$c88ac21fe7c88ae6,
    faTemperatureHigh: $321daf9b005e9cff$export$15d012277c3ecf9a,
    faTemperatureLow: $321daf9b005e9cff$export$9e9af12b90a1abd2,
    faTenge: $321daf9b005e9cff$export$af6ebee83047b793,
    faTerminal: $321daf9b005e9cff$export$5e63e8b85b5f119c,
    faTextHeight: $321daf9b005e9cff$export$3313bce3924ea7da,
    faTextWidth: $321daf9b005e9cff$export$d8724cf433389700,
    faTh: $321daf9b005e9cff$export$4d383c83efc0c819,
    faThLarge: $321daf9b005e9cff$export$69782f333e90cdc6,
    faThList: $321daf9b005e9cff$export$daf2614a457122c0,
    faTheaterMasks: $321daf9b005e9cff$export$3dbedc487b0159ac,
    faThermometer: $321daf9b005e9cff$export$f576739e9b18ea4f,
    faThermometerEmpty: $321daf9b005e9cff$export$81a2f8298cf523f9,
    faThermometerFull: $321daf9b005e9cff$export$74e07083cef79a6f,
    faThermometerHalf: $321daf9b005e9cff$export$2090f040324b4449,
    faThermometerQuarter: $321daf9b005e9cff$export$ed05754fcbec6e46,
    faThermometerThreeQuarters: $321daf9b005e9cff$export$6c632d1dc30d4a77,
    faThumbsDown: $321daf9b005e9cff$export$aba24ca305bbe8c1,
    faThumbsUp: $321daf9b005e9cff$export$47e4e0d519d33497,
    faThumbtack: $321daf9b005e9cff$export$b6314cdc01bb5c43,
    faTicketAlt: $321daf9b005e9cff$export$75e38ba471fd89c4,
    faTimes: $321daf9b005e9cff$export$174bd7f477b115b4,
    faTimesCircle: $321daf9b005e9cff$export$ab0ec50720a747eb,
    faTint: $321daf9b005e9cff$export$60dd975bd5938c15,
    faTintSlash: $321daf9b005e9cff$export$5d6f0943039b898f,
    faTired: $321daf9b005e9cff$export$3d016d62cda18371,
    faToggleOff: $321daf9b005e9cff$export$d20aaceb882ca545,
    faToggleOn: $321daf9b005e9cff$export$5cffc34afa81e517,
    faToilet: $321daf9b005e9cff$export$505476859b9691c0,
    faToiletPaper: $321daf9b005e9cff$export$c8cc083ccc72b17,
    faToiletPaperSlash: $321daf9b005e9cff$export$7a494edbf9b65575,
    faToolbox: $321daf9b005e9cff$export$b34d64c205c732a9,
    faTools: $321daf9b005e9cff$export$646e4e7a8c6172aa,
    faTooth: $321daf9b005e9cff$export$3a1fa2d16f90d635,
    faTorah: $321daf9b005e9cff$export$54d07baabd8c2acb,
    faToriiGate: $321daf9b005e9cff$export$75825a4c2b3375e,
    faTractor: $321daf9b005e9cff$export$e87e41787bbedc98,
    faTrademark: $321daf9b005e9cff$export$9c9b2fbddd59047d,
    faTrafficLight: $321daf9b005e9cff$export$bf0b19daceaec9c2,
    faTrailer: $321daf9b005e9cff$export$3a48b9820e92f5ab,
    faTrain: $321daf9b005e9cff$export$17cde74bf6f1ee89,
    faTram: $321daf9b005e9cff$export$a7a36674c079f293,
    faTransgender: $321daf9b005e9cff$export$7e3f1701aa95ef01,
    faTransgenderAlt: $321daf9b005e9cff$export$9c36cf9334c052f,
    faTrash: $321daf9b005e9cff$export$ed8c149a0ea54bb4,
    faTrashAlt: $321daf9b005e9cff$export$88df7ff7eb32f9dc,
    faTrashRestore: $321daf9b005e9cff$export$d32f45a64ed40e8d,
    faTrashRestoreAlt: $321daf9b005e9cff$export$d075b19b21cb9856,
    faTree: $321daf9b005e9cff$export$1744430f718caf6b,
    faTrophy: $321daf9b005e9cff$export$29c432d69ccf85a5,
    faTruck: $321daf9b005e9cff$export$d7895f386f8bd8b8,
    faTruckLoading: $321daf9b005e9cff$export$f00c152db7d44638,
    faTruckMonster: $321daf9b005e9cff$export$24b8a0147653649a,
    faTruckMoving: $321daf9b005e9cff$export$a06617a1a4ccea67,
    faTruckPickup: $321daf9b005e9cff$export$f846b848b3ba3064,
    faTshirt: $321daf9b005e9cff$export$36edce3ba87c2b17,
    faTty: $321daf9b005e9cff$export$7c85aba0f9624b29,
    faTv: $321daf9b005e9cff$export$e0cfed4ba2fe562c,
    faUmbrella: $321daf9b005e9cff$export$9ff64ffae70e08c0,
    faUmbrellaBeach: $321daf9b005e9cff$export$20932e4d438e4e4c,
    faUnderline: $321daf9b005e9cff$export$22346afd6a3cddf8,
    faUndo: $321daf9b005e9cff$export$a5e5ba60b1dfe2b2,
    faUndoAlt: $321daf9b005e9cff$export$c8197b992c46c4a6,
    faUniversalAccess: $321daf9b005e9cff$export$e119aada7f690d05,
    faUniversity: $321daf9b005e9cff$export$f2e1460ebe1a8cb0,
    faUnlink: $321daf9b005e9cff$export$2f546f7d8ba01e18,
    faUnlock: $321daf9b005e9cff$export$db1382cd406cc506,
    faUnlockAlt: $321daf9b005e9cff$export$b19f508797f3d9c3,
    faUpload: $321daf9b005e9cff$export$a9578350255b2b79,
    faUser: $321daf9b005e9cff$export$f5699fa0844e0188,
    faUserAlt: $321daf9b005e9cff$export$ae9b19c2ac726cfc,
    faUserAltSlash: $321daf9b005e9cff$export$46185fab4772ada6,
    faUserAstronaut: $321daf9b005e9cff$export$94363e983c225a04,
    faUserCheck: $321daf9b005e9cff$export$76de2a120043c9f8,
    faUserCircle: $321daf9b005e9cff$export$be7d974e9e0dba1a,
    faUserClock: $321daf9b005e9cff$export$b00596a09aa07311,
    faUserCog: $321daf9b005e9cff$export$474108c2b86e730e,
    faUserEdit: $321daf9b005e9cff$export$a68a6960fc8eef82,
    faUserFriends: $321daf9b005e9cff$export$46073bec205635d9,
    faUserGraduate: $321daf9b005e9cff$export$10f5839059d22f7e,
    faUserInjured: $321daf9b005e9cff$export$c950c1ba7f227d5b,
    faUserLock: $321daf9b005e9cff$export$d9b89b5872b67a4f,
    faUserMd: $321daf9b005e9cff$export$ab0d33a2c03f1794,
    faUserMinus: $321daf9b005e9cff$export$d6e17c0df8ed1bf7,
    faUserNinja: $321daf9b005e9cff$export$a9174995732e03c5,
    faUserNurse: $321daf9b005e9cff$export$ab9af5aa013d2162,
    faUserPlus: $321daf9b005e9cff$export$4c17261776a709f2,
    faUserSecret: $321daf9b005e9cff$export$597826232327559b,
    faUserShield: $321daf9b005e9cff$export$d1886bc596424e6c,
    faUserSlash: $321daf9b005e9cff$export$3924ab4d3ef9b5ef,
    faUserTag: $321daf9b005e9cff$export$9eec597148166b36,
    faUserTie: $321daf9b005e9cff$export$48c51dda34e9f04c,
    faUserTimes: $321daf9b005e9cff$export$45b996d071667753,
    faUsers: $321daf9b005e9cff$export$e5a8f011aef571ac,
    faUsersCog: $321daf9b005e9cff$export$5e0b06753fc69b81,
    faUtensilSpoon: $321daf9b005e9cff$export$fb7af5d245fb9053,
    faUtensils: $321daf9b005e9cff$export$750d52edc1dafc7,
    faVectorSquare: $321daf9b005e9cff$export$567d5631a7b0599f,
    faVenus: $321daf9b005e9cff$export$f89d028573ffc0a6,
    faVenusDouble: $321daf9b005e9cff$export$6a6f9cba7a1e5fe4,
    faVenusMars: $321daf9b005e9cff$export$63f2d9e5f4689aa8,
    faVial: $321daf9b005e9cff$export$aa014b06d2d70598,
    faVials: $321daf9b005e9cff$export$507e8edd7676b2e9,
    faVideo: $321daf9b005e9cff$export$5c6bd8729527871b,
    faVideoSlash: $321daf9b005e9cff$export$a714fc79f58cc9ef,
    faVihara: $321daf9b005e9cff$export$ee4b92e89fe0dfaf,
    faVirus: $321daf9b005e9cff$export$37c67e0b3dc6bd1b,
    faVirusSlash: $321daf9b005e9cff$export$c4ff5306c5470939,
    faViruses: $321daf9b005e9cff$export$ee194b18f5c6f6b6,
    faVoicemail: $321daf9b005e9cff$export$4f1ce88b2b4cd5cd,
    faVolleyballBall: $321daf9b005e9cff$export$a15e6fc8e68a76b0,
    faVolumeDown: $321daf9b005e9cff$export$69fdf57632b6cc29,
    faVolumeMute: $321daf9b005e9cff$export$aa8decd057dfd29b,
    faVolumeOff: $321daf9b005e9cff$export$d94ba52e980ea0f1,
    faVolumeUp: $321daf9b005e9cff$export$5940d3e475d90cc4,
    faVoteYea: $321daf9b005e9cff$export$e87bb3db1608b850,
    faVrCardboard: $321daf9b005e9cff$export$248171cb6dad4307,
    faWalking: $321daf9b005e9cff$export$4886811b7174ec35,
    faWallet: $321daf9b005e9cff$export$79204db8777905c8,
    faWarehouse: $321daf9b005e9cff$export$e3a174a50618c208,
    faWater: $321daf9b005e9cff$export$efaeddad0a6e901b,
    faWaveSquare: $321daf9b005e9cff$export$c38cf504b3bc58a2,
    faWeight: $321daf9b005e9cff$export$cf3bafa68a60bae4,
    faWeightHanging: $321daf9b005e9cff$export$43d1fa6671908715,
    faWheelchair: $321daf9b005e9cff$export$76a9413fbe130a53,
    faWifi: $321daf9b005e9cff$export$1642419fe3db2857,
    faWind: $321daf9b005e9cff$export$cc58cb0f2257a6a9,
    faWindowClose: $321daf9b005e9cff$export$18b7775f78a3e16,
    faWindowMaximize: $321daf9b005e9cff$export$703cd98be31ec905,
    faWindowMinimize: $321daf9b005e9cff$export$26a3f9d2784b90d8,
    faWindowRestore: $321daf9b005e9cff$export$eccfff9bfd585652,
    faWineBottle: $321daf9b005e9cff$export$770be8b3d5776043,
    faWineGlass: $321daf9b005e9cff$export$e06d6607d3577d6e,
    faWineGlassAlt: $321daf9b005e9cff$export$b8ff3fe2b78aef2f,
    faWonSign: $321daf9b005e9cff$export$51790ddd26e431bc,
    faWrench: $321daf9b005e9cff$export$3c6c0c8185296ac5,
    faXRay: $321daf9b005e9cff$export$8cf137aceaaf4de0,
    faYenSign: $321daf9b005e9cff$export$30f1437f5a4e991d,
    faYinYang: $321daf9b005e9cff$export$6ec1acbf3f610b8f
};


function $49b88f79c36d8b15$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $49b88f79c36d8b15$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $49b88f79c36d8b15$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $49b88f79c36d8b15$var$_typeof(obj);
}
function $49b88f79c36d8b15$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $49b88f79c36d8b15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $49b88f79c36d8b15$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $49b88f79c36d8b15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $49b88f79c36d8b15$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $49b88f79c36d8b15$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $49b88f79c36d8b15$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $49b88f79c36d8b15$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $49b88f79c36d8b15$var$_slicedToArray(arr, i) {
    return $49b88f79c36d8b15$var$_arrayWithHoles(arr) || $49b88f79c36d8b15$var$_iterableToArrayLimit(arr, i) || $49b88f79c36d8b15$var$_nonIterableRest();
}
function $49b88f79c36d8b15$var$_toConsumableArray(arr) {
    return $49b88f79c36d8b15$var$_arrayWithoutHoles(arr) || $49b88f79c36d8b15$var$_iterableToArray(arr) || $49b88f79c36d8b15$var$_nonIterableSpread();
}
function $49b88f79c36d8b15$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $49b88f79c36d8b15$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $49b88f79c36d8b15$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $49b88f79c36d8b15$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $49b88f79c36d8b15$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $49b88f79c36d8b15$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var $49b88f79c36d8b15$var$noop = function noop() {};
var $49b88f79c36d8b15$var$_WINDOW = {};
var $49b88f79c36d8b15$var$_DOCUMENT = {};
var $49b88f79c36d8b15$var$_MUTATION_OBSERVER = null;
var $49b88f79c36d8b15$var$_PERFORMANCE = {
    mark: $49b88f79c36d8b15$var$noop,
    measure: $49b88f79c36d8b15$var$noop
};
try {
    if (typeof window !== "undefined") $49b88f79c36d8b15$var$_WINDOW = window;
    if (typeof document !== "undefined") $49b88f79c36d8b15$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $49b88f79c36d8b15$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $49b88f79c36d8b15$var$_PERFORMANCE = performance;
} catch (e) {}
var $49b88f79c36d8b15$var$_ref = $49b88f79c36d8b15$var$_WINDOW.navigator || {}, $49b88f79c36d8b15$var$_ref$userAgent = $49b88f79c36d8b15$var$_ref.userAgent, $49b88f79c36d8b15$var$userAgent = $49b88f79c36d8b15$var$_ref$userAgent === void 0 ? "" : $49b88f79c36d8b15$var$_ref$userAgent;
var $49b88f79c36d8b15$var$WINDOW = $49b88f79c36d8b15$var$_WINDOW;
var $49b88f79c36d8b15$var$DOCUMENT = $49b88f79c36d8b15$var$_DOCUMENT;
var $49b88f79c36d8b15$var$MUTATION_OBSERVER = $49b88f79c36d8b15$var$_MUTATION_OBSERVER;
var $49b88f79c36d8b15$var$PERFORMANCE = $49b88f79c36d8b15$var$_PERFORMANCE;
var $49b88f79c36d8b15$var$IS_BROWSER = !!$49b88f79c36d8b15$var$WINDOW.document;
var $49b88f79c36d8b15$var$IS_DOM = !!$49b88f79c36d8b15$var$DOCUMENT.documentElement && !!$49b88f79c36d8b15$var$DOCUMENT.head && typeof $49b88f79c36d8b15$var$DOCUMENT.addEventListener === "function" && typeof $49b88f79c36d8b15$var$DOCUMENT.createElement === "function";
var $49b88f79c36d8b15$var$IS_IE = ~$49b88f79c36d8b15$var$userAgent.indexOf("MSIE") || ~$49b88f79c36d8b15$var$userAgent.indexOf("Trident/");
var $49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $49b88f79c36d8b15$var$UNITS_IN_GRID = 16;
var $49b88f79c36d8b15$var$DEFAULT_FAMILY_PREFIX = "fa";
var $49b88f79c36d8b15$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $49b88f79c36d8b15$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $49b88f79c36d8b15$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $49b88f79c36d8b15$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $49b88f79c36d8b15$var$DATA_PREFIX = "data-prefix";
var $49b88f79c36d8b15$var$DATA_ICON = "data-icon";
var $49b88f79c36d8b15$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $49b88f79c36d8b15$var$MUTATION_APPROACH_ASYNC = "async";
var $49b88f79c36d8b15$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $49b88f79c36d8b15$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $49b88f79c36d8b15$var$PREFIX_TO_STYLE = {
    "fas": "solid",
    "far": "regular",
    "fal": "light",
    "fad": "duotone",
    "fab": "brands",
    "fa": "solid"
};
var $49b88f79c36d8b15$var$STYLE_TO_PREFIX = {
    "solid": "fas",
    "regular": "far",
    "light": "fal",
    "duotone": "fad",
    "brands": "fab"
};
var $49b88f79c36d8b15$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $49b88f79c36d8b15$var$FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Duotone|Brands|Free|Pro)/;
var $49b88f79c36d8b15$var$FONT_WEIGHT_TO_PREFIX = {
    "900": "fas",
    "400": "far",
    "normal": "far",
    "300": "fal"
};
var $49b88f79c36d8b15$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $49b88f79c36d8b15$var$oneToTwenty = $49b88f79c36d8b15$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $49b88f79c36d8b15$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $49b88f79c36d8b15$var$DUOTONE_CLASSES = {
    GROUP: "group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $49b88f79c36d8b15$var$RESERVED_CLASSES = [
    "xs",
    "sm",
    "lg",
    "fw",
    "ul",
    "li",
    "border",
    "pull-left",
    "pull-right",
    "spin",
    "pulse",
    "rotate-90",
    "rotate-180",
    "rotate-270",
    "flip-horizontal",
    "flip-vertical",
    "flip-both",
    "stack",
    "stack-1x",
    "stack-2x",
    "inverse",
    "layers",
    "layers-text",
    "layers-counter",
    $49b88f79c36d8b15$var$DUOTONE_CLASSES.GROUP,
    $49b88f79c36d8b15$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $49b88f79c36d8b15$var$DUOTONE_CLASSES.PRIMARY,
    $49b88f79c36d8b15$var$DUOTONE_CLASSES.SECONDARY
].concat($49b88f79c36d8b15$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($49b88f79c36d8b15$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $49b88f79c36d8b15$var$initial = $49b88f79c36d8b15$var$WINDOW.FontAwesomeConfig || {};
function $49b88f79c36d8b15$var$getAttrConfig(attr) {
    var element = $49b88f79c36d8b15$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $49b88f79c36d8b15$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($49b88f79c36d8b15$var$DOCUMENT && typeof $49b88f79c36d8b15$var$DOCUMENT.querySelector === "function") {
    var $49b88f79c36d8b15$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $49b88f79c36d8b15$var$attrs.forEach(function(_ref) {
        var _ref2 = $49b88f79c36d8b15$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $49b88f79c36d8b15$var$coerce($49b88f79c36d8b15$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $49b88f79c36d8b15$var$initial[key] = val;
    });
}
var $49b88f79c36d8b15$var$_default = {
    familyPrefix: $49b88f79c36d8b15$var$DEFAULT_FAMILY_PREFIX,
    replacementClass: $49b88f79c36d8b15$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
var $49b88f79c36d8b15$var$_config = $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$_default, $49b88f79c36d8b15$var$initial);
if (!$49b88f79c36d8b15$var$_config.autoReplaceSvg) $49b88f79c36d8b15$var$_config.observeMutations = false;
var $49b88f79c36d8b15$export$e506a1d27d1eaa20 = $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$_config);
$49b88f79c36d8b15$var$WINDOW.FontAwesomeConfig = $49b88f79c36d8b15$export$e506a1d27d1eaa20;
var $49b88f79c36d8b15$var$w = $49b88f79c36d8b15$var$WINDOW || {};
if (!$49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER]) $49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER] = {};
if (!$49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER].styles) $49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER].hooks) $49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER].shims) $49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER].shims = [];
var $49b88f79c36d8b15$var$namespace = $49b88f79c36d8b15$var$w[$49b88f79c36d8b15$var$NAMESPACE_IDENTIFIER];
var $49b88f79c36d8b15$var$functions = [];
var $49b88f79c36d8b15$var$listener = function listener() {
    $49b88f79c36d8b15$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $49b88f79c36d8b15$var$loaded = 1;
    $49b88f79c36d8b15$var$functions.map(function(fn) {
        return fn();
    });
};
var $49b88f79c36d8b15$var$loaded = false;
if ($49b88f79c36d8b15$var$IS_DOM) {
    $49b88f79c36d8b15$var$loaded = ($49b88f79c36d8b15$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($49b88f79c36d8b15$var$DOCUMENT.readyState);
    if (!$49b88f79c36d8b15$var$loaded) $49b88f79c36d8b15$var$DOCUMENT.addEventListener("DOMContentLoaded", $49b88f79c36d8b15$var$listener);
}
function $49b88f79c36d8b15$var$domready(fn) {
    if (!$49b88f79c36d8b15$var$IS_DOM) return;
    $49b88f79c36d8b15$var$loaded ? setTimeout(fn, 0) : $49b88f79c36d8b15$var$functions.push(fn);
}
var $49b88f79c36d8b15$var$PENDING = "pending";
var $49b88f79c36d8b15$var$SETTLED = "settled";
var $49b88f79c36d8b15$var$FULFILLED = "fulfilled";
var $49b88f79c36d8b15$var$REJECTED = "rejected";
var $49b88f79c36d8b15$var$NOOP = function NOOP() {};
var $49b88f79c36d8b15$var$isNode = typeof $parcel$global !== "undefined" && typeof $parcel$global.process !== "undefined" && typeof $parcel$global.process.emit === "function";
var $49b88f79c36d8b15$var$asyncSetTimer = typeof setImmediate === "undefined" ? setTimeout : setImmediate;
var $49b88f79c36d8b15$var$asyncQueue = [];
var $49b88f79c36d8b15$var$asyncTimer;
function $49b88f79c36d8b15$var$asyncFlush() {
    // run promise callbacks
    for(var i = 0; i < $49b88f79c36d8b15$var$asyncQueue.length; i++)$49b88f79c36d8b15$var$asyncQueue[i][0]($49b88f79c36d8b15$var$asyncQueue[i][1]);
     // reset async asyncQueue
    $49b88f79c36d8b15$var$asyncQueue = [];
    $49b88f79c36d8b15$var$asyncTimer = false;
}
function $49b88f79c36d8b15$var$asyncCall(callback, arg) {
    $49b88f79c36d8b15$var$asyncQueue.push([
        callback,
        arg
    ]);
    if (!$49b88f79c36d8b15$var$asyncTimer) {
        $49b88f79c36d8b15$var$asyncTimer = true;
        $49b88f79c36d8b15$var$asyncSetTimer($49b88f79c36d8b15$var$asyncFlush, 0);
    }
}
function $49b88f79c36d8b15$var$invokeResolver(resolver, promise) {
    function resolvePromise(value) {
        $49b88f79c36d8b15$var$resolve(promise, value);
    }
    function rejectPromise(reason) {
        $49b88f79c36d8b15$var$reject(promise, reason);
    }
    try {
        resolver(resolvePromise, rejectPromise);
    } catch (e) {
        rejectPromise(e);
    }
}
function $49b88f79c36d8b15$var$invokeCallback(subscriber) {
    var owner = subscriber.owner;
    var settled = owner._state;
    var value = owner._data;
    var callback = subscriber[settled];
    var promise = subscriber.then;
    if (typeof callback === "function") {
        settled = $49b88f79c36d8b15$var$FULFILLED;
        try {
            value = callback(value);
        } catch (e) {
            $49b88f79c36d8b15$var$reject(promise, e);
        }
    }
    if (!$49b88f79c36d8b15$var$handleThenable(promise, value)) {
        if (settled === $49b88f79c36d8b15$var$FULFILLED) $49b88f79c36d8b15$var$resolve(promise, value);
        if (settled === $49b88f79c36d8b15$var$REJECTED) $49b88f79c36d8b15$var$reject(promise, value);
    }
}
function $49b88f79c36d8b15$var$handleThenable(promise, value) {
    var resolved;
    try {
        if (promise === value) throw new TypeError("A promises callback cannot return that same promise.");
        if (value && (typeof value === "function" || $49b88f79c36d8b15$var$_typeof(value) === "object")) {
            // then should be retrieved only once
            var then = value.then;
            if (typeof then === "function") {
                then.call(value, function(val) {
                    if (!resolved) {
                        resolved = true;
                        if (value === val) $49b88f79c36d8b15$var$fulfill(promise, val);
                        else $49b88f79c36d8b15$var$resolve(promise, val);
                    }
                }, function(reason) {
                    if (!resolved) {
                        resolved = true;
                        $49b88f79c36d8b15$var$reject(promise, reason);
                    }
                });
                return true;
            }
        }
    } catch (e) {
        if (!resolved) $49b88f79c36d8b15$var$reject(promise, e);
        return true;
    }
    return false;
}
function $49b88f79c36d8b15$var$resolve(promise, value) {
    if (promise === value || !$49b88f79c36d8b15$var$handleThenable(promise, value)) $49b88f79c36d8b15$var$fulfill(promise, value);
}
function $49b88f79c36d8b15$var$fulfill(promise, value) {
    if (promise._state === $49b88f79c36d8b15$var$PENDING) {
        promise._state = $49b88f79c36d8b15$var$SETTLED;
        promise._data = value;
        $49b88f79c36d8b15$var$asyncCall($49b88f79c36d8b15$var$publishFulfillment, promise);
    }
}
function $49b88f79c36d8b15$var$reject(promise, reason) {
    if (promise._state === $49b88f79c36d8b15$var$PENDING) {
        promise._state = $49b88f79c36d8b15$var$SETTLED;
        promise._data = reason;
        $49b88f79c36d8b15$var$asyncCall($49b88f79c36d8b15$var$publishRejection, promise);
    }
}
function $49b88f79c36d8b15$var$publish(promise) {
    promise._then = promise._then.forEach($49b88f79c36d8b15$var$invokeCallback);
}
function $49b88f79c36d8b15$var$publishFulfillment(promise) {
    promise._state = $49b88f79c36d8b15$var$FULFILLED;
    $49b88f79c36d8b15$var$publish(promise);
}
function $49b88f79c36d8b15$var$publishRejection(promise) {
    promise._state = $49b88f79c36d8b15$var$REJECTED;
    $49b88f79c36d8b15$var$publish(promise);
    if (!promise._handled && $49b88f79c36d8b15$var$isNode) $parcel$global.process.emit("unhandledRejection", promise._data, promise);
}
function $49b88f79c36d8b15$var$notifyRejectionHandled(promise) {
    $parcel$global.process.emit("rejectionHandled", promise);
}
/**
 * @class
 */ function $49b88f79c36d8b15$var$P(resolver) {
    if (typeof resolver !== "function") throw new TypeError("Promise resolver " + resolver + " is not a function");
    if (this instanceof $49b88f79c36d8b15$var$P === false) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    this._then = [];
    $49b88f79c36d8b15$var$invokeResolver(resolver, this);
}
$49b88f79c36d8b15$var$P.prototype = {
    constructor: $49b88f79c36d8b15$var$P,
    _state: $49b88f79c36d8b15$var$PENDING,
    _then: null,
    _data: undefined,
    _handled: false,
    then: function then(onFulfillment, onRejection) {
        var subscriber = {
            owner: this,
            then: new this.constructor($49b88f79c36d8b15$var$NOOP),
            fulfilled: onFulfillment,
            rejected: onRejection
        };
        if ((onRejection || onFulfillment) && !this._handled) {
            this._handled = true;
            if (this._state === $49b88f79c36d8b15$var$REJECTED && $49b88f79c36d8b15$var$isNode) $49b88f79c36d8b15$var$asyncCall($49b88f79c36d8b15$var$notifyRejectionHandled, this);
        }
        if (this._state === $49b88f79c36d8b15$var$FULFILLED || this._state === $49b88f79c36d8b15$var$REJECTED) // already resolved, call callback async
        $49b88f79c36d8b15$var$asyncCall($49b88f79c36d8b15$var$invokeCallback, subscriber);
        else // subscribe
        this._then.push(subscriber);
        return subscriber.then;
    },
    catch: function _catch(onRejection) {
        return this.then(null, onRejection);
    }
};
$49b88f79c36d8b15$var$P.all = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.all().");
    return new $49b88f79c36d8b15$var$P(function(resolve, reject) {
        var results = [];
        var remaining = 0;
        function resolver(index) {
            remaining++;
            return function(value) {
                results[index] = value;
                if (!--remaining) resolve(results);
            };
        }
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === "function") promise.then(resolver(i), reject);
            else results[i] = promise;
        }
        if (!remaining) resolve(results);
    });
};
$49b88f79c36d8b15$var$P.race = function(promises) {
    if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.race().");
    return new $49b88f79c36d8b15$var$P(function(resolve, reject) {
        for(var i = 0, promise; i < promises.length; i++){
            promise = promises[i];
            if (promise && typeof promise.then === "function") promise.then(resolve, reject);
            else resolve(promise);
        }
    });
};
$49b88f79c36d8b15$var$P.resolve = function(value) {
    if (value && $49b88f79c36d8b15$var$_typeof(value) === "object" && value.constructor === $49b88f79c36d8b15$var$P) return value;
    return new $49b88f79c36d8b15$var$P(function(resolve) {
        resolve(value);
    });
};
$49b88f79c36d8b15$var$P.reject = function(reason) {
    return new $49b88f79c36d8b15$var$P(function(resolve, reject) {
        reject(reason);
    });
};
var $49b88f79c36d8b15$var$picked = typeof Promise === "function" ? Promise : $49b88f79c36d8b15$var$P;
var $49b88f79c36d8b15$var$d = $49b88f79c36d8b15$var$UNITS_IN_GRID;
var $49b88f79c36d8b15$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $49b88f79c36d8b15$var$isReserved(name) {
    return ~$49b88f79c36d8b15$var$RESERVED_CLASSES.indexOf(name);
}
function $49b88f79c36d8b15$var$insertCss(css) {
    if (!css || !$49b88f79c36d8b15$var$IS_DOM) return;
    var style = $49b88f79c36d8b15$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $49b88f79c36d8b15$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $49b88f79c36d8b15$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $49b88f79c36d8b15$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $49b88f79c36d8b15$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $49b88f79c36d8b15$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $49b88f79c36d8b15$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $49b88f79c36d8b15$var$classArray(node) {
    if (node.classList) return $49b88f79c36d8b15$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $49b88f79c36d8b15$var$getIconName(familyPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === familyPrefix && iconName !== "" && !$49b88f79c36d8b15$var$isReserved(iconName)) return iconName;
    else return null;
}
function $49b88f79c36d8b15$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $49b88f79c36d8b15$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($49b88f79c36d8b15$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $49b88f79c36d8b15$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
    }, "");
}
function $49b88f79c36d8b15$var$transformIsMeaningful(transform) {
    return transform.size !== $49b88f79c36d8b15$var$meaninglessTransform.size || transform.x !== $49b88f79c36d8b15$var$meaninglessTransform.x || transform.y !== $49b88f79c36d8b15$var$meaninglessTransform.y || transform.rotate !== $49b88f79c36d8b15$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $49b88f79c36d8b15$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $49b88f79c36d8b15$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $49b88f79c36d8b15$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $49b88f79c36d8b15$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $49b88f79c36d8b15$var$IS_IE) val += "translate(".concat(transform.x / $49b88f79c36d8b15$var$d - width / 2, "em, ").concat(transform.y / $49b88f79c36d8b15$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $49b88f79c36d8b15$var$d, "em), calc(-50% + ").concat(transform.y / $49b88f79c36d8b15$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $49b88f79c36d8b15$var$d, "em, ").concat(transform.y / $49b88f79c36d8b15$var$d, "em) ");
    val += "scale(".concat(transform.size / $49b88f79c36d8b15$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $49b88f79c36d8b15$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $49b88f79c36d8b15$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $49b88f79c36d8b15$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = "black";
    return abstract;
}
function $49b88f79c36d8b15$var$deGroup(abstract) {
    if (abstract.tag === "g") return abstract.children;
    else return [
        abstract
    ];
}
function $49b88f79c36d8b15$var$makeIconMasking(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
    var mainWidth = main.width, mainPath = main.icon;
    var maskWidth = mask.width, maskPath = mask.icon;
    var trans = $49b88f79c36d8b15$var$transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
    });
    var maskRect = {
        tag: "rect",
        attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$ALL_SPACE, {
            fill: "white"
        })
    };
    var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map($49b88f79c36d8b15$var$fillBlack)
    } : {};
    var maskInnerGroup = {
        tag: "g",
        attributes: $49b88f79c36d8b15$var$_objectSpread({}, trans.inner),
        children: [
            $49b88f79c36d8b15$var$fillBlack($49b88f79c36d8b15$var$_objectSpread({
                tag: mainPath.tag,
                attributes: $49b88f79c36d8b15$var$_objectSpread({}, mainPath.attributes, trans.path)
            }, maskInnerGroupChildrenMixin))
        ]
    };
    var maskOuterGroup = {
        tag: "g",
        attributes: $49b88f79c36d8b15$var$_objectSpread({}, trans.outer),
        children: [
            maskInnerGroup
        ]
    };
    var maskId = "mask-".concat(explicitMaskId || $49b88f79c36d8b15$var$nextUniqueId());
    var clipId = "clip-".concat(explicitMaskId || $49b88f79c36d8b15$var$nextUniqueId());
    var maskTag = {
        tag: "mask",
        attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$ALL_SPACE, {
            id: maskId,
            maskUnits: "userSpaceOnUse",
            maskContentUnits: "userSpaceOnUse"
        }),
        children: [
            maskRect,
            maskOuterGroup
        ]
    };
    var defs = {
        tag: "defs",
        children: [
            {
                tag: "clipPath",
                attributes: {
                    id: clipId
                },
                children: $49b88f79c36d8b15$var$deGroup(maskPath)
            },
            maskTag
        ]
    };
    children.push(defs, {
        tag: "rect",
        attributes: $49b88f79c36d8b15$var$_objectSpread({
            fill: "currentColor",
            "clip-path": "url(#".concat(clipId, ")"),
            mask: "url(#".concat(maskId, ")")
        }, $49b88f79c36d8b15$var$ALL_SPACE)
    });
    return {
        children: children,
        attributes: attributes
    };
}
function $49b88f79c36d8b15$var$makeIconStandard(_ref) {
    var children = _ref.children, attributes = _ref.attributes, main = _ref.main, transform = _ref.transform, styles = _ref.styles;
    var styleString = $49b88f79c36d8b15$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    if ($49b88f79c36d8b15$var$transformIsMeaningful(transform)) {
        var trans = $49b88f79c36d8b15$var$transformForSvg({
            transform: transform,
            containerWidth: main.width,
            iconWidth: main.width
        });
        children.push({
            tag: "g",
            attributes: $49b88f79c36d8b15$var$_objectSpread({}, trans.outer),
            children: [
                {
                    tag: "g",
                    attributes: $49b88f79c36d8b15$var$_objectSpread({}, trans.inner),
                    children: [
                        {
                            tag: main.icon.tag,
                            children: main.icon.children,
                            attributes: $49b88f79c36d8b15$var$_objectSpread({}, main.icon.attributes, trans.path)
                        }
                    ]
                }
            ]
        });
    } else children.push(main.icon);
    return {
        children: children,
        attributes: attributes
    };
}
function $49b88f79c36d8b15$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($49b88f79c36d8b15$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $49b88f79c36d8b15$var$joinStyles($49b88f79c36d8b15$var$_objectSpread({}, styles, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $49b88f79c36d8b15$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $49b88f79c36d8b15$var$_objectSpread({}, attributes, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $49b88f79c36d8b15$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var widthClass = "fa-w-".concat(Math.ceil(width / height * 16));
    var attrClass = [
        $49b88f79c36d8b15$export$e506a1d27d1eaa20.replacementClass,
        iconName ? "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-").concat(iconName) : "",
        widthClass
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $49b88f79c36d8b15$var$_objectSpread({}, extra.attributes, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    if (watchable) content.attributes[$49b88f79c36d8b15$var$DATA_FA_I2SVG] = "";
    if (title) content.children.push({
        tag: "title",
        attributes: {
            id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $49b88f79c36d8b15$var$nextUniqueId())
        },
        children: [
            title
        ]
    });
    var args = $49b88f79c36d8b15$var$_objectSpread({}, content, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: extra.styles
    });
    var _ref2 = mask.found && main.found ? $49b88f79c36d8b15$var$makeIconMasking(args) : $49b88f79c36d8b15$var$makeIconStandard(args), children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $49b88f79c36d8b15$var$asSymbol(args);
    else return $49b88f79c36d8b15$var$asIcon(args);
}
function $49b88f79c36d8b15$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $49b88f79c36d8b15$var$_objectSpread({}, extra.attributes, title ? {
        "title": title
    } : {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$49b88f79c36d8b15$var$DATA_FA_I2SVG] = "";
    var styles = $49b88f79c36d8b15$var$_objectSpread({}, extra.styles);
    if ($49b88f79c36d8b15$var$transformIsMeaningful(transform)) {
        styles["transform"] = $49b88f79c36d8b15$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $49b88f79c36d8b15$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $49b88f79c36d8b15$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $49b88f79c36d8b15$var$_objectSpread({}, extra.attributes, title ? {
        "title": title
    } : {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $49b88f79c36d8b15$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $49b88f79c36d8b15$var$noop$1 = function noop() {};
var $49b88f79c36d8b15$var$p = $49b88f79c36d8b15$export$e506a1d27d1eaa20.measurePerformance && $49b88f79c36d8b15$var$PERFORMANCE && $49b88f79c36d8b15$var$PERFORMANCE.mark && $49b88f79c36d8b15$var$PERFORMANCE.measure ? $49b88f79c36d8b15$var$PERFORMANCE : {
    mark: $49b88f79c36d8b15$var$noop$1,
    measure: $49b88f79c36d8b15$var$noop$1
};
var $49b88f79c36d8b15$var$preamble = 'FA "5.13.0"';
var $49b88f79c36d8b15$var$begin = function begin(name) {
    $49b88f79c36d8b15$var$p.mark("".concat($49b88f79c36d8b15$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $49b88f79c36d8b15$var$end(name);
    };
};
var $49b88f79c36d8b15$var$end = function end(name) {
    $49b88f79c36d8b15$var$p.mark("".concat($49b88f79c36d8b15$var$preamble, " ").concat(name, " ends"));
    $49b88f79c36d8b15$var$p.measure("".concat($49b88f79c36d8b15$var$preamble, " ").concat(name), "".concat($49b88f79c36d8b15$var$preamble, " ").concat(name, " begins"), "".concat($49b88f79c36d8b15$var$preamble, " ").concat(name, " ends"));
};
var $49b88f79c36d8b15$var$perf = {
    begin: $49b88f79c36d8b15$var$begin,
    end: $49b88f79c36d8b15$var$end
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $49b88f79c36d8b15$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $49b88f79c36d8b15$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $49b88f79c36d8b15$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
function $49b88f79c36d8b15$var$toHex(unicode) {
    var result = "";
    for(var i = 0; i < unicode.length; i++){
        var hex = unicode.charCodeAt(i).toString(16);
        result += ("000" + hex).slice(-4);
    }
    return result;
}
function $49b88f79c36d8b15$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
    if (typeof $49b88f79c36d8b15$var$namespace.hooks.addPack === "function" && !skipHooks) $49b88f79c36d8b15$var$namespace.hooks.addPack(prefix, normalized);
    else $49b88f79c36d8b15$var$namespace.styles[prefix] = $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$namespace.styles[prefix] || {}, normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $49b88f79c36d8b15$var$defineIcons("fa", icons);
}
var $49b88f79c36d8b15$var$styles = $49b88f79c36d8b15$var$namespace.styles, $49b88f79c36d8b15$var$shims = $49b88f79c36d8b15$var$namespace.shims;
var $49b88f79c36d8b15$var$_byUnicode = {};
var $49b88f79c36d8b15$var$_byLigature = {};
var $49b88f79c36d8b15$var$_byOldName = {};
var $49b88f79c36d8b15$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $49b88f79c36d8b15$var$reduce($49b88f79c36d8b15$var$styles, function(o, style, prefix) {
            o[prefix] = $49b88f79c36d8b15$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $49b88f79c36d8b15$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        return acc;
    });
    $49b88f79c36d8b15$var$_byLigature = lookup(function(acc, icon, iconName) {
        var ligatures = icon[2];
        acc[iconName] = iconName;
        ligatures.forEach(function(ligature) {
            acc[ligature] = iconName;
        });
        return acc;
    });
    var hasRegular = "far" in $49b88f79c36d8b15$var$styles;
    $49b88f79c36d8b15$var$_byOldName = $49b88f79c36d8b15$var$reduce($49b88f79c36d8b15$var$shims, function(acc, shim) {
        var oldName = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        acc[oldName] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {});
};
$49b88f79c36d8b15$var$build();
function $49b88f79c36d8b15$var$byUnicode(prefix, unicode) {
    return ($49b88f79c36d8b15$var$_byUnicode[prefix] || {})[unicode];
}
function $49b88f79c36d8b15$var$byLigature(prefix, ligature) {
    return ($49b88f79c36d8b15$var$_byLigature[prefix] || {})[ligature];
}
function $49b88f79c36d8b15$var$byOldName(name) {
    return $49b88f79c36d8b15$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
var $49b88f79c36d8b15$var$styles$1 = $49b88f79c36d8b15$var$namespace.styles;
var $49b88f79c36d8b15$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $49b88f79c36d8b15$var$getCanonicalIcon(values) {
    return values.reduce(function(acc, cls) {
        var iconName = $49b88f79c36d8b15$var$getIconName($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, cls);
        if ($49b88f79c36d8b15$var$styles$1[cls]) acc.prefix = cls;
        else if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.autoFetchSvg && [
            "fas",
            "far",
            "fal",
            "fad",
            "fab",
            "fa"
        ].indexOf(cls) > -1) acc.prefix = cls;
        else if (iconName) {
            var shim = acc.prefix === "fa" ? $49b88f79c36d8b15$var$byOldName(iconName) : {};
            acc.iconName = shim.iconName || iconName;
            acc.prefix = shim.prefix || acc.prefix;
        } else if (cls !== $49b88f79c36d8b15$export$e506a1d27d1eaa20.replacementClass && cls.indexOf("fa-w-") !== 0) acc.rest.push(cls);
        return acc;
    }, $49b88f79c36d8b15$var$emptyCanonicalIcon());
}
function $49b88f79c36d8b15$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
function $49b88f79c36d8b15$export$a10125c086a4df16(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $49b88f79c36d8b15$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($49b88f79c36d8b15$var$joinAttributes(attributes), ">").concat(children.map($49b88f79c36d8b15$export$a10125c086a4df16).join(""), "</").concat(tag, ">");
}
var $49b88f79c36d8b15$var$noop$2 = function noop() {};
function $49b88f79c36d8b15$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($49b88f79c36d8b15$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $49b88f79c36d8b15$var$getMutator() {
    if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.autoReplaceSvg === true) return $49b88f79c36d8b15$var$mutators.replace;
    var mutator = $49b88f79c36d8b15$var$mutators[$49b88f79c36d8b15$export$e506a1d27d1eaa20.autoReplaceSvg];
    return mutator || $49b88f79c36d8b15$var$mutators.replace;
}
var $49b88f79c36d8b15$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        var newOuterHTML = abstract.map(function(a) {
            return $49b88f79c36d8b15$export$a10125c086a4df16(a);
        }).join("\n");
        if (node.parentNode && node.outerHTML) node.outerHTML = newOuterHTML + ($49b88f79c36d8b15$export$e506a1d27d1eaa20.keepOriginalSource && node.tagName.toLowerCase() !== "svg" ? "<!-- ".concat(node.outerHTML, " -->") : "");
        else if (node.parentNode) {
            var newNode = document.createElement("span");
            node.parentNode.replaceChild(newNode, node);
            newNode.outerHTML = newOuterHTML;
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$49b88f79c36d8b15$var$classArray(node).indexOf($49b88f79c36d8b15$export$e506a1d27d1eaa20.replacementClass)) return $49b88f79c36d8b15$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-.*"));
        delete abstract[0].attributes.style;
        delete abstract[0].attributes.id;
        var splitClasses = abstract[0].attributes.class.split(" ").reduce(function(acc, cls) {
            if (cls === $49b88f79c36d8b15$export$e506a1d27d1eaa20.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
            else acc.toNode.push(cls);
            return acc;
        }, {
            toNode: [],
            toSvg: []
        });
        abstract[0].attributes.class = splitClasses.toSvg.join(" ");
        var newInnerHTML = abstract.map(function(a) {
            return $49b88f79c36d8b15$export$a10125c086a4df16(a);
        }).join("\n");
        node.setAttribute("class", splitClasses.toNode.join(" "));
        node.setAttribute($49b88f79c36d8b15$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $49b88f79c36d8b15$var$performOperationSync(op) {
    op();
}
function $49b88f79c36d8b15$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $49b88f79c36d8b15$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $49b88f79c36d8b15$var$performOperationSync;
        if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.mutateApproach === $49b88f79c36d8b15$var$MUTATION_APPROACH_ASYNC) frame = $49b88f79c36d8b15$var$WINDOW.requestAnimationFrame || $49b88f79c36d8b15$var$performOperationSync;
        frame(function() {
            var mutator = $49b88f79c36d8b15$var$getMutator();
            var mark = $49b88f79c36d8b15$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $49b88f79c36d8b15$var$disabled = false;
function $49b88f79c36d8b15$var$disableObservation() {
    $49b88f79c36d8b15$var$disabled = true;
}
function $49b88f79c36d8b15$var$enableObservation() {
    $49b88f79c36d8b15$var$disabled = false;
}
var $49b88f79c36d8b15$var$mo = null;
function $49b88f79c36d8b15$var$observe(options) {
    if (!$49b88f79c36d8b15$var$MUTATION_OBSERVER) return;
    if (!$49b88f79c36d8b15$export$e506a1d27d1eaa20.observeMutations) return;
    var treeCallback = options.treeCallback, nodeCallback = options.nodeCallback, pseudoElementsCallback = options.pseudoElementsCallback, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $49b88f79c36d8b15$var$DOCUMENT : _options$observeMutat;
    $49b88f79c36d8b15$var$mo = new $49b88f79c36d8b15$var$MUTATION_OBSERVER(function(objects) {
        if ($49b88f79c36d8b15$var$disabled) return;
        $49b88f79c36d8b15$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$49b88f79c36d8b15$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $49b88f79c36d8b15$export$e506a1d27d1eaa20.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $49b88f79c36d8b15$var$isWatched(mutationRecord.target) && ~$49b88f79c36d8b15$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class") {
                    var _getCanonicalIcon = $49b88f79c36d8b15$var$getCanonicalIcon($49b88f79c36d8b15$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    if (prefix) mutationRecord.target.setAttribute("data-prefix", prefix);
                    if (iconName) mutationRecord.target.setAttribute("data-icon", iconName);
                } else nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$49b88f79c36d8b15$var$IS_DOM) return;
    $49b88f79c36d8b15$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $49b88f79c36d8b15$var$disconnect() {
    if (!$49b88f79c36d8b15$var$mo) return;
    $49b88f79c36d8b15$var$mo.disconnect();
}
function $49b88f79c36d8b15$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $49b88f79c36d8b15$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $49b88f79c36d8b15$var$getCanonicalIcon($49b88f79c36d8b15$var$classArray(node));
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.prefix && innerText.length > 1) val.iconName = $49b88f79c36d8b15$var$byLigature(val.prefix, node.innerText);
    else if (val.prefix && innerText.length === 1) val.iconName = $49b88f79c36d8b15$var$byUnicode(val.prefix, $49b88f79c36d8b15$var$toHex(node.innerText));
    return val;
}
var $49b88f79c36d8b15$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    if (!transformString) return transform;
    else return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
function $49b88f79c36d8b15$var$transformParser(node) {
    return $49b88f79c36d8b15$var$parseTransformString(node.getAttribute("data-fa-transform"));
}
function $49b88f79c36d8b15$var$symbolParser(node) {
    var symbol = node.getAttribute("data-fa-symbol");
    return symbol === null ? false : symbol === "" ? true : symbol;
}
function $49b88f79c36d8b15$var$attributesParser(node) {
    var extraAttributes = $49b88f79c36d8b15$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $49b88f79c36d8b15$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $49b88f79c36d8b15$var$maskParser(node) {
    var mask = node.getAttribute("data-fa-mask");
    if (!mask) return $49b88f79c36d8b15$var$emptyCanonicalIcon();
    else return $49b88f79c36d8b15$var$getCanonicalIcon(mask.split(" ").map(function(i) {
        return i.trim();
    }));
}
function $49b88f79c36d8b15$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $49b88f79c36d8b15$var$meaninglessTransform,
        symbol: false,
        mask: null,
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $49b88f79c36d8b15$var$parseMeta(node) {
    var _classParser = $49b88f79c36d8b15$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraStyles = $49b88f79c36d8b15$var$styleParser(node);
    var transform = $49b88f79c36d8b15$var$transformParser(node);
    var symbol = $49b88f79c36d8b15$var$symbolParser(node);
    var extraAttributes = $49b88f79c36d8b15$var$attributesParser(node);
    var mask = $49b88f79c36d8b15$var$maskParser(node);
    return {
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: transform,
        symbol: symbol,
        mask: mask,
        maskId: node.getAttribute("data-fa-mask-id"),
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    };
}
function $49b88f79c36d8b15$var$MissingIcon(error) {
    this.name = "MissingIcon";
    this.message = error || "Icon unavailable";
    this.stack = new Error().stack;
}
$49b88f79c36d8b15$var$MissingIcon.prototype = Object.create(Error.prototype);
$49b88f79c36d8b15$var$MissingIcon.prototype.constructor = $49b88f79c36d8b15$var$MissingIcon;
var $49b88f79c36d8b15$var$FILL = {
    fill: "currentColor"
};
var $49b88f79c36d8b15$var$ANIMATION_BASE = {
    attributeType: "XML",
    repeatCount: "indefinite",
    dur: "2s"
};
var $49b88f79c36d8b15$var$RING = {
    tag: "path",
    attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$FILL, {
        d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
    })
};
var $49b88f79c36d8b15$var$OPACITY_ANIMATE = $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$ANIMATION_BASE, {
    attributeName: "opacity"
});
var $49b88f79c36d8b15$var$DOT = {
    tag: "circle",
    attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$FILL, {
        cx: "256",
        cy: "364",
        r: "28"
    }),
    children: [
        {
            tag: "animate",
            attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$ANIMATION_BASE, {
                attributeName: "r",
                values: "28;14;28;28;14;28;"
            })
        },
        {
            tag: "animate",
            attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$OPACITY_ANIMATE, {
                values: "1;0;1;1;0;1;"
            })
        }
    ]
};
var $49b88f79c36d8b15$var$QUESTION = {
    tag: "path",
    attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$FILL, {
        opacity: "1",
        d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
    }),
    children: [
        {
            tag: "animate",
            attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$OPACITY_ANIMATE, {
                values: "1;0;0;0;0;1;"
            })
        }
    ]
};
var $49b88f79c36d8b15$var$EXCLAMATION = {
    tag: "path",
    attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$FILL, {
        opacity: "0",
        d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
    }),
    children: [
        {
            tag: "animate",
            attributes: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$OPACITY_ANIMATE, {
                values: "0;0;1;1;0;0;"
            })
        }
    ]
};
var $49b88f79c36d8b15$var$missing = {
    tag: "g",
    children: [
        $49b88f79c36d8b15$var$RING,
        $49b88f79c36d8b15$var$DOT,
        $49b88f79c36d8b15$var$QUESTION,
        $49b88f79c36d8b15$var$EXCLAMATION
    ]
};
var $49b88f79c36d8b15$var$styles$2 = $49b88f79c36d8b15$var$namespace.styles;
function $49b88f79c36d8b15$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $49b88f79c36d8b15$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-").concat($49b88f79c36d8b15$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-").concat($49b88f79c36d8b15$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-").concat($49b88f79c36d8b15$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
function $49b88f79c36d8b15$var$findIcon(iconName, prefix) {
    return new $49b88f79c36d8b15$var$picked(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $49b88f79c36d8b15$var$missing
        };
        if (iconName && prefix && $49b88f79c36d8b15$var$styles$2[prefix] && $49b88f79c36d8b15$var$styles$2[prefix][iconName]) {
            var icon = $49b88f79c36d8b15$var$styles$2[prefix][iconName];
            return resolve($49b88f79c36d8b15$var$asFoundIcon(icon));
        }
        var headers = {};
        if ($49b88f79c36d8b15$var$_typeof($49b88f79c36d8b15$var$WINDOW.FontAwesomeKitConfig) === "object" && typeof window.FontAwesomeKitConfig.token === "string") headers["fa-kit-token"] = $49b88f79c36d8b15$var$WINDOW.FontAwesomeKitConfig.token;
        if (iconName && prefix && !$49b88f79c36d8b15$export$e506a1d27d1eaa20.showMissingIcons) reject(new $49b88f79c36d8b15$var$MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
        else resolve(val);
    });
}
var $49b88f79c36d8b15$var$styles$3 = $49b88f79c36d8b15$var$namespace.styles;
function $49b88f79c36d8b15$var$generateSvgReplacementMutation(node, nodeMeta) {
    var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
    return new $49b88f79c36d8b15$var$picked(function(resolve, reject) {
        $49b88f79c36d8b15$var$picked.all([
            $49b88f79c36d8b15$var$findIcon(iconName, prefix),
            $49b88f79c36d8b15$var$findIcon(mask.iconName, mask.prefix)
        ]).then(function(_ref) {
            var _ref2 = $49b88f79c36d8b15$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
            resolve([
                node,
                $49b88f79c36d8b15$var$makeInlineSvgAbstract({
                    icons: {
                        main: main,
                        mask: mask
                    },
                    prefix: prefix,
                    iconName: iconName,
                    transform: transform,
                    symbol: symbol,
                    mask: mask,
                    maskId: maskId,
                    title: title,
                    titleId: titleId,
                    extra: extra,
                    watchable: true
                })
            ]);
        });
    });
}
function $49b88f79c36d8b15$var$generateLayersText(node, nodeMeta) {
    var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
    var width = null;
    var height = null;
    if ($49b88f79c36d8b15$var$IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
    }
    if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
    return $49b88f79c36d8b15$var$picked.resolve([
        node,
        $49b88f79c36d8b15$var$makeLayersTextAbstract({
            content: node.innerHTML,
            width: width,
            height: height,
            transform: transform,
            title: title,
            extra: extra,
            watchable: true
        })
    ]);
}
function $49b88f79c36d8b15$var$generateMutation(node) {
    var nodeMeta = $49b88f79c36d8b15$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($49b88f79c36d8b15$var$LAYERS_TEXT_CLASSNAME)) return $49b88f79c36d8b15$var$generateLayersText(node, nodeMeta);
    else return $49b88f79c36d8b15$var$generateSvgReplacementMutation(node, nodeMeta);
}
function $49b88f79c36d8b15$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$49b88f79c36d8b15$var$IS_DOM) return;
    var htmlClassList = $49b88f79c36d8b15$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($49b88f79c36d8b15$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($49b88f79c36d8b15$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $49b88f79c36d8b15$export$e506a1d27d1eaa20.autoFetchSvg ? Object.keys($49b88f79c36d8b15$var$PREFIX_TO_STYLE) : Object.keys($49b88f79c36d8b15$var$styles$3);
    var prefixesDomQuery = [
        ".".concat($49b88f79c36d8b15$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($49b88f79c36d8b15$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($49b88f79c36d8b15$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return;
    var candidates = [];
    try {
        candidates = $49b88f79c36d8b15$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return;
    var mark = $49b88f79c36d8b15$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $49b88f79c36d8b15$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$49b88f79c36d8b15$var$PRODUCTION) {
                if (e instanceof $49b88f79c36d8b15$var$MissingIcon) console.error(e);
            }
        }
        return acc;
    }, []);
    return new $49b88f79c36d8b15$var$picked(function(resolve, reject) {
        $49b88f79c36d8b15$var$picked.all(mutations).then(function(resolvedMutations) {
            $49b88f79c36d8b15$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function() {
            mark();
            reject();
        });
    });
}
function $49b88f79c36d8b15$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $49b88f79c36d8b15$var$generateMutation(node).then(function(mutation) {
        if (mutation) $49b88f79c36d8b15$var$perform([
            mutation
        ], callback);
    });
}
function $49b88f79c36d8b15$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($49b88f79c36d8b15$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new $49b88f79c36d8b15$var$picked(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $49b88f79c36d8b15$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($49b88f79c36d8b15$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $49b88f79c36d8b15$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($49b88f79c36d8b15$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Duotone",
                "Brands"
            ].indexOf(fontFamily[1]) ? $49b88f79c36d8b15$var$STYLE_TO_PREFIX[fontFamily[1].toLowerCase()] : $49b88f79c36d8b15$var$FONT_WEIGHT_TO_PREFIX[fontWeight];
            var hexValue = $49b88f79c36d8b15$var$toHex(content.length === 3 ? content.substr(1, 1) : content);
            var iconName = $49b88f79c36d8b15$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName; // Only convert the pseudo element in this :before/:after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($49b88f79c36d8b15$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($49b88f79c36d8b15$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $49b88f79c36d8b15$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$49b88f79c36d8b15$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $49b88f79c36d8b15$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $49b88f79c36d8b15$var$makeInlineSvgAbstract($49b88f79c36d8b15$var$_objectSpread({}, meta, {
                        icons: {
                            main: main,
                            mask: $49b88f79c36d8b15$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $49b88f79c36d8b15$var$DOCUMENT.createElement("svg");
                    if (position === ":before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return $49b88f79c36d8b15$export$a10125c086a4df16(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $49b88f79c36d8b15$var$replace(node) {
    return $49b88f79c36d8b15$var$picked.all([
        $49b88f79c36d8b15$var$replaceForPosition(node, ":before"),
        $49b88f79c36d8b15$var$replaceForPosition(node, ":after")
    ]);
}
function $49b88f79c36d8b15$var$processable(node) {
    return node.parentNode !== document.head && !~$49b88f79c36d8b15$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($49b88f79c36d8b15$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $49b88f79c36d8b15$var$searchPseudoElements(root) {
    if (!$49b88f79c36d8b15$var$IS_DOM) return;
    return new $49b88f79c36d8b15$var$picked(function(resolve, reject) {
        var operations = $49b88f79c36d8b15$var$toArray(root.querySelectorAll("*")).filter($49b88f79c36d8b15$var$processable).map($49b88f79c36d8b15$var$replace);
        var end = $49b88f79c36d8b15$var$perf.begin("searchPseudoElements");
        $49b88f79c36d8b15$var$disableObservation();
        $49b88f79c36d8b15$var$picked.all(operations).then(function() {
            end();
            $49b88f79c36d8b15$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $49b88f79c36d8b15$var$enableObservation();
            reject();
        });
    });
}
var $49b88f79c36d8b15$var$baseStyles = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
function $49b88f79c36d8b15$var$css() {
    var dfp = $49b88f79c36d8b15$var$DEFAULT_FAMILY_PREFIX;
    var drc = $49b88f79c36d8b15$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix;
    var rc = $49b88f79c36d8b15$export$e506a1d27d1eaa20.replacementClass;
    var s = $49b88f79c36d8b15$var$baseStyles;
    if (fp !== dfp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $49b88f79c36d8b15$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $49b88f79c36d8b15$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $49b88f79c36d8b15$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $49b88f79c36d8b15$var$_objectSpread({}, _this.definitions[key] || {}, additions[key]);
                    $49b88f79c36d8b15$var$defineIcons(key, additions[key]);
                    $49b88f79c36d8b15$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    if (!additions[prefix]) additions[prefix] = {};
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
function $49b88f79c36d8b15$var$ensureCss() {
    if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.autoAddCss && !$49b88f79c36d8b15$var$_cssInserted) {
        $49b88f79c36d8b15$var$insertCss($49b88f79c36d8b15$var$css());
        $49b88f79c36d8b15$var$_cssInserted = true;
    }
}
function $49b88f79c36d8b15$var$apiObject(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $49b88f79c36d8b15$export$a10125c086a4df16(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$49b88f79c36d8b15$var$IS_DOM) return;
            var container = $49b88f79c36d8b15$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $49b88f79c36d8b15$export$221fed4a47f597a5(iconLookup) {
    var _iconLookup$prefix = iconLookup.prefix, prefix = _iconLookup$prefix === void 0 ? "fa" : _iconLookup$prefix, iconName = iconLookup.iconName;
    if (!iconName) return;
    return $49b88f79c36d8b15$var$iconFromMapping($49b88f79c36d8b15$export$b839f963c7dc0e34.definitions, prefix, iconName) || $49b88f79c36d8b15$var$iconFromMapping($49b88f79c36d8b15$var$namespace.styles, prefix, iconName);
}
function $49b88f79c36d8b15$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $49b88f79c36d8b15$export$221fed4a47f597a5(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $49b88f79c36d8b15$export$221fed4a47f597a5(mask || {});
        return next(iconDefinition, $49b88f79c36d8b15$var$_objectSpread({}, params, {
            mask: mask
        }));
    };
}
var $49b88f79c36d8b15$export$b839f963c7dc0e34 = new $49b88f79c36d8b15$var$Library();
var $49b88f79c36d8b15$export$4f8e844b2782642c = function noAuto() {
    $49b88f79c36d8b15$export$e506a1d27d1eaa20.autoReplaceSvg = false;
    $49b88f79c36d8b15$export$e506a1d27d1eaa20.observeMutations = false;
    $49b88f79c36d8b15$var$disconnect();
};
var $49b88f79c36d8b15$var$_cssInserted = false;
var $49b88f79c36d8b15$export$df3a06d6289f983e = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($49b88f79c36d8b15$var$IS_DOM) {
            $49b88f79c36d8b15$var$ensureCss();
            var _params$node = params.node, node = _params$node === void 0 ? $49b88f79c36d8b15$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.searchPseudoElements) $49b88f79c36d8b15$var$searchPseudoElements(node);
            return $49b88f79c36d8b15$var$onTree(node, callback);
        } else return $49b88f79c36d8b15$var$picked.reject("Operation requires a DOM of some kind.");
    },
    css: $49b88f79c36d8b15$var$css,
    insertCss: function insertCss$$1() {
        if (!$49b88f79c36d8b15$var$_cssInserted) {
            $49b88f79c36d8b15$var$insertCss($49b88f79c36d8b15$var$css());
            $49b88f79c36d8b15$var$_cssInserted = true;
        }
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot, observeMutationsRoot = params.observeMutationsRoot;
        if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.autoReplaceSvg === false) $49b88f79c36d8b15$export$e506a1d27d1eaa20.autoReplaceSvg = true;
        $49b88f79c36d8b15$export$e506a1d27d1eaa20.observeMutations = true;
        $49b88f79c36d8b15$var$domready(function() {
            $49b88f79c36d8b15$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $49b88f79c36d8b15$var$observe({
                treeCallback: $49b88f79c36d8b15$var$onTree,
                nodeCallback: $49b88f79c36d8b15$var$onNode,
                pseudoElementsCallback: $49b88f79c36d8b15$var$searchPseudoElements,
                observeMutationsRoot: observeMutationsRoot
            });
        });
    }
};
var $49b88f79c36d8b15$export$98e6a39c04603d36 = {
    transform: function transform(transformString) {
        return $49b88f79c36d8b15$var$parseTransformString(transformString);
    }
};
var $49b88f79c36d8b15$export$1ca1ec8b29a4ce27 = $49b88f79c36d8b15$var$resolveIcons(function(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $49b88f79c36d8b15$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $49b88f79c36d8b15$var$apiObject($49b88f79c36d8b15$var$_objectSpread({
        type: "icon"
    }, iconDefinition), function() {
        $49b88f79c36d8b15$var$ensureCss();
        if ($49b88f79c36d8b15$export$e506a1d27d1eaa20.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.replacementClass, "-title-").concat(titleId || $49b88f79c36d8b15$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $49b88f79c36d8b15$var$makeInlineSvgAbstract({
            icons: {
                main: $49b88f79c36d8b15$var$asFoundIcon(icon),
                mask: mask ? $49b88f79c36d8b15$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$meaninglessTransform, transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
});
var $49b88f79c36d8b15$export$6f093cfa640b7166 = function text(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform2 = params.transform, transform = _params$transform2 === void 0 ? $49b88f79c36d8b15$var$meaninglessTransform : _params$transform2, _params$title2 = params.title, title = _params$title2 === void 0 ? null : _params$title2, _params$classes2 = params.classes, classes = _params$classes2 === void 0 ? [] : _params$classes2, _params$attributes2 = params.attributes, attributes = _params$attributes2 === void 0 ? {} : _params$attributes2, _params$styles2 = params.styles, styles = _params$styles2 === void 0 ? {} : _params$styles2;
    return $49b88f79c36d8b15$var$apiObject({
        type: "text",
        content: content
    }, function() {
        $49b88f79c36d8b15$var$ensureCss();
        return $49b88f79c36d8b15$var$makeLayersTextAbstract({
            content: content,
            transform: $49b88f79c36d8b15$var$_objectSpread({}, $49b88f79c36d8b15$var$meaninglessTransform, transform),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-layers-text")
                ].concat($49b88f79c36d8b15$var$_toConsumableArray(classes))
            }
        });
    });
};
var $49b88f79c36d8b15$export$e575061ef2a070eb = function counter(content) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$title3 = params.title, title = _params$title3 === void 0 ? null : _params$title3, _params$classes3 = params.classes, classes = _params$classes3 === void 0 ? [] : _params$classes3, _params$attributes3 = params.attributes, attributes = _params$attributes3 === void 0 ? {} : _params$attributes3, _params$styles3 = params.styles, styles = _params$styles3 === void 0 ? {} : _params$styles3;
    return $49b88f79c36d8b15$var$apiObject({
        type: "counter",
        content: content
    }, function() {
        $49b88f79c36d8b15$var$ensureCss();
        return $49b88f79c36d8b15$var$makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: [
                    "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-layers-counter")
                ].concat($49b88f79c36d8b15$var$_toConsumableArray(classes))
            }
        });
    });
};
var $49b88f79c36d8b15$export$50a222d9023da98b = function layer(assembler) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$classes4 = params.classes, classes = _params$classes4 === void 0 ? [] : _params$classes4;
    return $49b88f79c36d8b15$var$apiObject({
        type: "layer"
    }, function() {
        $49b88f79c36d8b15$var$ensureCss();
        var children = [];
        assembler(function(args) {
            Array.isArray(args) ? args.map(function(a) {
                children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
        });
        return [
            {
                tag: "span",
                attributes: {
                    class: [
                        "".concat($49b88f79c36d8b15$export$e506a1d27d1eaa20.familyPrefix, "-layers")
                    ].concat($49b88f79c36d8b15$var$_toConsumableArray(classes)).join(" ")
                },
                children: children
            }
        ];
    });
};
var $49b88f79c36d8b15$var$api = {
    noAuto: $49b88f79c36d8b15$export$4f8e844b2782642c,
    config: $49b88f79c36d8b15$export$e506a1d27d1eaa20,
    dom: $49b88f79c36d8b15$export$df3a06d6289f983e,
    library: $49b88f79c36d8b15$export$b839f963c7dc0e34,
    parse: $49b88f79c36d8b15$export$98e6a39c04603d36,
    findIconDefinition: $49b88f79c36d8b15$export$221fed4a47f597a5,
    icon: $49b88f79c36d8b15$export$1ca1ec8b29a4ce27,
    text: $49b88f79c36d8b15$export$6f093cfa640b7166,
    counter: $49b88f79c36d8b15$export$e575061ef2a070eb,
    layer: $49b88f79c36d8b15$export$50a222d9023da98b,
    toHtml: $49b88f79c36d8b15$export$a10125c086a4df16
};
var $49b88f79c36d8b15$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $49b88f79c36d8b15$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($49b88f79c36d8b15$var$namespace.styles).length > 0 || $49b88f79c36d8b15$export$e506a1d27d1eaa20.autoFetchSvg) && $49b88f79c36d8b15$var$IS_DOM && $49b88f79c36d8b15$export$e506a1d27d1eaa20.autoReplaceSvg) $49b88f79c36d8b15$var$api.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};



var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
function $e4ec753f5c716375$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e4ec753f5c716375$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $e4ec753f5c716375$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e4ec753f5c716375$var$_typeof(obj);
}
function $e4ec753f5c716375$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e4ec753f5c716375$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4ec753f5c716375$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e4ec753f5c716375$var$ownKeys(Object(source), true).forEach(function(key) {
            $e4ec753f5c716375$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e4ec753f5c716375$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e4ec753f5c716375$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e4ec753f5c716375$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e4ec753f5c716375$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e4ec753f5c716375$var$_toConsumableArray(arr) {
    return $e4ec753f5c716375$var$_arrayWithoutHoles(arr) || $e4ec753f5c716375$var$_iterableToArray(arr) || $e4ec753f5c716375$var$_nonIterableSpread();
}
function $e4ec753f5c716375$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $e4ec753f5c716375$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $e4ec753f5c716375$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
// Get CSS class list from a props object
function $e4ec753f5c716375$var$classList(props) {
    var _classes;
    var spin = props.spin, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-spin": spin,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $e4ec753f5c716375$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $e4ec753f5c716375$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $e4ec753f5c716375$var$camelize(string) {
    if ($e4ec753f5c716375$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
function $e4ec753f5c716375$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $e4ec753f5c716375$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $e4ec753f5c716375$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$e4ec753f5c716375$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $e4ec753f5c716375$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $e4ec753f5c716375$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $e4ec753f5c716375$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$e4ec753f5c716375$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $e4ec753f5c716375$var$_objectWithoutProperties(extraProps, [
        "style"
    ]);
    mixins.attrs["style"] = $e4ec753f5c716375$var$_objectSpread2({}, mixins.attrs["style"], {}, existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $e4ec753f5c716375$var$_objectSpread2({}, mixins.attrs, {}, remaining)
    ].concat($e4ec753f5c716375$var$_toConsumableArray(children)));
}
var $e4ec753f5c716375$var$PRODUCTION = false;
try {
    $e4ec753f5c716375$var$PRODUCTION = true;
} catch (e) {}
function $e4ec753f5c716375$var$log() {
    if (!$e4ec753f5c716375$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
// Normalize icon arguments
function $e4ec753f5c716375$var$normalizeIconArgs(icon) {
    // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if ($e4ec753f5c716375$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $e4ec753f5c716375$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $e4ec753f5c716375$var$_defineProperty({}, key, value) : {};
}
function $e4ec753f5c716375$export$2b9260d4a45c8710(props) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title;
    var iconLookup = $e4ec753f5c716375$var$normalizeIconArgs(iconArgs);
    var classes = $e4ec753f5c716375$var$objectWithKey("classes", [].concat($e4ec753f5c716375$var$_toConsumableArray($e4ec753f5c716375$var$classList(props)), $e4ec753f5c716375$var$_toConsumableArray(className.split(" "))));
    var transform = $e4ec753f5c716375$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $49b88f79c36d8b15$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $e4ec753f5c716375$var$objectWithKey("mask", $e4ec753f5c716375$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $49b88f79c36d8b15$export$1ca1ec8b29a4ce27)(iconLookup, $e4ec753f5c716375$var$_objectSpread2({}, classes, {}, transform, {}, mask, {
        symbol: symbol,
        title: title
    }));
    if (!renderedIcon) {
        $e4ec753f5c716375$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {};
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$e4ec753f5c716375$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $e4ec753f5c716375$var$convertCurry(abstract[0], extraProps);
}
$e4ec753f5c716375$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$e4ec753f5c716375$export$2b9260d4a45c8710.propTypes = {
    border: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        90,
        180,
        270
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "lg",
        "xs",
        "sm",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
$e4ec753f5c716375$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    fixedWidth: false,
    inverse: false,
    flip: null,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    symbol: false,
    title: "",
    transform: null,
    swapOpacity: false
};
var $e4ec753f5c716375$var$convertCurry = $e4ec753f5c716375$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement);


parcelRequire("acw62");
var $8ef988b2cc978acd$export$13ff1290a9e22e77;
(function(IconType) {
    IconType[IconType["Satellite"] = 0] = "Satellite";
    IconType[IconType["Check"] = 1] = "Check";
    IconType[IconType["Map"] = 2] = "Map";
    IconType[IconType["Crosshairs"] = 3] = "Crosshairs";
    IconType[IconType["Drafting"] = 4] = "Drafting";
    IconType[IconType["Import"] = 5] = "Import";
    IconType[IconType["BroadCast"] = 6] = "BroadCast";
    IconType[IconType["CaretRight"] = 7] = "CaretRight";
    IconType[IconType["ArrowRight"] = 8] = "ArrowRight";
    IconType[IconType["ArrowLeft"] = 9] = "ArrowLeft";
    IconType[IconType["Close"] = 10] = "Close";
})($8ef988b2cc978acd$export$13ff1290a9e22e77 || ($8ef988b2cc978acd$export$13ff1290a9e22e77 = {}));
function $8ef988b2cc978acd$var$getIcon(icon) {
    switch(icon){
        case 0:
            return 0, $321daf9b005e9cff$export$219ccae0e4da3c92;
        case 1:
            return 0, $321daf9b005e9cff$export$be9e388158c74f29;
        case 2:
            return 0, $321daf9b005e9cff$export$fc82fb79180cd17c;
        case 3:
            return 0, $321daf9b005e9cff$export$721c101130c40043;
        case 4:
            return 0, $321daf9b005e9cff$export$c8c2b127d13b9d79;
        case 5:
            return 0, $321daf9b005e9cff$export$d796c05153b1255c;
        case 6:
            return 0, $321daf9b005e9cff$export$f68b38d51f5c0ed;
        case 7:
            return 0, $321daf9b005e9cff$export$f1011352b01c1c0;
        case 8:
            return 0, $321daf9b005e9cff$export$b4da69a0247f3620;
        case 9:
            return 0, $321daf9b005e9cff$export$b7fac681e7d09400;
        case 10:
            return 0, $321daf9b005e9cff$export$18b7775f78a3e16;
        default:
            break;
    }
}
function $8ef988b2cc978acd$export$2e2bcd8739ae039({ icon: icon, className: className, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
        ...rest,
        className: className,
        icon: $8ef988b2cc978acd$var$getIcon(icon)
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
function $8de9ea61ee635d28$export$2e2bcd8739ae039({ priceTitle: priceTitle, amount: amount, trialUnavailable: trialUnavailable, onClick: onClick, priceID: priceID, discountText: discountText }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        style: {
            border: "1px solid #b2b2b2",
            borderRadius: "4px"
        },
        padding: 2,
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginY: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    fontWeight: 600,
                    fontSize: 18,
                    children: priceTitle
                })
            }),
            !trialUnavailable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginX: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    fontSize: 24,
                    children: "14 days free"
                })
            }),
            !trialUnavailable && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: [
                    "Then ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: amount
                    })
                ]
            }),
            trialUnavailable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    fontWeight: 600,
                    fontSize: 24,
                    children: amount
                })
            }),
            discountText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: discountText
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                variant: "contained",
                onClick: ()=>onClick(priceID),
                children: trialUnavailable ? "Subscribe" : "Start Trial"
            })
        ]
    });
}


function $41706c3e03419308$var$SubscriptionCTA({ className: className, trialUnavailable: trialUnavailable }) {
    const paymentURL = (0, $3e8772b7528d3c44$export$4f4427446da83a71)();
    const handleClick = async (p)=>{
        const u = await paymentURL(p);
        window.location.href = u.url;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            center: true,
            wide: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                align: true,
                column: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Subscribe to Frag Orders Premium"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginY: 2,
                        children: "Your subscription will unlock these premium features and help support the ongoing development of Frag Orders:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginY: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                                        className: "Icon",
                                        style: {
                                            color: "green"
                                        },
                                        icon: (0, $8ef988b2cc978acd$export$13ff1290a9e22e77).Check
                                    }),
                                    "Flight planning for mission participants"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                                        className: "Icon",
                                        style: {
                                            color: "green"
                                        },
                                        icon: (0, $8ef988b2cc978acd$export$13ff1290a9e22e77).Check
                                    }),
                                    "Auto-generated kneeboards injected directly into your .miz file"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                                        className: "Icon",
                                        style: {
                                            color: "green"
                                        },
                                        icon: (0, $8ef988b2cc978acd$export$13ff1290a9e22e77).Check
                                    }),
                                    "Radio preset and laser code configuration"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                                        className: "Icon",
                                        style: {
                                            color: "green"
                                        },
                                        icon: (0, $8ef988b2cc978acd$export$13ff1290a9e22e77).Check
                                    }),
                                    "Countrol measure drawing for mission participants"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8de9ea61ee635d28$export$2e2bcd8739ae039), {
                                    priceID: (0, $dbf86a8fe13ef9de$export$a6b3daa2792c50f8).Monthly,
                                    amount: "$5 per month",
                                    priceTitle: "Frag Orders Premium - Monthly",
                                    trialUnavailable: trialUnavailable,
                                    onClick: handleClick
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                sm: 6,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8de9ea61ee635d28$export$2e2bcd8739ae039), {
                                    priceID: (0, $dbf86a8fe13ef9de$export$a6b3daa2792c50f8).Yearly,
                                    amount: "$50 per year",
                                    priceTitle: "Frag Orders Premium - Yearly",
                                    trialUnavailable: trialUnavailable,
                                    onClick: handleClick
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $390198e472ccb254$export$2e2bcd8739ae039), {
                                flag: (0, $1bfb465a9f0e47a1$export$df35587a8f95f16f).VolumeLicense,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    sm: 12,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8de9ea61ee635d28$export$2e2bcd8739ae039), {
                                        priceID: (0, $dbf86a8fe13ef9de$export$a6b3daa2792c50f8).Volume,
                                        priceTitle: "Frag Orders Premium - Volume License",
                                        amount: "$20 per month for 5 users",
                                        discountText: "Save 20% per user",
                                        trialUnavailable: true,
                                        onClick: handleClick
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $41706c3e03419308$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($41706c3e03419308$var$SubscriptionCTA).attrs({
    className: $41706c3e03419308$var$SubscriptionCTA.name
})`
  .Icon {
    margin-right: 4px;
  }
`;


function $8907d218d1b2bc24$var$SubscriptionGate({ className: className, children: children, blockedHeader: blockedHeader }) {
    const isSubscribed = (0, $5f078b543969ac27$export$6e12a35b5fc14cf8)();
    if (!isSubscribed) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
            title: blockedHeader,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                center: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    column: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                            severity: "warning",
                            children: "This feature is only available to Frag Orders Premium subscribers."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            p: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41706c3e03419308$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        })
    });
    return children;
}
var $8907d218d1b2bc24$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($8907d218d1b2bc24$var$SubscriptionGate).attrs({
    className: $8907d218d1b2bc24$var$SubscriptionGate.name
})`
  a {
    text-decoration: none;
  }
`;


const $a6bef72edba85b27$var$ForwardedLink = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
        ...props,
        innerRef: ref
    }));
function $a6bef72edba85b27$var$findChildren(childrenProp) {
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(childrenProp, (c)=>!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isNull(c));
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isArray(filtered)) return filtered;
    return [
        filtered
    ];
}
function $a6bef72edba85b27$var$routesToIndex(routes, pathname) {
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).findIndex(routes, (r)=>pathname === r.path);
    return index === -1 ? 0 : index;
}
function $a6bef72edba85b27$export$733ac94ecabeac6c({ children: children, path: path, featureFlag: featureFlag, subscriberOnly: subscriberOnly, name: name, label: label }) {
    const userFlags = (0, $1bfb465a9f0e47a1$export$90335b3ff08f335)();
    if (featureFlag && !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(userFlags, featureFlag)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
        exact: true,
        path: path,
        children: subscriberOnly ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8907d218d1b2bc24$export$2e2bcd8739ae039), {
            blockedHeader: label || name,
            children: children
        }) : children
    });
}
function $a6bef72edba85b27$var$SubRouterTabs({ className: className, children: children, rootPath: rootPath }) {
    const childs = $a6bef72edba85b27$var$findChildren(children);
    const userFlags = (0, $1bfb465a9f0e47a1$export$90335b3ff08f335)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(childs, [
        0,
        "props",
        "path"
    ])) throw new Error("HashRouterTabs children must be of type HashRouterTab");
    const routes = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(childs, (c)=>{
        return {
            path: c?.props?.path,
            name: c?.props?.name,
            featureFlag: c?.props?.featureFlag,
            label: c?.props.label,
            icon: c?.props.icon
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        wide: true,
        column: true,
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                indicatorColor: "primary",
                value: $a6bef72edba85b27$var$routesToIndex(routes, window.location.pathname),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(routes, (route, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        component: $a6bef72edba85b27$var$ForwardedLink,
                        to: route.path,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                            hidden: route.featureFlag && !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(userFlags, route.featureFlag),
                            "active-tab": window.location.pathname.includes(route.path)
                        }),
                        label: route.label || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: route.name
                        }),
                        icon: route.icon
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                sx: {
                    borderTop: 2,
                    borderColor: "divider",
                    width: "100%"
                },
                paddingTop: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262), {
                    children: [
                        children,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e), {
                            from: "*",
                            to: rootPath
                        })
                    ]
                })
            })
        ]
    });
}
var $a6bef72edba85b27$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a6bef72edba85b27$var$SubRouterTabs).attrs({
    className: $a6bef72edba85b27$var$SubRouterTabs.name
})`
  .hidden {
    visibility: hidden;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $6ZWSX = parcelRequire("6ZWSX");
var $1f686b51e97e797f$require$Buffer = $6ZWSX.Buffer;
class $1f686b51e97e797f$export$d9d08b09962b4c23 extends Error {
    constructor(code, message, options, ...contexts){
        if (Array.isArray(message)) message = message.join(" ").trim();
        super(message);
        if (Error.captureStackTrace !== undefined) Error.captureStackTrace(this, $1f686b51e97e797f$export$d9d08b09962b4c23);
        this.code = code;
        for (const context of contexts)for(const key in context){
            const value = context[key];
            this[key] = $1f686b51e97e797f$require$Buffer.isBuffer(value) ? value.toString(options.encoding) : value == null ? value : JSON.parse(JSON.stringify(value));
        }
    }
}


const $4ec522923698d10c$export$167528a9b5133c2f = function(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};


const $256251f253ac874e$export$46bd8faf65ac9e2 = function(columns) {
    const normalizedColumns = [];
    for(let i = 0, l = columns.length; i < l; i++){
        const column = columns[i];
        if (column === undefined || column === null || column === false) normalizedColumns[i] = {
            disabled: true
        };
        else if (typeof column === "string") normalizedColumns[i] = {
            name: column
        };
        else if ((0, $4ec522923698d10c$export$167528a9b5133c2f)(column)) {
            if (typeof column.name !== "string") throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_OPTION_COLUMNS_MISSING_NAME", [
                "Option columns missing name:",
                `property "name" is required at position ${i}`,
                "when column is an object literal"
            ]);
            normalizedColumns[i] = column;
        } else throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_COLUMN_DEFINITION", [
            "Invalid column definition:",
            "expect a string or a literal object,",
            `got ${JSON.stringify(column)} at position ${i}`
        ]);
    }
    return normalizedColumns;
};



var $6ZWSX = parcelRequire("6ZWSX");
var $007ff4fdb1834ad7$require$Buffer = $6ZWSX.Buffer;
class $007ff4fdb1834ad7$var$ResizeableBuffer {
    constructor(size = 100){
        this.size = size;
        this.length = 0;
        this.buf = $007ff4fdb1834ad7$require$Buffer.allocUnsafe(size);
    }
    prepend(val) {
        if ($007ff4fdb1834ad7$require$Buffer.isBuffer(val)) {
            const length = this.length + val.length;
            if (length >= this.size) {
                this.resize();
                if (length >= this.size) throw Error("INVALID_BUFFER_STATE");
            }
            const buf = this.buf;
            this.buf = $007ff4fdb1834ad7$require$Buffer.allocUnsafe(this.size);
            val.copy(this.buf, 0);
            buf.copy(this.buf, val.length);
            this.length += val.length;
        } else {
            const length = this.length++;
            if (length === this.size) this.resize();
            const buf = this.clone();
            this.buf[0] = val;
            buf.copy(this.buf, 1, 0, length);
        }
    }
    append(val) {
        const length = this.length++;
        if (length === this.size) this.resize();
        this.buf[length] = val;
    }
    clone() {
        return $007ff4fdb1834ad7$require$Buffer.from(this.buf.slice(0, this.length));
    }
    resize() {
        const length = this.length;
        this.size = this.size * 2;
        const buf = $007ff4fdb1834ad7$require$Buffer.allocUnsafe(this.size);
        this.buf.copy(buf, 0, 0, length);
        this.buf = buf;
    }
    toString(encoding) {
        if (encoding) return this.buf.slice(0, this.length).toString(encoding);
        else return Uint8Array.prototype.slice.call(this.buf.slice(0, this.length));
    }
    toJSON() {
        return this.toString("utf8");
    }
    reset() {
        this.length = 0;
    }
}
var $007ff4fdb1834ad7$export$2e2bcd8739ae039 = $007ff4fdb1834ad7$var$ResizeableBuffer;



var $6ZWSX = parcelRequire("6ZWSX");
var $77128d227e7dc114$require$Buffer = $6ZWSX.Buffer;
// white space characters
// https://en.wikipedia.org/wiki/Whitespace_character
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Character_Classes#Types
// \f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff
const $77128d227e7dc114$var$np = 12;
const $77128d227e7dc114$var$cr = 13; // `\r`, carriage return, 0x0D in hexadécimal, 13 in decimal
const $77128d227e7dc114$var$nl = 10; // `\n`, newline, 0x0A in hexadecimal, 10 in decimal
const $77128d227e7dc114$var$space = 32;
const $77128d227e7dc114$var$tab = 9;
const $77128d227e7dc114$export$588199c25dc0cbed = function(options) {
    return {
        bomSkipped: false,
        bufBytesStart: 0,
        castField: options.cast_function,
        commenting: false,
        // Current error encountered by a record
        error: undefined,
        enabled: options.from_line === 1,
        escaping: false,
        escapeIsQuote: $77128d227e7dc114$require$Buffer.isBuffer(options.escape) && $77128d227e7dc114$require$Buffer.isBuffer(options.quote) && $77128d227e7dc114$require$Buffer.compare(options.escape, options.quote) === 0,
        // columns can be `false`, `true`, `Array`
        expectedRecordLength: Array.isArray(options.columns) ? options.columns.length : undefined,
        field: new (0, $007ff4fdb1834ad7$export$2e2bcd8739ae039)(20),
        firstLineToHeaders: options.cast_first_line_to_header,
        needMoreDataSize: Math.max(// Skip if the remaining buffer smaller than comment
        options.comment !== null ? options.comment.length : 0, // Skip if the remaining buffer can be delimiter
        ...options.delimiter.map((delimiter)=>delimiter.length), // Skip if the remaining buffer can be escape sequence
        options.quote !== null ? options.quote.length : 0),
        previousBuf: undefined,
        quoting: false,
        stop: false,
        rawBuffer: new (0, $007ff4fdb1834ad7$export$2e2bcd8739ae039)(100),
        record: [],
        recordHasError: false,
        record_length: 0,
        recordDelimiterMaxLength: options.record_delimiter.length === 0 ? 0 : Math.max(...options.record_delimiter.map((v)=>v.length)),
        trimChars: [
            $77128d227e7dc114$require$Buffer.from(" ", options.encoding)[0],
            $77128d227e7dc114$require$Buffer.from("	", options.encoding)[0]
        ],
        wasQuoting: false,
        wasRowDelimiter: false,
        timchars: [
            $77128d227e7dc114$require$Buffer.from($77128d227e7dc114$require$Buffer.from([
                $77128d227e7dc114$var$cr
            ], "utf8").toString(), options.encoding),
            $77128d227e7dc114$require$Buffer.from($77128d227e7dc114$require$Buffer.from([
                $77128d227e7dc114$var$nl
            ], "utf8").toString(), options.encoding),
            $77128d227e7dc114$require$Buffer.from($77128d227e7dc114$require$Buffer.from([
                $77128d227e7dc114$var$np
            ], "utf8").toString(), options.encoding),
            $77128d227e7dc114$require$Buffer.from($77128d227e7dc114$require$Buffer.from([
                $77128d227e7dc114$var$space
            ], "utf8").toString(), options.encoding),
            $77128d227e7dc114$require$Buffer.from($77128d227e7dc114$require$Buffer.from([
                $77128d227e7dc114$var$tab
            ], "utf8").toString(), options.encoding)
        ]
    };
};




const $83a94ff9603e8ed1$export$730f2a930033e8f0 = function(str) {
    return str.replace(/([A-Z])/g, function(_, match) {
        return "_" + match.toLowerCase();
    });
};



var $6ZWSX = parcelRequire("6ZWSX");
var $9d52b1238665b2e8$require$Buffer = $6ZWSX.Buffer;
const $9d52b1238665b2e8$export$ccfebcb248d28a57 = function(opts) {
    const options = {};
    // Merge with user options
    for(const opt in opts)options[(0, $83a94ff9603e8ed1$export$730f2a930033e8f0)(opt)] = opts[opt];
    // Normalize option `encoding`
    // Note: defined first because other options depends on it
    // to convert chars/strings into buffers.
    if (options.encoding === undefined || options.encoding === true) options.encoding = "utf8";
    else if (options.encoding === null || options.encoding === false) options.encoding = null;
    else if (typeof options.encoding !== "string" && options.encoding !== null) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_ENCODING", [
        "Invalid option encoding:",
        "encoding must be a string or null to return a buffer,",
        `got ${JSON.stringify(options.encoding)}`
    ], options);
    // Normalize option `bom`
    if (options.bom === undefined || options.bom === null || options.bom === false) options.bom = false;
    else if (options.bom !== true) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_BOM", [
        "Invalid option bom:",
        "bom must be true,",
        `got ${JSON.stringify(options.bom)}`
    ], options);
    // Normalize option `cast`
    options.cast_function = null;
    if (options.cast === undefined || options.cast === null || options.cast === false || options.cast === "") options.cast = undefined;
    else if (typeof options.cast === "function") {
        options.cast_function = options.cast;
        options.cast = true;
    } else if (options.cast !== true) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_CAST", [
        "Invalid option cast:",
        "cast must be true or a function,",
        `got ${JSON.stringify(options.cast)}`
    ], options);
    // Normalize option `cast_date`
    if (options.cast_date === undefined || options.cast_date === null || options.cast_date === false || options.cast_date === "") options.cast_date = false;
    else if (options.cast_date === true) options.cast_date = function(value) {
        const date = Date.parse(value);
        return !isNaN(date) ? new Date(date) : value;
    };
    else if (typeof options.cast_date !== "function") throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_CAST_DATE", [
        "Invalid option cast_date:",
        "cast_date must be true or a function,",
        `got ${JSON.stringify(options.cast_date)}`
    ], options);
    // Normalize option `columns`
    options.cast_first_line_to_header = null;
    if (options.columns === true) // Fields in the first line are converted as-is to columns
    options.cast_first_line_to_header = undefined;
    else if (typeof options.columns === "function") {
        options.cast_first_line_to_header = options.columns;
        options.columns = true;
    } else if (Array.isArray(options.columns)) options.columns = (0, $256251f253ac874e$export$46bd8faf65ac9e2)(options.columns);
    else if (options.columns === undefined || options.columns === null || options.columns === false) options.columns = false;
    else throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_COLUMNS", [
        "Invalid option columns:",
        "expect an array, a function or true,",
        `got ${JSON.stringify(options.columns)}`
    ], options);
    // Normalize option `group_columns_by_name`
    if (options.group_columns_by_name === undefined || options.group_columns_by_name === null || options.group_columns_by_name === false) options.group_columns_by_name = false;
    else if (options.group_columns_by_name !== true) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME", [
        "Invalid option group_columns_by_name:",
        "expect an boolean,",
        `got ${JSON.stringify(options.group_columns_by_name)}`
    ], options);
    else if (options.columns === false) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME", [
        "Invalid option group_columns_by_name:",
        "the `columns` mode must be activated."
    ], options);
    // Normalize option `comment`
    if (options.comment === undefined || options.comment === null || options.comment === false || options.comment === "") options.comment = null;
    else {
        if (typeof options.comment === "string") options.comment = $9d52b1238665b2e8$require$Buffer.from(options.comment, options.encoding);
        if (!$9d52b1238665b2e8$require$Buffer.isBuffer(options.comment)) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_COMMENT", [
            "Invalid option comment:",
            "comment must be a buffer or a string,",
            `got ${JSON.stringify(options.comment)}`
        ], options);
    }
    // Normalize option `delimiter`
    const delimiter_json = JSON.stringify(options.delimiter);
    if (!Array.isArray(options.delimiter)) options.delimiter = [
        options.delimiter
    ];
    if (options.delimiter.length === 0) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_DELIMITER", [
        "Invalid option delimiter:",
        "delimiter must be a non empty string or buffer or array of string|buffer,",
        `got ${delimiter_json}`
    ], options);
    options.delimiter = options.delimiter.map(function(delimiter) {
        if (delimiter === undefined || delimiter === null || delimiter === false) return $9d52b1238665b2e8$require$Buffer.from(",", options.encoding);
        if (typeof delimiter === "string") delimiter = $9d52b1238665b2e8$require$Buffer.from(delimiter, options.encoding);
        if (!$9d52b1238665b2e8$require$Buffer.isBuffer(delimiter) || delimiter.length === 0) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_DELIMITER", [
            "Invalid option delimiter:",
            "delimiter must be a non empty string or buffer or array of string|buffer,",
            `got ${delimiter_json}`
        ], options);
        return delimiter;
    });
    // Normalize option `escape`
    if (options.escape === undefined || options.escape === true) options.escape = $9d52b1238665b2e8$require$Buffer.from('"', options.encoding);
    else if (typeof options.escape === "string") options.escape = $9d52b1238665b2e8$require$Buffer.from(options.escape, options.encoding);
    else if (options.escape === null || options.escape === false) options.escape = null;
    if (options.escape !== null) {
        if (!$9d52b1238665b2e8$require$Buffer.isBuffer(options.escape)) throw new Error(`Invalid Option: escape must be a buffer, a string or a boolean, got ${JSON.stringify(options.escape)}`);
    }
    // Normalize option `from`
    if (options.from === undefined || options.from === null) options.from = 1;
    else {
        if (typeof options.from === "string" && /\d+/.test(options.from)) options.from = parseInt(options.from);
        if (Number.isInteger(options.from)) {
            if (options.from < 0) throw new Error(`Invalid Option: from must be a positive integer, got ${JSON.stringify(opts.from)}`);
        } else throw new Error(`Invalid Option: from must be an integer, got ${JSON.stringify(options.from)}`);
    }
    // Normalize option `from_line`
    if (options.from_line === undefined || options.from_line === null) options.from_line = 1;
    else {
        if (typeof options.from_line === "string" && /\d+/.test(options.from_line)) options.from_line = parseInt(options.from_line);
        if (Number.isInteger(options.from_line)) {
            if (options.from_line <= 0) throw new Error(`Invalid Option: from_line must be a positive integer greater than 0, got ${JSON.stringify(opts.from_line)}`);
        } else throw new Error(`Invalid Option: from_line must be an integer, got ${JSON.stringify(opts.from_line)}`);
    }
    // Normalize options `ignore_last_delimiters`
    if (options.ignore_last_delimiters === undefined || options.ignore_last_delimiters === null) options.ignore_last_delimiters = false;
    else if (typeof options.ignore_last_delimiters === "number") {
        options.ignore_last_delimiters = Math.floor(options.ignore_last_delimiters);
        if (options.ignore_last_delimiters === 0) options.ignore_last_delimiters = false;
    } else if (typeof options.ignore_last_delimiters !== "boolean") throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_IGNORE_LAST_DELIMITERS", [
        "Invalid option `ignore_last_delimiters`:",
        "the value must be a boolean value or an integer,",
        `got ${JSON.stringify(options.ignore_last_delimiters)}`
    ], options);
    if (options.ignore_last_delimiters === true && options.columns === false) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_IGNORE_LAST_DELIMITERS_REQUIRES_COLUMNS", [
        "The option `ignore_last_delimiters`",
        "requires the activation of the `columns` option"
    ], options);
    // Normalize option `info`
    if (options.info === undefined || options.info === null || options.info === false) options.info = false;
    else if (options.info !== true) throw new Error(`Invalid Option: info must be true, got ${JSON.stringify(options.info)}`);
    // Normalize option `max_record_size`
    if (options.max_record_size === undefined || options.max_record_size === null || options.max_record_size === false) options.max_record_size = 0;
    else if (Number.isInteger(options.max_record_size) && options.max_record_size >= 0) ;
    else if (typeof options.max_record_size === "string" && /\d+/.test(options.max_record_size)) options.max_record_size = parseInt(options.max_record_size);
    else throw new Error(`Invalid Option: max_record_size must be a positive integer, got ${JSON.stringify(options.max_record_size)}`);
    // Normalize option `objname`
    if (options.objname === undefined || options.objname === null || options.objname === false) options.objname = undefined;
    else if ($9d52b1238665b2e8$require$Buffer.isBuffer(options.objname)) {
        if (options.objname.length === 0) throw new Error(`Invalid Option: objname must be a non empty buffer`);
        if (options.encoding === null) ;
        else options.objname = options.objname.toString(options.encoding);
    } else if (typeof options.objname === "string") {
        if (options.objname.length === 0) throw new Error(`Invalid Option: objname must be a non empty string`);
    // Great, nothing to do
    } else if (typeof options.objname === "number") ;
    else throw new Error(`Invalid Option: objname must be a string or a buffer, got ${options.objname}`);
    if (options.objname !== undefined) {
        if (typeof options.objname === "number") {
            if (options.columns !== false) throw Error("Invalid Option: objname index cannot be combined with columns or be defined as a field");
        } else {
            if (options.columns === false) throw Error("Invalid Option: objname field must be combined with columns or be defined as an index");
        }
    }
    // Normalize option `on_record`
    if (options.on_record === undefined || options.on_record === null) options.on_record = undefined;
    else if (typeof options.on_record !== "function") throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_ON_RECORD", [
        "Invalid option `on_record`:",
        "expect a function,",
        `got ${JSON.stringify(options.on_record)}`
    ], options);
    // Normalize option `quote`
    if (options.quote === null || options.quote === false || options.quote === "") options.quote = null;
    else {
        if (options.quote === undefined || options.quote === true) options.quote = $9d52b1238665b2e8$require$Buffer.from('"', options.encoding);
        else if (typeof options.quote === "string") options.quote = $9d52b1238665b2e8$require$Buffer.from(options.quote, options.encoding);
        if (!$9d52b1238665b2e8$require$Buffer.isBuffer(options.quote)) throw new Error(`Invalid Option: quote must be a buffer or a string, got ${JSON.stringify(options.quote)}`);
    }
    // Normalize option `raw`
    if (options.raw === undefined || options.raw === null || options.raw === false) options.raw = false;
    else if (options.raw !== true) throw new Error(`Invalid Option: raw must be true, got ${JSON.stringify(options.raw)}`);
    // Normalize option `record_delimiter`
    if (options.record_delimiter === undefined) options.record_delimiter = [];
    else if (typeof options.record_delimiter === "string" || $9d52b1238665b2e8$require$Buffer.isBuffer(options.record_delimiter)) {
        if (options.record_delimiter.length === 0) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a non empty string or buffer,",
            `got ${JSON.stringify(options.record_delimiter)}`
        ], options);
        options.record_delimiter = [
            options.record_delimiter
        ];
    } else if (!Array.isArray(options.record_delimiter)) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
        "Invalid option `record_delimiter`:",
        "value must be a string, a buffer or array of string|buffer,",
        `got ${JSON.stringify(options.record_delimiter)}`
    ], options);
    options.record_delimiter = options.record_delimiter.map(function(rd, i) {
        if (typeof rd !== "string" && !$9d52b1238665b2e8$require$Buffer.isBuffer(rd)) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a string, a buffer or array of string|buffer",
            `at index ${i},`,
            `got ${JSON.stringify(rd)}`
        ], options);
        else if (rd.length === 0) throw new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a non empty string or buffer",
            `at index ${i},`,
            `got ${JSON.stringify(rd)}`
        ], options);
        if (typeof rd === "string") rd = $9d52b1238665b2e8$require$Buffer.from(rd, options.encoding);
        return rd;
    });
    // Normalize option `relax_column_count`
    if (typeof options.relax_column_count === "boolean") ;
    else if (options.relax_column_count === undefined || options.relax_column_count === null) options.relax_column_count = false;
    else throw new Error(`Invalid Option: relax_column_count must be a boolean, got ${JSON.stringify(options.relax_column_count)}`);
    if (typeof options.relax_column_count_less === "boolean") ;
    else if (options.relax_column_count_less === undefined || options.relax_column_count_less === null) options.relax_column_count_less = false;
    else throw new Error(`Invalid Option: relax_column_count_less must be a boolean, got ${JSON.stringify(options.relax_column_count_less)}`);
    if (typeof options.relax_column_count_more === "boolean") ;
    else if (options.relax_column_count_more === undefined || options.relax_column_count_more === null) options.relax_column_count_more = false;
    else throw new Error(`Invalid Option: relax_column_count_more must be a boolean, got ${JSON.stringify(options.relax_column_count_more)}`);
    // Normalize option `relax_quotes`
    if (typeof options.relax_quotes === "boolean") ;
    else if (options.relax_quotes === undefined || options.relax_quotes === null) options.relax_quotes = false;
    else throw new Error(`Invalid Option: relax_quotes must be a boolean, got ${JSON.stringify(options.relax_quotes)}`);
    // Normalize option `skip_empty_lines`
    if (typeof options.skip_empty_lines === "boolean") ;
    else if (options.skip_empty_lines === undefined || options.skip_empty_lines === null) options.skip_empty_lines = false;
    else throw new Error(`Invalid Option: skip_empty_lines must be a boolean, got ${JSON.stringify(options.skip_empty_lines)}`);
    // Normalize option `skip_records_with_empty_values`
    if (typeof options.skip_records_with_empty_values === "boolean") ;
    else if (options.skip_records_with_empty_values === undefined || options.skip_records_with_empty_values === null) options.skip_records_with_empty_values = false;
    else throw new Error(`Invalid Option: skip_records_with_empty_values must be a boolean, got ${JSON.stringify(options.skip_records_with_empty_values)}`);
    // Normalize option `skip_records_with_error`
    if (typeof options.skip_records_with_error === "boolean") ;
    else if (options.skip_records_with_error === undefined || options.skip_records_with_error === null) options.skip_records_with_error = false;
    else throw new Error(`Invalid Option: skip_records_with_error must be a boolean, got ${JSON.stringify(options.skip_records_with_error)}`);
    // Normalize option `rtrim`
    if (options.rtrim === undefined || options.rtrim === null || options.rtrim === false) options.rtrim = false;
    else if (options.rtrim !== true) throw new Error(`Invalid Option: rtrim must be a boolean, got ${JSON.stringify(options.rtrim)}`);
    // Normalize option `ltrim`
    if (options.ltrim === undefined || options.ltrim === null || options.ltrim === false) options.ltrim = false;
    else if (options.ltrim !== true) throw new Error(`Invalid Option: ltrim must be a boolean, got ${JSON.stringify(options.ltrim)}`);
    // Normalize option `trim`
    if (options.trim === undefined || options.trim === null || options.trim === false) options.trim = false;
    else if (options.trim !== true) throw new Error(`Invalid Option: trim must be a boolean, got ${JSON.stringify(options.trim)}`);
    // Normalize options `trim`, `ltrim` and `rtrim`
    if (options.trim === true && opts.ltrim !== false) options.ltrim = true;
    else if (options.ltrim !== true) options.ltrim = false;
    if (options.trim === true && opts.rtrim !== false) options.rtrim = true;
    else if (options.rtrim !== true) options.rtrim = false;
    // Normalize option `to`
    if (options.to === undefined || options.to === null) options.to = -1;
    else {
        if (typeof options.to === "string" && /\d+/.test(options.to)) options.to = parseInt(options.to);
        if (Number.isInteger(options.to)) {
            if (options.to <= 0) throw new Error(`Invalid Option: to must be a positive integer greater than 0, got ${JSON.stringify(opts.to)}`);
        } else throw new Error(`Invalid Option: to must be an integer, got ${JSON.stringify(opts.to)}`);
    }
    // Normalize option `to_line`
    if (options.to_line === undefined || options.to_line === null) options.to_line = -1;
    else {
        if (typeof options.to_line === "string" && /\d+/.test(options.to_line)) options.to_line = parseInt(options.to_line);
        if (Number.isInteger(options.to_line)) {
            if (options.to_line <= 0) throw new Error(`Invalid Option: to_line must be a positive integer greater than 0, got ${JSON.stringify(opts.to_line)}`);
        } else throw new Error(`Invalid Option: to_line must be an integer, got ${JSON.stringify(opts.to_line)}`);
    }
    return options;
};




var $6ZWSX = parcelRequire("6ZWSX");
var $e66fc40b7d4ed295$require$Buffer = $6ZWSX.Buffer;
const $e66fc40b7d4ed295$var$isRecordEmpty = function(record) {
    return record.every((field)=>field == null || field.toString && field.toString().trim() === "");
};
const $e66fc40b7d4ed295$var$cr = 13; // `\r`, carriage return, 0x0D in hexadécimal, 13 in decimal
const $e66fc40b7d4ed295$var$nl = 10; // `\n`, newline, 0x0A in hexadecimal, 10 in decimal
const $e66fc40b7d4ed295$var$boms = {
    // Note, the following are equals:
    // Buffer.from("\ufeff")
    // Buffer.from([239, 187, 191])
    // Buffer.from('EFBBBF', 'hex')
    "utf8": $e66fc40b7d4ed295$require$Buffer.from([
        239,
        187,
        191
    ]),
    // Note, the following are equals:
    // Buffer.from "\ufeff", 'utf16le
    // Buffer.from([255, 254])
    "utf16le": $e66fc40b7d4ed295$require$Buffer.from([
        255,
        254
    ])
};
const $e66fc40b7d4ed295$export$51186ad6e864892a = function(original_options = {}) {
    const info = {
        bytes: 0,
        comment_lines: 0,
        empty_lines: 0,
        invalid_field_length: 0,
        lines: 1,
        records: 0
    };
    const options = (0, $9d52b1238665b2e8$export$ccfebcb248d28a57)(original_options);
    return {
        info: info,
        original_options: original_options,
        options: options,
        state: (0, $77128d227e7dc114$export$588199c25dc0cbed)(options),
        __needMoreData: function(i, bufLen, end) {
            if (end) return false;
            const { encoding: encoding, escape: escape, quote: quote } = this.options;
            const { quoting: quoting, needMoreDataSize: needMoreDataSize, recordDelimiterMaxLength: recordDelimiterMaxLength } = this.state;
            const numOfCharLeft = bufLen - i - 1;
            const requiredLength = Math.max(needMoreDataSize, // Skip if the remaining buffer smaller than record delimiter
            // If "record_delimiter" is yet to be discovered:
            // 1. It is equals to `[]` and "recordDelimiterMaxLength" equals `0`
            // 2. We set the length to windows line ending in the current encoding
            // Note, that encoding is known from user or bom discovery at that point
            // recordDelimiterMaxLength,
            recordDelimiterMaxLength === 0 ? $e66fc40b7d4ed295$require$Buffer.from("\r\n", encoding).length : recordDelimiterMaxLength, // Skip if remaining buffer can be an escaped quote
            quoting ? (escape === null ? 0 : escape.length) + quote.length : 0, // Skip if remaining buffer can be record delimiter following the closing quote
            quoting ? quote.length + recordDelimiterMaxLength : 0);
            return numOfCharLeft < requiredLength;
        },
        // Central parser implementation
        parse: function(nextBuf, end, push, close) {
            const { bom: bom, encoding: encoding, from_line: from_line, ltrim: ltrim, max_record_size: max_record_size, raw: raw, relax_quotes: relax_quotes, rtrim: rtrim, skip_empty_lines: skip_empty_lines, to: to, to_line: to_line } = this.options;
            let { comment: comment, escape: escape, quote: quote, record_delimiter: record_delimiter } = this.options;
            const { bomSkipped: bomSkipped, previousBuf: previousBuf, rawBuffer: rawBuffer, escapeIsQuote: escapeIsQuote } = this.state;
            let buf;
            if (previousBuf === undefined) {
                if (nextBuf === undefined) {
                    // Handle empty string
                    close();
                    return;
                } else buf = nextBuf;
            } else if (previousBuf !== undefined && nextBuf === undefined) buf = previousBuf;
            else buf = $e66fc40b7d4ed295$require$Buffer.concat([
                previousBuf,
                nextBuf
            ]);
            // Handle UTF BOM
            if (bomSkipped === false) {
                if (bom === false) this.state.bomSkipped = true;
                else if (buf.length < 3) // No enough data
                {
                    if (end === false) {
                        // Wait for more data
                        this.state.previousBuf = buf;
                        return;
                    }
                } else {
                    for(const encoding in $e66fc40b7d4ed295$var$boms)if ($e66fc40b7d4ed295$var$boms[encoding].compare(buf, 0, $e66fc40b7d4ed295$var$boms[encoding].length) === 0) {
                        // Skip BOM
                        const bomLength = $e66fc40b7d4ed295$var$boms[encoding].length;
                        this.state.bufBytesStart += bomLength;
                        buf = buf.slice(bomLength);
                        // Renormalize original options with the new encoding
                        this.options = (0, $9d52b1238665b2e8$export$ccfebcb248d28a57)({
                            ...this.original_options,
                            encoding: encoding
                        });
                        // Options will re-evaluate the Buffer with the new encoding
                        ({ comment: comment, escape: escape, quote: quote } = this.options);
                        break;
                    }
                    this.state.bomSkipped = true;
                }
            }
            const bufLen = buf.length;
            let pos;
            for(pos = 0; pos < bufLen; pos++){
                // Ensure we get enough space to look ahead
                // There should be a way to move this out of the loop
                if (this.__needMoreData(pos, bufLen, end)) break;
                if (this.state.wasRowDelimiter === true) {
                    this.info.lines++;
                    this.state.wasRowDelimiter = false;
                }
                if (to_line !== -1 && this.info.lines > to_line) {
                    this.state.stop = true;
                    close();
                    return;
                }
                // Auto discovery of record_delimiter, unix, mac and windows supported
                if (this.state.quoting === false && record_delimiter.length === 0) {
                    const record_delimiterCount = this.__autoDiscoverRecordDelimiter(buf, pos);
                    if (record_delimiterCount) record_delimiter = this.options.record_delimiter;
                }
                const chr = buf[pos];
                if (raw === true) rawBuffer.append(chr);
                if ((chr === $e66fc40b7d4ed295$var$cr || chr === $e66fc40b7d4ed295$var$nl) && this.state.wasRowDelimiter === false) this.state.wasRowDelimiter = true;
                // Previous char was a valid escape char
                // treat the current char as a regular char
                if (this.state.escaping === true) this.state.escaping = false;
                else {
                    // Escape is only active inside quoted fields
                    // We are quoting, the char is an escape chr and there is a chr to escape
                    // if(escape !== null && this.state.quoting === true && chr === escape && pos + 1 < bufLen){
                    if (escape !== null && this.state.quoting === true && this.__isEscape(buf, pos, chr) && pos + escape.length < bufLen) {
                        if (escapeIsQuote) {
                            if (this.__isQuote(buf, pos + escape.length)) {
                                this.state.escaping = true;
                                pos += escape.length - 1;
                                continue;
                            }
                        } else {
                            this.state.escaping = true;
                            pos += escape.length - 1;
                            continue;
                        }
                    }
                    // Not currently escaping and chr is a quote
                    // TODO: need to compare bytes instead of single char
                    if (this.state.commenting === false && this.__isQuote(buf, pos)) {
                        if (this.state.quoting === true) {
                            const nextChr = buf[pos + quote.length];
                            const isNextChrTrimable = rtrim && this.__isCharTrimable(buf, pos + quote.length);
                            const isNextChrComment = comment !== null && this.__compareBytes(comment, buf, pos + quote.length, nextChr);
                            const isNextChrDelimiter = this.__isDelimiter(buf, pos + quote.length, nextChr);
                            const isNextChrRecordDelimiter = record_delimiter.length === 0 ? this.__autoDiscoverRecordDelimiter(buf, pos + quote.length) : this.__isRecordDelimiter(nextChr, buf, pos + quote.length);
                            // Escape a quote
                            // Treat next char as a regular character
                            if (escape !== null && this.__isEscape(buf, pos, chr) && this.__isQuote(buf, pos + escape.length)) pos += escape.length - 1;
                            else if (!nextChr || isNextChrDelimiter || isNextChrRecordDelimiter || isNextChrComment || isNextChrTrimable) {
                                this.state.quoting = false;
                                this.state.wasQuoting = true;
                                pos += quote.length - 1;
                                continue;
                            } else if (relax_quotes === false) {
                                const err = this.__error(new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_CLOSING_QUOTE", [
                                    "Invalid Closing Quote:",
                                    `got "${String.fromCharCode(nextChr)}"`,
                                    `at line ${this.info.lines}`,
                                    "instead of delimiter, record delimiter, trimable character",
                                    "(if activated) or comment"
                                ], this.options, this.__infoField()));
                                if (err !== undefined) return err;
                            } else {
                                this.state.quoting = false;
                                this.state.wasQuoting = true;
                                this.state.field.prepend(quote);
                                pos += quote.length - 1;
                            }
                        } else {
                            if (this.state.field.length !== 0) // In relax_quotes mode, treat opening quote preceded by chrs as regular
                            {
                                if (relax_quotes === false) {
                                    const info = this.__infoField();
                                    const bom = Object.keys($e66fc40b7d4ed295$var$boms).map((b)=>$e66fc40b7d4ed295$var$boms[b].equals(this.state.field.toString()) ? b : false).filter(Boolean)[0];
                                    const err = this.__error(new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("INVALID_OPENING_QUOTE", [
                                        "Invalid Opening Quote:",
                                        `a quote is found on field ${JSON.stringify(info.column)} at line ${info.lines}, value is ${JSON.stringify(this.state.field.toString(encoding))}`,
                                        bom ? `(${bom} bom)` : undefined
                                    ], this.options, info, {
                                        field: this.state.field
                                    }));
                                    if (err !== undefined) return err;
                                }
                            } else {
                                this.state.quoting = true;
                                pos += quote.length - 1;
                                continue;
                            }
                        }
                    }
                    if (this.state.quoting === false) {
                        const recordDelimiterLength = this.__isRecordDelimiter(chr, buf, pos);
                        if (recordDelimiterLength !== 0) {
                            // Do not emit comments which take a full line
                            const skipCommentLine = this.state.commenting && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0;
                            if (skipCommentLine) this.info.comment_lines++;
                            else {
                                // Activate records emition if above from_line
                                if (this.state.enabled === false && this.info.lines + (this.state.wasRowDelimiter === true ? 1 : 0) >= from_line) {
                                    this.state.enabled = true;
                                    this.__resetField();
                                    this.__resetRecord();
                                    pos += recordDelimiterLength - 1;
                                    continue;
                                }
                                // Skip if line is empty and skip_empty_lines activated
                                if (skip_empty_lines === true && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0) {
                                    this.info.empty_lines++;
                                    pos += recordDelimiterLength - 1;
                                    continue;
                                }
                                this.info.bytes = this.state.bufBytesStart + pos;
                                const errField = this.__onField();
                                if (errField !== undefined) return errField;
                                this.info.bytes = this.state.bufBytesStart + pos + recordDelimiterLength;
                                const errRecord = this.__onRecord(push);
                                if (errRecord !== undefined) return errRecord;
                                if (to !== -1 && this.info.records >= to) {
                                    this.state.stop = true;
                                    close();
                                    return;
                                }
                            }
                            this.state.commenting = false;
                            pos += recordDelimiterLength - 1;
                            continue;
                        }
                        if (this.state.commenting) continue;
                        const commentCount = comment === null ? 0 : this.__compareBytes(comment, buf, pos, chr);
                        if (commentCount !== 0) {
                            this.state.commenting = true;
                            continue;
                        }
                        const delimiterLength = this.__isDelimiter(buf, pos, chr);
                        if (delimiterLength !== 0) {
                            this.info.bytes = this.state.bufBytesStart + pos;
                            const errField = this.__onField();
                            if (errField !== undefined) return errField;
                            pos += delimiterLength - 1;
                            continue;
                        }
                    }
                }
                if (this.state.commenting === false) {
                    if (max_record_size !== 0 && this.state.record_length + this.state.field.length > max_record_size) return this.__error(new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_MAX_RECORD_SIZE", [
                        "Max Record Size:",
                        "record exceed the maximum number of tolerated bytes",
                        `of ${max_record_size}`,
                        `at line ${this.info.lines}`
                    ], this.options, this.__infoField()));
                }
                const lappend = ltrim === false || this.state.quoting === true || this.state.field.length !== 0 || !this.__isCharTrimable(buf, pos);
                // rtrim in non quoting is handle in __onField
                const rappend = rtrim === false || this.state.wasQuoting === false;
                if (lappend === true && rappend === true) this.state.field.append(chr);
                else if (rtrim === true && !this.__isCharTrimable(buf, pos)) return this.__error(new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_NON_TRIMABLE_CHAR_AFTER_CLOSING_QUOTE", [
                    "Invalid Closing Quote:",
                    "found non trimable byte after quote",
                    `at line ${this.info.lines}`
                ], this.options, this.__infoField()));
                else {
                    if (lappend === false) pos += this.__isCharTrimable(buf, pos) - 1;
                    continue;
                }
            }
            if (end === true) {
                // Ensure we are not ending in a quoting state
                if (this.state.quoting === true) {
                    const err = this.__error(new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_QUOTE_NOT_CLOSED", [
                        "Quote Not Closed:",
                        `the parsing is finished with an opening quote at line ${this.info.lines}`
                    ], this.options, this.__infoField()));
                    if (err !== undefined) return err;
                } else {
                    // Skip last line if it has no characters
                    if (this.state.wasQuoting === true || this.state.record.length !== 0 || this.state.field.length !== 0) {
                        this.info.bytes = this.state.bufBytesStart + pos;
                        const errField = this.__onField();
                        if (errField !== undefined) return errField;
                        const errRecord = this.__onRecord(push);
                        if (errRecord !== undefined) return errRecord;
                    } else if (this.state.wasRowDelimiter === true) this.info.empty_lines++;
                    else if (this.state.commenting === true) this.info.comment_lines++;
                }
            } else {
                this.state.bufBytesStart += pos;
                this.state.previousBuf = buf.slice(pos);
            }
            if (this.state.wasRowDelimiter === true) {
                this.info.lines++;
                this.state.wasRowDelimiter = false;
            }
        },
        __onRecord: function(push) {
            const { columns: columns, group_columns_by_name: group_columns_by_name, encoding: encoding, info: info, from: from, relax_column_count: relax_column_count, relax_column_count_less: relax_column_count_less, relax_column_count_more: relax_column_count_more, raw: raw, skip_records_with_empty_values: skip_records_with_empty_values } = this.options;
            const { enabled: enabled, record: record } = this.state;
            if (enabled === false) return this.__resetRecord();
            // Convert the first line into column names
            const recordLength = record.length;
            if (columns === true) {
                if (skip_records_with_empty_values === true && $e66fc40b7d4ed295$var$isRecordEmpty(record)) {
                    this.__resetRecord();
                    return;
                }
                return this.__firstLineToColumns(record);
            }
            if (columns === false && this.info.records === 0) this.state.expectedRecordLength = recordLength;
            if (recordLength !== this.state.expectedRecordLength) {
                const err = columns === false ? new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_RECORD_INCONSISTENT_FIELDS_LENGTH", [
                    "Invalid Record Length:",
                    `expect ${this.state.expectedRecordLength},`,
                    `got ${recordLength} on line ${this.info.lines}`
                ], this.options, this.__infoField(), {
                    record: record
                }) : new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_RECORD_INCONSISTENT_COLUMNS", [
                    "Invalid Record Length:",
                    `columns length is ${columns.length},`,
                    `got ${recordLength} on line ${this.info.lines}`
                ], this.options, this.__infoField(), {
                    record: record
                });
                if (relax_column_count === true || relax_column_count_less === true && recordLength < this.state.expectedRecordLength || relax_column_count_more === true && recordLength > this.state.expectedRecordLength) {
                    this.info.invalid_field_length++;
                    this.state.error = err;
                // Error is undefined with skip_records_with_error
                } else {
                    const finalErr = this.__error(err);
                    if (finalErr) return finalErr;
                }
            }
            if (skip_records_with_empty_values === true && $e66fc40b7d4ed295$var$isRecordEmpty(record)) {
                this.__resetRecord();
                return;
            }
            if (this.state.recordHasError === true) {
                this.__resetRecord();
                this.state.recordHasError = false;
                return;
            }
            this.info.records++;
            if (from === 1 || this.info.records >= from) {
                const { objname: objname } = this.options;
                // With columns, records are object
                if (columns !== false) {
                    const obj = {};
                    // Transform record array to an object
                    for(let i = 0, l = record.length; i < l; i++){
                        if (columns[i] === undefined || columns[i].disabled) continue;
                        // Turn duplicate columns into an array
                        if (group_columns_by_name === true && obj[columns[i].name] !== undefined) {
                            if (Array.isArray(obj[columns[i].name])) obj[columns[i].name] = obj[columns[i].name].concat(record[i]);
                            else obj[columns[i].name] = [
                                obj[columns[i].name],
                                record[i]
                            ];
                        } else obj[columns[i].name] = record[i];
                    }
                    // Without objname (default)
                    if (raw === true || info === true) {
                        const extRecord = Object.assign({
                            record: obj
                        }, raw === true ? {
                            raw: this.state.rawBuffer.toString(encoding)
                        } : {}, info === true ? {
                            info: this.__infoRecord()
                        } : {});
                        const err = this.__push(objname === undefined ? extRecord : [
                            obj[objname],
                            extRecord
                        ], push);
                        if (err) return err;
                    } else {
                        const err = this.__push(objname === undefined ? obj : [
                            obj[objname],
                            obj
                        ], push);
                        if (err) return err;
                    }
                // Without columns, records are array
                } else if (raw === true || info === true) {
                    const extRecord = Object.assign({
                        record: record
                    }, raw === true ? {
                        raw: this.state.rawBuffer.toString(encoding)
                    } : {}, info === true ? {
                        info: this.__infoRecord()
                    } : {});
                    const err = this.__push(objname === undefined ? extRecord : [
                        record[objname],
                        extRecord
                    ], push);
                    if (err) return err;
                } else {
                    const err = this.__push(objname === undefined ? record : [
                        record[objname],
                        record
                    ], push);
                    if (err) return err;
                }
            }
            this.__resetRecord();
        },
        __firstLineToColumns: function(record) {
            const { firstLineToHeaders: firstLineToHeaders } = this.state;
            try {
                const headers = firstLineToHeaders === undefined ? record : firstLineToHeaders.call(null, record);
                if (!Array.isArray(headers)) return this.__error(new (0, $1f686b51e97e797f$export$d9d08b09962b4c23)("CSV_INVALID_COLUMN_MAPPING", [
                    "Invalid Column Mapping:",
                    "expect an array from column function,",
                    `got ${JSON.stringify(headers)}`
                ], this.options, this.__infoField(), {
                    headers: headers
                }));
                const normalizedHeaders = (0, $256251f253ac874e$export$46bd8faf65ac9e2)(headers);
                this.state.expectedRecordLength = normalizedHeaders.length;
                this.options.columns = normalizedHeaders;
                this.__resetRecord();
                return;
            } catch (err) {
                return err;
            }
        },
        __resetRecord: function() {
            if (this.options.raw === true) this.state.rawBuffer.reset();
            this.state.error = undefined;
            this.state.record = [];
            this.state.record_length = 0;
        },
        __onField: function() {
            const { cast: cast, encoding: encoding, rtrim: rtrim, max_record_size: max_record_size } = this.options;
            const { enabled: enabled, wasQuoting: wasQuoting } = this.state;
            // Short circuit for the from_line options
            if (enabled === false) return this.__resetField();
            let field = this.state.field.toString(encoding);
            if (rtrim === true && wasQuoting === false) field = field.trimRight();
            if (cast === true) {
                const [err, f] = this.__cast(field);
                if (err !== undefined) return err;
                field = f;
            }
            this.state.record.push(field);
            // Increment record length if record size must not exceed a limit
            if (max_record_size !== 0 && typeof field === "string") this.state.record_length += field.length;
            this.__resetField();
        },
        __resetField: function() {
            this.state.field.reset();
            this.state.wasQuoting = false;
        },
        __push: function(record, push) {
            const { on_record: on_record } = this.options;
            if (on_record !== undefined) {
                const info = this.__infoRecord();
                try {
                    record = on_record.call(null, record, info);
                } catch (err) {
                    return err;
                }
                if (record === undefined || record === null) return;
            }
            push(record);
        },
        // Return a tuple with the error and the casted value
        __cast: function(field) {
            const { columns: columns, relax_column_count: relax_column_count } = this.options;
            const isColumns = Array.isArray(columns);
            // Dont loose time calling cast
            // because the final record is an object
            // and this field can't be associated to a key present in columns
            if (isColumns === true && relax_column_count && this.options.columns.length <= this.state.record.length) return [
                undefined,
                undefined
            ];
            if (this.state.castField !== null) try {
                const info = this.__infoField();
                return [
                    undefined,
                    this.state.castField.call(null, field, info)
                ];
            } catch (err) {
                return [
                    err
                ];
            }
            if (this.__isFloat(field)) return [
                undefined,
                parseFloat(field)
            ];
            else if (this.options.cast_date !== false) {
                const info = this.__infoField();
                return [
                    undefined,
                    this.options.cast_date.call(null, field, info)
                ];
            }
            return [
                undefined,
                field
            ];
        },
        // Helper to test if a character is a space or a line delimiter
        __isCharTrimable: function(buf, pos) {
            const isTrim = (buf, pos)=>{
                const { timchars: timchars } = this.state;
                loop1: for(let i = 0; i < timchars.length; i++){
                    const timchar = timchars[i];
                    for(let j = 0; j < timchar.length; j++){
                        if (timchar[j] !== buf[pos + j]) continue loop1;
                    }
                    return timchar.length;
                }
                return 0;
            };
            return isTrim(buf, pos);
        },
        // Keep it in case we implement the `cast_int` option
        // __isInt(value){
        //   // return Number.isInteger(parseInt(value))
        //   // return !isNaN( parseInt( obj ) );
        //   return /^(\-|\+)?[1-9][0-9]*$/.test(value)
        // }
        __isFloat: function(value) {
            return value - parseFloat(value) + 1 >= 0; // Borrowed from jquery
        },
        __compareBytes: function(sourceBuf, targetBuf, targetPos, firstByte) {
            if (sourceBuf[0] !== firstByte) return 0;
            const sourceLength = sourceBuf.length;
            for(let i = 1; i < sourceLength; i++){
                if (sourceBuf[i] !== targetBuf[targetPos + i]) return 0;
            }
            return sourceLength;
        },
        __isDelimiter: function(buf, pos, chr) {
            const { delimiter: delimiter, ignore_last_delimiters: ignore_last_delimiters } = this.options;
            if (ignore_last_delimiters === true && this.state.record.length === this.options.columns.length - 1) return 0;
            else if (ignore_last_delimiters !== false && typeof ignore_last_delimiters === "number" && this.state.record.length === ignore_last_delimiters - 1) return 0;
            loop1: for(let i = 0; i < delimiter.length; i++){
                const del = delimiter[i];
                if (del[0] === chr) {
                    for(let j = 1; j < del.length; j++){
                        if (del[j] !== buf[pos + j]) continue loop1;
                    }
                    return del.length;
                }
            }
            return 0;
        },
        __isRecordDelimiter: function(chr, buf, pos) {
            const { record_delimiter: record_delimiter } = this.options;
            const recordDelimiterLength = record_delimiter.length;
            loop1: for(let i = 0; i < recordDelimiterLength; i++){
                const rd = record_delimiter[i];
                const rdLength = rd.length;
                if (rd[0] !== chr) continue;
                for(let j = 1; j < rdLength; j++){
                    if (rd[j] !== buf[pos + j]) continue loop1;
                }
                return rd.length;
            }
            return 0;
        },
        __isEscape: function(buf, pos, chr) {
            const { escape: escape } = this.options;
            if (escape === null) return false;
            const l = escape.length;
            if (escape[0] === chr) {
                for(let i = 0; i < l; i++){
                    if (escape[i] !== buf[pos + i]) return false;
                }
                return true;
            }
            return false;
        },
        __isQuote: function(buf, pos) {
            const { quote: quote } = this.options;
            if (quote === null) return false;
            const l = quote.length;
            for(let i = 0; i < l; i++){
                if (quote[i] !== buf[pos + i]) return false;
            }
            return true;
        },
        __autoDiscoverRecordDelimiter: function(buf, pos) {
            const { encoding: encoding } = this.options;
            // Note, we don't need to cache this information in state,
            // It is only called on the first line until we find out a suitable
            // record delimiter.
            const rds = [
                // Important, the windows line ending must be before mac os 9
                $e66fc40b7d4ed295$require$Buffer.from("\r\n", encoding),
                $e66fc40b7d4ed295$require$Buffer.from("\n", encoding),
                $e66fc40b7d4ed295$require$Buffer.from("\r", encoding)
            ];
            loop: for(let i = 0; i < rds.length; i++){
                const l = rds[i].length;
                for(let j = 0; j < l; j++){
                    if (rds[i][j] !== buf[pos + j]) continue loop;
                }
                this.options.record_delimiter.push(rds[i]);
                this.state.recordDelimiterMaxLength = rds[i].length;
                return rds[i].length;
            }
            return 0;
        },
        __error: function(msg) {
            const { encoding: encoding, raw: raw, skip_records_with_error: skip_records_with_error } = this.options;
            const err = typeof msg === "string" ? new Error(msg) : msg;
            if (skip_records_with_error) {
                this.state.recordHasError = true;
                if (this.options.on_skip !== undefined) this.options.on_skip(err, raw ? this.state.rawBuffer.toString(encoding) : undefined);
                // this.emit('skip', err, raw ? this.state.rawBuffer.toString(encoding) : undefined);
                return undefined;
            } else return err;
        },
        __infoDataSet: function() {
            return {
                ...this.info,
                columns: this.options.columns
            };
        },
        __infoRecord: function() {
            const { columns: columns, raw: raw, encoding: encoding } = this.options;
            return {
                ...this.__infoDataSet(),
                error: this.state.error,
                header: columns === true,
                index: this.state.record.length,
                raw: raw ? this.state.rawBuffer.toString(encoding) : undefined
            };
        },
        __infoField: function() {
            const { columns: columns } = this.options;
            const isColumns = Array.isArray(columns);
            return {
                ...this.__infoRecord(),
                column: isColumns === true ? columns.length > this.state.record.length ? columns[this.state.record.length].name : null : this.state.record.length,
                quoting: this.state.wasQuoting
            };
        }
    };
};



var $6ZWSX = parcelRequire("6ZWSX");
var $9a5cc928091c4c46$require$Buffer = $6ZWSX.Buffer;
const $9a5cc928091c4c46$export$98e6a39c04603d36 = function(data, opts = {}) {
    if (typeof data === "string") data = $9a5cc928091c4c46$require$Buffer.from(data);
    const records = opts && opts.objname ? {} : [];
    const parser = (0, $e66fc40b7d4ed295$export$51186ad6e864892a)(opts);
    const push = (record)=>{
        if (parser.options.objname === undefined) records.push(record);
        else records[record[0]] = record[1];
    };
    const close = ()=>{};
    const err1 = parser.parse(data, false, push, close);
    if (err1 !== undefined) throw err1;
    const err2 = parser.parse(undefined, true, push, close);
    if (err2 !== undefined) throw err2;
    return records;
};



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $63af748d0fde9ea7$var$extendStatics = function(d, b) {
    $63af748d0fde9ea7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $63af748d0fde9ea7$var$extendStatics(d, b);
};
function $63af748d0fde9ea7$export$a8ba968b8961cb8a(d, b) {
    $63af748d0fde9ea7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $63af748d0fde9ea7$export$18ce0697a983be9b = function() {
    $63af748d0fde9ea7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63af748d0fde9ea7$export$18ce0697a983be9b.apply(this, arguments);
};
function $63af748d0fde9ea7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $63af748d0fde9ea7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $63af748d0fde9ea7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $63af748d0fde9ea7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $63af748d0fde9ea7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $63af748d0fde9ea7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $63af748d0fde9ea7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $63af748d0fde9ea7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $63af748d0fde9ea7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $63af748d0fde9ea7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $63af748d0fde9ea7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($63af748d0fde9ea7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $63af748d0fde9ea7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $63af748d0fde9ea7$export$10c90e4f7922046c(v) {
    return this instanceof $63af748d0fde9ea7$export$10c90e4f7922046c ? (this.v = v, this) : new $63af748d0fde9ea7$export$10c90e4f7922046c(v);
}
function $63af748d0fde9ea7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $63af748d0fde9ea7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $63af748d0fde9ea7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $63af748d0fde9ea7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $63af748d0fde9ea7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $63af748d0fde9ea7$export$19a8beecd37a4c45 === "function" ? $63af748d0fde9ea7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $63af748d0fde9ea7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $63af748d0fde9ea7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $63af748d0fde9ea7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $63af748d0fde9ea7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $63af748d0fde9ea7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $dac22b55eb23ffcc$export$db0345794bfc14ed = new Map([
    [
        "avi",
        "video/avi"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "ico",
        "image/x-icon"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ]
]);
function $dac22b55eb23ffcc$export$8cc09085015f0dc7(file, path) {
    var f = $dac22b55eb23ffcc$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $dac22b55eb23ffcc$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $dac22b55eb23ffcc$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $7ac450b547cb7da9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $7ac450b547cb7da9$export$a36e16046ae8f1bb(evt) {
    return $63af748d0fde9ea7$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $63af748d0fde9ea7$export$67ebef60e6f28a6(this, function(_a) {
            return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$isDragEvt(evt) && evt.dataTransfer ? $7ac450b547cb7da9$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $7ac450b547cb7da9$var$getInputFiles(evt)
            ];
        });
    });
}
function $7ac450b547cb7da9$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $7ac450b547cb7da9$var$getInputFiles(evt) {
    var files = $7ac450b547cb7da9$var$isInput(evt.target) ? evt.target.files ? $7ac450b547cb7da9$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    });
}
function $7ac450b547cb7da9$var$isInput(value) {
    return value !== null;
}
function $7ac450b547cb7da9$var$getDataTransferFiles(dt, type) {
    return $63af748d0fde9ea7$export$1050f835b63b671e(this, void 0, void 0, function() {
        var items, files;
        return $63af748d0fde9ea7$export$67ebef60e6f28a6(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7ac450b547cb7da9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7ac450b547cb7da9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$fromList(dt.files).map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7ac450b547cb7da9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7ac450b547cb7da9$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7ac450b547cb7da9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $7ac450b547cb7da9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7ac450b547cb7da9$var$fromDirEntry(entry);
    return $7ac450b547cb7da9$var$fromDataTransferItem(item);
}
function $7ac450b547cb7da9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return $63af748d0fde9ea7$export$afc72e2116322959(acc, Array.isArray(files) ? $7ac450b547cb7da9$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $7ac450b547cb7da9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7ac450b547cb7da9$var$fromEntry(entry) {
    return $63af748d0fde9ea7$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $63af748d0fde9ea7$export$67ebef60e6f28a6(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7ac450b547cb7da9$var$fromDirEntry(entry) : $7ac450b547cb7da9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7ac450b547cb7da9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return $63af748d0fde9ea7$export$1050f835b63b671e(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return $63af748d0fde9ea7$export$67ebef60e6f28a6(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7ac450b547cb7da9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7ac450b547cb7da9$var$fromFileEntry(entry) {
    return $63af748d0fde9ea7$export$1050f835b63b671e(this, void 0, void 0, function() {
        return $63af748d0fde9ea7$export$67ebef60e6f28a6(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $6e084c16e19f3cbf$exports = {};
$6e084c16e19f3cbf$exports = function(e) {
    function r(n) {
        if (t[n]) return t[n].exports;
        var o = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    var t = {};
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: n
        });
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
    }, r.p = "", r(r.s = 0);
}([
    function(e, r, t) {
        "use strict";
        r.__esModule = !0, r.default = function(e, r) {
            if (e && r) {
                var t = Array.isArray(r) ? r : r.split(","), n = e.name || "", o = e.type || "", u = o.replace(/\/.*$/, "");
                return t.some(function(e) {
                    var r = e.trim();
                    return "." === r.charAt(0) ? n.toLowerCase().endsWith(r.toLowerCase()) : r.endsWith("/*") ? u === r.replace(/\/.*$/, "") : o === r;
                });
            }
            return !0;
        };
    }
]);


function $aaac53b849ab07d4$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $aaac53b849ab07d4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $aaac53b849ab07d4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files"; // File Errors
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, (/*@__PURE__*/$parcel$interopDefault($6e084c16e19f3cbf$exports)))(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple;
    if (!multiple && files.length > 1) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        return accepted && sizeMatch;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}


function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a24044586ed82795$var$ownKeys(source, true).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a24044586ed82795$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, [
        "open"
    ]);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread({}, props, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone";
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, accept = _ref2.accept, _ref2$disabled = _ref2.disabled, disabled = _ref2$disabled === void 0 ? false : _ref2$disabled, _ref2$getFilesFromEve = _ref2.getFilesFromEvent, getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? (0, $7ac450b547cb7da9$export$a36e16046ae8f1bb) : _ref2$getFilesFromEve, _ref2$maxSize = _ref2.maxSize, maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize, _ref2$minSize = _ref2.minSize, minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize, _ref2$multiple = _ref2.multiple, multiple = _ref2$multiple === void 0 ? true : _ref2$multiple, onDragEnter = _ref2.onDragEnter, onDragLeave = _ref2.onDragLeave, onDragOver = _ref2.onDragOver, onDrop = _ref2.onDrop, onDropAccepted = _ref2.onDropAccepted, onDropRejected = _ref2.onDropRejected, onFileDialogCancel = _ref2.onFileDialogCancel, _ref2$preventDropOnDo = _ref2.preventDropOnDocument, preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo, _ref2$noClick = _ref2.noClick, noClick = _ref2$noClick === void 0 ? false : _ref2$noClick, _ref2$noKeyboard = _ref2.noKeyboard, noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard, _ref2$noDrag = _ref2.noDrag, noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag, _ref2$noDragEventsBub = _ref2.noDragEventsBubbling, noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;
    var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch
    ]); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    if (typeof onFileDialogCancel === "function") onFileDialogCancel();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancel
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        inputRef
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        inputRef,
        noClick
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        if (event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: "setDraggedFiles",
            draggedFiles: []
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var acceptedFiles = [];
            var fileRejections = [];
            files.forEach(function(file) {
                var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, accept), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
                var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
                if (accepted && sizeMatch) acceptedFiles.push(file);
                else {
                    var errors = [
                        acceptError,
                        sizeError
                    ].filter(function(e) {
                        return e;
                    });
                    fileRejections.push({
                        file: file,
                        errors: errors
                    });
                }
            });
            if (!multiple && acceptedFiles.length > 1) {
                // Reject everything and empty accepted files
                acceptedFiles.forEach(function(file) {
                    fileRejections.push({
                        file: file,
                        errors: [
                            (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                        ]
                    });
                });
                acceptedFiles.splice(0);
            }
            dispatch({
                acceptedFiles: acceptedFiles,
                fileRejections: fileRejections,
                type: "setFiles"
            });
            if (onDrop) onDrop(acceptedFiles, fileRejections, event);
            if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
            if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
        });
        dispatch({
            type: "reset"
        });
    }, [
        multiple,
        accept,
        minSize,
        maxSize,
        getFilesFromEvent,
        onDrop,
        onDropAccepted,
        onDropRejected,
        noDragEventsBubbling
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onKeyDown = _ref3.onKeyDown, onFocus = _ref3.onFocus, onBlur = _ref3.onBlur, onClick = _ref3.onClick, onDragEnter = _ref3.onDragEnter, onDragOver = _ref3.onDragOver, onDragLeave = _ref3.onDragLeave, onDrop = _ref3.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, [
                "refKey",
                "onKeyDown",
                "onFocus",
                "onBlur",
                "onClick",
                "onDragEnter",
                "onDragOver",
                "onDragLeave",
                "onDrop"
            ]);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb))
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}, {}, rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey, onChange = _ref4.onChange, onClick = _ref4.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref4, [
                "refKey",
                "onChange",
                "onClick"
            ]);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                autoComplete: "off",
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread({}, inputProps, {}, rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
        files: draggedFiles,
        accept: accept,
        minSize: minSize,
        maxSize: maxSize,
        multiple: multiple
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return $a24044586ed82795$var$_objectSpread({}, state, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread({}, state, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread({}, state, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread({}, state, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread({}, state, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $a24044586ed82795$var$_objectSpread({}, state, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread({}, state, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, state, {
                isFileDialogActive: false,
                isDragActive: false,
                draggedFiles: [],
                acceptedFiles: [],
                fileRejections: []
            });
        default:
            return state;
    }
}



const $880d05f11d0a3304$var$getColor = (props)=>{
    if (props.isDragAccept) return "#00e676";
    if (props.isDragReject) return "#ff1744";
    if (props.isDragActive) return "#2196f3";
    return "#eeeeee";
};
const $880d05f11d0a3304$var$Container = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props)=>$880d05f11d0a3304$var$getColor(props)};
  border-style: dashed;
  box-sizing: border-box;
  color: ${(props)=>props.theme.palette.text.primary};
  outline: none;
  transition: border 0.24s ease-in-out;
`;
function $880d05f11d0a3304$export$2e2bcd8739ae039({ onFileDrop: onFileDrop, text: text = "Drag and drop your mission file here" }) {
    const onDrop = $acw62.useCallback((acceptedFiles)=>{
        // TODO this fires twice: https://stackoverflow.com/questions/48610679/react-dropzone-ondrop-firing-twice
        onFileDrop(acceptedFiles);
    }, [
        onFileDrop
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive, isDragAccept: isDragAccept, isDragReject: isDragReject } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        onDrop: onDrop
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($880d05f11d0a3304$var$Container, {
            ...getRootProps({
                isDragActive: isDragActive,
                isDragAccept: isDragAccept,
                isDragReject: isDragReject
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    ...getInputProps()
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: text
                })
            ]
        })
    });
}





const $2ff48a27fd577971$var$numbers = [
    "lat",
    "lon",
    "x",
    "y",
    "z"
];
function $2ff48a27fd577971$var$AirbaseData({ className: className }) {
    const [result, setResult] = $acw62.useState(null);
    const handleDrop = async (files)=>{
        const file = files[0];
        const d = await file.text();
        const result = (0, $9a5cc928091c4c46$export$98e6a39c04603d36)(d, {
            columns: true
        });
        const keyed = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keyBy(result, "id");
        // Uppercase each key
        const out = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reduce(keyed, (acc, value, idx)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(value, (v, k)=>{
                if (k === "displayName") k = "name";
                let val;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes($2ff48a27fd577971$var$numbers, k)) val = parseFloat(v);
                else val = v;
                (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).set(acc, [
                    idx,
                    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(k)
                ], val);
            });
            return acc;
        }, {});
        setResult(out);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
            title: "Airbase Data",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "Upload airbase data files"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $880d05f11d0a3304$export$2e2bcd8739ae039), {
                    onFileDrop: handleDrop
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                        children: result && JSON.stringify(result, null, 2)
                    })
                })
            ]
        })
    });
}
var $2ff48a27fd577971$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($2ff48a27fd577971$var$AirbaseData).attrs({
    className: $2ff48a27fd577971$var$AirbaseData.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");


var $jTnBY = parcelRequire("jTnBY");
var $acw62 = parcelRequire("acw62");
let $f649782d844a38be$var$globalId = 0;
function $f649782d844a38be$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $f649782d844a38be$var$globalId += 1;
            setDefaultId(`mui-${$f649782d844a38be$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $f649782d844a38be$var$maybeReactUseId = $acw62.useId;
function $f649782d844a38be$export$2e2bcd8739ae039(idOverride) {
    if ($f649782d844a38be$var$maybeReactUseId !== undefined) {
        const reactId = $f649782d844a38be$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    } // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $f649782d844a38be$var$useGlobalId(idOverride);
}


var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $f649782d844a38be$export$2e2bcd8739ae039);



var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $3d9daf67b816649a$export$24fdd7c0683a4fed(slot) {
    return (0, $9XEW1.default)("MuiLoadingButton", slot);
}
const $3d9daf67b816649a$var$loadingButtonClasses = (0, $7u6PA.default)("MuiLoadingButton", [
    "root",
    "loading",
    "loadingIndicator",
    "loadingIndicatorCenter",
    "loadingIndicatorStart",
    "loadingIndicatorEnd",
    "endIconLoadingEnd",
    "startIconLoadingStart"
]);
var $3d9daf67b816649a$export$2e2bcd8739ae039 = $3d9daf67b816649a$var$loadingButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $6139cb5be32bc930$var$_excluded = [
    "children",
    "disabled",
    "id",
    "loading",
    "loadingIndicator",
    "loadingPosition",
    "variant"
];
const $6139cb5be32bc930$var$useUtilityClasses = (ownerState)=>{
    const { loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            loading && "loading"
        ],
        startIcon: [
            loading && `startIconLoading${(0, $jTnBY.default)(loadingPosition)}`
        ],
        endIcon: [
            loading && `endIconLoading${(0, $jTnBY.default)(loadingPosition)}`
        ],
        loadingIndicator: [
            "loadingIndicator",
            loading && `loadingIndicator${(0, $jTnBY.default)(loadingPosition)}`
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $3d9daf67b816649a$export$24fdd7c0683a4fed), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
}; // TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const $6139cb5be32bc930$var$rootShouldForwardProp = (prop)=>prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as" && prop !== "classes";
const $6139cb5be32bc930$var$LoadingButtonRoot = (0, $d8seH.default)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>$6139cb5be32bc930$var$rootShouldForwardProp(prop) || prop === "classes",
    name: "MuiLoadingButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            styles.root,
            styles.startIconLoadingStart && {
                [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}`]: styles.startIconLoadingStart
            },
            styles.endIconLoadingEnd && {
                [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: styles.endIconLoadingEnd
            }
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0
        }
    }, ownerState.loadingPosition === "center" && {
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        [`&.${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).loading}`]: {
            color: "transparent"
        }
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginRight: -8
        }
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        [`& .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $3d9daf67b816649a$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginLeft: -8
        }
    }));
const $6139cb5be32bc930$var$LoadingButtonLoadingIndicator = (0, $d8seH.default)("div", {
    name: "MuiLoadingButton",
    slot: "LoadingIndicator",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.loadingIndicator,
            styles[`loadingIndicator${(0, $jTnBY.default)(ownerState.loadingPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: "absolute",
        visibility: "visible",
        display: "flex"
    }, ownerState.loadingPosition === "start" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        left: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "start" && ownerState.variant === "text" && {
        left: 6
    }, ownerState.loadingPosition === "center" && {
        left: "50%",
        transform: "translate(-50%)",
        color: theme.palette.action.disabled
    }, ownerState.loadingPosition === "end" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        right: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "end" && ownerState.variant === "text" && {
        right: 6
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        position: "relative",
        left: -10
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        position: "relative",
        right: -10
    }));
const $6139cb5be32bc930$var$LoadingButton = /*#__PURE__*/ $acw62.forwardRef(function LoadingButton(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiLoadingButton"
    });
    const { children: children, disabled: disabled = false, id: idProp, loading: loading = false, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = "center", variant: variant = "text" } = props, other = (0, $1En50.default)(props, $6139cb5be32bc930$var$_excluded);
    const id = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
        "aria-labelledby": id,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        variant: variant
    });
    const classes = $6139cb5be32bc930$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6139cb5be32bc930$var$LoadingButtonRoot, (0, $8nd05.default)({
        disabled: disabled || loading,
        id: id,
        ref: ref
    }, other, {
        variant: variant,
        classes: classes,
        ownerState: ownerState,
        children: ownerState.loadingPosition === "end" ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                children,
                loading && /*#__PURE__*/ (0, $ayMG0.jsx)($6139cb5be32bc930$var$LoadingButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loadingIndicator
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                loading && /*#__PURE__*/ (0, $ayMG0.jsx)($6139cb5be32bc930$var$LoadingButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loadingIndicator
                }),
                children
            ]
        })
    }));
});
var $6139cb5be32bc930$export$2e2bcd8739ae039 = $6139cb5be32bc930$var$LoadingButton;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $9XEW1.default)("MuiFormGroup", slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $7u6PA.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext();
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;


function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $8426ae8303951a73$export$2e2bcd8739ae039));
}


function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $ayMG0 = parcelRequire("ayMG0");
const $5042f159189dda87$var$_excluded = [
    "className",
    "row"
];
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $9971e.default)(slots, (0, $de580948e3d734b1$export$d72d4cbdc30b331f), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $1En50.default)(props, $5042f159189dda87$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;



var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $9XEW1.default)("MuiTable", slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $7u6PA.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $22fefd5f207422b3$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $9971e.default)(slots, (0, $3e2d01fd3f88b8c8$export$315cb19215f77ce0), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $8nd05.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: theme.palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $22fefd5f207422b3$var$defaultComponent = "table";
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $1En50.default)(props, $22fefd5f207422b3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e848e543ed3bf349$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, (0, $8nd05.default)({
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $1SA7b.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;



var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $9XEW1.default)("MuiTableBody", slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $7u6PA.default)("MuiTableBody", [
    "root"
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $09d8a23708c3ccc9$var$_excluded = [
    "className",
    "component"
];
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9971e.default)(slots, (0, $9a6742b7048414d1$export$98bd2a9b566ec665), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: "body"
};
const $09d8a23708c3ccc9$var$defaultComponent = "tbody";
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent } = props, other = (0, $1En50.default)(props, $09d8a23708c3ccc9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, (0, $8nd05.default)({
            className: (0, $1SA7b.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $jTnBY = parcelRequire("jTnBY");



var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $9XEW1.default)("MuiTableCell", slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $7u6PA.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $a71dfe9e22152ea2$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $jTnBY.default)(align)}`,
            padding !== "normal" && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: `1px solid
    ${theme.palette.mode === "light" ? (0, $kyRHb.lighten)((0, $kyRHb.alpha)(theme.palette.divider, 1), 0.88) : (0, $kyRHb.darken)((0, $kyRHb.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: theme.palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: theme.palette.text.primary
    }, ownerState.variant === "footer" && {
        color: theme.palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $a8eb3ce62ab46dc7$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: theme.palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1En50.default)(props, $a71dfe9e22152ea2$var$_excluded);
    const table = $acw62.useContext((0, $e848e543ed3bf349$export$2e2bcd8739ae039));
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $9XEW1.default)("MuiTableHead", slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $7u6PA.default)("MuiTableHead", [
    "root"
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $c9c28a8e795911dc$var$_excluded = [
    "className",
    "component"
];
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9971e.default)(slots, (0, $cf1017f12785ebe4$export$2e731cea2d1c2392), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: "head"
};
const $c9c28a8e795911dc$var$defaultComponent = "thead";
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent } = props, other = (0, $1En50.default)(props, $c9c28a8e795911dc$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");


var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $9XEW1.default)("MuiTableRow", slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $7u6PA.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $22705465ad6920f8$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $9971e.default)(slots, (0, $321d86e199abda5b$export$ba0a6d6c28940107), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: theme.palette.action.hover
        },
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $22705465ad6920f8$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $1En50.default)(props, $22705465ad6920f8$var$_excluded);
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;



var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");


const $67963b09fdec1ded$var$EmptyRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $22705465ad6920f8$export$2e2bcd8739ae039))`
  td {
    text-align: center;
  }
`;
function $67963b09fdec1ded$var$DataTable({ columns: columns, rows: rows, className: className, selectedRow: selectedRow, emptyMessage: emptyMessage = "No Data", edit: edit, editingRows: editingRows, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
        ...rest,
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(columns, (c, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                            style: c.style?.th,
                            scope: "col",
                            width: c.width,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: c.label
                            })
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                children: rows?.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rows, (r, rowNum)=>{
                    const isEditing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(editingRows, rowNum);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                        className: selectedRow === rowNum ? "row-selected" : "",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(columns, (c, colNum)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                style: c.style?.td,
                                scope: "row",
                                width: c.width,
                                children: [
                                    isEditing && edit && typeof edit === "function" ? ()=>edit(r, rowNum) : null,
                                    !isEditing && typeof c.value === "function" ? c.value(r, colNum, rowNum) : r[c.value]
                                ]
                            }, colNum))
                    }, rowNum);
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($67963b09fdec1ded$var$EmptyRow, {
                    colSpan: columns.length,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                        colSpan: columns.length,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            center: true,
                            align: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                fontStyle: "italic",
                                style: {
                                    color: "grey"
                                },
                                children: emptyMessage
                            })
                        })
                    })
                })
            })
        ]
    });
}
var $67963b09fdec1ded$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($67963b09fdec1ded$var$DataTable).attrs({
    className: $67963b09fdec1ded$var$DataTable.name
})`
  td {
    text-overflow: ellipsis;
  }
`;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

const $547acb6fe382aadd$export$c24727297075ec6a = /*#__PURE__*/ $acw62.createContext(null);
function $547acb6fe382aadd$var$ControlledForm({ className: className, children: children, onSubmit: onSubmit, onChange: onChange, state: state }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($547acb6fe382aadd$export$c24727297075ec6a.Provider, {
        value: {
            findValue: (name)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(state.values, name),
            handleChange: (name, value)=>onChange(name, value)
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
            onSubmit: (ev)=>{
                ev.preventDefault();
                onSubmit(state.values);
            },
            className: className,
            children: children
        })
    });
}
var $547acb6fe382aadd$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($547acb6fe382aadd$var$ControlledForm).attrs({
    className: $547acb6fe382aadd$var$ControlledForm.name
})``;


var $735a0bab243419cb$var$ActionTypes;
(function(ActionTypes) {
    ActionTypes[ActionTypes["setValue"] = 0] = "setValue";
})($735a0bab243419cb$var$ActionTypes || ($735a0bab243419cb$var$ActionTypes = {}));
function $735a0bab243419cb$var$reducer(state, action) {
    switch(action.type){
        case 0:
            return {
                ...state,
                values: {
                    ...state.values,
                    [action.name]: action.value
                }
            };
        default:
            break;
    }
    return state;
}
function $735a0bab243419cb$var$Form({ className: className, children: children, onSubmit: onSubmit, initialState: initialState, onChange: onChange, ...rest }) {
    const firstRender = $acw62.useRef(true);
    const [state, dispatch] = $acw62.useReducer($735a0bab243419cb$var$reducer, {
        values: initialState
    });
    $acw62.useEffect(()=>{
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        if (onChange) onChange(state);
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547acb6fe382aadd$export$2e2bcd8739ae039), {
        ...rest,
        className: className,
        state: state,
        onChange: (name, value)=>dispatch({
                type: 0,
                name: name,
                value: value
            }),
        onSubmit: ()=>onSubmit(state.values),
        children: children
    });
}
var $735a0bab243419cb$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($735a0bab243419cb$var$Form).attrs({
    className: $735a0bab243419cb$var$Form.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");
function $d637ac0d813ae381$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}


var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $d637ac0d813ae381$export$2e2bcd8739ae039);




var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $9XEW1.default)("MuiFormControl", slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $7u6PA.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $9971e.default)(slots, (0, $ce03a37a8cfb980d$export$149c8b8bab2289d1), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $1e4827e2a850b1f0$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const onFilled = $acw62.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $acw62.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        size: size,
        onBlur: ()=>{
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: ()=>{
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");



var $jTnBY = parcelRequire("jTnBY");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $9XEW1.default)("MuiFormLabel", slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $7u6PA.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $9971e.default)(slots, (0, $c678fac155df4fc3$export$f7d501e40371cd17), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: theme.palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).focused}`]: {
            color: theme.palette[ownerState.color].main
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.text.disabled
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: theme.palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: theme.palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;


parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $9971e = parcelRequire("9971e");

var $17r9Q = parcelRequire("17r9Q");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $bUPtf = parcelRequire("bUPtf");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");


var $ayMG0 = parcelRequire("ayMG0");
const $0311c85f7d96727c$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $0311c85f7d96727c$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
const $0311c85f7d96727c$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
const $0311c85f7d96727c$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, ref) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1En50.default)(props, $0311c85f7d96727c$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(ref, inputRef);
    const shadowRef = $acw62.useRef(null);
    const renders = $acw62.useRef(0);
    const [state, setState] = $acw62.useState({});
    const syncHeight = $acw62.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return;
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle["box-sizing"];
        const padding = $0311c85f7d96727c$var$getStyleValue(computedStyle, "padding-bottom") + $0311c85f7d96727c$var$getStyleValue(computedStyle, "padding-top");
        const border = $0311c85f7d96727c$var$getStyleValue(computedStyle, "border-bottom-width") + $0311c85f7d96727c$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        const innerHeight = inputShallow.scrollHeight; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight; // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState((prevState)=>{
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $acw62.useEffect(()=>{
        const handleResize = (0, $41c4238d7b0ec499$export$2e2bcd8739ae039)(()=>{
            renders.current = 0;
            syncHeight();
        });
        const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(inputRef.current);
        containerWindow.addEventListener("resize", handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(inputRef.current);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        syncHeight
    ]);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $acw62.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
                ,
                rows: minRows,
                style: (0, $8nd05.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : null
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $0311c85f7d96727c$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $0311c85f7d96727c$export$2e2bcd8739ae039 = $0311c85f7d96727c$var$TextareaAutosize;


var $9971e = parcelRequire("9971e");




var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $jTnBY = parcelRequire("jTnBY");



var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");
parcelRequire("c9Z8w");

var $bBbjn = parcelRequire("bBbjn");

var $jR9F1 = parcelRequire("jR9F1");

var $ayMG0 = parcelRequire("ayMG0");
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $jR9F1.default)
    }));
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;




var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $9XEW1.default)("MuiInputBase", slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $7u6PA.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $jTnBY.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd"
        ]
    };
    return (0, $9971e.default)(slots, (0, $9b9dde6aa920e08c$export$ef57d5c8ca2278f6), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: theme.palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $d8seH.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: theme.palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03fc756f7adfd498$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputPropsRefProp = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    const handleInputRefProp = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    const handleInputRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $bUPtf.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
         // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $8nd05.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $0311c85f7d96727c$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = componentsProps.root || {};
    const Input = components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $1SA7b.default)(classes.root, rootProps.className, className),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $1SA7b.default)(classes.input, inputProps.className),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;



var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $8nd05 = parcelRequire("8nd05");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");

function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $9XEW1.default)("MuiInput", slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $7u6PA.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;




var $ayMG0 = parcelRequire("ayMG0");
const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $80c774dd7f29b734$export$cdb270390122322b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return (0, $8nd05.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}:after`]: {
            borderBottomColor: theme.palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}):before`]: {
            borderBottom: `2px solid ${theme.palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, type: type = "text" } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = componentsPropsProp ? (0, $17r9Q.default)(componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        components: (0, $8nd05.default)({
            Root: $76910a07fd4ac4fe$var$InputRoot,
            Input: $76910a07fd4ac4fe$var$InputInput
        }, components),
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.muiName = "Input";
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $17r9Q = parcelRequire("17r9Q");
parcelRequire("c9Z8w");

var $9971e = parcelRequire("9971e");


var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $8nd05 = parcelRequire("8nd05");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");

function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $9XEW1.default)("MuiFilledInput", slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $7u6PA.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;




var $ayMG0 = parcelRequire("ayMG0");
const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $b0b42157daacd8b1$export$3331e419f1a48437), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    return (0, $8nd05.default)({
        position: "relative",
        backgroundColor: backgroundColor,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)",
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: backgroundColor
            }
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: backgroundColor
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}:after`]: {
            borderBottomColor: theme.palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}):before`]: {
            borderBottom: `1px solid ${theme.palette.text.primary}`
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, type: type = "text" } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = componentsPropsProp ? (0, $17r9Q.default)(componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        components: (0, $8nd05.default)({
            Root: $bb335d5457c07f5b$var$FilledInputRoot,
            Input: $bb335d5457c07f5b$var$FilledInputInput
        }, components),
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.muiName = "Input";
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");


var $9971e = parcelRequire("9971e");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");
parcelRequire("c9Z8w");

var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)("legend")(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        float: "unset",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        width: "auto",
        // Fix conflict with bootstrap
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $d8seH = parcelRequire("d8seH");

var $8nd05 = parcelRequire("8nd05");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");

function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $9XEW1.default)("MuiOutlinedInput", slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $7u6PA.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;




var $6g9fa = parcelRequire("6g9fa");

var $ayMG0 = parcelRequire("ayMG0");
const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $6a1dc6d1d7e1816a$export$89922944c7227687), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $69d1b2c99a8dc649$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $8nd05.default)({
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: theme.palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: borderColor
            }
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).focused} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: theme.palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).error} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: theme.palette.error.main
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).disabled} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: theme.palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $746323a953600e78$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>({
        borderColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"
    }));
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        padding: "16.5px 14px",
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, type: type = "text" } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        components: (0, $8nd05.default)({
            Root: $d5d55d2dd82639e9$var$OutlinedInputRoot,
            Input: $d5d55d2dd82639e9$var$OutlinedInputInput
        }, components),
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\xa0",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = "Input";
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $9971e = parcelRequire("9971e");




var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $9XEW1.default)("MuiInputLabel", slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $7u6PA.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size === "small" && "sizeSmall",
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        maxWidth: "calc(133% - 24px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $6g9fa.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes
    }));
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");



var $d8seH = parcelRequire("d8seH");

var $jTnBY = parcelRequire("jTnBY");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $9XEW1.default)("MuiFormHelperText", slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $7u6PA.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;



var $6g9fa = parcelRequire("6g9fa");

var $ayMG0 = parcelRequire("ayMG0");
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $9971e.default)(slots, (0, $a46b344d341d82c0$export$a394fa61b1d583a9), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: theme.palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.text.disabled
        },
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).error}`]: {
            color: theme.palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $1En50.default)(props, $d23aa5c3ca6913fb$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $17r9Q = parcelRequire("17r9Q");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bUPtf = parcelRequire("bUPtf");

var $acw62 = parcelRequire("acw62");

parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $jTnBY = parcelRequire("jTnBY");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $jTnBY = parcelRequire("jTnBY");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $9XEW1.default)("MuiNativeSelect", slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $7u6PA.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $jTnBY.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $9971e.default)(slots, (0, $49a1663d7631a8fa$export$1ee13051fd9e2ab5), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": {
            // Show that it's not an text input
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
            borderRadius: 0 // Reset Chrome style
        },
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: theme.palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: theme.shape.borderRadius,
        "&:focus": {
            borderRadius: theme.shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $d8seH.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            {
                [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: theme.palette.action.active,
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $1SA7b.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;




var $d8seH = parcelRequire("d8seH");

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $acw62 = parcelRequire("acw62");
function $3b481a8630784b69$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $3b481a8630784b69$export$2e2bcd8739ae039);



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $9XEW1.default)("MuiSelect", slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $7u6PA.default)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;



var $ayMG0 = parcelRequire("ayMG0");
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $db2c454fb2e8bc3c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $db2c454fb2e8bc3c$export$e7a817afd12a40d0));
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)("input", {
    shouldForwardProp: (prop)=>(0, $d8seH.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
     // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $jTnBY.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $9971e.default)(slots, (0, $844e08aea9053c4b$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]); // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            displayRef.current.focus();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]); // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children); // Support autofill.
    const handleChange = (event)=>{
        const index = childrenArray.map((child)=>child.props.value).indexOf(event.target.value);
        if (index === -1) return;
        const child = childrenArray[index];
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue; // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child, index, arr)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $bUPtf.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        if (child.props.value === undefined) return /*#__PURE__*/ $acw62.cloneElement(child, {
            "aria-readonly": true,
            role: "option"
        });
        const isFirstSelectableElement = ()=>{
            if (value) return selected;
            const firstSelectableElement = arr.find((item)=>item.props.value !== undefined && item.props.disabled !== true);
            if (child === firstSelectableElement) return true;
            return selected;
        };
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: arr[0].props.value === undefined || arr[0].props.disabled === true ? isFirstSelectableElement() : selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    } // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $1SA7b.default)(classes.select, className, SelectDisplayProps.className) // The id is required for proper a11y
                ,
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: `menu-${name || ""}`,
                anchorEl: displayNode,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $8nd05.default)({}, MenuProps.PaperProps, {
                    style: (0, $8nd05.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;




parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");







var $6g9fa = parcelRequire("6g9fa");


var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
var $96e1233e8d06bb2d$var$_StyledInput, $96e1233e8d06bb2d$var$_StyledFilledInput;
const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $bb335d5457c07f5b$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $6g9fa.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $db2c454fb2e8bc3c$export$2e2bcd8739ae039) : (0, $8bd650259be885cb$export$2e2bcd8739ae039);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    const variant = fcs.variant || variantProp;
    const InputComponent = input || ({
        standard: $96e1233e8d06bb2d$var$_StyledInput || ($96e1233e8d06bb2d$var$_StyledInput = /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {})),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label
        }),
        filled: $96e1233e8d06bb2d$var$_StyledFilledInput || ($96e1233e8d06bb2d$var$_StyledFilledInput = /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {}))
    })[variant];
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const inputComponentRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
        inputComponent: // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent,
        inputProps: (0, $8nd05.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            multiple: // We render a select. We can ignore the type provided by the `Input`.
            multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            defaultOpen: defaultOpen,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $8nd05.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $17r9Q.default)(classes, inputProps.classes) : classes
        }, input ? input.props.inputProps : {})
    }, multiple && native && variant === "outlined" ? {
        notched: true
    } : {}, {
        ref: inputComponentRef,
        className: (0, $1SA7b.default)(InputComponent.props.className, className),
        variant: variant
    }, other));
});
$96e1233e8d06bb2d$var$Select.muiName = "Select";
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $9XEW1.default)("MuiTextField", slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $7u6PA.default)("MuiTextField", [
    "root"
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $d8826083c5af4ea7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $76910a07fd4ac4fe$export$2e2bcd8739ae039),
    filled: (0, $bb335d5457c07f5b$export$2e2bcd8739ae039),
    outlined: (0, $d5d55d2dd82639e9$export$2e2bcd8739ae039)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9971e.default)(slots, (0, $25a6b464d3ca38da$export$c1bdcbaf0596aeda), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $1En50.default)(props, $d8826083c5af4ea7$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $f649782d844a38be$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8826083c5af4ea7$var$TextFieldRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), (0, $8nd05.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;


parcelRequire("acw62");

function $bd6dc24e79fec2ce$var$Input({ className: className, value: value, type: type, name: name, label: label, onChange: onChange, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
        className: className,
        id: name,
        type: type,
        value: value,
        label: label,
        onChange: (e)=>onChange(e.target.value),
        ...rest,
        inputProps: {
            step: rest.step,
            ...rest.inputProps
        }
    });
}
var $bd6dc24e79fec2ce$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($bd6dc24e79fec2ce$var$Input)``;


const $e9924aff1dcc3644$export$b04be29aa201d4f5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ className: className, children: children, name: name, required: required })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
        className: className,
        htmlFor: name,
        required: required,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
            children: children
        })
    }))`
  label {
    margin-bottom: 4px;
  }
`;
function $e9924aff1dcc3644$var$FormInput({ className: className, label: label, name: name, component: component, valuePropName: valuePropName = "value", formatter: formatter, ...props }) {
    const Component = component || (0, $bd6dc24e79fec2ce$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $547acb6fe382aadd$export$c24727297075ec6a).Consumer, {
        children: ({ handleChange: handleChange, findValue: findValue })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e9924aff1dcc3644$export$b04be29aa201d4f5, {
                        name: name,
                        required: props.required,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                        id: name,
                        variant: "outlined",
                        ...props,
                        [valuePropName]: findValue(name),
                        onChange: (ev)=>{
                            let v = ev;
                            if (ev.target) // type=number inputs are a bit weird. handling that here.
                            v = ev.target[valuePropName];
                            handleChange(name, v);
                        },
                        onBlur: ()=>{
                            if (formatter) {
                                const v = findValue(name);
                                handleChange(name, formatter(v));
                            }
                        }
                    })
                ]
            })
    });
}
var $e9924aff1dcc3644$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($e9924aff1dcc3644$var$FormInput).attrs({
    className: $e9924aff1dcc3644$var$FormInput.name
})`
  min-width: 300px;
`;





var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");


var $ayMG0 = parcelRequire("ayMG0");
function $7aabd1280e8804e7$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $7aabd1280e8804e7$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click away listener](https://mui.com/base/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base/api/click-away-listener/)
 */ function $7aabd1280e8804e7$var$ClickAwayListener(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(children.ref, nodeRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $7aabd1280e8804e7$var$clickedRootScrollbar(event, doc)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $7aabd1280e8804e7$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $7aabd1280e8804e7$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, childrenProps)
    });
}
var $7aabd1280e8804e7$export$2e2bcd8739ae039 = $7aabd1280e8804e7$var$ClickAwayListener;



var $d8seH = parcelRequire("d8seH");


var $6g9fa = parcelRequire("6g9fa");


var $jTnBY = parcelRequire("jTnBY");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $4d2fdf4430378182$export$def81488db1a3216(slot) {
    return (0, $9XEW1.default)("MuiSnackbarContent", slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $7u6PA.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $4d2fdf4430378182$export$2e2bcd8739ae039 = $4d2fdf4430378182$var$snackbarContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $dbe322effc7340b4$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $9971e.default)(slots, (0, $4d2fdf4430378182$export$def81488db1a3216), classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $kyRHb.emphasize)(theme.palette.background.default, emphasis);
    return (0, $8nd05.default)({}, theme.typography.body2, {
        color: theme.palette.getContrastText(backgroundColor),
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: theme.shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $d8seH.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $d8seH.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $1En50.default)(props, $dbe322effc7340b4$var$_excluded);
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $dbe322effc7340b4$export$2e2bcd8739ae039 = $dbe322effc7340b4$var$SnackbarContent;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $f3bdc4d25b715a88$export$6cb096457f5926f4(slot) {
    return (0, $9XEW1.default)("MuiSnackbar", slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $7u6PA.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $f3bdc4d25b715a88$export$2e2bcd8739ae039 = $f3bdc4d25b715a88$var$snackbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $ef601776ba11bb1e$var$_excluded = [
    "onEnter",
    "onExited"
], $ef601776ba11bb1e$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $f3bdc4d25b715a88$export$6cb096457f5926f4), classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $d8seH.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = (0, $8nd05.default)({}, !ownerState.isRtl && {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    }, ownerState.isRtl && {
        right: "50%",
        left: "auto",
        transform: "translateX(50%)"
    });
    return (0, $8nd05.default)({
        zIndex: theme.zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $8nd05.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && (0, $8nd05.default)({}, !ownerState.isRtl && {
            left: 24,
            right: "auto"
        }, ownerState.isRtl && {
            right: 24,
            left: "auto"
        }), ownerState.anchorOrigin.horizontal === "right" && (0, $8nd05.default)({}, !ownerState.isRtl && {
            right: 24,
            left: "auto"
        }, ownerState.isRtl && {
            left: 24,
            right: "auto"
        }))
    });
});
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $ef601776ba11bb1e$var$_excluded), other = (0, $1En50.default)(props, $ef601776ba11bb1e$var$_excluded2);
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        isRtl: isRtl
    });
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const timerAutoHide = $acw62.useRef();
    const [exited, setExited] = $acw62.useState(true);
    const handleClose = (0, $331f3746e6346411$export$2e2bcd8739ae039)((...args)=>{
        if (onClose) onClose(...args);
    });
    const setAutoHideTimer = (0, $331f3746e6346411$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        handlePause();
    };
    const handleMouseEnter = (event)=>{
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        handleResume();
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    const handleClickAway = (event)=>{
        if (onClose) onClose(event, "clickaway");
    };
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                // IE11, Edge (prior to using Bink?) use 'Esc'
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                {
                    if (onClose) onClose(nativeEvent, "escapeKeyDown");
                }
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        exited,
        open,
        onClose
    ]); // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7aabd1280e8804e7$export$2e2bcd8739ae039), (0, $8nd05.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef601776ba11bb1e$var$SnackbarRoot, (0, $8nd05.default)({
            className: (0, $1SA7b.default)(classes.root, className),
            onBlur: handleBlur,
            onFocus: handleFocus,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            ownerState: ownerState,
            ref: ref // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            ,
            role: "presentation"
        }, other, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dbe322effc7340b4$export$2e2bcd8739ae039), (0, $8nd05.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $ef601776ba11bb1e$export$2e2bcd8739ae039 = $ef601776ba11bb1e$var$Snackbar;



var $acw62 = parcelRequire("acw62");
const $9e9e9cb50078a9ef$export$a6e93d8cb5d50678 = /*#__PURE__*/ $acw62.createContext({});
var $9e9e9cb50078a9ef$var$NotificationType;
(function(NotificationType) {
    NotificationType["Success"] = "success";
    NotificationType["Info"] = "info";
    NotificationType["Error"] = "error";
})($9e9e9cb50078a9ef$var$NotificationType || ($9e9e9cb50078a9ef$var$NotificationType = {}));
function $9e9e9cb50078a9ef$export$186b91822010e97f({ children: children }) {
    const [message, setMessage] = $acw62.useState({
        type: "info",
        text: ""
    });
    const [open, setOpen] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (message.text) setOpen(true);
    }, [
        message
    ]);
    const handleClose = ()=>setOpen(false);
    const value = {
        success: (message)=>{
            setMessage({
                type: "success",
                text: message
            });
        },
        error: (message)=>{
            setMessage({
                type: "error",
                text: message
            });
        },
        rawError: (error)=>{
            console.error(error);
            setMessage({
                type: "error",
                text: error.message
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9e9e9cb50078a9ef$export$a6e93d8cb5d50678.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef601776ba11bb1e$export$2e2bcd8739ae039), {
                    open: open,
                    onClose: handleClose,
                    autoHideDuration: 6000,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        variant: "filled",
                        onClose: handleClose,
                        severity: message.type,
                        sx: {
                            width: "100%"
                        },
                        children: message.text
                    })
                })
            })
        ]
    });
}
function $9e9e9cb50078a9ef$export$9949bd9c713ba425() {
    return $acw62.useContext($9e9e9cb50078a9ef$export$a6e93d8cb5d50678);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $76177b68db1e554f$export$4a35d29baec5dd1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
function $76177b68db1e554f$export$64b5917bffaa59c2({ fetch: fetch, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($76177b68db1e554f$export$4a35d29baec5dd1.Provider, {
        value: {
            fetch: fetch
        },
        children: children
    });
}
function $76177b68db1e554f$export$d852f5f778460fa4() {
    const { fetch: fetch } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($76177b68db1e554f$export$4a35d29baec5dd1);
    return fetch;
}
function $76177b68db1e554f$var$fetchIsSuperAdmin(fetch) {
    return fetch("/.netlify/functions/is_super_admin").then((res)=>res.json()).then((res)=>{
        return res.isSuperAdmin;
    });
}
function $76177b68db1e554f$export$dd53ec461ae8f03e() {
    const fetch = $76177b68db1e554f$export$d852f5f778460fa4();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "isSuperAdmin"
    ], ()=>$76177b68db1e554f$var$fetchIsSuperAdmin(fetch), {
        cacheTime: Infinity,
        staleTime: Infinity
    });
}
function $76177b68db1e554f$var$submitSub(fetch, body) {
    return fetch("/.netlify/functions/add_sub", {
        method: "POST",
        body: JSON.stringify({
            ...body
        })
    }).then((res)=>{
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    });
}
function $76177b68db1e554f$export$e0f655e8ac301b2() {
    const fetch = $76177b68db1e554f$export$d852f5f778460fa4();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return async (...args)=>{
        const res = await $76177b68db1e554f$var$submitSub(fetch, ...args);
        await qc.invalidateQueries([
            "subs"
        ]);
        return res;
    };
}
function $76177b68db1e554f$var$listSubs(fetch) {
    return fetch("/.netlify/functions/list_subs").then((res)=>res.json());
}
function $76177b68db1e554f$export$46e2c8442457ca66() {
    const fetch = $76177b68db1e554f$export$d852f5f778460fa4();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "subs"
    ], ()=>$76177b68db1e554f$var$listSubs(fetch), {
        cacheTime: Infinity,
        staleTime: Infinity
    });
}
function $76177b68db1e554f$var$removeSub(fetch, ownerDiscordID) {
    return fetch("/.netlify/functions/remove_sub", {
        method: "POST",
        body: JSON.stringify({
            ownerDiscordID: ownerDiscordID
        })
    }).then((res)=>res.json());
}
function $76177b68db1e554f$export$dd1005cf3ed1a182() {
    const fetch = $76177b68db1e554f$export$d852f5f778460fa4();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return async (...args)=>{
        const r = await $76177b68db1e554f$var$removeSub(fetch, ...args);
        await qc.invalidateQueries([
            "subs"
        ]);
        return r;
    };
}
function $76177b68db1e554f$export$2befcef6a4fe993a() {
    const fetch = $76177b68db1e554f$export$d852f5f778460fa4();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "superAdminInfo"
    ], ()=>{
        return fetch("/.netlify/functions/superadmin_info").then((res)=>res.json());
    });
}


var $49e655d557af2da9$export$6f169d678831145;
(function(SubscriptionOrigin) {
    SubscriptionOrigin["SuperAdmin"] = "SuperAdmin";
    SubscriptionOrigin["Stripe"] = "Stripe";
    SubscriptionOrigin["Volume"] = "Volume";
})($49e655d557af2da9$export$6f169d678831145 || ($49e655d557af2da9$export$6f169d678831145 = {}));
const $49e655d557af2da9$export$4ae4428989a3eca3 = "Subscriptions";
const $49e655d557af2da9$export$94c2f8b465936fd2 = "VolumeRedeemRecords";
class $49e655d557af2da9$export$f55210826850c514 {
}


const $1070efaf7a31e2a1$var$ModalContent = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  background: white;
  position: absolute;
  top: 36px;
  left: 50%;
  margin: 0 auto;
  transform: translateX(-50%);
  min-width: 720px;
  max-height: 1024px;
  overflow: auto;
`;
function $1070efaf7a31e2a1$var$Subscriptions({ className: className }) {
    const [removing, setRemoving] = $acw62.useState(null);
    const [submittingSub, setSubmittingSub] = $acw62.useState(false);
    const [subCreateModalOpen, setSubCreateModal] = $acw62.useState(false);
    const { data: subscriptions, isLoading: subsLoading } = (0, $76177b68db1e554f$export$46e2c8442457ca66)();
    const submit = (0, $76177b68db1e554f$export$e0f655e8ac301b2)();
    const remove = (0, $76177b68db1e554f$export$dd1005cf3ed1a182)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const { data: info, isLoading: infoLoading } = (0, $76177b68db1e554f$export$2befcef6a4fe993a)();
    const { data: isAdmin, isLoading: isLoading } = (0, $76177b68db1e554f$export$dd53ec461ae8f03e)();
    if (isLoading || subsLoading || infoLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {});
    if (!isAdmin) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47b3c0eb5fee4469$export$2e2bcd8739ae039), {
        message: "Page Not Found",
        stack: ""
    });
    const handleSubscriptionSubmit = (formState)=>{
        setSubmittingSub(true);
        submit({
            ...formState,
            origin: (0, $49e655d557af2da9$export$6f169d678831145).SuperAdmin
        }).then(()=>{
            success(`Sub created`);
            setSubCreateModal(false);
        }).catch((e)=>error(e.message)).finally(()=>setSubmittingSub(false));
    };
    const handleSubscriptionRemove = (ownerID)=>{
        setRemoving(ownerID);
        remove(ownerID).then(()=>{
            success("Removed sub for " + ownerID);
        }).catch((err)=>error(err.message)).finally(()=>setRemoving(null));
    };
    const initialFormState = {
        enabled: true,
        ownerDiscordID: "",
        discordGuildID: "",
        ownerDisplayName: ""
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                    severity: "warning",
                    children: "Super Admins Only"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: "Subscriptions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                        columns: [
                            {
                                value: "ownerDisplayName",
                                label: "Display Name"
                            },
                            {
                                value: (sub)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: `${info?.firebaseDashboardURL}/firestore/data/~2FSubscriptions~2F${sub.id}`,
                                        target: "_blank",
                                        children: sub.id
                                    }),
                                label: "ID"
                            },
                            {
                                value: (sub)=>sub.enabled ? "Enabled" : "Disabled",
                                label: "Enabled"
                            },
                            {
                                value: "origin",
                                label: "Origin"
                            },
                            {
                                value: (sub)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        target: "_blank",
                                        href: info?.s3Address.replace("{{USER_ID}}", sub.ownerDiscordID),
                                        children: sub.ownerDiscordID
                                    }),
                                label: "Discord ID"
                            },
                            {
                                value: (s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        target: "_blank",
                                        href: `${info?.stripeDashboardURL}/customers/${s.stripeCustomerID}`,
                                        children: s.stripeCustomerID
                                    }),
                                label: "Stripe Customer ID"
                            },
                            {
                                value: (sub)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                        disabled: sub.origin === (0, $49e655d557af2da9$export$6f169d678831145).Stripe || sub.origin === (0, $49e655d557af2da9$export$6f169d678831145).Volume,
                                        loading: removing === sub.ownerDiscordID,
                                        variant: "outlined",
                                        color: "error",
                                        onClick: ()=>handleSubscriptionRemove(sub.ownerDiscordID),
                                        children: "Remove"
                                    }),
                                label: ""
                            }
                        ],
                        rows: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(subscriptions, "ownerDisplayName", "desc")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginY: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                onClick: ()=>setSubCreateModal(true),
                                variant: "contained",
                                children: "Add"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                onClose: ()=>setSubCreateModal(false),
                open: subCreateModalOpen,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($1070efaf7a31e2a1$var$ModalContent, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: "Add Subscription"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $735a0bab243419cb$export$2e2bcd8739ae039), {
                                initialState: initialFormState,
                                onSubmit: handleSubscriptionSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9924aff1dcc3644$export$2e2bcd8739ae039), {
                                            autoComplete: "off",
                                            type: "text",
                                            name: "ownerDiscordID",
                                            label: "Discord User ID"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9924aff1dcc3644$export$2e2bcd8739ae039), {
                                            required: true,
                                            autoComplete: "off",
                                            name: "ownerDisplayName",
                                            label: "Owner Display Name"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9924aff1dcc3644$export$2e2bcd8739ae039), {
                                            autoComplete: "off",
                                            name: "discordGuildID",
                                            label: "Discord Guild ID"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        marginY: 2,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                            loading: submittingSub,
                                            variant: "contained",
                                            type: "submit",
                                            children: "Submit"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $1070efaf7a31e2a1$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($1070efaf7a31e2a1$var$Subscriptions).attrs({
    className: $1070efaf7a31e2a1$var$Subscriptions.name
})`
  margin: 0 auto;

  max-width: 1440px;
`;


function $b92f5c3ae8797ac1$var$SuperAdmin({ className: className }) {
    const { url: url } = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a6bef72edba85b27$export$2e2bcd8739ae039), {
            rootPath: `${url}/subscriptions`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                    name: "Subscriptions",
                    path: `${url}/subscriptions`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1070efaf7a31e2a1$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                    name: "Airbase Data",
                    path: `${url}/airbases`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ff48a27fd577971$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $b92f5c3ae8797ac1$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b92f5c3ae8797ac1$var$SuperAdmin).attrs({
    className: $b92f5c3ae8797ac1$var$SuperAdmin.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $938b1427b9e9a19f$export$5269a5bce2c2f987(slot) {
    return (0, $9XEW1.default)("MuiAlertTitle", slot);
}
const $938b1427b9e9a19f$var$alertTitleClasses = (0, $7u6PA.default)("MuiAlertTitle", [
    "root"
]);
var $938b1427b9e9a19f$export$2e2bcd8739ae039 = $938b1427b9e9a19f$var$alertTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $cbe9496169f0560d$var$_excluded = [
    "className"
];
const $cbe9496169f0560d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9971e.default)(slots, (0, $938b1427b9e9a19f$export$5269a5bce2c2f987), classes);
};
const $cbe9496169f0560d$var$AlertTitleRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $cbe9496169f0560d$var$AlertTitle = /*#__PURE__*/ $acw62.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $cbe9496169f0560d$var$_excluded);
    const ownerState = props;
    const classes = $cbe9496169f0560d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cbe9496169f0560d$var$AlertTitleRoot, (0, $8nd05.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other));
});
var $cbe9496169f0560d$export$2e2bcd8739ae039 = $cbe9496169f0560d$var$AlertTitle;


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $38327c46e281f643$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ className: className, height: height = 24, width: width = 24 })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        column: true,
        center: true,
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: height,
            height: width,
            viewBox: "0 0 71 55",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    clipPath: "url(#clip0)",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z",
                        fill: "#5865F2"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "71",
                            height: "55",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    }))``;



function $e5e8911e4b30dc90$var$DiscordLoginButton({ className: className, style: style }) {
    const [authUrl, setAuthURL] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        (0, $5f078b543969ac27$export$b0f449737312189d)().then((url)=>setAuthURL(url));
    }, []);
    const loginRouteMatch = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)((0, $91a9098e14452db2$export$37d3279522fbf5e2).Login);
    const handleSubmit = (event)=>{
        event.preventDefault();
        // We use this button in different places.
        // If on a public FO, we want to take them back to where they came from.
        // For admin login, we want to take the to /home.
        localStorage.setItem("callbackNext", loginRouteMatch?.path === (0, $91a9098e14452db2$export$37d3279522fbf5e2).Login ? (0, $91a9098e14452db2$export$37d3279522fbf5e2).Home : `${window.location.pathname}${window.location.search}`);
        window.location.href = authUrl;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        style: style,
        className: className,
        component: "form",
        onSubmit: handleSubmit,
        noValidate: true,
        sx: {
            mt: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
            loading: !authUrl,
            type: "submit",
            fullWidth: true,
            variant: "outlined",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                align: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            marginRight: 12
                        },
                        children: "Sign In with Discord"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38327c46e281f643$export$2e2bcd8739ae039), {
                        height: 24,
                        width: 24
                    })
                ]
            })
        })
    });
}
var $e5e8911e4b30dc90$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($e5e8911e4b30dc90$var$DiscordLoginButton).attrs({
    className: $e5e8911e4b30dc90$var$DiscordLoginButton.name
})`
  white-space: nowrap;
  background-color: white;
`;




var $ayMG0 = parcelRequire("ayMG0");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $ayMG0 = parcelRequire("ayMG0");
const $f875d00b2138afe4$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $9971e.default)(slots, (0, $024a60f892d3fa61$export$46f01d01378ec5a2), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: (0, $kyRHb.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            position: "relative",
            width: "100%",
            borderTop: `thin solid ${theme.palette.divider}`,
            top: "50%",
            content: '""',
            transform: "translateY(50%)"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            top: "0%",
            left: "50%",
            borderTop: 0,
            borderLeft: `thin solid ${theme.palette.divider}`,
            transform: "translateX(0%)"
        }
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $1En50.default)(props, $f875d00b2138afe4$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $9fa5a1ec57c21134$var$BundleClientContext = /*#__PURE__*/ $acw62.createContext(null);
function $9fa5a1ec57c21134$export$871d43b949ab7987({ client: client, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9fa5a1ec57c21134$var$BundleClientContext.Provider, {
        value: client,
        children: children
    });
}
function $9fa5a1ec57c21134$export$84bdc398979fa84f() {
    return $acw62.useContext($9fa5a1ec57c21134$var$BundleClientContext);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $a7e8caa803539e5f$export$9daed425602f604d = /*#__PURE__*/ $acw62.createContext({});
function $a7e8caa803539e5f$export$cd94e60a17ee9cf7({ client: client, children: children }) {
    const value = client;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a7e8caa803539e5f$export$9daed425602f604d.Provider, {
        value: value,
        children: children
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $8a132888bcd1c418$export$e57062a38354425e;
(function(AssetType) {
    AssetType["Kneeboard"] = "Kneeboard";
    AssetType["GeneratedKneeboard"] = "GeneratedKneeboard";
})($8a132888bcd1c418$export$e57062a38354425e || ($8a132888bcd1c418$export$e57062a38354425e = {}));
class $8a132888bcd1c418$export$c413dd039085b182 {
}


var $e46deec1d196b34c$export$608283ae8fe7f3eb;
(function(JobType) {
    JobType["ApplyPlans"] = "Apply Plans";
    JobType["InjectAirbasesKneeboard"] = "Inject Airbases Kneeboard";
    JobType["GroupLineupCard"] = "Inject Generated Lineup Cards";
    JobType["GroupCommsCard"] = "Inject Generated Communications Kneeboard";
    JobType["BriefingText"] = "Inject Briefing Text Kneeboard";
    JobType["Assets"] = "Inject Uploaded Kneeboards";
    JobType["RadioPresetConfig"] = "Configure Radio Presets";
    JobType["RadioPresetConfigKneeboard"] = "Inject Radio Presets Kneeboard";
    JobType["ControlPointsCard"] = "Inject Control Points Kneeboard";
    JobType["InjectSupportAssetsKneeboard"] = "Inject Support Assets Kneeboard";
    JobType["ApplyExternalData"] = "Apply Batch Edit Data";
    JobType["InjectBullsCompass"] = "Inject Bulls Compass Kneeboard";
    JobType["InjectRouteDetailCards"] = "Inject Route Detail Kneeboards";
})($e46deec1d196b34c$export$608283ae8fe7f3eb || ($e46deec1d196b34c$export$608283ae8fe7f3eb = {}));




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");
/**
 * @module ol/Feature
 */ /**
 * @module ol/Object
 */ /**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $aeedce20e9577100$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $aeedce20e9577100$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $aeedce20e9577100$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $aeedce20e9577100$export$2e2bcd8739ae039 = $aeedce20e9577100$var$BaseEvent;


/**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $e881b5dca21eb5d4$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: "propertychange"
};


/**
 * @module ol/Observable
 */ /**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $3273ed08087da3da$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $3273ed08087da3da$export$2e2bcd8739ae039 = $3273ed08087da3da$var$Disposable;



/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $b998d41b678ed5d1$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $b998d41b678ed5d1$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $b998d41b678ed5d1$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $b998d41b678ed5d1$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $b998d41b678ed5d1$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === "function") {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $b998d41b678ed5d1$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $b998d41b678ed5d1$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $b998d41b678ed5d1$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $b998d41b678ed5d1$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b998d41b678ed5d1$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $b998d41b678ed5d1$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $b998d41b678ed5d1$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


function $013a1733c226ec50$export$22e23a2304399231() {
    return true;
}
function $013a1733c226ec50$export$8f11cee4bdc7e668() {
    return false;
}
function $013a1733c226ec50$export$1cd1943b3a73bbe8() {}
function $013a1733c226ec50$export$ff83df6f9971435f(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $013a1733c226ec50$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}


/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $beaefe87199bb537$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $beaefe87199bb537$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $08c28d22c0cb5a39$var$Target extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === "string";
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $aeedce20e9577100$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ("handleEvent" in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $013a1733c226ec50$export$1cd1943b3a73bbe8));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $08c28d22c0cb5a39$export$2e2bcd8739ae039 = $08c28d22c0cb5a39$var$Target;


/**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $294047c5e65f31a3$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: "change",
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: "error",
    BLUR: "blur",
    CLEAR: "clear",
    CONTEXTMENU: "contextmenu",
    CLICK: "click",
    DBLCLICK: "dblclick",
    DRAGENTER: "dragenter",
    DRAGOVER: "dragover",
    DROP: "drop",
    FOCUS: "focus",
    KEYDOWN: "keydown",
    KEYPRESS: "keypress",
    LOAD: "load",
    RESIZE: "resize",
    TOUCHMOVE: "touchmove",
    WHEEL: "wheel"
};


/**
 * @module ol/events
 */ 
function $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @this {typeof target}
     */ listener = function() {
            target.removeEventListener(type, listener);
            originalListener.apply(thisArg ?? this, arguments);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $d5bf8abd656a3cdc$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $d5bf8abd656a3cdc$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $d5bf8abd656a3cdc$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(key);
    }
}


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $1f093ab5083c8a1f$var$Observable extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        }
        return (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $1f093ab5083c8a1f$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $1f093ab5083c8a1f$var$Observable.prototype.un;
function $1f093ab5083c8a1f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(key[i]);
    else (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $1f093ab5083c8a1f$export$2e2bcd8739ae039 = $1f093ab5083c8a1f$var$Observable;


/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $6c5e11070e371322$export$817eb92a8194bab0() {
    throw new Error("Unimplemented abstract method.");
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $6c5e11070e371322$var$uidCounter_ = 0;
function $6c5e11070e371322$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$6c5e11070e371322$var$uidCounter_));
}
const $6c5e11070e371322$export$a4ad2735b021c132 = "10.1.0";



class $b68b3d6e32e3074a$export$cf395d7c4a2d5a17 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ class $b68b3d6e32e3074a$var$BaseObject extends (0, $1f093ab5083c8a1f$export$2e2bcd8739ae039) {
    /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {Object<string, *>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ getProperties() {
        return this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $b68b3d6e32e3074a$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $b68b3d6e32e3074a$export$2e2bcd8739ae039 = $b68b3d6e32e3074a$var$BaseObject;



/**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $35d5ec884318008e$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}



/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ class $9fd014ab6df63665$var$Feature extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = "geometry";
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === "function") {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $9fd014ab6df63665$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(geometry, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $9fd014ab6df63665$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $9fd014ab6df63665$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === "function") return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `ol/style/Style` or an array of `ol/style/Style.js`");
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $9fd014ab6df63665$export$2e2bcd8739ae039 = $9fd014ab6df63665$var$Feature;


/**
 * @module ol/extent
 */ /**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $dab4245bc22b806c$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $6da4c8ed3074c92b$export$8aceca7c77505534(coordinates) {
    const extent = $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $6da4c8ed3074c92b$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $6da4c8ed3074c92b$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $6da4c8ed3074c92b$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $6da4c8ed3074c92b$export$ac68c24d37ca240f(extent, coordinate) {
    return $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $6da4c8ed3074c92b$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $6da4c8ed3074c92b$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $6da4c8ed3074c92b$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $6da4c8ed3074c92b$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $6da4c8ed3074c92b$export$3e2152b047719fa1(dest) {
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $6da4c8ed3074c92b$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $6da4c8ed3074c92b$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates);
}
function $6da4c8ed3074c92b$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $6da4c8ed3074c92b$export$73b4897e93bc5c83(rings, dest) {
    const extent = $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    return $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings);
}
function $6da4c8ed3074c92b$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $6da4c8ed3074c92b$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $6da4c8ed3074c92b$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $6da4c8ed3074c92b$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$6da4c8ed3074c92b$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $6da4c8ed3074c92b$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$6da4c8ed3074c92b$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $6da4c8ed3074c92b$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $6da4c8ed3074c92b$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($6da4c8ed3074c92b$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $6da4c8ed3074c92b$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) area = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) * $6da4c8ed3074c92b$export$c08559766941f856(extent);
    return area;
}
function $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $6da4c8ed3074c92b$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $6da4c8ed3074c92b$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === "bottom-left") coordinate = $6da4c8ed3074c92b$export$8d09f5e2e1bf560d(extent);
    else if (corner === "bottom-right") coordinate = $6da4c8ed3074c92b$export$e77c1cf70445e168(extent);
    else if (corner === "top-left") coordinate = $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent);
    else if (corner === "top-right") coordinate = $6da4c8ed3074c92b$export$b84fa077c8b05295(extent);
    else throw new Error("Invalid corner");
    return coordinate;
}
function $6da4c8ed3074c92b$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $6da4c8ed3074c92b$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $6da4c8ed3074c92b$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $6da4c8ed3074c92b$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $6da4c8ed3074c92b$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $6da4c8ed3074c92b$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2);
    return $6da4c8ed3074c92b$export$520c40045967cb15(intersection);
}
function $6da4c8ed3074c92b$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $6da4c8ed3074c92b$export$fe201bb3bbe031e9();
    if ($6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $6da4c8ed3074c92b$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $6da4c8ed3074c92b$export$1bc603050bd777b1(extent) {
    return $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) + $6da4c8ed3074c92b$export$c08559766941f856(extent);
}
function $6da4c8ed3074c92b$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $6da4c8ed3074c92b$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $6da4c8ed3074c92b$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $6da4c8ed3074c92b$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $6da4c8ed3074c92b$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, start);
    const endRel = $6da4c8ed3074c92b$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $dab4245bc22b806c$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $6da4c8ed3074c92b$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($6da4c8ed3074c92b$export$dd1bc94b04021eeb(extent)) return $6da4c8ed3074c92b$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $6da4c8ed3074c92b$var$_boundingExtentXYs(xs, ys, dest);
}
function $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $6da4c8ed3074c92b$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $6da4c8ed3074c92b$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $6da4c8ed3074c92b$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $6da4c8ed3074c92b$export$3c49c185de0c2bfc(projectionExtent);
        if ($6da4c8ed3074c92b$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}


/**
 * @module ol/geom/Point
 */ /**
 * @module ol/geom/SimpleGeometry
 */ /**
 * @module ol/geom/Geometry
 */ 

/**
 * @module ol/transform
 */ 
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $e22e7611e69f42a9$var$tmp_ = new Array(6);
function $e22e7611e69f42a9$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $e22e7611e69f42a9$export$aad8462122ac592b(transform) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $e22e7611e69f42a9$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $e22e7611e69f42a9$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $e22e7611e69f42a9$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $e22e7611e69f42a9$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $e22e7611e69f42a9$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $e22e7611e69f42a9$export$dcdf75081b88279d(transform, x, y) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, x, 0, 0, y, 0, 0));
}
function $e22e7611e69f42a9$export$3e4e33ea14aeb531(target, x, y) {
    return $e22e7611e69f42a9$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $e22e7611e69f42a9$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $e22e7611e69f42a9$export$2060d2db72cce88f(transform, $e22e7611e69f42a9$export$adaa4cf7ef1b65be($e22e7611e69f42a9$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $e22e7611e69f42a9$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $e22e7611e69f42a9$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $e22e7611e69f42a9$export$f84e8e69fd4488a5($e22e7611e69f42a9$export$f672e0b6f7222cd7($e22e7611e69f42a9$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $e22e7611e69f42a9$export$6897c284b6f9f4dc(source) {
    return $e22e7611e69f42a9$export$bd70ea2a93c0fa4(source, source);
}
function $e22e7611e69f42a9$export$bd70ea2a93c0fa4(target, source) {
    const det = $e22e7611e69f42a9$export$a04698f914c55ed9(source);
    (0, $35d5ec884318008e$export$a7a9523472993e97)(det !== 0, "Transformation matrix cannot be inverted");
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $e22e7611e69f42a9$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $e22e7611e69f42a9$var$matrixPrecision = [
    1e6,
    1e6,
    1e6,
    1e6,
    2,
    2
];
function $e22e7611e69f42a9$export$f84e8e69fd4488a5(mat) {
    const transformString = "matrix(" + mat.map((value, i)=>Math.round(value * $e22e7611e69f42a9$var$matrixPrecision[i]) / $e22e7611e69f42a9$var$matrixPrecision[i]).join(", ") + ")";
    return transformString;
}



/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ /**
 * @module ol/proj/Projection
 */ /**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $03edbd434a9e6608$var$unitByCode = {
    "9001": "m",
    "9002": "ft",
    "9003": "us-ft",
    "9101": "radians",
    "9102": "degrees"
};
function $03edbd434a9e6608$export$7f58726df3255edc(code) {
    return $03edbd434a9e6608$var$unitByCode[code];
}
const $03edbd434a9e6608$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    "radians": 6370997 / (2 * Math.PI),
    "degrees": 2 * Math.PI * 6370997 / 360,
    "ft": 0.3048,
    "m": 1,
    "us-ft": 1200 / 3937
};


/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj.get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4.register} function.
 *
 * @api
 */ class $6dc418afeec7068a$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : "enu";
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $03edbd434a9e6608$export$1482081eec883108)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $6dc418afeec7068a$export$2e2bcd8739ae039 = $6dc418afeec7068a$var$Projection;


/**
 * @module ol/proj/epsg3857
 */ 
const $84ad988f04807ab1$export$2d2c9be8b5b863f = 6378137;
const $84ad988f04807ab1$export$f3928063e5e96d35 = Math.PI * $84ad988f04807ab1$export$2d2c9be8b5b863f;
const $84ad988f04807ab1$export$21e6da8a7375dfe8 = [
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    -$84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35,
    $84ad988f04807ab1$export$f3928063e5e96d35
];
const $84ad988f04807ab1$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $84ad988f04807ab1$export$d26945d1ad52feeb = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $84ad988f04807ab1$var$EPSG3857Projection extends (0, $6dc418afeec7068a$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: "m",
            extent: $84ad988f04807ab1$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $84ad988f04807ab1$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $84ad988f04807ab1$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $84ad988f04807ab1$export$b508d7ad9a891c1b = [
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:3857"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:102100"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:102113"),
    new $84ad988f04807ab1$var$EPSG3857Projection("EPSG:900913"),
    new $84ad988f04807ab1$var$EPSG3857Projection("http://www.opengis.net/def/crs/EPSG/0/3857"),
    new $84ad988f04807ab1$var$EPSG3857Projection("http://www.opengis.net/gml/srs/epsg.xml#3857")
];
function $84ad988f04807ab1$export$1ff8bb36c0983070(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = $84ad988f04807ab1$export$f3928063e5e96d35 * input[i] / 180;
        let y = $84ad988f04807ab1$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $84ad988f04807ab1$export$d26945d1ad52feeb) y = $84ad988f04807ab1$export$d26945d1ad52feeb;
        else if (y < -$84ad988f04807ab1$export$d26945d1ad52feeb) y = -$84ad988f04807ab1$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $84ad988f04807ab1$export$8c71322ec28ed6b4(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / $84ad988f04807ab1$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $84ad988f04807ab1$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
const $b58ae362632b32c5$export$2d2c9be8b5b863f = 6378137;
const $b58ae362632b32c5$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $b58ae362632b32c5$export$1482081eec883108 = Math.PI * $b58ae362632b32c5$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $b58ae362632b32c5$var$EPSG4326Projection extends (0, $6dc418afeec7068a$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: "degrees",
            extent: $b58ae362632b32c5$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $b58ae362632b32c5$export$1482081eec883108,
            worldExtent: $b58ae362632b32c5$export$21e6da8a7375dfe8
        });
    }
}
const $b58ae362632b32c5$export$b508d7ad9a891c1b = [
    new $b58ae362632b32c5$var$EPSG4326Projection("CRS:84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("EPSG:4326", "neu"),
    new $b58ae362632b32c5$var$EPSG4326Projection("urn:ogc:def:crs:OGC:1.3:CRS84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("urn:ogc:def:crs:OGC:2:84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/def/crs/OGC/1.3/CRS84"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/gml/srs/epsg.xml#4326", "neu"),
    new $b58ae362632b32c5$var$EPSG4326Projection("http://www.opengis.net/def/crs/EPSG/0/4326", "neu")
];



/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $f5ec5c943d804ecb$var$cache = {};
function $f5ec5c943d804ecb$export$42ffd38884aecdac() {
    $f5ec5c943d804ecb$var$cache = {};
}
function $f5ec5c943d804ecb$export$3988ae62b71be9a3(code) {
    return $f5ec5c943d804ecb$var$cache[code] || $f5ec5c943d804ecb$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, "EPSG:$3")] || null;
}
function $f5ec5c943d804ecb$export$e16d8520af44a096(code, projection) {
    $f5ec5c943d804ecb$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $11b5dd198626e1de$var$transforms = {};
function $11b5dd198626e1de$export$42ffd38884aecdac() {
    $11b5dd198626e1de$var$transforms = {};
}
function $11b5dd198626e1de$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $11b5dd198626e1de$var$transforms)) $11b5dd198626e1de$var$transforms[sourceCode] = {};
    $11b5dd198626e1de$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $11b5dd198626e1de$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    delete $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    if ((0, $beaefe87199bb537$export$dd1bc94b04021eeb)($11b5dd198626e1de$var$transforms[sourceCode])) delete $11b5dd198626e1de$var$transforms[sourceCode];
    return transform;
}
function $11b5dd198626e1de$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    let transform;
    if (sourceCode in $11b5dd198626e1de$var$transforms && destinationCode in $11b5dd198626e1de$var$transforms[sourceCode]) transform = $11b5dd198626e1de$var$transforms[sourceCode][destinationCode];
    return transform;
}



/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $6b000a049d919fe5$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $6b000a049d919fe5$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $6b000a049d919fe5$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $6b000a049d919fe5$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $6b000a049d919fe5$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $6b000a049d919fe5$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $6b000a049d919fe5$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $6b000a049d919fe5$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $6b000a049d919fe5$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $6b000a049d919fe5$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $6b000a049d919fe5$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}
function $6b000a049d919fe5$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($6b000a049d919fe5$export$a81f732198733497(n, decimals));
}


/**
 * @module ol/coordinate
 */ 

/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $ff7180bdd45ebb19$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : "" + number;
    let decimal = numberString.indexOf(".");
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join("0") + numberString;
}
function $ff7180bdd45ebb19$export$66e1c0999abad646(v1, v2) {
    const s1 = ("" + v1).split(".");
    const s2 = ("" + v2).split(".");
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || "0", 10);
        const n2 = parseInt(s2[i] || "0", 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $1bd0a226f9a16141$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $1bd0a226f9a16141$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $1bd0a226f9a16141$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $1bd0a226f9a16141$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $6b000a049d919fe5$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $6b000a049d919fe5$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + "\xb0";
    if (min !== 0 || sec !== 0) hdms += " " + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(min, 2) + "\u2032";
    if (sec !== 0) hdms += " " + (0, $ff7180bdd45ebb19$export$24be126cb0a7bbeb)(sec, 2, decimals) + "\u2033";
    if (normalizedDegrees !== 0) hdms += " " + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $1bd0a226f9a16141$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace("{x}", coordinate[0].toFixed(fractionDigits)).replace("{y}", coordinate[1].toFixed(fractionDigits));
    return "";
}
function $1bd0a226f9a16141$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $1bd0a226f9a16141$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $1bd0a226f9a16141$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $1bd0a226f9a16141$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($1bd0a226f9a16141$export$88e6ebb4fe54f538(coord1, coord2));
}
function $1bd0a226f9a16141$export$6985570514055196(coordinate, segment) {
    return $1bd0a226f9a16141$export$88e6ebb4fe54f538(coordinate, $1bd0a226f9a16141$export$18cdd31d17f97131(coordinate, segment));
}
function $1bd0a226f9a16141$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $1bd0a226f9a16141$export$6eb0ac5f024d8590("NS", coordinate[1], fractionDigits) + " " + $1bd0a226f9a16141$export$6eb0ac5f024d8590("EW", coordinate[0], fractionDigits);
    return "";
}
function $1bd0a226f9a16141$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $1bd0a226f9a16141$export$d9468344d3651243(coordinate, "{x}, {y}", fractionDigits);
}
function $1bd0a226f9a16141$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projection.getExtent());
        const worldsAway = $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $1bd0a226f9a16141$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}


/**
 * @module ol/sphere
 */ 
const $fb75384508533d8f$export$63f2df7bd7371262 = 6371008.8;
function $fb75384508533d8f$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    const lat2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $fb75384508533d8f$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $fb75384508533d8f$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $fb75384508533d8f$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || "EPSG:3857";
    const type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
            break;
        case "LineString":
        case "LinearRing":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $fb75384508533d8f$var$getLengthInternal(coordinates, radius);
            break;
        case "MultiLineString":
        case "Polygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $fb75384508533d8f$var$getLengthInternal(coordinates[i], radius);
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $fb75384508533d8f$var$getLengthInternal(coords[j], radius);
            }
            break;
        case "GeometryCollection":
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $fb75384508533d8f$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $fb75384508533d8f$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $6b000a049d919fe5$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y1)) + Math.sin((0, $6b000a049d919fe5$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $fb75384508533d8f$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const projection = options.projection || "EPSG:3857";
    const type = geometry.getType();
    if (type !== "GeometryCollection") geometry = geometry.clone().transform(projection, "EPSG:4326");
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
        case "LinearRing":
            break;
        case "Polygon":
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coordinates[i], radius));
            break;
        case "MultiPolygon":
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($fb75384508533d8f$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($fb75384508533d8f$var$getAreaInternal(coords[j], radius));
            }
            break;
        case "GeometryCollection":
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $fb75384508533d8f$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return area;
}
function $fb75384508533d8f$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $fb75384508533d8f$export$63f2df7bd7371262;
    const lat1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[1]);
    const lon1 = (0, $6b000a049d919fe5$export$cba01ba138429a1d)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lon),
        (0, $6b000a049d919fe5$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $8c65b0699f3f3f8e$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels.info;
function $8c65b0699f3f3f8e$export$2c97a59140dbf245(l) {
    $8c65b0699f3f3f8e$var$level = $8c65b0699f3f3f8e$var$levels[l];
}
function $8c65b0699f3f3f8e$export$bef1f36f5486a6a3(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$c106dd0671a0fc2d(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $8c65b0699f3f3f8e$export$a3bc9b8ed74fc(...args) {
    if ($8c65b0699f3f3f8e$var$level > $8c65b0699f3f3f8e$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}


let $9c4744460e43e41b$var$showCoordinateWarning = true;
function $9c4744460e43e41b$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $9c4744460e43e41b$var$showCoordinateWarning = !hide;
}
function $9c4744460e43e41b$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $9c4744460e43e41b$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $9c4744460e43e41b$export$59ae956cd3e343f7(projection) {
    (0, $f5ec5c943d804ecb$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection, projection, $9c4744460e43e41b$export$dd516654c5f598fb);
}
function $9c4744460e43e41b$export$638ad73f7aafb913(projections) {
    projections.forEach($9c4744460e43e41b$export$59ae956cd3e343f7);
}
function $9c4744460e43e41b$export$3988ae62b71be9a3(projectionLike) {
    return typeof projectionLike === "string" ? (0, $f5ec5c943d804ecb$export$3988ae62b71be9a3)(/** @type {string} */ projectionLike) : /** @type {Projection} */ projectionLike || null;
}
function $9c4744460e43e41b$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $03edbd434a9e6608$export$1482081eec883108)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == "degrees" && !units || units == "degrees") pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $9c4744460e43e41b$export$e3c4995a701c26a3(projection, $9c4744460e43e41b$export$3988ae62b71be9a3("EPSG:4326"));
            if (toEPSG4326 === $9c4744460e43e41b$export$83e8ab53904f8022 && projUnits !== "degrees") // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $fb75384508533d8f$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $03edbd434a9e6608$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $9c4744460e43e41b$export$eeb8392580a05a37(projections) {
    $9c4744460e43e41b$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $11b5dd198626e1de$export$e16d8520af44a096)(source, destination, $9c4744460e43e41b$export$dd516654c5f598fb);
        });
    });
}
function $9c4744460e43e41b$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $11b5dd198626e1de$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $9c4744460e43e41b$export$4860237d10380594() {
    (0, $f5ec5c943d804ecb$export$42ffd38884aecdac)();
    (0, $11b5dd198626e1de$export$42ffd38884aecdac)();
}
function $9c4744460e43e41b$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $9c4744460e43e41b$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === "string") return $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $9c4744460e43e41b$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $9c4744460e43e41b$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destProj = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(sourceProj, destProj, $9c4744460e43e41b$export$6b4aafd331159e0d(forward));
    (0, $11b5dd198626e1de$export$e16d8520af44a096)(destProj, sourceProj, $9c4744460e43e41b$export$6b4aafd331159e0d(inverse));
}
function $9c4744460e43e41b$export$b15d9668511529b9(coordinate, projection) {
    $9c4744460e43e41b$export$ed949affbc7c4223();
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, "EPSG:4326", projection !== undefined ? projection : "EPSG:3857");
}
function $9c4744460e43e41b$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $9c4744460e43e41b$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : "EPSG:3857", "EPSG:4326");
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $6b000a049d919fe5$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $9c4744460e43e41b$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $9c4744460e43e41b$export$dd516654c5f598fb && equalUnits;
}
function $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection) {
    const sourceCode = sourceProjection.getCode();
    const destinationCode = destinationProjection.getCode();
    let transformFunc = (0, $11b5dd198626e1de$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (!transformFunc) transformFunc = $9c4744460e43e41b$export$83e8ab53904f8022;
    return transformFunc;
}
function $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(source);
    const destinationProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(destination);
    return $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $9c4744460e43e41b$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $9c4744460e43e41b$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $9c4744460e43e41b$export$fce0c6cfca85ed96(source, destination);
    return (0, $6da4c8ed3074c92b$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $9c4744460e43e41b$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $9c4744460e43e41b$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $9c4744460e43e41b$var$userProjection = null;
function $9c4744460e43e41b$export$d0aeadbeac54116e(projection) {
    $9c4744460e43e41b$var$userProjection = $9c4744460e43e41b$export$3988ae62b71be9a3(projection);
}
function $9c4744460e43e41b$export$1ae11279759d4e8f() {
    $9c4744460e43e41b$var$userProjection = null;
}
function $9c4744460e43e41b$export$3973b77d5f6f2790() {
    return $9c4744460e43e41b$var$userProjection;
}
function $9c4744460e43e41b$export$aa7494edfbe36197() {
    $9c4744460e43e41b$export$d0aeadbeac54116e("EPSG:4326");
}
function $9c4744460e43e41b$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return coordinate;
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) {
        if ($9c4744460e43e41b$var$showCoordinateWarning && !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $9c4744460e43e41b$var$showCoordinateWarning = false;
            (0, $8c65b0699f3f3f8e$export$c106dd0671a0fc2d)("Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.");
        }
        return coordinate;
    }
    return $9c4744460e43e41b$export$51186ad6e864892a(coordinate, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, sourceProjection, $9c4744460e43e41b$var$userProjection);
}
function $9c4744460e43e41b$export$494be3a3a25689ca(extent, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return extent;
    return $9c4744460e43e41b$export$751c68e0e0efff79(extent, $9c4744460e43e41b$var$userProjection, destProjection);
}
function $9c4744460e43e41b$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const sourceMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$9c4744460e43e41b$var$userProjection) return resolution;
    const destMetersPerUnit = $9c4744460e43e41b$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $9c4744460e43e41b$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $9c4744460e43e41b$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $1bd0a226f9a16141$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $9c4744460e43e41b$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $84ad988f04807ab1$export$b508d7ad9a891c1b));
    $9c4744460e43e41b$export$eeb8392580a05a37((0, $b58ae362632b32c5$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $9c4744460e43e41b$export$4856f21c2f184f24((0, $b58ae362632b32c5$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$b508d7ad9a891c1b), (0, $84ad988f04807ab1$export$1ff8bb36c0983070), (0, $84ad988f04807ab1$export$8c71322ec28ed6b4));
}
$9c4744460e43e41b$export$86eed449eb2dcac4();



/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ function $14c6e714516e527b$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $14c6e714516e527b$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $50db89a00eb954f6$var$tmpTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $50db89a00eb954f6$var$Geometry extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $013a1733c226ec50$export$ff83df6f9971435f)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        const coord = this.getClosestPoint([
            x,
            y
        ]);
        return coord[0] === x && coord[1] === y;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $6da4c8ed3074c92b$export$6a4fe494c558c238)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(source);
        const transformFn = sourceProj.getUnits() == "tile-pixels" ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $6da4c8ed3074c92b$export$c08559766941f856)(projectedExtent) / (0, $6da4c8ed3074c92b$export$c08559766941f856)(pixelExtent);
            (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)($50db89a00eb954f6$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $14c6e714516e527b$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $50db89a00eb954f6$var$tmpTransform, outCoordinates);
            return (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
        } : (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $50db89a00eb954f6$export$2e2bcd8739ae039 = $50db89a00eb954f6$var$Geometry;





/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $c76e993e57efc8c4$var$SimpleGeometry extends (0, $50db89a00eb954f6$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = "XY";
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = "XY";
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $c76e993e57efc8c4$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith("XYZ") ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $14c6e714516e527b$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $c76e993e57efc8c4$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = "XY";
    else if (stride == 3) layout = "XYZ";
    else if (stride == 4) layout = "XYZM";
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $c76e993e57efc8c4$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == "XY") stride = 2;
    else if (layout == "XYZ" || layout == "XYM") stride = 3;
    else if (layout == "XYZM") stride = 4;
    return /** @type {number} */ stride;
}
function $c76e993e57efc8c4$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $c76e993e57efc8c4$export$2e2bcd8739ae039 = $c76e993e57efc8c4$var$SimpleGeometry;



/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $6b086aa46281540d$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $6b086aa46281540d$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $6b086aa46281540d$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $6b086aa46281540d$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}



/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $6eced4c969949f6b$var$Point extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new $6eced4c969949f6b$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "Point";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $6da4c8ed3074c92b$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $6eced4c969949f6b$export$2e2bcd8739ae039 = $6eced4c969949f6b$var$Point;


/**
 * @module ol/source/Vector
 */ /**
 * @module ol/Collection
 */ 
/**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $161dd067fe2d672c$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: "add",
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: "remove"
};



/**
 * @enum {string}
 * @private
 */ const $931ffc4e747c14db$var$Property = {
    LENGTH: "length"
};
class $931ffc4e747c14db$export$a87ae6eb2761ec6d extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $931ffc4e747c14db$var$Collection extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ? array : [];
        if (this.unique_) for(let i = 0, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($931ffc4e747c14db$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error("Index out of bounds: " + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        if (this.unique_) this.assertUnique_(elem);
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error("Index out of bounds: " + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $931ffc4e747c14db$export$a87ae6eb2761ec6d((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($931ffc4e747c14db$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        for(let i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== except) throw new Error("Duplicate item added to a unique collection");
        }
    }
}
var $931ffc4e747c14db$export$2e2bcd8739ae039 = $931ffc4e747c14db$var$Collection;






/**
 * @module ol/structs/RBush
 */ var $176ca75ee9f69668$exports = {};
!function(t, i) {
    $176ca75ee9f69668$exports = i();
}($176ca75ee9f69668$exports, function() {
    "use strict";
    function t(e, h, r = 0, s = e.length - 1, a = n) {
        for(; s > r;){
            if (s - r > 600) {
                const i = s - r + 1, n = h - r + 1, o = Math.log(i), l = .5 * Math.exp(2 * o / 3), c = .5 * Math.sqrt(o * l * (i - l) / i) * (n - i / 2 < 0 ? -1 : 1);
                t(e, h, Math.max(r, Math.floor(h - n * l / i + c)), Math.min(s, Math.floor(h + (i - n) * l / i + c)), a);
            }
            const n = e[h];
            let o = r, l = s;
            for(i(e, r, h), a(e[s], n) > 0 && i(e, r, s); o < l;){
                for(i(e, o, l), o++, l--; a(e[o], n) < 0;)o++;
                for(; a(e[l], n) > 0;)l--;
            }
            0 === a(e[r], n) ? i(e, r, l) : (l++, i(e, l, s)), l <= h && (r = l + 1), h <= l && (s = l - 1);
        }
    }
    function i(t, i, n) {
        const e = t[i];
        t[i] = t[n], t[n] = e;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(let e = 0; e < i.length; e++)if (n(t, i[e])) return e;
        return -1;
    }
    function h(t, i) {
        r(t, 0, t.children.length, i, t);
    }
    function r(t, i, n, e, h) {
        h || (h = d(null)), h.minX = 1 / 0, h.minY = 1 / 0, h.maxX = -1 / 0, h.maxY = -1 / 0;
        for(let r = i; r < n; r++){
            const i = t.children[r];
            s(h, t.leaf ? e(i) : i);
        }
        return h;
    }
    function s(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function a(t, i) {
        return t.minX - i.minX;
    }
    function o(t, i) {
        return t.minY - i.minY;
    }
    function l(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function c(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        const n = Math.max(t.minX, i.minX), e = Math.max(t.minY, i.minY), h = Math.min(t.maxX, i.maxX), r = Math.min(t.maxY, i.maxY);
        return Math.max(0, h - n) * Math.max(0, r - e);
    }
    function f(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function u(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function d(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function x(i, n, e, h, r) {
        const s = [
            n,
            e
        ];
        for(; s.length;){
            if ((e = s.pop()) - (n = s.pop()) <= h) continue;
            const a = n + Math.ceil((e - n) / h / 2) * h;
            t(i, a, n, e, r), s.push(n, a, a, e);
        }
    }
    return class {
        constructor(t = 9){
            this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
        }
        all() {
            return this._all(this.data, []);
        }
        search(t) {
            let i = this.data;
            const n = [];
            if (!u(t, i)) return n;
            const e = this.toBBox, h = [];
            for(; i;){
                for(let r = 0; r < i.children.length; r++){
                    const s = i.children[r], a = i.leaf ? e(s) : s;
                    u(t, a) && (i.leaf ? n.push(s) : f(t, a) ? this._all(s, n) : h.push(s));
                }
                i = h.pop();
            }
            return n;
        }
        collides(t) {
            let i = this.data;
            if (!u(t, i)) return !1;
            const n = [];
            for(; i;){
                for(let e = 0; e < i.children.length; e++){
                    const h = i.children[e], r = i.leaf ? this.toBBox(h) : h;
                    if (u(t, r)) {
                        if (i.leaf || f(t, r)) return !0;
                        n.push(h);
                    }
                }
                i = n.pop();
            }
            return !1;
        }
        load(t) {
            if (!t || !t.length) return this;
            if (t.length < this._minEntries) {
                for(let i = 0; i < t.length; i++)this.insert(t[i]);
                return this;
            }
            let i = this._build(t.slice(), 0, t.length - 1, 0);
            if (this.data.children.length) {
                if (this.data.height === i.height) this._splitRoot(this.data, i);
                else {
                    if (this.data.height < i.height) {
                        const t = this.data;
                        this.data = i, i = t;
                    }
                    this._insert(i, this.data.height - i.height - 1, !0);
                }
            } else this.data = i;
            return this;
        }
        insert(t) {
            return t && this._insert(t, this.data.height - 1), this;
        }
        clear() {
            return this.data = d([]), this;
        }
        remove(t, i) {
            if (!t) return this;
            let n = this.data;
            const h = this.toBBox(t), r = [], s = [];
            let a, o, l;
            for(; n || r.length;){
                if (n || (n = r.pop(), o = r[r.length - 1], a = s.pop(), l = !0), n.leaf) {
                    const h = e(t, n.children, i);
                    if (-1 !== h) return n.children.splice(h, 1), r.push(n), this._condense(r), this;
                }
                l || n.leaf || !f(n, h) ? o ? (a++, n = o.children[a], l = !1) : n = null : (r.push(n), s.push(a), a = 0, o = n, n = n.children[0]);
            }
            return this;
        }
        toBBox(t) {
            return t;
        }
        compareMinX(t, i) {
            return t.minX - i.minX;
        }
        compareMinY(t, i) {
            return t.minY - i.minY;
        }
        toJSON() {
            return this.data;
        }
        fromJSON(t) {
            return this.data = t, this;
        }
        _all(t, i) {
            const n = [];
            for(; t;)t.leaf ? i.push(...t.children) : n.push(...t.children), t = n.pop();
            return i;
        }
        _build(t, i, n, e) {
            const r = n - i + 1;
            let s, a = this._maxEntries;
            if (r <= a) return s = d(t.slice(i, n + 1)), h(s, this.toBBox), s;
            e || (e = Math.ceil(Math.log(r) / Math.log(a)), a = Math.ceil(r / Math.pow(a, e - 1))), s = d([]), s.leaf = !1, s.height = e;
            const o = Math.ceil(r / a), l = o * Math.ceil(Math.sqrt(a));
            x(t, i, n, l, this.compareMinX);
            for(let h = i; h <= n; h += l){
                const i = Math.min(h + l - 1, n);
                x(t, h, i, o, this.compareMinY);
                for(let n = h; n <= i; n += o){
                    const h = Math.min(n + o - 1, i);
                    s.children.push(this._build(t, n, h, e - 1));
                }
            }
            return h(s, this.toBBox), s;
        }
        _chooseSubtree(t, i, n, e) {
            for(; e.push(i), !i.leaf && e.length - 1 !== n;){
                let n, e = 1 / 0, s = 1 / 0;
                for(let a = 0; a < i.children.length; a++){
                    const o = i.children[a], c = l(o), m = (h = t, r = o, (Math.max(r.maxX, h.maxX) - Math.min(r.minX, h.minX)) * (Math.max(r.maxY, h.maxY) - Math.min(r.minY, h.minY)) - c);
                    m < s ? (s = m, e = c < e ? c : e, n = o) : m === s && c < e && (e = c, n = o);
                }
                i = n || i.children[0];
            }
            var h, r;
            return i;
        }
        _insert(t, i, n) {
            const e = n ? t : this.toBBox(t), h = [], r = this._chooseSubtree(e, this.data, i, h);
            for(r.children.push(t), s(r, e); i >= 0 && h[i].children.length > this._maxEntries;)this._split(h, i), i--;
            this._adjustParentBBoxes(e, h, i);
        }
        _split(t, i) {
            const n = t[i], e = n.children.length, r = this._minEntries;
            this._chooseSplitAxis(n, r, e);
            const s = this._chooseSplitIndex(n, r, e), a = d(n.children.splice(s, n.children.length - s));
            a.height = n.height, a.leaf = n.leaf, h(n, this.toBBox), h(a, this.toBBox), i ? t[i - 1].children.push(a) : this._splitRoot(n, a);
        }
        _splitRoot(t, i) {
            this.data = d([
                t,
                i
            ]), this.data.height = t.height + 1, this.data.leaf = !1, h(this.data, this.toBBox);
        }
        _chooseSplitIndex(t, i, n) {
            let e, h = 1 / 0, s = 1 / 0;
            for(let a = i; a <= n - i; a++){
                const i = r(t, 0, a, this.toBBox), o = r(t, a, n, this.toBBox), c = m(i, o), f = l(i) + l(o);
                c < h ? (h = c, e = a, s = f < s ? f : s) : c === h && f < s && (s = f, e = a);
            }
            return e || n - i;
        }
        _chooseSplitAxis(t, i, n) {
            const e = t.leaf ? this.compareMinX : a, h = t.leaf ? this.compareMinY : o;
            this._allDistMargin(t, i, n, e) < this._allDistMargin(t, i, n, h) && t.children.sort(e);
        }
        _allDistMargin(t, i, n, e) {
            t.children.sort(e);
            const h = this.toBBox, a = r(t, 0, i, h), o = r(t, n - i, n, h);
            let l = c(a) + c(o);
            for(let e = i; e < n - i; e++){
                const i = t.children[e];
                s(a, t.leaf ? h(i) : i), l += c(a);
            }
            for(let e = n - i - 1; e >= i; e--){
                const i = t.children[e];
                s(o, t.leaf ? h(i) : i), l += c(o);
            }
            return l;
        }
        _adjustParentBBoxes(t, i, n) {
            for(let e = n; e >= 0; e--)s(i[e], t);
        }
        _condense(t) {
            for(let i, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (i = t[n - 1].children, i.splice(i.indexOf(t[n]), 1)) : this.clear() : h(t[n], this.toBBox);
        }
    };
});





/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class $34c742891733e7a4$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $6c5e11070e371322$export$5e82334337e0f204)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): *} callback Callback.
   * @return {*} Callback return value.
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): *} callback Callback.
   * @private
   * @return {*} Callback return value.
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $34c742891733e7a4$export$2e2bcd8739ae039 = $34c742891733e7a4$var$RBush;


/**
 * @module ol/render/Feature
 */ 
/**
 * @module ol/geom/LineString
 */ 
/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf5604c1b8258b71$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $bf5604c1b8258b71$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf5604c1b8258b71$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $bf5604c1b8258b71$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf5604c1b8258b71$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $bf5604c1b8258b71$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf5604c1b8258b71$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $bf5604c1b8258b71$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}




/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $8780aae6970f5f65$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $6b000a049d919fe5$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $8780aae6970f5f65$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $8780aae6970f5f65$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $8780aae6970f5f65$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $8780aae6970f5f65$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}



/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $3e64078bffae1cbd$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $5454470599558ddd$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $5454470599558ddd$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $5454470599558ddd$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/interpolate
 */ 

function $43ed5485a1d0c509$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $b998d41b678ed5d1$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $43ed5485a1d0c509$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $43ed5485a1d0c509$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}


/**
 * @module ol/geom/flat/intersectsextent
 */ 

/**
 * @module ol/geom/flat/contains
 */ 
function $239aa88e7a573859$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($239aa88e7a573859$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $239aa88e7a573859$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($239aa88e7a573859$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


function $acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent) {
    const coordinatesExtent = (0, $6da4c8ed3074c92b$export$30570204156ffd18)((0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if ((0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(extent, coordinatesExtent)) return true;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) return true;
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $6da4c8ed3074c92b$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $acee589e5b390c5c$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $239aa88e7a573859$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$acee589e5b390c5c$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $239aa88e7a573859$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$acee589e5b390c5c$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $acee589e5b390c5c$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($acee589e5b390c5c$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $bf04349d827c1d16$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $bf04349d827c1d16$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}


/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $292e4002746c8223$var$LineString extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new $292e4002746c8223$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $3e64078bffae1cbd$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != "XYM" && this.layout != "XYZM") return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $43ed5485a1d0c509$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $43ed5485a1d0c509$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $292e4002746c8223$var$LineString(simplifiedFlatCoordinates, "XY");
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "LineString";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $292e4002746c8223$export$2e2bcd8739ae039 = $292e4002746c8223$var$LineString;

/**
 * @module ol/geom/MultiLineString
 */ 









/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $b4c0e2e13beea46e$var$MultiLineString extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new $b4c0e2e13beea46e$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != "XYM" && this.layout != "XYZM" || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $43ed5485a1d0c509$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $b4c0e2e13beea46e$var$MultiLineString(simplifiedFlatCoordinates, "XY", simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "MultiLineString";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $b4c0e2e13beea46e$export$2e2bcd8739ae039 = $b4c0e2e13beea46e$var$MultiLineString;

/**
 * @module ol/geom/MultiPoint
 */ 






/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $e6080c63a9451eda$var$MultiPoint extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new $e6080c63a9451eda$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "MultiPoint";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $6da4c8ed3074c92b$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $e6080c63a9451eda$export$2e2bcd8739ae039 = $e6080c63a9451eda$var$MultiPoint;

/**
 * @module ol/geom/MultiPolygon
 */ 
/**
 * @module ol/geom/Polygon
 */ /**
 * @module ol/geom/LinearRing
 */ 





/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $01ff26a2f986a1d0$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $01ff26a2f986a1d0$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $548636579b4087f2$var$LinearRing extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new $548636579b4087f2$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $5454470599558ddd$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $548636579b4087f2$var$LinearRing(simplifiedFlatCoordinates, "XY");
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "LinearRing";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $6b086aa46281540d$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $548636579b4087f2$export$2e2bcd8739ae039 = $548636579b4087f2$var$LinearRing;








/**
 * @module ol/geom/flat/interiorpoint
 */ 

function $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $239aa88e7a573859$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $2166f19777f69377$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $2166f19777f69377$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}




/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $155dc783a4ec227e$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $7892dc06ffd23218$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$7892dc06ffd23218$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $155dc783a4ec227e$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $7892dc06ffd23218$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $7892dc06ffd23218$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $7892dc06ffd23218$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $7892dc06ffd23218$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}







/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $40aa8d43bbe572bf$var$Polygon extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new $40aa8d43bbe572bf$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $239aa88e7a573859$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $5454470599558ddd$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $2166f19777f69377$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), "XYM");
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $548636579b4087f2$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $548636579b4087f2$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $7892dc06ffd23218$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $40aa8d43bbe572bf$var$Polygon(simplifiedFlatCoordinates, "XY", simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "Polygon";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $40aa8d43bbe572bf$export$2e2bcd8739ae039 = $40aa8d43bbe572bf$var$Polygon;
function $40aa8d43bbe572bf$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, (0, $fb75384508533d8f$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$c16b671815801c75(extent) {
    if ((0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(extent)) throw new Error("Cannot create polygon from empty extent");
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, "XY", [
        flatCoordinates.length
    ]);
}
function $40aa8d43bbe572bf$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $40aa8d43bbe572bf$var$Polygon(flatCoordinates, layout, ends);
    $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $40aa8d43bbe572bf$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $6b000a049d919fe5$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}












/**
 * @module ol/geom/flat/center
 */ 
function $9825fadaf3b68c4e$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}




/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $f73f35eb6af8b987$var$MultiPolygon extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $f73f35eb6af8b987$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf5604c1b8258b71$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf5604c1b8258b71$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $239aa88e7a573859$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $01ff26a2f986a1d0$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $5454470599558ddd$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $9825fadaf3b68c4e$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), "XYM");
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $7892dc06ffd23218$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $f73f35eb6af8b987$var$MultiPolygon(simplifiedFlatCoordinates, "XY", simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "MultiPolygon";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $acee589e5b390c5c$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $6b086aa46281540d$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $f73f35eb6af8b987$export$2e2bcd8739ae039 = $f73f35eb6af8b987$var$MultiPolygon;













/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $36d6c36c1f9ad5d9$var$tmpTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $36d6c36c1f9ad5d9$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === "Point" ? (0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $6da4c8ed3074c92b$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$50e3b25928a5e892)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $7892dc06ffd23218$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $9825fadaf3b68c4e$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $2166f19777f69377$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $43ed5485a1d0c509$export$687ff82efd78795b)(flatCoordinates, offset, end, 2, 0.5);
                (0, $b998d41b678ed5d1$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $6da4c8ed3074c92b$export$c08559766941f856)(projectedExtent) / (0, $6da4c8ed3074c92b$export$c08559766941f856)(pixelExtent);
            (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)($36d6c36c1f9ad5d9$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $14c6e714516e527b$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $36d6c36c1f9ad5d9$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $013a1733c226ec50$export$ff83df6f9971435f)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case "LineString":
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case "MultiLineString":
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case "Polygon":
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $8780aae6970f5f65$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $36d6c36c1f9ad5d9$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getFlatCoordinates = $36d6c36c1f9ad5d9$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case "Point":
            return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case "MultiPoint":
            return new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY");
        case "LineString":
            return new (0, $292e4002746c8223$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY");
        case "MultiLineString":
            return new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), "XY", /** @type {Array<number>} */ renderFeature.getEnds());
        case "Polygon":
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $7892dc06ffd23218$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)(flatCoordinates, "XY", endss) : new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(flatCoordinates, "XY", ends);
        default:
            throw new Error("Invalid geometry type:" + geometryType);
    }
}
function $36d6c36c1f9ad5d9$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $36d6c36c1f9ad5d9$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $36d6c36c1f9ad5d9$export$2e2bcd8739ae039 = $36d6c36c1f9ad5d9$var$RenderFeature;


/**
 * @module ol/source/Source
 */ 

/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $ed6dc99f268f3882$var$Source extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : "ready";
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $ed6dc99f268f3882$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $ed6dc99f268f3882$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === "function") return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
var $ed6dc99f268f3882$export$2e2bcd8739ae039 = $ed6dc99f268f3882$var$Source;


/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $ccc4e6f11f11978f$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: "addfeature",
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: "changefeature",
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: "clear",
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: "removefeature",
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: "featuresloadstart",
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: "featuresloadend",
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: "featuresloaderror"
};



/**
 * @module ol/loadingstrategy
 */ 
function $eb51d0a16123ee90$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $eb51d0a16123ee90$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $eb51d0a16123ee90$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $9c4744460e43e41b$export$bd1cd3b88140b906)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $9c4744460e43e41b$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $9c4744460e43e41b$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}








/**
 * @module ol/featureloader
 */ 
/**
 *
 * @type {boolean}
 * @private
 */ let $588823c001569193$var$withCredentials = false;
function $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", typeof url === "function" ? url(extent, resolution, projection) : url, true);
    if (format.getType() == "arraybuffer") xhr.responseType = "arraybuffer";
    xhr.withCredentials = $588823c001569193$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == "text" || type == "json") source = xhr.responseText;
                else if (type == "xml") source = xhr.responseXML || xhr.responseText;
                else if (type == "arraybuffer") source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $588823c001569193$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   */ return function(extent, resolution, projection, success, failure) {
        const source = /** @type {import("./source/Vector").default<FeatureType>} */ this;
        $588823c001569193$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ function(features, dataProjection) {
            source.addFeatures(features);
            if (success !== undefined) success(features);
        }, /* FIXME handle error */ failure ? failure : (0, $013a1733c226ec50$export$1cd1943b3a73bbe8));
    };
}
function $588823c001569193$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $588823c001569193$var$withCredentials = xhrWithCredentials;
}


class $84888e4daf3fdf44$export$d402fd02dc2b661c extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $84888e4daf3fdf44$var$VectorSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: "ready",
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<FeatureType>}
     */ this.loader_ = (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.format_, "`format` must be set when `url` is set");
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $588823c001569193$export$14cc81df70b6707e)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $eb51d0a16123ee90$export$84bf76cd7afc7469);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $34c742891733e7a4$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(feature, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), "The passed `feature` was already added to the source");
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            const removeAndIgnoreReturn = (feature)=>{
                this.removeFeatureInternal(feature);
            };
            this.featuresRtree_.forEach(removeAndIgnoreReturn);
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $b998d41b678ed5d1$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<import("../Feature.js").default>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $6da4c8ed3074c92b$export$9031237f01de0947)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType} Closest feature.
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $013a1733c226ec50$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_.getExtent(extent);
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $6c5e11070e371322$export$5e82334337e0f204)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        let obj;
        loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(object.extent, extent)) {
                obj = object;
                return true;
            }
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE)) this.dispatchEvent(new $84888e4daf3fdf44$export$d402fd02dc2b661c((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader<FeatureType>} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(this.format_, "`format` must be set when `url` is set");
        this.url_ = url;
        this.setLoader((0, $588823c001569193$export$14cc81df70b6707e)(url, this.format_));
    }
}
var $84888e4daf3fdf44$export$2e2bcd8739ae039 = $84888e4daf3fdf44$var$VectorSource;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
var $e786e20e25c5f221$exports = {};
/**!
* @license
* The MIT License (MIT)
* 
* Copyright (c) 2017 Måns Beckman - www.spatialillusions.com
* 
* Permission is hereby granted, free of charge, to any person obtaining a copy
* of this software and associated documentation files (the "Software"), to deal
* in the Software without restriction, including without limitation the rights
* to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the Software is
* furnished to do so, subject to the following conditions:
* 
* The above copyright notice and this permission notice shall be included in all
* copies or substantial portions of the Software.
* 
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
* IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
* AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
* LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
* OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
* SOFTWARE.
* 
* More information can be found at www.spatialillusions.com 
*/ 
var $hPtJY = parcelRequire("hPtJY");
!function(I, t) {
    $e786e20e25c5f221$exports = t();
}($e786e20e25c5f221$exports, function() {
    "use strict";
    var t = {
        Black: {
            Civilian: "black",
            Friend: "black",
            Hostile: "black",
            Neutral: "black",
            Unknown: "black"
        },
        Dark: {
            Civilian: "rgb(80,0,80)",
            Friend: "rgb(0,107,140)",
            Hostile: "rgb(200,0,0)",
            Neutral: "rgb(0,160,0)",
            Unknown: "rgb(225,220,0)"
        },
        FrameColor: {
            Civilian: "rgb(255,0,255)",
            Friend: "rgb(0, 255, 255)",
            Hostile: "rgb(255, 0, 0)",
            Neutral: "rgb(0, 255, 0)",
            Unknown: "rgb(255, 255, 0)"
        },
        IconColor: {
            Civilian: "rgb(255,0,255)",
            Friend: "rgb(0, 255, 255)",
            Hostile: "rgb(255, 0, 0)",
            Neutral: "rgb(0, 255, 0)",
            Unknown: "rgb(255, 255, 0)"
        },
        Light: {
            Civilian: "rgb(255,161,255)",
            Friend: "rgb(128,224,255)",
            Hostile: "rgb(255,128,128)",
            Neutral: "rgb(170,255,170)",
            Unknown: "rgb(255,255,128)"
        },
        Medium: {
            Civilian: "rgb(128,0,128)",
            Friend: "rgb(0,168,220)",
            Hostile: "rgb(255,48,49)",
            Neutral: "rgb(0,226,110)",
            Unknown: "rgb(255,255,0)"
        },
        None: {
            Civilian: !1,
            Friend: !1,
            Hostile: !1,
            Neutral: !1,
            Unknown: !1
        },
        OffWhite: {
            Civilian: "rgb(239, 239, 239)",
            Friend: "rgb(239, 239, 239)",
            Hostile: "rgb(239, 239, 239)",
            Neutral: "rgb(239, 239, 239)",
            Unknown: "rgb(239, 239, 239)"
        },
        White: {
            Civilian: "white",
            Friend: "white",
            Hostile: "white",
            Neutral: "white",
            Unknown: "white"
        }
    };
    function E(I) {
        var t, E = [], R = [], e = this.colors.frameColor[this.metadata.affiliation];
        if (!this.metadata.frame && this.style.icon || void 0 === this.metadata.baseGeometry.g.type) return {
            pre: E,
            post: R,
            bbox: this.metadata.baseGeometry.bbox
        };
        var A, C = {
            type: this.metadata.baseGeometry.g.type
        };
        switch(C.type){
            case "path":
                C.d = this.metadata.baseGeometry.g.d;
                break;
            case "circle":
                C.cx = this.metadata.baseGeometry.g.cx, C.cy = this.metadata.baseGeometry.g.cy, C.r = this.metadata.baseGeometry.g.r;
        }
        (C.fill = this.colors.fillColor[this.metadata.affiliation], C.fillopacity = this.style.fillOpacity, C.stroke = e, C.strokewidth = 10 <= this.style.size ? this.style.strokeWidth : 10, this.style.frame && 0 < this.style.outlineWidth) && ("path" == C.type && this.metadata.fill && !this.style.monoColor ? ((A = {
            type: this.metadata.baseGeometry.g.type
        }).d = this.metadata.baseGeometry.g.d + " Z", A.strokewidth = 10 <= this.style.size ? this.style.strokeWidth : 10) : A = C, E.push(I.outline(A, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)));
        if ("" == this.style.monoColor && this.style.fill || !this.metadata.notpresent || (C.strokedasharray = this.metadata.notpresent), R.push(C), this.metadata.space && (t = {
            Friend: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "M 100,30 C 90,30 80,35 68.65625,50 l 62.6875,0 C 120,35 110,30 100,30"
            },
            Hostile: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "M67,50 L100,20 133,50 z"
            },
            Neutral: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "M45,50 l0,-20 110,0 0,20 z"
            },
            Unknown: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "M 100 22.5 C 85 22.5 70 31.669211 66 50 L 134 50 C 130 31.669204 115 22.5 100 22.5 z"
            }
        }, R.push(t[this.metadata.affiliation])), this.metadata.activity && (t = {
            Friend: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "m 160,135 0,15 15,0 0,-15 z m -135,0 15,0 0,15 -15,0 z m 135,-85 0,15 15,0 0,-15 z m -135,0 15,0 0,15 -15,0 z"
            },
            Hostile: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "M 100 28 L 89.40625 38.59375 L 100 49.21875 L 110.59375 38.59375 L 100 28 z M 38.6875 89.3125 L 28.0625 99.9375 L 38.6875 110.53125 L 49.28125 99.9375 L 38.6875 89.3125 z M 161.40625 89.40625 L 150.78125 100 L 161.40625 110.59375 L 172 100 L 161.40625 89.40625 z M 99.9375 150.71875 L 89.3125 161.3125 L 99.9375 171.9375 L 110.53125 161.3125 L 99.9375 150.71875"
            },
            Neutral: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "m 140,140 15,0 0,15 -15,0 z m -80,0 0,15 -15,0 0,-15 z m 80,-80 0,-15 15,0 0,15 z m -80,0 -15,0 0,-15 15,0 z"
            },
            Unknown: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "M 107.96875 31.46875 L 92.03125 31.71875 L 92.03125 46.4375 L 107.71875 46.4375 L 107.96875 31.46875 z M 47.03125 92.5 L 31.09375 92.75 L 31.09375 107.5 L 46.78125 107.5 L 47.03125 92.5 z M 168.4375 92.5 L 152.5 92.75 L 152.5 107.5 L 168.1875 107.5 L 168.4375 92.5 z M 107.96875 153.5625 L 92.03125 153.8125 L 92.03125 168.53125 L 107.71875 168.53125 L 107.96875 153.5625 z"
            }
        }, R.push(t[this.metadata.affiliation])), this.metadata.cyberspace && (t = {
            Friend: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "m 135,150 40,-40 0,40 z"
            },
            Hostile: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "m 150,78 0,44 22,-22 z"
            },
            Neutral: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "m 115,155 40,-40 0,40 z"
            },
            Unknown: {
                type: "path",
                stroke: !1,
                fill: e,
                d: "M 150 65.7 L 150 134 C 176 123 176 77.2 150 65.7 z"
            }
        }, R.push(t[this.metadata.affiliation])), this.style.fill && this.style.frame && this.metadata.notpresent && !this.metadata.unframed) {
            switch((C = {
                type: this.metadata.baseGeometry.g.type
            }).type){
                case "path":
                    C.d = this.metadata.baseGeometry.g.d;
                    break;
                case "circle":
                    C.cx = this.metadata.baseGeometry.g.cx, C.cy = this.metadata.baseGeometry.g.cy, C.r = this.metadata.baseGeometry.g.r;
            }
            C.fill = !1, C.stroke = this.colors.white[this.metadata.affiliation], C.strokewidth = parseFloat(this.style.strokeWidth) + 1, C.strokedasharray = this.metadata.notpresent, R.push(C);
        }
        return {
            pre: E,
            post: R,
            bbox: this.metadata.baseGeometry.bbox
        };
    }
    function R(I) {
        var t, E, R = [], e = [], A = new I.BBox({
            x1: 50,
            x2: 150,
            y1: 50,
            y2: 150
        }), C = [], T = [], S = [], N = [];
        if (this.style.icon) {
            var O = this.colors.fillColor[this.metadata.affiliation], G = this.colors.fillColor.Neutral;
            E = this.colors.iconColor[this.metadata.affiliation];
            var o = this.colors.iconFillColor[this.metadata.affiliation], M = this.colors.none[this.metadata.affiliation], i = this.colors.black[this.metadata.affiliation], L = this.colors.white[this.metadata.affiliation], s = (this.metadata.STD2525 ? "2525" : "APP6") + "," + this.metadata.dimension + this.metadata.affiliation + this.metadata.notpresent + this.metadata.numberSIDC + ",frame:" + this.style.frame + ",alternateMedal:" + this.style.alternateMedal + ",colors:{fillcolor:" + O + ",neutralColor" + G + ",iconColor:" + E + ",iconFillColor:" + o + ",none:" + M + ",black:" + i + ",white:" + L + "}";
            if (C = I._iconCache.hasOwnProperty(s) ? I._iconCache[s].iconParts : (I._iconCache[s] = {}, I._iconCache[s].iconParts = I._getIconParts(this.metadata, this.colors, this.metadata.STD2525, this.style.monoColor, this.style.alternateMedal)), this.metadata.numberSIDC || (-1 != [
                "WMGX--",
                "WMMX--",
                "WMFX--",
                "WMX---",
                "WMSX--"
            ].indexOf(this.metadata.functionid) && (A.y1 = 10, "Unknown" != this.metadata.affiliation && (A.x2 = this.metadata.baseGeometry.bbox.x2 + 20)), I._iconCache[s].hasOwnProperty("letterSIDC") ? (t = I._iconCache[s].letterSIDC.icons, N = I._iconCache[s].letterSIDC.bbox) : "function" == typeof I._getIcons.letter ? (I._iconCache[s].letterSIDC = I._getIcons.letter(I, C, this.metadata.STD2525), t = I._iconCache[s].letterSIDC.icons, N = I._iconCache[s].letterSIDC.bbox) : console.warn("ms._getIcons.letter() is not present, you will need to load functionality for letter based SIDCs")), this.metadata.numberSIDC) {
                var n = String(this.options.sidc).substr(4, 2);
                I._iconCache[s].hasOwnProperty("numberSIDC") ? I._iconCache[s].numberSIDC.symbolSet.hasOwnProperty(n) ? (t = I._iconCache[s].numberSIDC.symbolSet[n].icons, T = I._iconCache[s].numberSIDC.symbolSet[n].m1, S = I._iconCache[s].numberSIDC.symbolSet[n].m2, N = I._iconCache[s].numberSIDC.symbolSet[n].bbox) : "function" == typeof I._getIcons.number ? (I._iconCache[s].numberSIDC.symbolSet[n] = I._getIcons.number(I, n, C, this.metadata.STD2525), t = I._iconCache[s].numberSIDC.symbolSet[n].icons, T = I._iconCache[s].numberSIDC.symbolSet[n].m1, S = I._iconCache[s].numberSIDC.symbolSet[n].m2, N = I._iconCache[s].numberSIDC.symbolSet[n].bbox) : console.warn("ms._getIcons.number() is not present, you will need to load functionality for number based SIDCs") : (I._iconCache[s].numberSIDC = {}, I._iconCache[s].numberSIDC.symbolSet = {}, "function" == typeof I._getIcons.number ? (I._iconCache[s].numberSIDC.symbolSet[n] = I._getIcons.number(I, n, C, this.metadata.STD2525), t = I._iconCache[s].numberSIDC.symbolSet[n].icons, T = I._iconCache[s].numberSIDC.symbolSet[n].m1, S = I._iconCache[s].numberSIDC.symbolSet[n].m2, N = I._iconCache[s].numberSIDC.symbolSet[n].bbox) : console.warn("ms._getIcons.number() is not present, you will need to load functionality for number based SIDCs"));
            }
            var a = [
                {
                    type: "path",
                    stroke: !1,
                    fill: E = this.colors.iconColor[this.metadata.affiliation],
                    d: "m 94.8206,78.1372 c -0.4542,6.8983 0.6532,14.323 5.3424,19.6985 4.509,5.6933 11.309,9.3573 14.98,15.7283 3.164,6.353 -0.09,14.245 -5.903,17.822 -7.268,4.817 -18.6219,2.785 -22.7328,-5.249 -1.5511,-2.796 -2.3828,-5.931 -2.8815,-9.071 -3.5048,0.416 -7.0093,0.835 -10.5142,1.252 0.8239,8.555 5.2263,17.287 13.2544,21.111 7.8232,3.736 17.1891,3.783 25.3291,1.052 8.846,-3.103 15.737,-11.958 15.171,-21.537 0.05,-6.951 -4.272,-12.85 -9.134,-17.403 -4.526,-4.6949 -11.048,-8.3862 -12.401,-15.2748 -1.215,-2.3639 -0.889,-8.129 -0.889,-8.129 z m -0.6253,-20.5177 0,11.6509 11.6527,0 0,-11.6509 z"
                }
            ];
            if (this.metadata.numberSIDC) {
                var l = t[this.metadata.functionid.substr(0, 6)];
                if (void 0 === l && 95 <= this.metadata.functionid.substr(4, 2) && (l = t[this.metadata.functionid.substr(0, 4) + "00"]), void 0 === l) "000000" != this.metadata.functionid.substr(0, 6) && "" != this.metadata.functionid.substr(0, 6) && (e.push(a), this.validIcon = !1);
                else {
                    var r = Number(this.metadata.functionid.substr(0, 6));
                    this.metadata.dismounted && 110301 <= r && r <= 110403 && ("00" != this.metadata.functionid.substr(6, 2) && "00" != this.metadata.functionid.substr(8, 2) && (l = [
                        I._scale(.5, l)
                    ]), "00" == this.metadata.functionid.substr(6, 2) && "00" != this.metadata.functionid.substr(8, 2) && (l = [
                        I._translate(0, -10, I._scale(.7, l))
                    ]), "00" != this.metadata.functionid.substr(6, 2) && "00" == this.metadata.functionid.substr(8, 2) && (l = [
                        I._translate(0, 10, I._scale(.7, l))
                    ])), e.push(l);
                }
                if (N.hasOwnProperty(this.metadata.functionid.substr(0, 6)) && (A = new I.BBox(N[this.metadata.functionid.substr(0, 6)])), "95" == this.metadata.functionid.substr(4, 2) && e.push(C["GR.IC.FF.HEADQUARTERS OR HEADQUARTERS ELEMENT"]), "96" == this.metadata.functionid.substr(4, 2) && e.push(C["GR.IC.FF.DIVISION AND BELOW SUPPORT"]), "97" == this.metadata.functionid.substr(4, 2) && e.push(C["GR.IC.FF.CORPS SUPPORT"]), "98" == this.metadata.functionid.substr(4, 2) && e.push(C["GR.IC.FF.THEATRE SUPPORT"]), "00" != this.metadata.functionid.substr(6, 2)) {
                    var P = T[this.metadata.functionid.substr(6, 2)];
                    void 0 === P ? this.validIcon = !1 : e.push(P);
                }
                if ("00" != this.metadata.functionid.substr(8, 2)) {
                    var y = S[this.metadata.functionid.substr(8, 2)];
                    void 0 === y ? this.validIcon = !1 : e.push(y);
                }
            } else {
                var c = this.options.sidc.substr(0, 1) + "-" + this.options.sidc.substr(2, 1) + "-" + this.options.sidc.substr(4, 6);
                t.hasOwnProperty(c) ? e.push(t[c]) : "------" != this.options.sidc.substr(4, 6) && "" != this.options.sidc.substr(4, 6) && (e.push(a), this.validIcon = !1), N[c] && (A = new I.BBox(N[c]));
            }
        }
        return this.style.frame && this.metadata.fill && !this.style.monoColor && !this.metadata.controlMeasure || 0 < this.style.outlineWidth && R.push(I.outline(e, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), {
            pre: R,
            post: e,
            bbox: A
        };
    }
    function e(I) {
        var t, E = [], R = [], e = new I.BBox(this.metadata.baseGeometry.bbox), A = this.style.frameColor ? this.style.frameColor[this.metadata.affiliation] : this.colors.iconColor[this.metadata.affiliation], C = new I.BBox, T = Number(this.style.hqStaffLength || I._hqStaffLength);
        if (this.metadata.headquarters && 0 < T) {
            var S = 100;
            -1 < [
                "AirFriend",
                "AirNeutral",
                "GroundFriend",
                "GroundNeutral",
                "SeaNeutral",
                "SubsurfaceNeutral"
            ].indexOf(this.metadata.dimension + this.metadata.affiliation) && (S = e.y2), this.metadata.dimensionType + this.metadata.affiliationType == "SubsurfaceFriend" && (S = e.y1), t = {
                type: "path",
                d: "M" + e.x1 + "," + S + " L" + e.x1 + "," + (e.y2 + T)
            }, 0 < this.style.outlineWidth && E.push(I.outline(t, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), R.push(t), C.y2 = e.y2 + T;
        }
        if (this.metadata.taskForce) {
            var N = {
                "Corps/MEF": 110,
                Army: 145,
                "Army Group/front": 180,
                "Region/Theater": 215
            };
            t = {
                type: "path",
                d: "M" + (100 - (N = N[this.metadata.echelon] || 90) / 2) + "," + e.y1 + " L" + (100 - N / 2) + "," + (e.y1 - 40) + " " + (100 + N / 2) + "," + (e.y1 - 40) + " " + (100 + N / 2) + "," + e.y1
            }, 0 < this.style.outlineWidth && E.push(I.outline(t, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), R.push(t), C.x1 = Math.min(e.x1, 100 - N / 2), C.x2 = Math.max(e.x2, 100 + N / 2), C.y1 = e.y1 - 40;
        }
        if (this.metadata.installation) {
            var O = 0;
            -1 < [
                "AirHostile",
                "GroundHostile",
                "SeaHostile"
            ].indexOf(this.metadata.dimension + this.metadata.affiliation) && (O = 14), -1 < [
                "AirUnknown",
                "GroundUnknown",
                "SeaUnknown",
                "AirFriend",
                "SeaFriend"
            ].indexOf(this.metadata.dimension + this.metadata.affiliation) && (O = 2), t = {
                type: "path",
                fill: A,
                d: "M85," + (e.y1 + O - this.style.strokeWidth / 2) + " 85," + (e.y1 - 10) + " 115," + (e.y1 - 10) + " 115," + (e.y1 + O - this.style.strokeWidth / 2) + " 100," + (e.y1 - this.style.strokeWidth) + " Z"
            }, 0 < this.style.outlineWidth && E.push(I.outline(t, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), R.push(t), C.merge({
                y1: e.y1 - 10
            });
        }
        if (this.metadata.feintDummy) {
            var G = e.y1 - 0 - e.width() / 2;
            t = {
                type: "path",
                strokedasharray: I._dashArrays.feintDummy,
                d: "M100," + G + " L" + e.x1 + "," + (e.y1 - 0) + " M100," + G + " L" + e.x2 + "," + (e.y1 - 0)
            }, 0 < this.style.outlineWidth && E.push(I.outline(t, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), R.push(t), C.merge({
                y1: G
            });
        }
        if (this.metadata.echelon) {
            var o = this.metadata.installation ? 15 : 0, M = {
                "Team/Crew": {
                    g: [
                        {
                            type: "circle",
                            cx: 100,
                            cy: e.y1 - 20,
                            r: 15
                        },
                        {
                            type: "path",
                            d: "M80," + (e.y1 - 10) + "L120," + (e.y1 - 30)
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 40 - o
                    }
                },
                Squad: {
                    g: [
                        {
                            type: "circle",
                            fill: A,
                            cx: 100,
                            cy: e.y1 - 20,
                            r: 7.5
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 20 - 7.5 - o
                    }
                },
                Section: {
                    g: [
                        {
                            type: "circle",
                            fill: A,
                            cx: 115,
                            cy: e.y1 - 20,
                            r: 7.5
                        },
                        {
                            type: "circle",
                            fill: A,
                            cx: 85,
                            cy: e.y1 - 20,
                            r: 7.5
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 20 - 7.5 - o
                    }
                },
                "Platoon/detachment": {
                    g: [
                        {
                            type: "circle",
                            fill: A,
                            cx: 100,
                            cy: e.y1 - 20,
                            r: 7.5
                        },
                        {
                            type: "circle",
                            fill: A,
                            cx: 70,
                            cy: e.y1 - 20,
                            r: 7.5
                        },
                        {
                            type: "circle",
                            fill: A,
                            cx: 130,
                            cy: e.y1 - 20,
                            r: 7.5
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 20 - 7.5 - o
                    }
                },
                "Company/battery/troop": {
                    g: [
                        {
                            type: "path",
                            d: "M100," + (e.y1 - 10) + "L100," + (e.y1 - 35)
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 40 - o
                    }
                },
                "Battalion/squadron": {
                    g: [
                        {
                            type: "path",
                            d: "M90," + (e.y1 - 10) + "L90," + (e.y1 - 35)
                        },
                        {
                            type: "path",
                            d: "M110," + (e.y1 - 10) + "L110," + (e.y1 - 35)
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 40 - o
                    }
                },
                "Regiment/group": {
                    g: [
                        {
                            type: "path",
                            d: "M100," + (e.y1 - 10) + "L100," + (e.y1 - 35)
                        },
                        {
                            type: "path",
                            d: "M120," + (e.y1 - 10) + "L120," + (e.y1 - 35)
                        },
                        {
                            type: "path",
                            d: "M80," + (e.y1 - 10) + "L80," + (e.y1 - 35)
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 40 - o
                    }
                },
                Brigade: {
                    g: [
                        {
                            type: "path",
                            d: "M87.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25"
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 15 - 25 - o
                    }
                },
                Division: {
                    g: [
                        {
                            type: "path",
                            d: "M70," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25   M105," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25"
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 15 - 25 - o,
                        x1: 70,
                        x2: 130
                    }
                },
                "Corps/MEF": {
                    g: [
                        {
                            type: "path",
                            d: "M52.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25    M87.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25    M122.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25"
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 15 - 25 - o,
                        x1: 52.5,
                        x2: 147.5
                    }
                },
                Army: {
                    g: [
                        {
                            type: "path",
                            d: "M35," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25   M70," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25   M105," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25    M140," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25"
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 15 - 25 - o,
                        x1: 35,
                        x2: 165
                    }
                },
                "Army Group/front": {
                    g: [
                        {
                            type: "path",
                            d: "M17.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25    M52.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25    M87.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25    M122.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25       M157.5," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25"
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 15 - 25 - o,
                        x1: 17.5,
                        x2: 182.5
                    }
                },
                "Region/Theater": {
                    g: [
                        {
                            type: "path",
                            d: "M0," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25   M35," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25   M70," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25   M105," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25    M140," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25     M175," + (e.y1 - 10) + " l25,-25 m0,25 l-25,-25"
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 15 - 25 - o,
                        x1: 0,
                        x2: 200
                    }
                },
                Command: {
                    g: [
                        {
                            type: "path",
                            d: "M70," + (e.y1 - 22.5) + " l25,0 m-12.5,12.5 l0,-25   M105," + (e.y1 - 22.5) + " l25,0 m-12.5,12.5 l0,-25"
                        }
                    ],
                    bbox: {
                        y1: e.y1 - 15 - 25 - o,
                        x1: 70,
                        x2: 130
                    }
                }
            };
            M.hasOwnProperty(this.metadata.echelon) && (t = M[this.metadata.echelon].g, 0 < this.style.outlineWidth && E.push(I.outline({
                type: "translate",
                x: 0,
                y: -o,
                draw: t
            }, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), R.push({
                type: "translate",
                x: 0,
                y: -o,
                draw: t
            }), C.merge(M[this.metadata.echelon].bbox));
        }
        if (this.metadata.mobility) {
            this.style.frame || (e.y2 = this.bbox.y2), "Neutral" == this.metadata.affiliation && ("Towed" != this.metadata.mobility && "Short towed array" != this.metadata.mobility && "Long towed Array" != this.metadata.mobility || (e.y2 += 8), "Over snow (prime mover)" != this.metadata.mobility && "Sled" != this.metadata.mobility || (e.y2 += 13));
            var i = {
                "Wheeled limited cross country": {
                    g: [
                        {
                            type: "path",
                            d: "M 53,1 l 94,0"
                        },
                        {
                            type: "circle",
                            cx: 58,
                            cy: 8,
                            r: 8
                        },
                        {
                            type: "circle",
                            cx: 142,
                            cy: 8,
                            r: 8
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 16
                    }
                },
                "Wheeled cross country": {
                    g: [
                        {
                            type: "path",
                            d: "M 53,1 l 94,0"
                        },
                        {
                            type: "circle",
                            cx: 58,
                            cy: 8,
                            r: 8
                        },
                        {
                            type: "circle",
                            cx: 142,
                            cy: 8,
                            r: 8
                        },
                        {
                            type: "circle",
                            cx: 100,
                            cy: 8,
                            r: 8
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 16
                    }
                },
                Tracked: {
                    g: [
                        {
                            type: "path",
                            d: "M 53,1 l 100,0 c15,0 15,15 0,15 l -100,0 c-15,0 -15,-15 0,-15"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 18,
                        x1: 42,
                        x2: 168
                    }
                },
                "Wheeled and tracked combination": {
                    g: [
                        {
                            type: "circle",
                            cx: 58,
                            cy: 8,
                            r: 8
                        },
                        {
                            type: "path",
                            d: "M 83,1 l 70,0 c15,0 15,15 0,15 l -70,0 c-15,0 -15,-15 0,-15"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 16,
                        x2: 168
                    }
                },
                Towed: {
                    g: [
                        {
                            type: "path",
                            d: "M 63,1 l 74,0"
                        },
                        {
                            type: "circle",
                            cx: 58,
                            cy: 3,
                            r: 8
                        },
                        {
                            type: "circle",
                            cx: 142,
                            cy: 3,
                            r: 8
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 10
                    }
                },
                Rail: {
                    g: [
                        {
                            type: "path",
                            d: "M 53,1 l 96,0"
                        },
                        {
                            type: "circle",
                            cx: 58,
                            cy: 8,
                            r: 8
                        },
                        {
                            type: "circle",
                            cx: 73,
                            cy: 8,
                            r: 8
                        },
                        {
                            type: "circle",
                            cx: 127,
                            cy: 8,
                            r: 8
                        },
                        {
                            type: "circle",
                            cx: 142,
                            cy: 8,
                            r: 8
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 16
                    }
                },
                "Over snow (prime mover)": {
                    g: [
                        {
                            type: "path",
                            d: "M 50,-9 l10,10 90,0"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 9
                    }
                },
                Sled: {
                    g: [
                        {
                            type: "path",
                            d: "M 145,-12  c15,0 15,15 0,15 l -90,0 c-15,0 -15,-15 0,-15"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 15,
                        x1: 42,
                        x2: 168
                    }
                },
                "Pack animals": {
                    g: [
                        {
                            type: "path",
                            d: "M 80,20 l 10,-20 10,20 10,-20 10,20"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 20
                    }
                },
                Barge: {
                    g: [
                        {
                            type: "path",
                            d: "M 50,1 l 100,0 c0,10 -100,10 -100,0"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 10
                    }
                },
                Amphibious: {
                    g: [
                        {
                            type: "path",
                            d: "M 65,10 c 0,-10 10,-10 10,0 0,10 10,10 10,0	0,-10 10,-10 10,0 0,10 10,10 10,0	0,-10 10,-10 10,0 0,10 10,10 10,0	0,-10 10,-10 10,0"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 20
                    }
                },
                "Short towed array": {
                    g: [
                        {
                            type: "path",
                            fill: A,
                            d: "M 50,5 l 100,0 M50,0 l10,0 0,10 -10,0 z M150,0 l-10,0 0,10 10,0 z M100,0 l5,5 -5,5 -5,-5 z"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 10
                    }
                },
                "Long towed Array": {
                    g: [
                        {
                            type: "path",
                            fill: A,
                            d: "M 50,5 l 100,0 M50,0 l10,0 0,10 -10,0 z M150,0 l-10,0 0,10 10,0 z M105,0 l-10,0 0,10 10,0 z M75,0 l5,5 -5,5 -5,-5 z  M125,0 l5,5 -5,5 -5,-5 z"
                        }
                    ],
                    bbox: {
                        y2: e.y2 + 10
                    }
                }
            };
            i.hasOwnProperty(this.metadata.mobility) && (t = i[this.metadata.mobility].g, 0 < this.style.outlineWidth && E.push(I.outline({
                type: "translate",
                x: 0,
                y: e.y2,
                draw: t
            }, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), R.push({
                type: "translate",
                x: 0,
                y: e.y2,
                draw: t
            }), C.merge(i[this.metadata.mobility].bbox));
        }
        if (this.metadata.leadership) {
            var L = {
                Friend: {
                    type: "path",
                    d: "m 45,60 55,-25 55,25"
                }
            }[this.metadata.affiliation];
            L && (E.push(L), C.merge({
                y1: e.y1 - 20
            }));
        }
        for(var s = 0; s < E.length; s++)E[s].hasOwnProperty("fill") || (E[s].fill = !1), E[s].hasOwnProperty("stroke") || (E[s].stroke = A), E[s].hasOwnProperty("strokewidth") || (E[s].strokewidth = this.style.strokeWidth);
        for(s = 0; s < R.length; s++)R[s].hasOwnProperty("fill") || (R[s].fill = !1), R[s].hasOwnProperty("stroke") || (R[s].stroke = A), R[s].hasOwnProperty("strokewidth") || (R[s].strokewidth = this.style.strokeWidth);
        return {
            pre: E,
            post: R,
            bbox: C
        };
    }
    function A(I) {
        var t = [], E = [], R = this.metadata.baseGeometry.bbox, e = R.y1, A = R.y2;
        if (this.metadata.condition) {
            if (this.metadata.fill && "" === this.style.monoColor && !this.style.simpleStatusModifier) !this.metadata.frame && this.metadata.iconBottom && (A = this.metadata.iconBottom), this.options.headquartersElement && (A += 35), A += this.metadata.mobility ? 25 : 5, E.push({
                type: "path",
                strokewidth: this.style.strokeWidth,
                fill: {
                    FullyCapable: "rgb(0,255,0)",
                    Damaged: "rgb(255,255,0)",
                    Destroyed: "rgb(255,0,0)",
                    FullToCapacity: "rgb(0, 180, 240)"
                }[this.metadata.condition],
                stroke: this.colors.frameColor[this.metadata.affiliation],
                d: "M" + R.x1 + "," + A + " l" + R.width() + ",0 0,25 -" + R.width() + ",0 z"
            }), A += 25, 0 < this.style.outlineWidth && t.push(I.outline(E, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor));
            else "Damaged" != this.metadata.condition && "Destroyed" != this.metadata.condition || (E.push({
                type: "path",
                d: "M150,20 L50,180",
                strokewidth: 2 * this.style.strokeWidth,
                stroke: this.colors.frameColor[this.metadata.affiliation]
            }), e = 20, A = 180), "Destroyed" == this.metadata.condition && E.push({
                type: "path",
                d: "M50,20 L150,180",
                strokewidth: 2 * this.style.strokeWidth,
                stroke: this.colors.frameColor[this.metadata.affiliation]
            }), 0 < this.style.outlineWidth && t.push(I.outline(E, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor));
        }
        return {
            pre: t,
            post: E,
            bbox: {
                y1: e,
                y2: A
            }
        };
    }
    function C(I) {
        var t = [], E = [], R = this.bbox, e = R.x1, A = R.x2, C = R.y1, T = R.y2;
        if ("" !== this.options.engagementBar) {
            C -= 6;
            var S = this.style.fontfamily, N = this.colors.iconColor[this.metadata.affiliation] || this.colors.iconColor.Friend;
            E.push({
                type: "text",
                text: this.options.engagementBar,
                x: 100,
                y: R.y1 - 11,
                textanchor: "middle",
                fontsize: 22,
                fontfamily: S,
                fontweight: "bold",
                fill: N,
                stroke: !1
            });
            var O = !1;
            if (this.metadata.fill && "" === this.style.monoColor) O = ({
                TARGET: "rgb(255, 0, 0)",
                "NON-TARGET": "rgb(255, 255, 255)",
                EXPIRED: "rgb(255, 120, 0)"
            })[this.options.engagementType.toUpperCase()] || this.colors.fillColor[this.metadata.affiliation];
            var G, o = Math.max(R.width(), 16 * this.options.engagementBar.length);
            if (e = Math.min(e, 100 - o / 2), A = Math.max(A, 100 + o / 2), E.unshift({
                type: "path",
                strokewidth: this.style.strokeWidth,
                fill: O,
                stroke: this.colors.frameColor[this.metadata.affiliation],
                d: "M" + (100 - o / 2) + "," + C + " l" + o + ",0 0,-25 -" + o + ",0 z"
            }), C -= 25, 0 < this.style.outlineWidth) G = this.metadata.fill && "" === this.style.monoColor ? E[0] : E, t.push(I.outline(G, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor));
        }
        return {
            pre: t,
            post: E,
            bbox: {
                x1: e,
                x2: A,
                y1: C,
                y2: T
            }
        };
    }
    function T(I) {
        var t = [], E = [], R = this.metadata.baseGeometry.bbox, e = this.colors.frameColor[this.metadata.affiliation];
        if (this.metadata.dimensionUnknown && e && E.push({
            type: "text",
            text: "?",
            x: 100,
            y: 127,
            fill: e,
            fontfamily: this.style.fontfamily,
            fontsize: 80,
            fontweight: "bold",
            textanchor: "middle"
        }), this.metadata.baseGeometry.g && e) {
            var A = 10;
            ("Unknown" == this.metadata.affiliation || "Hostile" == this.metadata.affiliation && "Subsurface" != this.metadata.dimension) && (A = -10), "Exercise" == this.metadata.context && (this.metadata.joker || this.metadata.faker || E.push({
                type: "text",
                text: "X",
                x: R.x2 + A,
                y: 60,
                fill: e,
                fontfamily: this.style.fontfamily,
                fontsize: 35,
                fontweight: "bold",
                textanchor: "start"
            }), this.metadata.joker && E.push({
                type: "text",
                text: "J",
                x: R.x2 + A,
                y: 60,
                fill: e,
                fontfamily: this.style.fontfamily,
                fontsize: 35,
                fontweight: "bold",
                textanchor: "start"
            }), this.metadata.faker && E.push({
                type: "text",
                text: "K",
                x: R.x2 + A,
                y: 60,
                fill: e,
                fontfamily: this.style.fontfamily,
                fontsize: 35,
                fontweight: "bold",
                textanchor: "start"
            }), R = {
                x2: R.x2 + A + 22,
                y1: 35
            }), "Simulation" == this.metadata.context && (E.push({
                type: "text",
                text: "S",
                x: R.x2 + A,
                y: 60,
                fill: e,
                fontfamily: this.style.fontfamily,
                fontsize: 35,
                fontweight: "bold",
                textanchor: "start"
            }), R = new I.BBox({
                x2: R.x2 + A + 22,
                y1: 35
            }));
        }
        return 0 < this.style.outlineWidth && t.push(I.outline(E, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), {
            pre: t,
            post: E,
            bbox: R
        };
    }
    function S(I) {
        var t, E, R = [], e = [], A = this.metadata.baseGeometry.bbox, S = ("object" == typeof this.style.infoColor ? this.style.infoColor[this.metadata.affiliation] : this.style.infoColor) || this.colors.iconColor[this.metadata.affiliation] || this.colors.iconColor.Friend, N = this.style.fontfamily, O = this.style.infoSize, C = "object" == typeof this.style.infoBackground ? this.style.infoBackground[this.metadata.affiliation] : this.style.infoBackground, T = "object" == typeof this.style.infoBackground ? this.style.infoBackground[this.metadata.affiliation] : this.style.infoBackground, G = new I.BBox, o = 20;
        function M(I) {
            var t, E = [];
            for(var R in I)if (this.options.hasOwnProperty(R) && "" != this.options[R]) {
                if (!I.hasOwnProperty(R)) continue;
                for(var e = 0; e < (I[R].length || 1); e++){
                    var A;
                    if (t = {
                        y2: (A = Array.isArray(I[R]) ? I[R][e] : I[R]).y,
                        y1: A.y - A.fontsize
                    }, "start" == A.textanchor && (t.x1 = A.x, t.x2 = A.x + i(this.options[R]) * (A.fontsize / O)), "middle" == A.textanchor) {
                        var C = i(this.options[R]) * (A.fontsize / O);
                        t.x1 = A.x - C / 2, t.x2 = A.x + C / 2;
                    }
                    "end" == A.textanchor && (t.x1 = A.x - i(this.options[R]) * (A.fontsize / O), t.x2 = A.x), G.merge(t);
                    var T = {
                        type: "text",
                        fontfamily: N,
                        fill: S
                    };
                    A.hasOwnProperty("fill") && (T.fill = A.fill), A.hasOwnProperty("stroke") && (T.stroke = A.stroke), A.hasOwnProperty("textanchor") && (T.textanchor = A.textanchor), A.hasOwnProperty("fontsize") && (T.fontsize = A.fontsize), A.hasOwnProperty("fontweight") && (T.fontweight = A.fontweight), T.x = A.x, T.y = A.y, T.text = this.options[R], E.push(T);
                }
            }
            return E;
        }
        function i(I) {
            if (0 == I.length) return 0;
            for(var t = {
                " ": 9,
                "!": 10,
                '"': 15,
                "#": 17,
                $: 17,
                "%": 27,
                "&": 22,
                "'": 8,
                "(": 10,
                ")": 10,
                "*": 12,
                "+": 18,
                ",": 9,
                "-": 10,
                ".": 9,
                "/": 9,
                0: 17,
                1: 17,
                2: 17,
                3: 17,
                4: 17,
                5: 17,
                6: 17,
                7: 17,
                8: 17,
                9: 17,
                ":": 10,
                ";": 10,
                "<": 18,
                "=": 18,
                ">": 18,
                "?": 19,
                "@": 30,
                A: 22,
                B: 22,
                C: 22,
                D: 22,
                E: 21,
                F: 19,
                G: 24,
                H: 22,
                I: 9,
                J: 17,
                K: 22,
                L: 19,
                M: 25,
                N: 22,
                O: 24,
                P: 21,
                Q: 24,
                R: 22,
                S: 21,
                T: 19,
                U: 22,
                V: 21,
                W: 29,
                X: 21,
                Y: 21,
                Z: 19,
                "[": 10,
                "]": 10,
                "^": 18,
                _: 17,
                "`": 10,
                a: 17,
                b: 19,
                c: 17,
                d: 19,
                e: 17,
                f: 10,
                g: 19,
                h: 19,
                i: 9,
                j: 9,
                k: 17,
                l: 9,
                m: 27,
                n: 19,
                o: 19,
                p: 19,
                q: 19,
                r: 12,
                s: 17,
                t: 10,
                u: 19,
                v: 17,
                w: 24,
                x: 17,
                y: 17,
                z: 15,
                "{": 12,
                "|": 9,
                "}": 12,
                "~": 18
            }, E = 0, R = 0; R < I.length; R++)E += O / 30 * (t[I[R]] ? t[I[R]] : 28.5);
            return E += o;
        }
        if (this.metadata.numberSIDC) {
            if (!I._labelCache.hasOwnProperty("number")) for(t in I._labelCache.number = {}, I._labelOverrides.number)I._labelOverrides.number.hasOwnProperty(t) && I._labelOverrides.number[t].call(this, I._labelCache.number);
            if (E = this.metadata.functionid.substr(0, 6), this.metadata.controlMeasure && I._labelCache.number.hasOwnProperty(E)) return e.push(M.call(this, I._labelCache.number[E])), 0 < this.style.outlineWidth && R.push(I.outline(e, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), {
                pre: R,
                post: e,
                bbox: G
            };
        } else {
            if (!I._labelCache.hasOwnProperty("letter")) for(t in I._labelCache.letter = {}, I._labelOverrides.letter)I._labelOverrides.letter.hasOwnProperty(t) && I._labelOverrides.letter[t].call(this, I._labelCache.letter);
            if (E = this.options.sidc.substr(0, 1) + "-" + this.options.sidc.substr(2, 1) + "-" + this.options.sidc.substr(4, 6), I._labelCache.letter.hasOwnProperty(E)) return e.push(M.call(this, I._labelCache.letter[E])), 0 < this.style.outlineWidth && R.push(I.outline(e, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor)), {
                pre: R,
                post: e,
                bbox: G
            };
        }
        var L, s, n, a = this.options.quantity || this.options.reinforcedReduced || this.options.staffComments || this.options.additionalInformation || this.options.evaluationRating || this.options.combatEffectiveness || this.options.signatureEquipment || this.options.higherFormation || this.options.hostile || this.options.iffSif || this.options.sigint || this.options.uniqueDesignation || this.options.type || this.options.dtg || this.options.altitudeDepth || this.options.location || this.options.speed || this.options.specialHeadquarters || this.options.platformType || this.options.equipmentTeardownTime || this.options.commonIdentifier || this.options.auxiliaryEquipmentIndicator || this.options.headquartersElement || this.options.installationComposition || this.options.guardedUnit || this.options.specialDesignator;
        if (this.style.infoFields && a) {
            this.options.specialHeadquarters && e.push((L = this.options.specialHeadquarters, s = 42, n = 115, 1 == L.length && (s = 45, n = 115), 3 == L.length && (s = 35, n = 110), 4 <= L.length && (s = 32, n = 110), {
                type: "text",
                text: L,
                x: 100,
                y: n,
                textanchor: "middle",
                fontsize: s,
                fontfamily: N,
                fill: S,
                stroke: !1,
                fontweight: "bold"
            })), this.options.quantity && !this.metadata.dismounted && (e.push({
                type: "text",
                text: this.options.quantity,
                x: 100,
                y: A.y1 - 10,
                textanchor: "middle",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), G.y1 = A.y1 - 10 - O), this.options.headquartersElement && (e.push({
                type: "text",
                text: this.options.headquartersElement,
                x: 100,
                y: A.y2 + 35,
                textanchor: "middle",
                fontsize: 35,
                fontfamily: N,
                fontweight: "bold",
                fill: S,
                stroke: !1
            }), G.y2 = A.y2 + 35);
            var l, r = {
                L1: "",
                L2: "",
                L3: "",
                L4: "",
                L5: "",
                R1: "",
                R2: "",
                R3: "",
                R4: "",
                R5: ""
            };
            if (isNaN(this.options.sidc) || "Air" != this.metadata.baseDimension || (r.R1 = this.options.uniqueDesignation, r.R2 = this.options.iffSif, r.R3 = this.options.type, (this.options.speed || this.options.altitudeDepth) && (l = [], this.options.speed && l.push(this.options.speed), this.options.altitudeDepth && l.push(this.options.altitudeDepth), r.R4 = l.join("/")), (this.options.staffComments || this.options.additionalInformation) && (l = [], this.options.staffComments && l.push(this.options.staffComments), this.options.additionalInformation && l.push(this.options.additionalInformation), r.R5 = l.join("/"))), (isNaN(this.options.sidc) || "Ground" == this.metadata.baseDimension) && (r.L1 = this.options.dtg, (this.options.altitudeDepth || this.options.location) && (l = [], this.options.altitudeDepth && l.push(this.options.altitudeDepth), this.options.location && l.push(this.options.location), r.L2 = l.join("/")), r.L4 = this.options.uniqueDesignation, r.L5 = this.options.speed, r.R2 = this.options.staffComments, r.R4 = this.options.higherFormation, (this.options.evaluationRating || this.options.combatEffectiveness || this.options.signatureEquipment || this.options.hostile || this.options.iffSif) && (l = [], this.options.evaluationRating && l.push(this.options.evaluationRating), this.options.combatEffectiveness && l.push(this.options.combatEffectiveness), this.options.signatureEquipment && l.push(this.options.signatureEquipment), this.options.hostile && l.push(this.options.hostile), this.options.iffSif && l.push(this.options.iffSif), r.R5 = l.join("/")), isNaN(this.options.sidc) || this.metadata.unit ? ((this.options.type || this.options.platformType || this.options.equipmentTeardownTime) && (l = [], this.options.type && l.push(this.options.type), this.options.platformType && l.push(this.options.platformType), this.options.equipmentTeardownTime && l.push(this.options.equipmentTeardownTime), r.L3 = l.join("/")), r.R1 = this.options.reinforcedReduced, this.metadata.activity && (r.R1 = this.options.country), (this.options.additionalInformation || this.options.commonIdentifier) && (l = [], this.options.additionalInformation && l.push(this.options.additionalInformation), this.options.commonIdentifier && l.push(this.options.commonIdentifier), r.R3 = l.join("/"))) : ((this.options.type || this.options.platformType || this.options.commonIdentifier || this.options.installationComposition) && (l = [], this.options.type && l.push(this.options.type), this.options.platformType && l.push(this.options.platformType), this.options.commonIdentifier && l.push(this.options.commonIdentifier), this.options.installationComposition && l.push(this.options.installationComposition), r.L3 = l.join("/")), r.R1 = this.options.country, (this.options.additionalInformation || this.options.equipmentTeardownTime) && (l = [], this.options.additionalInformation && l.push(this.options.additionalInformation), this.options.equipmentTeardownTime && l.push(this.options.equipmentTeardownTime), r.R3 = l.join("/")))), this.metadata.dismounted && (this.options.quantity && (e.push({
                type: "text",
                text: this.options.quantity,
                x: 100,
                y: A.y2 + O,
                textanchor: "middle",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), G.y2 = A.y2 + O), r.L1 = this.options.dtg, (this.options.altitudeDepth || this.options.location) && (l = [], this.options.altitudeDepth && l.push(this.options.altitudeDepth), this.options.location && l.push(this.options.location), r.L2 = l.join("/")), (this.options.type || this.options.platformType || this.options.commonIdentifier) && (l = [], this.options.type && l.push(this.options.type), this.options.platformType && l.push(this.options.platformType), this.options.commonIdentifier && l.push(this.options.commonIdentifier), r.L3 = l.join("/")), r.L4 = this.options.uniqueDesignation, r.L5 = this.options.speed, r.R1 = this.options.country, r.R2 = this.options.staffComments, this.options.additionalInformation && (l = [], this.options.additionalInformation && l.push(this.options.additionalInformation), r.R3 = l.join("/")), r.R4 = this.options.higherFormation, (this.options.evaluationRating || this.options.combatEffectiveness || this.options.signatureEquipment || this.options.hostile || this.options.iffSif) && (l = [], this.options.evaluationRating && l.push(this.options.evaluationRating), this.options.combatEffectiveness && l.push(this.options.combatEffectiveness), this.options.signatureEquipment && l.push(this.options.signatureEquipment), this.options.hostile && l.push(this.options.hostile), this.options.iffSif && l.push(this.options.iffSif), r.R5 = l.join("/"))), isNaN(this.options.sidc) || "Sea" != this.metadata.baseDimension || ((this.options.guardedUnit || this.options.specialDesignator) && (l = [], this.options.guardedUnit && l.push(this.options.guardedUnit), this.options.specialDesignator && l.push(this.options.specialDesignator), r.L1 = l.join("/")), r.R1 = this.options.uniqueDesignation, r.R2 = this.options.type, r.R3 = this.options.iffSif, (this.options.staffComments || this.options.additionalInformation) && (l = [], this.options.staffComments && l.push(this.options.staffComments), this.options.additionalInformation && l.push(this.options.additionalInformation), r.R4 = l.join("/")), (this.options.location || this.options.speed) && (l = [], this.options.location && l.push(this.options.location), this.options.speed && l.push(this.options.speed), r.R5 = l.join("/"))), isNaN(this.options.sidc) || "Subsurface" != this.metadata.baseDimension || (r.L1 = this.options.specialDesignator, r.R1 = this.options.uniqueDesignation, r.R2 = this.options.type, r.R3 = this.options.altitudeDepth, r.R4 = this.options.staffComments, r.R5 = this.options.additionalInformation), G.x1 = A.x1 - Math.max(this.options.specialHeadquarters ? (i(this.options.specialHeadquarters) - this.metadata.baseGeometry.bbox.width()) / 2 : 0, this.options.quantity ? (i(this.options.quantity) - this.metadata.baseGeometry.bbox.width()) / 2 : 0, i(r.L1), i(r.L2), i(r.L3), i(r.L4), i(r.L5)), G.x2 = A.x2 + Math.max(this.options.specialHeadquarters ? (i(this.options.specialHeadquarters) - this.metadata.baseGeometry.bbox.width()) / 2 : 0, this.options.quantity ? (i(this.options.quantity) - this.metadata.baseGeometry.bbox.width()) / 2 : 0, i(r.R1), i(r.R2), i(r.R3), i(r.R4), i(r.R5)), (r.L1 || r.R1) && (G.y1 = Math.min(G.y1, 100 - 2.5 * O)), (r.L2 || r.R2) && (G.y1 = Math.min(G.y1, 100 - 1.5 * O)), (r.L4 || r.R4) && (G.y2 = Math.max(G.y2, 100 + 1.7 * O)), (r.L5 || r.R5) && (G.y2 = Math.max(G.y2, 100 + 2.7 * O)), this.style.infoBackground) {
                var P = {
                    x1: 100,
                    y1: 1e3,
                    y2: 0
                }, y = {
                    x2: 100,
                    y1: 1e3,
                    y2: 0
                };
                r.L1 && (P = {
                    x1: Math.min(P.x1, A.x1 - i(r.L1)),
                    x2: A.x1 - o / 2,
                    y1: Math.min(P.y1, 100 - 2.5 * O),
                    y2: Math.max(P.y2, 100 - 1.5 * O + o / 2)
                }), r.L2 && (P = {
                    x1: Math.min(P.x1, A.x1 - i(r.L2)),
                    x2: A.x1 - o / 2,
                    y1: Math.min(P.y1, 100 - 1.5 * O),
                    y2: Math.max(P.y2, 100 - .5 * O + o / 2)
                }), r.L3 && (P = {
                    x1: Math.min(P.x1, A.x1 - i(r.L3)),
                    x2: A.x1 - o / 2,
                    y1: Math.min(P.y1, 100 - .5 * O),
                    y2: Math.max(P.y2, 100 + .5 * O + o / 2)
                }), r.L4 && (P = {
                    x1: Math.min(P.x1, A.x1 - i(r.L4)),
                    x2: A.x1 - o / 2,
                    y1: Math.min(P.y1, 100 + .5 * O),
                    y2: Math.max(P.y2, 100 + 1.5 * O + o / 2)
                }), r.L5 && (P = {
                    x1: Math.min(P.x1, A.x1 - i(r.L5)),
                    x2: A.x1 - o / 2,
                    y1: Math.min(P.y1, 100 + 1.5 * O),
                    y2: Math.max(P.y2, 100 + 2.5 * O + o / 2)
                }), P.hasOwnProperty("x2") && (G.x1 -= O / 2, e.push({
                    type: "path",
                    d: "M " + (P.x1 - O / 2) + "," + (P.y1 + O / 2) + " " + P.x1 + "," + P.y1 + " " + P.x2 + "," + P.y1 + " " + P.x2 + "," + P.y2 + " " + (P.x1 - O / 2) + "," + P.y2 + "z",
                    fill: C,
                    stroke: T || !1
                })), r.R1 && (y = {
                    x1: A.x2 + o / 2,
                    x2: Math.max(y.x2, A.x2 + i(r.R1)),
                    y1: Math.min(y.y1, 100 - 2.5 * O),
                    y2: Math.max(y.y2, 100 - 1.5 * O + o / 2)
                }), r.R2 && (y = {
                    x1: A.x2 + o / 2,
                    x2: Math.max(y.x2, A.x2 + i(r.R2)),
                    y1: Math.min(y.y1, 100 - 1.5 * O),
                    y2: Math.max(y.y2, 100 - .5 * O + o / 2)
                }), r.R3 && (y = {
                    x1: A.x2 + o / 2,
                    x2: Math.max(y.x2, A.x2 + i(r.R3)),
                    y1: Math.min(y.y1, 100 - .5 * O),
                    y2: Math.max(y.y2, 100 + .5 * O + o / 2)
                }), r.R4 && (y = {
                    x1: A.x2 + o / 2,
                    x2: Math.max(y.x2, A.x2 + i(r.R4)),
                    y1: Math.min(y.y1, 100 + .5 * O),
                    y2: Math.max(y.y2, 100 + 1.5 * O + o / 2)
                }), r.R5 && (y = {
                    x1: A.x2 + o / 2,
                    x2: Math.max(y.x2, A.x2 + i(r.R5)),
                    y1: Math.min(y.y1, 100 + 1.5 * O),
                    y2: Math.max(y.y2, 100 + 2.5 * O + o / 2)
                }), y.hasOwnProperty("x1") && (G.x2 += O / 2, e.push({
                    type: "path",
                    d: "M " + y.x1 + "," + y.y1 + " " + (y.x2 + O / 2) + "," + y.y1 + " " + (y.x2 + O / 2) + "," + (y.y2 - O / 2) + " " + y.x2 + "," + y.y2 + " " + y.x1 + "," + y.y2 + "z",
                    fill: C,
                    stroke: T || !1
                }));
            }
            r.L1 && e.push({
                type: "text",
                text: r.L1,
                x: A.x1 - o,
                y: 100 - 1.5 * O,
                textanchor: "end",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.L2 && e.push({
                type: "text",
                text: r.L2,
                x: A.x1 - o,
                y: 100 - .5 * O,
                textanchor: "end",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.L3 && e.push({
                type: "text",
                text: r.L3,
                x: A.x1 - o,
                y: 100 + .5 * O,
                textanchor: "end",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.L4 && e.push({
                type: "text",
                text: r.L4,
                x: A.x1 - o,
                y: 100 + 1.5 * O,
                textanchor: "end",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.L5 && e.push({
                type: "text",
                text: r.L5,
                x: A.x1 - o,
                y: 100 + 2.5 * O,
                textanchor: "end",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.R1 && e.push({
                type: "text",
                text: r.R1,
                x: A.x2 + o,
                y: 100 - 1.5 * O,
                textanchor: "start",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.R2 && e.push({
                type: "text",
                text: r.R2,
                x: A.x2 + o,
                y: 100 - .5 * O,
                textanchor: "start",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.R3 && e.push({
                type: "text",
                text: r.R3,
                x: A.x2 + o,
                y: 100 + .5 * O,
                textanchor: "start",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.R4 && e.push({
                type: "text",
                text: r.R4,
                x: A.x2 + o,
                y: 100 + 1.5 * O,
                textanchor: "start",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), r.R5 && e.push({
                type: "text",
                text: r.R5,
                x: A.x2 + o,
                y: 100 + 2.5 * O,
                textanchor: "start",
                fontsize: O,
                fontfamily: N,
                fill: S,
                stroke: !1
            }), 0 < this.style.outlineWidth && R.push(I.outline(e, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor));
        }
        return {
            pre: R,
            post: e,
            bbox: G
        };
    }
    function N(I) {
        var t = [], E = [], R = this.metadata.baseGeometry.bbox;
        "" == this.metadata.baseGeometry.g && (R = this.bbox);
        var e, A = new I.BBox, C = this.colors.iconColor[this.metadata.affiliation] || this.colors.iconColor.Friend;
        if (this.style.infoFields && "" !== this.options.direction) {
            if (0 == this.options.speedLeader) e = [
                {
                    type: "rotate",
                    degree: this.options.direction,
                    x: 100,
                    y: 100,
                    draw: [
                        {
                            type: "path",
                            fill: C,
                            stroke: C,
                            strokewidth: this.style.strokeWidth,
                            d: "M100,100 l0,-75 -5,3 5,-15 5,15 -5,-3"
                        }
                    ]
                }
            ], A.y1 = Math.min(100 - 95 * Math.cos(this.options.direction / 360 * Math.PI * 2), 100), A.y2 = Math.max(100 - 95 * Math.cos(this.options.direction / 360 * Math.PI * 2), 100), A.x1 = Math.min(100 + 95 * Math.sin(this.options.direction / 360 * Math.PI * 2), 100), A.x2 = Math.max(100 + 95 * Math.sin(this.options.direction / 360 * Math.PI * 2), 100), "Ground" != this.metadata.baseDimension && "" != this.metadata.baseDimension || (this.metadata.headquarters ? (e = [
                {
                    type: "translate",
                    x: R.x1 - 100,
                    y: R.y2 - (100 - (this.style.hqStaffLength || I._hqStaffLength)),
                    draw: e
                }
            ], A.x1 += R.x1 - 100, A.x2 += R.x1 - 100) : e = [
                {
                    type: "translate",
                    x: 0,
                    y: R.y2,
                    draw: e
                },
                {
                    type: "path",
                    fill: C,
                    stroke: C,
                    strokewidth: this.style.strokeWidth,
                    d: "M 100," + R.y2 + "l0,100"
                }
            ]), A.y2 += R.y2 + parseFloat(this.style.strokeWidth), E.push(e);
            else {
                var T = this.options.speedLeader * (100 / this.style.size), S = this.options.direction * Math.PI / 180, N = -T * Math.cos(S), O = T * Math.sin(S);
                A.x1 = Math.min(100, 100 + O), A.x2 = Math.max(100, 100 + O), A.y1 = Math.min(100, 100 + N), A.y2 = Math.max(100, 100 + N), e = {
                    type: "path",
                    fill: C,
                    stroke: C,
                    strokewidth: this.style.strokeWidth,
                    d: "M 100,100  l" + O + "," + N
                }, t.push(e);
            }
            0 < this.style.outlineWidth && t.unshift(I.outline(e, this.style.outlineWidth, this.style.strokeWidth, "object" == typeof this.style.outlineColor ? this.style.outlineColor[this.metadata.affiliation] : this.style.outlineColor));
        }
        return {
            pre: t,
            post: E,
            bbox: A
        };
    }
    function I(I) {
        return void 0 === I && (I = {}), {
            x1: void 0 !== I.x1 ? I.x1 : 100,
            y1: void 0 !== I.y1 ? I.y1 : 100,
            x2: void 0 !== I.x2 ? I.x2 : 100,
            y2: void 0 !== I.y2 ? I.y2 : 100,
            width: function() {
                return this.x2 - this.x1;
            },
            height: function() {
                return this.y2 - this.y1;
            },
            getSize: function() {
                return {
                    height: this.y2 - this.y1,
                    width: this.x2 - this.x1
                };
            },
            merge: function(I) {
                return this.x1 = I.x1 <= this.x1 ? I.x1 : this.x1, this.y1 = I.y1 <= this.y1 ? I.y1 : this.y1, this.x2 = I.x2 >= this.x2 ? I.x2 : this.x2, this.y2 = I.y2 >= this.y2 ? I.y2 : this.y2, this;
            }
        };
    }
    var O = {
        AirHostile: {
            g: {
                type: "path",
                d: "M 45,150 L45,70 100,20 155,70 155,150"
            },
            bbox: new I({
                x1: 45,
                y1: 20,
                x2: 155,
                y2: 150
            })
        },
        AirFriend: {
            g: {
                type: "path",
                d: "M 155,150 C 155,50 115,30 100,30 85,30 45,50 45,150"
            },
            bbox: new I({
                x1: 45,
                y1: 30,
                x2: 155,
                y2: 150
            })
        },
        AirNeutral: {
            g: {
                type: "path",
                d: "M 45,150 L 45,30,155,30,155,150"
            },
            bbox: new I({
                x1: 45,
                y1: 30,
                x2: 155,
                y2: 150
            })
        },
        AirUnknown: {
            g: {
                type: "path",
                d: "M 65,150 c -55,0 -50,-90 0,-90 0,-50 70,-50 70,0 50,0 55,90 0,90"
            },
            bbox: new I({
                x1: 25,
                y1: 20,
                x2: 175,
                y2: 150
            })
        },
        GroundHostile: {
            g: {
                type: "path",
                d: "M 100,28 L172,100 100,172 28,100 100,28 Z"
            },
            bbox: new I({
                x1: 28,
                y1: 28,
                x2: 172,
                y2: 172
            })
        },
        GroundFriend: {
            g: {
                type: "path",
                d: "M25,50 l150,0 0,100 -150,0 z"
            },
            bbox: new I({
                x1: 25,
                y1: 50,
                x2: 175,
                y2: 150
            })
        },
        GroundNeutral: {
            g: {
                type: "path",
                d: "M45,45 l110,0 0,110 -110,0 z"
            },
            bbox: new I({
                x1: 45,
                y1: 45,
                x2: 155,
                y2: 155
            })
        },
        GroundUnknown: {
            g: {
                type: "path",
                d: "M63,63 C63,20 137,20 137,63 C180,63 180,137 137,137 C137,180 63,180 63,137 C20,137 20,63 63,63 Z"
            },
            bbox: new I({
                x1: 30.75,
                y1: 30.75,
                x2: 169.25,
                y2: 169.25
            })
        },
        LandDismountedIndividualHostile: {
            g: {
                type: "path",
                d: "M 100,28 L172,100 100,172 28,100 100,28 Z"
            },
            bbox: new I({
                x1: 28,
                y1: 28,
                x2: 172,
                y2: 172
            })
        },
        LandDismountedIndividualFriend: {
            g: {
                type: "path",
                d: "m 100,45 55,25 0,60 -55,25 -55,-25 0,-60 z"
            },
            bbox: new I({
                x1: 45,
                y1: 45,
                x2: 155,
                y2: 155
            })
        },
        LandDismountedIndividualNeutral: {
            g: {
                type: "path",
                d: "M45,45 l110,0 0,110 -110,0 z"
            },
            bbox: new I({
                x1: 45,
                y1: 45,
                x2: 155,
                y2: 155
            })
        },
        LandDismountedIndividualUnknown: {
            g: {
                type: "path",
                d: "M63,63 C63,20 137,20 137,63 C180,63 180,137 137,137 C137,180 63,180 63,137 C20,137 20,63 63,63 Z"
            },
            bbox: new I({
                x1: 30.75,
                y1: 30.75,
                x2: 169.25,
                y2: 169.25
            })
        },
        SeaHostile: {
            g: {
                type: "path",
                d: "M100,28 L172,100 100,172 28,100 100,28 Z"
            },
            bbox: new I({
                x1: 28,
                y1: 28,
                x2: 172,
                y2: 172
            })
        },
        SeaFriend: {
            g: {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 60
            },
            bbox: new I({
                x1: 40,
                y1: 40,
                x2: 160,
                y2: 160
            })
        },
        SeaNeutral: {
            g: {
                type: "path",
                d: "M45,45 l110,0 0,110 -110,0 z"
            },
            bbox: new I({
                x1: 45,
                y1: 45,
                x2: 155,
                y2: 155
            })
        },
        SeaUnknown: {
            g: {
                type: "path",
                d: "M63,63 C63,20 137,20 137,63 C180,63 180,137 137,137 C137,180 63,180 63,137 C20,137 20,63 63,63 Z"
            },
            bbox: new I({
                x1: 30.75,
                y1: 30.75,
                x2: 169.25,
                y2: 169.25
            })
        },
        SubsurfaceHostile: {
            g: {
                type: "path",
                d: "M45,50 L45,130 100,180 155,130 155,50"
            },
            bbox: new I({
                x1: 45,
                y1: 50,
                x2: 155,
                y2: 180
            })
        },
        SubsurfaceFriend: {
            g: {
                type: "path",
                d: "m 45,50 c 0,100 40,120 55,120 15,0 55,-20 55,-120"
            },
            bbox: new I({
                x1: 45,
                y1: 50,
                x2: 155,
                y2: 170
            })
        },
        SubsurfaceNeutral: {
            g: {
                type: "path",
                d: "M45,50 L45,170 155,170 155,50"
            },
            bbox: new I({
                x1: 45,
                y1: 50,
                x2: 155,
                y2: 170
            })
        },
        SubsurfaceUnknown: {
            g: {
                type: "path",
                d: "m 65,50 c -55,0 -50,90 0,90 0,50 70,50 70,0 50,0 55,-90 0,-90"
            },
            bbox: new I({
                x1: 25,
                y1: 50,
                x2: 175,
                y2: 180
            })
        },
        PositionMarker: {
            g: {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            },
            bbox: new I({
                x1: 85,
                y1: 85,
                x2: 115,
                y2: 115
            })
        }
    }, s = new function() {
        this._autoValidation = !1, this.version = "2.0.0", "object" == typeof console && "object" != typeof $hPtJY && console.info("milsymbol.js " + this.version + " - Copyright (c) 2018 M" + String.fromCharCode(229) + "ns Beckman  http://www.spatialillusions.com");
    };
    function G() {
        this.bbox = new I, this.colors = {}, this.metadata = {}, this.octagonAnchor = {
            x: 50,
            y: 50
        }, this.options = {}, this.options.quantity = "", this.options.reinforcedReduced = "", this.options.staffComments = "", this.options.additionalInformation = "", this.options.evaluationRating = "", this.options.combatEffectiveness = "", this.options.signatureEquipment = "", this.options.higherFormation = "", this.options.hostile = "", this.options.iffSif = "", this.options.direction = "", this.options.sigint = "", this.options.uniqueDesignation = "", this.options.type = "", this.options.dtg = "", this.options.altitudeDepth = "", this.options.location = "", this.options.speed = "", this.options.speedLeader = 0, this.options.specialHeadquarters = "", this.options.country = "", this.options.platformType = "", this.options.equipmentTeardownTime = "", this.options.commonIdentifier = "", this.options.auxiliaryEquipmentIndicator = "", this.options.headquartersElement = "", this.options.installationComposition = "", this.options.engagementBar = "", this.options.engagementType = "", this.options.guardedUnit = "", this.options.specialDesignator = "", this.style = {}, this.style.alternateMedal = !1, this.style.civilianColor = !0, this.style.colorMode = "Light", this.style.fill = !0, this.style.fillOpacity = 1, this.style.fontfamily = "Arial", this.style.frame = !0, this.style.frameColor = "", this.style.hqStaffLength = 0, this.style.icon = !0, this.style.iconColor = "", this.style.infoBackground = "", this.style.infoBackgroundFrame = "", this.style.infoColor = "", this.style.infoFields = !0, this.style.infoSize = 40, this.style.monoColor = "", this.style.outlineColor = "rgb(239, 239, 239)", this.style.outlineWidth = 0, this.style.padding = 0, this.style.simpleStatusModifier = !1, this.style.size = 100, this.style.square = !1, this.style.standard = "", this.style.strokeWidth = 4, this.symbolAnchor = {
            x: 50,
            y: 50
        }, this.validIcon = !0, 0 < arguments.length && this.setOptions.apply(this, arguments);
    }
    function o(I, t, E) {
        this.options.sidc = this.options.sidc.toUpperCase();
        var R = "" != this.options.sidc.charAt(0) ? this.options.sidc.charAt(0) : "-", e = "" != this.options.sidc.charAt(1) ? this.options.sidc.charAt(1) : "-", A = "" != this.options.sidc.charAt(2) ? this.options.sidc.charAt(2) : "-", C = "" != this.options.sidc.charAt(3) ? this.options.sidc.charAt(3) : "-", T = t.functionid = "" != this.options.sidc.substr(4, 6) ? this.options.sidc.substr(4, 6) : "------", S = "" != this.options.sidc.charAt(10) ? this.options.sidc.charAt(10) : "-", N = "" != this.options.sidc.charAt(11) ? this.options.sidc.charAt(11) : "-";
        if (-1 < [
            "H",
            "S",
            "J",
            "K"
        ].indexOf(e) && (t.affiliation = E.affiliation[0]), -1 < [
            "F",
            "A",
            "D",
            "M"
        ].indexOf(e) && (t.affiliation = E.affiliation[1]), -1 < [
            "N",
            "L"
        ].indexOf(e) && (t.affiliation = E.affiliation[2]), -1 < [
            "P",
            "U",
            "G",
            "W",
            "O"
        ].indexOf(e) && (t.affiliation = E.affiliation[3]), -1 < [
            "P",
            "A"
        ].indexOf(A) && (t.dimension = E.dimension[0]), -1 < [
            "G",
            "Z",
            "F",
            "X"
        ].indexOf(A) && (t.dimension = E.dimension[1]), -1 < [
            "S"
        ].indexOf(A) && (t.dimension = E.dimension[2]), -1 < [
            "U"
        ].indexOf(A) && (t.dimension = E.dimension[3]), "P" == A && "O" != R && (t.space = !0), "O" == R && -1 < [
            "V",
            "O",
            "R"
        ].indexOf(A) && (t.activity = !0), "G" == R && (t.controlMeasure = !0), "H" == S && (t.installation = !0), this.style.frame && "A" == C && (t.notpresent = I._dashArrays.anticipated), this.style.frame && -1 < [
            "P",
            "A",
            "S",
            "G",
            "M"
        ].indexOf(e) && (t.notpresent = I._dashArrays.pending), "C" == C && (t.condition = E.status[2]), "D" == C && (t.condition = E.status[3]), "X" == C && (t.condition = E.status[4]), "F" == C && (t.condition = E.status[5]), -1 < [
            "G",
            "W",
            "D",
            "L",
            "M",
            "J",
            "K"
        ].indexOf(e) && (t.context = E.context[1]), "O" == R && (t.dimension = E.dimension[1]), "E" == R && (t.dimension = E.dimension[1]), t.baseDimension = t.dimension, t.baseAffilation = t.affiliation, "J" == e && (t.joker = !0), "K" == e && (t.faker = !0), (t.joker || t.faker) && (t.affiliation = E.affiliation[1]), "S" == R && "G" == A && "E" == T.charAt(0) && (t.dimension = E.dimension[2]), "I" == R && "G" == A && (t.dimension = E.dimension[2]), "E" == R && ("O" == A && -1 < [
            "AB----",
            "AE----",
            "AF----",
            "BB----",
            "CB----",
            "CC----",
            "DB----",
            "DDB---",
            "DEB---",
            "DFB---",
            "DGB---",
            "DHB---",
            "DIB---",
            "DJB---",
            "DLB---",
            "DMB---",
            "DOB---",
            "EA----",
            "EB----",
            "EC----",
            "ED----",
            "EE----"
        ].indexOf(T) || "F" == A && -1 < [
            "BA----",
            "MA----",
            "MC----"
        ].indexOf(T)) && (t.dimension = E.dimension[2]), (-1 < [
            "F",
            "G",
            "C",
            "D"
        ].indexOf(S) || "H" == S && "B" == N) && (t.feintDummy = !0), -1 < [
            "A",
            "B",
            "C",
            "D"
        ].indexOf(S) && (t.headquarters = !0), "G" == A && "UH----" == T && (t.headquarters = !0), -1 < [
            "E",
            "B",
            "G",
            "D"
        ].indexOf(S) && (t.taskForce = !0), "A" == N && (t.echelon = E.echelonMobility[11]), "B" == N && "H" != S && (t.echelon = E.echelonMobility[12]), "C" == N && (t.echelon = E.echelonMobility[13]), "D" == N && (t.echelon = E.echelonMobility[14]), "E" == N && (t.echelon = E.echelonMobility[15]), "F" == N && (t.echelon = E.echelonMobility[16]), "G" == N && (t.echelon = E.echelonMobility[17]), "H" == N && (t.echelon = E.echelonMobility[18]), "I" == N && (t.echelon = E.echelonMobility[21]), "J" == N && (t.echelon = E.echelonMobility[22]), "K" == N && (t.echelon = E.echelonMobility[23]), "L" == N && "N" != S && (t.echelon = E.echelonMobility[24]), "M" == N && (t.echelon = E.echelonMobility[25]), "N" == N && (t.echelon = E.echelonMobility[26]), "M" == S) switch(N){
            case "O":
                t.mobility = E.echelonMobility[31];
                break;
            case "P":
                t.mobility = E.echelonMobility[32];
                break;
            case "Q":
                t.mobility = E.echelonMobility[33];
                break;
            case "R":
                t.mobility = E.echelonMobility[34];
                break;
            case "S":
                t.mobility = E.echelonMobility[35];
                break;
            case "T":
                t.mobility = E.echelonMobility[36];
                break;
            case "U":
                t.mobility = E.echelonMobility[41];
                break;
            case "V":
                t.mobility = E.echelonMobility[42];
                break;
            case "W":
                t.mobility = E.echelonMobility[37];
                break;
            case "Y":
                t.mobility = E.echelonMobility[51];
                break;
            case "Z":
                t.mobility = E.echelonMobility[52];
                break;
            default:
                t.mobility = void 0;
        }
        if ("N" == S) switch(N){
            case "S":
                t.mobility = E.echelonMobility[61];
                break;
            case "L":
                t.mobility = E.echelonMobility[62];
                break;
            default:
                t.mobility = void 0;
        }
        return ("A" == A && "C" == T.charAt(0) || "G" == A && "EVC" == T.substring(0, 3) || "S" == A && "X" == T.charAt(0)) && (t.civilian = !0), "Z" != A && "X" != A || (-1 < [
            "P",
            "U",
            "F",
            "N",
            "H",
            "A",
            "S",
            "G",
            "W"
        ].indexOf(e) && (t.dimensionUnknown = !0), -1 < [
            "F",
            "A"
        ].indexOf(e) && (t.dimension = "Sea"), -1 < [
            "D",
            "L",
            "M",
            "J",
            "K"
        ].indexOf(e) && (t.affiliation = "none")), "S" == A && -1 < [
            "O-----",
            "ED----",
            "EP----",
            "EV----",
            "ZM----",
            "ZN----",
            "ZI----"
        ].indexOf(T) && (t.frame = !1), "E" == R && "N" == A && -1 < [
            "AA----",
            "AB----",
            "AC----",
            "AD----",
            "AE----",
            "AG----",
            "BB----",
            "BC----",
            "BF----",
            "BM----",
            "-C-----",
            "CA----",
            "CB----",
            "CC----",
            "CD----",
            "CE----"
        ].indexOf(T) && (t.frame = !1), "W" == R && "S" == A && -1 < [
            "WSVE--",
            "WSD-LI",
            "WSFGSO",
            "WSGRL-",
            "WSR-LI",
            "WSDSLM",
            "WSS-LI",
            "WSTMH-",
            "WST-FC",
            "WSTSS-"
        ].indexOf(T) && (t.frame = !1), "U" == A && -1 < [
            "WM----",
            "WMD---",
            "WMG---",
            "WMGD--",
            "WMGX--",
            "WMGE--",
            "WMGC--",
            "WMGR--",
            "WMGO--",
            "WMM---",
            "WMMD--",
            "WMMX--",
            "WMME--",
            "WMMC--",
            "WMMR--",
            "WMMO--",
            "WMF---",
            "WMFD--",
            "WMFX--",
            "WMFE--",
            "WMFC--",
            "WMFR--",
            "WMFO--",
            "WMO---",
            "WMOD--",
            "WMX---",
            "WME---",
            "WMA---",
            "WMC---",
            "WMR---",
            "WMB---",
            "WMBD--",
            "WMN---",
            "WMS---",
            "WMSX--",
            "WMSD--",
            "WD----",
            "WDM---",
            "WDMG--",
            "WDMM--",
            "ND----",
            "E-----",
            "V-----",
            "X-----",
            "NBS---",
            "NBR---",
            "NBW---",
            "NM----",
            "NA----"
        ].indexOf(T) && (t.STD2525 ? (t.fill = !1, "WD----" == T && (t.fill = !0), -1 < [
            "ND----",
            "NBS---",
            "NBR---",
            "NBW---",
            "NM----",
            "NA----"
        ].indexOf(T) && (t.fill = !0, t.frame = !1)) : (t.frame = !1, -1 < [
            "E-----",
            "V-----",
            "X-----"
        ].indexOf(T) && (t.fill = !1, t.frame = !1))), "WAS" != this.options.sidc.substr(0, 3) && "WOS" != this.options.sidc.substr(0, 3) && "G" != R || (t.frame = !1), "G" == R && "O" == A && -1 < [
            "V",
            "L",
            "P",
            "I"
        ].indexOf(T.charAt(0)) && (t.frame = !0, t.dimension = E.dimension[1]), t;
    }
    function M(I, t, E) {
        var R = {}, e = {};
        for(var A in I._iconSIDC.letter)I._iconSIDC.letter.hasOwnProperty(A) && I._iconSIDC.letter[A].call(this, R, e, t, E);
        return {
            icons: R,
            bbox: e
        };
    }
    function n(I, t) {
        if ("object" == typeof I) {
            if (Array.isArray(I)) {
                for(var E = 0; E < I.length; E++)n.call(this, I[E], t);
                return;
            }
            return I.icon = !0, "text" == I.type && (I.hasOwnProperty("fontfamily") || (I.fontfamily = "Arial"), I.hasOwnProperty("fontweight") || (I.fontweight = "bold"), I.hasOwnProperty("textanchor") || (I.textanchor = "middle"), I.hasOwnProperty("stroke") || (I.stroke = !1)), I.hasOwnProperty("fill") || (I.fill = t), void (I.hasOwnProperty("stroke") || (I.stroke = t));
        }
    }
    function a(I) {
        var t = 42, E = 115;
        return 1 == I.length && (t = 45, E = 115), 3 == I.length && (t = 35, E = 110), 4 <= I.length && (t = 32, E = 110), {
            type: "text",
            stroke: !1,
            textanchor: "middle",
            x: 100,
            y: E,
            fontsize: t,
            text: I
        };
    }
    function l(I) {
        var t = 30;
        return 3 == I.length && (t = 25), 4 <= I.length && (t = 22), {
            type: "text",
            stroke: !1,
            textanchor: "middle",
            x: 100,
            y: 77,
            fontsize: t,
            text: I
        };
    }
    function r(I) {
        var t = 30, E = 145;
        return 3 == I.length && (t = 25, E = 140), 4 <= I.length && (t = 20, E = 135), {
            type: "text",
            stroke: !1,
            textanchor: "middle",
            x: 100,
            y: E,
            fontsize: t,
            text: I
        };
    }
    function i(I, t, E, R, e, A) {
        var C = t.affiliation || "Friend", T = t.frame, S = t.numberSIDC, N = E.iconColor[C], O = E.iconFillColor[C], G = E.none[C], o = E.black[C], M = {
            "SP.I.ANTISATELLITE WEAPON": {
                type: "path",
                d: "m 100,110 0,9 m 0,-34 0,5 m 0,-9 -2,4 4,0 z m -10,9 0,20 20,0 0,-20 z m 25,0 0,20 25,0 0,-20 z m -30,0 -25,0 0,20 25,0 z m 0,10 5,0 m 20,0 5,0"
            },
            "SP.I.ASTRONOMICAL SATELLITE": {
                type: "path",
                d: "m 97,90 -1,-9 8,0 -1,9 m -5,20 1,9 2,0 1,-9 m 8,-10 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
            },
            "SP.I.BIOSATELLITE": {
                type: "path",
                d: "m 100,89 c 0,4.4 -3.6,8 -8,8 -4.4,0 -8,-3.6 -8,-8 0,-4.4 3.6,-8 8,-8 4.4,0 8,3.6 8,8 z m -10,10 0,20 20,0 0,-20 z m 25,0 0,20 25,0 0,-20 z m -30,0 -25,0 0,20 25,0 z m 0,10 5,0 m 20,0 5,0 m -17,-25 17,10 -1,2 -14,-7"
            },
            "SP.I.CAPSULE": {
                type: "path",
                d: "m 85,115 c -2,5 32,5 30,0 l -5,-30 c -1,-5 -19,-5 -20,0 z"
            }
        };
        for(var i in M["SP.I.CIVILIAN ASTRONOMICAL SATELLITE"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 97,90 -1,-9 8,0 -1,9 m -5,20 1,9 2,0 1,-9 m 8,-10 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
        }, M["SP.I.CIVILIAN BIOSATELLITE"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 100,89 c 0,4.4 -3.6,8 -8,8 -4.4,0 -8,-3.6 -8,-8 0,-4.4 3.6,-8 8,-8 4.4,0 8,3.6 8,8 z m -10,10 0,20 20,0 0,-20 z m 25,0 0,20 25,0 0,-20 z m -30,0 -25,0 0,20 25,0 z m 0,10 5,0 m 20,0 5,0 m -17,-25 17,10 -1,2 -14,-7"
        }, M["SP.I.CIVILIAN CAPSULE"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 85,115 c -2,5 32,5 30,0 l -5,-30 c -1,-5 -19,-5 -20,0 z"
        }, M["SP.I.CIVILIAN COMMUNICATIONS SATELLITE"] = [
            {
                type: "path",
                fill: R ? O : !T && O,
                d: "m 110,109 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 100,90 0,9 M 75,81 c 16,12 34,12 50,0"
            }
        ], M["SP.I.CIVILIAN EARTH OBSERVATION SATELLITE"] = [
            {
                type: "path",
                fill: R ? O : !T && O,
                d: "m 107,113 c 0,3.9 -3.1,7 -7,7 -3.9,0 -7,-3.1 -7,-7 0,-3.9 3.1,-7 7,-7 3.9,0 7,3.1 7,7 z m -17,-33 0,20 20,0 0,-20 z m 25,0 0,20 25,0 0,-20 z m -30,0 -25,0 0,20 25,0 z m 0,10 5,0 m 20,0 5,0"
            },
            {
                type: "path",
                fill: !1,
                d: "m 88,107 c 8,-9 16,-9 24,0"
            }
        ], M["SP.I.CIVILIAN MINIATURIZED SATELLITE"] = [
            {
                type: "path",
                fill: R ? O : !T && O,
                d: "m 91.1,92 0,16 17.8,0 0,-16 z m 22.2,0 0,16 22.2,0 0,-16 z m -26.6,0 -22.2,0 0,16 22.2,0 z m 0,8 4.4,0 m 17.8,0 4.4,0"
            },
            {
                type: "path",
                fill: !1,
                d: "m 90,119 10,-9 10,9 m -20,-38 10,9 10,-9 m 35,9 -10,10 10,10 M 55,90 65,100 55,110"
            }
        ], M["SP.I.CIVILIAN NAVIGATIONAL SATELLITE"] = [
            {
                type: "path",
                fill: R ? O : !T && O,
                d: "m 110,109 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 88,87 c 8,6 16,6 24,0 m -20,8 8,-14 8,14"
            }
        ], M["SP.I.CIVILIAN ORBITER SHUTTLE"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 89,115 6,-25 c 3,-12 7,-12 10,0 l 6,25 -10,0 -1,5 -1,-5 z"
        }, M["SP.I.CIVILIAN SATELLITE"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 110,100 10,0 m -40,0 10,0 m -10,-10 -25,0 0,20 25,0 z m 40,0 0,20 25,0 0,-20 z m -30,0 0,20 20,0 0,-20 z"
        }, M["SP.I.CIVILIAN SPACE STATION"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 97.5,112.5 0,7.5 5,0 0,-7.5 z m 0,-32.5 5,0 0,26.4 -5,0 z m -0.3,7.6 C 83.3,88.2 72.5,93.5 72.5,100 c 0,6.9 12.3,12.5 27.5,12.5 15.2,0 27.5,-5.6 27.5,-12.5 0,-6.5 -11,-11.9 -25,-12.4 l 0,5.6 c 9.9,0.4 17.5,3.2 17.5,6.6 0,3.7 -8.9,6.7 -19.8,6.7 -10.9,0 -19.8,-3 -19.8,-6.7 0,-3.4 7.4,-6.1 17.1,-6.6 l 0,-5.6 c -0.1,0 -0.2,-0 -0.3,0 z"
        }, M["SP.I.CIVILIAN TETHERED SATELLITE"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 120,87 -20,12 m 33,-12 c 0,3.6 -2.9,6.5 -6.5,6.5 -3.6,0 -6.5,-2.9 -6.5,-6.5 0,-3.6 2.9,-6.5 6.5,-6.5 3.6,0 6.5,2.9 6.5,6.5 z m -23,22 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
        }, M["SP.I.CIVILIAN WEATHER SATELLITE"] = [
            {
                type: "path",
                fill: R ? O : !T && O,
                d: "m 110,109 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 25,
                text: "WX"
            }
        ], M["SP.I.CIVILIAN"] = a("CIV"), M["SP.I.CIVILIAN"].fill = R || S ? O : !T && O, M["SP.I.CIVILIAN"].stroke = o, M["SP.I.CIVILIAN"].strokewidth = 3, M["SP.I.COMMUNICATIONS SATELLITE"] = [
            {
                type: "path",
                d: "m 110,109 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 100,90 0,9 M 75,81 c 16,12 34,12 50,0"
            }
        ], M["SP.M1.CYBERSPACE"] = l("CYB"), M["SP.M2.CYBERSPACE"] = r("CYB"), M["SP.I.EARTH OBSERVATION SATELLITE"] = [
            {
                type: "path",
                d: "m 107,113 c 0,3.9 -3.1,7 -7,7 -3.9,0 -7,-3.1 -7,-7 0,-3.9 3.1,-7 7,-7 3.9,0 7,3.1 7,7 z m -17,-33 0,20 20,0 0,-20 z m 25,0 0,20 25,0 0,-20 z m -30,0 -25,0 0,20 25,0 z m 0,10 5,0 m 20,0 5,0"
            },
            {
                type: "path",
                fill: !1,
                d: "m 88,107 c 8,-9 16,-9 24,0"
            }
        ], M["SP.I.FF.CREWED SPACE VEHICLE"] = {
            type: "path",
            stroke: !1,
            d: "m 100.3,62.4 c -1.8,-0 -4.3,3.7 -4.5,5.4 -2.5,11.3 -3.4,23.1 -6.2,33.4 -2.9,6.7 -6.8,8.3 -9.9,12.1 -3,3.6 -8.5,10.4 -8.5,10.4 l 0,6.4 c 0,0 5.9,0.9 8.9,1.2 3,0.2 8.7,0.1 8.7,0.1 l 0.3,4.3 4.3,0.2 0.2,3.1 5.8,0 0.9,6.5 0.9,-6.4 5.8,0 0.2,-3.1 4.3,-0.2 0.3,-4.3 c 0,0 5.7,0.1 8.7,-0.1 3,-0.2 8.9,-1.2 8.9,-1.2 l 0,-6.4 c 0,0 -5.5,-6.7 -8.5,-10.3 -3.1,-3.8 -7,-5.4 -9.9,-12.1 -2.8,-10.4 -3.7,-22.2 -6.2,-33.4 -0.3,-2.9 -2.7,-5.5 -4.5,-5.5 z"
        }, M["SP.I.FF.SATELLITE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 115,70 20,0 0,55 -20,0 z m -25,5 20,0 0,45 -20,0 z m -25,-5 20,0 0,55 -20,0 z"
            },
            {
                type: "path",
                fill: !1,
                d: "M80,135 c10,-10 30,-10 40,0 M100,127 L100,100 M70,100 L130,100"
            }
        ], M["SP.I.FF.SPACE STATION"] = [
            {
                type: "path",
                d: "m 103.1,97.4 c -12.4,0.3 -25.7,0.1 -36.7,6.7 -4.1,2.1 -8.5,5.9 -7.8,11 0.2,3.7 0.3,7.4 0.5,11.1 6.2,7.8 16.6,10.4 26,11.8 14,1.8 28.5,1.2 42.1,-3 5.2,-1.7 10.4,-4.3 14.2,-8.3 0.3,-5.1 -0.3,-10.4 0.7,-15.3 -1.2,-4.3 -5.9,-6.4 -9.7,-8.2 -9.2,-4 -19.3,-5.4 -29.2,-5.6 z m -3.2,9.6 c 10.1,-0.2 20.5,1.9 29.1,7.4 -13,8.4 -29.6,9.7 -44.3,6.1 -4.9,-1.3 -9.7,-3.3 -13.7,-6.4 8.8,-4.9 18.9,-6.9 28.9,-7.2 z",
                fill: R ? O : G
            },
            {
                type: "path",
                fill: !1,
                stroke: "black",
                d: "m 96.9,107 c 0.7,-8.1 1.4,-16.3 2.1,-24.4 M 89.3,121.8 c 3.1,-13.2 6.2,-26.3 9.3,-39.5 4.9,12.7 9.7,25.5 14.6,38.2 m 27.8,-5.3 c -0.1,3.9 -0.2,7.8 -0.3,11.6 M 58.6,113.3 c 0.2,4.5 0.3,9 0.5,13.5 m -0.5,-1.2 c 3.5,6.3 11,8.6 17.6,10.5 16.4,4.1 33.9,3.9 50.1,-0.8 5.5,-1.8 11.8,-4.3 14.7,-9.7 m 0.5,-13 c -0.5,5.4 -6.1,8.1 -10.5,10 -15.4,5.7 -32.4,6.1 -48.5,3.6 -7.9,-1.4 -16.3,-3.4 -22.2,-9.2 -3.6,-3.9 -0.9,-9.6 3.4,-11.7 8.3,-5.2 18.3,-6.6 27.9,-7.5 13.5,-1 27.5,0 40.2,5.1 4.2,1.8 9.3,4.6 9.7,9.7 z m -13.3,1.6 c -8.2,-5.9 -18.8,-6.8 -28.6,-7 -9.5,0.1 -19.5,1.2 -27.6,6.4 l -0.6,0.5 m 58.9,-2.6 c -0.8,4.8 -6.1,6.4 -10,7.8 -13.2,3.7 -27.4,3.7 -40.5,-0 -3.8,-1.2 -8.1,-2.8 -9.8,-6.7 -0.7,-4.9 5,-7.1 8.7,-8.5 12.7,-4 26.6,-4 39.5,-1 4.4,1.2 9.8,2.8 11.9,7.3 l 0.1,0.5 0,0.5 z"
            },
            {
                type: "path",
                fill: "black",
                stroke: !1,
                d: "M 75.2,93.1 C 88.9,87 102.6,80.8 116.3,74.7 c 2.3,1.3 4.7,2.6 7,3.9 -13.7,6 -27.3,12 -41,18 -2.4,-1.2 -4.8,-2.3 -7.2,-3.5 z"
            }
        ], M["SP.I.MANUAL TRACK"] = a("MAN"), M["SP.I.MILITARY"] = a("MIL"), M["SP.I.MINIATURIZED SATELLITE"] = [
            {
                type: "path",
                d: "m 91.1,92 0,16 17.8,0 0,-16 z m 22.2,0 0,16 22.2,0 0,-16 z m -26.6,0 -22.2,0 0,16 22.2,0 z m 0,8 4.4,0 m 17.8,0 4.4,0"
            },
            {
                type: "path",
                fill: !1,
                d: "m 90,119 10,-9 10,9 m -20,-38 10,9 10,-9 m 35,9 -10,10 10,10 M 55,90 65,100 55,110"
            }
        ], M["SP.I.NAVIGATIONAL SATELLITE"] = [
            {
                type: "path",
                d: "m 110,109 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 88,87 c 8,6 16,6 24,0 m -20,8 8,-14 8,14"
            }
        ], M["SP.I.ORBITER SHUTTLE"] = {
            type: "path",
            d: "m 89,115 6,-25 c 3,-12 7,-12 10,0 l 6,25 -10,0 -1,5 -1,-5 z"
        }, M["SP.I.RE-ENTRY VEHICLE"] = a("RV"), M["SP.I.RECONNAISSANCE SATELLITE"] = {
            type: "path",
            d: "m 106,100 9,20 m -21,-20 -9,20 m 17,-20 3,20 m -7,-20 -3,20 m 15,-30 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
        }, M["SP.I.SATELLITE, GENERAL"] = a("SAT"), M["SP.I.SATELLITE"] = {
            type: "path",
            d: "m 110,100 10,0 m -40,0 10,0 m -10,-10 -25,0 0,20 25,0 z m 40,0 0,20 25,0 0,-20 z m -30,0 0,20 20,0 0,-20 z"
        }, M["SP.I.SPACE LAUNCH VEHICLE"] = a("SLV"), M["SP.I.SPACE STATION"] = {
            type: "path",
            d: "m 97.5,112.5 0,7.5 5,0 0,-7.5 z m 0,-32.5 5,0 0,26.4 -5,0 z m -0.3,7.6 C 83.3,88.2 72.5,93.5 72.5,100 c 0,6.9 12.3,12.5 27.5,12.5 15.2,0 27.5,-5.6 27.5,-12.5 0,-6.5 -11,-11.9 -25,-12.4 l 0,5.6 c 9.9,0.4 17.5,3.2 17.5,6.6 0,3.7 -8.9,6.7 -19.8,6.7 -10.9,0 -19.8,-3 -19.8,-6.7 0,-3.4 7.4,-6.1 17.1,-6.6 l 0,-5.6 c -0.1,0 -0.2,-0 -0.3,0 z"
        }, M["SP.I.SPACE VEHICLE"] = a("SV"), M["SP.I.TETHERED SATELLITE"] = {
            type: "path",
            d: "m 120,87 -20,12 m 33,-12 c 0,3.6 -2.9,6.5 -6.5,6.5 -3.6,0 -6.5,-2.9 -6.5,-6.5 0,-3.6 2.9,-6.5 6.5,-6.5 3.6,0 6.5,2.9 6.5,6.5 z m -23,22 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
        }, M["SP.I.WEATHER SATELLITE"] = [
            {
                type: "path",
                d: "m 110,109 5,0 m -30,0 5,0 m -5,-10 -25,0 0,20 25,0 z m 30,0 0,20 25,0 0,-20 z m -25,0 0,20 20,0 0,-20 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 100,
                fontsize: 25,
                text: "WX"
            }
        ], M["SP.M1.GEOSTATIONARY ORBIT (GO)"] = l("GO"), M["SP.M1.GEOSYNCHRONOUS ORBIT (GSO)"] = l("GSO"), M["SP.M1.HIGH EARTH ORBIT (HEO)"] = l("HEO"), M["SP.M1.LOW EARTH ORBIT (LEO)"] = l("LEO"), M["SP.M1.MEDIUM EARTH ORBIT (MEO)"] = l("MEO"), M["SP.M1.MOLNIYA ORBIT (MO)"] = l("MO"), M["SP.M2.INFRARED"] = r("IR"), M["SP.M2.OPTICAL"] = r("O"), M["SP.M2.RADAR"] = r("R"), M["SP.M2.SIGNALS INTELLIGENCE (SIGINT)"] = r("SI"), M["SPACE.MISSILE.ICON"] = {
            type: "path",
            d: "M90,135 l0,-10 5,-5 0,-55 5,-5 5,5 0,55 5,5 0,10 -10,-10 z"
        }, (R || S) && (M["SPACE.MISSILE.ICON"].fill = T ? E.fillColor.Unknown : E.iconFillColor.Unknown), M["SPACE.MISSILE.M1.BALLISTIC"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "B"
        }, M["SPACE.MISSILE.M1.INTERCEPTOR"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "I"
        }, M["SPACE.MISSILE.M1.SPACE"] = [
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 125,
                fontsize: 30,
                text: "P"
            }
        ], M["SPACE.MISSILE.M2.ARROW"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "A"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], M["SPACE.MISSILE.M2.GROUND-BASED INTERCEPTOR (GBI)"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "G"
        }, M["SPACE.MISSILE.M2.INTERCONTINENTAL"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "I"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "C"
            }
        ], M["SPACE.MISSILE.M2.INTERMEDIATE RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "I"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], M["SPACE.MISSILE.M2.LONG RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "L"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], M["SPACE.MISSILE.M2.MEDIUM RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "M"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], M["SPACE.MISSILE.M2.PATRIOT"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "P"
        }, M["SPACE.MISSILE.M2.SHORT RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], M["SPACE.MISSILE.M2.SPACE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "P"
            }
        ], M["SPACE.MISSILE.M2.STANDARD MISSILE - 3 (SM-3)"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "3"
            }
        ], M["SPACE.MISSILE.M2.STANDARD MISSILE - TERMINAL PHASE (SM-T)"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "T"
            }
        ], M["SPACE.MISSILE.M2.TERMINAL HIGH-ALTITUDE AREA DEFENSE (THAAD)"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "T"
        }, M["SPACE.MISSILE.M2.CLOSE RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "C"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], M["SPACE.MISSILE.M2.DEBRIS"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "D"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "B"
            }
        ], M["SPACE.MISSILE.M2.UNKNOWN"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "U"
        }, M["SPACE.PLANET LANDER"] = a("PL"), M)M.hasOwnProperty(i) && (I.hasOwnProperty(i) && console.warn("Override of: " + i), n.call(this, M[i], N), I[i] = M[i]);
    }
    s.setColorMode = function(I, t) {
        return this._colorModes[I] = {}, this._colorModes[I].Hostile = t.Hostile, this._colorModes[I].Friend = t.Friend, this._colorModes[I].Neutral = t.Neutral, this._colorModes[I].Unknown = t.Unknown, this._colorModes[I].Civilian = t.Civilian, this._colorModes[I];
    }, s.addSymbolPart = function(I) {
        if ("function" == typeof I) {
            var t = s.getSymbolParts();
            -1 == t.indexOf(I) && s.setSymbolParts(t.concat(I));
        }
        return s;
    }, s.getSymbolParts = function() {
        return this._symbolParts.slice(0);
    }, s.setSymbolParts = function(I) {
        return this._symbolParts = I, s;
    }, s.reset = function() {
        for(var I in this._brokenPath2D = void 0, this._colorModes = {}, t)s.setColorMode(I, t[I]);
        this._dashArrays = {
            pending: "4,4",
            anticipated: "8,12",
            feintDummy: "8,8"
        }, this._getIcons = {}, this._getMetadata = {}, this._hqStaffLength = 100, this._iconCache = {}, this._iconParts = [], this._labelCache = {}, this._labelOverrides = {}, this._iconSIDC = {}, this._iconSIDC.letter = [], this._iconSIDC.number = [], this._STD2525 = !0, this._svgNS = "http://www.w3.org/2000/svg", this._symbolParts = [], s.addSymbolPart(E), s.addSymbolPart(R), s.addSymbolPart(e), s.addSymbolPart(A), s.addSymbolPart(C), s.addSymbolPart(T), s.addSymbolPart(S), s.addSymbolPart(N);
    }, s.reset(), s.BBox = I, s.ColorMode = function(I, t, E, R, e) {
        var A = {};
        return A.Civilian = I, A.Friend = t, A.Hostile = E, A.Neutral = R, A.Unknown = e, A;
    }, s.setBrokenPath2D = function(I) {
        s._brokenPath2D = I;
    }, s._getIconParts = function(I, t, E, R, e) {
        var A = {};
        for(var C in this._iconParts)this._iconParts.hasOwnProperty(C) && this._iconParts[C].call(this, A, I, t, E, R, e);
        return A;
    }, s._scale = function(I, t) {
        return {
            type: "translate",
            x: 100 - 100 * I,
            y: 100 - 100 * I,
            draw: [
                {
                    type: "scale",
                    factor: I,
                    draw: [
                        t
                    ]
                }
            ]
        };
    }, s._translate = function(I, t, E) {
        return {
            type: "translate",
            x: I,
            y: t,
            draw: [
                E
            ]
        };
    }, s.addIconParts = function(I) {
        Array.isArray(I) || (I = [
            I
        ]);
        for(var t = 0; t < I.length; t++)"function" == typeof I[t] && -1 == this._iconParts.indexOf(I[t]) && (this._iconParts = this._iconParts.concat(I[t]));
        return s;
    }, s.addLabelOverrides = function(I, t) {
        return this._labelCache = {}, "function" == typeof I && (this._labelOverrides.hasOwnProperty(t) || (this._labelOverrides[t] = []), this._labelOverrides[t] = this._labelOverrides[t].concat(I)), s;
    }, s.addIcons = function(I) {
        this._iconCache = {}, Array.isArray(I) || (I = [
            I
        ]);
        for(var t = 0; t < I.length; t++)I[t].hasOwnProperty("getMetadata") && (s._getMetadata[I[t].type] = I[t].getMetadata), I[t].hasOwnProperty("getIcons") && (s._getIcons[I[t].type] = I[t].getIcons), I[t].hasOwnProperty("iconParts") && s.addIconParts(I[t].iconParts), I[t].hasOwnProperty("labels") && s.addLabelOverrides(I[t].labels, I[t].type), I[t].hasOwnProperty("icons") && s.addSIDCicons(I[t].icons, I[t].type);
    }, s.addSIDCicons = function(I, t) {
        return "function" == typeof I && -1 == this._iconSIDC[t].indexOf(I) && (this._iconSIDC[t] = this._iconSIDC[t].concat(I)), s;
    }, s.getColorMode = function(I) {
        var t = this._colorModes[I];
        return new s.ColorMode(t.Civilian, t.Friend, t.Hostile, t.Neutral, t.Unknown);
    }, s.getDashArrays = function() {
        return this._dashArrays;
    }, s.getHqStaffLength = function() {
        return this._hqStaffLength;
    }, s.getVersion = function() {
        return this.version;
    }, s.outline = function(I, t, E, R) {
        return function I(t, E, R, e) {
            var A;
            if (Array.isArray(t)) for(var C in A = [], t)A.push(I(t[C], E, R, e));
            else {
                for(var T in A = {}, t)-1 == [
                    "fill",
                    "fillopacity"
                ].indexOf(T) && (A[T] = t[T]);
                if ("translate" == t.type || "rotate" == t.type || "scale" == t.type) for(var S in A.draw = [], t.draw)A.draw.push(I(t.draw[S], E, R, e));
                else A.strokewidth = !1 !== A.stroke ? Number(A.strokewidth || R) + 2 * E : 2 * E, A.stroke = e, A.fill = !1, A.linecap = "round";
            }
            return A;
        }(I, t, E, R);
    }, s.setDashArrays = function(I, t, E) {
        return this._dashArrays.pending = I, this._dashArrays.anticipated = t, this._dashArrays.feintDummy = E, this._dashArrays;
    }, s.setHqStaffLength = function(I) {
        return this._hqStaffLength = I, this._hqStaffLength;
    }, s.setStandard = function(I) {
        return "2525" == I ? this._STD2525 = !0 : "APP6" == I && (this._STD2525 = !1, true);
    }, s._symbolGeometries = O, G.prototype.asCanvas = function(I) {
        if (void 0 === s._brokenPath2D) {
            if ("undefined" == typeof Path2D) s.setBrokenPath2D(!0);
            else {
                var t = document.createElement("canvas");
                t.widht = 1, t.height = 1;
                var E = t.getContext("2d"), R = new Path2D("M0 0 h 10 v 10 h -10 Z");
                E.fill(R);
                var e = E.getImageData(0, 0, 1, 1).data.join();
                s.setBrokenPath2D(!("0,0,0,255" == e));
            }
        }
        var A = document.createElement("canvas");
        I = I || 1, A.width = this.width * I, A.height = this.height * I;
        var C = A.getContext("2d");
        return C.scale(I * this.style.size / 100, I * this.style.size / 100), C.translate(-(this.bbox.x1 - this.style.strokeWidth - this.style.outlineWidth), -(this.bbox.y1 - this.style.strokeWidth - this.style.outlineWidth)), this.canvasDraw.call(this, C, this.drawInstructions), A;
    }, G.prototype.canvasDraw = function I(t, E) {
        for(var R = 0; R < E.length; R++)if (Array.isArray(E[R])) E[R].length && I.call(this, t, E[R]);
        else if ("object" == typeof E[R]) {
            switch(t.lineWidth = E[R].strokewidth || this.style.strokeWidth, void 0 !== E[R].stroke && (E[R].stroke ? t.strokeStyle = E[R].stroke : t.strokeStyle = "rgba(0,0,0,0)"), E[R].strokedasharray ? t.setLineDash(E[R].strokedasharray.split(",")) : 0 != t.getLineDash().length && t.setLineDash([]), E[R].linecap && (t.lineCap = E[R].linecap, t.lineJoin = E[R].linecap), E[R].fill && (t.fillStyle = E[R].fill), E[R].fill || (t.fillStyle = "rgba(0,0,0,0)"), void 0 !== E[R].fillopacity && (t.globalAlpha = E[R].fillopacity), E[R].type){
                case "path":
                    if (s._brokenPath2D) "function" == typeof s.Path2D ? (s.Path2D(t, E[R].d), (void 0 === E[R].fill || void 0 !== E[R].fill && E[R].fill) && t.fill(), 1 != t.globalAlpha && (t.globalAlpha = 1), (void 0 === E[R].stroke || void 0 !== E[R].stroke && E[R].stroke) && t.stroke()) : console.warn("ms.Path2D() is not present, you will need to load functionality for using Canvas in older version of Internet Explorer.");
                    else {
                        var e = new Path2D(E[R].d);
                        E[R].hasOwnProperty("clipPath") && (t.save(), t.clip(new Path2D(E[R].clipPath), "nonzero")), (void 0 === E[R].fill || void 0 !== E[R].fill && E[R].fill) && t.fill(e), E[R].hasOwnProperty("clipPath") && t.restore(), 1 != t.globalAlpha && (t.globalAlpha = 1), (void 0 === E[R].stroke || void 0 !== E[R].stroke && E[R].stroke) && t.stroke(e);
                    }
                    break;
                case "circle":
                    E[R].hasOwnProperty("clipPath") && (t.save(), t.clip(new Path2D(E[R].clipPath), "nonzero")), t.beginPath(), t.arc(E[R].cx, E[R].cy, E[R].r, 0, 2 * Math.PI, !1), (void 0 === E[R].fill || void 0 !== E[R].fill && E[R].fill) && t.fill(), E[R].hasOwnProperty("clipPath") && t.restore(), (void 0 === E[R].stroke || void 0 !== E[R].stroke && E[R].stroke) && t.stroke();
                    break;
                case "text":
                    t.font = (void 0 !== E[R].fontweight ? E[R].fontweight + " " : "") + E[R].fontsize + "px " + E[R].fontfamily, t.textAlign = "middle" == E[R].textanchor ? "center" : E[R].textanchor, t.fillText(E[R].text, E[R].x, E[R].y), E[R].stroke && t.strokeText(E[R].text, E[R].x, E[R].y);
                    break;
                case "translate":
                    t.save(), t.translate(E[R].x, E[R].y), I.call(this, t, E[R].draw), t.restore();
                    break;
                case "rotate":
                    var A = E[R].x, C = E[R].y;
                    t.save(), t.translate(A, C), t.rotate(E[R].degree * Math.PI / 180), t.translate(-A, -C), I.call(this, t, E[R].draw), t.restore();
                    break;
                case "scale":
                    t.save(), t.scale(E[R].factor, E[R].factor), I.call(this, t, E[R].draw), t.restore();
            }
            E[R].linecap && (t.lineCap = "butt", t.lineJoin = "miter"), void 0 !== E[R].fillopacity && (t.globalAlpha = 1);
        }
    }, G.prototype.asDOM = function() {
        var I = document, t = (new DOMParser).parseFromString(this.asSVG(), "text/xml");
        return I.adoptNode(t.documentElement);
    }, G.prototype.asSVG = function() {
        var I = '<svg xmlns="' + s._svgNS + '" version="1.2" baseProfile="tiny" width="' + this.width + '" height="' + this.height + '" viewBox="' + (this.bbox.x1 - this.style.strokeWidth - this.style.outlineWidth) + " " + (this.bbox.y1 - this.style.strokeWidth - this.style.outlineWidth) + " " + this.baseWidth + " " + this.baseHeight + '">';
        return I += (function I(t) {
            for(var E = "", R = 0; R < t.length; R++)if (Array.isArray(t[R])) t[R].length && (E += I.call(this, t[R]));
            else if ("object" == typeof t[R]) {
                var e = "";
                if ("svg" == t[R].type) e += t[R].svg;
                else {
                    switch(t[R].hasOwnProperty("clipPath") && (e += '<clipPath id="clip">', e += '<path d="' + t[R].clipPath + '" clip-rule="nonzero" />', e += "</clipPath>"), t[R].type){
                        case "path":
                            e += '<path d="' + t[R].d + '" ', t[R].hasOwnProperty("clipPath") && (e += 'clip-path="url(#clip)" ');
                            break;
                        case "circle":
                            e += '<circle cx="' + t[R].cx + '" cy="' + t[R].cy + '" r="' + t[R].r + '" ', t[R].hasOwnProperty("clipPath") && (e += 'clip-path="url(#clip)" ');
                            break;
                        case "text":
                            e += '<text x="' + t[R].x + '" y="' + t[R].y + '" text-anchor="' + t[R].textanchor + '" font-size="' + t[R].fontsize + '" font-family="' + t[R].fontfamily + '" ', t[R].fontweight && (e += 'font-weight="' + t[R].fontweight + '" ');
                            break;
                        case "translate":
                            e += '<g transform="translate(' + t[R].x + "," + t[R].y + ')" ';
                            break;
                        case "rotate":
                            e += '<g transform="rotate(' + t[R].degree + "," + t[R].x + "," + t[R].y + ')" ';
                            break;
                        case "scale":
                            e += '<g transform="scale(' + t[R].factor + ')" ';
                    }
                    switch(void 0 !== t[R].stroke && (e += 'stroke-width="' + (t[R].strokewidth || this.style.strokeWidth) + '" ', t[R].strokedasharray && (e += 'stroke-dasharray="' + t[R].strokedasharray + '" '), t[R].linecap && (e += 'stroke-linecap="' + t[R].linecap + '" ', e += 'stroke-linejoin="' + t[R].linecap + '" '), t[R].stroke ? e += 'stroke="' + t[R].stroke + '" ' : e += 'stroke="none" '), void 0 !== t[R].fill && (e += 'fill="' + (t[R].fill ? t[R].fill : "none") + '" '), void 0 !== t[R].fillopacity && (e += 'fill-opacity="' + t[R].fillopacity + '" '), e += ">", t[R].type){
                        case "path":
                            e += "</path>";
                            break;
                        case "circle":
                            e += "</circle>";
                            break;
                        case "text":
                            e += String(t[R].text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") + "</text>";
                            break;
                        case "translate":
                        case "rotate":
                        case "scale":
                            e += I.call(this, t[R].draw), e += "</g>";
                    }
                }
                E += e;
            }
            return E;
        }).call(this, this.drawInstructions), I += "</svg>", this.XML = I;
    }, G.prototype.getAnchor = function() {
        return this.symbolAnchor;
    }, G.prototype.getColors = function() {
        var I = "object" == typeof this.style.colorMode ? this.style.colorMode : s.getColorMode(this.style.colorMode), t = "object" == typeof this.style.frameColor ? this.style.frameColor : s.getColorMode("FrameColor"), E = "object" == typeof this.style.iconColor ? this.style.iconColor : s.getColorMode("IconColor"), R = I, e = s.getColorMode("Black"), A = s.getColorMode("White"), C = s.getColorMode("OffWhite"), T = s.getColorMode("None");
        this.style.civilianColor && this.metadata.civilian && (I.Friend = I.Neutral = I.Unknown = I.Civilian, t.Friend = t.Neutral = t.Unknown = t.Civilian, E.Friend = E.Neutral = E.Unknown = E.Civilian), (this.metadata.joker || this.metadata.faker) && (I.Friend = I.Hostile, t.Friend = t.Hostile, E.Friend = E.Hostile), "" != this.style.monoColor && (t.Friend = t.Neutral = t.Hostile = t.Unknown = t.Civilian = this.style.monoColor, e = t, A = I = T);
        var S = {
            fillColor: I,
            frameColor: t,
            iconColor: E,
            iconFillColor: R,
            none: T,
            black: e,
            white: A
        };
        return this.metadata.frame ? S.frameColor = "object" == typeof this.style.frameColor ? this.style.frameColor : e : S.frameColor = T, this.metadata.fill ? (S.fillColor = this.metadata.frame || !this.metadata.frame && !this.style.icon ? I : T, S.iconColor = "object" == typeof this.style.iconColor ? this.style.iconColor : e, S.iconFillColor = this.metadata.frame ? C : I, S.white = C) : (S.fillColor = T, S.frameColor = this.metadata.frame ? t : T, S.iconColor = t, S.iconFillColor = T, this.metadata.frame || this.metadata.fill || this.style.icon || (S.frameColor = e, S.fillColor = e)), S;
    }, G.prototype.getOctagonAnchor = function() {
        return this.octagonAnchor;
    }, G.prototype.getMetadata = function() {
        var I = {
            activity: !1,
            affiliation: "undefined",
            baseAffilation: "",
            baseDimension: "",
            baseGeometry: {
                g: "",
                bbox: {}
            },
            civilian: !1,
            condition: "",
            context: "",
            dimension: "undefined",
            dimensionUnknown: !1,
            echelon: "",
            faker: !1,
            fenintDummy: !1,
            fill: this.style.fill,
            frame: this.style.frame,
            functionid: "",
            headquarters: !1,
            installation: !1,
            joker: !1,
            mobility: "",
            notpresent: "",
            numberSIDC: !1,
            space: !1,
            STD2525: s._STD2525,
            taskForce: !1,
            unit: !1
        }, t = {
            context: [
                "Reality",
                "Exercise",
                "Simulation"
            ],
            status: [
                "Present",
                "Planned",
                "FullyCapable",
                "Damaged",
                "Destroyed",
                "FullToCapacity"
            ],
            echelonMobility: {
                11: "Team/Crew",
                12: "Squad",
                13: "Section",
                14: "Platoon/detachment",
                15: "Company/battery/troop",
                16: "Battalion/squadron",
                17: "Regiment/group",
                18: "Brigade",
                21: "Division",
                22: "Corps/MEF",
                23: "Army",
                24: "Army Group/front",
                25: "Region/Theater",
                26: "Command",
                31: "Wheeled limited cross country",
                32: "Wheeled cross country",
                33: "Tracked",
                34: "Wheeled and tracked combination",
                35: "Towed",
                36: "Rail",
                37: "Pack animals",
                41: "Over snow (prime mover)",
                42: "Sled",
                51: "Barge",
                52: "Amphibious",
                61: "Short towed array",
                62: "Long towed Array",
                71: "Leader Individual",
                72: "Deputy Individual"
            },
            affiliation: [
                "Hostile",
                "Friend",
                "Neutral",
                "Unknown"
            ],
            dimension: [
                "Air",
                "Ground",
                "Sea",
                "Subsurface"
            ]
        };
        return I.context = t.context[0], this.style.standard && (I.STD2525 = "APP6" != this.style.standard), "" != this.style.monoColor && (I.fill = !1), this.options.sidc = String(this.options.sidc).replace(/\*/g, "-").replace(/ /g, ""), I.numberSIDC = !isNaN(this.options.sidc), I.numberSIDC ? "function" == typeof s._getMetadata.number ? I = s._getMetadata.number.call(this, s, I, t) : console.warn("ms._getMetadata.number() is not present, you will need to load functionality for number based SIDCs") : "function" == typeof s._getMetadata.letter ? I = s._getMetadata.letter.call(this, s, I, t) : console.warn("ms._getMetadata.letter() is not present, you will need to load functionality for letter based SIDCs"), s._symbolGeometries.hasOwnProperty(I.dimension + I.affiliation) ? I.baseGeometry = s._symbolGeometries[I.dimension + I.affiliation] : I.baseGeometry.bbox = new s.BBox, this.style.frame || this.style.icon || (I.baseGeometry = s._symbolGeometries.PositionMarker), I;
    }, G.prototype.getOptions = function(I) {
        var t, E = {};
        for(t in this.options)this.options.hasOwnProperty(t) && (E[t] = this.options[t]);
        if (I || void 0 === I) for(t in this.style)this.style.hasOwnProperty(t) && (E[t] = this.style[t]);
        return E;
    }, G.prototype.getSize = function() {
        return void 0 !== this.width && void 0 !== this.height || this.updateSymbol(), {
            width: this.width,
            height: this.height
        };
    }, G.prototype.getStyle = function() {
        var I, t = {};
        for(I in this.style)this.style.hasOwnProperty(I) && (t[I] = this.style[I]);
        return t;
    }, G.prototype.isValid = function(I) {
        var t = -1 == JSON.stringify(this.drawInstructions).indexOf("null");
        return I ? {
            affiliation: this.metadata.affiliation,
            dimension: this.metadata.dimension,
            dimensionUnknown: this.metadata.dimensionUnknown,
            drawInstructions: t,
            icon: this.validIcon,
            mobility: null != this.metadata.mobility
        } : !("undefined" == this.metadata.affiliation || "undefined" == this.metadata.dimension && !this.metadata.controlMeasure) && t && this.validIcon && null != this.metadata.mobility;
    }, G.prototype.setOptions = function() {
        var I;
        for(I = 0; I < arguments.length; I++){
            var t = arguments[I];
            if ("object" == typeof t) for(var E in t)t.hasOwnProperty(E) && ("SIDC" !== E ? this.style.hasOwnProperty(E) ? this.style[E] = t[E] : this.options[E] = t[E] : this.options.sidc = t[E]);
            else this.options.sidc = t;
        }
        for(I in this.validIcon = !0, this.metadata = this.getMetadata(), this.colors = this.getColors(), this.drawInstructions = [], this.bbox = new s.BBox, s._symbolParts)if (s._symbolParts.hasOwnProperty(I)) {
            var R = s._symbolParts[I].call(this, s), e = 0 < R.pre.length || 0 < R.post.length;
            if (R.pre) {
                if (0 < R.pre.length) {
                    for(; 1 == R.pre.length;)R.pre = R.pre[0];
                    0 != R.pre.length && (this.drawInstructions = [].concat(R.pre, this.drawInstructions));
                }
                if (0 < R.post.length) {
                    for(; 1 == R.post.length && (R.post = R.post[0], void 0 !== R.post););
                    void 0 !== R.post && 0 == R.post.length || (this.drawInstructions = this.drawInstructions.concat(R.post));
                }
                "object" == typeof R.bbox && e && this.bbox.merge(R.bbox);
            }
        }
        this.style.padding && (this.bbox.x1 -= this.style.padding, this.bbox.x2 += this.style.padding, this.bbox.y1 -= this.style.padding, this.bbox.y2 += this.style.padding);
        var A = {
            x: 100,
            y: 100
        };
        if (this.octagonAnchor = {
            x: (A.x - this.bbox.x1 + parseFloat(this.style.strokeWidth) + parseFloat(this.style.outlineWidth)) * this.style.size / 100,
            y: (A.y - this.bbox.y1 + parseFloat(this.style.strokeWidth) + parseFloat(this.style.outlineWidth)) * this.style.size / 100
        }, this.metadata.headquarters) {
            var C = this.style.hqStaffLength || s._hqStaffLength;
            A = {
                x: this.metadata.baseGeometry.bbox.x1,
                y: this.metadata.baseGeometry.bbox.y2 + C
            };
        }
        if (this.style.square) {
            var T = Math.max(A.x - this.bbox.x1, this.bbox.x2 - A.x), S = Math.max(A.y - this.bbox.y1, this.bbox.y2 - A.y), N = Math.max(T, S);
            this.bbox.x1 = A.x - N, this.bbox.y1 = A.y - N, this.bbox.x2 = A.x + N, this.bbox.y2 = A.y + N;
        }
        return this.baseWidth = this.bbox.width() + Number(2 * this.style.strokeWidth) + Number(2 * this.style.outlineWidth), this.baseHeight = this.bbox.height() + Number(2 * this.style.strokeWidth) + Number(2 * this.style.outlineWidth), this.width = this.baseWidth * this.style.size / 100, this.height = this.baseHeight * this.style.size / 100, this.symbolAnchor = {
            x: (A.x - this.bbox.x1 + parseFloat(this.style.strokeWidth) + parseFloat(this.style.outlineWidth)) * this.style.size / 100,
            y: (A.y - this.bbox.y1 + parseFloat(this.style.strokeWidth) + parseFloat(this.style.outlineWidth)) * this.style.size / 100
        }, s._autoValidation && (this.isValid() || (console.warn("Error in symbol: " + this.options.sidc), console.warn(this.isValid(!0)))), this;
    }, G.prototype.toDataURL = function() {
        return "data:image/svg+xml;base64," + window.btoa(this.asSVG());
    }, s.Symbol = G;
    var L = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            i
        ],
        icons: function(I, t, E, R) {
            I["S-P-------"] = [], I["S-P-S-----"] = [
                E["SP.I.FF.SATELLITE"]
            ], I["S-P-V-----"] = [
                E["SP.I.FF.CREWED SPACE VEHICLE"]
            ], I["S-P-T-----"] = [
                E["SP.I.FF.SPACE STATION"]
            ], I["S-P-L-----"] = [
                E["SP.I.SPACE LAUNCH VEHICLE"]
            ];
        }
    };
    function P(I, t, E, R, e, A) {
        var C = t.frame, T = t.affiliation || "Friend", S = t.numberSIDC, N = E.iconColor[T], O = E.iconFillColor[T], G = E.black[T], o = {};
        for(var M in o["AR.I.MILITARY"] = a("MIL"), o["AR.I.CIVILIAN"] = a("CIV"), o["AR.I.CIVILIAN"].fill = R || S ? O : !C && O, o["AR.I.CIVILIAN"].stroke = G, o["AR.I.CIVILIAN"].strokewidth = 3, o["AR.I.MILITARY FIXED WING"] = {
            type: "path",
            d: "M100,100 L130,88 c15,0 15,24 0,24 L100,100 70,112 c-15,0 -15,-24 0,-24 Z"
        }, o["AR.I.CIVILIAN FIXED WING"] = {
            type: "path",
            fill: !1,
            d: "M100,100 L130,88 c15,0 15,24 0,24 L100,100 70,112 c-15,0 -15,-24 0,-24 Z"
        }, o["AR.I.FF.CIVILIAN FIXED WING"] = {
            type: "path",
            stroke: G,
            d: "M62,80 l30,0 0,-10 16,0 0,10 30,0 0,15 -30,0 0,25 10,0 0,5 -36,0 0,-5 10,0 0,-25 -30,0 Z M95,70 l0,-5 10,0 0,5",
            fill: !!R && O
        }, o["AR.I.MILITARY ROTARY WING"] = {
            type: "path",
            d: "M60,85 l40,15 40,-15 0,30 -40,-15 -40,15 z"
        }, o["AR.I.CIVILIAN ROTARY WING"] = {
            type: "path",
            fill: !(!R && !S) && O,
            stroke: G,
            d: "M60,85 l40,15 40,-15 0,30 -40,-15 -40,15 z"
        }, o["AR.I.FF.CIVILIAN ROTARY WING"] = [
            {
                type: "path",
                stroke: G,
                d: "M80,70 l10,10 M120,110 l-10,-10 M80,110 l10,-10 M120,70 l-10,10 M100,115 l0,20 M95,135 l10,0",
                fill: !1
            },
            {
                type: "path",
                stroke: G,
                fill: !!R && O,
                d: "m 113,90 c -0.3,8.8 -1.9,20.3 -10.8,24.6 -7.7,2 -12.3,-7.1 -13.8,-13.3 -2.6,-11.5 -2.3,-26 6.9,-34.6 6.0,-4.9 13.1,1.9 14.9,7.8 2,4.9 2.8,10.2 2.8,15.5 z"
            }
        ], o["AR.I.MILITARY BALLOON"] = [
            {
                type: "circle",
                cx: 100,
                cy: 95,
                r: 15
            },
            {
                type: "path",
                d: "M95,110 l0,10 10,0 0,-10 z"
            }
        ], o["AR.I.FF.MILITARY BALLOON"] = [
            {
                type: "path",
                d: "M90,115 l20,0 0,20 -20,0 z"
            },
            {
                type: "circle",
                cx: 100,
                cy: 90,
                r: 35
            }
        ], o["AR.I.CIVILIAN BALLOON"] = [
            {
                type: "circle",
                fill: !(!R && !S) && O,
                stroke: G,
                cx: 100,
                cy: 95,
                r: 15
            },
            {
                type: "path",
                fill: !(!R && !S) && O,
                stroke: G,
                d: "M95,110 l0,10 10,0 0,-10 z"
            }
        ], o["AR.I.FF.CIVILIAN BALLOON"] = [
            {
                type: "path",
                fill: !(!R && !S) && O,
                stroke: G,
                d: "M90,125 l20,0 0,10 -20,0 z"
            },
            {
                type: "circle",
                fill: !(!R && !S) && O,
                stroke: G,
                cx: 100,
                cy: 90,
                r: 35
            }
        ], o["AR.I.MILITARY AIRSHIP"] = {
            type: "path",
            d: "m 110,110 10,10 10,0 -5,-15 m 0,-10 5,-15 -10,0 -10,10 m 17.2,10 c 0,6.1 -12.2,11.1 -27.2,11.1 -15,0 -27.2,-5 -27.2,-11.1 0,-6.1 12.2,-11.1 27.2,-11.1 15,0 27.2,5 27.2,11.1 z"
        }, o["AR.I.CIVILIAN AIRSHIP"] = {
            type: "path",
            fill: !(!R && !S) && O,
            stroke: G,
            d: "m 110,110 10,10 10,0 -5,-15 m 0,-10 5,-15 -10,0 -10,10 m 17.2,10 c 0,6.1 -12.2,11.1 -27.2,11.1 -15,0 -27.2,-5 -27.2,-11.1 0,-6.1 12.2,-11.1 27.2,-11.1 15,0 27.2,5 27.2,11.1 z"
        }, o["AR.I.UNMANNED AERIAL VEHICLE"] = {
            type: "path",
            d: "m 60,84 40,20 40,-20 0,8 -40,25 -40,-25 z",
            stroke: !1
        }, o["AR.I.AIR DECOY"] = {
            type: "path",
            d: "M65,95 l15,-15 0,30 Z M92.5,95 l15,-15 0,30 Z M120,95 l15,-15 0,30 Z M65,120 l70,0 0,-5 -70,0 Z"
        }, o["SU.IC.AIR DECOY DSymbol"] = {
            type: "path",
            d: "M 85 81 L 65 98 L 85 119 L 85 81 z M 110 81 L 90 98 L 110 119 L 110 81 z M 135 81 L 115 98 L 135 119 L 135 81 z"
        }, o["AR.I.MEDICAL EVACUATION"] = {
            type: "path",
            d: "M93,83 l14,0 0,10 10,0 0,14 -10,0 0,10 -14,0 0,-10 -10,0 0,-14 10,0 Z"
        }, o["AR.I.ATTACK/STRIKE"] = a("A"), o["AR.I.BOMBER"] = a("B"), o["AR.I.CARGO"] = a("C"), o["AR.I.ESCORT"] = a("E"), o["AR.I.FIGHTER"] = a("F"), o["AR.I.FIGHTER INTERCEPTOR"] = a("I"), o["AR.I.JAMMER / ELECTRONIC COUNTER-MEASURES"] = a("J"), o["AR.I.TANKER"] = a("K"), o["AR.I.PATROL"] = a("P"), o["AR.I.RECONNAISSANCE"] = a("R"), o["AR.I.2525 PHOTOGRAPHIC"] = a("X"), o["AR.I.TRAINER"] = a("T"), o["AR.I.UTILITY"] = a("U"), o["AR.I.VSTOL"] = a(R && !S ? "L" : "V"), o["AR.I.AIRBORNE COMMAND POST"] = a(R && !S ? "D" : "ACP"), o["AR.I.AIRBORNE EARLY WARNING"] = a(R && !S ? "W" : "AEW"), o["AR.I.ANTISURFACE WARFARE"] = a(R && !S ? "N" : "ASUW"), o["AR.I.ANTISUBMARINE WARFARE"] = a(R && !S ? "S" : "ASW"), o["AR.I.COMMUNICATIONS"] = a(R && !S ? "Y" : "COM"), o["AR.I.COMBAT SEARCH AND RESCUE"] = a("CSAR"), o["AR.I.ELECTRONIC SUPPORT MEASURES"] = a(R ? "Z" : "ESM"), o["AR.I.GOVERNMENT"] = a("GOV"), o["AR.I.MINE COUNTERMEASURES"] = a("MCM"), o["AR.I.PERSONNEL RECOVERY"] = a(R ? "H" : "PRO"), o["AR.I.PASSENGER"] = a("PX"), o["AR.I.SEARCH AND RESCUE"] = a("SAR"), o["AR.I.SUPRESSION OF ENEMY AIR DEFENCE"] = a("SEAD"), o["AR.I.SPECIAL OPERATIONS FORCES"] = a("SOF"), o["AR.I.ULTRA LIGHT"] = a("UL"), o["AR.I.VIP"] = a("VIP"), o["AR.I.FF.MILITARY FIXED WING"] = {
            type: "path",
            d: "m 99.2,58.2 c -3,0.8 -2.5,5.8 -2.5,5.8 l -0.3,16 -37.2,36.5 1.3,4.6 L 96.7,96.6 97,128.6 l -8.5,8.2 0,4.6 9.3,-4.2 c 0.7,0.6 1.8,1.7 1.8,1.7 0,0 1.2,-1.1 1.9,-1.7 l 9.3,4.2 0,-4.6 -8.5,-8.2 0.3,-32 36.2,24.5 1.3,-4.6 -37.2,-36.5 -0.3,-16 c 0,0 0.5,-5 -2.5,-5.8 -0.4,-0.1 -0.7,-0.1 -1.1,0 z",
            stroke: !1
        }, o["AR.I.FIXED-WING DSymbol"] = {
            type: "path",
            d: R ? "M 99.4 80.8 C 97.9 81.1 98.1 83.4 98.1 83.4 L 98 90.7 L 78.6 107.4 L 79.3 109.4 L 98.1 98.3 L 98.3 112.9 L 93.9 116.6 L 93.9 118.7 L 98.8 116.8 C 99.1 117 99.7 117.5 99.7 117.5 C 99.7 117.5 100.4 117 100.7 116.8 L 105.6 118.7 L 105.6 116.6 L 101.1 112.9 L 101.3 98.3 L 120.2 109.4 L 120.9 107.4 L 101.5 90.7 L 101.3 83.4 C 101.3 83.4 101.6 81.1 100 80.8 C 99.8 80.8 99.6 80.8 99.4 80.8 z" : "M100,100 L130,88 c15,0 15,24 0,24 L100,100 70,112 c-15,0 -15,-24 0,-24 Z"
        }, o["AR.I.CIVILIAN FIXED-WING DSymbol"] = {
            type: "path",
            fill: !(!R && !S) && O,
            stroke: G,
            d: R ? "m 75.1,90.3 19.6,0 0,-6.5 10.5,0 0,6.5 19.6,0 0,9.7 -19.6,0 0,16.2 6.5,0 0,3.2 -23.6,0 0,-3.2 6.5,0 0,-16.2 -19.6,0 z m 21.6,-6.5 0,-3.2 6.5,0 0,3.2" : "M100,100 L130,88 c15,0 15,24 0,24 L100,100 70,112 c-15,0 -15,-24 0,-24 Z"
        }, o["AR.I.FIGHTER/BOMBER"] = a("F/B"), o["AR.I.ELECTRONIC SUPPORT"] = a(R ? "ES" : "ESM"), o["AR.I.PERSONNEL RECOVERY DSymbol"] = a("PR"), o["AR.I.PHOTOGRAPHIC RECONNAISSANCE"] = a("PH"), o["AR.I.ELECTRONIC ATTACK (EA)"] = a("EA"), o["AR.I.VERTICAL-TAKEOFF UAV (VT-UAV)"] = {
            type: "path",
            d: "m 70,85 30,10 30,-10 0,-5 -30,5 -30,-5 z m -10,5 40,15 40,-15 0,30 -40,-15 -40,15 z"
        }, o["AR.I.TETHERED LIGHTER THAN AIR"] = {
            type: "path",
            d: "M 75,110 85,95 m -5,20 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z m 15,-6 0,11 10,0 0,-11 m 10,-14 c 0,8.3 -6.7,15 -15,15 -8.3,0 -15,-6.7 -15,-15 0,-8.3 6.7,-15 15,-15 8.3,0 15,6.7 15,15 z"
        }, o["AR.I.CIVILIAN TETHERED LIGHTER THAN AIR"] = {
            type: "path",
            fill: !(!R && !S) && O,
            stroke: G,
            d: "M 75,110 85,95 m -5,20 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z m 15,-6 0,11 10,0 0,-11 m 10,-14 c 0,8.3 -6.7,15 -15,15 -8.3,0 -15,-6.7 -15,-15 0,-8.3 6.7,-15 15,-15 8.3,0 15,6.7 15,15 z"
        }, o["AR.I.CIVILIAN UNMANNED AERIAL VEHICLE"] = {
            type: "path",
            fill: !(!R && !S) && O,
            stroke: G,
            d: "m 60,84 40,20 40,-20 0,8 -40,25 -40,-25 z"
        }, o["AR.I.WEAPON"] = a("WPN"), o["AR.I.UNDERWATER DECOY DSymbol"] = {
            type: "path",
            d: "M 85 81 L 65 98 L 85 119 L 85 81 z M 110 81 L 90 98 L 110 119 L 110 81 z M 135 81 L 115 98 L 135 119 L 135 81 z"
        }, o["AR.I.BOMB"] = a("BOMB"), o["AR.I.MANUAL TRACK"] = a("MAN"), o["AIR.M1.ATTACK"] = l("A"), o["AIR.M1.BOMBER"] = l("B"), o["AIR.M1.CARGO"] = l("C"), o["AIR.M1.FIGHTER"] = l("F"), o["AIR.M1.INTERCEPTOR"] = l("I"), o["AIR.M1.TANKER"] = l("K"), o["AIR.M1.UTILITY"] = l("U"), o["AIR.M1.VSTOL"] = l(R && !S ? "L" : "V"), o["AIR.M1.PASSENGER"] = l("PX"), o["AIR.M1.ULTRA LIGHT"] = l("UL"), o["AIR.M1.AIRBORNE COMMAND POST"] = l(R && !S ? "D" : "ACP"), o["AIR.M1.ANTISURFACE WARFARE"] = l(R && !S ? "N" : "ASUW"), o["AIR.M1.AIRBORNE EARLY WARNING"] = l(R && !S ? "W" : "AEW"), o["AIR.M1.GOVERNMENT"] = l("GOV"), o["AIR.M1.MEDEVAC"] = {
            type: "path",
            stroke: !1,
            d: "M95.5,80 l9,0 0,-9 9,0 0,-9 -9,0 0,-9 -9,0 0,9 -9,0 0,9 9,0 Z"
        }, o["AIR.M1.ESCORT"] = l("E"), o["AIR.M1.INTENSIVE CARE"] = l("IC"), o["AIR.M1.JAMMER / ELECTRONIC COUNTER-MEASURES"] = l("J"), o["AIR.M1.PATROL"] = l("P"), o["AIR.M1.RECONNAISSANCE"] = l("R"), o["AIR.M1.TRAINER"] = l("T"), o["AIR.M1.PHOTOGRAPHIC"] = l(R && !S ? "X" : "PH"), o["AIR.M1.PERSONNEL RECOVERY"] = l("PR"), o["AIR.M1.ANTISUBMARINE WARFARE"] = l(R && !S ? "S" : "ASW"), o["AIR.M1.COMMUNICATIONS"] = l(R && !S ? "Y" : "COM"), o["AIR.M1.ELECTRONIC SURVEILLANCE MEASURES"] = l(R ? "Z" : "ESM"), o["AIR.M1.MINE COUNTERMEASURES"] = l("MCM"), o["AIR.M1.SEARCH AND RESCUE"] = l("SAR"), o["AIR.M1.SPECIAL OPERATIONS FORCES"] = l("SOF"), o["AIR.M1.SURFACE WARFARE"] = l("SUW"), o["AIR.M1.VIP"] = l("VIP"), o["AIR.M1.COMBAT SEARCH AND RESCUE"] = l(R && !S ? "H" : "CSAR"), o["AIR.M1.SUPRESSION OF ENEMY AIR DEFENCE"] = l("SEAD"), o["AIR.M1.UNMANNED AERIAL VEHICLE"] = {
            type: "path",
            stroke: !1,
            d: "m 80,65 20,13 20,-13 0,-5 -20,10 -20,-10 z"
        }, o["AIR.M1.BOOM-ONLY"] = l("B"), o["AIR.M1.DROUGE-ONLY"] = l("D"), o["AIR.M1.ELECTRONIC SUPPORT (ES)"] = l(R ? "ES" : "ESM"), o["AIR.M1.HIJACKER"] = l("HJ"), o["AIR.M1.CYBERSPACE"] = l("CYB"), o["AIR.M1.FIGHTER/BOMBER"] = l("F/B"), o["AIR.M1.ELECTRONIC ATTACK (EA)"] = l("EA"), o["AIR.M1.MULTIMISSION"] = l("MM"), o["AIR.M1.HIJACKING"] = l("H"), o["AIR.M1.ASW HELO-LAMPS"] = l("LP"), o["AIR.M1.ASW HELO - SH-60R"] = l("60R"), o["AIR.M2.HEAVY"] = r("H"), o["AIR.M2.MEDIUM"] = r("M"), o["AIR.M2.LIGHT"] = r("L"), o["AIR.M2.BOOM-ONLY"] = r("B"), o["AIR.M2.DROUGE-ONLY"] = r("D"), o["AIR.M2.BOOM AND DROUGE"] = r("B/D"), o["AIR.M2.CLOSE RANGE"] = r("CR"), o["AIR.M2.SHORT RANGE"] = r("SR"), o["AIR.M2.MEDIUM RANGE"] = r("MR"), o["AIR.M2.LONG RANGE"] = r("LR"), o["AIR.M2.PHOTOGRAPHIC"] = r("P"), o["AIR.M2.CYBERSPACE"] = r("CYB"), o["AIR.M2.DOWNLINKED"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 140,
            fontsize: 25,
            text: "DL"
        }, o["AIR.MISSILE.ICON"] = {
            type: "path",
            d: "M90,135 l0,-10 5,-5 0,-55 5,-5 5,5 0,55 5,5 0,10 -10,-10 z"
        }, (R || S) && (o["AIR.MISSILE.ICON"].fill = C ? E.fillColor.Unknown : E.iconFillColor.Unknown), o["AIR.MISSILE.IC.ANTIBALLISTIC MISSILE"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 25,
            text: "ABM"
        }, o["AIR.MISSILE.IC.BOMB"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 25,
            text: "BOMB"
        }, o["AIR.MISSILE.M1.AIR"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "A"
        }, o["AIR.MISSILE.M1.SURFACE"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "S"
        }, o["AIR.MISSILE.M1.SUBSURFACE"] = [
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 125,
                fontsize: 30,
                text: "U"
            }
        ], o["AIR.MISSILE.M1.SPACE"] = [
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 125,
                fontsize: 30,
                text: "P"
            }
        ], o["AIR.MISSILE.M1.ANTI-BALLISTIC"] = [
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 95,
                fontsize: 30,
                text: "A"
            },
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 125,
                fontsize: 30,
                text: "B"
            }
        ], o["AIR.MISSILE.M1.BALLISTIC"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "B"
        }, o["AIR.MISSILE.M1.CRUISE"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "C"
        }, o["AIR.MISSILE.M1.LAND"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "L"
        }, o["AIR.MISSILE.M1.INTERCEPTOR"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 30,
            text: "I"
        }, o["AIR.MISSILE.M2.AIR"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "A"
        }, o["AIR.MISSILE.M2.SURFACE"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "S"
        }, o["AIR.MISSILE.M2.SUBSURFACE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "U"
            }
        ], o["AIR.MISSILE.M2.SPACE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "P"
            }
        ], o["AIR.MISSILE.M2.LAUNCHED"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "L"
        }, o["AIR.MISSILE.M2.MISSILE"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "M"
        }, o["AIR.MISSILE.M2.PATRIOT"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "P"
        }, o["AIR.MISSILE.M2.STANDARD MISSILE - 2 (SM-2)"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "2"
            }
        ], o["AIR.MISSILE.M2.STANDARD MISSILE - 6 (SM-6)"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "6"
            }
        ], o["AIR.MISSILE.M2.EVOLVED SEA SPARROW MISSILE (ESSM)"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "S"
            }
        ], o["AIR.MISSILE.M2.ROLLING AIRFRAME MISSILE (RAM)"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 30,
            text: "R"
        }, o["AIR.MISSILE.M2.SHORT RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "S"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], o["AIR.MISSILE.M2.MEDIUM RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "M"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], o["AIR.MISSILE.M2.INTERMEDIATE RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "I"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], o["AIR.MISSILE.M2.LONG RANGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "L"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "R"
            }
        ], o["AIR.MISSILE.M2.INTERCONTINENTAL"] = [
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 95,
                fontsize: 30,
                text: "I"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 125,
                fontsize: 30,
                text: "C"
            }
        ], o)o.hasOwnProperty(M) && (I.hasOwnProperty(M) && console.warn("Override of: " + M), n.call(this, o[M], N), I[M] = o[M]);
    }
    var y = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            P
        ],
        icons: function(I, t, E, R) {
            I["S-A-------"] = [], I["S-A-M-----"] = [
                E["AR.I.MILITARY"]
            ], I["S-A-MF----"] = [
                E["AR.I.FF.MILITARY FIXED WING"]
            ], I["S-A-MFB---"] = [
                E["AR.I.BOMBER"]
            ], I["S-A-MFF---"] = [
                E["AR.I.FIGHTER"]
            ], I["S-A-MFFI--"] = [
                E["AR.I.FIGHTER INTERCEPTOR"]
            ], I["S-A-MFT---"] = [
                E["AR.I.TRAINER"]
            ], I["S-A-MFA---"] = [
                E["AR.I.ATTACK/STRIKE"]
            ], I["S-A-MFL---"] = [
                E["AR.I.VSTOL"]
            ], I["S-A-MFK---"] = [
                E["AR.I.TANKER"]
            ], I["S-A-MFKB--"] = [
                E["AR.I.TANKER"],
                E["AIR.M1.BOOM-ONLY"]
            ], I["S-A-MFKD--"] = [
                E["AR.I.TANKER"],
                E["AIR.M1.DROUGE-ONLY"]
            ], I["S-A-MFC---"] = [
                E["AR.I.CARGO"]
            ], I["S-A-MFCL--"] = [
                E["AR.I.CARGO"],
                E["AIR.M2.LIGHT"]
            ], I["S-A-MFCM--"] = [
                E["AR.I.CARGO"],
                E["AIR.M2.MEDIUM"]
            ], I["S-A-MFCH--"] = [
                E["AR.I.CARGO"],
                E["AIR.M2.HEAVY"]
            ], I["S-A-MFJ---"] = [
                E["AR.I.JAMMER / ELECTRONIC COUNTER-MEASURES"]
            ], I["S-A-MFO---"] = [
                E["AR.I.MEDICAL EVACUATION"]
            ], I["S-A-MFR---"] = [
                E["AR.I.RECONNAISSANCE"]
            ], I["S-A-MFRW--"] = [
                E["AR.I.AIRBORNE EARLY WARNING"]
            ], I["S-A-MFRZ--"] = [
                E["AR.I.ELECTRONIC SUPPORT MEASURES"]
            ], I["S-A-MFRX--"] = R ? [
                E["AR.I.2525 PHOTOGRAPHIC"]
            ] : [
                E["AR.I.RECONNAISSANCE"],
                E["AIR.M2.PHOTOGRAPHIC"]
            ], I["S-A-MFP---"] = [
                E["AR.I.PATROL"]
            ], I["S-A-MFPN--"] = [
                E["AR.I.ANTISURFACE WARFARE"]
            ], I["S-A-MFPM--"] = [
                E["AR.I.MINE COUNTERMEASURES"]
            ], I["S-A-MFU---"] = [
                E["AR.I.UTILITY"]
            ], I["S-A-MFUL--"] = [
                E["AR.I.UTILITY"],
                E["AIR.M2.LIGHT"]
            ], I["S-A-MFUM--"] = [
                E["AR.I.UTILITY"],
                E["AIR.M2.MEDIUM"]
            ], I["S-A-MFUH--"] = [
                E["AR.I.UTILITY"],
                E["AIR.M2.HEAVY"]
            ], I["S-A-MFY---"] = [
                E["AR.I.COMMUNICATIONS"]
            ], I["S-A-MFH---"] = [
                E["AR.I.PERSONNEL RECOVERY"]
            ], I["S-A-MFD---"] = [
                E["AR.I.AIRBORNE COMMAND POST"]
            ], I["S-A-MFQ---"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"]
            ], I["S-A-MFQA--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.ATTACK"]
            ], I["S-A-MFQB--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.BOMBER"]
            ], I["S-A-MFQC--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.CARGO"]
            ], I["S-A-MFQD--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.AIRBORNE COMMAND POST"]
            ], I["S-A-MFQF--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.FIGHTER"]
            ], I["S-A-MFQH--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.COMBAT SEARCH AND RESCUE"]
            ], I["S-A-MFQJ--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.JAMMER / ELECTRONIC COUNTER-MEASURES"]
            ], I["S-A-MFQK--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.TANKER"]
            ], I["S-A-MFQL--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.VSTOL"]
            ], I["S-A-MFQM--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-A-MFQI--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.MINE COUNTERMEASURES"]
            ], I["S-A-MFQN--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.ANTISURFACE WARFARE"]
            ], I["S-A-MFQP--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.PATROL"]
            ], I["S-A-MFQR--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.RECONNAISSANCE"]
            ], I["S-A-MFQRW-"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.AIRBORNE EARLY WARNING"]
            ], I["S-A-MFQRZ-"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.ELECTRONIC SURVEILLANCE MEASURES"]
            ], I["S-A-MFQRX-"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.PHOTOGRAPHIC"]
            ], I["S-A-MFQS--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.ANTISUBMARINE WARFARE"]
            ], I["S-A-MFQT--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.TRAINER"]
            ], I["S-A-MFQU--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.UTILITY"]
            ], I["S-A-MFQY--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.COMMUNICATIONS"]
            ], I["S-A-MFQO--"] = [
                E["AR.I.UNMANNED AERIAL VEHICLE"],
                E["AIR.M1.MEDEVAC"]
            ], I["S-A-MFS---"] = [
                E["AR.I.ANTISUBMARINE WARFARE"]
            ], I["S-A-MFM---"] = [
                E["AR.I.SPECIAL OPERATIONS FORCES"]
            ], I["S-A-MH----"] = [
                E["AR.I.MILITARY ROTARY WING"]
            ], I["S-A-MHA---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.ATTACK"]
            ], I["S-A-MHS---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.ANTISUBMARINE WARFARE"]
            ], I["S-A-MHU---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.UTILITY"]
            ], I["S-A-MHUL--"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.UTILITY"],
                E["AIR.M2.LIGHT"]
            ], I["S-A-MHUM--"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.UTILITY"],
                E["AIR.M2.MEDIUM"]
            ], I["S-A-MHUH--"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.UTILITY"],
                E["AIR.M2.HEAVY"]
            ], I["S-A-MHI---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.MINE COUNTERMEASURES"]
            ], I["S-A-MHH---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.COMBAT SEARCH AND RESCUE"]
            ], I["S-A-MHR---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.RECONNAISSANCE"]
            ], I["S-A-MHQ---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.UNMANNED AERIAL VEHICLE"]
            ], I["S-A-MHC---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.CARGO"]
            ], I["S-A-MHCL--"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.CARGO"],
                E["AIR.M2.LIGHT"]
            ], I["S-A-MHCM--"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.CARGO"],
                E["AIR.M2.MEDIUM"]
            ], I["S-A-MHCH--"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.CARGO"],
                E["AIR.M2.HEAVY"]
            ], I["S-A-MHT---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.TRAINER"]
            ], I["S-A-MHO---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.MEDEVAC"]
            ], I["S-A-MHM---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-A-MHD---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.AIRBORNE COMMAND POST"]
            ], I["S-A-MHK---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.TANKER"]
            ], I["S-A-MHJ---"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.JAMMER / ELECTRONIC COUNTER-MEASURES"]
            ], I["S-A-ML----"] = [
                E["AR.I.FF.MILITARY BALLOON"]
            ], I["S-A-MV----"] = [
                E["AR.I.VIP"]
            ], I["S-A-ME----"] = [
                E["AR.I.ESCORT"]
            ], I["S-A-W-----"] = [
                E["AIR.MISSILE.ICON"]
            ], I["S-A-WM----"] = [
                E["AIR.MISSILE.ICON"]
            ], I["S-A-WMS---"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.SURFACE"],
                E["AIR.MISSILE.M2.LAUNCHED"]
            ], I["S-A-WMSS--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.SURFACE"],
                E["AIR.MISSILE.M2.SURFACE"]
            ], I["S-A-WMSA--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.SURFACE"],
                E["AIR.MISSILE.M2.AIR"]
            ], I["S-A-WMSU--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.SURFACE"],
                E["AIR.MISSILE.M2.SUBSURFACE"]
            ], I["S-A-WMSB--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.IC.ANTIBALLISTIC MISSILE"]
            ], I["S-A-WMA---"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.AIR"],
                E["AIR.MISSILE.M2.LAUNCHED"]
            ], I["S-A-WMAS--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.AIR"],
                E["AIR.MISSILE.M2.SURFACE"]
            ], I["S-A-WMAA--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.AIR"],
                E["AIR.MISSILE.M2.AIR"]
            ], I["S-A-WMAP--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.AIR"],
                E["AIR.MISSILE.M2.SPACE"]
            ], I["S-A-WMU---"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.SUBSURFACE"],
                E["AIR.MISSILE.M2.SURFACE"]
            ], I["S-A-WML---"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.LAND"],
                E["AIR.MISSILE.M2.AIR"]
            ], I["S-A-WMCM--"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.CRUISE"],
                E["AIR.MISSILE.M2.MISSILE"]
            ], I["S-A-WMB---"] = [
                E["AIR.MISSILE.ICON"],
                E["AIR.MISSILE.M1.BALLISTIC"],
                E["AIR.MISSILE.M2.MISSILE"]
            ], I["S-A-WB----"] = [
                E["AIR.MISSILE.IC.BOMB"]
            ], I["S-A-WD----"] = [
                E["AR.I.AIR DECOY"]
            ], I["S-A-C-----"] = [
                E["AR.I.CIVILIAN"]
            ], I["S-A-CF----"] = [
                E["AR.I.FF.CIVILIAN FIXED WING"]
            ], I["S-A-CH----"] = [
                E["AR.I.FF.CIVILIAN ROTARY WING"]
            ], I["S-A-CL----"] = [
                E["AR.I.FF.CIVILIAN BALLOON"]
            ];
        }
    };
    function c(I, t, E, R, e, A) {
        var C = t.frame, T = t.affiliation || "Friend", S = t.baseGeometry, N = t.numberSIDC, O = E.iconColor[T], G = E.iconFillColor[T], o = E.black[T], M = E.white[T], i = {};
        for(var L in i["GR.IC.MILITARY"] = a("MIL"), i["GR.I.GOVERNMENT"] = a("GOV"), i["GR.IC.SUBMARINE NUCLEAR PROPULSION"] = {
            type: "path",
            d: "m 75,110 -10,-10 10,-10 0,-10 50,0 0,10 10,10 -10,10 z"
        }, i["GR.IC.FERRY"] = [
            {
                type: "path",
                fill: R ? G : !C && G,
                d: "m 75,100 0,-35 50,0 0,35 20,0 -15,35 -60,0 -15,-35 z"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: R ? "FE" : "F"
            }
        ], i["GR.IC.ADMINISTRATIVE"] = a("ADM"), i["GR.IC.MANUAL TRACK"] = a("MAN"), i["GR.IC.AIR DEFENSE CHAPARRAL"] = [
            {
                type: "path",
                fill: !1,
                d: "m 85,80 30,0 c 5.54,0 10,4.46 10,10 l 0,5 c 0,5.54 -4.46,10 -10,10 l -30,0 c -5.54,0 -10,-4.46 -10,-10 l 0,-5 c 0,-5.54 4.46,-10 10,-10 z"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 101,
                fontsize: 20,
                text: "C"
            }
        ], i["GR.IC.AIR DEFENSE COMPOSITE"] = {
            type: "path",
            d: "M85,120 C85,110 115,110 115,120 M90,115 L90,90 C90,80 110,80 110,90 L110,115 M100,112 l0,-30",
            fill: !1
        }, i["GR.IC.AIR DEFENSE H/MAD"] = a("HMD"), i["GR.IC.AIR DEFENSE H/MAD HAWK"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 101,
            fontsize: 20,
            text: "H"
        }, i["GR.IC.AIR DEFENSE H/MAD PATRIOT"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 101,
            fontsize: 20,
            text: "P"
        }, i["GR.IC.AIR DEFENSE MISSILE"] = {
            type: "path",
            d: "M90,120 L90,90 C90,80 110,80 110,90 L110,120",
            fill: !1
        }, i["GR.IC.FLOATING CRAFT"] = {
            type: "path",
            d: "m 90,75 20,0 0,-10 -5,0 0,-10 -10,0 0,10 -5,0 z",
            stroke: !1
        }, i["GR.IC.AIR AND MISSILE DEFENSE"] = a("MD"), i["GR.IC.MILITARY HISTORY"] = a("MH"), i["GR.IC.AIR DEFENSE TARGETING UNIT"] = [
            {
                type: "path",
                d: "M80,100 l20,-15 0,15 20,-15 M75,80 C75,100 85,115 105,115",
                fill: !1
            },
            {
                type: "circle",
                cx: 75,
                cy: 110,
                r: 5
            }
        ], i["GR.IC.AIR DEFENSE THEATER MISSILE DEFENSE UNIT"] = a("TMD"), i["GR.IC.AIR DEFENSE SHORT RANGE"] = a("SRD"), i["GR.IC.AIR DEFENSE STINGER"] = [
            {
                type: "path",
                fill: !1,
                d: "m 85,80 30,0 c 5.54,0 10,4.46 10,10 l 0,5 c 0,5.54 -4.46,10 -10,10 l -30,0 c -5.54,0 -10,-4.46 -10,-10 l 0,-5 c 0,-5.54 4.46,-10 10,-10 z"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 101,
                fontsize: 20,
                text: "S"
            }
        ], i["GR.IC.AIR DEFENSE VULCAN"] = [
            {
                type: "path",
                fill: !1,
                d: "m 85,80 30,0 c 5.54,0 10,4.46 10,10 l 0,5 c 0,5.54 -4.46,10 -10,10 l -30,0 c -5.54,0 -10,-4.46 -10,-10 l 0,-5 c 0,-5.54 4.46,-10 10,-10 z"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 101,
                fontsize: 20,
                text: "V"
            }
        ], i["GR.IC.AIR DEFENSE GUN UNIT"] = {
            type: "path",
            d: "M100,80 L100,120 M92,90 l0,20 M108,90 l0,20",
            fill: !1
        }, i["GR.IC.AIR TRAFFIC SERVICES"] = {
            type: "path",
            d: "m 100,95 0,25 m 7.5,-32.5 c 0,4.1 -3.4,7.5 -7.5,7.5 -4.1,0 -7.5,-3.4 -7.5,-7.5 0,-4.1 3.4,-7.5 7.5,-7.5 4.1,0 7.5,3.4 7.5,7.5 z M 60,85 l 40,15 40,-15 0,30 -40,-15 -40,15 z"
        }, i["GR.IC.AIRPORT OF DEBARKATION"] = [
            {
                type: "path",
                fill: !1,
                d: "M80,70 l40,0 M80,80 l25,-25 M100,80 l0,40 M81,90.5 l38,19 M81,109.5 l38,-19"
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 20,
                fill: !1
            }
        ], i["GR.IC.ALLIED COMMAND EUROPE RAPID REACTION CORPS (ARRC)"] = a("ARRC"), i["GR.IC.ALLIED COMMAND OPERATIONS"] = a("ACO"), i["GR.IC.AMMUNITION"] = {
            type: "path",
            d: "m 90,117 0,-25 c 0,-15 20,-15 20,0 l 0,25 m -25,0 30,0",
            fill: !1
        }, i["GR.IC.ARMOUR"] = {
            type: "path",
            d: "M125,80 C150,80 150,120 125,120 L75,120 C50,120 50,80 75,80 Z",
            fill: !1
        }, i["GR.IC.ARMOR, WHEELED"] = [
            {
                type: "path",
                d: "m 120,80 c 25,0 25,30 0,30 l -40,0 C 55,110 55,80 80,80 Z",
                fill: !1
            },
            {
                type: "circle",
                cx: 70,
                cy: 115,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 115,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 130,
                cy: 115,
                r: 5,
                fill: !1
            }
        ], i["GR.IC.AVIATION ROTARY WING"] = {
            type: "path",
            d: "M60,85 l40,15 40,-15 0,30 -40,-15 -40,15 z"
        }, i["GR.IC.AVIATION ROTARY WING 2525C"] = {
            type: "path",
            d: "M100,100 L100,140"
        }, i["GR.IC.AVIATION FIXED WING"] = {
            type: "path",
            d: "M100,100 L130,88 c15,0 15,24 0,24 L100,100 70,112 c-15,0 -15,-24 0,-24 Z"
        }, i["GR.IC.COMBATANT"] = [
            {
                type: "path",
                d: "m 86.9,110 c -3.6,2 -7.2,3.9 -10.8,5.9 2.1,2.9 6.7,3.9 10,2.1 2.6,-0.9 4.7,-3.8 3.1,-6.1 -0.8,-0.6 -1.5,-1.3 -2.3,-1.9 z m 26.3,0.1 c 3.6,2 7.2,3.9 10.8,5.9 -2.1,2.9 -6.7,3.9 -10,2.1 -2.6,-0.9 -4.7,-3.8 -3.1,-6.1 0.8,-0.6 1.5,-1.3 2.3,-1.9 z",
                fill: !1
            },
            {
                type: "path",
                d: "m 112.9,110 c -5.6,-4 -11.3,-7.9 -16.1,-12.5 -4.2,-4.5 -7,-9.8 -9.2,-15.1 -0.8,4.4 -0.9,9.3 2.4,13.2 3.6,4.5 8.6,8.1 13.5,11.8 2.3,1.7 4.7,3.3 7.1,4.8 0.8,-0.7 1.5,-1.5 2.3,-2.2 m -25.7,0 c 5.6,-4 11.3,-7.9 16.1,-12.5 4.2,-4.5 7,-9.8 9.2,-15.1 0.8,4.4 0.9,9.3 -2.4,13.2 -3.6,4.5 -8.6,8.1 -13.5,11.8 -2.3,1.7 -4.7,3.3 -7.1,4.8 -0.8,-0.7 -1.5,-1.5 -2.3,-2.2",
                fill: M,
                strokewidth: 2
            }
        ], i["GR.IC.AVIATION COMPOSITE"] = {
            type: "path",
            d: "m 100,100 15.7,7.9 c 11.8,0 11.8,-15.7 0,-15.7 z m 0,0 -15.7,-7.9 c -11.8,0 -11.8,15.7 0,15.7 z m -10,-20 10,20 -10,20 20,0 -10,-20 10,-20 z"
        }, i["GR.IC.AVIATION TACTICAL AIR CONTROL PARTY"] = a("TACP"), i["GR.IC.AVIATION FORWARD AIR CONTROLLER"] = a("FAC"), i["GR.IC.SPECIAL TROOPS"] = a("ST"), i["GR.IC.RANGER"] = a("RGR"), i["GR.IC.BAND"] = a("BAND"), i["GR.IC.ARMY MUSIC"] = {
            type: "path",
            d: "m 99.6,110.5 c -4.8,-1.4 -10.9,2.2 -10.4,7.7 1,2.5 6.2,2.4 9.6,-0.2 1.9,-1.5 2.7,-3.8 2.3,-6.9 l -0.1,-21.3 c 12.7,5.8 7.6,14.8 5.6,20.7 4.7,-4.9 5.8,-13.2 1.5,-17.9 -4.4,-4.6 -5,-7 -8.4,-13 z",
            stroke: !1
        }, i["GR.IC.BUREAU OF ALCOHOL, TOBACCO, FIREARMS AND EXPLOSIVES (ATF) (DEPARTMENT OF JUSTICE)"] = a("ATF"), i["GR.IC.CBRN"] = [
            {
                type: "path",
                d: "m 80,120 c 0,-20 10,-32 50,-35 m -10,35 C 120,100 110,88 70,85",
                fill: !1
            },
            {
                type: "circle",
                cx: 75,
                cy: 90,
                r: 6
            },
            {
                type: "circle",
                cx: 125,
                cy: 90,
                r: 6
            }
        ], i["GR.CHEMICAL, BIOLOGICAL, RADIOLOGICAL, NUCLEAR, AND HIGH-YIELD EXPLOSIVES"] = [
            {
                type: "path",
                d: "m 90,80 20,0 10,20 -10,20 -20,0 -10,-20 z",
                fill: G
            },
            a("E")
        ], i["GR.IC.SPACE"] = [
            {
                type: "path",
                d: "m 100,80 -1.25,16.5 -4.2,-3.3 2.5,4.9 -5.5,1.7 -0.4,-0 0.2,0 -0.2,0 0.4,-0 5.4,2.3 -1.8,4.6 3.6,-3.5 1.3,16.5 1.3,-16.5 4.2,3.3 -2.5,-4.9 5.5,-1.7 0.4,0 -0.2,-0 0.2,0 -0.4,0 -5.3,-1.7 2.5,-4.6 -4,3.2 z",
                stroke: !1
            }
        ], i["GR.IC.CIVIL AFFAIRS"] = a("CA"), i["GR.IC.CIVIL-MILITARY-COOPERATION"] = {
            type: "path",
            d: "m 60,80 80,0 0,20 c 0,25 -80,25 -80,0 z",
            fill: !1
        }, i["GR.I.CIVILIAN"] = a("CIV"), i["GR.I.CIVILIAN"].fill = R || N ? G : !C && G, i["GR.I.CIVILIAN"].stroke = o, i["GR.I.CIVILIAN"].strokewidth = 3, i["GR.IC.COMMAND AND CONTROL"] = a("C2"), i["GR.IC.COMBAT"] = a("CBT"), i["GR.IC.COMBAT SERVICE SUPPORT"] = a("CSS"), i["GR.IC.COMBAT SUPPORT"] = a("CS"), i["GR.IC.COMBAT SUPPORT (MANOEUVRE ENHANCEMENT)"] = {
            type: "path",
            d: "m 85,80 0,25 15,15 15,-15 0,-25 z"
        }, i["GR.IC.COMBINED ARMS"] = {
            type: "path",
            d: "m 70,80 60,40 m 0,-40 -60,40 m 55,-40 c 25,0 25,40 0,40 l -50,0 C 50,120 50,80 75,80 z",
            fill: !1
        }, i["GR.IC.COUNTER-INTELLIGENCE"] = a("CI"), i["GR.IC.CRIMINAL INVESTIGATION DIVISION"] = a("CID"), i["GR.IC.DIVING"] = [], i["GR.IC.DOG"] = a("DOG"), i["GR.IC.DRILLING"] = {
            type: "path",
            d: "m 85,80 5,40 20,0 5,-40 z"
        }, i["GR.IC.DRUG ENFORCEMENT AGENCY (DEA)"] = a("DEA"), i["GR.IC.ELECTRONIC RANGING"] = {
            type: "path",
            d: "M120,130 c-40,20 -80,-45 -40,-70 z M100,95 L140,75",
            fill: !!R && G
        }, i["GR.IC.ELECTRONIC WARFARE"] = a("EW"), i["GR.IC.EMERGENCY MEDICAL OPERATION"] = {
            type: "path",
            d: "m 90,60 0,22.7 -19.7,-11.3 -10,17.3 L 80,100 l -19.7,11.3 10,17.3 L 90,117.3 90,140 l 20,0 0,-22.7 19.7,11.3 10,-17.3 L 120,100 l 19.7,-11.3 -10,-17.3 L 110,82.7 110,60 90,60 z"
        }, i["GR.IC.ENGINEER"] = {
            type: "path",
            fill: !1,
            d: "M60,120 L60,80 140,80 140,120 M100,80 L100,110"
        }, i["GR.IC.ENGINEER MECHANIZED"] = {
            type: "path",
            fill: !1,
            d: "m 100,90 0,15 m -25,5 0,-20 50,0 0,20 m 0,-30 c 25,0 25,40 0,40 l -50,0 C 50,120 50,80 75,80 Z"
        }, i["GR.IC.ENGINEER UTILITY VEHICLE"] = {
            type: "path",
            fill: !1,
            d: "m 100,100 0,10 m -15,5 0,-15 30,0 0,15 M 70,80 c 0,15 60,15 60,0 l 0,40 -60,0 z"
        }, i["GR.IC.ENVIRONMENTAL PROTECTION"] = {
            type: "path",
            d: "m 100,80 -10,15 5,0 -10,10 5,0 -10,10 15,0 0,5 10,0 0,-5 15,0 -10,-10 5,0 -10,-10 5,0 z",
            fill: !1
        }, i["GR.IC.EXPLOSIVE ORDNANCE DISPOSAL"] = a("EOD"), i["GR.IC.FEDERAL BUREAU OF INVESTIGATION (FBI)"] = a("FBI"), i["GR.IC.FIELD ARTILLERY"] = {
            type: "circle",
            cx: 100,
            cy: 100,
            r: 15
        }, i["GR.IC.FIELD ARTILLERY OBSERVER"] = [
            {
                type: "circle",
                cx: 100,
                cy: 108,
                r: 5
            },
            {
                type: "path",
                d: "m 80,120 30,-20 m -30,20 20,-40 20,40 z",
                fill: !1
            }
        ], i["GR.IC.FIELD CAMP CONSTRUCTION"] = [
            i["GR.IC.ENGINEER"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 77,
                fontsize: 25,
                text: "CAMP"
            }
        ], i["GR.IC.FINANCE"] = {
            type: "path",
            d: "m 80,95 10,-10 20,0 10,10 m -40,0 0,20 40,0 0,-20 z",
            fill: !1
        }, i["GR.IC.FIRE PROTECTION"] = {
            type: "path",
            d: "m 120,90 -5,5 -10,-10 5,-5 -20,0 5,5 -10,10 -5,-5 0,20 5,-5 10,10 -5,5 20,0 -5,-5 10,-10 5,5 z"
        }, i["GR.IC.FIXED WING MISO"] = [
            {
                type: "path",
                fill: !!R && G,
                stroke: o,
                d: "M70,85 l40,0 10,-10 0,50 -10,-10 -40,0 z M120,85 l10,0 M120,95 l10,0 M120,105 l10,0 M120,115 l10,0"
            },
            {
                type: "path",
                d: "M 78.8 61.5 C 68.1 61.5 68.1 78.5 78.8 78.5 L 100 70 L 78.8 61.5 z M 100 70 L 121.3 78.5 C 131.9 78.5 131.9 61.5 121.3 61.5 L 100 70 z"
            }
        ], i["GR.IC.GEOSPATIAL SUPPORT"] = a("GEO"), i["GR.IC.GOVERNMENT ORGANIZATION"] = a("GO"), i["GR.IC.INFORMATION OPERATIONS"] = a(R && !N ? "IW" : "IO"), i["GR.IC.INTERNATIONAL SECURITY ASSISTANCE FORCE (ISAF)"] = a("ISAF"), i["GR.IC.INTERROGATION"] = a("IPW"), i["GR.IC.JOINT FIRE SUPPORT"] = a("JFS"), i["GR.IC.JOINT INFORMATION BUREAU"] = a("JIB"), i["GR.IC.JOINT INTELLIGENCE CENTRE"] = a("JIC"), i["GR.IC.JUDGE ADVOCATE GENERAL"] = a("JAG"), i["GR.IC.LABOUR"] = {
            type: "path",
            d: "m 90,85 20,0 m -10,0 0,25 -10,0 10,10 10,-10 -10,0",
            fill: !1
        }, i["GR.IC.LAUNDRY/BATH"] = {
            type: "path",
            d: "m 95,80 10,10 0,30 m 0,-30 -10,0 m 10,0 -10,10",
            fill: !1
        }, i["GR.IC.LAW ENFORCEMENT"] = {
            type: "path",
            d: "M 100,118 C 76,109 85,95 82,82 c 6,7 12,7 18,0 6,7 12,7 18,0 -3,13 6,27 -18,36 z",
            fill: !1
        }, i["GR.IC.LAW ENFORCEMENT VESSEL"] = [
            {
                type: "path",
                fill: R ? G : !C && G,
                d: "m 75,100 0,-35 50,0 0,35 20,0 -15,35 -60,0 -15,-35 z"
            },
            {
                type: "path",
                d: "m 135,100 -15,35 -10,0 15,-35 z"
            }
        ], i["GR.IC.LIAISON"] = a("LO"), i["GR.IC.MAINTENANCE"] = {
            type: "path",
            d: "M70,90 c10,0 10,20 0,20 m10,-10 l40,0 m10,-10 c-10,0 -10,20 0,20",
            fill: !1
        }, i["GR.IC.MATERIEL"] = a("MAT"), i["GR.IC.MEDICAL EVACUATION HELICOPTER"] = {
            type: "path",
            d: "M60,85 l40,15 40,-15 0,30 -40,-15 -40,15 z M95.5,80 l9,0 0,-9 9,0 0,-9 -9,0 0,-9 -9,0 0,9 -9,0 0,9 9,0 Z"
        }, i["GR.IC.MESSENGER"] = a("M"), i["GR.IC.METEOROLOGICAL"] = a("MET"), i["GR.IC.MILITARY INFORMATION SUPPORT OPERATIONS (MISO)"] = {
            type: "path",
            d: "M70,85 l40,0 10,-10 0,50 -10,-10 -40,0 z M120,85 l10,0 M120,95 l10,0 M120,105 l10,0 M120,115 l10,0"
        }, i["GR.IC.MILITARY INTELLIGENCE"] = a("MI"), i["GR.IC.MILITARY POLICE"] = a("MP"), i["GR.IC.MINE"] = {
            type: "path",
            d: "m 120,100 c 0,5.5 -9,10 -20,10 -11,0 -20,-4.5 -20,-10 0,-5.5 9,-10 20,-10 11,0 20,4.5 20,10 z m -5,-20 -30,40 m 0,-40 30,40 m -15,-40 0,40"
        }, i["GR.IC.MINE CLEARING"] = [
            i["GR.IC.MINE"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 77,
                fontsize: 25,
                text: "CLR"
            }
        ], i["GR.IC.MINE LAUNCHING"] = [
            i["GR.IC.MINE"],
            {
                type: "path",
                d: "m 80,125 0,10 40,0 0,-10 z"
            }
        ], i["GR.IC.MINE LAYING"] = [
            i["GR.IC.MINE"],
            {
                type: "path",
                d: "m 80,65 0,10 40,0 0,-10 z"
            }
        ], i["GR.IC.MISSILE"] = {
            type: "path",
            d: "M90,120 L90,90 C90,80 110,80 110,90 L110,120 M100,120 L100,80",
            fill: !1
        }, i["GR.IC.MISSILE.LIGHT"] = {
            type: "path",
            d: "M90,90 L110,90"
        }, i["GR.IC.MISSILE.MEDIUM"] = {
            type: "path",
            d: "M90,90 L110,90 M90,97 L110,97"
        }, i["GR.IC.MISSILE.HEAVY"] = {
            type: "path",
            d: "M90,90 L110,90 M90,97 L110,97 M90,104 L110,104"
        }, i["GR.IC.MORALE, WELFARE, AND RECREATION"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "MWR"
        }, i["GR.IC.MORTAR"] = [
            {
                type: "circle",
                cx: 100,
                cy: 115,
                r: 5,
                fill: !1
            },
            {
                type: "path",
                d: "M100,111 l0,-30 M90,90 l10,-10 10,10",
                fill: !1
            }
        ], i["GR.IC.MORTUARY AFFAIRS"] = {
            type: "path",
            d: "m 90,95 20,0 m -10,-10 0,30 m -15,-35 30,0 0,40 -30,0 z",
            fill: !1
        }, i["GR.IC.MULTINATIONAL (MN)"] = a("MN"), i["GR.IC.NAVAL"] = [
            {
                type: "path",
                d: "m 105,85 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z m -20,5 30,0 m -15,0 0,30",
                fill: !1
            },
            {
                type: "path",
                d: "M 82.3 102.6 C 82.3 113.9 84.2 115.9 84.2 115.9 L 86.5 114.1 C 90.2 117.8 94.8 120.8 99.9 120.9 L 100.5 120.9 L 101 120.9 C 106.2 120.8 110.8 117.8 114.4 114.1 L 116.7 115.9 C 116.7 115.9 118.6 113.9 118.7 102.6 C 113.9 106.8 108.9 109 108.9 109 L 110.9 110.7 C 110.9 110.7 106.8 115.2 100.5 115.2 L 100.5 115.2 C 100.5 115.2 100.4 115.2 100.4 115.2 C 94.2 115.2 90 110.7 90 110.7 L 92 109 C 92 109 87 106.8 82.3 102.6 z",
                stroke: !1
            }
        ], i["GR.IC.OBSERVER/OBSERVATION"] = {
            type: "path",
            d: "m 100,80 -25,40 50,0 z",
            fill: !1
        }, i["GR.IC.ORDNANCE"] = {
            type: "path",
            d: "M 90,97 83,83 m 27,14 7,-14 M 95,95 90,81 m 15,14 5,-14 m 10,26.5 c 0,6.9 -9,12.5 -20,12.5 -11,0 -20,-5.6 -20,-12.5 0,-6.9 9,-12.5 20,-12.5 11,0 20,5.6 20,12.5 z",
            fill: !1
        }, i["GR.IC.PERSONNEL SERVICES"] = a("PS"), i["GR.IC.PETROLEUM OIL LUBRICANTS"] = {
            type: "path",
            d: "m 100,119 0,-24 m 0,0 C 99,95 85,81 85,81 l 30,0 z",
            fill: !1
        }, i["GR.IC.PIPELINE"] = {
            type: "path",
            d: "m 115,110 15,0 m -15,-15 15,0 m -45,15 -15,0 M 85,95 70,95 m 30,-15 0,10 -15,0 0,25 30,0 0,-25 -15,0 m -10,-10 20,0",
            fill: !1
        }, i["GR.IC.POSTAL"] = {
            type: "path",
            d: "m 80,80 30,0 c -1.4,15.5 0,25 10,35 -20,0 -40,-20 -40,-35 z",
            fill: !1
        }, i["GR.IC.PUBLIC AFFAIRS"] = a("PA"), i["GR.IC.PUBLIC AFFAIRS BROADCAST"] = a("BPAD"), i["GR.IC.PSYCHOLOGICAL OPERATIONS"] = {
            type: "path",
            fill: !!R && G,
            stroke: o,
            d: "M70,85 l40,0 10,-10 0,50 -10,-10 -40,0 z M120,85 l10,0 M120,95 l10,0 M120,105 l10,0 M120,115 l10,0"
        }, i["GR.IC.QUARTERMASTER"] = {
            type: "path",
            fill: !1,
            d: "m 115,95 c 0,15 15,15 15,0 0,-15 -15,-15 -15,0 z m 0,0 -45,0 0,10 10,0 0,-10"
        }, i["GR.IC.RADAR"] = {
            type: "path",
            d: "M72,95 l30,-25 0,25 30,-25 M70,70 c0,35 15,50 50,50",
            fill: !1
        }, i["GR.IC.RADIO"] = [
            {
                type: "circle",
                cx: 100,
                cy: 130,
                r: 10,
                fill: !1
            },
            {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-60 M70,70 l10,-10 10,10 10,-10 10,10 10,-10 10,10"
            }
        ], i["GR.IC.RADIO RELAY"] = [
            {
                type: "circle",
                cx: 100,
                cy: 130,
                r: 10,
                fill: !1
            },
            {
                type: "path",
                fill: !1,
                d: "M100,120 l-15,-40 15,0 0,-20 M70,60 l60,0"
            }
        ], i["GR.IC.RADIO TELETYPE CENTRE"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 135,
                fontsize: 30,
                text: "C"
            },
            {
                type: "path",
                fill: !1,
                d: "M100,140 l0,-80  M70,60 l60,0 M80,70 l40,0"
            }
        ], i["GR.IC.RAILHEAD"] = [
            {
                type: "path",
                fill: !1,
                d: "M100,80 l0,40 M81,90.5 l38,19 M81,109.5 l38,-19"
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 20,
                fill: !1
            },
            s._translate(0, -50, [
                {
                    type: "path",
                    d: "M60,120 l80,0",
                    fill: !1
                },
                {
                    type: "circle",
                    fill: !1,
                    cx: 65,
                    cy: 125,
                    r: 5
                },
                {
                    type: "circle",
                    fill: !1,
                    cx: 75,
                    cy: 125,
                    r: 5
                },
                {
                    type: "circle",
                    fill: !1,
                    cx: 125,
                    cy: 125,
                    r: 5
                },
                {
                    type: "circle",
                    fill: !1,
                    cx: 135,
                    cy: 125,
                    r: 5
                }
            ])
        ], i["GR.IC.RELIGIOUS SUPPORT"] = a("REL"), i["GR.IC.REPLACEMENT HOLDING UNIT"] = a("RHU"), i["GR.IC.SEA-AIR-LAND"] = a("SEAL"), i["GR.IC.SUPPORT"] = a("SPT"), i["GR.IC.ARMY FIELD SUPPORT"] = a("AFS"), i["GR.IC.CONTRACTING SERVICES"] = a("KS"), i["GR.IC.SEAPORT OF DEBARKATION"] = [
            {
                type: "path",
                fill: !1,
                d: "M100,80 l0,40 M81,90.5 l38,19 M81,109.5 l38,-19"
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 20,
                fill: !1
            },
            s._translate(0, -35, s._scale(.6, i["GR.IC.NAVAL"]))
        ], i["GR.IC.SECURITY"] = a("SEC"), i["GR.IC.SECURITY POLICE (AIR)"] = [
            a("SP"),
            {
                type: "path",
                d: "M 78.8 121.5 C 68.1 121.5 68.1 138.5 78.8 138.5 L 100 130 L 78.8 121.5 z M 100 130 L 121.3 138.5 C 131.9 138.5 131.9 121.5 121.3 121.5 L 100 130 z"
            }
        ], i["GR.IC.SENSOR"] = {
            type: "path",
            d: "m 100,80 c 0,7.5 12.5,20 20,20 -7.5,0 -20,12.5 -20,20 0,-7.5 -12.5,-20 -20,-20 7.5,0 20,-12.5 20,-20 z"
        }, i["GR.IC.SHORE PATROL"] = a("SP"), i["GR.IC.SNIPER"] = {
            type: "path",
            fill: !1,
            d: "M 60 85 L 90 85 L 60 85 z M 110 85 L 140 85 L 110 85 z M 100 90 L 100 115 L 100 90 z"
        }, i["GR.IC.PARACHUTE RIGGER"] = {
            type: "path",
            fill: !1,
            d: "m 120,100 -20,20 -20,-20 m 0,0 c 0,-25 40,-25 40,0 l -40,0"
        }, i["GR.IC.SPECIAL FORCES"] = a("SF"), i["GR.IC.SPECIAL OPERATIONS FORCES"] = a("SOF"), i["GR.IC.SURVEILLANCE"] = {
            type: "path",
            d: "m 100,80 -25,40 50,0 z"
        }, i["GR.IC.SURVEY"] = [
            {
                type: "path",
                d: "M85,120 l15,-15 15,15 ",
                fill: !1
            },
            {
                type: "path",
                d: "M100,105 l0,-25 20,12.5 z",
                fill: !!R && G
            }
        ], i["GR.IC.SUSTAINMENT"] = a("SUST"), i["GR.IC.TELEPHONE SWITCH"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 135,
                fontsize: 30,
                text: "C"
            },
            {
                type: "path",
                fill: !1,
                d: "M100,140 l0,-80  M70,60 l60,0"
            }
        ], i["GR.IC.TOPOGRAPHIC"] = {
            type: "path",
            fill: !1,
            d: "m 85,105 c 10,5 20,5 30,0 m -15,-15 15,30 m -30,0 15,-30 0,-10"
        }, i["GR.IC.TRANSPORTATION"] = [
            {
                type: "path",
                fill: !1,
                d: "M100,80 l0,40 M81,90.5 l38,19 M81,109.5 l38,-19"
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 20,
                fill: !1
            }
        ], i["GR.IC.TRANSPORTATION SECURITY AGENCY (TSA)"] = a("TSA"), i["GR.IC.UNMANNED SYSTEMS"] = {
            type: "path",
            d: "m 60,84 40,20 40,-20 0,8 -40,25 -40,-25 z",
            stroke: !1
        }, i["GR.IC.SEARCH AND RESCUE"] = a("SAR"), i["GR.IC.DIVER, CIVILIAN"] = {
            type: "path",
            fill: G,
            d: "M 114.3,94 C 114.3,102.3 107.9,109 100,109 c -7.9,0 -14.2,-6.7 -14.2,-15 0,-8.3 6.4,-15 14.2,-15 7.9,0 14.3,6.7 14.3,15 z m 0,27 14.3,15 -57,0 14.3,-15 M 125.7,79 l 14.3,0 0,30 -14.3,0 m -51.3,0 -14.3,0 0,-30 14.3,0 m 54.2,15 c 0,16.6 -12.8,30 -28.5,30 -15.7,0 -28.5,-13.4 -28.5,-30 C 71.5,77.4 84.3,64 100,64 115.7,64 128.5,77.4 128.5,94 z"
        }, i["GR.IC.VIDEO IMAGERY"] = {
            type: "path",
            fill: !1,
            d: "m 140,110 -26,0 m 7,-20 19,0 m -15,-10 -65,0 0,40 50,0 z m 15,5 0,30"
        }, i["GR.IC.UNITED STATES SECRET SERVICE(TREAS) (USSS)"] = a("USSS"), i["GR.IC.WATER"] = {
            type: "path",
            d: "m 65,90 50,0 c 10,0 20,10 20,20 m -40,-30 20,0 m -10,0 0,10",
            fill: !1
        }, i["GR.IC.WATER PURIFICATION"] = [
            i["GR.IC.WATER"],
            {
                type: "text",
                stroke: !1,
                x: 90,
                y: 110,
                fontsize: 20,
                text: "PURE"
            }
        ], i["GR.IC.FF.AIR ASSAULT WITH ORGANIC LIFT"] = ({
            Unknown: {
                type: "path",
                d: "M35,120 L 90,120 l10,10 10,-10 L165,120",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,120 L 90,120 l10,10 10,-10 L175,120",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M45,120 L 90,120 l10,10 10,-10 L155,120",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M50,120 L 90,120 l10,10 10,-10 L150,120",
                fill: !1
            }
        })[T], i["GR.IC.FF.AIR DEFENCE"] = ({
            Unknown: {
                type: "path",
                d: "m 55,135 c 10,-20 80,-20 90,0",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,150 C25,110 175,110 175,150",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M45,150 C45,110 155,110 155,150",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M70,140 C70,115 130,115 130,140",
                fill: !1
            }
        })[T], i["GR.IC.FF.AIR AND NAVAL GUNFIRE LIAISON COMPANY"] = [], i["GR.IC.FF.AMPHIBIOUS"] = ({
            Unknown: {
                type: "path",
                d: "m 30,95 c 10,0 0,15 13.5,15 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 13.5,0 3.5,-15 13.5,-15",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "m 25,90 c 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 20,-20",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "m 45,110 c 18.8,0 0,-20 18,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18,20",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "m 32,95 c 10,0 0,15 11.5,15 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 11.5,0 1.5,-15 11.5,-15",
                fill: !1
            }
        })[T], i["GR.IC.FF.ANALYSIS"] = {
            type: "path",
            d: "m 100,120 0,-65 m 0,90 -30,-25 60,0 z",
            fill: !1
        }, i["GR.IC.FF.ANTITANK/ANTIARMOUR"] = ({
            Unknown: {
                type: "path",
                fill: !1,
                d: "M55,135 L100,33 145,135"
            },
            Friend: {
                type: "path",
                fill: !1,
                d: "M25,150 L100,52 175,150"
            },
            Neutral: {
                type: "path",
                fill: !1,
                d: "M45,150 L100,47 155,150"
            },
            Hostile: {
                type: "path",
                fill: !1,
                d: "M60,132 L100,30 140,132"
            }
        })[T], i["GR.IC.FF.BORDER PATROL"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 122.8 66.8 C 119.9 66.8 117.4 68.6 117.4 71.6 L 117.4 73.1 L 128.7 73.1 L 128.7 72.4 C 128.7 68.8 126.5 66.8 122.8 66.8 z M 108.6 74.8 L 108.6 76 L 117.6 76 L 117.5 77.5 L 118 80.8 C 119.1 81.5 118.9 82.5 120.8 83.5 C 122.1 84.1 124 84 125.2 83.4 C 127.5 82.4 129 79.2 128.3 76 L 137.5 76 L 137.5 74.8 L 108.6 74.8 z M 94.8 82.1 C 93.3 82.1 92 83.5 92 85 L 92 85.2 C 92 86.6 96 91.3 97 92.6 C 98.2 94.3 100.8 98.8 103.2 98.8 C 104.5 98.8 111.1 93.7 112.6 92.8 L 112.6 106.2 L 126.4 85.6 C 123 85.6 114.9 85.2 112.2 85.9 C 110.2 86.4 105 91.6 103.6 91.7 C 103.4 91 100.6 87.5 100 86.5 C 99.2 85.4 97.2 82.1 95.6 82.1 L 94.8 82.1 z M 130.4 85.6 C 129.6 85.6 117.5 104.1 116.3 106.2 L 128.1 106.2 L 128.1 110.6 L 112.5 110.6 L 112.5 133.2 L 120.7 133.2 L 122 117.5 L 124.3 117.5 L 125.6 133.2 L 133.5 133.2 L 133.5 87.9 C 133.5 87.2 131.2 85.6 130.4 85.6 z M 66.9 90.7 C 66.5 91.4 62.5 96.9 62.5 96.9 C 62.5 97.8 76.7 107.2 78.5 108.3 C 81.4 110.2 83.9 112.1 86.7 114 C 88.2 115 89.4 115.9 90.8 116.8 C 92.1 117.7 94.1 118.5 94.1 120.4 L 94.1 133.2 L 105.5 133.2 L 105.5 121.7 C 105.5 120.6 107.2 119 107.2 118.8 C 107.2 117.6 106.1 118.6 105.6 116.9 C 105.2 115.4 105.4 115.6 104.5 114.5 C 103.5 113.1 101.9 112 99.8 112 C 96.8 112 97.6 111.8 95.3 110.3 C 93.9 109.3 92.5 108.4 91.2 107.4 C 88.7 105.5 85.8 103.5 83.2 101.8 C 80.9 100.3 68.2 91 66.9 90.7 z M 67.9 92.6 L 72.7 95.7 L 72.8 103 L 67.9 99.9 L 67.9 92.6 z M 77.8 99.3 L 82.6 102.6 L 82.6 110 L 77.8 106.6 L 77.8 99.3 z M 87.4 106.2 L 92.5 109.5 L 92.4 116.9 L 87.4 113.5 L 87.4 106.2 z"
            },
            {
                type: "path",
                fill: !!R && G,
                stroke: !1,
                d: "M 117.4 73.1 L 117.4 74.8 L 128.7 74.8 L 128.7 73.1 L 117.4 73.1 z M 126.4 85.6 L 112.6 106.2 L 112.6 110.6 L 128.1 110.6 L 128.1 106.2 L 116.4 106.2 C 117.5 104.1 129.6 85.6 130.4 85.6 L 126.4 85.6 z M 67.9 92.6 L 67.9 99.9 L 72.8 103 L 72.7 95.7 L 67.9 92.6 z M 77.8 99.3 L 77.8 106.6 L 82.6 110 L 82.6 102.6 L 77.8 99.3 z M 87.4 106.2 L 87.4 113.5 L 92.4 116.9 L 92.5 109.5 L 87.4 106.2 z "
            }
        ], i["GR.IC.FF.BROADCAST TRANSMITTER ANTENNA"] = {
            type: "path",
            fill: !1,
            d: "m 80,60 20,20 20,-20 m -20,0 0,80"
        }, i["GR.IC.FF.CORPS SUPPORT"] = ({
            Unknown: {
                type: "path",
                d: "M160,75 l-15,25 15,25",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M175,50 l-30,50 30,50",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M155,50 l-20,50 20,50",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M150,80 l-15,20 15,20",
                fill: !1
            }
        })[T], i["GR.IC.FF.CUSTOMS SERVICE"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 115.5 69.8 C 115.8 70.4 116.9 72.9 117.5 72.9 L 128.3 72.9 L 128.3 69.8 L 115.5 69.8 z M 117.3 74.7 C 116.8 74.7 116 75.7 115.8 76.1 L 117.2 76.1 L 117.2 76.8 C 117.2 79.6 119.8 81.8 122.8 81.8 C 126.5 81.8 128.3 78.6 128.3 74.7 L 117.3 74.7 z M 111.3 83.6 C 110.5 83.6 99.4 91.8 97.8 92.9 C 95.6 94.4 93 96.1 91 97.7 C 89.1 99.2 85.4 100.5 85.4 103.6 L 85.4 104 C 85.4 104.7 87.1 106.7 88.2 106.7 L 88.8 106.7 C 90.2 106.7 108 93.4 111.3 91.7 L 111.3 105.3 L 126 83.6 L 111.3 83.6 z M 75.3 83.6 C 74.5 83.6 73.4 84.4 73.4 85 L 73.4 108.9 C 73.4 109.8 73.9 110.2 74.4 110.5 L 78.5 110.5 L 78.5 83.6 L 75.3 83.6 z M 78.5 110.5 L 78.5 135.2 L 105.6 135.2 L 105.6 110.5 L 78.5 110.5 z M 130.5 83.6 C 129.6 83.6 123.8 92.9 122.9 94.2 C 121.9 95.7 115.7 104.5 115.5 105.3 L 127.6 105.3 L 127.6 110.3 L 111.5 110.3 L 111.5 134.8 L 119.6 134.8 C 120.6 134.8 121.1 127.9 121.3 126.6 C 121.7 123.9 122.4 120.4 122.6 117.8 L 122.9 117.8 L 125.4 134.8 L 133.9 134.8 L 133.9 86.7 C 133.9 85.6 131.9 83.6 130.7 83.6 L 130.5 83.6"
            },
            {
                type: "path",
                fill: !!R && G,
                stroke: !1,
                d: "M 117.5 72.9 L 117.3 74.7 L 128.3 74.7 L 128.3 72.9 L 117.5 72.9 z M 126 83.7 L 111.3 105.3 L 111.5 110.3 L 127.7 110.3 L 127.7 105.3 L 115.5 105.3 C 115.7 104.5 121.9 95.7 122.9 94.3 C 123.8 92.9 129.6 83.7 130.5 83.7 L 126 83.7 z "
            }
        ], i["GR.IC.FF.DEPARTMENT OF JUSTICE (DOJ)"] = {
            type: "path",
            stroke: !1,
            d: "M 100.2 62.3 C 100.1 63.2 99 66.3 98.7 67.4 C 97.8 69.9 99.4 70 99.4 72.3 L 99.4 73 C 99.4 73.7 98.9 73.5 98.3 73.8 C 96.6 72.4 94.2 71 91.3 71 L 90 71 C 84.2 71 80 75.5 74.6 75.5 L 73.9 75.5 C 72.3 75.5 71.5 74.1 71.3 75.8 L 74.3 77.2 C 71.8 82.4 69.9 89.7 67.5 95.5 C 66.3 98.6 65.3 101.6 64.1 104.7 C 63.5 106.3 63.1 107.7 62.5 109.3 C 62 110.5 61.8 113.1 60.2 113.2 C 62.4 116.4 68 120.5 73.3 120.5 L 76 120.5 C 81.6 120.5 87.3 116.6 89.5 113.2 L 88.2 113.2 L 75.4 77.2 L 74.5 77.2 L 74.5 77 L 75.4 77.2 L 78.6 77.7 L 79.3 77.7 L 89.3 76.2 L 90.4 76.3 C 93.7 76.3 93.8 80.2 94.7 80.2 L 97.7 80.2 L 97.7 129.2 L 86.1 129.2 L 86.1 131.5 L 81.4 131.5 L 81.4 134.1 L 77.5 134.1 L 77.5 138.2 L 123.3 138.2 L 123.3 133.9 L 119.3 133.9 L 119.3 131.6 L 114.5 131.6 L 114.5 129.2 L 102.6 129.2 L 102.6 80.2 L 106 80.2 C 107 80.2 106.6 76.4 110.7 76.4 L 111.3 76.4 L 121.2 77.7 L 122.2 77.7 L 125.4 77.3 C 124.3 79.7 123.1 83.8 122.1 86.4 C 120.9 89.6 119.9 92.6 118.7 95.8 C 117.5 98.9 116.6 101.9 115.4 105 C 114.9 106.4 114.2 108.1 113.7 109.6 C 113.4 110.4 113.1 111.1 112.9 111.9 C 112.5 113.2 112.8 113.2 111.2 113.2 C 113.3 116.4 119.2 120.5 124.6 120.5 L 127.2 120.5 C 132.6 120.5 138.8 116.4 140.9 113.2 L 139.8 113.2 L 126.4 77.1 C 127.4 76.9 129.3 76.2 129.3 75.3 C 129.3 74.5 127.8 75.5 126.7 75.5 L 126.3 75.5 C 120.8 75.5 116.6 71 110.9 71 L 109.6 71 C 106.7 71 104.2 72.4 102.6 73.8 C 101.8 73.4 101.3 73.6 101.3 72.3 C 101.3 71.9 102.4 68.8 102.5 68.5 L 100.6 62.3 L 100.2 62.3 z M 126.1 80.8 L 137.8 113.2 L 114.1 113.2 L 126.1 80.8 z M 74.8 80.8 L 86.5 113.2 L 63.1 113.1 L 74.8 80.8 z"
        }, i["GR.IC.FF.DIRECTION FINDING"] = {
            type: "path",
            d: "M100,140 l0,-80 M80,80 l20,-20 20,20",
            fill: !1
        }, i["GR.IC.FF.DIVISION AND BELOW SUPPORT"] = ({
            Unknown: {
                type: "path",
                d: "M40,75 l15,25 -15,25",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,50 l30,50 -30,50",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M45,50 l20,50 -20,50",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M50,80 l15,20 -15,20",
                fill: !1
            }
        })[T], i["GR.IC.FF.EMERGENCY OPERATION"] = [
            {
                type: "path",
                d: "M 100 65 L 115.2 91.3 L 130.3 117.5 C 133.3 112.4 135 106.4 135 100 C 135 80.7 119.3 65 100 65 z M 100 65 C 80.7 65 65 80.7 65 100 C 65 106.4 66.7 112.4 69.7 117.5 L 84.8 91.3 L 100 65 z M 69.7 117.5 C 75.7 128 87 135 100 135 C 113 135 124.3 128 130.3 117.5 L 100 117.5 L 69.7 117.5 z"
            },
            {
                type: "path",
                fill: !!R && G,
                stroke: !1,
                d: "M 69.7,117.5 100,65 l 30.3,52.5 z"
            }
        ], i["GR.IC.FF.FIELD ARTILLERY ROCKET"] = {
            type: "path",
            d: "M100,150 l0,-97 M85,130 l0,-50 M115,130 l0,-50 M85,73 l15,-20 15,20",
            fill: !1
        }, i["GR.IC.FF.HEADQUARTERS OR HEADQUARTERS ELEMENT"] = ({
            Unknown: {
                type: "path",
                d: "M35,80 l130,0 ",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,80 l150,0 ",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M45,80 l110,0 ",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M50,80 l100,0 ",
                fill: !1
            }
        })[T], i["GR.IC.FF.HORSE"] = {
            type: "path",
            d: "m 129,72.8 c 0,0 -6.3,2 -9,2.6 -3.4,0.7 -4.9,1.8 -7.7,3.1 -4.2,1.9 -6.8,3.6 -11.3,4.3 -3.3,0.5 -7.7,1.7 -11,1 -3.9,-0.9 -6.1,-2.9 -10.1,-2.9 -3.7,-0 -7.4,-0.6 -10.6,1.3 -2.6,1.6 -4.7,4.2 -5.8,7.1 -2.3,5.4 -0.8,12.5 -1.2,18.4 -0.2,3.1 -0.4,9.3 -0.6,10.2 0,0 1.6,-0 3.4,-2.5 0.9,-1.2 1.7,-3.4 1.9,-4.9 0.5,-3.1 -0.7,-7.5 -0.4,-10 1.1,-0.3 2.4,2.8 2.6,4.7 0.2,2 -1,3.3 -1.4,5.2 -0.5,3 0.3,5 0.6,8.3 0.1,1.6 0.8,3.9 0.5,6 -0.2,2 -0.2,4.3 -0.2,4.3 l 6.9,0 -0.4,-3.8 c 0,0 -1.8,-2.5 -2.1,-4.3 -0.5,-2.7 -0.5,-5.4 0.2,-8 0.5,-2 3.1,-4.3 4.1,-6.1 1.8,-3.1 3.1,-7.1 3.1,-7.1 0,0 5.1,3.4 9.1,4.2 3.8,0.8 11.6,1.4 11.6,1.4 0,0 -0.2,7.3 0.1,12.4 -0,0.1 0.3,3.9 0.3,3.1 -1.4,3.2 -0,8.2 -0,8.2 0,0 2.9,0 6.3,-0 l -0.3,-3.4 c 0,0 -1.5,-3.5 -1.5,-5.3 0,-3.1 0.1,-5.9 0.9,-8.9 0.4,-1.2 0.7,-2.9 1.3,-4 1.4,-2.2 3.1,-3.8 4.2,-6.1 1.1,-2.6 2.3,-5.3 3.6,-7.9 1.6,-3.3 7.8,-7.3 7.8,-7.3 0,0 5,2.9 8.4,4.9 1.2,0.7 3,0.1 3.7,-1 0.7,-1.1 0.8,-2.2 0.3,-3.3 -3.2,-6.7 -7.8,-9.4 -7.8,-9.4 z",
            stroke: !1
        }, i["GR.IC.FF.INFANTRY"] = ({
            Unknown: {
                type: "path",
                d: "M50,65L150,135M50,135L150,65"
            },
            Friend: {
                type: "path",
                d: "M25,50 L175,150 M25,150 L175,50"
            },
            Neutral: {
                type: "path",
                d: "M45,45L155,155M45,155L155,45"
            },
            Hostile: {
                type: "path",
                d: "M60,70L140,130M60,130L140,70"
            }
        })[T], i["GR.IC.FF.INFANTRY DISMOUNTED"] = ({
            Unknown: {
                type: "path",
                d: "M50,65L150,135M50,135L150,65"
            },
            Friend: {
                type: "path",
                d: "m 45,70 110,60 M 45,130 155,70"
            },
            Neutral: {
                type: "path",
                d: "M45,45L155,155M45,155L155,45"
            },
            Hostile: {
                type: "path",
                d: "M60,70L140,130M60,130L140,70"
            }
        })[T], i["GR.IC.FF.INTERCEPT"] = {
            type: "path",
            d: "M100,120 l0,-60 M80,120 l20,20 20,-20"
        }, i["GR.IC.FF.JAMMING"] = ({
            Unknown: {
                type: "path",
                d: "M63,60 c10,0 0,10 7,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 7,-10 M40,75 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,60 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 M25,75 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M45,60 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10  M45,75 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M67,60 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 13,10   M52,75 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 10,-10 c10,0 0,10 10,10 c10,0 0,-10 7,-10",
                fill: !1
            }
        })[T], i["GR.IC.FF.LAW ENFORCEMENT"] = {
            type: "path",
            d: "m 99.6,51 c -2.8,0 -5,2.3 -5,5.3 0,2.1 1.2,3.9 2.8,4.7 L 87.8,78.3 69.5,78.4 c -0.1,-2.8 -2.3,-5.1 -5,-5.1 -2.8,0 -5,2.3 -5,5.3 0,2.9 2.2,5.3 5,5.3 0.7,0 1.4,-0.2 2,-0.4 l 9.2,16.8 -9.4,17.2 c -0.6,-0.2 -1.2,-0.4 -1.8,-0.4 -2.8,0 -5,2.4 -5,5.3 0,2.9 2.2,5.3 5,5.3 2.8,0 5,-2.3 5,-5.3 0,-0.1 -0,-0.2 -0,-0.3 l 18.3,0.1 9.5,17.1 c -1.6,0.9 -2.7,2.6 -2.7,4.6 0,2.9 2.3,5.3 5,5.3 2.8,0 5,-2.3 5,-5.3 0,-1.9 -0.9,-3.5 -2.3,-4.4 l 9.6,-17.3 18.7,-0.1 c -0,0.1 -0,0.2 -0,0.3 0,2.9 2.3,5.3 5,5.3 2.8,0 5,-2.3 5,-5.3 0,-2.9 -2.2,-5.3 -5,-5.3 -0.8,0 -1.5,0.2 -2.1,0.5 l -9.5,-17.4 9.5,-17.4 c 0.6,0.3 1.4,0.5 2.1,0.5 2.8,0 5,-2.4 5,-5.3 0,-2.9 -2.2,-5.3 -5,-5.3 -2.8,0 -5,2.3 -5,5.3 0,0.1 0,0.2 0,0.3 L 111.8,78.3 102.1,60.8 c 1.5,-0.9 2.5,-2.6 2.5,-4.5 0,-2.9 -2.2,-5.3 -5,-5.3 z"
        }, i["GR.IC.FF.MAIN GUN SYSTEM"] = ({
            Unknown: {
                type: "path",
                d: "M55,65L55,135"
            },
            Friend: {
                type: "path",
                d: "M55,50L55,150"
            },
            Neutral: {
                type: "path",
                d: "M55,45L55,155"
            },
            Hostile: {
                type: "path",
                d: "M55,72L55,128"
            }
        })[T], i["GR.IC.FF.MEDICAL"] = {
            type: "path",
            d: "M100," + S.bbox.y1 + "L100," + S.bbox.y2 + "M" + S.bbox.x1 + ",100L" + S.bbox.x2 + ",100"
        }, i["GR.IC.FF.MEDICAL THEATER"] = ({
            Unknown: {
                type: "path",
                d: "M100,170 l0,-140 M40,75 l15,25 -15,25 M160,75 l-15,25 15,25 M55,100 l90,0",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M100,150 l0,-100 M25,50 l30,50 -30,50 M175,50 l-30,50 30,50 M55,100 l90,0",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M100,155 l0,-110  M45,50 l20,50 -20,50 M155,50 l-20,50 20,50 M65,100 l70,0",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M100,172 l0,-144 M50,80 l15,20 -15,20 M150,80 l-15,20 15,20 M65,100 l70,0",
                fill: !1
            }
        })[T], i["GR.IC.FF.MEDICAL CORPS"] = ({
            Unknown: {
                type: "path",
                d: "M100,170 l0,-140 M160,75 l-15,25 15,25 M30,100 l115,0",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M100,150 l0,-100  M175,50 l-30,50 30,50 M25,100 l120,0",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M100,155 l0,-110 M155,50 l-20,50 20,50 M45,100 l90,0",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M100,172 l0,-144  M150,80 l-15,20 15,20 M28,100 l110,0",
                fill: !1
            }
        })[T], i["GR.IC.FF.MEDICAL TREATMENT FACILITY"] = [
            i["GR.IC.FF.MEDICAL"],
            {
                type: "path",
                fill: !1,
                d: "M70,90 l0,20  M130,90 l0,20"
            }
        ], i["GR.IC.FF.MILITARY POLICE"] = {
            type: "path",
            d: "M 100,140 C 53.7465,122.654 71.0916,95.6737 65.3099,70.6197 c 11.5634,13.4906 23.1267,13.4906 34.6901,0 11.564,13.4906 23.126,13.4906 34.69,0 C 128.908,95.6737 146.254,122.654 100,140 Z",
            fill: !1
        }, i["GR.IC.FF.MOTORIZED"] = {
            type: "path",
            d: "M100," + S.bbox.y1 + "L100," + S.bbox.y2
        }, i["GR.IC.FF.NAVAL"] = [
            {
                type: "path",
                d: "M 100,145 100,65",
                fill: !1
            },
            {
                type: "path",
                d: "m 70,70 60,0",
                fill: !1
            },
            {
                type: "path",
                d: "m 57.8,105.5 c -2.2,0.1 1.3,20.6 2.8,22.1 0.8,0.8 3.5,-3.8 4.6,-2.6 17.4,20.2 33,19.7 34.7,19.6 0,0 0.2,-0 0.3,0 1.7,0.1 17.3,0.5 34.7,-19.6 1,-1.2 3.7,3.4 4.6,2.6 1.4,-1.5 4.9,-21.9 2.8,-22.1 -2.2,-0.1 -4,4.2 -6.7,6.4 -3,2.4 -7.5,3.4 -7.7,4.5 -0.1,0.8 4.9,3.5 3.9,4.9 -5.1,6.3 -15.1,16.6 -31.3,17 l -0.3,4.3 -0.3,-4.3 c -16.2,-0.4 -26.3,-10.7 -31.3,-17 -1.1,-1.3 4,-4.1 3.9,-4.9 -0.2,-1 -4.7,-2 -7.7,-4.5 -2.7,-2.3 -4.5,-6.6 -6.7,-6.4 z",
                stroke: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 60,
                r: 5,
                fill: !1
            }
        ], i["GR.IC.FF.PRISON"] = {
            type: "path",
            stroke: !1,
            d: "M 62.5 67.9 L 62.5 73.4 L 69.9 73.4 L 69.9 106 C 66.8 106.7 64.4 109.6 64.4 113.4 C 64.4 116 65.8 116.9 65.9 118.4 C 66 120.4 65.6 122.5 65.6 124.7 L 65.6 126.6 L 62.5 126.6 L 62.5 132.1 L 137.5 132.1 L 137.5 126.6 L 136 126.6 L 135.6 117.5 C 138.3 113.4 135.8 107 131.5 106 L 131.5 73.4 L 137.5 73.4 L 137.5 67.9 L 62.5 67.9 z M 74.5 73.4 L 87.2 73.4 L 87.2 108.4 C 87.2 109.2 84.8 109.7 83.9 110.6 C 83.1 111.3 82.2 112.7 81.6 113.6 C 80.5 115.2 78.6 118.7 78.6 121.1 L 76.1 117 C 76.5 116.4 76.9 114.6 76.9 113.7 L 76.9 112.2 C 76.9 109.5 74.5 107.9 74.5 106.5 L 74.5 73.4 z M 91.5 73.4 L 110.2 73.4 L 110.2 90.9 C 109 89.6 108.8 87.8 106.8 85.7 C 105.4 84.3 103.5 83 100.8 83 L 100.3 83 C 98.2 83 96.1 83.6 94.9 84.5 C 94.3 85 93.6 85.4 93.1 86 C 92.4 86.6 92.2 87.3 91.5 87.8 L 91.5 73.4 z M 114.3 73.4 L 127.2 73.4 L 127.2 106.5 C 127.2 106.9 124.8 109.2 124.4 111.1 C 123.7 114.2 124.5 114.6 125 117 L 123.3 120.2 C 122.7 118.3 120.7 115 119.7 113.5 C 118.3 111.4 117.3 109.1 114.3 108.9 L 114.3 73.4 z M 99.7 84.9 L 100.6 84.9 C 104.8 84.9 108.5 90.4 108.5 94.7 L 108.5 96.4 C 108.5 100.4 105 106.2 101.3 106.2 L 99.4 106.2 C 94.9 106.2 91.4 100.2 91.6 95.5 C 91.8 90.7 94.9 84.9 99.7 84.9 z M 110.3 100.5 L 110.2 106.9 L 106.7 106.3 L 110.3 100.5 z M 91.5 103.6 L 94.3 106.8 L 91.5 107.4 L 91.5 103.6 z M 70.7 107.9 C 72.9 107.9 74.7 110.4 74.7 112.7 L 74.7 113.4 C 74.7 117.9 70 120.2 67.6 116.7 C 65.7 113.8 66.9 107.9 70.7 107.9 z M 130.6 107.9 C 132.8 107.9 134.4 110.8 134.4 113.2 L 134.4 113.4 C 134.4 116.7 133 116.7 132 118.2 L 128.9 118.3 L 126.7 115.4 L 126.5 113.2 C 126.1 111 128.2 107.9 130.6 107.9 z M 105.9 108.2 C 107.2 108.2 108.9 109 110.2 109.3 L 110.2 126.6 L 91.5 126.6 L 91.5 110.1 C 91.5 108.6 96.6 108.9 98.4 108.9 C 101.1 108.9 104 108.2 105.9 108.2 z M 114.3 110.8 C 117.2 112.3 117.4 113.4 119 116.4 C 120.1 118.5 121.7 120.9 121.7 124 C 121.9 124.2 122.3 124.9 122.7 124.9 C 124 124.9 125.5 119.8 126.7 118.9 L 126.7 119.4 L 127.2 119.4 L 127.2 126.6 L 114.3 126.6 L 114.3 110.8 z M 87.2 111.3 L 87.2 126.6 L 74.5 126.6 L 74.5 118.9 C 75.8 119.4 77.4 125.4 78.6 125.4 C 80.6 125.4 80.7 119.6 81.9 117.5 C 83.2 115.3 84.4 111.9 87.2 111.3 z M 133.6 119.7 L 133.9 126.6 L 131.5 126.6 L 131.5 120.4 L 133.6 119.7 z M 68.1 119.9 C 68.6 120.1 69.9 120.3 69.9 121.1 L 69.9 126.6 L 67.7 126.6 L 68.1 119.9 z"
        }, i["GR.IC.FF.JAIL BREAK"] = [
            i["GR.IC.FF.PRISON"],
            {
                type: "path",
                strokewidth: 5,
                d: "m 70,130 L130,70",
                fill: !1
            }
        ], i["GR.IC.FF.RECONNAISSANCE"] = ({
            Unknown: {
                type: "path",
                d: "M50,135L150,65"
            },
            Friend: {
                type: "path",
                d: "M25,150L175,50"
            },
            Neutral: {
                type: "path",
                d: "M45,155L155,45"
            },
            Hostile: {
                type: "path",
                d: "M60,130L140,70"
            }
        })[T], i["GR.IC.FF.RECONNAISSANCE DISMOUNTED"] = ({
            Unknown: {
                type: "path",
                d: "M50,135L150,65"
            },
            Friend: {
                type: "path",
                d: "M 45,130 155,70"
            },
            Neutral: {
                type: "path",
                d: "M45,155L155,45"
            },
            Hostile: {
                type: "path",
                d: "M60,130L140,70"
            }
        })[T], i["GR.IC.FF.RECONNAISSANCE EQUPIMENT"] = ({
            Unknown: {
                type: "path",
                d: "M50,135L150,65"
            },
            Friend: {
                type: "path",
                d: "M 50.6 132.9 L 149.3 67"
            },
            Neutral: {
                type: "path",
                d: "M45,155L155,45"
            },
            Hostile: {
                type: "path",
                d: "M60,130L140,70"
            }
        })[T], i["GR.IC.FF.SEARCH"] = {
            type: "path",
            d: "m 100,145 0,-90 m 30,65 -30,25 -30,-25",
            fill: !1
        }, i["GR.IC.FF.SENSOR"] = [
            {
                type: "path",
                d: "M" + S.bbox.x1 + ",100 L75,100 M" + (200 - S.bbox.x1) + ",100 L125,100"
            },
            {
                type: "path",
                d: "M65,85 l70,0 -15,30 -40,0 z",
                fill: !!R && G
            }
        ], i["GR.IC.FF.SIGNAL"] = ({
            Unknown: {
                type: "path",
                fill: !1,
                d: "M50,65 100,110 100,90 150,135"
            },
            Friend: {
                type: "path",
                fill: !1,
                d: "M25,50 100,110 100,90 175,150"
            },
            Neutral: {
                type: "path",
                fill: !1,
                d: "M45,45 100,110 100,90 155,155"
            },
            Hostile: {
                type: "path",
                fill: !1,
                d: "M57,70 100,110 100,90 143,130"
            }
        })[T], i["GR.IC.FF.SIGNAL DISMOUNTED"] = ({
            Unknown: {
                type: "path",
                fill: !1,
                d: "M50,65 100,110 100,90 150,135"
            },
            Friend: {
                type: "path",
                fill: !1,
                d: "M 52,66.8 100,110 l 0,-20 47.9,43.1"
            },
            Neutral: {
                type: "path",
                fill: !1,
                d: "M45,45 100,110 100,90 155,155"
            },
            Hostile: {
                type: "path",
                fill: !1,
                d: "M57,70 100,110 100,90 143,130"
            }
        })[T], i["GR.IC.FF.SOUND"] = [
            {
                type: "path",
                d: "M" + S.bbox.x1 + ",100 L75,100 M" + (200 - S.bbox.x1) + ",100 L125,100"
            },
            {
                type: "path",
                d: "M65,85 l70,0 -15,30 -40,0 z",
                fill: !!R && G
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 110,
                fontsize: 25,
                text: "S"
            }
        ], i["GR.IC.FF.SUPPLY"] = ({
            Unknown: {
                type: "path",
                d: "M35,120 l130,0 ",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,120 l150,0",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M45,120 l110,0",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M50,120 l100,0 ",
                fill: !1
            }
        })[T], i["GR.IC.FF.SUPPLY CORPS"] = ({
            Unknown: {
                type: "path",
                d: "M160,75 l-15,25 15,25 M35,120 l120,0",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M175,50 l-30,50 30,50 M25,120 l135,0",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M155,50 l-20,50 20,50 M45,120 l100,0",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M150,80 l-15,20 15,20 M50,120 l100,0",
                fill: !1
            }
        })[T], i["GR.IC.FF.SUPPLY DIVISION AND BELOW"] = ({
            Unknown: {
                type: "path",
                d: "m 45,120 120,0 M 40,75 55,100 40,125",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "m 45,120 130,0 M 25,50 55,100 25,150",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "m 57,120 98,0 M 45,50 65,100 45,150",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "m 50,120 100,0 M 50,80 65,100 50,120",
                fill: !1
            }
        })[T], i["GR.IC.FF.SUPPLY THEATER"] = ({
            Unknown: {
                type: "path",
                d: "M40,75 l15,25 -15,25 M160,75 l-15,25 15,25 M45,120 l110,0 ",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,50 l30,50 -30,50 M175,50 l-30,50 30,50 M40,120 l120,0 ",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: " M45,50 l20,50 -20,50 M155,50 l-20,50 20,50 M55,120 l90,0 ",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M50,80 l15,20 -15,20 M150,80 l-15,20 15,20 M50,120 l100,0",
                fill: !1
            }
        })[T], i["GR.IC.FF.CLASS ALL"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "ALL"
        }, i["GR.IC.FF.CLASS MULTIPLE"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "MULT"
        }, i["GR.IC.FF.CLASS I"] = {
            type: "path",
            d: "m 105,85 c -5,10 -5,20 0,30 m 0,-30 c -20,0 -20,30 0,30",
            fill: !1
        }, i["GR.IC.FF.NATO SUPPLY CLASS I"] = a("I"), i["GR.IC.FF.CLASS II"] = i["GR.IC.QUARTERMASTER"], i["GR.IC.FF.NATO SUPPLY CLASS II"] = a("II"), i["GR.IC.FF.CLASS III"] = {
            type: "path",
            d: "m 100,120 0,-20 -15,-20 30,0 -15,20 ",
            fill: !1
        }, i["GR.IC.FF.CLASS IV"] = i["GR.IC.ENGINEER"], i["GR.IC.FF.NATO SUPPLY CLASS IV"] = a("IV"), i["GR.IC.FF.CLASS V"] = {
            type: "path",
            d: "m 90,115 0,-25 c 0,-10 20,-10 20,0 l 0,25 m -25,0 30,0",
            fill: !1
        }, i["GR.IC.INTERPRETER/TRANSLATOR"] = [
            {
                type: "path",
                d: "m 65,90 15,0 0,-10 20,20 -20,20 0,-10 -15,0 z",
                fill: G
            },
            {
                type: "path",
                d: "m 135,90 -15,0 0,-10 -20,20 20,20 0,-10 15,0 z"
            }
        ], i["GR.IC.FF.NATO SUPPLY CLASS ALL"] = a("ALL"), i["GR.IC.FF.CLASS VI"] = [
            {
                type: "circle",
                cx: 100,
                cy: 85,
                r: 5,
                fill: !1
            },
            {
                type: "path",
                d: "m 85,95 30,0 m -15,15 0,-20 m -10,30 10,-10 10,10",
                fill: !1
            }
        ], i["GR.IC.FF.CLASS VII"] = [
            {
                type: "circle",
                cx: 75,
                cy: 100,
                r: 7
            },
            {
                type: "circle",
                cx: 125,
                cy: 100,
                r: 7
            },
            {
                type: "path",
                d: "M75,100 c0,-20 50,-20 50,0",
                fill: !1
            }
        ], i["GR.IC.FF.CLASS VIII"] = ({
            Unknown: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-90 M165,80 l-130,0"
            },
            Friend: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-70 M175,80 l-150,0"
            },
            Neutral: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-75 M155,80 l-110,0"
            },
            Hostile: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-92 M153,80 l-106,0"
            }
        })[T], i["GR.IC.FF.CLASS VIII.THEATER"] = ({
            Unknown: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-90 M155,80 l-110,0"
            },
            Friend: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-70 M155,80 l-110,0"
            },
            Neutral: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-75 M145,80 l-90,0"
            },
            Hostile: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-92 M153,80 l-106,0"
            }
        })[T], i["GR.IC.FF.CLASS VIII.CORPS"] = ({
            Unknown: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-90 M155,80 l-120,0"
            },
            Friend: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-70 M155,80 l-130,0"
            },
            Neutral: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-75 M145,80 l-100,0"
            },
            Hostile: {
                type: "path",
                fill: !1,
                d: "M100,120 l0,-92 M153,80 l-106,0"
            }
        })[T], i["GR.IC.FF.CLASS IX"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 10,
                fill: !1
            },
            {
                type: "path",
                d: "m 100,110 0,10 m 0,-30 0,-10 m 8.7,14.2 8.4,-4.8 m -8.4,15.9 8,5.4 m -25.4,-5.4 -8.2,5.4 m 8.2,-16.3 -8,-5.4",
                fill: !1
            }
        ], i["GR.IC.EQUIPMENT MANUFACTURE"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 20,
                fill: !1
            },
            {
                type: "path",
                d: "m 100,120 0,20 m 0,-60 0,-20 m 18.1,28.4 16,-9.6 m -16,31.2 16,12 M 82.5,110 66.1,122 M 82.5,88.8 66.5,78",
                fill: !1
            }
        ], i["GR.IC.FF.CLASS X"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "CA"
        }, i["GR.IC.FF.THEATRE SUPPORT"] = ({
            Unknown: {
                type: "path",
                d: "M40,75 l15,25 -15,25 M160,75 l-15,25 15,25",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "M25,50 l30,50 -30,50 M175,50 l-30,50 30,50",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M45,50 l20,50 -20,50 M155,50 l-20,50 20,50",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M50,80 l15,20 -15,20 M150,80 l-15,20 15,20",
                fill: !1
            }
        })[T], i["GR.IC.FF.US MARSHALS SERVICE"] = {
            type: "path",
            d: "m 100,70 7.1,20.3 21.5,0.4 -17.1,13 6.2,20.6 L 100,112 82.4,124.3 88.6,103.7 71.5,90.7 92.9,90.3 z m 0,-5 c -19.3,0 -35,15.7 -35,35 0,19.3 15.7,35 35,35 19.3,0 35,-15.7 35,-35 0,-19.3 -15.7,-35 -35,-35 z m 0,5 c 16.6,0 30,13.4 30,30 0,16.6 -13.4,30 -30,30 -16.6,0 -30,-13.4 -30,-30 0,-16.6 13.4,-30 30,-30 z"
        }, i["GR.M1.ACCIDENT"] = l("ACC"), i["GR.M1.AIRMOBILE/AIR ASSAULT"] = {
            type: "path",
            fill: !1,
            d: "M85,55 L100,75 115,55"
        }, i["GR.M1.ARMORED"] = {
            type: "path",
            fill: !1,
            d: "m 90,60 20,0 c 10,0 10,15 0,15 L 90,75 C 80,75 80,60 90,60"
        }, i["GR.M1.CARGO"] = {
            type: "path",
            fill: !1,
            d: "m 100,60 0,15 -15,0 0,-15 30,0 0,15 -15,0"
        }, i["GR.M1.AMMUNITION"] = {
            type: "path",
            d: "M95,75 L95,60 C95,55 105,55 105,60 L105,75 M90,75 L110,75",
            fill: !1
        }, i["GR.M1.AMPHIBIOUS WARFARE SHIP "] = {
            type: "path",
            d: "M 113,75 100,75 90,64.3 95,65 l 0,-8 10,0 0,8 5.5,-0.6 L 100,75"
        }, i["GR.M1.ANTISUBMARINE WARFARE"] = l("P"), i["GR.M1.AREA"] = l("AREA"), i["GR.M1.ARMY"] = l("XXXX"), i["GR.M1.ATTACK"] = l("A"), i["GR.M1.AVIATION"] = {
            type: "path",
            d: "m 75,60 0,15 50,-15 0,15 z"
        }, i["GR.M1.BATTALION"] = l("II"), i["GR.M1.BIOLOGICAL"] = l("B"), i["GR.M1.BORDER"] = l("BOR"), i["GR.M1.BRIDGING"] = {
            type: "path",
            fill: !1,
            d: "m 80,80 5,-5 30,0 5,5 m -40,-20 5,5 30,0 5,-5"
        }, i["GR.M1.BRIGADE"] = l("X"), i["GR.M1.CHEMICAL"] = l("C"), i["GR.M1.INTRUSION"] = l("I"), i["GR.M1.CHEMICAL SURVEILLANCE"] = l("RS"), i["GR.M1.CIVILIAN"] = l("CIV"), i["GR.M1.CLOSE PROTECTION"] = l("CLP"), i["GR.M1.COMBAT"] = l("CBT"), i["GR.M1.COMMAND AND CONTROL"] = l("C2"), i["GR.M1.COMMAND AND CONTROL ROTARY WING"] = l(R ? "Y" : "C2"), i["GR.M1.TILT-ROTOR"] = l("TR"), i["GR.M1.COMMAND POST NODE"] = l("CPN"), i["GR.M1.COMMUNICATIONS CONTINGENCY PACKAGE"] = l("CCP"), i["GR.M1.CONSTRUCTION"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 75,
            fontsize: 20,
            text: "CONST"
        }, i["GR.M1.COMPANY"] = l("I"), i["GR.M1.CORPS"] = l("XXX"), i["GR.M1.CROSS CULTURAL COMMUNICATION"] = l("CCC"), i["GR.M1.CROWD AND RIOT CONTROL"] = l("CRC"), i["GR.M1.DECONTAMINATION"] = l("D"), i["GR.M1.DETENTION"] = l("DET"), i["GR.M1.DEPUTY"] = l("DEP"), i["GR.M1.DIRECT COMMUNICATIONS"] = {
            type: "path",
            fill: !1,
            d: "m 95,65 -5,5 5,5 m 10,-10 5,5 -5,5 M 90,70 c 20,0 20,0 20,0 m 15,0 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z m -40,0 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z"
        }, i["GR.M1.DIVING"] = {
            type: "path",
            fill: !1,
            d: "m 104.6,64.8 c 0,2.7 -2.1,4.8 -4.6,4.8 -2.5,0 -4.6,-2.2 -4.6,-4.8 0,-2.7 2.1,-4.8 4.6,-4.8 2.5,0 4.6,2.2 4.6,4.8 z m 0,8.7 4.6,4.8 -18.3,0 4.6,-4.8 M 108.3,60 l 4.6,0 0,9.6 -4.6,0 m -16.5,0 -4.6,0 0,-9.6 4.6,0 m 17.4,4.8 c 0,5.3 -4.1,9.6 -9.2,9.6 -5.1,0 -9.2,-4.3 -9.2,-9.6 0,-5.3 4.1,-9.6 9.2,-9.6 5.1,0 9.2,4.3 9.2,9.6 z"
        }, i["GR.M1.DIVISION"] = l("XX"), i["GR.M1.MARINE DIVISION"] = l("D"), i["GR.M1.DOG"] = l("DOG"), i["GR.M1.DRILLING"] = {
            type: "path",
            d: "m 90,60 5,15 10,0 5,-15 z"
        }, i["GR.M1.ELECTRO-OPTICAL"] = l("EO"), i["GR.M1.ENHANCED"] = l("ENH"), i["GR.M1.EXPLOSIVE ORDNANCE DISPOSAL"] = l("EOD"), i["GR.M1.EARLY WARNING RADAR"] = l("EWR"), i["GR.M1.FIRE DIRECTION CENTRE"] = l("FDC"), i["GR.M1.FORCE"] = l("F"), i["GR.M1.FORWARD"] = l("FWD"), i["GR.M1.GROUND STATION MODULE"] = l("GSM"), i["GR.M1.HIJACKING"] = l("H"), i["GR.M1.INDIVIDUAL"] = {
            type: "path",
            fill: !1,
            d: "M85,65 l30,0"
        }, i["GR.M1.INTRUSION"] = l("I"), i["GR.M1.J1"] = l("J1"), i["GR.M1.J2"] = l("J2"), i["GR.M1.J3"] = l("J3"), i["GR.M1.J4"] = l("J4"), i["GR.M1.J5"] = l("J5"), i["GR.M1.J6"] = l("J6"), i["GR.M1.J7"] = l("J7"), i["GR.M1.J8"] = l("J8"), i["GR.M1.J9"] = l("J9"), i["GR.M1.JOINT NETWORK NODE"] = l("JNN"), i["GR.M1.LANDING SUPPORT"] = l("LS"), i["GR.M1.LARGE COMMUNICATIONS CONTINGENCY PACKAGE"] = l("LCCP"), i["GR.M1.LARGE EXTENSION NODE"] = l("LEN"), i["GR.M1.LOAD HANDLING SYSTEM"] = l("LHS"), i["GR.M1.MAINTENANCE"] = {
            type: "path",
            fill: !1,
            d: "m 84,70 32,0 m 4,-5 c -5,0 -5,10 0,10 M 80,65 c 5,0 5,10 0,10"
        }, i["GR.M1.MEDEVAC"] = {
            type: "path",
            stroke: !1,
            d: "M95.5,80 l9,0 0,-9 9,0 0,-9 -9,0 0,-9 -9,0 0,9 -9,0 0,9 9,0 Z"
        }, i["GR.M1.METEOROLOGICAL"] = l("MET"), i["GR.M1.MINE COUNTERMEASURE"] = l("MCM"), i["GR.M1.MISSILE"] = {
            type: "path",
            d: "M95,80 L95,60 C95,55 105,55 105,60 L105,80 M100,80 L100,55",
            fill: !1
        }, i["GR.M1.(MOBILE) ADVISOR AND SUPPORT"] = {
            type: "path",
            d: "m 105,65 5,5 -5,5 M 90,70 c 20,0 20,0 20,0 m 15,0 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z m -40,0 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z",
            fill: !1
        }, i["GR.M1.MOBILE SUBSCRIBER EQUIPMENT"] = l("MSE"), i["GR.M1.MOBILITY ASSAULT"] = l("MA"), i["GR.M1.MOBILITY SUPPORT"] = l("MS"), i["GR.M1.MOVEMENT CONTROL CENTRE"] = l("MCC"), i["GR.M1.MULTINATIONAL"] = l("MN"), i["GR.M1.MULTINATIONAL SPECIALIZED UNIT"] = l("MSU"), i["GR.M1.MULTIPLE ROCKET LAUNCHER"] = {
            type: "path",
            d: "M85,75 l15,-15 15,15 M85,67 l15,-15 15,15",
            fill: !1
        }, i["GR.M1.NATO MEDICAL ROLE 1"] = {
            type: "text",
            stroke: !1,
            x: 120,
            y: 77,
            fontsize: 25,
            text: "1"
        }, i["GR.M1.NATO MEDICAL ROLE 2"] = {
            type: "text",
            stroke: !1,
            x: 120,
            y: 77,
            fontsize: 25,
            text: "2"
        }, i["GR.M1.NATO MEDICAL ROLE 3"] = {
            type: "text",
            stroke: !1,
            x: 120,
            y: 77,
            fontsize: 25,
            text: "3"
        }, i["GR.M1.NATO MEDICAL ROLE 4"] = {
            type: "text",
            stroke: !1,
            x: 120,
            y: 77,
            fontsize: 25,
            text: "4"
        }, i["GR.M1.NAVAL"] = s._translate(0, -35, s._scale(.6, i["GR.IC.NAVAL"])), i["GR.M1.NODE CENTRE"] = l("NC"), i["GR.M1.NUCLEAR"] = l("N"), i["GR.M1.OF-1"] = l("OF-1"), i["GR.M1.OF-2"] = l("OF-2"), i["GR.M1.OF-3"] = l("OF-3"), i["GR.M1.OF-4"] = l("OF-4"), i["GR.M1.OF-5"] = l("OF-5"), i["GR.M1.OF-6"] = l("OF-6"), i["GR.M1.OF-7"] = l("OF-7"), i["GR.M1.OF-8"] = l("OF-8"), i["GR.M1.OF-9"] = l("OF-9"), i["GR.M1.OF-10"] = l("OF-10"), i["GR.M1.OF-D"] = l("OF-D"), i["GR.M1.OPERATIONS"] = l("OPS"), i["GR.M1.OPTICAL"] = l("OPT"), i["GR.M1.OR-1"] = l("OR-1"), i["GR.M1.OR-2"] = l("OR-2"), i["GR.M1.OR-3"] = l("OR-3"), i["GR.M1.OR-4"] = l("OR-4"), i["GR.M1.OR-5"] = l("OR-5"), i["GR.M1.OR-6"] = l("OR-6"), i["GR.M1.OR-7"] = l("OR-7"), i["GR.M1.OR-8"] = l("OR-8"), i["GR.M1.OR-9"] = l("OR-9"), i["GR.M1.OTHER"] = l("OTH"), i["GR.M1.PALLETIZED LOAD SYSTEM"] = l("PLS"), i["GR.M1.PERSONNEL RECOVERY"] = l("H"), i["GR.M1.PLATOON"] = [
            {
                type: "circle",
                stroke: !1,
                cx: 80,
                cy: 68,
                r: 8
            },
            {
                type: "circle",
                stroke: !1,
                cx: 100,
                cy: 68,
                r: 8
            },
            {
                type: "circle",
                stroke: !1,
                cx: 120,
                cy: 68,
                r: 8
            }
        ], i["GR.M1.RADAR"] = {
            type: "path",
            fill: !1,
            d: "m 85,55 c 0.1,21.4 11.7,24.6 25,25 M 116,55 101,67.5 101,55 86.6,66.9"
        }, i["GR.M1.RADIO FREQUENCY IDENTIFICATION (RFID) INTERROGATOR/ SENSOR"] = l("RF"), i["GR.M1.RAILROAD"] = s._translate(0, -50, [
            {
                type: "path",
                d: "M60,120 l80,0",
                fill: !1
            },
            {
                type: "circle",
                fill: !1,
                cx: 65,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 75,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 125,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 135,
                cy: 125,
                r: 5
            }
        ]), i["GR.M1.RADIOLOGICAL"] = l("RAD"), i["GR.M1.RANGER"] = l("RGR"), i["GR.M1.RECON"] = l("R"), i["GR.M1.REGIMENT"] = l("III"), i["GR.M1.RETRANSMISSION SITE"] = l("RTNS"), i["GR.M1.ROBOTIC"] = {
            type: "path",
            d: "m 100,52.7 14.9,14.8 c 0.4,-0.3 0.9,-0.4 1.4,-0.4 1.5,0 2.7,1.2 2.7,2.7 0,1.4 -1.2,2.7 -2.7,2.7 -1.5,0 -2.7,-1.3 -2.7,-2.7 0,-0.4 0.1,-0.7 0.2,-1 l -10.4,-5.2 -2.5,8.6 c 0.2,0.1 0.4,0.2 0.6,0.3 0.7,0.5 1.2,1.3 1.2,2.3 0,1.5 -1.2,2.7 -2.7,2.7 -0.55,0 -1.06,-0.2 -1.49,-0.5 -0.73,-0.4 -1.22,-1.3 -1.22,-2.2 0,-1.2 0.77,-2.2 1.85,-2.6 l -2.53,-8.6 -10.42,5.2 c 0.12,0.3 0.18,0.6 0.18,1 0,1.5 -1.21,2.7 -2.7,2.7 -1.49,0 -2.7,-1.2 -2.7,-2.7 0,-1.5 1.21,-2.7 2.7,-2.7 0.52,0 1.01,0.1 1.42,0.4 l 14.9,-14.8 0,0 0,0 z",
            stroke: !1
        }, i["GR.M1.ASSAULT"] = l("ASLT"), i["GR.M1.WEAPON"] = l("WPN"), i["GR.M1.WEAPONS"] = l("W"), i["GR.M1.CRIMINAL INVESTIGATION DIVISION"] = l("CID"), i["GR.M1.DIGITAL"] = l("DIG"), i["GR.M1.NETWORK OR NETWORK OPERATIONS"] = l("NET"), i["GR.M1.AIRFIELD, AERIAL PORT OF DEBARKATION, OR AERIAL PORT OF EMBARKATION"] = {
            type: "path",
            d: "m 80,70 40,0 M 80,80 111,55",
            fill: !1
        }, i["GR.M1.PIPELINE"] = {
            type: "path",
            d: "m 92,66 -12,0 m 12,8 -12,0 m 28,0 12,0 m -12,-8 12,0 m -20,-11 0,7 m -5,-7 10,0 m -13,7 0,16 16,0 0,-16 -16,0",
            fill: !1
        }, i["GR.M1.POSTAL"] = {
            type: "path",
            d: "m 90,60 15,0 c 0,5 0,10 10,15 -15,0 -20,0 -25,-15",
            fill: !1
        }, i["GR.M1.WATER"] = {
            type: "path",
            d: "m 90,55 20,0 m -10,10 0,-10 m -25,10 40,0 c 10,0 15,5 15,10",
            fill: !1
        }, i["GR.M1.INDEPENDENT COMMAND"] = {
            type: "path",
            d: "m 111.8,59.2 0,15.8 m -7.9,-7.9 15.8,0 m -31.6,-7.9 0,15.8 m 7.9,-7.9 -15.8,0",
            fill: !1
        }, i["GR.M1.MULTI-PURPOSE BLADE"] = {
            type: "path",
            d: "m 80,65 20,-10 20,10 m -20,15 0,-25",
            fill: !1
        }, i["GR.M1.TANK-WIDTH MINE PLOW"] = {
            type: "path",
            d: "m 80,65 5,-2.5 m 5,-2.5 5,-2.5 m 10,0 5,2.5 m 5,2.5 5,2.5 m -20,15 0,-20",
            fill: !1
        }, i["GR.M1.ROUTE, RECONNAISSANCE, AND CLEARANCE"] = l("RRC"), i["GR.M1.SEARCH AND RESCUE"] = l("SAR"), i["GR.M1.SECTION"] = [
            {
                type: "circle",
                stroke: !1,
                cx: 90,
                cy: 68,
                r: 8
            },
            {
                type: "circle",
                stroke: !1,
                cx: 110,
                cy: 68,
                r: 8
            }
        ], i["GR.M1.SECURITY"] = l("SEC"), i["GR.M1.SENSOR"] = {
            type: "path",
            d: "m 100,55 c -2,5 -5,8 -10,10 5,2 8,5 10,10 2,-5 5,-8 10,-10 -5,-2 -8,-5 -10,-10 z"
        }, i["GR.M1.SENSOR CONTROL MODULE"] = l("SCM"), i["GR.M1.SIGNALS INTELLIGENCE"] = {
            type: "path",
            fill: !1,
            d: "m 100,55 0,23 m -15,-18 5,-5 5,5 5,-5 5,5 5,-5 5,5"
        }, i["GR.M1.SIGNAL SUPPORT"] = l("SPT"), i["GR.M1.SINGLE SHELTER SWITCH"] = l("SSS"), i["GR.M1.SINGLE ROCKET LAUNCHER"] = {
            type: "path",
            d: "M85,75 l15,-15 15,15",
            fill: !1
        }, i["GR.M1.SMALL EXTENSION NODE"] = l("SEN"), i["GR.M1.SMOKE"] = l("S"), i["GR.M1.SMOKE/DECON"] = l("SD"), i["GR.M1.SNIPER"] = {
            type: "path",
            d: "M75,60 l20,0 M100,76 l0,-18 M125,60 l-20,0",
            fill: !1
        }, i["GR.M1.SOUND RANGING"] = l("SDR"), i["GR.M1.SPECIAL OPERATIONS FORCES (SOF)"] = l("SOF"), i["GR.M1.SPECIAL WEAPONS AND TACTICS"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 77,
            fontsize: 23,
            text: "SWAT"
        }, i["GR.M1.SQUAD"] = {
            type: "circle",
            stroke: !1,
            cx: 100,
            cy: 68,
            r: 8
        }, i["GR.M1.SUPPORT"] = l("SPT"), i["GR.M1.SURVEY"] = {
            type: "path",
            d: "m 108,78 -8,-8 m 0,0 -8,8 m 8,-8 0,-15 15,8 z"
        }, i["GR.M1.TACTICAL EXPLOITATION"] = l("TE"), i["GR.M1.TARGET ACQUISITION"] = l("TA"), i["GR.M1.TEAM"] = [
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 65,
                r: 10
            },
            {
                type: "path",
                d: "m 90,75 l20,-20"
            }
        ], i["GR.M1.THEATRE"] = l("XXXXX"), i["GR.M1.TOPOGRAPHIC"] = {
            type: "path",
            fill: !1,
            d: "m 92,65 c 6,3 10,3 16,0 m -18,13 10,-23 10,23"
        }, i["GR.M1.TRAINING CAMP"] = l("TNG"), i["GR.M1.HIJACKER"] = l("HJ"), i["GR.M1.UNMANNED AERIAL VEHICLE"] = {
            type: "path",
            stroke: !1,
            d: "m 80,65 20,13 20,-13 0,-5 -20,10 -20,-10 z"
        }, i["GR.M1.UPGRADED EARLY WARNING RADAR"] = l("UEW"), i["GR.M1.UTILITY"] = l("U"), i["GR.M1.VIDEO IMAGERY"] = {
            type: "path",
            fill: !1,
            d: "m 120,65 -11,0 m 11,10 -14,0 m 4,-14 -30,0 0,18 25,0 z m 10,2 0,14"
        }, i["GR.M1.WO-1"] = l("WO-1"), i["GR.M1.WO-2"] = l("WO-2"), i["GR.M1.WO-3"] = l("WO-3"), i["GR.M1.WO-4"] = l("WO-4"), i["GR.M1.WO-5"] = l("WO-5"), i["GR.M1.YARD"] = l("YRD"), i["GR.M2.AIRBORNE"] = {
            type: "path",
            d: "M75,140 C75,125 100,125 100,140 C100,125 125,125 125,140",
            fill: !1
        }, i["GR.M2.ARCTIC"] = {
            type: "path",
            d: "M115,125 C125,125 125,135 115,135 L85,135 C75,135 75,125 85,125",
            fill: !1
        }, i["GR.M2.ATTACK"] = r("A"), i["GR.M2.LANDING CRAFT"] = r("LC"), i["GR.M2.LANDING SHIP"] = r("LS"), i["GR.M2.SERVICE CRAFT/YARD"] = r("YY"), i["GR.M2.TUG HARBOR"] = r("YT"), i["GR.M2.OCEAN GOING TUG BOAT"] = r("AT"), i["GR.M2.SURFACE DEPLOYMENT AND DISTRIBUTION COMMAND"] = r("SDDC"), i["GR.M2.COMPOSITE"] = r("COMP"), i["GR.M2.LIGHT AND MEDIUM"] = r("L/M"), i["GR.M2.BATTLE DAMAGE REPAIR"] = r("BDR"), i["GR.M2.BICYCLE EQUIPPED"] = {
            type: "circle",
            cx: 100,
            cy: 132,
            r: 11,
            fill: !1
        }, i["GR.M2.CASUALTY STAGING"] = r("CS"), i["GR.M2.CLEARING"] = r("CLR"), i["GR.M2.CLOSE RANGE"] = r("CR"), i["GR.M2.COMBAT SEARCH AND RESCUE"] = r("CSAR"), i["GR.M2.CONTROL"] = {
            type: "path",
            d: "m 98,130 2,-4 2,4 m -8,8 -4,-2 4,-2 m 8,8 -2,4 -2,-4 m 8,-8 4,2 -4,2 m -14,-2 16,0 m -8,-8 0,16",
            fill: !1
        }, i["GR.M2.NONCOMBATANT GENERIC VESSEL"] = {
            type: "path",
            d: "m 95,135 0,-10 10,0 0,10 5,0 0,10 -20,0 0,-10 z",
            stroke: !1
        }, i["GR.M2.SHELTER"] = {
            type: "path",
            d: "m 85,140 30,0 -5,-15 -10,-5 -10,5 z",
            stroke: !1
        }, i["GR.M2.SELF-PROPELLED"] = {
            type: "path",
            d: "m 85,125 30,0 c 10,0 10,15 0,15 l -30,0 c -10,0 -10,-15 0,-15",
            fill: !1
        }, i["GR.M2.CROSS-COUNTRY TRUCK"] = [
            {
                type: "path",
                d: "M60,120 l80,0",
                fill: !1
            },
            {
                type: "circle",
                fill: !1,
                cx: 65,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 135,
                cy: 125,
                r: 5
            }
        ], i["GR.M2.CAVALRY"] = {
            type: "text",
            stroke: !1,
            x: 110,
            y: 140,
            fontsize: 25,
            text: "CAV"
        }, i["GR.M2.DECONTAMINATION"] = r("D"), i["GR.M2.DEMOLITION"] = r("DEM"), i["GR.M2.DENTAL"] = {
            type: "text",
            stroke: !1,
            x: 115,
            y: 133,
            fontsize: 25,
            text: "D"
        }, i["GR.M2.DIGITAL"] = r("DIG"), i["GR.M2.ENHANCED POSITION LOCATION REPORTING SYSTEM"] = {
            type: "path",
            d: "m 87,142 13,-12 13,12 m -13,-20 0,20 0,0",
            fill: !1
        }, i["GR.M2.EQUIPMENT"] = r("E"), i["GR.M2.EQUIMENT/TROOP"] = r("E/T"), i["GR.M2.HEAVY"] = r("H"), i["GR.M2.HIGH ALTITUDE"] = r("HA"), i["GR.M2.HIGH TO MEDIUM ALTITUDE"] = r("HMA"), i["GR.M2.HIGH TO LOW ALTITUDE"] = r("HLA"), i["GR.M1.CYBERSPACE"] = l("CYB"), i["GR.M2.AIR ASSAULT"] = {
            type: "path",
            fill: !1,
            d: "m 85,125 15,20 15,-20"
        }, i["GR.M2.VERY HEAVY"] = r("VH"), i["GR.M2.CYBERSPACE"] = r("CYB"), i["GR.M2.NAVY BARGE, SELF-PROPELLED"] = r("YS"), i["GR.M2.NAVY BARGE, NOT SELF-PROPELLED"] = r("YB"), i["GR.M2.LAUNCH"] = r("YFT"), i["GR.M1.TACTICAL SATELLITE COMMUNICATIONS"] = [
            {
                type: "path",
                d: "m 105,65 10,0 m -30,0 10,0 M 85,77 c 10,-7 20,-7 30,0",
                fill: !1
            },
            {
                type: "path",
                d: "m 75.4,60.9 0,9.1 13.1,0 0,-9.1 z m 36,0 0,9.1 13.1,0 0,-9.1 z m -18,0 0,9.1 13.1,0 0,-9.1 z",
                stroke: !1
            }
        ], i["GR.M2.INTERMODAL"] = {
            type: "path",
            d: "m 80,125 40,0 0,-4 8,9 -8,9 0,-4 -40,0 0,4 -8,-9 8,-9 z",
            fill: !1
        }, i["GR.M2.INTENSIVE CARE"] = r("IC"), i["GR.M2.J1"] = r("J1"), i["GR.M2.J2"] = r("J2"), i["GR.M2.J3"] = r("J3"), i["GR.M2.J4"] = r("J4"), i["GR.M2.J5"] = r("J5"), i["GR.M2.J6"] = r("J6"), i["GR.M2.J7"] = r("J7"), i["GR.M2.J8"] = r("J8"), i["GR.M2.J9"] = r("J9"), i["GR.M2.LIGHT"] = r("L"), i["GR.M2.LABORATORY"] = r("LAB"), i["GR.M2.LAUNCHER"] = {
            type: "path",
            fill: !1,
            d: "M80,140 L115,120 120,140"
        }, i["GR.M2.LONG RANGE"] = r("LR"), i["GR.M2.LONG RANGE SURVEILLANCE"] = {
            type: "text",
            stroke: !1,
            x: 110,
            y: 140,
            fontsize: 25,
            text: "LRS"
        }, i["GR.M2.LOW ALTITUDE"] = r("LA"), i["GR.M2.MEDIUM"] = r("M"), i["GR.M2.MEDIUM ALTITUDE"] = r("MA"), i["GR.M2.MEDIUM TO LOW ALTITUDE"] = r("MLA"), i["GR.M2.MEDIUM RANGE"] = r("MR"), i["GR.M2.MOUNTAIN"] = {
            type: "path",
            stroke: !1,
            d: "M90,140 L100,120 110,140"
        }, i["GR.M2.MULTIPLE ALTITUDES"] = r("H/MA"), i["GR.M2.MULTI-CHANNEL"] = r("MC"), i["GR.M2.OF-1"] = r("OF-1"), i["GR.M2.OF-2"] = r("OF-2"), i["GR.M2.OF-3"] = r("OF-3"), i["GR.M2.OF-4"] = r("OF-4"), i["GR.M2.OF-5"] = r("OF-5"), i["GR.M2.OF-6"] = r("OF-6"), i["GR.M2.OF-7"] = r("OF-7"), i["GR.M2.OF-8"] = r("OF-8"), i["GR.M2.OF-9"] = r("OF-9"), i["GR.M2.OF-10"] = r("OF-10"), i["GR.M2.OF-D"] = r("OF-D"), i["GR.M2.OPTICAL"] = r("OPT"), i["GR.M2.OR-1"] = r("OR-1"), i["GR.M2.OR-2"] = r("OR-2"), i["GR.M2.OR-3"] = r("OR-3"), i["GR.M2.OR-4"] = r("OR-4"), i["GR.M2.OR-5"] = r("OR-5"), i["GR.M2.OR-6"] = r("OR-6"), i["GR.M2.OR-7"] = r("OR-7"), i["GR.M2.OR-8"] = r("OR-8"), i["GR.M2.OR-9"] = r("OR-9"), i["GR.M2.GUERILLA"] = r("G"), i["GR.M2.AMPHIBIOUS"] = ({
            Unknown: {
                type: "path",
                d: "M 64 144.9 C 80.4 143.9 63.1 125 81.4 125 C 100.2 125 81.4 145 100.2 145 C 119 145 100.2 125 119 125 C 137.1 125 120.2 143.6 135.9 144.9",
                fill: !1
            },
            Friend: {
                type: "path",
                d: "m 25,145 c 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 18.8,20 18.8,0 0,-20 18.8,-20 18.8,0 0,20 20,20",
                fill: !1
            },
            Neutral: {
                type: "path",
                d: "M 45 125 C 61.7 125.9 44.2 145 62.6 145 C 81.4 145 62.6 125 81.4 125 C 100.2 125 81.4 145 100.2 145 C 119 145 100.2 125 119 125 C 137.8 125 119 145 137.8 145 C 155.9 145 138.9 126.2 154.8 125 ",
                fill: !1
            },
            Hostile: {
                type: "path",
                d: "M 70.4 142.4 C 74.8 137 66.8 125 81.4 125 C 100.2 125 81.4 145 100.2 145 C 119 145 100.2 125 119 125 C 133.3 125 125.7 136.6 129.7 142.1 ",
                fill: !1
            }
        })[T], i["GR.M2.PACK ANIMAL"] = {
            type: "path",
            d: "m 84,140 9,-15 7,15 7,-15 9,15",
            fill: !1
        }, i["GR.M2.PATIENT EVACUATION COORDINATION"] = r("PEC"), i["GR.M2.PREVENTIVE MAINTENANCE"] = r("PM"), i["GR.M2.PSYCHOLOGICAL"] = {
            type: "text",
            stroke: !1,
            x: 115,
            y: 133,
            fontsize: 25,
            text: "P"
        }, i["GR.M2.RADIO RELAY LINE OF SIGHT"] = [
            {
                type: "circle",
                cx: 100,
                cy: 132,
                r: 11,
                fill: !1
            },
            {
                type: "path",
                d: "M 90.8 128.2 C 90.3 129.3 90 130.6 90 132 C 90 133.4 90.3 134.7 90.8 135.8 L 100 132 L 90.8 128.2 z M 100 132 L 109.3 135.8 C 109.7 134.7 110 133.4 110 132 C 110 130.6 109.7 129.3 109.3 128.2 L 100 132 z"
            }
        ], i["GR.M2.RAILROAD"] = [
            {
                type: "path",
                d: "M60,120 l80,0",
                fill: !1
            },
            {
                type: "circle",
                fill: !1,
                cx: 65,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 75,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 125,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 135,
                cy: 125,
                r: 5
            }
        ], i["GR.M2.TRACTOR TRAILER"] = [
            {
                type: "path",
                d: "M60,120 l80,0",
                fill: !1
            },
            {
                type: "circle",
                fill: !1,
                cx: 65,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 75,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 135,
                cy: 125,
                r: 5
            }
        ], i["GR.M2.RECOVERY (UNMANNED SYSTEMS)"] = {
            type: "path",
            d: "m 70,125 c0,20 60,20 60,0",
            fill: !1
        }, i["GR.M2.RECOVERY (MAINTENANCE)"] = {
            type: "path",
            fill: !1,
            d: "M75,125 c8,0 8,16 0,16 m8,-8 l35,0 m8,-8 c-8,0 -8,16 0,16"
        }, i["GR.M2.REFUEL"] = r("K"), i["GR.M2.RESCUE COORDINATION CENTRE"] = r("RCC"), i["GR.M2.RIVERINE"] = {
            type: "path",
            d: "m 80,125 c 0,10 40,10 40,0 z",
            fill: !1
        }, i["GR.M2.ROBOTIC"] = {
            type: "path",
            d: "M100,121.68L114.895,136.459C115.309,136.201 115.798,136.052 116.321,136.052C117.812,136.052 119.022,137.262 119.022,138.753C119.022,140.243 117.812,141.454 116.321,141.454C114.831,141.454 113.62,140.243 113.62,138.753C113.62,138.407 113.686,138.076 113.805,137.772L103.378,132.6L100.851,141.224C101.072,141.298 101.28,141.4 101.471,141.526C102.211,142.008 102.701,142.843 102.701,143.791C102.701,145.281 101.491,146.492 100,146.492C99.451,146.492 98.939,146.327 98.512,146.045C97.776,145.562 97.29,144.73 97.29,143.785C97.29,142.592 98.064,141.579 99.138,141.222L96.613,132.606L86.186,137.778C86.305,138.082 86.37,138.413 86.37,138.759C86.37,140.25 85.16,141.46 83.669,141.46C82.179,141.46 80.969,140.25 80.969,138.759C80.969,137.268 82.179,136.058 83.669,136.058C84.193,136.058 84.681,136.207 85.095,136.465L99.991,121.671L100,121.662L100,121.68Z",
            stroke: !1
        }, i["GR.M2.SECURITY FORCE ASSISTANCE"] = r("SFA"), i["GR.M2.SINGLE CHANNEL"] = r("SC"), i["GR.M2.SKI"] = {
            type: "path",
            d: "m 95,145 -9,-8 m 28,0 -9,8 m -15,-24 20,20 m 0,-20 -20,20",
            fill: !1
        }, i["GR.M2.SHORT RANGE"] = r("SR"), i["GR.M2.STRATEGIC"] = r("STR"), i["GR.M2.STRATEGIC MISSILE"] = r("S"), i["GR.M2.SUPPORT"] = r("SPT"), i["GR.M2.TACTICAL"] = r("TAC"), i["GR.M2.TACTICAL MISSILE"] = r("T"), i["GR.M2.TARGET ACQUISITION"] = r("TA"), i["GR.M2.TOWED"] = [
            {
                type: "path",
                d: "M70,120 l60,0",
                fill: !1
            },
            {
                type: "circle",
                fill: !1,
                cx: 65,
                cy: 120,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 135,
                cy: 120,
                r: 5
            }
        ], i["GR.M2.TROOP"] = r("T"), i["GR.M2.TRACKED"] = {
            type: "path",
            d: "M 70,120 l 60,0 c10,0 10,10 0,10 l -60,0 c-10,0 -10,-10 0,-10",
            fill: !1
        }, i["GR.M2.TRUCK"] = [
            {
                type: "path",
                d: "M60,120 l80,0",
                fill: !1
            },
            {
                type: "circle",
                fill: !1,
                cx: 65,
                cy: 125,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 135,
                cy: 125,
                r: 5
            }
        ], i["GR.M2.UTILITY"] = r("U"), i["GR.M2.VERTICAL OR SHORT TAKE-OFF AND LANDING "] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 135,
            fontsize: 20,
            text: "VSTOL"
        }, i["GR.M2.VETERINARY"] = {
            type: "text",
            stroke: !1,
            x: 115,
            y: 133,
            fontsize: 25,
            text: "V"
        }, i["GR.M2.WHEELED"] = [
            {
                type: "circle",
                cx: 70,
                cy: 125,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 125,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 130,
                cy: 125,
                r: 5,
                fill: !1
            }
        ], i["GR.M2.WHEELED LIMITED"] = [
            {
                type: "circle",
                cx: 70,
                cy: 125,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 130,
                cy: 125,
                r: 5,
                fill: !1
            }
        ], i["GR.M2.WO-1"] = r("WO-1"), i["GR.M2.WO-2"] = r("WO-2"), i["GR.M2.WO-3"] = r("WO-3"), i["GR.M2.WO-4"] = r("WO-4"), i["GR.M2.WO-5"] = r("WO-5"), i["GR.EQ.SHORT RANGE"] = {
            type: "path",
            d: "m 85,100 30,0",
            fill: !1
        }, i["GR.EQ.INTERMEDIATE RANGE"] = {
            type: "path",
            d: "m 85,105 30,0 m -30,-10 30,0",
            fill: !1
        }, i["GR.EQ.LONG RANGE"] = {
            type: "path",
            d: "m 85,110 30,0 m -30,-20 30,0 m -30,10 30,0",
            fill: !1
        }, i["GR.EQ.WEAPON"] = {
            type: "path",
            d: "m 100,60 0,80",
            fill: !1
        }, i["GR.EQ.RIFLE"] = {
            type: "path",
            d: "m 100,60 0,80 M 85,75 100,60 115,75",
            fill: !1
        }, i["GR.EQ.RIFLE DISMOUNTED1"] = {
            type: "path",
            d: "m 90,90 10,-10 10,10 m -10,-10 0,40",
            fill: !1
        }, i["GR.EQ.MACHINE GUN"] = {
            type: "path",
            d: "m 100,60 0,80 M 85,75 100,60 115,75 M 80,140 120,140",
            fill: !1
        }, i["GR.EQ.GRENADE LAUNCHER"] = [
            i["GR.EQ.RIFLE"],
            {
                type: "circle",
                cx: 100,
                cy: 90,
                r: 15,
                fill: !1
            }
        ], i["GR.EQ.FLAME THROWER"] = {
            type: "path",
            fill: !1,
            d: "m 90,135 0,-70 c 0,-15 20,-15 20,0"
        }, i["GR.EQ.AIR DEFENCE GUN"] = [
            {
                type: "path",
                d: "m 85,140 30,0 c 0,-20 -30,-20 -30,0 z m 15,-80 0,65 m 15,-45 0,40 m -30,-40 0,40",
                fill: !1
            }
        ], R || N || i["GR.EQ.AIR DEFENCE GUN"].push({
            type: "path",
            d: "M 85,75 100,60 115,75",
            fill: !1
        }), i["GR.EQ.ANTITANK GUN"] = {
            type: "path",
            d: "m 85,140 15,-15 15,15 m -15,-80 0,65 m -15,-45 0,40 m 30,-40 0,40",
            fill: !1
        }, i["GR.EQ.DIRECT FIRE GUN"] = {
            type: "path",
            d: "m 100,60 0,80 m 15,-60 0,40 m -30,-40 0,40",
            fill: !1
        }, i["GR.EQ.RECOILLESS GUN"] = {
            type: "path",
            d: "m 85,75 15,-15 15,15 m 0,5 0,40 m -30,-40 0,40 m 15,-60 0,80",
            fill: !1
        }, i["GR.EQ.HOWITZER"] = [
            {
                type: "circle",
                cx: 100,
                cy: 130,
                r: 10,
                fill: !1
            },
            {
                type: "path",
                d: "m 115,80 0,40 m -30,-40 0,40 m 15,-60 0,60",
                fill: !1
            }
        ], R || i["GR.EQ.HOWITZER"].push({
            type: "path",
            d: "M 85,75 100,60 115,75",
            fill: !1
        }), i["GR.EQ.HOWITZER TRACKED"] = {
            type: "path",
            d: "M 70,120 l 60,0 c10,0 10,10 0,10 l -60,0 c-10,0 -10,-10 0,-10",
            fill: !1
        }, i["GR.EQ.MISSILE LAUNCHER"] = {
            type: "path",
            d: "m 100,140 0,-80 m -15,80 0,-65 c 0,-20 30,-20 30,0 l 0,65",
            fill: !1
        }, i["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"] = {
            type: "path",
            d: "m 85,140 30,0 c 0,-20 -30,-20 -30,0 z m 15,-15 0,-65 m -15,80 0,-65 c 0,-20 30,-20 30,0 l 0,65",
            fill: !1
        }, i["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "R"
        }, i["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"] = [
            {
                type: "text",
                stroke: !1,
                x: 68,
                y: 110,
                fontsize: 25,
                text: "E"
            },
            {
                type: "text",
                stroke: !1,
                x: 132,
                y: 110,
                fontsize: 25,
                text: "R"
            }
        ], i["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR THEATRE"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 145,
            fontsize: 30,
            text: "T"
        }, i["GR.EQ.ANTITANK MISSILE LAUNCHER"] = {
            type: "path",
            d: "m 85,140 15,-15 15,15 M 85,120 85,75 c 0,-20 30,-20 30,0 l 0,45 m -15,5 0,-65",
            fill: !1
        }, i["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"] = [
            i["GR.EQ.MISSILE LAUNCHER"]
        ], R && i["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"].push({
            type: "path",
            d: "m 85,140 30,0",
            fill: !1
        }), i["GR.EQ.MORTAR"] = [
            {
                type: "path",
                d: "m 100,60 0,60 M 85,75 100,60 115,75",
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 130,
                r: 10,
                fill: !1
            }
        ], i["GR.EQ.SINGLE ROCKET LAUNCHER"] = {
            type: "path",
            d: "m 85,75 15,-15 15,15 m -15,-5 0,70 M 85,85 100,70 115,85",
            fill: !1
        }, i["GR.EQ.MULTIPLE ROCKET LAUNCHER"] = {
            type: "path",
            d: "m 115,90 0,40 m -30,-40 0,40 m 0,-55 15,-15 15,15 m -15,-5 0,70 M 85,85 100,70 115,85",
            fill: !1
        }, i["GR.EQ.ANTITANK ROCKET LAUNCHER"] = {
            type: "path",
            d: "m 85,140 15,-15 15,15 M 85,85 100,70 115,85 m -15,-15 0,55 M 85,75 100,60 115,75",
            fill: !1
        }, i["GR.EQ.NON-LETHAL WEAPON"] = {
            type: "path",
            d: "m 100,60 0,80 M 80,60 l40,0",
            fill: !1
        }, i["GR.EQ.NON-LETHAL GRENADE LAUNCHER"] = [
            i["GR.EQ.NON-LETHAL WEAPON"],
            {
                type: "circle",
                cx: 100,
                cy: 90,
                r: 15,
                fill: !1
            }
        ], i["GR.EQ.TASER"] = [
            i["GR.EQ.NON-LETHAL WEAPON"],
            a("Z")
        ], i["GR.EQ.WATER CANNON"] = [
            i["GR.EQ.NON-LETHAL WEAPON"],
            a("W")
        ], i["GR.EQ.LIMITED CROSS-COUNTRY"] = [
            {
                type: "path",
                d: "m 70,130 60,0",
                fill: !1
            },
            {
                type: "circle",
                cx: 75,
                cy: 135,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 125,
                cy: 135,
                r: 5,
                fill: !1
            }
        ], i["GR.EQ.CROSS-COUNTRY"] = [
            {
                type: "path",
                d: "m 70,130 60,0",
                fill: !1
            },
            {
                type: "circle",
                cx: 75,
                cy: 135,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 135,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 125,
                cy: 135,
                r: 5,
                fill: !1
            }
        ], i["GR.EQ.ARMOURED FIGHTING VEHICLE"] = {
            type: "path",
            d: "m 70,100 30,-30 30,30 -30,30 z m 60,-30 0,60 m -60,-60 0,60 0,0",
            fill: !1
        }, i["GR.EQ.ARMOURED FIGHTING VEHICLE (AFV) COMMAND AND CONTROL"] = [
            i["GR.EQ.ARMOURED FIGHTING VEHICLE"]
        ], N ? i["GR.EQ.ARMOURED FIGHTING VEHICLE (AFV) COMMAND AND CONTROL"].push({
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "C2"
        }) : i["GR.EQ.ARMOURED FIGHTING VEHICLE (AFV) COMMAND AND CONTROL"].push({
            type: "path",
            d: "m 80,90 20,15 0,-10 20,15",
            fill: !1
        }), i["GR.EQ.ARMOURED PERSONNEL CARRIER"] = {
            type: "path",
            fill: !1,
            d: "m 70,80 30,-10 30,10 m -60,-10 0,60 60,0 0,-60"
        }, i["GR.EQ.ARMOURED PERSONNEL CARRIER COMBAT SERVICE SUPPORT VEHICLE"] = [
            i["GR.EQ.ARMOURED PERSONNEL CARRIER"],
            {
                type: "path",
                d: "m 70,120 60,0",
                fill: !1
            }
        ], i["GR.EQ.ARMOURED PERSONNEL CARRIER ENGINEER RECON VEHICLE"] = {
            type: "path",
            fill: !1,
            d: "M 130,80 70,130"
        }, i["GR.EQ.COMBAT SERVICE SUPPORT VEHICLE"] = {
            type: "path",
            fill: !1,
            d: "M 70,120 130,120"
        }, i["GR.EQ.ARMOURED MEDICAL PERSONNEL CARRIER"] = {
            type: "path",
            fill: !1,
            d: "m 70,100 60,0 m -30,-30 0,60"
        }, i["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"] = [
            {
                type: "path",
                d: "m 60,120 80,0 M 120,80 c 25,0.2 25,40 0,40 l -40,0 C 55,120 55,80 80,80 Z",
                fill: !1
            },
            i["GR.M2.WHEELED LIMITED"]
        ], i["GR.EQ.ARMOURED VEHICLE"] = a("A"), i["GR.EQ.ARMORED CARRIER WITH VOLCANO"] = a("V"), i["GR.EQ.TANK"] = {
            type: "path",
            fill: !1,
            d: "m 70,80 60,0 m -60,40 60,0 m -60,-50 0,60 0,0 m 60,-60 0,60"
        }, i["GR.EQ.ASSAULT BREACHER VEHICLE (ABV) WITH COMBAT DOZER BLADE"] = {
            type: "path",
            fill: !1,
            d: "m 100,95 30,25 m -30,-60 0,35 -30,25 m 10,-60 40,0 m -50,20 60,0 m -60,40 60,0 m -60,-50 0,60 0,0 m 60,-60 0,60"
        }, i["GR.EQ.LIGHT TANK"] = {
            type: "path",
            fill: !1,
            d: "m 100,80 0,40"
        }, i["GR.EQ.MEDIUM TANK"] = {
            type: "path",
            fill: !1,
            d: "m 105,80 0,40 m -10,-40 0,40"
        }, i["GR.EQ.HEAVY TANK"] = {
            type: "path",
            fill: !1,
            d: "m 110,80 0,40 m -20,-40 0,40 m 10,-40 0,40"
        }, i["GR.EQ.TANK RECOVERY VEHICLE"] = {
            type: "path",
            fill: !1,
            d: "m 85,100 30,0 m 10,-10 c -13.1,0 -12.4,20 0,20 M 75,90 c 12.7,0.3 12.7,20.3 0,20"
        }, i["GR.EQ.BRIDGE"] = {
            type: "path",
            d: "m 115,75 -10,10 0,30 10,10 m -30,-50 10,10 0,30 -10,10 m -15,-55 60,0 0,60 -60,0 0,-60",
            fill: !1
        }, i["GR.EQ.FIXED BRIDGE"] = {
            type: "path",
            d: "M 100,70 100,130",
            fill: !1
        }, i["GR.EQ.FOLDING GIRDER BRIDGE"] = {
            type: "path",
            d: "M 110, 80 90,80 90,120 110,120",
            fill: !1
        }, i["GR.EQ.HOLLOW DECK BRIDGE"] = {
            type: "path",
            d: "M 110, 80 90,80 90,120 110,120 z",
            fill: !1
        }, i["GR.EQ.DRILL"] = i["GR.IC.DRILLING"], i["GR.EQ.DOZER"] = {
            type: "path",
            d: "m 90,60 20,0 m -10,0 0,20 m -30,0 60,0 m -60,-10 0,60 0,0 m 60,-60 0,60 m -60,-10 60,0",
            fill: !1
        }, i["GR.EQ.DOZER ARMORED"] = {
            type: "path",
            d: "m 70,130 60,0 m -30,-70 0,10 m -30,10 30,-10 30,10 m 0,-10 0,60 m -60,-60 0,60 0,0 m 20,-70 20,0",
            fill: !1
        }, i["GR.EQ.EARTHMOVER"] = {
            type: "path",
            d: "m 100,60 0,20 m -25,-15 5,-5 40,0 5,5 m -55,15 60,0 m -60,40 60,0 m 0,-50 0,60 m -60,-60 0,60 0,0",
            fill: !1
        }, i["GR.EQ.MULTIFUNCTIONAL EARTHMOVER/DIGGER"] = [
            i["GR.EQ.EARTHMOVER"],
            a("MF")
        ], i["GR.EQ.MINE CLEARING EQUIPMENT"] = {
            type: "path",
            d: "m 100,80 0,15 -30,25 60,0 -30,-25",
            fill: !1
        }, i["GR.EQ.MINE LAYING VEHICLE"] = [
            {
                type: "path",
                d: "m 90,85 20,30 m 0,-30 -20,30 m 10,-30 0,30",
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 10
            }
        ], i["GR.EQ.MINE SCATTERABLE"] = [
            a("S"),
            {
                type: "circle",
                cx: 85,
                cy: 115,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 115,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 115,
                cy: 115,
                r: 5,
                fill: !1
            }
        ], i["GR.EQ.UTILITY VEHICLE"] = {
            type: "path",
            fill: !1,
            d: "m 70,65 c 0,15 60,15 60,0 l 0,65 -60,0 z"
        }, i["GR.EQ.UTILITY VEHICLE BACKHOE"] = [
            {
                type: "path",
                fill: !1,
                d: "M 130,130 100,80 75,95 75,95"
            },
            {
                type: "path",
                d: "M 75,105 85,95 75,95 z"
            }
        ], i["GR.EQ.UTILITY VEHICLE FERRY TRANSPORTER"] = {
            type: "path",
            fill: !1,
            d: "m 75,100 c 15,15 35,15 50,0 z"
        }, i["GR.EQ.UTILITY VEHICLE LIGHT"] = {
            type: "path",
            fill: !1,
            d: "M 100,78.3 100,130"
        }, i["GR.EQ.UTILITY VEHICLE MEDIUM"] = {
            type: "path",
            fill: !1,
            d: "m 105,130 0,-52 M 95,130 l0,-52"
        }, i["GR.EQ.UTILITY VEHICLE HEAVY"] = {
            type: "path",
            fill: !1,
            d: "m 110,130 0,-53 m -20,50 0,-53 m 10,1.3 0,52"
        }, i["GR.EQ.UTILITY VEHICLE.TOW TRUCK"] = {
            type: "path",
            fill: !1,
            d: "m 130,130 -40,-40 0,25 c 0,5 -10,5 -10,0"
        }, i["GR.EQ.UTILITY VEHICLE.TOW TRUCK.LIGHT"] = {
            type: "path",
            fill: !1,
            d: "m 105,115 10,-10"
        }, i["GR.EQ.UTILITY VEHICLE.TOW TRUCK.HEAVY"] = {
            type: "path",
            fill: !1,
            d: "m 120,110 -10,10 m -10,-10 10,-10 m -5,15 10,-10"
        }, i["GR.EQ.MEDICAL VEHICLE"] = {
            type: "path",
            fill: !1,
            d: "m 70,100 l 60,0 M 100,78.3 100,130"
        }, i["GR.EQ.MEDICAL EVACUATION"] = {
            type: "path",
            d: "m 95,85 10,0 0,10 10,0 0,10 -10,0 0,10 -10,0 0,-10 -10,0 0,-10 10,0 z"
        }, i["GR.EQ.MOBILE EMERGENCY PHYSICIAN"] = {
            type: "path",
            fill: !1,
            d: "m 70,100 l 60,0 M 100,78.3 100,130 M 85,85 115,85"
        }, i["GR.EQ.BUS"] = [
            i["GR.EQ.UTILITY VEHICLE"],
            a("B")
        ], i["GR.EQ.SEMI-TRAILER TRUCK"] = [
            i["GR.EQ.UTILITY VEHICLE"],
            {
                type: "path",
                fill: !1,
                d: "m 140,90 0,20 m -10,-10 10,0"
            },
            {
                type: "circle",
                cx: 75,
                cy: 135,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 85,
                cy: 135,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 125,
                cy: 135,
                r: 5,
                fill: !1
            }
        ], i["GR.EQ.WATER VEHICLE"] = [
            i["GR.EQ.UTILITY VEHICLE"],
            {
                type: "path",
                fill: !1,
                d: "m 70,95 c 10,0 0,10 10,10 10,0 0,-10 10,-10 10,0 0,10 10,10 10,0 0,-10 10,-10 10,0 0,10 10,10 10,0 0,-10 10,-10"
            },
            {
                type: "circle",
                cx: 75,
                cy: 135,
                r: 5,
                fill: !1
            },
            {
                type: "circle",
                cx: 125,
                cy: 135,
                r: 5,
                fill: !1
            }
        ], i["GR.EQ.TRAIN LOCOMOTIVE"] = {
            type: "path",
            fill: !1,
            d: "m 70,70 0,60 60,0 0,-30 -30,0 0,-30 z"
        }, i["GR.EQ.RAILCAR"] = [
            i["GR.EQ.UTILITY VEHICLE"],
            {
                type: "circle",
                fill: !1,
                cx: 75,
                cy: 135,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 85,
                cy: 135,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 115,
                cy: 135,
                r: 5
            },
            {
                type: "circle",
                fill: !1,
                cx: 125,
                cy: 135,
                r: 5
            }
        ], i["GR.EQ.CBRN EQUIPMENT"] = [
            {
                type: "path",
                d: "M80,140 c0,-20 10,-60 50,-63 m-10,63 c0,-20 -10,-60 -50,-63 ",
                fill: !1
            },
            {
                type: "circle",
                cx: 70,
                cy: 85,
                r: 8
            },
            {
                type: "circle",
                cx: 130,
                cy: 85,
                r: 8
            }
        ], i["GR.EQ.COMPUTER SYSTEM"] = {
            type: "path",
            d: "m 100,132 0,-10 -35,0 0,-50 70,0 0,50 -35,0 m -25,10 50,0",
            fill: !1
        }, i["GR.EQ.COMMAND LAUNCH EQUIPMENT (CLE)"] = a("CLE"), i["GR.EQ.GENERATOR SET"] = a("G"), i["GR.EQ.GROUND-BASED MIDCOURSE DEFENSE (GMD) FIRE CONTROL (GFC) CENTER"] = a("GFC"), i["GR.EQ.IN-FLIGHT INTERCEPTOR COMMUNICATIONS SYSTEM (IFICS) DATA TERMINAL (IDT)"] = {
            type: "path",
            fill: !1,
            d: "m 80,82.4 45,-2 -4,37 m -6,-1 0,-35 -34,9 m 12,21 0,8 M 80,82.4 c 0,25 16,35 41,35"
        }, i["GR.EQ.LASER"] = {
            type: "path",
            fill: !1,
            d: "m 100,55 0,25 10,5 -20,5 20,5 -20,5 10,5 0,15 10,5 -20,5 20,5 -20,5 20,5 M 90,65 100,55 110,65"
        }, i["GR.EQ.TENT"] = {
            type: "path",
            fill: !1,
            d: "m 65,124.4 10,-37 25,-10 25,10 10,37 z"
        }, i["GR.EQ.TENT CIVILIAN"] = {
            type: "path",
            fill: !1,
            d: "m 75,120 10,-30 15,-10 15,10 10,30 z"
        }, i["GR.EQ.TENT MILITARY"] = {
            type: "path",
            d: "m 75,120 10,-30 15,-10 15,10 10,30 z"
        }, i["GR.EQ.UNIT DEPLOYMENT SHIPMENTS"] = a("DPLY"), i["GR.EQ.CIVILIAN VEHICLE.LIGHT"] = {
            type: "path",
            fill: !1,
            d: "m 100,125 0,-20"
        }, i["GR.EQ.CIVILIAN VEHICLE.MEDIUM"] = {
            type: "path",
            fill: !1,
            d: "m 103,105 0,20 m -6,-20 0,20"
        }, i["GR.EQ.CIVILIAN VEHICLE.HEAVY"] = {
            type: "path",
            fill: !1,
            d: "m 106,105 0,20 m -12,-20 0,20 m 6,-20 0,20"
        }, i["GR.EQ.CIVILIAN VEHICLE.TRAILER"] = {
            type: "path",
            fill: !1,
            d: "m 140,105 0,20 m -10,-10 10,0"
        }, i["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"] = [
            {
                type: "path",
                fill: !!R && G,
                d: "m 90,125 20,0 m -20,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 35,0 5,0 0,-20 -20,0 0,-20 -20,0 0,20 -20,0 0,20 5,0 m 50,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z"
            },
            {
                type: "path",
                fill: !1,
                strokewidth: 2,
                d: "m 95,90 0,15 10,0 0,-15 z"
            }
        ], i["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"] = [
            {
                type: "path",
                fill: !!R && G,
                d: "m 90,125 20,0 m -20,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 35,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 0,0 5,0 0,-20 -20,0 -20,0 0,-20 -20,0 0,20 0,20 5,0"
            },
            {
                type: "path",
                fill: !1,
                strokewidth: 2,
                d: "m 75,90 0,15 10,0 0,-15 z"
            }
        ], i["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"] = [
            {
                type: "path",
                fill: !!R && G,
                d: "m 90,125 20,0 m -20,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 35,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 0,0 5,0 0,-20 0,-20 -20,0 -20,0 -20,0 0,20 0,20 5,0"
            },
            {
                type: "path",
                fill: !1,
                strokewidth: 2,
                d: "m 115,90 0,15 10,0 0,-15 z m -20,0 0,15 10,0 0,-15 z m -20,0 0,15 10,0 0,-15 z"
            }
        ], i["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"] = [
            {
                type: "path",
                fill: !!R && G,
                d: "m 90,125 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 35,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m -35,0 20,0 m 15,0 5,0 0,-20 0,-20 -20,0 -20,0 0,20 -20,0 0,20 5,0"
            },
            {
                type: "path",
                fill: !1,
                strokewidth: 2,
                d: "m 95,90 0,15 10,0 0,-15 z"
            }
        ], i["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"] = {
            type: "path",
            fill: !!R && G,
            d: "m 90,125 20,0 m -20,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 35,0 c 0,-4.1 -3.4,-7.5 -7.5,-7.5 -4.1,0 -7.5,3.4 -7.5,7.5 0,4.1 3.4,7.5 7.5,7.5 4.1,0 7.5,-3.4 7.5,-7.5 z m 0,0 5,0 0,-20 -60,0 0,20 5,0 m 15,-20 5,-15"
        }, i["GR.EQ.PACK ANIMAL"] = {
            type: "path",
            fill: !1,
            d: "m 70,125 15,-50 15,50 15,-50 15,50 "
        }, i["GR.EQ.MISSILE SUPPORT"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 100,
                fontsize: 20,
                text: "MSL"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 20,
                text: "SPT"
            }
        ], i["GR.EQ.MISSILE TRANSLOADER"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 110,
                fontsize: 30,
                text: "MSL"
            },
            {
                type: "path",
                fill: !1,
                d: "m 75,70 50,0 m -25,10 c 0,-5 0,-10 0,-10"
            }
        ], i["GR.EQ.MISSILE TRANSPORTER"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 110,
                fontsize: 30,
                text: "MSL"
            },
            {
                type: "path",
                fill: !1,
                d: "m 55,85 90,0"
            }
        ], i["GR.EQ.MISSILE CRANE/LOADING DEVICE"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 110,
                fontsize: 30,
                text: "MSL"
            },
            {
                type: "path",
                fill: !1,
                d: "m 75,80 25,-20 c 0,0 0,15 0,15 l 5,0 0,-5"
            }
        ], i["GR.EQ.MISSILE PROPELLANT TRANSPORTER"] = [
            {
                type: "text",
                stroke: !1,
                x: 90,
                y: 110,
                fontsize: 20,
                text: "MSL"
            },
            {
                type: "path",
                fill: !1,
                d: "m 120,115 0,-15 -10,-10 20,0 -10,10"
            }
        ], i["GR.EQ.MISSILE WARHEAD TRANSPORTER"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 100,
                fontsize: 20,
                text: "MSL"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 20,
                text: "WHD"
            }
        ], i["GR.EQ.LAND MINE"] = N ? {
            type: "circle",
            cx: 100,
            cy: 100,
            r: 22,
            fill: !1
        } : [
            {
                type: "path",
                fill: !1,
                d: "m 70,65 60,0 -30,65 z"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 90,
                fontfamily: "Arial",
                fontsize: 30,
                text: "M"
            }
        ], i["GR.EQ.ANTIPERSONNEL LAND MINE"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 22
            },
            {
                type: "path",
                d: "M117,82 l20,-18 -18,25z M83,82 l-20,-18 18,25z",
                stroke: !1
            }
        ], i["GR.EQ.ANTIPERSONNEL LAND MINE LESS THAN LETHAL"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 22,
                fill: !1
            },
            {
                type: "path",
                d: "M117,82 l20,-18 -18,25z M83,82 l-20,-18 18,25z",
                stroke: !1
            }
        ], i["GR.EQ.ANTITANK MINE"] = {
            type: "circle",
            cx: 100,
            cy: 100,
            r: 22
        }, i["GR.EQ.IMPROVISED EXPLOSIVE DEVICE"] = a("IED"), i["GR.EQ.LAND MINES"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 110,
                fontsize: 30,
                text: "M"
            },
            {
                type: "path",
                fill: !1,
                d: R ? "m 135,70 -70,0 35,70 z" : "m 65,130 70,0 -35,-70 z"
            }
        ], i["GR.EQ.SENSOR"] = {
            type: "path",
            d: "m 100,60 c 0,15 25,40 40,40 -15,0 -40,25 -40,40 0,-15 -25,-40 -40,-40 15,0 40,-25 40,-40 z"
        }, i["GR.EQ.SENSOR EMPLACED"] = [
            s._scale(.75, i["GR.EQ.SENSOR"]),
            {
                type: "path",
                fill: !1,
                d: "m 70,75 10,-15 10,15 10,-15 10,15 10,-15 10,15"
            }
        ], i["GR.EQ.RADAR"] = {
            type: "path",
            d: "M72,95 l30,-25 0,25 30,-25 M70,70 c0,35 15,50 50,50",
            fill: !1
        }, i["GR.EQ.ANTENNAE"] = [], i["GR.EQ.PSYCHOLOGICAL OPERATIONS EQUIPMENT"] = {
            type: "path",
            fill: !!R && G,
            stroke: o,
            d: "m 110,95 10,0 m -10,10 10,0 m -10,10 10,0 m -10,-30 10,0 m -10,-5 -10,10 -30,0 0,20 30,0 10,10 z"
        }, i["GR.IN.IC.ELDER CARE"] = {
            type: "path",
            d: "m 120.1,119.1 c 0,-6.3 2.3,-8.2 3.9,-12.6 1,-2.6 1.6,-3.3 1.8,-6.5 0.2,-2.4 0.9,-4.7 0.9,-7.2 v -2.6 c 0,-2.6 -2.2,-8.9 -3.3,-10.5 -1.3,-2 -4.8,-5.4 -6.7,-6.9 -2.2,-1.8 -5.4,-4.6 -8.2,-5.6 -1.6,-0.5 -9.8,-2.4 -11.4,-2.3 l -5.7,0.6 v 0.8 c 0,0.8 2,2.7 2.4,3.3 0,3.3 0.8,6.8 -1.3,8.4 -2.2,1.6 -2.8,3.4 -3.8,6.3 -0.4,1 -0.9,3.1 -1,4 -0.2,1 -0.2,4 -0.4,4.6 -1.1,2.4 -2.6,4.2 -3.8,6.4 l -5.1,0.5 c -2.1,3.2 -4.6,4.1 -4.6,9.6 v 26.4 c 0.6,0.2 0.4,0.2 0.9,0.2 0.5,0 0.3,-0.1 0.9,-0.2 v -27.5 c 0,-0.7 0.8,-3 1.1,-3.5 0.4,0.2 0.8,0.6 1.3,0.6 0.3,0 1.1,-0.3 1.3,-0.4 l 2.6,0.9 0.8,-0.6 0.6,2.5 c 0.4,0.3 0.4,0.5 0.8,0.5 h 0.4 c 0.5,0 0.6,-0.2 0.6,-0.6 v -0.4 c 0,-1 -1.2,-3 -1.5,-3.7 1.2,-2.5 6.3,-2.6 8.2,-5.8 0.9,-1.6 1.8,-3 2.6,-4.5 0.4,-0.9 2.3,-4.1 2.4,-4.4 h 4.4 c 2.3,0 2.1,2.5 2.6,4.2 0.6,2 2,2 2,4.6 0,2.8 -2.9,7 -4,9 -0.3,0.7 -3.9,8.8 -3.9,8.9 v 2 c 0,3 2.6,9.1 2.6,11.2 v 2.2 c -1.2,0.3 -6.8,2.4 -6.8,3.5 0,0.3 0.4,0.6 0.9,0.6 h 6.8 c 2.3,0 4.5,-1 6.6,-1.1 v -3 c 0,-0.6 -1.1,-2.2 -1.1,-3.7 -0.9,-1.3 -1.8,-6 -1.8,-8.2 0,-3.2 1.2,-5.4 2.5,-7.4 2.5,-4 0.4,-2.3 4.6,-5.1 l 1.8,1.7 c -1,1.8 -2.3,3.7 -2.3,6.4 v 5.9 h 0.4 v 0.6 c 0,0.9 5,9 5.7,10.3 -1.5,2.3 -6.7,1.6 -6.8,5 h 7.5 c 1.2,0 3.3,-1 4.5,-1.4 1.6,-0.5 2.9,-1.1 2.9,-3 0,-0.7 -2.9,-4.6 -3.6,-5.7 -0.3,-0.4 -2.4,-6 -2.4,-6.6 v -0.4 z m -45.3,-47.9 v 0.6 c 0,4.3 3.7,7.9 8.1,7.9 h 0.2 c 3.7,0 7.7,-3.6 7.7,-7 v -2.2 c 0,-3.2 -3.9,-6.8 -7.5,-6.8 h -1.2 c -3.4,0 -7.3,4 -7.3,7.5 z",
            stroke: !1
        }, i["GR.IN.IC.RAW MATERIAL PRODUCTION/STORAGE"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 90,
                fontsize: 30,
                text: "PS"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 120,
                fontsize: 30,
                text: "RM"
            }
        ], i["GR.IN.IC.MINE"] = {
            type: "path",
            d: "m 105,85 10,10 5,-5 c -5,-5 -10,-5 -15,-5 z M 95,85 85,95 80,90 c 5,-5 10,-5 15,-5 z m -5,5 30,30 m -40,0 30,-30"
        }, i["GR.IN.IC.PROCESSING FACILITY"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 90,
                fontsize: 30,
                text: "PROC"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 120,
                fontsize: 30,
                text: "FAC"
            }
        ], i["GR.IN.IC.UTILITY FACILITY"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "UTIL"
        }, i["GR.IN.IC.RESEARCH"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "R&D"
        }, i["GR.IN.IC.TELECOMMUNICATIONS"] = {
            type: "path",
            d: "m 95,80 10,20 -10,0 10,20",
            fill: !1
        }, i["GR.IN.IC.ELECTRIC POWER"] = {
            type: "path",
            d: "m 100,60.5 c -16.4,0 -29.6,13.2 -29.6,29.6 0,12.8 8.3,23.9 19.7,27.8 l 0,19.7 c 3.2,1.2 6.3,1.8 9.9,1.8 3.6,0 6.7,-0.6 9.9,-1.8 l 0,-19.8 c 11.5,-3.9 19.8,-15 19.7,-27.8 0,-16.4 -13.2,-29.6 -29.6,-29.6 z",
            fill: !1
        }, i["GR.IN.IC.ELECTRIC POWER NUCLEAR"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 105,
            fontsize: 40,
            text: "N"
        }, i["GR.IN.IC.ELECTRIC POWER DAM"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 105,
            fontsize: 40,
            text: "H"
        }, i["GR.IN.IC.ELECTRIC POWER FOSSIL"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 105,
            fontsize: 40,
            text: "F"
        }, i["GR.IN.IC.ATOMIC ENERGY"] = {
            type: "path",
            d: R ? "M 90.4,119 C 84.2,115 80,109 80,101 l 20,0 -9.6,18 z m 19.6,0 -10,-18 20,0 c 0,8 -4,14 -10,18 z M 100,101 89.7,83.8 c 3,-2 6.5,-3 10.3,-3 4,0 7,1 10,3 L 100,101 Z" : "M 89.9,82.5 110,82.7 89.7,117.1 80,99.9 120.1,100 110,117.3 z",
            fill: !1
        }, i["GR.IN.IC.ATOMIC ENERGY WEAPONS GRADE"] = {
            type: "path",
            d: R ? "M 90.4,119 C 84.2,115 80,109 80,101 l 20,0 -9.6,18 z m 19.6,0 -10,-18 20,0 c 0,8 -4,14 -10,18 z M 100,101 89.7,83.8 c 3,-2 6.5,-3 10.3,-3 4,0 7,1 10,3 L 100,101 Z" : "M 89.9,82.5 110,82.7 89.7,117.1 80,99.9 120.1,100 110,117.3 z"
        }, i["GR.IN.IC.AIRCRAFT PRODUCTION & ASSEMBLY"] = {
            type: "path",
            stroke: !1,
            d: "m 95.1,109.3 c 0,0 -20.8,4.9 -30.1,6.7 -2.2,0.4 -5.7,0.2 -6.5,-2 -0.4,-1.1 3.3,-6.6 6.5,-7.3 8.7,-1.9 25.7,-5.5 25.7,-5.5 l 3.1,-16.1 4,-0.8 0.3,15.9 25.6,-5.8 6.5,-13.2 5.3,-1.4 -3.3,16.1 14,4.8 -4.3,1.2 -13.7,-2.8 -23.6,6.7 31.6,11.8 -5.5,2.5 z"
        }, i["GR.IN.IC.BRIDGE"] = {
            type: "path",
            d: "m 70,115 10,-10 40,0 10,10 m -60,-30 10,10 40,0 10,-10",
            fill: !1
        }, i["GR.IN.IC.BASE"] = {
            type: "path",
            d: "m 75,85 50,30 m -50,0 50,-30",
            fill: !1
        }, i["GR.IN.IC.SEA SURFACE INSTALLATION, OIL RIG/PLATFORM"] = [
            {
                type: "path",
                d: "m 85,105 0,-40 m 25,40 0,15 m -35,0 0,-15 50,0 0,15",
                fill: !1
            },
            {
                type: "path",
                d: "m 85,90 15,0 0,15 -15,0 0,-15"
            }
        ], i["GR.IN.IC.MILITARY/CIVILIAN.MATERIEL"] = a("MAT"), i["GR.IN.IC.MILITARY/CIVILIAN.PRINTED MEDIA"] = [
            {
                type: "circle",
                cx: 100,
                cy: 90,
                r: 10,
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 110,
                r: 10,
                fill: !1
            },
            {
                type: "path",
                d: "m 65,100 75,0",
                fill: !1
            }
        ], i["GR.IN.IC.INFRASTRUCTURE.BANKING FINANCE AND INSURANCE  INFRASTRUCTURE.ECONOMIC INFRASTRUCTURE ASSET"] = a("ECON"), i["GR.IN.IC.INFRASTRUCTURE.TELECOMMUNICATIONS INFRASTRUCTURE.TELECOMMUNICATIONS"] = {
            type: "path",
            d: "m 90,105 20,0 0,0 m -25,15 15,-30 15,30 m -55,-40 25,10 0,-10 15,10 15,-10 0,10 25,-10",
            fill: !1
        }, i["GR.IN.M1.RADIOLOGICAL"] = l("R"), i["GR.IN.M1.COAL"] = l("CO"), i["GR.IN.M1.GEOTHERMAL"] = l("GT"), i["GR.IN.M1.HYDROELECTRIC"] = l("HY"), i["GR.IN.M1.NATURAL GAS"] = l("NG"), i["GR.IN.M1.PETROLEUM"] = {
            type: "path",
            d: "m 100,75 0,-10 -6,-10 12,0 -6,10",
            fill: !1
        }, i["GR.IN.M1.CIVILIAN"] = l("CIV"), i["GR.IN.M1.CIVILIAN TELEPHONE"] = l("T"), i["GR.IN.M1.CIVILIAN TELEVISION"] = l("TV"), i["GR.IN.M2.CHEMICAL WARFARE PRODUCTION"] = r("C"), i["GR.IN.M2.NUCLEAR WARFARE PRODUCTION"] = r("N"), i["GR.IN.M2.RADIOLOGICAL WARFARE PRODUCTION"] = r("R"), i["GR.IN.M2.ATOMIC ENERGY REACTOR"] = r("A"), i["GR.IN.M2.NUCLEAR MATERIAL PRODUCTION"] = r("P"), i["GR.IN.M2.NUCLEAR MATERIAL STORAGE"] = r("S"), i["GR.IN.M2.CHEMICAL & BIOLOGICAL WARFARE"] = r("B"), i["GR.IN.M2.SHIP CONSTRUCTION"] = r("YRD"), i["GR.IN.M2.WEAPONS GRADE PRODUCTION"] = r("W"), i["SOF.IC.UNDERWATER DEMOLITION TEAM"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 32,
            text: "UDT"
        }, i["SOF.M2.ATTACK"] = r("A"), i["SOF.M2.REFUEL"] = r("K"), i["SOF.M2.UTILITY"] = r("U"), i["SOF.M2.VSTOL"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 135,
            fontsize: 20,
            text: "VSTOL"
        }, i["SOF.M2.COMBAT SEARCH AND RESCUE"] = r(R ? "CSAR" : "H"), i["ST.IC.ARREST"] = {
            type: "path",
            d: "m 92.5,100 15,0 m -2.5,-10 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z m -5,5 0,20 m 20,-15 c 0,11 -9,20 -20,20 -11,0 -20,-9 -20,-20 0,-11 9,-20 20,-20 11,0 20,9 20,20 z",
            fill: !1
        }, i["ST.IC.ARSON/FIRE"] = R ? [
            {
                type: "path",
                d: "m 84.6,101.6 c 1.3,23.1 31,23.2 30.7,-1.9 -1.5,2.1 -4.6,6.5 -8.1,7.3 1.9,-2.4 2.6,-8.5 2.4,-12.9 -1.7,3.4 -4,7.9 -7,7.8 1.7,-4.3 2.7,-9.4 -0.5,-13.7 -0.2,3 0.8,7.1 -1.9,7 -2.7,-0.1 -2.9,-4.4 -1.1,-10.8 -4,4.1 -6.2,9.8 -3.8,17.5 -1.9,-0.2 -4.4,-1.9 -7,-7.8 -1.5,4.9 1.2,9.6 3.2,13.7 -2.4,-1.1 -6,-3 -7,-6.2 z",
                stroke: !1
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 75,
                fontsize: 25,
                text: "ASN"
            }
        ] : {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 35,
            text: "FIRE"
        }, i["ST.IC.ATTEMPTED CRIMINAL ACTIVITY"] = {
            type: "path",
            d: "m 127,127 5,5 m -15,-15 5,5 m -15,-15 5,5 m -15,-15 5,5 m -15,-15 5,5 m -15,-15 5,5 m -15,-15 5,5",
            fill: !1
        }, i["ST.IC.BLACK LIST LOCATION"] = a("BLK"), i["ST.IC.BLACK MARKETING"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 95,
                fontsize: 30,
                text: "BLK"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 125,
                fontsize: 30,
                text: "MKT"
            }
        ], i["ST.IC.BOMB"] = a("BOMB"), i["ST.IC.BOOBY TRAP"] = {
            type: "path",
            d: "m 85,105 15,-25 15,25 m -35,5 c 0,-10 40,-10 40,0 0,10 -40,10 -40,0 z",
            fill: !1
        }, i["ST.IC.COMPOSITE LOSS"] = {
            type: "path",
            d: "m 100,85 0,30 m -35,-15 45,0 m 20,0 c 0,5.5 -4.5,10 -10,10 -5.5,0 -10,-4.5 -10,-10 0,-5.5 4.5,-10 10,-10 5.5,0 10,4.5 10,10 z",
            fill: !1
        }, i["ST.IC.DEMONSTRATION"] = a("MASS"), i["ST.IC.DRIVE-BY SHOOTING"] = {
            type: "path",
            d: "m 95,85 5,-5 5,5 m -5,-5 0,30 m -15,0 30,0 m 5,5 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z m -30,0 c 0,2.8 -2.2,5 -5,5 -2.8,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 z",
            fill: !1
        }, i["ST.IC.DRUG RELATED ACTIVITIES"] = a("DRUG"), i["ST.IC.EXPLOSION"] = {
            type: "path",
            d: "m 110,55 5,20 15,-10 0,15 15,5 -15,10 15,10 -15,5 5,15 -20,-5 -5,20 -10,-15 -10,20 -5,-25 -20,10 5,-15 L 55,105 70,95 60,85 70,80 70,65 85,75 90,55 100,70 z",
            fill: !1
        }, i["ST.IC.EXTORTION"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 130,
            fontsize: 80,
            text: "$"
        }, i["ST.IC.FOOD DISTRIBUTION"] = [
            {
                type: "path",
                d: "m 105,85 c -5,10 -5,20 0,30 m 0,-30 c -20,0 -20,30 0,30",
                fill: !1
            },
            {
                Unknown: {
                    type: "path",
                    d: "M35,120 l130,0 ",
                    fill: !1
                },
                Friend: {
                    type: "path",
                    d: "M25,120 l150,0 ",
                    fill: !1
                },
                Neutral: {
                    type: "path",
                    d: "M45,120 l110,0 ",
                    fill: !1
                },
                Hostile: {
                    type: "path",
                    d: "M50,120 l100,0 ",
                    fill: !1
                }
            }[T]
        ], i["ST.IC.GRAFFITI"] = {
            type: "path",
            d: "m 110,80 c -10,0 -10,10 0,10 10,0 10,10 0,10 -10,0 -10,10 0,10 10,0 10,10 0,10 M 90,80 c -10,0 -10,10 0,10 10,0 10,10 0,10 -10,0 -10,10 0,10 10,0 10,10 0,10",
            fill: !1
        }, i["ST.IC.GROUP"] = {
            type: "path",
            d: "m 133,90 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0 m -52,-12.3 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0 m 23,-7.3 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0",
            fill: !1
        }, i["ST.IC.HIJACKING (AIRPLANE)"] = {
            type: "path",
            fill: !!R && G,
            d: "m 70,95 0,10 65,0 0,-10 z m 55,10 0,10 5,0 0,-10 z m 0,-10 0,-10 5,0 0,10 z m -45,10 0,15 10,0 0,-15 z m 0,-10 0,-15 10,0 0,15 z"
        }, i["ST.IC.HIJACKING (BOAT)"] = {
            type: "path",
            fill: R ? G : !C && G,
            d: "m 105,80 0,20 20,0 z m -5,25 0,-25 m -30,25 10,15 40,0 10,-15 z"
        }, i["ST.IC.GRAY LIST LOCATION"] = a("GRAY"), i["ST.IC.IED"] = a("IED"), i["ST.IC.INDIVIDUAL"] = {
            type: "path",
            d: "m 108,90 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0",
            fill: !1
        }, i["ST.IC.INTERNAL SECURITY FORCE"] = a("ISF"), i["ST.IC.KILLING VICTIM"] = [
            {
                type: "path",
                d: "m 108,90 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0",
                fill: !1
            },
            {
                Unknown: {
                    type: "path",
                    fill: !1,
                    d: "M50,65 150,135"
                },
                Friend: {
                    type: "path",
                    fill: !1,
                    d: "M25,50 175,150"
                },
                Neutral: {
                    type: "path",
                    fill: !1,
                    d: "M45,45 155,155"
                },
                Hostile: {
                    type: "path",
                    fill: !1,
                    d: "M57,70 143,130"
                }
            }[T]
        ], i["ST.IC.KILLING VICTIMS"] = [
            {
                type: "path",
                d: "m 133,90 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0 m -52,-12.3 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0 m 23,-7.3 c 0,10 -15,10 -15,0 0,-10 15,-10 15,0 z m -8,7.3 0,25 m -10,-20 20,0",
                fill: !1
            },
            {
                Unknown: {
                    type: "path",
                    fill: !1,
                    d: "M50,65 150,135"
                },
                Friend: {
                    type: "path",
                    fill: !1,
                    d: "M25,50 175,150"
                },
                Neutral: {
                    type: "path",
                    fill: !1,
                    d: "M45,45 155,155"
                },
                Hostile: {
                    type: "path",
                    fill: !1,
                    d: "M57,70 143,130"
                }
            }[T]
        ], i["ST.IC.KNOWN INSURGENT VEHICLE"] = {
            type: "path",
            d: "m 65,95 70,0 m 0,10 c 0,5.5 -4.5,10 -10,10 -5.5,0 -10,-4.5 -10,-10 0,-5.5 4.5,-10 10,-10 5.5,0 10,4.5 10,10 z m -50,0 c 0,5.5 -4.5,10 -10,10 -5.5,0 -10,-4.5 -10,-10 0,-5.5 4.5,-10 10,-10 5.5,0 10,4.5 10,10 z",
            fill: !1
        }, i["ST.IC.MASS GRAVE LOCATION"] = {
            type: "path",
            d: "m 77.5,90 10,0 m -5,-5 0,15 m 7.5,-20 0,30 -15,0 0,-30 z m 22.5,10 10,0 m -5,-5 0,15 m -7.5,-20 0,30 15,0 0,-30 z m -15,20 10,0 m -5,-5 0,20 m -7.5,-25 15,0 0,30 -15,0 z",
            fill: !1
        }, i["ST.IC.MINE LAYING"] = [
            {
                type: "path",
                d: "m 60,85 80,0 0,30 -80,0 z",
                fill: !1
            },
            {
                type: "path",
                d: "m 135,100 c 0,5.5 -4.5,10 -10,10 -5.5,0 -10,-4.5 -10,-10 0,-5.5 4.5,-10 10,-10 5.5,0 10,4.5 10,10 z m -25,0 c 0,5.5 -4.5,10 -10,10 -5.5,0 -10,-4.5 -10,-10 0,-5.5 4.5,-10 10,-10 5.5,0 10,4.5 10,10 z m -25,0 c 0,5.5 -4.5,10 -10,10 -5.5,0 -10,-4.5 -10,-10 0,-5.5 4.5,-10 10,-10 5.5,0 10,4.5 10,10 z",
                stroke: !1
            }
        ], i["ST.IC.PATROLLING"] = {
            type: "path",
            d: "m 131,97 0,-14 5,0 c 4,0 4,7 0,7 l -5,0 m -71,15 15,10 M 60,105 75,95 m -15,10 40,0 -15,-15 40,0",
            fill: !1
        }, i["ST.IC.POISONING"] = {
            type: "path",
            d: "m 85,95 c 0,-20 30,-20 30,0 0,20 -30,20 -30,0 z m -15,10 60,15 m -60,0 60,-15",
            fill: !1
        }, i["ST.IC.PSYCHOLOGICAL OPERATIONS"] = {
            type: "path",
            fill: !!R && G,
            stroke: o,
            d: "m 110,95 10,0 m -10,10 10,0 m -10,10 10,0 m -10,-30 10,0 m -10,-5 -10,10 -30,0 0,20 30,0 10,10 z"
        }, i["ST.IC.RADIO AND TELEVISION PSYCHOLOGICAL OPERATIONS"] = [
            i["ST.IC.PSYCHOLOGICAL OPERATIONS"],
            {
                Unknown: {
                    type: "path",
                    fill: !1,
                    d: "M50,65 100,110 100,90 150,135"
                },
                Friend: {
                    type: "path",
                    fill: !1,
                    d: "M25,50 100,110 100,90 175,150"
                },
                Neutral: {
                    type: "path",
                    fill: !1,
                    d: "M45,45 100,110 100,90 155,155"
                },
                Hostile: {
                    type: "path",
                    fill: !1,
                    d: "M57,70 100,110 100,90 143,130"
                }
            }[T]
        ], i["ST.IC.RIOT"] = a("RIOT"), i["ST.IC.SAFE HOUSE"] = a("SAFE"), i["ST.IC.SEARCHING"] = {
            type: "path",
            d: "m 140,105 c -10,0 -5,0 -10,0 -15,0 -5,-15 -20,-15 -15,0 -5,20 -20,20 -15,0 -5,-20 -20,-20 -10,0 -10,10 -10,10 m 70,0 10,5 -10,5",
            fill: !1
        }, i["ST.IC.SPY"] = a("SPY"), i["ST.IC.SNIPING"] = [
            {
                type: "path",
                d: "m 95,85 5,-5 5,5 m -5,-5 0,40",
                fill: !1
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 75,
                fontsize: 25,
                text: "S"
            }
        ], i["ST.IC.VANDALISM/LOOT/RANSACK/PLUNDER/SACK"] = {
            type: "path",
            d: "m 115,100 c 0,-5 5,-10 10,-10 M 85,100 C 85,95 80,90 75,90 m 5,25 c -0.5,-29.5 40,-30 40,0 z",
            fill: !1
        }, i["ST.IC.WHITE LIST LOCATION"] = a("WHT"), i["ST.IC.ROBBERY"] = a("ROB"), i["ST.IC.THEFT"] = a("THF"), i["ST.IC.BURGLARY"] = a("BUR"), i["ST.IC.SMUGGLING"] = a("SMGL"), i["ST.IC.SABOTAGE"] = a("SAB"), i["ST.IC.ILLEGAL DRUG OPERATION"] = a("DRUG"), i["ST.IC.SPY"] = a("SPY"), i["ST.IC.WARRANT SERVED"] = a("WNT"), i["ST.IC.POLLING PLACE/ELECTION"] = a("VOTE"), i["ST.IC.NATURAL EVENT"] = a("NAT"), i["ST.IC.GEOLOGIC"] = a("GEOL"), i["ST.IC.HYDRO-METEOROLOGICAL"] = a("HYDR"), i["ST.IC.INFESTATION"] = a("INFS"), i["ST.IC.GRENADE"] = a("G"), i["ST.IC.INCENDIARY"] = a("I"), i["ST.IC.MINE"] = a("M"), i["ST.IC.HOUSE"] = {
            type: "path",
            fill: !!R && G,
            d: "m 70,100 60,0 m -30,-20 -30,20 0,35 60,0 0,-35 -30,-20 z"
        }, i["ST.IC.ROCK THROWING"] = {
            type: "path",
            d: "m 90,60 25,25 M 70,65 95,90 M 60,80 80,100 m 45,-5 5,15 -5,15 -20,10 -20,-5 -5,-20 5,-5 10,0 5,-10 10,-5 15,5 z"
        }, i["ST.M1.ACCIDENT"] = l("ACC"), i["ST.M1.ASSASSINATION"] = l("AS"), i["ST.M1.CIVILIAN"] = l("CIV"), i["ST.M1.COERCED/IMPRESSED"] = l("C"), i["ST.M1.COMBAT"] = l("CBT"), i["ST.M1.DEAD BODY"] = l("DB"), i["ST.M1.DISPLACED PERSONS, REFUGEES, AND EVACUEES"] = l("DPRE"), i["ST.M1.DRUG"] = l("DRUG"), i["ST.M1.EVICTION"] = l("EV"), i["ST.M1.EXECUTION (WRONGFUL KILLING)"] = l("EX"), i["ST.M1.EXFILTRATION"] = l("EXFL"), i["ST.M1.FOREIGN FIGHTERS"] = l("FF"), i["ST.M1.GANG"] = l("GANG"), i["ST.M1.GOVERNMENT ORGANIZATION"] = l("GO"), i["ST.M1.HIJACKING/HIJACKED"] = l("H"), i["ST.M1.HOUSE-TO-HOUSE"] = {
            type: "path",
            fill: !!R && G,
            d: "m 110,65 -20,0 0,15 20,0 z m -10,-10 -10,10 20,0 z"
        }, i["ST.M1.IED"] = l("IED"), i["ST.M1.INCIDENT"] = l("INC"), i["ST.M1.INFILTRATION"] = l("INFL"), i["ST.M1.KIDNAPPING"] = l("K"), i["ST.M1.LABRATORY"] = l("LAB"), i["ST.M1.LEADER"] = l("LDR"), i["ST.M1.LOOT"] = l("LOOT"), i["ST.M1.MEETING"] = l("MTG"), i["ST.M1.MURDER"] = l("MU"), i["ST.M1.NONGOVERNMENTAL ORGANIZATION (NGO)"] = l("NGO"), i["ST.M1.OTHER"] = l("OTH"), i["ST.M1.PIRACY"] = l("PI"), i["ST.M1.PREMATURE"] = l("P"), i["ST.M1.RAID"] = l("RAID"), i["ST.M1.RAPE"] = l("RA"), i["ST.M1.RELIGIOUS"] = l("REL"), i["ST.M1.SPEAKER"] = l("SPK"), i["ST.M1.TARGETED"] = l("TGT"), i["ST.M1.TERRORIST"] = l("TER"), i["ST.M1.TRAFFICKING"] = l("TFK"), i["ST.M1.WILLING RECRUIT"] = l("WR"), i["ST.M1.WRITTEN PSYCHOLOGICAL OPERATIONS"] = i["ST.M1.WILLING"] = l("W"), i["ST.M1.FALSE"] = l("FAL"), i["ST.M1.FIND"] = l("FND"), i["ST.M1.FOUND AND CLEARED"] = l("CLR"), i["ST.M1.HOAX (DECOY)"] = {
            type: "path",
            d: "M 90,75 80,67.5 90,60 90,75 Z m 15,0 -10,-7.5 10,-7.5 0,15 z m 15,0 -10,-7.5 10,-7.5 0,15 z"
        }, i["ST.M1.ATTEMPTED"] = l("ATT"), i["ST.M1.ACCIDENT"] = l("ACC"), i["ST.M1.INCIDENT"] = l("INC"), i["ST.M1.THEFT"] = l("THF"), i["ST.M1.PIRATE"] = [
            {
                type: "circle",
                cx: 100,
                cy: 60,
                r: 7,
                fill: !1
            },
            {
                type: "path",
                fill: !1,
                d: "m 82.5,75 35,-15 m 0,15 -35,-15 m 3,7 5,10 m 27,-10 -10,10"
            }
        ], i["ST.M2.LEADER OR LEADERSHIP"] = r("LDR"), i["ST.M2.RELIGIOUS"] = r("REL"), i["AC.IC.CRIMINAL.ACTIVITY.INCIDENT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 98.7,66.7 c -3.2,0.7 -6.3,3.7 -6.4,7 0.3,3.6 5.3,2.8 7,0.6 2,-1.2 1.7,-4.5 4.5,-3.7 2.6,-0.6 3.2,3.2 5.9,3.2 1.6,1.5 4.4,-0.6 5.4,1.2 0.7,1.1 1.5,2.2 2.2,3.3 -2,3.1 -1.3,7.9 1.9,10 3.5,1.1 4.8,-3.5 4.1,-6.2 -0.2,-3 -2.5,-5 -5.1,-5.4 -1.5,-1.9 -2.7,-3.4 -1.6,-5.6 -1,-3.3 -5.1,-4.5 -8.2,-4.3 -2.2,0.3 -2.9,2.6 -5.3,1.9 -1.9,0.4 -1.9,-2.8 -4.3,-2 z m 0.2,1.3 c 2.7,0.5 0.9,0.6 -0.6,1.3 -0.5,2.2 3.8,0.4 1.4,2.9 -0.9,1.9 -5.8,4.7 -5.9,1.1 0.1,-2.5 2.7,-4.8 5.1,-5.2 z m 10.3,0.1 c 2.4,-0.5 7.1,2.3 5.6,3.7 -0.8,-2.1 -3,0 -1.2,1.2 -1.7,0.9 -7.4,-1.6 -5.7,-2.4 2.5,0.8 2.8,-2.7 -0,-1.9 -1.4,0.2 1.1,-0.8 1.3,-0.6 z M 81.9,71.6 c -1.8,1.9 -3.6,3.9 -5.5,5.8 -7.5,-0.1 -14,6.2 -15.7,13.2 -0.6,4.2 0.5,8.5 2.8,12 0.7,3.9 -3.2,6.7 -3,10.7 -0.8,7.4 4.8,14.5 11.7,16.8 2.3,-0.4 1.3,1.3 1.4,2 1.5,-0.4 3,-0.8 4.6,-1.2 -0.2,1.5 -0.1,2.7 1.4,1.2 0.9,-0.3 2.3,-2.2 2.9,-1.5 0.2,2.2 1.2,0.1 2,-0.7 0.8,-1.2 1.6,-2.3 2.4,-0.5 1.2,-2.4 4.1,-7.2 -0.8,-7.3 -3.4,2.3 -7.5,4.6 -11.8,3.5 -6.3,-1.5 -10.9,-8.8 -8.2,-14.9 0.4,-3.9 6.8,-3.4 5,-8.2 -1.8,-2.6 -5.7,-2.9 -5.7,-7 -1.5,-7.3 5.6,-14.7 13,-13.7 4.7,0.5 7.4,4.9 10.8,7.6 1.9,1.9 4.1,5.1 5.9,1.4 2.8,-2 4.3,-4.7 1.8,-7.6 C 94.8,79.7 90.9,77.3 88,74.4 86.3,72.9 83.9,72.6 81.9,71.6 z m 3.3,3.8 c 1.6,1.1 2.9,2.1 0.3,3.3 -0.9,3.7 -5.1,-0.5 -1.5,-1.5 0.4,-0.6 0.9,-1.1 1.2,-1.8 z m 34.2,3.1 c 3,1.4 3.9,6.4 1.4,8.8 -2.9,0.1 -3.6,-4.3 -3.1,-6.6 0.1,-2.9 2.5,2.7 2.5,-0.7 -0.2,-0.5 -0.5,-1 -0.8,-1.4 z M 127.3,90.2 c -4.3,0.4 -8.8,-0 -13.1,1 -2.1,1.1 -5.7,1.5 -4.6,4.5 0.1,1.8 0.2,3.6 0.4,5.4 -4.9,4.9 -5.5,13.3 -2.2,19.2 2.4,4.3 7,7 11.8,7.8 3.3,4.9 7.3,-1.3 11.2,-1.7 5.5,-2.5 8.9,-8.5 8.5,-14.5 0.2,-5 -2.4,-10.1 -6.7,-12.8 -0.1,-2.3 -0.2,-4.6 -0.3,-6.9 -1.6,-0.8 -3.4,-1.4 -5.1,-2.1 z M 127.8,92.5 c -0.9,1.7 0.6,3.8 -0.9,4.9 -2.3,0.7 -1.7,-2.4 -1.9,-3.8 -0.6,-1.7 1.9,-0.7 2.8,-1 z m -2.9,8.3 c 4.1,0.9 8,3.7 9.3,7.9 0.9,3.7 0.5,8 -2.3,10.9 -1.7,2 -5.3,4.3 -7.7,3.1 -3.1,-0.8 -5.8,2.1 -8.6,-0.5 -6.9,-4.2 -7.2,-16 0.2,-19.8 2.7,-1.6 6,-1.6 9.1,-1.6 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 85.1 75.3 C 85 75.8 84.2 76.7 83.9 77.1 C 83.6 77.6 82.4 77.9 82.4 78.6 L 82.4 79 C 82.4 79.4 83.3 80.1 83.6 80.1 L 83.8 80.1 C 84.8 80.1 85 79.1 85.4 78.6 C 85.7 78.2 86.7 77.4 87.2 77 L 85.1 75.3 z M 127.8 92.5 L 125 92.7 L 125.2 96.5 C 125.3 97.5 125.9 97.3 126.5 97.6 C 127.1 97.3 127.8 97.1 127.8 96.3 C 127.8 95.8 127.7 95.6 127.5 95.3 L 127.8 92.5 z"
            }
        ], i["AC.IC.CRIMINAL.CIVIL DISTURBANCE"] = {
            type: "path",
            stroke: !1,
            d: "m 110.6,142.4 0,-28.6 -7.1,0 0,28.6 z m -21.2,0 7.1,0 0,-28.6 -7.1,0 z m 7.1,-28.6 h 7.1 v -11.8 h 24.4 V 77.2 h -6.3 v 18.6 h -18 v -10.7 c 0,-0.9 2.1,-1.2 3,-1.7 0.8,-0.4 2.1,-1.4 2.7,-2 1.5,-1.4 3.2,-3.6 3.8,-5.9 1.6,-6.3 -0.2,-10.6 -3.8,-14.1 -3,-3.1 -9.2,-4.9 -14.3,-2.7 -3.6,1.6 -8.4,6.2 -8.4,11 v 3.2 c 0,2.8 1.9,6.2 3.3,7.7 1,1 1.8,1.7 3,2.5 1,0.6 3.6,1.3 3.6,2.2 v 10.7 H 78.4 v -18.6 h -6.3 v 24.9 h 24.4 v 11.8 h -0 z"
        }, i["AC.IC.SHOOTING"] = {
            type: "path",
            stroke: !1,
            d: "m 93.2,89.7 h 16.8 v 9.3 c -2.6,0 -7.3,1.6 -9,1 -2.3,-0.8 -5.4,-2 -7.8,-2.6 v -7.8 l 0,0 z m -30,0 h 26.1 v 9.6 c 0,0.9 4.1,2 5,2.3 1.9,0.6 3.6,1.4 5.5,2 2,0.7 3.4,0.4 6,-0.1 1.6,-0.3 5.7,-0.4 6.6,-0.9 0.6,2.7 4.6,14 4.6,15.2 0,1.6 -1.2,4 -1.3,5.7 l 21.5,0 -8.2,-25.9 7.8,-7.7 c -0.8,-1.6 -4.1,-13.4 -5.2,-13.4 h -68.4 v 13.2 l 0,0 z"
        }, i["AC.IC.FIRE EVENT"] = {
            type: "path",
            stroke: !1,
            d: "m 96.5,78.5 c 0,-5.1 4.1,-9.7 4.1,-13 v -0.4 c 0,-1.3 -0,-3.8 -1.1,-4.1 -1,4.5 -3.5,8 -5.9,11.2 -1.2,1.6 -2.4,3.3 -3.6,5 -1,1.4 -3.1,3.5 -3.1,5.5 0,1.4 6.1,17.7 3,17.7 -0.1,0 -3.8,-2.5 -4.2,-2.9 -1.4,-1 -2.4,-2.3 -3.3,-3.7 -3.1,-4.6 -2.4,-4.4 -3.8,-10.3 -1.5,0.4 -2.6,5 -2.9,6.9 -0.4,2.4 -0.3,6.6 0.2,9 0.6,2.8 1.4,5 2.5,7.3 0.6,1.2 3,5.5 3.1,6.5 -2.2,-0.5 -7,-4.6 -8.6,-6.2 -1.5,-1.5 -5.5,-8.3 -5.9,-8.6 0,9.9 5,22.8 9.8,27.6 3.1,3.1 6.3,6.4 10.2,8.6 2.4,1.5 10.5,4.3 14.3,4.3 h 2.4 c 2.8,0 10.8,-3 12.9,-4.2 3.4,-1.9 6.9,-4.7 9,-7.9 4.4,-6.5 8,-15 8,-25.8 v -1.3 l -0.4,-5.8 c -0.7,0.4 -2.2,4.4 -2.5,5.2 -0.5,1.3 -2,3.4 -2.9,4.6 -1.4,2.1 -5.2,6.3 -7.8,6.9 v -1.1 c 0,-4.4 2.8,-8.8 2.8,-12.4 v -1.9 l -1.3,-12.2 h -0.6 c -0.3,3.9 -1.6,7.9 -3.4,10.5 -1.3,2 -5.3,5.6 -7.7,6.2 -0.2,-0.4 -0.4,-0.6 -0.4,-1.3 v -2.3 c 0,-5.1 3,-8.9 3,-12.8 v -0.8 c 0,-1.5 -2.1,-3.9 -2.9,-5.2 -0.7,-1.1 -2.4,-4.3 -3.5,-4.6 v 1.3 c 0,6.2 -1.4,10.6 -5.6,12.6 -1.1,-1.7 -3.6,-3.2 -3.6,-6.2 v -1.9 l 0,0 z"
        }, i["AC.IC.NON-REsIdENTIAL FIRE"] = {
            type: "path",
            stroke: !1,
            d: "m 121.2,122.3 -6.2,0 0,5.9 6.2,0 z m -12.1,0 -6.1,0 0,5.9 6.1,0 z m -12.2,0 -5.9,0 0,5.9 5.9,0 z m -12.3,0 -5.7,0 0,5.9 5.7,0 z m 30.4,-4.8 h 6.1 v -6.2 h -2.5 c -1.2,0 -2.5,1.5 -3.6,1.8 v 4.4 z m -5.9,-6.2 -6.1,0 0,6.2 6.1,0 z m -12.2,0 -5.9,0 0,6.2 5.9,0 z m -12.3,0 -5.7,0 0,6.2 5.7,0 z m 25,-33.4 c 0,-3.4 3.4,-7.4 3.4,-9.1 0,-1.4 -0.8,-4.2 -1.8,-4.6 0,7.1 -8.6,12.8 -8.6,15.7 v 0.4 c 0,0.7 1.9,5.2 2.3,6.6 0.4,1.7 1.4,5.6 1.6,7.3 -6.2,-0.1 -7.3,-9.8 -10.3,-11.8 l -0.3,3 0,4.6 c 0,4.7 3.4,11.4 5.6,13.9 1,1.1 4.2,3.7 5.5,4.3 0.8,0.4 6.3,3 6.6,3 1.4,0 9.2,-7.2 10.5,-8.6 2.5,-2.5 4,-9.6 4,-14.8 v -0.7 l -0.7,-5.7 c -1,0.6 -2.1,5.6 -2.8,7 -1.5,3.2 -1.8,3.1 -5.4,4 -0.3,-12.2 6.7,-8.3 -2.7,-19.1 0,4.9 -0.9,7.9 -4.1,9.6 -1.4,-0.7 -3,-2.7 -3,-4.8 z m -14.8,26.4 h 3.6 c -0.1,-0.6 -0.3,-1.4 -1.1,-1.4 h -1.2 v -2.7 c 0,-0.9 -0.9,-2.4 -1.4,-3 v 7 z m -16.4,-28.6 h 3.9 v 28.6 h 8.9 v -28.6 h 3.6 v 5.4 c 0.3,-0.2 1.4,-1.4 1.4,-1.8 v -5 h -6.4 v 28.6 h -6.4 v -28.6 h -6.1 v 28.6 h -5.2 v 32.7 h 54.8 v -30.7 c -0.4,0.2 -1.1,1 -1.1,1.6 v 27.5 h -52.5 v -29.8 h 5.2 v -28.6 h -0 z"
        }, i["AC.IC.REsIdENTIAL FIRE"] = {
            type: "path",
            stroke: !1,
            d: "m 91.5,88.3 -0.7,-3 -30.1,25.2 15.6,0.1 v 25.6 h 50.5 v -25.6 h 12.4 c -0.4,-0.5 -7.6,-5.9 -8,-5.9 -0.3,0 -1.2,1.6 -1.4,1.9 l 1.4,1.4 h -2.4 c -0.7,0.5 -4.9,3.1 -4.9,3.8 v 22.3 h -18.3 v -12.9 h -8.7 v 12.9 h -18.1 v -23.5 h 22.6 l -2.2,-2.7 -30.7,-0.1 L 91.5,88.3 z m 27.6,28 -8.2,0 0,8.5 8.2,0 z m -27,0.2 -8.7,0 0,8.2 8.7,0 z m 11,-36.4 c 0,0.9 2.1,5.3 2.5,6.9 0.4,1.8 1.5,6.1 1.5,7.8 -7.1,-1.6 -6.9,-9.9 -10.3,-12.2 -1.7,7.5 0.8,15.1 3.7,19.5 2.4,3.6 2.6,3.4 6,6 0.4,0.4 7.9,4.3 7.9,4.3 2,0 9.6,-7.1 11.1,-8.6 1.8,-1.8 5.6,-10.8 5.6,-14.4 V 83.5 c 0,-1.9 -0.3,-3.2 -1.4,-4 0,2 -1.8,7 -2.6,8.4 -0.8,1.8 -4.3,4.2 -6.3,4.7 v -1.7 c 0,-4.4 2.4,-6.8 2.4,-10.1 0,-2 -4,-7.2 -5.2,-8 0,5.4 -0.7,8 -4.2,9.8 -1.2,-0.7 -3.1,-2.6 -3.1,-4.4 v -1 c 0,-1.5 1.8,-5.4 2.5,-6.6 2,-3.9 0.5,-3.8 -0.4,-7 h -0.4 c -1.3,5.5 -0.8,4.8 -3.8,8.9 -1,1.4 -5.4,5.9 -5.4,7.5 z"
        }, i["AC.IC.SCHOOL FIRE"] = {
            type: "path",
            stroke: !1,
            d: "m 131.3,73 c -4,-1 -17,-7.2 -19.8,-7.2 h -2.4 V 96 h -0.7 c 0,5.6 -3.8,15.3 -6.2,18.6 -2,2.7 -3.7,4.1 -6.2,6.2 -0.8,0.6 -7,4.9 -7,5.4 v 8 h 44.1 V 96 h -20.4 l 0,-14.8 18.8,-8.2 z m -49.2,11.8 c 0,-3 3.6,-8 3.6,-10 0,-1.8 -0.8,-3.9 -2,-4.6 -0.4,0.8 -0.4,3.6 -0.9,5 -0.3,0.7 -1.8,2.7 -2.3,3.5 -1.6,2.3 -3.4,4.2 -5.1,6.4 -2.2,2.8 0,5 1.1,8.2 0.8,2.2 1.4,7.9 2.1,9.4 C 71.9,102.4 70.6,91.8 67.6,89.9 l -0.6,7.6 0.1,0.2 c 0,5 3.6,12.3 5.9,15 1.1,1.3 4.3,3.6 5.9,4.6 1.1,0.7 2.5,1 3.7,1.6 0.4,0.2 3.2,1.9 3.2,1.9 2.1,0 9.9,-7.4 11.5,-9 1.8,-1.8 5.8,-11 5.8,-14.4 v -6.3 c 0,-2.1 -0.4,-2.6 -0.7,-4.2 h -0.8 c -0.2,1.9 -2.2,7.1 -3,8.7 -0.7,1.3 -6.3,5.7 -6.3,3.7 v -1.2 c 0,-3.8 2.4,-7.2 2.4,-10 v -0.8 c 0,-1.5 -4.3,-6.8 -5.4,-7.6 0,2.5 0.1,4.8 -0.8,6.5 -0.5,0.9 -2.5,3.5 -3.6,3.5 -1.1,0 -3.2,-3.4 -3.2,-5.1 z"
        }, i["AC.IC.HOT SPOT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 96.3,78.5 c 0,-5.1 4.1,-9.7 4.1,-13 v -0.4 c 0,-1.3 -0,-3.8 -1.1,-4.1 -1,4.5 -3.5,8 -5.9,11.2 -1.3,1.6 -2.3,3.3 -3.6,4.9 -1,1.3 -3.1,3.4 -3.1,5.5 0,1.4 6.1,17.7 3,17.7 -0.1,0 -3.7,-2.5 -4.2,-2.9 -1.4,-1 -2.4,-2.3 -3.3,-3.7 -3.1,-4.6 -2.4,-4.4 -3.8,-10.3 -1.5,0.4 -2.6,5 -2.9,6.9 -0.4,2.4 -0.3,6.7 0.3,9 0.6,2.8 1.3,5 2.5,7.3 0.6,1.2 3.1,5.5 3.1,6.5 -2.2,-0.5 -7.1,-4.6 -8.6,-6.1 -1.5,-1.5 -5.5,-8.3 -5.9,-8.6 0,9.9 5,22.8 9.8,27.6 3.1,3.1 6.3,6.4 10.1,8.7 2.5,1.5 10.5,4.3 14.3,4.3 h 2.4 c 2.9,0 10.8,-3 12.9,-4.2 3.4,-1.9 6.9,-4.7 9,-7.9 4.4,-6.5 8,-15 8,-25.7 V 99.9 l -0.4,-5.8 c -0.7,0.4 -2.2,4.4 -2.5,5.2 -0.5,1.3 -2,3.4 -2.8,4.6 -1.4,2.1 -5.2,6.3 -7.9,6.9 v -1.1 c 0,-4.4 2.8,-8.8 2.8,-12.4 v -1.9 l -1.3,-12.2 -0.7,8e-4 c -0.3,3.9 -1.7,7.9 -3.4,10.5 -1.3,2 -5.3,5.6 -7.7,6.2 -0.2,-0.4 -0.4,-0.6 -0.4,-1.3 v -2.4 c 0,-5.1 3,-8.9 3,-12.8 V 82.6 c 0,-1.5 -2.1,-3.9 -2.9,-5.2 -0.7,-1.1 -2.4,-4.3 -3.5,-4.6 v 1.3 c 0,6.2 -1.4,10.6 -5.6,12.6 -1.1,-1.7 -3.6,-3.1 -3.6,-6.2 v -1.9 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 113,126.9 c 0,6.3 -5.1,11.4 -11.4,11.4 -6.3,0 -11.4,-5.1 -11.4,-11.4 0,-6.3 5.1,-11.4 11.4,-11.4 6.3,0 11.4,5.1 11.4,11.4 z"
            }
        ], i["AC.IC.FIRE ORIGIN"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 96.3,78.5 c 0,-5.1 4.1,-9.7 4.1,-13 v -0.4 c 0,-1.3 -0,-3.8 -1.1,-4.1 -1,4.5 -3.5,8 -5.9,11.2 -1.3,1.6 -2.3,3.3 -3.6,4.9 -1,1.3 -3.1,3.4 -3.1,5.5 0,1.4 6.1,17.7 3,17.7 -0.1,0 -3.7,-2.5 -4.2,-2.9 -1.4,-1 -2.4,-2.3 -3.3,-3.7 -3.1,-4.6 -2.4,-4.4 -3.8,-10.3 -1.5,0.4 -2.6,5 -2.9,6.9 -0.4,2.4 -0.3,6.7 0.3,9 0.6,2.8 1.3,5 2.5,7.3 0.6,1.2 3.1,5.5 3.1,6.5 -2.2,-0.5 -7.1,-4.6 -8.6,-6.1 -1.5,-1.5 -5.5,-8.3 -5.9,-8.6 0,9.9 5,22.8 9.8,27.6 3.1,3.1 6.3,6.4 10.1,8.7 2.5,1.5 10.5,4.3 14.3,4.3 h 2.4 c 2.9,0 10.8,-3 12.9,-4.2 3.4,-1.9 6.9,-4.7 9,-7.9 4.4,-6.5 8,-15 8,-25.7 V 99.9 l -0.4,-5.8 c -0.7,0.4 -2.2,4.4 -2.5,5.2 -0.5,1.3 -2,3.4 -2.8,4.6 -1.4,2.1 -5.2,6.3 -7.9,6.9 v -1.1 c 0,-4.4 2.8,-8.8 2.8,-12.4 v -1.9 l -1.3,-12.2 -0.7,8e-4 c -0.3,3.9 -1.7,7.9 -3.4,10.5 -1.3,2 -5.3,5.6 -7.7,6.2 -0.2,-0.4 -0.4,-0.6 -0.4,-1.3 v -2.4 c 0,-5.1 3,-8.9 3,-12.8 V 82.6 c 0,-1.5 -2.1,-3.9 -2.9,-5.2 -0.7,-1.1 -2.4,-4.3 -3.5,-4.6 v 1.3 c 0,6.2 -1.4,10.6 -5.6,12.6 -1.1,-1.7 -3.6,-3.1 -3.6,-6.2 v -1.9 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 99.6 105.9 C 93.3 105.9 88.2 111 88.2 117.3 C 88.2 123.6 93.3 128.7 99.6 128.7 C 105.9 128.7 111 123.6 111 117.3 C 111 111 105.9 105.9 99.6 105.9 z M 105 109.4 L 106.8 111 L 101.2 117.1 L 107.3 123.2 L 105.6 124.9 L 99.5 118.8 L 93.7 125.3 L 91.9 123.6 L 97.8 117.2 L 92.1 111.4 L 93.8 109.8 L 99.5 115.4 L 105 109.4 z"
            }
        ], i["AC.IC.SMOKE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 99.3,69.2 c 0.2,-2.6 4.4,-5.5 7.2,-6 4.2,-0.8 6.9,1.2 9.1,3.3 1.1,1.1 1.9,2.7 2.4,4.3 0.6,2.2 1.9,1.3 4,2.5 2.4,1.4 4.9,4.4 5.6,7.4 5.3,0 10.3,4.8 10.3,9.9 v 1.3 c 0,3 -1.2,4.9 -2.8,6.5 -1.1,1.1 -1.2,1.2 -2.6,2.1 -1.3,0.8 -2.5,0.6 -2.7,2 -0.6,4.6 -4.2,9 -9.4,9 3.3,5 2.3,8.7 -0.6,13 0,4.8 -0.2,6.2 -2.8,8.8 -2.4,2.5 -4.5,2.4 -8.6,2.4 0.7,-1 1.2,-1 2,-2.4 0.6,-1.1 0.8,-1.7 1.4,-2.9 1,-2.2 1.8,-3.7 1.8,-6.8 v -2.1 c 0,-1.4 -0.2,-2.4 -0.8,-3.2 -1.2,5.2 -1.4,6.4 -5.7,8.6 0,-8.3 3.8,-6.8 -1.9,-13.4 0,3.8 -0.2,5.6 -2.7,6.9 -0.8,-0.5 -2.1,-1.7 -2.1,-2.9 v -0.4 c 0,-2 2.5,-5.2 2.5,-6.7 v -0.4 c 0,-1.1 -0.4,-2.1 -1,-2.5 0,2.9 -3.4,7.6 -4.9,9.2 -1.6,1.7 -1.1,2.8 -0.2,5 0.7,1.7 1.1,3.5 1.1,5.8 v 1 c -3.2,-0.3 -4.4,-6.2 -6.1,-8.2 0,3.4 -0.8,6.3 0.4,9.4 0.8,1.9 2.4,5.6 4.4,6.1 v 0.4 l -3.4,0.6 -0.2,-0.1 c -3.4,0 -6.4,-2.4 -7.8,-4.4 -0.8,-1.1 -1.5,-2.7 -1.7,-4.4 -0.3,-2.3 0.6,-3.6 0.6,-5 0,0 -5.1,-4.7 -4.4,-9 l 0.2,-1.7 c -0.4,-0.5 -1.4,-1.4 -2,-2.2 -0.6,-0.8 -1.1,-1.8 -1.6,-2.6 -1.4,0 -2,0.6 -3.2,0.6 h -0.6 c -5.4,0 -10.5,-5.2 -10.5,-10.5 v -0.8 c 0,-4.9 4.1,-9.2 9,-9.2 h 2.1 c 0.8,-3.2 5.7,-6.9 10.1,-5.9 -0.4,-1.5 -1,-2.7 -1,-4.8 v -0.4 c 0,-3.8 3.2,-7.8 6.1,-8.8 1.9,-0.7 3.9,-1 6.1,-0.4 2.3,0.6 3.7,2.2 4.8,2.5 l 0,0 z m -0.4,-1.9 c -1.3,-0.1 -2.9,-2.1 -5.9,-2.1 h -1.9 c -5,0 -10.6,5.8 -10,11.4 l 0.5,3.4 h -0.6 c -4.3,0 -7.1,3.2 -8.6,6.1 -2.3,-1.1 -6.8,1.2 -7.9,2.4 -1.6,1.6 -3.6,4.2 -3.6,7.3 v 1.5 c 0,3.6 2.4,7.3 4.5,8.9 1.8,1.3 2,1.6 4.4,2.4 2.7,0.9 3.7,0.1 5.9,0.2 l 3.1,3.7 c -0.6,1.3 0.4,4.9 0.9,6 0.5,1.2 0.7,1.4 1.4,2.4 0.2,0.4 1.7,2 1.7,2 0,1.1 -0.4,1.4 -0.4,2.7 v 0.2 c 0,6.3 4.8,12 10.7,12 2.1,0 3.6,-0.4 5,-1 2.6,1.4 7.1,3 9.2,-0.1 l 3.4,0.5 c 2.7,0.4 6.8,-2.2 7.9,-3.6 1,-1.4 3.7,-6 2.4,-8.8 1.1,-0.7 2.6,-3.7 2.7,-5.5 0.1,-1.7 0.2,-1.8 -0.1,-3.6 -0.2,-1.4 -0.9,-2.2 -1,-3.2 4,-0.3 8.4,-5.2 8.4,-9.7 2.5,-1.6 3.4,-1.2 5.6,-3.8 1.3,-1.4 2.6,-4.4 2.6,-7 0,-6.3 -4.7,-12 -10.7,-12 -0.9,-4 -4.8,-8.3 -9.2,-8.6 -0.4,-4.4 -5.7,-9.4 -10.7,-9.4 -4.1,-0 -8.9,2.7 -9.6,5.6 l 0,0 z m 15.8,38.4 c 0.5,0 1,0.1 1,-0.4 0,-3.1 -4.1,-6.7 -7.6,-6.7 h -1.9 c -0.6,0 -1,0.8 -0.6,1 0.4,0.2 1.6,0.1 2,0.1 1.2,0 2.6,0.5 3.4,1 2.1,1.6 2.8,2.1 3.5,5.1 z m -34.5,-12.6 v 1.7 c 0,1.4 0.6,2.2 0.6,3.2 0,0 -3.6,3.4 -3.8,5.4 l 0.6,0.2 c 1,-0.6 1.6,-2.6 3,-4 1,-0.9 3.1,-2.2 4.8,-2.2 h 0.6 c 1.3,0 3.6,1 3.6,-0.2 0,-0.9 -2.6,-1 -3.6,-1 h -0.2 c -1.6,0 -3,0.6 -4,1.3 -0.1,-1 -0.6,-1.9 -0.6,-3.2 0,-4.6 3.7,-8.6 8.4,-8.6 h 1 c 1,0 1.5,0.2 2.3,0.4 0.1,-0.2 0.4,-0.6 0.4,-0.7 0,-0.7 -1.8,-1 -2.5,-1 h -1.5 c -4.5,-8e-4 -9.2,4.4 -9.2,8.6 z m 19.1,-15.8 0.6,0.6 c 1.6,-0.9 3.4,-2.3 5.9,-2.3 h 1 c 5.5,0 10.1,4.4 10.1,9.7 v 0.6 c -1.5,-0 -2.6,-0.8 -4.6,-0.8 h -1 c -1.5,0 -4.1,0.3 -4.2,1.7 0.6,0.1 0.4,0.2 0.8,0.2 0.9,0 1.4,-0.6 3,-0.6 h 2.3 c 2.2,0 5.6,1.8 6.6,3.1 2,2.6 1.8,3.7 2.6,7.2 0.5,0 1,0.1 1,-0.4 0,-4 -2.6,-8.1 -5.2,-9.4 0,-6.9 -4.5,-12.4 -11.1,-12.4 h -1.3 c -2.3,0 -5.6,1.6 -6.5,2.9 z"
            }
        ], i["AC.IC.SPECIAL NEEDS FIRE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 75.3,133.9 h 49.4 v -28.9 c -0.6,0.4 -2.4,1.2 -2.4,2 v 24.8 H 77.4 v -30 h -2.2 v 32.1 l 0,0 z M 93,129.1 h 2 c 4.2,0 7.6,-2.4 9.3,-5 l -1.3,-3.5 c -1.2,0.3 -2.1,5.2 -8.6,5.2 h -0.8 c -3.4,0 -6.3,-3.3 -7.2,-6 -0.6,-1.7 -0.6,-3.6 0,-5.4 0.8,-2.5 1.6,-2.4 2.6,-4 l -0.4,-3.4 c -3.2,0.8 -7.1,8 -5.7,12.8 1.2,4.1 5.4,9.2 10.2,9.2 z M 88.9,97.9 v 0.4 c 0,0.8 0.5,1.4 0.8,2 l 1.4,14.7 11.3,0 4.3,10.2 6.2,-2 -1,-3 -3.5,1 C 108,119.9 104.8,111.7 104,111.7 H 94.1 C 94,111 93.8,110.9 93.8,110.1 v -1.1 h 7.6 v -2.4 h -8 l -0.2,-3.7 v -2.2 c 3.4,-0.8 2.7,-6.2 -1.1,-6.2 -1.8,0 -3.2,1.4 -3.2,3.2 z m 19.9,-7.4 v 1 l -0.4,0.3 C 105.1,89.7 101,86.1 101,80.8 99.6,81.7 98.8,84.8 98.8,87.1 v 1.1 c 0,4.5 3,10.7 5,13.3 2.8,3.7 7.4,4.8 11.6,7 1.6,-0.8 9.3,-5.4 10,-6.3 1.3,-1.7 4.2,-9.8 4.2,-12.4 0,-1.9 -0.3,-8.2 -1.3,-8.8 -0.7,2.7 -0.8,4.7 -2.3,6.8 -1,1.4 -3.3,3.5 -5,4 l -0.2,-2.4 v -0.2 c 0,-3 2,-5.4 2,-8.8 0,-1 -3.4,-6.1 -4.1,-6.2 0,1.8 -0.2,4.1 -0.6,5.4 -0.3,1 -1.9,3.4 -2.9,3.4 h -0.6 c -0.4,-1.4 -1.9,-1.7 -1.9,-4.8 V 76.9 c 0,-2.3 2.6,-5.5 2.6,-7.8 l 0,-0.6 -0.3,-2.4 c -1,0.2 -1,1.9 -1.4,2.9 -0.4,1 -1,2 -1.6,2.9 -1.3,1.7 -2.6,3.4 -3.9,5.1 -2,2.8 -2.1,2.7 -1,6.1 0.6,2 1.7,4.8 1.7,7.4 z m 24.3,10.2 -3.3,-2 -1.2,1.9 3.5,2 z m -66.2,0 1,1.9 c 5,-2.7 11,-6.9 16,-10.1 2.7,-1.7 5.2,-3.4 7.8,-5.1 1.4,-0.9 2.6,-1.6 3.9,-2.6 1.8,-1.2 1.9,-1.9 2.4,-4.3 l -31.2,20.2 z"
            }
        ], i["AC.IC.WILD FIRE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 110.8,139.5 c 0.2,-0.5 6.5,-6.2 7.4,-7 2.6,-2.6 5.6,-5.2 7.8,-8.1 3.9,-5.2 8,-15 8,-24 v -6.9 c 0,-1 0,-2.2 -0.8,-2.4 -0.8,3.4 -3.3,7.7 -5.1,10.1 -0.5,0.6 -7.9,8.7 -7.9,6.2 0,-4.7 2.5,-8.4 2.9,-13.4 0.2,-2.9 -0.8,-11.4 -1.4,-14.3 -0.9,0.7 -1.2,4.2 -1.7,5.7 -0.6,1.7 -1.2,3.6 -2.1,5 -0.7,1.1 -6.1,7.2 -7,7.2 -0.7,0 -1.6,-2.9 -1.6,-4.1 0,-4.7 3.3,-9.7 3.3,-13.4 v -0.6 c 0,-2.4 -1.9,-3.6 -3,-5.6 -0.6,-1 -2.7,-4.7 -3.7,-4.8 v 2.9 c 0,2.2 -0.5,5.6 -1.3,7.1 -0.4,0.8 -3.2,4.1 -4,4.1 -1,0 -3.9,-3.9 -3.9,-5.7 v -3.5 c 0,-4.1 4.1,-8.6 4.1,-12.6 v -0.2 c 0,-1.5 -0,-4 -1.4,-4.1 -0.7,8 -12.6,18.7 -12.6,21.8 0,4.4 3.9,9.2 3.9,15.9 v 2.2 c 0,0.7 -0.2,0.8 -0.2,1.4 -0.8,-0.2 -1.4,-1.3 -1.9,-2 -0.7,-0.8 -1.4,-1.1 -2.2,-1.7 -1.5,-1 -2.7,-2.3 -3.8,-3.7 -1.9,-2.5 -4.1,-6.7 -4.1,-10.9 -1.8,0.5 -3.3,6.3 -3.3,8.8 v 3.5 c 0,8.3 5.9,15.1 5.9,18.1 -3.2,-1.7 -6,-3.9 -8.5,-6.4 -1.2,-1.2 -5.5,-8.5 -6.2,-8.7 0,5.7 1.7,10.3 2.6,15.1 0.5,2.3 1.2,5.1 1.9,7.1 1,2.7 1.9,3.3 3.4,5.3 3,4 4.9,6 8.3,9.4 1.5,1.5 2.9,2.9 4.4,4.4 l 4.7,3.4 5.9,2.8 V 129.9 h -13 l 9.9,-11.5 -7.4,-0.1 9.8,-11.1 -6.6,-0.1 10.9,-17.3 0.1,-0.2 11.2,17.5 -6.1,-0 9.4,11 -7.6,0 10.1,11.7 -13.1,0.1 v 13 l 6,-3.4 z"
            }
        ], i["AC.IC.HAZARDOUS MATERIALS INCIDENT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 60.7,100.6 78.5,-0 -39.3,39.2 -39.2,-39.2 z M 127.6,87.8 c 0.6,0.4 6.1,5.9 6.1,6.2 V 100 h -6.1 V 87.8 z M 115.3,75.5 c 0.6,0.4 6.1,5.9 6.1,6.2 V 100 h -6.1 V 75.5 z M 90.8,69.5 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 100 H 90.8 V 69.5 z m -12.2,12.2 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 100 H 78.6 V 81.7 z m -6.3,6 0,12.2 H 66.4 V 94.2 c 0,-0.3 -0,-0.3 -0.1,-0.4 l 6,-6 z m 30.8,-24.5 6.2,6.1 c -0.2,0.4 -0.1,-0.1 -0.1,0.4 V 100 h -6.1 V 63.3 z M 56.7,100 100,143.3 143.3,100 100,56.7 56.7,100 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 103.1,63.3 6.2,6.1 c -0.2,0.4 -0.1,-0.1 -0.1,0.4 V 100 h -6.1 V 63.3 z m -30.8,24.5 0,12.2 H 66.4 V 94.2 c 0,-0.3 -0,-0.3 -0.1,-0.4 l 6,-6 z m 6.3,-6 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 100 H 78.6 V 81.7 z m 12.2,-12.2 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 100 H 90.8 V 69.5 z m 24.5,6 c 0.6,0.4 6.1,5.9 6.1,6.2 V 100 h -6.1 V 75.5 z m 12.3,12.3 c 0.6,0.4 6.1,5.9 6.1,6.2 V 100 h -6.1 V 87.8 z m -66.9,12.8 78.5,-0 -39.3,39.2 -39.2,-39.2 z"
            }
        ], i["AC.IC.CHEMICAL AGENT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 100.7,107.7 c -3.2,2e-5 -5.8,1 -7.6,3 -1.9,2 -2.8,4.7 -2.8,8.1 -2e-6,3.4 0.9,6.1 2.8,8.1 1.9,2 4.4,3 7.6,3 1.3,0 2.4,-0.2 3.6,-0.5 1.1,-0.3 2.2,-0.9 3.2,-1.5 l 0.1,-0.1 0,-0.1 0,-3 0,-0.5 -0.3,0.3 c -0.9,0.9 -1.9,1.5 -3,1.9 -1.1,0.4 -2.2,0.7 -3.4,0.7 -2.4,0 -4.1,-0.7 -5.3,-2.1 -1.2,-1.4 -1.9,-3.5 -1.9,-6.2 -4e-6,-2.7 0.6,-4.8 1.9,-6.2 1.2,-1.4 3,-2.1 5.3,-2.1 1.2,2e-5 2.3,0.2 3.4,0.6 1.1,0.4 2.1,1.1 3,1.9 l 0.3,0.3 0,-0.5 0,-3 -0.2,0 0.1,-0.2 c -1,-0.7 -2.1,-1.2 -3.2,-1.5 -1.1,-0.3 -2.3,-0.5 -3.6,-0.5 z M 92.7,64.2 h 14.7 v 33 c 0,8.2 12.9,9.6 12.4,21.8 -0.3,6.8 -7,18.6 -14.3,18.6 h -11 c -6.8,0 -14.6,-13.1 -14.3,-20 0.6,-10.6 12.4,-12.8 12.4,-20.4 v -33 z m -14.7,55 c 0,6.8 7.9,20.2 14.7,20.2 h 14.7 c 8.1,0 14.7,-13 14.7,-22 0,-11.8 -12.8,-13.6 -12.8,-22 V 60.6 H 90.8 V 95.4 c 0,7.8 -12.8,8.7 -12.8,23.9 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: E.fillColor.Unknown,
                d: "m 92.7,64.2 0,33 c 0,7.6 -11.9,9.8 -12.4,20.4 C 79.9,124.5 87.7,137.6 94.5,137.6 l 11,0 c 7.2,0 14,-11.8 14.3,-18.6 0.5,-12.2 -12.4,-13.6 -12.4,-21.8 l 0,-33 -14.7,0 z M 100.7,107.7 c 1.3,2e-5 2.5,0.2 3.6,0.5 1.1,0.3 2.2,0.8 3.2,1.5 l -0.1,0.2 0.2,0 0,3 0,0.5 -0.3,-0.3 c -0.9,-0.9 -1.9,-1.5 -3,-1.9 -1.1,-0.4 -2.2,-0.6 -3.4,-0.6 -2.4,2e-5 -4.1,0.7 -5.3,2.1 -1.2,1.4 -1.9,3.5 -1.9,6.2 -4e-6,2.7 0.6,4.8 1.9,6.2 1.2,1.4 3,2.1 5.3,2.1 1.2,0 2.3,-0.2 3.4,-0.7 1.1,-0.4 2.1,-1.1 3,-1.9 l 0.3,-0.3 0,0.5 0,3 0,0.1 -0.1,0.1 c -1,0.7 -2.1,1.2 -3.2,1.5 -1.1,0.3 -2.3,0.5 -3.6,0.5 -3.2,0 -5.8,-1 -7.6,-3 -1.9,-2 -2.8,-4.7 -2.8,-8.1 -2e-6,-3.4 0.9,-6.1 2.8,-8.1 1.9,-2 4.4,-3 7.6,-3 z"
            }
        ], i["AC.IC.CORROSIVE MATERIAL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 102.9,135.4 c 0.8,0 1.4,-0.8 1.4,-1.5 0,-0.7 -0.6,-1.5 -1.2,-1.5 H 102.3 c -0.5,0 -1.2,0.7 -1.2,1.4 v 0.3 c 0,0.8 0.6,1.4 1.4,1.4 H 102.9 z M 96.9,132.5 c 0,0.7 0.6,1.5 1.2,1.5 h 0.6 c 0.8,0 1.4,-0.8 1.4,-1.5 v -0.2 c 0,-0.7 -0.6,-1.5 -1.2,-1.5 H 98.1 c -0.6,0 -1.2,0.9 -1.2,1.5 v 0.2 z m 8.5,-0.9 c 1.3,0 2.2,-1.8 1.1,-2.8 -1,-1 -2.8,-0.2 -2.8,1.1 0,0.8 0.9,1.7 1.7,1.7 z m -6.2,-4.4 c 0,0.6 0.6,1.5 1.2,1.5 h 0.6 c 0.8,0 1.4,-0.6 1.4,-1.4 v -0.6 c 0,-0.5 -0.7,-1.2 -1.4,-1.2 h -0.3 c -0.8,0 -1.5,0.8 -1.5,1.6 z m -0.6,-4.1 c 0.6,0 1.2,-0.8 1.2,-1.5 0,-1 -0.7,-1.7 -1.7,-1.7 -0.6,0 -1.5,0.6 -1.5,1.2 v 0.6 c 0,0.7 0.7,1.4 1.2,1.4 h 0.8 V 123.1 z m 2.4,-2.7 c 0,0.6 0.7,1.5 1.2,1.5 h 0.8 c 0.4,0 1.2,-0.8 1.2,-1.2 v -0.8 c 0,-0.6 -0.8,-1.2 -1.5,-1.2 h -0.1 c -0.8,0 -1.5,0.8 -1.5,1.5 v 0.1 z m -2.7,-3.5 c 0.6,0 1.4,-0.8 1.4,-1.5 v -0.2 c 0,-2.2 -3.2,-1.8 -3.2,-0.3 v 0.8 c 0,0.7 1.1,1.2 1.8,1.2 z m 4.1,-3.6 c 0,2 3.3,1.9 3.2,-0.1 -0.1,-2.3 -3.2,-1.8 -3.2,-0.3 v 0.4 z m 4.7,-16.2 0,2.9 -3,-0.2 0.9,2.8 -1.1,0.1 -1.6,-0.9 -0.4,3 -1,-1.5 -3.3,1 -0.6,-3.2 -2,1.3 -0.6,-1.6 -2.5,0.4 1.5,-2.7 -0.6,-1.5 -22.2,0 0,12.4 59.2,0 0,-12.4 z M 94.3,85.2 v 1.4 c 0,4.4 2.1,8.7 5.7,9.4 3.7,0.8 7,-4.5 7,-8 v -1.5 c 0,-3 -2.1,-8.6 -3,-11.3 -0.5,-1.4 -3.1,-10.6 -3.9,-10.6 -0.8,0 -0.9,4.5 -1.1,5.4 -0.6,2.1 -0.9,3.2 -1.6,5.1 -0.8,2.3 -3.2,7.6 -3.2,10.1 l 0,0 z"
            }
        ], i["AC.IC.HAZARDOUS WHEN WET"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 60.6,100.5 78.8,-0 -39.4,39.4 L 60.6,100.5 z M 127.6,87.8 c 0.6,0.4 6.1,5.9 6.1,6.2 v 5.8 H 127.6 V 87.8 z M 115.3,75.5 c 0.6,0.4 6.1,5.9 6.1,6.2 v 18.1 h -6.1 V 75.5 z M 90.8,69.5 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 99.8 H 90.8 V 69.5 z M 78.6,81.7 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 99.8 H 78.6 V 81.7 z m -6.3,6 0,12.1 H 66.4 V 94.2 c 0,-0.3 -0,-0.3 -0.1,-0.4 l 6,-6 z m 30.8,-24.5 6.2,6.1 c -0.2,0.4 -0.1,-0.2 -0.1,0.4 v 30 h -6.1 V 63.3 z M 56.7,100 100,143.3 143.3,100 100,56.7 56.7,100 z m 41.2,25.3 c 0.2,1 0.6,1.6 1.6,1.8 l -0.8,0.6 c -1.3,-0.6 -1.3,-0.1 -1.7,-1.9 l 0.9,-0.4 z m -2.4,-1 c 0,2.9 1.3,4.9 4.2,4.9 h 0.9 c 1.9,0 3,-1 3.6,-2.3 0.9,-1.8 0.6,-3.1 -0.2,-4.6 -0.8,-1.4 -1.6,-2.3 -2.2,-3.8 -0.5,-1.2 -0.8,-3.8 -1.7,-4.4 C 99.6,118.1 95.5,122.5 95.5,124.2 z m -12.6,-9.4 c 0.4,0.9 0.4,1.4 1.5,1.7 l -0.6,0.6 C 82.2,116.7 82.6,116.5 82,115.3 l 0.9,-0.5 z m 1.6,3.8 H 86 c 2.3,0 3.7,-2.2 3.7,-4.6 0,-1.2 -1.9,-3.9 -2.6,-4.9 -0.9,-1.4 -1.2,-4.7 -2.2,-5.4 -0.2,3 -2.3,5.9 -3.6,8 -1.9,2.9 -0.4,6.9 3.1,6.9 z m 28.4,-3.8 c 0.2,1.6 0.9,1.1 1.5,2 l -0.8,0.3 c -1,-0.2 -1.7,-0.8 -1.8,-1.9 L 112.9,114.8 z m 2,-11.1 c -0.3,3.6 -2.2,5.6 -3.6,8.1 -1.7,3.1 -0.3,6.8 3.2,6.8 h 1.3 c 2.2,0 3.7,-1.7 3.7,-3.9 v -0.9 c 0,-1.4 -1.9,-3.8 -2.6,-4.9 -0.9,-1.4 -0.7,-4.4 -2,-5.2 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 112.9,114.8 c 0.2,1.6 0.9,1.1 1.5,2 l -0.8,0.3 c -1,-0.2 -1.7,-0.8 -1.8,-1.9 L 112.9,114.8 z m -30,0 c 0.4,0.9 0.4,1.4 1.5,1.7 l -0.6,0.6 C 82.2,116.7 82.6,116.5 82,115.3 l 0.9,-0.5 z m 15,10.4 c 0.2,1 0.6,1.6 1.6,1.8 l -0.8,0.6 c -1.3,-0.6 -1.3,-0.1 -1.7,-1.9 l 0.9,-0.4 z m 5.2,-62 6.2,6.1 c -0.2,0.4 -0.1,-0.2 -0.1,0.4 v 30 h -6.1 V 63.3 z m -30.8,24.5 0,12.1 H 66.4 V 94.2 c 0,-0.3 -0,-0.3 -0.1,-0.4 l 6,-6 z m 6.3,-6 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 99.8 H 78.6 V 81.7 z m 12.2,-12.2 c 0,-0.4 5.5,-5.8 6.1,-6.2 V 99.8 H 90.8 V 69.5 z m 24.5,6 c 0.6,0.4 6.1,5.9 6.1,6.2 v 18.1 h -6.1 V 75.5 z m 12.4,12.3 c 0.6,0.4 6.1,5.9 6.1,6.2 v 5.8 H 127.6 V 87.8 z m 11.7,12.6 -78.8,0 39.4,39.4 L 139.4,100.4 z M 85,103.7 c 1,0.7 1.3,4 2.2,5.4 0.6,1 2.6,3.6 2.6,4.9 0,2.4 -1.4,4.6 -3.7,4.6 l -1.5,0 c -3.5,0 -5,-4 -3.1,-6.9 1.3,-2.1 3.4,-5 3.6,-8 z m 29.8,0 c 1.3,0.9 1.2,3.8 2,5.2 0.7,1.1 2.6,3.5 2.6,4.9 l 0,0.9 c 0,2.2 -1.6,3.9 -3.7,3.9 l -1.3,0 c -3.5,0 -4.9,-3.7 -3.2,-6.8 1.4,-2.5 3.4,-4.5 3.7,-8.1 z M 100,114.1 c 0.8,0.6 1.2,3.1 1.7,4.3 0.6,1.5 1.5,2.4 2.2,3.8 0.8,1.5 1.2,2.7 0.3,4.6 -0.6,1.3 -1.7,2.3 -3.6,2.3 l -0.9,0 c -2.8,0 -4.2,-2 -4.2,-4.9 0,-1.7 4.1,-6.1 4.5,-10.1 z"
            }
        ], i["AC.IC.EXPLOSIVE MATERIAL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 96.5,104.6 0,0.2 -0.2,0 0,4 0,0.2 0.2,0 3.2,0 0.2,0 0,-0.2 0,-4 0,-0.2 -0.2,0 -3.2,0 z m 2.3,-20 c -1.1,2.4e-5 -2.2,0.1 -3.2,0.5 -1,0.3 -2,0.8 -3,1.4 l -0.1,0.1 0,0.1 0,3 0,0.4 0.3,-0.2 c 1,-0.7 2,-1.2 2.9,-1.6 0.9,-0.4 1.8,-0.5 2.6,-0.5 1.1,2.1e-5 2,0.3 2.6,0.8 0.7,0.5 1,1.2 1,2.1 -10e-6,0.5 -0.1,1 -0.4,1.4 -0.2,0.5 -0.7,1 -1.3,1.5 l -0,0 -1.4,1.4 c -1,0.9 -1.6,1.7 -1.9,2.5 -0.3,0.7 -0.5,1.6 -0.5,2.7 l 0,2.4 0,0.2 0.2,0 3,0 0,-0.2 0.2,0 0,-1.9 c -8e-6,-0.5 0,-1 0,-1.3 0,-0.3 0.1,-0.6 0.1,-0.8 0.1,-0.2 0.2,-0.5 0.4,-0.8 0.2,-0.3 0.5,-0.7 1,-1.1 l 1.4,-1.4 c 1,-0.9 1.6,-1.7 2,-2.5 0.4,-0.8 0.6,-1.6 0.6,-2.4 -2e-5,-1.7 -0.6,-3.1 -1.8,-4.2 -1.2,-1.1 -2.8,-1.6 -4.8,-1.6 z m 4.8,-31.1 -1.5,4.5 -4.3,12.9 -4.5,-7 -1.6,-2.5 -0.3,2.9 -1.3,14.4 -9.5,-10.7 -2.8,-3.2 1.1,4.1 3.4,12.9 -13.1,-0.7 -0.7,-0 -0.3,0.6 -0.1,0.2 -0.4,0.8 0.7,0.5 11.3,8.1 -20.1,1.4 -5.6,0.4 5.4,1.6 18,5.3 -12.3,7.1 -0.8,0.4 0.3,0.8 0.1,0.2 0.3,0.7 0.8,-0.1 16.1,-2 -4.8,8.3 -1.5,2.6 2.7,-1.1 8.8,-3.7 -3.4,14.5 -1.1,4.5 2.8,-3.7 8.9,-11.6 5,19.2 0.2,0.8 0.8,0 0.4,0 0.9,0 0.1,-1 0.9,-18.7 9.2,11.2 2.6,3.2 -0.9,-4 -3.3,-15.2 10.6,5.9 4.7,2.6 -3.4,-4.1 -5.5,-6.6 15.6,4.4 4,1.2 -3.1,-2.9 -10.7,-9.9 13.7,-2.1 4.6,-0.7 -4.5,-1.2 -15.5,-4.3 18.9,-9.6 4.7,-2.4 -5.2,0.5 -17.1,1.6 6.7,-10.8 2,-3.2 -3.3,1.8 -14.6,7.9 5.2,-16.5 1.7,-5.5 -3.5,4.5 -10.6,14 -1.7,-18.8 -0.4,-4.8 z m -1.1,9.7 1.5,16.6 0.2,2.6 1.6,-2 8.7,-11.5 -4.2,13.4 -0.8,2.4 2.2,-1.2 13.4,-7.3 -5.8,9.3 -1.1,1.7 2,-0.2 13.9,-1.3 -16.5,8.4 -2.3,1.2 2.5,0.7 13.5,3.7 -11.2,1.7 -2,0.3 1.5,1.4 9.1,8.4 -14.6,-4.2 -3.1,-0.9 2.1,2.5 4.2,5 -7.8,-4.3 -1.9,-1.1 0.5,2.2 2.9,13.3 -8.2,-10 -1.6,-2 -0.1,2.6 -0.8,16.1 -4.2,-16.3 -0.5,-2 -1.2,1.6 -7.3,9.5 2.8,-11.9 0.4,-1.9 -1.8,0.7 -7.9,3.3 4.3,-7.4 1,-1.7 -2,0.2 -13.9,1.7 10.3,-6 0.5,-0.3 0,-0.6 0,-0.3 0,-0.8 -0.7,-0.2 -14.5,-4.2 17.3,-1.2 2.8,-0.2 -2.3,-1.6 -11,-8 11.5,0.6 1.4,0.1 -0.3,-1.3 -2.7,-10.1 8.2,9.3 1.5,1.8 0.2,-2.3 1.3,-13.8 4,6.3 1.1,1.8 0.7,-2 3.4,-10.3 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 102.5 63.2 L 99 73.5 L 98.4 75.5 L 97.3 73.7 L 93.2 67.4 L 91.9 81.3 L 91.7 83.6 L 90.2 81.8 L 82 72.5 L 84.7 82.7 L 85.1 84 L 83.7 83.9 L 72.2 83.4 L 83.2 91.3 L 85.5 93 L 82.7 93.2 L 65.4 94.3 L 79.9 98.5 L 80.7 98.8 L 80.7 99.5 L 80.7 99.8 L 80.7 100.3 L 80.2 100.7 L 69.8 106.6 L 83.8 104.9 L 85.8 104.7 L 84.8 106.4 L 80.4 113.8 L 88.3 110.6 L 90.1 109.8 L 89.7 111.7 L 86.9 123.6 L 94.2 114.1 L 95.5 112.5 L 96 114.4 L 100.2 130.8 L 101 114.6 L 101.2 112 L 102.8 114 L 111 124 L 108.1 110.7 L 107.6 108.5 L 109.6 109.6 L 117.3 113.9 L 113.2 108.9 L 111.1 106.4 L 114.3 107.3 L 128.9 111.5 L 119.7 103.1 L 118.2 101.7 L 120.3 101.3 L 131.4 99.6 L 117.9 95.9 L 115.4 95.2 L 117.8 94 L 134.3 85.6 L 120.3 86.9 L 118.3 87.1 L 119.4 85.4 L 125.2 76.1 L 111.8 83.3 L 109.6 84.5 L 110.3 82.2 L 114.5 68.8 L 105.8 80.3 L 104.3 82.3 L 104 79.8 L 102.5 63.2 z M 98.8 84.5 C 100.8 84.5 102.4 85.1 103.6 86.1 C 104.8 87.2 105.5 88.6 105.5 90.3 C 105.5 91.2 105.3 92 104.9 92.7 C 104.5 93.5 103.8 94.3 102.8 95.2 L 101.5 96.6 C 101 97.1 100.6 97.4 100.4 97.7 C 100.2 98 100.1 98.2 100 98.5 C 100 98.7 99.9 98.9 99.9 99.2 C 99.8 99.5 99.8 100 99.8 100.5 L 99.8 102.4 L 99.7 102.4 L 99.7 102.7 L 96.6 102.7 L 96.4 102.7 L 96.4 102.4 L 96.4 100 C 96.4 98.9 96.6 98 96.9 97.3 C 97.2 96.6 97.9 95.8 98.8 94.8 L 100.2 93.4 C 100.8 92.9 101.2 92.4 101.5 91.9 C 101.7 91.4 101.9 91 101.9 90.5 C 101.9 89.6 101.5 88.9 100.9 88.3 C 100.2 87.8 99.4 87.5 98.3 87.5 C 97.5 87.5 96.6 87.7 95.7 88.1 C 94.8 88.5 93.8 89 92.8 89.7 L 92.5 89.9 L 92.5 89.5 L 92.5 86.5 L 92.5 86.4 L 92.6 86.3 C 93.6 85.7 94.6 85.3 95.6 85 C 96.7 84.7 97.7 84.5 98.8 84.5 z M 96.5 104.6 L 99.8 104.6 L 99.9 104.6 L 99.9 104.8 L 99.9 108.8 L 99.9 109 L 99.8 109 L 96.5 109 L 96.3 109 L 96.3 108.8 L 96.3 104.8 L 96.5 104.8 L 96.5 104.6 z"
            }
        ], i["AC.IC.FLAMMABLE GAS"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 93.3,82.5 c 0,-4.3 13.8,-4.3 13.8,0 v 55.6 c 0,1.3 -4.4,1.2 -5.9,1.2 h -2 c -1.5,0 -5.9,0.1 -5.9,-1.2 V 82.5 l 4e-4,0 z m 5.3,-20.6 h -6.5 v 2.9 h 6.3 v 3.2 h -3.7 v 2 h 3.7 v 5.3 h -4.6 v 4.5 c -1.1,0.3 -2,1.6 -2,3 v 54.8 c 0,3.3 3.7,3.2 7.1,3.2 h 2.4 c 3.4,0 7.1,0.2 7.1,-3.2 V 83.1 c 0,-2.8 -1.8,-2.8 -1.8,-3.7 v -4.1 h -4.7 v -10.4 h 6.3 v -3 h -6.7 v -2.5 h -2.9 v 2.5 l 0,0 z m 21.8,32.3 v 0.6 c 0,2.2 2.3,5.1 1.6,8.1 -1.3,-0.3 -3.1,-2 -3.8,-3 -0.3,-0.4 -0.9,-1.7 -1.2,-2.2 -0.4,-0.9 -0.4,-2.3 -0.7,-2.8 -1.1,0.8 -1.6,3.5 -1.6,5.5 v 0.2 c 0,3.2 2.4,7.5 3.8,9.6 2,3 6.3,3.3 8.4,5.1 1.6,-0.9 6.9,-3.7 7.7,-4.9 0.9,-1.2 3.2,-7.4 3,-9.6 l -0.7,-5.9 h -0.4 c -0,3.2 -2.7,7.6 -5.5,7.9 v -2 c 0,-1.7 1.4,-4 1.4,-6.1 v -0.2 c 0,-0.9 -2.4,-4.4 -3.2,-4.7 0,3.4 -0.3,5.5 -2.5,6.7 -0.8,-0.7 -1.8,-1.6 -1.8,-3.1 v -1.2 c 0,-2.1 2,-4.1 2,-6.1 0,-0.9 -0.1,-1.6 -0.6,-2 -0.9,3.8 -5.9,8.9 -5.9,10.2 z m -52.7,0 v 0.4 c 0,1.2 1.8,4.3 1.8,6.1 v 2.2 c -2.4,-0.2 -5.7,-5 -5.7,-8.1 -1.7,1.1 -1.5,4.3 -1.4,6.7 0.1,2.4 1.3,4.7 2.2,6.3 1.3,2.6 1.6,2.9 4,4.5 0.6,0.4 5.3,2.8 5.9,2.8 1.2,0 6.8,-3.9 7.5,-4.7 0.9,-1 3.3,-7.3 3.1,-9.1 l -0.6,-6.5 h -0.4 c -0.5,2.3 -0.3,3.3 -1.6,5 -0.6,0.8 -2.7,2.7 -3.8,2.8 0,-0.9 -0.2,-0.7 -0.2,-1.4 0,-1.8 1.4,-4.3 1.7,-6.6 0.1,-1 -2.6,-4.6 -3.3,-5 0.4,2 -0.8,6.5 -2.4,6.5 h -0.2 c -0.9,0 -1.8,-2.2 -1.8,-3.4 0,-3.9 2.6,-4.5 1.6,-8.8 -0,0 -2.2,4.5 -2.9,5.4 -0.6,0.6 -3.5,4.3 -3.5,4.9 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 93.3,82.5 c 0,-4.3 13.8,-4.3 13.8,0 v 55.6 c 0,1.3 -4.4,1.2 -5.9,1.2 h -2 c -1.5,0 -5.9,0.1 -5.9,-1.2 V 82.5 l 4e-4,0 z"
            }
        ], i["AC.IC.FLAMMABLE LIQUID"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 100.1,135.4 c -7.4,0 -11.3,-5.4 -13.1,-11.1 -2.1,-6.7 -2.4,-14.4 0.8,-20.2 5.9,-10.6 10.7,-21.6 11.9,-36.7 4,4.6 3.6,17.4 6.3,23.9 2.6,6.5 8.9,13.4 8.9,21 v 1.7 c 0,10 -4.5,21.3 -14.2,21.3 h -0.7 v 0 z m -0.6,1.7 h 1.9 c 10.1,0 15.4,-11.7 15.4,-21.9 v -3 c 0,-9.5 -7.7,-15.8 -9.9,-24.1 -2.4,-8.9 -1.7,-21.2 -9.1,-25.1 0,8.6 -1.3,16 -3.6,22.4 -1.2,3.3 -2.4,6.2 -3.6,9.5 -1.2,2.7 -3.1,5.8 -4.5,8.6 -1.4,2.7 -3,6.1 -2.6,10.5 0.4,4.4 0.6,7.6 1.8,11.3 2,5.9 6.7,11.9 14.3,11.9 z M 122,87 v 0.2 c 0,2.3 2.4,5.5 1.7,8.6 -1.3,-0.1 -3.5,-2.2 -4.1,-3.2 -0.5,-0.9 -0.9,-1.3 -1.2,-2.4 -0.3,-0.7 -0.6,-2.6 -0.8,-3 -1.2,0.9 -1.7,4 -1.7,6.1 0,3.2 2.6,8.4 4,10.4 1,1.3 2.5,2.3 4.1,3.1 0.6,0.3 4.8,2.4 5,2.4 0.9,0 7.6,-4.4 8.2,-5.1 0.9,-1.1 3.5,-8 3.3,-10.1 l -0.7,-6.8 h -0.4 c -0.1,3.5 -2.8,8.2 -5.9,8.4 0,0 0.3,-3.5 0.5,-4.4 0.3,-1.3 1,-2.9 1,-4.3 V 86.8 c 0,-1 -2.7,-4.6 -3.4,-5.1 0,3.7 -0.2,6 -2.7,7.2 -0.7,-0.6 -1.9,-1.7 -1.9,-3 v -1.4 c 0,-2.3 2.1,-4.7 2.1,-6.5 l 0,-0.2 -0.3,-1.9 c -1,0.2 -1.1,2 -1.5,2.9 -0.5,0.9 -1.2,1.9 -1.8,2.6 -0.9,1.2 -3.5,4.1 -3.5,5.7 z m -56.6,0 c 0,1.3 1.9,4.7 1.9,7 v 1.9 c -2.6,-0.2 -6.1,-5.2 -6.1,-8.6 -3.4,2.4 -0.7,11.4 0.9,14.1 1.5,2.6 1.8,3 4.4,4.7 0.4,0.3 6.1,3.1 6.2,3.1 1.3,0 4.1,-2.5 5.3,-3.2 2.5,-1.2 2.9,-1.7 4.2,-4.3 0.4,-0.9 1.6,-5.4 1.9,-6.6 0.4,-2.1 -0.5,-5.8 -0.5,-7.9 h -0.5 c -0.3,3.5 -2.9,8.4 -5.9,8.4 -0,-0.9 -0.2,-0.5 -0.2,-1.2 0,-2 1.5,-4.9 1.8,-7.1 0.2,-1.2 -2.7,-5.2 -3.5,-5.4 1,2.1 -1.1,6.1 -2.7,7 -0.9,-0.6 -1.9,-2.2 -1.9,-3.6 v -0.4 c 0,-3.7 2.7,-4.6 1.7,-9.1 -0.5,0.4 -0.8,2 -1.4,3 -0.7,1 -1,1.7 -1.8,2.7 -0.8,1 -3.6,4.2 -3.6,5.5 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 100.1,135.4 c -7.4,0 -11.3,-5.4 -13.1,-11.1 -2.1,-6.7 -2.4,-14.4 0.8,-20.2 5.9,-10.6 10.7,-21.6 11.9,-36.7 4,4.6 3.6,17.4 6.3,23.9 2.6,6.5 8.9,13.4 8.9,21 v 1.7 c 0,10 -4.5,21.3 -14.2,21.3 h -0.7 v 0 z"
            }
        ], i["AC.IC.FLAMMABLE SOLID"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 68.6,102 c 0,-2 1.9,-4.2 1.9,-6.3 v -1.5 c 0,-0.6 -0.1,-0.4 -0.4,-0.7 -0.8,3.7 -6.1,9.1 -6.1,10.4 0,1.6 1.9,4.6 1.9,8.2 -2.6,-0.2 -5.9,-4.9 -5.9,-8 -0.8,0.9 -1.5,2.6 -1.5,4.3 0,4.4 1.7,8.1 3.5,10.6 0.8,1.2 7,5.2 8.7,5.2 1.1,0 6.7,-3.7 7.3,-4.4 0.9,-1.2 3.2,-6.8 3.2,-8.6 0,-1.6 -0,-6.6 -0.9,-7.2 -1.1,4.8 -1.5,5.9 -5.4,8.1 0,-4.3 1.3,-5.7 1.3,-8.2 v -0.4 c 0,-0.1 -2.8,-4.4 -3,-4.6 0,2.4 -0.7,6.7 -2.6,6.7 -1,8e-4 -2,-2.4 -2,-3.7 z m 60.3,-0.4 c 0,-1.7 2.2,-4.5 2.2,-6.3 0,-0.7 -0.2,-1.6 -0.7,-1.9 -0.9,3.7 -5.9,8.9 -5.9,10.2 v 0.4 c 0,1.9 1.5,3.7 1.5,6.1 v 2.2 c -2.3,-0.6 -5.6,-4.9 -5.7,-8 -1,0.7 -1.5,3 -1.5,4.8 v 1.1 c 0,2.8 2.5,7.7 3.8,9.5 2,2.7 6.4,3.1 8.4,4.8 2.1,-1.1 3.1,-1.8 5.1,-2.9 2.6,-1.6 2.2,-1.5 3.5,-4.3 0.7,-1.4 1.7,-4.5 1.8,-6.2 0.1,-1.5 -0.1,-6.4 -0.9,-7 -0.8,3.5 -2.1,7.1 -5.4,8 -0,-0.7 -0.2,-0.7 -0.2,-1.5 v -0.2 c 0,-1.8 1.7,-4.9 1.5,-6.4 -0.1,-0.8 -2.5,-4.8 -3,-5.1 0,2.8 -0.5,6.7 -3,6.7 -0.4,-1.3 -1.5,-1 -1.5,-3.9 z m -35.6,1.9 v -20 l 20,-0.4 v 19.4 l -20,1 z m -13.9,-7.6 0,-16.8 10.8,4 v 19.8 c -1.2,-0.7 -10.9,-6.2 -10.9,-7 z m 1.5,-18.4 c 5.7,0 11.4,0 17.2,0 2.1,0 12.1,3.1 13.2,3.9 l -3.7,0.3 H 92.6 c -0.9,0 -11.1,-3.7 -11.7,-4.1 z m -3.5,-1.5 0,14.7 -0.3,6.7 c 2.2,1.2 5.3,3 7.5,4.5 1.9,1.2 5.5,4 8.1,4 7.6,0 15.3,-1.1 23.1,-1.1 l -0,-23.6 c -1,-0.5 -14.8,-5.4 -15.2,-5.4 l -3.9,-0.1 -19.3,0.4 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 80.9,77.5 c 5.7,0 11.4,0 17.2,0 2.1,0 12.1,3.1 13.2,3.9 l -3.7,0.3 H 92.6 c -0.9,0 -11.1,-3.7 -11.7,-4.1 z m -1.5,18.4 0,-16.8 10.8,4 v 19.8 c -1.2,-0.7 -10.9,-6.2 -10.9,-7 z m 13.9,7.6 v -20 l 20,-0.4 v 19.4 l -20,1 z"
            }
        ], i["AC.IC.NON-FLAMMABLE GAS"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 92.7,81.3 c 0,-4.6 14.7,-4.6 14.7,0 v 59.4 c 0,1.4 -4.7,1.3 -6.3,1.3 h -2.1 c -1.6,0 -6.3,0.1 -6.3,-1.3 V 81.3 z m 5.7,-22 h -7 v 3.2 h 6.7 v 3.3 h -4 v 2.1 h 4 v 5.7 h -4.8 v 4.8 c -1.1,0.3 -2.1,1.7 -2.1,3.1 v 58.6 c 0,3.5 4,3.3 7.6,3.3 h 2.5 c 3.6,0 7.6,0.2 7.6,-3.3 V 81.9 c 0,-3 -1.9,-3 -1.9,-4 v -4.4 h -5 v -11.1 h 6.7 v -3.1 h -7.2 v -2.7 h -3.1 v 2.7 l -4e-4,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 92.7,81.3 c 0,-4.6 14.7,-4.6 14.7,0 v 59.4 c 0,1.4 -4.7,1.3 -6.3,1.3 h -2.1 c -1.6,0 -6.3,0.1 -6.3,-1.3 V 81.3 z"
            }
        ], i["AC.IC.ORGANIC PEROXIDE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 132.1,128.2 v 6.2 l -36.6,2.2 v -6.7 l 0.6,0.1 36,-1.7 z m -63.8,-11.1 c 2.6,1.7 26.1,12.1 26.1,13.2 v 5.9 l -0.1,0.2 -26,-14.7 v -4.6 z m 61.1,10 c -4.7,0 -33,2.1 -34.6,1.5 -1.8,-0.7 -23.8,-11.4 -24.4,-12 3.8,0 7.5,0 11.3,0 2.9,0 8.8,-0.8 10,1.1 l -9,0.6 2.1,0.7 v 0.4 h -1.2 l -1.8,0.2 c 2,1.3 18.3,5.2 22.4,5.2 h 1.9 c 4.8,0 9.2,-1.3 13,-1.4 0.7,0 9.9,3.3 10.4,3.7 z m -25.4,-23.2 1.1,9.4 5.4,-6.8 -2.5,8.2 7.7,-4.3 -3.7,5.9 8.4,-0.8 -9.2,4.7 8.1,2.6 -14.4,1.7 c -3.3,0.2 -19,-3.7 -20.5,-4.8 l 10.3,-0.6 -6.2,-4.5 6.8,0.1 -1.7,-5.9 5.1,5.2 0.7,-7.5 2.6,3.9 2.1,-6.6 z m 0.7,-2.2 -0.1,-0.6 h -0.3 l -1.8,6.2 -0.4,-0 -2.4,-3.7 -0,2.1 -0.7,-1.1 -0.6,6.2 -4.9,-5.4 0.6,2.6 -1.5,-1.2 1.8,6.2 -2.5,0 -4,-0.2 1.5,1.1 -2.4,-0.1 1.5,1.4 h -21.3 c -0.1,0.5 -0.2,0.5 -0.2,1.1 v 5 c 0,1.6 4.8,3.7 6.2,4.4 2.3,1.3 4.6,2.4 6.9,3.8 4.4,2.7 9.2,5 13.7,7.6 1.8,1.1 6.8,0.5 9.6,0.2 2.8,-0.3 7.2,-0.2 9.9,-0.7 2.8,-0.5 7,-0.4 9.9,-0.7 2.7,-0.4 7.4,-0.6 10,-0.7 v -7.9 c 0,-0.9 -5.3,-2.4 -6.4,-2.8 -1.6,-0.5 -5.7,-1.9 -6.8,-2.6 l 2.9,-0.3 -8.4,-2.2 0,-0.4 9.2,-4.7 -1.5,0.2 1.7,-1.1 -10,1 3.9,-6.6 -8.1,4.7 2.9,-10 -6.4,8.4 -1.1,-11.1 -0.6,1.9 z m 1.1,-6.2 c -5.6,0 -9.6,-3.4 -9.6,-9 v -1.1 c 0,-4.8 9,-12.5 9,-21.1 2.8,3.2 2.2,7.6 4.3,11 1.2,1.9 5.3,7.8 5.3,9.9 v 1.1 c 0,5.3 -3.7,9.2 -9,9.2 z m -10.9,-10 v 1.1 c 0,13.7 21.1,13.2 21.1,0.8 v -2.1 c 0,-3.5 -4.5,-8.3 -5.9,-11.7 -2.2,-5.1 -1.1,-8.8 -6.2,-11.6 0,11.2 -9,17.6 -9,23.5 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 105.7,95.5 c -5.6,0 -9.6,-3.4 -9.6,-9 v -1.1 c 0,-4.8 9,-12.5 9,-21.1 2.8,3.2 2.2,7.6 4.3,11 1.2,1.9 5.3,7.8 5.3,9.9 v 1.1 c 0,5.3 -3.7,9.2 -9,9.2 z m -1.8,8.4 1.1,9.4 5.4,-6.8 -2.5,8.2 7.7,-4.3 -3.7,5.9 8.4,-0.8 -9.2,4.7 8.1,2.6 -14.4,1.7 c -3.3,0.2 -19,-3.7 -20.5,-4.8 l 10.3,-0.6 -6.2,-4.5 6.8,0.1 -1.7,-5.9 5.1,5.2 0.7,-7.5 2.6,3.9 2.1,-6.6 z m -35.6,13.2 c 2.6,1.7 26.1,12.1 26.1,13.2 v 5.9 l -0.1,0.2 -26,-14.7 v -4.6 z m 63.8,11.1 v 6.2 l -36.6,2.2 v -6.7 l 0.6,0.1 36,-1.7 z m -2.7,-1.1 c -4.7,0 -33,2.1 -34.6,1.5 -1.8,-0.7 -23.8,-11.4 -24.4,-12 3.8,0 7.5,0 11.3,0 2.9,0 8.8,-0.8 10,1.1 l -9,0.6 2.1,0.7 v 0.4 h -1.2 l -1.8,0.2 c 2,1.3 18.3,5.2 22.4,5.2 h 1.9 c 4.8,0 9.2,-1.3 13,-1.4 0.7,0 9.9,3.3 10.4,3.7 z"
            }
        ], i["AC.IC.OXIDIZER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 80.9,135.3 0,0.2 0,4.2 0,0.2 0.2,0 40.7,0 0.2,0 0,-0.2 0,-4.2 0,-0.2 -0.2,0 -40.7,0 -0.2,0 z m 6.5,-20.7 c 0,-7.4 6.1,-14 13.4,-14 h 1.1 c 7.5,0 13.6,6.6 13.6,14 0,7.1 -6.2,13.9 -13.2,13.9 h -1.9 c -6.8,-0 -13,-6.8 -13,-13.9 z m 12.8,-35.9 c -0.7,0 -2.1,-2.1 -2.3,-2.9 -0.3,-1.2 -0.4,-3 0,-4.4 0.5,-2.1 2.8,-5.9 2.8,-7.5 0,-1.1 -0.1,-3 -1.3,-3.1 -1,4.4 -2.1,4.9 -4.1,8 -1,1.5 -4.7,5.8 -4.7,7.3 v 0.4 c 0,2.4 3.1,8.1 2.7,10.5 l -0.2,1.7 c -3.5,-0.8 -8.1,-7.3 -8.1,-12 -1.4,0.1 -2.5,4.4 -2.5,6.1 v 2.9 c 0,5.7 3.3,8.3 4.2,12 -2.7,-1.4 -4,-2.2 -5.9,-4.4 -1.1,-1.2 -3.7,-5.6 -4.1,-5.9 -1.1,2.4 1.7,10.3 2.4,12.1 0.7,1.7 1.4,3.5 2.3,5 1.1,1.8 2.2,2.6 3.2,4.1 0,1.7 -0.5,2.4 -0.6,4.7 -0,1.8 -0,2.6 0.2,4.6 0.2,2.1 2.1,6.1 3.2,7.3 2.4,2.6 2.4,2.8 5.6,4.8 2,1.3 4.9,2.2 8.1,2.2 h 0.6 c 6.4,0 11.4,-3.5 14.2,-7.2 3.8,-5.2 3.8,-9.9 2.2,-16.7 3.5,-6.6 5.9,-9.3 5.9,-19.7 v -0.4 l -0.4,-4 c -0.1,0 -3.3,6.2 -3.8,7 -1,1.5 -3.7,4.8 -5.7,5 0.1,-3.2 2.1,-6.2 2.1,-9.4 v -2.2 l -1.1,-8 c -1,0.7 -1.5,5.9 -3,7.7 -0.4,0.5 -5.6,5.5 -5.6,3.6 v -1.7 c 0,-3.1 2.1,-6.3 2.1,-9 v -1.3 c 0,-0.8 -3.9,-6.5 -4.6,-6.9 0,2.3 -0.2,4.4 -0.7,6.2 -0.3,1.1 -2,3.7 -3,3.7 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 87.4,114.5 c 0,-7.4 6.1,-14 13.4,-14 h 1.1 c 7.5,0 13.6,6.6 13.6,14 0,7.1 -6.2,13.9 -13.2,13.9 h -1.9 c -6.8,-0 -13,-6.8 -13,-13.9 z"
            }
        ], i["AC.IC.RADIOACTIVE MATERIAL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 83.7,130.4 c -10.1,-5.6 -16.6,-17 -16.4,-28.5 l 17.8,-0 c -0.2,5 3.1,10.7 7.5,13.1 l -9,15.4 z m 49.1,-28.2 c 0.2,11.5 -6.4,22.9 -16.4,28.5 l -9,-15.4 c 4.4,-2.4 7.7,-8.1 7.6,-13.1 l 17.8,0 z M 83.5,73.8 c 9.9,-5.9 23,-5.9 32.9,0 l -8.9,15.5 c -4.3,-2.6 -10.9,-2.6 -15.1,0 l -8.9,-15.5 z m 26.5,28.5 c 0,5.5 -4.4,9.9 -9.9,9.9 -5.5,0 -9.9,-4.4 -9.9,-9.9 0,-5.5 4.4,-9.9 9.9,-9.9 5.5,0 9.9,4.4 9.9,9.9 z"
            }
        ], i["AC.IC.SPONTANEOUSLY COMBUSTIBLE MATERIAL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 101.2,128.4 -2.1,0 0,12.6 2.1,0 z m 26.5,0.6 -8.7,-8.6 -1.2,1.2 8.7,8.7 z m -45,-7.5 -1.3,-1.3 -8.8,8.8 1.3,1.4 z m 55.5,-19.7 -12.2,0 0,1.9 12.2,0 z m -63.3,0 -13.1,0 0,1.9 12.8,0 z m 52.8,-25.3 -1.3,-1.2 -9,8.7 1.5,1.5 z m -46.1,9.1 1.4,-1.5 -9.3,-9.2 -0,0.2 -1.2,1.3 z m 19.5,-26.5 -2.1,0 0,9.7 2.1,0 z M 91.7,88 v 0.6 c 0,0.5 1.4,4.3 1.7,5.1 0.7,2.2 0.7,3.4 0.7,5.7 -1.2,-0.1 -4.4,-3 -5.1,-4 -1.7,-2.5 -1.7,-3.4 -2.5,-6.7 -0.9,0.7 -1.9,3.8 -1.9,5.5 v 2.3 c 0,5.6 3.6,8.4 3.8,11.1 -0.9,-0.2 -4.8,-3.2 -5.4,-3.8 -0.7,-0.8 -3.3,-5.3 -3.8,-5.4 0,3.9 1.1,6.9 2.1,9.7 0.6,1.5 1.2,2.9 1.7,4.2 0.8,2.2 1.4,2 2.6,3.5 2.9,3.6 9.4,8.3 15.7,8.3 h 0.8 c 2.2,0 6.4,-1.7 7.9,-2.6 2.4,-1.3 4.5,-2.7 6,-4.8 2.8,-3.8 5.3,-9.3 5.3,-16 v -2.7 l -0.2,-2.3 h -0.4 c -1.1,4.7 -4.2,8.4 -8,10.5 0,-3.6 1.3,-5.3 1.9,-8.4 0.4,-2.4 -1,-6.9 -1,-9.2 -0.4,0.3 -1.2,5.4 -2.5,7 -0.3,0.4 -5.1,5.2 -5.1,3.1 v -2.1 c 0,-3 1.9,-4.8 1.9,-8.2 0,-0.8 -3.5,-6 -4.1,-6.3 l 0.1,0.9 c 0,1.2 -0.4,4.1 -0.7,5 -0.2,0.5 -2.3,3 -2.6,3 -1.2,0 -2.5,-2.9 -2.5,-4.4 v -1.1 c 0,-2.9 2.8,-6.1 2.6,-8 l -0.5,-2.9 c -0.5,0.4 -1.2,3 -1.6,3.9 -0.6,1.3 -1.4,2.2 -2.2,3.2 C 95.4,82.4 91.7,87.1 91.7,88 z"
            }
        ], i["AC.IC.UNEXPLODED ORDNANCE"] = a("UXO"), i["AC.IC.TOXIC INFECTIOUS MATERIAL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 104.6,116.2 c 0,-3.6 0.9,-4.6 1.5,-7.3 l -2.5,-1.2 c -2.4,2.1 -4.4,1.6 -6.8,0 l -2.5,1.4 c 0.2,2.6 2,3.9 1.5,8.7 -0.4,3.1 -1.1,5.8 -2.6,7.8 -2.9,3.9 -7,7.4 -13.7,7.4 h -1 c -4.7,0 -10.2,-3.2 -12,-6 l -1.2,0.6 c 3.3,4.9 11.4,10 19.8,10 h 0.2 c 6.4,0 10.9,-2.7 14.8,-5.3 3.7,2.5 7.6,5 13.8,5 h 3 c 3.8,0 8.2,-1.6 10.6,-3.2 1.8,-1.2 6.7,-4.5 7.2,-6.6 -1.1,-0.3 -0.5,-0.5 -1.3,-0.5 -0.5,0 -1.7,1.9 -2.2,2.3 -0.8,0.6 -1.8,1.1 -2.6,1.6 -1.4,0.9 -4.7,1.8 -7,1.8 h -1.8 c -7.9,0 -15.3,-7.7 -15.3,-15.8 v -0.8 z m 2.3,3.5 2.5,4.3 c 3.2,-0.8 7.7,-5.2 9.3,-7.8 2.2,-3.7 3.5,-7.8 3.5,-13.8 h -5.5 c 0.1,5.2 -0.1,7.2 -2.5,10.8 -1.2,1.8 -1.7,2.1 -3.2,3.6 -1,1 -3.6,2.2 -4.1,2.9 z m -28.6,-13.8 c 0,7.4 6.8,16.7 12.5,18 l 2.3,-4.5 c -6.5,-3.4 -9.5,-8 -9.5,-17.1 h -5.3 v 3.5 z m -2.5,-17 v 1 c 0,0.5 -5,3.2 -5.8,3.8 -1.6,1.1 -3.5,3.2 -4.7,4.8 -2.8,3.6 -4.8,8.1 -4.8,14.2 0,4.4 1,6 1.8,9.4 l 1.2,-0.6 c -0.1,-1.5 -0.8,-2.3 -0.8,-4 v -2 c 0,-7.8 7.9,-15.6 16,-15.6 h 1.8 c 2.6,0 5.9,1.3 7.5,2.2 2.2,1.3 3.6,3.6 5.3,4.8 l 2.3,-1 v -1.8 c 0,-2 1.6,-3.9 3.3,-4.3 v -3 c -7.6,-0.2 -15.3,-7.8 -15.3,-15.5 v -1.5 c 0,-4.1 2.1,-8.6 4.2,-10.6 1.3,-1.2 2.5,-2.3 4,-3.2 0.8,-0.5 5.1,-1.5 5.1,-2.5 v -1 c -6.6,1.6 -11.7,3.8 -15.4,8.5 -4.3,5.5 -5.7,9 -5.7,17.9 l 0,0 z m 27.6,-25.4 c 0,0.6 4.2,2.1 5,2.5 1.2,0.6 3.5,2.4 4.2,3.5 2.1,2.9 4.3,6 4.3,11 0,8.2 -7.4,16.3 -15.6,16.3 v 3 c 2.3,0.2 4.4,3.4 3.3,5.8 0.6,0.2 2.5,1.2 2.5,1.2 0.7,0 5,-7 14.3,-7 h 0.2 c 4.5,0 9,2.6 11.1,5 1.7,1.9 5.3,7.6 4.8,11.4 l -0.8,5.5 1.2,0.6 c 0.1,-0.9 0.8,-2.3 1.1,-3.6 0.3,-1.2 0.4,-3 0.4,-4.4 v -3.3 c 0,-8.4 -8.3,-18.8 -15,-20.3 0,-5 0.4,-6.4 -0.9,-10.9 -0.9,-2.8 -2.6,-6.4 -4.3,-8.3 -5.1,-5.3 -7.5,-7 -15.9,-9 v 1 l -4e-4,0 z m -15.8,22.6 2.8,4.8 c 3,-1.6 4.8,-3.3 9.5,-3.3 h 0.5 c 5.8,0 6.9,2.6 9.7,3.2 l 2.6,-4.7 c -9.5,-5 -15.7,-5 -25.1,0 z"
            }
        ], i["AC.IC.TOXIC GAS"] = [
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 90.2,102.3 c 0.6,-1.9 5.7,-1.9 11.3,-0 5.6,1.9 9.6,4.9 9,6.8 -0.6,1.9 -5.7,1.9 -11.3,0 -5.6,-1.9 -9.6,-4.9 -9,-6.8 z m 7.7,-22.2 c 10e-7,3.7 -1.7,6.7 -3.8,6.7 -2.1,-2e-6 -3.8,-3 -3.8,-6.7 2e-6,-3.7 1.7,-6.7 3.8,-6.7 2.1,0 3.8,3 3.8,6.7 z m 17,2.2 c 0,4.1 -2.8,7.3 -6.3,7.3 -3.5,2e-6 -6.3,-3.3 -6.3,-7.3 0,-4.1 2.8,-7.3 6.3,-7.3 3.5,0 6.3,3.3 6.3,7.3 z m -7.9,49.6 c -1,2.9 -8.5,2.9 -16.6,0 -8.2,-2.9 -13.9,-7.6 -12.9,-10.5 1,-2.9 8.5,-2.9 16.6,-0 8.2,2.9 13.9,7.6 12.9,10.5 z"
            },
            {
                type: "path",
                stroke: !1,
                d: "M 107.5 64.3 C 102.2 64.2 96.9 67.1 92.8 71.6 C 90.6 73.6 89.2 76.8 89.2 80.4 C 89.2 83 90 85.4 91.2 87.3 C 92.1 89.9 92.7 91.8 92.7 94.5 L 92.4 96.7 L 90.7 101.6 C 92.3 100.5 96.7 100.7 101.5 102.3 C 106.6 104 110.4 106.7 110.5 108.6 L 112 104.2 C 115.9 104 120.5 96.9 122.7 87.6 C 124.9 77.9 123.5 69.3 119.8 67.9 C 118.4 66.6 116.1 65.5 112.8 65.3 C 111.1 64.6 109.3 64.3 107.5 64.3 z M 94.1 73.4 C 94.4 73.4 94.6 73.4 94.8 73.5 C 95.1 73.6 95.3 73.8 95.6 73.9 C 96.2 74.4 96.8 75.3 97.2 76.3 C 97.5 77.1 97.7 77.9 97.8 78.7 C 97.9 79.2 97.9 79.6 97.9 80.1 C 97.9 80.5 97.9 81 97.8 81.4 C 97.7 82.3 97.5 83.1 97.2 83.8 C 96.9 84.7 96.4 85.4 95.9 85.9 C 95.6 86.2 95.2 86.5 94.8 86.6 C 94.7 86.6 94.6 86.7 94.5 86.7 C 94.3 86.7 94.2 86.7 94.1 86.7 C 93.8 86.7 93.6 86.7 93.3 86.6 C 93 86.5 92.6 86.2 92.3 85.9 C 92.2 85.8 92.1 85.7 92 85.6 C 91.6 85.1 91.2 84.5 91 83.8 C 90.8 83.4 90.7 83.1 90.6 82.7 C 90.4 81.9 90.3 81 90.3 80.1 C 90.3 79.1 90.4 78.3 90.6 77.5 C 90.7 77.1 90.8 76.7 91 76.3 C 91.2 75.6 91.6 75 92 74.5 C 92.2 74.3 92.4 74.1 92.6 73.9 C 92.9 73.8 93.1 73.6 93.3 73.5 C 93.6 73.4 93.8 73.4 94.1 73.4 z M 108.6 75 C 110.4 75 112.1 75.9 113.3 77.3 C 113.3 77.4 113.4 77.5 113.5 77.6 C 113.5 77.6 113.5 77.6 113.5 77.7 C 113.6 77.8 113.7 78 113.8 78.2 C 113.8 78.3 113.9 78.3 113.9 78.4 C 114 78.5 114 78.5 114 78.6 C 114.1 78.7 114.2 78.8 114.2 79 C 114.3 79.1 114.3 79.3 114.4 79.4 C 114.4 79.5 114.5 79.5 114.5 79.6 C 114.5 79.7 114.6 79.9 114.6 80 C 114.6 80.1 114.6 80.2 114.7 80.3 C 114.7 80.4 114.7 80.6 114.8 80.8 C 114.9 81.3 114.9 81.8 114.9 82.3 C 114.9 84.6 114 86.6 112.6 88 C 112 88.6 111.3 89 110.5 89.3 C 110.3 89.4 110.1 89.5 109.9 89.5 C 109.5 89.6 109 89.7 108.6 89.7 C 108.2 89.7 107.7 89.6 107.3 89.5 C 107.3 89.5 107.3 89.5 107.3 89.5 C 107.1 89.5 106.9 89.4 106.7 89.3 C 105.9 89 105.2 88.6 104.6 88 C 104 87.4 103.5 86.6 103.1 85.8 C 102.9 85.4 102.7 85 102.6 84.5 C 102.5 84.3 102.5 84 102.4 83.8 C 102.4 83.5 102.4 83.3 102.3 83.1 C 102.3 82.8 102.3 82.6 102.3 82.3 C 102.3 82 102.3 81.8 102.3 81.5 C 102.3 81.5 102.4 81.5 102.4 81.4 C 102.4 81 102.5 80.5 102.6 80.1 C 102.6 80.1 102.6 80.1 102.6 80 C 103.4 77.1 105.8 75 108.6 75 z M 88.8 104 C 86.6 104 84.8 104.4 83.9 105.2 L 83.8 105.2 L 83.7 105.3 C 83.4 105.6 83.2 105.9 83.1 106.2 C 83 106.5 83 106.8 83 107.2 L 78.1 120.5 C 80.2 118.5 86.9 118.7 94.2 121.3 C 101.2 123.8 106.4 127.7 107.1 130.6 L 111.8 117.8 C 112.2 117.5 112.5 117.2 112.7 116.8 C 113.7 113.8 107.9 109.1 99.8 106.2 C 95.7 104.8 91.8 104 88.8 104 z M 82 120.8 C 79 120.8 76.9 121.5 76.4 123 C 75.4 125.9 81.1 130.7 89.3 133.6 C 97.4 136.5 104.9 136.5 105.9 133.6 C 107 130.6 101.2 125.9 93 123 C 89 121.5 85 120.8 82 120.8 z M 86.1 125.6 C 87.4 125.5 89.4 125.9 91.5 126.6 C 94.8 127.8 97.2 129.6 96.9 130.6 C 96.5 131.6 93.5 131.5 90.1 130.3 C 86.8 129.1 84.4 127.3 84.7 126.3 C 84.9 125.9 85.4 125.7 86.1 125.6 z "
            }
        ], i["AC.IC.AFTERSHOCK"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 99,62.5 -0,0 -0,0 -0.9,0 -0,0 -0,0 -0.9,0.1 -0,0 -0,0 -0.9,0.1 -0,0 -0,0 -0.9,0.1 -0,0 -0,0 -0.9,0.1 -0,0 -0,0 -0.9,0.1 -0,0 -0,0 -0.9,0.2 -0,0 -0,0 -0.7,0.1 0.6,2.7 0.7,-0.1 0,-0 0.8,-0.1 0,-0 0.8,-0.1 0,0 0.8,-0.1 0,0 0.9,-0.1 0,0 0.9,-0.1 0,0 0.9,-0.1 0,0 0.9,-0 0,0 0.9,-0 0,0 0,0 0.9,0 0,0 0.9,0 0,0 0.1,0 0.2,-2.8 -0.1,-0 -0,0 -0,0 -0.9,-0 -0,0 -0,0 -1,-0 -0,0 -0,0 z m 8.8,3.6 0.2,0 0,0 0.8,0.2 0,0 0.8,0.2 0,0 0.8,0.2 0,0 0.8,0.3 0,0 0,0 0.8,0.3 0,0 0.8,0.3 0,0 0.8,0.3 0,0 0.8,0.3 0,0 0.8,0.3 0,0 0.8,0.4 0,0 0,0 0.7,0.4 0,0 0.1,0 1.3,-2.5 -0.1,-0.1 -0,-0 -0,0 -0.8,-0.4 -0,-0 -0,0 -0.8,-0.4 -0,0 -0,-0 -0.8,-0.4 -0,-0 -0,0 -0.8,-0.4 -0,0 -0,-0 -0.8,-0.3 -0,-0 -0,0 -0.8,-0.3 -0,-0 -0,0 -0.8,-0.3 -0,0 -0,-0 -0.9,-0.3 -0,0 -0,0 -0.9,-0.3 -0,0 -0,0 -0.9,-0.2 -0,0 -0,-0 -0.9,-0.2 -0,0 -0,0 -0.2,-0.1 z m -22.7,-0.7 -0,0 -0,0 -0.8,0.4 -0,0 -0,0 -0.8,0.4 -0,0 -0,0 -0.8,0.4 -0,0 -0,0 -0.8,0.4 -0,0 -0,0 -0.8,0.4 -0,0 -0,0 -0.8,0.5 -0,0 -0,0 -0.8,0.5 -0,0 -0,0 -0.7,0.5 -0,0 -0,0 -0.7,0.5 -0,0 -0,0 -0.7,0.5 -0,0 -0,0 -0.7,0.5 -0,0 -0,0 -0.1,0.1 1.7,2.2 0.1,-0.1 0,-0 0.7,-0.5 0,-0 0.7,-0.5 0,-0 0.7,-0.5 0,-0 0.7,-0.5 0,-0 0.7,-0.4 0,-0 0.7,-0.4 0,-0 0.7,-0.4 0,-0 0.7,-0.4 0,-0 0,0 0.8,-0.4 0,-0 0.8,-0.3 0,-0 0.8,-0.3 0,-0 0.3,-0.1 -1,-2.6 z m 36.9,7.3 0.6,0.5 0,0 0.6,0.5 0,0 0.6,0.5 0,0 0.6,0.5 0,0 0.6,0.6 0,0 0,0 0.6,0.6 0,0 0.6,0.6 0,0 0.5,0.6 0,0 0.5,0.6 0,0 0.5,0.6 0,0 0.5,0.6 0,0 0.4,0.5 2.3,-1.7 -0.4,-0.6 -0,-0 0,-0 -0.6,-0.7 -0,-0 0,-0 -0.6,-0.7 -0,-0 -0,-0 -0.6,-0.7 -0,-0 -0,-0 -0.6,-0.7 -0,-0 -0,-0 -0.6,-0.6 -0,-0 -0,-0 -0.6,-0.6 -0,-0 -0,-0 -0.6,-0.6 -0,-0 -0,0 -0.7,-0.6 -0,-0 -0,0 -0.7,-0.6 -0,-0 -0,-0 -0.7,-0.6 -0,-0 -0,-0 -0.6,-0.5 z m -51,2.7 -0,0 -0,0 -0.6,0.7 -0,0 -0,0 -0.6,0.7 0,0 -0,0 -0.6,0.7 0,0 -0,0 -0.5,0.7 -0,0 -0,0 -0.5,0.7 -0,0 -0,0 -0.5,0.7 -0,0 0,0 -0.5,0.7 -0,0 0,0 -0.5,0.8 0,0 -0,0 -0.4,0.8 -0,0 0,0 -0.4,0.8 0,0 -0,0 -0.3,0.6 2.5,1.3 0.3,-0.6 0,-0 0.4,-0.7 0,-0 0.4,-0.7 0,-0 0.4,-0.7 0,-0 0.4,-0.7 0,-0 0.5,-0.7 0,-0 0.5,-0.7 0,-0 0.5,-0.7 0,-0 0.5,-0.6 0,-0 0.5,-0.6 0,-0 0.5,-0.6 0,-0 0.5,-0.5 -2.1,-1.9 z m 60.9,9.4 0.1,0.1 0,0 0,0 0.3,0.7 0,0 0.3,0.7 0,0 0.3,0.8 0,0 0.3,0.8 0,0 0.3,0.8 0,0 0,0 0.3,0.8 0,0 0.2,0.8 0,0 0.2,0.8 0,0 0.2,0.8 0,0 0.2,0.8 0,0 0.2,0.8 0,0 0,0.2 2.8,-0.5 -0,-0.3 -0,-0 0,-0 -0.2,-0.9 0,-0 0,-0 -0.2,-0.9 0,-0 -0,-0 -0.2,-0.9 0,-0 -0,-0 -0.2,-0.9 0,-0 -0,-0 -0.3,-0.8 -0,-0 0,-0 -0.3,-0.8 0,-0 -0,-0 -0.3,-0.8 0,-0 -0,-0 -0.3,-0.8 -0,-0 0,-0 -0.3,-0.8 0,-0 -0,-0 -0.3,-0.8 -0,-0 -0,-0 -0.4,-0.8 -0,-0 0,-0 -0.1,-0.2 z m -68.8,4.9 -0,0 0,0 -0.2,0.9 -0,0 0,0 -0.2,0.9 -0,0 0,0 -0.2,0.9 0,0 0,0 -0.2,0.9 0,0 -0,0 -0.1,0.9 0,0 0,0 -0.1,0.9 -0,0 0,0 -0.1,0.9 0,0 -0,0 -0.1,0.9 0,0 0,0 -0.1,0.9 0,0 0,0 -0,0.9 0,0 0,0 -0,0.9 0,0 0,0 0,0 1.4,-0 0.3,0 1.1,0 0,-0 0,-0.9 0,-0 0,-0.9 -0,0 0.1,-0.8 0,-0 0.1,-0.9 -0,0 0.1,-0.9 0.1,-0.9 -0,0 0.1,-0.8 0,-0 0.2,-0.8 0,-0 0.2,-0.8 0,-0 0.2,-0.8 0,-0 0.2,-0.8 0,-0 0.1,-0.2 -2.7,-0.8 z m 73,10.3 -0.6,0 0,0 0,0 -0,0.9 0,0 -0,0.9 0,0 -0.1,0.8 0,0 -0.1,0.9 0,0 -0.1,0.9 -0.1,0.9 0,0 -0.1,0.8 0,0 -0.2,0.8 -0,0 -0.2,0.8 -0,0 -0.2,0.8 0,0 -0.2,0.8 -0,0 -0.1,0.2 2.7,0.8 0.1,-0.2 0,-0 0,-0 0.2,-0.9 0,-0 0,-0 0.2,-0.9 0,-0 0,-0 0.2,-0.9 0,-0 0,-0 0.2,-0.9 0,-0 0,-0 0.1,-0.9 0,-0 0,-0 0.1,-0.9 0,-0 0,-0 0.1,-0.9 0,-0 0,-0 0.1,-0.9 0,-0 0,-0 0.1,-0.9 0,-0 0,-0 0,-0.9 0,-0 0,-0 0,-0.9 -1.4,-0 1.4,-0 0,-0 z m -73.9,6.4 0,0.3 0,0 0,0 0.2,0.9 0,0 0,0 0.2,0.9 0,0 0,0 0.2,0.9 0,0 0,0 0.2,0.9 0,0 0,0 0.3,0.8 0,0 0,0 0.3,0.8 0,0 0,0 0.3,0.8 0,0 0,0 0.3,0.8 0,0 0,0 0.3,0.8 0,0 0,0 0.3,0.8 0,0 0,0 0.4,0.8 0,0 0,0 0.1,0.2 2.5,-1.3 -0.1,-0.1 -0,-0 -0.3,-0.7 -0,-0 -0.3,-0.7 -0,-0 -0.3,-0.8 -0,-0 -0.3,-0.8 -0,-0 -0.3,-0.8 -0,-0 0,-0 -0.3,-0.8 -0,-0 -0.2,-0.8 -0,-0 -0.2,-0.8 0,-0 -0.2,-0.8 -0,-0 -0.2,-0.8 -0,-0 -0.2,-0.8 0,-0 -0,-0.2 z m 69.4,9.4 -0,0 -0.4,0.7 -0,0 -0.4,0.7 -0,0 -0.4,0.7 -0,0 -0.4,0.7 -0,0 -0.5,0.7 -0,0 -0.5,0.7 -0,0 -0.5,0.7 -0,0 -0.5,0.6 -0,0 -0.5,0.6 -0,0 -0.5,0.6 -0,0 -0.5,0.6 2.1,1.9 0.5,-0.6 0,-0 0,-0 0.6,-0.7 0,-0 0,-0 0.6,-0.7 0,-0 0,-0 0.6,-0.7 0,-0 0,-0 0.5,-0.7 0,-0 0,-0 0.5,-0.7 0,-0 0,-0 0.5,-0.7 0,-0 0,-0 0.5,-0.7 0,-0 0,-0 0.5,-0.8 0,-0 0,-0 0.4,-0.8 0,-0 0,-0 0.4,-0.8 0,-0 0,-0 0.3,-0.6 -2.5,-1.3 z m -62.8,6.1 0.4,0.6 0,0 0,0 0.6,0.7 0,0 0,0 0.6,0.7 0,0 0,0 0.6,0.7 0,0 0,0 0.6,0.7 0,0 0,0 0.6,0.6 0,0 0,0 0.6,0.6 0,0 0,0 0.6,0.6 0,0 0,0 0.7,0.6 0,0 0,0 0.7,0.6 0,0 0,0 0.7,0.6 0,0 0,0 0.6,0.5 1.7,-2.2 -0.6,-0.5 -0,-0 -0.6,-0.5 -0,-0 -0.6,-0.5 -0,-0 -0.6,-0.5 -0,-0 -0.6,-0.6 -0,-0 -0,-0 -0.6,-0.6 -0,-0 -0.6,-0.6 -0,-0 -0.5,-0.6 -0,-0 -0.5,-0.6 -0,-0 -0.5,-0.6 -0,-0 -0.5,-0.6 -0,-0 -0.4,-0.5 z m 53.1,5.4 -0,0 -0.7,0.5 -0,0 -0.7,0.5 -0,0 -0.7,0.5 -0,0 -0.7,0.5 -0,0 -0.7,0.4 -0,0 -0.7,0.4 -0,0 -0.7,0.4 -0,0 -0.7,0.4 -0,0 -0,0 -0.8,0.4 -0,0 -0.8,0.3 -0,0 -0.8,0.3 -0,0 -0.3,0.1 1,2.6 0.4,-0.1 0,-0 0,0 0.8,-0.4 0,0 0,-0 0.8,-0.4 0,-0 0,0 0.8,-0.4 0,0 0,-0 0.8,-0.4 0,0 0,-0 0.8,-0.4 0,-0 0,0 0.8,-0.5 0,0 0,-0 0.8,-0.5 0,-0 0,0 0.7,-0.5 0,0 0,-0 0.7,-0.5 0,-0 0,0 0.7,-0.5 0,-0 0,-0 0.7,-0.5 0,-0 0,-0 0.1,-0.1 -1.7,-2.2 z m -40.4,5.6 0.1,0.1 0,0 0,0 0.8,0.4 0,0 0,0 0.8,0.4 0,0 0,0 0.8,0.4 0,0 0,0 0.8,0.4 0,0 0,0 0.8,0.3 0,0 0,0 0.8,0.3 0,0 0,0 0.8,0.3 0,0 0,0 0.9,0.3 0,0 0,0 0.9,0.3 0,0 0,0 0.9,0.2 0,0 0,0 0.9,0.2 0,0 0,0 0.2,0.1 0.6,-2.7 -0.2,-0 -0,-0 -0.8,-0.2 -0,-0 -0.8,-0.2 -0,-0 -0.8,-0.2 -0,-0 -0.8,-0.3 -0,-0 -0,0 -0.8,-0.3 0,-0 -0.8,-0.3 -0,-0 -0.8,-0.3 -0,-0 -0.8,-0.3 -0,-0 -0.8,-0.3 -0,-0 -0.8,-0.4 -0,0 -0,-0 -0.7,-0.4 -0,-0 -0.1,-0 z m 25.6,1.1 -0,0 -0.8,0.1 -0,0 -0.8,0.1 -0,0 -0.8,0.1 0,-0 -0.9,0.1 0,-0 -0.9,0.1 -0,0 -0.9,0.1 -0,0 -0.9,0 -0,0 -0.9,0 -0,0 -0,0 -0.9,-0 -0,0 -0.9,-0 -0,0 -0.1,0 -0.2,2.8 0.1,0 0,0 0,0 0.9,0 0,0 0,0 1,0 0,0 0,0 1,-0 0,0 0,0 0.9,-0 0,0 0,0 0.9,-0.1 0,0 0,0 0.9,-0.1 0,-0 0,0 0.9,-0.1 0,0 0,0 0.9,-0.1 0,-0 0,0 0.9,-0.1 0,0 0,0 0.9,-0.2 0,0 0,0 0.7,-0.1 -0.6,-2.7 z m -7.2,-58.9 -0,1.2 0.1,0 0,0 1.3,0 0,-0 1.3,0.1 1.1,0.1 0.1,0 0,0 1.1,0.2 0.1,0 0.7,0.1 0.7,-3.1 -0.7,-0.2 -0,0 -0,-0 -1.3,-0.2 -0,0 -0,-0 -1.3,-0.2 -0,0 -0,0 -1.3,-0.1 -0,0 -0.1,0 -1.3,-0 -0,0 -0,0 -0,0 z m -5.5,-1.4 -0,0 -0,0 -1.3,0.3 -0,0 -0,0 -1.2,0.3 -0,0 -0,0 -1.2,0.4 -0,0 -0,0 -0.9,0.3 1.1,3 0.8,-0.3 0.1,-0 0,0 1.1,-0.4 0,-0 1.1,-0.3 1.2,-0.3 0.1,-0 1.1,-0.2 -0.6,-3.1 z m 14.8,4.4 0.2,0.1 0.1,0 1.1,0.5 1,0.5 0.1,0 1,0.5 0,0 0,0 0.9,0.6 0.1,0 0.5,0.4 1.8,-2.6 -0.6,-0.4 -0,-0 -0,-0 -1.1,-0.7 -0,-0 -0,-0 -1.1,-0.6 -0,-0 -0,-0 -1.1,-0.6 -0,-0 -0,-0 -1.1,-0.5 -0,-0 -0,-0 -0.3,-0.1 z m -23.6,-1.1 -0,0 -0,0 -1.1,0.7 -0,0 -0,0 -1,0.7 -0,0 -0,0 -1,0.8 -0,0 -0,0 -0.9,0.8 -0,0 -0,0 -0.8,0.7 2.2,2.4 0.7,-0.7 0.1,-0.1 0.8,-0.7 0,-0 0,-0 0.9,-0.7 0.1,-0 0.9,-0.6 0.1,-0 0.9,-0.6 0,-0 0,-0 -0.4,-0.6 -1.2,-2.2 z m 31.5,6.2 0.1,0.1 0,0 0,0 0.8,0.8 0.1,0.1 0.7,0.8 0.1,0.1 0.7,0.8 0,0 0,0.1 0.6,0.9 0,0.1 0,0 0.5,0.7 2.7,-1.8 -0.5,-0.8 -0,-0 -0,-0 -0.7,-1 -0,-0 -0,-0 -0.8,-0.9 -0,-0 -0,-0 -0.8,-0.9 -0,-0 -0,-0 -0.9,-0.9 -0,-0 -0,-0 -0.1,-0.1 z m -40.1,1.8 -0,0 -0,0 -0.7,1 -0,0 -0,0 -0.6,1.1 -0,0 -0,0 -0.6,1.1 -0,0 -0,0 -0.5,1.1 -0,0 -0,0 -0,0.1 2.4,1 0.5,0.3 0,-0 0.5,-1 0,-0.1 0,-0 0.5,-0.9 0,-0.1 0.6,-0.9 0.6,-1 0,-0 0,-0.1 0.6,-0.8 -2.6,-1.9 z m 45.4,5.9 0.4,1.1 0,0.1 0.3,1 0,0.1 0.3,1.1 0.3,1.1 0.2,1 3.1,-0.6 -0.2,-1.1 0,-0 -0,-0 -0.3,-1.2 -0,-0 -0,-0.1 -0.3,-1.2 -0,-0 -0,-0 -0.4,-1.2 -0,-0 -0,-0 -0.5,-1.1 z m -49.6,3.8 -0,0 0,0 -0.2,1.3 0,0 -0,0 -0.2,1.3 -0,0 0,0 -0.1,1.3 0,0 0,0.1 -0,1.3 0,0 0,0 0,0 1.9,-0 1.3,0 0,-0.1 0,-0 0,-1.2 0.1,-1.1 0,0 0.1,-1.2 0,-0.1 0,-0 0.2,-1.1 0.2,-0.9 -3.1,-0.7 z m 52.8,5.5 -1.2,-0 0,0.1 0,0 -0,1.2 -0.1,1.1 -0,0 -0.1,1.2 0,0 -0,0.1 -0.2,1.1 -0.2,0.9 3.1,0.8 0.2,-0.9 0,-0 0,-0 0.2,-1.3 0,-0 0,-0 0.2,-1.3 0,-0 0,-0 0.1,-1.3 0,-0 0,-0.1 0,-1.3 -1.6,-0 1.6,-0 0,-0 z m -53,4.3 0.2,1.1 0,0 0,0 0.3,1.2 0,0 0,0.1 0.3,1.2 0,0 0,0 0.4,1.2 0,0 0,0 0.5,1.1 3,-1.2 -0.4,-1 -0,-0.1 -0.3,-1 -0,-0.1 -0.3,-1.1 -0.3,-1.1 -0.2,-1 z m 49.9,4.9 -0.5,1 -0,0.1 -0,0 -0.5,1 -0,0.1 -0.6,0.9 -0.6,1 -0,0 -0,0.1 -0.6,0.8 2.6,1.9 0.6,-0.9 0,-0 0,-0 0.7,-1 0,-0 0,-0 0.6,-1.1 0,-0 0,-0 0.6,-1.1 0,-0 0,-0 0.5,-1.1 0,-0 0,-0 0,-0 -2.2,-0.9 -0.8,-0.3 z m -46,5 0.5,0.8 0,0 0,0 0.7,1 0,0 0,0 0.8,0.9 0,0 0,0 0.8,0.9 0,0 0,0 0.9,0.9 0,0 0,0 0.1,0.1 2.2,-2.3 -0.1,-0.1 -0,-0 -0,-0 -0.8,-0.8 -0.1,-0.1 -0.7,-0.8 -0.1,-0.1 -0.7,-0.8 -0,-0 -0,-0.1 -0.6,-0.9 -0.1,-0.1 -0.5,-0.7 z m 40,3.3 -0.1,0.1 -0.8,0.7 -0,0 -0,0 -0.9,0.7 -0.1,0 -0.9,0.6 -0.1,0 -0.9,0.6 0,-0 -0.1,0 0,0 -0,0 0.3,0.4 1.3,2.4 0,-0 0,-0 0,-0 1.1,-0.7 0,-0 0,-0 1,-0.7 0,-0 0,-0 1,-0.8 0,-0 0,-0 0.9,-0.8 0,-0 0,-0 0.8,-0.7 -2.2,-2.4 z m -32.6,4.4 0.6,0.4 0,0 0,0 1.1,0.7 0,0 0,0 1.1,0.6 0,0 0,0 1.1,0.6 0,0 0,0 1.1,0.5 0,0 0,0 0.3,0.1 1.1,-3 -0.2,-0.1 -0.1,-0 -1.1,-0.5 -1,-0.5 -0.1,-0 -1,-0.6 0,0 -0.9,-0.6 -0.1,-0 -0.5,-0.4 z m 24.5,0.3 -0.1,0 -1.1,0.3 -0.1,0 -1.1,0.3 -1.2,0.3 -0.1,0 -1.1,0.2 0.6,3.1 1.2,-0.2 0,0 0,-0 1.3,-0.3 0,0 0,-0 1.2,-0.3 0,-0 0,-0 1.2,-0.4 0,-0 0,-0 0.9,-0.3 -1.1,-3 z m -14.8,3.9 0.7,0.2 0,0 0,0 1.3,0.2 0,0 0,0 1.3,0.2 0,0 0,0 1.3,0.1 0,0 0.1,0 1.3,0 0,0 0,0 0,0 -0.1,-1.6 0,-0.1 0,-1.5 -0.1,0 -1.3,-0 0,0 -1.3,-0.1 -1.1,-0.1 -0.1,-0 -0,0 -1.1,-0.2 -0.1,-0 -0.7,-0.1 z m 6.3,-43.1 -0.4,0 0.1,4 0.3,-0 0.1,0 0.1,0 0.6,0 0.1,0 0.6,0 0.1,0 0.6,0.1 0.1,0 0.6,0.1 0.7,0.1 0.1,0 0.1,0 0.6,0.2 0.5,0.2 0.1,0 0.5,0.2 0.1,0 0,0 0.5,0.2 0.1,0 0.4,0.2 1.8,-3.6 -0.5,-0.3 -0,-0 -0.1,-0 -0.7,-0.3 -0.1,-0 -0.1,-0 -0.7,-0.3 -0,-0 -0.1,-0 -0.7,-0.2 -0.1,-0 -0,-0 -0.7,-0.2 -0.1,-0 -0.1,-0 -0.7,-0.2 -0.1,-0 -0.1,-0 -0.8,-0.1 -0,-0 -0.1,-0 -0.8,-0.1 -0.1,-0 -0.1,0 -0.8,-0.1 -0.1,0 -0.1,0 -0.8,-0 -0.1,-0 z m -5.1,0.7 -0.1,0 -0,0 -0.7,0.2 -0.1,0 -0.1,0 -0.7,0.3 -0,0 -0.1,0 -0.7,0.3 -0.1,0 -0,0 -0.7,0.3 -0,0 -0,0 -0.7,0.4 -0,0 -0.1,0 -0.6,0.4 -0,0 -0,0 -0.6,0.4 -0,0 -0,0 -0.6,0.4 -0,0 -0,0 -0.6,0.5 -0,0 -0,0 -0.5,0.5 -0,0 -0,0 -0.2,0.2 2.9,2.8 0.1,-0.1 0.1,-0.1 0.4,-0.4 0.1,-0.1 0.4,-0.3 0,-0 0.1,-0.1 0.4,-0.3 0.5,-0.4 0.1,-0.1 0.6,-0.3 0,-0 0.5,-0.3 0.1,-0 0.5,-0.3 0.1,-0 0.5,-0.2 0,0 0.1,-0 0.6,-0.2 0,-0 0.5,-0.2 0.1,-0 0.1,-0 -1.1,-3.9 z m 14.2,6.7 0.4,0.3 0.5,0.5 0.1,0.1 0.3,0.4 0.1,0.1 0.3,0.4 0.1,0.1 0.3,0.4 0,0 0,0.1 0.3,0.4 0.1,0.1 0.3,0.5 0,0 0,0.1 0.3,0.5 0,0.1 0.2,0.5 0,0.1 0.2,0.5 0,0.1 0,0 0.2,0.6 3.8,-1.3 -0.2,-0.7 -0,-0.1 -0,-0.1 -0.3,-0.7 -0,-0.1 -0,-0 -0.3,-0.7 -0,-0.1 -0,-0 -0.3,-0.7 -0,-0.1 -0,-0 -0.4,-0.6 -0,-0 -0,-0.1 -0.4,-0.6 -0,-0 -0,-0.1 -0.4,-0.6 -0,-0.1 -0,-0 -0.5,-0.6 -0,-0 -0,-0 -0.5,-0.5 -0,-0 -0,-0 -0.5,-0.5 -0,-0 -0,-0 -0.5,-0.4 z m -24.4,1.4 -0,0 -0,0.1 -0.3,0.7 -0,0 -0,0.1 -0.3,0.7 -0,0 -0,0.1 -0.3,0.7 -0,0.1 -0,0.1 -0.2,0.7 -0,0.1 -0,0.1 -0.2,0.7 -0,0.1 0,0.1 -0.2,0.7 -0,0.1 -0,0.1 -0.1,0.7 -0,0.1 0,0.1 -0.1,0.8 0,0.1 -0,0.1 -0.1,0.8 0,0.1 0,0.1 -0,0.8 0,0.1 0,0.1 0,0.3 4,-0.1 -0,-0.2 0,-0.1 0,-0 0,-0.7 0,-0.6 0,-0.1 0,-0 0.1,-0.5 0.1,-0.6 0,-0.1 0.1,-0.5 0,-0 0,-0.1 0.1,-0.5 0.2,-0.6 0,-0.1 0,-0 0.2,-0.5 0.3,-0.6 0.1,-0.1 0.3,-0.5 0,-0.1 0,-0 0,-0 -3.5,-2 z m 28.7,7.6 0,0.5 0,0.1 0,0 -0,0.6 -0.1,0.7 -0,0.1 0,0.1 -0.1,0.6 -0.1,0.5 -0,0.1 -0.1,0.5 0,0 -0,0.1 -0.1,0.5 -0,0.1 -0.2,0.5 -0,0 -0,0.1 -0.2,0.5 -0,0 -0,0.1 -0.2,0.5 -0,0.1 -0.3,0.5 -0,0.1 -0,0 -0.2,0.3 3.5,2 0.2,-0.4 0,-0.1 0,-0 0.3,-0.7 0,-0 0,-0.1 0.3,-0.7 0,-0 0,-0.1 0.3,-0.7 0,-0.1 0,-0.1 0.2,-0.7 0,-0 0,-0.1 0.2,-0.7 0,-0.1 0,-0.1 0.2,-0.7 0,-0.1 0,-0.1 0.1,-0.7 0,-0.1 0,-0.1 0.1,-0.8 0,-0.1 0,-0.1 0.1,-0.8 0,-0.1 0,-0.1 0,-0.8 -2,-0.1 2,-0.1 -0,-0.6 z m -30.1,5.3 0.1,0.3 0,0.1 0,0 0.2,0.7 0,0.1 0,0.1 0.3,0.7 0,0.1 0,0 0.3,0.7 0,0.1 0,0 0.3,0.7 0,0 0,0.1 0.4,0.6 0,0 0,0.1 0.4,0.6 0,0 0,0 0.4,0.6 0,0 0,0 0.5,0.6 0,0 0,0 0.5,0.5 0,0 0,0 0.5,0.5 0,0 0,0 0.2,0.2 2.7,-2.9 -0.2,-0.1 -0.1,-0.1 -0,-0 -0.4,-0.4 -0.1,-0.1 -0.4,-0.4 -0,-0.1 -0,-0 -0.3,-0.4 -0.1,-0.1 -0.4,-0.5 -0.3,-0.4 -0.1,-0.1 -0.3,-0.5 -0,-0 -0,-0.1 -0.3,-0.5 -0.1,-0.1 -0.2,-0.5 -0,-0.1 -0,-0 -0.2,-0.5 -0,-0.1 -0,-0.1 -0.2,-0.6 -0,-0.1 z m 25.8,4.8 -0.1,0.1 -0.4,0.3 -0,0 -0.1,0.1 -0.4,0.3 -0.1,0.1 -0.5,0.3 -0,0 -0.1,0 -0.5,0.3 -0.1,0 -0,0 -0.6,0.3 -0.5,0.3 -0.1,0 -0.5,0.2 -0,0 -0.1,0 -0.5,0.2 -0.1,0 -0.5,0.2 -0.5,0.1 1.1,3.9 0.5,-0.1 0,-0 0.1,-0 0.7,-0.2 0.1,-0 0,-0 0.7,-0.3 0.1,-0 0.1,-0 0.7,-0.3 0.1,-0 0,-0 0.7,-0.3 0.1,-0 0,-0 0.7,-0.4 0,-0 0,-0 0.6,-0.4 0,-0 0.1,-0 0.6,-0.4 0,-0 0,-0 0.6,-0.5 0,-0 0,-0 0.6,-0.5 0,-0 0,-0 0.5,-0.5 -2.7,-2.9 z m -15.5,1.8 -1.9,3.5 0.1,0.1 0,0 0,0 0.7,0.3 0,0 0.1,0 0.7,0.3 0.1,0 0,0 0.7,0.3 0.1,0 0.1,0 0.7,0.2 0,0 0.1,0 0.7,0.2 0,0 0.1,0 0.8,0.2 0.1,0 0.1,0 0.8,0.1 0.1,0 0.1,0 0.8,0.1 0.1,0 0.1,0 0.8,0.1 0.1,0 0.1,0 0.8,0 0.1,0 0.1,0 0.1,0 -0.1,-4 -0.1,0 -0.1,0 -0.6,-0 -0.1,0 -0.6,-0 0,-0 -0.7,-0.1 -0,0 -0.1,-0 -0.6,-0.1 -0.1,-0 -0.6,-0.1 0,-0 -0.7,-0.2 -0.5,-0.2 0,-0 -0.6,-0.2 -0.1,-0 -0,0 -0.5,-0.2 -0.1,-0 -0.5,-0.3 -0.1,-0.1 z M 100,93.2 c -3.5,-4e-4 -6.7,2.9 -6.7,6.5 l 0,0.4 c 0,3.5 3,6.5 6.5,6.5 l 0.4,0 c 3.4,0 6.5,-3 6.5,-6.3 l 0,-0.9 c 0,-3.4 -3.3,-6.3 -6.8,-6.3 z"
            }
        ], i["AC.IC.AVALANCHE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 115.7,87.3 -3.6,0.9 11,38 -4.6,1.5 9.6,9.2 3.1,-13 -4.6,1.4 z m 3,46.4 -8.5,-10 4.3,-1.2 -11.2,-40.6 -34.5,51.9 z m -12.1,-59.8 0,8.4 1.6,0 0,-8.3 7.1,4.3 0.8,-1.3 -7.4,-4.1 7.5,-4.4 -1,-1.2 -7,4 0,-8.2 -1.6,0 0,8.2 -7.4,-4 -0.6,1.1 7.2,4.4 -7.2,4.1 0.6,1.4 z"
            }
        ], i["AC.IC.EARTHQUAKE EPICENTER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 62.8,99.8 c 0,-10.8 4.9,-20.2 10.3,-25.7 5.1,-5.1 14.8,-11.3 24.7,-11.3 h 4.1 c 4.9,0 10.5,1.9 13.9,3.6 5,2.5 6.4,4 10.4,7 4.6,3.6 11.1,15.4 11.1,23.8 v 5.3 c 0,17.4 -17.5,34.6 -35.1,34.6 h -4.6 c -10.3,0 -19.4,-6.2 -24.6,-11.4 -5.5,-5.4 -10.3,-15 -10.3,-25.8 z m 39.4,38.5 c 10.7,0 20,-6.3 25.5,-11.8 6.7,-6.7 9.9,-13.9 10.7,-26.5 1.3,-19.2 -17.7,-38.1 -36.2,-38.1 h -4.8 c -10.3,0 -20.1,6.6 -25.2,12.1 -3,3.2 -5.6,6.7 -7.5,11.1 -1.1,2.8 -3.5,11.3 -3,15.3 0.7,6.4 0.9,10.4 3.4,15.3 2.2,4.4 4,7.6 7.3,11 5,5.3 15.2,11.7 25.3,11.7 h 4.6 z m -3.9,-11.6 c -13.6,0 -24.7,-13.1 -25.2,-26.8 -0.5,-13.2 12.5,-26.4 25.4,-26.4 h 2.9 c 12.8,0 25.2,12.4 25.2,25.2 v 2.4 c 0,12.8 -12.4,25.7 -25.2,25.7 h -3.1 v -0 z m -27.1,-26.9 c 0,8.8 3.7,16 8.1,20.5 2.3,2.4 5.2,4.4 8.3,5.9 4.2,2.2 6.3,1.9 11.5,2.8 2.9,0.5 10,-1.3 12,-2.2 4.6,-2.2 5,-2.9 8.6,-5.6 4.3,-3.1 9.1,-12.3 9.1,-19.7 v -3.4 c 0,-13.7 -13.6,-26.8 -27.3,-26.8 h -3.2 c -14.5,-4e-4 -27.1,13.6 -27.1,28.5 z m 28.5,14.8 c -8.4,0 -13.5,-6.5 -14.4,-14.4 -0.7,-7.3 6.8,-14.6 13.9,-14.6 h 1.7 c 7.3,0 13.6,6.9 13.6,14.5 0,7.7 -6.2,14.5 -13.8,14.5 h -1 z m -18.6,-14.8 c 0,11.5 8,18.1 18.4,19.3 6.2,0.8 10.3,-2.9 13.6,-5.3 2.8,-2 5.8,-8.3 5.8,-13.3 V 99.8 c 0,-10.4 -8.3,-18.6 -18.6,-18.6 h -0.7 c -9.9,0 -18.4,8.6 -18.4,18.6 z m 10.9,0 v 0.2 c 0,3.7 3.5,7.7 7,7.7 h 1.7 c 3.9,0 7.3,-3.9 7.3,-7.7 0,-4 -3.5,-8 -7,-8 h -1.7 c -3.5,0 -7.3,4 -7.3,7.7 z"
            }
        ], i["AC.IC.LANDSLIDE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 129.4,110.8 c -2.7,0 -6.2,4.1 -4.3,5.1 -1,1.5 -3.6,2 -3.6,4 0,1.8 2.6,4.7 3.4,6.2 1.1,2 3.2,3.2 6.2,3.2 h 1.8 c 2.7,0 4.6,-2.6 4.6,-5.3 v -1 c 0,-3.4 -1,-5 -2.1,-7.5 -1,-2.4 -1.6,-4.6 -4.9,-4.6 h -1 z m -22.2,-35 -5.3,-5.2 -39.3,58.3 55.8,0.1 v -1.2 c 0,-0.7 -1,-1.5 -1.5,-1.8 0,-2 -0.6,-1.6 -0.9,-2.9 -0.2,-0.9 -0.1,-2.7 -0.1,-3.7 0,-2.8 -0.1,-4.3 -1.7,-5.6 -2.2,-1.9 -1.3,-1.5 -4.3,-3.1 -2,-1 -1.5,-2.1 -5.2,-2.2 v -1.5 c 0,-1.9 -2,-3.6 -2.8,-4.8 0,-2.3 -0.5,-4.7 -0.5,-6.8 0,-1.6 -0.2,-2 -0.2,-3.3 -0.1,-1.7 -0.8,-1.5 -0.8,-2.8 v -0.2 c 0,-3 0.5,-4.5 2.1,-6 2.2,-2.1 0.9,-2.2 3.8,-3.9 l 0.8,-3.3 0,0 z m 9.7,34 c 0,3.6 6.1,2.8 6.1,-0.8 0,-4.2 -6.1,-1.9 -6.1,0.8 z m 2.8,-16.4 c -2.2,0 -7,6.4 -4,8.6 1.7,1.2 2.6,1.6 5.3,0.6 2,-0.8 2.8,-1.6 2.8,-4.3 4e-4,-2.4 -2,-4.8 -4,-4.8 z m -8.4,5.3 c 0.8,0 1,-0.7 1.3,-1.3 -0.6,-1.4 -0.5,-2.5 -2.6,-2.5 h -0.2 c -1,0 -2,0.6 -2,1.5 0,0.7 1.6,2.3 2.8,2.3 h 0.8 z m -3.3,-13.7 c -0.1,1 -0.3,0.6 -0.3,1.5 0,1 0.8,3 1.8,3 h 0.2 c 3.1,0 3.1,-0.2 4.8,-1.5 -1,-2.3 -0.4,-3.6 -4.2,-3.6 -1.1,0 -1.4,0.3 -2.3,0.5 z"
            }
        ], i["AC.IC.SUBSIDENCE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 56.8,75.6 0,2 14.4,0 3.8,7.9 c -0.1,0.3 -0.3,0.7 -0.3,1.6 l 0,0.6 c 0,0.7 0.3,1.1 0.7,1.5 0.3,0.4 0.7,0.8 1.1,1.3 0.7,0.8 1.5,1.5 1.8,2 l -0.3,4.1 c -0.1,1 0.4,2 1,2.6 0.6,0.6 1.3,1.1 2,1.5 0.7,0.4 1.3,0.8 1.7,1.2 0.4,0.4 0.6,0.6 0.6,1 0,1.3 -0.5,2.2 -0.5,4.2 0,0.9 0.5,1.7 1.1,2.1 0.6,0.4 1.2,0.7 1.8,0.9 0.6,0.2 1.1,0.4 1.4,0.6 0.3,0.2 0.3,0.2 0.3,0.3 0,0.6 -0.1,0.8 -0.3,1.2 -0.2,0.3 -0.5,0.7 -0.5,1.5 l 0,0.6 c 0,1.8 1,2.9 1.9,3.5 0.8,0.6 1.3,0.8 1.5,1.3 0,0 0,0 0,0 0.2,0.8 0.3,2 0.7,3.1 0.2,0.6 0.5,1.2 1,1.6 0.5,0.5 1.2,0.7 2,0.7 l 0.3,0 c 1.1,0 1.9,-0 2.6,-0.2 0.7,-0.1 1.3,-0.4 1.7,-0.9 0.4,-0.5 0.5,-1.1 0.7,-1.7 0.1,-0.6 0.2,-1.3 0.3,-2.1 7.6e-4,-0 -7.6e-4,-0 0,-0 0.2,-1.4 0.7,-2.1 1.3,-2.8 0.5,-0.7 1.2,-1.7 1.2,-3.1 0,-0.6 -0.2,-1 -0.5,-1.3 -0.2,-0.3 -0.5,-0.7 -0.7,-1 -0.5,-0.7 -0.8,-1.5 -0.8,-2.4 l 0,-0.9 c 0,-0 -0,-0 0.1,-0.2 0.2,-0.2 0.5,-0.4 0.8,-0.6 0.4,-0.3 0.8,-0.5 1.1,-1 0.4,-0.4 0.7,-1.1 0.7,-1.8 0,-1.2 -0.5,-2.4 -0.9,-3.5 -0.4,-1.1 -0.8,-2.2 -0.8,-2.5 0,-0.5 0.2,-1 0.6,-1.6 0.4,-0.6 1,-1.3 1.5,-2.2 0.5,-0.8 0.9,-1.8 0.9,-3 -0,-1.1 -0.5,-2.4 -1.6,-3.6 l -0,-0 -0,0 c -0.3,-0.3 -0.7,-1.3 -0.8,-2.2 -0.1,-0.9 0.1,-1.9 0.4,-2.3 0.3,-0.5 0.9,-0.9 1.7,-1.4 0.7,-0.6 1.5,-1.6 1.5,-3 l 0,-1.4 38.1,0 0,-2 -40.1,0 -30.6,0 -0.6,0 -15,0 z"
            }
        ], i["AC.IC.VOLCANIC ERUPTION"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 122.2,66 -10.4,17.9 1.7,1 10.4,-17.9 -1.7,-1 z m -23.2,0.5 0,17.9 2,0 0,-17.9 -2,0 z m -19.5,-0.4 -1.8,0.8 8,17.9 1.8,-0.8 -8,-17.9 z M 99.3,120.8 c -1.7,-0 -3.3,0.8 -4.5,2 -1.2,1.2 -2,2.9 -2,4.5 l 0,1.9 c 0,1.7 0.8,3.3 2,4.5 1.2,1.2 2.8,2 4.5,2 l 1.3,0 c 1.7,0 3.3,-0.8 4.5,-2 1.2,-1.2 2,-2.8 2,-4.5 l 0,-1.9 c 0,-1.7 -0.8,-3.3 -2,-4.5 -1.2,-1.2 -2.8,-2 -4.5,-2 l -1.2,0 -0,0 z M 80.3,86.5 c -0.5,0 -0.9,0.3 -1.4,0.8 -0.4,0.5 -0.8,1.2 -1.3,2 -0.8,1.7 -1.6,3.9 -2.4,6.3 -1.5,4.7 -2.8,9.8 -3.4,11.4 l -0,0 c -2,7 -5.8,15.2 -7,21.6 l -0.1,0.2 0.2,0 20.9,0.6 0.2,0 0,-0.2 0,-1.9 0,-0.2 -0.2,-0 -17.6,-0.7 L 80.5,89.4 l 39.1,0 11.9,37.1 -17.5,0.7 -0.2,0 0,0.2 0,1.9 0,0.2 0.2,-0 20.9,-0.6 0.2,0 -0.1,-0.2 c -1.3,-6.4 -5.1,-14.7 -7,-21.6 L 128.1,107 c -0.6,-1.6 -1.9,-6.7 -3.4,-11.4 -0.8,-2.3 -1.6,-4.6 -2.4,-6.3 -0.4,-0.8 -0.8,-1.5 -1.3,-2 -0.4,-0.5 -0.9,-0.8 -1.4,-0.8 l -39.4,0 z"
            }
        ], i["AC.IC.VOLCANIC THREAT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 80.3,85.6 c -0.5,0 -0.9,0.3 -1.4,0.8 -0.4,0.5 -0.8,1.2 -1.3,2 -0.8,1.7 -1.6,3.9 -2.4,6.3 -1.5,4.7 -2.8,9.8 -3.4,11.3 l 0,0 -0,0 c -2,7 -5.8,15.2 -7,21.6 l -0.1,0.2 0.2,0 20.9,0.6 0.2,0 0,-0.2 0,-1.9 0,-0.2 -0.2,-0 -17.6,-0.7 12,-37.1 39.1,0 11.9,37.1 -17.5,0.7 -0.2,0 0,0.2 0,1.9 0,0.2 0.2,0 20.9,-0.6 0.2,-0 -0.1,-0.2 c -1.3,-6.4 -5.1,-14.7 -7,-21.6 l -0,0 0,-0 c -0.6,-1.6 -1.9,-6.7 -3.4,-11.3 -0.8,-2.3 -1.6,-4.6 -2.4,-6.3 -0.4,-0.8 -0.8,-1.5 -1.3,-2 -0.4,-0.5 -0.9,-0.8 -1.4,-0.8 l -39.4,0 z M 99.3,120 c -1.7,-0 -3.3,0.8 -4.5,2 -1.2,1.2 -2,2.9 -2,4.5 l 0,1.9 c 0,1.7 0.8,3.3 2,4.5 1.2,1.2 2.8,2 4.5,2 l 1.3,0 c 1.7,0 3.3,-0.8 4.5,-2 1.2,-1.2 2,-2.8 2,-4.5 l 0,-1.9 c 0,-1.7 -0.8,-3.3 -2,-4.5 -1.2,-1.2 -2.8,-2 -4.5,-2 l -1.2,0 -0,0 z m -2.7,-42.1 0,0.2 -0.2,0 0,4.2 0,0.2 0.2,0 3.3,0 0.2,0 0,-0.2 0,-4.2 0,-0.2 -0.2,0 -3.3,0 z M 99,57.1 c -1.1,2.5e-5 -2.3,0.2 -3.3,0.5 -1.1,0.3 -2.1,0.8 -3.2,1.4 l -0.1,0.1 0,0.1 0,3.1 0,0.4 0.3,-0.2 c 1.1,-0.7 2,-1.3 3,-1.6 1,-0.4 1.9,-0.6 2.7,-0.6 1.1,2.2e-5 2,0.3 2.7,0.8 0.7,0.6 1,1.3 1,2.2 -1e-5,0.5 -0.1,1 -0.4,1.5 -0.3,0.5 -0.7,1 -1.3,1.6 l 0,0 -1.5,1.5 c -1,0.9 -1.7,1.8 -2,2.5 -0.3,0.7 -0.5,1.7 -0.5,2.8 l 0,2.5 0,0.2 0.2,0 3.1,0 0,-0.2 0.2,0 0,-2 c -10e-6,-0.6 0,-1 0.1,-1.3 0,-0.3 0.1,-0.6 0.1,-0.8 0.1,-0.2 0.2,-0.5 0.4,-0.8 0.2,-0.3 0.6,-0.7 1.1,-1.2 l 1.4,-1.4 c 1,-0.9 1.7,-1.8 2.1,-2.6 l 0,-0 c 0.4,-0.8 0.6,-1.6 0.6,-2.5 -2e-5,-1.8 -0.6,-3.3 -1.9,-4.3 -1.3,-1.1 -2.9,-1.6 -5,-1.6 z"
            }
        ], i["AC.IC.CAVE ENTRANCE"] = [
            {
                type: "path",
                fill: !1,
                d: "m 55,100 55,0 30,-20 0,40 -30,-20"
            }
        ], i["AC.IC.DROUGHT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 87.6,127.4 c 1.3,0.6 4.5,0 6.1,0 h 4.2 l -2,-5.9 -4.9,-0.3 c -5.7,10.8 -2.4,4.3 -3.4,6.2 z m -24.1,-7 c -0.6,1.9 17.6,6.9 20.5,7.4 2.7,-1.8 4.5,-2.4 4.8,-6.7 -4,0 -11.4,-0.8 -14.8,-1.7 -2.2,-0.6 -4.2,-1.2 -6.4,-1.7 -3.5,-0.9 -4.2,-1.5 -4.2,2.6 z m 35.9,6.1 6.7,-0.3 18.6,-1.7 c 1.5,-0.4 4.5,-0.4 6,-1.4 -1.3,-2.6 -2.4,-4.1 -3.7,-6.6 -1.4,-2.6 -1.9,-4.9 -3,-7.2 -3.7,0.8 -4.7,3.5 -6.3,4 -3.5,1.1 -4.8,0.4 -6.7,3.8 -1.7,3 -2.5,3.3 -5.3,5.2 -2.4,1.7 -3.6,2.8 -6.3,4.2 z m -2.8,-9 c 0,3.7 0.5,4.2 2.2,7.3 l 8.5,-7.1 -0.2,-0.2 c -1.7,-0.4 -2.4,-1.5 -4.8,-2.2 -1.6,-0.4 -4.1,-1.3 -5.8,-1.4 v 3.6 h 0.1 z m 37.6,0.5 c -0.9,0 -1,-0.2 -1.9,-0.2 l 1,2.4 2.7,-2.8 c -0.9,0.2 -0.8,0.5 -1.8,0.5 z m -51.3,-0.3 c -0.1,1.9 7.7,1.5 9.3,1.5 h 2.8 c 0,-1.7 -0.7,-2.8 -0.8,-4.4 -0.1,-2.5 -0.4,-1.8 -3.1,-2.1 -4,-0.4 -4.6,-2 -7.7,-2.8 l -0.6,7.7 z m -25.5,-12.6 3,12.1 c 0.7,-3 2.2,-4.5 2.8,-7.3 0.3,-1.8 0.1,-2.6 0.9,-4 0.4,-0.7 1.3,-2.8 1.5,-3.6 -1.4,-0.3 -6.9,-1.6 -8.6,-1.6 l 0.4,4.4 z m 69.9,-2.2 c -1,4.1 -0.7,3.5 1,7 1.2,2.4 2,4.4 3.1,6.6 5.8,-0.5 6.2,-0.5 9.4,-3.6 1.6,-1.6 1,-6.8 2,-8.3 -2.5,-1.2 -1.7,-0.6 -4.6,-1.3 -4.5,-1 -6.6,-0.4 -10.9,-0.3 z m -30.9,1.1 v 0.8 c 0,2.2 -0.1,3.3 0,5.4 0.1,3.3 -0.3,2.5 3.1,2.8 1.2,0.1 3.5,1 4.5,1.4 0.7,0.4 1.5,0.5 2,0.8 0.8,0.4 0.3,0.6 1.7,1.4 l -0.2,-0.2 5.6,-4.7 c 3.1,0 4.2,0.4 5.8,-1.3 2.4,-2.5 0.8,-1.4 4,-3.1 l 0.6,-3.1 c -2.5,0.6 -5.5,2.2 -8.2,1.1 -2.6,-1.1 -3.8,-2.8 -7.4,-2.8 l -1.6,-0.3 -9.9,1.8 z m -32.1,11.2 c 1.3,0 5.8,0.7 6.9,1 1.4,0.4 4.7,2.3 5.6,2.3 h 2.8 c 1,0 0.9,-0.3 1.7,-0.5 l 1.7,-8.3 -5.2,-4.5 -9,-2 c -0.4,1.7 -2.4,3 -3.1,5.1 -0.3,0.7 -1.5,6.3 -1.5,7 z m 41,-35.1 c 1,1.2 1.4,2.8 2.2,4.2 0.4,0.6 2.9,3.3 2.9,3.5 0,0.8 -0.9,2.3 -1.3,2.3 -2.7,0 -3.8,-6.7 -3.8,-10 z m -1.8,-1.2 c -0.3,1 -1.9,4.5 -2.5,5.6 -0.9,1.8 -1.9,3.5 -4.4,3.5 -0.5,0 -1,-0.4 -1,-0.8 0,-3.1 3.8,-5.8 5.2,-7.6 l 2.8,-0.8 z m 9.5,8.6 h -0.8 c -2.3,0 -6.9,-8 -6.9,-9.7 0,-0.1 0.3,-0.5 0.3,-0.5 1.7,0.5 7.9,6 7.9,8.7 -4e-4,0.5 -0.4,0.8 -0.5,1.5 z m 0.6,-6 c -0.7,-0.3 -1.7,-1 -2.4,-1.3 -1.4,-0.8 -3.5,-2.9 -4.7,-3.3 l 1.1,-1.3 c 3.1,1.5 10.1,1.3 10.1,5.7 0,0.3 -0.8,0.8 -1,1 -0.8,-0.3 -2,-0.4 -3.1,-0.8 z m -24.9,1.3 h -1 c 1,-2 -2.2,-6.7 -4.4,-7.2 -2.2,1.2 -4.2,0.6 -5.5,3.3 -0.4,1 -0.7,2.2 -1.5,2.8 -0.8,0.6 -2.4,0.8 -2.4,1.9 0,1.5 4.3,0.4 4.9,-0.2 1.2,-1.1 2.4,-2.1 4.5,-2.1 2,0 2.9,5.8 3.1,8.2 0.2,3.2 -2.3,7.7 -2.2,9.5 l 0.9,6.8 -4.4,-0.3 c 2.1,3.1 8.5,6 13.4,6.4 l -0.4,-7.7 -5.6,1.3 c 0,-4.4 -2,-5.5 -0.5,-9.5 0.6,-1.7 1,-2.2 1,-4.7 0,-1.1 0.2,-4.6 0.6,-5.3 1.5,-2.5 1.9,-5.6 3.1,-8.4 1.2,-2.8 5,-2.6 8.3,-3.5 l 1.2,1.3 -1,0.3 0.8,1.8 c -1.7,2 -2.9,2.9 -4.5,5 -0.8,1 -3.8,6.3 -0.6,6.3 h 1 c 3.9,0 5.1,-7.1 6.9,-9.2 0.4,4.4 1.2,9.5 4.4,11.2 1.7,-0.4 2.2,-1.1 2.6,-2.8 0.7,0.2 0.5,0.3 1,0.3 1.3,0 2,-1.1 2,-2.3 V 85.8 c 0,-2.1 -1.2,-2.4 -1.5,-3.8 0.8,0.4 2.2,1 3.3,1 h 0.5 c 1.2,0 1.3,-0.6 1.8,-1.3 -0.2,-2.5 -1.5,-3.9 -3.5,-4.6 -1.3,-0.4 -5.2,-1.7 -6.7,-1.7 l 0.5,-1 h -0.7 l 0.8,-1.6 -4.9,1 c -0.9,-0.6 -1.2,-1.5 -2.6,-1.5 h -1.8 C 92.3,72.2 88.7,75.8 88.7,82.9 l 0,0 z"
            }
        ], i["AC.IC.FLOOD"] = [
            {
                type: "path",
                stroke: !1,
                d: "M77.2,92.9L77.3,92.8L99.3,72.5L99.7,72.1L100,72.1L100.4,72.5L122.4,92.8L123.5,93.9L122.4,93.9L122.4,115.902C123.023,115.106 123.657,114.5 124.4,114.5C125.454,114.199 124.857,116.712 125.5,117.6C125.988,118.273 126.805,118.721 127.609,118.928C130.146,119.58 132.747,117.303 134.5,116.2C135.043,115.859 136.356,115.26 136.4,115.9C136.652,119.558 136.526,123.235 136.4,126.9L63.7,126.9L63.7,114.9C64.819,117.943 66.835,120.948 70.637,119.05C72.357,118.192 73.209,115.745 75.1,115.4C75.464,115.334 76.266,116.335 77.1,117.278L77.1,93.9L76.2,93.9L77.1,93L77.1,92.9L77.2,92.9ZM121.2,117.544L121.2,94.1L78.3,94.1L78.3,118.49C78.521,118.667 78.727,118.795 78.911,118.845C83.407,120.084 82.345,116.009 86.9,115.5C87.588,115.423 90.549,119.114 91.583,119.536C95.694,121.215 95.826,116.694 98.9,115.9C100.074,115.597 100.538,118.237 100.9,118.5C101.86,119.198 103.028,119.651 104.2,119.837C109.33,120.655 108.685,117.216 111.9,114.9C112.848,114.217 113.556,116.602 113.563,116.613C115.1,119.229 115.092,120.273 118.659,119.606C119.666,119.418 120.465,118.529 121.2,117.544ZM99.75,73.846L99.8,73.8L99.7,73.8L99.75,73.846L79.3,92.7L120.2,92.7L99.75,73.846Z"
            }
        ], i["AC.IC.INVERSION"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 69.5,87.9 C 69.5,86.7 73.6,83.9 75.5,83.9 h 0.3 c 3.3,0 9,9.1 15.2,9.1 h 1.8 c 5.4,0 11.3,-9.1 14.9,-9.1 3.5,0 8.8,9.1 15.2,9.1 h 0.9 c 8.5,0 10.5,-4.4 15.5,-7 l -5.3,-6.4 c -3.4,1.8 -4.1,4.6 -9.5,5.3 -2.2,0.3 -6.6,-3.9 -8.3,-5.5 -8,-6.8 -13,-3 -19.4,2 -3.9,3.1 -3.9,5.3 -8.5,1.3 -2.2,-1.8 -5.6,-4.8 -8.2,-6 -3.8,-1.8 -8.6,-0.7 -11.4,1.2 -1.6,1 -7.3,5.2 -7.3,6.9 v 52.2 h 8.2 V 87.9 z m -9.4,-16.4 79.9,0 0,-8.5 -79.9,0 z"
            }
        ], i["AC.IC.TSUNAMI"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 63,122 39.5,-0.1 30.8,0.3 c -7.1,0 -12.8,-1.7 -16.9,-4.8 -3.7,-2.9 -7.7,-8 -7.7,-14.4 0,-9.1 6.9,-16.5 15.8,-16.5 h 0.7 c 6.5,0 8.2,2.8 11.8,5.3 -2,-8.6 -10.6,-14.2 -21.4,-14.2 h -0.2 c -18.2,0 -44.9,33 -52.4,44.3 l 0,0 0,0 z"
            }
        ], i["AC.IC.BIRD"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 81.6,92.5 -18.4,2.9 v 0.3 l 6.6,0.5 c -0.7,0.5 -3.3,1.1 -4.5,1.5 -2.6,0.9 -2,0.3 -3.5,2.4 l 3.4,0.1 -1,1 c 1.8,0 3.3,0.1 4.8,0.2 1.4,0.1 1.9,-1.3 3.5,-1.4 3,-0.2 5.7,0.2 9.3,0.3 l -0.8,0.5 c 0.6,0.1 0.7,0.2 1.4,0.2 h 1.6 l 0.1,0.9 2.9,1.2 1.6,-0.1 c 1.6,1.1 1.9,2.3 5.2,2.4 0.2,2.7 0.6,3.8 3,4.4 v 0.8 c 0,2.2 0.2,4.8 2.1,5 l 1.2,5.3 h -0.4 v 0.4 c -0.3,-0.3 -1.4,-1.2 -1.8,-1.2 h -0.2 c -0.5,0 -0.5,0.1 -1,0.2 0.6,0.8 2.7,1.7 3.1,2.7 0.5,1.6 0.1,3.8 0.2,5.3 l 0.9,0.6 0.8,-0.1 0.1,-0.8 -0.1,-2.7 c 0.7,0.5 2.7,3 3.3,3 h 1 c -0.5,-2 -1.8,-2.4 -2.7,-3.9 l 3.7,1.1 c -1,-1.5 -0.9,-1.8 -2.9,-2.3 -3.1,-0.8 -1.8,-1.9 -3.1,-2.2 l -1,-5.4 c 1,-0.2 1.4,-1 1.4,-2.2 l 0.1,-1.6 -0.3,-2.6 h 1 c 0.7,0 0.7,-0.2 1.4,-0.4 0.1,1.6 1.2,3.3 2.7,3.4 l 3.1,6.3 c -0.3,0.3 -0.4,0.3 -0.4,0.8 v 0.7 l -4.4,-0.9 v 0.2 c 0.8,0.7 3.7,1.7 5.1,2.8 1.1,0.8 1.2,0.6 2,1.9 0.3,0.5 1.3,2.2 1.9,2.2 h 0.8 l 0.2,-0.1 -1.7,-3.2 4.3,1.9 c -0.1,-2.1 -2.1,-1.5 -3.6,-2.8 h 3 c -1.3,-1.1 -1.6,-0.9 -3.5,-1.2 -1.6,-0.2 -1.7,-1.2 -2.7,-2.1 -1.1,-1.2 -2,-4.9 -2.9,-6.6 1.2,-1.8 1,-1.4 1,-4.4 4.8,-2.3 5.6,-2.1 9.3,-5.9 2.7,-2.7 3.9,-6.1 5.8,-9.7 0.9,-1.8 1.5,-3.3 2.2,-5.2 0.7,-1.8 0.7,-4.7 1.4,-6.3 2.3,-4.6 9,-3.2 10.3,-5.2 l -4.4,0.2 v -0.2 l 5,-0.6 c -2.2,-1.9 -4.8,-1.4 -8.3,-1.8 -2.1,-0.3 -2.9,0.7 -4.4,-0.3 -1.4,-1 -1.6,-1.2 -3.7,-1.5 -3.1,-0.5 -5.6,1.2 -7.4,2.5 -1.7,1.3 -3.2,5.2 -4.2,6.1 -0.3,0.2 -6.1,2.7 -7.1,3.2 -2.9,1.5 -3.5,2.5 -7.3,3.1 -6.3,1 -9.9,3.4 -14.2,6.3 l 0,0 z"
            }
        ], i["AC.IC.INSECT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 77.4,88.8 0.1,-0.3 6.1,4.9 -0.1,0.2 c -2.2,1.5 -7.7,9 -10,9 l -1.6,-0.1 5.6,-13.7 z m 7.1,3.3 c -0.4,-1.7 -5,-6.4 -6.7,-7.2 -0.4,0.3 -1.8,1 -1.8,1.6 0,0.8 0.3,1 0.5,1.5 l -5.6,14.7 h -1 c 0.2,0.9 0.5,0.7 0.5,1 0,0.3 -3,7.8 -3.3,8.7 -0.6,1.4 -1,2.7 -1.6,4.2 -0.3,0.8 -0.6,1.6 -0.9,2.2 -0.5,1.1 -0.6,0.3 -1.4,1.7 l -1.3,0.3 c 0.3,0.5 1.8,0.5 2.5,0.4 1.2,-0.2 0.4,-1 0.8,-2.2 0.7,-1.8 1.4,-3.5 2.1,-5.4 0.5,-1.2 3.7,-10.3 4.6,-10.3 h 1.3 c 0.8,0 1,0.3 1.5,0.5 l 2.3,-2.8 c 2.7,1.8 8.5,4.6 12.8,4.6 h 0.7 l 0.2,-0.1 -3.5,-5 -9.9,-0.1 6.5,-6.3 c 4.3,2.9 11.7,16.9 14.9,16.9 h 0.3 c 1.4,0 1.3,-0.6 1.8,-1.6 -0.9,-3.7 -4.8,-6.3 -7.3,-8.5 -2.4,-2 -6.1,-6.5 -8.3,-7.9 1.2,-1.7 10.3,-10.8 12.2,-11.3 l 0.9,7.7 0.1,2.9 -1.2,7.4 h -1.8 l 5.2,4.4 7.2,-3.9 c -0.5,2.1 -0.3,2.5 -2.2,3.4 -0.6,0.3 -3.7,1.9 -3.7,2.3 0,0.5 0.7,1.7 0.7,3.1 0,2.9 -3.1,4.4 -5.8,3.3 -2.1,-1 -4.9,-5.1 -5.5,-5.1 h -1 c -4.6,0 -6.7,1.6 -10.5,1.6 h -0.5 c -1.9,0 -2.5,-0.7 -4.1,-0.7 h -0.5 c -0.6,0 -1,0.4 -1,1 0,3.2 12.3,4.7 16.9,4.6 l 13.1,-0.3 v 0.3 c -0.9,1.3 -5.8,4.8 -8,4.8 -0.1,0.2 -0.5,0.7 -0.5,0.8 0,0.7 0.1,0.7 0.3,1.3 0.7,0.1 0.5,0.3 1,0.3 0.5,0 0.5,-0.2 1,-0.5 v -1.3 l 7.7,-5.4 -1.6,6.1 c -0.9,0.1 -1.3,0.4 -1.3,1.3 0,0.9 0.5,0.7 1.4,1.2 l 1.2,-1.4 c 0,-0.2 -0.7,-1.3 -0.7,-1.4 0,-1.3 2.4,-7.6 2.8,-9.5 l 15.6,-0.5 1.2,8.4 -0.4,0.1 c 0.3,0.5 0.3,1 1,1 1,0 1.1,-0.3 1.6,-0.7 -0.5,-1 -0.5,-1.9 -1.7,-1.3 l -0.8,-6.7 4.8,5.5 -0.7,0.8 1.4,1.2 c 0.5,-0.3 1,-0.2 1,-1 v -0.5 c 0,-0.9 -0.9,-1 -1.6,-1.2 l -4.5,-5 0.3,-1 h -8.5 c 0,-5 2,-8.2 2.3,-12.4 l -9.2,0.4 -0.8,2.5 h -4.6 c -1.8,0 -2.8,-8 -2.9,-10.3 0,-2.4 -0.3,-4.1 -0.2,-6.4 0.1,-1.4 1,-5.1 -1,-5.1 h -0.7 c -1,0 -1.3,1 -1.6,1.8 -0.3,1 -1,1.4 -1.6,2 -1.2,1.3 -2.3,2.4 -3.5,3.6 -1.2,1.2 -6.2,6.7 -7.4,7 l 0,0 z m 37.9,8 c 0,-0.3 0.3,-0.5 0.7,-0.5 h 0.7 l 0.1,0.5 -0.3,1 h -1 c -0.1,-0.7 -0.3,-0.4 -0.3,-1 z m 3.6,-1.8 c -0.2,0 -1.6,-1.8 -3.3,-1.8 h -0.5 c -2,0 -2,2.2 -2.5,3.9 -0.5,1.4 -1.4,3.7 -1.4,5.4 0,0.6 0.4,1 1,1 2.4,0 6.4,-5.2 6.9,-7.4 3.9,0 11.1,-1.1 11.8,-3.9 -2.6,0.7 -2.9,2.4 -8,2.8 1.8,-1.6 5.6,-4.3 5.9,-7.2 h -0.5 c -0.8,3.1 -5.6,7.2 -9.5,7.2 z"
            }
        ], i["AC.IC.MICROBIAL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 83.9,93.3 c -3.3,0 -6,2.7 -6,6 0,3.3 2.7,6 6,6 3.3,0 6,-2.7 6,-6 0,-3.3 -2.7,-6 -6,-6 z M 100,85.5 c -11.1,0 -21.2,1.5 -28.6,4.1 -3.7,1.3 -6.7,2.8 -8.8,4.5 -2.1,1.7 -3.4,3.7 -3.4,5.9 0,2.2 1.3,4.2 3.4,5.9 2.1,1.7 5.1,3.2 8.8,4.5 7.4,2.5 17.5,4.1 28.6,4.1 11.1,0 21.2,-1.5 28.6,-4.1 3.7,-1.3 6.7,-2.8 8.8,-4.5 2.1,-1.7 3.4,-3.7 3.4,-5.9 0,-2.2 -1.3,-4.2 -3.4,-5.9 -2.1,-1.7 -5.1,-3.2 -8.8,-4.5 C 121.2,87.1 111.1,85.5 100,85.5 z m 0,1.4 c 11,0 21,1.5 28.2,4 3.6,1.2 6.5,2.7 8.4,4.3 1.9,1.6 2.9,3.2 2.9,4.8 0,1.6 -1,3.3 -2.9,4.8 -1.9,1.6 -4.8,3 -8.4,4.3 -7.2,2.5 -17.1,4 -28.2,4 -11,0 -21,-1.5 -28.2,-4 -3.6,-1.2 -6.5,-2.7 -8.4,-4.3 -1.9,-1.6 -2.9,-3.2 -2.9,-4.8 0,-1.6 1,-3.3 2.9,-4.8 1.9,-1.6 4.8,-3 8.4,-4.3 7.2,-2.5 17.1,-4 28.2,-4 z"
            }
        ], i["AC.IC.REPTILE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 93.5,82.3 c 0,-2 1.8,-2.7 1.8,-4.3 0,-1 -0.6,-1.5 -1.2,-2 -2.8,0.3 -6.5,0.6 -7.4,2.7 -0.5,1.2 -0.5,2.4 -1.2,3.9 -0.5,1 -1.2,2.4 -1.2,3.8 0,0.8 0.4,0.7 0.4,1.6 v 0.8 c 0,2.2 -2.4,3.5 -0.6,6.1 -0.2,0.3 -2,1.5 -2.4,1.7 -1.7,1 -1.8,-0.6 -2.6,-0.6 h -0.8 l -0.3,-1.2 c -0.5,-0.3 -1,-0.8 -1.7,-0.8 -0.8,0 -0.8,0.5 -0.6,1 l -2.1,0.4 -0.8,2.3 h 1 c 0.9,0 1.4,0.4 1.6,1.2 l -1.5,1.2 -0.1,0.4 c 2.8,0.3 4.6,-0.6 7.2,-1.2 1.5,-0.4 6.8,-0.6 7.3,-1 l 0.1,-2.2 c 1,0.3 2,1.3 3.1,1.7 1.2,0.4 1.7,0.8 3.1,1.2 2.4,0.6 4.5,1.2 7.7,1.2 h 0.6 l 6.1,-0.6 c 0,2.6 2.3,2.5 2.8,4.5 -1.3,-0.3 -2.3,-2 -3.5,-2 -0.1,0 -0.4,0.1 -0.6,0.2 l 0.3,1.2 -1.6,0.3 v 0.8 l 0.6,0.4 -0.9,0.6 1,1 c -0.2,0.8 -0.7,0.6 -0.7,1.3 0,0.4 0.1,0.6 0.6,0.6 0.6,0 1.6,-1 2.8,-1 1.9,0 8.3,0.8 8.3,-0.8 v -0.2 c 0,-1.5 -3.5,-1.6 -3.3,-5.5 5,2.6 9.3,7.4 4.5,13.6 -1.5,2 -4.1,3.6 -6.7,4.5 -1.4,0.5 -7.4,1.9 -9.3,1.5 -4.2,-0.8 -5.4,-0.8 -8.8,-2.4 -2.6,-1.2 -4.7,-2.5 -7,-4 -3.9,-2.4 -10,-6.1 -16.1,-6.1 -5,0 -11.4,3.1 -11.4,7.9 1.2,-0.6 1.3,-1.3 2.1,-2.2 0.5,-0.6 1.7,-1.3 2.4,-1.7 1.5,-1 3.9,-1.8 6.5,-1.8 h 1 c 4.4,0 11.6,4.7 14.5,6.7 4.5,3.1 8.1,5.5 14.7,6.7 7,1.2 12.7,-0.1 17.4,-2.8 1.9,-1.1 4.3,-3.3 5.5,-5.1 1,-1.6 2.9,-5.4 2.7,-8 l -0.3,-2.6 c 0.3,0.1 2.8,3.7 3.6,4.5 0.8,0.8 3.8,2.5 5.3,2.5 1,0 4.4,-2.2 4.7,-2.9 l -1.3,-0.6 1.2,-1 c -1.5,-1 -0.8,-0.6 -2.4,-0.6 h -1 c 0,-1.4 -0.3,-1.8 -1.3,-1.6 l 0.2,0.1 -1.7,3.4 c -1.4,0 -2.9,-0.9 -3.6,-1.8 0,-0.1 -1.3,-3.8 -1.3,-3.9 -0.6,-2 -0.6,-2.2 -1.8,-3.6 -1.2,-1.3 -1.9,-1.2 -3.4,-1.9 l -0.1,0.6 c -0.6,-1.8 -6.2,-6.5 -8.1,-7.4 -2.2,-1.2 -3.2,-1.2 -6,-1.7 -2.1,-0.3 -5.4,0.3 -7,-0.5 0.4,-1.5 1.6,-0.6 1.6,-2.2 0,-0.5 -0.7,-0.4 -1.2,-0.4 0.6,-1.2 -0.3,-1 -1.3,-1 0.1,-0.3 0.4,-0.6 0.4,-1 0,-0.3 -0.3,-0.4 -0.6,-0.4 -0.4,0 0,0.6 -1.3,0.6 -0.3,-1 -0.3,-1.3 -1.5,-1.4 v 1.6 h -1.3 v 0.6 c 0,0.8 0.6,1.5 1,2.2 -0.4,0.7 -0.3,2 -1.4,2 -0.6,0 -1.8,-1.5 -3.1,-1.9 -1.3,-0.4 -3,0.5 -3,-1.5 -0,-0.9 2.1,-2.5 2.8,-3.5 l 0,0 z"
            }
        ], i["AC.IC.RODENT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 117.2,80.3 c 0.6,1.2 0.6,1.7 1.5,2.6 0.6,0.7 1.8,1.2 1.9,2.2 -2,-0.1 -4.2,-3.3 -4.4,-5.3 -2.1,-0.5 -8.4,-3.6 -10.9,-4.7 -3.1,-1.3 -8.3,-2.7 -12.7,-2.7 h -2.2 c -4,0 -9,2.5 -11.3,4.2 -3,2.2 -5.2,5.2 -5.2,10.4 v 0.7 c -4.6,1.1 -11.7,8.4 -11.7,13.9 v 2.4 c 0,6.2 7.7,10 11.8,12.7 2.5,1.7 4.7,3.3 7,5.1 2.2,1.7 4.7,4.2 6.7,5.5 -2.1,-9 -22.4,-12.7 -22.4,-25.1 0,-4.5 4.9,-9.3 8.5,-10.2 -0.1,0.6 -0.3,0.6 -0.3,1.3 v 0.5 c 0,4.5 7.8,4.1 11.5,3 5.1,-1.5 8.1,-2.2 13.6,-1.2 5.4,1.1 8.3,1.5 12.7,3.6 3.7,1.9 2,1.2 4.2,3.8 1.1,1.3 1,1.1 2.9,1.3 0.8,0.1 1.8,1 2.4,1.5 h 1.7 c -1.3,-2.6 -4.9,-2.9 -5.6,-5.8 0.8,-1.5 1.7,-1.7 3.9,-1.7 0.8,0 1,0.2 1.7,0.3 -0.3,-0.6 -0.6,-1.7 0.5,-1.7 h 1.9 c 4.5,0 9,2.5 12.7,0 0,-3 0.4,-2.2 -0.9,-4.9 -0.5,-0.8 -2.1,-2.7 -2.8,-3.4 -1.6,-1.5 -5.7,-4.1 -6.7,-5.5 0,-2.8 -0.4,-3.4 -2.7,-3.9 l -0.5,1 0.5,2.7 -1,0.3 v 0.9 h -0.8 c -0.2,-2.4 -1.2,-5.8 -3.6,-5.8 h -0.2 c -1.8,-4e-4 -1.5,1 -2,1.9 z m 9.5,24.6 h 1.2 c -0.2,-2.6 -5.1,-2.8 -5.4,-5.4 l -2.2,0.3 c 0.2,1.5 1.1,2.9 2.4,3.5 0.9,0.3 1.5,0 2.3,0.6 0.4,0.3 1.1,1 1.7,1 z m -45.1,-6.1 c 1.2,1.8 5.9,4.2 8.8,4.2 1,0 1.6,-0.8 1.9,-1.5 -0.9,-1.3 -2.9,-2.8 -4.7,-3.1 -3.7,-0.8 -2.9,0.1 -6,0.4 l 0,0 z m 9.5,-1.9 c 1.3,2 5,2.9 8.3,2.9 0.8,0 1.4,-0.4 1.9,-0.7 -2,-2.9 -6.1,-2.6 -10.2,-2.2 z"
            }
        ], i["AC.IC.PHARMACY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 83.3,74.5 h 13.2 c 3,0 6.2,3.8 6,7.3 -0.1,3.6 -2.9,6.6 -6.5,6.6 H 83.3 V 74.5 z m -8.7,45.9 h 8.7 V 98 h 2.4 c 0.6,0 13.6,16.1 13.6,17.2 0,0.6 -13.6,16.6 -15,19.3 l 10.5,-0.1 10.3,-12.2 9.6,12.3 10.9,-0 -15.2,-19.3 14.4,-17.8 -10.2,-0.1 -9.7,10.8 -7.4,-10 c 8.5,-2 14.1,-6.8 14.1,-17.2 0,-8.1 -7,-15.3 -15,-15.3 H 74.6 v 54.8 z"
            }
        ], i["GR.IN.IC.EDUCATIONAL FACILITIES INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 99.6,107.1 h -14.8 v 31.7 h 32 v -31.7 h -14.8 V 95.2 c 0,-0.6 6.5,-3 7.5,-3.4 1.3,-0.5 6.9,-3 7.9,-3 -0.3,-0.4 -14.7,-6.3 -15.7,-6.3 h -2.3 v 24.5 z m -3.1,-45 -5.6,14.8 1.7,0 1.3,-3.8 0.1,-0.1 0.1,0 6.8,0 0.1,0 0.1,0.1 1.3,3.8 1.7,0 -5.6,-14.8 -2.1,0 z m 0.8,1.8 0.2,0.1 0.2,-0.1 2.8,7.5 0.1,0.3 -0.3,0 -5.6,0 -0.3,0 0.1,-0.3 2.8,-7.5 z m -14.8,-1.8 8.3,0 0,1.3 -6.5,0 -0.2,0 0,0.2 0,4.5 0,0.2 0.2,0 5.8,0 0,1.3 -5.8,0 -0.2,0 0,0.2 0,7 -1.6,0 0,-14.8 z m 30.3,-0.3 c 0.9,1.5e-5 1.7,0.1 2.5,0.4 l 0,0 c 0.8,0.2 1.4,0.6 2.1,1 l 0,1.6 c -0.6,-0.5 -1.3,-0.9 -1.9,-1.2 -0.8,-0.3 -1.7,-0.5 -2.6,-0.5 -1.8,1.4e-5 -3.2,0.6 -4.1,1.7 -1,1.1 -1.4,2.7 -1.4,4.7 -1e-5,2 0.5,3.6 1.4,4.7 1,1.1 2.4,1.7 4.1,1.6 0.9,2e-6 1.8,-0.2 2.6,-0.5 0.7,-0.3 1.3,-0.7 1.9,-1.2 l 0,1.6 c -0.7,0.4 -1.4,0.8 -2.1,1 -0.8,0.2 -1.6,0.4 -2.5,0.4 -2.3,0 -4,-0.7 -5.3,-2 -1.3,-1.4 -1.9,-3.2 -1.9,-5.6 0,-2.4 0.6,-4.3 1.9,-5.6 1.3,-1.4 3,-2 5.3,-2 z"
            }
        ], i["ATMOSPHERIC.IC.DRIZZLE.INTERMITTENT LIGHT"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(0, 128, 0)",
                d: "m 100,82.7 c -5.5,0 -10,4.5 -10,10 0,5.5 4.5,10 10,10 0.1,0 0.1,0 0.2,0 l -0.2,0.2 c 0.9,5 -8.4,14.4 -8.4,14.4 12.8,0.1 18.4,-13.4 18.3,-23.4 l -0,0 c 0,-0.4 0.1,-0.8 0.1,-1.2 0,-5.5 -4.5,-10 -10,-10 z"
            }
        ], i["ATMOSPHERIC.IC.FOG.SKY OBSCURED"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(255, 247, 0)",
                d: "m 49.6,59.7 0,8 100.9,0 0,-8 -100.9,0 z m 0,71.6 0,8 100.9,0 0,-8 -100.9,0 z m 0,-35.6 0,8 100.9,0 0,-8 -100.9,0 z"
            }
        ], i["ATMOSPHERIC.IC.HAIL.LIGHT NOT ASSOCIATED WITH THUNDER"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(198, 16, 33)",
                d: "m 100,45.5 -0.9,2.1 -16,36 -0.6,1.4 1.5,0 32,0 1.5,0 -0.6,-1.4 -16,-36 L 100,45.5 z m -21.4,46.7 0.4,1.3 20,60 0.9,2.9 0.9,-2.9 20,-60 0.4,-1.3 -1.4,0 -40,0 -1.4,0 z m 2.8,2 37.2,0 L 100,150 81.4,94.1 z"
            }
        ], i["ATMOSPHERIC.IC.RAIN.INTERMITTENT LIGHT"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(0, 128, 0)",
                d: "m 100,79.8 c -11.2,0 -20.2,9 -20.2,20.2 0,11.2 9,20.2 20.2,20.2 11.2,0 20.2,-9 20.2,-20.2 0,-11.2 -9,-20.2 -20.2,-20.2 z"
            }
        ], i["ATMOSPHERIC.IC.DUST OR SAND.LIGHT TO MODERATE"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(173, 105, 75)",
                d: "m 140.7,85 -2,2 13,13 -13,13 2,2 14,-14 1,-1 -1,-1 L 140.7,85 z m -93.5,13.6 0,2.8 106.5,0 0,-2.8 -106.5,0 z M 98.5,62.3 c -3.2,0 -6.4,0.8 -9.2,2.2 -3.7,1.8 -6.9,4.4 -9.3,7.3 -2.3,2.9 -3.9,6.1 -3.9,9.3 0,5.6 2.9,9.9 6.9,13.2 4,3.3 9,5.8 13.9,8.3 4.9,2.5 9.7,4.9 13.1,7.7 3.4,2.8 5.4,5.8 5.4,10.1 0,3.6 -4,9 -10,11.6 -6,2.6 -13.6,2.7 -20.9,-3.4 l -2.7,3.2 c 8.4,7.1 18,7.2 25.3,4 7.2,-3.1 12.5,-9.2 12.5,-15.4 0,-5.6 -2.9,-10 -6.9,-13.3 -4,-3.3 -9,-5.8 -13.9,-8.2 -4.9,-2.5 -9.7,-4.9 -13.1,-7.7 -3.4,-2.8 -5.4,-5.8 -5.4,-10 0,-1.7 1,-4.3 2.9,-6.7 1.9,-2.4 4.7,-4.7 7.8,-6.2 6.2,-3 13.5,-3.1 19.9,4.4 l 3.2,-2.7 C 109.5,64.4 103.9,62.3 98.5,62.3 z"
            }
        ], i["ATMOSPHERIC.IC.SNOW.INTERMITTENT LIGHT"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(0, 128, 0)",
                d: "m 111.5,78.9 -26.4,40 3.3,2.2 26.4,-40 -3.3,-2.2 z m -23.1,0 -3.3,2.2 26.4,40 3.3,-2.2 -26.4,-40 z M 80,98 l 0,4 40,0 0,-4 -40,0 z"
            }
        ], i["ATMOSPHERIC.IC.STORMS.THUNDERSTORM LIGHT TO MODERATE - WITH HAIL"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(198, 16, 33)",
                d: "M 101 51.9 L 99.7 54.4 L 85.8 82.3 L 84.8 84.3 L 87 84.3 L 114.9 84.3 L 117.2 84.3 L 116.2 82.3 L 102.2 54.4 L 101 51.9 z M 101 58.1 L 112.7 81.5 L 89.3 81.5 L 101 58.1 z M 78.3 87.7 L 78.3 90.5 L 83.9 90.5 L 83.9 145 L 86.7 145 L 86.7 90.5 L 117.8 90.5 L 102.8 116.4 L 102.4 117.1 L 102.9 117.8 L 117.8 140.9 L 111.2 136.8 L 109.8 139.2 L 120.9 146.2 L 123.3 147.7 L 123 144.9 L 121.7 130.9 L 118.9 131.2 L 119.6 138.6 L 105.7 117 L 121.5 89.8 L 122.7 87.7 L 120.3 87.7 L 78.3 87.7 z "
            }
        ], i["ATMOSPHERIC.IC.STORMS.FUNNEL CLOUD (TORNADO/WATERSPOUT)"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(198, 16, 33)",
                d: "M 125.7,59.1 112.4,72.4 112,72.8 l 0,0.6 0,53.3 0,0.6 0.4,0.4 13.3,13.3 1.9,-1.9 -12.9,-12.9 0,-52.2 12.9,-12.9 -1.9,-1.9 z m -51.5,0 -1.9,1.9 12.9,12.9 0,52.2 L 72.4,139.1 74.3,140.9 87.6,127.6 88,127.2 l 0,-0.6 0,-53.3 0,-0.6 L 87.6,72.4 74.3,59.1 z"
            }
        ], i["ATMOSPHERIC.IC.TROPICAL STORM SYSTEMS.TROPICAL STORM"] = [
            {
                type: "path",
                stroke: !1,
                fill: "rgb(198, 16, 33)",
                d: "M 112.1 55 C 96.9 59.9 76.7 81.8 82.2 101.4 C 82.9 110.6 90.6 117.9 100 117.9 C 100 117.9 100 117.9 100.1 117.9 C 99.3 128.2 87.9 145 87.9 145 C 103.1 140.1 123.3 118.2 117.8 98.6 C 117.1 89.4 109.4 82.1 100 82.1 C 100 82.1 100 82.1 99.9 82.1 C 100.7 71.8 112.1 55 112.1 55 z M 100 84.5 C 106.8 84.5 112.5 88.8 114.6 94.8 C 114.8 95.2 114.9 95.6 115 96 C 115 96.1 115 96.1 115 96.2 C 115.1 96.6 115.2 96.9 115.3 97.3 C 115.4 98.1 115.5 99.1 115.5 100 C 115.5 101.1 115.4 102.1 115.2 103.1 C 115 104.1 114.7 105 114.4 105.8 C 114.4 105.9 114.3 105.9 114.3 106 C 114.1 106.4 114 106.7 113.8 107.1 C 113.7 107.2 113.7 107.3 113.7 107.3 C 113.6 107.4 113.6 107.5 113.5 107.6 C 113.3 107.9 113.1 108.3 112.9 108.6 C 112.4 109.3 111.9 110 111.3 110.6 C 111.2 110.7 111.1 110.8 111.1 110.9 C 110.8 111.1 110.5 111.4 110.3 111.6 C 110.2 111.7 110.2 111.7 110.1 111.8 C 109.8 112 109.5 112.3 109.2 112.5 C 109.1 112.5 109.1 112.5 109.1 112.5 C 108.9 112.7 108.6 112.9 108.4 113 C 108.1 113.2 107.8 113.4 107.5 113.6 C 107.4 113.6 107.4 113.6 107.4 113.7 C 106.6 114.1 105.7 114.4 104.9 114.7 C 104.7 114.8 104.5 114.8 104.3 114.9 C 104 115 103.6 115.1 103.3 115.2 C 103.2 115.2 103.1 115.2 103.1 115.2 C 102.1 115.4 101.1 115.5 100 115.5 C 93.3 115.5 87.6 111.3 85.4 105.3 C 85.4 105.3 85.4 105.2 85.4 105.2 C 85.3 104.8 85.2 104.5 85.1 104.2 C 85 104 85 103.9 85 103.8 C 84.9 103.5 84.8 103.2 84.8 102.9 C 84.7 102.5 84.6 102 84.6 101.6 C 84.5 101.1 84.5 100.5 84.5 100 C 84.5 99 84.6 98 84.8 97 C 84.8 97 84.8 96.9 84.8 96.9 C 84.9 96.4 85 96 85.2 95.6 C 85.3 95.2 85.4 94.9 85.5 94.5 C 85.6 94.3 85.6 94.2 85.7 94 C 85.7 93.9 85.8 93.8 85.8 93.8 C 86 93.4 86.2 93 86.3 92.7 C 86.4 92.6 86.4 92.5 86.5 92.4 C 86.7 92.1 86.9 91.7 87.1 91.4 C 87.3 91.1 87.5 90.8 87.8 90.5 C 88 90.2 88.2 90 88.4 89.7 C 88.6 89.5 88.8 89.3 88.9 89.1 C 89 89 89.1 89 89.2 88.9 C 89.4 88.7 89.7 88.4 89.9 88.2 C 90.2 88 90.5 87.8 90.8 87.5 C 90.8 87.5 90.9 87.5 90.9 87.5 C 91.1 87.3 91.4 87.1 91.6 87 C 91.9 86.8 92.2 86.6 92.5 86.4 C 92.6 86.4 92.6 86.4 92.6 86.3 C 93.1 86.1 93.5 85.9 94 85.7 C 94.4 85.6 94.7 85.4 95.1 85.3 C 95.3 85.2 95.5 85.2 95.7 85.1 C 96 85 96.4 84.9 96.8 84.8 C 96.8 84.8 96.8 84.8 96.9 84.8 C 96.9 84.8 96.9 84.8 96.9 84.8 C 97.4 84.7 97.9 84.6 98.4 84.6 C 98.9 84.5 99.5 84.5 100 84.5 z "
            }
        ], i["AC.IC.EMT STATION LOCATION"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 100 55 L 70 80 L 75 80 L 75 125 L 125 125 L 125 80 L 130 80 L 100 55 z M 95 80 L 105 80 L 105 91.3 L 114.8 85.7 L 119.8 94.3 L 110 100 L 119.8 105.7 L 114.8 114.3 L 105 108.7 L 105 120 L 95 120 L 95 108.7 L 85.2 114.3 L 80.2 105.7 L 90 100 L 80.2 94.3 L 85.2 85.7 L 95 91.3 L 95 80 z "
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 95 80 L 95 91.3 L 85.2 85.7 L 80.2 94.3 L 90 100 L 80.2 105.7 L 85.2 114.3 L 95 108.7 L 95 120 L 105 120 L 105 108.7 L 114.8 114.3 L 119.8 105.7 L 110 100 L 119.8 94.3 L 114.8 85.7 L 105 91.3 L 105 80 L 95 80 z "
            }
        ], i["AC.IC.HEALTH DEPARTMENT FACILITY"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 131.4,83.6 100,68.4 68.5,83.5 z m -26.4,14.6 0,-9.7 -10.1,0 0,9.7 -9.5,0 0,10.4 9.5,0 0,9.5 10.1,0 0,-9.5 9.6,0 0,-10.4 z m -27.2,19.5 0,-27.8 1.4,0 0,-3.7 -7.3,0 0,3.7 1.2,0 0,27.8 -1.2,0 0,3.8 7.3,0 0,-3.8 z m 48.7,0 0,-27.8 1.4,0 0,-3.7 -7.3,0 0,3.7 1.2,0 0,27.8 -1.2,0 0,3.8 7.3,0 0,-3.8 z m -56.4,5.1 0,3 59.4,0 0,-3 z m -1.8,6.1 0,2.8 63.2,0 0,-2.8 z"
            }
        ], i["AC.IC.MEDICAL FACILITIES OUTPATIENT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 81.8,63.6 26.6,9 0,63.9 -26.6,-9.1 v -63.8 l 0,0 z m -1.6,65 29.9,10.4 v -10.6 h 9.8 V 61 H 80.2 v 67.6 l 0,0 z m 21.4,-18.1 c 0,1.1 1,2.6 2.2,2.6 0.8,0 1.2,-0.8 1.2,-1.6 v -0.4 c 0,-1.2 -1.1,-3 -2,-3 -0.8,0 -1.4,0.8 -1.4,1.6 v 0.8 H 101.5 z M 85.9,90.9 c 0.9,0.1 5.3,1.8 5.3,2.4 v 7.1 l 5.7,2.2 v -7.5 l 5.5,1.9 V 89.1 C 101.5,88.8 96.9,87.2 96.9,86.6 V 79.5 L 91.2,77.6 v 7.4 l -5.3,-2 v 7.9 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 81.8 63.6 L 81.8 127.4 L 108.4 136.6 L 108.4 72.7 L 81.8 63.6 z M 91.2 77.6 L 96.9 79.5 L 96.9 86.6 C 96.9 87.2 101.5 88.9 102.3 89.1 L 102.3 97 L 96.8 95.2 L 96.8 102.6 L 91.1 100.4 L 91.1 93.3 C 91.1 92.6 86.8 91 85.9 90.9 L 85.9 83 L 91.2 85 L 91.2 77.6 z M 102.9 108.1 C 103.9 108.1 105 109.9 105 111.2 L 105 111.6 C 105 112.4 104.6 113.2 103.8 113.2 C 102.5 113.2 101.5 111.6 101.5 110.6 L 101.5 110.6 L 101.5 109.8 C 101.5 108.9 102.1 108.1 102.9 108.1 z "
            }
        ], i["AC.IC.OPERATION/EMERGENCY MEDICAL OPERATION"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 73.7,89.7 c 0.4,4.9 2.3,11.3 3.4,15.6 1.4,5.7 3.5,8.7 6.1,13.1 2.2,3.6 3.4,9.6 5.6,13.4 0.7,1.3 2.8,5.3 3.6,6 0.5,0.4 5.5,4 5.6,4 1.6,0 9.7,-0.4 10.4,-0.7 0.3,-0.1 4.1,-6.6 4.1,-7 v -3 h -7.8 c -2.7,0 -5.6,-1.3 -8.4,-1.3 V 112.6 c 0,-2.4 1.3,-17.3 2.1,-18 0.8,-0.7 11.4,-8.2 11.9,-8.3 l -1,-8.5 c -0.5,0.2 -5.6,1 -6,0.9 -1,-0.2 -4.7,-1.4 -5.5,-1.8 -1.9,1.1 -4.4,1.8 -6.5,2.7 -1.6,0.7 -3.5,2.7 -5.5,3.7 -2.4,1.2 -3.9,1.7 -6.7,2.5 -1.6,0.4 -2.4,0.4 -3.3,1.5 -0.7,0.8 -1.7,1.8 -2.2,2.5 z m 27.8,36.1 c 0,-8.1 2,-16.8 1.9,-24.8 0,-1.2 0.2,-1.9 0.2,-3.2 0,-1.4 0.4,-1.4 1.2,-2.2 1.2,-1.1 2.4,-2 3.6,-3 2.1,-1.7 5,-4.8 7.1,-6.1 0.3,0.1 0.3,0.2 0.9,0.2 h 4.9 c 0.2,0.8 4.9,6.4 5.8,7.4 2.6,3.1 3.8,3.9 2.9,9.6 -0.5,3.2 -0.7,8.6 -1,12 -0.3,4 -0.9,8.1 -0.9,12.2 l -26.7,-2.2 z m -1.7,1.3 29.8,2.2 2.4,-31.4 -9.8,-12.6 -7.2,-0.3 c -0.2,0 -6.9,5.9 -7.8,6.5 -1.4,1.1 -2.5,2.3 -3.9,3.2 -1.7,1.2 -1.2,3.3 -1.4,5.9 -0.6,8.4 -2.1,18.1 -2.1,26.5 z m 12.8,-9 0.2,0 c 2.3,0 6.5,2.8 8.1,2.8 h 3 V 119.4 H 121.4 c -0.6,0 -6.1,-2.3 -7.2,-2.7 -1.5,-0.6 -6.6,0.3 -8.6,0.3 v 1.3 l 7.1,-0.3 z m -5.6,-7.9 0.2,1.5 c 3.1,-0.7 5.6,-1.4 8.7,-0.8 1.3,0.3 2.8,0.6 4.2,0.9 2.5,0.6 2.8,1.2 3.3,-1 -1.3,0 -6.8,-1.3 -8.4,-1.7 -2.5,-0.7 -5.5,0.4 -8.1,1.1 z m -0.2,-8.1 0.5,1.4 5.7,-1.9 5,3.7 8,-1 -0.3,-1.7 -7.3,1 c -0.8,-0.6 -4.7,-3.6 -5.3,-3.6 -0.5,0 -5.6,1.9 -6.2,2.2 z m 10.7,-7.3 h 1.1 c 1.2,0 2.5,-1.3 2.5,-2.5 v -0.4 c 0,-1.4 -1.6,-2.5 -3,-2.5 -4.4,-0 -3.6,5.5 -0.6,5.5 z M 67.9,81.8 c 0,1.5 3.2,4.4 4.2,5.1 l 1.5,-1.6 -2.1,-4.7 h -2.2 c -0.5,0 -1.5,1.1 -1.5,1.2 z M 110.2,70.5 c 0.8,0.4 2.4,0.8 2.4,1.9 0,0.9 -0.5,1.4 -0.6,2.1 l -2.6,-0.4 c -1,-0.1 -4.2,0.6 -5.8,0.6 v 1.1 c 0,1.1 4,0 5.6,0 h 0.4 c 1.7,0 5.4,1.2 6.2,1.9 0.5,0.5 1.4,5.2 1.9,6.2 1.8,-0.9 1.3,-0.5 0.6,-3.2 -0.3,-0.9 -1.1,-3.1 -1.1,-4 l -3.9,-1.6 1.2,-2.3 c -1.1,-2.1 -0.8,-3.6 -4,-3.6 l -0.3,1.2 z m -36.5,6.6 c 0,0.9 2,4.6 2.2,6 0.3,0.1 1.1,0.4 1.1,0.4 0.3,0 2.1,-0.9 2.8,-1.1 -0.7,-3.1 -1.7,-6.6 -4.3,-7.9 -0.2,0.7 -1.7,2.3 -1.7,2.5 z m 5.9,-3.6 c 1.9,4.1 0.4,3.7 4.2,7 l 2.4,-1.2 v -3.8 c 0,-1.5 -1.2,-3.6 -1.3,-5.3 l -1.9,-0.2 h -1.7 l -1.6,3.7 z m 7.6,-2.8 2.5,5 3.9,-0.8 c 0,-1 0.6,-2.5 0.6,-3.4 0,-2.2 -1.1,-4.7 -1.1,-6.9 H 88.5 l -1.3,6 z M 97.8,62.8 c 0,0.6 0.2,7.2 0.3,7.4 0.3,1 3.7,2.6 5.5,2.4 0.9,-0.1 2.5,-0.3 3.5,-0.4 1.8,-0.2 1.2,-0.6 1.5,-2.6 0.2,-1.9 0.6,-4.9 1.1,-6.8 -0.4,-0.8 -2.4,-4.7 -3.2,-4.7 h -5.1 c -0.7,0 -3,4 -3.5,4.7 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 115.6 86.6 C 113.5 88 110.6 91 108.5 92.7 C 107.3 93.7 106 94.6 104.8 95.7 C 104 96.4 103.6 96.5 103.6 97.8 C 103.6 99.2 103.4 99.9 103.4 101.1 C 103.5 109.1 101.5 117.8 101.5 125.9 L 128.2 128 C 128.2 124 128.8 119.9 129.1 115.8 C 129.3 112.4 129.6 107.1 130.1 103.8 C 131 98.1 129.8 97.3 127.2 94.2 C 126.3 93.1 121.6 87.6 121.4 86.8 L 116.5 86.8 C 115.9 86.8 115.9 86.7 115.6 86.6 z M 118.2 89.3 C 119.5 89.3 121.1 90.4 121.1 91.9 L 121.1 92.3 C 121.1 93.6 119.8 94.9 118.6 94.9 L 117.5 94.9 C 114.5 94.9 113.8 89.3 118.2 89.3 z M 113.1 100 C 113.7 100 117.6 103.1 118.4 103.7 L 125.7 102.6 L 126 104.3 L 118 105.3 L 113 101.6 L 107.3 103.6 L 106.9 102.2 C 107.5 101.9 112.5 100 113.1 100 z M 113.2 109 C 113.9 109 114.5 109.1 115.2 109.2 C 116.7 109.6 122.2 110.9 123.5 110.9 C 123 113 122.7 112.4 120.2 111.8 C 118.8 111.5 117.3 111.2 116 110.9 C 112.8 110.3 110.4 111 107.3 111.8 L 107.1 110.3 C 109 109.8 111.2 109.1 113.2 109 z M 112.5 116.5 C 113.2 116.5 113.8 116.6 114.2 116.8 C 115.2 117.1 120.8 119.4 121.4 119.4 L 123.9 119.4 L 123.9 121 L 121 121 C 119.4 121 115.1 118.2 112.9 118.2 L 112.6 118.2 L 105.6 118.4 L 105.6 117.1 C 107.1 117.1 110.4 116.5 112.5 116.5 z"
            }
        ], i["AC.IC.TRIAGE"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 91.6 69 C 87.3 69 83.6 71.5 83.6 75.3 L 83.6 83.3 L 80.5 83.3 C 74 83.3 73.6 88.1 71.2 91.5 C 69.3 94.3 63 94.4 63 100.9 L 63 131 L 137 131 L 137 102.6 C 137 99.5 136.2 97.3 134.7 95.6 C 133.2 94 130.8 93.6 129.1 92 C 126 88.8 126.9 83.3 119.1 83.3 L 116.2 83.3 L 116.2 75.5 C 116.2 71.3 112.9 69 108.4 69 L 91.6 69 z M 89.9 76 L 110.1 76 L 110.1 83.3 L 89.9 83.3 L 89.9 76 z M 95.3 90.4 L 104.4 90.4 L 104.4 99.4 L 112.2 94.9 L 116.8 102.8 L 109.1 107.3 L 116.8 111.9 L 112.1 119.8 L 104.4 115.3 L 104.4 124.1 L 95.3 124.1 L 95.3 115.3 L 87.6 119.7 L 83 111.8 L 90.7 107.3 L 83 102.8 L 87.6 94.9 L 95.3 99.3 L 95.3 90.4 z "
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 112.1,119.8 4.6,-7.9 -7.6,-4.6 7.7,-4.5 -4.6,-7.9 -7.7,4.4 -0,-8.9 -9.1,0 0,8.9 -7.7,-4.4 -4.5,7.9 7.6,4.5 -7.6,4.5 4.5,7.9 7.7,-4.4 0,8.8 9.1,0 0,-8.8 z"
            }
        ], i["AC.IC.EMERGENCY PUBLIC INFORMATION CENTER"] = [
            i["GR.IC.FF.EMERGENCY OPERATION"],
            a("i")
        ], i["AC.IC.FIRE HYDRANT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 80,131.3 v -1 c 1.3,0.1 5.7,1.8 7.7,2.2 2.8,0.6 5.8,1 9.1,1 h 6.5 c 3.4,0 6.1,-0.4 8.9,-1 2,-0.4 6.5,-2.1 7.7,-2.2 v 1 c 0,2.9 -12.5,4.5 -16.6,4.5 h -6.4 c -4.1,0 -16.9,-1.6 -16.9,-4.5 l 0,0 z m 17.9,-43.4 4.5,0.1 12.4,0.4 v 8.3 h 6.3 v 11.9 h -6.3 v 17.4 l 4.5,1.3 c -1.2,1.6 -12.2,3.3 -15.8,3.3 h -6.4 c -3.5,0 -15,-1.8 -16,-3.2 l 4.6,-1.6 0.1,-17.2 h -6.3 V 96.7 h 6.3 v -8.3 l 12.4,-0.4 0,0 z m 25.7,5.9 h 3 v 6.7 h 3.2 v 3.9 h -3.2 v 6.7 h -3 V 93.8 z m -50,0 h 2.9 v 17.2 h -2.9 v -6.7 h -3.5 v -3.9 h 3.4 V 93.8 h 0.1 z m 26.1,-8.3 c -5.2,0 -9.7,0.2 -14.8,0.2 -4.4,0 -3.5,-2.6 -1.8,-2.8 2.1,-0.3 4.9,-0.1 6.9,-0.4 5.3,-0.8 23.6,-0.3 28.1,0.8 0.2,1.8 0.4,1.5 -1,2.4 l -15.8,-0.2 -1.6,0.1 z m -1,-21.1 h 2.9 v 3.8 h 2 v 1.8 c 3.2,0.7 5.3,1.1 7.4,3.1 1.3,1.3 3.5,4.3 3.7,6.7 l -10.4,-0.3 -9.9,0.1 0.2,-0.1 -9.1,0.5 c 0.4,-4.7 5.2,-9.7 10.4,-9.7 h 0.8 v -2 h 2 v -3.8 z m -2.6,1.2 h -2 v 2.2 c -5.7,0.5 -10.6,6.6 -11.1,12.5 -2.2,0.2 -2.3,1.3 -3.4,2.1 l -0.2,1.6 c -0.3,2.2 2,3.9 3.6,4.3 v 5.5 h -3.6 v -2.4 h -8.3 v 6.7 h -3.2 V 107 h 3.2 v 6.3 h 8.3 v -2.4 h 3.6 V 123.8 c -2.3,0.6 -5.5,2 -5.5,4.9 v 2 c 0,6.3 12.9,7.7 19.8,7.7 h 5.9 c 6.9,0 19.4,-1.2 19.4,-7.7 v -2 c 0,-2.8 -3,-4.3 -5.3,-4.9 v -12.9 h 3.6 v 2.4 h 8.1 V 107 h 3.2 v -9.1 h -3.2 v -6.4 h -8.1 v 2.4 h -3.6 v -5.5 c 1.6,-0.3 3.6,-1.8 3.6,-3.8 0,-2.2 -1.6,-3.9 -3.6,-4 -0.5,-5.9 -5.7,-12.1 -11.4,-12.6 v -2.2 h -2 V 61.6 h -7.9 v 4 z m 2.9,47.2 c -4,0 -8.3,-5 -8.1,-9.3 0.2,-4.4 4.2,-9 8.3,-9 h 2 c 4.2,0 8.3,4.7 8.3,9.1 0,4.3 -4,9.1 -8.1,9.1 h -2.4 l 0,0 z m -10.5,-9.9 v 1.8 c 0,5.2 5.4,10.8 10.5,10.8 h 2.4 c 5.6,0 10.8,-5.8 10.8,-11.8 0,-6 -5.3,-11.8 -10.9,-11.8 h -2.1 C 93.7,92 88.4,97.5 88.4,103 l 0,0 z m 9.5,0.8 c 0.3,-0.6 0.8,-1.8 1.4,-1.8 h 1.4 c 0.7,0 1.4,1.3 1.4,2 0,0.1 -0.9,1.6 -1.4,1.6 h -1.4 c -0.6,0.1 -1.1,-1.2 -1.4,-1.8 z m -2.9,0 2.2,4.3 h 5 c 0.7,0 2.4,-3.6 2.9,-4.3 l -2.4,-4.5 h -4.9 c -0.8,0.1 -2.5,3.7 -2.9,4.5 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 97.9,103.8 c 0.3,-0.6 0.8,-1.8 1.4,-1.8 h 1.4 c 0.7,0 1.4,1.3 1.4,2 0,0.1 -0.9,1.6 -1.4,1.6 h -1.4 c -0.6,0.1 -1.1,-1.2 -1.4,-1.8 z m 1.2,-9.1 c -4.1,0 -8.1,4.6 -8.3,9 -0.2,4.3 4.1,9.3 8.1,9.3 l 2.4,0 c 4,0 8.1,-4.9 8.1,-9.1 0,-4.4 -4.1,-9.1 -8.3,-9.1 l -2,0 z m -1.2,4.7 4.9,0 2.4,4.5 c -0.4,0.7 -2.1,4.3 -2.9,4.3 l -5,0 -2.3,-4.3 c 0.4,-0.8 2.1,-4.4 2.9,-4.5 z M 98.7,64.5 h 2.9 v 3.8 h 2 v 1.8 c 3.2,0.7 5.3,1.1 7.4,3.1 1.3,1.3 3.5,4.3 3.7,6.7 l -10.4,-0.3 -9.9,0.1 0.2,-0.1 -9.1,0.5 c 0.4,-4.7 5.2,-9.7 10.4,-9.7 h 0.8 v -2 h 2 v -3.8 z m 1,21.1 c -5.2,0 -9.7,0.2 -14.8,0.2 -4.4,0 -3.5,-2.6 -1.8,-2.8 2.1,-0.3 4.9,-0.1 6.9,-0.4 5.3,-0.8 23.6,-0.3 28.1,0.8 0.2,1.8 0.4,1.5 -1,2.4 l -15.8,-0.2 -1.6,0.1 z m -26.1,8.3 h 2.9 v 17.2 h -2.9 v -6.7 h -3.5 v -3.9 h 3.4 V 93.8 h 0.1 z m 50,0 h 3 v 6.7 h 3.2 v 3.9 h -3.2 v 6.7 h -3 V 93.8 z m -25.7,-5.9 -12.4,0.4 0,8.3 -6.3,0 0,11.9 6.3,0 -0.1,17.3 -4.6,1.6 c 1.1,1.5 12.5,3.3 16,3.3 l 6.4,0 c 3.6,0 14.7,-1.7 15.8,-3.3 l -4.5,-1.3 0,-17.4 6.3,0 0,-11.9 -6.3,0 0,-8.3 -12.4,-0.4 -4.5,-0.1 z m 1.2,4.2 2.1,0 c 5.7,0 10.9,5.8 10.9,11.8 0,5.9 -5.2,11.8 -10.8,11.8 l -2.4,0 c -5.2,0 -10.5,-5.6 -10.5,-10.8 l 0,-1.8 c 0,-5.5 5.3,-11 10.7,-10.9 z M 80,131.3 v -1 c 1.3,0.1 5.7,1.8 7.7,2.2 2.8,0.6 5.8,1 9.1,1 h 6.5 c 3.4,0 6.1,-0.4 8.9,-1 2,-0.4 6.5,-2.1 7.7,-2.2 v 1 c 0,2.9 -12.5,4.5 -16.6,4.5 h -6.4 c -4.1,0 -16.9,-1.6 -16.9,-4.5 l 0,0 z"
            }
        ], i["AC.IC.OTHER WATER SUPPLY LOCATION"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 113.2,116.5 c 0,-2.9 4.4,-9.3 5.8,-11.8 2.8,-5 3.1,-6.8 4.6,-13 2.1,1.4 2.2,4.3 3,7.1 0.8,2.8 1.6,4.8 2.9,7 2.2,3.8 6.7,8 5,14.1 -1.6,5.8 -5.2,7.8 -12.2,7.5 -5.8,-0.2 -9.1,-4.9 -9.1,-11 z m -1.2,-0.4 v 0.6 c 0,7.5 4.6,12.2 12,12.2 6.8,0 12,-4.6 12,-11 v -1.3 c 0,-5 -4.7,-10 -6.6,-13.8 -1.1,-2.2 -1.6,-5.5 -2.3,-8.1 -0.9,-3.3 -2.4,-4 -4.8,-5.6 0,13.6 -10.3,20 -10.3,26.8 z m 4.8,3.6 c 0,2.4 1.8,4.4 3.8,4.4 0.7,0 1.5,-0.6 1.7,-1.3 -1.6,-0.4 -3.2,-2.5 -3.4,-4.4 l -2.1,1.3 z M 89.2,73 v 15.8 h -2.1 v -15.8 l 0.6,-0.1 1.5,0.1 z m -10.4,2.3 h 6.6 v 11 H 78.8 v -11 z m 37.2,1.1 c 0,-0.5 0.2,-0.6 0.6,-0.6 h 1.5 c 0.5,0 0.6,0.2 0.6,0.6 v 9.1 h -2.8 v -9.1 z m -24.9,-1.3 22.8,2.4 v 6.5 l -22.8,1.9 v -10.7 z m -27,11.8 h 12.9 v 1 l 8.3,0.1 1.2,2.4 1.6,0.3 c 0.6,0.1 1,-0.2 1.8,-0.3 l 0.9,-0.6 0.2,-2.4 22.8,-1.6 c 1.2,2.5 4.2,1.6 6.6,1 0,-0.7 0.2,-0.8 0.2,-1.5 v -9.5 c 0,-1.5 -0.8,-2.1 -2.3,-2.1 h -2.1 c -3.8,0 0.2,2.5 -5,1.6 -2.1,-0.4 -4.6,-0.4 -6.7,-0.7 -3.3,-0.5 -10.4,-1.3 -13.5,-1.3 -0.1,-3.1 -5.6,-3.3 -5.7,0.4 h -8.4 v 0.6 h -13 l 0.1,12.4 0,0 z m 15.6,-4.8 0,1.9 4.6,0 0,-1.9 z m 0,-4.2 0,1.7 4.6,0 0,-1.7 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 91,75.1 22.8,2.4 v 6.5 l -22.8,1.9 v -10.7 z m 24.9,1.3 c 0,-0.5 0.2,-0.6 0.6,-0.6 h 1.5 c 0.5,0 0.6,0.2 0.6,0.6 v 9.1 h -2.8 v -9.1 z M 78.8,75.3 l 0,11 6.6,0 0,-11 -6.6,0 z m 0.8,2.6 4.7,0 0,1.7 -4.7,0 0,-1.7 z m 0,4.2 4.7,0 0,1.9 -4.7,0 0,-1.9 z M 123.5,91.8 c -1.4,6.2 -1.8,8 -4.6,13 -1.3,2.5 -5.8,8.9 -5.8,11.8 0,6.1 3.3,10.8 9.1,11 7,0.2 10.5,-1.7 12.2,-7.5 1.7,-6.1 -2.8,-10.3 -5,-14.1 -1.3,-2.2 -2,-4.3 -2.9,-7 -0.8,-2.8 -0.9,-5.7 -3,-7.1 z m -4.6,26.7 c 0.2,1.9 1.8,4 3.4,4.4 -0.2,0.6 -1,1.3 -1.7,1.3 -2,0 -3.8,-2.1 -3.8,-4.4 l 2.1,-1.3 z M 89.2,73 v 15.8 h -2.1 v -15.8 l 0.6,-0.1 1.5,0.1 z"
            }
        ], i["AC.IC.BANKING FINANCE AND INSURANCE INFRASTRUCTURE"] = a("\u20AC$\xa3"), i["GR.IN.IC.PUBLIC VENUES INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 87.9,87.3 c -3.2,0 -5.8,2.6 -5.8,5.8 0,2.8 2.1,5.2 4.8,5.7 l 0,3.3 -3.8,0 0,2 3.8,0 0,9.4 2,0 0,-9.4 3.8,0 0,-2 -3.8,0 0,-3.3 c 2.7,-0.5 4.8,-2.8 4.8,-5.7 0,-3.2 -2.6,-5.8 -5.8,-5.8 z m 24,0 c -3.2,0 -5.8,2.6 -5.8,5.8 0,2.8 2.1,5.2 4.8,5.7 l 0,3.3 -3.8,0 0,2 3.8,0 0,9.4 2,0 0,-9.4 3.8,0 0,-2 -3.8,0 0,-3.3 c 2.7,-0.5 4.8,-2.8 4.8,-5.7 0,-3.2 -2.6,-5.8 -5.8,-5.8 z m -24,2 c 2.1,0 3.8,1.7 3.8,3.8 0,2.1 -1.7,3.8 -3.8,3.8 -2.1,0 -3.8,-1.7 -3.8,-3.8 0,-2.1 1.7,-3.8 3.8,-3.8 z m 24,0 c 2.1,0 3.8,1.7 3.8,3.8 0,2.1 -1.7,3.8 -3.8,3.8 -2.1,0 -3.8,-1.7 -3.8,-3.8 0,-2.1 1.7,-3.8 3.8,-3.8 z m 24.2,37.8 0,-3 -72.1,0 0,3 z m -3,-6.2 0,-2.8 -66.2,0 0,2.8 z M 66.8,98.2 c 0,1.3 -0.7,2.6 -0.7,4.3 -0,1.8 -0.2,3.1 -0.2,5 v 3.2 l 0.6,3.6 h 2.7 l -0.8,-6.4 v -1.8 c 0,-8.1 5,-17.9 9.3,-21.5 5.6,-4.6 11.6,-9.1 21.7,-9.1 h 0.9 c 9,0 17.1,4.4 21.6,8.8 3.2,3.2 4.1,4.7 6.4,8.7 1.4,2.4 3.3,8.4 3.3,12 v 4.3 c 0,1.4 -0.7,3 -0.7,4.4 v 0.5 h 2.7 l 0.6,-6.4 v -3.8 c 0,-1.6 -1,-5.2 -1.4,-6.6 -0.8,-2.5 -1.3,-3.6 -2.3,-5.7 -1.8,-3.8 -3.8,-6.4 -6.7,-9.3 -4.6,-4.6 -13.6,-9.6 -22.6,-9.6 h -2.5 c -7.8,0 -16.6,4.1 -20.6,7.9 -2.8,2.7 -4.4,4.1 -6.7,7.5 -1.1,1.6 -1.5,3 -2.5,4.6 -0.9,1.6 -1.2,4 -2,5.2 z"
            }
        ], i["GR.IN.IC.RECREATIONAL AREA"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 96.4,78.8 8.1,-0 c 0.9,0 2.4,5.7 2.4,6.9 l 1.5,4.3 c 0,0.4 2,6.6 2,7 v 0.6 l -19.4,-0 5.4,-18.8 z m -19.9,-0 11.1,0 -3.5,11.2 c 0,1.7 -1.9,5.7 -1.9,6.9 v 0.6 h -20.8 v 7.2 l 18.5,0 -1.2,3 -0.1,0.8 -2.6,8.3 -3.6,11.5 c 1.1,0 9.3,0.1 9.7,-0.1 0.2,-0.1 2,-6.8 2.3,-7.7 0.5,-1.2 4.5,-15 4.5,-15.2 v -0.6 l 23.5,0 6.7,23.6 9.8,0 -1.4,-4.8 -0.7,-2.6 -2.4,-7.8 -0.9,-2.8 -1.7,-5.7 h 15.8 v -7.2 h -18.2 l -2.9,-8.9 -0.1,-0.8 -1,-3 -1.7,-6.2 h 10.6 v -7.2 h -47.9 v 7.2 l 0,0 0,0 z m 62.1,16.9 0,-6.1 -15.2,0 0,6.1 z m -62.3,0 0,-6.1 -14.9,0 0,6.1 z"
            }
        ], i["GR.IN.IC.SPECIAL NEEDS INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 73.1,111.2 c 0,-3.8 1,-5.8 2.3,-8.4 1.4,-2.8 3.3,-3.8 4.6,-5.8 l -1.1,-8.2 c -2.6,0.7 -7.7,6.5 -9.2,9 -2.4,4.1 -3.8,7.9 -3.8,14.2 v 3.3 c 0,2.2 2.2,8.1 3.1,9.6 2,3.2 3,4.5 5.5,7.1 3.6,3.6 10.7,7.1 17.9,7.1 h 1 c 4.9,0 9.9,-1.6 13.1,-3.6 1.7,-1 8.5,-6.2 8.5,-7.8 0,-1.2 -3.1,-6.6 -3.5,-8.4 -1.2,1.5 -1.6,3 -3,4.8 -1.2,1.5 -2.3,2.7 -3.8,3.8 -2.6,2 -6.8,4 -11.3,4 h -1.2 c -10.2,0 -19.1,-9 -19.1,-19.3 v -1.4 l 0,0 z m 8.9,-37.9 c 0.5,0.4 0.5,2.9 0.5,4 L 85,106.8 l 25.4,0 10,23 c 1.5,-0.1 5.5,-1.5 7.1,-2.1 1.2,-0.4 6.5,-1.4 6.5,-2.6 v -0.2 c 0,-0.7 -1.9,-4.8 -2,-6.3 l -7.6,2.6 -9,-21.6 H 91.6 l -0.4,-6 h 17.3 v -5.4 H 90.8 l -1.1,-12.9 c 2.6,-0.2 5.2,-3.9 5.2,-6.7 v -2.2 h -0.5 v -0.8 c 0,-0.8 -2.1,-3.1 -2.7,-3.5 -1,-0.7 -3.3,-1.6 -4.8,-1.3 -2.2,0.4 -3.2,0.8 -4.4,2 -0.7,0.7 -2.2,3.2 -2.2,4.3 v 1.2 c 0,2.4 0.8,3.6 1.7,4.9 l 0,0 z m 0.5,4 c 0,-1.1 0,-3.6 -0.5,-4 0,1.1 -0,3.6 0.5,4 z"
            }
        ], i["GR.IN.IC.ADULT DAY CARE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 107,118.3 v -0.2 c 0,-15.5 22.4,-14.7 22.4,-0.6 v 1.3 c 0,5.4 -5.3,10.4 -10.8,10.4 h -0.6 c -5.9,0 -11,-5.1 -11,-11 z m -1.6,-22.2 h 4.6 v 10 c 0,0 -3.2,3.3 -3.8,4.3 -0.5,0.8 -2.2,4.7 -2.2,5.8 v 2.3 c 0,6.8 6.6,13.7 13.3,13.7 h 1 c 5.8,0 10.8,-5 11,-5 h 7.1 v -1.9 h -3.2 c 0.2,-0.5 0.8,-1.3 0.8,-1.9 v -11 c 0,-1.9 -1,-3.3 -2.1,-4 h -3.3 l -0.8,-0.7 c 1.1,-0.3 2,-0.9 2,-2.2 v -0.4 c 0,-0.5 -1,-1.7 -1.6,-1.7 h -5 v -5.4 c 0,-2.7 -1.5,-4.2 -4.2,-4.2 h -2.1 c -5.9,0 -4.6,5.8 -4.6,11.6 l -0.6,0.4 V 94.7 c -0.4,-0.2 -0.4,-0.4 -0.8,-0.4 h -5.4 v 1.7 z m -22.6,1 c 0,-2.2 3.3,-4.8 4.5,-6.6 1.4,1 1.4,1.8 3.4,2.8 1.4,0.7 2.6,1.4 4,1.9 2.4,0.9 2.2,-0.1 4.3,1.9 0.9,0.9 1.8,2.5 3.5,2.5 0.4,0 0.8,-0.8 0.8,-1.3 v -1.1 c 0,-2.8 -3.3,-3.6 -5.3,-4.5 -2.3,-0.9 -5.3,-1.6 -6.1,-3.8 -0.8,-2.3 -2.2,-4.6 -2.9,-6.9 -0.7,-2.1 -1.9,-5.1 -4.6,-5.1 h -0.4 c -3,0 -7.4,7.5 -8.1,10.4 -0.6,2.3 -1.6,4.7 -2.1,7.2 -0.5,2.8 -0.6,5.2 -1.1,8 -0.3,1.8 0.1,2.3 -0.6,4 -0.4,1.2 -0.8,2.3 -1.2,3.4 -0.9,2.3 -1.7,4.6 -2.5,6.8 -0.8,2.1 -4.9,11.8 -4.9,13.5 0,2.6 6.2,1.3 7.7,1.1 -0,-1.9 -2.3,-1.6 -3.1,-2.7 2.1,-3.1 3.8,-6.3 5.8,-9.5 1,-1.7 4.6,-9.2 5.4,-9.8 0.6,0.4 3,3.1 3.8,3.9 1.9,1.9 2,1.8 2.8,4.8 1.1,4.2 1.9,7.7 1.9,13.1 l 1.7,0.2 4.2,-0 c 1.3,0 1.8,-0.2 2.3,-1 -0.6,-1 -3.1,-1.7 -4.6,-2.1 v -1.1 c 0,-0.4 -0.1,-0.4 -0.4,-0.8 v -12.1 c -1.5,-2.3 -2.9,-4.9 -4.6,-7.1 -1.1,-1.6 -3.8,-5.2 -3.8,-7.6 v -2.5 l 0,0 z m 30.3,-9.7 v 1.6 c 0,1.5 2.3,3.9 4.2,3.9 h 0.8 c 2.1,0 4.2,-2.3 4.2,-4.5 V 87.6 c 0,-2.2 -2.2,-4.2 -4.5,-4.2 h -0.1 c -2.3,-0 -4.6,2 -4.6,4 z m -28.4,-15.6 v 1.7 c 0,0.6 1,2.1 1.4,2.5 0.6,0.6 1.8,1.2 2.9,1.2 h 1 c 2,0 4.2,-2.2 4.2,-4 v -1.4 c 0,-1.6 -2.5,-3.9 -4.5,-3.9 h -0.7 c -1.8,0 -4.2,2.2 -4.2,3.9 z"
            }
        ], i["GR.IN.IC.AGRICULTURE AND FOOD INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 79.5,127.9 h -7.8 v -21.4 c 0,-1 6.8,-13.3 7.4,-13.6 1,-0.6 13.9,-7.1 14.1,-7.1 0.5,0 13.2,6.3 14.4,7 0.4,0.3 7.7,13.1 7.7,13.7 v 21.4 h -7.6 V 110.4 H 79.5 v 17.5 z m 37.4,-39.4 h 15.4 v 39.8 h -12.1 v -18.8 h 2.6 c -0.5,-0.8 -5.8,-9.8 -5.8,-10 V 88.5 z m 0.2,-1.9 c 0,-4.4 2.9,-8.2 7.2,-8.2 h 0.4 c 4.5,0 7.6,3.7 7.6,8.2 h -15.2 v 0 z M 105.2,82.1 h 8.9 c -0.2,1.6 -0.9,2.5 -0.9,5 0,2 0,3.9 0,5.8 -1.4,-1 -0.9,-2.8 -3.2,-4 -1.2,-0.6 -3.8,-2 -4.8,-2.3 v -4.6 z m 0,-2.8 c 0,-2.8 3.8,-7.4 6.9,-7.4 h 0.6 c 3.1,0 5.5,1.8 6.7,3.7 -0.2,0.2 -4.8,4.3 -4.8,4.3 h -9.5 v -0.6 z m -11.9,1.5 c -3.2,1.7 -6.6,3.2 -9.9,4.8 -1.7,0.9 -3.3,1.5 -5,2.4 -2.8,1.4 -2.3,0.7 -4,3.1 -0.9,1.3 -1.8,3.2 -2.7,4.7 -0.9,1.6 -1.9,3 -2.8,4.6 -1.6,2.9 -3.6,6.5 -5.4,9.1 h 2.8 v 22.5 H 84 V 114.7 h 19 v 17.3 h 33.3 V 87.5 c 0,-7.5 -4.2,-13 -11.7,-13 h -1.7 c -0.8,-2.9 -5.9,-6.5 -10,-6.5 h -0.4 c -6.4,0 -11,5.9 -11,12.1 v 4.6 l -8.2,-3.9 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 79.5,110.4 h 28.1 v 17.5 h 7.6 v -21.4 c 0,-0.6 -7.2,-13.4 -7.7,-13.7 -1.1,-0.8 -13.8,-7.1 -14.4,-7.1 -0.1,0 -13,6.5 -14.1,7.1 -0.6,0.4 -7.3,12.6 -7.3,13.6 v 21.4 h 7.8 v -17.5 z m 37.4,-10.8 c 0,0.1 5.3,9.2 5.8,10 h -2.6 v 18.8 h 12.1 v -39.8 h -15.4 v 11 z m 0.2,-13 h 15.1 c 0,-4.6 -3,-8.2 -7.6,-8.2 h -0.4 c -4.2,-0 -7.2,3.8 -7.2,8.2 z m -11.9,0 c 1.1,0.2 3.6,1.7 4.8,2.3 2.2,1.1 1.7,3 3.2,3.9 0,-2 0,-3.9 0,-5.8 0,-2.5 0.7,-3.4 0.9,-5 h -8.9 v 4.6 z m 0,-7.4 v 0.6 h 9.5 c 0,0 4.6,-4.1 4.8,-4.3 -1.2,-1.8 -3.6,-3.7 -6.7,-3.7 h -0.6 c -3.1,0 -6.9,4.6 -6.9,7.4 z"
            }
        ], i["GR.IN.IC.AGRICULTURAL LABORATORY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 98.4,77.9 -0.1,0.3 2.6,0.6 0,-0.3 z m 2.1,7.3 0.4,-3.2 -0.3,-0.1 -0.4,3.2 z m -3.8,-16.8 0.1,-0.2 -1.4,-0.3 1,-2.6 -0.4,-0.3 -1.7,5.7 0.1,0 0.3,-0.1 0.7,-2.4 z m -1,5.3 c 0.8,0 0.5,-1.7 0.8,-2.3 l -0.4,-0.1 -0.4,2.4 z m 1.4,-5.5 0.6,-2.6 -0.4,-0.1 -0.6,2.7 z m 0.2,-2.7 0.1,-0.3 -1,-0.2 -0.1,0.2 z m 11.8,65.6 0,5.6 3.3,0 c 1.1,0 1.9,-0.2 2.4,-0.7 0.5,-0.5 0.8,-1.2 0.8,-2.1 -10e-6,-0.9 -0.3,-1.6 -0.8,-2.1 -0.5,-0.5 -1.3,-0.7 -2.4,-0.7 l -3.3,0 m 0,-6.2 0,4.6 3,0 c 1,0 1.7,-0.2 2.2,-0.6 0.5,-0.4 0.7,-1 0.7,-1.7 -10e-6,-0.8 -0.2,-1.3 -0.7,-1.7 -0.5,-0.4 -1.2,-0.6 -2.2,-0.6 l -3,0 m -2.1,-1.7 5.2,0 c 1.6,1e-5 2.8,0.3 3.6,1 0.8,0.7 1.3,1.6 1.3,2.8 -2e-5,0.9 -0.2,1.7 -0.7,2.2 -0.4,0.5 -1.1,0.9 -1.9,1 1,0.2 1.8,0.7 2.3,1.4 0.6,0.7 0.8,1.5 0.8,2.6 -1e-5,1.4 -0.5,2.4 -1.4,3.1 -0.9,0.7 -2.2,1.1 -3.9,1.1 l -5.4,0 0,-15.2 m -9.2,2 -2.8,7.5 5.6,0 -2.8,-7.5 m -1.2,-2 2.3,0 5.8,15.2 -2.1,0 -1.4,-3.9 -6.8,0 -1.4,3.9 -2.2,0 5.8,-15.2 m -16,0 2.1,0 0,13.4 7.4,0 0,1.7 -9.4,0 0,-15.2 M 98.6,92.5 c 0.9,-0.2 0.8,-1.8 1.1,-2.6 l 0.9,0.4 -1.4,4.2 -0.6,-2 z m -0.2,-0.4 0.1,0.2 c -0.5,-0.1 -0.8,-1.3 -0.8,-1.9 l 0.4,0.6 -0.3,-2.2 1.6,0.8 c -0,0.7 -0.4,2.3 -0.9,2.4 z m -0.9,-2.3 -0.6,-1.4 c 0.4,0.1 0.6,0.3 0.6,0.9 v 0.5 z m 2.6,-4.4 -0.6,3.9 -1.7,-0.8 v -3.4 -0.3 l 2.3,0.6 z m -2.6,-1.1 0.4,0.1 v 0.4 h -0.4 v 3.5 l -0.8,-0.4 0.1,0.4 h -0.2 c 0,-0.9 -1.2,-2.8 -1.6,-3.5 0.1,-0.1 0.1,-0.1 0.1,-0.4 v -0.4 l 2.4,0.6 0,-0.4 z m 6.1,-1.7 2.5,0.6 v 0.4 c 0,0.2 0,0.2 0.1,0.3 -1.2,0 -1.9,0.4 -2.8,0.8 l 0.2,-2 z m -6.1,1.7 -2.4,-0.8 0.1,-1.8 v -1 l 2.4,0.5 -0.2,3 z m 8.6,-1.6 c -0.3,0 -2.3,-0.4 -2.4,-0.6 0,0 0.2,-2.3 0.2,-2.7 l 2.2,0.4 0.1,1.6 -0,1.2 z m -12.7,-2.4 c 0.4,0 0.7,0.2 1.1,0.2 0.8,0.2 0.4,0.1 0.4,0.7 v 2.1 c -0.3,-0 -0.7,-0.2 -1,-0.3 -0.7,-0.2 -0.5,0.1 -0.5,-0.4 v -2.4 z m 10.7,-4.2 1.7,0.4 0.3,3 -2.2,-0.4 0.2,-3 z m -6.4,5.2 v -0.4 l -2.4,-0.5 0.3,-2.8 2.4,0.5 -0.2,2.9 h 0.3 v 0.4 h -0.3 z m -4,-4.2 1.6,0.4 -0.3,2.9 -1.5,-0.4 0.2,-2.9 z m 7.6,1.4 0.3,-3.1 2.4,0.6 -0.3,3 -2.4,-0.5 z m -0.4,-0.1 0.4,0.1 v 0.4 c 0.4,0 2.3,0.4 2.4,0.6 0,0.1 -0.2,2.3 -0.2,2.6 -0.8,0 -1.6,-0.4 -2.3,-0.4 -0.2,0 -0.2,0.2 -0.2,0.4 l 2.4,0.5 -0.2,2.2 h 0.2 c -0.5,0.7 -1.1,1.6 -1.4,2.4 -0.3,0.8 -0.7,2.1 -1.1,2.8 l -0.9,-0.4 0.6,-4 h -0.2 l -0.2,-0.1 v -0.4 l -2.3,-0.7 0.2,-3 2.5,0.5 v -0.3 h 0.4 l 0.2,-2.8 h -0.3 l -0.3,2.7 -2.4,-0.4 0.2,-2.9 c -0.3,-0.1 -0.2,0 -0.3,-0.4 h 0.2 l 0.2,0.1 0.4,-3.2 2.4,0.6 -0.3,3.1 z m 3.2,-5.4 v -0.3 l 0.3,0.1 v 0.3 c 1,0.1 1.1,0.1 1.2,1 0,0.3 0.2,1.8 0.3,1.9 l -1.7,-0.3 v 0.4 h -0.3 v -0.5 l -2.4,-0.6 0.3,-2.5 2.3,0.4 z m 0.2,-0.2 0.2,-2.9 c 0.6,0.1 0.7,2.4 0.8,3.1 l -1,-0.2 z m -5.1,-0.9 2.4,0.5 -0.3,2.6 -2.4,-0.6 0.4,-2.5 z m 4.9,0.8 c -3.3,-0.8 -2,0 -2,-3.3 l 2.2,0.4 -0.2,2.9 z m -4.4,-3.8 c 3.2,0.8 1.9,-0.2 1.9,3.2 l -2.3,-0.5 0.4,-2.7 z m -2.5,-0.4 2.1,0.4 -0.4,2.7 -2.2,-0.4 0.4,-2.6 z m 7.1,1.3 v -0.4 l -2.2,-0.4 0.2,-2.6 c 0.3,0 0.7,0.1 1.1,0.2 0.6,0.1 0.5,0 0.7,0.6 0.3,1 0.3,0.9 0.3,2.2 l 0.3,0.4 -0.4,0.1 z m -4.1,-3.9 1.8,0.4 -0.2,2.6 -2.1,-0.4 0.4,-2.6 z m 2.3,-2.2 1.4,2.6 -1.5,-0.2 0.1,-2.4 z m -1.6,-1.6 0,-0.1 1.2,1.2 -0.1,0 c 0.3,-0.1 0.3,-0.1 0.4,0.3 l -0.2,-0.2 -0.2,2.6 -1.8,-0.4 0.7,-3.5 z m -2.9,3 c 0.5,-1.1 0.3,-3.4 1.9,-3.4 0.3,0 0.2,0 0.5,0.1 l -0.6,3.7 -1.8,-0.4 z m -0.4,-0.1 0.4,0.1 v 0.3 l 1.8,0.4 -0.4,2.6 -2.1,-0.4 v 0.2 l -0.1,0.2 -0.2,-0.1 h -0.2 l -0.5,2.6 -1.6,-0.3 v 0.3 c 0.5,0 1,0.3 1.4,0.3 0.2,0 0,-0.2 0.5,-0.2 v 0.4 l 2.2,0.4 -0.3,2.4 -2.4,-0.6 v 0.4 l 2.3,0.6 -0.3,3.1 -2.4,-0.6 0.4,-3.2 h -0.4 c -0,0.8 -0.3,1.7 -0.3,2.4 -0,0.8 -0,0.7 -0.7,0.5 -0.2,-0 -0.9,-0.1 -0.9,-0.3 -0,-0.3 0.2,-2 0.3,-2.4 0.2,-1.2 0.5,-0.4 1.7,-0.3 l 0.1,-0.3 c -0.2,-0.1 -1.6,-0.3 -1.6,-0.5 0,-0.8 0.4,-1.5 0.4,-2.3 -0.6,0.1 -0.7,2.3 -0.8,3 -0.1,0.8 -0.4,2.6 -0.4,3.3 0,0.8 -0.2,2.4 -0.2,3.5 0,1.3 -0.1,2.4 -0.1,3.8 h 0.3 v -0.9 l 1.5,0.4 v 1 l -3.4,-0.5 h -0.1 c -5,0 -8.8,9.7 -8.8,15.4 0,2.3 0.8,5.4 2,6.2 0.7,-1.4 1.3,-3.1 2,-4.6 0.8,-1.5 1.4,-3.1 2.1,-4.6 0.3,-0.7 0.7,-1.5 1,-2.2 0.4,-0.8 0.8,-1.5 1.8,-1.2 0.9,0.3 1.9,3.2 2.1,4.6 0.5,3.8 0,9 0.6,12.6 0.7,4 2.3,6.4 5.4,8 1,-0.4 2.5,-0.6 3.4,-1.2 0.9,-0.6 1.8,-1.2 2.4,-2.2 1.2,-1.8 2,-4.1 2,-7.2 l 0,-0.6 -0.3,-5.6 v -0.3 c 0,-2.7 0.5,-8.3 2.8,-8.3 h 0.1 c 1.4,0 2,0.6 2.6,1.4 0.6,0.8 1.2,1.4 1.8,2.2 1.2,1.5 2.6,2.9 2.6,5.5 v 0.6 l 0.4,0.1 c 0.4,-1.6 1.8,-2.8 1.8,-5.2 v -1.5 c 0,-3.5 -1.4,-6.2 -3,-8.3 -0.8,-1.1 -1.8,-2 -2.8,-2.8 -0.7,-0.5 -2.7,-1.9 -3.8,-1.9 l -0.8,-0 -2.3,0.4 c -0.2,-0.8 0.1,-2 -0.1,-3.1 -0.1,-0.8 -0.2,-2.5 -0.2,-3.3 -0.2,-2.1 -0.5,-4.2 -0.9,-6.1 -0.6,-3.3 -2,-8.2 -4.6,-9.4 v 0.3 l -0.4,-0.1 0.1,-0.3 -0.8,-0.1 c -0.9,-0.1 -1.9,0.8 -2.3,1.3 -0.2,0.3 -1.7,2 -0.8,2 0.2,-0.6 1.3,-2.2 1.8,-2.4 l -0.8,2.7 z m 3,20.4 1.6,0.5 0.2,-0 c -0.1,-0.5 -1.4,-0.6 -1.8,-0.8 v 0.4 z m 3.6,-9.8 0.2,-2.6 -0.2,-0.1 -0.2,2.6 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 98.6,92.5 0.6,2 1.4,-4.2 -0.9,-0.4 c -0.3,0.7 -0.2,2.3 -1.1,2.6 z m -0.6,-1.4 -0.3,-0.6 c 0,0.6 0.4,1.8 0.8,1.9 l -0.1,-0.2 c 0.6,-0.2 0.9,-1.8 1,-2.4 l -1.6,-0.8 0.2,2.2 z m 2.4,-5.9 c 0.4,0.2 1.7,0.3 1.8,0.8 l -0.2,0 -1.6,-0.5 -0.6,4 0.9,0.5 c 0.4,-0.7 0.8,-2 1.1,-2.8 0.4,-0.8 1,-1.7 1.4,-2.4 h -0.2 l 0.2,-2.3 -2.4,-0.5 -0.4,3.2 z m -1,4.1 0.6,-3.9 -2.3,-0.6 0,0.2 0,3.4 z m 0.6,-4.2 0.4,-3.2 -2.5,-0.5 -0.2,3 z m 0.7,-6.6 0.3,-3.1 -2.4,-0.6 -0.4,3.2 z m -5.1,-4.8 -0.1,0.3 c -1.2,-0 -1.5,-0.9 -1.7,0.3 -0.1,0.4 -0.3,2.1 -0.3,2.4 0,0.2 0.7,0.2 1,0.3 0.7,0.2 0.7,0.2 0.7,-0.5 0,-0.8 0.3,-1.7 0.4,-2.4 h 0.4 l -0.4,3.2 2.4,0.6 0.4,-3.2 -2.3,-0.5 v -0.4 l 2.3,0.6 0.3,-2.4 -2.2,-0.4 c -0.3,0.6 0,2.3 -0.8,2.3 z m 8.3,-1 0.2,-2.9 -2.2,-0.4 c 0,3.4 -1.3,2.6 2,3.3 z m -6.2,11.7 -0.4,-0.1 v 0.4 l -2.4,-0.6 v 0.4 c 0,0.2 -0,0.2 -0.1,0.4 0.4,0.7 1.6,2.6 1.6,3.5 h 0.2 l -0.1,-0.4 0.8,0.4 v -3.5 h 0.4 l -0,-0.4 0,0 z m -0.3,5.4 0,-0.6 c 0,-0.5 -0.2,-0.8 -0.6,-0.9 l 0.6,1.4 z m 2.6,-4.8 0,0.4 0.2,0.1 0.2,0 0,-0.3 z m 3.3,-0.4 c 0.8,-0.4 1.5,-0.8 2.8,-0.8 -0.1,-0.1 -0.1,-0.1 -0.1,-0.2 v -0.4 l -2.5,-0.6 -0.2,2 z m -8.3,-1.1 2.4,0.8 0.2,-3 -2.5,-0.5 0,1 z m -1.8,-0.8 c 0,0.5 -0.2,0.2 0.5,0.4 0.3,0.1 0.6,0.2 1,0.3 v -2.1 c 0,-0.7 0.4,-0.6 -0.4,-0.7 -0.4,-0.1 -0.7,-0.2 -1.1,-0.2 v 2.4 z m 7.5,-4 h 0.3 l -0.2,2.8 h -0.4 v 0.4 l 0.3,0.1 c 0,-0.2 0,-0.4 0.2,-0.4 0.7,0 1.6,0.4 2.3,0.4 0,-0.3 0.3,-2.5 0.2,-2.6 -0,-0.2 -2,-0.6 -2.3,-0.6 v -0.4 l -0.4,-0.1 v 0.3 z m 3.3,-8.9 0.4,-0 -0.3,-0.4 c 0,-1.3 -0,-1.2 -0.3,-2.2 -0.2,-0.6 -0,-0.5 -0.7,-0.6 -0.4,-0.1 -0.8,-0.2 -1.1,-0.2 l -0.2,2.6 2.2,0.4 v 0.4 z m -2.4,-0.9 0.2,-2.6 -1.8,-0.4 -0.4,2.6 z m 4.4,13.8 0,-1.2 -0.1,-1.6 -2.2,-0.4 c 0,0.4 -0.2,2.7 -0.2,2.7 0.1,0.2 2.2,0.6 2.4,0.6 z m -7.8,-4.6 -0.2,2.9 2.4,0.4 0.3,-2.7 z m -0.2,3.2 0,-0.4 -0.3,0 0.2,-2.9 -2.3,-0.5 -0.3,2.8 2.4,0.5 0,0.4 z m -3.1,-1 0.3,-2.9 -1.6,-0.4 -0.2,2.9 z m 11.1,-0.8 -0.3,-3 -1.7,-0.4 -0.2,3 z m -2,-6.6 -2.3,-0.4 -0.3,2.5 2.4,0.6 z m -0.4,6 0.2,-3 -2.4,-0.6 -0.2,3.1 z m -2.4,-4 0.3,-2.6 -2.3,-0.5 -0.3,2.5 z m -2.9,3.2 0.1,-0.3 -0.2,-0.1 h -0.2 c 0,0.4 -0.1,0.3 0.2,0.4 z m 5.8,-2.4 1.7,0.3 c -0.1,-0.2 -0.2,-1.6 -0.3,-1.9 -0.1,-1 -0.2,-1 -1.2,-1 l -0.2,2.6 z m 0,0.3 0,-0.3 -0.3,-0.1 0,0.4 z m 0.2,-3 0,-0.3 -0.2,-0.1 0,0.3 z m 0,-0.3 1,0.2 c -0.1,-0.6 -0.2,-3 -0.8,-3 l -0.2,2.9 z m -5.1,-1.1 2.3,0.5 c 0,-3.4 1.3,-2.5 -1.9,-3.2 l -0.4,2.7 z m -2.5,-0.6 2.2,0.4 0.4,-2.7 -2.1,-0.4 z m 1.1,-5.6 -0.6,2.6 2.1,0.4 0.4,-2.6 -1.8,-0.4 0,-0.3 -0.4,-0.1 -0.1,0.3 z m -0.6,2.8 0,-0.2 -0.4,0 -0.1,0.2 0.2,0 0.2,0.1 z m 0.2,-2.9 -1,-0.2 -1,2.6 1.4,0.3 z m 4.8,0.7 1.5,0.2 -1.4,-2.6 z m -2.1,-0.4 1.8,0.4 0.2,-2.6 0.2,0.2 c -0,-0.4 -0,-0.3 -0.4,-0.3 l 0.1,-0.1 -1.2,-1.1 -0.1,0.1 -0.7,3.5 z m -2.2,-0.4 1.8,0.4 0.6,-3.7 c -0.4,-0 -0.2,-0.1 -0.6,-0.1 -1.6,0 -1.4,2.3 -1.9,3.4 z"
            }
        ], i["GR.IN.IC.ANIMAL FEEDLOT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 121.6,107.1 -0.4,-2.3 -0.2,-2 h 16.3 l -1.7,13.2 h -13 v -0.6 l -1,-8.2 z m 16.1,4.3 0.4,-2.3 0.9,-6.2 -0.1,-1.6 h -19.6 l 1.4,10.7 0.3,0.6 0.5,4.3 -0.1,0.6 h 15.7 v -1.6 l 0.6,-4.6 z M 123,82.6 c -3.3,-0.8 -4.6,0.4 -6.8,1.9 h -1.4 c -0.3,0.4 -0.6,1.2 -1.2,1.2 h -1 c -2.2,0 -3.9,-1.8 -5.8,-1.8 h -0.6 c -0.9,0 -2.1,0.8 -3.9,0.8 -5.1,0 -3.9,0.2 -8,1.5 -2,0.6 -6.2,0.8 -8.9,0.8 h -5.2 c -2.8,0 -5,-0.6 -7.2,-0.6 -2.6,0 -4.7,0.2 -7.4,0.2 -0.5,0 -0.5,-0.1 -0.8,-0.2 -2.4,1.2 -3.1,4.2 -3.1,7.8 0,3.6 -0.6,6.3 -0.6,10.1 v 0.2 c 0,0.6 0.1,0.6 0.2,1 l 1,-0.3 0,-0.5 h 0.4 l 0.2,-12.2 h 0.2 c 0,2 0.1,4.5 0.6,6 0.4,1.2 1.7,3.8 1.7,4.9 v 0.2 l -1.6,13.2 h 3.7 c 0,-1.4 -0.4,-1.1 -0.4,-2.1 v -2.1 c 0,-1.4 1,-4.2 2.3,-4.3 0.4,1.5 3.3,3.7 3.3,6.8 v 0.6 c 0,0.6 -0.1,0.6 -0.2,1 0.4,-0.1 0.5,-0.2 1,-0.2 1.2,0 3.5,0.7 3.5,-0.4 0,-0.3 -1.9,-3.2 -2.2,-3.5 -0.4,-0.5 -1.3,-3.6 -1.3,-4.3 v -0.2 c 0,-0.2 1.2,-2.3 1.2,-4.8 4,2.2 3.5,2.7 9.9,2.7 2.2,0 4.2,0.5 6,0.4 1,-0 3.3,-1.4 4.3,-1.9 0,1.2 0.4,2.4 0.2,3.3 l -1.2,8 c 1,0.3 1.6,0.6 2.8,0.6 h 0.6 -0.2 l 0.7,-11.3 c 0.6,0.4 2.8,7.1 2.6,8.4 l -0.3,2.3 c 0.8,0.4 1.5,0.6 2.6,0.6 h 1 l -1.2,-7.4 -0.1,-0.8 c 0,-0.9 1.6,-0.7 2.5,-1.2 0.6,-0.3 1.4,-1.2 1.8,-1.7 1.1,-1.5 2,-2.7 3,-4.2 3.9,-5.4 3.5,-2.4 10.2,-4 v -0.6 h 1.6 c 1,0 1.8,-0.8 1.8,-1.8 v -0.4 c 0,-2.4 -2.5,-2.5 -2.5,-5.6 l -3.3,-3.4 5.4,-2.9 z m 14.6,28.9 c 0.4,-0.4 0.4,-1.5 0.4,-2.3 l -0.4,2.3 z m -16.1,-4.3 c 0,-0.8 0,-1.9 -0.4,-2.3 l 0.4,2.3 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 121.2,104.9 c 0.4,0.4 0.4,1.5 0.4,2.3 l 1,8.2 v 0.6 h 13 l 1.7,-13.2 h -16.3 l 0.2,2.1 z"
            }
        ], i["GR.I.FF.SATELLITE"] = [
            {
                type: "path",
                stroke: !N && O,
                fill: !!N && O,
                d: "m 115,70 20,0 0,55 -20,0 z m -25,5 20,0 0,45 -20,0 z m -25,-5 20,0 0,55 -20,0 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 110,100 5,0 m -30,0 5,0 m 10,27 0,-7 m -20,15 c 10,-10 30,-10 40,0"
            }
        ], i["GR.IN.IC.FARM/RANCH"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 119.9,119 v -0.2 c 0,-2 1.5,-3.7 3.5,-3.7 h 0.4 c 2.2,0 3.7,1.6 3.7,4 v 0.6 c 0,1.2 -2.1,2.8 -3.7,2.8 h -0.4 c -1.9,0 -3.5,-1.6 -3.5,-3.5 z m -52,-10.7 c 1.3,-2 1.1,-2.7 3.2,-4.4 1.3,-1 3.3,-1.9 5.5,-1.9 h 0.6 c 4.7,0 9,4.1 9,8.8 v 1.1 c 0,5 -4,9.2 -8.8,9.2 H 76.9 c -5.4,0 -9.4,-4.2 -9.4,-9.6 0,-1.4 0.4,-1.6 0.4,-3 l 0,0 z m 7.9,-20.2 c -0.8,0 -1.5,-4.4 -1.8,-5.3 -0.2,-1 -1.3,-4.6 -1.3,-5.5 h 24.1 c 0.5,0 1.3,-0.8 1.3,-1.3 v -2.2 c 0,-0.7 -0.8,-1.1 -1.5,-1.1 h -31.8 c -0.7,0 -1.5,0.4 -1.5,1.1 v 2.2 c 0,0.5 0.8,1.3 1.3,1.3 h 3.5 l 2.6,16 -6.8,2.5 2.8,3.4 c -1,1.3 -2.3,2.1 -3.6,4.2 -0.4,0.8 -1.9,4.4 -1.9,5.5 v 2.2 c 0,5.4 1.6,8.8 4.3,11.5 2.3,2.3 6.5,4.8 11,4.8 h 0.4 c 8.8,0 15.8,-7.4 15.8,-16 h 13.4 c 0.6,0 1.9,1.4 2.4,1.8 h 8.6 c -1.1,1.6 -2.2,2.9 -2.2,5.7 0,4.6 3.9,8.6 8.6,8.6 4.4,0 8.8,-3.8 8.8,-7.9 v -2 c 0,-1.2 -1.5,-3.4 -2,-4.4 h 7.2 l 1,-4.6 h -7.2 v -0.6 l 1.2,-8.1 -0.1,-3.3 c 0,-0.6 -1.7,-2.1 -2.2,-2.4 l -16,-0.5 V 78.2 c 0,-0.5 -0.4,-0.9 -0.9,-0.9 -0.5,0 -0.9,0.4 -0.9,0.9 v 15.4 c -2.2,-0.2 -6,-0.4 -8.1,-0.4 -1.3,0 -2.9,0.1 -4.2,0 -2.1,-0.1 -2,-1.3 -2.9,-1.3 h -4.6 l 2,12.3 H 91.1 V 98.6 C 91.1,97.8 87.1,94.4 86.1,94.4 H 78.7 V 89.8 L 77.5,88.1 75.8,88 z M 88.1,92 c 0,0.5 0.1,0.2 0.2,0.9 h 0.6 c 0.9,0 8.5,-6.4 10.1,-6.8 V 85.4 c 0,-0.5 -0.2,-0.6 -0.6,-0.6 h -0.4 C 97.5,84.7 88.1,91.6 88.1,92 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 119.9,119 c 0,1.9 1.6,3.5 3.5,3.5 h 0.4 c 1.6,0 3.7,-1.6 3.7,-2.8 v -0.7 c 0,-2.3 -1.5,-4 -3.7,-4 h -0.4 c -2,0 -3.5,1.7 -3.5,3.7 v 0.2 z m -52,-10.7 c 0,1.4 -0.4,1.7 -0.4,3.1 0,5.4 4.1,9.6 9.4,9.6 h 0.6 c 4.8,0 8.8,-4.3 8.8,-9.2 v -1.1 c 0,-4.7 -4.3,-8.8 -9,-8.8 h -0.6 c -2.2,0 -4.3,0.9 -5.5,1.9 -2.2,1.7 -1.9,2.4 -3.2,4.4 z"
            }
        ], i["GR.IN.IC.GRAIN STORAGE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 122.8,69.6 c 0.4,0.1 0.9,0.5 1.3,1 0.4,0.5 0.8,1.2 1.3,2 l 2.1,4.1 -2.2,0 -1.9,-3.9 c -0.5,-1 -1,-1.7 -1.5,-2 -0.5,-0.3 -1.1,-0.5 -1.9,-0.5 l -2.2,0 0,6.4 -2.1,0 0,-15.2 4.6,0 c 1.7,1.5e-5 3,0.4 3.9,1.1 0.9,0.7 1.3,1.8 1.3,3.3 -1e-5,1 -0.2,1.7 -0.7,2.4 -0.4,0.6 -1.1,1.1 -1.9,1.3 m -5.1,-6.4 0,5.4 2.6,0 c 1,8e-6 1.7,-0.2 2.2,-0.7 0.5,-0.5 0.8,-1.1 0.8,-2 -1e-5,-0.9 -0.3,-1.6 -0.8,-2 -0.5,-0.5 -1.2,-0.7 -2.2,-0.7 l -2.6,0 m -12.3,-0.3 c -1.5,1.4e-5 -2.7,0.6 -3.6,1.7 -0.9,1.1 -1.3,2.6 -1.3,4.5 0,1.9 0.4,3.4 1.3,4.5 0.9,1.1 2.1,1.7 3.6,1.7 1.5,1e-6 2.7,-0.6 3.5,-1.7 0.9,-1.1 1.3,-2.6 1.3,-4.5 -2e-5,-1.9 -0.4,-3.4 -1.3,-4.5 -0.9,-1.1 -2,-1.7 -3.5,-1.7 m 0,-1.7 c 2.1,1.6e-5 3.8,0.7 5.1,2.1 1.3,1.4 1.9,3.3 1.9,5.7 -2e-5,2.4 -0.6,4.3 -1.9,5.7 -1.3,1.4 -3,2.1 -5.1,2.1 -2.1,0 -3.8,-0.7 -5.1,-2.1 -1.3,-1.4 -1.9,-3.3 -1.9,-5.7 -10e-7,-2.4 0.6,-4.3 1.9,-5.7 1.3,-1.4 3,-2.1 5.1,-2.1 m -21,0.3 12.8,0 0,1.7 -5.4,0 0,13.4 -2.1,0 0,-13.4 -5.4,0 0,-1.7 m -2,0.5 0,2 c -0.8,-0.4 -1.5,-0.6 -2.2,-0.8 -0.7,-0.2 -1.4,-0.3 -2,-0.3 -1.1,1.4e-5 -2,0.2 -2.6,0.7 -0.6,0.4 -0.9,1 -0.9,1.8 -4e-6,0.7 0.2,1.2 0.6,1.5 0.4,0.3 1.2,0.6 2.3,0.8 l 1.2,0.3 c 1.5,0.3 2.7,0.8 3.4,1.5 0.7,0.7 1.1,1.7 1.1,2.9 -1.2e-5,1.5 -0.5,2.6 -1.5,3.3 -1,0.8 -2.4,1.1 -4.3,1.1 -0.7,0 -1.5,-0.1 -2.3,-0.2 -0.8,-0.2 -1.6,-0.4 -2.5,-0.7 l 0,-2.1 c 0.8,0.5 1.6,0.8 2.4,1.1 0.8,0.2 1.6,0.4 2.4,0.4 1.2,1e-6 2.1,-0.2 2.7,-0.7 0.6,-0.5 1,-1.1 1,-2 -10e-6,-0.7 -0.2,-1.3 -0.7,-1.7 -0.5,-0.4 -1.2,-0.7 -2.2,-0.9 l -1.2,-0.2 c -1.5,-0.3 -2.6,-0.8 -3.3,-1.4 -0.7,-0.6 -1,-1.6 -1,-2.7 -10e-7,-1.3 0.5,-2.4 1.4,-3.2 0.9,-0.8 2.3,-1.2 3.9,-1.2 0.7,1.6e-5 1.4,0.1 2.2,0.2 0.7,0.1 1.5,0.3 2.3,0.6 m 24.4,48.1 -0.2,2.4 h 0.4 l -1.7,3 -1,-1.7 -0.1,2 0.5,0.6 -1.2,3 -1.5,-3 0.4,3.6 0.8,0.2 -3.1,9.7 -0.5,-4.2 0.1,-1.8 c 0,-1.5 0.8,-4.7 1,-6.3 0.3,-1.7 1.3,-4.5 1.4,-6 0.6,0.1 0.4,0.2 0.8,0.2 0.4,0 2.3,-1.5 2.6,-1.8 l -3,0.6 0.8,-2.7 c 0.6,0.1 0.4,0.2 0.8,0.2 0.4,0 2.6,-1.7 2.8,-2 l -3,0.8 0.7,-2.4 c 1.3,0 2.1,-0.8 2.8,-1.4 l -2.4,0.4 0.8,-2 c 1.1,-0 1.5,-0.9 1.8,-1.8 l -1.3,0.7 2.3,-6.1 -0.8,-0.1 -2.1,5.9 -0.3,0 -0.5,-2.1 -0.1,-0 c 0,1.5 -0.4,1.6 -0.4,2.4 0,0.5 0.2,0.5 0.6,0.6 l -0.9,2.1 -1,-1.4 c -0.1,1.6 -0.4,1.9 0.7,2.4 l -0.8,2.4 -1.7,-2.2 0.4,2.8 0.6,0.5 -0.5,2.7 -1.5,-1.9 0.2,2.4 0.9,0.5 c 0,0.4 -1,4.6 -1.2,6 -0.4,2.3 -0.9,3.5 -0.9,6.3 l -1.2,-3.6 0.6,-0.8 -0,-2 -1.2,1.2 -0.8,-2.8 0.6,-0.8 -0,-2 -1.1,1.2 -0.7,-1.7 c 1,-0.5 1,-1.6 1,-3.2 l -1.3,2.1 c -0.7,-0.2 -1.1,-1.4 -1.3,-2.3 0.3,-0.4 0.6,-0.5 0.6,-1 v -1.6 h -0.4 l -0.7,1.8 c -0.2,-0.2 -0.7,-0.7 -0.7,-1.2 0,-0.4 0.6,-0.3 0.6,-1 v -0.2 c 0,-1.1 -0.4,-1.1 -0.4,-2.4 l -0.7,2.3 -0.3,0 -2.8,-5.9 -0.4,0.2 2.5,5.7 -1.3,-0.7 1,1.9 1,0 0.6,1 -2.6,-0.4 c 0.4,0.4 1.7,1.4 2.4,1.4 0.1,0 0.4,-0.1 0.6,-0.2 l 1,2.2 -3.2,-0.6 c 1.1,1 2,1.7 3.6,1.6 l 1.1,2.7 -2.9,-0.4 c 0.7,1 1.7,1.3 3,1.5 0.4,0.1 1.1,2.8 1.2,3.5 l -3,-0.6 2.2,1.6 h 1 c 1.2,2.3 2.4,11.9 2.4,15.8 h 1.4 l -0.2,-2.2 0,-1 c 0,-4 2.9,-9.3 3.2,-12.3 0.8,0.1 0.5,0.2 1,0.2 0.2,0 2.9,-1.2 3.2,-1.4 l -3.6,0.3 1.2,-3.1 0.8,0.4 3,-1.3 -3.2,0.2 1.4,-2.8 c 0.4,0.1 0.4,0.2 1,0.2 0.3,0 2.1,-1 2.4,-1.2 l -2.8,0.2 1.4,-2 c 1.5,0.1 1.5,-0.4 2.4,-1.6 l -1.4,0.4 c 0.5,-1.1 1.2,-2.2 1.8,-3.2 0.4,-0.6 2,-2.7 0.8,-3 l 0.2,0.1 -3.4,5.8 -0.4,-2.3 h -0.2 c 0,1.4 -0.6,1.7 -0.6,2.2 0,0.3 0.3,0.7 0.4,1 l -1.5,2 -0.7,-1.9 z m -25.4,13.5 c 0,-3.7 0.1,-9.1 0.7,-12.4 0.4,-2 0.1,-4 0.6,-6 0.4,-1.7 0.4,-4.2 0.8,-5.8 2.8,-10.1 1,-11.8 14.3,-11.8 h 4.4 c 11.6,0 12.6,1.2 14.2,11.3 1.2,7.6 2,14.6 2,23.6 v 8.3 l -0.4,3.6 c -1.1,1.6 -2.1,3.4 -4.9,3.4 H 86.7 c -5.4,0 -5.3,-6.4 -5.3,-11.9 v -2.4 z m -5.8,-32.5 c 2.1,-0.6 0.4,-1.3 4.4,-1 2.4,0.2 3,0.3 5,0.8 -0.7,1.1 -4.6,3 -6.5,3 h -0.4 c -0.9,0 -2.4,-1.2 -2.4,-2 v -0.8 h -0 z m 43.2,-1.5 c 2.2,-0.2 4.8,0.9 4.8,3.1 v 0.6 c 0,0.6 -0.6,0.8 -1.2,0.8 h -0.6 c -1.8,0 -6.2,-2.7 -6.9,-3.9 l 4,-0.6 z m -36.6,-6.7 c 0,-1 1,-2.2 1.8,-2.2 h 0.6 c 0.6,0 1.4,1.6 1.4,2.2 v 4.2 c 0,1.3 -0.4,1.5 -0.4,2.8 -1,-0.3 -3.4,-4.3 -3.4,-5.5 v -1.4 h -0 z m 31.7,2.8 c 0,-2.8 -0,-5.2 2.8,-5.2 h 0.6 c 0.6,0 1,0.7 1,1.4 0,2 -3,6.8 -4.4,7.3 v -3.6 h -0 z m 1.4,3.8 c 0.5,-1.8 3.8,-5 3.8,-7.1 v -1.4 c -0.6,-0.3 -0.7,-1.2 -1.6,-1.2 h -0.6 c -2.6,0 -3.8,2 -3.8,4.5 v 4.2 c -2,-0.5 -2.3,-1 -5.2,-1.2 -2,-0.2 -3.7,-0.4 -6,-0.4 h -3.6 c -4.8,0 -8.9,0.3 -12.1,2 0.2,-0.7 0.4,-0.9 0.4,-1.8 v -3.4 c 0,-1.4 -1,-3.8 -2.2,-3.8 h -0.8 c -0.8,0 -2.6,1.9 -2.6,3 0,2 2.1,5.5 3,6.8 l -5.7,-0.5 c -1.2,0 -3.4,1.1 -3.4,2.1 v 0.6 c 0,1.3 1.7,2.8 3,2.8 h 0.2 c 2.9,0 4.5,-2 6.3,-2.4 -1.9,3.5 -3.8,22 -3.8,28.1 v 6 c 0,5.9 0.3,12.3 6.1,12.3 h 26.1 c 4.1,0 6.1,-3.8 6.1,-7.9 v -10.5 c 0,-2.3 -0.2,-5.5 -0.4,-7.7 -0.2,-1.8 -0.8,-5.7 -0.8,-7.4 0,-2.6 -0.7,-4.7 -1,-7.1 -0.2,-2.1 -1.3,-4.3 -1.8,-6.2 1.2,0.6 4.9,3 6.1,3 h 1.2 c 1,0 1.8,-0.8 1.8,-1.8 v -0.2 c 0,-2.2 -1.5,-3.8 -3.8,-3.8 h -2.6 l -2.8,0.4 z m -28.1,0.6 c 0.5,1.9 8.9,3.2 11.9,3.2 h 1 c 3.1,0 12.5,-1.4 12.7,-3.6 -4.1,-1 -6.5,-1.8 -11.9,-1.8 h -1.4 c -2.4,0 -4.4,0.4 -6.5,0.6 -2.9,0.4 -3.8,1.1 -5.8,1.6 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 105.3,110.1 c -0.3,0.3 -2.2,1.8 -2.6,1.8 -0.4,0 -0.2,-0.1 -0.8,-0.2 0,1.5 -1.1,4.3 -1.3,6 -0.3,1.6 -1,4.8 -1,6.3 l -0.1,1.8 0.5,4.2 3.1,-9.7 -0.8,-0.2 -0.4,-3.6 1.5,3 1.2,-3 -0.5,-0.6 0.1,-2 1,1.7 1.7,-3 h -0.4 l 0.2,-2.4 -0.3,-1.2 -1.2,1.2 z m 0,0 1.2,-1.2 0.3,1.2 0.7,1.9 1.5,-2 c -0.1,-0.3 -0.4,-0.7 -0.4,-1 0,-0.5 0.6,-0.8 0.6,-2.2 h 0.2 l 0.4,2.3 3.4,-5.7 -0.2,-0.1 c 1.3,0.4 -0.4,2.4 -0.8,3 -0.6,1 -1.3,2.1 -1.8,3.2 l 1.4,-0.4 c -0.8,1.2 -0.9,1.7 -2.4,1.6 l -1.4,2 2.8,-0.2 c -0.3,0.2 -2,1.2 -2.4,1.2 -0.5,0 -0.5,-0.1 -1,-0.2 l -1.4,2.8 3.2,-0.2 -3,1.3 -0.8,-0.4 -1.2,3.1 3.6,-0.4 c -0.3,0.2 -2.9,1.4 -3.2,1.4 -0.5,0 -0.2,-0.1 -1,-0.2 -0.3,2.9 -3.2,8.2 -3.2,12.3 l -0.1,1 0.3,2.2 h -1.4 c 0,-4 -1.2,-13.6 -2.4,-15.8 h -1 l -2.2,-1.6 3,0.6 c 0,-0.7 -0.8,-3.4 -1.2,-3.5 -1.3,-0.2 -2.3,-0.5 -3,-1.5 l 2.9,0.4 -1.1,-2.8 c -1.5,0.1 -2.5,-0.6 -3.6,-1.6 l 3.2,0.6 -1.1,-2.2 c -0.2,0.1 -0.5,0.2 -0.6,0.2 -0.7,0 -2,-1 -2.4,-1.4 l 2.6,0.4 -0.6,-1 h -1 l -1,-1.9 1.3,0.7 -2.5,-5.7 0.4,-0.2 2.8,5.9 0.3,-0 0.7,-2.4 c 0,1.3 0.4,1.2 0.4,2.4 v 0.2 c 0,0.7 -0.6,0.6 -0.6,1 0,0.4 0.5,1 0.7,1.2 l 0.7,-1.8 h 0.4 v 1.6 c 0,0.5 -0.3,0.6 -0.6,1 0.2,0.9 0.5,2.1 1.3,2.3 l 1.3,-2.1 c 0,1.5 0,2.6 -1,3.2 l 0.7,1.7 1.1,-1.2 0,2 -0.6,0.8 0.8,2.8 1.2,-1.2 0,2 -0.6,0.7 1.2,3.6 c 0,-2.8 0.4,-4 0.9,-6.2 0.3,-1.3 1.3,-5.6 1.2,-6 l -0.9,-0.5 -0.2,-2.5 1.5,1.9 0.5,-2.7 -0.6,-0.5 -0.4,-2.8 1.7,2.2 0.8,-2.4 c -1,-0.5 -0.8,-0.8 -0.7,-2.4 l 1,1.4 0.9,-2.1 c -0.4,-0.1 -0.6,-0 -0.6,-0.6 0,-0.8 0.4,-0.9 0.4,-2.4 l 0.1,0 0.5,2.1 0.3,-0 2.1,-5.9 0.8,0.1 -2.3,6.1 1.3,-0.7 c -0.2,0.9 -0.6,1.8 -1.8,1.8 l -0.8,2 2.4,-0.4 c -0.7,0.6 -1.5,1.4 -2.8,1.4 l -0.7,2.4 3,-0.8 c -0.2,0.3 -2.4,2 -2.8,2 -0.4,0 -0.2,-0.1 -0.8,-0.2 l -0.8,2.7 3,-0.5 z M 87.1,90.1 c 2,-0.5 2.9,-1.2 5.8,-1.6 2.1,-0.3 4.1,-0.6 6.5,-0.6 h 1.4 c 5.4,0 7.8,0.8 11.9,1.8 -0.2,2.2 -9.6,3.6 -12.7,3.6 h -1 c -3,0 -11.4,-1.3 -11.9,-3.2 z m -5.8,33.5 v 2.4 c 0,5.5 -0.1,11.9 5.3,11.9 h 26.4 c 2.8,0 3.8,-1.7 4.9,-3.4 l 0.4,-3.6 v -8.3 c 0,-9 -0.8,-15.9 -2,-23.6 -1.6,-10.1 -2.6,-11.3 -14.2,-11.3 h -4.4 c -13.3,0 -11.6,1.7 -14.3,11.8 -0.4,1.6 -0.4,4 -0.8,5.8 -0.5,2 -0.2,3.9 -0.6,6 -0.6,3.3 -0.7,8.6 -0.7,12.4 z M 114.8,90.2 c 0.7,1.2 5.2,3.9 6.9,3.9 h 0.6 c 0.6,0 1.2,-0.2 1.2,-0.8 v -0.6 c 0,-2.2 -2.6,-3.3 -4.8,-3.1 l -4,0.6 0,0 z m -39.2,0.9 v 0.8 c 0,0.8 1.4,2 2.4,2 h 0.4 c 2,0 5.8,-1.9 6.5,-3 -2,-0.4 -2.6,-0.6 -5,-0.8 -3.8,-0.3 -2.1,0.4 -4.3,1 z m 38.3,-5.3 v 3.6 c 1.3,-0.5 4.4,-5.3 4.4,-7.3 0,-0.7 -0.4,-1.4 -1,-1.4 h -0.6 c -2.8,-0 -2.8,2.4 -2.8,5.1 z m -31.7,-2.8 v 1.4 c 0,1.3 2.4,5.3 3.4,5.5 0,-1.3 0.4,-1.5 0.4,-2.8 v -4.2 c 0,-0.6 -0.8,-2.2 -1.4,-2.2 h -0.6 c -0.8,0 -1.8,1.3 -1.8,2.2 z"
            }
        ], i["GR.IN.IC.ATM"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 73.6,116.3 c 5.1,-0.1 15.8,-6.6 17,-6.6 0.4,0 7.4,3.8 8.9,4.2 -0.4,0.6 -5.1,4.6 -6.2,5.7 -1.2,1.2 -4.7,5.8 -5.5,6.4 -1.6,-0.8 -14,-8.9 -14.2,-9.6 z m -15.1,-6.2 11.9,-2.5 11.1,5.6 -9.6,3 16.2,10.7 -0,-0.2 6.4,-7.5 26.9,12.7 20.3,-46.8 -50.2,-17.2 c -0.6,2.2 -5.2,9.1 -6.5,11.8 -0.8,1.8 -2.3,4.4 -3.3,6 -1.2,1.8 -2.2,4.1 -3.3,6 -1.2,2 -2.1,3.8 -3.3,5.8 -1.2,1.9 -2.1,4.2 -3.3,6 -2.4,3.6 -0.2,2.7 -5.5,3.7 -2.6,0.5 -5.2,1 -7.7,1.6 m 62,21.5 -25.2,-11.8 4.8,-4 7.3,3.5 1.2,-2.4 -23.9,-11.7 v 0.2 l -1,2.2 6,2.9 -6.2,3.4 -11.8,-5.8 -0.2,0 20.7,-37 0.2,0.1 47.4,16.1 h 0.2 l -19.4,44.2 z m 7.8,-31.3 1.1,-2 -5.8,-2.3 -0.8,2.3 z m -2.7,5.2 1.2,-1.9 -5.6,-2.3 -0.8,2.2 z m -22,-7.3 c 0.6,0.4 2.1,1.4 2.1,2.1 v 2.4 c 0,0.8 -1.7,1.5 -2.6,1.5 h -0.2 c -0.8,0 -1,-0.2 -1.7,-0.4 l 2.4,-5.7 z m -3.4,-6.4 c 0,-2.2 1.1,-2.8 3.2,-2.8 h 0.2 c 0.7,0 1,0.2 1.5,0.4 l -2.2,5.1 c -0.9,-0 -2.8,-1.2 -2.8,-2.4 v -0.2 z m 5.6,-4.2 c -0.3,-0.1 -1.2,-0.5 -1.6,-0.5 h -1.9 c -0.7,0 -2.5,0.6 -2.9,0.9 -0.3,0.2 -1.4,2.1 -1.4,2.5 v 1.7 c 0,2.1 3.8,4.2 3.8,4.9 0,0.4 -2.2,4.6 -2.4,5.7 -0.6,-0.3 -2.5,-1.8 -2.5,-2.6 v -0.6 c 0,-0.8 0.6,-1.4 0.8,-2.1 -0.9,-0.2 -2,-1.1 -2.4,-1.2 -0.4,-0.1 -1,1.7 -1,2.3 v 0.4 c 0,2.7 4.2,5.4 4.2,5.7 0,0.6 -0.4,1.4 -0.5,2 l 1.7,0.8 0.6,-1.7 c 1.4,0 2,0.8 3.6,0.8 h 0.6 c 1.4,0 2.6,-0.5 3.2,-1.3 0.3,-0.4 1.5,-2.4 1.5,-3 v -0.4 c 0,-2.6 -2.8,-4.8 -4.4,-5.9 l 2.5,-5.6 h 0.4 c 0.4,1.2 1.5,0.6 1.5,3.6 l 2.8,1.2 v -1.7 c 0,-2 -2,-4.1 -3.8,-4.6 l 0.8,-2.1 -2.1,-0.5 -0.8,1.5 z m 13,18.4 -0.9,2 5.4,2.2 -0,-0.2 1.2,-1.8 z m -22.4,-25.2 26.1,9.5 -11,24.1 -26.7,-12.8 11.6,-20.8 z m -12.5,21.2 27.8,13.4 11.7,-25.7 c -1,-0.1 -11.8,-4.2 -13.4,-4.8 -1.2,-0.5 -13.3,-5 -13.5,-5 -0.9,0 -5.4,9.5 -6.4,10.8 -0.8,1.3 -5.9,10.3 -6.1,11.2 z m 31.7,11.2 5.4,2.2 -0.1,-0.2 1.3,-1.8 c -1.1,-0.2 -5,-2.2 -5.5,-2.2 -0.4,0 -1.1,1.6 -1.2,2.1 z m -25.8,0.6 4.3,2.9 -6,5.8 -6,-4.1 7.7,-4.6 z m -9.1,4.5 7.4,4.9 7.1,-6.6 c -0.5,-0.4 -5.3,-3.6 -5.4,-3.6 -1,0 -7.6,4.9 -9.1,5.3 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 115.7,111.8 c 0,-0.5 0.8,-2.1 1.2,-2.1 0.5,0 4.4,2 5.5,2.3 l -1.3,1.8 0.1,0.2 -5.4,-2.2 z m 3.2,-7.1 5.7,2.2 -1.2,1.8 0,0.2 -5.4,-2.2 0.9,-2 z m 2.4,-4.8 5.6,2.3 -1.2,1.9 -5.2,-2 0.8,-2.2 z m 2.5,-5.3 5.8,2.3 -1.1,2 -5.5,-2 0.8,-2.3 z m -39.7,6 c 0.2,-1 5.3,-10 6.1,-11.2 0.9,-1.4 5.4,-10.8 6.4,-10.8 0.2,0 12.3,4.5 13.5,5 1.7,0.7 12.5,4.8 13.5,4.8 l -11.7,25.7 -27.8,-13.4 z m 55.9,-14.6 h -0.2 l -47.4,-16.1 -0.2,-0.1 -20.7,37 0.2,-0 11.8,5.8 6.3,-3.4 -6,-2.9 1,-2.2 v -0.2 l 23.9,11.7 -1.2,2.4 -7.3,-3.5 -4.8,4 25.2,11.8 19.4,-44.2 0,0 z m -59.1,30.9 c 1.5,-0.4 8,-5.3 9.1,-5.3 0.2,0 4.9,3.2 5.5,3.6 l -7.2,6.6 -7.4,-4.9 z m -7.2,-0.6 c 0.2,0.8 12.6,8.8 14.2,9.6 0.8,-0.6 4.3,-5.2 5.5,-6.4 1.1,-1.1 5.8,-5.1 6.2,-5.7 -1.6,-0.3 -8.5,-4.1 -8.9,-4.1 -1.2,0 -11.9,6.5 -17,6.6 z m 26.6,-25.9 v 0.2 c 0,1.2 1.8,2.4 2.7,2.4 l 2.2,-5 c -0.4,-0.2 -0.8,-0.4 -1.5,-0.4 h -0.2 c -2.1,0 -3.2,0.7 -3.2,2.8 z m 0.9,12.1 c 0.7,0.2 0.9,0.4 1.7,0.4 h 0.2 c 1,0 2.6,-0.7 2.6,-1.5 v -2.4 c 0,-0.7 -1.6,-1.7 -2.1,-2.1 l -2.4,5.6 z m 5.5,-17.7 2.1,0.5 -0.8,2.1 c 1.8,0.4 3.8,2.5 3.8,4.6 v 1.7 l -2.8,-1.1 c 0,-3 -1.1,-2.4 -1.5,-3.6 h -0.4 l -2.5,5.6 c 1.6,1.1 4.4,3.3 4.4,5.9 v 0.4 c 0,0.6 -1.2,2.6 -1.5,3 -0.6,0.8 -1.8,1.3 -3.2,1.3 h -0.6 c -1.6,0 -2.2,-0.7 -3.6,-0.8 l -0.6,1.7 -1.7,-0.8 c 0.1,-0.6 0.5,-1.4 0.5,-2 0,-0.3 -4.2,-2.9 -4.2,-5.7 v -0.4 c 0,-0.6 0.6,-2.4 1,-2.4 0.4,0.1 1.4,1 2.4,1.2 -0.2,0.7 -0.7,1.3 -0.7,2.1 v 0.6 c 0,0.8 1.8,2.3 2.4,2.6 0.2,-1 2.4,-5.3 2.4,-5.7 0,-0.7 -3.8,-2.8 -3.8,-4.9 V 89.1 c 0,-0.4 1.1,-2.3 1.4,-2.5 0.4,-0.3 2.2,-0.9 2.9,-0.9 h 1.9 c 0.4,0 1.4,0.4 1.6,0.5 l 0.8,-1.4 z m -21.8,15.4 26.6,12.9 11,-24.1 -26,-9.5 -11.6,20.8 z m 5,12.1 -7.7,4.6 6,4.1 6,-5.8 z"
            }
        ], i["GR.IN.IC.BANK"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 100.8,110.6 c 2.4,0 5.3,1.9 5.3,4.4 v 0.7 c 0,3.1 -2.1,4.9 -5.3,4.9 v -9.9 z m -6.6,-8.8 c 0,-2.3 1.7,-4.4 4,-4.4 h 0.7 v 9 c -1.9,-0.4 -4.6,-1.6 -4.6,-3.7 v -0.9 z m 6.6,-4.4 c 2.2,0 4.6,1.6 4.6,3.5 v 0.9 h 3.5 c 0,-5.3 -3.7,-6.7 -8.1,-7.7 v -2.4 h -2 v 2.4 c -3.9,0 -8.2,3.5 -8.2,7 v 2.6 c 0,1.3 2,3.6 3,4.2 1,0.6 3.8,1.8 5.1,1.9 v 10.6 c -3.4,-0.1 -5.2,-2.6 -5.2,-6.1 h -3.3 l 0.2,3.5 c 1.1,1.7 0.9,2.8 2.9,4.1 1.3,0.8 3.4,1.6 5.5,1.6 v 4 h 2 v -3.9 c 4.9,0 9,-3.4 9,-8.1 v -1.8 c 0,-4.2 -5.4,-6 -9,-6.8 v -9.4 z m -25.3,15.2 v -2.4 c 0,-2.2 2.6,-7.4 3.1,-9.4 0.7,-2.7 3.1,-5.9 4.7,-8 3.5,-4.6 8.5,-8.9 16.5,-8.9 h 4.4 c 3.4,0 8.8,4.3 10.4,6.5 1.3,1.7 2.2,3.1 3.4,5 0.5,0.7 2.7,5.2 2.7,5.9 v 0.7 h 0.4 v 0.7 c 0,0.4 0.9,1.5 0.8,3.1 l 0.5,0.7 c 0,2 1.1,6.8 1.3,9 0.4,3.2 1.3,5.6 -0.7,8.5 0,2.4 -5.2,8.7 -6.2,8.8 l -9.2,-1.5 c -1.8,-0.3 -6.8,2 -9.2,2 -2,0 -5.6,-1.7 -7.5,-1.7 -1.6,0 -3.2,1.3 -5.5,1.3 h -0.6 c -1.9,0 -5.9,-6.1 -7,-7.7 -1.8,-2.6 -2.4,-8 -2.4,-12.3 z m 30.7,-31 -6.1,-1.1 c -0.8,-0.1 -5.2,1.1 -5.8,1.3 l -6.3,-11.5 1.7,0.5 v -2.9 l 8.9,3.4 0.3,-3.5 3.2,2.5 5.7,-2.6 v 2.6 l 7.5,-1.4 -9.3,13 0,0 z m 11.8,-14.5 -9.1,1.6 v -2.8 c -0.9,0.5 -5.7,2.9 -6.6,2.9 -0.1,0 -3.4,-2.6 -4,-2.9 l -0.7,4 -8.8,-3.6 v 2.9 l -3.1,-1 8.1,15.1 -0.2,0.1 c -4.6,1.1 -10.3,6.8 -12.7,10.4 -0.8,1.1 -1.3,2.6 -2,3.7 -1.4,1.8 -0.9,2.5 -1.7,4 -0.6,1.1 -2.9,7.2 -2.9,8.6 v 3.7 c 0,1 0.7,5.8 1,6.7 0.4,1.4 0.4,2 0.8,3.2 0.3,0.9 0.9,1.6 1.4,2.3 1.3,2 4.8,7.5 7.6,7.5 2.5,0 4.3,-1.3 5.7,-1.3 2.3,0 5.2,1.7 7.3,1.7 h 0.7 c 2,0 5.7,-1.4 8,-1.9 1.8,-0.3 5.9,1 8.5,1 h 1.7 c 1.7,0 4.8,-4.2 5.8,-5.5 1.1,-1.4 1.3,-2.2 1.7,-4 0.1,-0.4 1.1,-4.3 1.1,-4.4 0,-3 -0.9,-4.1 -1.1,-5.9 -0.2,-2.4 -0.4,-4 -0.7,-6.1 -0.2,-1.7 -2.8,-8.6 -3.6,-10.3 -2.4,-4.9 -7.7,-13.2 -14,-13.7 l 11.7,-16.2 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 100.8,120.4 c 3.2,0 5.3,-1.7 5.3,-4.9 v -0.6 c 0,-2.5 -2.9,-4.3 -5.3,-4.4 v 9.8 z m -6.6,-18.7 v 0.9 c 0,2.2 2.8,3.3 4.6,3.7 v -9 h -0.7 c -2.3,0 -4,2 -4,4.4 z m 6.6,5 c 3.6,0.8 9,2.6 9,6.8 v 1.7 c 0,4.7 -4.1,8.1 -9,8.1 v 4 h -2 v -3.9 c -2,0 -4.2,-0.7 -5.5,-1.6 -2,-1.3 -1.7,-2.5 -2.9,-4.2 l -0.2,-3.5 h 3.3 c 0,3.5 1.8,6.1 5.3,6.2 v -10.6 c -1.3,-0.1 -4.1,-1.3 -5.1,-2 -1,-0.6 -3,-3 -3,-4.2 v -2.6 c 0,-3.5 4.2,-7 8.1,-7 v -2.4 h 2 v 2.4 c 4.4,1 8.1,2.3 8.1,7.7 h -3.5 v -0.9 c 0,-1.9 -2.5,-3.5 -4.6,-3.5 v 9.5 l 0,0 z m -25.3,5.8 c 0,4.3 0.6,9.8 2.4,12.3 1.1,1.6 5.1,7.7 7,7.7 h 0.7 c 2.3,0 3.9,-1.3 5.5,-1.3 1.9,0 5.5,1.7 7.5,1.7 2.5,0 7.4,-2.3 9.2,-2 l 9.1,1.5 c 1,0 6.2,-6.4 6.2,-8.8 2,-2.9 1,-5.3 0.7,-8.6 -0.2,-2.2 -1.3,-6.9 -1.3,-9 l -0.5,-0.6 c 0.1,-1.6 -0.8,-2.7 -0.8,-3.1 v -0.7 h -0.4 v -0.7 c 0,-0.7 -2.2,-5.2 -2.7,-5.9 -1.1,-1.9 -2.1,-3.2 -3.4,-5 -1.6,-2.2 -7,-6.5 -10.4,-6.5 h -4.4 c -8,0 -13,4.4 -16.5,8.9 -1.6,2.1 -4,5.3 -4.7,8 -0.5,2 -3.1,7.2 -3.1,9.4 v 2.4 z m 40,-44 -7.4,1.5 v -2.6 l -5.8,2.6 -3.2,-2.4 -0.3,3.5 -8.9,-3.4 v 2.9 l -1.7,-0.5 6.3,11.5 c 0.5,-0.2 5,-1.4 5.8,-1.3 l 6.1,1.1 9.3,-13 0,0 z"
            }
        ], i["GR.IN.IC.BULLION STORAGE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 123.1,77.9 c 0.4,0.1 0.9,0.5 1.3,1 0.4,0.5 0.8,1.2 1.3,2 l 2.1,4.1 -2.2,0 -1.9,-3.9 c -0.5,-1 -1,-1.7 -1.5,-2 -0.5,-0.3 -1.1,-0.5 -1.9,-0.5 l -2.2,0 0,6.4 -2.1,0 0,-15.2 4.6,0 c 1.7,1.5e-5 3,0.4 3.9,1.1 0.9,0.7 1.3,1.8 1.3,3.3 -1e-5,1 -0.2,1.7 -0.7,2.4 -0.4,0.6 -1.1,1.1 -1.9,1.3 m -5.1,-6.4 0,5.4 2.6,0 c 1,8e-6 1.7,-0.2 2.2,-0.7 0.5,-0.5 0.8,-1.1 0.8,-2 -1e-5,-0.9 -0.3,-1.6 -0.8,-2 -0.5,-0.5 -1.2,-0.7 -2.2,-0.7 l -2.6,0 m -12.3,-0.3 c -1.5,1.4e-5 -2.7,0.6 -3.6,1.7 -0.9,1.1 -1.3,2.6 -1.3,4.5 -10e-6,1.9 0.4,3.4 1.3,4.5 0.9,1.1 2.1,1.7 3.6,1.7 1.5,10e-7 2.7,-0.6 3.5,-1.7 0.9,-1.1 1.3,-2.6 1.3,-4.5 -1e-5,-1.9 -0.4,-3.4 -1.3,-4.5 -0.9,-1.1 -2,-1.7 -3.5,-1.7 m 0,-1.7 c 2.1,1.5e-5 3.8,0.7 5.1,2.1 1.3,1.4 1.9,3.3 1.9,5.7 -1e-5,2.4 -0.6,4.3 -1.9,5.7 -1.3,1.4 -3,2.1 -5.1,2.1 -2.1,0 -3.8,-0.7 -5.1,-2.1 -1.3,-1.4 -1.9,-3.3 -1.9,-5.7 -10e-7,-2.4 0.6,-4.3 1.9,-5.7 1.3,-1.4 3,-2.1 5.1,-2.1 m -21,0.3 12.8,0 0,1.7 -5.4,0 0,13.4 -2.1,0 0,-13.4 -5.4,0 0,-1.7 m -2,0.5 0,2 c -0.8,-0.4 -1.5,-0.6 -2.2,-0.8 -0.7,-0.2 -1.4,-0.3 -2,-0.3 -1.1,1.4e-5 -2,0.2 -2.6,0.7 -0.6,0.4 -0.9,1 -0.9,1.8 -3e-6,0.7 0.2,1.2 0.6,1.5 0.4,0.3 1.2,0.6 2.3,0.8 l 1.2,0.3 c 1.5,0.3 2.7,0.8 3.4,1.5 0.7,0.7 1.1,1.7 1.1,2.9 -1.2e-5,1.5 -0.5,2.6 -1.5,3.3 -1,0.8 -2.4,1.1 -4.3,1.1 -0.7,0 -1.5,-0.1 -2.3,-0.2 -0.8,-0.2 -1.6,-0.4 -2.5,-0.7 l 0,-2.1 c 0.8,0.5 1.6,0.8 2.4,1.1 0.8,0.2 1.6,0.4 2.4,0.4 1.2,10e-7 2.1,-0.2 2.7,-0.7 0.6,-0.5 1,-1.1 1,-2 -1e-5,-0.7 -0.2,-1.3 -0.7,-1.7 -0.5,-0.4 -1.2,-0.7 -2.2,-0.9 l -1.2,-0.2 c -1.5,-0.3 -2.6,-0.8 -3.3,-1.4 -0.7,-0.6 -1,-1.6 -1,-2.7 -2e-6,-1.3 0.5,-2.4 1.4,-3.2 0.9,-0.8 2.3,-1.2 3.9,-1.2 0.7,1.5e-5 1.4,0.1 2.2,0.2 0.7,0.1 1.5,0.3 2.3,0.6 M 103.6,119.3 h 9.6 c 0.4,0 9,9.2 9.6,10.1 H 95.6 c 0.2,-1 7.4,-10.1 8,-10.1 z m -29.2,0 h 9.9 c 0.6,0 8.2,9 8.9,10.1 H 65.9 c 0.3,-1 7.8,-10.1 8.4,-10.1 l 0,0 z m 11.5,0 h 15.4 l -6.9,9.9 -8.5,-9.9 z m -5.5,-1 c 0.7,-1.1 7.6,-9.4 8.4,-9.4 h 9.2 c 0.7,0 8.9,8.5 9.2,9.4 H 80.4 z m 43.7,10.8 -9.5,-10.4 10.4,-14.3 9.7,8.5 -10.7,16.1 0,0 z m -4.8,-24.8 4.8,-0 -10.5,14.1 -4.1,-0.1 9.8,-13.9 z m -31.1,-0.2 2.8,0.1 c -1.1,1.6 -4.6,4.9 -6.2,6.8 -1.7,2.1 -4.2,5.1 -5.6,7.2 l -4.2,-0.1 13.2,-14.1 z m 21.1,-8.6 c 0.9,0.6 9,8.2 9,8.5 0,0.1 -9.3,13.6 -9.9,14 l -8.9,-9.9 9.8,-12.6 z M 89.1,108 c 0.9,-1.3 11.4,-12.6 12.1,-12.6 h 6.8 l -9.5,12.5 -9.4,0 z m 2.9,-4.6 h -4.6 c -1.2,1.8 -4.3,4.9 -6,6.6 -2.1,2.1 -3.9,4.4 -6,6.5 -1.3,1.3 -11.2,12.8 -11.4,13.7 0.5,0.1 0.5,0.2 1.2,0.2 l 59.3,-0 11.6,-17.5 -0.3,0.1 -10.5,-9.6 h -5.8 c -1.5,-1 -9.6,-8.9 -10.4,-8.9 h -8.2 c -0.9,0 -7.6,8 -9,8.9 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 103.6,119.3 c -0.5,0 -7.7,9.2 -8,10.1 h 27.3 c -0.6,-1 -9.2,-10.1 -9.6,-10.1 h -9.6 z m -29.2,0 c -0.6,0 -8.2,9.1 -8.4,10.1 h 27.3 c -0.7,-1.1 -8.3,-10.1 -8.9,-10.1 H 74.3 l 0,0 z m 50.7,-14.7 -10.4,14.3 9.5,10.4 10.7,-16.1 z m -30.7,24.7 6.9,-9.9 -15.4,0 z m 5.1,-21.1 8.9,9.9 c 0.6,-0.4 9.9,-13.9 9.9,-14 0,-0.3 -8.1,-7.9 -9,-8.5 l -9.9,12.6 z m -19.1,10.2 h 26.8 c -0.2,-0.9 -8.5,-9.4 -9.2,-9.4 h -9.2 c -0.9,0 -7.7,8.3 -8.4,9.4 z m 33.2,0.1 10.5,-14.1 -4.8,0 -9.8,13.9 z m -38.6,-0.2 4.2,0.1 c 1.4,-2.1 3.9,-5.1 5.6,-7.2 1.6,-1.9 5.1,-5.2 6.2,-6.8 l -2.8,-0.1 -13.2,14.1 z m 14.1,-10.3 9.4,-0 9.5,-12.5 h -6.7 c -0.7,0 -11.2,11.2 -12.1,12.6 z"
            }
        ], i["GR.IN.IC.FEDERAL RESERVE BANK"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 65.6,125.4 h 68.8 v 4.4 H 65.6 v -4.4 z m 58.1,-31.3 h 5.3 v 29.9 h -5.3 v -29.9 z m -10.6,0 h 5.1 v 29.9 h -5.1 v -29.9 z m -31.3,0 h 5.3 v 29.9 H 81.8 v -29.9 z m -10.6,0 h 5.1 v 29.9 h -5.1 v -29.9 z m 27.7,1.5 h 2 v 1.4 h 0.5 c 2.9,0 6,2.3 6,5.3 l -2.9,0.4 c -0.2,-0 -1,-1.9 -1.4,-2.4 -0.4,-0.5 -1.5,-1.1 -2.3,-1.2 v 7.8 c 3,0.3 7.3,2.3 7.3,5.3 v 1.1 c 0,4 -3.4,6.7 -7.3,6.7 v 2.5 h -2 v -2.5 c -1.7,-0 -4.1,-0.8 -5.1,-1.7 -0.8,-0.7 -2.4,-2.8 -2.4,-4.1 v -0.9 l 3.1,-0.5 c 0,2.3 2,4.9 4.4,4.9 v -8.6 c -2.3,-0 -6.9,-2.5 -6.9,-5.1 v -1.8 c 0,-3 3.2,-5.3 6.2,-5.3 h 0.7 v -1.4 z m -33.3,-7.5 h 68.8 v 4.6 H 65.6 v -4.6 z M 100,70.3 c 0.7,0.6 6.5,3.4 7.9,4.1 2.7,1.4 5.2,2.7 7.9,4.1 2.7,1.3 5.3,2.7 7.9,4.1 1.1,0.6 7.7,3.6 8.1,4 H 68.5 l 31.5,-16.1 0,0 z m -35.9,17.1 v 6 c 0,0.4 0.3,0.7 0.7,0.7 h 4.9 v 29.9 h -5.6 v 7.4 h 71.7 v -7.4 h -5.5 v -29.9 h 4.9 c 0.4,0 0.5,-0.1 0.5,-0.5 v -6.7 c -2,-0.7 -6.7,-3.4 -8.9,-4.6 -3,-1.5 -5.9,-3 -8.9,-4.6 -1.7,-0.8 -17.8,-9.1 -17.9,-9.1 -0.4,0 -16.3,8.2 -18.1,9.2 -1.9,1 -17.8,8.7 -17.8,9.6 l 0,0 0,0 z m 36.7,30.4 c 1.7,0 4,-2 4,-3.5 v -1.4 c 0,-2.1 -2.3,-2.7 -4,-3.1 v 8 z m -5.6,-14 c 0,1.6 2.2,2.6 3.6,2.7 v -7.4 c -1.3,0.3 -3.6,1.4 -3.6,2.7 v 2 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 134.4,129.8 0,-4.4 -68.8,0 0,4.4 z m -5.5,-5.8 0,-29.9 -5.3,0 0,29.9 z m -10.8,0 0,-29.9 -5.1,0 0,29.9 z m -31.1,0 0,-29.9 -5.3,0 0,29.9 z m -10.7,0 0,-29.9 -5.1,0 0,29.9 z m -7.9,-37.5 63.3,0 c -0.4,-0.3 -6.9,-3.4 -8.1,-4 -2.7,-1.3 -5.2,-2.7 -7.9,-4.1 -2.7,-1.3 -5.2,-2.7 -7.9,-4.1 -1.4,-0.7 -7.2,-3.5 -7.9,-4.1 l -31.5,16.1 0,0 z m 65.9,6.2 0,-4.6 -68.8,0 0,4.6 z m -33.5,25.1 v -8 c 1.7,0.4 4,1 4,3.1 v 1.5 c 0,1.4 -2.2,3.5 -4,3.5 z m -5.6,-14 v -2 c 0,-1.3 2.4,-2.4 3.6,-2.7 v 7.4 c -1.5,-0.1 -3.6,-1.1 -3.6,-2.7 z m 3.6,-6.7 h -0.8 c -3,0 -6.2,2.3 -6.2,5.3 v 1.8 c 0,2.5 4.6,5.1 6.9,5.1 v 8.6 c -2.4,0 -4.4,-2.5 -4.4,-4.9 l -3.1,0.5 v 0.9 c 0,1.3 1.6,3.5 2.4,4.1 1,0.8 3.3,1.6 5.1,1.7 v 2.5 h 2 v -2.5 c 3.9,0 7.3,-2.7 7.3,-6.7 v -1.1 c 0,-3 -4.3,-5 -7.3,-5.3 v -7.8 c 0.8,0.1 1.9,0.6 2.3,1.2 0.3,0.5 1.1,2.3 1.4,2.4 l 2.9,-0.4 c 0,-3 -3.1,-5.3 -6,-5.3 h -0.6 v -1.4 h -2 v 1.4 z"
            }
        ], i["GR.IN.IC.FINANCIAL EXCHANGE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 133.7,124.6 0,-1.4 -66.8,0 0.3,0 0,-47 -1,0 0,48.4 z m -29.5,-8.6 -9.8,-20.8 -5.9,14.4 -5.3,-6.5 -13.3,12.4 0.9,1 v 0.2 l 12.4,-11.3 5.5,7 h 0.3 c 0,-1 2.3,-5.6 2.8,-7 0.3,-1 1.1,-2.4 1.5,-3.4 0.3,-0.8 0.9,-3.1 1.5,-3.2 l 9.4,20.3 0.1,0.2 17.4,-27.4 0.2,0.1 8,15.6 1.4,-0.5 -9.4,-18 c -0.1,0.5 -7.7,12.1 -8.7,13.6 -1,1.6 -8.2,13.2 -8.9,13.4 z m 2.8,-19.4 V 89.2 c 2.1,0 4.1,1.4 4.1,3.6 v 0.2 c 0,2.1 -1.9,3.6 -4.1,3.6 z m -4.7,-13.6 c 0,-2 1,-3.4 3,-3.4 h 0.5 v 6.6 c -1.8,-0.1 -3.4,-1.3 -3.4,-3.2 z m 3.5,-5.6 h -1 c -2.6,0 -5.2,2.9 -5.2,5.6 v 1 c 0,1.1 1.3,2.8 2.1,3.4 1.1,0.8 2.5,1.2 4,1.5 v 7.8 c -2.6,-0.6 -4.1,-1.7 -4.1,-4.8 h -2.4 l 0.2,2.5 c 0.9,1.4 0.6,2.1 2.2,3.2 1.1,0.7 2.4,1.2 4.1,1.2 v 2.8 h 1.2 v -2.8 c 3,0 6.4,-2.3 6.4,-5 v -2.5 c 0,-2.9 -4,-4.3 -6.4,-4.8 v -6.9 c 2,0 3.4,1.4 3.4,3.3 h 2.7 c 0,-3.2 -2.8,-5.5 -6.1,-5.5 V 75.4 h -1.2 v 1.9 z"
            }
        ], i["GR.IN.IC.FINANCIAL SERVICES, OTHER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 103.4,138.2 -2.7,0 -0,-8.2 c -1.9,-0 -3.8,-0.3 -5.7,-0.7 -1.9,-0.4 -3.8,-1 -5.8,-1.9 l 0,-4.9 c 1.9,1.2 3.7,2.1 5.6,2.7 1.9,0.6 3.9,0.9 5.9,0.9 l 0,-12.5 c -4,-0.7 -7,-1.8 -8.8,-3.3 -1.8,-1.6 -2.7,-3.7 -2.7,-6.5 -5e-6,-3 1,-5.3 3,-7 2,-1.7 4.8,-2.7 8.6,-3 l 0,-6.4 2.7,0 0,6.3 c 1.7,0.1 3.3,0.3 4.9,0.5 1.6,0.3 3.1,0.7 4.6,1.1 l 0,4.8 c -1.5,-0.8 -3.1,-1.4 -4.7,-1.8 -1.6,-0.4 -3.2,-0.7 -4.9,-0.7 l 0,11.7 c 4.1,0.6 7.2,1.8 9.1,3.4 2,1.6 2.9,3.9 2.9,6.7 -3e-5,3.1 -1,5.5 -3.1,7.3 -2.1,1.8 -5,2.8 -8.9,3.1 l 0,8.3 m -2.7,-29.3 0,-11.2 c -2.1,0.2 -3.7,0.8 -4.8,1.8 -1.1,1 -1.7,2.3 -1.7,3.9 -1e-5,1.6 0.5,2.8 1.5,3.7 1,0.9 2.7,1.5 5,1.9 m 2.7,5.3 0,11.8 c 2.3,-0.3 4.1,-1 5.2,-2 1.2,-1 1.8,-2.3 1.8,-4 -3e-5,-1.6 -0.6,-2.9 -1.7,-3.8 -1.1,-0.9 -2.9,-1.6 -5.3,-2.1 m 5.8,-52.2 2.1,0 0,6.2 7.5,0 0,-6.2 2.1,0 0,15.2 -2.1,0 0,-7.2 -7.5,0 0,7.2 -2.1,0 0,-15.2 m -14.8,0 12.8,0 0,1.7 -5.4,0 0,13.4 -2.1,0 0,-13.4 -5.4,0 0,-1.7 m -8.1,1.4 c -1.5,1.3e-5 -2.7,0.6 -3.6,1.7 -0.9,1.1 -1.3,2.6 -1.3,4.5 -3e-6,1.9 0.4,3.4 1.3,4.5 0.9,1.1 2.1,1.7 3.6,1.7 1.5,1e-6 2.7,-0.6 3.5,-1.7 0.9,-1.1 1.3,-2.6 1.3,-4.5 -1.3e-5,-1.9 -0.4,-3.4 -1.3,-4.5 -0.9,-1.1 -2,-1.7 -3.5,-1.7 m 0,-1.7 c 2.1,1.5e-5 3.8,0.7 5.1,2.1 1.3,1.4 1.9,3.3 1.9,5.7 -1.5e-5,2.4 -0.6,4.3 -1.9,5.7 -1.3,1.4 -3,2.1 -5.1,2.1 -2.1,-10e-7 -3.8,-0.7 -5.1,-2.1 -1.3,-1.4 -1.9,-3.3 -1.9,-5.7 -1e-6,-2.4 0.6,-4.3 1.9,-5.7 1.3,-1.4 3,-2.1 5.1,-2.1"
            }
        ], i["GR.IN.IC.COMMERCIAL INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 101.9,123.3 -1.7,0 -0,-5 c -1.2,-0 -2.3,-0.2 -3.5,-0.4 -1.2,-0.3 -2.3,-0.6 -3.5,-1.1 l 0,-3 c 1.1,0.7 2.3,1.2 3.4,1.6 1.2,0.4 2.4,0.5 3.6,0.5 l 0,-7.6 c -2.4,-0.4 -4.2,-1.1 -5.3,-2 -1.1,-1 -1.7,-2.3 -1.7,-3.9 -2e-6,-1.8 0.6,-3.2 1.8,-4.3 1.2,-1 2.9,-1.6 5.2,-1.8 l 0,-3.9 1.7,0 0,3.9 c 1,0 2,0.2 3,0.3 1,0.2 1.9,0.4 2.8,0.7 l 0,2.9 c -0.9,-0.5 -1.9,-0.8 -2.8,-1.1 -1,-0.3 -2,-0.4 -3,-0.4 l 0,7.1 c 2.5,0.4 4.4,1.1 5.5,2.1 1.2,1 1.8,2.4 1.8,4.1 -2e-5,1.9 -0.6,3.3 -1.9,4.4 -1.3,1.1 -3.1,1.7 -5.4,1.9 l 0,5 m -1.7,-17.8 0,-6.8 c -1.3,0.1 -2.3,0.5 -2.9,1.1 -0.7,0.6 -1,1.4 -1,2.3 -6e-6,1 0.3,1.7 0.9,2.2 0.6,0.5 1.6,0.9 3,1.1 m 1.7,3.2 0,7.2 c 1.4,-0.2 2.5,-0.6 3.2,-1.2 0.7,-0.6 1.1,-1.4 1.1,-2.4 -1e-5,-1 -0.3,-1.7 -1,-2.3 -0.7,-0.6 -1.7,-1 -3.2,-1.3 M 104.5,74.8 h 4.5 v 13.4 h 9.9 V 74.8 h 4.5 v 13.4 h 6.7 v 37 H 70 V 88.2 h 34.6 l 4e-4,-13.4 0,0 z m -35.7,51.6 h 62.3 V 86.9 h -6.4 V 73.5 h -7.2 v 13.4 h -7.2 V 73.5 h -7.2 V 86.9 H 68.8 v 39.5 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 101.9,108.7 0,7.2 c 1.4,-0.2 2.5,-0.6 3.2,-1.2 0.7,-0.6 1.1,-1.4 1.1,-2.4 -1e-5,-1 -0.3,-1.7 -1,-2.3 -0.7,-0.6 -1.7,-1 -3.2,-1.3 m -1.7,-3.2 0,-6.8 c -1.3,0.1 -2.3,0.5 -2.9,1.1 -0.7,0.6 -1,1.4 -1,2.3 -6e-6,1 0.3,1.7 0.9,2.2 0.6,0.5 1.6,0.9 3,1.1 m 4.3,-30.7 0,13.4 -34.6,0 0,37 60.1,0 0,-37 -6.7,0 0,-13.4 -4.5,0 0,13.4 -9.9,0 0,-13.4 -4.5,0 z m -4.3,17.6 1.7,0 0,3.8 c 1,0 2,0.2 3,0.3 1,0.2 1.9,0.4 2.8,0.7 l 0,2.9 c -0.9,-0.5 -1.9,-0.8 -2.8,-1.1 -1,-0.3 -2,-0.4 -3,-0.5 l 0,7.1 c 2.5,0.4 4.3,1.1 5.5,2.1 1.2,1 1.8,2.4 1.8,4.1 -2e-5,1.9 -0.6,3.4 -1.9,4.4 -1.3,1.1 -3.1,1.7 -5.4,1.9 l 0,5 -1.7,0 -0,-5 c -1.2,-0 -2.3,-0.2 -3.5,-0.4 -1.2,-0.3 -2.3,-0.6 -3.5,-1.1 l 0,-3 c 1.1,0.7 2.3,1.3 3.4,1.6 1.2,0.4 2.4,0.5 3.6,0.5 l 0,-7.6 c -2.4,-0.4 -4.2,-1.1 -5.3,-2 -1.1,-1 -1.7,-2.2 -1.7,-3.9 -2e-6,-1.8 0.6,-3.2 1.8,-4.3 1.2,-1 3,-1.6 5.2,-1.8 l 0,-3.9 z"
            }
        ], i["GR.IN.IC.CHEMICAL PLANT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 94.4,89.6 0,0.1 c -0.5,0.1 -1,0.3 -1.4,0.6 -0.5,0.5 -0.6,1.3 -0.5,1.9 0.2,0.8 0.8,1.5 1.7,1.8 -0,0.5 -0.1,1.7 0,3 l -0.1,0 c -0,2.7 -2.3,5.7 -4.9,8.8 -2.4,3 -5,6.4 -5.3,10.4 l -0.1,0 c 0,0.1 0,0.2 0,0.2 -0,0.1 -0,0.2 -0,0.3 l 0.1,0 c 0.2,2.4 1.7,4.2 3.7,5.3 2.1,1.2 4.6,1.7 6.8,1.6 l 0,-0 8.9,0 0,0.1 c 0.3,-0 0.5,-0 0.8,-0.1 l 0.5,0 0,-0.1 c 2.1,-0.2 4.2,-0.3 6,-1 1.1,-0.4 2.1,-1.1 2.8,-2.1 0.6,-0.9 0.9,-2.1 1.1,-3.6 l 0.2,0 c 0.2,-4.4 -2.1,-7.5 -4.5,-10.3 -2.3,-2.8 -4.7,-5.5 -5.4,-9.6 0,-1.3 0.1,-3 0.1,-3.3 0.2,-0.1 0.4,-0.2 0.6,-0.3 0.5,-0.4 0.9,-1 0.9,-1.7 -0,-0.7 -0.5,-1.3 -1.1,-1.6 -0.4,-0.2 -0.9,-0.3 -1.5,-0.4 l 0,-0.1 c -0.2,0 -0.4,-0 -0.6,0 -2.5,0 -7.2,0 -8.1,0 -0.1,-2.4e-4 -0.7,0 -0.7,0 z m 0.7,2 c 0.8,0 5.5,0 8.1,0 0.6,0 0.9,0.1 1.1,0.2 -0.2,0.1 -0.5,0.3 -0.9,0.4 l -8.1,0 c -0.4,-0.1 -0.7,-0.3 -0.7,-0.4 -0,-0.1 -0,-0.1 -0,-0.1 0,-0 0.1,-0.1 0.6,-0.1 z m 1.2,2.6 6.7,0 c -0,0.7 -0.1,1.9 -0.1,3.1 -0,0.1 -0,0.2 -0,0.3 l 0.1,0 c 0.9,4.5 3.5,7.6 5.8,10.3 2.2,2.7 4,5 4,8.4 l -0.1,0 c -0,1.4 -0.4,2.4 -0.8,3 -0.4,0.7 -1,1.1 -1.8,1.4 -1.4,0.6 -3.6,0.7 -5.8,0.9 l -10.3,0 0,0 c -1.6,0 -3.6,-0.4 -5.1,-1.3 -1.6,-0.9 -2.6,-2.2 -2.7,-3.9 0.1,-3.2 2.4,-6.3 4.9,-9.4 2.4,-3 5.1,-6.1 5.3,-9.6 l 0.1,-0 c -0.1,-1 -0.1,-2.7 -0,-3.3 z m -7,19.6 v 1.9 c 0,3.5 6,4.3 9.9,4.3 h 3.2 c 2.5,0 8,-2.2 8,-4.2 v -0.8 c 0,-3.2 -6.6,-9.4 -7.3,-12.4 h -7.5 c -0.6,2.5 -6.2,10 -6.2,11.2 z m 14.8,-39 h 4.5 v 13.4 h 9.9 V 74.8 h 4.5 v 13.4 h 6.7 v 37 H 69.6 V 88.2 h 34.6 l 4e-4,-13.4 0,0 z m -35.7,51.6 h 62.3 V 86.9 h -6.4 V 73.5 h -7.2 v 13.4 h -7.2 V 73.5 h -7.2 v 13.4 h -34.4 v 39.5 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 104.1 74.8 L 104.1 88.2 L 69.6 88.2 L 69.6 125.2 L 129.6 125.2 L 129.6 88.2 L 122.9 88.2 L 122.9 74.8 L 118.5 74.8 L 118.5 88.2 L 108.6 88.2 L 108.6 74.8 L 104.1 74.8 z M 94.4 89.6 C 94.4 89.6 95.1 89.6 95.2 89.6 C 96.1 89.6 100.8 89.6 103.3 89.6 C 103.5 89.6 103.8 89.6 103.9 89.6 L 103.9 89.7 C 104.5 89.8 105 89.9 105.4 90.1 C 106 90.4 106.5 91 106.5 91.7 C 106.5 92.4 106.1 93 105.6 93.4 C 105.4 93.5 105.2 93.6 105 93.8 C 105 94 104.9 95.7 104.9 97.1 C 105.6 101.1 108 103.8 110.3 106.7 C 112.6 109.5 114.9 112.6 114.7 117 L 114.6 116.9 C 114.4 118.4 114.1 119.6 113.5 120.5 C 112.8 121.5 111.8 122.2 110.8 122.7 C 108.9 123.4 106.8 123.5 104.8 123.7 L 104.8 123.7 L 104.3 123.7 C 104.1 123.7 103.8 123.8 103.5 123.8 L 103.5 123.7 L 94.6 123.7 L 94.6 123.8 C 92.4 123.9 89.9 123.4 87.8 122.2 C 85.9 121.1 84.3 119.2 84.1 116.8 L 84.1 116.8 C 84.1 116.7 84.1 116.6 84.1 116.5 C 84.1 116.4 84 116.4 84 116.3 L 84.1 116.3 C 84.3 112.3 86.9 109 89.4 105.9 C 91.9 102.7 94.2 99.8 94.3 97.1 L 94.3 97.1 C 94.2 95.7 94.3 94.6 94.3 94 C 93.5 93.7 92.8 93.1 92.6 92.3 C 92.4 91.6 92.6 90.9 93.1 90.4 C 93.4 90 93.9 89.8 94.4 89.7 L 94.4 89.6 z M 95.1 91.6 C 94.7 91.6 94.5 91.7 94.5 91.8 C 94.5 91.8 94.5 91.7 94.6 91.8 C 94.6 91.9 94.8 92.2 95.3 92.2 L 103.4 92.2 C 103.8 92.1 104.1 92 104.3 91.8 C 104.1 91.8 103.8 91.6 103.2 91.6 C 100.6 91.6 95.9 91.6 95.1 91.6 z M 96.3 94.2 C 96.2 94.9 96.2 96.5 96.3 97.5 L 96.2 97.6 C 96 101.1 93.4 104.2 90.9 107.2 C 88.5 110.3 86.2 113.3 86.1 116.6 C 86.2 118.3 87.2 119.5 88.8 120.5 C 90.3 121.3 92.3 121.8 93.9 121.8 L 93.9 121.7 L 104.2 121.7 C 106.5 121.5 108.6 121.4 110 120.8 C 110.8 120.5 111.4 120.1 111.8 119.4 C 112.3 118.8 112.6 117.8 112.7 116.4 L 112.7 116.4 C 112.7 113 110.9 110.6 108.7 107.9 C 106.5 105.2 103.8 102.1 103 97.6 L 102.8 97.6 C 102.8 97.5 102.9 97.4 102.9 97.3 C 102.9 96.1 102.9 94.9 103 94.2 L 96.3 94.2 z M 95.5 102.6 L 103 102.6 C 103.8 105.7 110.3 111.9 110.3 115.1 L 110.3 115.9 C 110.3 117.9 104.9 120 102.4 120 L 99.2 120 C 95.3 120 89.3 119.2 89.3 115.7 L 89.3 113.8 C 89.3 112.6 94.9 105.1 95.5 102.6 z "
            }
        ], i["GR.IN.IC.FIREARMS MANUFACTURER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 104.1,74.8 h 4.5 v 13.4 h 9.9 V 74.8 h 4.5 v 13.4 h 6.7 v 37 H 69.6 V 88.2 h 34.6 l 4e-4,-13.4 0,0 z m -35.7,51.6 h 62.3 V 86.9 h -6.4 V 73.5 h -7.2 v 13.4 h -7.2 V 73.5 h -7.2 v 13.4 h -34.4 v 39.5 z m 25.8,-26.6 h 10.8 v 5.8 c -1.6,0 -4.7,1 -5.8,0.7 -1.2,-0.4 -3.8,-1.5 -5,-1.6 v -4.8 z m -19.2,0 h 16.6 v 6 c 0,0.6 3,1.4 3.7,1.7 0.4,0.1 3.9,1.4 3.9,1.5 l 7.2,-0.9 0.8,2.7 1.1,3.7 c 0.3,0.4 1,2.4 1,3.1 v 0.2 c 0,1.1 -0.6,1.9 -0.6,3.5 l 13.5,-0 -0.9,-3 -0.6,-1.7 -3,-10 c -0.2,-0.4 -0.5,-0.7 -0.5,-1.3 0,-1.3 3.9,-4.1 4.7,-5.3 l -2.7,-8.4 h -43.9 v 8.4 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 94.2,99.9 h 10.8 v 5.8 c -1.6,0 -4.7,1 -5.8,0.7 -1.2,-0.4 -3.8,-1.5 -5,-1.6 v -4.8 z m 9.9,-25.1 0,13.4 -34.6,0 0,37 60.1,0 0,-37 -6.7,0 0,-13.4 -4.5,0 0,13.4 -9.9,0 0,-13.4 -4.5,0 z m -29.1,16.7 43.9,0 2.7,8.4 c -0.8,1.2 -4.7,4.1 -4.7,5.3 0,0.6 0.2,0.9 0.5,1.3 l 3.1,10 0.6,1.8 0.9,3 -13.5,0 c 0,-1.6 0.7,-2.4 0.7,-3.6 l 0,-0.2 c 0,-0.7 -0.7,-2.7 -1,-3.1 L 107.2,110.8 106.4,108.1 99.2,109 c -0,-0.1 -3.6,-1.4 -3.9,-1.5 -0.7,-0.3 -3.7,-1.1 -3.7,-1.7 l 0,-5.9 -16.6,0 0,-8.4 z"
            }
        ], i["GR.IN.IC.FIREARMS RETAILER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 85.1,123 -1.1,0 -0,-3.2 c -0.8,-0 -1.5,-0.1 -2.3,-0.3 -0.8,-0.2 -1.5,-0.4 -2.3,-0.7 l 0,-1.9 c 0.7,0.5 1.5,0.8 2.2,1 0.8,0.2 1.5,0.3 2.3,0.4 l 0,-4.9 c -1.6,-0.3 -2.7,-0.7 -3.5,-1.3 -0.7,-0.6 -1.1,-1.5 -1.1,-2.5 -2e-6,-1.2 0.4,-2.1 1.2,-2.8 0.8,-0.7 1.9,-1.1 3.4,-1.2 l 0,-2.5 1.1,0 0,2.5 c 0.7,0 1.3,0.1 1.9,0.2 0.6,0.1 1.2,0.3 1.8,0.5 l 0,1.9 c -0.6,-0.3 -1.2,-0.5 -1.8,-0.7 -0.6,-0.2 -1.3,-0.3 -1.9,-0.3 l 0,4.6 c 1.6,0.3 2.8,0.7 3.6,1.3 0.8,0.6 1.1,1.5 1.1,2.6 -1.2e-5,1.2 -0.4,2.2 -1.2,2.9 -0.8,0.7 -2,1.1 -3.5,1.2 l 0,3.3 m -1.1,-11.5 0,-4.4 c -0.8,0.1 -1.5,0.3 -1.9,0.7 -0.4,0.4 -0.7,0.9 -0.7,1.5 -4e-6,0.6 0.2,1.1 0.6,1.4 0.4,0.3 1.1,0.6 2,0.7 m 1.1,2.1 0,4.7 c 0.9,-0.1 1.6,-0.4 2.1,-0.8 0.5,-0.4 0.7,-0.9 0.7,-1.6 -1e-5,-0.6 -0.2,-1.1 -0.7,-1.5 -0.4,-0.4 -1.1,-0.6 -2.1,-0.8 m 22.6,-21.9 -8,20.8 0.8,0.3 8,-20.8 -0.8,-0.3 z m -43,6.5 0,0.8 0.3,26 0,0.8 0.8,0 32.2,-0.2 0.4,0 0.2,-0.3 7.3,-8.7 0.2,-0.2 -0,-0.3 -0.2,-10.1 0,-0.4 -0.3,-0.2 -8.4,-6.6 -0.2,-0.2 -0.3,0 -31.3,-0.4 -0.8,0 z m 1.6,1.6 30.2,0.3 7.9,6.2 0.2,9.4 -6.9,8.2 -31,0.2 -0.3,-24.3 z M 97.3,85.4 h 14.4 v 7.7 c -2.1,0 -6.2,1.4 -7.8,0.9 -1.6,-0.5 -5,-2.1 -6.6,-2.2 v -6.4 z m -25.5,0 h 22.1 v 7.9 c 0,0.8 4,1.9 4.8,2.2 0.5,0.2 5.2,1.9 5.2,2 l 9.6,-1.2 1,3.6 1.4,4.9 c 0.3,0.5 1.3,3.2 1.3,4.1 v 0.2 c 0,1.5 -0.9,2.5 -0.9,4.7 h 18 l -1.1,-3.9 -0.8,-2.4 -4,-13.4 c -0.3,-0.5 -0.6,-0.9 -0.6,-1.7 0,-1.7 5.2,-5.5 6.2,-7.1 l -3.6,-11.1 H 71.8 v 11.1 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 85.1,113.6 0,4.7 c 0.9,-0.1 1.6,-0.4 2.1,-0.8 0.5,-0.4 0.7,-0.9 0.7,-1.6 -1e-5,-0.6 -0.2,-1.1 -0.7,-1.5 -0.4,-0.4 -1.1,-0.6 -2.1,-0.8 m -1.1,-2.1 0,-4.4 c -0.8,0.1 -1.5,0.3 -1.9,0.7 -0.4,0.4 -0.7,0.9 -0.7,1.5 -4e-6,0.6 0.2,1.1 0.6,1.4 0.4,0.3 1.1,0.6 2,0.7 M 66.4,99.8 l 0.3,24.3 31,-0.2 6.9,-8.2 -0.2,-9.4 -7.9,-6.2 -30.2,-0.3 z m 17.7,3.3 1.1,0 0,2.5 c 0.7,0 1.3,0.1 1.9,0.2 0.6,0.1 1.2,0.2 1.8,0.4 l 0,1.9 c -0.6,-0.3 -1.2,-0.5 -1.8,-0.7 -0.6,-0.2 -1.3,-0.3 -1.9,-0.3 l 0,4.6 c 1.6,0.3 2.8,0.7 3.6,1.3 0.8,0.6 1.2,1.5 1.2,2.7 -1.2e-5,1.2 -0.4,2.2 -1.2,2.9 -0.8,0.7 -2,1.1 -3.5,1.2 l 0,3.3 -1.1,0 0,-3.2 c -0.8,-0 -1.5,-0.1 -2.3,-0.3 -0.8,-0.2 -1.5,-0.4 -2.3,-0.8 l 0,-1.9 c 0.7,0.5 1.5,0.8 2.2,1.1 0.8,0.2 1.5,0.3 2.3,0.3 l 0,-4.9 c -1.6,-0.3 -2.7,-0.7 -3.5,-1.3 -0.7,-0.6 -1.1,-1.5 -1.1,-2.5 -2e-6,-1.2 0.4,-2.1 1.2,-2.8 0.8,-0.7 1.9,-1.1 3.4,-1.2 l 0,-2.5 z"
            }
        ], i["GR.IN.IC.HAZARDOUS MATERIAL PRODUCTION"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 104.7,71.8 h 5 v 15 h 11.1 v -15 h 5 v 15 h 7.5 v 41.4 h -67.4 V 86.8 h 38.8 v -15 z m -40,57.9 h 69.8 V 85.5 h -7.1 v -15.2 h -8 v 15.2 h -8 v -15.2 h -8 v 15.2 h -38.6 v 44.1 l 0,0 z m 15.5,-21.8 h 38.6 l -19.3,18.6 -19.3,-18.6 z m 21.8,-16.8 c 0.5,0.4 4.3,3.8 4.3,4.3 v 12 h -4.3 V 91.1 z m -5,-0 0,16.3 h -4.3 l 0.1,-12.2 4.1,-4.1 0,0 z m -12.1,12 c 0,-0.4 3.1,-3.2 3.6,-3.6 v 7.8 h -3.6 v -4.3 z m 25.7,-3.6 3.7,3.4 c -0.2,0.4 -0.2,-0.2 -0.2,0.5 v 4 h -3.6 v -7.9 z m 9.4,8.2 -20.5,-20 -20.4,20 20.4,19.9 20.5,-19.9 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 99.5,126.5 19.3,-18.6 -38.6,0 z m 0,1 -20.4,-19.9 20.4,-20 20.5,20 -20.5,19.8 z m 5.2,-40.8 h -38.8 v 41.4 h 67.4 V 86.8 h -7.5 v -15 h -5 v 15 h -11.1 v -15 h -5 v 15 z m 5.9,20.6 h 3.6 v -4 c 0,-0.7 -0,-0.1 0.2,-0.5 l -3.7,-3.4 v 7.9 z m -8.6,0 h 4.3 v -12 c 0,-0.4 -3.8,-3.9 -4.3,-4.3 v 16.3 z m -9.3,0 4.3,0 -0,-16.3 -4.1,4.1 z m -7.8,-4.3 v 4.3 h 3.6 v -7.9 c -0.5,0.3 -3.6,3.2 -3.6,3.6 z"
            }
        ], i["GR.IN.IC.HAZARDOUS MATERIAL STORAGE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 122.4,68.8 c 0.4,0.1 0.9,0.5 1.3,1 0.4,0.5 0.8,1.2 1.3,2 l 2.1,4.1 -2.2,0 -1.9,-3.9 c -0.5,-1 -1,-1.7 -1.5,-2 -0.5,-0.3 -1.1,-0.5 -1.9,-0.5 l -2.2,0 0,6.4 -2.1,0 0,-15.2 4.6,0 c 1.7,1.5e-5 3,0.4 3.9,1.1 0.9,0.7 1.3,1.8 1.3,3.3 -10e-6,1 -0.2,1.7 -0.7,2.4 -0.4,0.6 -1.1,1.1 -1.9,1.3 m -5.1,-6.4 0,5.4 2.6,0 c 1,8e-6 1.7,-0.2 2.2,-0.7 0.5,-0.5 0.8,-1.1 0.8,-2 -10e-6,-0.9 -0.3,-1.6 -0.8,-2 -0.5,-0.5 -1.2,-0.7 -2.2,-0.7 l -2.6,0 m -12.3,-0.3 c -1.5,1.4e-5 -2.7,0.6 -3.6,1.7 -0.9,1.1 -1.3,2.6 -1.3,4.5 -1e-5,1.9 0.4,3.4 1.3,4.5 0.9,1.1 2.1,1.7 3.6,1.7 1.5,1e-6 2.7,-0.6 3.5,-1.7 0.9,-1.1 1.3,-2.6 1.3,-4.5 -10e-6,-1.9 -0.4,-3.4 -1.3,-4.5 -0.9,-1.1 -2,-1.7 -3.5,-1.7 m 0,-1.7 c 2.1,1.5e-5 3.8,0.7 5.1,2.1 1.3,1.4 1.9,3.3 1.9,5.7 -10e-6,2.4 -0.6,4.3 -1.9,5.7 -1.3,1.4 -3,2.1 -5.1,2.1 -2.1,-10e-7 -3.8,-0.7 -5.1,-2.1 -1.3,-1.4 -1.9,-3.3 -1.9,-5.7 -2e-6,-2.4 0.6,-4.3 1.9,-5.7 1.3,-1.4 3,-2.1 5.1,-2.1 m -21,0.3 12.8,0 0,1.7 -5.4,0 0,13.4 -2.1,0 0,-13.4 -5.4,0 0,-1.7 m -2,0.5 0,2 c -0.8,-0.4 -1.5,-0.6 -2.2,-0.8 -0.7,-0.2 -1.4,-0.3 -2,-0.3 -1.1,1.4e-5 -2,0.2 -2.6,0.7 -0.6,0.4 -0.9,1 -0.9,1.8 -3e-6,0.7 0.2,1.2 0.6,1.5 0.4,0.3 1.2,0.6 2.3,0.8 l 1.2,0.3 c 1.5,0.3 2.7,0.8 3.4,1.5 0.7,0.7 1.1,1.7 1.1,2.9 -1.2e-5,1.5 -0.5,2.6 -1.5,3.3 -1,0.8 -2.4,1.1 -4.3,1.1 -0.7,-10e-7 -1.5,-0.1 -2.3,-0.2 -0.8,-0.2 -1.6,-0.4 -2.5,-0.7 l 0,-2.1 c 0.8,0.5 1.6,0.8 2.4,1.1 0.8,0.2 1.6,0.4 2.4,0.4 1.2,1e-6 2.1,-0.2 2.7,-0.7 0.6,-0.5 1,-1.1 1,-2 -1e-5,-0.7 -0.2,-1.3 -0.7,-1.7 -0.5,-0.4 -1.2,-0.7 -2.2,-0.9 l -1.2,-0.2 c -1.5,-0.3 -2.6,-0.8 -3.3,-1.4 -0.7,-0.6 -1,-1.6 -1,-2.7 -2e-6,-1.3 0.5,-2.4 1.4,-3.2 0.9,-0.8 2.3,-1.2 3.9,-1.2 0.7,1.5e-5 1.4,0.1 2.2,0.2 0.7,0.1 1.5,0.3 2.3,0.6 M 70.6,110 h 57.9 l -29,27.9 -28.9,-27.9 z m 32.8,-25.2 c 0.8,0.5 6.4,5.8 6.4,6.4 v 17.9 h -6.4 V 84.8 z m -7.6,-0.1 0.1,24.4 h -6.5 l 0.2,-18.3 6.2,-6.1 0,0 z m -18.2,18 c 0,-0.7 4.7,-4.9 5.3,-5.3 v 11.8 h -5.3 v -6.5 z m 38.6,-5.3 5.6,5.2 c -0.3,0.7 -0.2,-0.3 -0.2,0.7 v 5.9 h -5.3 V 97.4 z m 14.2,12.3 -30.7,-30.1 -30.7,30 30.7,29.9 30.8,-29.8 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 99.5,137.9 29,-27.9 -57.9,0 z m 16.7,-28.7 h 5.3 v -5.9 c 0,-1 -0.1,-0.1 0.2,-0.7 l -5.6,-5.2 v 11.8 z m -12.8,0 h 6.4 V 91.2 c 0,-0.7 -5.6,-5.9 -6.4,-6.4 v 24.4 z m -14,-10e-6 6.5,0 -0.1,-24.4 -6.2,6.1 z m -11.8,-6.4 v 6.4 h 5.3 V 97.4 c -0.7,0.5 -5.3,4.7 -5.3,5.3 z"
            }
        ], i["GR.IN.IC.INDUSTRIAL SITE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 104.1,74.8 h 4.5 v 13.4 h 9.9 V 74.8 h 4.5 v 13.4 h 6.7 v 37 H 69.6 V 88.2 h 34.6 l 4e-4,-13.4 0,0 z m -35.7,51.6 h 62.3 V 86.9 h -6.4 V 73.5 h -7.2 v 13.4 h -7.2 V 73.5 h -7.2 v 13.4 h -34.4 v 39.5 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 104.1,74.8 h 4.5 v 13.4 h 9.9 V 74.8 h 4.5 v 13.4 h 6.7 v 37 H 69.6 V 88.2 h 34.6 l 4e-4,-13.4 0,0 z"
            }
        ], i["GR.IN.IC.LANDFILL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 124.1,115.8 c 0,2.5 1.6,2.7 3,3.6 h -22.8 c 1.2,-0.7 2.8,-1.2 2.8,-3.3 v -1.2 c 0,-1.3 -1.9,-2.8 -3.6,-2.8 -1,0 -1.8,0.4 -2.3,0.9 -0.4,0.4 -1.1,1.6 -1.1,2.1 v 1.3 c 0,0.2 0.9,1.7 1,1.9 0.6,0.7 1.2,0.6 1.8,1 h -8.6 c 0.6,-0.4 1.3,-0.5 1.8,-1.1 0.4,-0.4 0.6,-1.4 1,-1.6 v -1.7 c 0,-0.4 -0.9,-1.8 -1.2,-2.1 -0.6,-0.6 -1.3,-0.9 -2.4,-0.9 h -0.1 c -1.7,0 -3.5,1.5 -3.5,3.1 v 1.3 c 0,1.5 2,2.2 2.8,2.8 h -8.7 c -0.1,-3.2 -2.5,-1.8 -3.1,-3 -1.1,-1.9 0.9,-2.2 -2.8,-3.1 -3.1,-0.8 -2,-0.3 -3.9,-2.2 -0.6,-0.7 -3,-1.8 -4.2,-1.8 h -0.1 c -1,0 -1.9,1.2 -2.7,1.5 -1.1,0.5 -2.3,0.4 -3.2,1.1 -1.1,0.8 -2.3,4.4 -2.3,6.2 v 0.6 h -0.4 v 2.2 h 72.1 4.9 v -1.5 h -9.5 c 0.8,-0.5 0.9,-0.2 1.8,-1 0.4,-0.4 0.9,-1.5 1.2,-1.6 v -1.6 c 0,-0.5 -0.9,-1.9 -1.3,-2.2 -0.7,-0.5 -1.4,-0.8 -2.5,-0.8 -1.9,0 -3.6,1.5 -3.6,3.5 v 0.2 h 0 z m -1,-17.6 h 3.5 c 0.5,0 4.2,4.8 4.6,5.4 h -8.1 v -5.4 z m -4.1,-17.8 -0.7,-1.3 -7,3.9 1.4,3.5 -32,14.5 c 0.8,0.4 2.1,4.3 2.6,5.3 0.2,0.4 2.3,5 2.3,5.1 0,0.5 -0.9,0.2 -0.8,0.6 l 0.5,3.1 h 3.4 c 0,-2.4 2,-4.8 4.3,-4.8 h 1 c 2.4,0 4.3,2.3 4.3,4.8 h 0.6 c 0,-2.4 0.6,-2.3 1.5,-3.6 l -2.1,-5.6 9.5,-4.3 4.2,9.9 -5.1,0 c 0.9,1.3 1.6,1.3 1.6,3.6 h 14.4 v -0.5 c 0,-2.1 2.5,-4.3 4.8,-4.3 h 0.5 c 2.6,0 4.6,2.2 4.6,4.8 h 2.6 v -3.1 h -1.2 v -7.4 c 0,-1.2 -5.8,-6.8 -6.1,-8.1 h -6.4 v 15 h -4.1 l -5.3,-12.1 5.5,-2.3 -4.3,-9.5 5.6,-7.4 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 123.1,103.6 h 8.1 c -0.5,-0.6 -4.2,-5.4 -4.6,-5.4 h -3.5 v 5.4 z"
            }
        ], i["GR.IN.IC.PHARMACEUTICAL MANUFACTURER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 105.2,71.3 h 5.1 V 86.5 H 121.5 V 71.3 h 5.1 v 15.2 h 7.6 v 42.1 H 65.8 V 86.6 h 39.4 V 71.3 z M 64.5,130.1 h 71 V 85.3 h -7.3 V 69.9 h -8.2 V 85.3 h -8.2 V 69.9 H 103.7 V 85.3 H 64.5 v 44.8 z M 90.3,93.1 h 7.6 c 1.2,0 3.4,1.8 3.4,2.7 v 2.6 c 0,1.3 -2.4,2.9 -3.6,2.9 h -7.4 v -8.2 z m -4.9,26.5 h 4.9 v -13.1 l 1.7,0.1 7.6,10 -8.8,11 5.9,0.1 5.9,-7 c 1.2,0.3 4.2,5.9 5.6,6.9 h 6.2 c -0.9,-1.7 -8.4,-10.4 -8.4,-11 0,-0.3 7.4,-9.7 8.2,-10.4 l -6,-0.1 -5.6,6.2 -4.3,-5.7 c 5.2,-1.2 8.4,-3.3 8.4,-9.8 v -0.6 c 0,-2 -1.7,-4.7 -2.8,-5.8 -1,-1 -4.1,-2.4 -6.2,-2.4 H 85.4 v 31.6 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 85.4,88 h 12.4 c 2.1,0 5.1,1.4 6.1,2.4 1.1,1.1 2.8,3.8 2.8,5.8 v 0.6 c 0,6.5 -3.1,8.6 -8.4,9.8 l 4.3,5.7 5.6,-6.2 6.1,0.1 c -0.8,0.6 -8.2,10 -8.2,10.4 0,0.7 7.4,9.4 8.4,11.1 h -6.2 c -1.5,-1 -4.4,-6.6 -5.6,-6.9 l -5.9,6.9 -5.9,-0.1 8.8,-11 -7.6,-9.9 -1.8,-0.1 v 13.1 h -4.9 v -31.6 z m 19.8,-1.4 h -39.4 v 42.1 h 68.4 V 86.6 h -7.6 V 71.3 H 121.5 V 86.5 H 110.3 V 71.3 h -5.1 v 15.3 z m -14.9,14.7 h 7.4 c 1.2,0 3.6,-1.6 3.6,-2.9 v -2.5 c 0,-1 -2.2,-2.7 -3.4,-2.7 h -7.6 v 8.2 z"
            }
        ], i["GR.IN.IC.CONTAMINATED HAZARDOUS WASTE SITE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 133.7,71.5 c -0.3,0 -0.7,0.1 -0.9,0.2 l -49.5,0 -0.7,0 0,0.1 c -0.7,0.3 -1.3,0.9 -1.8,1.7 -0.6,1 -1.2,2.5 -1.6,4.2 -0.9,3.5 -1.4,8.2 -1.4,13.4 0,4.8 0.5,9.2 1.2,12.6 -1,0.1 -2.1,0.5 -3,0.3 -1.2,-0.1 -2.5,-0.1 -3.8,-0.1 -1.3,0 -6.5,-0.9 -6.5,0.7 0,1.8 6,3.4 7.5,6.1 -0.8,1.5 -5.9,1.4 -8.1,1.8 -1.5,0.2 -3,0.2 -3.8,1.1 -1,1 0.2,2.3 1.1,2.7 1.7,0.9 6,1 8.2,1.5 1.3,0.3 2.6,0.7 3.1,1.9 0.4,1.1 0.6,2.6 2.2,2.6 l 0.1,0 c 2.1,0 5.1,-1.7 7.9,-1.7 l 1.1,0 c 6.2,0 6.8,7.4 12.3,7.7 3.5,0.2 5.3,-0.8 7.8,-1.9 1.6,-0.7 5.5,-2.8 7.3,-2.8 l 0.3,0 c 1.8,0 3.3,1.1 4.8,1.5 1.6,0.5 3.3,1 5.4,1 l 0.5,0 c 1.2,0 2.3,-0.2 3.2,-0.5 1.2,-0.4 1.1,-1 1.1,-2.4 -0.1,-1.9 -2.2,-3.3 -3.5,-4 -1.4,-0.9 -3.4,-1.8 -4.9,-2.6 -0.8,-0.4 -1.5,-0.9 -2.3,-1.4 -1.3,-1 -1,-0.6 -1.7,-2.1 1.2,-1.8 6.9,0.2 6.9,-1.9 0,-0.2 -0.3,-0.5 -0.7,-0.7 l 12.2,0 0.7,0 0,-0.4 c 0.7,-0.3 1.3,-0.9 1.8,-1.7 0.6,-1 1.2,-2.5 1.6,-4.2 0.9,-3.5 1.4,-8.2 1.4,-13.4 0,-5.2 -0.5,-9.9 -1.4,-13.4 -0.4,-1.7 -1,-3.2 -1.6,-4.2 -0.6,-1 -1.4,-1.8 -2.5,-1.8 z m 0.3,1.4 c 0.3,0 0.7,0.3 1.3,1.1 0.5,0.8 1,2.2 1.4,3.8 0.8,3.3 1.4,7.9 1.4,13.1 0,5.1 -0.5,9.8 -1.4,13.1 -0.4,1.7 -0.9,3 -1.4,3.8 -0.5,0.8 -1,1.1 -1.3,1.1 -0.2,0 -0.4,-0.1 -0.7,-0.4 l 0,0.7 -47.9,0 c 0.2,-0.2 0.4,-0.4 0.6,-0.8 0.6,-1 1.1,-2.3 1.5,-4 0.9,-3.4 1.4,-8.1 1.4,-13.2 0,-5.2 -0.5,-9.8 -1.4,-13.2 -0.4,-1.7 -0.9,-3.1 -1.5,-4 -0.2,-0.3 -0.4,-0.5 -0.6,-0.7 l 47.9,0 0,0.2 c 0.3,-0.3 0.5,-0.4 0.7,-0.4 z m -50.7,0.2 c 0.3,0 0.7,0.3 1.3,1.1 0.5,0.8 1,2.2 1.4,3.8 0.8,3.3 1.4,7.9 1.4,13.1 0,5.1 -0.5,9.8 -1.4,13.1 -0.4,1.7 -0.9,3 -1.4,3.8 -0.5,0.8 -1,1.1 -1.3,1.1 -0.3,0 -0.7,-0.3 -1.3,-1.1 -0.3,-0.5 -0.6,-1.1 -0.8,-1.8 0.4,1.7 1,3 1.7,3.5 l 8.3,-0.2 7.1,0.1 20.3,-0.1 c 0.5,0 1.5,0.5 2.3,1 l 0,0 c 0.5,0.3 0.8,0.6 1,0.7 -0.1,0.2 -0.4,0.3 -0.6,0.4 -0.2,0.1 -0.5,0.2 -0.8,0.2 -0.4,0.1 -0.9,0.1 -1.3,0.1 -0.2,-0 -0.5,-0 -0.7,-0 -0.4,-0 -0.9,-0 -1.2,-0 l -0.3,0 c -0.9,0 -1.7,0.5 -1.7,1.4 l 0,0.1 0,0.1 c 0,0.1 0,0.2 0,0.3 0.7,3 11.3,5.8 11.9,9.2 0,0.1 0,0.2 0,0.3 -0,0.1 -0,0.1 -0,0.1 -0.2,1.6 -2.9,2.2 -5.2,2.2 -0.7,0 -1.3,0 -1.8,-0.1 -2.6,-0.4 -5.4,-2.3 -7.3,-2.3 -5.3,0 -9.5,5.5 -15.2,4.8 -4.4,-0.6 -5.5,-7.9 -12.3,-7.9 l -1.3,0 c -3,0 -5.6,1.7 -8.4,1.7 -0.5,0 -0.7,-0.3 -0.9,-0.6 -0,-0 -0,-0.1 -0.1,-0.1 -0.2,-0.5 -0.3,-1.1 -0.6,-1.6 -0,-0 0,-0 0,-0 -0,-0.1 -0.1,-0.1 -0.1,-0.2 -0,-0 -0,-0.1 -0.1,-0.1 -0,-0.1 -0.1,-0.1 -0.1,-0.1 -0.1,-0.2 -0.3,-0.3 -0.4,-0.4 -1.2,-0.9 -2.3,-1.1 -4,-1.4 -1.9,-0.3 -5.8,-0.3 -7.3,-1.5 -0,-0 -0.1,-0.1 -0.1,-0.1 -0,-0 -0,-0 -0.1,-0.1 -0,-0 -0.1,-0.1 -0.1,-0.1 -0,-0 -0,-0 -0,-0.1 -0,-0 -0,-0 -0,-0 -0.2,-0.3 -0.4,-0.6 -0.4,-0.9 l 0,-0.3 c 0,-2.1 13.2,-0.9 13.2,-3.2 0,-0.3 -0.1,-0.6 -0.3,-0.8 -0,-0.1 -0.1,-0.1 -0.1,-0.2 -0,-0 -0,-0 -0.1,-0.1 -0.1,-0.1 -0.1,-0.1 -0.2,-0.2 -0,-0 -0,-0 -0.1,-0.1 -0.1,-0.1 -0.3,-0.3 -0.5,-0.4 -1.7,-1.3 -4.8,-2.7 -6.3,-3.9 -0.1,-0.1 -0.3,-0.2 -0.4,-0.3 -0,-0 -0,-0 -0.1,-0.1 -0,-0 -0.1,-0.1 -0.1,-0.1 -0,-0 -0,-0 -0.1,-0.1 -0,-0 -0.1,-0.1 -0.1,-0.1 -0.1,-0.1 -0.2,-0.2 -0.2,-0.4 0.3,-0.1 0.6,-0.3 1.1,-0.3 l 2.9,0 6.3,0.3 2.6,-0.3 c 9.4e-4,0 -9.4e-4,0 0,0 l 0.7,-0.1 0.8,0.1 c -0,-0 -0,-0 -0,-0 -0.8,-3.3 -1.4,-7.9 -1.4,-13.1 0,-5.1 0.5,-9.7 1.4,-13.1 0.4,-1.7 0.9,-3 1.4,-3.8 0.5,-0.8 1,-1.1 1.3,-1.1 z m 27.7,1.1 -17.4,17 17.4,16.9 17.4,-16.9 -17.4,-17 z m -2.2,2.9 0,13.8 -3.6,0 0.1,-10.4 3.5,-3.5 z m 4.3,0 c 0.4,0.3 3.6,3.3 3.6,3.7 l 0,10.2 -3.6,0 0,-13.8 z m 7.3,7.2 3.2,2.9 c -0.1,0.1 -0.1,0.1 -0.1,0.1 -0,-0 0,0 0,0.3 l 0,3.3 -3.1,0 0,-6.7 z m -18.8,0 0,6.7 -3,0 0,-3.7 c 0,-0.4 2.7,-2.8 3,-3 z m -7,7.1 32.8,0 -16.4,15.8 -16.4,-15.8 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 134,72.9 c -0.2,0 -0.4,0.1 -0.7,0.4 l 0,-0.2 -47.9,0 c 0.2,0.2 0.4,0.4 0.6,0.7 0.6,1 1.1,2.3 1.5,4 0.9,3.4 1.4,8.1 1.4,13.2 0,5.2 -0.5,9.8 -1.4,13.2 -0.4,1.7 -0.9,3.1 -1.5,4 -0.2,0.3 -0.4,0.5 -0.6,0.8 l 47.9,0 0,-0.7 c 0.3,0.3 0.5,0.4 0.7,0.4 0.3,0 0.7,-0.3 1.3,-1.1 0.5,-0.8 1,-2.2 1.4,-3.8 0.8,-3.3 1.4,-7.9 1.4,-13.1 0,-5.1 -0.5,-9.8 -1.4,-13.1 -0.4,-1.7 -0.9,-3 -1.4,-3.8 -0.5,-0.8 -1,-1.1 -1.3,-1.1 z m -50.7,0.2 c -0.3,0 -0.7,0.3 -1.3,1.1 -0.5,0.8 -1,2.2 -1.4,3.8 -0.8,3.3 -1.4,7.9 -1.4,13.1 0,5.1 0.5,9.8 1.4,13.1 0,0 0,0 0,0 l -0.8,-0.1 -3.3,0.4 -6.2,-0.3 -2.9,0 c -0.5,0 -0.8,0.1 -1.1,0.3 0.4,1.6 8.4,4.3 8.4,6.5 0,2.3 -13.2,1.1 -13.2,3.2 l 0,0.3 c 0,2.4 5.6,2.3 8,2.7 1.7,0.3 2.8,0.5 4,1.4 1.3,1 0.8,3.3 2.2,3.3 2.8,0 5.4,-1.7 8.4,-1.7 l 1.3,0 c 6.8,0 7.9,7.3 12.3,7.9 5.7,0.7 9.9,-4.8 15.2,-4.8 1.8,0 4.7,1.9 7.3,2.3 2.3,0.2 7,-0.2 7,-2.4 0,-3.6 -12,-6.5 -12,-9.8 l 0,-0.1 c 0,-0.9 0.9,-1.4 1.7,-1.4 l 0.3,0 c 1.4,0 3.9,0.3 4.7,-0.7 -0.3,-0.4 -2.5,-1.7 -3.2,-1.7 l -20.3,0.1 -7.1,-0.1 -8.3,0.2 c -0.7,-0.5 -1.3,-1.8 -1.7,-3.5 0.3,0.7 0.5,1.3 0.8,1.8 0.5,0.8 1,1.1 1.3,1.1 0.3,0 0.7,-0.3 1.3,-1.1 0.5,-0.8 1,-2.2 1.4,-3.8 0.8,-3.3 1.4,-7.9 1.4,-13.1 0,-5.1 -0.5,-9.7 -1.4,-13.1 -0.4,-1.7 -0.9,-3 -1.4,-3.8 -0.5,-0.8 -1,-1.1 -1.3,-1.1 z m 27.7,1.1 17.4,17 -17.4,16.9 -17.4,-16.9 17.4,-17 z m -2.2,2.9 -3.5,3.5 -0.1,10.4 3.6,0 -0,-13.8 z m 4.3,0 0,13.8 3.6,0 0,-10.2 c 0,-0.4 -3.2,-3.4 -3.6,-3.7 z m 7.3,7.2 0,6.7 3.1,0 0,-3.3 c 0,-0.3 -0,-0.3 -0,-0.3 0,0 0,0 0.1,-0.1 l -3.2,-2.9 z m -18.8,0 c -0.4,0.3 -3,2.7 -3,3 l 0,3.7 3,0 0,-6.7 z m -7,7.1 16.4,15.8 16.4,-15.8 -32.8,0 z"
            }
        ], i["GR.IN.IC.TOXIC RELEASE INVENTORY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 81.8,61 0,15.2 2,0 0,-6.4 2.2,0 c 0.8,6e-6 1.5,0.2 1.9,0.5 0.5,0.3 1,1 1.5,2 l 1.9,3.9 2.2,0 -2.1,-4.2 c -0.4,-0.9 -0.8,-1.5 -1.3,-2 -0.4,-0.5 -0.8,-0.8 -1.3,-0.9 0.8,-0.2 1.5,-0.7 1.9,-1.3 0.4,-0.6 0.7,-1.4 0.7,-2.4 -2e-5,-1.5 -0.4,-2.6 -1.3,-3.3 -0.9,-0.7 -2.1,-1.1 -3.9,-1.1 l -4.6,0 z m 14.5,0 0,15.2 9.8,0 0,-1.7 -7.7,0 0,-5.5 7.2,0 0,-1.7 -7.2,0 0,-4.5 7.5,0 0,-1.7 -9.6,0 z m 13.2,0 0,15.2 9.4,0 0,-1.7 -7.4,0 0,-13.4 -2,0 z m -25.6,1.7 2.6,0 c 1,1.4e-5 1.7,0.2 2.2,0.7 0.5,0.4 0.8,1.1 0.8,2 -10e-6,0.9 -0.3,1.6 -0.8,2 -0.5,0.5 -1.2,0.7 -2.2,0.7 l -2.6,0 0,-5.4 z m 16,14.7 c -4.3,1.1e-5 -8.3,0.4 -11.2,1.2 -1.4,0.4 -2.6,0.8 -3.5,1.3 -0.7,0.4 -1.2,0.9 -1.4,1.5 l -0.1,0 0,0.6 c -3.1e-5,0 0,0 0,0 l 0,31.1 -0.2,-0.7 c -0.1,0 -1.1,0.1 -2.4,0 -1.2,-0.1 -2.7,-0.2 -4.2,-0.3 -1.5,-0.1 -2.9,-0.2 -4,-0.1 -0.6,0 -1.1,0 -1.5,0.1 -0.2,0 -0.4,0.1 -0.6,0.2 -0.2,0.1 -0.4,0.2 -0.6,0.5 -0.3,0.4 -0.4,0.9 -0.3,1.4 0.1,0.5 0.3,0.8 0.5,1.2 0.5,0.7 1.2,1.2 1.9,1.7 0.7,0.5 1.4,1 1.9,1.5 0.5,0.5 0.7,0.9 0.6,1.2 -0,0.1 -0,0.2 -0.2,0.3 -0.2,0.2 -0.6,0.3 -1,0.5 -0.9,0.3 -2.2,0.5 -3.5,0.7 -1.3,0.2 -2.7,0.3 -3.7,0.5 -0.5,0.1 -1,0.2 -1.4,0.4 -0.2,0.1 -0.4,0.2 -0.6,0.3 -0.2,0.2 -0.4,0.4 -0.4,0.7 -0.1,0.9 0.3,1.7 1,2.3 0.7,0.6 1.5,1.1 2.6,1.6 2.1,0.9 4.9,1.7 7.9,2.4 2.9,0.7 5.9,1.2 8.3,1.7 2.4,0.4 4.4,0.8 4.8,0.9 2,0.6 3.3,1.8 4.9,3.2 1.5,1.3 3.2,2.8 5.8,3.5 3,0.8 6.2,-0.6 9.4,-2 3.2,-1.4 6.4,-2.8 9.1,-2.5 0.1,0 1,0.2 1.9,0.5 1,0.3 2.2,0.6 3.4,0.8 1.2,0.3 2.4,0.5 3.5,0.6 1.1,0.1 2,0.2 2.7,-0.5 0.8,-0.7 1.3,-1.4 1.4,-2.1 0.2,-0.8 -0,-1.5 -0.4,-2.2 -0.8,-1.3 -2.2,-2.3 -3.9,-3.2 -1.6,-0.9 -3.5,-1.8 -5,-2.6 -1.5,-0.8 -2.7,-1.6 -3,-1.9 -0.2,-0.3 -0.2,-0.2 -0.1,-0.4 0.1,-0.1 0.3,-0.4 0.7,-0.7 0.8,-0.5 2.2,-1 3.2,-1.5 0.5,-0.3 1,-0.5 1.3,-1 0.2,-0.3 0.3,-0.7 0.2,-1 -0.1,-0.4 -0.3,-0.6 -0.6,-0.8 -0.5,-0.4 -1.2,-0.7 -2.3,-1.1 -1.1,-0.3 -2.6,-0.7 -4.6,-1.1 l -0.3,1.3 0,-35.4 0,-0.6 -0.1,0 c -0.2,-0.6 -0.7,-1.1 -1.4,-1.5 -0.9,-0.5 -2.1,-1 -3.5,-1.3 -2.9,-0.7 -6.8,-1.2 -11.2,-1.2 z m 0,1.2 c 4.3,-1.1e-5 8.1,0.4 10.9,1.1 1.4,0.4 2.5,0.8 3.2,1.2 0.3,0.2 0.4,0.3 0.6,0.5 0.1,0.1 0.2,0.2 0.3,0.3 0,0 0,0 0,0.1 0,0 0,0.1 0,0.1 0,0 0,0.1 0,0.1 0,0 -0,0.1 -0,0.1 -0,0 -0,0 -0,0 -0,0 -0,0 -0,0.1 -0,0 -0,0 -0,0.1 -0,0 -0,0 -0,0.1 -0,0 -0,0.1 -0.1,0.1 -0,0.1 -0.1,0.1 -0.1,0.2 -0,0 -0,0 -0,0 -0.1,0.1 -0.3,0.3 -0.6,0.5 -0.7,0.4 -1.8,0.8 -3.2,1.2 -2.8,0.7 -6.6,1.2 -10.9,1.2 -4.3,1.1e-5 -8.1,-0.4 -10.9,-1.1 -1.4,-0.4 -2.5,-0.8 -3.2,-1.2 -0.3,-0.2 -0.5,-0.3 -0.6,-0.5 -0,-0 -0.1,-0.1 -0.1,-0.1 -0,-0 -0,-0 -0,-0 -0,-0 -0,-0.1 -0.1,-0.1 -0,-0 -0,-0 -0,-0 -0,-0 -0,-0.1 -0.1,-0.1 -0,-0.1 -0.1,-0.1 -0.1,-0.2 0,-0 0,-0.1 0,-0.1 0.1,-0.2 0.3,-0.6 0.9,-0.9 0.7,-0.4 1.8,-0.8 3.2,-1.2 2.8,-0.7 6.6,-1.1 10.9,-1.1 z m 15,5.3 0,34.1 0,0 0,5.6 c 0.1,0.2 0.2,0.3 0.2,0.4 0,0.2 -0.2,0.6 -0.9,1.1 -0.7,0.4 -1.8,0.8 -3.2,1.2 -2.8,0.7 -6.6,1.1 -10.9,1.1 -4.3,1e-5 -8.1,-0.4 -10.9,-1.1 -1.4,-0.4 -2.5,-0.8 -3.2,-1.2 -0.6,-0.4 -0.9,-0.7 -0.9,-1 l -0,0 0,-0.1 0,-1.9 c -0.1,0.1 -0.1,0.1 -0.2,0.1 l 0,-38.4 c 0.1,0.1 0.2,0.1 0.3,0.2 0.9,0.5 2.1,1 3.5,1.3 2.9,0.7 6.8,1.2 11.2,1.2 4.3,-1.2e-5 8.3,-0.5 11.2,-1.2 1.4,-0.4 2.6,-0.8 3.5,-1.3 0.1,-0.1 0.2,-0.1 0.3,-0.2 z m -15.2,6.1 -14.6,14.2 14.2,13.8 0.8,0 14.2,-13.8 -14.6,-14.3 z m -1.8,2.4 0,11.6 -3.1,0 0.1,-8.7 3,-2.9 z m 3.6,0 c 0.4,0.3 3,2.7 3,3 l 0,8.5 -3,0 0,-11.6 z m -9.7,6 0,5.6 -2.5,0 0,-3.1 c 0,-0.3 2.2,-2.3 2.5,-2.5 z m 15.8,0 2.6,2.5 c -0.1,0.3 -0.1,-0.1 -0.1,0.3 l 0,2.8 -2.5,0 0,-5.6 z m -21.7,6 27.5,0 -13.8,13.3 -13.7,-13.3 z m -12.8,9.3 c 1.1,-0 2.5,0 3.9,0.1 1.4,0.1 2.9,0.2 4.2,0.3 1.1,0.1 1.9,0.1 2.6,-0 l 0,10 0,0.6 0.3,0 c 0.2,0.6 0.7,1.1 1.4,1.5 0.9,0.5 2.1,1 3.5,1.3 2.9,0.7 6.8,1.2 11.2,1.2 4.3,-1e-5 8.3,-0.4 11.2,-1.2 1.4,-0.4 2.6,-0.8 3.5,-1.3 0.9,-0.5 1.5,-1.2 1.5,-2.1 0,-0.3 -0.1,-0.5 -0.2,-0.8 l 0,-5.6 c 1.9,0.4 3.4,0.8 4.4,1.1 0.9,0.3 1.3,0.5 1.6,0.7 -0.1,0.1 -0.1,0.1 -0.4,0.3 -0.8,0.4 -2.2,0.9 -3.3,1.6 -0.5,0.3 -1,0.7 -1.3,1.3 -0.3,0.6 -0.2,1.4 0.2,2 0.7,1 2,1.6 3.5,2.4 1.6,0.8 3.4,1.6 4.9,2.5 1.5,0.9 2.8,1.9 3.3,2.7 0.2,0.4 0.3,0.7 0.2,1 -0.1,0.3 -0.3,0.8 -0.9,1.3 0,-0 -0.6,0.2 -1.5,0.1 -0.9,-0.1 -2.1,-0.3 -3.3,-0.6 -1.2,-0.3 -2.4,-0.6 -3.3,-0.8 -1,-0.3 -1.7,-0.5 -2.2,-0.5 -3.3,-0.3 -6.7,1.3 -9.9,2.7 -3.2,1.4 -6.1,2.5 -8.4,1.9 -2.3,-0.6 -3.7,-1.8 -5.2,-3.2 -1.5,-1.3 -3.1,-2.8 -5.5,-3.5 -0.8,-0.2 -2.5,-0.5 -5,-0.9 -2.4,-0.4 -5.4,-1 -8.3,-1.6 -2.9,-0.7 -5.6,-1.5 -7.6,-2.3 -1,-0.4 -1.7,-0.9 -2.2,-1.3 -0.3,-0.3 -0.4,-0.5 -0.5,-0.7 0.2,-0.1 0.6,-0.2 1.1,-0.3 1,-0.2 2.3,-0.3 3.6,-0.5 1.4,-0.2 2.7,-0.4 3.9,-0.8 0.6,-0.2 1.1,-0.4 1.5,-0.8 0.4,-0.3 0.8,-0.8 0.8,-1.4 0.1,-1 -0.4,-1.8 -1.1,-2.5 -0.6,-0.7 -1.4,-1.2 -2.1,-1.7 -0.7,-0.5 -1.3,-1 -1.6,-1.4 -0.1,-0.2 -0.2,-0.3 -0.2,-0.4 -0,-0.1 0,-0.1 0.1,-0.2 0,-0 0.1,-0 0.1,-0 0.3,-0 0.7,-0.1 1.2,-0.1 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 85.8,104.4 13.7,13.3 13.8,-13.3 z m 21.7,-0.4 h 2.5 v -2.8 c 0,-0.5 -0,-0.1 0.1,-0.4 l -2.7,-2.4 v 5.6 z m -6.1,0 h 3.1 v -8.5 c 0,-0.3 -2.7,-2.8 -3.1,-3.1 v 11.6 z m -6.6,-8.7 -0.1,8.7 3.1,0 -0,-11.6 z m -5.7,5.6 v 3.1 h 2.5 v -5.6 c -0.3,0.2 -2.5,2.2 -2.5,2.5 z M 99.8,85.4 c -4.3,1.2e-5 -8.1,-0.4 -10.9,-1.1 -1.4,-0.4 -2.5,-0.8 -3.2,-1.2 -0.7,-0.4 -0.9,-0.8 -0.9,-1 0,-0.2 0.2,-0.6 0.9,-1 0.7,-0.4 1.8,-0.8 3.2,-1.2 2.8,-0.7 6.6,-1.2 10.9,-1.2 4.3,-1.1e-5 8.1,0.4 10.9,1.1 1.4,0.4 2.5,0.8 3.2,1.2 0.7,0.4 0.9,0.8 0.9,1 0,0.2 -0.2,0.6 -0.9,1 -0.7,0.4 -1.8,0.8 -3.2,1.2 -2.8,0.7 -6.6,1.2 -10.9,1.2 z m -15,-1.5 0,38.4 c 0.1,-0.1 0.1,-0.1 0.2,-0.1 l 0,1.8 0,0.1 0,0 c 0,0.2 0.3,0.6 0.9,0.9 0.7,0.4 1.8,0.9 3.2,1.2 2.8,0.7 6.6,1.2 10.9,1.2 4.3,-1e-5 8.2,-0.5 10.9,-1.2 1.4,-0.4 2.4,-0.8 3.2,-1.2 0.7,-0.4 0.9,-0.8 0.9,-1 0,-0.1 -0,-0.2 -0.2,-0.4 l 0,-5.6 -0,0 0,-34.1 c -0.1,0.1 -0.2,0.1 -0.3,0.2 -0.9,0.5 -2.1,1 -3.5,1.3 -2.9,0.7 -6.8,1.2 -11.2,1.2 -4.3,1.1e-5 -8.3,-0.4 -11.2,-1.2 -1.4,-0.4 -2.6,-0.8 -3.5,-1.3 -0.1,-0.1 -0.2,-0.1 -0.3,-0.2 z m 14.8,6.1 14.6,14.3 -14.2,13.8 -0.8,0 L 85,104.2 99.6,90 z m -26.7,23.7 c 1.1,-0 2.5,0 3.9,0.1 1.4,0.1 2.9,0.2 4.2,0.3 1.1,0.1 1.9,0.1 2.6,-0 l 0,10 0,0.6 0.3,0 c 0.2,0.6 0.7,1.1 1.4,1.5 0.9,0.5 2.1,1 3.5,1.3 2.9,0.7 6.8,1.2 11.2,1.2 4.3,-1e-5 8.3,-0.4 11.2,-1.2 1.4,-0.4 2.6,-0.8 3.5,-1.3 0.9,-0.5 1.5,-1.2 1.5,-2.1 0,-0.3 -0.1,-0.5 -0.2,-0.8 l 0,-5.6 c 1.9,0.4 3.4,0.8 4.4,1.1 0.9,0.3 1.3,0.5 1.6,0.7 -0.1,0.1 -0.1,0.1 -0.4,0.3 -0.8,0.4 -2.2,0.9 -3.3,1.6 -0.5,0.3 -1,0.7 -1.3,1.3 -0.3,0.6 -0.2,1.4 0.2,2 0.7,1 2,1.6 3.5,2.4 1.6,0.8 3.4,1.6 4.9,2.5 1.5,0.9 2.8,1.9 3.3,2.7 0.2,0.4 0.3,0.7 0.2,1 -0.1,0.3 -0.3,0.8 -0.9,1.3 0,-0 -0.6,0.2 -1.5,0.1 -0.9,-0.1 -2.1,-0.3 -3.3,-0.6 -1.2,-0.3 -2.4,-0.6 -3.3,-0.8 -1,-0.3 -1.7,-0.5 -2.2,-0.5 -3.3,-0.3 -6.7,1.3 -9.9,2.7 -3.2,1.4 -6.1,2.5 -8.4,1.9 -2.3,-0.6 -3.7,-1.8 -5.2,-3.2 -1.5,-1.3 -3.1,-2.8 -5.5,-3.5 -0.8,-0.2 -2.5,-0.5 -5,-0.9 -2.4,-0.4 -5.4,-1 -8.3,-1.6 -2.9,-0.7 -5.6,-1.5 -7.6,-2.3 -1,-0.4 -1.7,-0.9 -2.2,-1.3 -0.3,-0.3 -0.4,-0.5 -0.5,-0.7 0.2,-0.1 0.6,-0.2 1.1,-0.3 1,-0.2 2.3,-0.3 3.6,-0.5 1.4,-0.2 2.7,-0.4 3.9,-0.8 0.6,-0.2 1.1,-0.4 1.5,-0.8 0.4,-0.3 0.8,-0.8 0.8,-1.4 0.1,-1 -0.4,-1.8 -1.1,-2.5 -0.6,-0.7 -1.4,-1.2 -2.1,-1.7 -0.7,-0.5 -1.3,-1 -1.6,-1.4 -0.1,-0.2 -0.2,-0.3 -0.2,-0.4 -0,-0.1 0,-0.1 0.1,-0.2 0,-0 0.1,-0 0.1,-0 0.3,-0 0.7,-0.1 1.2,-0.1 z"
            }
        ], i["GR.IN.IC.COLLEGE/UNIVERSITY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 97.4,106.9 h -14.8 v 31.7 h 32 v -31.7 H 99.8 V 95.1 c 0,-0.6 6.5,-3 7.5,-3.4 1.3,-0.5 6.9,-3 7.9,-3 -0.3,-0.4 -14.7,-6.3 -15.7,-6.3 h -2.3 v 24.5 z m 23.3,-30.1 -9.6,0 0,-15.1 2,0 0,13.3 7.6,0 0,1.8 M 106,63.5 c 0.6,0.7 1.1,1.5 1.4,2.5 0.3,1 0.5,2.1 0.5,3.3 -1e-5,1.2 -0.2,2.4 -0.5,3.4 -0.3,1 -0.8,1.8 -1.4,2.5 -0.6,0.7 -1.4,1.2 -2.2,1.5 -0.8,0.3 -1.8,0.5 -2.9,0.5 -1.1,0 -2,-0.2 -2.9,-0.5 -0.9,-0.4 -1.6,-0.9 -2.2,-1.5 -0.6,-0.7 -1.1,-1.5 -1.4,-2.5 -0.3,-1 -0.5,-2.1 -0.5,-3.3 -10e-7,-1.2 0.2,-2.3 0.5,-3.3 0.3,-1 0.8,-1.8 1.4,-2.5 0.6,-0.7 1.3,-1.2 2.2,-1.5 0.9,-0.4 1.9,-0.5 2.9,-0.5 1.1,1.5e-5 2.1,0.2 2.9,0.5 0.9,0.4 1.6,0.9 2.2,1.5 m -0.2,5.8 c -2e-5,-2 -0.4,-3.5 -1.3,-4.5 -0.9,-1.1 -2.1,-1.6 -3.6,-1.6 -1.5,1.4e-5 -2.7,0.5 -3.6,1.6 -0.9,1.1 -1.3,2.6 -1.3,4.5 -3e-6,2 0.4,3.5 1.3,4.6 0.9,1 2.1,1.6 3.6,1.6 1.5,2e-6 2.7,-0.5 3.6,-1.6 0.9,-1.1 1.3,-2.6 1.3,-4.6 m -14,6.5 c -0.4,0.2 -0.7,0.3 -1,0.5 -0.3,0.1 -0.7,0.3 -1.2,0.4 -0.4,0.1 -0.9,0.2 -1.4,0.3 -0.5,0.1 -1,0.1 -1.6,0.1 -1.1,0 -2.1,-0.2 -3,-0.5 -0.9,-0.3 -1.7,-0.8 -2.3,-1.5 -0.7,-0.6 -1.2,-1.5 -1.5,-2.4 -0.4,-1 -0.5,-2.1 -0.5,-3.5 -10e-7,-1.2 0.2,-2.4 0.5,-3.3 0.4,-1 0.9,-1.8 1.5,-2.5 0.6,-0.7 1.4,-1.2 2.3,-1.5 0.9,-0.3 1.9,-0.5 3,-0.5 0.8,1.5e-5 1.6,0.1 2.4,0.3 0.8,0.2 1.7,0.5 2.7,1 l 0,2.4 -0.2,0 c -0.8,-0.7 -1.7,-1.2 -2.5,-1.5 -0.8,-0.3 -1.7,-0.5 -2.6,-0.5 -0.8,1.4e-5 -1.5,0.1 -2.1,0.4 -0.6,0.2 -1.2,0.6 -1.6,1.1 -0.5,0.5 -0.8,1.2 -1.1,1.9 -0.3,0.8 -0.4,1.7 -0.4,2.7 -3e-6,1.1 0.1,2 0.4,2.7 0.3,0.8 0.7,1.4 1.1,1.9 0.5,0.5 1,0.9 1.7,1.1 0.6,0.2 1.3,0.4 2,0.4 1,2e-6 1.9,-0.2 2.7,-0.5 0.8,-0.3 1.6,-0.8 2.4,-1.5 l 0.1,0 0,2.4"
            }
        ], i["GR.IN.IC.SCHOOL"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 98.4,96.4 H 83.7 v 31.7 h 32 V 96.4 H 100.9 V 84.6 c 0,-0.6 6.5,-3 7.5,-3.4 1.3,-0.5 6.9,-3 7.9,-3 -0.3,-0.4 -14.7,-6.3 -15.7,-6.3 H 98.4 V 96.4 z"
            }
        ], i["GR.IN.IC.REST STOP"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 108.4,89.6 v -0.4 l 0.6,-0.6 -0.4,1.4 -3.8,13.4 -0.2,0.8 -0.4,0.6 0,0.9 -2,6.7 7.2,0 v 19.7 h 5.2 v -19.7 h 2.7 v 19.7 h 5.2 v -19.7 h 7.1 l -1.3,-5.3 -0.2,-0.8 -4.8,-16.4 -0.5,-1.4 0.6,0.7 0.1,0.4 c 2.1,2.4 5.4,14.2 8.6,14.2 h 0.4 c 1.2,0 2.1,-1.1 2.1,-2.3 v -0.6 c 0,-0.5 -4.8,-10 -5.3,-11.6 -0.7,-2 -1.7,-4.2 -2.6,-6 -1,-2.1 -1.2,-3.8 -4.6,-3.8 h -12.4 c -3.4,0 -3.6,1.8 -4.7,3.9 -0.9,1.7 -1.9,4 -2.5,5.9 -0.6,1.6 -5.2,11.1 -5.2,11.6 v 0.6 c 0,1.3 0.6,2.3 1.9,2.3 h 0.8 c 2.4,0 6.4,-12.2 8.2,-14.2 z m 0.2,0.4 0.4,-1.5 -0.6,0.6 0,0.4 z m 15.1,-0.4 -0.1,-0.4 -0.6,-0.6 0.5,1.4 z M 69.6,88.8 h 2.3 v 43.6 h 6.1 v -25.6 h 2.7 v 25.6 h 5.9 v -43.6 h 2.3 v 16.4 h 4.6 V 86.3 l -0.3,-2.3 h -0.4 c 0,-2.3 -1.7,-4.4 -4,-4.4 H 69.6 c -3,0 -4.4,3.4 -4.4,6.5 v 19.1 h 4.4 V 88.8 z M 110.7,72.8 c 0,2.7 2.4,5.4 5,5.4 h 0.2 c 1.6,0 2.8,-0.6 3.6,-1.4 0.5,-0.4 1.8,-2.4 1.8,-3 v -1.6 c 0,-2.4 -2.8,-4.6 -5.4,-4.6 -3,-0 -5.2,2.4 -5.2,5.2 z m -36.7,1.1 c 0,2 2.8,4.4 5,4.4 h 0.2 c 4.2,0 4.3,-3.4 5.2,-3.8 V 71.6 c 0,-1.8 -2.8,-4 -5.2,-4 -2.3,0 -5.2,2.2 -5.2,4 v 2.3 z"
            }
        ], i["GR.IN.IC.CONTROL VALVE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 114,114.5 h 15.7 v 4 h 9.1 v -23.6 h -9.1 V 98.8 H 114.4 c -0.4,0 -2.6,-2.6 -2.6,-3.4 v -5.6 h -9.9 v -8.2 h 12.3 v -3.6 h -28.2 v 3.6 h 12.1 v 8.3 H 89.2 v 6.6 l -0.2,-0.2 -1.8,2.4 -17.2,0.1 V 95 H 61.2 v 23.6 h 8.9 v -4 H 87 c 0.4,0 2,2.4 2.4,2.8 0.5,0.6 2.2,1.9 2.9,2.4 1.9,1.2 4.7,2.4 7.8,2.4 h 0.6 c 3.5,0 5.8,-1 8.1,-2.4 1.4,-0.8 4.8,-3.8 5.2,-5.3 z"
            }
        ], i["GR.IN.IC.DAM"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 68.3,89.1 c 2.3,0 3.2,-1.7 4.6,-2.6 1.1,0.8 2.2,2.6 4.4,2.6 h 0.2 c 2.6,0 3.3,-1.7 4.7,-2.6 1.4,0.9 2.2,2.6 4.7,2.6 2.4,0 3.3,-1.8 4.6,-2.6 0.6,0.4 1.1,1.1 1.9,1.6 0.4,0.2 2.2,0.9 2.2,1.3 v 6.8 C 94.1,95.8 91.8,93.8 91.5,92.6 h -0.3 c -0.3,1.1 -3,3.6 -4.5,3.6 -1.5,0 -4.1,-2.6 -4.4,-3.8 -1,0.6 -2.6,3.8 -4.6,3.8 h -0.4 c -1.2,0 -4,-2.7 -4.2,-3.7 -0.8,0.2 -2.6,3.7 -4.7,3.7 h -0.3 c -1.1,0 -1.7,-0.7 -2.4,-1.2 l -1,1.2 c 1,0.7 1.6,1.8 3.2,1.8 h 0.4 c 2.3,0 3.1,-1.8 4.6,-2.8 0.7,1.1 2.8,2.8 4.7,2.8 2.3,0 3.3,-2 4.6,-2.8 1.2,0.8 2.6,2.8 4.7,2.8 2.1,0 3.4,-2.1 4.7,-2.8 0.7,1 2.6,2.4 4,2.7 v 7 c -1.4,-0.1 -3.4,-2.4 -4,-3.5 -1.1,0.7 -2.5,3.6 -4.7,3.6 h -0.1 c -2.3,0 -4.1,-3.5 -4.7,-3.7 -0.3,1 -3,3.7 -4.1,3.7 h -0.4 c -2.2,0 -3.6,-2.9 -4.7,-3.7 -0.6,1 -2.8,3.7 -4.1,3.7 H 67.7 c -0.7,0 -1.7,-1 -2.2,-1.3 l -0.9,1.5 c 1.1,0.7 1.7,1.6 3.6,1.6 2.7,0 3.1,-1.8 4.7,-2.6 1.4,0.9 2,2.6 4.7,2.6 2.2,0 3.4,-1.8 4.6,-2.6 1.4,1 2.5,2.6 4.8,2.6 1.8,0 3.4,-2 4.4,-2.6 0.9,0.5 1,1 2,1.6 0.4,0.3 2.2,0.7 2.2,1.2 v 6.8 c -1.4,-0.3 -3.6,-2.2 -4,-3.5 -1.1,0.7 -2.5,3.8 -4.8,3.8 -1.4,0 -4.1,-2.6 -4.4,-3.8 -1.2,0.8 -2.6,3.8 -4.8,3.8 -2,0 -3.7,-3.2 -4.7,-3.8 -0.3,1 -3,3.8 -4.3,3.8 h -0.6 c -0.8,0 -1.8,-1 -2.4,-1.3 l -0.9,1.3 c 1.1,0.7 1.8,1.8 3.6,1.8 2.2,0 3.3,-1.8 4.7,-2.8 1.2,0.8 2.6,2.9 4.7,2.8 2.3,-0.1 3.3,-1.9 4.6,-2.8 1.2,0.8 2.7,2.8 4.7,2.8 1.9,0 3.4,-2 4.6,-2.8 1.6,1 1.8,2 4.1,2.5 v 5 h 17 l -1.4,-5.2 c 0.8,0.2 1,0.6 2.2,0.6 2,0 3.3,-1.9 4.6,-2.8 1.3,0.9 2.4,2.8 4.7,2.8 1.6,0 3.8,-1.8 4.4,-2.8 1.3,0.3 2.5,2.8 5.1,2.8 1.2,0 2.6,-1.4 3.4,-1.8 l -1,-1.3 c -0.7,0.4 -1.5,1.3 -2.6,1.3 -2.1,0 -3.7,-3.1 -4.7,-3.8 -0.7,1.4 -2.7,3.8 -4.7,3.8 -1.3,0 -4.3,-2.6 -4.4,-3.8 -1,0.7 -2.6,3.8 -4.7,3.8 h -0.2 c -1.1,0 -2.2,-0.9 -2.7,-1.5 -0.4,-0.4 -0.8,-2.5 -1.1,-3.2 -0.4,-1 -1.8,-5.6 -1.8,-6.6 l -0.3,-0.4 0,-0.6 -0.3,-0.4 v -0.6 l -0.3,-0.4 -5.3,-18.6 0.2,-0 -0.3,-0.4 0,-0.6 c -0.2,-0.3 -0.3,-0.3 -0.3,-0.6 v -0.4 h -5.6 v 7.8 c -1.4,-0.7 -1.2,-0.5 -2.4,-1.6 -0.1,-0.1 -1,-0.9 -1,-1 -0.4,-0.5 -0.1,-0.9 -0.8,-1.1 -0.1,1.2 -3.1,3.8 -4.3,3.8 h -0.2 c -2.5,0 -4.2,-3.6 -4.8,-3.8 -0.3,1.1 -3,3.8 -4.2,3.8 h -0.4 c -1.2,0 -4.2,-2.7 -4.2,-3.8 -0.5,0.1 -2.8,3.8 -4.4,3.8 H 67.7 c -0.7,0 -1.7,-1 -2.2,-1.3 l -0.9,1.3 c 1,0.7 1.6,1.6 3.4,1.6 h 0.3 v 0 z"
            }
        ], i["GR.IN.IC.DISCHARGE OUTFALL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 63.2,111.4 v 13.4 h 73.6 V 111.7 l -3.1,0.5 -1.1,-0.1 c -2.2,0 -3.6,-0.7 -4.9,-1.6 -0.6,-0.4 -1.1,-1.1 -1.5,-1.8 -0.4,-0.6 -0.2,-2.1 -1,-2.1 h -0.4 c -0.8,0 -0.7,1.6 -1.2,2.2 -0.4,0.6 -0.9,1.2 -1.6,1.7 -1.3,1 -3,1.6 -5.1,1.6 h -0.9 c -3.2,0 -6.8,-2.1 -6.8,-5.1 -0.3,-0.2 -0.4,-0.4 -0.8,-0.4 h -0.3 c -0.7,0 -0.8,1.5 -1.1,2.1 -0.4,0.6 -1,1.4 -1.5,1.8 -1.2,1 -2.7,1.6 -4.8,1.6 h -0.9 c -3.5,0 -7.3,-2.1 -7.3,-5.4 -0.4,-0.1 -0.4,-0.2 -0.8,-0.2 h -0.3 c -0.6,0 -0.6,1.5 -1.1,2.2 -0.5,0.8 -0.7,1.1 -1.5,1.7 -1.3,1 -2.7,1.6 -4.8,1.6 H 82.9 c -3.5,0 -6.7,-2.2 -7,-5.4 -0.3,-0.1 -0.4,-0.2 -0.8,-0.2 h -0.1 c -0.7,0 -0.8,1.5 -1.2,2.2 -0.4,0.6 -0.9,1.2 -1.6,1.7 -1.4,1 -2.7,1.6 -5,1.6 h -1 c -1.2,0 -2.2,-0.4 -3,-0.8 l 0,0 z m 0,-21.6 19.5,0 0,1.2 2.7,0 0,-15.8 -2.7,0 0,1.2 -19.5,0 z M 89.7,80.9 v 0.1 c 8.1,0 16.2,1.2 20.6,4.9 2.8,2.4 3.1,4.5 3.1,9.6 0,4.1 0.5,8.3 4.5,8.3 h 0.8 c 1.7,0 2.8,-2.6 2.8,-4.3 v -0.9 c 0,-5.1 -3.3,-10.7 -5.9,-13.3 -1.6,-1.6 -3.6,-3 -6.1,-3.6 -2.2,-0.5 -6,-1.1 -8.6,-1.1 l -1.8,-0.1 -9.4,0.4 z"
            }
        ], i["GR.IN.IC.GROUND WATER WELL"] = [
            {
                type: "path",
                stroke: !1,
                d: "M86,64L86,70L75,110L81,110L92,70L99,70L99,130L86,130L86,140L120,140L120,130L110,130L110,89L120,89L120,93L130,93L130,87C130,82.631 125.551,83 125.551,83L110,83L110,70L113.774,70L113.774,64L86,64Z"
            }
        ], i["GR.IN.IC.TELECOMMUNICATIONS INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 109.7,116.6 4.1,13.4 -0.2,0.1 -12.2,-8.4 8.3,-5.2 z m -19.7,0 8,5.1 -12.1,8.4 4.1,-13.6 z m 9.8,-9.8 8.8,8.2 c -1.7,0.5 -8.1,5.6 -8.8,5.6 -0.2,0 -8.2,-5.4 -8.6,-5.8 l 8.5,-8.1 z m 5.3,-4.8 3.1,9.8 -6.9,-6.4 3.7,-3.4 z m -10.5,0.1 3.8,3.3 -6.9,6.4 3.1,-9.7 z m 2.1,-1 6.4,-0 -3.2,3.2 -3.2,-3.2 z M 99.2,84.8 C 99.1,85.4 99,85.5 99,86.1 v 2 h -3 c -0.5,0 -0.8,0.3 -0.8,0.8 0,0.5 0.1,0.5 0.2,1 0.4,0.1 0.4,0.2 1,0.2 h 2.6 v 2.8 h -4.5 c -0.6,0 -1.2,0.2 -1.2,0.8 0,0.5 0.3,0.8 0.8,0.8 h 4.9 v 4.9 h -4.5 c -0.5,0 -0.5,0.1 -0.9,0.2 l -2.5,7.9 -1,3.2 -4.1,13.3 -1.1,3.1 c 0,2 -1.4,3.5 -1.4,5.5 0,0.4 0.1,0.2 0.2,0.8 h 0.5 c 0.6,0 15.1,-10.3 15.4,-10.3 0.6,0 14.2,9.4 15.8,10.5 0.4,-0.2 1,-0.4 1,-1 v -0.6 c 0,-0 -1.5,-4.4 -1.7,-5 -0.4,-1.1 -1.4,-4.3 -1.5,-5.2 l -1,-3.2 -4.1,-13.2 -0.9,-3.4 c -1,-0.4 -0.3,-2.6 -1.6,-2.6 h -4.8 v -5 h 4.8 c 0.5,0 0.8,-0.3 0.8,-0.8 0,-0.5 -0.3,-0.8 -0.8,-0.8 H 100.8 V 90.1 h 2.4 c 0.7,0 1.4,-0.4 1.4,-1 v -0.2 c 0,-0.5 -0.3,-0.8 -0.8,-0.8 h -2.9 v -2.6 c 0,-0.4 -0.6,-1 -0.8,-1 -0,-0 -0.7,0.1 -0.8,0.2 z m 6.7,-15.7 c 7,1.6 10.9,4.6 15.1,8.9 3,3 7.3,11 7.3,16.9 v 4 c 0,2.1 -1.5,7.7 -2.2,9 -0.7,1.1 -1.2,2.4 -1.9,3.6 -0.3,0.4 -2.4,3.3 -2.4,3.4 0,0.7 1,1.6 1.2,2.6 1.7,-0.4 4.8,-6.3 5.7,-8.2 1.2,-2.5 2.7,-7.8 2.7,-11.4 V 94.3 c 0,-0.1 -0.9,-4.9 -1,-5.5 -0.3,-0.9 -1.4,-3.7 -1.8,-4.8 -0.9,-2.2 -3.7,-6.4 -5.2,-8 -3.6,-3.6 -10.6,-9.2 -16.9,-9.7 l -0.4,2.8 z m -1.6,10.7 c 6,0.5 13.3,9.2 13.3,16.1 v 2.2 c 0,1.5 -1.4,5.5 -1.4,5.5 0,0.2 1.2,2.9 1.4,3.2 l 0.2,0.1 1.6,-3.4 0.1,-0.6 0.7,-5.9 0.2,-0.4 -1,-5.9 c -0.7,-0.3 -0.6,-1.4 -1.1,-2.2 -0.4,-0.8 -0.8,-1.6 -1.3,-2.3 -1.1,-1.6 -1.8,-2.6 -3.2,-3.9 -2.2,-2.2 -5.8,-4.2 -9.2,-5 l -0.3,2.8 z M 68.7,95.2 v 5.1 c 0,4.2 5.4,16.3 7.9,17 0.1,-0.5 1,-2.2 1,-2.6 0,0 -2.1,-2.9 -2.3,-3.4 -0.7,-1.3 -1.3,-2.4 -1.9,-3.8 -1,-2.6 -1.8,-6 -1.8,-9.6 v -2.4 c 0,-8 3.3,-12.9 6.9,-17.5 1.4,-1.8 4.7,-4.4 6.7,-5.6 1.4,-0.8 2.5,-1.4 4.1,-2.1 0.5,-0.2 4.5,-1.3 4.5,-1.6 l -0.2,-2.6 c -2.4,0.1 -8,2.6 -9.6,3.7 -3.2,1.9 -4.8,3.6 -7.3,6.1 -3.6,3.6 -7.8,12 -7.8,19.1 l 0,0 z m 10.7,0 v 2.9 c 0,1.9 0.2,3.1 0.8,4.5 0.2,0.4 1.5,4 1.5,4 l 0.4,-0 1.5,-2.9 c -0.9,-1.2 -1.4,-4 -1.4,-6.2 v -1.8 c 0,-3.7 2.3,-8.3 4.2,-10.3 1.8,-1.8 5.9,-5.5 9.1,-5.6 L 95,77.1 C 88,77.6 79.4,87.3 79.4,95.2 z"
            }
        ], i["GR.IN.IC.TELECOMMUNICATIONS TOWER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 102.5,119.2 12,-8 2.8,9.2 1.3,4 2.1,6.9 -18.2,-12 z m -23,12 3.4,-11.7 2,-5.9 0.8,-2.6 11.9,8.2 -18,12 z m 20.4,-34.6 13,12.2 c -1.5,1 -12.3,8.5 -13.1,8.5 -0.1,0 -11.6,-7.7 -12.7,-8.5 L 99.9,96.6 z m 7.7,-7.1 0.2,0.2 1.8,5.7 2.5,8.7 -10.1,-9.3 5.6,-5.2 0,0 z m -15.5,0.6 v -0.6 l 0.4,0.2 5.4,5 -10,9.4 2.6,-9 1.6,-5 z m 2.9,-1.7 9.8,-0 -5,4.4 -4.8,-4.4 z m 3.6,-23.1 v 3.6 h -4.4 c -0.5,0 -1,0.6 -1,1 v 0.6 c 0,0.7 0.8,1 1.5,1 h 4 v 4.2 h -7.2 c -0.5,0 -1,0.6 -1,1 v 0.2 c 0,1 0.5,1.5 1.5,1.5 h 6.8 v 7 h -6.8 c -0.8,0 -1,0.3 -1.3,0.7 l -0.6,2 -4.9,15.6 -3,9.6 -3.1,9.4 -0.1,0.8 -2.9,8.7 -0.1,0.8 -0.5,2.2 c 1,0.2 0.5,0.6 1.3,0.6 h 0.2 c 0.8,0 20.1,-13.7 23.1,-15.2 2.5,1.7 22.4,15.2 23.5,15.2 0.6,0 1,-0.7 1,-1.3 0,-0.1 -1.4,-4 -1.5,-4.2 l -0.1,-0.8 -3.1,-9.7 -2.9,-9.3 -4.7,-15.7 c -0.6,-0.8 -1.4,-3.8 -1.8,-5 -0.6,-1.8 -0.5,-4.3 -2.5,-4.3 h -6.8 v -7 h 7.2 c 0.5,0 1,-0.6 1,-1 v -0.4 c 0,-0.6 -0.2,-1.3 -0.8,-1.3 h -7.4 v -4.2 h 4 c 0.7,0 1.5,-0.4 1.5,-1 v -0.6 c 0,-0.7 -0.8,-1 -1.5,-1 h -4 v -4 c 0,-0.6 -0.7,-1 -1.3,-1 -0.8,-0 -1.3,0.6 -1.3,1.4 l 0,0 z m -6.6,24.8 0.4,-0.4 -0.4,-0.2 z"
            }
        ], i["GR.IN.IC.AIR TRAFFIC CONTROL FACILITY"] = a("ATC"), i["GR.IN.IC.PROPANE FACILITY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 98.7,73.1 v 0.2 c 0,1 0.5,1.5 1.5,1.5 0.5,0 1.1,-0.6 1.1,-1.1 0,-0.8 -0.2,-0.8 -0.2,-1.5 -0.5,-0.1 -0.5,-0.2 -1.1,-0.2 h -0.2 c -0.5,0 -1.1,0.6 -1.1,1.1 z m -12.6,58.5 h 28.4 v 3.3 h -28.4 v -3.3 z M 75.8,119 h 48.5 v 3.3 c 0,2 -8.8,7.8 -9.8,7.8 H 85.8 c -1,0 -10,-5.8 -10,-7.6 v -3.5 l 0,0 z m 0,-27.5 c 0,-1.1 7.2,-5.8 8.5,-6.6 2.6,-1.5 7.4,-3.7 11.4,-3.7 h 8.5 c 4.1,0 9.1,2 11.6,3.7 1.3,0.9 8.5,5.4 8.5,6.6 v 4.2 H 75.8 V 91.5 l 0,0 z M 98.2,77.1 c 0.7,0 0.8,0.2 1.5,0.2 h 0.4 c 0.8,0 0.8,-0.2 1.5,-0.2 v 1.8 l 1.2,0.8 -5.5,0 c 0.3,-0.5 0.9,-0.8 0.9,-1.3 l -0,-1.3 0,0 z m -1.1,-4 c 0,-1.4 1.4,-2.4 2.8,-2.4 1.3,0 2.8,0.9 2.8,2 v 1.1 c 0,1.4 -1.6,2.4 -3,2.4 -1,0 -2.6,-1.2 -2.6,-2.4 v -0.7 h -0 z m 12.2,-8.1 h 3.5 v 3.5 h -1.8 v 6.8 c 0.7,0 2.4,0.6 2.4,1.3 v 3.7 H 109.4 V 65.1 z m -22.7,0 h 4.2 V 80.3 H 85.8 v -4.1 c 0.8,-0.2 3.1,-0.8 3.1,-1.5 v -6.1 h -2.2 v -3.5 z m 5.7,0 h 15.5 v 15.3 c -1.6,-0.4 -4.8,-0.9 -4.8,-2.6 v -0.9 c 0,-1.5 0.9,-2.1 0.9,-2.6 v -1.1 c 0,-3.2 -3,-3.2 -3.3,-4.4 h 4.2 v -1.5 h -9.6 v 1.5 h 4.2 v 0.6 c -1.9,0.1 -3.1,1.9 -3.1,4 v 0.6 c 0,1 0.9,2 0.9,2.4 v 1.3 c 0,1.4 -3.4,2.3 -4.8,2.6 V 65.1 l 0,0 z m -7.2,4.8 h 2.2 v 4 c 0,0.8 -2.1,1.2 -2.8,1.3 v 6.8 h 3 c -0.6,0.4 -2.7,1.2 -3.6,1.8 -1.2,0.7 -2.2,1.4 -3.4,2.1 -0.9,0.6 -6.1,4.7 -6.3,4.8 v 31.6 c 0,1.9 3.2,4.4 4.5,5.3 1,0.6 5.8,3.3 5.8,4.1 v 4.8 h 31.2 v -4.8 c 0,-1.6 10,-4.6 10,-10 V 91.1 c 0,-0.9 -5,-4.4 -6,-5.1 -1.2,-0.8 -2.1,-1.4 -3.3,-2.1 -0.9,-0.6 -3.2,-1.4 -3.7,-1.9 h 2.4 v -6.8 c -0.7,-0.2 -2.6,-0.5 -2.6,-1.3 v -4 h 2 V 63.5 H 85.2 v 6.3 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 114.4,134.9 0,-3.3 -28.4,0 0,3.3 z M 75.8,122.5 c 0,1.9 9,7.6 10,7.6 h 28.6 c 1,0 9.8,-5.9 9.8,-7.8 v -3.3 H 75.8 v 3.5 l 0,0 z m 0,-31 v 4.2 h 48.5 V 91.5 c 0,-1.2 -7.2,-5.7 -8.5,-6.6 -2.5,-1.7 -7.5,-3.7 -11.6,-3.7 h -8.5 c -3.9,0 -8.8,2.2 -11.4,3.7 -1.3,0.8 -8.5,5.4 -8.5,6.6 l 0,0 z M 109.4,80.3 h 4.2 v -3.7 c 0,-0.8 -1.7,-1.2 -2.4,-1.3 v -6.8 h 1.8 V 65.1 H 109.4 V 80.3 z M 86.7,68.6 h 2.2 v 6.1 c 0,0.8 -2.3,1.4 -3,1.5 v 4.2 h 5 V 65.1 h -4.2 v 3.5 z m 11.6,9.8 c 0,0.6 -0.6,0.8 -0.9,1.3 l 5.5,-0.1 -1.1,-0.8 V 77.1 c -0.7,0 -0.8,0.2 -1.5,0.2 H 99.8 c -0.8,0 -0.8,-0.2 -1.5,-0.2 l -0,1.3 0,0 z m 2.8,-6.1 c 0.1,0.7 0.2,0.8 0.2,1.6 0,0.5 -0.6,1.1 -1.1,1.1 -1,0 -1.5,-0.5 -1.5,-1.5 v -0.2 c 0,-0.5 0.6,-1.1 1.1,-1.1 h 0.2 c 0.6,0 0.6,0.1 1.1,0.2 z m -3.9,0.9 v 0.7 c 0,1.2 1.6,2.4 2.6,2.4 1.4,0 3,-1 3,-2.4 V 72.7 c 0,-1 -1.6,-2 -2.8,-2 -1.4,0 -2.8,1 -2.8,2.4 z"
            }
        ], i["GR.IN.IC.GOVERNMENT SITE INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 100,67.3 C 90.1122,72.1037 79.3336,77.3992 70,82 c -1.2,0.6 -3.8,1.3 -3.8,2.8 l -0.1,0 0,0.4 c 0,0.6 0.1,0.6 0.2,1.1 0.5,0.1 0.5,0.2 1.1,0.2 l 65,0 c 0.7,0 1.7,-0.6 1.7,-1.1 0,-2.2 -1.7,-2.4 -3.2,-3 C 119.391,76.7575 109.17,71.7941 100,67.3 Z m -0.1,3.4 c 0.2,0 24.5,12 25.9,13 l -51.6,0 0,-0.1 C 75,83 99.7,70.7 99.9,70.7 Z m 31.6,55.6 0,-3 -63.3,0 0,3 z m 2.3,6.4 0,-3 -67.7,0 0,3 z m -6.2,-40.7 2.4,0 0,-3.2 -7.9,0 0,3.2 2.1,0 -0.6,25.5 -1.5,0 0,3.8 7.9,0 0,-3.8 -1.5,0 z m -14.6,-3.2 -7.6,0 0,3.2 2.2,0 -0.9,25.4 -1.3,0 0,3.8 7.6,0 0,-3.8 -1.4,0 -0.7,-25.5 2.1,0 z m -20.8,3.1 2.3,0 0,-3.2 -7.8,0 0,3.2 2.3,0 -0.8,25.4 -1.5,0 0,3.8 7.8,0 0,-3.8 -1.7,0 z m -22.5,25.5 0,3.8 8,0 0,-3.8 -1.5,0 -0.8,-25.5 2.3,0 0,-3.2 -8,0 0,3.2 2.4,0 -0.9,25.5 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 74.1,83.6 h 51.6 C 124.3,82.7 100,70.7 99.8,70.7 99.6,70.7 74.9,83 74.1,83.6 l 0,0 z"
            }
        ], i["GR.IN.IC.MILITARY INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 65.2,93.1 c 0,-0.5 15.6,-11.5 17.3,-12.8 1.5,-1.2 17.3,-12.6 17.4,-12.6 0.6,0 15.9,11.2 17.6,12.5 1.7,1.3 17.3,12.4 17.3,12.9 0,0 -6.1,18.6 -6.7,20.3 -1.2,3.4 -2.2,6.8 -3.4,10.3 -1,3 -2.7,7.2 -3.3,10 H 78.4 c -0.1,-1.7 -5.6,-18 -6.5,-20.4 -0.6,-1.4 -6.6,-20.1 -6.6,-20.1 z m 8.4,38.5 2,6.1 49,0 8.4,-26.4 6.6,-20.5 -39.7,-28.7 -39.6,28.8 13.3,40.6 0,0 z M 100,76.2 c 2.7,2.4 26.6,18.7 26.6,19.6 0,0.8 -4.1,12.7 -4.5,13.4 l -5.6,17.4 -32.5,0 c -0.9,0 -3,-7.4 -3.5,-8.7 -0.6,-1.8 -2.9,-7.8 -2.9,-9.4 L 74.3,98.9 73.5,95.5 100,76.2 z m 30.5,18 c -3.1,-2.1 -30,-22.2 -30.7,-22.2 -0.1,0 -13.8,10.1 -15.2,11.1 -2,1.4 -14.3,10.7 -15.2,10.9 v 0.7 c 0,1 2.9,7 2.9,9.3 l 8.7,26.3 37.7,0 5,-15.7 6.6,-20.4 z m -50.4,3.2 c 0.8,-0.2 8.6,-6.1 10,-7 1.2,-0.8 9.5,-7.1 10,-7.1 0,0 9,6.5 10,7.2 1.2,0.8 9.7,6.5 9.7,7.3 0,1.2 -0.4,2 -0.9,2.7 0,1.6 -2.6,8.7 -3.3,10.6 -0.5,1.4 -2.8,10.1 -3.7,10.1 H 88.1 c -0.7,0 -1.8,-4 -2,-4.8 -0.6,-1.7 -1.2,-3.3 -1.7,-5.1 -0.6,-2.1 -3.1,-8.7 -3.1,-10.3 l -0.3,0.1 -0.9,-3.7 z m -3.2,-0.7 8.8,27 28.2,-0 8.7,-27.2 c -3.2,-1.7 -21.7,-16.3 -22.9,-16.3 -0.3,0 -20.6,15 -22.9,16.6 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 77,96.8 c 2.3,-1.5 22.6,-16.6 22.9,-16.6 1.2,0 19.7,14.6 22.9,16.3 l -8.7,27.2 -28.3,0 -8.8,-27 z m -3.6,-1.3 0.9,3.4 3.4,9.7 c 0,1.5 2.3,7.6 2.9,9.4 0.4,1.3 2.5,8.7 3.5,8.7 l 32.5,-0 5.5,-17.4 c 0.4,-0.6 4.5,-12.6 4.5,-13.4 0,-1 -23.9,-17.2 -26.6,-19.6 L 73.5,95.5 z m 6.7,2 0.9,3.7 0.3,-0.1 c 0,1.6 2.4,8.2 3.1,10.3 0.5,1.8 1.1,3.4 1.7,5.1 0.2,0.8 1.3,4.8 2,4.8 h 23.8 c 1,0 3.3,-8.6 3.7,-10.1 0.6,-1.9 3.3,-9 3.3,-10.6 0.5,-0.7 1,-1.5 1,-2.7 0,-0.8 -8.5,-6.5 -9.7,-7.3 -1,-0.7 -9.9,-7.2 -10,-7.2 -0.5,0 -8.8,6.2 -10,7 -1.3,1 -9.2,6.8 -10,7.1 z m 43.8,17.1 -5,15.7 -37.7,-0 -8.7,-26.3 c 0,-2.3 -2.9,-8.3 -2.9,-9.3 v -0.7 c 1,-0.2 13.2,-9.5 15.2,-10.9 1.4,-1 15.1,-11.1 15.2,-11.1 0.7,0 27.6,20 30.7,22.2 l -6.6,20.4 z M 65.2,93.1 c 0,0 6,18.7 6.6,20.1 1,2.4 6.4,18.7 6.5,20.4 h 43.1 c 0.6,-2.8 2.3,-7 3.3,-10 1.2,-3.5 2.1,-6.8 3.4,-10.3 0.6,-1.7 6.7,-20.2 6.7,-20.3 0,-0.5 -15.6,-11.5 -17.3,-12.9 C 115.8,79 100.5,67.7 99.9,67.7 99.8,67.7 84.1,79.2 82.5,80.3 80.8,81.6 65.2,92.7 65.2,93.1 z"
            }
        ], i["GR.IN.IC.POSTAL SERVICE INFRASTRUCTURE"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 64.3,86.6 99.9,102.1 135.7,86.6 v 31.8 H 64.3 v -31.8 l 0,0 z m 62.5,1.9 c -3.1,1.2 -5.9,2.6 -9,3.9 -2.2,0.9 -17.1,7.7 -18,7.7 -0.5,0 -15.8,-7 -17.8,-7.8 -3,-1.2 -5.9,-2.8 -8.8,-3.9 -2.3,-0.9 -6.8,-3.4 -8.8,-3.8 v -3.2 h 71.5 v 3.2 c -2.1,0.4 -6.6,2.9 -9,3.9 z m -64.1,31.7 h 74.7 V 79.8 H 62.7 v 40.4 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 64.3,86.6 0,31.8 71.5,0 0,-31.8 -35.8,15.5 z m 0,-2 c 2,0.5 6.5,3 8.8,3.8 2.9,1.1 5.8,2.7 8.8,3.9 2,0.8 17.3,7.8 17.8,7.8 0.9,0 15.9,-6.8 18,-7.7 3.1,-1.3 5.9,-2.6 9,-3.9 2.4,-1 6.9,-3.4 9,-3.9 V 81.4 H 64.3 v 3.2 l 0,0 z"
            }
        ], i["GR.IN.IC.POSTAL DISTRIBUTION CENTER"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 64.3,94.6 99.9,110.1 135.7,94.6 V 126.4 H 64.3 l 4e-4,-31.8 0,0 z m 62.5,1.9 c -3.1,1.2 -5.9,2.6 -9,3.9 -2.2,0.9 -17.1,7.7 -18.1,7.7 -0.5,0 -15.7,-6.9 -17.8,-7.8 -3,-1.2 -5.9,-2.8 -8.8,-3.9 -2.3,-0.9 -6.8,-3.4 -8.8,-3.9 v -3.2 h 71.5 v 3.2 c -2.1,0.5 -6.6,2.9 -9,3.9 z M 62.7,128.2 h 74.7 V 87.8 H 62.7 v 40.5 z m 66.1,-54.4 -5.4,0 0,13.3 -2,0 0,-13.3 -5.4,0 0,-1.8 12.8,0 0,1.8 m -14,9 c -1e-5,0.6 -0.1,1.2 -0.4,1.7 -0.3,0.6 -0.7,1.1 -1.1,1.5 -0.5,0.4 -1.2,0.8 -1.9,1 -0.7,0.2 -1.6,0.4 -2.6,0.4 -1.1,0 -2.1,-0.1 -2.9,-0.3 -0.9,-0.2 -1.8,-0.5 -2.7,-0.9 l 0,-2.5 0.1,0 c 0.8,0.6 1.6,1.1 2.7,1.5 1,0.3 1.9,0.5 2.8,0.5 1.2,10e-7 2.2,-0.2 2.9,-0.7 0.7,-0.5 1,-1.1 1,-1.9 -1e-5,-0.7 -0.2,-1.2 -0.5,-1.5 -0.3,-0.3 -0.8,-0.6 -1.5,-0.7 -0.5,-0.1 -1.1,-0.2 -1.7,-0.3 -0.6,-0.1 -1.2,-0.2 -1.9,-0.3 -1.3,-0.3 -2.3,-0.8 -3,-1.5 -0.6,-0.7 -1,-1.6 -1,-2.7 0,-1.3 0.5,-2.3 1.6,-3.1 1.1,-0.8 2.4,-1.2 4.1,-1.2 1.1,1.6e-5 2,0.1 2.9,0.3 0.9,0.2 1.7,0.5 2.4,0.8 l 0,2.4 -0.1,0 c -0.6,-0.5 -1.3,-0.9 -2.3,-1.2 -0.9,-0.3 -1.9,-0.5 -2.9,-0.5 -1.1,1.3e-5 -1.9,0.2 -2.6,0.7 -0.7,0.4 -1,1 -1,1.7 -1e-5,0.6 0.2,1.1 0.5,1.5 0.3,0.4 0.9,0.6 1.7,0.8 0.4,0.1 1,0.2 1.8,0.3 0.8,0.1 1.5,0.3 2,0.4 1.1,0.3 2,0.7 2.5,1.4 0.6,0.6 0.9,1.4 0.9,2.5 m -14.4,4.3 -6,0 0,-1.5 2,0 0,-12 -2,0 0,-1.5 6,0 0,1.5 -2,0 0,12 2,0 0,1.5 m -8.6,-7.5 c -1.5e-5,1.4 -0.3,2.6 -0.9,3.7 -0.6,1.1 -1.4,2 -2.4,2.6 -0.7,0.4 -1.5,0.7 -2.3,0.9 -0.8,0.2 -2,0.3 -3.4,0.3 l -3.8,0 0,-15.1 3.8,0 c 1.5,1.5e-5 2.6,0.1 3.5,0.3 0.9,0.2 1.6,0.5 2.2,0.9 1,0.6 1.8,1.5 2.4,2.6 0.6,1.1 0.9,2.3 0.9,3.8 m -2.1,-0 c -1.2e-5,-1.2 -0.2,-2.2 -0.6,-3 -0.4,-0.8 -1,-1.5 -1.8,-1.9 -0.6,-0.3 -1.2,-0.6 -1.9,-0.7 -0.7,-0.1 -1.5,-0.2 -2.4,-0.2 l -1.9,0 0,11.7 1.9,0 c 1,2e-6 1.8,-0.1 2.5,-0.2 0.7,-0.1 1.4,-0.4 2,-0.8 0.8,-0.5 1.3,-1.1 1.7,-1.9 0.4,-0.8 0.6,-1.8 0.6,-2.9"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 126.8,96.5 c -3.1,1.2 -5.9,2.6 -9,3.9 -2.2,0.9 -17.1,7.7 -18.1,7.7 -0.5,0 -15.7,-6.9 -17.8,-7.8 -3,-1.2 -5.9,-2.8 -8.8,-3.9 -2.3,-0.9 -6.8,-3.4 -8.8,-3.9 v -3.2 h 71.5 v 3.2 c -2.1,0.5 -6.6,2.9 -9,3.9 z m -62.5,-1.9 35.6,15.5 35.8,-15.5 V 126.4 H 64.3 l 4e-4,-31.8 0,0 z"
            }
        ], i["GR.IN.IC.POST OFFICE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 74.7,92.8 24.9,10.8 L 124.7,92.8 V 115.1 H 74.7 V 92.8 l 0,0 z m 43.7,1.3 c -2.2,0.9 -4.1,1.8 -6.3,2.7 -1.5,0.6 -12,5.4 -12.6,5.4 -0.4,0 -11,-4.9 -12.5,-5.4 -2.1,-0.8 -4.1,-1.9 -6.2,-2.7 -1.6,-0.6 -4.8,-2.4 -6.2,-2.7 v -2.2 h 50 v 2.3 c -1.5,0.3 -4.6,2 -6.3,2.7 z M 73.6,116.4 H 125.8 V 88.1 H 73.6 V 116.4 z M 99.8,64.3 c 0.2,0 35.5,19.8 37.1,21.2 h -4.8 v 38.6 h -63.9 v -38.6 h -4.9 c 1.6,-1.4 6.9,-4.1 9.1,-5.3 3.1,-1.8 6,-3.4 9.1,-5.3 1.6,-1 18.3,-10.6 18.4,-10.6 z m -43.3,23.1 9.9,-0.2 v 38.4 h 67.4 v -38.4 l 9.9,0.2 c -0.5,-0.6 -43.6,-25 -43.9,-25 -0,0 -19.5,11.4 -21.7,12.5 -3.5,1.8 -7.4,4.2 -10.9,6.2 -2.7,1.6 -8.8,4.6 -10.8,6.3 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "M 99.8,64.3 C 99.8,64.3 83.1,73.9 81.5,74.9 c -3,1.8 -6,3.5 -9.1,5.3 -2.2,1.2 -7.5,4 -9.1,5.3 l 4.9,0 0,38.6 63.9,0 0,-38.7 4.8,0 c -1.6,-1.4 -36.9,-21.2 -37.1,-21.2 z M 73.6,88.1 l 52.3,0 0,28.3 -52.3,0 0,-28.3 z m 44.9,6.1 c -2.2,0.9 -4.1,1.8 -6.3,2.7 -1.5,0.6 -12,5.4 -12.6,5.4 -0.4,0 -11,-4.9 -12.5,-5.4 -2.1,-0.8 -4.1,-1.9 -6.2,-2.7 -1.6,-0.6 -4.8,-2.4 -6.2,-2.7 v -2.2 h 50 v 2.3 c -1.5,0.3 -4.6,2 -6.3,2.7 z M 74.7,92.8 99.6,103.7 124.7,92.8 V 115.1 H 74.7 V 92.8 l 0,0 z"
            }
        ], i["GR.IN.IC.ENCLOSED FACITLITY (PUBLIC VENUE)"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 114.9,121.3 0,-1.2 -30.7,0 0,1.2 z m -31.9,-2.5 -10.4,-16.7 -1,0.4 10.6,16.6 z m 13,-13.8 h 7 c 0.6,0 4.4,-6 5,-6.8 H 91 c 0.6,0.9 4.4,6.8 5,6.8 z m 15.3,12 0,-1 -23.5,0 0,1 z m 2.4,-1.6 8.6,-13.6 -0.8,-0.4 -8.5,13.3 z M 76.8,101.9 c 0,0.3 3.7,5.9 4.2,6.7 0.4,0.6 4.2,6.7 4.3,6.7 0.4,0 0.5,-0.2 0.7,-0.5 l -8.5,-13.4 c -0.2,0.1 -0.7,0.2 -0.7,0.5 z m 31,10.8 0,-1 -16.5,0 0,1 z m -19.3,-1.2 0.7,-0.4 -6.7,-10.5 -0.7,0.4 z m 22.3,-0 6.4,-10.5 -0.8,-0.3 -6.6,10.5 z m -6.4,-3 0,-1 -9.7,0 0,1 z m 2.8,-1.8 c 0,0.6 0.3,0.6 0.7,0.6 l 4.2,-6.9 -0.6,-0.4 c -0.2,0.2 -4.3,6.6 -4.3,6.7 z m -20.3,-6.3 4.1,7 c 0.3,-0.1 0.8,-0.2 0.8,-0.5 0,-0.6 -3.7,-5.6 -4,-6.9 l -1,0.4 z m -19.7,18 0.3,-2.8 c 0.1,-3.9 2,-11.4 3,-14.6 1.6,-4.7 3.2,-8.3 5.6,-12 4.4,-6.5 12,-12.4 22.8,-12.4 h 1.1 c 9.6,0 17,4.8 21.3,10.2 1.2,1.5 2.3,2.8 3.2,4.6 0.5,0.9 1,1.6 1.4,2.6 0.4,0.9 0.7,1.9 1.1,2.7 0.8,1.4 3.6,10.3 3.6,12.1 v 0.6 h 0.3 v 1 l 1.2,10.8 -0.1,2.2 H 67 l 0.2,-5 0,0 z m -2.3,-4 -0.3,2.4 -0.4,5.6 v 3.8 h 70.9 v -1 c 0,-2 0.1,-6.4 -0.2,-8.1 -0.4,-2.4 -0.5,-5.2 -1,-7.5 -0.4,-2 -2.9,-12.7 -3.9,-13.1 0,-1.6 -3.5,-7.6 -4.3,-8.8 -1.8,-2.6 -3.8,-5 -6.2,-7 -4.9,-3.9 -10.5,-7 -19.3,-7 h -1 c -11.8,0 -19.6,5.9 -24.6,12.8 -1.4,1.9 -2.4,3.8 -3.5,5.9 -1.2,2.3 -1.7,4.2 -2.6,6.7 -1.2,3 -3.4,11.4 -3.5,15.3 l 0,0 z m 52.2,4.7 c 0.4,-1.3 4.2,-6.6 5.2,-8.3 0.6,-1 5.1,-7.9 5.1,-8.2 0,-0.3 -0.6,-0.4 -0.8,-0.5 l -10.6,16.6 1.1,0.4 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 84.2,120.1 h 30.7 v 1.2 H 84.2 v -1.2 z m 3.6,-4.2 h 23.5 v 1 H 87.8 v -1 z m 3.5,-4.2 h 16.5 v 1 H 91.4 v -1 z m 3.3,-4.2 h 9.7 v 1 h -9.7 v -1 z m 22.4,11.5 -1.1,-0.4 10.6,-16.6 c 0.3,0.1 0.8,0.2 0.8,0.5 0,0.3 -4.6,7.2 -5.1,8.2 -1,1.8 -4.9,7 -5.2,8.3 z m -45.4,-16.6 1,-0.4 10.4,16.7 -0.8,0.4 -10.6,-16.6 z m 13.7,12.8 c -0.2,0 -4,-6 -4.3,-6.7 -0.5,-0.8 -4.2,-6.3 -4.2,-6.6 0,-0.3 0.4,-0.4 0.7,-0.5 l 8.5,13.3 c -0.2,0.3 -0.2,0.5 -0.7,0.5 z m 36.2,-13.8 0.8,0.4 -8.6,13.6 -0.8,-0.6 8.6,-13.4 z m -5.1,-0.6 0.8,0.3 -6.4,10.5 -1,-0.3 6.6,-10.5 z m -33.9,-0 6.7,10.5 -0.7,0.4 -6.7,-10.5 0.7,-0.4 z m 24.7,6 c 0,-0.1 4.1,-6.5 4.3,-6.7 l 0.6,0.4 -4.2,6.9 c -0.4,0 -0.7,-0.1 -0.7,-0.6 z m -19.4,-6.7 c 0.3,1.3 4,6.3 4,6.9 0,0.3 -0.6,0.4 -0.8,0.5 l -4.1,-7 1,-0.4 z m 8.2,4.9 c -0.6,0 -4.4,-6 -5,-6.8 h 17 c -0.6,0.8 -4.4,6.8 -5,6.8 h -7 z m -28.5,10.7 c 0,0.5 -0,2.8 -0.3,2.8 l -0.2,5 h 65.2 l 0.1,-2.2 -1.2,-10.8 v -1 h -0.3 v -0.6 c 0,-1.8 -2.8,-10.6 -3.6,-12.1 -0.4,-0.8 -0.7,-1.8 -1.1,-2.7 -0.5,-1 -1,-1.6 -1.5,-2.6 -0.9,-1.8 -2,-3.1 -3.2,-4.6 -4.2,-5.4 -11.6,-10.2 -21.3,-10.2 h -1 c -10.8,0 -18.5,5.8 -22.8,12.4 -2.5,3.8 -4.1,7.4 -5.7,12 -1.1,3.2 -3,10.7 -3,14.6 l 0,0 z"
            }
        ], i["GR.IN.IC.OPEN FACILITY (OPEN VENUE)"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 122.4,117.1 0,-1.5 -45.1,0 0,1.5 z M 74.5,114 75.6,113.4 59.8,88.8 58.8,89.4 z m 49.6,-0.6 c 0.2,0.1 1,0.5 1.3,0.5 0.2,0 14.4,-22.4 15.9,-24.6 l -1.5,-0.5 -15.7,24.6 z m -6.6,-2.6 0,-1.7 -35,0 0,1.7 z m 2.4,-3.2 c 0,0.2 1,0.8 1.1,0.9 l 12.8,-20 h 0.2 l -1.6,-0.8 c -1.3,2.4 -12.6,19.3 -12.6,20 z m -41.1,0.9 1.4,-0.8 -12.7,-20.1 -1.3,0.8 z m 33.3,-3.9 0,-1.6 -24.4,0 0,1.6 z m 3.4,-2.8 c 0,0.6 0.6,0.7 1.1,0.9 l 9.6,-15.4 -1.2,-0.6 c -0.6,2 -9.4,14.5 -9.4,15.2 z m -32.2,1 1.4,-0.6 -9.7,-15.5 -1.3,0.8 z m 23.4,-4.5 0,-1.7 -13.8,0 0,1.7 z m 5.6,-1.7 6.4,-10.3 -1.2,-0.5 -6.6,10.2 z m -24.6,0.1 1.1,-0.8 -6.5,-10.2 -1.3,0.6 z m 6.6,-4 11,0.1 c 0.6,0 6.4,-8.9 7,-10 H 87.3 l 6.9,9.9 z"
            }
        ], i["GR.IN.IC.RELIGIOUS INSTITUTION"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 101.2,68.1 c 7.9,0 18,3.8 21.7,8 5,5.7 7,12.3 7,22.8 V 131.9 H 101.2 V 68.1 z M 70.1,96.3 c 0,-8.4 3.4,-16.4 7.7,-20.7 3.9,-3.9 13.2,-7.5 20.9,-7.5 v 63.9 H 70.1 V 96.3 z m -2.6,38.3 h 65 V 99.3 c 0,-10.8 -2.5,-19.7 -8.1,-25.2 -4.8,-4.8 -15,-8.7 -24.6,-8.7 -8.3,0 -19.4,3.7 -23.6,7.9 -3.2,3.3 -4.3,5 -6.2,9.5 -1,2.4 -2.5,10 -2.5,13.2 v 38.5 l 0,0 z M 105.1,97.6 v 12.5 c 0,0.5 0.6,1.1 1.1,1.1 h 0.4 c 0.7,0 1.1,-0.8 1.1,-1.5 V 97.8 c 0,-0.5 -0.6,-1.1 -1.1,-1.1 H 106 c -0.5,0 -0.9,0.4 -0.9,0.9 z m -11.2,13.6 c 0.8,0 0.9,-1 0.9,-1.7 V 97.6 c 0,-0.5 -0.4,-0.9 -0.9,-0.9 h -0.6 c -0.5,0 -0.9,0.4 -0.9,0.9 v 12.5 c 0,0.5 0.6,1.1 1.1,1.1 h 0.4 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 105.1,97.6 c 0,-0.5 0.4,-0.9 0.9,-0.9 h 0.7 c 0.5,0 1.1,0.6 1.1,1.1 v 11.8 c 0,0.7 -0.4,1.5 -1.1,1.5 h -0.5 c -0.5,0 -1.1,-0.6 -1.1,-1.1 V 97.6 h 0 z m -3.9,34.4 h 28.7 V 98.9 c 0,-10.5 -2,-17.1 -7,-22.8 C 119.2,71.9 109.1,68.1 101.2,68.1 v 63.9 z M 94,111.2 H 93.5 c -0.5,0 -1.1,-0.6 -1.1,-1.1 V 97.6 c 0,-0.5 0.4,-0.9 0.9,-0.9 h 0.7 c 0.5,0 0.9,0.4 0.9,0.9 v 11.8 c 0,0.8 -0.1,1.8 -0.9,1.8 z M 70.1,96.3 v 35.7 H 98.8 V 68.1 c -7.7,0 -17,3.6 -20.9,7.5 -4.3,4.3 -7.7,12.3 -7.7,20.7 z"
            }
        ], i["GR.IN.IC.CHILD DAY CARE"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 76.6,100.3 c 0,1.8 1.1,3.4 3,3.4 h 0.6 c 1.4,0 2.4,-1.5 2.4,-3 0,-4.3 -6,-4.2 -6,-0.4 z m 26.5,-11.9 v 0.4 c 0,1.5 1.4,3.2 2.8,3.2 h 0.4 c 1.6,0 3,-1.2 3,-2.8 V 87.8 c 0,-1 -1.6,-2 -2.8,-2 h -0.2 c -1.5,-0 -3.2,1.4 -3.2,2.6 z m -3.2,-16.8 35.4,21.7 c -1.3,0.2 -4.6,-0.3 -4.6,0.9 v 34.9 H 69.3 V 94.1 c 0,-1.2 -3.3,-0.8 -4.6,-0.9 l 35.2,-21.7 0,0 z m -39.8,22.4 c 0.2,0.8 0.3,1.3 1.3,1.3 h 6.2 v 34.6 c 0,0.5 0.1,0.5 0.2,0.9 h 64 c 0.4,0 0.8,-0.3 0.8,-0.8 V 95.2 h 6 c 0.8,0 1.3,-0.4 1.3,-1.1 0,-0.6 -17.8,-11.2 -19.8,-12.5 -1.6,-1 -20,-12.3 -20,-12.3 -0.2,0 -36.7,22.5 -40,24.7 l 0,0 z m 20.9,14.2 5.9,4.3 -0.1,0.1 -4.8,2.2 c -0.2,-0.8 -1,-1.9 -1,-2.5 v -4.1 z m 28.4,-8.8 c 0.5,-0.8 0.6,-2.9 1,-3.1 0.4,-0.2 2.4,0.8 2.9,0.9 v 3.6 l -4.4,1.7 v -0.6 c -0,-0.9 0.5,-1 0.5,-2.4 z m -3,2 c 0,0.9 0,1.1 -0.4,1.7 V 104 c -2.4,0.2 -15.4,7.5 -17,7.5 -0.5,0 -6.5,-6.7 -7.3,-6.7 h -4.3 c -0.5,0 -2.8,5.2 -2.8,5.6 v 4.7 c 0,0.9 1.8,1.4 2,2.4 l -4.1,1.7 1.3,2.6 6.2,-2.8 c 1.5,0.8 9.3,5.6 10.5,5.6 h 0.6 c 0.8,0 1.9,-0.8 1.9,-1.5 v -0.4 c 0,-0.9 -7.3,-4.8 -8.4,-5.8 l 14,-6.3 v 8.4 h -3 v 6.7 h 8.4 v -6.7 h -2.8 v -9.9 l 13.2,-5.8 c 0,1.6 0.2,3.7 0.4,5.1 0.2,1.8 -0.6,3.9 1.5,3.9 2.1,0 1.3,-2.5 1.3,-4.3 0,-1.9 -0.2,-3.5 -0.2,-5.6 v -0.6 l 9.1,-4 -1,-2.9 -6.2,2.8 c 0.3,-0.6 0.7,-0.8 1,-1.4 0.2,-0.7 0.4,-1.2 0.7,-1.8 0.5,-1 0.9,-2.6 1.4,-3.4 l -11.4,-1.6 c -0.6,0.5 -3.2,3.3 -3.2,4.2 v 0.6 h -0.4 l -1.1,7.1 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 81,112.2 c 0,0.6 0.8,1.7 1,2.5 l 4.8,-2.2 0.2,-0.1 -6,-4.3 v 4.1 z m 28.4,-12.9 c 0,1.4 -0.6,1.6 -0.6,2.4 v 0.6 l 4.5,-1.7 v -3.6 c -0.5,-0.1 -2.6,-1 -2.9,-0.9 -0.4,0.2 -0.5,2.4 -1,3.1 z m -32.9,0.9 c 0,-3.9 6,-4 6,0.4 0,1.4 -1.1,3 -2.4,3 h -0.5 c -1.8,0 -3,-1.6 -3,-3.4 z m 29.5,2.8 0.4,-1.7 1.1,-7.1 h 0.4 v -0.6 c 0,-0.8 2.6,-3.7 3.2,-4.2 l 11.4,1.6 c -0.5,0.8 -0.9,2.4 -1.4,3.4 -0.3,0.6 -0.4,1.1 -0.7,1.8 -0.3,0.7 -0.7,0.8 -1,1.4 l 6.2,-2.8 1,2.9 -9.1,4 v 0.6 c 0,2.1 0.2,3.7 0.2,5.6 0,1.8 0.8,4.3 -1.3,4.3 -2.1,0 -1.3,-2.2 -1.5,-3.9 -0.2,-1.4 -0.4,-3.5 -0.4,-5.1 l -13.2,5.8 v 9.9 h 2.8 v 6.7 h -8.4 v -6.7 h 3 v -8.4 l -14,6.3 c 1.1,0.9 8.4,4.9 8.4,5.8 v 0.4 c 0,0.7 -1,1.5 -1.9,1.5 H 90.6 c -1.2,0 -8.9,-4.8 -10.5,-5.6 l -6.2,2.8 -1.3,-2.6 4.1,-1.7 c -0.3,-1 -2,-1.5 -2,-2.4 v -4.6 c 0,-0.4 2.3,-5.6 2.8,-5.6 h 4.3 c 0.8,0 6.8,6.7 7.3,6.7 1.5,0 14.6,-7.3 17,-7.5 v -0.9 z m -3,-14.8 c 0,-1.2 1.7,-2.6 3.2,-2.6 h 0.2 c 1.2,0 2.8,1.1 2.8,2 v 1.3 c 0,1.6 -1.4,2.8 -3,2.8 h -0.4 c -1.4,0 -2.8,-1.7 -2.8,-3.2 v -0.4 z m -38.4,4.9 c 1.3,0.1 4.6,-0.3 4.6,0.8 v 34.9 h 61.4 V 94.1 c 0,-1.2 3.3,-0.8 4.6,-0.9 l -35.4,-21.7 -35.2,21.8 0,0 z"
            }
        ], i["GR.IN.IC.HELICOPTER LANDING SITE"] = [
            {
                type: "path",
                stroke: o,
                d: "M80,70 l10,10 M120,110 l-10,-10 M80,110 l10,-10 M120,70 l-10,10 M100,115 l0,20 M95,135 l10,0",
                fill: !1
            },
            {
                type: "path",
                stroke: o,
                fill: !!R && G,
                d: "m 113,90 c -0.3,8.8 -1.9,20.3 -10.8,24.6 -7.7,2 -12.3,-7.1 -13.8,-13.3 -2.6,-11.5 -2.3,-26 6.9,-34.6 6.0,-4.9 13.1,1.9 14.9,7.8 2,4.9 2.8,10.2 2.8,15.5 z"
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 40
            }
        ], i["GR.IN.IC.TRANSPORTATION INFRASTRUCTURE LOCK"] = [
            {
                type: "path",
                fill: !1,
                d: "m 70,70 65,30 -65,30"
            }
        ], i["GR.IN.IC.TRANSPORTATION INFRASTRUCTURE SHIP ANCHORAGE"] = [
            {
                type: "path",
                fill: !1,
                stroke: "rgb(255, 0, 255)",
                d: "m 73.6,112.8 c 0.8,8 26.4,11.2 26.4,11.2 0,0 25.6,-3.2 26.4,-11.2 M 80,88 l 40,0 m -20,-12 0,48"
            }
        ], i["GR.IN.IC.NATURAL GAS FACILITY"] = [
            {
                type: "path",
                fill: !1,
                d: "m 100,60.5 c -16.4,0 -29.6,13.2 -29.6,29.6 0,12.8 8.3,23.9 19.7,27.8 l 0,19.7 c 3.2,1.2 6.3,1.8 9.9,1.8 3.6,0 6.7,-0.6 9.9,-1.8 l 0,-19.8 c 11.5,-3.9 19.8,-15 19.7,-27.8 0,-16.4 -13.2,-29.6 -29.6,-29.6 z"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 103,
                fontsize: 35,
                text: "NG"
            }
        ], i["GR.IN.IC.TOLL FACILITY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 69.1,112.3 c 0,-0.7 0.8,-1.7 1.4,-1.7 h 0.5 c 0.8,0 1.5,0.8 1.5,1.5 v 1.2 c 0,0.5 -0.9,1.2 -1.5,1.2 h -0.2 c -0.8,0 -1.7,-0.8 -1.7,-1.4 v -0.9 l 0,0 z m -1.1,0.5 v 0.3 c 0,1.2 1.5,2.6 2.9,2.6 1.3,0 2.8,-1.5 2.8,-2.5 v -1 c 0,-1.2 -1.4,-2.6 -2.8,-2.6 -1.7,0 -2.9,1.6 -2.9,3.2 z m 27.6,-11.6 -2,-2.8 -2.3,0 4.3,2.8 z m -29.5,17.8 c 0,-0.5 0.8,-0.9 1.4,-0.9 H 99.1 c 0.8,0 1.3,0.6 1.4,1.4 -0.6,0.1 -1,0.3 -1.7,0.3 H 68 c -0.6,0 -1.8,0 -1.8,-0.6 v -0.2 z m 9.4,-10.2 15.1,0 8.2,0.2 c 0.5,0.9 2,3 1.8,4.3 l -0.2,2.6 c -0.5,0.2 -0.5,0.3 -1,0.3 H 67.1 c -0.6,0 -0.5,-0.2 -1.1,-0.3 -0.1,-0.7 -0.3,-1 -0.3,-1.8 v -0.6 c 0,-1.1 1.5,-3.5 2,-4.4 l 7.8,-0.2 z m -5.8,-2 c 0.1,-1.1 3.5,-7.1 4.3,-7.1 h 18.4 c 1,0 4,5.8 4.3,7.1 H 69.7 z m 21.7,-8.4 2.3,-0 2,2.8 -4.3,-2.8 z m 44.3,27.8 V 73.8 c -1,0.2 -10.3,6 -11.9,7 -1.3,0.8 -11.6,6.5 -11.6,7.2 0,0 1.3,2.1 1.4,2.3 l 4.9,-2.8 v 19.2 l -0.4,0.3 c -2.9,-2 -33.4,-22 -33.6,-22 -0.1,0 -3.9,5.6 -4,6.2 l 10.8,7 -18.3,0 c -0.9,1.4 -1.9,2.4 -2.8,3.8 -0.2,0.3 -2,4.4 -2,4.6 v 0.8 h -1.2 c -0.1,0.9 -2.6,4.6 -2.6,5.4 v 0.8 c 0,1.5 0.4,2.9 1.4,3.4 -0.2,0.3 -1,1.1 -1,1.6 v 0.9 c 0,1.1 1.5,1.5 2.6,1.5 v 2.3 l 0.2,2 c 0.5,0.2 0.3,0.5 1.2,0.6 0.6,0.1 1,0.2 1.7,0.2 h 1.1 l 1.7,-0.2 0.3,-0.3 0.2,-2 0,-2.5 h 19.1 v 3.1 c 0,0.8 0.3,1.2 0.6,1.7 l 1.4,0.2 1.2,-0 c 1.7,0 3.1,-0.1 3.1,-1.8 v -3.1 c 0.8,-0.2 2.6,-0.5 2.6,-1.4 v -1.7 c 0,-0.5 -0.5,-0.7 -0.9,-0.8 0.1,-0.5 1.2,-1.1 1.2,-2.5 v -2 c 0,-1.5 -2.1,-4.1 -2.5,-5.4 h -1.2 v -0.4 c 0,-1.1 -2.2,-4.8 -2.5,-5.8 l 19,12.5 c -0.4,1.6 -2,4 -2,5.2 v 7.2 h 22.9 l 0,0 z M 95.9,114.6 H 95.7 c -1.1,0 -1.8,-0.7 -1.8,-1.7 v -0.5 c 0,-1 0.6,-1.8 1.5,-1.8 h 0.5 c 1,0 1.5,1.1 1.5,2 0,1.1 -0.5,2 -1.5,2 z m -3.1,-2.5 v 1.1 c 0,1 1.6,2.5 2.9,2.5 1.4,0 2.6,-1.3 2.6,-2.8 v -0.8 c 0,-1.2 -1.3,-2.6 -2.5,-2.6 H 95.7 c -1.4,0 -2.9,1.4 -2.9,2.6 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 114.5,107.9 c 0,0.9 -0.8,1.6 -1.8,1.6 -1,0 -1.8,-0.7 -1.8,-1.6 0,-0.9 0.8,-1.6 1.8,-1.6 1,0 1.8,0.7 1.8,1.6 z m -11.2,-7.2 c 0,0.9 -0.8,1.6 -1.8,1.6 -1,0 -1.8,-0.7 -1.8,-1.6 0,-0.9 0.8,-1.6 1.8,-1.6 1,0 1.8,0.7 1.8,1.6 z m -5.5,-3.7 c 0,0.9 -0.8,1.6 -1.8,1.6 -1,0 -1.8,-0.7 -1.8,-1.6 0,-0.9 0.8,-1.6 1.8,-1.6 1,0 1.8,0.7 1.8,1.6 z M 108.9,104.5 c 0,0.9 -0.8,1.6 -1.8,1.6 -1,0 -1.8,-0.7 -1.8,-1.6 0,-0.9 0.8,-1.6 1.8,-1.6 1,0 1.8,0.7 1.8,1.6 z M 92.3,93.5 c 0,0.9 -0.8,1.6 -1.8,1.6 -1,0 -1.8,-0.7 -1.8,-1.6 0,-0.9 0.8,-1.6 1.8,-1.6 1,0 1.8,0.7 1.8,1.6 z M 86.5,89.8 c 0,0.9 -0.8,1.6 -1.8,1.6 -1,0 -1.8,-0.7 -1.8,-1.6 0,-0.9 0.8,-1.6 1.8,-1.6 1,0 1.8,0.7 1.8,1.6 z m 35.6,2.6 10.8,0 0,16.1 -10.8,0 z m -55.9,26.4 v 0.2 c 0,0.6 1.2,0.6 1.8,0.6 h 30.8 c 0.7,0 1.1,-0.2 1.7,-0.3 -0.1,-0.8 -0.6,-1.4 -1.4,-1.4 H 67.5 c -0.5,0 -1.4,0.4 -1.4,0.9 z m 26.6,-6.8 c 0,-1.2 1.5,-2.6 2.9,-2.6 h 0.2 c 1.2,0 2.5,1.4 2.5,2.6 v 0.8 c 0,1.4 -1.2,2.8 -2.6,2.8 -1.4,0 -2.9,-1.4 -2.9,-2.5 v -1 h -0 z m -24.8,0.6 c 0,-1.6 1.2,-3.2 2.9,-3.2 1.3,0 2.8,1.5 2.8,2.6 v 1.1 c 0,0.9 -1.4,2.5 -2.8,2.5 -1.4,0 -2.9,-1.4 -2.9,-2.6 v -0.3 z m -0.3,-3.8 c -0.5,1 -2,3.4 -2,4.4 v 0.6 c 0,0.9 0.2,1.1 0.3,1.8 0.5,0.1 0.5,0.3 1.1,0.3 h 32.3 c 0.6,0 0.5,-0.2 1,-0.3 l 0.2,-2.6 c 0.1,-1.2 -1.4,-3.4 -1.8,-4.3 l -8.2,-0.2 -15.1,-0 -7.8,0.2 z m 2,-2.2 h 27.1 c -0.4,-1.3 -3.3,-7.1 -4.3,-7.1 H 74 c -0.8,0 -4.2,6 -4.3,7.1 z m 26.2,7.8 c 1.1,0 1.5,-0.9 1.5,-2 0,-0.9 -0.6,-2 -1.5,-2 h -0.5 c -1,0 -1.5,0.8 -1.5,1.8 v 0.5 c 0,1 0.8,1.7 1.8,1.7 h 0.2 l 0,0 z M 69.1,112.3 v 0.9 c 0,0.6 1,1.4 1.7,1.4 h 0.2 c 0.6,0 1.5,-0.8 1.5,-1.2 v -1.2 c 0,-0.8 -0.8,-1.5 -1.5,-1.5 h -0.5 c -0.6,0 -1.4,1 -1.4,1.7 z"
            }
        ], i["GR.IN.IC.TRAFFIC INSPECTION FACILITY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 121.4,81.7 h 1.1 v 0.6 c 0,0.6 0.8,2.1 1.2,2.4 0.5,0.4 1.9,0.9 2.7,0.9 2.6,0 3.9,-1.9 3.9,-4.5 v -0.5 h -7.4 c -0.5,0 -1.2,0.8 -1.4,1.1 z m -22.6,23.5 c 0,-1.7 1.7,-3 3.4,-3 1.7,0 3.1,1.4 3.1,3.1 v 0.6 c 0,1.3 -1.7,2.6 -3.1,2.6 -1.7,0 -3.4,-1.3 -3.4,-3 v -0.5 z m -29.7,0 c 0,-1.8 1.3,-3 3.1,-3 1.7,0 3.3,1.4 3.3,3.1 v 0.3 c 0,1.6 -1.6,3 -3.4,3 -1.5,0 -3,-1.2 -3,-2.6 v -0.8 z m 3.7,-7 c 0,-0.4 1.6,-4.2 1.9,-5 0.6,-1.7 0.9,-3.6 3.3,-3.6 H 96.5 c 2.8,0 2.2,1.8 3.2,3.6 0.2,0.4 1.8,4.5 1.8,4.9 H 72.8 z m -3.7,1 c -2.1,0 -3.7,1.5 -3.7,3.6 v 9.2 c 0,1 1.7,2.3 3.1,2.3 v 5.3 c 0,1.8 1.3,3.3 3.3,3.3 1.4,0 3.1,-1.6 3.1,-2.6 v -5.9 h 24.8 v 6.2 c 0,1 1.7,2.3 3,2.3 h 0.2 c 1.4,0 3.1,-1.3 3.1,-2.6 v -5.9 c 1.9,0 3.3,-1.4 3.3,-3.3 v -8.1 c 0,-2 -1.4,-3.3 -3.2,-3.7 -1.4,-0.2 -1.1,-0.8 -1.6,-1.9 -0.4,-0.8 -0.7,-1.6 -1,-2.4 -1.2,-2.6 -2.2,-8.2 -5.6,-8.2 h -21.2 c -2.9,0 -3.5,3.3 -4.5,5.5 -0.6,1.4 -2.7,5.8 -3,7 z m 56.5,20.2 0.3,-3.3 0.5,-6.2 h 1.7 l 0.8,12.9 h 5.8 V 88.9 c 0,-0.6 -1.2,-1.9 -2,-1.9 l -0.6,0.1 -9.9,14.6 h 8.4 v 3.6 h -11.2 v 17.6 h 6.1 l -0,-0.8 0.2,-2.6 z m -16.8,-30.8 c 0.2,-0.9 1,-1.5 2,-1.6 v 2.2 h -2 c 0,1.4 0.8,2.2 2.2,2.2 v -2 h 2 c -0,1.3 -0.8,1.4 -1.4,2 h 7.8 l 0,10.2 10,-14.3 -10.1,-0.2 h -6.4 v -7.6 c 0,-1.2 -0.8,-2.2 -1.9,-2.2 h -0.4 c -2.2,0 -2,2.4 -2,4.7 0,1.3 -0.4,5.8 0.2,6.6 z m 0,0 v 0.6 h 2 v -2.2 c -1.1,0 -1.8,0.7 -2,1.6 z m 2.2,2.8 h 0.6 c 0.6,-0.6 1.4,-0.7 1.4,-2 h -2 v 2 z m 19.3,-12 0,-2 -8.8,-0 1,2 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 130.3,79.4 -7.9,-0 0.4,1.3 7.5,0 z m -8.1,22.2 9.9,-14.6 0.6,-0.1 -3.1,0.2 -10,14.3 -0.1,3.7 11.2,0 0,-3.6 z m -23.3,3.6 v 0.5 c 0,1.7 1.7,3 3.4,3 1.4,0 3.1,-1.4 3.1,-2.6 v -0.6 c 0,-1.7 -1.4,-3.1 -3.1,-3.1 -1.8,0 -3.4,1.3 -3.4,3 z m -29.7,0 v 0.8 c 0,1.4 1.5,2.6 3,2.6 1.8,0 3.4,-1.3 3.4,-3 v -0.3 c 0,-1.6 -1.6,-3.1 -3.3,-3.1 -1.8,0 -3.1,1.2 -3.1,3 z m 3.7,-7 h 28.6 c 0,-0.5 -1.5,-4.5 -1.8,-4.9 -1,-1.8 -0.4,-3.6 -3.2,-3.6 H 77.9 c -2.4,0 -2.6,1.9 -3.3,3.6 -0.2,0.8 -1.8,4.6 -1.8,5 z"
            }
        ], i["GR.IN.IC.TUNNEL"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 94.4,116.8 c 0,-3.5 2.6,-7.2 5.9,-7.2 3.2,0 5.6,4 5.6,7.1 v 0.8 H 94.4 v -0.7 z m 27.2,-4.7 9,-4.2 c 0.2,1.7 0.8,3.2 1,5.2 0.3,1.8 0.6,3.3 0.6,5.6 v 0.5 h -10 l -0.7,-7.1 z m -43.5,4.9 0.1,2.2 H 68 c 0,-1.6 0.3,-3.8 0.6,-5.4 0.1,-0.7 0.2,-1.8 0.5,-2.4 0.1,-0.2 0.7,-2.2 0.7,-2.4 l 9.2,3.1 -0.8,4.9 z m 39,-16.8 6.2,-6.2 c 0.6,1 1.2,1.8 1.9,2.8 0.8,1.1 1.2,2 1.8,3.1 0.6,1 2.8,5.6 2.8,6.9 l -8.7,4.2 c -0.1,-2.5 -3,-9 -4,-10.6 z m -37.9,10.4 -9.1,-3 c 0.1,-1.2 2.4,-5.9 3,-7 1.2,-2.1 3,-4.2 4,-6 l 7.6,4.4 c -0.2,0.5 -2.6,4.3 -3,5.4 -0.8,1.7 -1.6,4.9 -2.4,6.2 z M 111.2,83.2 c 2.8,0.7 9.8,7.1 11.3,9.4 l -6.3,6.2 c -0.5,-1.8 -6,-6.9 -8.2,-7.4 l 3.2,-8.2 z M 78.1,93.4 C 79.7,91 88,83.8 91,83.1 L 94.9,91 c -2.6,0.6 -7.9,5 -9.2,6.9 l -7.6,-4.5 z M 92.6,82.4 c 2.6,-0.6 4.1,-1.8 7.8,-1.8 h 1.4 c 4,0 5.3,1.2 8.1,1.8 -0,1 -1.9,5.2 -2.3,6.3 -0.6,1.4 -0.4,2 -2.2,1.5 -1.1,-0.3 -2.4,-0.6 -3.6,-0.6 h -1 L 96.1,90.3 92.6,82.4 z M 66.5,119.8 H 60.4 c -0.4,0 -0.5,0.1 -0.5,0.5 v 0.2 c 0,0.4 0.1,0.5 0.5,0.5 h 79 c 0.3,0 0.7,-0.3 0.7,-0.5 0,-0.4 -0.3,-0.7 -0.7,-0.7 h -5.7 v -1.5 c 0,-10.1 -4.9,-20.4 -9.5,-25.9 C 119.8,87 111.6,79 102.2,79 h -2 c -9.7,0 -18.8,8.4 -23.6,13.7 -5,5.6 -10.1,16.6 -10.1,27.1 l 0,0 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 79,112 -9.3,-3.1 c -0,0.2 -0.6,2.2 -0.7,2.4 -0.2,0.6 -0.4,1.7 -0.5,2.4 -0.2,1.5 -0.5,3.8 -0.5,5.4 h 10.3 l -0.1,-2.2 0.8,-4.9 z m 15.5,5.4 h 11.4 v -0.8 c 0,-3.1 -2.4,-7.1 -5.6,-7.1 -3.3,0 -5.9,3.8 -5.9,7.2 v 0.7 z m 27.9,1.7 h 10 v -0.5 c 0,-2.3 -0.4,-3.8 -0.6,-5.6 -0.3,-2 -0.9,-3.5 -1,-5.2 l -9,4.2 0.7,7.1 z m -5.2,-19 c 1.1,1.6 4,8.1 4,10.6 l 8.7,-4.2 c 0,-1.2 -2.1,-5.8 -2.8,-6.8 -0.7,-1.1 -1.1,-2 -1.8,-3.1 -0.7,-1 -1.3,-1.8 -1.9,-2.8 l -6.2,6.2 z m -37.9,10.4 c 0.7,-1.4 1.6,-4.5 2.4,-6.2 0.5,-1.1 2.9,-4.9 3,-5.4 l -7.6,-4.4 c -1,1.8 -2.8,4 -4,6 -0.6,1.1 -2.9,5.8 -3,7 l 9.1,3 z m 28.8,-19.1 c 2.1,0.5 7.6,5.6 8.2,7.4 l 6.3,-6.1 c -1.5,-2.3 -8.5,-8.8 -11.3,-9.5 l -3.2,8.2 z m -30,2 7.6,4.6 C 87,96 92.3,91.6 94.9,91 l -3.8,-7.9 c -3.1,0.7 -11.4,7.9 -13,10.3 z M 92.6,82.4 l 3.5,7.9 4.6,-0.6 h 1 c 1.3,0 2.6,0.3 3.6,0.6 1.7,0.4 1.6,-0.1 2.2,-1.5 0.4,-1.1 2.3,-5.3 2.3,-6.3 -2.8,-0.6 -4,-1.9 -8.1,-1.9 h -1.4 c -3.6,0 -5.2,1.3 -7.7,1.9 z"
            }
        ], i["GR.IN.IC.PUMPING STATION"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 83.2,83.8 0,1.2 0,5.6 -11.3,0 0,-0 c -0.2,0 -0.3,0 -0.5,0 -0.1,6.6e-4 -0.1,-9.6e-4 -0.2,0 -2.7,0 -4.9,0.3 -6.5,1.7 -1.4,1.2 -2,3.3 -2.1,5.9 l -0.1,0 0,1.2 c 8e-6,0.1 -0,0.2 -0,0.3 l 0,0 0,14.1 -2.8,0 0,2.4 80.8,0 0,-2.4 -2.8,0 0,-14 0,-1.6 -0.1,0 c -0.1,-2.6 -0.5,-4.6 -1.8,-5.9 -1.5,-1.4 -3.8,-1.7 -6.8,-1.7 l 0,-0 -0.3,0 c -0.2,-5.6e-4 -0.3,-0 -0.4,-0 l 0,0 -11.3,0 0,-5.6 0,-1.2 -1.2,0 -31.2,0 -1.2,0 z m 2.4,2.4 28.8,0 0,27.2 -28.8,0 0,-27.2 z M 71.2,93 c 0.1,-0 0.1,0 0.2,0 l 11.8,0 0,8.4 -7.5,0 c -0.8,-0.1 -1.4,-0.1 -2,-0 -0,0 -0,0 -0.1,0 -0,0 -0,-0 -0,0 l 0,0 c -0.5,0.1 -1.2,0.3 -1.5,0.8 -0.4,0.5 -0.4,1.1 -0.4,1.6 -0,0.4 -0,0.8 0,1.2 l -0,0 0,8.8 -6.8,0 0,-14.5 c 0,-3 0.5,-4.5 1.4,-5.3 C 67.1,93.3 68.7,93.1 71.2,93 z m 45.6,0 11.8,0 c 0.1,9.7e-4 0.1,-0 0.2,0 2.8,0.1 4.5,0.4 5.2,1.1 0.8,0.7 1.2,2.3 1.2,5.2 l 0,14.5 -6.8,0 0,-8 0,0 c -0,-0.1 -0,-0.3 -0,-0.4 0,-0.9 0.2,-1.6 -0.1,-2.5 -0.1,-0.5 -0.6,-1.2 -1.2,-1.4 -0.2,-0.1 -0.5,-0 -0.7,-0 l 0,-0.1 -9.6,0 0,-8.4 z M 74,103.8 l 9.2,0 0,10 -9.2,0 0,-8.5 0,0 c 0,-0.6 -0,-1.1 -0,-1.4 0,-0.1 -0,-0 0,-0.1 z m 42.8,0 9.2,0 c 0,0.2 0,0.8 0,1.6 l -0,0 0,8.4 -9.2,0 0,-10 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 116.8,93 11.8,0 c 0.1,9.7e-4 0.1,-0 0.2,0 2.8,0.1 4.5,0.4 5.2,1.1 0.8,0.7 1.2,2.3 1.2,5.2 l 0,14.5 -6.8,0 0,-8 0,0 c -0,-0.1 -0,-0.3 -0,-0.4 0,-0.9 0.2,-1.6 -0.1,-2.5 -0.1,-0.5 -0.6,-1.2 -1.2,-1.4 -0.2,-0.1 -0.5,-0 -0.7,-0 l 0,-0.1 -9.6,0 0,-8.4 z m -45.6,0 c 0.1,-0 0.1,0 0.2,0 l 11.8,0 0,8.4 -7.5,0 c -0.8,-0.1 -1.4,-0.1 -2,-0 -0,0 -0,0 -0.1,0 -0,0 -0,-0 -0,0 l 0,0 c -0.5,0.1 -1.2,0.3 -1.5,0.8 -0.4,0.5 -0.4,1.1 -0.4,1.6 -0,0.4 -0,0.8 0,1.2 l -0,0 0,8.8 -6.8,0 0,-14.5 c 0,-3 0.5,-4.5 1.4,-5.3 C 67.1,93.3 68.7,93.1 71.2,93 z m 14.4,-6.8 28.8,0 0,27.2 -28.8,0 0,-27.2 z"
            }
        ], i["GR.IN.IC.RESERVOIR"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 127.3 69.1 C 127 69.1 126.7 69.2 126.4 69.2 C 123.4 69.5 120.8 71.9 118.4 74.5 C 115.9 77 113.5 79.7 111.5 80.9 C 108.9 82.4 105.5 82.5 101.9 82.6 C 98.3 82.7 94.7 82.9 91.8 84.9 C 89.7 86.5 88.6 88.5 87.5 90.3 C 86.4 92 85.2 93.4 82.7 94.2 C 79.4 95.3 72 96.4 66.9 98.8 C 64.3 100.1 62.1 101.7 61.5 104 C 60.8 106.3 61.7 109.1 64.7 112.3 L 65.1 111.9 L 65.1 120.1 L 84.3 120.1 L 84.3 129.7 L 86.7 129.7 L 86.7 120.1 L 97.9 120.1 L 97.9 129.7 L 100.3 129.7 L 100.3 120.1 L 117.1 120.1 L 117.1 112.5 C 117.4 112.2 117.7 111.9 118 111.5 C 119 110.1 119.3 108.5 119.5 106.9 C 119.8 103.7 119.5 100.5 121.7 97.7 C 123.1 95.9 126 95.4 129.1 94.7 C 132.1 94.1 135.4 93.3 137.2 90.4 C 139.4 86.7 139.1 81.3 137.2 76.8 C 136.3 74.5 134.9 72.5 133 71.1 C 131.4 69.9 129.5 69.1 127.3 69.1 z M 127.4 70.7 C 129.2 70.7 130.7 71.3 132.1 72.3 C 133.6 73.5 134.9 75.4 135.8 77.4 C 137.5 81.5 137.6 86.6 135.8 89.6 C 134.5 91.8 131.7 92.5 128.7 93.2 C 125.7 93.8 122.4 94.3 120.5 96.7 C 117.8 100 118.2 103.7 117.9 106.7 C 117.8 108.2 117.5 109.5 116.7 110.6 C 116.5 110.8 116.3 111.1 116.1 111.3 L 65.8 111.3 L 65.9 111.3 C 63.1 108.2 62.6 106.1 63 104.4 C 63.5 102.8 65.2 101.4 67.6 100.3 C 72.3 98 79.5 96.9 83.1 95.8 C 86.1 94.8 87.7 92.9 88.8 91.1 C 90 89.3 90.9 87.5 92.8 86.2 C 95.1 84.5 98.4 84.3 102 84.2 C 105.5 84.1 109.2 84.1 112.3 82.3 C 114.7 80.8 117.1 78.1 119.5 75.6 C 121.9 73.1 124.4 71 126.6 70.8 C 126.9 70.8 127.1 70.7 127.4 70.7 z "
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 127.4,70.7 c 1.8,-0 3.3,0.6 4.7,1.6 1.5,1.2 2.8,3 3.7,5.1 1.7,4.1 1.9,9.2 0.1,12.2 -1.3,2.2 -4.1,3 -7.1,3.6 -3,0.6 -6.3,1.1 -8.3,3.5 -2.6,3.3 -2.3,7.1 -2.6,10 -0.1,1.5 -0.4,2.8 -1.2,3.8 -0.2,0.2 -0.4,0.5 -0.6,0.7 l -50.2,0 0,-0 c -2.8,-3 -3.3,-5.2 -2.8,-6.8 0.5,-1.6 2.1,-3 4.5,-4.2 4.8,-2.3 11.9,-3.4 15.6,-4.5 3,-1 4.5,-2.8 5.7,-4.6 1.2,-1.8 2.1,-3.6 3.9,-4.9 2.3,-1.7 5.7,-1.9 9.2,-2 3.5,-0.1 7.3,-0.1 10.3,-1.9 2.5,-1.4 4.8,-4.2 7.2,-6.7 2.4,-2.5 4.9,-4.6 7.1,-4.8 0.3,-0 0.5,-0.1 0.8,-0.1 z m -41.9,49 13.6,0 0,10 -13.6,0 z"
            }
        ], i["GR.IN.IC.STORAGE TOWER"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 118.3,121 0.4,5.3 0.7,12.8 h 2.9 c 0,-6.1 -1.1,-12.6 -1.1,-18.6 0,-3.4 -0.4,-6.2 -0.4,-9.6 -0.1,-5.3 0.2,-3 2.6,-6.6 l -0.3,-3.1 0,-1.1 h -4.2 V 84 c -2.5,0.6 -5.2,1.8 -8.3,2.6 -2.6,0.6 -6.4,1.4 -9.4,1.4 h -2.4 c -7.6,0 -12.2,-2.6 -18,-4 v 16.2 h -4.2 v 0.7 l -0.3,3.7 3.2,3.7 -2,30.8 h 3.1 v -3.3 l 1.4,-21.7 c 0.5,0.4 2.1,2.7 3,3.6 0.9,0.9 2.4,2.2 3.5,2.9 2.2,1.5 5.6,3.8 8.7,4.1 v 14.4 h 5.6 v -14.4 c 3.7,-0.9 6.2,-2.2 8.8,-4.3 1.4,-1.1 2.2,-1.8 3.4,-3 0.7,-0.7 2.5,-3.2 3,-3.4 v 3.1 l 0.2,3.8 z M 99.7,85.2 c 7.4,0 23,-4.4 25.7,-8.4 -2.8,-1.5 -25.1,-16 -25.3,-16 -0.4,0 -24.9,15.4 -25.5,16.2 2.6,3.5 16.6,8.2 23.3,8.2 h 1.8 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 97.9,85.2 c -4.3,0 -11.7,-2 -17,-4.3 l -0,3.2 c 5.8,1.4 10.4,4 18,4 h 2.4 c 3,0 6.9,-0.8 9.4,-1.4 3,-0.8 5.8,-2 8.3,-2.6 V 80.8 c -6,2.4 -14.4,4.4 -19.3,4.4 H 97.9 z"
            }
        ], i["GR.IN.IC.SURFACE WATER INTAKE"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 63.4 75.5 L 63.4 76.3 L 63.4 90.7 L 63.4 91.5 L 64.2 91.5 L 75.7 91.5 C 76.5 96.6 79.8 99.1 83.3 101 C 87.1 102.9 91.3 104.3 93.8 107.5 C 94.8 108.9 94.9 110.7 95.2 112.6 C 95.4 113.6 95.6 114.5 96.2 115.4 C 96.7 116.2 97.5 117 98.8 117.5 C 101.2 118.6 108.7 120.7 115.9 122.4 C 119.6 123.2 123.1 123.9 126 124.3 C 127.5 124.4 128.7 124.5 129.8 124.5 C 130.8 124.4 131.6 124.3 132.2 123.8 C 134.8 121.7 136.1 119.9 136.5 118.3 C 136.8 116.8 136.1 115.4 135 114.4 C 133.9 113.4 132.4 112.5 131 111.7 C 129.7 110.8 128.4 109.9 127.7 108.8 C 124.2 103.6 121 95.5 113.4 91.5 L 119 91.5 L 119.8 91.5 L 119.8 90.7 L 119.8 76.3 L 119.8 75.5 L 119 75.5 L 64.2 75.5 L 63.4 75.5 z M 65 77.1 L 118.2 77.1 L 118.2 89.9 L 109.4 89.9 L 109.4 81.1 L 73.8 81.1 L 73.8 89.9 L 65 89.9 L 65 77.1 z M 76.9 91.5 L 110.5 91.5 C 119.4 94.8 122.7 103.5 126.7 109.5 C 127.6 110.8 129 111.8 130.4 112.7 C 131.8 113.6 133.2 114.4 134.2 115.3 C 135.1 116.2 135.6 117 135.3 118.1 C 135.1 119.2 134 120.8 131.4 122.9 C 131.3 123 130.6 123.2 129.7 123.3 C 128.8 123.3 127.6 123.3 126.2 123.1 C 123.3 122.8 119.8 122.1 116.2 121.3 C 109 119.6 101.5 117.3 99.3 116.4 C 98.2 116 97.6 115.4 97.2 114.8 C 96.8 114.1 96.6 113.3 96.4 112.4 C 96.1 110.6 96 108.5 94.7 106.8 C 91.9 103.2 87.6 101.8 83.9 99.9 C 80.5 98.1 77.7 96.1 76.9 91.5 z "
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 76.9,91.5 33.6,0 c 8.9,3.3 12.2,12 16.2,18 0.9,1.3 2.3,2.3 3.7,3.2 1.4,0.9 2.8,1.7 3.8,2.6 0.9,0.9 1.4,1.7 1.2,2.8 -0.2,1.1 -1.3,2.7 -3.9,4.8 -0.2,0.1 -0.8,0.3 -1.7,0.4 -0.9,0 -2.2,-0 -3.6,-0.2 -2.8,-0.3 -6.4,-1 -10,-1.8 -7.2,-1.7 -14.7,-3.9 -16.9,-4.8 -1.1,-0.4 -1.6,-1 -2.1,-1.7 -0.4,-0.7 -0.6,-1.5 -0.8,-2.3 -0.3,-1.8 -0.4,-3.9 -1.7,-5.6 -2.8,-3.6 -7.1,-5 -10.8,-6.9 C 80.5,98.1 77.7,96.1 76.9,91.5 z m -11.9,-14.4 53.2,0 0,12.8 -8.8,0 0,-8.8 -35.6,0 0,8.8 -8.8,0 0,-12.8 z"
            }
        ], i["GR.IN.IC.WAREHOUSE/STORAGE FACILITY"] = [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 113,
                fontsize: 23,
                text: "STOR"
            }
        ], i["GR.IN.IC.WASTEWATER TREATMENT FACILITY"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 107.2,114.8 c 1.9,0 3.9,-1 4.3,-2.4 1.5,1 1.7,2.4 4.6,2.4 h 0.4 c 1.8,0 3.8,-1.1 4.1,-2.4 h 0.4 c 0.4,1.4 2.5,2.4 4.5,2.4 h 0.4 c 2.7,0 3,-1.5 4.5,-2.4 0.4,1.4 2.6,2.4 4.5,2.4 v -1.5 c -2.2,0 -3.5,-1.6 -3.9,-3.4 h -1.5 c -0,1.8 -1.7,3.4 -3.6,3.4 h -0.4 c -2.2,0 -3.6,-1.4 -3.8,-3.4 h -1.7 l -0.2,1.3 c -1,0.7 -1.1,2 -3.3,2 h -0.4 c -3.3,0 -3.2,-3.4 -4.1,-3.4 h -1.3 c -0.2,2 -1.4,3.4 -3.6,3.4 v 1.5 z m -2.2,-33.3 h 32 v 37 h -32 V 81.5 z M 65.1,114.8 v -1.5 c 2,0 3.7,-1.6 3.8,-3.4 h 1.9 c 0,1.8 1.5,3.4 3.4,3.4 h 0.4 c 1.8,0 3.5,-1.6 3.6,-3.4 h 1.9 c 0,2 1.7,3.4 3.8,3.4 h 0.2 c 2.2,0 3.2,-1.6 3.6,-3.4 h 1.7 c 0,2 1.7,3.4 3.8,3.4 v 1.5 c -2,0 -4.1,-1 -4.5,-2.4 -1.4,0.9 -1.7,2.5 -4.6,2.5 h -0.6 c -2.9,0 -3.1,-1.5 -4.5,-2.4 -0.4,1.3 -2.4,2.4 -4.1,2.4 H 74.1 c -2.4,0 -3.4,-1.2 -4.5,-2.4 -0.4,1.4 -2.6,2.4 -4.5,2.4 l 0,0 z M 96.5,93.4 h 6.7 v 13.3 H 96.5 V 93.4 z m -31.4,7.9 c 2,0 3.6,-1.5 3.8,-3.4 h 1.9 c 0.2,1.8 1.4,3.4 3.4,3.4 h 0.4 c 1.8,0 3.5,-1.7 3.6,-3.4 h 1.9 c 0,2 1.7,3.4 3.8,3.4 h 0.2 c 1.5,0 3.4,-1.5 3.4,-2.6 v -0.8 h 1.9 c 0,1.9 1.8,3.4 3.8,3.4 v 1.5 c -3.6,0 -3.8,-2 -4.9,-2.2 -0.4,1.3 -2.5,2.2 -4.2,2.2 h -0.6 c -1.7,0 -3.8,-1 -4.1,-2.2 -1,0.3 -1.4,2.2 -4.5,2.2 H 74.1 c -2.7,0 -3,-1.3 -4.5,-2.2 -1,1.4 -2.2,2.2 -4.5,2.2 v -1.5 l 0,0 z m 0,-12 c 2,0 3.6,-1.5 3.8,-3.4 h 1.9 c 0.1,1.8 1.4,3.4 3.4,3.4 h 0.4 c 1.8,0 3.5,-1.7 3.6,-3.4 h 1.9 c 0,2 1.7,3.4 3.8,3.4 h 0.2 c 1.5,0 3.4,-1.5 3.4,-2.6 v -0.8 h 1.9 c 0,1.9 1.8,3.4 3.8,3.4 v 1.5 c -3.1,0 -3,-1 -4.7,-2 -1.4,1 -1.7,2.1 -4.4,2.1 h -0.6 c -2.7,0 -2.9,-1.1 -4.3,-2 -1.6,1 -1.6,2 -4.5,2 H 73.9 c -2.4,0 -2.9,-1.2 -4.1,-2 -1.6,1 -1.7,2 -4.7,2 v -1.5 l 0,0 z m 31.4,21.3 h 6.7 v 10.1 h 35.6 V 79.4 L 103.3,79.2 V 89.5 H 96.5 V 79.4 L 61.2,79.2 v 41.6 h 35.4 v -10.1 z m 14.2,-12.2 c 0,1.4 -1.8,2.8 -3.6,2.8 v 1.5 c 3.4,0 3.5,-1.9 4.7,-2.2 0.4,1.3 2.7,2.2 4.5,2.2 h 0.2 c 2.9,0 3,-1.3 4.3,-2.2 1.2,0.9 1.7,2.2 4.3,2.2 h 0.8 c 2.6,0 3,-1.3 4.3,-2.2 1.4,1 1.5,2.2 4.6,2.2 v -1.5 c -1.7,0 -3.8,-1.6 -3.8,-2.8 v -0.6 h -1.7 c -0.1,1.8 -1.6,3.4 -3.6,3.4 h -0.6 c -1.4,0 -3.4,-1.4 -3.4,-2.4 v -0.9 h -1.9 c 0,1.7 -1.7,3.4 -3.5,3.4 h -0.4 c -1.9,0 -3.5,-1.5 -3.6,-3.4 h -1.8 v 0.6 z m 0,-12 c 0,1.4 -1.8,2.8 -3.6,2.8 v 1.5 c 1.8,0 4,-0.9 4.3,-2.2 1.6,1.1 1.7,2.2 4.9,2.2 h 0.4 c 2.6,0 2.9,-1.3 4.3,-2.2 0.3,1.3 2.4,2.3 4.1,2.3 h 0.8 c 2.7,0 3,-1.3 4.5,-2.2 0.4,1.3 2.7,2.2 4.5,2.2 v -1.5 c -1.7,0 -3.8,-1.6 -3.8,-2.8 v -0.6 h -1.7 c -0.1,1.8 -1.6,3.4 -3.6,3.4 h -0.6 c -1.6,0 -3.4,-1.4 -3.4,-2.8 v -0.6 h -1.9 c 0,1.7 -1.7,3.4 -3.5,3.4 h -0.4 c -1.9,0 -3.5,-1.5 -3.6,-3.4 h -1.8 v 0.5 z"
            },
            {
                type: "path",
                stroke: !1,
                fill: !!R && G,
                d: "m 65.1,114.8 c 1.9,0 4.1,-1 4.5,-2.4 1.1,1.2 2.2,2.4 4.5,2.4 h 0.6 c 1.8,0 3.8,-1.1 4.1,-2.4 1.4,1 1.6,2.4 4.5,2.4 h 0.6 c 2.8,0 3.2,-1.6 4.5,-2.4 0.4,1.4 2.5,2.4 4.5,2.4 v -1.5 c -2.1,0 -3.7,-1.4 -3.8,-3.4 h -1.6 c -0.4,1.8 -1.4,3.4 -3.6,3.4 h -0.2 c -2.1,0 -3.7,-1.4 -3.8,-3.4 h -1.8 c -0,1.8 -1.7,3.4 -3.6,3.4 H 74.1 c -1.8,0 -3.3,-1.6 -3.4,-3.4 h -1.9 c -0,1.8 -1.8,3.4 -3.8,3.4 v 1.5 l 0,0 z m 0,-13.5 v 1.5 c 2.3,0 3.6,-0.9 4.5,-2.2 1.4,1 1.8,2.2 4.5,2.2 h 0.6 c 3.1,0 3.5,-2 4.5,-2.2 0.4,1.3 2.4,2.2 4.1,2.2 h 0.6 c 1.7,0 3.8,-1 4.1,-2.2 1.1,0.3 1.2,2.2 4.9,2.2 v -1.5 c -2,0 -3.8,-1.4 -3.8,-3.4 h -1.9 v 0.8 c 0,1.2 -1.9,2.6 -3.4,2.6 h -0.2 c -2,0 -3.7,-1.4 -3.8,-3.4 h -1.8 c -0,1.6 -1.7,3.4 -3.6,3.4 H 74.1 c -2,0 -3.2,-1.5 -3.4,-3.4 h -1.9 c -0.2,1.8 -1.7,3.4 -3.8,3.4 l 0,0 z m 0,-12 v 1.5 c 3,0 3.1,-1 4.7,-2 1.2,0.9 1.7,2 4.1,2 h 0.6 c 2.9,0 2.9,-1 4.5,-2 1.4,0.9 1.6,2 4.3,2 h 0.6 c 2.7,0 2.9,-1.1 4.3,-2 1.6,1.1 1.6,2 4.7,2 v -1.5 c -2,0 -3.8,-1.4 -3.8,-3.4 h -1.9 v 0.8 c 0,1.2 -1.9,2.6 -3.4,2.6 h -0.2 c -2,0 -3.7,-1.4 -3.8,-3.4 h -1.8 c -0,1.7 -1.7,3.4 -3.6,3.4 H 74.1 c -2,0 -3.2,-1.5 -3.4,-3.4 h -1.9 c -0.2,1.8 -1.7,3.4 -3.8,3.4 l 0,0 z m 42.1,25.4 v -1.5 c 2.2,0 3.4,-1.4 3.6,-3.4 h 1.3 c 1,0 0.8,3.4 4.1,3.4 h 0.4 c 2.2,0 2.4,-1.4 3.3,-2.1 l 0.2,-1.3 h 1.7 c 0.2,2 1.6,3.4 3.8,3.4 h 0.4 c 1.8,0 3.5,-1.6 3.6,-3.4 h 1.5 c 0.4,1.8 1.7,3.4 3.9,3.4 v 1.5 c -1.9,0 -4.1,-1 -4.5,-2.4 -1.5,1 -1.8,2.5 -4.5,2.5 h -0.4 c -2,0 -4.1,-1 -4.5,-2.4 h -0.4 c -0.4,1.3 -2.3,2.4 -4.1,2.4 h -0.4 c -2.9,0 -3.1,-1.4 -4.7,-2.4 -0.4,1.4 -2.4,2.4 -4.3,2.4 z m 3.6,-16.8 h 1.9 c 0,1.8 1.6,3.4 3.5,3.4 h 0.4 c 1.8,0 3.5,-1.6 3.6,-3.4 h 1.9 v 0.9 c 0,1 2,2.4 3.4,2.4 h 0.6 c 1.9,0 3.4,-1.6 3.6,-3.4 h 1.7 v 0.6 c 0,1.2 2,2.8 3.8,2.8 v 1.5 c -3.1,0 -3.2,-1.2 -4.7,-2.2 -1.3,0.9 -1.7,2.2 -4.4,2.2 h -0.7 c -2.6,0 -3,-1.3 -4.3,-2.2 -1.3,1 -1.4,2.2 -4.3,2.2 h -0.2 c -1.8,0 -4.2,-1 -4.5,-2.2 -1.2,0.3 -1.2,2.2 -4.7,2.2 v -1.5 c 1.8,0 3.6,-1.4 3.6,-2.8 v -0.6 l 0,0 z m 0,-12 h 1.9 c 0,1.9 1.6,3.4 3.5,3.4 h 0.4 c 1.8,0 3.5,-1.6 3.6,-3.4 h 1.9 v 0.6 c 0,1.4 1.8,2.8 3.4,2.8 h 0.6 c 1.9,0 3.4,-1.6 3.6,-3.4 h 1.7 v 0.6 c 0,1.2 2,2.8 3.8,2.8 v 1.5 c -1.8,0 -4.2,-1 -4.5,-2.2 -1.5,1 -1.8,2.2 -4.6,2.2 h -0.7 c -1.7,0 -3.8,-1 -4.1,-2.2 -1.4,0.9 -1.7,2.2 -4.3,2.2 h -0.4 c -3.1,0 -3.2,-1.2 -4.9,-2.2 -0.4,1.3 -2.5,2.2 -4.3,2.2 v -1.5 c 1.8,0 3.6,-1.4 3.6,-2.8 v -0.6 z m -5.8,32.6 h 32 V 81.5 h -32 v 37 z m -1.7,-11.8 0,-13.3 -6.8,0 0,13.3 z"
            }
        ], i["GR.IN.IC.TRANSPORTATION INFRASTRUCTURE.TRAFFIC CONTROL POINT"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 85.5,81.3 0.5,0.7 13.7,18.2 0.3,0.5 0.3,-0.5 13.7,-18.2 0.5,-0.7 -0.9,0 -27.4,0 -0.9,0 z m 1.7,0.9 25.7,0 L 100,99.3 87.2,82.2 z M 106.7,50.7 c 0,0.2 -0,0.5 -0.1,0.7 -0.1,0.2 -0.2,0.4 -0.4,0.5 -0.2,0.2 -0.4,0.3 -0.7,0.4 -0.3,0.1 -0.6,0.1 -1,0.1 l -0.7,0 0,2.1 -0.7,0 0,-5.6 1.5,0 c 0.3,5e-6 0.6,0 0.9,0.1 0.2,0.1 0.4,0.1 0.6,0.3 0.2,0.1 0.4,0.3 0.5,0.5 0.1,0.2 0.2,0.5 0.2,0.8 m -0.8,0 c -1e-5,-0.2 -0,-0.4 -0.1,-0.5 -0.1,-0.1 -0.2,-0.3 -0.3,-0.3 -0.1,-0.1 -0.3,-0.1 -0.4,-0.2 -0.2,-0 -0.3,-0.1 -0.6,-0.1 l -0.7,0 0,2.2 0.6,0 c 0.3,3e-6 0.5,-0 0.7,-0.1 0.2,-0.1 0.3,-0.1 0.5,-0.3 0.1,-0.1 0.2,-0.2 0.2,-0.4 0.1,-0.1 0.1,-0.3 0.1,-0.4 m -3.9,3.5 c -0.1,0.1 -0.3,0.1 -0.4,0.2 -0.1,0.1 -0.3,0.1 -0.4,0.2 -0.2,0 -0.3,0.1 -0.5,0.1 -0.2,0 -0.4,0.1 -0.6,0.1 -0.4,0 -0.8,-0.1 -1.1,-0.2 -0.3,-0.1 -0.6,-0.3 -0.9,-0.5 -0.2,-0.2 -0.4,-0.5 -0.6,-0.9 -0.1,-0.4 -0.2,-0.8 -0.2,-1.3 0,-0.5 0.1,-0.9 0.2,-1.2 0.1,-0.4 0.3,-0.7 0.6,-0.9 0.2,-0.2 0.5,-0.4 0.9,-0.6 0.3,-0.1 0.7,-0.2 1.1,-0.2 0.3,6e-6 0.6,0 0.9,0.1 0.3,0.1 0.6,0.2 1,0.4 l 0,0.9 -0.1,0 c -0.3,-0.3 -0.6,-0.4 -0.9,-0.6 -0.3,-0.1 -0.6,-0.2 -1,-0.2 -0.3,5e-6 -0.5,0 -0.8,0.1 -0.2,0.1 -0.4,0.2 -0.6,0.4 -0.2,0.2 -0.3,0.4 -0.4,0.7 -0.1,0.3 -0.1,0.6 -0.1,1 -10e-7,0.4 0.1,0.7 0.2,1 0.1,0.3 0.2,0.5 0.4,0.7 0.2,0.2 0.4,0.3 0.6,0.4 0.2,0.1 0.5,0.1 0.7,0.1 0.4,10e-7 0.7,-0.1 1,-0.2 0.3,-0.1 0.6,-0.3 0.9,-0.6 l 0.1,0 0,0.9 m -5.1,-4.5 -2,0 0,4.9 -0.7,0 0,-4.9 -2,0 0,-0.7 4.7,0 0,0.7 M 85.9,44.6 l 0,0.4 0,36.5 0,0.4 0.4,0 27.4,0 0.4,0 0,-0.4 0,-36.5 0,-0.4 -0.4,0 -27.4,0 -0.4,0 z m 0.9,0.9 26.5,0 0,35.6 -26.5,0 0,-35.6 z"
            }
        ], i["AC.M1.RIOT"] = l("RIOT"), i["AC.M1.THREAT"] = l("?"), i["AC.M1.EMERGENCY COLLECTION EVACUATION POINT"] = l("ECEP"), i["AC.M1.EMERGENCY INCIDENT COMMAND CENTER"] = l("EICC"), i["AC.M1.EMERGENCY OPERATIONS CENTER"] = l("EOC"), i["AC.M1.EMERGENCY SHELTER"] = l("ES"), i["AC.M1.EMERGENCY STAGING AREA"] = l("SA"), i["AC.M1.EMERGENCY"] = l("EMER"), i["AC.M1.COMMERCIAL"] = l("COM"), i["AC.M1.PRODUCTION"] = l("PROD"), i["AC.M1.RETAIL"] = l("RTL"), i["AC.M1.MILITARY ARMORY"] = l("RES"), i["AC.M1.GENERATION STATION"] = l("GEN"), i["GR.I.FF.CIVILIAN ROTARY WING"] = [
            {
                type: "path",
                stroke: o,
                d: "M80,70 l10,10 M120,110 l-10,-10 M80,110 l10,-10 M120,70 l-10,10 M100,115 l0,20 M95,135 l10,0",
                fill: !1
            },
            {
                type: "path",
                stroke: o,
                fill: !!R && G,
                d: "m 113,90 c -0.3,8.8 -1.9,20.3 -10.8,24.6 -7.7,2 -12.3,-7.1 -13.8,-13.3 -2.6,-11.5 -2.3,-26 6.9,-34.6 6.0,-4.9 13.1,1.9 14.9,7.8 2,4.9 2.8,10.2 2.8,15.5 z"
            }
        ], i["GR.IC.HOSPITAL SHIP"] = a("AH"), i["GR.IC.LAW ENFORCEMENT VESSEL"] = [
            {
                type: "path",
                fill: R ? G : !C && G,
                d: "m 75,100 0,-35 50,0 0,35 20,0 -15,35 -60,0 -15,-35 z"
            },
            {
                type: "path",
                d: "m 135,100 -15,35 -10,0 15,-35 z"
            }
        ], i["CY.IC.COMBAT MISSION TEAM"] = a("CMT"), i["CY.IC.NATIONAL MISSION TEAM"] = a("NMT"), i["CY.IC.CYBER PROTECTION TEAM"] = a("CPT"), i["CY.IC.NATION STATE CYBER THREAT ACTOR"] = a("CTA"), i["CY.IC.NON NATION STATE CYBER THREAT ACTOR"] = a("CTA"), i["CY.IC.NON NATION STATE CYBER THREAT ACTOR"].fill = R || N ? G : !C && G, i["CY.IC.NON NATION STATE CYBER THREAT ACTOR"].stroke = o, i["CY.IC.NON NATION STATE CYBER THREAT ACTOR"].strokewidth = 3, i)i.hasOwnProperty(L) && (I.hasOwnProperty(L) && console.warn("Override of: " + L), n.call(this, i[L], O), I[L] = i[L]);
    }
    var h = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            c
        ],
        icons: function(I, t, E, R) {
            I["S-G-------"] = [], I["S-G-U-----"] = [], I["S-G-UC----"] = [
                E["GR.IC.COMBAT"]
            ], I["S-G-UCD---"] = [
                E["GR.IC.FF.AIR DEFENCE"]
            ], I["S-G-UCDS--"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE SHORT RANGE"]
            ], I["S-G-UCDSC-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.AIR DEFENSE CHAPARRAL"]
            ], I["S-G-UCDSS-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.AIR DEFENSE STINGER"]
            ], I["S-G-UCDSV-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.FF.MAIN GUN SYSTEM"],
                E["GR.IC.AIR DEFENSE VULCAN"]
            ], I["S-G-UCDM--"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"]
            ], I["S-G-UCDML-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.MISSILE.LIGHT"]
            ], I["S-G-UCDMLA"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UCDMM-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.MISSILE.MEDIUM"]
            ], I["S-G-UCDMH-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.MISSILE.HEAVY"]
            ], I["S-G-UCDH--"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE H/MAD"]
            ], I["S-G-UCDHH-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.AIR DEFENSE H/MAD HAWK"]
            ], I["S-G-UCDHP-"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE MISSILE"],
                E["GR.IC.AIR DEFENSE H/MAD PATRIOT"]
            ], I["S-G-UCDG--"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE GUN UNIT"]
            ], I["S-G-UCDC--"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE COMPOSITE"]
            ], I["S-G-UCDT--"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE TARGETING UNIT"]
            ], I["S-G-UCDO--"] = [
                E["GR.IC.FF.AIR DEFENCE"],
                E["GR.IC.AIR DEFENSE THEATER MISSILE DEFENSE UNIT"]
            ], I["S-G-UCA---"] = [
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCAT--"] = [
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCATA-"] = [
                E["GR.IC.ARMOUR"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCATW-"] = [
                E["GR.IC.ARMOUR"],
                E["GR.IC.FF.AMPHIBIOUS"]
            ], I["S-G-UCATWR"] = [
                E["GR.IC.ARMOUR"],
                E["GR.IC.FF.AMPHIBIOUS"],
                E["GR.M2.RECOVERY (MAINTENANCE)"]
            ], I["S-G-UCATL-"] = [
                E["GR.IC.ARMOUR"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCATM-"] = [
                E["GR.IC.ARMOUR"],
                E["GR.M2.MEDIUM"]
            ], I["S-G-UCATH-"] = [
                E["GR.IC.ARMOUR"],
                E["GR.M2.HEAVY"]
            ], I["S-G-UCATR-"] = [
                E["GR.IC.ARMOUR"],
                E["GR.M2.RECOVERY (MAINTENANCE)"]
            ], I["S-G-UCAW--"] = [
                E["GR.IC.ARMOR, WHEELED"]
            ], I["S-G-UCAWS-"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCAWA-"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCAWW-"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.IC.FF.AMPHIBIOUS"]
            ], I["S-G-UCAWWR"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.IC.FF.AMPHIBIOUS"],
                E["GR.M2.RECOVERY (MAINTENANCE)"]
            ], I["S-G-UCAWL-"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCAWM-"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.M2.MEDIUM"]
            ], I["S-G-UCAWH-"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.M2.HEAVY"]
            ], I["S-G-UCAWR-"] = [
                E["GR.IC.ARMOR, WHEELED"],
                E["GR.M2.RECOVERY (MAINTENANCE)"]
            ], I["S-G-UCAA--"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"]
            ], I["S-G-UCAAD-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"]
            ], I["S-G-UCAAL-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCAAM-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCAAS-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCAAU-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCAAC-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.M2.ARCTIC"]
            ], I["S-G-UCAAA-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCAAAT"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCAAAW"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.IC.ARMOUR"],
                E["GR.M2.WHEELED"]
            ], I["S-G-UCAAAS"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.IC.ARMOUR"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCAAO-"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UCAAOS"] = [
                E["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                E["GR.IC.FF.MOTORIZED"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCV---"] = [
                E["GR.IC.AVIATION ROTARY WING"]
            ], I["S-G-UCVF--"] = [
                E["GR.IC.AVIATION FIXED WING"]
            ], I["S-G-UCVFU-"] = [
                E["GR.IC.AVIATION FIXED WING"],
                E["GR.M1.UTILITY"]
            ], I["S-G-UCVFA-"] = [
                E["GR.IC.AVIATION FIXED WING"],
                E["GR.M1.ATTACK"]
            ], I["S-G-UCVUTP"] = [
                E["GR.IC.AVIATION TACTICAL AIR CONTROL PARTY"]
            ], I["S-G-UCVUFC"] = [
                E["GR.IC.AVIATION FORWARD AIR CONTROLLER"]
            ], I["S-G-UCVFR-"] = [
                E["GR.IC.AVIATION FIXED WING"],
                E["GR.M1.RECON"]
            ], I["S-G-UCVR--"] = R ? [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.IC.AVIATION ROTARY WING 2525C"]
            ] : [
                E["GR.IC.AVIATION ROTARY WING"]
            ], I["S-G-UCVRA-"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.ATTACK"]
            ], I["S-G-UCVRS-"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.RECON"]
            ], I["S-G-UCVRW-"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.ANTISUBMARINE WARFARE"]
            ], I["S-G-UCVRU-"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.UTILITY"]
            ], I["S-G-UCVRUL"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.UTILITY"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCVRUM"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.UTILITY"],
                E["GR.M2.MEDIUM"]
            ], I["S-G-UCVRUH"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.UTILITY"],
                E["GR.M2.HEAVY"]
            ], I["S-G-UCVRUC"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.COMMAND AND CONTROL ROTARY WING"]
            ], I["S-G-UCVRUE"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.MEDEVAC"]
            ], I["S-G-UCVRM-"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.MINE COUNTERMEASURE"]
            ], I["S-G-UCVS--"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.PERSONNEL RECOVERY"]
            ], I["S-G-UCVC--"] = [
                E["GR.IC.AVIATION COMPOSITE"]
            ], I["S-G-UCVV--"] = [
                E["GR.IC.AVIATION FIXED WING"],
                E["GR.M2.VERTICAL OR SHORT TAKE-OFF AND LANDING "]
            ], I["S-G-UCVU--"] = [
                E["GR.IC.UNMANNED SYSTEMS"]
            ], I["S-G-UCVUF-"] = [
                E["GR.IC.AVIATION FIXED WING"],
                E["GR.M1.UNMANNED AERIAL VEHICLE"]
            ], I["S-G-UCVUR-"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.UNMANNED AERIAL VEHICLE"]
            ], I["S-G-UCI---"] = [
                E["GR.IC.FF.INFANTRY"]
            ], I["S-G-UCIL--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCIM--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UCIO--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCIA--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCIS--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCIZ--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCIN--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.IC.FF.NAVAL"]
            ], I["S-G-UCII--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.IC.ARMOUR"],
                E["GR.IC.FF.MAIN GUN SYSTEM"]
            ], I["S-G-UCIC--"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.M2.ARCTIC"]
            ], I["S-G-UCE---"] = [
                E["GR.IC.ENGINEER"]
            ], I["S-G-UCEC--"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M1.COMBAT"]
            ], I["S-G-UCECS-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCECA-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCECC-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M2.ARCTIC"]
            ], I["S-G-UCECL-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M1.COMBAT"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCECM-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M1.COMBAT"],
                E["GR.M2.MEDIUM"]
            ], I["S-G-UCECH-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M1.COMBAT"],
                E["GR.M2.HEAVY"]
            ], I["S-G-UCECT-"] = [
                s._scale(.7, E["GR.IC.ENGINEER"]),
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCECW-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UCECO-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCECR-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.IC.FF.RECONNAISSANCE"]
            ], I["S-G-UCEN--"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M1.CONSTRUCTION"]
            ], I["S-G-UCENN-"] = [
                E["GR.IC.ENGINEER"],
                E["GR.M1.NAVAL"]
            ], I["S-G-UCF---"] = [
                E["GR.IC.FIELD ARTILLERY"]
            ], I["S-G-UCFH--"] = [
                E["GR.IC.FIELD ARTILLERY"]
            ], I["S-G-UCFHE-"] = [
                s._scale(.8, E["GR.IC.FIELD ARTILLERY"]),
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCFHS-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCFHA-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCFHC-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M2.ARCTIC"]
            ], I["S-G-UCFHO-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCFHL-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCFHM-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M2.MEDIUM"]
            ], I["S-G-UCFHH-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M2.HEAVY"]
            ], I["S-G-UCFHX-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.IC.FF.AMPHIBIOUS"]
            ], I["S-G-UCFR--"] = [
                E["GR.IC.FF.FIELD ARTILLERY ROCKET"]
            ], I["S-G-UCFRS-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.SINGLE ROCKET LAUNCHER"]
            ], I["S-G-UCFRS-"] = [
                s._scale(.8, E["GR.IC.FIELD ARTILLERY"]),
                E["GR.M1.SINGLE ROCKET LAUNCHER"],
                R ? [] : E["GR.IC.ARMOUR"]
            ], I["S-G-UCFRSS"] = [
                s._scale(.8, E["GR.IC.FIELD ARTILLERY"]),
                E["GR.M1.SINGLE ROCKET LAUNCHER"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCFRSR"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.SINGLE ROCKET LAUNCHER"],
                E["GR.M2.TRUCK"]
            ], I["S-G-UCFRST"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.SINGLE ROCKET LAUNCHER"],
                E["GR.M2.TOWED"]
            ], I["S-G-UCFRM-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.MULTIPLE ROCKET LAUNCHER"],
                R ? "" : E["GR.M2.CROSS-COUNTRY TRUCK"]
            ], I["S-G-UCFRMS"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.MULTIPLE ROCKET LAUNCHER"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCFRMR"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.MULTIPLE ROCKET LAUNCHER"],
                E["GR.M2.TRUCK"]
            ], I["S-G-UCFRMT"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.MULTIPLE ROCKET LAUNCHER"],
                E["GR.M2.TOWED"]
            ], I["S-G-UCFT--"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M2.TARGET ACQUISITION"]
            ], I["S-G-UCFTR-"] = [
                s._translate(-30, 10, s._scale(.6, E["GR.IC.FIELD ARTILLERY"])),
                E["GR.IC.RADAR"]
            ], I["S-G-UCFTS-"] = [
                s._translate(0, 30, s._scale(.7, E["GR.IC.FIELD ARTILLERY"])),
                E["GR.IC.FF.SOUND"]
            ], I["S-G-UCFTF-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.M1.OPTICAL"],
                E["GR.M2.TARGET ACQUISITION"]
            ], I["S-G-UCFTC-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.IC.FF.MOTORIZED"],
                E["GR.IC.FF.RECONNAISSANCE"]
            ], I["S-G-UCFTCD"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.IC.FF.RECONNAISSANCE"]
            ], I["S-G-UCFTCM"] = [
                s._scale(.8, E["GR.IC.FIELD ARTILLERY"]),
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCFTA-"] = [
                E["GR.IC.FIELD ARTILLERY"],
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.AVIATION ROTARY WING"],
                E["GR.M1.NAVAL"]
            ], I["S-G-UCFM--"] = [
                E["GR.IC.MORTAR"]
            ], I["S-G-UCFMS-"] = [
                E["GR.IC.MORTAR"],
                E["GR.M2.TRACKED"]
            ], I["S-G-UCFMW-"] = I["S-G-UCFMSW"] = [
                E["GR.IC.MORTAR"],
                E["GR.M2.TRUCK"]
            ], I["S-G-UCFMT-"] = [
                E["GR.IC.MORTAR"],
                E["GR.M2.TOWED"]
            ], I["S-G-UCFMTA"] = [
                E["GR.IC.MORTAR"],
                E["GR.M2.TOWED"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCFMTS"] = [
                E["GR.IC.MORTAR"],
                E["GR.M2.TOWED"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCFMTC"] = [
                E["GR.IC.MORTAR"],
                E["GR.M2.ARCTIC"]
            ], I["S-G-UCFMTO"] = [
                E["GR.IC.MORTAR"],
                E["GR.M2.TOWED"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCFML-"] = [
                s._translate(0, -20, E["GR.IC.MORTAR"]),
                E["GR.IC.FF.AMPHIBIOUS"]
            ], I["S-G-UCFS--"] = [
                E["GR.IC.SURVEY"]
            ], I["S-G-UCFSS-"] = [
                E["GR.IC.SURVEY"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCFSA-"] = [
                E["GR.IC.SURVEY"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCFSL-"] = [
                E["GR.IC.SURVEY"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCFSO-"] = [
                E["GR.IC.SURVEY"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCFO--"] = [
                E["GR.IC.METEOROLOGICAL"]
            ], I["S-G-UCFOS-"] = [
                E["GR.IC.METEOROLOGICAL"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCFOA-"] = [
                E["GR.IC.METEOROLOGICAL"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCFOL-"] = [
                E["GR.IC.METEOROLOGICAL"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCFOO-"] = [
                E["GR.IC.METEOROLOGICAL"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCR---"] = [
                E["GR.IC.FF.RECONNAISSANCE"]
            ], I["S-G-UCRH--"] = [
                E["GR.IC.FF.HORSE"]
            ], I["S-G-UCRV--"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                R ? E["GR.M2.CAVALRY"] : []
            ], I["S-G-UCRVA-"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCRVM-"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UCRVG-"] = [
                E["GR.IC.FF.RECONNAISSANCE"]
            ], I["S-G-UCRVO-"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.AVIATION ROTARY WING"]
            ], I["S-G-UCRC--"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.M2.ARCTIC"]
            ], I["S-G-UCRS--"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], I["S-G-UCRA--"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UCRO--"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.M2.MOUNTAIN"]
            ], I["S-G-UCRL--"] = I["S-G-UCRLL-"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.M2.LIGHT"]
            ], I["S-G-UCRR--"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.FF.AMPHIBIOUS"]
            ], I["S-G-UCRRD-"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.FF.AMPHIBIOUS"],
                R ? E["GR.M1.MARINE DIVISION"] : []
            ], I["S-G-UCRRF-"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.FF.AMPHIBIOUS"],
                E["GR.M1.FORCE"]
            ], I["S-G-UCRRL-"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.ARMOUR"],
                E["GR.M2.WHEELED"]
            ], I["S-G-UCRX--"] = [
                E["GR.IC.FF.RECONNAISSANCE"],
                R ? E["GR.M2.LONG RANGE SURVEILLANCE"] : [
                    s._translate(0, -20, E["GR.M2.MOUNTAIN"]),
                    E["GR.M2.LONG RANGE"]
                ]
            ], I["S-G-UCM---"] = [
                E["GR.IC.MISSILE"]
            ], I["S-G-UCMT--"] = [
                E["GR.IC.MISSILE"],
                E["GR.M2.TACTICAL MISSILE"]
            ], I["S-G-UCMS--"] = [
                E["GR.IC.MISSILE"],
                E["GR.M2.STRATEGIC MISSILE"]
            ], I["S-G-UCS---"] = [
                E["GR.IC.SECURITY"]
            ], I["S-G-UCSW--"] = [
                s._translate(0, -20, E["GR.IC.SECURITY"]),
                E["GR.IC.FF.AMPHIBIOUS"]
            ], I["S-G-UCSG--"] = [
                E["GR.IC.SECURITY"]
            ], I["S-G-UCSGD-"] = [
                E["GR.IC.SECURITY"],
                E["GR.IC.FF.INFANTRY"]
            ], I["S-G-UCSGM-"] = [
                E["GR.IC.SECURITY"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UCSGA-"] = [
                E["GR.IC.SECURITY"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UCSM--"] = [
                E["GR.IC.SECURITY"],
                E["GR.IC.ARMOUR"],
                E["GR.M2.WHEELED"]
            ], I["S-G-UCSR--"] = [
                E["GR.IC.SECURITY"],
                E["GR.M2.RAILROAD"]
            ], I["S-G-UCSA--"] = [
                s._translate(0, -20, E["GR.IC.SECURITY"]),
                E["GR.IC.AVIATION ROTARY WING"]
            ], I["S-G-F-S---"] = E["GR.IC.SURVEILLANCE"], I["S-G-UU----"] = [
                E["GR.IC.COMBAT SUPPORT"]
            ], I["S-G-UUA---"] = [
                E["GR.IC.CBRN"]
            ], I["S-G-UUAC--"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.CHEMICAL"]
            ], I["S-G-UUACC-"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.SMOKE/DECON"]
            ], I["S-G-UUACCK"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.SMOKE/DECON"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UUACCM"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.SMOKE/DECON"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UUACS-"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.SMOKE"]
            ], I["S-G-UUACSM"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.SMOKE"],
                E["GR.IC.FF.MOTORIZED"]
            ], I["S-G-UUACSA"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.SMOKE"],
                E["GR.IC.ARMOUR"]
            ], I["S-G-UUACR-"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.CHEMICAL"],
                E["GR.IC.FF.RECONNAISSANCE"]
            ], I["S-G-UUACRW"] = [
                E["GR.IC.CBRN"],
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.ARMOUR"],
                E["GR.M2.WHEELED"]
            ], I["S-G-UUACRS"] = [
                E["GR.IC.CBRN"],
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.ARMOUR"],
                E["GR.M2.WHEELED"],
                R ? E["GR.M1.CHEMICAL SURVEILLANCE"] : []
            ], I["S-G-UUAN--"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.NUCLEAR"]
            ], I["S-G-UUAB--"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.BIOLOGICAL"]
            ], I["S-G-UUABR-"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.BIOLOGICAL"],
                E["GR.IC.FF.MOTORIZED"],
                E["GR.IC.FF.RECONNAISSANCE"]
            ], I["S-G-UUAD--"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.DECONTAMINATION"]
            ], I["S-G-UUADT-"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.DECONTAMINATION"],
                E["GR.M2.TROOP"]
            ], I["S-G-UUADE-"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.DECONTAMINATION"],
                E["GR.M2.EQUIPMENT"]
            ], I["S-G-UUADET"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.DECONTAMINATION"],
                E["GR.M2.EQUIMENT/TROOP"]
            ], I["S-G-UUAL--"] = [
                E["GR.IC.CBRN"],
                E["GR.M2.LABORATORY"]
            ], I["S-G-UUM---"] = [
                E["GR.IC.MILITARY INTELLIGENCE"]
            ], I["S-G-UUMA--"] = [
                E["GR.IC.MILITARY INTELLIGENCE"],
                E["GR.M1.UNMANNED AERIAL VEHICLE"]
            ], I["S-G-UUMS--"] = [
                s._translate(-25, 0, E["GR.IC.MILITARY INTELLIGENCE"]),
                E["GR.IC.RADIO"]
            ], I["S-G-UUMSE-"] = [
                E["GR.IC.ELECTRONIC WARFARE"]
            ], I["S-G-UUMSEA"] = [
                E["GR.IC.ELECTRONIC WARFARE"],
                E["GR.IC.FF.RECONNAISSANCE"],
                E["GR.IC.ARMOUR"],
                E["GR.M2.WHEELED"]
            ], I["S-G-UUMSED"] = [
                E["GR.IC.ELECTRONIC WARFARE"],
                E["GR.IC.FF.DIRECTION FINDING"]
            ], I["S-G-UUMSEI"] = [
                E["GR.IC.ELECTRONIC WARFARE"],
                E["GR.IC.FF.INTERCEPT"]
            ], I["S-G-UUMSEJ"] = [
                E["GR.IC.ELECTRONIC WARFARE"],
                E["GR.IC.FF.JAMMING"]
            ], I["S-G-UUMSET"] = [
                E["GR.IC.ELECTRONIC WARFARE"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-UUMSEC"] = [
                E["GR.IC.ELECTRONIC WARFARE"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-UUMC--"] = [
                E["GR.IC.COUNTER-INTELLIGENCE"]
            ], I["S-G-UUMR--"] = [
                E["GR.IC.MILITARY INTELLIGENCE"]
            ], I["S-G-UUMRG-"] = [
                E["GR.IC.MILITARY INTELLIGENCE"],
                E["GR.M1.RADAR"]
            ], I["S-G-UUMRS-"] = [
                s._translate(0, 30, s._scale(.8, E["GR.IC.MILITARY INTELLIGENCE"])),
                E["GR.IC.FF.SENSOR"]
            ], I["S-G-UUMRSS"] = [
                s._translate(0, 30, s._scale(.8, E["GR.IC.MILITARY INTELLIGENCE"])),
                E["GR.IC.FF.SENSOR"],
                E["GR.M1.SENSOR CONTROL MODULE"]
            ], I["S-G-UUMRX-"] = [
                E["GR.IC.MILITARY INTELLIGENCE"],
                E["GR.M1.GROUND STATION MODULE"]
            ], I["S-G-UUMMO-"] = [
                E["GR.IC.MILITARY INTELLIGENCE"],
                E["GR.M1.METEOROLOGICAL"]
            ], I["S-G-UUMO--"] = [
                E["GR.IC.MILITARY INTELLIGENCE"],
                E["GR.M1.OPERATIONS"]
            ], I["S-G-UUMT--"] = [
                E["GR.IC.MILITARY INTELLIGENCE"],
                E["GR.M1.TACTICAL EXPLOITATION"]
            ], I["S-G-UUMQ--"] = [
                E["GR.IC.INTERROGATION"]
            ], I["S-G-UUMJ--"] = [
                E["GR.IC.JOINT INTELLIGENCE CENTRE"]
            ], I["S-G-UUL---"] = [
                E["GR.IC.FF.MILITARY POLICE"],
                E["GR.IC.MILITARY POLICE"]
            ], I["S-G-UULS--"] = [
                E["GR.IC.SHORE PATROL"]
            ], I["S-G-UULM--"] = [
                E["GR.IC.MILITARY POLICE"]
            ], I["S-G-UULC--"] = [
                E["GR.IC.LAW ENFORCEMENT"]
            ], I["S-G-UULF--"] = [
                s._translate(0, -25, s._scale(.8, E["GR.IC.SHORE PATROL"])),
                E["GR.IC.AVIATION FIXED WING"]
            ], I["S-G-UULD--"] = [
                E["GR.IC.CRIMINAL INVESTIGATION DIVISION"]
            ], I["S-G-UUS---"] = [
                E["GR.IC.FF.SIGNAL"]
            ], I["S-G-UUSA--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.AREA"]
            ], I["S-G-UUSC--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.COMMUNICATIONS CONTINGENCY PACKAGE"]
            ], I["S-G-UUSCL-"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.LARGE COMMUNICATIONS CONTINGENCY PACKAGE"],
                E["GR.M2.AIRBORNE"]
            ], I["S-G-UUSO--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.OPERATIONS"]
            ], I["S-G-UUSF--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.FORWARD"]
            ], I["S-G-UUSM--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.MOBILE SUBSCRIBER EQUIPMENT"]
            ], I["S-G-UUSMS-"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.SMALL EXTENSION NODE"]
            ], I["S-G-UUSML-"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.LARGE EXTENSION NODE"]
            ], I["S-G-UUSMN-"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.NODE CENTRE"]
            ], I["S-G-UUSR--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.IC.RADIO"]
            ], I["S-G-UUSRS-"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.I.FF.SATELLITE"]
            ], I["S-G-UUSRT-"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.IC.RADIO TELETYPE CENTRE"]
            ], I["S-G-UUSRW-"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.IC.RADIO RELAY"]
            ], I["S-G-UUSS--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.M1.SIGNAL SUPPORT"]
            ], I["S-G-UUSW--"] = [
                E["GR.IC.FF.SIGNAL"],
                E["GR.IC.TELEPHONE SWITCH"]
            ], I["S-G-UUSX--"] = [
                E["GR.IC.ELECTRONIC RANGING"]
            ], I["S-G-UUI---"] = [
                E["GR.IC.INFORMATION OPERATIONS"]
            ], I["S-G-UUP---"] = I["S-G-UUX---"] = [
                E["GR.IC.FF.AMPHIBIOUS"],
                E["GR.M1.LANDING SUPPORT"]
            ], I["S-G-UUE---"] = [
                E["GR.IC.EXPLOSIVE ORDNANCE DISPOSAL"]
            ], I["S-G-UUT---"] = [
                E["GR.IC.TOPOGRAPHIC"]
            ], I["S-G-UUD---"] = [
                E["GR.IC.DRILLING"]
            ], I["S-G-US----"] = [
                E["GR.IC.COMBAT SERVICE SUPPORT"]
            ], I["S-G-USA---"] = [
                E["GR.IC.ADMINISTRATIVE"]
            ], I["S-G-USAT--"] = [
                E["GR.IC.ADMINISTRATIVE"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAC--"] = [
                E["GR.IC.ADMINISTRATIVE"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAJ--"] = [
                E["GR.IC.JUDGE ADVOCATE GENERAL"]
            ], I["S-G-USAJT-"] = [
                E["GR.IC.JUDGE ADVOCATE GENERAL"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAJC-"] = [
                E["GR.IC.JUDGE ADVOCATE GENERAL"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAO--"] = [
                E["GR.IC.POSTAL"]
            ], I["S-G-USAOT-"] = [
                E["GR.IC.POSTAL"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAOC-"] = [
                E["GR.IC.POSTAL"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAF--"] = [
                E["GR.IC.FINANCE"]
            ], I["S-G-USAFT-"] = [
                E["GR.IC.FINANCE"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAFC-"] = [
                E["GR.IC.FINANCE"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAS--"] = [
                E["GR.IC.PERSONNEL SERVICES"]
            ], I["S-G-USAST-"] = [
                E["GR.IC.PERSONNEL SERVICES"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USASC-"] = [
                E["GR.IC.PERSONNEL SERVICES"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAM--"] = [
                E["GR.IC.MORTUARY AFFAIRS"]
            ], I["S-G-USAMT-"] = [
                E["GR.IC.MORTUARY AFFAIRS"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAMC-"] = [
                E["GR.IC.MORTUARY AFFAIRS"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAR--"] = [
                E["GR.IC.RELIGIOUS SUPPORT"]
            ], I["S-G-USART-"] = [
                E["GR.IC.RELIGIOUS SUPPORT"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USARC-"] = [
                E["GR.IC.RELIGIOUS SUPPORT"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAP--"] = [
                E["GR.IC.PUBLIC AFFAIRS"]
            ], I["S-G-USAPT-"] = [
                E["GR.IC.PUBLIC AFFAIRS"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAPC-"] = [
                E["GR.IC.PUBLIC AFFAIRS"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAPB-"] = [
                E["GR.IC.PUBLIC AFFAIRS BROADCAST"]
            ], I["S-G-USAPBT"] = [
                E["GR.IC.PUBLIC AFFAIRS BROADCAST"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAPBC"] = [
                E["GR.IC.PUBLIC AFFAIRS BROADCAST"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAPM-"] = [
                E["GR.IC.JOINT INFORMATION BUREAU"]
            ], I["S-G-USAPMT"] = [
                E["GR.IC.JOINT INFORMATION BUREAU"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAPMC"] = [
                E["GR.IC.JOINT INFORMATION BUREAU"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAX--"] = [
                E["GR.IC.REPLACEMENT HOLDING UNIT"]
            ], I["S-G-USAXT-"] = [
                E["GR.IC.REPLACEMENT HOLDING UNIT"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAXC-"] = [
                E["GR.IC.REPLACEMENT HOLDING UNIT"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAL--"] = [
                E["GR.IC.LABOUR"]
            ], I["S-G-USALT-"] = [
                E["GR.IC.LABOUR"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USALC-"] = [
                E["GR.IC.LABOUR"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAW--"] = [
                E["GR.IC.MORALE, WELFARE, AND RECREATION"]
            ], I["S-G-USAWT-"] = [
                E["GR.IC.MORALE, WELFARE, AND RECREATION"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAWC-"] = [
                E["GR.IC.MORALE, WELFARE, AND RECREATION"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USAQ--"] = [
                E["GR.IC.QUARTERMASTER"]
            ], I["S-G-USAQT-"] = [
                E["GR.IC.QUARTERMASTER"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USAQC-"] = [
                E["GR.IC.QUARTERMASTER"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USM---"] = [
                E["GR.IC.FF.MEDICAL"]
            ], I["S-G-USMT--"] = [
                E["GR.IC.FF.MEDICAL THEATER"]
            ], I["S-G-USMC--"] = [
                E["GR.IC.FF.MEDICAL CORPS"]
            ], I["S-G-USMM--"] = [
                E["GR.IC.FF.MEDICAL"],
                E["GR.IC.FF.MEDICAL TREATMENT FACILITY"]
            ], I["S-G-USMMT-"] = [
                E["GR.IC.FF.MEDICAL THEATER"],
                E["GR.IC.FF.MEDICAL TREATMENT FACILITY"]
            ], I["S-G-USMMC-"] = [
                E["GR.IC.FF.MEDICAL CORPS"],
                E["GR.IC.FF.MEDICAL TREATMENT FACILITY"]
            ], I["S-G-USMV--"] = [
                E["GR.IC.FF.MEDICAL"],
                E["GR.M2.VETERINARY"]
            ], I["S-G-USMVT-"] = [
                E["GR.IC.FF.MEDICAL THEATER"],
                E["GR.M2.VETERINARY"]
            ], I["S-G-USMVC-"] = [
                E["GR.IC.FF.MEDICAL CORPS"],
                E["GR.M2.VETERINARY"]
            ], I["S-G-USMD--"] = [
                E["GR.IC.FF.MEDICAL"],
                E["GR.M2.DENTAL"]
            ], I["S-G-USMDT-"] = [
                E["GR.IC.FF.MEDICAL THEATER"],
                E["GR.M2.DENTAL"]
            ], I["S-G-USMDC-"] = [
                E["GR.IC.FF.MEDICAL CORPS"],
                E["GR.M2.DENTAL"]
            ], I["S-G-USMP--"] = [
                E["GR.IC.FF.MEDICAL"],
                E["GR.M2.PSYCHOLOGICAL"]
            ], I["S-G-USMPT-"] = [
                E["GR.IC.FF.MEDICAL THEATER"],
                E["GR.M2.PSYCHOLOGICAL"]
            ], I["S-G-USMPC-"] = [
                E["GR.IC.FF.MEDICAL CORPS"],
                E["GR.M2.PSYCHOLOGICAL"]
            ], I["S-G-USS---"] = [
                E["GR.IC.FF.SUPPLY"]
            ], I["S-G-USST--"] = [
                E["GR.IC.FF.SUPPLY THEATER"]
            ], I["S-G-USSC--"] = [
                E["GR.IC.FF.SUPPLY CORPS"]
            ], I["S-G-USS1--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS I"]
            ], I["S-G-USS1T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS I"]
            ], I["S-G-USS1C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS I"]
            ], I["S-G-USS2--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS II"]
            ], I["S-G-USS2T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS II"]
            ], I["S-G-USS2C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS II"]
            ], I["S-G-USS3--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS III"]
            ], I["S-G-USS3T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS III"]
            ], I["S-G-USS3C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS III"]
            ], I["S-G-USS3A-"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS III"],
                s._translate(25, 5, s._scale(.5, E["GR.IC.AVIATION ROTARY WING"]))
            ], I["S-G-USS3AT"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS III"],
                s._translate(25, 5, s._scale(.5, E["GR.IC.AVIATION ROTARY WING"]))
            ], I["S-G-USS3AC"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS III"],
                s._translate(25, 5, s._scale(.5, E["GR.IC.AVIATION ROTARY WING"]))
            ], I["S-G-USS4--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS IV"]
            ], I["S-G-USS4T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS IV"]
            ], I["S-G-USS4C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS IV"]
            ], I["S-G-USS5--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS V"]
            ], I["S-G-USS5T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS V"]
            ], I["S-G-USS5C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS V"]
            ], I["S-G-USS6--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS VI"]
            ], I["S-G-USS6T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS VI"]
            ], I["S-G-USS6C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS VI"]
            ], I["S-G-USS7--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS VII"]
            ], I["S-G-USS7T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS VII"]
            ], I["S-G-USS7C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS VII"]
            ], I["S-G-USS8--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS VIII"]
            ], I["S-G-USS8T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS VIII"]
            ], I["S-G-USS8C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS VIII"]
            ], I["S-G-USS9--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS IX"]
            ], I["S-G-USS9T-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS IX"]
            ], I["S-G-USS9C-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS IX"]
            ], I["S-G-USSX--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.CLASS X"]
            ], I["S-G-USSXT-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.FF.CLASS X"]
            ], I["S-G-USSXC-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.FF.CLASS X"]
            ], I["S-G-USSL--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.LAUNDRY/BATH"]
            ], I["S-G-USSLT-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.LAUNDRY/BATH"]
            ], I["S-G-USSLC-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.LAUNDRY/BATH"]
            ], I["S-G-USSW--"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.WATER"]
            ], I["S-G-USSWT-"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.WATER"]
            ], I["S-G-USSWC-"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.WATER"]
            ], I["S-G-USSWP-"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.WATER PURIFICATION"]
            ], I["S-G-USSWPT"] = [
                E["GR.IC.FF.SUPPLY THEATER"],
                E["GR.IC.WATER PURIFICATION"]
            ], I["S-G-USSWPC"] = [
                E["GR.IC.FF.SUPPLY CORPS"],
                E["GR.IC.WATER PURIFICATION"]
            ], I["S-G-UST---"] = [
                E["GR.IC.TRANSPORTATION"]
            ], I["S-G-USTT--"] = [
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.IC.TRANSPORTATION"]
            ], I["S-G-USTC--"] = [
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.IC.TRANSPORTATION"]
            ], I["S-G-USTM--"] = [
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.MOVEMENT CONTROL CENTRE"]
            ], I["S-G-USTMT-"] = [
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.MOVEMENT CONTROL CENTRE"]
            ], I["S-G-USTMC-"] = [
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.MOVEMENT CONTROL CENTRE"]
            ], I["S-G-USTR--"] = [
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.RAILROAD"]
            ], I["S-G-USTRT-"] = [
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.RAILROAD"]
            ], I["S-G-USTRC-"] = [
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.RAILROAD"]
            ], I["S-G-USTS--"] = [
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.NAVAL"]
            ], I["S-G-USTST-"] = [
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.NAVAL"]
            ], I["S-G-USTSC-"] = [
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.NAVAL"]
            ], I["S-G-USTA--"] = [
                E["GR.IC.TRANSPORTATION"],
                E["GR.IC.AIRPORT OF DEBARKATION"]
            ], I["S-G-USTAT-"] = [
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.IC.AIRPORT OF DEBARKATION"]
            ], I["S-G-USTAC-"] = [
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.IC.AIRPORT OF DEBARKATION"]
            ], I["S-G-USTI--"] = [
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.MISSILE"]
            ], I["S-G-USTIT-"] = [
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.MISSILE"]
            ], I["S-G-USTIC-"] = [
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.IC.TRANSPORTATION"],
                E["GR.M1.MISSILE"]
            ], I["S-G-USX---"] = [
                E["GR.IC.MAINTENANCE"]
            ], I["S-G-USXT--"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.THEATRE SUPPORT"]
            ], I["S-G-USXC--"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.CORPS SUPPORT"]
            ], I["S-G-USXH--"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.M2.HEAVY"]
            ], I["S-G-USXHT-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.M2.HEAVY"]
            ], I["S-G-USXHC-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.M2.HEAVY"]
            ], I["S-G-USXR--"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.M2.RAILROAD"]
            ], I["S-G-USXRT-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.M2.RAILROAD"]
            ], I["S-G-USXRC-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.M2.RAILROAD"]
            ], I["S-G-USXO--"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.M1.AMMUNITION"]
            ], I["S-G-USXOT-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.M1.AMMUNITION"]
            ], I["S-G-USXOC-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.M1.AMMUNITION"]
            ], I["S-G-USXOM-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.M1.MISSILE"]
            ], I["S-G-USXOMT"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.M1.MISSILE"]
            ], I["S-G-USXOMC"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.M1.MISSILE"]
            ], I["S-G-USXE--"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.M1.ELECTRO-OPTICAL"]
            ], I["S-G-USXET-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.THEATRE SUPPORT"],
                E["GR.M1.ELECTRO-OPTICAL"]
            ], I["S-G-USXEC-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.IC.FF.CORPS SUPPORT"],
                E["GR.M1.ELECTRO-OPTICAL"]
            ], I["S-G-USXBDR"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.M2.BATTLE DAMAGE REPAIR"]
            ], I["S-G-USXPM-"] = [
                E["GR.IC.MAINTENANCE"],
                E["GR.M2.PREVENTIVE MAINTENANCE"]
            ], I["S-G-USXP--"] = [
                E["GR.IC.PIPELINE"]
            ], I["S-G-USXEP-"] = [
                E["GR.IC.ENVIRONMENTAL PROTECTION"]
            ], I["S-G-UH----"] = [], I["S-G-UH1---"] = [
                E["GR.IC.FF.HEADQUARTERS OR HEADQUARTERS ELEMENT"]
            ], I["S-G-UH2---"] = [
                E["GR.IC.FF.SUPPLY"],
                E["GR.IC.FF.HEADQUARTERS OR HEADQUARTERS ELEMENT"]
            ], I["S-G-UHGL--"] = I["S-G-GL----"] = [
                E["GR.IC.LIAISON"]
            ];
        }
    }, x = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            c
        ],
        icons: function(I, t, E, R) {
            I["S-G-E-----"] = [], I["S-G-EW----"] = [], I["S-G-EWM---"] = [
                E["GR.EQ.MISSILE LAUNCHER"]
            ], I["S-G-EWMA--"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"]
            ], I["S-G-EWMAS-"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWMASR"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.SHORT RANGE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"]
            ], I["S-G-EWMASE"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.SHORT RANGE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"]
            ], I["S-G-EWMAI-"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWMAIR"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.INTERMEDIATE RANGE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"]
            ], I["S-G-EWMAIE"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.INTERMEDIATE RANGE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"]
            ], I["S-G-EWMAL-"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWMALR"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.LONG RANGE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"]
            ], I["S-G-EWMALE"] = [
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                E["GR.EQ.LONG RANGE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"]
            ], I["S-G-EWMAT-"] = [
                s._translate(0, -15, s._scale(.7, E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"])),
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR THEATRE"]
            ], I["S-G-EWMATR"] = [
                s._translate(0, -15, s._scale(.7, E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"])),
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR THEATRE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"]
            ], I["S-G-EWMATE"] = [
                s._translate(0, -15, s._scale(.7, E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"])),
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR THEATRE"],
                E["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"]
            ], I["S-G-EWMS--"] = [
                E["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"]
            ], I["S-G-EWMSS-"] = [
                E["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWMSI-"] = [
                E["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWMSL-"] = [
                E["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWMT--"] = [
                E["GR.EQ.ANTITANK MISSILE LAUNCHER"]
            ], I["S-G-EWMTL-"] = [
                E["GR.EQ.ANTITANK MISSILE LAUNCHER"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWMTM-"] = [
                E["GR.EQ.ANTITANK MISSILE LAUNCHER"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWMTH-"] = [
                E["GR.EQ.ANTITANK MISSILE LAUNCHER"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWS---"] = [
                E["GR.EQ.SINGLE ROCKET LAUNCHER"]
            ], I["S-G-EWSL--"] = [
                E["GR.EQ.SINGLE ROCKET LAUNCHER"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWSM--"] = [
                E["GR.EQ.SINGLE ROCKET LAUNCHER"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWSH--"] = [
                E["GR.EQ.SINGLE ROCKET LAUNCHER"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWX---"] = [
                E["GR.EQ.MULTIPLE ROCKET LAUNCHER"]
            ], I["S-G-EWXL--"] = [
                E["GR.EQ.MULTIPLE ROCKET LAUNCHER"],
                s._translate(0, 10, E["GR.EQ.SHORT RANGE"])
            ], I["S-G-EWXM--"] = [
                E["GR.EQ.MULTIPLE ROCKET LAUNCHER"],
                s._translate(0, 10, E["GR.EQ.INTERMEDIATE RANGE"])
            ], I["S-G-EWXH--"] = [
                E["GR.EQ.MULTIPLE ROCKET LAUNCHER"],
                s._translate(0, 10, E["GR.EQ.LONG RANGE"])
            ], I["S-G-EWT---"] = [
                E["GR.EQ.ANTITANK ROCKET LAUNCHER"]
            ], I["S-G-EWTL--"] = [
                E["GR.EQ.ANTITANK ROCKET LAUNCHER"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWTM--"] = [
                E["GR.EQ.ANTITANK ROCKET LAUNCHER"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWTH--"] = [
                E["GR.EQ.ANTITANK ROCKET LAUNCHER"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWR---"] = [
                E["GR.EQ.RIFLE"]
            ], I["S-G-EWRR--"] = [
                E["GR.EQ.RIFLE"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWRL--"] = [
                E["GR.EQ.RIFLE"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWRH--"] = [
                E["GR.EQ.RIFLE"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWZ---"] = [
                E["GR.EQ.GRENADE LAUNCHER"]
            ], I["S-G-EWZL--"] = [
                E["GR.EQ.GRENADE LAUNCHER"],
                s._translate(0, 20, E["GR.EQ.SHORT RANGE"])
            ], I["S-G-EWZM--"] = [
                E["GR.EQ.GRENADE LAUNCHER"],
                s._translate(0, 20, E["GR.EQ.INTERMEDIATE RANGE"])
            ], I["S-G-EWZH--"] = [
                E["GR.EQ.GRENADE LAUNCHER"],
                s._translate(0, 20, E["GR.EQ.LONG RANGE"])
            ], I["S-G-EWO---"] = [
                E["GR.EQ.MORTAR"]
            ], I["S-G-EWOL--"] = [
                E["GR.EQ.MORTAR"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWOM--"] = [
                E["GR.EQ.MORTAR"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWOH--"] = [
                E["GR.EQ.MORTAR"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWH---"] = [
                E["GR.EQ.HOWITZER"]
            ], I["S-G-EWHL--"] = [
                E["GR.EQ.HOWITZER"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWHLS-"] = [
                s._translate(0, -15, s._scale(.8, [
                    E["GR.EQ.HOWITZER"],
                    E["GR.EQ.SHORT RANGE"]
                ])),
                E["GR.EQ.HOWITZER TRACKED"]
            ], I["S-G-EWHM--"] = [
                E["GR.EQ.HOWITZER"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWHMS-"] = [
                s._translate(0, -15, s._scale(.8, [
                    E["GR.EQ.HOWITZER"],
                    E["GR.EQ.INTERMEDIATE RANGE"]
                ])),
                E["GR.EQ.HOWITZER TRACKED"]
            ], I["S-G-EWHH--"] = [
                E["GR.EQ.HOWITZER"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWHHS-"] = [
                s._translate(0, -15, s._scale(.8, [
                    E["GR.EQ.HOWITZER"],
                    E["GR.EQ.LONG RANGE"]
                ])),
                E["GR.EQ.HOWITZER TRACKED"]
            ], I["S-G-EWG---"] = [
                E["GR.EQ.ANTITANK GUN"]
            ], I["S-G-EWGL--"] = [
                E["GR.EQ.ANTITANK GUN"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWGM--"] = [
                E["GR.EQ.ANTITANK GUN"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWGH--"] = [
                E["GR.EQ.ANTITANK GUN"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWGR--"] = [
                E["GR.EQ.RECOILLESS GUN"]
            ], I["S-G-EWD---"] = [
                E["GR.EQ.DIRECT FIRE GUN"]
            ], I["S-G-EWDL--"] = [
                E["GR.EQ.DIRECT FIRE GUN"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWDLS-"] = [
                s._translate(0, -15, s._scale(.8, [
                    E["GR.EQ.DIRECT FIRE GUN"],
                    E["GR.EQ.SHORT RANGE"]
                ])),
                E["GR.EQ.HOWITZER TRACKED"]
            ], I["S-G-EWDM--"] = [
                E["GR.EQ.DIRECT FIRE GUN"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWDMS-"] = [
                s._translate(0, -15, s._scale(.8, [
                    E["GR.EQ.DIRECT FIRE GUN"],
                    E["GR.EQ.INTERMEDIATE RANGE"]
                ])),
                E["GR.EQ.HOWITZER TRACKED"]
            ], I["S-G-EWDH--"] = [
                E["GR.EQ.DIRECT FIRE GUN"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EWDHS-"] = [
                s._translate(0, -15, s._scale(.8, [
                    E["GR.EQ.DIRECT FIRE GUN"],
                    E["GR.EQ.LONG RANGE"]
                ])),
                E["GR.EQ.HOWITZER TRACKED"]
            ], I["S-G-EWA---"] = [
                E["GR.EQ.AIR DEFENCE GUN"]
            ], I["S-G-EWAL--"] = [
                E["GR.EQ.AIR DEFENCE GUN"],
                E["GR.EQ.SHORT RANGE"]
            ], I["S-G-EWAM--"] = [
                E["GR.EQ.AIR DEFENCE GUN"],
                E["GR.EQ.INTERMEDIATE RANGE"]
            ], I["S-G-EWAH--"] = [
                E["GR.EQ.AIR DEFENCE GUN"],
                E["GR.EQ.LONG RANGE"]
            ], I["S-G-EV----"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"]
            ], I["S-G-EVA---"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                E["GR.EQ.ARMOURED VEHICLE"]
            ], I["S-G-EVAT--"] = [
                E["GR.EQ.TANK"]
            ], I["S-G-EVATL-"] = [
                E["GR.EQ.TANK"],
                E["GR.EQ.LIGHT TANK"]
            ], I["S-G-EVATLR"] = I["S-G-EVATW-"] = [
                E["GR.EQ.TANK"],
                E["GR.EQ.LIGHT TANK"],
                E["GR.EQ.TANK RECOVERY VEHICLE"]
            ], I["S-G-EVATM-"] = [
                E["GR.EQ.TANK"],
                E["GR.EQ.MEDIUM TANK"]
            ], I["S-G-EVATMR"] = I["S-G-EVATX-"] = [
                E["GR.EQ.TANK"],
                E["GR.EQ.MEDIUM TANK"],
                E["GR.EQ.TANK RECOVERY VEHICLE"]
            ], I["S-G-EVATH-"] = [
                E["GR.EQ.TANK"],
                E["GR.EQ.HEAVY TANK"]
            ], I["S-G-EVATHR"] = I["S-G-EVATY-"] = [
                E["GR.EQ.TANK"],
                E["GR.EQ.HEAVY TANK"],
                E["GR.EQ.TANK RECOVERY VEHICLE"]
            ], I["S-G-EVAA--"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER"]
            ], I["S-G-EVAAR-"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                E["GR.EQ.TANK RECOVERY VEHICLE"]
            ], I["S-G-EVAI--"] = [
                E["GR.EQ.ARMOURED FIGHTING VEHICLE"]
            ], I["S-G-EVAC--"] = [
                E["GR.EQ.ARMOURED FIGHTING VEHICLE (AFV) COMMAND AND CONTROL"]
            ], I["S-G-EVAS--"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER COMBAT SERVICE SUPPORT VEHICLE"]
            ], I["S-G-EVAL--"] = [
                E["GR.EQ.ARMOURED FIGHTING VEHICLE"],
                E["GR.EQ.CROSS-COUNTRY"]
            ], I["S-G-EVU---"] = [
                E["GR.EQ.UTILITY VEHICLE"]
            ], I["S-G-EVUB--"] = [
                E["GR.EQ.BUS"]
            ], I["S-G-EVUS--"] = [
                E["GR.EQ.SEMI-TRAILER TRUCK"]
            ], I["S-G-EVUSL-"] = [
                E["GR.EQ.SEMI-TRAILER TRUCK"],
                E["GR.EQ.UTILITY VEHICLE LIGHT"]
            ], I["S-G-EVUSM-"] = [
                E["GR.EQ.SEMI-TRAILER TRUCK"],
                E["GR.EQ.UTILITY VEHICLE MEDIUM"]
            ], I["S-G-EVUSH-"] = [
                E["GR.EQ.SEMI-TRAILER TRUCK"],
                E["GR.EQ.UTILITY VEHICLE HEAVY"]
            ], I["S-G-EVUL--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.LIMITED CROSS-COUNTRY"]
            ], I["S-G-EVUX--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.CROSS-COUNTRY"]
            ], I["S-G-EVUR--"] = [
                E["GR.EQ.WATER VEHICLE"]
            ], I["S-G-EVUT--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.UTILITY VEHICLE.TOW TRUCK"]
            ], I["S-G-EVUTL-"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.UTILITY VEHICLE.TOW TRUCK"],
                E["GR.EQ.UTILITY VEHICLE.TOW TRUCK.LIGHT"]
            ], I["S-G-EVUTH-"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.UTILITY VEHICLE.TOW TRUCK"],
                E["GR.EQ.UTILITY VEHICLE.TOW TRUCK.HEAVY"]
            ], I["S-G-EVUA--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.MEDICAL EVACUATION"]
            ], I["S-G-EVUAA-"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                E["GR.EQ.MEDICAL EVACUATION"]
            ], I["S-G-EVE---"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                s._scale(.7, E["GR.IC.ENGINEER"])
            ], I["S-G-EVEB--"] = [
                E["GR.EQ.BRIDGE"]
            ], I["S-G-EVEE--"] = [
                E["GR.EQ.EARTHMOVER"]
            ], I["S-G-EVEC--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.LIMITED CROSS-COUNTRY"],
                s._scale(.6, E["GR.IC.ENGINEER"])
            ], I["S-G-EVEM--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.MINE LAYING VEHICLE"]
            ], I["S-G-EVEMA-"] = [
                E["GR.EQ.MINE CLEARING EQUIPMENT"],
                E["GR.EQ.TANK"]
            ], I["S-G-EVEMV-"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                E["GR.EQ.ARMORED CARRIER WITH VOLCANO"]
            ], I["S-G-EVEMT-"] = [
                E["GR.EQ.MINE CLEARING EQUIPMENT"],
                s._translate(0, -10, E["GR.EQ.LIMITED CROSS-COUNTRY"])
            ], I["S-G-EVEML-"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.LIMITED CROSS-COUNTRY"],
                E["GR.EQ.ARMORED CARRIER WITH VOLCANO"]
            ], I["S-G-EVEA--"] = [
                E["GR.EQ.MINE CLEARING EQUIPMENT"]
            ], I["S-G-EVEAA-"] = [
                E["GR.EQ.MINE CLEARING EQUIPMENT"],
                E["GR.EQ.TANK"]
            ], I["S-G-EVEAT-"] = [
                E["GR.EQ.MINE CLEARING EQUIPMENT"],
                s._translate(0, -10, E["GR.EQ.LIMITED CROSS-COUNTRY"])
            ], I["S-G-EVEMSM"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                E["GR.EQ.MINE SCATTERABLE"]
            ], I["S-G-EVED--"] = [
                E["GR.EQ.DOZER"]
            ], I["S-G-EVEDA-"] = [
                E["GR.EQ.DOZER ARMORED"]
            ], I["S-G-EVES--"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                s._scale(.6, E["GR.IC.ENGINEER"])
            ], I["S-G-EVER--"] = [
                E["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                s._scale(.6, E["GR.IC.ENGINEER"]),
                E["GR.EQ.ARMOURED PERSONNEL CARRIER ENGINEER RECON VEHICLE"]
            ], I["S-G-EVEH--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.LIMITED CROSS-COUNTRY"],
                E["GR.EQ.UTILITY VEHICLE BACKHOE"]
            ], I["S-G-EVEF--"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.CROSS-COUNTRY"],
                E["GR.EQ.UTILITY VEHICLE FERRY TRANSPORTER"]
            ], I["S-G-EVD---"] = [
                E["GR.EQ.UTILITY VEHICLE"],
                E["GR.EQ.CROSS-COUNTRY"],
                s._scale(.7, E["GR.IC.DRILLING"])
            ], I["S-G-EVT---"] = [
                E["GR.EQ.TRAIN LOCOMOTIVE"]
            ], I["S-G-EVC---"] = [
                E["GR.I.CIVILIAN"]
            ], I["S-G-EVCA--"] = [
                E["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"]
            ], I["S-G-EVCAL-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"],
                E["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
            ], I["S-G-EVCAM-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"],
                E["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
            ], I["S-G-EVCAH-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"],
                E["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
            ], I["S-G-EVCO--"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"]
            ], I["S-G-EVCOL-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                E["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
            ], I["S-G-EVCOM-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                E["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
            ], I["S-G-EVCOH-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                E["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
            ], I["S-G-EVCM--"] = [
                E["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"]
            ], I["S-G-EVCML-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
            ], I["S-G-EVCMM-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
            ], I["S-G-EVCMH-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
            ], I["S-G-EVCU--"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"]
            ], I["S-G-EVCUL-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
            ], I["S-G-EVCUM-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
            ], I["S-G-EVCUH-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
            ], I["S-G-EVCJ--"] = [
                E["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"]
            ], I["S-G-EVCJL-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
            ], I["S-G-EVCJM-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
            ], I["S-G-EVCJH-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
            ], I["S-G-EVCT--"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVCTL-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.LIGHT"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVCTM-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.MEDIUM"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVCTH-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                E["GR.EQ.CIVILIAN VEHICLE.HEAVY"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVCF--"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVCFL-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                E["GR.EQ.CIVILIAN VEHICLE.LIGHT"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVCFM-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                E["GR.EQ.CIVILIAN VEHICLE.MEDIUM"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVCFH-"] = [
                E["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                E["GR.EQ.CIVILIAN VEHICLE.HEAVY"],
                E["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
            ], I["S-G-EVM---"] = [
                E["GR.EQ.PACK ANIMAL"]
            ], I["S-G-EVS---"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                E["GR.EQ.MISSILE SUPPORT"]
            ], I["S-G-EVST--"] = R ? [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                E["GR.EQ.MISSILE TRANSLOADER"]
            ] : [
                E["GR.EQ.TRAIN LOCOMOTIVE"]
            ], I["S-G-EVSR--"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                E["GR.EQ.MISSILE TRANSPORTER"]
            ], I["S-G-EVSC--"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                E["GR.EQ.MISSILE CRANE/LOADING DEVICE"]
            ], I["S-G-EVSP--"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                E["GR.EQ.MISSILE PROPELLANT TRANSPORTER"]
            ], I["S-G-EVSW--"] = [
                E["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                E["GR.EQ.MISSILE WARHEAD TRANSPORTER"]
            ], I["S-G-ES----"] = [
                E["GR.EQ.SENSOR"]
            ], I["S-G-ESR---"] = [
                E["GR.EQ.RADAR"]
            ], I["S-G-ESE---"] = [
                E["GR.EQ.SENSOR EMPLACED"]
            ], I["S-G-EXI---"] = [
                E["GR.EQ.IMPROVISED EXPLOSIVE DEVICE"]
            ], I["S-G-EX----"] = [], I["S-G-EXL---"] = [
                E["GR.EQ.LASER"]
            ], I["S-G-EXN---"] = [
                E["GR.EQ.CBRN EQUIPMENT"]
            ], I["S-G-EXF---"] = [
                E["GR.EQ.FLAME THROWER"]
            ], I["S-G-EXM---"] = [
                E["GR.EQ.LAND MINES"]
            ], I["S-G-EXMC--"] = [
                E["GR.EQ.ANTIPERSONNEL LAND MINE"]
            ], I["S-G-EXML--"] = [
                E["GR.EQ.ANTIPERSONNEL LAND MINE LESS THAN LETHAL"]
            ];
            var e = {
                "E-----": 0,
                "EWM---": 140,
                "EWMA--": 140,
                "EWMAS-": 140,
                EWMASR: 140,
                EWMASE: 140,
                "EWMAI-": 140,
                EWMAIR: 140,
                EWMAIE: 140,
                "EWMAL-": 140,
                EWMALR: 140,
                EWMALE: 140,
                "EWMAT-": 153,
                EWMATR: 153,
                EWMATE: 153,
                "EWMS--": 140,
                "EWMSS-": 140,
                "EWMSI-": 140,
                "EWMSL-": 140,
                "EWMT--": 140,
                "EWMTL-": 140,
                "EWMTM-": 140,
                "EWMTH-": 140,
                "EWS---": 140,
                "EWSL--": 140,
                "EWSM--": 140,
                "EWSH--": 140,
                "EWX---": 140,
                "EWXL--": 140,
                "EWXM--": 140,
                "EWXH--": 140,
                "EWT---": 140,
                "EWTL--": 140,
                "EWTM--": 140,
                "EWTH--": 140,
                "EWR---": 140,
                "EWRL--": 140,
                "EWRM--": 140,
                "EWRH--": 140,
                "EWZ---": 140,
                "EWZL--": 140,
                "EWZM--": 140,
                "EWZH--": 140,
                "EWO---": 140,
                "EWOL--": 140,
                "EWOM--": 140,
                "EWOH--": 140,
                "EWH---": 140,
                "EWHL--": 140,
                "EWHLS-": 130,
                "EWHM--": 140,
                "EWHMS-": 130,
                "EWHH--": 140,
                "EWHHS-": 130,
                "EWG---": 140,
                "EWGL--": 140,
                "EWGM--": 140,
                "EWGH--": 140,
                "EWGR--": 140,
                "EWD---": 140,
                "EWDL--": 140,
                "EWDLS-": 130,
                "EWDM--": 140,
                "EWDMS-": 130,
                "EWDH--": 140,
                "EWDHS-": 130,
                "EWA---": 140,
                "EWAL--": 140,
                "EWAM--": 140,
                "EWAH--": 140,
                "EV----": 129,
                "EVA---": 129,
                "EVAT--": 130,
                "EVATL-": 130,
                EVATLR: 130,
                "EVATM-": 130,
                EVATMR: 130,
                "EVATH-": 130,
                EVATHR: 130,
                "EVAA--": 130,
                "EVAAR-": 130,
                "EVAI--": 130,
                "EVAC--": 130,
                "EVAS--": 130,
                "EVAL--": 140,
                "EVU---": 130,
                "EVAB--": 130,
                "EVUS--": 140,
                "EVUSL-": 140,
                "EVUSM-": 140,
                "EVUSH-": 140,
                "EVUL--": 140,
                "EVUX--": 140,
                "EVUR--": 130,
                "EVUTL-": 130,
                "EVUTH-": 130,
                "EVUA--": 130,
                "EVUAA-": 130,
                "EVE---": 129,
                "EVEB--": 130,
                "EVEE--": 130,
                "EVEC--": 140,
                "EVEM--": 130,
                "EVEMA-": 130,
                "EVEMV-": 130,
                "EVEMT-": 130,
                "EVEML-": 140,
                "EVEA--": 120,
                "EVEAA-": 130,
                "EVEAT-": 130,
                EVEMSM: 130,
                "EVED--": 130,
                "EVEDA-": 130,
                "EVES--": 130,
                "EVER--": 130,
                "EVEH--": 140,
                "EVEF--": 140,
                "EVD---": 140,
                "EVT--": 130,
                "EVC---": 119,
                "EVCA--": 132.5,
                "EVCAL-": 132.5,
                "EVCAM-": 132.5,
                "EVCAH-": 132.5,
                "EVCO--": 132.5,
                "EVCOL-": 132.5,
                "EVCOM-": 132.5,
                "EVCOH-": 132.5,
                "EVCM--": 132.5,
                "EVCML-": 132.5,
                "EVCMM-": 132.5,
                "EVCMH-": 132.5,
                "EVCU--": 132.5,
                "EVCUL-": 132.5,
                "EVCUM-": 132.5,
                "EVCUH-": 132.5,
                "EVCJ--": 132.5,
                "EVCJL-": 132.5,
                "EVCJM-": 132.5,
                "EVCJH-": 132.5,
                "EVCT--": 132.5,
                "EVCTL-": 132.5,
                "EVCTM-": 132.5,
                "EVCTH-": 132.5,
                "EVCF--": 132.5,
                "EVCFL-": 132.5,
                "EVCFM-": 132.5,
                "EVCFH-": 132.5,
                "EVM---": 125,
                "EVS---": 129,
                "EVST--": 129,
                "EVSR--": 129,
                "EVSC--": 129,
                "EVSP--": 129,
                "EVSW--": 129,
                "ES----": 140,
                "ESR---": 120,
                "ESE---": 136,
                "EXI---": 119,
                "EXL---": 145,
                "EXN---": 140,
                "EXF---": 135,
                "EXM---": 130,
                "EXMC--": 122,
                "EXML--": 122
            };
            for(var A in e)e.hasOwnProperty(A) && (t["S-G-" + A] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: e[A]
            });
        }
    }, U = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            c
        ],
        icons: function(I, t, E, R) {
            I["S-G-I-----"] = [], I["S-G-IR----"] = [
                E["GR.IN.IC.RAW MATERIAL PRODUCTION/STORAGE"]
            ], I["S-G-IRM---"] = [
                E["GR.IN.IC.MINE"]
            ], I["S-G-IRP---"] = [
                E["GR.IC.FF.CLASS III"]
            ], I["S-G-IRN---"] = [
                E["GR.IC.CBRN"]
            ], I["S-G-IRNB--"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.BIOLOGICAL"]
            ], I["S-G-IRNC--"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.CHEMICAL"]
            ], I["S-G-IRNN--"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.NUCLEAR"]
            ], I["S-G-IP----"] = [
                E["GR.IN.IC.PROCESSING FACILITY"]
            ], I["S-G-IPD---"] = [
                E["GR.IC.CBRN"],
                E["GR.M1.DECONTAMINATION"]
            ], I["S-G-IE----"] = [
                E["GR.IC.EQUIPMENT MANUFACTURE"]
            ], I["S-G-IU----"] = [
                E["GR.IN.IC.UTILITY FACILITY"]
            ], I["S-G-IUR---"] = [
                E["GR.IN.IC.RESEARCH"]
            ], I["S-G-IUT---"] = [
                E["GR.IN.IC.TELECOMMUNICATIONS"]
            ], I["S-G-IUE---"] = [
                E["GR.IN.IC.ELECTRIC POWER"]
            ], I["S-G-IUEN--"] = [
                E["GR.IN.IC.ELECTRIC POWER"],
                E["GR.IN.IC.ELECTRIC POWER NUCLEAR"]
            ], I["S-G-IUED--"] = [
                E["GR.IN.IC.ELECTRIC POWER"],
                E["GR.IN.IC.ELECTRIC POWER DAM"]
            ], I["S-G-IUEF--"] = [
                E["GR.IN.IC.ELECTRIC POWER"],
                E["GR.IN.IC.ELECTRIC POWER FOSSIL"]
            ], I["S-G-IUP---"] = [
                E["GR.IC.WATER"]
            ], I["S-G-IM----"] = [], I["S-G-IMF---"] = [
                E["GR.IN.IC.ATOMIC ENERGY"]
            ], I["S-G-IMFA--"] = [
                E["GR.IN.IC.ATOMIC ENERGY"],
                E["GR.IN.M2.ATOMIC ENERGY REACTOR"]
            ], I["S-G-IMFP--"] = [
                E["GR.IN.IC.ATOMIC ENERGY"],
                E["GR.IN.M2.NUCLEAR MATERIAL PRODUCTION"]
            ], I["S-G-IMFPW-"] = [
                E["GR.IN.IC.ATOMIC ENERGY WEAPONS GRADE"],
                E["GR.IN.M2.NUCLEAR MATERIAL PRODUCTION"]
            ], I["S-G-IMFS--"] = [
                E["GR.IN.IC.ATOMIC ENERGY"],
                E["GR.IN.M2.NUCLEAR MATERIAL STORAGE"]
            ], I["S-G-IMA---"] = [
                E["GR.IN.IC.AIRCRAFT PRODUCTION & ASSEMBLY"]
            ], I["S-G-IME---"] = [
                E["GR.IC.FF.CLASS V"]
            ], I["S-G-IMG---"] = [
                E["GR.EQ.TANK"]
            ], I["S-G-IMV---"] = [
                E["GR.IC.MAINTENANCE"]
            ], I["S-G-IMN---"] = [
                E["GR.EQ.DOZER"]
            ], I["S-G-IMNB--"] = [
                E["GR.IN.IC.BRIDGE"]
            ], I["S-G-IMC---"] = [
                E["GR.IC.CBRN"],
                E["GR.IN.M2.CHEMICAL & BIOLOGICAL WARFARE"]
            ], I["S-G-IMS---"] = [
                E["GR.IC.NAVAL"],
                E["GR.IN.M2.SHIP CONSTRUCTION"]
            ], I["S-G-IMM---"] = [
                E["GR.IC.MISSILE"]
            ], I["S-G-IG----"] = [
                E["GR.I.GOVERNMENT"]
            ], I["S-G-IB----"] = [
                E["GR.IN.IC.BASE"]
            ], I["S-G-IBA---"] = [
                E["GR.IC.TRANSPORTATION"],
                E["GR.IC.AIRPORT OF DEBARKATION"]
            ], I["S-G-IBN---"] = [
                E["GR.IC.NAVAL"]
            ], I["S-G-IT----"] = [
                E["GR.IC.TRANSPORTATION"]
            ], I["S-G-IX----"] = [
                E["GR.IC.FF.MEDICAL"]
            ], I["S-G-IXH---"] = [
                E["GR.IC.FF.MEDICAL TREATMENT FACILITY"]
            ], I["S-G-IRR---"] = I["S-G-IRSR--"] = [
                E["GR.IN.IC.SEA SURFACE INSTALLATION, OIL RIG/PLATFORM"]
            ];
        }
    };
    function d(I, t, E, R, e, A) {
        var C = t.frame, T = t.affiliation || "Friend", S = t.numberSIDC, N = E.iconColor[T], O = E.iconFillColor[T], G = E.black[T], o = E.white[T], M = {};
        for(var i in M["SE.IC.MILITARY"] = a("MIL"), M["SE.IC.MANUAL TRACK"] = a("MAN"), M["SE.IC.COMBATANT"] = [
            {
                type: "path",
                d: "m 86.9,110 c -3.6,2 -7.2,3.9 -10.8,5.9 2.1,2.9 6.7,3.9 10,2.1 2.6,-0.9 4.7,-3.8 3.1,-6.1 -0.8,-0.6 -1.5,-1.3 -2.3,-1.9 z m 26.3,0.1 c 3.6,2 7.2,3.9 10.8,5.9 -2.1,2.9 -6.7,3.9 -10,2.1 -2.6,-0.9 -4.7,-3.8 -3.1,-6.1 0.8,-0.6 1.5,-1.3 2.3,-1.9 z",
                fill: !1
            },
            {
                type: "path",
                d: "m 112.9,110 c -5.6,-4 -11.3,-7.9 -16.1,-12.5 -4.2,-4.5 -7,-9.8 -9.2,-15.1 -0.8,4.4 -0.9,9.3 2.4,13.2 3.6,4.5 8.6,8.1 13.5,11.8 2.3,1.7 4.7,3.3 7.1,4.8 0.8,-0.7 1.5,-1.5 2.3,-2.2 m -25.7,0 c 5.6,-4 11.3,-7.9 16.1,-12.5 4.2,-4.5 7,-9.8 9.2,-15.1 0.8,4.4 0.9,9.3 -2.4,13.2 -3.6,4.5 -8.6,8.1 -13.5,11.8 -2.3,1.7 -4.7,3.3 -7.1,4.8 -0.8,-0.7 -1.5,-1.5 -2.3,-2.2",
                fill: o,
                strokewidth: 2
            }
        ], M["SE.IC.SURFACE COMBATANT, LINE"] = {
            type: "path",
            stroke: !1,
            d: "m 100,120 -25,-17 15,2 0,-10 5,0 0,-5 -15,0 0,-5 15,0 0,-5 10,0 0,5 15,0 0,5 -15,0 0,5 5,0 0,10 15,-2 z"
        }, M["SE.IC.CARRIER"] = {
            type: "path",
            d: "m 80,100 20,20 20,-20 -20,0 0,-20 -20,0 z"
        }, M["SE.IC.BATTLESHIP"] = a("BB"), M["SE.IC.CIVILIAN"] = a("CIV"), M["SE.IC.CIVILIAN"].fill = R || S ? O : !C && O, M["SE.IC.CIVILIAN"].stroke = G, M["SE.IC.CIVILIAN"].strokewidth = 3, M["SE.IC.CRUISER"] = a("CC"), M["SE.IC.CRUISER, GUIDED MISSILE"] = a("CG"), M["SE.IC.DESTROYER"] = a("DD"), M["SE.IC.FRIGATE"] = a("FF"), M["SE.IC.CORVETTE"] = a("FS"), M["SE.IC.LITTORAL COMBATANT SHIP"] = a("LL"), M["SE.IC.AMPHIBIOUS WARFARE SHIP"] = {
            type: "path",
            d: "m 100,120 20,0 m -20,0 -20,-20 10,0 0,-20 20,0 0,20 10,0 z"
        }, M["SE.IC.AMPHIBIOUS FORCE FLAGSHIP"] = a("LCC"), M["SE.IC.AMPHIBIOUS ASSAULT"] = a("LA"), M["SE.IC.AMPHIBIOUS ASSAULT SHIP, GENERAL"] = a("LHA"), M["SE.IC.AMPHIBIOUS ASSAULT SHIP, MULTI-PURPOSE"] = a("LHD"), M["SE.IC.AMPHIBIOUS TRANSPORT, DOCK"] = a("LPD"), M["SE.IC.AMPHIBIOUS ASSAULT SHIP, HELICOPTER"] = a("LPH"), M["SE.IC.LANDING SHIP"] = a("LS"), M["SE.IC.LANDING CRAFT"] = a("LC"), M["SE.IC.MINE WARFARE VESSEL"] = {
            type: "path",
            d: "m 98.3,81 0,4.1 c -2.4,0.3 -4.6,1.4 -6.4,2.9 l -3.5,-3.5 -2.4,2.4 3.6,3.6 c -0.9,1.3 -1.5,4.9 -1.8,6.5 l -10.8,0 0,3 3,0 20,20 20,-20 3,0 0,-3 -10,0 c -1,-1.7 -2,-5.3 -3,-6.7 l 4,-3.7 -2,-2.4 -4,3.6 c -2,-1.4 -4,-2.4 -6,-2.7 l 0,-4.1 z"
        }, M["SE.IC.MINELAYER"] = a("ML"), M["SE.IC.MINESWEEPER"] = a("MS"), M["SE.IC.MINESWEEPER, DRONE"] = a("MSD"), M["SE.IC.MINEHUNTER"] = a("MH"), M["SE.IC.MINE COUNTER MEASURE SUPPORT SHIP"] = a(R ? "MA" : "MCS"), M["SE.IC.MINE COUNTERMEASURES"] = a("MCM"), M["SE.IC.SEA SURFACE DECOY"] = {
            type: "path",
            d: "M 105,110 90,95 105,80 z M 85,110 70,95 85,80 z m 40,-30 -15,15 15,15 z m -55,40 0,-5 55,0 0,5 z"
        }, M["SE.IC.PATROL"] = {
            type: "path",
            d: "m 80,100 20,20 20,-20 -10,0 0,-20 -20,0 0,20 z"
        }, M["SE.IC.PATROL CRAFT"] = a("PC"), M["SE.IC.PATROL ANTI SUBMARINE WARFARE"] = {
            type: "path",
            d: "m 100,120 -25,-25 5,-5 10,10 5,0 0,-20 10,0 0,20 5,0 10,-10 5,5 z"
        }, M["SE.IC.PATROL ANTISHIP MISSILE"] = a("PM"), M["SE.IC.PATROL TORPEDO"] = a("PT"), M["SE.IC.PATROL GUN"] = a("PG"), M["SE.IC.PATROL SHIP"] = [], M["SE.IC.MILITARY SPEEDBOAT"] = {
            type: "path",
            stroke: !1,
            d: "m 120,120 -40,0 -15,-25 15,0 5,-15 10,0 -5,15 45,0 z"
        }, M["SE.IC.MILITARY SPEEDBOAT, RIGID-HULL INFLATABLE BOAT"] = [
            {
                type: "path",
                stroke: !1,
                d: "M 85 80 L 80 95 L 65 95 L 80 120 L 120 120 L 135 95 L 90 95 L 95 80 L 85 80 z M 87 100.7 L 93.1 100.7 C 94.6 100.7 95.7 100.8 96.4 101.1 C 97.1 101.3 97.7 101.8 98.1 102.4 C 98.5 103.1 98.7 103.8 98.7 104.7 C 98.7 105.8 98.4 106.7 97.8 107.4 C 97.1 108.1 96.2 108.5 94.9 108.7 C 95.6 109.1 96.1 109.4 96.5 109.9 C 96.9 110.3 97.4 111.1 98.1 112.2 L 99.9 115 L 96.4 115 L 94.3 111.9 C 93.6 110.8 93.1 110.1 92.8 109.8 C 92.5 109.5 92.2 109.3 91.9 109.2 C 91.6 109.1 91.2 109 90.5 109 L 89.9 109 L 89.9 115 L 87 115 L 87 100.7 z M 101.5 100.7 L 107.2 100.7 C 108.3 100.7 109.2 100.7 109.7 100.8 C 110.3 100.9 110.8 101.1 111.2 101.4 C 111.7 101.7 112 102.1 112.3 102.6 C 112.6 103.1 112.7 103.7 112.8 104.3 C 112.7 105 112.6 105.6 112.2 106.1 C 111.9 106.7 111.4 107.1 110.8 107.4 C 111.6 107.7 112.3 108.1 112.8 108.7 C 113.2 109.3 113.5 110 113.5 110.8 C 113.5 111.5 113.3 112.1 113 112.8 C 112.7 113.4 112.3 113.8 111.8 114.2 C 111.2 114.6 110.6 114.8 109.8 114.9 C 109.3 115 108.2 115 106.3 115 L 101.5 115 L 101.5 100.7 z M 104.3 103.1 L 104.3 106.4 L 106.3 106.4 C 107.4 106.4 108.1 106.3 108.3 106.3 C 108.8 106.3 109.2 106.1 109.5 105.8 C 109.8 105.5 109.9 105.1 109.9 104.7 C 109.9 104.2 109.8 103.9 109.6 103.6 C 109.3 103.3 109 103.2 108.5 103.1 C 108.2 103.1 107.4 103.1 106 103.1 L 104.3 103.1 z M 89.9 103.1 L 89.9 106.8 L 92 106.8 C 93.4 106.8 94.3 106.7 94.6 106.6 C 95 106.4 95.2 106.3 95.4 106 C 95.6 105.7 95.7 105.3 95.8 104.9 C 95.7 104.4 95.6 104 95.3 103.7 C 95.1 103.4 94.7 103.2 94.3 103.2 C 94 103.1 93.3 103.1 92.2 103.1 L 89.9 103.1 z M 104.3 108.8 L 104.3 112.6 L 107 112.6 C 108.1 112.6 108.7 112.6 109 112.5 C 109.4 112.4 109.8 112.2 110.1 111.9 C 110.3 111.6 110.5 111.2 110.5 110.7 C 110.5 110.3 110.4 109.9 110.2 109.6 C 109.9 109.3 109.6 109.1 109.3 109 C 108.9 108.8 108 108.8 106.7 108.8 L 104.3 108.8 z"
            },
            {
                type: "text",
                fill: R ? O : !C && O,
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 20,
                text: "RB"
            }
        ], M["SE.IC.MILITARY JETSKI"] = {
            type: "path",
            stroke: !1,
            d: "m 135,105 0,15 -60,0 -10,-15 20,-25 10,0 0,10 -5,0 -5,15 z"
        }, M["SE.IC.UNMANNED SURFACE WATER VEHICLE"] = {
            type: "path",
            d: "m 60,84 40,20 40,-20 0,8 -40,25 -40,-25 z",
            stroke: !1
        }, M["SE.IC.NAVY TASK ORGANIZATION UNIT"] = [
            {
                type: "path",
                d: "m 110,80 15,15 0,25 M 90,80 75,95 l 0,25",
                fill: !1
            }
        ], R && M["SE.IC.NAVY TASK ORGANIZATION UNIT"].push({
            type: "path",
            d: "m 100,80 -15,15 0,25 30,0 0,-25 -15,-15"
        }), M["SE.IC.NAVY TASK FORCE"] = [
            M["SE.IC.NAVY TASK ORGANIZATION UNIT"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: R ? 150 : 120,
                fontsize: 30,
                text: "TF"
            }
        ], M["SE.IC.NAVY TASK GROUP"] = [
            M["SE.IC.NAVY TASK ORGANIZATION UNIT"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: R ? 150 : 120,
                fontsize: 30,
                text: "TG"
            }
        ], M["SE.IC.NAVY TASK UNIT"] = [
            M["SE.IC.NAVY TASK ORGANIZATION UNIT"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: R ? 150 : 120,
                fontsize: 30,
                text: "TU"
            }
        ], M["SE.IC.NAVY TASK ELEMENT"] = [
            M["SE.IC.NAVY TASK ORGANIZATION UNIT"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: R ? 150 : 120,
                fontsize: 30,
                text: "TE"
            }
        ], M["SE.IC.CONVOY"] = {
            type: "path",
            d: "m 80,115 -20,0 0,-35 80,0 0,35 -20,0 0,-20 -40,0 z"
        }, M["SE.IC.NONCOMBATANT"] = {
            type: "path",
            d: "m 80,100 0,-20 40,0 0,20 15,0 0,20 -70,0 0,-20 z"
        }, M["SE.IC.AUXILIARY SHIP"] = a(R ? "AR" : "AA"), M["SE.IC.AMMUNITION SHIP"] = a("AE"), M["SE.IC.STORES SHIP"] = a("AF"), M["SE.IC.AUXILIARY FLAG OR COMMAND SHIP"] = a("AGF"), M["SE.IC.INTELLIGENCE COLLECTOR"] = a(R ? "JI" : "AI"), M["SE.IC.OCEAN RESEARCH SHIP"] = a("AGO"), M["SE.IC.SURVEY SHIP"] = a("AGS"), M["SE.IC.HOSPITAL SHIP"] = a("AH"), M["SE.IC.CARGO SHIP"] = a("AK"), M["SE.IC.COMBAT SUPPORT SHIP, FAST"] = a("AOE"), M["SE.IC.OILER, REPLENISHMENT"] = a("AO"), M["SE.IC.REPAIR SHIP"] = a("AR"), M["SE.IC.SUBMARINE TENDER"] = a("AS"), M["SE.IC.TUG, OCEAN GOING"] = a(R ? "AS" : "AT"), M["SE.IC.SERVICE CRAFT, YARD, GENERAL"] = a(R ? "YY" : "YT"), M["SE.IC.BARGE, NOT SELF-PROPELLED"] = a("YB"), M["SE.IC.BARGE, SELF-PROPELLED"] = a("YS"), M["SE.IC.TUG, HARBOUR"] = a("YT"), M["SE.IC.LAUNCH"] = a("YFT"), M["SE.IC.MERCHANT SHIP, GENERAL"] = {
            type: "path",
            fill: R ? O : !C && O,
            d: "m 75,100 0,-35 50,0 0,35 20,0 -15,35 -60,0 -15,-35 z"
        }, M["SE.IC.CARGO, GENERAL"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: R ? "CA" : "A"
            }
        ], M["SE.IC.CONTAINER SHIP"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "C"
            }
        ], M["SE.IC.DREDGE"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "D"
            }
        ], M["SE.IC.RADAR"] = {
            type: "path",
            d: "M72,95 l30,-25 0,25 30,-25 M70,70 c0,35 15,50 50,50",
            fill: !1
        }, M["SE.IC.ROLL ON-ROLL OFF"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: "30",
                text: R ? "RO" : "E"
            }
        ], M["SE.IC.FERRY"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: R ? "FE" : "F"
            }
        ], M["SE.IC.HEAVY LIFT"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "H"
            }
        ], M["SE.IC.HOVERCRAFT"] = {
            type: "path",
            d: R ? "m 65,100 0,-30 5,10 60,0 5,-10 0,30 10,0 -15,35 -60,0 -15,-35 z" : "m 90,80 0,15.6 C 78.4,96.9 70,100.6 70,105 c 0,5.5 13.4,10 30,10 16.6,0 30,-4.5 30,-10 0,-4.4 -8.4,-8.1 -20,-9.4 L 110,80 90,80 z m -15,40 50,0"
        }, M["SE.IC.HOVERCRAFT 2525D"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "J"
            }
        ], M["SE.IC.HOVERCRAFT CIVILIAN"] = {
            type: "path",
            fill: R ? O : !C && O,
            d: R ? "m 65,100 0,-30 5,10 60,0 5,-10 0,30 10,0 -15,35 -60,0 -15,-35 z" : "m 90,80 0,15.6 C 78.4,96.9 70,100.6 70,105 c 0,5.5 13.4,10 30,10 16.6,0 30,-4.5 30,-10 0,-4.4 -8.4,-8.1 -20,-9.4 L 110,80 90,80 z m -15,40 50,0"
        }, M["SE.IC.HOVERCRAFT NONCOMBATANT"] = [
            {
                type: "path",
                d: "m 65,100 0,-30 5,10 60,0 5,-10 0,30 10,0 -15,35 -60,0 -15,-35 z",
                strokewidth: !1
            },
            R ? {
                type: "text",
                fill: o,
                stroke: !1,
                x: 100,
                y: 120,
                fontsize: 30,
                text: "NC"
            } : []
        ], M["SE.IC.MERCHANT SHIP, LASH CARRIER (WITH BARGES)"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "L"
            }
        ], M["SE.IC.OILER/TANKER"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: R ? "OT" : "O"
            }
        ], M["SE.IC.PASSENGER SHIP"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: R ? "PA" : "P"
            }
        ], M["SE.IC.TUG, OCEAN GOING CIVILIAN"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: R ? "TU" : "T"
            }
        ], M["SE.IC.TOW"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "TW"
            }
        ], M["SE.IC.TRANSPORT SHIP, HAZARDOUS MATERIAL"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "HZ"
            }
        ], M["SE.IC.JUNK/DHOW"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "QJ"
            }
        ], M["SE.IC.BARGE, NOT SELF-PROPELLED"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 115,
                fontsize: 30,
                text: "YB"
            }
        ], M["SE.IC.HOSPITAL SHIP2"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "path",
                stroke: !1,
                d: "m 95,95 0,-15 10,0 0,15 15,0 0,10 -15,0 0,15 -10,0 0,-15 -15,0 0,-10 z"
            }
        ], M["SE.IC.FISHING VESSEL"] = {
            type: "path",
            fill: R ? O : !C && O,
            d: "m 75,100 0,-15 20,0 0,15 50,0 -15,35 -60,0 -15,-35 z M 105,57.4 105,100 m 30,-35 -30,35"
        }, M["SE.IC.DRIFTER"] = [
            M["SE.IC.FISHING VESSEL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 125,
                fontsize: 30,
                text: "DF"
            }
        ], M["SE.IC.TRAWLER"] = [
            M["SE.IC.FISHING VESSEL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 125,
                fontsize: 30,
                text: "TR"
            }
        ], M["SE.IC.FISHING VESSEL DREDGE"] = [
            M["SE.IC.FISHING VESSEL"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 125,
                fontsize: 30,
                text: "DR"
            }
        ], M["SE.IC.LAW ENFORCEMENT VESSEL"] = [
            M["SE.IC.MERCHANT SHIP, GENERAL"],
            {
                type: "path",
                d: "m 135,100 -15,35 -10,0 15,-35 z"
            }
        ], M["SE.IC.LEISURE CRAFT, SAILING BOAT"] = {
            type: "path",
            fill: R ? O : !C && O,
            d: "m 105,55 0,40 35,0 z m -5,-5 0,50 m 45,0 -15,35 -60,0 -15,-35 z"
        }, M["SE.IC.LEISURE CRAFT, MOTORIZED"] = {
            type: "path",
            fill: R ? O : !C && O,
            d: "m 70,97.4 15,-30 10,0 -15,30 65,0 -15,35 -60,0 -15,-35 z"
        }, M["SE.IC.LEISURE CRAFT, MOTORIZED, RIGID-HULL INFLATABLE BOAT"] = [
            M["SE.IC.LEISURE CRAFT, MOTORIZED"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 125,
                fontsize: 30,
                text: "RB"
            }
        ], M["SE.IC.LEISURE CRAFT, MOTORIZED, SPEEDBOAT"] = [
            M["SE.IC.LEISURE CRAFT, MOTORIZED"],
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 125,
                fontsize: 30,
                text: "SP"
            }
        ], M["SE.IC.LEISURE CRAFT, JETSKI"] = {
            type: "path",
            fill: R ? O : !C && O,
            d: "m 85,60 -30,45 10,15 75,0 0,-20 -60,0 10,-30 5,0 0,-10 z"
        }, M["SE.IC.UNMANNED SURFACE WATER VEHICLE (USV)"] = {
            type: "path",
            fill: !(!R && !S) && O,
            stroke: G,
            d: "m 60,84 40,20 40,-20 0,8 -40,25 -40,-25 z"
        }, M["SE.IC.OWN SHIP"] = {
            type: "path",
            fill: !1,
            stroke: e ? N : O,
            d: "m 50,100 100,0 m -50,-50 0,100 m 50,-50 c 0,27.6 -22.4,50 -50,50 -27.6,0 -50,-22.4 -50,-50 0,-27.6 22.4,-50 50,-50 27.6,0 50,22.4 50,50 z"
        }, M["SE.IC.DITCHED AIRCRAFT"] = {
            type: "path",
            fill: e ? N : O,
            stroke: e ? N : O,
            d: "m 145,120 -15,-15 m -15,15 15,-15 m -75,15 15,-15 m 15,15 -15,-15 m 10,10 25,-30 -10,-10 10,-10 20,20 -10,35 -15,-15 -15,15 z"
        }, M["SE.IC.PERSON IN WATER"] = {
            type: "path",
            fill: e ? N : O,
            stroke: e ? N : O,
            d: "m 105,110 10,-10 0,-15 5,0 0,20 -10,10 z m -10,0 -10,-10 0,-15 -5,0 0,20 10,10 z m 5,-5 0,-10 -5,0 -5,-5 0,-10 5,-5 10,0 5,5 0,10 -5,5 -5,0 m -15,25 15,-15 m 45,15 -15,-15 m -15,15 15,-15 m -75,15 15,-15 m 15,15 -15,-15 m 45,15 -15,-15"
        }, M["SE.IC.DISTRESSED VESSEL"] = {
            type: "path",
            fill: e ? N : O,
            stroke: e ? N : O,
            d: "m 120,65 -20,20 20,-20 m -5,55 -35,-35 0,-20 45,45 z m -30,0 -15,-15 m -15,15 15,-15 m 45,15 15,-15 m 15,15 -15,-15 m -45,15 15,-15"
        }, M["SE.IC.SEA MINELIKE"] = {
            type: "path",
            fill: e ? N : O,
            stroke: e ? N : O,
            d: "m 117.7,75 c 3.5,-3.5 7.1,-7.1 7.1,-7.1 l 7.1,7.1 -7.1,7.1 m -49.5,0 c -3.5,-3.5 -7.1,-7.1 -7.1,-7.1 l 7.1,-7.1 7.1,7.1 M 95,70 c 0,-5 0,-10 0,-10 l 10,0 0,10 m 25,30 c 0,16.6 -13.4,30 -30,30 -16.6,0 -30,-13.4 -30,-30 0,-16.6 13.4,-30 30,-30 16.6,0 30,13.4 30,30 z"
        }, M["SE.IC.NAVIGATIONAL"] = {
            type: "path",
            fill: !1,
            stroke: e ? N : "red",
            d: "m 75,90 -10,10 70,0 -10,10"
        }, M["SE.IC.ICEBERG"] = {
            type: "path",
            fill: e ? N : O,
            stroke: e ? N : O,
            d: "m 75,100 25,-30 25,30 -5,15 -5,-5 -15,20 -15,-20 -5,5 z m -15,0 80,0"
        }, M["SE.IC.FUSED TRACK"] = [
            a("?"),
            {
                type: "path",
                fill: !1,
                d: "m 70,65 10,35 -10,35 60,0 -10,-35 10,-35 z"
            }
        ], M["SE.M1.OWN SHIP"] = l("OWN"), M["SE.M1.ANTIAIR WARFARE"] = l("AAW"), M["SE.M1.ANTISUBMARINE WARFARE"] = l("ASW"), M["SE.M1.ESCORT"] = l("E"), M["SE.M1.ELECTRONIC WARFARE"] = l("EW"), M["SE.M1.INTELLIGENCE, SURVEILLANCE, RECONNAISSANCE"] = l("ISR"), M["SE.M1.MINE COUNTER MEASURES"] = l("MCM"), M["SE.M1.MISSILE DEFENSE"] = l("MD"), M["SE.M1.MEDICAL"] = l("ME"), M["SE.M1.MINE COUNTERMEASURES"] = l("MCM"), M["SE.M1.MINE WARFARE"] = l("MIW"), M["SE.M1.REMOTE MULTI-MISSION VEHIHLE"] = l("RMV"), M["SE.M1.SPECIAL OPERATIONS FORCE"] = l("SOF"), M["SE.M1.SURFACE WARFARE"] = l("SUW"), M["SE.M1.BALLISTIC MISSILE"] = l("B"), M["SE.M1.GUIDED MISSILE"] = l("G"), M["SE.M1.OTHER GUIDED MISSILE"] = l("M"), M["SE.M1.TORPEDO"] = l("T"), M["SE.M1.CYBERSPACE"] = l("CYB"), M["SE.M1.HIJACKER"] = l("HJ"), M["SE.M2.CYBERSPACE"] = r("CYB"), M["SE.M1.DRONE-EQUIPPED"] = {
            type: "path",
            stroke: !1,
            d: "m 80,65 20,13 20,-13 0,-5 -20,10 -20,-10 z"
        }, M["SE.M1.HELICOPTER-EQUIPPED"] = l("H"), M["SE.M1.BALLISTIC MISSILE DEFENSE, SHOOTER"] = l("BM"), M["SE.M1.BALLISTIC MISSILE DEFENSE, LONG- RANGE SURVEILLANCE AND TRACK (LRS&T)"] = l("ST"), M["SE.M1.SEA-BASE X-BAND"] = l("SBX"), M["SE.M1.HIJACKING/HIJACKED"] = l("H"), M["SE.M2.ANTISUBMARINE WARFARE"] = r("ASW"), M["SE.M2.MINE WARFARE"] = r("MIW"), M["SE.M2.SURFACE WARFARE"] = r("SUW"), M["SE.M2.NUCLEAR POWERED"] = r("N"), M["SE.M2.HEAVY"] = r("H"), M["SE.M2.LIGHT"] = r("L"), M["SE.M2.MEDIUM"] = r("M"), M["SE.M2.DOCK"] = r("D"), M["SE.M2.LOGISTICS"] = r("LOG"), M["SE.M2.TANK"] = r("T"), M["SE.M2.VEHICLE"] = r("V"), M["SE.M2.FAST"] = r("F"), M["SE.M2.AIR-CUSHIONED"] = r("J"), M["SE.M2.AIR-CUSHIONED (USA ONLY)"] = r("AC"), M["SE.M2.HYDROFOIL"] = r("K"), M["SE.M2.AUTONOMOUS CONTROL"] = r("AUT"), M["SE.M2.REMOTELY PILOTED"] = r("RP"), M["SE.M2.EXPENDABLE"] = r("EXP"), M)M.hasOwnProperty(i) && (I.hasOwnProperty(i) && console.warn("Override of: " + i), n.call(this, M[i], N), I[i] = M[i]);
    }
    var p = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            d
        ],
        icons: function(I, t, E, R) {
            I["S-S-------"] = [], I["S-S-C-----"] = [
                E["SE.IC.COMBATANT"]
            ], I["S-S-CL----"] = [
                E["SE.IC.SURFACE COMBATANT, LINE"]
            ], I["S-S-CLCV--"] = [
                E["SE.IC.CARRIER"]
            ], I["S-S-CLBB--"] = [
                E["SE.IC.BATTLESHIP"]
            ], I["S-S-CLCC--"] = [
                E["SE.IC.CRUISER"]
            ], I["S-S-CLDD--"] = [
                E["SE.IC.DESTROYER"]
            ], I["S-S-CLFF--"] = [
                E["SE.IC.FRIGATE"]
            ], I["S-S-CLLL--"] = [
                E["SE.IC.LITTORAL COMBATANT SHIP"]
            ], I["S-S-CLLLAS"] = [
                E["SE.IC.LITTORAL COMBATANT SHIP"],
                E["SE.M2.ANTISUBMARINE WARFARE"]
            ], I["S-S-CLLLMI"] = [
                E["SE.IC.LITTORAL COMBATANT SHIP"],
                E["SE.M2.MINE WARFARE"]
            ], I["S-S-CLLLSU"] = [
                E["SE.IC.LITTORAL COMBATANT SHIP"],
                E["SE.M2.SURFACE WARFARE"]
            ], I["S-S-CA----"] = [
                E["SE.IC.AMPHIBIOUS WARFARE SHIP"]
            ], I["S-S-CALA--"] = [
                R ? E["SE.IC.AMPHIBIOUS ASSAULT"] : E["SE.IC.AMPHIBIOUS ASSAULT SHIP, GENERAL"]
            ], I["S-S-CALS--"] = [
                E["SE.IC.LANDING SHIP"]
            ], I["S-S-CALSM-"] = [
                E["SE.IC.LANDING SHIP"],
                E["SE.M2.MEDIUM"]
            ], I["S-S-CALST-"] = [
                E["SE.IC.LANDING SHIP"],
                E["SE.M2.TANK"]
            ], I["S-S-CALC--"] = [
                E["SE.IC.LANDING CRAFT"]
            ], I["S-S-CM----"] = [
                E["SE.IC.MINE WARFARE VESSEL"]
            ], I["S-S-CMML--"] = [
                E["SE.IC.MINELAYER"]
            ], I["S-S-CMMS--"] = [
                E["SE.IC.MINESWEEPER"]
            ], I["S-S-CMMH--"] = [
                E["SE.IC.MINEHUNTER"]
            ], I["S-S-CMMA--"] = [
                E["SE.IC.MINE COUNTER MEASURE SUPPORT SHIP"]
            ], I["S-S-CMMD--"] = [
                E["SE.IC.MINESWEEPER, DRONE"]
            ], I["S-S-CP----"] = [
                E["SE.IC.PATROL"]
            ], I["S-S-CPSB--"] = [
                E["SE.IC.PATROL CRAFT"]
            ], I["S-S-CPSU--"] = [
                E["SE.IC.PATROL ANTI SUBMARINE WARFARE"]
            ], I["S-S-CPSUM-"] = [
                E["SE.IC.PATROL ANTISHIP MISSILE"]
            ], I["S-S-CPSUT-"] = [
                E["SE.IC.PATROL TORPEDO"]
            ], I["S-S-CPSUG-"] = [
                E["SE.IC.PATROL GUN"]
            ], I["S-S-CH----"] = [
                E["SE.IC.HOVERCRAFT"]
            ], I["S-S-G-----"] = [
                E["SE.IC.NAVY TASK ORGANIZATION UNIT"]
            ], I["S-S-GF----"] = I["S-S-GT----"] = [
                E["SE.IC.NAVY TASK FORCE"]
            ], I["S-S-GG----"] = [
                E["SE.IC.NAVY TASK GROUP"]
            ], I["S-S-GU----"] = [
                E["SE.IC.NAVY TASK UNIT"]
            ], I["S-S-GE----"] = [
                E["SE.IC.NAVY TASK ELEMENT"]
            ], I["S-S-GC----"] = [
                E["SE.IC.CONVOY"]
            ], I["S-S-CD----"] = [
                E["SE.IC.SEA SURFACE DECOY"]
            ], I["S-S-CU----"] = [
                E["SE.IC.UNMANNED SURFACE WATER VEHICLE"]
            ], I["S-S-CUM---"] = [
                E["SE.IC.UNMANNED SURFACE WATER VEHICLE"],
                E["SE.M1.MINE COUNTERMEASURES"]
            ], I["S-S-CUS---"] = [
                E["SE.IC.UNMANNED SURFACE WATER VEHICLE"],
                E["SE.M1.ANTISUBMARINE WARFARE"]
            ], I["S-S-CUN---"] = [
                E["SE.IC.UNMANNED SURFACE WATER VEHICLE"],
                E["SE.M1.SURFACE WARFARE"]
            ], I["S-S-CUR---"] = [
                E["SE.IC.UNMANNED SURFACE WATER VEHICLE"],
                E["SE.M1.REMOTE MULTI-MISSION VEHIHLE"]
            ], I["S-S-N-----"] = [
                E["SE.IC.NONCOMBATANT"]
            ], I["S-S-NR----"] = [
                E["SE.IC.AUXILIARY SHIP"]
            ], I["S-S-NRA---"] = [
                E["SE.IC.AMMUNITION SHIP"]
            ], I["S-S-NRO---"] = [
                E["SE.IC.OILER, REPLENISHMENT"]
            ], I["S-S-NF----"] = I["S-S-NFT---"] = [
                E["SE.IC.TUG, OCEAN GOING"]
            ], I["S-S-NI----"] = [
                E["SE.IC.INTELLIGENCE COLLECTOR"]
            ], I["S-S-NM----"] = [
                E["SE.IC.HOSPITAL SHIP"]
            ], I["S-S-NS----"] = [
                E["SE.IC.SERVICE CRAFT, YARD, GENERAL"]
            ], I["S-S-NR----"] = [
                E["SE.IC.REPAIR SHIP"]
            ], I["S-S-NTS---"] = [
                E["SE.IC.SUBMARINE TENDER"]
            ], I["S-S-NH----"] = [
                E["SE.IC.HOVERCRAFT NONCOMBATANT"]
            ], I["S-S-X-----"] = [], I["S-S-XM----"] = [
                E["SE.IC.MERCHANT SHIP, GENERAL"]
            ], I["S-S-XMC---"] = [
                E["SE.IC.CARGO, GENERAL"]
            ], I["S-S-XME---"] = I["S-S-XMR---"] = [
                E["SE.IC.ROLL ON-ROLL OFF"]
            ], I["S-S-XMO---"] = [
                E["SE.IC.OILER/TANKER"]
            ], I["S-S-XMT---"] = I["S-S-XMTU--"] = [
                E["SE.IC.TUG, OCEAN GOING CIVILIAN"]
            ], I["S-S-XMF---"] = [
                E["SE.IC.FERRY"]
            ], I["S-S-XMP---"] = [
                E["SE.IC.PASSENGER SHIP"]
            ], I["S-S-XMH---"] = [
                E["SE.IC.TRANSPORT SHIP, HAZARDOUS MATERIAL"]
            ], I["S-S-XMD---"] = [
                E["SE.IC.DREDGE"]
            ], I["S-S-XMTO--"] = [
                E["SE.IC.TOW"]
            ], I["S-S-XF----"] = [
                E["SE.IC.FISHING VESSEL"]
            ], I["S-S-XFDF--"] = [
                E["SE.IC.DRIFTER"]
            ], I["S-S-XFTR--"] = [
                E["SE.IC.TRAWLER"]
            ], I["S-S-XFDR--"] = [
                E["SE.IC.FISHING VESSEL DREDGE"]
            ], I["S-S-XR----"] = [
                E["SE.IC.LEISURE CRAFT, SAILING BOAT"]
            ], I["S-S-XL----"] = [
                E["SE.IC.LAW ENFORCEMENT VESSEL"]
            ], I["S-S-XH----"] = [
                E["SE.IC.HOVERCRAFT CIVILIAN"]
            ], I["S-S-XA----"] = [
                E["SE.IC.LEISURE CRAFT, MOTORIZED"]
            ], I["S-S-XAR---"] = [
                E["SE.IC.LEISURE CRAFT, MOTORIZED, RIGID-HULL INFLATABLE BOAT"]
            ], I["S-S-XAS---"] = [
                E["SE.IC.LEISURE CRAFT, MOTORIZED, SPEEDBOAT"]
            ], I["S-S-XP----"] = [
                E["SE.IC.LEISURE CRAFT, JETSKI"]
            ], I["S-S-O-----"] = [
                E["SE.IC.OWN SHIP"]
            ], I["S-S-E-----"] = [], I["S-S-ED----"] = [
                E["SE.IC.DITCHED AIRCRAFT"]
            ], I["S-S-EP----"] = [
                E["SE.IC.PERSON IN WATER"]
            ], I["S-S-EV----"] = [
                E["SE.IC.DISTRESSED VESSEL"]
            ], I["S-S-Z-----"] = [], I["S-S-ZM----"] = [
                E["SE.IC.SEA MINELIKE"]
            ], I["S-S-ZN----"] = [
                E["SE.IC.NAVIGATIONAL"]
            ], I["S-S-ZI----"] = [
                E["SE.IC.ICEBERG"]
            ];
        }
    };
    function D(I, t, E, R, e, A) {
        var C = t.affiliation || "Friend", T = t.frame, S = t.numberSIDC, N = E.iconColor[C], O = E.iconFillColor[C], G = E.white[C], o = E.black[C], M = {};
        for(var i in M["SU.IC.MILITARY"] = a("MIL"), M["SU.IC.CIVILIAN"] = a("CIV"), M["SU.IC.CIVILIAN"].fill = R || S ? O : !T && O, M["SU.IC.CIVILIAN"].stroke = o, M["SU.IC.CIVILIAN"].strokewidth = 3, M["SU.IC.MANUAL TRACK"] = a("MAN"), M["SU.IC.SUBMARINE"] = {
            type: "path",
            d: "m 75,85 50,0 15,15 -15,15 -50,0 -15,-15 z"
        }, M["SU.IC.SUBMARINE CONVENTIONAL PROPULSION"] = {
            type: "path",
            d: "m 75,110 -10,-10 10,-10 20,0 0,-10 10,0 0,10 20,0 10,10 -10,10 z"
        }, M["SU.IC.SUBMARINE CONVENTIONAL PROPULSION, SURFACED"] = [
            {
                type: "path",
                d: "m 75,110 -10,-10 10,-10 20,0 0,-10 10,0 0,10 20,0 10,10 -10,10 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 65,120 10,-10 10,10 10,-10 10,10 10,-10 10,10 10,-10"
            }
        ], M["SU.IC.SUBMARINE NUCLEAR PROPULSION"] = {
            type: "path",
            d: "m 75,110 -10,-10 10,-10 0,-10 50,0 0,10 10,10 -10,10 z"
        }, M["SU.IC.SUBMARINE NUCLEAR PROPULSION, SURFACED"] = [
            {
                type: "path",
                d: "m 75,110 -10,-10 10,-10 0,-10 50,0 0,10 10,10 -10,10 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 65,120 10,-10 10,10 10,-10 10,10 10,-10 10,10 10,-10"
            }
        ], M["SU.IC.SUBMARINE ATTACK (SSN)"] = {
            type: "text",
            fill: G,
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "A"
        }, M["SU.IC.SUBMARINE MISSILE (TYPE UNKNOWN)"] = {
            type: "text",
            fill: G,
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "M"
        }, M["SU.IC.SUBMARINE GUIDED MISSILE (SSGN)"] = {
            type: "text",
            fill: G,
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "G"
        }, M["SU.IC.SUBMARINE BALLISTIC MISSILE (SSBN)"] = {
            type: "text",
            fill: G,
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 30,
            text: "B"
        }, M["SU.IC.SUBMARINE, SURFACED"] = [
            {
                type: "path",
                d: "m 75,80 50,0 15,15 -15,15 -50,0 -15,-15 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 65,120 10,-10 10,10 10,-10 10,10 10,-10 10,10 10,-10"
            }
        ], M["SU.IC.SUBMARINE, BOTTOMED"] = [
            {
                type: "path",
                d: "m 75,80 50,0 15,15 -15,15 -50,0 -15,-15 z"
            },
            {
                type: "path",
                d: "m 70,120 0,-5 60,0 0,5 z"
            }
        ], M["SU.IC.SUBMARINE, SNORKELING"] = [
            {
                type: "path",
                d: "m 75,120 -10,-10 10,-10 20,0 0,-20 10,0 0,20 20,0 10,10 -10,10 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 65,95 10,-10 10,10 10,-10 10,10 10,-10 10,10 10,-10"
            }
        ], M["SU.IC.OTHER SUBMERSIBLE"] = {
            type: "path",
            d: "m 85,90 0,-10 30,0 0,10 m 20,10 c 0,5.5 -15.7,10 -35,10 -19.3,0 -35,-4.5 -35,-10 0,-5.5 15.7,-10 35,-10 19.3,0 35,4.5 35,10 z"
        }, M["SU.IC.OTHER SUBMERSIBLE, SURFACED"] = [
            M["SU.IC.OTHER SUBMERSIBLE"],
            {
                type: "path",
                fill: !1,
                d: "m 65,120 10,-10 10,10 10,-10 10,10 10,-10 10,10 10,-10"
            }
        ], M["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV)"] = {
            type: "path",
            d: "m 60,84 40,20 40,-20 0,8 -40,25 -40,-25 z",
            stroke: !1
        }, M["SU.IC.NON-SUBMARINE"] = R && !S ? {
            type: "text",
            stroke: !1,
            x: 100,
            y: 110,
            fontsize: 35,
            text: "NON"
        } : [
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 100,
                fontsize: 25,
                text: "NON"
            },
            {
                type: "text",
                stroke: !1,
                x: 100,
                y: 120,
                fontsize: 25,
                text: "SUB"
            }
        ], M["SU.IC.DIVER, MILITARY"] = {
            type: "path",
            stroke: !1,
            d: "M 100 80 C 93.7 80 88.3 82.7 85.8 88.3 L 85.8 88.3 L 77.8 88.3 L 77.8 105 L 85.8 105 L 85.8 104.8 C 87.3 108.2 88.8 110 92 111.7 L 92.1 111.7 L 84.2 120 L 115.8 120 L 107.9 111.7 L 108 111.7 C 111.1 110 112.8 108.3 114.3 105 L 122.2 105 L 122.2 88.3 L 114.3 88.3 L 114.3 88.3 C 111.7 82.8 106.3 80 100 80 z M 100 86.6 C 105.4 86.6 109.8 91.1 109.8 96.6 C 109.8 102.1 105.4 106.6 100 106.6 C 94.6 106.6 90.1 102.1 90.1 96.6 C 90.1 91.1 94.6 86.6 100 86.6 z M 100 89.6 C 96.2 89.6 93.1 92.7 93.1 96.6 C 93.1 100.5 96.2 103.6 100 103.6 C 103.8 103.6 106.8 100.5 106.8 96.6 C 106.8 92.7 103.8 89.6 100 89.6 z"
        }, M["SU.IC.SUBMERSIBLE, CIVILIAN"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 85,90 0,-10 30,0 0,10 m 20,10 c 0,5.5 -15.7,10 -35,10 -19.3,0 -35,-4.5 -35,-10 0,-5.5 15.7,-10 35,-10 19.3,0 35,4.5 35,10 z"
        }, M["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV), CIVILIAN"] = {
            type: "path",
            fill: R ? O : !T && O,
            d: "m 60,84 40,20 40,-20 0,8 -40,25 -40,-25 z"
        }, M["SU.M1.CYBERSPACE"] = l("CYB"), M["SU.M1.HIJACKER"] = l("HJ"), M["SU.M2.CYBERSPACE"] = r("CYB"), M["SU.IC.DIVER, CIVILIAN"] = {
            type: "path",
            fill: O,
            d: "M 114.3,94 C 114.3,102.3 107.9,109 100,109 c -7.9,0 -14.2,-6.7 -14.2,-15 0,-8.3 6.4,-15 14.2,-15 7.9,0 14.3,6.7 14.3,15 z m 0,27 14.3,15 -57,0 14.3,-15 M 125.7,79 l 14.3,0 0,30 -14.3,0 m -51.3,0 -14.3,0 0,-30 14.3,0 m 54.2,15 c 0,16.6 -12.8,30 -28.5,30 -15.7,0 -28.5,-13.4 -28.5,-30 C 71.5,77.4 84.3,64 100,64 115.7,64 128.5,77.4 128.5,94 z"
        }, M["SU.IC.UNDERWATER WEAPON"] = a("WPN"), M["SU.IC.TORPEDO"] = {
            type: "path",
            d: "m 65,105 -5,-5 5,-5 60,0 c 0,0 5,5 5,5 l 5,-5 0,10 -5,-5 -5,5 z"
        }, M["SU.IC.IMPROVISED EXPLOSIVE DEVICE (IED)"] = a("IED"), M["SU.IC.UNDERWATER DECOY"] = {
            type: "path",
            stroke: o,
            d: R ? "M 105,110 90,95 105,80 z M 85,110 70,95 85,80 z m 40,-30 -15,15 15,15 z m -55,40 0,-5 55,0 0,5 z" : "M 105,120 90,105 105,90 z M 85,120 70,105 85,90 z m 40,-30 -15,15 15,15 z m -55,-5 0,-5 55,0 0,5 z",
            fill: R ? N : O
        }, M["SU.IC.UNDERWATER DECOY DSymbol"] = {
            type: "path",
            d: "M 85 81 L 65 98 L 85 119 L 85 81 z M 110 81 L 90 98 L 110 119 L 110 81 z M 135 81 L 115 98 L 135 119 L 135 81 z"
        }, M["SU.IC.ECHO TRACKER CLASSIFIER (ETC)/POSSIBLE CONTACT (POSCON)"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 130,
            fontsize: 60,
            text: "?"
        }, M["SU.IC.FUSED TRACK"] = [
            a("?"),
            {
                type: "path",
                fill: !1,
                d: "m 70,65 10,35 -10,35 60,0 -10,-35 10,-35"
            }
        ], M["SU.IC.SEA MINE"] = {
            type: "path",
            fill: !R && !S || e ? O : E.iconColor.Hostile,
            stroke: !R && !S || e ? N : o,
            d: "M 115.9,73 126.5,62.4 137.1,73 126.5,83.6 m -53,0 L 62.9,73 73.5,62.4 84.1,73 m 8.4,-3 0,-15 15,0 0,15 m 22.5,30 c 0,16.6 -13.4,30 -30,30 -16.6,0 -30,-13.4 -30,-30 0,-16.6 13.4,-30 30,-30 C 116.6,70 130,83.4 130,100 z"
        }, M["SU.IC.SEA MINE - BOTTOM"] = [
            M["SU.IC.SEA MINE"],
            {
                type: "path",
                fill: !R && !S || e ? O : E.iconColor.Hostile,
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE - MOORED"] = [
            M["SU.IC.SEA MINE"],
            {
                type: "path",
                fill: !R && !S || e ? O : E.iconColor.Hostile,
                stroke: !R && !S || e ? N : o,
                d: "m 75.5,136.8 49,0 M 100,124.5 l 0,12.3"
            }
        ], M["SU.IC.SEA MINE - FLOATING"] = [
            M["SU.IC.SEA MINE"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10"
            }
        ], M["SU.IC.SEA MINE - RISING"] = [
            M["SU.IC.SEA MINE"],
            {
                type: "path",
                fill: S && A ? "" : !R && !S || e ? O : E.iconColor.Hostile,
                stroke: !R && !S || e ? N : o,
                d: "m 100,128 -10,15 20,0 z"
            }
        ], M["SU.IC.SEA MINE (IN OTHER POSITION)"] = [
            M["SU.IC.SEA MINE"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 130,100 15,0 M 70,100 l -15,0"
            }
        ], M["SU.IC.SEA MINE - KINGFISHER"] = [
            M["SU.IC.SEA MINE"],
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 110,
                fontsize: 35,
                text: "K"
            }
        ], M["SU.IC.SEA MINE - SMALL OBJECT"] = [
            M["SU.IC.SEA MINE"],
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 112,
                fontsize: 30,
                text: "SO"
            }
        ], M["SU.IC.SEA MINE EXERCISE MINE"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "M 115.9,73 126.5,62.4 137.1,73 126.5,83.6 m -53,0 L 62.9,73 73.5,62.4 84.1,73 m 8.4,-3 0,-15 15,0 0,15 m 22.5,30 c 0,16.6 -13.4,30 -30,30 -16.6,0 -30,-13.4 -30,-30 0,-16.6 13.4,-30 30,-30 C 116.6,70 130,83.4 130,100 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 112,
                fontsize: 30,
                text: "EX"
            },
            S ? [] : {
                type: "text",
                stroke: !1,
                fill: !R && !S || e ? N : o,
                x: 150,
                y: 46,
                fontsize: 40,
                text: "X"
            }
        ], M["SU.IC.SEA MINE EXERCISE MINE - BOTTOM"] = [
            M["SU.IC.SEA MINE EXERCISE MINE"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE EXERCISE MINE - MOORED"] = [
            M["SU.IC.SEA MINE EXERCISE MINE"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 75.5,136.8 49,0 M 100,124.5 l 0,12.3"
            }
        ], M["SU.IC.SEA MINE EXERCISE MINE - FLOATING"] = [
            M["SU.IC.SEA MINE EXERCISE MINE"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10"
            }
        ], M["SU.IC.SEA MINE EXERCISE MINE - RISING"] = [
            M["SU.IC.SEA MINE EXERCISE MINE"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 100,128 -10,15 20,0 z"
            }
        ], M["SU.IC.SEA MINE DECOY"] = {
            type: "path",
            fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
            stroke: !R && !S || e ? N : o,
            d: "m 106.6,101.6 0,26.3 -13.1,-13.1 z m -19.7,0 0,26.3 -13.1,-13.1 z m 39.4,0 0,26.3 -13.1,-13.1 13.1,-13.1 M 100,75.3 c -14.5,0 -26.3,11.8 -26.3,26.3 l 52.5,0 C 126.3,87.1 114.5,75.3 100,75.3 z m -6.6,0 0,-13.1 13.1,0 0,13.1 m -29.8,12.3 -9.3,-9.3 9.3,-9.3 9.3,9.3 m 27.9,0 9.3,-9.3 9.3,9.3 -9.3,9.3"
        }, M["SU.IC.SEA MINE DECOY, BOTTOM/GROUND"] = [
            M["SU.IC.SEA MINE DECOY"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE DECOY, MOORED"] = [
            M["SU.IC.SEA MINE DECOY"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 50,0 M 100,100 l 0,40"
            }
        ], M["SU.IC.SEA MINE NEUTRALIZED"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : E.iconColor.Neutral,
                stroke: !R && !S || e ? N : o,
                d: "M 115.9,73 126.5,62.4 137.1,73 126.5,83.6 m -53,0 L 62.9,73 73.5,62.4 84.1,73 m 8.4,-3 0,-15 15,0 0,15 m 22.5,30 c 0,16.6 -13.4,30 -30,30 -16.6,0 -30,-13.4 -30,-30 0,-16.6 13.4,-30 30,-30 C 116.6,70 130,83.4 130,100 z"
            },
            {
                type: "path",
                strokewidth: 5,
                stroke: A ? G : o,
                d: "m 135,65 -70,70 m 0,-70 70,70"
            }
        ], M["SU.IC.SEA MINE NEUTRALIZED - BOTTOM"] = [
            M["SU.IC.SEA MINE NEUTRALIZED"],
            {
                type: "path",
                fill: !R && !S || e ? O : E.iconColor.Neutral,
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE NEUTRALIZED - MOORED"] = [
            M["SU.IC.SEA MINE NEUTRALIZED"],
            {
                type: "path",
                fill: !R && !S || e ? O : E.iconColor.Neutral,
                stroke: !R && !S || e ? N : o,
                d: "m 75.5,136.8 49,0 M 100,124.5 l 0,12.3"
            }
        ], M["SU.IC.SEA MINE NEUTRALIZED - FLOATING"] = [
            M["SU.IC.SEA MINE NEUTRALIZED"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10"
            }
        ], M["SU.IC.SEA MINE NEUTRALIZED - RISING"] = [
            M["SU.IC.SEA MINE NEUTRALIZED"],
            {
                type: "path",
                fill: !R && !S || e ? O : E.iconColor.Neutral,
                stroke: !R && !S || e ? N : o,
                d: "m 100,128 -10,15 20,0 z"
            }
        ], M["SU.IC.SEA MINE (IN OTHER POSITION) NEUTRALIZED"] = [
            M["SU.IC.SEA MINE NEUTRALIZED"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 130,100 15,0 M 70,100 l -15,0"
            }
        ], M["SU.IC.SEA MINE MILEC"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,255,0)",
                stroke: !R && !S || e ? N : o,
                d: "m 113.8,127.6 -27.6,0 -13.8,-13.8 0,-27.6 13.8,-13.8 27.6,0 13.8,13.8 0,27.6 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 112,
                fontsize: 30,
                text: "E"
            }
        ], M["SU.IC.SEA MINE MILEC - BOTTOM"] = [
            M["SU.IC.SEA MINE MILEC"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,255,0)",
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE MILEC - MOORED"] = [
            M["SU.IC.SEA MINE MILEC"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,255,0)",
                stroke: !R && !S || e ? N : o,
                d: "m 75.5,136.8 49,0 M 100,124.5 l 0,12.3"
            }
        ], M["SU.IC.SEA MINE MILEC - FLOATING"] = [
            M["SU.IC.SEA MINE MILEC"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10"
            }
        ], M["SU.IC.SEA MINE MINE ANCHOR"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !(!R && !S || e) && o,
                d: "m 113.8,127.6 -27.6,0 -13.8,-13.8 0,-27.6 13.8,-13.8 27.6,0 13.8,13.8 0,27.6 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 105,
                fontsize: 18,
                text: "ANCR"
            }
        ], M["SU.IC.SEA MINE MILCO"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,141,42)",
                stroke: !R && !S || e ? N : o,
                d: "m 113.8,127.6 -27.6,0 -13.8,-13.8 0,-27.6 13.8,-13.8 27.6,0 13.8,13.8 0,27.6 z"
            },
            S ? [] : {
                type: "text",
                stroke: !1,
                fill: !R && !S || e ? N : o,
                x: 100,
                y: 112,
                fontsize: 30,
                text: "#"
            }
        ], M["SU.IC.SEA MINE MILCO - BOTTOM"] = [
            M["SU.IC.SEA MINE MILCO"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,141,42)",
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE MILCO - MOORED"] = [
            M["SU.IC.SEA MINE MILCO"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 75.5,136.8 49,0 M 100,124.5 l 0,12.3"
            }
        ], M["SU.IC.SEA MINE MILCO - FLOATING"] = [
            M["SU.IC.SEA MINE MILCO"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10"
            }
        ], M["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 1"] = {
            type: "text",
            stroke: !1,
            fill: e || (!R && !S || A ? G : o),
            x: 100,
            y: 110,
            fontsize: 35,
            text: "1"
        }, M["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 2"] = {
            type: "text",
            stroke: !1,
            fill: e || (!R && !S || A ? G : o),
            x: 100,
            y: 110,
            fontsize: 35,
            text: "2"
        }, M["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 3"] = {
            type: "text",
            stroke: !1,
            fill: e || (!R && !S || A ? G : o),
            x: 100,
            y: 110,
            fontsize: 35,
            text: "3"
        }, M["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 4"] = {
            type: "text",
            stroke: !1,
            fill: e || (!R && !S || A ? G : o),
            x: 100,
            y: 110,
            fontsize: 35,
            text: "4"
        }, M["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 5"] = {
            type: "text",
            stroke: !1,
            fill: e || (!R && !S || A ? G : o),
            x: 100,
            y: 110,
            fontsize: 35,
            text: "5"
        }, M["SU.IC.SEA MINE NEGATIVE REACQUISITION"] = [
            {
                type: "path",
                strokedasharray: "8,4",
                fill: !R && !S || e ? O : A ? o : "rgb(255,255,0)",
                stroke: !R && !S || e ? N : o,
                d: "m 113.8,127.6 -27.6,0 -13.8,-13.8 0,-27.6 13.8,-13.8 27.6,0 13.8,13.8 0,27.6 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 112,
                fontsize: 30,
                text: "NR"
            }
        ], M["SU.IC.SEA MINE NEGATIVE REACQUISITION - BOTTOM"] = [
            M["SU.IC.SEA MINE NEGATIVE REACQUISITION"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,255,0)",
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE NEGATIVE REACQUISITION - MOORED"] = [
            M["SU.IC.SEA MINE NEGATIVE REACQUISITION"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,255,0)",
                stroke: !R && !S || e ? N : o,
                d: "m 75.5,136.8 49,0 M 100,124.5 l 0,12.3"
            }
        ], M["SU.IC.SEA MINE NEGATIVE REACQUISITION - FLOATING"] = [
            M["SU.IC.SEA MINE NEGATIVE REACQUISITION"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10"
            }
        ], M["SU.IC.SEA MINE GENERAL OBSTRUCTOR"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(255,255,0)",
                stroke: !R && !S || e ? N : o,
                d: "m 113.8,127.6 -27.6,0 -13.8,-13.8 0,-27.6 13.8,-13.8 27.6,0 13.8,13.8 0,27.6 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 112,
                fontsize: 30,
                text: "OB"
            }
        ], M["SU.IC.SEA MINE GENERAL OBSTRUCTOR NEUTRALIZED"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : E.iconColor.Neutral,
                stroke: !R && !S || e ? N : o,
                d: "m 113.8,127.6 -27.6,0 -13.8,-13.8 0,-27.6 13.8,-13.8 27.6,0 13.8,13.8 0,27.6 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: !R && !S || e || A ? G : o,
                x: 100,
                y: 112,
                fontsize: 30,
                text: "OB"
            },
            {
                type: "path",
                strokewidth: 5,
                stroke: A ? G : o,
                d: "m 135,65 -70,70 m 0,-70 70,70"
            }
        ], M["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT"] = [
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 113.8,127.6 -27.6,0 -13.8,-13.8 0,-27.6 13.8,-13.8 27.6,0 13.8,13.8 0,27.6 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: e || (!R && !S || A ? G : o),
                x: 100,
                y: 112,
                fontsize: 30,
                text: "N"
            }
        ], M["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - BOTTOM"] = [
            M["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 74.8,125.2 50.4,0 0,12.6 -50.4,0 z"
            }
        ], M["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - MOORED"] = [
            M["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT"],
            {
                type: "path",
                fill: !R && !S || e ? O : A ? o : "rgb(0, 130, 24)",
                stroke: !R && !S || e ? N : o,
                d: "m 75.5,136.8 49,0 M 100,124.5 l 0,12.3"
            }
        ], M["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - FLOATING"] = [
            M["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT"],
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : o,
                d: "m 75,140 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10 5,-10 5,10"
            }
        ], M["SU.IC.UNEXPLODED EXPLOSIVE ORDNANCE"] = [
            {
                type: "path",
                strokedasharray: "8,4",
                fill: !1,
                stroke: !R && !S || e ? N : E.iconColor.Hostile,
                d: "m 85,65 30,0 20,20 0,30 -20,20 -30,0 -20,-20 0,-30 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: !R && !S || e ? N : E.iconColor.Hostile,
                x: 100,
                y: 110,
                fontsize: 30,
                text: "UXO"
            }
        ], M["SU.IC.ENVIRONMENTAL REPORT LOCATION"] = [
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : E.iconColor.Neutral,
                d: "m 70,70 0,60 60,0 0,-60 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: !R && !S || e ? N : E.iconColor.Neutral,
                x: 100,
                y: 122,
                fontsize: 60,
                text: "E"
            }
        ], M["SU.IC.DIVE REPORT LOCATION"] = [
            {
                type: "path",
                fill: !1,
                stroke: !R && !S || e ? N : E.iconColor.Neutral,
                d: "m 70,70 0,60 60,0 0,-60 z"
            },
            {
                type: "text",
                stroke: !1,
                fill: !R && !S || e ? N : E.iconColor.Neutral,
                x: 100,
                y: 122,
                fontsize: 60,
                text: "D"
            }
        ], M["SU.IC.SEABED INSTALLATION/MANMADE"] = {
            type: "path",
            fill: O,
            stroke: o,
            d: "m 140,125 -80,0 10,-30 10,20 20,-50 20,50 10,-25 z"
        }, M["SU.IC.SEABED INSTALLATION, MAN-MADE, MILITARY"] = {
            type: "path",
            d: "m 75,80 0,40 50,0 0,-15 -15,0 0,-10 -20,0 0,-15 z"
        }, M["SU.IC.SEABED INSTALLATION, MAN-MADE, NON-MILITARY"] = {
            type: "path",
            fill: O,
            d: "m 75,80 0,40 50,0 0,-15 -15,0 0,-10 -20,0 0,-15 z"
        }, M["SU.IC.SEABED ROCK/STONE, OBSTACLE, OTHER"] = {
            type: "path",
            d: "m 140,125 -80,0 10,-30 10,20 20,-50 20,50 10,-25 z"
        }, M["SU.IC.WRECK"] = {
            type: "path",
            d: "m 125,85 0,30 m -50,-30 0,30 m 25,-40 0,45 m -40,-20 80,0"
        }, M["SU.IC.MARINE LIFE"] = {
            type: "path",
            d: "m 60,100 20,-20 45,20 15,-10 0,20 -15,-10 -45,20 z"
        }, M["SU.IC.SEA ANOMALY"] = {
            type: "path",
            fill: !1,
            d: "m 65,100 15,-20 20,30 20,-30 15,20 m -70,10 15,-20 20,30 20,-30 15,20"
        }, M["SU.M1.ANTISUBMARINE WARFARE"] = l("ASW"), M["SU.M1.AUXILIARY"] = l("AUX"), M["SU.M1.COMMAND AND CONTROL"] = l("C2"), M["SU.M1.INTELLIGENCE, SURVEILLANCE, RECONNAISSANCE"] = l("ISR"), M["SU.M1.MINE COUNTERMEASURES"] = l("MCM"), M["SU.M1.MINE WARFARE"] = l("MIW"), M["SU.M1.SURFACE WARFARE"] = l("SUW"), M["SU.M1.ATTACK"] = l("A"), M["SU.M1.BALLISTIC MISSILE"] = l("B"), M["SU.M1.GUIDED MISSILE"] = l("G"), M["SU.M1.OTHER GUIDED MISSILES (POINT DEFENCE)"] = l("M"), M["SU.M1.SPECIAL OPERATIONS FORCE"] = l("SOF"), M["SU.M1.POSSIBLE SUBMARINE - LOW 1"] = l("P1"), M["SU.M1.POSSIBLE SUBMARINE - LOW 2"] = l("P2"), M["SU.M1.POSSIBLE SUBMARINE - HIGH 3"] = l("P3"), M["SU.M1.POSSIBLE SUBMARINE - HIGH 4"] = l("P4"), M["SU.M1.PROBABLE SUBMARINE"] = l("PB"), M["SU.M1.CERTAIN SUBMARINE"] = l("CT"), M["SU.M1.ANTI-TORPEDO TORPEDO"] = l("ATT"), M["SU.M1.HIJACKING/HIJACKED"] = l("H"), M["SU.M2.POSSIBLE SUBMARINE - LOW 1"] = r("P1"), M["SU.M2.POSSIBLE SUBMARINE - LOW 2"] = r("P2"), M["SU.M2.POSSIBLE SUBMARINE - HIGH 3"] = r("P3"), M["SU.M2.POSSIBLE SUBMARINE - HIGH 4"] = r("P4"), M["SU.M2.PROBABLE SUBMARINE"] = r("PB"), M["SU.M2.AIR INDEPENDENT PROPULSION"] = r("AI"), M["SU.M2.CERTSUB"] = r("CT"), M["SU.M2.DIESEL PROPULSION"] = r("D"), M["SU.M2.DIESEL - TYPE 1"] = r("D1"), M["SU.M2.DIESEL - TYPE 2"] = r("D2"), M["SU.M2.DIESEL - TYPE 3"] = r("D3"), M["SU.M2.NUCLEAR POWERED"] = r("N"), M["SU.M2.NUCLEAR - TYPE 1"] = r("N1"), M["SU.M2.NUCLEAR - TYPE 2"] = r("N2"), M["SU.M2.NUCLEAR - TYPE 3"] = r("N3"), M["SU.M2.NUCLEAR - TYPE 4"] = r("N4"), M["SU.M2.NUCLEAR - TYPE 5"] = r("N5"), M["SU.M2.NUCLEAR - TYPE 6"] = r("N6"), M["SU.M2.NUCLEAR - TYPE 7"] = r("N7"), M["SU.M2.AUTONOMOUS CONTROL"] = r("AUT"), M["SU.M2.REMOTELY PILOTED"] = r("RP"), M["SU.M2.EXPENDABLE"] = r("EXP"), M)M.hasOwnProperty(i) && (I.hasOwnProperty(i) && console.warn("Override of: " + i), n.call(this, M[i], N), I[i] = M[i]);
    }
    var m = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            D
        ],
        icons: function(I, t, E, R) {
            I["S-U-------"] = [], I["S-U-S-----"] = [
                E["SU.IC.SUBMARINE"]
            ], I["S-U-SF----"] = [
                E["SU.IC.SUBMARINE, SURFACED"]
            ], I["S-U-SB----"] = [
                E["SU.IC.SUBMARINE, BOTTOMED"]
            ], I["S-U-SR----"] = [
                E["SU.IC.SUBMARINE"],
                E["SU.M2.CERTSUB"]
            ], I["S-U-SX----"] = [
                E["SU.IC.NON-SUBMARINE"]
            ], I["S-U-SN----"] = [
                E["SU.IC.SUBMARINE NUCLEAR PROPULSION"]
            ], I["S-U-SNF---"] = [
                E["SU.IC.SUBMARINE NUCLEAR PROPULSION, SURFACED"]
            ], I["S-U-SNA---"] = [
                E["SU.IC.SUBMARINE NUCLEAR PROPULSION"],
                E["SU.IC.SUBMARINE ATTACK (SSN)"]
            ], I["S-U-SNM---"] = [
                E["SU.IC.SUBMARINE NUCLEAR PROPULSION"],
                E["SU.IC.SUBMARINE MISSILE (TYPE UNKNOWN)"]
            ], I["S-U-SNG---"] = [
                E["SU.IC.SUBMARINE NUCLEAR PROPULSION"],
                E["SU.IC.SUBMARINE GUIDED MISSILE (SSGN)"]
            ], I["S-U-SNB---"] = [
                E["SU.IC.SUBMARINE NUCLEAR PROPULSION"],
                E["SU.IC.SUBMARINE BALLISTIC MISSILE (SSBN)"]
            ], I["S-U-SC----"] = [
                E["SU.IC.SUBMARINE CONVENTIONAL PROPULSION"]
            ], I["S-U-SCF---"] = [
                E["SU.IC.SUBMARINE CONVENTIONAL PROPULSION, SURFACED"]
            ], I["S-U-SCA---"] = [
                E["SU.IC.SUBMARINE CONVENTIONAL PROPULSION"],
                E["SU.IC.SUBMARINE ATTACK (SSN)"]
            ], I["S-U-SCM---"] = [
                E["SU.IC.SUBMARINE CONVENTIONAL PROPULSION"],
                E["SU.IC.SUBMARINE MISSILE (TYPE UNKNOWN)"]
            ], I["S-U-SCG---"] = [
                E["SU.IC.SUBMARINE CONVENTIONAL PROPULSION"],
                E["SU.IC.SUBMARINE GUIDED MISSILE (SSGN)"]
            ], I["S-U-SCB---"] = [
                E["SU.IC.SUBMARINE CONVENTIONAL PROPULSION"],
                E["SU.IC.SUBMARINE BALLISTIC MISSILE (SSBN)"]
            ], I["S-U-SO----"] = [
                E["SU.IC.OTHER SUBMERSIBLE"]
            ], I["S-U-SOF---"] = [
                E["SU.IC.OTHER SUBMERSIBLE, SURFACED"]
            ], I["S-U-SU----"] = [
                E["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV)"]
            ], I["S-U-SUM---"] = [
                E["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV)"],
                E["SU.M1.MINE COUNTERMEASURES"]
            ], I["S-U-SUS---"] = [
                E["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV)"],
                E["SU.M1.ANTISUBMARINE WARFARE"]
            ], I["S-U-SUN---"] = [
                E["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV)"],
                E["SU.M1.SURFACE WARFARE"]
            ], I["S-U-S1----"] = [
                E["SU.IC.SUBMARINE"],
                E["SU.M2.POSSIBLE SUBMARINE - LOW 1"]
            ], I["S-U-S2----"] = [
                E["SU.IC.SUBMARINE"],
                E["SU.M2.POSSIBLE SUBMARINE - LOW 2"]
            ], I["S-U-S3----"] = [
                E["SU.IC.SUBMARINE"],
                E["SU.M2.POSSIBLE SUBMARINE - HIGH 3"]
            ], I["S-U-S4----"] = [
                E["SU.IC.SUBMARINE"],
                E["SU.M2.POSSIBLE SUBMARINE - HIGH 4"]
            ], I["S-U-SL----"] = [
                E["SU.IC.SUBMARINE"],
                E["SU.M2.PROBABLE SUBMARINE"]
            ], I["S-U-SK----"] = [
                E["SU.IC.SUBMARINE, SNORKELING"]
            ], I["S-U-W-----"] = [
                E["SU.IC.UNDERWATER WEAPON"]
            ], I["S-U-WT----"] = [
                E["SU.IC.TORPEDO"]
            ], I["S-U-WM----"] = [
                E["SU.IC.SEA MINE"]
            ], I["S-U-WMD---"] = [
                E["SU.IC.SEA MINE NEUTRALIZED"]
            ], I["S-U-WMG---"] = [
                E["SU.IC.SEA MINE - BOTTOM"]
            ], I["S-U-WMGD--"] = [
                E["SU.IC.SEA MINE NEUTRALIZED - BOTTOM"]
            ], I["S-U-WMGX--"] = [
                E["SU.IC.SEA MINE EXERCISE MINE - BOTTOM"]
            ], I["S-U-WMGE--"] = [
                E["SU.IC.SEA MINE MILEC - BOTTOM"]
            ], I["S-U-WMGC--"] = [
                E["SU.IC.SEA MINE MILCO - BOTTOM"]
            ], I["S-U-WMGR--"] = [
                E["SU.IC.SEA MINE NEGATIVE REACQUISITION - BOTTOM"]
            ], I["S-U-WMGO--"] = [
                E["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - BOTTOM"]
            ], I["S-U-WMM---"] = [
                E["SU.IC.SEA MINE - MOORED"]
            ], I["S-U-WMMD--"] = [
                E["SU.IC.SEA MINE NEUTRALIZED - MOORED"]
            ], I["S-U-WMMX--"] = [
                E["SU.IC.SEA MINE EXERCISE MINE - MOORED"]
            ], I["S-U-WMME--"] = [
                E["SU.IC.SEA MINE MILEC - MOORED"]
            ], I["S-U-WMMC--"] = [
                E["SU.IC.SEA MINE MILCO - MOORED"]
            ], I["S-U-WMMR--"] = [
                E["SU.IC.SEA MINE NEGATIVE REACQUISITION - MOORED"]
            ], I["S-U-WMMO--"] = [
                E["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - MOORED"]
            ], I["S-U-WMF---"] = [
                E["SU.IC.SEA MINE - FLOATING"]
            ], I["S-U-WMFD--"] = [
                E["SU.IC.SEA MINE NEUTRALIZED - FLOATING"]
            ], I["S-U-WMFX--"] = [
                E["SU.IC.SEA MINE EXERCISE MINE - FLOATING"]
            ], I["S-U-WMFE--"] = [
                E["SU.IC.SEA MINE MILEC - FLOATING"]
            ], I["S-U-WMFC--"] = [
                E["SU.IC.SEA MINE MILCO - FLOATING"]
            ], I["S-U-WMFR--"] = [
                E["SU.IC.SEA MINE NEGATIVE REACQUISITION - FLOATING"]
            ], I["S-U-WMFO--"] = [
                E["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - FLOATING"]
            ], I["S-U-WMO---"] = [
                E["SU.IC.SEA MINE (IN OTHER POSITION)"]
            ], I["S-U-WMOD--"] = [
                E["SU.IC.SEA MINE (IN OTHER POSITION) NEUTRALIZED"]
            ], I["S-U-WMX---"] = [
                E["SU.IC.SEA MINE EXERCISE MINE"]
            ], I["S-U-WME---"] = [
                E["SU.IC.SEA MINE MILEC"]
            ], I["S-U-WMA---"] = [
                E["SU.IC.SEA MINE MINE ANCHOR"]
            ], I["S-U-WMC---"] = [
                E["SU.IC.SEA MINE MILCO"]
            ], I["S-U-WMR---"] = [
                E["SU.IC.SEA MINE NEGATIVE REACQUISITION"]
            ], I["S-U-WMB---"] = [
                E["SU.IC.SEA MINE GENERAL OBSTRUCTOR"]
            ], I["S-U-WMBD--"] = [
                E["SU.IC.SEA MINE GENERAL OBSTRUCTOR NEUTRALIZED"]
            ], I["S-U-WMN---"] = [
                E["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT"]
            ], I["S-U-WMS---"] = [
                E["SU.IC.SEA MINE - RISING"]
            ], I["S-U-WMSX--"] = [
                E["SU.IC.SEA MINE EXERCISE MINE - RISING"]
            ], I["S-U-WMSD--"] = [
                E["SU.IC.SEA MINE NEUTRALIZED - RISING"]
            ], I["S-U-WV----"] = [
                E["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV)"]
            ], I["S-U-WD----"] = [
                E["SU.IC.UNDERWATER DECOY"]
            ], I["S-U-WDM---"] = [
                E["SU.IC.SEA MINE DECOY"]
            ], I["S-U-WDMG--"] = [
                E["SU.IC.SEA MINE DECOY, BOTTOM/GROUND"]
            ], I["S-U-WDMM--"] = [
                E["SU.IC.SEA MINE DECOY, MOORED"]
            ], I["S-U-N-----"] = [
                E["SU.IC.NON-SUBMARINE"]
            ], I["S-U-ND----"] = [
                E["SU.IC.DIVER, CIVILIAN"]
            ], I["S-U-NB----"] = [], I["S-U-E-----"] = [
                E["SU.IC.ENVIRONMENTAL REPORT LOCATION"]
            ], I["S-U-V-----"] = [
                E["SU.IC.DIVE REPORT LOCATION"]
            ], I["S-U-X-----"] = [
                E["SU.IC.UNEXPLODED EXPLOSIVE ORDNANCE"]
            ], I["S-U-NBS---"] = [
                E["SU.IC.SEABED INSTALLATION/MANMADE"]
            ], I["S-U-NBR---"] = [
                E["SU.IC.SEABED ROCK/STONE, OBSTACLE, OTHER"]
            ], I["S-U-NBW---"] = [
                E["SU.IC.WRECK"]
            ], I["S-U-NM----"] = [
                E["SU.IC.MARINE LIFE"]
            ], I["S-U-NA----"] = [
                E["SU.IC.SEA ANOMALY"]
            ];
        }
    }, F = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            c,
            P
        ],
        icons: function(I, t, E, R) {
            I["S-F-------"] = [
                E["GR.IC.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-A-----"] = [
                E["AR.I.MILITARY ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-AF----"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-AFA---"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["SOF.M2.ATTACK"]
            ], I["S-F-AFK---"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["SOF.M2.REFUEL"]
            ], I["S-F-AFU---"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["SOF.M2.UTILITY"]
            ], I["S-F-AFUL--"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["AIR.M2.LIGHT"]
            ], I["S-F-AFUM--"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["AIR.M2.MEDIUM"]
            ], I["S-F-AFUH--"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["AIR.M2.HEAVY"]
            ], I["S-F-AV----"] = [
                E["AR.I.MILITARY FIXED WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["SOF.M2.VSTOL"]
            ], I["S-F-AH----"] = R ? [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["GR.IC.AVIATION ROTARY WING 2525C"]
            ] : [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-AHH---"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["SOF.M2.COMBAT SEARCH AND RESCUE"]
            ], I["S-F-AHA---"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["SOF.M2.ATTACK"]
            ], I["S-F-AHU---"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["SOF.M2.UTILITY"]
            ], I["S-F-AHUL--"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["AIR.M2.LIGHT"]
            ], I["S-F-AHUM--"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["AIR.M2.MEDIUM"]
            ], I["S-F-AHUH--"] = [
                E["GR.IC.AVIATION ROTARY WING"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"],
                E["AIR.M2.HEAVY"]
            ], I["S-F-SN----"] = I["S-F-N-----"] = [
                E["GR.IC.NAVAL"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-SNS---"] = I["S-F-NS----"] = [
                E["GR.IC.SEA-AIR-LAND"]
            ], I["S-F-SNU---"] = I["S-F-NU----"] = [
                E["SOF.IC.UNDERWATER DEMOLITION TEAM"]
            ], I["S-F-SNB---"] = I["S-F-NB----"] = [
                E["GR.IC.COMBATANT"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-SNN---"] = I["S-F-NN----"] = [
                E["GR.IC.SUBMARINE NUCLEAR PROPULSION"],
                E["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-G-----"] = [
                E["GR.IC.FF.INFANTRY"],
                E["GR.IC.SPECIAL OPERATIONS FORCES"]
            ], I["S-F-GS----"] = [
                E["GR.IC.SPECIAL FORCES"]
            ], I["S-F-GR----"] = I["S-F-GSR---"] = [
                E["GR.IC.FF.INFANTRY"],
                E["AIR.M1.RECONNAISSANCE"],
                E["GR.M2.AIRBORNE"]
            ], I["S-F-GP----"] = I["S-F-GSP---"] = [
                E["GR.EQ.PSYCHOLOGICAL OPERATIONS EQUIPMENT"]
            ], I["S-F-GPA---"] = I["S-F-GSPA--"] = [
                E["GR.EQ.PSYCHOLOGICAL OPERATIONS EQUIPMENT"],
                s._translate(0, -30, s._scale(.7, E["AR.I.MILITARY FIXED WING"]))
            ], I["S-F-GC----"] = I["S-F-GCA---"] = [
                E["GR.IC.CIVIL AFFAIRS"]
            ], I["S-F-GB----"] = I["S-F-B-----"] = [
                E["GR.IC.SPECIAL OPERATIONS FORCES"],
                E["GR.M2.SUPPORT"]
            ];
        }
    };
    function f(I, t, E, R, e, A) {
        var C = t.affiliation || "Friend", T = E.iconColor[C], S = {
            "SI.IC.COMMUNICATIONS": {
                type: "path",
                d: "m 93,120 14,0 0,0 m -7,-27 0,27 m 2,-25 8,2 -5,5 13,3 m -20,-10 -8,2 5,5 -14,3 m 21,-13 8,-2 -5,-5 13,-3 m -37,0 14,3 -5,5 8,2",
                fill: !1
            },
            "SI.IC.RADAR": {
                type: "path",
                d: "m 115,90 -15,15 0,-15 -15,15 M 80,85 c 0,25 15,35 35,35",
                fill: !1
            }
        };
        for(var N in S["SI.I.JAMMER / ELECTRONIC COUNTER-MEASURES"] = a("J"), S["SI.M1.ANTI-AIRCRAFT FIRE CONTROL"] = l("AA"), S["SI.M1.AIRBORNE SEARCH AND BOMBING"] = l("AB"), S["SI.M1.AIRBORNE INTERCEPT"] = l("AI"), S["SI.M1.ALTIMETER"] = l("AL"), S["SI.M1.AIRBORNE RECONNAISSANCE AND MAPPING"] = l("AM"), S["SI.M1.AIR TRAFFIC CONTROL"] = l("AT"), S["SI.M1.BEACON TRANSPONDER (NOT IFF)"] = l("BN"), S["SI.M1.BATTLEFIELD SURVEILLANCE"] = l("BS"), S["SI.M1.CONTROLLED APPROACH"] = l("CA"), S["SI.M1.CONTROLLED INTERCEPT"] = l("CI"), S["SI.M1.CELLULAR/MOBILE"] = l("CM"), S["SI.M1.COASTAL SURVEILLANCE"] = l("CS"), S["SI.M1.CYBER"] = l("CYB"), S["SI.M1.DECOY/MIMIC"] = l("DC"), S["SI.M1.DATA TRANSMISSION"] = l("DT"), S["SI.M1.EARTH SURVEILLANCE"] = l("ES"), S["SI.M1.EARLY WARNING"] = l("EW"), S["SI.M1.FIRE CONTROL"] = l("FC"), S["SI.M1.GROUND MAPPING"] = l("GM"), S["SI.M1.HEIGHT FINDING"] = l("HF"), S["SI.M1.HARBOR SURVEILLANCE"] = l("HS"), S["SI.M1.IDENTIFICATION, FRIEND OR FOE (INTERROGATOR)"] = l("IF"), S["SI.M1.INSTRUMENT LANDING SYSTEM"] = l("IL"), S["SI.M1.IONOSPHERIC SOUNDING"] = l("IS"), S["SI.M1.IDENTIFICATION, FRIEND OR FOE (TRANSPONDER)"] = l("IT"), S["SI.M1.BARRAGE JAMMER"] = l("JB"), S["SI.M1.CLICK JAMMER"] = l("JC"), S["SI.M1.DECEPTIVE JAMMER"] = l("JD"), S["SI.M1.FREQUENCY SWEPT JAMMER"] = l("JF"), S["SI.M1.JAMMER (GENERAL)"] = l("JG"), S["SI.M1.NOISE JAMMER"] = l("JN"), S["SI.M1.PULSED JAMMER"] = l("JP"), S["SI.M1.REPEATER JAMMER"] = l("JR"), S["SI.M1.SPOT NOISE JAMMER"] = l("JS"), S["SI.M1.TRANSPONDER JAMMER"] = l("JT"), S["SI.M1.MISSILE ACQUISITION"] = l("MA"), S["SI.M1.MISSILE CONTROL"] = l("MC"), S["SI.M1.MISSILE DOWNLINK"] = l("MD"), S["SI.M1.METEOROLOGICAL"] = l("ME"), S["SI.M1.MULTI-FUNCTION"] = l("MF"), S["SI.M1.MISSILE GUIDANCE"] = l("MG"), S["SI.M1.MISSILE HOMING"] = l("MH"), S["SI.M1.MISSILE TRACKING"] = l("MT"), S["SI.M1.NAVIGATIONAL/GENERAL"] = l("NA"), S["SI.M1.NAVIGATIONAL/DISTANCE MEASURING EQUIPMENT"] = l("ND"), S["SI.M1.NAVIGATION/TERRAIN FOLLOWING"] = l("NT"), S["SI.M1.NAVIGATIONAL/WEATHER AVOIDANCE"] = l("NW"), S["SI.M1.OMNI-LINE OF SIGHT (LOS)"] = l("OL"), S["SI.M1.PROXIMITY USE"] = l("PF"), S["SI.M1.POINT-TO-POINT LINE OF SIGHT (LOS)"] = l("PP"), S["SI.M1.INSTRUMENTATION"] = l("RI"), S["SI.M1.RANGE ONLY"] = l("RO"), S["SI.M1.SONOBUOY"] = l("SB"), S["SI.M1.SATELLITE DOWNLINK"] = l("SD"), S["SI.M1.SPACE"] = l("SP"), S["SI.M1.SURFACE SEARCH"] = l("SS"), S["SI.M1.SHELL TRACKING"] = l("ST"), S["SI.M1.SATELLITE UPLINK"] = l("SU"), S["SI.M1.TARGET ACQUISITION"] = l("TA"), S["SI.M1.TARGET ILLUMINATION"] = l("TI"), S["SI.M1.TROPOSPHERIC SCATTER"] = l("TS"), S["SI.M1.TARGET TRACKING"] = l("TT"), S["SI.M1.UNKNOWN"] = l("UN"), S["SI.M1.VIDEO REMOTING"] = l("VR"), S["SI.M1.EXPERIMENTAL"] = l("XP"), S["SI.M1.ALPHA"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "A"
        }, S["SI.M1.BRAVO"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "B"
        }, S["SI.M1.CHARLIE"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "C"
        }, S["SI.M1.DELTA"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "D"
        }, S["SI.M1.ECHO"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "E"
        }, S["SI.M1.FOXTROT"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "F"
        }, S["SI.M1.HOTEL"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "H"
        }, S["SI.M1.INDY"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "I"
        }, S["SI.M1.MIKE"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "M"
        }, S["SI.M1.OSCAR"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "O"
        }, S["SI.M1.PAPA"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "P"
        }, S["SI.M1.SIERRA"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "S"
        }, S["SI.M1.TANGO"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "T"
        }, S["SI.M1.UNIFORM"] = {
            type: "text",
            stroke: !1,
            x: 68,
            y: 110,
            fontsize: 25,
            text: "U"
        }, S["SI.M2.ALPHA"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "A"
        }, S["SI.M2.BRAVO"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "B"
        }, S["SI.M2.CHARLIE"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "C"
        }, S["SI.M2.CYBER"] = r("CYB"), S["SI.M2.DELTA"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "D"
        }, S["SI.M2.ECHO"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "E"
        }, S["SI.M2.FOXTROT"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "F"
        }, S["SI.M2.GOLF"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "G"
        }, S["SI.M2.INDY"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "I"
        }, S["SI.M2.LIMA"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "L"
        }, S["SI.M2.MIKE"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "M"
        }, S["SI.M2.NOVEMBER"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "N"
        }, S["SI.M2.PAPA"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "P"
        }, S["SI.M2.SIERRA"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "S"
        }, S["SI.M2.TANGO"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "T"
        }, S["SI.M2.UNIFORM"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "U"
        }, S["SI.M2.WHISKEY"] = {
            type: "text",
            stroke: !1,
            x: 132,
            y: 110,
            fontsize: 25,
            text: "W"
        }, S["SI.M3.SPACE"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 75,
            fontsize: 25,
            text: "S"
        }, S["SI.M3.GROUND"] = {
            type: "text",
            stroke: !1,
            x: 100,
            y: 75,
            fontsize: 25,
            text: "G"
        }, S)S.hasOwnProperty(N) && (I.hasOwnProperty(N) && console.warn("Override of: " + N), n.call(this, S[N], T), I[N] = S[N]);
    }
    var z = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            f
        ],
        icons: function(I, t, E, R) {
            I["I-P-S-----"] = [], I["I-P-SC----"] = [], I["I-P-SCD---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.SIERRA"],
                E["SI.M2.DELTA"],
                E["SI.M3.SPACE"]
            ], I["I-P-SR----"] = [], I["I-P-SRD---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.DELTA"],
                E["SI.M2.TANGO"],
                E["SI.M3.SPACE"]
            ], I["I-P-SRE---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ECHO"],
                E["SI.M2.SIERRA"],
                E["SI.M3.SPACE"]
            ], I["I-P-SRI---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.INDY"],
                E["SI.M2.FOXTROT"],
                E["SI.M3.SPACE"]
            ], I["I-P-SRM---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.FOXTROT"],
                E["SI.M3.SPACE"]
            ], I["I-P-SRT---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.ALPHA"],
                E["SI.M3.SPACE"]
            ], I["I-P-SRS---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.SIERRA"],
                E["SI.M2.PAPA"],
                E["SI.M3.SPACE"]
            ], I["I-P-SRU---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.UNIFORM"],
                E["SI.M2.NOVEMBER"],
                E["SI.M3.SPACE"]
            ], I["I-A-S-----"] = [], I["I-A-SC----"] = [], I["I-A-SCC---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.MIKE"]
            ], I["I-A-SCO---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.OSCAR"],
                E["SI.M2.LIMA"]
            ], I["I-A-SCP---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.PAPA"],
                E["SI.M2.PAPA"]
            ], I["I-A-SCS---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.SIERRA"],
                E["SI.M2.UNIFORM"]
            ], I["I-A-SR----"] = [], I["I-A-SRAI--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ALPHA"],
                E["SI.M2.INDY"]
            ], I["I-A-SRAS--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ALPHA"],
                E["SI.M2.BRAVO"]
            ], I["I-A-SRC---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.INDY"]
            ], I["I-A-SRD---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.DELTA"],
                E["SI.M2.TANGO"]
            ], I["I-A-SRE---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ECHO"],
                E["SI.M2.WHISKEY"]
            ], I["I-A-SRF---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.FOXTROT"],
                E["SI.M2.CHARLIE"]
            ], I["I-A-SRI---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.INDY"],
                E["SI.M2.FOXTROT"]
            ], I["I-A-SRMA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.ALPHA"]
            ], I["I-A-SRMD--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.DELTA"]
            ], I["I-A-SRMG--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.GOLF"]
            ], I["I-A-SRMT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.TANGO"]
            ], I["I-A-SRMF--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.FOXTROT"]
            ], I["I-A-SRTI--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.INDY"]
            ], I["I-A-SRTA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.ALPHA"]
            ], I["I-A-SRTT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.TANGO"]
            ], I["I-A-SRU---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.UNIFORM"],
                E["SI.M2.NOVEMBER"]
            ], I["I-G-S-----"] = [], I["I-G-SC----"] = [], I["I-G-SCC---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.MIKE"],
                E["SI.M3.GROUND"]
            ], I["I-G-SCO---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.OSCAR"],
                E["SI.M2.LIMA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SCP---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.PAPA"],
                E["SI.M2.PAPA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SCS---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.SIERRA"],
                E["SI.M2.UNIFORM"],
                E["SI.M3.GROUND"]
            ], I["I-G-SCT---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.TANGO"],
                E["SI.M2.SIERRA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SR----"] = [], I["I-G-SRAT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ALPHA"],
                E["SI.M2.TANGO"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRAA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ALPHA"],
                E["SI.M2.ALPHA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRB---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.BRAVO"],
                E["SI.M2.SIERRA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRCS--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.SIERRA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRCA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.ALPHA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRD---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.DELTA"],
                E["SI.M2.TANGO"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRE---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ECHO"],
                E["SI.M2.WHISKEY"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRF---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.FOXTROT"],
                E["SI.M2.CHARLIE"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRH---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.HOTEL"],
                E["SI.M2.FOXTROT"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRI---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.INDY"],
                E["SI.M2.FOXTROT"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRMM--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.ECHO"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRMA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.ALPHA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRMG--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.GOLF"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRMT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.TANGO"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRMF--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.FOXTROT"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRS---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.SIERRA"],
                E["SI.M2.TANGO"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRTA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.ALPHA"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRTI--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.INDY"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRTT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.TANGO"],
                E["SI.M3.GROUND"]
            ], I["I-G-SRU---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.UNIFORM"],
                E["SI.M2.NOVEMBER"],
                E["SI.M3.GROUND"]
            ], I["I-S-S-----"] = [], I["I-S-SC----"] = [], I["I-S-SCC---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.MIKE"]
            ], I["I-S-SCO---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.OSCAR"],
                E["SI.M2.LIMA"]
            ], I["I-S-SCP---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.PAPA"],
                E["SI.M2.PAPA"]
            ], I["I-S-SCS---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.SIERRA"],
                E["SI.M2.UNIFORM"]
            ], I["I-S-SR----"] = [], I["I-S-SRAT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ALPHA"],
                E["SI.M2.TANGO"]
            ], I["I-S-SRAA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ALPHA"],
                E["SI.M2.ALPHA"]
            ], I["I-S-SRCA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.ALPHA"]
            ], I["I-S-SRCI--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.CHARLIE"],
                E["SI.M2.INDY"]
            ], I["I-S-SRD---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.DELTA"],
                E["SI.M2.TANGO"]
            ], I["I-S-SRE---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ECHO"],
                E["SI.M2.WHISKEY"]
            ], I["I-S-SRF---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.FOXTROT"],
                E["SI.M2.CHARLIE"]
            ], I["I-S-SRH---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.HOTEL"],
                E["SI.M2.FOXTROT"]
            ], I["I-S-SRI---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.INDY"],
                E["SI.M2.FOXTROT"]
            ], I["I-S-SRMM--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.ECHO"]
            ], I["I-S-SRMA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.ALPHA"]
            ], I["I-S-SRMG--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.GOLF"]
            ], I["I-S-SRMT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.TANGO"]
            ], I["I-S-SRMF--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.FOXTROT"]
            ], I["I-S-SRS---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.SIERRA"],
                E["SI.M2.SIERRA"]
            ], I["I-S-SRTA--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.ALPHA"]
            ], I["I-S-SRTI--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.INDY"]
            ], I["I-S-SRTT--"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.TANGO"]
            ], I["I-S-SRU---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.UNIFORM"],
                E["SI.M2.NOVEMBER"]
            ], I["I-U-S-----"] = [], I["I-U-SC----"] = [], I["I-U-SCO---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.OSCAR"],
                E["SI.M2.LIMA"]
            ], I["I-U-SCP---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.PAPA"],
                E["SI.M2.PAPA"]
            ], I["I-U-SCS---"] = [
                E["SI.IC.COMMUNICATIONS"],
                E["SI.M1.SIERRA"],
                E["SI.M2.UNIFORM"]
            ], I["I-U-SR----"] = [], I["I-U-SRD---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.DELTA"],
                E["SI.M2.TANGO"]
            ], I["I-U-SRE---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.ECHO"],
                E["SI.M2.WHISKEY"]
            ], I["I-U-SRM---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.MIKE"],
                E["SI.M2.FOXTROT"]
            ], I["I-U-SRS---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.SIERRA"],
                E["SI.M2.SIERRA"]
            ], I["I-U-SRT---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.TANGO"],
                E["SI.M2.ALPHA"]
            ], I["I-U-SRU---"] = [
                E["SI.IC.RADAR"],
                E["SI.M1.UNIFORM"],
                E["SI.M2.NOVEMBER"]
            ];
        }
    }, H = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            c
        ],
        icons: function(I, t, E, R) {
            I["O-V-A-----"] = [
                E["ST.IC.ARSON/FIRE"]
            ], I["O-V-M-----"] = [
                E["ST.IC.KILLING VICTIM"]
            ], I["O-V-MA----"] = [
                E["ST.IC.KILLING VICTIM"],
                E["ST.M1.MURDER"]
            ], I["O-V-MB----"] = [
                E["ST.IC.KILLING VICTIM"],
                E["ST.M1.EXECUTION (WRONGFUL KILLING)"]
            ], I["O-V-MC----"] = [
                E["ST.IC.KILLING VICTIM"],
                E["ST.M1.ASSASSINATION"]
            ], I["O-V-B-----"] = [
                E["ST.IC.BOMB"]
            ], I["O-V-Y-----"] = [
                E["ST.IC.BOOBY TRAP"]
            ], I["O-V-D-----"] = [
                E["ST.IC.DRIVE-BY SHOOTING"]
            ], I["O-V-S-----"] = [
                E["ST.IC.SNIPING"]
            ], I["O-V-P-----"] = [
                E["ST.IC.POISONING"]
            ], I["O-V-E-----"] = [
                E["ST.IC.EXPLOSION"]
            ], I["O-V-EI----"] = [
                E["ST.IC.EXPLOSION"],
                E["ST.IC.IED"]
            ], I["O-L-B-----"] = [
                E["ST.IC.BLACK LIST LOCATION"]
            ], I["O-L-G-----"] = [
                E["ST.IC.GRAY LIST LOCATION"]
            ], I["O-L-W-----"] = [
                E["ST.IC.WHITE LIST LOCATION"]
            ], I["O-L-M-----"] = [
                E["ST.IC.MASS GRAVE LOCATION"]
            ], I["O-O-P-----"] = [
                E["ST.IC.PATROLLING"]
            ], I["O-O-R-----"] = [], I["O-O-RW----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.WILLING"]
            ], I["O-O-RC----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.COERCED/IMPRESSED"]
            ], I["O-O-D-----"] = [
                E["ST.IC.DEMONSTRATION"]
            ], I["O-O-M-----"] = [
                E["ST.IC.MINE LAYING"]
            ], I["O-O-Y-----"] = [
                E["ST.IC.PSYCHOLOGICAL OPERATIONS"]
            ], I["O-O-YT----"] = [
                E["ST.IC.RADIO AND TELEVISION PSYCHOLOGICAL OPERATIONS"]
            ], I["O-O-YW----"] = [
                E["ST.IC.PSYCHOLOGICAL OPERATIONS"],
                E["ST.M1.WRITTEN PSYCHOLOGICAL OPERATIONS"]
            ], I["O-O-YH----"] = [
                E["ST.IC.PSYCHOLOGICAL OPERATIONS"],
                E["ST.M1.HOUSE-TO-HOUSE"]
            ], I["O-O-F-----"] = [
                E["ST.IC.SEARCHING"]
            ], I["O-O-S-----"] = [
                E["ST.IC.SPY"]
            ], I["O-O-O-----"] = [
                E["ST.IC.FOOD DISTRIBUTION"]
            ], I["O-O-E-----"] = [
                E["ST.IC.EXTORTION"]
            ], I["O-O-H-----"] = [], I["O-O-HT----"] = [
                E["ST.IC.KNOWN INSURGENT VEHICLE"],
                E["ST.M1.HIJACKING/HIJACKED"]
            ], I["O-O-HA----"] = [
                E["ST.IC.HIJACKING (AIRPLANE)"],
                E["ST.M1.HIJACKING/HIJACKED"]
            ], I["O-O-HV----"] = [
                E["ST.IC.HIJACKING (BOAT)"],
                E["ST.M1.HIJACKING/HIJACKED"]
            ], I["O-O-K-----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.KIDNAPPING"]
            ], I["O-O-KA----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.KIDNAPPING"],
                E["ST.IC.ATTEMPTED CRIMINAL ACTIVITY"]
            ], I["O-O-A-----"] = [
                E["ST.IC.ARREST"]
            ], I["O-O-U-----"] = [
                E["ST.IC.DRUG RELATED ACTIVITIES"]
            ], I["O-O-C-----"] = [
                E["ST.IC.COMPOSITE LOSS"]
            ], I["O-O-CA----"] = [
                E["ST.IC.COMPOSITE LOSS"],
                E["ST.M1.COMBAT"]
            ], I["O-O-CB----"] = [
                E["ST.IC.COMPOSITE LOSS"],
                E["ST.M1.ACCIDENT"]
            ], I["O-O-CC----"] = [
                E["ST.IC.COMPOSITE LOSS"],
                E["ST.M1.OTHER"]
            ], I["O-I-R-----"] = [
                E["ST.IC.GROUP"]
            ], I["O-I-S-----"] = [
                E["ST.IC.SAFE HOUSE"]
            ], I["O-I-G-----"] = [
                E["ST.IC.GRAFFITI"]
            ], I["O-I-V-----"] = [
                E["ST.IC.VANDALISM/LOOT/RANSACK/PLUNDER/SACK"]
            ], I["O-I-I-----"] = [
                E["ST.IC.KNOWN INSURGENT VEHICLE"]
            ], I["O-I-D-----"] = [
                E["ST.IC.KNOWN INSURGENT VEHICLE"],
                E["ST.M1.DRUG"]
            ], I["O-I-F-----"] = [
                E["ST.IC.INTERNAL SECURITY FORCE"]
            ], I["O-P-------"] = [
                E["ST.IC.INDIVIDUAL"]
            ], I["O-P-A-----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.LEADER"]
            ], I["O-P-B-----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.TARGETED"]
            ], I["O-P-C-----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.TERRORIST"]
            ], I["O-G-------"] = [
                E["ST.IC.GROUP"]
            ], I["O-G-A-----"] = [
                E["ST.IC.GROUP"],
                E["ST.M1.DISPLACED PERSONS, REFUGEES, AND EVACUEES"]
            ], I["O-G-B-----"] = [
                E["ST.IC.GROUP"],
                E["ST.M1.NONGOVERNMENTAL ORGANIZATION (NGO)"]
            ], I["O-G-C-----"] = [
                E["ST.IC.GROUP"],
                E["ST.M1.TERRORIST"]
            ], I["O-G-D-----"] = [
                E["ST.IC.GROUP"],
                E["ST.M1.RELIGIOUS"]
            ], I["O-G-E-----"] = [
                E["ST.IC.GROUP"],
                E["ST.M1.FOREIGN FIGHTERS"]
            ], I["O-G-F-----"] = [
                E["ST.IC.GROUP"],
                E["ST.M1.GANG"]
            ], I["O-R-------"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.RAPE"]
            ], I["O-R-A-----"] = [
                E["ST.IC.INDIVIDUAL"],
                E["ST.M1.RAPE"],
                E["ST.IC.ATTEMPTED CRIMINAL ACTIVITY"]
            ];
        }
    };
    function V(I, t, E, R, e, A) {
        var C = t.affiliation || "Friend", T = "Hostile" != C || e ? E.iconColor[C] : "rgb(255, 0, 0)", S = "Hostile" != C || e ? E.fillColor[C] : "rgb(255, 0, 0)", N = t.numberSIDC, O = E.white[C], G = {};
        for(var o in G["TP.DESTROY"] = R || N ? [
            {
                type: "path",
                fill: !1,
                d: "m 0,45 85,46.75 m 30,16.5 85,46.75 M 0,155 85,108.25 M 115,91.75 200,45"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "D"
            }
        ] : {
            type: "path",
            fill: !1,
            strokedasharray: "12,5",
            d: "M 0,155 200,45 M 0,45 200,155"
        }, G["TP.INTERDICT"] = R || N ? [
            {
                type: "path",
                fill: !1,
                d: "m 194.203,65.6674 5.49,-20.4904 -20.49,-5.4904 M 115,91.75 200,45 M 0,155 85,108.25 M 185,85 l 15,15 -15,15 m -70,-15 85,0 m -200,0 85,0"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "I"
            }
        ] : {
            type: "path",
            fill: !1,
            d: "m 0,100 200,0 M 0,155 200,45.2 M 185,85 l 15,15 -15,15 m 9.2,-49.3 5.5,-20.5 -20.5,-5.5"
        }, G["TP.NEUTRALIZE"] = R || N ? [
            {
                type: "path",
                fill: !1,
                d: "M 115,108.25 200,155 M 0,45 85,91.75"
            },
            {
                type: "path",
                fill: !1,
                strokedasharray: "12,5",
                d: "M 115,91.75 200,45 M 0,155 85,108.25"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "N"
            }
        ] : [
            {
                type: "path",
                fill: !1,
                d: "M 0,45 200,155"
            },
            {
                type: "path",
                fill: !1,
                strokedasharray: "12,5",
                d: "M 0,155 200,45"
            }
        ], G["TP.SUPPRESS"] = R || N ? [
            {
                type: "path",
                fill: !1,
                strokedasharray: "12,5",
                d: "M 115,108.25 200,155 M 0,45 85,91.75"
            },
            {
                type: "path",
                fill: !1,
                strokedasharray: "12,5",
                d: "M 115,91.75 200,45 M 0,155 85,108.25"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "S"
            }
        ] : [
            {
                type: "path",
                fill: !1,
                d: "M 0,45 200,155"
            },
            {
                type: "path",
                fill: !1,
                strokedasharray: "12,5",
                d: "M 0,155 200,45"
            }
        ], G["TP.DATUM"] = [
            {
                type: "path",
                stroke: !1,
                d: "m 100,50 0,50 50,0 C 150,72.3858 127.614,50 100,50 Z m 0,50 -50,0 c 0,27.614 22.3858,50 50,50 z"
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            }
        ], G["TP.BRIEF CONTACT"] = [
            {
                type: "path",
                d: "m 65,0 70,0 m -35,80 0,-80 m 0,100 -45,-20 90,0 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 75,
                y: 55,
                fontsize: 45,
                text: "B"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 125,
                y: 55,
                fontsize: 45,
                text: "C"
            }
        ], G["TP.LOST CONTACT"] = [
            {
                type: "path",
                d: "m 65,0 70,0 m -35,80 0,-80 m 0,100 -45,-20 90,0 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 75,
                y: 55,
                fontsize: 45,
                text: "L"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 125,
                y: 55,
                fontsize: 45,
                text: "C"
            }
        ], G["TP.SINKER"] = [
            {
                type: "path",
                fill: !1,
                d: "m 100,15 0,65 M 60,15 80,0 100,15 120,0 140,15"
            },
            {
                type: "path",
                d: "M 100,100 55,80 145,80 Z"
            }
        ], G["TP.TRIAL TRACK"] = [
            {
                type: "path",
                d: "m 65,0 70,0 m -35,80 0,-80 m 0,100 -45,-20 90,0 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 75,
                y: 55,
                fontsize: 45,
                text: "T"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 125,
                y: 55,
                fontsize: 45,
                text: "T"
            }
        ], G["TP.SONOBUOY"] = [
            {
                type: "path",
                fill: !1,
                d: "M 100,60 l 0,-35 10,10 0,-45"
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 40
            }
        ], G["TP.SONOBUOY PATTERN CENTER"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "P"
            }
        ], G["TP.SONOBUOY DIFAR"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "D"
            }
        ], G["TP.SONOBUOY LOFAR"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "L"
            }
        ], G["TP.SONOBUOY CASS"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "C"
            }
        ], G["TP.SONOBUOY DICASS"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "S"
            }
        ], G["TP.SONOBUOY BT"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "B"
            }
        ], G["TP.SONOBUOY ANM"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "A"
            }
        ], G["TP.SONOBUOY VLAD"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "V"
            }
        ], G["TP.SONOBUOY ATAC"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "T"
            }
        ], G["TP.SONOBUOY BARRA"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "BR"
            }
        ], G["TP.SONOBUOY BATHYTHERMOGRAPH TRANSMITTING SONOBUOY (BT)"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "B"
            }
        ], G["TP.SONOBUOY COMMAND ACTIVE MULTIBEAM SONOBUOY (CAMBS)"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "CM"
            }
        ], G["TP.SONOBUOY EXPENDABLE RELIABLE ACOUSTIC PATH SONOBUOY (ERAPS)"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "E"
            }
        ], G["TP.SONOBUOY RO"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "R"
            }
        ], G["TP.SONOBUOY KINGPIN"] = [
            G["TP.SONOBUOY"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "K"
            }
        ], G["TP.SONOBUOY EXPIRED"] = [
            G["TP.SONOBUOY"],
            {
                type: "path",
                fill: !1,
                d: "M 40,60 l 120,80 M 40,140 l 120,-80"
            }
        ], G["TP.SEARCH"] = {
            type: "path",
            d: "m 80,80 20,20 -20,20 40,0 -20,-20 20,-20 z M 50,150 150,50 M 50,50 150,150"
        }, G["TP.SEARCH AREA"] = [
            G["TP.SEARCH"],
            R || N ? [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 60,
                    y: 115,
                    fontsize: 45,
                    text: "S"
                },
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 140,
                    y: 115,
                    fontsize: 45,
                    text: "A"
                }
            ] : {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "SA"
            }
        ], G["TP.DIP POSITION"] = [
            G["TP.SEARCH"],
            R || N ? [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 60,
                    y: 115,
                    fontsize: 45,
                    text: "D"
                },
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 140,
                    y: 115,
                    fontsize: 45,
                    text: "P"
                }
            ] : {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "DIP"
            }
        ], G["TP.SEARCH CENTER"] = {
            type: "path",
            stroke: !1,
            d: "m 100,100 -50,10 0,-20 z m 0,0 10,50 -20,0 z m 0,0 50,-10 0,20 z m 0,0 -10,-50 20,0 z"
        }, G["TP.REFERENCE POINT"] = [
            {
                type: "path",
                fill: !1,
                d: "M 160,160 40,160 40,40 160,40 Z"
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.NAVIGATIONAL REFERENCE"] = !N && R ? {
            type: "path",
            fill: !1,
            d: "M 160,160 40,160 40,40 160,40 Z M 160,160 40,40 M 40,160 160,40"
        } : {
            type: "path",
            fill: !1,
            d: "M 160,160 40,40 M 40,160 160,40"
        }, G["TP.SPECIAL POINT"] = [
            G["TP.NAVIGATIONAL REFERENCE"],
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.AIRFIELD"] = [
            {
                type: "path",
                fill: !1,
                d: "M 35,125 165,60 m -135,40 140,0"
            }
        ], G["TP.DLRP"] = [
            G["TP.SPECIAL POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "D"
            }
        ], G["TP.POINT OF INTENDED MOVEMENT"] = [
            G["TP.REFERENCE POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "P"
            }
        ], G["TP.PRE-LANDFALL WAYPOINT"] = [
            G["TP.REFERENCE POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "PL"
            }
        ], G["TP.MARSHALL POINT"] = [
            G["TP.REFERENCE POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "M"
            }
        ], G["TP.REFERENCE POINT WAYPOINT"] = [
            G["TP.REFERENCE POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "W"
            }
        ], G["TP.CORRIDOR TAB"] = [
            G["TP.REFERENCE POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "C"
            }
        ], G["TP.ENEMY POINT"] = [
            G["TP.REFERENCE POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "ENY"
            }
        ], G["TP.POINT OF INTEREST"] = [
            {
                type: "path",
                d: "M 129.021,41.957 C 121.48,49.9458 110.986,54.4816 100,54.5 89.0432,54.4928 78.569,49.9914 71.0234,42.0469 L 100,100 Z"
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 15,
                r: 40
            }
        ], G["POINT OF INTEREST \u2013 LAUNCH EVENT"] = [
            G["TP.POINT OF INTEREST"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 30,
                fontsize: 40,
                fontweight: "bold",
                text: "LE"
            }
        ], G["TP.SHIP AREA OF INTEREST (AEGIS ONLY)"] = {
            type: "circle",
            fill: !1,
            cx: 100,
            cy: 100,
            r: 50
        }, G["TP.ACTIVE MANOEUVRE AREA (AEGIS ONLY)"] = {
            type: "circle",
            fill: !1,
            stroke: "rgb(254,203,47)",
            cx: 100,
            cy: 100,
            r: 60
        }, G["TP.PLAN SHIP"] = [
            {
                type: "circle",
                fill: S,
                stroke: S,
                cx: 100,
                cy: 100,
                r: 15
            },
            {
                type: "circle",
                stroke: S,
                cx: 100,
                cy: 100,
                r: 45,
                fill: !1
            }
        ], G["TP.AIM POINT"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 35,
                fill: !1
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 45,
                fill: !1
            }
        ], G["TP.DEFENDED ASSET"] = {
            type: "path",
            fill: !1,
            d: "m 90,135 0,-30 20,0 0,30 m -50,0 0,-50 -10,0 0,-20 20,0 0,10 20,0 0,-10 20,0 0,10 20,0 0,-10 20,0 0,20 -10,0 0,50 z"
        }, G["TP.CHEMICAL EVENT"] = [
            {
                type: "path",
                fill: !1,
                d: "M 110,60 C 110,40 115,25 80,20 M 90,60 C 90,40 85,25 120,20 m -20,80 -60,-110 120,0 z"
            },
            {
                type: "path",
                d: "m 120,20 c 10,0 10,15 0,15 -10,0 -10,-15 0,-15 z M 80,35 c 10,0 10,-15 0,-15 -10,0 -10,15 0,15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 30,
                text: "C"
            }
        ], G["TP.CHEMICAL \u2013 TOXIC INDUSTRIAL MATERIAL"] = [
            {
                type: "path",
                fill: !1,
                d: "M 110,60 C 110,40 115,25 80,20 M 90,60 C 90,40 85,25 120,20 m -20,80 -60,-110 120,0 z"
            },
            {
                type: "path",
                d: "m 120,20 c 10,0 10,15 0,15 -10,0 -10,-15 0,-15 z M 80,35 c 10,0 10,-15 0,-15 -10,0 -10,15 0,15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 30,
                text: "C"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 85,
                fontsize: 30,
                text: "T"
            }
        ], G["TP.BIOLOGICAL EVENT"] = [
            {
                type: "path",
                fill: !1,
                d: "M 110,60 C 110,40 115,25 80,20 M 90,60 C 90,40 85,25 120,20 m -20,80 -60,-110 120,0 z"
            },
            {
                type: "path",
                d: "m 120,20 c 10,0 10,15 0,15 -10,0 -10,-15 0,-15 z M 80,35 c 10,0 10,-15 0,-15 -10,0 -10,15 0,15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 30,
                text: "B"
            }
        ], G["TP.BIOLOGICAL \u2013 TOXIC INDUSTRIAL MATERIAL"] = [
            {
                type: "path",
                fill: !1,
                d: "M 110,60 C 110,40 115,25 80,20 M 90,60 C 90,40 85,25 120,20 m -20,80 -60,-110 120,0 z"
            },
            {
                type: "path",
                d: "m 120,20 c 10,0 10,15 0,15 -10,0 -10,-15 0,-15 z M 80,35 c 10,0 10,-15 0,-15 -10,0 -10,15 0,15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 30,
                text: "B"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 85,
                fontsize: 30,
                text: "T"
            }
        ], G["TP.NUCLEAR EVENT"] = [
            {
                type: "path",
                fill: !1,
                d: "M 110,60 C 110,40 115,25 80,20 M 90,60 C 90,40 85,25 120,20 m -20,80 -60,-110 120,0 z"
            },
            {
                type: "path",
                d: "m 120,20 c 10,0 10,15 0,15 -10,0 -10,-15 0,-15 z M 80,35 c 10,0 10,-15 0,-15 -10,0 -10,15 0,15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 30,
                text: "N"
            }
        ], G["TP.RADIOLOGICAL EVENT"] = [
            {
                type: "path",
                fill: !1,
                d: "M 110,60 C 110,40 115,25 80,20 M 90,60 C 90,40 85,25 120,20 m -20,80 -60,-110 120,0 z"
            },
            {
                type: "path",
                d: "m 120,20 c 10,0 10,15 0,15 -10,0 -10,-15 0,-15 z M 80,35 c 10,0 10,-15 0,-15 -10,0 -10,15 0,15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 30,
                text: "R"
            }
        ], G["TP.RADIOLOGICAL \u2013 TOXIC INDUSTRIAL MATERIAL"] = [
            {
                type: "path",
                fill: !1,
                d: "M 110,60 C 110,40 115,25 80,20 M 90,60 C 90,40 85,25 120,20 m -20,80 -60,-110 120,0 z"
            },
            {
                type: "path",
                d: "m 120,20 c 10,0 10,15 0,15 -10,0 -10,-15 0,-15 z M 80,35 c 10,0 10,-15 0,-15 -10,0 -10,15 0,15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 30,
                text: "R"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 85,
                fontsize: 30,
                text: "T"
            }
        ], G["TP.DROP POINT"] = {
            type: "path",
            fill: !1,
            d: "m 130,100 0,-40 m -60,40 0,-40 m 60,40 0,0 c 0,8.284 -6.716,15 -15,15 -8.284,0 -15,-6.716 -15,-15 m 0,0 0,0 c 0,8.284 -6.7157,15 -15,15 -8.2843,0 -15,-6.716 -15,-15 m 30,-40 0,40"
        }, G["TP.ENTRY POINT"] = {
            type: "path",
            fill: !1,
            d: "m 100,100 0,-50 m -35,15 35,35 35,-35 m -85,35 100,0"
        }, G["TP.AIR DETONATION"] = {
            type: "path",
            d: "m 55,150 90,0 m -35,-95 5,20 15,-10 0,15 15,5 -15,10 15,10 -15,5 5,15 -20,-5 -5,20 -10,-15 -10,20 -5,-25 -20,10 5,-15 L 55,105 70,95 60,85 70,80 70,65 85,75 90,55 100,70 Z",
            fill: !1
        }, G["TP.GROUND ZERO"] = {
            type: "path",
            stroke: !1,
            d: "M 100 28 C 100 28 65.4398 29.8261 61.6543 55 C 60.2826 64.1213 75.0115 70.4884 82.2363 71.6543 C 89.4611 72.8201 91.7277 55.3462 98.5098 56.0371 L 93 90 C 93 90 70 90 67 97 C 65.0304 101.596 100 100 100 100 C 100 100 134.97 101.596 133 97 C 130 90 107 90 107 90 L 101.49 56.0371 C 108.272 55.3462 110.539 72.8201 117.764 71.6543 C 124.988 70.4884 139.718 64.1213 138.346 55 C 134.56 29.8261 100 28 100 28 z"
        }, G["TP.LAUNCHED TORPEDO (AEGIS ONLY)"] = {
            type: "path",
            d: "m 150,90 0,20 m -10,-10 10,0 m -97,-10 84,0 c 1.662,0 3,1.338 3,3 l 0,14 c 0,1.662 -1.338,3 -3,3 l -84,0 c -1.662,0 -3,-1.338 -3,-3 l 0,-14 c 0,-1.662 1.338,-3 3,-3 z"
        }, G["TP.MSL DETECT POINT"] = {
            type: "path",
            d: "m 95,100 0,-55 -10,0 15,-15 15,15 -10,0 0,55 m -55,0 100,0"
        }, G["TP.ACOUSTIC COUNTER MEASURE (DECOY)"] = {
            type: "path",
            d: "M 107.5,55 92.5518,70 107.5,85 Z M 50,30 150,30 m -90,70 0,-5 80,0 0,5 z m 70,-45 -15,15 15,15 z M 85,55 70,70 85,85 Z m 15,-25 0,33"
        }, G["TP.ELECTRONIC COUNTER MEASURES (ECM) DECOY"] = [
            {
                type: "path",
                d: "m 80,120 -20,10 20,10 z m 30,0 -20,10 20,10 0,-20 z m 30,0 -20,10 20,10 z m -25,-20 c 0,10 -10,18 -19.4,14 -9.4,-2 -13.8,-14.7 -8,-22.5 5.2,-8.2 18.4,-8.7 24.4,-0.8 2,2.6 3,5.9 3,9.3 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 50,50 0,100 100,0 0,-100 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 80,
                fontsize: 30,
                text: "ECM"
            }
        ], G["TP.IMPACT POINT"] = {
            type: "path",
            d: "m 50,100 40,-10 10,-40 10,40 40,10 -40,10 -10,40 -10,-40 -40,-10"
        }, G["TP.PREDICTED IMPACT POINT"] = {
            type: "path",
            fill: !1,
            strokedasharray: "12,5",
            d: "m 50,100 40,-10 10,-40 10,40 40,10 -40,10 -10,40 -10,-40 -40,-10"
        }, G["TP.FORMATION"] = {
            type: "path",
            fill: !1,
            d: "m 100,50 0,100 m -50,-50 100,0"
        }, G["TP.HARBOR"] = {
            type: "path",
            fill: !1,
            d: "M 80,140 50,60 150,60 120,140"
        }, G["TP.HARBOR POINT Q"] = [
            G["TP.HARBOR"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "Q"
            }
        ], G["TP.HARBOR POINT A"] = [
            G["TP.HARBOR"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "A"
            }
        ], G["TP.HARBOR POINT Y"] = [
            G["TP.HARBOR"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "Y"
            }
        ], G["TP.HARBOR POINT X"] = [
            G["TP.HARBOR"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "X"
            }
        ], G["TP.ROUTE"] = {
            type: "path",
            fill: !1,
            d: "m 138.484,76.82 c 0,-7.4823 6.066,-13.5478 13.548,-13.548 7.483,-3e-4 13.549,6.0653 13.549,13.548 m -27.097,0 0,0 c 0,6.9484 -5.634,12.5807 -12.582,12.58 -6.948,-4e-4 -12.58,-5.6324 -12.58,-12.58 m -27.097,0 c 2e-4,-7.4823 6.0657,-13.5478 13.548,-13.548 7.483,-3e-4 13.549,6.0653 13.549,13.548 m -79.3554,0 c 2e-4,-7.4824 6.066,-13.548 13.5484,-13.548 7.4824,0 13.5482,6.0656 13.5484,13.548 m 25.1616,0 0,0 C 86.2246,83.7681 80.5918,89.4003 73.6437,89.4 66.696,89.3998 61.0638,83.7677 61.0634,76.82 m 77.4206,47.328 c 0,-7.482 6.066,-13.548 13.548,-13.548 7.483,0 13.549,6.065 13.549,13.548 m -27.097,0 0,0 c 0,6.948 -5.634,12.581 -12.582,12.58 -6.948,0 -12.58,-5.632 -12.58,-12.58 m -27.097,0 c 2e-4,-7.482 6.0657,-13.548 13.548,-13.548 7.483,0 13.549,6.065 13.549,13.548 m -79.3554,0 c 2e-4,-7.482 6.066,-13.548 13.5484,-13.548 7.4824,0 13.5482,6.066 13.5484,13.548 m 25.1616,0 0,0 c -4e-4,6.948 -5.6332,12.58 -12.5813,12.58 -6.9477,0 -12.5799,-5.632 -12.5803,-12.58 m -27.0968,-23.664 132.5184,0"
        }, G["TP.ROUTE RENDEZVOUS"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "R"
            }
        ], G["TP.ROUTE DIVERSIONS"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "D"
            }
        ], G["TP.ROUTE WAYPOINT"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "W"
            }
        ], G["TP.ROUTE PIM"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "M"
            }
        ], G["TP.ROUTE POINT R"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "P"
            }
        ], G["TP.PICKET ROUTE"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "PK"
            }
        ], G["TP.POINT R ROUTE"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "R"
            }
        ], G["TP.RENDEZVOUS ROUTE"] = [
            G["TP.ROUTE"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 170,
                fontsize: 45,
                text: "RZ"
            }
        ], G["TP.AIR CONTROL"] = {
            type: "path",
            fill: !1,
            d: "m 140,165 0,-130 m -80,0 0,130"
        }, G["TP.AIR CONTROL POINT"] = [
            G["TP.AIR CONTROL"],
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.COMBAT AIR PATROL (CAP)"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "C"
            }
        ], G["TP.AIRBORNE EARLY WARNING (AEW)"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "W"
            }
        ], G["TP.TANKING"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: N || R ? 115 : 155,
                fontsize: 45,
                text: "K"
            },
            N || R ? [] : {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.FIXED WING"] = [
            G["TP.AIR CONTROL"],
            N || R ? [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 75,
                    fontsize: 32,
                    text: R ? "ASW" : "AS"
                },
                {
                    type: "path",
                    d: R ? "m 100,81.3203 c -1.5135,-0 -2.5365,2.6426 -2.5365,2.6426 l -0.1365,14.1465 -28.3641,29.9996 0.1484,4.604 28.5162,-18.748 -0.2929,24.43 -6.3073,6.017 -0.096,3.766 8.0313,-3.524 1.0312,3.326 0,0.02 0,-0.01 0,0.01 0,-0.02 1.0312,-3.326 8.031,3.524 -0.09,-3.766 -6.309,-6.017 -0.293,-24.43 28.518,18.748 0.146,-4.604 -28.364,-29.9996 -0.136,-14.1465 c 0,0 -1.014,-2.6416 -2.528,-2.6426 z" : "M 80,88.3 C 60,80 60,120 80,111.4 L 100.2,99.9 120,111.3 C 140,120 140,80 120,88.6 l -19.8,11.3 z",
                    stroke: !1
                }
            ] : [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 155,
                    fontsize: 45,
                    text: "F"
                },
                {
                    type: "circle",
                    cx: 100,
                    cy: 100,
                    r: 15
                }
            ]
        ], G["TP.ROTARY WING"] = [
            G["TP.AIR CONTROL"],
            N || R ? [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 75,
                    fontsize: 32,
                    text: "ASW"
                },
                {
                    type: "path",
                    d: "m 65,80 0,40 70,-40 0,40 -70,-40",
                    stroke: !1
                }
            ] : [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 155,
                    fontsize: 45,
                    text: "H"
                },
                {
                    type: "circle",
                    cx: 100,
                    cy: 100,
                    r: 15
                }
            ]
        ], G["TP.SUCAP - FIXED WING"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 75,
                fontsize: 32,
                text: "SUW"
            },
            {
                type: "path",
                d: R ? "m 100,81.3203 c -1.5135,-0 -2.5365,2.6426 -2.5365,2.6426 l -0.1365,14.1465 -28.3641,29.9996 0.1484,4.604 28.5162,-18.748 -0.2929,24.43 -6.3073,6.017 -0.096,3.766 8.0313,-3.524 1.0312,3.326 0,0.02 0,-0.01 0,0.01 0,-0.02 1.0312,-3.326 8.031,3.524 -0.09,-3.766 -6.309,-6.017 -0.293,-24.43 28.518,18.748 0.146,-4.604 -28.364,-29.9996 -0.136,-14.1465 c 0,0 -1.014,-2.6416 -2.528,-2.6426 z" : "M 80,88.3 C 60,80 60,120 80,111.4 L 100.2,99.9 120,111.3 C 140,120 140,80 120,88.6 l -19.8,11.3 z",
                stroke: !1
            }
        ], G["TP.SUCAP - ROTARY WING"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 75,
                fontsize: 32,
                text: "ASW"
            },
            {
                type: "path",
                d: "m 65,80 0,40 70,-40 0,40 -70,-40",
                stroke: !1
            }
        ], G["TP.MIW - FIXED WING"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 75,
                fontsize: 32,
                text: R ? "MIW" : "MW"
            },
            {
                type: "path",
                d: R ? "m 100,81.3203 c -1.5135,-0 -2.5365,2.6426 -2.5365,2.6426 l -0.1365,14.1465 -28.3641,29.9996 0.1484,4.604 28.5162,-18.748 -0.2929,24.43 -6.3073,6.017 -0.096,3.766 8.0313,-3.524 1.0312,3.326 0,0.02 0,-0.01 0,0.01 0,-0.02 1.0312,-3.326 8.031,3.524 -0.09,-3.766 -6.309,-6.017 -0.293,-24.43 28.518,18.748 0.146,-4.604 -28.364,-29.9996 -0.136,-14.1465 c 0,0 -1.014,-2.6416 -2.528,-2.6426 z" : "M 80,88.3 C 60,80 60,120 80,111.4 L 100.2,99.9 120,111.3 C 140,120 140,80 120,88.6 l -19.8,11.3 z",
                stroke: !1
            }
        ], G["TP.MIW - ROTARY WING"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 75,
                fontsize: 32,
                text: R ? "MIW" : "MW"
            },
            {
                type: "path",
                d: "m 65,80 0,40 70,-40 0,40 -70,-40",
                stroke: !1
            }
        ], G["TP.STRIKE IP"] = [
            G["TP.AIR CONTROL"],
            N || R ? {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "S"
            } : [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 155,
                    fontsize: 45,
                    text: "S"
                },
                {
                    type: "circle",
                    cx: 100,
                    cy: 100,
                    r: 15
                }
            ]
        ], G["TP.CORRIDOR TAB POINT"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 155,
                fontsize: 45,
                text: "C"
            },
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.AIR CONTROL RENDEZVOUS"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: N || R ? 115 : 155,
                fontsize: 45,
                text: "RZ"
            }
        ], G["TP.CAP STATION"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: N || R ? 115 : 155,
                fontsize: 45,
                text: "C"
            }
        ], G["TP.AEW STATION"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: N || R ? 115 : 155,
                fontsize: 45,
                text: "W"
            }
        ], G["TP.TACAN"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: N || R ? 115 : 155,
                fontsize: 45,
                text: "T"
            },
            N || R ? [] : {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.REPLENISHMENT STATION"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: N || R ? 115 : 155,
                fontsize: 45,
                text: "RP"
            }
        ], G["TP.TANKING"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: N || R ? 115 : 155,
                fontsize: 45,
                text: "K"
            }
        ], G["TP.TOMCAT"] = [
            G["TP.AIR CONTROL"],
            N || R ? {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "TC"
            } : [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 155,
                    fontsize: 45,
                    text: "O"
                },
                {
                    type: "circle",
                    cx: 100,
                    cy: 100,
                    r: 15
                }
            ]
        ], G["TP.RESCUE"] = [
            G["TP.AIR CONTROL"],
            N ? {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "RS"
            } : R ? {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "RC"
            } : [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 155,
                    fontsize: 45,
                    text: "R"
                },
                {
                    type: "circle",
                    cx: 100,
                    cy: 100,
                    r: 15
                }
            ]
        ], G["TP.REPLENISH"] = [
            G["TP.AIR CONTROL"],
            N || R ? {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "RP"
            } : [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 155,
                    fontsize: 45,
                    text: "F"
                },
                {
                    type: "circle",
                    cx: 100,
                    cy: 100,
                    r: 15
                }
            ]
        ], G["TP.MARSHALL"] = [
            G["TP.AIR CONTROL"],
            N || R ? {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "M"
            } : [
                {
                    type: "text",
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 155,
                    fontsize: 45,
                    text: "M"
                },
                {
                    type: "circle",
                    cx: 100,
                    cy: 100,
                    r: 15
                }
            ]
        ], G["TP.UNMANNED AERIAL SYSTEM"] = [
            G["TP.AIR CONTROL"],
            {
                type: "path",
                stroke: !1,
                d: "m 70,85 30,15 30,-15 0,15 -30,15 -30,-15 z"
            }
        ], G["TP.VTUA"] = [
            G["TP.AIR CONTROL"],
            {
                type: "path",
                stroke: !1,
                d: "m 70,95 30,15 30,-15 0,30 -30,-15 -30,15 z m 0,-25 30,15 30,-15 0,15 -30,15 -30,-15 z"
            }
        ], G["TP.ORBIT"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "O"
            }
        ], G["TP.ORBIT - FIGURE EIGHT"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "O"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "F8"
            }
        ], G["TP.ORBIT - RACE TRACK"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "O"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "RT"
            }
        ], G["TP.ORBIT - RANDOM, CLOSED"] = [
            G["TP.AIR CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "O"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 150,
                fontsize: 40,
                text: "RC"
            }
        ], G["TP.ACTION POINT"] = {
            type: "path",
            fill: !1,
            d: "m 60,45 80,0 m -40,55 -40,-55 0,-105 80,0 0,105 z"
        }, G["TP.ACTION CHECK POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "CKP"
            }
        ], G["TP.CONTACT POINT"] = N ? {
            type: "path",
            fill: !1,
            d: "M 50,50 150,50 150,150 50,150z"
        } : {
            type: "path",
            fill: !1,
            d: "m 100,100 0,-35 -45,0 0,-75 90,0 0,75 -45,0"
        }, G["TP.CENTRE OF MAIN EFFORT"] = [
            {
                type: "path",
                fill: !1,
                d: "m 155,100 0,-35 M 45,100 45,65 m 88,0 0,35 m -22,-35 0,35 m -22,-35 0,35 m -22,0 0,-35 m -37,70 0,-35 140,0 0,40"
            }
        ], G["TP.COORDINATION POINT"] = [
            {
                type: "path",
                fill: !1,
                d: "m 65,135 70,-70 m -70,0 70,70"
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            }
        ], G["TP.DECISION POINT"] = {
            type: "path",
            fill: !1,
            d: "M 99.9998,25.5886 117.061,76.5192 170.77,77.0054 127.604,108.968 143.738,160.2 100,129.024 56.2624,160.2 72.3967,108.968 29.2306,77.0059 82.9403,76.5192 Z"
        }, G["TP.DISTRESS CALL"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "SOS"
            }
        ], G["TP.ENTRY CONTROL POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "EC"
            }
        ], G["TP.FLY-TO-POINT (SONOBUOY)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "FTP"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 35,
                text: "SBY"
            }
        ], G["TP.FLY-TO-POINT (WEAPON)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "FTP"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 35,
                text: "WPN"
            }
        ], G["TP.FLY-TO-POINT (NORMAL)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "FTP"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 20,
                fontsize: 35,
                text: "NRM"
            }
        ], G["TP.ACTION LINKUP POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "LU"
            }
        ], G["TP.ACTION PASSAGE POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "PP"
            }
        ], G["TP.ACTION RALLY POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "RLY"
            }
        ], G["TP.ACTION RELEASE POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "RP"
            }
        ], G["TP.ACTION START POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "SP"
            }
        ], G["TP.ACTION AMNESTY POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "AMN"
            }
        ], G["TP.WAYPOINT"] = {
            type: "path",
            fill: !1,
            strokewidth: 8,
            d: "m 65,135 70,-70 m -70,0 70,70"
        }, G["TP.COMBATANT STATION"] = [
            G["TP.WAYPOINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "CBT"
            }
        ], G["TP.PICKET STATION"] = [
            G["TP.WAYPOINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "PKT"
            }
        ], G["TP.ASW SHIP STATION"] = [
            G["TP.WAYPOINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "ASW"
            }
        ], G["TP.REPLENISHMENT AT SEA (RAS) STATION"] = [
            G["TP.WAYPOINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "RAS"
            }
        ], G["TP.RESCUE STATION"] = [
            G["TP.WAYPOINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "RSC"
            }
        ], G["TP.SUBMARINE STATION"] = [
            G["TP.WAYPOINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "SUB"
            }
        ], G["TP.ASW SUBMARINE STATION"] = [
            G["TP.WAYPOINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 75,
                y: 115,
                fontsize: 40,
                text: "ASW/SUB"
            }
        ], G["TP.SEA SURFACE CONTROL"] = {
            type: "path",
            fill: !1,
            d: "m 30,60 140,0 m -140,80 140,0"
        }, G["TP.SEA SURFACE CONTROL STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.(USV) CONTROL STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "path",
                stroke: !1,
                d: "m 100,115 45,-20 0,-15 -45,20 -45,-20 0,15 z"
            }
        ], G["TP.(USV)"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "path",
                stroke: !1,
                d: "m 55,100 45,20 45,-20 0,15 -45,20 -45,-20 z"
            }
        ], G["TP.(RMV) USV CONTROL STATION"] = [
            G["TP.(USV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "RMV"
            }
        ], G["TP.USV - ASW CONTROL STATION"] = [
            G["TP.(USV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "ASW"
            }
        ], G["TP.MINE WARFARE UNMANNED UNDERWATER VEHICLE SURFACE STATION"] = [
            G["TP.(USV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "MW"
            }
        ], G["TP.USV - SUW CONTROL STATION"] = [
            G["TP.(USV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "SUW"
            }
        ], G["TP.USV - MIW CONTROL STATION"] = [
            G["TP.(USV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "MIW"
            }
        ], G["TP.ASW CONTROL STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "ASW"
            }
        ], G["TP.MINE WARFARE SURFACE STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "MW"
            }
        ], G["TP.NON-COMBATANT SURFACE STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "NC"
            }
        ], G["TP.SUW CONTROL STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "SUW"
            }
        ], G["TP.MIW CONTROL STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "MIW"
            }
        ], G["TP.PICKET CONTROL STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "PK"
            }
        ], G["TP.RENDEZVOUS CONTROL POINT"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "RZ"
            }
        ], G["TP.REPLENISHMENT AT SEA SURFACE STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "RAS"
            }
        ], G["TP.RESCUE CONTROL POINT"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "RS"
            }
        ], G["TP.REPLENISHMENT CONTROL POINT"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "RP"
            }
        ], G["TP.NONCOMBATANT CONTROL STATION"] = [
            G["TP.SEA SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 45,
                text: "NC"
            }
        ], G["TP.SUB SURFACE CONTROL"] = [
            {
                type: "path",
                fill: !1,
                d: "m 30,140 140,0"
            },
            {
                type: "path",
                fill: !1,
                strokedasharray: "12,4",
                d: "m 30,60 140,0"
            }
        ], G["TP.SUB SURFACE CONTROL STATION"] = [
            G["TP.SUB SURFACE CONTROL"],
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.(UUV) CONTROL STATION"] = [
            G["TP.SUB SURFACE CONTROL"],
            {
                type: "path",
                stroke: !1,
                d: "m 100,115 45,-20 0,-15 -45,20 -45,-20 0,15 z"
            }
        ], G["TP.(UUV)"] = [
            G["TP.SUB SURFACE CONTROL"],
            {
                type: "path",
                stroke: !1,
                d: "m 55,100 45,20 45,-20 0,15 -45,20 -45,-20 z"
            }
        ], G["TP.UUV - ASW CONTROL STATION"] = [
            G["TP.(UUV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "ASW"
            }
        ], G["TP.MINE WARFARE UNMANNED UNDERWATER VEHICLE SUBSURFACE STATION"] = [
            G["TP.(UUV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "MW"
            }
        ], G["TP.UUV - SUW CONTROL STATION"] = [
            G["TP.(UUV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "SUW"
            }
        ], G["TP.UUV - MIW CONTROL STATION"] = [
            G["TP.(UUV)"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 95,
                fontsize: 40,
                text: "MIW"
            }
        ], G["TP.SUBMARINE CONTROL STATION"] = [
            G["TP.SUB SURFACE CONTROL"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 130,
                fontsize: 35,
                text: "SS"
            },
            {
                type: "path",
                d: "m 75,95 0,-20 50,0 0,20 z m 25,-30 0,40"
            }
        ], G["TP.ASW SUBMARINE CONTROL STATION"] = [
            G["TP.SUB SURFACE CONTROL"],
            {
                type: "path",
                d: "m 68.75,105 -12.5,12.5 12.5,12.5 62.5,0 12.5,-12.5 -12.5,-12.5 z M 75,95 l 0,-20 50,0 0,20 z m 25,-30 0,40"
            }
        ], G["TP.AIR CONTROL POINT (ACP)"] = [
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 90,
                fontsize: 30,
                text: "ACP"
            }
        ], G["TP.COMMUNICATIONS CHECKPOINT"] = [
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 90,
                fontsize: 30,
                text: "CCP"
            }
        ], G["TP.PULL-UP POINT"] = [
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "start",
                x: 160,
                y: 115,
                fontsize: 40,
                text: "PUP"
            },
            {
                type: "path",
                fill: !1,
                d: "m 65,80 0,40 70,-40 0,40 z"
            }
        ], G["TP.DOWNED AIRCREW PICKUP POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "circle",
                cx: 100,
                cy: -35,
                r: 12
            },
            {
                type: "path",
                fill: !1,
                d: "m 75,35 50,0 m -25,-45 0,45 m -30,-75 30,30 30,-30"
            }
        ], G["TP.DUMMY MINEFIELD"] = [
            {
                type: "path",
                fill: !1,
                d: "m 75,100 c 0,5.523 -4.4772,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.5228,0 10,4.4772 10,10 z m 70,0 c 0,5.523 -4.477,10 -10,10 -5.523,0 -10,-4.477 -10,-10 0,-5.5228 4.477,-10 10,-10 5.523,0 10,4.4772 10,10 z m -35,0 c 0,5.523 -4.477,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.523,0 10,4.4772 10,10 z m -70,-40 0,80 120,0 0,-80 z"
            },
            {
                type: "path",
                fill: !1,
                strokedasharray: "15,10",
                d: "M 160,60 100,-5 M 40,60 100,-5"
            }
        ], G["TP.TARGET REFERENCE"] = {
            type: "path",
            fill: !1,
            d: "m 50,100 100,0 m -50,-50 0,100"
        }, G["TP.OBSERVATION POST/OUTPOST"] = {
            type: "path",
            fill: !1,
            d: "m 100,45 47.6,82.5 -95.2,0 z"
        }, G["TP.COMBAT OUTPOST"] = {
            type: "path",
            fill: !1,
            d: "m 140,140 0,-12.5 m -16,12.5 0,-12.5 m -16,12.5 0,-12.5 m -48.0001,12.5 3e-4,-12.5 m 15.9993,12.5 4e-4,-12.501 m 16,12.501 3e-4,-12.5 m -46.43,-12.493 10.8256,6.25 m -2.8256,-20.107 10.8256,6.251 m -2.8257,-20.1071 10.8257,6.2506 m 13.1743,-47.8198 10.8257,6.2506 m -18.8253,7.6056 10.8256,6.2506 m -18.826,7.606 10.8257,6.2506 M 114.43,45.725 l -10.826,6.25 m 18.826,7.6064 -10.826,6.25 m 18.826,7.6064 -10.826,6.25 m 34.826,35.3192 -10.826,6.25 m 2.826,-20.106 -10.826,6.25 m 2.826,-20.1068 -10.826,6.25 M 99.9998,45 l 47.6312,82.5 -95.2623,0 z"
        }, G["TP.OBSERVATION POST/RECONNAISSANCE"] = {
            type: "path",
            fill: !1,
            d: "M 52.3687,127.5 123.816,86.2499 M 99.9998,45 l 47.6312,82.5 -95.2623,0 z"
        }, G["TP.FORWARD OBSERVER POSITION"] = [
            G["TP.OBSERVATION POST/RECONNAISSANCE"],
            {
                type: "path",
                d: "m 115,100 c 0,8.284 -6.716,15 -15,15 -8.2843,0 -15,-6.716 -15,-15 0,-8.2843 6.7157,-15 15,-15 8.284,0 15,6.7157 15,15 z"
            }
        ], G["TP.SENSOR OUTPOST"] = N ? [
            {
                type: "path",
                fill: !1,
                d: "M 99.9998,45 l 47.6312,82.5 -95.2623,0 z"
            },
            {
                type: "path",
                stroke: !1,
                d: "m 100,80 c 0,7.5 12.5,20 20,20 -7.5,0 -20,12.5 -20,20 0,-7.5 -12.5,-20 -20,-20 7.5,0 20,-12.5 20,-20 z"
            }
        ] : {
            type: "path",
            fill: !1,
            d: "m 61.1738,112.25 23.6601,0 m 30.3321,0 23.66,0 M 80,105 l 10,15 20,0 10,-15 z m 19.9998,-60 47.6312,82.5 -95.2623,0 z"
        }, G["TP.CBRN OBSERVATION POST"] = [
            {
                type: "path",
                fill: !1,
                d: "m 99.9998,45 47.6312,82.5 -95.2623,0 z M 88,119 c 2.1824,-13.288 7.7157,-24.22 22,-29 m 1.829,29 C 109.664,105.712 104.173,94.78 90,90 M 52.3687,127.5 123.816,86.2499"
            },
            {
                type: "path",
                d: "m 91,92 c 0,2.7614 -2.2386,5 -5,5 -2.7614,0 -5,-2.2386 -5,-5 0,-2.7614 2.2386,-5 5,-5 2.7614,0 5,2.2386 5,5 z m 28.011,0 c 0,2.7678 -2.243,5.0117 -5.011,5.012 -2.768,-3e-4 -5.011,-2.2442 -5.011,-5.012 0,-2.7676 2.243,-5.0112 5.011,-5.0115 2.768,3e-4 5.011,2.2439 5.011,5.0115 z"
            }
        ], G["TP.POINT OF DEPARTURE"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "PD"
            }
        ], G["TP.FIXED AND PREFABRICATED"] = {
            type: "path",
            d: "m 60,100 40,-65 40,65 z"
        }, G["TP.TETRAHEDRONS"] = {
            type: "path",
            fill: !1,
            d: "m 60,100 40,-65 40,65"
        }, G["TP.TETRAHEDRONS MOVABLE"] = {
            type: "path",
            fill: !1,
            d: "m 60,100 40,-65 40,65 z"
        }, G["TP.BOOBY TRAP"] = {
            type: "path",
            fill: !1,
            d: "M 77.2413,87.9311 100,50 122.781,87.9687 M 130,100 c 0,10.24 -13.431,18.541 -30,18.541 -16.5685,0 -30,-8.301 -30,-18.541 0,-10.2399 13.4315,-18.541 30,-18.541 16.569,0 30,8.3011 30,18.541 z"
        }, G["TP.UNSPECIFIED MINE"] = {
            type: "path",
            fill: !1,
            d: "m 129,100 c 0,16.016 -12.984,29 -29,29 -16.0163,0 -29,-12.984 -29,-29 0,-16.0163 12.9837,-29 29,-29 16.016,0 29,12.9837 29,29 z"
        }, G["TP.ANTITANK MINE (AT)"] = {
            type: "path",
            d: "m 129,100 c 0,16.016 -12.984,29 -29,29 -16.0163,0 -29,-12.984 -29,-29 0,-16.0163 12.9837,-29 29,-29 16.016,0 29,12.9837 29,29 z"
        }, G["TP.(AT) ANTIHANDLING DEVICE"] = [
            G["TP.ANTITANK MINE (AT)"],
            {
                type: "path",
                fill: !1,
                d: "m 100,130 0,65 15,-15"
            }
        ], G["TP.(AT) DIRECTIONAL"] = [
            G["TP.ANTITANK MINE (AT)"],
            {
                type: "path",
                fill: !1,
                strokedasharray: "5,5",
                d: "m 100,70 0,-60"
            },
            {
                type: "path",
                fill: !1,
                d: "m 90,20 10,-10 10,10"
            }
        ], G["TP.ANTIPERSONNEL (AP) MINES"] = [
            G["TP.ANTITANK MINE (AT)"],
            {
                type: "path",
                fill: !1,
                d: "m 50,50 29.5,29.5 m 41,0 L 150,50"
            }
        ], G["TP.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS"] = [
            G["TP.ANTITANK MINE (AT)"],
            {
                type: "path",
                fill: !1,
                d: "m 131,100 10,0 M 50,50 79.5,79.5 m 41,0 L 150,50 m -4,50 10,0 m 5,0 10,0 m -10,-10 10,10 -10,10"
            }
        ], G["TP.WIDE AREA MINES"] = [
            G["TP.ANTITANK MINE (AT)"],
            {
                type: "path",
                fill: !1,
                d: "m 50,110 25,40 12,-24 M 113,126 125,150 150,110"
            }
        ], G["TP.PLANNED MINEFIELD"] = [
            {
                type: "path",
                fill: !1,
                strokedasharray: "15,15",
                d: "m 40,65 0,70 120,0 0,-70 z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 75,100 c 0,5.523 -4.4772,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.5228,0 10,4.4772 10,10 z m 70,0 c 0,5.523 -4.477,10 -10,10 -5.523,0 -10,-4.477 -10,-10 0,-5.5228 4.477,-10 10,-10 5.523,0 10,4.4772 10,10 z m -35,0 c 0,5.523 -4.477,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.523,0 10,4.4772 10,10 z"
            }
        ], G["TP.MINEFIELDS STATIC"] = {
            type: "path",
            fill: !1,
            d: "m 40,65 0,70 120,0 0,-70 z m 70,35 c 0,5.523 -4.477,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.523,0 10,4.4772 10,10 z m 35,0 c 0,5.523 -4.477,10 -10,10 -5.523,0 -10,-4.477 -10,-10 0,-5.5228 4.477,-10 10,-10 5.523,0 10,4.4772 10,10 z m -70,0 c 0,5.523 -4.4772,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.5228,0 10,4.4772 10,10 z"
        }, G["TP.MINEFIELD, STATIC"] = {
            type: "path",
            fill: !1,
            d: "m 25,65 0,70 150,0 0,-70 z"
        }, t.notpresent && (G["TP.MINEFIELDS STATIC"] = G["TP.PLANNED MINEFIELD"]), G["TP.ANTITANK (AT) MINEFIELD"] = [
            {
                type: "path",
                fill: !1,
                d: "m 40,65 0,70 120,0 0,-70 z"
            },
            {
                type: "path",
                d: "m 75,100 c 0,5.523 -4.4772,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.5228,0 10,4.4772 10,10 z m 70,0 c 0,5.523 -4.477,10 -10,10 -5.523,0 -10,-4.477 -10,-10 0,-5.5228 4.477,-10 10,-10 5.523,0 10,4.4772 10,10 z m -35,0 c 0,5.523 -4.477,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.523,0 10,4.4772 10,10 z"
            }
        ], G["TP.SCATTERABLE MINES"] = [
            G["TP.MINEFIELDS STATIC"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 60,
                fontsize: 35,
                text: "S"
            }
        ], G["TP.ANTIPERSONNEL (AP) MINEFIELD"] = [
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 60,
                fontsize: 35,
                text: "+S"
            },
            {
                type: "path",
                fill: !1,
                d: "m 40,65 0,70 120,0 0,-70 z"
            },
            {
                type: "path",
                d: "M 72.0703,92.9297 80,82.3622 m -30,0 7.9297,10.5675 m 49.1403,0 7.93,-10.5675 m -30,0 7.9297,10.5675 m 49.1403,0 7.93,-10.5675 m -30,0 7.93,10.5675 M 110,100 c 0,5.523 -4.477,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.523,0 10,4.4772 10,10 z m 35,0 c 0,5.523 -4.477,10 -10,10 -5.523,0 -10,-4.477 -10,-10 0,-5.5228 4.477,-10 10,-10 5.523,0 10,4.4772 10,10 z m -70,0 c 0,5.523 -4.4772,10 -10,10 -5.5228,0 -10,-4.477 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.5228,0 10,4.4772 10,10 z"
            }
        ], G["TP.SCATTERABLE MINEFIELD WITH SELF-DESTRUCT"] = [
            G["TP.ANTITANK (AT) MINEFIELD"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 60,
                fontsize: 35,
                text: "S"
            }
        ], G["TP.VOLCANO MINEFIELD"] = [
            G["TP.ANTITANK (AT) MINEFIELD"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 60,
                fontsize: 35,
                text: "V"
            }
        ], G["TP.TOWER LOW"] = [
            {
                type: "circle",
                stroke: !1,
                cx: 100,
                cy: 100,
                r: 7
            },
            {
                type: "path",
                fill: !1,
                strokewidth: 8,
                d: "m 75,105 25,-65 25,65"
            }
        ], G["TP.TOWER HIGH"] = [
            {
                type: "circle",
                stroke: !1,
                cx: 100,
                cy: 100,
                r: 7
            },
            {
                type: "path",
                fill: !1,
                strokewidth: 8,
                d: "m 100,40 c 2.358,31.6754 7.162,59.2531 25,64.999 M 100,40 c -2.358,31.6754 -7.1624,59.2531 -25,65"
            }
        ], G["TP.ENGINEER REGULATING POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "ERP"
            }
        ], G["TP.EARTHWORK/FORTIFICATION"] = {
            type: "path",
            d: "m 65,65 0,70 70,0 0,-70 -70,0z"
        }, G["TP.FORT"] = {
            type: "path",
            fill: !1,
            d: "m 135,65 15,-15 m -15,85 15,15 M 65,135 50,150 m 15,-85 0,70 70,0 0,-70 -70,0 -15,-15"
        }, G["TP.SURFACE SHELTER"] = {
            type: "path",
            d: "m 135,135 15,0 m -100,0 15,0 m 0,-70 0,70 70,0 0,-70 -70,0"
        }, G["TP.UNDERGROUND SHELTER"] = {
            type: "path",
            d: "m 135,65 15,0 m -100,0 15,0 m 0,70 0,-70 70,0 0,70 -70,0"
        }, G["TP.NUCLEAR DETONATIONS GROUND ZERO"] = [
            {
                type: "path",
                fill: !e && "rgb(255,255,0)",
                d: "m 85,25 0,75 30,0 0,-75 m -50,0 c 0,-50 70,-50 70,0 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 75,
                fontsize: 35,
                text: "N"
            }
        ], G["TP.NUCLEAR DETONATIONS GROUND ZERO PLANNED"] = [
            {
                type: "path",
                strokedasharray: "5,5",
                fill: !e && "rgb(255,255,0)",
                d: "m 85,25 0,75 30,0 0,-75 m -50,0 c 0,-50 70,-50 70,0 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 75,
                fontsize: 35,
                text: "N"
            }
        ], G["TP.NUCLEAR FALLOUT PRODUCING"] = [
            {
                type: "path",
                fill: !1,
                d: "m 120,85 -15,15 m -25,0 40,-35 M 80,80 120,40 M 80,55 115,25 M 80,40 95,25 m -40,0 c 0,-60 90,-60 90,0 z m 25,0 0,75 40,0 0,-75"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 75,
                fontsize: 35,
                text: "N"
            }
        ], G["TP.RELEASE EVENTS BIOLOGICAL"] = [
            {
                type: "path",
                fill: !e && "rgb(255,255,0)",
                d: "m 85,-15 0,60 -25,55 80,0 -25,-55 0,-60 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 85,
                fontsize: 35,
                text: "B"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 50,
                y: 60,
                fontsize: 35,
                text: "BIO"
            }
        ], G["TP.RELEASE EVENTS CHEMICAL"] = [
            {
                type: "path",
                fill: !e && "rgb(255,255,0)",
                d: "m 85,-15 0,59.0625 C 75.7313,49.4137 70.0154,59.2975 70,70 c 0,16.5685 13.4315,30 30,30 16.569,0 30,-13.4315 30,-30 -0.01,-10.7067 -5.728,-20.5959 -15,-25.9492 L 115,-15 Z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 80,
                fontsize: 35,
                text: "C"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "end",
                x: 50,
                y: 60,
                fontsize: 35,
                text: "CML"
            }
        ], G["TP.DECON SITE/POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "DCN"
            }
        ], G["TP.ALTERNATE DECON SITE/POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 0,
                fontsize: 35,
                text: "ALT"
            }
        ], G["TP.DECON SITE/POINT (TROOPS)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 0,
                fontsize: 35,
                text: "T"
            }
        ], G["TP.DECON SITE/POINT (EQUIPMENT)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 0,
                fontsize: 35,
                text: "E"
            }
        ], G["TP.DECON SITE/POINT (EQUIPMENT AND TROOPS)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 0,
                fontsize: 35,
                text: "E/T"
            }
        ], G["TP.DECON SITE/POINT (OPERATIONAL DECONTAMINATION)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 0,
                fontsize: 35,
                text: "O"
            }
        ], G["TP.DECON SITE/POINT (THOROUGH DECONTAMINATION)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 0,
                fontsize: 35,
                text: "TH"
            }
        ], G["TP.MAIN EQUIPMENT DECONTAMINATION POINT/SITE"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 30,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -10,
                fontsize: 25,
                text: "(M)"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 13,
                fontsize: 25,
                text: "E"
            }
        ], G["TP.FORWARD TROOP DECONTAMINATION POINT/SITE"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 30,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -10,
                fontsize: 25,
                text: "(F)"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 13,
                fontsize: 25,
                text: "T"
            }
        ], G["TP.WOUNDED PERSONNEL DECONTAMINATION SITE"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 0,
                fontsize: 35,
                text: "W"
            }
        ], G["TP.AMBULANCE CONTROL POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "ACP"
            }
        ], G["TP.AMBULANCE LOAD POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "ALP"
            }
        ], G["TP.AMBULANCE RELAY POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "ARP"
            }
        ], G["TP.DECON POINT (MAIN) EQUIPMENT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 10,
                fontsize: 35,
                text: "(M)E"
            }
        ], G["TP.DECON POINT (FORWARD) TROOPS"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "DCN"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 10,
                fontsize: 35,
                text: "(F)T"
            }
        ], G["TP.POINT/SINGLE TARGET"] = {
            type: "path",
            fill: !1,
            d: "m 50,100 100,0 m -50,-50 0,100"
        }, G["TP.KNOWN POINT"] = [
            {
                type: "path",
                fill: !1,
                d: "m 50,100 100,0 m -50,-50 0,100"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "start",
                x: 110,
                y: 80,
                fontsize: 30,
                text: "KNP"
            }
        ], G["TP.NUCLEAR TARGET"] = {
            type: "path",
            fill: !1,
            d: "m 90,100 -40,0 m 50,10 0,40 m 10,-50 40,0 m -50,-10 0,-40 m 2.5,50 c 0,1.381 -1.119,2.5 -2.5,2.5 -1.3807,0 -2.5,-1.119 -2.5,-2.5 0,-1.3807 1.1193,-2.5 2.5,-2.5 1.381,0 2.5,1.1193 2.5,2.5 z"
        }, G["TP.TARGETRECORDED (AEGIS ONLY)"] = [
            {
                type: "path",
                fill: !1,
                d: "m 0,50 0,100 200,0 0,-100 z"
            },
            {
                type: "path",
                stroke: !1,
                d: "m 100,90 -10,10 10,10 10,-10 z"
            }
        ], G["TP.FIRE SUPPORT STATION"] = [
            {
                type: "path",
                fill: !1,
                d: "M 50,50 150,150 M 50,150 150,50"
            },
            N ? {
                type: "text",
                stroke: !1,
                textanchor: "left",
                x: 120,
                y: 110,
                fontsize: 35,
                text: "FSS"
            } : []
        ], G["TP.SURVEY CONTROL POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "SCP"
            }
        ], G["TP.FIRING POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "FP"
            }
        ], G["TP.RELOAD POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "RLP"
            }
        ], G["TP.HIDE POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "HP"
            }
        ], G["TP.LAUNCH POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "LP"
            }
        ], G["TP.AMBULANCE EXCHANGE POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "AXP"
            }
        ], G["TP.CANNIBALIZATION POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "CAN"
            }
        ], G["TP.CASUALTY COLLECTION POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "CCP"
            }
        ], G["TP.CIVILIAN COLLECTION POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "CIV"
            }
        ], G["TP.DETAINEE COLLECTION POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "DET"
            }
        ], G["TP.EPW COLLECTION POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "EPW"
            }
        ], G["TP.LOGISTICS RELEASE POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "LRP"
            }
        ], G["TP.MAINTENANCE COLLECTION POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "MCP"
            }
        ], G["TP.MEDICAL EVACUATION (MEDEVAC) PICKUP POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -30,
                fontsize: 30,
                text: "MEP"
            },
            {
                type: "path",
                stroke: !1,
                d: "m 95,-25 0,10 -10,0 0,10 10,0 0,10 10,0 0,-10 10,0 0,-10 -10,0 0,-10 z"
            }
        ], G["TP.REARM, REFUEL AND RESUPPLY POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "R3P"
            }
        ], G["TP.REFUEL ON THE MOVE POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "ROM"
            }
        ], G["TP.TRAFFIC CONTROL POST"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "TCP"
            }
        ], G["TP.TRAILER TRANSFER POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "TTP"
            }
        ], G["TP.UNIT MAINTENANCE COLLECTION POINT"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 25,
                text: "UMCP"
            }
        ], G["TP.SUPPLY POINT"] = {
            type: "path",
            fill: !1,
            d: "m 60,30 80,0 m -80,15 80,0 m -40,55 -40,-55 0,-105 80,0 0,105 z"
        }, G["TP.NATO CLASS I"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 45,
                text: "I"
            }
        ], G["TP.NATO CLASS II"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 45,
                text: "II"
            }
        ], G["TP.NATO CLASS III"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 45,
                text: "III"
            }
        ], G["TP.NATO CLASS IV"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 45,
                text: "IV"
            }
        ], G["TP.NATO CLASS V"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 80,-10 40,0 m -32,0 0,-26.7 c 0,-17.8 24,-17.8 24,0 L 112,-10"
            }
        ], G["TP.SP CLASS I"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 115,-50 c -45,5 -45,65 0,70 -20,-25 -20,-50 0,-70 z"
            }
        ], G["TP.SP CLASS II"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                stroke: !1,
                d: "m 101.143,3.91602 q 3.662,-0.26368 4.746,-1.08399 1.084,-0.84961 1.084,-4.33594 l 0,-26.68949 q 0,-3.3105 -1.084,-4.248 -1.084,-0.9668 -4.746,-1.1426 l 0,-1.1133 17.753,0 0,1.1133 q -3.662,0.1758 -4.746,1.1426 -1.084,0.9375 -1.084,4.248 l 0,26.68949 q 0,3.48633 1.084,4.33594 1.084,0.82031 4.746,1.08399 l 0,1.08398 -17.753,0 0,-1.08398 z m 8.877,-38.61332 0,0 z M 81.1035,3.91602 q 3.6621,-0.26368 4.7461,-1.08399 1.084,-0.84961 1.084,-4.33594 l 0,-26.68949 q 0,-3.3105 -1.084,-4.248 -1.084,-0.9668 -4.7461,-1.1426 l 0,-1.1133 17.7539,0 0,1.1133 q -3.6621,0.1758 -4.7461,1.1426 -1.084,0.9375 -1.084,4.248 l 0,26.68949 q 0,3.48633 1.084,4.33594 1.084,0.82031 4.7461,1.08399 l 0,1.08398 -17.7539,0 0,-1.08398 z m 8.877,-38.61332 0,0 z"
            }
        ], G["TP.SP CLASS III"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 100,20 0,-30 -20,-40 40,0 -20,40"
            }
        ], G["TP.SP CLASS IV"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 100,-40 0,20 m -25,10 0,-30 50,0 0,30"
            }
        ], G["TP.SP CLASS V"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 80,15 0,-50 c 0,-20 40,-20 40,0 l 0,50 m -50,0 60,0"
            }
        ], G["TP.SP CLASS VI"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 75,-20 50,0 m -25,15 15,25 m -15,-50 0,25 -20,25 m 30,-60 c 0,5.5228 -4.477,10 -10,10 -5.5228,0 -10,-4.4772 -10,-10 0,-5.5228 4.4772,-10 10,-10 5.523,0 10,4.4772 10,10 z"
            }
        ], G["TP.SP CLASS VII"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 85,-25 c 10,-10 20,-10 30,0"
            },
            {
                type: "path",
                d: "m 129.6,-20 c 0,5.3019 -4.298,9.5999 -9.6,9.5998 -5.302,10e-5 -9.6,-4.2979 -9.6,-9.5998 0,-5.3019 4.298,-9.5999 9.6,-9.5998 5.302,-1e-4 9.6,4.2979 9.6,9.5998 z m -40.4886,0 c 0,5.0321 -4.0793,9.1114 -9.1114,9.1114 -5.0321,0 -9.1114,-4.0793 -9.1114,-9.1114 0,-5.0321 4.0793,-9.1114 9.1114,-9.1114 5.0321,0 9.1114,4.0793 9.1114,9.1114 z"
            }
        ], G["TP.SP CLASS VIII"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 60,-15 80,0 m -40,-45 0,90"
            }
        ], G["TP.SP CLASS IX"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 121.213,-36.2132 -7.08,7.0802 M 85.8669,-0.866982 78.7868,6.2132 m 0,-42.4264 7.0801,7.0802 m 28.2661,28.266018 7.08,7.080182 M 100,-45 l 0,10 m 0,40 0,10 m -30,-30 10,0 m 40,0 10,0 m -10,0 c 0,11.04569 -8.954,20 -20,20 -11.0457,0 -20,-8.95431 -20,-20 0,-11.0457 8.9543,-20 20,-20 11.046,0 20,8.9543 20,20 z"
            }
        ], G["TP.SP CLASS X"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -10,
                fontsize: 40,
                text: "CA"
            }
        ], G["TP.MEDICAL SUPPLY POINT"] = [
            G["TP.SUPPLY POINT"],
            {
                type: "path",
                fill: !1,
                d: "m 100,-20 0,-40 m -40,25 80,0"
            }
        ], G["TP.AMMUNITION SUPPLY POINT (ASP)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "ASP"
            }
        ], G["TP.AMMUNITION TRANSFER POINT (ATP)"] = [
            G["TP.ACTION POINT"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: -20,
                fontsize: 35,
                text: "ATP"
            }
        ], G["TP.TARGET HANDOVER"] = [
            {
                type: "path",
                strokedasharray: "10,5",
                fill: !1,
                d: "m 100,45 -15,40 -40,15 40,15 15,40 15,-40 40,-15 -40,-15 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 110,
                fontsize: 30,
                text: "TH"
            }
        ], G["TP.KEY TERRAIN"] = [
            {
                type: "path",
                d: "m 145,100 a 45,45 0 0 1 -45,45 45,45 0 0 1 -45,-45 45,45 0 0 1 45,-45 45,45 0 0 1 45,45 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 80,
                y: 110,
                fontsize: 35,
                text: "K",
                fill: O
            }
        ], G["TP.BT BOUY DROP"] = [
            {
                type: "path",
                fill: !1,
                d: "m 65,45 0,110 70,0 0,-110 m -35,95 0,-95 m -35,0 70,0"
            },
            {
                type: "path",
                d: "m 104,100 c 0,2 -3,2 -4.8,2 -1.4,0 -4.1,-1 -2.7,-2.9 1.9,-1.4 4.5,-1.4 6.5,-0.4 1,0.3 1,0.7 1,1.3 z m 0,40 c 0,2 -3,2 -4.8,2 -1.4,0 -4.1,-1 -2.7,-3 1.9,-1 4.5,-1 6.5,0 1,0 1,0 1,1 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 80,
                y: 110,
                fontsize: 35,
                text: "B"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 120,
                y: 110,
                fontsize: 35,
                text: "T"
            }
        ], G["TP.REPORTED BOTTOMED SUB"] = {
            type: "path",
            fill: !1,
            d: "M 129,122.4 70.9,78.8 m 0,43.6 58.1,-43.6 m -80,-14.5 0,43.6 29,0 0,29 43.6,0 0,-29 29,0 0,-43.6"
        }, G["TP.MOVING HAVEN"] = {
            type: "path",
            d: "M 108.142,100 A 8.14167,8.14167 0 0 1 100,108.142 8.14167,8.14167 0 0 1 91.8583,100 8.14167,8.14167 0 0 1 100,91.8583 8.14167,8.14167 0 0 1 108.142,100 Z M 45,55 l 0,90 m 110,-90 0,90 m -110,-45 110,0"
        }, G["TP.SCREEN CENTRE"] = {
            type: "path",
            d: "m 100,55 0,90 m 8.142,-45 A 8.14167,8.14167 0 0 1 100,108.142 8.14167,8.14167 0 0 1 91.8583,100 8.14167,8.14167 0 0 1 100,91.8583 8.14167,8.14167 0 0 1 108.142,100 Z"
        }, G["TP.SHORE CONTROL STATION"] = {
            type: "path",
            fill: !1,
            d: "m 30,155 140,0 m -27,-20 2,-10 -10,5 m -78,5 -2,-10 10,5 m 35,-55 0,68 m 7.5,-76 A 7.5,7.5 0 0 1 100,74.5 7.5,7.5 0 0 1 92.5,67 7.5,7.5 0 0 1 100,59.5 7.5,7.5 0 0 1 107.5,67 Z m -52.5,8 90,0 m -90,50 c 15,25 75,25 90,0 M 40,45 50,55 60,45 70,55 80,45 l 10,10 10,-10 10,10 10,-10 10,10 10,-10 10,10 10,-10"
        }, G["TP.DITCHED AIRCRAFT"] = {
            type: "path",
            d: "m 145,120 -15,-15 m -15,15 15,-15 m -75,15 15,-15 m 15,15 -15,-15 m 10,10 25,-30 -10,-10 10,-10 20,20 -10,35 -15,-15 -15,15 z"
        }, G["TP.PERSON IN WATER"] = {
            type: "path",
            d: "m 105,110 10,-10 0,-15 5,0 0,20 -10,10 z m -10,0 -10,-10 0,-15 -5,0 0,20 10,10 z m 5,-5 0,-10 -5,0 -5,-5 0,-10 5,-5 10,0 5,5 0,10 -5,5 -5,0 m -15,25 15,-15 m 45,15 -15,-15 m -15,15 15,-15 m -75,15 15,-15 m 15,15 -15,-15 m 45,15 -15,-15"
        }, G["TP.CLUTTER, STATIONARY OR CEASE REPORTING"] = {
            type: "path",
            fill: !1,
            d: "m 65,135 c 23.3,-23 47,-46.7 70,-70 m -70,0 c 23.3,23.3 47,47 70,70 m -35,-4 c -19.7,0 -47.8,-8 -50,-31 3,-24.9 33.9,-32 55,-30.7 19,0.8 46,10.9 45,33.7 -5,21 -31,28 -50,28 z m 31,-31 c 0,20 -8,48 -31,50 C 75.1,147 68,116 69.3,95 70.1,76.2 80.2,48.6 103,50.2 c 21,4.9 28,31.1 28,49.8 z"
        }, G["TP.TENTATIVE OR PROVISIONAL TRACK"] = {
            type: "path",
            fill: !1,
            d: "M 130.902,100 A 30.9017,50 0 0 1 100,150 30.9017,50 0 0 1 69.0983,100 30.9017,50 0 0 1 100,50 30.9017,50 0 0 1 130.902,100 Z M 100,130.902 A 50,30.9017 0 0 1 50,100 50,30.9017 0 0 1 100,69.0983 50,30.9017 0 0 1 150,100 50,30.9017 0 0 1 100,130.902 Z"
        }, G["TP.DISTRESSED VESSEL"] = {
            type: "path",
            d: "m 120,65 -20,20 20,-20 m -5,55 -35,-35 0,-20 45,45 z m -30,0 -15,-15 m -15,15 15,-15 m 45,15 15,-15 m 15,15 -15,-15 m -45,15 15,-15"
        }, G["TP.SEA MINELIKE"] = {
            type: "path",
            d: "M 75,75 55,55 m 45,-15 0,25 m 25,10 20,-20 m -80,60 0,-30 20,-20 30,0 20,20 0,30 -20,20 -30,0 z"
        }, G["TP.ICEBERG"] = {
            type: "path",
            d: "m 75,100 25,-30 25,30 -5,15 -5,-5 -15,20 -15,-20 -5,5 z m -15,0 80,0"
        }, G["TP.OIL RIG/PLATFORM"] = [
            {
                type: "path",
                d: "m 55,100 0,-50 m 75,50 0,40 m 20,-40 0,40 m -115,0 0,-40 130,0",
                fill: !1
            },
            {
                type: "path",
                d: "m 55,100 0,-15 25,0 0,15 z"
            }
        ], G["TP.BOTTOM RETURN"] = {
            type: "path",
            d: "m 50,100 15,-35 15,30 20,-55 20,55 15,-35 15,40 z"
        }, G["TP.INSTALLATION/MANMADE"] = {
            type: "path",
            fill: !1,
            d: "m 50,100 15,-35 15,30 20,-55 20,55 15,-35 15,40 z"
        }, G["TP.WRECK, NON DANGEROUS"] = {
            type: "path",
            fill: !1,
            d: "m 135,85 0,30 m -85,-15 100,0 m -85,-15 0,30 m 35,-40 0,50"
        }, G["TP.WRECK, DANGEROUS"] = [
            G["TP.WRECK, NON DANGEROUS"],
            {
                type: "path",
                strokedasharray: "5,5",
                fill: !1,
                d: "m 156.547,100 c 0,16.382 -25.162,29.662 -56.202,29.662 -31.0395,0 -56.2019,-13.28 -56.2017,-29.662 0,-16.3818 25.1624,-29.6618 56.2017,-29.6618 31.039,-1e-4 56.202,13.28 56.202,29.6618 z"
            }
        ], G["TP.MARINE LIFE"] = {
            type: "path",
            stroke: !1,
            d: "m 132,75 0,50 83,-37.5 0,25 L 132,75 m -32,25 25.5,-25 0,50 z"
        }, G["TP.SEA ANOMALY"] = {
            type: "path",
            fill: !1,
            d: "M 150,80 130,35 100,100 70,35 50,80 m 0,20 20,-45 30,65 30,-65 20,45"
        }, G["TP.FIX ACOUSTIC"] = {
            type: "path",
            fill: !1,
            d: "M 50,150 150,50 M 50,50 150,150 m -50,-100 0,100"
        }, G["TP.FIX ELECTRO-MAGNETIC"] = {
            type: "path",
            fill: !1,
            d: "m 50,90 15,20 5,-20 15,20 5,-20 20,20 5,-20 15,20 5,-20 15,20 M 50,150 150,50 M 50,50 150,150 m -50,-100 0,100"
        }, G["TP.ELECTRO MAGNETIC - MAGNETIC ANOMALY DETECTION (MAD)"] = [
            G["TP.FIX ELECTRO-MAGNETIC"],
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 180,
                fontsize: 35,
                text: "MAD"
            }
        ], G["TP.FIX ELECTRO-OPTICAL"] = {
            type: "path",
            fill: !1,
            d: "m 150,100 c 0,6.904 -22.386,12.5 -50,12.5 -27.6142,0 -50,-5.596 -50,-12.5 0,-6.9036 22.3858,-12.5 50,-12.5 27.614,0 50,5.5964 50,12.5 z M 50,150 150,50 M 50,50 150,150 m -50,-100 0,100"
        }, G["TP.FIRE"] = {
            type: "text",
            stroke: !1,
            fill: E.iconColor[C],
            textanchor: "middle",
            x: 100,
            y: 115,
            fontsize: 35,
            text: "FIRE"
        }, G["TP.INDIRECT FIRE"] = {
            type: "path",
            stroke: E.iconColor[C],
            fill: !1,
            d: "m 100,60 0,80 m -40,-40 80,0"
        }, G["TP.AMBUSH"] = {
            type: "path",
            stroke: E.iconColor[C],
            fill: !1,
            d: "m 77.5,106 20,0 m -20,-12 20,0 M 75,82 95,82 m -20,36 20,0 m -25,12 20,0 M 70,70 90,70 M 80,60 c 25,15 25,65 0,80 m 45,-50 10,10 -10,10 m -25,-10 35,0"
        }, G["TP.ROAD BLOCK"] = {
            type: "path",
            stroke: E.iconColor[C],
            fill: !1,
            d: "m 73,133 60,-60 m -66,54 60,-60 m -54,0 60,60 m -66,-54 60,60"
        }, G["TP.ROAD BLOCK (UNDER CONSTRUCTION)"] = [
            {
                type: "path",
                stroke: E.iconColor[C],
                fill: !1,
                strokedasharray: "5,5",
                d: "m 73,67 60,60 m -66,-54 60,60"
            },
            {
                type: "path",
                stroke: E.iconColor[C],
                fill: !1,
                d: "M 73,133 133,73 M 67,127 127,67"
            }
        ], G["TP.VITAL AREA CENTRE"] = [
            {
                type: "path",
                fill: !1,
                d: "m 45,100 110,0 m 0,-40 0,85 M 45,60 l 0,80 m 55,-80 0,80"
            }
        ], G["TP.ESTIMATED POSITION (EP)"] = [
            {
                type: "path",
                fill: !1,
                strokedasharray: "12,5",
                d: "M 160,160 40,160 40,40 160,40 Z"
            },
            {
                type: "path",
                fill: !1,
                d: "m 140,100 c 1,26 -27,47 -51.8,38 C 63.1,131 51.5,98.3 67,77.4 c 13.8,-21.9 49,-23.2 64,-2.3 6,7 9,15.9 9,24.9 z"
            },
            {
                type: "text",
                stroke: !1,
                textanchor: "middle",
                x: 100,
                y: 115,
                fontsize: 35,
                text: "EP"
            }
        ], G["FORWARD OBSERVER / SPOTTER POSITION"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 3
            },
            {
                type: "path",
                fill: !1,
                d: "m 40,135 60,-75 60,75 z"
            }
        ], G["MAN MADE SPACE DEBRIS SMALL"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 17
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            },
            {
                type: "path",
                fill: !1,
                d: "M 60,110 75,100 60,90 m 50,50 -10,-15 -10,15 m 50,-50 -15,10 15,10 M 90,60 100,75 110,60"
            }
        ], G["MAN MADE SPACE DEBRIS MEDIUM"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 17
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            }
        ], G["MAN MADE SPACE DEBRIS BIG"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 17
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            },
            {
                type: "path",
                fill: !1,
                d: "m 90,75 10,-15 10,15 M 75,110 60,100 75,90 m 35,35 -10,15 -10,-15 m 35,-35 15,10 -15,10"
            }
        ], G["NATURAL SPACE DEBRIS SMALL"] = [
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 17
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            },
            {
                type: "path",
                fill: !1,
                d: "M 60,110 75,100 60,90 m 50,50 -10,-15 -10,15 m 50,-50 -15,10 15,10 M 90,60 100,75 110,60"
            }
        ], G["NATURAL SPACE DEBRIS MEDIUM"] = [
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 17
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            }
        ], G["NATURAL SPACE DEBRIS BIG"] = [
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 17
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 50
            },
            {
                type: "path",
                fill: !1,
                d: "m 90,75 10,-15 10,15 M 75,110 60,100 75,90 m 35,35 -10,15 -10,-15 m 35,-35 15,10 -15,10"
            }
        ], G["TP.M1.UNSPECIFIED"] = [
            {
                type: "circle",
                fill: !1,
                cx: 55,
                cy: 100,
                r: 15
            },
            {
                type: "circle",
                fill: !1,
                cx: 100,
                cy: 100,
                r: 15
            },
            {
                type: "circle",
                fill: !1,
                cx: 145,
                cy: 100,
                r: 15
            }
        ], G["TP.M1.ANTIPERSONNEL MINE 1"] = [
            {
                type: "circle",
                cx: 55,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 35,75 10.6,13.3 m 18.8,0 10.6,-13.3"
            }
        ], G["TP.M1.ANTIPERSONNEL MINE 2"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 80,75 10.6,13.3 m 18.8,0 10.6,-13.3"
            }
        ], G["TP.M1.ANTIPERSONNEL MINE 3"] = [
            {
                type: "circle",
                cx: 145,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 125,75 10.6,13.3 m 18.8,0 10.6,-13.3"
            }
        ], G["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"] = [
            {
                type: "circle",
                cx: 55,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "M 64.4,88.3 75,75 m -40,0 10.6,13.3 m 32.4,10 2,1.7 -2,2 z m -8,1.7 3.3,0"
            }
        ], G["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 2"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "M 109,88.3 120,75 m -40,0 10.6,13.3 m 32.4,10 2,1.7 -2,2 z m -8,1.7 3,0"
            }
        ], G["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 3"] = [
            {
                type: "circle",
                cx: 145,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "M 154,88.3 165,75 m -40,0 11,13.3 m 32,10 2,1.7 -2,2 z m -8,1.7 3,0"
            }
        ], G["TP.M1.ANTITANK MINE 1"] = [
            {
                type: "circle",
                cx: 55,
                cy: 100,
                r: 15
            }
        ], G["TP.M1.ANTITANK MINE 2"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            }
        ], G["TP.M1.ANTITANK MINE 3"] = [
            {
                type: "circle",
                cx: 145,
                cy: 100,
                r: 15
            }
        ], G["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 1"] = [
            {
                type: "circle",
                cx: 55,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 55,115 0,13 6,-6"
            }
        ], G["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 100,115 0,13 6,-6"
            }
        ], G["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 3"] = [
            {
                type: "circle",
                cx: 145,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 145,115 0,13 6,-6"
            }
        ], G["TP.M1.WIDE AREA ANTITANK MINE 1"] = [
            {
                type: "circle",
                cx: 55,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 35,115 8,10 5.5,-11 m 13,0 5.5,11 8,-10"
            }
        ], G["TP.M1.WIDE AREA ANTITANK MINE 2"] = [
            {
                type: "circle",
                cx: 100,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 80,115 8,10 5.5,-11 m 13,0 5.5,11 8,-10"
            }
        ], G["TP.M1.WIDE AREA ANTITANK MINE 3"] = [
            {
                type: "circle",
                cx: 145,
                cy: 100,
                r: 15
            },
            {
                type: "path",
                fill: !1,
                d: "m 125,115 8,10 5.5,-11 m 13,0 5.5,11 8,-10"
            }
        ], G["TP.M1.MINE CLUSTER 1"] = [
            {
                type: "path",
                fill: !1,
                strokedasharray: "7.5,5",
                d: "m 73,110 -36,0 c 0,-10 3,-20 18,-20 15,0 18,10 18,20 z"
            }
        ], G["TP.M1.MINE CLUSTER 2"] = [
            {
                type: "path",
                fill: !1,
                strokedasharray: "7.5,5",
                d: "m 118,110 -36,0 c 0,-10 3,-20 18,-20 15,0 18,10 18,20 z"
            }
        ], G["TP.M1.MINE CLUSTER 3"] = [
            {
                type: "path",
                fill: !1,
                strokedasharray: "7.5,5",
                d: "m 163,110 -36,0 c 0,-10 3,-20 18,-20 15,0 18,10 18,20 z"
            }
        ], G)G.hasOwnProperty(o) && (I.hasOwnProperty(o) && console.warn("Override of: " + o), n.call(this, G[o], T), I[o] = G[o]);
    }
    var k = {
        type: "letter",
        getMetadata: o,
        getIcons: M,
        iconParts: [
            V
        ],
        labels: function(I) {
            I["G-T-D-----"] = {}, I["G-T-I-----"] = {}, I["G-T-N-----"] = {}, I["G-G-GPUUD-"] = {}, I["G-G-GPUUB-"] = {}, I["G-G-GPUUL-"] = {}, I["G-G-GPUUS-"] = {}, I["G-G-GPUY--"] = {}, I["G-G-GPUYP-"] = {}, I["G-G-GPUYD-"] = {}, I["G-G-GPUYL-"] = {}, I["G-G-GPUYC-"] = {}, I["G-G-GPUYS-"] = {}, I["G-G-GPUYB-"] = {}, I["G-G-GPUYA-"] = {}, I["G-G-GPUYV-"] = {}, I["G-G-GPUYT-"] = {}, I["G-G-GPUYR-"] = {}, I["G-G-GPUYK-"] = {}, I["G-G-GPUYX-"] = {}, I["G-G-GPUS--"] = {}, I["G-G-GPUSA-"] = {}, I["G-G-GPUSD-"] = {}, I["G-G-GPUSC-"] = {}, I["G-G-GPR---"] = {}, I["G-G-GPRN--"] = {}, I["G-G-GPRS--"] = {}, I["G-G-GPRD--"] = {}, I["G-G-GPRP--"] = {}, I["G-G-GPRM--"] = {}, I["G-G-GPRW--"] = {}, I["G-G-GPRC--"] = {}, I["G-G-GPRI--"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 30,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I["G-G-GPWA--"] = {}, I["G-G-GPWD--"] = {}, I["G-G-GPWE--"] = {}, I["G-G-GPWG--"] = {}, I["G-G-GPWM--"] = {}, I["G-G-GPWI--"] = {}, I["G-G-GPWP--"] = {}, I["G-G-GPF---"] = {}, I["G-G-GPH---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 115,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I["G-G-GPHQ--"] = {}, I["G-G-GPHA--"] = {}, I["G-G-GPHY--"] = {}, I["G-G-GPHX--"] = {}, I["G-G-GPO---"] = {}, I["G-G-GPOZ--"] = {}, I["G-G-GPOD--"] = {}, I["G-G-GPOW--"] = {}, I["G-G-GPOP--"] = {}, I["G-G-GPOR--"] = {}, I["G-G-GPA---"] = {}, I["G-G-GPAP--"] = {}, I["G-G-GPAW--"] = {}, I["G-G-GPAK--"] = {}, I["G-G-GPAA--"] = {}, I["G-G-GPAH--"] = {}, I["G-G-GPAB--"] = {}, I["G-G-GPAC--"] = {}, I["G-G-GPAD--"] = {}, I["G-G-GPAE--"] = {}, I["G-G-GPAS--"] = {}, I["G-G-GPAT--"] = {}, I["G-G-GPAO--"] = {}, I["G-G-GPAR--"] = {}, I["G-G-GPAL--"] = {}, I["G-G-GPAF--"] = {}, I["G-G-GPAG--"] = {}, I["G-G-GPAI--"] = {}, I["G-G-GPAJ--"] = {}, I["G-G-GPAM--"] = {}, I["G-G-GPAN--"] = {}, I["G-G-GPP---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                additionalInformation1: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -20,
                    fontsize: 35,
                    fontweight: "bold"
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPK--"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPC--"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 40,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I["G-G-GPPO--"] = {}, I["G-G-GPPD--"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 115,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I["G-G-GPPL--"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPP--"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPR--"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPE--"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPS--"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPA--"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-G-GPPW--"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 125,
                    fontsize: 70
                }
            }, I["G-G-GPC---"] = {}, I["G-G-GPCU--"] = {}, I["G-G-GPCUR-"] = {}, I["G-G-GPCUA-"] = {}, I["G-G-GPCUS-"] = {}, I["G-G-GPCUM-"] = {}, I["G-G-GPCA--"] = {}, I["G-G-GPCS--"] = {}, I["G-G-GPCM--"] = {}, I["G-G-GPCP--"] = {}, I["G-G-GPCR--"] = {}, I["G-G-GPCC--"] = {}, I["G-G-GPCE--"] = {}, I["G-G-GPCN--"] = {}, I["G-G-GPB---"] = {}, I["G-G-GPBU--"] = {}, I["G-G-GPBUA-"] = {}, I["G-G-GPBUS-"] = {}, I["G-G-GPBUM-"] = {}, I["G-G-GPBS--"] = {}, I["G-G-GPBSA-"] = {}, I["G-G-APP---"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I["G-G-APC---"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I["G-G-APU---"] = {}, I["G-G-APD---"] = {}, I["G-G-PN----"] = {}, I["G-G-DPT---"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 115,
                    y: 85,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I["G-G-DPO---"] = {}, I["G-G-DPOC--"] = {}, I["G-G-DPOR--"] = {}, I["G-G-DPOF--"] = {}, I["G-G-DPOS--"] = {}, I["G-G-DPON--"] = {}, I["G-G-OPP---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-OAOF--"] = {}, I["G-M-OAOM--"] = {}, I["G-M-OAOP--"] = {}, I["G-M-OB----"] = {}, I["G-M-OMU---"] = {}, I["G-M-OMT---"] = {}, I["G-M-OMD---"] = {}, I["G-M-OME---"] = {}, I["G-M-OMP---"] = {}, I["G-M-OMW---"] = {}, I["G-M-OFS---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 55,
                    fontsize: 40
                },
                hostile: [
                    {
                        stroke: !1,
                        textanchor: "end",
                        x: 35,
                        y: 110,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    {
                        stroke: !1,
                        textanchor: "start",
                        x: 165,
                        y: 110,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                ],
                dtg: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 175,
                    fontsize: 40
                }
            }, I["G-M-OHTL--"] = {
                altitudeDepth: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 60,
                    fontsize: 40,
                    fontweight: "bold"
                }
            }, I["G-M-OHTH--"] = {
                altitudeDepth: {
                    stroke: !1,
                    textanchor: "start",
                    x: 115,
                    y: 60,
                    fontsize: 40,
                    fontweight: "bold"
                }
            }, I["G-M-BCP---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-SE----"] = {}, I["G-M-SF----"] = {}, I["G-M-SS----"] = {}, I["G-M-SU----"] = {}, I["G-M-NZ----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 20,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 20,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 100,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 140,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -25,
                    fontsize: 35
                },
                type: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 60,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 100,
                    fontsize: 35
                }
            }, I["G-M-NF----"] = {}, I["G-M-NEB---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 20,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 20,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 100,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 140,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -25,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 100,
                    fontsize: 35
                }
            }, I["G-M-NEC---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 20,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 20,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 100,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 140,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -25,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 100,
                    fontsize: 35
                }
            }, I["G-M-NDP---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-NDA---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-NDT---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-NDE---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-NDB---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-NDO---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-M-NDD---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-F-PTS---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 145,
                    fontsize: 40
                },
                altitudeDepth: {
                    stroke: !1,
                    textanchor: "end",
                    x: 80,
                    y: 145,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 80,
                    fontsize: 40
                }
            }, I["G-F-PTN---"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 80,
                    fontsize: 40,
                    fontweight: "bold"
                }
            }, I["G-F-PCF---"] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 125,
                    y: 115,
                    fontsize: 40,
                    fontweight: "bold"
                }
            }, I["G-F-PCS---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-F-PCB---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-F-PCR---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-F-PCH---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-F-PCL---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PX----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                uniqueDesignation1: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 10,
                    fontsize: 35,
                    fontweight: "bold"
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PC----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PY----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PT----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PD----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PE----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PL----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PM----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PR----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PU----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PO----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PI----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PN----"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PS----"] = {}, I["G-S-PSZ---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSA---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSB---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSC---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSD---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSE---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSF---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSG---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSH---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSI---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PSJ---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: -30,
                    fontsize: 40
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PA----"] = {}, I["G-S-PAS---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-S-PAT---"] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I["G-O-ED----"] = {}, I["G-O-EP----"] = {}, I["G-O-EV----"] = {}, I["G-O-HM----"] = {}, I["G-O-HI----"] = {}, I["G-O-HO----"] = {}, I["G-O-SB----"] = {}, I["G-O-SBM---"] = {}, I["G-O-SBN---"] = {}, I["G-O-SBW---"] = {}, I["G-O-SBX---"] = {}, I["G-O-SM----"] = {}, I["G-O-SS----"] = {}, I["G-O-FA----"] = {}, I["G-O-FE----"] = {}, I["G-O-FO----"] = {};
        },
        icons: function(I, t, E, R) {
            I["G-T-D-----"] = E["TP.DESTROY"], t["G-T-D-----"] = {
                x1: 0,
                x2: 200,
                y1: 40,
                y2: 160
            }, I["G-T-I-----"] = E["TP.INTERDICT"], t["G-T-I-----"] = {
                x1: 0,
                x2: 200,
                y1: 40,
                y2: 160
            }, I["G-T-N-----"] = E["TP.NEUTRALIZE"], t["G-T-N-----"] = {
                x1: 0,
                x2: 200,
                y1: 40,
                y2: 160
            }, I["G-G-GPUUD-"] = E["TP.DATUM"], t["G-G-GPUUD-"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPUUB-"] = E["TP.BRIEF CONTACT"], t["G-G-GPUUB-"] = {
                x1: 50,
                x2: 150,
                y1: 0,
                y2: 100
            }, I["G-G-GPUUL-"] = E["TP.LOST CONTACT"], t["G-G-GPUUL-"] = {
                x1: 50,
                x2: 150,
                y1: 0,
                y2: 100
            }, I["G-G-GPUUS-"] = E["TP.SINKER"], t["G-G-GPUUS-"] = {
                x1: 50,
                x2: 150,
                y1: 0,
                y2: 100
            }, I["G-G-GPUY--"] = E["TP.SONOBUOY"], t["G-G-GPUY--"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYP-"] = E["TP.SONOBUOY PATTERN CENTER"], t["G-G-GPUYP-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYD-"] = E["TP.SONOBUOY DIFAR"], t["G-G-GPUYD-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYL-"] = E["TP.SONOBUOY LOFAR"], t["G-G-GPUYL-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYC-"] = E["TP.SONOBUOY CASS"], t["G-G-GPUYC-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYS-"] = E["TP.SONOBUOY DICASS"], t["G-G-GPUYS-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYB-"] = E["TP.SONOBUOY BT"], t["G-G-GPUYB-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYA-"] = E["TP.SONOBUOY ANM"], t["G-G-GPUYA-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYV-"] = E["TP.SONOBUOY VLAD"], t["G-G-GPUYV-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYT-"] = E["TP.SONOBUOY ATAC"], t["G-G-GPUYT-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYR-"] = E["TP.SONOBUOY RO"], t["G-G-GPUYR-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYK-"] = E["TP.SONOBUOY KINGPIN"], t["G-G-GPUYK-"] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I["G-G-GPUYX-"] = E["TP.SONOBUOY EXPIRED"], t["G-G-GPUYX-"] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 160
            }, I["G-G-GPUS--"] = E["TP.SEARCH"], t["G-G-GPUS--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPUSA-"] = E["TP.SEARCH AREA"], t["G-G-GPUSA-"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPUSD-"] = E["TP.DIP POSITION"], t["G-G-GPUSD-"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPUSC-"] = E["TP.SEARCH CENTER"], t["G-G-GPUSC-"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPR---"] = E["TP.REFERENCE POINT"], t["G-G-GPR---"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRN--"] = E["TP.NAVIGATIONAL REFERENCE"], t["G-G-GPRN--"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRS--"] = E["TP.SPECIAL POINT"], t["G-G-GPRS--"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRD--"] = E["TP.DLRP"], t["G-G-GPRD--"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRP--"] = E["TP.POINT OF INTENDED MOVEMENT"], t["G-G-GPRP--"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRM--"] = E["TP.MARSHALL POINT"], t["G-G-GPRM--"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRW--"] = E["TP.REFERENCE POINT WAYPOINT"], t["G-G-GPRW--"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRC--"] = E["TP.CORRIDOR TAB"], t["G-G-GPRC--"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I["G-G-GPRI--"] = E["TP.POINT OF INTEREST"], t["G-G-GPRI--"] = {
                x1: 50,
                x2: 150,
                y1: -25
            }, I["G-G-GPWA--"] = E["TP.AIM POINT"], t["G-G-GPWA--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPWD--"] = E["TP.DROP POINT"], t["G-G-GPWD--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 120
            }, I["G-G-GPWE--"] = E["TP.ENTRY POINT"], t["G-G-GPWE--"] = {
                x1: 50,
                x2: 150,
                y1: 50
            }, I["G-G-GPWG--"] = E["TP.GROUND ZERO"], t["G-G-GPWG--"] = {
                x1: 50,
                x2: 150,
                y1: 30
            }, I["G-G-GPWM--"] = E["TP.MSL DETECT POINT"], t["G-G-GPWM--"] = {
                x1: 50,
                x2: 150,
                y1: 30
            }, I["G-G-GPWI--"] = E["TP.IMPACT POINT"], t["G-G-GPWI--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPWP--"] = E["TP.PREDICTED IMPACT POINT"], t["G-G-GPWP--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPF---"] = E["TP.FORMATION"], t["G-G-GPF---"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPH---"] = E["TP.HARBOR"], t["G-G-GPH---"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPHQ--"] = E["TP.HARBOR POINT Q"], t["G-G-GPHQ--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPHA--"] = E["TP.HARBOR POINT A"], t["G-G-GPHA--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPHY--"] = E["TP.HARBOR POINT Y"], t["G-G-GPHY--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPHX--"] = E["TP.HARBOR POINT X"], t["G-G-GPHX--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPO---"] = E["TP.ROUTE"], t["G-G-GPO---"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPOZ--"] = E["TP.ROUTE RENDEZVOUS"], t["G-G-GPOZ--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I["G-G-GPOD--"] = E["TP.ROUTE DIVERSIONS"], t["G-G-GPOD--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I["G-G-GPOW--"] = E["TP.ROUTE WAYPOINT"], t["G-G-GPOW--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I["G-G-GPOP--"] = E["TP.ROUTE PIM"], t["G-G-GPOP--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I["G-G-GPOR--"] = E["TP.ROUTE POINT R"], t["G-G-GPOR--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I["G-G-GPA---"] = E["TP.AIR CONTROL POINT"], t["G-G-GPA---"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAP--"] = E["TP.COMBAT AIR PATROL (CAP)"], t["G-G-GPAP--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAW--"] = E["TP.AIRBORNE EARLY WARNING (AEW)"], t["G-G-GPAW--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAK--"] = E["TP.TANKING"], t["G-G-GPAK--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAA--"] = E["TP.FIXED WING"], t["G-G-GPAA--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAH--"] = E["TP.ROTARY WING"], t["G-G-GPAH--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAB--"] = E["TP.SUCAP - FIXED WING"], t["G-G-GPAB--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAC--"] = E["TP.SUCAP - ROTARY WING"], t["G-G-GPAC--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAD--"] = E["TP.MIW - FIXED WING"], t["G-G-GPAD--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAE--"] = E["TP.MIW - ROTARY WING"], t["G-G-GPAE--"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I["G-G-GPAS--"] = E["TP.STRIKE IP"], t["G-G-GPAS--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAT--"] = E["TP.TACAN"], t["G-G-GPAT--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAO--"] = E["TP.TOMCAT"], t["G-G-GPAO--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAR--"] = E["TP.RESCUE"], t["G-G-GPAR--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAL--"] = E["TP.REPLENISH"], t["G-G-GPAL--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAF--"] = E["TP.UNMANNED AERIAL SYSTEM"], t["G-G-GPAF--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAG--"] = E["TP.VTUA"], t["G-G-GPAG--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAI--"] = E["TP.ORBIT"], t["G-G-GPAI--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAJ--"] = E["TP.ORBIT - FIGURE EIGHT"], t["G-G-GPAJ--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAM--"] = E["TP.ORBIT - RACE TRACK"], t["G-G-GPAM--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPAN--"] = E["TP.ORBIT - RANDOM, CLOSED"], t["G-G-GPAN--"] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I["G-G-GPP---"] = E["TP.ACTION POINT"], t["G-G-GPP---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPK--"] = E["TP.ACTION CHECK POINT"], t["G-G-GPPK--"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPC--"] = E["TP.CONTACT POINT"], t["G-G-GPPC--"] = {
                x1: 55,
                x2: 145,
                y1: -10
            }, I["G-G-GPPO--"] = E["TP.COORDINATION POINT"], t["G-G-GPPO--"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-GPPD--"] = E["TP.DECISION POINT"], t["G-G-GPPD--"] = {
                x1: 30,
                x2: 170,
                y1: 25,
                y2: 160
            }, I["G-G-GPPL--"] = E["TP.ACTION LINKUP POINT"], t["G-G-GPPL--"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPP--"] = E["TP.ACTION PASSAGE POINT"], t["G-G-GPPP--"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPR--"] = E["TP.ACTION RALLY POINT"], t["G-G-GPPR--"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPE--"] = E["TP.ACTION RELEASE POINT"], t["G-G-GPPE--"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPS--"] = E["TP.ACTION START POINT"], t["G-G-GPPS--"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPA--"] = E["TP.ACTION AMNESTY POINT"], t["G-G-GPPA--"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-GPPW--"] = E["TP.WAYPOINT"], t["G-G-GPPW--"] = {
                x1: 60,
                x2: 140,
                y1: 60,
                y2: 140
            }, I["G-G-GPC---"] = E["TP.SEA SURFACE CONTROL STATION"], t["G-G-GPC---"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCU--"] = E["TP.(USV) CONTROL STATION"], t["G-G-GPCU--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCUR-"] = E["TP.(RMV) USV CONTROL STATION"], t["G-G-GPCUR-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCUA-"] = E["TP.USV - ASW CONTROL STATION"], t["G-G-GPCUA-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCUS-"] = E["TP.USV - SUW CONTROL STATION"], t["G-G-GPCUS-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCUM-"] = E["TP.USV - MIW CONTROL STATION"], t["G-G-GPCUM-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCA--"] = E["TP.ASW CONTROL STATION"], t["G-G-GPCA--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCS--"] = E["TP.SUW CONTROL STATION"], t["G-G-GPCS--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCM--"] = E["TP.MIW CONTROL STATION"], t["G-G-GPCM--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCP--"] = E["TP.PICKET CONTROL STATION"], t["G-G-GPCP--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCR--"] = E["TP.RENDEZVOUS CONTROL POINT"], t["G-G-GPCR--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCC--"] = E["TP.RESCUE CONTROL POINT"], t["G-G-GPCC--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCE--"] = E["TP.REPLENISHMENT CONTROL POINT"], t["G-G-GPCE--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPCN--"] = E["TP.NONCOMBATANT CONTROL STATION"], t["G-G-GPCN--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPB---"] = E["TP.SUB SURFACE CONTROL STATION"], t["G-G-GPB---"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPBU--"] = E["TP.(UUV) CONTROL STATION"], t["G-G-GPBU--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPBUA-"] = E["TP.UUV - ASW CONTROL STATION"], t["G-G-GPBUA-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPBUS-"] = E["TP.UUV - SUW CONTROL STATION"], t["G-G-GPBUS-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPBUM-"] = E["TP.UUV - MIW CONTROL STATION"], t["G-G-GPBUM-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPBS--"] = E["TP.SUBMARINE CONTROL STATION"], t["G-G-GPBS--"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-GPBSA-"] = E["TP.ASW SUBMARINE CONTROL STATION"], t["G-G-GPBSA-"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-G-APP---"] = E["TP.AIR CONTROL POINT (ACP)"], t["G-G-APP---"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-APC---"] = E["TP.COMMUNICATIONS CHECKPOINT"], t["G-G-APC---"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-G-APU---"] = E["TP.PULL-UP POINT"], t["G-G-APU---"] = {
                x1: 50,
                x2: 240,
                y1: 50,
                y2: 150
            }, I["G-G-APD---"] = E["TP.DOWNED AIRCREW PICKUP POINT"], t["G-G-APD---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-G-PN----"] = E["TP.DUMMY MINEFIELD"], t["G-G-PN----"] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 140
            }, I["G-G-DPT---"] = E["TP.TARGET REFERENCE"], I["G-G-DPO---"] = E["TP.OBSERVATION POST/OUTPOST"], t["G-G-DPO---"] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I["G-G-DPOC--"] = E["TP.COMBAT OUTPOST"], t["G-G-DPOC--"] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I["G-G-DPOR--"] = E["TP.OBSERVATION POST/RECONNAISSANCE"], t["G-G-DPOR--"] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I["G-G-DPOF--"] = E["TP.FORWARD OBSERVER POSITION"], t["G-G-DPOF--"] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I["G-G-DPOS--"] = E["TP.SENSOR OUTPOST"], t["G-G-DPOS--"] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I["G-G-DPON--"] = E["TP.CBRN OBSERVATION POST"], t["G-G-DPON--"] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I["G-G-OPP---"] = E["TP.POINT OF DEPARTURE"], t["G-G-OPP---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-OAOF--"] = E["TP.FIXED AND PREFABRICATED"], t["G-M-OAOF--"] = {
                x1: 60,
                x2: 140,
                y1: 30
            }, I["G-M-OAOM--"] = E["TP.TETRAHEDRONS"], t["G-M-OAOM--"] = {
                x1: 60,
                x2: 140,
                y1: 30
            }, I["G-M-OAOP--"] = E["TP.TETRAHEDRONS MOVABLE"], t["G-M-OAOP--"] = {
                x1: 60,
                x2: 140,
                y1: 30
            }, I["G-M-OB----"] = E["TP.BOOBY TRAP"], I["G-M-OMU---"] = E["TP.UNSPECIFIED MINE"], I["G-M-OMT---"] = E["TP.ANTITANK MINE (AT)"], I["G-M-OMD---"] = E["TP.(AT) ANTIHANDLING DEVICE"], t["G-M-OMD---"] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 195
            }, I["G-M-OME---"] = E["TP.(AT) DIRECTIONAL"], t["G-M-OME---"] = {
                x1: 60,
                x2: 140,
                y1: 10,
                y2: 140
            }, I["G-M-OMP---"] = E["TP.ANTIPERSONNEL (AP) MINES"], I["G-M-OMW---"] = E["TP.WIDE AREA MINES"], I["G-M-OFS---"] = E["TP.MINEFIELDS STATIC"], t["G-M-OFS---"] = {
                x1: 40,
                x2: 160,
                y1: 60,
                y2: 140
            }, I["G-M-OHTL--"] = E["TP.TOWER LOW"], t["G-M-OHTL--"] = {
                x1: 50,
                x2: 150,
                y1: 30,
                y2: 120
            }, I["G-M-OHTH--"] = E["TP.TOWER HIGH"], t["G-M-OHTH--"] = {
                x1: 50,
                x2: 150,
                y1: 30,
                y2: 120
            }, I["G-M-BCP---"] = E["TP.ENGINEER REGULATING POINT"], t["G-M-BCP---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-SE----"] = E["TP.EARTHWORK/FORTIFICATION"], I["G-M-SF----"] = E["TP.FORT"], I["G-M-SS----"] = E["TP.SURFACE SHELTER"], I["G-M-SU----"] = E["TP.UNDERGROUND SHELTER"], I["G-M-NZ----"] = E["TP.NUCLEAR DETONATIONS GROUND ZERO"], t["G-M-NZ----"] = {
                x1: 60,
                x2: 140,
                y1: -20
            }, I["G-M-NF----"] = E["TP.NUCLEAR FALLOUT PRODUCING"], t["G-M-NF----"] = {
                x1: 50,
                x2: 150,
                y1: -20
            }, I["G-M-NEB---"] = E["TP.RELEASE EVENTS BIOLOGICAL"], t["G-M-NEB---"] = {
                x1: -10,
                x2: 140,
                y1: -20
            }, I["G-M-NEC---"] = E["TP.RELEASE EVENTS CHEMICAL"], t["G-M-NEC---"] = {
                x1: -20,
                x2: 140,
                y1: -20
            }, I["G-M-NDP---"] = E["TP.DECON SITE/POINT"], t["G-M-NDP---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-NDA---"] = E["TP.ALTERNATE DECON SITE/POINT"], t["G-M-NDA---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-NDT---"] = E["TP.DECON SITE/POINT (TROOPS)"], t["G-M-NDT---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-NDE---"] = E["TP.DECON SITE/POINT (EQUIPMENT)"], t["G-M-NDE---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-NDB---"] = E["TP.DECON SITE/POINT (EQUIPMENT AND TROOPS)"], t["G-M-NDB---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-NDO---"] = E["TP.DECON SITE/POINT (OPERATIONAL DECONTAMINATION)"], t["G-M-NDO---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-M-NDD---"] = E["TP.DECON SITE/POINT (THOROUGH DECONTAMINATION)"], t["G-M-NDD---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-F-PTS---"] = E["TP.POINT/SINGLE TARGET"], I["G-F-PTN---"] = E["TP.NUCLEAR TARGET"], I["G-F-PCF---"] = E["TP.FIRE SUPPORT STATION"], I["G-F-PCS---"] = E["TP.SURVEY CONTROL POINT"], t["G-F-PCS---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-F-PCB---"] = E["TP.FIRING POINT"], t["G-F-PCB---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-F-PCR---"] = E["TP.RELOAD POINT"], t["G-F-PCR---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-F-PCH---"] = E["TP.HIDE POINT"], t["G-F-PCH---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-F-PCL---"] = E["TP.LAUNCH POINT"], t["G-F-PCL---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PX----"] = E["TP.AMBULANCE EXCHANGE POINT"], t["G-S-PX----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PC----"] = E["TP.CANNIBALIZATION POINT"], t["G-S-PC----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PY----"] = E["TP.CASUALTY COLLECTION POINT"], t["G-S-PY----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PT----"] = E["TP.CIVILIAN COLLECTION POINT"], t["G-S-PT----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PD----"] = E["TP.DETAINEE COLLECTION POINT"], t["G-S-PD----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PE----"] = E["TP.EPW COLLECTION POINT"], t["G-S-PE----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PL----"] = E["TP.LOGISTICS RELEASE POINT"], t["G-S-PL----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PM----"] = E["TP.MAINTENANCE COLLECTION POINT"], t["G-S-PM----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PR----"] = E["TP.REARM, REFUEL AND RESUPPLY POINT"], t["G-S-PR----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PU----"] = E["TP.REFUEL ON THE MOVE POINT"], t["G-S-PU----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PO----"] = E["TP.TRAFFIC CONTROL POST"], t["G-S-PO----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PI----"] = E["TP.TRAILER TRANSFER POINT"], t["G-S-PI----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PN----"] = E["TP.UNIT MAINTENANCE COLLECTION POINT"], t["G-S-PN----"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSZ---"] = E["TP.SUPPLY POINT"], t["G-S-PSZ---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSA---"] = E["TP.SP CLASS I"], t["G-S-PSA---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSB---"] = E["TP.SP CLASS II"], t["G-S-PSB---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSC---"] = E["TP.SP CLASS III"], t["G-S-PSC---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSD---"] = E["TP.SP CLASS IV"], t["G-S-PSD---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSE---"] = E["TP.SP CLASS V"], t["G-S-PSE---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSF---"] = E["TP.SP CLASS VI"], t["G-S-PSF---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSG---"] = E["TP.SP CLASS VII"], t["G-S-PSG---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSH---"] = E["TP.SP CLASS VIII"], t["G-S-PSH---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSI---"] = E["TP.SP CLASS IX"], t["G-S-PSI---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PSJ---"] = E["TP.SP CLASS X"], t["G-S-PSJ---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PAS---"] = E["TP.AMMUNITION SUPPLY POINT (ASP)"], t["G-S-PAS---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-S-PAT---"] = E["TP.AMMUNITION TRANSFER POINT (ATP)"], t["G-S-PAT---"] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I["G-O-ED----"] = E["TP.DITCHED AIRCRAFT"], I["G-O-EP----"] = E["TP.PERSON IN WATER"], I["G-O-EV----"] = E["TP.DISTRESSED VESSEL"], I["G-O-HM----"] = E["TP.SEA MINELIKE"], t["G-O-HM----"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 150
            }, I["G-O-HI----"] = E["TP.ICEBERG"], t["G-O-HI----"] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I["G-O-HO----"] = E["TP.OIL RIG/PLATFORM"], t["G-O-HO----"] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I["G-O-SB----"] = E["TP.BOTTOM RETURN"], t["G-O-SB----"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 100
            }, I["G-O-SBM---"] = E["TP.INSTALLATION/MANMADE"], t["G-O-SBM---"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 100
            }, I["G-O-SBN---"] = E["TP.BOTTOM RETURN"], t["G-O-SBN---"] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 100
            }, I["G-O-SBW---"] = E["TP.WRECK, NON DANGEROUS"], t["G-O-SBW---"] = {
                x1: 40,
                x2: 160,
                y1: 70,
                y2: 130
            }, I["G-O-SBX---"] = E["TP.WRECK, DANGEROUS"], t["G-O-SBX---"] = {
                x1: 40,
                x2: 160,
                y1: 70,
                y2: 130
            }, I["G-O-SM----"] = E["TP.MARINE LIFE"], t["G-O-SM----"] = {
                x1: 100,
                x2: 220,
                y1: 70,
                y2: 130
            }, I["G-O-SS----"] = E["TP.SEA ANOMALY"], t["G-O-SS----"] = {
                x1: 50,
                x2: 150,
                y1: 30,
                y2: 120
            }, I["G-O-FA----"] = E["TP.FIX ACOUSTIC"], I["G-O-FE----"] = E["TP.FIX ELECTRO-MAGNETIC"], I["G-O-FO----"] = E["TP.FIX ELECTRO-OPTICAL"];
        }
    };
    var B = [
        L,
        y,
        h,
        x,
        U,
        p,
        m,
        F,
        {
            type: "letter",
            getMetadata: o,
            getIcons: M,
            iconParts: [
                V
            ],
            labels: function(I) {
                I["G-T-GD----"] = {}, I["G-T-GI----"] = {}, I["G-T-GN----"] = {}, I["G-C-MGPFE-"] = {}, I["G-C-MGPFA-"] = {}, I["G-C-MGPFO-"] = {}, I["G-C-MGPI--"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 30,
                        fontsize: 45,
                        fontweight: "bold"
                    }
                }, I["G-C-MAAP--"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 135,
                        fontsize: 45,
                        fontweight: "bold"
                    }
                }, I["G-C-MAAC--"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 135,
                        fontsize: 45,
                        fontweight: "bold"
                    }
                }, I["G-C-MAAU--"] = {}, I["G-C-MAAD--"] = {}, I["G-C-MDN---"] = {}, I["G-C-MMPT--"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 115,
                        y: 85,
                        fontsize: 45,
                        fontweight: "bold"
                    }
                }, I["G-C-MMPO--"] = {}, I["G-C-MMPOC-"] = {}, I["G-C-MMPOR-"] = {}, I["G-C-MMPOF-"] = {}, I["G-C-MMPOS-"] = {}, I["G-C-MMPON-"] = {}, I["G-C-MMPON-"] = {}, I["G-C-MMPON-"] = {}, I["G-C-MOPD--"] = {}, I["G-C-BOATD-"] = {}, I["G-C-BOAB--"] = {}, I["G-C-BOAMA-"] = {}, I["G-C-BOAMT-"] = {}, I["G-C-BOAMD-"] = {}, I["G-C-BOAMC-"] = {}, I["G-C-BOAMU-"] = {}, I["G-C-BOAMN-"] = {}, I["G-C-BOAIP-"] = {}, I["G-C-BOAIC-"] = {}, I["G-C-BOAIN-"] = {}, I["G-C-BOAIS-"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 165,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-BOAIH-"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 165,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-BOAID-"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 165,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-BOAV--"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 165,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-BYCG--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BSE---"] = {}, I["G-C-BSF---"] = {}, I["G-C-BSH---"] = {}, I["G-C-BSU---"] = {}, I["G-C-BWN---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 20,
                        fontsize: 35
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 20,
                        fontsize: 35
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 100,
                        fontsize: 35
                    },
                    location: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 140,
                        fontsize: 35
                    },
                    quantity: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -25,
                        fontsize: 35
                    },
                    type: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 60,
                        fontsize: 35
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 100,
                        fontsize: 35
                    }
                }, I["G-C-BWE---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 20,
                        fontsize: 35
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 20,
                        fontsize: 35
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 100,
                        fontsize: 35
                    },
                    location: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 140,
                        fontsize: 35
                    },
                    quantity: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -25,
                        fontsize: 35
                    },
                    type: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 60,
                        fontsize: 35
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 100,
                        fontsize: 35
                    }
                }, I["G-C-BWI---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 20,
                        fontsize: 35
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 20,
                        fontsize: 35
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 100,
                        fontsize: 35
                    },
                    location: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 140,
                        fontsize: 35
                    },
                    quantity: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -25,
                        fontsize: 35
                    },
                    type: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 60,
                        fontsize: 35
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 100,
                        fontsize: 35
                    }
                }, I["G-C-BWF---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 20,
                        fontsize: 35
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 20,
                        fontsize: 35
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 100,
                        fontsize: 35
                    },
                    location: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 140,
                        fontsize: 35
                    },
                    quantity: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -25,
                        fontsize: 35
                    },
                    type: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 60,
                        fontsize: 35
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 100,
                        fontsize: 35
                    }
                }, I["G-C-BWP---"] = {}, I["G-C-BWDP--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDA--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDT--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDE--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDS--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDO--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDG--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDEM-"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-BWDTF-"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-FSTP--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 120,
                        y: 145,
                        fontsize: 40
                    },
                    altitudeDepth: {
                        stroke: !1,
                        textanchor: "end",
                        x: 80,
                        y: 145,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 120,
                        y: 80,
                        fontsize: 40
                    }
                }, I["G-C-FSS---"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 125,
                        y: 115,
                        fontsize: 40,
                        fontweight: "bold"
                    }
                }, I["G-C-FAU---"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 120,
                        y: 80,
                        fontsize: 40,
                        fontweight: "bold"
                    }
                }, I["G-C-SPA---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPC---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPY---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPT---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPD---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPE---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPL---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPM---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPR---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPU---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPO---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPI---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPN---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQT--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQA--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQB--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQC--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQD--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQE--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQF--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQG--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQH--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQI--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPQJ--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: -30,
                        fontsize: 40
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPMA--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-SPMT--"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OX----"] = {}, I["G-C-OXRN--"] = {}, I["G-C-OXRD--"] = {}, I["G-C-OXUD--"] = {}, I["G-C-OXUB--"] = {}, I["G-C-OXUL--"] = {}, I["G-C-OXUS--"] = {}, I["G-C-OXWA--"] = {}, I["G-C-OXWD--"] = {}, I["G-C-OXWE--"] = {}, I["G-C-OXWG--"] = {}, I["G-C-OXWM--"] = {}, I["G-C-OXWI--"] = {}, I["G-C-OXWP--"] = {}, I["G-C-OXY---"] = {}, I["G-C-OXYP--"] = {}, I["G-C-OXYD--"] = {}, I["G-C-OXYL--"] = {}, I["G-C-OXYC--"] = {}, I["G-C-OXYS--"] = {}, I["G-C-OXYB--"] = {}, I["G-C-OXYA--"] = {}, I["G-C-OXYV--"] = {}, I["G-C-OXYT--"] = {}, I["G-C-OXYR--"] = {}, I["G-C-OXYK--"] = {}, I["G-C-OXN---"] = {}, I["G-C-OXH---"] = {}, I["G-C-OXHQ--"] = {}, I["G-C-OXHA--"] = {}, I["G-C-OXHY--"] = {}, I["G-C-OXHX--"] = {}, I["G-C-OXR---"] = {}, I["G-C-OXRR--"] = {}, I["G-C-OXRD--"] = {}, I["G-C-OXRW--"] = {}, I["G-C-OXRP--"] = {}, I["G-C-OXRT--"] = {}, I["G-C-OXSTC-"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 92,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 128,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-OXSTCP"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 92,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 128,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-OXSTCA"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 92,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 128,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-OXSTR-"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 92,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 128,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-OXSTH-"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 92,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 128,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-OXSTS-"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 92,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 128,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-OXSTSA"] = {
                    dtg: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 92,
                        fontsize: 30,
                        fontweight: "bold"
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 128,
                        fontsize: 30,
                        fontweight: "bold"
                    }
                }, I["G-C-OXS---"] = {}, I["G-C-OXSA--"] = {}, I["G-C-OXSD--"] = {}, I["G-C-OXSC--"] = {}, I["G-C-OXAC--"] = {}, I["G-C-OXAA--"] = {}, I["G-C-OXAT--"] = {}, I["G-C-OXAK--"] = {}, I["G-C-OXAF--"] = {}, I["G-C-OXAH--"] = {}, I["G-C-OXAO--"] = {}, I["G-C-OXAR--"] = {}, I["G-C-OXAP--"] = {}, I["G-C-OXAM--"] = {}, I["G-C-OXAS--"] = {}, I["G-C-OXAD--"] = {}, I["G-C-OG----"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OGC---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    uniqueDesignation1: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 10,
                        fontsize: 35,
                        fontweight: "bold"
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OGP---"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 40,
                        fontsize: 45,
                        fontweight: "bold"
                    }
                }, I["G-C-OGT---"] = {}, I["G-C-OGD---"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: 115,
                        fontsize: 45,
                        fontweight: "bold"
                    }
                }, I["G-C-OGL---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OGN---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OGR---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OGS---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OGI---"] = {
                    additionalInformation: {
                        stroke: !1,
                        textanchor: "middle",
                        x: 100,
                        y: -70,
                        fontsize: 40
                    },
                    hostile: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 45,
                        fontsize: 40
                    },
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 150,
                        y: 0,
                        fontsize: 80
                    },
                    dtg: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: -30,
                        fontsize: 40
                    },
                    dtg1: {
                        stroke: !1,
                        textanchor: "end",
                        x: 50,
                        y: 10,
                        fontsize: 40
                    }
                }, I["G-C-OGW---"] = {
                    uniqueDesignation: {
                        stroke: !1,
                        textanchor: "start",
                        x: 140,
                        y: 125,
                        fontsize: 70
                    }
                }, I["G-O-VA----"] = {}, I["G-O-VR----"] = {}, I["G-O-VE----"] = {}, I["G-O-VB----"] = {}, I["G-O-VY----"] = {}, I["G-O-VD----"] = {}, I["G-O-VI----"] = {}, I["G-O-VM----"] = {}, I["G-O-VK----"] = {}, I["G-O-VS----"] = {}, I["G-O-VP----"] = {}, I["G-O-VU----"] = {}, I["G-O-VC----"] = {}, I["G-O-VH----"] = {}, I["G-O-VF----"] = {}, I["G-O-VO----"] = {}, I["G-O-VL----"] = {}, I["G-O-VX----"] = {}, I["G-O-VZ----"] = {}, I["G-O-LB----"] = {}, I["G-O-LG----"] = {}, I["G-O-LW----"] = {}, I["G-O-PR----"] = {}, I["G-O-PRB---"] = {}, I["G-O-PT----"] = {}, I["G-O-PC----"] = {}, I["G-O-PCU---"] = {}, I["G-O-PD----"] = {}, I["G-O-PM----"] = {}, I["G-O-PH----"] = {}, I["G-O-PHY---"] = {}, I["G-O-PHW---"] = {}, I["G-O-PHG---"] = {}, I["G-O-PHT---"] = {}, I["G-O-PG----"] = {}, I["G-O-PS----"] = {}, I["G-O-PF----"] = {}, I["G-O-PI----"] = {}, I["G-O-PE----"] = {}, I["G-O-PX----"] = {}, I["G-O-PJV---"] = {}, I["G-O-PJA---"] = {}, I["G-O-PJB---"] = {}, I["G-O-PK----"] = {}, I["G-O-PA----"] = {}, I["G-O-PO----"] = {}, I["G-O-IR----"] = {}, I["G-O-IS----"] = {}, I["G-O-IG----"] = {}, I["G-O-IV----"] = {}, I["G-O-IK----"] = {}, I["G-O-ID----"] = {}, I["G-O-IF----"] = {};
            },
            icons: function(I, t, E, R) {
                I["G-T-GD----"] = E["TP.DESTROY"], t["G-T-GD----"] = {
                    x1: 0,
                    x2: 200,
                    y1: 40,
                    y2: 160
                }, I["G-T-GI----"] = E["TP.INTERDICT"], t["G-T-GI----"] = {
                    x1: 0,
                    x2: 200,
                    y1: 40,
                    y2: 160
                }, I["G-T-GN----"] = E["TP.NEUTRALIZE"], t["G-T-GN----"] = {
                    x1: 0,
                    x2: 200,
                    y1: 40,
                    y2: 160
                }, I["G-C-MGPFE-"] = E["TP.FIX ELECTRO-MAGNETIC"], I["G-C-MGPFA-"] = E["TP.FIX ACOUSTIC"], I["G-C-MGPFO-"] = E["TP.FIX ELECTRO-OPTICAL"], I["G-C-MGPI--"] = E["TP.POINT OF INTEREST"], t["G-C-MGPI--"] = {
                    x1: 50,
                    x2: 150,
                    y1: -25
                }, I["G-C-MAAP--"] = E["TP.AIR CONTROL POINT (ACP)"], t["G-C-MAAP--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-MAAC--"] = E["TP.COMMUNICATIONS CHECKPOINT"], t["G-C-MAAC--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-MAAU--"] = E["TP.PULL-UP POINT"], t["G-C-MAAU--"] = {
                    x1: 50,
                    x2: 240,
                    y1: 50,
                    y2: 150
                }, I["G-C-MAAD--"] = E["TP.DOWNED AIRCREW PICKUP POINT"], t["G-C-MAAD--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-MDN---"] = E["TP.DUMMY MINEFIELD"], t["G-C-MDN---"] = {
                    x1: 40,
                    x2: 160,
                    y1: -10,
                    y2: 140
                }, I["G-C-MMPT--"] = E["TP.TARGET REFERENCE"], I["G-C-MMPO--"] = E["TP.OBSERVATION POST/OUTPOST"], t["G-C-MMPO--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 40,
                    y2: 150
                }, I["G-C-MMPOC-"] = E["TP.COMBAT OUTPOST"], t["G-C-MMPOC-"] = {
                    x1: 50,
                    x2: 150,
                    y1: 40,
                    y2: 150
                }, I["G-C-MMPOR-"] = E["TP.OBSERVATION POST/RECONNAISSANCE"], t["G-C-MMPOR-"] = {
                    x1: 50,
                    x2: 150,
                    y1: 40,
                    y2: 150
                }, I["G-C-MMPOF-"] = E["TP.FORWARD OBSERVER POSITION"], t["G-C-MMPOF-"] = {
                    x1: 50,
                    x2: 150,
                    y1: 40,
                    y2: 150
                }, I["G-C-MMPOS-"] = E["TP.SENSOR OUTPOST"], t["G-C-MMPOS-"] = {
                    x1: 50,
                    x2: 150,
                    y1: 40,
                    y2: 150
                }, I["G-C-MMPON-"] = E["TP.CBRN OBSERVATION POST"], t["G-C-MMPON-"] = {
                    x1: 50,
                    x2: 150,
                    y1: 40,
                    y2: 150
                }, I["G-C-MOPD--"] = E["TP.POINT OF DEPARTURE"], t["G-C-MOPD--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BOATD-"] = E["TP.FIXED AND PREFABRICATED"], t["G-C-BOATD-"] = {
                    x1: 60,
                    x2: 140,
                    y1: 30
                }, I["G-C-BOAB--"] = E["TP.BOOBY TRAP"], I["G-C-BOAMA-"] = E["TP.ANTIPERSONNEL (AP) MINES"], I["G-C-BOAMT-"] = E["TP.ANTITANK MINE (AT)"], I["G-C-BOAMD-"] = E["TP.(AT) ANTIHANDLING DEVICE"], t["G-C-BOAMD-"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 195
                }, I["G-C-BOAMC-"] = E["TP.(AT) DIRECTIONAL"], t["G-C-BOAMC-"] = {
                    x1: 60,
                    x2: 140,
                    y1: 10,
                    y2: 140
                }, I["G-C-BOAMU-"] = E["TP.UNSPECIFIED MINE"], I["G-C-BOAMW-"] = E["TP.WIDE AREA MINES"], I["G-C-BOAIP-"] = E["TP.PLANNED MINEFIELD"], t["G-C-BOAIP-"] = {
                    x1: 40,
                    x2: 160,
                    y1: 60,
                    y2: 140
                }, I["G-C-BOAIC-"] = E["TP.MINEFIELDS STATIC"], t["G-C-BOAIC-"] = {
                    x1: 40,
                    x2: 160,
                    y1: 60,
                    y2: 140
                }, I["G-C-BOAIN-"] = E["TP.ANTITANK (AT) MINEFIELD"], t["G-C-BOAIN-"] = {
                    x1: 40,
                    x2: 160,
                    y1: 60,
                    y2: 140
                }, I["G-C-BOAIS-"] = E["TP.SCATTERABLE MINES"], t["G-C-BOAIS-"] = {
                    x1: 40,
                    x2: 160,
                    y1: 20,
                    y2: 140
                }, I["G-C-BOAIH-"] = E["TP.ANTIPERSONNEL (AP) MINEFIELD"], t["G-C-BOAIH-"] = {
                    x1: 40,
                    x2: 160,
                    y1: 20,
                    y2: 140
                }, I["G-C-BOAID-"] = E["TP.SCATTERABLE MINEFIELD WITH SELF-DESTRUCT"], t["G-C-BOAID-"] = {
                    x1: 40,
                    x2: 160,
                    y1: 20,
                    y2: 140
                }, I["G-C-BOAV--"] = E["TP.VOLCANO MINEFIELD"], t["G-C-BOAV--"] = {
                    x1: 40,
                    x2: 160,
                    y1: 20,
                    y2: 140
                }, I["G-C-BYCG--"] = E["TP.ENGINEER REGULATING POINT"], t["G-C-BYCG--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BSE---"] = E["TP.EARTHWORK/FORTIFICATION"], I["G-C-BSF---"] = E["TP.FORT"], I["G-C-BSH---"] = E["TP.SURFACE SHELTER"], I["G-C-BSU---"] = E["TP.UNDERGROUND SHELTER"], I["G-C-BWN---"] = E["TP.NUCLEAR DETONATIONS GROUND ZERO"], t["G-C-BWN---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -20
                }, I["G-C-BWE---"] = E["TP.NUCLEAR DETONATIONS GROUND ZERO"], t["G-C-BWE---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -20
                }, I["G-C-BWI---"] = E["TP.NUCLEAR DETONATIONS GROUND ZERO PLANNED"], t["G-C-BWI---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -20
                }, I["G-C-BWF---"] = E["TP.NUCLEAR DETONATIONS GROUND ZERO PLANNED"], t["G-C-BWF---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -20
                }, I["G-C-BWP---"] = E["TP.NUCLEAR FALLOUT PRODUCING"], t["G-C-BWP---"] = {
                    x1: 50,
                    x2: 150,
                    y1: -20
                }, I["G-C-BWDP--"] = E["TP.DECON SITE/POINT"], t["G-C-BWDP--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDA--"] = E["TP.ALTERNATE DECON SITE/POINT"], t["G-C-BWDA--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDT--"] = E["TP.DECON SITE/POINT (TROOPS)"], t["G-C-BWDT--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDE--"] = E["TP.DECON SITE/POINT (EQUIPMENT)"], t["G-C-BWDE--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDS--"] = E["TP.DECON SITE/POINT (EQUIPMENT AND TROOPS)"], t["G-C-BWDS--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDO--"] = E["TP.DECON SITE/POINT (OPERATIONAL DECONTAMINATION)"], t["G-C-BWDO--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDG--"] = E["TP.DECON SITE/POINT (THOROUGH DECONTAMINATION)"], t["G-C-BWDG--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDEM-"] = E["TP.DECON POINT (MAIN) EQUIPMENT"], t["G-C-BWDEM-"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-BWDTF-"] = E["TP.DECON POINT (FORWARD) TROOPS"], t["G-C-BWDTF-"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-FSTP--"] = E["TP.POINT/SINGLE TARGET"], I["G-C-FSS---"] = E["TP.FIRE SUPPORT STATION"], I["G-C-FAU---"] = E["TP.NUCLEAR TARGET"], I["G-C-SPA---"] = E["TP.AMBULANCE EXCHANGE POINT"], t["G-C-SPA---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPC---"] = E["TP.CANNIBALIZATION POINT"], t["G-C-SPC---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPY---"] = E["TP.CASUALTY COLLECTION POINT"], t["G-C-SPY---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPT---"] = E["TP.CIVILIAN COLLECTION POINT"], t["G-C-SPT---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPD---"] = E["TP.DETAINEE COLLECTION POINT"], t["G-C-SPD---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPE---"] = E["TP.EPW COLLECTION POINT"], t["G-C-SPE---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPL---"] = E["TP.LOGISTICS RELEASE POINT"], t["G-C-SPL---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPM---"] = E["TP.MAINTENANCE COLLECTION POINT"], t["G-C-SPM---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPR---"] = E["TP.REARM, REFUEL AND RESUPPLY POINT"], t["G-C-SPR---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPU---"] = E["TP.REFUEL ON THE MOVE POINT"], t["G-C-SPU---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPO---"] = E["TP.TRAFFIC CONTROL POST"], t["G-C-SPO---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPI---"] = E["TP.TRAILER TRANSFER POINT"], t["G-C-SPI---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPN---"] = E["TP.UNIT MAINTENANCE COLLECTION POINT"], t["G-C-SPN---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQT--"] = E["TP.SUPPLY POINT"], t["G-C-SPQT--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQA--"] = E["TP.SP CLASS I"], t["G-C-SPQA--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQB--"] = E["TP.SP CLASS II"], t["G-C-SPQB--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQC--"] = E["TP.SP CLASS III"], t["G-C-SPQC--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQD--"] = E["TP.SP CLASS IV"], t["G-C-SPQD--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQE--"] = E["TP.SP CLASS V"], t["G-C-SPQE--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQF--"] = E["TP.SP CLASS VI"], t["G-C-SPQF--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQG--"] = E["TP.SP CLASS VII"], t["G-C-SPQG--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQH--"] = E["TP.SP CLASS VIII"], t["G-C-SPQH--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQI--"] = E["TP.SP CLASS IX"], t["G-C-SPQI--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPQJ--"] = E["TP.SP CLASS X"], t["G-C-SPQJ--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPMA--"] = E["TP.AMMUNITION SUPPLY POINT (ASP)"], t["G-C-SPMA--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-SPMT--"] = E["TP.AMMUNITION TRANSFER POINT (ATP)"], t["G-C-SPMT--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OX----"] = E["TP.SPECIAL POINT"], t["G-C-OX----"] = {
                    x1: 40,
                    x2: 160,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXRN--"] = E["TP.NAVIGATIONAL REFERENCE"], t["G-C-OXRN--"] = {
                    x1: 40,
                    x2: 160,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXUD--"] = E["TP.DATUM"], t["G-C-OXUD--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXUB--"] = E["TP.BRIEF CONTACT"], t["G-C-OXUB--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 0,
                    y2: 100
                }, I["G-C-OXUL--"] = E["TP.LOST CONTACT"], t["G-C-OXUL--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 0,
                    y2: 100
                }, I["G-C-OXUS--"] = E["TP.SINKER"], t["G-C-OXUS--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 0,
                    y2: 100
                }, I["G-C-OXWA--"] = E["TP.AIM POINT"], t["G-C-OXWA--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXWD--"] = E["TP.DROP POINT"], t["G-C-OXWD--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 120
                }, I["G-C-OXWE--"] = E["TP.ENTRY POINT"], t["G-C-OXWE--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50
                }, I["G-C-OXWG--"] = E["TP.GROUND ZERO"], t["G-C-OXWG--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 30
                }, I["G-C-OXWM--"] = E["TP.MSL DETECT POINT"], t["G-C-OXWM--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 30
                }, I["G-C-OXWI--"] = E["TP.IMPACT POINT"], t["G-C-OXWI--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXWP--"] = E["TP.PREDICTED IMPACT POINT"], t["G-C-OXWP--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXY---"] = E["TP.SONOBUOY"], t["G-C-OXY---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYP--"] = E["TP.SONOBUOY PATTERN CENTER"], t["G-C-OXYP--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYD--"] = E["TP.SONOBUOY DIFAR"], t["G-C-OXYD--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYL--"] = E["TP.SONOBUOY LOFAR"], t["G-C-OXYL--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYC--"] = E["TP.SONOBUOY CASS"], t["G-C-OXYC--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYS--"] = E["TP.SONOBUOY DICASS"], t["G-C-OXYS--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYB--"] = E["TP.SONOBUOY BT"], t["G-C-OXYB--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYA--"] = E["TP.SONOBUOY ANM"], t["G-C-OXYA--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYV--"] = E["TP.SONOBUOY VLAD"], t["G-C-OXYV--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYT--"] = E["TP.SONOBUOY ATAC"], t["G-C-OXYT--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYR--"] = E["TP.SONOBUOY RO"], t["G-C-OXYR--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXYK--"] = E["TP.SONOBUOY KINGPIN"], t["G-C-OXYK--"] = {
                    x1: 60,
                    x2: 140,
                    y1: -10,
                    y2: 160
                }, I["G-C-OXN---"] = E["TP.FORMATION"], t["G-C-OXN---"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXH---"] = E["TP.HARBOR"], t["G-C-OXH---"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXHQ--"] = E["TP.HARBOR POINT Q"], t["G-C-OXHQ--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXHA--"] = E["TP.HARBOR POINT A"], t["G-C-OXHA--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXHY--"] = E["TP.HARBOR POINT Y"], t["G-C-OXHY--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXHX--"] = E["TP.HARBOR POINT X"], t["G-C-OXHX--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXR---"] = E["TP.ROUTE"], t["G-C-OXR---"] = {
                    x1: 30,
                    x2: 170,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXRR--"] = E["TP.ROUTE RENDEZVOUS"], t["G-C-OXRR--"] = {
                    x1: 30,
                    x2: 170,
                    y1: 60,
                    y2: 170
                }, I["G-C-OXRD--"] = E["TP.ROUTE DIVERSIONS"], t["G-C-OXRD--"] = {
                    x1: 30,
                    x2: 170,
                    y1: 60,
                    y2: 170
                }, I["G-C-OXRW--"] = E["TP.ROUTE WAYPOINT"], t["G-C-OXRW--"] = {
                    x1: 30,
                    x2: 170,
                    y1: 60,
                    y2: 170
                }, I["G-C-OXRP--"] = E["TP.ROUTE PIM"], t["G-C-OXRP--"] = {
                    x1: 30,
                    x2: 170,
                    y1: 60,
                    y2: 170
                }, I["G-C-OXRT--"] = E["TP.ROUTE POINT R"], t["G-C-OXRT--"] = {
                    x1: 30,
                    x2: 170,
                    y1: 60,
                    y2: 170
                }, I["G-C-OXSTC-"] = E["TP.COMBATANT STATION"], t["G-C-OXSTC-"] = {
                    x1: -15,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXSTCP"] = E["TP.PICKET STATION"], t["G-C-OXSTCP"] = {
                    x1: -15,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXSTCA"] = E["TP.ASW SHIP STATION"], t["G-C-OXSTCA"] = {
                    x1: -15,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXSTR-"] = E["TP.REPLENISHMENT AT SEA (RAS) STATION"], t["G-C-OXSTR-"] = {
                    x1: -15,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXSTH-"] = E["TP.RESCUE STATION"], t["G-C-OXSTH-"] = {
                    x1: -15,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXSTS-"] = E["TP.SUBMARINE STATION"], t["G-C-OXSTS-"] = {
                    x1: -15,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXSTSA"] = E["TP.ASW SUBMARINE STATION"], t["G-C-OXSTSA"] = {
                    x1: -115,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-C-OXS---"] = E["TP.SEARCH"], t["G-C-OXS---"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXSA--"] = E["TP.SEARCH AREA"], t["G-C-OXSA--"] = {
                    x1: 20,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXSD--"] = E["TP.DIP POSITION"], t["G-C-OXSD--"] = {
                    x1: 10,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXSC--"] = E["TP.SEARCH CENTER"], t["G-C-OXSC--"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OXAC--"] = E["TP.COMBAT AIR PATROL (CAP)"], t["G-C-OXAC--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAA--"] = E["TP.AIRBORNE EARLY WARNING (AEW)"], t["G-C-OXAA--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAT--"] = E["TP.TACAN"], t["G-C-OXAT--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAK--"] = E["TP.TANKING"], t["G-C-OXAK--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAF--"] = E["TP.FIXED WING"], t["G-C-OXAF--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAH--"] = E["TP.ROTARY WING"], t["G-C-OXAH--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAO--"] = E["TP.TOMCAT"], t["G-C-OXAO--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAR--"] = E["TP.RESCUE"], t["G-C-OXAR--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAP--"] = E["TP.REPLENISH"], t["G-C-OXAP--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAM--"] = E["TP.MARSHALL"], t["G-C-OXAM--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAS--"] = E["TP.STRIKE IP"], t["G-C-OXAS--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OXAD--"] = E["TP.CORRIDOR TAB POINT"], t["G-C-OXAD--"] = {
                    x1: 60,
                    x2: 140,
                    y1: 40,
                    y2: 160
                }, I["G-C-OG----"] = E["TP.ACTION POINT"], t["G-C-OG----"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OGC---"] = E["TP.ACTION POINT"], t["G-C-OGC---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OGP---"] = E["TP.CONTACT POINT"], t["G-C-OGP---"] = {
                    x1: 55,
                    x2: 145,
                    y1: -10
                }, I["G-C-OGT---"] = E["TP.COORDINATION POINT"], t["G-C-OGT---"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["G-C-OGD---"] = E["TP.DECISION POINT"], t["G-C-OGD---"] = {
                    x1: 30,
                    x2: 170,
                    y1: 25,
                    y2: 160
                }, I["G-C-OGL---"] = E["TP.ACTION LINKUP POINT"], t["G-C-OGL---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OGN---"] = E["TP.ACTION PASSAGE POINT"], t["G-C-OGN---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OGR---"] = E["TP.ACTION RALLY POINT"], t["G-C-OGR---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OGS---"] = E["TP.ACTION RELEASE POINT"], t["G-C-OGS---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OGI---"] = E["TP.ACTION START POINT"], t["G-C-OGI---"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["G-C-OGW---"] = E["TP.WAYPOINT"], t["G-C-OGW---"] = {
                    x1: 60,
                    x2: 140,
                    y1: 60,
                    y2: 140
                }, I["G-O-VA----"] = E["TP.FIRE"], I["G-O-VR----"] = E["GR.EQ.HOWITZER"], I["G-O-VE----"] = E["ST.IC.KILLING VICTIM"], I["G-O-VB----"] = E["AIR.MISSILE.IC.BOMB"], I["G-O-VY----"] = E["ST.IC.BOOBY TRAP"], I["G-O-VD----"] = E["ST.IC.DRIVE-BY SHOOTING"], I["G-O-VI----"] = E["TP.INDIRECT FIRE"], I["G-O-VM----"] = E["GR.EQ.MORTAR"], I["G-O-VK----"] = E["GR.EQ.MULTIPLE ROCKET LAUNCHER"], I["G-O-VS----"] = E["ST.IC.SNIPING"], I["G-O-VP----"] = E["ST.IC.POISONING"], I["G-O-VU----"] = E["TP.AMBUSH"], I["G-O-VC----"] = E["GR.IC.FF.CLASS V"], I["G-O-VH----"] = E["AR.I.FF.CIVILIAN ROTARY WING"], I["G-O-VF----"] = [
                    E["GR.IC.FF.INFANTRY"],
                    E["GR.IC.FF.MOTORIZED"]
                ], I["G-O-VO----"] = E["GR.IC.FF.INFANTRY"], I["G-O-VL----"] = E["GR.IC.FF.RECONNAISSANCE"], I["G-O-VX----"] = E["GR.IC.FF.SIGNAL"], I["G-O-VZ----"] = E["GR.IC.FF.SUPPLY"], I["G-O-LB----"] = E["ST.IC.BLACK LIST LOCATION"], I["G-O-LG----"] = E["ST.IC.GRAY LIST LOCATION"], I["G-O-LW----"] = E["ST.IC.WHITE LIST LOCATION"], I["G-O-PR----"] = E["TP.ROAD BLOCK"], I["G-O-PRB---"] = E["TP.ROAD BLOCK (UNDER CONSTRUCTION)"], I["G-O-PT----"] = E["ST.IC.PATROLLING"], I["G-O-PC----"] = [
                    E["ST.IC.INDIVIDUAL"],
                    E["ST.M1.WILLING"]
                ], I["G-O-PCU---"] = [
                    E["ST.IC.INDIVIDUAL"],
                    E["ST.M1.COERCED/IMPRESSED"]
                ], I["G-O-PD----"] = E["ST.IC.DEMONSTRATION"], I["G-O-PM----"] = E["ST.IC.MINE LAYING"], I["G-O-PH----"] = E["ST.IC.PSYCHOLOGICAL OPERATIONS"], I["G-O-PHY---"] = E["ST.IC.RADIO AND TELEVISION PSYCHOLOGICAL OPERATIONS"], I["G-O-PHW---"] = [
                    E["ST.IC.PSYCHOLOGICAL OPERATIONS"],
                    E["ST.M1.WRITTEN PSYCHOLOGICAL OPERATIONS"]
                ], I["G-O-PHG---"] = [
                    E["ST.IC.PSYCHOLOGICAL OPERATIONS"],
                    E["ST.M1.WRITTEN PSYCHOLOGICAL OPERATIONS"]
                ], I["G-O-PHT---"] = [
                    E["ST.IC.PSYCHOLOGICAL OPERATIONS"],
                    E["ST.M1.HOUSE-TO-HOUSE"]
                ], I["G-O-PG----"] = E["ST.IC.SEARCHING"], I["G-O-PS----"] = E["ST.IC.SPY"], I["G-O-PF----"] = E["ST.IC.FOOD DISTRIBUTION"], I["G-O-PI----"] = E["GR.IC.FF.MEDICAL TREATMENT FACILITY"], I["G-O-PE----"] = [
                    E["GR.IC.ELECTRONIC WARFARE"],
                    E["GR.IC.FF.INTERCEPT"]
                ], I["G-O-PX----"] = E["ST.IC.EXTORTION"], I["G-O-PJV---"] = [
                    E["ST.IC.KNOWN INSURGENT VEHICLE"],
                    E["ST.M1.HIJACKING/HIJACKED"]
                ], I["G-O-PJA---"] = [
                    E["ST.IC.HIJACKING (AIRPLANE)"],
                    E["ST.M1.HIJACKING/HIJACKED"]
                ], I["G-O-PJB---"] = [
                    E["ST.IC.HIJACKING (BOAT)"],
                    E["ST.M1.HIJACKING/HIJACKED"]
                ], I["G-O-PK----"] = [
                    E["ST.IC.INDIVIDUAL"],
                    E["ST.M1.KIDNAPPING"]
                ], I["G-O-PA----"] = E["ST.IC.ARREST"], I["G-O-PO----"] = E["ST.IC.DRUG RELATED ACTIVITIES"], I["G-O-IR----"] = E["ST.IC.GROUP"], I["G-O-IS----"] = E["ST.IC.SAFE HOUSE"], I["G-O-IG----"] = E["ST.IC.GRAFFITI"], I["G-O-IV----"] = E["ST.IC.VANDALISM/LOOT/RANSACK/PLUNDER/SACK"], I["G-O-IK----"] = E["ST.IC.KNOWN INSURGENT VEHICLE"], I["G-O-ID----"] = [
                    E["ST.IC.KNOWN INSURGENT VEHICLE"],
                    E["ST.M1.DRUG"]
                ], I["G-O-IF----"] = E["ST.IC.INTERNAL SECURITY FORCE"];
            }
        }
    ], Y = [
        L,
        y,
        h,
        x,
        U,
        p,
        m,
        F,
        z,
        H,
        {
            type: "letter",
            getMetadata: o,
            getIcons: M,
            iconParts: [
                function(I, t, E, R, e, A) {
                    var C = t.affiliation || "Friend", T = E.iconColor[C], S = {
                        "2525B.ASWSUB": {
                            type: "path",
                            d: "m 80,85 40,0 0,-20 -40,0 z m 20,-30 0,40 m -40,15 15,15 50,0 15,-15 -15,-15 -50,0 z"
                        },
                        "2525B.NCBTT.STN": [
                            {
                                type: "path",
                                fill: !1,
                                d: "m 70,85 60,0 0,30 -60,0 z m 30,-15 0,60"
                            },
                            {
                                type: "text",
                                stroke: !1,
                                x: 100,
                                y: 145,
                                fontsize: 30,
                                text: "NC"
                            }
                        ],
                        "2525B.STN.ASWSHP": [
                            {
                                type: "path",
                                fill: !1,
                                d: "m 70,85 60,0 0,30 -60,0 z m 30,-15 0,60"
                            },
                            {
                                type: "text",
                                stroke: !1,
                                x: 100,
                                y: 145,
                                fontsize: 30,
                                text: "AS"
                            }
                        ],
                        "2525B.STN.PKT": [
                            {
                                type: "path",
                                fill: !1,
                                d: "m 70,85 60,0 0,30 -60,0 z m 30,-15 0,60"
                            },
                            {
                                type: "text",
                                stroke: !1,
                                x: 100,
                                y: 145,
                                fontsize: 30,
                                text: "PK"
                            }
                        ],
                        "2525B.STN.RSC": [
                            {
                                type: "path",
                                fill: !1,
                                d: "m 70,85 60,0 0,30 -60,0 z m 30,-15 0,60"
                            },
                            {
                                type: "text",
                                stroke: !1,
                                x: 100,
                                y: 145,
                                fontsize: 30,
                                text: "RS"
                            }
                        ],
                        "2525B.STN": {
                            type: "path",
                            fill: !1,
                            d: "m 70,85 c 20,0 40,0 60,0 0,10 0,20 0,30 -20,0 -40,0 -60,0 0,-10 0,-20 0,-30 z m 30,-15 c 0,20 0,40 0,60 m 35,-5 C 120,148 82.7,149 66.8,126 49.2,105 59.1,69.2 85.2,60.1 103,53.1 124,59.4 135,74.8"
                        },
                        "2525B.SUB.STN": [
                            {
                                type: "path",
                                d: "m 70,85 60,0 0,30 -60,0 z m 30,-15 0,60"
                            },
                            {
                                type: "text",
                                stroke: !1,
                                x: 100,
                                y: 145,
                                fontsize: 30,
                                text: "SS"
                            }
                        ]
                    };
                    for(var N in S)S.hasOwnProperty(N) && (I.hasOwnProperty(N) && console.warn("Override of: " + N), n.call(this, S[N], T), I[N] = S[N]);
                }
            ],
            icons: function(I, t, E, R) {
                I["S-S-S-----"] = E["2525B.STN"], I["S-S-SP----"] = E["2525B.STN.PKT"], I["S-S-SA----"] = E["2525B.STN.ASWSHP"], I["S-S-NN----"] = E["2525B.NCBTT.STN"], I["S-S-NNR---"] = E["2525B.STN.RSC"], I["S-U-SS----"] = E["2525B.SUB.STN"], I["S-U-SSA---"] = E["2525B.ASWSUB"], I["G-O-SBWD--"] = E["TP.WRECK, DANGEROUS"], t["G-O-SBXD--"] = {
                    x1: 35,
                    x2: 165,
                    y1: 70,
                    y2: 130
                };
            }
        },
        k
    ], W = [
        L,
        y,
        h,
        x,
        U,
        p,
        m,
        F,
        z,
        H,
        {
            type: "letter",
            getMetadata: o,
            getIcons: M,
            iconParts: [
                c,
                V
            ],
            icons: function(I, t, E, R) {
                I["E-I-A-----"] = [
                    E["AC.IC.CRIMINAL.CIVIL DISTURBANCE"]
                ], I["E-I-AC----"] = [
                    E["ST.IC.GROUP"],
                    E["AC.M1.RIOT"]
                ], I["E-I-B-----"] = [
                    E["AC.IC.CRIMINAL.ACTIVITY.INCIDENT"]
                ], I["E-I-BA----"] = [
                    E["ST.IC.BOMB"],
                    E["AC.M1.THREAT"]
                ], I["E-I-BC----"] = [
                    E["ST.IC.EXPLOSION"],
                    s._scale(.6, E["ST.IC.BOMB"])
                ], I["E-I-BD----"] = [
                    E["ST.IC.GROUP"],
                    E["ST.M1.LOOT"]
                ], I["E-I-BF----"] = [
                    E["AC.IC.SHOOTING"]
                ], I["E-I-C-----"] = [
                    E["AC.IC.FIRE EVENT"]
                ], I["E-I-CA----"] = [
                    E["AC.IC.HOT SPOT"]
                ], I["E-I-CB----"] = [
                    E["AC.IC.NON-REsIdENTIAL FIRE"]
                ], I["E-I-CC----"] = [
                    E["AC.IC.FIRE ORIGIN"]
                ], I["E-I-CD----"] = [
                    E["AC.IC.REsIdENTIAL FIRE"]
                ], I["E-I-CE----"] = [
                    E["AC.IC.SCHOOL FIRE"]
                ], I["E-I-CF----"] = [
                    E["AC.IC.SMOKE"]
                ], I["E-I-CG----"] = [
                    E["AC.IC.SPECIAL NEEDS FIRE"]
                ], I["E-I-CH----"] = [
                    E["AC.IC.WILD FIRE"]
                ], I["E-I-D-----"] = [
                    E["AC.IC.HAZARDOUS MATERIALS INCIDENT"]
                ], I["E-I-DA----"] = [
                    E["AC.IC.CHEMICAL AGENT"]
                ], I["E-I-DB----"] = [
                    E["AC.IC.CORROSIVE MATERIAL"]
                ], I["E-I-DC----"] = [
                    E["AC.IC.HAZARDOUS WHEN WET"]
                ], I["E-I-DD----"] = [
                    E["AC.IC.EXPLOSIVE MATERIAL"]
                ], I["E-I-DE----"] = [
                    E["AC.IC.FLAMMABLE GAS"]
                ], I["E-I-DF----"] = [
                    E["AC.IC.FLAMMABLE LIQUID"]
                ], I["E-I-DG----"] = [
                    E["AC.IC.FLAMMABLE SOLID"]
                ], I["E-I-DH----"] = [
                    E["AC.IC.NON-FLAMMABLE GAS"]
                ], I["E-I-DI----"] = [
                    E["AC.IC.ORGANIC PEROXIDE"]
                ], I["E-I-DJ----"] = [
                    E["AC.IC.OXIDIZER"]
                ], I["E-I-DK----"] = [
                    E["AC.IC.RADIOACTIVE MATERIAL"]
                ], I["E-I-DL----"] = [
                    E["AC.IC.SPONTANEOUSLY COMBUSTIBLE MATERIAL"]
                ], I["E-I-DM----"] = [
                    E["AC.IC.TOXIC GAS"]
                ], I["E-I-DN----"] = [
                    E["AC.IC.TOXIC INFECTIOUS MATERIAL"]
                ], I["E-I-DO----"] = [
                    E["AC.IC.UNEXPLODED ORDNANCE"]
                ], I["E-I-E-----"] = [
                    E["ST.M1.INCIDENT"],
                    E["ST.IC.HIJACKING (AIRPLANE)"]
                ], I["E-I-EA----"] = [
                    E["ST.M1.ACCIDENT"],
                    E["ST.IC.HIJACKING (AIRPLANE)"]
                ], I["E-I-F-----"] = [
                    E["ST.M1.INCIDENT"],
                    E["ST.IC.HIJACKING (BOAT)"]
                ], I["E-I-FA----"] = [
                    E["ST.M1.ACCIDENT"],
                    E["ST.IC.HIJACKING (BOAT)"]
                ], I["E-I-G-----"] = [
                    E["ST.M1.INCIDENT"],
                    E["GR.EQ.TRAIN LOCOMOTIVE"]
                ], I["E-I-GA----"] = [
                    E["ST.M1.ACCIDENT"],
                    E["GR.EQ.TRAIN LOCOMOTIVE"]
                ], I["E-I-GB----"] = [
                    E["GR.EQ.TRAIN LOCOMOTIVE"],
                    E["ST.M1.HIJACKING/HIJACKED"]
                ], I["E-I-H-----"] = [
                    E["ST.M1.INCIDENT"],
                    E["ST.IC.KNOWN INSURGENT VEHICLE"]
                ], I["E-I-HA----"] = [
                    E["ST.M1.ACCIDENT"],
                    E["ST.IC.KNOWN INSURGENT VEHICLE"]
                ], I["E-N-A-----"] = [], I["E-N-AA----"] = [
                    E["AC.IC.AFTERSHOCK"]
                ], I["E-N-AB----"] = [
                    E["AC.IC.AVALANCHE"]
                ], I["E-N-AC----"] = [
                    E["AC.IC.EARTHQUAKE EPICENTER"]
                ], I["E-N-AD----"] = [
                    E["AC.IC.LANDSLIDE"]
                ], I["E-N-AE----"] = [
                    E["AC.IC.SUBSIDENCE"]
                ], I["W-S-WSVE--"] = [
                    E["AC.IC.VOLCANIC ERUPTION"]
                ], I["E-N-AG----"] = [
                    E["AC.IC.VOLCANIC THREAT"]
                ], I["W-S-WSD-LI"] = [
                    E["ATMOSPHERIC.IC.DRIZZLE.INTERMITTENT LIGHT"]
                ], I["E-N-B-----"] = [], I["E-N-BB----"] = [
                    E["AC.IC.DROUGHT"]
                ], I["E-N-BC----"] = [
                    E["AC.IC.FLOOD"]
                ], I["W-S-WSFGSO"] = [
                    E["ATMOSPHERIC.IC.FOG.SKY OBSCURED"]
                ], I["W-S-WSGRL-"] = [
                    E["ATMOSPHERIC.IC.HAIL.LIGHT NOT ASSOCIATED WITH THUNDER"]
                ], I["E-N-BF----"] = [
                    E["AC.IC.INVERSION"]
                ], I["W-S-WSR-LI"] = [
                    E["ATMOSPHERIC.IC.RAIN.INTERMITTENT LIGHT"]
                ], I["W-S-WSDSLM"] = [
                    E["ATMOSPHERIC.IC.DUST OR SAND.LIGHT TO MODERATE"]
                ], I["W-S-WSS-LI"] = [
                    E["ATMOSPHERIC.IC.SNOW.INTERMITTENT LIGHT"]
                ], I["W-S-WSTMH-"] = [
                    E["ATMOSPHERIC.IC.STORMS.THUNDERSTORM LIGHT TO MODERATE - WITH HAIL"]
                ], I["W-S-WST-FC"] = [
                    E["ATMOSPHERIC.IC.STORMS.FUNNEL CLOUD (TORNADO/WATERSPOUT)"]
                ], I["W-S-WSTSS-"] = [
                    E["ATMOSPHERIC.IC.TROPICAL STORM SYSTEMS.TROPICAL STORM"]
                ], I["E-N-BM----"] = [
                    E["AC.IC.TSUNAMI"]
                ], I["E-N-C-----"] = [], I["E-N-CA----"] = [
                    E["AC.IC.BIRD"]
                ], I["E-N-CB----"] = [
                    E["AC.IC.INSECT"]
                ], I["E-N-CC----"] = [
                    E["AC.IC.MICROBIAL"]
                ], I["E-N-CD----"] = [
                    E["AC.IC.REPTILE"]
                ], I["E-N-CE----"] = [
                    E["AC.IC.RODENT"]
                ], I["E-O-A-----"] = I["E-O-AA----"] = I["E-O-AB----"] = I["E-O-AC----"] = I["E-O-AD----"] = [
                    E["GR.IC.EMERGENCY MEDICAL OPERATION"]
                ], I["E-O-AE----"] = [
                    E["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    E["GR.M1.MEDEVAC"]
                ], I["E-O-AF----"] = [
                    s._translate(0, 10, s._scale(.8, E["GR.I.FF.CIVILIAN ROTARY WING"])),
                    E["GR.M1.MEDEVAC"]
                ], I["E-O-AG----"] = [
                    E["AC.IC.HEALTH DEPARTMENT FACILITY"]
                ], I["E-O-AJ----"] = [
                    E["AC.IC.MEDICAL FACILITIES OUTPATIENT"]
                ], I["E-O-AK----"] = [
                    E["AC.IC.OPERATION/EMERGENCY MEDICAL OPERATION"]
                ], I["E-O-AL----"] = [
                    E["AC.IC.PHARMACY"]
                ], I["E-O-AM----"] = [
                    E["AC.IC.TRIAGE"]
                ], I["E-O-B-----"] = I["E-O-BA----"] = I["E-O-BB----"] = I["E-O-BC----"] = [
                    E["GR.IC.FF.EMERGENCY OPERATION"]
                ], I["E-O-BD----"] = [
                    s._scale(.7, E["GR.IC.FF.EMERGENCY OPERATION"]),
                    E["AC.M1.EMERGENCY COLLECTION EVACUATION POINT"]
                ], I["E-O-BE----"] = [
                    s._scale(.7, E["GR.IC.FF.EMERGENCY OPERATION"]),
                    E["AC.M1.EMERGENCY INCIDENT COMMAND CENTER"]
                ], I["E-O-BF----"] = [
                    s._scale(.7, E["GR.IC.FF.EMERGENCY OPERATION"]),
                    E["AC.M1.EMERGENCY OPERATIONS CENTER"]
                ], I["E-O-BG----"] = [
                    E["AC.IC.EMERGENCY PUBLIC INFORMATION CENTER"]
                ], I["E-O-BH----"] = [
                    s._scale(.7, E["GR.IC.FF.EMERGENCY OPERATION"]),
                    E["AC.M1.EMERGENCY SHELTER"]
                ], I["E-O-BI----"] = [
                    s._scale(.7, E["GR.IC.FF.EMERGENCY OPERATION"]),
                    E["AC.M1.EMERGENCY STAGING AREA"]
                ], I["E-O-BJ----"] = [
                    E["GR.IC.FF.EMERGENCY OPERATION"]
                ], I["E-O-BK----"] = I["S-G-USSW--"], I["E-O-BL----"] = [
                    E["ST.IC.FOOD DISTRIBUTION"],
                    E["AC.M1.EMERGENCY"]
                ], I["E-O-C-----"] = I["E-O-CA----"] = I["E-O-CB----"] = I["E-O-CE----"] = [
                    E["GR.IC.FIRE PROTECTION"]
                ], I["E-O-CC----"] = [
                    E["AC.IC.FIRE HYDRANT"]
                ], I["E-O-CD----"] = [
                    E["AC.IC.OTHER WATER SUPPLY LOCATION"]
                ], I["E-O-D-----"] = I["E-O-DA----"] = I["E-O-DB----"] = I["E-O-DC----"] = [
                    E["GR.IC.FF.LAW ENFORCEMENT"]
                ], I["E-O-DD----"] = I["E-O-DDA---"] = I["E-O-DDB---"] = I["E-O-DDC---"] = [
                    E["GR.IC.BUREAU OF ALCOHOL, TOBACCO, FIREARMS AND EXPLOSIVES (ATF) (DEPARTMENT OF JUSTICE)"]
                ], I["E-O-DE----"] = I["E-O-DEA---"] = I["E-O-DEB---"] = I["E-O-DEC---"] = [
                    E["GR.IC.FF.BORDER PATROL"]
                ], I["E-O-DF----"] = I["E-O-DFA---"] = I["E-O-DFB---"] = I["E-O-DFC---"] = [
                    E["GR.IC.FF.CUSTOMS SERVICE"]
                ], I["E-O-DG----"] = I["E-O-DGA---"] = I["E-O-DGB---"] = I["E-O-DGC---"] = [
                    E["GR.IC.DRUG ENFORCEMENT AGENCY (DEA)"]
                ], I["E-O-DH----"] = I["E-O-DHA---"] = I["E-O-DHB---"] = I["E-O-DHC---"] = [
                    E["GR.IC.FF.DEPARTMENT OF JUSTICE (DOJ)"]
                ], I["E-O-DI----"] = I["E-O-DIA---"] = I["E-O-DIB---"] = I["E-O-DIC---"] = [
                    E["GR.IC.FEDERAL BUREAU OF INVESTIGATION (FBI)"]
                ], I["E-O-DJ----"] = I["E-O-DJB---"] = I["E-O-DJC---"] = [
                    E["GR.IC.LAW ENFORCEMENT"]
                ], I["E-O-DK----"] = [
                    E["GR.IC.FF.PRISON"]
                ], I["E-O-DL----"] = I["E-O-DLA---"] = I["E-O-DLB---"] = I["E-O-DLC---"] = [
                    E["GR.IC.UNITED STATES SECRET SERVICE(TREAS) (USSS)"]
                ], I["E-O-DM----"] = I["E-O-DMA---"] = I["E-O-DMB---"] = I["E-O-DMC---"] = [
                    E["GR.IC.TRANSPORTATION SECURITY AGENCY (TSA)"]
                ], I["E-O-DN----"] = I["E-O-DNA---"] = I["E-O-DNC---"] = [
                    E["GR.IC.LAW ENFORCEMENT VESSEL"]
                ], I["E-O-DO----"] = I["E-O-DOA---"] = I["E-O-DOB---"] = I["E-O-DOC---"] = [
                    E["GR.IC.FF.US MARSHALS SERVICE"]
                ], I["E-O-EA----"] = [
                    s._scale(.6, E["GR.EQ.SENSOR"]),
                    E["GR.M1.BIOLOGICAL"]
                ], I["E-O-EB----"] = [
                    s._scale(.6, E["GR.EQ.SENSOR"]),
                    E["GR.M1.CHEMICAL"]
                ], I["E-O-EC----"] = [
                    s._scale(.6, E["GR.EQ.SENSOR"]),
                    E["GR.M1.INTRUSION"]
                ], I["E-O-ED----"] = [
                    s._scale(.6, E["GR.EQ.SENSOR"]),
                    E["GR.M1.NUCLEAR"]
                ], I["E-O-EE----"] = [
                    s._scale(.6, E["GR.EQ.SENSOR"]),
                    E["GR.M1.RADIOLOGICAL"]
                ], I["E-F-A-----"] = [
                    E["GR.IN.IC.AGRICULTURE AND FOOD INFRASTRUCTURE"]
                ], I["E-F-AA----"] = [
                    E["GR.IN.IC.AGRICULTURAL LABORATORY"]
                ], I["E-F-AB----"] = [
                    E["GR.IN.IC.ANIMAL FEEDLOT"]
                ], I["E-F-AC----"] = [
                    E["ST.IC.FOOD DISTRIBUTION"],
                    E["AC.M1.COMMERCIAL"]
                ], I["E-F-AD----"] = [
                    E["GR.IN.IC.FARM/RANCH"]
                ], I["E-F-AE----"] = [
                    E["ST.IC.FOOD DISTRIBUTION"],
                    E["AC.M1.PRODUCTION"]
                ], I["E-F-AF----"] = [
                    E["ST.IC.FOOD DISTRIBUTION"],
                    E["AC.M1.RETAIL"]
                ], I["E-F-AG----"] = [
                    E["GR.IN.IC.GRAIN STORAGE"]
                ], I["E-F-B-----"] = [
                    E["AC.IC.BANKING FINANCE AND INSURANCE INFRASTRUCTURE"]
                ], I["E-F-BA----"] = [
                    E["GR.IN.IC.ATM"]
                ], I["E-F-BB----"] = [
                    E["GR.IN.IC.BANK"]
                ], I["E-F-BC----"] = [
                    E["GR.IN.IC.BULLION STORAGE"]
                ], I["E-F-BD----"] = [
                    E["GR.IN.IC.FEDERAL RESERVE BANK"]
                ], I["E-F-BE----"] = [
                    E["GR.IN.IC.FINANCIAL EXCHANGE"]
                ], I["E-F-BF----"] = [
                    E["GR.IN.IC.FINANCIAL SERVICES, OTHER"]
                ], I["E-F-C-----"] = [
                    E["GR.IN.IC.COMMERCIAL INFRASTRUCTURE"]
                ], I["E-F-CA----"] = [
                    E["GR.IN.IC.CHEMICAL PLANT"]
                ], I["E-F-CB----"] = [
                    E["GR.IN.IC.FIREARMS MANUFACTURER"]
                ], I["E-F-CC----"] = [
                    E["GR.IN.IC.FIREARMS RETAILER"]
                ], I["E-F-CD----"] = [
                    E["GR.IN.IC.HAZARDOUS MATERIAL PRODUCTION"]
                ], I["E-F-CE----"] = [
                    E["GR.IN.IC.HAZARDOUS MATERIAL STORAGE"]
                ], I["E-F-CF----"] = [
                    E["GR.IN.IC.INDUSTRIAL SITE"]
                ], I["E-F-CG----"] = [
                    E["GR.IN.IC.LANDFILL"]
                ], I["E-F-CH----"] = [
                    E["GR.IN.IC.PHARMACEUTICAL MANUFACTURER"]
                ], I["E-F-CI----"] = [
                    E["GR.IN.IC.CONTAMINATED HAZARDOUS WASTE SITE"]
                ], I["E-F-CJ----"] = [
                    E["GR.IN.IC.TOXIC RELEASE INVENTORY"]
                ], I["E-F-D-----"] = [
                    E["GR.IN.IC.EDUCATIONAL FACILITIES INFRASTRUCTURE"]
                ], I["E-F-DA----"] = [
                    E["GR.IN.IC.COLLEGE/UNIVERSITY"]
                ], I["E-F-DB----"] = [
                    E["GR.IN.IC.SCHOOL"]
                ], I["E-F-EA----"] = [
                    s._translate(0, 15, s._scale(.75, E["GR.IN.IC.ELECTRIC POWER"])),
                    E["AC.M1.GENERATION STATION"]
                ], I["E-F-EB----"] = [
                    E["GR.IN.IC.NATURAL GAS FACILITY"]
                ], I["E-F-EE----"] = [
                    E["GR.IN.IC.PROPANE FACILITY"]
                ], I["E-F-F-----"] = [
                    E["GR.IN.IC.GOVERNMENT SITE INFRASTRUCTURE"]
                ], I["E-F-G-----"] = [
                    E["GR.IN.IC.MILITARY INFRASTRUCTURE"]
                ], I["E-F-GA----"] = [
                    E["GR.IN.IC.BASE"],
                    E["AC.M1.MILITARY ARMORY"]
                ], I["E-F-H-----"] = [
                    E["GR.IN.IC.POSTAL SERVICE INFRASTRUCTURE"]
                ], I["E-F-HA----"] = [
                    E["GR.IN.IC.POSTAL DISTRIBUTION CENTER"]
                ], I["E-F-HB----"] = [
                    E["GR.IN.IC.POST OFFICE"]
                ], I["E-F-I-----"] = [
                    E["GR.IN.IC.PUBLIC VENUES INFRASTRUCTURE"]
                ], I["E-F-IA----"] = [
                    E["GR.IN.IC.ENCLOSED FACITLITY (PUBLIC VENUE)"]
                ], I["E-F-IB----"] = [
                    E["GR.IN.IC.OPEN FACILITY (OPEN VENUE)"]
                ], I["E-F-IC----"] = [
                    E["GR.IN.IC.RECREATIONAL AREA"]
                ], I["E-F-ID----"] = [
                    E["GR.IN.IC.RELIGIOUS INSTITUTION"]
                ], I["E-F-J-----"] = [
                    E["GR.IN.IC.SPECIAL NEEDS INFRASTRUCTURE"]
                ], I["E-F-JA----"] = [
                    E["GR.IN.IC.ADULT DAY CARE"]
                ], I["E-F-JB----"] = [
                    E["GR.IN.IC.CHILD DAY CARE"]
                ], I["E-F-JC----"] = [
                    E["GR.IN.IC.ELDER CARE"]
                ], I["E-F-K-----"] = [
                    E["GR.IN.IC.TELECOMMUNICATIONS INFRASTRUCTURE"]
                ], I["E-F-KB----"] = [
                    E["GR.IN.IC.TELECOMMUNICATIONS TOWER"]
                ], I["E-F-LA----"] = [
                    E["GR.IN.IC.AIR TRAFFIC CONTROL FACILITY"]
                ], I["G-M-BCB---"] = [
                    E["GR.IN.IC.BRIDGE"]
                ], t["G-M-BCB---"] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: 150
                }, I["E-F-LD----"] = [
                    E["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"]
                ], I["E-F-LE----"] = [
                    E["GR.IC.FERRY"]
                ], I["E-F-LF----"] = [
                    E["GR.IN.IC.HELICOPTER LANDING SITE"]
                ], I["W-S-ML----"] = [
                    E["GR.IN.IC.TRANSPORTATION INFRASTRUCTURE LOCK"]
                ], I["E-F-LH----"] = [
                    E["GR.IC.MAINTENANCE"]
                ], I["E-F-LJ----"] = [
                    E["GR.IC.RAILHEAD"]
                ], I["E-F-LK----"] = [
                    E["GR.IN.IC.REST STOP"]
                ], I["W-S-HPBA--"] = [
                    E["GR.IN.IC.TRANSPORTATION INFRASTRUCTURE SHIP ANCHORAGE"]
                ], I["E-F-LM----"] = [
                    E["GR.IN.IC.TOLL FACILITY"]
                ], I["G-S-PO----"] = E["TP.TRAFFIC CONTROL POST"], t["G-S-PO----"] = {
                    x1: 60,
                    x2: 140,
                    y1: -60
                }, I["E-F-LO----"] = [
                    E["GR.IN.IC.TRAFFIC INSPECTION FACILITY"]
                ], I["E-F-LP----"] = [
                    E["GR.IN.IC.TUNNEL"]
                ], I["E-F-MA----"] = [
                    E["GR.IN.IC.CONTROL VALVE"]
                ], I["E-F-MB----"] = [
                    E["GR.IN.IC.DAM"]
                ], I["E-F-MC----"] = [
                    E["GR.IN.IC.DISCHARGE OUTFALL"]
                ], I["E-F-MD----"] = [
                    E["GR.IN.IC.GROUND WATER WELL"]
                ], I["E-F-ME----"] = [
                    E["GR.IN.IC.PUMPING STATION"]
                ], I["E-F-MF----"] = [
                    E["GR.IN.IC.RESERVOIR"]
                ], I["E-F-MG----"] = [
                    E["GR.IN.IC.STORAGE TOWER"]
                ], I["E-F-MH----"] = [
                    E["GR.IN.IC.SURFACE WATER INTAKE"]
                ], I["E-F-MI----"] = [
                    E["GR.IN.IC.WASTEWATER TREATMENT FACILITY"]
                ], I["O-O-D-----"] = [
                    E["ST.IC.DEMONSTRATION"]
                ], I["O-I-R-----"] = [
                    E["ST.IC.GROUP"]
                ], I["O-V-B-----"] = [
                    E["ST.IC.BOMB"]
                ], I["O-V-P-----"] = [
                    E["ST.IC.POISONING"]
                ], I["O-O-HA----"] = [
                    E["ST.IC.HIJACKING (AIRPLANE)"],
                    E["ST.M1.HIJACKING/HIJACKED"]
                ], I["O-O-HV----"] = [
                    E["ST.IC.HIJACKING (BOAT)"],
                    E["ST.M1.HIJACKING/HIJACKED"]
                ], I["O-O-HT----"] = [
                    E["ST.IC.KNOWN INSURGENT VEHICLE"],
                    E["ST.M1.HIJACKING/HIJACKED"]
                ], I["S-G-IXH---"] = [
                    E["GR.IC.FF.MEDICAL TREATMENT FACILITY"]
                ], I["S-S-NM----"] = [
                    E["GR.IC.HOSPITAL SHIP"]
                ], I["E-O-BK----"] = [
                    E["GR.IC.FF.SUPPLY"],
                    E["GR.IC.WATER"]
                ], I["S-G-UULC--"] = [
                    E["GR.IC.LAW ENFORCEMENT"]
                ], I["S-S-XL----"] = [
                    E["GR.IC.LAW ENFORCEMENT VESSEL"]
                ], I["S-G-ES----"] = [
                    E["GR.EQ.SENSOR"]
                ], I["S-G-IUE---"] = [
                    E["GR.IN.IC.ELECTRIC POWER"]
                ], I["S-G-IUEN--"] = [
                    E["GR.IN.IC.ELECTRIC POWER"],
                    E["GR.IN.IC.ELECTRIC POWER NUCLEAR"]
                ], I["S-G-IRP---"] = [
                    E["GR.IC.FF.CLASS III"]
                ], I["S-G-IB----"] = [
                    E["GR.IN.IC.BASE"]
                ], I["S-G-IUT---"] = [
                    E["GR.IN.IC.TELECOMMUNICATIONS"]
                ], I["S-G-IT----"] = [
                    E["GR.IC.TRANSPORTATION"]
                ], I["S-G-IBA---"] = [
                    E["GR.IC.TRANSPORTATION"],
                    E["GR.IC.AIRPORT OF DEBARKATION"]
                ], I["S-G-IBN---"] = [
                    E["GR.IC.NAVAL"]
                ], I["S-G-IUP---"] = [
                    E["GR.IC.WATER"]
                ];
            }
        },
        k
    ];
    function u(I, t, E) {
        var R = this.options.sidc.substr(2, 1), e = this.options.sidc.substr(3, 1), A = this.options.sidc.substr(4, 2), C = this.options.sidc.substr(6, 1), T = this.options.sidc.substr(7, 1), S = this.options.sidc.substr(8, 2), N = t.functionid = this.options.sidc.substr(10, 10);
        return t.context = E.context[parseInt(this.options.sidc.substr(2, 1))], t.affiliation = ({
            0: "Unknown",
            1: "Unknown",
            2: "Friend",
            3: "Friend",
            4: "Neutral",
            5: "Hostile",
            6: "Hostile"
        })[e], t.dimension = ({
            "00": "Sea",
            "01": "Air",
            "02": "Air",
            "05": "Air",
            "06": "Air",
            10: "Ground",
            11: "Ground",
            12: "Ground",
            15: "Ground",
            20: "Ground",
            30: "Sea",
            35: "Subsurface",
            36: "Subsurface",
            39: "Subsurface",
            40: "Ground",
            50: "Air",
            51: "Air",
            52: "Ground",
            53: "Sea",
            54: "Subsurface",
            60: "Ground"
        })[A] || "", "10" != A && "11" != A && "25" != A && "27" != A && "40" != A || (t.unit = !0), "05" != A && "06" != A && "50" != A || (t.space = !0), "40" == A && (t.activity = !0), "20" == A && (t.installation = !0), "25" == A && (t.controlMeasure = !0), "60" == A && (t.cyberspace = !0), "36" == A && !1 === this.style.alternateMedal && (t.fill = !1), "30" == A && 15e4 == N.substr(0, 6) && (t.frame = !1), "1" == C && (t.notpresent = I._dashArrays.anticipated), "0" != e && "2" != e && "5" != e || (t.notpresent = I._dashArrays.pending), "30" == A && 16e4 == N.substr(0, 6) && (t.notpresent = I._dashArrays.pending), "35" == A && 14e4 == N.substr(0, 6) && (t.notpresent = I._dashArrays.pending), "35" == A && 15e4 == N.substr(0, 6) && (t.notpresent = I._dashArrays.pending), "2" != C && "3" != C && "4" != C && "5" != C || (t.condition = E.status[parseInt(C)]), t.baseDimension = t.dimension, t.baseAffilation = t.affiliation, "5" == e && "1" == R && (t.joker = !0), "6" == e && "1" == R && (t.faker = !0), (t.joker || t.faker) && (t.affiliation = E.affiliation[1]), "00" == A && (t.dimensionUnknown = !0), "00" == A && "1" == R && "Unknown" != t.affiliation && (t.affiliation = ""), "27" == A && (t.dimension = "LandDismountedIndividual", t.dismounted = !0), "15" != A && "52" != A || (t.dimension = E.dimension[2]), -1 < [
            "1",
            "3",
            "5",
            "7"
        ].indexOf(T) && (t.feintDummy = !0), -1 < [
            "2",
            "3",
            "6",
            "7"
        ].indexOf(T) && (t.headquarters = !0), -1 < [
            "4",
            "5",
            "6",
            "7"
        ].indexOf(T) && (t.taskForce = !0), S <= 30 && (t.echelon = E.echelonMobility[S]), 30 <= S && S < 70 && (t.mobility = E.echelonMobility[S]), 70 <= S && S < 80 && (t.leadership = E.echelonMobility[S]), ("01" == A && "12" == N.substring(0, 2) || "05" == A && "12" == N.substring(0, 2) || "11" == A || "12" == A && "12" == N.substring(0, 2) || "15" == A && "16" == N.substring(0, 2) || "30" == A && "14" == N.substring(0, 2) || "35" == A && "12" == N.substring(0, 2)) && (t.civilian = !0), t;
    }
    function v(I, t, E, R) {
        var e = {}, A = {}, C = {}, T = {};
        for(var S in I._iconSIDC.number)I._iconSIDC.number.hasOwnProperty(S) && I._iconSIDC.number[S].call(this, e, A, C, T, t, E, R);
        return {
            icons: e,
            m1: A,
            m2: C,
            bbox: T
        };
    }
    var Q = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: P,
        icons: function(I, t, E, R, e, A, C) {
            "01" == e && (I[11e4] = [
                A["AR.I.MILITARY"]
            ], I[110100] = [
                A["AR.I.FIXED-WING DSymbol"]
            ], I[110101] = [
                A["AR.I.MEDICAL EVACUATION"]
            ], I[110102] = [
                A["AR.I.ATTACK/STRIKE"]
            ], I[110103] = [
                A["AR.I.BOMBER"]
            ], I[110104] = [
                A["AR.I.FIGHTER"]
            ], I[110105] = [
                A["AR.I.FIGHTER/BOMBER"]
            ], I[110106] = [], I[110107] = [
                A["AR.I.CARGO"]
            ], I[110108] = [
                A["AR.I.JAMMER / ELECTRONIC COUNTER-MEASURES"]
            ], I[110109] = [
                A["AR.I.TANKER"]
            ], I[110110] = [
                A["AR.I.PATROL"]
            ], I[110111] = [
                A["AR.I.RECONNAISSANCE"]
            ], I[110112] = [
                A["AR.I.TRAINER"]
            ], I[110113] = [
                A["AR.I.UTILITY"]
            ], I[110114] = [
                A["AR.I.VSTOL"]
            ], I[110115] = [
                A["AR.I.AIRBORNE COMMAND POST"]
            ], I[110116] = [
                A["AR.I.AIRBORNE EARLY WARNING"]
            ], I[110117] = [
                A["AR.I.ANTISURFACE WARFARE"]
            ], I[110118] = [
                A["AR.I.ANTISUBMARINE WARFARE"]
            ], I[110119] = [
                A["AR.I.COMMUNICATIONS"]
            ], I[110120] = [
                A["AR.I.COMBAT SEARCH AND RESCUE"]
            ], I[110121] = [
                A["AR.I.ELECTRONIC SUPPORT"]
            ], I[110122] = [
                A["AR.I.GOVERNMENT"]
            ], I[110123] = [
                A["AR.I.MINE COUNTERMEASURES"]
            ], I[110124] = [
                A["AR.I.PERSONNEL RECOVERY DSymbol"]
            ], I[110125] = [
                A["AR.I.SEARCH AND RESCUE"]
            ], I[110126] = [
                A["AR.I.SPECIAL OPERATIONS FORCES"]
            ], I[110127] = [
                A["AR.I.ULTRA LIGHT"]
            ], I[110128] = [
                A["AR.I.PHOTOGRAPHIC RECONNAISSANCE"]
            ], I[110129] = [
                A["AR.I.VIP"]
            ], I[110130] = [
                A["AR.I.SUPRESSION OF ENEMY AIR DEFENCE"]
            ], I[110131] = [
                A["AR.I.PASSENGER"]
            ], I[110132] = [
                A["AR.I.ESCORT"]
            ], I[110133] = [
                A["AR.I.ELECTRONIC ATTACK (EA)"]
            ], I[110200] = [
                A["AR.I.MILITARY ROTARY WING"]
            ], I[110300] = [
                A["AR.I.UNMANNED AERIAL VEHICLE"]
            ], I[110400] = [
                A["AR.I.VERTICAL-TAKEOFF UAV (VT-UAV)"]
            ], I[110500] = [
                A["AR.I.MILITARY BALLOON"]
            ], I[110600] = [
                A["AR.I.MILITARY AIRSHIP"]
            ], I[110700] = [
                A["AR.I.TETHERED LIGHTER THAN AIR"]
            ], I[12e4] = [
                A["AR.I.CIVILIAN"]
            ], I[120100] = [
                A["AR.I.CIVILIAN FIXED-WING DSymbol"]
            ], I[120200] = [
                A["AR.I.CIVILIAN ROTARY WING"]
            ], I[120300] = [
                A["AR.I.CIVILIAN UNMANNED AERIAL VEHICLE"]
            ], I[120400] = [
                A["AR.I.CIVILIAN BALLOON"]
            ], I[120500] = [
                A["AR.I.CIVILIAN AIRSHIP"]
            ], I[120600] = [
                A["AR.I.CIVILIAN TETHERED LIGHTER THAN AIR"]
            ], I[13e4] = [
                A["AR.I.WEAPON"]
            ], I[130100] = [
                A["AR.I.BOMB"]
            ], I[130200] = [
                A["AR.I.UNDERWATER DECOY DSymbol"]
            ], I[14e4] = [
                A["AR.I.MANUAL TRACK"]
            ], t["01"] = [
                A["AIR.M1.ATTACK"]
            ], t["02"] = [
                A["AIR.M1.BOMBER"]
            ], t["03"] = [
                A["AIR.M1.CARGO"]
            ], t["04"] = [
                A["AIR.M1.FIGHTER"]
            ], t["05"] = [
                A["AIR.M1.INTERCEPTOR"]
            ], t["06"] = [
                A["AIR.M1.TANKER"]
            ], t["07"] = [
                A["AIR.M1.UTILITY"]
            ], t["08"] = [
                A["AIR.M1.VSTOL"]
            ], t["09"] = [
                A["AIR.M1.PASSENGER"]
            ], t[10] = [
                A["AIR.M1.ULTRA LIGHT"]
            ], t[11] = [
                A["AIR.M1.AIRBORNE COMMAND POST"]
            ], t[12] = [
                A["AIR.M1.AIRBORNE EARLY WARNING"]
            ], t[13] = [
                A["AIR.M1.GOVERNMENT"]
            ], t[14] = [
                A["AIR.M1.MEDEVAC"]
            ], t[15] = [
                A["AIR.M1.ESCORT"]
            ], t[16] = [
                A["AIR.M1.JAMMER / ELECTRONIC COUNTER-MEASURES"]
            ], t[17] = [
                A["AIR.M1.PATROL"]
            ], t[18] = [
                A["AIR.M1.RECONNAISSANCE"]
            ], t[19] = [
                A["AIR.M1.TRAINER"]
            ], t[20] = [
                A["AIR.M1.PHOTOGRAPHIC"]
            ], t[21] = [
                A["AIR.M1.PERSONNEL RECOVERY"]
            ], t[22] = [
                A["AIR.M1.ANTISUBMARINE WARFARE"]
            ], t[23] = [
                A["AIR.M1.COMMUNICATIONS"]
            ], t[24] = [
                A["AIR.M1.ELECTRONIC SUPPORT (ES)"]
            ], t[25] = [
                A["AIR.M1.MINE COUNTERMEASURES"]
            ], t[26] = [
                A["AIR.M1.SEARCH AND RESCUE"]
            ], t[27] = [
                A["AIR.M1.SPECIAL OPERATIONS FORCES"]
            ], t[28] = [
                A["AIR.M1.SURFACE WARFARE"]
            ], t[29] = [
                A["AIR.M1.VIP"]
            ], t[30] = [
                A["AIR.M1.COMBAT SEARCH AND RESCUE"]
            ], t[31] = [
                A["AIR.M1.SUPRESSION OF ENEMY AIR DEFENCE"]
            ], t[32] = [
                A["AIR.M1.ANTISURFACE WARFARE"]
            ], t[33] = [
                A["AIR.M1.FIGHTER/BOMBER"]
            ], t[34] = [
                A["AIR.M1.INTENSIVE CARE"]
            ], t[35] = [
                A["AIR.M1.ELECTRONIC ATTACK (EA)"]
            ], t[36] = [
                A["AIR.M1.MULTIMISSION"]
            ], t[37] = [
                A["AIR.M1.HIJACKING"]
            ], t[38] = [
                A["AIR.M1.ASW HELO-LAMPS"]
            ], t[39] = [
                A["AIR.M1.ASW HELO - SH-60R"]
            ], t[40] = [
                A["AIR.M1.HIJACKER"]
            ], t[41] = [
                A["AIR.M1.CYBERSPACE"]
            ], E["01"] = [
                A["AIR.M2.HEAVY"]
            ], E["02"] = [
                A["AIR.M2.MEDIUM"]
            ], E["03"] = [
                A["AIR.M2.LIGHT"]
            ], E["04"] = [
                A["AIR.M2.BOOM-ONLY"]
            ], E["05"] = [
                A["AIR.M2.DROUGE-ONLY"]
            ], E["06"] = [
                A["AIR.M2.BOOM AND DROUGE"]
            ], E["07"] = [
                A["AIR.M2.CLOSE RANGE"]
            ], E["08"] = [
                A["AIR.M2.SHORT RANGE"]
            ], E["09"] = [
                A["AIR.M2.MEDIUM RANGE"]
            ], E[10] = [
                A["AIR.M2.LONG RANGE"]
            ], E[11] = [
                A["AIR.M2.DOWNLINKED"]
            ], E[12] = [
                A["AIR.M2.CYBERSPACE"]
            ]);
        }
    }, g = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: P,
        icons: function(I, t, E, R, e, A, C) {
            "02" == e && (I[11e4] = [
                A["AIR.MISSILE.ICON"]
            ], t["01"] = [
                A["AIR.MISSILE.M1.AIR"]
            ], t["02"] = [
                A["AIR.MISSILE.M1.SURFACE"]
            ], t["03"] = [
                A["AIR.MISSILE.M1.SUBSURFACE"]
            ], t["04"] = [
                A["AIR.MISSILE.M1.SPACE"]
            ], t["05"] = [
                A["AIR.MISSILE.M1.ANTI-BALLISTIC"]
            ], t["06"] = [
                A["AIR.MISSILE.M1.BALLISTIC"]
            ], t["07"] = [
                A["AIR.MISSILE.M1.CRUISE"]
            ], t["08"] = [
                A["AIR.MISSILE.M1.INTERCEPTOR"]
            ], E["01"] = [
                A["AIR.MISSILE.M2.AIR"]
            ], E["02"] = [
                A["AIR.MISSILE.M2.SURFACE"]
            ], E["03"] = [
                A["AIR.MISSILE.M2.SUBSURFACE"]
            ], E["04"] = [
                A["AIR.MISSILE.M2.SPACE"]
            ], E["05"] = [
                A["AIR.MISSILE.M2.LAUNCHED"]
            ], E["06"] = [
                A["AIR.MISSILE.M2.MISSILE"]
            ], E["07"] = [
                A["AIR.MISSILE.M2.PATRIOT"]
            ], E["08"] = [
                A["AIR.MISSILE.M2.STANDARD MISSILE - 2 (SM-2)"]
            ], E["09"] = [
                A["AIR.MISSILE.M2.STANDARD MISSILE - 6 (SM-6)"]
            ], E[10] = [
                A["AIR.MISSILE.M2.EVOLVED SEA SPARROW MISSILE (ESSM)"]
            ], E[11] = [
                A["AIR.MISSILE.M2.ROLLING AIRFRAME MISSILE (RAM)"]
            ], E[12] = [
                A["AIR.MISSILE.M2.SHORT RANGE"]
            ], E[13] = [
                A["AIR.MISSILE.M2.MEDIUM RANGE"]
            ], E[14] = [
                A["AIR.MISSILE.M2.INTERMEDIATE RANGE"]
            ], E[15] = [
                A["AIR.MISSILE.M2.LONG RANGE"]
            ], E[16] = [
                A["AIR.MISSILE.M2.INTERCONTINENTAL"]
            ]);
        }
    }, b = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: i,
        icons: function(I, t, E, R, e, A, C) {
            "05" == e && (I[11e4] = [
                A["SP.I.MILITARY"]
            ], I[110100] = [
                A["SP.I.SPACE VEHICLE"]
            ], I[110200] = [
                A["SP.I.RE-ENTRY VEHICLE"]
            ], I[110300] = [
                A["SPACE.PLANET LANDER"]
            ], I[110400] = [
                A["SP.I.ORBITER SHUTTLE"]
            ], I[110500] = [
                A["SP.I.CAPSULE"]
            ], I[110600] = [
                A["SP.I.SATELLITE, GENERAL"]
            ], I[110700] = [
                A["SP.I.SATELLITE"]
            ], I[110800] = [
                A["SP.I.ANTISATELLITE WEAPON"]
            ], I[110900] = [
                A["SP.I.ASTRONOMICAL SATELLITE"]
            ], I[111e3] = [
                A["SP.I.BIOSATELLITE"]
            ], I[111100] = [
                A["SP.I.COMMUNICATIONS SATELLITE"]
            ], I[111200] = [
                A["SP.I.EARTH OBSERVATION SATELLITE"]
            ], I[111300] = [
                A["SP.I.MINIATURIZED SATELLITE"]
            ], I[111400] = [
                A["SP.I.NAVIGATIONAL SATELLITE"]
            ], I[111500] = [
                A["SP.I.RECONNAISSANCE SATELLITE"]
            ], I[111600] = [
                A["SP.I.SPACE STATION"]
            ], I[111700] = [
                A["SP.I.TETHERED SATELLITE"]
            ], I[111800] = [
                A["SP.I.WEATHER SATELLITE"]
            ], I[111900] = [
                A["SP.I.SPACE LAUNCH VEHICLE"]
            ], I[12e4] = [
                A["SP.I.CIVILIAN"]
            ], I[120100] = [
                A["SP.I.CIVILIAN ORBITER SHUTTLE"]
            ], I[120200] = [
                A["SP.I.CIVILIAN CAPSULE"]
            ], I[120300] = [
                A["SP.I.CIVILIAN SATELLITE"]
            ], I[120400] = [
                A["SP.I.CIVILIAN ASTRONOMICAL SATELLITE"]
            ], I[120500] = [
                A["SP.I.CIVILIAN BIOSATELLITE"]
            ], I[120600] = [
                A["SP.I.CIVILIAN COMMUNICATIONS SATELLITE"]
            ], I[120700] = [
                A["SP.I.CIVILIAN EARTH OBSERVATION SATELLITE"]
            ], I[120800] = [
                A["SP.I.CIVILIAN MINIATURIZED SATELLITE"]
            ], I[120900] = [
                A["SP.I.CIVILIAN NAVIGATIONAL SATELLITE"]
            ], I[121e3] = [
                A["SP.I.CIVILIAN SPACE STATION"]
            ], I[121100] = [
                A["SP.I.CIVILIAN TETHERED SATELLITE"]
            ], I[121200] = [
                A["SP.I.CIVILIAN WEATHER SATELLITE"]
            ], I[13e4] = [
                A["SP.I.MANUAL TRACK"]
            ], t["01"] = [
                A["SP.M1.LOW EARTH ORBIT (LEO)"]
            ], t["02"] = [
                A["SP.M1.MEDIUM EARTH ORBIT (MEO)"]
            ], t["03"] = [
                A["SP.M1.HIGH EARTH ORBIT (HEO)"]
            ], t["04"] = [
                A["SP.M1.GEOSYNCHRONOUS ORBIT (GSO)"]
            ], t["05"] = [
                A["SP.M1.GEOSTATIONARY ORBIT (GO)"]
            ], t["06"] = [
                A["SP.M1.MOLNIYA ORBIT (MO)"]
            ], t["07"] = [
                A["SP.M1.CYBERSPACE"]
            ], E["01"] = [
                A["SP.M2.OPTICAL"]
            ], E["02"] = [
                A["SP.M2.INFRARED"]
            ], E["03"] = [
                A["SP.M2.RADAR"]
            ], E["04"] = [
                A["SP.M2.SIGNALS INTELLIGENCE (SIGINT)"]
            ], E["05"] = [
                A["SP.M2.CYBERSPACE"]
            ]);
        }
    }, K = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: i,
        icons: function(I, t, E, R, e, A, C) {
            "06" == e && (I[11e4] = [
                A["SPACE.MISSILE.ICON"]
            ], t["01"] = [
                A["SPACE.MISSILE.M1.BALLISTIC"]
            ], t["02"] = [
                A["SPACE.MISSILE.M1.SPACE"]
            ], t["03"] = [
                A["SPACE.MISSILE.M1.INTERCEPTOR"]
            ], E["01"] = [
                A["SPACE.MISSILE.M2.SHORT RANGE"]
            ], E["02"] = [
                A["SPACE.MISSILE.M2.MEDIUM RANGE"]
            ], E["03"] = [
                A["SPACE.MISSILE.M2.INTERMEDIATE RANGE"]
            ], E["04"] = [
                A["SPACE.MISSILE.M2.LONG RANGE"]
            ], E["05"] = [
                A["SPACE.MISSILE.M2.INTERCONTINENTAL"]
            ], E["06"] = [
                A["SPACE.MISSILE.M2.ARROW"]
            ], E["07"] = [
                A["SPACE.MISSILE.M2.GROUND-BASED INTERCEPTOR (GBI)"]
            ], E["08"] = [
                A["SPACE.MISSILE.M2.PATRIOT"]
            ], E["09"] = [
                A["SPACE.MISSILE.M2.STANDARD MISSILE - TERMINAL PHASE (SM-T)"]
            ], E[10] = [
                A["SPACE.MISSILE.M2.STANDARD MISSILE - 3 (SM-3)"]
            ], E[11] = [
                A["SPACE.MISSILE.M2.TERMINAL HIGH-ALTITUDE AREA DEFENSE (THAAD)"]
            ], E[12] = [
                A["SPACE.MISSILE.M2.SPACE"]
            ], E[13] = [
                A["SPACE.MISSILE.M2.CLOSE RANGE"]
            ], E[14] = [
                A["SPACE.MISSILE.M2.DEBRIS"]
            ], E[15] = [
                A["SPACE.MISSILE.M2.UNKNOWN"]
            ]);
        }
    }, X = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: c,
        icons: function(I, t, E, R, e, A, C) {
            "10" == e && (I[11e4] = [
                A["GR.IC.COMMAND AND CONTROL"]
            ], I[110100] = [
                A["GR.IC.FF.BROADCAST TRANSMITTER ANTENNA"]
            ], I[110200] = [
                A["GR.IC.CIVIL AFFAIRS"]
            ], I[110300] = [
                A["GR.IC.CIVIL-MILITARY-COOPERATION"]
            ], I[110400] = [
                A["GR.IC.INFORMATION OPERATIONS"]
            ], I[110500] = [
                A["GR.IC.LIAISON"]
            ], I[110501] = [
                A["GR.IC.LIAISON"],
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[110600] = [
                A["GR.IC.MILITARY INFORMATION SUPPORT OPERATIONS (MISO)"]
            ], I[110601] = [
                A["GR.IC.MILITARY INFORMATION SUPPORT OPERATIONS (MISO)"],
                A["GR.IC.FF.BROADCAST TRANSMITTER ANTENNA"]
            ], I[110700] = [
                A["GR.IC.RADIO"]
            ], I[110800] = [
                A["GR.IC.RADIO RELAY"]
            ], I[110900] = [
                A["GR.IC.RADIO TELETYPE CENTRE"]
            ], I[111e3] = [
                A["GR.IC.FF.SIGNAL"]
            ], I[111001] = [
                A["GR.IC.FF.SIGNAL"],
                A["GR.IC.RADIO"]
            ], I[111002] = [
                A["GR.IC.FF.SIGNAL"],
                A["GR.IC.RADIO RELAY"]
            ], I[111003] = [
                A["GR.IC.FF.SIGNAL"],
                A["GR.IC.RADIO TELETYPE CENTRE"]
            ], I[111004] = [
                A["GR.IC.FF.SIGNAL"],
                A["GR.I.FF.SATELLITE"]
            ], I[111005] = [
                A["GR.IC.FF.SIGNAL"],
                A["GR.IC.VIDEO IMAGERY"]
            ], I[111100] = [
                A["GR.I.FF.SATELLITE"]
            ], I[111200] = [
                A["GR.IC.VIDEO IMAGERY"]
            ], I[111300] = [
                A["GR.IC.SPACE"]
            ], I[111400] = [
                A["GR.IC.SPECIAL TROOPS"]
            ], I[12e4] = [], I[120100] = [
                A["GR.IC.FF.AIR ASSAULT WITH ORGANIC LIFT"]
            ], I[120200] = [
                A["GR.IC.AIR TRAFFIC SERVICES"]
            ], I[120300] = [
                A["GR.IC.FF.AMPHIBIOUS"]
            ], I[120400] = [
                A["GR.IC.FF.ANTITANK/ANTIARMOUR"]
            ], I[120401] = [
                A["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                A["GR.IC.ARMOUR"]
            ], I[120402] = [
                A["GR.IC.FF.ANTITANK/ANTIARMOUR"],
                A["GR.IC.FF.MOTORIZED"]
            ], I[120500] = [
                A["GR.IC.ARMOUR"]
            ], I[120501] = [
                A["GR.IC.ARMOUR"],
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[120502] = [
                A["GR.IC.ARMOUR"],
                A["GR.IC.FF.AMPHIBIOUS"]
            ], I[120600] = [
                A["GR.IC.AVIATION ROTARY WING"]
            ], I[120601] = [
                A["GR.IC.AVIATION ROTARY WING"],
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[120700] = [
                A["GR.IC.AVIATION COMPOSITE"]
            ], I[120800] = [
                A["GR.IC.AVIATION FIXED WING"]
            ], I[120801] = [
                A["GR.IC.AVIATION FIXED WING"],
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[120900] = [
                A["GR.IC.COMBAT"]
            ], I[121e3] = [
                A["GR.IC.COMBINED ARMS"]
            ], I[121100] = [
                A["GR.IC.FF.INFANTRY"]
            ], I[121101] = [
                A["GR.IC.FF.INFANTRY"],
                A["GR.IC.FF.AMPHIBIOUS"]
            ], I[121102] = [
                A["GR.IC.FF.INFANTRY"],
                A["GR.IC.ARMOUR"]
            ], I[121103] = [
                A["GR.IC.FF.INFANTRY"],
                A["GR.IC.FF.MAIN GUN SYSTEM"]
            ], I[121104] = [
                A["GR.IC.FF.INFANTRY"],
                A["GR.IC.FF.MOTORIZED"]
            ], I[121105] = [
                A["GR.IC.FF.INFANTRY"],
                A["GR.IC.ARMOUR"],
                A["GR.IC.FF.MAIN GUN SYSTEM"]
            ], I[121106] = [
                A["GR.IC.FF.MAIN GUN SYSTEM"]
            ], I[121200] = [
                A["GR.IC.OBSERVER/OBSERVATION"]
            ], I[121300] = [
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[121301] = [
                A["GR.IC.FF.RECONNAISSANCE"],
                A["GR.IC.SURVEILLANCE"]
            ], I[121302] = [
                A["GR.IC.FF.RECONNAISSANCE"],
                A["GR.IC.FF.AMPHIBIOUS"]
            ], I[121303] = [
                A["GR.IC.FF.RECONNAISSANCE"],
                A["GR.IC.FF.MOTORIZED"]
            ], I[121400] = [
                A["GR.IC.SEA-AIR-LAND"]
            ], I[121500] = [
                A["GR.IC.SNIPER"]
            ], I[121600] = [
                A["GR.IC.SURVEILLANCE"]
            ], I[121700] = [
                A["GR.IC.SPECIAL FORCES"]
            ], I[121800] = [
                A["GR.IC.SPECIAL OPERATIONS FORCES"]
            ], I[121801] = [
                A["GR.IC.FIXED WING MISO"]
            ], I[121802] = [
                A["GR.IC.SPECIAL OPERATIONS FORCES"],
                A["GR.IC.FF.INFANTRY"]
            ], I[121803] = [
                A["GR.IC.COMBATANT"],
                A["GR.M1.SPECIAL OPERATIONS FORCES (SOF)"]
            ], I[121804] = [
                A["GR.IC.SUBMARINE NUCLEAR PROPULSION"],
                A["GR.M1.SPECIAL OPERATIONS FORCES (SOF)"]
            ], I[121805] = [
                A["SOF.IC.UNDERWATER DEMOLITION TEAM"]
            ], I[121900] = [
                A["GR.IC.UNMANNED SYSTEMS"]
            ], I[122e3] = [
                A["GR.IC.RANGER"]
            ], I[13e4] = [], I[130100] = [
                A["GR.IC.FF.AIR DEFENCE"]
            ], I[130101] = [
                A["GR.IC.FF.AIR DEFENCE"],
                A["GR.IC.FF.MAIN GUN SYSTEM"]
            ], I[130102] = [
                A["GR.IC.FF.AIR DEFENCE"],
                A["GR.IC.AIR DEFENSE MISSILE"]
            ], I[130103] = [
                A["GR.IC.FF.AIR DEFENCE"],
                A["GR.IC.AIR AND MISSILE DEFENSE"]
            ], I[130200] = [
                A["GR.IC.FIELD ARTILLERY"],
                A["GR.IC.FF.RECONNAISSANCE"],
                A["GR.IC.AVIATION ROTARY WING"],
                A["GR.M1.NAVAL"]
            ], I[130300] = [
                A["GR.IC.FIELD ARTILLERY"]
            ], I[130301] = [
                s._scale(.8, A["GR.IC.FIELD ARTILLERY"]),
                A["GR.IC.ARMOUR"]
            ], I[130302] = [
                s._scale(.8, A["GR.IC.FIELD ARTILLERY"]),
                A["GR.IC.ARMOUR"],
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[130303] = [
                s._scale(.8, A["GR.IC.FIELD ARTILLERY"]),
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[130400] = [
                A["GR.IC.FIELD ARTILLERY OBSERVER"]
            ], I[130500] = [
                A["GR.IC.JOINT FIRE SUPPORT"]
            ], I[130600] = [
                A["GR.IC.METEOROLOGICAL"]
            ], I[130700] = [
                A["GR.IC.MISSILE"]
            ], I[130800] = [
                A["GR.IC.MORTAR"]
            ], I[130801] = [
                A["GR.IC.MORTAR"],
                A["GR.M2.TRACKED"]
            ], I[130802] = [
                A["GR.IC.MORTAR"],
                A["GR.M2.TRUCK"]
            ], I[130803] = [
                A["GR.IC.MORTAR"],
                A["GR.M2.TOWED"]
            ], I[130900] = [
                A["GR.IC.SURVEY"]
            ], I[14e4] = [], I[140100] = [
                A["GR.IC.CBRN"]
            ], I[140101] = [
                A["GR.IC.CBRN"],
                A["GR.IC.ARMOUR"]
            ], I[140102] = [
                A["GR.IC.CBRN"],
                A["GR.IC.FF.MOTORIZED"]
            ], I[140103] = [
                A["GR.IC.CBRN"],
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[140104] = [
                A["GR.IC.CBRN"],
                A["GR.IC.FF.RECONNAISSANCE"],
                A["GR.IC.ARMOUR"]
            ], I[140105] = [
                A["GR.IC.CBRN"],
                A["GR.IC.FF.RECONNAISSANCE"],
                A["GR.IC.FF.MOTORIZED"]
            ], I[140106] = [
                A["GR.IC.CBRN"],
                A["GR.CHEMICAL, BIOLOGICAL, RADIOLOGICAL, NUCLEAR, AND HIGH-YIELD EXPLOSIVES"]
            ], I[140200] = [
                A["GR.IC.COMBAT SUPPORT (MANOEUVRE ENHANCEMENT)"]
            ], I[140300] = [
                A["GR.IC.CRIMINAL INVESTIGATION DIVISION"]
            ], I[140400] = [
                A["GR.IC.DIVER, CIVILIAN"]
            ], I[140500] = [
                A["GR.IC.DOG"]
            ], I[140600] = [
                A["GR.IC.DRILLING"]
            ], I[140700] = [
                A["GR.IC.ENGINEER"]
            ], I[140701] = [
                A["GR.IC.ENGINEER MECHANIZED"]
            ], I[140702] = [
                A["GR.IC.ENGINEER"],
                A["GR.IC.FF.MOTORIZED"]
            ], I[140703] = [
                A["GR.IC.ENGINEER"],
                A["GR.IC.FF.RECONNAISSANCE"]
            ], I[140800] = [
                A["GR.IC.EXPLOSIVE ORDNANCE DISPOSAL"]
            ], I[140900] = [
                A["GR.IC.FIELD CAMP CONSTRUCTION"]
            ], I[141e3] = [
                A["GR.IC.FIRE PROTECTION"]
            ], I[141100] = [
                A["GR.IC.GEOSPATIAL SUPPORT"]
            ], I[141200] = [
                A["GR.IC.MILITARY POLICE"]
            ], I[141300] = [
                A["GR.IC.MINE"]
            ], I[141400] = [
                A["GR.IC.MINE CLEARING"]
            ], I[141500] = [
                A["GR.IC.MINE LAUNCHING"]
            ], I[141600] = [
                A["GR.IC.MINE LAYING"]
            ], I[141700] = [
                A["GR.IC.SECURITY"]
            ], I[141701] = [
                A["GR.IC.SECURITY"],
                A["GR.IC.ARMOUR"]
            ], I[141702] = [
                A["GR.IC.SECURITY"],
                A["GR.IC.FF.MOTORIZED"]
            ], I[141800] = [
                A["GR.IC.SEARCH AND RESCUE"]
            ], I[141900] = [
                A["GR.IC.SECURITY POLICE (AIR)"]
            ], I[142e3] = [
                A["GR.IC.SHORE PATROL"]
            ], I[142100] = [
                A["GR.IC.TOPOGRAPHIC"]
            ], I[142200] = [
                A["GR.IC.AIR AND MISSILE DEFENSE"]
            ], I[15e4] = [], I[150100] = [
                A["GR.IC.FF.ANALYSIS"]
            ], I[150200] = [
                A["GR.IC.COUNTER-INTELLIGENCE"]
            ], I[150300] = [
                A["GR.IC.FF.DIRECTION FINDING"]
            ], I[150400] = [
                A["GR.IC.ELECTRONIC RANGING"]
            ], I[150500] = [
                A["GR.IC.ELECTRONIC WARFARE"]
            ], I[150501] = [
                A["GR.IC.ELECTRONIC WARFARE"],
                A["GR.IC.FF.ANALYSIS"]
            ], I[150502] = [
                A["GR.IC.ELECTRONIC WARFARE"],
                A["GR.IC.FF.DIRECTION FINDING"]
            ], I[150503] = [
                A["GR.IC.ELECTRONIC WARFARE"],
                A["GR.IC.FF.INTERCEPT"]
            ], I[150504] = [
                A["GR.IC.ELECTRONIC WARFARE"],
                A["GR.IC.FF.JAMMING"]
            ], I[150505] = [
                A["GR.IC.ELECTRONIC WARFARE"],
                A["GR.IC.FF.SEARCH"]
            ], I[150600] = [
                A["GR.IC.FF.INTERCEPT"]
            ], I[150700] = [
                A["GR.IC.INTERROGATION"]
            ], I[150800] = [
                A["GR.IC.FF.JAMMING"]
            ], I[150900] = [
                A["GR.IC.JOINT INTELLIGENCE CENTRE"]
            ], I[151e3] = [
                A["GR.IC.MILITARY INTELLIGENCE"]
            ], I[151100] = [
                A["GR.IC.FF.SEARCH"]
            ], I[151200] = [
                A["GR.IC.SENSOR"]
            ], I[151300] = [
                A["GR.IC.MILITARY HISTORY"]
            ], I[16e4] = [
                A["GR.IC.SUSTAINMENT"]
            ], I[160100] = [
                A["GR.IC.ADMINISTRATIVE"]
            ], I[160200] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS ALL"]
            ], I[160300] = [
                A["GR.IC.TRANSPORTATION"],
                A["GR.IC.AIRPORT OF DEBARKATION"]
            ], I[160400] = [
                A["GR.IC.AMMUNITION"]
            ], I[160500] = [
                A["GR.IC.BAND"]
            ], I[160501] = [
                A["GR.IC.ARMY MUSIC"]
            ], I[160600] = [
                A["GR.IC.COMBAT SERVICE SUPPORT"]
            ], I[160700] = [
                A["GR.IC.FINANCE"]
            ], I[160800] = [
                A["GR.IC.JUDGE ADVOCATE GENERAL"]
            ], I[160900] = [
                A["GR.IC.LABOUR"]
            ], I[161e3] = [
                A["GR.IC.LAUNDRY/BATH"]
            ], I[161100] = [
                A["GR.IC.MAINTENANCE"]
            ], I[161200] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.MATERIEL"]
            ], I[161300] = [
                A["GR.IC.FF.MEDICAL"]
            ], I[161400] = [
                A["GR.IC.FF.MEDICAL TREATMENT FACILITY"]
            ], I[161500] = [
                A["GR.IC.MORALE, WELFARE, AND RECREATION"]
            ], I[161600] = [
                A["GR.IC.MORTUARY AFFAIRS"]
            ], I[161700] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS MULTIPLE"]
            ], I[161800] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.NATO SUPPLY CLASS I"]
            ], I[161900] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.NATO SUPPLY CLASS II"]
            ], I[162e3] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS III"]
            ], I[162100] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.NATO SUPPLY CLASS IV"]
            ], I[162200] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS V"]
            ], I[162300] = [
                A["GR.IC.ORDNANCE"]
            ], I[162400] = [
                A["GR.IC.PERSONNEL SERVICES"]
            ], I[162500] = [
                A["GR.IC.PETROLEUM OIL LUBRICANTS"]
            ], I[162600] = [
                A["GR.IC.PIPELINE"]
            ], I[162700] = [
                A["GR.IC.POSTAL"]
            ], I[162800] = [
                A["GR.IC.PUBLIC AFFAIRS"]
            ], I[162900] = [
                A["GR.IC.QUARTERMASTER"]
            ], I[163e3] = [
                A["GR.IC.RAILHEAD"]
            ], I[163100] = [
                A["GR.IC.RELIGIOUS SUPPORT"]
            ], I[163200] = [
                A["GR.IC.REPLACEMENT HOLDING UNIT"]
            ], I[163300] = [
                A["GR.IC.SEAPORT OF DEBARKATION"]
            ], I[163400] = [
                A["GR.IC.FF.SUPPLY"]
            ], I[163500] = [
                A["GR.IC.JOINT INFORMATION BUREAU"]
            ], I[163600] = [
                A["GR.IC.TRANSPORTATION"]
            ], I[163601] = [
                A["GR.IC.TRANSPORTATION"],
                A["GR.IC.FLOATING CRAFT"]
            ], I[163700] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS I"]
            ], I[163800] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS II"]
            ], I[163900] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS III"]
            ], I[164e3] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS IV"]
            ], I[164100] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS V"]
            ], I[164200] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS VI"]
            ], I[164300] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS VII"]
            ], I[164400] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS VIII"]
            ], I[164500] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS IX"]
            ], I[164600] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.CLASS X"]
            ], I[164700] = [
                A["GR.IC.WATER"]
            ], I[164800] = [
                A["GR.IC.WATER PURIFICATION"]
            ], I[164900] = [
                A["GR.IC.PUBLIC AFFAIRS BROADCAST"]
            ], I[165e3] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.FF.NATO SUPPLY CLASS ALL"]
            ], I[165100] = [
                A["GR.IC.INTERPRETER/TRANSLATOR"]
            ], I[165200] = [
                A["GR.IC.SUPPORT"]
            ], I[165300] = [
                A["GR.IC.ARMY FIELD SUPPORT"]
            ], I[165400] = [
                A["GR.IC.CONTRACTING SERVICES"]
            ], I[165500] = [
                A["GR.IC.PARACHUTE RIGGER"]
            ], I[17e4] = [], I[170100] = [
                A["GR.IC.NAVAL"]
            ], I[18e4] = [], I[180100] = [
                A["GR.IC.ALLIED COMMAND EUROPE RAPID REACTION CORPS (ARRC)"]
            ], I[180200] = [
                A["GR.IC.ALLIED COMMAND OPERATIONS"]
            ], I[180300] = [
                A["GR.IC.INTERNATIONAL SECURITY ASSISTANCE FORCE (ISAF)"]
            ], I[180400] = [
                A["GR.IC.MULTINATIONAL (MN)"]
            ], I[19e4] = [
                A["GR.IC.FF.EMERGENCY OPERATION"]
            ], I[2e5] = [
                A["GR.IC.FF.LAW ENFORCEMENT"]
            ], I[200100] = [
                A["GR.IC.BUREAU OF ALCOHOL, TOBACCO, FIREARMS AND EXPLOSIVES (ATF) (DEPARTMENT OF JUSTICE)"]
            ], I[200200] = [
                A["GR.IC.FF.BORDER PATROL"]
            ], I[200300] = [
                A["GR.IC.FF.CUSTOMS SERVICE"]
            ], I[200400] = [
                A["GR.IC.DRUG ENFORCEMENT AGENCY (DEA)"]
            ], I[200500] = [
                A["GR.IC.FF.DEPARTMENT OF JUSTICE (DOJ)"]
            ], I[200600] = [
                A["GR.IC.FEDERAL BUREAU OF INVESTIGATION (FBI)"]
            ], I[200700] = [
                A["GR.IC.LAW ENFORCEMENT"]
            ], I[200800] = [
                A["GR.IC.FF.PRISON"]
            ], I[200900] = [
                A["GR.IC.UNITED STATES SECRET SERVICE(TREAS) (USSS)"]
            ], I[201e3] = [
                A["GR.IC.TRANSPORTATION SECURITY AGENCY (TSA)"]
            ], I[201100] = [
                A["GR.IC.LAW ENFORCEMENT VESSEL"]
            ], I[201200] = [
                A["GR.IC.FF.US MARSHALS SERVICE"]
            ], I[201300] = [
                A["ST.IC.INTERNAL SECURITY FORCE"]
            ], t["01"] = [
                C ? A["GR.M1.TACTICAL SATELLITE COMMUNICATIONS"] : A["GR.M1.AIRMOBILE/AIR ASSAULT"]
            ], t["02"] = [
                A["GR.M1.AREA"]
            ], t["03"] = [
                A["GR.M1.ATTACK"]
            ], t["04"] = [
                A["GR.M1.BIOLOGICAL"]
            ], t["05"] = [
                A["GR.M1.BORDER"]
            ], t["06"] = [
                A["GR.M1.BRIDGING"]
            ], t["07"] = [
                A["GR.M1.CHEMICAL"]
            ], t["08"] = [
                A["GR.M1.CLOSE PROTECTION"]
            ], t["09"] = [
                A["GR.M1.COMBAT"]
            ], t[10] = [
                A["GR.M1.COMMAND AND CONTROL"]
            ], t[11] = [
                A["GR.M1.COMMUNICATIONS CONTINGENCY PACKAGE"]
            ], t[12] = [
                A["GR.M1.CONSTRUCTION"]
            ], t[13] = [
                A["GR.M1.CROSS CULTURAL COMMUNICATION"]
            ], t[14] = [
                A["GR.M1.CROWD AND RIOT CONTROL"]
            ], t[15] = [
                A["GR.M1.DECONTAMINATION"]
            ], t[16] = [
                A["GR.M1.DETENTION"]
            ], t[17] = [
                A["GR.M1.DIRECT COMMUNICATIONS"]
            ], t[18] = [
                A["GR.M1.DIVING"]
            ], t[19] = [
                A["GR.M1.DIVISION"]
            ], t[20] = [
                A["GR.M1.DOG"]
            ], t[21] = [
                A["GR.M1.DRILLING"]
            ], t[22] = [
                A["GR.M1.ELECTRO-OPTICAL"]
            ], t[23] = [
                A["GR.M1.ENHANCED"]
            ], t[24] = [
                A["GR.M1.EXPLOSIVE ORDNANCE DISPOSAL"]
            ], t[25] = [
                A["GR.M1.FIRE DIRECTION CENTRE"]
            ], t[26] = [
                A["GR.M1.FORCE"]
            ], t[27] = [
                A["GR.M1.FORWARD"]
            ], t[28] = [
                A["GR.M1.GROUND STATION MODULE"]
            ], t[29] = [
                A["GR.M1.LANDING SUPPORT"]
            ], t[30] = [
                A["GR.M1.LARGE EXTENSION NODE"]
            ], t[31] = [
                A["GR.M1.MAINTENANCE"]
            ], t[32] = [
                A["GR.M1.METEOROLOGICAL"]
            ], t[33] = [
                A["GR.M1.MINE COUNTERMEASURE"]
            ], t[34] = [
                A["GR.M1.MISSILE"]
            ], t[35] = [
                A["GR.M1.(MOBILE) ADVISOR AND SUPPORT"]
            ], t[36] = [
                A["GR.M1.MOBILE SUBSCRIBER EQUIPMENT"]
            ], t[37] = [
                A["GR.M1.MOBILITY SUPPORT"]
            ], t[38] = [
                A["GR.M1.MOVEMENT CONTROL CENTRE"]
            ], t[39] = [
                A["GR.M1.MULTINATIONAL"]
            ], t[40] = [
                A["GR.M1.MULTINATIONAL SPECIALIZED UNIT"]
            ], t[41] = [
                A["GR.M1.MULTIPLE ROCKET LAUNCHER"]
            ], t[42] = [
                A["GR.M1.NATO MEDICAL ROLE 1"]
            ], t[43] = [
                A["GR.M1.NATO MEDICAL ROLE 2"]
            ], t[44] = [
                A["GR.M1.NATO MEDICAL ROLE 3"]
            ], t[45] = [
                A["GR.M1.NATO MEDICAL ROLE 4"]
            ], t[46] = [
                A["GR.M1.NAVAL"]
            ], t[47] = [
                C ? A["GR.M1.UNMANNED AERIAL VEHICLE"] : A["GR.M1.NODE CENTRE"]
            ], t[48] = [
                A["GR.M1.NUCLEAR"]
            ], t[49] = [
                A["GR.M1.OPERATIONS"]
            ], t[50] = [
                A["GR.M1.RADAR"]
            ], t[51] = [
                A["GR.M1.RADIO FREQUENCY IDENTIFICATION (RFID) INTERROGATOR/ SENSOR"]
            ], t[52] = [
                A["GR.M1.RADIOLOGICAL"]
            ], t[53] = [
                A["GR.M1.SEARCH AND RESCUE"]
            ], t[54] = [
                A["GR.M1.SECURITY"]
            ], t[55] = [
                A["GR.M1.SENSOR"]
            ], t[56] = [
                C ? A["GR.M1.WEAPON"] : A["GR.M1.SENSOR CONTROL MODULE"]
            ], t[57] = [
                A["GR.M1.SIGNALS INTELLIGENCE"]
            ], t[58] = [
                C ? A["GR.M1.ARMORED"] : A["GR.M1.SINGLE SHELTER SWITCH"]
            ], t[59] = [
                A["GR.M1.SINGLE ROCKET LAUNCHER"]
            ], t[60] = [
                A["GR.M1.SMOKE"]
            ], t[61] = [
                A["GR.M1.SNIPER"]
            ], t[62] = [
                A["GR.M1.SOUND RANGING"]
            ], t[63] = [
                A["GR.M1.SPECIAL OPERATIONS FORCES (SOF)"]
            ], t[64] = [
                A["GR.M1.SPECIAL WEAPONS AND TACTICS"]
            ], t[65] = [
                A["GR.M1.SURVEY"]
            ], t[66] = [
                A["GR.M1.TACTICAL EXPLOITATION"]
            ], t[67] = [
                A["GR.M1.TARGET ACQUISITION"]
            ], t[68] = [
                A["GR.M1.TOPOGRAPHIC"]
            ], t[69] = [
                A["GR.M1.UTILITY"]
            ], t[70] = [
                A["GR.M1.VIDEO IMAGERY"]
            ], t[71] = [
                C ? A["GR.M1.MOBILITY ASSAULT"] : A["GR.M1.ACCIDENT"]
            ], t[72] = [
                C ? A["GR.M1.AMPHIBIOUS WARFARE SHIP "] : A["GR.M1.OTHER"]
            ], t[73] = [
                C ? A["GR.M1.LOAD HANDLING SYSTEM"] : A["GR.M1.CIVILIAN"]
            ], t[74] = [
                C ? A["GR.M1.PALLETIZED LOAD SYSTEM"] : A["GR.M1.ANTISUBMARINE WARFARE"]
            ], t[75] = [
                A["GR.M1.MEDEVAC"]
            ], t[76] = [
                A["GR.M1.CYBERSPACE"]
            ], t[77] = [
                A["GR.M1.SUPPORT"]
            ], t[78] = [
                A["GR.M1.AVIATION"]
            ], t[79] = [
                A["GR.M1.ROUTE, RECONNAISSANCE, AND CLEARANCE"]
            ], t[80] = [
                A["GR.M1.TILT-ROTOR"]
            ], t[81] = [
                A["GR.M1.COMMAND POST NODE"]
            ], t[82] = [
                A["GR.M1.JOINT NETWORK NODE"]
            ], t[83] = [
                A["GR.M1.RETRANSMISSION SITE"]
            ], t[84] = [
                A["GR.M1.ASSAULT"]
            ], t[85] = [
                A["GR.M1.WEAPONS"]
            ], t[86] = [
                A["GR.M1.CRIMINAL INVESTIGATION DIVISION"]
            ], t[87] = [
                A["GR.M1.DIGITAL"]
            ], t[88] = [
                A["GR.M1.NETWORK OR NETWORK OPERATIONS"]
            ], t[89] = [
                A["GR.M1.AIRFIELD, AERIAL PORT OF DEBARKATION, OR AERIAL PORT OF EMBARKATION"]
            ], t[90] = [
                A["GR.M1.PIPELINE"]
            ], t[91] = [
                A["GR.M1.POSTAL"]
            ], t[92] = [
                A["GR.M1.WATER"]
            ], t[93] = [
                A["GR.M1.INDEPENDENT COMMAND"]
            ], t[94] = [
                A["GR.M1.THEATRE"]
            ], t[95] = [
                A["GR.M1.ARMY"]
            ], t[96] = [
                A["GR.M1.CORPS"]
            ], t[97] = [
                A["GR.M1.BRIGADE"]
            ], t[98] = [
                A["GR.IC.FF.HEADQUARTERS OR HEADQUARTERS ELEMENT"]
            ], E["01"] = [
                A["GR.M2.AIRBORNE"]
            ], E["02"] = [
                A["GR.M2.ARCTIC"]
            ], E["03"] = [
                A["GR.M2.BATTLE DAMAGE REPAIR"]
            ], E["04"] = [
                A["GR.M2.BICYCLE EQUIPPED"]
            ], E["05"] = [
                A["GR.M2.CASUALTY STAGING"]
            ], E["06"] = [
                A["GR.M2.CLEARING"]
            ], E["07"] = [
                A["GR.M2.CLOSE RANGE"]
            ], E["08"] = [
                A["GR.M2.CONTROL"]
            ], E["09"] = [
                A["GR.M2.DECONTAMINATION"]
            ], E[10] = [
                A["GR.M2.DEMOLITION"]
            ], E[11] = [
                A["GR.M2.DENTAL"]
            ], E[12] = [
                A["GR.M2.DIGITAL"]
            ], E[13] = [
                A["GR.M2.ENHANCED POSITION LOCATION REPORTING SYSTEM"]
            ], E[14] = [
                A["GR.M2.EQUIPMENT"]
            ], E[15] = [
                A["GR.M2.HEAVY"]
            ], E[16] = [
                A["GR.M2.HIGH ALTITUDE"]
            ], E[17] = [
                A["GR.M2.INTERMODAL"]
            ], E[18] = [
                A["GR.M2.INTENSIVE CARE"]
            ], E[19] = [
                A["GR.M2.LIGHT"]
            ], E[20] = [
                A["GR.M2.LABORATORY"]
            ], E[21] = [
                A["GR.M2.LAUNCHER"]
            ], E[22] = [
                A["GR.M2.LONG RANGE"]
            ], E[23] = [
                A["GR.M2.LOW ALTITUDE"]
            ], E[24] = [
                A["GR.M2.MEDIUM"]
            ], E[25] = [
                A["GR.M2.MEDIUM ALTITUDE"]
            ], E[26] = [
                A["GR.M2.MEDIUM RANGE"]
            ], E[27] = [
                A["GR.M2.MOUNTAIN"]
            ], E[28] = [
                A["GR.M2.HIGH TO MEDIUM ALTITUDE"]
            ], E[29] = [
                A["GR.M2.MULTI-CHANNEL"]
            ], E[30] = [
                A["GR.M2.OPTICAL"]
            ], E[31] = [
                A["GR.M2.PACK ANIMAL"]
            ], E[32] = [
                A["GR.M2.PATIENT EVACUATION COORDINATION"]
            ], E[33] = [
                A["GR.M2.PREVENTIVE MAINTENANCE"]
            ], E[34] = [
                A["GR.M2.PSYCHOLOGICAL"]
            ], E[35] = [
                A["GR.M2.RADIO RELAY LINE OF SIGHT"]
            ], E[36] = [
                A["GR.M2.RAILROAD"]
            ], E[37] = [
                A["GR.M2.RECOVERY (UNMANNED SYSTEMS)"]
            ], E[38] = [
                A["GR.M2.RECOVERY (MAINTENANCE)"]
            ], E[39] = [
                A["GR.M2.RESCUE COORDINATION CENTRE"]
            ], E[40] = [
                A["GR.M2.RIVERINE"]
            ], E[41] = [
                A["GR.M2.SINGLE CHANNEL"]
            ], E[42] = [
                A["GR.M2.SKI"]
            ], E[43] = [
                A["GR.M2.SHORT RANGE"]
            ], E[44] = [
                A["GR.M2.STRATEGIC"]
            ], E[45] = [
                A["GR.M2.SUPPORT"]
            ], E[46] = [
                A["GR.M2.TACTICAL"]
            ], E[47] = [
                A["GR.M2.TOWED"]
            ], E[48] = [
                A["GR.M2.TROOP"]
            ], E[49] = [
                A["GR.M2.VERTICAL OR SHORT TAKE-OFF AND LANDING "]
            ], E[50] = [
                A["GR.M2.VETERINARY"]
            ], E[51] = [
                A["GR.M2.WHEELED"]
            ], E[52] = [
                A["GR.M2.HIGH TO LOW ALTITUDE"]
            ], E[53] = [
                A["GR.M2.MEDIUM TO LOW ALTITUDE"]
            ], E[54] = [
                A["GR.M2.ATTACK"]
            ], E[55] = [
                A["GR.M2.REFUEL"]
            ], E[56] = [
                A["GR.M2.UTILITY"]
            ], E[57] = [
                A["GR.M2.COMBAT SEARCH AND RESCUE"]
            ], E[58] = [
                A["GR.M2.GUERILLA"]
            ], E[59] = [
                A["GR.M2.AIR ASSAULT"]
            ], E[60] = [
                A["GR.M2.AMPHIBIOUS"]
            ], E[61] = [
                A["GR.M2.VERY HEAVY"]
            ], E[62] = [
                A["GR.IC.FF.SUPPLY"]
            ], E[63] = [
                A["GR.M2.CYBERSPACE"]
            ], E[64] = [
                A["GR.M2.NAVY BARGE, SELF-PROPELLED"]
            ], E[65] = [
                A["GR.M2.NAVY BARGE, NOT SELF-PROPELLED"]
            ], E[66] = [
                A["GR.M2.LAUNCH"]
            ], E[67] = [
                A["GR.M2.LANDING CRAFT"]
            ], E[68] = [
                A["GR.M2.LANDING SHIP"]
            ], E[69] = [
                A["GR.M2.SERVICE CRAFT/YARD"]
            ], E[70] = [
                A["GR.M2.TUG HARBOR"]
            ], E[71] = [
                A["GR.M2.OCEAN GOING TUG BOAT"]
            ], E[72] = [
                A["GR.M2.SURFACE DEPLOYMENT AND DISTRIBUTION COMMAND"]
            ], E[73] = [
                A["GR.M2.NONCOMBATANT GENERIC VESSEL"]
            ], E[74] = [
                A["GR.M2.COMPOSITE"]
            ], E[75] = [
                A["GR.M2.SHELTER"]
            ], E[76] = [
                A["GR.M2.LIGHT AND MEDIUM"]
            ], E[77] = [
                A["GR.M2.SELF-PROPELLED"]
            ], E[78] = [
                A["GR.M2.SECURITY FORCE ASSISTANCE"]
            ]);
        }
    }, w = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: c,
        icons: function(I, t, E, R, e, A, C) {
            "11" == e && (I[11e4] = [
                A["GR.I.CIVILIAN"]
            ], I[110100] = [
                A["GR.IC.ENVIRONMENTAL PROTECTION"]
            ], I[110200] = [
                A["GR.IC.GOVERNMENT ORGANIZATION"]
            ], I[110300] = [
                A["ST.IC.INDIVIDUAL"]
            ], I[110400] = [
                A["ST.IC.GROUP"]
            ], I[110500] = [
                A["ST.IC.KILLING VICTIM"]
            ], I[110600] = [
                A["ST.IC.KILLING VICTIMS"]
            ], I[110700] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.IC.ATTEMPTED CRIMINAL ACTIVITY"]
            ], I[110800] = [
                A["ST.IC.SPY"]
            ], I[110900] = [
                A["ST.IC.COMPOSITE LOSS"]
            ], I[111e3] = [
                A["GR.IC.EMERGENCY MEDICAL OPERATION"]
            ], t["01"] = [
                A["ST.M1.ASSASSINATION"]
            ], t["02"] = [
                A["ST.M1.EXECUTION (WRONGFUL KILLING)"]
            ], t["03"] = [
                A["ST.M1.MURDER"]
            ], t["04"] = [
                A["ST.M1.HIJACKING/HIJACKED"]
            ], t["05"] = [
                A["ST.M1.KIDNAPPING"]
            ], t["06"] = [
                A["ST.M1.PIRACY"]
            ], t["07"] = [
                A["ST.M1.RAPE"]
            ], t["08"] = [
                A["ST.M1.CIVILIAN"]
            ], t["09"] = [
                A["ST.M1.DISPLACED PERSONS, REFUGEES, AND EVACUEES"]
            ], t[10] = [
                A["ST.M1.FOREIGN FIGHTERS"]
            ], t[11] = [
                A["ST.M1.GANG"]
            ], t[12] = [
                A["ST.M1.GOVERNMENT ORGANIZATION"]
            ], t[13] = [
                A["ST.M1.LEADER"]
            ], t[14] = [
                A["ST.M1.NONGOVERNMENTAL ORGANIZATION (NGO)"]
            ], t[15] = [
                A["ST.M1.COERCED/IMPRESSED"]
            ], t[16] = [
                A["ST.M1.WILLING RECRUIT"]
            ], t[17] = [
                A["ST.M1.RELIGIOUS"]
            ], t[18] = [
                A["ST.M1.TARGETED"]
            ], t[19] = [
                A["ST.M1.TERRORIST"]
            ], t[20] = [
                A["ST.M1.SPEAKER"]
            ], t[21] = [
                A["ST.M1.ACCIDENT"]
            ], t[22] = [
                A["ST.M1.COMBAT"]
            ], t[23] = [
                A["ST.M1.OTHER"]
            ], t[24] = [
                A["ST.M1.LOOT"]
            ], t[25] = [
                A["GR.M1.HIJACKER"]
            ], t[26] = [
                A["GR.M1.CYBERSPACE"]
            ], E["01"] = [
                A["ST.M2.LEADER OR LEADERSHIP"]
            ], E["02"] = [
                A["GR.M2.CYBERSPACE"]
            ]);
        }
    }, _ = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: c,
        icons: function(I, t, E, R, e, A, C) {
            if ("15" == e) {
                I[11e4] = [
                    A["GR.EQ.WEAPON"]
                ], I[110100] = [
                    A["GR.EQ.RIFLE"]
                ], I[110101] = [
                    A["GR.EQ.RIFLE"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110102] = [
                    A["GR.EQ.RIFLE"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110103] = [
                    A["GR.EQ.RIFLE"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110200] = [
                    A["GR.EQ.MACHINE GUN"]
                ], I[110201] = [
                    A["GR.EQ.MACHINE GUN"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110202] = [
                    A["GR.EQ.MACHINE GUN"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110203] = [
                    A["GR.EQ.MACHINE GUN"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110300] = [
                    A["GR.EQ.GRENADE LAUNCHER"]
                ], I[110301] = [
                    A["GR.EQ.GRENADE LAUNCHER"],
                    s._translate(0, 20, A["GR.EQ.SHORT RANGE"])
                ], I[110302] = [
                    A["GR.EQ.GRENADE LAUNCHER"],
                    s._translate(0, 20, A["GR.EQ.INTERMEDIATE RANGE"])
                ], I[110303] = [
                    A["GR.EQ.GRENADE LAUNCHER"],
                    s._translate(0, 20, A["GR.EQ.LONG RANGE"])
                ], I[110400] = [
                    A["GR.EQ.FLAME THROWER"]
                ], I[110500] = [
                    A["GR.EQ.AIR DEFENCE GUN"]
                ], I[110501] = [
                    A["GR.EQ.AIR DEFENCE GUN"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110502] = [
                    A["GR.EQ.AIR DEFENCE GUN"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110503] = [
                    A["GR.EQ.AIR DEFENCE GUN"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110600] = [
                    A["GR.EQ.ANTITANK GUN"]
                ], I[110601] = [
                    A["GR.EQ.ANTITANK GUN"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110602] = [
                    A["GR.EQ.ANTITANK GUN"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110603] = [
                    A["GR.EQ.ANTITANK GUN"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110700] = [
                    A["GR.EQ.DIRECT FIRE GUN"]
                ], I[110701] = [
                    A["GR.EQ.DIRECT FIRE GUN"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110702] = [
                    A["GR.EQ.DIRECT FIRE GUN"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110703] = [
                    A["GR.EQ.DIRECT FIRE GUN"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110800] = [
                    A["GR.EQ.RECOILLESS GUN"]
                ], I[110801] = [
                    A["GR.EQ.RECOILLESS GUN"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110802] = [
                    A["GR.EQ.RECOILLESS GUN"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110803] = [
                    A["GR.EQ.RECOILLESS GUN"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110900] = [
                    A["GR.EQ.HOWITZER"]
                ], I[110901] = [
                    A["GR.EQ.HOWITZER"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110902] = [
                    A["GR.EQ.HOWITZER"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110903] = [
                    A["GR.EQ.HOWITZER"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111e3] = [
                    A["GR.EQ.MISSILE LAUNCHER"]
                ], I[111001] = [
                    A["GR.EQ.MISSILE LAUNCHER"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[111002] = [
                    A["GR.EQ.MISSILE LAUNCHER"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[111003] = [
                    A["GR.EQ.MISSILE LAUNCHER"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111100] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"]
                ], I[111101] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[111102] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.SHORT RANGE"],
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"]
                ], I[111103] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.SHORT RANGE"],
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"]
                ], I[111104] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[111105] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.INTERMEDIATE RANGE"],
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"]
                ], I[111106] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.INTERMEDIATE RANGE"],
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"]
                ], I[111107] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111108] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.LONG RANGE"],
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TLAR"]
                ], I[111109] = [
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR"],
                    A["GR.EQ.LONG RANGE"],
                    A["GR.EQ.AIR DEFENCE MISSILE LAUNCHER SURFACE-TO-AIR TELAR"]
                ], I[111200] = [
                    A["GR.EQ.ANTITANK MISSILE LAUNCHER"]
                ], I[111201] = [
                    A["GR.EQ.ANTITANK MISSILE LAUNCHER"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[111202] = [
                    A["GR.EQ.ANTITANK MISSILE LAUNCHER"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[111203] = [
                    A["GR.EQ.ANTITANK MISSILE LAUNCHER"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111300] = [
                    A["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"]
                ], I[111301] = [
                    A["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[111302] = [
                    A["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[111303] = [
                    A["GR.EQ.SURFACE-TO-SURFACE MISSILE LAUNCHER"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111400] = [
                    A["GR.EQ.MORTAR"]
                ], I[111401] = [
                    A["GR.EQ.MORTAR"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[111402] = [
                    A["GR.EQ.MORTAR"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[111403] = [
                    A["GR.EQ.MORTAR"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111500] = [
                    A["GR.EQ.SINGLE ROCKET LAUNCHER"]
                ], I[111501] = [
                    A["GR.EQ.SINGLE ROCKET LAUNCHER"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[111502] = [
                    A["GR.EQ.SINGLE ROCKET LAUNCHER"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[111503] = [
                    A["GR.EQ.SINGLE ROCKET LAUNCHER"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111600] = [
                    A["GR.EQ.MULTIPLE ROCKET LAUNCHER"]
                ], I[111601] = [
                    A["GR.EQ.MULTIPLE ROCKET LAUNCHER"],
                    s._translate(0, 10, A["GR.EQ.SHORT RANGE"])
                ], I[111602] = [
                    A["GR.EQ.MULTIPLE ROCKET LAUNCHER"],
                    s._translate(0, 10, A["GR.EQ.INTERMEDIATE RANGE"])
                ], I[111603] = [
                    A["GR.EQ.MULTIPLE ROCKET LAUNCHER"],
                    s._translate(0, 10, A["GR.EQ.LONG RANGE"])
                ], I[111700] = [
                    A["GR.EQ.ANTITANK ROCKET LAUNCHER"]
                ], I[111701] = [
                    A["GR.EQ.ANTITANK ROCKET LAUNCHER"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[111702] = [
                    A["GR.EQ.ANTITANK ROCKET LAUNCHER"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[111703] = [
                    A["GR.EQ.ANTITANK ROCKET LAUNCHER"],
                    A["GR.EQ.LONG RANGE"]
                ], I[111800] = [
                    A["GR.EQ.NON-LETHAL WEAPON"]
                ], I[111900] = [
                    A["GR.EQ.TASER"]
                ], I[112e3] = [
                    A["GR.EQ.WATER CANNON"]
                ], I[12e4] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"]
                ], I[120100] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    A["GR.EQ.ARMOURED VEHICLE"]
                ], I[120101] = [
                    A["GR.EQ.ARMOURED FIGHTING VEHICLE"]
                ], I[120102] = [
                    A["GR.EQ.ARMOURED FIGHTING VEHICLE (AFV) COMMAND AND CONTROL"]
                ], I[120103] = [
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER"]
                ], I[120104] = [
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                    A["GR.EQ.MEDICAL EVACUATION"]
                ], I[120105] = [
                    A["GR.IC.ARMOUR"]
                ], I[120106] = [
                    A["GR.IC.ARMOUR"],
                    A["GR.EQ.TANK RECOVERY VEHICLE"]
                ], I[120107] = [
                    A["GR.IC.ARMOUR"],
                    A["GR.EQ.MEDICAL EVACUATION"]
                ], I[120108] = [
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                    A["GR.EQ.TANK RECOVERY VEHICLE"]
                ], I[120109] = [
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                    A["GR.EQ.COMBAT SERVICE SUPPORT VEHICLE"]
                ], I[120110] = [
                    A["GR.EQ.ARMOURED FIGHTING VEHICLE"],
                    A["GR.EQ.CROSS-COUNTRY"]
                ], I[120111] = [
                    A["GR.EQ.ARMOURED FIGHTING VEHICLE"],
                    A["GR.EQ.CROSS-COUNTRY"],
                    A["GR.IC.FF.RECONNAISSANCE EQUPIMENT"]
                ], I[120200] = [
                    A["GR.EQ.TANK"]
                ], I[120201] = [
                    A["GR.EQ.TANK"],
                    A["GR.EQ.LIGHT TANK"]
                ], I[120202] = [
                    A["GR.EQ.TANK"],
                    A["GR.EQ.MEDIUM TANK"]
                ], I[120203] = [
                    A["GR.EQ.TANK"],
                    A["GR.EQ.HEAVY TANK"]
                ], I[120300] = [
                    A["GR.EQ.TANK"],
                    A["GR.EQ.TANK RECOVERY VEHICLE"]
                ], I[120301] = [
                    A["GR.EQ.TANK"],
                    A["GR.EQ.LIGHT TANK"],
                    A["GR.EQ.TANK RECOVERY VEHICLE"]
                ], I[120302] = [
                    A["GR.EQ.TANK"],
                    A["GR.EQ.MEDIUM TANK"],
                    A["GR.EQ.TANK RECOVERY VEHICLE"]
                ], I[120303] = [
                    A["GR.EQ.TANK"],
                    A["GR.EQ.HEAVY TANK"],
                    A["GR.EQ.TANK RECOVERY VEHICLE"]
                ], I[13e4] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    s._scale(.7, A["GR.IC.ENGINEER"])
                ], I[130100] = [
                    A["GR.IN.IC.BRIDGE"]
                ], I[130200] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    s._scale(.8, A["GR.IN.IC.BRIDGE"])
                ], I[130300] = [
                    A["GR.IN.IC.BRIDGE"],
                    A["GR.EQ.FIXED BRIDGE"]
                ], I[130400] = [
                    A["GR.IN.IC.BRIDGE"],
                    A["GR.M2.RIVERINE"]
                ], I[130500] = [
                    A["GR.IN.IC.BRIDGE"],
                    A["GR.EQ.FOLDING GIRDER BRIDGE"]
                ], I[130600] = [
                    A["GR.IN.IC.BRIDGE"],
                    A["GR.EQ.HOLLOW DECK BRIDGE"]
                ], I[130700] = [
                    A["GR.IC.DRILLING"]
                ], I[130701] = [
                    s._scale(.7, A["GR.IC.DRILLING"]),
                    A["GR.EQ.UTILITY VEHICLE"]
                ], I[130800] = [
                    A["GR.EQ.EARTHMOVER"]
                ], I[130801] = [
                    A["GR.EQ.MULTIFUNCTIONAL EARTHMOVER/DIGGER"]
                ], I[130900] = [
                    A["GR.EQ.MINE CLEARING EQUIPMENT"]
                ], I[130901] = [
                    A["GR.EQ.MINE CLEARING EQUIPMENT"],
                    s._translate(0, -10, A["GR.EQ.LIMITED CROSS-COUNTRY"])
                ], I[130902] = [
                    A["GR.EQ.MINE CLEARING EQUIPMENT"],
                    A["GR.EQ.TANK"]
                ], I[130903] = [
                    A["GR.EQ.ASSAULT BREACHER VEHICLE (ABV) WITH COMBAT DOZER BLADE"]
                ], I[130904] = [
                    A["GR.M1.ROUTE, RECONNAISSANCE, AND CLEARANCE"],
                    A["GR.IC.ENGINEER UTILITY VEHICLE"],
                    A["GR.M2.MEDIUM"]
                ], I[130905] = [
                    A["GR.M1.ROUTE, RECONNAISSANCE, AND CLEARANCE"],
                    A["GR.IC.ENGINEER UTILITY VEHICLE"],
                    A["GR.M2.HEAVY"]
                ], I[131e3] = [
                    A["GR.IC.MINE LAYING"]
                ], I[131001] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    s._translate(0, 10, s._scale(.7, A["GR.IC.MINE LAYING"]))
                ], I[131002] = [
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                    A["GR.EQ.ARMORED CARRIER WITH VOLCANO"]
                ], I[131003] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.LIMITED CROSS-COUNTRY"],
                    A["GR.EQ.ARMORED CARRIER WITH VOLCANO"]
                ], I[131100] = [
                    A["GR.EQ.DOZER"]
                ], I[131101] = [
                    A["GR.EQ.DOZER ARMORED"]
                ], I[131200] = [
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                    s._scale(.6, A["GR.IC.ENGINEER"])
                ], I[131300] = [
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER"],
                    s._scale(.6, A["GR.IC.ENGINEER"]),
                    A["GR.EQ.ARMOURED PERSONNEL CARRIER ENGINEER RECON VEHICLE"]
                ], I[131400] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.LIMITED CROSS-COUNTRY"],
                    A["GR.EQ.UTILITY VEHICLE BACKHOE"]
                ], I[131500] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.LIMITED CROSS-COUNTRY"],
                    s._scale(.6, A["GR.IC.ENGINEER"])
                ], I[131600] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.CROSS-COUNTRY"],
                    A["GR.EQ.UTILITY VEHICLE FERRY TRANSPORTER"]
                ], I[14e4] = [], I[140100] = [
                    A["GR.EQ.UTILITY VEHICLE"]
                ], I[140200] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.MEDICAL VEHICLE"]
                ], I[140300] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.MEDICAL EVACUATION"]
                ], I[140400] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.MOBILE EMERGENCY PHYSICIAN"]
                ], I[140500] = [
                    A["GR.EQ.BUS"]
                ], I[140600] = [
                    A["GR.EQ.SEMI-TRAILER TRUCK"]
                ], I[140601] = [
                    A["GR.EQ.SEMI-TRAILER TRUCK"],
                    A["GR.EQ.UTILITY VEHICLE LIGHT"]
                ], I[140602] = [
                    A["GR.EQ.SEMI-TRAILER TRUCK"],
                    A["GR.EQ.UTILITY VEHICLE MEDIUM"]
                ], I[140603] = [
                    A["GR.EQ.SEMI-TRAILER TRUCK"],
                    A["GR.EQ.UTILITY VEHICLE HEAVY"]
                ], I[140700] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.LIMITED CROSS-COUNTRY"]
                ], I[140800] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.CROSS-COUNTRY"]
                ], I[140900] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    s._scale(.8, A["GR.IC.FF.CLASS III"])
                ], I[141e3] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    s._scale(.7, A["GR.IC.WATER"])
                ], I[141100] = [
                    A["GR.EQ.WATER VEHICLE"],
                    A["GR.EQ.LIMITED CROSS-COUNTRY"]
                ], I[141200] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.UTILITY VEHICLE.TOW TRUCK"]
                ], I[141201] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.UTILITY VEHICLE.TOW TRUCK"],
                    A["GR.EQ.UTILITY VEHICLE.TOW TRUCK.LIGHT"]
                ], I[141202] = [
                    A["GR.EQ.UTILITY VEHICLE"],
                    A["GR.EQ.UTILITY VEHICLE.TOW TRUCK"],
                    A["GR.EQ.UTILITY VEHICLE.TOW TRUCK.HEAVY"]
                ], I[15e4] = [], I[150100] = [
                    A["GR.EQ.TRAIN LOCOMOTIVE"]
                ], I[150200] = [
                    A["GR.EQ.RAILCAR"]
                ], I[16e4] = [], I[160100] = [
                    A["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"]
                ], I[160101] = [
                    A["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"],
                    A["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
                ], I[160102] = [
                    A["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"],
                    A["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
                ], I[160103] = [
                    A["GR.EQ.CIVILIAN VEHICLE.AUTOMOBILE"],
                    A["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
                ], I[160200] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"]
                ], I[160201] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                    A["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
                ], I[160202] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                    A["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
                ], I[160203] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                    A["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
                ], I[160300] = [
                    A["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"]
                ], I[160301] = [
                    A["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
                ], I[160302] = [
                    A["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
                ], I[160303] = [
                    A["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
                ], I[160400] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"]
                ], I[160401] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
                ], I[160402] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
                ], I[160403] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
                ], I[160500] = [
                    A["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"]
                ], I[160501] = [
                    A["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.LIGHT"]
                ], I[160502] = [
                    A["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.MEDIUM"]
                ], I[160503] = [
                    A["GR.EQ.CIVILIAN VEHICLE.JEEP TYPE VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.HEAVY"]
                ], I[160600] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160601] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.LIGHT"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160602] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.MEDIUM"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160603] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.EQ.CIVILIAN VEHICLE.HEAVY"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160700] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160701] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                    A["GR.EQ.CIVILIAN VEHICLE.LIGHT"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160702] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                    A["GR.EQ.CIVILIAN VEHICLE.MEDIUM"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160703] = [
                    A["GR.EQ.CIVILIAN VEHICLE.OPEN-BED TRUCK"],
                    A["GR.EQ.CIVILIAN VEHICLE.HEAVY"],
                    A["GR.EQ.CIVILIAN VEHICLE.TRAILER"]
                ], I[160800] = [
                    A["ST.IC.KNOWN INSURGENT VEHICLE"]
                ], I[160900] = [
                    A["ST.IC.KNOWN INSURGENT VEHICLE"],
                    A["ST.M1.DRUG"]
                ], I[17e4] = [
                    A["GR.IC.FF.LAW ENFORCEMENT"]
                ], I[170100] = [
                    A["GR.IC.BUREAU OF ALCOHOL, TOBACCO, FIREARMS AND EXPLOSIVES (ATF) (DEPARTMENT OF JUSTICE)"]
                ], I[170200] = [
                    A["GR.IC.FF.BORDER PATROL"]
                ], I[170300] = [
                    A["GR.IC.FF.CUSTOMS SERVICE"]
                ], I[170400] = [
                    A["GR.IC.DRUG ENFORCEMENT AGENCY (DEA)"]
                ], I[170500] = [
                    A["GR.IC.FF.DEPARTMENT OF JUSTICE (DOJ)"]
                ], I[170600] = [
                    A["GR.IC.FEDERAL BUREAU OF INVESTIGATION (FBI)"]
                ], I[170700] = [
                    A["GR.IC.MILITARY POLICE"]
                ], I[170800] = [
                    A["GR.IC.UNITED STATES SECRET SERVICE(TREAS) (USSS)"]
                ], I[170900] = [
                    A["GR.IC.TRANSPORTATION SECURITY AGENCY (TSA)"]
                ], I[171e3] = [
                    A["GR.IC.LAW ENFORCEMENT VESSEL"]
                ], I[171100] = [
                    A["GR.IC.FF.US MARSHALS SERVICE"]
                ], I[18e4] = [
                    A["GR.EQ.PACK ANIMAL"]
                ], I[19e4] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    A["GR.EQ.MISSILE SUPPORT"]
                ], I[190100] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    A["GR.EQ.MISSILE TRANSLOADER"]
                ], I[190200] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    A["GR.EQ.MISSILE TRANSPORTER"]
                ], I[190300] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    A["GR.EQ.MISSILE CRANE/LOADING DEVICE"]
                ], I[190400] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    A["GR.EQ.MISSILE PROPELLANT TRANSPORTER"]
                ], I[190500] = [
                    A["GR.EQ.ARMOURED PROTECTED VEHICLE WITH LIMITED CROSS COUNTRY MOBILITY"],
                    A["GR.EQ.MISSILE WARHEAD TRANSPORTER"]
                ], I[2e5] = [], I[200100] = [
                    A["GR.IC.FF.BROADCAST TRANSMITTER ANTENNA"]
                ], I[200200] = [
                    A["ST.IC.BOMB"]
                ], I[200300] = [
                    A["ST.IC.BOOBY TRAP"]
                ], I[200400] = [
                    A["GR.EQ.CBRN EQUIPMENT"]
                ], I[200500] = [
                    A["GR.EQ.COMPUTER SYSTEM"]
                ], I[200600] = [
                    A["GR.EQ.COMMAND LAUNCH EQUIPMENT (CLE)"]
                ], I[200700] = [
                    A["GR.EQ.GENERATOR SET"]
                ], I[200800] = [
                    A["GR.EQ.GROUND-BASED MIDCOURSE DEFENSE (GMD) FIRE CONTROL (GFC) CENTER"]
                ], I[200900] = [
                    A["GR.EQ.IN-FLIGHT INTERCEPTOR COMMUNICATIONS SYSTEM (IFICS) DATA TERMINAL (IDT)"]
                ], I[201e3] = [
                    A["GR.EQ.LASER"]
                ], I[201100] = [
                    A["GR.EQ.PSYCHOLOGICAL OPERATIONS EQUIPMENT"]
                ], I[201200] = [
                    A["GR.IC.SUSTAINMENT"]
                ], I[201300] = [
                    A["GR.EQ.TENT"]
                ], I[201301] = [
                    A["GR.EQ.TENT CIVILIAN"]
                ], I[201302] = [
                    A["GR.EQ.TENT MILITARY"]
                ], I[201400] = [
                    A["GR.EQ.UNIT DEPLOYMENT SHIPMENTS"]
                ], I[201500] = [
                    A["GR.IC.EMERGENCY MEDICAL OPERATION"]
                ], I[201501] = [
                    A["GR.IC.MEDICAL EVACUATION HELICOPTER"]
                ], I[21e4] = [], I[210100] = [
                    A["GR.EQ.LAND MINE"]
                ], I[210200] = [
                    A["GR.EQ.ANTIPERSONNEL LAND MINE"]
                ], I[210300] = [
                    A["GR.EQ.ANTITANK MINE"]
                ], I[210400] = [
                    A["GR.EQ.IMPROVISED EXPLOSIVE DEVICE"]
                ], I[210500] = [
                    A["GR.EQ.ANTIPERSONNEL LAND MINE LESS THAN LETHAL"]
                ], I[22e4] = [], I[220100] = [
                    A["GR.EQ.SENSOR"]
                ], I[220200] = [
                    A["GR.EQ.SENSOR EMPLACED"]
                ], I[220300] = [
                    A["GR.EQ.RADAR"]
                ], I[23e4] = [
                    A["GR.IC.FF.EMERGENCY OPERATION"]
                ], I[230100] = [
                    A["GR.EQ.CIVILIAN VEHICLE.UTILITY VEHICLE"],
                    A["GR.M1.MEDEVAC"]
                ], I[230200] = [
                    A["GR.IC.FIRE PROTECTION"]
                ], I[24e4] = [
                    A["GR.IC.MANUAL TRACK"]
                ], I[25e4] = [
                    A["GR.IC.AVIATION ROTARY WING"]
                ], t["01"] = [
                    A["GR.M1.BIOLOGICAL"]
                ], t["02"] = [
                    A["GR.M1.CHEMICAL"]
                ], t["03"] = [
                    A["GR.M1.EARLY WARNING RADAR"]
                ], t["04"] = [
                    A["GR.M1.INTRUSION"]
                ], t["05"] = [
                    A["GR.M1.NUCLEAR"]
                ], t["06"] = [
                    A["GR.M1.RADIOLOGICAL"]
                ], t["07"] = [
                    A["GR.M1.UPGRADED EARLY WARNING RADAR"]
                ], t["08"] = [
                    A["GR.M1.HIJACKING"]
                ], t["09"] = [
                    A["GR.M1.CIVILIAN"]
                ], t[10] = [
                    A["GR.M1.TILT-ROTOR"]
                ], t[11] = [], t[12] = [
                    A["GR.M1.MULTI-PURPOSE BLADE"]
                ], t[13] = [
                    A["GR.M1.TANK-WIDTH MINE PLOW"]
                ], t[14] = [
                    A["GR.M1.BRIDGING"]
                ], t[15] = [
                    A["GR.M1.CYBERSPACE"]
                ], t[16] = [
                    A["GR.M1.ARMORED"]
                ], t[17] = [
                    A["GR.M1.ATTACK"]
                ], t[18] = [
                    A["GR.M1.CARGO"]
                ], t[19] = [
                    A["GR.M1.MAINTENANCE"]
                ], t[20] = [
                    A["GR.M1.MEDEVAC"]
                ], t[21] = [
                    A["GR.IN.M1.PETROLEUM"]
                ], t[22] = [
                    A["GR.M1.UTILITY"]
                ], t[23] = [
                    A["GR.M1.WATER"]
                ], t[24] = [
                    A["GR.M1.ROBOTIC"]
                ], E["01"] = [
                    A["GR.M2.CYBERSPACE"]
                ], E["02"] = [
                    A["GR.M2.LIGHT"]
                ], E["03"] = [
                    A["GR.M2.MEDIUM"]
                ], E["04"] = [
                    A["GR.M2.RAILROAD"]
                ], E["05"] = [
                    A["GR.M2.TRACKED"]
                ], E["06"] = [
                    A["GR.M2.TRACTOR TRAILER"]
                ], E["07"] = [
                    A["GR.M2.WHEELED LIMITED"]
                ], E["08"] = [
                    A["GR.M2.WHEELED"]
                ], E["09"] = [
                    A["GR.M2.ROBOTIC"]
                ];
                var T = {
                    11e4: 140,
                    110100: 140,
                    110101: 140,
                    110102: 140,
                    110103: 140,
                    110200: 140,
                    110201: 140,
                    110202: 140,
                    110203: 140,
                    110300: 140,
                    110301: 140,
                    110302: 140,
                    110303: 140,
                    110400: 135,
                    110500: 140,
                    110501: 140,
                    110502: 140,
                    110503: 140,
                    110600: 140,
                    110601: 140,
                    110602: 140,
                    110603: 140,
                    110700: 140,
                    110701: 140,
                    110702: 140,
                    110703: 140,
                    110800: 140,
                    110801: 140,
                    110802: 140,
                    110803: 140,
                    110900: 140,
                    110901: 140,
                    110902: 140,
                    110903: 140,
                    111e3: 140,
                    111001: 140,
                    111002: 140,
                    111003: 140,
                    111100: 140,
                    111101: 140,
                    111102: 140,
                    111103: 140,
                    111104: 140,
                    111105: 140,
                    111106: 140,
                    111107: 140,
                    111108: 140,
                    111109: 140,
                    111200: 140,
                    111201: 140,
                    111202: 140,
                    111203: 140,
                    111300: 140,
                    111301: 140,
                    111302: 140,
                    111303: 140,
                    111400: 140,
                    111401: 140,
                    111402: 140,
                    111403: 140,
                    111500: 140,
                    111501: 140,
                    111502: 140,
                    111503: 140,
                    111600: 140,
                    111601: 140,
                    111602: 140,
                    111603: 140,
                    111701: 140,
                    111702: 140,
                    111703: 140,
                    111800: 140,
                    111900: 140,
                    112e3: 140,
                    12e4: 129,
                    120100: 129,
                    120101: 130,
                    120102: 130,
                    120103: 130,
                    120104: 130,
                    120105: 120,
                    120106: 120,
                    120107: 120,
                    120108: 130,
                    120109: 130,
                    120110: 140,
                    120200: 130,
                    120201: 130,
                    120202: 130,
                    120203: 130,
                    120300: 130,
                    120301: 130,
                    120302: 130,
                    120303: 130,
                    13e4: 129,
                    130100: 115,
                    130200: 130,
                    130300: 130,
                    130400: 135,
                    130500: 120,
                    130600: 120,
                    130700: 120,
                    130701: 130,
                    130800: 130,
                    130801: 130,
                    130900: 120,
                    130901: 130,
                    130902: 130,
                    131e3: 115,
                    131001: 130,
                    131002: 130,
                    131003: 140,
                    131100: 130,
                    131101: 130,
                    131200: 130,
                    131300: 130,
                    131400: 140,
                    131500: 140,
                    131600: 140,
                    140100: 130,
                    140200: 130,
                    140300: 130,
                    140400: 130,
                    140500: 130,
                    140600: 140,
                    140601: 140,
                    140602: 140,
                    140603: 140,
                    140700: 140,
                    140800: 140,
                    140900: 130,
                    141e3: 130,
                    141100: 140,
                    141200: 130,
                    141201: 130,
                    141202: 130,
                    150100: 130,
                    150200: 140,
                    160100: 132.5,
                    160101: 132.5,
                    160102: 132.5,
                    160103: 132.5,
                    160200: 132.5,
                    160201: 132.5,
                    160202: 132.5,
                    160203: 132.5,
                    160300: 132.5,
                    160301: 132.5,
                    160302: 132.5,
                    160303: 132.5,
                    160400: 132.5,
                    160401: 132.5,
                    160402: 132.5,
                    160403: 132.5,
                    160500: 132.5,
                    160501: 132.5,
                    160502: 132.5,
                    160503: 132.5,
                    160600: 132.5,
                    160601: 132.5,
                    160602: 132.5,
                    160603: 132.5,
                    160700: 132.5,
                    160701: 132.5,
                    160702: 132.5,
                    160703: 132.5,
                    160800: 115,
                    160900: 115,
                    17e4: 149.03125,
                    170100: 118.75,
                    170200: 133.21875,
                    170300: 135.21875,
                    170400: 118.75,
                    170500: 138.1875,
                    170600: 118.75,
                    170700: 118.75,
                    170800: 118,
                    170900: 118,
                    171e3: 135,
                    171100: 135,
                    18e4: 125,
                    19e4: 129,
                    190100: 129,
                    190200: 129,
                    190300: 129,
                    190400: 129,
                    190500: 129,
                    200100: 140,
                    200200: 118.75,
                    200300: 120,
                    200400: 140,
                    200500: 132,
                    200600: 118.75,
                    200700: 118.75,
                    200800: 118.75,
                    200900: 119.36222839355469,
                    201e3: 145,
                    201100: 120,
                    201200: 118,
                    201300: 124.36222076416016,
                    201301: 120,
                    201302: 120,
                    201400: 118.75,
                    201500: 140,
                    201501: 115,
                    210100: 122,
                    210200: 122,
                    210300: 122,
                    210400: 118.75,
                    210500: 122,
                    220100: 140,
                    220200: 136,
                    220300: 120,
                    23e4: 135,
                    230100: 132.5,
                    230200: 120,
                    24e4: 118.75
                };
                for(var S in T)T.hasOwnProperty(S) && (R[S] = {
                    x1: 50,
                    x2: 150,
                    y1: 50,
                    y2: T[S]
                });
            }
        }
    }, J = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: c,
        icons: function(I, t, E, R, e, A, C) {
            "20" == e && (I[11e4] = [
                A["GR.IC.MILITARY"]
            ], I[110100] = [
                A["GR.IN.IC.AIRCRAFT PRODUCTION & ASSEMBLY"]
            ], I[110200] = [
                s._scale(1.4, A["GR.IC.FF.CLASS V"])
            ], I[110300] = [
                A["GR.IC.FF.CLASS V"],
                A["GR.IC.FF.SUPPLY"]
            ], I[110400] = [
                A["GR.EQ.TANK"]
            ], I[110500] = [
                A["ST.IC.BLACK LIST LOCATION"]
            ], I[110600] = [
                A["GR.IC.CBRN"]
            ], I[110700] = [
                A["GR.EQ.DOZER"]
            ], I[110701] = [
                A["GR.IN.IC.BRIDGE"]
            ], I[110800] = [
                A["GR.IC.EQUIPMENT MANUFACTURE"]
            ], I[110900] = [
                A["GR.I.GOVERNMENT"]
            ], I[111e3] = [
                A["ST.IC.GRAY LIST LOCATION"]
            ], I[111100] = [
                A["ST.IC.MASS GRAVE LOCATION"]
            ], I[111200] = [
                A["GR.IN.IC.MILITARY/CIVILIAN.MATERIEL"],
                A["GR.IC.FF.SUPPLY"]
            ], I[111300] = [
                A["GR.IN.IC.MINE"]
            ], I[111400] = [
                A["GR.EQ.MISSILE LAUNCHER"]
            ], I[111500] = [
                s._scale(.8, A["AC.IC.RADIOACTIVE MATERIAL"])
            ], I[111600] = [
                A["GR.IN.IC.MILITARY/CIVILIAN.PRINTED MEDIA"]
            ], I[111700] = [
                A["ST.IC.SAFE HOUSE"]
            ], I[111800] = [
                A["ST.IC.WHITE LIST LOCATION"]
            ], I[111900] = [
                A["GR.EQ.TENT"]
            ], I[111901] = [
                A["GR.EQ.TENT"],
                A["ST.M1.DISPLACED PERSONS, REFUGEES, AND EVACUEES"]
            ], I[111902] = [
                A["GR.EQ.TENT"],
                A["GR.M1.TRAINING CAMP"]
            ], I[112e3] = [
                A["GR.IN.IC.INDUSTRIAL SITE"],
                A["GR.IN.IC.WAREHOUSE/STORAGE FACILITY"]
            ], I[112100] = [
                A["GR.IC.FF.LAW ENFORCEMENT"]
            ], I[112101] = [
                A["GR.IC.BUREAU OF ALCOHOL, TOBACCO, FIREARMS AND EXPLOSIVES (ATF) (DEPARTMENT OF JUSTICE)"]
            ], I[112102] = [
                A["GR.IC.FF.BORDER PATROL"]
            ], I[112103] = [
                A["GR.IC.FF.CUSTOMS SERVICE"]
            ], I[112104] = [
                A["GR.IC.DRUG ENFORCEMENT AGENCY (DEA)"]
            ], I[112105] = [
                A["GR.IC.FF.DEPARTMENT OF JUSTICE (DOJ)"]
            ], I[112106] = [
                A["GR.IC.FEDERAL BUREAU OF INVESTIGATION (FBI)"]
            ], I[112107] = [
                A["GR.IC.LAW ENFORCEMENT"]
            ], I[112108] = [
                A["GR.IC.FF.PRISON"]
            ], I[112109] = [
                A["GR.IC.UNITED STATES SECRET SERVICE(TREAS) (USSS)"]
            ], I[112110] = [
                A["GR.IC.TRANSPORTATION SECURITY AGENCY (TSA)"]
            ], I[112111] = [
                A["GR.IC.LAW ENFORCEMENT VESSEL"]
            ], I[112112] = [
                A["GR.IC.FF.US MARSHALS SERVICE"]
            ], I[112200] = [
                A["GR.IC.FF.EMERGENCY OPERATION"]
            ], I[112201] = [
                A["GR.IC.FIRE PROTECTION"]
            ], I[112202] = [
                A["GR.IC.EMERGENCY MEDICAL OPERATION"]
            ], I[12e4] = [], I[120100] = [
                A["GR.IN.IC.AGRICULTURE AND FOOD INFRASTRUCTURE"]
            ], I[120101] = [
                A["GR.IN.IC.AGRICULTURAL LABORATORY"]
            ], I[120102] = [
                A["GR.IN.IC.ANIMAL FEEDLOT"]
            ], I[120103] = [
                A["ST.IC.FOOD DISTRIBUTION"],
                A["AC.M1.COMMERCIAL"]
            ], I[120104] = [
                A["GR.IN.IC.FARM/RANCH"]
            ], I[120105] = [
                A["ST.IC.FOOD DISTRIBUTION"]
            ], I[120106] = [
                A["ST.IC.FOOD DISTRIBUTION"],
                A["AC.M1.PRODUCTION"]
            ], I[120107] = [
                A["ST.IC.FOOD DISTRIBUTION"],
                A["AC.M1.RETAIL"]
            ], I[120108] = [
                A["GR.IN.IC.GRAIN STORAGE"]
            ], I[120200] = [
                A["AC.IC.BANKING FINANCE AND INSURANCE INFRASTRUCTURE"]
            ], I[120201] = [
                A["GR.IN.IC.ATM"]
            ], I[120202] = [
                A["GR.IN.IC.BANK"]
            ], I[120203] = [
                A["GR.IN.IC.BULLION STORAGE"]
            ], I[120204] = [
                A["GR.IN.IC.INFRASTRUCTURE.BANKING FINANCE AND INSURANCE  INFRASTRUCTURE.ECONOMIC INFRASTRUCTURE ASSET"]
            ], I[120205] = [
                A["GR.IN.IC.FEDERAL RESERVE BANK"]
            ], I[120206] = [
                A["GR.IN.IC.FINANCIAL EXCHANGE"]
            ], I[120207] = [
                A["GR.IN.IC.FINANCIAL SERVICES, OTHER"]
            ], I[120300] = [
                A["GR.IN.IC.COMMERCIAL INFRASTRUCTURE"]
            ], I[120301] = [
                A["GR.IN.IC.CHEMICAL PLANT"]
            ], I[120302] = [
                A["GR.IN.IC.FIREARMS MANUFACTURER"]
            ], I[120303] = [
                A["GR.IN.IC.FIREARMS RETAILER"]
            ], I[120304] = [
                A["GR.IN.IC.HAZARDOUS MATERIAL PRODUCTION"]
            ], I[120305] = [
                A["GR.IN.IC.HAZARDOUS MATERIAL STORAGE"]
            ], I[120306] = [
                A["GR.IN.IC.INDUSTRIAL SITE"]
            ], I[120307] = [
                A["GR.IN.IC.LANDFILL"]
            ], I[120308] = [
                A["GR.IN.IC.PHARMACEUTICAL MANUFACTURER"]
            ], I[120309] = [
                A["GR.IN.IC.CONTAMINATED HAZARDOUS WASTE SITE"]
            ], I[120310] = [
                A["GR.IN.IC.TOXIC RELEASE INVENTORY"]
            ], I[120400] = [
                A["GR.IN.IC.EDUCATIONAL FACILITIES INFRASTRUCTURE"]
            ], I[120401] = [
                A["GR.IN.IC.COLLEGE/UNIVERSITY"]
            ], I[120402] = [
                A["GR.IN.IC.SCHOOL"]
            ], I[120500] = [
                A["GR.IN.IC.ELECTRIC POWER"]
            ], I[120501] = [
                s._scale(.6, A["GR.IN.IC.ELECTRIC POWER"])
            ], I[120502] = [
                s._translate(0, 15, s._scale(.75, A["GR.IN.IC.ELECTRIC POWER"])),
                A["AC.M1.GENERATION STATION"]
            ], I[120503] = [
                A["GR.IN.IC.NATURAL GAS FACILITY"]
            ], I[120504] = [
                s._scale(1.5, A["GR.IC.FF.CLASS III"])
            ], I[120505] = [
                A["GR.IC.FF.CLASS III"]
            ], I[120506] = [
                A["GR.IN.IC.PROPANE FACILITY"]
            ], I[120600] = [
                A["GR.IN.IC.GOVERNMENT SITE INFRASTRUCTURE"]
            ], I[120700] = [], I[120701] = [
                A["GR.IC.FF.MEDICAL"]
            ], I[120702] = [
                A["GR.IC.FF.MEDICAL"],
                A["GR.IC.FF.MEDICAL TREATMENT FACILITY"]
            ], I[120800] = [
                A["GR.IN.IC.MILITARY INFRASTRUCTURE"]
            ], I[120801] = [
                A["GR.IN.IC.BASE"],
                A["AC.M1.MILITARY ARMORY"]
            ], I[120802] = [
                A["GR.IN.IC.BASE"]
            ], I[120900] = [
                A["GR.IN.IC.POSTAL SERVICE INFRASTRUCTURE"]
            ], I[120901] = [
                A["GR.IN.IC.POSTAL DISTRIBUTION CENTER"]
            ], I[120902] = [
                A["GR.IN.IC.POST OFFICE"]
            ], I[121e3] = [
                A["GR.IN.IC.PUBLIC VENUES INFRASTRUCTURE"]
            ], I[121001] = [
                A["GR.IN.IC.ENCLOSED FACITLITY (PUBLIC VENUE)"]
            ], I[121002] = [
                A["GR.IN.IC.OPEN FACILITY (OPEN VENUE)"]
            ], I[121003] = [
                A["GR.IN.IC.RECREATIONAL AREA"]
            ], I[121004] = [
                A["GR.IN.IC.RELIGIOUS INSTITUTION"]
            ], I[121100] = [
                A["GR.IN.IC.SPECIAL NEEDS INFRASTRUCTURE"]
            ], I[121101] = [
                A["GR.IN.IC.ADULT DAY CARE"]
            ], I[121102] = [
                A["GR.IN.IC.CHILD DAY CARE"]
            ], I[121103] = [
                A["GR.IN.IC.ELDER CARE"]
            ], I[121200] = [
                A["GR.IN.IC.TELECOMMUNICATIONS INFRASTRUCTURE"]
            ], I[121201] = [
                A["GR.IC.FF.BROADCAST TRANSMITTER ANTENNA"]
            ], I[121202] = [
                A["GR.IN.IC.INFRASTRUCTURE.TELECOMMUNICATIONS INFRASTRUCTURE.TELECOMMUNICATIONS"]
            ], I[121203] = [
                A["GR.IN.IC.TELECOMMUNICATIONS TOWER"]
            ], I[121300] = [
                s._scale(1.5, A["GR.IC.TRANSPORTATION"])
            ], I[121301] = [
                A["GR.IC.TRANSPORTATION"],
                A["GR.IC.AIRPORT OF DEBARKATION"]
            ], I[121302] = [
                A["GR.IN.IC.AIR TRAFFIC CONTROL FACILITY"]
            ], I[121303] = [
                A["GR.EQ.CIVILIAN VEHICLE.MULTIPLE PASSENGER VEHICLE"]
            ], I[121304] = [
                A["GR.IC.FERRY"]
            ], I[121305] = [
                A["GR.IN.IC.HELICOPTER LANDING SITE"]
            ], I[121306] = [
                A["GR.IC.MAINTENANCE"]
            ], I[121307] = [
                A["GR.IC.RAILHEAD"]
            ], I[121308] = [
                A["GR.IN.IC.REST STOP"]
            ], I[121309] = [
                A["GR.IC.TRANSPORTATION"],
                A["GR.M1.NAVAL"]
            ], I[121310] = [
                A["GR.IC.NAVAL"],
                A["GR.M1.YARD"]
            ], I[121311] = [
                A["GR.IN.IC.TOLL FACILITY"]
            ], I[121312] = [
                A["GR.IN.IC.TRAFFIC INSPECTION FACILITY"]
            ], I[121313] = [
                A["GR.IN.IC.TUNNEL"]
            ], I[121400] = [
                A["GR.IC.WATER"]
            ], I[121401] = [
                A["GR.IN.IC.CONTROL VALVE"]
            ], I[121402] = [
                A["GR.IN.IC.DAM"]
            ], I[121403] = [
                A["GR.IN.IC.DISCHARGE OUTFALL"]
            ], I[121404] = [
                A["GR.IN.IC.GROUND WATER WELL"]
            ], I[121405] = [
                A["GR.IN.IC.PUMPING STATION"]
            ], I[121406] = [
                A["GR.IN.IC.RESERVOIR"]
            ], I[121407] = [
                A["GR.IN.IC.STORAGE TOWER"]
            ], I[121408] = [
                A["GR.IN.IC.SURFACE WATER INTAKE"]
            ], I[121409] = [
                A["GR.IN.IC.WASTEWATER TREATMENT FACILITY"]
            ], I[121410] = [
                A["GR.IC.WATER"]
            ], I[121411] = [
                A["GR.IC.WATER PURIFICATION"]
            ], t["01"] = [
                A["GR.M1.BIOLOGICAL"]
            ], t["02"] = [
                A["GR.M1.CHEMICAL"]
            ], t["03"] = [
                A["GR.M1.NUCLEAR"]
            ], t["04"] = [
                A["GR.IN.M1.RADIOLOGICAL"]
            ], t["05"] = [
                A["GR.M1.DECONTAMINATION"]
            ], t["06"] = [
                A["GR.IN.M1.COAL"]
            ], t["07"] = [
                A["GR.IN.M1.GEOTHERMAL"]
            ], t["08"] = [
                A["GR.IN.M1.HYDROELECTRIC"]
            ], t["09"] = [
                A["GR.IN.M1.NATURAL GAS"]
            ], t[10] = [
                A["GR.IN.M1.PETROLEUM"]
            ], t[11] = [
                A["GR.IN.M1.CIVILIAN"]
            ], t[12] = [
                A["GR.IN.M1.CIVILIAN TELEPHONE"]
            ], t[13] = [
                A["GR.IN.M1.CIVILIAN TELEVISION"]
            ], t[14] = [
                A["GR.M1.CYBERSPACE"]
            ], t[15] = [
                A["GR.M1.JOINT NETWORK NODE"]
            ], t[16] = [
                A["GR.M1.COMMAND POST NODE"]
            ], E["01"] = [
                A["GR.IN.M2.CHEMICAL & BIOLOGICAL WARFARE"]
            ], E["02"] = [
                A["GR.IN.M2.CHEMICAL WARFARE PRODUCTION"]
            ], E["03"] = [
                A["GR.IN.M2.NUCLEAR WARFARE PRODUCTION"]
            ], E["04"] = [
                A["GR.IN.M2.RADIOLOGICAL WARFARE PRODUCTION"]
            ], E["05"] = [
                A["GR.IN.M2.ATOMIC ENERGY REACTOR"]
            ], E["06"] = [
                A["GR.IN.M2.NUCLEAR MATERIAL PRODUCTION"]
            ], E["07"] = [
                A["GR.IN.M2.NUCLEAR MATERIAL STORAGE"]
            ], E["08"] = [
                A["GR.IN.M2.WEAPONS GRADE PRODUCTION"]
            ], E["09"] = [
                A["GR.M2.CYBERSPACE"]
            ]);
        }
    }, Z = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: d,
        icons: function(I, t, E, R, e, A, C) {
            "30" == e && (I[11e4] = [
                A["SE.IC.MILITARY"]
            ], I[12e4] = [
                A["SE.IC.COMBATANT"]
            ], I[120100] = [
                A["SE.IC.CARRIER"]
            ], I[120200] = [
                A["SE.IC.SURFACE COMBATANT, LINE"]
            ], I[120201] = [
                A["SE.IC.BATTLESHIP"]
            ], I[120202] = [
                A["SE.IC.CRUISER, GUIDED MISSILE"]
            ], I[120203] = [
                A["SE.IC.DESTROYER"]
            ], I[120204] = [
                A["SE.IC.FRIGATE"]
            ], I[120205] = [
                A["SE.IC.CORVETTE"]
            ], I[120206] = [
                A["SE.IC.LITTORAL COMBATANT SHIP"]
            ], I[120300] = [
                A["SE.IC.AMPHIBIOUS WARFARE SHIP"]
            ], I[120301] = [
                A["SE.IC.AMPHIBIOUS FORCE FLAGSHIP"]
            ], I[120302] = [
                A["SE.IC.AMPHIBIOUS ASSAULT"]
            ], I[120303] = [
                A["SE.IC.AMPHIBIOUS ASSAULT SHIP, GENERAL"]
            ], I[120304] = [
                A["SE.IC.AMPHIBIOUS ASSAULT SHIP, MULTI-PURPOSE"]
            ], I[120305] = [
                A["SE.IC.AMPHIBIOUS ASSAULT SHIP, HELICOPTER"]
            ], I[120306] = [
                A["SE.IC.AMPHIBIOUS TRANSPORT, DOCK"]
            ], I[120307] = [
                A["SE.IC.LANDING SHIP"]
            ], I[120308] = [
                A["SE.IC.LANDING CRAFT"]
            ], I[120400] = [
                A["SE.IC.MINE WARFARE VESSEL"]
            ], I[120401] = [
                A["SE.IC.MINELAYER"]
            ], I[120402] = [
                A["SE.IC.MINESWEEPER"]
            ], I[120403] = [
                A["SE.IC.MINESWEEPER, DRONE"]
            ], I[120404] = [
                A["SE.IC.MINEHUNTER"]
            ], I[120405] = [
                A["SE.IC.MINE COUNTERMEASURES"]
            ], I[120406] = [
                A["SE.IC.MINE COUNTER MEASURE SUPPORT SHIP"]
            ], I[120500] = [
                A["SE.IC.PATROL"]
            ], I[120501] = [
                A["SE.IC.PATROL CRAFT"]
            ], I[120502] = [
                A["SE.IC.PATROL GUN"]
            ], I[120600] = [
                A["SE.IC.SEA SURFACE DECOY"]
            ], I[120700] = [
                A["SE.IC.UNMANNED SURFACE WATER VEHICLE"]
            ], I[120800] = [
                A["SE.IC.MILITARY SPEEDBOAT"]
            ], I[120801] = [
                A["SE.IC.MILITARY SPEEDBOAT, RIGID-HULL INFLATABLE BOAT"]
            ], I[120900] = [
                A["SE.IC.MILITARY JETSKI"]
            ], I[121e3] = [
                A["SE.IC.NAVY TASK ORGANIZATION UNIT"]
            ], I[121001] = [
                A["SE.IC.NAVY TASK ELEMENT"]
            ], I[121002] = [
                A["SE.IC.NAVY TASK FORCE"]
            ], I[121003] = [
                A["SE.IC.NAVY TASK GROUP"]
            ], I[121004] = [
                A["SE.IC.NAVY TASK UNIT"]
            ], I[121005] = [
                A["SE.IC.CONVOY"]
            ], I[121100] = [
                A["SE.IC.RADAR"]
            ], I[13e4] = [
                A["SE.IC.NONCOMBATANT"]
            ], I[130100] = [
                A["SE.IC.AUXILIARY SHIP"]
            ], I[130101] = [
                A["SE.IC.AMMUNITION SHIP"]
            ], I[130102] = [
                A["SE.IC.STORES SHIP"]
            ], I[130103] = [
                A["SE.IC.AUXILIARY FLAG OR COMMAND SHIP"]
            ], I[130104] = [
                A["SE.IC.INTELLIGENCE COLLECTOR"]
            ], I[130105] = [
                A["SE.IC.OCEAN RESEARCH SHIP"]
            ], I[130106] = [
                A["SE.IC.SURVEY SHIP"]
            ], I[130107] = [
                A["SE.IC.HOSPITAL SHIP2"]
            ], I[130108] = [
                A["SE.IC.CARGO SHIP"]
            ], I[130109] = [
                A["SE.IC.COMBAT SUPPORT SHIP, FAST"]
            ], I[130110] = [
                A["SE.IC.OILER, REPLENISHMENT"]
            ], I[130111] = [
                A["SE.IC.REPAIR SHIP"]
            ], I[130112] = [
                A["SE.IC.SUBMARINE TENDER"]
            ], I[130113] = [
                A["SE.IC.TUG, OCEAN GOING"]
            ], I[130200] = [
                A["SE.IC.SERVICE CRAFT, YARD, GENERAL"]
            ], I[130201] = [
                A["SE.IC.BARGE, NOT SELF-PROPELLED"]
            ], I[130202] = [
                A["SE.IC.BARGE, SELF-PROPELLED"]
            ], I[130203] = [
                A["SE.IC.TUG, HARBOUR"]
            ], I[130204] = [
                A["SE.IC.LAUNCH"]
            ], I[14e4] = [
                A["SE.IC.CIVILIAN"]
            ], I[140100] = [
                A["SE.IC.MERCHANT SHIP, GENERAL"]
            ], I[140101] = [
                A["SE.IC.CARGO, GENERAL"]
            ], I[140102] = [
                A["SE.IC.CONTAINER SHIP"]
            ], I[140103] = [
                A["SE.IC.DREDGE"]
            ], I[140104] = [
                A["SE.IC.ROLL ON-ROLL OFF"]
            ], I[140105] = [
                A["SE.IC.FERRY"]
            ], I[140106] = [
                A["SE.IC.HEAVY LIFT"]
            ], I[140107] = [
                A["SE.IC.HOVERCRAFT 2525D"]
            ], I[140108] = [
                A["SE.IC.MERCHANT SHIP, LASH CARRIER (WITH BARGES)"]
            ], I[140109] = [
                A["SE.IC.OILER/TANKER"]
            ], I[140110] = [
                A["SE.IC.PASSENGER SHIP"]
            ], I[140111] = [
                A["SE.IC.TUG, OCEAN GOING CIVILIAN"]
            ], I[140112] = [
                A["SE.IC.TOW"]
            ], I[140113] = [
                A["SE.IC.TRANSPORT SHIP, HAZARDOUS MATERIAL"]
            ], I[140114] = [
                A["SE.IC.JUNK/DHOW"]
            ], I[140115] = [
                A["SE.IC.BARGE, NOT SELF-PROPELLED"]
            ], I[140116] = [
                A["SE.IC.HOSPITAL SHIP"]
            ], I[140200] = [
                A["SE.IC.FISHING VESSEL"]
            ], I[140201] = [
                A["SE.IC.DRIFTER"]
            ], I[140202] = [
                A["SE.IC.TRAWLER"]
            ], I[140203] = [
                A["SE.IC.FISHING VESSEL DREDGE"]
            ], I[140300] = [
                A["SE.IC.LAW ENFORCEMENT VESSEL"]
            ], I[140400] = [
                A["SE.IC.LEISURE CRAFT, SAILING BOAT"]
            ], I[140500] = [
                A["SE.IC.LEISURE CRAFT, MOTORIZED"]
            ], I[140501] = [
                A["SE.IC.LEISURE CRAFT, MOTORIZED, RIGID-HULL INFLATABLE BOAT"]
            ], I[140502] = [
                A["SE.IC.LEISURE CRAFT, MOTORIZED, SPEEDBOAT"]
            ], I[140600] = [
                A["SE.IC.LEISURE CRAFT, JETSKI"]
            ], I[140700] = [
                A["SE.IC.UNMANNED SURFACE WATER VEHICLE (USV)"]
            ], I[15e4] = [
                A["SE.IC.OWN SHIP"]
            ], I[16e4] = [
                A["SE.IC.FUSED TRACK"]
            ], I[17e4] = [
                A["SE.IC.MANUAL TRACK"]
            ], t["01"] = [
                A["SE.M1.OWN SHIP"]
            ], t["02"] = [
                A["SE.M1.ANTIAIR WARFARE"]
            ], t["03"] = [
                A["SE.M1.ANTISUBMARINE WARFARE"]
            ], t["04"] = [
                A["SE.M1.ESCORT"]
            ], t["05"] = [
                A["SE.M1.ELECTRONIC WARFARE"]
            ], t["06"] = [
                A["SE.M1.INTELLIGENCE, SURVEILLANCE, RECONNAISSANCE"]
            ], t["07"] = [
                A["SE.M1.MINE COUNTER MEASURES"]
            ], t["08"] = [
                A["SE.M1.MISSILE DEFENSE"]
            ], t["09"] = [
                A["SE.M1.MEDICAL"]
            ], t[10] = [
                A["SE.M1.MINE WARFARE"]
            ], t[11] = [
                A["SE.M1.REMOTE MULTI-MISSION VEHIHLE"]
            ], t[12] = [
                A["SE.M1.SPECIAL OPERATIONS FORCE"]
            ], t[13] = [
                A["SE.M1.SURFACE WARFARE"]
            ], t[14] = [
                A["SE.M1.BALLISTIC MISSILE"]
            ], t[15] = [
                A["SE.M1.GUIDED MISSILE"]
            ], t[16] = [
                A["SE.M1.OTHER GUIDED MISSILE"]
            ], t[17] = [
                A["SE.M1.TORPEDO"]
            ], t[18] = [
                A["SE.M1.DRONE-EQUIPPED"]
            ], t[19] = [
                A["SE.M1.HELICOPTER-EQUIPPED"]
            ], t[20] = [
                A["SE.M1.BALLISTIC MISSILE DEFENSE, SHOOTER"]
            ], t[21] = [
                A["SE.M1.BALLISTIC MISSILE DEFENSE, LONG- RANGE SURVEILLANCE AND TRACK (LRS&T)"]
            ], t[22] = [
                A["SE.M1.SEA-BASE X-BAND"]
            ], t[23] = [
                A["SE.M1.HIJACKING/HIJACKED"]
            ], t[24] = [
                A["SE.M1.HIJACKER"]
            ], t[25] = [
                A["SE.M1.CYBERSPACE"]
            ], E["01"] = [
                A["SE.M2.NUCLEAR POWERED"]
            ], E["02"] = [
                A["SE.M2.HEAVY"]
            ], E["03"] = [
                A["SE.M2.LIGHT"]
            ], E["04"] = [
                A["SE.M2.MEDIUM"]
            ], E["05"] = [
                A["SE.M2.DOCK"]
            ], E["06"] = [
                A["SE.M2.LOGISTICS"]
            ], E["07"] = [
                A["SE.M2.TANK"]
            ], E["08"] = [
                A["SE.M2.VEHICLE"]
            ], E["09"] = [
                A["SE.M2.FAST"]
            ], E[10] = [
                A["SE.M2.AIR-CUSHIONED (USA ONLY)"]
            ], E[11] = [
                A["SE.M2.AIR-CUSHIONED"]
            ], E[12] = [
                A["SE.M2.HYDROFOIL"]
            ], E[13] = [
                A["SE.M2.AUTONOMOUS CONTROL"]
            ], E[14] = [
                A["SE.M2.REMOTELY PILOTED"]
            ], E[15] = [
                A["SE.M2.EXPENDABLE"]
            ], E[16] = [
                A["SE.M2.CYBERSPACE"]
            ]);
        }
    }, q = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: D,
        icons: function(I, t, E, R, e, A, C) {
            "35" == e && (I[11e4] = [
                A["SU.IC.MILITARY"]
            ], I[110100] = [
                A["SU.IC.SUBMARINE"]
            ], I[110101] = [
                A["SU.IC.SUBMARINE, SURFACED"]
            ], I[110102] = [
                A["SU.IC.SUBMARINE, SNORKELING"]
            ], I[110103] = [
                A["SU.IC.SUBMARINE, BOTTOMED"]
            ], I[110200] = [
                A["SU.IC.OTHER SUBMERSIBLE"]
            ], I[110300] = [
                A["SU.IC.NON-SUBMARINE"]
            ], I[110400] = [
                A["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV)"]
            ], I[110500] = [
                A["SU.IC.DIVER, MILITARY"]
            ], I[12e4] = [
                A["SU.IC.CIVILIAN"]
            ], I[120100] = [
                A["SU.IC.SUBMERSIBLE, CIVILIAN"]
            ], I[120200] = [
                A["SU.IC.AUTONOMOUS UNDERWATER VEHICLE/ UNMANNED UNDERWATER VEHICLE (AUV/UUV), CIVILIAN"]
            ], I[120300] = [
                A["SU.IC.DIVER, CIVILIAN"]
            ], I[13e4] = [
                A["SU.IC.UNDERWATER WEAPON"]
            ], I[130100] = [
                A["SU.IC.TORPEDO"]
            ], I[130200] = [
                A["SU.IC.IMPROVISED EXPLOSIVE DEVICE (IED)"]
            ], I[130300] = [
                A["SU.IC.UNDERWATER DECOY DSymbol"]
            ], I[14e4] = [
                A["SU.IC.ECHO TRACKER CLASSIFIER (ETC)/POSSIBLE CONTACT (POSCON)"]
            ], I[15e4] = [
                A["SU.IC.FUSED TRACK"]
            ], I[16e4] = [
                A["SU.IC.MANUAL TRACK"]
            ], I[2e5] = [
                A["SU.IC.SEABED INSTALLATION, MAN-MADE, MILITARY"]
            ], I[21e4] = [
                A["SU.IC.SEABED INSTALLATION, MAN-MADE, NON-MILITARY"]
            ], t["01"] = [
                A["SU.M1.ANTISUBMARINE WARFARE"]
            ], t["02"] = [
                A["SU.M1.AUXILIARY"]
            ], t["03"] = [
                A["SU.M1.COMMAND AND CONTROL"]
            ], t["04"] = [
                A["SU.M1.INTELLIGENCE, SURVEILLANCE, RECONNAISSANCE"]
            ], t["05"] = [
                A["SU.M1.MINE COUNTERMEASURES"]
            ], t["06"] = [
                A["SU.M1.MINE WARFARE"]
            ], t["07"] = [
                A["SU.M1.SURFACE WARFARE"]
            ], t["08"] = [
                A["SU.M1.ATTACK"]
            ], t["09"] = [
                A["SU.M1.BALLISTIC MISSILE"]
            ], t[10] = [
                A["SU.M1.GUIDED MISSILE"]
            ], t[11] = [
                A["SU.M1.OTHER GUIDED MISSILES (POINT DEFENCE)"]
            ], t[12] = [
                A["SU.M1.SPECIAL OPERATIONS FORCE"]
            ], t[13] = [
                A["SU.M1.POSSIBLE SUBMARINE - LOW 1"]
            ], t[14] = [
                A["SU.M1.POSSIBLE SUBMARINE - LOW 2"]
            ], t[15] = [
                A["SU.M1.POSSIBLE SUBMARINE - HIGH 3"]
            ], t[16] = [
                A["SU.M1.POSSIBLE SUBMARINE - HIGH 4"]
            ], t[17] = [
                A["SU.M1.PROBABLE SUBMARINE"]
            ], t[18] = [
                A["SU.M1.CERTAIN SUBMARINE"]
            ], t[19] = [
                A["SU.M1.ANTI-TORPEDO TORPEDO"]
            ], t[20] = [
                A["SU.M1.HIJACKING/HIJACKED"]
            ], t[21] = [
                A["SU.M1.HIJACKER"]
            ], t[22] = [
                A["SU.M1.CYBERSPACE"]
            ], E["01"] = [
                A["SU.M2.AIR INDEPENDENT PROPULSION"]
            ], E["02"] = [
                A["SU.M2.DIESEL PROPULSION"]
            ], E["03"] = [
                A["SU.M2.DIESEL - TYPE 1"]
            ], E["04"] = [
                A["SU.M2.DIESEL - TYPE 2"]
            ], E["05"] = [
                A["SU.M2.DIESEL - TYPE 3"]
            ], E["06"] = [
                A["SU.M2.NUCLEAR POWERED"]
            ], E["07"] = [
                A["SU.M2.NUCLEAR - TYPE 1"]
            ], E["08"] = [
                A["SU.M2.NUCLEAR - TYPE 2"]
            ], E["09"] = [
                A["SU.M2.NUCLEAR - TYPE 3"]
            ], E[10] = [
                A["SU.M2.NUCLEAR - TYPE 4"]
            ], E[11] = [
                A["SU.M2.NUCLEAR - TYPE 5"]
            ], E[12] = [
                A["SU.M2.NUCLEAR - TYPE 6"]
            ], E[13] = [
                A["SU.M2.NUCLEAR - TYPE 7"]
            ], E[14] = [
                A["SU.M2.AUTONOMOUS CONTROL"]
            ], E[15] = [
                A["SU.M2.REMOTELY PILOTED"]
            ], E[16] = [
                A["SU.M2.EXPENDABLE"]
            ], E[17] = [
                A["SU.M2.CYBERSPACE"]
            ]);
        }
    }, j = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: D,
        icons: function(I, t, E, R, e, A, C) {
            "36" == e && (I[11e4] = [
                A["SU.IC.SEA MINE"]
            ], I[110100] = [
                A["SU.IC.SEA MINE - BOTTOM"]
            ], I[110200] = [
                A["SU.IC.SEA MINE - MOORED"]
            ], I[110300] = [
                A["SU.IC.SEA MINE - FLOATING"]
            ], I[110400] = [
                A["SU.IC.SEA MINE - RISING"]
            ], I[110500] = [
                A["SU.IC.SEA MINE (IN OTHER POSITION)"]
            ], I[110600] = [
                A["SU.IC.SEA MINE - KINGFISHER"]
            ], I[110700] = [
                A["SU.IC.SEA MINE - SMALL OBJECT"]
            ], I[110800] = [
                A["SU.IC.SEA MINE EXERCISE MINE"]
            ], I[110801] = [
                A["SU.IC.SEA MINE EXERCISE MINE - BOTTOM"]
            ], I[110802] = [
                A["SU.IC.SEA MINE EXERCISE MINE - MOORED"]
            ], I[110803] = [
                A["SU.IC.SEA MINE EXERCISE MINE - FLOATING"]
            ], I[110804] = [
                A["SU.IC.SEA MINE EXERCISE MINE - RISING"]
            ], I[110900] = [
                A["SU.IC.SEA MINE NEUTRALIZED"]
            ], I[110901] = [
                A["SU.IC.SEA MINE NEUTRALIZED - BOTTOM"]
            ], I[110902] = [
                A["SU.IC.SEA MINE NEUTRALIZED - MOORED"]
            ], I[110903] = [
                A["SU.IC.SEA MINE NEUTRALIZED - FLOATING"]
            ], I[110904] = [
                A["SU.IC.SEA MINE NEUTRALIZED - RISING"]
            ], I[110905] = [
                A["SU.IC.SEA MINE (IN OTHER POSITION) NEUTRALIZED"]
            ], I[12e4] = [
                A["SU.IC.UNEXPLODED EXPLOSIVE ORDNANCE"]
            ], I[13e4] = [
                A["SU.IC.SEA MINE DECOY"]
            ], I[130100] = [
                A["SU.IC.SEA MINE DECOY, BOTTOM/GROUND"]
            ], I[130200] = [
                A["SU.IC.SEA MINE DECOY, MOORED"]
            ], I[14e4] = [], I[140100] = [
                s._scale(1.3, A["SU.IC.SEA MINE MILCO"])
            ], I[140101] = [
                s._scale(1.3, [
                    A["SU.IC.SEA MINE MILCO"],
                    A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 1"]
                ])
            ], I[140102] = [
                s._scale(1.3, [
                    A["SU.IC.SEA MINE MILCO"],
                    A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 2"]
                ])
            ], I[140103] = [
                s._scale(1.3, [
                    A["SU.IC.SEA MINE MILCO"],
                    A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 3"]
                ])
            ], I[140104] = [
                s._scale(1.3, [
                    A["SU.IC.SEA MINE MILCO"],
                    A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 4"]
                ])
            ], I[140105] = [
                s._scale(1.3, [
                    A["SU.IC.SEA MINE MILCO"],
                    A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 5"]
                ])
            ], I[140200] = [
                A["SU.IC.SEA MINE MILCO - BOTTOM"]
            ], I[140201] = [
                A["SU.IC.SEA MINE MILCO - BOTTOM"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 1"]
            ], I[140202] = [
                A["SU.IC.SEA MINE MILCO - BOTTOM"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 2"]
            ], I[140203] = [
                A["SU.IC.SEA MINE MILCO - BOTTOM"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 3"]
            ], I[140204] = [
                A["SU.IC.SEA MINE MILCO - BOTTOM"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 4"]
            ], I[140205] = [
                A["SU.IC.SEA MINE MILCO - BOTTOM"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 5"]
            ], I[140300] = [
                A["SU.IC.SEA MINE MILCO - MOORED"]
            ], I[140301] = [
                A["SU.IC.SEA MINE MILCO - MOORED"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 1"]
            ], I[140302] = [
                A["SU.IC.SEA MINE MILCO - MOORED"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 2"]
            ], I[140303] = [
                A["SU.IC.SEA MINE MILCO - MOORED"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 3"]
            ], I[140304] = [
                A["SU.IC.SEA MINE MILCO - MOORED"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 4"]
            ], I[140305] = [
                A["SU.IC.SEA MINE MILCO - MOORED"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 5"]
            ], I[140400] = [
                A["SU.IC.SEA MINE MILCO - FLOATING"]
            ], I[140401] = [
                A["SU.IC.SEA MINE MILCO - FLOATING"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 1"]
            ], I[140402] = [
                A["SU.IC.SEA MINE MILCO - FLOATING"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 2"]
            ], I[140403] = [
                A["SU.IC.SEA MINE MILCO - FLOATING"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 3"]
            ], I[140404] = [
                A["SU.IC.SEA MINE MILCO - FLOATING"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 4"]
            ], I[140405] = [
                A["SU.IC.SEA MINE MILCO - FLOATING"],
                A["SU.IC.SEA MINE MILCO - GENERAL, CONFIDENCE LEVEL 5"]
            ], I[15e4] = [
                s._scale(1.3, A["SU.IC.SEA MINE MILEC"])
            ], I[150100] = [
                A["SU.IC.SEA MINE MILEC - BOTTOM"]
            ], I[150200] = [
                A["SU.IC.SEA MINE MILEC - MOORED"]
            ], I[150300] = [
                A["SU.IC.SEA MINE MILEC - FLOATING"]
            ], I[16e4] = [
                s._scale(1.3, A["SU.IC.SEA MINE NEGATIVE REACQUISITION"])
            ], I[160100] = [
                A["SU.IC.SEA MINE NEGATIVE REACQUISITION - BOTTOM"]
            ], I[160200] = [
                A["SU.IC.SEA MINE NEGATIVE REACQUISITION - MOORED"]
            ], I[160300] = [
                A["SU.IC.SEA MINE NEGATIVE REACQUISITION - FLOATING"]
            ], I[17e4] = [
                s._scale(1.3, A["SU.IC.SEA MINE GENERAL OBSTRUCTOR"])
            ], I[170100] = [
                A["SU.IC.SEA MINE GENERAL OBSTRUCTOR NEUTRALIZED"]
            ], I[18e4] = [
                s._scale(1.3, A["SU.IC.SEA MINE MINE ANCHOR"])
            ], I[19e4] = [
                s._scale(1.3, A["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT"])
            ], I[190100] = [
                A["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - BOTTOM"]
            ], I[190200] = [
                A["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - MOORED"]
            ], I[190300] = [
                A["SU.IC.SEA MINE NON-MINE MINE-LIKE CONTACT - FLOATING"]
            ], I[2e5] = [
                A["SU.IC.ENVIRONMENTAL REPORT LOCATION"]
            ], I[21e4] = [
                A["SU.IC.DIVE REPORT LOCATION"]
            ]);
        }
    }, $ = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: c,
        icons: function(I, t, E, R, e, A, C) {
            "40" == e && (I[11e4] = [], I[110100] = [
                A["AC.IC.CRIMINAL.ACTIVITY.INCIDENT"]
            ], I[110101] = [
                s._scale(1.5, A["ST.IC.ARREST"])
            ], I[110102] = [
                A["ST.IC.ARSON/FIRE"]
            ], I[110103] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.IC.ATTEMPTED CRIMINAL ACTIVITY"]
            ], I[110104] = [
                A["ST.IC.DRIVE-BY SHOOTING"]
            ], I[110105] = [
                A["ST.IC.DRUG RELATED ACTIVITIES"]
            ], I[110106] = [
                A["ST.IC.EXTORTION"]
            ], I[110107] = [
                A["ST.IC.GRAFFITI"]
            ], I[110108] = [
                A["ST.IC.KILLING VICTIM"]
            ], I[110109] = [
                A["ST.IC.POISONING"]
            ], I[110110] = [
                A["ST.IC.RIOT"]
            ], I[110111] = [
                s._scale(1.5, A["ST.IC.BOOBY TRAP"])
            ], I[110112] = [
                A["ST.IC.HOUSE"],
                A["ST.M1.EVICTION"]
            ], I[110113] = [
                A["ST.IC.BLACK MARKETING"]
            ], I[110114] = [
                A["ST.IC.VANDALISM/LOOT/RANSACK/PLUNDER/SACK"]
            ], I[110115] = [
                A["GR.IC.FF.JAIL BREAK"]
            ], I[110116] = [
                A["ST.IC.ROBBERY"]
            ], I[110117] = [
                A["ST.IC.THEFT"]
            ], I[110118] = [
                A["ST.IC.BURGLARY"]
            ], I[110119] = [
                A["ST.IC.SMUGGLING"]
            ], I[110120] = [
                A["ST.IC.ROCK THROWING"]
            ], I[110121] = [
                A["ST.IC.COMPOSITE LOSS"],
                A["ST.M1.DEAD BODY"]
            ], I[110122] = [
                A["ST.IC.SABOTAGE"]
            ], I[110123] = [
                s._translate(0, 10, s._scale(.8, A["AC.IC.CRIMINAL.ACTIVITY.INCIDENT"])),
                A["AC.M1.THREAT"]
            ], I[110200] = [
                A["ST.IC.BOMB"]
            ], I[110201] = [
                A["ST.IC.BOMB"],
                A["AC.M1.THREAT"]
            ], I[110300] = [
                A["ST.IC.IED"]
            ], I[110301] = [
                A["ST.IC.EXPLOSION"],
                A["ST.IC.IED"]
            ], I[110302] = [
                s._translate(0, 15, s._scale(.7, [
                    A["ST.IC.EXPLOSION"],
                    A["ST.IC.IED"]
                ])),
                A["ST.M1.PREMATURE"]
            ], I[110303] = [
                A["ST.IC.IED"],
                A["GR.IC.FF.SUPPLY"]
            ], I[110304] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.M1.IED"]
            ], I[110400] = [
                A["AC.IC.SHOOTING"]
            ], I[110401] = [
                A["ST.IC.SNIPING"]
            ], I[110500] = [
                A["ST.IC.ILLEGAL DRUG OPERATION"]
            ], I[110501] = [
                A["ST.IC.ILLEGAL DRUG OPERATION"],
                A["ST.M1.TRAFFICKING"]
            ], I[110502] = [
                A["ST.IC.ILLEGAL DRUG OPERATION"],
                A["ST.M1.LABRATORY"]
            ], I[110600] = [
                A["ST.IC.EXPLOSION"]
            ], I[110601] = [
                A["ST.IC.EXPLOSION"],
                A["ST.IC.GRENADE"]
            ], I[110602] = [
                A["ST.IC.EXPLOSION"],
                A["ST.IC.INCENDIARY"]
            ], I[110603] = [
                A["ST.IC.EXPLOSION"],
                A["ST.IC.MINE"]
            ], I[110604] = [
                A["ST.IC.EXPLOSION"],
                s._scale(.6, A["GR.EQ.MORTAR"])
            ], I[110605] = [
                A["ST.IC.EXPLOSION"],
                s._scale(.6, A["GR.EQ.SINGLE ROCKET LAUNCHER"])
            ], I[110606] = [
                s._scale(.7, A["ST.IC.BOMB"]),
                A["ST.IC.EXPLOSION"]
            ], I[12e4] = [
                A["AC.IC.CRIMINAL.CIVIL DISTURBANCE"]
            ], I[120100] = [
                A["ST.IC.DEMONSTRATION"]
            ], I[13e4] = [], I[130100] = [
                A["ST.IC.PATROLLING"]
            ], I[130200] = [
                A["ST.IC.PSYCHOLOGICAL OPERATIONS"]
            ], I[130201] = [
                A["ST.IC.RADIO AND TELEVISION PSYCHOLOGICAL OPERATIONS"]
            ], I[130300] = [
                A["ST.IC.SEARCHING"]
            ], I[130400] = [], I[130401] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.M1.WILLING"]
            ], I[130402] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.M1.COERCED/IMPRESSED"]
            ], I[130500] = [
                A["ST.IC.MINE LAYING"]
            ], I[130600] = [
                A["ST.IC.SPY"]
            ], I[130700] = [
                A["ST.IC.WARRANT SERVED"]
            ], I[130800] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.M1.EXFILTRATION"]
            ], I[130900] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.M1.INFILTRATION"]
            ], I[131e3] = [
                A["ST.IC.GROUP"],
                A["ST.M1.MEETING"]
            ], I[131001] = [
                A["ST.IC.POLLING PLACE/ELECTION"]
            ], I[131100] = [
                A["ST.IC.HOUSE"],
                A["ST.M1.RAID"]
            ], I[131200] = [
                A["GR.IC.FF.EMERGENCY OPERATION"]
            ], I[131201] = [
                s._scale(.7, A["GR.IC.FF.EMERGENCY OPERATION"]),
                A["AC.M1.EMERGENCY COLLECTION EVACUATION POINT"]
            ], I[131202] = [
                A["ST.IC.FOOD DISTRIBUTION"]
            ], I[131203] = [
                s._scale(.7, A["GR.IC.FF.EMERGENCY OPERATION"]),
                A["AC.M1.EMERGENCY INCIDENT COMMAND CENTER"]
            ], I[131204] = [
                s._scale(.7, A["GR.IC.FF.EMERGENCY OPERATION"]),
                A["AC.M1.EMERGENCY OPERATIONS CENTER"]
            ], I[131205] = [
                A["AC.IC.EMERGENCY PUBLIC INFORMATION CENTER"]
            ], I[131206] = [
                s._scale(.7, A["GR.IC.FF.EMERGENCY OPERATION"]),
                A["AC.M1.EMERGENCY SHELTER"]
            ], I[131207] = [
                s._scale(.7, A["GR.IC.FF.EMERGENCY OPERATION"]),
                A["AC.M1.EMERGENCY STAGING AREA"]
            ], I[131208] = [
                A["GR.IC.FF.SUPPLY"],
                A["GR.IC.WATER"]
            ], I[131300] = [
                A["GR.IC.EMERGENCY MEDICAL OPERATION"]
            ], I[131301] = [
                A["AC.IC.EMT STATION LOCATION"]
            ], I[131302] = [
                A["AC.IC.HEALTH DEPARTMENT FACILITY"]
            ], I[131303] = [
                A["AC.IC.MEDICAL FACILITIES OUTPATIENT"]
            ], I[131304] = [
                A["AC.IC.OPERATION/EMERGENCY MEDICAL OPERATION"]
            ], I[131305] = [
                A["AC.IC.PHARMACY"]
            ], I[131306] = [
                A["AC.IC.TRIAGE"]
            ], I[131400] = [
                A["GR.IC.FIRE PROTECTION"]
            ], I[131401] = [
                A["AC.IC.FIRE HYDRANT"]
            ], I[131402] = [
                s._scale(1.5, A["GR.IC.FIRE PROTECTION"])
            ], I[131403] = [
                A["AC.IC.OTHER WATER SUPPLY LOCATION"]
            ], I[131500] = [
                A["GR.IC.FF.LAW ENFORCEMENT"]
            ], I[131501] = [
                A["GR.IC.BUREAU OF ALCOHOL, TOBACCO, FIREARMS AND EXPLOSIVES (ATF) (DEPARTMENT OF JUSTICE)"]
            ], I[131502] = [
                A["GR.IC.FF.BORDER PATROL"]
            ], I[131503] = [
                A["GR.IC.FF.CUSTOMS SERVICE"]
            ], I[131504] = [
                A["GR.IC.DRUG ENFORCEMENT AGENCY (DEA)"]
            ], I[131505] = [
                A["GR.IC.FF.DEPARTMENT OF JUSTICE (DOJ)"]
            ], I[131506] = [
                A["GR.IC.FEDERAL BUREAU OF INVESTIGATION (FBI)"]
            ], I[131507] = [
                A["GR.IC.LAW ENFORCEMENT"]
            ], I[131508] = [
                A["GR.IC.FF.PRISON"]
            ], I[131509] = [
                A["GR.IC.UNITED STATES SECRET SERVICE(TREAS) (USSS)"]
            ], I[131510] = [
                A["GR.IC.TRANSPORTATION SECURITY AGENCY (TSA)"]
            ], I[131511] = [
                A["GR.IC.LAW ENFORCEMENT VESSEL"]
            ], I[131512] = [
                A["GR.IC.FF.US MARSHALS SERVICE"]
            ], I[131513] = [
                A["ST.IC.INTERNAL SECURITY FORCE"]
            ], I[14e4] = [
                A["AC.IC.FIRE EVENT"]
            ], I[140100] = [
                A["AC.IC.FIRE ORIGIN"]
            ], I[140200] = [
                A["AC.IC.SMOKE"]
            ], I[140300] = [
                A["AC.IC.HOT SPOT"]
            ], I[140400] = [
                A["AC.IC.NON-REsIdENTIAL FIRE"]
            ], I[140500] = [
                A["AC.IC.REsIdENTIAL FIRE"]
            ], I[140600] = [
                A["AC.IC.SCHOOL FIRE"]
            ], I[140700] = [
                A["AC.IC.SPECIAL NEEDS FIRE"]
            ], I[140800] = [
                A["AC.IC.WILD FIRE"]
            ], I[15e4] = [], I[150100] = [
                A["AC.IC.HAZARDOUS MATERIALS INCIDENT"]
            ], I[150101] = [
                A["AC.IC.CHEMICAL AGENT"]
            ], I[150102] = [
                A["AC.IC.CORROSIVE MATERIAL"]
            ], I[150103] = [
                A["AC.IC.HAZARDOUS WHEN WET"]
            ], I[150104] = [
                A["AC.IC.EXPLOSIVE MATERIAL"]
            ], I[150105] = [
                A["AC.IC.FLAMMABLE GAS"]
            ], I[150106] = [
                A["AC.IC.FLAMMABLE LIQUID"]
            ], I[150107] = [
                A["AC.IC.FLAMMABLE SOLID"]
            ], I[150108] = [
                A["AC.IC.NON-FLAMMABLE GAS"]
            ], I[150109] = [
                A["AC.IC.ORGANIC PEROXIDE"]
            ], I[150110] = [
                A["AC.IC.OXIDIZER"]
            ], I[150111] = [
                A["AC.IC.RADIOACTIVE MATERIAL"]
            ], I[150112] = [
                A["AC.IC.SPONTANEOUSLY COMBUSTIBLE MATERIAL"]
            ], I[150113] = [
                A["AC.IC.TOXIC GAS"]
            ], I[150114] = [
                A["AC.IC.TOXIC INFECTIOUS MATERIAL"]
            ], I[150115] = [
                A["AC.IC.UNEXPLODED ORDNANCE"]
            ], I[16e4] = [
                A["GR.IC.TRANSPORTATION"]
            ], I[160100] = [
                A["ST.IC.HIJACKING (AIRPLANE)"]
            ], I[160200] = [
                A["ST.IC.HIJACKING (BOAT)"]
            ], I[160300] = [
                A["GR.EQ.TRAIN LOCOMOTIVE"]
            ], I[160400] = [
                A["ST.IC.KNOWN INSURGENT VEHICLE"]
            ], I[160500] = [
                A["ST.IC.EXPLOSION"],
                s._scale(.7, A["ST.IC.KNOWN INSURGENT VEHICLE"])
            ], I[17e4] = [
                A["ST.IC.NATURAL EVENT"]
            ], I[170100] = [
                A["ST.IC.GEOLOGIC"]
            ], I[170101] = [
                A["AC.IC.AFTERSHOCK"]
            ], I[170102] = [
                A["AC.IC.AVALANCHE"]
            ], I[170103] = [
                A["AC.IC.EARTHQUAKE EPICENTER"]
            ], I[170104] = [
                A["AC.IC.LANDSLIDE"]
            ], I[170105] = [
                A["AC.IC.SUBSIDENCE"]
            ], I[170106] = [
                A["AC.IC.VOLCANIC ERUPTION"]
            ], I[170107] = [
                A["AC.IC.VOLCANIC THREAT"]
            ], I[170108] = [
                A["AC.IC.CAVE ENTRANCE"]
            ], I[170200] = [
                A["ST.IC.HYDRO-METEOROLOGICAL"]
            ], I[170201] = [
                A["AC.IC.DROUGHT"]
            ], I[170202] = [
                A["AC.IC.FLOOD"]
            ], I[170203] = [
                A["AC.IC.TSUNAMI"]
            ], I[170300] = [
                A["ST.IC.INFESTATION"]
            ], I[170301] = [
                A["AC.IC.BIRD"]
            ], I[170302] = [
                A["AC.IC.INSECT"]
            ], I[170303] = [
                A["AC.IC.MICROBIAL"]
            ], I[170304] = [
                A["AC.IC.REPTILE"]
            ], I[170305] = [
                A["AC.IC.RODENT"]
            ], I[18e4] = [], I[180100] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.M1.LEADER"],
                A["ST.M2.RELIGIOUS"]
            ], I[180200] = [
                A["ST.IC.INDIVIDUAL"],
                A["ST.M1.SPEAKER"]
            ], t["01"] = [
                A["ST.M1.ASSASSINATION"]
            ], t["02"] = [
                A["ST.M1.EXECUTION (WRONGFUL KILLING)"]
            ], t["03"] = [
                A["ST.M1.HIJACKING/HIJACKED"]
            ], t["04"] = [
                A["ST.M1.HOUSE-TO-HOUSE"]
            ], t["05"] = [
                A["ST.M1.KIDNAPPING"]
            ], t["06"] = [
                A["ST.M1.MURDER"]
            ], t["07"] = [
                A["ST.M1.PIRACY"]
            ], t["08"] = [
                A["ST.M1.RAPE"]
            ], t["09"] = [
                A["ST.M1.WRITTEN PSYCHOLOGICAL OPERATIONS"]
            ], t[10] = [
                A["ST.M1.PIRATE"]
            ], t[11] = [
                A["ST.M1.FALSE"]
            ], t[12] = [
                A["ST.M1.FIND"]
            ], t[13] = [
                A["ST.M1.FOUND AND CLEARED"]
            ], t[14] = [
                A["ST.M1.HOAX (DECOY)"]
            ], t[15] = [
                A["ST.M1.ATTEMPTED"]
            ], t[16] = [
                A["ST.M1.ACCIDENT"]
            ], t[17] = [
                A["ST.M1.INCIDENT"]
            ], t[18] = [
                A["ST.M1.THEFT"]
            ], t[19] = [
                A["GR.M1.HIJACKER"]
            ], t[20] = [
                A["GR.M1.CYBERSPACE"]
            ], E["01"] = [
                A["GR.M2.CYBERSPACE"]
            ], E["02"] = [
                A["GR.M2.SECURITY FORCE ASSISTANCE"]
            ]);
        }
    }, II = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: f,
        icons: function(I, t, E, R, e, A, C) {
            "50" != e && "51" != e && "52" != e && "53" != e && "54" != e || (I[11e4] = [], I[110100] = [
                A["SI.IC.COMMUNICATIONS"]
            ], I[110200] = [
                A["SI.I.JAMMER / ELECTRONIC COUNTER-MEASURES"]
            ], I[110300] = [
                A["SI.IC.RADAR"]
            ], t["01"] = [
                A["SI.M1.ANTI-AIRCRAFT FIRE CONTROL"]
            ], t["02"] = [
                A["SI.M1.AIRBORNE SEARCH AND BOMBING"]
            ], t["03"] = [
                A["SI.M1.AIRBORNE INTERCEPT"]
            ], t["04"] = [
                A["SI.M1.ALTIMETER"]
            ], t["05"] = [
                A["SI.M1.AIRBORNE RECONNAISSANCE AND MAPPING"]
            ], t["06"] = [
                A["SI.M1.AIR TRAFFIC CONTROL"]
            ], t["07"] = [
                A["SI.M1.BEACON TRANSPONDER (NOT IFF)"]
            ], t["08"] = [
                A["SI.M1.BATTLEFIELD SURVEILLANCE"]
            ], t["09"] = [
                A["SI.M1.CONTROLLED APPROACH"]
            ], t[10] = [
                A["SI.M1.CONTROLLED INTERCEPT"]
            ], t[11] = [
                A["SI.M1.CELLULAR/MOBILE"]
            ], t[12] = [
                A["SI.M1.COASTAL SURVEILLANCE"]
            ], t[13] = [
                A["SI.M1.DECOY/MIMIC"]
            ], t[14] = [
                A["SI.M1.DATA TRANSMISSION"]
            ], t[15] = [
                A["SI.M1.EARTH SURVEILLANCE"]
            ], t[16] = [
                A["SI.M1.EARLY WARNING"]
            ], t[17] = [
                A["SI.M1.FIRE CONTROL"]
            ], t[18] = [
                A["SI.M1.GROUND MAPPING"]
            ], t[19] = [
                A["SI.M1.HEIGHT FINDING"]
            ], t[20] = [
                A["SI.M1.HARBOR SURVEILLANCE"]
            ], t[21] = [
                A["SI.M1.IDENTIFICATION, FRIEND OR FOE (INTERROGATOR)"]
            ], t[22] = [
                A["SI.M1.INSTRUMENT LANDING SYSTEM"]
            ], t[23] = [
                A["SI.M1.IONOSPHERIC SOUNDING"]
            ], t[24] = [
                A["SI.M1.IDENTIFICATION, FRIEND OR FOE (TRANSPONDER)"]
            ], t[25] = [
                A["SI.M1.BARRAGE JAMMER"]
            ], t[26] = [
                A["SI.M1.CLICK JAMMER"]
            ], t[27] = [
                A["SI.M1.DECEPTIVE JAMMER"]
            ], t[28] = [
                A["SI.M1.FREQUENCY SWEPT JAMMER"]
            ], t[29] = [
                A["SI.M1.JAMMER (GENERAL)"]
            ], t[30] = [
                A["SI.M1.NOISE JAMMER"]
            ], t[31] = [
                A["SI.M1.PULSED JAMMER"]
            ], t[32] = [
                A["SI.M1.REPEATER JAMMER"]
            ], t[33] = [
                A["SI.M1.SPOT NOISE JAMMER"]
            ], t[34] = [
                A["SI.M1.TRANSPONDER JAMMER"]
            ], t[35] = [
                A["SI.M1.MISSILE ACQUISITION"]
            ], t[36] = [
                A["SI.M1.MISSILE CONTROL"]
            ], t[37] = [
                A["SI.M1.MISSILE DOWNLINK"]
            ], t[38] = [
                A["SI.M1.METEOROLOGICAL"]
            ], t[39] = [
                A["SI.M1.MULTI-FUNCTION"]
            ], t[40] = [
                A["SI.M1.MISSILE GUIDANCE"]
            ], t[41] = [
                A["SI.M1.MISSILE HOMING"]
            ], t[42] = [
                A["SI.M1.MISSILE TRACKING"]
            ], t[43] = [
                A["SI.M1.NAVIGATIONAL/GENERAL"]
            ], t[44] = [
                A["SI.M1.NAVIGATIONAL/DISTANCE MEASURING EQUIPMENT"]
            ], t[45] = [
                A["SI.M1.NAVIGATION/TERRAIN FOLLOWING"]
            ], t[46] = [
                A["SI.M1.NAVIGATIONAL/WEATHER AVOIDANCE"]
            ], t[47] = [
                A["SI.M1.OMNI-LINE OF SIGHT (LOS)"]
            ], t[48] = [
                A["SI.M1.PROXIMITY USE"]
            ], t[49] = [
                A["SI.M1.POINT-TO-POINT LINE OF SIGHT (LOS)"]
            ], t[50] = [
                A["SI.M1.INSTRUMENTATION"]
            ], t[51] = [
                A["SI.M1.RANGE ONLY"]
            ], t[52] = [
                A["SI.M1.SONOBUOY"]
            ], t[53] = [
                A["SI.M1.SATELLITE DOWNLINK"]
            ], t[54] = [
                A["SI.M1.SPACE"]
            ], t[55] = [
                A["SI.M1.SURFACE SEARCH"]
            ], t[56] = [
                A["SI.M1.SHELL TRACKING"]
            ], t[57] = [
                A["SI.M1.SATELLITE UPLINK"]
            ], t[58] = [
                A["SI.M1.TARGET ACQUISITION"]
            ], t[59] = [
                A["SI.M1.TARGET ILLUMINATION"]
            ], t[60] = [
                A["SI.M1.TROPOSPHERIC SCATTER"]
            ], t[61] = [
                A["SI.M1.TARGET TRACKING"]
            ], t[62] = [
                A["SI.M1.UNKNOWN"]
            ], t[63] = [
                A["SI.M1.VIDEO REMOTING"]
            ], t[64] = [
                A["SI.M1.EXPERIMENTAL"]
            ], t[65] = [
                A["SI.M1.CYBER"]
            ], E["01"] = [
                A["SI.M2.CYBER"]
            ]);
        }
    };
    var tI = {
        type: "number",
        getMetadata: u,
        getIcons: v,
        iconParts: V,
        labels: function(I) {
            var t = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                uniqueDesignation1: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 30,
                    fontsize: 30
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, E = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, R = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                uniqueDesignation1: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 20,
                    fontsize: 30
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            };
            I[130100] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -70,
                    fontsize: 40
                },
                additionalInformation1: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -25,
                    fontsize: 30
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 45,
                    fontsize: 40
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 0,
                    fontsize: 80
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: -30,
                    fontsize: 40
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "end",
                    x: 50,
                    y: 10,
                    fontsize: 40
                }
            }, I[130200] = t, I[130300] = t, I[130400] = {}, I[130500] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 115,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I[130600] = {}, I[130700] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 115,
                    fontsize: 45,
                    fontweight: "bold"
                }
            }, I[130800] = t, I[130900] = t, I[131001] = E, I[131002] = E, I[131003] = E, I[131100] = t, I[131200] = t, I[131300] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 30,
                    fontsize: 40,
                    fontweight: "bold"
                }
            }, I[131301] = {}, I[131400] = t, I[131500] = t, I[131600] = t, I[131700] = {}, I[131800] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 125,
                    fontsize: 70
                }
            }, I[131900] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 115,
                    fontsize: 40
                }
            }, I[132e3] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 80,
                    fontsize: 40
                }
            }, I[132100] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 100,
                    y: 110,
                    fontsize: 35,
                    fill: "rgb(255,255,255)",
                    fontweight: "bold"
                }
            }, I[160100] = {}, I[160200] = {}, I[160201] = {}, I[160202] = {}, I[160203] = {}, I[160204] = {}, I[160205] = {}, I[160300] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 110,
                    y: 90,
                    fontsize: 40
                }
            }, I[160400] = E, I[18e4] = {}, I[180100] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 130,
                    fontsize: 35
                }
            }, I[180200] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 130,
                    fontsize: 35
                }
            }, I[180300] = {}, I[180400] = {}, I[180500] = {}, I[180600] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 70,
                    fontsize: 35
                }
            }, I[180700] = {}, I[180800] = {}, I[180900] = {}, I[181e3] = {}, I[181100] = {}, I[181200] = {}, I[181300] = {}, I[181400] = {}, I[181500] = {}, I[181600] = {}, I[181700] = {}, I[181800] = {}, I[181900] = {}, I[182e3] = {}, I[182100] = {}, I[182200] = {}, I[182300] = {}, I[182400] = {}, I[182500] = {}, I[200400] = {}, I[200500] = {}, I[200600] = {}, I[200700] = {}, I[210100] = {}, I[210200] = {}, I[210300] = {}, I[210400] = {}, I[210500] = {}, I[210600] = {
                altitudeDepth: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 70,
                    fontsize: 35
                }
            }, I[210700] = {}, I[210800] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 80,
                    fontsize: 35
                }
            }, I[210900] = {}, I[211e3] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 80,
                    fontsize: 35
                }
            }, I[211100] = {}, I[211200] = {}, I[211300] = {}, I[211400] = {}, I[211500] = {}, I[211600] = {}, I[211700] = {}, I[211800] = {}, I[211900] = {}, I[212e3] = {}, I[212100] = {}, I[212200] = {}, I[212300] = {}, I[212400] = {}, I[212500] = {}, I[212600] = {}, I[212700] = {}, I[212800] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 115,
                    fontsize: 45
                }
            }, I[212900] = {}, I[212901] = {}, I[212902] = {}, I[212903] = {}, I[212904] = {}, I[213e3] = {}, I[213100] = {}, I[213200] = {}, I[213300] = {}, I[213400] = {}, I[213500] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 70,
                    fontsize: 35
                },
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213501] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 70,
                    fontsize: 35
                },
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213502] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213503] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213504] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 70,
                    fontsize: 35
                },
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213505] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213506] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213507] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 70,
                    fontsize: 35
                },
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213508] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 70,
                    fontsize: 35
                },
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213509] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213510] = {}, I[213511] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213512] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213513] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213514] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213515] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 140,
                    y: 70,
                    fontsize: 35
                },
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 150,
                    y: 105,
                    fontsize: 35
                }
            }, I[213600] = {}, I[213700] = {}, I[213800] = {}, I[213900] = {}, I[214e3] = {}, I[214100] = {}, I[214200] = {}, I[214300] = {}, I[214400] = {}, I[214500] = {}, I[214600] = {}, I[214700] = {}, I[214800] = {}, I[214900] = {
                dtg: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 75,
                    fontsize: 30
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 100,
                    fontsize: 30
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 125,
                    fontsize: 30
                }
            }, I[215e3] = {}, I[215100] = {}, I[215200] = {}, I[215300] = {}, I[215400] = {}, I[215500] = {}, I[215600] = {
                dtg: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 75,
                    fontsize: 30
                },
                dtg1: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 100,
                    fontsize: 30
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 125,
                    fontsize: 30
                }
            }, I[215700] = {}, I[215800] = {}, I[215900] = {}, I[216e3] = {}, I[216100] = {}, I[216200] = {}, I[216300] = {}, I[216400] = {}, I[216500] = {}, I[216600] = {}, I[216700] = {}, I[216800] = {}, I[216900] = {}, I[217e3] = {}, I[217100] = {}, I[217200] = {}, I[217300] = {}, I[217400] = {}, I[217500] = {}, I[217600] = {}, I[217700] = {}, I[217800] = {}, I[217900] = {}, I[218e3] = {}, I[218100] = {}, I[218200] = {}, I[218300] = {}, I[218500] = {}, I[218600] = {}, I[218700] = {}, I[218800] = {}, I[218900] = {}, I[219e3] = {}, I[219100] = {}, I[219200] = {}, I[240601] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 145,
                    fontsize: 40
                },
                altitudeDepth: {
                    stroke: !1,
                    textanchor: "end",
                    x: 80,
                    y: 145,
                    fontsize: 40
                },
                targetNumber: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 80,
                    fontsize: 40
                }
            }, I[240602] = {
                targetNumber: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 80,
                    fontsize: 40
                }
            }, I[240603] = {}, I[240900] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 195,
                    y: 110,
                    fontsize: 35,
                    fontweight: "bold"
                }
            }, I[250100] = E, I[250200] = E, I[250300] = E, I[250400] = E, I[250500] = E, I[250600] = {
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 180,
                    y: 80,
                    fontsize: 35
                }
            }, I[270601] = {}, I[270602] = {}, I[270603] = {}, I[270701] = {}, I[280100] = {}, I[280200] = {}, I[280201] = {}, I[280300] = {}, I[280400] = {}, I[280500] = {}, I[280600] = {}, I[280700] = {}, I[280800] = t, I[280900] = {}, I[281e3] = {}, I[281100] = {}, I[281200] = {}, I[281300] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 30,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 30,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 90,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -20,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 90,
                    fontsize: 35
                }
            }, I[281301] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 30,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 30,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 90,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -20,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 90,
                    fontsize: 35
                }
            }, I[281400] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 30,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 30,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 90,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -20,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 90,
                    fontsize: 35
                }
            }, I[281500] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 30,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 30,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 90,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -20,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 90,
                    fontsize: 35
                }
            }, I[281600] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 30,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 30,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 90,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -20,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 90,
                    fontsize: 35
                }
            }, I[281700] = {
                additionalInformation: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 30,
                    fontsize: 35
                },
                dtg: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 30,
                    fontsize: 35
                },
                hostile: {
                    stroke: !1,
                    textanchor: "start",
                    x: 160,
                    y: 90,
                    fontsize: 35
                },
                location: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: 135,
                    fontsize: 35
                },
                quantity: {
                    stroke: !1,
                    textanchor: "middle",
                    x: 100,
                    y: -20,
                    fontsize: 35
                },
                uniqueDesignation: {
                    stroke: !1,
                    textanchor: "end",
                    x: 40,
                    y: 90,
                    fontsize: 35
                }
            }, I[281800] = t, I[281801] = t, I[281802] = t, I[281803] = t, I[281804] = t, I[281805] = t, I[281806] = t, I[281807] = t, I[281808] = t, I[281809] = t, I[281901] = {}, I[281902] = {}, I[281903] = {}, I[282001] = {
                altitudeDepth: {
                    stroke: !1,
                    textanchor: "start",
                    x: 120,
                    y: 60,
                    fontsize: 40,
                    fontweight: "bold"
                }
            }, I[282002] = {
                altitudeDepth: {
                    stroke: !1,
                    textanchor: "start",
                    x: 115,
                    y: 60,
                    fontsize: 40,
                    fontweight: "bold"
                }
            }, I[320100] = {}, I[320101] = t, I[320102] = t, I[320103] = t, I[320104] = t, I[320200] = t, I[320300] = t, I[320400] = t, I[320500] = t, I[320600] = t, I[320700] = t, I[320800] = t, I[320900] = t, I[321e3] = t, I[321100] = t, I[321200] = t, I[321300] = t, I[321400] = t, I[321500] = t, I[321600] = t, I[321700] = R, I[321701] = R, I[321702] = R, I[321703] = R, I[321704] = R, I[321705] = R, I[321706] = {}, I[321707] = E, I[321708] = E, I[321709] = E, I[321710] = E, I[321711] = E, I[321712] = E, I[321713] = E, I[321714] = E, I[321715] = E, I[321716] = E, I[321800] = R, I[340300] = {}, I[340400] = {}, I[340900] = {}, I[341400] = {}, I[341600] = {}, I[342800] = {}, I[350101] = {}, I[350102] = {}, I[350103] = {}, I[350201] = {}, I[350202] = {}, I[350203] = {};
        },
        icons: function(I, t, E, R, e, A, C) {
            "25" == e && (I[130100] = A["TP.ACTION POINT"], R[130100] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[130200] = A["TP.ACTION AMNESTY POINT"], R[130200] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[130300] = A["TP.ACTION CHECK POINT"], R[130300] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[130400] = A["TP.CENTRE OF MAIN EFFORT"], R[130400] = {
                x1: 25,
                x2: 175,
                y1: 65,
                y2: 135
            }, I[130500] = A["TP.CONTACT POINT"], R[130500] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[130600] = A["TP.COORDINATION POINT"], R[130600] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[130700] = A["TP.DECISION POINT"], R[130700] = {
                x1: 30,
                x2: 170,
                y1: 25,
                y2: 160
            }, I[130800] = A["TP.DISTRESS CALL"], R[130800] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[130900] = A["TP.ENTRY CONTROL POINT"], R[130900] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131001] = A["TP.FLY-TO-POINT (SONOBUOY)"], R[131001] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131002] = A["TP.FLY-TO-POINT (WEAPON)"], R[131002] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131003] = A["TP.FLY-TO-POINT (NORMAL)"], R[131003] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131100] = A["TP.ACTION LINKUP POINT"], R[131100] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131200] = A["TP.ACTION PASSAGE POINT"], R[131200] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131300] = A["TP.POINT OF INTEREST"], R[131300] = {
                x1: 50,
                x2: 150,
                y1: -25
            }, I[131301] = A["POINT OF INTEREST \u2013 LAUNCH EVENT"], R[131301] = {
                x1: 50,
                x2: 150,
                y1: -25
            }, I[131400] = A["TP.ACTION RALLY POINT"], R[131400] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131500] = A["TP.ACTION RELEASE POINT"], R[131500] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131600] = A["TP.ACTION START POINT"], R[131600] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[131700] = A["TP.SPECIAL POINT"], R[131700] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[131800] = A["TP.WAYPOINT"], R[131800] = {
                x1: 60,
                x2: 140,
                y1: 60,
                y2: 140
            }, I[131900] = A["TP.AIRFIELD"], R[131900] = {
                x1: 35,
                x2: 165,
                y1: 60,
                y2: 125
            }, I[132e3] = A["TP.TARGET HANDOVER"], R[132e3] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[132100] = A["TP.KEY TERRAIN"], I[160100] = A["TP.OBSERVATION POST/OUTPOST"], R[160100] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I[160200] = A["TP.OBSERVATION POST/OUTPOST"], R[160200] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I[160201] = A["TP.OBSERVATION POST/RECONNAISSANCE"], R[160201] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I[160202] = A["TP.FORWARD OBSERVER POSITION"], R[160202] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I[160203] = A["TP.CBRN OBSERVATION POST"], R[160203] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I[160204] = A["TP.SENSOR OUTPOST"], R[160204] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I[160205] = A["TP.COMBAT OUTPOST"], R[160205] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 150
            }, I[160300] = A["TP.TARGET REFERENCE"], I[160400] = A["TP.POINT OF DEPARTURE"], R[160400] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[18e4] = A["TP.AIR CONTROL POINT"], R[18e4] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I[180100] = A["TP.AIR CONTROL POINT (ACP)"], R[180100] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[180200] = A["TP.COMMUNICATIONS CHECKPOINT"], R[180200] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[180300] = A["TP.DOWNED AIRCREW PICKUP POINT"], R[180300] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[180400] = A["TP.PULL-UP POINT"], R[180400] = {
                x1: 50,
                x2: 240,
                y1: 50,
                y2: 150
            }, I[180500] = A["TP.AIR CONTROL RENDEZVOUS"], R[180500] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[180600] = A["TP.TACAN"], R[180600] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[180700] = A["TP.CAP STATION"], R[180700] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[180800] = A["TP.AEW STATION"], R[180800] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[180900] = A["TP.FIXED WING"], I[181e3] = A["TP.STRIKE IP"], R[181e3] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[181100] = A["TP.REPLENISHMENT STATION"], R[181100] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[181200] = A["TP.TANKING"], R[181200] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[181300] = A["TP.SUCAP - ROTARY WING"], R[181300] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I[181400] = A["TP.SUCAP - FIXED WING"], R[181400] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I[181500] = A["TP.SUCAP - ROTARY WING"], R[181500] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I[181600] = A["TP.MIW - FIXED WING"], R[181600] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I[181700] = A["TP.MIW - ROTARY WING"], R[181700] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 160
            }, I[181800] = A["TP.TOMCAT"], R[181800] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[181900] = A["TP.RESCUE"], R[181900] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[182e3] = A["TP.UNMANNED AERIAL SYSTEM"], R[182e3] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[182100] = A["TP.VTUA"], R[182100] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[182200] = A["TP.ORBIT"], R[182200] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[182300] = A["TP.ORBIT - FIGURE EIGHT"], R[182300] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[182400] = A["TP.ORBIT - RACE TRACK"], R[182400] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[182500] = A["TP.ORBIT - RANDOM, CLOSED"], R[182500] = {
                x1: 60,
                x2: 140,
                y1: 30,
                y2: 170
            }, I[200400] = A["TP.SHIP AREA OF INTEREST (AEGIS ONLY)"], I[200500] = A["TP.ACTIVE MANOEUVRE AREA (AEGIS ONLY)"], R[200500] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[200600] = A.TODO, I[200700] = A.TODO, I[210100] = A["TP.PLAN SHIP"], R[210100] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[210200] = A["TP.AIM POINT"], R[210200] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[210300] = A["TP.DEFENDED ASSET"], I[210400] = A["TP.DROP POINT"], R[210400] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 120
            }, I[210500] = A["TP.ENTRY POINT"], R[210500] = {
                x1: 50,
                x2: 150,
                y1: 50
            }, I[210600] = A["TP.AIR DETONATION"], I[210700] = A["TP.GROUND ZERO"], R[210700] = {
                x1: 50,
                x2: 150,
                y1: 30
            }, I[210800] = A["TP.IMPACT POINT"], R[210800] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[210900] = A["TP.PREDICTED IMPACT POINT"], R[210900] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[211e3] = A["TP.LAUNCHED TORPEDO (AEGIS ONLY)"], R[211e3] = {
                x1: 50,
                x2: 150,
                y1: 90,
                y2: 110
            }, I[211100] = A["TP.MSL DETECT POINT"], R[211100] = {
                x1: 50,
                x2: 150,
                y1: 30
            }, I[211200] = A["TP.ACOUSTIC COUNTER MEASURE (DECOY)"], R[211200] = {
                x1: 50,
                x2: 150,
                y1: 30
            }, I[211300] = A["TP.ELECTRONIC COUNTER MEASURES (ECM) DECOY"], R[211300] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[211400] = A["TP.BRIEF CONTACT"], R[211400] = {
                x1: 50,
                x2: 150,
                y1: 0,
                y2: 100
            }, I[211500] = A["TP.DATUM"], R[211500] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[211600] = A["TP.BT BOUY DROP"], R[211600] = {
                x1: 50,
                x2: 150,
                y1: 40,
                y2: 160
            }, I[211700] = A["TP.REPORTED BOTTOMED SUB"], I[211800] = A["TP.MOVING HAVEN"], R[211800] = {
                x1: 40,
                x2: 160,
                y1: 50,
                y2: 150
            }, I[211900] = A["TP.SCREEN CENTRE"], I[212e3] = A["TP.LOST CONTACT"], R[212e3] = {
                x1: 50,
                x2: 150,
                y1: 0,
                y2: 100
            }, I[212100] = A["TP.SINKER"], R[212100] = {
                x1: 50,
                x2: 150,
                y1: 0,
                y2: 100
            }, I[212200] = A["TP.TRIAL TRACK"], R[212200] = {
                x1: 50,
                x2: 150,
                y1: 0,
                y2: 100
            }, I[212300] = A["TP.FIX ACOUSTIC"], I[212400] = A["TP.FIX ELECTRO-MAGNETIC"], I[212500] = A["TP.ELECTRO MAGNETIC - MAGNETIC ANOMALY DETECTION (MAD)"], R[212500] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 180
            }, I[212600] = A["TP.FIX ELECTRO-OPTICAL"], I[212700] = A["TP.TARGET REFERENCE"], I[212800] = A["TP.HARBOR"], R[212800] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[212900] = A["TP.HARBOR"], R[212900] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[212901] = A["TP.HARBOR POINT A"], R[212901] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[212902] = A["TP.HARBOR POINT Q"], R[212902] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[212903] = A["TP.HARBOR POINT X"], R[212903] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[212904] = A["TP.HARBOR POINT Y"], R[212904] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[213e3] = A["TP.DIP POSITION"], R[213e3] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[213100] = A["TP.SEARCH"], R[213100] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[213200] = A["TP.SEARCH AREA"], R[213200] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[213300] = A["TP.SEARCH CENTER"], R[213300] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[213400] = A["TP.NAVIGATIONAL REFERENCE"], I[213500] = A["TP.SONOBUOY"], R[213500] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213501] = A["TP.SONOBUOY ANM"], R[213501] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213502] = A["TP.SONOBUOY ATAC"], R[213502] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213503] = A["TP.SONOBUOY BARRA"], R[213503] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213504] = A["TP.SONOBUOY BATHYTHERMOGRAPH TRANSMITTING SONOBUOY (BT)"], R[213504] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213505] = A["TP.SONOBUOY COMMAND ACTIVE MULTIBEAM SONOBUOY (CAMBS)"], R[213505] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213506] = A["TP.SONOBUOY CASS"], R[213506] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213507] = A["TP.SONOBUOY DIFAR"], R[213507] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213508] = A["TP.SONOBUOY DICASS"], R[213508] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213509] = A["TP.SONOBUOY EXPENDABLE RELIABLE ACOUSTIC PATH SONOBUOY (ERAPS)"], R[213509] = {
                x1: 60,
                x2: 140,
                y1: -10,
                y2: 160
            }, I[213510] = A["TP.SONOBUOY EXPIRED"], R[213510] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 160
            }, I[213511] = A["TP.SONOBUOY KINGPIN"], R[213511] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 160
            }, I[213512] = A["TP.SONOBUOY LOFAR"], R[213512] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 160
            }, I[213513] = A["TP.SONOBUOY PATTERN CENTER"], R[213513] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 160
            }, I[213514] = A["TP.SONOBUOY RO"], R[213514] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 160
            }, I[213515] = A["TP.SONOBUOY VLAD"], R[213515] = {
                x1: 40,
                x2: 160,
                y1: -10,
                y2: 160
            }, I[213600] = A["TP.REFERENCE POINT"], R[213600] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[213700] = A["TP.SPECIAL POINT"], R[213700] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[213800] = A["TP.NAVIGATIONAL REFERENCE"], R[213800] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[213900] = A["TP.DLRP"], R[213900] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214e3] = A["FORWARD OBSERVER / SPOTTER POSITION"], R[214e3] = {
                x1: 40,
                x2: 160,
                y1: 60,
                y2: 140
            }, I[214100] = A["TP.VITAL AREA CENTRE"], R[214100] = {
                x1: 40,
                x2: 160,
                y1: 60,
                y2: 140
            }, I[214200] = A["TP.CORRIDOR TAB"], R[214200] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214300] = A["TP.ENEMY POINT"], R[214300] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214400] = A["TP.MARSHALL POINT"], R[214400] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214500] = A["TP.POINT OF INTENDED MOVEMENT"], R[214500] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214600] = A["TP.PRE-LANDFALL WAYPOINT"], R[214600] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214700] = A["TP.ESTIMATED POSITION (EP)"], R[214700] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214800] = A["TP.REFERENCE POINT WAYPOINT"], R[214800] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[214900] = A["TP.SUB SURFACE CONTROL STATION"], R[214900] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215e3] = A["TP.SUBMARINE CONTROL STATION"], R[215e3] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215100] = A["TP.ASW SUBMARINE CONTROL STATION"], R[215100] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215200] = A["TP.(UUV) CONTROL STATION"], R[215200] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215300] = A["TP.UUV - ASW CONTROL STATION"], R[215300] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215400] = A["TP.MINE WARFARE UNMANNED UNDERWATER VEHICLE SUBSURFACE STATION"], R[215400] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215500] = A["TP.UUV - SUW CONTROL STATION"], R[215500] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215600] = A["TP.SEA SURFACE CONTROL STATION"], R[215600] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215700] = A["TP.ASW CONTROL STATION"], R[215700] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215800] = A["TP.MINE WARFARE SURFACE STATION"], R[215800] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[215900] = A["TP.NON-COMBATANT SURFACE STATION"], R[215900] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216e3] = A["TP.PICKET CONTROL STATION"], R[216e3] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216100] = A["TP.RENDEZVOUS CONTROL POINT"], R[216100] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216200] = A["TP.REPLENISHMENT AT SEA SURFACE STATION"], R[216200] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216300] = A["TP.RESCUE CONTROL POINT"], R[216300] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216400] = A["TP.SUW CONTROL STATION"], R[216400] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216500] = A["TP.(USV) CONTROL STATION"], R[216500] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216600] = A["TP.USV - ASW CONTROL STATION"], R[216600] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216700] = A["TP.MINE WARFARE UNMANNED UNDERWATER VEHICLE SURFACE STATION"], R[216700] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216800] = A["TP.(RMV) USV CONTROL STATION"], R[216800] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[216900] = A["TP.USV - SUW CONTROL STATION"], R[216900] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[217e3] = A["TP.SHORE CONTROL STATION"], R[217e3] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 160
            }, I[217100] = A["TP.ROUTE"], R[217100] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[217200] = A["TP.ROUTE DIVERSIONS"], R[217200] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I[217300] = A["TP.ROUTE POINT R"], R[217300] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I[217400] = A["TP.PICKET ROUTE"], R[217400] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I[217500] = A["TP.POINT R ROUTE"], R[217500] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I[217600] = A["TP.RENDEZVOUS ROUTE"], R[217600] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I[217700] = A["TP.ROUTE WAYPOINT"], R[217700] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 170
            }, I[217800] = A["TP.CLUTTER, STATIONARY OR CEASE REPORTING"], I[217900] = A["TP.TENTATIVE OR PROVISIONAL TRACK"], I[218e3] = A["TP.DISTRESSED VESSEL"], I[218100] = A["TP.DITCHED AIRCRAFT"], I[218200] = A["TP.PERSON IN WATER"], I[218300] = A["TP.ICEBERG"], R[218300] = {
                x1: 50,
                x2: 150,
                y1: 50,
                y2: 150
            }, I[218500] = A["TP.OIL RIG/PLATFORM"], R[218500] = {
                x1: 30,
                x2: 170,
                y1: 60,
                y2: 140
            }, I[218600] = A["TP.SEA MINELIKE"], R[218600] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 150
            }, I[218700] = A["TP.BOTTOM RETURN"], R[218700] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 100
            }, I[218800] = A["TP.INSTALLATION/MANMADE"], R[218800] = {
                x1: 40,
                x2: 160,
                y1: 40,
                y2: 100
            }, I[218900] = A["TP.MARINE LIFE"], R[218900] = {
                x1: 100,
                x2: 220,
                y1: 70,
                y2: 130
            }, I[219e3] = A["TP.SEA ANOMALY"], R[219e3] = {
                x1: 50,
                x2: 150,
                y1: 30,
                y2: 120
            }, I[219100] = A["TP.WRECK, DANGEROUS"], R[219100] = {
                x1: 40,
                x2: 160,
                y1: 70,
                y2: 130
            }, I[219200] = A["TP.WRECK, NON DANGEROUS"], R[219200] = {
                x1: 40,
                x2: 160,
                y1: 70,
                y2: 130
            }, I[240601] = A["TP.POINT/SINGLE TARGET"], I[240602] = A["TP.NUCLEAR TARGET"], I[240603] = A["TP.TARGETRECORDED (AEGIS ONLY)"], R[240603] = {
                x1: 0,
                x2: 200,
                y1: 50,
                y2: 150
            }, I[240900] = A["TP.FIRE SUPPORT STATION"], R[240900] = {
                x1: 50,
                x2: 200,
                y1: 50,
                y2: 150
            }, I[250100] = A["TP.FIRING POINT"], R[250100] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[250200] = A["TP.HIDE POINT"], R[250200] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[250300] = A["TP.LAUNCH POINT"], R[250300] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[250400] = A["TP.RELOAD POINT"], R[250400] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[250500] = A["TP.SURVEY CONTROL POINT"], R[250500] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[250600] = A["TP.KNOWN POINT"], I[270701] = A["TP.MINEFIELD, STATIC"], R[270701] = {
                x1: 25,
                x2: 175,
                y1: 65,
                y2: 145
            }, I[280100] = A.TODO, I[280200] = A["TP.ANTIPERSONNEL (AP) MINES"], I[280201] = A["TP.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS"], R[280201] = {
                x1: 40,
                x2: 180,
                y1: 40,
                y2: 150
            }, I[280300] = A["TP.ANTITANK MINE (AT)"], I[280400] = A["TP.(AT) ANTIHANDLING DEVICE"], R[280400] = {
                x1: 60,
                x2: 140,
                y1: 40,
                y2: 195
            }, I[280500] = A["TP.WIDE AREA MINES"], I[280600] = A["TP.UNSPECIFIED MINE"], I[280700] = A["TP.BOOBY TRAP"], I[280800] = A["TP.ENGINEER REGULATING POINT"], R[280800] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[280900] = A["TP.EARTHWORK/FORTIFICATION"], I[281e3] = A["TP.SURFACE SHELTER"], I[281100] = A["TP.UNDERGROUND SHELTER"], I[281200] = A["TP.FORT"], I[281300] = A["TP.CHEMICAL EVENT"], R[281300] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281301] = A["TP.CHEMICAL \u2013 TOXIC INDUSTRIAL MATERIAL"], R[281301] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281400] = A["TP.BIOLOGICAL EVENT"], R[281400] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281401] = A["TP.BIOLOGICAL \u2013 TOXIC INDUSTRIAL MATERIAL"], R[281401] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281500] = A["TP.NUCLEAR EVENT"], R[281500] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281600] = A["TP.NUCLEAR EVENT"], R[281600] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281700] = A["TP.RADIOLOGICAL EVENT"], R[281700] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281701] = A["TP.RADIOLOGICAL \u2013 TOXIC INDUSTRIAL MATERIAL"], R[281701] = {
                x1: 25,
                x2: 175,
                y1: -10
            }, I[281800] = A["TP.DECON SITE/POINT"], R[281800] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281801] = A["TP.ALTERNATE DECON SITE/POINT"], R[281801] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281802] = A["TP.DECON SITE/POINT (EQUIPMENT)"], R[281802] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281803] = A["TP.DECON SITE/POINT (TROOPS)"], R[281803] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281804] = A["TP.DECON SITE/POINT (EQUIPMENT AND TROOPS)"], R[281804] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281805] = A["TP.DECON SITE/POINT (OPERATIONAL DECONTAMINATION)"], R[281805] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281806] = A["TP.DECON SITE/POINT (THOROUGH DECONTAMINATION)"], R[281806] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281807] = A["TP.MAIN EQUIPMENT DECONTAMINATION POINT/SITE"], R[281807] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281808] = A["TP.FORWARD TROOP DECONTAMINATION POINT/SITE"], R[281808] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281809] = A["TP.WOUNDED PERSONNEL DECONTAMINATION SITE"], R[281809] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[281901] = A["TP.FIXED AND PREFABRICATED"], R[281901] = {
                x1: 60,
                x2: 140,
                y1: 30
            }, I[281902] = A["TP.TETRAHEDRONS"], R[281902] = {
                x1: 60,
                x2: 140,
                y1: 30
            }, I[281903] = A["TP.TETRAHEDRONS MOVABLE"], R[281903] = {
                x1: 60,
                x2: 140,
                y1: 30
            }, I[282001] = A["TP.TOWER LOW"], R[282001] = {
                x1: 50,
                x2: 150,
                y1: 30,
                y2: 120
            }, I[282002] = A["TP.TOWER HIGH"], R[282002] = {
                x1: 50,
                x2: 150,
                y1: 30,
                y2: 120
            }, I[320100] = A["TP.AMBULANCE EXCHANGE POINT"], R[320100] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320101] = A["TP.AMBULANCE EXCHANGE POINT"], R[320101] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320102] = A["TP.AMBULANCE CONTROL POINT"], R[320102] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320103] = A["TP.AMBULANCE LOAD POINT"], R[320103] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320104] = A["TP.AMBULANCE RELAY POINT"], R[320104] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320200] = A["TP.AMMUNITION SUPPLY POINT (ASP)"], R[320200] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320300] = A["TP.AMMUNITION TRANSFER POINT (ATP)"], R[320300] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320400] = A["TP.CANNIBALIZATION POINT"], R[320400] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320500] = A["TP.CASUALTY COLLECTION POINT"], R[320500] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320600] = A["TP.CIVILIAN COLLECTION POINT"], R[320600] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320700] = A["TP.DETAINEE COLLECTION POINT"], R[320700] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320800] = A["TP.EPW COLLECTION POINT"], R[320800] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[320900] = A["TP.LOGISTICS RELEASE POINT"], R[320900] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321e3] = A["TP.MAINTENANCE COLLECTION POINT"], R[321e3] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321100] = A["TP.MEDICAL EVACUATION (MEDEVAC) PICKUP POINT"], R[321100] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321200] = A["TP.REARM, REFUEL AND RESUPPLY POINT"], R[321200] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321300] = A["TP.REFUEL ON THE MOVE POINT"], R[321300] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321400] = A["TP.TRAFFIC CONTROL POST"], R[321400] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321500] = A["TP.TRAILER TRANSFER POINT"], R[321500] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321600] = A["TP.UNIT MAINTENANCE COLLECTION POINT"], R[321600] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321700] = A["TP.SUPPLY POINT"], R[321700] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321701] = A["TP.NATO CLASS I"], R[321701] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321702] = A["TP.NATO CLASS II"], R[321702] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321703] = A["TP.NATO CLASS III"], R[321703] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321704] = A["TP.NATO CLASS IV"], R[321704] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321705] = A["TP.NATO CLASS V"], R[321705] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321706] = A["TP.SUPPLY POINT"], R[321706] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321707] = A["TP.SP CLASS I"], R[321707] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321708] = A["TP.SP CLASS II"], R[321708] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321709] = A["TP.SP CLASS III"], R[321709] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321710] = A["TP.SP CLASS IV"], R[321710] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321711] = A["TP.SP CLASS V"], R[321711] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321712] = A["TP.SP CLASS VI"], R[321712] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321713] = A["TP.SP CLASS VII"], R[321713] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321714] = A["TP.SP CLASS VIII"], R[321714] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321715] = A["TP.SP CLASS IX"], R[321715] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321716] = A["TP.SP CLASS X"], R[321716] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[321800] = A["TP.MEDICAL SUPPLY POINT"], R[321800] = {
                x1: 60,
                x2: 140,
                y1: -60
            }, I[340900] = A["TP.DESTROY"], R[340900] = {
                x1: 0,
                x2: 200,
                y1: 40,
                y2: 160
            }, I[341400] = A["TP.INTERDICT"], R[341400] = {
                x1: 0,
                x2: 200,
                y1: 40,
                y2: 160
            }, I[341600] = A["TP.NEUTRALIZE"], R[341600] = {
                x1: 0,
                x2: 200,
                y1: 40,
                y2: 160
            }, I[342800] = A["TP.SUPPRESS"], R[342800] = {
                x1: 0,
                x2: 200,
                y1: 40,
                y2: 160
            }, I[350101] = A["MAN MADE SPACE DEBRIS SMALL"], I[350102] = A["MAN MADE SPACE DEBRIS MEDIUM"], I[350103] = A["MAN MADE SPACE DEBRIS BIG"], I[350201] = A["NATURAL SPACE DEBRIS SMALL"], I[350202] = A["NATURAL SPACE DEBRIS MEDIUM"], I[350203] = A["NATURAL SPACE DEBRIS BIG"], t[13] = [
                A["TP.M1.UNSPECIFIED"]
            ], t[14] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTIPERSONNEL MINE 2"],
                A["TP.M1.ANTIPERSONNEL MINE 3"]
            ], t[15] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 2"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 3"]
            ], t[16] = [
                A["TP.M1.ANTITANK MINE 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.ANTITANK MINE 3"]
            ], t[17] = [
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 3"]
            ], t[18] = [
                A["TP.M1.WIDE AREA ANTITANK MINE 1"],
                A["TP.M1.WIDE AREA ANTITANK MINE 2"],
                A["TP.M1.WIDE AREA ANTITANK MINE 3"]
            ], t[19] = [
                A["TP.M1.MINE CLUSTER 1"],
                A["TP.M1.MINE CLUSTER 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ], t[20] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 2"],
                A["TP.M1.ANTIPERSONNEL MINE 3"]
            ], t[21] = [
                A["TP.M1.ANTITANK MINE 1"],
                A["TP.M1.ANTIPERSONNEL MINE 2"],
                A["TP.M1.ANTITANK MINE 3"]
            ], t[22] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.ANTIPERSONNEL MINE 3"]
            ], t[23] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.WIDE AREA ANTITANK MINE 2"],
                A["TP.M1.ANTIPERSONNEL MINE 3"]
            ], t[24] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.MINE CLUSTER 2"],
                A["TP.M1.ANTIPERSONNEL MINE 3"]
            ], t[25] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 3"]
            ], t[26] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 3"]
            ], t[27] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.WIDE AREA ANTITANK MINE 2"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 3"]
            ], t[28] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.MINE CLUSTER 2"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 3"]
            ], t[29] = [
                A["TP.M1.ANTITANK MINE 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.ANTITANK MINE 3"]
            ], t[30] = [
                A["TP.M1.ANTITANK MINE 1"],
                A["TP.M1.WIDE AREA ANTITANK MINE 2"],
                A["TP.M1.ANTITANK MINE 3"]
            ], t[31] = [
                A["TP.M1.ANTITANK MINE 1"],
                A["TP.M1.MINE CLUSTER 2"],
                A["TP.M1.ANTITANK MINE 3"]
            ], t[32] = [
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 1"],
                A["TP.M1.WIDE AREA ANTITANK MINE 2"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 3"]
            ], t[33] = [
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 1"],
                A["TP.M1.MINE CLUSTER 2"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 3"]
            ], t[34] = [
                A["TP.M1.WIDE AREA ANTITANK MINE 1"],
                A["TP.M1.MINE CLUSTER 2"],
                A["TP.M1.WIDE AREA ANTITANK MINE 3"]
            ], t[35] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 2"],
                A["TP.M1.ANTITANK MINE 3"]
            ], t[36] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 2"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 3"]
            ], t[37] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 2"],
                A["TP.M1.WIDE AREA ANTITANK MINE 3"]
            ], t[38] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ], t[39] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 3"]
            ], t[40] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.WIDE AREA ANTITANK MINE 3"]
            ], t[41] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ], t[42] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.WIDE AREA ANTITANK MINE 3"]
            ], t[43] = [
                A["TP.M1.ANTIPERSONNEL MINE 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ], t[44] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.WIDE AREA ANTITANK MINE 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ], t[45] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 3"]
            ], t[46] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.WIDE AREA ANTITANK MINE 3"]
            ], t[47] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTITANK MINE 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ], t[48] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.WIDE AREA ANTITANK MINE 3"]
            ], t[49] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.ANTITANK MINE WITH ANTIHANDLING DEVICE 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ], t[50] = [
                A["TP.M1.ANTIPERSONNEL MINE WITH DIRECTIONAL EFFECTS 1"],
                A["TP.M1.WIDE AREA ANTITANK MINE 2"],
                A["TP.M1.MINE CLUSTER 3"]
            ]);
        }
    }, EI = [
        Q,
        g,
        b,
        K,
        X,
        w,
        _,
        J,
        Z,
        q,
        j,
        $,
        II,
        {
            type: "number",
            getMetadata: u,
            getIcons: v,
            iconParts: c,
            icons: function(I, t, E, R, e, A, C) {
                "27" == e && (I[11e4] = [], I[110100] = [], I[110101] = [
                    A["GR.IC.FF.INFANTRY DISMOUNTED"]
                ], I[110102] = [
                    A["GR.IC.FF.MEDICAL"]
                ], I[110103] = [
                    A["GR.IC.FF.RECONNAISSANCE DISMOUNTED"]
                ], I[110104] = [
                    A["GR.IC.FF.SIGNAL DISMOUNTED"]
                ], I[110200] = [], I[110201] = [
                    A["GR.IC.EXPLOSIVE ORDNANCE DISPOSAL"]
                ], I[110202] = [
                    A["GR.IC.FIELD ARTILLERY OBSERVER"]
                ], I[110203] = [
                    A["GR.IC.JOINT FIRE SUPPORT"]
                ], I[110204] = [
                    A["GR.IC.LIAISON"]
                ], I[110205] = [
                    A["GR.IC.MESSENGER"]
                ], I[110206] = [
                    A["GR.IC.MILITARY POLICE"]
                ], I[110207] = [
                    A["GR.IC.OBSERVER/OBSERVATION"]
                ], I[110208] = [
                    A["GR.IC.SECURITY"]
                ], I[110209] = [
                    A["GR.IC.SNIPER"]
                ], I[110210] = [
                    A["GR.IC.SPECIAL OPERATIONS FORCES"]
                ], I[110300] = [], I[110301] = [
                    A["GR.EQ.RIFLE"]
                ], I[110302] = [
                    A["GR.EQ.RIFLE"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110303] = [
                    A["GR.EQ.RIFLE"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110304] = [
                    A["GR.EQ.RIFLE"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110305] = [
                    A["GR.EQ.MACHINE GUN"]
                ], I[110306] = [
                    A["GR.EQ.MACHINE GUN"],
                    A["GR.EQ.SHORT RANGE"]
                ], I[110307] = [
                    A["GR.EQ.MACHINE GUN"],
                    A["GR.EQ.INTERMEDIATE RANGE"]
                ], I[110308] = [
                    A["GR.EQ.MACHINE GUN"],
                    A["GR.EQ.LONG RANGE"]
                ], I[110309] = [
                    A["GR.EQ.GRENADE LAUNCHER"]
                ], I[110310] = [
                    A["GR.EQ.GRENADE LAUNCHER"],
                    s._translate(0, 20, A["GR.EQ.SHORT RANGE"])
                ], I[110311] = [
                    A["GR.EQ.GRENADE LAUNCHER"],
                    s._translate(0, 20, A["GR.EQ.INTERMEDIATE RANGE"])
                ], I[110312] = [
                    A["GR.EQ.GRENADE LAUNCHER"],
                    s._translate(0, 20, A["GR.EQ.LONG RANGE"])
                ], I[110313] = [
                    A["GR.EQ.FLAME THROWER"]
                ], I[110314] = [
                    A["GR.EQ.MORTAR"]
                ], I[110315] = [
                    A["GR.EQ.SINGLE ROCKET LAUNCHER"]
                ], I[110316] = [
                    A["GR.EQ.ANTITANK ROCKET LAUNCHER"]
                ], I[110400] = [], I[110401] = [
                    A["GR.EQ.NON-LETHAL WEAPON"]
                ], I[110402] = A["GR.EQ.NON-LETHAL GRENADE LAUNCHER"], I[110403] = [
                    A["GR.EQ.TASER"]
                ], I[12e4] = [], I[120100] = [], I[120101] = [
                    A["GR.IC.LAW ENFORCEMENT"]
                ], t["01"] = [
                    A["GR.M1.CLOSE PROTECTION"]
                ], t["02"] = [
                    A["GR.M1.CROWD AND RIOT CONTROL"]
                ], t["03"] = [
                    A["GR.M1.EXPLOSIVE ORDNANCE DISPOSAL"]
                ], t["04"] = [
                    A["GR.M1.SECURITY"]
                ], t["05"] = [
                    A["GR.M1.SNIPER"]
                ], t["06"] = [
                    A["GR.M1.SPECIAL WEAPONS AND TACTICS"]
                ], t["07"] = [
                    A["ST.M1.NONGOVERNMENTAL ORGANIZATION (NGO)"]
                ], t["08"] = [
                    A["GR.M1.MULTINATIONAL"]
                ], t["09"] = [
                    A["GR.M1.MULTINATIONAL SPECIALIZED UNIT"]
                ], t[10] = [
                    A["ST.M1.GOVERNMENT ORGANIZATION"]
                ], t[11] = [
                    A["GR.M1.VIDEO IMAGERY"]
                ], t[12] = [
                    A["GR.M1.J1"]
                ], t[13] = [
                    A["GR.M1.J2"]
                ], t[14] = [
                    A["GR.M1.J3"]
                ], t[15] = [
                    A["GR.M1.J4"]
                ], t[16] = [
                    A["GR.M1.J5"]
                ], t[17] = [
                    A["GR.M1.J6"]
                ], t[18] = [
                    A["GR.M1.J7"]
                ], t[19] = [
                    A["GR.M1.J8"]
                ], t[20] = [
                    A["GR.M1.J9"]
                ], t[21] = [
                    A["GR.M1.OF-1"]
                ], t[22] = [
                    A["GR.M1.OF-2"]
                ], t[23] = [
                    A["GR.M1.OF-3"]
                ], t[24] = [
                    A["GR.M1.OF-4"]
                ], t[25] = [
                    A["GR.M1.OF-5"]
                ], t[26] = [
                    A["GR.M1.OF-6"]
                ], t[27] = [
                    A["GR.M1.OF-7"]
                ], t[28] = [
                    A["GR.M1.OF-8"]
                ], t[29] = [
                    A["GR.M1.OF-9"]
                ], t[30] = [
                    A["GR.M1.OF-10"]
                ], t[31] = [
                    A["GR.M1.OF-D"]
                ], t[32] = [
                    A["GR.M1.OR-1"]
                ], t[33] = [
                    A["GR.M1.OR-2"]
                ], t[34] = [
                    A["GR.M1.OR-3"]
                ], t[35] = [
                    A["GR.M1.OR-4"]
                ], t[36] = [
                    A["GR.M1.OR-5"]
                ], t[37] = [
                    A["GR.M1.OR-6"]
                ], t[38] = [
                    A["GR.M1.OR-7"]
                ], t[39] = [
                    A["GR.M1.OR-8"]
                ], t[40] = [
                    A["GR.M1.OR-9"]
                ], t[41] = [
                    A["GR.M1.WO-1"]
                ], t[42] = [
                    A["GR.M1.WO-2"]
                ], t[43] = [
                    A["GR.M1.WO-3"]
                ], t[44] = [
                    A["GR.M1.WO-4"]
                ], t[45] = [
                    A["GR.M1.WO-5"]
                ], t[46] = [
                    A["GR.M1.INDIVIDUAL"]
                ], t[47] = [
                    A["GR.M1.TEAM"]
                ], t[48] = [
                    A["GR.M1.SQUAD"]
                ], t[49] = [
                    A["GR.M1.SECTION"]
                ], t[50] = [
                    A["GR.M1.PLATOON"]
                ], t[51] = [
                    A["GR.M1.COMPANY"]
                ], t[52] = [
                    A["GR.M1.BATTALION"]
                ], t[53] = [
                    A["GR.M1.REGIMENT"]
                ], t[54] = [
                    A["GR.M1.BRIGADE"]
                ], t[55] = [
                    A["GR.M1.DIVISION"]
                ], E["01"] = [
                    A["GR.M2.AIRBORNE"]
                ], E["02"] = [
                    A["GR.M2.BICYCLE EQUIPPED"]
                ], E["03"] = [
                    A["GR.M2.DEMOLITION"]
                ], E["04"] = [
                    A["GR.M2.J1"]
                ], E["05"] = [
                    A["GR.M2.J2"]
                ], E["06"] = [
                    A["GR.M2.J3"]
                ], E["07"] = [
                    A["GR.M2.J4"]
                ], E["08"] = [
                    A["GR.M2.J5"]
                ], E["09"] = [
                    A["GR.M2.J6"]
                ], E[10] = [
                    A["GR.M2.J7"]
                ], E[11] = [
                    A["GR.M2.J8"]
                ], E[12] = [
                    A["GR.M2.J9"]
                ], E[13] = [
                    A["GR.M2.MOUNTAIN"]
                ], E[14] = [
                    A["GR.M2.OF-1"]
                ], E[15] = [
                    A["GR.M2.OF-2"]
                ], E[16] = [
                    A["GR.M2.OF-3"]
                ], E[17] = [
                    A["GR.M2.OF-4"]
                ], E[18] = [
                    A["GR.M2.OF-5"]
                ], E[19] = [
                    A["GR.M2.OF-6"]
                ], E[20] = [
                    A["GR.M2.OF-7"]
                ], E[21] = [
                    A["GR.M2.OF-8"]
                ], E[22] = [
                    A["GR.M2.OF-9"]
                ], E[23] = [
                    A["GR.M2.OF-10"]
                ], E[24] = [
                    A["GR.M2.OF-D"]
                ], E[25] = [
                    A["GR.M2.OR-1"]
                ], E[26] = [
                    A["GR.M2.OR-2"]
                ], E[27] = [
                    A["GR.M2.OR-3"]
                ], E[28] = [
                    A["GR.M2.OR-4"]
                ], E[29] = [
                    A["GR.M2.OR-5"]
                ], E[30] = [
                    A["GR.M2.OR-6"]
                ], E[31] = [
                    A["GR.M2.OR-7"]
                ], E[32] = [
                    A["GR.M2.OR-8"]
                ], E[33] = [
                    A["GR.M2.OR-9"]
                ], E[34] = [
                    A["GR.M2.WO-1"]
                ], E[35] = [
                    A["GR.M2.WO-2"]
                ], E[36] = [
                    A["GR.M2.WO-3"]
                ], E[37] = [
                    A["GR.M2.WO-4"]
                ], E[38] = [
                    A["GR.M2.WO-5"]
                ], E[39] = [
                    A["GR.M2.SKI"]
                ]);
            }
        },
        tI
    ], RI = [
        Q,
        g,
        b,
        K,
        X,
        w,
        _,
        J,
        Z,
        q,
        j,
        $,
        II,
        {
            type: "number",
            getMetadata: u,
            getIcons: v,
            iconParts: c,
            icons: function(I, t, E, R, e, A, C) {
                "60" == e && (I[11e4] = [], I[110100] = [
                    A["CY.IC.COMBAT MISSION TEAM"]
                ], I[110200] = [
                    A["CY.IC.NATIONAL MISSION TEAM"]
                ], I[110300] = [
                    A["CY.IC.CYBER PROTECTION TEAM"]
                ], I[110400] = [
                    A["CY.IC.NATION STATE CYBER THREAT ACTOR"]
                ], I[110500] = [
                    A["CY.IC.NON NATION STATE CYBER THREAT ACTOR"]
                ]);
            }
        },
        tI
    ];
    return s.addIcons(B), s.addIcons(Y), s.addIcons(W), s.addIcons(EI), s.addIcons(RI), s.Path2D = function(I, t) {
        var E, R, e, A, C, T, S, N, O, G, o;
        I.beginPath();
        var M = t.match(/([MCLHV][^MCLHV]*)/gi);
        for(S = 0; S < M.length; S++){
            if ("M" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d].*[\d]/)[0].split(/[\s,]/g), O = E = parseFloat(o[0]), G = R = parseFloat(o[1]), I.moveTo(E, R), N = 2; N < o.length; N += 2)E = parseFloat(o[N]), R = parseFloat(o[N + 1]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && (I.closePath(), E = O, R = G);
            }
            if ("m" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d].*[\d]/)[0].split(/[\s,]/g), O = E = E ? E + parseFloat(o[0]) : parseFloat(o[0]), G = R = R ? R + parseFloat(o[1]) : parseFloat(o[1]), I.moveTo(E, R), N = 2; N < o.length; N += 2)E += parseFloat(o[N]), R += parseFloat(o[N + 1]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && (I.closePath(), E = O, R = G);
            }
            if ("L" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d].*[\d]/)[0].split(/[\s,]/g), N = 0; N < o.length; N += 2)E = parseFloat(o[N]), R = parseFloat(o[N + 1]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && (I.closePath(), E = O, R = G);
            }
            if ("l" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d].*[\d]/)[0].split(/[\s,]/g), N = 0; N < o.length; N += 2)E += parseFloat(o[N]), R += parseFloat(o[N + 1]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && I.closePath();
            }
            if ("C" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d].*[\d]/)[0].split(/[\s,]/g), N = 0; N < o.length; N += 6)e = parseFloat(o[N]), A = parseFloat(o[N + 1]), C = parseFloat(o[N + 2]), T = parseFloat(o[N + 3]), E = parseFloat(o[N + 4]), R = parseFloat(o[N + 5]), I.bezierCurveTo(e, A, C, T, E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && I.closePath();
            }
            if ("c" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d].*[\d]/)[0].split(/[\s,]/g), N = 0; N < o.length; N += 6)e = E + parseFloat(o[N]), A = R + parseFloat(o[N + 1]), C = E + parseFloat(o[N + 2]), T = R + parseFloat(o[N + 3]), E += parseFloat(o[N + 4]), R += parseFloat(o[N + 5]), I.bezierCurveTo(e, A, C, T, E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && I.closePath();
            }
            if ("H" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d](.*[\d])?/)[0].split(/[\s,]/g), N = 0; N < o.length; N++)E = parseFloat(o[N]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && I.closePath();
            }
            if ("h" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d](.*[\d])?/)[0].split(/[\s,]/g), N = 0; N < o.length; N++)E += parseFloat(o[N]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && I.closePath();
            }
            if ("V" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d](.*[\d])?/)[0].split(/[\s,]/g), N = 0; N < o.length; N++)R = parseFloat(o[N]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && I.closePath();
            }
            if ("v" == M[S].charAt(0)) {
                for(o = M[S].match(/[-\d](.*[\d])?/)[0].split(/[\s,]/g), N = 0; N < o.length; N++)R += parseFloat(o[N]), I.lineTo(E, R);
                "Z" == M[S].replace(/\s/g, "").substr(-1, 1).toUpperCase() && I.closePath();
            }
        }
    }, s;
});



/**
 * @module ol/style/Fill
 */ /**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $7eb75c96a6b6f2c6$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};


/**
 * @module ol/style/IconImage
 */ 


/**
 * @module ol/color
 */ /**
 * Cylindrical CIE LUV
 *
 * @module color-space/lchuv
 */ /**
 * CIE LUV (C'est la vie)
 *
 * @module color-space/luv
 */ /**
 * CIE XYZ
 *
 * @module  color-space/xyz
 */ /**
 * RGB space.
 *
 * @module  color-space/rgb
 */ var $3751ab4954229b70$export$2e2bcd8739ae039 = {
    name: "rgb",
    min: [
        0,
        0,
        0
    ],
    max: [
        255,
        255,
        255
    ],
    channel: [
        "red",
        "green",
        "blue"
    ],
    alias: [
        "RGB"
    ]
};


var $3d55e8295660d0b8$var$xyz = {
    name: "xyz",
    min: [
        0,
        0,
        0
    ],
    channel: [
        "X",
        "Y",
        "Z"
    ],
    alias: [
        "XYZ",
        "ciexyz",
        "cie1931"
    ]
};
/**
 * Whitepoint reference values with observer/illuminant
 *
 * http://en.wikipedia.org/wiki/Standard_illuminant
 */ $3d55e8295660d0b8$var$xyz.whitepoint = {
    //1931 2°
    2: {
        //incadescent
        A: [
            109.85,
            100,
            35.585
        ],
        // B:[],
        C: [
            98.074,
            100,
            118.232
        ],
        D50: [
            96.422,
            100,
            82.521
        ],
        D55: [
            95.682,
            100,
            92.149
        ],
        //daylight
        D65: [
            95.045592705167,
            100,
            108.9057750759878
        ],
        D75: [
            94.972,
            100,
            122.638
        ],
        //flourescent
        // F1: [],
        F2: [
            99.187,
            100,
            67.395
        ],
        // F3: [],
        // F4: [],
        // F5: [],
        // F6:[],
        F7: [
            95.044,
            100,
            108.755
        ],
        // F8: [],
        // F9: [],
        // F10: [],
        F11: [
            100.966,
            100,
            64.370
        ],
        // F12: [],
        E: [
            100,
            100,
            100
        ]
    },
    //1964  10°
    10: {
        //incadescent
        A: [
            111.144,
            100,
            35.200
        ],
        C: [
            97.285,
            100,
            116.145
        ],
        D50: [
            96.720,
            100,
            81.427
        ],
        D55: [
            95.799,
            100,
            90.926
        ],
        //daylight
        D65: [
            94.811,
            100,
            107.304
        ],
        D75: [
            94.416,
            100,
            120.641
        ],
        //flourescent
        F2: [
            103.280,
            100,
            69.026
        ],
        F7: [
            95.792,
            100,
            107.687
        ],
        F11: [
            103.866,
            100,
            65.627
        ],
        E: [
            100,
            100,
            100
        ]
    }
};
/**
 * Top values are the whitepoint’s top values, default are D65
 */ $3d55e8295660d0b8$var$xyz.max = $3d55e8295660d0b8$var$xyz.whitepoint[2].D65;
/**
 * Transform xyz to rgb
 *
 * @param {Array} xyz Array of xyz values
 *
 * @return {Array} RGB values
 */ $3d55e8295660d0b8$var$xyz.rgb = function(_xyz, white) {
    //FIXME: make sure we have to divide like this. Probably we have to replace matrix as well then
    white = white || $3d55e8295660d0b8$var$xyz.whitepoint[2].E;
    var x = _xyz[0] / white[0], y = _xyz[1] / white[1], z = _xyz[2] / white[2], r, g, b;
    // assume sRGB
    // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
    r = x * 3.240969941904521 + y * -1.537383177570093 + z * -0.498610760293;
    g = x * -0.96924363628087 + y * 1.87596750150772 + z * 0.041555057407175;
    b = x * 0.055630079696993 + y * -0.20397695888897 + z * 1.056971514242878;
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
/**
 * RGB to XYZ
 *
 * @param {Array} rgb RGB channels
 *
 * @return {Array} XYZ channels
 */ (0, $3751ab4954229b70$export$2e2bcd8739ae039).xyz = function(rgb, white) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.41239079926595 + g * 0.35758433938387 + b * 0.18048078840183;
    var y = r * 0.21263900587151 + g * 0.71516867876775 + b * 0.072192315360733;
    var z = r * 0.019330818715591 + g * 0.11919477979462 + b * 0.95053215224966;
    white = white || $3d55e8295660d0b8$var$xyz.whitepoint[2].E;
    return [
        x * white[0],
        y * white[1],
        z * white[2]
    ];
};
var $3d55e8295660d0b8$export$2e2bcd8739ae039 = $3d55e8295660d0b8$var$xyz;


var $f857682ac15a36ea$export$2e2bcd8739ae039 = {
    name: "luv",
    //NOTE: luv has no rigidly defined limits
    //easyrgb fails to get proper coords
    //boronine states no rigid limits
    //colorMine refers this ones:
    min: [
        0,
        -134,
        -140
    ],
    max: [
        100,
        224,
        122
    ],
    channel: [
        "lightness",
        "u",
        "v"
    ],
    alias: [
        "LUV",
        "cieluv",
        "cie1976"
    ],
    xyz: function(arg, i, o) {
        var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
        l = arg[0], u = arg[1], v = arg[2];
        if (l === 0) return [
            0,
            0,
            0
        ];
        //get constants
        //var e = 0.008856451679035631; //(6/29)^3
        var k = 0.0011070564598794539; //(3/29)^3
        //get illuminant/observer
        i = i || "D65";
        o = o || 2;
        xn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][0];
        yn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][1];
        zn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][2];
        un = 4 * xn / (xn + 15 * yn + 3 * zn);
        vn = 9 * yn / (xn + 15 * yn + 3 * zn);
        // un = 0.19783000664283;
        // vn = 0.46831999493879;
        _u = u / (13 * l) + un || 0;
        _v = v / (13 * l) + vn || 0;
        y = l > 8 ? yn * Math.pow((l + 16) / 116, 3) : yn * l * k;
        //wikipedia method
        x = y * 9 * _u / (4 * _v) || 0;
        z = y * (12 - 3 * _u - 20 * _v) / (4 * _v) || 0;
        //boronine method
        //https://github.com/boronine/husl/blob/master/husl.coffee#L201
        // x = 0 - (9 * y * _u) / ((_u - 4) * _v - _u * _v);
        // z = (9 * y - (15 * _v * y) - (_v * x)) / (3 * _v);
        return [
            x,
            y,
            z
        ];
    }
};
// http://www.brucelindbloom.com/index.html?Equations.html
// https://github.com/boronine/husl/blob/master/husl.coffee
//i - illuminant
//o - observer
(0, $3d55e8295660d0b8$export$2e2bcd8739ae039).luv = function(arg, i, o) {
    var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
    //get constants
    var e = 0.008856451679035631; //(6/29)^3
    var k = 903.2962962962961; //(29/3)^3
    //get illuminant/observer coords
    i = i || "D65";
    o = o || 2;
    xn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][0];
    yn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][1];
    zn = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).whitepoint[o][i][2];
    un = 4 * xn / (xn + 15 * yn + 3 * zn);
    vn = 9 * yn / (xn + 15 * yn + 3 * zn);
    x = arg[0], y = arg[1], z = arg[2];
    _u = 4 * x / (x + 15 * y + 3 * z) || 0;
    _v = 9 * y / (x + 15 * y + 3 * z) || 0;
    var yr = y / yn;
    l = yr <= e ? k * yr : 116 * Math.pow(yr, 1 / 3) - 16;
    u = 13 * l * (_u - un);
    v = 13 * l * (_v - vn);
    return [
        l,
        u,
        v
    ];
};



//cylindrical luv
var $2abac224ee1f2820$var$lchuv = {
    name: "lchuv",
    channel: [
        "lightness",
        "chroma",
        "hue"
    ],
    alias: [
        "LCHuv",
        "cielchuv"
    ],
    min: [
        0,
        0,
        0
    ],
    max: [
        100,
        100,
        360
    ],
    luv: function(luv) {
        var l = luv[0], c = luv[1], h = luv[2], u, v, hr;
        hr = h / 360 * 2 * Math.PI;
        u = c * Math.cos(hr);
        v = c * Math.sin(hr);
        return [
            l,
            u,
            v
        ];
    },
    xyz: function(arg) {
        return (0, $f857682ac15a36ea$export$2e2bcd8739ae039).xyz($2abac224ee1f2820$var$lchuv.luv(arg));
    }
};
var $2abac224ee1f2820$export$2e2bcd8739ae039 = $2abac224ee1f2820$var$lchuv;
(0, $f857682ac15a36ea$export$2e2bcd8739ae039).lchuv = function(luv) {
    var l = luv[0], u = luv[1], v = luv[2];
    var c = Math.sqrt(u * u + v * v);
    var hr = Math.atan2(v, u);
    var h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    return [
        l,
        c,
        h
    ];
};
(0, $3d55e8295660d0b8$export$2e2bcd8739ae039).lchuv = function(arg) {
    return (0, $f857682ac15a36ea$export$2e2bcd8739ae039).lchuv((0, $3d55e8295660d0b8$export$2e2bcd8739ae039).luv(arg));
};


/** @module  color-rgba */ /**
 * @module color-parse
 */ var $96f3bba6e010158e$export$2e2bcd8739ae039 = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};


var $5481cadd51b98557$export$2e2bcd8739ae039 = $5481cadd51b98557$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $5481cadd51b98557$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $5481cadd51b98557$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    //numeric case
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    if (typeof cstr === "number") return {
        space: "rgb",
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    cstr = String(cstr).toLowerCase();
    //keyword
    if ((0, $96f3bba6e010158e$export$2e2bcd8739ae039)[cstr]) {
        parts = (0, $96f3bba6e010158e$export$2e2bcd8739ae039)[cstr].slice();
        space = "rgb";
    } else if (cstr === "transparent") {
        alpha = 0;
        space = "rgb";
        parts = [
            0,
            0,
            0
        ];
    } else if (cstr[0] === "#") {
        var base = cstr.slice(1);
        var size = base.length;
        var isShort = size <= 4;
        alpha = 1;
        if (isShort) {
            parts = [
                parseInt(base[0] + base[0], 16),
                parseInt(base[1] + base[1], 16),
                parseInt(base[2] + base[2], 16)
            ];
            if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
        } else {
            parts = [
                parseInt(base[0] + base[1], 16),
                parseInt(base[2] + base[3], 16),
                parseInt(base[4] + base[5], 16)
            ];
            if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
        }
        if (!parts[0]) parts[0] = 0;
        if (!parts[1]) parts[1] = 0;
        if (!parts[2]) parts[2] = 0;
        space = "rgb";
    } else if (m = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1];
        space = name.replace(/a$/, "");
        var dims = space === "cmyk" ? 4 : space === "gray" ? 1 : 3;
        parts = m[2].trim().split(/\s*[,\/]\s*|\s+/);
        // color(srgb-linear x x x) -> srgb-linear(x x x)
        if (space === "color") space = parts.shift();
        parts = parts.map(function(x, i) {
            //<percentage>
            if (x[x.length - 1] === "%") {
                x = parseFloat(x) / 100;
                // alpha -> 0..1
                if (i === 3) return x;
                // rgb -> 0..255
                if (space === "rgb") return x * 255;
                // hsl, hwb H -> 0..100
                if (space[0] === "h") return x * 100;
                // lch, lab L -> 0..100
                if (space[0] === "l" && !i) return x * 100;
                // lab A B -> -125..125
                if (space === "lab") return x * 125;
                // lch C -> 0..150, H -> 0..360
                if (space === "lch") return i < 2 ? x * 150 : x * 360;
                // oklch/oklab L -> 0..1
                if (space[0] === "o" && !i) return x;
                // oklab A B -> -0.4..0.4
                if (space === "oklab") return x * 0.4;
                // oklch C -> 0..0.4, H -> 0..360
                if (space === "oklch") return i < 2 ? x * 0.4 : x * 360;
                // color(xxx) -> 0..1
                return x;
            }
            //hue
            if (space[i] === "h" || i === 2 && space[space.length - 1] === "h") {
                //<base-hue>
                if ($5481cadd51b98557$var$baseHues[x] !== undefined) return $5481cadd51b98557$var$baseHues[x];
                //<deg>
                if (x.endsWith("deg")) return parseFloat(x);
                //<turn>
                if (x.endsWith("turn")) return parseFloat(x) * 360;
                if (x.endsWith("grad")) return parseFloat(x) * 360 / 400;
                if (x.endsWith("rad")) return parseFloat(x) * 180 / Math.PI;
            }
            if (x === "none") return 0;
            return parseFloat(x);
        });
        alpha = parts.length > dims ? parts.pop() : 1;
    } else if (/[0-9](?:\s|\/|,)/.test(cstr)) {
        parts = cstr.match(/([0-9]+)/g).map(function(value) {
            return parseFloat(value);
        });
        space = cstr.match(/([a-z])/ig)?.join("")?.toLowerCase() || "rgb";
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}



/**
 * @module color-space/hsl
 */ 
var $4b161c5b6bfbd933$export$2e2bcd8739ae039 = {
    name: "hsl",
    min: [
        0,
        0,
        0
    ],
    max: [
        360,
        100,
        100
    ],
    channel: [
        "hue",
        "saturation",
        "lightness"
    ],
    alias: [
        "HSL"
    ],
    rgb: function(hsl) {
        var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb, val, i = 0;
        if (s === 0) return val = l * 255, [
            val,
            val,
            val
        ];
        t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        t1 = 2 * l - t2;
        rgb = [
            0,
            0,
            0
        ];
        for(; i < 3;){
            t3 = h + 1 / 3 * -(i - 1);
            t3 < 0 ? t3++ : t3 > 1 && t3--;
            val = 6 * t3 < 1 ? t1 + (t2 - t1) * 6 * t3 : 2 * t3 < 1 ? t2 : 3 * t3 < 2 ? t1 + (t2 - t1) * (2 / 3 - t3) * 6 : t1;
            rgb[i++] = val * 255;
        }
        return rgb;
    }
};
//extend rgb
(0, $3751ab4954229b70$export$2e2bcd8739ae039).hsl = function(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};


function $6f2ac7eebd53949d$export$2e2bcd8739ae039(color) {
    // template literals
    if (Array.isArray(color) && color.raw) color = String.raw(...arguments);
    if (color instanceof Number) color = +color;
    var values, i, l;
    //attempt to parse non-array arguments
    var parsed = (0, $5481cadd51b98557$export$2e2bcd8739ae039)(color);
    if (!parsed.space) return [];
    const min = parsed.space[0] === "h" ? (0, $4b161c5b6bfbd933$export$2e2bcd8739ae039).min : (0, $3751ab4954229b70$export$2e2bcd8739ae039).min;
    const max = parsed.space[0] === "h" ? (0, $4b161c5b6bfbd933$export$2e2bcd8739ae039).max : (0, $3751ab4954229b70$export$2e2bcd8739ae039).max;
    values = Array(3);
    values[0] = Math.min(Math.max(parsed.values[0], min[0]), max[0]);
    values[1] = Math.min(Math.max(parsed.values[1], min[1]), max[1]);
    values[2] = Math.min(Math.max(parsed.values[2], min[2]), max[2]);
    if (parsed.space[0] === "h") values = (0, $4b161c5b6bfbd933$export$2e2bcd8739ae039).rgb(values);
    values.push(Math.min(Math.max(parsed.alpha, 0), 1));
    return values;
}





const $322346e1ff7894ca$export$6c844c64a5efe1ee = [
    NaN,
    NaN,
    NaN,
    0
];
function $322346e1ff7894ca$export$590567be997858b6(color) {
    if (typeof color === "string") return color;
    return $322346e1ff7894ca$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $322346e1ff7894ca$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $322346e1ff7894ca$var$cache = {};
/**
 * @type {number}
 */ let $322346e1ff7894ca$var$cacheSize = 0;
function $322346e1ff7894ca$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
function $322346e1ff7894ca$export$44fb54fa2e0c0d4(color) {
    const output = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).lchuv((0, $3751ab4954229b70$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $322346e1ff7894ca$export$27cc94530c050f00(color) {
    const output = (0, $3d55e8295660d0b8$export$2e2bcd8739ae039).rgb((0, $2abac224ee1f2820$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $322346e1ff7894ca$export$3004f64547af360e(s) {
    if (s === "none") return $322346e1ff7894ca$export$6c844c64a5efe1ee;
    if ($322346e1ff7894ca$var$cache.hasOwnProperty(s)) return $322346e1ff7894ca$var$cache[s];
    if ($322346e1ff7894ca$var$cacheSize >= $322346e1ff7894ca$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $322346e1ff7894ca$var$cache)if ((i++ & 3) === 0) {
            delete $322346e1ff7894ca$var$cache[key];
            --$322346e1ff7894ca$var$cacheSize;
        }
    }
    const color = (0, $6f2ac7eebd53949d$export$2e2bcd8739ae039)(s);
    if (color.length !== 4) throw new Error('failed to parse "' + s + '" as color');
    for (const c of color){
        if (isNaN(c)) throw new Error('failed to parse "' + s + '" as color');
    }
    $322346e1ff7894ca$export$a3295358bff77e(color);
    $322346e1ff7894ca$var$cache[s] = color;
    ++$322346e1ff7894ca$var$cacheSize;
    return color;
}
function $322346e1ff7894ca$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $322346e1ff7894ca$export$3004f64547af360e(color);
}
function $322346e1ff7894ca$export$a3295358bff77e(color) {
    color[0] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(color[3], 0, 1);
    return color;
}
function $322346e1ff7894ca$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
}
function $322346e1ff7894ca$export$40dd713d7775a0b1(s) {
    try {
        $322346e1ff7894ca$export$3004f64547af360e(s);
        return true;
    } catch (_) {
        return false;
    }
}


/**
 * @module ol/has
 */ const $67c66761d21428d0$var$ua = typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined" ? navigator.userAgent.toLowerCase() : "";
const $67c66761d21428d0$export$8442bdfd18b7b8a6 = $67c66761d21428d0$var$ua.includes("firefox");
const $67c66761d21428d0$export$3227bfbdaa9275de = $67c66761d21428d0$var$ua.includes("safari") && !$67c66761d21428d0$var$ua.includes("chrom");
const $67c66761d21428d0$export$b23eed0e325a206a = $67c66761d21428d0$export$3227bfbdaa9275de && ($67c66761d21428d0$var$ua.includes("version/15.4") || /cpu (os|iphone os) 15_4 like mac os x/.test($67c66761d21428d0$var$ua));
const $67c66761d21428d0$export$39dfd62a25e0fe93 = $67c66761d21428d0$var$ua.includes("webkit") && !$67c66761d21428d0$var$ua.includes("edge");
const $67c66761d21428d0$export$76c0a3b101d93136 = $67c66761d21428d0$var$ua.includes("macintosh");
const $67c66761d21428d0$export$6b83a0446fc26f94 = typeof devicePixelRatio !== "undefined" ? devicePixelRatio : 1;
const $67c66761d21428d0$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== "undefined" && typeof OffscreenCanvas !== "undefined" && self instanceof WorkerGlobalScope; //eslint-disable-line
const $67c66761d21428d0$export$716f8695eedb9bad = typeof Image !== "undefined" && Image.prototype.decode;
const $67c66761d21428d0$export$7478563940788376 = typeof createImageBitmap === "function";
const $67c66761d21428d0$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, "passive", {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener("_", null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener("_", null, options);
    } catch (error) {
    // passive not supported
    }
    return passive;
}();


function $075f937d7366f1a2$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $67c66761d21428d0$export$98fcef3dc9973292) canvas = new OffscreenCanvas(width || 300, height || 300);
    else canvas = document.createElement("canvas");
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext("2d", settings);
}
/** @type {CanvasRenderingContext2D} */ let $075f937d7366f1a2$var$sharedCanvasContext;
function $075f937d7366f1a2$export$fcb72ce088a6632c() {
    if (!$075f937d7366f1a2$var$sharedCanvasContext) $075f937d7366f1a2$var$sharedCanvasContext = $075f937d7366f1a2$export$9e05d10eae75c464(1, 1);
    return $075f937d7366f1a2$var$sharedCanvasContext;
}
function $075f937d7366f1a2$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $075f937d7366f1a2$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $075f937d7366f1a2$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $075f937d7366f1a2$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.lastChild.remove();
}
function $075f937d7366f1a2$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}


/**
 * @module ol/Image
 */ 





/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $b54439be79d4619a$var$ImageWrapper extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|import("./Image.js").Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === "function" ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {import("./Image.js").Loader}
     */ this.loader = typeof stateOrLoader === "function" ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            if (this.loader) {
                this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $013a1733c226ec50$export$4dbaaf6c79705e6c)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ("image" in image) this.image_ = image.image;
                    if ("extent" in image) this.extent = image.extent;
                    if ("resolution" in image) this.resolution = image.resolution;
                    if ("pixelRatio" in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
                }).catch((error)=>{
                    this.state = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $b54439be79d4619a$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $67c66761d21428d0$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $d5bf8abd656a3cdc$export$8d2a95bc11b44725)(img, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
    };
}
function $b54439be79d4619a$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error("Image load error"));
        }
        function unlisten() {
            image.removeEventListener("load", handleLoad);
            image.removeEventListener("error", handleError);
        }
        image.addEventListener("load", handleLoad);
        image.addEventListener("error", handleError);
        if (src) image.src = src;
    });
}
function $b54439be79d4619a$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $67c66761d21428d0$export$716f8695eedb9bad) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $b54439be79d4619a$export$11e63f7b0f3d9900(image);
}
function $b54439be79d4619a$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $67c66761d21428d0$export$716f8695eedb9bad) && (0, $67c66761d21428d0$export$7478563940788376) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $b54439be79d4619a$export$a9e5af241c1bd389(image);
}
var $b54439be79d4619a$export$2e2bcd8739ae039 = $b54439be79d4619a$var$ImageWrapper;


/**
 * @module ol/style/IconImageCache
 */ 


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $f351daabfe6e2d22$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 32;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, crossOrigin, color) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, crossOrigin, color, iconImage, pattern) {
        const key = $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $075f937d7366f1a2$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), "repeat");
            });
            else this.patternCache_[key] = (0, $075f937d7366f1a2$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), "repeat");
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `32`. Change this value when
   * your map uses more than 32 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $f351daabfe6e2d22$export$611736262b635f8d(src, crossOrigin, color) {
    const colorString = color ? (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color) : "null";
    return crossOrigin + ":" + src + ":" + colorString;
}
var $f351daabfe6e2d22$export$2e2bcd8739ae039 = $f351daabfe6e2d22$var$IconImageCache;
const $f351daabfe6e2d22$export$747ccdf771a87ab8 = new $f351daabfe6e2d22$var$IconImageCache();


/**
 * @type {CanvasRenderingContext2D}
 */ let $0e5ad1d3b638689e$var$taintedTestContext = null;
class $0e5ad1d3b638689e$var$IconImage extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, crossOrigin, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) {
            if (!$0e5ad1d3b638689e$var$taintedTestContext) $0e5ad1d3b638689e$var$taintedTestContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1, undefined, {
                willReadFrequently: true
            });
            $0e5ad1d3b638689e$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $0e5ad1d3b638689e$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch (e) {
                $0e5ad1d3b638689e$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch (e) {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $b54439be79d4619a$export$a9e5af241c1bd389)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const image = this.image_;
        const canvas = document.createElement("canvas");
        canvas.width = Math.ceil(image.width * pixelRatio);
        canvas.height = Math.ceil(image.height * pixelRatio);
        const ctx = canvas.getContext("2d");
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = "multiply";
        ctx.fillStyle = (0, $322346e1ff7894ca$export$590567be997858b6)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = "destination-in";
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) {
                        this.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function $0e5ad1d3b638689e$export$3988ae62b71be9a3(image, cacheKey, crossOrigin, imageState, color, pattern) {
    let iconImage = cacheKey === undefined ? undefined : (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(cacheKey, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $0e5ad1d3b638689e$var$IconImage(image, image && "src" in image ? image.src || undefined : cacheKey, crossOrigin, imageState, color);
        (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, crossOrigin, color)) (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    return iconImage;
}
var $0e5ad1d3b638689e$export$2e2bcd8739ae039 = $0e5ad1d3b638689e$var$IconImage;


/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $d61d1dcaf3c44610$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $d61d1dcaf3c44610$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === "object" && "src" in color) {
            const patternImage = (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(null, color.src, "anonymous", undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $d61d1dcaf3c44610$export$2e2bcd8739ae039 = $d61d1dcaf3c44610$var$Fill;

/**
 * @module ol/style/Icon
 */ 

/**
 * @module ol/style/Image
 */ 
/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $cc435a5409103773$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $cc435a5409103773$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $cc435a5409103773$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $cc435a5409103773$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}


/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $e60011aea38e6239$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $e60011aea38e6239$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $e60011aea38e6239$export$2e2bcd8739ae039 = $e60011aea38e6239$var$ImageStyle;






/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $8463d325b53eeb0c$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $8463d325b53eeb0c$var$Icon extends (0, $e60011aea38e6239$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : "top-left";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : "fraction";
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : "fraction";
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(cacheKey !== undefined && image), "`image` and `src` cannot be provided at the same time");
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $6c5e11070e371322$export$5e82334337e0f204)(image);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, "A defined and non-empty `src` or `image` must be provided");
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), "`width` or `height` cannot be provided together with `scale`");
        let imageState;
        if (options.src !== undefined) imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if ("complete" in image) {
                if (image.complete) imageState = image.src ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $322346e1ff7894ca$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, this.crossOrigin_, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : "top-left";
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($8463d325b53eeb0c$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($8463d325b53eeb0c$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $8463d325b53eeb0c$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == "fraction" || this.anchorYUnits_ == "fraction") {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == "fraction") anchor[0] *= size[0];
                if (this.anchorYUnits_ == "fraction") anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != "top-left") {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == "top-right" || this.anchorOrigin_ == "bottom-right") anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == "bottom-left" || this.anchorOrigin_ == "bottom-right") anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != "top-left") {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == "top-right" || this.offsetOrigin_ == "bottom-right") offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == "bottom-left" || this.offsetOrigin_ == "bottom-right") offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
var $8463d325b53eeb0c$export$2e2bcd8739ae039 = $8463d325b53eeb0c$var$Icon;

/**
 * @module ol/style/Style
 */ /**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ 


/**
 * @module ol/colorlike
 */ 




function $e0807f400ec9a0a9$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $322346e1ff7894ca$export$f84e8e69fd4488a5)(color);
    if (typeof color === "object" && "src" in color) return $e0807f400ec9a0a9$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $e0807f400ec9a0a9$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(pattern.src, "anonymous", pattern.color);
    const cacheKey = pattern.src + ":" + pattern.offset;
    const canvasPattern = (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).get(pattern.src, "anonymous", null);
    if (iconImage.getImageState() !== (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return null;
    const patternCanvasContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $0e5ad1d3b638689e$export$3988ae62b71be9a3)(patternCanvasContext.canvas, cacheKey, undefined, (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED, pattern.color, true);
    return (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
}



/**
 * @module ol/render/canvas
 */ 



/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $ce07df6d5d4656f1$export$981241db82723ce2 = "ol-hidden";
const $ce07df6d5d4656f1$export$99b49471b0394319 = "ol-selectable";
const $ce07df6d5d4656f1$export$1afde3d6e16a7b29 = "ol-unselectable";
const $ce07df6d5d4656f1$export$68eede0dd8c6c1da = "ol-unsupported";
const $ce07df6d5d4656f1$export$4d4f8be70b656192 = "ol-control";
const $ce07df6d5d4656f1$export$e16017ac68d14492 = "ol-collapsed";
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $ce07df6d5d4656f1$var$fontRegEx = new RegExp([
    "^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)",
    "(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)",
    "(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?",
    "(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))",
    "(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))",
    "?\\s*([-,\\\"\\'\\sa-z]+?)\\s*$"
].join(""), "i");
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $ce07df6d5d4656f1$var$fontRegExMatchIndex = [
    "style",
    "variant",
    "weight",
    "size",
    "lineHeight",
    "family"
];
const $ce07df6d5d4656f1$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($ce07df6d5d4656f1$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: "normal",
        size: "1.2em",
        style: "normal",
        weight: "normal",
        variant: "normal"
    };
    for(let i = 0, ii = $ce07df6d5d4656f1$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$ce07df6d5d4656f1$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};


const $d4aabc5c971073f1$export$3847dfea4f8d4dfa = "10px sans-serif";
const $d4aabc5c971073f1$export$c495d52ee3fd74b2 = "#000";
const $d4aabc5c971073f1$export$17bd0c38d6ae694e = "round";
const $d4aabc5c971073f1$export$e21b4112fdc612fc = [];
const $d4aabc5c971073f1$export$e06efc2409049f76 = 0;
const $d4aabc5c971073f1$export$365eb9648cf19bd0 = "round";
const $d4aabc5c971073f1$export$80c1c01844597b7b = 10;
const $d4aabc5c971073f1$export$1eb2eaecacf2031e = "#000";
const $d4aabc5c971073f1$export$94d53b95641b5766 = "center";
const $d4aabc5c971073f1$export$cf2279a1bff62eb = "middle";
const $d4aabc5c971073f1$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $d4aabc5c971073f1$export$79661f132c62010e = 1;
const $d4aabc5c971073f1$export$1d36981fcadac93b = new (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D}
 */ let $d4aabc5c971073f1$var$measureContext = null;
/**
 * @type {string}
 */ let $d4aabc5c971073f1$var$measureFont;
const $d4aabc5c971073f1$export$7fdcec604f0b1fa7 = {};
const $d4aabc5c971073f1$export$a534074a28fa87ff = function() {
    const retries = 100;
    const size = "32px ";
    const referenceFonts = [
        "monospace",
        "serif"
    ];
    const len = referenceFonts.length;
    const text = "wmytzilWMYTZIL@#/&?$%10\uF013";
    let interval, referenceWidth;
    /**
   * @param {string} fontStyle Css font-style
   * @param {string} fontWeight Css font-weight
   * @param {*} fontFamily Css font-family
   * @return {boolean} Font with style and weight is available
   */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        let available = true;
        for(let i = 0; i < len; ++i){
            const referenceFont = referenceFonts[i];
            referenceWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                const width = $d4aabc5c971073f1$export$4ea92329b673abd1(fontStyle + " " + fontWeight + " " + size + fontFamily + "," + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        let done = true;
        const fonts = $d4aabc5c971073f1$export$1d36981fcadac93b.getKeys();
        for(let i = 0, ii = fonts.length; i < ii; ++i){
            const font = fonts[i];
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(font) < retries) {
                const [style, weight, family] = font.split("\n");
                if (isAvailable(style, weight, family)) {
                    (0, $beaefe87199bb537$export$42ffd38884aecdac)($d4aabc5c971073f1$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $d4aabc5c971073f1$var$measureContext = null;
                    $d4aabc5c971073f1$var$measureFont = undefined;
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(font, $d4aabc5c971073f1$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        const font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        const families = font.families;
        for(let i = 0, ii = families.length; i < ii; ++i){
            const family = families[i];
            const key = font.style + "\n" + font.weight + "\n" + family;
            if ($d4aabc5c971073f1$export$1d36981fcadac93b.get(key) === undefined) {
                $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $d4aabc5c971073f1$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
const $d4aabc5c971073f1$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $67c66761d21428d0$export$98fcef3dc9973292) {
                const font = (0, $ce07df6d5d4656f1$export$5abde8a6aec4a131)(fontSpec);
                const metrics = $d4aabc5c971073f1$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement("div");
                    measureElement.innerHTML = "M";
                    measureElement.style.minHeight = "0";
                    measureElement.style.maxHeight = "none";
                    measureElement.style.height = "auto";
                    measureElement.style.padding = "0";
                    measureElement.style.border = "none";
                    measureElement.style.position = "absolute";
                    measureElement.style.display = "block";
                    measureElement.style.left = "-99999px";
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $d4aabc5c971073f1$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $d4aabc5c971073f1$var$measureText(font, text) {
    if (!$d4aabc5c971073f1$var$measureContext) $d4aabc5c971073f1$var$measureContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    if (font != $d4aabc5c971073f1$var$measureFont) {
        $d4aabc5c971073f1$var$measureContext.font = font;
        $d4aabc5c971073f1$var$measureFont = $d4aabc5c971073f1$var$measureContext.font;
    }
    return $d4aabc5c971073f1$var$measureContext.measureText(text);
}
function $d4aabc5c971073f1$export$4ea92329b673abd1(font, text) {
    return $d4aabc5c971073f1$var$measureText(font, text).width;
}
function $d4aabc5c971073f1$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split("\n").reduce((prev, curr)=>Math.max(prev, $d4aabc5c971073f1$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $d4aabc5c971073f1$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === "\n" || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $d4aabc5c971073f1$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $d4aabc5c971073f1$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $d4aabc5c971073f1$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $d4aabc5c971073f1$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $d4aabc5c971073f1$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}


/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $3e99c452138b2224$var$RegularShape extends (0, $e60011aea38e6239$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvases_;
        /**
     * @private
     * @type {HTMLCanvasElement|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING : (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
        if (this.imageState_ === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADING) this.ready().then(()=>this.imageState_ = (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $3e99c452138b2224$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        let image = this.canvases_[pixelRatio];
        if (!image) {
            const renderOptions = this.renderOptions_;
            const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size * pixelRatio, renderOptions.size * pixelRatio);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            this.canvases_[pixelRatio] = image;
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== "bevel" && lineJoin !== "miter") return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === "miter" && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === "bevel") return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
        let lineJoin = (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(this.stroke_.getColor() ?? (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            strokeWidth = this.stroke_.getWidth() ?? (0, $d4aabc5c971073f1$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap() ?? (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.canvases_ = {};
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === "string") color = (0, $322346e1ff7894ca$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $3e99c452138b2224$export$2e2bcd8739ae039 = $3e99c452138b2224$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $06150d8570b7481b$var$CircleStyle extends (0, $3e99c452138b2224$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $06150d8570b7481b$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */ setRadius(radius) {
        this.radius = radius;
        this.render();
    }
}
var $06150d8570b7481b$export$2e2bcd8739ae039 = $06150d8570b7481b$var$CircleStyle;



/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $f9d0329c5c745263$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $f9d0329c5c745263$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $f9d0329c5c745263$export$2e2bcd8739ae039 = $f9d0329c5c745263$var$Stroke;



/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * * **declutter**: Overlapping symbols and text are decluttered.
 * * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $8c7f6dda98e8cb9c$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === "object") geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $8c7f6dda98e8cb9c$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === "function") this.geometryFunction_ = geometry;
        else if (typeof geometry === "string") this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $8c7f6dda98e8cb9c$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $8c7f6dda98e8cb9c$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === "function") styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === "function", "Expected an `Style` or an array of `Style`");
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $8c7f6dda98e8cb9c$var$defaultStyles = null;
function $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$8c7f6dda98e8cb9c$var$defaultStyles) {
        const fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255,255,255,0.4)"
        });
        const stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: "#3399CC",
            width: 1.25
        });
        $8c7f6dda98e8cb9c$var$defaultStyles = [
            new $8c7f6dda98e8cb9c$var$Style({
                image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $8c7f6dda98e8cb9c$var$defaultStyles;
}
function $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles["Polygon"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles["MultiPolygon"] = styles["Polygon"];
    styles["LineString"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $8c7f6dda98e8cb9c$var$Style({
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles["MultiLineString"] = styles["LineString"];
    styles["Circle"] = styles["Polygon"].concat(styles["LineString"]);
    styles["Point"] = [
        new $8c7f6dda98e8cb9c$var$Style({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles["MultiPoint"] = styles["Point"];
    styles["GeometryCollection"] = styles["Polygon"].concat(styles["LineString"], styles["Point"]);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $8c7f6dda98e8cb9c$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $8c7f6dda98e8cb9c$export$2e2bcd8739ae039 = $8c7f6dda98e8cb9c$var$Style;

/**
 * @module ol/style/Text
 */ 

/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $944be50faeff5321$var$DEFAULT_FILL_COLOR = "#333";
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $944be50faeff5321$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: $944be50faeff5321$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : "point";
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $944be50faeff5321$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $944be50faeff5321$export$2e2bcd8739ae039 = $944be50faeff5321$var$Text;


parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");
/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $31ee54b8e1d1cd8f$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS = "AJSAJS";
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS = "AFAFAF";
var $31ee54b8e1d1cd8f$var$A = 65; // A
var $31ee54b8e1d1cd8f$var$I = 73; // I
var $31ee54b8e1d1cd8f$var$O = 79; // O
var $31ee54b8e1d1cd8f$var$V = 86; // V
var $31ee54b8e1d1cd8f$var$Z = 90; // Z
var $31ee54b8e1d1cd8f$export$2e2bcd8739ae039 = {
    forward: $31ee54b8e1d1cd8f$export$174bb771924e7eb1,
    inverse: $31ee54b8e1d1cd8f$export$70ae2c07e401031b,
    toPoint: $31ee54b8e1d1cd8f$export$b63cca88ddc558a9
};
function $31ee54b8e1d1cd8f$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $31ee54b8e1d1cd8f$var$encode($31ee54b8e1d1cd8f$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $31ee54b8e1d1cd8f$export$70ae2c07e401031b(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $31ee54b8e1d1cd8f$export$b63cca88ddc558a9(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $31ee54b8e1d1cd8f$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $31ee54b8e1d1cd8f$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $31ee54b8e1d1cd8f$var$degToRad(Lat);
    var LongRad = $31ee54b8e1d1cd8f$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $31ee54b8e1d1cd8f$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $31ee54b8e1d1cd8f$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < "N") y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $31ee54b8e1d1cd8f$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $31ee54b8e1d1cd8f$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $31ee54b8e1d1cd8f$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $31ee54b8e1d1cd8f$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = "Z";
    if (84 >= lat && lat >= 72) LetterDesignator = "X";
    else if (72 > lat && lat >= 64) LetterDesignator = "W";
    else if (64 > lat && lat >= 56) LetterDesignator = "V";
    else if (56 > lat && lat >= 48) LetterDesignator = "U";
    else if (48 > lat && lat >= 40) LetterDesignator = "T";
    else if (40 > lat && lat >= 32) LetterDesignator = "S";
    else if (32 > lat && lat >= 24) LetterDesignator = "R";
    else if (24 > lat && lat >= 16) LetterDesignator = "Q";
    else if (16 > lat && lat >= 8) LetterDesignator = "P";
    else if (8 > lat && lat >= 0) LetterDesignator = "N";
    else if (0 > lat && lat >= -8) LetterDesignator = "M";
    else if (-8 > lat && lat >= -16) LetterDesignator = "L";
    else if (-16 > lat && lat >= -24) LetterDesignator = "K";
    else if (-24 > lat && lat >= -32) LetterDesignator = "J";
    else if (-32 > lat && lat >= -40) LetterDesignator = "H";
    else if (-40 > lat && lat >= -48) LetterDesignator = "G";
    else if (-48 > lat && lat >= -56) LetterDesignator = "F";
    else if (-56 > lat && lat >= -64) LetterDesignator = "E";
    else if (-64 > lat && lat >= -72) LetterDesignator = "D";
    else if (-72 > lat && lat >= -80) LetterDesignator = "C";
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $31ee54b8e1d1cd8f$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $31ee54b8e1d1cd8f$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $31ee54b8e1d1cd8f$var$get100kSetForZone(i) {
    var setParm = i % $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $31ee54b8e1d1cd8f$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $31ee54b8e1d1cd8f$var$Z) {
        colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    }
    if (colInt === $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I && colInt > $31ee54b8e1d1cd8f$var$I || (colInt > $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) colInt++;
    if (colInt === $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O && colInt > $31ee54b8e1d1cd8f$var$O || (colInt > $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        colInt++;
        if (colInt === $31ee54b8e1d1cd8f$var$I) colInt++;
    }
    if (colInt > $31ee54b8e1d1cd8f$var$Z) colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
    if (rowInt > $31ee54b8e1d1cd8f$var$V) {
        rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I && rowInt > $31ee54b8e1d1cd8f$var$I || (rowInt > $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) rowInt++;
    if (rowInt === $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O && rowInt > $31ee54b8e1d1cd8f$var$O || (rowInt > $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        rowInt++;
        if (rowInt === $31ee54b8e1d1cd8f$var$I) rowInt++;
    }
    if (rowInt > $31ee54b8e1d1cd8f$var$V) rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $31ee54b8e1d1cd8f$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= "A" || zoneLetter === "B" || zoneLetter === "Y" || zoneLetter >= "Z" || zoneLetter === "I" || zoneLetter === "O") throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var east100k = $31ee54b8e1d1cd8f$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $31ee54b8e1d1cd8f$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$I) curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$O) curCol++;
        if (curCol > $31ee54b8e1d1cd8f$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getNorthingFromChar(n, set) {
    if (n > "V") throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$I) curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $31ee54b8e1d1cd8f$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case "C":
            northing = 1100000.0;
            break;
        case "D":
            northing = 2000000.0;
            break;
        case "E":
            northing = 2800000.0;
            break;
        case "F":
            northing = 3700000.0;
            break;
        case "G":
            northing = 4600000.0;
            break;
        case "H":
            northing = 5500000.0;
            break;
        case "J":
            northing = 6400000.0;
            break;
        case "K":
            northing = 7300000.0;
            break;
        case "L":
            northing = 8200000.0;
            break;
        case "M":
            northing = 9100000.0;
            break;
        case "N":
            northing = 0.0;
            break;
        case "P":
            northing = 800000.0;
            break;
        case "Q":
            northing = 1700000.0;
            break;
        case "R":
            northing = 2600000.0;
            break;
        case "S":
            northing = 3500000.0;
            break;
        case "T":
            northing = 4400000.0;
            break;
        case "U":
            northing = 5300000.0;
            break;
        case "V":
            northing = 6200000.0;
            break;
        case "W":
            northing = 7000000.0;
            break;
        case "X":
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}





function $95bfc720255032a6$export$2e2bcd8739ae039(defs) {
    defs("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
    defs("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
    defs("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
    defs.WGS84 = defs["EPSG:4326"];
    defs["EPSG:3785"] = defs["EPSG:3857"]; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs["EPSG:3857"];
    defs["EPSG:900913"] = defs["EPSG:3857"];
    defs["EPSG:102113"] = defs["EPSG:3857"];
}



var $gyVUi = parcelRequire("gyVUi");
var $c0ed0517e336f22b$export$2e2bcd8739ae039 = {};
$c0ed0517e336f22b$export$2e2bcd8739ae039.greenwich = 0.0; //"0dE",
$c0ed0517e336f22b$export$2e2bcd8739ae039.lisbon = -9.131906111111; //"9d07'54.862\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.paris = 2.337229166667; //"2d20'14.025\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bogota = -74.080916666667; //"74d04'51.3\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.madrid = -3.687938888889; //"3d41'16.58\"W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.rome = 12.452333333333; //"12d27'8.4\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.bern = 7.439583333333; //"7d26'22.5\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.jakarta = 106.807719444444; //"106d48'27.79\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.ferro = -17.666666666667; //"17d40'W",
$c0ed0517e336f22b$export$2e2bcd8739ae039.brussels = 4.367975; //"4d22'4.71\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.stockholm = 18.058277777778; //"18d3'29.8\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.athens = 23.7163375; //"23d42'58.815\"E",
$c0ed0517e336f22b$export$2e2bcd8739ae039.oslo = 10.722916666667; //"10d43'22.5\"E"


var $4d34d8675ead8d22$export$2e2bcd8739ae039 = {
    ft: {
        to_meter: 0.3048
    },
    "us-ft": {
        to_meter: 1200 / 3937
    }
};


var $ccc3ecc4732a4173$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $ccc3ecc4732a4173$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, "");
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, "");
        if (processedKey === lkey) return obj[testkey];
    }
}


function $583158df16d3522c$export$2e2bcd8739ae039(defData) {
    var self = {};
    var paramObj = defData.split("+").map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        var split = a.split("=");
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: "projName",
        datum: "datumCode",
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $gyVUi.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $gyVUi.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $gyVUi.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $gyVUi.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $gyVUi.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $gyVUi.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $gyVUi.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $gyVUi.D2R);
        },
        lonc: function(v) {
            self.longc = v * (0, $gyVUi.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(",").map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $4d34d8675ead8d22$export$2e2bcd8739ae039), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $gyVUi.D2R);
        },
        pm: function(v) {
            var pm = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $c0ed0517e336f22b$export$2e2bcd8739ae039), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $gyVUi.D2R);
        },
        nadgrids: function(v) {
            if (v === "@null") self.datumCode = "none";
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = "ewnsud";
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === "function") paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === "string" && self.datumCode !== "WGS84") self.datumCode = self.datumCode.toLowerCase();
    return self;
}


var $4f92c43f9960a1f4$export$2e2bcd8739ae039 = $4f92c43f9960a1f4$var$parseString;
var $4f92c43f9960a1f4$var$NEUTRAL = 1;
var $4f92c43f9960a1f4$var$KEYWORD = 2;
var $4f92c43f9960a1f4$var$NUMBER = 3;
var $4f92c43f9960a1f4$var$QUOTED = 4;
var $4f92c43f9960a1f4$var$AFTERQUOTE = 5;
var $4f92c43f9960a1f4$var$ENDED = -1;
var $4f92c43f9960a1f4$var$whitespace = /\s/;
var $4f92c43f9960a1f4$var$latin = /[A-Za-z]/;
var $4f92c43f9960a1f4$var$keyword = /[A-Za-z84]/;
var $4f92c43f9960a1f4$var$endThings = /[,\]]/;
var $4f92c43f9960a1f4$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $4f92c43f9960a1f4$var$Parser(text) {
    if (typeof text !== "string") throw new Error("not a string");
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $4f92c43f9960a1f4$var$NEUTRAL;
}
$4f92c43f9960a1f4$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $4f92c43f9960a1f4$var$QUOTED) while($4f92c43f9960a1f4$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $4f92c43f9960a1f4$var$NEUTRAL:
            return this.neutral(char);
        case $4f92c43f9960a1f4$var$KEYWORD:
            return this.keyword(char);
        case $4f92c43f9960a1f4$var$QUOTED:
            return this.quoted(char);
        case $4f92c43f9960a1f4$var$AFTERQUOTE:
            return this.afterquote(char);
        case $4f92c43f9960a1f4$var$NUMBER:
            return this.number(char);
        case $4f92c43f9960a1f4$var$ENDED:
            return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in afterquote yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.afterItem = function(char) {
    if (char === ",") {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if (char === "]") {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $4f92c43f9960a1f4$var$ENDED;
        return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.number = function(char) {
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in number yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $4f92c43f9960a1f4$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$4f92c43f9960a1f4$var$Parser.prototype.keyword = function(char) {
    if ($4f92c43f9960a1f4$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === "[") {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in keyword yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.neutral = function(char) {
    if ($4f92c43f9960a1f4$var$latin.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = "";
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$NUMBER;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error("havn't handled \"" + char + '" in neutral yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $4f92c43f9960a1f4$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $4f92c43f9960a1f4$var$parseString(txt) {
    var parser = new $4f92c43f9960a1f4$var$Parser(txt);
    return parser.output();
}


function $5bda1e467f1c2649$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $5bda1e467f1c2649$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === "PARAMETER") key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $5bda1e467f1c2649$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === "TOWGS84") {
        obj[key] = v;
        return;
    }
    if (key === "AXIS") {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case "UNIT":
        case "PRIMEM":
        case "VERT_DATUM":
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case "SPHEROID":
        case "ELLIPSOID":
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case "PROJECTEDCRS":
        case "PROJCRS":
        case "GEOGCS":
        case "GEOCCS":
        case "PROJCS":
        case "LOCAL_CS":
        case "GEODCRS":
        case "GEODETICCRS":
        case "GEODETICDATUM":
        case "EDATUM":
        case "ENGINEERINGDATUM":
        case "VERT_CS":
        case "VERTCRS":
        case "VERTICALCRS":
        case "COMPD_CS":
        case "COMPOUNDCRS":
        case "ENGINEERINGCRS":
        case "ENGCRS":
        case "FITTED_CS":
        case "LOCAL_DATUM":
        case "DATUM":
            v[0] = [
                "name",
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $5bda1e467f1c2649$var$mapit(obj, key, v);
    }
}


var $5c3aabf591259c07$var$D2R = 0.01745329251994329577;
function $5c3aabf591259c07$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $5c3aabf591259c07$var$d2r(input) {
    return input * $5c3aabf591259c07$var$D2R;
}
function $5c3aabf591259c07$var$cleanWKT(wkt) {
    if (wkt.type === "GEOGCS") wkt.projName = "longlat";
    else if (wkt.type === "LOCAL_CS") {
        wkt.projName = "identity";
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === "object") wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = "";
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = wkt.AXIS[i];
            var descriptor = axis[0].toLowerCase();
            if (descriptor.indexOf("north") !== -1) axisOrder += "n";
            else if (descriptor.indexOf("south") !== -1) axisOrder += "s";
            else if (descriptor.indexOf("east") !== -1) axisOrder += "e";
            else if (descriptor.indexOf("west") !== -1) axisOrder += "w";
        }
        if (axisOrder.length === 2) axisOrder += "u";
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === "metre") wkt.units = "meter";
        if (wkt.UNIT.convert) {
            if (wkt.type === "GEOGCS") {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === "GEOGCS") geogcs = wkt;
    if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === "d_") wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === "new_zealand_geodetic_datum_1949" || wkt.datumCode === "new_zealand_1949") wkt.datumCode = "nzgd49";
        if (wkt.datumCode === "wgs_1984" || wkt.datumCode === "world_geodetic_system_1984") {
            if (wkt.PROJECTION === "Mercator_Auxiliary_Sphere") wkt.sphere = true;
            wkt.datumCode = "wgs84";
        }
        if (wkt.datumCode.slice(-6) === "_ferro") wkt.datumCode = wkt.datumCode.slice(0, -6);
        if (wkt.datumCode.slice(-8) === "_jakarta") wkt.datumCode = wkt.datumCode.slice(0, -8);
        if (~wkt.datumCode.indexOf("belge")) wkt.datumCode = "rnb72";
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk");
            if (wkt.ellps.toLowerCase().slice(0, 13) === "international") wkt.ellps = "intl";
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf("osgb_1936")) wkt.datumCode = "osgb36";
        if (~wkt.datumCode.indexOf("osni_1952")) wkt.datumCode = "osni52";
        if (~wkt.datumCode.indexOf("tm65") || ~wkt.datumCode.indexOf("geodetic_datum_of_1965")) wkt.datumCode = "ire65";
        if (wkt.datumCode === "ch1903+") wkt.datumCode = "ch1903";
        if (~wkt.datumCode.indexOf("israel")) wkt.datumCode = "isr93";
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $5c3aabf591259c07$var$rename(wkt, a);
    };
    var list = [
        [
            "standard_parallel_1",
            "Standard_Parallel_1"
        ],
        [
            "standard_parallel_2",
            "Standard_Parallel_2"
        ],
        [
            "false_easting",
            "False_Easting"
        ],
        [
            "false_northing",
            "False_Northing"
        ],
        [
            "central_meridian",
            "Central_Meridian"
        ],
        [
            "latitude_of_origin",
            "Latitude_Of_Origin"
        ],
        [
            "latitude_of_origin",
            "Central_Parallel"
        ],
        [
            "scale_factor",
            "Scale_Factor"
        ],
        [
            "k0",
            "scale_factor"
        ],
        [
            "latitude_of_center",
            "Latitude_Of_Center"
        ],
        [
            "latitude_of_center",
            "Latitude_of_center"
        ],
        [
            "lat0",
            "latitude_of_center",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "longitude_of_center",
            "Longitude_Of_Center"
        ],
        [
            "longitude_of_center",
            "Longitude_of_center"
        ],
        [
            "longc",
            "longitude_of_center",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "x0",
            "false_easting",
            toMeter
        ],
        [
            "y0",
            "false_northing",
            toMeter
        ],
        [
            "long0",
            "central_meridian",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat0",
            "latitude_of_origin",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat0",
            "standard_parallel_1",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat1",
            "standard_parallel_1",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "lat2",
            "standard_parallel_2",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "azimuth",
            "Azimuth"
        ],
        [
            "alpha",
            "azimuth",
            $5c3aabf591259c07$var$d2r
        ],
        [
            "srsCode",
            "name"
        ]
    ];
    list.forEach(renamer);
    if (!wkt.long0 && wkt.longc && (wkt.projName === "Albers_Conic_Equal_Area" || wkt.projName === "Lambert_Azimuthal_Equal_Area")) wkt.long0 = wkt.longc;
    if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === "Stereographic_South_Pole" || wkt.projName === "Polar Stereographic (variant B)")) {
        wkt.lat0 = $5c3aabf591259c07$var$d2r(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
    }
}
function $5c3aabf591259c07$export$2e2bcd8739ae039(wkt) {
    var lisp = (0, $4f92c43f9960a1f4$export$2e2bcd8739ae039)(wkt);
    var type = lisp.shift();
    var name = lisp.shift();
    lisp.unshift([
        "name",
        name
    ]);
    lisp.unshift([
        "type",
        type
    ]);
    var obj = {};
    (0, $5bda1e467f1c2649$export$337bc7a3aef1f775)(lisp, obj);
    $5c3aabf591259c07$var$cleanWKT(obj);
    return obj;
}


function $a9b3183caccb3297$var$defs(name) {
    /*global console*/ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === "string") {
            if (def.charAt(0) === "+") $a9b3183caccb3297$var$defs[name] = (0, $583158df16d3522c$export$2e2bcd8739ae039)(arguments[1]);
            else $a9b3183caccb3297$var$defs[name] = (0, $5c3aabf591259c07$export$2e2bcd8739ae039)(arguments[1]);
        } else $a9b3183caccb3297$var$defs[name] = def;
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) $a9b3183caccb3297$var$defs.apply(that, v);
            else $a9b3183caccb3297$var$defs(v);
        });
        else if (typeof name === "string") {
            if (name in $a9b3183caccb3297$var$defs) return $a9b3183caccb3297$var$defs[name];
        } else if ("EPSG" in name) $a9b3183caccb3297$var$defs["EPSG:" + name.EPSG] = name;
        else if ("ESRI" in name) $a9b3183caccb3297$var$defs["ESRI:" + name.ESRI] = name;
        else if ("IAU2000" in name) $a9b3183caccb3297$var$defs["IAU2000:" + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $95bfc720255032a6$export$2e2bcd8739ae039)($a9b3183caccb3297$var$defs);
var $a9b3183caccb3297$export$2e2bcd8739ae039 = $a9b3183caccb3297$var$defs;





function $bddd3b9c0d2064cd$var$testObj(code) {
    return typeof code === "string";
}
function $bddd3b9c0d2064cd$var$testDef(code) {
    return code in (0, $a9b3183caccb3297$export$2e2bcd8739ae039);
}
var $bddd3b9c0d2064cd$var$codeWords = [
    "PROJECTEDCRS",
    "PROJCRS",
    "GEOGCS",
    "GEOCCS",
    "PROJCS",
    "LOCAL_CS",
    "GEODCRS",
    "GEODETICCRS",
    "GEODETICDATUM",
    "ENGCRS",
    "ENGINEERINGCRS"
];
function $bddd3b9c0d2064cd$var$testWKT(code) {
    return $bddd3b9c0d2064cd$var$codeWords.some(function(word) {
        return code.indexOf(word) > -1;
    });
}
var $bddd3b9c0d2064cd$var$codes = [
    "3857",
    "900913",
    "3785",
    "102113"
];
function $bddd3b9c0d2064cd$var$checkMercator(item) {
    var auth = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(item, "authority");
    if (!auth) return;
    var code = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(auth, "epsg");
    return code && $bddd3b9c0d2064cd$var$codes.indexOf(code) > -1;
}
function $bddd3b9c0d2064cd$var$checkProjStr(item) {
    var ext = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(item, "extension");
    if (!ext) return;
    return (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)(ext, "proj4");
}
function $bddd3b9c0d2064cd$var$testProj(code) {
    return code[0] === "+";
}
function $bddd3b9c0d2064cd$var$parse(code) {
    if ($bddd3b9c0d2064cd$var$testObj(code)) {
        //check to see if this is a WKT string
        if ($bddd3b9c0d2064cd$var$testDef(code)) return (0, $a9b3183caccb3297$export$2e2bcd8739ae039)[code];
        if ($bddd3b9c0d2064cd$var$testWKT(code)) {
            var out = (0, $5c3aabf591259c07$export$2e2bcd8739ae039)(code);
            // test of spetial case, due to this being a very common and often malformed
            if ($bddd3b9c0d2064cd$var$checkMercator(out)) return (0, $a9b3183caccb3297$export$2e2bcd8739ae039)["EPSG:3857"];
            var maybeProjStr = $bddd3b9c0d2064cd$var$checkProjStr(out);
            if (maybeProjStr) return (0, $583158df16d3522c$export$2e2bcd8739ae039)(maybeProjStr);
            return out;
        }
        if ($bddd3b9c0d2064cd$var$testProj(code)) return (0, $583158df16d3522c$export$2e2bcd8739ae039)(code);
    } else return code;
}
var $bddd3b9c0d2064cd$export$2e2bcd8739ae039 = $bddd3b9c0d2064cd$var$parse;


function $96b30a4c80088893$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}



var $bi5ZC = parcelRequire("bi5ZC");

var $a9oRf = parcelRequire("a9oRf");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d64d5a882433f366$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!("x0" in this)) this.x0 = 0;
    if (!("y0" in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $d64d5a882433f366$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $gyVUi.R2D) > 90 && lat * (0, $gyVUi.R2D) < -90 && lon * (0, $gyVUi.R2D) > 180 && lon * (0, $gyVUi.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $gyVUi.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $3xC66.default)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $d64d5a882433f366$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $gyVUi.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $a9oRf.default)(this.long0 + x / (this.a * this.k0));
    p.x = lon;
    p.y = lat;
    return p;
}
var $d64d5a882433f366$export$e4b2ac9215619f8d = [
    "Mercator",
    "Popular Visualisation Pseudo Mercator",
    "Mercator_1SP",
    "Mercator_Auxiliary_Sphere",
    "merc"
];
var $d64d5a882433f366$export$2e2bcd8739ae039 = {
    init: $d64d5a882433f366$export$2cd8252107eb640b,
    forward: $d64d5a882433f366$export$174bb771924e7eb1,
    inverse: $d64d5a882433f366$export$70ae2c07e401031b,
    names: $d64d5a882433f366$export$e4b2ac9215619f8d
};


function $dad2845bfa7291b9$export$2cd8252107eb640b() {
//no-op for longlat
}
function $dad2845bfa7291b9$export$174bb771924e7eb1(pt) {
    return pt;
}
var $dad2845bfa7291b9$export$e4b2ac9215619f8d = [
    "longlat",
    "identity"
];
var $dad2845bfa7291b9$export$2e2bcd8739ae039 = {
    init: $dad2845bfa7291b9$export$2cd8252107eb640b,
    forward: $dad2845bfa7291b9$export$174bb771924e7eb1,
    inverse: $dad2845bfa7291b9$export$174bb771924e7eb1,
    names: $dad2845bfa7291b9$export$e4b2ac9215619f8d
};


var $169de593aeaa174c$var$projs = [
    (0, $d64d5a882433f366$export$2e2bcd8739ae039),
    (0, $dad2845bfa7291b9$export$2e2bcd8739ae039)
];
var $169de593aeaa174c$var$names = {};
var $169de593aeaa174c$var$projStore = [];
function $169de593aeaa174c$export$e16d8520af44a096(proj, i) {
    var len = $169de593aeaa174c$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $169de593aeaa174c$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $169de593aeaa174c$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $169de593aeaa174c$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $169de593aeaa174c$var$names[n] !== "undefined" && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
}
function $169de593aeaa174c$export$b3571188c770cc5a() {
    $169de593aeaa174c$var$projs.forEach($169de593aeaa174c$export$e16d8520af44a096);
}
var $169de593aeaa174c$export$2e2bcd8739ae039 = {
    start: $169de593aeaa174c$export$b3571188c770cc5a,
    add: $169de593aeaa174c$export$e16d8520af44a096,
    get: $169de593aeaa174c$export$3988ae62b71be9a3
};



var $gyVUi = parcelRequire("gyVUi");
var $8988c354f092c217$export$2e2bcd8739ae039 = {};
$8988c354f092c217$export$2e2bcd8739ae039.MERIT = {
    a: 6378137.0,
    rf: 298.257,
    ellipseName: "MERIT 1983"
};
$8988c354f092c217$export$2e2bcd8739ae039.SGS85 = {
    a: 6378136.0,
    rf: 298.257,
    ellipseName: "Soviet Geodetic System 85"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS80 = {
    a: 6378137.0,
    rf: 298.257222101,
    ellipseName: "GRS 1980(IUGG, 1980)"
};
$8988c354f092c217$export$2e2bcd8739ae039.IAU76 = {
    a: 6378140.0,
    rf: 298.257,
    ellipseName: "IAU 1976"
};
$8988c354f092c217$export$2e2bcd8739ae039.airy = {
    a: 6377563.396,
    b: 6356256.910,
    ellipseName: "Airy 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.APL4 = {
    a: 6378137,
    rf: 298.25,
    ellipseName: "Appl. Physics. 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.NWL9D = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "Naval Weapons Lab., 1965"
};
$8988c354f092c217$export$2e2bcd8739ae039.mod_airy = {
    a: 6377340.189,
    b: 6356034.446,
    ellipseName: "Modified Airy"
};
$8988c354f092c217$export$2e2bcd8739ae039.andrae = {
    a: 6377104.43,
    rf: 300.0,
    ellipseName: "Andrae 1876 (Den., Iclnd.)"
};
$8988c354f092c217$export$2e2bcd8739ae039.aust_SA = {
    a: 6378160.0,
    rf: 298.25,
    ellipseName: "Australian Natl & S. Amer. 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.GRS67 = {
    a: 6378160.0,
    rf: 298.2471674270,
    ellipseName: "GRS 67(IUGG 1967)"
};
$8988c354f092c217$export$2e2bcd8739ae039.bessel = {
    a: 6377397.155,
    rf: 299.1528128,
    ellipseName: "Bessel 1841"
};
$8988c354f092c217$export$2e2bcd8739ae039.bess_nam = {
    a: 6377483.865,
    rf: 299.1528128,
    ellipseName: "Bessel 1841 (Namibia)"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk66 = {
    a: 6378206.4,
    b: 6356583.8,
    ellipseName: "Clarke 1866"
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk80 = {
    a: 6378249.145,
    rf: 293.4663,
    ellipseName: "Clarke 1880 mod."
};
$8988c354f092c217$export$2e2bcd8739ae039.clrk58 = {
    a: 6378293.645208759,
    rf: 294.2606763692654,
    ellipseName: "Clarke 1858"
};
$8988c354f092c217$export$2e2bcd8739ae039.CPM = {
    a: 6375738.7,
    rf: 334.29,
    ellipseName: "Comm. des Poids et Mesures 1799"
};
$8988c354f092c217$export$2e2bcd8739ae039.delmbr = {
    a: 6376428.0,
    rf: 311.5,
    ellipseName: "Delambre 1810 (Belgium)"
};
$8988c354f092c217$export$2e2bcd8739ae039.engelis = {
    a: 6378136.05,
    rf: 298.2566,
    ellipseName: "Engelis 1985"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst30 = {
    a: 6377276.345,
    rf: 300.8017,
    ellipseName: "Everest 1830"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst48 = {
    a: 6377304.063,
    rf: 300.8017,
    ellipseName: "Everest 1948"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst56 = {
    a: 6377301.243,
    rf: 300.8017,
    ellipseName: "Everest 1956"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrst69 = {
    a: 6377295.664,
    rf: 300.8017,
    ellipseName: "Everest 1969"
};
$8988c354f092c217$export$2e2bcd8739ae039.evrstSS = {
    a: 6377298.556,
    rf: 300.8017,
    ellipseName: "Everest (Sabah & Sarawak)"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60 = {
    a: 6378166.0,
    rf: 298.3,
    ellipseName: "Fischer (Mercury Datum) 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr60m = {
    a: 6378155.0,
    rf: 298.3,
    ellipseName: "Fischer 1960"
};
$8988c354f092c217$export$2e2bcd8739ae039.fschr68 = {
    a: 6378150.0,
    rf: 298.3,
    ellipseName: "Fischer 1968"
};
$8988c354f092c217$export$2e2bcd8739ae039.helmert = {
    a: 6378200.0,
    rf: 298.3,
    ellipseName: "Helmert 1906"
};
$8988c354f092c217$export$2e2bcd8739ae039.hough = {
    a: 6378270.0,
    rf: 297.0,
    ellipseName: "Hough"
};
$8988c354f092c217$export$2e2bcd8739ae039.intl = {
    a: 6378388.0,
    rf: 297.0,
    ellipseName: "International 1909 (Hayford)"
};
$8988c354f092c217$export$2e2bcd8739ae039.kaula = {
    a: 6378163.0,
    rf: 298.24,
    ellipseName: "Kaula 1961"
};
$8988c354f092c217$export$2e2bcd8739ae039.lerch = {
    a: 6378139.0,
    rf: 298.257,
    ellipseName: "Lerch 1979"
};
$8988c354f092c217$export$2e2bcd8739ae039.mprts = {
    a: 6397300.0,
    rf: 191.0,
    ellipseName: "Maupertius 1738"
};
$8988c354f092c217$export$2e2bcd8739ae039.new_intl = {
    a: 6378157.5,
    b: 6356772.2,
    ellipseName: "New International 1967"
};
$8988c354f092c217$export$2e2bcd8739ae039.plessis = {
    a: 6376523.0,
    rf: 6355863.0,
    ellipseName: "Plessis 1817 (France)"
};
$8988c354f092c217$export$2e2bcd8739ae039.krass = {
    a: 6378245.0,
    rf: 298.3,
    ellipseName: "Krassovsky, 1942"
};
$8988c354f092c217$export$2e2bcd8739ae039.SEasia = {
    a: 6378155.0,
    b: 6356773.3205,
    ellipseName: "Southeast Asia"
};
$8988c354f092c217$export$2e2bcd8739ae039.walbeck = {
    a: 6376896.0,
    b: 6355834.8467,
    ellipseName: "Walbeck"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS60 = {
    a: 6378165.0,
    rf: 298.3,
    ellipseName: "WGS 60"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS66 = {
    a: 6378145.0,
    rf: 298.25,
    ellipseName: "WGS 66"
};
$8988c354f092c217$export$2e2bcd8739ae039.WGS7 = {
    a: 6378135.0,
    rf: 298.26,
    ellipseName: "WGS 72"
};
var $8988c354f092c217$export$a1db874f6c0f1ba1 = $8988c354f092c217$export$2e2bcd8739ae039.WGS84 = {
    a: 6378137.0,
    rf: 298.257223563,
    ellipseName: "WGS 84"
};
$8988c354f092c217$export$2e2bcd8739ae039.sphere = {
    a: 6370997.0,
    b: 6370997.0,
    ellipseName: "Normal Sphere (r=6370997)"
};



function $98f4ab684186b766$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $gyVUi.SIXTH) + es * ((0, $gyVUi.RA4) + es * (0, $gyVUi.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $98f4ab684186b766$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $8988c354f092c217$export$2e2bcd8739ae039), ellps);
        if (!ellipse) ellipse = (0, $8988c354f092c217$export$a1db874f6c0f1ba1);
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $gyVUi.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}


var $c36bbc8057de3d00$export$2e2bcd8739ae039 = {};
$c36bbc8057de3d00$export$2e2bcd8739ae039.wgs84 = {
    towgs84: "0,0,0",
    ellipse: "WGS84",
    datumName: "WGS84"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ch1903 = {
    towgs84: "674.374,15.056,405.346",
    ellipse: "bessel",
    datumName: "swiss"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ggrs87 = {
    towgs84: "-199.87,74.79,246.62",
    ellipse: "GRS80",
    datumName: "Greek_Geodetic_Reference_System_1987"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nad83 = {
    towgs84: "0,0,0",
    ellipse: "GRS80",
    datumName: "North_American_Datum_1983"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nad27 = {
    nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
    ellipse: "clrk66",
    datumName: "North_American_Datum_1927"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.potsdam = {
    towgs84: "606.0,23.0,413.0",
    ellipse: "bessel",
    datumName: "Potsdam Rauenberg 1950 DHDN"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.carthage = {
    towgs84: "-263.0,6.0,431.0",
    ellipse: "clark80",
    datumName: "Carthage 1934 Tunisia"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.hermannskogel = {
    towgs84: "653.0,-212.0,449.0",
    ellipse: "bessel",
    datumName: "Hermannskogel"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.osni52 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "airy",
    datumName: "Irish National"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.ire65 = {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "mod_airy",
    datumName: "Ireland 1965"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.rassadiran = {
    towgs84: "-133.63,-157.5,-158.62",
    ellipse: "intl",
    datumName: "Rassadiran"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.nzgd49 = {
    towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
    ellipse: "intl",
    datumName: "New Zealand Geodetic Datum 1949"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.osgb36 = {
    towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
    ellipse: "airy",
    datumName: "Airy 1830"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.s_jtsk = {
    towgs84: "589,76,480",
    ellipse: "bessel",
    datumName: "S-JTSK (Ferro)"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.beduaram = {
    towgs84: "-106,-87,188",
    ellipse: "clrk80",
    datumName: "Beduaram"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.gunung_segara = {
    towgs84: "-403,684,41",
    ellipse: "bessel",
    datumName: "Gunung Segara Jakarta"
};
$c36bbc8057de3d00$export$2e2bcd8739ae039.rnb72 = {
    towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
    ellipse: "intl",
    datumName: "Reseau National Belge 1972"
};



var $gyVUi = parcelRequire("gyVUi");
function $2c13a87cc45f972b$var$datum(datumCode, datum_params, a, b, es, ep2) {
    var out = {};
    if (datumCode === undefined || datumCode === "none") out.datum_type = (0, $gyVUi.PJD_NODATUM);
    else out.datum_type = (0, $gyVUi.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $gyVUi.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $gyVUi.PJD_7PARAM);
                out.datum_params[3] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[4] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[5] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    out.a = a; //datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $2c13a87cc45f972b$export$2e2bcd8739ae039 = $2c13a87cc45f972b$var$datum;



function $24869d6338533b3b$var$Projection(srsCode, callback) {
    if (!(this instanceof $24869d6338533b3b$var$Projection)) return new $24869d6338533b3b$var$Projection(srsCode);
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $bddd3b9c0d2064cd$export$2e2bcd8739ae039)(srsCode);
    if (typeof json !== "object") {
        callback(srsCode);
        return;
    }
    var ourProj = $24869d6338533b3b$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback(srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== "none") {
        var datumDef = (0, $ccc3ecc4732a4173$export$2e2bcd8739ae039)((0, $c36bbc8057de3d00$export$2e2bcd8739ae039), json.datumCode);
        if (datumDef) {
            json.datum_params = datumDef.towgs84 ? datumDef.towgs84.split(",") : null;
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || "enu";
    json.ellps = json.ellps || "wgs84";
    var sphere_ = (0, $98f4ab684186b766$export$b2690196de52b050)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $98f4ab684186b766$export$e3d7bf2ed2a7479f)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var datumObj = json.datum || (0, $2c13a87cc45f972b$export$2e2bcd8739ae039)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2);
    (0, $96b30a4c80088893$export$2e2bcd8739ae039)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $96b30a4c80088893$export$2e2bcd8739ae039)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calulated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$24869d6338533b3b$var$Projection.projections = (0, $169de593aeaa174c$export$2e2bcd8739ae039);
$24869d6338533b3b$var$Projection.projections.start();
var $24869d6338533b3b$export$2e2bcd8739ae039 = $24869d6338533b3b$var$Projection;



var $gyVUi = parcelRequire("gyVUi");

var $gyVUi = parcelRequire("gyVUi");

var $gyVUi = parcelRequire("gyVUi");
"use strict";
function $3a04bd721826a648$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $gyVUi.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $gyVUi.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $3a04bd721826a648$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; //Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $gyVUi.HALF_PI) && Latitude > -1.001 * (0, $gyVUi.HALF_PI)) Latitude = -(0, $gyVUi.HALF_PI);
    else if (Latitude > (0, $gyVUi.HALF_PI) && Latitude < 1.001 * (0, $gyVUi.HALF_PI)) Latitude = (0, $gyVUi.HALF_PI);
    else if (Latitude < -(0, $gyVUi.HALF_PI)) /* Latitude out of range */ //..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $gyVUi.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $3a04bd721826a648$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $gyVUi.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $3a04bd721826a648$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $3a04bd721826a648$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) //if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        //if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } //cs_geocentric_from_wgs84()
}


function $98d040a88dc0214f$var$checkParams(type) {
    return type === (0, $gyVUi.PJD_3PARAM) || type === (0, $gyVUi.PJD_7PARAM);
}
function $98d040a88dc0214f$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $3a04bd721826a648$export$68c8d8590fbb24e4)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $gyVUi.PJD_NODATUM) || dest.datum_type === (0, $gyVUi.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    // Do we need to go through geocentric coordinates?
    if (source.es === dest.es && source.a === dest.a && !$98d040a88dc0214f$var$checkParams(source.datum_type) && !$98d040a88dc0214f$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $3a04bd721826a648$export$4a4ae2976f9a808a)(point, source.es, source.a);
    // Convert between datums
    if ($98d040a88dc0214f$var$checkParams(source.datum_type)) point = (0, $3a04bd721826a648$export$d18952b9ecb47c8f)(point, source.datum_type, source.datum_params);
    if ($98d040a88dc0214f$var$checkParams(dest.datum_type)) point = (0, $3a04bd721826a648$export$2b744ad521e7ac0b)(point, dest.datum_type, dest.datum_params);
    return (0, $3a04bd721826a648$export$26210192c8922750)(point, dest.es, dest.a, dest.b);
}


function $cedb7bb5617791b0$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ("ew".indexOf(crs.axis[i]) !== -1) t = "x";
            else t = "y";
        } else if (i === 1) {
            v = yin;
            if ("ns".indexOf(crs.axis[i]) !== -1) t = "y";
            else t = "x";
        } else {
            v = zin;
            t = "z";
        }
        switch(crs.axis[i]){
            case "e":
            case "w":
            case "n":
            case "s":
                out[t] = v;
                break;
            case "u":
                if (point[t] !== undefined) out.z = v;
                break;
            case "d":
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}



function $01093474ae9bd8f6$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}


function $906e8b8bdc80d434$export$2e2bcd8739ae039(point) {
    $906e8b8bdc80d434$var$checkCoord(point.x);
    $906e8b8bdc80d434$var$checkCoord(point.y);
}
function $906e8b8bdc80d434$var$checkCoord(num) {
    if (typeof Number.isFinite === "function") {
        if (Number.isFinite(num)) return;
        throw new TypeError("coordinates must be finite numbers");
    }
    if (typeof num !== "number" || num !== num || !isFinite(num)) throw new TypeError("coordinates must be finite numbers");
}


function $8e8cfb7cbefc2113$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_7PARAM)) && dest.datumCode !== "WGS84" || (dest.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_7PARAM)) && source.datumCode !== "WGS84";
}
function $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, dest, point) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $01093474ae9bd8f6$export$2e2bcd8739ae039)(point);
    (0, $906e8b8bdc80d434$export$2e2bcd8739ae039)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $8e8cfb7cbefc2113$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $24869d6338533b3b$export$2e2bcd8739ae039)("WGS84");
        point = $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, wgs84, point);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (source.axis !== "enu") point = (0, $cedb7bb5617791b0$export$2e2bcd8739ae039)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === "longlat") point = {
        x: point.x * (0, $gyVUi.D2R),
        y: point.y * (0, $gyVUi.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $98d040a88dc0214f$export$2e2bcd8739ae039)(source.datum, dest.datum, point);
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === "longlat") // convert radians to decimal degrees
    point = {
        x: point.x * (0, $gyVUi.R2D),
        y: point.y * (0, $gyVUi.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (dest.axis !== "enu") return (0, $cedb7bb5617791b0$export$2e2bcd8739ae039)(dest, true, point);
    return point;
}


var $471507637a3ff861$var$wgs84 = (0, $24869d6338533b3b$export$2e2bcd8739ae039)("WGS84");
function $471507637a3ff861$var$transformer(from, to, coords) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039)(from, to, coords) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (typeof transformedArray.z === "number") return [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.splice(3));
                else return [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.splice(3));
            } else return [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.splice(2));
        } else return [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039)(from, to, coords);
        keys = Object.keys(coords);
        if (keys.length === 2) return out;
        keys.forEach(function(key) {
            if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
                if (key === "x" || key === "y" || key === "z") return;
            } else {
                if (key === "x" || key === "y") return;
            }
            out[key] = coords[key];
        });
        return out;
    }
}
function $471507637a3ff861$var$checkProj(item) {
    if (item instanceof (0, $24869d6338533b3b$export$2e2bcd8739ae039)) return item;
    if (item.oProj) return item.oProj;
    return (0, $24869d6338533b3b$export$2e2bcd8739ae039)(item);
}
function $471507637a3ff861$var$proj4(fromProj, toProj, coord) {
    fromProj = $471507637a3ff861$var$checkProj(fromProj);
    var single = false;
    var obj;
    if (typeof toProj === "undefined") {
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    } else if (typeof toProj.x !== "undefined" || Array.isArray(toProj)) {
        coord = toProj;
        toProj = fromProj;
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    }
    toProj = $471507637a3ff861$var$checkProj(toProj);
    if (coord) return $471507637a3ff861$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            forward: function(coords) {
                return $471507637a3ff861$var$transformer(fromProj, toProj, coords);
            },
            inverse: function(coords) {
                return $471507637a3ff861$var$transformer(toProj, fromProj, coords);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $471507637a3ff861$export$2e2bcd8739ae039 = $471507637a3ff861$var$proj4;




function $d8ec3fc1ff061c76$var$Point(x, y, z) {
    if (!(this instanceof $d8ec3fc1ff061c76$var$Point)) return new $d8ec3fc1ff061c76$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === "object") {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === "string" && typeof y === "undefined") {
        var coords = x.split(",");
        this.x = parseFloat(coords[0], 10);
        this.y = parseFloat(coords[1], 10);
        this.z = parseFloat(coords[2], 10) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
$d8ec3fc1ff061c76$var$Point.fromMGRS = function(mgrsStr) {
    return new $d8ec3fc1ff061c76$var$Point((0, $31ee54b8e1d1cd8f$export$b63cca88ddc558a9)(mgrsStr));
};
$d8ec3fc1ff061c76$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $31ee54b8e1d1cd8f$export$174bb771924e7eb1)([
        this.x,
        this.y
    ], accuracy);
};
var $d8ec3fc1ff061c76$export$2e2bcd8739ae039 = $d8ec3fc1ff061c76$var$Point;






// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js
var $bf6313ff986be9ac$var$C00 = 1;
var $bf6313ff986be9ac$var$C02 = 0.25;
var $bf6313ff986be9ac$var$C04 = 0.046875;
var $bf6313ff986be9ac$var$C06 = 0.01953125;
var $bf6313ff986be9ac$var$C08 = 0.01068115234375;
var $bf6313ff986be9ac$var$C22 = 0.75;
var $bf6313ff986be9ac$var$C44 = 0.46875;
var $bf6313ff986be9ac$var$C46 = 0.01302083333333333333;
var $bf6313ff986be9ac$var$C48 = 0.00712076822916666666;
var $bf6313ff986be9ac$var$C66 = 0.36458333333333333333;
var $bf6313ff986be9ac$var$C68 = 0.00569661458333333333;
var $bf6313ff986be9ac$var$C88 = 0.3076171875;
function $bf6313ff986be9ac$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $bf6313ff986be9ac$var$C00 - es * ($bf6313ff986be9ac$var$C02 + es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    en[1] = es * ($bf6313ff986be9ac$var$C22 - es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    var t = es * es;
    en[2] = t * ($bf6313ff986be9ac$var$C44 - es * ($bf6313ff986be9ac$var$C46 + es * $bf6313ff986be9ac$var$C48));
    t *= es;
    en[3] = t * ($bf6313ff986be9ac$var$C66 - es * $bf6313ff986be9ac$var$C68);
    en[4] = t * es * $bf6313ff986be9ac$var$C88;
    return en;
}


function $cae0dd692f473684$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}




var $gyVUi = parcelRequire("gyVUi");
var $e73ee39023f9c198$var$MAX_ITER = 20;
function $e73ee39023f9c198$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $e73ee39023f9c198$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        //phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $cae0dd692f473684$export$2e2bcd8739ae039)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $gyVUi.EPSLN)) return phi;
    }
    //..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $6e495242beb4668f$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $bf6313ff986be9ac$export$2e2bcd8739ae039)(this.es);
        this.ml0 = (0, $cae0dd692f473684$export$2e2bcd8739ae039)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $6e495242beb4668f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $gyVUi.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $gyVUi.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $cae0dd692f473684$export$2e2bcd8739ae039)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $6e495242beb4668f$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $a9oRf.default)(Math.atan2(g, h) + this.long0);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $e73ee39023f9c198$export$2e2bcd8739ae039)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $gyVUi.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $a9oRf.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi);
        } else {
            lat = (0, $gyVUi.HALF_PI) * (0, $boTd3.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $6e495242beb4668f$export$e4b2ac9215619f8d = [
    "Transverse_Mercator",
    "Transverse Mercator",
    "tmerc"
];
var $6e495242beb4668f$export$2e2bcd8739ae039 = {
    init: $6e495242beb4668f$export$2cd8252107eb640b,
    forward: $6e495242beb4668f$export$174bb771924e7eb1,
    inverse: $6e495242beb4668f$export$70ae2c07e401031b,
    names: $6e495242beb4668f$export$e4b2ac9215619f8d
};


// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js
function $06b03d370063c40e$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}


function $e7d754d244264a37$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}



function $ba9a64430787103e$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}


function $96919c3c2b0cfee9$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $ba9a64430787103e$export$2e2bcd8739ae039)(y * (1 + y / ((0, $e7d754d244264a37$export$2e2bcd8739ae039)(1, y) + 1)));
    return x < 0 ? -y : y;
}


function $ecee41736c9c0e4b$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}


function $e909e682fc23c405$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}



function $925c5d35b4e59088$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}


function $da7beda932685c15$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $06b03d370063c40e$export$2e2bcd8739ae039)(arg_i);
    var cosh_arg_i = (0, $925c5d35b4e59088$export$2e2bcd8739ae039)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}



var $a9oRf = parcelRequire("a9oRf");
function $6f7c72613b8aa92a$export$2cd8252107eb640b() {
    if (this.es === undefined || this.es <= 0) throw new Error("incorrect elliptical usage");
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $ecee41736c9c0e4b$export$2e2bcd8739ae039)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $e909e682fc23c405$export$2e2bcd8739ae039)(this.gtu, 2 * Z));
}
function $6f7c72613b8aa92a$export$174bb771924e7eb1(p) {
    var Ce = (0, $a9oRf.default)(p.x - this.long0);
    var Cn = p.y;
    Cn = (0, $ecee41736c9c0e4b$export$2e2bcd8739ae039)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $e7d754d244264a37$export$2e2bcd8739ae039)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $96919c3c2b0cfee9$export$2e2bcd8739ae039)(Math.tan(Ce));
    var tmp = (0, $da7beda932685c15$export$2e2bcd8739ae039)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $6f7c72613b8aa92a$export$70ae2c07e401031b(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $da7beda932685c15$export$2e2bcd8739ae039)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $06b03d370063c40e$export$2e2bcd8739ae039)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $e7d754d244264a37$export$2e2bcd8739ae039)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $a9oRf.default)(Ce + this.long0);
        lat = (0, $ecee41736c9c0e4b$export$2e2bcd8739ae039)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $6f7c72613b8aa92a$export$e4b2ac9215619f8d = [
    "Extended_Transverse_Mercator",
    "Extended Transverse Mercator",
    "etmerc"
];
var $6f7c72613b8aa92a$export$2e2bcd8739ae039 = {
    init: $6f7c72613b8aa92a$export$2cd8252107eb640b,
    forward: $6f7c72613b8aa92a$export$174bb771924e7eb1,
    inverse: $6f7c72613b8aa92a$export$70ae2c07e401031b,
    names: $6f7c72613b8aa92a$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");
function $810f2c2910fd20b1$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $a9oRf.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}




var $gyVUi = parcelRequire("gyVUi");
var $efe46ba059d82de2$export$3f91ef0e0d0d8bf8 = "etmerc";
function $efe46ba059d82de2$export$2cd8252107eb640b() {
    var zone = (0, $810f2c2910fd20b1$export$2e2bcd8739ae039)(this.zone, this.long0);
    if (zone === undefined) throw new Error("unknown utm zone");
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $gyVUi.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $6f7c72613b8aa92a$export$2e2bcd8739ae039).init.apply(this);
    this.forward = (0, $6f7c72613b8aa92a$export$2e2bcd8739ae039).forward;
    this.inverse = (0, $6f7c72613b8aa92a$export$2e2bcd8739ae039).inverse;
}
var $efe46ba059d82de2$export$e4b2ac9215619f8d = [
    "Universal Transverse Mercator System",
    "utm"
];
var $efe46ba059d82de2$export$2e2bcd8739ae039 = {
    init: $efe46ba059d82de2$export$2cd8252107eb640b,
    names: $efe46ba059d82de2$export$e4b2ac9215619f8d,
    dependsOn: $efe46ba059d82de2$export$3f91ef0e0d0d8bf8
};


function $5db95ad4da70d3a6$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}



var $gyVUi = parcelRequire("gyVUi");
var $06b464b721451620$var$MAX_ITER = 20;
function $06b464b721451620$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $gyVUi.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $gyVUi.FORTPI)), this.C) * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * sphi, this.ratexp));
}
function $06b464b721451620$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)), this.C) * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * Math.sin(lat), this.ratexp)) - (0, $gyVUi.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $06b464b721451620$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)) / this.K, 1 / this.C);
    for(var i = $06b464b721451620$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $5db95ad4da70d3a6$export$2e2bcd8739ae039)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $gyVUi.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $06b464b721451620$export$e4b2ac9215619f8d = [
    "gauss"
];
var $06b464b721451620$export$2e2bcd8739ae039 = {
    init: $06b464b721451620$export$2cd8252107eb640b,
    forward: $06b464b721451620$export$174bb771924e7eb1,
    inverse: $06b464b721451620$export$70ae2c07e401031b,
    names: $06b464b721451620$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");
function $4279f8b9d31284e6$export$2cd8252107eb640b() {
    (0, $06b464b721451620$export$2e2bcd8739ae039).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = "Oblique Stereographic Alternative";
}
function $4279f8b9d31284e6$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $a9oRf.default)(p.x - this.long0);
    (0, $06b464b721451620$export$2e2bcd8739ae039).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $4279f8b9d31284e6$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = Math.sqrt(p.x * p.x + p.y * p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $06b464b721451620$export$2e2bcd8739ae039).inverse.apply(this, [
        p
    ]);
    p.x = (0, $a9oRf.default)(p.x + this.long0);
    return p;
}
var $4279f8b9d31284e6$export$e4b2ac9215619f8d = [
    "Stereographic_North_Pole",
    "Oblique_Stereographic",
    "Polar_Stereographic",
    "sterea",
    "Oblique Stereographic Alternative",
    "Double_Stereographic"
];
var $4279f8b9d31284e6$export$2e2bcd8739ae039 = {
    init: $4279f8b9d31284e6$export$2cd8252107eb640b,
    forward: $4279f8b9d31284e6$export$174bb771924e7eb1,
    inverse: $4279f8b9d31284e6$export$70ae2c07e401031b,
    names: $4279f8b9d31284e6$export$e4b2ac9215619f8d
};



var $llHto = parcelRequire("llHto");
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ function $31a8278a941356d4$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $31a8278a941356d4$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $31a8278a941356d4$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) //...reportError("omercFwdInfinity");
        return;
        //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $31a8278a941356d4$export$e4b2ac9215619f8d = [
    "somerc"
];
var $31a8278a941356d4$export$2e2bcd8739ae039 = {
    init: $31a8278a941356d4$export$2cd8252107eb640b,
    forward: $31a8278a941356d4$export$174bb771924e7eb1,
    inverse: $31a8278a941356d4$export$70ae2c07e401031b,
    names: $31a8278a941356d4$export$e4b2ac9215619f8d
};



var $3xC66 = parcelRequire("3xC66");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $a6cb33582cb5910b$export$2cd8252107eb640b() {
    this.no_off = this.no_off || false;
    this.no_rot = this.no_rot || false;
    if (isNaN(this.k0)) this.k0 = 1;
    var sinlat = Math.sin(this.lat0);
    var coslat = Math.cos(this.lat0);
    var con = this.e * sinlat;
    this.bl = Math.sqrt(1 + this.es / (1 - this.es) * Math.pow(coslat, 4));
    this.al = this.a * this.bl * this.k0 * Math.sqrt(1 - this.es) / (1 - con * con);
    var t0 = (0, $3xC66.default)(this.e, this.lat0, sinlat);
    var dl = this.bl / coslat * Math.sqrt((1 - this.es) / (1 - con * con));
    if (dl * dl < 1) dl = 1;
    var fl;
    var gl;
    if (!isNaN(this.longc)) {
        //Central point and azimuth method
        if (this.lat0 >= 0) fl = dl + Math.sqrt(dl * dl - 1);
        else fl = dl - Math.sqrt(dl * dl - 1);
        this.el = fl * Math.pow(t0, this.bl);
        gl = 0.5 * (fl - 1 / fl);
        this.gamma0 = Math.asin(Math.sin(this.alpha) / dl);
        this.long0 = this.longc - Math.asin(gl * Math.tan(this.gamma0)) / this.bl;
    } else {
        //2 points method
        var t1 = (0, $3xC66.default)(this.e, this.lat1, Math.sin(this.lat1));
        var t2 = (0, $3xC66.default)(this.e, this.lat2, Math.sin(this.lat2));
        if (this.lat0 >= 0) this.el = (dl + Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
        else this.el = (dl - Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
        var hl = Math.pow(t1, this.bl);
        var ll = Math.pow(t2, this.bl);
        fl = this.el / hl;
        gl = 0.5 * (fl - 1 / fl);
        var jl = (this.el * this.el - ll * hl) / (this.el * this.el + ll * hl);
        var pl = (ll - hl) / (ll + hl);
        var dlon12 = (0, $a9oRf.default)(this.long1 - this.long2);
        this.long0 = 0.5 * (this.long1 + this.long2) - Math.atan(jl * Math.tan(0.5 * this.bl * dlon12) / pl) / this.bl;
        this.long0 = (0, $a9oRf.default)(this.long0);
        var dlon10 = (0, $a9oRf.default)(this.long1 - this.long0);
        this.gamma0 = Math.atan(Math.sin(this.bl * dlon10) / gl);
        this.alpha = Math.asin(dl * Math.sin(this.gamma0));
    }
    if (this.no_off) this.uc = 0;
    else if (this.lat0 >= 0) this.uc = this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
    else this.uc = -1 * this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
}
function $a6cb33582cb5910b$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var us, vs;
    var con;
    if (Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
        if (lat > 0) con = -1;
        else con = 1;
        vs = this.al / this.bl * Math.log(Math.tan((0, $gyVUi.FORTPI) + con * this.gamma0 * 0.5));
        us = -1 * con * (0, $gyVUi.HALF_PI) * this.al / this.bl;
    } else {
        var t = (0, $3xC66.default)(this.e, lat, Math.sin(lat));
        var ql = this.el / Math.pow(t, this.bl);
        var sl = 0.5 * (ql - 1 / ql);
        var tl = 0.5 * (ql + 1 / ql);
        var vl = Math.sin(this.bl * dlon);
        var ul = (sl * Math.sin(this.gamma0) - vl * Math.cos(this.gamma0)) / tl;
        if (Math.abs(Math.abs(ul) - 1) <= (0, $gyVUi.EPSLN)) vs = Number.POSITIVE_INFINITY;
        else vs = 0.5 * this.al * Math.log((1 - ul) / (1 + ul)) / this.bl;
        if (Math.abs(Math.cos(this.bl * dlon)) <= (0, $gyVUi.EPSLN)) us = this.al * this.bl * dlon;
        else us = this.al * Math.atan2(sl * Math.cos(this.gamma0) + vl * Math.sin(this.gamma0), Math.cos(this.bl * dlon)) / this.bl;
    }
    if (this.no_rot) {
        p.x = this.x0 + us;
        p.y = this.y0 + vs;
    } else {
        us -= this.uc;
        p.x = this.x0 + vs * Math.cos(this.alpha) + us * Math.sin(this.alpha);
        p.y = this.y0 + us * Math.cos(this.alpha) - vs * Math.sin(this.alpha);
    }
    return p;
}
function $a6cb33582cb5910b$export$70ae2c07e401031b(p) {
    var us, vs;
    if (this.no_rot) {
        vs = p.y - this.y0;
        us = p.x - this.x0;
    } else {
        vs = (p.x - this.x0) * Math.cos(this.alpha) - (p.y - this.y0) * Math.sin(this.alpha);
        us = (p.y - this.y0) * Math.cos(this.alpha) + (p.x - this.x0) * Math.sin(this.alpha);
        us += this.uc;
    }
    var qp = Math.exp(-1 * this.bl * vs / this.al);
    var sp = 0.5 * (qp - 1 / qp);
    var tp = 0.5 * (qp + 1 / qp);
    var vp = Math.sin(this.bl * us / this.al);
    var up = (vp * Math.cos(this.gamma0) + sp * Math.sin(this.gamma0)) / tp;
    var ts = Math.pow(this.el / Math.sqrt((1 + up) / (1 - up)), 1 / this.bl);
    if (Math.abs(up - 1) < (0, $gyVUi.EPSLN)) {
        p.x = this.long0;
        p.y = (0, $gyVUi.HALF_PI);
    } else if (Math.abs(up + 1) < (0, $gyVUi.EPSLN)) {
        p.x = this.long0;
        p.y = -1 * (0, $gyVUi.HALF_PI);
    } else {
        p.y = (0, $2AZR8.default)(this.e, ts);
        p.x = (0, $a9oRf.default)(this.long0 - Math.atan2(sp * Math.cos(this.gamma0) - vp * Math.sin(this.gamma0), Math.cos(this.bl * us / this.al)) / this.bl);
    }
    return p;
}
var $a6cb33582cb5910b$export$e4b2ac9215619f8d = [
    "Hotine_Oblique_Mercator",
    "Hotine Oblique Mercator",
    "Hotine_Oblique_Mercator_Azimuth_Natural_Origin",
    "Hotine_Oblique_Mercator_Azimuth_Center",
    "omerc"
];
var $a6cb33582cb5910b$export$2e2bcd8739ae039 = {
    init: $a6cb33582cb5910b$export$2cd8252107eb640b,
    forward: $a6cb33582cb5910b$export$174bb771924e7eb1,
    inverse: $a6cb33582cb5910b$export$70ae2c07e401031b,
    names: $a6cb33582cb5910b$export$e4b2ac9215619f8d
};



var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $boTd3 = parcelRequire("boTd3");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d753eaf12887a276$export$2cd8252107eb640b() {
    // array of:  r_maj,r_min,lat1,lat2,c_lon,c_lat,false_east,false_north
    //double c_lat;                   /* center latitude                      */
    //double c_lon;                   /* center longitude                     */
    //double lat1;                    /* first standard parallel              */
    //double lat2;                    /* second standard parallel             */
    //double r_maj;                   /* major axis                           */
    //double r_min;                   /* minor axis                           */
    //double false_east;              /* x offset in meters                   */
    //double false_north;             /* y offset in meters                   */
    if (!this.lat2) this.lat2 = this.lat1;
     //if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $bi5ZC.default)(this.e, sin1, cos1);
    var ts1 = (0, $3xC66.default)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $bi5ZC.default)(this.e, sin2, cos2);
    var ts2 = (0, $3xC66.default)(this.e, this.lat2, sin2);
    var ts0 = (0, $3xC66.default)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = "Lambert Conformal Conic";
}
function $d753eaf12887a276$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $gyVUi.EPSLN)) lat = (0, $boTd3.default)(lat) * ((0, $gyVUi.HALF_PI) - 2 * (0, $gyVUi.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI));
    var ts, rh1;
    if (con > (0, $gyVUi.EPSLN)) {
        ts = (0, $3xC66.default)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $d753eaf12887a276$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $gyVUi.HALF_PI);
    lon = (0, $a9oRf.default)(theta / this.ns + this.long0);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d753eaf12887a276$export$e4b2ac9215619f8d = [
    "Lambert Tangential Conformal Conic Projection",
    "Lambert_Conformal_Conic",
    "Lambert_Conformal_Conic_2SP",
    "lcc"
];
var $d753eaf12887a276$export$2e2bcd8739ae039 = {
    init: $d753eaf12887a276$export$2cd8252107eb640b,
    forward: $d753eaf12887a276$export$174bb771924e7eb1,
    inverse: $d753eaf12887a276$export$70ae2c07e401031b,
    names: $d753eaf12887a276$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");
function $c765c705b741a192$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251;
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $c765c705b741a192$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $c765c705b741a192$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x*/ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $c765c705b741a192$export$e4b2ac9215619f8d = [
    "Krovak",
    "krovak"
];
var $c765c705b741a192$export$2e2bcd8739ae039 = {
    init: $c765c705b741a192$export$2cd8252107eb640b,
    forward: $c765c705b741a192$export$174bb771924e7eb1,
    inverse: $c765c705b741a192$export$70ae2c07e401031b,
    names: $c765c705b741a192$export$e4b2ac9215619f8d
};


function $af51062589eeb2ce$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}


function $8b22a51ec249391e$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}


function $d08e0117e308bb87$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}


function $d36e2161accfe0ec$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}


function $89245c5bc9a5a616$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}


function $259e1333723cc7cb$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $7bf9815baea17aa9$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $gyVUi.HALF_PI) ? x : x - (0, $boTd3.default)(x) * Math.PI;
}


function $8ebd4771f70de1ee$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}



var $gyVUi = parcelRequire("gyVUi");
function $00f791059e8f61f5$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        this.ml0 = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $00f791059e8f61f5$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        //ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $00f791059e8f61f5$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $gyVUi.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $a9oRf.default)(lam + this.long0);
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(phi);
    return p;
}
var $00f791059e8f61f5$export$e4b2ac9215619f8d = [
    "Cassini",
    "Cassini_Soldner",
    "cass"
];
var $00f791059e8f61f5$export$2e2bcd8739ae039 = {
    init: $00f791059e8f61f5$export$2cd8252107eb640b,
    forward: $00f791059e8f61f5$export$174bb771924e7eb1,
    inverse: $00f791059e8f61f5$export$70ae2c07e401031b,
    names: $00f791059e8f61f5$export$e4b2ac9215619f8d
};



var $deudM = parcelRequire("deudM");

var $8mhgZ = parcelRequire("8mhgZ");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $dbf05e97c9232a2a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $dbf05e97c9232a2a$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $dbf05e97c9232a2a$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $ljPJJ.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $a9oRf.default)(this.long0 + lon);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $dbf05e97c9232a2a$export$e4b2ac9215619f8d = [
    "gnom"
];
var $dbf05e97c9232a2a$export$2e2bcd8739ae039 = {
    init: $dbf05e97c9232a2a$export$2cd8252107eb640b,
    forward: $dbf05e97c9232a2a$export$174bb771924e7eb1,
    inverse: $dbf05e97c9232a2a$export$70ae2c07e401031b,
    names: $dbf05e97c9232a2a$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $874JP = parcelRequire("874JP");

var $bi5ZC = parcelRequire("bi5ZC");

var $gyVUi = parcelRequire("gyVUi");
function $81070f0f2a61f650$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $gyVUi.HALF_PI);
        else return 0, $gyVUi.HALF_PI;
    }
    //var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}


function $4d31684dfe594c29$export$2cd8252107eb640b() {
    //no-op
    if (!this.sphere) this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $4d31684dfe594c29$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $874JP.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $4d31684dfe594c29$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts));
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $81070f0f2a61f650$export$2e2bcd8739ae039)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $a9oRf.default)(this.long0 + p.x / (this.a * this.k0));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $4d31684dfe594c29$export$e4b2ac9215619f8d = [
    "cea"
];
var $4d31684dfe594c29$export$2e2bcd8739ae039 = {
    init: $4d31684dfe594c29$export$2cd8252107eb640b,
    forward: $4d31684dfe594c29$export$174bb771924e7eb1,
    inverse: $4d31684dfe594c29$export$70ae2c07e401031b,
    names: $4d31684dfe594c29$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

function $936a7dd52884a3fc$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Equidistant Cylindrical (Plate Carre)";
    this.rc = Math.cos(this.lat_ts);
}
function $936a7dd52884a3fc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var dlat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $936a7dd52884a3fc$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $a9oRf.default)(this.long0 + (x - this.x0) / (this.a * this.rc));
    p.y = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $936a7dd52884a3fc$export$e4b2ac9215619f8d = [
    "Equirectangular",
    "Equidistant_Cylindrical",
    "eqc"
];
var $936a7dd52884a3fc$export$2e2bcd8739ae039 = {
    init: $936a7dd52884a3fc$export$2cd8252107eb640b,
    forward: $936a7dd52884a3fc$export$174bb771924e7eb1,
    inverse: $936a7dd52884a3fc$export$70ae2c07e401031b,
    names: $936a7dd52884a3fc$export$e4b2ac9215619f8d
};







var $a9oRf = parcelRequire("a9oRf");



var $gyVUi = parcelRequire("gyVUi");

var $20353e9e716518d0$var$MAX_ITER = 20;
function $20353e9e716518d0$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
    this.ml0 = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
}
function $20353e9e716518d0$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $20353e9e716518d0$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $gyVUi.EPSLN)) {
            lon = (0, $a9oRf.default)(x / this.a + this.long0);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat));
        }
    } else if (Math.abs(y + this.ml0) <= (0, $gyVUi.EPSLN)) {
        lat = 0;
        lon = (0, $a9oRf.default)(this.long0 + x / this.a);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                lat = phi;
                break;
            }
        }
        //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $20353e9e716518d0$export$e4b2ac9215619f8d = [
    "Polyconic",
    "poly"
];
var $20353e9e716518d0$export$2e2bcd8739ae039 = {
    init: $20353e9e716518d0$export$2cd8252107eb640b,
    forward: $20353e9e716518d0$export$174bb771924e7eb1,
    inverse: $20353e9e716518d0$export$70ae2c07e401031b,
    names: $20353e9e716518d0$export$e4b2ac9215619f8d
};



var $6Eu1X = parcelRequire("6Eu1X");

var $a9oRf = parcelRequire("a9oRf");
function $b37863f65bf2a2a4$export$2cd8252107eb640b() {
//no-op
}
function $b37863f65bf2a2a4$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $b37863f65bf2a2a4$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $a9oRf.default)(this.long0 + p.x / this.a);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b37863f65bf2a2a4$export$e4b2ac9215619f8d = [
    "Miller_Cylindrical",
    "mill"
];
var $b37863f65bf2a2a4$export$2e2bcd8739ae039 = {
    init: $b37863f65bf2a2a4$export$2cd8252107eb640b,
    forward: $b37863f65bf2a2a4$export$174bb771924e7eb1,
    inverse: $b37863f65bf2a2a4$export$70ae2c07e401031b,
    names: $b37863f65bf2a2a4$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");





var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
var $a9d7febe7a8566f2$var$MAX_ITER = 20;
function $a9d7febe7a8566f2$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    -------------------------------------------------*/ if (!this.sphere) this.en = (0, $bf6313ff986be9ac$export$2e2bcd8739ae039)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $a9d7febe7a8566f2$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ lon = (0, $a9oRf.default)(lon - this.long0);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $a9d7febe7a8566f2$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $gyVUi.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $cae0dd692f473684$export$2e2bcd8739ae039)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $a9d7febe7a8566f2$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $ljPJJ.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $ljPJJ.default)(Math.sin(lat) / this.n);
        lon = (0, $a9oRf.default)(lon + this.long0);
        lat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(lat);
    } else {
        lat = (0, $e73ee39023f9c198$export$2e2bcd8739ae039)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $gyVUi.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            //temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $a9oRf.default)(temp);
        } else if (s - (0, $gyVUi.EPSLN) < (0, $gyVUi.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $a9d7febe7a8566f2$export$e4b2ac9215619f8d = [
    "Sinusoidal",
    "sinu"
];
var $a9d7febe7a8566f2$export$2e2bcd8739ae039 = {
    init: $a9d7febe7a8566f2$export$2cd8252107eb640b,
    forward: $a9d7febe7a8566f2$export$174bb771924e7eb1,
    inverse: $a9d7febe7a8566f2$export$70ae2c07e401031b,
    names: $a9d7febe7a8566f2$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");
function $57490138fba0a0b8$export$2cd8252107eb640b() {}
function $57490138fba0a0b8$export$174bb771924e7eb1(p) {
    /* Forward equations
      -----------------*/ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      -----------------------------------------------------*/ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $gyVUi.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       --------------------------------------------------------------------------*/ if (Math.PI / 2 - Math.abs(lat) < (0, $gyVUi.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $57490138fba0a0b8$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       -------------------------------------------------------------------*/ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $a9oRf.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)));
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $57490138fba0a0b8$export$e4b2ac9215619f8d = [
    "Mollweide",
    "moll"
];
var $57490138fba0a0b8$export$2e2bcd8739ae039 = {
    init: $57490138fba0a0b8$export$2cd8252107eb640b,
    forward: $57490138fba0a0b8$export$174bb771924e7eb1,
    inverse: $57490138fba0a0b8$export$70ae2c07e401031b,
    names: $57490138fba0a0b8$export$e4b2ac9215619f8d
};







var $bi5ZC = parcelRequire("bi5ZC");


var $a9oRf = parcelRequire("a9oRf");



var $gyVUi = parcelRequire("gyVUi");
function $cab513e7d920927e$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
    this.e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
    this.e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
    this.e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
    this.sinphi = Math.sin(this.lat1);
    this.cosphi = Math.cos(this.lat1);
    this.ms1 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
    this.ml1 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $gyVUi.EPSLN)) this.ns = this.sinphi;
    else {
        this.sinphi = Math.sin(this.lat2);
        this.cosphi = Math.cos(this.lat2);
        this.ms2 = (0, $bi5ZC.default)(this.e, this.sinphi, this.cosphi);
        this.ml2 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $cab513e7d920927e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      -----------------*/ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $cab513e7d920927e$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        lat = (0, $7bf9815baea17aa9$export$2e2bcd8739ae039)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $cab513e7d920927e$export$e4b2ac9215619f8d = [
    "Equidistant_Conic",
    "eqdc"
];
var $cab513e7d920927e$export$2e2bcd8739ae039 = {
    init: $cab513e7d920927e$export$2cd8252107eb640b,
    forward: $cab513e7d920927e$export$174bb771924e7eb1,
    inverse: $cab513e7d920927e$export$70ae2c07e401031b,
    names: $cab513e7d920927e$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
function $168e5f6524a6fc5f$export$2cd8252107eb640b() {
    //this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $168e5f6524a6fc5f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    -----------------*/ var dlon = (0, $a9oRf.default)(lon - this.long0);
    var x, y;
    if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $ljPJJ.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $gyVUi.EPSLN) || Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    //con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $168e5f6524a6fc5f$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $gyVUi.EPSLN)) lon = this.long0;
    else lon = (0, $a9oRf.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
    p.x = lon;
    p.y = lat;
    return p;
}
var $168e5f6524a6fc5f$export$e4b2ac9215619f8d = [
    "Van_der_Grinten_I",
    "VanDerGrinten",
    "vandg"
];
var $168e5f6524a6fc5f$export$2e2bcd8739ae039 = {
    init: $168e5f6524a6fc5f$export$2cd8252107eb640b,
    forward: $168e5f6524a6fc5f$export$174bb771924e7eb1,
    inverse: $168e5f6524a6fc5f$export$70ae2c07e401031b,
    names: $168e5f6524a6fc5f$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");







var $ljPJJ = parcelRequire("ljPJJ");

function $d2d34f4dbda3af26$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
}
function $d2d34f4dbda3af26$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $a9oRf.default)(lon - this.long0);
    var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            //default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North Pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South Pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            //Default case
            tanphi = sinphi / cosphi;
            Nl1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, this.sin_p12);
            Nl = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, sinphi);
            psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
            Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
            if (Az === 0) s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else if (Math.abs(Math.abs(Az) - Math.PI) <= (0, $gyVUi.EPSLN)) s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
            else s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
            G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
            H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
            GH = G * H;
            Hs = H * H;
            s2 = s * s;
            s3 = s2 * s;
            s4 = s3 * s;
            s5 = s4 * s;
            c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
            p.x = this.x0 + c * Math.sin(Az);
            p.y = this.y0 + c * Math.cos(Az);
            return p;
        }
    }
}
function $d2d34f4dbda3af26$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F, sinpsi;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $gyVUi.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $ljPJJ.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
            if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
                else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
            } else /*con = cosz - this.sin_p12 * Math.sin(lat);
        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
          //no-op, just keep the lon value as is
        } else {
          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
        }*/ lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $8b22a51ec249391e$export$2e2bcd8739ae039)(this.es);
        e1 = (0, $d08e0117e308bb87$export$2e2bcd8739ae039)(this.es);
        e2 = (0, $d36e2161accfe0ec$export$2e2bcd8739ae039)(this.es);
        e3 = (0, $89245c5bc9a5a616$export$2e2bcd8739ae039)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            //North pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            //South pole case
            Mlp = this.a * (0, $af51062589eeb2ce$export$2e2bcd8739ae039)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $8ebd4771f70de1ee$export$2e2bcd8739ae039)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y));
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            //default case
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            Az = Math.atan2(p.x, p.y);
            N1 = (0, $259e1333723cc7cb$export$2e2bcd8739ae039)(this.a, this.e, this.sin_p12);
            cosAz = Math.cos(Az);
            tmp = this.e * this.cos_p12 * cosAz;
            A = -tmp * tmp / (1 - this.es);
            B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
            D = rh / N1;
            Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
            F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
            psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
            sinpsi = Math.sin(psi);
            lat = Math.atan2((sinpsi - this.es * F * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
            p.x = lon;
            p.y = lat;
            return p;
        }
    }
}
var $d2d34f4dbda3af26$export$e4b2ac9215619f8d = [
    "Azimuthal_Equidistant",
    "aeqd"
];
var $d2d34f4dbda3af26$export$2e2bcd8739ae039 = {
    init: $d2d34f4dbda3af26$export$2cd8252107eb640b,
    forward: $d2d34f4dbda3af26$export$174bb771924e7eb1,
    inverse: $d2d34f4dbda3af26$export$70ae2c07e401031b,
    names: $d2d34f4dbda3af26$export$e4b2ac9215619f8d
};



var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $24629f153ebf2c1f$export$2cd8252107eb640b() {
    //double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      -------------------------------------------------*/ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
}
function $24629f153ebf2c1f$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      -----------------*/ dlon = (0, $a9oRf.default)(lon - this.long0);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $24629f153ebf2c1f$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    /* Inverse equations
      -----------------*/ p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $ljPJJ.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    lon = this.long0;
    if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $ljPJJ.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
    if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
        if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y));
        else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y));
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
    p.x = lon;
    p.y = lat;
    return p;
}
var $24629f153ebf2c1f$export$e4b2ac9215619f8d = [
    "ortho"
];
var $24629f153ebf2c1f$export$2e2bcd8739ae039 = {
    init: $24629f153ebf2c1f$export$2cd8252107eb640b,
    forward: $24629f153ebf2c1f$export$174bb771924e7eb1,
    inverse: $24629f153ebf2c1f$export$70ae2c07e401031b,
    names: $24629f153ebf2c1f$export$e4b2ac9215619f8d
};


// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $gyVUi = parcelRequire("gyVUi");
/* constants */ var $228cab2632c5bcf7$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $228cab2632c5bcf7$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $228cab2632c5bcf7$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || "Quadrilateralized Spherical Cube";
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0) this.face = $228cab2632c5bcf7$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $gyVUi.FORTPI)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) this.face = this.long0 > 0.0 ? $228cab2632c5bcf7$var$FACE_ENUM.RIGHT : $228cab2632c5bcf7$var$FACE_ENUM.LEFT;
    else this.face = $228cab2632c5bcf7$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $228cab2632c5bcf7$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; //lon = lp.lam;
    if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = (0, $gyVUi.HALF_PI) - lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $gyVUi.HALF_PI);
        } else if (lon > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || lon <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $gyVUi.SPI) : lon + (0, $gyVUi.SPI);
        } else if (lon > -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) && lon <= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = (0, $gyVUi.HALF_PI) + lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $gyVUi.HALF_PI);
        } else if (lon < (0, $gyVUi.FORTPI) && lon >= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $gyVUi.FORTPI) && lon >= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $gyVUi.SPI) : -lon - (0, $gyVUi.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, -(0, $gyVUi.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $gyVUi.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $gyVUi.FORTPI))) - (0, $gyVUi.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) mu += (0, $gyVUi.HALF_PI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) mu += (0, $gyVUi.SPI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $gyVUi.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $228cab2632c5bcf7$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
        mu -= (0, $gyVUi.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $gyVUi.SPI) : mu - (0, $gyVUi.SPI);
    } else {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
        mu += (0, $gyVUi.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $gyVUi.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $gyVUi.HALF_PI) - phi;
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $gyVUi.SPI) : theta - (0, $gyVUi.SPI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $gyVUi.HALF_PI);
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $gyVUi.SPI) : -theta + (0, $gyVUi.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $gyVUi.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, +(0, $gyVUi.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $gyVUi.EPSLN)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $gyVUi.FORTPI)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $gyVUi.FORTPI) && theta <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta -= (0, $gyVUi.HALF_PI);
        } else if (theta > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || theta <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $gyVUi.SPI) : theta + (0, $gyVUi.SPI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta += (0, $gyVUi.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $gyVUi.SPI)) slon += (0, $gyVUi.TWO_PI);
    else if (slon > +(0, $gyVUi.SPI)) slon -= (0, $gyVUi.TWO_PI);
    return slon;
}
var $228cab2632c5bcf7$export$e4b2ac9215619f8d = [
    "Quadrilateralized Spherical Cube",
    "Quadrilateralized_Spherical_Cube",
    "qsc"
];
var $228cab2632c5bcf7$export$2e2bcd8739ae039 = {
    init: $228cab2632c5bcf7$export$2cd8252107eb640b,
    forward: $228cab2632c5bcf7$export$174bb771924e7eb1,
    inverse: $228cab2632c5bcf7$export$70ae2c07e401031b,
    names: $228cab2632c5bcf7$export$e4b2ac9215619f8d
};


// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $gyVUi = parcelRequire("gyVUi");

var $a9oRf = parcelRequire("a9oRf");
var $86b26d30d3579075$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $86b26d30d3579075$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $86b26d30d3579075$var$FXC = 0.8487;
var $86b26d30d3579075$var$FYC = 1.3523;
var $86b26d30d3579075$var$C1 = (0, $gyVUi.R2D) / 5; // rad to 5-degree interval
var $86b26d30d3579075$var$RC1 = 1 / $86b26d30d3579075$var$C1;
var $86b26d30d3579075$var$NODES = 18;
var $86b26d30d3579075$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $86b26d30d3579075$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $86b26d30d3579075$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $86b26d30d3579075$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || "Robinson";
}
function $86b26d30d3579075$export$174bb771924e7eb1(ll) {
    var lon = (0, $a9oRf.default)(ll.x - this.long0);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $86b26d30d3579075$var$C1);
    if (i < 0) i = 0;
    else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
    dphi = (0, $gyVUi.R2D) * (dphi - $86b26d30d3579075$var$RC1 * i);
    var xy = {
        x: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], dphi) * lon,
        y: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $86b26d30d3579075$var$FXC + this.x0;
    xy.y = xy.y * this.a * $86b26d30d3579075$var$FYC + this.y0;
    return xy;
}
function $86b26d30d3579075$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $86b26d30d3579075$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $86b26d30d3579075$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $86b26d30d3579075$var$COEFS_X[$86b26d30d3579075$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $86b26d30d3579075$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
        for(;;){
            if ($86b26d30d3579075$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($86b26d30d3579075$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $86b26d30d3579075$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($86b26d30d3579075$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $86b26d30d3579075$var$newton_rapshon(function(x) {
            return ($86b26d30d3579075$var$poly3_val(coefs, x) - ll.y) / $86b26d30d3579075$var$poly3_der(coefs, x);
        }, t, (0, $gyVUi.EPSLN), 100);
        ll.x /= $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $gyVUi.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $a9oRf.default)(ll.x + this.long0);
    return ll;
}
var $86b26d30d3579075$export$e4b2ac9215619f8d = [
    "Robinson",
    "robin"
];
var $86b26d30d3579075$export$2e2bcd8739ae039 = {
    init: $86b26d30d3579075$export$2cd8252107eb640b,
    forward: $86b26d30d3579075$export$174bb771924e7eb1,
    inverse: $86b26d30d3579075$export$70ae2c07e401031b,
    names: $86b26d30d3579075$export$e4b2ac9215619f8d
};



function $07c2abe70612fbc5$export$2cd8252107eb640b() {
    this.name = "geocent";
}
function $07c2abe70612fbc5$export$174bb771924e7eb1(p) {
    var point = (0, $3a04bd721826a648$export$4a4ae2976f9a808a)(p, this.es, this.a);
    return point;
}
function $07c2abe70612fbc5$export$70ae2c07e401031b(p) {
    var point = (0, $3a04bd721826a648$export$26210192c8922750)(p, this.es, this.a, this.b);
    return point;
}
var $07c2abe70612fbc5$export$e4b2ac9215619f8d = [
    "Geocentric",
    "geocentric",
    "geocent",
    "Geocent"
];
var $07c2abe70612fbc5$export$2e2bcd8739ae039 = {
    init: $07c2abe70612fbc5$export$2cd8252107eb640b,
    forward: $07c2abe70612fbc5$export$174bb771924e7eb1,
    inverse: $07c2abe70612fbc5$export$70ae2c07e401031b,
    names: $07c2abe70612fbc5$export$e4b2ac9215619f8d
};


function $de14c0a63cfa0e0d$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $6e495242beb4668f$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $6f7c72613b8aa92a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $efe46ba059d82de2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4279f8b9d31284e6$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $llHto.default));
    proj4.Proj.projections.add((0, $31a8278a941356d4$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a6cb33582cb5910b$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d753eaf12887a276$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $c765c705b741a192$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $00f791059e8f61f5$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $deudM.default));
    proj4.Proj.projections.add((0, $8mhgZ.default));
    proj4.Proj.projections.add((0, $dbf05e97c9232a2a$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $4d31684dfe594c29$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $936a7dd52884a3fc$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $20353e9e716518d0$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $6Eu1X.default));
    proj4.Proj.projections.add((0, $b37863f65bf2a2a4$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $a9d7febe7a8566f2$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $57490138fba0a0b8$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $cab513e7d920927e$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $168e5f6524a6fc5f$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $d2d34f4dbda3af26$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $24629f153ebf2c1f$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $228cab2632c5bcf7$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $86b26d30d3579075$export$2e2bcd8739ae039));
    proj4.Proj.projections.add((0, $07c2abe70612fbc5$export$2e2bcd8739ae039));
}


(0, $471507637a3ff861$export$2e2bcd8739ae039).defaultDatum = "WGS84"; //default datum
(0, $471507637a3ff861$export$2e2bcd8739ae039).Proj = (0, $24869d6338533b3b$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).WGS84 = new (0, $471507637a3ff861$export$2e2bcd8739ae039).Proj("WGS84");
(0, $471507637a3ff861$export$2e2bcd8739ae039).Point = (0, $d8ec3fc1ff061c76$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).toPoint = (0, $01093474ae9bd8f6$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).defs = (0, $a9b3183caccb3297$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).transform = (0, $8e8cfb7cbefc2113$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).mgrs = (0, $31ee54b8e1d1cd8f$export$2e2bcd8739ae039);
(0, $471507637a3ff861$export$2e2bcd8739ae039).version = "__VERSION__";
(0, $de14c0a63cfa0e0d$export$2e2bcd8739ae039)((0, $471507637a3ff861$export$2e2bcd8739ae039));
var $a52c207aab93bf4f$export$2e2bcd8739ae039 = (0, $471507637a3ff861$export$2e2bcd8739ae039);


var $79e13355954d15ea$export$e47cd17bd9fde012;
(function(Theater) {
    Theater["PG"] = "PG";
    Theater["CAUCASUS"] = "CAUCASUS";
    Theater["SYRIA"] = "SYRIA";
    Theater["NEVADA"] = "NEVADA";
    Theater["MARIANAS"] = "MARIANAS";
    Theater["SOUTH_ATLANTIC"] = "SOUTH_ATLANTIC";
    Theater["SINAI"] = "SINAI";
    Theater["NORMANDY"] = "Normandy2";
    Theater["KOLA"] = "KOLA";
    Theater["AFGHANISTAN"] = "AFGHANISTAN";
    Theater["GERMANY_COLD_WAR"] = "GERMANY_COLD_WAR";
    Theater["IRAQ"] = "IRAQ";
})($79e13355954d15ea$export$e47cd17bd9fde012 || ($79e13355954d15ea$export$e47cd17bd9fde012 = {}));
function $79e13355954d15ea$export$8b8eac99639c6a1c(t) {
    switch(t){
        // Backwards compat after fixing a spelling error
        // @ts-ignore
        case "CAUCASES":
        case "CAUCASUS":
            return "+proj=tmerc +lon_0=33 +k_0=0.9996 +x_0=-99517 +y_0=-4998115";
        case "PG":
            return "+proj=tmerc +lon_0=57 +k_0=0.9996 +x_0=75757 +y_0=-2894931";
        case "SYRIA":
            return "+proj=tmerc +lon_0=39 +k_0=0.9996 +x_0=282801 +y_0=-3879865";
        case "NEVADA":
            return "+proj=tmerc +lon_0=-117 +k_0=0.9996 +x_0=-193996 +y_0=-4410028";
        case "MARIANAS":
            return `+proj=tmerc +lon_0=147 +k_0=0.9996 +x_0=238418 +y_0=-1491840`;
        case "SOUTH_ATLANTIC":
            return `+proj=tmerc +lon_0=-57 +k_0=0.9996 +x_0=147640 +y_0=5815417`;
        case "SINAI":
            return `+proj=tmerc +lon_0=33 +k_0=0.9996 +x_0=169222 +y_0=-3325313`;
        case "Normandy2":
            return `+proj=tmerc +lon_0=-3 +k_0=0.9996 +x_0=-195526.00000000204 +y_0=-5484812.999999951`;
        case "KOLA":
            return `+proj=tmerc +lon_0=21 +k=0.9996 +x_0=-62702 +y_0=-7543625`;
        case "AFGHANISTAN":
            return `+proj=tmerc +lon_0=63 +k=0.9996 +x_0=-300150 +y_0=-3759657`;
        case "GERMANY_COLD_WAR":
            return `+proj=tmerc +lon_0=21 +k=0.9996 +x_0=35427.62 +y_0=-6061633.128`;
        case "IRAQ":
            return `+proj=tmerc +lon_0=45 +k=0.9996 +x_0=72290 +y_0=-3680057`;
    }
}
function $79e13355954d15ea$export$836ff99bad0a09da(t) {
    switch(t){
        // Backwards compat after fixing a spelling error
        // @ts-ignore
        case "CAUCASES":
        case "CAUCASUS":
            return [
                41.7302,
                42.12121
            ];
        case "PG":
            return [
                54.98095,
                25.01897
            ];
        case "SYRIA":
            return [
                35.98095,
                35.01897
            ];
        case "NEVADA":
            return [
                35.98095,
                -114
            ];
        case "MARIANAS":
            return [
                14.174905098823,
                -145
            ];
        case "Normandy2":
            return [
                49.174905098823,
                -0.145
            ];
    }
}
// https://github.com/DCS-Web-Editor/dcs-web-editor-mono/blob/main/packages/map-projection/src/mapCoordinates.ts
const $79e13355954d15ea$var$coords = {
    ["CAUCASES"]: [
        {
            lat: 48.387663480938,
            long: 26.778743595881
        },
        // bottom left
        {
            lat: 39.608931903399,
            long: 27.637331401126
        },
        // bottom right
        {
            lat: 38.86511140611,
            long: 47.142314272867
        },
        // top right
        {
            lat: 47.382221906262,
            long: 49.309787386754
        }
    ],
    ["CAUCASUS"]: [
        // top left
        {
            lat: 48.387663480938,
            long: 26.778743595881
        },
        // bottom left
        {
            lat: 39.608931903399,
            long: 27.637331401126
        },
        // bottom right
        {
            lat: 38.86511140611,
            long: 47.142314272867
        },
        // top right
        {
            lat: 47.382221906262,
            long: 49.309787386754
        }
    ],
    ["SYRIA"]: [
        // top left
        {
            lat: 37.470301761465,
            long: 29.480123666167
        },
        // bottom left
        {
            lat: 31.683960285685,
            long: 30.123622480902
        },
        // bottom right
        {
            lat: 31.960960214436,
            long: 41.932899899137
        },
        // top right
        {
            lat: 37.814134114831,
            long: 42.148931009427
        }
    ],
    ["PG"]: [
        {
            lat: 32.955527544002,
            long: 46.583433745255
        },
        {
            lat: 21.749230188233,
            long: 47.594358099874
        },
        {
            lat: 21.869681127563,
            long: 63.997389263298
        },
        {
            lat: 33.150981840679,
            long: 64.756585025318
        }
    ],
    ["Normandy2"]: [
        // top left
        {
            lat: 51.853053209954,
            long: -3.5005307234326
        },
        {
            lat: 48.345555267203,
            long: -3.4652619527823
        },
        {
            lat: 48.182820700457,
            long: 3.1296001999935
        },
        {
            lat: 51.668977027237,
            long: 3.5903264200692
        },
        {
            lat: 51.853053209954,
            long: -3.5005307234326
        }
    ],
    ["NEVADA"]: [
        {
            lat: 39.801712624973,
            long: -119.9902311096
        },
        {
            lat: 34.400025213159,
            long: -119.78488669575
        },
        {
            lat: 34.346907399159,
            long: -112.44599267994
        },
        {
            lat: 39.737162541546,
            long: -112.11118674647
        }
    ],
    ["MARIANAS"]: [
        {
            lat: 22.220143285088,
            long: 136.96126049266
        },
        {
            lat: 10.637681299806,
            long: 137.54638410345
        },
        {
            lat: 10.739229846557,
            long: 152.12973515767
        },
        {
            lat: 22.44081213808,
            long: 152.4517401234
        }
    ],
    ["SOUTH_ATLANTIC"]: [
        {
            lat: -45.850907963742,
            long: -84.733179722768
        },
        {
            lat: -53.241290032056,
            long: -89.780310307149
        },
        {
            lat: -56.442360340952,
            long: -38.172247338514
        },
        {
            lat: -48.278746783249,
            long: -41.444185881767
        }
    ],
    ["SINAI"]: [
        {
            lat: 34.55404881,
            long: 25.448642
        },
        {
            lat: 25.06909856,
            long: 25.448642
        },
        {
            lat: 25.06909856,
            long: 41.69756169
        },
        {
            lat: 34.55404881,
            long: 41.69756169
        }
    ],
    ["KOLA"]: [
        {
            lat: 72.0,
            long: -4
        },
        {
            lat: 71.0,
            long: 48.0
        },
        {
            lat: 63.0,
            long: 39.0
        },
        {
            lat: 64.0,
            long: -3
        }
    ],
    ["AFGHANISTAN"]: [
        {
            lat: 39,
            long: 60
        },
        {
            lat: 29.4,
            long: 60.2
        },
        {
            lat: 29,
            long: 74.5
        },
        {
            lat: 38.6,
            long: 75.34
        }
    ],
    ["GERMANY_COLD_WAR"]: [
        {
            lat: 59.416667059204,
            long: 0.78605025385029
        },
        {
            lat: 60.847630263092,
            long: 14.821474574334
        },
        {
            lat: 49.215506254256,
            long: 16.393423859364
        },
        {
            lat: 48.276207845363,
            long: 5.6742887695796
        }
    ],
    ["IRAQ"]: [
        {
            lat: 37.052110852583,
            long: 38.567371358039
        },
        {
            lat: 36.905227474756,
            long: 53.72044156962
        },
        {
            lat: 24.489466197319,
            long: 52.660473282227
        },
        {
            lat: 24.578732351094,
            long: 39.353834118213
        }
    ]
};
function $79e13355954d15ea$export$4a2b0cf97b33b444(t) {
    return $79e13355954d15ea$var$coords[t];
}
function $79e13355954d15ea$export$7ed87cae1557ab30(t) {
    const corners = $79e13355954d15ea$export$4a2b0cf97b33b444(t);
    const m = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(corners, (c)=>[
            c.long,
            c.lat
        ]);
    const extent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)(m);
    return extent;
}
function $79e13355954d15ea$export$3c40acb1973c9787(ary) {
    // Minutes and seconds are just degrees plus their decimal place divided by 60
    const isPositive = Math.sign(ary[0]) === 1;
    const f = isPositive ? parseFloat(`${ary[0] + ary[1] / 60}`) : parseFloat(`${ary[0] - ary[1] / 60}`);
    return Number(f.toFixed(6));
}
function $79e13355954d15ea$export$fea9c56d107c783a(dec) {
    const [degStr, decStr] = dec.toString().split(".");
    const decimal = parseFloat(`0.${decStr}`);
    const f = decimal * 60;
    return [
        parseInt(degStr),
        Number(f.toFixed(4))
    ];
}
function $79e13355954d15ea$export$5380b7513846c4b2(decimal, isLatitude) {
    var indicator = isLatitude ? decimal >= 0 ? "N" : "S" : decimal >= 0 ? "E" : "W";
    var degrees = Math.floor(decimal);
    var minutesAndSeconds = (decimal - degrees) * 60;
    var minutes = Math.floor(minutesAndSeconds);
    var seconds = (minutesAndSeconds - minutes) * 60;
    return indicator + " " + degrees + "\xb0 " + minutes + "' " + seconds.toFixed(2) + "''";
}
function $79e13355954d15ea$export$11f9fb45e60bb023(decimal) {
    var minutesAndSeconds = (decimal - Math.floor(decimal)) * 60;
    var seconds = minutesAndSeconds * 60;
    return seconds.toFixed(2);
}
function $79e13355954d15ea$export$b2b002b78ef471ac([longDec, latDec], decLength = 4) {
    const northingText = Math.sign(latDec) === -1 ? "S" : "N";
    const eastingText = Math.sign(longDec) === -1 ? "W" : "E";
    const [ltDeg, ltDec] = $79e13355954d15ea$export$fea9c56d107c783a(latDec);
    const [lnDeg, lnDec] = $79e13355954d15ea$export$fea9c56d107c783a(longDec);
    const ltStr = "0" + ltDec.toFixed(decLength);
    const lnStr = "0" + lnDec.toFixed(decLength);
    // Trims or doesn't trim the leading 0
    const sliceLen = (decLength + 3) * -1;
    return [
        `${northingText} ${Math.abs(ltDeg)}\xb0 ${ltStr.slice(sliceLen)}`,
        `${eastingText} ${Math.abs(lnDeg)}\xb0 ${lnStr.slice(sliceLen)}`,
        $79e13355954d15ea$export$a83fd77c82670907({
            lat: latDec,
            long: longDec
        })
    ];
}
function $79e13355954d15ea$export$3b6b44ca42529cf5([longDec, latDec], decLength = 4) {
    const [lat, long, mgrs] = $79e13355954d15ea$export$b2b002b78ef471ac([
        longDec,
        latDec
    ], decLength);
    return {
        lat: lat,
        long: long,
        mgrs: mgrs
    };
}
function $79e13355954d15ea$export$a83fd77c82670907(coords) {
    const m = (0, $31ee54b8e1d1cd8f$export$2e2bcd8739ae039).forward([
        coords.long,
        coords.lat
    ], 5);
    const formatted = m.split("");
    const ref = formatted.slice(0, 3).join("");
    const square = formatted.slice(3, 5).join("");
    const northing = formatted.slice(5, 10).join("");
    const easting = formatted.slice(10, 15).join("");
    return [
        ref,
        square,
        northing,
        easting
    ].join(" ");
}
function $79e13355954d15ea$export$9175a52f61945120(mgrsString) {
    const str = mgrsString.replace(/\s/g, "");
    const m = (0, $31ee54b8e1d1cd8f$export$2e2bcd8739ae039).toPoint(str);
    return {
        lat: m[1],
        long: m[0]
    };
}
function $79e13355954d15ea$export$43105f50ad4fdfb0(map, { lat: lat, long: long }) {
    const projectionString = $79e13355954d15ea$export$8b8eac99639c6a1c(map);
    const [y, x] = (0, $a52c207aab93bf4f$export$2e2bcd8739ae039)(projectionString, [
        long,
        lat
    ]);
    return {
        x: Number(x.toFixed(5)),
        y: Number(y.toFixed(5))
    };
}
function $79e13355954d15ea$export$7d61ade677ae99ee(map, coords) {
    if (!coords) throw new Error("This Frag Order was created with an older version of Frag Orders. Please re-publish/update this Frag Order.");
    const { x: x, y: y } = coords;
    if (!map) throw new Error("Theater was undefined");
    const projectionString = $79e13355954d15ea$export$8b8eac99639c6a1c(map);
    const [long, lat] = (0, $a52c207aab93bf4f$export$2e2bcd8739ae039)(projectionString).inverse([
        y,
        x
    ]);
    return {
        lat: lat,
        long: long
    };
}
function $79e13355954d15ea$export$d284c26147b5ca34(meters) {
    return meters * 3.28084;
}
function $79e13355954d15ea$export$76afc266724c5901(feet) {
    return feet * 0.3048;
}
function $79e13355954d15ea$export$b668502fb6da9201(theater, vertices) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(vertices, (v)=>{
        const { lat: lat, long: long } = $79e13355954d15ea$export$7d61ade677ae99ee(theater, v);
        return [
            long,
            lat
        ];
    });
}
function $79e13355954d15ea$export$f855e4255431a6a0(nm) {
    return nm * 1852;
}
function $79e13355954d15ea$export$68f4cf8c6d4e06be(theater, d) {
    const origin = $79e13355954d15ea$export$7d61ade677ae99ee(theater, {
        x: d.mapX,
        y: d.mapY
    });
    const projection = new (0, $6dc418afeec7068a$export$2e2bcd8739ae039)({
        code: "EPSG:4326",
        units: "m"
    });
    const pointRes = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(projection, 1, [
        origin.long,
        origin.lat
    ]);
    const point1 = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
        origin.long,
        origin.lat
    ]);
    point1.translate(-d.width / 2 / pointRes, -d.height / 2 / pointRes);
    const point2 = point1.clone();
    point2.translate(d.width / pointRes, 0);
    const point3 = point1.clone();
    point3.translate(d.width / pointRes, d.height / pointRes);
    const point4 = point1.clone();
    point4.translate(0, d.height / pointRes);
    const coords = [
        point1.getCoordinates(),
        point2.getCoordinates(),
        point3.getCoordinates(),
        point4.getCoordinates()
    ];
    return new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)([
        coords
    ]);
}
function $79e13355954d15ea$export$983094a1b3fd35c5(latLongStr) {
    const regex = /([NS])?\s*(\d{1,2})°\s*(\d{1,2}\.\d+)'?\s*([NS])?\s*([EW])?\s*(\d{1,3})°\s*(\d{1,2}\.\d+)'?\s*([EW])?/;
    const match = latLongStr.match(regex);
    if (!match) return null;
    let latSign = 1, lonSign = 1;
    if (match[1] === "S" || match[4] === "S") latSign = -1;
    if (match[5] === "W" || match[8] === "W") lonSign = -1;
    const latitude = latSign * (parseInt(match[2]) + parseFloat(match[3]) / 60);
    const longitude = lonSign * (parseInt(match[6]) + parseFloat(match[7]) / 60);
    return {
        latitude: latitude,
        longitude: longitude
    };
}



var $f1q41 = parcelRequire("f1q41");
/* eslint-disable */ class $3495a833b5fe555e$export$e8f1069689b9c900 extends Error {
    constructor(message){
        super();
        this.message = message;
    }
    toString() {
        return `LuaError: ${this.message}`;
    }
}



class $0b8af60ab5d60464$export$54ec01a60f47d33d {
    constructor(initialiser){
        this.numValues = [
            undefined
        ];
        this.strValues = {};
        this.keys = [];
        this.values = [];
        this.metatable = null;
        if (initialiser === undefined) return;
        if (typeof initialiser === "function") {
            initialiser(this);
            return;
        }
        if (Array.isArray(initialiser)) {
            this.insert(...initialiser);
            return;
        }
        for(const key in initialiser)if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)(initialiser, key)) {
            let value = initialiser[key];
            if (value === null) value = undefined;
            this.set(key, value);
        }
    }
    get(key) {
        const value = this.rawget(key);
        if (value === undefined && this.metatable) {
            const mm = this.metatable.get("__index");
            if (mm instanceof $0b8af60ab5d60464$export$54ec01a60f47d33d) return mm.get(key);
            if (typeof mm === "function") {
                const v = mm.call(undefined, this, key);
                return v instanceof Array ? v[0] : v;
            }
        }
        return value;
    }
    rawget(key) {
        switch(typeof key){
            case "string":
                if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)(this.strValues, key)) return this.strValues[key];
                break;
            case "number":
                if (key > 0 && key % 1 === 0) return this.numValues[key];
        }
        const index = this.keys.indexOf((0, $67f923318f75be7d$export$2d61a1c0fd545922)(key));
        return index === -1 ? undefined : this.values[index];
    }
    getMetaMethod(name) {
        return this.metatable && this.metatable.rawget(name);
    }
    set(key, value) {
        const mm = this.metatable && this.metatable.get("__newindex");
        if (mm) {
            const oldValue = this.rawget(key);
            if (oldValue === undefined) {
                if (mm instanceof $0b8af60ab5d60464$export$54ec01a60f47d33d) return mm.set(key, value);
                if (typeof mm === "function") return mm(this, key, value);
            }
        }
        this.rawset(key, value);
    }
    setFn(key) {
        return (v)=>this.set(key, v);
    }
    rawset(key, value) {
        switch(typeof key){
            case "string":
                this.strValues[key] = value;
                return;
            case "number":
                if (key > 0 && key % 1 === 0) {
                    this.numValues[key] = value;
                    return;
                }
        }
        const K = (0, $67f923318f75be7d$export$2d61a1c0fd545922)(key);
        const index = this.keys.indexOf(K);
        if (index > -1) {
            this.values[index] = value;
            return;
        }
        this.values[this.keys.length] = value;
        this.keys.push(K);
    }
    insert(...values) {
        this.numValues.push(...values);
    }
    toObject() {
        const outputAsArray = Object.keys(this.strValues).length === 0 && this.getn() > 0;
        const result = outputAsArray ? [] : {};
        for(let i = 1; i < this.numValues.length; i++){
            const propValue = this.numValues[i];
            const value = propValue instanceof $0b8af60ab5d60464$export$54ec01a60f47d33d ? propValue.toObject() : propValue;
            if (outputAsArray) {
                const res = result;
                res[i - 1] = value;
            } else {
                const res = result;
                res[String(i - 1)] = value;
            }
        }
        for(const key in this.strValues)if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)(this.strValues, key)) {
            const propValue = this.strValues[key];
            const value = propValue instanceof $0b8af60ab5d60464$export$54ec01a60f47d33d ? propValue.toObject() : propValue;
            const res = result;
            res[key] = value;
        }
        return result;
    }
    getn() {
        const vals = this.numValues;
        const keys = [];
        for(const i in vals)if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)(vals, i)) keys[i] = true;
        let j = 0;
        while(keys[j + 1])j += 1;
        // Following translated from ltable.c (http://www.lua.org/source/5.3/ltable.c.html)
        if (j > 0 && vals[j] === undefined) {
            /* there is a boundary in the array part: (binary) search for it */ let i = 0;
            while(j - i > 1){
                const m = Math.floor((i + j) / 2);
                if (vals[m] === undefined) j = m;
                else i = m;
            }
            return i;
        }
        return j;
    }
}


/** Pattern to identify a float string value that can validly be converted to a number in Lua */ const $67f923318f75be7d$var$FLOATING_POINT_PATTERN = /^[-+]?[0-9]*\.?([0-9]+([eE][-+]?[0-9]+)?)?$/;
/** Pattern to identify a hex string value that can validly be converted to a number in Lua */ const $67f923318f75be7d$var$HEXIDECIMAL_CONSTANT_PATTERN = /^(-)?0x([0-9a-fA-F]*)\.?([0-9a-fA-F]*)$/;
function $67f923318f75be7d$export$bf9fb029d174d554(v) {
    const t = typeof v;
    switch(t){
        case "undefined":
            return "nil";
        case "number":
        case "string":
        case "boolean":
        case "function":
            return t;
        case "object":
            if (v instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)) return "table";
            if (v instanceof Function) return "function";
    }
}
function $67f923318f75be7d$export$2d61a1c0fd545922(v) {
    if (v instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)) {
        const mm = v.getMetaMethod("__tostring");
        if (mm) return mm(v)[0];
        return valToStr(v, "table: 0x");
    }
    if (v instanceof Function) return valToStr(v, "function: 0x");
    return $67f923318f75be7d$export$c75e8fe1cada7bf(v);
    function valToStr(v, prefix) {
        const s = v.toString();
        if (s.indexOf(prefix) > -1) return s;
        const str = prefix + Math.floor(Math.random() * 0xffffffff).toString(16);
        v.toString = ()=>str;
        return str;
    }
}
/* translate a relative string position: negative means back from end */ function $67f923318f75be7d$export$b6dbfe34ed7ccb32(pos, len) {
    if (pos >= 0) return pos;
    if (-pos > len) return 0;
    return len + pos + 1;
}
/**
 * Thows an error with the type of a variable included in the message
 * @param {Object} val The value whise type is to be inspected.
 * @param {String} errorMessage The error message to throw.
 * @throws {LuaError}
 */ function $67f923318f75be7d$var$throwCoerceError(val, errorMessage) {
    if (!errorMessage) return undefined;
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`${errorMessage}`.replace(/%type/gi, $67f923318f75be7d$export$bf9fb029d174d554(val)));
}
/**
 * Coerces a value from its current type to a boolean in the same manner as Lua.
 * @param {Object} val The value to be converted.
 * @returns {Boolean} The converted value.
 */ function $67f923318f75be7d$export$4b720ee0f8ec719c(val) {
    return !(val === false || val === undefined);
}
/**
 * Coerces a value from its current type to a number in the same manner as Lua.
 * @param {Object} val The value to be converted.
 * @param {String} [errorMessage] The error message to throw if the conversion fails.
 * @returns {Number} The converted value.
 */ function $67f923318f75be7d$export$7de25fcdfb94b938(val, errorMessage) {
    if (typeof val === "number") return val;
    switch(val){
        case undefined:
            return undefined;
        case "inf":
            return Infinity;
        case "-inf":
            return -Infinity;
        case "nan":
            return NaN;
    }
    const V = `${val}`;
    if (V.match($67f923318f75be7d$var$FLOATING_POINT_PATTERN)) return parseFloat(V);
    const match = V.match($67f923318f75be7d$var$HEXIDECIMAL_CONSTANT_PATTERN);
    if (match) {
        const [, sign, exponent, mantissa] = match;
        let n = parseInt(exponent, 16) || 0;
        if (mantissa) n += parseInt(mantissa, 16) / Math.pow(16, mantissa.length);
        if (sign) n *= -1;
        return n;
    }
    if (errorMessage === undefined) return undefined;
    $67f923318f75be7d$var$throwCoerceError(val, errorMessage);
}
/**
 * Coerces a value from its current type to a string in the same manner as Lua.
 * @param {Object} val The value to be converted.
 * @param {String} [errorMessage] The error message to throw if the conversion fails.
 * @returns {String} The converted value.
 */ function $67f923318f75be7d$export$c75e8fe1cada7bf(val, errorMessage) {
    if (typeof val === "string") return val;
    switch(val){
        case undefined:
        case null:
            return "nil";
        case Infinity:
            return "inf";
        case -Infinity:
            return "-inf";
    }
    if (typeof val === "number") return Number.isNaN(val) ? "nan" : `${val}`;
    if (typeof val === "boolean") return `${val}`;
    if (errorMessage === undefined) return "nil";
    $67f923318f75be7d$var$throwCoerceError(val, errorMessage);
}
function $67f923318f75be7d$var$coerceArg(value, coerceFunc, typ, funcName, index) {
    return coerceFunc(value, `bad argument #${index} to '${funcName}' (${typ} expected, got %type)`);
}
function $67f923318f75be7d$export$a10e5668227c81bc(value, funcName, index) {
    return $67f923318f75be7d$var$coerceArg(value, $67f923318f75be7d$export$7de25fcdfb94b938, "number", funcName, index);
}
function $67f923318f75be7d$export$4ecf6a6aa59500b5(value, funcName, index) {
    return $67f923318f75be7d$var$coerceArg(value, $67f923318f75be7d$export$c75e8fe1cada7bf, "string", funcName, index);
}
function $67f923318f75be7d$export$811af271c077e9d6(value, funcName, index) {
    if (value instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)) return value;
    else {
        const typ = $67f923318f75be7d$export$bf9fb029d174d554(value);
        throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`bad argument #${index} to '${funcName}' (table expected, got ${typ})`);
    }
}
function $67f923318f75be7d$export$f89c54311c4679e9(value, funcName, index) {
    if (value instanceof Function) return value;
    else {
        const typ = $67f923318f75be7d$export$bf9fb029d174d554(value);
        throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`bad argument #${index} to '${funcName}' (function expected, got ${typ})`);
    }
}
const $67f923318f75be7d$export$d0c8ecbd4ed8940c = (value)=>value instanceof Array ? value : [
        value
    ];
const $67f923318f75be7d$export$5a15a386532a5ea4 = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);


class $9cd33625fe0b5bcc$export$775b6bb06e53a214 {
    constructor(variables = {}){
        this._variables = variables;
    }
    get(key) {
        return this._variables[key];
    }
    set(key, value) {
        if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)(this._variables, key) || !this.parent) this.setLocal(key, value);
        else this.parent.set(key, value);
    }
    setLocal(key, value) {
        this._variables[key] = value;
    }
    setVarargs(args) {
        this._varargs = args;
    }
    getVarargs() {
        return this._varargs || this.parent && this.parent.getVarargs() || [];
    }
    extend() {
        const innerVars = Object.create(this._variables);
        const scope = new $9cd33625fe0b5bcc$export$775b6bb06e53a214(innerVars);
        scope.parent = this;
        return scope;
    }
}



var $jv3NX = parcelRequire("jv3NX");
const $10a22d21a5252b59$var$isBlock = (node)=>node.type === "IfClause" || node.type === "ElseifClause" || node.type === "ElseClause" || node.type === "WhileStatement" || node.type === "DoStatement" || node.type === "RepeatStatement" || node.type === "FunctionDeclaration" || node.type === "ForNumericStatement" || node.type === "ForGenericStatement" || node.type === "Chunk";
class $10a22d21a5252b59$var$MemExpr extends String {
    constructor(base, property){
        super();
        this.base = base;
        this.property = property;
    }
    get() {
        return `__lua.get(${this.base}, ${this.property})`;
    }
    set(value) {
        return `${this.base}.set(${this.property}, ${value})`;
    }
    setFn() {
        return `${this.base}.setFn(${this.property})`;
    }
    toString() {
        return this.get();
    }
    valueOf() {
        return this.get();
    }
}
const $10a22d21a5252b59$var$UNI_OP_MAP = {
    not: "not",
    "-": "unm",
    "~": "bnot",
    "#": "len"
};
const $10a22d21a5252b59$var$BIN_OP_MAP = {
    "+": "add",
    "-": "sub",
    "*": "mul",
    "%": "mod",
    "^": "pow",
    "/": "div",
    "//": "idiv",
    "&": "band",
    "|": "bor",
    "~": "bxor",
    "<<": "shl",
    ">>": "shr",
    "..": "concat",
    "~=": "neq",
    "==": "eq",
    "<": "lt",
    "<=": "le",
    ">": "gt",
    ">=": "ge"
};
const $10a22d21a5252b59$var$generate = (node)=>{
    switch(node.type){
        case "LabelStatement":
            return `case '${node.label.name}': label = undefined`;
        case "BreakStatement":
            return "break";
        case "GotoStatement":
            return `label = '${node.label.name}'; continue`;
        case "ReturnStatement":
            {
                const args = $10a22d21a5252b59$var$parseExpressions(node.arguments);
                return `return ${args}`;
            }
        case "IfStatement":
            {
                const clauses = node.clauses.map((clause)=>$10a22d21a5252b59$var$generate(clause));
                return clauses.join(" else ");
            }
        case "IfClause":
        case "ElseifClause":
            {
                const condition = $10a22d21a5252b59$var$expression(node.condition);
                const body = $10a22d21a5252b59$var$parseBody(node);
                return `if (__lua.bool(${condition})) {\n${body}\n}`;
            }
        case "ElseClause":
            {
                const body = $10a22d21a5252b59$var$parseBody(node);
                return `{\n${body}\n}`;
            }
        case "WhileStatement":
            {
                const condition = $10a22d21a5252b59$var$expression(node.condition);
                const body = $10a22d21a5252b59$var$parseBody(node);
                return `while(${condition}) {\n${body}\n}`;
            }
        case "DoStatement":
            {
                const body = $10a22d21a5252b59$var$parseBody(node);
                return `\n${body}\n`;
            }
        case "RepeatStatement":
            {
                const condition = $10a22d21a5252b59$var$expression(node.condition);
                const body = $10a22d21a5252b59$var$parseBody(node);
                return `do {\n${body}\n} while (!(${condition}))`;
            }
        case "LocalStatement":
            return $10a22d21a5252b59$var$parseAssignments(node);
        case "AssignmentStatement":
            return $10a22d21a5252b59$var$parseAssignments(node);
        case "CallStatement":
            return $10a22d21a5252b59$var$generate(node.expression);
        case "FunctionDeclaration":
            {
                const getFuncDef = (params)=>{
                    const paramStr = params.join(";\n");
                    const body = $10a22d21a5252b59$var$parseBody(node, paramStr);
                    const argsStr = params.length === 0 ? "" : "...args";
                    const returnStr = node.body.findIndex((node)=>node.type === "ReturnStatement") === -1 ? "\nreturn []" : "";
                    return `(${argsStr}) => {\n${body}${returnStr}\n}`;
                };
                const params = node.parameters.map((param)=>{
                    if (param.type === "VarargLiteral") return `$${$10a22d21a5252b59$var$nodeToScope.get(param)}.setVarargs(args)`;
                    return `$${$10a22d21a5252b59$var$nodeToScope.get(param)}.setLocal('${param.name}', args.shift())`;
                });
                // anonymous function
                if (node.identifier === null) return getFuncDef(params);
                if (node.identifier.type === "Identifier") {
                    const scope = $10a22d21a5252b59$var$nodeToScope.get(node.identifier);
                    const setStr = node.isLocal ? "setLocal" : "set";
                    return `$${scope}.${setStr}('${node.identifier.name}', ${getFuncDef(params)})`;
                }
                const identifier = $10a22d21a5252b59$var$generate(node.identifier);
                if (node.identifier.indexer === ":") params.unshift(`$${$10a22d21a5252b59$var$nodeToScope.get(node)}.setLocal('self', args.shift())`);
                return identifier.set(getFuncDef(params));
            }
        case "ForNumericStatement":
            {
                const varName = node.variable.name;
                const start = $10a22d21a5252b59$var$expression(node.start);
                const end = $10a22d21a5252b59$var$expression(node.end);
                const step = node.step === null ? 1 : $10a22d21a5252b59$var$expression(node.step);
                const init = `let ${varName} = ${start}, end = ${end}, step = ${step}`;
                const cond = `step > 0 ? ${varName} <= end : ${varName} >= end`;
                const after = `${varName} += step`;
                const varInit = `$${$10a22d21a5252b59$var$nodeToScope.get(node.variable)}.setLocal('${varName}', ${varName});`;
                const body = $10a22d21a5252b59$var$parseBody(node, varInit);
                return `for (${init}; ${cond}; ${after}) {\n${body}\n}`;
            }
        case "ForGenericStatement":
            {
                const iterators = $10a22d21a5252b59$var$parseExpressions(node.iterators);
                const variables = node.variables.map((variable, index)=>{
                    return `$${$10a22d21a5252b59$var$nodeToScope.get(variable)}.setLocal('${variable.name}', res[${index}])`;
                }).join(";\n");
                const body = $10a22d21a5252b59$var$parseBody(node, variables);
                return `for (let [iterator, table, next] = ${iterators}, res = __lua.call(iterator, table, next); res[0] !== undefined; res = __lua.call(iterator, table, res[0])) {\n${body}\n}`;
            }
        case "Chunk":
            {
                const body = $10a22d21a5252b59$var$parseBody(node);
                return `'use strict'\nconst $0 = __lua.globalScope\nlet vars\nlet vals\nlet label\n\n${body}`;
            }
        case "Identifier":
            return `$${$10a22d21a5252b59$var$nodeToScope.get(node)}.get('${node.name}')`;
        case "StringLiteral":
            {
                const S = node.value.replace(/([^\\])?\\(\d{1,3})/g, (_, pre, dec)=>`${pre || ""}${String.fromCharCode(dec)}`).replace(/\\/g, "\\\\");
                return `\`${S}\``;
            }
        case "NumericLiteral":
            return node.value.toString();
        case "BooleanLiteral":
            return node.value ? "true" : "false";
        case "NilLiteral":
            return "undefined";
        case "VarargLiteral":
            return `$${$10a22d21a5252b59$var$nodeToScope.get(node)}.getVarargs()`;
        // inside TableConstructorExpression
        // case 'TableKey': {}
        // case 'TableKeyString': {}
        // case 'TableValue': {}
        case "TableConstructorExpression":
            {
                if (node.fields.length === 0) return "new __lua.Table()";
                const fields = node.fields.map((field, index, arr)=>{
                    if (field.type === "TableKey") return `t.rawset(${$10a22d21a5252b59$var$generate(field.key)}, ${$10a22d21a5252b59$var$expression(field.value)})`;
                    if (field.type === "TableKeyString") return `t.rawset('${field.key.name}', ${$10a22d21a5252b59$var$expression(field.value)})`;
                    if (field.type === "TableValue") {
                        if (index === arr.length - 1 && $10a22d21a5252b59$var$ExpressionReturnsArray(field.value)) return `t.insert(...${$10a22d21a5252b59$var$generate(field.value)})`;
                        return `t.insert(${$10a22d21a5252b59$var$expression(field.value)})`;
                    }
                }).join(";\n");
                return `new __lua.Table(t => {\n${fields}\n})`;
            }
        case "UnaryExpression":
            {
                const operator = $10a22d21a5252b59$var$UNI_OP_MAP[node.operator];
                const argument = $10a22d21a5252b59$var$expression(node.argument);
                if (!operator) throw new Error(`Unhandled unary operator: ${node.operator}`);
                return `__lua.${operator}(${argument})`;
            }
        case "BinaryExpression":
            {
                const left = $10a22d21a5252b59$var$expression(node.left);
                const right = $10a22d21a5252b59$var$expression(node.right);
                const operator = $10a22d21a5252b59$var$BIN_OP_MAP[node.operator];
                if (!operator) throw new Error(`Unhandled binary operator: ${node.operator}`);
                return `__lua.${operator}(${left}, ${right})`;
            }
        case "LogicalExpression":
            {
                const left = $10a22d21a5252b59$var$expression(node.left);
                const right = $10a22d21a5252b59$var$expression(node.right);
                const operator = node.operator;
                if (operator === "and") return `(!__lua.bool(${left})?${left}:${right})`;
                if (operator === "or") return `(__lua.bool(${left})?${left}:${right})`;
                throw new Error(`Unhandled logical operator: ${node.operator}`);
            }
        case "MemberExpression":
            {
                const base = $10a22d21a5252b59$var$expression(node.base);
                return new $10a22d21a5252b59$var$MemExpr(base, `'${node.identifier.name}'`);
            }
        case "IndexExpression":
            {
                const base = $10a22d21a5252b59$var$expression(node.base);
                const index = $10a22d21a5252b59$var$expression(node.index);
                return new $10a22d21a5252b59$var$MemExpr(base, index);
            }
        case "CallExpression":
        case "TableCallExpression":
        case "StringCallExpression":
            {
                const functionName = $10a22d21a5252b59$var$expression(node.base);
                const args = node.type === "CallExpression" ? $10a22d21a5252b59$var$parseExpressionList(node.arguments).join(", ") : $10a22d21a5252b59$var$expression(node.type === "TableCallExpression" ? node.arguments : node.argument);
                if (functionName instanceof $10a22d21a5252b59$var$MemExpr && node.base.type === "MemberExpression" && node.base.indexer === ":") return `__lua.call(${functionName}, ${functionName.base}, ${args})`;
                return `__lua.call(${functionName}, ${args})`;
            }
        default:
            throw new Error(`No generator found for: ${node.type}`);
    }
};
const $10a22d21a5252b59$var$parseBody = (node, header = "")=>{
    const scope = $10a22d21a5252b59$var$nodeToScope.get(node);
    const scopeDef = scope === undefined ? "" : `const $${scope} = $${$10a22d21a5252b59$var$scopeToParentScope.get(scope)}.extend();`;
    const body = node.body.map((statement)=>$10a22d21a5252b59$var$generate(statement)).join(";\n");
    const goto = $10a22d21a5252b59$var$nodeToGoto.get(node);
    if (goto === undefined) return `${scopeDef}\n${header}\n${body}`;
    const gotoHeader = `L${goto}: do { switch(label) { case undefined:`;
    const gotoParent = $10a22d21a5252b59$var$gotoToParentGoto.get(goto);
    const def = gotoParent === undefined ? "" : `break; default: continue L${gotoParent}\n`;
    const footer = `${def}} } while (label)`;
    return `${scopeDef}\n${gotoHeader}\n${header}\n${body}\n${footer}`;
};
const $10a22d21a5252b59$var$expression = (node)=>{
    const v = $10a22d21a5252b59$var$generate(node);
    if ($10a22d21a5252b59$var$ExpressionReturnsArray(node)) return `${v}[0]`;
    return v;
};
const $10a22d21a5252b59$var$parseExpressions = (expressions)=>{
    // return the `array` directly instead of `[...array]`
    if (expressions.length === 1 && $10a22d21a5252b59$var$ExpressionReturnsArray(expressions[0])) return $10a22d21a5252b59$var$generate(expressions[0]);
    return `[${$10a22d21a5252b59$var$parseExpressionList(expressions).join(", ")}]`;
};
const $10a22d21a5252b59$var$parseExpressionList = (expressions)=>{
    return expressions.map((node, index, arr)=>{
        const value = $10a22d21a5252b59$var$generate(node);
        if ($10a22d21a5252b59$var$ExpressionReturnsArray(node)) return index === arr.length - 1 ? `...${value}` : `${value}[0]`;
        return value;
    });
};
const $10a22d21a5252b59$var$parseAssignments = (node)=>{
    const lines = [];
    const valFns = [];
    const useTempVar = node.variables.length > 1 && node.init.length > 0 && !node.init.every($10a22d21a5252b59$var$isLiteral);
    for(let i = 0; i < node.variables.length; i++){
        const K = node.variables[i];
        const V = node.init[i];
        const initStr = // eslint-disable-next-line no-nested-ternary
        useTempVar ? `vars[${i}]` : V === undefined ? "undefined" : $10a22d21a5252b59$var$expression(V);
        if (K.type === "Identifier") {
            const setStr = node.type === "LocalStatement" ? "setLocal" : "set";
            lines.push(`$${$10a22d21a5252b59$var$nodeToScope.get(K)}.${setStr}('${K.name}', ${initStr})`);
        } else {
            const name = $10a22d21a5252b59$var$generate(K);
            if (useTempVar) {
                lines.push(`vals[${valFns.length}](${initStr})`);
                valFns.push(name.setFn());
            } else lines.push(name.set(initStr));
        }
    }
    // push remaining CallExpressions
    for(let i = node.variables.length; i < node.init.length; i++){
        const init = node.init[i];
        if ($10a22d21a5252b59$var$isCallExpression(init)) lines.push($10a22d21a5252b59$var$generate(init));
    }
    if (useTempVar) {
        lines.unshift(`vars = ${$10a22d21a5252b59$var$parseExpressions(node.init)}`);
        if (valFns.length > 0) lines.unshift(`vals = [${valFns.join(", ")}]`);
    }
    return lines.join(";\n");
};
const $10a22d21a5252b59$var$isCallExpression = (node)=>{
    return node.type === "CallExpression" || node.type === "StringCallExpression" || node.type === "TableCallExpression";
};
const $10a22d21a5252b59$var$ExpressionReturnsArray = (node)=>{
    return $10a22d21a5252b59$var$isCallExpression(node) || node.type === "VarargLiteral";
};
const $10a22d21a5252b59$var$isLiteral = (node)=>{
    return node.type === "StringLiteral" || node.type === "NumericLiteral" || node.type === "BooleanLiteral" || node.type === "NilLiteral" || node.type === "TableConstructorExpression";
};
const $10a22d21a5252b59$var$checkGoto = (ast)=>{
    const gotoInfo = [];
    let gotoScope = 0;
    const gotoScopeMap = new Map();
    const getNextGotoScope = (()=>{
        let id = 0;
        return ()=>{
            id += 1;
            return id;
        };
    })();
    const check = (node)=>{
        if ($10a22d21a5252b59$var$isBlock(node)) {
            createGotoScope();
            for(let i = 0; i < node.body.length; i++){
                const n = node.body[i];
                switch(n.type){
                    case "LocalStatement":
                        gotoInfo.push({
                            type: "local",
                            name: n.variables[0].name,
                            scope: gotoScope
                        });
                        break;
                    case "LabelStatement":
                        if (gotoInfo.find((node)=>node.type === "label" && node.name === n.label.name && node.scope === gotoScope)) throw new Error(`label '${n.label.name}' already defined`);
                        gotoInfo.push({
                            type: "label",
                            name: n.label.name,
                            scope: gotoScope,
                            last: node.type !== "RepeatStatement" && node.body.slice(i).every((n)=>n.type === "LabelStatement")
                        });
                        break;
                    case "GotoStatement":
                        gotoInfo.push({
                            type: "goto",
                            name: n.label.name,
                            scope: gotoScope
                        });
                        break;
                    case "IfStatement":
                        n.clauses.forEach((n)=>check(n));
                        break;
                    default:
                        check(n);
                }
            }
            destroyGotoScope();
        }
    };
    check(ast);
    function createGotoScope() {
        const parent = gotoScope;
        gotoScope = getNextGotoScope();
        gotoScopeMap.set(gotoScope, parent);
    }
    function destroyGotoScope() {
        gotoScope = gotoScopeMap.get(gotoScope);
    }
    for(let i = 0; i < gotoInfo.length; i++){
        const goto = gotoInfo[i];
        if (goto.type === "goto") {
            const label = gotoInfo.filter((node)=>node.type === "label" && node.name === goto.name && node.scope <= goto.scope).sort((a, b)=>Math.abs(goto.scope - a.scope) - Math.abs(goto.scope - b.scope))[0];
            if (!label) throw new Error(`no visible label '${goto.name}' for <goto>`);
            const labelI = gotoInfo.findIndex((n)=>n === label);
            if (labelI > i) {
                const locals = gotoInfo.slice(i, labelI).filter((node)=>node.type === "local" && node.scope === label.scope);
                if (!label.last && locals.length > 0) throw new Error(`<goto ${goto.name}> jumps into the scope of local '${locals[0].name}'`);
            }
        }
    }
};
const $10a22d21a5252b59$var$visitNode = (node, visitProp, nextScope, isNewScope, nextGoto)=>{
    const VP = (node, partOfBlock = true)=>{
        if (!node) return;
        const S = partOfBlock === false && isNewScope ? $10a22d21a5252b59$var$scopeToParentScope.get(nextScope) : nextScope;
        if (Array.isArray(node)) node.forEach((n)=>visitProp(n, S, nextGoto));
        else visitProp(node, S, nextGoto);
    };
    switch(node.type){
        case "LocalStatement":
        case "AssignmentStatement":
            VP(node.variables);
            VP(node.init);
            break;
        case "UnaryExpression":
            VP(node.argument);
            break;
        case "BinaryExpression":
        case "LogicalExpression":
            VP(node.left);
            VP(node.right);
            break;
        case "FunctionDeclaration":
            VP(node.identifier, false);
            VP(node.parameters);
            VP(node.body);
            break;
        case "ForGenericStatement":
            VP(node.variables);
            VP(node.iterators, false);
            VP(node.body);
            break;
        case "IfClause":
        case "ElseifClause":
        case "WhileStatement":
        case "RepeatStatement":
            VP(node.condition, false);
        /* fall through */ case "Chunk":
        case "ElseClause":
        case "DoStatement":
            VP(node.body);
            break;
        case "ForNumericStatement":
            VP(node.variable);
            VP(node.start, false);
            VP(node.end, false);
            VP(node.step, false);
            VP(node.body);
            break;
        case "ReturnStatement":
            VP(node.arguments);
            break;
        case "IfStatement":
            VP(node.clauses);
            break;
        case "MemberExpression":
            VP(node.base);
            VP(node.identifier);
            break;
        case "IndexExpression":
            VP(node.base);
            VP(node.index);
            break;
        case "LabelStatement":
            VP(node.label);
            break;
        case "CallStatement":
            VP(node.expression);
            break;
        case "GotoStatement":
            VP(node.label);
            break;
        case "TableConstructorExpression":
            VP(node.fields);
            break;
        case "TableKey":
        case "TableKeyString":
            VP(node.key);
        /* fall through */ case "TableValue":
            VP(node.value);
            break;
        case "CallExpression":
            VP(node.base);
            VP(node.arguments);
            break;
        case "TableCallExpression":
            VP(node.base);
            VP(node.arguments);
            break;
        case "StringCallExpression":
            VP(node.base);
            VP(node.argument);
    }
};
const $10a22d21a5252b59$var$scopeToParentScope = new Map();
const $10a22d21a5252b59$var$nodeToScope = new Map();
const $10a22d21a5252b59$var$gotoToParentGoto = new Map();
const $10a22d21a5252b59$var$nodeToGoto = new Map();
const $10a22d21a5252b59$var$setExtraInfo = (ast)=>{
    let scopeID = 0;
    let gotoID = 0;
    const visitProp = (node, prevScope, prevGoto)=>{
        let nextScope = prevScope;
        let nextGoto = prevGoto;
        if ($10a22d21a5252b59$var$isBlock(node)) {
            // set scope info
            if (node.body.findIndex((n)=>n.type === "LocalStatement" || n.type === "FunctionDeclaration" && n.isLocal) !== -1 || node.type === "FunctionDeclaration" && (node.parameters.length > 0 || node.identifier && node.identifier.type === "MemberExpression") || node.type === "ForNumericStatement" || node.type === "ForGenericStatement") {
                scopeID += 1;
                nextScope = scopeID;
                $10a22d21a5252b59$var$nodeToScope.set(node, scopeID);
                $10a22d21a5252b59$var$scopeToParentScope.set(scopeID, prevScope);
            }
            // set goto info
            if (node.body.findIndex((s)=>s.type === "LabelStatement" || s.type === "GotoStatement") !== -1) {
                nextGoto = gotoID;
                $10a22d21a5252b59$var$nodeToGoto.set(node, gotoID);
                if (node.type !== "Chunk" && node.type !== "FunctionDeclaration") $10a22d21a5252b59$var$gotoToParentGoto.set(gotoID, prevGoto);
                gotoID += 1;
            }
        } else if (node.type === "Identifier" || node.type === "VarargLiteral") $10a22d21a5252b59$var$nodeToScope.set(node, prevScope);
        $10a22d21a5252b59$var$visitNode(node, visitProp, nextScope, prevScope !== nextScope, nextGoto);
    };
    visitProp(ast, scopeID, gotoID);
};
const $10a22d21a5252b59$export$98e6a39c04603d36 = (data)=>{
    const ast = (0, (/*@__PURE__*/$parcel$interopDefault($jv3NX))).parse(data.replace(/^#.*/, ""), {
        scope: false,
        comments: false,
        luaVersion: "5.3"
    });
    $10a22d21a5252b59$var$checkGoto(ast);
    $10a22d21a5252b59$var$setExtraInfo(ast);
    return $10a22d21a5252b59$var$generate(ast).toString();
};





/* printj.js (C) 2016-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint sub:true, eqnull:true */ /*exported PRINTJ */ /*:: declare var DO_NOT_EXPORT_PRINTJ:?boolean; */ /*:: declare function define(cb:()=>any):void; */ var $92368d23f7d468f6$var$PRINTJ /*:PRINTJModule*/  = /*::(*/ {} /*:: :any)*/ ;
$92368d23f7d468f6$var$PRINTJ.version = "1.3.1";
const $92368d23f7d468f6$export$83d89fbfd8236492 = $92368d23f7d468f6$var$PRINTJ.version;
var $92368d23f7d468f6$var$tcache = {};
function $92368d23f7d468f6$var$tokenize(fmt /*:string*/ ) /*:ParsedFmt*/ {
    if ($92368d23f7d468f6$var$tcache[fmt]) return $92368d23f7d468f6$var$tcache[fmt];
    var out /*:ParsedFmt*/  = [];
    var start /*:number*/  = 0;
    var i /*:number*/  = 0;
    var infmt /*:boolean*/  = false;
    var fmtparam /*:string*/  = "", fmtflags /*:string*/  = "", fmtwidth /*:string*/  = "", fmtprec /*:string*/  = "", fmtlen /*:string*/  = "";
    var c /*:number*/  = 0;
    var L /*:number*/  = fmt.length;
    for(; i < L; ++i){
        c = fmt.charCodeAt(i);
        if (!infmt) {
            if (c !== 37) continue;
            if (start < i) out.push([
                "L",
                fmt.substring(start, i)
            ]);
            start = i;
            infmt = true;
            continue;
        }
        if (c >= 48 && c < 58) {
            if (fmtprec.length) fmtprec += String.fromCharCode(c);
            else if (c == 48 && !fmtwidth.length) fmtflags += String.fromCharCode(c);
            else fmtwidth += String.fromCharCode(c);
        } else switch(c){
            /* positional */ case 36:
                if (fmtprec.length) fmtprec += "$";
                else if (fmtwidth.charAt(0) == "*") fmtwidth += "$";
                else {
                    fmtparam = fmtwidth + "$";
                    fmtwidth = "";
                }
                break;
            /* flags */ case 39:
                fmtflags += "'";
                break;
            case 45:
                fmtflags += "-";
                break;
            case 43:
                fmtflags += "+";
                break;
            case 32:
                fmtflags += " ";
                break;
            case 35:
                fmtflags += "#";
                break;
            /* width and precision */ case 46:
                fmtprec = ".";
                break;
            case 42:
                if (fmtprec.charAt(0) == ".") fmtprec += "*";
                else fmtwidth += "*";
                break;
            /* length */ case 104:
            case 108:
                if (fmtlen.length > 1) throw "bad length " + fmtlen + String(c);
                fmtlen += String.fromCharCode(c);
                break;
            case 76:
            case 106:
            case 122:
            case 116:
            case 113:
            case 90:
            case 119:
                if (fmtlen !== "") throw "bad length " + fmtlen + String.fromCharCode(c);
                fmtlen = String.fromCharCode(c);
                break;
            case 73:
                if (fmtlen !== "") throw "bad length " + fmtlen + "I";
                fmtlen = "I";
                break;
            /* conversion */ case 100:
            case 105:
            case 111:
            case 117:
            case 120:
            case 88:
            case 102:
            case 70:
            case 101:
            case 69:
            case 103:
            case 71:
            case 97:
            case 65:
            case 99:
            case 67:
            case 115:
            case 83:
            case 112:
            case 110:
            case 68:
            case 85:
            case 79:
            case 109:
            case 98:
            case 66:
            case 121:
            case 89:
            case 74:
            case 86:
            case 84:
            case 37:
                infmt = false;
                if (fmtprec.length > 1) fmtprec = fmtprec.substr(1);
                out.push([
                    String.fromCharCode(c),
                    fmt.substring(start, i + 1),
                    fmtparam,
                    fmtflags,
                    fmtwidth,
                    fmtprec,
                    fmtlen
                ]);
                start = i + 1;
                fmtlen = fmtprec = fmtwidth = fmtflags = fmtparam = "";
                break;
            default:
                throw new Error("Invalid format string starting with |" + fmt.substring(start, i + 1) + "|");
        }
    }
    if (start < fmt.length) out.push([
        "L",
        fmt.substring(start)
    ]);
    return $92368d23f7d468f6$var$tcache[fmt] = out;
}
var $92368d23f7d468f6$var$u_inspect /*:(o:any)=>string*/  = JSON.stringify;
function $92368d23f7d468f6$var$doit(t /*:ParsedFmt*/ , args /*:Array<any>*/ ) /*:string*/ {
    //var o/*:Array<string>*/ = [];
    var o = "";
    var argidx /*:number*/  = 0, idx /*:number*/  = 0;
    var Vnum /*:number*/  = 0;
    var pad /*:string*/  = "";
    for(var i /*:number*/  = 0; i < t.length; ++i){
        var m /*:ParsedEntry*/  = t[i], c /*:number*/  = m[0].charCodeAt(0);
        /* m order: conv full param flags width prec length */ if (c === /*L*/ 76) {
            o += /*o.push*/ m[1];
            continue;
        }
        if (c === /*%*/ 37) {
            o += /*o.push*/ "%";
            continue;
        }
        var O /*:string*/  = "";
        var isnum /*:number*/  = 0, radix /*:number*/  = 10, bytes /*:number*/  = 4, sign /*:boolean*/  = false;
        /* flags */ var flags /*:string*/  = m[3] /*||""*/ ;
        var alt /*:boolean*/  = flags.indexOf("#") > -1;
        /* position */ if (m[2]) argidx = parseInt(m[2], 10) - 1;
        else if (c === /*m*/ 109 && !alt) {
            o += /*.push*/ "Success";
            continue;
        }
        /* grab width */ var width = 0;
        if (m[4].length > 0) {
            if (m[4].charAt(0) !== "*") width = parseInt(m[4], 10);
            else if (m[4].length === 1) width = args[idx++];
            else width = args[parseInt(m[4].substr(1), 10) - 1];
        }
        /* grab precision */ var prec = -1;
        if (m[5].length > 0) {
            if (m[5].charAt(0) !== "*") prec = parseInt(m[5], 10);
            else if (m[5].length === 1) prec = args[idx++];
            else prec = args[parseInt(m[5].substr(1), 10) - 1];
        }
        /* position not specified */ if (!m[2]) argidx = idx++;
        /* grab argument */ var arg /*:any*/  = args[argidx];
        /* grab length */ var len /*:string*/  = m[6] /* || ""*/ ;
        switch(c){
            /* str cCsS */ case /*S*/ 83:
            case /*s*/ 115:
                /* only valid flag is "-" for left justification */ O = String(arg);
                if (prec >= 0) O = O.substr(0, prec);
                if (width > O.length || -width > O.length) {
                    if ((flags.indexOf("-") == -1 || width < 0) && flags.indexOf("0") != -1) {
                        pad = width - O.length >= 0 ? "0".repeat(width - O.length) : "";
                        O = pad + O;
                    } else {
                        pad = width - O.length >= 0 ? " ".repeat(width - O.length) : "";
                        O = flags.indexOf("-") > -1 ? O + pad : pad + O;
                    }
                }
                break;
            /* first char of string or convert */ case /*C*/ 67:
            case /*c*/ 99:
                switch(typeof arg){
                    case "number":
                        var cc /*:number*/  = arg;
                        if (c == 67 || len.charCodeAt(0) === /*l*/ 108) {
                            cc &= 0xFFFFFFFF;
                            O = String.fromCharCode(cc);
                        } else {
                            cc &= 0xFF;
                            O = String.fromCharCode(cc);
                        }
                        break;
                    case "string":
                        O = /*::(*/ arg /*:: :string)*/ .charAt(0);
                        break;
                    default:
                        O = String(arg).charAt(0);
                }
                if (width > O.length || -width > O.length) {
                    if ((flags.indexOf("-") == -1 || width < 0) && flags.indexOf("0") != -1) {
                        pad = width - O.length >= 0 ? "0".repeat(width - O.length) : "";
                        O = pad + O;
                    } else {
                        pad = width - O.length >= 0 ? " ".repeat(width - O.length) : "";
                        O = flags.indexOf("-") > -1 ? O + pad : pad + O;
                    }
                }
                break;
            /* int diDuUoOxXbB */ /* signed integer */ case /*D*/ 68:
                bytes = 8;
            /* falls through */ case /*d*/ 100:
            case /*i*/ 105:
                isnum = -1;
                sign = true;
                break;
            /* unsigned integer */ case /*U*/ 85:
                bytes = 8;
            /* falls through */ case /*u*/ 117:
                isnum = -1;
                break;
            /* unsigned octal */ case /*O*/ 79:
                bytes = 8;
            /* falls through */ case /*o*/ 111:
                isnum = -1;
                radix = 8;
                break;
            /* unsigned hex */ case /*x*/ 120:
                isnum = -1;
                radix = -16;
                break;
            case /*X*/ 88:
                isnum = -1;
                radix = 16;
                break;
            /* unsigned binary (extension) */ case /*B*/ 66:
                bytes = 8;
            /* falls through */ case /*b*/ 98:
                isnum = -1;
                radix = 2;
                break;
            /* flt fegFEGaA */ /* floating point logic */ case /*F*/ 70:
            case /*f*/ 102:
                isnum = 1;
                break;
            case /*E*/ 69:
            case /*e*/ 101:
                isnum = 2;
                break;
            case /*G*/ 71:
            case /*g*/ 103:
                isnum = 3;
                break;
            /* floating hex */ case /*A*/ 65:
            case /*a*/ 97:
                isnum = 4;
                break;
            /* misc pnmJVTyY */ /* JS has no concept of pointers so interpret the `l` key as an address */ case /*p*/ 112:
                Vnum = typeof arg == "number" ? arg : arg ? Number(arg.l) : -1;
                if (isNaN(Vnum)) Vnum = -1;
                if (alt) O = Vnum.toString(10);
                else {
                    Vnum = Math.abs(Vnum);
                    O = "0x" + Vnum.toString(16).toLowerCase();
                }
                break;
            /* store length in the `len` key */ case /*n*/ 110:
                if (arg) arg.len = o.length;
                continue;
            /* process error */ case /*m*/ 109:
                if (!(arg instanceof Error)) O = "Success";
                else if (arg.message) O = arg.message;
                else if (arg.errno) O = "Error number " + arg.errno;
                else O = "Error " + String(arg);
                break;
            /* JS-specific conversions (extension) */ case /*J*/ 74:
                O = (alt ? $92368d23f7d468f6$var$u_inspect : JSON.stringify)(arg);
                break;
            case /*V*/ 86:
                O = arg == null ? "null" : String(arg.valueOf());
                break;
            case /*T*/ 84:
                if (alt) {
                    O = Object.prototype.toString.call(arg).substr(8);
                    O = O.substr(0, O.length - 1);
                } else O = typeof arg;
                break;
            /* boolean (extension) */ case /*Y*/ 89:
            case /*y*/ 121:
                O = arg ? alt ? "yes" : "true" : alt ? "no" : "false";
                if (c == /*Y*/ 89) O = O.toUpperCase();
                if (prec >= 0) O = O.substr(0, prec);
                if (width > O.length || -width > O.length) {
                    if ((flags.indexOf("-") == -1 || width < 0) && flags.indexOf("0") != -1) {
                        pad = width - O.length >= 0 ? "0".repeat(width - O.length) : "";
                        O = pad + O;
                    } else {
                        pad = width - O.length >= 0 ? " ".repeat(width - O.length) : "";
                        O = flags.indexOf("-") > -1 ? O + pad : pad + O;
                    }
                }
                break;
        }
        if (width < 0) {
            width = -width;
            flags += "-";
        }
        if (isnum == -1) {
            Vnum = Number(arg);
            /* parse byte length field */ switch(len){
                /* char */ case "hh":
                    bytes = 1;
                    break;
                /* short */ case "h":
                    bytes = 2;
                    break;
                /* long */ case "l":
                    if (bytes == 4) bytes = 8;
                    break;
                /* long long */ case "L":
                case "q":
                case "ll":
                    if (bytes == 4) bytes = 8;
                    break;
                /* intmax_t */ case "j":
                    if (bytes == 4) bytes = 8;
                    break;
                /* ptrdiff_t */ case "t":
                    if (bytes == 4) bytes = 8;
                    break;
                /* size_t */ case "z":
                case "Z":
                    if (bytes == 4) bytes = 8;
                    break;
                /* CRT size_t or ptrdiff_t */ case "I":
                    if (bytes == 4) bytes = 8;
                    break;
                /* CRT wchar_t */ case "w":
                    break;
            }
            /* restrict value */ switch(bytes){
                case 1:
                    Vnum = Vnum & 0xFF;
                    if (sign && Vnum > 0x7F) Vnum -= 256;
                    break;
                case 2:
                    Vnum = Vnum & 0xFFFF;
                    if (sign && Vnum > 0x7FFF) Vnum -= 65536;
                    break;
                case 4:
                    Vnum = sign ? Vnum | 0 : Vnum >>> 0;
                    break;
                default:
                    Vnum = isNaN(Vnum) ? 0 : Math.round(Vnum);
                    break;
            }
            /* generate string */ if (bytes > 4 && Vnum < 0 && !sign) {
                if (radix == 16 || radix == -16) {
                    O = (Vnum >>> 0).toString(16);
                    Vnum = Math.floor((Vnum - (Vnum >>> 0)) / Math.pow(2, 32));
                    O = (Vnum >>> 0).toString(16) + (8 - O.length >= 0 ? "0".repeat(8 - O.length) : "") + O;
                    O = (16 - O.length >= 0 ? "f".repeat(16 - O.length) : "") + O;
                    if (radix == 16) O = O.toUpperCase();
                } else if (radix == 8) {
                    O = (Vnum >>> 0).toString(8);
                    O = (10 - O.length >= 0 ? "0".repeat(10 - O.length) : "") + O;
                    Vnum = Math.floor((Vnum - (Vnum >>> 0 & 0x3FFFFFFF)) / Math.pow(2, 30));
                    O = (Vnum >>> 0).toString(8) + O.substr(O.length - 10);
                    O = O.substr(O.length - 20);
                    O = "1" + (21 - O.length >= 0 ? "7".repeat(21 - O.length) : "") + O;
                } else {
                    Vnum = -Vnum % 1e16;
                    var d1 /*:Array<number>*/  = [
                        1,
                        8,
                        4,
                        4,
                        6,
                        7,
                        4,
                        4,
                        0,
                        7,
                        3,
                        7,
                        0,
                        9,
                        5,
                        5,
                        1,
                        6,
                        1,
                        6
                    ];
                    var di /*:number*/  = d1.length - 1;
                    while(Vnum > 0){
                        if ((d1[di] -= Vnum % 10) < 0) {
                            d1[di] += 10;
                            d1[di - 1]--;
                        }
                        --di;
                        Vnum = Math.floor(Vnum / 10);
                    }
                    O = d1.join("");
                }
            } else {
                if (radix === -16) O = Vnum.toString(16).toLowerCase();
                else if (radix === 16) O = Vnum.toString(16).toUpperCase();
                else O = Vnum.toString(radix);
            }
            /* apply precision */ if (prec === 0 && O == "0" && !(radix == 8 && alt)) O = ""; /* bail out */ 
            else {
                if (O.length < prec + (O.substr(0, 1) == "-" ? 1 : 0)) {
                    if (O.substr(0, 1) != "-") O = (prec - O.length >= 0 ? "0".repeat(prec - O.length) : "") + O;
                    else O = O.substr(0, 1) + (prec + 1 - O.length >= 0 ? "0".repeat(prec + 1 - O.length) : "") + O.substr(1);
                }
                /* add prefix for # form */ if (!sign && alt && Vnum !== 0) switch(radix){
                    case -16:
                        O = "0x" + O;
                        break;
                    case 16:
                        O = "0X" + O;
                        break;
                    case 8:
                        if (O.charAt(0) != "0") O = "0" + O;
                        break;
                    case 2:
                        O = "0b" + O;
                        break;
                }
            }
            /* add sign character */ if (sign && O.charAt(0) != "-") {
                if (flags.indexOf("+") > -1) O = "+" + O;
                else if (flags.indexOf(" ") > -1) O = " " + O;
            }
            /* width */ if (width > 0) {
                if (O.length < width) {
                    if (flags.indexOf("-") > -1) O = O + (width - O.length >= 0 ? " ".repeat(width - O.length) : "");
                    else if (flags.indexOf("0") > -1 && prec < 0 && O.length > 0) {
                        if (prec > O.length) O = (prec - O.length >= 0 ? "0".repeat(prec - O.length) : "") + O;
                        pad = width - O.length >= 0 ? (prec > 0 ? " " : "0").repeat(width - O.length) : "";
                        if (O.charCodeAt(0) < 48) {
                            if (O.charAt(2).toLowerCase() == "x") O = O.substr(0, 3) + pad + O.substring(3);
                            else O = O.substr(0, 1) + pad + O.substring(1);
                        } else if (O.charAt(1).toLowerCase() == "x") O = O.substr(0, 2) + pad + O.substring(2);
                        else O = pad + O;
                    } else O = (width - O.length >= 0 ? " ".repeat(width - O.length) : "") + O;
                }
            }
        } else if (isnum > 0) {
            Vnum = Number(arg);
            if (arg === null) Vnum = 0 / 0;
            if (len == "L") bytes = 12;
            var isf /*:boolean*/  = isFinite(Vnum);
            if (!isf) {
                if (Vnum < 0) O = "-";
                else if (flags.indexOf("+") > -1) O = "+";
                else if (flags.indexOf(" ") > -1) O = " ";
                O += isNaN(Vnum) ? "nan" : "inf";
            } else {
                var E /*:number*/  = 0;
                if (prec == -1 && isnum != 4) prec = 6;
                /* g/G conditional behavior */ if (isnum == 3) {
                    O = Vnum.toExponential(1);
                    E = +O.substr(O.indexOf("e") + 1);
                    if (prec === 0) prec = 1;
                    if (prec > E && E >= -4) {
                        isnum = 11;
                        prec = prec - (E + 1);
                    } else {
                        isnum = 12;
                        prec = prec - 1;
                    }
                }
                /* sign: workaround for negative zero */ var sg /*:string*/  = Vnum < 0 || 1 / Vnum == -Infinity ? "-" : "";
                if (Vnum < 0) Vnum = -Vnum;
                switch(isnum){
                    /* f/F standard */ case 1:
                    case 11:
                        if (Vnum < 1e21) {
                            O = Vnum.toFixed(prec);
                            if (isnum == 1) {
                                if (prec === 0 && alt && O.indexOf(".") == -1) O += ".";
                            } else if (!alt) O = O.replace(/(\.\d*[1-9])0*$/, "$1").replace(/\.0*$/, "");
                            else if (O.indexOf(".") == -1) O += ".";
                            break;
                        }
                        O = Vnum.toExponential(20);
                        E = +O.substr(O.indexOf("e") + 1);
                        O = O.charAt(0) + O.substr(2, O.indexOf("e") - 2);
                        O = O + (E - O.length + 1 >= 0 ? "0".repeat(E - O.length + 1) : "");
                        if (alt || prec > 0 && isnum !== 11) O = O + "." + (prec >= 0 ? "0".repeat(prec) : "");
                        break;
                    /* e/E exponential */ case 2:
                    case 12:
                        O = Vnum.toExponential(prec);
                        E = O.indexOf("e");
                        if (O.length - E === 3) O = O.substr(0, E + 2) + "0" + O.substr(E + 2);
                        if (alt && O.indexOf(".") == -1) O = O.substr(0, E) + "." + O.substr(E);
                        else if (!alt && isnum == 12) O = O.replace(/\.0*e/, "e").replace(/\.(\d*[1-9])0*e/, ".$1e");
                        break;
                    /* a/A hex */ case 4:
                        if (Vnum === 0) {
                            O = "0x0" + (alt || prec > 0 ? "." + (prec >= 0 ? "0".repeat(prec) : "") : "") + "p+0";
                            break;
                        }
                        O = Vnum.toString(16);
                        /* First char 0-9 */ var ac /*:number*/  = O.charCodeAt(0);
                        if (ac == 48) {
                            ac = 2;
                            E = -4;
                            Vnum *= 16;
                            while(O.charCodeAt(ac++) == 48){
                                E -= 4;
                                Vnum *= 16;
                            }
                            O = Vnum.toString(16);
                            ac = O.charCodeAt(0);
                        }
                        var ai /*:number*/  = O.indexOf(".");
                        if (O.indexOf("(") > -1) {
                            /* IE exponential form */ var am /*:?Array<any>*/  = O.match(/\(e(.*)\)/);
                            var ae /*:number*/  = am ? +am[1] : 0;
                            E += 4 * ae;
                            Vnum /= Math.pow(16, ae);
                        } else if (ai > 1) {
                            E += 4 * (ai - 1);
                            Vnum /= Math.pow(16, ai - 1);
                        } else if (ai == -1) {
                            E += 4 * (O.length - 1);
                            Vnum /= Math.pow(16, O.length - 1);
                        }
                        /* at this point 1 <= Vnum < 16 */ if (bytes > 8) {
                            if (ac < 50) {
                                E -= 3;
                                Vnum *= 8;
                            } else if (ac < 52) {
                                E -= 2;
                                Vnum *= 4;
                            } else if (ac < 56) {
                                E -= 1;
                                Vnum *= 2;
                            }
                        /* at this point 8 <= Vnum < 16 */ } else {
                            if (ac >= 56) {
                                E += 3;
                                Vnum /= 8;
                            } else if (ac >= 52) {
                                E += 2;
                                Vnum /= 4;
                            } else if (ac >= 50) {
                                E += 1;
                                Vnum /= 2;
                            }
                        /* at this point 1 <= Vnum < 2 */ }
                        O = Vnum.toString(16);
                        if (O.length > 1) {
                            if (O.length > prec + 2 && O.charCodeAt(prec + 2) >= 56) {
                                var _f /*:boolean*/  = O.charCodeAt(0) == 102;
                                O = (Vnum + 8 * Math.pow(16, -prec - 1)).toString(16);
                                if (_f && O.charCodeAt(0) == 49) E += 4;
                            }
                            if (prec > 0) {
                                O = O.substr(0, prec + 2);
                                if (O.length < prec + 2) {
                                    if (O.charCodeAt(0) < 48) O = O.charAt(0) + (prec + 2 - O.length >= 0 ? "0".repeat(prec + 2 - O.length) : "") + O.substr(1);
                                    else O += prec + 2 - O.length >= 0 ? "0".repeat(prec + 2 - O.length) : "";
                                }
                            } else if (prec === 0) O = O.charAt(0) + (alt ? "." : "");
                        } else if (prec > 0) O = O + "." + (prec >= 0 ? "0".repeat(prec) : "");
                        else if (alt) O = O + ".";
                        O = "0x" + O + "p" + (E >= 0 ? "+" + E : E);
                        break;
                }
                if (sg === "") {
                    if (flags.indexOf("+") > -1) sg = "+";
                    else if (flags.indexOf(" ") > -1) sg = " ";
                }
                O = sg + O;
            }
            /* width */ if (width > O.length) {
                if (flags.indexOf("-") > -1) O = O + (width - O.length >= 0 ? " ".repeat(width - O.length) : "");
                else if (flags.indexOf("0") > -1 && O.length > 0 && isf) {
                    pad = width - O.length >= 0 ? "0".repeat(width - O.length) : "";
                    if (O.charCodeAt(0) < 48) {
                        if (O.charAt(2).toLowerCase() == "x") O = O.substr(0, 3) + pad + O.substring(3);
                        else O = O.substr(0, 1) + pad + O.substring(1);
                    } else if (O.charAt(1).toLowerCase() == "x") O = O.substr(0, 2) + pad + O.substring(2);
                    else O = pad + O;
                } else O = (width - O.length >= 0 ? " ".repeat(width - O.length) : "") + O;
            }
            if (c < 96) O = O.toUpperCase();
        }
        o += /*.push*/ O;
    }
    return o /*.join("")*/ ;
}
function $92368d23f7d468f6$export$790fb69b1a2884f9(fmt /*:string*/ , args /*:Args*/ ) /*:string*/ {
    return $92368d23f7d468f6$var$doit($92368d23f7d468f6$var$tokenize(fmt), args);
}
function $92368d23f7d468f6$export$63151d8bb18a49f9() /*:string*/ {
    var args /*:Array<any>*/  = new Array(arguments.length - 1);
    for(var i /*:number*/  = 0; i < args.length; ++i)args[i] = arguments[i + 1];
    return $92368d23f7d468f6$var$doit($92368d23f7d468f6$var$tokenize(arguments[0]), args);
}





const $e0e1ecd360f89547$var$ROSETTA_STONE = {
    "([^a-zA-Z0-9%(])-": "$1*?",
    "([^%])-([^a-zA-Z0-9?])": "$1*?$2",
    "([^%])\\.": "$1[\\s\\S]",
    "(.)-$": "$1*?",
    "%a": "[a-zA-Z]",
    "%A": "[^a-zA-Z]",
    "%c": "[\0-\x1f]",
    "%C": "[^\0-\x1f]",
    "%d": "\\d",
    "%D": "[^d]",
    "%l": "[a-z]",
    "%L": "[^a-z]",
    "%p": "[.,\"'?!;:#$%&()*+-/<>=@\\[\\]\\\\^_{}|~]",
    "%P": "[^.,\"'?!;:#$%&()*+-/<>=@\\[\\]\\\\^_{}|~]",
    "%s": "[ \\t\\n\\f\\v\\r]",
    "%S": "[^ 	\n\f\v\r]",
    "%u": "[A-Z]",
    "%U": "[^A-Z]",
    "%w": "[a-zA-Z0-9]",
    "%W": "[^a-zA-Z0-9]",
    "%x": "[a-fA-F0-9]",
    "%X": "[^a-fA-F0-9]",
    "%([^a-zA-Z])": "\\$1"
};
function $e0e1ecd360f89547$var$translatePattern(pattern) {
    // TODO Add support for balanced character matching (not sure this is easily achieveable).
    // Replace single backslash with double backslashes
    let tPattern = pattern.replace(/\\/g, "\\\\");
    for(const i in $e0e1ecd360f89547$var$ROSETTA_STONE)if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)($e0e1ecd360f89547$var$ROSETTA_STONE, i)) tPattern = tPattern.replace(new RegExp(i, "g"), $e0e1ecd360f89547$var$ROSETTA_STONE[i]);
    let nestingLevel = 0;
    for(let i = 0, l = tPattern.length; i < l; i++){
        if (i && tPattern.substr(i - 1, 1) === "\\") continue;
        // Remove nested square brackets caused by substitutions
        const character = tPattern.substr(i, 1);
        if (character === "[" || character === "]") {
            if (character === "]") nestingLevel -= 1;
            if (nestingLevel > 0) {
                tPattern = tPattern.substr(0, i) + tPattern.substr(i + 1);
                i -= 1;
                l -= 1;
            }
            if (character === "[") nestingLevel += 1;
        }
    }
    return tPattern;
}
/**
 * Returns the internal numeric codes of the characters s[i], s[i+1], ..., s[j].
 * The default value for i is 1; the default value for j is i.
 * These indices are corrected following the same rules of function string.sub.
 *
 * Numeric codes are not necessarily portable across platforms.
 */ function $e0e1ecd360f89547$var$byte(s, i, j) {
    const S = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "byte", 1);
    const I = i === undefined ? 1 : (0, $67f923318f75be7d$export$a10e5668227c81bc)(i, "byte", 2);
    const J = j === undefined ? I : (0, $67f923318f75be7d$export$a10e5668227c81bc)(j, "byte", 3);
    return S.substring(I - 1, J).split("").map((c)=>c.charCodeAt(0));
}
/**
 * Receives zero or more integers. Returns a string with length equal to the number of arguments,
 * in which each character has the internal numeric code equal to its corresponding argument.
 *
 * Numeric codes are not necessarily portable across platforms.
 */ function $e0e1ecd360f89547$var$char(...bytes) {
    return bytes.map((b, i)=>{
        const B = (0, $67f923318f75be7d$export$a10e5668227c81bc)(b, "char", i);
        return String.fromCharCode(B);
    }).join("");
}
/**
 * Looks for the first match of pattern (see §6.4.1) in the string s. If it finds a match, then find returns
 * the indices of s where this occurrence starts and ends; otherwise, it returns nil.
 * A third, optional numeric argument init specifies where to start the search; its default value is 1 and can be negative.
 * A value of true as a fourth, optional argument plain turns off the pattern matching facilities,
 * so the function does a plain "find substring" operation, with no characters in pattern being considered magic.
 * Note that if plain is given, then init must be given as well.
 *
 * If the pattern has captures, then in a successful match the captured values are also returned, after the two indices.
 */ function $e0e1ecd360f89547$var$find(s, pattern, init, plain) {
    const S = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "find", 1);
    const P = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(pattern, "find", 2);
    const INIT = init === undefined ? 1 : (0, $67f923318f75be7d$export$a10e5668227c81bc)(init, "find", 3);
    const PLAIN = plain === undefined ? false : (0, $67f923318f75be7d$export$a10e5668227c81bc)(plain, "find", 4);
    // Regex
    if (!PLAIN) {
        const regex = new RegExp($e0e1ecd360f89547$var$translatePattern(P));
        const index = S.substr(INIT - 1).search(regex);
        if (index < 0) return;
        const match = S.substr(INIT - 1).match(regex);
        const result = [
            index + INIT,
            index + INIT + match[0].length - 1
        ];
        match.shift();
        return [
            ...result,
            ...match
        ];
    }
    // Plain
    const index = S.indexOf(P, INIT - 1);
    return index === -1 ? undefined : [
        index + 1,
        index + P.length
    ];
}
function $e0e1ecd360f89547$var$format(formatstring, ...args) {
    // Pattern with all constraints:
    // /%%|%([-+ #0]{0,5})?(\d{0,2})?(?:\.(\d{0,2}))?([AEGXacdefgioqsux])/g
    const PATTERN = /%%|%([-+ #0]*)?(\d*)?(?:\.(\d*))?(.)/g;
    let i = -1;
    return formatstring.replace(PATTERN, (format, flags, width, precision, modifier)=>{
        if (format === "%%") return "%";
        if (!modifier.match(/[AEGXacdefgioqsux]/)) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`invalid option '%${format}' to 'format'`);
        if (flags && flags.length > 5) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`invalid format (repeated flags)`);
        if (width && width.length > 2) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`invalid format (width too long)`);
        if (precision && precision.length > 2) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`invalid format (precision too long)`);
        i += 1;
        const arg = args[i];
        if (arg === undefined) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`bad argument #${i} to 'format' (no value)`);
        if (/A|a|E|e|f|G|g/.test(modifier)) return $92368d23f7d468f6$export$63151d8bb18a49f9(format, (0, $67f923318f75be7d$export$a10e5668227c81bc)(arg, "format", i));
        if (/c|d|i|o|u|X|x/.test(modifier)) return $92368d23f7d468f6$export$63151d8bb18a49f9(format, (0, $67f923318f75be7d$export$a10e5668227c81bc)(arg, "format", i));
        if (modifier === "q") return `"${arg.replace(/([\n"])/g, "\\$1")}"`;
        if (modifier === "s") return $92368d23f7d468f6$export$63151d8bb18a49f9(format, (0, $67f923318f75be7d$export$2d61a1c0fd545922)(arg));
        return $92368d23f7d468f6$export$63151d8bb18a49f9(format, arg);
    });
}
/**
 * Returns an iterator function that, each time it is called, returns the next captures from pattern (see §6.4.1)
 * over the string s. If pattern specifies no captures, then the whole match is produced in each call.
 */ function $e0e1ecd360f89547$var$gmatch(s, pattern) {
    const S = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "gmatch", 1);
    const P = $e0e1ecd360f89547$var$translatePattern((0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(pattern, "gmatch", 2));
    const reg = new RegExp(P, "g");
    const matches = S.match(reg);
    return ()=>{
        const match = matches.shift();
        if (match === undefined) return [];
        const groups = new RegExp(P).exec(match);
        groups.shift();
        return groups.length ? groups : [
            match
        ];
    };
}
/**
 * Returns a copy of s in which all (or the first n, if given) occurrences of the pattern (see §6.4.1)
 * have been replaced by a replacement string specified by repl, which can be a string, a table, or a function.
 * gsub also returns, as its second value, the total number of matches that occurred.
 * The name gsub comes from Global SUBstitution.
 *
 * If repl is a string, then its value is used for replacement. The character % works as an escape character:
 * any sequence in repl of the form %d, with d between 1 and 9, stands for the value of the d-th captured substring.
 * The sequence %0 stands for the whole match. The sequence %% stands for a single %.
 *
 * If repl is a table, then the table is queried for every match, using the first capture as the key.
 *
 * If repl is a function, then this function is called every time a match occurs,
 * with all captured substrings passed as arguments, in order.
 *
 * In any case, if the pattern specifies no captures, then it behaves as if the whole pattern was inside a capture.
 *
 * If the value returned by the table query or by the function call is a string or a number,
 * then it is used as the replacement string; otherwise, if it is false or nil, then there is no replacement
 * (that is, the original match is kept in the string).
 */ function $e0e1ecd360f89547$var$gsub(s, pattern, repl, n) {
    let S = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "gsub", 1);
    const N = n === undefined ? Infinity : (0, $67f923318f75be7d$export$a10e5668227c81bc)(n, "gsub", 3);
    const P = $e0e1ecd360f89547$var$translatePattern((0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(pattern, "gsub", 2));
    const REPL = (()=>{
        if (typeof repl === "function") return (strs)=>{
            const ret = repl(strs[0])[0];
            return ret === undefined ? strs[0] : ret;
        };
        if (repl instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)) return (strs)=>repl.get(strs[0]).toString();
        return (strs)=>`${repl}`.replace(/%([0-9])/g, (_, i)=>strs[i]);
    })();
    let result = "";
    let count = 0;
    let match;
    let lastMatch;
    while(count < N && S && (match = S.match(P))){
        const prefix = // eslint-disable-next-line no-nested-ternary
        match[0].length > 0 ? S.substr(0, match.index) : lastMatch === undefined ? "" : S.substr(0, 1);
        lastMatch = match[0];
        result += `${prefix}${REPL(match)}`;
        S = S.substr(`${prefix}${lastMatch}`.length);
        count += 1;
    }
    return `${result}${S}`;
}
/**
 * Receives a string and returns its length. The empty string "" has length 0.
 * Embedded zeros are counted, so "a\000bc\000" has length 5.
 */ function $e0e1ecd360f89547$var$len(s) {
    const str = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "len", 1);
    return str.length;
}
/**
 * Receives a string and returns a copy of this string with all uppercase letters changed to lowercase.
 * All other characters are left unchanged.
 * The definition of what an uppercase letter is depends on the current locale.
 */ function $e0e1ecd360f89547$var$lower(s) {
    const str = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "lower", 1);
    return str.toLowerCase();
}
/**
 * Looks for the first match of pattern (see §6.4.1) in the string s.
 * If it finds one, then match returns the captures from the pattern; otherwise it returns nil.
 * If pattern specifies no captures, then the whole match is returned.
 * A third, optional numeric argument init specifies where to start the search; its default value is 1 and can be negative.
 */ function $e0e1ecd360f89547$var$match(s, pattern, init = 0) {
    let str = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "match", 1);
    const patt = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(pattern, "match", 2);
    const ini = (0, $67f923318f75be7d$export$a10e5668227c81bc)(init, "match", 3);
    str = str.substr(ini);
    const matches = str.match(new RegExp($e0e1ecd360f89547$var$translatePattern(patt)));
    if (!matches) return;
    else if (!matches[1]) return matches[0];
    matches.shift();
    return matches;
}
/**
 * Returns a string that is the concatenation of n copies of the string s separated by the string sep.
 * The default value for sep is the empty string (that is, no separator).
 * Returns the empty string if n is not positive.
 */ function $e0e1ecd360f89547$var$rep(s, n, sep) {
    const str = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "rep", 1);
    const num = (0, $67f923318f75be7d$export$a10e5668227c81bc)(n, "rep", 2);
    const SEP = sep === undefined ? "" : (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(sep, "rep", 3);
    return Array(num).fill(str).join(SEP);
}
/** Returns a string that is the string s reversed. */ function $e0e1ecd360f89547$var$reverse(s) {
    const str = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "reverse", 1);
    return str.split("").reverse().join("");
}
/**
 * Returns the substring of s that starts at i and continues until j; i and j can be negative.
 * If j is absent, then it is assumed to be equal to -1 (which is the same as the string length).
 * In particular, the call string.sub(s,1,j) returns a prefix of s with length j, and string.sub(s, -i)
 * (for a positive j) returns a suffix of s with length i.
 *
 * If, after the translation of negative indices, i is less than 1, it is corrected to 1. If j is greater than
 * the string length, it is corrected to that length. If, after these corrections, i is greater than j,
 * the function returns the empty string.
 */ function $e0e1ecd360f89547$var$sub(s, i = 1, j = -1) {
    const S = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "sub", 1);
    let start = (0, $67f923318f75be7d$export$b6dbfe34ed7ccb32)((0, $67f923318f75be7d$export$a10e5668227c81bc)(i, "sub", 2), S.length);
    let end = (0, $67f923318f75be7d$export$b6dbfe34ed7ccb32)((0, $67f923318f75be7d$export$a10e5668227c81bc)(j, "sub", 3), S.length);
    if (start < 1) start = 1;
    if (end > S.length) end = S.length;
    if (start <= end) return S.substr(start - 1, end - start + 1);
    return "";
}
/**
 * Receives a string and returns a copy of this string with all lowercase letters changed to uppercase.
 * All other characters are left unchanged.
 * The definition of what a lowercase letter is depends on the current locale.
 */ function $e0e1ecd360f89547$var$upper(s) {
    const S = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(s, "upper", 1);
    return S.toUpperCase();
}
const $e0e1ecd360f89547$export$35bd0f919b4eb16d = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
    byte: $e0e1ecd360f89547$var$byte,
    char: $e0e1ecd360f89547$var$char,
    find: $e0e1ecd360f89547$var$find,
    format: $e0e1ecd360f89547$var$format,
    gmatch: $e0e1ecd360f89547$var$gmatch,
    gsub: $e0e1ecd360f89547$var$gsub,
    len: $e0e1ecd360f89547$var$len,
    lower: $e0e1ecd360f89547$var$lower,
    match: $e0e1ecd360f89547$var$match,
    rep: $e0e1ecd360f89547$var$rep,
    reverse: $e0e1ecd360f89547$var$reverse,
    sub: $e0e1ecd360f89547$var$sub,
    upper: $e0e1ecd360f89547$var$upper
});
const $e0e1ecd360f89547$export$ad73a8836d423aa6 = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
    __index: $e0e1ecd360f89547$export$35bd0f919b4eb16d
});


const $2f63b9a9012fe169$var$CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $2f63b9a9012fe169$var$ipairsIterator(table, index) {
    if (index === undefined) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("Bad argument #2 to ipairs() iterator");
    const nextIndex = index + 1;
    const numValues = table.numValues;
    if (!numValues[nextIndex] || numValues[nextIndex] === undefined) return undefined;
    return [
        nextIndex,
        numValues[nextIndex]
    ];
}
const $2f63b9a9012fe169$var$_VERSION = "Lua 5.3";
function $2f63b9a9012fe169$var$assert(v, m) {
    if ((0, $67f923318f75be7d$export$4b720ee0f8ec719c)(v)) return [
        v,
        m
    ];
    const msg = m === undefined ? "Assertion failed!" : (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(m, "assert", 2);
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(msg);
}
function $2f63b9a9012fe169$var$collectgarbage() {
    // noop
    return [];
}
function $2f63b9a9012fe169$var$error(message) {
    const msg = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(message, "error", 1);
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(msg);
}
/**
 * If object does not have a metatable, returns nil.
 * Otherwise, if the object's metatable has a __metatable field, returns the associated value.
 * Otherwise, returns the metatable of the given object.
 */ function $2f63b9a9012fe169$var$getmetatable(table) {
    if (table instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && table.metatable) {
        const mm = table.metatable.rawget("__metatable");
        return mm ? mm : table.metatable;
    }
    if (typeof table === "string") return 0, $e0e1ecd360f89547$export$ad73a8836d423aa6;
}
/**
 * Returns three values (an iterator function, the table t, and 0) so that the construction
 *
 *      `for i,v in ipairs(t) do body end`
 *
 * will iterate over the key–value pairs (1,t[1]), (2,t[2]), ..., up to the first nil value.
 */ function $2f63b9a9012fe169$var$ipairs(t) {
    const table = (0, $67f923318f75be7d$export$811af271c077e9d6)(t, "ipairs", 1);
    const mm = table.getMetaMethod("__pairs") || table.getMetaMethod("__ipairs");
    return mm ? mm(table).slice(0, 3) : [
        $2f63b9a9012fe169$var$ipairsIterator,
        table,
        0
    ];
}
/**
 * Allows a program to traverse all fields of a table.
 * Its first argument is a table and its second argument is an index in this table.
 * next returns the next index of the table and its associated value.
 * When called with nil as its second argument, next returns an initial index and its associated value.
 * When called with the last index, or with nil in an empty table, next returns nil.
 * If the second argument is absent, then it is interpreted as nil.
 * In particular, you can use next(t) to check whether a table is empty.
 *
 * The order in which the indices are enumerated is not specified, even for numeric indices.
 * (To traverse a table in numerical order, use a numerical for.)
 *
 * The behavior of next is undefined if, during the traversal, you assign any value to a non-existent field in the table.
 * You may however modify existing fields. In particular, you may clear existing fields.
 */ function $2f63b9a9012fe169$var$next(table, index) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "next", 1);
    // SLOOOOOOOW...
    let found = index === undefined;
    if (found || typeof index === "number" && index > 0) {
        const numValues = TABLE.numValues;
        const keys = Object.keys(numValues);
        let i = 1;
        if (!found) {
            const I = keys.indexOf(`${index}`);
            if (I >= 0) {
                found = true;
                i += I;
            }
        }
        if (found) for(i; keys[i] !== undefined; i++){
            const key = Number(keys[i]);
            const value = numValues[key];
            if (value !== undefined) return [
                key,
                value
            ];
        }
    }
    for(const i in TABLE.strValues)if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)(TABLE.strValues, i)) {
        if (!found) {
            if (i === index) found = true;
        } else if (TABLE.strValues[i] !== undefined) return [
            i,
            TABLE.strValues[i]
        ];
    }
    for(const i in TABLE.keys)if ((0, $67f923318f75be7d$export$5a15a386532a5ea4)(TABLE.keys, i)) {
        const key = TABLE.keys[i];
        if (!found) {
            if (key === index) found = true;
        } else if (TABLE.values[i] !== undefined) return [
            key,
            TABLE.values[i]
        ];
    }
}
/**
 * If t has a metamethod __pairs, calls it with t as argument and returns the first three results from the call.
 *
 * Otherwise, returns three values: the next function, the table t, and nil, so that the construction
 *
 *      `for k,v in pairs(t) do body end`
 *
 * will iterate over all key–value pairs of table t.
 *
 * See function next for the caveats of modifying the table during its traversal.
 */ function $2f63b9a9012fe169$var$pairs(t) {
    const table = (0, $67f923318f75be7d$export$811af271c077e9d6)(t, "pairs", 1);
    const mm = table.getMetaMethod("__pairs");
    return mm ? mm(table).slice(0, 3) : [
        $2f63b9a9012fe169$var$next,
        table,
        undefined
    ];
}
/**
 * Calls function f with the given arguments in protected mode.
 * This means that any error inside f is not propagated;
 * instead, pcall catches the error and returns a status code.
 * Its first result is the status code (a boolean), which is true if the call succeeds without errors.
 * In such case, pcall also returns all results from the call, after this first result.
 * In case of any error, pcall returns false plus the error message.
 */ function $2f63b9a9012fe169$var$pcall(f, ...args) {
    if (typeof f !== "function") throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("Attempt to call non-function");
    try {
        return [
            true,
            ...f(...args)
        ];
    } catch (e) {
        return [
            false,
            e && e.toString()
        ];
    }
}
/**
 * Checks whether v1 is equal to v2, without invoking the __eq metamethod. Returns a boolean.
 */ function $2f63b9a9012fe169$var$rawequal(v1, v2) {
    return v1 === v2;
}
/**
 * Gets the real value of table[index], without invoking the __index metamethod.
 * table must be a table; index may be any value.
 */ function $2f63b9a9012fe169$var$rawget(table, index) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "rawget", 1);
    return TABLE.rawget(index);
}
/**
 * Returns the length of the object v, which must be a table or a string, without invoking the __len metamethod.
 * Returns an integer.
 */ function $2f63b9a9012fe169$var$rawlen(v) {
    if (v instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)) return v.getn();
    if (typeof v === "string") return v.length;
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("attempt to get length of an unsupported value");
}
/**
 * Sets the real value of table[index] to value, without invoking the __newindex metamethod.
 * table must be a table, index any value different from nil and NaN, and value any Lua value.
 *
 * This function returns table.
 */ function $2f63b9a9012fe169$var$rawset(table, index, value) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "rawset", 1);
    if (index === undefined) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("table index is nil");
    TABLE.rawset(index, value);
    return TABLE;
}
/**
 * If index is a number, returns all arguments after argument number index;
 * a negative number indexes from the end (-1 is the last argument).
 * Otherwise, index must be the string "#", and select returns the total number of extra arguments it received.
 */ function $2f63b9a9012fe169$var$select(index, ...args) {
    if (index === "#") return args.length;
    if (typeof index === "number") {
        const pos = (0, $67f923318f75be7d$export$b6dbfe34ed7ccb32)(Math.trunc(index), args.length);
        return args.slice(pos - 1);
    }
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`bad argument #1 to 'select' (number expected, got ${(0, $67f923318f75be7d$export$bf9fb029d174d554)(index)})`);
}
/**
 * Sets the metatable for the given table.
 * (To change the metatable of other types from Lua code,you must use the debug library (§6.10).)
 * If metatable is nil, removes the metatable of the given table.
 * If the original metatable has a __metatable field, raises an error.
 *
 * This function returns table.
 */ function $2f63b9a9012fe169$var$setmetatable(table, metatable) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "setmetatable", 1);
    if (TABLE.metatable && TABLE.metatable.rawget("__metatable")) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("cannot change a protected metatable");
    TABLE.metatable = (0, $67f923318f75be7d$export$811af271c077e9d6)(metatable, "setmetatable", 2);
    return TABLE;
}
/**
 * When called with no base, tonumber tries to convert its argument to a number.
 * If the argument is already a number or a string convertible to a number,
 * then tonumber returns this number; otherwise, it returns nil.
 *
 * The conversion of strings can result in integers or floats,
 * according to the lexical conventions of Lua (see §3.1).
 * (The string may have leading and trailing spaces and a sign.)
 *
 * When called with base, then e must be a string to be interpreted as an integer numeral in that base.
 * The base may be any integer between 2 and 36, inclusive.
 * In bases above 10, the letter 'A' (in either upper or lower case) represents 10,
 * 'B' represents 11, and so forth, with 'Z' representing 35.
 * If the string e is not a valid numeral in the given base, the function returns nil.
 */ function $2f63b9a9012fe169$var$tonumber(e, base) {
    const E = (0, $67f923318f75be7d$export$c75e8fe1cada7bf)(e).trim();
    const BASE = base === undefined ? 10 : (0, $67f923318f75be7d$export$a10e5668227c81bc)(base, "tonumber", 2);
    if (BASE !== 10 && E === "nil") throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("bad argument #1 to 'tonumber' (string expected, got nil)");
    if (BASE < 2 || BASE > 36) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`bad argument #2 to 'tonumber' (base out of range)`);
    if (E === "") return;
    if (BASE === 10) return (0, $67f923318f75be7d$export$7de25fcdfb94b938)(E);
    const pattern = new RegExp(`^${BASE === 16 ? "(0x)?" : ""}[${$2f63b9a9012fe169$var$CHARS.substr(0, BASE)}]*$`, "gi");
    if (!pattern.test(E)) return; // Invalid
    return parseInt(E, BASE);
}
/**
 * This function is similar to pcall, except that it sets a new message handler msgh.
 */ function $2f63b9a9012fe169$var$xpcall(f, msgh, ...args) {
    if (typeof f !== "function" || typeof msgh !== "function") throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("Attempt to call non-function");
    try {
        return [
            true,
            ...f(...args)
        ];
    } catch (e) {
        return [
            false,
            msgh(e)[0]
        ];
    }
}
function $2f63b9a9012fe169$export$568b7bcf0c752cad(cfg, execChunk) {
    function print(...args) {
        const output = args.map((arg)=>(0, $67f923318f75be7d$export$2d61a1c0fd545922)(arg)).join("	");
        cfg.stdout(output);
    }
    function load(chunk, _chunkname, _mode, env) {
        let C = "";
        if (chunk instanceof Function) {
            let ret = " ";
            while(ret !== "" && ret !== undefined){
                C += ret;
                ret = chunk()[0];
            }
        } else C = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(chunk, "load", 1);
        let parsed;
        try {
            parsed = (0, $10a22d21a5252b59$export$98e6a39c04603d36)(C);
        } catch (e) {
            return [
                undefined,
                e.message
            ];
        }
        return ()=>execChunk(env || _G, parsed);
    }
    function dofile(filename) {
        const res = loadfile(filename);
        if (Array.isArray(res) && res[0] === undefined) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(res[1]);
        const exec = res;
        return exec();
    }
    function loadfile(filename, mode, env) {
        const FILENAME = filename === undefined ? cfg.stdin : (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(filename, "loadfile", 1);
        if (!cfg.fileExists) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("loadfile requires the config.fileExists function");
        if (!cfg.fileExists(FILENAME)) return [
            undefined,
            "file not found"
        ];
        if (!cfg.loadFile) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("loadfile requires the config.loadFile function");
        return load(cfg.loadFile(FILENAME), FILENAME, mode, env);
    }
    const _G = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
        _VERSION: $2f63b9a9012fe169$var$_VERSION,
        assert: $2f63b9a9012fe169$var$assert,
        dofile: dofile,
        collectgarbage: $2f63b9a9012fe169$var$collectgarbage,
        error: $2f63b9a9012fe169$var$error,
        getmetatable: $2f63b9a9012fe169$var$getmetatable,
        ipairs: $2f63b9a9012fe169$var$ipairs,
        load: load,
        loadfile: loadfile,
        next: $2f63b9a9012fe169$var$next,
        pairs: $2f63b9a9012fe169$var$pairs,
        pcall: $2f63b9a9012fe169$var$pcall,
        print: print,
        rawequal: $2f63b9a9012fe169$var$rawequal,
        rawget: $2f63b9a9012fe169$var$rawget,
        rawlen: $2f63b9a9012fe169$var$rawlen,
        rawset: $2f63b9a9012fe169$var$rawset,
        select: $2f63b9a9012fe169$var$select,
        setmetatable: $2f63b9a9012fe169$var$setmetatable,
        tonumber: $2f63b9a9012fe169$var$tonumber,
        tostring: $67f923318f75be7d$export$2d61a1c0fd545922,
        type: $67f923318f75be7d$export$bf9fb029d174d554,
        xpcall: $2f63b9a9012fe169$var$xpcall
    });
    return _G;
}





const $3e246d7fed0ae91c$var$binaryArithmetic = (left, right, metaMethodName, callback)=>{
    const mm = left instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && left.getMetaMethod(metaMethodName) || right instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && right.getMetaMethod(metaMethodName);
    if (mm) return mm(left, right)[0];
    const L = (0, $67f923318f75be7d$export$7de25fcdfb94b938)(left, "attempt to perform arithmetic on a %type value");
    const R = (0, $67f923318f75be7d$export$7de25fcdfb94b938)(right, "attempt to perform arithmetic on a %type value");
    return callback(L, R);
};
const $3e246d7fed0ae91c$var$binaryBooleanArithmetic = (left, right, metaMethodName, callback)=>{
    if (typeof left === "string" && typeof right === "string" || typeof left === "number" && typeof right === "number") return callback(left, right);
    return $3e246d7fed0ae91c$var$binaryArithmetic(left, right, metaMethodName, callback);
};
// extra
const $3e246d7fed0ae91c$var$bool = (value)=>(0, $67f923318f75be7d$export$4b720ee0f8ec719c)(value);
// unary
const $3e246d7fed0ae91c$var$not = (value)=>!$3e246d7fed0ae91c$var$bool(value);
const $3e246d7fed0ae91c$var$unm = (value)=>{
    const mm = value instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && value.getMetaMethod("__unm");
    if (mm) return mm(value)[0];
    return -1 * (0, $67f923318f75be7d$export$7de25fcdfb94b938)(value, "attempt to perform arithmetic on a %type value");
};
const $3e246d7fed0ae91c$var$bnot = (value)=>{
    const mm = value instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && value.getMetaMethod("__bnot");
    if (mm) return mm(value)[0];
    return ~(0, $67f923318f75be7d$export$7de25fcdfb94b938)(value, "attempt to perform arithmetic on a %type value");
};
const $3e246d7fed0ae91c$var$len = (value)=>{
    if (value instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)) {
        const mm = value.getMetaMethod("__len");
        if (mm) return mm(value)[0];
        return value.getn();
    }
    if (typeof value === "string") return value.length;
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("attempt to get length of an unsupported value");
// if (typeof value === 'object') {
//     let length = 0
//     for (const key in value) {
//         if (hasOwnProperty(value, key)) {
//             length += 1
//         }
//     }
//     return length
// }
};
// binary
const $3e246d7fed0ae91c$var$add = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__add", (l, r)=>l + r);
const $3e246d7fed0ae91c$var$sub = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__sub", (l, r)=>l - r);
const $3e246d7fed0ae91c$var$mul = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__mul", (l, r)=>l * r);
const $3e246d7fed0ae91c$var$mod = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__mod", (l, r)=>{
        if (r === 0 || r === -Infinity || r === Infinity || isNaN(l) || isNaN(r)) return NaN;
        const absR = Math.abs(r);
        let result = Math.abs(l) % absR;
        if (l * r < 0) result = absR - result;
        if (r < 0) result *= -1;
        return result;
    });
const $3e246d7fed0ae91c$var$pow = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__pow", Math.pow);
const $3e246d7fed0ae91c$var$div = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__div", (l, r)=>{
        if (r === undefined) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("attempt to perform arithmetic on a nil value");
        return l / r;
    });
const $3e246d7fed0ae91c$var$idiv = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__idiv", (l, r)=>{
        if (r === undefined) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("attempt to perform arithmetic on a nil value");
        return Math.floor(l / r);
    });
const $3e246d7fed0ae91c$var$band = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__band", (l, r)=>l & r);
const $3e246d7fed0ae91c$var$bor = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__bor", (l, r)=>l | r);
const $3e246d7fed0ae91c$var$bxor = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__bxor", (l, r)=>l ^ r);
const $3e246d7fed0ae91c$var$shl = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__shl", (l, r)=>l << r);
const $3e246d7fed0ae91c$var$shr = (left, right)=>$3e246d7fed0ae91c$var$binaryArithmetic(left, right, "__shr", (l, r)=>l >> r);
const $3e246d7fed0ae91c$var$concat = (left, right)=>{
    const mm = left instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && left.getMetaMethod("__concat") || right instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && right.getMetaMethod("__concat");
    if (mm) return mm(left, right)[0];
    const L = (0, $67f923318f75be7d$export$c75e8fe1cada7bf)(left, "attempt to concatenate a %type value");
    const R = (0, $67f923318f75be7d$export$c75e8fe1cada7bf)(right, "attempt to concatenate a %type value");
    return `${L}${R}`;
};
const $3e246d7fed0ae91c$var$neq = (left, right)=>!$3e246d7fed0ae91c$var$eq(left, right);
const $3e246d7fed0ae91c$var$eq = (left, right)=>{
    const mm = right !== left && left instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && right instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && left.metatable === right.metatable && left.getMetaMethod("__eq");
    if (mm) return !!mm(left, right)[0];
    return left === right;
};
const $3e246d7fed0ae91c$var$lt = (left, right)=>$3e246d7fed0ae91c$var$binaryBooleanArithmetic(left, right, "__lt", (l, r)=>l < r);
const $3e246d7fed0ae91c$var$le = (left, right)=>$3e246d7fed0ae91c$var$binaryBooleanArithmetic(left, right, "__le", (l, r)=>l <= r);
const $3e246d7fed0ae91c$var$gt = (left, right)=>!$3e246d7fed0ae91c$var$le(left, right);
const $3e246d7fed0ae91c$var$ge = (left, right)=>!$3e246d7fed0ae91c$var$lt(left, right);
const $3e246d7fed0ae91c$export$ccbce4efa7f8029b = {
    bool: $3e246d7fed0ae91c$var$bool,
    not: $3e246d7fed0ae91c$var$not,
    unm: $3e246d7fed0ae91c$var$unm,
    bnot: $3e246d7fed0ae91c$var$bnot,
    len: $3e246d7fed0ae91c$var$len,
    add: $3e246d7fed0ae91c$var$add,
    sub: $3e246d7fed0ae91c$var$sub,
    mul: $3e246d7fed0ae91c$var$mul,
    mod: $3e246d7fed0ae91c$var$mod,
    pow: $3e246d7fed0ae91c$var$pow,
    div: $3e246d7fed0ae91c$var$div,
    idiv: $3e246d7fed0ae91c$var$idiv,
    band: $3e246d7fed0ae91c$var$band,
    bor: $3e246d7fed0ae91c$var$bor,
    bxor: $3e246d7fed0ae91c$var$bxor,
    shl: $3e246d7fed0ae91c$var$shl,
    shr: $3e246d7fed0ae91c$var$shr,
    concat: $3e246d7fed0ae91c$var$concat,
    neq: $3e246d7fed0ae91c$var$neq,
    eq: $3e246d7fed0ae91c$var$eq,
    lt: $3e246d7fed0ae91c$var$lt,
    le: $3e246d7fed0ae91c$var$le,
    gt: $3e246d7fed0ae91c$var$gt,
    ge: $3e246d7fed0ae91c$var$ge
};






const $06e864c20f2cf7c2$var$maxinteger = Number.MAX_SAFE_INTEGER;
const $06e864c20f2cf7c2$var$mininteger = Number.MIN_SAFE_INTEGER;
const $06e864c20f2cf7c2$var$huge = Infinity;
const $06e864c20f2cf7c2$var$pi = Math.PI;
let $06e864c20f2cf7c2$var$randomSeed = 1;
function $06e864c20f2cf7c2$var$getRandom() {
    $06e864c20f2cf7c2$var$randomSeed = 16807 * $06e864c20f2cf7c2$var$randomSeed % 2147483647;
    return $06e864c20f2cf7c2$var$randomSeed / 2147483647;
}
function $06e864c20f2cf7c2$var$abs(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "abs", 1);
    return Math.abs(X);
}
function $06e864c20f2cf7c2$var$acos(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "acos", 1);
    return Math.acos(X);
}
function $06e864c20f2cf7c2$var$asin(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "asin", 1);
    return Math.asin(X);
}
function $06e864c20f2cf7c2$var$atan(y, x) {
    const Y = (0, $67f923318f75be7d$export$a10e5668227c81bc)(y, "atan", 1);
    const X = x === undefined ? 1 : (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "atan", 2);
    return Math.atan2(Y, X);
}
function $06e864c20f2cf7c2$var$atan2(y, x) {
    return $06e864c20f2cf7c2$var$atan(y, x);
}
function $06e864c20f2cf7c2$var$ceil(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "ceil", 1);
    return Math.ceil(X);
}
function $06e864c20f2cf7c2$var$cos(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "cos", 1);
    return Math.cos(X);
}
function $06e864c20f2cf7c2$var$cosh(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "cosh", 1);
    return ($06e864c20f2cf7c2$var$exp(X) + $06e864c20f2cf7c2$var$exp(-X)) / 2;
}
function $06e864c20f2cf7c2$var$deg(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "deg", 1);
    return X * 180 / Math.PI;
}
function $06e864c20f2cf7c2$var$exp(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "exp", 1);
    return Math.exp(X);
}
function $06e864c20f2cf7c2$var$floor(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "floor", 1);
    return Math.floor(X);
}
function $06e864c20f2cf7c2$var$fmod(x, y) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "fmod", 1);
    const Y = (0, $67f923318f75be7d$export$a10e5668227c81bc)(y, "fmod", 2);
    return X % Y;
}
function $06e864c20f2cf7c2$var$frexp(x) {
    let X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "frexp", 1);
    if (X === 0) return [
        0,
        0
    ];
    const delta = X > 0 ? 1 : -1;
    X *= delta;
    const exponent = Math.floor(Math.log(X) / Math.log(2)) + 1;
    const mantissa = X / Math.pow(2, exponent);
    return [
        mantissa * delta,
        exponent
    ];
}
function $06e864c20f2cf7c2$var$ldexp(m, e) {
    const M = (0, $67f923318f75be7d$export$a10e5668227c81bc)(m, "ldexp", 1);
    const E = (0, $67f923318f75be7d$export$a10e5668227c81bc)(e, "ldexp", 2);
    return M * Math.pow(2, E);
}
function $06e864c20f2cf7c2$var$log(x, base) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "log", 1);
    if (base === undefined) return Math.log(X);
    else {
        const B = (0, $67f923318f75be7d$export$a10e5668227c81bc)(base, "log", 2);
        return Math.log(X) / Math.log(B);
    }
}
function $06e864c20f2cf7c2$var$log10(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "log10", 1);
    // v5.2: warn ('math.log10 is deprecated. Use math.log with 10 as its second argument instead.');
    return Math.log(X) / Math.log(10);
}
function $06e864c20f2cf7c2$var$max(...args) {
    const ARGS = args.map((n, i)=>(0, $67f923318f75be7d$export$a10e5668227c81bc)(n, "max", i + 1));
    return Math.max(...ARGS);
}
function $06e864c20f2cf7c2$var$min(...args) {
    const ARGS = args.map((n, i)=>(0, $67f923318f75be7d$export$a10e5668227c81bc)(n, "min", i + 1));
    return Math.min(...ARGS);
}
function $06e864c20f2cf7c2$var$modf(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "modf", 1);
    const intValue = Math.floor(X);
    const mantissa = X - intValue;
    return [
        intValue,
        mantissa
    ];
}
function $06e864c20f2cf7c2$var$pow(x, y) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "pow", 1);
    const Y = (0, $67f923318f75be7d$export$a10e5668227c81bc)(y, "pow", 2);
    return Math.pow(X, Y);
}
function $06e864c20f2cf7c2$var$rad(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "rad", 1);
    return Math.PI / 180 * X;
}
function $06e864c20f2cf7c2$var$random(min, max) {
    if (min === undefined && max === undefined) return $06e864c20f2cf7c2$var$getRandom();
    const firstArg = (0, $67f923318f75be7d$export$a10e5668227c81bc)(min, "random", 1);
    const MIN = max === undefined ? firstArg : 1;
    const MAX = max === undefined ? (0, $67f923318f75be7d$export$a10e5668227c81bc)(max, "random", 2) : firstArg;
    if (MIN > MAX) throw new Error("bad argument #2 to 'random' (interval is empty)");
    return Math.floor($06e864c20f2cf7c2$var$getRandom() * (MAX - MIN + 1) + MIN);
}
function $06e864c20f2cf7c2$var$randomseed(x) {
    $06e864c20f2cf7c2$var$randomSeed = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "randomseed", 1);
}
function $06e864c20f2cf7c2$var$sin(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "sin", 1);
    return Math.sin(X);
}
function $06e864c20f2cf7c2$var$sinh(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "sinh", 1);
    return ($06e864c20f2cf7c2$var$exp(X) - $06e864c20f2cf7c2$var$exp(-X)) / 2;
}
function $06e864c20f2cf7c2$var$sqrt(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "sqrt", 1);
    return Math.sqrt(X);
}
function $06e864c20f2cf7c2$var$tan(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "tan", 1);
    return Math.tan(X);
}
function $06e864c20f2cf7c2$var$tanh(x) {
    const X = (0, $67f923318f75be7d$export$a10e5668227c81bc)(x, "tanh", 1);
    return ($06e864c20f2cf7c2$var$exp(X) - $06e864c20f2cf7c2$var$exp(-X)) / ($06e864c20f2cf7c2$var$exp(X) + $06e864c20f2cf7c2$var$exp(-X));
}
function $06e864c20f2cf7c2$var$tointeger(x) {
    const X = (0, $67f923318f75be7d$export$7de25fcdfb94b938)(x);
    if (X === undefined) return undefined;
    return Math.floor(X);
}
function $06e864c20f2cf7c2$var$type(x) {
    const X = (0, $67f923318f75be7d$export$7de25fcdfb94b938)(x);
    if (X === undefined) return undefined;
    if ($06e864c20f2cf7c2$var$tointeger(X) === X) return "integer";
    return "float";
}
function $06e864c20f2cf7c2$var$ult(m, n) {
    const M = (0, $67f923318f75be7d$export$a10e5668227c81bc)(m, "ult", 1);
    const N = (0, $67f923318f75be7d$export$a10e5668227c81bc)(n, "ult", 2);
    const toUnsigned = (n)=>n >>> 0;
    return toUnsigned(M) < toUnsigned(N);
}
const $06e864c20f2cf7c2$export$d0a8b3fae6b123bf = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
    abs: $06e864c20f2cf7c2$var$abs,
    acos: $06e864c20f2cf7c2$var$acos,
    asin: $06e864c20f2cf7c2$var$asin,
    atan: $06e864c20f2cf7c2$var$atan,
    atan2: $06e864c20f2cf7c2$var$atan2,
    ceil: $06e864c20f2cf7c2$var$ceil,
    cos: $06e864c20f2cf7c2$var$cos,
    cosh: $06e864c20f2cf7c2$var$cosh,
    deg: $06e864c20f2cf7c2$var$deg,
    exp: $06e864c20f2cf7c2$var$exp,
    floor: $06e864c20f2cf7c2$var$floor,
    fmod: $06e864c20f2cf7c2$var$fmod,
    frexp: $06e864c20f2cf7c2$var$frexp,
    huge: $06e864c20f2cf7c2$var$huge,
    ldexp: $06e864c20f2cf7c2$var$ldexp,
    log: $06e864c20f2cf7c2$var$log,
    log10: $06e864c20f2cf7c2$var$log10,
    max: $06e864c20f2cf7c2$var$max,
    min: $06e864c20f2cf7c2$var$min,
    maxinteger: $06e864c20f2cf7c2$var$maxinteger,
    mininteger: $06e864c20f2cf7c2$var$mininteger,
    modf: $06e864c20f2cf7c2$var$modf,
    pi: $06e864c20f2cf7c2$var$pi,
    pow: $06e864c20f2cf7c2$var$pow,
    rad: $06e864c20f2cf7c2$var$rad,
    random: $06e864c20f2cf7c2$var$random,
    randomseed: $06e864c20f2cf7c2$var$randomseed,
    sin: $06e864c20f2cf7c2$var$sin,
    sinh: $06e864c20f2cf7c2$var$sinh,
    sqrt: $06e864c20f2cf7c2$var$sqrt,
    tan: $06e864c20f2cf7c2$var$tan,
    tanh: $06e864c20f2cf7c2$var$tanh,
    tointeger: $06e864c20f2cf7c2$var$tointeger,
    type: $06e864c20f2cf7c2$var$type,
    ult: $06e864c20f2cf7c2$var$ult
});





function $83fa037f17d6e90c$var$getn(table) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "getn", 1);
    return TABLE.getn();
}
/**
 * Given a list where all elements are strings or numbers, returns the string list[i]..sep..list[i+1] ··· sep..list[j].
 * The default value for sep is the empty string, the default for i is 1, and the default for j is #list.
 * If i is greater than j, returns the empty string.
 */ function $83fa037f17d6e90c$var$concat(table, sep = "", i = 1, j) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "concat", 1);
    const SEP = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(sep, "concat", 2);
    const I = (0, $67f923318f75be7d$export$a10e5668227c81bc)(i, "concat", 3);
    const J = j === undefined ? $83fa037f17d6e90c$var$maxn(TABLE) : (0, $67f923318f75be7d$export$a10e5668227c81bc)(j, "concat", 4);
    return [].concat(TABLE.numValues).splice(I, J - I + 1).join(SEP);
}
/**
 * Inserts element value at position pos in list, shifting up the elements list[pos], list[pos+1], ···, list[#list].
 * The default value for pos is #list+1, so that a call table.insert(t,x) inserts x at the end of list t.
 */ function $83fa037f17d6e90c$var$insert(table, pos, value) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "insert", 1);
    const POS = value === undefined ? TABLE.numValues.length : (0, $67f923318f75be7d$export$a10e5668227c81bc)(pos, "insert", 2);
    const VALUE = value === undefined ? pos : value;
    TABLE.numValues.splice(POS, 0, undefined);
    TABLE.set(POS, VALUE);
}
function $83fa037f17d6e90c$var$maxn(table) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "maxn", 1);
    return TABLE.numValues.length - 1;
}
/**
 * Moves elements from table a1 to table a2, performing the equivalent to the following multiple assignment:
 *
 *      `a2[t],··· = a1[f],···,a1[e].`
 *
 * The default for a2 is a1.
 * The destination range can overlap with the source range.
 * The number of elements to be moved must fit in a Lua integer.
 *
 * Returns the destination table a2.
 */ function $83fa037f17d6e90c$var$move(a1, f, e, t, a2) {
    const A1 = (0, $67f923318f75be7d$export$811af271c077e9d6)(a1, "move", 1);
    const F = (0, $67f923318f75be7d$export$a10e5668227c81bc)(f, "move", 2);
    const E = (0, $67f923318f75be7d$export$a10e5668227c81bc)(e, "move", 3);
    const T = (0, $67f923318f75be7d$export$a10e5668227c81bc)(t, "move", 4);
    const A2 = a2 === undefined ? A1 : (0, $67f923318f75be7d$export$811af271c077e9d6)(a2, "move", 5);
    if (E >= F) {
        if (F <= 0 && E >= Number.MAX_SAFE_INTEGER + F) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("too many elements to move");
        const n = E - F + 1 // number of elements to movea
        ;
        if (T > Number.MAX_SAFE_INTEGER - n + 1) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("destination wrap around");
        if (T > E || T <= F || A2 !== A1) for(let i = 0; i < n; i++){
            const v = A1.get(F + i);
            A2.set(T + i, v);
        }
        else for(let i = n - 1; i >= 0; i--){
            const v = A1.get(F + i);
            A2.set(T + i, v);
        }
    }
    return A2;
}
/**
 * Returns a new table with all arguments stored into keys 1, 2, etc. and with a field "n" with the total number of arguments.
 * Note that the resulting table may not be a sequence.
 */ function $83fa037f17d6e90c$var$pack(...args) {
    const table = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)(args);
    table.rawset("n", args.length);
    return table;
}
/**
 * Removes from list the element at position pos, returning the value of the removed element.
 * When pos is an integer between 1 and #list, it shifts down the elements list[pos+1], list[pos+2], ···, list[#list] and
 * erases element list[#list]; The index pos can also be 0 when #list is 0, or #list + 1;
 * in those cases, the function erases the element list[pos].
 *
 * The default value for pos is #list, so that a call table.remove(l) removes the last element of list l.
 */ function $83fa037f17d6e90c$var$remove(table, pos) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "remove", 1);
    const max = TABLE.getn();
    const POS = pos === undefined ? max : (0, $67f923318f75be7d$export$a10e5668227c81bc)(pos, "remove", 2);
    if (POS > max || POS < 0) return;
    const vals = TABLE.numValues;
    const result = vals.splice(POS, 1)[0];
    let i = POS;
    while(i < max && vals[i] === undefined){
        delete vals[i];
        i += 1;
    }
    return result;
}
/**
 * Sorts list elements in a given order, in-place, from list[1] to list[#list].
 * If comp is given, then it must be a function that receives two list elements and
 * returns true when the first element must come before the second in the final order
 * (so that, after the sort, i < j implies not comp(list[j],list[i])).
 * If comp is not given, then the standard Lua operator < is used instead.
 *
 * Note that the comp function must define a strict partial order over the elements in the list;
 * that is, it must be asymmetric and transitive. Otherwise, no valid sort may be possible.
 *
 * The sort algorithm is not stable: elements considered equal by the given order may have
 * their relative positions changed by the sort.
 */ function $83fa037f17d6e90c$var$sort(table, comp) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "sort", 1);
    let sortFunc;
    if (comp) {
        const COMP = (0, $67f923318f75be7d$export$f89c54311c4679e9)(comp, "sort", 2);
        sortFunc = (a, b)=>(0, $67f923318f75be7d$export$4b720ee0f8ec719c)(COMP(a, b)[0]) ? -1 : 1;
    } else sortFunc = (a, b)=>a < b ? -1 : 1;
    const arr = TABLE.numValues;
    arr.shift();
    arr.sort(sortFunc).unshift(undefined);
}
/**
 * Returns the elements from the given list. This function is equivalent to
 *
 *      `return list[i], list[i+1], ···, list[j]`
 *
 * By default, i is 1 and j is #list.
 */ function $83fa037f17d6e90c$var$unpack(table, i, j) {
    const TABLE = (0, $67f923318f75be7d$export$811af271c077e9d6)(table, "unpack", 1);
    const I = i === undefined ? 1 : (0, $67f923318f75be7d$export$a10e5668227c81bc)(i, "unpack", 2);
    const J = j === undefined ? TABLE.getn() : (0, $67f923318f75be7d$export$a10e5668227c81bc)(j, "unpack", 3);
    return TABLE.numValues.slice(I, J + 1);
}
const $83fa037f17d6e90c$export$910a1f609f6ccfa1 = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
    getn: $83fa037f17d6e90c$var$getn,
    concat: $83fa037f17d6e90c$var$concat,
    insert: $83fa037f17d6e90c$var$insert,
    maxn: $83fa037f17d6e90c$var$maxn,
    move: $83fa037f17d6e90c$var$move,
    pack: $83fa037f17d6e90c$var$pack,
    remove: $83fa037f17d6e90c$var$remove,
    sort: $83fa037f17d6e90c$var$sort,
    unpack: $83fa037f17d6e90c$var$unpack
});






const $86d7d76f96171c87$var$DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $86d7d76f96171c87$var$MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $86d7d76f96171c87$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $86d7d76f96171c87$var$DATE_FORMAT_HANDLERS = {
    "%": ()=>"%",
    Y: (date, utc)=>`${utc ? date.getUTCFullYear() : date.getFullYear()}`,
    y: (date, utc)=>$86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.Y(date, utc).substr(-2),
    b: (date, utc)=>$86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.B(date, utc).substr(0, 3),
    B: (date, utc)=>$86d7d76f96171c87$var$MONTHS[utc ? date.getUTCMonth() : date.getMonth()],
    m: (date, utc)=>`0${(utc ? date.getUTCMonth() : date.getMonth()) + 1}`.substr(-2),
    U: (date, utc)=>$86d7d76f96171c87$var$getWeekOfYear(date, 0, utc),
    W: (date, utc)=>$86d7d76f96171c87$var$getWeekOfYear(date, 1, utc),
    j: (date, utc)=>{
        let result = utc ? date.getUTCDate() : date.getDate();
        const month = utc ? date.getUTCMonth() : date.getMonth();
        const year = utc ? date.getUTCFullYear() : date.getFullYear();
        result += $86d7d76f96171c87$var$DAYS_IN_MONTH.slice(0, month).reduce((sum, n)=>sum + n, 0);
        if (month > 1 && year % 4 === 0) result += 1;
        return `00${result}`.substr(-3);
    },
    d: (date, utc)=>`0${utc ? date.getUTCDate() : date.getDate()}`.substr(-2),
    a: (date, utc)=>$86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.A(date, utc).substr(0, 3),
    A: (date, utc)=>$86d7d76f96171c87$var$DAYS[utc ? date.getUTCDay() : date.getDay()],
    w: (date, utc)=>`${utc ? date.getUTCDay() : date.getDay()}`,
    H: (date, utc)=>`0${utc ? date.getUTCHours() : date.getHours()}`.substr(-2),
    I: (date, utc)=>`0${(utc ? date.getUTCHours() : date.getHours()) % 12 || 12}`.substr(-2),
    M: (date, utc)=>`0${utc ? date.getUTCMinutes() : date.getMinutes()}`.substr(-2),
    S: (date, utc)=>`0${utc ? date.getUTCSeconds() : date.getSeconds()}`.substr(-2),
    c: (date, utc)=>date.toLocaleString(undefined, utc ? {
            timeZone: "UTC"
        } : undefined),
    x: (date, utc)=>{
        const m = $86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.m(date, utc);
        const d = $86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.d(date, utc);
        const y = $86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.y(date, utc);
        return `${m}/${d}/${y}`;
    },
    X: (date, utc)=>{
        const h = $86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.H(date, utc);
        const m = $86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.M(date, utc);
        const s = $86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.S(date, utc);
        return `${h}:${m}:${s}`;
    },
    p: (date, utc)=>(utc ? date.getUTCHours() : date.getHours()) < 12 ? "AM" : "PM",
    Z: (date, utc)=>{
        if (utc) return "UTC";
        const match = date.toString().match(/[A-Z][A-Z][A-Z]/);
        return match ? match[0] : "";
    }
};
function $86d7d76f96171c87$var$isDST(date) {
    const year = date.getFullYear();
    const jan = new Date(year, 0);
    // ASSUMPTION: If the time offset of the date is the same as it would be in January of the same year, DST is not in effect.
    return date.getTimezoneOffset() !== jan.getTimezoneOffset();
}
function $86d7d76f96171c87$var$getWeekOfYear(date, firstDay, utc) {
    const dayOfYear = parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.j(date, utc), 10);
    const jan1 = new Date(date.getFullYear(), 0, 1, 12);
    const offset = (8 - (utc ? jan1.getUTCDay() : jan1.getDay()) + firstDay) % 7;
    return `0${Math.floor((dayOfYear - offset) / 7) + 1}`.substr(-2);
}
function $86d7d76f96171c87$var$date(input = "%c", time) {
    const utc = input.substr(0, 1) === "!";
    const string = utc ? input.substr(1) : input;
    const date = new Date();
    if (time) date.setTime(time * 1000);
    if (string === "*t") return new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
        year: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.Y(date, utc), 10),
        month: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.m(date, utc), 10),
        day: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.d(date, utc), 10),
        hour: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.H(date, utc), 10),
        min: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.M(date, utc), 10),
        sec: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.S(date, utc), 10),
        wday: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.w(date, utc), 10) + 1,
        yday: parseInt($86d7d76f96171c87$var$DATE_FORMAT_HANDLERS.j(date, utc), 10),
        isdst: $86d7d76f96171c87$var$isDST(date)
    });
    return string.replace(/%[%YybBmUWjdaAwHIMScxXpZ]/g, (f)=>$86d7d76f96171c87$var$DATE_FORMAT_HANDLERS[f[1]](date, utc));
}
function $86d7d76f96171c87$var$setlocale(locale = "C") {
    if (locale === "C") return "C";
// TODO: implement fully
}
function $86d7d76f96171c87$var$time(table) {
    let now = Math.round(Date.now() / 1000);
    if (!table) return now;
    const year = table.rawget("year");
    const month = table.rawget("month");
    const day = table.rawget("day");
    const hour = table.rawget("hour") || 12;
    const min = table.rawget("min");
    const sec = table.rawget("sec");
    // const isdst = table.rawget('isdst') as boolean
    if (year) now += year * 31557600;
    if (month) now += month * 2629800;
    if (day) now += day * 86400;
    if (hour) now += hour * 3600;
    if (min) now += min * 60;
    if (sec) now += sec;
    return now;
}
function $86d7d76f96171c87$var$difftime(t2, t1) {
    const T2 = (0, $67f923318f75be7d$export$a10e5668227c81bc)(t2, "difftime", 1);
    const T1 = (0, $67f923318f75be7d$export$a10e5668227c81bc)(t1, "difftime", 2);
    return T2 - T1;
}
const $86d7d76f96171c87$export$749e6bd8f9693dfb = (cfg)=>{
    function exit(code) {
        if (!cfg.osExit) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("os.exit requires the config.osExit function");
        let CODE = 0;
        if (typeof code === "boolean" && code === false) CODE = 1;
        else if (typeof code === "number") CODE = code;
        cfg.osExit(CODE);
    }
    return new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
        date: $86d7d76f96171c87$var$date,
        exit: exit,
        setlocale: $86d7d76f96171c87$var$setlocale,
        time: $86d7d76f96171c87$var$time,
        difftime: $86d7d76f96171c87$var$difftime
    });
};





const $3296459aa572b4a9$export$5e23cdf6851f8607 = (execModule, cfg)=>{
    const LUA_DIRSEP = "/";
    const LUA_PATH_SEP = ";";
    const LUA_PATH_MARK = "?";
    const LUA_EXEC_DIR = "!";
    const LUA_IGMARK = "-";
    const LUA_PATH = cfg.LUA_PATH;
    const config = [
        LUA_DIRSEP,
        LUA_PATH_SEP,
        LUA_PATH_MARK,
        LUA_EXEC_DIR,
        LUA_IGMARK
    ].join("\n");
    const loaded = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)();
    const preload = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)();
    const searchpath = (name, path, sep, rep)=>{
        if (!cfg.fileExists) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("package.searchpath requires the config.fileExists function");
        let NAME = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(name, "searchpath", 1);
        const PATH = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(path, "searchpath", 2);
        const SEP = sep === undefined ? "." : (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(sep, "searchpath", 3);
        const REP = rep === undefined ? "/" : (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(rep, "searchpath", 4);
        NAME = NAME.replace(SEP, REP);
        const paths = PATH.split(";").map((template)=>template.replace("?", NAME));
        for (const path of paths){
            if (cfg.fileExists(path)) return path;
        }
        return [
            undefined,
            `The following files don't exist: ${paths.join(" ")}`
        ];
    };
    const searchers = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)([
        (moduleName)=>{
            const res = preload.rawget(moduleName);
            if (res === undefined) return [
                undefined
            ];
            return [
                res
            ];
        },
        (moduleName)=>{
            const res = searchpath(moduleName, libPackage.rawget("path"));
            if (Array.isArray(res) && res[0] === undefined) return [
                res[1]
            ];
            if (!cfg.loadFile) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("package.searchers requires the config.loadFile function");
            return [
                (moduleName, path)=>execModule(cfg.loadFile(path), moduleName),
                res
            ];
        }
    ]);
    function _require(modname) {
        const MODNAME = (0, $67f923318f75be7d$export$4ecf6a6aa59500b5)(modname, "require", 1);
        const module = loaded.rawget(MODNAME);
        if (module) return module;
        const searcherFns = searchers.numValues.filter((fn)=>!!fn);
        for (const searcher of searcherFns){
            const res = searcher(MODNAME);
            if (res[0] !== undefined && typeof res[0] !== "string") {
                const loader = res[0];
                const result = loader(MODNAME, res[1]);
                const module = result === undefined ? true : result;
                loaded.rawset(MODNAME, module);
                return module;
            }
        }
        throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`Module '${MODNAME}' not found!`);
    }
    const libPackage = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)({
        path: LUA_PATH,
        config: config,
        loaded: loaded,
        preload: preload,
        searchers: searchers,
        searchpath: searchpath
    });
    return {
        libPackage: libPackage,
        _require: _require
    };
};




const $2ed1e52b1498d9b2$var$call = (f, ...args)=>{
    if (f instanceof Function) return (0, $67f923318f75be7d$export$d0c8ecbd4ed8940c)(f(...args));
    const mm = f instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d) && f.getMetaMethod("__call");
    if (mm) return (0, $67f923318f75be7d$export$d0c8ecbd4ed8940c)(mm(f, ...args));
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`attempt to call an uncallable type`);
};
const $2ed1e52b1498d9b2$var$stringTable = new (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)();
$2ed1e52b1498d9b2$var$stringTable.metatable = (0, $e0e1ecd360f89547$export$ad73a8836d423aa6);
const $2ed1e52b1498d9b2$var$get = (t, v)=>{
    if (t instanceof (0, $0b8af60ab5d60464$export$54ec01a60f47d33d)) return t.get(v);
    if (typeof t === "string") return $2ed1e52b1498d9b2$var$stringTable.get(v);
    throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)(`no table or metatable found for given type`);
};
const $2ed1e52b1498d9b2$var$execChunk = (_G, chunk, chunkName)=>{
    const exec = new Function("__lua", chunk);
    const globalScope = new (0, $9cd33625fe0b5bcc$export$775b6bb06e53a214)(_G.strValues).extend();
    if (chunkName) globalScope.setVarargs([
        chunkName
    ]);
    const res = exec({
        globalScope: globalScope,
        ...(0, $3e246d7fed0ae91c$export$ccbce4efa7f8029b),
        Table: $0b8af60ab5d60464$export$54ec01a60f47d33d,
        call: $2ed1e52b1498d9b2$var$call,
        get: $2ed1e52b1498d9b2$var$get
    });
    return res === undefined ? [
        undefined
    ] : res;
};
function $2ed1e52b1498d9b2$export$cadeb2d34e317e82(config = {}) {
    const cfg = {
        LUA_PATH: "./?.lua",
        stdin: "",
        stdout: console.log,
        ...config
    };
    const _G = (0, $2f63b9a9012fe169$export$568b7bcf0c752cad)(cfg, $2ed1e52b1498d9b2$var$execChunk);
    const { libPackage: libPackage, _require: _require } = (0, $3296459aa572b4a9$export$5e23cdf6851f8607)((content, moduleName)=>$2ed1e52b1498d9b2$var$execChunk(_G, (0, $10a22d21a5252b59$export$98e6a39c04603d36)(content), moduleName)[0], cfg);
    const loaded = libPackage.get("loaded");
    const loadLib = (name, value)=>{
        _G.rawset(name, value);
        loaded.rawset(name, value);
    };
    loadLib("_G", _G);
    loadLib("package", libPackage);
    loadLib("math", (0, $06e864c20f2cf7c2$export$d0a8b3fae6b123bf));
    loadLib("table", (0, $83fa037f17d6e90c$export$910a1f609f6ccfa1));
    loadLib("string", (0, $e0e1ecd360f89547$export$35bd0f919b4eb16d));
    loadLib("os", (0, $86d7d76f96171c87$export$749e6bd8f9693dfb)(cfg));
    _G.rawset("require", _require);
    const parse = (code)=>{
        const script = (0, $10a22d21a5252b59$export$98e6a39c04603d36)(code);
        return {
            exec: ()=>$2ed1e52b1498d9b2$var$execChunk(_G, script)[0]
        };
    };
    const parseFile = (filename)=>{
        if (!cfg.fileExists) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("parseFile requires the config.fileExists function");
        if (!cfg.loadFile) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("parseFile requires the config.loadFile function");
        if (!cfg.fileExists(filename)) throw new (0, $3495a833b5fe555e$export$e8f1069689b9c900)("file not found");
        return parse(cfg.loadFile(filename));
    };
    return {
        parse: parse,
        parseFile: parseFile,
        loadLib: loadLib
    };
}



var $f1q41 = parcelRequire("f1q41");


const $e8170945d4879225$var$bases = {
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).NORMANDY]: {
        "1": {
            Name: "Saint Pierre du Mont",
            X: -11997.431640625,
            Y: 31.479330062866,
            Z: -46557.78515625
        },
        "2": {
            Name: "Lignerolles",
            X: -35319.11328125,
            Y: 123.42208099365,
            Z: -34889.20703125
        },
        "3": {
            Name: "Cretteville",
            X: -19148.455078125,
            Y: 28.970609664917,
            Z: -77273.8359375
        },
        "4": {
            Name: "Maupertus",
            X: 15844.725585938,
            Y: 134.4774017334,
            Z: -84150.796875
        },
        "5": {
            Name: "Brucheville",
            X: -15041.91015625,
            Y: 13.913147926331,
            Z: -66514.4609375
        },
        "6": {
            Name: "Meautis",
            X: -24563.125,
            Y: 25.325464248657,
            Z: -72508.1171875
        },
        "7": {
            Name: "Cricqueville-en-Bessin",
            X: -14390.693359375,
            Y: 24.763647079468,
            Z: -50853.4375
        },
        "8": {
            Name: "Lessay",
            X: -33566.88671875,
            Y: 20.000019073486,
            Z: -85784.15625
        },
        "9": {
            Name: "Sainte-Laurent-sur-Mer",
            X: -14429.124023438,
            Y: 17.835691452026,
            Z: -41785.3203125
        },
        "10": {
            Name: "Biniville",
            X: -7265.7392578125,
            Y: 32.473197937012,
            Z: -84835.0078125
        },
        "11": {
            Name: "Cardonville",
            X: -17144.2890625,
            Y: 30.951379776001,
            Z: -53703.78125
        },
        "12": {
            Name: "Deux Jumeaux",
            X: -16994.240234375,
            Y: 37.679191589355,
            Z: -48197.32421875
        },
        "13": {
            Name: "Chippelle",
            X: -28812.5546875,
            Y: 38.041233062744,
            Z: -48519.23046875
        },
        "14": {
            Name: "Beuzeville",
            X: -9576.9912109375,
            Y: 34.831809997559,
            Z: -72591.578125
        },
        "15": {
            Name: "Azeville",
            X: -2686.3544921875,
            Y: 22.806873321533,
            Z: -74181.3984375
        },
        "16": {
            Name: "Picauville",
            X: -11851.96484375,
            Y: 22.10747718811,
            Z: -80781.453125
        },
        "17": {
            Name: "Le Molay",
            X: -25702.712890625,
            Y: 31.954740524292,
            Z: -40995.66015625
        },
        "18": {
            Name: "Longues-sur-Mer",
            X: -16468.4140625,
            Y: 68.611747741699,
            Z: -29311.9453125
        },
        "19": {
            Name: "Carpiquet",
            X: -35224.9609375,
            Y: 57.000102996826,
            Z: -9368.1083984375
        },
        "20": {
            Name: "Bazenville",
            X: -21037.55859375,
            Y: 60.873630523682,
            Z: -18979.0703125
        },
        "21": {
            Name: "Sainte-Croix-sur-Mer",
            X: -18815.318359375,
            Y: 48.796699523926,
            Z: -14521.333007812
        },
        "22": {
            Name: "Beny-sur-Mer",
            X: -21520.779296875,
            Y: 60.732841491699,
            Z: -8397.8515625
        },
        "23": {
            Name: "Rucqueville",
            X: -26621.591796875,
            Y: 58.80305480957,
            Z: -18748.99609375
        },
        "24": {
            Name: "Sommervieu",
            X: -21383.123046875,
            Y: 56.978862762451,
            Z: -26792.662109375
        },
        "25": {
            Name: "Lantheuil",
            X: -24512.44921875,
            Y: 53.291923522949,
            Z: -16956.955078125
        },
        "26": {
            Name: "Evreux",
            X: -45534.58984375,
            Y: 129.00012207031,
            Z: 112927.1640625
        },
        "27": {
            Name: "Chailey",
            X: 164349.671875,
            Y: 29.000028610229,
            Z: 11626.734375
        },
        "28": {
            Name: "Needs Oar Point",
            X: 140493.015625,
            Y: 6.0000061988831,
            Z: -85719.9765625
        },
        "29": {
            Name: "Funtington",
            X: 153106.53125,
            Y: 38.000038146973,
            Z: -45889.23828125
        },
        "30": {
            Name: "Tangmere",
            X: 149796.25,
            Y: 14.517134666443,
            Z: -33471.78515625
        },
        "31": {
            Name: "Ford",
            X: 148097.921875,
            Y: 8.8593835830688,
            Z: -26195.72265625
        },
        "32": {
            Name: "Argentan",
            X: -79065.4296875,
            Y: 195.00019836426,
            Z: 23095.654296875
        },
        "33": {
            Name: "Goulet",
            X: -81589.6875,
            Y: 188.00018310547,
            Z: 16541.515625
        },
        "34": {
            Name: "Barville",
            X: -110392.796875,
            Y: 141.0001373291,
            Z: 49691.72265625
        },
        "35": {
            Name: "Essay",
            X: -105601.96875,
            Y: 152.43608093262,
            Z: 45523.95703125
        },
        "36": {
            Name: "Hauterive",
            X: -107583.2109375,
            Y: 149.32998657227,
            Z: 40573.76953125
        },
        "37": {
            Name: "Lymington",
            X: 139258.75,
            Y: 6.0000061988831,
            Z: -90410.7734375
        },
        "38": {
            Name: "Vrigny",
            X: -89071.8046875,
            Y: 180.00018310547,
            Z: 24835.84375
        },
        "39": {
            Name: "Odiham",
            X: 193002.359375,
            Y: 111.60011291504,
            Z: -51107.12109375
        },
        "40": {
            Name: "Conches",
            X: -56519.49609375,
            Y: 165.00016784668,
            Z: 95087.1796875
        },
        "41": {
            Name: "West Malling",
            X: 200894.3125,
            Y: 93.000091552734,
            Z: 42662.09765625
        },
        "42": {
            Name: "Villacoublay",
            X: -70473.4296875,
            Y: 170.00015258789,
            Z: 187341.640625
        },
        "43": {
            Name: "Kenley",
            X: 203016.6875,
            Y: 171.00016784668,
            Z: 6592.0600585938
        },
        "44": {
            Name: "Beauvais-Tille",
            X: 6109.880859375,
            Y: 101.00009155273,
            Z: 174345.8125
        },
        "45": {
            Name: "Cormeilles-en-Vexin",
            X: -34185.2265625,
            Y: 95.00008392334,
            Z: 172538.96875
        },
        "46": {
            Name: "Creil",
            X: -15022.7109375,
            Y: 82.00008392334,
            Z: 205003.515625
        },
        "47": {
            Name: "Guyancourt",
            X: -71430.5625,
            Y: 160.00009155273,
            Z: 177497.109375
        },
        "48": {
            Name: "Lonrai",
            X: -112353.7265625,
            Y: 157.00016784668,
            Z: 28436.138671875
        },
        "49": {
            Name: "Dinan-Trelivan",
            X: -118942.5234375,
            Y: 115.00011444092,
            Z: -129568.703125
        },
        "50": {
            Name: "Heathrow",
            X: 221173.203125,
            Y: 27.000028610229,
            Z: -20096.12890625
        },
        "51": {
            Name: "Fecamp-Benouville",
            X: 30532.82421875,
            Y: 90.000091552734,
            Z: 46208.15625
        },
        "52": {
            Name: "Farnborough",
            X: 198911.625,
            Y: 75.000076293945,
            Z: -40367.8046875
        },
        "53": {
            Name: "Friston",
            X: 143096.859375,
            Y: 94.084091186523,
            Z: 27691.28125
        },
        "54": {
            Name: "Deanland",
            X: 157193.46875,
            Y: 22.000022888184,
            Z: 27264.55078125
        },
        "55": {
            Name: "Triqueville",
            X: -14693.797851562,
            Y: 122.55814361572,
            Z: 55842.53125
        },
        "56": {
            Name: "Poix",
            X: 44984.21484375,
            Y: 166.77716064453,
            Z: 161936.03125
        },
        "57": {
            Name: "Orly",
            X: -72915.4765625,
            Y: 83.00008392334,
            Z: 200388.4375
        },
        "58": {
            Name: "Stoney Cross",
            X: 155617.53125,
            Y: 117.10011291504,
            Z: -101963.296875
        },
        "59": {
            Name: "Amiens-Glisy",
            X: 53802.65234375,
            Y: 58.523963928223,
            Z: 191132.3125
        },
        "60": {
            Name: "Ronai",
            X: -73490.546875,
            Y: 262.0002746582,
            Z: 13349.24609375
        },
        "61": {
            Name: "Rouen-Boos",
            X: -5539.1752929688,
            Y: 150.00015258789,
            Z: 108042.7109375
        },
        "62": {
            Name: "Deauville",
            X: -11855.204101562,
            Y: 140.02659606934,
            Z: 33318.3515625
        },
        "63": {
            Name: "Saint-Aubin",
            X: 48750.61328125,
            Y: 95.027503967285,
            Z: 97910.1875
        },
        "64": {
            Name: "Flers",
            X: -82171.296875,
            Y: 198.28337097168,
            Z: -18382.314453125
        },
        "65": {
            Name: "Avranches Le Val-Saint-Pere",
            X: -92669.3203125,
            Y: 14.258261680603,
            Z: -76678.0859375
        },
        "66": {
            Name: "Gravesend",
            X: 217765.109375,
            Y: 54.430534362793,
            Z: 40635.1171875
        },
        "67": {
            Name: "Beaumont-le-Roger",
            X: -40018.515625,
            Y: 148.98263549805,
            Z: 81845
        },
        "68": {
            Name: "Broglie",
            X: -49977.37890625,
            Y: 181.26385498047,
            Z: 60717.1953125
        },
        "69": {
            Name: "Bernay Saint Martin",
            X: -39024.96875,
            Y: 159.67486572266,
            Z: 67126.3359375
        },
        "70": {
            Name: "Saint-Andre-de-lEure",
            X: -61135.62109375,
            Y: 142.88969421387,
            Z: 117901.4921875
        },
        "71": {
            Name: "Biggin Hill",
            X: 206709.21875,
            Y: 173.00016784668,
            Z: 15977.452148438
        },
        "72": {
            Name: "Manston",
            X: 211852.875,
            Y: 48.000049591064,
            Z: 108427.2734375
        },
        "73": {
            Name: "Detling",
            X: 205568.90625,
            Y: 180.80578613281,
            Z: 55873.59375
        },
        "74": {
            Name: "Lympne",
            X: 181717.59375,
            Y: 61.834384918213,
            Z: 86430.46875
        },
        "75": {
            Name: "Abbeville Drucat",
            X: 80017.75,
            Y: 66.139770507812,
            Z: 150582.71875
        },
        "76": {
            Name: "Saint-Omer Wizernes",
            X: 147955.984375,
            Y: 65.000061035156,
            Z: 173364.9375
        },
        "77": {
            Name: "Merville Calonne",
            X: 137816.65625,
            Y: 40.000038146973,
            Z: 203570.015625
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).SYRIA]: {
        "1": {
            Name: "Abu al-Duhur",
            X: 75929.77344,
            Y: 250.0002441,
            Z: 112670.3281,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 9496,
            UHF: 250.35,
            VHF: 122.2,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "820'",
            "MF/HF": "3.950 / 38.80",
            ICAO: "OS57"
        },
        "2": {
            Name: "Adana Sakirpasa",
            X: 220139.0313,
            Y: 17.00001717,
            Z: -47292.88672,
            Theater: "SYRIA",
            Runways: "05,23",
            RunwayLength: 9071,
            UHF: 250.9,
            VHF: 121.1,
            TACAN: "",
            VOR: "112.70 (ADA)",
            ILS: [
                "05/108.70/056\u02DA"
            ],
            Elevation: "55'",
            "MF/HF": "4.225/39.350",
            ICAO: "LTAF"
        },
        "3": {
            Name: "Al Qusayr",
            X: -52203.73047,
            Y: 527.0005493,
            Z: 61287.85938,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: 9600,
            UHF: 251.25,
            VHF: 119.2,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1729'",
            "MF/HF": "4.400 / 39.70",
            ICAO: "OS70"
        },
        "4": {
            Name: "An Nasiriyah",
            X: -123819.2891,
            Y: 837.1625366,
            Z: 86407.89063,
            Theater: "SYRIA",
            Runways: "04,22",
            RunwayLength: 8318,
            UHF: 251.35,
            VHF: 122.3,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2746'",
            "MF/HF": "4.450 / 39.80",
            ICAO: "OS64"
        },
        "5": {
            Name: "Tha'lah",
            X: -259061.4219,
            Y: 725.7504272,
            Z: 39317.87891,
            Theater: "SYRIA",
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "6": {
            Name: "Beirut-Rafic Hariri",
            X: -130182.1641,
            Y: 12.0000124,
            Z: -42278.93359,
            Theater: "SYRIA",
            Runways: "17,35,03,21,16,34",
            RunwayLength: 10566,
            UHF: 251.4,
            VHF: 118.9,
            TACAN: "",
            VOR: "112.60 (KAD)",
            ILS: [
                "17/109.50/179\u02DA",
                "16/110.10/169\u02DA",
                "03/110.70/035\u02DA"
            ],
            Elevation: "39'",
            "MF/HF": "4.475 / 39.85",
            ICAO: "OLBA"
        },
        "7": {
            Name: "Damascus",
            X: -179748.3281,
            Y: 612.0006104,
            Z: 50728.26563,
            Theater: "SYRIA",
            Runways: "05L,23R,05R,23L",
            RunwayLength: 11903,
            UHF: 251.45,
            VHF: 118.5,
            TACAN: "",
            VOR: "116.0 (DAM)",
            ILS: [
                "23R/109.90/230\u02DA",
                "05R/111.10/050\u02DA"
            ],
            Elevation: "2007'",
            "MF/HF": "4.500 / 39.90",
            ICAO: "OSDI"
        },
        "8": {
            Name: "Marj as Sultan South",
            X: -171681.1719,
            Y: 611.9667358,
            Z: 48217.06641,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 681,
            UHF: 251.5,
            VHF: 122.9,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2007'",
            "MF/HF": "4.525 / 39.95",
            ICAO: "-"
        },
        "9": {
            Name: "Al-Dumayr",
            X: -159245.375,
            Y: 630.0006104,
            Z: 72725.04688,
            Theater: "SYRIA",
            Runways: "06,24",
            RunwayLength: 9843,
            UHF: 251.55,
            VHF: 120.3,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2066'",
            "MF/HF": "4.550 / 40.00",
            ICAO: "OS61"
        },
        "10": {
            Name: "Eyn Shemer",
            X: -283415.875,
            Y: 28.57603073,
            Z: -93149.375,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 3826,
            UHF: 250,
            VHF: 123.4,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "93'",
            "MF/HF": "3.750 / 38.40",
            ICAO: "LLES"
        },
        "11": {
            Name: "Gaziantep",
            X: 210716.109375,
            Y: 697.21142578125,
            Z: 146087.90625,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: 0,
            UHF: 250.05,
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "13": {
            Name: "Haifa",
            X: -242139.0156,
            Y: 6.000006676,
            Z: -87825.28906,
            Theater: "SYRIA",
            Runways: "16,34",
            RunwayLength: 3639,
            UHF: 250.05,
            VHF: 127.8,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "19'",
            "MF/HF": "3.775 / 38.45",
            ICAO: "LLHA"
        },
        "14": {
            Name: "Hama",
            X: 8419.59375,
            Y: 299.9153748,
            Z: 75521.71094,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 8719,
            UHF: 250.1,
            VHF: 118.05,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "983'",
            "MF/HF": "3.800 / 38.50",
            ICAO: "OS58"
        },
        "15": {
            Name: "Hatay",
            X: 148653.7656,
            Y: 77.17556763,
            Z: 40403.94531,
            Theater: "SYRIA",
            Runways: "04,22",
            RunwayLength: 9867,
            UHF: 250.15,
            VHF: 128.5,
            TACAN: "",
            VOR: "112.05 (HTY)",
            ILS: [
                "04/108.90/044\u02DA",
                "22/108.15/224\u02DA"
            ],
            Elevation: "253'",
            "MF/HF": "3.825 / 38.55",
            ICAO: "LTDA"
        },
        "16": {
            Name: "Incirlik",
            X: 220387.5469,
            Y: 47.56959915,
            Z: -36463.6875,
            Theater: "SYRIA",
            Runways: "05,23",
            RunwayLength: 9928,
            UHF: 360.1,
            VHF: 129.4,
            TACAN: "21X (DAN)",
            VOR: "108.40 (DAN)",
            ILS: [
                "05/109.30/055\u02DA",
                "23/111.70/235\u02DA"
            ],
            Elevation: "156'",
            "MF/HF": "3.850 / 38.60",
            ICAO: "LTAG"
        },
        "17": {
            Name: "Jirah",
            X: 115071.7578,
            Y: 356.7168579,
            Z: 188376.1563,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: 9770,
            UHF: 250.2,
            VHF: 118.1,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1170'",
            "MF/HF": "3.875 / 38.65",
            ICAO: "OS62"
        },
        "18": {
            Name: "Khalkhalah",
            X: -218879.4375,
            Y: 712.3335571,
            Z: 54981.88281,
            Theater: "SYRIA",
            Runways: "07,25,15,33",
            RunwayLength: 9855,
            UHF: 250.25,
            VHF: 122.5,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2337'",
            "MF/HF": "3.900 / 38.70",
            ICAO: "OS69"
        },
        "19": {
            Name: "King Hussein Air College",
            X: -297491.9375,
            Y: 672.0006714,
            Z: 25897.08789,
            Theater: "SYRIA",
            Runways: "13,31",
            RunwayLength: 9819,
            UHF: 250.3,
            VHF: 118.3,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2204'",
            "MF/HF": "3.925 / 38.75",
            ICAO: "OJMF"
        },
        "20": {
            Name: "Kiryat Shmona",
            X: -199857.7188,
            Y: 100.0000916,
            Z: -34831.57422,
            Theater: "SYRIA",
            Runways: "03,21",
            RunwayLength: 3737,
            UHF: 250.4,
            VHF: 118.4,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "238'",
            "MF/HF": "3.975 / 38.85",
            ICAO: "LLKS"
        },
        "21": {
            Name: "Bassel Al-Assad",
            X: 42994.66406,
            Y: 28.45734406,
            Z: 5658.36084,
            Theater: "SYRIA",
            Runways: "17,35",
            RunwayLength: 9168,
            UHF: 250.45,
            VHF: 118.1,
            TACAN: "",
            VOR: "114.80 (LTK)",
            ILS: [
                "17/109.10/179\u02DA"
            ],
            Elevation: "93'",
            "MF/HF": "4.000 / 38.90",
            ICAO: "OSLK"
        },
        "22": {
            Name: "Marj as Sultan North",
            X: -170221.7969,
            Y: 611.7497559,
            Z: 47457.74219,
            Theater: "SYRIA",
            Runways: "08,26",
            RunwayLength: 632,
            UHF: 250.5,
            VHF: 122.7,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2007'",
            "MF/HF": "4.025 / 38.95",
            ICAO: "-"
        },
        "23": {
            Name: "Marj Ruhayyil",
            X: -194683.9063,
            Y: 658.5941772,
            Z: 45031.90625,
            Theater: "SYRIA",
            Runways: "06,24",
            RunwayLength: 9770,
            UHF: 250.55,
            VHF: 120.8,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2160'",
            "MF/HF": "4.050 / 39.00",
            ICAO: "OS63"
        },
        "24": {
            Name: "Megiddo",
            X: -266879.7188,
            Y: 55.00004959,
            Z: -71994.76563,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 6471,
            UHF: 250.6,
            VHF: 119.9,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "180'",
            "MF/HF": "4.075 / 39.05",
            ICAO: "LLMG"
        },
        "25": {
            Name: "Mezzeh",
            X: -171641.8438,
            Y: 718.0916748,
            Z: 25888.5332,
            Theater: "SYRIA",
            Runways: "06,24",
            RunwayLength: 9661,
            UHF: 250.65,
            VHF: 120.7,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2355'",
            "MF/HF": "4.100 / 39.10",
            ICAO: "OS67"
        },
        "26": {
            Name: "Minakh",
            X: 163870.9219,
            Y: 492.0004578,
            Z: 106743.0313,
            Theater: "SYRIA",
            Runways: "10,28,04,22",
            RunwayLength: 4648,
            UHF: 250.7,
            VHF: 120.6,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1614'",
            "MF/HF": "4.125 / 39.15",
            ICAO: "OS71"
        },
        "27": {
            Name: "Aleppo",
            X: 125776.7031,
            Y: 382.19104,
            Z: 121870.9531,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 9496,
            UHF: 250.75,
            VHF: 119.1,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1253'",
            "MF/HF": "4.150 / 39.20",
            ICAO: "OSAP"
        },
        "28": {
            Name: "Palmyra",
            X: -55607.97266,
            Y: 386.2240295,
            Z: 221438.1563,
            Theater: "SYRIA",
            Runways: "08,26",
            RunwayLength: 9485,
            UHF: 250.8,
            VHF: 121.9,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1267'",
            "MF/HF": "4.175 / 39.25",
            ICAO: "OSPR"
        },
        "29": {
            Name: "Qabr as Sitt",
            X: -174610.6719,
            Y: 650.5708008,
            Z: 37142.67578,
            Theater: "SYRIA",
            Runways: "06,24",
            RunwayLength: 1003,
            UHF: 250.85,
            VHF: 122.6,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2134'",
            "MF/HF": "4.200 / 39.30",
            ICAO: "-"
        },
        "30": {
            Name: "Ramat David",
            X: -259097.3438,
            Y: 32.23926926,
            Z: -76862.32031,
            Theater: "SYRIA",
            Runways: "14,32,09,27,11,29",
            RunwayLength: 8008,
            UHF: 251.05,
            VHF: 118.6,
            TACAN: "84X",
            VOR: "113.70",
            ILS: [
                ""
            ],
            Elevation: "105'",
            "MF/HF": "4.250 / 39.40",
            ICAO: "LLRD"
        },
        "31": {
            Name: "Kuweires",
            X: 126034.1172,
            Y: 366.0003662,
            Z: 154262.7656,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: 7838,
            UHF: 251,
            VHF: 120.5,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1200'",
            "MF/HF": "4.275 / 39.45",
            ICAO: "OS66"
        },
        "32": {
            Name: "Rayak",
            X: -131016.3047,
            Y: 894.3814697,
            Z: 3064.66748,
            Theater: "SYRIA",
            Runways: "04,22",
            RunwayLength: 9600,
            UHF: 251.1,
            VHF: 124.4,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2934'",
            "MF/HF": "4.300 / 39.50",
            ICAO: "OLRA"
        },
        "33": {
            Name: "Rene Mouawad",
            X: -48864.37109,
            Y: 4.410843372,
            Z: 7502.123535,
            Theater: "SYRIA",
            Runways: "06,24",
            RunwayLength: 9332,
            UHF: 251.1,
            VHF: 119.5,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "14'",
            "MF/HF": "4.325 / 39.55",
            ICAO: "OLKA"
        },
        "37": {
            Name: "Tabqa",
            X: 77069.83594,
            Y: 330.3158875,
            Z: 242231.7656,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 9509,
            UHF: 251.15,
            VHF: 118.5,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1083'",
            "MF/HF": "4.350 / 39.60",
            ICAO: "OS59"
        },
        "38": {
            Name: "Taftanaz",
            X: 103379.0234,
            Y: 311.0003052,
            Z: 83165.92969,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: 3366,
            UHF: 251.2,
            VHF: 112.8,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1020'",
            "MF/HF": "4.375 / 39.65",
            ICAO: "-"
        },
        "40": {
            Name: "Wujah Al Hajar",
            X: -80912.17188,
            Y: 188.6738739,
            Z: -22454.4668,
            Theater: "SYRIA",
            Runways: "02,20",
            RunwayLength: 5045,
            UHF: 251.3,
            VHF: 121.5,
            TACAN: "",
            VOR: "116.20 (CAK)",
            ILS: [
                ""
            ],
            Elevation: "619'",
            "MF/HF": "4.425 / 39.75",
            ICAO: "Z19O"
        },
        "41": {
            Name: "Gazipasa",
            X: 158094.9375,
            Y: 11.10494041,
            Z: -320441.0625,
            Theater: "SYRIA",
            Runways: "08,26",
            RunwayLength: "6885'",
            UHF: 251.65,
            VHF: 119.25,
            TACAN: "",
            VOR: "",
            ILS: [
                "08/108.50"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "43": {
            Name: "Nicosia",
            X: 24923.6543,
            Y: 218.4187775,
            Z: -238861.7188,
            Theater: "SYRIA",
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "44": {
            Name: "Akrotiri",
            X: -35297.09375,
            Y: 18.946064,
            Z: -270072.2813,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: "8276'",
            UHF: 251.7,
            VHF: 128.0,
            TACAN: "107X",
            VOR: "",
            ILS: [
                "28/109.70"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "45": {
            Name: "Kingsfield",
            X: 7776.000488,
            Y: 82.47331238,
            Z: -198993.4063,
            Theater: "SYRIA",
            Runways: "06,24",
            RunwayLength: "3069'",
            UHF: 251.75,
            VHF: 121,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "46": {
            Name: "Paphos",
            X: -18147.3125,
            Y: 12.30508232,
            Z: -315369.5,
            Theater: "SYRIA",
            Runways: "11,29",
            RunwayLength: "8425'",
            UHF: 251.8,
            VHF: 119.9,
            TACAN: "79X",
            VOR: "117.90",
            ILS: [
                "29/108.90"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "47": {
            Name: "Larnaca",
            X: -8466.051758,
            Y: 5.000004768,
            Z: -209773.4688,
            Theater: "SYRIA",
            Runways: "04,22",
            RunwayLength: "8009'",
            UHF: 251.85,
            VHF: 121.2,
            TACAN: "",
            VOR: "112.80",
            ILS: [
                "22/110.30"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "48": {
            Name: "Lakatamia",
            X: 19750.61133,
            Y: 231.0002441,
            Z: -234973.5156,
            Theater: "SYRIA",
            Runways: "17,35",
            RunwayLength: "1230'",
            UHF: 251.9,
            VHF: 120.2,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "49": {
            Name: "Ercan",
            X: 24764.47656,
            Y: 117.0001144,
            Z: -219271.6875,
            Theater: "SYRIA",
            Runways: "11,29",
            RunwayLength: "7559'",
            UHF: 251.95,
            VHF: 120.2,
            TACAN: "",
            VOR: "117.00",
            ILS: [
                "29/108.30"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "50": {
            Name: "Gecitkale",
            X: 32254.64063,
            Y: 45.00004578,
            Z: -199005.9844,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: "8156'",
            UHF: 252.05,
            VHF: 120.0,
            TACAN: "",
            VOR: "114.30",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "51": {
            Name: "Pinarbashi",
            X: 39146.83203,
            Y: 235.0002289,
            Z: -238857.2344,
            Theater: "SYRIA",
            Runways: "16,34",
            RunwayLength: "3364'",
            UHF: 252.1,
            VHF: 121,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "52": {
            Name: "Naqoura",
            X: -209938.1875,
            Y: 115.2789459,
            Z: -78642.60938,
            Theater: "SYRIA",
            Runways: "",
            RunwayLength: "",
            UHF: 252.15,
            VHF: 122.0,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "12": {
            Name: "H4",
            X: -279644.28125,
            Y: 688.00067138672,
            Z: 208278.046875,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: "7179'",
            UHF: 250.1,
            VHF: 122.6,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).PG]: {
        "1": {
            Name: "Abu Musa Island",
            X: -31593.10547,
            Y: 5.000004768,
            Z: -122493.0547,
            Theater: "PG",
            Runways: "13L,31R,13R,31L",
            RunwayLength: "",
            UHF: 250.5,
            VHF: 119.2,
            TACAN: "",
            VOR: 114.25,
            ILS: [
                ""
            ],
            Elevation: "55'",
            "MF/HF": "4.225/39.350",
            ICAO: "LTAF"
        },
        "2": {
            Name: "Bandar Abbas Intl",
            X: 114214.0547,
            Y: 5.587854385,
            Z: 13397.94141,
            Theater: "PG",
            Runways: "03L,21R,03R,21L",
            RunwayLength: "",
            UHF: 251,
            VHF: 118.1,
            TACAN: "78X",
            VOR: 117.2,
            ILS: [
                "21L/109.90"
            ],
            Elevation: "39'",
            "MF/HF": "4.475 / 39.85",
            ICAO: "OLBA"
        },
        "3": {
            Name: "Bandar Lengeh",
            X: 41395.73828,
            Y: 24.6532383,
            Z: -142141.3125,
            Theater: "PG",
            Runways: "08,26",
            RunwayLength: "",
            UHF: 251.05,
            VHF: 121.7,
            TACAN: "",
            VOR: 114.8,
            ILS: [
                ""
            ],
            Elevation: "2007'",
            "MF/HF": "4.500 / 39.90",
            ICAO: "OSDI"
        },
        "4": {
            Name: "Al Dhafra AFB",
            X: -209935.4844,
            Y: 16.00001526,
            Z: -174592.0625,
            Theater: "PG",
            Runways: "13L,31R,13R,31L",
            RunwayLength: "",
            UHF: 251.1,
            VHF: 126.5,
            TACAN: "96X",
            VOR: 114.9,
            ILS: [
                "13L/111.10\u02DA",
                "31R/109.10\u02DA",
                "13R/108.70\u02DA",
                "31L/108.70\u02DA"
            ],
            Elevation: "2066'",
            "MF/HF": "4.550 / 40.00",
            ICAO: "OS61"
        },
        "5": {
            Name: "Dubai Intl",
            X: -101509.8438,
            Y: 5.000004768,
            Z: -87472.57813,
            Theater: "PG",
            Runways: "12L,30R,12R,30L",
            RunwayLength: "",
            UHF: 251.05,
            VHF: 118.75,
            TACAN: "",
            VOR: "",
            ILS: [
                "30R/110.90\u02DA",
                "30L/111.30\u02DA",
                "12L/110.10\u02DA",
                "12R/109.50"
            ],
            Elevation: "19'",
            "MF/HF": "3.775 / 38.45",
            ICAO: "LLHA"
        },
        "6": {
            Name: "Al Maktoum Intl",
            X: -141081.625,
            Y: 37.61849976,
            Z: -108598.2422,
            Theater: "PG",
            Runways: "12,30",
            RunwayLength: "",
            UHF: 251.2,
            VHF: 118.6,
            TACAN: "",
            VOR: "",
            ILS: [
                "30/109.75/302\u02DA",
                "12/111.75/122\u02DA"
            ],
            Elevation: "1253'",
            "MF/HF": "4.150 / 39.20",
            ICAO: "OSAP"
        },
        "7": {
            Name: "Fujairah Intl",
            X: -118114.7813,
            Y: 18.52036858,
            Z: 9254.498047,
            Theater: "PG",
            Runways: "11,29",
            RunwayLength: "",
            UHF: 251.25,
            VHF: 124.6,
            TACAN: "",
            VOR: 113.8,
            ILS: [
                "29/111.10/293\u02DA"
            ],
            Elevation: "983'",
            "MF/HF": "3.800 / 38.50",
            ICAO: "OS58"
        },
        "8": {
            Name: "Tunb Island AFB",
            X: 9707.209961,
            Y: 13.0000124,
            Z: -92900.58594,
            Theater: "PG",
            Runways: "03,21",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "105'",
            "MF/HF": "4.250 / 39.40",
            ICAO: "LLRD"
        },
        "9": {
            Name: "Havadarya",
            X: 109479.2813,
            Y: 15.45833778,
            Z: -5180.572754,
            Theater: "PG",
            Runways: "08,26",
            RunwayLength: "",
            UHF: 251.3,
            VHF: 123.15,
            TACAN: "47X",
            VOR: "",
            ILS: [
                "08/108.90/079\u02DA"
            ],
            Elevation: "253'",
            "MF/HF": "3.825 / 38.55",
            ICAO: "LTDA"
        },
        "10": {
            Name: "Khasab",
            X: 883.8808594,
            Y: 14.49072838,
            Z: 128.6996765,
            Theater: "PG",
            Runways: "01,19",
            RunwayLength: "",
            UHF: 250,
            VHF: 124.35,
            TACAN: "",
            VOR: "",
            ILS: [
                "19/110.30/194\u02DA"
            ],
            Elevation: "2337'",
            "MF/HF": "3.900 / 38.70",
            ICAO: "OS69"
        },
        "11": {
            Name: "Lar",
            X: 169016.75,
            Y: 803.3289185,
            Z: -183822.5781,
            Theater: "PG",
            Runways: "09,27",
            RunwayLength: "",
            UHF: 250.05,
            VHF: 127.35,
            TACAN: "",
            VOR: 117.9,
            ILS: [
                ""
            ],
            Elevation: "238'",
            "MF/HF": "3.975 / 38.85",
            ICAO: "LLKS"
        },
        "12": {
            Name: "Al Minhad AFB",
            X: -126043.7813,
            Y: 58.14745712,
            Z: -87325.16406,
            Theater: "PG",
            Runways: "09,27",
            RunwayLength: "",
            UHF: 250.1,
            VHF: 118.55,
            TACAN: "99X",
            VOR: "",
            ILS: [
                "27/110.75/270\u02DA",
                "09/110.70/090\u02DA"
            ],
            Elevation: "2746'",
            "MF/HF": "4.450 / 39.80",
            ICAO: "OS64"
        },
        "13": {
            Name: "Qeshm Island",
            X: 66079.17188,
            Y: 8.028849602,
            Z: -31812.67969,
            Theater: "PG",
            Runways: "05,23",
            RunwayLength: "",
            UHF: 250.15,
            VHF: 118.05,
            TACAN: "",
            VOR: 117.1,
            ILS: [
                ""
            ],
            Elevation: "2007'",
            "MF/HF": "4.525 / 39.95",
            ICAO: "-"
        },
        "14": {
            Name: "Sharjah Intl",
            X: -93431.32031,
            Y: 29.99998283,
            Z: -72062,
            Theater: "PG",
            Runways: "12L,30R,12R,30L",
            RunwayLength: "",
            UHF: 250.2,
            VHF: 118.6,
            TACAN: "",
            VOR: 117.8,
            ILS: [
                "30R/111.95/303",
                "\u02DA12L/108.55/123\u02DA"
            ],
            Elevation: "2355'",
            "MF/HF": "4.100 / 39.10",
            ICAO: "OS67"
        },
        "15": {
            Name: "Sirri Island",
            X: -27656.47461,
            Y: 5.44174099,
            Z: -169860.0781,
            Theater: "PG",
            Runways: "12,30",
            RunwayLength: "",
            UHF: 250.25,
            VHF: 135.05,
            TACAN: "",
            VOR: 113.75,
            ILS: [
                ""
            ],
            Elevation: "2134'",
            "MF/HF": "4.200 / 39.30",
            ICAO: "-"
        },
        "16": {
            Name: "Tunb Kochak",
            X: 9049.399414,
            Y: 4.642024517,
            Z: -109088.5781,
            Theater: "PG",
            Runways: "08,26",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "89X",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2934'",
            "MF/HF": "4.300 / 39.50",
            ICAO: "OLRA"
        },
        "17": {
            Name: "Sir Abu Nuayr",
            X: -103189.0469,
            Y: 7.682799816,
            Z: -202643.0313,
            Theater: "PG",
            Runways: "10,28",
            RunwayLength: "",
            UHF: 250.8,
            VHF: 118,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1267'",
            "MF/HF": "4.175 / 39.25",
            ICAO: "OSPR"
        },
        "18": {
            Name: "Kerman",
            X: 452408.4063,
            Y: 1751.425659,
            Z: 71741.58594,
            Theater: "PG",
            Runways: "16,34",
            RunwayLength: "",
            UHF: 250.3,
            VHF: 118.25,
            TACAN: "97X",
            VOR: 112,
            ILS: [
                ""
            ],
            Elevation: "1170'",
            "MF/HF": "3.875 / 38.65",
            ICAO: "OS62"
        },
        "19": {
            Name: "Shiraz Intl",
            X: 380165.5313,
            Y: 1487.001465,
            Z: -349843.0313,
            Theater: "PG",
            Runways: "11L,29R,11R,29L",
            RunwayLength: "",
            UHF: 250.35,
            VHF: 121.9,
            TACAN: "94X",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1614'",
            "MF/HF": "4.125 / 39.15",
            ICAO: "OS71"
        },
        "20": {
            Name: "Sas Al Nakheel",
            X: -188819.25,
            Y: 2.945518017,
            Z: -176195.9844,
            Theater: "PG",
            Runways: "16,34",
            RunwayLength: "",
            UHF: 250.45,
            VHF: 128.9,
            TACAN: "",
            VOR: 128.93,
            ILS: [
                ""
            ],
            Elevation: "180'",
            "MF/HF": "4.075 / 39.05",
            ICAO: "LLMG"
        },
        "21": {
            Name: "Bandar-e-Jask",
            X: -57716.9375,
            Y: 7.950510025,
            Z: 155264.7813,
            Theater: "PG",
            Runways: "06,24",
            RunwayLength: "",
            UHF: 250.5,
            VHF: 118.15,
            TACAN: "110X",
            VOR: 116.3,
            ILS: [
                ""
            ],
            Elevation: "93'",
            "MF/HF": "3.750 / 38.40",
            ICAO: "LLES"
        },
        "22": {
            Name: "Abu Dhabi Intl",
            X: -187211.25,
            Y: 28.00002861,
            Z: -163535.5156,
            Theater: "PG",
            Runways: "08,26",
            RunwayLength: "",
            UHF: 250.4,
            VHF: 122.9,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "820'",
            "MF/HF": "3.950 / 38.80",
            ICAO: "OS57"
        },
        "23": {
            Name: "Al-Bateen",
            X: -190269.1094,
            Y: 3.650626898,
            Z: -182714.7969,
            Theater: "PG",
            Runways: "13,31",
            RunwayLength: "",
            UHF: 250.6,
            VHF: 119.9,
            TACAN: "",
            VOR: 114,
            ILS: [
                ""
            ],
            Elevation: "93'",
            "MF/HF": "4.000 / 38.90",
            ICAO: "OSLK"
        },
        "24": {
            Name: "Kish Intl",
            X: 42988.85938,
            Y: 35.00003433,
            Z: -226699.4063,
            Theater: "PG",
            Runways: "10L,28R,10R,28L",
            RunwayLength: "",
            UHF: 250.65,
            VHF: 121.65,
            TACAN: "112X",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "2204'",
            "MF/HF": "3.925 / 38.75",
            ICAO: "OJMF"
        },
        "25": {
            Name: "Al Ain Intl",
            X: -209361.9688,
            Y: 248.04953,
            Z: -65151.40625,
            Theater: "PG",
            Runways: "01,19",
            RunwayLength: "",
            UHF: 250.7,
            VHF: 119.85,
            TACAN: "",
            VOR: 112.6,
            ILS: [
                ""
            ],
            Elevation: "1729'",
            "MF/HF": "4.400 / 39.70",
            ICAO: "OS70"
        },
        "26": {
            Name: "Lavan Island",
            X: 76294.11719,
            Y: 22.91065216,
            Z: -287950.9375,
            Theater: "PG",
            Runways: "11,29",
            RunwayLength: "",
            UHF: 250.75,
            VHF: 128.55,
            TACAN: "",
            VOR: 116.85,
            ILS: [
                ""
            ],
            Elevation: "1200'",
            "MF/HF": "4.275 / 39.45",
            ICAO: "OS66"
        },
        "27": {
            Name: "Jiroft",
            X: 283496.7188,
            Y: 812.0008545,
            Z: 140608.3125,
            Theater: "PG",
            Runways: "13,31",
            RunwayLength: "",
            UHF: 250.85,
            VHF: 136,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "156'",
            "MF/HF": "3.850 / 38.60",
            ICAO: "LTAG"
        },
        "28": {
            Name: "Ras Al Khaimah Intl",
            X: -62870.88281,
            Y: 21.58902168,
            Z: -30497.56641,
            Theater: "PG",
            Runways: "17,35",
            RunwayLength: "",
            UHF: 250.9,
            VHF: 121.6,
            TACAN: "",
            VOR: 113.6,
            ILS: [
                ""
            ],
            Elevation: "2160'",
            "MF/HF": "4.050 / 39.00",
            ICAO: "OS63"
        },
        "29": {
            Name: "Liwa AFB",
            X: -274638.75,
            Y: 121.9301147,
            Z: -249407.125,
            Theater: "PG",
            Runways: "13,31",
            RunwayLength: "",
            UHF: 250.95,
            VHF: 119.3,
            TACAN: "121X",
            VOR: 117.4,
            ILS: [
                ""
            ],
            Elevation: "2007'",
            "MF/HF": "4.025 / 38.95",
            ICAO: "-"
        },
        "33": {
            Name: "Rene Mouawad",
            X: -48864.37109,
            Y: 4.410843372,
            Z: 7502.123535,
            Theater: "SYRIA",
            Runways: "06,24",
            RunwayLength: 9332,
            UHF: 251.1,
            VHF: 119.5,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "14'",
            "MF/HF": "4.325 / 39.55",
            ICAO: "OLKA"
        },
        "37": {
            Name: "Tabqa",
            X: 77069.83594,
            Y: 330.3158875,
            Z: 242231.7656,
            Theater: "SYRIA",
            Runways: "09,27",
            RunwayLength: 9509,
            UHF: 251.15,
            VHF: 118.5,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1083'",
            "MF/HF": "4.350 / 39.60",
            ICAO: "OS59"
        },
        "38": {
            Name: "Taftanaz",
            X: 103379.0234,
            Y: 311.0003052,
            Z: 83165.92969,
            Theater: "SYRIA",
            Runways: "10,28",
            RunwayLength: 3366,
            UHF: 251.2,
            VHF: 112.8,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "1020'",
            "MF/HF": "4.375 / 39.65",
            ICAO: "-"
        },
        "40": {
            Name: "Wujah Al Hajar",
            X: -80912.17188,
            Y: 188.6738739,
            Z: -22454.4668,
            Theater: "SYRIA",
            Runways: "02,20",
            RunwayLength: 5045,
            UHF: 251.3,
            VHF: 121.5,
            TACAN: "",
            VOR: "116.20 (CAK)",
            ILS: [
                ""
            ],
            Elevation: "619'",
            "MF/HF": "4.425 / 39.75",
            ICAO: "Z19O"
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).CAUCASUS]: {
        "12": {
            Name: "Anapa-Vityazevo",
            X: -4447.790527,
            Y: 43.00004196,
            Z: 244021.9844,
            Theater: "",
            Runways: "04,22",
            RunwayLength: "(8202')",
            UHF: 250,
            VHF: 121,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "13": {
            Name: "Krasnodar-Center",
            X: 11652.91309,
            Y: 30.01003265,
            Z: 366766.3125,
            Theater: "",
            Runways: "09,27",
            RunwayLength: "(8200')",
            UHF: 251,
            VHF: 122,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "14": {
            Name: "Novorossiysk",
            X: -40299.02344,
            Y: 40.01004028,
            Z: 279853.5,
            Theater: "",
            Runways: "04,22",
            RunwayLength: "(5905')",
            UHF: 252,
            VHF: 123,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "15": {
            Name: "Krymsk",
            X: -7349.032715,
            Y: 20.0103035,
            Z: 293711.9688,
            Theater: "",
            Runways: "04,22",
            RunwayLength: "(8530')",
            UHF: 253,
            VHF: 124,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "16": {
            Name: "Maykop-Khanskaya",
            X: -27625.94336,
            Y: 180.0101929,
            Z: 457047.6875,
            Theater: "",
            Runways: "04,22",
            RunwayLength: "(10495')",
            UHF: 254,
            VHF: 125,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "17": {
            Name: "Gelendzhik",
            X: -50995.63281,
            Y: 22.00992393,
            Z: 297848.8438,
            Theater: "",
            Runways: "01,19",
            RunwayLength: "(8050')",
            UHF: 255,
            VHF: 126,
            TACAN: "",
            VOR: "",
            ILS: [
                "01/110.10/007\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "18": {
            Name: "Sochi-Adler",
            X: -165163.2813,
            Y: 30.01003456,
            Z: 460901.5313,
            Theater: "",
            Runways: "06,24",
            RunwayLength: "(10170')",
            UHF: 256,
            VHF: 127,
            TACAN: "",
            VOR: "",
            ILS: [
                "06/111.10/056\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "19": {
            Name: "Krasnodar-Pashkovsky",
            X: 8706.819336,
            Y: 34.01003647,
            Z: 388985.7188,
            Theater: "",
            Runways: "05R,23",
            RunwayLength: "(10170')",
            UHF: 257,
            VHF: 128,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "20": {
            Name: "Sukhumi-Babushara",
            X: -221381.6875,
            Y: 13.3385067,
            Z: 565908.75,
            Theater: "",
            Runways: "12,30",
            RunwayLength: "(11610')",
            UHF: 258,
            VHF: 129,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "21": {
            Name: "Gudauta",
            X: -195650.5156,
            Y: 21.01003075,
            Z: 515898.75,
            Theater: "",
            Runways: "15,33",
            RunwayLength: "(8200')",
            UHF: 259,
            VHF: 130,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "22": {
            Name: "Batumi",
            X: -356437.1563,
            Y: 10.04403782,
            Z: 618210.875,
            Theater: "",
            Runways: "13,31",
            RunwayLength: "(8050')",
            UHF: 260,
            VHF: 131,
            TACAN: "16X",
            VOR: "",
            ILS: [
                "13/110.30/126\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "23": {
            Name: "Senaki-Kolkhi",
            X: -281903.125,
            Y: 13.23994255,
            Z: 648379.125,
            Theater: "",
            Runways: "09,27",
            RunwayLength: "(7790')",
            UHF: 261,
            VHF: 132,
            TACAN: "31X",
            VOR: "",
            ILS: [
                "09/108.90/088\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "24": {
            Name: "Kobuleti",
            X: -317604.9063,
            Y: 18.0100174,
            Z: 636704.125,
            Theater: "",
            Runways: "07,25",
            RunwayLength: "(7870')",
            UHF: 262,
            VHF: 133,
            TACAN: "67X",
            VOR: "",
            ILS: [
                "07/111.50/064\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "25": {
            Name: "Kutaisi",
            X: -284582.8125,
            Y: 45.01004791,
            Z: 685029.625,
            Theater: "",
            Runways: "08,26",
            RunwayLength: "(8202')",
            UHF: 263,
            VHF: 134,
            TACAN: "44X",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "26": {
            Name: "Mineralnye Vody",
            X: -52089.54688,
            Y: 320.0103149,
            Z: 707418.0625,
            Theater: "",
            Runways: "12,30",
            RunwayLength: "(13350')",
            UHF: 264,
            VHF: 135,
            TACAN: "",
            VOR: "",
            ILS: [
                "12/111.70/109\u02DA",
                "30/109.30/289\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "27": {
            Name: "Nalchik",
            X: -125499.5391,
            Y: 430.010437,
            Z: 759543.375,
            Theater: "",
            Runways: "06,24",
            RunwayLength: "(7545')",
            UHF: 265,
            VHF: 136,
            TACAN: "",
            VOR: "",
            ILS: [
                "24/110.50/229\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "28": {
            Name: "Mozdok",
            X: -83329.78906,
            Y: 154.6118469,
            Z: 835634.6875,
            Theater: "",
            Runways: "08,26",
            RunwayLength: "(10325')",
            UHF: 266,
            VHF: 137,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "29": {
            Name: "Tbilisi-Lochini",
            X: -314926.25,
            Y: 479.6948242,
            Z: 895724,
            Theater: "",
            Runways: "13,31",
            RunwayLength: "(8120')",
            UHF: 267,
            VHF: 138,
            TACAN: "25X",
            VOR: "",
            ILS: [
                "13/110.30/126\u02DA",
                "31/108.90/306\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "30": {
            Name: "Soganlug",
            X: -318656.9688,
            Y: 449.4102478,
            Z: 896274.9375,
            Theater: "",
            Runways: "14,32",
            RunwayLength: "(8120')",
            UHF: 268,
            VHF: 139,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "31": {
            Name: "Vaziani",
            X: -318191.7188,
            Y: 464.5004578,
            Z: 902331.75,
            Theater: "",
            Runways: "13,31",
            RunwayLength: "(8150')",
            UHF: 269,
            VHF: 140,
            TACAN: "22X",
            VOR: "",
            ILS: [
                "13/108.75/129\u02DA",
                "31/108.75/309\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "32": {
            Name: "Beslan",
            X: -148472.4063,
            Y: 524.0057983,
            Z: 842251.75,
            Theater: "",
            Runways: "10,28",
            RunwayLength: "(9890')",
            UHF: 270,
            VHF: 141,
            TACAN: "",
            VOR: "",
            ILS: [
                "10/110.50/087\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).NEVADA]: {
        "1": {
            Name: "Creech AFB",
            X: -360452.1563,
            Y: 952.9445801,
            Z: -76518.58594,
            Lat: 36.58442988,
            Long: -115.6868106,
            Runways: "8,26",
            RunwayLength: "6100'",
            UHF: 360.6,
            VHF: 118.3,
            TACAN: "87X",
            VOR: "",
            ILS: [
                "08/108.70/078\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "2": {
            Name: "Groom Lake AFB",
            X: -290154.4063,
            Y: 1369.867676,
            Z: -86227.29688,
            Lat: 37.21913894,
            Long: -115.7853107,
            Runways: "14,32",
            RunwayLength: "11008'",
            UHF: 250.05,
            VHF: 118,
            TACAN: "18X",
            VOR: "",
            ILS: [
                "32/109.30/323\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "3": {
            Name: "McCarran International Airport",
            X: -416012.5313,
            Y: 661.3760986,
            Z: -28511.07227,
            Lat: 36.07667007,
            Long: -115.1621901,
            Runways: "7,25",
            RunwayLength: "10377'",
            UHF: 257.8,
            VHF: 119.9,
            TACAN: "116X",
            VOR: "",
            ILS: [
                "25/110.30/255\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "4": {
            Name: "Nellis AFB",
            X: -399275.8438,
            Y: 561.3091431,
            Z: -18183.10938,
            Lat: 36.22566202,
            Long: -115.0438076,
            Runways: "03,21",
            RunwayLength: "9437'",
            UHF: 327,
            VHF: 132.5,
            TACAN: "12X",
            VOR: "",
            ILS: [
                "3R/109.10/029\u02DA",
                "21L/109.10/210\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "5": {
            Name: "Beatty Airport",
            X: -329733.625,
            Y: 967.133667,
            Z: -174930.5625,
            Lat: 36.8683943,
            Long: -116.7860831,
            Runways: "16,34",
            RunwayLength: "5380'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "6": {
            Name: "Boulder City Airport",
            X: -430210.6875,
            Y: 646.6636353,
            Z: -1022.358459,
            Lat: 35.94368164,
            Long: -114.8605518,
            Runways: "15,33",
            RunwayLength: "3702'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "7": {
            Name: "Echo Bay",
            X: -388670.5,
            Y: 472.0336914,
            Z: 33210.67188,
            Lat: 36.31047139,
            Long: -114.4693376,
            Runways: "6,24",
            RunwayLength: "3228'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "8": {
            Name: "Henderson Executive Airport",
            X: -428077.3438,
            Y: 759.4368896,
            Z: -25692.61914,
            Lat: 35.96746879,
            Long: -115.1334711,
            Runways: "17,35",
            RunwayLength: "4753'",
            UHF: 250.1,
            VHF: 125.1,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "9": {
            Name: "Jean Airport",
            X: -449876.7813,
            Y: 860.8758545,
            Z: -42659.71875,
            Lat: 35.77378555,
            Long: -115.3257027,
            Runways: "2,20",
            RunwayLength: "4053'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "10": {
            Name: "Laughlin Airport",
            X: -515859.9063,
            Y: 200.0001984,
            Z: 28242.04688,
            Lat: 35.16590527,
            Long: -114.5598643,
            Runways: "16,34",
            RunwayLength: "7139'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "11": {
            Name: "Lincoln County",
            X: -223999.0781,
            Y: 1467.689941,
            Z: 33240.82031,
            Lat: 37.79338959,
            Long: -114.419237,
            Runways: "17,35",
            RunwayLength: "4408'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "13": {
            Name: "Mesquite",
            X: -330275,
            Y: 566.4873657,
            Z: 68185.86719,
            Lat: 36.82734525,
            Long: -114.0603351,
            Runways: "1,19",
            RunwayLength: "4937'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "14": {
            Name: "Mina Airport 3Q0",
            X: -162089.0781,
            Y: 1390.512207,
            Z: -289514.125,
            Lat: 38.37454685,
            Long: -118.0934993,
            Runways: "13,31",
            RunwayLength: "4222'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "15": {
            Name: "North Las Vegas",
            X: -400889.9063,
            Y: 679.2798462,
            Z: -31004.8418,
            Lat: 36.21336457,
            Long: -115.1867376,
            Runways: "7,25",
            RunwayLength: "4734'",
            UHF: 360.75,
            VHF: 125.7,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "16": {
            Name: "Pahute Mesa Airstrip",
            X: -304416.4375,
            Y: 1541.363525,
            Z: -133159.0938,
            Lat: 37.09483135,
            Long: -116.3153996,
            Runways: "18,36",
            RunwayLength: "5420'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "17": {
            Name: "Tonopah Airport",
            X: -197772.3594,
            Y: 1644.139648,
            Z: -200656.875,
            Lat: 38.05802445,
            Long: -117.0759171,
            Runways: "11,29",
            RunwayLength: "5314'",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "18": {
            Name: "Tonopah Test Range Airfield",
            X: -228149.6719,
            Y: 1686.814331,
            Z: -174035.1719,
            Lat: 37.78403952,
            Long: -116.7733029,
            Runways: "14,32",
            RunwayLength: "11633'",
            UHF: 257.95,
            VHF: 124.75,
            TACAN: "77X",
            VOR: "",
            ILS: [
                "14/108.30/142\u02DA",
                "32/111.70/321\u02DA"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).MARIANAS]: {
        "1": {
            Name: "Rota Intl",
            X: 75950.77344,
            Y: 173.3801727,
            Z: 47661.18359,
            Lat: 14.1749051,
            Long: 145.2324856,
            Runways: "09,27",
            RunwayLength: "6105'",
            UHF: 250.0,
            VHF: 123.6,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "2": {
            Name: "Saipan Intl",
            X: 179620.4531,
            Y: 65.00006866,
            Z: 100743.2344,
            Lat: 15.11512163,
            Long: 145.7187983,
            Runways: "07,25",
            RunwayLength: "7790'",
            UHF: 256.9,
            VHF: 125.7,
            TACAN: "",
            VOR: "",
            ILS: [
                "07/109.90"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "3": {
            Name: "Tinian Intl",
            X: 166672,
            Y: 73.15426636,
            Z: 88785.89063,
            Lat: 14.99742938,
            Long: 145.6083061,
            Runways: "08,26",
            RunwayLength: "7777'",
            UHF: 250.05,
            VHF: 123.65,
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "4": {
            Name: "Antonio B. Won Pat Intl",
            X: -588.5232544,
            Y: 77.79207611,
            Z: -1388.050415,
            Lat: 13.479569,
            Long: 144.78477,
            Runways: "06,24",
            RunwayLength: "9359'",
            UHF: 340.2,
            VHF: 118.1,
            TACAN: "",
            VOR: "",
            ILS: [
                "06/110.30"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "5": {
            Name: "Olf Orote",
            X: -5213.99707,
            Y: 28.36422539,
            Z: -16965.1543,
            Lat: 13.43646945,
            Long: 144.641373,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "6": {
            Name: "Andersen AFB",
            X: 9961.662109,
            Y: 166.1221466,
            Z: 13072.15527,
            Lat: 13.57604707,
            Long: 144.9174589,
            Runways: "06,24",
            RunwayLength: "10490'",
            UHF: 250.1,
            VHF: 126.2,
            TACAN: "54X",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "7": {
            Name: "Pagan Airstrip",
            X: 512369.6875,
            Y: 16.033027648926,
            Z: 107433.7421875,
            Lat: 18.122779139405,
            Long: 145.76191440812,
            Runways: "06,24",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "8": {
            Name: "North West Field",
            X: 15909.4765625,
            Y: 159.00015258789,
            Z: 7619.5615234375,
            Lat: 18.122779139405,
            Long: 145.76191440812,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).SOUTH_ATLANTIC]: {
        "1": {
            Name: "Port Stanley",
            X: 89009.42969,
            Y: 20.55744362,
            Z: 94537.625,
            Lat: -51.68611764,
            Long: -57.76816164,
            Runways: "27,09",
            RunwayLength: "",
            UHF: "250.150",
            VHF: "118.100",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "2": {
            Name: "Mount Pleasant",
            X: 73598.5625,
            Y: 74.13807678,
            Z: 46176.41406,
            Lat: -51.81798045,
            Long: -58.4720474,
            Runways: "10,28",
            RunwayLength: "",
            UHF: "250.200",
            VHF: "133.350",
            TACAN: "59X",
            VOR: "114.70",
            ILS: [
                "111.90"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "3": {
            Name: "San Carlos FOB",
            X: 107859.1875,
            Y: 19.96663284,
            Z: 8631.193359,
            Lat: -51.50203963,
            Long: -59.00282194,
            Runways: "11,27",
            RunwayLength: "",
            UHF: "250.250",
            VHF: "134.350",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "5": {
            Name: "Rio Gallegos",
            X: 26083.36328,
            Y: 15.45477486,
            Z: -701836.5,
            Lat: -51.60800384,
            Long: -69.28920478,
            Runways: "25,07",
            RunwayLength: "",
            UHF: "250.300",
            VHF: "119.100",
            TACAN: "",
            VOR: "116.70",
            ILS: [
                "110.30"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "6": {
            Name: "Rio Grande",
            X: -197290.6563,
            Y: 18.52179146,
            Z: -560378.75,
            Lat: -53.77768328,
            Long: -67.76350106,
            Runways: "08,26",
            RunwayLength: "",
            UHF: "250.350",
            VHF: "117.30",
            TACAN: "31X",
            VOR: "",
            ILS: [
                "RWY 26 109.50"
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "7": {
            Name: "Ushuaia",
            X: -320821.5625,
            Y: 18.49926949,
            Z: -577284.25,
            Lat: -54.84373642,
            Long: -68.31383249,
            Runways: "07,25",
            RunwayLength: "",
            UHF: "250.400",
            VHF: "118.100",
            TACAN: "",
            VOR: "113.70",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "8": {
            Name: "Ushuaia Helo Port",
            X: -317643.0313,
            Y: 12.84391403,
            Z: -577155.5625,
            Lat: -54.81591238,
            Long: -68.30393645,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "9": {
            Name: "Punta Arenas",
            X: -148447.125,
            Y: 37.38114929,
            Z: -778803.625,
            Lat: -53.01269434,
            Long: -70.84715544,
            Runways: "30,12",
            RunwayLength: "",
            UHF: "250.500",
            VHF: "118.700",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "10": {
            Name: "Pampa Guanaco",
            X: -238376.9531,
            Y: 158.3751068,
            Z: -623417,
            Lat: -54.05023552,
            Long: -68.80356711,
            Runways: "26,8",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "11": {
            Name: "San Julian",
            X: 297758.4063,
            Y: 44.00004578,
            Z: -636012.375,
            Lat: -49.30537186,
            Long: -67.78993822,
            Runways: "25,07",
            RunwayLength: "",
            UHF: "250.000",
            VHF: "118.000",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "12": {
            Name: "Puerto Williams",
            X: -323578.4375,
            Y: 13.99996471,
            Z: -532581.4375,
            Lat: -54.93062329,
            Long: -67.63640861,
            Runways: "08,26",
            RunwayLength: "",
            UHF: "250.050",
            VHF: "118.050",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "13": {
            Name: "Puerto Natales",
            X: -24327.92773,
            Y: 66.13660431,
            Z: -922249.125,
            Lat: -51.67447612,
            Long: -72.51843416,
            Runways: "28,10",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "14": {
            Name: "El Calafate",
            X: 136666.4375,
            Y: 199.6387939,
            Z: -921364.6875,
            Lat: -50.27955475,
            Long: -72.03679295,
            Runways: "25,07",
            RunwayLength: "",
            UHF: "250.100",
            VHF: "119.950",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).SINAI]: {
        "1": {
            Name: "Difarsuwar Airfield",
            X: 40625.1640625,
            Y: 2.0000019073486,
            Z: 105362.5546875,
            Lat: 30.423828562277,
            Long: 32.335048697909,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "2": {
            Name: "Abu Suwayr",
            X: 57019.3125,
            Y: 5.6534752845764,
            Z: 83860.0390625,
            Lat: 30.570417983294,
            Long: 32.109822645849,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "3": {
            Name: "As Salihiyah",
            X: 80638.28125,
            Y: 2.2865109443665,
            Z: 77155.0625,
            Lat: 30.783020972132,
            Long: 32.037799068387,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "4": {
            Name: "Al Ismailiyah",
            X: 59102.58203125,
            Y: 3.5000035762787,
            Z: 96999.0546875,
            Lat: 30.590080139459,
            Long: 32.24668362756,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "5": {
            Name: "Melez",
            X: 37918.48828125,
            Y: 305.94686889648,
            Z: 184226.4375,
            Lat: 30.401003417138,
            Long: 33.156202467285,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "6": {
            Name: "Fayed",
            X: 30116.763671875,
            Y: 8.4882583618164,
            Z: 100213.671875,
            Lat: 30.328723193332,
            Long: 32.282131415295,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "7": {
            Name: "Hatzerim",
            X: 131615.359375,
            Y: 209.16006469727,
            Z: 328237.03125,
            Lat: 31.235724997339,
            Long: 34.669682340172,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "8": {
            Name: "Nevatim",
            X: 128765,
            Y: 397.19345092773,
            Z: 359368.625,
            Lat: 31.205363057243,
            Long: 34.995874044725,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "9": {
            Name: "Ramon Airbase",
            X: 80339.390625,
            Y: 619.02374267578,
            Z: 327491.28125,
            Lat: 30.773346519205,
            Long: 34.653849887603,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "10": {
            Name: "Ovda",
            X: -12648.833984375,
            Y: 437.17709350586,
            Z: 355426.9375,
            Lat: 29.930639915861,
            Long: 34.929106872332,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "11": {
            Name: "Kibrit Air Base",
            X: 19641.556640625,
            Y: 4.0000038146973,
            Z: 121117.6171875,
            Lat: 30.235208931832,
            Long: 32.500058570759,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "12": {
            Name: "Kedem",
            X: 134111.25,
            Y: 193.26135253906,
            Z: 326173.71875,
            Lat: 31.258515236062,
            Long: 34.648415986261,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "13": {
            Name: "Wadi al Jandali",
            X: 434.43112182617,
            Y: 228.25518798828,
            Z: 56276.01953125,
            Lat: 30.05760913971,
            Long: 31.828304106519,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "14": {
            Name: "Al Mansurah",
            X: 100415.7734375,
            Y: 2.0000019073486,
            Z: 20298.685546875,
            Lat: 30.955645437317,
            Long: 31.440851709277,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "15": {
            Name: "AzZaqaziq",
            X: 58754.62109375,
            Y: 2.0000019073486,
            Z: 41092.86328125,
            Lat: 30.582259984221,
            Long: 31.663705462571,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "16": {
            Name: "Bilbeis Air Base",
            X: 37095.92578125,
            Y: 28.000028610229,
            Z: 35651.41015625,
            Lat: 30.38627603978,
            Long: 31.609749173047,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "17": {
            Name: "Cairo International Airport",
            X: 5399.4194335938,
            Y: 120.00010681152,
            Z: 16962.88671875,
            Lat: 30.098133059692,
            Long: 31.419872765816,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "18": {
            Name: "Cairo West",
            X: 5664.8173828125,
            Y: 134.0313873291,
            Z: -33175.203125,
            Lat: 30.093241009478,
            Long: 30.899751236877,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "19": {
            Name: "Inshas Airbase",
            X: 31109.359375,
            Y: 47.1042137146,
            Z: 18786.103515625,
            Lat: 30.330287198002,
            Long: 31.435120951601,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "20": {
            Name: "Hatzor",
            X: 189237.921875,
            Y: 30.605157852173,
            Z: 331719.21875,
            Lat: 31.754913729124,
            Long: 34.715696596211,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "21": {
            Name: "Palmahim",
            X: 204512.3125,
            Y: 10.000009536743,
            Z: 328835.9375,
            Lat: 31.893066615134,
            Long: 34.687770236765,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "22": {
            Name: "Sde Dov",
            X: 229793.375,
            Y: 6.0000061988831,
            Z: 337688.125,
            Lat: 32.119759383142,
            Long: 34.785751671538,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "23": {
            Name: "Tel Nof",
            X: 197285.875,
            Y: 43.283580780029,
            Z: 341181.34375,
            Lat: 31.826102387607,
            Long: 34.816978448507,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "24": {
            Name: "Ben-Gurion",
            X: 216344.328125,
            Y: 30.125030517578,
            Z: 347410.78125,
            Lat: 31.996996567521,
            Long: 34.886274956492,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "25": {
            Name: "St Catherine",
            X: -152696.75,
            Y: 1297.2513427734,
            Z: 273158.125,
            Lat: 28.676570073217,
            Long: 34.0637788636,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "26": {
            Name: "Abu Rudeis",
            X: -127799.015625,
            Y: 0.89797097444534,
            Z: 188272.4375,
            Lat: 28.905340977704,
            Long: 33.195411869275,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "27": {
            Name: "Baluza",
            X: 104538.2265625,
            Y: 36.500038146973,
            Z: 127337.171875,
            Lat: 31.001504106029,
            Long: 32.561254631972,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "28": {
            Name: "Bir Hasanah",
            X: 14379.502929688,
            Y: 373.25036621094,
            Z: 210189.71875,
            Lat: 30.187985774894,
            Long: 33.425568649715,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "29": {
            Name: "El Arish",
            X: 107455.1328125,
            Y: 94.929046630859,
            Z: 247926.53125,
            Lat: 31.025935036084,
            Long: 33.824634027005,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        },
        "30": {
            Name: "El Gora",
            X: 112702.203125,
            Y: 128.82461547852,
            Z: 277753.84375,
            Lat: 31.070896202002,
            Long: 34.137670492733,
            Runways: "",
            RunwayLength: "",
            UHF: "",
            VHF: "",
            TACAN: "",
            VOR: "",
            ILS: [
                ""
            ],
            Elevation: "",
            "MF/HF": "",
            ICAO: ""
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).KOLA]: {
        "1": {
            Id: "1",
            Name: "Lakselv",
            X: 233623.484375,
            Y: 5.2753481864929,
            Z: 88526.1171875,
            Lat: 70.057759938201,
            Lon: 24.975276128064
        },
        "2": {
            Id: "2",
            Name: "Rovaniemi",
            X: -151314.21875,
            Y: 186.5428314209,
            Z: 152281.609375,
            Lat: 66.574566219304,
            Lon: 25.849959054083
        },
        "3": {
            Id: "3",
            Name: "Kemi Tornio",
            X: -242203.125,
            Y: 14.260339736938,
            Z: 101322.7734375,
            Lat: 65.792105051259,
            Lon: 24.586346222607
        },
        "4": {
            Id: "4",
            Name: "Bas 100",
            X: -92977.59375,
            Y: 224.3041229248,
            Z: 178726.296875,
            Lat: 67.075946867342,
            Lon: 26.560454027496
        },
        "5": {
            Id: "5",
            Name: "Kiruna",
            X: -19536.68359375,
            Y: 437.3486328125,
            Z: -89975.9921875,
            Lat: 67.830309878359,
            Lon: 20.352317498997
        },
        "6": {
            Id: "6",
            Name: "Severomorsk3",
            X: 147695.09375,
            Y: 172.87286376953,
            Z: 446049,
            Lat: 68.85677411136,
            Lon: 33.715938376222
        },
        "7": {
            Id: "7",
            Name: "Bodo",
            X: -67068.453125,
            Y: 7.8878412246704,
            Z: -349646.53125,
            Lat: 67.266972958478,
            Lon: 14.335477876481
        },
        "8": {
            Id: "8",
            Name: "Severomorsk1",
            X: 165326.0625,
            Y: 79.83479309082,
            Z: 429605.875,
            Lat: 69.041038945947,
            Lon: 33.404833413526
        },
        "9": {
            Id: "9",
            Name: "Olenegorsk",
            X: 70022.5234375,
            Y: 220.00268554688,
            Z: 452243.71875,
            Lat: 68.165641193625,
            Lon: 33.478248615765
        },
        "10": {
            Id: "10",
            Name: "Monchegorsk",
            X: 45776.3046875,
            Y: 166.96284484863,
            Z: 436966.53125,
            Lat: 67.980068235154,
            Lon: 33.00554585351
        },
        "11": {
            Id: "11",
            Name: "Jokkmokk",
            X: -167324.4375,
            Y: 271.79202270508,
            Z: -101186.4296875,
            Lat: 66.503506337049,
            Lon: 20.134963877353
        },
        "12": {
            Id: "12",
            Name: "Murmansk International",
            X: 132609.640625,
            Y: 76.017112731934,
            Z: 408650.03125,
            Lat: 68.790779721545,
            Lon: 32.735392362593
        },
        "13": {
            Id: "13",
            Name: "Kalixfors",
            X: -26226.8671875,
            Y: 473.07836914062,
            Z: -94382.59375,
            Lat: 67.769859948236,
            Lon: 20.249609559672
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).AFGHANISTAN]: {
        "1": {
            Id: "1",
            Name: "Herat",
            X: 27163.974609375,
            Y: 969.9853515625,
            Z: -371062.8125,
            Lat: 34.220031212738,
            Lon: 62.230129665702
        },
        "2": {
            Id: "2",
            Name: "Farah",
            X: -179584.328125,
            Y: 682.77307128906,
            Z: -377949.8125,
            Lat: 32.354876963981,
            Lon: 62.173144056959
        },
        "3": {
            Id: "3",
            Name: "Shindand",
            X: -65664.1640625,
            Y: 1132.6168212891,
            Z: -368944.5625,
            Lat: 33.383007536994,
            Lon: 62.260362260821
        },
        "4": {
            Id: "4",
            Name: "Maymana Zahiraddin Faryabi",
            X: 217346.609375,
            Y: 840.72406005859,
            Z: -140807.25,
            Lat: 35.924391322221,
            Lon: 64.76619558641
        },
        "5": {
            Id: "5",
            Name: "Chaghcharan",
            X: 63560.796875,
            Y: 2271.1975097656,
            Z: -90877.8984375,
            Lat: 34.529394368153,
            Lon: 65.280155710858
        },
        "6": {
            Id: "6",
            Name: "Qala i Naw",
            X: 112515.5546875,
            Y: 889.08715820312,
            Z: -288784.59375,
            Lat: 34.992086349078,
            Lon: 63.124538116342
        },
        "7": {
            Id: "7",
            Name: "Kandahar",
            X: -269628.46875,
            Y: 1016.9556884766,
            Z: -28470.814453125,
            Lat: 31.513217729616,
            Lon: 65.860714738417
        },
        "8": {
            Id: "8",
            Name: "Bost",
            X: -268069.53125,
            Y: 776.12280273438,
            Z: -170755.5625,
            Lat: 31.55201665208,
            Lon: 64.363255135089
        },
        "9": {
            Id: "9",
            Name: "Tarinkot",
            X: -148011.875,
            Y: 1333.1419677734,
            Z: -32091.802734375,
            Lat: 32.609904004956,
            Lon: 65.856509652753
        },
        "10": {
            Id: "10",
            Name: "Camp Bastion",
            X: -236770.609375,
            Y: 879.70733642578,
            Z: -184686.5,
            Lat: 31.835819789783,
            Lon: 64.22020303609
        },
        "11": {
            Id: "11",
            Name: "Dwyer",
            X: -320083.34375,
            Y: 731.04968261719,
            Z: -199276.921875,
            Lat: 31.085639060294,
            Lon: 64.05755617642
        },
        "12": {
            Id: "12",
            Name: "Nimroz",
            X: -332894.40625,
            Y: 483.00051879883,
            Z: -390513.4375,
            Lat: 30.970914944055,
            Lon: 62.053757073272
        },
        "13": {
            Id: "13",
            Name: "Camp Bastion Heliport",
            X: -234788.125,
            Y: 884.36590576172,
            Z: -185436.375,
            Lat: 31.853777562069,
            Lon: 64.212513895988
        },
        "14": {
            Id: "14",
            Name: "Shindand Heliport",
            X: -63020.765625,
            Y: 1157.8818359375,
            Z: -368217.8125,
            Lat: 33.406894837978,
            Lon: 62.267975429692
        },
        "15": {
            Id: "15",
            Name: "Kandahar Heliport",
            X: -268791.6875,
            Y: 1017.0010375977,
            Z: -29800.087890625,
            Lat: 31.521070343338,
            Lon: 65.84696137969
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).GERMANY_COLD_WAR]: {
        "1": {
            Id: "1",
            Name: "Wittstock",
            X: -133381.78125,
            Y: 68.734672546387,
            Z: -531401.5625,
            Lat: 53.199829920908,
            Lon: 12.505681945199
        },
        "2": {
            Id: "2",
            Name: "Altes Lager",
            X: -270407.25,
            Y: 95.000091552734,
            Z: -515668.15625,
            Lat: 51.996909975113,
            Lon: 12.966579887285
        },
        "3": {
            Id: "3",
            Name: "Barth",
            X: -8651.1396484375,
            Y: 6.2616715431213,
            Z: -503458.71875,
            Lat: 54.338497242553,
            Lon: 12.702200003825
        },
        "4": {
            Id: "4",
            Name: "Zerbst",
            X: -263162.875,
            Y: 76.196990966797,
            Z: -570766.8125,
            Lat: 52.004064064661,
            Lon: 12.16046633084
        },
        "5": {
            Id: "5",
            Name: "Bremen",
            X: -113961.46875,
            Y: 12.412530899048,
            Z: -782363.8125,
            Lat: 53.04692278082,
            Lon: 8.7747068368897
        },
        "6": {
            Id: "6",
            Name: "Briest",
            X: -217312.5,
            Y: 35.102939605713,
            Z: -543776.1875,
            Lat: 52.440516746986,
            Lon: 12.470949907533
        },
        "7": {
            Id: "7",
            Name: "Buckeburg",
            X: -202446.65625,
            Y: 58.687442779541,
            Z: -776900.875,
            Lat: 52.277234598966,
            Lon: 9.0713377389501
        },
        "8": {
            Id: "8",
            Name: "Celle",
            X: -178054.84375,
            Y: 38.487518310547,
            Z: -705838.75,
            Lat: 52.59264739147,
            Lon: 10.039394657282
        },
        "9": {
            Id: "9",
            Name: "Cochstedt",
            X: -273168.90625,
            Y: 173.44630432129,
            Z: -624984.125,
            Lat: 51.853775281583,
            Lon: 11.400506697408
        },
        "10": {
            Id: "10",
            Name: "Damgarten",
            X: -15102.349609375,
            Y: 8.0466842651367,
            Z: -522342.78125,
            Lat: 54.260926327452,
            Lon: 12.42697408514
        },
        "11": {
            Id: "11",
            Name: "Fassberg",
            X: -143215.1875,
            Y: 77.417747497559,
            Z: -691765.0625,
            Lat: 52.919236892689,
            Lon: 10.166476832553
        },
        "12": {
            Id: "12",
            Name: "Finow",
            X: -183908.3125,
            Y: 33.956886291504,
            Z: -455300.28125,
            Lat: 52.824948996231,
            Lon: 13.711835877067
        },
        "13": {
            Id: "13",
            Name: "Garz",
            X: -70260,
            Y: 20.161508560181,
            Z: -413427.625,
            Lat: 53.875885698851,
            Lon: 14.167760742385
        },
        "14": {
            Id: "14",
            Name: "Gatow",
            X: -218568.53125,
            Y: 41.599109649658,
            Z: -497236.4375,
            Lat: 52.476596407084,
            Lon: 13.150991334237
        },
        "15": {
            Id: "15",
            Name: "Templin",
            X: -159931.609375,
            Y: 73.755645751953,
            Z: -462571.25,
            Lat: 53.032030251824,
            Lon: 13.568105196044
        },
        "16": {
            Id: "16",
            Name: "Gutersloh",
            X: -232437.53125,
            Y: 65.000068664551,
            Z: -836793,
            Lat: 51.92314781124,
            Lon: 8.2908273216415
        },
        "17": {
            Id: "17",
            Name: "Hamburg",
            X: -62281.59765625,
            Y: 22.186412811279,
            Z: -690651.875,
            Lat: 53.635091523403,
            Lon: 9.9986059961522
        },
        "18": {
            Id: "18",
            Name: "Hamburg Finkenwerder",
            X: -72139.3515625,
            Y: 3.0125162601471,
            Z: -704111.9375,
            Lat: 53.529413746175,
            Lon: 9.8221409036071
        },
        "19": {
            Id: "19",
            Name: "Hannover",
            X: -189958.71875,
            Y: 51.180934906006,
            Z: -730444.375,
            Lat: 52.453768953697,
            Lon: 9.7104206816058
        },
        "20": {
            Id: "20",
            Name: "Laage",
            X: -51583.10546875,
            Y: 35.000034332275,
            Z: -537832.6875,
            Lat: 53.919812047092,
            Lon: 12.2608407156
        },
        "21": {
            Id: "21",
            Name: "Larz",
            X: -123645.0078125,
            Y: 63.238056182861,
            Z: -514746.75,
            Lat: 53.303900602217,
            Lon: 12.735599800492
        },
        "22": {
            Id: "22",
            Name: "Mahlwinkel",
            X: -217904.203125,
            Y: 43.490783691406,
            Z: -586974,
            Lat: 52.387952762397,
            Lon: 11.84444320285
        },
        "23": {
            Id: "23",
            Name: "Neubrandenburg",
            X: -94698.859375,
            Y: 54.000053405762,
            Z: -474266.40625,
            Lat: 53.602182151792,
            Lon: 13.290616335329
        },
        "24": {
            Id: "24",
            Name: "Neuruppin",
            X: -163955.109375,
            Y: 45.00004196167,
            Z: -517122.59375,
            Lat: 52.942843359419,
            Lon: 12.769585773506
        },
        "25": {
            Id: "25",
            Name: "Peenemunde",
            X: -35345.07421875,
            Y: 7.0000071525574,
            Z: -436765.34375,
            Lat: 54.166542452148,
            Lon: 13.761408138595
        },
        "26": {
            Id: "26",
            Name: "Schonefeld",
            X: -231248.421875,
            Y: 44.525234222412,
            Z: -470959.3125,
            Lat: 52.388535022049,
            Lon: 13.553727177273
        },
        "27": {
            Id: "27",
            Name: "Stendal",
            X: -190949.625,
            Y: 37.21475982666,
            Z: -586166.8125,
            Lat: 52.628094328336,
            Lon: 11.805939738515
        },
        "28": {
            Id: "28",
            Name: "Tegel",
            X: -210495.984375,
            Y: 35.237186431885,
            Z: -485475.21875,
            Lat: 52.559846322265,
            Lon: 13.309964659488
        },
        "29": {
            Id: "29",
            Name: "Tempelhof",
            X: -220525,
            Y: 47.000045776367,
            Z: -481058.6875,
            Lat: 52.474681358442,
            Lon: 13.3900841494
        },
        "30": {
            Id: "30",
            Name: "Tutow",
            X: -57639.609375,
            Y: 2.0000011920929,
            Z: -475128.375,
            Lat: 53.931396141848,
            Lon: 13.216531233063
        },
        "31": {
            Id: "31",
            Name: "Werneuchen",
            X: -205706.171875,
            Y: 78.79825592041,
            Z: -454838.59375,
            Lat: 52.630983620979,
            Lon: 13.751115547377
        },
        "32": {
            Id: "32",
            Name: "Wunstorf",
            X: -186536.828125,
            Y: 50.497585296631,
            Z: -748622.125,
            Lat: 52.458255852582,
            Lon: 9.440303407026
        },
        "53": {
            Id: "53",
            Name: "H FRG 01",
            X: -220040.9375,
            Y: 0.0,
            Z: -672240.625,
            Lat: 52.266052222407,
            Lon: 10.615636790158
        },
        "54": {
            Id: "54",
            Name: "H FRG 02",
            X: -41757.125,
            Y: 0.0,
            Z: -644331.75,
            Lat: 53.878601072254,
            Lon: 10.642456095091
        },
        "55": {
            Id: "55",
            Name: "H FRG 03",
            X: -62719.40234375,
            Y: 0.0,
            Z: -681190.25,
            Lat: 53.644214610792,
            Lon: 10.14012873697
        },
        "56": {
            Id: "56",
            Name: "H FRG 04",
            X: -88846.953125,
            Y: 0.0,
            Z: -659675.875,
            Lat: 53.442230220956,
            Lon: 10.517905440044
        },
        "57": {
            Id: "57",
            Name: "H FRG 05",
            X: -124321.6484375,
            Y: 0.0,
            Z: -635677.4375,
            Lat: 53.15928653074,
            Lon: 10.948311270422
        },
        "58": {
            Id: "58",
            Name: "H FRG 06",
            X: -112638.0546875,
            Y: 0.0,
            Z: -773002,
            Lat: 53.072719561287,
            Lon: 8.9079381365481
        },
        "59": {
            Id: "59",
            Name: "H FRG 07",
            X: -131374.328125,
            Y: 0.0,
            Z: -620658,
            Lat: 53.115474725775,
            Lon: 11.184009018108
        },
        "60": {
            Id: "60",
            Name: "H FRG 08",
            X: -182536.609375,
            Y: 0.0,
            Z: -665769.0625,
            Lat: 52.60601430655,
            Lon: 10.630504445187
        },
        "61": {
            Id: "61",
            Name: "H FRG 09",
            X: -194336.296875,
            Y: 0.0,
            Z: -652736.125,
            Lat: 52.518207460779,
            Lon: 10.84431233294
        },
        "62": {
            Id: "62",
            Name: "H FRG 10",
            X: -198084.515625,
            Y: 0.0,
            Z: -727524.5625,
            Lat: 52.386184662242,
            Lon: 9.7710171326285
        },
        "64": {
            Id: "64",
            Name: "H FRG 12",
            X: -65731.96875,
            Y: 0.0,
            Z: -637241.875,
            Lat: 53.675743074639,
            Lon: 10.800684948562
        },
        "65": {
            Id: "65",
            Name: "H FRG 13",
            X: -223972.890625,
            Y: 0.0,
            Z: -814741.875,
            Lat: 52.031402475665,
            Lon: 8.5830617461302
        },
        "66": {
            Id: "66",
            Name: "H FRG 14",
            X: -220416.890625,
            Y: 0.0,
            Z: -492494.75,
            Lat: 52.464729299576,
            Lon: 13.223080583792
        },
        "67": {
            Id: "67",
            Name: "H GDR 01",
            X: -95275.09375,
            Y: 0.0,
            Z: -618294.5625,
            Lat: 53.438106510829,
            Lon: 11.144805943632
        },
        "68": {
            Id: "68",
            Name: "H GDR 02",
            X: -196614.25,
            Y: 0.0,
            Z: -549177.5625,
            Lat: 52.618755400439,
            Lon: 12.356065171789
        },
        "69": {
            Id: "69",
            Name: "H GDR 03",
            X: -150750.453125,
            Y: 0.0,
            Z: -464421.0625,
            Lat: 53.112140616687,
            Lon: 13.526520000818
        },
        "70": {
            Id: "70",
            Name: "H GDR 04",
            X: -103572.6953125,
            Y: 0.0,
            Z: -473247.65625,
            Lat: 53.524124178178,
            Lon: 13.320290651004
        },
        "71": {
            Id: "71",
            Name: "H GDR 05",
            X: -94853.046875,
            Y: 0.0,
            Z: -433827.40625,
            Lat: 53.63853075279,
            Lon: 13.897127889753
        },
        "72": {
            Id: "72",
            Name: "H GDR 06",
            X: -220710.5625,
            Y: 0.0,
            Z: -539810.5,
            Lat: 52.414478265231,
            Lon: 12.534485468828
        },
        "73": {
            Id: "73",
            Name: "H GDR 07",
            X: -150546.3125,
            Y: 0.0,
            Z: -587952.9375,
            Lat: 52.984531389089,
            Lon: 11.703076964725
        },
        "74": {
            Id: "74",
            Name: "H GDR 08",
            X: -195804.859375,
            Y: 0.0,
            Z: -467992.375,
            Lat: 52.707229613611,
            Lon: 13.543297934126
        },
        "75": {
            Id: "75",
            Name: "H GDR 09",
            X: -64018.75,
            Y: 0.0,
            Z: -482535.15625,
            Lat: 53.867263794322,
            Lon: 13.11555266614
        },
        "76": {
            Id: "76",
            Name: "H GDR 10",
            X: -218167.875,
            Y: 0.0,
            Z: -471591.6875,
            Lat: 52.504550973527,
            Lon: 13.524689501184
        },
        "77": {
            Id: "77",
            Name: "H GDR 11",
            X: -232004.6875,
            Y: 0.0,
            Z: -467087,
            Lat: 52.385353110327,
            Lon: 13.611285030873
        },
        "78": {
            Id: "78",
            Name: "H FRG 15",
            X: -205692.109375,
            Y: 0.0,
            Z: -484623.65625,
            Lat: 52.603458341672,
            Lon: 13.31488687313
        },
        "80": {
            Id: "80",
            Name: "Gross Mohrdorf",
            X: -4493.5249023438,
            Y: 3.0000030994415,
            Z: -490113.65625,
            Lat: 54.389383912564,
            Lon: 12.898064514909
        },
        "81": {
            Id: "81",
            Name: "Lubeck",
            X: -50779.29296875,
            Y: 22.75500869751,
            Z: -641691.5625,
            Lat: 53.80225828922,
            Lon: 10.701777240816
        },
        "82": {
            Id: "82",
            Name: "Kothen",
            X: -292969.28125,
            Y: 86.643325805664,
            Z: -587093.375,
            Lat: 51.721398295091,
            Lon: 11.979095583118
        },
        "83": {
            Id: "83",
            Name: "Dessau",
            X: -282368.34375,
            Y: 59.58052444458,
            Z: -571964.875,
            Lat: 51.832133456077,
            Lon: 12.176999067877
        },
        "84": {
            Id: "84",
            Name: "Parchim",
            X: -102494.0078125,
            Y: 52.000053405762,
            Z: -577197.9375,
            Lat: 53.423303560796,
            Lon: 11.76925391755
        },
        "85": {
            Id: "85",
            Name: "H GDR 12",
            X: -204987.328125,
            Y: 0.0,
            Z: -602388.6875,
            Lat: 52.484844180629,
            Lon: 11.596375968381
        },
        "86": {
            Id: "86",
            Name: "Uetersen",
            X: -58093.3125,
            Y: 7.0000061988831,
            Z: -709294.25,
            Lat: 53.645944070975,
            Lon: 9.7120891115921
        },
        "89": {
            Id: "89",
            Name: "Luneburg",
            X: -109700.5859375,
            Y: 45.125038146973,
            Z: -666435.9375,
            Lat: 53.24903428572,
            Lon: 10.463902491278
        },
        "90": {
            Id: "90",
            Name: "Northeim",
            X: -146422.03125,
            Y: 14.960956573486,
            Z: -618667.625,
            Lat: 52.984605972131,
            Lon: 11.243761975715
        },
        "91": {
            Id: "91",
            Name: "H GDR 13",
            X: -85572.9609375,
            Y: 0.0,
            Z: -545707.4375,
            Lat: 53.60917277054,
            Lon: 12.206163928849
        },
        "92": {
            Id: "92",
            Name: "H GDR 14",
            X: -157286.015625,
            Y: 0.0,
            Z: -474879.875,
            Lat: 53.044029315232,
            Lon: 13.381988717978
        },
        "93": {
            Id: "93",
            Name: "H GDR 15",
            X: -243124.15625,
            Y: 0.0,
            Z: -567018.875,
            Lat: 52.186172497558,
            Lon: 12.179097394042
        },
        "94": {
            Id: "94",
            Name: "H GDR 16",
            X: -235841.890625,
            Y: 0.0,
            Z: -593646.375,
            Lat: 52.221176148039,
            Lon: 11.781077452687
        },
        "95": {
            Id: "95",
            Name: "H GDR 17",
            X: -46310.67578125,
            Y: 0.0,
            Z: -595276.4375,
            Lat: 53.900058787899,
            Lon: 11.387239910772
        },
        "96": {
            Id: "96",
            Name: "H FRG 16",
            X: -225079.71875,
            Y: 0.0,
            Z: -754555.25,
            Lat: 52.110313394488,
            Lon: 9.4446431471309
        },
        "97": {
            Id: "97",
            Name: "H FRG 17",
            X: -110358.359375,
            Y: 0.0,
            Z: -733413.125,
            Lat: 53.151012480768,
            Lon: 9.4812816497498
        },
        "98": {
            Id: "98",
            Name: "H FRG 18",
            X: -10776.405273438,
            Y: 0.0,
            Z: -645730.9375,
            Lat: 54.150634771533,
            Lon: 10.55237485751
        },
        "99": {
            Id: "99",
            Name: "H FRG 19",
            X: -80211.484375,
            Y: 0.0,
            Z: -699572.125,
            Lat: 53.464557662867,
            Lon: 9.908176622337
        },
        "100": {
            Id: "100",
            Name: "H FRG 11",
            X: -154631.640625,
            Y: 0.0,
            Z: -701429.875,
            Lat: 52.805370361471,
            Lon: 10.05105017187
        },
        "101": {
            Id: "101",
            Name: "Sperenberg",
            X: -257646.046875,
            Y: 56.572044372559,
            Z: -489559.09375,
            Lat: 52.135869814455,
            Lon: 13.323818703394
        },
        "102": {
            Id: "102",
            Name: "Uelzen",
            X: -139164.71875,
            Y: 75.89427947998,
            Z: -670244.25,
            Lat: 52.983634526237,
            Lon: 10.472323432657
        },
        "103": {
            Id: "103",
            Name: "Dedelow",
            X: -125383.015625,
            Y: 53.558223724365,
            Z: -444937.8125,
            Lat: 53.356240443418,
            Lon: 13.777079413204
        },
        "104": {
            Id: "104",
            Name: "Kammermark",
            X: -131056.46875,
            Y: 87.381820678711,
            Z: -554675.875,
            Lat: 53.195244581502,
            Lon: 12.157065666545
        },
        "106": {
            Id: "106",
            Name: "Weser Wumme",
            X: -117320.9921875,
            Y: 24.960800170898,
            Z: -753220.4375,
            Lat: 53.060947127645,
            Lon: 9.2083208560006
        },
        "107": {
            Id: "107",
            Name: "Braunschweig",
            X: -213625.375,
            Y: 83.225402832031,
            Z: -674902.75,
            Lat: 52.31935950815,
            Lon: 10.563799154846
        },
        "108": {
            Id: "108",
            Name: "Wismar",
            X: -45719.328125,
            Y: 9.816312789917,
            Z: -587821.5,
            Lat: 53.914290075186,
            Lon: 11.497933357773
        },
        "109": {
            Id: "109",
            Name: "Waren Vielist",
            X: -93757.8125,
            Y: 79.693450927734,
            Z: -516400.4375,
            Lat: 53.568007510225,
            Lon: 12.658787366903
        },
        "110": {
            Id: "110",
            Name: "Bienenfarm",
            X: -195466.953125,
            Y: 30.018665313721,
            Z: -521948.6875,
            Lat: 52.657534411885,
            Lon: 12.752095083792
        },
        "111": {
            Id: "111",
            Name: "Pinnow",
            X: -78780.8203125,
            Y: 45.427276611328,
            Z: -587778.3125,
            Lat: 53.621227778112,
            Lon: 11.56513810091
        },
        "112": {
            Id: "112",
            Name: "Gardelegen",
            X: -198085.234375,
            Y: 55.785251617432,
            Z: -617911.0625,
            Lat: 52.527720937387,
            Lon: 11.357485557652
        },
        "113": {
            Id: "113",
            Name: "Glindbruchkippe ",
            X: -209110.28125,
            Y: 48.427280426025,
            Z: -701358.8125,
            Lat: 52.324522653465,
            Lon: 10.172631618018
        },
        "114": {
            Id: "114",
            Name: "Ummern",
            X: -178987.890625,
            Y: 66.633346557617,
            Z: -680130.8125,
            Lat: 52.61872936989,
            Lon: 10.414364168969
        },
        "115": {
            Id: "115",
            Name: "Hildesheim",
            X: -222738.34375,
            Y: 98.000099182129,
            Z: -718630.25,
            Lat: 52.180930844778,
            Lon: 9.954168862081
        },
        "116": {
            Id: "116",
            Name: "Verden-Scharnhorst",
            X: -128418.53125,
            Y: 44.801300048828,
            Z: -750335.875,
            Lat: 52.967502221122,
            Lon: 9.2773389153295
        },
        "117": {
            Id: "117",
            Name: "Rinteln",
            X: -213398.234375,
            Y: 53.064262390137,
            Z: -780286.8125,
            Lat: 52.175927172397,
            Lon: 9.0490595276539
        },
        "118": {
            Id: "118",
            Name: "Holzdorf",
            X: -297609.9375,
            Y: 74.765602111816,
            Z: -503198.5625,
            Lat: 51.766820715034,
            Lon: 13.188867267665
        },
        "119": {
            Id: "119",
            Name: "H Med GDR 01",
            X: -30940.408203125,
            Y: 0.0,
            Z: -546656.6875,
            Lat: 54.093303695956,
            Lon: 12.088701425931
        },
        "120": {
            Id: "120",
            Name: "H Med GDR 02",
            X: -15433.755859375,
            Y: 0.0,
            Z: -479944.1875,
            Lat: 54.302375780369,
            Lon: 13.072044215918
        },
        "121": {
            Id: "121",
            Name: "H Med GDR 03",
            X: -41087.23046875,
            Y: 0.0,
            Z: -462763.625,
            Lat: 54.090877530646,
            Lon: 13.37611308005
        },
        "122": {
            Id: "122",
            Name: "H GDR 33",
            X: -377164.40625,
            Y: 0.0,
            Z: -685670.1875,
            Lat: 50.859187973135,
            Lon: 10.743132308626
        },
        "123": {
            Id: "123",
            Name: "Airracing Koblenz",
            X: -407457.53125,
            Y: 322.00030517578,
            Z: -900929.125,
            Lat: 50.288812597402,
            Lon: 7.8335943900546
        },
        "124": {
            Id: "124",
            Name: "H GDR 34",
            X: -148483.109375,
            Y: 0.0,
            Z: -524805.5,
            Lat: 53.072505918209,
            Lon: 12.629696245089
        },
        "126": {
            Id: "126",
            Name: "H Med GDR 08",
            X: -231163.9375,
            Y: 0.0,
            Z: -586332.9375,
            Lat: 52.270980873787,
            Lon: 11.878193030808
        },
        "127": {
            Id: "127",
            Name: "H Med GDR 09",
            X: -241050.6875,
            Y: 0.0,
            Z: -604574.125,
            Lat: 52.162426005329,
            Lon: 11.633035921979
        },
        "128": {
            Id: "128",
            Name: "H Med GDR 10",
            X: -267572.75,
            Y: 0.0,
            Z: -575447.4375,
            Lat: 51.959777712263,
            Lon: 12.100928575513
        },
        "129": {
            Id: "129",
            Name: "H Med FRG 01",
            X: -45588.9140625,
            Y: 0.0,
            Z: -641827.75,
            Lat: 53.847980470494,
            Lon: 10.688355159494
        },
        "130": {
            Id: "130",
            Name: "H Med FRG 02",
            X: -70712.65625,
            Y: 0.0,
            Z: -690217.4375,
            Lat: 53.561298412854,
            Lon: 10.024595415562
        },
        "132": {
            Id: "132",
            Name: "H Med FRG 04",
            X: -108681.2421875,
            Y: 0.0,
            Z: -670744.3125,
            Lat: 53.252349809156,
            Lon: 10.398180579467
        },
        "134": {
            Id: "134",
            Name: "H Med FRG 06",
            X: -198269.75,
            Y: 0.0,
            Z: -788763.5,
            Lat: 52.296394350486,
            Lon: 8.8911551827461
        },
        "139": {
            Id: "139",
            Name: "H Med FRG 11",
            X: -259561.75,
            Y: 0.0,
            Z: -807106.875,
            Lat: 51.730316076157,
            Lon: 8.7782169215562
        },
        "140": {
            Id: "140",
            Name: "Hasselfelde",
            X: -284775.96875,
            Y: 493.427734375,
            Z: -662595.625,
            Lat: 51.705472413151,
            Lon: 10.885994253382
        },
        "141": {
            Id: "141",
            Name: "Grosse Wiese",
            X: -233879.359375,
            Y: 84.68383026123,
            Z: -676982.5,
            Lat: 52.137599710741,
            Lon: 10.576288490099
        },
        "142": {
            Id: "142",
            Name: "H GDR 18",
            X: -267812.65625,
            Y: 0.0,
            Z: -668572.5,
            Lat: 51.848136954636,
            Lon: 10.766606261039
        },
        "143": {
            Id: "143",
            Name: "H FRG 20",
            X: -281004.25,
            Y: 0.0,
            Z: -682905.6875,
            Lat: 51.71330644203,
            Lon: 10.589120624646
        },
        "144": {
            Id: "144",
            Name: "H Med FRG 12",
            X: -266955.59375,
            Y: 0.0,
            Z: -698609.4375,
            Lat: 51.817207348048,
            Lon: 10.336157428475
        },
        "145": {
            Id: "145",
            Name: "H GDR 19",
            X: -273065.15625,
            Y: 0.0,
            Z: -632426.5625,
            Lat: 51.845871100178,
            Lon: 11.293790069798
        },
        "146": {
            Id: "146",
            Name: "H GDR 30",
            X: 3790.9597167969,
            Y: 0.0,
            Z: -442071.6875,
            Lat: 54.510482801775,
            Lon: 13.618227240312
        },
        "147": {
            Id: "147",
            Name: "H Med GDR 11",
            X: -276599.96875,
            Y: 0.0,
            Z: -668144.5,
            Lat: 51.770919899172,
            Lon: 10.790493115004
        },
        "148": {
            Id: "148",
            Name: "H FRG 21",
            X: -212554.609375,
            Y: 0.0,
            Z: -669507.0625,
            Lat: 52.335758238184,
            Lon: 10.639428501737
        },
        "149": {
            Id: "149",
            Name: "H FRG 50",
            X: -148824.875,
            Y: 0.0,
            Z: -719459.25,
            Lat: 52.831764291632,
            Lon: 9.7753136950266
        },
        "150": {
            Id: "150",
            Name: "H FRG 23",
            X: -139513.578125,
            Y: 0.0,
            Z: -694687.0625,
            Lat: 52.947967528838,
            Lon: 10.115503448252
        },
        "151": {
            Id: "151",
            Name: "H FRG 39",
            X: -397539.96875,
            Y: 0.0,
            Z: -763954,
            Lat: 50.577255260524,
            Lon: 9.6955794689909
        },
        "152": {
            Id: "152",
            Name: "H GDR 21",
            X: -13600.244140625,
            Y: 0.0,
            Z: -516123.125,
            Lat: 54.281005861849,
            Lon: 12.518647174113
        },
        "153": {
            Id: "153",
            Name: "H GDR 22",
            X: -263161.71875,
            Y: 0.0,
            Z: -506378.15625,
            Lat: 52.070556522737,
            Lon: 13.089145860158
        },
        "154": {
            Id: "154",
            Name: "Fritzlar",
            X: -333799.96875,
            Y: 168.1029510498,
            Z: -782950.9375,
            Lat: 51.112495707409,
            Lon: 9.2911242390732
        },
        "155": {
            Id: "155",
            Name: "Hahn",
            X: -436889.46875,
            Y: 494.1369934082,
            Z: -947583.875,
            Lat: 49.956484778758,
            Lon: 7.2723298639052
        },
        "156": {
            Id: "156",
            Name: "Sembach",
            X: -494129.46875,
            Y: 311.43463134766,
            Z: -913120.625,
            Lat: 49.510638990257,
            Lon: 7.8782175645345
        },
        "157": {
            Id: "157",
            Name: "Allstedt",
            X: -325835.84375,
            Y: 283.31329345703,
            Z: -627545,
            Lat: 51.38381203936,
            Lon: 11.463156911303
        },
        "158": {
            Id: "158",
            Name: "Zweibrucken",
            X: -522124.03125,
            Y: 340.21948242188,
            Z: -954430.0625,
            Lat: 49.200480802653,
            Lon: 7.3924126213119
        },
        "159": {
            Id: "159",
            Name: "Giebelstadt",
            X: -503428.15625,
            Y: 290.41006469727,
            Z: -761145.875,
            Lat: 49.64673958393,
            Lon: 9.9543480025954
        },
        "160": {
            Id: "160",
            Name: "Schweinfurt",
            X: -461185,
            Y: 229.54638671875,
            Z: -738823.8125,
            Lat: 50.048891656981,
            Lon: 10.173991945804
        },
        "161": {
            Id: "161",
            Name: "Haina",
            X: -360303,
            Y: 310.00030517578,
            Z: -701054.6875,
            Lat: 50.988977855103,
            Lon: 10.494267882953
        },
        "162": {
            Id: "162",
            Name: "Spangdahlem",
            X: -426028.21875,
            Y: 300.00030517578,
            Z: -986801.0625,
            Lat: 49.985889217803,
            Lon: 6.7136498802471
        },
        "163": {
            Id: "163",
            Name: "Frankfurt",
            X: -444328.125,
            Y: 100.00009918213,
            Z: -855231.9375,
            Lat: 50.035444146771,
            Lon: 8.5453319733434
        },
        "164": {
            Id: "164",
            Name: "Bindersleben",
            X: -365685.4375,
            Y: 309.47366333008,
            Z: -669398.9375,
            Lat: 50.980820379202,
            Lon: 10.948639987704
        },
        "165": {
            Id: "165",
            Name: "Ramstein",
            X: -498536.09375,
            Y: 245.30303955078,
            Z: -935772.8125,
            Lat: 49.436513772802,
            Lon: 7.5845117809856
        },
        "166": {
            Id: "166",
            Name: "Fulda",
            X: -401142.09375,
            Y: 285.5856628418,
            Z: -768015.8125,
            Lat: 50.539950897448,
            Lon: 9.6470694578512
        },
        "167": {
            Id: "167",
            Name: "Obermehler Schlotheim",
            X: -330472,
            Y: 271.03067016602,
            Z: -687425.1875,
            Lat: 51.270072958671,
            Lon: 10.625673657584
        },
        "168": {
            Id: "168",
            Name: "Mendig",
            X: -392153.28125,
            Y: 183.05128479004,
            Z: -935225.375,
            Lat: 50.367587223332,
            Lon: 7.3265155003307
        },
        "169": {
            Id: "169",
            Name: "Merseburg",
            X: -332475.96875,
            Y: 103.5025177002,
            Z: -595257.9375,
            Lat: 51.361551540134,
            Lon: 11.932952555931
        },
        "170": {
            Id: "170",
            Name: "Wiesbaden",
            X: -440158.5625,
            Y: 137.93103027344,
            Z: -871687.125,
            Lat: 50.04735254785,
            Lon: 8.3113292085411
        },
        "171": {
            Id: "171",
            Name: "Leipzig Halle",
            X: -329544.96875,
            Y: 128.34651184082,
            Z: -572988.3125,
            Lat: 51.41182694254,
            Lon: 12.24402305039
        },
        "180": {
            Id: "180",
            Name: "H Med GDR 12",
            X: -358612.625,
            Y: 0.0,
            Z: -713512.0625,
            Lat: 50.98791492918,
            Lon: 10.316367731737
        },
        "181": {
            Id: "181",
            Name: "H Med GDR 13",
            X: -329506.96875,
            Y: 0.0,
            Z: -678944.375,
            Lat: 51.289264687317,
            Lon: 10.743367281466
        },
        "182": {
            Id: "182",
            Name: "H Med GDR 14",
            X: -377418.75,
            Y: 0.0,
            Z: -723266.8125,
            Lat: 50.809082072314,
            Lon: 10.218730106234
        },
        "184": {
            Id: "184",
            Name: "H Med GDR 16",
            X: -382416.0625,
            Y: 0.0,
            Z: -623949.5625,
            Lat: 50.886089255741,
            Lon: 11.617336509284
        },
        "185": {
            Id: "185",
            Name: "H GDR 24",
            X: -255385.359375,
            Y: 0.0,
            Z: -478253.875,
            Lat: 52.166625973472,
            Lon: 13.484153654033
        },
        "186": {
            Id: "186",
            Name: "H Med FRG 13",
            X: -499112.625,
            Y: 0.0,
            Z: -922274.5,
            Lat: 49.452728251598,
            Lon: 7.7670972387481
        },
        "187": {
            Id: "187",
            Name: "H Med FRG 14",
            X: -354706.96875,
            Y: 0.0,
            Z: -749508.1875,
            Lat: 50.974670365201,
            Lon: 9.8047104832976
        },
        "188": {
            Id: "188",
            Name: "H Med FRG 15",
            X: -318794.1875,
            Y: 0.0,
            Z: -774213.4375,
            Lat: 51.257019015633,
            Lon: 9.3797327456911
        },
        "189": {
            Id: "189",
            Name: "H Med FRG 16",
            X: -273869.28125,
            Y: 0.0,
            Z: -841198.5,
            Lat: 51.552894603829,
            Lon: 8.332072415314
        },
        "190": {
            Id: "190",
            Name: "H Med FRG 17",
            X: -306133.875,
            Y: 0.0,
            Z: -752297.125,
            Lat: 51.399204257128,
            Lon: 9.6597540494487
        },
        "191": {
            Id: "191",
            Name: "H FRG 25",
            X: -383822.625,
            Y: 0.0,
            Z: -744826.75,
            Lat: 50.724075335035,
            Lon: 9.9318838308264
        },
        "193": {
            Id: "193",
            Name: "H Radar GDR 01",
            X: -271654.875,
            Y: 0.0,
            Z: -679917.1875,
            Lat: 51.799797025439,
            Lon: 10.612503104672
        },
        "194": {
            Id: "194",
            Name: "H Radar GDR 02",
            X: -402316.3125,
            Y: 0.0,
            Z: -736558.6875,
            Lat: 50.571777454623,
            Lon: 10.085249722822
        },
        "195": {
            Id: "195",
            Name: "H Radar GDR 03",
            X: -344062.625,
            Y: 0.0,
            Z: -720118.0625,
            Lat: 51.107845343406,
            Lon: 10.193685961616
        },
        "196": {
            Id: "196",
            Name: "H Radar GDR 04",
            X: -292226.375,
            Y: 0.0,
            Z: -675013.875,
            Lat: 51.624038596637,
            Lon: 10.724235389591
        },
        "197": {
            Id: "197",
            Name: "H Radar GDR 05",
            X: -249862.25,
            Y: 0.0,
            Z: -669029.0625,
            Lat: 52.006374321327,
            Lon: 10.723485802686
        },
        "198": {
            Id: "198",
            Name: "H Radar GDR 06",
            X: -221399.046875,
            Y: 0.0,
            Z: -614268.375,
            Lat: 52.325382276089,
            Lon: 11.45559704004
        },
        "199": {
            Id: "199",
            Name: "H Radar GDR 07",
            X: -112177.7109375,
            Y: 0.0,
            Z: -624960.0625,
            Lat: 53.280174268017,
            Lon: 11.081132170543
        },
        "200": {
            Id: "200",
            Name: "Bitburg",
            X: -428053.96875,
            Y: 368.22198486328,
            Z: -997282.6875,
            Lat: 49.950342486546,
            Lon: 6.5774226211865
        },
        "201": {
            Id: "201",
            Name: "Airracing Lubeck",
            X: -61852.5546875,
            Y: 8.5000085830688,
            Z: -638823.9375,
            Lat: 53.708027235578,
            Lon: 10.76870991191
        },
        "202": {
            Id: "202",
            Name: "H FRG 27",
            X: -312523.59375,
            Y: 0.0,
            Z: -766281.625,
            Lat: 51.32342155121,
            Lon: 9.4770912119768
        },
        "204": {
            Id: "204",
            Name: "Airracing Frankfurt",
            X: -441938.4375,
            Y: 83.279518127441,
            Z: -888022.75,
            Lat: 50.006800963507,
            Lon: 8.0931538163611
        },
        "208": {
            Id: "208",
            Name: "H Med FRG 21",
            X: -516712.21875,
            Y: 0.0,
            Z: -955473.5625,
            Lat: 49.246116641484,
            Lon: 7.3652304476851
        },
        "211": {
            Id: "211",
            Name: "H FRG 30",
            X: -430928.90625,
            Y: 0.0,
            Z: -940813.5,
            Lat: 50.019607671412,
            Lon: 7.3490182855151
        },
        "212": {
            Id: "212",
            Name: "H FRG 31",
            X: -441193.1875,
            Y: 0.0,
            Z: -946857.9375,
            Lat: 49.920066812411,
            Lon: 7.2930424879033
        },
        "213": {
            Id: "213",
            Name: "H FRG 32",
            X: -498148.40625,
            Y: 0.0,
            Z: -913587.9375,
            Lat: 49.474708542011,
            Lon: 7.8815115420038
        },
        "215": {
            Id: "215",
            Name: "H FRG 34",
            X: -388266.375,
            Y: 0.0,
            Z: -926071.1875,
            Lat: 50.416492363564,
            Lon: 7.4417569021525
        },
        "218": {
            Id: "218",
            Name: "H FRG 51",
            X: -476275.59375,
            Y: 0.0,
            Z: -946843.75,
            Lat: 49.61348343317,
            Lon: 7.3810866353906
        },
        "219": {
            Id: "219",
            Name: "H FRG 38",
            X: -397840.90625,
            Y: 0.0,
            Z: -804564.0625,
            Lat: 50.517971121701,
            Lon: 9.134741397165
        },
        "220": {
            Id: "220",
            Name: "H FRG 48",
            X: -432577.4375,
            Y: 0.0,
            Z: -990782.875,
            Lat: 49.922039017769,
            Lon: 6.6771347771373
        },
        "221": {
            Id: "221",
            Name: "H FRG 49",
            X: -440818.28125,
            Y: 0.0,
            Z: -853129.4375,
            Lat: 50.069393134211,
            Lon: 8.5659104536627
        },
        "222": {
            Id: "222",
            Name: "H Med FRG 24",
            X: -276566.9375,
            Y: 0.0,
            Z: -824883.4375,
            Lat: 51.55418388054,
            Lon: 8.5683862663869
        },
        "223": {
            Id: "223",
            Name: "H Radar FRG 02",
            X: -421370.375,
            Y: 0.0,
            Z: -857727.625,
            Lat: 50.233295528292,
            Lon: 8.4578786392672
        },
        "225": {
            Id: "225",
            Name: "H Med FRG 26",
            X: -434227.3125,
            Y: 0.0,
            Z: -979057.5625,
            Lat: 49.927509476044,
            Lon: 6.8397892455214
        },
        "226": {
            Id: "226",
            Name: "H GDR 25",
            X: -355786.59375,
            Y: 0.0,
            Z: -609538.6875,
            Lat: 51.138686984776,
            Lon: 11.772348197125
        },
        "227": {
            Id: "227",
            Name: "H GDR 26",
            X: -317575.5625,
            Y: 0.0,
            Z: -595191.3125,
            Lat: 51.493926964241,
            Lon: 11.907455228486
        },
        "229": {
            Id: "229",
            Name: "H GDR 31",
            X: -8152.0322265625,
            Y: 0.0,
            Z: -478226.5,
            Lat: 54.368923189434,
            Lon: 13.085670472653
        },
        "230": {
            Id: "230",
            Name: "H GDR 32",
            X: -13186.21484375,
            Y: 0.0,
            Z: -454528.1875,
            Lat: 54.347370156731,
            Lon: 13.455492224739
        },
        "231": {
            Id: "231",
            Name: "H Med FRG 27",
            X: -435667,
            Y: 0.0,
            Z: -877882.4375,
            Lat: 50.077335272917,
            Lon: 8.2162955127311
        },
        "232": {
            Id: "232",
            Name: "Pferdsfeld",
            X: -452328.9375,
            Y: 400.05047607422,
            Z: -927059.625,
            Lat: 49.854633331487,
            Lon: 7.5887589220295
        },
        "233": {
            Id: "233",
            Name: "H Med FRG 29",
            X: -501961.8125,
            Y: 0.0,
            Z: -938323.4375,
            Lat: 49.402496283702,
            Lon: 7.5586374227809
        },
        "234": {
            Id: "234",
            Name: "H FRG 40",
            X: -394813.40625,
            Y: 0.0,
            Z: -916886.625,
            Lat: 50.374080788447,
            Lon: 7.5839601533051
        },
        "235": {
            Id: "235",
            Name: "Buchel",
            X: -410938.25,
            Y: 459.90634155273,
            Z: -958685.375,
            Lat: 50.164800508111,
            Lon: 7.0552539182038
        },
        "236": {
            Id: "236",
            Name: "Leipzig Mockau",
            X: -332672.875,
            Y: 126.59696960449,
            Z: -561152.8125,
            Lat: 51.39656025007,
            Lon: 12.417527195149
        },
        "237": {
            Id: "237",
            Name: "H FRG 43",
            X: -485798.1875,
            Y: 0.0,
            Z: -792526.8125,
            Lat: 49.760147074825,
            Lon: 9.4910914032897
        },
        "238": {
            Id: "238",
            Name: "H FRG 44",
            X: -458853.71875,
            Y: 0.0,
            Z: -830446,
            Lat: 49.94407272622,
            Lon: 8.9161840027737
        },
        "239": {
            Id: "239",
            Name: "H FRG 45",
            X: -482750.5,
            Y: 0.0,
            Z: -822902.0625,
            Lat: 49.744632687083,
            Lon: 9.0716550211019
        },
        "240": {
            Id: "240",
            Name: "H FRG 46",
            X: -457237.4375,
            Y: 0.0,
            Z: -763776.625,
            Lat: 50.050910968513,
            Lon: 9.8237998615087
        },
        "241": {
            Id: "241",
            Name: "H FRG 47",
            X: -504603.46875,
            Y: 0.0,
            Z: -805866.75,
            Lat: 49.576087841703,
            Lon: 9.3498684529008
        },
        "242": {
            Id: "242",
            Name: "Bad Durkheim",
            X: -502320.15625,
            Y: 106.00010681152,
            Z: -891343.8125,
            Lat: 49.472261211229,
            Lon: 8.1905370845889
        },
        "243": {
            Id: "243",
            Name: "Gelnhausen",
            X: -433794.9375,
            Y: 127.04621887207,
            Z: -808575.9375,
            Lat: 50.195813775009,
            Lon: 9.1594906971128
        },
        "244": {
            Id: "244",
            Name: "Herrenteich",
            X: -520535.53125,
            Y: 92.852737426758,
            Z: -872503.5625,
            Lat: 49.340611646103,
            Lon: 8.4857106092771
        },
        "245": {
            Id: "245",
            Name: "Hockenheim",
            X: -523131.15625,
            Y: 98.300086975098,
            Z: -869593.625,
            Lat: 49.322111589913,
            Lon: 8.5306734366465
        },
        "246": {
            Id: "246",
            Name: "Langenselbold",
            X: -434879.90625,
            Y: 123.17177581787,
            Z: -815379,
            Lat: 50.176585118535,
            Lon: 9.0686461180917
        },
        "247": {
            Id: "247",
            Name: "Walldorf",
            X: -527140.6875,
            Y: 110.73534393311,
            Z: -860559.25,
            Lat: 49.300125046946,
            Lon: 8.6610470307795
        },
        "248": {
            Id: "248",
            Name: "Ober-Morlen",
            X: -409938.46875,
            Y: 218.08465576172,
            Z: -836920.125,
            Lat: 50.364652866296,
            Lon: 8.7166468852598
        },
        "249": {
            Id: "249",
            Name: "Pottschutthohe",
            X: -516446.8125,
            Y: 334.98599243164,
            Z: -946424.3125,
            Lat: 49.262912451444,
            Lon: 7.4854594543482
        },
        "250": {
            Id: "250",
            Name: "Worms",
            X: -489572,
            Y: 83.229866027832,
            Z: -875905,
            Lat: 49.607376117047,
            Lon: 8.3691670463782
        },
        "251": {
            Id: "251",
            Name: "H Radar GDR 09",
            X: -223165.296875,
            Y: 0.0,
            Z: -433505.84375,
            Lat: 52.493991854044,
            Lon: 14.088624934465
        },
        "252": {
            Id: "252",
            Name: "H Radar GDR 08",
            X: -163706.640625,
            Y: 0.0,
            Z: -650633,
            Lat: 52.791889226648,
            Lon: 10.811338365153
        },
        "253": {
            Id: "253",
            Name: "H FRG 41",
            X: -487516.0625,
            Y: 0.0,
            Z: -756529.9375,
            Lat: 49.793273907505,
            Lon: 9.9849786165634
        },
        "254": {
            Id: "254",
            Name: "H FRG 42",
            X: -482600.9375,
            Y: 0.0,
            Z: -762950.5625,
            Lat: 49.828193567148,
            Lon: 9.887384356259
        }
    },
    [(0, $79e13355954d15ea$export$e47cd17bd9fde012).IRAQ]: {
        "1": {
            Id: "1",
            Name: "Al-Asad Airbase",
            X: 60846.38671875,
            Y: 185.72004699707,
            Z: -167784.890625,
            Lat: 33.781070361046,
            Lon: 42.407292937235
        },
        "2": {
            Id: "2",
            Name: "Baghdad International Airport",
            X: 1173.5290527344,
            Y: 29.151187896729,
            Z: -551.31390380859,
            Lat: 33.267636612195,
            Lon: 44.21788645786
        },
        "4": {
            Id: "4",
            Name: "Erbil International Airport",
            X: 333060.4375,
            Y: 367.54125976562,
            Z: -22292.353515625,
            Lat: 36.258346243316,
            Lon: 43.94714629154
        },
        "5": {
            Id: "5",
            Name: "Bashur Airport",
            X: 364004.46875,
            Y: 610.86248779297,
            Z: 12634.440429688,
            Lat: 36.540088661994,
            Lon: 44.333529446039
        },
        "6": {
            Id: "6",
            Name: "Qayyarah Airfield West",
            X: 280919.59375,
            Y: 219.67904663086,
            Z: -98099.3203125,
            Lat: 35.778104244046,
            Lon: 43.114841933697
        },
        "7": {
            Id: "7",
            Name: "Sulaimaniyah International Airport",
            X: 256298.09375,
            Y: 740.56463623047,
            Z: 99697.8359375,
            Lat: 35.570506124024,
            Lon: 45.302468286783
        },
        "8": {
            Id: "8",
            Name: "Balad Airbase",
            X: 77026.625,
            Y: 44.000045776367,
            Z: 13108.348632812,
            Lat: 33.952586408149,
            Lon: 44.3595048199
        },
        "9": {
            Id: "9",
            Name: "Al-Taji Airport",
            X: 28792.58984375,
            Y: 30.945068359375,
            Z: 3497.6357421875,
            Lat: 33.517000292005,
            Lon: 44.259247615052
        },
        "10": {
            Id: "10",
            Name: "Kirkuk International Airport",
            X: 246046.09375,
            Y: 313.00024414062,
            Z: 12227.240234375,
            Lat: 35.476630768488,
            Lon: 44.337932724551
        },
        "11": {
            Id: "11",
            Name: "K1 Base",
            X: 249466.453125,
            Y: 297.3896484375,
            Z: 7845.9233398438,
            Lat: 35.507194180781,
            Lon: 44.289369515415
        },
        "12": {
            Id: "12",
            Name: "Al-Sahra Airport",
            X: 158077.21875,
            Y: 129.9769744873,
            Z: -62472.04296875,
            Lat: 34.676326600432,
            Lon: 43.529009055047
        },
        "13": {
            Id: "13",
            Name: "Al-Taquddum Airport",
            X: 10486.7890625,
            Y: 79.22721862793,
            Z: -59398.63671875,
            Lat: 33.346036835017,
            Lon: 43.584803434161
        },
        "14": {
            Id: "14",
            Name: "Al-Salam Airbase",
            X: 3194.9602050781,
            Y: 23.256319046021,
            Z: 24619.4921875,
            Lat: 33.287275487508,
            Lon: 44.488032783503
        }
    }
};
var $e8170945d4879225$export$2e2bcd8739ae039 = $e8170945d4879225$var$bases;



var $f1q41 = parcelRequire("f1q41");

var $b9c9d9c1adf94aca$export$cf0a21f30f3a5187;
(function(RadioFreqRange) {
    RadioFreqRange["UHF"] = "UHF";
    RadioFreqRange["VHF"] = "VHF";
    RadioFreqRange["MIXED"] = "MIXED";
    RadioFreqRange["FM"] = "FM";
})($b9c9d9c1adf94aca$export$cf0a21f30f3a5187 || ($b9c9d9c1adf94aca$export$cf0a21f30f3a5187 = {}));
const $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter = (keyPrefix = "LaserCode")=>{
    return {
        fieldName: keyPrefix,
        formatter: (unit)=>{
            if (!unit.aircraftProps) return "";
            return [
                unit.aircraftProps[`${keyPrefix}100`],
                unit.aircraftProps[`${keyPrefix}10`],
                unit.aircraftProps[`${keyPrefix}1`]
            ].join("");
        }
    };
};
const $b9c9d9c1adf94aca$export$7e386c066bbeab5b = (keyPrefix = "LaserCode")=>(props, entry)=>{
        let code = entry[keyPrefix];
        const str = code.toString();
        const codeArray = str.split("");
        if (codeArray.length !== 3) throw new Error("Invalid laser code length. Must be 3 digits.");
        props[`${keyPrefix}1000`] = 1;
        props[`${keyPrefix}100`] = parseInt(codeArray[0]);
        props[`${keyPrefix}10`] = parseInt(codeArray[1]);
        props[`${keyPrefix}1`] = parseInt(codeArray[2]);
    };
function $b9c9d9c1adf94aca$export$f028d354b7025aa9(group) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(group, [
        "units",
        0,
        "type"
    ]);
}
function $b9c9d9c1adf94aca$export$8e159f10abc1bae9(group) {
    const t = $b9c9d9c1adf94aca$export$f028d354b7025aa9(group);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get($b9c9d9c1adf94aca$export$cc2c248003684daa, t);
}
function $b9c9d9c1adf94aca$export$f6f709ff2b245f60(m) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get($b9c9d9c1adf94aca$export$cc2c248003684daa, [
        m,
        "label"
    ]);
}
const $b9c9d9c1adf94aca$export$cc2c248003684daa = {
    "FA-18C_hornet": {
        radios: [
            {
                label: "COMM 1: ARC-210",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "COM1"
            },
            {
                label: "COMM 2: ARC-210",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "COM2"
            }
        ],
        label: "F/A-18C",
        programmableLaser: false,
        radioPresetOrder: [
            "UHF",
            "MIXED"
        ],
        fuel: {
            internal: 10803,
            externalCapacity: 2244,
            maxExternalTanks: 3,
            engineCount: 2,
            defaultValues: {
                groundSpeed: 480,
                fuelFlow: 6000,
                bingo: 4000,
                externalTanks: 2
            }
        }
    },
    "M-2000C": {
        radios: [
            {
                label: "UHF Radio",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                short: "UHF"
            },
            {
                label: "V/UHF Radio",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                short: "V/UHF"
            }
        ],
        label: "M-2000C",
        programmableLaser: true,
        radioPresetOrder: [
            "UHF",
            "MIXED"
        ],
        laserConfigFields: {
            "Laser Code (1xxx)": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter()
        },
        mizLaserFormatter: $b9c9d9c1adf94aca$export$7e386c066bbeab5b(),
        supportsNavPoints: true,
        fuel: {
            internal: 6978,
            externalCapacity: 3843,
            maxExternalTanks: 2,
            engineCount: 1,
            defaultValues: {
                groundSpeed: 480,
                fuelFlow: 6000,
                bingo: 2000,
                externalTanks: 2
            }
        }
    },
    "F-14A-135-GR": {
        radios: [
            {
                label: "UHF AN/ARC-159",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                short: "UHF"
            },
            {
                label: "VHF/UHF AN/ARC-182",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "V/UHF"
            }
        ],
        label: "F-14A-135-GR",
        programmableLaser: true,
        radioPresetOrder: [
            "UHF",
            "MIXED"
        ],
        laserConfigFields: {
            "Laser Code (1xxx)": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter("LGB")
        },
        mizLaserFormatter: $b9c9d9c1adf94aca$export$7e386c066bbeab5b("LGB"),
        hasMultiCrew: true,
        supportsNavPoints: true,
        fuel: {
            internal: 16200,
            externalCapacity: 2000,
            maxExternalTanks: 2,
            engineCount: 2,
            defaultValues: {
                groundSpeed: 480,
                fuelFlow: 6000,
                bingo: 4000,
                externalTanks: 2
            }
        }
    },
    "F-14B": {
        radios: [
            {
                label: "UHF AN/ARC-159",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                short: "UHF"
            },
            {
                label: "VHF/UHF AN/ARC-182",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "V/UHF"
            }
        ],
        label: "F-14B",
        programmableLaser: true,
        radioPresetOrder: [
            "UHF",
            "MIXED"
        ],
        laserConfigFields: {
            "Laser Code": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter("LGB")
        },
        mizLaserFormatter: $b9c9d9c1adf94aca$export$7e386c066bbeab5b("LGB"),
        hasMultiCrew: true,
        supportsNavPoints: true,
        fuel: {
            internal: 16200,
            externalCapacity: 2000,
            maxExternalTanks: 2,
            engineCount: 2,
            defaultValues: {
                groundSpeed: 480,
                fuelFlow: 6000,
                bingo: 4000,
                externalTanks: 2
            }
        }
    },
    "F-4E-45MC": {
        label: "F-4E",
        hasMultiCrew: true,
        radios: [
            {
                label: "UHF AN/ARC-164",
                short: "UHF 1",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ]
            },
            {
                label: "UHF AN/ARC-164",
                short: "UHF 2",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ]
            }
        ],
        radioPresetOrder: [
            "UHF",
            "UHF"
        ],
        laserConfigFields: {
            "Laser Code (1xxx)": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter()
        },
        programmableLaser: true,
        mizLaserFormatter: (props, entry)=>{
            const val = entry["LaserCode"];
            const [d1, d2, d3] = val.toString().split("");
            props["LaserCodeDigit1"] = 1;
            props["LaserCodeDigit2"] = d1;
            props["LaserCodeDigit3"] = d2;
            props["LaserCodeDigit4"] = d3;
        },
        supportsNavPoints: true,
        fuel: {
            internal: 12149,
            externalCapacity: 2410,
            maxExternalTanks: 2,
            engineCount: 2,
            defaultValues: {
                groundSpeed: 480,
                fuelFlow: 6000,
                bingo: 4000,
                externalTanks: 2
            }
        }
    },
    "F-16C_50": {
        radios: [
            {
                label: "COMM 1 (UHF): AN/ARC-164",
                short: "COM1 UHF",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ]
            },
            {
                label: "COMM 2 (VHF): AN/ARC-222",
                short: "COM2 VHF",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ]
            }
        ],
        label: "F-16C",
        programmableLaser: true,
        radioPresetOrder: [
            "UHF",
            "VHF"
        ],
        laserConfigFields: {
            "Laser Code (1xxx)": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter()
        },
        mizLaserFormatter: $b9c9d9c1adf94aca$export$7e386c066bbeab5b(),
        fuel: {
            internal: 7200,
            externalCapacity: 2450,
            maxExternalTanks: 2,
            engineCount: 1,
            defaultValues: {
                groundSpeed: 480,
                fuelFlow: 6000,
                bingo: 2000,
                externalTanks: 2
            }
        }
    },
    "JF-17": {
        radios: [
            {
                label: "COMM 1/2 Preset",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                short: "COMM 1/2"
            }
        ],
        label: "JF-17",
        programmableLaser: true,
        radioPresetOrder: [
            "MIXED"
        ],
        laserConfigFields: {
            "Laser Code (1xxx)": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter()
        },
        mizLaserFormatter: $b9c9d9c1adf94aca$export$7e386c066bbeab5b(),
        supportsNavPoints: true
    },
    "A-10C": {
        radios: [
            {
                label: "VHF AM: ARC-186",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                short: "COM 1",
                presetCount: 20,
                usesChannelNames: true
            },
            {
                label: "UHF AM: ARC-164",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                short: "COM 2",
                presetCount: 20
            },
            {
                label: "VHF FM: ARC-186",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "COM 3",
                presetCount: 20
            }
        ],
        label: "A-10C",
        programmableLaser: false,
        radioPresetOrder: [
            "VHF",
            "UHF",
            "FM"
        ]
    },
    "A-10C_2": {
        radios: [
            {
                label: "UHF/VHF ARC-210",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                short: "COM 1",
                presetCount: 25,
                usesChannelNames: true
            },
            {
                label: "UHF AM: ARC-164",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                short: "COM 2",
                presetCount: 20
            },
            {
                label: "VHF FM: ARC-186",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "COM 3",
                presetCount: 20
            }
        ],
        label: "A-10C II",
        programmableLaser: false,
        radioPresetOrder: [
            "MIXED",
            "UHF",
            "FM"
        ]
    },
    AV8BNA: {
        radios: [
            {
                label: "V/UHF Radio 1",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 26,
                short: "V/UHF 1"
            },
            {
                label: "V/UHF Radio 2",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 26,
                short: "V/UHF 2"
            },
            {
                label: "V/UHF RCS Presets",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "RCS"
            }
        ],
        label: "AV-8B",
        programmableLaser: true,
        radioPresetOrder: [
            "UHF",
            "MIXED"
        ],
        laserConfigFields: {
            "Laser code for APKWS": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter(),
            "Laser code for GBUs": $b9c9d9c1adf94aca$var$defaultLaserCodeFormatter("GBULaserCode")
        },
        mizLaserFormatter: (props, entry)=>{
            const f1 = $b9c9d9c1adf94aca$export$7e386c066bbeab5b();
            const f2 = $b9c9d9c1adf94aca$export$7e386c066bbeab5b("GBULaserCode");
            f1(props, entry);
            f2(props, entry);
        },
        supportsNavPoints: true
    },
    "Mi-24P": {
        radios: [
            {
                label: "R-863",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 20,
                short: "R-863"
            },
            {
                label: "R-828",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                presetCount: 10,
                short: "R-828"
            }
        ],
        label: "Mi-24P",
        programmableLaser: false,
        radioPresetOrder: [
            "MIXED",
            "FM"
        ]
    },
    "Mi-8MT": {
        radios: [
            {
                label: "R-863",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 20,
                short: "R-863"
            },
            {
                label: "R-828",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                presetCount: 10,
                short: "R-828"
            }
        ],
        label: "Mi-8MT",
        programmableLaser: false,
        radioPresetOrder: [
            "MIXED",
            "FM"
        ]
    },
    "ka-50": {
        radios: [
            {
                label: "R-828",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                short: "R-828"
            },
            {
                label: "ARK-22",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                short: "ARK-22"
            }
        ],
        label: "Ka-50P",
        programmableLaser: false,
        radioPresetOrder: [
            "FM",
            "UHF"
        ],
        supportsNavPoints: true
    },
    "Uh-1h": {
        radios: [
            {
                label: "UHF AN/ARC-51",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                short: "UHF"
            }
        ],
        label: "UH-1H",
        programmableLaser: false,
        radioPresetOrder: [
            "UHF"
        ]
    },
    "AH-64D_BLK_II": {
        radios: [
            {
                label: "ARC-186 (VHF)",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 10,
                short: "VHF"
            },
            {
                label: "ARC-164 (UHF)",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                presetCount: 10,
                short: "UHF"
            },
            {
                label: "FM 1: ARC-201D",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                presetCount: 10,
                short: "FM1"
            },
            {
                label: "FM 2: ARC-201D",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                presetCount: 10,
                short: "FM2"
            }
        ],
        label: "AH-64D",
        hasMultiCrew: true,
        programmableLaser: false,
        radioPresetOrder: [
            "VHF",
            "UHF",
            "FM",
            "FM"
        ],
        category: (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Helicopter,
        fuel: {
            internal: 2513,
            externalCapacity: 657,
            maxExternalTanks: 1,
            engineCount: 2,
            defaultValues: {
                groundSpeed: 120,
                fuelFlow: 335,
                bingo: 250,
                externalTanks: 1
            }
        }
    },
    "UH-60L": {
        label: "UH-60L",
        radios: [
            {
                label: "AN/ARC-201 (1)",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 7,
                short: ""
            },
            {
                label: "AN/ARC-164 (V)",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                presetCount: 20,
                short: ""
            },
            {
                label: "AN/ARC-186 (V)",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 2,
                short: ""
            },
            {
                label: "AN/ARC-201 (2)",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 7,
                short: ""
            },
            {
                label: "AN/ARC-220",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).HF
                ],
                presetCount: 2,
                short: "HF"
            }
        ],
        programmableLaser: false,
        radioPresetOrder: [
            "VHF",
            "UHF",
            "VHF",
            "UHF"
        ]
    },
    "F-15ESE": {
        label: "F-15E",
        // This field is now legacy. Used for rendering kneeboards.
        programmableLaser: false,
        supportsNavPoints: true,
        radios: [
            {
                label: "UHF Radio 1",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                presetCount: 20,
                short: "COM 1"
            },
            {
                label: "V/UHF Radio 2",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 20,
                short: "COM 2"
            }
        ],
        radioPresetOrder: [
            "UHF",
            "MIXED"
        ],
        mizLaserFormatter: (props, entry)=>{
            for(const key in entry)props[key] = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toNumber(entry[key]);
        },
        hasMultiCrew: true,
        laserConfigFields: {
            "Station 2 (1xxx)": {
                fieldName: "Sta2LaserCode",
                formatter: (unit)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toString(unit.aircraftProps["Sta2LaserCode"])
            },
            "Left CFT (1xxx)": {
                fieldName: "LCFTLaserCode",
                formatter: (unit)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toString(unit.aircraftProps["LCFTLaserCode"])
            },
            "Station 5 (1xxx)": {
                fieldName: "Sta5LaserCode",
                formatter: (unit)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toString(unit.aircraftProps["Sta5LaserCode"])
            },
            "Right CFT (1xxx)": {
                fieldName: "RCFTLaserCode",
                formatter: (unit)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toString(unit.aircraftProps["RCFTLaserCode"])
            },
            "Station 8 (1xxx)": {
                fieldName: "Sta8LaserCode",
                formatter: (unit)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toString(unit.aircraftProps["Sta8LaserCode"])
            }
        },
        fuel: {
            internal: 22588,
            externalCapacity: 3965,
            maxExternalTanks: 3,
            engineCount: 2,
            defaultValues: {
                groundSpeed: 480,
                fuelFlow: 6000,
                bingo: 4000,
                externalTanks: 2
            }
        }
    },
    OH58D: {
        label: "OH-58D",
        programmableLaser: false,
        supportsNavPoints: true,
        hasMultiCrew: true,
        radios: [
            {
                label: "UHF AM",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                ],
                presetCount: 20,
                short: "UHF"
            },
            {
                label: "VHF",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                ],
                presetCount: 20,
                short: "VHF"
            },
            {
                label: "VHF FM1",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                presetCount: 20,
                short: "VHF FM1"
            },
            {
                label: "VHF FM2",
                bands: [
                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM
                ],
                presetCount: 20,
                short: "VHF FM2"
            }
        ],
        radioPresetOrder: [
            "UHF",
            "VHF",
            "FM",
            "FM"
        ],
        fuel: {
            internal: 736,
            externalCapacity: 0,
            maxExternalTanks: 0,
            engineCount: 1,
            defaultValues: {
                groundSpeed: 100,
                fuelFlow: 370,
                bingo: 250,
                externalTanks: 1
            }
        }
    }
};


const $e56653165fb50b77$var$None = 0;
const $e56653165fb50b77$var$Weapons = {
    AB_250_2___144_x_SD_2__250kg_CBU_with_HE_submunitions: {
        clsid: "{AB_250_2_SD_2}",
        name: "AB 250-2 - 144 x SD-2, 250kg CBU with HE submunitions",
        weight: 290
    },
    AB_250_2___17_x_SD_10A__250kg_CBU_with_10kg_Frag_HE_submunitions: {
        clsid: "{AB_250_2_SD_10A}",
        name: "AB 250-2 - 17 x SD-10A, 250kg CBU with 10kg Frag/HE submunitions",
        weight: 253
    },
    AB_500_1___34_x_SD_10A__500kg_CBU_with_10kg_Frag_HE_submunitions: {
        clsid: "{AB_500_1_SD_10A}",
        name: "AB 500-1 - 34 x SD-10A, 500kg CBU with 10kg Frag/HE submunitions",
        weight: 500
    },
    ADEN_GUNPOD: {
        clsid: "{ADEN_GUNPOD}",
        name: "ADEN GUNPOD",
        weight: 87
    },
    ADM_141A: {
        clsid: "{BRU42_ADM141}",
        name: "ADM_141A",
        weight: 308
    },
    ADM_141A_: {
        clsid: "{BRU3242_ADM141}",
        name: "ADM_141A",
        weight: 365.38
    },
    ADM_141A_TALD: {
        clsid: "{ADM_141A}",
        name: "ADM-141A TALD",
        weight: 180
    },
    ADM_141B_TALD: {
        clsid: "{ADM_141B}",
        name: "ADM-141B TALD",
        weight: 180
    },
    AERO_1D_300_Gallons_Fuel_Tank_: {
        clsid: "{AV8BNA_AERO1D}",
        name: "AERO 1D 300 Gallons Fuel Tank ",
        weight: 1002.439
    },
    AERO_1D_300_Gallons_Fuel_Tank__Empty_: {
        clsid: "{AV8BNA_AERO1D_EMPTY}",
        name: "AERO 1D 300 Gallons Fuel Tank (Empty)",
        weight: 93.89362
    },
    AGM114x2_OH_58: {
        clsid: "AGM114x2_OH_58",
        name: "AGM-114K * 2",
        weight: 250
    },
    AGM_114K: {
        clsid: "{ee368869-c35a-486a-afe7-284beb7c5d52}",
        name: "AGM-114K",
        weight: 65
    },
    AGM_114K___4: {
        clsid: "{88D18A5E-99C8-4B04-B40B-1C02F2018B6E}",
        name: "AGM-114K * 4",
        weight: 250
    },
    AGM_119B_Penguin_ASM: {
        clsid: "{7B8DCEB4-820B-4015-9B48-1028A4195692}",
        name: "AGM-119B Penguin ASM",
        weight: 300
    },
    AGM_122_Sidearm: {
        clsid: "{AGM_122_SIDEARM}",
        name: "AGM-122 Sidearm",
        weight: 92
    },
    AGM_122_Sidearm_: {
        clsid: "{LAU_7_AGM_122_SIDEARM}",
        name: "AGM-122 Sidearm",
        weight: 107
    },
    AGM_122_Sidearm___light_ARM: {
        clsid: "{AGM_122}",
        name: "AGM-122 Sidearm - light ARM",
        weight: 88
    },
    AGM_154A___JSOW_CEB__CBU_type_: {
        clsid: "{AGM-154A}",
        name: "AGM-154A - JSOW CEB (CBU-type)",
        weight: 485
    },
    AGM_154B___JSOW_Anti_Armour: {
        clsid: "{AGM-154B}",
        name: "AGM-154B - JSOW Anti-Armour",
        weight: 485
    },
    AGM_154C___JSOW_Unitary_BROACH: {
        clsid: "{9BCC2A2B-5708-4860-B1F1-053A18442067}",
        name: "AGM-154C - JSOW Unitary BROACH",
        weight: 484
    },
    AGM_45A_Shrike_ARM: {
        clsid: "{AGM_45A}",
        name: "AGM-45A Shrike ARM",
        weight: 177
    },
    AGM_45B_Shrike_ARM__Imp_: {
        clsid: "{3E6B632D-65EB-44D2-9501-1C2D04515404}",
        name: "AGM-45B Shrike ARM (Imp)",
        weight: 177
    },
    AGM_62_Walleye_II___Guided_Weapon_Mk_5__TV_Guided_: {
        clsid: "{C40A1E3A-DD05-40D9-85A4-217729E37FAE}",
        name: "AGM-62 Walleye II - Guided Weapon Mk 5 (TV Guided)",
        weight: 1061
    },
    AGM_65D___Maverick_D__IIR_ASM_: {
        clsid: "{444BA8AE-82A7-4345-842E-76154EFCCA47}",
        name: "AGM-65D - Maverick D (IIR ASM)",
        weight: 218
    },
    AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_: {
        clsid: "{F16A4DE0-116C-4A71-97F0-2CF85B0313EF}",
        name: "AGM-65E - Maverick E (Laser ASM - Lg Whd)",
        weight: 286
    },
    AGM_65K___Maverick_K__CCD_Imp_ASM_: {
        clsid: "{69DC8AE7-8F77-427B-B8AA-B19D3F478B65}",
        name: "AGM-65K - Maverick K (CCD Imp ASM)",
        weight: 360
    },
    AGM_84: {
        clsid: "AGM_84",
        name: "AGM-84 HARPOON",
        weight: $e56653165fb50b77$var$None
    },
    AGM_84A_Harpoon_ASM: {
        clsid: "{8B7CADF9-4954-46B3-8CFB-93F2F5B90B03}",
        name: "AGM-84A Harpoon ASM",
        weight: 661.5
    },
    AGM_84D_Harpoon_AShM: {
        clsid: "{AGM_84D}",
        name: "AGM-84D Harpoon AShM",
        weight: 540
    },
    AGM_84E_Harpoon_SLAM__Stand_Off_Land_Attack_Missile_: {
        clsid: "{AF42E6DF-9A60-46D8-A9A0-1708B241AADB}",
        name: "AGM-84E Harpoon/SLAM (Stand-Off Land-Attack Missile)",
        weight: 628
    },
    AGM_84E_Harpoon_SLAM__Stand_Off_Land_Attack_Missile__: {
        clsid: "{AGM_84E}",
        name: "AGM-84E Harpoon/SLAM (Stand-Off Land-Attack Missile)",
        weight: 628
    },
    AGM_84H_SLAM_ER__Expanded_Response_: {
        clsid: "{AGM_84H}",
        name: "AGM-84H SLAM-ER (Expanded Response)",
        weight: 675
    },
    AGM_86C_ALCM: {
        clsid: "{769A15DF-6AFB-439F-9B24-5B7A45C59D16}",
        name: "AGM-86C ALCM",
        weight: 1950
    },
    AGM_88C_HARM___High_Speed_Anti_Radiation_Missile: {
        clsid: "{B06DD79A-F21E-4EB9-BD9D-AB3844618C9C}",
        name: "AGM-88C HARM - High Speed Anti-Radiation Missile",
        weight: 361
    },
    AGM_88C_HARM___High_Speed_Anti_Radiation_Missile_: {
        clsid: "{B06DD79A-F21E-4EB9-BD9D-AB3844618C93}",
        name: "AGM-88C HARM - High Speed Anti-Radiation Missile",
        weight: 406.4
    },
    AIM_120B_AMRAAM___Active_Rdr_AAM: {
        clsid: "{C8E06185-7CD6-4C90-959F-044679E90751}",
        name: "AIM-120B AMRAAM - Active Rdr AAM",
        weight: 156
    },
    AIM_120C_5_AMRAAM___Active_Rdr_AAM: {
        clsid: "{40EF17B7-F508-45de-8566-6FFECC0C1AB8}",
        name: "AIM-120C-5 AMRAAM - Active Rdr AAM",
        weight: 161.5
    },
    AIM_54A_Mk47: {
        clsid: "{AIM_54A_Mk47}",
        name: "AIM-54A-Mk47",
        weight: 444
    },
    AIM_54A_Mk47_: {
        clsid: "{SHOULDER AIM_54A_Mk47 L}",
        name: "AIM-54A-Mk47",
        weight: 489.36
    },
    AIM_54A_Mk47__: {
        clsid: "{SHOULDER AIM_54A_Mk47 R}",
        name: "AIM-54A-Mk47",
        weight: 489.36
    },
    AIM_54A_Mk60: {
        clsid: "{AIM_54A_Mk60}",
        name: "AIM-54A-Mk60",
        weight: 471.7
    },
    AIM_54A_Mk60_: {
        clsid: "{SHOULDER AIM_54A_Mk60 L}",
        name: "AIM-54A-Mk60",
        weight: 517.06
    },
    AIM_54A_Mk60__: {
        clsid: "{SHOULDER AIM_54A_Mk60 R}",
        name: "AIM-54A-Mk60",
        weight: 517.06
    },
    AIM_54C_Mk47: {
        clsid: "{AIM_54C_Mk47}",
        name: "AIM-54C-Mk47",
        weight: 465.6
    },
    AIM_54C_Mk47_: {
        clsid: "{SHOULDER AIM_54C_Mk47 L}",
        name: "AIM-54C-Mk47",
        weight: 510.96
    },
    AIM_54C_Mk47_Phoenix_IN__Semi_Active_Radar: {
        clsid: "{7575BA0B-7294-4844-857B-031A144B2595}",
        name: "AIM-54C-Mk47 Phoenix IN & Semi-Active Radar",
        weight: 463
    },
    AIM_54C_Mk47__: {
        clsid: "{SHOULDER AIM_54C_Mk47 R}",
        name: "AIM-54C-Mk47",
        weight: 510.96
    },
    AIM_7E_Sparrow_Semi_Active_Radar: {
        clsid: "{AIM-7E}",
        name: "AIM-7E Sparrow Semi-Active Radar",
        weight: 230
    },
    AIM_7F: {
        clsid: "{SHOULDER AIM-7F}",
        name: "AIM-7F",
        weight: 284.4
    },
    AIM_7F_: {
        clsid: "{BELLY AIM-7F}",
        name: "AIM-7F",
        weight: 230
    },
    AIM_7F_Sparrow_Semi_Active_Radar: {
        clsid: "{AIM-7F}",
        name: "AIM-7F Sparrow Semi-Active Radar",
        weight: 231
    },
    AIM_7M: {
        clsid: "{SHOULDER AIM-7M}",
        name: "AIM-7M",
        weight: 284.4
    },
    AIM_7MH: {
        clsid: "{SHOULDER AIM-7MH}",
        name: "AIM-7MH",
        weight: 284.4
    },
    AIM_7MH_: {
        clsid: "{BELLY AIM-7MH}",
        name: "AIM-7MH",
        weight: 230
    },
    AIM_7MH_Sparrow_Semi_Active_Radar: {
        clsid: "{AIM-7H}",
        name: "AIM-7MH Sparrow Semi-Active Radar",
        weight: 231
    },
    AIM_7M_: {
        clsid: "{BELLY AIM-7M}",
        name: "AIM-7M",
        weight: 230
    },
    AIM_7M_Sparrow_Semi_Active_Radar: {
        clsid: "{8D399DDA-FF81-4F14-904D-099B34FE7918}",
        name: "AIM-7M Sparrow Semi-Active Radar",
        weight: 231.1
    },
    AIM_9B_Sidewinder_IR_AAM: {
        clsid: "{AIM-9B}",
        name: "AIM-9B Sidewinder IR AAM",
        weight: 74.39
    },
    AIM_9L_Sidewinder_IR_AAM: {
        clsid: "{AIM-9L}",
        name: "AIM-9L Sidewinder IR AAM",
        weight: 85.73
    },
    AIM_9M_Sidewinder_IR_AAM: {
        clsid: "{6CEB49FC-DED8-4DED-B053-E1F033FF72D3}",
        name: "AIM-9M Sidewinder IR AAM",
        weight: 85.73
    },
    AIM_9P5_Sidewinder_IR_AAM: {
        clsid: "{AIM-9P5}",
        name: "AIM-9P5 Sidewinder IR AAM",
        weight: 85.5
    },
    AIM_9P_Sidewinder_IR_AAM: {
        clsid: "{9BFD8C90-F7AE-4e90-833B-BFD0CED0E536}",
        name: "AIM-9P Sidewinder IR AAM",
        weight: 86.18
    },
    AIM_9X_Sidewinder_IR_AAM: {
        clsid: "{5CE2FF2A-645A-4197-B48D-8720AC69394F}",
        name: "AIM-9X Sidewinder IR AAM",
        weight: 84.46
    },
    AJS_External_tank_1013kg_fuel: {
        clsid: "{VIGGEN_X-TANK}",
        name: "AJS External-tank 1013kg fuel",
        weight: 1208
    },
    AKAN_M_55_Gunpod__150_rnds_MINGR55_HE: {
        clsid: "{AKAN}",
        name: "AKAN M/55 Gunpod, 150 rnds MINGR55-HE",
        weight: 276
    },
    ALARM: {
        clsid: "{E6747967-B1F0-4C77-977B-AB2E6EB0C102}",
        name: "ALARM",
        weight: 268
    },
    ALQ_131___ECM_Pod: {
        clsid: "{6D21ECEA-F85B-4E8D-9D51-31DC9B8AA4EF}",
        name: "ALQ-131 - ECM Pod",
        weight: 305
    },
    ALQ_184: {
        clsid: "ALQ_184",
        name: "ALQ-184 - ECM Pod",
        weight: 215
    },
    AN_AAQ_28_LITENING___Targeting_Pod: {
        clsid: "{A111396E-D3E8-4b9c-8AC9-2432489304D5}",
        name: "AN/AAQ-28 LITENING - Targeting Pod",
        weight: 208
    },
    AN_AAQ_28_LITENING___Targeting_Pod_: {
        clsid: "{AAQ-28_LEFT}",
        name: "AN/AAQ-28 LITENING - Targeting Pod",
        weight: 208
    },
    AN_ALQ_164_DECM_Pod: {
        clsid: "{ALQ_164_RF_Jammer}",
        name: "AN/ALQ-164 DECM Pod",
        weight: 143.789
    },
    AN_ASQ_173_Laser_Spot_Tracker_Strike_CAMera__LST_SCAM_: {
        clsid: "{1C2B16EB-8EB0-43de-8788-8EBB2D70B8BC}",
        name: "AN/ASQ-173 Laser Spot Tracker/Strike CAMera (LST/SCAM)",
        weight: 250
    },
    AN_ASQ_228_ATFLIR___Targeting_Pod: {
        clsid: "{AN_ASQ_228}",
        name: "AN/ASQ-228 ATFLIR - Targeting Pod",
        weight: 195
    },
    AN_ASQ_T50_TCTS_Pod___ACMI_Pod: {
        clsid: "{AIS_ASQ_T50}",
        name: "AN/ASQ-T50 TCTS Pod - ACMI Pod",
        weight: 62.6
    },
    AN_M3: {
        clsid: "{AN-M3}",
        name: "AN-M3",
        weight: 218
    },
    AN_M30A1___100lb_GP_Bomb_LD: {
        clsid: "{AN_M30A1}",
        name: "AN-M30A1 - 100lb GP Bomb LD",
        weight: 45.8
    },
    AN_M57___250lb_GP_Bomb_LD: {
        clsid: "{AN_M57}",
        name: "AN-M57 - 250lb GP Bomb LD",
        weight: 113
    },
    AN_M64___500lb_GP_Bomb_LD: {
        clsid: "{AN-M64}",
        name: "AN-M64 - 500lb GP Bomb LD",
        weight: 227
    },
    AN_M64___500lb_GP_Bomb_LD_: {
        clsid: "{F86ANM64}",
        name: "AN-M64 - 500lb GP Bomb LD",
        weight: 227
    },
    AN_M65___1000lb_GP_Bomb_LD: {
        clsid: "{AN_M65}",
        name: "AN-M65 - 1000lb GP Bomb LD",
        weight: 475
    },
    AN_M66___2000lb_GP_Bomb_LD: {
        clsid: "{AN_M66}",
        name: "AN-M66 - 2000lb GP Bomb LD",
        weight: 977
    },
    APU_60_1M_with_R_60M__AA_8_Aphid____Infra_Red: {
        clsid: "{APU-60-1_R_60M}",
        name: "APU-60-1M with R-60M (AA-8 Aphid) - Infra Red",
        weight: 76
    },
    APU_60_2M_with_2_x_R_60M__AA_8_Aphid____Infra_Red: {
        clsid: "{B0DBC591-0F52-4F7D-AD7B-51E67725FB81}",
        name: "APU-60-2M with 2 x R-60M (AA-8 Aphid) - Infra Red",
        weight: 148
    },
    APU_60_2M_with_2_x_R_60M__AA_8_Aphid____Infra_Red_: {
        clsid: "{275A2855-4A79-4B2D-B082-91EA2ADF4691}",
        name: "APU-60-2M with 2 x R-60M (AA-8 Aphid) - Infra Red",
        weight: 148
    },
    APU_68___S_24B: {
        clsid: "{APU_68_S-24}",
        name: "APU-68 - S-24B",
        weight: 295
    },
    APU_6___6_9A4172_Vikhr: {
        clsid: "{A6FD14D3-6D30-4C85-88A7-8D17BEE120E2}",
        name: "APU-6 - 6 9A4172 Vikhr",
        weight: 330
    },
    APU_8___8_9A4172_Vikhr: {
        clsid: "{F789E86A-EE2E-4E6B-B81E-D5E5F903B6ED}",
        name: "APU-8 - 8 9A4172 Vikhr",
        weight: 404
    },
    ARAK_M_70B_AP_6x_135mm_UnGd_Rkts__Pshu70_HEAT: {
        clsid: "{ARAKM70BAP}",
        name: "ARAK M/70B AP 6x 135mm UnGd Rkts, Pshu70 HEAT",
        weight: 372.2
    },
    ARAK_M_70B_HE_6x_135mm_UnGd_Rkts__Shu70_HE_FRAG: {
        clsid: "{ARAKM70BHE}",
        name: "ARAK M/70B HE 6x 135mm UnGd Rkts, Shu70 HE/FRAG",
        weight: 372.2
    },
    ASO_2: {
        clsid: "{ASO-2}",
        name: "ASO-2",
        weight: 22
    },
    AUF2_BLG_66_AC_x_2: {
        clsid: "{M2KC_RAFAUT_BLG66}",
        name: "AUF2 BLG-66-AC x 2",
        weight: 685
    },
    AUF2_GBU_12_x_2: {
        clsid: "{M2KC_RAFAUT_GBU12}",
        name: "AUF2 GBU-12 x 2",
        weight: 621
    },
    AUF2_MK_82_Snakeyes_x_2: {
        clsid: "{M2KC_RAFAUT_MK82S}",
        name: "AUF2 MK-82 Snakeyes x 2",
        weight: 525
    },
    AUF2_MK_82_x_2: {
        clsid: "{M2KC_RAFAUT_MK82}",
        name: "AUF2 MK-82 x 2",
        weight: 525
    },
    AUF2_ROCKEYE_x_2: {
        clsid: "{M2KC_RAFAUT_ROCKEYE}",
        name: "AUF2 ROCKEYE x 2",
        weight: 525
    },
    AWW_13_DATALINK_POD: {
        clsid: "{AWW-13}",
        name: "AWW-13 DATALINK POD",
        weight: 200
    },
    BDU_33___25lb_Practice_Bomb_LD: {
        clsid: "{BDU-33}",
        name: "BDU-33 - 25lb Practice Bomb LD",
        weight: 11
    },
    BDU_45: {
        clsid: "{BDU_45}",
        name: "BDU-45",
        weight: 232
    },
    BDU_45B: {
        clsid: "{BDU_45B}",
        name: "BDU-45B",
        weight: 232
    },
    BDU_50HD___500lb_Inert_Practice_Bomb_HD: {
        clsid: "{BDU-50HD}",
        name: "BDU-50HD - 500lb Inert Practice Bomb HD",
        weight: 232
    },
    BDU_50LD___500lb_Inert_Practice_Bomb_LD: {
        clsid: "{BDU-50LD}",
        name: "BDU-50LD - 500lb Inert Practice Bomb LD",
        weight: 232
    },
    BDU_50LGB___500lb_Laser_Guided_Inert_Practice_Bomb_LD: {
        clsid: "{BDU-50LGB}",
        name: "BDU-50LGB - 500lb Laser Guided Inert Practice Bomb LD",
        weight: 280
    },
    BETAB_500M: {
        clsid: "{BETAB-500M}",
        name: "BETAB-500M",
        weight: 479
    },
    BETAB_500S: {
        clsid: "{BETAB-500S}",
        name: "BETAB-500S",
        weight: 425
    },
    Beer_Bomb: {
        clsid: "{BEER_BOMB}",
        name: "Beer Bomb",
        weight: 100
    },
    Beer_Bomb__D__on_LH_Spitfire_Wing_Carrier: {
        clsid: "Beer_Bomb_(D)_on_LH_Spitfire_Wing_Carrier",
        name: "Beer Bomb (Bitter Ale)",
        weight: 104
    },
    Beer_Bomb__D__on_RH_Spitfire_Wing_Carrier: {
        clsid: "Beer_Bomb_(D)_on_RH_Spitfire_Wing_Carrier",
        name: "Beer Bomb (Bitter Ale)",
        weight: 104
    },
    Beer_Bomb__L__on_LH_Spitfire_Wing_Carrier: {
        clsid: "Beer_Bomb_(L)_on_LH_Spitfire_Wing_Carrier",
        name: "Beer Bomb (Pale Ale)",
        weight: 104
    },
    Beer_Bomb__L__on_RH_Spitfire_Wing_Carrier: {
        clsid: "Beer_Bomb_(L)_on_RH_Spitfire_Wing_Carrier",
        name: "Beer Bomb (Pale Ale)",
        weight: 104
    },
    Belouga: {
        clsid: "{BLG66_BELOUGA}",
        name: "Belouga",
        weight: 290
    },
    BetAB_500ShP___500kg_Concrete_Piercing_HD_w_booster_Bomb: {
        clsid: "{BD289E34-DF84-4C5E-9220-4B14C346E79D}",
        name: "BetAB-500ShP - 500kg Concrete Piercing HD w booster Bomb",
        weight: 424
    },
    BetAB_500___500kg_Concrete_Piercing_Bomb_LD: {
        clsid: "{35B698AC-9FEF-4EC4-AD29-484A0085F62B}",
        name: "BetAB-500 - 500kg Concrete Piercing Bomb LD",
        weight: 430
    },
    BF109K_4_FUEL_TANK: {
        clsid: "BF109K_4_FUEL_TANK",
        name: "300 liter Fuel Tank",
        weight: 266
    },
    BGM_109: {
        clsid: "BGM_109",
        name: "BGM-109 TOMAHAWK",
        weight: $e56653165fb50b77$var$None
    },
    BGM_109B: {
        clsid: "BGM-109B",
        name: "BGM-109B",
        weight: $e56653165fb50b77$var$None
    },
    BIN_200: {
        clsid: "BIN_200",
        name: "BIN-200",
        weight: 200
    },
    BK_90_MJ12__12x_MJ2_HEAT___36x_MJ1_HE_FRAG_Bomblets_: {
        clsid: "{BK90}",
        name: "BK-90 MJ1+2 (12x MJ2 HEAT / 36x MJ1 HE-FRAG Bomblets)",
        weight: 605
    },
    BK_90_MJ1__72_x_MJ1_HE_FRAG_Bomblets_: {
        clsid: "{BK90MJ1}",
        name: "BK-90 MJ1 (72 x MJ1 HE-FRAG Bomblets)",
        weight: 605
    },
    BK_90_MJ2__24_x_MJ2_HEAT_Bomblets_: {
        clsid: "{BK90MJ2}",
        name: "BK-90 MJ2 (24 x MJ2 HEAT Bomblets)",
        weight: 605
    },
    BLG_66_AC_Belouga: {
        clsid: "{BLG66_BELOUGA_AC}",
        name: "BLG-66-AC Belouga",
        weight: 305
    },
    BLG_66_Belouga___290kg_CBU__151_Frag_Pen_bomblets: {
        clsid: "{BLG66_AC}",
        name: "BLG-66 Belouga - 290kg CBU, 151 Frag/Pen bomblets",
        weight: 305
    },
    BLU_107___440lb_Anti_Runway_Penetrator_Bomb: {
        clsid: "{752B9781-F962-11d5-9190-00A0249B6F00}",
        name: "BLU-107 - 440lb Anti-Runway Penetrator Bomb",
        weight: 185
    },
    BL_755_CBU___450kg__147_Frag_Pen_bomblets: {
        clsid: "{08164777-5E9C-4B08-B48E-5AA7AFB246E2}",
        name: "BL-755 CBU - 450kg, 147 Frag/Pen bomblets",
        weight: 264
    },
    BOZ_107___Countermeasure_Dispenser: {
        clsid: "{8C3F26A1-FA0F-11d5-9190-00A0249B6F00}",
        name: "BOZ-107 - Countermeasure Dispenser",
        weight: 200
    },
    BRU_33_with_1_x_LAU_10_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG: {
        clsid: "{BRU33_LAU10}",
        name: "BRU-33 with 1 x LAU-10 pod - 4 x 127mm ZUNI, UnGd Rkts Mk71, HE/FRAG",
        weight: 407.6
    },
    BRU_33_with_1_x_LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{BRU33_LAU61}",
        name: "BRU-33 with 1 x LAU-61 pod - 19 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 364.4
    },
    BRU_33_with_1_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{BRU33_LAU68}",
        name: "BRU-33 with 1 x LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 204.9
    },
    BRU_33_with_1_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT: {
        clsid: "{BRU33_LAU68_MK5}",
        name: "BRU-33 with 1 x LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 193.1
    },
    BRU_33_with_2_x_BDU_45B___500lb_Practice_Bomb: {
        clsid: "{BRU33_2X_BDU-45B}",
        name: "BRU-33 with 2 x BDU-45B - 500lb Practice Bomb",
        weight: 555
    },
    BRU_33_with_2_x_BDU_45___500lb_Practice_Bomb: {
        clsid: "{BRU33_2X_BDU-45}",
        name: "BRU-33 with 2 x BDU-45 - 500lb Practice Bomb",
        weight: 555
    },
    BRU_33_with_2_x_CBU_99___490lbs__247_x_HEAT_Bomblets: {
        clsid: "{BRU33_2X_CBU-99}",
        name: "BRU-33 with 2 x CBU-99 - 490lbs, 247 x HEAT Bomblets",
        weight: 535
    },
    BRU_33_with_2_x_GBU_12___500lb_Laser_Guided_Bomb: {
        clsid: "{BRU33_2X_GBU-12}",
        name: "BRU-33 with 2 x GBU-12 - 500lb Laser Guided Bomb",
        weight: 645
    },
    BRU_33_with_2_x_GBU_16___1000lb_Laser_Guided_Bomb: {
        clsid: "{BRU33_2X_GBU-16}",
        name: "BRU-33 with 2 x GBU-16 - 1000lb Laser Guided Bomb",
        weight: 1117
    },
    BRU_33_with_2_x_LAU_10_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG: {
        clsid: "{BRU33_2*LAU10}",
        name: "BRU-33 with 2 x LAU-10 pod - 4 x 127mm ZUNI, UnGd Rkts Mk71, HE/FRAG",
        weight: 724.2
    },
    BRU_33_with_2_x_LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{BRU33_2*LAU61}",
        name: "BRU-33 with 2 x LAU-61 pod - 19 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 637.8
    },
    BRU_33_with_2_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{BRU33_2*LAU68}",
        name: "BRU-33 with 2 x LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 318.8
    },
    BRU_33_with_2_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT: {
        clsid: "{BRU33_2*LAU68_MK5}",
        name: "BRU-33 with 2 x LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 295.2
    },
    BRU_33_with_2_x_Mk_20_Rockeye___490lbs_CBU__247_x_HEAT_Bomblets: {
        clsid: "{BRU33_2X_ROCKEYE}",
        name: "BRU-33 with 2 x Mk-20 Rockeye - 490lbs CBU, 247 x HEAT Bomblets",
        weight: 535
    },
    BRU_33_with_2_x_Mk_82Y___500lb_GP_Chute_Retarded_HD: {
        clsid: "{BRU33_2X_MK-82Y}",
        name: "BRU-33 with 2 x Mk-82Y - 500lb GP Chute Retarded HD",
        weight: 555
    },
    BRU_33_with_2_x_Mk_82_Snakeye___500lb_GP_Bomb_HD: {
        clsid: "{BRU33_2X_MK-82_Snakeye}",
        name: "BRU-33 with 2 x Mk-82 Snakeye - 500lb GP Bomb HD",
        weight: 590
    },
    BRU_33_with_2_x_Mk_82___500lb_GP_Bomb_LD: {
        clsid: "{BRU33_2X_MK-82}",
        name: "BRU-33 with 2 x Mk-82 - 500lb GP Bomb LD",
        weight: 547
    },
    BRU_33_with_2_x_Mk_82___500lb_GP_Bomb_LD_: {
        clsid: "{BRU33_2X_MK-82}",
        name: "BRU-33 with 2 x Mk-82 - 500lb GP Bomb LD",
        weight: 547
    },
    BRU_33_with_2_x_Mk_83___1000lb_GP_Bomb_LD: {
        clsid: "{BRU33_2X_MK-83}",
        name: "BRU-33 with 2 x Mk-83 - 1000lb GP Bomb LD",
        weight: 999
    },
    BRU_41A_with_6_x_BDU_33___25lb_Practice_Bomb_LD: {
        clsid: "{BRU41_6X_BDU-33}",
        name: "BRU-41A with 6 x BDU-33 - 25lb Practice Bomb LD",
        weight: 195.713
    },
    BRU_41A_with_6_x_Mk_82___500lb_GP_Bomb_LD: {
        clsid: "{BRU41_6X_MK-82}",
        name: "BRU-41A with 6 x Mk-82 - 500lb GP Bomb LD",
        weight: 1495.913
    },
    BRU_42_3_BDU_33: {
        clsid: "BRU-42_3*BDU-33",
        name: "BRU-42 with 3 x BDU-33 - 25lb Practice Bombs LD",
        weight: 90.15
    },
    BRU_42_3_GBU_12: {
        clsid: "BRU-42_3*GBU-12",
        name: "BRU-42 with 3 x GBU-12 - 500lb Laser Guided Bombs",
        weight: 887.25
    },
    BRU_42_LS: {
        clsid: "BRU-42_LS",
        name: "BRU-42 - Triple Ejector Rack (TER)",
        weight: 56.25
    },
    BRU_42_with_2_x_GBU_10___2000lb_Laser_Guided_Bombs: {
        clsid: "{62BE78B1-9258-48AE-B882-279534C0D278}",
        name: "BRU-42 with 2 x GBU-10 - 2000lb Laser Guided Bombs",
        weight: 1974.25
    },
    BRU_42_with_2_x_GBU_27___2000lb_Laser_Guided_Penetrator_Bombs: {
        clsid: "{EB969276-1922-4ED1-A5CB-18590F45D7FE}",
        name: "BRU-42 with 2 x GBU-27 - 2000lb Laser Guided Penetrator Bombs",
        weight: 2038.25
    },
    BRU_42_with_3_x_GBU_16___1000lb_Laser_Guided_Bombs: {
        clsid: "{88D49E04-78DF-4F08-B47E-B81247A9E3C5}",
        name: "BRU-42 with 3 x GBU-16 - 1000lb Laser Guided Bombs",
        weight: 1595.25
    },
    BRU_42_with_3_x_LAU_131_pods___7_x_2_75_Hydra__Laser_Guided_Rkts_M151__HE_APKWS: {
        clsid: "{LAU-131x3 - 7 AGR-20A}",
        name: "BRU-42 with 3 x LAU-131 pods - 7 x 2.75 Hydra, Laser Guided Rkts M151, HE APKWS",
        weight: 454.3
    },
    BRU_42_with_3_x_LAU_131_pods___7_x_2_75_Hydra__Laser_Guided_Rkts_M282__MPP_APKWS: {
        clsid: "{LAU-131x3 - 7 AGR-20 M282}",
        name: "BRU-42 with 3 x LAU-131 pods - 7 x 2.75 Hydra, Laser Guided Rkts M282, MPP APKWS",
        weight: 496.3
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{64329ED9-B14C-4c0b-A923-A3C911DA1527}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 397.95
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos: {
        clsid: "{C2593383-3CA8-4b18-B73D-0E750BCA1C85}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 399.63
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M257__Para_Illum: {
        clsid: "{E6966004-A525-4f47-AF94-BCFEDF8FDBDA}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts M257, Para Illum",
        weight: 412.65
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M274__Practice_Smk: {
        clsid: "{4C044B08-886B-46c8-9B1F-AB05B3ED9C1D}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts M274, Practice Smk",
        weight: 395.85
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_Mk1__Practice: {
        clsid: "{443364AE-D557-488e-9499-45EDB3BA6730}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts Mk1, Practice",
        weight: 368.76
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT: {
        clsid: "{9BC82B3D-FE70-4910-B2B7-3E54EFE73262}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 362.46
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_Mk61__Practice: {
        clsid: "{C0FA251E-B645-4ce5-926B-F4BC20822F8B}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts Mk61, Practice",
        weight: 368.76
    },
    BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_WTU_1_B__Practice: {
        clsid: "{A1853B38-2160-4ffe-B7E9-9BF81E6C3D77}",
        name: "BRU-42 with 3 x LAU-68 pods - 21 x 2.75 Hydra, UnGd Rkts WTU-1/B, Practice",
        weight: 395.85
    },
    BRU_42_with_3_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets: {
        clsid: "{B83CB620-5BBE-4BEA-910C-EB605A327EF9}",
        name: "BRU-42 with 3 x Mk-20 Rockeye - 490lbs CBUs, 247 x HEAT Bomblets",
        weight: 722.25
    },
    BRU_42_with_3_x_Mk_81___250lb_GP_Bombs_LD: {
        clsid: "{7B34E0BB-E427-4C2A-A61A-8407CE18B54D}",
        name: "BRU-42 with 3 x Mk-81 - 250lb GP Bombs LD",
        weight: 396.45
    },
    BRU_42_with_3_x_Mk_82_AIR_Ballute___500lb_GP_Bombs_HD: {
        clsid: "{BRU-42_3*Mk-82AIR}",
        name: "BRU-42 with 3 x Mk-82 AIR Ballute - 500lb GP Bombs HD",
        weight: 782.25
    },
    BRU_42_with_3_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{60CC734F-0AFA-4E2E-82B8-93B941AB11CF}",
        name: "BRU-42 with 3 x Mk-82 - 500lb GP Bombs LD",
        weight: 740.25
    },
    BRU_42_with_3_x_SUU_25_x_8_LUU_2___Target_Marker_Flares: {
        clsid: "{BRU-42_LS_3*SUU-25_8*LUU-2}",
        name: "BRU-42 with 3 x SUU-25 x 8 LUU-2 - Target Marker Flares",
        weight: 736.65
    },
    BRU_55_with_2_x_AGM_154A___JSOW_CEB__CBU_type_: {
        clsid: "{BRU55_2*AGM-154A}",
        name: "BRU-55 with 2 x AGM-154A - JSOW CEB (CBU-type)",
        weight: 1057.5
    },
    BRU_55_with_2_x_AGM_154C___JSOW_Unitary_BROACH: {
        clsid: "{BRU55_2*AGM-154C}",
        name: "BRU-55 with 2 x AGM-154C - JSOW Unitary BROACH",
        weight: 1055.5
    },
    BRU_55_with_2_x_GBU_38___JDAM__500lb_GPS_Guided_Bomb: {
        clsid: "{BRU55_2*GBU-38}",
        name: "BRU-55 with 2 x GBU-38 - JDAM, 500lb GPS Guided Bomb",
        weight: 573
    },
    BRU_57_with_2_x_AGM_154A___JSOW_CEB__CBU_type_: {
        clsid: "{BRU57_2*AGM-154A}",
        name: "BRU-57 with 2 x AGM-154A - JSOW CEB (CBU-type)",
        weight: 1082
    },
    BRU_57_with_2_x_CBU_103: {
        clsid: "{BRU57_2*CBU-103}",
        name: "BRU-57 with 2 x CBU-103",
        weight: 951
    },
    BRU_57_with_2_x_CBU_105: {
        clsid: "{BRU57_2*CBU-105}",
        name: "BRU-57 with 2 x CBU-105",
        weight: 925
    },
    BRU_57_with_2_x_GBU_38___JDAM__500lb_GPS_Guided_Bomb: {
        clsid: "{BRU57_2*GBU-38}",
        name: "BRU-57 with 2 x GBU-38 - JDAM, 500lb GPS Guided Bomb",
        weight: 573
    },
    BR_250: {
        clsid: "BR_250",
        name: "BR-250",
        weight: 250
    },
    BR_500: {
        clsid: "BR_500",
        name: "BR-500",
        weight: 500
    },
    British_GP_250LBS_Bomb_MK4_on_LH_Spitfire_Wing_Carrier: {
        clsid: "British_GP_250LBS_Bomb_MK4_on_LH_Spitfire_Wing_Carrier",
        name: "250lb Mk.I - GP Bomb LD",
        weight: 108.326
    },
    British_GP_250LBS_Bomb_MK4_on_RH_Spitfire_Wing_Carrier: {
        clsid: "British_GP_250LBS_Bomb_MK4_on_RH_Spitfire_Wing_Carrier",
        name: "250lb Mk.I - GP Bomb LD",
        weight: 108.326
    },
    British_GP_500LBS_Bomb_MK4_on_British_UniversalBC_MK3: {
        clsid: "British_GP_500LBS_Bomb_MK4_on_British_UniversalBC_MK3",
        name: "500lb Mk.I - GP Bomb LD",
        weight: 225.188
    },
    B_13L_pod___5_x_S_13_OF__122mm_UnGd_Rkts__Blast_Frag: {
        clsid: "{FC56DF80-9B09-44C5-8976-DCFAFF219062}",
        name: "B-13L pod - 5 x S-13-OF, 122mm UnGd Rkts, Blast/Frag",
        weight: 510
    },
    B_1B_Mk_84_8: {
        clsid: "B-1B_Mk-84*8",
        name: "8 x Mk-84 - 2000lb GP Bombs LD",
        weight: 7152
    },
    B_8M1_pod___20_x_S_8KOM__80mm_UnGd_Rkts__HEAT_AP: {
        clsid: "{F72F47E5-C83A-4B85-96ED-D3E46671EE9A}",
        name: "B-8M1 pod - 20 x S-8KOM, 80mm UnGd Rkts, HEAT/AP",
        weight: 363.5
    },
    B_8M1_pod___20_x_S_8TsM__80mm_UnGd_Rkts__Smk: {
        clsid: "{3DFB7320-AB0E-11d7-9897-000476191836}",
        name: "B-8M1 pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk",
        weight: 359.5
    },
    B_8M1___20_S_8OFP2: {
        clsid: "B-8M1 - 20 S-8OFP2",
        name: "B-8M1 pod - 20 x S-8OFP2, 80mm UnGd Rkts, HE/Frag/AP",
        weight: 471.5
    },
    B_8V20A_CM: {
        clsid: "B_8V20A_CM",
        name: "B-8V20A pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk, OG",
        weight: 345
    },
    B_8V20A_CM_BU: {
        clsid: "B_8V20A_CM_BU",
        name: "B-8V20A pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk, BU",
        weight: 345
    },
    B_8V20A_CM_GN: {
        clsid: "B_8V20A_CM_GN",
        name: "B-8V20A pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk, GN",
        weight: 345
    },
    B_8V20A_CM_RD: {
        clsid: "B_8V20A_CM_RD",
        name: "B-8V20A pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk, RD",
        weight: 345
    },
    B_8V20A_CM_VT: {
        clsid: "B_8V20A_CM_VT",
        name: "B-8V20A pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk, VT",
        weight: 345
    },
    B_8V20A_CM_WH: {
        clsid: "B_8V20A_CM_WH",
        name: "B-8V20A pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk, WH",
        weight: 345
    },
    B_8V20A_CM_YE: {
        clsid: "B_8V20A_CM_YE",
        name: "B-8V20A pod - 20 x S-8TsM, 80mm UnGd Rkts, Smk, YE",
        weight: 345
    },
    B_8V20A_OFP2: {
        clsid: "B_8V20A_OFP2",
        name: "B-8V20A pod - 20 x S-8OFP2, 80mm UnGd Rkts, HE/Frag/AP",
        weight: 457
    },
    B_8V20A_OM: {
        clsid: "B_8V20A_OM",
        name: "B-8V20A pod - 20 x S-8OM, 80mm UnGd Rkts, Illum",
        weight: 365
    },
    B_8V20A_pod___20_x_S_8KOM__80mm_UnGd_Rkts__HEAT_AP: {
        clsid: "{6A4B9E69-64FE-439a-9163-3A87FB6A4D81}",
        name: "B-8V20A pod - 20 x S-8KOM, 80mm UnGd Rkts, HEAT/AP",
        weight: 349
    },
    CATM_9M: {
        clsid: "CATM-9M",
        name: "Captive AIM-9M for ACM",
        weight: 85.73
    },
    CBLS_200: {
        clsid: "CBLS-200",
        name: "4*BDU-33",
        weight: 98
    },
    CBU87_10: {
        clsid: "CBU87*10",
        name: "10 x CBU-87 - 202 x CEM Cluster Bombs",
        weight: 4300
    },
    CBU97_10: {
        clsid: "CBU97*10",
        name: "10 x CBU-97 - 10 x CEM Cluster Bombs",
        weight: 4170
    },
    CBU_103___202_x_CEM__CBU_with_WCMD: {
        clsid: "{CBU_103}",
        name: "CBU-103 - 202 x CEM, CBU with WCMD",
        weight: 430
    },
    CBU_105___10_x_CEM__CBU_with_WCMD: {
        clsid: "{CBU_105}",
        name: "CBU-105 - 10 x CEM, CBU with WCMD",
        weight: 417
    },
    CBU_52B___220_x_HE_Frag_bomblets: {
        clsid: "{CBU-52B}",
        name: "CBU-52B - 220 x HE/Frag bomblets",
        weight: 356
    },
    CBU_87___202_x_CEM_Cluster_Bomb: {
        clsid: "{CBU-87}",
        name: "CBU-87 - 202 x CEM Cluster Bomb",
        weight: 430
    },
    CBU_97___10_x_CEM_Cluster_Bomb: {
        clsid: "{5335D97A-35A5-4643-9D9B-026C75961E52}",
        name: "CBU-97 - 10 x CEM Cluster Bomb",
        weight: 417
    },
    CBU_99___490lbs__247_x_HEAT_Bomblets: {
        clsid: "{CBU_99}",
        name: "CBU-99 - 490lbs, 247 x HEAT Bomblets",
        weight: 222
    },
    DEFA_553: {
        clsid: "{C-101-DEFA553}",
        name: "DEFA-553",
        weight: 218
    },
    DIS_AKD_10: {
        clsid: "DIS_AKD-10",
        name: "AKD-10",
        weight: 58
    },
    DIS_AKG_DLPOD: {
        clsid: "DIS_AKG_DLPOD",
        name: "DATA-LINK POD",
        weight: 295
    },
    DIS_BRM1_90: {
        clsid: "DIS_BRM1_90",
        name: "BRM-1_90MM",
        weight: 462.5
    },
    DIS_CM_802AKG: {
        clsid: "DIS_CM-802AKG",
        name: "CM-802AKG",
        weight: 765
    },
    DIS_C_701IR: {
        clsid: "DIS_C-701IR",
        name: "C-701IR",
        weight: 170
    },
    DIS_C_701T: {
        clsid: "DIS_C-701T",
        name: "C-701T",
        weight: 170
    },
    DIS_C_802AK: {
        clsid: "DIS_C-802AK",
        name: "C-802AK",
        weight: 765
    },
    DIS_GB6: {
        clsid: "DIS_GB6",
        name: "GB-6",
        weight: 672
    },
    DIS_GB6_HE: {
        clsid: "DIS_GB6_HE",
        name: "GB-6-HE",
        weight: 672
    },
    DIS_GB6_TSP: {
        clsid: "DIS_GB6_TSP",
        name: "GB-6-SFW",
        weight: 672
    },
    DIS_GBU_10: {
        clsid: "DIS_GBU_10",
        name: "GBU-10",
        weight: 1162
    },
    DIS_GBU_12: {
        clsid: "DIS_GBU_12",
        name: "GBU-12",
        weight: 275
    },
    DIS_GBU_12_DUAL_GDJ_II19_L: {
        clsid: "DIS_GBU_12_DUAL_GDJ_II19_L",
        name: "GDJ-II19 - 2 x GBU-12",
        weight: 629
    },
    DIS_GBU_12_DUAL_GDJ_II19_R: {
        clsid: "DIS_GBU_12_DUAL_GDJ_II19_R",
        name: "GDJ-II19 - 2 x GBU-12",
        weight: 629
    },
    DIS_GBU_16: {
        clsid: "DIS_GBU_16",
        name: "GBU-16",
        weight: 564
    },
    DIS_LAU68_MK5_DUAL_GDJ_II19_L: {
        clsid: "DIS_LAU68_MK5_DUAL_GDJ_II19_L",
        name: "GDJ-II19 - 2 x LAU68 MK5",
        weight: 261.06
    },
    DIS_LAU68_MK5_DUAL_GDJ_II19_R: {
        clsid: "DIS_LAU68_MK5_DUAL_GDJ_II19_R",
        name: "GDJ-II19 - 2 x LAU68 MK5",
        weight: 261.06
    },
    DIS_LD_10: {
        clsid: "DIS_LD-10",
        name: "LD-10",
        weight: 289
    },
    DIS_LD_10_DUAL_L: {
        clsid: "DIS_LD-10_DUAL_L",
        name: "LD-10 x 2",
        weight: 558
    },
    DIS_LD_10_DUAL_R: {
        clsid: "DIS_LD-10_DUAL_R",
        name: "LD-10 x 2",
        weight: 558
    },
    DIS_LS_6_500: {
        clsid: "DIS_LS_6_500",
        name: "LS-6-500",
        weight: 570
    },
    DIS_MK_20: {
        clsid: "DIS_MK_20",
        name: "Mk-20",
        weight: 222
    },
    DIS_MK_20_DUAL_GDJ_II19_L: {
        clsid: "DIS_MK_20_DUAL_GDJ_II19_L",
        name: "GDJ-II19 - 2 x Mk-20",
        weight: 523
    },
    DIS_MK_20_DUAL_GDJ_II19_R: {
        clsid: "DIS_MK_20_DUAL_GDJ_II19_R",
        name: "GDJ-II19 - 2 x Mk-20",
        weight: 523
    },
    DIS_MK_82S_DUAL_GDJ_II19_L: {
        clsid: "DIS_MK_82S_DUAL_GDJ_II19_L",
        name: "GDJ-II19 - 2 x Mk-82 SnakeEye",
        weight: 543
    },
    DIS_MK_82S_DUAL_GDJ_II19_R: {
        clsid: "DIS_MK_82S_DUAL_GDJ_II19_R",
        name: "GDJ-II19 - 2 x Mk-82 SnakeEye",
        weight: 543
    },
    DIS_MK_82_DUAL_GDJ_II19_L: {
        clsid: "DIS_MK_82_DUAL_GDJ_II19_L",
        name: "GDJ-II19 - 2 x Mk-82",
        weight: 561
    },
    DIS_MK_82_DUAL_GDJ_II19_R: {
        clsid: "DIS_MK_82_DUAL_GDJ_II19_R",
        name: "GDJ-II19 - 2 x Mk-82",
        weight: 561
    },
    DIS_PL_12: {
        clsid: "DIS_PL-12",
        name: "PL-12",
        weight: 199
    },
    DIS_PL_5EII: {
        clsid: "DIS_PL-5EII",
        name: "PL-5EII",
        weight: 153
    },
    DIS_PL_5EII_TIP: {
        clsid: "DIS_PL-5EII_TIP",
        name: "PL-5EII",
        weight: 83
    },
    DIS_PL_8A: {
        clsid: "DIS_PL-8A",
        name: "PL-8A",
        weight: 115
    },
    DIS_PL_8B: {
        clsid: "DIS_PL-8B",
        name: "PL-8B",
        weight: 115
    },
    DIS_RKT_90_UG: {
        clsid: "DIS_RKT_90_UG",
        name: "UG_90MM",
        weight: 382.5
    },
    DIS_SD_10: {
        clsid: "DIS_SD-10",
        name: "SD-10",
        weight: 289
    },
    DIS_SD_10_DUAL_L: {
        clsid: "DIS_SD-10_DUAL_L",
        name: "SD-10 x 2",
        weight: 558
    },
    DIS_SD_10_DUAL_R: {
        clsid: "DIS_SD-10_DUAL_R",
        name: "SD-10 x 2",
        weight: 558
    },
    DIS_SMOKE_GENERATOR_B: {
        clsid: "DIS_SMOKE_GENERATOR_B",
        name: "Smoke Generator - blue",
        weight: 0
    },
    DIS_SMOKE_GENERATOR_G: {
        clsid: "DIS_SMOKE_GENERATOR_G",
        name: "Smoke Generator - green",
        weight: 0
    },
    DIS_SMOKE_GENERATOR_O: {
        clsid: "DIS_SMOKE_GENERATOR_O",
        name: "Smoke Generator - orange",
        weight: 0
    },
    DIS_SMOKE_GENERATOR_R: {
        clsid: "DIS_SMOKE_GENERATOR_R",
        name: "Smoke Generator - red",
        weight: 0
    },
    DIS_SMOKE_GENERATOR_W: {
        clsid: "DIS_SMOKE_GENERATOR_W",
        name: "Smoke Generator - white",
        weight: 0
    },
    DIS_SMOKE_GENERATOR_Y: {
        clsid: "DIS_SMOKE_GENERATOR_Y",
        name: "Smoke Generator - yellow",
        weight: 0
    },
    DIS_SPJ_POD: {
        clsid: "DIS_SPJ_POD",
        name: "SPJ POD",
        weight: 270
    },
    DIS_TANK1100: {
        clsid: "DIS_TANK1100",
        name: "1100L Tank",
        weight: 1064
    },
    DIS_TANK800: {
        clsid: "DIS_TANK800",
        name: "800L Tank",
        weight: 730
    },
    DIS_TYPE200: {
        clsid: "DIS_TYPE200",
        name: "TYPE-200A",
        weight: 200
    },
    DIS_TYPE200_DUAL_L: {
        clsid: "DIS_TYPE200_DUAL_L",
        name: "TYPE-200A Dual",
        weight: 400
    },
    DIS_TYPE200_DUAL_R: {
        clsid: "DIS_TYPE200_DUAL_R",
        name: "TYPE-200A Dual",
        weight: 400
    },
    DIS_WMD7: {
        clsid: "DIS_WMD7",
        name: "WMD7 POD",
        weight: 295
    },
    DWS39_MJ1: {
        clsid: "{DWS39_MJ1}",
        name: "DWS39 MJ1",
        weight: 605
    },
    DWS39_MJ1_MJ2: {
        clsid: "{DWS39_MJ1_MJ2}",
        name: "DWS39 MJ1-MJ2",
        weight: 605
    },
    DWS39_MJ2: {
        clsid: "{DWS39_MJ2}",
        name: "DWS39 MJ2",
        weight: 605
    },
    Eclair: {
        clsid: "{Eclair}",
        name: "Eclair",
        weight: 20
    },
    ER_4_SC50: {
        clsid: "ER_4_SC50",
        name: "4 x SC 50 - 50kg GP Bomb LD",
        weight: 220
    },
    ETHER: {
        clsid: "{0519A261-0AB6-11d6-9193-00A0249B6F00}",
        name: "ETHER",
        weight: 200
    },
    FAB_100M: {
        clsid: "FAB_100M",
        name: "FAB-100M - 100kg GP Bomb LD",
        weight: 100
    },
    FAB_100M_: {
        clsid: "FAB_100M",
        name: "FAB-100M",
        weight: 100
    },
    FAB_100_x_4: {
        clsid: "{FAB-100-4}",
        name: "FAB-100 x 4",
        weight: 465
    },
    FAB_100___100kg_GP_Bomb_LD: {
        clsid: "{FB3CE165-BF07-4979-887C-92B87F13276B}",
        name: "FAB-100 - 100kg GP Bomb LD",
        weight: 100
    },
    FAB_1500_M_54___1500kg_GP_Bomb_LD: {
        clsid: "{40AA4ABE-D6EB-4CD6-AEFE-A1A0477B24AB}",
        name: "FAB-1500 M-54 - 1500kg GP Bomb LD",
        weight: 1392
    },
    FAB_250_M54: {
        clsid: "{FAB-250-M54}",
        name: "FAB-250 M54",
        weight: 235
    },
    FAB_250_M54_TU: {
        clsid: "{FAB-250-M54-TU}",
        name: "FAB-250 M54 TU",
        weight: 235
    },
    FAB_250___250kg_GP_Bomb_LD: {
        clsid: "{3C612111-C7AD-476E-8A8E-2485812F4E5C}",
        name: "FAB-250 - 250kg GP Bomb LD",
        weight: 250
    },
    FAB_50: {
        clsid: "FAB_50",
        name: "FAB-50 - 50kg GP Bomb LD",
        weight: 50
    },
    FAB_500_M54: {
        clsid: "{FAB-500-M54}",
        name: "FAB-500 M54",
        weight: 474
    },
    FAB_500_M54_TU: {
        clsid: "{FAB-500-M54-TU}",
        name: "FAB-500 M54 TU",
        weight: 480
    },
    FAB_500_M_62___500kg_GP_Bomb_LD: {
        clsid: "{37DCC01E-9E02-432F-B61D-10C166CA2798}",
        name: "FAB-500 M-62 - 500kg GP Bomb LD",
        weight: 506
    },
    FAB_500_SL: {
        clsid: "{FAB-500-SL}",
        name: "FAB-500 SL",
        weight: 515
    },
    FAB_500_TA: {
        clsid: "{FAB-500-TA}",
        name: "FAB-500 TA",
        weight: 477
    },
    FAB_50_: {
        clsid: "FAB_50",
        name: "FAB-50",
        weight: 50
    },
    FIM_92: {
        clsid: "FIM_92",
        name: "STINGER",
        weight: $e56653165fb50b77$var$None
    },
    FPU_8A_Fuel_Tank_330_gallons: {
        clsid: "{FPU_8A_FUEL_TANK}",
        name: "FPU-8A Fuel Tank 330 gallons",
        weight: 1150
    },
    Fuel_Tank_120_gallons: {
        clsid: "{PTB_120_F86F35}",
        name: "Fuel Tank 120 gallons",
        weight: 413.36
    },
    Fuel_Tank_150_liters: {
        clsid: "{PTB_150L_L39}",
        name: "Fuel Tank 150 liters",
        weight: 124.25
    },
    Fuel_Tank_200_gallons: {
        clsid: "{PTB_200_F86F35}",
        name: "Fuel Tank 200 gallons",
        weight: 675.6
    },
    Fuel_Tank_350_liters: {
        clsid: "{PTB_350L_L39}",
        name: "Fuel Tank 350 liters",
        weight: 283.25
    },
    Fuel_Tank_490_L_Central__21_: {
        clsid: "{PTB_490C_MIG21}",
        name: "Fuel Tank 490 L Central (21)",
        weight: 434
    },
    Fuel_Tank_490_L__21_: {
        clsid: "{PTB_490_MIG21}",
        name: "Fuel Tank 490 L (21)",
        weight: 434
    },
    Fuel_Tank_800_L__21_: {
        clsid: "{PTB_800_MIG21}",
        name: "Fuel Tank 800 L (21)",
        weight: 682
    },
    Fuel_Tank_FT600: {
        clsid: "Fuel_Tank_FT600",
        name: "Fuel tank FT600",
        weight: 1925
    },
    Fuel_tank_1150L: {
        clsid: "{414E383A-59EB-41BC-8566-2B5E0788ED1F}",
        name: "Fuel tank 1150L",
        weight: 975.25
    },
    Fuel_tank_1150L_MiG_29: {
        clsid: "{C0FF4842-FBAC-11d5-9190-00A0249B6F00}",
        name: "Fuel tank 1150L MiG-29",
        weight: 975.25
    },
    Fuel_tank_1400L: {
        clsid: "{2BEC576B-CDF5-4B7F-961F-B0FA4312B841}",
        name: "Fuel tank 1400L",
        weight: 1262.5
    },
    Fuel_tank_2000L: {
        clsid: "{16602053-4A12-40A2-B214-AB60D481B20E}",
        name: "Fuel tank 2000L",
        weight: 1700
    },
    Fuel_tank_3000L: {
        clsid: "{7D7EC917-05F6-49D4-8045-61FC587DD019}",
        name: "Fuel tank 3000L",
        weight: 2550
    },
    Fuel_tank_300_gal: {
        clsid: "{8A0BE8AE-58D4-4572-9263-3144C0D06364}",
        name: "Fuel tank 300 gal",
        weight: 1083.5076415
    },
    Fuel_tank_300_gal_: {
        clsid: "{F14-300gal}",
        name: "Fuel tank 300 gal",
        weight: 958.4
    },
    Fuel_tank_300_gal__empty_: {
        clsid: "{F14-300gal-empty}",
        name: "Fuel tank 300 gal (empty)",
        weight: 70
    },
    Fuel_tank_330_gal: {
        clsid: "{EFEC8200-B922-11d7-9897-000476191836}",
        name: "Fuel tank 330 gal",
        weight: 1067.750921
    },
    Fuel_tank_330_gal_: {
        clsid: "{EFEC8201-B922-11d7-9897-000476191836}",
        name: "Fuel tank 330 gal",
        weight: 1067.750921
    },
    Fuel_tank_367_gal: {
        clsid: "{82364E69-5564-4043-A866-E13032926C3E}",
        name: "Fuel tank 367 gal",
        weight: 1181.8623879
    },
    Fuel_tank_370_gal: {
        clsid: "{F376DBEE-4CAE-41BA-ADD9-B2910AC95DEC}",
        name: "Fuel tank 370 gal",
        weight: 1338.1101068
    },
    Fuel_tank_5000L: {
        clsid: "{0855A3A1-FA50-4C89-BDBB-5D5360ABA071}",
        name: "Fuel tank 5000L",
        weight: 4420
    },
    Fuel_tank_610_gal: {
        clsid: "{E1F29B21-F291-4589-9FD8-3272EEC69506}",
        name: "Fuel tank 610 gal",
        weight: 2010.8766885
    },
    Fuel_tank_800L: {
        clsid: "{A5BAEAB7-6FAF-4236-AF72-0FD900F493F9}",
        name: "Fuel tank 800L",
        weight: 680
    },
    Fuel_tank_800L_Wing: {
        clsid: "{E8D4652F-FD48-45B7-BA5B-2AE05BB5A9CF}",
        name: "Fuel tank 800L Wing",
        weight: 760
    },
    Fuel_tank_Ka_50: {
        clsid: "{B99EE8A8-99BC-4a8d-89AC-A26831920DCE}",
        name: "Fuel tank Ka-50",
        weight: 550
    },
    Fuel_tank_S_3: {
        clsid: "{A504D93B-4E80-4B4F-A533-0D9B65F2C55F}",
        name: "Fuel tank S-3",
        weight: 964
    },
    FW109_FUEL_TANK: {
        clsid: "FW109_FUEL_TANK",
        name: "300 liter Fuel Tank Type E2",
        weight: 266
    },
    F_4_Fuel_tank_C: {
        clsid: "{8B9E3FD0-F034-4A07-B6CE-C269884CC71B}",
        name: "F-4 Fuel tank-C",
        weight: 2345
    },
    F_4_Fuel_tank_W: {
        clsid: "{7B4B122D-C12C-4DB4-834E-4D8BB4D863A8}",
        name: "F-4 Fuel tank-W",
        weight: 1420
    },
    F_5_150Gal_Fuel_tank: {
        clsid: "{PTB-150GAL}",
        name: "F-5 150Gal Fuel tank",
        weight: 509
    },
    F_5_275Gal_Fuel_tank: {
        clsid: "{0395076D-2F77-4420-9D33-087A4398130B}",
        name: "F-5 275Gal Fuel tank",
        weight: 909
    },
    GAU_12_Gunpod: {
        clsid: "{GAU_12_Equalizer}",
        name: "GAU 12 Gunpod",
        weight: 283.9
    },
    GBU_10: {
        clsid: "{BRU-32 GBU-10}",
        name: "GBU-10",
        weight: 997.38
    },
    GBU_10___2000lb_Laser_Guided_Bomb: {
        clsid: "{51F9AAE5-964F-4D21-83FB-502E3BFE5F8A}",
        name: "GBU-10 - 2000lb Laser Guided Bomb",
        weight: 959
    },
    GBU_12: {
        clsid: "{BRU-32 GBU-12}",
        name: "GBU-12",
        weight: 332.38
    },
    GBU_12___500lb_Laser_Guided_Bomb: {
        clsid: "{DB769D48-67D7-42ED-A2BE-108D566C8B1E}",
        name: "GBU-12 - 500lb Laser Guided Bomb",
        weight: 277
    },
    GBU_16: {
        clsid: "{BRU-32 GBU-16}",
        name: "GBU-16",
        weight: 621.38
    },
    GBU_16___1000lb_Laser_Guided_Bomb: {
        clsid: "{0D33DDAE-524F-4A4E-B5B8-621754FE3ADE}",
        name: "GBU-16 - 1000lb Laser Guided Bomb",
        weight: 513
    },
    GBU_24: {
        clsid: "{BRU-32 GBU-24}",
        name: "GBU-24",
        weight: 1107.38
    },
    GBU_24_Paveway_III___2000lb_Laser_Guided_Bomb: {
        clsid: "{34759BBC-AF1E-4AEE-A581-498FF7A6EBCE}",
        name: "GBU-24 Paveway III - 2000lb Laser Guided Bomb",
        weight: 900
    },
    GBU_24_Paveway_III___2000lb_Laser_Guided_Bomb_: {
        clsid: "{GBU-24}",
        name: "GBU-24 Paveway III - 2000lb Laser Guided Bomb",
        weight: 934
    },
    GBU_27___2000lb_Laser_Guided_Penetrator_Bomb: {
        clsid: "{EF0A9419-01D6-473B-99A3-BEBDB923B14D}",
        name: "GBU-27 - 2000lb Laser Guided Penetrator Bomb",
        weight: 1200
    },
    GBU_28___5000lb_Laser_Guided_Penetrator_Bomb: {
        clsid: "{F06B775B-FC70-44B5-8A9F-5B5E2EB839C7}",
        name: "GBU-28 - 5000lb Laser Guided Penetrator Bomb",
        weight: 2130
    },
    GBU_31V3B_8: {
        clsid: "GBU-31V3B*8",
        name: "8 x GBU-31(V)3/B - JDAM, 2000lb GPS Guided Penetrator Bombs",
        weight: 7848
    },
    GBU_31_8: {
        clsid: "GBU-31*8",
        name: "8 x GBU-31(V)1/B - JDAM, 2000lb GPS Guided Bombs",
        weight: 7152
    },
    GBU_31_V_1_B___JDAM__2000lb_GPS_Guided_Bomb: {
        clsid: "{GBU-31}",
        name: "GBU-31(V)1/B - JDAM, 2000lb GPS Guided Bomb",
        weight: 934
    },
    GBU_31_V_2_B___JDAM__2000lb_GPS_Guided_Bomb: {
        clsid: "{GBU_31_V_2B}",
        name: "GBU-31(V)2/B - JDAM, 2000lb GPS Guided Bomb",
        weight: 934
    },
    GBU_31_V_3_B___JDAM__2000lb_GPS_Guided_Penetrator_Bomb: {
        clsid: "{GBU-31V3B}",
        name: "GBU-31(V)3/B - JDAM, 2000lb GPS Guided Penetrator Bomb",
        weight: 981
    },
    GBU_31_V_4_B___JDAM__2000lb_GPS_Guided_Penetrator_Bomb: {
        clsid: "{GBU_31_V_4B}",
        name: "GBU-31(V)4/B - JDAM, 2000lb GPS Guided Penetrator Bomb",
        weight: 970
    },
    GBU_32_V_2_B___JDAM__1000lb_GPS_Guided_Bomb: {
        clsid: "{GBU_32_V_2B}",
        name: "GBU-32(V)2/B - JDAM, 1000lb GPS Guided Bomb",
        weight: 467
    },
    GBU_38_16: {
        clsid: "GBU-38*16",
        name: "16 x GBU-38 - JDAM, 500lb GPS Guided Bombs",
        weight: 3856
    },
    GBU_38___JDAM__500lb_GPS_Guided_Bomb: {
        clsid: "{GBU-38}",
        name: "GBU-38 - JDAM, 500lb GPS Guided Bomb",
        weight: 241
    },
    GBU_54B___LJDAM__500lb_Laser__GPS_Guided_Bomb_LD: {
        clsid: "{GBU_54_V_1B}",
        name: "GBU-54B - LJDAM, 500lb Laser & GPS Guided Bomb LD",
        weight: 253
    },
    GUV_VOG: {
        clsid: "GUV_VOG",
        name: "GUV-8700 w AP-30 - 30mm Grenade Launcher",
        weight: 274
    },
    GUV_YakB_GSHP: {
        clsid: "GUV_YakB_GSHP",
        name: "GUV-8700 w 1x12.7 mm & 2x7.62 mm Rotary HMG",
        weight: 452
    },
    HOT3: {
        clsid: "{HOT3G}",
        name: "HOT3",
        weight: 32
    },
    HOT3_: {
        clsid: "{HOT3D}",
        name: "HOT3",
        weight: 32
    },
    HSAB_with_9_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets: {
        clsid: "{4CD2BB0F-5493-44EF-A927-9760350F7BA1}",
        name: "HSAB with 9 x Mk-20 Rockeye - 490lbs CBUs, 247 x HEAT Bomblets",
        weight: 2050
    },
    HSAB_with_9_x_Mk_83___1000lb_GP_Bombs_LD: {
        clsid: "{696CFFC4-0BDE-42A8-BE4B-0BE3D9DD723C}",
        name: "HSAB with 9 x Mk-83 - 1000lb GP Bombs LD",
        weight: 8100
    },
    HVAR_SMOKE__UnGd_Rkt: {
        clsid: "{HVAR_SMOKE_2}",
        name: "HVAR SMOKE, UnGd Rkt",
        weight: 100
    },
    HVAR_Smoke_Generator: {
        clsid: "{HVAR_SMOKE_GENERATOR}",
        name: "HVAR Smoke Generator",
        weight: 64
    },
    HVAR__UnGd_Rkt: {
        clsid: "{HVAR}",
        name: "HVAR, UnGd Rkt",
        weight: 64
    },
    I16_DROP_FUEL_TANK: {
        clsid: "I16_DROP_FUEL_TANK",
        name: "I-16 External Fuel Tank",
        weight: 73
    },
    I16_FAB_100SV: {
        clsid: "I16_FAB_100SV",
        name: "FAB-100SV",
        weight: 100
    },
    I16_RS_82: {
        clsid: "I16_RS_82",
        name: "RS-82",
        weight: 9.7
    },
    IAB_500: {
        clsid: "{IAB-500}",
        name: "IAB-500",
        weight: 470
    },
    IR_Deflector: {
        clsid: "{IR_Deflector}",
        name: "IR Deflector",
        weight: 5
    },
    KAB_1500Kr___1500kg_TV_Guided_Bomb: {
        clsid: "{KAB_1500Kr_LOADOUT}",
        name: "KAB-1500Kr - 1500kg TV Guided Bomb",
        weight: 1525
    },
    KAB_1500LG_Pr___1500kg_Laser_Guided_Penetrator_Bomb: {
        clsid: "{KAB_1500LG_LOADOUT}",
        name: "KAB-1500LG-Pr - 1500kg Laser Guided Penetrator Bomb",
        weight: 1525
    },
    KAB_1500L___1500kg_Laser_Guided_Bomb: {
        clsid: "{39821727-F6E2-45B3-B1F0-490CC8921D1E}",
        name: "KAB-1500L - 1500kg Laser Guided Bomb",
        weight: 1560
    },
    KAB_500Kr___500kg_TV_Guided_Bomb: {
        clsid: "{E2C426E3-8B10-4E09-B733-9CDC26520F48}",
        name: "KAB-500Kr - 500kg TV Guided Bomb",
        weight: 560
    },
    KAB_500LG___500kg_Laser_Guided_Bomb: {
        clsid: "{BA565F89-2373-4A84-9502-A0E017D3A44A}",
        name: "KAB-500LG - 500kg Laser Guided Bomb",
        weight: 534
    },
    KAB_500S___500kg_GPS_Guided_Bomb: {
        clsid: "{KAB_500S_LOADOUT}",
        name: "KAB-500S - 500kg GPS Guided Bomb",
        weight: 500
    },
    KB_Flare_Chaff_dispenser_pod: {
        clsid: "{KB}",
        name: "KB Flare/Chaff dispenser pod",
        weight: 296
    },
    Kh_22__AS_4_Kitchen____1000kg__AShM__IN__Act_Pas_Rdr: {
        clsid: "{12429ECF-03F0-4DF6-BCBD-5D38B6343DE1}",
        name: "Kh-22 (AS-4 Kitchen) - 1000kg, AShM, IN & Act/Pas Rdr",
        weight: 6800
    },
    Kh_23L_Grom__AS_7_Kerry____286kg__ASM__Laser_Guided: {
        clsid: "{9F390892-E6F9-42C9-B84E-1136A881DCB2}",
        name: "Kh-23L Grom (AS-7 Kerry) - 286kg, ASM, Laser Guided",
        weight: 288
    },
    Kh_25ML__AS_10_Karen____300kg__ASM__Semi_Act_Laser: {
        clsid: "{6DADF342-D4BA-4D8A-B081-BA928C4AF86D}",
        name: "Kh-25ML (AS-10 Karen) - 300kg, ASM, Semi-Act Laser",
        weight: 360
    },
    Kh_25ML__AS_10_Karen____300kg__ASM__Semi_Act_Laser_: {
        clsid: "{79D73885-0801-45a9-917F-C90FE1CE3DFC}",
        name: "Kh-25ML (AS-10 Karen) - 300kg, ASM, Semi-Act Laser",
        weight: 360
    },
    Kh_25ML__AS_10_Karen____300kg__ASM__Semi_Act_Laser__: {
        clsid: "{X-25ML}",
        name: "Kh-25ML (AS-10 Karen) - 300kg, ASM, Semi-Act Laser",
        weight: 360
    },
    Kh_25MPU__Updated_AS_12_Kegler____320kg__ARM__IN__Pas_Rdr: {
        clsid: "{E86C5AA5-6D49-4F00-AD2E-79A62D6DDE26}",
        name: "Kh-25MPU (Updated AS-12 Kegler) - 320kg, ARM, IN & Pas Rdr",
        weight: 370
    },
    Kh_25MPU__Updated_AS_12_Kegler____320kg__ARM__IN__Pas_Rdr_: {
        clsid: "{752AF1D2-EBCC-4bd7-A1E7-2357F5601C70}",
        name: "Kh-25MPU (Updated AS-12 Kegler) - 320kg, ARM, IN & Pas Rdr",
        weight: 370
    },
    Kh_25MPU__Updated_AS_12_Kegler____320kg__ARM__IN__Pas_Rdr__: {
        clsid: "{X-25MPU}",
        name: "Kh-25MPU (Updated AS-12 Kegler) - 320kg, ARM, IN & Pas Rdr",
        weight: 370
    },
    Kh_25MP__AS_12_Kegler____320kg__ARM__Pas_Rdr: {
        clsid: "{Kh-25MP}",
        name: "Kh-25MP (AS-12 Kegler) - 320kg, ARM, Pas Rdr",
        weight: 355
    },
    Kh_25MR__AS_10_Karen____300kg__ASM__10km__RC_Guided: {
        clsid: "{292960BB-6518-41AC-BADA-210D65D5073C}",
        name: "Kh-25MR (AS-10 Karen) - 300kg, ASM, 10km, RC Guided",
        weight: 360
    },
    Kh_25MR__AS_10_Karen____300kg__ASM__RC_Guided: {
        clsid: "{X-25MR}",
        name: "Kh-25MR (AS-10 Karen) - 300kg, ASM, RC Guided",
        weight: 360
    },
    Kh_28__AS_9_Kyle____720kg__ARM__Pas_Rdr: {
        clsid: "{Kh-28}",
        name: "Kh-28 (AS-9 Kyle) - 720kg, ARM, Pas Rdr",
        weight: 715
    },
    Kh_29L__AS_14_Kedge____657kg__ASM__Semi_Act_Laser: {
        clsid: "{3468C652-E830-4E73-AFA9-B5F260AB7C3D}",
        name: "Kh-29L (AS-14 Kedge) - 657kg, ASM, Semi-Act Laser",
        weight: 747
    },
    Kh_29L__AS_14_Kedge____657kg__ASM__Semi_Act_Laser_: {
        clsid: "{D4A8D9B9-5C45-42e7-BBD2-0E54F8308432}",
        name: "Kh-29L (AS-14 Kedge) - 657kg, ASM, Semi-Act Laser",
        weight: 747
    },
    Kh_29L__AS_14_Kedge____657kg__ASM__Semi_Act_Laser__: {
        clsid: "{X-29L}",
        name: "Kh-29L (AS-14 Kedge) - 657kg, ASM, Semi-Act Laser",
        weight: 747
    },
    Kh_29T__AS_14_Kedge____670kg__ASM__TV_Guided: {
        clsid: "{B4FC81C9-B861-4E87-BBDC-A1158E648EBF}",
        name: "Kh-29T (AS-14 Kedge) - 670kg, ASM, TV Guided",
        weight: 760
    },
    Kh_29T__AS_14_Kedge____670kg__ASM__TV_Guided_: {
        clsid: "{601C99F7-9AF3-4ed7-A565-F8B8EC0D7AAC}",
        name: "Kh-29T (AS-14 Kedge) - 670kg, ASM, TV Guided",
        weight: 760
    },
    Kh_29T__AS_14_Kedge____670kg__ASM__TV_Guided__: {
        clsid: "{X-29T}",
        name: "Kh-29T (AS-14 Kedge) - 670kg, ASM, TV Guided",
        weight: 760
    },
    Kh_31A__AS_17_Krypton____610kg__AShM__IN__Act_Rdr: {
        clsid: "{4D13E282-DF46-4B23-864A-A9423DFDE504}",
        name: "Kh-31A (AS-17 Krypton) - 610kg, AShM, IN & Act Rdr",
        weight: 690
    },
    Kh_31A__AS_17_Krypton____610kg__AShM__IN__Act_Rdr_: {
        clsid: "{4D13E282-DF46-4B23-864A-A9423DFDE50A}",
        name: "Kh-31A (AS-17 Krypton) - 610kg, AShM, IN & Act Rdr",
        weight: 690
    },
    Kh_31A__AS_17_Krypton____610kg__AShM__IN__Act_Rdr__: {
        clsid: "{X-31A}",
        name: "Kh-31A (AS-17 Krypton) - 610kg, AShM, IN & Act Rdr",
        weight: 690
    },
    Kh_31P__AS_17_Krypton____600kg__ARM__IN__Pas_Rdr: {
        clsid: "{D8F2C90B-887B-4B9E-9FE2-996BC9E9AF03}",
        name: "Kh-31P (AS-17 Krypton) - 600kg, ARM, IN & Pas Rdr",
        weight: 690
    },
    Kh_31P__AS_17_Krypton____600kg__ARM__IN__Pas_Rdr_: {
        clsid: "{D8F2C90B-887B-4B9E-9FE2-996BC9E9AF0A}",
        name: "Kh-31P (AS-17 Krypton) - 600kg, ARM, IN & Pas Rdr",
        weight: 690
    },
    Kh_31P__AS_17_Krypton____600kg__ARM__IN__Pas_Rdr__: {
        clsid: "{X-31P}",
        name: "Kh-31P (AS-17 Krypton) - 600kg, ARM, IN & Pas Rdr",
        weight: 690
    },
    Kh_35__AS_20_Kayak____520kg__AShM__IN__Act_Rdr: {
        clsid: "{2234F529-1D57-4496-8BB0-0150F9BDBBD2}",
        name: "Kh-35 (AS-20 Kayak) - 520kg, AShM, IN & Act Rdr",
        weight: 480
    },
    Kh_35__AS_20_Kayak____520kg__AShM__IN__Act_Rdr_: {
        clsid: "{2234F529-1D57-4496-8BB0-0150F9BDBBD3}",
        name: "Kh-35 (AS-20 Kayak) - 520kg, AShM, IN & Act Rdr",
        weight: 570
    },
    Kh_41__SS_N_22_Sunburn____4500kg__AShM__IN__Act_Rdr: {
        clsid: "{3F26D9C5-5CC3-4E42-BC79-82FAA54E9F26}",
        name: "Kh-41 (SS-N-22-Sunburn) - 4500kg, AShM, IN & Act Rdr",
        weight: 4500
    },
    Kh_58U__AS_11_Kilter____640kg__ARM__IN__Pas_Rdr: {
        clsid: "{FE382A68-8620-4AC0-BDF5-709BFE3977D7}",
        name: "Kh-58U (AS-11 Kilter) - 640kg, ARM, IN & Pas Rdr",
        weight: 730
    },
    Kh_58U__AS_11_Kilter____640kg__ARM__IN__Pas_Rdr_: {
        clsid: "{B5CA9846-776E-4230-B4FD-8BCC9BFB1676}",
        name: "Kh-58U (AS-11 Kilter) - 640kg, ARM, IN & Pas Rdr",
        weight: 730
    },
    Kh_59M__AS_18_Kazoo____930kg__ASM__IN: {
        clsid: "{40AB87E8-BEFB-4D85-90D9-B2753ACF9514}",
        name: "Kh-59M (AS-18 Kazoo) - 930kg, ASM, IN",
        weight: 850
    },
    Kh_65__AS_15B_Kent____1250kg__ASM__IN__MCC: {
        clsid: "{BADAF2DE-68B5-472A-8AAC-35BAEFF6B4A1}",
        name: "Kh-65 (AS-15B Kent) - 1250kg, ASM, IN & MCC",
        weight: 1250
    },
    Kh_66_Grom__21__APU_68: {
        clsid: "{Kh-66_Grom}",
        name: "Kh-66 Grom (21) APU-68",
        weight: 300
    },
    KMGU_2___96_x_AO_2_5RT_Dispenser__CBU__HE_Frag: {
        clsid: "{96A7F676-F956-404A-AD04-F33FB2C74884}",
        name: "KMGU-2 - 96 x AO-2.5RT Dispenser (CBU) HE/Frag",
        weight: 520
    },
    KMGU_2___96_x_PTAB_2_5KO_Dispenser__CBU__HEAT_AP: {
        clsid: "{96A7F676-F956-404A-AD04-F33FB2C74881}",
        name: "KMGU-2 - 96 x PTAB-2.5KO Dispenser (CBU) HEAT/AP",
        weight: 520
    },
    KORD_12_7: {
        clsid: "KORD_12_7",
        name: "Kord 12.7mm HMG",
        weight: 95
    },
    Kopyo_radar_pod: {
        clsid: "{F4920E62-A99A-11d8-9897-000476191836}",
        name: "Kopyo radar pod",
        weight: 115
    },
    Kormoran___ASM: {
        clsid: "{7210496B-7B81-4B52-80D6-8529ECF847CD}",
        name: "Kormoran - ASM",
        weight: 660
    },
    K_13A: {
        clsid: "{K-13A}",
        name: "K-13A",
        weight: 90
    },
    L005_Sorbtsiya_ECM_pod__left_: {
        clsid: "{44EE8698-89F9-48EE-AF36-5FD31896A82F}",
        name: "L005 Sorbtsiya ECM pod (left)",
        weight: 150
    },
    L005_Sorbtsiya_ECM_pod__right_: {
        clsid: "{44EE8698-89F9-48EE-AF36-5FD31896A82A}",
        name: "L005 Sorbtsiya ECM pod (right)",
        weight: 150
    },
    L175V_Khibiny_ECM_pod: {
        clsid: "{ECM_POD_L_175V}",
        name: "L175V Khibiny ECM pod",
        weight: 150
    },
    LANTIRN_Targeting_Pod: {
        clsid: "{F14-LANTIRN-TP}",
        name: "LANTIRN Targeting Pod",
        weight: 342
    },
    LAU3_HE151: {
        clsid: "LAU3_HE151",
        name: "LAU-3 pod - 19 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 234
    },
    LAU3_HE5: {
        clsid: "LAU3_HE5",
        name: "LAU-3 pod - 19 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 234
    },
    LAU3_WP156: {
        clsid: "LAU3_WP156",
        name: "LAU-3 pod - 19 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 234
    },
    LAU3_WP1B: {
        clsid: "LAU3_WP1B",
        name: "LAU-3 pod - 19 x 2.75 Hydra, UnGd Rkts WTU-1/B, Practice",
        weight: 234
    },
    LAU3_WP61: {
        clsid: "LAU3_WP61",
        name: "LAU-3 pod - 19 x 2.75 Hydra, UnGd Rkts Mk61, Practice",
        weight: 234
    },
    LAU_105: {
        clsid: "LAU-105",
        name: "LAU-105",
        weight: 18
    },
    LAU_105_1_AIM_9L_L: {
        clsid: "LAU-105_1*AIM-9L_L",
        name: "LAU-105 with 1 x AIM-9L Sidewinder IR AAM",
        weight: 115.73
    },
    LAU_105_1_AIM_9L_R: {
        clsid: "LAU-105_1*AIM-9L_R",
        name: "LAU-105 with 1 x AIM-9L Sidewinder IR AAM",
        weight: 115.73
    },
    LAU_105_1_AIM_9M_L: {
        clsid: "LAU-105_1*AIM-9M_L",
        name: "LAU-105 with 1 x AIM-9M Sidewinder IR AAM",
        weight: 115.73
    },
    LAU_105_1_AIM_9M_R: {
        clsid: "LAU-105_1*AIM-9M_R",
        name: "LAU-105 with 1 x AIM-9M Sidewinder IR AAM",
        weight: 115.73
    },
    LAU_105_1_CATM_9M_L: {
        clsid: "LAU-105_1*CATM-9M_L",
        name: "LAU-105 with 1 x Captive AIM-9M for ACM",
        weight: 115.73
    },
    LAU_105_1_CATM_9M_R: {
        clsid: "LAU-105_1*CATM-9M_R",
        name: "LAU-105 with 1 x Captive AIM-9M for ACM",
        weight: 115.73
    },
    LAU_105_2_AIM_9L: {
        clsid: "LAU-105_2*AIM-9L",
        name: "LAU-105 with 2 x AIM-9L Sidewinder IR AAM",
        weight: 201.46
    },
    LAU_105_2_AIM_9P5: {
        clsid: "LAU-105_2*AIM-9P5",
        name: "LAU-105 with 2 x AIM-9P5 Sidewinder IR AAM",
        weight: 201
    },
    LAU_105_2_CATM_9M: {
        clsid: "LAU-105_2*CATM-9M",
        name: "LAU-105 with 2 x Captive AIM-9M for ACM",
        weight: 201.46
    },
    LAU_105_AIS_ASQ_T50_L: {
        clsid: "LAU-105_AIS_ASQ_T50_L",
        name: "LAU-105 with 1 x AN/ASQ-T50 TCTS Pod - ACMI Pod",
        weight: 92.6
    },
    LAU_105_AIS_ASQ_T50_R: {
        clsid: "LAU-105_AIS_ASQ_T50_R",
        name: "LAU-105 with 1 x AN/ASQ-T50 TCTS Pod - ACMI Pod",
        weight: 92.6
    },
    LAU_105_with_2_x_AIM_9M_Sidewinder_IR_AAM: {
        clsid: "{DB434044-F5D0-4F1F-9BA9-B73027E18DD3}",
        name: "LAU-105 with 2 x AIM-9M Sidewinder IR AAM",
        weight: 201.46
    },
    LAU_105_with_2_x_AIM_9P_Sidewinder_IR_AAM: {
        clsid: "{3C0745ED-8B0B-42eb-B907-5BD5C1717447}",
        name: "LAU-105 with 2 x AIM-9P Sidewinder IR AAM",
        weight: 202.36
    },
    LAU_10R_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG: {
        clsid: "{LAU_10R}",
        name: "LAU-10R pod - 4 x 127mm ZUNI, UnGd Rkts Mk71, HE/FRAG",
        weight: 316.6
    },
    LAU_10_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG: {
        clsid: "{F3EFE0AB-E91A-42D8-9CA2-B63C91ED570A}",
        name: "LAU-10 pod - 4 x 127mm ZUNI, UnGd Rkts Mk71, HE/FRAG",
        weight: 316.6
    },
    LAU_10___4_ZUNI_MK_71: {
        clsid: "{BRU42_LAU10}",
        name: "LAU-10 - 4 ZUNI MK 71",
        weight: 568
    },
    LAU_10___4_ZUNI_MK_71_: {
        clsid: "{BRU3242_LAU10}",
        name: "LAU-10 - 4 ZUNI MK 71",
        weight: 625.38
    },
    LAU_115C_with_AIM_7E_Sparrow_Semi_Active_Radar: {
        clsid: "{LAU-115 - AIM-7E}",
        name: "LAU-115C with AIM-7E Sparrow Semi-Active Radar",
        weight: 284.4
    },
    LAU_115C_with_AIM_7F_Sparrow_Semi_Active_Radar: {
        clsid: "{LAU-115 - AIM-7F}",
        name: "LAU-115C with AIM-7F Sparrow Semi-Active Radar",
        weight: 285.4
    },
    LAU_115C_with_AIM_7MH_Sparrow_Semi_Active_Radar: {
        clsid: "{LAU-115 - AIM-7H}",
        name: "LAU-115C with AIM-7MH Sparrow Semi-Active Radar",
        weight: 285.4
    },
    LAU_115_2_LAU_127_AIM_120B: {
        clsid: "LAU-115_2*LAU-127_AIM-120B",
        name: "LAU-115 with 2 x LAU-127 AIM-120B AMRAAM - Active Rdr AAM",
        weight: 457
    },
    LAU_115_2_LAU_127_AIM_120C: {
        clsid: "LAU-115_2*LAU-127_AIM-120C",
        name: "LAU-115 with 2 x LAU-127 AIM-120C-5 AMRAAM - Active Rdr AAM",
        weight: 468
    },
    LAU_115_2_LAU_127_AIM_9L: {
        clsid: "LAU-115_2*LAU-127_AIM-9L",
        name: "LAU-115 with 2 x LAU-127 AIM-9L Sidewinder IR AAM",
        weight: 316.46
    },
    LAU_115_2_LAU_127_AIM_9M: {
        clsid: "LAU-115_2*LAU-127_AIM-9M",
        name: "LAU-115 with 2 x LAU-127 AIM-9M Sidewinder IR AAM",
        weight: 316.46
    },
    LAU_115_2_LAU_127_AIM_9X: {
        clsid: "LAU-115_2*LAU-127_AIM-9X",
        name: "LAU-115 with 2 x LAU-127 AIM-9X Sidewinder IR AAM",
        weight: 313.92
    },
    LAU_115_2_LAU_127_CATM_9M: {
        clsid: "LAU-115_2*LAU-127_CATM-9M",
        name: "LAU-115 with 2 x LAU-127 Captive AIM-9M for ACM",
        weight: 316.46
    },
    LAU_115_LAU_127_AIM_9L: {
        clsid: "LAU-115_LAU-127_AIM-9L",
        name: "LAU-115 with 1 x LAU-127 AIM-9L Sidewinder IR AAM",
        weight: 230.73
    },
    LAU_115_LAU_127_AIM_9L_R: {
        clsid: "LAU-115_LAU-127_AIM-9L_R",
        name: "LAU-115 with 1 x LAU-127 AIM-9L Sidewinder IR AAM",
        weight: 230.73
    },
    LAU_115_LAU_127_AIM_9M: {
        clsid: "LAU-115_LAU-127_AIM-9M",
        name: "LAU-115 with 1 x LAU-127 AIM-9M Sidewinder IR AAM",
        weight: 230.73
    },
    LAU_115_LAU_127_AIM_9M_R: {
        clsid: "LAU-115_LAU-127_AIM-9M_R",
        name: "LAU-115 with 1 x LAU-127 AIM-9M Sidewinder IR AAM",
        weight: 230.73
    },
    LAU_115_LAU_127_AIM_9X: {
        clsid: "LAU-115_LAU-127_AIM-9X",
        name: "LAU-115 with 1 x LAU-127 AIM-9X Sidewinder IR AAM",
        weight: 229.46
    },
    LAU_115_LAU_127_AIM_9X_R: {
        clsid: "LAU-115_LAU-127_AIM-9X_R",
        name: "LAU-115 with 1 x LAU-127 AIM-9X Sidewinder IR AAM",
        weight: 229.46
    },
    LAU_115_LAU_127_CATM_9M: {
        clsid: "LAU-115_LAU-127_CATM-9M",
        name: "LAU-115 with 1 x LAU-127 Captive AIM-9M for ACM",
        weight: 230.73
    },
    LAU_115_LAU_127_CATM_9M_R: {
        clsid: "LAU-115_LAU-127_CATM-9M_R",
        name: "LAU-115 with 1 x LAU-127 Captive AIM-9M for ACM",
        weight: 230.73
    },
    LAU_115_with_1_x_LAU_127_AIM_120B_AMRAAM___Active_Rdr_AAM: {
        clsid: "{LAU-115 - AIM-120B}",
        name: "LAU-115 with 1 x LAU-127 AIM-120B AMRAAM - Active Rdr AAM",
        weight: 301
    },
    LAU_115_with_1_x_LAU_127_AIM_120B_AMRAAM___Active_Rdr_AAM_: {
        clsid: "{LAU-115 - AIM-120B_R}",
        name: "LAU-115 with 1 x LAU-127 AIM-120B AMRAAM - Active Rdr AAM",
        weight: 301
    },
    LAU_115_with_1_x_LAU_127_AIM_120C_5_AMRAAM___Active_Rdr_AAM: {
        clsid: "{LAU-115 - AIM-120C}",
        name: "LAU-115 with 1 x LAU-127 AIM-120C-5 AMRAAM - Active Rdr AAM",
        weight: 306.5
    },
    LAU_115_with_1_x_LAU_127_AIM_120C_5_AMRAAM___Active_Rdr_AAM_: {
        clsid: "{LAU-115 - AIM-120C_R}",
        name: "LAU-115 with 1 x LAU-127 AIM-120C-5 AMRAAM - Active Rdr AAM",
        weight: 306.5
    },
    LAU_115_with_AIM_7M_Sparrow_Semi_Active_Radar: {
        clsid: "{LAU-115 - AIM-7M}",
        name: "LAU-115 with AIM-7M Sparrow Semi-Active Radar",
        weight: 285.5
    },
    LAU_117_AGM_65A: {
        clsid: "LAU_117_AGM_65A",
        name: "LAU-117 with AGM-65A - Maverick A (TV Guided)",
        weight: 269.5
    },
    LAU_117_AGM_65B: {
        clsid: "LAU_117_AGM_65B",
        name: "LAU-117 with AGM-65B - Maverick B (TV Guided)",
        weight: 269.5
    },
    LAU_117_AGM_65F: {
        clsid: "LAU_117_AGM_65F",
        name: "LAU-117 with AGM-65F - Maverick F (IIR ASM)",
        weight: 360
    },
    LAU_117_AGM_65G: {
        clsid: "LAU_117_AGM_65G",
        name: "LAU-117 with AGM-65G - Maverick G (IIR ASM - Lg Whd)",
        weight: 360
    },
    LAU_117_AGM_65H: {
        clsid: "LAU_117_AGM_65H",
        name: "LAU-117 with AGM-65H - Maverick H (CCD Imp ASM)",
        weight: 267
    },
    LAU_117_AGM_65L: {
        clsid: "LAU_117_AGM_65L",
        name: "LAU-117 with AGM-65L - Maverick E2/L (CCD Laser ASM)",
        weight: 351
    },
    LAU_117_CATM_65K: {
        clsid: "LAU_117_CATM_65K",
        name: "LAU-117 with CATM-65K - Captive Trg Round for Mav K (CCD)",
        weight: 356
    },
    LAU_117_TGM_65D: {
        clsid: "LAU_117_TGM_65D",
        name: "LAU-117 with TGM-65D - Trg Round for Mav D (IIR)",
        weight: 277
    },
    LAU_117_TGM_65G: {
        clsid: "LAU_117_TGM_65G",
        name: "LAU-117 with TGM-65G - Trg Round for Mav G (IIR)",
        weight: 360
    },
    LAU_117_TGM_65H: {
        clsid: "LAU_117_TGM_65H",
        name: "LAU-117 with TGM-65H - Trg Round for Mav H (CCD)",
        weight: 267
    },
    LAU_117_with_AGM_65D___Maverick_D__IIR_ASM_: {
        clsid: "{444BA8AE-82A7-4345-842E-76154EFCCA46}",
        name: "LAU-117 with AGM-65D - Maverick D (IIR ASM)",
        weight: 277
    },
    LAU_117_with_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_: {
        clsid: "{F16A4DE0-116C-4A71-97F0-2CF85B0313EC}",
        name: "LAU-117 with AGM-65E - Maverick E (Laser ASM - Lg Whd)",
        weight: 345
    },
    LAU_117_with_AGM_65K___Maverick_K__CCD_Imp_ASM_: {
        clsid: "{69DC8AE7-8F77-427B-B8AA-B19D3F478B66}",
        name: "LAU-117 with AGM-65K - Maverick K (CCD Imp ASM)",
        weight: 356
    },
    LAU_118a_with_AGM_45B_Shrike_ARM__Imp_: {
        clsid: "{3E6B632D-65EB-44D2-9501-1C2D04515405}",
        name: "LAU-118a with AGM-45B Shrike ARM (Imp)",
        weight: 222.4
    },
    LAU_127_AIM_9L: {
        clsid: "LAU-127_AIM-9L",
        name: "LAU-127 AIM-9L Sidewinder IR AAM",
        weight: 131.03
    },
    LAU_127_AIM_9M: {
        clsid: "LAU-127_AIM-9M",
        name: "LAU-127 AIM-9M Sidewinder IR AAM",
        weight: 131.03
    },
    LAU_127_AIM_9X: {
        clsid: "LAU-127_AIM-9X",
        name: "LAU-127 AIM-9X Sidewinder IR AAM",
        weight: 129.76
    },
    LAU_127_CATM_9M: {
        clsid: "LAU-127_CATM-9M",
        name: "LAU-127 Captive AIM-9M for ACM",
        weight: 131.03
    },
    LAU_131x3_HYDRA_70_M151: {
        clsid: "LAU_131x3_HYDRA_70_M151",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 406.65
    },
    LAU_131x3_HYDRA_70_M156: {
        clsid: "LAU_131x3_HYDRA_70_M156",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 410.43
    },
    LAU_131x3_HYDRA_70_M257: {
        clsid: "LAU_131x3_HYDRA_70_M257",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts M257, Para Illum",
        weight: 423.45
    },
    LAU_131x3_HYDRA_70_M274: {
        clsid: "LAU_131x3_HYDRA_70_M274",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts M274, Practice Smk",
        weight: 406.65
    },
    LAU_131x3_HYDRA_70_MK1: {
        clsid: "LAU_131x3_HYDRA_70_MK1",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts Mk1, Practice",
        weight: 379.56
    },
    LAU_131x3_HYDRA_70_MK5: {
        clsid: "LAU_131x3_HYDRA_70_MK5",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 373.26
    },
    LAU_131x3_HYDRA_70_MK61: {
        clsid: "LAU_131x3_HYDRA_70_MK61",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts Mk61, Practice",
        weight: 379.56
    },
    LAU_131x3_HYDRA_70_WTU1B: {
        clsid: "LAU_131x3_HYDRA_70_WTU1B",
        name: "BRU-42 with 3 x LAU-131 pods - 21 x 2.75 Hydra, UnGd Rkts WTU-1/B, Practice",
        weight: 406.65
    },
    LAU_131_pod___7_x_2_75_Hydra__Laser_Guided_Rkts_M151__HE_APKWS: {
        clsid: "{LAU-131 - 7 AGR-20A}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, Laser Guided Rkts M151, HE APKWS",
        weight: 134.5
    },
    LAU_131_pod___7_x_2_75_Hydra__Laser_Guided_Rkts_M282__MPP_APKWS: {
        clsid: "{LAU-131 - 7 AGR-20 M282}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, Laser Guided Rkts M282, MPP APKWS",
        weight: 148.5
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{69926055-0DA8-4530-9F2F-C86B157EA9F6}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 102.3
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos: {
        clsid: "{2AF2EC3F-9065-4de5-93E1-1739C9A71EF7}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 103.56
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M257__Para_Illum: {
        clsid: "{DAD45FE5-CFF0-4a2b-99D4-5D044D3BC22F}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts M257, Para Illum",
        weight: 107.9
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M274__Practice_Smk: {
        clsid: "{6D6D5C07-2A90-4a68-9A74-C5D0CFFB05D9}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts M274, Practice Smk",
        weight: 102.3
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk1__Practice: {
        clsid: "{D22C2D63-E5C9-4247-94FB-5E8F3DE22B71}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts Mk1, Practice",
        weight: 93.27
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT: {
        clsid: "{319293F2-392C-4617-8315-7C88C22AF7C4}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 91.17
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk61__Practice: {
        clsid: "{1CA5E00B-D545-4ff9-9B53-5970E292F14D}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts Mk61, Practice",
        weight: 93.27
    },
    LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_WTU_1_B__Practice: {
        clsid: "{DDCE7D70-5313-4181-8977-F11018681662}",
        name: "LAU-131 pod - 7 x 2.75 Hydra, UnGd Rkts WTU-1/B, Practice",
        weight: 102.3
    },
    LAU_138_AIM_9L: {
        clsid: "{LAU-138 wtip - AIM-9L}",
        name: "LAU-138 AIM-9L",
        weight: 85.5
    },
    LAU_138_AIM_9M: {
        clsid: "{LAU-138 wtip - AIM-9M}",
        name: "LAU-138 AIM-9M",
        weight: 86.64
    },
    LAU_3_pod___19_x_2_75_FFAR__UnGd_Rkts_M156__Wht_Phos: {
        clsid: "{LAU3_FFAR_WP156}",
        name: "LAU-3 pod - 19 x 2.75 FFAR, UnGd Rkts M156, Wht Phos",
        weight: 312.8707256
    },
    LAU_3_pod___19_x_2_75_FFAR__UnGd_Rkts_Mk1__HE: {
        clsid: "{LAU3_FFAR_MK1HE}",
        name: "LAU-3 pod - 19 x 2.75 FFAR, UnGd Rkts Mk1, HE",
        weight: 285.292332
    },
    LAU_3_pod___19_x_2_75_FFAR__UnGd_Rkts_Mk5__HEAT: {
        clsid: "{LAU3_FFAR_MK5HEAT}",
        name: "LAU-3 pod - 19 x 2.75 FFAR, UnGd Rkts Mk5, HEAT",
        weight: 286.1541568
    },
    LAU_61R_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{LAU_61R}",
        name: "LAU-61R pod - 19 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 271.5
    },
    LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{FD90A1DC-9147-49FA-BF56-CB83EF0BD32B}",
        name: "LAU-61 pod - 19 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 273.4
    },
    LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos: {
        clsid: "{3DFB7321-AB0E-11d7-9897-000476191836}",
        name: "LAU-61 pod - 19 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 274.92
    },
    LAU_68_pod___7_x_2_75_FFAR__UnGd_Rkts_M156__Wht_Phos: {
        clsid: "{LAU68_FFAR_WP156}",
        name: "LAU-68 pod - 7 x 2.75 FFAR, UnGd Rkts M156, Wht Phos",
        weight: 120.1560568
    },
    LAU_68_pod___7_x_2_75_FFAR__UnGd_Rkts_Mk1__HE: {
        clsid: "{LAU68_FFAR_MK1HE}",
        name: "LAU-68 pod - 7 x 2.75 FFAR, UnGd Rkts Mk1, HE",
        weight: 109.995596
    },
    LAU_68_pod___7_x_2_75_FFAR__UnGd_Rkts_Mk5__HEAT: {
        clsid: "{LAU68_FFAR_MK5HEAT}",
        name: "LAU-68 pod - 7 x 2.75 FFAR, UnGd Rkts Mk5, HEAT",
        weight: 110.3131104
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{A021F29D-18AB-4d3e-985C-FC9C60E35E9E}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 113.9
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos: {
        clsid: "{4F977A2A-CD25-44df-90EF-164BFA2AE72F}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 114.46
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M257__Para_Illum: {
        clsid: "{647C5F26-BDD1-41e6-A371-8DE1E4CC0E94}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts M257, Para Illum",
        weight: 118.8
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M274__Practice_Smk: {
        clsid: "{0877B74B-5A00-4e61-BA8A-A56450BA9E27}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts M274, Practice Smk",
        weight: 113.2
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk1__Practice: {
        clsid: "{FC85D2ED-501A-48ce-9863-49D468DDD5FC}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts Mk1, Practice",
        weight: 104.17
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT: {
        clsid: "{174C6E6D-0C3D-42ff-BCB3-0853CB371F5C}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 102.07
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk61__Practice: {
        clsid: "{65396399-9F5C-4ec3-A7D2-5A8F4C1D90C4}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts Mk61, Practice",
        weight: 104.17
    },
    LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_WTU_1_B__Practice: {
        clsid: "{1F7136CB-8120-4e77-B97B-945FF01FB67C}",
        name: "LAU-68 pod - 7 x 2.75 Hydra, UnGd Rkts WTU-1/B, Practice",
        weight: 113.2
    },
    LAU_7_AIM_9L: {
        clsid: "{LAU-7 - AIM-9L}",
        name: "LAU-7 AIM-9L",
        weight: 100.5
    },
    LAU_7_AIM_9M: {
        clsid: "{LAU-7 - AIM-9M}",
        name: "LAU-7 AIM-9M",
        weight: 101.64
    },
    LAU_7_with_2_x_AIM_9B_Sidewinder_IR_AAM: {
        clsid: "{F4-2-AIM9B}",
        name: "LAU-7 with 2 x AIM-9B Sidewinder IR AAM",
        weight: 178.78
    },
    LAU_7_with_2_x_AIM_9L_Sidewinder_IR_AAM: {
        clsid: "{F4-2-AIM9L}",
        name: "LAU-7 with 2 x AIM-9L Sidewinder IR AAM",
        weight: 201.46
    },
    LAU_7_with_2_x_AIM_9M_Sidewinder_IR_AAM: {
        clsid: "{9DDF5297-94B9-42FC-A45E-6E316121CD85}",
        name: "LAU-7 with 2 x AIM-9M Sidewinder IR AAM",
        weight: 201.46
    },
    LAU_7_with_2_x_AIM_9P5_Sidewinder_IR_AAM: {
        clsid: "{F4-2-AIM9P5}",
        name: "LAU-7 with 2 x AIM-9P5 Sidewinder IR AAM",
        weight: 201
    },
    LAU_7_with_2_x_AIM_9P_Sidewinder_IR_AAM: {
        clsid: "{773675AB-7C29-422f-AFD8-32844A7B7F17}",
        name: "LAU-7 with 2 x AIM-9P Sidewinder IR AAM",
        weight: 202.36
    },
    LAU_7_with_AIM_9B_Sidewinder_IR_AAM: {
        clsid: "{GAR-8}",
        name: "LAU-7 with AIM-9B Sidewinder IR AAM",
        weight: 89.39
    },
    LAU_7_with_AIM_9M_Sidewinder_IR_AAM: {
        clsid: "{AIM-9M-ON-ADAPTER}",
        name: "LAU-7 with AIM-9M Sidewinder IR AAM",
        weight: 100.73
    },
    LAU_7_with_AIM_9P5_Sidewinder_IR_AAM: {
        clsid: "{AIM-9P5-ON-ADAPTER}",
        name: "LAU-7 with AIM-9P5 Sidewinder IR AAM",
        weight: 100.5
    },
    LAU_7_with_AIM_9P_Sidewinder_IR_AAM: {
        clsid: "{AIM-9P-ON-ADAPTER}",
        name: "LAU-7 with AIM-9P Sidewinder IR AAM",
        weight: 101.18
    },
    LAU_7_with_AIM_9X_Sidewinder_IR_AAM: {
        clsid: "{AIM-9X-ON-ADAPTER}",
        name: "LAU-7 with AIM-9X Sidewinder IR AAM",
        weight: 99.46
    },
    LAU_7_with_AN_ASQ_T50_TCTS_Pod___ACMI_Pod: {
        clsid: "{LAU-7_AIS_ASQ_T50}",
        name: "LAU-7 with AN/ASQ-T50 TCTS Pod - ACMI Pod",
        weight: 92.6
    },
    LAU_88_AGM_65D_ONE: {
        clsid: "LAU_88_AGM_65D_ONE",
        name: "LAU-88 with 1 x AGM-65D - Maverick D (IIR ASM)",
        weight: 429
    },
    LAU_88_AGM_65H: {
        clsid: "LAU_88_AGM_65H",
        name: "LAU-88 with 1 x AGM-65H - Maverick H (CCD Imp ASM)",
        weight: 419
    },
    LAU_88_AGM_65H_2_L: {
        clsid: "LAU_88_AGM_65H_2_L",
        name: "LAU-88 with 2 x AGM-65H - Maverick H (CCD Imp ASM)",
        weight: 627
    },
    LAU_88_AGM_65H_2_R: {
        clsid: "LAU_88_AGM_65H_2_R",
        name: "LAU-88 with 2 x AGM-65H - Maverick H (CCD Imp ASM)",
        weight: 627
    },
    LAU_88_AGM_65H_3: {
        clsid: "LAU_88_AGM_65H_3",
        name: "LAU-88 with 3 x AGM-65H - Maverick H (CCD Imp ASM)",
        weight: 835
    },
    LAU_88_with_2_x_AGM_65D___Maverick_D__IIR_ASM_: {
        clsid: "{E6A6262A-CA08-4B3D-B030-E1A993B98452}",
        name: "LAU-88 with 2 x AGM-65D - Maverick D (IIR ASM)",
        weight: 647
    },
    LAU_88_with_2_x_AGM_65D___Maverick_D__IIR_ASM__: {
        clsid: "{E6A6262A-CA08-4B3D-B030-E1A993B98453}",
        name: "LAU-88 with 2 x AGM-65D - Maverick D (IIR ASM)",
        weight: 647
    },
    LAU_88_with_2_x_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_: {
        clsid: "{2CC29C7A-E863-411C-8A6E-BD6F0E730548}",
        name: "LAU-88 with 2 x AGM-65E - Maverick E (Laser ASM - Lg Whd)",
        weight: 783
    },
    LAU_88_with_2_x_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd__: {
        clsid: "{2CC29C7A-E863-411C-8A6E-BD6F0E730547}",
        name: "LAU-88 with 2 x AGM-65E - Maverick E (Laser ASM - Lg Whd)",
        weight: 783
    },
    LAU_88_with_2_x_AGM_65K___Maverick_K__CCD_Imp_ASM_: {
        clsid: "{D7670BC7-881B-4094-906C-73879CF7EB28}",
        name: "LAU-88 with 2 x AGM-65K - Maverick K (CCD Imp ASM)",
        weight: 805
    },
    LAU_88_with_2_x_AGM_65K___Maverick_K__CCD_Imp_ASM__: {
        clsid: "{D7670BC7-881B-4094-906C-73879CF7EB27}",
        name: "LAU-88 with 2 x AGM-65K - Maverick K (CCD Imp ASM)",
        weight: 805
    },
    LAU_88_with_3_x_AGM_65D___Maverick_D__IIR_ASM_: {
        clsid: "{DAC53A2F-79CA-42FF-A77A-F5649B601308}",
        name: "LAU-88 with 3 x AGM-65D - Maverick D (IIR ASM)",
        weight: 865
    },
    LAU_88_with_3_x_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_: {
        clsid: "{71AAB9B8-81C1-4925-BE50-1EF8E9899271}",
        name: "LAU-88 with 3 x AGM-65E - Maverick E (Laser ASM - Lg Whd)",
        weight: 1069
    },
    LAU_88_with_3_x_AGM_65K___Maverick_K__CCD_Imp_ASM_: {
        clsid: "{907D835F-E650-4154-BAFD-C656882555C0}",
        name: "LAU-88 with 3 x AGM-65K - Maverick K (CCD Imp ASM)",
        weight: 1102
    },
    LAU_SNEB68G___8xSNEB68_EAP: {
        clsid: "{LAU_SNEB68G}",
        name: "LAU_SNEB68G - 8xSNEB68_EAP",
        weight: 50.08
    },
    LAU_SNEB68G___8xSNEB68_WP: {
        clsid: "{LAU_SNEB68_WP}",
        name: "LAU_SNEB68G - 8xSNEB68_WP",
        weight: 50.08
    },
    Lantirn_F_16: {
        clsid: "{CAAC1CFD-6745-416B-AFA4-CB57414856D0}",
        name: "Lantirn F-16",
        weight: 445
    },
    Lantirn_Target_Pod: {
        clsid: "{D1744B93-2A8A-4C4D-B004-7A09CD8C8F3F}",
        name: "Lantirn Target Pod",
        weight: 200
    },
    L_081_Fantasmagoria_ELINT_pod: {
        clsid: "{0519A264-0AB6-11d6-9193-00A0249B6F00}",
        name: "L-081 Fantasmagoria ELINT pod",
        weight: 300
    },
    M10_Smoke_Tank___blue: {
        clsid: "{US_M10_SMOKE_TANK_BLUE}",
        name: "M10 Smoke Tank - blue",
        weight: 266.7
    },
    M10_Smoke_Tank___green: {
        clsid: "{US_M10_SMOKE_TANK_GREEN}",
        name: "M10 Smoke Tank - green",
        weight: 266.7
    },
    M10_Smoke_Tank___orange: {
        clsid: "{US_M10_SMOKE_TANK_ORANGE}",
        name: "M10 Smoke Tank - orange",
        weight: 266.7
    },
    M10_Smoke_Tank___red: {
        clsid: "{US_M10_SMOKE_TANK_RED}",
        name: "M10 Smoke Tank - red",
        weight: 266.7
    },
    M10_Smoke_Tank___white: {
        clsid: "{US_M10_SMOKE_TANK_WHITE}",
        name: "M10 Smoke Tank - white",
        weight: 266.7
    },
    M10_Smoke_Tank___yellow: {
        clsid: "{US_M10_SMOKE_TANK_YELLOW}",
        name: "M10 Smoke Tank - yellow",
        weight: 266.7
    },
    M117___750lb_GP_Bomb_LD: {
        clsid: "{00F5DAC4-0466-4122-998F-B1A298E34113}",
        name: "M117 - 750lb GP Bomb LD",
        weight: 340
    },
    M134_L: {
        clsid: "M134_L",
        name: "M134 - 6 x 7.62mm MiniGun left",
        weight: 146.4
    },
    M134_R: {
        clsid: "M134_R",
        name: "M134 - 6 x 7.62mm MiniGun right",
        weight: 146.4
    },
    M134_SIDE_L: {
        clsid: "M134_SIDE_L",
        name: "M134 - 6 x 7.62mm MiniGun left door",
        weight: 270.4
    },
    M134_SIDE_R: {
        clsid: "M134_SIDE_R",
        name: "M134 - 6 x 7.62mm MiniGun right door",
        weight: 270.4
    },
    M2000_Fuel_tank: {
        clsid: "{414DA830-B61A-4F9E-B71B-C2F6832E1D7A}",
        name: "M2000 Fuel tank",
        weight: 1050
    },
    M260_HYDRA: {
        clsid: "M260_HYDRA",
        name: "M260 - 7 2.75' rockets MK156",
        weight: 112
    },
    M260_HYDRA_WP: {
        clsid: "M260_HYDRA_WP",
        name: "M260 - 7 2.75' rockets MK156 WP",
        weight: 112
    },
    M261_MK151: {
        clsid: "M261_MK151",
        name: "M261 pod - 19 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 234
    },
    M261_MK156: {
        clsid: "M261_MK156",
        name: "M261 pod - 19 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 234
    },
    M60_SIDE_L: {
        clsid: "M60_SIDE_L",
        name: "M60 - 7.62mm MG left door",
        weight: 141.4
    },
    M60_SIDE_R: {
        clsid: "M60_SIDE_R",
        name: "M60 - 7.62mm MG right door",
        weight: 141.4
    },
    MAK79_2_MK_20: {
        clsid: "{MAK79_MK20 2L}",
        name: "MAK79 2 MK-20",
        weight: 464
    },
    MAK79_2_MK_20_: {
        clsid: "{MAK79_MK20 2R}",
        name: "MAK79 2 MK-20",
        weight: 464
    },
    MAK79_3_BDU_33: {
        clsid: "{MAK79_BDU33 3L}",
        name: "MAK79 3 BDU-33",
        weight: 63
    },
    MAK79_3_BDU_33_: {
        clsid: "{MAK79_BDU33 3R}",
        name: "MAK79 3 BDU-33",
        weight: 63
    },
    MAK79_3_Mk_81: {
        clsid: "{MAK79_MK81 3L}",
        name: "MAK79 3 Mk-81",
        weight: 384
    },
    MAK79_3_Mk_81_: {
        clsid: "{MAK79_MK81 3R}",
        name: "MAK79 3 Mk-81",
        weight: 384
    },
    MAK79_3_Mk_82: {
        clsid: "{MAK79_MK82 3L}",
        name: "MAK79 3 Mk-82",
        weight: 753
    },
    MAK79_3_Mk_82AIR: {
        clsid: "{MAK79_MK82AIR 3L}",
        name: "MAK79 3 Mk-82AIR",
        weight: 753
    },
    MAK79_3_Mk_82AIR_: {
        clsid: "{MAK79_MK82AIR 3R}",
        name: "MAK79 3 Mk-82AIR",
        weight: 753
    },
    MAK79_3_Mk_82_: {
        clsid: "{MAK79_MK82 3R}",
        name: "MAK79 3 Mk-82",
        weight: 753
    },
    MAK79_3_Mk_82_SnakeEye: {
        clsid: "{MAK79_MK82SE 3L}",
        name: "MAK79 3 Mk-82 SnakeEye",
        weight: 753
    },
    MAK79_3_Mk_82_SnakeEye_: {
        clsid: "{MAK79_MK82SE 3R}",
        name: "MAK79 3 Mk-82 SnakeEye",
        weight: 753
    },
    MAK79_3_Mk_83: {
        clsid: "{MAK79_MK83 3L}",
        name: "MAK79 3 Mk-83",
        weight: 1371
    },
    MAK79_3_Mk_83_: {
        clsid: "{MAK79_MK83 3R}",
        name: "MAK79 3 Mk-83",
        weight: 1371
    },
    MAK79_4_BDU_33: {
        clsid: "{MAK79_BDU33 4}",
        name: "MAK79 4 BDU-33",
        weight: 84
    },
    MAK79_4_Mk_81: {
        clsid: "{MAK79_MK81 4}",
        name: "MAK79 4 Mk-81",
        weight: 512
    },
    MAK79_4_Mk_82: {
        clsid: "{MAK79_MK82 4}",
        name: "MAK79 4 Mk-82",
        weight: 1004
    },
    MAK79_4_Mk_82AIR: {
        clsid: "{MAK79_MK82AIR 4}",
        name: "MAK79 4 Mk-82AIR",
        weight: 1004
    },
    MAK79_4_Mk_82_SnakeEye: {
        clsid: "{MAK79_MK82SE 4}",
        name: "MAK79 4 Mk-82 SnakeEye",
        weight: 1004
    },
    MAK79_MK_20: {
        clsid: "{MAK79_MK20 1R}",
        name: "MAK79 MK-20",
        weight: 232
    },
    MAK79_MK_20_: {
        clsid: "{MAK79_MK20 1L}",
        name: "MAK79 MK-20",
        weight: 232
    },
    MAK79_Mk_83: {
        clsid: "{MAK79_MK83 1R}",
        name: "MAK79 Mk-83",
        weight: 457
    },
    MAK79_Mk_83_: {
        clsid: "{MAK79_MK83 1L}",
        name: "MAK79 Mk-83",
        weight: 457
    },
    Matra_Magic_II: {
        clsid: "{MMagicII}",
        name: "Matra Magic II",
        weight: 85
    },
    Matra_Super_530D: {
        clsid: "{Matra_S530D}",
        name: "Matra Super 530D",
        weight: 275
    },
    Matra_Type_155_Rocket_Pod: {
        clsid: "{Matra155RocketPod}",
        name: "Matra Type 155 Rocket Pod",
        weight: 190
    },
    MBD2_67U_with_4_x_FAB_100___100kg_GP_Bombs_LD: {
        clsid: "{5A1AC2B4-CA4B-4D09-A1AF-AC52FBC4B60B}",
        name: "MBD2-67U with 4 x FAB-100 - 100kg GP Bombs LD",
        weight: 465
    },
    MBD2_67U_with_4_x_FAB_100___100kg_GP_Bombs_LD_: {
        clsid: "{29A828E2-C6BB-11d8-9897-000476191836}",
        name: "MBD2-67U with 4 x FAB-100 - 100kg GP Bombs LD",
        weight: 465
    },
    MBD3_U2T_with_2_x_FAB_1500_M_54___1500kg_GP_Bombs_LD: {
        clsid: "{7C5F0F5F-0A0B-46E8-937C-8922303E39A8}",
        name: "MBD3-U2T with 2 x FAB-1500 M-54 - 1500kg GP Bombs LD",
        weight: 3100
    },
    MBD3_U4T_with_4_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{6A367BB4-327F-4A04-8D9E-6D86BDC98E7E}",
        name: "MBD3-U4T with 4 x FAB-250 - 250kg GP Bombs LD",
        weight: 1060
    },
    MBD3_U4T_with_4_x_RBK_250___42_x_PTAB_2_5M__250kg_CBUs_Medium_HEAT_AP: {
        clsid: "{02B81892-7E24-4795-84F9-B8110C641AF0}",
        name: "MBD3-U4T with 4 x RBK-250 - 42 x PTAB-2.5M, 250kg CBUs Medium HEAT/AP",
        weight: 1060
    },
    MBD3_U6_68_with_2_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{E659C4BE-2CD8-4472-8C08-3F28ACB61A8A}",
        name: "MBD3-U6-68 with 2 x FAB-250 - 250kg GP Bombs LD",
        weight: 550
    },
    MBD3_U6_68_with_3_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{MBD3_U6_3*FAB-250_fwd}",
        name: "MBD3-U6-68 with 3 x FAB-250 - 250kg GP Bombs LD",
        weight: 810
    },
    MBD3_U6_68_with_4_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{3E35F8C1-052D-11d6-9191-00A0249B6F00}",
        name: "MBD3-U6-68 with 4 x FAB-250 - 250kg GP Bombs LD",
        weight: 1060
    },
    MBD3_U6_68_with_4_x_FAB_250___250kg_GP_Bombs_LD_: {
        clsid: "{MBD3_U6_4*FAB-250_fwd}",
        name: "MBD3-U6-68 with 4 x FAB-250 - 250kg GP Bombs LD",
        weight: 1060
    },
    MBD3_U6_68_with_5_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{MBD3_U6_5*FAB-250}",
        name: "MBD3-U6-68 with 5 x FAB-250 - 250kg GP Bombs LD",
        weight: 1310
    },
    MBD3_U6_68_with_6_x_BetAB_500ShP___500kg_Concrete_Piercing_HD_w_booster_Bombs: {
        clsid: "{E96E1EDD-FF3F-47CF-A959-576C3B682955}",
        name: "MBD3-U6-68 with 6 x BetAB-500ShP - 500kg Concrete Piercing HD w booster Bombs",
        weight: 3060
    },
    MBD3_U6_68_with_6_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD: {
        clsid: "{436C6FB9-8BF2-46B6-9DC4-F55ABF3CD1EC}",
        name: "MBD3-U6-68 with 6 x BetAB-500 - 500kg Concrete Piercing Bombs LD",
        weight: 3060
    },
    MBD3_U6_68_with_6_x_FAB_100___100kg_GP_Bombs_LD: {
        clsid: "{F99BEC1A-869D-4AC7-9730-FBA0E3B1F5FC}",
        name: "MBD3-U6-68 with 6 x FAB-100 - 100kg GP Bombs LD",
        weight: 660
    },
    MBD3_U6_68_with_6_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{53BE25A4-C86C-4571-9BC0-47D668349595}",
        name: "MBD3-U6-68 with 6 x FAB-250 - 250kg GP Bombs LD",
        weight: 1560
    },
    MBD3_U6_68_with_6_x_FAB_500_M_62___500kg_GP_Bombs_LD: {
        clsid: "{FA673F4C-D9E4-4993-AA7A-019A92F3C005}",
        name: "MBD3-U6-68 with 6 x FAB-500 M-62 - 500kg GP Bombs LD",
        weight: 3060
    },
    MBD3_U6_68_with_6_x_FAB_500_M_62___500kg_GP_Bombs_LD_: {
        clsid: "{0D945D78-542C-4E9B-9A17-9B5008CC8D39}",
        name: "MBD3-U6-68 with 6 x FAB-500 M-62 - 500kg GP Bombs LD",
        weight: 3060
    },
    MBD3_U6_68_with_6_x_RBK_500_255___30_x_PTAB_10_5__500kg_CBUs_Heavy_HEAT_AP: {
        clsid: "{F503C276-FE15-4C54-B310-17B50B735A84}",
        name: "MBD3-U6-68 with 6 x RBK-500-255 - 30 x PTAB-10-5, 500kg CBUs Heavy HEAT/AP",
        weight: 3060
    },
    MBD3_U6_68_with_6_x_RBK_500_255___30_x_PTAB_10_5__500kg_CBUs_Heavy_HEAT_AP_: {
        clsid: "{4D459A95-59C0-462F-8A57-34E80697F38B}",
        name: "MBD3-U6-68 with 6 x RBK-500-255 - 30 x PTAB-10-5, 500kg CBUs Heavy HEAT/AP",
        weight: 3060
    },
    MBD3_U9M_with_9_x_FAB_100___100kg_GP_Bombs_LD: {
        clsid: "{5F1C54C0-0ABD-4868-A883-B52FF9FCB422}",
        name: "MBD3-U9M with 9 x FAB-100 - 100kg GP Bombs LD",
        weight: 960
    },
    MBD3_U9M_with_9_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{E1AAE713-5FC3-4CAA-9FF5-3FDCFB899E33}",
        name: "MBD3-U9M with 9 x FAB-250 - 250kg GP Bombs LD",
        weight: 2310
    },
    MBD3_U9M_with_9_x_RBK_250___42_x_PTAB_2_5M__250kg_CBUs_Medium_HEAT_AP: {
        clsid: "{BF83E8FD-E7A2-40D2-9608-42E13AFE2193}",
        name: "MBD3-U9M with 9 x RBK-250 - 42 x PTAB-2.5M, 250kg CBUs Medium HEAT/AP",
        weight: 2535
    },
    MBD3_with_3_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD: {
        clsid: "{005E70F5-C3EA-4E95-A148-C1044C42D845}",
        name: "MBD3 with 3 x BetAB-500 - 500kg Concrete Piercing Bombs LD",
        weight: 1566
    },
    MBD3_with_3_x_FAB_100___100kg_GP_Bombs_LD: {
        clsid: "{CEE04106-B9AA-46B4-9CD1-CD3FDCF0CE78}",
        name: "MBD3 with 3 x FAB-100 - 100kg GP Bombs LD",
        weight: 360
    },
    MBD3_with_3_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{D109EE9C-A1B7-4F1C-8D87-631C293A1D26}",
        name: "MBD3 with 3 x FAB-250 - 250kg GP Bombs LD",
        weight: 810
    },
    MBD3_with_3_x_FAB_500_M_62___500kg_GP_Bombs_LD: {
        clsid: "{A1E85991-B58E-4E92-AE91-DED6DC85B2E7}",
        name: "MBD3 with 3 x FAB-500 M-62 - 500kg GP Bombs LD",
        weight: 1560
    },
    MBD3_with_3_x_RBK_250___42_x_PTAB_2_5M__250kg_CBUs_Medium_HEAT_AP: {
        clsid: "{EAD9B2C1-F3BA-4A7B-A2A5-84E2AF8A1975}",
        name: "MBD3 with 3 x RBK-250 - 42 x PTAB 2.5M, 250kg CBUs Medium HEAT/AP",
        weight: 885
    },
    MBD3_with_3_x_RBK_500_255___30_x_PTAB_10_5__500kg_CBUs_Heavy_HEAT_AP: {
        clsid: "{919CE839-9390-4629-BAF7-229DE19B8523}",
        name: "MBD3 with 3 x RBK-500-255 - 30 x PTAB-10-5, 500kg CBUs Heavy HEAT/AP",
        weight: 1560
    },
    MER12_with_12_x_M117___750lb_GP_Bombs_LD: {
        clsid: "{574EDEDF-20DE-4942-B2A2-B2EDFD621562}",
        name: "MER12 with 12 x M117 - 750lb GP Bombs LD",
        weight: 4250
    },
    MER12_with_12_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{585D626E-7F42-4073-AB70-41E728C333E2}",
        name: "MER12 with 12 x Mk-82 - 500lb GP Bombs LD",
        weight: 3000
    },
    MER2_with_2_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets: {
        clsid: "{0B9ABA77-93B8-45FC-9C63-82AFB2CB50A4}",
        name: "MER2 with 2 x Mk-20 Rockeye - 490lbs CBUs, 247 x HEAT Bomblets",
        weight: 200
    },
    MER2_with_2_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{D5D51E24-348C-4702-96AF-97A714E72697}",
        name: "MER2 with 2 x Mk-82 - 500lb GP Bombs LD",
        weight: 200
    },
    MER2_with_2_x_Mk_83___1000lb_GP_Bombs_LD: {
        clsid: "{18617C93-78E7-4359-A8CE-D754103EDF63}",
        name: "MER2 with 2 x Mk-83 - 1000lb GP Bombs LD",
        weight: 200
    },
    MER3_with_3_x_M117___750lb_GP_Bombs_LD: {
        clsid: "{82F90BEC-0E2E-4CE5-A66E-1E4ADA2B5D1E}",
        name: "MER3 with 3 x M117 - 750lb GP Bombs LD",
        weight: 1060
    },
    MER6_with_6_x_BLU_107___440lb_Anti_Runway_Penetrator_Bombs: {
        clsid: "{752B9782-F962-11d5-9190-00A0249B6F00}",
        name: "MER6 with 6 x BLU-107 - 440lb Anti-Runway Penetrator Bombs",
        weight: 1800
    },
    MER6_with_6_x_M117___750lb_GP_Bombs_LD: {
        clsid: "{6CDB6B36-7165-47D0-889F-6625FB333561}",
        name: "MER6 with 6 x M117 - 750lb GP Bombs LD",
        weight: 2100
    },
    MER6_with_6_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets: {
        clsid: "{3C7CD675-7D39-41C5-8735-0F4F537818A8}",
        name: "MER6 with 6 x Mk-20 Rockeye - 490lbs CBUs, 247 x HEAT Bomblets",
        weight: 1392
    },
    MER6_with_6_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{1C97B4A0-AA3B-43A8-8EE7-D11071457185}",
        name: "MER6 with 6 x Mk-82 - 500lb GP Bombs LD",
        weight: 1506
    },
    Mercury_LLTV_Pod: {
        clsid: "{B1EF6B0E-3D91-4047-A7A5-A99E7D8B4A8B}",
        name: "Mercury LLTV Pod",
        weight: 230
    },
    MICA_IR: {
        clsid: "{0DA03783-61E4-40B2-8FAE-6AEE0A5C5AAE}",
        name: "MICA IR",
        weight: 110
    },
    MICA_RF: {
        clsid: "{6D778860-7BB8-4ACB-9E95-BA772C6BBC2C}",
        name: "MICA RF",
        weight: 110
    },
    MIM_104: {
        clsid: "MIM_104",
        name: "M901 PATRIOT",
        weight: $e56653165fb50b77$var$None
    },
    MIM_72: {
        clsid: "MIM_72",
        name: "M48 CHAPARRAL",
        weight: $e56653165fb50b77$var$None
    },
    Mistral: {
        clsid: "{MBDA_MistralG}",
        name: "Mistral",
        weight: 27.2
    },
    Mistral_: {
        clsid: "{MBDA_MistralD}",
        name: "Mistral",
        weight: 27.2
    },
    MK_82_28: {
        clsid: "MK_82*28",
        name: "28 x Mk-82 - 500lb GP Bombs LD",
        weight: 6748
    },
    Mk_20: {
        clsid: "{BRU-32 MK-20}",
        name: "Mk-20",
        weight: 279.38
    },
    Mk_20_18: {
        clsid: "{ACADB374-6D6C-45A0-BA7C-B22B2E108AE4}",
        name: "Mk 20*18",
        weight: 3996
    },
    Mk_20_Rockeye___490lbs_CBU__247_x_HEAT_Bomblets: {
        clsid: "{ADD3FAE1-EBF6-4EF9-8EFC-B36B5DDF1E6B}",
        name: "Mk-20 Rockeye - 490lbs CBU, 247 x HEAT Bomblets",
        weight: 222
    },
    Mk_81___250lb_GP_Bomb_LD: {
        clsid: "{90321C8E-7ED1-47D4-A160-E074D5ABD902}",
        name: "Mk-81 - 250lb GP Bomb LD",
        weight: 118
    },
    Mk_82: {
        clsid: "{BRU-32 MK-82}",
        name: "Mk-82",
        weight: 298.38
    },
    Mk_82AIR: {
        clsid: "{BRU-32 MK-82AIR}",
        name: "Mk-82AIR",
        weight: 298.38
    },
    Mk_82B: {
        clsid: "{Mk_82B}",
        name: "Mk-82B",
        weight: 228
    },
    Mk_82BT: {
        clsid: "{Mk_82BT}",
        name: "Mk-82BT",
        weight: 228
    },
    Mk_82P: {
        clsid: "{Mk_82P}",
        name: "Mk-82P",
        weight: 228
    },
    Mk_82PT: {
        clsid: "{Mk_82PT}",
        name: "Mk-82PT",
        weight: 228
    },
    Mk_82SB: {
        clsid: "{Mk_82SB}",
        name: "Mk-82SB",
        weight: 228
    },
    Mk_82SP: {
        clsid: "{Mk_82SP}",
        name: "Mk-82SP",
        weight: 228
    },
    Mk_82YT: {
        clsid: "{Mk_82YT}",
        name: "Mk-82YT",
        weight: 228
    },
    Mk_82Y___500lb_GP_Chute_Retarded_HD: {
        clsid: "{Mk_82Y}",
        name: "Mk-82Y - 500lb GP Chute Retarded HD",
        weight: 232
    },
    Mk_82_AIR_Ballute___500lb_GP_Bomb_HD: {
        clsid: "{Mk82AIR}",
        name: "Mk-82 AIR Ballute - 500lb GP Bomb HD",
        weight: 242
    },
    Mk_82_SnakeEye: {
        clsid: "{BRU-32 MK-82SE}",
        name: "Mk-82 SnakeEye",
        weight: 298.38
    },
    Mk_82_Snakeye___500lb_GP_Bomb_HD: {
        clsid: "{Mk82SNAKEYE}",
        name: "Mk-82 Snakeye - 500lb GP Bomb HD",
        weight: 249.5
    },
    Mk_82___500lb_GP_Bomb_LD: {
        clsid: "{BCE4E030-38E9-423E-98ED-24BE3DA87C32}",
        name: "Mk-82 - 500lb GP Bomb LD",
        weight: 228
    },
    Mk_83: {
        clsid: "{BRU-32 MK-83}",
        name: "Mk-83",
        weight: 504.38
    },
    Mk_83BT: {
        clsid: "{Mk_83BT}",
        name: "Mk-83BT",
        weight: 454
    },
    Mk_83CT: {
        clsid: "{Mk_83CT}",
        name: "Mk-83CT",
        weight: 454
    },
    Mk_83P: {
        clsid: "{Mk_83P}",
        name: "Mk-83P",
        weight: 454
    },
    Mk_83PT: {
        clsid: "{Mk_83PT}",
        name: "Mk-83PT",
        weight: 454
    },
    Mk_83_: {
        clsid: "{BRU42_MK83 RS}",
        name: "Mk-83",
        weight: 575
    },
    Mk_83__: {
        clsid: "{BRU3242_MK83 RS}",
        name: "Mk-83",
        weight: 632.38
    },
    Mk_83___: {
        clsid: "{PHXBRU3242_MK83 RS}",
        name: "Mk-83",
        weight: 632.38
    },
    Mk_83___1000lb_GP_Bomb_LD: {
        clsid: "{7A44FF09-527C-4B7E-B42B-3F111CFE50FB}",
        name: "Mk-83 - 1000lb GP Bomb LD",
        weight: 454
    },
    Mk_83____: {
        clsid: "{BRU42_MK83 LS}",
        name: "Mk-83",
        weight: 575
    },
    Mk_83_____: {
        clsid: "{BRU3242_MK83 LS}",
        name: "Mk-83",
        weight: 632.38
    },
    Mk_83______: {
        clsid: "{PHXBRU3242_MK83 LS}",
        name: "Mk-83",
        weight: 632.38
    },
    Mk_84: {
        clsid: "{BRU-32 MK-84}",
        name: "Mk-84",
        weight: 951.38
    },
    Mk_84P: {
        clsid: "{Mk_84P}",
        name: "Mk-84P",
        weight: 908
    },
    Mk_84T: {
        clsid: "{Mk_84T}",
        name: "Mk-84T",
        weight: 908
    },
    Mk_84_18: {
        clsid: "{F092B80C-BB54-477E-9408-66DEEF740008}",
        name: "Mk 84*18",
        weight: 16092
    },
    Mk_84_28: {
        clsid: "{D3ABF208-FA56-4D56-BB31-E0D931D57AE3}",
        name: "Mk 84*28",
        weight: 25032
    },
    Mk_84___2000lb_GP_Bomb_LD: {
        clsid: "{AB8B8299-F1CC-4359-89B5-2172E0CF4A5A}",
        name: "Mk-84 - 2000lb GP Bomb LD",
        weight: 894
    },
    MPS_410: {
        clsid: "{44EE8698-89F9-48EE-AF36-5FD31896A82D}",
        name: "MPS-410",
        weight: 150
    },
    MPS_410_: {
        clsid: "{44EE8698-89F9-48EE-AF36-5FD31896A82C}",
        name: "MPS-410",
        weight: 150
    },
    MXU_648_TP: {
        clsid: "MXU-648-TP",
        name: "MXU-648 Travel Pod",
        weight: 300
    },
    ODAB_500PM: {
        clsid: "{ODAB-500PM}",
        name: "ODAB-500PM",
        weight: 520
    },
    OFAB_100_120_TU_x_4: {
        clsid: "{OFAB-100-120-TU}",
        name: "OFAB-100-120-TU x 4",
        weight: 557
    },
    OFAB_100_Jupiter___100kg_GP_Bomb_LD: {
        clsid: "{OFAB_100_Jupiter}",
        name: "OFAB-100 Jupiter - 100kg GP Bomb LD",
        weight: 121
    },
    ORO_57K___S_5M1_HE_FRAG_FFAR_x_8: {
        clsid: "{ORO57K_S5M1_HEFRAG}",
        name: "ORO-57K - S-5M1 HE-FRAG FFAR x 8",
        weight: 63.88
    },
    ORO_57K___S_5MO_HE_FRAG_FFAR_x_8: {
        clsid: "{ORO57K_S5MO_HEFRAG}",
        name: "ORO-57K - S-5MO HE-FRAG FFAR x 8",
        weight: 63.88
    },
    ORO_57K___S_5M_x_8: {
        clsid: "{ORO57K_S5M_HEFRAG}",
        name: "ORO-57K - S-5M x 8",
        weight: 64.92
    },
    oh_58_brauning: {
        clsid: "oh-58-brauning",
        name: "OH-58D Brauning",
        weight: 290
    },
    Pavetack_F_111: {
        clsid: "{199D6D51-1764-497E-9AE5-7D07C8D4D87E}",
        name: "Pavetack F-111",
        weight: 200
    },
    PKT_7_62: {
        clsid: "PKT_7_62",
        name: "PKT 7.62mm MMG",
        weight: 90
    },
    PK_3___7_62mm_GPMG: {
        clsid: "{PK-3}",
        name: "PK-3 - 7.62mm GPMG",
        weight: 218
    },
    PTB300_MIG15: {
        clsid: "PTB300_MIG15",
        name: "Fuel Tank 300 liters",
        weight: 271
    },
    PTB400_MIG15: {
        clsid: "PTB400_MIG15",
        name: "Fuel Tank 400 liters",
        weight: 364
    },
    PTB400_MIG19: {
        clsid: "PTB400_MIG19",
        name: "Fuel Tank 400 liters",
        weight: 364
    },
    PTB600_MIG15: {
        clsid: "PTB600_MIG15",
        name: "Fuel Tank 600 liters",
        weight: 531
    },
    PTB760_MIG19: {
        clsid: "PTB760_MIG19",
        name: "Fuel Tank 760 liters",
        weight: 663.8
    },
    P_50T___50kg_Practice_Bomb_LD: {
        clsid: "{P-50T}",
        name: "P-50T - 50kg Practice Bomb LD",
        weight: 50
    },
    RBK_250_275___150_x_AO_1SCh__250kg_CBU_HE_Frag: {
        clsid: "{RBK_250_275_AO_1SCH}",
        name: "RBK-250-275 - 150 x AO-1SCh, 250kg CBU HE/Frag",
        weight: 244.6
    },
    RBK_250___42_x_PTAB_2_5M__250kg_CBU_Medium_HEAT_AP: {
        clsid: "{4203753F-8198-4E85-9924-6F8FF679F9FF}",
        name: "RBK-250 - 42 x PTAB-2.5M, 250kg CBU Medium HEAT/AP",
        weight: 273
    },
    RBK_500U___126_x_OAB_2_5RT__500kg_CBU_HE_Frag: {
        clsid: "{RBK_500U_OAB_2_5RT}",
        name: "RBK-500U - 126 x OAB-2.5RT, 500kg CBU HE/Frag",
        weight: 427
    },
    RBK_500_255___30_x_PTAB_10_5__500kg_CBU_Heavy_HEAT_AP: {
        clsid: "{D5435F26-F120-4FA3-9867-34ACE562EF1B}",
        name: "RBK-500-255 - 30 x PTAB-10-5, 500kg CBU Heavy HEAT/AP",
        weight: 427
    },
    RBK_500___268_x_PTAB_1M__500kg_CBU_Light_HEAT_AP: {
        clsid: "{7AEC222D-C523-425e-B714-719C0D1EB14D}",
        name: "RBK-500 - 268 x PTAB-1M, 500kg CBU Light HEAT/AP",
        weight: 427
    },
    RB_04E__for_A_I___with_launcher: {
        clsid: "{Rb04AI}",
        name: "RB-04E (for A.I.) with launcher",
        weight: 661
    },
    RB_15F__for_A_I___with_launcher: {
        clsid: "{Rb15AI}",
        name: "RB-15F (for A.I.) with launcher",
        weight: 610
    },
    Rb_04E_Anti_ship_Missile: {
        clsid: "{Rb04}",
        name: "Rb-04E Anti-ship Missile",
        weight: 661
    },
    Rb_05A_MCLOS_ASM_AShM_AAM: {
        clsid: "{Robot05}",
        name: "Rb-05A MCLOS ASM/AShM/AAM",
        weight: 341
    },
    Rb_15F_Programmable_Anti_ship_Missile: {
        clsid: "{Rb15}",
        name: "Rb-15F Programmable Anti-ship Missile",
        weight: 610
    },
    Rb_24J__AIM_9P__Sidewinder_IR_AAM: {
        clsid: "{Robot24J}",
        name: "Rb-24J (AIM-9P) Sidewinder IR AAM",
        weight: 90
    },
    Rb_24__AIM_9B__Sidewinder_IR_AAM: {
        clsid: "{Robot24}",
        name: "Rb-24 (AIM-9B) Sidewinder IR AAM",
        weight: 90
    },
    Rb_74__AIM_9L__Sidewinder_IR_AAM: {
        clsid: "{Robot74}",
        name: "Rb-74 (AIM-9L) Sidewinder IR AAM",
        weight: 90
    },
    Rb_75A__AGM_65A_Maverick___TV_ASM_: {
        clsid: "{RB75}",
        name: "Rb-75A (AGM-65A Maverick) (TV ASM)",
        weight: 210
    },
    Rb_75B__AGM_65B_Maverick___TV_ASM_: {
        clsid: "{RB75B}",
        name: "Rb-75B (AGM-65B Maverick) (TV ASM)",
        weight: 210
    },
    Rb_75T__AGM_65A_Maverick___TV_ASM_Lg_Whd_: {
        clsid: "{RB75T}",
        name: "Rb-75T (AGM-65A Maverick) (TV ASM Lg Whd)",
        weight: 210
    },
    REFLEX_9M119: {
        clsid: "REFLEX_9M119",
        name: "AT-11 SNIPER (Reflex)",
        weight: $e56653165fb50b77$var$None
    },
    RKL609_ECM_Pod__Left_: {
        clsid: "{RKL609_L}",
        name: "RKL609 ECM Pod (Left)",
        weight: 150
    },
    RKL609_ECM_Pod__Right_: {
        clsid: "{RKL609_R}",
        name: "RKL609 ECM Pod (Right)",
        weight: 150
    },
    RN_24: {
        clsid: "{RN-24}",
        name: "RN-24",
        weight: 470
    },
    RN_28: {
        clsid: "{RN-28}",
        name: "RN-28",
        weight: 260
    },
    ROLAND: {
        clsid: "ROLAND",
        name: "ROLAND",
        weight: $e56653165fb50b77$var$None
    },
    RPL_522_1300_liters_Fuel_Tank: {
        clsid: "{M2KC_RPL_522}",
        name: "RPL 522 1300 liters Fuel Tank",
        weight: 1170
    },
    RPL_522_1300_liters_Fuel_Tank__Empty_: {
        clsid: "{M2KC_RPL_522_EMPTY}",
        name: "RPL 522 1300 liters Fuel Tank (Empty)",
        weight: 180
    },
    RPL_541_2000_liters_Fuel_Tank_: {
        clsid: "{M2KC_02_RPL541}",
        name: "RPL 541 2000 liters Fuel Tank ",
        weight: 1837
    },
    RPL_541_2000_liters_Fuel_Tank__: {
        clsid: "{M2KC_08_RPL541}",
        name: "RPL 541 2000 liters Fuel Tank ",
        weight: 1837
    },
    RPL_541_2000_liters_Fuel_Tank__Empty_: {
        clsid: "{M2KC_02_RPL541_EMPTY}",
        name: "RPL 541 2000 liters Fuel Tank (Empty)",
        weight: 257
    },
    RPL_541_2000_liters_Fuel_Tank__Empty__: {
        clsid: "{M2KC_08_RPL541_EMPTY}",
        name: "RPL 541 2000 liters Fuel Tank (Empty)",
        weight: 257
    },
    RS2US: {
        clsid: "{RS-2US}",
        name: "RS2US",
        weight: 105.2
    },
    R_13M: {
        clsid: "{R-13M}",
        name: "R-13M",
        weight: 119.7
    },
    R_13M1: {
        clsid: "{R-13M1}",
        name: "R-13M1",
        weight: 122.4
    },
    R_24R__AA_7_Apex_SA____Semi_Act_Rdr: {
        clsid: "{CCF898C9-5BC7-49A4-9D1E-C3ED3D5166A1}",
        name: "R-24R (AA-7 Apex SA) - Semi-Act Rdr",
        weight: 215
    },
    R_24T__AA_7_Apex_IR____Infra_Red: {
        clsid: "{6980735A-44CC-4BB9-A1B5-591532F1DC69}",
        name: "R-24T (AA-7 Apex IR) - Infra Red",
        weight: 215
    },
    R_27ER__AA_10_Alamo_C____Semi_Act_Extended_Range: {
        clsid: "{E8069896-8435-4B90-95C0-01A03AE6E400}",
        name: "R-27ER (AA-10 Alamo C) - Semi-Act Extended Range",
        weight: 350
    },
    R_27ET__AA_10_Alamo_D____IR_Extended_Range: {
        clsid: "{B79C379A-9E87-4E50-A1EE-7F7E29C2E87A}",
        name: "R-27ET (AA-10 Alamo D) - IR Extended Range",
        weight: 343
    },
    R_27R__AA_10_Alamo_A____Semi_Act_Rdr: {
        clsid: "{9B25D316-0434-4954-868F-D51DB1A38DF0}",
        name: "R-27R (AA-10 Alamo A) - Semi-Act Rdr",
        weight: 253
    },
    R_27T__AA_10_Alamo_B____Infra_Red: {
        clsid: "{88DAC840-9F75-4531-8689-B46E64E42E53}",
        name: "R-27T (AA-10 Alamo B) - Infra Red",
        weight: 254
    },
    R_33__AA_9_Amos____Semi_Act_Rdr: {
        clsid: "{F1243568-8EF0-49D4-9CB5-4DA90D92BC1D}",
        name: "R-33 (AA-9 Amos) - Semi-Act Rdr",
        weight: 490
    },
    R_3R: {
        clsid: "{R-3R}",
        name: "R-3R",
        weight: 111.5
    },
    R_3S: {
        clsid: "{R-3S}",
        name: "R-3S",
        weight: 103.3
    },
    R_40R__AA_6_Acrid____Semi_Act_Rdr: {
        clsid: "{4EDBA993-2E34-444C-95FB-549300BF7CAF}",
        name: "R-40R (AA-6 Acrid) - Semi-Act Rdr",
        weight: 475
    },
    R_40T__AA_6_Acrid____Infra_Red: {
        clsid: "{5F26DBC2-FB43-4153-92DE-6BBCE26CB0FF}",
        name: "R-40T (AA-6 Acrid) - Infra Red",
        weight: 475
    },
    R_55: {
        clsid: "{R-55}",
        name: "R-55",
        weight: 113
    },
    R_550_Magic_2: {
        clsid: "{FC23864E-3B80-48E3-9C03-4DA8B1D7497B}",
        name: "R.550 Magic 2",
        weight: 89
    },
    R_60: {
        clsid: "{R-60}",
        name: "R-60",
        weight: 58.5
    },
    R_60M: {
        clsid: "{R-60M}",
        name: "R-60M",
        weight: 58.5
    },
    R_60M_x_2: {
        clsid: "{R-60M 2L}",
        name: "R-60M x 2",
        weight: 122
    },
    R_60M_x_2_: {
        clsid: "{R-60M 2R}",
        name: "R-60M x 2",
        weight: 122
    },
    R_60M__AA_8_Aphid____Infra_Red: {
        clsid: "{682A481F-0CB5-4693-A382-D00DD4A156D7}",
        name: "R-60M (AA-8 Aphid) - Infra Red",
        weight: 44
    },
    R_60_x_2: {
        clsid: "{R-60 2L}",
        name: "R-60 x 2",
        weight: 122
    },
    R_60_x_2_: {
        clsid: "{R-60 2R}",
        name: "R-60 x 2",
        weight: 122
    },
    R_73__AA_11_Archer____Infra_Red: {
        clsid: "{FBC29BFE-3D24-4C64-B81D-941239D12249}",
        name: "R-73 (AA-11 Archer) - Infra Red",
        weight: 110
    },
    R_73__AA_11_Archer____Infra_Red_: {
        clsid: "{CBC29BFE-3D24-4C64-B81D-941239D12249}",
        name: "R-73 (AA-11 Archer) - Infra Red",
        weight: 110
    },
    R_77__AA_12_Adder____Active_Rdr: {
        clsid: "{B4C01D60-A8A3-4237-BD72-CA7655BC0FE9}",
        name: "R-77 (AA-12 Adder) - Active Rdr",
        weight: 175
    },
    R_77__AA_12_Adder____Active_Rdr_: {
        clsid: "{B4C01D60-A8A3-4237-BD72-CA7655BC0FEC}",
        name: "R-77 (AA-12 Adder) - Active Rdr",
        weight: 250
    },
    SAB_100___100kg_flare_illumination_Bomb: {
        clsid: "{0511E528-EA28-4caf-A212-00D1408DF10A}",
        name: "SAB-100 - 100kg flare/illumination Bomb",
        weight: 100
    },
    Sand_Filter: {
        clsid: "{FAS}",
        name: "Sand Filter",
        weight: 15
    },
    SC_250_Type_1_L2___250kg_GP_Bomb_LD: {
        clsid: "{SC_250_T1_L2}",
        name: "SC 250 Type 1 L2 - 250kg GP Bomb LD",
        weight: 250
    },
    SC_250_Type_3_J___250kg_GP_Bomb_LD: {
        clsid: "{Schloss500XIIC1_SC_250_T3_J}",
        name: "SC 250 Type 3 J - 250kg GP Bomb LD",
        weight: 270
    },
    SC_500_L2___500kg_GP_Bomb_LD: {
        clsid: "{SC_500_L2}",
        name: "SC 500 L2 - 500kg GP Bomb LD",
        weight: 500
    },
    SC_501_SC250: {
        clsid: "SC_501_SC250",
        name: "SC 250 Type 3 J - 250kg GP Bomb LD",
        weight: 250
    },
    SC_501_SC500: {
        clsid: "SC_501_SC500",
        name: "SC 500 J - 500kg GP Bomb LD",
        weight: 500
    },
    SC_50___50kg_GP_Bomb_LD: {
        clsid: "{SC_50}",
        name: "SC 50 - 50kg GP Bomb LD",
        weight: 50
    },
    SD_250_Stg___250kg_GP_Bomb_LD: {
        clsid: "{SD_250_Stg}",
        name: "SD 250 Stg - 250kg GP Bomb LD",
        weight: 250
    },
    SD_500_A___500kg_GP_Bomb_LD: {
        clsid: "{SD_500_A}",
        name: "SD 500 A - 500kg GP Bomb LD",
        weight: 500
    },
    SEASPARROW: {
        clsid: "SEASPARROW",
        name: "SEASPARROW",
        weight: $e56653165fb50b77$var$None
    },
    Sea_Eagle___ASM: {
        clsid: "{1461CD18-429A-42A9-A21F-4C621ECD4573}",
        name: "Sea Eagle - ASM",
        weight: 600
    },
    Shpil_2_Laser_Recon__Intel_Pod: {
        clsid: "{0519A263-0AB6-11d6-9193-00A0249B6F00}",
        name: "Shpil-2 Laser Recon & Intel Pod",
        weight: 200
    },
    Sky_Shadow_ECM_Pod: {
        clsid: "{8C3F26A2-FA0F-11d5-9190-00A0249B6F00}",
        name: "Sky-Shadow ECM Pod",
        weight: 200
    },
    SM2: {
        clsid: "SM2",
        name: "SM2",
        weight: $e56653165fb50b77$var$None
    },
    Smokewinder___blue: {
        clsid: "{A4BCC903-06C8-47bb-9937-A30FEDB4E743}",
        name: "Smokewinder - blue",
        weight: 200
    },
    Smokewinder___green: {
        clsid: "{A4BCC903-06C8-47bb-9937-A30FEDB4E742}",
        name: "Smokewinder - green",
        weight: 200
    },
    Smokewinder___orange: {
        clsid: "{A4BCC903-06C8-47bb-9937-A30FEDB4E746}",
        name: "Smokewinder - orange",
        weight: 200
    },
    Smokewinder___red: {
        clsid: "{A4BCC903-06C8-47bb-9937-A30FEDB4E741}",
        name: "Smokewinder - red",
        weight: 200
    },
    Smokewinder___white: {
        clsid: "{A4BCC903-06C8-47bb-9937-A30FEDB4E744}",
        name: "Smokewinder - white",
        weight: 200
    },
    Smokewinder___yellow: {
        clsid: "{A4BCC903-06C8-47bb-9937-A30FEDB4E745}",
        name: "Smokewinder - yellow",
        weight: 200
    },
    Smoke_for_Christen_Eagle_II__white: {
        clsid: "{CE2_SMOKE_WHITE}",
        name: "Smoke for Christen Eagle II, white",
        weight: 7
    },
    Smoke_Generator___blue: {
        clsid: "{D3F65166-1AB8-490f-AF2F-2FB6E22568B3}",
        name: "Smoke Generator - blue",
        weight: 220
    },
    Smoke_Generator___blue_: {
        clsid: "{INV-SMOKE-BLUE}",
        name: "Smoke Generator - blue",
        weight: 0
    },
    Smoke_Generator___green: {
        clsid: "{D3F65166-1AB8-490f-AF2F-2FB6E22568B2}",
        name: "Smoke Generator - green",
        weight: 220
    },
    Smoke_Generator___green_: {
        clsid: "{INV-SMOKE-GREEN}",
        name: "Smoke Generator - green",
        weight: 0
    },
    Smoke_Generator___orange: {
        clsid: "{D3F65166-1AB8-490f-AF2F-2FB6E22568B6}",
        name: "Smoke Generator - orange",
        weight: 220
    },
    Smoke_Generator___orange_: {
        clsid: "{INV-SMOKE-ORANGE}",
        name: "Smoke Generator - orange",
        weight: 0
    },
    Smoke_Generator___red: {
        clsid: "{D3F65166-1AB8-490f-AF2F-2FB6E22568B1}",
        name: "Smoke Generator - red",
        weight: 220
    },
    Smoke_Generator___red_: {
        clsid: "{INV-SMOKE-RED}",
        name: "Smoke Generator - red",
        weight: 0
    },
    Smoke_Generator___white: {
        clsid: "{D3F65166-1AB8-490f-AF2F-2FB6E22568B4}",
        name: "Smoke Generator - white",
        weight: 220
    },
    Smoke_Generator___white_: {
        clsid: "{INV-SMOKE-WHITE}",
        name: "Smoke Generator - white",
        weight: 0
    },
    Smoke_Generator___yellow: {
        clsid: "{D3F65166-1AB8-490f-AF2F-2FB6E22568B5}",
        name: "Smoke Generator - yellow",
        weight: 220
    },
    Smoke_Generator___yellow_: {
        clsid: "{INV-SMOKE-YELLOW}",
        name: "Smoke Generator - yellow",
        weight: 0
    },
    Smoke_System_red_colorant: {
        clsid: "{SMOKE-RED-AVIOJET}",
        name: "Smoke System red colorant",
        weight: 32.6
    },
    Smoke_System_yellow_colorant: {
        clsid: "{SMOKE-YELLOW-AVIOJET}",
        name: "Smoke System yellow colorant",
        weight: 32.6
    },
    Smoke_System__White_Smoke_: {
        clsid: "{SMOKE-SYSTEM-AVIOJET}",
        name: "Smoke System (White Smoke)",
        weight: 1
    },
    Smoke___red___21__t: {
        clsid: "{MIG21_SMOKE_RED}",
        name: "Smoke - red - 21 /t",
        weight: 30
    },
    Smoke___white___21: {
        clsid: "{SMOKE_WHITE}",
        name: "Smoke - white - 21",
        weight: 30
    },
    Smoke___white___21_: {
        clsid: "{MIG21_SMOKE_WHITE}",
        name: "Smoke - white - 21",
        weight: 30
    },
    SPITFIRE_45GAL_SLIPPER_TANK: {
        clsid: "SPITFIRE_45GAL_SLIPPER_TANK",
        name: "45 gal. Slipper Tank",
        weight: 138.647
    },
    SPITFIRE_45GAL_TORPEDO_TANK: {
        clsid: "SPITFIRE_45GAL_TORPEDO_TANK",
        name: "45 gal. Torpedo Tank",
        weight: 144.647
    },
    SPPU_22_1___2_x_23mm__GSh_23L_Autocannon_Pod: {
        clsid: "{E92CBFE5-C153-11d8-9897-000476191836}",
        name: "SPPU-22-1 - 2 x 23mm  GSh-23L Autocannon Pod",
        weight: 290
    },
    SPRD_99: {
        clsid: "{SPRD}",
        name: "SPRD-99",
        weight: 500
    },
    SPS_141_100__21_: {
        clsid: "{SPS-141-100}",
        name: "SPS-141-100 (21)",
        weight: 150
    },
    SPS_141___ECM_Jamming_Pod: {
        clsid: "{F75187EF-1D9E-4DA9-84B4-1A1A14A3973A}",
        name: "SPS-141 - ECM Jamming Pod",
        weight: 150
    },
    SUU_25_x_8_LUU_2___Target_Marker_Flares: {
        clsid: "{CAE48299-A294-4bad-8EE6-89EFC5DCDF00}",
        name: "SUU-25 x 8 LUU-2 - Target Marker Flares",
        weight: 130
    },
    SUU_25___8_LUU_2: {
        clsid: "{BRU42_SUU25}",
        name: "SUU-25 * 8 LUU-2",
        weight: 258
    },
    SUU_25___8_LUU_2_: {
        clsid: "{BRU3242_SUU25}",
        name: "SUU-25 * 8 LUU-2",
        weight: 315.38
    },
    Super_530D: {
        clsid: "{FD21B13E-57F3-4C2A-9F78-C522D0B5BCE1}",
        name: "Super 530D",
        weight: 270
    },
    SVIR_9M119: {
        clsid: "SVIR_9M119",
        name: "AT-11 SNIPER (Svir')",
        weight: $e56653165fb50b77$var$None
    },
    S_24A__21_: {
        clsid: "{S-24A}",
        name: "S-24A (21)",
        weight: 235
    },
    S_24B__21_: {
        clsid: "{S-24B}",
        name: "S-24B (21)",
        weight: 235
    },
    S_24B___240mm_UnGd_Rkt__235kg__HE_Frag___Low_Smk_: {
        clsid: "{1FA14DEA-8CDB-45AD-88A8-EC068DF1E65A}",
        name: "S-24B - 240mm UnGd Rkt, 235kg, HE/Frag, (Low Smk)",
        weight: 235
    },
    S_24B___240mm_UnGd_Rkt__235kg__HE_Frag___Low_Smk__: {
        clsid: "{3858707D-F5D5-4bbb-BDD8-ABB0530EBC7C}",
        name: "S-24B - 240mm UnGd Rkt, 235kg, HE/Frag, (Low Smk)",
        weight: 295
    },
    S_25L___320Kg__340mm_Laser_Guided_Rkt: {
        clsid: "{0180F983-C14A-11d8-9897-000476191836}",
        name: "S-25L - 320Kg, 340mm Laser Guided Rkt",
        weight: 500
    },
    S_25_OFM___340mm_UnGd_Rkt__480kg_Penetrator: {
        clsid: "{A0648264-4BC0-4EE8-A543-D119F6BA4257}",
        name: "S-25-OFM - 340mm UnGd Rkt, 480kg Penetrator",
        weight: 495
    },
    Tangazh_ELINT_pod: {
        clsid: "{0519A262-0AB6-11d6-9193-00A0249B6F00}",
        name: "Tangazh ELINT pod",
        weight: 200
    },
    TER_9A_with_2_x_CBU_87___202_x_Anti_Armor_Skeet_SFW_Cluster_Bomb: {
        clsid: "{TER_9A_2L*CBU-87}",
        name: "TER-9A with 2 x CBU-87 - 202 x Anti-Armor Skeet SFW Cluster Bomb",
        weight: 913
    },
    TER_9A_with_2_x_CBU_87___202_x_Anti_Armor_Skeet_SFW_Cluster_Bomb_: {
        clsid: "{TER_9A_2R*CBU-87}",
        name: "TER-9A with 2 x CBU-87 - 202 x Anti-Armor Skeet SFW Cluster Bomb",
        weight: 913
    },
    TER_9A_with_2_x_CBU_97___10_x_Anti_Armor_Skeet_SFW_Cluster_Bomb: {
        clsid: "{TER_9A_2L*CBU-97}",
        name: "TER-9A with 2 x CBU-97 - 10 x Anti-Armor Skeet SFW Cluster Bomb",
        weight: 887
    },
    TER_9A_with_2_x_CBU_97___10_x_Anti_Armor_Skeet_SFW_Cluster_Bomb_: {
        clsid: "{TER_9A_2R*CBU-97}",
        name: "TER-9A with 2 x CBU-97 - 10 x Anti-Armor Skeet SFW Cluster Bomb",
        weight: 887
    },
    TER_9A_with_2_x_GBU_12___500lb_Laser_Guided_Bomb: {
        clsid: "{TER_9A_2L*GBU-12}",
        name: "TER-9A with 2 x GBU-12 - 500lb Laser Guided Bomb",
        weight: 607
    },
    TER_9A_with_2_x_GBU_12___500lb_Laser_Guided_Bomb_: {
        clsid: "{TER_9A_2R*GBU-12}",
        name: "TER-9A with 2 x GBU-12 - 500lb Laser Guided Bomb",
        weight: 607
    },
    TER_9A_with_2_x_Mk_82_AIR_Ballute___500lb_GP_Bomb_HD: {
        clsid: "{TER_9A_2L*MK-82AIR}",
        name: "TER-9A with 2 x Mk-82 AIR Ballute - 500lb GP Bomb HD",
        weight: 537
    },
    TER_9A_with_2_x_Mk_82_AIR_Ballute___500lb_GP_Bomb_HD_: {
        clsid: "{TER_9A_2R*MK-82AIR}",
        name: "TER-9A with 2 x Mk-82 AIR Ballute - 500lb GP Bomb HD",
        weight: 537
    },
    TER_9A_with_2_x_Mk_82_Snakeye___500lb_GP_Bomb_HD: {
        clsid: "{TER_9A_2L*MK-82_Snakeye}",
        name: "TER-9A with 2 x Mk-82 Snakeye - 500lb GP Bomb HD",
        weight: 552
    },
    TER_9A_with_2_x_Mk_82_Snakeye___500lb_GP_Bomb_HD_: {
        clsid: "{TER_9A_2R*MK-82_Snakeye}",
        name: "TER-9A with 2 x Mk-82 Snakeye - 500lb GP Bomb HD",
        weight: 552
    },
    TER_9A_with_2_x_Mk_82___500lb_GP_Bomb_LD: {
        clsid: "{TER_9A_2L*MK-82}",
        name: "TER-9A with 2 x Mk-82 - 500lb GP Bomb LD",
        weight: 509
    },
    TER_9A_with_2_x_Mk_82___500lb_GP_Bomb_LD_: {
        clsid: "{TER_9A_2R*MK-82}",
        name: "TER-9A with 2 x Mk-82 - 500lb GP Bomb LD",
        weight: 509
    },
    TER_9A_with_3_x_BDU_33___25lb_Practice_Bomb_LD: {
        clsid: "{TER_9A_3*BDU-33}",
        name: "TER-9A with 3 x BDU-33 - 25lb Practice Bomb LD",
        weight: 86.9
    },
    TER_9A_with_3_x_CBU_87___202_x_Anti_Armor_Skeet_SFW_Cluster_Bomb: {
        clsid: "{TER_9A_3*CBU-87}",
        name: "TER-9A with 3 x CBU-87 - 202 x Anti-Armor Skeet SFW Cluster Bomb",
        weight: 1343
    },
    TER_9A_with_3_x_CBU_97___10_x_Anti_Armor_Skeet_SFW_Cluster_Bomb: {
        clsid: "{TER_9A_3*CBU-97}",
        name: "TER-9A with 3 x CBU-97 - 10 x Anti-Armor Skeet SFW Cluster Bomb",
        weight: 1304
    },
    TER_9A_with_3_x_Mk_82_AIR_Ballute___500lb_GP_Bomb_HD: {
        clsid: "{TER_9A_3*MK-82AIR}",
        name: "TER-9A with 3 x Mk-82 AIR Ballute - 500lb GP Bomb HD",
        weight: 779
    },
    TER_9A_with_3_x_Mk_82_Snakeye___500lb_GP_Bomb_HD: {
        clsid: "{TER_9A_3*MK-82_Snakeye}",
        name: "TER-9A with 3 x Mk-82 Snakeye - 500lb GP Bomb HD",
        weight: 801.5
    },
    TER_9A_with_3_x_Mk_82___500lb_GP_Bomb_LD: {
        clsid: "{TER_9A_3*MK-82}",
        name: "TER-9A with 3 x Mk-82 - 500lb GP Bomb LD",
        weight: 737
    },
    TEST_ROTARY_LAUNCHER_MK82: {
        clsid: "TEST_ROTARY_LAUNCHER_MK82",
        name: "TEST ROTARY LAUNCHER MK82",
        weight: 6748
    },
    TGM_65H: {
        clsid: "TGM_65H",
        name: "TGM-65H - Trg Round for Mav H (CCD)",
        weight: 208
    },
    TORNADO_Fuel_tank: {
        clsid: "{EF124821-F9BB-4314-A153-E0E2FE1162C4}",
        name: "TORNADO Fuel tank",
        weight: 1275
    },
    TOW: {
        clsid: "TOW",
        name: "BGM-71D TOW ATGM",
        weight: $e56653165fb50b77$var$None
    },
    U22_A_Jammer: {
        clsid: "{U22A}",
        name: "U22/A Jammer",
        weight: 348
    },
    UB_16UM_pod___16_x_S_5KO__57mm_UnGd_Rkts__HEAT_Frag: {
        clsid: "{UB-16-57UMP}",
        name: "UB-16UM pod - 16 x S-5KO, 57mm UnGd Rkts, HEAT/Frag",
        weight: 138
    },
    UB_16UM___16_S_5M: {
        clsid: "{UB-16_S5M}",
        name: "UB-16UM - 16 S-5M",
        weight: 119.76
    },
    UB_32A_pod___32_x_S_5KO__57mm_UnGd_Rkts__HEAT_Frag: {
        clsid: "{637334E4-AB5A-47C0-83A6-51B7F1DF3CD5}",
        name: "UB-32A pod - 32 x S-5KO, 57mm UnGd Rkts, HEAT/Frag",
        weight: 275
    },
    UB_32M___32_S_5M: {
        clsid: "{UB-32_S5M}",
        name: "UB-32M - 32 S-5M",
        weight: 228.52
    },
    UPK_23_250: {
        clsid: "{UPK-23-250 MiG-21}",
        name: "UPK-23-250",
        weight: 218
    },
    UPK_23_250___2_x_23mm__GSh_23L_Autocannon_Pod: {
        clsid: "{05544F1A-C39C-466b-BC37-5BD1D52E57BB}",
        name: "UPK-23-250 - 2 x 23mm  GSh-23L Autocannon Pod",
        weight: 218
    },
    U_22_Jammer_pod: {
        clsid: "{U22}",
        name: "U/22 Jammer pod",
        weight: 348
    },
    Werfer_Granate_21___21_cm_UnGd_air_to_air_rocket: {
        clsid: "{WGr21}",
        name: "Werfer-Granate 21 - 21 cm UnGd air-to-air rocket",
        weight: 121
    },
    XM158_M151: {
        clsid: "XM158_M151",
        name: "XM158 pod - 7 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 112
    },
    XM158_M156: {
        clsid: "XM158_M156",
        name: "XM158 pod - 7 x 2.75 Hydra, UnGd Rkts M156, Wht Phos",
        weight: 112
    },
    XM158_M257: {
        clsid: "XM158_M257",
        name: "XM158 pod - 7 x 2.75 Hydra, UnGd Rkts M257, Para Illum",
        weight: 112
    },
    XM158_M274: {
        clsid: "XM158_M274",
        name: "XM158 pod - 7 x 2.75 Hydra, UnGd Rkts M274, Practice Smk",
        weight: 112
    },
    XM158_MK1: {
        clsid: "XM158_MK1",
        name: "XM158 pod - 7 x 2.75 Hydra, UnGd Rkts Mk1, Practice",
        weight: 112
    },
    XM158_MK5: {
        clsid: "XM158_MK5",
        name: "XM158 pod - 7 x 2.75 Hydra, UnGd Rkts Mk5, HEAT",
        weight: 112
    },
    _108_US_gal__Paper_Fuel_Tank: {
        clsid: "{US_108GAL_PAPER_FUEL_TANK}",
        name: "108 US gal. Paper Fuel Tank",
        weight: 319
    },
    _110_US_gal__Fuel_Tank: {
        clsid: "{US_110GAL_FUEL_TANK}",
        name: "110 US gal. Fuel Tank",
        weight: 349
    },
    _12_AN_M64___500lb_GP_Bomb_LD: {
        clsid: "{12xM64}",
        name: "12 AN-M64 - 500lb GP Bomb LD",
        weight: 2744
    },
    _12_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD: {
        clsid: "{D6A0441E-6794-4FEB-87F7-E68E2290DFAB}",
        name: "12 x BetAB-500 - 500kg Concrete Piercing Bombs LD",
        weight: 478
    },
    _12_x_FAB_500_M_62___500kg_GP_Bombs_LD: {
        clsid: "{E70446B7-C7E6-4B95-B685-DEA10CAD1A0E}",
        name: "12 x FAB-500 M-62 - 500kg GP Bombs LD",
        weight: 6000
    },
    _13_R4M_3_2kg_UnGd_air_to_air_rocket: {
        clsid: "{FW_190_R4M_LEFT_WING}",
        name: "13 R4M 3.2kg UnGd air-to-air rocket",
        weight: 70.05
    },
    _13_R4M_3_2kg_UnGd_air_to_air_rocket_: {
        clsid: "{FW_190_R4M_RGHT_WING}",
        name: "13 R4M 3.2kg UnGd air-to-air rocket",
        weight: 70.05
    },
    _150_US_gal__Fuel_Tank: {
        clsid: "{US_150GAL_FUEL_TANK}",
        name: "150 US gal. Fuel Tank",
        weight: 458.8
    },
    _20_x_AGM_86C_ALCM: {
        clsid: "{22906569-A97F-404B-BA4F-D96DBF94D05E}",
        name: "20 x AGM-86C ALCM",
        weight: 39000
    },
    _24_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{B0241BD2-5628-47E0-954C-A8675B7E698E}",
        name: "24 x FAB-250 - 250kg GP Bombs LD",
        weight: 6000
    },
    _250lb_Mk_IV___GP_Bomb_LD: {
        clsid: "{British_GP_250LB_Bomb_Mk4}",
        name: "250lb Mk.IV - GP Bomb LD",
        weight: 104.326
    },
    _250lb_Mk_I___GP_Bomb_LD: {
        clsid: "{British_GP_250LB_Bomb_Mk1}",
        name: "250lb Mk.I - GP Bomb LD",
        weight: 104.326
    },
    _250_lb_GP_Mk_V: {
        clsid: "{British_GP_250LB_Bomb_Mk5}",
        name: "250 lb GP Mk.V",
        weight: 104.326
    },
    _250_lb_MC_Mk_I: {
        clsid: "{British_MC_250LB_Bomb_Mk1}",
        name: "250 lb MC Mk.I",
        weight: 102
    },
    _250_lb_MC_Mk_II: {
        clsid: "{British_MC_250LB_Bomb_Mk2}",
        name: "250 lb MC Mk.II",
        weight: 102
    },
    _250_lb_S_A_P_: {
        clsid: "{British_SAP_250LB_Bomb_Mk5}",
        name: "250 lb S.A.P.",
        weight: 111.13
    },
    _27_x_M117___750lb_GP_Bombs_LD: {
        clsid: "{B58F99BA-5480-4572-8602-28B0449F5260}",
        name: "27 x M117 - 750lb GP Bombs LD",
        weight: 9180
    },
    _27_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{6C47D097-83FF-4FB2-9496-EAB36DDF0B05}",
        name: "27 x Mk-82 - 500lb GP Bombs LD",
        weight: 6507
    },
    _2xGBU_12___500lb_Laser_Guided_Bomb: {
        clsid: "{89D000B0-0360-461A-AD83-FB727E2ABA98}",
        name: "2xGBU-12 - 500lb Laser Guided Bomb",
        weight: 610.25
    },
    _2xGBU_12___500lb_Laser_Guided_Bomb_: {
        clsid: "{BRU-42_2xGBU-12_right}",
        name: "2xGBU-12 - 500lb Laser Guided Bomb",
        weight: 610.25
    },
    _2x_80kg_LYSB_71_Illumination_Bomb: {
        clsid: "{LYSBOMB}",
        name: "2x 80kg LYSB-71 Illumination Bomb",
        weight: 220
    },
    _2_GBU_12: {
        clsid: "{BRU-42_2*GBU-12_LEFT}",
        name: "2 GBU-12",
        weight: 547
    },
    _2_GBU_12_: {
        clsid: "{BRU-42_2*GBU-12_RIGHT}",
        name: "2 GBU-12",
        weight: 547
    },
    _2_GBU_16: {
        clsid: "{BRU-42_2*GBU-16_LEFT}",
        name: "2 GBU-16",
        weight: 1005
    },
    _2_GBU_16_: {
        clsid: "{BRU-42_2*GBU-16_RIGHT}",
        name: "2 GBU-16",
        weight: 1005
    },
    _2_GBU_38: {
        clsid: "{BRU-42_2*GBU-38_LEFT}",
        name: "2 GBU-38",
        weight: 579
    },
    _2_GBU_38_: {
        clsid: "{BRU-42_2*GBU-38_RIGHT}",
        name: "2 GBU-38",
        weight: 579
    },
    _2_GBU_54_V_1_B: {
        clsid: "{BRU-70A_2*GBU-54_LEFT}",
        name: "2 GBU-54(V)1/B",
        weight: 603
    },
    _2_GBU_54_V_1_B_: {
        clsid: "{BRU-70A_2*GBU-54_RIGHT}",
        name: "2 GBU-54(V)1/B",
        weight: 603
    },
    _2_LAU_10___4_ZUNI_MK_71: {
        clsid: "{BRU42_2*LAU10 L}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1008
    },
    _2_LAU_10___4_ZUNI_MK_71_: {
        clsid: "{BRU3242_2*LAU10 L}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1065.38
    },
    _2_LAU_10___4_ZUNI_MK_71__: {
        clsid: "{BRU42_2*LAU10 R}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1008
    },
    _2_LAU_10___4_ZUNI_MK_71___: {
        clsid: "{BRU3242_2*LAU10 R}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1065.38
    },
    _2_LAU_10___4_ZUNI_MK_71____: {
        clsid: "{BRU42_2*LAU10 RS}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1008
    },
    _2_LAU_10___4_ZUNI_MK_71_____: {
        clsid: "{BRU3242_2*LAU10 RS}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1065.38
    },
    _2_LAU_10___4_ZUNI_MK_71______: {
        clsid: "{PHXBRU3242_2*LAU10 RS}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1065.38
    },
    _2_LAU_10___4_ZUNI_MK_71_______: {
        clsid: "{BRU42_2*LAU10 LS}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1008
    },
    _2_LAU_10___4_ZUNI_MK_71________: {
        clsid: "{BRU3242_2*LAU10 LS}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1065.38
    },
    _2_LAU_10___4_ZUNI_MK_71_________: {
        clsid: "{PHXBRU3242_2*LAU10 LS}",
        name: "2 LAU-10 - 4 ZUNI MK 71",
        weight: 1065.38
    },
    _2_LUU_2: {
        clsid: "{BRU42_2*LUU2 R}",
        name: "2 LUU-2",
        weight: 155.2
    },
    _2_LUU_2_: {
        clsid: "{BRU3242_2*LUU2 R}",
        name: "2 LUU-2",
        weight: 212.58
    },
    _2_LUU_2__: {
        clsid: "{BRU42_2*LUU2 L}",
        name: "2 LUU-2",
        weight: 155.2
    },
    _2_LUU_2___: {
        clsid: "{BRU3242_2*LUU2 L}",
        name: "2 LUU-2",
        weight: 212.58
    },
    _2_MK_20: {
        clsid: "{BRU42_2*MK20 RS}",
        name: "2 MK-20",
        weight: 572
    },
    _2_MK_20_: {
        clsid: "{BRU3242_2*MK20 RS}",
        name: "2 MK-20",
        weight: 629.38
    },
    _2_MK_20__: {
        clsid: "{PHXBRU3242_2*MK20 RS}",
        name: "2 MK-20",
        weight: 629.38
    },
    _2_MK_20___: {
        clsid: "{BRU42_2*MK20 LS}",
        name: "2 MK-20",
        weight: 572
    },
    _2_MK_20____: {
        clsid: "{BRU3242_2*MK20 LS}",
        name: "2 MK-20",
        weight: 629.38
    },
    _2_MK_20_____: {
        clsid: "{PHXBRU3242_2*MK20 LS}",
        name: "2 MK-20",
        weight: 629.38
    },
    _2_Mk_20_Rockeye: {
        clsid: "{BRU-42_2*MK-20_LEFT}",
        name: "2 Mk-20 Rockeye",
        weight: 541
    },
    _2_Mk_20_Rockeye_: {
        clsid: "{BRU-42_2*MK-20_RIGHT}",
        name: "2 Mk-20 Rockeye",
        weight: 541
    },
    _2_Mk_81: {
        clsid: "{BRU42_2*MK81 RS}",
        name: "2 Mk-81",
        weight: 364
    },
    _2_Mk_81_: {
        clsid: "{BRU3242_2*MK81 RS}",
        name: "2 Mk-81",
        weight: 421.38
    },
    _2_Mk_81__: {
        clsid: "{PHXBRU3242_2*MK81 RS}",
        name: "2 Mk-81",
        weight: 421.38
    },
    _2_Mk_81___: {
        clsid: "{BRU42_2*MK81 LS}",
        name: "2 Mk-81",
        weight: 364
    },
    _2_Mk_81____: {
        clsid: "{BRU3242_2*MK81 LS}",
        name: "2 Mk-81",
        weight: 421.38
    },
    _2_Mk_81_____: {
        clsid: "{PHXBRU3242_2*MK81 LS}",
        name: "2 Mk-81",
        weight: 421.38
    },
    _2_Mk_82: {
        clsid: "{BRU-42_2*Mk-82_LEFT}",
        name: "2 Mk-82",
        weight: 579
    },
    _2_Mk_82AIR: {
        clsid: "{BRU42_2*MK82AIR RS}",
        name: "2 Mk-82AIR",
        weight: 610
    },
    _2_Mk_82AIR_: {
        clsid: "{BRU3242_2*MK82AIR RS}",
        name: "2 Mk-82AIR",
        weight: 667.38
    },
    _2_Mk_82AIR__: {
        clsid: "{PHXBRU3242_2*MK82AIR RS}",
        name: "2 Mk-82AIR",
        weight: 667.38
    },
    _2_Mk_82AIR___: {
        clsid: "{BRU42_2*MK82AIR LS}",
        name: "2 Mk-82AIR",
        weight: 610
    },
    _2_Mk_82AIR____: {
        clsid: "{BRU3242_2*MK82AIR LS}",
        name: "2 Mk-82AIR",
        weight: 667.38
    },
    _2_Mk_82AIR_____: {
        clsid: "{PHXBRU3242_2*MK82AIR LS}",
        name: "2 Mk-82AIR",
        weight: 667.38
    },
    _2_Mk_82_: {
        clsid: "{BRU-42_2*Mk-82_RIGHT}",
        name: "2 Mk-82",
        weight: 579
    },
    _2_Mk_82_AIR: {
        clsid: "{BRU-42_2*Mk-82AIR_LEFT}",
        name: "2 Mk-82 AIR",
        weight: 579
    },
    _2_Mk_82_AIR_: {
        clsid: "{BRU-42_2*Mk-82AIR_RIGHT}",
        name: "2 Mk-82 AIR",
        weight: 579
    },
    _2_Mk_82_SnakeEye: {
        clsid: "{BRU42_2*MK82SE RS}",
        name: "2 Mk-82 SnakeEye",
        weight: 610
    },
    _2_Mk_82_SnakeEye_: {
        clsid: "{BRU3242_2*MK82SE RS}",
        name: "2 Mk-82 SnakeEye",
        weight: 667.38
    },
    _2_Mk_82_SnakeEye__: {
        clsid: "{PHXBRU3242_2*MK82SE RS}",
        name: "2 Mk-82 SnakeEye",
        weight: 667.38
    },
    _2_Mk_82_SnakeEye___: {
        clsid: "{BRU42_2*MK82SE LS}",
        name: "2 Mk-82 SnakeEye",
        weight: 610
    },
    _2_Mk_82_SnakeEye____: {
        clsid: "{BRU3242_2*MK82SE LS}",
        name: "2 Mk-82 SnakeEye",
        weight: 667.38
    },
    _2_Mk_82_SnakeEye_____: {
        clsid: "{PHXBRU3242_2*MK82SE LS}",
        name: "2 Mk-82 SnakeEye",
        weight: 667.38
    },
    _2_Mk_82_Snakeye: {
        clsid: "{BRU-42_2*Mk-82SNAKEYE_LEFT}",
        name: "2 Mk-82 Snakeye",
        weight: 579
    },
    _2_Mk_82_Snakeye_: {
        clsid: "{BRU-42_2*Mk-82SNAKEYE_RIGHT}",
        name: "2 Mk-82 Snakeye",
        weight: 579
    },
    _2_Mk_82__: {
        clsid: "{BRU42_2*MK82 RS}",
        name: "2 Mk-82",
        weight: 610
    },
    _2_Mk_82___: {
        clsid: "{BRU3242_2*MK82 RS}",
        name: "2 Mk-82",
        weight: 667.38
    },
    _2_Mk_82____: {
        clsid: "{PHXBRU3242_2*MK82 RS}",
        name: "2 Mk-82",
        weight: 667.38
    },
    _2_Mk_82_____: {
        clsid: "{BRU42_2*MK82 LS}",
        name: "2 Mk-82",
        weight: 610
    },
    _2_Mk_82______: {
        clsid: "{BRU3242_2*MK82 LS}",
        name: "2 Mk-82",
        weight: 667.38
    },
    _2_Mk_82_______: {
        clsid: "{PHXBRU3242_2*MK82 LS}",
        name: "2 Mk-82",
        weight: 667.38
    },
    _2_Mk_83: {
        clsid: "{BRU-42_2*Mk-83_LEFT}",
        name: "2 Mk-83",
        weight: 991
    },
    _2_Mk_83_: {
        clsid: "{BRU-42_2*Mk-83_RIGHT}",
        name: "2 Mk-83",
        weight: 991
    },
    _2_SUU_25___8_LUU_2: {
        clsid: "{BRU42_2*SUU25 L}",
        name: "2 SUU-25 * 8 LUU-2",
        weight: 388
    },
    _2_SUU_25___8_LUU_2_: {
        clsid: "{BRU3242_2*SUU25 L}",
        name: "2 SUU-25 * 8 LUU-2",
        weight: 445.38
    },
    _2_SUU_25___8_LUU_2__: {
        clsid: "{BRU42_2*SUU25 R}",
        name: "2 SUU-25 * 8 LUU-2",
        weight: 388
    },
    _2_SUU_25___8_LUU_2___: {
        clsid: "{BRU3242_2*SUU25 R}",
        name: "2 SUU-25 * 8 LUU-2",
        weight: 445.38
    },
    _2_x_ALARM: {
        clsid: "{07BE2D19-0E48-4B0B-91DA-5F6C8F9E3C75}",
        name: "2 x ALARM",
        weight: 200
    },
    _2_x_BL_755_CBUs___450kg__147_Frag_Pen_bomblets: {
        clsid: "{C535596E-F7D2-4301-8BB4-B1658BB87ED7}",
        name: "2 x BL-755 CBUs - 450kg, 147 Frag/Pen bomblets",
        weight: 200
    },
    _2_x_B_13L_pods___10_x_S_13_OF__122mm_UnGd_Rkts__Blast_Frag: {
        clsid: "{TWIN_B13L_5OF}",
        name: "2 x B-13L pods - 10 x S-13-OF, 122mm UnGd Rkts, Blast/Frag",
        weight: 1042
    },
    _2_x_B_13L___5_S_13_OF: {
        clsid: "{B13_5_S13OF_DUAL_L}",
        name: "2 x B-13L - 5 S-13 OF",
        weight: 1042
    },
    _2_x_B_13L___5_S_13_OF_: {
        clsid: "{B13_5_S13OF_DUAL_R}",
        name: "2 x B-13L - 5 S-13 OF",
        weight: 1042
    },
    _2_x_B_8M1_pods___40_x_S_8KOM__80mm_UnGd_Rkts__HEAT_AP: {
        clsid: "{TWIN_B_8M1_S_8KOM}",
        name: "2 x B-8M1 pods - 40 x S-8KOM, 80mm UnGd Rkts, HEAT/AP",
        weight: 759
    },
    _2_x_B_8M1___20_S_8KOM: {
        clsid: "{B8M1_20_S8KOM_DUAL_L}",
        name: "2 x B-8M1 - 20 S-8KOM",
        weight: 975
    },
    _2_x_B_8M1___20_S_8KOM_: {
        clsid: "{B8M1_20_S8KOM_DUAL_R}",
        name: "2 x B-8M1 - 20 S-8KOM",
        weight: 975
    },
    _2_x_B_8M1___20_S_8OFP2: {
        clsid: "{B8M1_20_S8OFP2_DUAL_L}",
        name: "2 x B-8M1 - 20 S-8OFP2",
        weight: 975
    },
    _2_x_B_8M1___20_S_8OFP2_: {
        clsid: "{B8M1_20_S8OFP2_DUAL_R}",
        name: "2 x B-8M1 - 20 S-8OFP2",
        weight: 975
    },
    _2_x_B_8M1___20_S_8TsM: {
        clsid: "{B8M1_20_S8TsM_DUAL_L}",
        name: "2 x B-8M1 - 20 S-8TsM",
        weight: 751
    },
    _2_x_B_8M1___20_S_8TsM_: {
        clsid: "{B8M1_20_S8TsM_DUAL_R}",
        name: "2 x B-8M1 - 20 S-8TsM",
        weight: 751
    },
    _2_x_B_8V20A_pods___40_x_S_8OFP2__80mm_UnGd_Rkts__HE_Frag_AP: {
        clsid: "{TWIN_B_8M1_S_8_OFP2}",
        name: "2 x B-8V20A pods - 40 x S-8OFP2, 80mm UnGd Rkts, HE/Frag/AP",
        weight: 975
    },
    _2_x_B_8V20A_pods___40_x_S_8TsM__80mm_UnGd_Rkts__Smk: {
        clsid: "{TWIN_B_8M1_S_8TsM}",
        name: "2 x B-8V20A pods - 40 x S-8TsM, 80mm UnGd Rkts, Smk",
        weight: 751
    },
    _2_x_FAB_250: {
        clsid: "{FAB_250_DUAL_L}",
        name: "2 x FAB-250",
        weight: 532
    },
    _2_x_FAB_250_: {
        clsid: "{FAB_250_DUAL_R}",
        name: "2 x FAB-250",
        weight: 532
    },
    _2_x_FAB_500: {
        clsid: "{FAB_500_DUAL_L}",
        name: "2 x FAB-500",
        weight: 1044
    },
    _2_x_FAB_500_: {
        clsid: "{FAB_500_DUAL_R}",
        name: "2 x FAB-500",
        weight: 1044
    },
    _2_x_HVAR__UnGd_Rkts: {
        clsid: "{HVARx2}",
        name: "2 x HVAR, UnGd Rkts",
        weight: 128
    },
    _2_x_OFAB_100_Jupiter___100kg_GP_Bombs_LD: {
        clsid: "{FAB-100x2}",
        name: "2 x OFAB-100 Jupiter - 100kg GP Bombs LD",
        weight: 342
    },
    _2_x_RBK_250_PTAB_2_5M: {
        clsid: "{RBK_250_PTAB25M_DUAL_L}",
        name: "2 x RBK-250 PTAB-2.5M",
        weight: 578
    },
    _2_x_RBK_250_PTAB_2_5M_: {
        clsid: "{RBK_250_PTAB25M_DUAL_R}",
        name: "2 x RBK-250 PTAB-2.5M",
        weight: 578
    },
    _2_x_RBK_500_255_PTAB_10_5: {
        clsid: "{RBK_500_PTAB105_DUAL_L}",
        name: "2 x RBK-500-255 PTAB-10-5",
        weight: 886
    },
    _2_x_RBK_500_255_PTAB_10_5_: {
        clsid: "{RBK_500_PTAB105_DUAL_R}",
        name: "2 x RBK-500-255 PTAB-10-5",
        weight: 886
    },
    _2_x_S_25: {
        clsid: "{S25_DUAL_L}",
        name: "2 x S-25",
        weight: 902
    },
    _2_x_S_25_: {
        clsid: "{S25_DUAL_R}",
        name: "2 x S-25",
        weight: 902
    },
    _2_x_S_25_OFM___340mm_UnGdrocket__480kg_Penetrator: {
        clsid: "{TWIN_S25}",
        name: "2 x S-25-OFM - 340mm UnGdrocket, 480kg Penetrator",
        weight: 902
    },
    _33_x_FAB_250___250kg_GP_Bombs_LD: {
        clsid: "{BDAD04AA-4D4A-4E51-B958-180A89F963CF}",
        name: "33 x FAB-250 - 250kg GP Bombs LD",
        weight: 8250
    },
    _33_x_FAB_500_M_62___500kg_GP_Bombs_LD: {
        clsid: "{AD5E5863-08FC-4283-B92C-162E2B2BD3FF}",
        name: "33 x FAB-500 M-62 - 500kg GP Bombs LD",
        weight: 16500
    },
    _3M45: {
        clsid: "3M45",
        name: "SS-N-19 SHIPWRECK",
        weight: $e56653165fb50b77$var$None
    },
    _3_BDU_33: {
        clsid: "{BRU42_3*BDU33}",
        name: "3 BDU-33",
        weight: 161
    },
    _3_BDU_33_: {
        clsid: "{BRU3242_3*BDU33}",
        name: "3 BDU-33",
        weight: 218.38
    },
    _3_BDU_33__: {
        clsid: "{BRU42_3*BDU33_N}",
        name: "3 BDU-33",
        weight: 161
    },
    _3_BDU_33___: {
        clsid: "{BRU3242_3*BDU33_N}",
        name: "3 BDU-33",
        weight: 218.38
    },
    _3_BDU_33____: {
        clsid: "{PHXBRU3242_BDU33}",
        name: "3 BDU-33",
        weight: 218.38
    },
    _3_GBU_12: {
        clsid: "{BRU-42A_3*GBU-12}",
        name: "3 GBU-12",
        weight: 772
    },
    _3_GBU_16: {
        clsid: "{BRU-42A_3*GBU-16}",
        name: "3 GBU-16",
        weight: 1459
    },
    _3_GBU_38: {
        clsid: "{BRU-42_3*GBU-38}",
        name: "3 GBU-38",
        weight: 820
    },
    _3_GBU_54_V_1_B: {
        clsid: "{BRU-70A_3*GBU-54}",
        name: "3 GBU-54(V)1/B",
        weight: 856
    },
    _3_Mk_20_Rockeye: {
        clsid: "{BRU-42_3*MK-20}",
        name: "3 Mk-20 Rockeye",
        weight: 763
    },
    _3_Mk_81: {
        clsid: "{BRU-42_3*Mk-81LD}",
        name: "3 Mk-81",
        weight: 451
    },
    _3_Mk_82: {
        clsid: "{BRU-42_3*Mk-82LD}",
        name: "3 Mk-82",
        weight: 820
    },
    _3_Mk_82_AIR: {
        clsid: "{BRU-42_3_MK82AIR}",
        name: "3 Mk-82 AIR",
        weight: 820
    },
    _3_Mk_82_Snakeye: {
        clsid: "{BRU-42_3*Mk-82SNAKEYE}",
        name: "3 Mk-82 Snakeye",
        weight: 820
    },
    _3_Mk_83: {
        clsid: "{BRU-42_3*Mk-83}",
        name: "3 Mk-83",
        weight: 1438
    },
    _3_x_4_5_inch_M8_UnGd_Rocket: {
        clsid: "{3xM8_ROCKETS_IN_TUBES}",
        name: "3 x 4.5 inch M8 UnGd Rocket",
        weight: 71.72
    },
    _3_x_FAB_1500_M_54___1500kg_GP_Bombs_LD: {
        clsid: "{639DB5DD-CB7E-4E42-AC75-2112BC397B97}",
        name: "3 x FAB-1500 M-54 - 1500kg GP Bombs LD",
        weight: 4500
    },
    _3_x_LAU_61_pods___57_x_2_75_Hydra__UnGd_Rkts_M151__HE: {
        clsid: "{A76344EB-32D2-4532-8FA2-0C1BDC00747E}",
        name: "3 x LAU-61 pods - 57 x 2.75 Hydra, UnGd Rkts M151, HE",
        weight: 871
    },
    _48N6E2: {
        clsid: "48N6E2",
        name: "48N6E2 S-300F (SA-N-6 Grumble)",
        weight: $e56653165fb50b77$var$None
    },
    _4M80: {
        clsid: "_4M80",
        name: "SS-N-12 SANDBOX",
        weight: $e56653165fb50b77$var$None
    },
    _4x_SB_M_71_120kg_GP_Bomb_High_drag: {
        clsid: "{M71BOMBD}",
        name: "4x SB M/71 120kg GP Bomb High-drag",
        weight: 609
    },
    _4x_SB_M_71_120kg_GP_Bomb_Low_drag: {
        clsid: "{M71BOMB}",
        name: "4x SB M/71 120kg GP Bomb Low-drag",
        weight: 609
    },
    _4_x_AGM_154C___JSOW_Unitary_BROACH: {
        clsid: "{AABA1A14-78A1-4E85-94DD-463CF75BD9E4}",
        name: "4 x AGM-154C - JSOW Unitary BROACH",
        weight: 2560
    },
    _4_x_AN_M64___500lb_GP_Bomb_LD: {
        clsid: "{4xAN-M64_on_InvCountedAttachmentPoints}",
        name: "4 x AN-M64 - 500lb GP Bomb LD",
        weight: 908
    },
    _4_x_BGM_71D_TOW_ATGM: {
        clsid: "{3EA17AB0-A805-4D9E-8732-4CE00CB00F17}",
        name: "4 x BGM-71D TOW ATGM",
        weight: 250
    },
    _4_x_GBU_27___2000lb_Laser_Guided_Penetrator_Bombs: {
        clsid: "{B8C99F40-E486-4040-B547-6639172A5D57}",
        name: "4 x GBU-27 - 2000lb Laser Guided Penetrator Bombs",
        weight: 3936
    },
    _500lb_Mk_IV___GP_Bomb_LD: {
        clsid: "{British_GP_500LB_Bomb_Mk4}",
        name: "500lb Mk.IV - GP Bomb LD",
        weight: 213.188
    },
    _500lb_Mk_I___GP_Bomb_LD: {
        clsid: "{British_GP_500LB_Bomb_Mk1}",
        name: "500lb Mk.I - GP Bomb LD",
        weight: 213.188
    },
    _500_lb_GP_Mk_V: {
        clsid: "{British_GP_500LB_Bomb_Mk5}",
        name: "500 lb GP Mk.V",
        weight: 213.188
    },
    _500_lb_GP_Short_tail: {
        clsid: "{British_GP_500LB_Bomb_Mk4_Short}",
        name: "500 lb GP Short tail",
        weight: 207.7
    },
    _500_lb_MC_Mk_II: {
        clsid: "{British_MC_500LB_Bomb_Mk2}",
        name: "500 lb MC Mk.II",
        weight: 231.8
    },
    _500_lb_MC_Short_tail: {
        clsid: "{British_MC_500LB_Bomb_Mk1_Short}",
        name: "500 lb MC Short tail",
        weight: 226.3
    },
    _500_lb_S_A_P_: {
        clsid: "{British_SAP_500LB_Bomb_Mk5}",
        name: "500 lb S.A.P.",
        weight: 222.26
    },
    _51_x_M117___750lb_GP_Bombs_LD: {
        clsid: "{72CAC282-AE18-490B-BD4D-35E7EE969E73}",
        name: "51 x M117 - 750lb GP Bombs LD",
        weight: 17340
    },
    _51_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{B84DFE16-6AC7-4854-8F6D-34137892E166}",
        name: "51 x Mk-82 - 500lb GP Bombs LD",
        weight: 12291
    },
    _5V55: {
        clsid: "5V55",
        name: "5V55 S-300PS (SA-10B Grumble)",
        weight: $e56653165fb50b77$var$None
    },
    _5_x_HVAR__UnGd_Rkt: {
        clsid: "{P47_5_HVARS_ON_LEFT_WING_RAILS}",
        name: "5 x HVAR, UnGd Rkt",
        weight: 330
    },
    _5_x_HVAR__UnGd_Rkt_: {
        clsid: "{P47_5_HVARS_ON_RIGHT_WING_RAILS}",
        name: "5 x HVAR, UnGd Rkt",
        weight: 330
    },
    _5_x_Mk_82_Snakeye___500lb_GP_Bomb_HD: {
        clsid: "{MER-5E_Mk82SNAKEYEx5}",
        name: "5 x Mk-82 Snakeye - 500lb GP Bomb HD",
        weight: 1250.7
    },
    _5_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{MER-5E_MK82x5}",
        name: "5 x Mk-82 - 500lb GP Bombs LD",
        weight: 1295.7
    },
    _6_x_AGM_86C_ALCM_on_MER: {
        clsid: "{45447F82-01B5-4029-A572-9AAD28AF0275}",
        name: "6 x AGM-86C ALCM on MER",
        weight: 11760
    },
    _6_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD: {
        clsid: "{2B7BDB38-4F45-43F9-BE02-E7B3141F3D24}",
        name: "6 x BetAB-500 - 500kg Concrete Piercing Bombs LD",
        weight: 2868
    },
    _6_x_FAB_1500_M_54___1500kg_GP_Bombs_LD: {
        clsid: "{D9179118-E42F-47DE-A483-A6C2EA7B4F38}",
        name: "6 x FAB-1500 M-54 - 1500kg GP Bombs LD",
        weight: 9000
    },
    _6_x_FAB_500_M_62___500kg_GP_Bombs_LD: {
        clsid: "{26D2AF37-B0DF-4AB6-9D61-A150FF58A37B}",
        name: "6 x FAB-500 M-62 - 500kg GP Bombs LD",
        weight: 3000
    },
    _6_x_Kh_35__AS_20_Kayak____520kg__AShM__IN__Act_Rdr: {
        clsid: "{C42EE4C3-355C-4B83-8B22-B39430B8F4AE}",
        name: "6 x Kh-35 (AS-20 Kayak) - 520kg, AShM, IN & Act Rdr",
        weight: 2880
    },
    _6_x_Kh_65__AS_15B_Kent____1250kg__ASM__IN__MCC: {
        clsid: "{0290F5DE-014A-4BB1-9843-D717749B1DED}",
        name: "6 x Kh-65 (AS-15B Kent) - 1250kg, ASM, IN & MCC",
        weight: 7500
    },
    _6_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets: {
        clsid: "{E79759F7-C622-4AA4-B1EF-37639A34D924}",
        name: "6 x Mk-20 Rockeye - 490lbs CBUs, 247 x HEAT Bomblets",
        weight: 1332
    },
    _6_x_Mk_82___500lb_GP_Bombs_LD: {
        clsid: "{027563C9-D87E-4A85-B317-597B510E3F03}",
        name: "6 x Mk-82 - 500lb GP Bombs LD",
        weight: 1446
    },
    _75_US_gal__Fuel_Tank: {
        clsid: "{DT75GAL}",
        name: "75 US gal. Fuel Tank",
        weight: 227.048087675
    },
    _8_x_AGM_84A_Harpoon_ASM: {
        clsid: "{46ACDCF8-5451-4E26-BDDB-E78D5830E93C}",
        name: "8 x AGM-84A Harpoon ASM",
        weight: 5292
    },
    _8_x_AGM_86C_ALCM: {
        clsid: "{8DCAF3A3-7FCF-41B8-BB88-58DEDA878EDE}",
        name: "8 x AGM-86C ALCM",
        weight: 15600
    },
    _8_x_Kh_65__AS_15B_Kent____1250kg__ASM__IN__MCC: {
        clsid: "{CD9417DF-455F-4176-A5A2-8C58D61AA00B}",
        name: "8 x Kh-65 (AS-15B Kent) - 1250kg, ASM, IN & MCC",
        weight: 10000
    },
    _9M111: {
        clsid: "_9M111",
        name: "AT-4 SPIGOT",
        weight: $e56653165fb50b77$var$None
    },
    _9M114_Shturm_V_2__AT_6_Spiral____ATGM__SACLOS: {
        clsid: "{B919B0F4-7C25-455E-9A02-CEA51DB895E3}",
        name: "9M114 Shturm-V-2 (AT-6 Spiral) - ATGM, SACLOS",
        weight: 230
    },
    _9M114_Shturm_V_8__AT_6_Spiral____ATGM__SACLOS: {
        clsid: "{57232979-8B0F-4db7-8D9A-55197E06B0F5}",
        name: "9M114 Shturm-V-8 (AT-6 Spiral) - ATGM, SACLOS",
        weight: 300
    },
    _9M117: {
        clsid: "_9M117",
        name: "AT-10 SABBER",
        weight: $e56653165fb50b77$var$None
    },
    _9M133: {
        clsid: "9M133",
        name: "AT-14 KORNET",
        weight: $e56653165fb50b77$var$None
    },
    _9M14: {
        clsid: "9M14",
        name: "AT-3 SAGGER",
        weight: $e56653165fb50b77$var$None
    },
    _9M31: {
        clsid: "9M31",
        name: "SA-9 GASKIN",
        weight: $e56653165fb50b77$var$None
    },
    _9M311: {
        clsid: "9M311",
        name: "SA-19 GRISON",
        weight: $e56653165fb50b77$var$None
    },
    _9M33: {
        clsid: "9M33",
        name: "SA-8 GECKO",
        weight: $e56653165fb50b77$var$None
    },
    _9M331: {
        clsid: "_9M331",
        name: "SA-15 GAUNTLET",
        weight: $e56653165fb50b77$var$None
    },
    _9M37: {
        clsid: "_9M37",
        name: "SA-13 GOPHER",
        weight: $e56653165fb50b77$var$None
    },
    _9M38: {
        clsid: "_9M38",
        name: "SA-11 GADFLY",
        weight: $e56653165fb50b77$var$None
    },
    _9M39: {
        clsid: "_9M39",
        name: "SA-18 GROUSE",
        weight: $e56653165fb50b77$var$None
    },
    _NiteHawk_FLIR: {
        clsid: "_NiteHawk_FLIR",
        name: "AN/AAS-38 Nite hawk FLIR, Laser designator & Laser spot tracker pod",
        weight: 200
    }
};
var $e56653165fb50b77$export$2e2bcd8739ae039 = $e56653165fb50b77$var$Weapons;


const $491c0dea9b8dcbb0$var$weaponIDs = {
    "{AB_250_2_SD_2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AB_250_2___144_x_SD_2__250kg_CBU_with_HE_submunitions,
    "{AB_250_2_SD_10A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AB_250_2___17_x_SD_10A__250kg_CBU_with_10kg_Frag_HE_submunitions,
    "{AB_500_1_SD_10A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AB_500_1___34_x_SD_10A__500kg_CBU_with_10kg_Frag_HE_submunitions,
    "{ADEN_GUNPOD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ADEN_GUNPOD,
    "{BRU42_ADM141}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ADM_141A,
    "{BRU3242_ADM141}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ADM_141A_,
    "{ADM_141A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ADM_141A_TALD,
    "{ADM_141B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ADM_141B_TALD,
    "{AV8BNA_AERO1D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AERO_1D_300_Gallons_Fuel_Tank_,
    "{AV8BNA_AERO1D_EMPTY}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AERO_1D_300_Gallons_Fuel_Tank__Empty_,
    AGM114x2_OH_58: (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM114x2_OH_58,
    "{ee368869-c35a-486a-afe7-284beb7c5d52}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_114K,
    "{88D18A5E-99C8-4B04-B40B-1C02F2018B6E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_114K___4,
    "{7B8DCEB4-820B-4015-9B48-1028A4195692}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_119B_Penguin_ASM,
    "{AGM_122_SIDEARM}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_122_Sidearm,
    "{LAU_7_AGM_122_SIDEARM}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_122_Sidearm_,
    "{AGM_122}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_122_Sidearm___light_ARM,
    "{AGM-154A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_154A___JSOW_CEB__CBU_type_,
    "{AGM-154B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_154B___JSOW_Anti_Armour,
    "{9BCC2A2B-5708-4860-B1F1-053A18442067}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_154C___JSOW_Unitary_BROACH,
    "{AGM_45A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_45A_Shrike_ARM,
    "{3E6B632D-65EB-44D2-9501-1C2D04515404}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_45B_Shrike_ARM__Imp_,
    "{C40A1E3A-DD05-40D9-85A4-217729E37FAE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_62_Walleye_II___Guided_Weapon_Mk_5__TV_Guided_,
    "{444BA8AE-82A7-4345-842E-76154EFCCA47}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_65D___Maverick_D__IIR_ASM_,
    "{F16A4DE0-116C-4A71-97F0-2CF85B0313EF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_,
    "{69DC8AE7-8F77-427B-B8AA-B19D3F478B65}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_65K___Maverick_K__CCD_Imp_ASM_,
    AGM_84: (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_84,
    "{8B7CADF9-4954-46B3-8CFB-93F2F5B90B03}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_84A_Harpoon_ASM,
    "{AGM_84D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_84D_Harpoon_AShM,
    "{AF42E6DF-9A60-46D8-A9A0-1708B241AADB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_84E_Harpoon_SLAM__Stand_Off_Land_Attack_Missile_,
    "{AGM_84E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_84E_Harpoon_SLAM__Stand_Off_Land_Attack_Missile__,
    "{AGM_84H}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_84H_SLAM_ER__Expanded_Response_,
    "{769A15DF-6AFB-439F-9B24-5B7A45C59D16}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_86C_ALCM,
    "{B06DD79A-F21E-4EB9-BD9D-AB3844618C9C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_88C_HARM___High_Speed_Anti_Radiation_Missile,
    "{B06DD79A-F21E-4EB9-BD9D-AB3844618C93}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AGM_88C_HARM___High_Speed_Anti_Radiation_Missile_,
    "{C8E06185-7CD6-4C90-959F-044679E90751}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_120B_AMRAAM___Active_Rdr_AAM,
    "{40EF17B7-F508-45de-8566-6FFECC0C1AB8}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_120C_5_AMRAAM___Active_Rdr_AAM,
    "{AIM_54A_Mk47}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54A_Mk47,
    "{SHOULDER AIM_54A_Mk47 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54A_Mk47_,
    "{SHOULDER AIM_54A_Mk47 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54A_Mk47__,
    "{AIM_54A_Mk60}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54A_Mk60,
    "{SHOULDER AIM_54A_Mk60 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54A_Mk60_,
    "{SHOULDER AIM_54A_Mk60 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54A_Mk60__,
    "{AIM_54C_Mk47}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54C_Mk47,
    "{SHOULDER AIM_54C_Mk47 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54C_Mk47_,
    "{7575BA0B-7294-4844-857B-031A144B2595}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54C_Mk47_Phoenix_IN__Semi_Active_Radar,
    "{SHOULDER AIM_54C_Mk47 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_54C_Mk47__,
    "{AIM-7E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7E_Sparrow_Semi_Active_Radar,
    "{SHOULDER AIM-7F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7F,
    "{BELLY AIM-7F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7F_,
    "{AIM-7F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7F_Sparrow_Semi_Active_Radar,
    "{SHOULDER AIM-7M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7M,
    "{SHOULDER AIM-7MH}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7MH,
    "{BELLY AIM-7MH}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7MH_,
    "{AIM-7H}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7MH_Sparrow_Semi_Active_Radar,
    "{BELLY AIM-7M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7M_,
    "{8D399DDA-FF81-4F14-904D-099B34FE7918}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_7M_Sparrow_Semi_Active_Radar,
    "{AIM-9B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_9B_Sidewinder_IR_AAM,
    "{AIM-9L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_9L_Sidewinder_IR_AAM,
    "{6CEB49FC-DED8-4DED-B053-E1F033FF72D3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_9M_Sidewinder_IR_AAM,
    "{AIM-9P5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_9P5_Sidewinder_IR_AAM,
    "{9BFD8C90-F7AE-4e90-833B-BFD0CED0E536}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_9P_Sidewinder_IR_AAM,
    "{5CE2FF2A-645A-4197-B48D-8720AC69394F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AIM_9X_Sidewinder_IR_AAM,
    "{VIGGEN_X-TANK}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AJS_External_tank_1013kg_fuel,
    "{AKAN}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AKAN_M_55_Gunpod__150_rnds_MINGR55_HE,
    "{E6747967-B1F0-4C77-977B-AB2E6EB0C102}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ALARM,
    "{6D21ECEA-F85B-4E8D-9D51-31DC9B8AA4EF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ALQ_131___ECM_Pod,
    ALQ_184: (0, $e56653165fb50b77$export$2e2bcd8739ae039).ALQ_184,
    "{A111396E-D3E8-4b9c-8AC9-2432489304D5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_AAQ_28_LITENING___Targeting_Pod,
    "{AAQ-28_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_AAQ_28_LITENING___Targeting_Pod_,
    "{ALQ_164_RF_Jammer}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_ALQ_164_DECM_Pod,
    "{1C2B16EB-8EB0-43de-8788-8EBB2D70B8BC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_ASQ_173_Laser_Spot_Tracker_Strike_CAMera__LST_SCAM_,
    "{AN_ASQ_228}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_ASQ_228_ATFLIR___Targeting_Pod,
    "{AIS_ASQ_T50}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_ASQ_T50_TCTS_Pod___ACMI_Pod,
    "{AN-M3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_M3,
    "{AN_M30A1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_M30A1___100lb_GP_Bomb_LD,
    "{AN_M57}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_M57___250lb_GP_Bomb_LD,
    "{AN-M64}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_M64___500lb_GP_Bomb_LD,
    "{F86ANM64}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_M64___500lb_GP_Bomb_LD_,
    "{AN_M65}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_M65___1000lb_GP_Bomb_LD,
    "{AN_M66}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AN_M66___2000lb_GP_Bomb_LD,
    "{APU-60-1_R_60M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).APU_60_1M_with_R_60M__AA_8_Aphid____Infra_Red,
    "{B0DBC591-0F52-4F7D-AD7B-51E67725FB81}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).APU_60_2M_with_2_x_R_60M__AA_8_Aphid____Infra_Red,
    "{275A2855-4A79-4B2D-B082-91EA2ADF4691}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).APU_60_2M_with_2_x_R_60M__AA_8_Aphid____Infra_Red_,
    "{APU_68_S-24}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).APU_68___S_24B,
    "{A6FD14D3-6D30-4C85-88A7-8D17BEE120E2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).APU_6___6_9A4172_Vikhr,
    "{F789E86A-EE2E-4E6B-B81E-D5E5F903B6ED}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).APU_8___8_9A4172_Vikhr,
    "{ARAKM70BAP}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ARAK_M_70B_AP_6x_135mm_UnGd_Rkts__Pshu70_HEAT,
    "{ARAKM70BHE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ARAK_M_70B_HE_6x_135mm_UnGd_Rkts__Shu70_HE_FRAG,
    "{ASO-2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ASO_2,
    "{M2KC_RAFAUT_BLG66}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AUF2_BLG_66_AC_x_2,
    "{M2KC_RAFAUT_GBU12}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AUF2_GBU_12_x_2,
    "{M2KC_RAFAUT_MK82S}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AUF2_MK_82_Snakeyes_x_2,
    "{M2KC_RAFAUT_MK82}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AUF2_MK_82_x_2,
    "{M2KC_RAFAUT_ROCKEYE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AUF2_ROCKEYE_x_2,
    "{AWW-13}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).AWW_13_DATALINK_POD,
    "{BDU-33}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BDU_33___25lb_Practice_Bomb_LD,
    "{BDU_45}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BDU_45,
    "{BDU_45B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BDU_45B,
    "{BDU-50HD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BDU_50HD___500lb_Inert_Practice_Bomb_HD,
    "{BDU-50LD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BDU_50LD___500lb_Inert_Practice_Bomb_LD,
    "{BDU-50LGB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BDU_50LGB___500lb_Laser_Guided_Inert_Practice_Bomb_LD,
    "{BETAB-500M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BETAB_500M,
    "{BETAB-500S}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BETAB_500S,
    "{BEER_BOMB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Beer_Bomb,
    "Beer_Bomb_(D)_on_LH_Spitfire_Wing_Carrier": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Beer_Bomb__D__on_LH_Spitfire_Wing_Carrier,
    "Beer_Bomb_(D)_on_RH_Spitfire_Wing_Carrier": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Beer_Bomb__D__on_RH_Spitfire_Wing_Carrier,
    "Beer_Bomb_(L)_on_LH_Spitfire_Wing_Carrier": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Beer_Bomb__L__on_LH_Spitfire_Wing_Carrier,
    "Beer_Bomb_(L)_on_RH_Spitfire_Wing_Carrier": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Beer_Bomb__L__on_RH_Spitfire_Wing_Carrier,
    "{BLG66_BELOUGA}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Belouga,
    "{BD289E34-DF84-4C5E-9220-4B14C346E79D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BetAB_500ShP___500kg_Concrete_Piercing_HD_w_booster_Bomb,
    "{35B698AC-9FEF-4EC4-AD29-484A0085F62B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BetAB_500___500kg_Concrete_Piercing_Bomb_LD,
    BF109K_4_FUEL_TANK: (0, $e56653165fb50b77$export$2e2bcd8739ae039).BF109K_4_FUEL_TANK,
    BGM_109: (0, $e56653165fb50b77$export$2e2bcd8739ae039).BGM_109,
    "BGM-109B": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BGM_109B,
    BIN_200: (0, $e56653165fb50b77$export$2e2bcd8739ae039).BIN_200,
    "{BK90}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BK_90_MJ12__12x_MJ2_HEAT___36x_MJ1_HE_FRAG_Bomblets_,
    "{BK90MJ1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BK_90_MJ1__72_x_MJ1_HE_FRAG_Bomblets_,
    "{BK90MJ2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BK_90_MJ2__24_x_MJ2_HEAT_Bomblets_,
    "{BLG66_BELOUGA_AC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BLG_66_AC_Belouga,
    "{BLG66_AC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BLG_66_Belouga___290kg_CBU__151_Frag_Pen_bomblets,
    "{752B9781-F962-11d5-9190-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BLU_107___440lb_Anti_Runway_Penetrator_Bomb,
    "{08164777-5E9C-4B08-B48E-5AA7AFB246E2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BL_755_CBU___450kg__147_Frag_Pen_bomblets,
    "{8C3F26A1-FA0F-11d5-9190-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BOZ_107___Countermeasure_Dispenser,
    "{BRU33_LAU10}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_1_x_LAU_10_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG,
    "{BRU33_LAU61}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_1_x_LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{BRU33_LAU68}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_1_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{BRU33_LAU68_MK5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_1_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT,
    "{BRU33_2X_BDU-45B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_BDU_45B___500lb_Practice_Bomb,
    "{BRU33_2X_BDU-45}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_BDU_45___500lb_Practice_Bomb,
    "{BRU33_2X_CBU-99}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_CBU_99___490lbs__247_x_HEAT_Bomblets,
    "{BRU33_2X_GBU-12}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_GBU_12___500lb_Laser_Guided_Bomb,
    "{BRU33_2X_GBU-16}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_GBU_16___1000lb_Laser_Guided_Bomb,
    "{BRU33_2*LAU10}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_LAU_10_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG,
    "{BRU33_2*LAU61}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{BRU33_2*LAU68}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{BRU33_2*LAU68_MK5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT,
    "{BRU33_2X_ROCKEYE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_Mk_20_Rockeye___490lbs_CBU__247_x_HEAT_Bomblets,
    "{BRU33_2X_MK-82Y}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_Mk_82Y___500lb_GP_Chute_Retarded_HD,
    "{BRU33_2X_MK-82_Snakeye}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_Mk_82_Snakeye___500lb_GP_Bomb_HD,
    "{BRU33_2X_MK-82}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_Mk_82___500lb_GP_Bomb_LD,
    "{BRU33_2X_MK-83}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_33_with_2_x_Mk_83___1000lb_GP_Bomb_LD,
    "{BRU41_6X_BDU-33}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_41A_with_6_x_BDU_33___25lb_Practice_Bomb_LD,
    "{BRU41_6X_MK-82}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_41A_with_6_x_Mk_82___500lb_GP_Bomb_LD,
    "BRU-42_3*BDU-33": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_3_BDU_33,
    "BRU-42_3*GBU-12": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_3_GBU_12,
    "BRU-42_LS": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_LS,
    "{62BE78B1-9258-48AE-B882-279534C0D278}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_2_x_GBU_10___2000lb_Laser_Guided_Bombs,
    "{EB969276-1922-4ED1-A5CB-18590F45D7FE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_2_x_GBU_27___2000lb_Laser_Guided_Penetrator_Bombs,
    "{88D49E04-78DF-4F08-B47E-B81247A9E3C5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_GBU_16___1000lb_Laser_Guided_Bombs,
    "{LAU-131x3 - 7 AGR-20A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_131_pods___7_x_2_75_Hydra__Laser_Guided_Rkts_M151__HE_APKWS,
    "{LAU-131x3 - 7 AGR-20 M282}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_131_pods___7_x_2_75_Hydra__Laser_Guided_Rkts_M282__MPP_APKWS,
    "{64329ED9-B14C-4c0b-A923-A3C911DA1527}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{C2593383-3CA8-4b18-B73D-0E750BCA1C85}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos,
    "{E6966004-A525-4f47-AF94-BCFEDF8FDBDA}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M257__Para_Illum,
    "{4C044B08-886B-46c8-9B1F-AB05B3ED9C1D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_M274__Practice_Smk,
    "{443364AE-D557-488e-9499-45EDB3BA6730}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_Mk1__Practice,
    "{9BC82B3D-FE70-4910-B2B7-3E54EFE73262}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT,
    "{C0FA251E-B645-4ce5-926B-F4BC20822F8B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_Mk61__Practice,
    "{A1853B38-2160-4ffe-B7E9-9BF81E6C3D77}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_LAU_68_pods___21_x_2_75_Hydra__UnGd_Rkts_WTU_1_B__Practice,
    "{B83CB620-5BBE-4BEA-910C-EB605A327EF9}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets,
    "{7B34E0BB-E427-4C2A-A61A-8407CE18B54D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_Mk_81___250lb_GP_Bombs_LD,
    "{BRU-42_3*Mk-82AIR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_Mk_82_AIR_Ballute___500lb_GP_Bombs_HD,
    "{60CC734F-0AFA-4E2E-82B8-93B941AB11CF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_Mk_82___500lb_GP_Bombs_LD,
    "{BRU-42_LS_3*SUU-25_8*LUU-2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_42_with_3_x_SUU_25_x_8_LUU_2___Target_Marker_Flares,
    "{BRU55_2*AGM-154A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_55_with_2_x_AGM_154A___JSOW_CEB__CBU_type_,
    "{BRU55_2*AGM-154C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_55_with_2_x_AGM_154C___JSOW_Unitary_BROACH,
    "{BRU55_2*GBU-38}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_55_with_2_x_GBU_38___JDAM__500lb_GPS_Guided_Bomb,
    "{BRU57_2*AGM-154A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_57_with_2_x_AGM_154A___JSOW_CEB__CBU_type_,
    "{BRU57_2*CBU-103}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_57_with_2_x_CBU_103,
    "{BRU57_2*CBU-105}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_57_with_2_x_CBU_105,
    "{BRU57_2*GBU-38}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).BRU_57_with_2_x_GBU_38___JDAM__500lb_GPS_Guided_Bomb,
    BR_250: (0, $e56653165fb50b77$export$2e2bcd8739ae039).BR_250,
    BR_500: (0, $e56653165fb50b77$export$2e2bcd8739ae039).BR_500,
    British_GP_250LBS_Bomb_MK4_on_LH_Spitfire_Wing_Carrier: (0, $e56653165fb50b77$export$2e2bcd8739ae039).British_GP_250LBS_Bomb_MK4_on_LH_Spitfire_Wing_Carrier,
    British_GP_250LBS_Bomb_MK4_on_RH_Spitfire_Wing_Carrier: (0, $e56653165fb50b77$export$2e2bcd8739ae039).British_GP_250LBS_Bomb_MK4_on_RH_Spitfire_Wing_Carrier,
    British_GP_500LBS_Bomb_MK4_on_British_UniversalBC_MK3: (0, $e56653165fb50b77$export$2e2bcd8739ae039).British_GP_500LBS_Bomb_MK4_on_British_UniversalBC_MK3,
    "{FC56DF80-9B09-44C5-8976-DCFAFF219062}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_13L_pod___5_x_S_13_OF__122mm_UnGd_Rkts__Blast_Frag,
    "B-1B_Mk-84*8": (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_1B_Mk_84_8,
    "{F72F47E5-C83A-4B85-96ED-D3E46671EE9A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8M1_pod___20_x_S_8KOM__80mm_UnGd_Rkts__HEAT_AP,
    "{3DFB7320-AB0E-11d7-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8M1_pod___20_x_S_8TsM__80mm_UnGd_Rkts__Smk,
    "B-8M1 - 20 S-8OFP2": (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8M1___20_S_8OFP2,
    B_8V20A_CM: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_CM,
    B_8V20A_CM_BU: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_CM_BU,
    B_8V20A_CM_GN: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_CM_GN,
    B_8V20A_CM_RD: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_CM_RD,
    B_8V20A_CM_VT: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_CM_VT,
    B_8V20A_CM_WH: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_CM_WH,
    B_8V20A_CM_YE: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_CM_YE,
    B_8V20A_OFP2: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_OFP2,
    B_8V20A_OM: (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_OM,
    "{6A4B9E69-64FE-439a-9163-3A87FB6A4D81}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).B_8V20A_pod___20_x_S_8KOM__80mm_UnGd_Rkts__HEAT_AP,
    "CATM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CATM_9M,
    "CBLS-200": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBLS_200,
    "CBU87*10": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU87_10,
    "CBU97*10": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU97_10,
    "{CBU_103}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU_103___202_x_CEM__CBU_with_WCMD,
    "{CBU_105}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU_105___10_x_CEM__CBU_with_WCMD,
    "{CBU-52B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU_52B___220_x_HE_Frag_bomblets,
    "{CBU-87}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU_87___202_x_CEM_Cluster_Bomb,
    "{5335D97A-35A5-4643-9D9B-026C75961E52}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU_97___10_x_CEM_Cluster_Bomb,
    "{CBU_99}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).CBU_99___490lbs__247_x_HEAT_Bomblets,
    "{C-101-DEFA553}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DEFA_553,
    "DIS_AKD-10": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_AKD_10,
    DIS_AKG_DLPOD: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_AKG_DLPOD,
    DIS_BRM1_90: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_BRM1_90,
    "DIS_CM-802AKG": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_CM_802AKG,
    "DIS_C-701IR": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_C_701IR,
    "DIS_C-701T": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_C_701T,
    "DIS_C-802AK": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_C_802AK,
    DIS_GB6: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GB6,
    DIS_GB6_HE: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GB6_HE,
    DIS_GB6_TSP: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GB6_TSP,
    DIS_GBU_10: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GBU_10,
    DIS_GBU_12: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GBU_12,
    DIS_GBU_12_DUAL_GDJ_II19_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GBU_12_DUAL_GDJ_II19_L,
    DIS_GBU_12_DUAL_GDJ_II19_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GBU_12_DUAL_GDJ_II19_R,
    DIS_GBU_16: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_GBU_16,
    DIS_LAU68_MK5_DUAL_GDJ_II19_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_LAU68_MK5_DUAL_GDJ_II19_L,
    DIS_LAU68_MK5_DUAL_GDJ_II19_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_LAU68_MK5_DUAL_GDJ_II19_R,
    "DIS_LD-10": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_LD_10,
    "DIS_LD-10_DUAL_L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_LD_10_DUAL_L,
    "DIS_LD-10_DUAL_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_LD_10_DUAL_R,
    DIS_LS_6_500: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_LS_6_500,
    DIS_MK_20: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_MK_20,
    DIS_MK_20_DUAL_GDJ_II19_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_MK_20_DUAL_GDJ_II19_L,
    DIS_MK_20_DUAL_GDJ_II19_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_MK_20_DUAL_GDJ_II19_R,
    DIS_MK_82S_DUAL_GDJ_II19_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_MK_82S_DUAL_GDJ_II19_L,
    DIS_MK_82S_DUAL_GDJ_II19_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_MK_82S_DUAL_GDJ_II19_R,
    DIS_MK_82_DUAL_GDJ_II19_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_MK_82_DUAL_GDJ_II19_L,
    DIS_MK_82_DUAL_GDJ_II19_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_MK_82_DUAL_GDJ_II19_R,
    "DIS_PL-12": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_PL_12,
    "DIS_PL-5EII": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_PL_5EII,
    "DIS_PL-5EII_TIP": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_PL_5EII_TIP,
    "DIS_PL-8A": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_PL_8A,
    "DIS_PL-8B": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_PL_8B,
    DIS_RKT_90_UG: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_RKT_90_UG,
    "DIS_SD-10": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SD_10,
    "DIS_SD-10_DUAL_L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SD_10_DUAL_L,
    "DIS_SD-10_DUAL_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SD_10_DUAL_R,
    DIS_SMOKE_GENERATOR_B: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SMOKE_GENERATOR_B,
    DIS_SMOKE_GENERATOR_G: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SMOKE_GENERATOR_G,
    DIS_SMOKE_GENERATOR_O: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SMOKE_GENERATOR_O,
    DIS_SMOKE_GENERATOR_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SMOKE_GENERATOR_R,
    DIS_SMOKE_GENERATOR_W: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SMOKE_GENERATOR_W,
    DIS_SMOKE_GENERATOR_Y: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SMOKE_GENERATOR_Y,
    DIS_SPJ_POD: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_SPJ_POD,
    DIS_TANK1100: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_TANK1100,
    DIS_TANK800: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_TANK800,
    DIS_TYPE200: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_TYPE200,
    DIS_TYPE200_DUAL_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_TYPE200_DUAL_L,
    DIS_TYPE200_DUAL_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_TYPE200_DUAL_R,
    DIS_WMD7: (0, $e56653165fb50b77$export$2e2bcd8739ae039).DIS_WMD7,
    "{DWS39_MJ1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DWS39_MJ1,
    "{DWS39_MJ1_MJ2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DWS39_MJ1_MJ2,
    "{DWS39_MJ2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).DWS39_MJ2,
    "{Eclair}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Eclair,
    ER_4_SC50: (0, $e56653165fb50b77$export$2e2bcd8739ae039).ER_4_SC50,
    "{0519A261-0AB6-11d6-9193-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ETHER,
    FAB_100M: (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_100M,
    "{FAB-100-4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_100_x_4,
    "{FB3CE165-BF07-4979-887C-92B87F13276B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_100___100kg_GP_Bomb_LD,
    "{40AA4ABE-D6EB-4CD6-AEFE-A1A0477B24AB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_1500_M_54___1500kg_GP_Bomb_LD,
    "{FAB-250-M54}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_250_M54,
    "{FAB-250-M54-TU}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_250_M54_TU,
    "{3C612111-C7AD-476E-8A8E-2485812F4E5C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_250___250kg_GP_Bomb_LD,
    FAB_50: (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_50,
    "{FAB-500-M54}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_500_M54,
    "{FAB-500-M54-TU}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_500_M54_TU,
    "{37DCC01E-9E02-432F-B61D-10C166CA2798}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_500_M_62___500kg_GP_Bomb_LD,
    "{FAB-500-SL}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_500_SL,
    "{FAB-500-TA}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FAB_500_TA,
    FIM_92: (0, $e56653165fb50b77$export$2e2bcd8739ae039).FIM_92,
    "{FPU_8A_FUEL_TANK}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).FPU_8A_Fuel_Tank_330_gallons,
    "{PTB_120_F86F35}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_120_gallons,
    "{PTB_150L_L39}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_150_liters,
    "{PTB_200_F86F35}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_200_gallons,
    "{PTB_350L_L39}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_350_liters,
    "{PTB_490C_MIG21}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_490_L_Central__21_,
    "{PTB_490_MIG21}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_490_L__21_,
    "{PTB_800_MIG21}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_800_L__21_,
    Fuel_Tank_FT600: (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_Tank_FT600,
    "{414E383A-59EB-41BC-8566-2B5E0788ED1F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_1150L,
    "{C0FF4842-FBAC-11d5-9190-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_1150L_MiG_29,
    "{2BEC576B-CDF5-4B7F-961F-B0FA4312B841}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_1400L,
    "{16602053-4A12-40A2-B214-AB60D481B20E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_2000L,
    "{7D7EC917-05F6-49D4-8045-61FC587DD019}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_3000L,
    "{8A0BE8AE-58D4-4572-9263-3144C0D06364}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_300_gal,
    "{F14-300gal}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_300_gal_,
    "{F14-300gal-empty}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_300_gal__empty_,
    "{EFEC8200-B922-11d7-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_330_gal,
    "{EFEC8201-B922-11d7-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_330_gal_,
    "{82364E69-5564-4043-A866-E13032926C3E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_367_gal,
    "{F376DBEE-4CAE-41BA-ADD9-B2910AC95DEC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_370_gal,
    "{0855A3A1-FA50-4C89-BDBB-5D5360ABA071}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_5000L,
    "{E1F29B21-F291-4589-9FD8-3272EEC69506}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_610_gal,
    "{A5BAEAB7-6FAF-4236-AF72-0FD900F493F9}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_800L,
    "{E8D4652F-FD48-45B7-BA5B-2AE05BB5A9CF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_800L_Wing,
    "{B99EE8A8-99BC-4a8d-89AC-A26831920DCE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_Ka_50,
    "{A504D93B-4E80-4B4F-A533-0D9B65F2C55F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Fuel_tank_S_3,
    FW109_FUEL_TANK: (0, $e56653165fb50b77$export$2e2bcd8739ae039).FW109_FUEL_TANK,
    "{8B9E3FD0-F034-4A07-B6CE-C269884CC71B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).F_4_Fuel_tank_C,
    "{7B4B122D-C12C-4DB4-834E-4D8BB4D863A8}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).F_4_Fuel_tank_W,
    "{PTB-150GAL}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).F_5_150Gal_Fuel_tank,
    "{0395076D-2F77-4420-9D33-087A4398130B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).F_5_275Gal_Fuel_tank,
    "{GAU_12_Equalizer}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GAU_12_Gunpod,
    "{BRU-32 GBU-10}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_10,
    "{51F9AAE5-964F-4D21-83FB-502E3BFE5F8A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_10___2000lb_Laser_Guided_Bomb,
    "{BRU-32 GBU-12}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_12,
    "{DB769D48-67D7-42ED-A2BE-108D566C8B1E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_12___500lb_Laser_Guided_Bomb,
    "{BRU-32 GBU-16}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_16,
    "{0D33DDAE-524F-4A4E-B5B8-621754FE3ADE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_16___1000lb_Laser_Guided_Bomb,
    "{BRU-32 GBU-24}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_24,
    "{34759BBC-AF1E-4AEE-A581-498FF7A6EBCE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_24_Paveway_III___2000lb_Laser_Guided_Bomb,
    "{GBU-24}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_24_Paveway_III___2000lb_Laser_Guided_Bomb_,
    "{EF0A9419-01D6-473B-99A3-BEBDB923B14D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_27___2000lb_Laser_Guided_Penetrator_Bomb,
    "{F06B775B-FC70-44B5-8A9F-5B5E2EB839C7}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_28___5000lb_Laser_Guided_Penetrator_Bomb,
    "GBU-31V3B*8": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_31V3B_8,
    "GBU-31*8": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_31_8,
    "{GBU-31}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_31_V_1_B___JDAM__2000lb_GPS_Guided_Bomb,
    "{GBU_31_V_2B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_31_V_2_B___JDAM__2000lb_GPS_Guided_Bomb,
    "{GBU-31V3B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_31_V_3_B___JDAM__2000lb_GPS_Guided_Penetrator_Bomb,
    "{GBU_31_V_4B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_31_V_4_B___JDAM__2000lb_GPS_Guided_Penetrator_Bomb,
    "{GBU_32_V_2B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_32_V_2_B___JDAM__1000lb_GPS_Guided_Bomb,
    "GBU-38*16": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_38_16,
    "{GBU-38}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_38___JDAM__500lb_GPS_Guided_Bomb,
    "{GBU_54_V_1B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).GBU_54B___LJDAM__500lb_Laser__GPS_Guided_Bomb_LD,
    GUV_VOG: (0, $e56653165fb50b77$export$2e2bcd8739ae039).GUV_VOG,
    GUV_YakB_GSHP: (0, $e56653165fb50b77$export$2e2bcd8739ae039).GUV_YakB_GSHP,
    "{HOT3G}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).HOT3,
    "{HOT3D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).HOT3_,
    "{4CD2BB0F-5493-44EF-A927-9760350F7BA1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).HSAB_with_9_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets,
    "{696CFFC4-0BDE-42A8-BE4B-0BE3D9DD723C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).HSAB_with_9_x_Mk_83___1000lb_GP_Bombs_LD,
    "{HVAR_SMOKE_2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).HVAR_SMOKE__UnGd_Rkt,
    "{HVAR_SMOKE_GENERATOR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).HVAR_Smoke_Generator,
    "{HVAR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).HVAR__UnGd_Rkt,
    I16_DROP_FUEL_TANK: (0, $e56653165fb50b77$export$2e2bcd8739ae039).I16_DROP_FUEL_TANK,
    I16_FAB_100SV: (0, $e56653165fb50b77$export$2e2bcd8739ae039).I16_FAB_100SV,
    I16_RS_82: (0, $e56653165fb50b77$export$2e2bcd8739ae039).I16_RS_82,
    "{IAB-500}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).IAB_500,
    "{IR_Deflector}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).IR_Deflector,
    "{KAB_1500Kr_LOADOUT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KAB_1500Kr___1500kg_TV_Guided_Bomb,
    "{KAB_1500LG_LOADOUT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KAB_1500LG_Pr___1500kg_Laser_Guided_Penetrator_Bomb,
    "{39821727-F6E2-45B3-B1F0-490CC8921D1E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KAB_1500L___1500kg_Laser_Guided_Bomb,
    "{E2C426E3-8B10-4E09-B733-9CDC26520F48}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KAB_500Kr___500kg_TV_Guided_Bomb,
    "{BA565F89-2373-4A84-9502-A0E017D3A44A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KAB_500LG___500kg_Laser_Guided_Bomb,
    "{KAB_500S_LOADOUT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KAB_500S___500kg_GPS_Guided_Bomb,
    "{KB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KB_Flare_Chaff_dispenser_pod,
    "{12429ECF-03F0-4DF6-BCBD-5D38B6343DE1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_22__AS_4_Kitchen____1000kg__AShM__IN__Act_Pas_Rdr,
    "{9F390892-E6F9-42C9-B84E-1136A881DCB2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_23L_Grom__AS_7_Kerry____286kg__ASM__Laser_Guided,
    "{6DADF342-D4BA-4D8A-B081-BA928C4AF86D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25ML__AS_10_Karen____300kg__ASM__Semi_Act_Laser,
    "{79D73885-0801-45a9-917F-C90FE1CE3DFC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25ML__AS_10_Karen____300kg__ASM__Semi_Act_Laser_,
    "{X-25ML}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25ML__AS_10_Karen____300kg__ASM__Semi_Act_Laser__,
    "{E86C5AA5-6D49-4F00-AD2E-79A62D6DDE26}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25MPU__Updated_AS_12_Kegler____320kg__ARM__IN__Pas_Rdr,
    "{752AF1D2-EBCC-4bd7-A1E7-2357F5601C70}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25MPU__Updated_AS_12_Kegler____320kg__ARM__IN__Pas_Rdr_,
    "{X-25MPU}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25MPU__Updated_AS_12_Kegler____320kg__ARM__IN__Pas_Rdr__,
    "{Kh-25MP}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25MP__AS_12_Kegler____320kg__ARM__Pas_Rdr,
    "{292960BB-6518-41AC-BADA-210D65D5073C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25MR__AS_10_Karen____300kg__ASM__10km__RC_Guided,
    "{X-25MR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_25MR__AS_10_Karen____300kg__ASM__RC_Guided,
    "{Kh-28}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_28__AS_9_Kyle____720kg__ARM__Pas_Rdr,
    "{3468C652-E830-4E73-AFA9-B5F260AB7C3D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_29L__AS_14_Kedge____657kg__ASM__Semi_Act_Laser,
    "{D4A8D9B9-5C45-42e7-BBD2-0E54F8308432}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_29L__AS_14_Kedge____657kg__ASM__Semi_Act_Laser_,
    "{X-29L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_29L__AS_14_Kedge____657kg__ASM__Semi_Act_Laser__,
    "{B4FC81C9-B861-4E87-BBDC-A1158E648EBF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_29T__AS_14_Kedge____670kg__ASM__TV_Guided,
    "{601C99F7-9AF3-4ed7-A565-F8B8EC0D7AAC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_29T__AS_14_Kedge____670kg__ASM__TV_Guided_,
    "{X-29T}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_29T__AS_14_Kedge____670kg__ASM__TV_Guided__,
    "{4D13E282-DF46-4B23-864A-A9423DFDE504}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_31A__AS_17_Krypton____610kg__AShM__IN__Act_Rdr,
    "{4D13E282-DF46-4B23-864A-A9423DFDE50A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_31A__AS_17_Krypton____610kg__AShM__IN__Act_Rdr_,
    "{X-31A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_31A__AS_17_Krypton____610kg__AShM__IN__Act_Rdr__,
    "{D8F2C90B-887B-4B9E-9FE2-996BC9E9AF03}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_31P__AS_17_Krypton____600kg__ARM__IN__Pas_Rdr,
    "{D8F2C90B-887B-4B9E-9FE2-996BC9E9AF0A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_31P__AS_17_Krypton____600kg__ARM__IN__Pas_Rdr_,
    "{X-31P}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_31P__AS_17_Krypton____600kg__ARM__IN__Pas_Rdr__,
    "{2234F529-1D57-4496-8BB0-0150F9BDBBD2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_35__AS_20_Kayak____520kg__AShM__IN__Act_Rdr,
    "{2234F529-1D57-4496-8BB0-0150F9BDBBD3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_35__AS_20_Kayak____520kg__AShM__IN__Act_Rdr_,
    "{3F26D9C5-5CC3-4E42-BC79-82FAA54E9F26}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_41__SS_N_22_Sunburn____4500kg__AShM__IN__Act_Rdr,
    "{FE382A68-8620-4AC0-BDF5-709BFE3977D7}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_58U__AS_11_Kilter____640kg__ARM__IN__Pas_Rdr,
    "{B5CA9846-776E-4230-B4FD-8BCC9BFB1676}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_58U__AS_11_Kilter____640kg__ARM__IN__Pas_Rdr_,
    "{40AB87E8-BEFB-4D85-90D9-B2753ACF9514}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_59M__AS_18_Kazoo____930kg__ASM__IN,
    "{BADAF2DE-68B5-472A-8AAC-35BAEFF6B4A1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_65__AS_15B_Kent____1250kg__ASM__IN__MCC,
    "{Kh-66_Grom}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kh_66_Grom__21__APU_68,
    "{96A7F676-F956-404A-AD04-F33FB2C74884}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KMGU_2___96_x_AO_2_5RT_Dispenser__CBU__HE_Frag,
    "{96A7F676-F956-404A-AD04-F33FB2C74881}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).KMGU_2___96_x_PTAB_2_5KO_Dispenser__CBU__HEAT_AP,
    KORD_12_7: (0, $e56653165fb50b77$export$2e2bcd8739ae039).KORD_12_7,
    "{F4920E62-A99A-11d8-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kopyo_radar_pod,
    "{7210496B-7B81-4B52-80D6-8529ECF847CD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Kormoran___ASM,
    "{K-13A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).K_13A,
    "{44EE8698-89F9-48EE-AF36-5FD31896A82F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).L005_Sorbtsiya_ECM_pod__left_,
    "{44EE8698-89F9-48EE-AF36-5FD31896A82A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).L005_Sorbtsiya_ECM_pod__right_,
    "{ECM_POD_L_175V}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).L175V_Khibiny_ECM_pod,
    "{F14-LANTIRN-TP}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LANTIRN_Targeting_Pod,
    LAU3_HE151: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU3_HE151,
    LAU3_HE5: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU3_HE5,
    LAU3_WP156: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU3_WP156,
    LAU3_WP1B: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU3_WP1B,
    LAU3_WP61: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU3_WP61,
    "LAU-105": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105,
    "LAU-105_1*AIM-9L_L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_1_AIM_9L_L,
    "LAU-105_1*AIM-9L_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_1_AIM_9L_R,
    "LAU-105_1*AIM-9M_L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_1_AIM_9M_L,
    "LAU-105_1*AIM-9M_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_1_AIM_9M_R,
    "LAU-105_1*CATM-9M_L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_1_CATM_9M_L,
    "LAU-105_1*CATM-9M_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_1_CATM_9M_R,
    "LAU-105_2*AIM-9L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_2_AIM_9L,
    "LAU-105_2*AIM-9P5": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_2_AIM_9P5,
    "LAU-105_2*CATM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_2_CATM_9M,
    "LAU-105_AIS_ASQ_T50_L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_AIS_ASQ_T50_L,
    "LAU-105_AIS_ASQ_T50_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_AIS_ASQ_T50_R,
    "{DB434044-F5D0-4F1F-9BA9-B73027E18DD3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_with_2_x_AIM_9M_Sidewinder_IR_AAM,
    "{3C0745ED-8B0B-42eb-B907-5BD5C1717447}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_105_with_2_x_AIM_9P_Sidewinder_IR_AAM,
    "{LAU_10R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_10R_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG,
    "{F3EFE0AB-E91A-42D8-9CA2-B63C91ED570A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_10_pod___4_x_127mm_ZUNI__UnGd_Rkts_Mk71__HE_FRAG,
    "{BRU42_LAU10}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_10___4_ZUNI_MK_71,
    "{BRU3242_LAU10}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_10___4_ZUNI_MK_71_,
    "{LAU-115 - AIM-7E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115C_with_AIM_7E_Sparrow_Semi_Active_Radar,
    "{LAU-115 - AIM-7F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115C_with_AIM_7F_Sparrow_Semi_Active_Radar,
    "{LAU-115 - AIM-7H}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115C_with_AIM_7MH_Sparrow_Semi_Active_Radar,
    "LAU-115_2*LAU-127_AIM-120B": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_2_LAU_127_AIM_120B,
    "LAU-115_2*LAU-127_AIM-120C": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_2_LAU_127_AIM_120C,
    "LAU-115_2*LAU-127_AIM-9L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_2_LAU_127_AIM_9L,
    "LAU-115_2*LAU-127_AIM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_2_LAU_127_AIM_9M,
    "LAU-115_2*LAU-127_AIM-9X": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_2_LAU_127_AIM_9X,
    "LAU-115_2*LAU-127_CATM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_2_LAU_127_CATM_9M,
    "LAU-115_LAU-127_AIM-9L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_AIM_9L,
    "LAU-115_LAU-127_AIM-9L_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_AIM_9L_R,
    "LAU-115_LAU-127_AIM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_AIM_9M,
    "LAU-115_LAU-127_AIM-9M_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_AIM_9M_R,
    "LAU-115_LAU-127_AIM-9X": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_AIM_9X,
    "LAU-115_LAU-127_AIM-9X_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_AIM_9X_R,
    "LAU-115_LAU-127_CATM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_CATM_9M,
    "LAU-115_LAU-127_CATM-9M_R": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_LAU_127_CATM_9M_R,
    "{LAU-115 - AIM-120B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_with_1_x_LAU_127_AIM_120B_AMRAAM___Active_Rdr_AAM,
    "{LAU-115 - AIM-120B_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_with_1_x_LAU_127_AIM_120B_AMRAAM___Active_Rdr_AAM_,
    "{LAU-115 - AIM-120C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_with_1_x_LAU_127_AIM_120C_5_AMRAAM___Active_Rdr_AAM,
    "{LAU-115 - AIM-120C_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_with_1_x_LAU_127_AIM_120C_5_AMRAAM___Active_Rdr_AAM_,
    "{LAU-115 - AIM-7M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_115_with_AIM_7M_Sparrow_Semi_Active_Radar,
    LAU_117_AGM_65A: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_AGM_65A,
    LAU_117_AGM_65B: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_AGM_65B,
    LAU_117_AGM_65F: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_AGM_65F,
    LAU_117_AGM_65G: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_AGM_65G,
    LAU_117_AGM_65H: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_AGM_65H,
    LAU_117_AGM_65L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_AGM_65L,
    LAU_117_CATM_65K: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_CATM_65K,
    LAU_117_TGM_65D: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_TGM_65D,
    LAU_117_TGM_65G: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_TGM_65G,
    LAU_117_TGM_65H: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_TGM_65H,
    "{444BA8AE-82A7-4345-842E-76154EFCCA46}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_with_AGM_65D___Maverick_D__IIR_ASM_,
    "{F16A4DE0-116C-4A71-97F0-2CF85B0313EC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_with_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_,
    "{69DC8AE7-8F77-427B-B8AA-B19D3F478B66}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_117_with_AGM_65K___Maverick_K__CCD_Imp_ASM_,
    "{3E6B632D-65EB-44D2-9501-1C2D04515405}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_118a_with_AGM_45B_Shrike_ARM__Imp_,
    "LAU-127_AIM-9L": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_127_AIM_9L,
    "LAU-127_AIM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_127_AIM_9M,
    "LAU-127_AIM-9X": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_127_AIM_9X,
    "LAU-127_CATM-9M": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_127_CATM_9M,
    LAU_131x3_HYDRA_70_M151: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_M151,
    LAU_131x3_HYDRA_70_M156: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_M156,
    LAU_131x3_HYDRA_70_M257: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_M257,
    LAU_131x3_HYDRA_70_M274: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_M274,
    LAU_131x3_HYDRA_70_MK1: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_MK1,
    LAU_131x3_HYDRA_70_MK5: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_MK5,
    LAU_131x3_HYDRA_70_MK61: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_MK61,
    LAU_131x3_HYDRA_70_WTU1B: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131x3_HYDRA_70_WTU1B,
    "{LAU-131 - 7 AGR-20A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__Laser_Guided_Rkts_M151__HE_APKWS,
    "{LAU-131 - 7 AGR-20 M282}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__Laser_Guided_Rkts_M282__MPP_APKWS,
    "{69926055-0DA8-4530-9F2F-C86B157EA9F6}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{2AF2EC3F-9065-4de5-93E1-1739C9A71EF7}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos,
    "{DAD45FE5-CFF0-4a2b-99D4-5D044D3BC22F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M257__Para_Illum,
    "{6D6D5C07-2A90-4a68-9A74-C5D0CFFB05D9}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_M274__Practice_Smk,
    "{D22C2D63-E5C9-4247-94FB-5E8F3DE22B71}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk1__Practice,
    "{319293F2-392C-4617-8315-7C88C22AF7C4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT,
    "{1CA5E00B-D545-4ff9-9B53-5970E292F14D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk61__Practice,
    "{DDCE7D70-5313-4181-8977-F11018681662}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_131_pod___7_x_2_75_Hydra__UnGd_Rkts_WTU_1_B__Practice,
    "{LAU-138 wtip - AIM-9L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_138_AIM_9L,
    "{LAU-138 wtip - AIM-9M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_138_AIM_9M,
    "{LAU3_FFAR_WP156}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_3_pod___19_x_2_75_FFAR__UnGd_Rkts_M156__Wht_Phos,
    "{LAU3_FFAR_MK1HE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_3_pod___19_x_2_75_FFAR__UnGd_Rkts_Mk1__HE,
    "{LAU3_FFAR_MK5HEAT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_3_pod___19_x_2_75_FFAR__UnGd_Rkts_Mk5__HEAT,
    "{LAU_61R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_61R_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{FD90A1DC-9147-49FA-BF56-CB83EF0BD32B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{3DFB7321-AB0E-11d7-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_61_pod___19_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos,
    "{LAU68_FFAR_WP156}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_FFAR__UnGd_Rkts_M156__Wht_Phos,
    "{LAU68_FFAR_MK1HE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_FFAR__UnGd_Rkts_Mk1__HE,
    "{LAU68_FFAR_MK5HEAT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_FFAR__UnGd_Rkts_Mk5__HEAT,
    "{A021F29D-18AB-4d3e-985C-FC9C60E35E9E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "{4F977A2A-CD25-44df-90EF-164BFA2AE72F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M156__Wht_Phos,
    "{647C5F26-BDD1-41e6-A371-8DE1E4CC0E94}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M257__Para_Illum,
    "{0877B74B-5A00-4e61-BA8A-A56450BA9E27}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_M274__Practice_Smk,
    "{FC85D2ED-501A-48ce-9863-49D468DDD5FC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk1__Practice,
    "{174C6E6D-0C3D-42ff-BCB3-0853CB371F5C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk5__HEAT,
    "{65396399-9F5C-4ec3-A7D2-5A8F4C1D90C4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_Mk61__Practice,
    "{1F7136CB-8120-4e77-B97B-945FF01FB67C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_68_pod___7_x_2_75_Hydra__UnGd_Rkts_WTU_1_B__Practice,
    "{LAU-7 - AIM-9L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_AIM_9L,
    "{LAU-7 - AIM-9M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_AIM_9M,
    "{F4-2-AIM9B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_2_x_AIM_9B_Sidewinder_IR_AAM,
    "{F4-2-AIM9L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_2_x_AIM_9L_Sidewinder_IR_AAM,
    "{9DDF5297-94B9-42FC-A45E-6E316121CD85}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_2_x_AIM_9M_Sidewinder_IR_AAM,
    "{F4-2-AIM9P5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_2_x_AIM_9P5_Sidewinder_IR_AAM,
    "{773675AB-7C29-422f-AFD8-32844A7B7F17}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_2_x_AIM_9P_Sidewinder_IR_AAM,
    "{GAR-8}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_AIM_9B_Sidewinder_IR_AAM,
    "{AIM-9M-ON-ADAPTER}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_AIM_9M_Sidewinder_IR_AAM,
    "{AIM-9P5-ON-ADAPTER}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_AIM_9P5_Sidewinder_IR_AAM,
    "{AIM-9P-ON-ADAPTER}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_AIM_9P_Sidewinder_IR_AAM,
    "{AIM-9X-ON-ADAPTER}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_AIM_9X_Sidewinder_IR_AAM,
    "{LAU-7_AIS_ASQ_T50}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_7_with_AN_ASQ_T50_TCTS_Pod___ACMI_Pod,
    LAU_88_AGM_65D_ONE: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_AGM_65D_ONE,
    LAU_88_AGM_65H: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_AGM_65H,
    LAU_88_AGM_65H_2_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_AGM_65H_2_L,
    LAU_88_AGM_65H_2_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_AGM_65H_2_R,
    LAU_88_AGM_65H_3: (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_AGM_65H_3,
    "{E6A6262A-CA08-4B3D-B030-E1A993B98452}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_2_x_AGM_65D___Maverick_D__IIR_ASM_,
    "{E6A6262A-CA08-4B3D-B030-E1A993B98453}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_2_x_AGM_65D___Maverick_D__IIR_ASM__,
    "{2CC29C7A-E863-411C-8A6E-BD6F0E730548}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_2_x_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_,
    "{2CC29C7A-E863-411C-8A6E-BD6F0E730547}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_2_x_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd__,
    "{D7670BC7-881B-4094-906C-73879CF7EB28}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_2_x_AGM_65K___Maverick_K__CCD_Imp_ASM_,
    "{D7670BC7-881B-4094-906C-73879CF7EB27}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_2_x_AGM_65K___Maverick_K__CCD_Imp_ASM__,
    "{DAC53A2F-79CA-42FF-A77A-F5649B601308}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_3_x_AGM_65D___Maverick_D__IIR_ASM_,
    "{71AAB9B8-81C1-4925-BE50-1EF8E9899271}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_3_x_AGM_65E___Maverick_E__Laser_ASM___Lg_Whd_,
    "{907D835F-E650-4154-BAFD-C656882555C0}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_88_with_3_x_AGM_65K___Maverick_K__CCD_Imp_ASM_,
    "{LAU_SNEB68G}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_SNEB68G___8xSNEB68_EAP,
    "{LAU_SNEB68_WP}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).LAU_SNEB68G___8xSNEB68_WP,
    "{CAAC1CFD-6745-416B-AFA4-CB57414856D0}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Lantirn_F_16,
    "{D1744B93-2A8A-4C4D-B004-7A09CD8C8F3F}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Lantirn_Target_Pod,
    "{0519A264-0AB6-11d6-9193-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).L_081_Fantasmagoria_ELINT_pod,
    "{US_M10_SMOKE_TANK_BLUE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M10_Smoke_Tank___blue,
    "{US_M10_SMOKE_TANK_GREEN}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M10_Smoke_Tank___green,
    "{US_M10_SMOKE_TANK_ORANGE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M10_Smoke_Tank___orange,
    "{US_M10_SMOKE_TANK_RED}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M10_Smoke_Tank___red,
    "{US_M10_SMOKE_TANK_WHITE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M10_Smoke_Tank___white,
    "{US_M10_SMOKE_TANK_YELLOW}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M10_Smoke_Tank___yellow,
    "{00F5DAC4-0466-4122-998F-B1A298E34113}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M117___750lb_GP_Bomb_LD,
    M134_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M134_L,
    M134_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M134_R,
    M134_SIDE_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M134_SIDE_L,
    M134_SIDE_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M134_SIDE_R,
    "{414DA830-B61A-4F9E-B71B-C2F6832E1D7A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).M2000_Fuel_tank,
    M260_HYDRA: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M260_HYDRA,
    M260_HYDRA_WP: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M260_HYDRA_WP,
    M261_MK151: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M261_MK151,
    M261_MK156: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M261_MK156,
    M60_SIDE_L: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M60_SIDE_L,
    M60_SIDE_R: (0, $e56653165fb50b77$export$2e2bcd8739ae039).M60_SIDE_R,
    "{MAK79_MK20 2L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_2_MK_20,
    "{MAK79_MK20 2R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_2_MK_20_,
    "{MAK79_BDU33 3L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_BDU_33,
    "{MAK79_BDU33 3R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_BDU_33_,
    "{MAK79_MK81 3L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_81,
    "{MAK79_MK81 3R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_81_,
    "{MAK79_MK82 3L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_82,
    "{MAK79_MK82AIR 3L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_82AIR,
    "{MAK79_MK82AIR 3R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_82AIR_,
    "{MAK79_MK82 3R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_82_,
    "{MAK79_MK82SE 3L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_82_SnakeEye,
    "{MAK79_MK82SE 3R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_82_SnakeEye_,
    "{MAK79_MK83 3L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_83,
    "{MAK79_MK83 3R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_3_Mk_83_,
    "{MAK79_BDU33 4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_4_BDU_33,
    "{MAK79_MK81 4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_4_Mk_81,
    "{MAK79_MK82 4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_4_Mk_82,
    "{MAK79_MK82AIR 4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_4_Mk_82AIR,
    "{MAK79_MK82SE 4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_4_Mk_82_SnakeEye,
    "{MAK79_MK20 1R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_MK_20,
    "{MAK79_MK20 1L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_MK_20_,
    "{MAK79_MK83 1R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_Mk_83,
    "{MAK79_MK83 1L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MAK79_Mk_83_,
    "{MMagicII}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Matra_Magic_II,
    "{Matra_S530D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Matra_Super_530D,
    "{Matra155RocketPod}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Matra_Type_155_Rocket_Pod,
    "{5A1AC2B4-CA4B-4D09-A1AF-AC52FBC4B60B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD2_67U_with_4_x_FAB_100___100kg_GP_Bombs_LD,
    "{29A828E2-C6BB-11d8-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD2_67U_with_4_x_FAB_100___100kg_GP_Bombs_LD_,
    "{7C5F0F5F-0A0B-46E8-937C-8922303E39A8}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U2T_with_2_x_FAB_1500_M_54___1500kg_GP_Bombs_LD,
    "{6A367BB4-327F-4A04-8D9E-6D86BDC98E7E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U4T_with_4_x_FAB_250___250kg_GP_Bombs_LD,
    "{02B81892-7E24-4795-84F9-B8110C641AF0}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U4T_with_4_x_RBK_250___42_x_PTAB_2_5M__250kg_CBUs_Medium_HEAT_AP,
    "{E659C4BE-2CD8-4472-8C08-3F28ACB61A8A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_2_x_FAB_250___250kg_GP_Bombs_LD,
    "{MBD3_U6_3*FAB-250_fwd}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_3_x_FAB_250___250kg_GP_Bombs_LD,
    "{3E35F8C1-052D-11d6-9191-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_4_x_FAB_250___250kg_GP_Bombs_LD,
    "{MBD3_U6_4*FAB-250_fwd}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_4_x_FAB_250___250kg_GP_Bombs_LD_,
    "{MBD3_U6_5*FAB-250}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_5_x_FAB_250___250kg_GP_Bombs_LD,
    "{E96E1EDD-FF3F-47CF-A959-576C3B682955}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_BetAB_500ShP___500kg_Concrete_Piercing_HD_w_booster_Bombs,
    "{436C6FB9-8BF2-46B6-9DC4-F55ABF3CD1EC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD,
    "{F99BEC1A-869D-4AC7-9730-FBA0E3B1F5FC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_FAB_100___100kg_GP_Bombs_LD,
    "{53BE25A4-C86C-4571-9BC0-47D668349595}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_FAB_250___250kg_GP_Bombs_LD,
    "{FA673F4C-D9E4-4993-AA7A-019A92F3C005}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_FAB_500_M_62___500kg_GP_Bombs_LD,
    "{0D945D78-542C-4E9B-9A17-9B5008CC8D39}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_FAB_500_M_62___500kg_GP_Bombs_LD_,
    "{F503C276-FE15-4C54-B310-17B50B735A84}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_RBK_500_255___30_x_PTAB_10_5__500kg_CBUs_Heavy_HEAT_AP,
    "{4D459A95-59C0-462F-8A57-34E80697F38B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U6_68_with_6_x_RBK_500_255___30_x_PTAB_10_5__500kg_CBUs_Heavy_HEAT_AP_,
    "{5F1C54C0-0ABD-4868-A883-B52FF9FCB422}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U9M_with_9_x_FAB_100___100kg_GP_Bombs_LD,
    "{E1AAE713-5FC3-4CAA-9FF5-3FDCFB899E33}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U9M_with_9_x_FAB_250___250kg_GP_Bombs_LD,
    "{BF83E8FD-E7A2-40D2-9608-42E13AFE2193}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_U9M_with_9_x_RBK_250___42_x_PTAB_2_5M__250kg_CBUs_Medium_HEAT_AP,
    "{005E70F5-C3EA-4E95-A148-C1044C42D845}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_with_3_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD,
    "{CEE04106-B9AA-46B4-9CD1-CD3FDCF0CE78}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_with_3_x_FAB_100___100kg_GP_Bombs_LD,
    "{D109EE9C-A1B7-4F1C-8D87-631C293A1D26}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_with_3_x_FAB_250___250kg_GP_Bombs_LD,
    "{A1E85991-B58E-4E92-AE91-DED6DC85B2E7}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_with_3_x_FAB_500_M_62___500kg_GP_Bombs_LD,
    "{EAD9B2C1-F3BA-4A7B-A2A5-84E2AF8A1975}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_with_3_x_RBK_250___42_x_PTAB_2_5M__250kg_CBUs_Medium_HEAT_AP,
    "{919CE839-9390-4629-BAF7-229DE19B8523}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MBD3_with_3_x_RBK_500_255___30_x_PTAB_10_5__500kg_CBUs_Heavy_HEAT_AP,
    "{574EDEDF-20DE-4942-B2A2-B2EDFD621562}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER12_with_12_x_M117___750lb_GP_Bombs_LD,
    "{585D626E-7F42-4073-AB70-41E728C333E2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER12_with_12_x_Mk_82___500lb_GP_Bombs_LD,
    "{0B9ABA77-93B8-45FC-9C63-82AFB2CB50A4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER2_with_2_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets,
    "{D5D51E24-348C-4702-96AF-97A714E72697}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER2_with_2_x_Mk_82___500lb_GP_Bombs_LD,
    "{18617C93-78E7-4359-A8CE-D754103EDF63}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER2_with_2_x_Mk_83___1000lb_GP_Bombs_LD,
    "{82F90BEC-0E2E-4CE5-A66E-1E4ADA2B5D1E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER3_with_3_x_M117___750lb_GP_Bombs_LD,
    "{752B9782-F962-11d5-9190-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER6_with_6_x_BLU_107___440lb_Anti_Runway_Penetrator_Bombs,
    "{6CDB6B36-7165-47D0-889F-6625FB333561}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER6_with_6_x_M117___750lb_GP_Bombs_LD,
    "{3C7CD675-7D39-41C5-8735-0F4F537818A8}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER6_with_6_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets,
    "{1C97B4A0-AA3B-43A8-8EE7-D11071457185}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MER6_with_6_x_Mk_82___500lb_GP_Bombs_LD,
    "{B1EF6B0E-3D91-4047-A7A5-A99E7D8B4A8B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mercury_LLTV_Pod,
    "{0DA03783-61E4-40B2-8FAE-6AEE0A5C5AAE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MICA_IR,
    "{6D778860-7BB8-4ACB-9E95-BA772C6BBC2C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MICA_RF,
    MIM_104: (0, $e56653165fb50b77$export$2e2bcd8739ae039).MIM_104,
    MIM_72: (0, $e56653165fb50b77$export$2e2bcd8739ae039).MIM_72,
    "{MBDA_MistralG}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mistral,
    "{MBDA_MistralD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mistral_,
    "MK_82*28": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MK_82_28,
    "{BRU-32 MK-20}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_20,
    "{ACADB374-6D6C-45A0-BA7C-B22B2E108AE4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_20_18,
    "{ADD3FAE1-EBF6-4EF9-8EFC-B36B5DDF1E6B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_20_Rockeye___490lbs_CBU__247_x_HEAT_Bomblets,
    "{90321C8E-7ED1-47D4-A160-E074D5ABD902}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_81___250lb_GP_Bomb_LD,
    "{BRU-32 MK-82}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82,
    "{BRU-32 MK-82AIR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82AIR,
    "{Mk_82B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82B,
    "{Mk_82BT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82BT,
    "{Mk_82P}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82P,
    "{Mk_82PT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82PT,
    "{Mk_82SB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82SB,
    "{Mk_82SP}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82SP,
    "{Mk_82YT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82YT,
    "{Mk_82Y}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82Y___500lb_GP_Chute_Retarded_HD,
    "{Mk82AIR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82_AIR_Ballute___500lb_GP_Bomb_HD,
    "{BRU-32 MK-82SE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82_SnakeEye,
    "{Mk82SNAKEYE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82_Snakeye___500lb_GP_Bomb_HD,
    "{BCE4E030-38E9-423E-98ED-24BE3DA87C32}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_82___500lb_GP_Bomb_LD,
    "{BRU-32 MK-83}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83,
    "{Mk_83BT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83BT,
    "{Mk_83CT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83CT,
    "{Mk_83P}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83P,
    "{Mk_83PT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83PT,
    "{BRU42_MK83 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83_,
    "{BRU3242_MK83 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83__,
    "{PHXBRU3242_MK83 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83___,
    "{7A44FF09-527C-4B7E-B42B-3F111CFE50FB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83___1000lb_GP_Bomb_LD,
    "{BRU42_MK83 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83____,
    "{BRU3242_MK83 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83_____,
    "{PHXBRU3242_MK83 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_83______,
    "{BRU-32 MK-84}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_84,
    "{Mk_84P}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_84P,
    "{Mk_84T}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_84T,
    "{F092B80C-BB54-477E-9408-66DEEF740008}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_84_18,
    "{D3ABF208-FA56-4D56-BB31-E0D931D57AE3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_84_28,
    "{AB8B8299-F1CC-4359-89B5-2172E0CF4A5A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Mk_84___2000lb_GP_Bomb_LD,
    "{44EE8698-89F9-48EE-AF36-5FD31896A82D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MPS_410,
    "{44EE8698-89F9-48EE-AF36-5FD31896A82C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MPS_410_,
    "MXU-648-TP": (0, $e56653165fb50b77$export$2e2bcd8739ae039).MXU_648_TP,
    "{ODAB-500PM}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ODAB_500PM,
    "{OFAB-100-120-TU}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).OFAB_100_120_TU_x_4,
    "{OFAB_100_Jupiter}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).OFAB_100_Jupiter___100kg_GP_Bomb_LD,
    "{ORO57K_S5M1_HEFRAG}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ORO_57K___S_5M1_HE_FRAG_FFAR_x_8,
    "{ORO57K_S5MO_HEFRAG}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ORO_57K___S_5MO_HE_FRAG_FFAR_x_8,
    "{ORO57K_S5M_HEFRAG}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).ORO_57K___S_5M_x_8,
    "oh-58-brauning": (0, $e56653165fb50b77$export$2e2bcd8739ae039).oh_58_brauning,
    "{199D6D51-1764-497E-9AE5-7D07C8D4D87E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Pavetack_F_111,
    PKT_7_62: (0, $e56653165fb50b77$export$2e2bcd8739ae039).PKT_7_62,
    "{PK-3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).PK_3___7_62mm_GPMG,
    PTB300_MIG15: (0, $e56653165fb50b77$export$2e2bcd8739ae039).PTB300_MIG15,
    PTB400_MIG15: (0, $e56653165fb50b77$export$2e2bcd8739ae039).PTB400_MIG15,
    PTB400_MIG19: (0, $e56653165fb50b77$export$2e2bcd8739ae039).PTB400_MIG19,
    PTB600_MIG15: (0, $e56653165fb50b77$export$2e2bcd8739ae039).PTB600_MIG15,
    PTB760_MIG19: (0, $e56653165fb50b77$export$2e2bcd8739ae039).PTB760_MIG19,
    "{P-50T}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).P_50T___50kg_Practice_Bomb_LD,
    "{RBK_250_275_AO_1SCH}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RBK_250_275___150_x_AO_1SCh__250kg_CBU_HE_Frag,
    "{4203753F-8198-4E85-9924-6F8FF679F9FF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RBK_250___42_x_PTAB_2_5M__250kg_CBU_Medium_HEAT_AP,
    "{RBK_500U_OAB_2_5RT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RBK_500U___126_x_OAB_2_5RT__500kg_CBU_HE_Frag,
    "{D5435F26-F120-4FA3-9867-34ACE562EF1B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RBK_500_255___30_x_PTAB_10_5__500kg_CBU_Heavy_HEAT_AP,
    "{7AEC222D-C523-425e-B714-719C0D1EB14D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RBK_500___268_x_PTAB_1M__500kg_CBU_Light_HEAT_AP,
    "{Rb04AI}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RB_04E__for_A_I___with_launcher,
    "{Rb15AI}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RB_15F__for_A_I___with_launcher,
    "{Rb04}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_04E_Anti_ship_Missile,
    "{Robot05}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_05A_MCLOS_ASM_AShM_AAM,
    "{Rb15}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_15F_Programmable_Anti_ship_Missile,
    "{Robot24J}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_24J__AIM_9P__Sidewinder_IR_AAM,
    "{Robot24}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_24__AIM_9B__Sidewinder_IR_AAM,
    "{Robot74}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_74__AIM_9L__Sidewinder_IR_AAM,
    "{RB75}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_75A__AGM_65A_Maverick___TV_ASM_,
    "{RB75B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_75B__AGM_65B_Maverick___TV_ASM_,
    "{RB75T}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Rb_75T__AGM_65A_Maverick___TV_ASM_Lg_Whd_,
    REFLEX_9M119: (0, $e56653165fb50b77$export$2e2bcd8739ae039).REFLEX_9M119,
    "{RKL609_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RKL609_ECM_Pod__Left_,
    "{RKL609_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RKL609_ECM_Pod__Right_,
    "{RN-24}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RN_24,
    "{RN-28}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RN_28,
    ROLAND: (0, $e56653165fb50b77$export$2e2bcd8739ae039).ROLAND,
    "{M2KC_RPL_522}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RPL_522_1300_liters_Fuel_Tank,
    "{M2KC_RPL_522_EMPTY}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RPL_522_1300_liters_Fuel_Tank__Empty_,
    "{M2KC_02_RPL541}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RPL_541_2000_liters_Fuel_Tank_,
    "{M2KC_08_RPL541}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RPL_541_2000_liters_Fuel_Tank__,
    "{M2KC_02_RPL541_EMPTY}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RPL_541_2000_liters_Fuel_Tank__Empty_,
    "{M2KC_08_RPL541_EMPTY}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RPL_541_2000_liters_Fuel_Tank__Empty__,
    "{RS-2US}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).RS2US,
    "{R-13M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_13M,
    "{R-13M1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_13M1,
    "{CCF898C9-5BC7-49A4-9D1E-C3ED3D5166A1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_24R__AA_7_Apex_SA____Semi_Act_Rdr,
    "{6980735A-44CC-4BB9-A1B5-591532F1DC69}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_24T__AA_7_Apex_IR____Infra_Red,
    "{E8069896-8435-4B90-95C0-01A03AE6E400}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_27ER__AA_10_Alamo_C____Semi_Act_Extended_Range,
    "{B79C379A-9E87-4E50-A1EE-7F7E29C2E87A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_27ET__AA_10_Alamo_D____IR_Extended_Range,
    "{9B25D316-0434-4954-868F-D51DB1A38DF0}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_27R__AA_10_Alamo_A____Semi_Act_Rdr,
    "{88DAC840-9F75-4531-8689-B46E64E42E53}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_27T__AA_10_Alamo_B____Infra_Red,
    "{F1243568-8EF0-49D4-9CB5-4DA90D92BC1D}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_33__AA_9_Amos____Semi_Act_Rdr,
    "{R-3R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_3R,
    "{R-3S}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_3S,
    "{4EDBA993-2E34-444C-95FB-549300BF7CAF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_40R__AA_6_Acrid____Semi_Act_Rdr,
    "{5F26DBC2-FB43-4153-92DE-6BBCE26CB0FF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_40T__AA_6_Acrid____Infra_Red,
    "{R-55}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_55,
    "{FC23864E-3B80-48E3-9C03-4DA8B1D7497B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_550_Magic_2,
    "{R-60}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_60,
    "{R-60M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_60M,
    "{R-60M 2L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_60M_x_2,
    "{R-60M 2R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_60M_x_2_,
    "{682A481F-0CB5-4693-A382-D00DD4A156D7}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_60M__AA_8_Aphid____Infra_Red,
    "{R-60 2L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_60_x_2,
    "{R-60 2R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_60_x_2_,
    "{FBC29BFE-3D24-4C64-B81D-941239D12249}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_73__AA_11_Archer____Infra_Red,
    "{CBC29BFE-3D24-4C64-B81D-941239D12249}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_73__AA_11_Archer____Infra_Red_,
    "{B4C01D60-A8A3-4237-BD72-CA7655BC0FE9}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_77__AA_12_Adder____Active_Rdr,
    "{B4C01D60-A8A3-4237-BD72-CA7655BC0FEC}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).R_77__AA_12_Adder____Active_Rdr_,
    "{0511E528-EA28-4caf-A212-00D1408DF10A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SAB_100___100kg_flare_illumination_Bomb,
    "{FAS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Sand_Filter,
    "{SC_250_T1_L2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SC_250_Type_1_L2___250kg_GP_Bomb_LD,
    "{Schloss500XIIC1_SC_250_T3_J}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SC_250_Type_3_J___250kg_GP_Bomb_LD,
    "{SC_500_L2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SC_500_L2___500kg_GP_Bomb_LD,
    SC_501_SC250: (0, $e56653165fb50b77$export$2e2bcd8739ae039).SC_501_SC250,
    SC_501_SC500: (0, $e56653165fb50b77$export$2e2bcd8739ae039).SC_501_SC500,
    "{SC_50}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SC_50___50kg_GP_Bomb_LD,
    "{SD_250_Stg}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SD_250_Stg___250kg_GP_Bomb_LD,
    "{SD_500_A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SD_500_A___500kg_GP_Bomb_LD,
    SEASPARROW: (0, $e56653165fb50b77$export$2e2bcd8739ae039).SEASPARROW,
    "{1461CD18-429A-42A9-A21F-4C621ECD4573}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Sea_Eagle___ASM,
    "{0519A263-0AB6-11d6-9193-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Shpil_2_Laser_Recon__Intel_Pod,
    "{8C3F26A2-FA0F-11d5-9190-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Sky_Shadow_ECM_Pod,
    SM2: (0, $e56653165fb50b77$export$2e2bcd8739ae039).SM2,
    "{A4BCC903-06C8-47bb-9937-A30FEDB4E743}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smokewinder___blue,
    "{A4BCC903-06C8-47bb-9937-A30FEDB4E742}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smokewinder___green,
    "{A4BCC903-06C8-47bb-9937-A30FEDB4E746}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smokewinder___orange,
    "{A4BCC903-06C8-47bb-9937-A30FEDB4E741}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smokewinder___red,
    "{A4BCC903-06C8-47bb-9937-A30FEDB4E744}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smokewinder___white,
    "{A4BCC903-06C8-47bb-9937-A30FEDB4E745}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smokewinder___yellow,
    "{CE2_SMOKE_WHITE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_for_Christen_Eagle_II__white,
    "{D3F65166-1AB8-490f-AF2F-2FB6E22568B3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___blue,
    "{INV-SMOKE-BLUE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___blue_,
    "{D3F65166-1AB8-490f-AF2F-2FB6E22568B2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___green,
    "{INV-SMOKE-GREEN}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___green_,
    "{D3F65166-1AB8-490f-AF2F-2FB6E22568B6}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___orange,
    "{INV-SMOKE-ORANGE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___orange_,
    "{D3F65166-1AB8-490f-AF2F-2FB6E22568B1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___red,
    "{INV-SMOKE-RED}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___red_,
    "{D3F65166-1AB8-490f-AF2F-2FB6E22568B4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___white,
    "{INV-SMOKE-WHITE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___white_,
    "{D3F65166-1AB8-490f-AF2F-2FB6E22568B5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___yellow,
    "{INV-SMOKE-YELLOW}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_Generator___yellow_,
    "{SMOKE-RED-AVIOJET}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_System_red_colorant,
    "{SMOKE-YELLOW-AVIOJET}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_System_yellow_colorant,
    "{SMOKE-SYSTEM-AVIOJET}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke_System__White_Smoke_,
    "{MIG21_SMOKE_RED}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke___red___21__t,
    "{SMOKE_WHITE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke___white___21,
    "{MIG21_SMOKE_WHITE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Smoke___white___21_,
    SPITFIRE_45GAL_SLIPPER_TANK: (0, $e56653165fb50b77$export$2e2bcd8739ae039).SPITFIRE_45GAL_SLIPPER_TANK,
    SPITFIRE_45GAL_TORPEDO_TANK: (0, $e56653165fb50b77$export$2e2bcd8739ae039).SPITFIRE_45GAL_TORPEDO_TANK,
    "{E92CBFE5-C153-11d8-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SPPU_22_1___2_x_23mm__GSh_23L_Autocannon_Pod,
    "{SPRD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SPRD_99,
    "{SPS-141-100}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SPS_141_100__21_,
    "{F75187EF-1D9E-4DA9-84B4-1A1A14A3973A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SPS_141___ECM_Jamming_Pod,
    "{CAE48299-A294-4bad-8EE6-89EFC5DCDF00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SUU_25_x_8_LUU_2___Target_Marker_Flares,
    "{BRU42_SUU25}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SUU_25___8_LUU_2,
    "{BRU3242_SUU25}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).SUU_25___8_LUU_2_,
    "{FD21B13E-57F3-4C2A-9F78-C522D0B5BCE1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Super_530D,
    SVIR_9M119: (0, $e56653165fb50b77$export$2e2bcd8739ae039).SVIR_9M119,
    "{S-24A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).S_24A__21_,
    "{S-24B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).S_24B__21_,
    "{1FA14DEA-8CDB-45AD-88A8-EC068DF1E65A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).S_24B___240mm_UnGd_Rkt__235kg__HE_Frag___Low_Smk_,
    "{3858707D-F5D5-4bbb-BDD8-ABB0530EBC7C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).S_24B___240mm_UnGd_Rkt__235kg__HE_Frag___Low_Smk__,
    "{0180F983-C14A-11d8-9897-000476191836}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).S_25L___320Kg__340mm_Laser_Guided_Rkt,
    "{A0648264-4BC0-4EE8-A543-D119F6BA4257}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).S_25_OFM___340mm_UnGd_Rkt__480kg_Penetrator,
    "{0519A262-0AB6-11d6-9193-00A0249B6F00}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Tangazh_ELINT_pod,
    "{TER_9A_2L*CBU-87}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_CBU_87___202_x_Anti_Armor_Skeet_SFW_Cluster_Bomb,
    "{TER_9A_2R*CBU-87}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_CBU_87___202_x_Anti_Armor_Skeet_SFW_Cluster_Bomb_,
    "{TER_9A_2L*CBU-97}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_CBU_97___10_x_Anti_Armor_Skeet_SFW_Cluster_Bomb,
    "{TER_9A_2R*CBU-97}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_CBU_97___10_x_Anti_Armor_Skeet_SFW_Cluster_Bomb_,
    "{TER_9A_2L*GBU-12}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_GBU_12___500lb_Laser_Guided_Bomb,
    "{TER_9A_2R*GBU-12}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_GBU_12___500lb_Laser_Guided_Bomb_,
    "{TER_9A_2L*MK-82AIR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_Mk_82_AIR_Ballute___500lb_GP_Bomb_HD,
    "{TER_9A_2R*MK-82AIR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_Mk_82_AIR_Ballute___500lb_GP_Bomb_HD_,
    "{TER_9A_2L*MK-82_Snakeye}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_Mk_82_Snakeye___500lb_GP_Bomb_HD,
    "{TER_9A_2R*MK-82_Snakeye}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_Mk_82_Snakeye___500lb_GP_Bomb_HD_,
    "{TER_9A_2L*MK-82}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_Mk_82___500lb_GP_Bomb_LD,
    "{TER_9A_2R*MK-82}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_2_x_Mk_82___500lb_GP_Bomb_LD_,
    "{TER_9A_3*BDU-33}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_3_x_BDU_33___25lb_Practice_Bomb_LD,
    "{TER_9A_3*CBU-87}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_3_x_CBU_87___202_x_Anti_Armor_Skeet_SFW_Cluster_Bomb,
    "{TER_9A_3*CBU-97}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_3_x_CBU_97___10_x_Anti_Armor_Skeet_SFW_Cluster_Bomb,
    "{TER_9A_3*MK-82AIR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_3_x_Mk_82_AIR_Ballute___500lb_GP_Bomb_HD,
    "{TER_9A_3*MK-82_Snakeye}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_3_x_Mk_82_Snakeye___500lb_GP_Bomb_HD,
    "{TER_9A_3*MK-82}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TER_9A_with_3_x_Mk_82___500lb_GP_Bomb_LD,
    TEST_ROTARY_LAUNCHER_MK82: (0, $e56653165fb50b77$export$2e2bcd8739ae039).TEST_ROTARY_LAUNCHER_MK82,
    TGM_65H: (0, $e56653165fb50b77$export$2e2bcd8739ae039).TGM_65H,
    "{EF124821-F9BB-4314-A153-E0E2FE1162C4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).TORNADO_Fuel_tank,
    TOW: (0, $e56653165fb50b77$export$2e2bcd8739ae039).TOW,
    "{U22A}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).U22_A_Jammer,
    "{UB-16-57UMP}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).UB_16UM_pod___16_x_S_5KO__57mm_UnGd_Rkts__HEAT_Frag,
    "{UB-16_S5M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).UB_16UM___16_S_5M,
    "{637334E4-AB5A-47C0-83A6-51B7F1DF3CD5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).UB_32A_pod___32_x_S_5KO__57mm_UnGd_Rkts__HEAT_Frag,
    "{UB-32_S5M}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).UB_32M___32_S_5M,
    "{UPK-23-250 MiG-21}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).UPK_23_250,
    "{05544F1A-C39C-466b-BC37-5BD1D52E57BB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).UPK_23_250___2_x_23mm__GSh_23L_Autocannon_Pod,
    "{U22}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).U_22_Jammer_pod,
    "{WGr21}": (0, $e56653165fb50b77$export$2e2bcd8739ae039).Werfer_Granate_21___21_cm_UnGd_air_to_air_rocket,
    XM158_M151: (0, $e56653165fb50b77$export$2e2bcd8739ae039).XM158_M151,
    XM158_M156: (0, $e56653165fb50b77$export$2e2bcd8739ae039).XM158_M156,
    XM158_M257: (0, $e56653165fb50b77$export$2e2bcd8739ae039).XM158_M257,
    XM158_M274: (0, $e56653165fb50b77$export$2e2bcd8739ae039).XM158_M274,
    XM158_MK1: (0, $e56653165fb50b77$export$2e2bcd8739ae039).XM158_MK1,
    XM158_MK5: (0, $e56653165fb50b77$export$2e2bcd8739ae039).XM158_MK5,
    "{US_108GAL_PAPER_FUEL_TANK}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._108_US_gal__Paper_Fuel_Tank,
    "{US_110GAL_FUEL_TANK}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._110_US_gal__Fuel_Tank,
    "{12xM64}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._12_AN_M64___500lb_GP_Bomb_LD,
    "{D6A0441E-6794-4FEB-87F7-E68E2290DFAB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._12_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD,
    "{E70446B7-C7E6-4B95-B685-DEA10CAD1A0E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._12_x_FAB_500_M_62___500kg_GP_Bombs_LD,
    "{FW_190_R4M_LEFT_WING}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._13_R4M_3_2kg_UnGd_air_to_air_rocket,
    "{FW_190_R4M_RGHT_WING}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._13_R4M_3_2kg_UnGd_air_to_air_rocket_,
    "{US_150GAL_FUEL_TANK}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._150_US_gal__Fuel_Tank,
    "{22906569-A97F-404B-BA4F-D96DBF94D05E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._20_x_AGM_86C_ALCM,
    "{B0241BD2-5628-47E0-954C-A8675B7E698E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._24_x_FAB_250___250kg_GP_Bombs_LD,
    "{British_GP_250LB_Bomb_Mk4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._250lb_Mk_IV___GP_Bomb_LD,
    "{British_GP_250LB_Bomb_Mk1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._250lb_Mk_I___GP_Bomb_LD,
    "{British_GP_250LB_Bomb_Mk5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._250_lb_GP_Mk_V,
    "{British_MC_250LB_Bomb_Mk1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._250_lb_MC_Mk_I,
    "{British_MC_250LB_Bomb_Mk2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._250_lb_MC_Mk_II,
    "{British_SAP_250LB_Bomb_Mk5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._250_lb_S_A_P_,
    "{B58F99BA-5480-4572-8602-28B0449F5260}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._27_x_M117___750lb_GP_Bombs_LD,
    "{6C47D097-83FF-4FB2-9496-EAB36DDF0B05}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._27_x_Mk_82___500lb_GP_Bombs_LD,
    "{89D000B0-0360-461A-AD83-FB727E2ABA98}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2xGBU_12___500lb_Laser_Guided_Bomb,
    "{BRU-42_2xGBU-12_right}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2xGBU_12___500lb_Laser_Guided_Bomb_,
    "{LYSBOMB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2x_80kg_LYSB_71_Illumination_Bomb,
    "{BRU-42_2*GBU-12_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_12,
    "{BRU-42_2*GBU-12_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_12_,
    "{BRU-42_2*GBU-16_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_16,
    "{BRU-42_2*GBU-16_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_16_,
    "{BRU-42_2*GBU-38_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_38,
    "{BRU-42_2*GBU-38_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_38_,
    "{BRU-70A_2*GBU-54_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_54_V_1_B,
    "{BRU-70A_2*GBU-54_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_GBU_54_V_1_B_,
    "{BRU42_2*LAU10 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71,
    "{BRU3242_2*LAU10 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71_,
    "{BRU42_2*LAU10 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71__,
    "{BRU3242_2*LAU10 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71___,
    "{BRU42_2*LAU10 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71____,
    "{BRU3242_2*LAU10 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71_____,
    "{PHXBRU3242_2*LAU10 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71______,
    "{BRU42_2*LAU10 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71_______,
    "{BRU3242_2*LAU10 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71________,
    "{PHXBRU3242_2*LAU10 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LAU_10___4_ZUNI_MK_71_________,
    "{BRU42_2*LUU2 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LUU_2,
    "{BRU3242_2*LUU2 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LUU_2_,
    "{BRU42_2*LUU2 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LUU_2__,
    "{BRU3242_2*LUU2 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_LUU_2___,
    "{BRU42_2*MK20 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_MK_20,
    "{BRU3242_2*MK20 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_MK_20_,
    "{PHXBRU3242_2*MK20 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_MK_20__,
    "{BRU42_2*MK20 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_MK_20___,
    "{BRU3242_2*MK20 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_MK_20____,
    "{PHXBRU3242_2*MK20 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_MK_20_____,
    "{BRU-42_2*MK-20_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_20_Rockeye,
    "{BRU-42_2*MK-20_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_20_Rockeye_,
    "{BRU42_2*MK81 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_81,
    "{BRU3242_2*MK81 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_81_,
    "{PHXBRU3242_2*MK81 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_81__,
    "{BRU42_2*MK81 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_81___,
    "{BRU3242_2*MK81 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_81____,
    "{PHXBRU3242_2*MK81 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_81_____,
    "{BRU-42_2*Mk-82_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82,
    "{BRU42_2*MK82AIR RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82AIR,
    "{BRU3242_2*MK82AIR RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82AIR_,
    "{PHXBRU3242_2*MK82AIR RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82AIR__,
    "{BRU42_2*MK82AIR LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82AIR___,
    "{BRU3242_2*MK82AIR LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82AIR____,
    "{PHXBRU3242_2*MK82AIR LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82AIR_____,
    "{BRU-42_2*Mk-82_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_,
    "{BRU-42_2*Mk-82AIR_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_AIR,
    "{BRU-42_2*Mk-82AIR_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_AIR_,
    "{BRU42_2*MK82SE RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_SnakeEye,
    "{BRU3242_2*MK82SE RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_SnakeEye_,
    "{PHXBRU3242_2*MK82SE RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_SnakeEye__,
    "{BRU42_2*MK82SE LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_SnakeEye___,
    "{BRU3242_2*MK82SE LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_SnakeEye____,
    "{PHXBRU3242_2*MK82SE LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_SnakeEye_____,
    "{BRU-42_2*Mk-82SNAKEYE_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_Snakeye,
    "{BRU-42_2*Mk-82SNAKEYE_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_Snakeye_,
    "{BRU42_2*MK82 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82__,
    "{BRU3242_2*MK82 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82___,
    "{PHXBRU3242_2*MK82 RS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82____,
    "{BRU42_2*MK82 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_____,
    "{BRU3242_2*MK82 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82______,
    "{PHXBRU3242_2*MK82 LS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_82_______,
    "{BRU-42_2*Mk-83_LEFT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_83,
    "{BRU-42_2*Mk-83_RIGHT}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_Mk_83_,
    "{BRU42_2*SUU25 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_SUU_25___8_LUU_2,
    "{BRU3242_2*SUU25 L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_SUU_25___8_LUU_2_,
    "{BRU42_2*SUU25 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_SUU_25___8_LUU_2__,
    "{BRU3242_2*SUU25 R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_SUU_25___8_LUU_2___,
    "{07BE2D19-0E48-4B0B-91DA-5F6C8F9E3C75}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_ALARM,
    "{C535596E-F7D2-4301-8BB4-B1658BB87ED7}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_BL_755_CBUs___450kg__147_Frag_Pen_bomblets,
    "{TWIN_B13L_5OF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_13L_pods___10_x_S_13_OF__122mm_UnGd_Rkts__Blast_Frag,
    "{B13_5_S13OF_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_13L___5_S_13_OF,
    "{B13_5_S13OF_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_13L___5_S_13_OF_,
    "{TWIN_B_8M1_S_8KOM}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8M1_pods___40_x_S_8KOM__80mm_UnGd_Rkts__HEAT_AP,
    "{B8M1_20_S8KOM_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8M1___20_S_8KOM,
    "{B8M1_20_S8KOM_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8M1___20_S_8KOM_,
    "{B8M1_20_S8OFP2_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8M1___20_S_8OFP2,
    "{B8M1_20_S8OFP2_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8M1___20_S_8OFP2_,
    "{B8M1_20_S8TsM_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8M1___20_S_8TsM,
    "{B8M1_20_S8TsM_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8M1___20_S_8TsM_,
    "{TWIN_B_8M1_S_8_OFP2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8V20A_pods___40_x_S_8OFP2__80mm_UnGd_Rkts__HE_Frag_AP,
    "{TWIN_B_8M1_S_8TsM}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_B_8V20A_pods___40_x_S_8TsM__80mm_UnGd_Rkts__Smk,
    "{FAB_250_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_FAB_250,
    "{FAB_250_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_FAB_250_,
    "{FAB_500_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_FAB_500,
    "{FAB_500_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_FAB_500_,
    "{HVARx2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_HVAR__UnGd_Rkts,
    "{FAB-100x2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_OFAB_100_Jupiter___100kg_GP_Bombs_LD,
    "{RBK_250_PTAB25M_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_RBK_250_PTAB_2_5M,
    "{RBK_250_PTAB25M_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_RBK_250_PTAB_2_5M_,
    "{RBK_500_PTAB105_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_RBK_500_255_PTAB_10_5,
    "{RBK_500_PTAB105_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_RBK_500_255_PTAB_10_5_,
    "{S25_DUAL_L}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_S_25,
    "{S25_DUAL_R}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_S_25_,
    "{TWIN_S25}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._2_x_S_25_OFM___340mm_UnGdrocket__480kg_Penetrator,
    "{BDAD04AA-4D4A-4E51-B958-180A89F963CF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._33_x_FAB_250___250kg_GP_Bombs_LD,
    "{AD5E5863-08FC-4283-B92C-162E2B2BD3FF}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._33_x_FAB_500_M_62___500kg_GP_Bombs_LD,
    "3M45": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3M45,
    "{BRU42_3*BDU33}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_BDU_33,
    "{BRU3242_3*BDU33}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_BDU_33_,
    "{BRU42_3*BDU33_N}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_BDU_33__,
    "{BRU3242_3*BDU33_N}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_BDU_33___,
    "{PHXBRU3242_BDU33}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_BDU_33____,
    "{BRU-42A_3*GBU-12}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_GBU_12,
    "{BRU-42A_3*GBU-16}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_GBU_16,
    "{BRU-42_3*GBU-38}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_GBU_38,
    "{BRU-70A_3*GBU-54}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_GBU_54_V_1_B,
    "{BRU-42_3*MK-20}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_Mk_20_Rockeye,
    "{BRU-42_3*Mk-81LD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_Mk_81,
    "{BRU-42_3*Mk-82LD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_Mk_82,
    "{BRU-42_3_MK82AIR}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_Mk_82_AIR,
    "{BRU-42_3*Mk-82SNAKEYE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_Mk_82_Snakeye,
    "{BRU-42_3*Mk-83}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_Mk_83,
    "{3xM8_ROCKETS_IN_TUBES}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_x_4_5_inch_M8_UnGd_Rocket,
    "{639DB5DD-CB7E-4E42-AC75-2112BC397B97}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_x_FAB_1500_M_54___1500kg_GP_Bombs_LD,
    "{A76344EB-32D2-4532-8FA2-0C1BDC00747E}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._3_x_LAU_61_pods___57_x_2_75_Hydra__UnGd_Rkts_M151__HE,
    "48N6E2": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._48N6E2,
    _4M80: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._4M80,
    "{M71BOMBD}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._4x_SB_M_71_120kg_GP_Bomb_High_drag,
    "{M71BOMB}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._4x_SB_M_71_120kg_GP_Bomb_Low_drag,
    "{AABA1A14-78A1-4E85-94DD-463CF75BD9E4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._4_x_AGM_154C___JSOW_Unitary_BROACH,
    "{4xAN-M64_on_InvCountedAttachmentPoints}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._4_x_AN_M64___500lb_GP_Bomb_LD,
    "{3EA17AB0-A805-4D9E-8732-4CE00CB00F17}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._4_x_BGM_71D_TOW_ATGM,
    "{B8C99F40-E486-4040-B547-6639172A5D57}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._4_x_GBU_27___2000lb_Laser_Guided_Penetrator_Bombs,
    "{British_GP_500LB_Bomb_Mk4}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._500lb_Mk_IV___GP_Bomb_LD,
    "{British_GP_500LB_Bomb_Mk1}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._500lb_Mk_I___GP_Bomb_LD,
    "{British_GP_500LB_Bomb_Mk5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._500_lb_GP_Mk_V,
    "{British_GP_500LB_Bomb_Mk4_Short}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._500_lb_GP_Short_tail,
    "{British_MC_500LB_Bomb_Mk2}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._500_lb_MC_Mk_II,
    "{British_MC_500LB_Bomb_Mk1_Short}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._500_lb_MC_Short_tail,
    "{British_SAP_500LB_Bomb_Mk5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._500_lb_S_A_P_,
    "{72CAC282-AE18-490B-BD4D-35E7EE969E73}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._51_x_M117___750lb_GP_Bombs_LD,
    "{B84DFE16-6AC7-4854-8F6D-34137892E166}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._51_x_Mk_82___500lb_GP_Bombs_LD,
    "5V55": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._5V55,
    "{P47_5_HVARS_ON_LEFT_WING_RAILS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._5_x_HVAR__UnGd_Rkt,
    "{P47_5_HVARS_ON_RIGHT_WING_RAILS}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._5_x_HVAR__UnGd_Rkt_,
    "{MER-5E_Mk82SNAKEYEx5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._5_x_Mk_82_Snakeye___500lb_GP_Bomb_HD,
    "{MER-5E_MK82x5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._5_x_Mk_82___500lb_GP_Bombs_LD,
    "{45447F82-01B5-4029-A572-9AAD28AF0275}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_AGM_86C_ALCM_on_MER,
    "{2B7BDB38-4F45-43F9-BE02-E7B3141F3D24}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_BetAB_500___500kg_Concrete_Piercing_Bombs_LD,
    "{D9179118-E42F-47DE-A483-A6C2EA7B4F38}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_FAB_1500_M_54___1500kg_GP_Bombs_LD,
    "{26D2AF37-B0DF-4AB6-9D61-A150FF58A37B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_FAB_500_M_62___500kg_GP_Bombs_LD,
    "{C42EE4C3-355C-4B83-8B22-B39430B8F4AE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_Kh_35__AS_20_Kayak____520kg__AShM__IN__Act_Rdr,
    "{0290F5DE-014A-4BB1-9843-D717749B1DED}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_Kh_65__AS_15B_Kent____1250kg__ASM__IN__MCC,
    "{E79759F7-C622-4AA4-B1EF-37639A34D924}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_Mk_20_Rockeye___490lbs_CBUs__247_x_HEAT_Bomblets,
    "{027563C9-D87E-4A85-B317-597B510E3F03}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._6_x_Mk_82___500lb_GP_Bombs_LD,
    "{DT75GAL}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._75_US_gal__Fuel_Tank,
    "{46ACDCF8-5451-4E26-BDDB-E78D5830E93C}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._8_x_AGM_84A_Harpoon_ASM,
    "{8DCAF3A3-7FCF-41B8-BB88-58DEDA878EDE}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._8_x_AGM_86C_ALCM,
    "{CD9417DF-455F-4176-A5A2-8C58D61AA00B}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._8_x_Kh_65__AS_15B_Kent____1250kg__ASM__IN__MCC,
    _9M111: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M111,
    "{B919B0F4-7C25-455E-9A02-CEA51DB895E3}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M114_Shturm_V_2__AT_6_Spiral____ATGM__SACLOS,
    "{57232979-8B0F-4db7-8D9A-55197E06B0F5}": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M114_Shturm_V_8__AT_6_Spiral____ATGM__SACLOS,
    _9M117: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M117,
    "9M133": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M133,
    "9M14": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M14,
    "9M31": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M31,
    "9M311": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M311,
    "9M33": (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M33,
    _9M331: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M331,
    _9M37: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M37,
    _9M38: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M38,
    _9M39: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._9M39,
    _NiteHawk_FLIR: (0, $e56653165fb50b77$export$2e2bcd8739ae039)._NiteHawk_FLIR
};
var $491c0dea9b8dcbb0$export$2e2bcd8739ae039 = $491c0dea9b8dcbb0$var$weaponIDs;



const $c255bc447a24c026$var$formatPath = (addr)=>{
    let path = [];
    for (const key of addr){
        if (typeof key === "number") path.push("numValues");
        else path.push("strValues");
        path.push(key);
    }
    return path;
};
const $c255bc447a24c026$export$3988ae62b71be9a3 = (table, addr)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(table, $c255bc447a24c026$var$formatPath(addr));
};
const $c255bc447a24c026$export$c6c37d5d787adc8a = (table, addr)=>{
    const result = $c255bc447a24c026$export$3988ae62b71be9a3(table, addr);
    if (result && result.strValues && result.strValues.length > 0) return result.strValues;
    if (result && result.numValues && result.numValues.length > 0) return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact(result.numValues);
};
const $c255bc447a24c026$export$543a593fdc0b48a9 = (unit, presets)=>{
    // @ts-ignore
    const type = unit.strValues.type;
    const module = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
    if (!module) return;
    const radioCfg = module.radios;
    if (radioCfg.length === 0) throw new Error(`no programmable radios found`);
    for(let i = 0; i < radioCfg.length; i++){
        const radio = $c255bc447a24c026$export$3988ae62b71be9a3(unit, [
            "Radio",
            i + 1
        ]);
        if (!radio) throw new Error(`invalid radio index given for ${type}: index ${i}`);
        for(let j = 0; j < presets[i].channels.length + 1; j++){
            const desired = presets[i];
            const chanIdx = j + 1;
            radio.strValues.channels.numValues[chanIdx] = desired.channels[j];
            radio.strValues.modulations.numValues[chanIdx] = desired.modulations[j];
            if (radio.strValues.channelsNames) radio.strValues.channelsNames.numValues[chanIdx] = desired.channelsNames[j];
        }
    }
};
function $c255bc447a24c026$export$d05c0403206b558e(unit, presets) {
    // @ts-ignore
    const type = unit.strValues.type;
    const m = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
    if (!m) {
        console.error(`No module found for ${type}`);
        return;
    }
    const uhfPresets = presets[0];
    const vhfPresets = presets[1];
    const mixedPresets = presets[2];
    const uhfRadioIndex = m.radioPresetOrder.indexOf((0, $b9c9d9c1adf94aca$export$cf0a21f30f3a5187).UHF);
    const hasUhfradio = uhfRadioIndex !== -1;
    const mixedRadioIndex = m.radioPresetOrder.indexOf((0, $b9c9d9c1adf94aca$export$cf0a21f30f3a5187).MIXED);
    const hasMixedRadio = mixedRadioIndex !== -1;
    const vhfRadioIndex = m.radioPresetOrder.indexOf((0, $b9c9d9c1adf94aca$export$cf0a21f30f3a5187).VHF);
    const hasVHFRadio = vhfRadioIndex !== -1;
    if (hasUhfradio) {
        const idx = uhfRadioIndex + 1;
        let radio = $c255bc447a24c026$export$3988ae62b71be9a3(unit, [
            "Radio",
            idx
        ]);
        if (!radio) {
            radio = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
                channels: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
                modulations: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
                channelsNames: new $0b8af60ab5d60464$export$54ec01a60f47d33d()
            });
            if (!unit.strValues.Radio) unit.strValues.Radio = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
            unit.strValues.Radio.numValues[idx] = radio;
        }
        const isOH58 = type === "OH58D";
        for(let j = 0; j < uhfPresets.channels.length + 1; j++){
            let chanIdx = j + 1;
            if (isOH58) // Special case for OH58D.
            // The first channel is the M or manual frequency, so skip it.
            // So increment the channel number by 1
            {
                if (chanIdx === 1) {
                    console.log("skipping", uhfPresets.channels[j]);
                    continue;
                }
            }
            radio.strValues.channels.numValues[chanIdx] = uhfPresets.channels[j];
            if (radio.strValues.modulations) radio.strValues.modulations.numValues[chanIdx] = uhfPresets.modulations[j];
            if (radio.strValues.channelsNames) radio.strValues.channelsNames.numValues[chanIdx] = uhfPresets.channelsNames[j];
        }
    }
    if (hasMixedRadio) {
        const idx = mixedRadioIndex + 1;
        let radio = $c255bc447a24c026$export$3988ae62b71be9a3(unit, [
            "Radio",
            idx
        ]);
        if (!radio) {
            radio = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
                channels: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
                modulations: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
                channelsNames: new $0b8af60ab5d60464$export$54ec01a60f47d33d()
            });
            if (!unit.strValues.Radio) unit.strValues.Radio = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
            unit.strValues.Radio.numValues[idx] = radio;
        }
        for(let m = 0; m < mixedPresets.channels.length + 1; m++){
            const chanIdx = m + 1;
            radio.strValues.channels.numValues[chanIdx] = mixedPresets.channels[m];
            if (radio.strValues.modulations) radio.strValues.modulations.numValues[chanIdx] = mixedPresets.modulations[m];
            if (radio.strValues.channelsNames) radio.strValues.channelsNames.numValues[chanIdx] = mixedPresets.channelsNames[m];
        }
    }
    if (hasVHFRadio) {
        const idx = vhfRadioIndex + 1;
        let radio = $c255bc447a24c026$export$3988ae62b71be9a3(unit, [
            "Radio",
            idx
        ]);
        if (!radio) {
            radio = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
                channels: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
                modulations: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
                channelsNames: new $0b8af60ab5d60464$export$54ec01a60f47d33d()
            });
            if (!unit.strValues.Radio) unit.strValues.Radio = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
            unit.strValues.Radio.numValues[idx] = radio;
        }
        const isOH58 = type === "OH58D";
        for(let j = 0; j < vhfPresets.channels.length + 1; j++){
            let chanIdx = j + 1;
            if (isOH58) {
                // Special case for OH58D.
                // The first channel is the M or manual frequency, so skip it.
                // So increment the channel number by 1
                if (chanIdx === 1) continue;
            }
            radio.strValues.channels.numValues[chanIdx] = vhfPresets.channels[j];
            if (radio.strValues.modulations) radio.strValues.modulations.numValues[chanIdx] = vhfPresets.modulations[j];
            if (radio.strValues.channelsNames) radio.strValues.channelsNames.numValues[chanIdx] = vhfPresets.channelsNames[j];
        }
    }
}
const $c255bc447a24c026$export$9c8a3e002e2d3c78 = (group, presets)=>{
    if (!presets) throw new Error("No presets defined");
    const type = group.strValues.units.numValues[1].strValues.type;
    // DCS ME is weird about setting the first channel of the "primary" UHF radio to the group freq.
    // Match it here, else chan 1 will get set to the lowest possible if a VHF radio is in pos[0].
    const uhfPreset = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(presets, (p)=>{
        const highest = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).max(p.channels);
        return highest >= 225;
    });
    if (!uhfPreset) return;
    if (type === "OH58D") // Special case for OH58D
    // The first channel is the M or manual frequency, so skip it.
    return;
    group.strValues.frequency = uhfPreset.channels[0];
    group.strValues.radioSet = true;
};
const $c255bc447a24c026$export$310428e83ded2f9c = (coalition, typeName, presets)=>(mission)=>{
        // Warning, USA is hardcoded country
        const groupsAddr = [
            "coalition",
            coalition,
            "country",
            31,
            "plane",
            "group"
        ];
        const groups = $c255bc447a24c026$export$3988ae62b71be9a3(mission, groupsAddr);
        for (const group of groups.numValues){
            // Lua is 1 based,  so our arrays start at 1.
            // The first element will be undefined.
            if (!group) continue;
            const units = $c255bc447a24c026$export$3988ae62b71be9a3(group, [
                "units"
            ]);
            const groupType = $c255bc447a24c026$export$3988ae62b71be9a3(units, [
                1,
                "type"
            ]);
            if (groupType === typeName) {
                $c255bc447a24c026$export$9c8a3e002e2d3c78(group, presets);
                for (const unit of units.numValues){
                    if (!unit) continue;
                    $c255bc447a24c026$export$543a593fdc0b48a9(unit, presets);
                }
            }
        }
    };
const $c255bc447a24c026$export$c8a04ddf41434c2e = (coalition, category, name, mission, dictionary)=>{
    const groups = $c255bc447a24c026$export$b84d9b908e43eb92(coalition, category, mission, dictionary);
    for (const group of groups){
        if (group.name === name) return group;
    }
};
const $c255bc447a24c026$export$5ba11f3fd9843bae = (mission, coalition, category, fn)=>{
    const countries = $c255bc447a24c026$export$89299530f2a0cec2(coalition, mission);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(countries, (country)=>{
        const groupsAddr = [
            category,
            "group"
        ];
        const groups = $c255bc447a24c026$export$3988ae62b71be9a3(country, groupsAddr);
        if (!groups) return;
        for (const group of groups.numValues){
            if (!group) continue;
            fn(group);
        }
    });
};
function $c255bc447a24c026$export$8014604593e0a373(mission, coalition, category, name) {
    let group = null;
    $c255bc447a24c026$export$5ba11f3fd9843bae(mission, coalition, category, (g)=>{
        // @ts-ignore
        if (g.strValues.name === name) group = g;
    });
    return group;
}
const $c255bc447a24c026$export$89299530f2a0cec2 = (coalition, mission)=>{
    const lookup = {};
    const result = [];
    const countryLookup = $c255bc447a24c026$export$3988ae62b71be9a3(mission, [
        "coalitions",
        coalition
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(countryLookup.numValues, (v)=>{
        if (typeof v === "undefined") return;
        lookup[v] = true;
    });
    const countries = $c255bc447a24c026$export$3988ae62b71be9a3(mission, [
        "coalition",
        coalition,
        "country"
    ]);
    (0, $f1q41.each)(countries.numValues, (c)=>{
        if (!c) return;
        if (typeof lookup[c.strValues.id] !== "undefined") result.push(c);
    });
    return result;
};
const $c255bc447a24c026$export$6af2dc03a755a66c = (coalition, presets)=>(mission)=>{
        // TODO fix this copy pase
        const countries = $c255bc447a24c026$export$89299530f2a0cec2(coalition, mission);
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(countries, (country)=>{
            const groupsAddr = [
                "plane",
                "group"
            ];
            const groups = $c255bc447a24c026$export$3988ae62b71be9a3(country, groupsAddr);
            if (!groups) return;
            for (const group of groups.numValues){
                if (!group) continue;
                $c255bc447a24c026$export$9c8a3e002e2d3c78(group, presets);
                const units = $c255bc447a24c026$export$3988ae62b71be9a3(group, [
                    "units"
                ]);
                for (const unit of units.numValues){
                    if (!unit) continue;
                    const skill = unit.strValues.skill;
                    if (skill === "Client" || skill === "Player") $c255bc447a24c026$export$543a593fdc0b48a9(unit, presets);
                }
            }
        });
    };
const $c255bc447a24c026$export$3102ab015d5c1acf = (unit)=>{
    const r = [];
    const radios = $c255bc447a24c026$export$3988ae62b71be9a3(unit, [
        "Radio"
    ]);
    if (!radios) {
        // FARPs have special keys to define their radio config
        if (unit.strValues.category === "Heliports") return [
            [
                {
                    frequency: unit.strValues.heliport_frequency,
                    modulation: unit.strValues.heliport_modulation,
                    name: ""
                }
            ]
        ];
        return [
            [
                {
                    frequency: unit.strValues.frequency,
                    modulation: unit.strValues.modulation,
                    name: ""
                }
            ]
        ];
    }
    for (const radio of radios.numValues){
        if (!radio) continue;
        const modulations = radio.strValues?.modulations?.numValues;
        const channels = radio?.strValues?.channels?.numValues;
        const channelsNames = radio?.strValues?.channelsNames?.numValues;
        if (!modulations || !channels) continue;
        const radioData = [];
        for(let c = 0; c < channels.length; c++){
            const frequency = channels[c];
            const modulation = modulations && modulations[c];
            const name = channelsNames && channelsNames[c];
            if (!frequency) continue;
            radioData.push({
                frequency: frequency,
                modulation: modulation,
                name: name
            });
        }
        r.push(radioData);
    }
    return r;
};
const $c255bc447a24c026$var$formatLaserCode = (u)=>{
    const propObj = $c255bc447a24c026$export$3988ae62b71be9a3(u, [
        "AddPropAircraft"
    ]);
    let laserCode = [];
    if (propObj) // TODO: not sure why get or get2 isn't working here.
    // Needs some test coverage.
    laserCode = [
        propObj.strValues.LaserCode1000 || propObj.strValues.LGB1000,
        propObj.strValues.LaserCode100 || propObj.strValues.LGB100,
        propObj.strValues.LaserCode10 || propObj.strValues.LGB10,
        propObj.strValues.LaserCode1 || propObj.strValues.LGB1
    ];
    return laserCode;
};
function $c255bc447a24c026$var$getAirdrome(g) {
    const points = $c255bc447a24c026$export$c6c37d5d787adc8a(g, [
        "route",
        "points"
    ]);
    for(const key in points){
        const p = points[key];
        if (p.strValues.type === "TakeOffParking" || p.strValues.type === "TakeOffParkingHot") return p.strValues.airdromeId;
    }
}
const $c255bc447a24c026$export$b84d9b908e43eb92 = (coalition, category, mission, dictionary)=>{
    if (!coalition) throw new Error("no coalition specified");
    const lookup = {};
    const result = [];
    const countryLookup = $c255bc447a24c026$export$3988ae62b71be9a3(mission, [
        "coalitions",
        coalition
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(countryLookup?.numValues, (v)=>{
        if (typeof v === "undefined") return;
        lookup[v] = true;
    });
    const countries = $c255bc447a24c026$export$3988ae62b71be9a3(mission, [
        "coalition",
        coalition,
        "country"
    ]);
    (0, $f1q41.each)(countries.numValues, (c)=>{
        if (!c) return;
        if (typeof lookup[c.strValues.id] !== "undefined") {
            if (c.strValues[category]) {
                const country = $c255bc447a24c026$export$3988ae62b71be9a3(c, [
                    "name"
                ]);
                const groups = $c255bc447a24c026$export$c6c37d5d787adc8a(c, [
                    category,
                    "group"
                ]);
                (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(groups, (g)=>{
                    const isPlayer = $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                        "units",
                        1,
                        "skill"
                    ]) === "Client" || $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                        "units",
                        1,
                        "skill"
                    ]) === "Player";
                    let name;
                    // DCS 2.7: looks like dictionary may or may not exist
                    if (dictionary) name = dictionary[$c255bc447a24c026$export$3988ae62b71be9a3(g, [
                        "name"
                    ])];
                    if (!name) name = $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                        "name"
                    ]);
                    const firstPoint = g.strValues.route.strValues.points.numValues[1].strValues;
                    let linkedUnitId = null;
                    if (firstPoint.type === (0, $91a9098e14452db2$export$325098d3a9c3b991).TakeOff || firstPoint.type === (0, $91a9098e14452db2$export$325098d3a9c3b991).TakeoffParking) linkedUnitId = firstPoint.linkUnit;
                    const tp = $c255bc447a24c026$export$c6c37d5d787adc8a(g, [
                        "NavTargetPoints"
                    ]);
                    let navTargetPoints = null;
                    if (tp) navTargetPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(tp, (p)=>({
                            index: p.strValues.index,
                            textComment: p.strValues.text_comment,
                            x: p.strValues.x,
                            y: p.strValues.y
                        }));
                    if (g.strValues.name === "Russian BG-2") console.log(g);
                    const data = {
                        coalition: coalition,
                        category: category,
                        country: country,
                        name: name,
                        channel: {
                            frequency: g.strValues.frequency,
                            modulation: g.strValues.modulation,
                            name: ""
                        },
                        groupId: g.strValues.groupId,
                        linkedUnitId: linkedUnitId,
                        navTargetPoints: navTargetPoints,
                        units: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map($c255bc447a24c026$export$c6c37d5d787adc8a(g, [
                            "units"
                        ]), (u)=>{
                            const laserCode = $c255bc447a24c026$var$formatLaserCode(u);
                            const radios = $c255bc447a24c026$export$3102ab015d5c1acf(u);
                            let unitName;
                            // 2.7 seems to have rolled back i18n?
                            // Unit and group names may or may not be in the dictionary file.
                            if (dictionary) {
                                unitName = dictionary[u.strValues.name];
                                if (!unitName) unitName = u.strValues.name;
                            }
                            const payload = [];
                            if (isPlayer) {
                                if (u.strValues.payload.strValues.pylons.numValues.length > 1) {
                                    const pylons = u.strValues.payload.strValues.pylons.numValues;
                                    for(let i = 0; i < pylons.length; i++){
                                        const pylon = pylons[i];
                                        if (!pylon) {
                                            if (i === 0) continue;
                                            payload.push(null);
                                            continue;
                                        }
                                        const weapon = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, $491c0dea9b8dcbb0$export$2e2bcd8739ae039), [
                                            pylon.strValues.CLSID,
                                            "name"
                                        ]);
                                        payload.push(weapon);
                                    }
                                }
                            }
                            const props = {};
                            const propObj = u.strValues.AddPropAircraft;
                            if (propObj && propObj.strValues) for(const p in propObj.strValues)props[p] = propObj.strValues[p];
                            let datalinks = null;
                            if (u.strValues.datalinks) {
                                const links = u.strValues.datalinks;
                                datalinks = {};
                                for(const kind in links.strValues){
                                    datalinks[kind] = {};
                                    const record = links.strValues[kind];
                                    for(const key in record.strValues){
                                        const v = record.strValues[key];
                                        if (key === "network") {
                                            datalinks[kind]["network"] = {
                                                donors: [],
                                                teamMembers: []
                                            };
                                            if (!v.strValues.donors) continue;
                                            for (const d of v.strValues.donors.numValues)if (d) datalinks[kind].network.donors.push(d.strValues);
                                            for (const tm of v.strValues.teamMembers.numValues)if (tm) datalinks[kind].network.teamMembers.push(tm.strValues);
                                        }
                                        if (key === "settings") {
                                            datalinks[kind][key] = {};
                                            for(const field in v.strValues){
                                                const element = v.strValues[field];
                                                datalinks[kind][key][field] = element;
                                            }
                                        }
                                    }
                                }
                            }
                            return {
                                unitId: u.strValues.unitId,
                                type: $c255bc447a24c026$export$3988ae62b71be9a3(u, [
                                    "type"
                                ]),
                                x: $c255bc447a24c026$export$3988ae62b71be9a3(u, [
                                    "x"
                                ]),
                                y: $c255bc447a24c026$export$3988ae62b71be9a3(u, [
                                    "y"
                                ]),
                                name: unitName,
                                callsign: $c255bc447a24c026$export$3988ae62b71be9a3(u, [
                                    "callsign",
                                    "name"
                                ]) || null,
                                laserCode: laserCode,
                                radios: radios,
                                payload: payload,
                                linkedUnitId: linkedUnitId,
                                tailNumber: u.strValues.onboard_num,
                                aircraftProps: props,
                                datalinks: datalinks,
                                internalFuel: u?.strValues?.payload?.strValues?.fuel
                            };
                        }),
                        waypoints: $c255bc447a24c026$export$cd15fa077f15ea37(g, dictionary),
                        x: $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                            "x"
                        ]),
                        y: $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                            "y"
                        ]),
                        hidden: $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                            "hidden"
                        ]),
                        hiddenOnMFD: $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                            "hiddenOnMFD"
                        ]),
                        hiddenOnPlanner: $c255bc447a24c026$export$3988ae62b71be9a3(g, [
                            "hiddenOnPlanner"
                        ]),
                        airdromeId: $c255bc447a24c026$var$getAirdrome(g),
                        isPlayer: isPlayer
                    };
                    result.push(data);
                });
            }
        }
    });
    return result;
};
function $c255bc447a24c026$export$cd15fa077f15ea37(group, dictionary) {
    const waypoints = [];
    const points = $c255bc447a24c026$export$c6c37d5d787adc8a(group, [
        "route",
        "points"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(points, (v, i)=>{
        let name;
        if (dictionary) name = dictionary[v.strValues.name];
        if (!name) name = v.strValues.name;
        if (!name) name = i.toString();
        waypoints.push({
            ...v.strValues,
            name: name,
            number: i
        });
    });
    return waypoints;
}
const $c255bc447a24c026$var$removeHiddenUnits = (coalition, cat, mission)=>{
    const countries = $c255bc447a24c026$export$c6c37d5d787adc8a(mission, [
        "coalition",
        coalition,
        "country"
    ]);
    for(let c = 0; c < countries.length; c++){
        const country = countries[c];
        if (!country) continue;
        const groups = $c255bc447a24c026$export$c6c37d5d787adc8a(country, [
            cat,
            "group"
        ]);
        if (!groups) continue;
        const visible = [
            undefined
        ];
        for(let v = 0; v < groups.length; v++){
            let group = groups[v];
            if (!group) continue;
            if (!group.strValues.hidden) visible.push(group);
        }
        country.strValues[cat].strValues.group.numValues = visible;
    }
    return mission;
};
const $c255bc447a24c026$export$1455800b99067ea7 = ()=>(mission)=>{
        let updated = mission;
        [
            (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue,
            (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red
        ].forEach((coalition)=>{
            [
                (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Vehicle,
                (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Plane,
                (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship,
                (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Helicopter
            ].forEach((category)=>{
                updated = $c255bc447a24c026$var$removeHiddenUnits(coalition, category, updated);
            });
        });
        return updated;
    };
function $c255bc447a24c026$export$2d76461f96e51b23(mission) {
    const zones = mission.strValues.triggers.strValues.zones.numValues;
    const out = [];
    for (const zone of zones){
        if (!zone) continue;
        const record = {
            name: zone.strValues.name,
            hidden: zone.strValues.hidden,
            verticies: null,
            type: zone.strValues.type,
            color: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(zone.strValues.color.numValues, (n)=>typeof n !== "undefined"),
            origin: {
                x: zone.strValues.x,
                y: zone.strValues.y
            },
            radius: zone.strValues.radius
        };
        record.verticies = [];
        if (zone.strValues.verticies) for (const vertex of zone.strValues.verticies.numValues){
            if (!vertex) continue;
            record.verticies.push({
                x: vertex.strValues.x,
                y: vertex.strValues.y
            });
        }
        out.push(record);
    }
    return out;
}
const $c255bc447a24c026$export$7594c041727c2620 = (coa, mission)=>{
    return mission.strValues.coalition.strValues[coa].strValues.bullseye.strValues;
};
const $c255bc447a24c026$export$555b5e1594145069 = (coa, mission)=>{
    const tbl = mission.strValues.coalition.strValues[coa].strValues.nav_points.numValues;
    const points = [];
    for (const point of tbl){
        if (!point) continue;
        points.push({
            type: point.strValues.type,
            callsignStr: point.strValues.callsignStr,
            comment: point.strValues.comment,
            id: point.strValues.id,
            x: point.strValues.x,
            y: point.strValues.y
        });
    }
    return points;
};
const $c255bc447a24c026$export$32c107075c6c16a9 = (coa, mission, dict)=>{
    const key = mission.strValues.descriptionText;
    return dict[key];
};
const $c255bc447a24c026$export$6986b74517635805 = ()=>(mission)=>{
        const triggers = mission.strValues.triggers;
        const zones = triggers.strValues.zones;
        if (!zones) return mission;
        mission.strValues.triggers.strValues.zones.numValues = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(zones.numValues, (z)=>z && !z.strValues.hidden);
        // Because Lua is 1-based, the first element needs to be undefined.
        // The _.filter func above removed undefined.
        mission.strValues.triggers.strValues.zones.numValues.unshift(undefined);
        return mission;
    };
const $c255bc447a24c026$export$395ec81007945923 = ()=>(mission)=>{
        // Set this to a blank table
        mission.strValues.trig = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
        mission.strValues.trigrules = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
        return mission;
    };
const $c255bc447a24c026$export$965783a514687a55 = (coalition, groupName, category, template, missionDict)=>(mission)=>{
        const countries = $c255bc447a24c026$export$89299530f2a0cec2(coalition, mission);
        for(let c = 0; c < countries.length; c++){
            const country = countries[c];
            if (!country) continue;
            const mg = country.strValues[category];
            if (!mg) continue;
            const mgs = mg.strValues.group.numValues;
            for(let m = 0; m < mg.strValues.group.numValues.length; m++){
                let mg = mgs[m];
                if (!mg) continue;
                let mgName = missionDict[mg.strValues.name];
                // DCS 2.7 is now inconsistent with i18n.
                // Older missions have names defined in the dictionary, newer ones seem to apply it directly.
                if (!mgName) mgName = mg.strValues.name;
                if (mgName !== groupName) continue;
                const tmplCountries = $c255bc447a24c026$export$89299530f2a0cec2(coalition, template.lua);
                for (const tmplCountry of tmplCountries){
                    const tg = tmplCountry.strValues[category];
                    if (!tg) continue;
                    const templateGroups = tg.strValues.group.numValues;
                    for(let t = 0; t < templateGroups.length; t++){
                        const templateGroup = templateGroups[t];
                        if (!templateGroup) continue;
                        let gName = template.dictionary[templateGroup.strValues.name];
                        if (!gName) gName = templateGroup.strValues.name;
                        if (gName === mgName) {
                            // Convert waypoint names.
                            // For some reason, adding entries to the dictionary does NOT work.
                            // This means that waypoint names cannot be internationalized,
                            // but we consider that an edge case anyway.
                            for(let p = 0; p < templateGroup.strValues.route.strValues.points.numValues.length; p++){
                                const point = templateGroup.strValues.route.strValues.points.numValues[p];
                                if (!point) continue;
                                let newName = template.dictionary[point.strValues.name];
                                // Handle DCS 2.7 dctionary inconsistency
                                if (newName) point.strValues.name = newName;
                            }
                            const originalGroup = mission.strValues.coalition.strValues[coalition].strValues.country.numValues[c + 1].strValues[category].strValues.group.numValues[m];
                            templateGroup.strValues.groupId = originalGroup.strValues.groupId;
                            for(let i = 0; i < originalGroup.strValues.units.numValues.length; i++){
                                const originalUnit = originalGroup.strValues.units.numValues[i];
                                if (!originalUnit) continue;
                                if (!templateGroup.strValues.units.numValues[i]) continue;
                                templateGroup.strValues.units.numValues[i].strValues.unitId = originalUnit.strValues.unitId;
                            }
                            mission.strValues.coalition.strValues[coalition].strValues.country.numValues[c + 1].strValues[category].strValues.group.numValues[m] = templateGroup;
                        }
                    }
                }
            }
        }
        return mission;
    };
const $c255bc447a24c026$export$49f0c9f4fd874112 = ()=>(mission)=>{
        let updated = mission;
        [
            (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue,
            (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red
        ].forEach((coalition)=>{
            [
                (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Static
            ].forEach((category)=>{
                updated = $c255bc447a24c026$var$removeHiddenUnits(coalition, category, updated);
            });
        });
        return updated;
    };
const $c255bc447a24c026$export$71ff21b02f58bd76 = (opts)=>(mission)=>{
        let updated = mission;
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(opts.templates, (template)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(opts.categories, (cat)=>{
                const groups = $c255bc447a24c026$export$aacddaff3d6b29ae(opts.coalition, cat, template.lua, template.dictionary);
                (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(groups, (gData)=>{
                    updated = $c255bc447a24c026$export$965783a514687a55(opts.coalition, gData.name, cat, template, opts.missionDict)(updated);
                });
            });
        });
        return updated;
    };
const $c255bc447a24c026$export$aacddaff3d6b29ae = (coalition, category, template, dictionary)=>{
    const allGroups = $c255bc447a24c026$export$b84d9b908e43eb92(coalition, category, template, dictionary);
    const plannedGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(allGroups, (g)=>g.isPlayer && g.waypoints.length > 1);
    return plannedGroups;
};
const $c255bc447a24c026$export$40a7dcdd22bafa6f = (coalition, category, template, dictionary)=>{
    const allGroups = $c255bc447a24c026$export$b84d9b908e43eb92(coalition, category, template, dictionary);
    const plannedGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(allGroups, (g)=>g.isPlayer && !g.hidden && !g.hiddenOnPlanner);
    return plannedGroups;
};
function $c255bc447a24c026$export$8d988fa4222bb81(coalition, warehousesData, theater) {
    const basesForTheater = (0, $e8170945d4879225$export$2e2bcd8739ae039)[theater];
    const output = [];
    if (!basesForTheater) throw new Error(`No bases defined for theater ${theater}`);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(warehousesData.strValues.airports.numValues, (b, i)=>{
        if (!b) return;
        if (!basesForTheater[i]) // Strange mismatch case where the warehouse file has an airbase ID but the
        // DCS scripting API doesn't...
        return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).lowerCase(b.strValues.coalition) === coalition) output.push({
            ...basesForTheater[i],
            Type: (0, $91a9098e14452db2$export$307b49132840b0da).Airfield,
            AirdromeId: i
        });
    });
    return output;
}
function $c255bc447a24c026$var$isLHA(type) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(type, "LHA");
}
// This type is provided by DCS. Each Nimitz carrier has a type like "CVN_71" or "CVN_74".
// TODO: support Kuz.
function $c255bc447a24c026$var$isCarrier(type) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(type, "CVN") || (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(type, "Stennis");
}
// FARPs can be lots of different types.
// This is naive for now.
function $c255bc447a24c026$var$isFARP(s) {
    return !!s.units[0].radios[0][0].frequency;
}
var $c255bc447a24c026$var$BeaconType;
// https://wiki.hoggitworld.com/view/DCS_command_activateBeacon
(function(BeaconType) {
    BeaconType[BeaconType["TACAN"] = 4] = "TACAN";
})($c255bc447a24c026$var$BeaconType || ($c255bc447a24c026$var$BeaconType = {}));
function $c255bc447a24c026$export$2e52c604a323e3c7(group, taskId) {
    for (const w of group.waypoints){
        const tasks = w.task.strValues.params.strValues.tasks.numValues;
        for (const st of tasks){
            if (!st) continue;
            if (st.strValues.id === "WrappedAction") {
                const action = st.strValues.params.strValues.action.strValues;
                if (action.id === taskId) return action;
            }
            if (st.strValues.id === taskId) return st.strValues;
            const action = st.strValues.params.strValues.action;
            if (!action) continue;
            if (action.strValues.id === taskId) return action.strValues;
        }
    }
}
function $c255bc447a24c026$export$1cc6625bb95a1f24(unit, group) {
    let action = $c255bc447a24c026$export$2e52c604a323e3c7(group, "ActivateBeacon");
    let output = "";
    if (action) {
        let data;
        // Handle the various ways DCS mission tasks will get returned
        if (!action.type && action.params) data = action.params.strValues;
        else data = action.strValues.params.strValues;
        if (data.type === 4) {
            if (data.unitId === unit.unitId) output = `${data.channel}${data.modeChannel} ${data.callsign}`;
        }
    }
    return output;
}
function $c255bc447a24c026$export$2479251f7619e07e(unit, group) {
    let action = $c255bc447a24c026$export$2e52c604a323e3c7(group, "ActivateICLS");
    return action ? `ICLS ${action.params.strValues.channel}` : "";
}
// Mission editor freqs are represented by large ints without decimals.
function $c255bc447a24c026$var$formatLongFreq(freq) {
    return freq / 1000000;
}
function $c255bc447a24c026$var$isUHF(freq) {
    return freq >= 225.0;
}
function $c255bc447a24c026$export$8dabf28ccdc844ef(coalition, mission, dictionary) {
    const output = [];
    const ships = $c255bc447a24c026$export$b84d9b908e43eb92(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship, mission, dictionary);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(ships, (g)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(g.units, (u)=>{
            if ($c255bc447a24c026$var$isCarrier(u.type) || $c255bc447a24c026$var$isLHA(u.type)) {
                // Coverting from a DCSUnit to an interal Airbase type,
                // so the radio translation is a little weird.
                const freq = $c255bc447a24c026$var$formatLongFreq(u.radios[0][0].frequency);
                output.push({
                    Name: u.name,
                    X: u.x,
                    Y: 0,
                    Z: u.y,
                    Theater: "",
                    Runways: "",
                    UHF: $c255bc447a24c026$var$isUHF(freq) ? freq : null,
                    VHF: !$c255bc447a24c026$var$isUHF(freq) ? freq : null,
                    TACAN: $c255bc447a24c026$export$1cc6625bb95a1f24(u, g),
                    VOR: "",
                    ILS: [
                        $c255bc447a24c026$export$2479251f7619e07e(u, g)
                    ],
                    Elevation: "",
                    "MF/HF": "",
                    ICAO: "",
                    UnitId: u.unitId,
                    Type: $c255bc447a24c026$var$isCarrier(u.type) ? (0, $91a9098e14452db2$export$307b49132840b0da).Carrier : (0, $91a9098e14452db2$export$307b49132840b0da).LHA
                });
            }
        });
    });
    const statics = $c255bc447a24c026$export$b84d9b908e43eb92(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Static, mission, dictionary);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(statics, (s)=>{
        if ($c255bc447a24c026$var$isFARP(s)) {
            if (s.hidden) return;
            // DCS changed to allow statics to be in groups.
            // Each unit can be a separate parking spot, but it isn't really a speparate FARP.
            // Use the first for the pos and freq.
            const u = s.units[0];
            const freq = u.radios[0][0].frequency;
            output.push({
                Name: s.name,
                X: u.x,
                Y: 0,
                Z: u.y,
                Theater: "",
                Runways: "",
                UHF: $c255bc447a24c026$var$isUHF(freq) ? freq : null,
                VHF: $c255bc447a24c026$var$isUHF(freq) ? null : freq,
                TACAN: "",
                VOR: "",
                ILS: "",
                Elevation: "",
                "MF/HF": "",
                ICAO: "",
                Type: (0, $91a9098e14452db2$export$307b49132840b0da).FARP
            });
        }
    });
    return output;
}
var $c255bc447a24c026$export$99e832f86608bb2f;
(function(SupportAction) {
    SupportAction["AWACS"] = "AWACS";
    SupportAction["Tanker"] = "Tanker";
    SupportAction["FAC"] = "FAC";
})($c255bc447a24c026$export$99e832f86608bb2f || ($c255bc447a24c026$export$99e832f86608bb2f = {}));
function $c255bc447a24c026$var$getGroupWithAction(coalition, missionAST, dictionary, category, action) {
    const planes = $c255bc447a24c026$export$b84d9b908e43eb92(coalition, category, missionAST, dictionary);
    const withSupportType = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(planes, (p)=>({
            ...p,
            supportType: action
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(withSupportType, (p)=>{
        const a = $c255bc447a24c026$export$2e52c604a323e3c7(p, action);
        if (a) return true;
    });
}
function $c255bc447a24c026$export$4b9f485ad9ea72e7(coalition, missionAST, dictionary) {
    const awacs = $c255bc447a24c026$var$getGroupWithAction(coalition, missionAST, dictionary, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Plane, "AWACS");
    const tankers = $c255bc447a24c026$var$getGroupWithAction(coalition, missionAST, dictionary, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Plane, "Tanker");
    return [
        ...awacs,
        ...tankers
    ];
}



var $165c1a1c0f22e853$export$476dfc2401bc286b;
(function(InputType) {
    InputType["Dynamic"] = "Dynamic";
    InputType["Automated"] = "Automated";
    InputType["Manual"] = "Manual";
})($165c1a1c0f22e853$export$476dfc2401bc286b || ($165c1a1c0f22e853$export$476dfc2401bc286b = {}));
var $165c1a1c0f22e853$export$10e5b857d7fbb29f;
(function(DynamicChannel) {
    DynamicChannel["ATC"] = "dynamic_atc";
})($165c1a1c0f22e853$export$10e5b857d7fbb29f || ($165c1a1c0f22e853$export$10e5b857d7fbb29f = {}));
const $165c1a1c0f22e853$export$f601b9f6a9d5498e = (coalition, cat, groupName, presets)=>(mission)=>{
        (0, $c255bc447a24c026$export$5ba11f3fd9843bae)(mission, coalition, cat, (group)=>{
            const gName = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(group, [
                "name"
            ]);
            if (gName === groupName) {
                (0, $c255bc447a24c026$export$9c8a3e002e2d3c78)(group, presets);
                const units = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(group, [
                    "units"
                ]);
                for (const unit of units.numValues){
                    if (!unit) continue;
                    (0, $c255bc447a24c026$export$543a593fdc0b48a9)(unit, presets);
                }
            }
        });
    };
const $165c1a1c0f22e853$export$17011d0763770f78 = (chans, modules, group, interactable)=>{
    const uhfChans = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(chans, (c)=>c.band === (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF);
    const vhfChans = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(chans, (c)=>c.band === (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF || c.band === (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM);
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(group, [
        "units",
        0,
        "type"
    ]);
    if (!type) {
        console.warn("no type");
        return;
    }
    const module = modules[type];
    if (!module) {
        console.warn("no module: " + type);
        return;
    }
    const firstUHFRadio = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).findIndex(module.radios, (r)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(r.bands, (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF));
    const presets = [
        [],
        []
    ];
    for(let index = 0; index < uhfChans.length; index++){
        const c = uhfChans[index];
        if (c.type === "Dynamic") {
            if (c.value === "dynamic_atc") {
                const base = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(interactable, (b)=>{
                    if (group.airdromeId && !group.linkedUnitId) return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEqual(b.AirdromeId, group.airdromeId);
                    if (group.linkedUnitId) return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEqual(b.UnitID, group.linkedUnitId);
                    return false;
                });
                if (base) c.value = base[c.band];
            }
        }
        if (c.type === "Automated") {
            const target = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(interactable, {
                name: c.name
            });
            const freq = target[c.band];
            c.value = freq;
        }
    }
    const uhfVals = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(uhfChans, (c)=>({
            value: c.value,
            band: c.band
        }));
    const vhfVals = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(vhfChans, (c)=>({
            value: c.value,
            band: c.band
        }));
    if (firstUHFRadio > -1) presets[firstUHFRadio] = uhfVals;
    const lastVHFRadio = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).findLastIndex(module.radios, (r)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(r.bands, (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF));
    if (lastVHFRadio > -1) presets[lastVHFRadio] = vhfVals;
    const out = [
        {
            modulations: [],
            channels: [],
            channelsNames: []
        },
        {
            modulations: [],
            channels: [],
            channelsNames: []
        }
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(presets, (chans, p)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(chans, (chan, c)=>{
            out[p].modulations[c] = chan.band === (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM ? (0, $91a9098e14452db2$export$459e66e1d1ce05ca).FM : (0, $91a9098e14452db2$export$459e66e1d1ce05ca).AM;
            out[p].channels[c] = parseFloat(chan.value);
        });
    });
    return out;
};
function $165c1a1c0f22e853$export$3ecc6c0c07998cb5(freq) {
    if (!freq) return "";
    const [int, dec] = freq.toString().split(".");
    return `${int}.${(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).padEnd(dec, 3, "0")}`;
}
function $165c1a1c0f22e853$export$b63a20d758e83ab7(ovr) {
    const radioCfg = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(ovr, (list, i)=>{
        const p = {
            channels: [],
            modulations: [],
            channelsNames: []
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(list, (o, j)=>{
            const f = parseFloat(o.frequency);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isNaN(f)) {
                console.error(new Error(`invalid float for frequency: ${o.frequency}`));
                return;
            }
            p.channels[j] = f;
            p.modulations[j] = o.modulation;
            p.channelsNames[j] = o.description;
        });
        radioCfg[i] = p;
    });
    return radioCfg;
}
function $165c1a1c0f22e853$export$c711d73526b53d5(unit, overrides, radioIndex) {
    const presets = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get($165c1a1c0f22e853$export$b63a20d758e83ab7([
        overrides
    ]), 0);
    let radio = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(unit, [
        "Radio",
        radioIndex + 1
    ]);
    if (!radio) {
        radio = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
            channels: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
            modulations: new $0b8af60ab5d60464$export$54ec01a60f47d33d(),
            channelsNames: new $0b8af60ab5d60464$export$54ec01a60f47d33d()
        });
        unit.strValues.Radio = radio;
    }
    for(let j = 0; j < presets.channels.length + 1; j++){
        const chanIdx = j + 1;
        radio.strValues.channels.numValues[chanIdx] = presets.channels[j];
        if (radio.strValues.modulations) radio.strValues.modulations.numValues[chanIdx] = presets.modulations[j];
        if (radio.strValues.channelsNames) radio.strValues.channelsNames.numValues[chanIdx] = presets.channelsNames[j];
    }
}
function $165c1a1c0f22e853$export$f1d992e78c170a3d(tacan) {
    const re = /(.*)(.)$/g;
    const match = re.exec(tacan);
    const chan = match[1];
    const low = parseInt(chan);
    const high = low + 63;
    const band = match[2];
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isNaN(low) || (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isNaN(high) ? "N/A" : `${low}/${high}${band}`;
}
function $165c1a1c0f22e853$export$5507a3a66b1c2cfb(group, presets) {
    const unit = new $0b8af60ab5d60464$export$54ec01a60f47d33d({});
    if (!presets) return [
        []
    ];
    const formatted = [
        presets?.UHF,
        presets?.VHF,
        presets?.["V/UHF"],
        presets.FM
    ];
    const p = $165c1a1c0f22e853$export$b63a20d758e83ab7(formatted);
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(group.units).type;
    // @ts-ignore
    unit.strValues.type = type;
    (0, $c255bc447a24c026$export$d05c0403206b558e)(unit, p);
    const out = [];
    const d = (0, $c255bc447a24c026$export$3102ab015d5c1acf)(unit);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(d, (v, i)=>{
        out[i] = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(v, (c, j)=>{
            out[i][j] = {
                frequency: c?.frequency?.toString(),
                description: c.name,
                modulation: c.modulation
            };
        });
    });
    return out;
}




var $f1q41 = parcelRequire("f1q41");


/**
 * @module ol/layer/Vector
 */ /**
 * @module ol/layer/BaseVector
 */ /**
 * @module ol/layer/Layer
 */ /**
 * @module ol/layer/Base
 */ 
/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $f6d1853b3fcae320$export$2e2bcd8739ae039 = {
    OPACITY: "opacity",
    VISIBLE: "visible",
    EXTENT: "extent",
    Z_INDEX: "zIndex",
    MAX_RESOLUTION: "maxResolution",
    MIN_RESOLUTION: "minResolution",
    MAX_ZOOM: "maxZoom",
    MIN_ZOOM: "minZoom",
    SOURCE: "source",
    MAP: "map"
};





/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ class $57c5f0299cb9b82f$var$BaseLayer extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {Object<string, *>}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === "object") {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY] === "number", "Layer opacity must be a number");
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : "ol-layer";
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof opacity === "number", "Layer opacity must be a number");
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $57c5f0299cb9b82f$export$2e2bcd8739ae039 = $57c5f0299cb9b82f$var$BaseLayer;




/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $f5e92a4d985a2824$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: "prerender",
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: "precompose",
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: "postcompose",
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: "rendercomplete"
};


/**
 * @module ol/View
 */ 
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $7d362782b4ccb93d$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $d35baefbe89be4c5$export$2e2bcd8739ae039 = {
    CENTER: "center",
    RESOLUTION: "resolution",
    ROTATION: "rotation"
};


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $57cd8651d88957a0$export$e98a216cdcc847dc = 42;
const $57cd8651d88957a0$export$6b8cb5cd370bd90c = 256;






/**
 * @module ol/centerconstraint
 */ 
function $b21a6e049949bb31$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        let y = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $b21a6e049949bb31$export$f883a24d5edde77c(center) {
    return center;
}



/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $bac43a1f4a628548$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    const yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $bac43a1f4a628548$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $bac43a1f4a628548$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $bac43a1f4a628548$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $bac43a1f4a628548$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $d65f0a322291d127$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $d65f0a322291d127$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $d65f0a322291d127$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $d65f0a322291d127$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $6b000a049d919fe5$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $c7ccf7e681a9b333$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $c7ccf7e681a9b333$export$57636bb43b1ccbb0(t) {
    return 1 - $c7ccf7e681a9b333$export$929e5a82286172a6(1 - t);
}
function $c7ccf7e681a9b333$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $c7ccf7e681a9b333$export$45db2fc2f15997e7(t) {
    return t;
}
function $c7ccf7e681a9b333$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * t);
    return 1 - $c7ccf7e681a9b333$export$9b47139b511b56e4(2 * (t - 0.5));
}





/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $70364d0195659942$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ class $70364d0195659942$var$View extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, "EPSG:3857");
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $9c4744460e43e41b$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $d35baefbe89be4c5$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $70364d0195659942$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $70364d0195659942$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $70364d0195659942$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === "function") {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $70364d0195659942$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $c7ccf7e681a9b333$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $6b000a049d919fe5$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($70364d0195659942$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $70364d0195659942$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $6b000a049d919fe5$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $70364d0195659942$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $1bd0a226f9a16141$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get("constrainResolution");
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(center, "The view center is not defined");
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(resolution !== undefined, "The view resolution is not defined");
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(rotation !== undefined, "The view rotation is not defined");
        return (0, $6da4c8ed3074c92b$export$13ba650faf8308)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $9c4744460e43e41b$export$494be3a3a25689ca)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / size[0];
        const yResolution = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $70364d0195659942$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_) {
            if (this.resolutions_.length <= 1) return 0;
            const baseLevel = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === "function", "Invalid extent or geometry provided as `geometry`");
        if (Array.isArray(geometryOrExtent)) {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(!(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(geometryOrExtent), "Cannot fit empty extent provided as `geometry`");
            const extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === "Circle") {
            const extent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $40aa8d43bbe572bf$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(extent));
        } else {
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $013a1733c226ec50$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $70364d0195659942$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($70364d0195659942$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $70364d0195659942$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set("zoom", this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER) || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.get((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $d35baefbe89be4c5$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction=0] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $70364d0195659942$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $70364d0195659942$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, "EPSG:3857");
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $b21a6e049949bb31$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $b21a6e049949bb31$export$f883a24d5edde77c;
}
function $70364d0195659942$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $70364d0195659942$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $9c4744460e43e41b$export$549167224996a0fb)(options.projection, "EPSG:3857");
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $03edbd434a9e6608$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projExtent), (0, $6da4c8ed3074c92b$export$c08559766941f856)(projExtent));
        const defaultMaxResolution = size / (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $70364d0195659942$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $bac43a1f4a628548$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $bac43a1f4a628548$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $70364d0195659942$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $d65f0a322291d127$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $d65f0a322291d127$export$f883a24d5edde77c;
        if (typeof constrainRotation === "number") return (0, $d65f0a322291d127$export$9ba78806de831083)(constrainRotation);
        return 0, $d65f0a322291d127$export$f883a24d5edde77c;
    }
    return 0, $d65f0a322291d127$export$e20fbacbb41798b;
}
function $70364d0195659942$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $1bd0a226f9a16141$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $70364d0195659942$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $70364d0195659942$export$2e2bcd8739ae039 = $70364d0195659942$var$View;





/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ class $534f30fce11effcd$var$Layer extends (0, $57c5f0299cb9b82f$export$2e2bcd8739ae039) {
    /**
   * @param {Options<SourceType>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? "undefined" : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== "ready") return;
        this.sourceReady_ = true;
        this.dispatchEvent("sourceready");
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(source, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === "ready") {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent("sourceready");
                }, 0);
            }
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
        else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, (evt)=>{
                const renderEvent = /** @type {import("../render/Event.js").default} */ evt;
                const layerStatesArray = renderEvent.frameState.layerStatesArray;
                const layerState = this.getLayerState(false);
                (0, $35d5ec884318008e$export$a7a9523472993e97)(!layerStatesArray.some(function(arrayLayerState) {
                    return arrayLayerState.layer === layerState.layer;
                }), "A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.");
                layerStatesArray.push(layerState);
            });
            this.mapRenderKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $f6d1853b3fcae320$export$2e2bcd8739ae039).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
        this.setSource(null);
        super.disposeInternal();
    }
}
function $534f30fce11effcd$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $534f30fce11effcd$export$2e2bcd8739ae039 = $534f30fce11effcd$var$Layer;




/**
 * @module ol/render/canvas/style
 */ 






/**
 * @module ol/expr/expression
 */ 


/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * * Reading operators:
 *   * `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   * `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   * `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   * `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   * `['resolution']` returns the current resolution
 *   * `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   * `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   * `['zoom']` The current zoom level (WebGL only).
 *   * `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * * Math operators:
 *   * `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2, ...]` adds the values
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   * `['abs', value1]` returns the absolute value of `value1`
 *   * `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $778943ec39690f8e$var$numTypes = 0;
const $778943ec39690f8e$export$267d7ad6fa96ffaf = 0;
const $778943ec39690f8e$export$240f7fffab1b25a0 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$86a7aca748b1e260 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2b93044cbf134323 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$2cd82751acc0e609 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$d701d0e49f4bcb39 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$52725c8a6d4c61d1 = 1 << $778943ec39690f8e$var$numTypes++;
const $778943ec39690f8e$export$ec4c9a150bae86cd = Math.pow(2, $778943ec39690f8e$var$numTypes) - 1;
const $778943ec39690f8e$var$typeNames = {
    [$778943ec39690f8e$export$240f7fffab1b25a0]: "boolean",
    [$778943ec39690f8e$export$86a7aca748b1e260]: "number",
    [$778943ec39690f8e$export$2b93044cbf134323]: "string",
    [$778943ec39690f8e$export$2cd82751acc0e609]: "color",
    [$778943ec39690f8e$export$d701d0e49f4bcb39]: "number[]",
    [$778943ec39690f8e$export$52725c8a6d4c61d1]: "size"
};
const $778943ec39690f8e$var$namedTypes = Object.keys($778943ec39690f8e$var$typeNames).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
/**
 * @param {number} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function $778943ec39690f8e$var$isSpecific(type) {
    return type in $778943ec39690f8e$var$typeNames;
}
function $778943ec39690f8e$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $778943ec39690f8e$var$namedTypes)if ($778943ec39690f8e$export$9fdcb8b441c4f2b4(type, namedType)) names.push($778943ec39690f8e$var$typeNames[namedType]);
    if (names.length === 0) return "untyped";
    if (names.length < 3) return names.join(" or ");
    return names.slice(0, -1).join(", ") + ", or " + names[names.length - 1];
}
function $778943ec39690f8e$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $778943ec39690f8e$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $778943ec39690f8e$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $778943ec39690f8e$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!$778943ec39690f8e$var$isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${$778943ec39690f8e$export$b2afc7c96b2b4a45(type)}`);
        this.type = type;
        this.value = value;
    }
}
class $778943ec39690f8e$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $778943ec39690f8e$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false
    };
}
function $778943ec39690f8e$export$98e6a39c04603d36(encoded, expectedType, context) {
    switch(typeof encoded){
        case "boolean":
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded ? "true" : "false");
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) throw new Error(`got a boolean, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, encoded);
        case "number":
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$52725c8a6d4c61d1)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$52725c8a6d4c61d1, (0, $cc435a5409103773$export$a71a825ff42fb8e1)(encoded));
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, !!encoded);
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded.toString());
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$86a7aca748b1e260)) throw new Error(`got a number, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, encoded);
        case "string":
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2cd82751acc0e609)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, (0, $322346e1ff7894ca$export$3004f64547af360e)(encoded));
            if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$240f7fffab1b25a0)) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$240f7fffab1b25a0, !!encoded);
            if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$2b93044cbf134323)) throw new Error(`got a string, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error("expression must be an array or a primitive value");
    if (encoded.length === 0) throw new Error("empty expression");
    if (typeof encoded[0] === "string") return $778943ec39690f8e$var$parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== "number") throw new Error("expected an array of numbers");
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$52725c8a6d4c61d1)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$52725c8a6d4c61d1, encoded);
    }
    if ($778943ec39690f8e$export$26b9f946b448f23e(expectedType, $778943ec39690f8e$export$2cd82751acc0e609)) {
        if (encoded.length === 3) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2cd82751acc0e609, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!$778943ec39690f8e$export$9fdcb8b441c4f2b4(expectedType, $778943ec39690f8e$export$d701d0e49f4bcb39)) throw new Error(`got an array of numbers, but expected ${$778943ec39690f8e$export$b2afc7c96b2b4a45(expectedType)}`);
    return new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$d701d0e49f4bcb39, encoded);
}
const $778943ec39690f8e$export$2655e45458bc48f3 = {
    Get: "get",
    Var: "var",
    Concat: "concat",
    GeometryType: "geometry-type",
    LineMetric: "line-metric",
    Any: "any",
    All: "all",
    Not: "!",
    Resolution: "resolution",
    Zoom: "zoom",
    Time: "time",
    Equal: "==",
    NotEqual: "!=",
    GreaterThan: ">",
    GreaterThanOrEqualTo: ">=",
    LessThan: "<",
    LessThanOrEqualTo: "<=",
    Multiply: "*",
    Divide: "/",
    Add: "+",
    Subtract: "-",
    Clamp: "clamp",
    Mod: "%",
    Pow: "^",
    Abs: "abs",
    Floor: "floor",
    Ceil: "ceil",
    Round: "round",
    Sin: "sin",
    Cos: "cos",
    Atan: "atan",
    Sqrt: "sqrt",
    Match: "match",
    Between: "between",
    Interpolate: "interpolate",
    Coalesce: "coalesce",
    Case: "case",
    In: "in",
    Number: "number",
    String: "string",
    Array: "array",
    Color: "color",
    Id: "id",
    Band: "band",
    Palette: "palette",
    ToString: "to-string",
    Has: "has"
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const $778943ec39690f8e$var$parsers = {
    [$778943ec39690f8e$export$2655e45458bc48f3.Get]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Var]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withVarArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Has]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withGetArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Id]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesFeatureId, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Concat]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$2b93044cbf134323)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GeometryType]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$usesGeometryType, $778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.LineMetric]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Resolution]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Zoom]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Time]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$withNoArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Any]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.All]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Not]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Equal]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.NotEqual]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.LessThanOrEqualTo]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Multiply]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfReturnType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Coalesce]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfReturnType),
    [$778943ec39690f8e$export$2655e45458bc48f3.Divide]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Add]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Subtract]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Clamp]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Mod]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Pow]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Abs]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Floor]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Ceil]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Round]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sin]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Cos]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Atan]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 2), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Sqrt]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Match]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(4, Infinity), $778943ec39690f8e$var$hasEvenArgs, $778943ec39690f8e$var$withMatchArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Between]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Interpolate]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(6, Infinity), $778943ec39690f8e$var$hasEvenArgs, $778943ec39690f8e$var$withInterpolateArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Case]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(3, Infinity), $778943ec39690f8e$var$hasOddArgs, $778943ec39690f8e$var$withCaseArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.In]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withInArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.Number]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.String]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$ec4c9a150bae86cd)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Array]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, Infinity), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Color]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 4), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Band]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 3), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$86a7aca748b1e260)),
    [$778943ec39690f8e$export$2655e45458bc48f3.Palette]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(2, 2), $778943ec39690f8e$var$withPaletteArgs),
    [$778943ec39690f8e$export$2655e45458bc48f3.ToString]: $778943ec39690f8e$var$createCallExpressionParser($778943ec39690f8e$var$hasArgsCount(1, 1), $778943ec39690f8e$var$withArgsOfType($778943ec39690f8e$export$240f7fffab1b25a0 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, number, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case "number":
                args[i] = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, key);
                break;
            case "string":
                args[i] = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.add(String(key));
    }
    return args;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withVarArgs(encoded, returnType, context) {
    const name = encoded[1];
    if (typeof name !== "string") throw new Error("expected a string argument for var operation");
    context.variables.add(name);
    return [
        new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$2b93044cbf134323, name)
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? "" : "s";
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $778943ec39690f8e$var$withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $778943ec39690f8e$var$hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const inputType = $778943ec39690f8e$export$2b93044cbf134323 | $778943ec39690f8e$export$86a7aca748b1e260 | $778943ec39690f8e$export$240f7fffab1b25a0;
    const input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], inputType, context);
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], input.type, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case "linear":
            base = 1;
            break;
        case "exponential":
            const b = interpolationType[1];
            if (typeof b !== "number" || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new $778943ec39690f8e$export$eb63e96e0913dda4($778943ec39690f8e$export$86a7aca748b1e260, base);
    let input;
    try {
        input = $778943ec39690f8e$export$98e6a39c04603d36(encoded[2], $778943ec39690f8e$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 3], $778943ec39690f8e$export$86a7aca748b1e260, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withCaseArgs(encoded, returnType, context) {
    const fallback = $778943ec39690f8e$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 1], $778943ec39690f8e$export$240f7fffab1b25a0, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = $778943ec39690f8e$export$98e6a39c04603d36(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {number}
   */ let needleType;
    if (typeof haystack[0] === "string") {
        if (haystack[0] !== "literal") throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
        if (!Array.isArray(haystack[1])) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
        haystack = haystack[1];
        needleType = $778943ec39690f8e$export$2b93044cbf134323;
    } else needleType = $778943ec39690f8e$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = $778943ec39690f8e$export$98e6a39c04603d36(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type ArgValidator
 */ function $778943ec39690f8e$var$withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = $778943ec39690f8e$export$98e6a39c04603d36(encoded[1], $778943ec39690f8e$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error("the second argument of palette must be an array");
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = $778943ec39690f8e$export$98e6a39c04603d36(colors[i], $778943ec39690f8e$export$2cd82751acc0e609, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof $778943ec39690f8e$export$eb63e96e0913dda4)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function $778943ec39690f8e$var$createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error("expected last argument validator to return the parsed args");
                args = parsed;
            }
        }
        return new $778943ec39690f8e$export$6f3d80189eb72cd4(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {number} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function $778943ec39690f8e$var$parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = $778943ec39690f8e$var$parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function $778943ec39690f8e$export$8da88d86d10c1295(geometry) {
    if (!geometry) return "";
    const type = geometry.getType();
    switch(type){
        case "Point":
        case "LineString":
        case "Polygon":
            return type;
        case "MultiPoint":
        case "MultiLineString":
        case "MultiPolygon":
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case "Circle":
            return "Polygon";
        case "GeometryCollection":
            return $778943ec39690f8e$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return "";
    }
}



/**
 * @module ol/expr/cpu
 */ 

function $d597295b1f166e98$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ""
    };
}
function $d597295b1f166e98$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $778943ec39690f8e$export$98e6a39c04603d36)(encoded, type, context);
    return $d597295b1f166e98$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileExpression(expression, context) {
    if (expression instanceof (0, $778943ec39690f8e$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $778943ec39690f8e$export$2cd82751acc0e609) && typeof expression.value === "string") {
            const colorValue = (0, $322346e1ff7894ca$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Number:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).String:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Coalesce:
            return $d597295b1f166e98$var$compileAssertionExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Get:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Var:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Has:
            return $d597295b1f166e98$var$compileAccessorExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Id:
            return (context)=>context.featureId;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GeometryType:
            return (context)=>context.geometryType;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Concat:
            {
                const args = expression.args.map((e)=>$d597295b1f166e98$var$compileExpression(e, context));
                return (context)=>"".concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Resolution:
            return (context)=>context.resolution;
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Any:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).All:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Between:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).In:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Not:
            return $d597295b1f166e98$var$compileLogicalExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Equal:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).NotEqual:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $d597295b1f166e98$var$compileComparisonExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Multiply:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Divide:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Add:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Subtract:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Clamp:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Mod:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Pow:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Abs:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Floor:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Ceil:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Round:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sin:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Cos:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Atan:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sqrt:
            return $d597295b1f166e98$var$compileNumericExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Case:
            return $d597295b1f166e98$var$compileCaseExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Match:
            return $d597295b1f166e98$var$compileMatchExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Interpolate:
            return $d597295b1f166e98$var$compileInterpolateExpression(expression, context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).ToString:
            return $d597295b1f166e98$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== "undefined" && value !== null) return value;
                }
                throw new Error("Expected one of the values to be non-null");
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Number:
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Var:
            return (context)=>context.variables[name];
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $d597295b1f166e98$var$compileExpression(expression.args[0], context);
    const right = $d597295b1f166e98$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Equal:
            return (context)=>left(context) === right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $322346e1ff7894ca$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $d597295b1f166e98$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $d597295b1f166e98$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $d597295b1f166e98$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $d597295b1f166e98$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $778943ec39690f8e$export$2655e45458bc48f3).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $778943ec39690f8e$export$2cd82751acc0e609)) return (0, $322346e1ff7894ca$export$f84e8e69fd4488a5)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $d597295b1f166e98$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $d597295b1f166e98$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $322346e1ff7894ca$export$44fb54fa2e0c0d4)(rgba1);
    const lcha2 = (0, $322346e1ff7894ca$export$44fb54fa2e0c0d4)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $d597295b1f166e98$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $d597295b1f166e98$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $322346e1ff7894ca$export$a3295358bff77e)((0, $322346e1ff7894ca$export$27cc94530c050f00)(lcha));
}




/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $6000539d86fde80c$var$always(context) {
    return true;
}
function $6000539d86fde80c$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $778943ec39690f8e$export$1c8b4c1584800354)();
    const evaluator = $6000539d86fde80c$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $d597295b1f166e98$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $778943ec39690f8e$export$8da88d86d10c1295)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $6000539d86fde80c$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $778943ec39690f8e$export$1c8b4c1584800354)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $6000539d86fde80c$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $d597295b1f166e98$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $6000539d86fde80c$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = "filter" in rule ? (0, $d597295b1f166e98$export$b5f535122a9211f0)(rule.filter, (0, $778943ec39690f8e$export$240f7fffab1b25a0), context) : $6000539d86fde80c$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $6000539d86fde80c$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $6000539d86fde80c$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $6000539d86fde80c$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, "", context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, "", context);
    const evaluateText = $6000539d86fde80c$var$buildText(flatStyle, context);
    const evaluateImage = $6000539d86fde80c$var$buildImage(flatStyle, context);
    const evaluateZIndex = $6000539d86fde80c$var$numberEvaluator(flatStyle, "z-index", context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error("No fill, stroke, point, or text symbolizer properties in style: " + JSON.stringify(flatStyle));
    const style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $6000539d86fde80c$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + "fill-pattern-src" in flatStyle) evaluateColor = $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix + "fill-", context);
    else {
        if (flatStyle[prefix + "fill-color"] === "none") // avoids hit detection
        return (context)=>null;
        evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "fill-color", context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, $322346e1ff7894ca$export$6c844c64a5efe1ee)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-width", context);
    const evaluateColor = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "stroke-color", context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "stroke-line-cap", context);
    const evaluateLineJoin = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "stroke-line-join", context);
    const evaluateLineDash = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + "stroke-line-dash", context);
    const evaluateLineDashOffset = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-line-dash-offset", context);
    const evaluateMiterLimit = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "stroke-miter-limit", context);
    const stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, $322346e1ff7894ca$export$6c844c64a5efe1ee)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== "butt" && lineCap !== "round" && lineCap !== "square") throw new Error("Expected butt, round, or square line cap");
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== "bevel" && lineJoin !== "round" && lineJoin !== "miter") throw new Error("Expected bevel, round, or miter line join");
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $6000539d86fde80c$var$buildText(flatStyle, context) {
    const prefix = "text-";
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "value", context);
    if (!evaluateValue) return null;
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix + "background-", context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix + "background-", context);
    const evaluateFont = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "font", context);
    const evaluateMaxAngle = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "max-angle", context);
    const evaluateOffsetX = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "offset-x", context);
    const evaluateOffsetY = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "offset-y", context);
    const evaluateOverflow = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "overflow", context);
    const evaluatePlacement = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "placement", context);
    const evaluateRepeat = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "repeat", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateAlign = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "align", context);
    const evaluateJustify = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "justify", context);
    const evaluateBaseline = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "baseline", context);
    const evaluatePadding = $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, prefix + "padding", context);
    // The following properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const text = new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== "point" && placement !== "line") throw new Error("Expected point or line for text-placement");
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== "left" && textAlign !== "center" && textAlign !== "right" && textAlign !== "end" && textAlign !== "start") throw new Error("Expected left, right, center, start, or end for text-align");
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== "left" && justify !== "right" && justify !== "center") throw new Error("Expected left, right, or center for text-justify");
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== "bottom" && textBaseline !== "top" && textBaseline !== "middle" && textBaseline !== "alphabetic" && textBaseline !== "hanging") throw new Error("Expected bottom, top, middle, alphabetic, or hanging for text-baseline");
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildImage(flatStyle, context) {
    if ("icon-src" in flatStyle) return $6000539d86fde80c$var$buildIcon(flatStyle, context);
    if ("shape-points" in flatStyle) return $6000539d86fde80c$var$buildShape(flatStyle, context);
    if ("circle-radius" in flatStyle) return $6000539d86fde80c$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $6000539d86fde80c$var$buildIcon(flatStyle, context) {
    const prefix = "icon-";
    // required property
    const srcName = prefix + "src";
    const src = $6000539d86fde80c$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "anchor", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateOpacity = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "opacity", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + "anchor-origin");
    const anchorXUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-x-units");
    const anchorYUnits = $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, prefix + "anchor-y-units");
    const color = $6000539d86fde80c$var$optionalColorLike(flatStyle, prefix + "color");
    const crossOrigin = $6000539d86fde80c$var$optionalString(flatStyle, prefix + "cross-origin");
    const offset = $6000539d86fde80c$var$optionalNumberArray(flatStyle, prefix + "offset");
    const offsetOrigin = $6000539d86fde80c$var$optionalIconOrigin(flatStyle, prefix + "offset-origin");
    const width = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "width");
    const height = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "height");
    const size = $6000539d86fde80c$var$optionalSize(flatStyle, prefix + "size");
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const icon = new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        color: color,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $6000539d86fde80c$var$buildShape(flatStyle, context) {
    const prefix = "shape-";
    // required property
    const pointsName = prefix + "points";
    const radiusName = prefix + "radius";
    const points = $6000539d86fde80c$var$requireNumber(flatStyle[pointsName], pointsName);
    const radius = $6000539d86fde80c$var$requireNumber(flatStyle[radiusName], radiusName);
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    const radius2 = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "radius2");
    const angle = $6000539d86fde80c$var$optionalNumber(flatStyle, prefix + "angle");
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const shape = new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        points: points,
        radius: radius,
        radius2: radius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $6000539d86fde80c$var$buildCircle(flatStyle, context) {
    const prefix = "circle-";
    // settable properties
    const evaluateFill = $6000539d86fde80c$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $6000539d86fde80c$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "radius", context);
    const evaluateScale = $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, prefix + "scale", context);
    const evaluateDisplacement = $6000539d86fde80c$var$coordinateEvaluator(flatStyle, prefix + "displacement", context);
    const evaluateRotation = $6000539d86fde80c$var$numberEvaluator(flatStyle, prefix + "rotation", context);
    const evaluateRotateWithView = $6000539d86fde80c$var$booleanEvaluator(flatStyle, prefix + "rotate-with-view", context);
    // the remaining properties are not currently settable
    const declutterMode = $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, prefix + "declutter-mode");
    const circle = new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $6000539d86fde80c$var$numberEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return undefined;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$86a7aca748b1e260), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$stringEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$2b93044cbf134323), context);
    return function(context) {
        return $6000539d86fde80c$var$requireString(evaluator(context), name);
    };
}
function $6000539d86fde80c$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $6000539d86fde80c$var$stringEvaluator(flatStyle, prefix + "pattern-src", context);
    const offsetEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + "pattern-offset", context);
    const patternSizeEvaluator = $6000539d86fde80c$var$sizeEvaluator(flatStyle, prefix + "pattern-size", context);
    const colorEvaluator = $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, prefix + "color", context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$booleanEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$240f7fffab1b25a0), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== "boolean") throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$colorLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$2cd82751acc0e609), context);
    return function(context) {
        return $6000539d86fde80c$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$numberArrayEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$coordinateEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        const array = $6000539d86fde80c$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $6000539d86fde80c$var$sizeLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $d597295b1f166e98$export$b5f535122a9211f0)(flatStyle[name], (0, $778943ec39690f8e$export$d701d0e49f4bcb39) | (0, $778943ec39690f8e$export$86a7aca748b1e260), context);
    return function(context) {
        return $6000539d86fde80c$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $6000539d86fde80c$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== "number") throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $6000539d86fde80c$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === "number") return (0, $cc435a5409103773$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== "number" || typeof encoded[1] !== "number") throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $6000539d86fde80c$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $6000539d86fde80c$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "bottom-left" && encoded !== "bottom-right" && encoded !== "top-left" && encoded !== "top-right") throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $6000539d86fde80c$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== "pixels" && encoded !== "fraction") throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $6000539d86fde80c$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $6000539d86fde80c$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== "string") throw new Error(`Expected a string for ${property}`);
    if (encoded !== "declutter" && encoded !== "obstacle" && encoded !== "none") throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|Array<number>|undefined} A string or an array of color values or undefined.
 */ function $6000539d86fde80c$var$optionalColorLike(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $6000539d86fde80c$var$requireColorLike(encoded, property);
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $6000539d86fde80c$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== "number") throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $6000539d86fde80c$var$requireString(value, property) {
    if (typeof value !== "string") throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $6000539d86fde80c$var$requireNumber(value, property) {
    if (typeof value !== "number") throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $6000539d86fde80c$var$requireColorLike(value, property) {
    if (typeof value === "string") return value;
    const array = $6000539d86fde80c$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSize(value, property) {
    const size = $6000539d86fde80c$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $6000539d86fde80c$var$requireSizeLike(value, property) {
    if (typeof value === "number") return value;
    return $6000539d86fde80c$var$requireSize(value, property);
}


/**
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $c8d6dc4c09ed9916$var$Property = {
    RENDER_ORDER: "renderOrder"
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class $c8d6dc4c09ed9916$var$BaseVectorLayer extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
   *     order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($c8d6dc4c09ed9916$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($c8d6dc4c09ed9916$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6) : style;
        const styleLike = $c8d6dc4c09ed9916$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $8c7f6dda98e8cb9c$export$c314ea3f6b164147)(styleLike);
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $c8d6dc4c09ed9916$var$toStyleLike(style) {
    if (style === undefined) return 0, $8c7f6dda98e8cb9c$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === "function") return style;
    if (style instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $6000539d86fde80c$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039))) throw new Error("Expected a list of style instances");
            styles[i] = candidate;
        }
        return styles;
    }
    if ("style" in first) {
        /**
     * @type Array<import("../style/flat.js").Rule>
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!("style" in candidate)) throw new Error("Expected a list of rules with a style property");
            rules[i] = candidate;
        }
        return (0, $6000539d86fde80c$export$fc6a94152b1b05a8)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $6000539d86fde80c$export$5a130bc4f0a0420b)(flatStyles);
}
var $c8d6dc4c09ed9916$export$2e2bcd8739ae039 = $c8d6dc4c09ed9916$var$BaseVectorLayer;


/**
 * @module ol/renderer/canvas/VectorLayer
 */ /**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Builder
 */ /**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $cf547866e052f25b$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $cf547866e052f25b$export$f21891651e408226 = [
    $cf547866e052f25b$var$Instruction.FILL
];
const $cf547866e052f25b$export$7a98aa5364d62ba8 = [
    $cf547866e052f25b$var$Instruction.STROKE
];
const $cf547866e052f25b$export$9f746cc58a899a00 = [
    $cf547866e052f25b$var$Instruction.BEGIN_PATH
];
const $cf547866e052f25b$export$89b10f327e413e71 = [
    $cf547866e052f25b$var$Instruction.CLOSE_PATH
];
var $cf547866e052f25b$export$2e2bcd8739ae039 = $cf547866e052f25b$var$Instruction;



/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $eb0e5c3938110b4c$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $eb0e5c3938110b4c$export$2e2bcd8739ae039 = $eb0e5c3938110b4c$var$VectorContext;







class $2bb20f8873deb436$var$CanvasBuilder extends (0, $eb0e5c3938110b4c$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $6da4c8ed3074c92b$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $dab4245bc22b806c$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case "MultiPolygon":
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$915c7058aeb4dfeb),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$915c7058aeb4dfeb),
                    index
                ]);
                break;
            case "Polygon":
            case "MultiLineString":
                builderEnds = [];
                flatCoordinates = type == "Polygon" ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$cbb9596fc0f40db2),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$cbb9596fc0f40db2),
                    index
                ]);
                break;
            case "LineString":
            case "Circle":
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                    index
                ]);
                break;
            case "MultiPoint":
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $5454470599558ddd$export$9c0934e4e9c3f61e),
                        index
                    ]);
                }
                break;
            case "Point":
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $b998d41b678ed5d1$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === "object" && "src" in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== "string") // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            this.applyPixelRatio(state.lineDash),
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== "string" || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $2bb20f8873deb436$export$2e2bcd8739ae039 = $2bb20f8873deb436$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 


class $b652f9dd73b29cfe$var$CanvasImageBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $b652f9dd73b29cfe$export$2e2bcd8739ae039 = $b652f9dd73b29cfe$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 


class $a207f23baa5aa2c5$var$CanvasLineStringBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        const moveToLineToInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ], (0, $cf547866e052f25b$export$9f746cc58a899a00));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
    }
}
var $a207f23baa5aa2c5$export$2e2bcd8739ae039 = $a207f23baa5aa2c5$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 



class $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            const moveToLineToInstruction = [
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $cf547866e052f25b$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
            (0, $d4aabc5c971073f1$export$e06efc2409049f76)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $8780aae6970f5f65$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        const fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    }
}
var $7d2e8ba11a45ae8a$export$2e2bcd8739ae039 = $7d2e8ba11a45ae8a$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 






function $7704cc1df2ddb619$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $79529ab61b92f869$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}


const $8243e906fae47bbe$export$91a016276e4aee96 = {
    "left": 0,
    "center": 0.5,
    "right": 1,
    "top": 0,
    "middle": 0.5,
    "hanging": 0.2,
    "alphabetic": 0.8,
    "ideographic": 0.8,
    "bottom": 1
};
class $8243e906fae47bbe$var$CanvasTextBuilder extends (0, $2bb20f8873deb436$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $d4aabc5c971073f1$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = "";
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = "";
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === "" || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === "line" && (geometryType == "LineString" || geometryType == "MultiLineString" || geometryType == "Polygon" || geometryType == "MultiPolygon")) {
            if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == "LineString") ends = [
                flatCoordinates.length
            ];
            else if (geometryType == "MultiLineString") ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == "Polygon") ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == "MultiPolygon") {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $7704cc1df2ddb619$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $79529ab61b92f869$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case "Point":
                case "MultiPoint":
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case "LineString":
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case "Circle":
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case "MultiLineString":
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case "Polygon":
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case "MultiPolygon":
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            if (textState.backgroundFill || textState.backgroundStroke) {
                this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                if (textState.backgroundFill) this.updateFillStyle(this.state, this.createFill);
                if (textState.backgroundStroke) {
                    this.updateStrokeStyle(this.state, this.applyStroke);
                    this.hitDetectionInstructions.push(this.createStroke(this.state));
                }
            }
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $d4aabc5c971073f1$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $d4aabc5c971073f1$export$40a9eeef55665a40) ? (0, $d4aabc5c971073f1$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const currentFillStyle = this.state.fillStyle;
            if (textState.backgroundFill) {
                this.state.fillStyle = (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2);
                this.hitDetectionInstructions.push(this.createFill(this.state));
            }
            this.hitDetectionInstructions.push([
                (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            // Reset previous fill
            if (textState.backgroundFill) {
                this.state.fillStyle = currentFillStyle;
                this.hitDetectionInstructions.push(this.createFill(this.state));
            }
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $8243e906fae47bbe$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_
        ]);
        this.hitDetectionInstructions.push([
            (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = "";
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $d4aabc5c971073f1$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $d4aabc5c971073f1$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $d4aabc5c971073f1$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $d4aabc5c971073f1$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa);
            (0, $d4aabc5c971073f1$export$a534074a28fa87ff)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || "";
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == "string" ? strokeState.strokeStyle : (0, $6c5e11070e371322$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + "|" + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + "[" + strokeState.lineDash.join() + "]" : "";
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || "?") + (textState.repeat || "?") + (textState.justify || "?") + (textState.textBaseline || "?");
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == "string" ? fillState.fillStyle : "|" + (0, $6c5e11070e371322$export$5e82334337e0f204)(fillState.fillStyle) : "";
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $8243e906fae47bbe$export$2e2bcd8739ae039 = $8243e906fae47bbe$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $e22658f4b743550b$var$BATCH_CONSTRUCTORS = {
    "Circle": (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    "Default": (0, $2bb20f8873deb436$export$2e2bcd8739ae039),
    "Image": (0, $b652f9dd73b29cfe$export$2e2bcd8739ae039),
    "LineString": (0, $a207f23baa5aa2c5$export$2e2bcd8739ae039),
    "Polygon": (0, $7d2e8ba11a45ae8a$export$2e2bcd8739ae039),
    "Text": (0, $8243e906fae47bbe$export$2e2bcd8739ae039)
};
class $e22658f4b743550b$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : "0";
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $e22658f4b743550b$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $e22658f4b743550b$export$2e2bcd8739ae039 = $e22658f4b743550b$var$BuilderGroup;


/**
 * @module ol/renderer/canvas/Layer
 */ /**
 * @module ol/renderer/Layer
 */ 



const $cb18cdefd702a327$var$maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $cb18cdefd702a327$var$LayerRenderer extends (0, $1f093ab5083c8a1f$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = $cb18cdefd702a327$var$maxStaleKeys;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED && imageState != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === "ready") layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $cb18cdefd702a327$export$2e2bcd8739ae039 = $cb18cdefd702a327$var$LayerRenderer;


/**
 * @module ol/render/Event
 */ 
class $b80dddceb0c42ad4$var$RenderEvent extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $b80dddceb0c42ad4$export$2e2bcd8739ae039 = $b80dddceb0c42ad4$var$RenderEvent;



/**
 * @module ol/render/canvas/ZIndexContext
 */ 
/** @typedef {CanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $c1cb593c98d2cbd0$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $075f937d7366f1a2$export$fcb72ce088a6632c)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $075f937d7366f1a2$export$fcb72ce088a6632c)()[property] !== "function") // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property, value);
                return true;
            }
        });
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.instructions_[this.zIndex + this.offset_].push(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.instructions_[this.zIndex + this.offset_].push(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === "function") {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === "function") /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === "function") {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $c1cb593c98d2cbd0$export$2e2bcd8739ae039 = $c1cb593c98d2cbd0$var$ZIndexContext;







const $42152f52b26b6ca7$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ let $42152f52b26b6ca7$var$pixelContext = null;
function $42152f52b26b6ca7$var$createPixelContext() {
    $42152f52b26b6ca7$var$pixelContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $42152f52b26b6ca7$var$CanvasLayerRenderer extends (0, $cb18cdefd702a327$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$42152f52b26b6ca7$var$pixelContext) $42152f52b26b6ca7$var$createPixelContext();
        $42152f52b26b6ca7$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $42152f52b26b6ca7$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $42152f52b26b6ca7$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch (err) {
            $42152f52b26b6ca7$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === "function") background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $b998d41b678ed5d1$export$e9bab7fafb253603)((0, $322346e1ff7894ca$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $322346e1ff7894ca$export$75093a47a9fa838d)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext("2d");
        }
        if (context && context.canvas.style.transform === transform) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = document.createElement("div");
            container.className = layerClassName;
            let style = container.style;
            style.position = "absolute";
            style.width = "100%";
            style.height = "100%";
            context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)();
            const canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = "absolute";
            style.left = "0";
            style.transformOrigin = "top left";
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        const topRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent);
        const bottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent);
        const bottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $e22e7611e69f42a9$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $c1cb593c98d2cbd0$export$2e2bcd8739ae039)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $42152f52b26b6ca7$export$2e2bcd8739ae039 = $42152f52b26b6ca7$var$CanvasLayerRenderer;


/**
 * @module ol/render/canvas/ExecutorGroup
 */ /**
 * @module ol/render/canvas/Executor
 */ 





/**
 * @module ol/geom/flat/textpath
 */ 

function $f6421f31729929e6$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const beginY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const endY = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright
    let reverse;
    if (rotation) {
        const flat = [
            beginX,
            beginY,
            endX,
            endY
        ];
        (0, $14c6e714516e527b$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
        reverse = flat[0] > flat[2];
    } else reverse = beginX > endX;
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, " "); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        const y = (0, $6b000a049d919fe5$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}





/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $6526fa4ee42dc39d$var$tmpExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $6526fa4ee42dc39d$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function $6526fa4ee42dc39d$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $6526fa4ee42dc39d$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ "[" + String.fromCharCode(0x00591) + "-" + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + "-" + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + "-" + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + "-" + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + "-" + String.fromCharCode(0x1efff) + "]");
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $6526fa4ee42dc39d$var$horizontalTextAlign(text, align) {
    if (align === "start") align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? "right" : "left";
    else if (align === "end") align = $6526fa4ee42dc39d$var$rtlRegEx.test(text) ? "left" : "right";
    return (0, $8243e906fae47bbe$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $6526fa4ee42dc39d$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push("\n", "");
    acc.push(line, "");
    return acc;
}
class $6526fa4ee42dc39d$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $c1cb593c98d2cbd0$export$2e2bcd8739ae039)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, $8243e906fae47bbe$export$91a016276e4aee96)[textState.justify] : $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split("\n").reduce($6526fa4ee42dc39d$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $d4aabc5c971073f1$export$7d7c13020df1e791)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push("scale", scale);
        if (strokeKey) {
            contextInstructions.push("strokeStyle", strokeState.strokeStyle);
            contextInstructions.push("lineWidth", strokeWidth);
            contextInstructions.push("lineCap", strokeState.lineCap);
            contextInstructions.push("lineJoin", strokeState.lineJoin);
            contextInstructions.push("miterLimit", strokeState.miterLimit);
            contextInstructions.push("setLineDash", [
                strokeState.lineDash
            ]);
            contextInstructions.push("lineDashOffset", strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push("fillStyle", fillState.fillStyle);
        contextInstructions.push("textBaseline", "middle");
        contextInstructions.push("textAlign", "center");
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === "\n") {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push("font", font);
                if (fillKey) fillInstructions.push("font", font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push("strokeText", fillStrokeArgs);
            if (fillKey) fillInstructions.push("fillText", fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $6526fa4ee42dc39d$var$p1[0] = boxX;
            $6526fa4ee42dc39d$var$p4[0] = boxX;
            $6526fa4ee42dc39d$var$p1[1] = boxY;
            $6526fa4ee42dc39d$var$p2[1] = boxY;
            $6526fa4ee42dc39d$var$p2[0] = boxX + boxW;
            $6526fa4ee42dc39d$var$p3[0] = $6526fa4ee42dc39d$var$p2[0];
            $6526fa4ee42dc39d$var$p3[1] = boxY + boxH;
            $6526fa4ee42dc39d$var$p4[1] = $6526fa4ee42dc39d$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)((0, $e22e7611e69f42a9$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p1);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p2);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p3);
            (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(transform, $6526fa4ee42dc39d$var$p4);
            (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.min($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), Math.max($6526fa4ee42dc39d$var$p1[0], $6526fa4ee42dc39d$var$p2[0], $6526fa4ee42dc39d$var$p3[0], $6526fa4ee42dc39d$var$p4[0]), Math.max($6526fa4ee42dc39d$var$p1[1], $6526fa4ee42dc39d$var$p2[1], $6526fa4ee42dc39d$var$p3[1], $6526fa4ee42dc39d$var$p4[1]), $6526fa4ee42dc39d$var$tmpExtent);
        } else (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $6526fa4ee42dc39d$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $6526fa4ee42dc39d$var$tmpExtent[0],
                minY: $6526fa4ee42dc39d$var$tmpExtent[1],
                maxX: $6526fa4ee42dc39d$var$tmpExtent[2],
                maxY: $6526fa4ee42dc39d$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $6526fa4ee42dc39d$var$p1, $6526fa4ee42dc39d$var$p2, $6526fa4ee42dc39d$var$p3, $6526fa4ee42dc39d$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $d4aabc5c971073f1$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $6526fa4ee42dc39d$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $d4aabc5c971073f1$export$94d53b95641b5766));
        const baseline = (0, $8243e906fae47bbe$export$91a016276e4aee96)[textState.textBaseline || (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $b998d41b678ed5d1$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $e22e7611e69f42a9$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        let lastFillInstruction = null;
        let lastStrokeInstruction = null;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2];
                    const y2 = pixelCoordinates[d + 3];
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || "declutter";
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFill, backgroundStroke;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFill = /** @type {boolean} */ instruction[17];
                        backgroundStroke = /** @type {boolean} */ instruction[18];
                    } else {
                        padding = (0, $d4aabc5c971073f1$export$40a9eeef55665a40);
                        backgroundFill = false;
                        backgroundStroke = false;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, backgroundFill || backgroundStroke, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFill ? /** @type {Array<*>} */ lastFillInstruction : null,
                            backgroundStroke ? /** @type {Array<*>} */ lastStrokeInstruction : null
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $6526fa4ee42dc39d$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== "declutter" || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== "declutter" || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === "declutter" && declutterMode === "declutter") {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== "none") declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== "none") declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string} */ instruction[11];
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || "declutter";
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $bf04349d827c1d16$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $d4aabc5c971073f1$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $6526fa4ee42dc39d$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $f6421f31729929e6$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $d4aabc5c971073f1$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, "", strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === "declutter" && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, "");
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $d4aabc5c971073f1$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === "declutter" && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== "none") declutterTree.load(replayImageOrLabelArgs.map($6526fa4ee42dc39d$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $cf547866e052f25b$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $6526fa4ee42dc39d$export$2e2bcd8739ae039 = $6526fa4ee42dc39d$var$Executor;








const $a34a824d875e4ea1$export$61b49a5ae59d663 = [
    "Polygon",
    "Circle",
    "LineString",
    "Image",
    "Text",
    "Default"
];
const $a34a824d875e4ea1$export$6195a93a6c97ce02 = [
    "Image",
    "Text"
];
const $a34a824d875e4ea1$export$d0fe61ccfaa1ca87 = $a34a824d875e4ea1$export$61b49a5ae59d663.filter((builderType)=>!$a34a824d875e4ea1$export$6195a93a6c97ce02.includes(builderType));
class $a34a824d875e4ea1$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $6526fa4ee42dc39d$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(contextSize, contextSize, undefined, {
            willReadFrequently: true
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /**
     * @type {import("../../extent.js").Extent}
     */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $a34a824d875e4ea1$export$96fc84ea21b8269f(hitTolerance);
        let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === "none" || builderType !== "Image" && builderType !== "Text" || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $a34a824d875e4ea1$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $a34a824d875e4ea1$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $beaefe87199bb537$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        builderTypes = builderTypes ? builderTypes : $a34a824d875e4ea1$export$61b49a5ae59d663;
        const maxBuilderTypes = $a34a824d875e4ea1$export$61b49a5ae59d663.length;
        let i, ii, j, jj, replays;
        if (declutterTree) zs.reverse();
        for(i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            replays = this.executorsByZIndex_[zIndexKey];
            for(j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== "Image" && builderType !== "Text";
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === "Text" || builderType === "Image") replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + j;
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $a34a824d875e4ea1$var$circlePixelIndexArrayCache = {};
function $a34a824d875e4ea1$export$96fc84ea21b8269f(radius) {
    if ($a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] !== undefined) return $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $a34a824d875e4ea1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $a34a824d875e4ea1$export$2e2bcd8739ae039 = $a34a824d875e4ea1$var$ExecutorGroup;




/**
 * @module ol/render/canvas/hitdetect
 */ /**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?









/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $7b0c2128a27f5020$var$CanvasImmediateRenderer extends (0, $eb0e5c3938110b4c$export$2e2bcd8739ae039) {
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $6b000a049d919fe5$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = "";
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === "") return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close) {
        const context = this.context_;
        const pixelCoordinates = (0, $14c6e714516e527b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $c76e993e57efc8c4$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case "Point":
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case "LineString":
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case "Polygon":
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case "MultiPoint":
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case "MultiLineString":
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case "MultiPolygon":
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case "GeometryCollection":
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case "Circle":
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== "") this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== "") {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== "") {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== "") {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc);
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = "";
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $d4aabc5c971073f1$export$c495d52ee3fd74b2))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $d4aabc5c971073f1$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $d4aabc5c971073f1$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $d4aabc5c971073f1$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $d4aabc5c971073f1$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $d4aabc5c971073f1$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $d4aabc5c971073f1$export$80c1c01844597b7b),
                    strokeStyle: (0, $e0807f400ec9a0a9$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $d4aabc5c971073f1$export$1eb2eaecacf2031e))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $d4aabc5c971073f1$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $d4aabc5c971073f1$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $d4aabc5c971073f1$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? " " : t, "") : textText : "";
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $7b0c2128a27f5020$export$2e2bcd8739ae039 = $7b0c2128a27f5020$var$CanvasImmediateRenderer;








const $13dfa0283bf5c35f$export$ab51038298418f25 = 0.5;
function $13dfa0283bf5c35f$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection) : extent;
    const width = size[0] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const height = size[1] * $13dfa0283bf5c35f$export$ab51038298418f25;
    const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $7b0c2128a27f5020$export$2e2bcd8739ae039)(context, $13dfa0283bf5c35f$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $9c4744460e43e41b$export$e3c4995a701c26a3)((0, $9c4744460e43e41b$export$3973b77d5f6f2790)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, "#00000");
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: "pixels",
                    anchorYUnits: "pixels",
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType["Polygon"] = [];
                byGeometryType["Circle"] = [];
                byGeometryType["LineString"] = [];
                byGeometryType["Point"] = [];
            }
            const type = geometry.getType();
            if (type === "GeometryCollection") {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace("Multi", "")].push(geometry, style);
                }
            } else byGeometryType[type.replace("Multi", "")].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $13dfa0283bf5c35f$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $13dfa0283bf5c35f$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}




/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $4b9ac454600c05d2$var$GEOMETRY_RENDERERS = {
    "Point": $4b9ac454600c05d2$var$renderPointGeometry,
    "LineString": $4b9ac454600c05d2$var$renderLineStringGeometry,
    "Polygon": $4b9ac454600c05d2$var$renderPolygonGeometry,
    "MultiPoint": $4b9ac454600c05d2$var$renderMultiPointGeometry,
    "MultiLineString": $4b9ac454600c05d2$var$renderMultiLineStringGeometry,
    "MultiPolygon": $4b9ac454600c05d2$var$renderMultiPolygonGeometry,
    "GeometryCollection": $4b9ac454600c05d2$var$renderGeometryCollectionGeometry,
    "Circle": $4b9ac454600c05d2$var$renderCircleGeometry
};
function $4b9ac454600c05d2$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $6c5e11070e371322$export$5e82334337e0f204)(feature2), 10);
}
function $4b9ac454600c05d2$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $4b9ac454600c05d2$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $4b9ac454600c05d2$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), "Circle");
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $4b9ac454600c05d2$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED || imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).ERROR) loading = false;
        else if (imageState == (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $4b9ac454600c05d2$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $4b9ac454600c05d2$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == "GeometryCollection") {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$4b9ac454600c05d2$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), "Default");
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $4b9ac454600c05d2$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), "LineString");
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4b9ac454600c05d2$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $7eb75c96a6b6f2c6$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), "Image");
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4b9ac454600c05d2$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), "Polygon");
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), "Text");
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}






/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $659e0e97392a5f5e$var$CanvasVectorLayerRenderer extends (0, $42152f52b26b6ca7$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.clipped_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $a34a824d875e4ea1$export$61b49a5ae59d663) : declutterable ? (0, $a34a824d875e4ea1$export$6195a93a6c97ce02) : (0, $a34a824d875e4ea1$export$d0fe61ccfaa1ca87), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $42152f52b26b6ca7$export$a166f0857c555517));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(this.context);
            (0, $42152f52b26b6ca7$export$a166f0857c555517).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        this.replayGroup_.renderDeferred();
        if (this.clipped_) this.context.restore();
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTRENDER);
            if (!hasRenderListeners) return null;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipped_ = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            this.clipped_ = render && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (this.clipped_) this.clipUnrotated(context, frameState, layerExtent);
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (!frameState.declutter && this.clipped_) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $13dfa0283bf5c35f$export$ab51038298418f25);
                const height = size[1] * (0, $13dfa0283bf5c35f$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $13dfa0283bf5c35f$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                this.hitDetectionImageData_ = (0, $13dfa0283bf5c35f$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $13dfa0283bf5c35f$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        let result;
        const executorGroups = [
            this.replayGroup_
        ];
        const declutter = this.getLayer().getDeclutter();
        executorGroups.some((executorGroup)=>{
            return result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter && frameState.declutter[declutter] ? frameState.declutter[declutter].all().map((item)=>item.value) : null);
        });
        return result;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING];
        const interacting = frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $4b9ac454600c05d2$export$531ddd8416d52dfc);
        const center = viewState.center.slice();
        const extent = (0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            const gutter = Math.max((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(center, projection);
            const loadExtent = (0, $6da4c8ed3074c92b$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $e22658f4b743550b$export$2e2bcd8739ae039)((0, $4b9ac454600c05d2$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $9c4744460e43e41b$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $4b9ac454600c05d2$export$75084a70d324c1e6)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $a34a824d875e4ea1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $4b9ac454600c05d2$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $659e0e97392a5f5e$export$2e2bcd8739ae039 = $659e0e97392a5f5e$var$CanvasVectorLayerRenderer;


/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class $82a68515bd6ef378$var$VectorLayer extends (0, $c8d6dc4c09ed9916$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $659e0e97392a5f5e$export$2e2bcd8739ae039)(this);
    }
}
var $82a68515bd6ef378$export$2e2bcd8739ae039 = $82a68515bd6ef378$var$VectorLayer;




var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

function $3f9383da7c35acdb$export$b1b72b1c509ed03d(name, key) {
    return `${name}/${key.join("/")}`;
}
function $3f9383da7c35acdb$export$ec0b75c3939f59b7(id) {
    return id.split("/")[0];
}



var $f1q41 = parcelRequire("f1q41");
var $319680b363c8af04$export$60715063f26dc4e3;
(function(PlanStatus) {
    PlanStatus["None"] = "None";
    PlanStatus["Draft"] = "Draft";
    PlanStatus["Submitted"] = "Submitted";
    PlanStatus["Invalid"] = "Invalid";
    PlanStatus["Deleted"] = "Deleted";
})($319680b363c8af04$export$60715063f26dc4e3 || ($319680b363c8af04$export$60715063f26dc4e3 = {}));
function $319680b363c8af04$export$c481faffd44f8c9d(plans) {
    const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(plans, "updated_at_timestamp");
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reduce(sorted, (r, plan)=>{
        if (!r[plan.groupName]) {
            r[plan.groupName] = plan;
            return r;
        }
        const existing = r[plan.groupName];
        if (existing) {
            const keys = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys(plan);
            for (const key of keys){
                const newVal = plan[key];
                if (Array.isArray(newVal) && newVal.length === 0) continue;
                if (newVal && !existing[key]) existing[key] = newVal;
                // If the plan has a value and the dupe as a value,
                // use the plan that has the more recent 'updated_at_timestamp' for this field.
                if (newVal && existing[key]) {
                    if (plan.updated_at_timestamp > existing.updated_at_timestamp) existing[key] = newVal;
                }
            }
        }
        return r;
    }, {});
    const resultValues = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).values(result);
    return resultValues;
}



var $f1q41 = parcelRequire("f1q41");
var $63618293c58b5f80$exports = {};
"use strict";
Object.defineProperty($63618293c58b5f80$exports, "__esModule", {
    value: true
});
function $63618293c58b5f80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $63618293c58b5f80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63618293c58b5f80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63618293c58b5f80$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $63618293c58b5f80$var$_extends() {
    $63618293c58b5f80$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63618293c58b5f80$var$_extends.apply(this, arguments);
}
function $63618293c58b5f80$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $63618293c58b5f80$var$_setPrototypeOf(subClass, superClass);
}
function $63618293c58b5f80$var$_getPrototypeOf(o) {
    $63618293c58b5f80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63618293c58b5f80$var$_getPrototypeOf(o);
}
function $63618293c58b5f80$var$_setPrototypeOf(o, p) {
    $63618293c58b5f80$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63618293c58b5f80$var$_setPrototypeOf(o, p);
}
function $63618293c58b5f80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$_construct(Parent, args, Class) {
    if ($63618293c58b5f80$var$_isNativeReflectConstruct()) $63618293c58b5f80$var$_construct = Reflect.construct;
    else $63618293c58b5f80$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $63618293c58b5f80$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $63618293c58b5f80$var$_construct.apply(null, arguments);
}
function $63618293c58b5f80$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $63618293c58b5f80$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $63618293c58b5f80$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$63618293c58b5f80$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $63618293c58b5f80$var$_construct(Class, arguments, $63618293c58b5f80$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $63618293c58b5f80$var$_setPrototypeOf(Wrapper, Class);
    };
    return $63618293c58b5f80$var$_wrapNativeSuper(Class);
}
function $63618293c58b5f80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $63618293c58b5f80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
}
function $63618293c58b5f80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63618293c58b5f80$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $63618293c58b5f80$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $63618293c58b5f80$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $63618293c58b5f80$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $63618293c58b5f80$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $63618293c58b5f80$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $63618293c58b5f80$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$n = "numeric", $63618293c58b5f80$var$s = "short", $63618293c58b5f80$var$l = "long";
var $63618293c58b5f80$var$DATE_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATE_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_24_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
/**
 * @private
 */ // TYPES
function $63618293c58b5f80$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $63618293c58b5f80$var$isNumber(o) {
    return typeof o === "number";
}
function $63618293c58b5f80$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $63618293c58b5f80$var$isString(o) {
    return typeof o === "string";
}
function $63618293c58b5f80$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES
function $63618293c58b5f80$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
} // OBJECTS AND ARRAYS
function $63618293c58b5f80$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $63618293c58b5f80$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $63618293c58b5f80$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $63618293c58b5f80$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS
function $63618293c58b5f80$var$integerBetween(thing, bottom, top) {
    return $63618293c58b5f80$var$isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x
function $63618293c58b5f80$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $63618293c58b5f80$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $63618293c58b5f80$var$parseInteger(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $63618293c58b5f80$var$parseFloating(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $63618293c58b5f80$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($63618293c58b5f80$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $63618293c58b5f80$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
} // DATE BASICS
function $63618293c58b5f80$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $63618293c58b5f80$var$daysInYear(year) {
    return $63618293c58b5f80$var$isLeapYear(year) ? 366 : 365;
}
function $63618293c58b5f80$var$daysInMonth(year, month) {
    var modMonth = $63618293c58b5f80$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $63618293c58b5f80$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $63618293c58b5f80$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        d.setUTCFullYear(d.getUTCFullYear() - 1900);
    }
    return +d;
}
function $63618293c58b5f80$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $63618293c58b5f80$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING
function $63618293c58b5f80$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $63618293c58b5f80$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
} // signedOffset('-5', '30') -> -330
function $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
} // COERCION
function $63618293c58b5f80$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $63618293c58b5f80$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($63618293c58b5f80$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $63618293c58b5f80$var$asNumber(v);
    }
    return normalized;
}
function $63618293c58b5f80$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + ":" + $63618293c58b5f80$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + $63618293c58b5f80$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $63618293c58b5f80$var$timeObject(obj) {
    return $63618293c58b5f80$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
var $63618293c58b5f80$var$ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z0-9_+-]{1,256}(\/[A-Za-z0-9_+-]{1,256})?)?/;
/**
 * @private
 */ var $63618293c58b5f80$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $63618293c58b5f80$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $63618293c58b5f80$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $63618293c58b5f80$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$monthsNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$monthsShort);
        case "long":
            return [].concat($63618293c58b5f80$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $63618293c58b5f80$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $63618293c58b5f80$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $63618293c58b5f80$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$weekdaysNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$weekdaysShort);
        case "long":
            return [].concat($63618293c58b5f80$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$meridiems = [
    "AM",
    "PM"
];
var $63618293c58b5f80$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $63618293c58b5f80$var$erasShort = [
    "BC",
    "AD"
];
var $63618293c58b5f80$var$erasNarrow = [
    "B",
    "A"
];
function $63618293c58b5f80$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$erasNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$erasShort);
        case "long":
            return [].concat($63618293c58b5f80$var$erasLong);
        default:
            return null;
    }
}
function $63618293c58b5f80$var$meridiemForDateTime(dt) {
    return $63618293c58b5f80$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $63618293c58b5f80$var$weekdayForDateTime(dt, length) {
    return $63618293c58b5f80$var$weekdays(length)[dt.weekday - 1];
}
function $63618293c58b5f80$var$monthForDateTime(dt, length) {
    return $63618293c58b5f80$var$months(length)[dt.month - 1];
}
function $63618293c58b5f80$var$eraForDateTime(dt, length) {
    return $63618293c58b5f80$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $63618293c58b5f80$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $63618293c58b5f80$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $63618293c58b5f80$var$_macroTokenToFormatOpts = {
    D: $63618293c58b5f80$var$DATE_SHORT,
    DD: $63618293c58b5f80$var$DATE_MED,
    DDD: $63618293c58b5f80$var$DATE_FULL,
    DDDD: $63618293c58b5f80$var$DATE_HUGE,
    t: $63618293c58b5f80$var$TIME_SIMPLE,
    tt: $63618293c58b5f80$var$TIME_WITH_SECONDS,
    ttt: $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET,
    tttt: $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET,
    T: $63618293c58b5f80$var$TIME_24_SIMPLE,
    TT: $63618293c58b5f80$var$TIME_24_WITH_SECONDS,
    TTT: $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET,
    f: $63618293c58b5f80$var$DATETIME_SHORT,
    ff: $63618293c58b5f80$var$DATETIME_MED,
    fff: $63618293c58b5f80$var$DATETIME_FULL,
    ffff: $63618293c58b5f80$var$DATETIME_HUGE,
    F: $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS,
    FFF: $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $63618293c58b5f80$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed,
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: false,
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed,
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $63618293c58b5f80$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $63618293c58b5f80$var$padStart(n, p);
        var opts = $63618293c58b5f80$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $63618293c58b5f80$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $63618293c58b5f80$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $63618293c58b5f80$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $63618293c58b5f80$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $63618293c58b5f80$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/**
 * @interface
 */ var $63618293c58b5f80$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $63618293c58b5f80$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton$1 === null) $63618293c58b5f80$var$singleton$1 = new SystemZone();
                return $63618293c58b5f80$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$dtfCache = {};
function $63618293c58b5f80$var$makeDTF(zone) {
    if (!$63618293c58b5f80$var$dtfCache[zone]) $63618293c58b5f80$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $63618293c58b5f80$var$dtfCache[zone];
}
var $63618293c58b5f80$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $63618293c58b5f80$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $63618293c58b5f80$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $63618293c58b5f80$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$63618293c58b5f80$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $63618293c58b5f80$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $63618293c58b5f80$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$63618293c58b5f80$var$ianaZoneCache[name]) $63618293c58b5f80$var$ianaZoneCache[name] = new IANAZone(name);
        return $63618293c58b5f80$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $63618293c58b5f80$var$ianaZoneCache = {};
        $63618293c58b5f80$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale, this.name);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $63618293c58b5f80$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $63618293c58b5f80$var$partsOffset(dtf, date) : $63618293c58b5f80$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
         // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $63618293c58b5f80$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $63618293c58b5f80$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($63618293c58b5f80$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.fixed, format);
    } /** @override **/ ;
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $63618293c58b5f80$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton === null) $63618293c58b5f80$var$singleton = new FixedOffsetZone(0);
                return $63618293c58b5f80$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($63618293c58b5f80$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($63618293c58b5f80$var$Zone);
/**
 * @private
 */ function $63618293c58b5f80$var$normalizeZone(input, defaultZone) {
    if ($63618293c58b5f80$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $63618293c58b5f80$var$Zone) return input;
    else if ($63618293c58b5f80$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "local" || lowered === "system") return defaultZone;
        else if (lowered === "utc" || lowered === "gmt") return $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        else return $63618293c58b5f80$var$FixedOffsetZone.parseSpecifier(lowered) || $63618293c58b5f80$var$IANAZone.create(input);
    } else if ($63618293c58b5f80$var$isNumber(input)) return $63618293c58b5f80$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $63618293c58b5f80$var$InvalidZone(input);
}
var $63618293c58b5f80$var$now = function now() {
    return Date.now();
}, $63618293c58b5f80$var$defaultZone = "system", $63618293c58b5f80$var$defaultLocale = null, $63618293c58b5f80$var$defaultNumberingSystem = null, $63618293c58b5f80$var$defaultOutputCalendar = null, $63618293c58b5f80$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $63618293c58b5f80$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $63618293c58b5f80$var$Locale.resetCache();
        $63618293c58b5f80$var$IANAZone.resetCache();
    };
    $63618293c58b5f80$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $63618293c58b5f80$var$now;
            },
            set: function set(n) {
                $63618293c58b5f80$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $63618293c58b5f80$var$normalizeZone($63618293c58b5f80$var$defaultZone, $63618293c58b5f80$var$SystemZone.instance);
            },
            set: function set(zone) {
                $63618293c58b5f80$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $63618293c58b5f80$var$defaultLocale;
            },
            set: function set(locale) {
                $63618293c58b5f80$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $63618293c58b5f80$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $63618293c58b5f80$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $63618293c58b5f80$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $63618293c58b5f80$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $63618293c58b5f80$var$throwOnInvalid;
            },
            set: function set(t) {
                $63618293c58b5f80$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $63618293c58b5f80$var$_excluded = [
    "base"
], $63618293c58b5f80$var$_excluded2 = [
    "padTo",
    "floor"
];
var $63618293c58b5f80$var$intlLFCache = {};
function $63618293c58b5f80$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $63618293c58b5f80$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlDTCache = {};
function $63618293c58b5f80$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlNumCache = {};
function $63618293c58b5f80$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $63618293c58b5f80$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $63618293c58b5f80$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$intlRelCache = {};
function $63618293c58b5f80$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(_opts, $63618293c58b5f80$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $63618293c58b5f80$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$sysLocaleCache = null;
function $63618293c58b5f80$var$systemLocale() {
    if ($63618293c58b5f80$var$sysLocaleCache) return $63618293c58b5f80$var$sysLocaleCache;
    else {
        $63618293c58b5f80$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $63618293c58b5f80$var$sysLocaleCache;
    }
}
function $63618293c58b5f80$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var smaller = localeStr.substring(0, uIndex);
        try {
            options = $63618293c58b5f80$var$getCachedDTF(localeStr).resolvedOptions();
        } catch (e) {
            options = $63618293c58b5f80$var$getCachedDTF(smaller).resolvedOptions();
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
        return [
            smaller,
            numberingSystem,
            calendar
        ];
    }
}
function $63618293c58b5f80$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $63618293c58b5f80$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $63618293c58b5f80$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $63618293c58b5f80$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(opts, $63618293c58b5f80$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $63618293c58b5f80$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $63618293c58b5f80$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $63618293c58b5f80$var$roundTo(i, 3);
            return $63618293c58b5f80$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        var z;
        if (dt.zone.isUniversal) {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $63618293c58b5f80$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
                // So we have to make do. Two cases:
                // 1. The format options tell us to show the zone. We can't do that, so the best
                // we can do is format the date in UTC.
                // 2. The format options don't tell us to show the zone. Then we can adjust them
                // the time and tell the formatter to show it to us in UTC, so that the time is right
                // and the bad zone doesn't show up.
                z = "UTC";
                if (opts.timeZoneName) this.dt = dt;
                else this.dt = dt.offset === 0 ? dt : $63618293c58b5f80$var$DateTime.fromMillis(dt.ts + dt.offset * 60000);
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else {
            this.dt = dt;
            z = dt.zone.name;
        }
        var intlOpts = $63618293c58b5f80$var$_extends({}, this.opts);
        if (z) intlOpts.timeZone = z;
        this.dtf = $63618293c58b5f80$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        return this.dtf.formatToParts(this.dt.toJSDate());
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $63618293c58b5f80$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $63618293c58b5f80$var$hasRelative()) this.rtf = $63618293c58b5f80$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $63618293c58b5f80$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $63618293c58b5f80$var$Settings.defaultLocale; // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $63618293c58b5f80$var$systemLocale());
        var numberingSystemR = numberingSystem || $63618293c58b5f80$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $63618293c58b5f80$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $63618293c58b5f80$var$sysLocaleCache = null;
        $63618293c58b5f80$var$intlDTCache = {};
        $63618293c58b5f80$var$intlNumCache = {};
        $63618293c58b5f80$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, outputCalendar = _ref.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $63618293c58b5f80$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $63618293c58b5f80$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this.monthsCache[formatStr][length]) _this.monthsCache[formatStr][length] = $63618293c58b5f80$var$mapMonths(function(dt) {
                return _this.extract(dt, intl, "month");
            });
            return _this.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.weekdaysCache[formatStr][length]) _this2.weekdaysCache[formatStr][length] = $63618293c58b5f80$var$mapWeekdays(function(dt) {
                return _this2.extract(dt, intl, "weekday");
            });
            return _this2.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this3 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, undefined, defaultOK, function() {
            return $63618293c58b5f80$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this3.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this3.meridiemCache = [
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 9),
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this3.extract(dt, intl, "dayperiod");
                });
            }
            return _this3.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$eras, function() {
            var intl = {
                era: length
            }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this4.eraCache[length]) _this4.eraCache[length] = [
                $63618293c58b5f80$var$DateTime.utc(-40, 1, 1),
                $63618293c58b5f80$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this4.extract(dt, intl, "era");
            });
            return _this4.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $63618293c58b5f80$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $63618293c58b5f80$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $63618293c58b5f80$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $63618293c58b5f80$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $63618293c58b5f80$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $63618293c58b5f80$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ function $63618293c58b5f80$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $63618293c58b5f80$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $63618293c58b5f80$var$_extends({}, mergedVals, val),
                mergedZone || zone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $63618293c58b5f80$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $63618293c58b5f80$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $63618293c58b5f80$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
} // ISO and SQL parsing
var $63618293c58b5f80$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, $63618293c58b5f80$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, $63618293c58b5f80$var$isoTimeRegex = RegExp("" + $63618293c58b5f80$var$isoTimeBaseRegex.source + $63618293c58b5f80$var$offsetRegex.source + "?"), $63618293c58b5f80$var$isoTimeExtensionRegex = RegExp("(?:T" + $63618293c58b5f80$var$isoTimeRegex.source + ")?"), $63618293c58b5f80$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, $63618293c58b5f80$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/, $63618293c58b5f80$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/, $63618293c58b5f80$var$extractISOWeekData = $63618293c58b5f80$var$simpleParse("weekYear", "weekNumber", "weekDay"), $63618293c58b5f80$var$extractISOOrdinalData = $63618293c58b5f80$var$simpleParse("year", "ordinal"), $63618293c58b5f80$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/, // dumbed-down version of the ISO one
$63618293c58b5f80$var$sqlTimeRegex = RegExp($63618293c58b5f80$var$isoTimeBaseRegex.source + " ?(?:" + $63618293c58b5f80$var$offsetRegex.source + "|(" + $63618293c58b5f80$var$ianaRegex.source + "))?"), $63618293c58b5f80$var$sqlTimeExtensionRegex = RegExp("(?: " + $63618293c58b5f80$var$sqlTimeRegex.source + ")?");
function $63618293c58b5f80$var$int(match, pos, fallback) {
    var m = match[pos];
    return $63618293c58b5f80$var$isUndefined(m) ? fallback : $63618293c58b5f80$var$parseInteger(m);
}
function $63618293c58b5f80$var$extractISOYmd(match, cursor) {
    var item = {
        year: $63618293c58b5f80$var$int(match, cursor),
        month: $63618293c58b5f80$var$int(match, cursor + 1, 1),
        day: $63618293c58b5f80$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractISOTime(match, cursor) {
    var item = {
        hours: $63618293c58b5f80$var$int(match, cursor, 0),
        minutes: $63618293c58b5f80$var$int(match, cursor + 1, 0),
        seconds: $63618293c58b5f80$var$int(match, cursor + 2, 0),
        milliseconds: $63618293c58b5f80$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $63618293c58b5f80$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $63618293c58b5f80$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $63618293c58b5f80$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $63618293c58b5f80$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
} // ISO time parsing
var $63618293c58b5f80$var$isoTimeOnly = RegExp("^T?" + $63618293c58b5f80$var$isoTimeBaseRegex.source + "$"); // ISO duration parsing
var $63618293c58b5f80$var$isoDuration = /^-?P(?:(?:(-?\d{1,9}(?:\.\d{1,9})?)Y)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,9}(?:\.\d{1,9})?)W)?(?:(-?\d{1,9}(?:\.\d{1,9})?)D)?(?:T(?:(-?\d{1,9}(?:\.\d{1,9})?)H)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;
function $63618293c58b5f80$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($63618293c58b5f80$var$parseFloating(yearStr)),
            months: maybeNegate($63618293c58b5f80$var$parseFloating(monthStr)),
            weeks: maybeNegate($63618293c58b5f80$var$parseFloating(weekStr)),
            days: maybeNegate($63618293c58b5f80$var$parseFloating(dayStr)),
            hours: maybeNegate($63618293c58b5f80$var$parseFloating(hourStr)),
            minutes: maybeNegate($63618293c58b5f80$var$parseFloating(minuteStr)),
            seconds: maybeNegate($63618293c58b5f80$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($63618293c58b5f80$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $63618293c58b5f80$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $63618293c58b5f80$var$untruncateYear($63618293c58b5f80$var$parseInteger(yearStr)) : $63618293c58b5f80$var$parseInteger(yearStr),
        month: $63618293c58b5f80$var$monthsShort.indexOf(monthStr) + 1,
        day: $63618293c58b5f80$var$parseInteger(dayStr),
        hour: $63618293c58b5f80$var$parseInteger(hourStr),
        minute: $63618293c58b5f80$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $63618293c58b5f80$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $63618293c58b5f80$var$weekdaysLong.indexOf(weekdayStr) + 1 : $63618293c58b5f80$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
} // RFC 2822/5322
var $63618293c58b5f80$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $63618293c58b5f80$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $63618293c58b5f80$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $63618293c58b5f80$var$FixedOffsetZone(offset)
    ];
}
function $63618293c58b5f80$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date
var $63618293c58b5f80$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $63618293c58b5f80$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
function $63618293c58b5f80$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
var $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoYmdRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoWeekRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoOrdinalRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOWeekTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOWeekData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOOrdinalDateAndTime = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOOrdinalData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
/**
 * @private
 */ function $63618293c58b5f80$var$parseISODate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOWeekTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOOrdinalDateAndTime
    ], [
        $63618293c58b5f80$var$isoTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeAndOffset
    ]);
}
function $63618293c58b5f80$var$parseRFC2822Date(s) {
    return $63618293c58b5f80$var$parse($63618293c58b5f80$var$preprocessRFC2822(s), [
        $63618293c58b5f80$var$rfc2822,
        $63618293c58b5f80$var$extractRFC2822
    ]);
}
function $63618293c58b5f80$var$parseHTTPDate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$rfc1123,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$rfc850,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$ascii,
        $63618293c58b5f80$var$extractASCII
    ]);
}
function $63618293c58b5f80$var$parseISODuration(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoDuration,
        $63618293c58b5f80$var$extractISODuration
    ]);
}
var $63618293c58b5f80$var$extractISOTimeOnly = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime);
function $63618293c58b5f80$var$parseISOTimeOnly(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoTimeOnly,
        $63618293c58b5f80$var$extractISOTimeOnly
    ]);
}
var $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlYmdRegex, $63618293c58b5f80$var$sqlTimeExtensionRegex);
var $63618293c58b5f80$var$sqlTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
function $63618293c58b5f80$var$parseSQL(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeOffsetAndIANAZone
    ], [
        $63618293c58b5f80$var$sqlTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $63618293c58b5f80$var$INVALID$2 = "Invalid Duration"; // unit conversion constants
var $63618293c58b5f80$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $63618293c58b5f80$var$casualMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $63618293c58b5f80$var$lowOrderMatrix), $63618293c58b5f80$var$daysInYearAccurate = 365.2425, $63618293c58b5f80$var$daysInMonthAccurate = 30.436875, $63618293c58b5f80$var$accurateMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 7,
        days: $63618293c58b5f80$var$daysInYearAccurate,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 28,
        days: $63618293c58b5f80$var$daysInYearAccurate / 4,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24 / 4,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440 / 4,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $63618293c58b5f80$var$daysInMonthAccurate / 7,
        days: $63618293c58b5f80$var$daysInMonthAccurate,
        hours: $63618293c58b5f80$var$daysInMonthAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInMonthAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400000
    }
}, $63618293c58b5f80$var$lowOrderMatrix); // units ordered by size
var $63618293c58b5f80$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $63618293c58b5f80$var$reverseUnits = $63618293c58b5f80$var$orderedUnits$1.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
function $63618293c58b5f80$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $63618293c58b5f80$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
    };
    return new $63618293c58b5f80$var$Duration(conf);
}
function $63618293c58b5f80$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters
function $63618293c58b5f80$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $63618293c58b5f80$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters
function $63618293c58b5f80$var$normalizeValues(matrix, vals) {
    $63618293c58b5f80$var$reverseUnits.reduce(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) $63618293c58b5f80$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration#fromMillis}, {@link Duration#fromObject}, or {@link Duration#fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration.months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $63618293c58b5f80$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = accurate ? $63618293c58b5f80$var$accurateMatrix : $63618293c58b5f80$var$casualMatrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $63618293c58b5f80$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $63618293c58b5f80$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($63618293c58b5f80$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $63618293c58b5f80$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $63618293c58b5f80$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $63618293c58b5f80$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $63618293c58b5f80$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        var l = $63618293c58b5f80$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($63618293c58b5f80$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($63618293c58b5f80$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($63618293c58b5f80$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $63618293c58b5f80$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $63618293c58b5f80$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $63618293c58b5f80$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits$1), _step; !(_step = _iterator()).done;){
            var k = _step.value;
            if ($63618293c58b5f80$var$hasOwnProperty(dur.values, k) || $63618293c58b5f80$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++){
            var k = _Object$keys[_i];
            result[k] = $63618293c58b5f80$var$asNumber(fn(this.values[k], k));
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $63618293c58b5f80$var$_extends({}, this.values, $63618293c58b5f80$var$normalizeObject(values, Duration.normalizeUnit));
        return $63618293c58b5f80$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        }), opts = {
            loc: loc
        };
        if (conversionAccuracy) opts.conversionAccuracy = conversionAccuracy;
        return $63618293c58b5f80$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $63618293c58b5f80$var$normalizeValues(this.matrix, vals);
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits$1), _step2; !(_step2 = _iterator2()).done;){
            var k = _step2.value;
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0; // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                } // plus anything that's already in this unit
                if ($63618293c58b5f80$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000; // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($63618293c58b5f80$var$orderedUnits$1.indexOf(down) > $63618293c58b5f80$var$orderedUnits$1.indexOf(k)) $63618293c58b5f80$var$convert(this.matrix, vals, down, built, k);
                 // otherwise, keep it in the wings to boil it later
            } else if ($63618293c58b5f80$var$isNumber(vals[k])) accumulated[k] = vals[k];
        } // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $63618293c58b5f80$var$clone$1(this, {
            values: built
        }, true).normalize();
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++){
            var k = _Object$keys2[_i2];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _iterator3 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits$1), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $63618293c58b5f80$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $63618293c58b5f80$var$INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
function $63618293c58b5f80$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $63618293c58b5f80$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval#fromDateTimes}, {@link Interval#after}, {@link Interval#before}, or {@link Interval#fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval#merge}, {@link Interval#xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $63618293c58b5f80$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $63618293c58b5f80$var$friendlyDateTime(start), builtEnd = $63618293c58b5f80$var$friendlyDateTime(end);
        var validateError = $63618293c58b5f80$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $63618293c58b5f80$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $63618293c58b5f80$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $63618293c58b5f80$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $63618293c58b5f80$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */ ;
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + 1;
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($63618293c58b5f80$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime#toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $63618293c58b5f80$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $63618293c58b5f80$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $63618293c58b5f80$var$Settings.defaultZone;
        var proto = $63618293c58b5f80$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $63618293c58b5f80$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $63618293c58b5f80$var$normalizeZone(input, $63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $63618293c58b5f80$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $63618293c58b5f80$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $63618293c58b5f80$var$hasRelative()
        };
    };
    return Info;
}();
function $63618293c58b5f80$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($63618293c58b5f80$var$Duration.fromMillis(ms).as("days"));
}
function $63618293c58b5f80$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $63618293c58b5f80$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $63618293c58b5f80$var$dayDiff
        ]
    ];
    var results = {};
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            var _cursor$plus;
            lowestOrder = unit;
            var delta = differ(cursor, later);
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
            if (highWater > later) {
                var _cursor$plus2;
                cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
                delta -= 1;
            } else cursor = highWater;
            results[unit] = delta;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $63618293c58b5f80$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $63618293c58b5f80$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus3;
            highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $63618293c58b5f80$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $63618293c58b5f80$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $63618293c58b5f80$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $63618293c58b5f80$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $63618293c58b5f80$var$hanidecChars = $63618293c58b5f80$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $63618293c58b5f80$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($63618293c58b5f80$var$numberingSystems.hanidec) !== -1) value += $63618293c58b5f80$var$hanidecChars.indexOf(str[i]);
            else for(var key in $63618293c58b5f80$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $63618293c58b5f80$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $63618293c58b5f80$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $63618293c58b5f80$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $63618293c58b5f80$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $63618293c58b5f80$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($63618293c58b5f80$var$parseDigits(s));
        }
    };
}
var $63618293c58b5f80$var$NBSP = String.fromCharCode(160);
var $63618293c58b5f80$var$spaceOrNBSP = "( |" + $63618293c58b5f80$var$NBSP + ")";
var $63618293c58b5f80$var$spaceOrNBSPRegExp = new RegExp($63618293c58b5f80$var$spaceOrNBSP, "g");
function $63618293c58b5f80$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($63618293c58b5f80$var$spaceOrNBSPRegExp, $63618293c58b5f80$var$spaceOrNBSP);
}
function $63618293c58b5f80$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($63618293c58b5f80$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $63618293c58b5f80$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($63618293c58b5f80$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $63618293c58b5f80$var$stripInsensitivities(s) === $63618293c58b5f80$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $63618293c58b5f80$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $63618293c58b5f80$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $63618293c58b5f80$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $63618293c58b5f80$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $63618293c58b5f80$var$unitForToken(token, loc) {
    var one = $63618293c58b5f80$var$digitRegex(loc), two = $63618293c58b5f80$var$digitRegex(loc, "{2}"), three = $63618293c58b5f80$var$digitRegex(loc, "{3}"), four = $63618293c58b5f80$var$digitRegex(loc, "{4}"), six = $63618293c58b5f80$var$digitRegex(loc, "{6}"), oneOrTwo = $63618293c58b5f80$var$digitRegex(loc, "{1,2}"), oneToThree = $63618293c58b5f80$var$digitRegex(loc, "{1,3}"), oneToSix = $63618293c58b5f80$var$digitRegex(loc, "{1,6}"), oneToNine = $63618293c58b5f80$var$digitRegex(loc, "{1,9}"), twoToFour = $63618293c58b5f80$var$digitRegex(loc, "{2,4}"), fourToSix = $63618293c58b5f80$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($63618293c58b5f80$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $63618293c58b5f80$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $63618293c58b5f80$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $63618293c58b5f80$var$intUnit(oneToSix);
            case "yy":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            case "yyyy":
                return $63618293c58b5f80$var$intUnit(four);
            case "yyyyy":
                return $63618293c58b5f80$var$intUnit(fourToSix);
            case "yyyyyy":
                return $63618293c58b5f80$var$intUnit(six);
            // months
            case "M":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "MM":
                return $63618293c58b5f80$var$intUnit(two);
            case "MMM":
                return $63618293c58b5f80$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $63618293c58b5f80$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "LL":
                return $63618293c58b5f80$var$intUnit(two);
            case "LLL":
                return $63618293c58b5f80$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $63618293c58b5f80$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "dd":
                return $63618293c58b5f80$var$intUnit(two);
            // ordinals
            case "o":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "ooo":
                return $63618293c58b5f80$var$intUnit(three);
            // time
            case "HH":
                return $63618293c58b5f80$var$intUnit(two);
            case "H":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "hh":
                return $63618293c58b5f80$var$intUnit(two);
            case "h":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "mm":
                return $63618293c58b5f80$var$intUnit(two);
            case "m":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "q":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "qq":
                return $63618293c58b5f80$var$intUnit(two);
            case "s":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "ss":
                return $63618293c58b5f80$var$intUnit(two);
            case "S":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "SSS":
                return $63618293c58b5f80$var$intUnit(three);
            case "u":
                return $63618293c58b5f80$var$simple(oneToNine);
            case "uu":
                return $63618293c58b5f80$var$simple(oneOrTwo);
            case "uuu":
                return $63618293c58b5f80$var$intUnit(one);
            // meridiem
            case "a":
                return $63618293c58b5f80$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $63618293c58b5f80$var$intUnit(four);
            case "kk":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "WW":
                return $63618293c58b5f80$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $63618293c58b5f80$var$intUnit(one);
            case "EEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $63618293c58b5f80$var$simple(/[a-z_+-/]{1,256}?/i);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $63618293c58b5f80$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $63618293c58b5f80$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    }
};
function $63618293c58b5f80$var$tokenForPart(part, locale, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") return {
        literal: true,
        val: value
    };
    var style = formatOpts[type];
    var val = $63618293c58b5f80$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $63618293c58b5f80$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $63618293c58b5f80$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($63618293c58b5f80$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $63618293c58b5f80$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$63618293c58b5f80$var$isUndefined(matches.z)) zone = $63618293c58b5f80$var$IANAZone.create(matches.z);
    if (!$63618293c58b5f80$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $63618293c58b5f80$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$63618293c58b5f80$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$63618293c58b5f80$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$63618293c58b5f80$var$isUndefined(matches.u)) matches.S = $63618293c58b5f80$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $63618293c58b5f80$var$dummyDateTimeCache = null;
function $63618293c58b5f80$var$getDummyDateTime() {
    if (!$63618293c58b5f80$var$dummyDateTimeCache) $63618293c58b5f80$var$dummyDateTimeCache = $63618293c58b5f80$var$DateTime.fromMillis(1555555555555);
    return $63618293c58b5f80$var$dummyDateTimeCache;
}
function $63618293c58b5f80$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $63618293c58b5f80$var$Formatter.macroTokenToFormatOpts(token.val);
    if (!formatOpts) return token;
    var formatter = $63618293c58b5f80$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($63618293c58b5f80$var$getDummyDateTime());
    var tokens = parts.map(function(p) {
        return $63618293c58b5f80$var$tokenForPart(p, locale, formatOpts);
    });
    if (tokens.includes(undefined)) return token;
    return tokens;
}
function $63618293c58b5f80$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $63618293c58b5f80$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $63618293c58b5f80$var$explainFromTokens(locale, input, format) {
    var tokens = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $63618293c58b5f80$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $63618293c58b5f80$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $63618293c58b5f80$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $63618293c58b5f80$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($63618293c58b5f80$var$hasOwnProperty(matches, "a") && $63618293c58b5f80$var$hasOwnProperty(matches, "H")) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $63618293c58b5f80$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $63618293c58b5f80$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
var $63618293c58b5f80$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $63618293c58b5f80$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $63618293c58b5f80$var$unitOutOfRange(unit, value) {
    return new $63618293c58b5f80$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $63618293c58b5f80$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $63618293c58b5f80$var$computeOrdinal(year, month, day) {
    return day + ($63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder)[month - 1];
}
function $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal) {
    var table = $63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $63618293c58b5f80$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day), weekday = $63618293c58b5f80$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $63618293c58b5f80$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $63618293c58b5f80$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $63618293c58b5f80$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $63618293c58b5f80$var$timeObject(gregObj));
}
function $63618293c58b5f80$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $63618293c58b5f80$var$dayOfWeek(weekYear, 1, 4), yearInDays = $63618293c58b5f80$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $63618293c58b5f80$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $63618293c58b5f80$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(weekData));
}
function $63618293c58b5f80$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day);
    return $63618293c58b5f80$var$_extends({
        year: year,
        ordinal: ordinal
    }, $63618293c58b5f80$var$timeObject(gregData));
}
function $63618293c58b5f80$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(ordinalData));
}
function $63618293c58b5f80$var$hasInvalidWeekData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.weekYear), validWeek = $63618293c58b5f80$var$integerBetween(obj.weekNumber, 1, $63618293c58b5f80$var$weeksInWeekYear(obj.weekYear)), validWeekday = $63618293c58b5f80$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $63618293c58b5f80$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $63618293c58b5f80$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidOrdinalData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validOrdinal = $63618293c58b5f80$var$integerBetween(obj.ordinal, 1, $63618293c58b5f80$var$daysInYear(obj.year));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $63618293c58b5f80$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidGregorianData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validMonth = $63618293c58b5f80$var$integerBetween(obj.month, 1, 12), validDay = $63618293c58b5f80$var$integerBetween(obj.day, 1, $63618293c58b5f80$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $63618293c58b5f80$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $63618293c58b5f80$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $63618293c58b5f80$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $63618293c58b5f80$var$integerBetween(minute, 0, 59), validSecond = $63618293c58b5f80$var$integerBetween(second, 0, 59), validMillisecond = $63618293c58b5f80$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $63618293c58b5f80$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $63618293c58b5f80$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $63618293c58b5f80$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $63618293c58b5f80$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $63618293c58b5f80$var$INVALID = "Invalid DateTime";
var $63618293c58b5f80$var$MAX_DATE = 8.64e15;
function $63618293c58b5f80$var$unsupportedZone(zone) {
    return new $63618293c58b5f80$var$Invalid("unsupported zone", 'the zone "' + zone.name + '" is not supported');
} // we cache week data on the DT object and this intermediates the cache
function $63618293c58b5f80$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $63618293c58b5f80$var$gregorianToWeek(dt.c);
    return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $63618293c58b5f80$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $63618293c58b5f80$var$DateTime($63618293c58b5f80$var$_extends({}, current, alts, {
        old: current
    }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $63618293c58b5f80$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000; // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
     // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000; // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
     // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
} // convert an epoch timestamp into a calendar object with the given offset
function $63618293c58b5f80$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
} // convert a calendar object to a epoch timestamp
function $63618293c58b5f80$var$objToTS(obj, offset, zone) {
    return $63618293c58b5f80$var$fixOffset($63618293c58b5f80$var$objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs
function $63618293c58b5f80$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $63618293c58b5f80$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $63618293c58b5f80$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $63618293c58b5f80$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $63618293c58b5f80$var$objToLocalTS(c);
    var _fixOffset = $63618293c58b5f80$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options
function $63618293c58b5f80$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0) {
        var interpretationZone = parsedZone || zone, inst = $63618293c58b5f80$var$DateTime.fromObject(parsed, $63618293c58b5f80$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $63618293c58b5f80$var$DateTime.invalid(new $63618293c58b5f80$var$Invalid("unparsable", 'the input "' + text + "\" can't be parsed as " + format));
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $63618293c58b5f80$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $63618293c58b5f80$var$Formatter.create($63618293c58b5f80$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $63618293c58b5f80$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $63618293c58b5f80$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.day);
    } else {
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += $63618293c58b5f80$var$padStart(o.c.day);
    }
    return c;
}
function $63618293c58b5f80$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset) {
    var c = $63618293c58b5f80$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $63618293c58b5f80$var$padStart(o.c.minute);
        if (o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $63618293c58b5f80$var$padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
        c += $63618293c58b5f80$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $63618293c58b5f80$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o % 60));
        }
    }
    return c;
} // defaults for unspecified units in the supported calendars
var $63618293c58b5f80$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}; // Units in the supported calendars, sorted by bigness
var $63618293c58b5f80$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
]; // standardize case and plurality in units
function $63618293c58b5f80$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
    return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $63618293c58b5f80$var$quickDT(obj, opts) {
    var zone = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone), loc = $63618293c58b5f80$var$Locale.fromObject(opts), tsNow = $63618293c58b5f80$var$Settings.now();
    var ts, o; // assume we have the higher-order units
    if (!$63618293c58b5f80$var$isUndefined(obj.year)) {
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits), _step; !(_step = _iterator()).done;){
            var u = _step.value;
            if ($63618293c58b5f80$var$isUndefined(obj[u])) obj[u] = $63618293c58b5f80$var$defaultUnitValues[u];
        }
        var invalid = $63618293c58b5f80$var$hasInvalidGregorianData(obj) || $63618293c58b5f80$var$hasInvalidTimeData(obj);
        if (invalid) return $63618293c58b5f80$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $63618293c58b5f80$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $63618293c58b5f80$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $63618293c58b5f80$var$diffRelative(start, end, opts) {
    var round = $63618293c58b5f80$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $63618293c58b5f80$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;){
        var unit = _step2.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $63618293c58b5f80$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime#local}, {@link DateTime#utc}, and (most flexibly) {@link DateTime#fromObject}. To create one from a standard string format, use {@link DateTime#fromISO}, {@link DateTime#fromHTTP}, and {@link DateTime#fromRFC2822}. To create one from a custom string format, use {@link DateTime#fromFormat}. To create one from a native JS date, use {@link DateTime#fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $63618293c58b5f80$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $63618293c58b5f80$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $63618293c58b5f80$var$Invalid("invalid input") : null) || (!zone.isValid ? $63618293c58b5f80$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $63618293c58b5f80$var$isUndefined(config.ts) ? $63618293c58b5f80$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $63618293c58b5f80$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $63618293c58b5f80$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    } // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $63618293c58b5f80$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(milliseconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$63618293c58b5f80$var$MAX_DATE || milliseconds > $63618293c58b5f80$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(seconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = !$63618293c58b5f80$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $63618293c58b5f80$var$normalizeObject(obj, $63618293c58b5f80$var$normalizeUnit), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $63618293c58b5f80$var$Locale.fromObject(opts); // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $63618293c58b5f80$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $63618293c58b5f80$var$orderedWeekUnits;
            defaultValues = $63618293c58b5f80$var$defaultWeekUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $63618293c58b5f80$var$orderedOrdinalUnits;
            defaultValues = $63618293c58b5f80$var$defaultOrdinalUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToOrdinal(objNow);
        } else {
            units = $63618293c58b5f80$var$orderedUnits;
            defaultValues = $63618293c58b5f80$var$defaultUnitValues;
        } // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator3 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            var v = normalized[u];
            if (!$63618293c58b5f80$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        } // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $63618293c58b5f80$var$hasInvalidWeekData(normalized) : containsOrdinal ? $63618293c58b5f80$var$hasInvalidOrdinalData(normalized) : $63618293c58b5f80$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $63618293c58b5f80$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
         // compute the actual time
        var gregorian = useWeekData ? $63618293c58b5f80$var$weekToGregorian(normalized) : containsOrdinal ? $63618293c58b5f80$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $63618293c58b5f80$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        }); // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $63618293c58b5f80$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $63618293c58b5f80$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $63618293c58b5f80$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(fmt)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $63618293c58b5f80$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $63618293c58b5f80$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } // INFO
     /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } // TRANSFORM
     /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($63618293c58b5f80$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $63618293c58b5f80$var$normalizeZone(zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $63618293c58b5f80$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $63618293c58b5f80$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $63618293c58b5f80$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $63618293c58b5f80$var$normalizeObject(values, $63618293c58b5f80$var$normalizeUnit), settingWeekStuff = !$63618293c58b5f80$var$isUndefined(normalized.weekYear) || !$63618293c58b5f80$var$isUndefined(normalized.weekNumber) || !$63618293c58b5f80$var$isUndefined(normalized.weekday), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $63618293c58b5f80$var$weekToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToWeek(this.c), normalized));
        else if (!$63618293c58b5f80$var$isUndefined(normalized.ordinal)) mixed = $63618293c58b5f80$var$ordinalToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $63618293c58b5f80$var$_extends({}, this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($63618293c58b5f80$var$isUndefined(normalized.day)) mixed.day = Math.min($63618293c58b5f80$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $63618293c58b5f80$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $63618293c58b5f80$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration).negate();
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $63618293c58b5f80$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } // OUTPUT
     /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $63618293c58b5f80$var$_toISODate(this, ext);
        c += "T";
        c += $63618293c58b5f80$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $63618293c58b5f80$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $63618293c58b5f80$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $63618293c58b5f80$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $63618293c58b5f80$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $63618293c58b5f80$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } // COMPARE
     /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $63618293c58b5f80$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $63618293c58b5f80$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $63618293c58b5f80$var$maybeArray(unit).map($63618293c58b5f80$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $63618293c58b5f80$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $63618293c58b5f80$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    } /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $63618293c58b5f80$var$diffRelative(base, this.plus(padding), $63618293c58b5f80$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $63618293c58b5f80$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } // MISC
     /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $63618293c58b5f80$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } // FORMAT PRESETS
     /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $63618293c58b5f80$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $63618293c58b5f80$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $63618293c58b5f80$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $63618293c58b5f80$var$friendlyDateTime(dateTimeish) {
    if ($63618293c58b5f80$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $63618293c58b5f80$var$isNumber(dateTimeish.valueOf())) return $63618293c58b5f80$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $63618293c58b5f80$var$DateTime.fromObject(dateTimeish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $63618293c58b5f80$var$VERSION = "2.3.2";
$63618293c58b5f80$exports.DateTime = $63618293c58b5f80$var$DateTime;
$63618293c58b5f80$exports.Duration = $63618293c58b5f80$var$Duration;
$63618293c58b5f80$exports.FixedOffsetZone = $63618293c58b5f80$var$FixedOffsetZone;
$63618293c58b5f80$exports.IANAZone = $63618293c58b5f80$var$IANAZone;
$63618293c58b5f80$exports.Info = $63618293c58b5f80$var$Info;
$63618293c58b5f80$exports.Interval = $63618293c58b5f80$var$Interval;
$63618293c58b5f80$exports.InvalidZone = $63618293c58b5f80$var$InvalidZone;
$63618293c58b5f80$exports.Settings = $63618293c58b5f80$var$Settings;
$63618293c58b5f80$exports.SystemZone = $63618293c58b5f80$var$SystemZone;
$63618293c58b5f80$exports.VERSION = $63618293c58b5f80$var$VERSION;
$63618293c58b5f80$exports.Zone = $63618293c58b5f80$var$Zone;



var $f1q41 = parcelRequire("f1q41");
var $5fc29812bef4ecf9$export$46cf917f0a794e7;
(function(DCSDrawingLayers) {
    DCSDrawingLayers["Author"] = "Author";
    DCSDrawingLayers["Common"] = "Common";
    DCSDrawingLayers["Neutrals"] = "Neutrals";
    DCSDrawingLayers["Red"] = "Red";
    DCSDrawingLayers["Blue"] = "Blue";
})($5fc29812bef4ecf9$export$46cf917f0a794e7 || ($5fc29812bef4ecf9$export$46cf917f0a794e7 = {}));
function $5fc29812bef4ecf9$export$d81f3dfa50be3f5(missionAST, layers) {
    const m = [];
    const drawings = missionAST.strValues?.drawings?.strValues.layers;
    if (!drawings) return [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(drawings.numValues, (d)=>{
        if (!d) return;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(layers, d.strValues.name)) return;
        const cleaned = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(d.strValues.objects.numValues, (o)=>o && {
                ...o.strValues,
                points: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(o.strValues.points?.numValues, (p)=>{
                    return p && p.strValues;
                }))
            }));
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(cleaned, (c)=>m.push(c));
    });
    return m;
}


var $950bc911f3ee385b$exports = {};
"use strict";
/**
 * Representation a of zip file in js
 * @constructor
 */ function $950bc911f3ee385b$var$JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if (!(this instanceof $950bc911f3ee385b$var$JSZip)) return new $950bc911f3ee385b$var$JSZip();
    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};
    this.comment = null;
    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new $950bc911f3ee385b$var$JSZip();
        for(var i in this)if (typeof this[i] !== "function") newObj[i] = this[i];
        return newObj;
    };
}

$950bc911f3ee385b$var$JSZip.prototype = (parcelRequire("851aL"));

$950bc911f3ee385b$var$JSZip.prototype.loadAsync = (parcelRequire("i71Qm"));

$950bc911f3ee385b$var$JSZip.support = (parcelRequire("4Fiik"));

$950bc911f3ee385b$var$JSZip.defaults = (parcelRequire("798BN"));
// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
$950bc911f3ee385b$var$JSZip.version = "3.4.0";
$950bc911f3ee385b$var$JSZip.loadAsync = function(content, options) {
    return new $950bc911f3ee385b$var$JSZip().loadAsync(content, options);
};

$950bc911f3ee385b$var$JSZip.external = (parcelRequire("gEpFr"));
$950bc911f3ee385b$exports = $950bc911f3ee385b$var$JSZip;



var $f1q41 = parcelRequire("f1q41");

// Ideally, we would keep this as lua and write a custom parcel bundler
// to handle converting it to a JS String. But the parcel plugin/asset documentation
// is very lacking, so skipping it for now.
const $c0b5bca449a418f2$export$17af4c048e04b3b5 = (varName)=>{
    return `
    function SerializeTable(t, f)
        local str = ""
        local function printTableHelper(obj, cnt, key)
    
            local cnt = cnt or 0
    
            if type(obj) == "table" then
                str = str .. "\\n" .. string.rep("\\t", cnt) .. "{\\n"
                cnt = cnt + 1
    
                for k, v in pairs(obj) do
    
                    if type(k) == "string" then
                        str = str .. string.rep("\\t", cnt) .. '["' .. k .. '"]' .. " = "
                    end
    
                    if type(k) == "number" then
                        str = str .. string.rep("\\t", cnt) .. "[" .. k .. "]" ..  " = "
                    end
    
                    printTableHelper(v, cnt, k)
                    str = str .. ",\\n"
                end
    
                cnt = cnt - 1
                local lastChars = cnt > 0 and "}," or "}"
    
                local commentKey = ""
                if type(key) == "string" then
                    commentKey = '["' .. key .. '"]'
                end
    
                if type(key) == "number" then
                    commentKey = "[" .. key .. "]"
                end
    
                str =
                    -- str .. string.rep("\\t", cnt) .. lastChars .. ' -- end of ["' .. key .. '"]'
                    str .. string.rep("\\t", cnt) .. lastChars .. ' -- end of ' .. commentKey
    
            elseif type(obj) == "string" then
                str = str .. string.format("%q", obj)
    
            else
                str = str .. tostring(obj)
            end
    
            return str
        end
    
        return printTableHelper(t, 0, "${varName}")
    end
    
    `;
};



function $0dc5bcacaa5e05aa$export$a1a624bc799618af(luaEnv, varName = "mission") {
    let result = null;
    const myLib = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
        getAST: (table)=>{
            result = table;
        }
    });
    luaEnv.loadLib("myLib", myLib);
    luaEnv.parse(`myLib.getAST(${varName})`).exec();
    return result;
}
function $0dc5bcacaa5e05aa$export$a7bc6ddd501a46d4(luaStr, luaVar) {
    const luaEnv = $0dc5bcacaa5e05aa$export$e19c4d7ca45727b2(luaStr, luaVar);
    return $0dc5bcacaa5e05aa$export$a1a624bc799618af(luaEnv, luaVar);
}
function $0dc5bcacaa5e05aa$export$992c8ee8f2347e2(missionLua) {
    if (!missionLua) throw new Error("Mission lua string was undefined");
    return $0dc5bcacaa5e05aa$export$a7bc6ddd501a46d4(missionLua, "mission");
}
// Backticks create parsing issues.
// The most common occurence is livery names like `desert`.
// This will break those livery settings, but the upside is that missions will parse.
// The trade-off is no exceptions being thrown, but breaking livery settings in some cases.
function $0dc5bcacaa5e05aa$var$sanitizeBackticks(str) {
    if (typeof str === "undefined") throw new Error("Mission data was undefined. The miz file could be invalid.");
    return str.replace(/`(.*)`/g, "");
}
function $0dc5bcacaa5e05aa$export$e19c4d7ca45727b2(luaStr, tableName = "mission") {
    const luaEnv = $2ed1e52b1498d9b2$export$cadeb2d34e317e82();
    luaEnv.parse((0, $c0b5bca449a418f2$export$17af4c048e04b3b5)(tableName)).exec();
    luaEnv.parse($0dc5bcacaa5e05aa$var$sanitizeBackticks(luaStr)).exec();
    return luaEnv;
}
function $0dc5bcacaa5e05aa$export$a1016d6598db77f(luaEnv, customFunc, luaVar = "mission") {
    const customLib = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
        customFunc: customFunc
    });
    luaEnv.loadLib("customLib", customLib);
    luaEnv.parse(`customLib.customFunc(${luaVar})`).exec();
    return $0dc5bcacaa5e05aa$export$eefa2ea77bb6739b(luaEnv);
}
/* eslint-disable-next-line */ const $0dc5bcacaa5e05aa$var$backslashRegex = /\\\\\"/g;
const $0dc5bcacaa5e05aa$var$commentRegex = /-- end of \[(.*)\],/g;
const $0dc5bcacaa5e05aa$var$inlineLuaRegex = /\\\\\n/g;
function $0dc5bcacaa5e05aa$export$eefa2ea77bb6739b(luaEnv) {
    const output = luaEnv.parse(`return "mission =" .. SerializeTable(mission)`).exec();
    // The PrintTable function's recursiveness appends a trailing `,` to comments.
    // Remove it in JS land, since we don't have regex in Lua land
    let clean = output.replace($0dc5bcacaa5e05aa$var$commentRegex, (match)=>match.replace(",", ""));
    // Because the miz file has "lua within lua" in the form of actions,
    // we need to replace all \\" occurrences with \\\".
    clean = clean.replace($0dc5bcacaa5e05aa$var$backslashRegex, '\\\\\\"');
    // Actions have inline lua that can have newline characters that cause issues.
    clean = clean.replace($0dc5bcacaa5e05aa$var$inlineLuaRegex, "\\\\\\\n");
    return clean;
}
function $0dc5bcacaa5e05aa$export$7f3b48ada48e33da(dictionary) {
    const luaEnv = $0dc5bcacaa5e05aa$export$e19c4d7ca45727b2(dictionary, "dictionary");
    let obj = {};
    const myLib = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
        getAST: (dictionaryAst)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(dictionaryAst.strValues, (v, k)=>{
                obj[k] = v;
            });
        }
    });
    luaEnv.loadLib("myLib", myLib);
    luaEnv.parse(`myLib.getAST(dictionary)`).exec();
    return obj;
}
async function $0dc5bcacaa5e05aa$export$429e6a39523db463(coalition, miz) {
    const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($950bc911f3ee385b$exports))).loadAsync(miz);
    const [mission, dictionary, warehouses] = await $0dc5bcacaa5e05aa$export$c05b9514531d5fff(zip);
    const ts = (0, $e1dc1ccf277543ba$export$1c86ec91605d839b)(coalition, mission, warehouses, $0dc5bcacaa5e05aa$export$7f3b48ada48e33da(dictionary));
    return ts;
}
const $0dc5bcacaa5e05aa$export$c05b9514531d5fff = (zip, cb)=>{
    if (!zip) return null;
    const p = [];
    zip.forEach((path, e)=>{
        // Use array indices to ensure a consistent order every time.
        if (path === "mission") p[0] = e.async("text");
        if (path === "l10n/DEFAULT/dictionary") p[1] = e.async("text");
        if (path === "warehouses") p[2] = e.async("text");
    });
    return Promise.all(p).then(([mission, dictionary, warehouses])=>{
        // This assumes mission will always be pushed first.
        // Not sure if that is a safe assumption or not...
        if (cb) cb(mission, dictionary, warehouses);
        // Hack to make this promise-able
        return [
            mission,
            dictionary,
            warehouses
        ];
    });
};
const $0dc5bcacaa5e05aa$export$40f6f198121d01ac = (dictionary)=>{
    // TODO: hacky JS to Lua transpile that will only work
    // in this specific case.
    let luaStr = "dictionary = \n{\n";
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(dictionary, (v, k)=>{
        luaStr += `\t["${k}"] = "${v}",\n`;
    });
    luaStr += "} -- end of dictionary";
    return luaStr;
};





function $e1dc1ccf277543ba$export$e16efecc740d0823(missionAST) {
    const t = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(missionAST, [
        "theatre"
    ]);
    switch(t){
        case "Caucasus":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).CAUCASUS;
        case "PersianGulf":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).PG;
        case "Syria":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).SYRIA;
        case "Nevada":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).NEVADA;
        case "MarianaIslands":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).MARIANAS;
        case "Falklands":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).SOUTH_ATLANTIC;
        case "SinaiMap":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).SINAI;
        case "Normandy":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).NORMANDY;
        case "Kola":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).KOLA;
        case "Afghanistan":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).AFGHANISTAN;
        case "GermanyCW":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).GERMANY_COLD_WAR;
        case "Iraq":
            return (0, $79e13355954d15ea$export$e47cd17bd9fde012).IRAQ;
        default:
            throw new Error("theater not found: " + t);
    }
}
function $e1dc1ccf277543ba$export$59c99f3515d3493f(theater) {
    switch(theater){
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).CAUCASUS:
            return 3;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).MARIANAS:
            return 10;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).NEVADA:
            return -8;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).PG:
            return 4;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).SYRIA:
            return 3;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).SOUTH_ATLANTIC:
            return -3;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).SINAI:
            return 2;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).NORMANDY:
            return 1;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).KOLA:
            return 2;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).AFGHANISTAN:
            return 3.5;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).GERMANY_COLD_WAR:
            return 2;
        case (0, $79e13355954d15ea$export$e47cd17bd9fde012).IRAQ:
            return 3;
        default:
            throw new Error("invalid theater: " + theater);
    }
}
function $e1dc1ccf277543ba$export$faf6d6372f212d80(theater, missionAST) {
    const date = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(missionAST, [
        "date"
    ]);
    const day = date.strValues.Day;
    const month = date.strValues.Month;
    const year = date.strValues.Year;
    const s = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(missionAST, [
        "start_time"
    ]);
    let d = (0, $63618293c58b5f80$exports.DateTime).fromObject({
        day: day,
        month: month,
        year: year
    }, {
        zone: "utc"
    });
    d = d.plus({
        seconds: s
    });
    return d;
}
function $e1dc1ccf277543ba$export$d20a632493278500(coalition, theater, missionAST, warehouseAST, dictionary) {
    const planes = (0, $c255bc447a24c026$export$40a7dcdd22bafa6f)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Plane, missionAST, dictionary);
    const helos = (0, $c255bc447a24c026$export$40a7dcdd22bafa6f)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Helicopter, missionAST, dictionary);
    const airfields = (0, $c255bc447a24c026$export$8d988fa4222bb81)(coalition, warehouseAST, theater);
    const carriersAndFARPs = (0, $c255bc447a24c026$export$8dabf28ccdc844ef)(coalition, missionAST, dictionary);
    const bluforVehicles = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Vehicle, missionAST, dictionary);
    const bluforStatics = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Static, missionAST, dictionary);
    const bluforShips = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship, missionAST, dictionary);
    return {
        playerGroups: [
            ...planes,
            ...helos
        ],
        airfields: [
            ...airfields,
            ...carriersAndFARPs
        ],
        bluforVehicles: bluforVehicles,
        bluforStatics: bluforStatics,
        bluforShips: bluforShips
    };
}
function $e1dc1ccf277543ba$export$1c86ec91605d839b(coalition, mission, warehouses, dictionary) {
    const missionAST = (0, $0dc5bcacaa5e05aa$export$992c8ee8f2347e2)(mission);
    const warehouseAST = (0, $0dc5bcacaa5e05aa$export$a7bc6ddd501a46d4)(warehouses, "warehouses");
    const theater = $e1dc1ccf277543ba$export$e16efecc740d0823(missionAST);
    const time = $e1dc1ccf277543ba$export$faf6d6372f212d80(theater, missionAST);
    const drawingData = (0, $5fc29812bef4ecf9$export$d81f3dfa50be3f5)(missionAST, [
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Common,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Author,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Neutrals,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Blue,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Red
    ]);
    const opposingCoalition = coalition === (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue ? (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red : (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue;
    const { playerGroups: plannedGroups, airfields: airfields, bluforVehicles: bluforVehicles, bluforStatics: bluforStatics, bluforShips: bluforShips } = $e1dc1ccf277543ba$export$d20a632493278500(coalition, theater, missionAST, warehouseAST, dictionary);
    const { opforAirbases: opforAirbases, opforVehicles: opforVehicles, opforPlanes: opforPlanes, opforStatics: opforStatics, opforShips: opforShips } = $e1dc1ccf277543ba$export$d1f996d7812b5c15(opposingCoalition, theater, missionAST, warehouseAST, dictionary);
    const supportAssets = (0, $c255bc447a24c026$export$4b9f485ad9ea72e7)(coalition, missionAST, dictionary);
    const zones = (0, $c255bc447a24c026$export$2d76461f96e51b23)(missionAST);
    const bullseye = (0, $c255bc447a24c026$export$7594c041727c2620)(coalition, missionAST);
    const controlPoints = (0, $c255bc447a24c026$export$555b5e1594145069)(coalition, missionAST);
    const briefingText = (0, $c255bc447a24c026$export$32c107075c6c16a9)(coalition, missionAST, dictionary);
    return {
        theater: theater,
        plannedGroups: plannedGroups,
        airbases: airfields,
        opforAirbases: opforAirbases,
        opforVehicles: opforVehicles,
        supportAssets: supportAssets,
        zones: zones,
        opforPlanes: opforPlanes,
        bluforVehicles: bluforVehicles,
        drawingData: drawingData,
        time: time.toJSON(),
        weather: null,
        bluforStatics: bluforStatics,
        opforStatics: opforStatics,
        bluforShips: bluforShips,
        opforShips: opforShips,
        bullseye: bullseye,
        briefingText: briefingText,
        controlPoints: controlPoints
    };
}
function $e1dc1ccf277543ba$export$d1f996d7812b5c15(coalition, theater, missionAST, warehouseAST, dictionary) {
    const opforAirbases = (0, $c255bc447a24c026$export$8d988fa4222bb81)(coalition, warehouseAST, theater);
    const opforVehicles = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Vehicle, missionAST, dictionary);
    // We currently aren't doing anything with this,
    // and it can put users over the 1000MB limit for the serialized taskingData field.
    const opforPlanes = [];
    // const opforPlanes = getGroupsOfType(
    //   coalition,
    //   UnitCategory.Plane,
    //   missionAST,
    //   dictionary
    // );
    const opforStatics = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Static, missionAST, dictionary);
    const opforShips = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(coalition, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship, missionAST, dictionary);
    return {
        opforAirbases: opforAirbases,
        opforVehicles: opforVehicles,
        opforPlanes: opforPlanes,
        opforStatics: opforStatics,
        opforShips: opforShips
    };
}
function $e1dc1ccf277543ba$export$2edad77f069d825c(group, airbases, supportAssets) {
    const radios = group.units[0].radios;
    const out = [];
    for(let r = 0; r < radios.length; r++){
        const radio = radios[r];
        out[r] = [];
        for(let c = 0; c < radio.length; c++){
            const chan = radio[c];
            if (!chan) continue;
            const record = {
                ...chan,
                description: null,
                channel: c + 1
            };
            for (const base of airbases)if (base.UHF === chan.frequency || base.VHF === chan.frequency) record.description = base.Name;
            for (const group of supportAssets)if (group.channel.frequency === chan.frequency) record.description = group.name;
            out[r][c] = record;
        }
    }
    return out;
}
// https://chat.openai.com/share/e53fec80-2140-45f8-9d07-9b69d0c867f2
const $e1dc1ccf277543ba$var$highContrastColors = [
    "#000000",
    "#CC0000",
    "#00CC00",
    "#0000CC",
    "#E6B800",
    "#CC00CC",
    "#00CCCC",
    "#CC8000",
    "#660066",
    "#006600",
    "#CCAF00",
    "#CC3D00",
    "#009999",
    "#CC0A69",
    "#5B005B",
    "#1E661E",
    "#CC4782",
    "#196DCC",
    "#CC3F2C",
    "#802C99"
];
function $e1dc1ccf277543ba$export$302c46776847a549(idx) {
    return $e1dc1ccf277543ba$var$highContrastColors[idx % $e1dc1ccf277543ba$var$highContrastColors.length];
}
function $e1dc1ccf277543ba$export$d87878d6a8186d78(groupNames) {
    const map = {};
    for (const name of groupNames){
        const idx = groupNames.indexOf(name);
        map[name] = $e1dc1ccf277543ba$export$302c46776847a549(idx);
    }
    return map;
}
function $e1dc1ccf277543ba$export$b0887be10c72f2f9(mission, warehouses, dictionary) {
    const missionAST = (0, $0dc5bcacaa5e05aa$export$992c8ee8f2347e2)(mission);
    const drawingData = (0, $5fc29812bef4ecf9$export$d81f3dfa50be3f5)(missionAST, [
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Common,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Author,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Neutrals,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Blue,
        (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Red
    ]);
    const coaLookup = {};
    [
        (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue,
        (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red,
        (0, $91a9098e14452db2$export$193e4cdf5c5b208).Neutrals
    ].forEach((c)=>{
        const planes = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(c, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Plane, missionAST, dictionary);
        const helos = (0, $c255bc447a24c026$export$b84d9b908e43eb92)(c, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Helicopter, missionAST, dictionary);
        const flyable = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter([
            ...planes,
            ...helos
        ], "isPlayer");
        const vehicles = (0, $c255bc447a24c026$export$b84d9b908e43eb92)((0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Vehicle, missionAST, dictionary);
        coaLookup[c] = {
            planes: planes,
            helos: helos,
            flyable: flyable,
            vehicles: vehicles
        };
    });
    return {
        flyableBLUFOR: coaLookup.blue.flyable.length,
        flyableREDFOR: coaLookup.red.flyable.length,
        vehiclesBLUFOR: coaLookup.blue.vehicles.length,
        vehiclesREDFOR: coaLookup.red.vehicles.length,
        drawingObjects: drawingData.length,
        zones: (0, $c255bc447a24c026$export$2d76461f96e51b23)(missionAST).length
    };
}





var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");



var $3688fdfd7954d49f$export$58047b57cdffebb3;
(function(PlanItemType) {
    PlanItemType["FuelPlan"] = "FuelPlan";
    PlanItemType["Waypoint"] = "Waypoint";
    PlanItemType["PlanNote"] = "Note";
    PlanItemType["RadioPresets"] = "RadioPresets";
    PlanItemType["LaserCodes"] = "LaserCodes";
    PlanItemType["NavPoint"] = "NavPoint";
})($3688fdfd7954d49f$export$58047b57cdffebb3 || ($3688fdfd7954d49f$export$58047b57cdffebb3 = {}));
function $3688fdfd7954d49f$export$7117fc57f3fba397(p) {
    switch(p.type){
        case "FuelPlan":
            return JSON.parse(p.payload);
        case "Note":
            return JSON.parse(p.payload);
        case "RadioPresets":
            return JSON.parse(p.payload);
        case "LaserCodes":
            return JSON.parse(p.payload);
        default:
            throw new Error(`Unknown plan item type: ${p.type}`);
    }
}




var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


const $1ae4eb57bb4d8f1b$var$PlanManagerV2Context = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $1ae4eb57bb4d8f1b$export$4cd335292efb4883 = ({ manager: manager, waypointManager: waypointManager, navPointManager: navPointManager, children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1ae4eb57bb4d8f1b$var$PlanManagerV2Context.Provider, {
        value: {
            manager: manager,
            waypointManager: waypointManager,
            navPointManager: navPointManager
        },
        children: children
    });
};
const $1ae4eb57bb4d8f1b$export$5020ca831ed7928a = ()=>{
    const ctx = $acw62.useContext($1ae4eb57bb4d8f1b$var$PlanManagerV2Context);
    if (!ctx) throw new Error("PlanManagerV2Context not found");
    return ctx.manager;
};
function $1ae4eb57bb4d8f1b$export$7a90b43b29d22817() {
    const mgr = $acw62.useContext($1ae4eb57bb4d8f1b$var$PlanManagerV2Context).waypointManager;
    if (!mgr) throw new Error("Waypoint manager not available");
    return mgr;
}
function $1ae4eb57bb4d8f1b$export$352d37a1384d31c3() {
    const mgr = $acw62.useContext($1ae4eb57bb4d8f1b$var$PlanManagerV2Context).navPointManager;
    if (!mgr) throw new Error("NavPoint manager not available");
    return mgr;
}
const $1ae4eb57bb4d8f1b$var$PLAN_ITEMS_QUERY_KEY = "planItems";
const $1ae4eb57bb4d8f1b$export$f006ac3e7644ef4a = (manifestID)=>{
    const pmV2 = $1ae4eb57bb4d8f1b$export$5020ca831ed7928a();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    return $acw62.useCallback(async (item)=>{
        await pmV2.add(currentUser, item);
        return qc.invalidateQueries([
            $1ae4eb57bb4d8f1b$var$PLAN_ITEMS_QUERY_KEY,
            manifestID
        ]);
    }, [
        pmV2,
        manifestID
    ]);
};
const $1ae4eb57bb4d8f1b$export$38a9b5ff2a6ec096 = (manifestID)=>{
    const pmV2 = $1ae4eb57bb4d8f1b$export$5020ca831ed7928a();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return $acw62.useCallback(async (item)=>{
        await pmV2.update(item);
        return qc.invalidateQueries([
            $1ae4eb57bb4d8f1b$var$PLAN_ITEMS_QUERY_KEY,
            manifestID
        ]);
    }, [
        pmV2,
        manifestID
    ]);
};
const $1ae4eb57bb4d8f1b$export$d5a943bb2ea9518c = (manifestID)=>{
    const { data: items, isLoading: isLoading, error: error } = $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f(manifestID);
    const add = $1ae4eb57bb4d8f1b$export$f006ac3e7644ef4a(manifestID);
    const update = $1ae4eb57bb4d8f1b$export$38a9b5ff2a6ec096(manifestID);
    return $acw62.useCallback(async (item)=>{
        const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(items, {
            group: item.group,
            uniqID: item.uniqID,
            type: item.type
        });
        if (existing) return update({
            ...existing,
            ...item
        });
        else return add(item);
    }, [
        add,
        update,
        isLoading,
        error
    ]);
};
const $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f = (manifestID, opts)=>{
    const pmV2 = $1ae4eb57bb4d8f1b$export$5020ca831ed7928a();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $1ae4eb57bb4d8f1b$var$PLAN_ITEMS_QUERY_KEY,
        manifestID
    ], async ()=>{
        if (!manifestID) return [];
        return pmV2.list(manifestID);
    }, opts);
};
const $1ae4eb57bb4d8f1b$export$2e55148600f7bc1b = (manifestID, group)=>{
    const { data: d, ...rest } = $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f(manifestID);
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(d, {
        group: group
    });
    return {
        data: data,
        ...rest
    };
};
const $1ae4eb57bb4d8f1b$export$8bbf2d825787d1a6 = (manifestID, groupName, type)=>{
    const { data: d, ...rest } = $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f(manifestID);
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(d, {
        group: groupName,
        type: type
    });
    return {
        data: data,
        ...rest
    };
};
function $1ae4eb57bb4d8f1b$export$e11674744930cd15(msg) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(msg, "Missing or insufficient permissions");
}





const $92839c6c950486dc$export$c446799d3c20abd9 = /*#__PURE__*/ $acw62.createContext(null);
function $92839c6c950486dc$export$ee75abe092c19c2({ manager: manager, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($92839c6c950486dc$export$c446799d3c20abd9.Provider, {
        value: manager,
        children: children
    });
}
function $92839c6c950486dc$export$b7eed842b7007476() {
    return $acw62.useContext($92839c6c950486dc$export$c446799d3c20abd9);
}
const $92839c6c950486dc$export$2bc4a83296d7cbc4 = "Plans";
function $92839c6c950486dc$export$aa3859200fac1b16(fragOrderID, opts) {
    const mgr = $92839c6c950486dc$export$b7eed842b7007476();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $92839c6c950486dc$export$2bc4a83296d7cbc4,
        fragOrderID
    ], ()=>mgr.listPlans(fragOrderID), opts);
}
function $92839c6c950486dc$export$7f919cacd49cf683(plans, groups, filters) {
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(plans, filters);
    const combined = (0, $319680b363c8af04$export$c481faffd44f8c9d)(filtered);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>{
        const f = {
            groupName: g.name
        };
        if (filters?.status) f.status = filters.status;
        if (filters?.user) f.created_by_uid = filters.user.id;
        const plan = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(combined, f);
        const out = {
            ...g
        };
        if (plan) {
            if (plan.waypoints && plan.waypoints.length > 1) out.waypoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(plan.waypoints, "number");
            if (plan.navPoints && plan.navPoints.length > 0) out.navTargetPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(plan.navPoints, "index");
            out.plan = plan;
        }
        return out;
    });
}
const $92839c6c950486dc$export$44b2a9c32532960 = "groups_with_plan";
function $92839c6c950486dc$export$eb9ef5d0eda4b7a6(fragOrderID, groups, filters) {
    const { state: state } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const mgr = $92839c6c950486dc$export$b7eed842b7007476();
    const v2 = (0, $1ae4eb57bb4d8f1b$export$5020ca831ed7928a)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $92839c6c950486dc$export$44b2a9c32532960,
        fragOrderID,
        groups
    ], async ()=>{
        if (state?.manifest?.version >= 3) {
            const res = await v2.list(state.manifest.id);
            const waypoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(res, {
                type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint
            });
            const out = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>{
                const plannedWaypoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(waypoints, {
                    group: g.name
                }), (p)=>JSON.parse(p.payload));
                const uniq = [];
                const replaced = {};
                // Replace matches
                for (const w of g.waypoints){
                    const match = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(plannedWaypoints, {
                        number: w.number
                    });
                    if (match) {
                        const item = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(waypoints, {
                            group: g.name,
                            uniqID: w.number.toString()
                        });
                        replaced[w.number] = true;
                        if (item?.deleted) continue;
                        uniq.push(match);
                    } else uniq.push(w);
                }
                // Add additional waypoints
                for (const w of plannedWaypoints){
                    const item = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(waypoints, {
                        group: g.name,
                        uniqID: w.number.toString()
                    });
                    if (item?.deleted) {
                        console.log("deleted", w);
                        continue;
                    }
                    if (!replaced[w.number]) uniq.push(w);
                }
                return {
                    ...g,
                    waypoints: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(uniq, "number")
                };
            });
            return out;
        }
        const plans = await mgr.listPlans(fragOrderID);
        return $92839c6c950486dc$export$7f919cacd49cf683(plans, groups, filters);
    }, {
        refetchInterval: Infinity
    });
}
function $92839c6c950486dc$var$plannedWaypointsForGroup(g, controller) {
    const s = controller.findSource(g.name);
    if (!s) return null;
    return s.getFeatures();
}
function $92839c6c950486dc$export$7c0965223e29d235(manifest, theater, controller) {
    const mgr = $92839c6c950486dc$export$b7eed842b7007476();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const nav = (0, $99f46708ff5ed621$export$9e35e8a90270fdf6)();
    return $acw62.useCallback(async (g, radioOverrides = null, plannerNotes = null, laserConfig = null)=>{
        if (manifest.version >= 3) // Skip this code path for new
        return;
        let waypoints = g.waypoints;
        let navPoints = g.navTargetPoints;
        if (controller) {
            // I guess we were assuming that a planning controller was already initialized.
            // Found during laser codes, but was broken for notes as well.
            const features = $92839c6c950486dc$var$plannedWaypointsForGroup(g, controller);
            const w = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(features, $92839c6c950486dc$export$38c4cb5fbd3d765a(theater));
            waypoints = w;
        }
        if (nav) {
            const navPointFeatures = nav.getPlannedNavPoints(g.name);
            navPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(g.navTargetPoints, (p)=>{
                const match = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(navPointFeatures, (f)=>{
                    return f.get("point").index === p.index;
                });
                if (match) {
                    const [long, lat] = match.getGeometry().getCoordinates();
                    const { x: x, y: y } = (0, $79e13355954d15ea$export$43105f50ad4fdfb0)(theater, {
                        long: long,
                        lat: lat
                    });
                    const point = match.get("point");
                    return {
                        ...p,
                        x: x,
                        y: y,
                        textComment: point.textComment,
                        index: point.index
                    };
                }
                return p;
            });
            const newNavPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(navPointFeatures, (f)=>{
                return !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(g.navTargetPoints, (p)=>{
                    return p.index === f.get("point").index;
                });
            });
            const formatted = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(newNavPoints, (f)=>{
                const [long, lat] = f.getGeometry().getCoordinates();
                const { x: x, y: y } = (0, $79e13355954d15ea$export$43105f50ad4fdfb0)(theater, {
                    long: long,
                    lat: lat
                });
                const point = f.get("point");
                return {
                    x: x,
                    y: y,
                    textComment: point.textComment,
                    index: point.index
                };
            });
            navPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(navPoints, formatted);
        }
        const moduleName = $92839c6c950486dc$var$getModuleNameForGroup(g);
        // Check for out of sequence waypoints. This will crash DCS.
        const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(waypoints, "number");
        for(let i = 1; i < sorted.length; i++){
            if (sorted[i].number !== i) throw new Error(`Waypoint ${sorted[i].number} is out of sequence for group ${g.name}.`);
        }
        const p = await mgr.upsertPlan({
            user: currentUser,
            coalition: manifest.coalition,
            fragOrderID: manifest.fragOrderID,
            groupName: g.name,
            category: g.category,
            moduleName: moduleName
        }, waypoints, radioOverrides, plannerNotes, laserConfig, navPoints);
        await Promise.all([
            queryClient.invalidateQueries([
                $92839c6c950486dc$export$2bc4a83296d7cbc4,
                manifest.fragOrderID
            ]),
            queryClient.invalidateQueries([
                $92839c6c950486dc$export$44b2a9c32532960
            ])
        ]);
        return p;
    }, [
        manifest,
        theater,
        controller
    ]);
}
const $92839c6c950486dc$export$38c4cb5fbd3d765a = (theater)=>(f)=>{
        const [long, lat] = f.getGeometry().getCoordinates();
        const { x: x, y: y } = (0, $79e13355954d15ea$export$43105f50ad4fdfb0)(theater, {
            long: long,
            lat: lat
        });
        const number = f.get("number");
        const name = f.get("name");
        return {
            name: name === number.toString() ? number.toString() : name,
            number: number,
            action: (0, $91a9098e14452db2$export$b851e513e23ef23b).TurningPoint,
            type: (0, $91a9098e14452db2$export$325098d3a9c3b991).TurningPoint,
            alt: f.get("altitude") || 0,
            alt_type: f.get("altitudeType") || (0, $91a9098e14452db2$export$4b3b082d0b2e2996).AGL,
            x: x,
            y: y,
            ETA: f.get("eta") || 0
        };
    };
function $92839c6c950486dc$var$getModuleNameForGroup(g) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(g.units, [
        0,
        "type"
    ]);
}
function $92839c6c950486dc$export$ec5b24de8874d406() {
    const { controller: controller, state: { tasking: { plannedGroups: plannedGroups } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    return (sourceGroup, targetGroup)=>{
        return controller.current.copyWaypoints(sourceGroup, targetGroup, plannedGroups);
    };
}
function $92839c6c950486dc$export$53040a172a7e0d87() {
    const { data: manifest } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    const { data: tasking } = (0, $a10ff9c4760c9625$export$5c900e05ff5ed627)();
    return $92839c6c950486dc$export$eb9ef5d0eda4b7a6(manifest.fragOrderID, tasking.plannedGroups);
}



var $99f46708ff5ed621$export$bb7997377d28252d;
(function(DrawMode) {
    DrawMode[DrawMode["None"] = 0] = "None";
    DrawMode[DrawMode["Freehand"] = 1] = "Freehand";
    DrawMode[DrawMode["Ruler"] = 2] = "Ruler";
    DrawMode[DrawMode["PointDrop"] = 3] = "PointDrop";
})($99f46708ff5ed621$export$bb7997377d28252d || ($99f46708ff5ed621$export$bb7997377d28252d = {}));
var $99f46708ff5ed621$export$159e21535af98b26;
(function(TaskingMapActionTypes) {
    TaskingMapActionTypes[TaskingMapActionTypes["focusFeature"] = 0] = "focusFeature";
    TaskingMapActionTypes[TaskingMapActionTypes["blurFeature"] = 1] = "blurFeature";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleDrawer"] = 2] = "toggleDrawer";
    TaskingMapActionTypes[TaskingMapActionTypes["soloGroup"] = 3] = "soloGroup";
    TaskingMapActionTypes[TaskingMapActionTypes["setDrawMode"] = 4] = "setDrawMode";
    TaskingMapActionTypes[TaskingMapActionTypes["mapReady"] = 5] = "mapReady";
    TaskingMapActionTypes[TaskingMapActionTypes["togglePlanning"] = 6] = "togglePlanning";
    TaskingMapActionTypes[TaskingMapActionTypes["enableWaypointDropMode"] = 7] = "enableWaypointDropMode";
    TaskingMapActionTypes[TaskingMapActionTypes["disableWaypointDropMode"] = 8] = "disableWaypointDropMode";
    TaskingMapActionTypes[TaskingMapActionTypes["setPlanStatus"] = 9] = "setPlanStatus";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleGroupLayers"] = 10] = "toggleGroupLayers";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleMapLayers"] = 11] = "toggleMapLayers";
    TaskingMapActionTypes[TaskingMapActionTypes["togglePlanningDataEntry"] = 12] = "togglePlanningDataEntry";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleAssetViewer"] = 13] = "toggleAssetViewer";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleLayer"] = 14] = "toggleLayer";
    TaskingMapActionTypes[TaskingMapActionTypes["disableDistances"] = 15] = "disableDistances";
    TaskingMapActionTypes[TaskingMapActionTypes["disableWaypointLabels"] = 16] = "disableWaypointLabels";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleEditControlMeasure"] = 17] = "toggleEditControlMeasure";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleNavPointMode"] = 18] = "toggleNavPointMode";
    TaskingMapActionTypes[TaskingMapActionTypes["toggleCompassViz"] = 19] = "toggleCompassViz";
})($99f46708ff5ed621$export$159e21535af98b26 || ($99f46708ff5ed621$export$159e21535af98b26 = {}));
var $99f46708ff5ed621$export$6f7bda0e1442fae8;
(function(TaskingMenuDrawer) {
    TaskingMenuDrawer[TaskingMenuDrawer["PlayerGroups"] = 0] = "PlayerGroups";
    TaskingMenuDrawer[TaskingMenuDrawer["Planning"] = 1] = "Planning";
    TaskingMenuDrawer[TaskingMenuDrawer["Airbases"] = 2] = "Airbases";
    TaskingMenuDrawer[TaskingMenuDrawer["SupportAssets"] = 3] = "SupportAssets";
})($99f46708ff5ed621$export$6f7bda0e1442fae8 || ($99f46708ff5ed621$export$6f7bda0e1442fae8 = {}));
function $99f46708ff5ed621$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case 0:
            return {
                ...state,
                focusedFeature: {
                    layerName: action.layerName,
                    name: action.name,
                    featureClass: action.featureClass,
                    pageableFeatures: action.otherFeatures
                },
                dataEntryGroup: action.layerName === "Player Groups" ? action.name : state.dataEntryGroup
            };
        case 1:
            return {
                ...state,
                focusedFeature: null
            };
        case 2:
            return {
                ...state,
                openDrawerValue: action.value
            };
        case 4:
            return {
                ...state,
                drawMode: action.mode,
                waypointDropMode: action.mode === 0 ? false : state.waypointDropMode
            };
        case 5:
            // This is just here to force a re-render when the map is created
            return {
                ...state
            };
        case 6:
            return {
                ...state,
                planningMode: action.enabled
            };
        case 7:
            return {
                ...state,
                waypointDropMode: true
            };
        case 8:
            return {
                ...state,
                waypointDropMode: false
            };
        case 9:
            return {
                ...state,
                plans: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).set([
                    ...state.plans
                ], [
                    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).findIndex(state.plans, {
                        groupName: action.groupName
                    }),
                    "status"
                ], action.status)
            };
        case 12:
            return {
                ...state,
                dataEntryGroup: action.enabled ? action.groupName : null,
                dataEntryEnabled: action.enabled
            };
        case 13:
            return {
                ...state,
                assetViewer: {
                    ...state.assetViewer,
                    open: action.open
                }
            };
        case 14:
            return {
                ...state,
                disabledLayers: $99f46708ff5ed621$var$nextLayers(state, action.layers, action.enabled)
            };
        case 15:
            return {
                ...state,
                disableDistances: action.enabled
            };
        case 16:
            return {
                ...state,
                disableWaypointLabels: action.enabled
            };
        case 17:
            return {
                ...state,
                editingControlMeasure: action.controlMeasure || null
            };
        case 18:
            return {
                ...state,
                focusedFeature: null,
                navPointMode: {
                    enabled: !state.navPointMode.enabled,
                    group: action.group
                }
            };
        case 19:
            return {
                ...state,
                compassVisible: action.enabled
            };
        default:
            break;
    }
    return state;
}
function $99f46708ff5ed621$var$nextLayers(state, actionLayer, enabled) {
    const nextLayers = [
        ...state.disabledLayers
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(actionLayer, (l)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isUndefined(enabled)) {
            if (enabled) (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pull(nextLayers, l);
            else nextLayers.push(l);
            return;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(nextLayers, l)) (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).pull(nextLayers, l);
        else nextLayers.push(l);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(nextLayers);
}
const $99f46708ff5ed621$export$c9b1963ef22ba7a5 = /*#__PURE__*/ $acw62.createContext({});
function $99f46708ff5ed621$var$initialPlans(manifest, tasking, plannableGroups) {
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(tasking.plannedGroups, (g)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(plannableGroups, g.name));
    const plans = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(groups, (g)=>{
        plans.push({
            coalition: manifest.coalition,
            fragOrderID: manifest.fragOrderID,
            groupName: g.name,
            groupCategory: g.category,
            waypoints: g.waypoints,
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).None,
            moduleName: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(g.units, [
                0,
                "type"
            ])
        });
    });
    return plans;
}
function $99f46708ff5ed621$export$49d5fc8cba920a0(manifest, tasking, plannableGroups, history) {
    const assetViewOpen = new URLSearchParams(history?.location.search).get((0, $91a9098e14452db2$export$895cfaa78f9f7717)) === "true";
    return {
        manifest: manifest,
        contextualHopup: {
            visible: false,
            coordinates: null,
            features: []
        },
        focusedFeature: null,
        tasking: tasking,
        userPlannableGroups: plannableGroups,
        openDrawerValue: null,
        drawMode: 0,
        planningMode: false,
        plans: $99f46708ff5ed621$var$initialPlans(manifest, tasking, plannableGroups),
        waypointDropMode: false,
        dataEntryGroup: null,
        dataEntryEnabled: false,
        assetViewer: {
            open: assetViewOpen
        },
        disabledLayers: [],
        colorMap: (0, $e1dc1ccf277543ba$export$d87878d6a8186d78)((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(tasking.plannedGroups, "name")),
        disableDistances: true,
        disableWaypointLabels: false,
        editingControlMeasure: null,
        navPointMode: {
            enabled: false,
            group: null
        },
        compassVisible: false
    };
}
function $99f46708ff5ed621$export$6b4e12d920b219ca({ children: children, tasking: tasking, plannableGroups: plannableGroups, publish: publish, disableUI: disableUI }) {
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const controller = $acw62.useRef(null);
    const navPointController = $acw62.useRef(null);
    const initialState = $99f46708ff5ed621$export$49d5fc8cba920a0(publish, tasking, plannableGroups, history);
    if (disableUI) initialState.disableUI = disableUI;
    const [state, dispatch] = $acw62.useReducer($99f46708ff5ed621$export$1650419e431d3ba3, initialState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($99f46708ff5ed621$export$c9b1963ef22ba7a5.Provider, {
        value: {
            state: state,
            dispatch: dispatch,
            controller: controller,
            navPointController: navPointController
        },
        children: children
    });
}
function $99f46708ff5ed621$export$3120560bb593c233() {
    return $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
}
function $99f46708ff5ed621$export$8e382b6f4e85b912() {
    const { state: state } = $99f46708ff5ed621$export$3120560bb593c233();
    return state.userPlannableGroups.length > 0;
}
function $99f46708ff5ed621$var$canPlan(state, groupName) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(state.userPlannableGroups, groupName);
}
function $99f46708ff5ed621$export$9e53ded791f25835(groupName) {
    const { state: state } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return $99f46708ff5ed621$var$canPlan(state, groupName);
}
function $99f46708ff5ed621$export$a1854f3defd0f515() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (layerName, name, featureClass, otherFeatures = [])=>{
        dispatch({
            type: 0,
            layerName: layerName,
            name: name,
            otherFeatures: otherFeatures,
            featureClass: featureClass
        });
    };
}
function $99f46708ff5ed621$export$19df1d269fc1c6e9() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return ()=>{
        dispatch({
            type: 1
        });
    };
}
function $99f46708ff5ed621$export$910c5181afa5ba66() {
    const select = $99f46708ff5ed621$export$a1854f3defd0f515();
    return (groupName, wp)=>select(groupName, wp?.number, (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint);
}
function $99f46708ff5ed621$export$9eeff4ea7fd3fcc() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (enabled, groupName)=>{
        dispatch({
            type: 12,
            groupName: groupName,
            enabled: enabled
        });
    };
}
function $99f46708ff5ed621$export$59b9dc6fb1cf1292() {
    const { state: { tasking: { plannedGroups: plannedGroups } } } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    const toggle = $99f46708ff5ed621$export$90155930613bed46();
    return (groupName)=>{
        const rest = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(plannedGroups, (g)=>g.name != groupName);
        const layers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rest, (g)=>(0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                g.name
            ]));
        toggle(layers, false);
        toggle([
            (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                groupName
            ])
        ], true);
    };
}
function $99f46708ff5ed621$export$256cead14fc47c14() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (open)=>dispatch({
            type: 13,
            open: open
        });
}
function $99f46708ff5ed621$export$cce769050d8b552e() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (mode)=>{
        dispatch({
            type: 4,
            mode: mode
        });
    };
}
function $99f46708ff5ed621$export$90155930613bed46() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (layers, enabled)=>{
        dispatch({
            type: 14,
            layers: layers,
            enabled: enabled
        });
    };
}
function $99f46708ff5ed621$export$6af74cd118fd0c5d() {
    const { state: state } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return state?.colorMap || {};
}
function $99f46708ff5ed621$export$fce17c6a22986ba4(groupName) {
    const cm = $99f46708ff5ed621$export$6af74cd118fd0c5d();
    return cm[groupName];
}
function $99f46708ff5ed621$export$4448fc5d2712794a() {
    const { state: state, controller: controller } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const submit = (0, $92839c6c950486dc$export$7c0965223e29d235)(state.manifest, state.tasking.theater, controller.current);
    $acw62.useEffect(()=>{
        // Handling this via PlanManaverV2 to accomodate PlanItems
        if (state.manifest.version >= 3) return;
        const p = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(state.plans, {
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Draft
        });
        if (p.length === 0) return;
        const work = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(p, (p)=>{
            const g = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(state.tasking.plannedGroups, {
                name: p.groupName
            });
            if (g) return submit(g);
        });
        Promise.all(work).then(()=>success("Plan updated")).catch((e)=>{
            error(`Error updating plan: ${e.message}`);
            throw e;
        });
    }, [
        state.plans
    ]);
}
function $99f46708ff5ed621$export$635e5f346bd462a6() {
    const { dispatch: dispatch, state: state } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (enabled)=>{
        dispatch({
            type: 6,
            enabled: typeof enabled !== "undefined" ? enabled : !state.planningMode
        });
    };
}
function $99f46708ff5ed621$export$4221ea9241cbaab6() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const { state: { manifest: manifest } } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    if (!currentUser) return false;
    return !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifest.controlMeasureEditors, (e)=>e.discordUserID === currentUser.id);
}
function $99f46708ff5ed621$export$9059596f8e425fd6() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (controlMeasure)=>{
        dispatch({
            type: 17,
            controlMeasure: controlMeasure
        });
    };
}
function $99f46708ff5ed621$export$37f1b64de37d2ad1() {
    const { dispatch: dispatch } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return (group)=>{
        dispatch({
            type: 18,
            group: group
        });
    };
}
function $99f46708ff5ed621$export$9e35e8a90270fdf6() {
    const { navPointController: navPointController } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return navPointController.current;
}
function $99f46708ff5ed621$export$b4f230b1bcff1dd6() {
    const { state: state } = $acw62.useContext($99f46708ff5ed621$export$c9b1963ef22ba7a5);
    return state.disableUI;
}


const $9c554d6df7d74017$var$WHICH_RIGHT_CLICK = 3;
const $9c554d6df7d74017$var$WHICH_LEFT_CLICK = 1;
const $9c554d6df7d74017$var$WHICH_MOUSE_MOVE = 0;
function $9c554d6df7d74017$export$15fd6aa86c652915(event) {
    return event.originalEvent.which === $9c554d6df7d74017$var$WHICH_LEFT_CLICK;
}
function $9c554d6df7d74017$export$d8dfe47506dd265c(event) {
    return event.originalEvent.which === $9c554d6df7d74017$var$WHICH_MOUSE_MOVE;
}
function $9c554d6df7d74017$export$8a7ef89a0633946c(event) {
    return event.originalEvent.which === $9c554d6df7d74017$var$WHICH_RIGHT_CLICK;
}



var $f1q41 = parcelRequire("f1q41");
/**
 * @module ol/Map
 */ 


/**
 * @module ol/renderer/Composite
 */ 
/**
 * @module ol/renderer/Map
 */ 







/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $b370ab32454a96fd$var$MapRenderer extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $e22e7611e69f42a9$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $013a1733c226ec50$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $f351daabfe6e2d22$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($b370ab32454a96fd$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $b370ab32454a96fd$var$expireIconCache(map, frameState) {
    (0, $f351daabfe6e2d22$export$747ccdf771a87ab8).expire();
}
var $b370ab32454a96fd$export$2e2bcd8739ae039 = $b370ab32454a96fd$var$MapRenderer;










/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $fa78c97693b12120$var$CompositeMapRenderer extends (0, $b370ab32454a96fd$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)((0, $d4aabc5c971073f1$export$1d36981fcadac93b), (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText.bind(map));
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = document.createElement("div");
        const style = this.element_.style;
        style.position = "absolute";
        style.width = "100%";
        style.height = "100%";
        style.zIndex = "0";
        this.element_.className = (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " ol-layers";
        const container = map.getViewport();
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $b80dddceb0c42ad4$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $c8d6dc4c09ed9916$export$2e2bcd8739ae039) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $534f30fce11effcd$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != "ready" && sourceState != "undefined") {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $075f937d7366f1a2$export$caeacfe04f52533a)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = "";
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $fa78c97693b12120$export$2e2bcd8739ae039 = $fa78c97693b12120$var$CompositeMapRenderer;




/**
 * @module ol/layer/Group
 */ 










class $0b703156bb914e6f$export$2f5ff21d758d25a7 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $0b703156bb914e6f$var$Property = {
    LAYERS: "layers"
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ class $0b703156bb914e6f$var$LayerGroup extends (0, $57c5f0299cb9b82f$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($0b703156bb914e6f$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === "function", "Expected `layers` to be an array or a `Collection`");
        } else layers = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layers, (0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $0b703156bb914e6f$var$LayerGroup) listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, "addlayer", this.handleLayerGroupAdd_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layer, "removelayer", this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $6c5e11070e371322$export$5e82334337e0f204)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("addlayer", layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $6c5e11070e371322$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($0b703156bb914e6f$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $0b703156bb914e6f$export$2f5ff21d758d25a7("removelayer", currentLayers[i]));
        }
        this.set($0b703156bb914e6f$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return "ready";
    }
}
var $0b703156bb914e6f$export$2e2bcd8739ae039 = $0b703156bb914e6f$var$LayerGroup;


/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $3a171922c3a0c5ed$var$MapEvent extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $3a171922c3a0c5ed$export$2e2bcd8739ae039 = $3a171922c3a0c5ed$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */ class $a1b91f073c6a6c43$var$MapBrowserEvent extends (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ("preventDefault" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ("stopPropagation" in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $a1b91f073c6a6c43$export$2e2bcd8739ae039 = $a1b91f073c6a6c43$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 

/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $150f412a4a7fa263$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: "singleclick",
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $294047c5e65f31a3$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: "pointerdrag",
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $d564567e31203d44$export$2e2bcd8739ae039 = {
    POINTERMOVE: "pointermove",
    POINTERDOWN: "pointerdown",
    POINTERUP: "pointerup",
    POINTEROVER: "pointerover",
    POINTEROUT: "pointerout",
    POINTERENTER: "pointerenter",
    POINTERLEAVE: "pointerleave",
    POINTERCANCEL: "pointercancel"
};





class $6085d006f9d0efe2$var$MapBrowserEventHandler extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(element, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, "target", {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(doc, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_, (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== "boolean" || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $6085d006f9d0efe2$export$2e2bcd8739ae039 = $6085d006f9d0efe2$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $e4ad75f913b6f7ff$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: "postrender",
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: "movestart",
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: "moveend",
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: "loadstart",
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: "loadend"
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $07fa325567004bb7$export$2e2bcd8739ae039 = {
    LAYERGROUP: "layergroup",
    SIZE: "size",
    TARGET: "target",
    VIEW: "view"
};





/**
 * @module ol/TileQueue
 */ 
/**
 * @module ol/structs/PriorityQueue
 */ 

const $716c6804ea170b71$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $716c6804ea170b71$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $beaefe87199bb537$export$42ffd38884aecdac)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), "Tried to enqueue an `element` that was already added to the queue");
        const priority = this.priorityFunction_(element);
        if (priority != $716c6804ea170b71$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $716c6804ea170b71$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $716c6804ea170b71$export$2e2bcd8739ae039 = $716c6804ea170b71$var$PriorityQueue;


/**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $b8291d9739c3c64e$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};


/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */ class $4c51fd53052a6bbc$var$TileQueue extends (0, $716c6804ea170b71$export$2e2bcd8739ae039) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super(/**
       * @param {Array} element Element.
       * @return {number} Priority.
       */ function(element) {
            return tilePriorityFunction.apply(null, element);
        }, /**
       * @param {Array} element Element.
       * @return {string} Key.
       */ function(element) {
            return /** @type {import("./Tile.js").default} */ element[0].getKey();
        });
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {Array} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
            if (state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            /**
       * @type {import("./Tile.js").default}
       */ const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $4c51fd53052a6bbc$export$2e2bcd8739ae039 = $4c51fd53052a6bbc$var$TileQueue;
function $4c51fd53052a6bbc$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $716c6804ea170b71$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}









/**
 * @module ol/control/defaults
 */ /**
 * @module ol/control/Attribution
 */ /**
 * @module ol/control/Control
 */ 



/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $b978dafe8f7d27ff$var$Control extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = "auto";
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            target.appendChild(this.element);
            if (this.render !== (0, $013a1733c226ec50$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === "string" ? document.getElementById(target) : target;
    }
}
var $b978dafe8f7d27ff$export$2e2bcd8739ae039 = $b978dafe8f7d27ff$var$Control;







/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $6a26ab11104d2c24$var$Attribution extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement("ul");
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : "ol-attribution";
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : "Attributions";
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + "-expand";
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : "\u203A";
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + "-collapse";
        if (typeof collapseLabel === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement("span");
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : "i";
        if (typeof label === "string") {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement("span");
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement("button");
        this.toggleButton_.setAttribute("type", "button");
        this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + " " + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " " + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? " " + (0, $ce07df6d5d4656f1$export$e16017ac68d14492) : "") + (this.collapsible_ ? "" : " ol-uncollapsible");
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = "none";
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $013a1733c226ec50$export$4dbaaf6c79705e6c)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? "" : "none";
            this.renderedVisible_ = visible;
        }
        if ((0, $b998d41b678ed5d1$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement("li");
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $ce07df6d5d4656f1$export$e16017ac68d14492));
        if (this.collapsed_) (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $075f937d7366f1a2$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute("aria-expanded", String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle("ol-uncollapsible");
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $6a26ab11104d2c24$export$2e2bcd8739ae039 = $6a26ab11104d2c24$var$Attribution;



/**
 * @module ol/control/Rotate
 */ 



/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $a305cff1f91b3b86$var$Rotate extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : "ol-rotate";
        const label = options.label !== undefined ? options.label : "\u21E7";
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : "ol-compass";
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === "string") {
            this.label_ = document.createElement("span");
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : "Reset rotation";
        const button = document.createElement("button");
        button.className = className + "-reset";
        button.setAttribute("type", "button");
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + " " + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " " + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = "rotate(" + rotation + "rad)";
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $ce07df6d5d4656f1$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $ce07df6d5d4656f1$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $a305cff1f91b3b86$export$2e2bcd8739ae039 = $a305cff1f91b3b86$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $4901e3e27e30416a$var$Zoom extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement("div"),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : "ol-zoom";
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + "-in";
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + "-out";
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : "+";
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : "\u2013";
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : "Zoom in";
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : "Zoom out";
        const inElement = document.createElement("button");
        inElement.className = zoomInClassName;
        inElement.setAttribute("type", "button");
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === "string" ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement("button");
        outElement.className = zoomOutClassName;
        outElement.setAttribute("type", "button");
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === "string" ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + " " + (0, $ce07df6d5d4656f1$export$1afde3d6e16a7b29) + " " + (0, $ce07df6d5d4656f1$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $4901e3e27e30416a$export$2e2bcd8739ae039 = $4901e3e27e30416a$var$Zoom;


function $af7495b2f822d5e9$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $4901e3e27e30416a$export$2e2bcd8739ae039)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $a305cff1f91b3b86$export$2e2bcd8739ae039)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $6a26ab11104d2c24$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}


/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/interaction/DoubleClickZoom
 */ /**
 * @module ol/interaction/Interaction
 */ 
/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $2c9e42723ccf2bfb$export$2e2bcd8739ae039 = {
    ACTIVE: "active"
};



/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $39210df8527e63e5$var$Interaction extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $39210df8527e63e5$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $c7ccf7e681a9b333$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $39210df8527e63e5$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
    });
}
var $39210df8527e63e5$export$2e2bcd8739ae039 = $39210df8527e63e5$var$Interaction;



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $b50403621294a654$var$DoubleClickZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $b50403621294a654$export$2e2bcd8739ae039 = $b50403621294a654$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ /**
 * @module ol/interaction/Pointer
 */ 

/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $cf1eb502962d87a8$var$PointerInteraction extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $cf1eb502962d87a8$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $cf1eb502962d87a8$export$2e2bcd8739ae039 = $cf1eb502962d87a8$var$PointerInteraction;



/**
 * @module ol/events/condition
 */ 



function $edf87b50170125f7$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $edf87b50170125f7$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const $edf87b50170125f7$export$ae2cdf064e3b0c55 = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute("tabindex") ? $edf87b50170125f7$export$d7ddd398f22d79ef(event) : true;
};
const $edf87b50170125f7$export$ba9e5d519bc326ca = (0, $013a1733c226ec50$export$22e23a2304399231);
const $edf87b50170125f7$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).CLICK;
};
const $edf87b50170125f7$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $67c66761d21428d0$export$39dfd62a25e0fe93) && (0, $67c66761d21428d0$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
const $edf87b50170125f7$export$b3e22bcfd64c1022 = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
const $edf87b50170125f7$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == "pointermove";
};
const $edf87b50170125f7$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK;
};
const $edf87b50170125f7$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK;
};
const $edf87b50170125f7$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $67c66761d21428d0$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $edf87b50170125f7$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return (0, $67c66761d21428d0$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $edf87b50170125f7$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $edf87b50170125f7$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== "INPUT" && tagName !== "SELECT" && tagName !== "TEXTAREA" && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $edf87b50170125f7$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == "mouse";
};
const $edf87b50170125f7$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "touch";
};
const $edf87b50170125f7$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvt !== undefined, "mapBrowserEvent must originate from a pointer event");
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === "pen";
};
const $edf87b50170125f7$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $35d5ec884318008e$export$a7a9523472993e97)(pointerEvent !== undefined, "mapBrowserEvent must originate from a pointer event");
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $c11585da26a016db$var$DragPan extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$fdc892d0d8fe3bfb), (0, $edf87b50170125f7$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $1bd0a226f9a16141$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $c11585da26a016db$export$2e2bcd8739ae039 = $c11585da26a016db$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $197c7092261b2aa0$var$DragRotate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $013a1733c226ec50$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $edf87b50170125f7$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $edf87b50170125f7$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $197c7092261b2aa0$export$2e2bcd8739ae039 = $197c7092261b2aa0$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ /**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box


/**
 * @module ol/render/Box
 */ 

class $c47adf75308683a6$var$RenderBox extends (0, $3273ed08087da3da$export$2e2bcd8739ae039) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement("div");
        this.element_.style.position = "absolute";
        this.element_.style.pointerEvents = "auto";
        this.element_.className = "ol-box " + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = "px";
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = "inherit";
            style.top = "inherit";
            style.width = "inherit";
            style.height = "inherit";
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $c47adf75308683a6$export$2e2bcd8739ae039 = $c47adf75308683a6$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $e05f414bc3918235$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: "boxstart",
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: "boxdrag",
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: "boxend",
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: "boxcancel"
};
class $e05f414bc3918235$export$7053c33c051365ea extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $e05f414bc3918235$var$DragBox extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $c47adf75308683a6$export$2e2bcd8739ae039)(options.className || "ol-dragbox");
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, $edf87b50170125f7$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea(completeBox ? $e05f414bc3918235$var$DragBoxEventType.BOXEND : $e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $e05f414bc3918235$export$7053c33c051365ea($e05f414bc3918235$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
var $e05f414bc3918235$export$2e2bcd8739ae039 = $e05f414bc3918235$var$DragBox;




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $afc7f51010a5b660$var$DragZoom extends (0, $e05f414bc3918235$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        super({
            condition: condition,
            className: options.className || "ol-dragzoom",
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $c7ccf7e681a9b333$export$57636bb43b1ccbb0)
        });
    }
}
var $afc7f51010a5b660$export$2e2bcd8739ae039 = $afc7f51010a5b660$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $368e06a3031941b5$export$2e2bcd8739ae039 = {
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown"
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $178bb1517d626802$var$KeyboardPan extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $edf87b50170125f7$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).DOWN || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).LEFT || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).RIGHT || key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $368e06a3031941b5$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $1bd0a226f9a16141$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $39210df8527e63e5$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $178bb1517d626802$export$2e2bcd8739ae039 = $178bb1517d626802$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $2237fabfa170eefc$var$KeyboardZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $edf87b50170125f7$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $edf87b50170125f7$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === "+" || key === "-")) {
                const map = mapBrowserEvent.map;
                const delta = key === "+" ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $2237fabfa170eefc$export$2e2bcd8739ae039 = $2237fabfa170eefc$var$KeyboardZoom;


/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $9a54ea8d5f7a49ee$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $9a54ea8d5f7a49ee$export$2e2bcd8739ae039 = $9a54ea8d5f7a49ee$var$Kinetic;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 




/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $aaa378764710d71e$var$MouseWheelZoom extends (0, $39210df8527e63e5$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $edf87b50170125f7$export$84bf76cd7afc7469)((0, $edf87b50170125f7$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../coordinate.js").Coordinate}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.coordinate;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta;
        if (mapBrowserEvent.type == (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL) {
            delta = wheelEvent.deltaY;
            if ((0, $67c66761d21428d0$export$8442bdfd18b7b8a6) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $67c66761d21428d0$export$6b83a0446fc26f94);
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? "trackpad" : "wheel";
        const view = map.getView();
        if (this.mode_ === "trackpad" && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $39210df8527e63e5$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $aaa378764710d71e$export$2e2bcd8739ae039 = $aaa378764710d71e$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $9727451f2459496c$var$PinchRotate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $d65f0a322291d127$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $9727451f2459496c$export$2e2bcd8739ae039 = $9727451f2459496c$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $79c946b60b88d4a6$var$PinchZoom extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $cf1eb502962d87a8$export$e2a20c553f6c85ce)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $79c946b60b88d4a6$export$2e2bcd8739ae039 = $79c946b60b88d4a6$var$PinchZoom;


function $e3fbd36d629ecc04$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    const kinetic = new (0, $9a54ea8d5f7a49ee$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $197c7092261b2aa0$export$2e2bcd8739ae039)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $b50403621294a654$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $c11585da26a016db$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $9727451f2459496c$export$2e2bcd8739ae039)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $79c946b60b88d4a6$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $178bb1517d626802$export$2e2bcd8739ae039)());
        interactions.push(new (0, $2237fabfa170eefc$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $aaa378764710d71e$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $afc7f51010a5b660$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}








/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, ?FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $41aa29ae0c4b607a$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $534f30fce11effcd$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) layer.getLayers().forEach($41aa29ae0c4b607a$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $41aa29ae0c4b607a$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $534f30fce11effcd$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$41aa29ae0c4b607a$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $41aa29ae0c4b607a$var$Map extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $41aa29ae0c4b607a$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $67c66761d21428d0$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $e22e7611e69f42a9$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ this.viewport_ = document.createElement("div");
        this.viewport_.className = "ol-viewport" + ("ontouchstart" in window ? " ol-touch" : "");
        this.viewport_.style.position = "relative";
        this.viewport_.style.overflow = "hidden";
        this.viewport_.style.width = "100%";
        this.viewport_.style.height = "100%";
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainer_ = document.createElement("div");
        this.overlayContainer_.style.position = "absolute";
        this.overlayContainer_.style.zIndex = "0";
        this.overlayContainer_.style.width = "100%";
        this.overlayContainer_.style.height = "100%";
        this.overlayContainer_.style.pointerEvents = "none";
        this.overlayContainer_.className = "ol-overlaycontainer";
        this.viewport_.appendChild(this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainerStopEvent_ = document.createElement("div");
        this.overlayContainerStopEvent_.style.position = "absolute";
        this.overlayContainerStopEvent_.style.zIndex = "0";
        this.overlayContainerStopEvent_.style.width = "100%";
        this.overlayContainerStopEvent_.style.height = "100%";
        this.overlayContainerStopEvent_.style.pointerEvents = "none";
        this.overlayContainerStopEvent_.className = "ol-overlaycontainer-stopevent";
        this.viewport_.appendChild(this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        /**
     * @private
     * @type {ResizeObserver}
     */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || (0, $af7495b2f822d5e9$export$ebe90cb607ad99e)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || (0, $e3fbd36d629ecc04$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $4c51fd53052a6bbc$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $70364d0195659942$export$2e2bcd8739ae039)(viewOptions));
        });
        this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $41aa29ae0c4b607a$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $0b703156bb914e6f$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $013a1733c226ec50$export$22e23a2304399231);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        "changedTouches" in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $931ffc4e747c14db$export$2e2bcd8739ae039)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $4c51fd53052a6bbc$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = /** @type {PointerEvent} */ mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL || eventType === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_) {
            this.resizeObserver_.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === "string" ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $fa78c97693b12120$export$2e2bcd8739ae039)(this);
            this.mapBrowserEventHandler_ = new (0, $6085d006f9d0efe2$export$2e2bcd8739ae039)(this, this.moveTolerance_);
            for(const key in 0, $150f412a4a7fa263$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $150f412a4a7fa263$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $67c66761d21428d0$export$f751ce96c6c4e4fc) ? {
                passive: false
            } : false);
            let keyboardEventTarget;
            if (!this.keyboardEventTarget_) {
                // check if map target is in shadowDOM, if yes use host element as target
                const targetRoot = targetElement.getRootNode();
                const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                keyboardEventTarget = targetCandidate;
            } else keyboardEventTarget = this.keyboardEventTarget_;
            this.targetChangeHandlerKeys_ = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(keyboardEventTarget, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
            ];
            const rootNode = targetElement.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
            this.resizeObserver_.observe(targetElement);
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(view, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $0b703156bb914e6f$export$2f5ff21d758d25a7)("addlayer", layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $e881b5dca21eb5d4$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.render, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, "addlayer", this.handleLayerAdd_, this),
                (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(layerGroup, "removelayer", this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        const layerStates = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $41aa29ae0c4b607a$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $cc435a5409103773$export$622c471beb1693c7)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $6da4c8ed3074c92b$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $6c5e11070e371322$export$5e82334337e0f204)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $6da4c8ed3074c92b$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $6da4c8ed3074c92b$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $7d362782b4ccb93d$export$2e2bcd8739ae039).INTERACTING] && !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $6da4c8ed3074c92b$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $3a171922c3a0c5ed$export$2e2bcd8739ae039)((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $f5e92a4d985a2824$export$2e2bcd8739ae039).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $0b703156bb914e6f$export$2f5ff21d758d25a7)("removelayer", oldLayerGroup));
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039)) {
            this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW, new (0, $70364d0195659942$export$2e2bcd8739ae039)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $70364d0195659942$export$2e2bcd8739ae039)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            const computedStyle = getComputedStyle(targetElement);
            const width = targetElement.offsetWidth - parseFloat(computedStyle["borderLeftWidth"]) - parseFloat(computedStyle["paddingLeft"]) - parseFloat(computedStyle["paddingRight"]) - parseFloat(computedStyle["borderRightWidth"]);
            const height = targetElement.offsetHeight - parseFloat(computedStyle["borderTopWidth"]) - parseFloat(computedStyle["paddingTop"]) - parseFloat(computedStyle["paddingBottom"]) - parseFloat(computedStyle["borderBottomWidth"]);
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, $cc435a5409103773$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $8c65b0699f3f3f8e$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $b998d41b678ed5d1$export$e9bab7fafb253603)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $41aa29ae0c4b607a$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === "string" ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === "function" ? /** @type {LayerGroup} */ options.layers : new (0, $0b703156bb914e6f$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $07fa325567004bb7$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $70364d0195659942$export$2e2bcd8739ae039) ? options.view : new (0, $70364d0195659942$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === "function", "Expected `controls` to be an array or an `ol/Collection.js`");
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === "function", "Expected `interactions` to be an array or an `ol/Collection.js`");
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $35d5ec884318008e$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === "function", "Expected `overlays` to be an array or an `ol/Collection.js`");
            overlays = options.overlays;
        }
    } else overlays = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $41aa29ae0c4b607a$export$2e2bcd8739ae039 = $41aa29ae0c4b607a$var$Map;






var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $f1q41 = parcelRequire("f1q41");

/**
 * @module ol/interaction/Modify
 */ 



















/**
 * The segment index assigned to a circle's center when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX = 0;
/**
 * The segment index assigned to a circle's circumference when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */ const $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX = 1;
const $8c24f34a0807f744$var$tempExtent = [
    0,
    0,
    0,
    0
];
const $8c24f34a0807f744$var$tempSegment = [];
/**
 * @enum {string}
 */ const $8c24f34a0807f744$var$ModifyEventType = {
    /**
   * Triggered upon feature modification start
   * @event ModifyEvent#modifystart
   * @api
   */ MODIFYSTART: "modifystart",
    /**
   * Triggered upon feature modification end
   * @event ModifyEvent#modifyend
   * @api
   */ MODIFYEND: "modifyend"
};
class $8c24f34a0807f744$export$eb2af8bb6aa1fb54 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {ModifyEventType} type Type.
   * @param {Collection<Feature>} features
   * The features modified.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent
   * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, features, mapBrowserEvent){
        super(type);
        /**
     * The features being modified.
     * @type {Collection<Feature>}
     * @api
     */ this.features = features;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'modifyend'|'modifystart', ModifyEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'modifyend'|'modifystart', Return>} ModifyOnSignature
 */ /**
 * @classdesc
 * Interaction for modifying feature geometries.  To modify features that have
 * been added to an existing source, construct the modify interaction with the
 * `source` option.  If you want to modify features in a collection (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.  The interaction must be constructed with either a
 * `source` or `features` option.
 *
 * Cartesian distance from the pointer is used to determine the features that
 * will be modified. This means that geometries will only be considered for
 * modification when they are within the configured `pixelTolerance`. For point
 * geometries, the `hitDetection` option can be used to match their visual
 * appearance.
 *
 * By default, the interaction will allow deletion of vertices when the `alt`
 * key is pressed.  To configure the interaction with a different condition
 * for deletion, use the `deleteCondition` option.
 * @fires ModifyEvent
 * @api
 */ class $8c24f34a0807f744$var$Modify extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super(/** @type {import("./Pointer.js").Options} */ options);
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ModifyOnSignature<void>}
     */ this.un;
        /** @private */ this.boundHandleFeatureChange_ = this.handleFeatureChange_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$189f0d593022b199);
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultDeleteCondition_ = function(mapBrowserEvent) {
            return (0, $edf87b50170125f7$export$573409992e89967e)(mapBrowserEvent) && (0, $edf87b50170125f7$export$194df8bad091b401)(mapBrowserEvent);
        };
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.deleteCondition_ = options.deleteCondition ? options.deleteCondition : this.defaultDeleteCondition_;
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.insertVertexCondition_ = options.insertVertexCondition ? options.insertVertexCondition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * Editing vertex.
     * @type {Feature<Point>}
     * @private
     */ this.vertexFeature_ = null;
        /**
     * Segments intersecting {@link this.vertexFeature_} by segment uid.
     * @type {Object<string, boolean>}
     * @private
     */ this.vertexSegments_ = null;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.lastPixel_ = [
            0,
            0
        ];
        /**
     * Tracks if the next `singleclick` event should be ignored to prevent
     * accidental deletion right after vertex creation.
     * @type {boolean}
     * @private
     */ this.ignoreNextSingleClick_ = false;
        /**
     * @type {Collection<Feature>}
     * @private
     */ this.featuresBeingModified_ = null;
        /**
     * Segment RTree for each layer
     * @type {RBush<SegmentData>}
     * @private
     */ this.rBush_ = new (0, $34c742891733e7a4$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
     * @type {boolean}
     * @private
     */ this.snappedToVertex_ = false;
        /**
     * Indicate whether the interaction is currently changing a feature's
     * coordinates.
     * @type {boolean}
     * @private
     */ this.changingFeature_ = false;
        /**
     * @type {Array}
     * @private
     */ this.dragSegments_ = [];
        /**
     * Draw overlay where sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: !!options.wrapX
            }),
            style: options.style ? options.style : $8c24f34a0807f744$var$getDefaultStyleFunction(),
            updateWhileAnimating: true,
            updateWhileInteracting: true
        });
        /**
     * @const
     * @private
     * @type {!Object<string, function(Feature, import("../geom/Geometry.js").default): void>}
     */ this.SEGMENT_WRITERS_ = {
            "Point": this.writePointGeometry_.bind(this),
            "LineString": this.writeLineStringGeometry_.bind(this),
            "LinearRing": this.writeLineStringGeometry_.bind(this),
            "Polygon": this.writePolygonGeometry_.bind(this),
            "MultiPoint": this.writeMultiPointGeometry_.bind(this),
            "MultiLineString": this.writeMultiLineStringGeometry_.bind(this),
            "MultiPolygon": this.writeMultiPolygonGeometry_.bind(this),
            "Circle": this.writeCircleGeometry_.bind(this),
            "GeometryCollection": this.writeGeometryCollectionGeometry_.bind(this)
        };
        /**
     * @type {VectorSource}
     * @private
     */ this.source_ = null;
        /**
     * @type {boolean|import("../layer/BaseVector").default}
     * @private
     */ this.hitDetection_ = null;
        /** @type {Collection<Feature>} */ let features;
        if (options.features) features = options.features;
        else if (options.source) {
            this.source_ = options.source;
            features = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(this.source_.getFeatures());
            this.source_.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).ADDFEATURE, this.handleSourceAdd_.bind(this));
            this.source_.addEventListener((0, $ccc4e6f11f11978f$export$2e2bcd8739ae039).REMOVEFEATURE, this.handleSourceRemove_.bind(this));
        }
        if (!features) throw new Error("The modify interaction requires features, a source or a layer");
        if (options.hitDetection) this.hitDetection_ = options.hitDetection;
        /**
     * @type {Collection<Feature>}
     * @private
     */ this.features_ = features;
        this.features_.forEach(this.addFeature_.bind(this));
        this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).ADD, this.handleFeatureAdd_.bind(this));
        this.features_.addEventListener((0, $161dd067fe2d672c$export$2e2bcd8739ae039).REMOVE, this.handleFeatureRemove_.bind(this));
        /**
     * @type {import("../MapBrowserEvent.js").default}
     * @private
     */ this.lastPointerEvent_ = null;
        /**
     * Delta (x, y in map units) between matched rtree vertex and pointer vertex.
     * @type {Array<number>}
     * @private
     */ this.delta_ = [
            0,
            0
        ];
        /**
     * @private
     */ this.snapToPointer_ = options.snapToPointer === undefined ? !this.hitDetection_ : options.snapToPointer;
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ addFeature_(feature) {
        const geometry = feature.getGeometry();
        if (geometry) {
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            if (writer) writer(feature, geometry);
        }
        const map = this.getMap();
        if (map && map.isRendered() && this.getActive()) this.handlePointerAtPixel_(this.lastPixel_, map);
        feature.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleFeatureChange_);
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
   * @param {Array<Array<SegmentData>>} segments The segments subject to modification.
   * @private
   */ willModifyFeatures_(evt, segments) {
        if (!this.featuresBeingModified_) {
            this.featuresBeingModified_ = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)();
            const features = this.featuresBeingModified_.getArray();
            for(let i = 0, ii = segments.length; i < ii; ++i){
                const segment = segments[i];
                for(let s = 0, ss = segment.length; s < ss; ++s){
                    const feature = segment[s].feature;
                    if (feature && !features.includes(feature)) this.featuresBeingModified_.push(feature);
                }
            }
            if (this.featuresBeingModified_.getLength() === 0) this.featuresBeingModified_ = null;
            else this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYSTART, this.featuresBeingModified_, evt));
        }
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeature_(feature) {
        this.removeFeatureSegmentData_(feature);
        // Remove the vertex feature if the collection of candidate features is empty.
        if (this.vertexFeature_ && this.features_.getLength() === 0) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        feature.removeEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.boundHandleFeatureChange_);
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureSegmentData_(feature) {
        const rBush = this.rBush_;
        /** @type {Array<SegmentData>} */ const nodesToRemove = [];
        rBush.forEach(/**
       * @param {SegmentData} node RTree node.
       */ function(node) {
            if (feature === node.feature) nodesToRemove.push(node);
        });
        for(let i = nodesToRemove.length - 1; i >= 0; --i){
            const nodeToRemove = nodesToRemove[i];
            for(let j = this.dragSegments_.length - 1; j >= 0; --j)if (this.dragSegments_[j][0] === nodeToRemove) this.dragSegments_.splice(j, 1);
            rBush.remove(nodeToRemove);
        }
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (this.vertexFeature_ && !active) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        super.setActive(active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        this.overlay_.setMap(map);
        super.setMap(map);
    }
    /**
   * Get the overlay layer that this interaction renders the modification point or vertex to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceAdd_(event) {
        if (event.feature) this.features_.push(event.feature);
    }
    /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */ handleSourceRemove_(event) {
        if (event.feature) this.features_.remove(event.feature);
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ handleFeatureAdd_(evt) {
        this.addFeature_(evt.element);
    }
    /**
   * @param {import("../events/Event.js").default} evt Event.
   * @private
   */ handleFeatureChange_(evt) {
        if (!this.changingFeature_) {
            const feature = /** @type {Feature} */ evt.target;
            this.removeFeature_(feature);
            this.addFeature_(feature);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ handleFeatureRemove_(evt) {
        this.removeFeature_(evt.element);
    }
    /**
   * @param {Feature} feature Feature
   * @param {Point} geometry Geometry.
   * @private
   */ writePointGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        /** @type {SegmentData} */ const segmentData = {
            feature: feature,
            geometry: geometry,
            segment: [
                coordinates,
                coordinates
            ]
        };
        this.rBush_.insert(geometry.getExtent(), segmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
   * @private
   */ writeMultiPointGeometry_(feature, geometry) {
        const points = geometry.getCoordinates();
        for(let i = 0, ii = points.length; i < ii; ++i){
            const coordinates = points[i];
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                depth: [
                    i
                ],
                index: i,
                segment: [
                    coordinates,
                    coordinates
                ]
            };
            this.rBush_.insert(geometry.getExtent(), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/LineString.js").default} geometry Geometry.
   * @private
   */ writeLineStringGeometry_(feature, geometry) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
            const segment = coordinates.slice(i, i + 2);
            /** @type {SegmentData} */ const segmentData = {
                feature: feature,
                geometry: geometry,
                index: i,
                segment: segment
            };
            this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
   * @private
   */ writeMultiLineStringGeometry_(feature, geometry) {
        const lines = geometry.getCoordinates();
        for(let j = 0, jj = lines.length; j < jj; ++j){
            const coordinates = lines[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/Polygon.js").default} geometry Geometry.
   * @private
   */ writePolygonGeometry_(feature, geometry) {
        const rings = geometry.getCoordinates();
        for(let j = 0, jj = rings.length; j < jj; ++j){
            const coordinates = rings[j];
            for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                const segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */ const segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [
                        j
                    ],
                    index: i,
                    segment: segment
                };
                this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
            }
        }
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
   * @private
   */ writeMultiPolygonGeometry_(feature, geometry) {
        const polygons = geometry.getCoordinates();
        for(let k = 0, kk = polygons.length; k < kk; ++k){
            const rings = polygons[k];
            for(let j = 0, jj = rings.length; j < jj; ++j){
                const coordinates = rings[j];
                for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
                    const segment = coordinates.slice(i, i + 2);
                    /** @type {SegmentData} */ const segmentData = {
                        feature: feature,
                        geometry: geometry,
                        depth: [
                            j,
                            k
                        ],
                        index: i,
                        segment: segment
                    };
                    this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segment), segmentData);
                }
            }
        }
    }
    /**
   * We convert a circle into two segments.  The segment at index
   * {@link CIRCLE_CENTER_INDEX} is the
   * circle's center (a point).  The segment at index
   * {@link CIRCLE_CIRCUMFERENCE_INDEX} is
   * the circumference, and is not a line segment.
   *
   * @param {Feature} feature Feature.
   * @param {import("../geom/Circle.js").default} geometry Geometry.
   * @private
   */ writeCircleGeometry_(feature, geometry) {
        const coordinates = geometry.getCenter();
        /** @type {SegmentData} */ const centerSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        /** @type {SegmentData} */ const circumferenceSegmentData = {
            feature: feature,
            geometry: geometry,
            index: $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX,
            segment: [
                coordinates,
                coordinates
            ]
        };
        const featureSegments = [
            centerSegmentData,
            circumferenceSegmentData
        ];
        centerSegmentData.featureSegments = featureSegments;
        circumferenceSegmentData.featureSegments = featureSegments;
        this.rBush_.insert((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(coordinates), centerSegmentData);
        let circleGeometry = /** @type {import("../geom/Geometry.js").default} */ geometry;
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection && this.getMap()) {
            const projection = this.getMap().getView().getProjection();
            circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            circleGeometry = (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(/** @type {import("../geom/Circle.js").default} */ circleGeometry).transform(projection, userProjection);
        }
        this.rBush_.insert(circleGeometry.getExtent(), circumferenceSegmentData);
    }
    /**
   * @param {Feature} feature Feature
   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
   * @private
   */ writeGeometryCollectionGeometry_(feature, geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0; i < geometries.length; ++i){
            const geometry = geometries[i];
            const writer = this.SEGMENT_WRITERS_[geometry.getType()];
            writer(feature, geometry);
        }
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {Array<Feature>} features The features being modified.
   * @param {Array<import("../geom/SimpleGeometry.js").default>} geometries The geometries being modified.
   * @return {Feature} Vertex feature.
   * @private
   */ createOrUpdateVertexFeature_(coordinates, features, geometries) {
        let vertexFeature = this.vertexFeature_;
        if (!vertexFeature) {
            vertexFeature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(coordinates));
            this.vertexFeature_ = vertexFeature;
            this.overlay_.getSource().addFeature(vertexFeature);
        } else {
            const geometry = vertexFeature.getGeometry();
            geometry.setCoordinates(coordinates);
        }
        vertexFeature.set("features", features);
        vertexFeature.set("geometries", geometries);
        return vertexFeature;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may modify the geometry.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        this.lastPointerEvent_ = mapBrowserEvent;
        let handled;
        if (!mapBrowserEvent.map.getView().getInteracting() && mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE && !this.handlingDownUpSequence) this.handlePointerMove_(mapBrowserEvent);
        if (this.vertexFeature_ && this.deleteCondition_(mapBrowserEvent)) {
            if (mapBrowserEvent.type != (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK || !this.ignoreNextSingleClick_) handled = this.removePoint();
            else handled = true;
        }
        if (mapBrowserEvent.type == (0, $150f412a4a7fa263$export$2e2bcd8739ae039).SINGLECLICK) this.ignoreNextSingleClick_ = false;
        return super.handleEvent(mapBrowserEvent) && !handled;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @override
   */ handleDragEvent(evt) {
        this.ignoreNextSingleClick_ = false;
        this.willModifyFeatures_(evt, this.dragSegments_);
        const vertex = [
            evt.coordinate[0] + this.delta_[0],
            evt.coordinate[1] + this.delta_[1]
        ];
        const features = [];
        const geometries = [];
        for(let i = 0, ii = this.dragSegments_.length; i < ii; ++i){
            const dragSegment = this.dragSegments_[i];
            const segmentData = dragSegment[0];
            const feature = segmentData.feature;
            if (!features.includes(feature)) features.push(feature);
            const geometry = segmentData.geometry;
            if (!geometries.includes(geometry)) geometries.push(geometry);
            const depth = segmentData.depth;
            let coordinates;
            const segment = segmentData.segment;
            const index = dragSegment[1];
            while(vertex.length < geometry.getStride())vertex.push(segment[index][vertex.length]);
            switch(geometry.getType()){
                case "Point":
                    coordinates = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case "MultiPoint":
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index] = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case "LineString":
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "MultiLineString":
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "Polygon":
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "MultiPolygon":
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case "Circle":
                    segment[0] = vertex;
                    segment[1] = vertex;
                    if (segmentData.index === $8c24f34a0807f744$var$CIRCLE_CENTER_INDEX) {
                        this.changingFeature_ = true;
                        geometry.setCenter(vertex);
                        this.changingFeature_ = false;
                    } else {
                        // We're dragging the circle's circumference:
                        this.changingFeature_ = true;
                        const projection = evt.map.getView().getProjection();
                        let radius = (0, $1bd0a226f9a16141$export$9f17032d917177de)((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(geometry.getCenter(), projection), (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(vertex, projection));
                        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                        if (userProjection) {
                            const circleGeometry = geometry.clone().transform(userProjection, projection);
                            circleGeometry.setRadius(radius);
                            radius = circleGeometry.transform(projection, userProjection).getRadius();
                        }
                        geometry.setRadius(radius);
                        this.changingFeature_ = false;
                    }
                    break;
                default:
            }
            if (coordinates) this.setGeometryCoordinates_(geometry, coordinates);
        }
        this.createOrUpdateVertexFeature_(vertex, features, geometries);
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(evt) {
        if (!this.condition_(evt)) return false;
        const pixelCoordinate = evt.coordinate;
        this.handlePointerAtPixel_(evt.pixel, evt.map, pixelCoordinate);
        this.dragSegments_.length = 0;
        this.featuresBeingModified_ = null;
        const vertexFeature = this.vertexFeature_;
        if (vertexFeature) {
            const projection = evt.map.getView().getProjection();
            const insertVertices = [];
            const vertex = vertexFeature.getGeometry().getCoordinates();
            const vertexExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
                vertex
            ]);
            const segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
            const componentSegments = {};
            segmentDataMatches.sort($8c24f34a0807f744$var$compareIndexes);
            for(let i = 0, ii = segmentDataMatches.length; i < ii; ++i){
                const segmentDataMatch = segmentDataMatches[i];
                const segment = segmentDataMatch.segment;
                let uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(segmentDataMatch.geometry);
                const depth = segmentDataMatch.depth;
                if (depth) uid += "-" + depth.join("-"); // separate feature components
                if (!componentSegments[uid]) componentSegments[uid] = new Array(2);
                if (segmentDataMatch.geometry.getType() === "Circle" && segmentDataMatch.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                    const closestVertex = $8c24f34a0807f744$var$closestOnSegmentData(pixelCoordinate, segmentDataMatch, projection);
                    if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestVertex, vertex) && !componentSegments[uid][0]) {
                        this.dragSegments_.push([
                            segmentDataMatch,
                            0
                        ]);
                        componentSegments[uid][0] = segmentDataMatch;
                    }
                    continue;
                }
                if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[0], vertex) && !componentSegments[uid][0]) {
                    this.dragSegments_.push([
                        segmentDataMatch,
                        0
                    ]);
                    componentSegments[uid][0] = segmentDataMatch;
                    continue;
                }
                if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(segment[1], vertex) && !componentSegments[uid][1]) {
                    if (componentSegments[uid][0] && componentSegments[uid][0].index === 0) {
                        let coordinates = segmentDataMatch.geometry.getCoordinates();
                        switch(segmentDataMatch.geometry.getType()){
                            // prevent dragging closed linestrings by the connecting node
                            case "LineString":
                            case "MultiLineString":
                                continue;
                            // if dragging the first vertex of a polygon, ensure the other segment
                            // belongs to the closing vertex of the linear ring
                            case "MultiPolygon":
                                coordinates = coordinates[depth[1]];
                            /* falls through */ case "Polygon":
                                if (segmentDataMatch.index !== coordinates[depth[0]].length - 2) continue;
                                break;
                            default:
                        }
                    }
                    this.dragSegments_.push([
                        segmentDataMatch,
                        1
                    ]);
                    componentSegments[uid][1] = segmentDataMatch;
                    continue;
                }
                if ((0, $6c5e11070e371322$export$5e82334337e0f204)(segment) in this.vertexSegments_ && !componentSegments[uid][0] && !componentSegments[uid][1] && this.insertVertexCondition_(evt)) insertVertices.push(segmentDataMatch);
            }
            if (insertVertices.length) this.willModifyFeatures_(evt, [
                insertVertices
            ]);
            for(let j = insertVertices.length - 1; j >= 0; --j)this.insertVertex_(insertVertices[j], vertex);
        }
        return !!this.vertexFeature_;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(evt) {
        for(let i = this.dragSegments_.length - 1; i >= 0; --i){
            const segmentData = this.dragSegments_[i][0];
            const geometry = segmentData.geometry;
            if (geometry.getType() === "Circle") {
                // Update a circle object in the R* bush:
                const coordinates = geometry.getCenter();
                const centerSegmentData = segmentData.featureSegments[0];
                const circumferenceSegmentData = segmentData.featureSegments[1];
                centerSegmentData.segment[0] = coordinates;
                centerSegmentData.segment[1] = coordinates;
                circumferenceSegmentData.segment[0] = coordinates;
                circumferenceSegmentData.segment[1] = coordinates;
                this.rBush_.update((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(coordinates), centerSegmentData);
                let circleGeometry = geometry;
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                if (userProjection) {
                    const projection = evt.map.getView().getProjection();
                    circleGeometry = circleGeometry.clone().transform(userProjection, projection);
                    circleGeometry = (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(circleGeometry).transform(projection, userProjection);
                }
                this.rBush_.update(circleGeometry.getExtent(), circumferenceSegmentData);
            } else this.rBush_.update((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(segmentData.segment), segmentData);
        }
        if (this.featuresBeingModified_) {
            this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
        }
        return false;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @private
   */ handlePointerMove_(evt) {
        this.lastPixel_ = evt.pixel;
        this.handlePointerAtPixel_(evt.pixel, evt.map, evt.coordinate);
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel
   * @param {import("../Map.js").default} map Map.
   * @param {import("../coordinate.js").Coordinate} [coordinate] The pixel Coordinate.
   * @private
   */ handlePointerAtPixel_(pixel, map, coordinate) {
        const pixelCoordinate = coordinate || map.getCoordinateFromPixel(pixel);
        const projection = map.getView().getProjection();
        const sortByDistance = function(a, b) {
            return $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, a, projection) - $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pixelCoordinate, b, projection);
        };
        /** @type {Array<SegmentData>|undefined} */ let nodes;
        /** @type {Point|undefined} */ let hitPointGeometry;
        if (this.hitDetection_) {
            const layerFilter = typeof this.hitDetection_ === "object" ? (layer)=>layer === this.hitDetection_ : undefined;
            map.forEachFeatureAtPixel(pixel, (feature, layer, geometry)=>{
                if (geometry && geometry.getType() === "Point") geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)((0, $9c4744460e43e41b$export$698f563af1ba02a5)(geometry.getCoordinates(), projection));
                const geom = geometry || feature.getGeometry();
                if (feature instanceof (0, $9fd014ab6df63665$export$2e2bcd8739ae039) && this.features_.getArray().includes(feature)) {
                    hitPointGeometry = /** @type {Point} */ geom;
                    const coordinate = /** @type {Point} */ feature.getGeometry().getFlatCoordinates().slice(0, 2);
                    nodes = [
                        {
                            feature: feature,
                            geometry: hitPointGeometry,
                            segment: [
                                coordinate,
                                coordinate
                            ]
                        }
                    ];
                }
                return true;
            }, {
                layerFilter: layerFilter
            });
        }
        if (!nodes) {
            const viewExtent = (0, $9c4744460e43e41b$export$494be3a3a25689ca)((0, $6da4c8ed3074c92b$export$4838bf78d04a9440)(pixelCoordinate, $8c24f34a0807f744$var$tempExtent), projection);
            const buffer = map.getView().getResolution() * this.pixelTolerance_;
            const box = (0, $9c4744460e43e41b$export$96bfd09e2cffb006)((0, $6da4c8ed3074c92b$export$ab1029bcae9ddb4a)(viewExtent, buffer, $8c24f34a0807f744$var$tempExtent), projection);
            nodes = this.rBush_.getInExtent(box);
        }
        if (nodes && nodes.length > 0) {
            const node = nodes.sort(sortByDistance)[0];
            const closestSegment = node.segment;
            let vertex = $8c24f34a0807f744$var$closestOnSegmentData(pixelCoordinate, node, projection);
            const vertexPixel = map.getPixelFromCoordinate(vertex);
            let dist = (0, $1bd0a226f9a16141$export$9f17032d917177de)(pixel, vertexPixel);
            if (hitPointGeometry || dist <= this.pixelTolerance_) {
                /** @type {Object<string, boolean>} */ const vertexSegments = {};
                vertexSegments[(0, $6c5e11070e371322$export$5e82334337e0f204)(closestSegment)] = true;
                if (!this.snapToPointer_) {
                    this.delta_[0] = vertex[0] - pixelCoordinate[0];
                    this.delta_[1] = vertex[1] - pixelCoordinate[1];
                }
                if (node.geometry.getType() === "Circle" && node.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
                    this.snappedToVertex_ = true;
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ]);
                } else {
                    const pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
                    const pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
                    const squaredDist1 = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(vertexPixel, pixel1);
                    const squaredDist2 = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(vertexPixel, pixel2);
                    dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                    this.snappedToVertex_ = dist <= this.pixelTolerance_;
                    if (this.snappedToVertex_) vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
                    this.createOrUpdateVertexFeature_(vertex, [
                        node.feature
                    ], [
                        node.geometry
                    ]);
                    const geometries = {};
                    geometries[(0, $6c5e11070e371322$export$5e82334337e0f204)(node.geometry)] = true;
                    for(let i = 1, ii = nodes.length; i < ii; ++i){
                        const segment = nodes[i].segment;
                        if ((0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[0], segment[0]) && (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[1], segment[1]) || (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[0], segment[1]) && (0, $1bd0a226f9a16141$export$e9bab7fafb253603)(closestSegment[1], segment[0])) {
                            const geometryUid = (0, $6c5e11070e371322$export$5e82334337e0f204)(nodes[i].geometry);
                            if (!(geometryUid in geometries)) {
                                geometries[geometryUid] = true;
                                vertexSegments[(0, $6c5e11070e371322$export$5e82334337e0f204)(segment)] = true;
                            }
                        } else break;
                    }
                }
                this.vertexSegments_ = vertexSegments;
                return;
            }
        }
        if (this.vertexFeature_) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
    }
    /**
   * @param {SegmentData} segmentData Segment data.
   * @param {import("../coordinate.js").Coordinate} vertex Vertex.
   * @private
   */ insertVertex_(segmentData, vertex) {
        const segment = segmentData.segment;
        const feature = segmentData.feature;
        const geometry = segmentData.geometry;
        const depth = segmentData.depth;
        const index = segmentData.index;
        let coordinates;
        while(vertex.length < geometry.getStride())vertex.push(0);
        switch(geometry.getType()){
            case "MultiLineString":
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case "Polygon":
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case "MultiPolygon":
                coordinates = geometry.getCoordinates();
                coordinates[depth[1]][depth[0]].splice(index + 1, 0, vertex);
                break;
            case "LineString":
                coordinates = geometry.getCoordinates();
                coordinates.splice(index + 1, 0, vertex);
                break;
            default:
                return;
        }
        this.setGeometryCoordinates_(geometry, coordinates);
        const rTree = this.rBush_;
        rTree.remove(segmentData);
        this.updateSegmentIndices_(geometry, index, depth, 1);
        /** @type {SegmentData} */ const newSegmentData = {
            segment: [
                segment[0],
                vertex
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index
        };
        rTree.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
        this.dragSegments_.push([
            newSegmentData,
            1
        ]);
        /** @type {SegmentData} */ const newSegmentData2 = {
            segment: [
                vertex,
                segment[1]
            ],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index + 1
        };
        rTree.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData2.segment), newSegmentData2);
        this.dragSegments_.push([
            newSegmentData2,
            0
        ]);
        this.ignoreNextSingleClick_ = true;
    }
    /**
   * Removes the vertex currently being pointed.
   * @return {boolean} True when a vertex was removed.
   * @api
   */ removePoint() {
        if (this.lastPointerEvent_ && this.lastPointerEvent_.type != (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
            const evt = this.lastPointerEvent_;
            this.willModifyFeatures_(evt, this.dragSegments_);
            const removed = this.removeVertex_();
            if (this.featuresBeingModified_) this.dispatchEvent(new $8c24f34a0807f744$export$eb2af8bb6aa1fb54($8c24f34a0807f744$var$ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
            return removed;
        }
        return false;
    }
    /**
   * Removes a vertex from all matching features.
   * @return {boolean} True when a vertex was removed.
   * @private
   */ removeVertex_() {
        const dragSegments = this.dragSegments_;
        const segmentsByFeature = {};
        let deleted = false;
        let component, coordinates, dragSegment, geometry, i, index, left;
        let newIndex, right, segmentData, uid;
        for(i = dragSegments.length - 1; i >= 0; --i){
            dragSegment = dragSegments[i];
            segmentData = dragSegment[0];
            uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(segmentData.feature);
            if (segmentData.depth) // separate feature components
            uid += "-" + segmentData.depth.join("-");
            if (!(uid in segmentsByFeature)) segmentsByFeature[uid] = {};
            if (dragSegment[1] === 0) {
                segmentsByFeature[uid].right = segmentData;
                segmentsByFeature[uid].index = segmentData.index;
            } else if (dragSegment[1] == 1) {
                segmentsByFeature[uid].left = segmentData;
                segmentsByFeature[uid].index = segmentData.index + 1;
            }
        }
        for(uid in segmentsByFeature){
            right = segmentsByFeature[uid].right;
            left = segmentsByFeature[uid].left;
            index = segmentsByFeature[uid].index;
            newIndex = index - 1;
            if (left !== undefined) segmentData = left;
            else segmentData = right;
            if (newIndex < 0) newIndex = 0;
            geometry = segmentData.geometry;
            coordinates = geometry.getCoordinates();
            component = coordinates;
            deleted = false;
            switch(geometry.getType()){
                case "MultiLineString":
                    if (coordinates[segmentData.depth[0]].length > 2) {
                        coordinates[segmentData.depth[0]].splice(index, 1);
                        deleted = true;
                    }
                    break;
                case "LineString":
                    if (coordinates.length > 2) {
                        coordinates.splice(index, 1);
                        deleted = true;
                    }
                    break;
                case "MultiPolygon":
                    component = component[segmentData.depth[1]];
                /* falls through */ case "Polygon":
                    component = component[segmentData.depth[0]];
                    if (component.length > 4) {
                        if (index == component.length - 1) index = 0;
                        component.splice(index, 1);
                        deleted = true;
                        if (index === 0) {
                            // close the ring again
                            component.pop();
                            component.push(component[0]);
                            newIndex = component.length - 1;
                        }
                    }
                    break;
                default:
            }
            if (deleted) {
                this.setGeometryCoordinates_(geometry, coordinates);
                const segments = [];
                if (left !== undefined) {
                    this.rBush_.remove(left);
                    segments.push(left.segment[0]);
                }
                if (right !== undefined) {
                    this.rBush_.remove(right);
                    segments.push(right.segment[1]);
                }
                if (left !== undefined && right !== undefined) {
                    /** @type {SegmentData} */ const newSegmentData = {
                        depth: segmentData.depth,
                        feature: segmentData.feature,
                        geometry: segmentData.geometry,
                        index: newIndex,
                        segment: segments
                    };
                    this.rBush_.insert((0, $6da4c8ed3074c92b$export$8aceca7c77505534)(newSegmentData.segment), newSegmentData);
                }
                this.updateSegmentIndices_(geometry, index, segmentData.depth, -1);
                if (this.vertexFeature_) {
                    this.overlay_.getSource().removeFeature(this.vertexFeature_);
                    this.vertexFeature_ = null;
                }
                dragSegments.length = 0;
            }
        }
        return deleted;
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {Array} coordinates Coordinates.
   * @private
   */ setGeometryCoordinates_(geometry, coordinates) {
        this.changingFeature_ = true;
        geometry.setCoordinates(coordinates);
        this.changingFeature_ = false;
    }
    /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {number} index Index.
   * @param {Array<number>|undefined} depth Depth.
   * @param {number} delta Delta (1 or -1).
   * @private
   */ updateSegmentIndices_(geometry, index, depth, delta) {
        this.rBush_.forEachInExtent(geometry.getExtent(), function(segmentDataMatch) {
            if (segmentDataMatch.geometry === geometry && (depth === undefined || segmentDataMatch.depth === undefined || (0, $b998d41b678ed5d1$export$e9bab7fafb253603)(segmentDataMatch.depth, depth)) && segmentDataMatch.index > index) segmentDataMatch.index += delta;
        });
    }
}
/**
 * @param {SegmentData} a The first segment data.
 * @param {SegmentData} b The second segment data.
 * @return {number} The difference in indexes.
 */ function $8c24f34a0807f744$var$compareIndexes(a, b) {
    return a.index - b.index;
}
/**
 * Returns the distance from a point to a line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The coordinates of the point from
 *        which to calculate the distance.
 * @param {SegmentData} segmentData The object describing the line
 *        segment we are calculating the distance to.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {number} The square of the distance between a point and a line segment.
 */ function $8c24f34a0807f744$var$projectedDistanceToSegmentDataSquared(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === "Circle") {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        if (segmentData.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
            const distanceToCenterSquared = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(circleGeometry.getCenter(), (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection));
            const distanceToCircumference = Math.sqrt(distanceToCenterSquared) - circleGeometry.getRadius();
            return distanceToCircumference * distanceToCircumference;
        }
    }
    const coordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $8c24f34a0807f744$var$tempSegment[0] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $8c24f34a0807f744$var$tempSegment[1] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $1bd0a226f9a16141$export$6985570514055196)(coordinate, $8c24f34a0807f744$var$tempSegment);
}
/**
 * Returns the point closest to a given line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The point to which a closest point
 *        should be found.
 * @param {SegmentData} segmentData The object describing the line
 *        segment which should contain the closest point.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {import("../coordinate.js").Coordinate} The point closest to the specified line segment.
 */ function $8c24f34a0807f744$var$closestOnSegmentData(pointCoordinates, segmentData, projection) {
    const geometry = segmentData.geometry;
    if (geometry.getType() === "Circle" && segmentData.index === $8c24f34a0807f744$var$CIRCLE_CIRCUMFERENCE_INDEX) {
        let circleGeometry = /** @type {import("../geom/Circle.js").default} */ geometry;
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) circleGeometry = circleGeometry.clone().transform(userProjection, projection);
        return (0, $9c4744460e43e41b$export$698f563af1ba02a5)(circleGeometry.getClosestPoint((0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection)), projection);
    }
    const coordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(pointCoordinates, projection);
    $8c24f34a0807f744$var$tempSegment[0] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[0], projection);
    $8c24f34a0807f744$var$tempSegment[1] = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(segmentData.segment[1], projection);
    return (0, $9c4744460e43e41b$export$698f563af1ba02a5)((0, $1bd0a226f9a16141$export$18cdd31d17f97131)(coordinate, $8c24f34a0807f744$var$tempSegment), projection);
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $8c24f34a0807f744$var$getDefaultStyleFunction() {
    const style = (0, $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return style["Point"];
    };
}
var $8c24f34a0807f744$export$2e2bcd8739ae039 = $8c24f34a0807f744$var$Modify;

/**
 * @module ol/interaction/Translate
 */ 







/**
 * @enum {string}
 */ const $de2b65ee847802a8$var$TranslateEventType = {
    /**
   * Triggered upon feature translation start.
   * @event TranslateEvent#translatestart
   * @api
   */ TRANSLATESTART: "translatestart",
    /**
   * Triggered upon feature translation.
   * @event TranslateEvent#translating
   * @api
   */ TRANSLATING: "translating",
    /**
   * Triggered upon feature translation end.
   * @event TranslateEvent#translateend
   * @api
   */ TRANSLATEEND: "translateend"
};
class $de2b65ee847802a8$export$1766f140d6979b9 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {TranslateEventType} type Type.
   * @param {Collection<Feature>} features The features translated.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../coordinate.js").Coordinate} startCoordinate The original coordinates before.translation started
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   */ constructor(type, features, coordinate, startCoordinate, mapBrowserEvent){
        super(type);
        /**
     * The features being translated.
     * @type {Collection<Feature>}
     * @api
     */ this.features = features;
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * The coordinate of the start position before translation started.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.startCoordinate = startCoordinate;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'translateend'|'translatestart'|'translating', TranslateEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'translateend'|'translatestart'|'translating', Return>} TranslateOnSignature
 */ /**
 * @classdesc
 * Interaction for translating (moving) features.
 * If you want to translate multiple features in a single action (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.
 *
 * @fires TranslateEvent
 * @api
 */ class $de2b65ee847802a8$var$Translate extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Pointer.js").Options} */ options);
        /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TranslateOnSignature<void>}
     */ this.un;
        /**
     * The last position we translated to.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.lastCoordinate_ = null;
        /**
     * The start position before translation started.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.startCoordinate_ = null;
        /**
     * @type {Collection<Feature>|null}
     * @private
     */ this.features_ = options.features !== undefined ? options.features : null;
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */ let layerFilter;
        if (options.layers && !this.features_) {
            if (typeof options.layers === "function") layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter && !this.features_ ? options.filter : (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        /**
     * @type {Feature}
     * @private
     */ this.lastFeature_ = null;
        this.addChangeListener((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, this.handleActiveChanged_);
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        if (!event.originalEvent || !this.condition_(event)) return false;
        this.lastFeature_ = this.featuresAtPixel_(event.pixel, event.map);
        if (!this.lastCoordinate_ && this.lastFeature_) {
            this.startCoordinate_ = event.coordinate;
            this.lastCoordinate_ = event.coordinate;
            this.handleMoveEvent(event);
            const features = this.features_ || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            this.dispatchEvent(new $de2b65ee847802a8$export$1766f140d6979b9($de2b65ee847802a8$var$TranslateEventType.TRANSLATESTART, features, event.coordinate, this.startCoordinate_, event));
            return true;
        }
        return false;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        if (this.lastCoordinate_) {
            this.lastCoordinate_ = null;
            this.handleMoveEvent(event);
            const features = this.features_ || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            this.dispatchEvent(new $de2b65ee847802a8$export$1766f140d6979b9($de2b65ee847802a8$var$TranslateEventType.TRANSLATEEND, features, event.coordinate, this.startCoordinate_, event));
            // cleanup
            this.startCoordinate_ = null;
            return true;
        }
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ handleDragEvent(event) {
        if (this.lastCoordinate_) {
            const newCoordinate = event.coordinate;
            const projection = event.map.getView().getProjection();
            const newViewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(newCoordinate, projection);
            const lastViewCoordinate = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(this.lastCoordinate_, projection);
            const deltaX = newViewCoordinate[0] - lastViewCoordinate[0];
            const deltaY = newViewCoordinate[1] - lastViewCoordinate[1];
            const features = this.features_ || new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                this.lastFeature_
            ]);
            const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
            features.forEach(function(feature) {
                const geom = feature.getGeometry();
                if (userProjection) {
                    geom.transform(userProjection, projection);
                    geom.translate(deltaX, deltaY);
                    geom.transform(projection, userProjection);
                } else geom.translate(deltaX, deltaY);
                feature.setGeometry(geom);
            });
            this.lastCoordinate_ = newCoordinate;
            this.dispatchEvent(new $de2b65ee847802a8$export$1766f140d6979b9($de2b65ee847802a8$var$TranslateEventType.TRANSLATING, features, newCoordinate, this.startCoordinate_, event));
        }
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ handleMoveEvent(event) {
        const elem = event.map.getViewport();
        // Change the cursor to grab/grabbing if hovering any of the features managed
        // by the interaction
        if (this.featuresAtPixel_(event.pixel, event.map)) {
            elem.classList.remove(this.lastCoordinate_ ? "ol-grab" : "ol-grabbing");
            elem.classList.add(this.lastCoordinate_ ? "ol-grabbing" : "ol-grab");
        } else elem.classList.remove("ol-grab", "ol-grabbing");
    }
    /**
   * Tests to see if the given coordinates intersects any of our selected
   * features.
   * @param {import("../pixel.js").Pixel} pixel Pixel coordinate to test for intersection.
   * @param {import("../Map.js").default} map Map to test the intersection on.
   * @return {Feature} Returns the feature found at the specified pixel
   * coordinates.
   * @private
   */ featuresAtPixel_(pixel, map) {
        return map.forEachFeatureAtPixel(pixel, (feature, layer)=>{
            if (!(feature instanceof (0, $9fd014ab6df63665$export$2e2bcd8739ae039)) || !this.filter_(feature, layer)) return undefined;
            if (this.features_ && !this.features_.getArray().includes(feature)) return undefined;
            return feature;
        }, {
            layerFilter: this.layerFilter_,
            hitTolerance: this.hitTolerance_
        });
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        super.setMap(map);
        this.updateState_(oldMap);
    }
    /**
   * @private
   */ handleActiveChanged_() {
        this.updateState_(null);
    }
    /**
   * @param {import("../Map.js").default} oldMap Old map.
   * @private
   */ updateState_(oldMap) {
        let map = this.getMap();
        const active = this.getActive();
        if (!map || !active) {
            map = map || oldMap;
            if (map) {
                const elem = map.getViewport();
                elem.classList.remove("ol-grab", "ol-grabbing");
            }
        }
    }
}
var $de2b65ee847802a8$export$2e2bcd8739ae039 = $de2b65ee847802a8$var$Translate;




var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $9e79ec4b86b0bc11$export$e84d5527aab02376 = /*#__PURE__*/ $acw62.createContext(null);
function $9e79ec4b86b0bc11$export$c82639dc638c4e5({ manager: manager, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e79ec4b86b0bc11$export$e84d5527aab02376.Provider, {
        value: manager,
        children: children
    });
}






function $302106ffa43351a6$var$useControlMeasureReader() {
    return (0, $acw62.useContext)((0, $9e79ec4b86b0bc11$export$e84d5527aab02376));
}
function $302106ffa43351a6$var$useControlMeasureWriter() {
    return (0, $acw62.useContext)((0, $9e79ec4b86b0bc11$export$e84d5527aab02376));
}
const $302106ffa43351a6$var$queryKey = "control-measures";
function $302106ffa43351a6$export$5dad9a454d8c40c0(manifestID) {
    const reader = $302106ffa43351a6$var$useControlMeasureReader();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $302106ffa43351a6$var$queryKey
    ], ()=>reader.list(manifestID));
}
function $302106ffa43351a6$export$71ef0e0adb83665(manifests) {
    const reader = $302106ffa43351a6$var$useControlMeasureReader();
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, "id");
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "submitted-control-measures",
        ...ids
    ], ()=>{
        if (!manifests) return Promise.resolve([]);
        const work = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, (m)=>reader.list(m.id));
        return Promise.all(work).then((results)=>{
            const list = [];
            for(let i = 0; i < results.length; i++){
                const coalition = manifests[i].coalition;
                const items = results[i];
                for(let j = 0; j < items.length; j++){
                    const item = items[j];
                    list.push({
                        ...item,
                        coalition: coalition
                    });
                }
            }
            return list;
        });
    });
}
function $302106ffa43351a6$export$598f3fe495c47e() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const writer = $302106ffa43351a6$var$useControlMeasureWriter();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    // Going for optimistic updates here so that the layer updates immediately.
    // https://tanstack.com/query/v4/docs/react/guides/optimistic-updates
    const mu = (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (cm)=>{
            return writer.save(currentUser.id, cm);
        },
        onMutate: async (cm)=>{
            await qc.cancelQueries({
                queryKey: [
                    $302106ffa43351a6$var$queryKey
                ]
            });
            // Snapshot the previous value
            const previousCMs = qc.getQueryData([
                $302106ffa43351a6$var$queryKey
            ]);
            // Optimistically update to the new value
            qc.setQueryData([
                $302106ffa43351a6$var$queryKey
            ], (old)=>[
                    ...old,
                    cm
                ]);
            // Return a context object with the snapshotted value
            return {
                previousCMs: previousCMs
            };
        },
        onSettled: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    $302106ffa43351a6$var$queryKey
                ]
            });
        }
    });
    return mu;
}
function $302106ffa43351a6$export$b02902a51cce2283() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const writer = $302106ffa43351a6$var$useControlMeasureWriter();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const manifestID = (0, $0a53c1f23450367c$export$690fab4e9789b198)();
    const { data: controlMeasures } = $302106ffa43351a6$export$5dad9a454d8c40c0(manifestID);
    return (cm)=>{
        const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(controlMeasures, {
            name: cm.name
        });
        if (!currentUser) return Promise.reject(new Error("Not logged in"));
        if (!existing) return Promise.resolve();
        return writer.delete(currentUser.id, existing).then(()=>{
            qc.invalidateQueries([
                $302106ffa43351a6$var$queryKey
            ]);
        });
    };
}
function $302106ffa43351a6$export$34799c4c5cc899c6() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const writer = $302106ffa43351a6$var$useControlMeasureWriter();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (cm)=>{
        return writer.update(currentUser.id, cm).then(()=>{
            qc.invalidateQueries([
                $302106ffa43351a6$var$queryKey
            ]);
        });
    };
}
const $302106ffa43351a6$var$modifyTipStyle = (text = "Drag to Modify")=>new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
            radius: 5,
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.7)"
            }),
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.4)"
            })
        }),
        text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
            text: text,
            font: "12px Roboto,sans-serif",
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "rgba(255, 255, 255, 1)"
            }),
            backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.7)"
            }),
            padding: [
                2,
                2,
                2,
                2
            ],
            textAlign: "left",
            offsetX: 15
        })
    });
function $302106ffa43351a6$export$755755835fad5070(onChange) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const modifyRef = (0, $acw62.useRef)();
    const translateRef = (0, $acw62.useRef)();
    const { state: { editingControlMeasure: editingControlMeasure } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const toggle = (0, $99f46708ff5ed621$export$9059596f8e425fd6)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        if (!editingControlMeasure) {
            if (modifyRef.current) map.removeInteraction(modifyRef.current);
            if (translateRef.current) map.removeInteraction(translateRef.current);
            return;
        }
        const layer = $302106ffa43351a6$var$findLayer(map);
        if (!layer) return;
        const feature = $302106ffa43351a6$var$findFeature(layer, editingControlMeasure);
        const modify = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
            features: new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                feature
            ]),
            style: $302106ffa43351a6$var$modifyTipStyle()
        });
        // We can move shapes, but not lines.
        // The  translate interaction doesn't work on thin lines (can't grab it).
        if (feature.getGeometry().getType() !== "LineString") {
            const translate = new (0, $de2b65ee847802a8$export$2e2bcd8739ae039)({
                features: new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)([
                    feature
                ])
            });
            translate.on("translateend", (e)=>{
                const feature = e.features.getArray()[0];
                const geom = feature.getGeometry();
                onChange(geom);
            });
            translateRef.current = translate;
            map.addInteraction(translate);
        }
        modify.on("modifyend", (e)=>{
            const feature = e.features.getArray()[0];
            const geom = feature.getGeometry();
            onChange(geom);
        });
        modifyRef.current = modify;
        map.addInteraction(modify);
        return ()=>{
            map.removeInteraction(modifyRef.current);
            map.removeInteraction(translateRef.current);
        };
    }, [
        map,
        editingControlMeasure
    ]);
    // Reset function
    return ()=>{
        toggle(null);
        if (translateRef.current) map.removeInteraction(translateRef.current);
        if (modifyRef.current) map.removeInteraction(modifyRef.current);
        const layer = $302106ffa43351a6$var$findLayer(map);
        const prev = $302106ffa43351a6$var$findFeature(layer, editingControlMeasure);
        prev?.setGeometry(prev.get("originalGeometry").clone());
    };
}
function $302106ffa43351a6$var$findLayer(map) {
    return map.getLayers().getArray().find((l)=>l.get("name") === (0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlMeasures);
}
function $302106ffa43351a6$var$findFeature(layer, cm) {
    const source = layer.getSource();
    const features = source.getFeatures();
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(features, (f)=>f.get("id") === cm?.id);
}
function $302106ffa43351a6$export$be66956e5fa7746a() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    return (0, $acw62.useCallback)((cm)=>{
        if (!currentUser) return false;
        return cm.created_by_uid === currentUser.id;
    }, [
        currentUser
    ]);
}



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");

const $a0e83392a1945b28$var$Key = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  font-weight: bold;
`;
const $a0e83392a1945b28$var$Value = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  text-overflow: ellipsis;
  overflow: hidden !important;
`;
const $a0e83392a1945b28$var$Item = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $00a20d475386f68c$export$2e2bcd8739ae039))``;
function $a0e83392a1945b28$var$KeyValueTable({ className: className, pairs: pairs, columns: columns }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "list",
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            columns: columns,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(pairs, (a, i)=>{
                const { key: key, value: value } = a;
                const label = key;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($a0e83392a1945b28$var$Item, {
                        p: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a0e83392a1945b28$var$Key, {
                                "aria-label": label,
                                children: label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a0e83392a1945b28$var$Value, {
                                children: value || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        marginLeft: 2
                                    },
                                    children: "-"
                                })
                            })
                        ]
                    })
                }, i);
            })
        })
    });
}
var $a0e83392a1945b28$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a0e83392a1945b28$var$KeyValueTable).attrs({
    className: "KeyValueTable"
})`
  width: 100%;

  tr {
    height: 72px;
    border-bottom: none;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");
var $19fb6d413538179b$exports = {};
"use strict";

Object.defineProperty($19fb6d413538179b$exports, "__esModule", {
    value: true
});
$19fb6d413538179b$exports.default = void 0;

var $19fb6d413538179b$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $19fb6d413538179b$var$_default = (0, $19fb6d413538179b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
}), "ColorLens");
$19fb6d413538179b$exports.default = $19fb6d413538179b$var$_default;


var $8c6ad197f63b3f3e$exports = {};
"use strict";

Object.defineProperty($8c6ad197f63b3f3e$exports, "__esModule", {
    value: true
});
$8c6ad197f63b3f3e$exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Edit");
$8c6ad197f63b3f3e$exports.default = $8c6ad197f63b3f3e$var$_default;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $8nd05 = parcelRequire("8nd05");

function $bca986a09b53b6aa$export$2e2bcd8739ae039(elementType, existingProps = {}, ownerState) {
    if ((0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(elementType)) return existingProps;
    return (0, $8nd05.default)({}, existingProps, {
        ownerState: (0, $8nd05.default)({}, existingProps.ownerState, ownerState)
    });
}


var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");


var $6g9fa = parcelRequire("6g9fa");

var $jTnBY = parcelRequire("jTnBY");


var $8nd05 = parcelRequire("8nd05");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale) {
    if (includeScale === void 0) includeScale = false;
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) && includeScale) {
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        // Fallback to 1 in case both values are `0`
        if (offsetWidth > 0) scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / offsetWidth || 1;
        if (offsetHeight > 0) scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / offsetHeight || 1;
    }
    return {
        width: rect.width / scaleX,
        height: rect.height / scaleY,
        top: rect.top / scaleY,
        right: rect.right / scaleX,
        bottom: rect.bottom / scaleY,
        left: rect.left / scaleX,
        x: rect.left / scaleX,
        y: rect.top / scaleY
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
    var isIE = navigator.userAgent.indexOf("Trident") !== -1;
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}



var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $60bdf67e43f5dfcb$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $60bdf67e43f5dfcb$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}






function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};












var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $d9a06bdf697677bb$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "ownerState",
    "placement",
    "popperOptions",
    "popperRef",
    "TransitionProps"
], $d9a06bdf697677bb$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition"
];
function $d9a06bdf697677bb$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $d9a06bdf697677bb$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $d9a06bdf697677bb$var$defaultPopperOptions = {};
/* eslint-disable react/prop-types */ const $d9a06bdf697677bb$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, ref) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $d9a06bdf697677bb$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(tooltipRef, ref);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $d9a06bdf697677bb$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (!anchorEl || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        const resolvedAnchorEl = $d9a06bdf697677bb$var$resolveAnchorEl(anchorEl);
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)($d9a06bdf697677bb$var$resolveAnchorEl(anchorEl), tooltipRef.current, (0, $8nd05.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        ref: ownRef,
        role: "tooltip"
    }, other, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/* eslint-enable react/prop-types */ /**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 */ const $d9a06bdf697677bb$var$PopperUnstyled = /*#__PURE__*/ $acw62.forwardRef(function PopperUnstyled(props, ref) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $d9a06bdf697677bb$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false } = props, other = (0, $1En50.default)(props, $d9a06bdf697677bb$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $4cf4482b502c4310$export$2e2bcd8739ae039)($d9a06bdf697677bb$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2ad7edda02764f6$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d9a06bdf697677bb$var$PopperTooltip, (0, $8nd05.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: ref,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef
        }, other, {
            style: (0, $8nd05.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: !open && keepMounted && (!transition || exited) ? "none" : null
            }, style),
            TransitionProps: transition ? {
                in: open,
                onEnter: handleEnter,
                onExited: handleExited
            } : null,
            children: children
        }))
    });
});
var $d9a06bdf697677bb$export$2e2bcd8739ae039 = $d9a06bdf697677bb$var$PopperUnstyled;



var $5aZTU = parcelRequire("5aZTU");

parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
var $6g9fa = parcelRequire("6g9fa");

var $ayMG0 = parcelRequire("ayMG0");
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $d9a06bdf697677bb$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menus](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    const theme = (0, $5aZTU.default)();
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiPopper"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, (0, $8nd05.default)({
        direction: theme == null ? void 0 : theme.direction
    }, props, {
        ref: ref
    }));
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;








var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $9XEW1.default)("MuiTooltip", slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $7u6PA.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $96a8b4f445fd9172$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $jTnBY.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $9971e.default)(slots, (0, $add5737403c6a16a$export$837848f5f6cee923), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $8nd05.default)({
        zIndex: theme.zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: (0, $kyRHb.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $8nd05.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $8nd05.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $8nd05.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $8nd05.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $8nd05.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $8nd05.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em",
        boxSizing: "border-box",
        color: (0, $kyRHb.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $96a8b4f445fd9172$var$hystersisOpen = false;
let $96a8b4f445fd9172$var$hystersisTimer = null;
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    clearTimeout($96a8b4f445fd9172$var$hystersisTimer);
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
} // TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _components$Popper, _ref, _components$Transitio, _components$Tooltip, _components$Arrow, _componentsProps$popp;
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: children, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $96a8b4f445fd9172$var$_excluded);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $acw62.useRef();
    const enterTimer = $acw62.useRef();
    const leaveTimer = $acw62.useRef();
    const touchTimer = $acw62.useRef();
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = $acw62.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($96a8b4f445fd9172$var$hystersisTimer);
        $96a8b4f445fd9172$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $331f3746e6346411$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($96a8b4f445fd9172$var$hystersisTimer);
        $96a8b4f445fd9172$var$hystersisTimer = setTimeout(()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
         // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)(); // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect; // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleUseRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(setChildNode, ref);
    const handleFocusRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(focusVisibleRef, handleUseRef);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(children.ref, handleFocusRef); // There is no point in displaying an empty tooltip.
    if (title === "") open = false;
    const positionRef = $acw62.useRef({
        x: 0,
        y: 0
    });
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        positionRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $8nd05.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $1SA7b.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $8nd05.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const PopperComponent = (_components$Popper = components.Popper) != null ? _components$Popper : $96a8b4f445fd9172$var$TooltipPopper;
    const TransitionComponent = (_ref = (_components$Transitio = components.Transition) != null ? _components$Transitio : TransitionComponentProp) != null ? _ref : (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039);
    const TooltipComponent = (_components$Tooltip = components.Tooltip) != null ? _components$Tooltip : $96a8b4f445fd9172$var$TooltipTooltip;
    const ArrowComponent = (_components$Arrow = components.Arrow) != null ? _components$Arrow : $96a8b4f445fd9172$var$TooltipArrow;
    const popperProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(PopperComponent, (0, $8nd05.default)({}, PopperProps, componentsProps.popper), ownerState);
    const transitionProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(TransitionComponent, (0, $8nd05.default)({}, TransitionProps, componentsProps.transition), ownerState);
    const tooltipProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(TooltipComponent, (0, $8nd05.default)({}, componentsProps.tooltip), ownerState);
    const tooltipArrowProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(ArrowComponent, (0, $8nd05.default)({}, componentsProps.arrow), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $8nd05.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $a4669aa090d445bd$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: positionRef.current.y,
                            left: positionRef.current.x,
                            right: positionRef.current.x,
                            bottom: positionRef.current.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                className: (0, $1SA7b.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_componentsProps$popp = componentsProps.popper) == null ? void 0 : _componentsProps$popp.className),
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>{
                    var _componentsProps$tool, _componentsProps$arro;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $8nd05.default)({}, tooltipProps, {
                            className: (0, $1SA7b.default)(classes.tooltip, (_componentsProps$tool = componentsProps.tooltip) == null ? void 0 : _componentsProps$tool.className),
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $8nd05.default)({}, tooltipArrowProps, {
                                    className: (0, $1SA7b.default)(classes.arrow, (_componentsProps$arro = componentsProps.arrow) == null ? void 0 : _componentsProps$arro.className),
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }));
                }
            }))
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $498ba2dab0ae91e7$var$u() {
    return ($498ba2dab0ae91e7$var$u = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $498ba2dab0ae91e7$var$c(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)r.indexOf(t = a[n]) >= 0 || (o[t] = e[t]);
    return o;
}
function $498ba2dab0ae91e7$var$i(e) {
    var t = (0, $acw62.useRef)(e), n = (0, $acw62.useRef)(function(e) {
        t.current && t.current(e);
    });
    return t.current = e, n.current;
}
var $498ba2dab0ae91e7$var$s = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = 1), e > t ? t : e < r ? r : e;
}, $498ba2dab0ae91e7$var$f = function(e) {
    return "touches" in e;
}, $498ba2dab0ae91e7$var$v = function(e) {
    return e && e.ownerDocument.defaultView || self;
}, $498ba2dab0ae91e7$var$d = function(e, r, t) {
    var n = e.getBoundingClientRect(), o = $498ba2dab0ae91e7$var$f(r) ? function(e, r) {
        for(var t = 0; t < e.length; t++)if (e[t].identifier === r) return e[t];
        return e[0];
    }(r.touches, t) : r;
    return {
        left: $498ba2dab0ae91e7$var$s((o.pageX - (n.left + $498ba2dab0ae91e7$var$v(e).pageXOffset)) / n.width),
        top: $498ba2dab0ae91e7$var$s((o.pageY - (n.top + $498ba2dab0ae91e7$var$v(e).pageYOffset)) / n.height)
    };
}, $498ba2dab0ae91e7$var$h = function(e) {
    !$498ba2dab0ae91e7$var$f(e) && e.preventDefault();
}, $498ba2dab0ae91e7$var$m = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(o) {
    var a = o.onMove, l = o.onKey, s = $498ba2dab0ae91e7$var$c(o, [
        "onMove",
        "onKey"
    ]), m = (0, $acw62.useRef)(null), g = $498ba2dab0ae91e7$var$i(a), p = $498ba2dab0ae91e7$var$i(l), b = (0, $acw62.useRef)(null), _ = (0, $acw62.useRef)(!1), x = (0, $acw62.useMemo)(function() {
        var e = function(e) {
            $498ba2dab0ae91e7$var$h(e), ($498ba2dab0ae91e7$var$f(e) ? e.touches.length > 0 : e.buttons > 0) && m.current ? g($498ba2dab0ae91e7$var$d(m.current, e, b.current)) : t(!1);
        }, r = function() {
            return t(!1);
        };
        function t(t) {
            var n = _.current, o = $498ba2dab0ae91e7$var$v(m.current), a = t ? o.addEventListener : o.removeEventListener;
            a(n ? "touchmove" : "mousemove", e), a(n ? "touchend" : "mouseup", r);
        }
        return [
            function(e) {
                var r = e.nativeEvent, n = m.current;
                if (n && ($498ba2dab0ae91e7$var$h(r), !function(e, r) {
                    return r && !$498ba2dab0ae91e7$var$f(e);
                }(r, _.current) && n)) {
                    if ($498ba2dab0ae91e7$var$f(r)) {
                        _.current = !0;
                        var o = r.changedTouches || [];
                        o.length && (b.current = o[0].identifier);
                    }
                    n.focus(), g($498ba2dab0ae91e7$var$d(n, r, b.current)), t(!0);
                }
            },
            function(e) {
                var r = e.which || e.keyCode;
                r < 37 || r > 40 || (e.preventDefault(), p({
                    left: 39 === r ? .05 : 37 === r ? -0.05 : 0,
                    top: 40 === r ? .05 : 38 === r ? -0.05 : 0
                }));
            },
            t
        ];
    }, [
        p,
        g
    ]), C = x[0], E = x[1], H = x[2];
    return (0, $acw62.useEffect)(function() {
        return H;
    }, [
        H
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        onTouchStart: C,
        onMouseDown: C,
        className: "react-colorful__interactive",
        ref: m,
        onKeyDown: E,
        tabIndex: 0,
        role: "slider"
    }));
}), $498ba2dab0ae91e7$var$g = function(e) {
    return e.filter(Boolean).join(" ");
}, $498ba2dab0ae91e7$var$p = function(r) {
    var t = r.color, n = r.left, o = r.top, a = void 0 === o ? .5 : o, l = $498ba2dab0ae91e7$var$g([
        "react-colorful__pointer",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l,
        style: {
            top: 100 * a + "%",
            left: 100 * n + "%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__pointer-fill",
        style: {
            backgroundColor: t
        }
    }));
}, $498ba2dab0ae91e7$var$b = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = Math.pow(10, r)), Math.round(t * e) / t;
}, $498ba2dab0ae91e7$var$_ = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $498ba2dab0ae91e7$var$x = function(e) {
    return "#" === e[0] && (e = e.substr(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 1
    } : {
        r: parseInt(e.substr(0, 2), 16),
        g: parseInt(e.substr(2, 2), 16),
        b: parseInt(e.substr(4, 2), 16),
        a: 1
    };
}, $498ba2dab0ae91e7$var$C = function(e, r) {
    return void 0 === r && (r = "deg"), Number(e) * ($498ba2dab0ae91e7$var$_[r] || 1);
}, $498ba2dab0ae91e7$var$E = function(e) {
    var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$M({
        h: $498ba2dab0ae91e7$var$C(r[1], r[2]),
        s: Number(r[3]),
        l: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$H = $498ba2dab0ae91e7$var$E, $498ba2dab0ae91e7$var$M = function(e) {
    var r = e.s, t = e.l;
    return {
        h: e.h,
        s: (r *= (t < 50 ? t : 100 - t) / 100) > 0 ? 2 * r / (t + r) * 100 : 0,
        v: t + r,
        a: e.a
    };
}, $498ba2dab0ae91e7$var$N = function(e) {
    var r = e.s, t = e.v, n = e.a, o = (200 - r) * t / 100;
    return {
        h: $498ba2dab0ae91e7$var$b(e.h),
        s: $498ba2dab0ae91e7$var$b(o > 0 && o < 200 ? r * t / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
        l: $498ba2dab0ae91e7$var$b(o / 2),
        a: $498ba2dab0ae91e7$var$b(n, 2)
    };
}, $498ba2dab0ae91e7$var$w = function(e) {
    var r = $498ba2dab0ae91e7$var$N(e);
    return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
}, $498ba2dab0ae91e7$var$y = function(e) {
    var r = $498ba2dab0ae91e7$var$N(e);
    return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
}, $498ba2dab0ae91e7$var$q = function(e) {
    var r = e.h, t = e.s, n = e.v, o = e.a;
    r = r / 360 * 6, t /= 100, n /= 100;
    var a = Math.floor(r), l = n * (1 - t), u = n * (1 - (r - a) * t), c = n * (1 - (1 - r + a) * t), i = a % 6;
    return {
        r: $498ba2dab0ae91e7$var$b(255 * [
            n,
            u,
            l,
            l,
            c,
            n
        ][i]),
        g: $498ba2dab0ae91e7$var$b(255 * [
            c,
            n,
            n,
            u,
            l,
            l
        ][i]),
        b: $498ba2dab0ae91e7$var$b(255 * [
            l,
            l,
            c,
            n,
            n,
            u
        ][i]),
        a: $498ba2dab0ae91e7$var$b(o, 2)
    };
}, $498ba2dab0ae91e7$var$k = function(e) {
    var r = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$D({
        h: $498ba2dab0ae91e7$var$C(r[1], r[2]),
        s: Number(r[3]),
        v: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$O = $498ba2dab0ae91e7$var$k, $498ba2dab0ae91e7$var$I = function(e) {
    var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$B({
        r: Number(r[1]) / (r[2] ? 100 / 255 : 1),
        g: Number(r[3]) / (r[4] ? 100 / 255 : 1),
        b: Number(r[5]) / (r[6] ? 100 / 255 : 1),
        a: void 0 === r[7] ? 1 : Number(r[7]) / (r[8] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$j = $498ba2dab0ae91e7$var$I, $498ba2dab0ae91e7$var$z = function(e) {
    var r = e.toString(16);
    return r.length < 2 ? "0" + r : r;
}, $498ba2dab0ae91e7$var$B = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = Math.max(r, t, n), l = a - Math.min(r, t, n), u = l ? a === r ? (t - n) / l : a === t ? 2 + (n - r) / l : 4 + (r - t) / l : 0;
    return {
        h: $498ba2dab0ae91e7$var$b(60 * (u < 0 ? u + 6 : u)),
        s: $498ba2dab0ae91e7$var$b(a ? l / a * 100 : 0),
        v: $498ba2dab0ae91e7$var$b(a / 255 * 100),
        a: o
    };
}, $498ba2dab0ae91e7$var$D = function(e) {
    return {
        h: $498ba2dab0ae91e7$var$b(e.h),
        s: $498ba2dab0ae91e7$var$b(e.s),
        v: $498ba2dab0ae91e7$var$b(e.v),
        a: $498ba2dab0ae91e7$var$b(e.a, 2)
    };
}, $498ba2dab0ae91e7$var$K = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hue, n = r.onChange, o = $498ba2dab0ae91e7$var$g([
        "react-colorful__hue",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            n({
                h: 360 * e.left
            });
        },
        onKey: function(e) {
            n({
                h: $498ba2dab0ae91e7$var$s(t + 360 * e.left, 0, 360)
            });
        },
        "aria-label": "Hue",
        "aria-valuetext": $498ba2dab0ae91e7$var$b(t)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__hue-pointer",
        left: t / 360,
        color: $498ba2dab0ae91e7$var$w({
            h: t,
            s: 100,
            v: 100,
            a: 1
        })
    })));
}), $498ba2dab0ae91e7$var$L = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hsva, n = r.onChange, o = {
        backgroundColor: $498ba2dab0ae91e7$var$w({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
        })
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__saturation",
        style: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            n({
                s: 100 * e.left,
                v: 100 - 100 * e.top
            });
        },
        onKey: function(e) {
            n({
                s: $498ba2dab0ae91e7$var$s(t.s + 100 * e.left, 0, 100),
                v: $498ba2dab0ae91e7$var$s(t.v - 100 * e.top, 0, 100)
            });
        },
        "aria-label": "Color",
        "aria-valuetext": "Saturation " + $498ba2dab0ae91e7$var$b(t.s) + "%, Brightness " + $498ba2dab0ae91e7$var$b(t.v) + "%"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__saturation-pointer",
        top: 1 - t.v / 100,
        left: t.s / 100,
        color: $498ba2dab0ae91e7$var$w(t)
    })));
}), $498ba2dab0ae91e7$var$A = function(e, r) {
    if (e === r) return !0;
    for(var t in e)if (e[t] !== r[t]) return !1;
    return !0;
}, $498ba2dab0ae91e7$var$S = function(e, r) {
    return e.replace(/\s/g, "") === r.replace(/\s/g, "");
};
function $498ba2dab0ae91e7$var$T(e, t, l) {
    var u = $498ba2dab0ae91e7$var$i(l), c = (0, $acw62.useState)(function() {
        return e.toHsva(t);
    }), s = c[0], f = c[1], v = (0, $acw62.useRef)({
        color: t,
        hsva: s
    });
    (0, $acw62.useEffect)(function() {
        if (!e.equal(t, v.current.color)) {
            var r = e.toHsva(t);
            v.current = {
                hsva: r,
                color: t
            }, f(r);
        }
    }, [
        t,
        e
    ]), (0, $acw62.useEffect)(function() {
        var r;
        $498ba2dab0ae91e7$var$A(s, v.current.hsva) || e.equal(r = e.fromHsva(s), v.current.color) || (v.current = {
            hsva: s,
            color: r
        }, u(r));
    }, [
        s,
        e,
        u
    ]);
    var d = (0, $acw62.useCallback)(function(e) {
        f(function(r) {
            return Object.assign({}, r, e);
        });
    }, []);
    return [
        s,
        d
    ];
}
var $498ba2dab0ae91e7$var$F, $498ba2dab0ae91e7$var$P = "undefined" != typeof window ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $498ba2dab0ae91e7$var$X = function() {
    return $498ba2dab0ae91e7$var$F || ("undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0);
}, $498ba2dab0ae91e7$export$c5f670b24c0ae95a = function(e) {
    $498ba2dab0ae91e7$var$F = e;
}, $498ba2dab0ae91e7$var$R = new Map, $498ba2dab0ae91e7$var$V = function(e) {
    $498ba2dab0ae91e7$var$P(function() {
        var r = e.current ? e.current.ownerDocument : document;
        if (void 0 !== r && !$498ba2dab0ae91e7$var$R.has(r)) {
            var t = r.createElement("style");
            t.innerHTML = '.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}', $498ba2dab0ae91e7$var$R.set(r, t);
            var n = $498ba2dab0ae91e7$var$X();
            n && t.setAttribute("nonce", n), r.head.appendChild(t);
        }
    }, []);
}, $498ba2dab0ae91e7$var$$ = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $498ba2dab0ae91e7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $498ba2dab0ae91e7$var$V(f);
    var v = $498ba2dab0ae91e7$var$T(o, l, i), d = v[0], h = v[1], m = $498ba2dab0ae91e7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$L, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$K, {
        hue: d.h,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $498ba2dab0ae91e7$var$G = {
    defaultColor: "000",
    toHsva: function(e) {
        return $498ba2dab0ae91e7$var$B($498ba2dab0ae91e7$var$x(e));
    },
    fromHsva: function(e) {
        var r, t, n;
        return t = (r = $498ba2dab0ae91e7$var$q(e)).g, n = r.b, "#" + $498ba2dab0ae91e7$var$z(r.r) + $498ba2dab0ae91e7$var$z(t) + $498ba2dab0ae91e7$var$z(n);
    },
    equal: function(e, r) {
        return e.toLowerCase() === r.toLowerCase() || $498ba2dab0ae91e7$var$A($498ba2dab0ae91e7$var$x(e), $498ba2dab0ae91e7$var$x(r));
    }
}, $498ba2dab0ae91e7$export$a3bc3c32746e9f3a = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$$, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$G
    }));
}, $498ba2dab0ae91e7$var$Q = function(r) {
    var t = r.className, n = r.hsva, o = r.onChange, a = {
        backgroundImage: "linear-gradient(90deg, " + $498ba2dab0ae91e7$var$y(Object.assign({}, n, {
            a: 0
        })) + ", " + $498ba2dab0ae91e7$var$y(Object.assign({}, n, {
            a: 1
        })) + ")"
    }, l = $498ba2dab0ae91e7$var$g([
        "react-colorful__alpha",
        t
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__alpha-gradient",
        style: a
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            o({
                a: e.left
            });
        },
        onKey: function(e) {
            o({
                a: $498ba2dab0ae91e7$var$s(n.a + e.left)
            });
        },
        "aria-label": "Alpha",
        "aria-valuetext": $498ba2dab0ae91e7$var$b(100 * n.a) + "%"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__alpha-pointer",
        left: n.a,
        color: $498ba2dab0ae91e7$var$y(n)
    })));
}, $498ba2dab0ae91e7$var$U = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $498ba2dab0ae91e7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $498ba2dab0ae91e7$var$V(f);
    var v = $498ba2dab0ae91e7$var$T(o, l, i), d = v[0], h = v[1], m = $498ba2dab0ae91e7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$L, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$K, {
        hue: d.h,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$Q, {
        hsva: d,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $498ba2dab0ae91e7$var$W = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1
    },
    toHsva: $498ba2dab0ae91e7$var$M,
    fromHsva: $498ba2dab0ae91e7$var$N,
    equal: $498ba2dab0ae91e7$var$A
}, $498ba2dab0ae91e7$export$ee0b0fc8d408da1d = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$W
    }));
}, $498ba2dab0ae91e7$var$ee = {
    defaultColor: "hsla(0, 0%, 0%, 1)",
    toHsva: $498ba2dab0ae91e7$var$E,
    fromHsva: $498ba2dab0ae91e7$var$y,
    equal: $498ba2dab0ae91e7$var$S
}, $498ba2dab0ae91e7$export$989f0248ad966033 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ee
    }));
}, $498ba2dab0ae91e7$var$te = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0
    },
    toHsva: function(e) {
        return $498ba2dab0ae91e7$var$M({
            h: e.h,
            s: e.s,
            l: e.l,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            h: (r = $498ba2dab0ae91e7$var$N(e)).h,
            s: r.s,
            l: r.l
        };
    },
    equal: $498ba2dab0ae91e7$var$A
}, $498ba2dab0ae91e7$export$c737d6c85aab3af7 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$$, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$te
    }));
}, $498ba2dab0ae91e7$var$oe = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: $498ba2dab0ae91e7$var$H,
    fromHsva: $498ba2dab0ae91e7$var$w,
    equal: $498ba2dab0ae91e7$var$S
}, $498ba2dab0ae91e7$export$f4f988c96ece960 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$$, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$oe
    }));
}, $498ba2dab0ae91e7$var$le = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    },
    toHsva: function(e) {
        return e;
    },
    fromHsva: $498ba2dab0ae91e7$var$D,
    equal: $498ba2dab0ae91e7$var$A
}, $498ba2dab0ae91e7$export$a2298f22bee4c5fd = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$le
    }));
}, $498ba2dab0ae91e7$var$ce = {
    defaultColor: "hsva(0, 0%, 0%, 1)",
    toHsva: $498ba2dab0ae91e7$var$k,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$D(e);
        return "hsva(" + r.h + ", " + r.s + "%, " + r.v + "%, " + r.a + ")";
    },
    equal: $498ba2dab0ae91e7$var$S
}, $498ba2dab0ae91e7$export$b2c7d62665b7ee26 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ce
    }));
}, $498ba2dab0ae91e7$var$se = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0
    },
    toHsva: function(e) {
        return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        };
    },
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$D(e);
        return {
            h: r.h,
            s: r.s,
            v: r.v
        };
    },
    equal: $498ba2dab0ae91e7$var$A
}, $498ba2dab0ae91e7$export$580e7249020ee39f = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$$, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$se
    }));
}, $498ba2dab0ae91e7$var$ve = {
    defaultColor: "hsv(0, 0%, 0%)",
    toHsva: $498ba2dab0ae91e7$var$O,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$D(e);
        return "hsv(" + r.h + ", " + r.s + "%, " + r.v + "%)";
    },
    equal: $498ba2dab0ae91e7$var$S
}, $498ba2dab0ae91e7$export$ef09412d0ef04fda = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$$, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ve
    }));
}, $498ba2dab0ae91e7$var$he = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    },
    toHsva: $498ba2dab0ae91e7$var$B,
    fromHsva: $498ba2dab0ae91e7$var$q,
    equal: $498ba2dab0ae91e7$var$A
}, $498ba2dab0ae91e7$export$e9c07ef2be187cb1 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$he
    }));
}, $498ba2dab0ae91e7$var$ge = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: $498ba2dab0ae91e7$var$I,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$q(e);
        return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    equal: $498ba2dab0ae91e7$var$S
}, $498ba2dab0ae91e7$export$be07dcc7abc11a36 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ge
    }));
}, $498ba2dab0ae91e7$var$be = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0
    },
    toHsva: function(e) {
        return $498ba2dab0ae91e7$var$B({
            r: e.r,
            g: e.g,
            b: e.b,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            r: (r = $498ba2dab0ae91e7$var$q(e)).r,
            g: r.g,
            b: r.b
        };
    },
    equal: $498ba2dab0ae91e7$var$A
}, $498ba2dab0ae91e7$export$5ac2ba36722d4bd2 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$$, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$be
    }));
}, $498ba2dab0ae91e7$var$xe = {
    defaultColor: "rgb(0, 0, 0)",
    toHsva: $498ba2dab0ae91e7$var$j,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$q(e);
        return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    equal: $498ba2dab0ae91e7$var$S
}, $498ba2dab0ae91e7$export$9d70f030bf44a214 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$$, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$xe
    }));
}, $498ba2dab0ae91e7$var$Ee = /^#?([0-9A-F]{3,8})$/i, $498ba2dab0ae91e7$var$He = function(r) {
    var t = r.color, l = void 0 === t ? "" : t, s = r.onChange, f = r.onBlur, v = r.escape, d = r.validate, h = r.format, m = r.process, g = $498ba2dab0ae91e7$var$c(r, [
        "color",
        "onChange",
        "onBlur",
        "escape",
        "validate",
        "format",
        "process"
    ]), p = (0, $acw62.useState)(function() {
        return v(l);
    }), b = p[0], _ = p[1], x = $498ba2dab0ae91e7$var$i(s), C = $498ba2dab0ae91e7$var$i(f), E = (0, $acw62.useCallback)(function(e) {
        var r = v(e.target.value);
        _(r), d(r) && x(m ? m(r) : r);
    }, [
        v,
        m,
        d,
        x
    ]), H = (0, $acw62.useCallback)(function(e) {
        d(e.target.value) || _(v(l)), C(e);
    }, [
        l,
        v,
        d,
        C
    ]);
    return (0, $acw62.useEffect)(function() {
        _(v(l));
    }, [
        l,
        v
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $498ba2dab0ae91e7$var$u({}, g, {
        value: h ? h(b) : b,
        spellCheck: "false",
        onChange: E,
        onBlur: H
    }));
}, $498ba2dab0ae91e7$var$Me = function(e) {
    return "#" + e;
}, $498ba2dab0ae91e7$export$9219d762117624b6 = function(r) {
    var t = r.prefixed, n = r.alpha, o = $498ba2dab0ae91e7$var$c(r, [
        "prefixed",
        "alpha"
    ]), l = (0, $acw62.useCallback)(function(e) {
        return e.replace(/([^0-9A-F]+)/gi, "").substr(0, n ? 8 : 6);
    }, [
        n
    ]), i = (0, $acw62.useCallback)(function(e) {
        return function(e, r) {
            var t = $498ba2dab0ae91e7$var$Ee.exec(e), n = t ? t[1].length : 0;
            return 3 === n || 6 === n || !!r && 4 === n || !!r && 8 === n;
        }(e, n);
    }, [
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$He, $498ba2dab0ae91e7$var$u({}, o, {
        escape: l,
        format: t ? $498ba2dab0ae91e7$var$Me : void 0,
        process: $498ba2dab0ae91e7$var$Me,
        validate: i
    }));
};






var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");

const $3fe6920ef40d5760$var$StateButton = /*#__PURE__*/ (0, $acw62.forwardRef)(function StateButton({ active: active, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
        ...rest,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            active: active
        }, className)
    });
});
const $3fe6920ef40d5760$export$fb3c76ca6bd03684 = (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
  &.MuiIconButton-root {
    background-color: ${(props)=>props.theme.palette.background.paper};
    margin-right: 24px;
    box-shadow: ${(props)=>props.theme.shadows[15]};

    &:hover,
    &.active {
      & svg {
        color: ${(props)=>props.theme.palette.primary.contrastText};
      }
      background-color: ${(props)=>props.theme.palette.primary.dark};
    }

    &.active {
      & svg {
        color: ${(props)=>props.theme.palette.secondary.contrastText};
      }
      background-color: ${(props)=>props.theme.palette.secondary.main};
    }

    &.Mui-disabled {
      background-color: ${(props)=>props.theme.palette.background.paper};
    }
  }
`;
var $3fe6920ef40d5760$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($3fe6920ef40d5760$var$StateButton).attrs({
    className: $3fe6920ef40d5760$var$StateButton.name
})`
  ${$3fe6920ef40d5760$export$fb3c76ca6bd03684}
`;



var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");


var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");




var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $9XEW1.default)("PrivateSwitchBase", slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $7u6PA.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $f3bdb1b636c81735$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $9971e.default)(slots, (0, $86603163591f910a$export$baa0faa0c7ad8085), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $8nd05.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $1En50.default)(props, $f3bdb1b636c81735$var$_excluded);
    const [checked, setCheckedState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3bdb1b636c81735$var$SwitchBaseRoot, (0, $8nd05.default)({
        component: "span",
        className: (0, $1SA7b.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($f3bdb1b636c81735$var$SwitchBaseInput, (0, $8nd05.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor && id,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
}); // NB: If changed, please update Checkbox, Switch and Radio
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $jTnBY = parcelRequire("jTnBY");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $9XEW1.default)("MuiCheckbox", slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $7u6PA.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary"
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $12775c00f473d955$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size"
];
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $jTnBY.default)(color)}`
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $6e1cd6b997bc70d3$export$6c57c6e16b4063b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: theme.palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: (0, $kyRHb.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).checked}, &.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).indeterminate}`]: {
            color: theme.palette[ownerState.color].main
        },
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.action.disabled
        }
    }));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8b10b2b5aaa8e54$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $122b08a8ae2faae5$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8b21cdbf539e4f$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium" } = props, other = (0, $1En50.default)(props, $12775c00f473d955$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$CheckboxRoot, (0, $8nd05.default)({
        type: "checkbox",
        inputProps: (0, $8nd05.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes
    }));
});
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $9XEW1.default)("MuiFormControlLabel", slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $7u6PA.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error"
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;




var $ayMG0 = parcelRequire("ayMG0");
const $1a034abd43bd8eee$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "value"
];
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && "error"
        ],
        label: [
            "label",
            disabled && "disabled"
        ]
    };
    return (0, $9971e.default)(slots, (0, $5cff6b4166fff27c$export$717666c39ec07e12), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.palette.text.disabled
            }
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end" } = props, other = (0, $1En50.default)(props, $1a034abd43bd8eee$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    let disabled = disabledProp;
    if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") disabled = control.props.disabled;
    if (typeof disabled === "undefined" && muiFormControl) disabled = muiFormControl.disabled;
    const controlProps = {
        disabled: disabled
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        error: fcs.error
    });
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    let label = labelProp;
    if (label != null && label.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        component: "span",
        className: classes.label
    }, componentsProps.typography, {
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            label
        ]
    }));
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $jTnBY = parcelRequire("jTnBY");




var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $9XEW1.default)("MuiInputAdornment", slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $7u6PA.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;



var $6g9fa = parcelRequire("6g9fa");

var $ayMG0 = parcelRequire("ayMG0");
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $f3e589c60baacdec$export$4b135a4b3a6c4550), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: theme.palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1En50.default)(props, $d0c64ff513a9933f$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");



var $ayMG0 = parcelRequire("ayMG0");
const $83e175cb7e49d325$var$_excluded = [
    "className"
];
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $9971e.default)(slots, (0, $9c1b7b40cd19f5fe$export$81478e24460c57f2), classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $d8seH.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        minWidth: 56,
        color: theme.palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $83e175cb7e49d325$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $83e175cb7e49d325$export$2e2bcd8739ae039 = $83e175cb7e49d325$var$ListItemIcon;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");



var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");
const $0d696835f9b43a35$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $9971e.default)(slots, (0, $c01aa6ddbe5e68bd$export$1061006a0db3aeb5), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $1En50.default)(props, $0d696835f9b43a35$var$_excluded);
    const { dense: dense } = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d696835f9b43a35$var$ListItemTextRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;




var $acw62 = parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");





const $ac2178c3fe9853aa$export$668bd77d4f78425a = {
    ALBATROS: 16000.0,
    ara_vdm: 5000.0,
    "BDK-775": 6000.0,
    CastleClass_01: 3000.0,
    CVN_71: 25000.0,
    CVN_72: 25000.0,
    CVN_73: 25000.0,
    CVN_75: 25000.0,
    CV_1143_5: 12000.0,
    "Dry-cargo ship-1": 0.0,
    "Dry-cargo ship-2": 0.0,
    ELNYA: 0.0,
    Forrestal: 25000.0,
    HandyWind: 0.0,
    HarborTug: 0.0,
    Higgins_boat: 1000.0,
    hms_invincible: 74000.0,
    IMPROVED_KILO: 0.0,
    KILO: 0.0,
    KUZNECOW: 12000.0,
    La_Combattante_II: 4000.0,
    "leander-gun-achilles": 8000.0,
    "leander-gun-andromeda": 140000.0,
    "leander-gun-ariadne": 100000.0,
    "leander-gun-condell": 100000.0,
    "leander-gun-lynch": 140000.0,
    LHA_Tarawa: 20000.0,
    LST_Mk2: 4000.0,
    MOLNIYA: 2000.0,
    MOSCOW: 75000.0,
    NEUSTRASH: 12000.0,
    PERRY: 100000.0,
    PIOTR: 190000.0,
    REZKY: 16000.0,
    santafe: null,
    Schnellboot_type_S130: 4000.0,
    Seawise_Giant: 0.0,
    Ship_Tilde_Supply: 0.0,
    SOM: 0.0,
    speedboat: 1000.0,
    Stennis: 25000.0,
    TICONDEROG: 100000.0,
    Type_052B: 30000.0,
    Type_052C: 100000.0,
    Type_054A: 45000.0,
    Type_071: 150000.0,
    Type_093: 40000.0,
    Uboat_VIIC: 4000.0,
    USS_Arleigh_Burke_IIa: 100000.0,
    USS_Samuel_Chase: 7000.0,
    VINSON: 15000.0,
    ZWEZDNY: 0.0
};




var $c5dd9f05f83ae634$var$SAMType;
(function(SAMType) {
    SAMType["SA6"] = "SA6";
    SAMType["SA2"] = "SA2";
    SAMType["SA3"] = "SA3";
    SAMType["Patriot"] = "Patriot";
    SAMType["HAWK"] = "Hawk";
    SAMType["SA5"] = "SA5";
    SAMType["SA10"] = "SA10";
    SAMType["SA11"] = "SA11";
    SAMType["SA15"] = "SA15";
    SAMType["SA8"] = "SA8";
})($c5dd9f05f83ae634$var$SAMType || ($c5dd9f05f83ae634$var$SAMType = {}));
const $c5dd9f05f83ae634$var$nmToMeters = 1852;
const $c5dd9f05f83ae634$var$SAM_RADARS = {
    "Kub 1S91 str": "SA6",
    SNR_75V: "SA2",
    "snr s-125 tr": "SA3",
    "Patriot str": "Patriot",
    "Hawk tr": "Hawk",
    RPC_5N62V: "SA5",
    "S-300PS 40B6M tr": "SA10",
    "SA-11 Buk LN 9A310M1": "SA11",
    "Tor 9A331": "SA15",
    "Osa 9A33 ln": "SA8"
};
const $c5dd9f05f83ae634$var$threatDistances = {
    ["SA6"]: 13,
    ["SA2"]: 22,
    ["SA3"]: 9.6,
    ["Patriot"]: 53,
    ["Hawk"]: 19,
    ["SA5"]: 80,
    ["SA10"]: 35,
    ["SA11"]: 18,
    ["SA15"]: 6,
    ["SA8"]: 5
};
function $c5dd9f05f83ae634$var$getThreatRadius(sam) {
    let miles = $c5dd9f05f83ae634$var$threatDistances[sam] || 0;
    return miles * $c5dd9f05f83ae634$var$nmToMeters;
}
function $c5dd9f05f83ae634$var$getShipThreatRadius(type) {
    return (0, $ac2178c3fe9853aa$export$668bd77d4f78425a)[type] || 0;
}
function $c5dd9f05f83ae634$export$ef25a7bc432a381c(type) {
    return $c5dd9f05f83ae634$var$SAM_RADARS[type] || null;
}
function $c5dd9f05f83ae634$export$2d46b8799829d984(theater, groups, friendly = false) {
    const features = [];
    for (const group of groups)for (const unit of group.units){
        const samType = $c5dd9f05f83ae634$export$ef25a7bc432a381c(unit.type);
        if (samType || group.category === (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship) {
            const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, unit);
            const point = [
                long,
                lat
            ];
            const radius = group.category === (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship ? $c5dd9f05f83ae634$var$getShipThreatRadius(unit.type) : $c5dd9f05f83ae634$var$getThreatRadius(samType);
            const geometry = (0, $40aa8d43bbe572bf$export$f99d756c6d81ae3f)(point, radius);
            const f = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                geometry: geometry,
                radius: radius,
                type: unit.type,
                designation: samType,
                unselectable: true
            });
            features.push(f);
            break;
        }
    }
    const layer = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            features: features
        }),
        style: ()=>{
            return [
                new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: friendly ? "blue" : "red",
                        width: 2
                    }),
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: friendly ? "rgb(0, 0, 255, .1)" : "rgb(255, 0, 0, .1)"
                    }),
                    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                        overflow: true,
                        font: '14px "Roboto","sans-serif"',
                        placement: "point",
                        // text: feature.get("designation"),
                        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                            color: "black"
                        }),
                        offsetY: 24
                    })
                })
            ];
        }
    });
    layer.set("name", (0, $91a9098e14452db2$export$fb028bc55343bb1f).Threats);
    return layer;
}



function $75a1e531b08ffb65$var$categoryToSymbold(cat, support) {
    switch(cat){
        case (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Vehicle:
            return [
                "G",
                "---"
            ];
        case (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Plane:
            return [
                "A",
                support ? $75a1e531b08ffb65$export$65be6133e6c5e77b[support] : "MFF"
            ];
        case (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Helicopter:
            return [
                "A",
                "MHA"
            ];
        case (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Static:
            return [
                "G",
                "--"
            ];
        case (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship:
            return [
                "S",
                "CLDD"
            ];
        default:
            break;
    }
}
function $75a1e531b08ffb65$export$edaef53a74a5ccc9(isOpfor) {
    return `S${isOpfor ? "H" : "F"}GPI-----H-`;
}
var $75a1e531b08ffb65$export$65be6133e6c5e77b;
(function(SubCategory) {
    SubCategory["Ground"] = "---";
    SubCategory["Fighter"] = "MFF";
    SubCategory["Helicopter"] = "MHA";
    SubCategory["AWACS"] = "MFRW";
    SubCategory["Tanker"] = "MFK";
    SubCategory["Static"] = "--";
    SubCategory["AirDefense"] = "UCDC";
    SubCategory["Armor"] = "UCA";
    SubCategory["Infantry"] = "UCI";
    SubCategory["Artillery"] = "UCF";
    SubCategory["Recon"] = "UCR";
    SubCategory["Destroyer"] = "CLDD";
})($75a1e531b08ffb65$export$65be6133e6c5e77b || ($75a1e531b08ffb65$export$65be6133e6c5e77b = {}));
function $75a1e531b08ffb65$export$af576a01257ae419(hostile, category, support, type) {
    let [cat, subCat] = $75a1e531b08ffb65$var$categoryToSymbold(category, support);
    let isSAM = false;
    if (Array.isArray(type)) isSAM = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).some(type, (t)=>(0, $c5dd9f05f83ae634$export$ef25a7bc432a381c)(t));
    else isSAM = !!(0, $c5dd9f05f83ae634$export$ef25a7bc432a381c)(type);
    if (isSAM) subCat = "UCDC";
    const out = [
        "S",
        hostile ? "H" : "F",
        cat,
        "P",
        subCat
    ].join("");
    const p = out.padEnd(10, "-");
    return p;
}
var $75a1e531b08ffb65$export$2b3fa5494dd8ce2f;
(function(SymbolSet) {
    SymbolSet["Air"] = "A";
    SymbolSet["Ground"] = "G";
})($75a1e531b08ffb65$export$2b3fa5494dd8ce2f || ($75a1e531b08ffb65$export$2b3fa5494dd8ce2f = {}));
function $75a1e531b08ffb65$export$520fa8fc0607d91a(hostile, set, sub) {
    const out = [
        "S",
        hostile ? "H" : "F",
        set,
        "P",
        sub
    ].join("");
    const p = out.padEnd(10, "-");
    return p;
}



function $7c8d582dba39de96$var$PointDetailsForm({ className: className, hostile: hostile, ident: ident, free: free, icon: icon, ring: ring, onChange: onChange }) {
    const symbol = $acw62.useCallback((sub, set = (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Ground)=>new (0, (/*@__PURE__*/$parcel$interopDefault($e786e20e25c5f221$exports))).Symbol((0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(hostile, set, sub), {
            size: 20
        }).asSVG(), [
        hostile
    ]);
    $acw62.useEffect(()=>{
        const str = `${icon}`.split("");
        str[1] = hostile ? "H" : "F";
        onChange("icon", str.join(""));
    }, [
        hostile
    ]);
    $acw62.useEffect(()=>{
        if (icon !== (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(true, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Ground, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).AirDefense)) onChange("ring", 0);
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                onChange: (ev)=>onChange("ident", ev.target.value),
                                size: "small",
                                label: "IDENT",
                                value: ident
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            ml: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    onChange: (ev)=>onChange("free", ev.target.value),
                                    label: "FREE",
                                    size: "small",
                                    value: free
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                children: "Icon"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                style: {
                                    height: 52
                                },
                                value: icon,
                                onChange: (ev)=>{
                                    onChange("icon", ev.target.value);
                                },
                                size: "small",
                                label: "Icon",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: "",
                                        children: "None"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        style: {
                                            display: "flex"
                                        },
                                        value: (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(hostile, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Ground, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Armor),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: "data:image/svg+xml;utf8," + symbol((0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Armor)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                children: "Armor"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(hostile, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Ground, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).AirDefense),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: "data:image/svg+xml;utf8," + symbol((0, $75a1e531b08ffb65$export$65be6133e6c5e77b).AirDefense)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                children: "Air Defense"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(hostile, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Ground, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Artillery),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: "data:image/svg+xml;utf8," + symbol((0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Artillery)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                children: "Artillery"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(hostile, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Ground, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Infantry),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: "data:image/svg+xml;utf8," + symbol((0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Infantry)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                children: "Infantry"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(hostile, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Air, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Helicopter),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: "data:image/svg+xml;utf8," + symbol((0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Helicopter, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Air)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                children: "Helicopter"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(hostile, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Air, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Fighter),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: "data:image/svg+xml;utf8," + symbol((0, $75a1e531b08ffb65$export$65be6133e6c5e77b).Fighter, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Air)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                children: "Fighter"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    wide: true,
                    between: true,
                    children: [
                        icon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                    defaultChecked: true,
                                    value: hostile,
                                    onChange: ()=>{
                                        onChange("hostile", !hostile);
                                    }
                                }),
                                label: "Hostile"
                            })
                        }),
                        icon === (0, $75a1e531b08ffb65$export$520fa8fc0607d91a)(true, (0, $75a1e531b08ffb65$export$2b3fa5494dd8ce2f).Ground, (0, $75a1e531b08ffb65$export$65be6133e6c5e77b).AirDefense) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            style: {
                                width: 136
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                label: "Ring",
                                type: "number",
                                size: "small",
                                value: ring,
                                onChange: (ev)=>onChange("ring", ev.target.value),
                                InputProps: {
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                                        position: "end",
                                        children: "NM"
                                    })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $7c8d582dba39de96$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($7c8d582dba39de96$var$PointDetailsForm).attrs({
    className: $7c8d582dba39de96$var$PointDetailsForm.name
})`
  .MuiInputBase-inputSizeSmall {
    display: flex !important;
  }

  .MuiListItemIcon-root {
    min-width: unset;
    margin-right: 8px;
  }
`;


const $1979cb34b49b6368$var$Editor = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ onSubmit: onSubmit, submitting: submitting, onEdit: onEdit, controlMeasure: controlMeasure, editing: editing, onDelete: onDelete, className: className })=>{
    const pickeAnchorRef = $acw62.useRef(null);
    const [colorPickerOpen, setColorPickerOpen] = $acw62.useState(false);
    const { name: name, color: color, geometry: geometry, ident: ident = "", free: free = "", icon: icon = "", hostile: hostile = true, ring: ring = 0 } = controlMeasure;
    const [formState, setState] = $acw62.useState({
        name: name,
        color: color,
        dirty: false,
        geometry: geometry,
        ident: ident,
        free: free,
        icon: icon,
        hostile: hostile,
        ring: ring
    });
    const reset = (0, $302106ffa43351a6$export$755755835fad5070)((newGeom)=>{
        setState({
            ...formState,
            dirty: true,
            geometry: newGeom
        });
    });
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (onSubmit) {
            setState({
                ...formState,
                dirty: false
            });
            onSubmit(formState);
        }
    };
    const handleCancel = ()=>{
        reset();
        setState({
            name: controlMeasure.name,
            color: controlMeasure.color,
            geometry: controlMeasure.geometry,
            dirty: false
        });
    };
    $acw62.useEffect(()=>{
        // Reset the form state if the control measure changes
        setState({
            ...formState,
            name: name,
            color: color,
            geometry: geometry,
            dirty: false,
            ident: ident,
            free: free,
            icon: icon,
            hostile: hostile,
            ring: ring
        });
    }, [
        name,
        color
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    mb: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                onChange: (e)=>setState({
                                        ...formState,
                                        name: e.target.value,
                                        dirty: true
                                    }),
                                label: "Name",
                                value: formState.name
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mt: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                wide: true,
                                align: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                                                children: "Color"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                                align: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                        title: "Edit Color",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                                                            style: {
                                                                boxShadow: "none",
                                                                border: "1px solid #ccc",
                                                                marginRight: 0
                                                            },
                                                            ref: pickeAnchorRef,
                                                            onClick: ()=>setColorPickerOpen(!colorPickerOpen),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($19fb6d413538179b$exports))), {})
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                        ml: 1,
                                                        style: {
                                                            display: "inline-block",
                                                            backgroundColor: formState.color,
                                                            height: 24,
                                                            width: 24
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
                                                anchorOrigin: {
                                                    vertical: "center",
                                                    horizontal: "right"
                                                },
                                                PaperProps: {
                                                    style: {
                                                        overflow: "hidden"
                                                    }
                                                },
                                                anchorEl: pickeAnchorRef.current,
                                                open: colorPickerOpen,
                                                onClose: ()=>setColorPickerOpen(false),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $498ba2dab0ae91e7$export$a3bc3c32746e9f3a), {
                                                    color: formState.color,
                                                    onChange: (newColor)=>{
                                                        setState({
                                                            ...formState,
                                                            color: newColor,
                                                            dirty: true
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        ml: 4,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                                                    children: "Geometry"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                                    align: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                            title: "Edit Geometry",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                                                                onClick: onEdit,
                                                                active: !!editing,
                                                                style: {
                                                                    boxShadow: "none",
                                                                    border: "1px solid #ccc",
                                                                    marginRight: 0
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {})
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            ml: 1,
                                                            children: geometry.getType()
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                geometry.getType() === "Point" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c8d582dba39de96$export$2e2bcd8739ae039), {
                    ...formState,
                    onChange: (key, val)=>{
                        setState({
                            ...formState,
                            [key]: val,
                            dirty: true
                        });
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    mt: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        align: true,
                        wide: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                loading: submitting,
                                disabled: !formState.dirty,
                                variant: "contained",
                                type: "submit",
                                children: "Save"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                ml: 1,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    disabled: !formState.dirty,
                                    variant: "outlined",
                                    onClick: handleCancel,
                                    children: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                color: "error",
                                style: {
                                    marginLeft: "auto"
                                },
                                variant: "outlined",
                                onClick: onDelete,
                                children: "Delete"
                            })
                        ]
                    })
                })
            ]
        })
    });
})``;
var $1979cb34b49b6368$export$2e2bcd8739ae039 = $1979cb34b49b6368$var$Editor;


function $76ac0c10b812f0bc$var$ControlMeasureHopup({ className: className, ...controlMeasure }) {
    const [submitting, setSubmitting] = $acw62.useState(false);
    const { state: { editingControlMeasure: editingControlMeasure } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const isOwner = (0, $302106ffa43351a6$export$be66956e5fa7746a)();
    const canEdit = isOwner(controlMeasure) && (0, $99f46708ff5ed621$export$4221ea9241cbaab6)();
    const blur = (0, $99f46708ff5ed621$export$19df1d269fc1c6e9)();
    const update = (0, $302106ffa43351a6$export$34799c4c5cc899c6)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const toggleGeomEdit = (0, $99f46708ff5ed621$export$9059596f8e425fd6)();
    const remove = (0, $302106ffa43351a6$export$b02902a51cce2283)();
    const handleRemove = $acw62.useCallback(()=>{
        if (window.confirm("Are you sure you want to delete this control measure?")) {
            blur();
            remove(controlMeasure).then(()=>success("Control measure deleted")).catch((err)=>{
                console.error(err);
                error(err.message);
            });
        }
    }, [
        controlMeasure
    ]);
    const handleSubmit = $acw62.useCallback((vals)=>{
        setSubmitting(true);
        toggleGeomEdit(null);
        const next = {
            ...controlMeasure,
            ...vals,
            name: vals.name,
            color: vals.color,
            geometry: vals.geometry
        };
        update(next).then(()=>{
            success("Control measure updated");
        }).catch((err)=>{
            console.error(err);
            error(err.message);
        }).finally(()=>{
            setSubmitting(false);
        });
    }, [
        controlMeasure,
        editingControlMeasure
    ]);
    const handleEdit = $acw62.useCallback(()=>{
        toggleGeomEdit(editingControlMeasure ? null : controlMeasure);
    }, [
        editingControlMeasure,
        controlMeasure
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            !canEdit && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                columns: 2,
                pairs: [
                    {
                        key: "Geometry Type",
                        value: controlMeasure.geometry.getType()
                    }
                ]
            }),
            canEdit && controlMeasure && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1979cb34b49b6368$export$2e2bcd8739ae039), {
                submitting: submitting,
                onSubmit: handleSubmit,
                onEdit: handleEdit,
                onDelete: handleRemove,
                controlMeasure: controlMeasure,
                editing: !!editingControlMeasure
            })
        ]
    });
}
var $76ac0c10b812f0bc$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($76ac0c10b812f0bc$var$ControlMeasureHopup).attrs({
    className: $76ac0c10b812f0bc$var$ControlMeasureHopup.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

const $8396d1566d56485e$var$WindowManagerContext = (0, $acw62.createContext)(null);
function $8396d1566d56485e$export$d3d0694a1d2def88() {
    return (0, $acw62.useContext)($8396d1566d56485e$var$WindowManagerContext);
}
function $8396d1566d56485e$export$79de27f3d89caa16({ children: children }) {
    const [windows, setWindows] = (0, $acw62.useState)([]);
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    (0, $acw62.useEffect)(()=>{
        const q = new URLSearchParams(window.location.search);
        const w = q.get("window");
        const group = q.get("group");
        if (w) {
            let props = {};
            if (group) props = {
                group: decodeURIComponent(group)
            };
            addWindow({
                id: w,
                type: w,
                props: props
            });
        }
    }, [
        window.location.search
    ]);
    const addWindow = (win)=>{
        const exists = !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(windows, {
            id: win.id
        });
        if (exists) {
            // remove the existing window
            const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(windows, (w)=>w.id !== win.id);
            setWindows([
                ...filtered,
                win
            ]);
        }
        if (!exists) setWindows([
            ...windows,
            win
        ]);
    };
    const handleClick = (type, id, props)=>{
        let next = [
            ...windows
        ];
        const win = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(next, {
            type: type
        });
        if (win) {
            // remove the existing window
            next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(next, (w)=>w.type !== type);
            setWindows(next);
            return;
        }
        const q = new URLSearchParams(window.location.search);
        q.set("window", type);
        if (props?.group) q.set("group", encodeURIComponent(props.group));
        history.replace({
            search: q.toString()
        });
        next.push({
            id: type,
            type: type,
            props: props
        });
        setWindows(next);
    };
    const handleClose = (win)=>{
        const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(windows, (w)=>w.id !== win.id);
        const q = new URLSearchParams(window.location.search);
        q.delete("window");
        q.delete("group");
        history.replace({
            search: q.toString()
        });
        setWindows(filtered);
    };
    return (0, $acw62.createElement)($8396d1566d56485e$var$WindowManagerContext.Provider, {
        value: {
            windows: windows,
            addWindow: addWindow,
            handleClick: handleClick,
            handleClose: handleClose
        },
        children: children
    });
}
var $8396d1566d56485e$export$988a21494ff06fc5;
(function(FOWindow) {
    FOWindow["Players"] = "Players";
    FOWindow["SupportAssets"] = "Support Assets";
    FOWindow["Bases"] = "Bases";
    FOWindow["Assets"] = "Kneeboards";
    FOWindow["DataEntry"] = "Data Entry";
    FOWindow["SelectedFeature"] = "Selected Feature";
    FOWindow["AirportDiagram"] = "Airport Diagram";
    FOWindow["Planning"] = "Planning";
    FOWindow["AircraftData"] = "Aircraft Data";
    FOWindow["Singups"] = "Signups";
    FOWindow["FlyableGroup"] = "Flyable Group";
    FOWindow["ControlMeasures"] = "Control Measures";
    FOWindow["Signups"] = "Signups";
    FOWindow["TacviewExport"] = "Tacview Export";
    FOWindow["Search"] = "Search";
    FOWindow["TimelineEditor"] = "Timeline Editor";
})($8396d1566d56485e$export$988a21494ff06fc5 || ($8396d1566d56485e$export$988a21494ff06fc5 = {}));
function $8396d1566d56485e$export$b57932fbfac1e18() {
    const win = $8396d1566d56485e$export$d3d0694a1d2def88();
    return (group)=>{
        const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(win.windows, {
            id: group.name
        });
        if (existing) {
            win.handleClose(existing);
            return;
        }
        win.addWindow({
            id: group.name,
            type: "Flyable Group",
            props: {
                group: group
            }
        });
    };
}




function $690458fd8db35481$var$Airbase({ className: className, airbase: airbase }) {
    const { addWindow: addWindow } = (0, $8396d1566d56485e$export$d3d0694a1d2def88)();
    const pairs = [
        {
            key: "UHF",
            value: (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(airbase.UHF)
        },
        {
            key: "VHF",
            value: (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(airbase.VHF)
        },
        {
            key: "TACAN",
            value: airbase.TACAN
        }
    ];
    if (airbase.ILS) pairs.push({
        key: "ILS",
        value: airbase.ILS.join("\n")
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                columns: 3,
                pairs: pairs
            }),
            !airbase.UnitId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                center: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    variant: "outlined",
                    onClick: ()=>addWindow({
                            id: `${airbase.Name} - Parking Diagram`,
                            type: (0, $8396d1566d56485e$export$988a21494ff06fc5).AirportDiagram,
                            props: {
                                name: airbase.Name
                            }
                        }),
                    children: "Parking Diagram"
                })
            })
        ]
    });
}
var $690458fd8db35481$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($690458fd8db35481$var$Airbase).attrs({
    className: $690458fd8db35481$var$Airbase.name
})`
  td {
    padding: 0;
    border-bottom: 0px;
  }

  tr:nth-child(2) td:nth-child(1) {
    max-width: 20px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



function $d59e282e16833671$var$Bullseye({ className: className, bullseye: bullseye }) {
    const { state: { tasking: { theater: theater } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, bullseye);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
            children: (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
                long,
                lat
            ]).join("\n")
        })
    });
}
var $d59e282e16833671$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($d59e282e16833671$var$Bullseye).attrs({
    className: $d59e282e16833671$var$Bullseye.name
})``;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $f1f54eceadee9a7b$var$ControlPoint({ className: className, point: point }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
            children: point.comment
        })
    });
}
var $f1f54eceadee9a7b$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($f1f54eceadee9a7b$var$ControlPoint).attrs({
    className: $f1f54eceadee9a7b$var$ControlPoint.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");
var $6eefe30025c8ad9a$exports = {};
"use strict";

Object.defineProperty($6eefe30025c8ad9a$exports, "__esModule", {
    value: true
});
$6eefe30025c8ad9a$exports.default = void 0;

var $6eefe30025c8ad9a$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6eefe30025c8ad9a$var$_default = (0, $6eefe30025c8ad9a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
}), "Save");
$6eefe30025c8ad9a$exports.default = $6eefe30025c8ad9a$var$_default;



var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(b, c, d) {
        var e = new XMLHttpRequest;
        e.open("GET", b), e.responseType = "blob", e.onload = function() {
            a(e.response, c, d);
        }, e.onerror = function() {
            console.error("could not download file");
        }, e.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(a, b, d, e) {
        if (e = e || open("", "_blank"), e && (e.document.title = e.document.body.innerText = "downloading..."), "string" == typeof a) return c(a, b, d);
        var g = "application/octet-stream" === a.type, h = /constructor/i.test(f.HTMLElement) || f.safari, i = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((i || g && h) && "object" == typeof FileReader) {
            var j = new FileReader;
            j.onloadend = function() {
                var a = j.result;
                a = i ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), e ? e.location.href = a : location = a, e = null;
            }, j.readAsDataURL(a);
        } else {
            var k = f.URL || f.webkitURL, l = k.createObjectURL(a);
            e ? e.location = l : location.href = l, e = null, setTimeout(function() {
                k.revokeObjectURL(l);
            }, 4E4);
        }
    });
    f.saveAs = a.saveAs = a, $90f256c567e4c320$exports = a;
});



var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");




var $f1q41 = parcelRequire("f1q41");



var $f1q41 = parcelRequire("f1q41");




function $53c885ff43760466$var$toLocale(d) {
    return d.toLocaleString((0, $63618293c58b5f80$exports.DateTime).TIME_24_SIMPLE);
}
function $53c885ff43760466$var$militaryTime(tasking) {
    // @ts-ignore
    const d = (0, $63618293c58b5f80$exports.DateTime).fromISO(tasking.time, {
        zone: "utc"
    });
    return [
        d,
        d.minus({
            hour: (0, $e1dc1ccf277543ba$export$59c99f3515d3493f)(tasking.theater)
        })
    ];
}
function $53c885ff43760466$export$ee1d6d1eff24dd98(time) {
    return (0, $63618293c58b5f80$exports.DateTime).fromISO(time, {
        zone: "utc"
    });
}
function $53c885ff43760466$export$569833b2e4f7ab18(d, theater) {
    return d.minus({
        hour: (0, $e1dc1ccf277543ba$export$59c99f3515d3493f)(theater)
    });
}
function $53c885ff43760466$export$c6d8503b07f17cbd(tasking) {
    const [local, zulu] = $53c885ff43760466$var$militaryTime(tasking);
    return [
        $53c885ff43760466$var$toLocale(local),
        $53c885ff43760466$var$toLocale(zulu)
    ];
}
function $53c885ff43760466$export$466569099c44c97b(tasking, delta) {
    const [, zulu] = $53c885ff43760466$var$militaryTime(tasking);
    return zulu.plus({
        seconds: delta
    });
}
function $53c885ff43760466$export$7230f5ee2063b315(zulu, eta) {
    return zulu.plus({
        hours: 0,
        minutes: 0,
        seconds: eta
    });
}
function $53c885ff43760466$export$45bc8b206e259390(prev, next) {
    const d = (0, $63618293c58b5f80$exports.Duration).fromObject({
        hours: 0,
        minutes: 0,
        seconds: next.ETA
    });
    return d.minus({
        seconds: prev.ETA
    });
}
function $53c885ff43760466$export$65b5e8193f7205c1(start, knots, distance) {
    const hours = distance / knots;
    return start.plus({
        hours: hours
    });
}
function $53c885ff43760466$export$55ad5c77306bdcab(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = $53c885ff43760466$var$deg2rad(lat2 - lat1); // deg2rad below
    var dLon = $53c885ff43760466$var$deg2rad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos($53c885ff43760466$var$deg2rad(lat1)) * Math.cos($53c885ff43760466$var$deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}
function $53c885ff43760466$var$deg2rad(deg) {
    return deg * (Math.PI / 180);
}
function $53c885ff43760466$export$9f17032d917177de(theater, p1, p2) {
    const p1LL = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, p1);
    const p2LL = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, p2);
    return $53c885ff43760466$export$7aff669504c23062(p1LL, p2LL);
}
function $53c885ff43760466$export$7aff669504c23062(p1, p2) {
    const km = $53c885ff43760466$export$55ad5c77306bdcab(p1.lat, p1.long, p2.lat, p2.long);
    const nauticalMiles = (0, $91a9098e14452db2$export$a31389e164b90234) * (km * 1000);
    return nauticalMiles;
}
function $53c885ff43760466$export$c883c0766fae79f3(theater, wp, allwp) {
    // Slice of all the waypoints up to and including the current
    const sl = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(allwp, (w)=>w.number <= wp.number);
    // Add them all up for "distance so far"
    const total = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sum((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(sl, (w, i, all)=>{
        const l = all[w.number - 1];
        return l ? $53c885ff43760466$export$9f17032d917177de(theater, l, w) : 0;
    }));
    return total;
}


const $7f575851fb70de69$var$re = /(.\d)°\s/g;
function $7f575851fb70de69$export$c181bcb10410d4cf(theater, startTime, g, presets) {
    const type = (0, $b9c9d9c1adf94aca$export$f028d354b7025aa9)(g);
    const Waypoints = [];
    for(let i = 0; i < g.waypoints.length; i += 1){
        if (i === 0) continue;
        const w = g.waypoints[i];
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, w);
        const [n, e] = (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
            long,
            lat
        ], 3);
        let latFormatted = n + "\u2019";
        let longFormatted = e + "\u2019";
        if (type === "F-16C_50") {
            // Append leading 0 to Easting only for the viper
            const padded = $7f575851fb70de69$var$padDegrees(longFormatted);
            // DTC requires a different format for the lat/long only on the viper for some reason
            latFormatted = n.replace($7f575851fb70de69$var$re, "$1.");
            longFormatted = padded.replace($7f575851fb70de69$var$re, "$1.");
        }
        const tot = (0, $53c885ff43760466$export$7230f5ee2063b315)(startTime, w.ETA);
        Waypoints.push({
            Sequence: i,
            Name: w.name,
            Latitude: latFormatted,
            Longitude: longFormatted,
            Elevation: Math.floor((0, $79e13355954d15ea$export$d284c26147b5ca34)(w.alt)),
            TimeOverSteerpoint: tot.toFormat("HH:mm:ss"),
            IsCoordinateBlank: false,
            PointType: "WP",
            Identifier: "WP",
            Free: ""
        });
    }
    const result = {
        Waypoints: {
            Waypoints: Waypoints,
            SteerpointStart: 1,
            SteerpointEnd: 20,
            OverrideRange: false,
            EnableUploadCoordsElevation: true,
            EnableUploadTOS: true,
            EnableUpload: true
        }
    };
    if (presets && presets.length > 0) {
        const r1c1 = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(presets, [
            0,
            0
        ], []);
        const r2c1 = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(presets, [
            1,
            0
        ], []);
        const Radios = {
            COM1: {
                Name: "COM1",
                Type: 0,
                Channels: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(presets?.[0], (c, i)=>{
                    return {
                        Type: 1,
                        Channel: i + 1,
                        Frequency: c.frequency,
                        ToBeUpdated: false
                    };
                }),
                SelectedChannel: {
                    Type: 2,
                    Channel: 1,
                    Frequency: r1c1?.frequency,
                    ToBeUpdated: false
                }
            },
            COM2: {
                Name: "COM2",
                Type: 1,
                Channels: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(presets?.[1], (c, i)=>{
                    return {
                        Type: 2,
                        Channel: i + 1,
                        Frequency: c.frequency,
                        ToBeUpdated: false
                    };
                }),
                SelectedChannel: {
                    Type: 2,
                    Channel: 1,
                    Frequency: r2c1.frequency,
                    ToBeUpdated: false
                }
            },
            EnableUpload: true
        };
        result.Radios = Radios;
    }
    if (type === "AH-64D_BLK_II") // DTC needs a version set here for the AH-64D
    result.Version = 2;
    return result;
}
function $7f575851fb70de69$var$padDegrees(input) {
    return input.replace(/([A-Z]) (\d{1,2})(°)/, (_, dir, num, deg)=>{
        const padded = num.padStart(3, "0");
        return `${dir} ${padded}${deg}`;
    });
}







const $4a532efbc490c445$var$NoShadowStateButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039))`
  &.MuiIconButton-root {
    box-shadow: none;
    margin-right: 8px;
  }

  border: 1px solid gray !important;
`;
var $4a532efbc490c445$export$2e2bcd8739ae039 = $4a532efbc490c445$var$NoShadowStateButton;


function $794b56692e7edb69$var$DownloadDTCFileButton({ className: className, group: group }) {
    const { data: manifest } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    const { data: tasking } = (0, $a10ff9c4760c9625$export$5c900e05ff5ed627)();
    const { data: groupsWithPlans } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest?.fragOrderID, tasking?.plannedGroups, {
        status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
    });
    if (!groupsWithPlans || !tasking || !manifest) return null;
    const g = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groupsWithPlans, {
        name: group?.name
    });
    if (!g) return null;
    let presets;
    if (g?.plan?.radioOverrides) presets = JSON.parse(g.plan.radioOverrides);
    else if (tasking.radioPresets) presets = (0, $165c1a1c0f22e853$export$5507a3a66b1c2cfb)(g, tasking.radioPresets);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        title: "Download DTC file",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            className: className,
            onClick: ()=>{
                const dtc = (0, $7f575851fb70de69$export$c181bcb10410d4cf)(tasking.theater, (0, $53c885ff43760466$export$ee1d6d1eff24dd98)(tasking.time), g, presets);
                (0, (/*@__PURE__*/$parcel$interopDefault($90f256c567e4c320$exports)))(new Blob([
                    JSON.stringify(dtc, null, 2)
                ], {
                    type: "application/json"
                }), `${g.name}.json`);
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6eefe30025c8ad9a$exports))), {})
        })
    });
}
var $794b56692e7edb69$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($794b56692e7edb69$var$DownloadDTCFileButton).attrs({
    className: $794b56692e7edb69$var$DownloadDTCFileButton.name
})``;



var $ayMG0 = parcelRequire("ayMG0");
var $a4c0ee58e423f6a7$exports = {};
"use strict";

Object.defineProperty($a4c0ee58e423f6a7$exports, "__esModule", {
    value: true
});
$a4c0ee58e423f6a7$exports.default = void 0;

var $a4c0ee58e423f6a7$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a4c0ee58e423f6a7$var$_default = (0, $a4c0ee58e423f6a7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
}), "WebAsset");
$a4c0ee58e423f6a7$exports.default = $a4c0ee58e423f6a7$var$_default;




var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



function $8e4775d1707ca58d$var$OpenDataWindow({ className: className, group: group }) {
    const win = (0, $8396d1566d56485e$export$d3d0694a1d2def88)();
    const openWindow = (0, $8396d1566d56485e$export$b57932fbfac1e18)();
    if (!group) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        className: className,
        title: "View Data",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            active: !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(win.windows, {
                id: group.name
            }),
            onClick: ()=>openWindow(group),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4c0ee58e423f6a7$exports))), {})
        })
    });
}
var $8e4775d1707ca58d$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($8e4775d1707ca58d$var$OpenDataWindow).attrs({
    className: $8e4775d1707ca58d$var$OpenDataWindow.name
})``;



var $ayMG0 = parcelRequire("ayMG0");
var $8993172cb7bc25ee$exports = {};
"use strict";

Object.defineProperty($8993172cb7bc25ee$exports, "__esModule", {
    value: true
});
$8993172cb7bc25ee$exports.default = void 0;

var $8993172cb7bc25ee$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8993172cb7bc25ee$var$_default = (0, $8993172cb7bc25ee$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
}), "GpsFixed");
$8993172cb7bc25ee$exports.default = $8993172cb7bc25ee$var$_default;



parcelRequire("acw62");




function $900511af1dc92622$var$PlanningModeButton({ className: className }) {
    const { state: state } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const plan = (0, $99f46708ff5ed621$export$635e5f346bd462a6)();
    const wm = (0, $8396d1566d56485e$export$d3d0694a1d2def88)();
    const handlePlanningToggle = ()=>{
        if (state.planningMode) {
            plan(false);
            wm.handleClose({
                id: (0, $8396d1566d56485e$export$988a21494ff06fc5).Planning,
                type: (0, $8396d1566d56485e$export$988a21494ff06fc5).Planning
            });
        } else {
            plan(true);
            wm.addWindow({
                id: (0, $8396d1566d56485e$export$988a21494ff06fc5).Planning,
                type: (0, $8396d1566d56485e$export$988a21494ff06fc5).Planning
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        className: className,
        title: "Toggle Planning Mode",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            active: state.planningMode,
            onClick: handlePlanningToggle,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8993172cb7bc25ee$exports))), {})
        })
    });
}
var $900511af1dc92622$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($900511af1dc92622$var$PlanningModeButton).attrs({
    className: $900511af1dc92622$var$PlanningModeButton.name
})``;



var $ayMG0 = parcelRequire("ayMG0");
var $20e4b243ccff587b$exports = {};
"use strict";

Object.defineProperty($20e4b243ccff587b$exports, "__esModule", {
    value: true
});
$20e4b243ccff587b$exports.default = void 0;

var $20e4b243ccff587b$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $20e4b243ccff587b$var$_default = (0, $20e4b243ccff587b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
$20e4b243ccff587b$exports.default = $20e4b243ccff587b$var$_default;




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");





function $26d69e06ab13261e$var$SoloGroupRouteButton({ className: className, group: group }) {
    const { state: { disabledLayers: disabledLayers, tasking: tasking } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const focus = (0, $99f46708ff5ed621$export$59b9dc6fb1cf1292)();
    const toggle = (0, $99f46708ff5ed621$export$90155930613bed46)();
    const layerName = (0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups;
    const relevantDisabledLayers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(disabledLayers, (l)=>{
        return (0, $3f9383da7c35acdb$export$ec0b75c3939f59b7)(l) === layerName;
    });
    const id = (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)(layerName, [
        group?.name
    ]);
    const diff = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).difference(relevantDisabledLayers, [
        id
    ]);
    const isSoloed = disabledLayers.length > 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(disabledLayers, id) && diff.length === disabledLayers.length;
    const handleToggle = $acw62.useCallback(()=>{
        if (isSoloed) {
            const layers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(tasking.plannedGroups, (g)=>{
                return (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                    g.name
                ]);
            });
            toggle(layers, true);
            return;
        }
        focus(group?.name);
    }, [
        group?.name,
        isSoloed
    ]);
    if (!group) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        className: className,
        title: "Solo Route",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            onClick: handleToggle,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($20e4b243ccff587b$exports))), {})
        })
    });
}
var $26d69e06ab13261e$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($26d69e06ab13261e$var$SoloGroupRouteButton).attrs({
    className: $26d69e06ab13261e$var$SoloGroupRouteButton.name
})``;


function $20d61836794ba3f6$var$FlyableGroup({ className: className, group: group }) {
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(group, [
        "units",
        0,
        "type"
    ]);
    const module = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
    const isPlannable = (0, $99f46708ff5ed621$export$9e53ded791f25835)(group.name);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                between: true,
                align: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        group.units.length,
                        "x ",
                        module?.label || type
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginY: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e4775d1707ca58d$export$2e2bcd8739ae039), {
                            group: group
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26d69e06ab13261e$export$2e2bcd8739ae039), {
                            group: group
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $794b56692e7edb69$export$2e2bcd8739ae039), {
                            group: group
                        }),
                        isPlannable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $900511af1dc92622$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
}
var $20d61836794ba3f6$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($20d61836794ba3f6$var$FlyableGroup).attrs({
    className: $20d61836794ba3f6$var$FlyableGroup.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");




function $560c1a590256e122$var$NavPoint({ className: className, point: point, group: group }) {
    const isPlannable = (0, $99f46708ff5ed621$export$9e53ded791f25835)(group);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 2,
                children: point.textComment
            }),
            isPlannable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                align: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $900511af1dc92622$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $560c1a590256e122$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($560c1a590256e122$var$NavPoint).attrs({
    className: $560c1a590256e122$var$NavPoint.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");

function $15515c224272b642$var$OpforGroup({ className: className, group: group }) {
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).countBy(group.units, "type");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                children: "Unit Type"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                children: "Quantity"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rows, (count, type)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    children: type
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    children: count
                                })
                            ]
                        }, type))
                })
            ]
        })
    });
}
var $15515c224272b642$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($15515c224272b642$var$OpforGroup).attrs({
    className: $15515c224272b642$var$OpforGroup.name
})`
  th,
  td {
    padding: 4px;
  }

  tbody td {
    font-size: 12px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



function $e16a96ccd3958221$var$Static({ className: className, group: group }) {
    const { state: { tasking: { theater: theater } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
        x: group.x,
        y: group.y
    });
    const f = (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
        long,
        lat
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                children: f.join("\n")
            })
        })
    });
}
var $e16a96ccd3958221$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($e16a96ccd3958221$var$Static).attrs({
    className: $e16a96ccd3958221$var$Static.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");




function $6e516a70de606564$var$SupportAsset({ className: className, group: group }) {
    const { channel: channel, supportType: supportType } = group;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
            columns: 2,
            pairs: [
                {
                    key: "Support Type",
                    value: supportType
                },
                {
                    key: "Aircraft",
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(group, "units[0].type")
                },
                {
                    key: "Frequency",
                    value: `${(0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(channel?.frequency)} ${channel?.modulation === 0 ? "AM" : "FM"}`
                },
                {
                    key: "TACAN",
                    value: (0, $c255bc447a24c026$export$1cc6625bb95a1f24)(group.units[0], group)
                }
            ]
        })
    });
}
var $6e516a70de606564$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($6e516a70de606564$var$SupportAsset).attrs({
    className: $6e516a70de606564$var$SupportAsset.name
})`
  td {
    padding: 0;
    border-bottom: 0px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");









function $17343e09256faa4e$var$Waypoint({ className: className, waypoint: waypoint, legDistance: legDistance, totalDistance: totalDistance, group: group }) {
    const { state: state } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const isPlannable = (0, $99f46708ff5ed621$export$9e53ded791f25835)(group);
    const g = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(state.tasking.plannedGroups, {
        name: group
    });
    const pairs = [
        {
            key: "Name",
            value: waypoint?.name || waypoint?.number
        },
        {
            key: "Altitude",
            value: `${waypoint && (0, $79e13355954d15ea$export$d284c26147b5ca34)(waypoint.alt).toFixed(0)} ${waypoint?.alt_type === (0, $91a9098e14452db2$export$4b3b082d0b2e2996).MSL ? "MSL" : "AGL"} `
        }
    ];
    if (legDistance) pairs.push({
        key: "Distance (leg)",
        value: `${legDistance?.toFixed(1)} NM`
    });
    if (totalDistance) pairs.push({
        key: "Distance (total)",
        value: `${totalDistance?.toFixed(1)} NM`
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                columns: 2,
                pairs: pairs
            }),
            isPlannable && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                align: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e4775d1707ca58d$export$2e2bcd8739ae039), {
                        group: g
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26d69e06ab13261e$export$2e2bcd8739ae039), {
                        group: g
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $900511af1dc92622$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $17343e09256faa4e$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($17343e09256faa4e$var$Waypoint).attrs({
    className: $17343e09256faa4e$var$Waypoint.name
})`
  td {
    padding: 0;
    border-bottom: 0px;
  }

  pre {
    margin: 0;
  }

  tr:nth-child(2) {
    td {
      vertical-align: top;
    }
  }
`;



class $421f8cc0df78e291$export$5521938a80db9e6e {
    constructor(f){
        this.feature = null;
        this.feature = f;
        this.name = this.name.bind(this);
        this.coordinates = this.coordinates.bind(this);
        this.render = this.render.bind(this);
        this.properties = this.properties.bind(this);
        this.title = this.title.bind(this);
        this.class = this.class.bind(this);
        this.selectable = this.selectable.bind(this);
    }
    name() {
        return this.feature.get("name");
    }
    coordinates() {
        const geom = this.feature.getGeometry();
        if (geom.getType() === "LineString") return geom.getCoordinateAt(0.5);
        if (geom.getType() === "Polygon") return geom.getInteriorPoint().getCoordinates();
        if (geom.getType() === "Circle") return geom.getCenter();
        return geom.getCoordinates();
    }
    render() {
        const type = this.feature.get("featureClass");
        const props = this.feature.getProperties();
        switch(type){
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).FlyableGroup:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $20d61836794ba3f6$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).SupportAsset:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e516a70de606564$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).Airbase:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $690458fd8db35481$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).OPFORGroups:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $15515c224272b642$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $17343e09256faa4e$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).NavPoint:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $560c1a590256e122$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).Static:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e16a96ccd3958221$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).Bullseye:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d59e282e16833671$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).ControlPoint:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f1f54eceadee9a7b$export$2e2bcd8739ae039), props);
            case (0, $91a9098e14452db2$export$589bf38da6f496d9).ControlMeasure:
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76ac0c10b812f0bc$export$2e2bcd8739ae039), props);
            default:
                return null;
        }
    }
    properties() {
        return this.feature.getProperties();
    }
    title() {
        return this.feature.get("name");
    }
    class() {
        return this.feature.get("featureClass");
    }
    selectable() {
        // using the inverse so that this is an opt-out instead of opt-in
        const unselectable = this.feature.get("unselectable");
        return typeof unselectable === "undefined" || unselectable === false;
    }
}



class $356d5fa1b1c7c9b9$export$2e2bcd8739ae039 extends (0, $421f8cc0df78e291$export$5521938a80db9e6e) {
    group() {
        return this.feature.get("group");
    }
    textComment() {
        return this.feature.get("point").textComment;
    }
    index() {
        return this.feature.get("point").index;
    }
}



var $f1q41 = parcelRequire("f1q41");





class $0cfb673144ee3a1c$export$2e2bcd8739ae039 extends (0, $421f8cc0df78e291$export$5521938a80db9e6e) {
    constructor(f){
        super(f);
        this.title = this.title.bind(this);
        this.group = this.group.bind(this);
    }
    title() {
        return `${this.feature.get("group")} Waypoint ${this.feature.get("number")}`;
    }
    group() {
        return this.feature.get("group");
    }
    toOLPointFeature(theater, allwp) {
        const wp = this.properties();
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, wp);
        const geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
            long,
            lat
        ]);
        // Show waypoint names if they are meaninful.
        // If they are just numbers, hide them.
        const name = wp.name || wp.number.toString();
        const last = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(allwp, {
            number: wp.number - 1
        });
        let d = null;
        let total = null;
        if (last) {
            d = (0, $53c885ff43760466$export$9f17032d917177de)(theater, last, wp);
            total = (0, $53c885ff43760466$export$c883c0766fae79f3)(theater, wp, allwp);
        }
        return {
            geometry: geometry,
            group: this.group(),
            featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint,
            name: name,
            number: wp.number,
            type: wp.type,
            title: `${this.group()} Waypoint ${wp.number}`,
            uniqID: (0, $f1q41.uniqueId)(this.group()),
            altitude: wp.alt,
            altitudeType: wp.alt_type,
            eta: wp.ETA,
            speed: wp.speed,
            waypoint: wp,
            legDistance: d,
            totalDistance: total
        };
    }
}


function $119c634bd0a30bc2$export$3f88ccaa41f1ca7a(f) {
    if (f.get("featureClass") === (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint) return new (0, $0cfb673144ee3a1c$export$2e2bcd8739ae039)(f);
    if (f.get("featureClass") === (0, $91a9098e14452db2$export$589bf38da6f496d9).NavPoint) return new (0, $356d5fa1b1c7c9b9$export$2e2bcd8739ae039)(f);
    return new (0, $421f8cc0df78e291$export$5521938a80db9e6e)(f);
}




function $e8542b590c5a8fca$export$2e2bcd8739ae039(ref) {
    // @ts-ignore
    ref.addEventListener("contextmenu", (event)=>event.preventDefault());
    const map = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)({
        target: ref
    });
    const interactions = map.getInteractions();
    const defaultDragPans = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(interactions.getArray(), (i)=>i instanceof (0, $c11585da26a016db$export$2e2bcd8739ae039));
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(defaultDragPans, (d)=>map.removeInteraction(d));
    map.addInteraction(new (0, $c11585da26a016db$export$2e2bcd8739ae039)({
        condition: function(event) {
            if ((0, $edf87b50170125f7$export$e74de664a571d084)(event)) return true;
            return (0, $9c554d6df7d74017$export$8a7ef89a0633946c)(event);
        }
    }));
    return map;
}
function $e8542b590c5a8fca$export$3aa9cca608759cfa(map, layerName) {
    const layers = map.getLayers();
    const layer = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(layers.getArray(), (l)=>{
        if (!l) return;
        const name = l.get("name");
        return name === layerName;
    });
    return layer;
}
function $e8542b590c5a8fca$export$43f5354f3d355747(map, layerName, name, featureClass) {
    if (!map) return null;
    let layer = $e8542b590c5a8fca$export$3aa9cca608759cfa(map, layerName);
    if (!layer) return null;
    const source = layer.getSource();
    if (!source || !source.getFeatures) return null;
    const features = source.getFeatures();
    let feature = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(features, (f)=>f.get("name") === name);
    if (featureClass === (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint) feature = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(features, (f)=>f.get("number") === name);
    if (!feature) return null;
    return (0, $119c634bd0a30bc2$export$3f88ccaa41f1ca7a)(feature);
}




var $ayMG0 = parcelRequire("ayMG0");
var $b62e8e213130dab6$exports = {};
"use strict";

Object.defineProperty($b62e8e213130dab6$exports, "__esModule", {
    value: true
});
$b62e8e213130dab6$exports.default = void 0;

var $b62e8e213130dab6$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b62e8e213130dab6$var$_default = (0, $b62e8e213130dab6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H9V4h9v12zM3 15v-2h2v2H3zm0-5.5h2v2H3v-2zM10 20h2v2h-2v-2zm-7-1.5v-2h2v2H3zM5 22c-1.1 0-2-.9-2-2h2v2zm3.5 0h-2v-2h2v2zm5 0v-2h2c0 1.1-.9 2-2 2zM5 6v2H3c0-1.1.9-2 2-2z"
}), "CopyAll");
$b62e8e213130dab6$exports.default = $b62e8e213130dab6$var$_default;


var $3e21277543f7c25a$exports = {};
"use strict";

Object.defineProperty($3e21277543f7c25a$exports, "__esModule", {
    value: true
});
$3e21277543f7c25a$exports.default = void 0;

var $3e21277543f7c25a$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $3e21277543f7c25a$var$_default = (0, $3e21277543f7c25a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");
$3e21277543f7c25a$exports.default = $3e21277543f7c25a$var$_default;


var $cbce43614cfca6bb$exports = {};
"use strict";

Object.defineProperty($cbce43614cfca6bb$exports, "__esModule", {
    value: true
});
$cbce43614cfca6bb$exports.default = void 0;

var $cbce43614cfca6bb$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $cbce43614cfca6bb$var$_default = (0, $cbce43614cfca6bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");
$cbce43614cfca6bb$exports.default = $cbce43614cfca6bb$var$_default;




var $f1q41 = parcelRequire("f1q41");
/**
 * @module ol/Overlay
 */ 





/**
 * @typedef {'bottom-left' | 'bottom-center' | 'bottom-right' | 'center-left' | 'center-center' | 'center-right' | 'top-left' | 'top-center' | 'top-right'} Positioning
 * The overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, or `'top-right'`.
 */ /**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {Positioning} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */ /**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */ /**
 * @enum {string}
 * @protected
 */ const $c80d3ed2a84f41ed$var$Property = {
    ELEMENT: "element",
    MAP: "map",
    OFFSET: "offset",
    POSITION: "position",
    POSITIONING: "positioning"
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */ /**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay.js';
 *
 *     // ...
 *     const popup = new Overlay({
 *       element: document.getElementById('popup'),
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ class $c80d3ed2a84f41ed$var$Overlay extends (0, $b68b3d6e32e3074a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Overlay options.
   */ constructor(options){
        super();
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {OverlayOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {Options}
     */ this.options = options;
        /**
     * @protected
     * @type {number|string|undefined}
     */ this.id = options.id;
        /**
     * @protected
     * @type {boolean}
     */ this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
     * @protected
     * @type {boolean}
     */ this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = document.createElement("div");
        this.element.className = options.className !== undefined ? options.className : "ol-overlay-container " + (0, $ce07df6d5d4656f1$export$99b49471b0394319);
        this.element.style.position = "absolute";
        this.element.style.pointerEvents = "auto";
        /**
     * @protected
     * @type {PanIntoViewOptions|undefined}
     */ this.autoPan = options.autoPan === true ? {} : options.autoPan || undefined;
        /**
     * @protected
     * @type {{transform_: string,
     *         visible: boolean}}
     */ this.rendered = {
            transform_: "",
            visible: true
        };
        /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */ this.mapPostrenderListenerKey = null;
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.ELEMENT, this.handleElementChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.MAP, this.handleMapChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.OFFSET, this.handleOffsetChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITION, this.handlePositionChanged);
        this.addChangeListener($c80d3ed2a84f41ed$var$Property.POSITIONING, this.handlePositioningChanged);
        if (options.element !== undefined) this.setElement(options.element);
        this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        this.setPositioning(options.positioning || "top-left");
        if (options.position !== undefined) this.setPosition(options.position);
    }
    /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */ getElement() {
        return /** @type {HTMLElement|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.ELEMENT);
    }
    /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id;
    }
    /**
   * Get the map associated with this overlay.
   * @return {import("./Map.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */ getMap() {
        return /** @type {import("./Map.js").default|null} */ this.get($c80d3ed2a84f41ed$var$Property.MAP) || null;
    }
    /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */ getOffset() {
        return /** @type {Array<number>} */ this.get($c80d3ed2a84f41ed$var$Property.OFFSET);
    }
    /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */ getPosition() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($c80d3ed2a84f41ed$var$Property.POSITION);
    }
    /**
   * Get the current positioning of this overlay.
   * @return {Positioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */ getPositioning() {
        return /** @type {Positioning} */ this.get($c80d3ed2a84f41ed$var$Property.POSITIONING);
    }
    /**
   * @protected
   */ handleElementChanged() {
        (0, $075f937d7366f1a2$export$1e1c9bf5a4ffe0d1)(this.element);
        const element = this.getElement();
        if (element) this.element.appendChild(element);
    }
    /**
   * @protected
   */ handleMapChanged() {
        if (this.mapPostrenderListenerKey) {
            this.element?.remove();
            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        const map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(map, (0, $e4ad75f913b6f7ff$export$2e2bcd8739ae039).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            const container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
            this.performAutoPan();
        }
    }
    /**
   * @protected
   */ render() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handleOffsetChanged() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handlePositionChanged() {
        this.updatePixelPosition();
        this.performAutoPan();
    }
    /**
   * @protected
   */ handlePositioningChanged() {
        this.updatePixelPosition();
    }
    /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */ setElement(element) {
        this.set($c80d3ed2a84f41ed$var$Property.ELEMENT, element);
    }
    /**
   * Set the map to be associated with this overlay.
   * @param {import("./Map.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */ setMap(map) {
        this.set($c80d3ed2a84f41ed$var$Property.MAP, map);
    }
    /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */ setOffset(offset) {
        this.set($c80d3ed2a84f41ed$var$Property.OFFSET, offset);
    }
    /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */ setPosition(position) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITION, position);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */ performAutoPan() {
        if (this.autoPan) this.panIntoView(this.autoPan);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [panIntoViewOptions] Options for the pan action
   * @api
   */ panIntoView(panIntoViewOptions) {
        const map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get($c80d3ed2a84f41ed$var$Property.POSITION)) return;
        const mapRect = this.getRect(map.getTargetElement(), map.getSize());
        const element = this.getElement();
        const overlayRect = this.getRect(element, [
            (0, $075f937d7366f1a2$export$e823f88e4111159a)(element),
            (0, $075f937d7366f1a2$export$fc5b8aac72846d1e)(element)
        ]);
        panIntoViewOptions = panIntoViewOptions || {};
        const myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!(0, $6da4c8ed3074c92b$export$be866b1e0809b17e)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            const offsetLeft = overlayRect[0] - mapRect[0];
            const offsetRight = mapRect[2] - overlayRect[2];
            const offsetTop = overlayRect[1] - mapRect[1];
            const offsetBottom = mapRect[3] - overlayRect[3];
            const delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - myMargin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + myMargin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - myMargin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + myMargin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                const center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenterInternal();
                const centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) return;
                const newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                const panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing
                });
            }
        }
    }
    /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */ getRect(element, size) {
        const box = element.getBoundingClientRect();
        const offsetX = box.left + window.pageXOffset;
        const offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    }
    /**
   * Set the positioning for this overlay.
   * @param {Positioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */ setPositioning(positioning) {
        this.set($c80d3ed2a84f41ed$var$Property.POSITIONING, positioning);
    }
    /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */ setVisible(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? "" : "none";
            this.rendered.visible = visible;
        }
    }
    /**
   * Update pixel position.
   * @protected
   */ updatePixelPosition() {
        const map = this.getMap();
        const position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        const pixel = map.getPixelFromCoordinate(position);
        const mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    }
    /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */ updateRenderedPosition(pixel, mapSize) {
        const style = this.element.style;
        const offset = this.getOffset();
        const positioning = this.getPositioning();
        this.setVisible(true);
        const x = Math.round(pixel[0] + offset[0]) + "px";
        const y = Math.round(pixel[1] + offset[1]) + "px";
        let posX = "0%";
        let posY = "0%";
        if (positioning == "bottom-right" || positioning == "center-right" || positioning == "top-right") posX = "-100%";
        else if (positioning == "bottom-center" || positioning == "center-center" || positioning == "top-center") posX = "-50%";
        if (positioning == "bottom-left" || positioning == "bottom-center" || positioning == "bottom-right") posY = "-100%";
        else if (positioning == "center-left" || positioning == "center-center" || positioning == "center-right") posY = "-50%";
        const transform = `translate(${posX}, ${posY}) translate(${x}, ${y})`;
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
        }
    }
    /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */ getOptions() {
        return this.options;
    }
}
var $c80d3ed2a84f41ed$export$2e2bcd8739ae039 = $c80d3ed2a84f41ed$var$Overlay;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");





var $f1q41 = parcelRequire("f1q41");

const $a48a327511f3c8e6$export$2963449ce9583ad5 = "__internal_terrain_height";
// https://openlayers.org/en/latest/examples/interpolation.html
function $a48a327511f3c8e6$var$getHeight(rgba) {
    if (!rgba) return 0;
    return -10000 + (rgba[0] * 65536 + rgba[1] * 256 + rgba[2]) * 0.1;
}
function $a48a327511f3c8e6$export$70467d14cb8c16f8(map, coords) {
    // We get the terrain height layer here to keep the presentation uniform
    // with the over mouse position stuff.
    const elevationLayer = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(map.getLayers().getArray(), (l)=>l.get("name") === $a48a327511f3c8e6$export$2963449ce9583ad5);
    const px = map.getPixelFromCoordinate(coords);
    const d = elevationLayer.getData(px);
    const elevation = $a48a327511f3c8e6$var$getHeight(d);
    return elevation;
}
function $a48a327511f3c8e6$export$1b3e02615f43c5ec(theater, wp, allwp) {
    const prev = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(allwp, {
        number: wp.number - 1
    });
    let leg = null;
    let total = null;
    if (prev) {
        leg = (0, $53c885ff43760466$export$9f17032d917177de)(theater, prev, wp);
        total = (0, $53c885ff43760466$export$c883c0766fae79f3)(theater, wp, allwp);
    }
    return {
        leg: leg,
        total: total
    };
}
// https://blog.onethinglab.com/openlayers-align-label-with-line-feature/
function $a48a327511f3c8e6$var$radians(n) {
    return n * (Math.PI / 180);
}
function $a48a327511f3c8e6$var$degrees(n) {
    return n * (180 / Math.PI);
}
function $a48a327511f3c8e6$export$ff318d6e318fce97(start_lat, start_long, end_lat, end_long) {
    start_lat = $a48a327511f3c8e6$var$radians(start_lat);
    start_long = $a48a327511f3c8e6$var$radians(start_long);
    end_lat = $a48a327511f3c8e6$var$radians(end_lat);
    end_long = $a48a327511f3c8e6$var$radians(end_long);
    var dlong = end_long - start_long;
    var dphi = Math.log(Math.tan(end_lat / 2.0 + Math.PI / 4.0) / Math.tan(start_lat / 2.0 + Math.PI / 4.0));
    if (Math.abs(dlong) > Math.PI) {
        if (dlong > 0.0) dlong = -(2.0 * Math.PI - dlong);
        else dlong = 2.0 * Math.PI + dlong;
    }
    return ($a48a327511f3c8e6$var$degrees(Math.atan2(dlong, dphi)) + 360.0) % 360.0;
}
function $a48a327511f3c8e6$var$bearingToRadians(br) {
    return $a48a327511f3c8e6$var$radians((450 - br) % 360);
}
function $a48a327511f3c8e6$export$2e1e9e0c5142c9d7(pt0, pt1, br) {
    var rotate = pt0[0] > pt1[0] ? Math.PI : 0;
    return $a48a327511f3c8e6$var$bearingToRadians(br) + rotate;
}






var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
var $a0d51cf792fe2bb1$exports = {};
"use strict";

Object.defineProperty($a0d51cf792fe2bb1$exports, "__esModule", {
    value: true
});
$a0d51cf792fe2bb1$exports.default = void 0;

var $a0d51cf792fe2bb1$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a0d51cf792fe2bb1$var$_default = (0, $a0d51cf792fe2bb1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7.77 18.39 18H5.61L12 7.77M12 4 2 20h20L12 4z"
}), "ChangeHistory");
$a0d51cf792fe2bb1$exports.default = $a0d51cf792fe2bb1$var$_default;



parcelRequire("acw62");



function $58eee85040d1a07e$var$NavTargetPointsButton({ className: className, groupName: groupName }) {
    const nav = (0, $99f46708ff5ed621$export$9e35e8a90270fdf6)();
    const handleClick = ()=>{
        nav.toggleAddMode(true, groupName);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        className: className,
        title: "Add Nav Target Point",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            onClick: handleClick,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a0d51cf792fe2bb1$exports))), {})
        })
    });
}
var $58eee85040d1a07e$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($58eee85040d1a07e$var$NavTargetPointsButton).attrs({
    className: $58eee85040d1a07e$var$NavTargetPointsButton.name
})``;



function $3bccad2fb478df57$var$NavPointPlanningTools({ className: className, feature: feature }) {
    const [form, setForm] = $acw62.useState({
        textComment: feature?.textComment()
    });
    const blur = (0, $99f46708ff5ed621$export$19df1d269fc1c6e9)();
    const renderInput = feature?.textComment();
    const nav = (0, $99f46708ff5ed621$export$9e35e8a90270fdf6)();
    const handleBlur = ()=>{
        nav.updateNavPointText(feature?.group(), feature?.index(), form.textComment);
    };
    const handleDelete = ()=>{
        nav.deleteNavPoint(feature?.group(), feature?.index());
        blur();
    };
    $acw62.useEffect(()=>{
        setForm({
            textComment: feature?.textComment()
        });
    }, [
        feature
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            renderInput && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        py: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            wide: true,
                            align: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                onClick: handleDelete,
                                size: "small",
                                variant: "outlined",
                                color: "primary",
                                children: "Delete"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                                    children: "Text Comment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    multiline: true,
                                    onBlur: handleBlur,
                                    value: form.textComment,
                                    onChange: (e)=>setForm({
                                            ...form,
                                            textComment: e.target.value
                                        })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $900511af1dc92622$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58eee85040d1a07e$export$2e2bcd8739ae039), {
                groupName: feature.group()
            })
        ]
    });
}
var $3bccad2fb478df57$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($3bccad2fb478df57$var$NavPointPlanningTools).attrs({
    className: $3bccad2fb478df57$var$NavPointPlanningTools.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $7aeaea8c78c744f5$exports = {};
"use strict";

Object.defineProperty($7aeaea8c78c744f5$exports, "__esModule", {
    value: true
});
$7aeaea8c78c744f5$exports.default = void 0;

var $7aeaea8c78c744f5$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7aeaea8c78c744f5$var$_default = (0, $7aeaea8c78c744f5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
}), "Input");
$7aeaea8c78c744f5$exports.default = $7aeaea8c78c744f5$var$_default;






var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");



function $7e85fd8fda59dc4a$var$CoordinatesInput({ className: className, initialValue: initialValue, onSubmit: onSubmit, onClose: onClose }) {
    const [errors, setErrors] = $acw62.useState({
        mgrs: null,
        latlong: null
    });
    const coords = initialValue?.coordinates();
    let initialState;
    const { lat: lat, long: long, mgrs: mgrs } = (0, $79e13355954d15ea$export$3b6b44ca42529cf5)([
        coords[0],
        coords[1]
    ]);
    if (coords) initialState = {
        latitude: lat,
        longitude: long,
        mgrs: mgrs
    };
    else initialState = {
        latitude: "",
        longitude: "",
        mgrs: ""
    };
    const [state, setState] = $acw62.useState(initialState);
    const handleChange = (field, value)=>{
        setState({
            ...state,
            [field]: value
        });
    };
    const handleBlur = $acw62.useCallback((field)=>{
        if (field === "mgrs") {
            try {
                const { long: long, lat: lat } = (0, $79e13355954d15ea$export$9175a52f61945120)(state.mgrs);
                const { lat: latF, long: longF, mgrs: mgrsF } = (0, $79e13355954d15ea$export$3b6b44ca42529cf5)([
                    long,
                    lat
                ]);
                setState({
                    ...state,
                    latitude: latF,
                    longitude: longF,
                    mgrs: mgrsF
                });
            } catch (e) {
                setErrors({
                    ...errors,
                    mgrs: "Invalid MGRS"
                });
            }
            setErrors({
                ...errors,
                mgrs: null
            });
            return;
        }
        try {
            const { latitude: latitude, longitude: longitude } = (0, $79e13355954d15ea$export$983094a1b3fd35c5)(`${state.latitude} ${state.longitude}`);
            const { lat: lat, long: long, mgrs: mgrs } = (0, $79e13355954d15ea$export$3b6b44ca42529cf5)([
                longitude,
                latitude
            ]);
            setState({
                ...state,
                latitude: lat,
                longitude: long,
                mgrs: mgrs
            });
        } catch (e) {
            setErrors({
                ...errors,
                latlong: "Inavlid Lat/Long"
            });
        }
    }, [
        state
    ]);
    const handleSubmit = (e)=>{
        e.preventDefault();
        try {
            const { latitude: latitude, longitude: longitude } = (0, $79e13355954d15ea$export$983094a1b3fd35c5)(`${state.latitude} ${state.longitude}`);
            onSubmit({
                lat: latitude,
                long: longitude
            });
        } catch (e) {
            setErrors({
                ...errors,
                latlong: "Invalid Lat/Long"
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mb: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                align: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    onChange: (e)=>handleChange("latitude", e.target.value),
                                    label: "Latitude",
                                    value: state.latitude,
                                    onBlur: ()=>handleBlur("latitude"),
                                    error: !!errors.latlong,
                                    helperText: errors?.latlong
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mb: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                onChange: (e)=>handleChange("longitude", e.target.value),
                                label: "Longitude",
                                value: state.longitude,
                                onBlur: ()=>handleBlur("longitude"),
                                error: !!errors.latlong,
                                helperText: errors?.latlong
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    mb: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                        onChange: (e)=>handleChange("mgrs", e.target.value),
                        label: "MGRS",
                        value: state.mgrs,
                        onBlur: ()=>handleBlur("mgrs"),
                        error: !!errors.mgrs,
                        helperText: errors.mgrs
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        align: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                disabled: !!errors.latlong || !!errors.mgrs,
                                variant: "contained",
                                type: "submit",
                                children: "Submit"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                ml: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    onClick: onClose,
                                    variant: "outlined",
                                    children: "Cancel"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $7e85fd8fda59dc4a$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($7e85fd8fda59dc4a$var$CoordinatesInput).attrs({
    className: $7e85fd8fda59dc4a$var$CoordinatesInput.name
})``;




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

const $35112c070f73202a$var$modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 0
};
function $35112c070f73202a$var$Content({ className: className, children: children, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        ...rest,
        sx: $35112c070f73202a$var$modalStyle,
        className: className,
        children: children
    });
}
const $35112c070f73202a$var$Styled = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($35112c070f73202a$var$Content).attrs({
    className: $35112c070f73202a$var$Content.name
})``;
// eslint-disable-next-line
const $35112c070f73202a$var$ModalContent = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)($35112c070f73202a$var$Styled, {
        ...props
    }));
var $35112c070f73202a$export$2e2bcd8739ae039 = $35112c070f73202a$var$ModalContent;







var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");




function $0bfaa97c0933cbe0$var$PlanningDataEntryButton({ className: className, groupName: groupName }) {
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const handleToggle = $acw62.useCallback(()=>{
        const q = new URLSearchParams(window.location.search);
        q.set("window", (0, $8396d1566d56485e$export$988a21494ff06fc5).DataEntry);
        q.set("group", encodeURIComponent(groupName));
        history.push({
            search: q.toString(),
            location: window.location.pathname
        });
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        className: className,
        title: "Open Data Entry",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            onClick: handleToggle,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {})
        })
    });
}
var $0bfaa97c0933cbe0$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($0bfaa97c0933cbe0$var$PlanningDataEntryButton).attrs({
    className: $0bfaa97c0933cbe0$var$PlanningDataEntryButton.name
})``;






var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


function $f414792c5b1c90fa$var$TimeOnTargetInput({ className: className, eta: eta, onChange: onChange, valid: isValid }) {
    const hours = Math.floor(eta / 60 / 60);
    const minutes = Math.floor((eta - hours * 3600) / 60);
    const seconds = eta - hours * 3600 - minutes * 60;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                paddingBottom: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    fontSize: 12,
                    children: "Time on Target (from start)"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                align: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            error: !isValid,
                            onChange: (ev)=>{
                                let val = parseInt(ev.target.value);
                                if (isNaN(val)) val = 0;
                                const nextEta = val * 3600 + minutes * 60 + seconds;
                                onChange(nextEta, isValid);
                            },
                            type: "number",
                            label: "Hours",
                            value: hours,
                            style: {
                                width: 72
                            },
                            size: "small",
                            variant: "outlined",
                            inputProps: {
                                "data-testid": "time-on-target-input-hours"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginX: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: ":"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            error: !isValid,
                            onChange: (ev)=>{
                                let val = parseInt(ev.target.value);
                                if (isNaN(val)) val = 0;
                                const nextEta = hours * 3600 + val * 60 + seconds;
                                onChange(nextEta, isValid);
                            },
                            type: "number",
                            label: "Minutes",
                            value: minutes,
                            style: {
                                width: 72
                            },
                            size: "small",
                            variant: "outlined",
                            inputProps: {
                                "data-testid": "time-on-target-input-minutes"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginX: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: ":"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            error: !isValid,
                            onChange: (ev)=>{
                                let val = parseInt(ev.target.value);
                                if (isNaN(val)) val = 0;
                                const nextEta = hours * 3600 + minutes * 60 + val;
                                onChange(nextEta, isValid);
                            },
                            type: "number",
                            label: "Seconds",
                            value: seconds,
                            style: {
                                width: 72
                            },
                            size: "small",
                            variant: "outlined",
                            inputProps: {
                                "data-testid": "time-on-target-input-seconds"
                            }
                        })
                    })
                ]
            }),
            !isValid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                error: true,
                children: "Must be after previous waypoint Time on Target"
            })
        ]
    });
}
var $f414792c5b1c90fa$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($f414792c5b1c90fa$var$TimeOnTargetInput).attrs({
    className: $f414792c5b1c90fa$var$TimeOnTargetInput.name
})``;


function $4e74c72e16f1e37b$var$WaypointInput({ className: className, controller: controller, feature: feature, missionStart: missionStart, theater: theater }) {
    const [inputVals, setValsState] = $acw62.useState($4e74c72e16f1e37b$var$defaultVals(feature));
    const wpNum = feature?.properties()?.number;
    const tot = (0, $53c885ff43760466$export$7230f5ee2063b315)(missionStart, inputVals.eta || 0);
    const allWaypoints = controller?.getWaypointsForGroup(feature.group()) || [];
    const totValid = $4e74c72e16f1e37b$var$isValidToT(inputVals.eta, feature, allWaypoints);
    $acw62.useEffect(()=>{
        setValsState($4e74c72e16f1e37b$var$defaultVals(feature));
    }, [
        feature,
        feature?.properties()?.eta
    ]);
    const updateWaypoint = (vals)=>{
        const altitude = $4e74c72e16f1e37b$var$formatAlt(vals.altitude);
        const meters = (0, $79e13355954d15ea$export$76afc266724c5901)(altitude);
        const next = {
            ...vals,
            altitude: meters
        };
        if ($4e74c72e16f1e37b$var$isValidToT(vals.eta, feature, allWaypoints)) next.eta = vals.eta;
        controller.setWaypointDetails(feature.group(), wpNum, next);
        setValsState({
            ...vals,
            eta: next.eta
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: className,
        component: "form",
        marginY: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                paddingBottom: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    fontSize: 12,
                    children: "Waypoint Details"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginBottom: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    autoComplete: "off",
                                    onBlur: (ev)=>{
                                        updateWaypoint({
                                            ...inputVals,
                                            text: ev.target.value
                                        });
                                    },
                                    label: "Name",
                                    id: "name",
                                    value: inputVals.text,
                                    onChange: (ev)=>{
                                        setValsState({
                                            ...inputVals,
                                            text: ev.target.value
                                        });
                                    },
                                    size: "small",
                                    variant: "outlined",
                                    placeholder: "Name"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        align: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                marginRight: 1,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                        type: "number",
                                        label: "Altitude",
                                        id: "altitude",
                                        value: inputVals.altitude,
                                        onChange: (ev)=>{
                                            updateWaypoint({
                                                ...inputVals,
                                                altitude: ev.target.value
                                            });
                                        },
                                        size: "small",
                                        variant: "outlined",
                                        placeholder: "Altitude"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                size: "small",
                                value: inputVals.altitudeType === (0, $91a9098e14452db2$export$4b3b082d0b2e2996).AGL ? (0, $91a9098e14452db2$export$4b3b082d0b2e2996).AGL : (0, $91a9098e14452db2$export$4b3b082d0b2e2996).MSL,
                                onChange: (ev)=>updateWaypoint({
                                        ...inputVals,
                                        altitudeType: ev.target.value
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: (0, $91a9098e14452db2$export$4b3b082d0b2e2996).AGL,
                                        children: "AGL"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                        value: (0, $91a9098e14452db2$export$4b3b082d0b2e2996).MSL,
                                        children: "MSL"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    marginTop: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f414792c5b1c90fa$export$2e2bcd8739ae039), {
                            valid: totValid,
                            eta: inputVals.eta,
                            onChange: (val)=>{
                                updateWaypoint({
                                    ...inputVals,
                                    eta: val
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginY: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    fontSize: 12,
                                    children: "Time on Target (zulu/local)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                        between: true,
                                        wide: true,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            fontWeight: 600,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    "data-testid": "zulu-time",
                                                    children: tot.minus({
                                                        hours: (0, $e1dc1ccf277543ba$export$59c99f3515d3493f)(theater)
                                                    }).toFormat("HH:mm:ss")
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        marginLeft: 8,
                                                        marginRight: 8
                                                    },
                                                    children: "/"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    "data-testid": "local-time",
                                                    children: tot.toFormat("HH:mm:ss")
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $4e74c72e16f1e37b$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($4e74c72e16f1e37b$var$WaypointInput).attrs({
    className: $4e74c72e16f1e37b$var$WaypointInput.name
})`
  width: 360px;
`;
function $4e74c72e16f1e37b$var$defaultVals(f) {
    const feature = f.properties();
    const alt = typeof feature?.altitude !== "undefined" ? feature?.altitude : "0";
    const num = feature?.number;
    const text = feature?.name && feature?.name !== num?.toString() ? feature?.name : num?.toString();
    return {
        text: text,
        altitude: (0, $79e13355954d15ea$export$d284c26147b5ca34)(alt).toFixed(0).toString(),
        altitudeType: feature?.altitudeType || (0, $91a9098e14452db2$export$4b3b082d0b2e2996).AGL,
        eta: Math.floor(feature.eta)
    };
}
const $4e74c72e16f1e37b$var$formatAlt = (altString)=>{
    return Math.floor(parseFloat(altString));
};
function $4e74c72e16f1e37b$var$isValidToT(eta, feature, waypoints) {
    const prev = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(waypoints, {
        number: feature.properties().number - 1
    });
    if (!prev || !prev.waypoint?.ETA) return eta > 0;
    return eta > prev.waypoint.ETA;
}


function $8c871a0fbeb5ceb6$var$PlanningHopupTools({ className: className, feature: feature }) {
    const [coordsEntryOpen, setCoordsEntryOpen] = $acw62.useState(false);
    const { dispatch: dispatch, state: state, controller: controller } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const copy = (0, $92839c6c950486dc$export$ec5b24de8874d406)();
    const [importAnchor, setImportAnchor] = $acw62.useState(null);
    const n = feature?.properties().number;
    const isGroupIconFeature = !n;
    const isWaypoint = feature?.class() === (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint;
    const isEditableFeature = isWaypoint && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(state.userPlannableGroups, feature?.group()) && n > 0;
    const renderButtons = isGroupIconFeature || isEditableFeature;
    const isFirst = n === 0;
    const disableDelete = isGroupIconFeature || isFirst;
    const renderInputs = isEditableFeature && !isFirst;
    const featureNumber = isGroupIconFeature ? 0 : n;
    const wps = isWaypoint ? controller?.current?.getWaypointsForGroup(feature?.group()) : controller?.current?.getWaypointsForGroup(feature?.name()) || [];
    const handleAdd = ()=>{
        controller.current.toggleAddMode(true, feature.group ? feature?.group() : feature.name(), n || 0);
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).blurFeature
        });
    };
    const handleArrowClick = (inc)=>{
        const num = featureNumber + inc;
        if (num === 0) {
            dispatch({
                type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
                layerName: (0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups,
                name: feature?.group(),
                otherFeatures: []
            });
            return;
        }
        if (isGroupIconFeature) {
            // We are looking at the group details here.
            // Find the first waypoint and set as next feature.
            const wp = controller.current.findWaypointForGroup(feature?.name(), 1);
            if (!wp) return;
            dispatch({
                type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
                layerName: feature?.name(),
                name: wp.get("name"),
                otherFeatures: []
            });
            return;
        }
        const next = controller.current.findWaypointForGroup(feature?.group(), num);
        if (!next) throw new Error("Could not find next waypoint");
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
            layerName: feature?.group(),
            name: next.get("name"),
            otherFeatures: []
        });
    };
    const handleRemove = ()=>{
        controller.current.removeWaypoint(feature.group(), n);
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).blurFeature
        });
    };
    const group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(state.tasking.plannedGroups, {
        name: feature?.name() || feature?.group()
    });
    const handleImportClick = $acw62.useCallback((sourceGroupName)=>{
        if (!group) return;
        copy(sourceGroupName, group.name);
        setImportAnchor(null);
    }, [
        group
    ]);
    const handleCoordsSubmit = (coords)=>{
        controller.current.setWaypointCoords(feature.group(), featureNumber, [
            coords.long,
            coords.lat
        ]);
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
            layerName: feature.group(),
            name: feature.name(),
            otherFeatures: []
        });
        setCoordsEntryOpen(false);
    };
    const mod = (0, $b9c9d9c1adf94aca$export$8e159f10abc1bae9)(group);
    const renderNavPointInput = isGroupIconFeature && mod?.supportsNavPoints;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            !state.planningMode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                children: feature?.render()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    position: "absolute",
                    right: 8,
                    top: 24
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                        disabled: featureNumber === 0,
                        onClick: ()=>handleArrowClick(-1),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3e21277543f7c25a$exports))), {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                        disabled: featureNumber === wps?.length - 1,
                        onClick: ()=>handleArrowClick(1),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cbce43614cfca6bb$exports))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            renderButtons && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                align: true,
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginRight: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            onClick: handleAdd,
                            size: "small",
                            variant: "contained",
                            children: "Add Waypoint"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginRight: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            disabled: disableDelete,
                            onClick: handleRemove,
                            size: "small",
                            variant: "outlined",
                            children: "Delete"
                        })
                    }),
                    isEditableFeature && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                            title: "Edit Coordinates",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
                                style: {
                                    height: 36,
                                    width: 36
                                },
                                onClick: ()=>setCoordsEntryOpen(true),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {})
                            })
                        })
                    })
                ]
            }),
            renderInputs && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e74c72e16f1e37b$export$2e2bcd8739ae039), {
                controller: controller.current,
                feature: feature,
                missionStart: (0, $53c885ff43760466$export$ee1d6d1eff24dd98)(state.tasking.time),
                theater: state.tasking.theater
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginTop: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e4775d1707ca58d$export$2e2bcd8739ae039), {
                            group: group
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26d69e06ab13261e$export$2e2bcd8739ae039), {
                            group: group
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $794b56692e7edb69$export$2e2bcd8739ae039), {
                            group: group
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $900511af1dc92622$export$2e2bcd8739ae039), {}),
                        !renderInputs && /*#__PURE__*/ (0, $ayMG0.jsx)($8c871a0fbeb5ceb6$var$CopyButton, {
                            onClick: (e)=>setImportAnchor(e.target)
                        }),
                        !renderInputs && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bfaa97c0933cbe0$export$2e2bcd8739ae039), {
                            groupName: group?.name
                        }),
                        renderNavPointInput && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58eee85040d1a07e$export$2e2bcd8739ae039), {
                            groupName: group?.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), {
                anchorEl: importAnchor,
                open: Boolean(importAnchor),
                onClose: ()=>setImportAnchor(null),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(// Remove the current group from the list of groups to import from
                (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(state.tasking.plannedGroups, (g)=>g.name !== group?.name), (g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        onClick: ()=>handleImportClick(g.name),
                        children: g.name
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: coordsEntryOpen,
                onClose: ()=>{
                    setCoordsEntryOpen(false);
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                        title: "Edit Coordinates",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e85fd8fda59dc4a$export$2e2bcd8739ae039), {
                            initialValue: feature,
                            onSubmit: handleCoordsSubmit,
                            onClose: ()=>setCoordsEntryOpen(false)
                        })
                    })
                })
            })
        ]
    });
}
var $8c871a0fbeb5ceb6$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($8c871a0fbeb5ceb6$var$PlanningHopupTools).attrs({
    className: $8c871a0fbeb5ceb6$var$PlanningHopupTools.name
})`
  .KeyValueTable {
    table td {
      padding-left: 0;
      border-bottom: 0;
    }
  }
`;
const $8c871a0fbeb5ceb6$var$CopyButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ className: className, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        className: className,
        title: "Import Waypoints from Group",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7aeaea8c78c744f5$exports))), {})
        })
    });
})``;


const $edd08701bc9eb69d$var$overlay = document.createElement("div");
document.body.appendChild($edd08701bc9eb69d$var$overlay);
function $edd08701bc9eb69d$export$2e2bcd8739ae039({ className: className, mapRef: mapRef }) {
    const overlayRef = $acw62.useRef();
    const mapClickHanderRef = $acw62.useRef();
    const { state: state, dispatch: dispatch } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const [featureData, setFeatureData] = $acw62.useState(null);
    const visible = !!state.focusedFeature;
    const pageableFeaures = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(state.focusedFeature?.pageableFeatures, (f)=>f.feature.selectable()) || [];
    const featureIndex = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).findIndex(pageableFeaures, (f)=>f.layerName === state.focusedFeature?.layerName && f.feature.name() === state.focusedFeature.name);
    // Battling a stale closure here
    const drawMode = $acw62.useRef(state.drawMode);
    $acw62.useEffect(()=>{
        drawMode.current = state.drawMode;
    }, [
        state.drawMode
    ]);
    const isPlannableGroupSymbol = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(state.userPlannableGroups, state?.focusedFeature?.name);
    const isWaypoint = featureData?.class() === (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint;
    const isNavPoint = featureData?.class() === (0, $91a9098e14452db2$export$589bf38da6f496d9).NavPoint;
    const canPlan = (0, $99f46708ff5ed621$export$9e53ded791f25835)(isWaypoint || isNavPoint ? featureData?.group() : featureData?.name());
    const isPlannableWaypoint = isWaypoint && canPlan;
    const isPlannableNavPoint = isNavPoint && canPlan;
    const renderPlanningTools = featureData && state.planningMode && (isPlannableGroupSymbol || isPlannableWaypoint);
    const renderNavPointPlanningTools = featureData && state.planningMode && isPlannableNavPoint;
    $acw62.useEffect(()=>{
        if (!mapRef.current) return;
        const map = mapRef.current;
        if (!overlayRef.current) {
            const ovr = new (0, $c80d3ed2a84f41ed$export$2e2bcd8739ae039)({
                element: $edd08701bc9eb69d$var$overlay,
                stopEvent: true,
                autoPan: {
                    animation: {
                        duration: 250
                    }
                }
            });
            map.addOverlay(ovr);
            overlayRef.current = ovr;
        }
        // We need to remake the click handler to avoid a stale closure
        // There needs to be an effect to remake the handler based on the internal closure state,
        // in this case state.waypointDropMode.
        // On state change, remove the old one and add the new one with the updated closure state.
        if (mapClickHanderRef.current) map.un("click", mapClickHanderRef.current.listener);
        const key = map.on("click", (e)=>{
            const features = [];
            map.forEachFeatureAtPixel(e.pixel, (feature, layer)=>{
                if (!layer) return;
                const layerName = layer.get("name");
                if (!layerName) return;
                const f = {
                    layerName: layerName,
                    feature: (0, $119c634bd0a30bc2$export$3f88ccaa41f1ca7a)(feature)
                };
                if (f) features.push(f);
            });
            if (drawMode.current !== (0, $99f46708ff5ed621$export$bb7997377d28252d).None || state.waypointDropMode) return null;
            if (features.length > 0) {
                const f = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(features, (f)=>f.feature.selectable());
                if (f?.layerName === (0, $91a9098e14452db2$export$fb028bc55343bb1f).DrawingObjects || !f?.layerName) return;
                dispatch({
                    type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
                    layerName: f.layerName,
                    name: f.feature.name(),
                    feature: f.feature,
                    otherFeatures: features
                });
            } else dispatch({
                type: (0, $99f46708ff5ed621$export$159e21535af98b26).blurFeature
            });
            mapClickHanderRef.current = key;
            return ()=>{
                map.un("click", mapClickHanderRef.current?.listener);
            };
        });
    }, [
        mapRef.current,
        state.waypointDropMode
    ]);
    const handleFeaturePageClick = (index)=>{
        const next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(pageableFeaures, index);
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
            layerName: next.layerName,
            name: next.feature.name(),
            otherFeatures: pageableFeaures
        });
    };
    $acw62.useEffect(()=>{
        if (!mapRef.current) return;
        const map = mapRef.current;
        if (!state.focusedFeature) {
            overlayRef.current?.setPosition(null);
            return;
        }
        const feature = (0, $e8542b590c5a8fca$export$43f5354f3d355747)(map, state.focusedFeature.layerName, state.focusedFeature.name, state.focusedFeature.featureClass);
        if (!feature) return;
        const coordinates = feature.coordinates();
        if (overlayRef.current) overlayRef.current.setPosition(coordinates);
        // Schooch the map up a bit so the popup doesn't disappear off the top of the screen
        const offsetY = -160;
        const view = map.getView();
        const targetPixel = map.getPixelFromCoordinate(coordinates);
        const offsetPixel = [
            targetPixel[0],
            targetPixel[1] + offsetY
        ];
        const offsetCoordinates = map.getCoordinateFromPixel(offsetPixel);
        view.animate({
            center: offsetCoordinates,
            duration: 500
        });
        setFeatureData(feature);
    }, [
        overlayRef.current,
        state.planningMode,
        state.focusedFeature
    ]);
    const handleCopyCoords = ()=>{
        const coords = featureData?.coordinates();
        if (!coords) return;
        const text = (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
            coords[0],
            coords[1]
        ]);
        const elevation = (0, $a48a327511f3c8e6$export$70467d14cb8c16f8)(mapRef.current, coords);
        text.push(`${(0, $79e13355954d15ea$export$d284c26147b5ca34)(elevation).toFixed(0)} ft`);
        navigator.clipboard.writeText(text.join("\n"));
    };
    const coords = featureData ? (0, $79e13355954d15ea$export$3b6b44ca42529cf5)(featureData?.coordinates()) : null;
    // https://github.com/openlayers/openlayers/issues/12848
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: visible ? "block" : "none"
            },
            id: "popup",
            className: "ol-popup",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    onClick: ()=>{
                        dispatch({
                            type: (0, $99f46708ff5ed621$export$159e21535af98b26).blurFeature
                        });
                    },
                    href: "#",
                    id: "popup-closer",
                    className: "ol-popup-closer"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        align: true,
                        wide: true,
                        between: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                fontWeight: 600,
                                children: featureData?.title()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: !state.planningMode && pageableFeaures?.length > 0 ? "block" : "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                        disabled: featureIndex === 0,
                                        onClick: ()=>handleFeaturePageClick(featureIndex - 1),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3e21277543f7c25a$exports))), {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                        disabled: featureIndex === pageableFeaures.length - 1,
                                        onClick: ()=>handleFeaturePageClick(featureIndex + 1),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cbce43614cfca6bb$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        fontSize: 12,
                        children: state.focusedFeature?.layerName
                    })
                }),
                renderNavPointPlanningTools && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bccad2fb478df57$export$2e2bcd8739ae039), {
                    feature: featureData
                }),
                renderPlanningTools && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    my: 1,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8c871a0fbeb5ceb6$export$2e2bcd8739ae039), {
                        feature: featureData
                    })
                }),
                !renderPlanningTools && !renderNavPointPlanningTools && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    my: 1,
                    children: featureData?.render()
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    wide: true,
                    between: true,
                    children: [
                        featureData && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    fontSize: 12,
                                    children: [
                                        coords.lat,
                                        " ",
                                        coords.long
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    fontSize: 12,
                                    children: coords.mgrs
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($edd08701bc9eb69d$var$CopyCoordsButton, {
                            onClick: handleCopyCoords
                        })
                    ]
                })
            ]
        })
    }), $edd08701bc9eb69d$var$overlay);
}
const $edd08701bc9eb69d$var$CopyCoordsButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ onClick: onClick, className: className })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
            title: "Copy Coordinates",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                onClick: onClick,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b62e8e213130dab6$exports))), {
                    fontSize: "small"
                })
            })
        })
    }))`
  position: absolute;
  right: 0;
  bottom: 0;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");
var $9liTZ = parcelRequire("9liTZ");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");


var $6g9fa = parcelRequire("6g9fa");




var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $fd904517f2a78af6$export$d6efab9620b78fec(slot) {
    return (0, $9XEW1.default)("MuiLink", slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $7u6PA.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $fd904517f2a78af6$export$2e2bcd8739ae039 = $fd904517f2a78af6$var$linkClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $731ce78e0c47d0a7$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $731ce78e0c47d0a7$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $731ce78e0c47d0a7$var$transformDeprecatedColors = (color)=>{
    return $731ce78e0c47d0a7$var$colorTransformations[color] || color;
};
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $jTnBY.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $9971e.default)(slots, (0, $fd904517f2a78af6$export$d6efab9620b78fec), classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $jTnBY.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const color = (0, $9liTZ.getPath)(theme, `palette.${$731ce78e0c47d0a7$var$transformDeprecatedColors(ownerState.color)}`) || ownerState.color;
    return (0, $8nd05.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && {
        textDecoration: "underline",
        textDecorationColor: color !== "inherit" ? (0, $kyRHb.alpha)(color, 0.4) : undefined,
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }, ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $fd904517f2a78af6$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $1En50.default)(props, $731ce78e0c47d0a7$var$_excluded);
    const sxColor = typeof sx === "function" ? sx(theme).color : sx == null ? void 0 : sx.color;
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handlerRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        // It is too complex to support any types of `sx`.
        // Need to find a better way to get rid of the color manipulation for `textDecorationColor`.
        color: (typeof sxColor === "function" ? sxColor(theme) : sxColor) || color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, (0, $8nd05.default)({
        color: color,
        className: (0, $1SA7b.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...inProps.color ? [
                {
                    color: $731ce78e0c47d0a7$var$colorTransformations[color] || color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $731ce78e0c47d0a7$export$2e2bcd8739ae039 = $731ce78e0c47d0a7$var$Link;



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
/**
 * @module ol/control/MousePosition
 */ 




/**
 * @type {string}
 */ const $c9687314c91cf896$var$PROJECTION = "projection";
/**
 * @type {string}
 */ const $c9687314c91cf896$var$COORDINATE_FORMAT = "coordinateFormat";
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', Return>} MousePositionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-mouse-position'] CSS class name.
 * @property {import("../coordinate.js").CoordinateFormat} [coordinateFormat] Coordinate format.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the
 * control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {string} [placeholder] Markup to show when the mouse position is not
 * available (e.g. when the pointer leaves the map viewport).  By default, a non-breaking space is rendered
 * initially and the last position is retained when the mouse leaves the viewport.
 * When a string is provided (e.g. `'no position'` or `''` for an empty string) it is used as a
 * placeholder.
 * @property {boolean} [wrapX=true] Wrap the world horizontally on the projection's antimeridian, if it
 * is a global projection.
 */ /**
 * @classdesc
 * A control to show the 2D coordinates of the mouse cursor. By default, these
 * are in the view projection, but can be in any supported projection.
 * By default the control is shown in the top right corner of the map, but this
 * can be changed by using the css selector `.ol-mouse-position`.
 *
 * On touch devices, which usually do not have a mouse cursor, the coordinates
 * of the currently touched position are shown.
 *
 * @api
 */ class $c9687314c91cf896$var$MousePosition extends (0, $b978dafe8f7d27ff$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Mouse position options.
   */ constructor(options){
        options = options ? options : {};
        const element = document.createElement("div");
        element.className = options.className !== undefined ? options.className : "ol-mouse-position";
        super({
            element: element,
            render: options.render,
            target: options.target
        });
        /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {MousePositionOnSignature<void>}
     */ this.un;
        this.addChangeListener($c9687314c91cf896$var$PROJECTION, this.handleProjectionChanged_);
        if (options.coordinateFormat) this.setCoordinateFormat(options.coordinateFormat);
        if (options.projection) this.setProjection(options.projection);
        /**
     * @private
     * @type {boolean}
     */ this.renderOnMouseOut_ = options.placeholder !== undefined;
        /**
     * @private
     * @type {string}
     */ this.placeholder_ = this.renderOnMouseOut_ ? options.placeholder : "&#160;";
        /**
     * @private
     * @type {string}
     */ this.renderedHTML_ = element.innerHTML;
        /**
     * @private
     * @type {?import("../proj/Projection.js").default}
     */ this.mapProjection_ = null;
        /**
     * @private
     * @type {?import("../proj.js").TransformFunction}
     */ this.transform_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX === false ? false : true;
    }
    /**
   * @private
   */ handleProjectionChanged_() {
        this.transform_ = null;
    }
    /**
   * Return the coordinate format type used to render the current position or
   * undefined.
   * @return {import("../coordinate.js").CoordinateFormat|undefined} The format to render the current
   *     position in.
   * @observable
   * @api
   */ getCoordinateFormat() {
        return /** @type {import("../coordinate.js").CoordinateFormat|undefined} */ this.get($c9687314c91cf896$var$COORDINATE_FORMAT);
    }
    /**
   * Return the projection that is used to report the mouse position.
   * @return {import("../proj/Projection.js").default|undefined} The projection to report mouse
   *     position in.
   * @observable
   * @api
   */ getProjection() {
        return /** @type {import("../proj/Projection.js").default|undefined} */ this.get($c9687314c91cf896$var$PROJECTION);
    }
    /**
   * @param {MouseEvent} event Browser event.
   * @protected
   */ handleMouseMove(event) {
        const map = this.getMap();
        this.updateHTML_(map.getEventPixel(event));
    }
    /**
   * @param {Event} event Browser event.
   * @protected
   */ handleMouseOut(event) {
        this.updateHTML_(null);
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        super.setMap(map);
        if (map) {
            const viewport = map.getViewport();
            this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(viewport, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTERMOVE, this.handleMouseMove, this));
            if (this.renderOnMouseOut_) this.listenerKeys.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(viewport, (0, $d564567e31203d44$export$2e2bcd8739ae039).POINTEROUT, this.handleMouseOut, this));
            this.updateHTML_(null);
        }
    }
    /**
   * Set the coordinate format type used to render the current position.
   * @param {import("../coordinate.js").CoordinateFormat} format The format to render the current
   *     position in.
   * @observable
   * @api
   */ setCoordinateFormat(format) {
        this.set($c9687314c91cf896$var$COORDINATE_FORMAT, format);
    }
    /**
   * Set the projection that is used to report the mouse position.
   * @param {import("../proj.js").ProjectionLike} projection The projection to report mouse
   *     position in.
   * @observable
   * @api
   */ setProjection(projection) {
        this.set($c9687314c91cf896$var$PROJECTION, (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection));
    }
    /**
   * @param {?import("../pixel.js").Pixel} pixel Pixel.
   * @private
   */ updateHTML_(pixel) {
        let html = this.placeholder_;
        if (pixel && this.mapProjection_) {
            if (!this.transform_) {
                const projection = this.getProjection();
                if (projection) this.transform_ = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(this.mapProjection_, projection);
                else this.transform_ = (0, $9c4744460e43e41b$export$83e8ab53904f8022);
            }
            const map = this.getMap();
            const coordinate = map.getCoordinateFromPixelInternal(pixel);
            if (coordinate) {
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                if (userProjection) this.transform_ = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(this.mapProjection_, userProjection);
                this.transform_(coordinate, coordinate);
                if (this.wrapX_) {
                    const projection = userProjection || this.getProjection() || this.mapProjection_;
                    (0, $1bd0a226f9a16141$export$39a9ce3624977b84)(coordinate, projection);
                }
                const coordinateFormat = this.getCoordinateFormat();
                if (coordinateFormat) html = coordinateFormat(coordinate);
                else html = coordinate.toString();
            }
        }
        if (!this.renderedHTML_ || html !== this.renderedHTML_) {
            this.element.innerHTML = html;
            this.renderedHTML_ = html;
        }
    }
    /**
   * Update the projection. Rendering of the coordinates is done in
   * `handleMouseMove` and `handleMouseUp`.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) this.mapProjection_ = null;
        else if (this.mapProjection_ != frameState.viewState.projection) {
            this.mapProjection_ = frameState.viewState.projection;
            this.transform_ = null;
        }
    }
}
var $c9687314c91cf896$export$2e2bcd8739ae039 = $c9687314c91cf896$var$MousePosition;


parcelRequire("acw62");
var $f46ed4009cb9c1cd$export$83d89fbfd8236492;
var $f46ed4009cb9c1cd$export$80e7718417253a51;
var $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51;
var $f46ed4009cb9c1cd$export$307591e98609eddd;
var $f46ed4009cb9c1cd$export$b23711c915539651;
var $f46ed4009cb9c1cd$export$7020a3240b287705;
"use strict";
var $f46ed4009cb9c1cd$var$l, $f46ed4009cb9c1cd$var$s;

$f46ed4009cb9c1cd$var$l = (parcelRequire("sBxfj"));

$f46ed4009cb9c1cd$var$s = (parcelRequire("3odmW"));
$f46ed4009cb9c1cd$export$83d89fbfd8236492 = $f46ed4009cb9c1cd$var$l.version;
$f46ed4009cb9c1cd$export$80e7718417253a51 = $f46ed4009cb9c1cd$var$l.renderToString;
$f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = $f46ed4009cb9c1cd$var$l.renderToStaticMarkup;
$f46ed4009cb9c1cd$export$307591e98609eddd = $f46ed4009cb9c1cd$var$l.renderToNodeStream;
$f46ed4009cb9c1cd$export$b23711c915539651 = $f46ed4009cb9c1cd$var$l.renderToStaticNodeStream;
$f46ed4009cb9c1cd$export$7020a3240b287705 = $f46ed4009cb9c1cd$var$s.renderToReadableStream;




function $4549cd201b72b761$var$padDec(dec) {
    const s = dec.toString();
    const [first, second] = s.split(".");
    const [deg, int] = first.split(" ");
    const padded = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).padStart(int, 2, "0");
    const decPadded = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).padEnd(second, 4, "0");
    return `${deg} ${padded}.${decPadded}`;
}
function $4549cd201b72b761$export$e23a2ede629f2806(map, ref) {
    const mousePositionControl = new (0, $c9687314c91cf896$export$2e2bcd8739ae039)({
        coordinateFormat: (coords)=>{
            const northingText = Math.sign(coords[1]) === -1 ? "S" : "N";
            const eastingText = Math.sign(coords[0]) === -1 ? "W" : "E";
            const lat = (0, $79e13355954d15ea$export$fea9c56d107c783a)(coords[1]).join(" ");
            const long = (0, $79e13355954d15ea$export$fea9c56d107c783a)(coords[0]).join(" ");
            const elevation = (0, $a48a327511f3c8e6$export$70467d14cb8c16f8)(map, coords);
            const out = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            component: "span",
                            fontWeight: 600,
                            children: [
                                "LAT:",
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            northingText,
                            " ",
                            $4549cd201b72b761$var$padDec(lat)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            component: "span",
                            fontWeight: 600,
                            children: [
                                " ",
                                "LON:",
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            eastingText,
                            " ",
                            $4549cd201b72b761$var$padDec(long)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontSize: 14,
                            component: "span",
                            fontWeight: 600,
                            children: [
                                " ",
                                "MGRS:",
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: (0, $79e13355954d15ea$export$a83fd77c82670907)({
                            lat: coords[1],
                            long: coords[0]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                fontSize: 14,
                                component: "span",
                                fontWeight: 600,
                                children: [
                                    " ",
                                    "ELEVATION:",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        (0, $79e13355954d15ea$export$d284c26147b5ca34)(elevation).toFixed(0),
                                        " FT"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
            return $f46ed4009cb9c1cd$export$80e7718417253a51(out);
        },
        projection: "EPSG:4326",
        className: "custom-mouse-position",
        target: ref
    });
    map.addControl(mousePositionControl);
    return mousePositionControl;
}





/**
 * @module ol/layer/Tile
 */ /**
 * @module ol/layer/BaseTile
 */ 
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $e4c61536de922b84$export$2e2bcd8739ae039 = {
    PRELOAD: "preload",
    USE_INTERIM_TILES_ON_ERROR: "useInterimTilesOnError"
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $93be2de6a052f587$var$BaseTileLayer extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $e4c61536de922b84$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $93be2de6a052f587$export$2e2bcd8739ae039 = $93be2de6a052f587$var$BaseTileLayer;


/**
 * @module ol/renderer/canvas/TileLayer
 */ 
/**
 * @module ol/DataTile
 */ /**
 * @module ol/Tile
 */ 




/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $0f235d2d04095c6e$var$Tile extends (0, $08c28d22c0cb5a39$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = "";
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        if (this.state === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + "/" + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error("Tile load sequence violation");
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $c7ccf7e681a9b333$export$929e5a82286172a6)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
}
var $0f235d2d04095c6e$export$2e2bcd8739ae039 = $0f235d2d04095c6e$var$Tile;




function $fd518ba473015b27$export$3a7c913cb40dcb7d(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function $fd518ba473015b27$export$7386cb0413f6b283(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const $fd518ba473015b27$export$df4c617b86128e3e = new Error("disposed");
/**
 * @type {CanvasRenderingContext2D|null}
 */ let $fd518ba473015b27$var$sharedContext = null;
function $fd518ba473015b27$export$45b10814cc054894(image) {
    if (!$fd518ba473015b27$var$sharedContext) $fd518ba473015b27$var$sharedContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = $fd518ba473015b27$var$sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    $fd518ba473015b27$var$sharedContext.clearRect(0, 0, width, height);
    $fd518ba473015b27$var$sharedContext.drawImage(image, 0, 0);
    return $fd518ba473015b27$var$sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const $fd518ba473015b27$var$defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class $fd518ba473015b27$var$DataTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = $fd518ba473015b27$export$3a7c913cb40dcb7d(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return $fd518ba473015b27$var$defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) return;
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort($fd518ba473015b27$export$df4c617b86128e3e);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
var $fd518ba473015b27$export$2e2bcd8739ae039 = $fd518ba473015b27$var$DataTile;


/**
 * @module ol/ImageTile
 */ 



class $cd3bc8d185522361$var$ImageTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, crossOrigin, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = new Image();
        if (crossOrigin !== null) this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $cd3bc8d185522361$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        const image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $b54439be79d4619a$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $cd3bc8d185522361$var$getBlankImage() {
    const ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = "rgba(0,0,0,0)";
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $cd3bc8d185522361$export$2e2bcd8739ae039 = $cd3bc8d185522361$var$ImageTile;


/**
 * @module ol/structs/LRUCache
 */ 
/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $859b1614288c6316$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.pop();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.count_ = 0;
        this.entries_ = {};
        this.oldest_ = null;
        this.newest_ = null;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $35d5ec884318008e$export$a7a9523472993e97)(entry !== undefined, "Tried to get a value for a key that does not exist in the cache");
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!(key in this.entries_), "Tried to set a value for a key that is used already");
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $859b1614288c6316$export$2e2bcd8739ae039 = $859b1614288c6316$var$LRUCache;


/**
 * @module ol/reproj/DataTile
 */ /**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855 = 0.5;





/**
 * @module ol/reproj/Triangulation
 */ 


/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $6be53f6edfbf1854$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = (0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + "/" + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
        const destinationTopRight = (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(targetExtent);
        const destinationBottomRight = (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(targetExtent);
        const destinationBottomLeft = (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $6be53f6edfbf1854$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $6da4c8ed3074c92b$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $6be53f6edfbf1854$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $6b000a049d919fe5$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $6b000a049d919fe5$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $6b000a049d919fe5$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[0]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[1]);
            (0, $6da4c8ed3074c92b$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $6be53f6edfbf1854$export$2e2bcd8739ae039 = $6be53f6edfbf1854$var$Triangulation;


/**
 * @module ol/reproj
 */ 



let $2b0a118af78fb031$var$brokenDiagonalRendering_;
const $2b0a118af78fb031$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $2b0a118af78fb031$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $2b0a118af78fb031$var$isBrokenDiagonalRendering() {
    if ($2b0a118af78fb031$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(6, 6, $2b0a118af78fb031$export$a166f0857c555517);
        ctx.globalCompositeOperation = "lighter";
        ctx.fillStyle = "rgba(210, 0, 0, 0.75)";
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $2b0a118af78fb031$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $2b0a118af78fb031$var$brokenDiagonalRendering_ = $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 0) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 4) || $2b0a118af78fb031$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(ctx);
        $2b0a118af78fb031$export$a166f0857c555517.push(ctx.canvas);
    }
    return $2b0a118af78fb031$var$brokenDiagonalRendering_;
}
function $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $9c4744460e43e41b$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $9c4744460e43e41b$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $2b0a118af78fb031$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(targetExtent);
    let sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $2b0a118af78fb031$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $2b0a118af78fb031$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $2b0a118af78fb031$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = "lighter";
    const sourceDataExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $6da4c8ed3074c92b$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(Math.round((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceDataExtent) * stitchScale), Math.round((0, $6da4c8ed3074c92b$export$c08559766941f856)(sourceDataExtent) * stitchScale), $2b0a118af78fb031$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceExtent) * stitchScale;
            const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(src.clipExtent) * stitchScale;
                    const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(src.extent) * stitchScale;
                const srcHeight = (0, $6da4c8ed3074c92b$export$c08559766941f856)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $6b000a049d919fe5$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($2b0a118af78fb031$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $6da4c8ed3074c92b$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(stitchContext);
        $2b0a118af78fb031$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = "source-over";
        context.strokeStyle = "black";
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}






/**
 * @typedef {function(number, number, number, number) : import("../DataTile.js").default} TileGetter
 */ /**
 * @typedef {Object} TileOffset
 * @property {DataTile} tile Tile.
 * @property {number} offset Offset.
 */ /**
 * @typedef {Object} Options
 * @property {import("../proj/Projection.js").default} sourceProj Source projection.
 * @property {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
 * @property {import("../proj/Projection.js").default} targetProj Target projection.
 * @property {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
 * @property {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
 * @property {import("../tilecoord.js").TileCoord} [wrappedTileCoord] Coordinate of the tile wrapped in X.
 * @property {number} pixelRatio Pixel ratio.
 * @property {number} gutter Gutter of the source tiles.
 * @property {TileGetter} getTileFunction Function returning source tiles (z, x, y, pixelRatio).
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {number} [errorThreshold] Acceptable reprojection error (in px).
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected data tile.
 * See {@link module:ol/source/DataTile~DataTileSource}.
 *
 */ class $4eec0210e41cb24b$var$ReprojDataTile extends (0, $fd518ba473015b27$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        super({
            tileCoord: options.tileCoord,
            loader: ()=>Promise.resolve(new Uint8ClampedArray(4)),
            interpolate: options.interpolate,
            transition: options.transition
        });
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter;
        /**
     * @type {import("../DataTile.js").Data}
     * @private
     */ this.reprojData_ = null;
        /**
     * @type {Error}
     * @private
     */ this.reprojError_ = null;
        /**
     * @type {import('../size.js').Size}
     * @private
     */ this.reprojSize_ = undefined;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = options.sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = options.targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = options.wrappedTileCoord || options.tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        const sourceProj = options.sourceProj;
        const sourceProjExtent = sourceProj.getExtent();
        const sourceTileGridExtent = options.sourceTileGrid.getExtent();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceTileGridExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(sourceProjExtent, sourceTileGridExtent) : sourceProjExtent : sourceTileGridExtent;
        const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $6da4c8ed3074c92b$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = this.targetTileGrid_.getResolution(this.wrappedTileCoord_[0]);
        const targetProj = options.targetProj;
        const sourceResolution = (0, $2b0a118af78fb031$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = options.errorThreshold !== undefined ? options.errorThreshold : (0, $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $6be53f6edfbf1854$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = this.sourceTileGrid_.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $6da4c8ed3074c92b$export$520c40045967cb15)(sourceExtent)) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $6da4c8ed3074c92b$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = this.sourceTileGrid_.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                const getTile = options.getTileFunction;
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const tile = getTile(this.sourceZ_, srcX, srcY, this.pixelRatio_);
                    if (tile) {
                        const offset = worldsAway * worldWidth;
                        this.sourceTiles_.push({
                            tile: tile,
                            offset: offset
                        });
                    }
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the tile size.
   * @return {import('../size.js').Size} Tile size.
   * @override
   */ getSize() {
        return this.reprojSize_;
    }
    /**
   * Get the data for the tile.
   * @return {import("../DataTile.js").Data} Tile data.
   * @override
   */ getData() {
        return this.reprojData_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @override
   */ getError() {
        return this.reprojError_;
    }
    /**
   * @private
   */ reproject_() {
        const dataSources = [];
        let imageLike = false;
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (!tile || tile.getState() !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) return;
            const size = tile.getSize();
            const gutter = this.gutter_;
            /**
       * @type {import("../DataTile.js").ArrayLike}
       */ let tileData;
            const arrayData = (0, $fd518ba473015b27$export$7386cb0413f6b283)(tile.getData());
            if (arrayData) tileData = arrayData;
            else {
                imageLike = true;
                tileData = (0, $fd518ba473015b27$export$45b10814cc054894)((0, $fd518ba473015b27$export$3a7c913cb40dcb7d)(tile.getData()));
            }
            const pixelSize = [
                size[0] + 2 * gutter,
                size[1] + 2 * gutter
            ];
            const isFloat = tileData instanceof Float32Array;
            const pixelCount = pixelSize[0] * pixelSize[1];
            const DataType = isFloat ? Float32Array : Uint8ClampedArray;
            const tileDataR = new DataType(tileData.buffer);
            const bytesPerElement = DataType.BYTES_PER_ELEMENT;
            const bytesPerPixel = bytesPerElement * tileDataR.length / pixelCount;
            const bytesPerRow = tileDataR.byteLength / pixelSize[1];
            const bandCount = Math.floor(bytesPerRow / bytesPerElement / pixelSize[0]);
            const packedLength = pixelCount * bandCount;
            let packedData = tileDataR;
            if (tileDataR.length !== packedLength) {
                packedData = new DataType(packedLength);
                let dataIndex = 0;
                let rowOffset = 0;
                const colCount = pixelSize[0] * bandCount;
                for(let rowIndex = 0; rowIndex < pixelSize[1]; ++rowIndex){
                    for(let colIndex = 0; colIndex < colCount; ++colIndex)packedData[dataIndex++] = tileDataR[rowOffset + colIndex];
                    rowOffset += bytesPerRow / bytesPerElement;
                }
            }
            const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
            extent[0] += source.offset;
            extent[2] += source.offset;
            const clipExtent = this.clipExtent_?.slice();
            if (clipExtent) {
                clipExtent[0] += source.offset;
                clipExtent[2] += source.offset;
            }
            dataSources.push({
                extent: extent,
                clipExtent: clipExtent,
                data: new Uint8ClampedArray(packedData.buffer),
                dataType: DataType,
                bytesPerPixel: bytesPerPixel,
                pixelSize: pixelSize
            });
        });
        this.sourceTiles_.length = 0;
        if (dataSources.length === 0) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
            this.changed();
            return;
        }
        const z = this.wrappedTileCoord_[0];
        const size = this.targetTileGrid_.getTileSize(z);
        const targetWidth = typeof size === "number" ? size : size[0];
        const targetHeight = typeof size === "number" ? size : size[1];
        const targetResolution = this.targetTileGrid_.getResolution(z);
        const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
        const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
        let dataR, dataU;
        const bytesPerPixel = dataSources[0].bytesPerPixel;
        const reprojs = Math.ceil(bytesPerPixel / 3);
        for(let reproj = reprojs - 1; reproj >= 0; --reproj){
            const sources = [];
            for(let i = 0, len = dataSources.length; i < len; ++i){
                const dataSource = dataSources[i];
                const buffer = dataSource.data;
                const pixelSize = dataSource.pixelSize;
                const width = pixelSize[0];
                const height = pixelSize[1];
                const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(width, height, (0, $2b0a118af78fb031$export$a166f0857c555517));
                const imageData = context.createImageData(width, height);
                const data = imageData.data;
                let offset = reproj * 3;
                for(let j = 0, len = data.length; j < len; j += 4){
                    data[j] = buffer[offset];
                    data[j + 1] = buffer[offset + 1];
                    data[j + 2] = buffer[offset + 2];
                    data[j + 3] = 255;
                    offset += bytesPerPixel;
                }
                context.putImageData(imageData, 0, 0);
                sources.push({
                    extent: dataSource.extent,
                    clipExtent: dataSource.clipExtent,
                    image: context.canvas
                });
            }
            const canvas = (0, $2b0a118af78fb031$export$b3890eb0ae9dca99)(targetWidth, targetHeight, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, false, false, false);
            for(let i = 0, len = sources.length; i < len; ++i){
                const canvas = sources[i].image;
                const context = canvas.getContext("2d");
                (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(context);
                (0, $2b0a118af78fb031$export$a166f0857c555517).push(context.canvas);
            }
            const context = canvas.getContext("2d");
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(context);
            (0, $2b0a118af78fb031$export$a166f0857c555517).push(canvas);
            if (!dataR) {
                dataU = new Uint8ClampedArray(bytesPerPixel * imageData.width * imageData.height);
                dataR = new dataSources[0].dataType(dataU.buffer);
            }
            const data = imageData.data;
            let offset = reproj * 3;
            for(let i = 0, len = data.length; i < len; i += 4){
                if (data[i + 3] === 255) {
                    dataU[offset] = data[i];
                    dataU[offset + 1] = data[i + 1];
                    dataU[offset + 2] = data[i + 2];
                } else {
                    dataU[offset] = 0;
                    dataU[offset + 1] = 0;
                    dataU[offset + 2] = 0;
                }
                offset += bytesPerPixel;
            }
        }
        if (imageLike) {
            const context = (0, $075f937d7366f1a2$export$9e05d10eae75c464)(targetWidth, targetHeight);
            const imageData = new ImageData(dataR, targetWidth);
            context.putImageData(imageData, 0, 0);
            this.reprojData_ = context.canvas;
        } else this.reprojData_ = dataR;
        this.reprojSize_ = [
            Math.round(targetWidth * this.pixelRatio_),
            Math.round(targetHeight * this.pixelRatio_)
        ];
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && this.state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR) return;
        this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
        this.changed();
        let leftToLoad = 0;
        this.sourcesListenerKeys_ = [];
        this.sourceTiles_.forEach(({ tile: tile })=>{
            const state = tile.getState();
            if (state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE && state !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) return;
            leftToLoad++;
            const sourceListenKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(tile, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, ()=>{
                const state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
                    (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(sourceListenKey);
                    leftToLoad--;
                    if (leftToLoad === 0) {
                        this.unlistenSources_();
                        this.reproject_();
                    }
                }
            });
            this.sourcesListenerKeys_.push(sourceListenKey);
        });
        if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
        else this.sourceTiles_.forEach(function({ tile: tile }) {
            const state = tile.getState();
            if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) tile.load();
        });
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
}
var $4eec0210e41cb24b$export$2e2bcd8739ae039 = $4eec0210e41cb24b$var$ReprojDataTile;


/**
 * @module ol/reproj/Tile
 */ 









/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} tile Tile.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $398e350e33050c07$var$ReprojTile extends (0, $0f235d2d04095c6e$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $6da4c8ed3074c92b$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $6da4c8ed3074c92b$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $2b0a118af78fb031$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $8ea51dd7be3ba5e2$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $6be53f6edfbf1854$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $6da4c8ed3074c92b$export$520c40045967cb15)(sourceExtent)) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $6da4c8ed3074c92b$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
                    if (tile) {
                        const offset = worldsAway * worldWidth;
                        this.sourceTiles_.push({
                            tile: tile,
                            offset: offset
                        });
                    }
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === "number" ? size : size[0];
            const height = typeof size === "number" ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $2b0a118af78fb031$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(tile, (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR || state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) {
                            (0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, $075f937d7366f1a2$export$e918ac6a1026a12a)(this.canvas_.getContext("2d"));
            (0, $2b0a118af78fb031$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        super.release();
    }
}
var $398e350e33050c07$export$2e2bcd8739ae039 = $398e350e33050c07$var$ReprojTile;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $550e524b0d1b61d4$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $550e524b0d1b61d4$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $550e524b0d1b61d4$var$TileRange(minX, maxX, minY, maxY);
}
var $550e524b0d1b61d4$export$2e2bcd8739ae039 = $550e524b0d1b61d4$var$TileRange;






/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $bf2a04496fadabc6$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y) {
    return z + "/" + x + "/" + y;
}
function $bf2a04496fadabc6$export$a47fb462a08de82f(tileCoord) {
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf("/") + 1, tileKey.length).split(",").map(Number);
    return $bf2a04496fadabc6$export$92d0df0f1d25c63c(z, x, y);
}
function $bf2a04496fadabc6$export$a807b7874eb66454(key) {
    return key.split("/").map(Number);
}
function $bf2a04496fadabc6$export$d6af199866bfb566(tileCoord) {
    return $bf2a04496fadabc6$export$731f79419750ccf7(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $bf2a04496fadabc6$export$731f79419750ccf7(z, x, y) {
    return (x << z) + y;
}
function $bf2a04496fadabc6$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}





/**
 * @param {string} sourceKey The source key.
 * @param {number} z The tile z level.
 * @param {number} x The tile x level.
 * @param {number} y The tile y level.
 * @return {string} The cache key.
 */ function $02fffef185f4339b$var$getCacheKey(sourceKey, z, x, y) {
    return `${sourceKey},${(0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y)}`;
}
/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function $02fffef185f4339b$var$removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function $02fffef185f4339b$var$getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(extent, (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $02fffef185f4339b$var$CanvasTileLayerRenderer extends (0, $42152f52b26b6ca7$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default}
     */ this.renderedProjection = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedRevision;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {string}
     */ this.renderedSourceKey_;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, $6da4c8ed3074c92b$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, $859b1614288c6316$export$2e2bcd8739ae039)(cacheSize);
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = $02fffef185f4339b$var$getCacheKey(tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, frameState.viewState.projection);
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, $cd3bc8d185522361$export$2e2bcd8739ae039)) image = tile.getImage();
            else if (tile instanceof (0, $fd518ba473015b27$export$2e2bcd8739ae039)) {
                image = (0, $fd518ba473015b27$export$3a7c913cb40dcb7d)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedRevision_) this.renderedRevision_ = sourceRevision;
        else if (this.renderedRevision_ !== sourceRevision) {
            this.renderedRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) this.tileCache_.clear();
        }
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = $02fffef185f4339b$var$getCacheKey(staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.get(cacheKey);
                if (tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                    tile.endTransition((0, $6c5e11070e371322$export$5e82334337e0f204)(this));
                    $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = $02fffef185f4339b$var$getCacheKey(sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.get(cacheKey);
                if (tile.getState() === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                    $02fffef185f4339b$var$addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        this.renderComplete = true;
        /**
     * TODO:
     *  * maybe skip transition when not fully opaque
     *  * decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const sourceRevision = tileSource.getRevision();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const sourceKey = tileSource.getKey();
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) frameExtent = (0, $6da4c8ed3074c92b$export$72209efa88586d42)(frameExtent, (0, $9c4744460e43e41b$export$494be3a3a25689ca)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = $02fffef185f4339b$var$getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = $02fffef185f4339b$var$getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if ((tile instanceof (0, $398e350e33050c07$export$2e2bcd8739ae039) || tile instanceof (0, $4eec0210e41cb24b$export$2e2bcd8739ae039)) && tileState === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                $02fffef185f4339b$var$removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $e22e7611e69f42a9$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerState.extent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        /** @type {Array<number>} */ const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, $b998d41b678ed5d1$export$fcb633242ef15540));
        let currentClip;
        const clips = [];
        const clipZs = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $e22e7611e69f42a9$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = zs.length === 1;
                let contextSaved = false;
                // Clip mask for regions in this tile that already filled by a higher z tile
                currentClip = [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ];
                for(let i = 0, ii = clips.length; i < ii; ++i)if (!transition && currentZ < clipZs[i]) {
                    const clip = clips[i];
                    if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)([
                        x,
                        y,
                        x + w,
                        y + h
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            context.save();
                            contextSaved = true;
                        }
                        context.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        context.moveTo(currentClip[0], currentClip[1]);
                        context.lineTo(currentClip[2], currentClip[3]);
                        context.lineTo(currentClip[4], currentClip[5]);
                        context.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        context.moveTo(clip[6], clip[7]);
                        context.lineTo(clip[4], clip[5]);
                        context.lineTo(clip[2], clip[3]);
                        context.lineTo(clip[0], clip[1]);
                        context.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);
                if (contextSaved) context.restore();
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedRevision = sourceRevision;
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $6da4c8ed3074c92b$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.renderedProjection = projection;
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        // TODO: let the renderers manage their own cache instead of managing the source cache
        /**
     * Here we unconditionally expire the source cache since the renderer maintains
     * its own cache.
     * @param {import("../../Map.js").default} map Map.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     */ const postRenderFunction = (map, frameState)=>{
            const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
            const wantedTiles = frameState.wantedTiles[tileSourceKey];
            const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
            this.updateCacheSize(tilesCount);
            this.tileCache_.expireCache();
        };
        frameState.postRenderFunctions.push(postRenderFunction);
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        let image;
        if (tile instanceof (0, $fd518ba473015b27$export$2e2bcd8739ae039)) {
            image = (0, $fd518ba473015b27$export$3a7c913cb40dcb7d)(tile.getData());
            if (!image) throw new Error("Rendering array data is not yet supported");
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
var $02fffef185f4339b$export$2e2bcd8739ae039 = $02fffef185f4339b$var$CanvasTileLayerRenderer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $32e67a4d3559554a$var$TileLayer extends (0, $93be2de6a052f587$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $02fffef185f4339b$export$2e2bcd8739ae039)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
var $32e67a4d3559554a$export$2e2bcd8739ae039 = $32e67a4d3559554a$var$TileLayer;


/**
 * @module ol/source/XYZ
 */ /**
 * @module ol/source/TileImage
 */ 


/**
 * @module ol/TileCache
 */ 

class $a12e09565a34db59$var$TileCache extends (0, $859b1614288c6316$export$2e2bcd8739ae039) {
    /**
   * @override
   */ clear() {
        while(this.getCount() > 0)this.pop().release();
        super.clear();
    }
    /**
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   * @override
   */ expireCache(usedTiles) {
        while(this.canExpireCache()){
            const tile = this.peekLast();
            if (tile.getKey() in usedTiles) break;
            else this.pop().release();
        }
    }
    /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */ pruneExceptNewestZ() {
        if (this.getCount() === 0) return;
        const key = this.peekFirstKey();
        const tileCoord = (0, $bf2a04496fadabc6$export$a807b7874eb66454)(key);
        const z = tileCoord[0];
        this.forEach((tile)=>{
            if (tile.tileCoord[0] !== z) {
                this.remove((0, $bf2a04496fadabc6$export$a47fb462a08de82f)(tile.tileCoord));
                tile.release();
            }
        });
    }
}
var $a12e09565a34db59$export$2e2bcd8739ae039 = $a12e09565a34db59$var$TileCache;



/**
 * @module ol/source/UrlTile
 */ /**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $7e3d7a0f8b272861$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: "tileloadstart",
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: "tileloadend",
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: "tileloaderror"
};


/**
 * @module ol/source/Tile
 */ 





/**
 * @module ol/tilegrid
 */ /**
 * @module ol/tilegrid/TileGrid
 */ 








/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $bb602a307ef98bb5$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $bb602a307ef98bb5$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $bb602a307ef98bb5$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $35d5ec884318008e$export$a7a9523472993e97)((0, $b998d41b678ed5d1$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), "`resolutions` must be sorted in descending order");
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, "Number of `origins` and `resolutions` must be equal");
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent);
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, "Either `origin` or `origins` must be configured, never both");
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $35d5ec884318008e$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, "Number of `tileSizes` and `resolutions` must be equal");
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c) : null;
        (0, $35d5ec884318008e$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, "Either `tileSize` or `tileSizes` must be configured, never both");
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $550e524b0d1b61d4$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $bb602a307ef98bb5$var$tmpTileCoord);
        const minX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const minY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $bb602a307ef98bb5$var$tmpTileCoord);
        const maxX = $bb602a307ef98bb5$var$tmpTileCoord[1];
        const maxY = $bb602a307ef98bb5$var$tmpTileCoord[2];
        return (0, $550e524b0d1b61d4$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS) - 1;
            tileCoordY = (0, $6b000a049d919fe5$export$803ce6b71a0a94b2)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordX, $bb602a307ef98bb5$var$DECIMALS);
            tileCoordY = (0, $6b000a049d919fe5$export$a3fe094919f356fd)(tileCoordY, $bb602a307ef98bb5$var$DECIMALS);
        }
        return (0, $bf2a04496fadabc6$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $b998d41b678ed5d1$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $acee589e5b390c5c$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $bb602a307ef98bb5$export$2e2bcd8739ae039 = $bb602a307ef98bb5$var$TileGrid;







function $5779655d81caea04$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $5779655d81caea04$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $5779655d81caea04$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $6da4c8ed3074c92b$export$ac68c24d37ca240f)(projectionExtent, center)) {
        const worldWidth = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : "top-left";
    const resolutions = $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $6da4c8ed3074c92b$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $5779655d81caea04$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:3857").getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $5779655d81caea04$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $bb602a307ef98bb5$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $5779655d81caea04$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $57cd8651d88957a0$export$e98a216cdcc847dc);
    tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $57cd8651d88957a0$export$6b8cb5cd370bd90c));
    const height = (0, $6da4c8ed3074c92b$export$c08559766941f856)(extent);
    const width = (0, $6da4c8ed3074c92b$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $5779655d81caea04$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $5779655d81caea04$export$7b5b6ef8fd55fac4(projection);
    return $5779655d81caea04$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $5779655d81caea04$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $03edbd434a9e6608$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}




/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class $988a11d09320f6a8$var$TileSource extends (0, $ed6dc99f268f3882$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $cc435a5409103773$export$a71a825ff42fb8e1)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../TileCache.js").default}
     */ this.tileCache = new (0, $a12e09565a34db59$export$2e2bcd8739ae039)(options.cacheSize || 0);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || "";
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.tileCache.canExpireCache();
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */ expireCache(projection, usedTiles) {
        const tileCache = this.getTileCacheForProjection(projection);
        if (tileCache) tileCache.expireCache(usedTiles);
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @protected
   */ getTileCacheForProjection(projection) {
        const sourceProjection = this.getProjection();
        (0, $35d5ec884318008e$export$a7a9523472993e97)(sourceProjection === null || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection), "A VectorTile source can only be rendered if it has a projection compatible with the view projection.");
        return this.tileCache;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $cc435a5409103773$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $cc435a5409103773$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        projection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = this.getTileGridForProjection(projection);
        if (this.getWrapX() && projection.isGlobal()) tileCoord = (0, $5779655d81caea04$export$39a9ce3624977b84)(tileGrid, tileCoord, projection);
        return (0, $bf2a04496fadabc6$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
   * @api
   */ clear() {
        this.tileCache.clear();
    }
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
    /**
   * Marks a tile coord as being used, without triggering a load.
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ useTile(z, x, y, projection) {}
}
class $988a11d09320f6a8$export$c571855c51e6c4b6 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $988a11d09320f6a8$export$2e2bcd8739ae039 = $988a11d09320f6a8$var$TileSource;



/**
 * @module ol/tileurlfunction
 */ 
/**
 * @module ol/uri
 */ 

function $60db182c0252e220$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + "=" + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join("&");
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, "");
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes("?") ? "&" : "?";
    return uri + qs;
}
const $60db182c0252e220$var$zRegEx = /\{z\}/g;
const $60db182c0252e220$var$xRegEx = /\{x\}/g;
const $60db182c0252e220$var$yRegEx = /\{y\}/g;
const $60db182c0252e220$var$dashYRegEx = /\{-y\}/g;
function $60db182c0252e220$export$df1e52f1b5b1c86f(template, z, x, y, maxY) {
    return template.replace($60db182c0252e220$var$zRegEx, z.toString()).replace($60db182c0252e220$var$xRegEx, x.toString()).replace($60db182c0252e220$var$yRegEx, y.toString()).replace($60db182c0252e220$var$dashYRegEx, function() {
        if (maxY === undefined) throw new Error("If the URL template has a {-y} placeholder, the grid extent must be known");
        return (maxY - y).toString();
    });
}
function $60db182c0252e220$export$83e87e683240b2e8(urls, z, x, y) {
    const hash = (0, $bf2a04496fadabc6$export$731f79419750ccf7)(z, x, y);
    const index = (0, $6b000a049d919fe5$export$ba467bec01d66def)(hash, urls.length);
    return urls[index];
}
function $60db182c0252e220$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}



function $91dd08a0f5859882$export$f0ecb46e90798741(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, $60db182c0252e220$export$df1e52f1b5b1c86f)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function $91dd08a0f5859882$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $91dd08a0f5859882$export$f0ecb46e90798741(templates[i], tileGrid);
    return $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $91dd08a0f5859882$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $bf2a04496fadabc6$export$d6af199866bfb566)(tileCoord);
        const index = (0, $6b000a049d919fe5$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $91dd08a0f5859882$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}





/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $e6408236331c2614$var$UrlTile extends (0, $988a11d09320f6a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $e6408236331c2614$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $6c5e11070e371322$export$5e82334337e0f204)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).ERROR ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).LOADED ? (0, $7e3d7a0f8b272861$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $988a11d09320f6a8$export$c571855c51e6c4b6)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileCache.clear();
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        this.tileCache.pruneExceptNewestZ();
        if (typeof key !== "undefined") this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $60db182c0252e220$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join("\n");
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $91dd08a0f5859882$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
    /**
   * Marks a tile coord as being used, without triggering a load.
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @override
   */ useTile(z, x, y) {
        const tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) this.tileCache.get(tileCoordKey);
    }
}
var $e6408236331c2614$export$2e2bcd8739ae039 = $e6408236331c2614$var$UrlTile;






/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $51d055913ca55b5e$var$TileImage extends (0, $e6408236331c2614$export$2e2bcd8739ae039) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $51d055913ca55b5e$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $cd3bc8d185522361$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, TileCache>}
     */ this.tileCacheForProjection = {};
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @return {boolean} Can expire cache.
   * @override
   */ canExpireCache() {
        if (this.tileCache.canExpireCache()) return true;
        for(const key in this.tileCacheForProjection){
            if (this.tileCacheForProjection[key].canExpireCache()) return true;
        }
        return false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   * @override
   */ expireCache(projection, usedTiles) {
        const usedTileCache = this.getTileCacheForProjection(projection);
        this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
        for(const id in this.tileCacheForProjection){
            const tileCache = this.tileCacheForProjection[id];
            tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
        }
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ":disable-interpolation";
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $9c4744460e43e41b$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $5779655d81caea04$export$1f4812384df8a9c5)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../TileCache.js").default} Tile cache.
   * @override
   */ getTileCacheForProjection(projection) {
        const thisProj = this.getProjection();
        if (!thisProj || (0, $9c4744460e43e41b$export$fe091d73a555748b)(thisProj, projection)) return this.tileCache;
        const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileCacheForProjection)) this.tileCacheForProjection[projKey] = new (0, $a12e09565a34db59$export$2e2bcd8739ae039)(this.tileCache.highWaterMark);
        return this.tileCacheForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).IDLE : (0, $b8291d9739c3c64e$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : "", this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $9c4744460e43e41b$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const cache = this.getTileCacheForProjection(projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        let tile;
        const tileCoordKey = (0, $bf2a04496fadabc6$export$a47fb462a08de82f)(tileCoord);
        if (cache.containsKey(tileCoordKey)) tile = cache.get(tileCoordKey);
        const key = this.getKey();
        if (tile && tile.key == key) return tile;
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const newTile = new (0, $398e350e33050c07$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        newTile.key = key;
        if (tile) cache.replace(tileCoordKey, newTile);
        else cache.set(tileCoordKey, newTile);
        return newTile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection) {
        const tileCoordKey = (0, $bf2a04496fadabc6$export$92d0df0f1d25c63c)(z, x, y);
        const key = this.getKey();
        if (!this.tileCache.containsKey(tileCoordKey)) {
            const tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.set(tileCoordKey, tile);
            return tile;
        }
        let tile = this.tileCache.get(tileCoordKey);
        if (tile.key != key) {
            tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.replace(tileCoordKey, tile);
        }
        return tile;
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        for(const id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(projection);
        if (proj) {
            const projKey = (0, $6c5e11070e371322$export$5e82334337e0f204)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
    /**
   * @override
   */ clear() {
        super.clear();
        for(const id in this.tileCacheForProjection)this.tileCacheForProjection[id].clear();
    }
}
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $51d055913ca55b5e$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $51d055913ca55b5e$export$2e2bcd8739ae039 = $51d055913ca55b5e$var$TileImage;



/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Deprecated.  Use an ImageTile source with a loader
 * instead.  Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] Deprecated.  Use an ImageTile source and provide an array of URLs for the
 * url option instead.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $963a7ef65488964c$var$XYZ extends (0, $51d055913ca55b5e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : "EPSG:3857";
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $5779655d81caea04$export$38500bbeccc864ff)({
            extent: (0, $5779655d81caea04$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
}
var $963a7ef65488964c$export$2e2bcd8739ae039 = $963a7ef65488964c$var$XYZ;



var $acw62 = parcelRequire("acw62");


function $536f31bf23af746e$export$c2c2d7fec16485c1() {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const l = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
            opacity: 0,
            source: new (0, $963a7ef65488964c$export$2e2bcd8739ae039)({
                url: "https://api.maptiler.com/tiles/terrain-rgb/{z}/{x}/{y}.png?key=FjTRMbK3Ct060QVlsxbx",
                tileSize: 512,
                maxZoom: 12,
                crossOrigin: ""
            })
        });
        l.set("name", (0, $a48a327511f3c8e6$export$2963449ce9583ad5));
        map.addLayer(l);
    }, [
        map
    ]);
    return null;
}


function $c1c089d31abc8997$var$CursorPosition({ className: className }) {
    const controlRef = $acw62.useRef();
    const divRef = $acw62.useRef();
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map || !divRef.current) return;
        if (controlRef.current) // Already have a control
        return;
        controlRef.current = (0, $4549cd201b72b761$export$e23a2ede629f2806)(map, divRef.current);
        return ()=>{
            map.removeControl(controlRef.current);
        };
    }, [
        divRef.current,
        map
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        wide: true,
        align: true,
        between: true,
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "coords-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                    ref: divRef
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $536f31bf23af746e$export$c2c2d7fec16485c1), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mr: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    between: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mr: 4,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                fontSize: 12,
                                whiteSpace: "nowrap",
                                children: "\xa9 2025 Frag Orders, LLC. All rights reserved."
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mr: 4,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                                whiteSpace: "nowrap",
                                target: "_blank",
                                href: "https://docs.fragorders.com",
                                children: "Docs"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                            target: "_blank",
                            href: "https://discord.gg/mgdk8H9zhX",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38327c46e281f643$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        ]
    });
}
var $c1c089d31abc8997$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c1c089d31abc8997$var$CursorPosition).attrs({
    className: $c1c089d31abc8997$var$CursorPosition.name
})`
  position: absolute;
  bottom: 0px;

  z-index: 3;
  background-color: white;
  word-wrap: nowrap;
  /* Safari abs position + flex bug */

  .coords-container {
    padding: 4px;
    margin-right: 8px;
    flex: 1;

    width: 100%;
    pre {
      margin: 0;
      padding: 0;
    }
  }

  @media only screen and (max-width: 600px) {
    display: none;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");


function $ecc7df52b0c760fb$var$LayerSelector({ className: className, items: items, selectedLayers: selectedLayers, onChange: onChange, heading: heading = "Layers" }) {
    const handleChange = (checked, l)=>{
        onChange(l);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        className: className,
        column: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginRight: 16
                },
                children: heading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(items, (l)=>{
                        const on = !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(selectedLayers, l);
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                    onChange: (ev)=>handleChange(ev.target.checked, l),
                                    checked: on
                                }),
                                label: l.label
                            })
                        }, l.value);
                    })
                })
            })
        ]
    });
}
var $ecc7df52b0c760fb$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ecc7df52b0c760fb$var$LayerSelector)`
  background-color: ${(props)=>props.theme.palette.background.paper};
  z-index: 2;
  padding: 8px;
  opacity: 0.8;
  border-radius: 4px;
  min-width: 150px;

  ul {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  li {
    padding-right: 16px;
  }

  .MuiCheckbox-root {
    padding: 0 9px;
  }

  @media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    & {
      display: none;
    }
  }
`;


parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


function $051196b900f7d6e0$export$b2bdaef0c871405f() {
    const { state: state } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const [layers, setLayers] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const disabledLayers = state.disabledLayers;
        const layers = map.getLayers().getArray();
        for (const layer of layers){
            const tag = layer.get("filterTag") || layer.get("name");
            if (tag && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(disabledLayers, tag)) layer.setVisible(false);
            else layer.setVisible(true);
        }
        // Need to trigger a re-render here because map has changed.
        setLayers(layers);
    }, [
        map,
        state.disabledLayers
    ]);
    return {
        layers: layers,
        registerLayer: (layer)=>{
            setLayers([
                ...layers,
                layer
            ]);
        }
    };
}


function $04af159e2934cc2b$var$LayerControl({ className: className }) {
    const { layers: ml } = (0, $051196b900f7d6e0$export$b2bdaef0c871405f)();
    const { state: { disabledLayers: disabledLayers, disableUI: disableUI } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const toggle = (0, $99f46708ff5ed621$export$90155930613bed46)();
    const controllableLayers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(ml, (l)=>{
        return !!l.get("hideable");
    });
    const layers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(controllableLayers, (l)=>{
        return {
            label: l.get("name"),
            value: l.get("filterTag") || l.get("name"),
            enabled: !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(disabledLayers, l.get("filterTag"))
        };
    }), "value");
    const handleLayerSelect = (changed)=>{
        toggle([
            changed.value
        ]);
    };
    if (disableUI) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecc7df52b0c760fb$export$2e2bcd8739ae039), {
            heading: "Layers",
            items: layers,
            selectedLayers: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(layers, (l)=>!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(disabledLayers, l.value)),
            onChange: handleLayerSelect
        })
    });
}
var $04af159e2934cc2b$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($04af159e2934cc2b$var$LayerControl).attrs({
    className: $04af159e2934cc2b$var$LayerControl.name
})`
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 36px;
  right: 16px;

  ${(0, $ecc7df52b0c760fb$export$2e2bcd8739ae039)} {
    margin-bottom: 16px;
  }

  @media only screen and (max-width: 600px) {
    display: none;
  }

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    display: none;
  }
`;


(0, $9c4744460e43e41b$export$aa7494edfbe36197)();
const $5790baaab4a6e44c$export$2c4610b9e695e728 = /*#__PURE__*/ $acw62.createContext(null);
function $5790baaab4a6e44c$export$86f8f9f08863e403() {
    return $acw62.useContext($5790baaab4a6e44c$export$2c4610b9e695e728);
}
function $5790baaab4a6e44c$var$MapCanvas({ className: className, width: width, height: height, initialExtent: initialExtent, children: children }) {
    const { dispatch: dispatch, state: state } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const divRef = $acw62.useRef(null);
    const map = $acw62.useRef(null);
    const panning = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        (async ()=>{
            const m = await (0, $e8542b590c5a8fca$export$2e2bcd8739ae039)(divRef.current);
            const v = m.getView();
            if (initialExtent) {
                const ne = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(initialExtent, (e)=>e + 0);
                v.fit(ne);
                // Zoom out just a little bit to ensure the whole flight plan is visible
                v.adjustZoom(-0.2);
            } else {
                const center = (0, $79e13355954d15ea$export$836ff99bad0a09da)(state.tasking.theater);
                v.centerOn(center, m.getSize(), [
                    1,
                    1
                ]);
                v.adjustZoom(-2);
            }
            m.on("pointermove", (e)=>{
                panning.current = e.dragging;
            });
            m.on("pointerup", (e)=>{
                if ((0, $9c554d6df7d74017$export$8a7ef89a0633946c)(e) && !panning.current) // Turn things off on right click (that isn't a pan)
                dispatch({
                    type: (0, $99f46708ff5ed621$export$159e21535af98b26).setDrawMode,
                    mode: (0, $99f46708ff5ed621$export$bb7997377d28252d).None
                });
            });
            map.current = m;
            dispatch({
                type: (0, $99f46708ff5ed621$export$159e21535af98b26).mapReady
            });
        })();
    }, []);
    const layerGroups = $acw62.Children.map(children, (c)=>({
            title: c.props.name,
            layers: c.props.layers
        }));
    const dimensions = width && height ? {
        width: width,
        height: height
    } : null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($5790baaab4a6e44c$export$2c4610b9e695e728.Provider, {
            value: map.current,
            children: [
                children,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04af159e2934cc2b$export$2e2bcd8739ae039), {
                    layers: layerGroups
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $edd08701bc9eb69d$export$2e2bcd8739ae039), {
                    mapRef: map
                }),
                dimensions ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fo-map",
                    style: dimensions,
                    ref: divRef
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fo-map",
                    ref: divRef
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1c089d31abc8997$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $5790baaab4a6e44c$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($5790baaab4a6e44c$var$MapCanvas).attrs({
    className: $5790baaab4a6e44c$var$MapCanvas.name
})`
  background-color: white;
  position: relative;
  z-index: 0;
  width: 100%;

  .fo-map {
    height: 100vh;
    width: calc(100vw - ${(props)=>props.offsetLeft || 0}px);
  }

  .ol-tooltip {
    background-color: white;
    color: black;
    font-weight: bold;
    padding: 2px;
  }

  .ruler-active {
    background-color: white;
    color: blue;
  }

  .ol-attribution {
    display: none;
  }

  .ol-zoom {
    top: 50vh;
    left: unset;
    right: 8px;
  }
`;


function $da3c93492c01c66a$export$2e2bcd8739ae039({ features: features, style: style, name: name, foLayerID: foLayerID, filterTag: filterTag, hideable: hideable }) {
    const source = (0, $acw62.useRef)();
    const layer = (0, $acw62.useRef)();
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const f = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(features, (f)=>new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                ...f
            }));
        source.current = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            features: f
        });
        layer.current = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: source.current,
            style: style
        });
        layer.current.set("name", name);
        layer.current.set("hideable", hideable);
        if (foLayerID) layer.current.set("uniqID", foLayerID);
        if (filterTag) layer.current.set("filterTag", filterTag);
        map.addLayer(layer.current);
        map.renderSync();
        const extent = source.current.getExtent();
        if (extent) {
            const view = map.getView();
            const current = view.calculateExtent(map.getSize());
            const next = (0, $6da4c8ed3074c92b$export$8b58be045bf06082)(current, extent);
            map.getView().fit(next);
            view.adjustZoom(-0.01);
        }
    }, [
        map
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!source.current) return;
        const existing = source.current.getFeatures();
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(existing, (mapFeature)=>{
            source.current.removeFeature(mapFeature);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(features, (fe)=>{
            const f = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                ...fe
            });
            source.current.addFeature(f);
        });
    }, []);
    return null;
}


const $5bf64f63e772c9ba$export$e858a115168a55d6 = (theater, isOpfor)=>(b)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
            x: b.X,
            y: b.Z
        });
        const geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
            long,
            lat
        ]);
        const iff = isOpfor ? "H" : "F";
        return {
            name: b.Name,
            featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).Airbase,
            airbase: b,
            geometry: geometry,
            title: b.Name,
            freq: b.UHF || b.VHF,
            tacan: b.TACAN,
            sidc: b.UnitId ? `S${iff}SPCLCV----` : `S${iff}GPI-----H-`
        };
    };
const $5bf64f63e772c9ba$var$style = (isOpfor, color, renderFrequences)=>(feature)=>{
        const freq = renderFrequences ? feature.get("freq") : null;
        let label = `${feature.get("name")}\n${freq ? (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(freq) : ""}\n${feature.get("tacan") ? " " + feature.get("tacan") : ""}`;
        let colorOverride = color || "blue";
        if (isOpfor) {
            label = feature.get("name");
            colorOverride = "red";
        }
        return [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    opacity: 1,
                    src: "data:image/svg+xml;utf8," + new (0, (/*@__PURE__*/$parcel$interopDefault($e786e20e25c5f221$exports))).Symbol(feature.get("sidc"), {
                        size: 24
                    }, {
                        infoSize: 48
                    }).asSVG(),
                    scale: 1
                }),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: "bold 14px Roboto, sans-serif",
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: colorOverride
                    }),
                    text: label,
                    offsetY: 28
                })
            })
        ];
    };
function $5bf64f63e772c9ba$export$2e2bcd8739ae039({ bases: bases, theater: theater, isOpfor: isOpfor, color: color, renderFrequencies: renderFrequencies = true }) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(bases, $5bf64f63e772c9ba$export$e858a115168a55d6(theater, isOpfor));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        features: features,
        style: $5bf64f63e772c9ba$var$style(isOpfor, color, renderFrequencies),
        name: isOpfor ? (0, $91a9098e14452db2$export$fb028bc55343bb1f).OPFORBases : (0, $91a9098e14452db2$export$fb028bc55343bb1f).Bases,
        hideable: true
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");







var $acw62 = parcelRequire("acw62");




const $a3631ef098ab8d4c$var$shapes = (shape, radius, color)=>{
    const s = {
        circle: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
            radius: radius,
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: color
            })
        }),
        diamond: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: color
            }),
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: color,
                width: 2
            }),
            points: 4,
            radius: 10,
            rotation: Math.PI / 2,
            angle: 0
        })
    };
    return s[shape];
};
const $a3631ef098ab8d4c$export$c692a1d3c0fd781b = (colorOverride, radius = 5, shape = "circle", disableWaypointLabels = false)=>(feature)=>{
        let txt = feature.get("number").toString();
        const name = feature.get("name");
        const nameIsNumber = !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isNaN(parseInt(name));
        if (name && !nameIsNumber) txt = name;
        if (disableWaypointLabels) txt = "";
        if (feature.get("number") === 0) return;
        const color = colorOverride;
        var styles = [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: $a3631ef098ab8d4c$var$shapes(shape, radius, color),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: '18px "Roboto", "Arial Unicode MS", "sans-serif"',
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: color
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: "black",
                        width: 1
                    }),
                    text: txt,
                    offsetY: 20
                })
            })
        ];
        return styles;
    };
const $a3631ef098ab8d4c$var$uniqID = (group)=>`${group.name}_waypoints`;
const $a3631ef098ab8d4c$export$b63cca88ddc558a9 = (group, theater)=>(wp, i, allwp)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, wp);
        const geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
            long,
            lat
        ]);
        // Show waypoint names if they are meaninful.
        // If they are just numbers, hide them.
        const name = wp.name || wp.number.toString();
        const { leg: leg, total: total } = (0, $a48a327511f3c8e6$export$1b3e02615f43c5ec)(theater, wp, allwp);
        return {
            geometry: geometry,
            group: group.name,
            featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint,
            name: name,
            number: wp.number,
            type: wp.type,
            title: `${group.name} Waypoint ${wp.number}`,
            uniqID: $a3631ef098ab8d4c$var$uniqID(group),
            altitude: wp.alt,
            altitudeType: wp.alt_type,
            eta: wp.ETA,
            speed: wp.speed,
            waypoint: wp,
            legDistance: leg,
            totalDistance: total
        };
    };
// const debounced = _.debounce(
//   (theater: Theater) => (ev, layer: VectorLayer<VectorSource>) => {
//     const source = layer.getSource() as VectorSource;
//     const features = source.getFeatures() as Feature<Point>[];
//     for (const feature of features) {
//       configurePointFeature(feature.get("group"), theater)(
//         feature,
//         feature.get("number"),
//         features
//       );
//     }
//   },
//   1000
// );
function $a3631ef098ab8d4c$var$PointLayer({ group: group, theater: theater, color: color, filterTag: filterTag, disableWaypointLabels: disableWaypointLabels, declutter: declutter }) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const layerRef = $acw62.useRef();
    const sourceRef = $acw62.useRef();
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(group.waypoints, $a3631ef098ab8d4c$export$b63cca88ddc558a9(group, theater));
    $acw62.useEffect(()=>{
        if (!map) return;
        const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            features: features.map((f)=>new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(f))
        });
        const layer = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: source,
            style: $a3631ef098ab8d4c$export$c692a1d3c0fd781b(color, 5, "circle", disableWaypointLabels),
            renderBuffer: 100000,
            declutter: declutter
        });
        layerRef.current = layer;
        sourceRef.current = source;
        layer.set("filterTag", filterTag || group.name);
        layer.set("uniqID", $a3631ef098ab8d4c$var$uniqID(group));
        layer.set("name", group.name);
        map.addLayer(layer);
    }, [
        map
    ]);
    $acw62.useEffect(()=>{
        if (!layerRef.current || !sourceRef.current) return;
        const next = $a3631ef098ab8d4c$export$c692a1d3c0fd781b(color, 5, "circle", disableWaypointLabels);
        layerRef.current?.setStyle(next);
    }, [
        disableWaypointLabels
    ]);
    return null;
}
const $a3631ef098ab8d4c$export$7bfe86960c803747 = (theater, source, colorOverride, dotted, disableDistance)=>(feature)=>{
        const styles = [];
        const coords = feature.getGeometry().getCoordinates();
        const num = feature.get("number");
        const features = source.getFeatures();
        const prev = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(features, (f)=>f.get("number") === num - 1);
        const color = colorOverride;
        if (prev) {
            const prevCoords = prev.getGeometry().getCoordinates();
            const dist = feature.get("legDistance");
            const rot = (0, $a48a327511f3c8e6$export$2e1e9e0c5142c9d7)(prevCoords, coords, (0, $a48a327511f3c8e6$export$ff318d6e318fce97)(prevCoords[1], prevCoords[0], coords[1], coords[0]));
            const ls = new (0, $292e4002746c8223$export$2e2bcd8739ae039)([
                prevCoords,
                coords
            ]);
            styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                geometry: ls,
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: color,
                    width: 2,
                    lineDash: dotted ? [
                        10,
                        10
                    ] : null
                })
            }));
            if (!disableDistance && dist) styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(ls.getCoordinateAt(0.5)),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    rotation: -rot,
                    text: `${dist?.toFixed(1).toString()}NM`,
                    font: "14px sans-serif",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: color
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: "black",
                        width: 1
                    }),
                    offsetY: -8
                })
            }));
        // Couldn't get the triangle to point the right way...
        // styles.push(
        //   new Style({
        //     geometry: new Point(ls.getCoordinateAt(0.25)),
        //     image: new RegularShape({
        //       fill: new Fill({ color }),
        //       stroke: new Stroke({ color, width: 2 }),
        //       points: 3,
        //       radius: 20,
        //       rotateWithView: true,
        //       angle: 0,
        //       rotation: -rot,
        //       // displacement: [0, 200],
        //     }),
        //   })
        // );
        }
        return styles;
    };
function $a3631ef098ab8d4c$var$PathLayer({ theater: theater, group: group, color: color, filterTag: filterTag, dotted: dotted, disableDistanceLabels: disableDistanceLabels }) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const layerRef = $acw62.useRef();
    const sourceRef = $acw62.useRef();
    $acw62.useEffect(()=>{
        if (!map) return;
        // This path layer needs to be kept in sync with the point source.
        const pointLayer = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(map.getLayers().getArray(), (l)=>l.get("uniqID") === $a3631ef098ab8d4c$var$uniqID(group));
        const source = pointLayer.getSource();
        const layer = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: source,
            style: $a3631ef098ab8d4c$export$7bfe86960c803747(theater, source, color, dotted, disableDistanceLabels),
            renderBuffer: 100000,
            declutter: true
        });
        layerRef.current = layer;
        sourceRef.current = source;
        layer.set("filterTag", filterTag || group.name);
        map.addLayer(layer);
    }, [
        map,
        dotted
    ]);
    $acw62.useEffect(()=>{
        if (!layerRef.current || !sourceRef.current) return;
        const next = $a3631ef098ab8d4c$export$7bfe86960c803747(theater, sourceRef.current, color, dotted, disableDistanceLabels);
        layerRef.current?.setStyle(next);
    }, [
        disableDistanceLabels
    ]);
    return null;
}
function $a3631ef098ab8d4c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a3631ef098ab8d4c$var$PointLayer, {
                ...props
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a3631ef098ab8d4c$var$PathLayer, {
                ...props
            })
        ]
    });
}



function $1cf8f597a58d4025$export$e87e5ed6e6e32a15(theater, airbases) {
    if (!airbases || airbases.length === 0) return [];
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(airbases, (0, $5bf64f63e772c9ba$export$e858a115168a55d6)(theater, false));
    const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
        features: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(features, (f)=>new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                ...f
            }))
    });
    return source.getExtent();
}
function $1cf8f597a58d4025$export$63a77e50b78bd96(theater, group) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(group.waypoints, (0, $a3631ef098ab8d4c$export$b63cca88ddc558a9)(group, theater));
    const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
        features: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(features, (f)=>new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                ...f
            }))
    });
    return source.getExtent();
}
function $1cf8f597a58d4025$export$bcf8b7f0e3ae2f95(theater, groups) {
    let extent;
    for (const g of groups){
        const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(g.waypoints, (0, $a3631ef098ab8d4c$export$b63cca88ddc558a9)(g, theater));
        const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            features: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(features, (f)=>new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                    ...f
                }))
        });
        const e = source.getExtent();
        if (!extent) {
            // don't have one yet, nothing to exend
            extent = e;
            continue;
        }
        extent = (0, $6da4c8ed3074c92b$export$8b58be045bf06082)(extent, e);
    }
    return extent;
}
function $1cf8f597a58d4025$export$aacd22ce05963fb1(theater, groups) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
            x: g.x,
            y: g.y
        });
        return {
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                long,
                lat
            ]),
            name: g.name
        };
    });
    const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
        features: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(features, (f)=>new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                ...f
            }))
    });
    return source.getExtent();
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

function $5cf135077a5d2795$var$SVGWrapper({ height: height, width: width, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("foreignObject", {
            width: width,
            height: height,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                xmlns: "http://www.w3.org/1999/xhtml",
                children: children
            })
        })
    });
}
class $5cf135077a5d2795$var$generator {
    async renderToURL(el, opts) {
        const url = await this.render(true, el, opts);
        return url;
    }
    async renderToBlob(el, opts) {
        const blob = await this.render(false, el, opts);
        return blob;
    }
    render(asURL, el, opts) {
        return new Promise((accept, reject)=>{
            const canvas = document.createElement("canvas");
            canvas.height = opts.height;
            canvas.width = opts.width;
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = opts.fillColor || "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            const str = $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51(/*#__PURE__*/ (0, $acw62.createElement)($5cf135077a5d2795$var$SVGWrapper, {
                height: canvas.height,
                width: canvas.width,
                children: el
            }));
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.height = canvas.height;
            img.addEventListener("load", ()=>{
                ctx.drawImage(img, 0, 0);
                if (asURL) accept(canvas.toDataURL("image/png"));
                else canvas.toBlob((blob)=>{
                    accept(blob);
                });
            }, false);
            img.onerror = reject;
            img.width = canvas.width;
            img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(str)}`;
        });
    }
}
function $5cf135077a5d2795$export$b5430364fbdbee0e() {
    const g = new $5cf135077a5d2795$var$generator();
    return g;
}


class $9bfb1b056e7a5cd5$var$composer {
    add(data, opts) {
        this.images.push({
            data: data,
            opts: opts
        });
    }
    async render() {
        this.canvas = document.createElement("canvas");
        const canvas = this.canvas;
        canvas.height = this.height;
        canvas.width = this.width;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = this.backgroundColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        for (const cfg of this.images)await $9bfb1b056e7a5cd5$var$writeBlob(canvas, cfg);
    }
    async renderToBlob() {
        await this.render();
        return $9bfb1b056e7a5cd5$var$canvasToBlob(this.canvas);
    }
    async renderToURL() {
        await this.render();
        return this.canvas.toDataURL("image/png");
    }
    constructor(){
        this.backgroundColor = "#ffffff";
        this.images = [];
    }
}
async function $9bfb1b056e7a5cd5$var$canvasToBlob(canvas) {
    return new Promise((accept)=>{
        canvas.toBlob((blob)=>{
            accept(blob);
        });
    });
}
async function $9bfb1b056e7a5cd5$var$writeBlob(canvas, cfg) {
    return new Promise((accept, reject)=>{
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.height = canvas.height;
        img.addEventListener("load", ()=>{
            ctx.drawImage(img, cfg.opts.x, cfg.opts.y);
            accept();
        }, false);
        img.onerror = reject;
        img.width = canvas.width;
        img.src = URL.createObjectURL(cfg.data);
    });
}
function $9bfb1b056e7a5cd5$export$95422b89ba9092d1(height, width) {
    const c = new $9bfb1b056e7a5cd5$var$composer();
    c.height = height;
    c.width = width;
    return c;
}




var $ayMG0 = parcelRequire("ayMG0");



parcelRequire("acw62");



var $a4e0c9d7a276f99f$exports = {};
$a4e0c9d7a276f99f$exports = new URL("bulls-blue.70a6ca39.svg", import.meta.url).toString();


const $ef857df75211522c$var$style = ()=>()=>{
        return [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    anchor: [
                        0.5,
                        0.5
                    ],
                    anchorXUnits: "fraction",
                    anchorYUnits: "fraction",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a4e0c9d7a276f99f$exports))),
                    width: 32,
                    height: 32
                })
            })
        ];
    };
function $ef857df75211522c$export$2e2bcd8739ae039({ theater: theater, bullseye: bullseye }) {
    const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, bullseye);
    const point = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
        long,
        lat
    ]);
    const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
        geometry: point
    });
    feature.set("featureClass", (0, $91a9098e14452db2$export$589bf38da6f496d9).Bullseye);
    feature.set("name", "Bullseye");
    feature.set("bullseye", bullseye);
    //   const ft = NewMapFeature(feature);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        name: "Shared Nav Points",
        displayName: "Shared Nav Points",
        features: [
            {
                geometry: point,
                ...feature.getProperties()
            }
        ],
        style: $ef857df75211522c$var$style(),
        hideable: true
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");


const $939332248e5880d8$var$latLong = (theater, b)=>{
    const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
        x: b.X,
        y: b.Y
    });
    const [n, e] = (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
        long,
        lat
    ], 3);
    return `${n}\n${e}`;
};
const $939332248e5880d8$var$styles = {
    p: {
        margin: 0
    },
    heading: {
        fontWeight: 800
    },
    th: {
        borderBottom: "1px solid #000000"
    },
    tr: (index)=>({
            backgroundColor: index % 2 === 1 ? "#ffe194" : "#ffffff"
        }),
    td: {
        overflowWrap: "break-word"
    }
};
function $939332248e5880d8$var$KneeboardAirbasesTable({ theater: theater, bases: bases }) {
    const rows = [
        ...(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).take(bases, 10)
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: "100%",
            // width: "100%",
            fontFamily: "monospace",
            fontSize: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    style: {
                        fontSize: 18,
                        fontFamily: "sans-serif"
                    },
                    children: "Airfield and Support Asset Navigation Card"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                style: {
                    textAlign: "left",
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    style: $939332248e5880d8$var$styles.th,
                                    width: 30,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: $939332248e5880d8$var$styles.heading,
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: "Coordinates"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    style: $939332248e5880d8$var$styles.th,
                                    width: 10,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: $939332248e5880d8$var$styles.heading,
                                            children: "MSL (feet)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: "Meters"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    style: $939332248e5880d8$var$styles.th,
                                    width: 10,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: $939332248e5880d8$var$styles.heading,
                                            children: "TACAN"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: "VOR"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    style: $939332248e5880d8$var$styles.th,
                                    width: 30,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: $939332248e5880d8$var$styles.heading,
                                            children: "Runways"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: "ILS"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rows, (b, i)=>{
                            const altStr = b.supportType === (0, $c255bc447a24c026$export$99e832f86608bb2f).AWACS ? "" : b.Elevation?.replace("'", "");
                            const isSupport = !!b.supportType;
                            const supportNotes = isSupport ? `${b.supportType} (${b.unitType})` : "";
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                style: $939332248e5880d8$var$styles.tr(i),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $939332248e5880d8$var$styles.heading,
                                                children: b.Name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: b.supportType ? supportNotes : $939332248e5880d8$var$latLong(theater, b)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $939332248e5880d8$var$styles.heading,
                                                children: isSupport && b.supportType !== (0, $c255bc447a24c026$export$99e832f86608bb2f).AWACS ? Math.ceil((0, $79e13355954d15ea$export$d284c26147b5ca34)(parseInt(b.Elevation)) / 100) * 100 : altStr
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: altStr && !isSupport ? (0, $79e13355954d15ea$export$76afc266724c5901)(parseInt(altStr)).toFixed(0) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $939332248e5880d8$var$styles.heading,
                                                children: b.TACAN || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: b.VOR || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $939332248e5880d8$var$styles.heading,
                                                children: b.Runways || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: b.ILS || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, b.Name);
                        })
                    })
                ]
            })
        ]
    });
}
var $939332248e5880d8$export$2e2bcd8739ae039 = $939332248e5880d8$var$KneeboardAirbasesTable;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");








class $45164d3830ef5d35$export$9ed9e168ae73bd0e {
    init(luaStr, varName = "mission") {
        const env = (0, $0dc5bcacaa5e05aa$export$e19c4d7ca45727b2)(luaStr, varName);
        this.luaEnv = env;
    }
    run(customFunc, luaVar = "mission") {
        const customLib = new $0b8af60ab5d60464$export$54ec01a60f47d33d({
            customFunc: customFunc
        });
        this.luaEnv.loadLib("customLib", customLib);
        this.luaEnv.parse(`customLib.customFunc(${luaVar})`).exec();
    }
    print() {
        return (0, $0dc5bcacaa5e05aa$export$eefa2ea77bb6739b)(this.luaEnv);
    }
    client(varName) {
        return (0, $0dc5bcacaa5e05aa$export$a1a624bc799618af)(this.luaEnv, varName);
    }
}


const $b8845d04f48c0190$export$4f3f9abc0506b44c = {
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectAirbasesKneeboard]: ()=>"FragOrders_Airbase_Kneeboard",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).BriefingText]: ()=>"FragOrders_Briefing_Text_Kneeboard",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard]: (groupName)=>`FragOrders_Lineup_Card_${groupName}`,
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard]: (groupName)=>`FragOrders_Comms_Card_${groupName}`,
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard]: ()=>"FragOrders_Radio_Presets",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ControlPointsCard]: ()=>"FragOrders_Control_Points",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards]: ()=>"FragOrders_Route_Detail_Cards",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectSupportAssetsKneeboard]: ()=>"FragOrders_Support_Assets"
};
const $b8845d04f48c0190$export$867e91a0c7aed7fd = {
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectAirbasesKneeboard]: ()=>"Airbases",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).BriefingText]: ()=>"Briefing",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard]: (groupName)=>`Lineup Card - ${groupName}`,
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard]: (groupName)=>`Comms Card - ${groupName}`,
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard]: ()=>"Radio Presets",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ControlPointsCard]: ()=>"Control Points",
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards]: (groupName)=>`${groupName} - Route Detail`,
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectSupportAssetsKneeboard]: ()=>"Support Assets"
};
class $b8845d04f48c0190$var$runner {
    add(job) {
        this.jobs.push(job);
    }
    async run(fragOrder) {
        await this.setup(fragOrder.id);
        for (const job of this.jobs){
            if (!job) continue;
            if (job.luaFunc) {
                const lua = new (0, $45164d3830ef5d35$export$9ed9e168ae73bd0e)();
                lua.init(this.missionStr);
                lua.run(job.luaFunc);
                this.missionStr = lua.print();
            }
            if (job.zipFunc) this.miz = await job.zipFunc(this.miz);
        }
        return await this.assembleMiz();
    }
    async setup(id) {
        this.miz = await this.ms.download(id);
        const [missionStr] = await (0, $0dc5bcacaa5e05aa$export$c05b9514531d5fff)(this.miz);
        this.missionStr = missionStr;
    }
    async assembleMiz() {
        this.miz.file("mission", this.missionStr);
        return this.miz;
    }
    constructor(){
        this.jobs = [];
    }
}
function $b8845d04f48c0190$export$f72ab2bd281958c8(ms, fact) {
    const r = new $b8845d04f48c0190$var$runner();
    r.ms = ms;
    r.lua = fact;
    return r;
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
class $a36b596dfe840009$export$39755524c96b40ae {
    constructor(map){
        this.map = map;
    }
    async toImage() {
        const [blob] = await $a36b596dfe840009$export$aa33e3c8b743022c(this.map);
        return blob;
    }
    async toImageURL() {
        const [, canvas] = await $a36b596dfe840009$export$aa33e3c8b743022c(this.map);
        return canvas.toDataURL("image/png");
    }
}
async function $a36b596dfe840009$export$aa33e3c8b743022c(m) {
    return new Promise((accept)=>{
        m.once("rendercomplete", ()=>{
            const mapCanvas = document.createElement("canvas");
            const size = m.getSize();
            mapCanvas.width = size[0];
            mapCanvas.height = size[1];
            const mapContext = mapCanvas.getContext("2d");
            const nodes = m.getViewport().querySelectorAll(".ol-layer canvas, canvas.ol-layer") || [];
            nodes.forEach((canvas)=>{
                if (canvas.width > 0) {
                    const opacity = canvas.parentNode.style.opacity || canvas.style.opacity;
                    mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);
                    const backgroundColor = canvas.parentNode.style.backgroundColor;
                    if (backgroundColor) {
                        mapContext.fillStyle = backgroundColor;
                        mapContext.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    let matrix;
                    const transform = canvas.style.transform;
                    if (transform) // Get the transform parameters from the style's transform matrix
                    matrix = transform.match(/^matrix\(([^(]*)\)$/)[1].split(",").map(Number);
                    else matrix = [
                        parseFloat(canvas.style.width) / canvas.width,
                        0,
                        0,
                        parseFloat(canvas.style.height) / canvas.height,
                        0,
                        0
                    ];
                    // Apply the transform to the export map context
                    mapContext.setTransform(matrix);
                    mapContext.drawImage(canvas, 0, 0);
                }
            });
            mapCanvas.toBlob((blob)=>{
                accept([
                    blob,
                    mapCanvas
                ]);
            });
        });
        m.renderSync();
    });
}




/**
 * @module ol/source/TileJSON
 */ // FIXME check order of async callbacks
/**
 * See https://mapbox.com/developers/api/.
 */ 




/**
 * @module ol/net
 */ 
function $b9995293a67f37e1$export$3552a04808364507(url, callback, errback, callbackParam) {
    const script = document.createElement("script");
    const key = "olc_" + (0, $6c5e11070e371322$export$5e82334337e0f204)(callback);
    function cleanup() {
        delete window[key];
        script.parentNode.removeChild(script);
    }
    script.async = true;
    script.src = url + (url.includes("?") ? "&" : "?") + (callbackParam || "callback") + "=" + key;
    const timer = setTimeout(function() {
        cleanup();
        if (errback) errback();
    }, 10000);
    window[key] = function(data) {
        clearTimeout(timer);
        cleanup();
        callback(data);
    };
    document.head.appendChild(script);
}
class $b9995293a67f37e1$export$286baf652d0b1206 extends Error {
    /**
   * @param {XMLHttpRequest} response The XHR object.
   */ constructor(response){
        const message = "Unexpected response status: " + response.status;
        super(message);
        /**
     * @type {string}
     */ this.name = "ResponseError";
        /**
     * @type {XMLHttpRequest}
     */ this.response = response;
    }
}
class $b9995293a67f37e1$export$bb8c263ad32caa8 extends Error {
    /**
   * @param {XMLHttpRequest} client The XHR object.
   */ constructor(client){
        super("Failed to issue request");
        /**
     * @type {string}
     */ this.name = "ClientError";
        /**
     * @type {XMLHttpRequest}
     */ this.client = client;
    }
}
function $b9995293a67f37e1$export$d047a7c56db64af4(url) {
    return new Promise(function(resolve, reject) {
        /**
     * @param {ProgressEvent<XMLHttpRequest>} event The load event.
     */ function onLoad(event) {
            const client = event.target;
            // status will be 0 for file:// urls
            if (!client.status || client.status >= 200 && client.status < 300) {
                let data;
                try {
                    data = JSON.parse(client.responseText);
                } catch (err) {
                    const message = "Error parsing response text as JSON: " + err.message;
                    reject(new Error(message));
                    return;
                }
                resolve(data);
                return;
            }
            reject(new $b9995293a67f37e1$export$286baf652d0b1206(client));
        }
        /**
     * @param {ProgressEvent<XMLHttpRequest>} event The error event.
     */ function onError(event) {
            reject(new $b9995293a67f37e1$export$bb8c263ad32caa8(event.target));
        }
        const client = new XMLHttpRequest();
        client.addEventListener("load", onLoad);
        client.addEventListener("error", onError);
        client.open("GET", url);
        client.setRequestHeader("Accept", "application/json");
        client.send();
    });
}
function $b9995293a67f37e1$export$f85c16a6d62f7d63(base, url) {
    if (url.includes("://")) return url;
    return new URL(url, base).href;
}
let $b9995293a67f37e1$var$originalXHR;
function $b9995293a67f37e1$export$deeb0e1e5243b56c(xhr) {
    if (typeof XMLHttpRequest !== "undefined") $b9995293a67f37e1$var$originalXHR = XMLHttpRequest;
    $parcel$global.XMLHttpRequest = xhr;
}
function $b9995293a67f37e1$export$c2af84f345593eb8() {
    $parcel$global.XMLHttpRequest = $b9995293a67f37e1$var$originalXHR;
}


/**
 * @typedef {Object} Config
 * @property {string} [name] The name.
 * @property {string} [description] The description.
 * @property {string} [version] The version.
 * @property {string} [attribution] The attribution.
 * @property {string} [template] The template.
 * @property {string} [legend] The legend.
 * @property {string} [scheme] The scheme.
 * @property {Array<string>} tiles The tile URL templates.
 * @property {Array<string>} [grids] Optional grids.
 * @property {number} [minzoom] Minimum zoom level.
 * @property {number} [maxzoom] Maximum zoom level.
 * @property {Array<number>} [bounds] Optional bounds.
 * @property {Array<number>} [center] Optional center.
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {boolean} [jsonp=false] Use JSONP with callback to load the TileJSON.
 * Useful when the server does not support CORS..
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {Config} [tileJSON] TileJSON configuration for this source.
 * If not provided, `url` must be configured.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Note: `tileSize` and other non-standard TileJSON properties are currently ignored.
 * @property {string} [url] URL to the TileJSON file. If not provided, `tileJSON` must be configured.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data in TileJSON format.
 * @api
 */ class $492792e764651581$var$TileJSON extends (0, $51d055913ca55b5e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options TileJSON options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:3857"),
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            state: "loading",
            tileLoadFunction: options.tileLoadFunction,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @type {Config}
     * @private
     */ this.tileJSON_ = null;
        /**
     * @type {number|import("../size.js").Size}
     * @private
     */ this.tileSize_ = options.tileSize;
        if (options.url) {
            if (options.jsonp) (0, $b9995293a67f37e1$export$3552a04808364507)(options.url, this.handleTileJSONResponse.bind(this), this.handleTileJSONError.bind(this));
            else {
                const client = new XMLHttpRequest();
                client.addEventListener("load", this.onXHRLoad_.bind(this));
                client.addEventListener("error", this.onXHRError_.bind(this));
                client.open("GET", options.url);
                client.send();
            }
        } else if (options.tileJSON) this.handleTileJSONResponse(options.tileJSON);
        else throw new Error("Either `url` or `tileJSON` options must be provided");
    }
    /**
   * @private
   * @param {Event} event The load event.
   */ onXHRLoad_(event) {
        const client = /** @type {XMLHttpRequest} */ event.target;
        // status will be 0 for file:// urls
        if (!client.status || client.status >= 200 && client.status < 300) {
            let response;
            try {
                response = /** @type {Config} */ JSON.parse(client.responseText);
            } catch (err) {
                this.handleTileJSONError();
                return;
            }
            this.handleTileJSONResponse(response);
        } else this.handleTileJSONError();
    }
    /**
   * @private
   * @param {Event} event The error event.
   */ onXHRError_(event) {
        this.handleTileJSONError();
    }
    /**
   * @return {Config} The tilejson object.
   * @api
   */ getTileJSON() {
        return this.tileJSON_;
    }
    /**
   * @protected
   * @param {Config} tileJSON Tile JSON.
   */ handleTileJSONResponse(tileJSON) {
        const epsg4326Projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:4326");
        const sourceProjection = this.getProjection();
        let extent;
        if (tileJSON["bounds"] !== undefined) {
            const transform = (0, $9c4744460e43e41b$export$e3c4995a701c26a3)(epsg4326Projection, sourceProjection);
            extent = (0, $6da4c8ed3074c92b$export$9f9dcb98c894b623)(tileJSON["bounds"], transform);
        }
        const gridExtent = (0, $5779655d81caea04$export$7b5b6ef8fd55fac4)(sourceProjection);
        const minZoom = tileJSON["minzoom"] || 0;
        const maxZoom = tileJSON["maxzoom"] || 22;
        const tileGrid = (0, $5779655d81caea04$export$38500bbeccc864ff)({
            extent: gridExtent,
            maxZoom: maxZoom,
            minZoom: minZoom,
            tileSize: this.tileSize_
        });
        this.tileGrid = tileGrid;
        this.tileUrlFunction = (0, $91dd08a0f5859882$export$436f44dbcc31fea3)(tileJSON["tiles"], tileGrid);
        if (tileJSON["attribution"] && !this.getAttributions()) {
            const attributionExtent = extent !== undefined ? extent : gridExtent;
            this.setAttributions(function(frameState) {
                if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(attributionExtent, frameState.extent)) return [
                    tileJSON["attribution"]
                ];
                return null;
            });
        }
        this.tileJSON_ = tileJSON;
        this.setState("ready");
    }
    /**
   * @protected
   */ handleTileJSONError() {
        this.setState("error");
    }
}
var $492792e764651581$export$2e2bcd8739ae039 = $492792e764651581$var$TileJSON;



var $acw62 = parcelRequire("acw62");

function $96537245bb46b15e$export$a17bed72c0e7a8c6() {
    const source = new (0, $492792e764651581$export$2e2bcd8739ae039)({
        url: `https://api.maptiler.com/maps/openstreetmap/tiles.json?key=${"FjTRMbK3Ct060QVlsxbx"}`,
        tileSize: 512,
        crossOrigin: "anonymous"
    });
    const layer = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
        source: source
    });
    return layer;
}
function $96537245bb46b15e$export$2e2bcd8739ae039() {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const layer = $96537245bb46b15e$export$a17bed72c0e7a8c6();
        layer.set("name", "Map");
        layer.set("hideable", true);
        map.addLayer(layer);
    }, [
        map
    ]);
    return null;
}


function $49838b21bfe24b63$export$2e2bcd8739ae039({ height: height, width: width, children: children, extent: extent, onMount: onMount, disableRender: disableRender, zoomAdjust: zoomAdjust = -0.2 }) {
    const map = $acw62.useRef(null);
    const divRef = $acw62.useRef(null);
    const [, setReady] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!divRef.current || map.current) return;
        (async ()=>{
            const m = new (0, $41aa29ae0c4b607a$export$2e2bcd8739ae039)({
                target: divRef.current
            });
            const osmLayer = (0, $96537245bb46b15e$export$a17bed72c0e7a8c6)();
            m.addLayer(osmLayer);
            const v = m.getView();
            v.fit(extent);
            v.adjustZoom(zoomAdjust);
            map.current = m;
            m.renderSync();
            osmLayer.once("postrender", ()=>{
                setReady(true);
                if (onMount) onMount(new (0, $a36b596dfe840009$export$39755524c96b40ae)(m));
            });
        })();
    }, [
        divRef.current
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5790baaab4a6e44c$export$2c4610b9e695e728).Provider, {
        value: map.current,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                position: disableRender ? "fixed" : "relative",
                visibility: disableRender ? "hidden" : "visible"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    height: height || "100%",
                    width: width || "100%",
                    position: "fixed"
                },
                ref: divRef,
                children: children
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");




const $070f177e2e5a7c3e$var$divStyle = {
    display: "flex",
    margin: 8,
    fontFamily: "sans-serif",
    height: "100%",
    width: "98%",
    fontSize: 14,
    flexWrap: "wrap",
    justifyContent: "space-between"
};
const $070f177e2e5a7c3e$var$cellStyle = {
    borderBottom: "1px solid gray",
    overflow: "hidden",
    whiteSpace: "nowrap"
};
function $070f177e2e5a7c3e$export$2e2bcd8739ae039({ group: group }) {
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(group.units).type;
    const module = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
    const radios = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(group.units).radios;
    const radioCfg = module?.radios;
    if (!radioCfg || radioCfg.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            ...$070f177e2e5a7c3e$var$divStyle,
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            children: [
                "Kneeboard not supported for ",
                type
            ]
        })
    });
    const plannedPresets = group.plan?.radioOverrides;
    const overrides = plannedPresets ? JSON.parse(plannedPresets) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $070f177e2e5a7c3e$var$divStyle,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    style: {
                        fontSize: 18
                    },
                    children: [
                        group.name,
                        " - ",
                        module?.label || type,
                        " - Comms Card"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                    justifyContent: "space-between"
                },
                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(radioCfg, (r, idx)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            maxWidth: 320,
                            marginRight: 8,
                            marginBottom: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: r.label
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                                style: (0, $59e76ac65671d31b$export$9dd6ff9ea0189349).table,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                        style: (0, $59e76ac65671d31b$export$9dd6ff9ea0189349).th,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 32
                                                    },
                                                    children: "Chan"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 64
                                                    },
                                                    children: "Freq"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 32
                                                    },
                                                    children: "AM/FM"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 72
                                                    },
                                                    children: "Description"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).times(r.presetCount || 20, (t)=>{
                                            const planned = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(overrides, [
                                                idx,
                                                t
                                            ]);
                                            const fallback = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(radios, [
                                                idx,
                                                t
                                            ]);
                                            let freq = planned ? planned.frequency : fallback.frequency;
                                            let mod = planned ? planned.modulation : fallback.modulation;
                                            let desc = planned ? planned.description : "";
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                style: {
                                                    backgroundColor: t % 2 === 1 ? "#ffe194" : "#ffffff"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: {
                                                            ...$070f177e2e5a7c3e$var$cellStyle
                                                        },
                                                        children: t + 1
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: $070f177e2e5a7c3e$var$cellStyle,
                                                        children: (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(freq)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: $070f177e2e5a7c3e$var$cellStyle,
                                                        children: mod === (0, $91a9098e14452db2$export$459e66e1d1ce05ca).FM ? "FM" : "AM"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: $070f177e2e5a7c3e$var$cellStyle,
                                                        children: desc
                                                    })
                                                ]
                                            }, t);
                                        })
                                    })
                                ]
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
}



const $59e76ac65671d31b$export$8cc1a63178152958 = 957;
const $59e76ac65671d31b$export$9b1cdce8e74ca79e = 717;
async function $59e76ac65671d31b$export$fe4501d50e7230de(extent, opts, children, asURL) {
    if (!extent) throw new Error("Extent is required");
    return new Promise((accept)=>{
        const el = document.createElement("div");
        document.body.appendChild(el);
        const root = $7e96a608cb33bf79$export$882461b6382ed46c(el);
        root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $49838b21bfe24b63$export$2e2bcd8739ae039), {
            disableRender: true,
            onMount: async (ctrl)=>{
                if (asURL) {
                    const uri = await ctrl.toImageURL();
                    accept(uri);
                } else {
                    const blob = await ctrl.toImage();
                    accept(blob);
                }
            },
            height: opts.height,
            width: opts.width,
            extent: extent,
            zoomAdjust: opts.zoomAdjust,
            children: children
        }));
    });
}
async function $59e76ac65671d31b$export$933d533764865bb(tasking, title) {
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)($59e76ac65671d31b$export$8cc1a63178152958, $59e76ac65671d31b$export$9b1cdce8e74ca79e);
    const el = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: "flex",
                    width: "100%",
                    fontFamily: "sans-serif",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    children: [
                        title,
                        " - Mission Briefing"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                style: {
                    whiteSpace: "pre-wrap",
                    width: 701,
                    fontSize: 16
                },
                children: tasking.briefingText
            })
        ]
    });
    const blob = await g.renderToBlob(el, {
        height: $59e76ac65671d31b$export$8cc1a63178152958,
        width: $59e76ac65671d31b$export$9b1cdce8e74ca79e
    });
    composer.add(blob, {
        x: 10,
        y: 0
    });
    return composer;
}
async function $59e76ac65671d31b$export$62862cd479f79fd7(group) {
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)($59e76ac65671d31b$export$8cc1a63178152958, $59e76ac65671d31b$export$9b1cdce8e74ca79e);
    const el = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $070f177e2e5a7c3e$export$2e2bcd8739ae039), {
        group: group
    });
    const blob = await g.renderToBlob(el, {
        height: $59e76ac65671d31b$export$8cc1a63178152958,
        width: $59e76ac65671d31b$export$9b1cdce8e74ca79e - 8
    });
    composer.add(blob, {
        x: 0,
        y: 0
    });
    return composer;
}
const $59e76ac65671d31b$export$9dd6ff9ea0189349 = {
    table: {
        textAlign: "left",
        width: "100%",
        borderCollapse: "collapse",
        tableLayout: "fixed",
        border: "1px solid black"
    },
    th: {
        fontSize: 12,
        border: "1px solid black"
    },
    td: {
        border: "1px solid gray",
        overflow: "hidden",
        whiteSpace: "nowrap"
    }
};
async function $59e76ac65671d31b$export$8887fdde5f502e63(fo, coa, title, tasking, external, planItems, zip) {
    const jobs = fo.jobs;
    const perGroupJobs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(jobs, (j)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes([
            (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard,
            (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard,
            (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards
        ], j);
    });
    const otherJobs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(jobs, (j)=>{
        return !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(perGroupJobs, j);
    });
    for (const group of tasking.plannedGroups)for (const job of perGroupJobs){
        const settings = fo.jobSettings[job];
        const composer = await (0, $e0c6a541dbb07ec6$export$56b3e1b6a6adb266)(job, tasking, {
            group: group,
            title: title,
            radioConfig: fo.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig]
        }, settings, external, planItems);
        const blob = await composer.renderToBlob();
        const name = (0, $b8845d04f48c0190$export$4f3f9abc0506b44c)[job];
        zip.file(`${group.name}/${name(group.name)}.png`, blob);
    }
    for (const job of otherJobs){
        const settings = fo.jobSettings[job];
        const composer = await (0, $e0c6a541dbb07ec6$export$56b3e1b6a6adb266)(job, tasking, {
            title: title,
            radioConfig: fo.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig]
        }, settings, external, planItems);
        if (!composer) continue;
        const blob = await composer.renderToBlob();
        const name = (0, $b8845d04f48c0190$export$4f3f9abc0506b44c)[job];
        zip.file(`${name()}.png`, blob);
    }
}


async function $366e7823df40ef4e$export$8fdd276949ba31d5(tasking, jobSettings) {
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)((0, $59e76ac65671d31b$export$8cc1a63178152958), (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e));
    const el = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $939332248e5880d8$export$2e2bcd8739ae039), {
        settings: jobSettings,
        theater: tasking.theater,
        bases: tasking?.airbases
    });
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const tblBlob = await g.renderToBlob(el, {
        height: (0, $59e76ac65671d31b$export$8cc1a63178152958) / 2 + 100,
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e)
    });
    if (!tasking?.airbases || tasking.airbases.length === 0) throw new Error("No airbases found. Unable to render kneeboard.");
    let ext = (0, $1cf8f597a58d4025$export$e87e5ed6e6e32a15)(tasking.theater, tasking?.airbases);
    const mapImg = await (0, $59e76ac65671d31b$export$fe4501d50e7230de)(ext, {
        height: ((0, $59e76ac65671d31b$export$8cc1a63178152958) - 100) / 2,
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e),
        zoomAdjust: -1.2
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bf64f63e772c9ba$export$2e2bcd8739ae039), {
                isOpfor: false,
                theater: tasking?.theater,
                bases: tasking?.airbases,
                color: "black",
                renderFrequencies: jobSettings?.showAirbaseFreqs
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef857df75211522c$export$2e2bcd8739ae039), {
                theater: tasking.theater,
                bullseye: tasking.bullseye
            })
        ]
    }));
    composer.add(tblBlob, {
        x: 0,
        y: 0
    });
    composer.add(mapImg, {
        x: 0,
        y: ((0, $59e76ac65671d31b$export$8cc1a63178152958) + 100) / 2
    });
    return composer;
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");



parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");


parcelRequire("acw62");



const $50f4a82b70a68396$var$color = "#0037ff";
const $50f4a82b70a68396$var$styles = ()=>(feature)=>{
        return [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                    // Transparent so clicks work
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: $50f4a82b70a68396$var$color
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: $50f4a82b70a68396$var$color,
                        width: 4
                    }),
                    radius: 5
                }),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: 'bold 14px "Roboto", "Arial Unicode MS", "sans-serif"',
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: $50f4a82b70a68396$var$color
                    }),
                    text: feature.get("label"),
                    offsetY: 24,
                    backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: "#ffffffbd"
                    })
                })
            })
        ];
    };
function $50f4a82b70a68396$export$2e2bcd8739ae039({ theater: theater, points: points }) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(points, (p)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, p);
        const geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
            long,
            lat
        ]);
        return {
            geometry: geometry,
            point: p,
            featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).ControlPoint,
            label: p.callsignStr,
            name: p.callsignStr
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        features: features,
        foLayerID: (0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlPoints,
        style: $50f4a82b70a68396$var$styles(),
        name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlPoints,
        hideable: true
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");


const $28426700a5660f3c$var$divStyle = {
    display: "flex",
    margin: 8,
    fontFamily: "sans-serif",
    height: "100%",
    width: "98%",
    fontSize: 14,
    flexWrap: "wrap",
    justifyContent: "space-between"
};
const $28426700a5660f3c$var$cellStyle = {
    borderBottom: "1px solid gray",
    overflow: "hidden",
    whiteSpace: "nowrap"
};
const $28426700a5660f3c$var$trStyle = (index)=>({
        backgroundColor: index % 2 === 1 ? "#ffe194" : "#ffffff"
    });
function $28426700a5660f3c$export$2e2bcd8739ae039({ theater: theater, controlPoints: controlPoints }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $28426700a5660f3c$var$divStyle,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    textAlign: "center",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    style: {
                        fontSize: 18
                    },
                    children: "Control Measures"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                    justifyContent: "space-between"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                        style: (0, $59e76ac65671d31b$export$9dd6ff9ea0189349).table,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                style: (0, $59e76ac65671d31b$export$9dd6ff9ea0189349).th,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            style: {
                                                width: 24
                                            },
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            style: {
                                                width: 48
                                            },
                                            children: "Comment"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            style: {
                                                width: 36
                                            },
                                            children: "LL (DM)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            style: {
                                                width: 36
                                            },
                                            children: "LL (DMS)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            style: {
                                                width: 36
                                            },
                                            children: "MGRS"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(controlPoints, (cp, i)=>{
                                    const coords = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, cp);
                                    const { lat: lat, long: long } = coords;
                                    const str = (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
                                        long,
                                        lat
                                    ], 3);
                                    const mgrs = str[2];
                                    const longDMS = (0, $79e13355954d15ea$export$5380b7513846c4b2)(long, false);
                                    const latDMS = (0, $79e13355954d15ea$export$5380b7513846c4b2)(lat, true);
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                        style: $28426700a5660f3c$var$trStyle(i),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                style: $28426700a5660f3c$var$cellStyle,
                                                children: cp.callsignStr
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                style: $28426700a5660f3c$var$cellStyle,
                                                children: cp.comment
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                style: $28426700a5660f3c$var$cellStyle,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).padStart(str[0], 13, " ")
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: str[1]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                style: $28426700a5660f3c$var$cellStyle,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        children: latDMS
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        children: longDMS
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                style: $28426700a5660f3c$var$cellStyle,
                                                children: mgrs
                                            })
                                        ]
                                    }, cp.id);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}



async function $6989236d425f0950$export$dfd7129622cfccc3(tasking) {
    const trimmed = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).take(tasking.controlPoints, 15);
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)((0, $59e76ac65671d31b$export$8cc1a63178152958), (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e));
    if (trimmed.length === 0) throw new Error(`No control points to render. Disable the "Inject Control Points" kneeboard job to resolve this issue.`);
    const el = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28426700a5660f3c$export$2e2bcd8739ae039), {
        theater: tasking.theater,
        controlPoints: trimmed
    });
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const blob = await g.renderToBlob(el, {
        height: (0, $59e76ac65671d31b$export$8cc1a63178152958),
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e) - 8
    });
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(trimmed, (cp)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(tasking.theater, cp);
        return new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                long,
                lat
            ])
        });
    });
    const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
        features: features
    });
    const extent = source.getExtent();
    const height = (0, $59e76ac65671d31b$export$8cc1a63178152958) / 3;
    const width = (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e);
    const mapImg = await (0, $59e76ac65671d31b$export$fe4501d50e7230de)(extent, {
        height: height,
        width: width,
        zoomAdjust: -0.3
    }, /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50f4a82b70a68396$export$2e2bcd8739ae039), {
            points: trimmed,
            theater: tasking.theater
        })
    }));
    composer.add(blob, {
        x: 4,
        y: 0
    });
    composer.add(mapImg, {
        x: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e) - width,
        y: (0, $59e76ac65671d31b$export$8cc1a63178152958) - height
    });
    return composer;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");



parcelRequire("acw62");




const $5404f6a81ab6ced0$export$18237acf550aab6a = (size = 24, displayName)=>(feature)=>{
        const icon = "data:image/svg+xml;utf8," + new (0, (/*@__PURE__*/$parcel$interopDefault($e786e20e25c5f221$exports))).Symbol(feature.get("sidc"), {
            size: size
        }).asSVG();
        return [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    opacity: 1,
                    src: icon,
                    scale: 1
                }),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: 'bold 14px "Arial", "Arial Unicode MS", "sans-serif"',
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: "#000"
                    }),
                    text: displayName ? feature.get("name") : null,
                    offsetY: 36
                })
            }),
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({})
            })
        ];
    };
function $5404f6a81ab6ced0$export$2e2bcd8739ae039({ groups: groups, theater: theater, name: name, isOpfor: isOpfor, size: size = 24, titleOverride: titleOverride = null, style: style = $5404f6a81ab6ced0$export$18237acf550aab6a(size) }) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (group)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
            x: group.x,
            y: group.y
        });
        let title = group.name;
        if (titleOverride) title = titleOverride;
        return {
            name: group.name,
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                long,
                lat
            ]),
            featureClass: isOpfor ? (0, $91a9098e14452db2$export$589bf38da6f496d9).OPFORGroups : null,
            title: title,
            sidc: (0, $75a1e531b08ffb65$export$af576a01257ae419)(isOpfor, group.category, group.supportType, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(group.units, "type")),
            group: group
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        features: features,
        style: style,
        name: name,
        hideable: true
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");



var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");


parcelRequire("acw62");



const $6a33db4e41351fb9$export$957d7daebd899f12 = (comment)=>{
    const text = comment?.split("\n")[0] || "Nav Point";
    return text;
};
const $6a33db4e41351fb9$export$6106ebb8e8b4f99d = (color)=>(feature)=>{
        const comment = feature.get("point")?.textComment?.toString() || "";
        const text = $6a33db4e41351fb9$export$957d7daebd899f12(comment);
        return [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: color
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: "black"
                    }),
                    points: 3,
                    radius: 12
                }),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: 'bold 18px "Roboto", "Arial Unicode MS", "sans-serif"',
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: color
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: "black",
                        width: 2
                    }),
                    text: text,
                    offsetY: 20
                })
            })
        ];
    };
const $6a33db4e41351fb9$var$toNavPoint = (theater, group)=>(point)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, point);
        const geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
            long,
            lat
        ]);
        return {
            geometry: geometry,
            point: point,
            name: `${group.name} Nav Point ${point.index}`,
            // name: `nav/${group.name}/${point.index}`,
            featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).NavPoint,
            group: group.name
        };
    };
function $6a33db4e41351fb9$export$2e2bcd8739ae039({ group: group, color: color, planItemNavPoints: planItemNavPoints, filterTag: filterTag, theater: theater }) {
    const planPoints = planItemNavPoints && planItemNavPoints.length > 0;
    const navPoints = group?.navTargetPoints || group?.plan?.navPoints;
    const collection = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniqBy((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(navPoints || [], planPoints ? planItemNavPoints : []), "index");
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(collection, $6a33db4e41351fb9$var$toNavPoint(theater, group));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        features: features,
        style: $6a33db4e41351fb9$export$6106ebb8e8b4f99d(color),
        filterTag: filterTag,
        name: $6a33db4e41351fb9$export$d03821c02d9d2c2f(group.name)
    });
}
function $6a33db4e41351fb9$export$d03821c02d9d2c2f(groupName) {
    return `${groupName} Nav Points`;
}



const $5bc458713ae03df2$export$aedfc9d54728a259 = (theater, featureClass)=>(group)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
            x: group.x,
            y: group.y
        });
        return {
            name: group.name,
            featureClass: featureClass,
            group: group,
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                long,
                lat
            ]),
            sidc: (0, $75a1e531b08ffb65$export$af576a01257ae419)(false, group.category, group.supportType)
        };
    };
function $5bc458713ae03df2$export$2e2bcd8739ae039({ groups: groups, theater: theater, layerName: layerName, colorOverride: colorOverride, disableDistanceLabels: disableDistanceLabels, disableWaypointLabels: disableWaypointLabels, declutter: declutter, renderIcon: renderIcon = true, planItemNavPoints: planItemNavPoints }) {
    const colorMap = (0, $99f46708ff5ed621$export$6af74cd118fd0c5d)();
    const features = renderIcon ? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, $5bc458713ae03df2$export$aedfc9d54728a259(theater, (0, $91a9098e14452db2$export$589bf38da6f496d9).FlyableGroup)) : [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>{
                const color = colorOverride || colorMap[g.name];
                const points = planItemNavPoints.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(planItemNavPoints, {
                    group: g.name
                }), (item)=>JSON.parse(item.payload)) : [];
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3631ef098ab8d4c$export$2e2bcd8739ae039), {
                            theater: theater,
                            group: g,
                            color: color,
                            filterTag: (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)(layerName, [
                                g.name
                            ]),
                            disableDistanceLabels: disableDistanceLabels,
                            disableWaypointLabels: disableWaypointLabels,
                            declutter: declutter
                        }, `${g.name}/route`),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a33db4e41351fb9$export$2e2bcd8739ae039), {
                            theater: theater,
                            color: color,
                            group: g,
                            filterTag: (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)(layerName, [
                                g.name
                            ]),
                            planItemNavPoints: points
                        }, `${g.name}/nav`)
                    ]
                }, g.name);
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
                features: features,
                style: (0, $5404f6a81ab6ced0$export$18237acf550aab6a)(24),
                name: layerName
            })
        ]
    });
}




// Match NATO symbol blue
const $26edd936cfd125a0$var$SUPPORT_ASSET_COLOR = "#54B7D9";
function $26edd936cfd125a0$export$2e2bcd8739ae039({ groups: groups, theater: theater, color: color = $26edd936cfd125a0$var$SUPPORT_ASSET_COLOR, disableWaypointLabels: disableWaypointLabels = false }) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (0, $5bc458713ae03df2$export$aedfc9d54728a259)(theater, (0, $91a9098e14452db2$export$589bf38da6f496d9).SupportAsset));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3631ef098ab8d4c$export$2e2bcd8739ae039), {
                    group: g,
                    theater: theater,
                    filterTag: (0, $91a9098e14452db2$export$fb028bc55343bb1f).SupportAssets,
                    color: color,
                    disableWaypointLabels: disableWaypointLabels,
                    disableDistanceLabels: true
                }, g.name)),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
                features: features,
                style: (0, $5404f6a81ab6ced0$export$18237acf550aab6a)(24, true),
                name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).SupportAssets,
                hideable: true
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



const $cc319f66f442f913$var$styles = {
    p: {
        margin: 0
    },
    heading: {
        fontWeight: 800
    },
    th: {
        borderBottom: "1px solid #000000"
    },
    tr: (index)=>({
            backgroundColor: index % 2 === 1 ? "#ffe194" : "#ffffff"
        }),
    td: {
        overflowWrap: "break-word"
    }
};
function $cc319f66f442f913$var$KneeboardSupportAssets({ support: support, settings: settings }) {
    const assets = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(support, (s)=>{
        const isSupport = !!s.supportType;
        const wps = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(s, "waypoints");
        const highestAlt = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).maxBy(wps, (u)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(u, "alt", 0)), "alt") || "";
        const TACAN = (0, $c255bc447a24c026$export$1cc6625bb95a1f24)(s.units[0], s);
        return {
            supportType: s.supportType,
            Elevation: isSupport ? highestAlt?.toString() : "",
            TACAN: TACAN,
            UHF: s.channel.frequency,
            X: s.x,
            Y: s.y,
            Name: s.name,
            unitType: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(s, "units[0].type")
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: "100%",
            // width: "100%",
            fontFamily: "monospace",
            fontSize: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    style: {
                        fontSize: 18,
                        fontFamily: "sans-serif"
                    },
                    children: "Support Asset Card"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                style: {
                    textAlign: "left",
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    style: $cc319f66f442f913$var$styles.th,
                                    width: 30,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: $cc319f66f442f913$var$styles.heading,
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: "Type"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    style: $cc319f66f442f913$var$styles.th,
                                    width: 10,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: $cc319f66f442f913$var$styles.heading,
                                        children: "MSL (feet)"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    style: $cc319f66f442f913$var$styles.th,
                                    width: 10,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: $cc319f66f442f913$var$styles.heading,
                                            children: "UHF"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: "VHF"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    style: $cc319f66f442f913$var$styles.th,
                                    width: 10,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: "TACAN"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(assets, (b, i)=>{
                            const altStr = b.supportType === (0, $c255bc447a24c026$export$99e832f86608bb2f).AWACS ? "" : b.Elevation.replace("'", "");
                            const isSupport = !!b.supportType;
                            const supportNotes = isSupport ? `${b.supportType} (${b.unitType})` : "";
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                style: $cc319f66f442f913$var$styles.tr(i),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $cc319f66f442f913$var$styles.heading,
                                                children: b.Name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: supportNotes
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $cc319f66f442f913$var$styles.heading,
                                                children: isSupport && b.supportType !== (0, $c255bc447a24c026$export$99e832f86608bb2f).AWACS ? Math.ceil((0, $79e13355954d15ea$export$d284c26147b5ca34)(parseInt(b.Elevation)) / 100) * 100 : altStr
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: altStr && !isSupport ? (0, $79e13355954d15ea$export$76afc266724c5901)(parseInt(altStr)).toFixed(0) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        style: {
                                            opacity: !isSupport && !settings?.showAirbaseFreqs ? 0 : 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $cc319f66f442f913$var$styles.heading,
                                                children: b.UHF ? (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(b.UHF) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: "\xa0"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: $cc319f66f442f913$var$styles.heading,
                                                children: b.TACAN ? b.TACAN : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa0"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: "\xa0"
                                            })
                                        ]
                                    })
                                ]
                            }, b.Name);
                        })
                    })
                ]
            })
        ]
    });
}
var $cc319f66f442f913$export$2e2bcd8739ae039 = $cc319f66f442f913$var$KneeboardSupportAssets;



async function $9ba3ac95ea50b8ac$export$55eed746402cf864(tasking, jobSettings) {
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)((0, $59e76ac65671d31b$export$8cc1a63178152958), (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e));
    if (!tasking.supportAssets || tasking.supportAssets.length === 0) throw new Error(`No support assets to render. Please disable the "Inject Support Assets" kneeboard job to resolve this issue.`);
    const el = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc319f66f442f913$export$2e2bcd8739ae039), {
        settings: jobSettings,
        theater: tasking.theater,
        support: tasking?.supportAssets
    });
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const tblBlob = await g.renderToBlob(el, {
        height: (0, $59e76ac65671d31b$export$8cc1a63178152958) / 2 + 100,
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e)
    });
    let ext = (0, $1cf8f597a58d4025$export$bcf8b7f0e3ae2f95)(tasking.theater, tasking?.supportAssets);
    const mapImg = await (0, $59e76ac65671d31b$export$fe4501d50e7230de)(ext, {
        height: ((0, $59e76ac65671d31b$export$8cc1a63178152958) - 100) / 2,
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e),
        zoomAdjust: -0.2
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26edd936cfd125a0$export$2e2bcd8739ae039), {
                theater: tasking.theater,
                groups: tasking.supportAssets,
                color: "black"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef857df75211522c$export$2e2bcd8739ae039), {
                theater: tasking.theater,
                bullseye: tasking.bullseye
            })
        ]
    }));
    composer.add(tblBlob, {
        x: 0,
        y: 0
    });
    composer.add(mapImg, {
        x: 0,
        y: ((0, $59e76ac65671d31b$export$8cc1a63178152958) + 100) / 2
    });
    return composer;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");








var $acw62 = parcelRequire("acw62");



const $c48252d8bfb57141$var$color = "grey";
const $c48252d8bfb57141$var$style = ()=>(feature)=>{
        let geometry = feature.getGeometry();
        const text = new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
            font: "14px Roboto bold,sans-serif",
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "black"
            }),
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: "black",
                width: 1
            }),
            text: feature.get("label"),
            backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "#ffffff93"
            }),
            offsetX: 0,
            offsetY: 0
        });
        const textStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            text: text
        });
        const textPosition = feature.get("textPosition");
        if (textPosition) textStyle.setGeometry(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(textPosition));
        const styles = [];
        if (geometry instanceof (0, $292e4002746c8223$export$2e2bcd8739ae039)) {
            const bearing = feature.get("bearing");
            if (bearing === 0) textStyle.getText().setText("");
            textStyle.setGeometry(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(geometry.getLastCoordinate()));
        }
        if (geometry instanceof (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)) {
            textStyle.getText().setOffsetX(12);
            textStyle.getText().setOffsetY(-10);
        }
        styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            geometry: geometry,
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: $c48252d8bfb57141$var$color,
                width: 2
            })
        }));
        styles.push(textStyle);
        return styles;
    };
const $c48252d8bfb57141$export$736dbcdec949fdf9 = ([long, lat])=>new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            features: [
                ...[
                    0,
                    45,
                    90,
                    135,
                    180,
                    225,
                    270,
                    315
                ].map((bearing)=>{
                    return new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                        geometry: new (0, $292e4002746c8223$export$2e2bcd8739ae039)([
                            [
                                long,
                                lat
                            ],
                            $c48252d8bfb57141$var$getEnd(long, lat, 120, bearing)
                        ]),
                        bearing: bearing,
                        label: `${bearing}\xb0`
                    });
                }),
                ...[
                    20,
                    40,
                    60,
                    80,
                    100,
                    120
                ].map((distance)=>{
                    const circle = (0, $40aa8d43bbe572bf$export$f99d756c6d81ae3f)([
                        long,
                        lat
                    ], (0, $79e13355954d15ea$export$f855e4255431a6a0)(distance));
                    return new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                        geometry: circle,
                        label: `${distance}`,
                        textPosition: $fb75384508533d8f$export$cc800923e997bb8([
                            long,
                            lat
                        ], (0, $79e13355954d15ea$export$f855e4255431a6a0)(distance), $c48252d8bfb57141$var$degressToRadians(0))
                    });
                })
            ]
        }),
        style: $c48252d8bfb57141$var$style()
    });
const $c48252d8bfb57141$export$9424b4281d9e66ee = ({ bulls: bulls, visible: visible, theater: theater })=>{
    const layerRef = $acw62.useRef(null);
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    $acw62.useEffect(()=>{
        if (!map) return;
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, bulls);
        const vectorLayer = $c48252d8bfb57141$export$736dbcdec949fdf9([
            long,
            lat
        ]);
        // addLayer turns on visibility by default, so we need to turn it off
        vectorLayer.setStyle(null);
        layerRef.current = vectorLayer;
        map.addLayer(vectorLayer);
        return ()=>{
            if (map && layerRef.current) map.removeLayer(layerRef.current);
        };
    }, [
        map
    ]);
    $acw62.useEffect(()=>{
        if (!layerRef.current) return;
        if (visible) layerRef.current.setStyle($c48252d8bfb57141$var$style());
        else layerRef.current.setStyle(null);
    }, [
        map,
        visible
    ]);
    return null;
};
function $c48252d8bfb57141$export$2e2bcd8739ae039() {
    const { state: { compassVisible: compassVisible, tasking: { theater: theater, bullseye: bullseye } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c48252d8bfb57141$export$9424b4281d9e66ee, {
        bulls: bullseye,
        visible: compassVisible,
        theater: theater
    });
}
function $c48252d8bfb57141$var$degressToRadians(degrees) {
    return degrees * (Math.PI / 180);
}
// https://chatgpt.com/c/c931d546-921d-4f3c-b57b-3df2c7904102
function $c48252d8bfb57141$var$getEnd(long, lat, distance, bearing) {
    // const startPoint = [long, lat]; // Example: Philadelphia, PA
    // const d = nauticalMilesToMeters(distance); // Convert miles to meters
    // const headingRadians = degressToRadians(bearing);
    // // Calculate changes in coordinates
    // const deltaX = d * Math.cos(headingRadians); // West is negative in the Cartesian plane
    // const deltaY = d * Math.sin(headingRadians); // South is negative in the Cartesian plane
    // // Convert distance delta from meters to degrees (approximation)
    // // Note: This approximation works reasonably for small distances
    // const deltaLongitude =
    //   deltaX / (111320 * Math.cos(degressToRadians(startPoint[1])));
    // const deltaLatitude = deltaY / 110540;
    // // Calculate the new position
    // const newLongitude = startPoint[0] + deltaLongitude;
    // const newLatitude = startPoint[1] + deltaLatitude;
    // const end = [newLongitude, newLatitude];
    // Old way that uses earth's sphere
    const end = $fb75384508533d8f$export$cc800923e997bb8([
        long,
        lat
    ], (0, $79e13355954d15ea$export$f855e4255431a6a0)(distance), $c48252d8bfb57141$var$degressToRadians(bearing));
    return end;
}



var $acw62 = parcelRequire("acw62");


function $d49379707a571fbc$export$2e2bcd8739ae039({ groups: groups, theater: theater }) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const layer = (0, $c5dd9f05f83ae634$export$2d46b8799829d984)(theater, groups);
        layer.set("hideable", true);
        map.addLayer(layer);
    }, [
        map
    ]);
    return null;
}



async function $eb53551ec8be4604$export$5a365f478c4c33a2(tasking) {
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)((0, $59e76ac65671d31b$export$8cc1a63178152958), (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e));
    const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(tasking.theater, tasking.bullseye);
    const layer = (0, $c48252d8bfb57141$export$736dbcdec949fdf9)([
        long,
        lat
    ]);
    const extent = layer.getSource().getExtent();
    const mapImg = await (0, $59e76ac65671d31b$export$fe4501d50e7230de)(extent, {
        height: (0, $59e76ac65671d31b$export$8cc1a63178152958),
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e)
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d49379707a571fbc$export$2e2bcd8739ae039), {
                groups: tasking.opforVehicles,
                theater: tasking.theater
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48252d8bfb57141$export$9424b4281d9e66ee), {
                theater: tasking.theater,
                visible: true,
                bulls: tasking.bullseye
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef857df75211522c$export$2e2bcd8739ae039), {
                theater: tasking.theater,
                bullseye: tasking.bullseye
            })
        ]
    }));
    composer.add(mapImg, {
        x: 0,
        y: 0
    });
    return composer;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



const $6f1b3da50136634f$var$divStyle = {
    display: "flex",
    margin: 8,
    fontFamily: "sans-serif",
    height: "100%",
    width: "98%",
    fontSize: 14,
    flexWrap: "wrap",
    justifyContent: "space-between"
};
const $6f1b3da50136634f$var$cellStyle = {
    borderBottom: "1px solid gray",
    overflow: "hidden",
    whiteSpace: "nowrap"
};
function $6f1b3da50136634f$export$2e2bcd8739ae039({ radioConfig: radioConfig }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $6f1b3da50136634f$var$divStyle,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    textAlign: "center",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    style: {
                        fontSize: 18
                    },
                    children: "Frequencies"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                    justifyContent: "space-between"
                },
                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(radioConfig, (v, k)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            maxWidth: 320,
                            marginRight: 8,
                            marginBottom: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: k
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                                style: (0, $59e76ac65671d31b$export$9dd6ff9ea0189349).table,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                        style: (0, $59e76ac65671d31b$export$9dd6ff9ea0189349).th,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 24
                                                    },
                                                    children: "Chan"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 48
                                                    },
                                                    children: "Freq"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 32
                                                    },
                                                    children: "AM/FM"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                    style: {
                                                        width: 96
                                                    },
                                                    children: "Description"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(v, (t, i)=>{
                                            let freq = t.frequency;
                                            let mod = t.modulation;
                                            let desc = t.description;
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                style: {
                                                    backgroundColor: i % 2 === 1 ? "#ffe194" : "#ffffff"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: {
                                                            ...$6f1b3da50136634f$var$cellStyle
                                                        },
                                                        children: i + 1
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: $6f1b3da50136634f$var$cellStyle,
                                                        children: (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(freq)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: $6f1b3da50136634f$var$cellStyle,
                                                        children: mod === (0, $91a9098e14452db2$export$459e66e1d1ce05ca).FM ? "FM" : "AM"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: $6f1b3da50136634f$var$cellStyle,
                                                        children: desc
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    }, k);
                })
            })
        ]
    });
}



async function $06abbfd1311cc25f$export$f5e408544e31b1f(cfg) {
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)((0, $59e76ac65671d31b$export$8cc1a63178152958), (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e));
    const el = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f1b3da50136634f$export$2e2bcd8739ae039), {
        radioConfig: cfg
    });
    const blob = await g.renderToBlob(el, {
        height: (0, $59e76ac65671d31b$export$8cc1a63178152958),
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e) - 8
    });
    composer.add(blob, {
        x: 0,
        y: 0
    });
    return composer;
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

parcelRequire("acw62");


const $2af77d96514f3f21$export$f269fbe035abd952 = (mod, theater, targetWP, wps, fuelPlan, internalFuel)=>{
    const distance = targetWP ? (0, $53c885ff43760466$export$c883c0766fae79f3)(theater, targetWP, wps) : 0;
    const time = distance / fuelPlan.groundSpeed * 60;
    const internalOrDefault = internalFuel || mod?.fuel?.internal;
    const totalFuel = internalOrDefault + fuelPlan.externalTanks * mod?.fuel?.externalCapacity;
    const fuelConsumed = fuelPlan.fuelFlow / 60 * time * mod?.fuel?.engineCount;
    const fuelAtTarget = totalFuel - fuelConsumed;
    const loiterGas = fuelAtTarget - fuelPlan.bingo;
    const loiterTime = loiterGas / fuelPlan.fuelFlow * 60;
    const fuelAtLanding = fuelPlan.bingo - fuelConsumed;
    return {
        time: time,
        distance: distance,
        totalFuel: totalFuel,
        fuelConsumed: fuelConsumed,
        fuelAtTarget: fuelAtTarget,
        loiterGas: loiterGas,
        loiterTime: loiterTime,
        fuelAtLanding: fuelAtLanding
    };
};



var $d639ce2b0593ab0e$export$2edcab8dd1869daa;
(function(RecordType) {
    RecordType["GroupAdminDetails"] = "GroupAdminDetails";
    RecordType["AircraftAdminDetails"] = "AircraftAdminDetails";
})($d639ce2b0593ab0e$export$2edcab8dd1869daa || ($d639ce2b0593ab0e$export$2edcab8dd1869daa = {}));
var $d639ce2b0593ab0e$export$b26feff89eea1884;
(function(TACANBand) {
    TACANBand["X"] = "X";
    TACANBand["Y"] = "Y";
})($d639ce2b0593ab0e$export$b26feff89eea1884 || ($d639ce2b0593ab0e$export$b26feff89eea1884 = {}));
class $d639ce2b0593ab0e$export$78e20fcf95093a7d {
}
function $d639ce2b0593ab0e$export$3f35682dca895bb0(record) {
    switch(record.type){
        case "AircraftAdminDetails":
            return JSON.parse(record.payload);
        case "GroupAdminDetails":
            return JSON.parse(record.payload);
        default:
            throw new Error(`Unknown record type: ${record.type}`);
    }
}






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $4f2bf588db7a614f$export$2e2bcd8739ae039({ styles: styles, groupDetails: details }) {
    const formattedTacan = (0, $165c1a1c0f22e853$export$f1d992e78c170a3d)(details?.tacanChannelLow);
    const aux = (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(details?.auxFrequency);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            style: styles.table,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                style: styles.th,
                                children: "Group Name"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                style: styles.th,
                                children: "Aux Freq"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                style: styles.th,
                                children: "TACAN"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                rowSpan: 4,
                                style: styles.td,
                                children: details?.groupName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                style: styles.td,
                                children: aux
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                style: styles.td,
                                children: formattedTacan
                            })
                        ]
                    })
                })
            ]
        })
    });
}


const $a6331e059cc44a13$var$styles = {
    table: {
        textAlign: "left",
        width: "100%",
        borderCollapse: "collapse",
        tableLayout: "fixed",
        border: "1px solid black"
    },
    th: {
        fontSize: 12,
        border: "1px solid black"
    },
    td: {
        border: "1px solid gray",
        overflow: "hidden",
        whiteSpace: "nowrap"
    },
    tableLabel: {
        display: "flex",
        width: "calc(100% - 1px)",
        justifyContent: "center",
        border: "1px solid black",
        borderBottom: 0,
        boxSizing: "border-box"
    }
};
function $a6331e059cc44a13$export$2e2bcd8739ae039({ tasking: tasking, group: group, hideToT: hideToT, settings: settings, radioConfig: radioConfig, externalData: externalData, fuelPlan: fuelPlan, remarks: remarks, radioPlanItems: radioPlanItems, laserConfig: laserConfig }) {
    const [local, zulu] = (0, $53c885ff43760466$export$c6d8503b07f17cbd)(tasking);
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(group.units).type;
    const module = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
    // const laser = new DCSPlayerGroup(group).laserCodes();
    const aircraftDataRecord = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(externalData, {
        type: (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails
    });
    const externalAircraftData = aircraftDataRecord && JSON.parse(aircraftDataRecord?.payload);
    const cols = [
        {
            value: (u, c, r)=>`${group.name}-${r + 1}`,
            label: "Flight Member",
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            }
        }
    ];
    const first = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(group.units);
    const hasLink = first.aircraftProps?.STN_L16 || first.aircraftProps?.OwnshipCallSign;
    let linkText;
    let isApache = false;
    if (first.aircraftProps?.STN_L16) linkText = "STN";
    if (first.aircraftProps?.OwnshipCallSign) {
        linkText = "DL Callsign";
        isApache = true;
    }
    if (hasLink) cols.push({
        value: (u)=>u.aircraftProps?.STN_L16 || u.aircraftProps?.OwnshipCallSign,
        label: linkText,
        style: {
            th: $a6331e059cc44a13$var$styles.th,
            td: $a6331e059cc44a13$var$styles.td
        }
    });
    if (isApache) cols.push({
        value: (u)=>u.aircraftProps?.TN_IDM_LB,
        label: "Originator ID",
        style: {
            th: $a6331e059cc44a13$var$styles.th,
            td: $a6331e059cc44a13$var$styles.td
        }
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys(module?.laserConfigFields).length > 0) cols.push({
        value: (u, c, r)=>{
            const relevant = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(externalAircraftData, {
                flightNumber: r + 1,
                groupName: group.name
            });
            if (relevant && relevant.laserCode) return relevant.laserCode;
            if (!relevant && laserConfig) return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(laserConfig, [
                r,
                "LaserCode"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact(u.laserCode).join("");
        },
        label: "Laser Code",
        style: {
            th: $a6331e059cc44a13$var$styles.th,
            td: $a6331e059cc44a13$var$styles.td
        }
    });
    const aircraftDetails = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(externalData, {
        type: (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails
    });
    const detailsPayload = aircraftDetails ? JSON.parse(aircraftDetails?.payload) : null;
    const relevantAircraftDetails = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(detailsPayload, {
        groupName: group.name
    });
    if (relevantAircraftDetails && relevantAircraftDetails.length > 0) {
        if (relevantAircraftDetails.some((d)=>d.playerName)) cols.push({
            value: (u, colNum, rowNum)=>relevantAircraftDetails[rowNum]?.playerName,
            label: "Player Name",
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            }
        });
        cols.push({
            value: (u, colNum, rowNum)=>{
                const a = relevantAircraftDetails[rowNum];
                const mode1 = a?.iffMode1;
                const mode3 = a?.iffMode3;
                return mode1 ? `${mode1}/${mode3}` : "";
            },
            label: "IFF Mode 1/3",
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            }
        });
        cols.push({
            value: (u, colNum, rowNum)=>relevantAircraftDetails[rowNum]?.tailNumber,
            label: "Tail Number",
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            }
        });
    }
    const groupDetails = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(externalData, {
        type: (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).GroupAdminDetails
    });
    const groupDetailsPayload = groupDetails ? JSON.parse(groupDetails?.payload) : null;
    const relevantGroupDetails = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groupDetailsPayload, {
        groupName: group.name
    });
    let overrides;
    if (settings?.showFreqs) {
        if (radioConfig) overrides = (0, $165c1a1c0f22e853$export$5507a3a66b1c2cfb)(group, radioConfig);
        if (group.plan?.radioOverrides) overrides = JSON.parse(group.plan?.radioOverrides);
        if (radioPlanItems.length > 0) overrides = radioPlanItems;
    }
    const radioRows = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(overrides, (radio, n)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(radio, (o, i)=>{
            if (!radioRows[i]) radioRows[i] = [];
            radioRows[i][n] = o;
        });
    });
    const comCols = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(module?.radios, (r)=>({
            label: r.short,
            value: (o, colN)=>{
                const ov = o[colN - 1];
                let text = ov?.description;
                return text;
            },
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            }
        }));
    const waypointCols = [
        {
            value: "number",
            label: "#",
            width: 5,
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            }
        },
        {
            value: (wp)=>wp.name !== wp.number.toString() ? wp.name : "",
            label: "Name",
            width: 20,
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            }
        }
    ];
    if (settings?.showTimeOnTarget) waypointCols.push({
        value: (wp)=>(0, $53c885ff43760466$export$466569099c44c97b)(tasking, wp.ETA).toLocaleString((0, $63618293c58b5f80$exports.DateTime).TIME_24_WITH_SECONDS),
        label: "ToT (Zulu)",
        width: 16,
        style: {
            th: {
                ...$a6331e059cc44a13$var$styles.th,
                display: hideToT ? "none" : ""
            },
            td: {
                ...$a6331e059cc44a13$var$styles.td,
                display: hideToT ? "none" : ""
            }
        }
    });
    if (settings?.showDistance) waypointCols.push({
        label: "Distance (NM)",
        style: {
            th: $a6331e059cc44a13$var$styles.th,
            td: $a6331e059cc44a13$var$styles.td
        },
        width: 10,
        value: (wp)=>{
            const last = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(group.waypoints, {
                number: wp.number - 1
            });
            if (!last) return "";
            return (0, $53c885ff43760466$export$9f17032d917177de)(tasking.theater, last, wp).toFixed(1);
        }
    });
    if (settings?.showSpeed) waypointCols.push({
        label: "Ground Speed (kts)",
        style: {
            th: $a6331e059cc44a13$var$styles.th,
            td: $a6331e059cc44a13$var$styles.td
        },
        width: 10,
        value: (wp)=>{
            const last = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(group.waypoints, {
                number: wp.number - 1
            });
            if (!last) return "";
            const d = (0, $53c885ff43760466$export$9f17032d917177de)(tasking.theater, last, wp);
            const seconds = wp.ETA - last.ETA;
            return (d / seconds * 3600).toFixed(0);
        }
    });
    if (settings?.showAltitude) waypointCols.push({
        style: {
            th: $a6331e059cc44a13$var$styles.th,
            td: $a6331e059cc44a13$var$styles.td
        },
        width: 18,
        value: (wp)=>`${(0, $79e13355954d15ea$export$d284c26147b5ca34)(wp.alt).toFixed(0)}ft ${wp.alt_type === "BARO" ? "MSL" : "AGL"}`,
        label: "Altitude"
    });
    if (settings?.showCoords) {
        const fn = (idx)=>(wp)=>{
                const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(tasking.theater, wp);
                const coord = (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
                    long,
                    lat
                ], 3);
                return coord[idx];
            };
        const northing = {
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            },
            width: 20,
            value: fn(0),
            label: "Latitude"
        };
        const easting = {
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            },
            width: 20,
            value: fn(1),
            label: "Longitude"
        };
        const mgrs = {
            style: {
                th: $a6331e059cc44a13$var$styles.th,
                td: $a6331e059cc44a13$var$styles.td
            },
            width: 24,
            value: fn(2),
            label: "MGRS"
        };
        waypointCols.push(northing);
        waypointCols.push(easting);
        waypointCols.push(mgrs);
    }
    let targetWP;
    let fuel;
    if (fuelPlan) {
        targetWP = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(group.waypoints, {
            number: fuelPlan.targetWaypoint
        });
        fuel = (0, $2af77d96514f3f21$export$f269fbe035abd952)(module, tasking.theater, targetWP, group.waypoints, fuelPlan, first.internalFuel * 2.205 // DCS uses kilograms, we use pounds
        );
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            margin: 8,
            fontFamily: "sans-serif",
            height: "100%",
            width: "98%",
            fontSize: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            style: {
                                fontSize: 18
                            },
                            children: [
                                group.name,
                                " - ",
                                module?.label || type,
                                " - Lineup Card"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontSize: 14,
                                fontWeight: "bold"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Time (local/zulu): ",
                                    local,
                                    "/",
                                    zulu
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 8
                },
                children: relevantGroupDetails && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f2bf588db7a614f$export$2e2bcd8739ae039), {
                    styles: $a6331e059cc44a13$var$styles,
                    groupDetails: relevantGroupDetails
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 8
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                    style: $a6331e059cc44a13$var$styles.table,
                    columns: cols,
                    rows: group.units
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    width: "100%",
                    display: "flex",
                    marginTop: 8,
                    paddingRight: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: $a6331e059cc44a13$var$styles.tableLabel,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    style: {
                                        fontSize: 12
                                    },
                                    children: "Waypoints"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                                style: {
                                    ...$a6331e059cc44a13$var$styles.table
                                },
                                columns: waypointCols,
                                rows: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).tail(group.waypoints)
                            }),
                            fuelPlan && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    marginTop: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: $a6331e059cc44a13$var$styles.tableLabel,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            style: {
                                                fontSize: 12
                                            },
                                            children: "Fuel Plan"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                        style: {
                                            ...$a6331e059cc44a13$var$styles.table
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    style: {
                                                        border: "0px solid white",
                                                        height: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {})
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Target WP:\xa0"
                                                                    }),
                                                                    fuelPlan.targetWaypoint
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Dist:\xa0"
                                                                    }),
                                                                    fuel.distance.toFixed(0),
                                                                    "NM"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Time:\xa0"
                                                                    }),
                                                                    fuel.time.toFixed(0),
                                                                    "min"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "GS: \xa0"
                                                                    }),
                                                                    fuelPlan.groundSpeed
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "FF: \xa0"
                                                                    }),
                                                                    fuelPlan.fuelFlow,
                                                                    "PPH"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Bingo: \xa0"
                                                                    }),
                                                                    fuelPlan.bingo
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Loiter: \xa0"
                                                                    }),
                                                                    fuel.loiterTime.toFixed(0),
                                                                    "min"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Target: \xa0"
                                                                    }),
                                                                    fuel.fuelAtTarget.toFixed(0),
                                                                    "lbs"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                style: $a6331e059cc44a13$var$styles.td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Home: \xa0"
                                                                    }),
                                                                    fuel.fuelAtLanding.toFixed(0),
                                                                    "lbs"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            paddingLeft: 4,
                            display: radioRows.length === 0 ? "none" : "block"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: $a6331e059cc44a13$var$styles.tableLabel,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    style: {
                                        fontSize: 12
                                    },
                                    children: "Radio Presets"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                                style: {
                                    ...$a6331e059cc44a13$var$styles.table
                                },
                                columns: [
                                    {
                                        value: (o, colN, rowN)=>rowN + 1,
                                        label: "Chan",
                                        width: 32,
                                        style: {
                                            th: $a6331e059cc44a13$var$styles.th,
                                            td: $a6331e059cc44a13$var$styles.td
                                        }
                                    },
                                    ...comCols
                                ],
                                rows: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).take(radioRows, 20)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "flex-start",
                    border: "1px solid black",
                    position: "absolute",
                    right: 0,
                    top: 657,
                    width: 350.5,
                    height: 300
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        marginLeft: 4
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Remarks:"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                style: {
                                    whiteSpace: "pre-wrap",
                                    width: 350.5
                                },
                                children: remarks
                            })
                        })
                    ]
                })
            })
        ]
    });
}



async function $08a4e17e4b7d2cae$export$3dd67841550c9710(tasking, group, jobSettings, radioConfig, externalData, planItems) {
    if (!group) throw new Error(`No group specified for lineup cards`);
    const trimmed = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).take(group?.plan?.waypoints && group?.plan?.waypoints.length > 0 ? group.plan.waypoints : group.waypoints, 21);
    const trimmedGroup = {
        ...group,
        waypoints: trimmed
    };
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)((0, $59e76ac65671d31b$export$8cc1a63178152958), (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e));
    const fuelPlanDoc = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).FuelPlan,
        group: group.name
    });
    let parsed = null;
    if (fuelPlanDoc) parsed = JSON.parse(fuelPlanDoc.payload);
    const remarks = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).PlanNote,
        group: group.name
    });
    const navPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).NavPoint,
        group: group.name
    });
    const radioPlanItem = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).RadioPresets,
        group: group.name
    });
    let presets = [];
    if (radioPlanItem) presets = JSON.parse(radioPlanItem.payload);
    const parsedRemarks = remarks ? (0, $3688fdfd7954d49f$export$7117fc57f3fba397)(remarks) : null;
    const laserConfig = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).LaserCodes,
        group: group.name
    });
    const el = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6331e059cc44a13$export$2e2bcd8739ae039), {
        tasking: tasking,
        group: trimmedGroup,
        settings: jobSettings,
        radioConfig: radioConfig ? JSON.parse(radioConfig) : null,
        externalData: externalData,
        fuelPlan: parsed,
        remarks: remarks ? parsedRemarks?.text : group?.plan?.plannerNotes,
        radioPlanItems: presets,
        laserConfig: laserConfig ? JSON.parse(laserConfig.payload) : null
    });
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const blob = await g.renderToBlob(el, {
        height: (0, $59e76ac65671d31b$export$8cc1a63178152958),
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e) - 8
    });
    const extent = (0, $1cf8f597a58d4025$export$63a77e50b78bd96)(tasking.theater, trimmedGroup);
    const height = 300;
    const width = (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e);
    const mapImg = await (0, $59e76ac65671d31b$export$fe4501d50e7230de)(extent, {
        height: height,
        width: width / 2,
        zoomAdjust: -0.3
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bc458713ae03df2$export$2e2bcd8739ae039), {
                groups: [
                    trimmedGroup
                ],
                theater: tasking.theater,
                colorOverride: "black",
                disableDistanceLabels: true,
                declutter: false,
                renderIcon: true,
                planItemNavPoints: navPoints
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef857df75211522c$export$2e2bcd8739ae039), {
                theater: tasking.theater,
                bullseye: tasking.bullseye
            })
        ]
    }));
    composer.add(blob, {
        x: 4,
        y: 0
    });
    composer.add(mapImg, {
        x: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e) - width,
        y: (0, $59e76ac65671d31b$export$8cc1a63178152958) - height
    });
    return composer;
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");


var $acw62 = parcelRequire("acw62");






const $53941ccde1a78f2f$var$pathStyle = (feature)=>{
    const color = "#" + (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).slice(feature.get("colorString"), 2).join("");
    const fill = "#" + (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).slice(feature.get("fillColorString"), 2).join("");
    const dashed = feature.get("style") === "dash";
    const primitiveType = feature.get("primitiveType");
    const styles = [];
    styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        // image: new Circle({
        //   radius: 5,
        //   fill: new Fill({
        //     color: "orange",
        //   }),
        // }),
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: color,
            width: feature.get("thickness") / 2,
            lineDash: dashed ? [
                10,
                10
            ] : null
        }),
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: fill
        })
    }));
    if (primitiveType === (0, $91a9098e14452db2$export$b89d56b50e08a256).TextBox) {
        const text = feature.get("text").toString();
        const border = feature.get("borderThickness");
        const fontSize = feature.get("fontSize");
        styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                overflow: true,
                padding: [
                    4,
                    4,
                    4,
                    4
                ],
                font: `${fontSize}px Roboto, sans-serif`,
                placement: "point",
                text: text,
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: color
                }),
                backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: fill
                }),
                backgroundStroke: border > 0 ? new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: color,
                    width: border / 2
                }) : null,
                rotation: feature.get("angle") * (Math.PI / 180),
                textAlign: "left"
            })
        }));
    }
    return styles;
};
const $53941ccde1a78f2f$export$2dcfe4cffc26be0b = ({ drawings: drawings, theater: theater })=>{
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(drawings, (d)=>({
            ...d,
            geometry: $53941ccde1a78f2f$export$c1574d1248e9db1b(theater, d),
            unselectable: true
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).DrawingObjects,
        displayName: (0, $91a9098e14452db2$export$fb028bc55343bb1f).DrawingObjects,
        foLayerID: "miz-drawing-layer",
        filterTag: (0, $91a9098e14452db2$export$fb028bc55343bb1f).DrawingObjects,
        features: features,
        hideable: true,
        style: $53941ccde1a78f2f$var$pathStyle
    });
};
function $53941ccde1a78f2f$export$2e2bcd8739ae039() {
    const { state: { tasking: tasking } } = (0, $acw62.useContext)((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($53941ccde1a78f2f$export$2dcfe4cffc26be0b, {
        drawings: tasking.drawingData,
        theater: tasking.theater
    });
}
function $53941ccde1a78f2f$var$toLinePoints(theater, d) {
    // const origin = convertDCSToLatLong(theater, { x: d.mapX, y: d.mapY });
    const points = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(d.points, (p)=>{
        const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
            x: p.x + d.mapX,
            y: p.y + d.mapY
        });
        const coords = [
            long,
            lat
        ];
        return coords;
    });
    if (d.closed) points.push(points[0]);
    return points;
}
function $53941ccde1a78f2f$var$toPolyPoints(theater, d) {
    const origin = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
        x: d.mapX,
        y: d.mapY
    });
    let geometry;
    switch(d.polygonMode){
        case "rect":
            geometry = (0, $79e13355954d15ea$export$68f4cf8c6d4e06be)(theater, d);
            geometry.rotate(-d.angle * (Math.PI / 180), geometry.getInteriorPoint().getCoordinates());
            break;
        case "circle":
            geometry = (0, $40aa8d43bbe572bf$export$f99d756c6d81ae3f)([
                origin.long,
                origin.lat
            ], d.radius);
            break;
        case "oval":
            geometry = (0, $40aa8d43bbe572bf$export$f99d756c6d81ae3f)([
                origin.long,
                origin.lat
            ], d.r1);
            geometry.scale(d.r2 / d.r1, 1);
            geometry.rotate(-d.angle * (Math.PI / 180), geometry.getInteriorPoint().getCoordinates());
            break;
    }
    return geometry;
}
function $53941ccde1a78f2f$var$toPoint(theater, d) {
    const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
        x: d.mapX,
        y: d.mapY
    });
    return new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
        long,
        lat
    ]);
}
function $53941ccde1a78f2f$export$c1574d1248e9db1b(theater, d) {
    switch(d.primitiveType){
        case (0, $91a9098e14452db2$export$b89d56b50e08a256).Line:
            return new (0, $292e4002746c8223$export$2e2bcd8739ae039)($53941ccde1a78f2f$var$toLinePoints(theater, d));
        case (0, $91a9098e14452db2$export$b89d56b50e08a256).Polygon:
            return $53941ccde1a78f2f$var$toPolyPoints(theater, d);
        case (0, $91a9098e14452db2$export$b89d56b50e08a256).TextBox:
            return $53941ccde1a78f2f$var$toPoint(theater, d);
    }
}





async function $0dcf5d51c79343e5$export$235114961ede588e(tasking, group, settings) {
    const composer = (0, $9bfb1b056e7a5cd5$export$95422b89ba9092d1)((0, $59e76ac65671d31b$export$8cc1a63178152958), (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e));
    const el = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            fontFamily: "Roboto, sans-serif"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
            children: group?.name
        })
    });
    const g = (0, $5cf135077a5d2795$export$b5430364fbdbee0e)();
    const blob = await g.renderToBlob(el, {
        height: 200,
        width: 400,
        fillColor: "rgba(0, 0, 0, 0.0)"
    });
    const extent = (0, $1cf8f597a58d4025$export$bcf8b7f0e3ae2f95)(tasking.theater, [
        group
    ]);
    const mapImg = await (0, $59e76ac65671d31b$export$fe4501d50e7230de)(extent, {
        height: (0, $59e76ac65671d31b$export$8cc1a63178152958),
        width: (0, $59e76ac65671d31b$export$9b1cdce8e74ca79e),
        zoomAdjust: -0.3
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d49379707a571fbc$export$2e2bcd8739ae039), {
                theater: tasking.theater,
                groups: tasking.opforVehicles
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53941ccde1a78f2f$export$2dcfe4cffc26be0b), {
                theater: tasking.theater,
                drawings: tasking.drawingData
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bc458713ae03df2$export$2e2bcd8739ae039), {
                groups: [
                    group
                ],
                theater: tasking.theater,
                colorOverride: "black",
                disableDistanceLabels: !settings?.showDistances,
                declutter: false,
                renderIcon: true,
                planItemNavPoints: []
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef857df75211522c$export$2e2bcd8739ae039), {
                theater: tasking.theater,
                bullseye: tasking.bullseye
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48252d8bfb57141$export$9424b4281d9e66ee), {
                theater: tasking.theater,
                bulls: tasking.bullseye,
                visible: settings?.showBullsCompass
            })
        ]
    }));
    composer.add(mapImg, {
        x: 0,
        y: 0
    });
    composer.add(blob, {
        x: 24,
        y: 0
    });
    return composer;
}



async function $e0c6a541dbb07ec6$export$56b3e1b6a6adb266(j, tasking, jobData, settings, externalData, planItems) {
    let composer;
    switch(j){
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectAirbasesKneeboard:
            composer = await (0, $366e7823df40ef4e$export$8fdd276949ba31d5)(tasking, settings);
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectSupportAssetsKneeboard:
            composer = await (0, $9ba3ac95ea50b8ac$export$55eed746402cf864)(tasking);
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard:
            composer = await (0, $08a4e17e4b7d2cae$export$3dd67841550c9710)(tasking, jobData.group, settings, jobData.radioConfig, externalData, planItems);
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard:
            composer = await (0, $59e76ac65671d31b$export$62862cd479f79fd7)(jobData.group);
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).BriefingText:
            composer = await (0, $59e76ac65671d31b$export$933d533764865bb)(tasking, jobData.title);
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard:
            composer = await (0, $06abbfd1311cc25f$export$f5e408544e31b1f)(JSON.parse(jobData.radioConfig));
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ControlPointsCard:
            composer = await (0, $6989236d425f0950$export$dfd7129622cfccc3)(tasking);
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectBullsCompass:
            composer = await (0, $eb53551ec8be4604$export$5a365f478c4c33a2)(tasking);
            break;
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards:
            composer = await (0, $0dcf5d51c79343e5$export$235114961ede588e)(tasking, jobData.group, settings);
            break;
        default:
            break;
    }
    return composer;
}
async function $e0c6a541dbb07ec6$export$41b3415e6330f1b5(j, tasking, jobData, settings, externalData, planItems) {
    const cmp = await $e0c6a541dbb07ec6$export$56b3e1b6a6adb266(j, tasking, jobData, settings, externalData, planItems);
    return await cmp.renderToURL();
}



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $a6d9669b5694b4b9$export$c862ce853eaf3dac = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $a6d9669b5694b4b9$export$a9089b66d078b0e4({ manager: manager, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6d9669b5694b4b9$export$c862ce853eaf3dac.Provider, {
        value: manager,
        children: children
    });
}




function $6f6b89abe389e58a$var$useExternalData() {
    return (0, $acw62.useContext)((0, $a6d9669b5694b4b9$export$c862ce853eaf3dac));
}
function $6f6b89abe389e58a$export$f170a02a4314e0c9() {
    return $6f6b89abe389e58a$var$useExternalData();
}
function $6f6b89abe389e58a$export$d15d4a480abe4570() {
    return $6f6b89abe389e58a$var$useExternalData();
}
const $6f6b89abe389e58a$var$queryKey = "externalData";
function $6f6b89abe389e58a$export$a71275835f6fa47f(fragOrderID, coa) {
    const reader = $6f6b89abe389e58a$export$f170a02a4314e0c9();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $6f6b89abe389e58a$var$queryKey,
        fragOrderID,
        coa
    ], ()=>reader.list(fragOrderID, coa));
}
function $6f6b89abe389e58a$export$8df626c21f17201f(fragOrderID) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const writer = $6f6b89abe389e58a$export$d15d4a480abe4570();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (type, coalition, payload)=>writer.upsert(currentUser.id, {
            fragOrderID: fragOrderID,
            coalition: coalition,
            type: type,
            payload: payload,
            contentType: "application/csv"
        }).then(()=>{
            qc.invalidateQueries([
                (0, $0a53c1f23450367c$export$16e811213eb2e34a)
            ]);
            qc.invalidateQueries([
                $6f6b89abe389e58a$var$queryKey,
                fragOrderID
            ]);
        });
}
function $6f6b89abe389e58a$export$d321df0b0928cdb4(fragOrderID) {
    const writer = $6f6b89abe389e58a$export$d15d4a480abe4570();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    return (record)=>writer.delete(currentUser.id, record).then(()=>{
            qc.invalidateQueries([
                (0, $0a53c1f23450367c$export$16e811213eb2e34a)
            ]);
            qc.invalidateQueries([
                $6f6b89abe389e58a$var$queryKey,
                fragOrderID
            ]);
        });
}






var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");






const $aae70ce689e02dd3$export$b34a6c5661fd52c4 = "PublishStatus";
const $aae70ce689e02dd3$export$93ddcb7c9d6be108 = /*#__PURE__*/ $acw62.createContext({});
function $aae70ce689e02dd3$export$a98e73a25480d7d3({ manager: manager, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aae70ce689e02dd3$export$93ddcb7c9d6be108.Provider, {
        value: manager,
        children: children
    });
}
function $aae70ce689e02dd3$export$75b3d57a7e9ef3fe() {
    return $acw62.useContext($aae70ce689e02dd3$export$93ddcb7c9d6be108);
}
function $aae70ce689e02dd3$export$2ca11ab2ab0c6e67(fragOrderID) {
    const mgr = $aae70ce689e02dd3$export$75b3d57a7e9ef3fe();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $aae70ce689e02dd3$export$b34a6c5661fd52c4,
        fragOrderID
    ], ()=>mgr.getPublishStatus(fragOrderID));
}
function $aae70ce689e02dd3$export$95d527e7801163e8(fragOrderID, coalition) {
    const { data: manifests, ...rest } = $aae70ce689e02dd3$export$2ca11ab2ab0c6e67(fragOrderID);
    return {
        data: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
            coalition: coalition
        }),
        ...rest
    };
}
function $aae70ce689e02dd3$export$c0705b6f85ff496b() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const mgr = $acw62.useContext($aae70ce689e02dd3$export$93ddcb7c9d6be108);
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (fragOrder, coalition)=>{
        return mgr.upsertPublishManifest(currentUser.id, coalition, fragOrder, fragOrder.publishOpts).then(()=>{
            qc.invalidateQueries([
                $aae70ce689e02dd3$export$b34a6c5661fd52c4
            ]);
        });
    };
}
function $aae70ce689e02dd3$export$922bf4ca65b75c36() {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const mgr = $acw62.useContext($aae70ce689e02dd3$export$93ddcb7c9d6be108);
    const { data: fragOrder } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const fo = $acw62.useContext((0, $a7e8caa803539e5f$export$9daed425602f604d));
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    return (manifest, rule)=>{
        return mgr.upsertPlanningRule(manifest, rule).then(async ()=>{
            if (rule && !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(fragOrder.jobs, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyPlans)) {
                await fo.update(currentUser.id, [
                    manifest.coalition
                ], {
                    ...fragOrder,
                    jobs: [
                        ...fragOrder.jobs || [],
                        (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyPlans
                    ]
                });
                queryClient.invalidateQueries([
                    (0, $0a53c1f23450367c$export$16e811213eb2e34a)
                ]);
            }
            queryClient.invalidateQueries([
                $aae70ce689e02dd3$export$b34a6c5661fd52c4
            ]);
        });
    };
}
function $aae70ce689e02dd3$export$6d3369aca4859529() {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const mgr = $acw62.useContext($aae70ce689e02dd3$export$93ddcb7c9d6be108);
    return (manifest, rule)=>mgr.removePlanningRule(manifest, rule.discordUserID).then(async ()=>{
            queryClient.invalidateQueries([
                $aae70ce689e02dd3$export$b34a6c5661fd52c4
            ]);
        });
}
function $aae70ce689e02dd3$export$1d63914b63ab258e() {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const mgr = $acw62.useContext($aae70ce689e02dd3$export$93ddcb7c9d6be108);
    return (manifest, editors)=>{
        return mgr.upsertControlMeasureEditors(manifest, editors).then(()=>{
            queryClient.invalidateQueries([
                $aae70ce689e02dd3$export$b34a6c5661fd52c4
            ]);
        });
    };
}
function $aae70ce689e02dd3$export$f598f7827181eec0() {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const mgr = $acw62.useContext($aae70ce689e02dd3$export$93ddcb7c9d6be108);
    return (manifest, rules)=>mgr.upsertSignupRules(manifest, rules).then(()=>{
            queryClient.invalidateQueries([
                $aae70ce689e02dd3$export$b34a6c5661fd52c4
            ]);
        });
}
function $aae70ce689e02dd3$export$9e1f293388361fee() {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const mgr = $acw62.useContext($aae70ce689e02dd3$export$93ddcb7c9d6be108);
    return (manifest, enabled)=>mgr.toggleSignupsEnabled(manifest, enabled).then(()=>{
            queryClient.invalidateQueries([
                $aae70ce689e02dd3$export$b34a6c5661fd52c4
            ]);
        });
}
function $aae70ce689e02dd3$export$f760ffd5af329347(manifest) {
    const bc = (0, $9fa5a1ec57c21134$export$84bdc398979fa84f)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $aae70ce689e02dd3$export$b34a6c5661fd52c4,
        manifest?.fragOrderID,
        manifest?.bundleAddress
    ], async ()=>{
        if (!manifest) return Promise.resolve(null);
        if (!manifest.version || manifest.version < 2) return JSON.parse(manifest.taskingData);
        const res = await bc.get(manifest);
        return JSON.parse(res);
    });
}



const $de1274ee98092164$export$a0b6379ff5e56126 = /*#__PURE__*/ $acw62.createContext({});
function $de1274ee98092164$export$51d3d37f5897afd5({ manager: manager, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($de1274ee98092164$export$a0b6379ff5e56126.Provider, {
        value: manager,
        children: children
    });
}
function $de1274ee98092164$export$8b27c7f353a6101a(fragOrder) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const mgr = (0, $acw62.useContext)($de1274ee98092164$export$a0b6379ff5e56126);
    const update = (0, $0a53c1f23450367c$export$4f91b3529d70dcc2)();
    return async (manifests, files)=>{
        const work = [];
        for (const manifest of manifests){
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(fragOrder.jobs, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).Assets)) await update({
                ...fragOrder,
                jobs: [
                    ...fragOrder?.jobs || [],
                    (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).Assets
                ]
            }, [
                manifest.coalition
            ]);
            for (const file of files){
                const asset = {
                    manifestID: manifest.id,
                    name: file.name,
                    type: (0, $8a132888bcd1c418$export$e57062a38354425e).Kneeboard,
                    displayName: file.name
                };
                work.push(mgr.upload(currentUser.id, asset, file));
            }
        }
        return Promise.all(work).then(()=>qc.invalidateQueries([
                $de1274ee98092164$var$queryKey
            ]));
    };
}
const $de1274ee98092164$var$queryKey = "kneeboards";
function $de1274ee98092164$export$7744273c9977e539(manifestID) {
    const mgr = (0, $acw62.useContext)($de1274ee98092164$export$a0b6379ff5e56126);
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $de1274ee98092164$var$queryKey,
        manifestID
    ], ()=>{
        if (!manifestID) return Promise.resolve(null);
        return mgr.list(manifestID);
    });
}
function $de1274ee98092164$export$7b94101b3d766751(asset, manifest) {
    const mgr = (0, $acw62.useContext)($de1274ee98092164$export$a0b6379ff5e56126);
    const { data: tasking } = (0, $aae70ce689e02dd3$export$f760ffd5af329347)(manifest);
    const { data: groups } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest?.fragOrderID, tasking?.plannedGroups);
    const { data: planItems } = (0, $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f)(manifest?.id);
    const { data: externalData, isLoading: isLoading } = (0, $6f6b89abe389e58a$export$a71275835f6fa47f)(manifest?.fragOrderID, manifest?.coalition);
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "asset_url",
        asset?.id,
        isLoading
    ], async ()=>{
        if (!asset) return Promise.resolve(null);
        if (asset.jobType) {
            let group;
            let radioConfig;
            if (asset.jobType) {
                if (asset.jobType === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard || asset.jobType === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard || asset.jobType === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards) {
                    const { groupName: name } = JSON.parse(asset.jobData);
                    group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groups, {
                        name: name
                    });
                }
            }
            if (asset.jobType === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard) radioConfig = JSON.parse(asset.jobData);
            const url = await (0, $e0c6a541dbb07ec6$export$41b3415e6330f1b5)(asset.jobType, tasking, {
                title: manifest?.title,
                group: group,
                radioConfig: radioConfig
            }, asset.jobSettings, externalData, planItems);
            return url;
        }
        return mgr.url(manifest.created_by_uid, asset);
    }, {
        retry: false,
        cacheTime: Infinity,
        staleTime: Infinity
    });
}
function $de1274ee98092164$export$a2278b7b030e2078() {
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const mgr = (0, $acw62.useContext)($de1274ee98092164$export$a0b6379ff5e56126);
    return (a)=>mgr.remove(a).then(()=>qc.invalidateQueries([
                $de1274ee98092164$var$queryKey
            ]));
}
function $de1274ee98092164$export$3748ec2d0288f7e5() {
    return (0, $acw62.useContext)($de1274ee98092164$export$a0b6379ff5e56126);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $38644a8687878cac$export$97cfa3fd2e8d725e = /*#__PURE__*/ $acw62.createContext({});
function $38644a8687878cac$export$426775f502b733a5({ storer: storer, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($38644a8687878cac$export$97cfa3fd2e8d725e.Provider, {
        value: storer,
        children: children
    });
}
function $38644a8687878cac$export$22d997cffb69b6c9() {
    const storer = (0, $acw62.useContext)($38644a8687878cac$export$97cfa3fd2e8d725e);
    return (fo)=>storer.download(fo.id);
}










var $f1q41 = parcelRequire("f1q41");




const $a64d85b213a654e1$export$56cd21e080707bdd = (records)=>(mission)=>{
        for (const record of records){
            const data = (0, $d639ce2b0593ab0e$export$3f35682dca895bb0)(record);
            const countries = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(mission, [
                "coalition",
                record.coalition,
                "country"
            ]);
            for (const country of countries.numValues){
                if (!country) continue;
                const categories = [
                    (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Plane,
                    (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Helicopter
                ];
                for (const cat of categories){
                    const category = country.strValues[cat];
                    if (!category) continue;
                    for (const group of category.strValues.group.numValues){
                        if (!group) continue;
                        if (record.type === (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).GroupAdminDetails) {
                            const d = data;
                            for (const g of d){
                                const match = g.groupName === group.strValues.name;
                                if (match) continue;
                            }
                        }
                        if (record.type === (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails) {
                            const d = data;
                            for (const a of d){
                                const match = a.groupName === group.strValues.name;
                                if (match) for(let index = 0; index < group.strValues.units.numValues.length; index++){
                                    const unit = group.strValues.units.numValues[index];
                                    if (!unit) continue;
                                    //   @ts-ignore
                                    const type = unit.strValues.type;
                                    const mod = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
                                    if (a.flightNumber === index) {
                                        // We have a match. Mutate values on the unit.
                                        if (a.tailNumber) // @ts-ignore
                                        unit.strValues.onboard_num = a.tailNumber.toString();
                                        if (a.stn) // @ts-ignore
                                        unit.strValues.AddPropAircraft.strValues.STN_L16 = a.stn;
                                        if (a.voiceCallsignLabel) // @ts-ignore
                                        unit.strValues.AddPropAircraft.strValues.VoiceCallsignLabel = a.voiceCallsignLabel;
                                        if (a.voiceCallsignNumber) // @ts-ignore
                                        unit.strValues.AddPropAircraft.strValues.VoiceCallsignNumber = a.voiceCallsignNumber;
                                        if ((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys(mod?.laserConfigFields).length > 0) {
                                            if (mod?.mizLaserFormatter) {
                                                const format = mod.mizLaserFormatter;
                                                const entry = {};
                                                const slicedCode = a.laserCode.toString().slice(1, 4);
                                                if (mod.laserConfigFields) for(const k in mod.laserConfigFields){
                                                    const field = mod.laserConfigFields[k];
                                                    if (field.fieldName) entry[field.fieldName] = slicedCode;
                                                }
                                                const props = unit.strValues.AddPropAircraft.strValues;
                                                format(props, entry);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    };



var $f1q41 = parcelRequire("f1q41");





function $cf372e462d8c8894$export$9526080f485581bd(wp) {
    const luaPoint = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(wp, "number", "name"), (v, k)=>{
        luaPoint.set(k, v);
    });
    if (wp.name !== wp.number.toString()) luaPoint.set("name", wp.name);
    luaPoint.set("x", wp.x);
    luaPoint.set("y", wp.y);
    luaPoint.set("alt", wp.alt || 0);
    luaPoint.set("alt_type", wp.alt_type || "RADIO");
    luaPoint.set("ETA", wp.ETA);
    luaPoint.set("ETA_locked", wp.ETA ? true : false);
    luaPoint.set("speed", wp.speed || 138);
    luaPoint.set("speed_locked", wp.ETA ? false : true);
    const task = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
    task.set("id", "ComboTask");
    const params = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
    params.set("tasks", new $0b8af60ab5d60464$export$54ec01a60f47d33d());
    task.set("params", params);
    luaPoint.set("task", task);
    luaPoint.set("formation_template", "");
    luaPoint.set("action", wp.type);
    return luaPoint;
}
const $cf372e462d8c8894$export$c5b2025ae8c55e80 = (plans)=>(mission)=>{
        let updated = mission;
        const merged = (0, $319680b363c8af04$export$c481faffd44f8c9d)(plans);
        for (const plan of merged){
            const countries = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(updated, [
                "coalition",
                plan.coalition,
                "country"
            ]);
            for (const country of countries.numValues){
                if (!country) continue;
                const cat = country.strValues[plan.groupCategory]?.strValues.group;
                if (cat) for (const group of cat.numValues){
                    if (!group) continue;
                    const match = group.strValues.name === plan.groupName;
                    if (match) {
                        if (plan.radioOverrides) {
                            const ovr = JSON.parse(plan.radioOverrides);
                            (0, $165c1a1c0f22e853$export$f601b9f6a9d5498e)(plan.coalition, plan.groupCategory, plan.groupName, (0, $165c1a1c0f22e853$export$b63a20d758e83ab7)(ovr))(mission);
                        }
                        if (plan.waypoints && plan.waypoints.length > 0) for (const wp of plan.waypoints){
                            const idx = wp.number + 1;
                            if (idx === 1) continue;
                            const tbl = $cf372e462d8c8894$export$9526080f485581bd(wp);
                            group.strValues.route.strValues.points.numValues[idx] = tbl;
                        }
                        if (plan.laserConfig) {
                            const units = group.strValues.units.numValues;
                            for (const unit of units){
                                if (!unit) continue;
                                const index = units.indexOf(unit);
                                const m = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[unit.strValues.type];
                                if (!m || !m.laserConfigFields) continue;
                                const formatter = m.mizLaserFormatter;
                                const laserEntry = plan.laserConfig[index - 1];
                                if (!formatter || !laserEntry) continue;
                                const props = unit.strValues.AddPropAircraft.strValues;
                                try {
                                    formatter(props, laserEntry);
                                } catch (e) {
                                    console.error(`Failed to apply laser config for ${unit.strValues.type}: ${e}`);
                                }
                            }
                        }
                        if (plan.navPoints && plan.navPoints.length > 0) {
                            const tbl = group.strValues.NavTargetPoints?.numValues || new $0b8af60ab5d60464$export$54ec01a60f47d33d().numValues;
                            for (const np of plan.navPoints){
                                const t = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
                                t.set("x", np.x);
                                t.set("y", np.y);
                                t.set("text_comment", np.textComment);
                                t.set("index", np.index);
                                tbl[np.index] = t;
                            }
                            if (!group.strValues.NavTargetPoints) {
                                group.strValues.NavTargetPoints = new $0b8af60ab5d60464$export$54ec01a60f47d33d();
                                group.strValues.NavTargetPoints.numValues = tbl;
                            }
                        }
                    }
                }
            }
        }
    };



const $70de41fa111b1925$export$9893a8e42f3f46ad = (tasking, jobSettings)=>async (zip)=>{
        const composer = await (0, $366e7823df40ef4e$export$8fdd276949ba31d5)(tasking, jobSettings);
        const blob = await composer.renderToBlob();
        return zip.file("KNEEBOARD/IMAGES/Airbases.png", blob);
    };


function $5995d3bed1c2280a$export$2e2bcd8739ae039(currentUserID, manifestID, am) {
    return async (zip)=>{
        const list = await am.list(manifestID);
        for (const asset of list){
            if (asset.jobType) continue;
            const url = await am.url(currentUserID, asset);
            const file = await fetch(url).then((res)=>res.blob());
            zip = zip.file(`KNEEBOARD/IMAGES/${asset.name}`, file);
        }
        return zip;
    };
}



const $5519ddab0bdd0a39$export$a838df5501834181 = (tasking, title)=>async (zip)=>{
        const composer = await (0, $59e76ac65671d31b$export$933d533764865bb)(tasking, title);
        const blob = await composer.renderToBlob();
        return zip.file("KNEEBOARD/IMAGES/Briefing.png", blob);
    };





const $033e320cfcdb0c59$export$365fc63a9dedb39e = (tasking, plans)=>async (zip)=>{
        const groups = (0, $92839c6c950486dc$export$7f919cacd49cf683)(plans, tasking.plannedGroups, {
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
        });
        for (const group of groups){
            const type = group.units[0].type;
            const composer = await (0, $59e76ac65671d31b$export$62862cd479f79fd7)(group);
            const blob = await composer.renderToBlob();
            zip = zip.file(`KNEEBOARD/${type}/IMAGES/${group.name}_CommsCard.png`, blob);
        }
        return zip;
    };



const $a51434310f799586$export$d76af75bc24d9b45 = (tasking)=>async (zip)=>{
        const composer = await (0, $6989236d425f0950$export$dfd7129622cfccc3)(tasking);
        const blob = await composer.renderToBlob();
        zip = zip.file(`KNEEBOARD/IMAGES/FragOrders_Control_Points.png`, blob);
        return zip;
    };





const $0968f9878ed7a685$export$2c7aaff40fd6353a = (tasking, plans, jobSettings, radioConfig, externalData, planItems)=>async (zip)=>{
        const groups = (0, $92839c6c950486dc$export$7f919cacd49cf683)(plans, tasking.plannedGroups, {
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
        });
        for (const group of groups){
            const type = group.units[0].type;
            const composer = await (0, $08a4e17e4b7d2cae$export$3dd67841550c9710)(tasking, group, jobSettings, radioConfig, externalData, planItems);
            const blob = await composer.renderToBlob();
            zip = zip.file(`KNEEBOARD/${type}/IMAGES/${group.name}_LineupCard.png`, blob);
        }
        return zip;
    };



const $cb87d29c90c2795c$export$244734aa07496335 = (radioConfig)=>async (zip)=>{
        const composer = await (0, $06abbfd1311cc25f$export$f5e408544e31b1f)(radioConfig);
        const blob = await composer.renderToBlob();
        zip = zip.file(`KNEEBOARD/IMAGES/FragOrders_Master_Frequencies.png`, blob);
        return zip;
    };





const $e1b7bdbadfaaf8ab$export$c982a37b93543cd9 = (tasking, plans, jobSettings)=>async (zip)=>{
        const groups = (0, $92839c6c950486dc$export$7f919cacd49cf683)(plans, tasking.plannedGroups, {
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
        });
        for (const group of groups){
            const type = group.units[0].type;
            const composer = await (0, $0dcf5d51c79343e5$export$235114961ede588e)(tasking, group, jobSettings);
            const blob = await composer.renderToBlob();
            zip = zip.file(`KNEEBOARD/${type}/IMAGES/${group.name}_RouteDetail.png`, blob);
        }
        return zip;
    };



const $6128bf652491b016$export$39fa7f973321a045 = (tasking)=>async (zip)=>{
        const composer = await (0, $9ba3ac95ea50b8ac$export$55eed746402cf864)(tasking);
        const blob = await composer.renderToBlob();
        return zip.file("KNEEBOARD/IMAGES/SupportAssets.png", blob);
    };




const $6c8a2b46ddfacc63$var$applyRadioPresets = (presets, opts)=>(mission)=>{
        const formatted = [
            presets.UHF,
            presets.VHF,
            presets["V/UHF"],
            presets.FM
        ];
        const p = (0, $165c1a1c0f22e853$export$b63a20d758e83ab7)(formatted);
        for (const group of opts.groups){
            const g = (0, $c255bc447a24c026$export$8014604593e0a373)(mission, opts.coalition, group.category, group.name);
            if (!g) throw new Error(`Group ${group.name} not found in mission`);
            (0, $c255bc447a24c026$export$9c8a3e002e2d3c78)(g, p);
            const units = (0, $c255bc447a24c026$export$3988ae62b71be9a3)(g, [
                "units"
            ]);
            for (const unit of units.numValues){
                if (!unit) continue;
                (0, $c255bc447a24c026$export$d05c0403206b558e)(unit, p);
            }
        }
    };
var $6c8a2b46ddfacc63$export$2e2bcd8739ae039 = $6c8a2b46ddfacc63$var$applyRadioPresets;









var $d286e426fc35c29d$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $d286e426fc35c29d$export$2e2bcd8739ae039 = {};
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $d286e426fc35c29d$var$k, $d286e426fc35c29d$var$goog = $d286e426fc35c29d$var$goog || {}, $d286e426fc35c29d$var$l = $d286e426fc35c29d$var$commonjsGlobal || self;
function $d286e426fc35c29d$var$aa() {}
function $d286e426fc35c29d$var$ba(a) {
    var b = typeof a;
    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $d286e426fc35c29d$var$p(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $d286e426fc35c29d$var$da(a) {
    return Object.prototype.hasOwnProperty.call(a, $d286e426fc35c29d$var$ea) && a[$d286e426fc35c29d$var$ea] || (a[$d286e426fc35c29d$var$ea] = ++$d286e426fc35c29d$var$fa);
}
var $d286e426fc35c29d$var$ea = "closure_uid_" + (1E9 * Math.random() >>> 0), $d286e426fc35c29d$var$fa = 0;
function $d286e426fc35c29d$var$ha(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $d286e426fc35c29d$var$ia(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $d286e426fc35c29d$var$q(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $d286e426fc35c29d$var$q = $d286e426fc35c29d$var$ha : $d286e426fc35c29d$var$q = $d286e426fc35c29d$var$ia;
    return $d286e426fc35c29d$var$q.apply(null, arguments);
}
function $d286e426fc35c29d$var$ja(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
function $d286e426fc35c29d$var$t(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.Z = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.Vb = function(d, e, f) {
        for(var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)h[n - 2] = arguments[n];
        return b.prototype[e].apply(d, h);
    };
}
function $d286e426fc35c29d$var$v() {
    this.s = this.s;
    this.o = this.o;
}
var $d286e426fc35c29d$var$ka = 0, $d286e426fc35c29d$var$la = {};
$d286e426fc35c29d$var$v.prototype.s = !1;
$d286e426fc35c29d$var$v.prototype.na = function() {
    if (!this.s && (this.s = !0, this.M(), 0 != $d286e426fc35c29d$var$ka)) {
        var a = $d286e426fc35c29d$var$da(this);
        delete $d286e426fc35c29d$var$la[a];
    }
};
$d286e426fc35c29d$var$v.prototype.M = function() {
    if (this.o) for(; this.o.length;)this.o.shift()();
};
const $d286e426fc35c29d$var$ma = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(let c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
}, $d286e426fc35c29d$var$na = Array.prototype.forEach ? function(a, b, c) {
    Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
    const d = a.length, e = "string" === typeof a ? a.split("") : a;
    for(let f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
};
function $d286e426fc35c29d$var$oa(a) {
    a: {
        var b = $d286e426fc35c29d$var$pa;
        const c = a.length, d = "string" === typeof a ? a.split("") : a;
        for(let e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
            b = e;
            break a;
        }
        b = -1;
    }
    return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
}
function $d286e426fc35c29d$var$qa(a) {
    return Array.prototype.concat.apply([], arguments);
}
function $d286e426fc35c29d$var$ra(a) {
    const b = a.length;
    if (0 < b) {
        const c = Array(b);
        for(let d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $d286e426fc35c29d$var$sa(a) {
    return /^[\s\xa0]*$/.test(a);
}
var $d286e426fc35c29d$var$ta = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function $d286e426fc35c29d$var$w(a, b) {
    return -1 != a.indexOf(b);
}
function $d286e426fc35c29d$var$ua(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var $d286e426fc35c29d$var$x;
a: {
    var $d286e426fc35c29d$var$va = $d286e426fc35c29d$var$l.navigator;
    if ($d286e426fc35c29d$var$va) {
        var $d286e426fc35c29d$var$wa = $d286e426fc35c29d$var$va.userAgent;
        if ($d286e426fc35c29d$var$wa) {
            $d286e426fc35c29d$var$x = $d286e426fc35c29d$var$wa;
            break a;
        }
    }
    $d286e426fc35c29d$var$x = "";
}
function $d286e426fc35c29d$var$xa(a, b, c) {
    for(const d in a)b.call(c, a[d], d, a);
}
function $d286e426fc35c29d$var$ya(a) {
    const b = {};
    for(const c in a)b[c] = a[c];
    return b;
}
var $d286e426fc35c29d$var$za = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $d286e426fc35c29d$var$Aa(a, b) {
    let c, d;
    for(let e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(let f = 0; f < $d286e426fc35c29d$var$za.length; f++)c = $d286e426fc35c29d$var$za[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $d286e426fc35c29d$var$Ca(a) {
    $d286e426fc35c29d$var$Ca[" "](a);
    return a;
}
$d286e426fc35c29d$var$Ca[" "] = $d286e426fc35c29d$var$aa;
function $d286e426fc35c29d$var$Fa(a) {
    var b = $d286e426fc35c29d$var$Ga;
    return Object.prototype.hasOwnProperty.call(b, 9) ? b[9] : b[9] = a(9);
}
var $d286e426fc35c29d$var$Ha = $d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Opera"), $d286e426fc35c29d$var$y = $d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Trident") || $d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "MSIE"), $d286e426fc35c29d$var$Ia = $d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Edge"), $d286e426fc35c29d$var$Ja = $d286e426fc35c29d$var$Ia || $d286e426fc35c29d$var$y, $d286e426fc35c29d$var$Ka = $d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Gecko") && !($d286e426fc35c29d$var$w($d286e426fc35c29d$var$x.toLowerCase(), "webkit") && !$d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Edge")) && !($d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Trident") || $d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "MSIE")) && !$d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Edge"), $d286e426fc35c29d$var$La = $d286e426fc35c29d$var$w($d286e426fc35c29d$var$x.toLowerCase(), "webkit") && !$d286e426fc35c29d$var$w($d286e426fc35c29d$var$x, "Edge");
function $d286e426fc35c29d$var$Ma() {
    var a = $d286e426fc35c29d$var$l.document;
    return a ? a.documentMode : void 0;
}
var $d286e426fc35c29d$var$Na;
a: {
    var $d286e426fc35c29d$var$Oa = "", $d286e426fc35c29d$var$Pa = function() {
        var a = $d286e426fc35c29d$var$x;
        if ($d286e426fc35c29d$var$Ka) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($d286e426fc35c29d$var$Ia) return /Edge\/([\d\.]+)/.exec(a);
        if ($d286e426fc35c29d$var$y) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($d286e426fc35c29d$var$La) return /WebKit\/(\S+)/.exec(a);
        if ($d286e426fc35c29d$var$Ha) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $d286e426fc35c29d$var$Pa && ($d286e426fc35c29d$var$Oa = $d286e426fc35c29d$var$Pa ? $d286e426fc35c29d$var$Pa[1] : "");
    if ($d286e426fc35c29d$var$y) {
        var $d286e426fc35c29d$var$Qa = $d286e426fc35c29d$var$Ma();
        if (null != $d286e426fc35c29d$var$Qa && $d286e426fc35c29d$var$Qa > parseFloat($d286e426fc35c29d$var$Oa)) {
            $d286e426fc35c29d$var$Na = String($d286e426fc35c29d$var$Qa);
            break a;
        }
    }
    $d286e426fc35c29d$var$Na = $d286e426fc35c29d$var$Oa;
}
var $d286e426fc35c29d$var$Ga = {};
function $d286e426fc35c29d$var$Ra() {
    return $d286e426fc35c29d$var$Fa(function() {
        let a = 0;
        const b = $d286e426fc35c29d$var$ta(String($d286e426fc35c29d$var$Na)).split("."), c = $d286e426fc35c29d$var$ta("9").split("."), d = Math.max(b.length, c.length);
        for(let h = 0; 0 == a && h < d; h++){
            var e = b[h] || "", f = c[h] || "";
            do {
                e = /(\d*)(\D*)(.*)/.exec(e) || [
                    "",
                    "",
                    "",
                    ""
                ];
                f = /(\d*)(\D*)(.*)/.exec(f) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == e[0].length && 0 == f[0].length) break;
                a = $d286e426fc35c29d$var$ua(0 == e[1].length ? 0 : parseInt(e[1], 10), 0 == f[1].length ? 0 : parseInt(f[1], 10)) || $d286e426fc35c29d$var$ua(0 == e[2].length, 0 == f[2].length) || $d286e426fc35c29d$var$ua(e[2], f[2]);
                e = e[3];
                f = f[3];
            }while (0 == a);
        }
        return 0 <= a;
    });
}
var $d286e426fc35c29d$var$Sa;
if ($d286e426fc35c29d$var$l.document && $d286e426fc35c29d$var$y) {
    var $d286e426fc35c29d$var$Ta = $d286e426fc35c29d$var$Ma();
    $d286e426fc35c29d$var$Sa = $d286e426fc35c29d$var$Ta ? $d286e426fc35c29d$var$Ta : parseInt($d286e426fc35c29d$var$Na, 10) || void 0;
} else $d286e426fc35c29d$var$Sa = void 0;
var $d286e426fc35c29d$var$Ua = $d286e426fc35c29d$var$Sa;
var $d286e426fc35c29d$var$Va = function() {
    if (!$d286e426fc35c29d$var$l.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $d286e426fc35c29d$var$l.addEventListener("test", $d286e426fc35c29d$var$aa, b), $d286e426fc35c29d$var$l.removeEventListener("test", $d286e426fc35c29d$var$aa, b);
    } catch (c) {}
    return a;
}();
function $d286e426fc35c29d$var$z(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
}
$d286e426fc35c29d$var$z.prototype.h = function() {
    this.defaultPrevented = !0;
};
function $d286e426fc35c29d$var$A(a, b) {
    $d286e426fc35c29d$var$z.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        if (b = a.relatedTarget) {
            if ($d286e426fc35c29d$var$Ka) {
                a: {
                    try {
                        $d286e426fc35c29d$var$Ca(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $d286e426fc35c29d$var$Wa[a.pointerType] || "";
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && $d286e426fc35c29d$var$A.Z.h.call(this);
    }
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$A, $d286e426fc35c29d$var$z);
var $d286e426fc35c29d$var$Wa = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$d286e426fc35c29d$var$A.prototype.h = function() {
    $d286e426fc35c29d$var$A.Z.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $d286e426fc35c29d$var$B = "closure_listenable_" + (1E6 * Math.random() | 0);
var $d286e426fc35c29d$var$Xa = 0;
function $d286e426fc35c29d$var$Ya(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.ia = e;
    this.key = ++$d286e426fc35c29d$var$Xa;
    this.ca = this.fa = !1;
}
function $d286e426fc35c29d$var$Za(a) {
    a.ca = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.ia = null;
}
function $d286e426fc35c29d$var$$a(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
}
$d286e426fc35c29d$var$$a.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var h = $d286e426fc35c29d$var$ab(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.fa = !1)) : (b = new $d286e426fc35c29d$var$Ya(b, this.src, f, !!d, e), b.fa = c, a.push(b));
    return b;
};
function $d286e426fc35c29d$var$bb(a, b) {
    var c = b.type;
    if (c in a.g) {
        var d = a.g[c], e = $d286e426fc35c29d$var$ma(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($d286e426fc35c29d$var$Za(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
}
function $d286e426fc35c29d$var$ab(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.ca && f.listener == b && f.capture == !!c && f.ia == d) return e;
    }
    return -1;
}
var $d286e426fc35c29d$var$cb = "closure_lm_" + (1E6 * Math.random() | 0), $d286e426fc35c29d$var$db = {};
function $d286e426fc35c29d$var$fb(a, b, c, d, e) {
    if (d && d.once) return $d286e426fc35c29d$var$gb(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$d286e426fc35c29d$var$fb(a, b[f], c, d, e);
        return null;
    }
    c = $d286e426fc35c29d$var$hb(c);
    return a && a[$d286e426fc35c29d$var$B] ? a.N(b, c, $d286e426fc35c29d$var$p(d) ? !!d.capture : !!d, e) : $d286e426fc35c29d$var$ib(a, b, c, !1, d, e);
}
function $d286e426fc35c29d$var$ib(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $d286e426fc35c29d$var$p(e) ? !!e.capture : !!e, n = $d286e426fc35c29d$var$jb(a);
    n || (a[$d286e426fc35c29d$var$cb] = n = new $d286e426fc35c29d$var$$a(a));
    c = n.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $d286e426fc35c29d$var$kb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $d286e426fc35c29d$var$Va || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($d286e426fc35c29d$var$lb(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $d286e426fc35c29d$var$kb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    var b = $d286e426fc35c29d$var$mb;
    return a;
}
function $d286e426fc35c29d$var$gb(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$d286e426fc35c29d$var$gb(a, b[f], c, d, e);
        return null;
    }
    c = $d286e426fc35c29d$var$hb(c);
    return a && a[$d286e426fc35c29d$var$B] ? a.O(b, c, $d286e426fc35c29d$var$p(d) ? !!d.capture : !!d, e) : $d286e426fc35c29d$var$ib(a, b, c, !0, d, e);
}
function $d286e426fc35c29d$var$nb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$d286e426fc35c29d$var$nb(a, b[f], c, d, e);
    else (d = $d286e426fc35c29d$var$p(d) ? !!d.capture : !!d, c = $d286e426fc35c29d$var$hb(c), a && a[$d286e426fc35c29d$var$B]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = $d286e426fc35c29d$var$ab(f, c, d, e), -1 < c && ($d286e426fc35c29d$var$Za(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = $d286e426fc35c29d$var$jb(a)) && (b = a.g[b.toString()], a = -1, b && (a = $d286e426fc35c29d$var$ab(b, c, d, e)), (c = -1 < a ? b[a] : null) && $d286e426fc35c29d$var$ob(c));
}
function $d286e426fc35c29d$var$ob(a) {
    if ("number" !== typeof a && a && !a.ca) {
        var b = a.src;
        if (b && b[$d286e426fc35c29d$var$B]) $d286e426fc35c29d$var$bb(b.i, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($d286e426fc35c29d$var$lb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $d286e426fc35c29d$var$jb(b)) ? ($d286e426fc35c29d$var$bb(c, a), 0 == c.h && (c.src = null, b[$d286e426fc35c29d$var$cb] = null)) : $d286e426fc35c29d$var$Za(a);
        }
    }
}
function $d286e426fc35c29d$var$lb(a) {
    return a in $d286e426fc35c29d$var$db ? $d286e426fc35c29d$var$db[a] : $d286e426fc35c29d$var$db[a] = "on" + a;
}
function $d286e426fc35c29d$var$mb(a, b) {
    if (a.ca) a = !0;
    else {
        b = new $d286e426fc35c29d$var$A(b, this);
        var c = a.listener, d = a.ia || a.src;
        a.fa && $d286e426fc35c29d$var$ob(a);
        a = c.call(d, b);
    }
    return a;
}
function $d286e426fc35c29d$var$jb(a) {
    a = a[$d286e426fc35c29d$var$cb];
    return a instanceof $d286e426fc35c29d$var$$a ? a : null;
}
var $d286e426fc35c29d$var$pb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $d286e426fc35c29d$var$hb(a) {
    if ("function" === typeof a) return a;
    a[$d286e426fc35c29d$var$pb] || (a[$d286e426fc35c29d$var$pb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$d286e426fc35c29d$var$pb];
}
function $d286e426fc35c29d$var$C() {
    $d286e426fc35c29d$var$v.call(this);
    this.i = new $d286e426fc35c29d$var$$a(this);
    this.P = this;
    this.I = null;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$C, $d286e426fc35c29d$var$v);
$d286e426fc35c29d$var$C.prototype[$d286e426fc35c29d$var$B] = !0;
$d286e426fc35c29d$var$C.prototype.removeEventListener = function(a, b, c, d) {
    $d286e426fc35c29d$var$nb(this, a, b, c, d);
};
function $d286e426fc35c29d$var$D(a, b) {
    var c, d = a.I;
    if (d) for(c = []; d; d = d.I)c.push(d);
    a = a.P;
    d = b.type || b;
    if ("string" === typeof b) b = new $d286e426fc35c29d$var$z(b, a);
    else if (b instanceof $d286e426fc35c29d$var$z) b.target = b.target || a;
    else {
        var e = b;
        b = new $d286e426fc35c29d$var$z(d, a);
        $d286e426fc35c29d$var$Aa(b, e);
    }
    e = !0;
    if (c) for(var f = c.length - 1; 0 <= f; f--){
        var h = b.g = c[f];
        e = $d286e426fc35c29d$var$qb(h, d, !0, b) && e;
    }
    h = b.g = a;
    e = $d286e426fc35c29d$var$qb(h, d, !0, b) && e;
    e = $d286e426fc35c29d$var$qb(h, d, !1, b) && e;
    if (c) for(f = 0; f < c.length; f++)h = b.g = c[f], e = $d286e426fc35c29d$var$qb(h, d, !1, b) && e;
}
$d286e426fc35c29d$var$C.prototype.M = function() {
    $d286e426fc35c29d$var$C.Z.M.call(this);
    if (this.i) {
        var a = this.i, c;
        for(c in a.g){
            for(var d = a.g[c], e = 0; e < d.length; e++)$d286e426fc35c29d$var$Za(d[e]);
            delete a.g[c];
            a.h--;
        }
    }
    this.I = null;
};
$d286e426fc35c29d$var$C.prototype.N = function(a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
};
$d286e426fc35c29d$var$C.prototype.O = function(a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
};
function $d286e426fc35c29d$var$qb(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.ca && h.capture == c) {
            var n = h.listener, u = h.ia || h.src;
            h.fa && $d286e426fc35c29d$var$bb(a.i, h);
            e = !1 !== n.call(u, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $d286e426fc35c29d$var$rb = $d286e426fc35c29d$var$l.JSON.stringify;
function $d286e426fc35c29d$var$sb() {
    var a = $d286e426fc35c29d$var$tb;
    let b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
}
class $d286e426fc35c29d$var$ub {
    constructor(){
        this.h = this.g = null;
    }
    add(a, b) {
        const c = $d286e426fc35c29d$var$vb.get();
        c.set(a, b);
        this.h ? this.h.next = c : this.g = c;
        this.h = c;
    }
}
var $d286e426fc35c29d$var$vb = new class {
    constructor(a, b){
        this.i = a;
        this.j = b;
        this.h = 0;
        this.g = null;
    }
    get() {
        let a;
        0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
        return a;
    }
}(()=>new $d286e426fc35c29d$var$wb, (a)=>a.reset());
class $d286e426fc35c29d$var$wb {
    constructor(){
        this.next = this.g = this.h = null;
    }
    set(a, b) {
        this.h = a;
        this.g = b;
        this.next = null;
    }
    reset() {
        this.next = this.g = this.h = null;
    }
}
function $d286e426fc35c29d$var$yb(a) {
    $d286e426fc35c29d$var$l.setTimeout(()=>{
        throw a;
    }, 0);
}
function $d286e426fc35c29d$var$zb(a, b) {
    $d286e426fc35c29d$var$Ab || $d286e426fc35c29d$var$Bb();
    $d286e426fc35c29d$var$Cb || ($d286e426fc35c29d$var$Ab(), $d286e426fc35c29d$var$Cb = !0);
    $d286e426fc35c29d$var$tb.add(a, b);
}
var $d286e426fc35c29d$var$Ab;
function $d286e426fc35c29d$var$Bb() {
    var a = $d286e426fc35c29d$var$l.Promise.resolve(void 0);
    $d286e426fc35c29d$var$Ab = function() {
        a.then($d286e426fc35c29d$var$Db);
    };
}
var $d286e426fc35c29d$var$Cb = !1, $d286e426fc35c29d$var$tb = new $d286e426fc35c29d$var$ub;
function $d286e426fc35c29d$var$Db() {
    for(var a; a = $d286e426fc35c29d$var$sb();){
        try {
            a.h.call(a.g);
        } catch (c) {
            $d286e426fc35c29d$var$yb(c);
        }
        var b = $d286e426fc35c29d$var$vb;
        b.j(a);
        100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }
    $d286e426fc35c29d$var$Cb = !1;
}
function $d286e426fc35c29d$var$Eb(a, b) {
    $d286e426fc35c29d$var$C.call(this);
    this.h = a || 1;
    this.g = b || $d286e426fc35c29d$var$l;
    this.j = $d286e426fc35c29d$var$q(this.kb, this);
    this.l = Date.now();
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Eb, $d286e426fc35c29d$var$C);
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$Eb.prototype;
$d286e426fc35c29d$var$k.da = !1;
$d286e426fc35c29d$var$k.S = null;
$d286e426fc35c29d$var$k.kb = function() {
    if (this.da) {
        var a = Date.now() - this.l;
        0 < a && a < .8 * this.h ? this.S = this.g.setTimeout(this.j, this.h - a) : (this.S && (this.g.clearTimeout(this.S), this.S = null), $d286e426fc35c29d$var$D(this, "tick"), this.da && ($d286e426fc35c29d$var$Fb(this), this.start()));
    }
};
$d286e426fc35c29d$var$k.start = function() {
    this.da = !0;
    this.S || (this.S = this.g.setTimeout(this.j, this.h), this.l = Date.now());
};
function $d286e426fc35c29d$var$Fb(a) {
    a.da = !1;
    a.S && (a.g.clearTimeout(a.S), a.S = null);
}
$d286e426fc35c29d$var$k.M = function() {
    $d286e426fc35c29d$var$Eb.Z.M.call(this);
    $d286e426fc35c29d$var$Fb(this);
    delete this.g;
};
function $d286e426fc35c29d$var$Gb(a, b, c) {
    if ("function" === typeof a) c && (a = $d286e426fc35c29d$var$q(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $d286e426fc35c29d$var$q(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $d286e426fc35c29d$var$l.setTimeout(a, b || 0);
}
function $d286e426fc35c29d$var$Hb(a) {
    a.g = $d286e426fc35c29d$var$Gb(()=>{
        a.g = null;
        a.i && (a.i = !1, $d286e426fc35c29d$var$Hb(a));
    }, a.j);
    const b = a.h;
    a.h = null;
    a.m.apply(null, b);
}
class $d286e426fc35c29d$var$Ib extends $d286e426fc35c29d$var$v {
    constructor(a, b){
        super();
        this.m = a;
        this.j = b;
        this.h = null;
        this.i = !1;
        this.g = null;
    }
    l(a) {
        this.h = arguments;
        this.g ? this.i = !0 : $d286e426fc35c29d$var$Hb(this);
    }
    M() {
        super.M();
        this.g && ($d286e426fc35c29d$var$l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    }
}
function $d286e426fc35c29d$var$E(a) {
    $d286e426fc35c29d$var$v.call(this);
    this.h = a;
    this.g = {};
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$E, $d286e426fc35c29d$var$v);
var $d286e426fc35c29d$var$Jb = [];
function $d286e426fc35c29d$var$Kb(a, b, c, d) {
    Array.isArray(c) || (c && ($d286e426fc35c29d$var$Jb[0] = c.toString()), c = $d286e426fc35c29d$var$Jb);
    for(var e = 0; e < c.length; e++){
        var f = $d286e426fc35c29d$var$fb(b, c[e], d || a.handleEvent, !1, a.h || a);
        if (!f) break;
        a.g[f.key] = f;
    }
}
function $d286e426fc35c29d$var$Lb(a) {
    $d286e426fc35c29d$var$xa(a.g, function(b, c) {
        this.g.hasOwnProperty(c) && $d286e426fc35c29d$var$ob(b);
    }, a);
    a.g = {};
}
$d286e426fc35c29d$var$E.prototype.M = function() {
    $d286e426fc35c29d$var$E.Z.M.call(this);
    $d286e426fc35c29d$var$Lb(this);
};
$d286e426fc35c29d$var$E.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $d286e426fc35c29d$var$Mb() {
    this.g = !0;
}
$d286e426fc35c29d$var$Mb.prototype.Aa = function() {
    this.g = !1;
};
function $d286e426fc35c29d$var$Nb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.g) {
            if (f) {
                var h = "";
                for(var n = f.split("&"), u = 0; u < n.length; u++){
                    var m = n[u].split("=");
                    if (1 < m.length) {
                        var r = m[0];
                        m = m[1];
                        var G = r.split("_");
                        h = 2 <= G.length && "type" == G[1] ? h + (r + "=" + m + "&") : h + (r + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $d286e426fc35c29d$var$Ob(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $d286e426fc35c29d$var$F(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $d286e426fc35c29d$var$Pb(a, c) + (d ? " " + d : "");
    });
}
function $d286e426fc35c29d$var$Qb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$d286e426fc35c29d$var$Mb.prototype.info = function() {};
function $d286e426fc35c29d$var$Pb(a, b) {
    if (!a.g) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $d286e426fc35c29d$var$rb(c);
    } catch (n) {
        return b;
    }
}
var $d286e426fc35c29d$var$H = {}, $d286e426fc35c29d$var$Rb = null;
function $d286e426fc35c29d$var$Sb() {
    return $d286e426fc35c29d$var$Rb = $d286e426fc35c29d$var$Rb || new $d286e426fc35c29d$var$C;
}
$d286e426fc35c29d$var$H.Ma = "serverreachability";
function $d286e426fc35c29d$var$Tb(a) {
    $d286e426fc35c29d$var$z.call(this, $d286e426fc35c29d$var$H.Ma, a);
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Tb, $d286e426fc35c29d$var$z);
function $d286e426fc35c29d$var$I(a) {
    const b = $d286e426fc35c29d$var$Sb();
    $d286e426fc35c29d$var$D(b, new $d286e426fc35c29d$var$Tb(b, a));
}
$d286e426fc35c29d$var$H.STAT_EVENT = "statevent";
function $d286e426fc35c29d$var$Ub(a, b) {
    $d286e426fc35c29d$var$z.call(this, $d286e426fc35c29d$var$H.STAT_EVENT, a);
    this.stat = b;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Ub, $d286e426fc35c29d$var$z);
function $d286e426fc35c29d$var$J(a) {
    const b = $d286e426fc35c29d$var$Sb();
    $d286e426fc35c29d$var$D(b, new $d286e426fc35c29d$var$Ub(b, a));
}
$d286e426fc35c29d$var$H.Na = "timingevent";
function $d286e426fc35c29d$var$Vb(a, b) {
    $d286e426fc35c29d$var$z.call(this, $d286e426fc35c29d$var$H.Na, a);
    this.size = b;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Vb, $d286e426fc35c29d$var$z);
function $d286e426fc35c29d$var$K(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return $d286e426fc35c29d$var$l.setTimeout(function() {
        a();
    }, b);
}
var $d286e426fc35c29d$var$Wb = {
    NO_ERROR: 0,
    lb: 1,
    yb: 2,
    xb: 3,
    sb: 4,
    wb: 5,
    zb: 6,
    Ja: 7,
    TIMEOUT: 8,
    Cb: 9
};
var $d286e426fc35c29d$var$Xb = {
    qb: "complete",
    Mb: "success",
    Ka: "error",
    Ja: "abort",
    Eb: "ready",
    Fb: "readystatechange",
    TIMEOUT: "timeout",
    Ab: "incrementaldata",
    Db: "progress",
    tb: "downloadprogress",
    Ub: "uploadprogress"
};
function $d286e426fc35c29d$var$Yb() {}
$d286e426fc35c29d$var$Yb.prototype.h = null;
function $d286e426fc35c29d$var$Zb(a) {
    return a.h || (a.h = a.i());
}
function $d286e426fc35c29d$var$$b() {}
var $d286e426fc35c29d$var$L = {
    OPEN: "a",
    pb: "b",
    Ka: "c",
    Bb: "d"
};
function $d286e426fc35c29d$var$ac() {
    $d286e426fc35c29d$var$z.call(this, "d");
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$ac, $d286e426fc35c29d$var$z);
function $d286e426fc35c29d$var$bc() {
    $d286e426fc35c29d$var$z.call(this, "c");
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$bc, $d286e426fc35c29d$var$z);
var $d286e426fc35c29d$var$cc;
function $d286e426fc35c29d$var$dc() {}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$dc, $d286e426fc35c29d$var$Yb);
$d286e426fc35c29d$var$dc.prototype.g = function() {
    return new XMLHttpRequest;
};
$d286e426fc35c29d$var$dc.prototype.i = function() {
    return {};
};
$d286e426fc35c29d$var$cc = new $d286e426fc35c29d$var$dc;
function $d286e426fc35c29d$var$M(a, b, c, d) {
    this.l = a;
    this.j = b;
    this.m = c;
    this.X = d || 1;
    this.V = new $d286e426fc35c29d$var$E(this);
    this.P = $d286e426fc35c29d$var$ec;
    a = $d286e426fc35c29d$var$Ja ? 125 : void 0;
    this.W = new $d286e426fc35c29d$var$Eb(a);
    this.H = null;
    this.i = !1;
    this.s = this.A = this.v = this.K = this.F = this.Y = this.B = null;
    this.D = [];
    this.g = null;
    this.C = 0;
    this.o = this.u = null;
    this.N = -1;
    this.I = !1;
    this.O = 0;
    this.L = null;
    this.aa = this.J = this.$ = this.U = !1;
    this.h = new $d286e426fc35c29d$var$fc;
}
function $d286e426fc35c29d$var$fc() {
    this.i = null;
    this.g = "";
    this.h = !1;
}
var $d286e426fc35c29d$var$ec = 45E3, $d286e426fc35c29d$var$gc = {}, $d286e426fc35c29d$var$hc = {};
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$M.prototype;
$d286e426fc35c29d$var$k.setTimeout = function(a) {
    this.P = a;
};
function $d286e426fc35c29d$var$ic(a, b, c) {
    a.K = 1;
    a.v = $d286e426fc35c29d$var$jc($d286e426fc35c29d$var$N(b));
    a.s = c;
    a.U = !0;
    $d286e426fc35c29d$var$kc(a, null);
}
function $d286e426fc35c29d$var$kc(a, b) {
    a.F = Date.now();
    $d286e426fc35c29d$var$lc(a);
    a.A = $d286e426fc35c29d$var$N(a.v);
    var c = a.A, d = a.X;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $d286e426fc35c29d$var$mc(c.h, "t", d);
    a.C = 0;
    c = a.l.H;
    a.h = new $d286e426fc35c29d$var$fc;
    a.g = $d286e426fc35c29d$var$nc(a.l, c ? b : null, !a.s);
    0 < a.O && (a.L = new $d286e426fc35c29d$var$Ib($d286e426fc35c29d$var$q(a.Ia, a, a.g), a.O));
    $d286e426fc35c29d$var$Kb(a.V, a.g, "readystatechange", a.gb);
    b = a.H ? $d286e426fc35c29d$var$ya(a.H) : {};
    a.s ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.s, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
    $d286e426fc35c29d$var$I(1);
    $d286e426fc35c29d$var$Nb(a.j, a.u, a.A, a.m, a.X, a.s);
}
$d286e426fc35c29d$var$k.gb = function(a) {
    a = a.target;
    const b = this.L;
    b && 3 == $d286e426fc35c29d$var$O(a) ? b.l() : this.Ia(a);
};
$d286e426fc35c29d$var$k.Ia = function(a) {
    try {
        if (a == this.g) a: {
            const r = $d286e426fc35c29d$var$O(this.g);
            var b = this.g.Da();
            const G = this.g.ba();
            if (!(3 > r) && (3 != r || $d286e426fc35c29d$var$Ja || this.g && (this.h.h || this.g.ga() || $d286e426fc35c29d$var$oc(this.g)))) {
                this.I || 4 != r || 7 == b || (8 == b || 0 >= G ? $d286e426fc35c29d$var$I(3) : $d286e426fc35c29d$var$I(2));
                $d286e426fc35c29d$var$pc(this);
                var c = this.g.ba();
                this.N = c;
                b: if ($d286e426fc35c29d$var$qc(this)) {
                    var d = $d286e426fc35c29d$var$oc(this.g);
                    a = "";
                    var e = d.length, f = 4 == $d286e426fc35c29d$var$O(this.g);
                    if (!this.h.i) {
                        if ("undefined" === typeof TextDecoder) {
                            $d286e426fc35c29d$var$P(this);
                            $d286e426fc35c29d$var$rc(this);
                            var h = "";
                            break b;
                        }
                        this.h.i = new $d286e426fc35c29d$var$l.TextDecoder;
                    }
                    for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                        stream: f && b == e - 1
                    });
                    d.splice(0, e);
                    this.h.g += a;
                    this.C = 0;
                    h = this.h.g;
                } else h = this.g.ga();
                this.i = 200 == c;
                $d286e426fc35c29d$var$Ob(this.j, this.u, this.A, this.m, this.X, r, c);
                if (this.i) {
                    if (this.$ && !this.J) {
                        b: {
                            if (this.g) {
                                var n, u = this.g;
                                if ((n = u.g ? u.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !$d286e426fc35c29d$var$sa(n)) {
                                    var m = n;
                                    break b;
                                }
                            }
                            m = null;
                        }
                        if (c = m) $d286e426fc35c29d$var$F(this.j, this.m, c, "Initial handshake response via X-HTTP-Initial-Response"), this.J = !0, $d286e426fc35c29d$var$sc(this, c);
                        else {
                            this.i = !1;
                            this.o = 3;
                            $d286e426fc35c29d$var$J(12);
                            $d286e426fc35c29d$var$P(this);
                            $d286e426fc35c29d$var$rc(this);
                            break a;
                        }
                    }
                    this.U ? ($d286e426fc35c29d$var$tc(this, r, h), $d286e426fc35c29d$var$Ja && this.i && 3 == r && ($d286e426fc35c29d$var$Kb(this.V, this.W, "tick", this.fb), this.W.start())) : ($d286e426fc35c29d$var$F(this.j, this.m, h, null), $d286e426fc35c29d$var$sc(this, h));
                    4 == r && $d286e426fc35c29d$var$P(this);
                    this.i && !this.I && (4 == r ? $d286e426fc35c29d$var$uc(this.l, this) : (this.i = !1, $d286e426fc35c29d$var$lc(this)));
                } else 400 == c && 0 < h.indexOf("Unknown SID") ? (this.o = 3, $d286e426fc35c29d$var$J(12)) : (this.o = 0, $d286e426fc35c29d$var$J(13)), $d286e426fc35c29d$var$P(this), $d286e426fc35c29d$var$rc(this);
            }
        }
    } catch (r) {} finally{}
};
function $d286e426fc35c29d$var$qc(a) {
    return a.g ? "GET" == a.u && 2 != a.K && a.l.Ba : !1;
}
function $d286e426fc35c29d$var$tc(a, b, c) {
    let d = !0, e;
    for(; !a.I && a.C < c.length;)if (e = $d286e426fc35c29d$var$vc(a, c), e == $d286e426fc35c29d$var$hc) {
        4 == b && (a.o = 4, $d286e426fc35c29d$var$J(14), d = !1);
        $d286e426fc35c29d$var$F(a.j, a.m, null, "[Incomplete Response]");
        break;
    } else if (e == $d286e426fc35c29d$var$gc) {
        a.o = 4;
        $d286e426fc35c29d$var$J(15);
        $d286e426fc35c29d$var$F(a.j, a.m, c, "[Invalid Chunk]");
        d = !1;
        break;
    } else $d286e426fc35c29d$var$F(a.j, a.m, e, null), $d286e426fc35c29d$var$sc(a, e);
    $d286e426fc35c29d$var$qc(a) && e != $d286e426fc35c29d$var$hc && e != $d286e426fc35c29d$var$gc && (a.h.g = "", a.C = 0);
    4 != b || 0 != c.length || a.h.h || (a.o = 1, $d286e426fc35c29d$var$J(16), d = !1);
    a.i = a.i && d;
    d ? 0 < c.length && !a.aa && (a.aa = !0, b = a.l, b.g == a && b.$ && !b.L && (b.h.info("Great, no buffering proxy detected. Bytes received: " + c.length), $d286e426fc35c29d$var$wc(b), b.L = !0, $d286e426fc35c29d$var$J(11))) : ($d286e426fc35c29d$var$F(a.j, a.m, c, "[Invalid Chunked Response]"), $d286e426fc35c29d$var$P(a), $d286e426fc35c29d$var$rc(a));
}
$d286e426fc35c29d$var$k.fb = function() {
    if (this.g) {
        var a = $d286e426fc35c29d$var$O(this.g), b = this.g.ga();
        this.C < b.length && ($d286e426fc35c29d$var$pc(this), $d286e426fc35c29d$var$tc(this, a, b), this.i && 4 != a && $d286e426fc35c29d$var$lc(this));
    }
};
function $d286e426fc35c29d$var$vc(a, b) {
    var c = a.C, d = b.indexOf("\n", c);
    if (-1 == d) return $d286e426fc35c29d$var$hc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $d286e426fc35c29d$var$gc;
    d += 1;
    if (d + c > b.length) return $d286e426fc35c29d$var$hc;
    b = b.substr(d, c);
    a.C = d + c;
    return b;
}
$d286e426fc35c29d$var$k.cancel = function() {
    this.I = !0;
    $d286e426fc35c29d$var$P(this);
};
function $d286e426fc35c29d$var$lc(a) {
    a.Y = Date.now() + a.P;
    $d286e426fc35c29d$var$xc(a, a.P);
}
function $d286e426fc35c29d$var$xc(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = $d286e426fc35c29d$var$K($d286e426fc35c29d$var$q(a.eb, a), b);
}
function $d286e426fc35c29d$var$pc(a) {
    a.B && ($d286e426fc35c29d$var$l.clearTimeout(a.B), a.B = null);
}
$d286e426fc35c29d$var$k.eb = function() {
    this.B = null;
    const a = Date.now();
    0 <= a - this.Y ? ($d286e426fc35c29d$var$Qb(this.j, this.A), 2 != this.K && ($d286e426fc35c29d$var$I(3), $d286e426fc35c29d$var$J(17)), $d286e426fc35c29d$var$P(this), this.o = 2, $d286e426fc35c29d$var$rc(this)) : $d286e426fc35c29d$var$xc(this, this.Y - a);
};
function $d286e426fc35c29d$var$rc(a) {
    0 == a.l.G || a.I || $d286e426fc35c29d$var$uc(a.l, a);
}
function $d286e426fc35c29d$var$P(a) {
    $d286e426fc35c29d$var$pc(a);
    var b = a.L;
    b && "function" == typeof b.na && b.na();
    a.L = null;
    $d286e426fc35c29d$var$Fb(a.W);
    $d286e426fc35c29d$var$Lb(a.V);
    a.g && (b = a.g, a.g = null, b.abort(), b.na());
}
function $d286e426fc35c29d$var$sc(a, b) {
    try {
        var c = a.l;
        if (0 != c.G && (c.g == a || $d286e426fc35c29d$var$yc(c.i, a))) {
            if (c.I = a.N, !a.J && $d286e426fc35c29d$var$yc(c.i, a) && 3 == c.G) {
                try {
                    var d = c.Ca.g.parse(b);
                } catch (m) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.u) {
                            if (c.g) {
                                if (c.g.F + 3E3 < a.F) $d286e426fc35c29d$var$zc(c), $d286e426fc35c29d$var$Ac(c);
                                else break a;
                            }
                            $d286e426fc35c29d$var$Bc(c);
                            $d286e426fc35c29d$var$J(18);
                        }
                    } else c.ta = e[1], 0 < c.ta - c.U && 37500 > e[2] && c.N && 0 == c.A && !c.v && (c.v = $d286e426fc35c29d$var$K($d286e426fc35c29d$var$q(c.ab, c), 6E3));
                    if (1 >= $d286e426fc35c29d$var$Cc(c.i) && c.ka) {
                        try {
                            c.ka();
                        } catch (m) {}
                        c.ka = void 0;
                    }
                } else $d286e426fc35c29d$var$Q(c, 11);
            } else if ((a.J || c.g == a) && $d286e426fc35c29d$var$zc(c), !$d286e426fc35c29d$var$sa(b)) for(e = c.Ca.g.parse(b), b = 0; b < e.length; b++){
                let m = e[b];
                c.U = m[0];
                m = m[1];
                if (2 == c.G) {
                    if ("c" == m[0]) {
                        c.J = m[1];
                        c.la = m[2];
                        const r = m[3];
                        null != r && (c.ma = r, c.h.info("VER=" + c.ma));
                        const G = m[4];
                        null != G && (c.za = G, c.h.info("SVER=" + c.za));
                        const Da = m[5];
                        null != Da && "number" === typeof Da && 0 < Da && (d = 1.5 * Da, c.K = d, c.h.info("backChannelRequestTimeoutMs_=" + d));
                        d = c;
                        const ca = a.g;
                        if (ca) {
                            const Ea = ca.g ? ca.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                            if (Ea) {
                                var f = d.i;
                                !f.g && ($d286e426fc35c29d$var$w(Ea, "spdy") || $d286e426fc35c29d$var$w(Ea, "quic") || $d286e426fc35c29d$var$w(Ea, "h2")) && (f.j = f.l, f.g = new Set, f.h && ($d286e426fc35c29d$var$Dc(f, f.h), f.h = null));
                            }
                            if (d.D) {
                                const xb = ca.g ? ca.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                xb && (d.sa = xb, $d286e426fc35c29d$var$R(d.F, d.D, xb));
                            }
                        }
                        c.G = 3;
                        c.j && c.j.xa();
                        c.$ && (c.O = Date.now() - a.F, c.h.info("Handshake RTT: " + c.O + "ms"));
                        d = c;
                        var h = a;
                        d.oa = $d286e426fc35c29d$var$Ec(d, d.H ? d.la : null, d.W);
                        if (h.J) {
                            $d286e426fc35c29d$var$Fc(d.i, h);
                            var n = h, u = d.K;
                            u && n.setTimeout(u);
                            n.B && ($d286e426fc35c29d$var$pc(n), $d286e426fc35c29d$var$lc(n));
                            d.g = h;
                        } else $d286e426fc35c29d$var$Gc(d);
                        0 < c.l.length && $d286e426fc35c29d$var$Hc(c);
                    } else "stop" != m[0] && "close" != m[0] || $d286e426fc35c29d$var$Q(c, 7);
                } else 3 == c.G && ("stop" == m[0] || "close" == m[0] ? "stop" == m[0] ? $d286e426fc35c29d$var$Q(c, 7) : $d286e426fc35c29d$var$Ic(c) : "noop" != m[0] && c.j && c.j.wa(m), c.A = 0);
            }
        }
        $d286e426fc35c29d$var$I(4);
    } catch (m) {}
}
function $d286e426fc35c29d$var$Jc(a) {
    if (a.R && "function" == typeof a.R) return a.R();
    if ("string" === typeof a) return a.split("");
    if ($d286e426fc35c29d$var$ba(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return b;
}
function $d286e426fc35c29d$var$Kc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($d286e426fc35c29d$var$ba(a) || "string" === typeof a) $d286e426fc35c29d$var$na(a, b, void 0);
    else {
        if (a.T && "function" == typeof a.T) var c = a.T();
        else if (a.R && "function" == typeof a.R) c = void 0;
        else if ($d286e426fc35c29d$var$ba(a) || "string" === typeof a) {
            c = [];
            for(var d = a.length, e = 0; e < d; e++)c.push(e);
        } else for(e in c = [], d = 0, a)c[d++] = e;
        d = $d286e426fc35c29d$var$Jc(a);
        e = d.length;
        for(var f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
}
function $d286e426fc35c29d$var$S(a, b) {
    this.h = {};
    this.g = [];
    this.i = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else if (a) {
        if (a instanceof $d286e426fc35c29d$var$S) for(c = a.T(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
        else for(d in a)this.set(d, a[d]);
    }
}
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$S.prototype;
$d286e426fc35c29d$var$k.R = function() {
    $d286e426fc35c29d$var$Lc(this);
    for(var a = [], b = 0; b < this.g.length; b++)a.push(this.h[this.g[b]]);
    return a;
};
$d286e426fc35c29d$var$k.T = function() {
    $d286e426fc35c29d$var$Lc(this);
    return this.g.concat();
};
function $d286e426fc35c29d$var$Lc(a) {
    if (a.i != a.g.length) {
        for(var b = 0, c = 0; b < a.g.length;){
            var d = a.g[b];
            $d286e426fc35c29d$var$T(a.h, d) && (a.g[c++] = d);
            b++;
        }
        a.g.length = c;
    }
    if (a.i != a.g.length) {
        var e = {};
        for(c = b = 0; b < a.g.length;)d = a.g[b], $d286e426fc35c29d$var$T(e, d) || (a.g[c++] = d, e[d] = 1), b++;
        a.g.length = c;
    }
}
$d286e426fc35c29d$var$k.get = function(a, b) {
    return $d286e426fc35c29d$var$T(this.h, a) ? this.h[a] : b;
};
$d286e426fc35c29d$var$k.set = function(a, b) {
    $d286e426fc35c29d$var$T(this.h, a) || (this.i++, this.g.push(a));
    this.h[a] = b;
};
$d286e426fc35c29d$var$k.forEach = function(a, b) {
    for(var c = this.T(), d = 0; d < c.length; d++){
        var e = c[d], f = this.get(e);
        a.call(b, f, e, this);
    }
};
function $d286e426fc35c29d$var$T(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var $d286e426fc35c29d$var$Mc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function $d286e426fc35c29d$var$Nc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $d286e426fc35c29d$var$U(a, b) {
    this.i = this.s = this.j = "";
    this.m = null;
    this.o = this.l = "";
    this.g = !1;
    if (a instanceof $d286e426fc35c29d$var$U) {
        this.g = void 0 !== b ? b : a.g;
        $d286e426fc35c29d$var$Oc(this, a.j);
        this.s = a.s;
        $d286e426fc35c29d$var$Pc(this, a.i);
        $d286e426fc35c29d$var$Qc(this, a.m);
        this.l = a.l;
        b = a.h;
        var c = new $d286e426fc35c29d$var$Rc;
        c.i = b.i;
        b.g && (c.g = new $d286e426fc35c29d$var$S(b.g), c.h = b.h);
        $d286e426fc35c29d$var$Sc(this, c);
        this.o = a.o;
    } else a && (c = String(a).match($d286e426fc35c29d$var$Mc)) ? (this.g = !!b, $d286e426fc35c29d$var$Oc(this, c[1] || "", !0), this.s = $d286e426fc35c29d$var$Tc(c[2] || ""), $d286e426fc35c29d$var$Pc(this, c[3] || "", !0), $d286e426fc35c29d$var$Qc(this, c[4]), this.l = $d286e426fc35c29d$var$Tc(c[5] || "", !0), $d286e426fc35c29d$var$Sc(this, c[6] || "", !0), this.o = $d286e426fc35c29d$var$Tc(c[7] || "")) : (this.g = !!b, this.h = new $d286e426fc35c29d$var$Rc(null, this.g));
}
$d286e426fc35c29d$var$U.prototype.toString = function() {
    var a = [], b = this.j;
    b && a.push($d286e426fc35c29d$var$Uc(b, $d286e426fc35c29d$var$Vc, !0), ":");
    var c = this.i;
    if (c || "file" == b) a.push("//"), (b = this.s) && a.push($d286e426fc35c29d$var$Uc(b, $d286e426fc35c29d$var$Vc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));
    if (c = this.l) this.i && "/" != c.charAt(0) && a.push("/"), a.push($d286e426fc35c29d$var$Uc(c, "/" == c.charAt(0) ? $d286e426fc35c29d$var$Wc : $d286e426fc35c29d$var$Xc, !0));
    (c = this.h.toString()) && a.push("?", c);
    (c = this.o) && a.push("#", $d286e426fc35c29d$var$Uc(c, $d286e426fc35c29d$var$Yc));
    return a.join("");
};
function $d286e426fc35c29d$var$N(a) {
    return new $d286e426fc35c29d$var$U(a);
}
function $d286e426fc35c29d$var$Oc(a, b, c) {
    a.j = c ? $d286e426fc35c29d$var$Tc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
}
function $d286e426fc35c29d$var$Pc(a, b, c) {
    a.i = c ? $d286e426fc35c29d$var$Tc(b, !0) : b;
}
function $d286e426fc35c29d$var$Qc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.m = b;
    } else a.m = null;
}
function $d286e426fc35c29d$var$Sc(a, b, c) {
    b instanceof $d286e426fc35c29d$var$Rc ? (a.h = b, $d286e426fc35c29d$var$Zc(a.h, a.g)) : (c || (b = $d286e426fc35c29d$var$Uc(b, $d286e426fc35c29d$var$$c)), a.h = new $d286e426fc35c29d$var$Rc(b, a.g));
}
function $d286e426fc35c29d$var$R(a, b, c) {
    a.h.set(b, c);
}
function $d286e426fc35c29d$var$jc(a) {
    $d286e426fc35c29d$var$R(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
}
function $d286e426fc35c29d$var$ad(a) {
    return a instanceof $d286e426fc35c29d$var$U ? $d286e426fc35c29d$var$N(a) : new $d286e426fc35c29d$var$U(a, void 0);
}
function $d286e426fc35c29d$var$bd(a, b, c, d) {
    var e = new $d286e426fc35c29d$var$U(null, void 0);
    a && $d286e426fc35c29d$var$Oc(e, a);
    b && $d286e426fc35c29d$var$Pc(e, b);
    c && $d286e426fc35c29d$var$Qc(e, c);
    d && (e.l = d);
    return e;
}
function $d286e426fc35c29d$var$Tc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $d286e426fc35c29d$var$Uc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $d286e426fc35c29d$var$cd), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $d286e426fc35c29d$var$cd(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $d286e426fc35c29d$var$Vc = /[#\/\?@]/g, $d286e426fc35c29d$var$Xc = /[#\?:]/g, $d286e426fc35c29d$var$Wc = /[#\?]/g, $d286e426fc35c29d$var$$c = /[#\?@]/g, $d286e426fc35c29d$var$Yc = /#/g;
function $d286e426fc35c29d$var$Rc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
}
function $d286e426fc35c29d$var$V(a) {
    a.g || (a.g = new $d286e426fc35c29d$var$S, a.h = 0, a.i && $d286e426fc35c29d$var$Nc(a.i, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$Rc.prototype;
$d286e426fc35c29d$var$k.add = function(a, b) {
    $d286e426fc35c29d$var$V(this);
    this.i = null;
    a = $d286e426fc35c29d$var$W(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
};
function $d286e426fc35c29d$var$dd(a, b) {
    $d286e426fc35c29d$var$V(a);
    b = $d286e426fc35c29d$var$W(a, b);
    $d286e426fc35c29d$var$T(a.g.h, b) && (a.i = null, a.h -= a.g.get(b).length, a = a.g, $d286e426fc35c29d$var$T(a.h, b) && (delete a.h[b], a.i--, a.g.length > 2 * a.i && $d286e426fc35c29d$var$Lc(a)));
}
function $d286e426fc35c29d$var$ed(a, b) {
    $d286e426fc35c29d$var$V(a);
    b = $d286e426fc35c29d$var$W(a, b);
    return $d286e426fc35c29d$var$T(a.g.h, b);
}
$d286e426fc35c29d$var$k.forEach = function(a, b) {
    $d286e426fc35c29d$var$V(this);
    this.g.forEach(function(c, d) {
        $d286e426fc35c29d$var$na(c, function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$d286e426fc35c29d$var$k.T = function() {
    $d286e426fc35c29d$var$V(this);
    for(var a = this.g.R(), b = this.g.T(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
    return c;
};
$d286e426fc35c29d$var$k.R = function(a) {
    $d286e426fc35c29d$var$V(this);
    var b = [];
    if ("string" === typeof a) $d286e426fc35c29d$var$ed(this, a) && (b = $d286e426fc35c29d$var$qa(b, this.g.get($d286e426fc35c29d$var$W(this, a))));
    else {
        a = this.g.R();
        for(var c = 0; c < a.length; c++)b = $d286e426fc35c29d$var$qa(b, a[c]);
    }
    return b;
};
$d286e426fc35c29d$var$k.set = function(a, b) {
    $d286e426fc35c29d$var$V(this);
    this.i = null;
    a = $d286e426fc35c29d$var$W(this, a);
    $d286e426fc35c29d$var$ed(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [
        b
    ]);
    this.h += 1;
    return this;
};
$d286e426fc35c29d$var$k.get = function(a, b) {
    if (!a) return b;
    a = this.R(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $d286e426fc35c29d$var$mc(a, b, c) {
    $d286e426fc35c29d$var$dd(a, b);
    0 < c.length && (a.i = null, a.g.set($d286e426fc35c29d$var$W(a, b), $d286e426fc35c29d$var$ra(c)), a.h += c.length);
}
$d286e426fc35c29d$var$k.toString = function() {
    if (this.i) return this.i;
    if (!this.g) return "";
    for(var a = [], b = this.g.T(), c = 0; c < b.length; c++){
        var d = b[c], e = encodeURIComponent(String(d));
        d = this.R(d);
        for(var f = 0; f < d.length; f++){
            var h = e;
            "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
            a.push(h);
        }
    }
    return this.i = a.join("&");
};
function $d286e426fc35c29d$var$W(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
}
function $d286e426fc35c29d$var$Zc(a, b) {
    b && !a.j && ($d286e426fc35c29d$var$V(a), a.i = null, a.g.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($d286e426fc35c29d$var$dd(this, d), $d286e426fc35c29d$var$mc(this, e, c));
    }, a));
    a.j = b;
}
var $d286e426fc35c29d$var$fd = class {
    constructor(a, b){
        this.h = a;
        this.g = b;
    }
};
function $d286e426fc35c29d$var$gd(a) {
    this.l = a || $d286e426fc35c29d$var$hd;
    $d286e426fc35c29d$var$l.PerformanceNavigationTiming ? (a = $d286e426fc35c29d$var$l.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($d286e426fc35c29d$var$l.g && $d286e426fc35c29d$var$l.g.Ea && $d286e426fc35c29d$var$l.g.Ea() && $d286e426fc35c29d$var$l.g.Ea().Zb);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set);
    this.h = null;
    this.i = [];
}
var $d286e426fc35c29d$var$hd = 10;
function $d286e426fc35c29d$var$id(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
}
function $d286e426fc35c29d$var$Cc(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
}
function $d286e426fc35c29d$var$yc(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
}
function $d286e426fc35c29d$var$Dc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
}
function $d286e426fc35c29d$var$Fc(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
}
$d286e426fc35c29d$var$gd.prototype.cancel = function() {
    this.i = $d286e426fc35c29d$var$jd(this);
    if (this.h) this.h.cancel(), this.h = null;
    else if (this.g && 0 !== this.g.size) {
        for (const a of this.g.values())a.cancel();
        this.g.clear();
    }
};
function $d286e426fc35c29d$var$jd(a) {
    if (null != a.h) return a.i.concat(a.h.D);
    if (null != a.g && 0 !== a.g.size) {
        let b = a.i;
        for (const c of a.g.values())b = b.concat(c.D);
        return b;
    }
    return $d286e426fc35c29d$var$ra(a.i);
}
function $d286e426fc35c29d$var$kd() {}
$d286e426fc35c29d$var$kd.prototype.stringify = function(a) {
    return $d286e426fc35c29d$var$l.JSON.stringify(a, void 0);
};
$d286e426fc35c29d$var$kd.prototype.parse = function(a) {
    return $d286e426fc35c29d$var$l.JSON.parse(a, void 0);
};
function $d286e426fc35c29d$var$ld() {
    this.g = new $d286e426fc35c29d$var$kd;
}
function $d286e426fc35c29d$var$md(a, b, c) {
    const d = c || "";
    try {
        $d286e426fc35c29d$var$Kc(a, function(e, f) {
            let h = e;
            $d286e426fc35c29d$var$p(e) && (h = $d286e426fc35c29d$var$rb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $d286e426fc35c29d$var$nd(a, b) {
    const c = new $d286e426fc35c29d$var$Mb;
    if ($d286e426fc35c29d$var$l.Image) {
        const d = new Image;
        d.onload = $d286e426fc35c29d$var$ja($d286e426fc35c29d$var$od, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $d286e426fc35c29d$var$ja($d286e426fc35c29d$var$od, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $d286e426fc35c29d$var$ja($d286e426fc35c29d$var$od, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $d286e426fc35c29d$var$ja($d286e426fc35c29d$var$od, c, d, "TestLoadImage: timeout", !1, b);
        $d286e426fc35c29d$var$l.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $d286e426fc35c29d$var$od(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
function $d286e426fc35c29d$var$pd(a) {
    this.l = a.$b || null;
    this.j = a.ib || !1;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$pd, $d286e426fc35c29d$var$Yb);
$d286e426fc35c29d$var$pd.prototype.g = function() {
    return new $d286e426fc35c29d$var$qd(this.l, this.j);
};
$d286e426fc35c29d$var$pd.prototype.i = function(a) {
    return function() {
        return a;
    };
}({});
function $d286e426fc35c29d$var$qd(a, b) {
    $d286e426fc35c29d$var$C.call(this);
    this.D = a;
    this.u = b;
    this.m = void 0;
    this.readyState = $d286e426fc35c29d$var$rd;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.v = new Headers;
    this.h = null;
    this.C = "GET";
    this.B = "";
    this.g = !1;
    this.A = this.j = this.l = null;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$qd, $d286e426fc35c29d$var$C);
var $d286e426fc35c29d$var$rd = 0;
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$qd.prototype;
$d286e426fc35c29d$var$k.open = function(a, b) {
    if (this.readyState != $d286e426fc35c29d$var$rd) throw this.abort(), Error("Error reopening a connection");
    this.C = a;
    this.B = b;
    this.readyState = 1;
    $d286e426fc35c29d$var$sd(this);
};
$d286e426fc35c29d$var$k.send = function(a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    const b = {
        headers: this.v,
        method: this.C,
        credentials: this.m,
        cache: void 0
    };
    a && (b.body = a);
    (this.D || $d286e426fc35c29d$var$l).fetch(new Request(this.B, b)).then(this.Va.bind(this), this.ha.bind(this));
};
$d286e426fc35c29d$var$k.abort = function() {
    this.response = this.responseText = "";
    this.v = new Headers;
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.");
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, $d286e426fc35c29d$var$td(this));
    this.readyState = $d286e426fc35c29d$var$rd;
};
$d286e426fc35c29d$var$k.Va = function(a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, $d286e426fc35c29d$var$sd(this)), this.g && (this.readyState = 3, $d286e426fc35c29d$var$sd(this), this.g))) {
        if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Ta.bind(this), this.ha.bind(this));
        else if ("undefined" !== typeof $d286e426fc35c29d$var$l.ReadableStream && "body" in a) {
            this.j = a.body.getReader();
            if (this.u) {
                if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                this.response = [];
            } else this.response = this.responseText = "", this.A = new TextDecoder;
            $d286e426fc35c29d$var$ud(this);
        } else a.text().then(this.Ua.bind(this), this.ha.bind(this));
    }
};
function $d286e426fc35c29d$var$ud(a) {
    a.j.read().then(a.Sa.bind(a)).catch(a.ha.bind(a));
}
$d286e426fc35c29d$var$k.Sa = function(a) {
    if (this.g) {
        if (this.u && a.value) this.response.push(a.value);
        else if (!this.u) {
            var b = a.value ? a.value : new Uint8Array(0);
            if (b = this.A.decode(b, {
                stream: !a.done
            })) this.response = this.responseText += b;
        }
        a.done ? $d286e426fc35c29d$var$td(this) : $d286e426fc35c29d$var$sd(this);
        3 == this.readyState && $d286e426fc35c29d$var$ud(this);
    }
};
$d286e426fc35c29d$var$k.Ua = function(a) {
    this.g && (this.response = this.responseText = a, $d286e426fc35c29d$var$td(this));
};
$d286e426fc35c29d$var$k.Ta = function(a) {
    this.g && (this.response = a, $d286e426fc35c29d$var$td(this));
};
$d286e426fc35c29d$var$k.ha = function() {
    this.g && $d286e426fc35c29d$var$td(this);
};
function $d286e426fc35c29d$var$td(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.A = null;
    $d286e426fc35c29d$var$sd(a);
}
$d286e426fc35c29d$var$k.setRequestHeader = function(a, b) {
    this.v.append(a, b);
};
$d286e426fc35c29d$var$k.getResponseHeader = function(a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
$d286e426fc35c29d$var$k.getAllResponseHeaders = function() {
    if (!this.h) return "";
    const a = [], b = this.h.entries();
    for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    return a.join("\r\n");
};
function $d286e426fc35c29d$var$sd(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty($d286e426fc35c29d$var$qd.prototype, "withCredentials", {
    get: function() {
        return "include" === this.m;
    },
    set: function(a) {
        this.m = a ? "include" : "same-origin";
    }
});
var $d286e426fc35c29d$var$vd = $d286e426fc35c29d$var$l.JSON.parse;
function $d286e426fc35c29d$var$X(a) {
    $d286e426fc35c29d$var$C.call(this);
    this.headers = new $d286e426fc35c29d$var$S;
    this.u = a || null;
    this.h = !1;
    this.C = this.g = null;
    this.H = "";
    this.m = 0;
    this.j = "";
    this.l = this.F = this.v = this.D = !1;
    this.B = 0;
    this.A = null;
    this.J = $d286e426fc35c29d$var$wd;
    this.K = this.L = !1;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$X, $d286e426fc35c29d$var$C);
var $d286e426fc35c29d$var$wd = "", $d286e426fc35c29d$var$xd = /^https?$/i, $d286e426fc35c29d$var$yd = [
    "POST",
    "PUT"
];
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$X.prototype;
$d286e426fc35c29d$var$k.ea = function(a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.H + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.H = a;
    this.j = "";
    this.m = 0;
    this.D = !1;
    this.h = !0;
    this.g = this.u ? this.u.g() : $d286e426fc35c29d$var$cc.g();
    this.C = this.u ? $d286e426fc35c29d$var$Zb(this.u) : $d286e426fc35c29d$var$Zb($d286e426fc35c29d$var$cc);
    this.g.onreadystatechange = $d286e426fc35c29d$var$q(this.Fa, this);
    try {
        this.F = !0, this.g.open(b, String(a), !0), this.F = !1;
    } catch (f) {
        $d286e426fc35c29d$var$zd(this, f);
        return;
    }
    a = c || "";
    const e = new $d286e426fc35c29d$var$S(this.headers);
    d && $d286e426fc35c29d$var$Kc(d, function(f, h) {
        e.set(h, f);
    });
    d = $d286e426fc35c29d$var$oa(e.T());
    c = $d286e426fc35c29d$var$l.FormData && a instanceof $d286e426fc35c29d$var$l.FormData;
    !(0 <= $d286e426fc35c29d$var$ma($d286e426fc35c29d$var$yd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    e.forEach(function(f, h) {
        this.g.setRequestHeader(h, f);
    }, this);
    this.J && (this.g.responseType = this.J);
    "withCredentials" in this.g && this.g.withCredentials !== this.L && (this.g.withCredentials = this.L);
    try {
        $d286e426fc35c29d$var$Ad(this), 0 < this.B && ((this.K = $d286e426fc35c29d$var$Bd(this.g)) ? (this.g.timeout = this.B, this.g.ontimeout = $d286e426fc35c29d$var$q(this.pa, this)) : this.A = $d286e426fc35c29d$var$Gb(this.pa, this.B, this)), this.v = !0, this.g.send(a), this.v = !1;
    } catch (f) {
        $d286e426fc35c29d$var$zd(this, f);
    }
};
function $d286e426fc35c29d$var$Bd(a) {
    return $d286e426fc35c29d$var$y && $d286e426fc35c29d$var$Ra() && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
function $d286e426fc35c29d$var$pa(a) {
    return "content-type" == a.toLowerCase();
}
$d286e426fc35c29d$var$k.pa = function() {
    "undefined" != typeof $d286e426fc35c29d$var$goog && this.g && (this.j = "Timed out after " + this.B + "ms, aborting", this.m = 8, $d286e426fc35c29d$var$D(this, "timeout"), this.abort(8));
};
function $d286e426fc35c29d$var$zd(a, b) {
    a.h = !1;
    a.g && (a.l = !0, a.g.abort(), a.l = !1);
    a.j = b;
    a.m = 5;
    $d286e426fc35c29d$var$Cd(a);
    $d286e426fc35c29d$var$Dd(a);
}
function $d286e426fc35c29d$var$Cd(a) {
    a.D || (a.D = !0, $d286e426fc35c29d$var$D(a, "complete"), $d286e426fc35c29d$var$D(a, "error"));
}
$d286e426fc35c29d$var$k.abort = function(a) {
    this.g && this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1, this.m = a || 7, $d286e426fc35c29d$var$D(this, "complete"), $d286e426fc35c29d$var$D(this, "abort"), $d286e426fc35c29d$var$Dd(this));
};
$d286e426fc35c29d$var$k.M = function() {
    this.g && (this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1), $d286e426fc35c29d$var$Dd(this, !0));
    $d286e426fc35c29d$var$X.Z.M.call(this);
};
$d286e426fc35c29d$var$k.Fa = function() {
    this.s || (this.F || this.v || this.l ? $d286e426fc35c29d$var$Ed(this) : this.cb());
};
$d286e426fc35c29d$var$k.cb = function() {
    $d286e426fc35c29d$var$Ed(this);
};
function $d286e426fc35c29d$var$Ed(a) {
    if (a.h && "undefined" != typeof $d286e426fc35c29d$var$goog && (!a.C[1] || 4 != $d286e426fc35c29d$var$O(a) || 2 != a.ba())) {
        if (a.v && 4 == $d286e426fc35c29d$var$O(a)) $d286e426fc35c29d$var$Gb(a.Fa, 0, a);
        else if ($d286e426fc35c29d$var$D(a, "readystatechange"), 4 == $d286e426fc35c29d$var$O(a)) {
            a.h = !1;
            try {
                const n = a.ba();
                a: switch(n){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var b = !0;
                        break a;
                    default:
                        b = !1;
                }
                var c;
                if (!(c = b)) {
                    var d;
                    if (d = 0 === n) {
                        var e = String(a.H).match($d286e426fc35c29d$var$Mc)[1] || null;
                        if (!e && $d286e426fc35c29d$var$l.self && $d286e426fc35c29d$var$l.self.location) {
                            var f = $d286e426fc35c29d$var$l.self.location.protocol;
                            e = f.substr(0, f.length - 1);
                        }
                        d = !$d286e426fc35c29d$var$xd.test(e ? e.toLowerCase() : "");
                    }
                    c = d;
                }
                if (c) $d286e426fc35c29d$var$D(a, "complete"), $d286e426fc35c29d$var$D(a, "success");
                else {
                    a.m = 6;
                    try {
                        var h = 2 < $d286e426fc35c29d$var$O(a) ? a.g.statusText : "";
                    } catch (u) {
                        h = "";
                    }
                    a.j = h + " [" + a.ba() + "]";
                    $d286e426fc35c29d$var$Cd(a);
                }
            } finally{
                $d286e426fc35c29d$var$Dd(a);
            }
        }
    }
}
function $d286e426fc35c29d$var$Dd(a, b) {
    if (a.g) {
        $d286e426fc35c29d$var$Ad(a);
        const c = a.g, d = a.C[0] ? $d286e426fc35c29d$var$aa : null;
        a.g = null;
        a.C = null;
        b || $d286e426fc35c29d$var$D(a, "ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $d286e426fc35c29d$var$Ad(a) {
    a.g && a.K && (a.g.ontimeout = null);
    a.A && ($d286e426fc35c29d$var$l.clearTimeout(a.A), a.A = null);
}
function $d286e426fc35c29d$var$O(a) {
    return a.g ? a.g.readyState : 0;
}
$d286e426fc35c29d$var$k.ba = function() {
    try {
        return 2 < $d286e426fc35c29d$var$O(this) ? this.g.status : -1;
    } catch (a) {
        return -1;
    }
};
$d286e426fc35c29d$var$k.ga = function() {
    try {
        return this.g ? this.g.responseText : "";
    } catch (a) {
        return "";
    }
};
$d286e426fc35c29d$var$k.Qa = function(a) {
    if (this.g) {
        var b = this.g.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $d286e426fc35c29d$var$vd(b);
    }
};
function $d286e426fc35c29d$var$oc(a) {
    try {
        if (!a.g) return null;
        if ("response" in a.g) return a.g.response;
        switch(a.J){
            case $d286e426fc35c29d$var$wd:
            case "text":
                return a.g.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
        }
        return null;
    } catch (b) {
        return null;
    }
}
$d286e426fc35c29d$var$k.Da = function() {
    return this.m;
};
$d286e426fc35c29d$var$k.La = function() {
    return "string" === typeof this.j ? this.j : String(this.j);
};
function $d286e426fc35c29d$var$Fd(a) {
    let b = "";
    $d286e426fc35c29d$var$xa(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $d286e426fc35c29d$var$Gd(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $d286e426fc35c29d$var$Fd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $d286e426fc35c29d$var$R(a, b, c));
}
function $d286e426fc35c29d$var$Hd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $d286e426fc35c29d$var$Id(a) {
    this.za = 0;
    this.l = [];
    this.h = new $d286e426fc35c29d$var$Mb;
    this.la = this.oa = this.F = this.W = this.g = this.sa = this.D = this.aa = this.o = this.P = this.s = null;
    this.Za = this.V = 0;
    this.Xa = $d286e426fc35c29d$var$Hd("failFast", !1, a);
    this.N = this.v = this.u = this.m = this.j = null;
    this.X = !0;
    this.I = this.ta = this.U = -1;
    this.Y = this.A = this.C = 0;
    this.Pa = $d286e426fc35c29d$var$Hd("baseRetryDelayMs", 5E3, a);
    this.$a = $d286e426fc35c29d$var$Hd("retryDelaySeedMs", 1E4, a);
    this.Ya = $d286e426fc35c29d$var$Hd("forwardChannelMaxRetries", 2, a);
    this.ra = $d286e426fc35c29d$var$Hd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.qa = a && a.xmlHttpFactory || void 0;
    this.Ba = a && a.Yb || !1;
    this.K = void 0;
    this.H = a && a.supportsCrossDomainXhr || !1;
    this.J = "";
    this.i = new $d286e426fc35c29d$var$gd(a && a.concurrentRequestLimit);
    this.Ca = new $d286e426fc35c29d$var$ld;
    this.ja = a && a.fastHandshake || !1;
    this.Ra = a && a.Wb || !1;
    a && a.Aa && this.h.Aa();
    a && a.forceLongPolling && (this.X = !1);
    this.$ = !this.ja && this.X && a && a.detectBufferingProxy || !1;
    this.ka = void 0;
    this.O = 0;
    this.L = !1;
    this.B = null;
    this.Wa = !a || !1 !== a.Xb;
}
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$Id.prototype;
$d286e426fc35c29d$var$k.ma = 8;
$d286e426fc35c29d$var$k.G = 1;
function $d286e426fc35c29d$var$Ic(a) {
    $d286e426fc35c29d$var$Jd(a);
    if (3 == a.G) {
        var b = a.V++, c = $d286e426fc35c29d$var$N(a.F);
        $d286e426fc35c29d$var$R(c, "SID", a.J);
        $d286e426fc35c29d$var$R(c, "RID", b);
        $d286e426fc35c29d$var$R(c, "TYPE", "terminate");
        $d286e426fc35c29d$var$Kd(a, c);
        b = new $d286e426fc35c29d$var$M(a, a.h, b, void 0);
        b.K = 2;
        b.v = $d286e426fc35c29d$var$jc($d286e426fc35c29d$var$N(c));
        c = !1;
        $d286e426fc35c29d$var$l.navigator && $d286e426fc35c29d$var$l.navigator.sendBeacon && (c = $d286e426fc35c29d$var$l.navigator.sendBeacon(b.v.toString(), ""));
        !c && $d286e426fc35c29d$var$l.Image && ((new Image).src = b.v, c = !0);
        c || (b.g = $d286e426fc35c29d$var$nc(b.l, null), b.g.ea(b.v));
        b.F = Date.now();
        $d286e426fc35c29d$var$lc(b);
    }
    $d286e426fc35c29d$var$Ld(a);
}
$d286e426fc35c29d$var$k.hb = function(a) {
    try {
        this.h.info("Origin Trials invoked: " + a);
    } catch (b) {}
};
function $d286e426fc35c29d$var$Ac(a) {
    a.g && ($d286e426fc35c29d$var$wc(a), a.g.cancel(), a.g = null);
}
function $d286e426fc35c29d$var$Jd(a) {
    $d286e426fc35c29d$var$Ac(a);
    a.u && ($d286e426fc35c29d$var$l.clearTimeout(a.u), a.u = null);
    $d286e426fc35c29d$var$zc(a);
    a.i.cancel();
    a.m && ("number" === typeof a.m && $d286e426fc35c29d$var$l.clearTimeout(a.m), a.m = null);
}
function $d286e426fc35c29d$var$Md(a, b) {
    a.l.push(new $d286e426fc35c29d$var$fd(a.Za++, b));
    3 == a.G && $d286e426fc35c29d$var$Hc(a);
}
function $d286e426fc35c29d$var$Hc(a) {
    $d286e426fc35c29d$var$id(a.i) || a.m || (a.m = !0, $d286e426fc35c29d$var$zb(a.Ha, a), a.C = 0);
}
function $d286e426fc35c29d$var$Nd(a, b) {
    if ($d286e426fc35c29d$var$Cc(a.i) >= a.i.j - (a.m ? 1 : 0)) return !1;
    if (a.m) return a.l = b.D.concat(a.l), !0;
    if (1 == a.G || 2 == a.G || a.C >= (a.Xa ? 0 : a.Ya)) return !1;
    a.m = $d286e426fc35c29d$var$K($d286e426fc35c29d$var$q(a.Ha, a, b), $d286e426fc35c29d$var$Od(a, a.C));
    a.C++;
    return !0;
}
$d286e426fc35c29d$var$k.Ha = function(a) {
    if (this.m) {
        if (this.m = null, 1 == this.G) {
            if (!a) {
                this.V = Math.floor(1E5 * Math.random());
                a = this.V++;
                const e = new $d286e426fc35c29d$var$M(this, this.h, a, void 0);
                let f = this.s;
                this.P && (f ? (f = $d286e426fc35c29d$var$ya(f), $d286e426fc35c29d$var$Aa(f, this.P)) : f = this.P);
                null === this.o && (e.H = f);
                if (this.ja) a: {
                    var b = 0;
                    for(var c = 0; c < this.l.length; c++){
                        b: {
                            var d = this.l[c];
                            if ("__data__" in d.g && (d = d.g.__data__, "string" === typeof d)) {
                                d = d.length;
                                break b;
                            }
                            d = void 0;
                        }
                        if (void 0 === d) break;
                        b += d;
                        if (4096 < b) {
                            b = c;
                            break a;
                        }
                        if (4096 === b || c === this.l.length - 1) {
                            b = c + 1;
                            break a;
                        }
                    }
                    b = 1E3;
                }
                else b = 1E3;
                b = $d286e426fc35c29d$var$Pd(this, e, b);
                c = $d286e426fc35c29d$var$N(this.F);
                $d286e426fc35c29d$var$R(c, "RID", a);
                $d286e426fc35c29d$var$R(c, "CVER", 22);
                this.D && $d286e426fc35c29d$var$R(c, "X-HTTP-Session-Id", this.D);
                $d286e426fc35c29d$var$Kd(this, c);
                this.o && f && $d286e426fc35c29d$var$Gd(c, this.o, f);
                $d286e426fc35c29d$var$Dc(this.i, e);
                this.Ra && $d286e426fc35c29d$var$R(c, "TYPE", "init");
                this.ja ? ($d286e426fc35c29d$var$R(c, "$req", b), $d286e426fc35c29d$var$R(c, "SID", "null"), e.$ = !0, $d286e426fc35c29d$var$ic(e, c, null)) : $d286e426fc35c29d$var$ic(e, c, b);
                this.G = 2;
            }
        } else 3 == this.G && (a ? $d286e426fc35c29d$var$Qd(this, a) : 0 == this.l.length || $d286e426fc35c29d$var$id(this.i) || $d286e426fc35c29d$var$Qd(this));
    }
};
function $d286e426fc35c29d$var$Qd(a, b) {
    var c;
    b ? c = b.m : c = a.V++;
    const d = $d286e426fc35c29d$var$N(a.F);
    $d286e426fc35c29d$var$R(d, "SID", a.J);
    $d286e426fc35c29d$var$R(d, "RID", c);
    $d286e426fc35c29d$var$R(d, "AID", a.U);
    $d286e426fc35c29d$var$Kd(a, d);
    a.o && a.s && $d286e426fc35c29d$var$Gd(d, a.o, a.s);
    c = new $d286e426fc35c29d$var$M(a, a.h, c, a.C + 1);
    null === a.o && (c.H = a.s);
    b && (a.l = b.D.concat(a.l));
    b = $d286e426fc35c29d$var$Pd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.ra) + Math.round(.5 * a.ra * Math.random()));
    $d286e426fc35c29d$var$Dc(a.i, c);
    $d286e426fc35c29d$var$ic(c, d, b);
}
function $d286e426fc35c29d$var$Kd(a, b) {
    a.j && $d286e426fc35c29d$var$Kc({}, function(c, d) {
        $d286e426fc35c29d$var$R(b, d, c);
    });
}
function $d286e426fc35c29d$var$Pd(a, b, c) {
    c = Math.min(a.l.length, c);
    var d = a.j ? $d286e426fc35c29d$var$q(a.j.Oa, a.j, a) : null;
    a: {
        var e = a.l;
        let f = -1;
        for(;;){
            const h = [
                "count=" + c
            ];
            -1 == f ? 0 < c ? (f = e[0].h, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
            let n = !0;
            for(let u = 0; u < c; u++){
                let m = e[u].h;
                const r = e[u].g;
                m -= f;
                if (0 > m) f = Math.max(0, e[u].h - 100), n = !1;
                else try {
                    $d286e426fc35c29d$var$md(r, h, "req" + m + "_");
                } catch (G) {
                    d && d(r);
                }
            }
            if (n) {
                d = h.join("&");
                break a;
            }
        }
    }
    a = a.l.splice(0, c);
    b.D = a;
    return d;
}
function $d286e426fc35c29d$var$Gc(a) {
    a.g || a.u || (a.Y = 1, $d286e426fc35c29d$var$zb(a.Ga, a), a.A = 0);
}
function $d286e426fc35c29d$var$Bc(a) {
    if (a.g || a.u || 3 <= a.A) return !1;
    a.Y++;
    a.u = $d286e426fc35c29d$var$K($d286e426fc35c29d$var$q(a.Ga, a), $d286e426fc35c29d$var$Od(a, a.A));
    a.A++;
    return !0;
}
$d286e426fc35c29d$var$k.Ga = function() {
    this.u = null;
    $d286e426fc35c29d$var$Rd(this);
    if (this.$ && !(this.L || null == this.g || 0 >= this.O)) {
        var a = 2 * this.O;
        this.h.info("BP detection timer enabled: " + a);
        this.B = $d286e426fc35c29d$var$K($d286e426fc35c29d$var$q(this.bb, this), a);
    }
};
$d286e426fc35c29d$var$k.bb = function() {
    this.B && (this.B = null, this.h.info("BP detection timeout reached."), this.h.info("Buffering proxy detected and switch to long-polling!"), this.N = !1, this.L = !0, $d286e426fc35c29d$var$J(10), $d286e426fc35c29d$var$Ac(this), $d286e426fc35c29d$var$Rd(this));
};
function $d286e426fc35c29d$var$wc(a) {
    null != a.B && ($d286e426fc35c29d$var$l.clearTimeout(a.B), a.B = null);
}
function $d286e426fc35c29d$var$Rd(a) {
    a.g = new $d286e426fc35c29d$var$M(a, a.h, "rpc", a.Y);
    null === a.o && (a.g.H = a.s);
    a.g.O = 0;
    var b = $d286e426fc35c29d$var$N(a.oa);
    $d286e426fc35c29d$var$R(b, "RID", "rpc");
    $d286e426fc35c29d$var$R(b, "SID", a.J);
    $d286e426fc35c29d$var$R(b, "CI", a.N ? "0" : "1");
    $d286e426fc35c29d$var$R(b, "AID", a.U);
    $d286e426fc35c29d$var$Kd(a, b);
    $d286e426fc35c29d$var$R(b, "TYPE", "xmlhttp");
    a.o && a.s && $d286e426fc35c29d$var$Gd(b, a.o, a.s);
    a.K && a.g.setTimeout(a.K);
    var c = a.g;
    a = a.la;
    c.K = 1;
    c.v = $d286e426fc35c29d$var$jc($d286e426fc35c29d$var$N(b));
    c.s = null;
    c.U = !0;
    $d286e426fc35c29d$var$kc(c, a);
}
$d286e426fc35c29d$var$k.ab = function() {
    null != this.v && (this.v = null, $d286e426fc35c29d$var$Ac(this), $d286e426fc35c29d$var$Bc(this), $d286e426fc35c29d$var$J(19));
};
function $d286e426fc35c29d$var$zc(a) {
    null != a.v && ($d286e426fc35c29d$var$l.clearTimeout(a.v), a.v = null);
}
function $d286e426fc35c29d$var$uc(a, b) {
    var c = null;
    if (a.g == b) {
        $d286e426fc35c29d$var$zc(a);
        $d286e426fc35c29d$var$wc(a);
        a.g = null;
        var d = 2;
    } else if ($d286e426fc35c29d$var$yc(a.i, b)) c = b.D, $d286e426fc35c29d$var$Fc(a.i, b), d = 1;
    else return;
    a.I = b.N;
    if (0 != a.G) {
        if (b.i) {
            if (1 == d) {
                c = b.s ? b.s.length : 0;
                b = Date.now() - b.F;
                var e = a.C;
                d = $d286e426fc35c29d$var$Sb();
                $d286e426fc35c29d$var$D(d, new $d286e426fc35c29d$var$Vb(d, c, b, e));
                $d286e426fc35c29d$var$Hc(a);
            } else $d286e426fc35c29d$var$Gc(a);
        } else if (e = b.o, 3 == e || 0 == e && 0 < a.I || !(1 == d && $d286e426fc35c29d$var$Nd(a, b) || 2 == d && $d286e426fc35c29d$var$Bc(a))) switch(c && 0 < c.length && (b = a.i, b.i = b.i.concat(c)), e){
            case 1:
                $d286e426fc35c29d$var$Q(a, 5);
                break;
            case 4:
                $d286e426fc35c29d$var$Q(a, 10);
                break;
            case 3:
                $d286e426fc35c29d$var$Q(a, 6);
                break;
            default:
                $d286e426fc35c29d$var$Q(a, 2);
        }
    }
}
function $d286e426fc35c29d$var$Od(a, b) {
    let c = a.Pa + Math.floor(Math.random() * a.$a);
    a.j || (c *= 2);
    return c * b;
}
function $d286e426fc35c29d$var$Q(a, b) {
    a.h.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.j && (c = null);
        var d = $d286e426fc35c29d$var$q(a.jb, a);
        c || (c = new $d286e426fc35c29d$var$U("//www.google.com/images/cleardot.gif"), $d286e426fc35c29d$var$l.location && "http" == $d286e426fc35c29d$var$l.location.protocol || $d286e426fc35c29d$var$Oc(c, "https"), $d286e426fc35c29d$var$jc(c));
        $d286e426fc35c29d$var$nd(c.toString(), d);
    } else $d286e426fc35c29d$var$J(2);
    a.G = 0;
    a.j && a.j.va(b);
    $d286e426fc35c29d$var$Ld(a);
    $d286e426fc35c29d$var$Jd(a);
}
$d286e426fc35c29d$var$k.jb = function(a) {
    a ? (this.h.info("Successfully pinged google.com"), $d286e426fc35c29d$var$J(2)) : (this.h.info("Failed to ping google.com"), $d286e426fc35c29d$var$J(1));
};
function $d286e426fc35c29d$var$Ld(a) {
    a.G = 0;
    a.I = -1;
    if (a.j) {
        if (0 != $d286e426fc35c29d$var$jd(a.i).length || 0 != a.l.length) a.i.i.length = 0, $d286e426fc35c29d$var$ra(a.l), a.l.length = 0;
        a.j.ua();
    }
}
function $d286e426fc35c29d$var$Ec(a, b, c) {
    let d = $d286e426fc35c29d$var$ad(c);
    if ("" != d.i) b && $d286e426fc35c29d$var$Pc(d, b + "." + d.i), $d286e426fc35c29d$var$Qc(d, d.m);
    else {
        const e = $d286e426fc35c29d$var$l.location;
        d = $d286e426fc35c29d$var$bd(e.protocol, b ? b + "." + e.hostname : e.hostname, +e.port, c);
    }
    a.aa && $d286e426fc35c29d$var$xa(a.aa, function(e, f) {
        $d286e426fc35c29d$var$R(d, f, e);
    });
    b = a.D;
    c = a.sa;
    b && c && $d286e426fc35c29d$var$R(d, b, c);
    $d286e426fc35c29d$var$R(d, "VER", a.ma);
    $d286e426fc35c29d$var$Kd(a, d);
    return d;
}
function $d286e426fc35c29d$var$nc(a, b, c) {
    if (b && !a.H) throw Error("Can't create secondary domain capable XhrIo object.");
    b = c && a.Ba && !a.qa ? new $d286e426fc35c29d$var$X(new $d286e426fc35c29d$var$pd({
        ib: !0
    })) : new $d286e426fc35c29d$var$X(a.qa);
    b.L = a.H;
    return b;
}
function $d286e426fc35c29d$var$Sd() {}
$d286e426fc35c29d$var$k = $d286e426fc35c29d$var$Sd.prototype;
$d286e426fc35c29d$var$k.xa = function() {};
$d286e426fc35c29d$var$k.wa = function() {};
$d286e426fc35c29d$var$k.va = function() {};
$d286e426fc35c29d$var$k.ua = function() {};
$d286e426fc35c29d$var$k.Oa = function() {};
function $d286e426fc35c29d$var$Td() {
    if ($d286e426fc35c29d$var$y && !(10 <= Number($d286e426fc35c29d$var$Ua))) throw Error("Environmental error: no available transport.");
}
$d286e426fc35c29d$var$Td.prototype.g = function(a, b) {
    return new $d286e426fc35c29d$var$Y(a, b);
};
function $d286e426fc35c29d$var$Y(a, b) {
    $d286e426fc35c29d$var$C.call(this);
    this.g = new $d286e426fc35c29d$var$Id(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.g.s = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.ya && (a ? a["X-WebChannel-Client-Profile"] = b.ya : a = {
        "X-WebChannel-Client-Profile": b.ya
    });
    this.g.P = a;
    (a = b && b.httpHeadersOverwriteParam) && !$d286e426fc35c29d$var$sa(a) && (this.g.o = a);
    this.A = b && b.supportsCrossDomainXhr || !1;
    this.v = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$d286e426fc35c29d$var$sa(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new $d286e426fc35c29d$var$Z(this);
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Y, $d286e426fc35c29d$var$C);
$d286e426fc35c29d$var$Y.prototype.m = function() {
    this.g.j = this.j;
    this.A && (this.g.H = !0);
    var a = this.g, b = this.l, c = this.h || void 0;
    a.Wa && (a.h.info("Origin Trials enabled."), $d286e426fc35c29d$var$zb($d286e426fc35c29d$var$q(a.hb, a, b)));
    $d286e426fc35c29d$var$J(0);
    a.W = b;
    a.aa = c || {};
    a.N = a.X;
    a.F = $d286e426fc35c29d$var$Ec(a, null, a.W);
    $d286e426fc35c29d$var$Hc(a);
};
$d286e426fc35c29d$var$Y.prototype.close = function() {
    $d286e426fc35c29d$var$Ic(this.g);
};
$d286e426fc35c29d$var$Y.prototype.u = function(a) {
    if ("string" === typeof a) {
        var b = {};
        b.__data__ = a;
        $d286e426fc35c29d$var$Md(this.g, b);
    } else this.v ? (b = {}, b.__data__ = $d286e426fc35c29d$var$rb(a), $d286e426fc35c29d$var$Md(this.g, b)) : $d286e426fc35c29d$var$Md(this.g, a);
};
$d286e426fc35c29d$var$Y.prototype.M = function() {
    this.g.j = null;
    delete this.j;
    $d286e426fc35c29d$var$Ic(this.g);
    delete this.g;
    $d286e426fc35c29d$var$Y.Z.M.call(this);
};
function $d286e426fc35c29d$var$Ud(a) {
    $d286e426fc35c29d$var$ac.call(this);
    var b = a.__sm__;
    if (b) {
        a: {
            for(const c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
        this.data = b;
    } else this.data = a;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Ud, $d286e426fc35c29d$var$ac);
function $d286e426fc35c29d$var$Vd() {
    $d286e426fc35c29d$var$bc.call(this);
    this.status = 1;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Vd, $d286e426fc35c29d$var$bc);
function $d286e426fc35c29d$var$Z(a) {
    this.g = a;
}
$d286e426fc35c29d$var$t($d286e426fc35c29d$var$Z, $d286e426fc35c29d$var$Sd);
$d286e426fc35c29d$var$Z.prototype.xa = function() {
    $d286e426fc35c29d$var$D(this.g, "a");
};
$d286e426fc35c29d$var$Z.prototype.wa = function(a) {
    $d286e426fc35c29d$var$D(this.g, new $d286e426fc35c29d$var$Ud(a));
};
$d286e426fc35c29d$var$Z.prototype.va = function(a) {
    $d286e426fc35c29d$var$D(this.g, new $d286e426fc35c29d$var$Vd(a));
};
$d286e426fc35c29d$var$Z.prototype.ua = function() {
    $d286e426fc35c29d$var$D(this.g, "b");
}; /*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
$d286e426fc35c29d$var$Td.prototype.createWebChannel = $d286e426fc35c29d$var$Td.prototype.g;
$d286e426fc35c29d$var$Y.prototype.send = $d286e426fc35c29d$var$Y.prototype.u;
$d286e426fc35c29d$var$Y.prototype.open = $d286e426fc35c29d$var$Y.prototype.m;
$d286e426fc35c29d$var$Y.prototype.close = $d286e426fc35c29d$var$Y.prototype.close;
$d286e426fc35c29d$var$Wb.NO_ERROR = 0;
$d286e426fc35c29d$var$Wb.TIMEOUT = 8;
$d286e426fc35c29d$var$Wb.HTTP_ERROR = 6;
$d286e426fc35c29d$var$Xb.COMPLETE = "complete";
$d286e426fc35c29d$var$$b.EventType = $d286e426fc35c29d$var$L;
$d286e426fc35c29d$var$L.OPEN = "a";
$d286e426fc35c29d$var$L.CLOSE = "b";
$d286e426fc35c29d$var$L.ERROR = "c";
$d286e426fc35c29d$var$L.MESSAGE = "d";
$d286e426fc35c29d$var$C.prototype.listen = $d286e426fc35c29d$var$C.prototype.N;
$d286e426fc35c29d$var$X.prototype.listenOnce = $d286e426fc35c29d$var$X.prototype.O;
$d286e426fc35c29d$var$X.prototype.getLastError = $d286e426fc35c29d$var$X.prototype.La;
$d286e426fc35c29d$var$X.prototype.getLastErrorCode = $d286e426fc35c29d$var$X.prototype.Da;
$d286e426fc35c29d$var$X.prototype.getStatus = $d286e426fc35c29d$var$X.prototype.ba;
$d286e426fc35c29d$var$X.prototype.getResponseJson = $d286e426fc35c29d$var$X.prototype.Qa;
$d286e426fc35c29d$var$X.prototype.getResponseText = $d286e426fc35c29d$var$X.prototype.ga;
$d286e426fc35c29d$var$X.prototype.send = $d286e426fc35c29d$var$X.prototype.ea;
var $d286e426fc35c29d$export$66869136fc133c3a = $d286e426fc35c29d$export$2e2bcd8739ae039.createWebChannelTransport = function() {
    return new $d286e426fc35c29d$var$Td;
};
var $d286e426fc35c29d$export$888d0d9ab79d08fc = $d286e426fc35c29d$export$2e2bcd8739ae039.getStatEventTarget = function() {
    return $d286e426fc35c29d$var$Sb();
};
var $d286e426fc35c29d$export$d4e71bc0b80dc0fb = $d286e426fc35c29d$export$2e2bcd8739ae039.ErrorCode = $d286e426fc35c29d$var$Wb;
var $d286e426fc35c29d$export$3d7865934588d77e = $d286e426fc35c29d$export$2e2bcd8739ae039.EventType = $d286e426fc35c29d$var$Xb;
var $d286e426fc35c29d$export$d61e24a684f9e51 = $d286e426fc35c29d$export$2e2bcd8739ae039.Event = $d286e426fc35c29d$var$H;
var $d286e426fc35c29d$export$cbbc350c1dfc80cb = $d286e426fc35c29d$export$2e2bcd8739ae039.Stat = {
    rb: 0,
    ub: 1,
    vb: 2,
    Ob: 3,
    Tb: 4,
    Qb: 5,
    Rb: 6,
    Pb: 7,
    Nb: 8,
    Sb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Lb: 12,
    Hb: 13,
    Ib: 14,
    Gb: 15,
    Jb: 16,
    Kb: 17,
    nb: 18,
    mb: 19,
    ob: 20
};
var $d286e426fc35c29d$export$ddb1030448106742 = $d286e426fc35c29d$export$2e2bcd8739ae039.FetchXmlHttpFactory = $d286e426fc35c29d$var$pd;
var $d286e426fc35c29d$export$aa726fb96ad3e039 = $d286e426fc35c29d$export$2e2bcd8739ae039.WebChannel = $d286e426fc35c29d$var$$b;
var $d286e426fc35c29d$export$26404658cda3ee02 = $d286e426fc35c29d$export$2e2bcd8739ae039.XhrIo = $d286e426fc35c29d$var$X;



var $hPtJY = parcelRequire("hPtJY");
const $70fd6868680e912c$var$D = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $70fd6868680e912c$var$C {
    constructor(t){
        this.uid = t;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(t) {
        return t.uid === this.uid;
    }
}
/** A user with a null UID. */ $70fd6868680e912c$var$C.UNAUTHENTICATED = new $70fd6868680e912c$var$C(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$70fd6868680e912c$var$C.GOOGLE_CREDENTIALS = new $70fd6868680e912c$var$C("google-credentials-uid"), $70fd6868680e912c$var$C.FIRST_PARTY = new $70fd6868680e912c$var$C("first-party-uid"), $70fd6868680e912c$var$C.MOCK_USER = new $70fd6868680e912c$var$C("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $70fd6868680e912c$var$x = "9.8.3";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$N = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $70fd6868680e912c$var$k() {
    return $70fd6868680e912c$var$N.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $70fd6868680e912c$export$c622e99c0ce7b1c9(t) {
    $70fd6868680e912c$var$N.setLogLevel(t);
}
function $70fd6868680e912c$var$M(t, ...e) {
    if ($70fd6868680e912c$var$N.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) {
        const n = e.map($70fd6868680e912c$var$B);
        $70fd6868680e912c$var$N.debug(`Firestore (${$70fd6868680e912c$var$x}): ${t}`, ...n);
    }
}
function $70fd6868680e912c$var$F(t, ...e) {
    if ($70fd6868680e912c$var$N.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) {
        const n = e.map($70fd6868680e912c$var$B);
        $70fd6868680e912c$var$N.error(`Firestore (${$70fd6868680e912c$var$x}): ${t}`, ...n);
    }
}
/**
 * @internal
 */ function $70fd6868680e912c$export$86cd73f49cc6e0bb(t, ...e) {
    if ($70fd6868680e912c$var$N.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) {
        const n = e.map($70fd6868680e912c$var$B);
        $70fd6868680e912c$var$N.warn(`Firestore (${$70fd6868680e912c$var$x}): ${t}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $70fd6868680e912c$var$B(t) {
    if ("string" == typeof t) return t;
    try {
        return e = t, JSON.stringify(e);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ var e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $70fd6868680e912c$var$L(t = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const e = `FIRESTORE (${$70fd6868680e912c$var$x}) INTERNAL ASSERTION FAILED: ` + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $70fd6868680e912c$var$F(e), new Error(e);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $70fd6868680e912c$var$U(t, e) {
    t || $70fd6868680e912c$var$L();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $70fd6868680e912c$export$1d2b90eea9bba017(t, e) {
    t || $70fd6868680e912c$var$L();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $70fd6868680e912c$var$K(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$G = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $70fd6868680e912c$export$8fada0bf726bf278 extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ t, /**
     * A custom error description.
     */ e){
        super(t, e), this.code = t, this.message = e, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$j {
    constructor(){
        this.promise = new Promise((t, e)=>{
            this.resolve = t, this.reject = e;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$W {
    constructor(t, e){
        this.user = e, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${t}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(t, e) {
        // Fire with initial user.
        t.enqueueRetryable(()=>e($70fd6868680e912c$var$C.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $70fd6868680e912c$var$H {
    constructor(t){
        this.token = t, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(t, e) {
        this.changeListener = e, // Fire with initial user.
        t.enqueueRetryable(()=>e(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $70fd6868680e912c$var$J {
    constructor(t){
        this.t = t, /** Tracks the current User. */ this.currentUser = $70fd6868680e912c$var$C.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(t, e) {
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const s = (t)=>this.i !== n ? (n = this.i, e(t)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let i = new $70fd6868680e912c$var$j;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), i.resolve(), i = new $70fd6868680e912c$var$j, t.enqueueRetryable(()=>s(this.currentUser));
        };
        const r = ()=>{
            const e = i;
            t.enqueueRetryable(async ()=>{
                await e.promise, await s(this.currentUser);
            });
        }, o = (t)=>{
            $70fd6868680e912c$var$M("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = t, this.auth.addAuthTokenListener(this.o), r();
        };
        this.t.onInit((t)=>o(t)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const t = this.t.getImmediate({
                    optional: !0
                });
                t ? o(t) : // If auth is still not available, proceed with `null` user
                ($70fd6868680e912c$var$M("FirebaseAuthCredentialsProvider", "Auth not yet detected"), i.resolve(), i = new $70fd6868680e912c$var$j);
            }
        }, 0), r();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const t = this.i, e = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(e).then((e)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== t ? ($70fd6868680e912c$var$M("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : e ? ($70fd6868680e912c$var$U("string" == typeof e.accessToken), new $70fd6868680e912c$var$W(e.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.auth.removeAuthTokenListener(this.o);
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const t = this.auth && this.auth.getUid();
        return $70fd6868680e912c$var$U(null === t || "string" == typeof t), new $70fd6868680e912c$var$C(t);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $70fd6868680e912c$var$Y {
    constructor(t, e, n){
        this.type = "FirstParty", this.user = $70fd6868680e912c$var$C.FIRST_PARTY, this.headers = new Map, this.headers.set("X-Goog-AuthUser", e);
        const s = t.auth.getAuthHeaderValueForFirstParty([]);
        s && this.headers.set("Authorization", s), n && this.headers.set("X-Goog-Iam-Authorization-Token", n);
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $70fd6868680e912c$var$X {
    constructor(t, e, n){
        this.h = t, this.l = e, this.m = n;
    }
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$Y(this.h, this.l, this.m));
    }
    start(t, e) {
        // Fire with initial uid.
        t.enqueueRetryable(()=>e($70fd6868680e912c$var$C.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $70fd6868680e912c$var$Z {
    constructor(t){
        this.value = t, this.type = "AppCheck", this.headers = new Map, t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $70fd6868680e912c$var$tt {
    constructor(t){
        this.g = t, this.forceRefresh = !1, this.appCheck = null, this.p = null;
    }
    start(t, e) {
        const n = (t)=>{
            null != t.error && $70fd6868680e912c$var$M("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${t.error.message}`);
            const n = t.token !== this.p;
            return this.p = t.token, $70fd6868680e912c$var$M("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? e(t.token) : Promise.resolve();
        };
        this.o = (e)=>{
            t.enqueueRetryable(()=>n(e));
        };
        const s = (t)=>{
            $70fd6868680e912c$var$M("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = t, this.appCheck.addTokenListener(this.o);
        };
        this.g.onInit((t)=>s(t)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const t = this.g.getImmediate({
                    optional: !0
                });
                t ? s(t) : // If AppCheck is still not available, proceed without it.
                $70fd6868680e912c$var$M("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const t = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(t).then((t)=>t ? ($70fd6868680e912c$var$U("string" == typeof t.token), this.p = t.token, new $70fd6868680e912c$var$Z(t.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.appCheck.removeTokenListener(this.o);
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$Z(""));
    }
    invalidateToken() {}
    start(t, e) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $70fd6868680e912c$var$nt(t) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
    if (e && "function" == typeof e.getRandomValues) e.getRandomValues(n);
    else // Falls back to Math.random
    for(let e = 0; e < t; e++)n[e] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$st {
    static I() {
        // Alphanumeric characters
        const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const s = $70fd6868680e912c$var$nt(40);
            for(let i = 0; i < s.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && s[i] < e && (n += t.charAt(s[i] % t.length));
        }
        return n;
    }
}
function $70fd6868680e912c$var$it(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $70fd6868680e912c$var$rt(t, e, n) {
    return t.length === e.length && t.every((t, s)=>n(t, e[s]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $70fd6868680e912c$var$ot(t) {
    // Return the input string, with an additional NUL byte appended.
    return t + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $70fd6868680e912c$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ t, /**
     * The fractions of a second at nanosecond resolution.*
     */ e){
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(t) {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(t.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(t) {
        const e = Math.floor(t / 1e3), n = Math.floor(1e6 * (t - 1e3 * e));
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e, n);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(t) {
        return this.seconds === t.seconds ? $70fd6868680e912c$var$it(this.nanoseconds, t.nanoseconds) : $70fd6868680e912c$var$it(this.seconds, t.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexiographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexiographical ordering.
        const t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $70fd6868680e912c$var$ct {
    constructor(t){
        this.timestamp = t;
    }
    static fromTimestamp(t) {
        return new $70fd6868680e912c$var$ct(t);
    }
    static min() {
        return new $70fd6868680e912c$var$ct(new $70fd6868680e912c$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $70fd6868680e912c$var$ct(new $70fd6868680e912c$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(t) {
        return this.timestamp._compareTo(t.timestamp);
    }
    isEqual(t) {
        return this.timestamp.isEqual(t.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $70fd6868680e912c$var$at {
    constructor(t, e, n){
        void 0 === e ? e = 0 : e > t.length && $70fd6868680e912c$var$L(), void 0 === n ? n = t.length - e : n > t.length - e && $70fd6868680e912c$var$L(), this.segments = t, this.offset = e, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(t) {
        return 0 === $70fd6868680e912c$var$at.comparator(this, t);
    }
    child(t) {
        const e = this.segments.slice(this.offset, this.limit());
        return t instanceof $70fd6868680e912c$var$at ? t.forEach((t)=>{
            e.push(t);
        }) : e.push(t), this.construct(e);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(t) {
        return t = void 0 === t ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(t) {
        return this.segments[this.offset + t];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(t) {
        if (t.length < this.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    isImmediateParentOf(t) {
        if (this.length + 1 !== t.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    forEach(t) {
        for(let e = this.offset, n = this.limit(); e < n; e++)t(this.segments[e]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(t, e) {
        const n = Math.min(t.length, e.length);
        for(let s = 0; s < n; s++){
            const n = t.get(s), i = e.get(s);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $70fd6868680e912c$var$ht extends $70fd6868680e912c$var$at {
    construct(t, e, n) {
        return new $70fd6868680e912c$var$ht(t, e, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...t) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const e = [];
        for (const n of t){
            if (n.indexOf("//") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and traling slashed.
            e.push(...n.split("/").filter((t)=>t.length > 0));
        }
        return new $70fd6868680e912c$var$ht(e);
    }
    static emptyPath() {
        return new $70fd6868680e912c$var$ht([]);
    }
}
const $70fd6868680e912c$var$lt = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $70fd6868680e912c$export$b7871852b967eaf1 extends $70fd6868680e912c$var$at {
    construct(t, e, n) {
        return new $70fd6868680e912c$export$b7871852b967eaf1(t, e, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(t) {
        return $70fd6868680e912c$var$lt.test(t);
    }
    canonicalString() {
        return this.toArray().map((t)=>(t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $70fd6868680e912c$export$b7871852b967eaf1.isValidIdentifier(t) || (t = "`" + t + "`"), t)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(t) {
        const e = [];
        let n = "", s = 0;
        const i = ()=>{
            if (0 === n.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            e.push(n), n = "";
        };
        let r = !1;
        for(; s < t.length;){
            const e = t[s];
            if ("\\" === e) {
                if (s + 1 === t.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                const e = t[s + 1];
                if ("\\" !== e && "." !== e && "`" !== e) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                n += e, s += 2;
            } else "`" === e ? (r = !r, s++) : "." !== e || r ? (n += e, s++) : (i(), s++);
        }
        if (i(), r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
        return new $70fd6868680e912c$export$b7871852b967eaf1(e);
    }
    static emptyPath() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $70fd6868680e912c$export$afc2e57c475b7810 {
    constructor(t){
        this.path = t;
    }
    static fromPath(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ht.fromString(t));
    }
    static fromName(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ht.fromString(t).popFirst(5));
    }
    static empty() {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ht.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(t) {
        return null !== t && 0 === $70fd6868680e912c$var$ht.comparator(this.path, t.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(t, e) {
        return $70fd6868680e912c$var$ht.comparator(t.path, e.path);
    }
    static isDocumentKey(t) {
        return t.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ht(t.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $70fd6868680e912c$var$_t {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ t, /** The collection ID this index applies to. */ e, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ s){
        this.indexId = t, this.collectionGroup = e, this.fields = n, this.indexState = s;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $70fd6868680e912c$var$wt(t) {
    return t.fields.find((t)=>2 /* CONTAINS */  === t.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $70fd6868680e912c$var$mt(t) {
    return t.fields.filter((t)=>2 /* CONTAINS */  !== t.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ $70fd6868680e912c$var$_t.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $70fd6868680e912c$var$gt {
    constructor(/** The field path of the component. */ t, /** The fields sorting order. */ e){
        this.fieldPath = t, this.kind = e;
    }
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $70fd6868680e912c$var$yt {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ t, /** The the latest indexed read time, document and batch id. */ e){
        this.sequenceNumber = t, this.offset = e;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $70fd6868680e912c$var$yt(0, $70fd6868680e912c$var$Tt.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $70fd6868680e912c$var$pt(t, e) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = t.toTimestamp().seconds, s = t.toTimestamp().nanoseconds + 1, i = $70fd6868680e912c$var$ct.fromTimestamp(1e9 === s ? new $70fd6868680e912c$export$d9bcbd5e1ff81430(n + 1, 0) : new $70fd6868680e912c$export$d9bcbd5e1ff81430(n, s));
    return new $70fd6868680e912c$var$Tt(i, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e);
}
/** Creates a new offset based on the provided document. */ function $70fd6868680e912c$var$It(t) {
    return new $70fd6868680e912c$var$Tt(t.readTime, t.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $70fd6868680e912c$var$Tt {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ t, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ e, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = t, this.documentKey = e, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $70fd6868680e912c$var$Tt($70fd6868680e912c$var$ct.min(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $70fd6868680e912c$var$Tt($70fd6868680e912c$var$ct.max(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
}
function $70fd6868680e912c$var$Et(t, e) {
    let n = t.readTime.compareTo(e.readTime);
    return 0 !== n ? n : (n = $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey), 0 !== n ? n : $70fd6868680e912c$var$it(t.largestBatchId, e.largestBatchId));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(indexing): Remove this constant
const $70fd6868680e912c$var$At = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $70fd6868680e912c$var$Rt {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(t) {
        this.onCommittedListeners.push(t);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((t)=>t());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $70fd6868680e912c$var$bt(t) {
    if (t.code !== $70fd6868680e912c$var$G.FAILED_PRECONDITION || t.message !== $70fd6868680e912c$var$At) throw t;
    $70fd6868680e912c$var$M("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $70fd6868680e912c$var$Pt {
    constructor(t){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, t((t)=>{
            this.isDone = !0, this.result = t, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(t);
        }, (t)=>{
            this.isDone = !0, this.error = t, this.catchCallback && this.catchCallback(t);
        });
    }
    catch(t) {
        return this.next(void 0, t);
    }
    next(t, e) {
        return this.callbackAttached && $70fd6868680e912c$var$L(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(e, this.error) : this.wrapSuccess(t, this.result) : new $70fd6868680e912c$var$Pt((n, s)=>{
            this.nextCallback = (e)=>{
                this.wrapSuccess(t, e).next(n, s);
            }, this.catchCallback = (t)=>{
                this.wrapFailure(e, t).next(n, s);
            };
        });
    }
    toPromise() {
        return new Promise((t, e)=>{
            this.next(t, e);
        });
    }
    wrapUserFunction(t) {
        try {
            const e = t();
            return e instanceof $70fd6868680e912c$var$Pt ? e : $70fd6868680e912c$var$Pt.resolve(e);
        } catch (t) {
            return $70fd6868680e912c$var$Pt.reject(t);
        }
    }
    wrapSuccess(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $70fd6868680e912c$var$Pt.resolve(e);
    }
    wrapFailure(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $70fd6868680e912c$var$Pt.reject(e);
    }
    static resolve(t) {
        return new $70fd6868680e912c$var$Pt((e, n)=>{
            e(t);
        });
    }
    static reject(t) {
        return new $70fd6868680e912c$var$Pt((e, n)=>{
            n(t);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t) {
        return new $70fd6868680e912c$var$Pt((e, n)=>{
            let s = 0, i = 0, r = !1;
            t.forEach((t)=>{
                ++s, t.next(()=>{
                    ++i, r && i === s && e();
                }, (t)=>n(t));
            }), r = !0, i === s && e();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(t) {
        let e = $70fd6868680e912c$var$Pt.resolve(!1);
        for (const n of t)e = e.next((t)=>t ? $70fd6868680e912c$var$Pt.resolve(t) : n());
        return e;
    }
    static forEach(t, e) {
        const n = [];
        return t.forEach((t, s)=>{
            n.push(e.call(this, t, s));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(t, e) {
        return new $70fd6868680e912c$var$Pt((n, s)=>{
            const i = t.length, r = new Array(i);
            let o = 0;
            for(let u = 0; u < i; u++){
                const c = u;
                e(t[c]).next((t)=>{
                    r[c] = t, ++o, o === i && n(r);
                }, (t)=>s(t));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(t, e) {
        return new $70fd6868680e912c$var$Pt((n, s)=>{
            const i = ()=>{
                !0 === t() ? e().next(()=>{
                    i();
                }, s) : n();
            };
            i();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $70fd6868680e912c$var$vt {
    constructor(t, e){
        this.action = t, this.transaction = e, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.T = new $70fd6868680e912c$var$j, this.transaction.oncomplete = ()=>{
            this.T.resolve();
        }, this.transaction.onabort = ()=>{
            e.error ? this.T.reject(new $70fd6868680e912c$var$Dt(t, e.error)) : this.T.resolve();
        }, this.transaction.onerror = (e)=>{
            const n = $70fd6868680e912c$var$Ot(e.target.error);
            this.T.reject(new $70fd6868680e912c$var$Dt(t, n));
        };
    }
    static open(t, e, n, s) {
        try {
            return new $70fd6868680e912c$var$vt(e, t.transaction(s, n));
        } catch (t) {
            throw new $70fd6868680e912c$var$Dt(e, t);
        }
    }
    get A() {
        return this.T.promise;
    }
    abort(t) {
        t && this.T.reject(t), this.aborted || ($70fd6868680e912c$var$M("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    R() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = this.transaction;
        this.aborted || "function" != typeof t.commit || t.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(t) {
        const e = this.transaction.objectStore(t);
        return new $70fd6868680e912c$var$xt(e);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $70fd6868680e912c$var$Vt {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(t, e, n){
        this.name = t, this.version = e, this.P = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $70fd6868680e912c$var$Vt.v((0, $c38e0f42709c826a$export$c36915b22ce77c19)()) && $70fd6868680e912c$var$F("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ static delete(t) {
        return $70fd6868680e912c$var$M("SimpleDb", "Removing database:", t), $70fd6868680e912c$var$Nt(window.indexedDB.deleteDatabase(t)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static V() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return !1;
        if ($70fd6868680e912c$var$Vt.S()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const t = (0, $c38e0f42709c826a$export$c36915b22ce77c19)(), e = $70fd6868680e912c$var$Vt.v(t), n = 0 < e && e < 10, s = $70fd6868680e912c$var$Vt.D(t), i = 0 < s && s < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(t.indexOf("MSIE ") > 0 || t.indexOf("Trident/") > 0 || t.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static S() {
        var t;
        return "undefined" != typeof $hPtJY && "YES" === ((t = {}, void 0 === t) ? void 0 : t.C);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static N(t, e) {
        return t.store(e);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static v(t) {
        const e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ static D(t) {
        const e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async k(t) {
        return this.db || ($70fd6868680e912c$var$M("SimpleDb", "Opening database:", this.name), this.db = await new Promise((e, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const s = indexedDB.open(this.name, this.version);
            s.onsuccess = (t)=>{
                const n = t.target.result;
                e(n);
            }, s.onblocked = ()=>{
                n(new $70fd6868680e912c$var$Dt(t, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, s.onerror = (e)=>{
                const s = e.target.error;
                "VersionError" === s.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === s.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + s)) : n(new $70fd6868680e912c$var$Dt(t, s));
            }, s.onupgradeneeded = (t)=>{
                $70fd6868680e912c$var$M("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', t.oldVersion);
                const e = t.target.result;
                this.P.O(e, s.transaction, t.oldVersion, this.version).next(()=>{
                    $70fd6868680e912c$var$M("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.M && (this.db.onversionchange = (t)=>this.M(t)), this.db;
    }
    F(t) {
        this.M = t, this.db && (this.db.onversionchange = (e)=>t(e));
    }
    async runTransaction(t, e, n, s) {
        const i = "readonly" === e;
        let r = 0;
        for(;;){
            ++r;
            try {
                this.db = await this.k(t);
                const e = $70fd6868680e912c$var$vt.open(this.db, t, i ? "readonly" : "readwrite", n), r = s(e).next((t)=>(e.R(), t)).catch((t)=>// Abort the transaction if there was an error.
                    (e.abort(t), $70fd6868680e912c$var$Pt.reject(t))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return r.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await e.A, r;
            } catch (t) {
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                const e = "FirebaseError" !== t.name && r < 3;
                if ($70fd6868680e912c$var$M("SimpleDb", "Transaction failed with error:", t.message, "Retrying:", e), this.close(), !e) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $70fd6868680e912c$var$St {
    constructor(t){
        this.$ = t, this.B = !1, this.L = null;
    }
    get isDone() {
        return this.B;
    }
    get U() {
        return this.L;
    }
    set cursor(t) {
        this.$ = t;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.B = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ q(t) {
        this.L = t;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $70fd6868680e912c$var$Nt(this.$.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $70fd6868680e912c$var$Dt extends $70fd6868680e912c$export$8fada0bf726bf278 {
    constructor(t, e){
        super($70fd6868680e912c$var$G.UNAVAILABLE, `IndexedDB transaction '${t}' failed: ${e}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $70fd6868680e912c$var$Ct(t) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === t.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $70fd6868680e912c$var$xt {
    constructor(t){
        this.store = t;
    }
    put(t, e) {
        let n;
        return void 0 !== e ? ($70fd6868680e912c$var$M("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : ($70fd6868680e912c$var$M("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), $70fd6868680e912c$var$Nt(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(t) {
        $70fd6868680e912c$var$M("SimpleDb", "ADD", this.store.name, t, t);
        return $70fd6868680e912c$var$Nt(this.store.add(t));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(t) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $70fd6868680e912c$var$Nt(this.store.get(t)).next((e)=>// Normalize nonexistence to null.
            (void 0 === e && (e = null), $70fd6868680e912c$var$M("SimpleDb", "GET", this.store.name, t, e), e));
    }
    delete(t) {
        $70fd6868680e912c$var$M("SimpleDb", "DELETE", this.store.name, t);
        return $70fd6868680e912c$var$Nt(this.store.delete(t));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $70fd6868680e912c$var$M("SimpleDb", "COUNT", this.store.name);
        return $70fd6868680e912c$var$Nt(this.store.count());
    }
    K(t, e) {
        const n = this.options(t, e);
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster. Unfortunately, getAll() does not support custom indices.
        if (n.index || "function" != typeof this.store.getAll) {
            const t = this.cursor(n), e = [];
            return this.G(t, (t, n)=>{
                e.push(n);
            }).next(()=>e);
        }
        {
            const t = this.store.getAll(n.range);
            return new $70fd6868680e912c$var$Pt((e, n)=>{
                t.onerror = (t)=>{
                    n(t.target.error);
                }, t.onsuccess = (t)=>{
                    e(t.target.result);
                };
            });
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ j(t, e) {
        const n = this.store.getAll(t, null === e ? void 0 : e);
        return new $70fd6868680e912c$var$Pt((t, e)=>{
            n.onerror = (t)=>{
                e(t.target.error);
            }, n.onsuccess = (e)=>{
                t(e.target.result);
            };
        });
    }
    W(t, e) {
        $70fd6868680e912c$var$M("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(t, e);
        n.H = !1;
        const s = this.cursor(n);
        return this.G(s, (t, e, n)=>n.delete());
    }
    J(t, e) {
        let n;
        e ? n = t : (n = {}, e = t);
        const s = this.cursor(n);
        return this.G(s, e);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Y(t) {
        const e = this.cursor({});
        return new $70fd6868680e912c$var$Pt((n, s)=>{
            e.onerror = (t)=>{
                const e = $70fd6868680e912c$var$Ot(t.target.error);
                s(e);
            }, e.onsuccess = (e)=>{
                const s = e.target.result;
                s ? t(s.primaryKey, s.value).next((t)=>{
                    t ? s.continue() : n();
                }) : n();
            };
        });
    }
    G(t, e) {
        const n = [];
        return new $70fd6868680e912c$var$Pt((s, i)=>{
            t.onerror = (t)=>{
                i(t.target.error);
            }, t.onsuccess = (t)=>{
                const i = t.target.result;
                if (!i) return void s();
                const r = new $70fd6868680e912c$var$St(i), o = e(i.primaryKey, i.value, r);
                if (o instanceof $70fd6868680e912c$var$Pt) {
                    const t = o.catch((t)=>(r.done(), $70fd6868680e912c$var$Pt.reject(t)));
                    n.push(t);
                }
                r.isDone ? s() : null === r.U ? i.continue() : i.continue(r.U);
            };
        }).next(()=>$70fd6868680e912c$var$Pt.waitFor(n));
    }
    options(t, e) {
        let n;
        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
            index: n,
            range: e
        };
    }
    cursor(t) {
        let e = "next";
        if (t.reverse && (e = "prev"), t.index) {
            const n = this.store.index(t.index);
            return t.H ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
        }
        return this.store.openCursor(t.range, e);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $70fd6868680e912c$var$Nt(t) {
    return new $70fd6868680e912c$var$Pt((e, n)=>{
        t.onsuccess = (t)=>{
            const n = t.target.result;
            e(n);
        }, t.onerror = (t)=>{
            const e = $70fd6868680e912c$var$Ot(t.target.error);
            n(e);
        };
    });
}
// Guard so we only report the error once.
let $70fd6868680e912c$var$kt = !1;
function $70fd6868680e912c$var$Ot(t) {
    const e = $70fd6868680e912c$var$Vt.v((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
    if (e >= 12.2 && e < 13) {
        const e = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(e) >= 0) {
            // Wrap error in a more descriptive one.
            const t = new $70fd6868680e912c$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${e}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $70fd6868680e912c$var$kt || ($70fd6868680e912c$var$kt = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw t;
            }, 0)), t;
        }
    }
    return t;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $70fd6868680e912c$var$Mt {
    constructor(t, e){
        this.asyncQueue = t, this.X = e, this.task = null;
    }
    start() {}
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    Z(t) {
        $70fd6868680e912c$var$M("IndexBackiller", `Scheduled in ${t}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* IndexBackfill */ , t, async ()=>{
            this.task = null;
            try {
                $70fd6868680e912c$var$M("IndexBackiller", `Documents written: ${await this.X.tt()}`);
            } catch (t) {
                $70fd6868680e912c$var$Ct(t) ? $70fd6868680e912c$var$M("IndexBackiller", "Ignoring IndexedDB error during index backfill: ", t) : await $70fd6868680e912c$var$bt(t);
            }
            await this.Z(1);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $70fd6868680e912c$var$Ft {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ t, e){
        this.localStore = t, this.persistence = e;
    }
    async tt(t = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (e)=>this.et(e, t));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ et(t, e) {
        const n = new Set;
        let s = e, i = !0;
        return $70fd6868680e912c$var$Pt.doWhile(()=>!0 === i && s > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(t).next((e)=>{
                if (null !== e && !n.has(e)) return $70fd6868680e912c$var$M("IndexBackiller", `Processing collection: ${e}`), this.nt(t, e, s).next((t)=>{
                    s -= t, n.add(e);
                });
                i = !1;
            })).next(()=>e - s);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ nt(t, e, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(t, e).next((s)=>this.localStore.localDocuments.getNextDocuments(t, e, s, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(t, i).next(()=>this.st(s, n)).next((n)=>($70fd6868680e912c$var$M("IndexBackiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(t, e, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ st(t, e) {
        let n = t;
        return e.changes.forEach((t, e)=>{
            const s = $70fd6868680e912c$var$It(e);
            $70fd6868680e912c$var$Et(s, n) > 0 && (n = s);
        }), new $70fd6868680e912c$var$Tt(n.readTime, n.documentKey, Math.max(e.batchId, t.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $70fd6868680e912c$var$$t {
    constructor(t, e){
        this.previousValue = t, e && (e.sequenceNumberHandler = (t)=>this.it(t), this.rt = (t)=>e.writeSequenceNumber(t));
    }
    it(t) {
        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }
    next() {
        const t = ++this.previousValue;
        return this.rt && this.rt(t), t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$Bt(t) {
    let e = 0;
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e++;
    return e;
}
function $70fd6868680e912c$var$Lt(t, e) {
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
}
function $70fd6868680e912c$var$Ut(t) {
    for(const e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
$70fd6868680e912c$var$$t.ot = -1;
class $70fd6868680e912c$var$qt {
    constructor(t, e){
        this.comparator = t, this.root = e || $70fd6868680e912c$var$Gt.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(t, e) {
        return new $70fd6868680e912c$var$qt(this.comparator, this.root.insert(t, e, this.comparator).copy(null, null, $70fd6868680e912c$var$Gt.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(t) {
        return new $70fd6868680e912c$var$qt(this.comparator, this.root.remove(t, this.comparator).copy(null, null, $70fd6868680e912c$var$Gt.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(t) {
        let e = this.root;
        for(; !e.isEmpty();){
            const n = this.comparator(t, e.key);
            if (0 === n) return e.value;
            n < 0 ? e = e.left : n > 0 && (e = e.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(t) {
        // Number of nodes that were pruned when descending right
        let e = 0, n = this.root;
        for(; !n.isEmpty();){
            const s = this.comparator(t, n.key);
            if (0 === s) return e + n.left.size;
            s < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (e += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.root.inorderTraversal(t);
    }
    forEach(t) {
        this.inorderTraversal((e, n)=>(t(e, n), !1));
    }
    toString() {
        const t = [];
        return this.inorderTraversal((e, n)=>(t.push(`${e}:${n}`), !1)), `{${t.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.root.reverseTraversal(t);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $70fd6868680e912c$var$Kt(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(t) {
        return new $70fd6868680e912c$var$Kt(this.root, t, this.comparator, !1);
    }
    getReverseIterator() {
        return new $70fd6868680e912c$var$Kt(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(t) {
        return new $70fd6868680e912c$var$Kt(this.root, t, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $70fd6868680e912c$var$Kt {
    constructor(t, e, n, s){
        this.isReverse = s, this.nodeStack = [];
        let i = 1;
        for(; !t.isEmpty();)if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
        e && s && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.isReverse ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
        }
    }
    getNext() {
        let t = this.nodeStack.pop();
        const e = {
            key: t.key,
            value: t.value
        };
        if (this.isReverse) for(t = t.left; !t.isEmpty();)this.nodeStack.push(t), t = t.right;
        else for(t = t.right; !t.isEmpty();)this.nodeStack.push(t), t = t.left;
        return e;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const t = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $70fd6868680e912c$var$Gt {
    constructor(t, e, n, s, i){
        this.key = t, this.value = e, this.color = null != n ? n : $70fd6868680e912c$var$Gt.RED, this.left = null != s ? s : $70fd6868680e912c$var$Gt.EMPTY, this.right = null != i ? i : $70fd6868680e912c$var$Gt.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(t, e, n, s, i) {
        return new $70fd6868680e912c$var$Gt(null != t ? t : this.key, null != e ? e : this.value, null != n ? n : this.color, null != s ? s : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(t, e, n) {
        let s = this;
        const i = n(t, s.key);
        return s = i < 0 ? s.copy(null, null, null, s.left.insert(t, e, n), null) : 0 === i ? s.copy(null, e, null, null, null) : s.copy(null, null, null, null, s.right.insert(t, e, n)), s.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $70fd6868680e912c$var$Gt.EMPTY;
        let t = this;
        return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(t, e) {
        let n, s = this;
        if (e(t, s.key) < 0) s.left.isEmpty() || s.left.isRed() || s.left.left.isRed() || (s = s.moveRedLeft()), s = s.copy(null, null, null, s.left.remove(t, e), null);
        else {
            if (s.left.isRed() && (s = s.rotateRight()), s.right.isEmpty() || s.right.isRed() || s.right.left.isRed() || (s = s.moveRedRight()), 0 === e(t, s.key)) {
                if (s.right.isEmpty()) return $70fd6868680e912c$var$Gt.EMPTY;
                n = s.right.min(), s = s.copy(n.key, n.value, null, null, s.right.removeMin());
            }
            s = s.copy(null, null, null, null, s.right.remove(t, e));
        }
        return s.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let t = this;
        return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
    }
    moveRedLeft() {
        let t = this.colorFlip();
        return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
    }
    moveRedRight() {
        let t = this.colorFlip();
        return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
    }
    rotateLeft() {
        const t = this.copy(null, null, $70fd6868680e912c$var$Gt.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, t, null);
    }
    rotateRight() {
        const t = this.copy(null, null, $70fd6868680e912c$var$Gt.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, t);
    }
    colorFlip() {
        const t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, t, e);
    }
    // For testing.
    checkMaxDepth() {
        const t = this.check();
        return Math.pow(2, t) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $70fd6868680e912c$var$L();
        if (this.right.isRed()) throw $70fd6868680e912c$var$L();
        const t = this.left.check();
        if (t !== this.right.check()) throw $70fd6868680e912c$var$L();
        return t + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$70fd6868680e912c$var$Gt.EMPTY = null, $70fd6868680e912c$var$Gt.RED = !0, $70fd6868680e912c$var$Gt.BLACK = !1;
// end LLRBEmptyNode
$70fd6868680e912c$var$Gt.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $70fd6868680e912c$var$L();
    }
    get value() {
        throw $70fd6868680e912c$var$L();
    }
    get color() {
        throw $70fd6868680e912c$var$L();
    }
    get left() {
        throw $70fd6868680e912c$var$L();
    }
    get right() {
        throw $70fd6868680e912c$var$L();
    }
    // Returns a copy of the current node.
    copy(t, e, n, s, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(t, e, n) {
        return new $70fd6868680e912c$var$Gt(t, e);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(t, e) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(t) {
        return !1;
    }
    reverseTraversal(t) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $70fd6868680e912c$var$Qt {
    constructor(t){
        this.comparator = t, this.data = new $70fd6868680e912c$var$qt(this.comparator);
    }
    has(t) {
        return null !== this.data.get(t);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(t) {
        return this.data.indexOf(t);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(t) {
        this.data.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(t, e) {
        const n = this.data.getIteratorFrom(t[0]);
        for(; n.hasNext();){
            const s = n.getNext();
            if (this.comparator(s.key, t[1]) >= 0) return;
            e(s.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(t, e) {
        let n;
        for(n = void 0 !== e ? this.data.getIteratorFrom(e) : this.data.getIterator(); n.hasNext();){
            if (!t(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(t) {
        const e = this.data.getIteratorFrom(t);
        return e.hasNext() ? e.getNext().key : null;
    }
    getIterator() {
        return new $70fd6868680e912c$var$jt(this.data.getIterator());
    }
    getIteratorFrom(t) {
        return new $70fd6868680e912c$var$jt(this.data.getIteratorFrom(t));
    }
    /** Inserts or updates an element */ add(t) {
        return this.copy(this.data.remove(t).insert(t, !0));
    }
    /** Deletes an element */ delete(t) {
        return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(t) {
        let e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach((t)=>{
            e = e.add(t);
        }), e;
    }
    isEqual(t) {
        if (!(t instanceof $70fd6868680e912c$var$Qt)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.data.getIterator(), n = t.data.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (0 !== this.comparator(t, s)) return !1;
        }
        return !0;
    }
    toArray() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e);
        }), t;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>t.push(e)), "SortedSet(" + t.toString() + ")";
    }
    copy(t) {
        const e = new $70fd6868680e912c$var$Qt(this.comparator);
        return e.data = t, e;
    }
}
class $70fd6868680e912c$var$jt {
    constructor(t){
        this.iter = t;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $70fd6868680e912c$var$Wt(t) {
    return t.hasNext() ? t.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $70fd6868680e912c$var$zt {
    constructor(t){
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($70fd6868680e912c$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $70fd6868680e912c$var$zt([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(t) {
        let e = new $70fd6868680e912c$var$Qt($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (const t of this.fields)e = e.add(t);
        for (const n of t)e = e.add(n);
        return new $70fd6868680e912c$var$zt(e.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(t) {
        for (const e of this.fields)if (e.isPrefixOf(t)) return !0;
        return !1;
    }
    isEqual(t) {
        return $70fd6868680e912c$var$rt(this.fields, t.fields, (t, e)=>t.isEqual(e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $70fd6868680e912c$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $70fd6868680e912c$var$Jt {
    constructor(t){
        this.binaryString = t;
    }
    static fromBase64String(t) {
        const e = atob(t);
        return new $70fd6868680e912c$var$Jt(e);
    }
    static fromUint8Array(t) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const e = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function(t) {
            let e = "";
            for(let n = 0; n < t.length; ++n)e += String.fromCharCode(t[n]);
            return e;
        }(t);
        return new $70fd6868680e912c$var$Jt(e);
    }
    [Symbol.iterator]() {
        let t = 0;
        return {
            next: ()=>t < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(t++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        var t;
        return t = this.binaryString, btoa(t);
    }
    toUint8Array() {
        return function(t) {
            const e = new Uint8Array(t.length);
            for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
            return e;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(t) {
        return $70fd6868680e912c$var$it(this.binaryString, t.binaryString);
    }
    isEqual(t) {
        return this.binaryString === t.binaryString;
    }
}
$70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING = new $70fd6868680e912c$var$Jt("");
const $70fd6868680e912c$var$Yt = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $70fd6868680e912c$var$Xt(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($70fd6868680e912c$var$U(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let e = 0;
        const n = $70fd6868680e912c$var$Yt.exec(t);
        if ($70fd6868680e912c$var$U(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let t = n[1];
            t = (t + "000000000").substr(0, 9), e = Number(t);
        }
        // Parse the date to get the seconds.
        const s = new Date(t);
        return {
            seconds: Math.floor(s.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $70fd6868680e912c$var$Zt(t.seconds),
        nanos: $70fd6868680e912c$var$Zt(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $70fd6868680e912c$var$Zt(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $70fd6868680e912c$var$te(t) {
    return "string" == typeof t ? $70fd6868680e912c$var$Jt.fromBase64String(t) : $70fd6868680e912c$var$Jt.fromUint8Array(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $70fd6868680e912c$var$ee(t) {
    var e, n;
    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $70fd6868680e912c$var$ne(t) {
    const e = t.mapValue.fields.__previous_value__;
    return $70fd6868680e912c$var$ee(e) ? $70fd6868680e912c$var$ne(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $70fd6868680e912c$var$se(t) {
    const e = $70fd6868680e912c$var$Xt(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ie {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(t, e, n, s, i, r, o, u){
        this.databaseId = t, this.appId = e, this.persistenceKey = n, this.host = s, this.ssl = i, this.forceLongPolling = r, this.autoDetectLongPolling = o, this.useFetchStreams = u;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $70fd6868680e912c$export$4c3ccc07620ae30a {
    constructor(t, e){
        this.projectId = t, this.database = e || "(default)";
    }
    static empty() {
        return new $70fd6868680e912c$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$export$4c3ccc07620ae30a && t.projectId === this.projectId && t.database === this.database;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ /**
 * Returns whether a variable is either undefined or null.
 */ function $70fd6868680e912c$var$oe(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $70fd6868680e912c$var$ue(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $70fd6868680e912c$var$ce(t) {
    return "number" == typeof t && Number.isInteger(t) && !$70fd6868680e912c$var$ue(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$ae = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $70fd6868680e912c$var$he = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $70fd6868680e912c$var$le(t) {
    return "nullValue" in t ? 0 /* NullValue */  : "booleanValue" in t ? 1 /* BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* NumberValue */  : "timestampValue" in t ? 3 /* TimestampValue */  : "stringValue" in t ? 5 /* StringValue */  : "bytesValue" in t ? 6 /* BlobValue */  : "referenceValue" in t ? 7 /* RefValue */  : "geoPointValue" in t ? 8 /* GeoPointValue */  : "arrayValue" in t ? 9 /* ArrayValue */  : "mapValue" in t ? $70fd6868680e912c$var$ee(t) ? 4 /* ServerTimestampValue */  : $70fd6868680e912c$var$be(t) ? 9007199254740991 /* MaxValue */  : 10 /* ObjectValue */  : $70fd6868680e912c$var$L();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $70fd6868680e912c$var$fe(t, e) {
    if (t === e) return !0;
    const n = $70fd6868680e912c$var$le(t);
    if (n !== $70fd6868680e912c$var$le(e)) return !1;
    switch(n){
        case 0 /* NullValue */ :
        case 9007199254740991 /* MaxValue */ :
            return !0;
        case 1 /* BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* ServerTimestampValue */ :
            return $70fd6868680e912c$var$se(t).isEqual($70fd6868680e912c$var$se(e));
        case 3 /* TimestampValue */ :
            return function(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                const n = $70fd6868680e912c$var$Xt(t.timestampValue), s = $70fd6868680e912c$var$Xt(e.timestampValue);
                return n.seconds === s.seconds && n.nanos === s.nanos;
            }(t, e);
        case 5 /* StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* BlobValue */ :
            return function(t, e) {
                return $70fd6868680e912c$var$te(t.bytesValue).isEqual($70fd6868680e912c$var$te(e.bytesValue));
            }(t, e);
        case 7 /* RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                return $70fd6868680e912c$var$Zt(t.geoPointValue.latitude) === $70fd6868680e912c$var$Zt(e.geoPointValue.latitude) && $70fd6868680e912c$var$Zt(t.geoPointValue.longitude) === $70fd6868680e912c$var$Zt(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* NumberValue */ :
            return function(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $70fd6868680e912c$var$Zt(t.integerValue) === $70fd6868680e912c$var$Zt(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    const n = $70fd6868680e912c$var$Zt(t.doubleValue), s = $70fd6868680e912c$var$Zt(e.doubleValue);
                    return n === s ? $70fd6868680e912c$var$ue(n) === $70fd6868680e912c$var$ue(s) : isNaN(n) && isNaN(s);
                }
                return !1;
            }(t, e);
        case 9 /* ArrayValue */ :
            return $70fd6868680e912c$var$rt(t.arrayValue.values || [], e.arrayValue.values || [], $70fd6868680e912c$var$fe);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                const n = t.mapValue.fields || {}, s = e.mapValue.fields || {};
                if ($70fd6868680e912c$var$Bt(n) !== $70fd6868680e912c$var$Bt(s)) return !1;
                for(const t in n)if (n.hasOwnProperty(t) && (void 0 === s[t] || !$70fd6868680e912c$var$fe(n[t], s[t]))) return !1;
                return !0;
            }(t, e);
        default:
            return $70fd6868680e912c$var$L();
    }
}
function $70fd6868680e912c$var$de(t, e) {
    return void 0 !== (t.values || []).find((t)=>$70fd6868680e912c$var$fe(t, e));
}
function $70fd6868680e912c$var$_e(t, e) {
    if (t === e) return 0;
    const n = $70fd6868680e912c$var$le(t), s = $70fd6868680e912c$var$le(e);
    if (n !== s) return $70fd6868680e912c$var$it(n, s);
    switch(n){
        case 0 /* NullValue */ :
        case 9007199254740991 /* MaxValue */ :
            return 0;
        case 1 /* BooleanValue */ :
            return $70fd6868680e912c$var$it(t.booleanValue, e.booleanValue);
        case 2 /* NumberValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$Zt(t.integerValue || t.doubleValue), s = $70fd6868680e912c$var$Zt(e.integerValue || e.doubleValue);
                return n < s ? -1 : n > s ? 1 : n === s ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(s) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TimestampValue */ :
            return $70fd6868680e912c$var$we(t.timestampValue, e.timestampValue);
        case 4 /* ServerTimestampValue */ :
            return $70fd6868680e912c$var$we($70fd6868680e912c$var$se(t), $70fd6868680e912c$var$se(e));
        case 5 /* StringValue */ :
            return $70fd6868680e912c$var$it(t.stringValue, e.stringValue);
        case 6 /* BlobValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$te(t), s = $70fd6868680e912c$var$te(e);
                return n.compareTo(s);
            }(t.bytesValue, e.bytesValue);
        case 7 /* RefValue */ :
            return function(t, e) {
                const n = t.split("/"), s = e.split("/");
                for(let t = 0; t < n.length && t < s.length; t++){
                    const e = $70fd6868680e912c$var$it(n[t], s[t]);
                    if (0 !== e) return e;
                }
                return $70fd6868680e912c$var$it(n.length, s.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$it($70fd6868680e912c$var$Zt(t.latitude), $70fd6868680e912c$var$Zt(e.latitude));
                if (0 !== n) return n;
                return $70fd6868680e912c$var$it($70fd6868680e912c$var$Zt(t.longitude), $70fd6868680e912c$var$Zt(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* ArrayValue */ :
            return function(t, e) {
                const n = t.values || [], s = e.values || [];
                for(let t = 0; t < n.length && t < s.length; ++t){
                    const e = $70fd6868680e912c$var$_e(n[t], s[t]);
                    if (e) return e;
                }
                return $70fd6868680e912c$var$it(n.length, s.length);
            }(t.arrayValue, e.arrayValue);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                if (t === $70fd6868680e912c$var$ae.mapValue && e === $70fd6868680e912c$var$ae.mapValue) return 0;
                if (t === $70fd6868680e912c$var$ae.mapValue) return 1;
                if (e === $70fd6868680e912c$var$ae.mapValue) return -1;
                const n = t.fields || {}, s = Object.keys(n), i = e.fields || {}, r = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                s.sort(), r.sort();
                for(let t = 0; t < s.length && t < r.length; ++t){
                    const e = $70fd6868680e912c$var$it(s[t], r[t]);
                    if (0 !== e) return e;
                    const o = $70fd6868680e912c$var$_e(n[s[t]], i[r[t]]);
                    if (0 !== o) return o;
                }
                return $70fd6868680e912c$var$it(s.length, r.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $70fd6868680e912c$var$L();
    }
}
function $70fd6868680e912c$var$we(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $70fd6868680e912c$var$it(t, e);
    const n = $70fd6868680e912c$var$Xt(t), s = $70fd6868680e912c$var$Xt(e), i = $70fd6868680e912c$var$it(n.seconds, s.seconds);
    return 0 !== i ? i : $70fd6868680e912c$var$it(n.nanos, s.nanos);
}
function $70fd6868680e912c$var$me(t) {
    return $70fd6868680e912c$var$ge(t);
}
function $70fd6868680e912c$var$ge(t) {
    var e, n;
    return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function(t) {
        const e = $70fd6868680e912c$var$Xt(t);
        return `time(${e.seconds},${e.nanos})`;
    }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? $70fd6868680e912c$var$te(t.bytesValue).toBase64() : "referenceValue" in t ? (n = t.referenceValue, $70fd6868680e912c$export$afc2e57c475b7810.fromName(n).toString()) : "geoPointValue" in t ? `geo(${(e = t.geoPointValue).latitude},${e.longitude})` : "arrayValue" in t ? function(t) {
        let e = "[", n = !0;
        for (const s of t.values || [])n ? n = !1 : e += ",", e += $70fd6868680e912c$var$ge(s);
        return e + "]";
    }(t.arrayValue) : "mapValue" in t ? function(t) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const e = Object.keys(t.fields || {}).sort();
        let n = "{", s = !0;
        for (const i of e)s ? s = !1 : n += ",", n += `${i}:${$70fd6868680e912c$var$ge(t.fields[i])}`;
        return n + "}";
    }(t.mapValue) : $70fd6868680e912c$var$L();
}
function $70fd6868680e912c$var$ye(t, e) {
    return {
        referenceValue: `projects/${t.projectId}/databases/${t.database}/documents/${e.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $70fd6868680e912c$var$pe(t) {
    return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $70fd6868680e912c$var$Ie(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $70fd6868680e912c$var$Te(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $70fd6868680e912c$var$Ee(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $70fd6868680e912c$var$Ae(t) {
    return !!t && "mapValue" in t;
}
/** Creates a deep copy of `source`. */ function $70fd6868680e912c$var$Re(t) {
    if (t.geoPointValue) return {
        geoPointValue: Object.assign({}, t.geoPointValue)
    };
    if (t.timestampValue && "object" == typeof t.timestampValue) return {
        timestampValue: Object.assign({}, t.timestampValue)
    };
    if (t.mapValue) {
        const e = {
            mapValue: {
                fields: {}
            }
        };
        return $70fd6868680e912c$var$Lt(t.mapValue.fields, (t, n)=>e.mapValue.fields[t] = $70fd6868680e912c$var$Re(n)), e;
    }
    if (t.arrayValue) {
        const e = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (t.arrayValue.values || []).length; ++n)e.arrayValue.values[n] = $70fd6868680e912c$var$Re(t.arrayValue.values[n]);
        return e;
    }
    return Object.assign({}, t);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $70fd6868680e912c$var$be(t) {
    return "__max__" === (((t.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function $70fd6868680e912c$var$Pe(t) {
    return "nullValue" in t ? $70fd6868680e912c$var$he : "booleanValue" in t ? {
        booleanValue: !1
    } : "integerValue" in t || "doubleValue" in t ? {
        doubleValue: NaN
    } : "timestampValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in t ? {
        stringValue: ""
    } : "bytesValue" in t ? {
        bytesValue: ""
    } : "referenceValue" in t ? $70fd6868680e912c$var$ye($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "geoPointValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in t ? {
        arrayValue: {}
    } : "mapValue" in t ? {
        mapValue: {}
    } : $70fd6868680e912c$var$L();
}
/** Returns the largest value for the given value type (exclusive). */ function $70fd6868680e912c$var$ve(t) {
    return "nullValue" in t ? {
        booleanValue: !1
    } : "booleanValue" in t ? {
        doubleValue: NaN
    } : "integerValue" in t || "doubleValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in t ? {
        stringValue: ""
    } : "stringValue" in t ? {
        bytesValue: ""
    } : "bytesValue" in t ? $70fd6868680e912c$var$ye($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "referenceValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in t ? {
        arrayValue: {}
    } : "arrayValue" in t ? {
        mapValue: {}
    } : "mapValue" in t ? $70fd6868680e912c$var$ae : $70fd6868680e912c$var$L();
}
function $70fd6868680e912c$var$Ve(t, e) {
    const n = $70fd6868680e912c$var$_e(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? -1 : !t.inclusive && e.inclusive ? 1 : 0;
}
function $70fd6868680e912c$var$Se(t, e) {
    const n = $70fd6868680e912c$var$_e(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? 1 : !t.inclusive && e.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $70fd6868680e912c$var$De {
    constructor(t){
        this.value = t;
    }
    static empty() {
        return new $70fd6868680e912c$var$De({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(t) {
        if (t.isEmpty()) return this.value;
        {
            let e = this.value;
            for(let n = 0; n < t.length - 1; ++n)if (e = (e.mapValue.fields || {})[t.get(n)], !$70fd6868680e912c$var$Ae(e)) return null;
            return e = (e.mapValue.fields || {})[t.lastSegment()], e || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(t, e) {
        this.getFieldsMap(t.popLast())[t.lastSegment()] = $70fd6868680e912c$var$Re(e);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(t) {
        let e = $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(), n = {}, s = [];
        t.forEach((t, i)=>{
            if (!e.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const t = this.getFieldsMap(e);
                this.applyChanges(t, n, s), n = {}, s = [], e = i.popLast();
            }
            t ? n[i.lastSegment()] = $70fd6868680e912c$var$Re(t) : s.push(i.lastSegment());
        });
        const i = this.getFieldsMap(e);
        this.applyChanges(i, n, s);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(t) {
        const e = this.field(t.popLast());
        $70fd6868680e912c$var$Ae(e) && e.mapValue.fields && delete e.mapValue.fields[t.lastSegment()];
    }
    isEqual(t) {
        return $70fd6868680e912c$var$fe(this.value, t.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(t) {
        let e = this.value;
        e.mapValue.fields || (e.mapValue = {
            fields: {}
        });
        for(let n = 0; n < t.length; ++n){
            let s = e.mapValue.fields[t.get(n)];
            $70fd6868680e912c$var$Ae(s) && s.mapValue.fields || (s = {
                mapValue: {
                    fields: {}
                }
            }, e.mapValue.fields[t.get(n)] = s), e = s;
        }
        return e.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(t, e, n) {
        $70fd6868680e912c$var$Lt(e, (e, n)=>t[e] = n);
        for (const e of n)delete t[e];
    }
    clone() {
        return new $70fd6868680e912c$var$De($70fd6868680e912c$var$Re(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $70fd6868680e912c$var$Ce(t) {
    const e = [];
    return $70fd6868680e912c$var$Lt(t.fields, (t, n)=>{
        const s = new $70fd6868680e912c$export$b7871852b967eaf1([
            t
        ]);
        if ($70fd6868680e912c$var$Ae(n)) {
            const t = $70fd6868680e912c$var$Ce(n.mapValue).fields;
            if (0 === t.length) // Preserve the empty map by adding it to the FieldMask.
            e.push(s);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of t)e.push(s.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        e.push(s);
    }), new $70fd6868680e912c$var$zt(e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $70fd6868680e912c$var$xe {
    constructor(t, e, n, s, i, r){
        this.key = t, this.documentType = e, this.version = n, this.readTime = s, this.data = i, this.documentState = r;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(t) {
        return new $70fd6868680e912c$var$xe(t, 0 /* INVALID */ , $70fd6868680e912c$var$ct.min(), $70fd6868680e912c$var$ct.min(), $70fd6868680e912c$var$De.empty(), 0 /* SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(t, e, n) {
        return new $70fd6868680e912c$var$xe(t, 1 /* FOUND_DOCUMENT */ , e, $70fd6868680e912c$var$ct.min(), n, 0 /* SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(t, e) {
        return new $70fd6868680e912c$var$xe(t, 2 /* NO_DOCUMENT */ , e, $70fd6868680e912c$var$ct.min(), $70fd6868680e912c$var$De.empty(), 0 /* SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(t, e) {
        return new $70fd6868680e912c$var$xe(t, 3 /* UNKNOWN_DOCUMENT */ , e, $70fd6868680e912c$var$ct.min(), $70fd6868680e912c$var$De.empty(), 2 /* HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(t, e) {
        return this.version = t, this.documentType = 1 /* FOUND_DOCUMENT */ , this.data = e, this.documentState = 0 /* SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(t) {
        return this.version = t, this.documentType = 2 /* NO_DOCUMENT */ , this.data = $70fd6868680e912c$var$De.empty(), this.documentState = 0 /* SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(t) {
        return this.version = t, this.documentType = 3 /* UNKNOWN_DOCUMENT */ , this.data = $70fd6868680e912c$var$De.empty(), this.documentState = 2 /* HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* HAS_LOCAL_MUTATIONS */ , this.version = $70fd6868680e912c$var$ct.min(), this;
    }
    setReadTime(t) {
        return this.readTime = t, this;
    }
    get hasLocalMutations() {
        return 1 /* HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$xe && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
    }
    mutableCopy() {
        return new $70fd6868680e912c$var$xe(this.key, this.documentType, this.version, this.readTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $70fd6868680e912c$var$Ne {
    constructor(t, e = null, n = [], s = [], i = null, r = null, o = null){
        this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = s, this.limit = i, this.startAt = r, this.endAt = o, this.ut = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $70fd6868680e912c$var$ke(t, e = null, n = [], s = [], i = null, r = null, o = null) {
    return new $70fd6868680e912c$var$Ne(t, e, n, s, i, r, o);
}
function $70fd6868680e912c$var$Oe(t) {
    const e = $70fd6868680e912c$var$K(t);
    if (null === e.ut) {
        let t = e.path.canonicalString();
        null !== e.collectionGroup && (t += "|cg:" + e.collectionGroup), t += "|f:", t += e.filters.map((t)=>{
            var e;
            return (e = t).field.canonicalString() + e.op.toString() + $70fd6868680e912c$var$me(e.value);
        }).join(","), t += "|ob:", t += e.orderBy.map((t)=>(function(t) {
                // TODO(b/29183165): Make this collision robust.
                return t.field.canonicalString() + t.dir;
            })(t)).join(","), $70fd6868680e912c$var$oe(e.limit) || (t += "|l:", t += e.limit), e.startAt && (t += "|lb:", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((t)=>$70fd6868680e912c$var$me(t)).join(",")), e.endAt && (t += "|ub:", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((t)=>$70fd6868680e912c$var$me(t)).join(",")), e.ut = t;
    }
    return e.ut;
}
function $70fd6868680e912c$var$Me(t) {
    let e = t.path.canonicalString();
    return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), t.filters.length > 0 && (e += `, filters: [${t.filters.map((t)=>{
        var e;
        return `${(e = t).field.canonicalString()} ${e.op} ${$70fd6868680e912c$var$me(e.value)}`;
    /** Filter that matches on key fields (i.e. '__name__'). */ }).join(", ")}]`), $70fd6868680e912c$var$oe(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += `, orderBy: [${t.orderBy.map((t)=>(function(t) {
            return `${t.field.canonicalString()} (${t.dir})`;
        })(t)).join(", ")}]`), t.startAt && (e += ", startAt: ", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((t)=>$70fd6868680e912c$var$me(t)).join(",")), t.endAt && (e += ", endAt: ", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((t)=>$70fd6868680e912c$var$me(t)).join(",")), `Target(${e})`;
}
function $70fd6868680e912c$var$Fe(t, e) {
    if (t.limit !== e.limit) return !1;
    if (t.orderBy.length !== e.orderBy.length) return !1;
    for(let n = 0; n < t.orderBy.length; n++)if (!$70fd6868680e912c$var$Ze(t.orderBy[n], e.orderBy[n])) return !1;
    if (t.filters.length !== e.filters.length) return !1;
    for(let i = 0; i < t.filters.length; i++)if (n = t.filters[i], s = e.filters[i], n.op !== s.op || !n.field.isEqual(s.field) || !$70fd6868680e912c$var$fe(n.value, s.value)) return !1;
    var n, s;
    return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!$70fd6868680e912c$var$en(t.startAt, e.startAt) && $70fd6868680e912c$var$en(t.endAt, e.endAt);
}
function $70fd6868680e912c$var$$e(t) {
    return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
}
/** Returns the field filters that target the given field path. */ function $70fd6868680e912c$var$Be(t, e) {
    return t.filters.filter((t)=>t instanceof $70fd6868680e912c$var$qe && t.field.isEqual(e));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $70fd6868680e912c$var$Le(t, e, n) {
    let s = $70fd6868680e912c$var$he, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$Be(t, e)){
        let t = $70fd6868680e912c$var$he, e = !0;
        switch(n.op){
            case "<" /* LESS_THAN */ :
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                t = $70fd6868680e912c$var$Pe(n.value);
                break;
            case "==" /* EQUAL */ :
            case "in" /* IN */ :
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case ">" /* GREATER_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* NOT_EQUAL */ :
            case "not-in" /* NOT_IN */ :
                t = $70fd6868680e912c$var$he;
        }
        $70fd6868680e912c$var$Ve({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) < 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $70fd6868680e912c$var$Ve({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) < 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $70fd6868680e912c$var$Ue(t, e, n) {
    let s = $70fd6868680e912c$var$ae, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$Be(t, e)){
        let t = $70fd6868680e912c$var$ae, e = !0;
        switch(n.op){
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
            case ">" /* GREATER_THAN */ :
                t = $70fd6868680e912c$var$ve(n.value), e = !1;
                break;
            case "==" /* EQUAL */ :
            case "in" /* IN */ :
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case "<" /* LESS_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* NOT_EQUAL */ :
            case "not-in" /* NOT_IN */ :
                t = $70fd6868680e912c$var$ae;
        }
        $70fd6868680e912c$var$Se({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) > 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $70fd6868680e912c$var$Se({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) > 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ class $70fd6868680e912c$var$qe extends class {
} {
    constructor(t, e, n){
        super(), this.field = t, this.op = e, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e, n) {
        return t.isKeyField() ? "in" /* IN */  === e || "not-in" /* NOT_IN */  === e ? this.ct(t, e, n) : new $70fd6868680e912c$var$Ke(t, e, n) : "array-contains" /* ARRAY_CONTAINS */  === e ? new $70fd6868680e912c$var$We(t, n) : "in" /* IN */  === e ? new $70fd6868680e912c$var$ze(t, n) : "not-in" /* NOT_IN */  === e ? new $70fd6868680e912c$var$He(t, n) : "array-contains-any" /* ARRAY_CONTAINS_ANY */  === e ? new $70fd6868680e912c$var$Je(t, n) : new $70fd6868680e912c$var$qe(t, e, n);
    }
    static ct(t, e, n) {
        return "in" /* IN */  === e ? new $70fd6868680e912c$var$Ge(t, n) : new $70fd6868680e912c$var$Qe(t, n);
    }
    matches(t) {
        const e = t.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* NOT_EQUAL */  === this.op ? null !== e && this.at($70fd6868680e912c$var$_e(e, this.value)) : null !== e && $70fd6868680e912c$var$le(this.value) === $70fd6868680e912c$var$le(e) && this.at($70fd6868680e912c$var$_e(e, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    at(t) {
        switch(this.op){
            case "<" /* LESS_THAN */ :
                return t < 0;
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* EQUAL */ :
                return 0 === t;
            case "!=" /* NOT_EQUAL */ :
                return 0 !== t;
            case ">" /* GREATER_THAN */ :
                return t > 0;
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $70fd6868680e912c$var$L();
        }
    }
    ht() {
        return [
            "<" /* LESS_THAN */ ,
            "<=" /* LESS_THAN_OR_EQUAL */ ,
            ">" /* GREATER_THAN */ ,
            ">=" /* GREATER_THAN_OR_EQUAL */ ,
            "!=" /* NOT_EQUAL */ ,
            "not-in" /* NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
}
class $70fd6868680e912c$var$Ke extends $70fd6868680e912c$var$qe {
    constructor(t, e, n){
        super(t, e, n), this.key = $70fd6868680e912c$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(t) {
        const e = $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, this.key);
        return this.at(e);
    }
}
/** Filter that matches on key fields within an array. */ class $70fd6868680e912c$var$Ge extends $70fd6868680e912c$var$qe {
    constructor(t, e){
        super(t, "in" /* IN */ , e), this.keys = $70fd6868680e912c$var$je("in" /* IN */ , e);
    }
    matches(t) {
        return this.keys.some((e)=>e.isEqual(t.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $70fd6868680e912c$var$Qe extends $70fd6868680e912c$var$qe {
    constructor(t, e){
        super(t, "not-in" /* NOT_IN */ , e), this.keys = $70fd6868680e912c$var$je("not-in" /* NOT_IN */ , e);
    }
    matches(t) {
        return !this.keys.some((e)=>e.isEqual(t.key));
    }
}
function $70fd6868680e912c$var$je(t, e) {
    var n;
    return ((null === (n = e.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((t)=>$70fd6868680e912c$export$afc2e57c475b7810.fromName(t.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $70fd6868680e912c$var$We extends $70fd6868680e912c$var$qe {
    constructor(t, e){
        super(t, "array-contains" /* ARRAY_CONTAINS */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return $70fd6868680e912c$var$Ie(e) && $70fd6868680e912c$var$de(e.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $70fd6868680e912c$var$ze extends $70fd6868680e912c$var$qe {
    constructor(t, e){
        super(t, "in" /* IN */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return null !== e && $70fd6868680e912c$var$de(this.value.arrayValue, e);
    }
}
/** A Filter that implements the not-in operator. */ class $70fd6868680e912c$var$He extends $70fd6868680e912c$var$qe {
    constructor(t, e){
        super(t, "not-in" /* NOT_IN */ , e);
    }
    matches(t) {
        if ($70fd6868680e912c$var$de(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const e = t.data.field(this.field);
        return null !== e && !$70fd6868680e912c$var$de(this.value.arrayValue, e);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $70fd6868680e912c$var$Je extends $70fd6868680e912c$var$qe {
    constructor(t, e){
        super(t, "array-contains-any" /* ARRAY_CONTAINS_ANY */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return !(!$70fd6868680e912c$var$Ie(e) || !e.arrayValue.values) && e.arrayValue.values.some((t)=>$70fd6868680e912c$var$de(this.value.arrayValue, t));
    }
}
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $70fd6868680e912c$var$Ye {
    constructor(t, e){
        this.position = t, this.inclusive = e;
    }
}
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $70fd6868680e912c$var$Xe {
    constructor(t, e = "asc" /* ASCENDING */ ){
        this.field = t, this.dir = e;
    }
}
function $70fd6868680e912c$var$Ze(t, e) {
    return t.dir === e.dir && t.field.isEqual(e.field);
}
function $70fd6868680e912c$var$tn(t, e, n) {
    let s = 0;
    for(let i = 0; i < t.position.length; i++){
        const r = e[i], o = t.position[i];
        if (r.field.isKeyField()) s = $70fd6868680e912c$export$afc2e57c475b7810.comparator($70fd6868680e912c$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else s = $70fd6868680e912c$var$_e(o, n.data.field(r.field));
        if ("desc" /* DESCENDING */  === r.dir && (s *= -1), 0 !== s) break;
    }
    return s;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $70fd6868680e912c$var$en(t, e) {
    if (null === t) return null === e;
    if (null === e) return !1;
    if (t.inclusive !== e.inclusive || t.position.length !== e.position.length) return !1;
    for(let n = 0; n < t.position.length; n++){
        if (!$70fd6868680e912c$var$fe(t.position[n], e.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $70fd6868680e912c$var$nn {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(t, e = null, n = [], s = [], i = null, r = "F" /* First */ , o = null, u = null){
        this.path = t, this.collectionGroup = e, this.explicitOrderBy = n, this.filters = s, this.limit = i, this.limitType = r, this.startAt = o, this.endAt = u, this.lt = null, // The corresponding `Target` of this `Query` instance.
        this.ft = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $70fd6868680e912c$var$sn(t, e, n, s, i, r, o, u) {
    return new $70fd6868680e912c$var$nn(t, e, n, s, i, r, o, u);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $70fd6868680e912c$var$rn(t) {
    return new $70fd6868680e912c$var$nn(t);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $70fd6868680e912c$var$on(t) {
    return 0 === t.filters.length && null === t.limit && null == t.startAt && null == t.endAt && (0 === t.explicitOrderBy.length || 1 === t.explicitOrderBy.length && t.explicitOrderBy[0].field.isKeyField());
}
function $70fd6868680e912c$var$un(t) {
    return t.explicitOrderBy.length > 0 ? t.explicitOrderBy[0].field : null;
}
function $70fd6868680e912c$var$cn(t) {
    for (const e of t.filters)if (e.ht()) return e.field;
    return null;
}
/**
 * Checks if any of the provided Operators are included in the query and
 * returns the first one that is, or null if none are.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $70fd6868680e912c$var$an(t) {
    return null !== t.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */ function $70fd6868680e912c$var$hn(t) {
    const e = $70fd6868680e912c$var$K(t);
    if (null === e.lt) {
        e.lt = [];
        const t = $70fd6868680e912c$var$cn(e), n = $70fd6868680e912c$var$un(e);
        if (null !== t && null === n) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        t.isKeyField() || e.lt.push(new $70fd6868680e912c$var$Xe(t)), e.lt.push(new $70fd6868680e912c$var$Xe($70fd6868680e912c$export$b7871852b967eaf1.keyField(), "asc" /* ASCENDING */ ));
        else {
            let t = !1;
            for (const n of e.explicitOrderBy)e.lt.push(n), n.field.isKeyField() && (t = !0);
            if (!t) {
                // The order of the implicit key ordering always matches the last
                // explicit order by
                const t = e.explicitOrderBy.length > 0 ? e.explicitOrderBy[e.explicitOrderBy.length - 1].dir : "asc" /* ASCENDING */ ;
                e.lt.push(new $70fd6868680e912c$var$Xe($70fd6868680e912c$export$b7871852b967eaf1.keyField(), t));
            }
        }
    }
    return e.lt;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */ function $70fd6868680e912c$var$ln(t) {
    const e = $70fd6868680e912c$var$K(t);
    if (!e.ft) {
        if ("F" /* First */  === e.limitType) e.ft = $70fd6868680e912c$var$ke(e.path, e.collectionGroup, $70fd6868680e912c$var$hn(e), e.filters, e.limit, e.startAt, e.endAt);
        else {
            // Flip the orderBy directions since we want the last results
            const t = [];
            for (const n of $70fd6868680e912c$var$hn(e)){
                const e = "desc" /* DESCENDING */  === n.dir ? "asc" /* ASCENDING */  : "desc" /* DESCENDING */ ;
                t.push(new $70fd6868680e912c$var$Xe(n.field, e));
            }
            // We need to swap the cursors to match the now-flipped query ordering.
            const n = e.endAt ? new $70fd6868680e912c$var$Ye(e.endAt.position, e.endAt.inclusive) : null, s = e.startAt ? new $70fd6868680e912c$var$Ye(e.startAt.position, e.startAt.inclusive) : null;
            // Now return as a LimitType.First query.
            e.ft = $70fd6868680e912c$var$ke(e.path, e.collectionGroup, t, e.filters, e.limit, n, s);
        }
    }
    return e.ft;
}
function $70fd6868680e912c$var$fn(t, e, n) {
    return new $70fd6868680e912c$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
}
function $70fd6868680e912c$var$dn(t, e) {
    return $70fd6868680e912c$var$Fe($70fd6868680e912c$var$ln(t), $70fd6868680e912c$var$ln(e)) && t.limitType === e.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $70fd6868680e912c$var$_n(t) {
    return `${$70fd6868680e912c$var$Oe($70fd6868680e912c$var$ln(t))}|lt:${t.limitType}`;
}
function $70fd6868680e912c$var$wn(t) {
    return `Query(target=${$70fd6868680e912c$var$Me($70fd6868680e912c$var$ln(t))}; limitType=${t.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $70fd6868680e912c$var$mn(t, e) {
    return e.isFoundDocument() && function(t, e) {
        const n = e.key.path;
        return null !== t.collectionGroup ? e.key.hasCollectionId(t.collectionGroup) && t.path.isPrefixOf(n) : $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) ? t.path.isEqual(n) : t.path.isImmediateParentOf(n);
    }(t, e) && function(t, e) {
        for (const n of t.explicitOrderBy)// order by key always matches
        if (!n.field.isKeyField() && null === e.data.field(n.field)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        for (const n of t.filters)if (!n.matches(e)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        if (t.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function(t, e, n) {
            const s = $70fd6868680e912c$var$tn(t, e, n);
            return t.inclusive ? s <= 0 : s < 0;
        }(t.startAt, $70fd6868680e912c$var$hn(t), e)) return !1;
        if (t.endAt && !function(t, e, n) {
            const s = $70fd6868680e912c$var$tn(t, e, n);
            return t.inclusive ? s >= 0 : s > 0;
        }(t.endAt, $70fd6868680e912c$var$hn(t), e)) return !1;
        return !0;
    }(t, e);
}
function $70fd6868680e912c$var$gn(t) {
    return t.collectionGroup || (t.path.length % 2 == 1 ? t.path.lastSegment() : t.path.get(t.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $70fd6868680e912c$var$yn(t) {
    return (e, n)=>{
        let s = !1;
        for (const i of $70fd6868680e912c$var$hn(t)){
            const t = $70fd6868680e912c$var$pn(i, e, n);
            if (0 !== t) return t;
            s = s || i.field.isKeyField();
        }
        return 0;
    };
}
function $70fd6868680e912c$var$pn(t, e, n) {
    const s = t.field.isKeyField() ? $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, n.key) : function(t, e, n) {
        const s = e.data.field(t), i = n.data.field(t);
        return null !== s && null !== i ? $70fd6868680e912c$var$_e(s, i) : $70fd6868680e912c$var$L();
    }(t.field, e, n);
    switch(t.dir){
        case "asc" /* ASCENDING */ :
            return s;
        case "desc" /* DESCENDING */ :
            return -1 * s;
        default:
            return $70fd6868680e912c$var$L();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $70fd6868680e912c$var$In(t, e) {
    if (t.dt) {
        if (isNaN(e)) return {
            doubleValue: "NaN"
        };
        if (e === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (e === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $70fd6868680e912c$var$ue(e) ? "-0" : e
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $70fd6868680e912c$var$Tn(t) {
    return {
        integerValue: "" + t
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $70fd6868680e912c$var$En(t, e) {
    return $70fd6868680e912c$var$ce(e) ? $70fd6868680e912c$var$Tn(e) : $70fd6868680e912c$var$In(t, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $70fd6868680e912c$var$An {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $70fd6868680e912c$var$Rn(t, e, n) {
    return t instanceof $70fd6868680e912c$var$vn ? function(t, e) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: t.seconds,
                        nanos: t.nanoseconds
                    }
                }
            }
        };
        return e && (n.fields.__previous_value__ = e), {
            mapValue: n
        };
    }(n, e) : t instanceof $70fd6868680e912c$var$Vn ? $70fd6868680e912c$var$Sn(t, e) : t instanceof $70fd6868680e912c$var$Dn ? $70fd6868680e912c$var$Cn(t, e) : function(t, e) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $70fd6868680e912c$var$Pn(t, e), s = $70fd6868680e912c$var$Nn(n) + $70fd6868680e912c$var$Nn(t._t);
        return $70fd6868680e912c$var$pe(n) && $70fd6868680e912c$var$pe(t._t) ? $70fd6868680e912c$var$Tn(s) : $70fd6868680e912c$var$In(t.wt, s);
    }(t, e);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $70fd6868680e912c$var$bn(t, e, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return t instanceof $70fd6868680e912c$var$Vn ? $70fd6868680e912c$var$Sn(t, e) : t instanceof $70fd6868680e912c$var$Dn ? $70fd6868680e912c$var$Cn(t, e) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $70fd6868680e912c$var$Pn(t, e) {
    var n;
    return t instanceof $70fd6868680e912c$var$xn ? $70fd6868680e912c$var$pe(n = e) || function(t) {
        return !!t && "doubleValue" in t;
    }(n) ? e : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $70fd6868680e912c$var$vn extends $70fd6868680e912c$var$An {
}
/** Transforms an array value via a union operation. */ class $70fd6868680e912c$var$Vn extends $70fd6868680e912c$var$An {
    constructor(t){
        super(), this.elements = t;
    }
}
function $70fd6868680e912c$var$Sn(t, e) {
    const n = $70fd6868680e912c$var$kn(e);
    for (const e of t.elements)n.some((t)=>$70fd6868680e912c$var$fe(t, e)) || n.push(e);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $70fd6868680e912c$var$Dn extends $70fd6868680e912c$var$An {
    constructor(t){
        super(), this.elements = t;
    }
}
function $70fd6868680e912c$var$Cn(t, e) {
    let n = $70fd6868680e912c$var$kn(e);
    for (const e of t.elements)n = n.filter((t)=>!$70fd6868680e912c$var$fe(t, e));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $70fd6868680e912c$var$xn extends $70fd6868680e912c$var$An {
    constructor(t, e){
        super(), this.wt = t, this._t = e;
    }
}
function $70fd6868680e912c$var$Nn(t) {
    return $70fd6868680e912c$var$Zt(t.integerValue || t.doubleValue);
}
function $70fd6868680e912c$var$kn(t) {
    return $70fd6868680e912c$var$Ie(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $70fd6868680e912c$var$On {
    constructor(t, e){
        this.field = t, this.transform = e;
    }
}
function $70fd6868680e912c$var$Mn(t, e) {
    return t.field.isEqual(e.field) && function(t, e) {
        return t instanceof $70fd6868680e912c$var$Vn && e instanceof $70fd6868680e912c$var$Vn || t instanceof $70fd6868680e912c$var$Dn && e instanceof $70fd6868680e912c$var$Dn ? $70fd6868680e912c$var$rt(t.elements, e.elements, $70fd6868680e912c$var$fe) : t instanceof $70fd6868680e912c$var$xn && e instanceof $70fd6868680e912c$var$xn ? $70fd6868680e912c$var$fe(t._t, e._t) : t instanceof $70fd6868680e912c$var$vn && e instanceof $70fd6868680e912c$var$vn;
    }(t.transform, e.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $70fd6868680e912c$var$Fn {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ t, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ e){
        this.version = t, this.transformResults = e;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $70fd6868680e912c$var$$n {
    constructor(t, e){
        this.updateTime = t, this.exists = e;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $70fd6868680e912c$var$$n;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(t) {
        return new $70fd6868680e912c$var$$n(void 0, t);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(t) {
        return new $70fd6868680e912c$var$$n(t);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $70fd6868680e912c$var$Bn(t, e) {
    return void 0 !== t.updateTime ? e.isFoundDocument() && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $70fd6868680e912c$var$Ln {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $70fd6868680e912c$var$Un(t, e) {
    if (!t.hasLocalMutations || e && 0 === e.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === e) return t.isNoDocument() ? new $70fd6868680e912c$var$Yn(t.key, $70fd6868680e912c$var$$n.none()) : new $70fd6868680e912c$var$jn(t.key, t.data, $70fd6868680e912c$var$$n.none());
    {
        const n = t.data, s = $70fd6868680e912c$var$De.empty();
        let i = new $70fd6868680e912c$var$Qt($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (let t of e.fields)if (!i.has(t)) {
            let e = n.field(t);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === e && t.length > 1 && (t = t.popLast(), e = n.field(t)), null === e ? s.delete(t) : s.set(t, e), i = i.add(t);
        }
        return new $70fd6868680e912c$var$Wn(t.key, s, new $70fd6868680e912c$var$zt(i.toArray()), $70fd6868680e912c$var$$n.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $70fd6868680e912c$var$qn(t, e, n) {
    t instanceof $70fd6868680e912c$var$jn ? function(t, e, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const s = t.value.clone(), i = $70fd6868680e912c$var$Hn(t.fieldTransforms, e, n.transformResults);
        s.setAll(i), e.convertToFoundDocument(n.version, s).setHasCommittedMutations();
    }(t, e, n) : t instanceof $70fd6868680e912c$var$Wn ? function(t, e, n) {
        if (!$70fd6868680e912c$var$Bn(t.precondition, e)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void e.convertToUnknownDocument(n.version);
        const s = $70fd6868680e912c$var$Hn(t.fieldTransforms, e, n.transformResults), i = e.data;
        i.setAll($70fd6868680e912c$var$zn(t)), i.setAll(s), e.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(t, e, n) : function(t, e, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        e.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, e, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $70fd6868680e912c$var$Kn(t, e, n, s) {
    return t instanceof $70fd6868680e912c$var$jn ? function(t, e, n, s) {
        if (!$70fd6868680e912c$var$Bn(t.precondition, e)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = t.value.clone(), r = $70fd6868680e912c$var$Jn(t.fieldTransforms, s, e);
        return i.setAll(r), e.convertToFoundDocument(e.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(t, e, n, s) : t instanceof $70fd6868680e912c$var$Wn ? function(t, e, n, s) {
        if (!$70fd6868680e912c$var$Bn(t.precondition, e)) return n;
        const i = $70fd6868680e912c$var$Jn(t.fieldTransforms, s, e), r = e.data;
        if (r.setAll($70fd6868680e912c$var$zn(t)), r.setAll(i), e.convertToFoundDocument(e.version, r).setHasLocalMutations(), null === n) return null;
        return n.unionWith(t.fieldMask.fields).unionWith(t.fieldTransforms.map((t)=>t.field));
    }(t, e, n, s) : function(t, e, n) {
        if ($70fd6868680e912c$var$Bn(t.precondition, e)) return e.convertToNoDocument(e.version).setHasLocalMutations(), null;
        return n;
    }(t, e, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $70fd6868680e912c$var$Gn(t, e) {
    let n = null;
    for (const s of t.fieldTransforms){
        const t = e.data.field(s.field), i = $70fd6868680e912c$var$Pn(s.transform, t || null);
        null != i && (null === n && (n = $70fd6868680e912c$var$De.empty()), n.set(s.field, i));
    }
    return n || null;
}
function $70fd6868680e912c$var$Qn(t, e) {
    return t.type === e.type && !!t.key.isEqual(e.key) && !!t.precondition.isEqual(e.precondition) && !!function(t, e) {
        return void 0 === t && void 0 === e || !(!t || !e) && $70fd6868680e912c$var$rt(t, e, (t, e)=>$70fd6868680e912c$var$Mn(t, e));
    }(t.fieldTransforms, e.fieldTransforms) && (0 /* Set */  === t.type ? t.value.isEqual(e.value) : 1 /* Patch */  !== t.type || t.data.isEqual(e.data) && t.fieldMask.isEqual(e.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $70fd6868680e912c$var$jn extends $70fd6868680e912c$var$Ln {
    constructor(t, e, n, s = []){
        super(), this.key = t, this.value = e, this.precondition = n, this.fieldTransforms = s, this.type = 0 /* Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$Wn extends $70fd6868680e912c$var$Ln {
    constructor(t, e, n, s, i = []){
        super(), this.key = t, this.data = e, this.fieldMask = n, this.precondition = s, this.fieldTransforms = i, this.type = 1 /* Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $70fd6868680e912c$var$zn(t) {
    const e = new Map;
    return t.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const s = t.data.field(n);
            e.set(n, s);
        }
    }), e;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$Hn(t, e, n) {
    const s = new Map;
    $70fd6868680e912c$var$U(t.length === n.length);
    for(let i = 0; i < n.length; i++){
        const r = t[i], o = r.transform, u = e.data.field(r.field);
        s.set(r.field, $70fd6868680e912c$var$bn(o, u, n[i]));
    }
    return s;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$Jn(t, e, n) {
    const s = new Map;
    for (const i of t){
        const t = i.transform, r = n.data.field(i.field);
        s.set(i.field, $70fd6868680e912c$var$Rn(t, r, e));
    }
    return s;
}
/** A mutation that deletes the document at the given key. */ class $70fd6868680e912c$var$Yn extends $70fd6868680e912c$var$Ln {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 2 /* Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$Xn extends $70fd6868680e912c$var$Ln {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 3 /* Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Zn {
    // TODO(b/33078163): just use simplest form of existence filter for now
    constructor(t){
        this.count = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $70fd6868680e912c$var$ts, $70fd6868680e912c$var$es;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $70fd6868680e912c$var$ns(t) {
    switch(t){
        default:
            return $70fd6868680e912c$var$L();
        case $70fd6868680e912c$var$G.CANCELLED:
        case $70fd6868680e912c$var$G.UNKNOWN:
        case $70fd6868680e912c$var$G.DEADLINE_EXCEEDED:
        case $70fd6868680e912c$var$G.RESOURCE_EXHAUSTED:
        case $70fd6868680e912c$var$G.INTERNAL:
        case $70fd6868680e912c$var$G.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $70fd6868680e912c$var$G.UNAUTHENTICATED:
            return !1;
        case $70fd6868680e912c$var$G.INVALID_ARGUMENT:
        case $70fd6868680e912c$var$G.NOT_FOUND:
        case $70fd6868680e912c$var$G.ALREADY_EXISTS:
        case $70fd6868680e912c$var$G.PERMISSION_DENIED:
        case $70fd6868680e912c$var$G.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $70fd6868680e912c$var$G.ABORTED:
        case $70fd6868680e912c$var$G.OUT_OF_RANGE:
        case $70fd6868680e912c$var$G.UNIMPLEMENTED:
        case $70fd6868680e912c$var$G.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $70fd6868680e912c$var$ss(t) {
    if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $70fd6868680e912c$var$F("GRPC error has no .code"), $70fd6868680e912c$var$G.UNKNOWN;
    switch(t){
        case $70fd6868680e912c$var$ts.OK:
            return $70fd6868680e912c$var$G.OK;
        case $70fd6868680e912c$var$ts.CANCELLED:
            return $70fd6868680e912c$var$G.CANCELLED;
        case $70fd6868680e912c$var$ts.UNKNOWN:
            return $70fd6868680e912c$var$G.UNKNOWN;
        case $70fd6868680e912c$var$ts.DEADLINE_EXCEEDED:
            return $70fd6868680e912c$var$G.DEADLINE_EXCEEDED;
        case $70fd6868680e912c$var$ts.RESOURCE_EXHAUSTED:
            return $70fd6868680e912c$var$G.RESOURCE_EXHAUSTED;
        case $70fd6868680e912c$var$ts.INTERNAL:
            return $70fd6868680e912c$var$G.INTERNAL;
        case $70fd6868680e912c$var$ts.UNAVAILABLE:
            return $70fd6868680e912c$var$G.UNAVAILABLE;
        case $70fd6868680e912c$var$ts.UNAUTHENTICATED:
            return $70fd6868680e912c$var$G.UNAUTHENTICATED;
        case $70fd6868680e912c$var$ts.INVALID_ARGUMENT:
            return $70fd6868680e912c$var$G.INVALID_ARGUMENT;
        case $70fd6868680e912c$var$ts.NOT_FOUND:
            return $70fd6868680e912c$var$G.NOT_FOUND;
        case $70fd6868680e912c$var$ts.ALREADY_EXISTS:
            return $70fd6868680e912c$var$G.ALREADY_EXISTS;
        case $70fd6868680e912c$var$ts.PERMISSION_DENIED:
            return $70fd6868680e912c$var$G.PERMISSION_DENIED;
        case $70fd6868680e912c$var$ts.FAILED_PRECONDITION:
            return $70fd6868680e912c$var$G.FAILED_PRECONDITION;
        case $70fd6868680e912c$var$ts.ABORTED:
            return $70fd6868680e912c$var$G.ABORTED;
        case $70fd6868680e912c$var$ts.OUT_OF_RANGE:
            return $70fd6868680e912c$var$G.OUT_OF_RANGE;
        case $70fd6868680e912c$var$ts.UNIMPLEMENTED:
            return $70fd6868680e912c$var$G.UNIMPLEMENTED;
        case $70fd6868680e912c$var$ts.DATA_LOSS:
            return $70fd6868680e912c$var$G.DATA_LOSS;
        default:
            return $70fd6868680e912c$var$L();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($70fd6868680e912c$var$es = $70fd6868680e912c$var$ts || ($70fd6868680e912c$var$ts = {}))[$70fd6868680e912c$var$es.OK = 0] = "OK", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.CANCELLED = 1] = "CANCELLED", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.UNKNOWN = 2] = "UNKNOWN", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.NOT_FOUND = 5] = "NOT_FOUND", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.ABORTED = 10] = "ABORTED", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.INTERNAL = 13] = "INTERNAL", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.UNAVAILABLE = 14] = "UNAVAILABLE", $70fd6868680e912c$var$es[$70fd6868680e912c$var$es.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $70fd6868680e912c$var$is {
    constructor(t, e){
        this.mapKeyFn = t, this.equalsFn = e, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 !== n) {
            for (const [e, s] of n)if (this.equalsFn(e, t)) return s;
        }
    }
    has(t) {
        return void 0 !== this.get(t);
    }
    /** Put this key and value in the map. */ set(t, e) {
        const n = this.mapKeyFn(t), s = this.inner[n];
        if (void 0 === s) return this.inner[n] = [
            [
                t,
                e
            ]
        ], void this.innerSize++;
        for(let n = 0; n < s.length; n++)if (this.equalsFn(s[n][0], t)) // This is updating an existing entry and does not increase `innerSize`.
        return void (s[n] = [
            t,
            e
        ]);
        s.push([
            t,
            e
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 === n) return !1;
        for(let s = 0; s < n.length; s++)if (this.equalsFn(n[s][0], t)) return 1 === n.length ? delete this.inner[e] : n.splice(s, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(t) {
        $70fd6868680e912c$var$Lt(this.inner, (e, n)=>{
            for (const [e, s] of n)t(e, s);
        });
    }
    isEmpty() {
        return $70fd6868680e912c$var$Ut(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$rs = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$os() {
    return $70fd6868680e912c$var$rs;
}
const $70fd6868680e912c$var$us = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$cs(...t) {
    let e = $70fd6868680e912c$var$us;
    for (const n of t)e = e.insert(n.key, n);
    return e;
}
function $70fd6868680e912c$var$as(t) {
    let e = $70fd6868680e912c$var$us;
    return t.forEach((t, n)=>e = e.insert(t, n.overlayedDocument)), e;
}
function $70fd6868680e912c$var$hs() {
    return $70fd6868680e912c$var$fs();
}
function $70fd6868680e912c$var$ls() {
    return $70fd6868680e912c$var$fs();
}
function $70fd6868680e912c$var$fs() {
    return new $70fd6868680e912c$var$is((t)=>t.toString(), (t, e)=>t.isEqual(e));
}
const $70fd6868680e912c$var$ds = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
const $70fd6868680e912c$var$_s = new $70fd6868680e912c$var$Qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$ws(...t) {
    let e = $70fd6868680e912c$var$_s;
    for (const n of t)e = e.add(n);
    return e;
}
const $70fd6868680e912c$var$ms = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it);
function $70fd6868680e912c$var$gs() {
    return $70fd6868680e912c$var$ms;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $70fd6868680e912c$var$ys {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ t, /**
     * A map from target to changes to the target. See TargetChange.
     */ e, /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ s, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = t, this.targetChanges = e, this.targetMismatches = n, this.documentUpdates = s, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(t, e) {
        const n = new Map;
        return n.set(t, $70fd6868680e912c$var$ps.createSynthesizedTargetChangeForCurrentChange(t, e)), new $70fd6868680e912c$var$ys($70fd6868680e912c$var$ct.min(), n, $70fd6868680e912c$var$gs(), $70fd6868680e912c$var$os(), $70fd6868680e912c$var$ws());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $70fd6868680e912c$var$ps {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ t, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ e, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ s, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = t, this.current = e, this.addedDocuments = n, this.modifiedDocuments = s, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(t, e) {
        return new $70fd6868680e912c$var$ps($70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING, e, $70fd6868680e912c$var$ws(), $70fd6868680e912c$var$ws(), $70fd6868680e912c$var$ws());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $70fd6868680e912c$var$Is {
    constructor(/** The new document applies to all of these targets. */ t, /** The new document is removed from all of these targets. */ e, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ s){
        this.gt = t, this.removedTargetIds = e, this.key = n, this.yt = s;
    }
}
class $70fd6868680e912c$var$Ts {
    constructor(t, e){
        this.targetId = t, this.It = e;
    }
}
class $70fd6868680e912c$var$Es {
    constructor(/** What kind of change occurred to the watch target. */ t, /** The target IDs that were added/removed/set. */ e, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING, s = null){
        this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = s;
    }
}
/** Tracks the internal state of a Watch target. */ class $70fd6868680e912c$var$As {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.Tt = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Et = $70fd6868680e912c$var$Ps(), /** See public getters for explanations of these fields. */ this.At = $70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING, this.Rt = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.bt = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.Rt;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.At;
    }
    /** Whether this target has pending target adds or target removes. */ get Pt() {
        return 0 !== this.Tt;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get vt() {
        return this.bt;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Vt(t) {
        t.approximateByteSize() > 0 && (this.bt = !0, this.At = t);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ St() {
        let t = $70fd6868680e912c$var$ws(), e = $70fd6868680e912c$var$ws(), n = $70fd6868680e912c$var$ws();
        return this.Et.forEach((s, i)=>{
            switch(i){
                case 0 /* Added */ :
                    t = t.add(s);
                    break;
                case 2 /* Modified */ :
                    e = e.add(s);
                    break;
                case 1 /* Removed */ :
                    n = n.add(s);
                    break;
                default:
                    $70fd6868680e912c$var$L();
            }
        }), new $70fd6868680e912c$var$ps(this.At, this.Rt, t, e, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Dt() {
        this.bt = !1, this.Et = $70fd6868680e912c$var$Ps();
    }
    Ct(t, e) {
        this.bt = !0, this.Et = this.Et.insert(t, e);
    }
    xt(t) {
        this.bt = !0, this.Et = this.Et.remove(t);
    }
    Nt() {
        this.Tt += 1;
    }
    kt() {
        this.Tt -= 1;
    }
    Ot() {
        this.bt = !0, this.Rt = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $70fd6868680e912c$var$Rs {
    constructor(t){
        this.Mt = t, /** The internal state of all tracked targets. */ this.Ft = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.$t = $70fd6868680e912c$var$os(), /** A mapping of document keys to their set of target IDs. */ this.Bt = $70fd6868680e912c$var$bs(), /**
         * A list of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Lt = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ut(t) {
        for (const e of t.gt)t.yt && t.yt.isFoundDocument() ? this.qt(e, t.yt) : this.Kt(e, t.key, t.yt);
        for (const e of t.removedTargetIds)this.Kt(e, t.key, t.yt);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ Gt(t) {
        this.forEachTarget(t, (e)=>{
            const n = this.Qt(e);
            switch(t.state){
                case 0 /* NoChange */ :
                    this.jt(e) && n.Vt(t.resumeToken);
                    break;
                case 1 /* Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.kt(), n.Pt || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Dt(), n.Vt(t.resumeToken);
                    break;
                case 2 /* Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.kt(), n.Pt || this.removeTarget(e);
                    break;
                case 3 /* Current */ :
                    this.jt(e) && (n.Ot(), n.Vt(t.resumeToken));
                    break;
                case 4 /* Reset */ :
                    this.jt(e) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.Wt(e), n.Vt(t.resumeToken));
                    break;
                default:
                    $70fd6868680e912c$var$L();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(t, e) {
        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Ft.forEach((t, n)=>{
            this.jt(n) && e(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ zt(t) {
        const e = t.targetId, n = t.It.count, s = this.Ht(e);
        if (s) {
            const t = s.target;
            if ($70fd6868680e912c$var$$e(t)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const n = new $70fd6868680e912c$export$afc2e57c475b7810(t.path);
                    this.Kt(e, n, $70fd6868680e912c$var$xe.newNoDocument(n, $70fd6868680e912c$var$ct.min()));
                } else $70fd6868680e912c$var$U(1 === n);
            } else this.Jt(e) !== n && // Existence filter mismatch: We reset the mapping and raise a new
            // snapshot with `isFromCache:true`.
            (this.Wt(e), this.Lt = this.Lt.add(e));
        }
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Yt(t) {
        const e = new Map;
        this.Ft.forEach((n, s)=>{
            const i = this.Ht(s);
            if (i) {
                if (n.current && $70fd6868680e912c$var$$e(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const e = new $70fd6868680e912c$export$afc2e57c475b7810(i.target.path);
                    null !== this.$t.get(e) || this.Xt(s, e) || this.Kt(s, e, $70fd6868680e912c$var$xe.newNoDocument(e, t));
                }
                n.vt && (e.set(s, n.St()), n.Dt());
            }
        });
        let n = $70fd6868680e912c$var$ws();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Bt.forEach((t, e)=>{
            let s = !0;
            e.forEachWhile((t)=>{
                const e = this.Ht(t);
                return !e || 2 /* LimboResolution */  === e.purpose || (s = !1, !1);
            }), s && (n = n.add(t));
        }), this.$t.forEach((e, n)=>n.setReadTime(t));
        const s = new $70fd6868680e912c$var$ys(t, e, this.Lt, this.$t, n);
        return this.$t = $70fd6868680e912c$var$os(), this.Bt = $70fd6868680e912c$var$bs(), this.Lt = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it), s;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    qt(t, e) {
        if (!this.jt(t)) return;
        const n = this.Xt(t, e.key) ? 2 /* Modified */  : 0 /* Added */ ;
        this.Qt(t).Ct(e.key, n), this.$t = this.$t.insert(e.key, e), this.Bt = this.Bt.insert(e.key, this.Zt(e.key).add(t));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Kt(t, e, n) {
        if (!this.jt(t)) return;
        const s = this.Qt(t);
        this.Xt(t, e) ? s.Ct(e, 1 /* Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        s.xt(e), this.Bt = this.Bt.insert(e, this.Zt(e).delete(t)), n && (this.$t = this.$t.insert(e, n));
    }
    removeTarget(t) {
        this.Ft.delete(t);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ Jt(t) {
        const e = this.Qt(t).St();
        return this.Mt.getRemoteKeysForTarget(t).size + e.addedDocuments.size - e.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ Nt(t) {
        this.Qt(t).Nt();
    }
    Qt(t) {
        let e = this.Ft.get(t);
        return e || (e = new $70fd6868680e912c$var$As, this.Ft.set(t, e)), e;
    }
    Zt(t) {
        let e = this.Bt.get(t);
        return e || (e = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it), this.Bt = this.Bt.insert(t, e)), e;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ jt(t) {
        const e = null !== this.Ht(t);
        return e || $70fd6868680e912c$var$M("WatchChangeAggregator", "Detected inactive target", t), e;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ Ht(t) {
        const e = this.Ft.get(t);
        return e && e.Pt ? null : this.Mt.te(t);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ Wt(t) {
        this.Ft.set(t, new $70fd6868680e912c$var$As);
        this.Mt.getRemoteKeysForTarget(t).forEach((e)=>{
            this.Kt(t, e, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ Xt(t, e) {
        return this.Mt.getRemoteKeysForTarget(t).has(e);
    }
}
function $70fd6868680e912c$var$bs() {
    return new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
function $70fd6868680e912c$var$Ps() {
    return new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$vs = (()=>{
    const t = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return t;
})(), $70fd6868680e912c$var$Vs = (()=>{
    const t = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return t;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $70fd6868680e912c$var$Ss {
    constructor(t, e){
        this.databaseId = t, this.dt = e;
    }
}
/**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $70fd6868680e912c$var$Ds(t, e) {
    if (t.dt) return `${new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + e.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + e.seconds,
        nanos: e.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$Cs(t, e) {
    return t.dt ? e.toBase64() : e.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $70fd6868680e912c$var$xs(t, e) {
    return $70fd6868680e912c$var$Ds(t, e.toTimestamp());
}
function $70fd6868680e912c$var$Ns(t) {
    return $70fd6868680e912c$var$U(!!t), $70fd6868680e912c$var$ct.fromTimestamp(function(t) {
        const e = $70fd6868680e912c$var$Xt(t);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }(t));
}
function $70fd6868680e912c$var$ks(t, e) {
    return (function(t) {
        return new $70fd6868680e912c$var$ht([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    })(t).child("documents").child(e).canonicalString();
}
function $70fd6868680e912c$var$Os(t) {
    const e = $70fd6868680e912c$var$ht.fromString(t);
    return $70fd6868680e912c$var$U($70fd6868680e912c$var$ui(e)), e;
}
function $70fd6868680e912c$var$Ms(t, e) {
    return $70fd6868680e912c$var$ks(t.databaseId, e.path);
}
function $70fd6868680e912c$var$Fs(t, e) {
    const n = $70fd6868680e912c$var$Os(e);
    if (n.get(1) !== t.databaseId.projectId) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + t.databaseId.projectId);
    if (n.get(3) !== t.databaseId.database) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + t.databaseId.database);
    return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$Us(n));
}
function $70fd6868680e912c$var$$s(t, e) {
    return $70fd6868680e912c$var$ks(t.databaseId, e);
}
function $70fd6868680e912c$var$Bs(t) {
    const e = $70fd6868680e912c$var$Os(t);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === e.length ? $70fd6868680e912c$var$ht.emptyPath() : $70fd6868680e912c$var$Us(e);
}
function $70fd6868680e912c$var$Ls(t) {
    return new $70fd6868680e912c$var$ht([
        "projects",
        t.databaseId.projectId,
        "databases",
        t.databaseId.database
    ]).canonicalString();
}
function $70fd6868680e912c$var$Us(t) {
    return $70fd6868680e912c$var$U(t.length > 4 && "documents" === t.get(4)), t.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $70fd6868680e912c$var$qs(t, e, n) {
    return {
        name: $70fd6868680e912c$var$Ms(t, e),
        fields: n.value.mapValue.fields
    };
}
function $70fd6868680e912c$var$Ks(t, e, n) {
    const s = $70fd6868680e912c$var$Fs(t, e.name), i = $70fd6868680e912c$var$Ns(e.updateTime), r = new $70fd6868680e912c$var$De({
        mapValue: {
            fields: e.fields
        }
    }), o = $70fd6868680e912c$var$xe.newFoundDocument(s, i, r);
    return n && o.setHasCommittedMutations(), n ? o.setHasCommittedMutations() : o;
}
function $70fd6868680e912c$var$Gs(t, e) {
    return "found" in e ? function(t, e) {
        $70fd6868680e912c$var$U(!!e.found), e.found.name, e.found.updateTime;
        const n = $70fd6868680e912c$var$Fs(t, e.found.name), s = $70fd6868680e912c$var$Ns(e.found.updateTime), i = new $70fd6868680e912c$var$De({
            mapValue: {
                fields: e.found.fields
            }
        });
        return $70fd6868680e912c$var$xe.newFoundDocument(n, s, i);
    }(t, e) : "missing" in e ? function(t, e) {
        $70fd6868680e912c$var$U(!!e.missing), $70fd6868680e912c$var$U(!!e.readTime);
        const n = $70fd6868680e912c$var$Fs(t, e.missing), s = $70fd6868680e912c$var$Ns(e.readTime);
        return $70fd6868680e912c$var$xe.newNoDocument(n, s);
    }(t, e) : $70fd6868680e912c$var$L();
}
function $70fd6868680e912c$var$Qs(t, e) {
    let n;
    if ("targetChange" in e) {
        e.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const s = function(t) {
            return "NO_CHANGE" === t ? 0 /* NoChange */  : "ADD" === t ? 1 /* Added */  : "REMOVE" === t ? 2 /* Removed */  : "CURRENT" === t ? 3 /* Current */  : "RESET" === t ? 4 /* Reset */  : $70fd6868680e912c$var$L();
        }(e.targetChange.targetChangeType || "NO_CHANGE"), i = e.targetChange.targetIds || [], r = function(t, e) {
            return t.dt ? ($70fd6868680e912c$var$U(void 0 === e || "string" == typeof e), $70fd6868680e912c$var$Jt.fromBase64String(e || "")) : ($70fd6868680e912c$var$U(void 0 === e || e instanceof Uint8Array), $70fd6868680e912c$var$Jt.fromUint8Array(e || new Uint8Array));
        }(t, e.targetChange.resumeToken), o = e.targetChange.cause, u = o && function(t) {
            const e = void 0 === t.code ? $70fd6868680e912c$var$G.UNKNOWN : $70fd6868680e912c$var$ss(t.code);
            return new $70fd6868680e912c$export$8fada0bf726bf278(e, t.message || "");
        }(o);
        n = new $70fd6868680e912c$var$Es(s, i, r, u || null);
    } else if ("documentChange" in e) {
        e.documentChange;
        const s = e.documentChange;
        s.document, s.document.name, s.document.updateTime;
        const i = $70fd6868680e912c$var$Fs(t, s.document.name), r = $70fd6868680e912c$var$Ns(s.document.updateTime), o = new $70fd6868680e912c$var$De({
            mapValue: {
                fields: s.document.fields
            }
        }), u = $70fd6868680e912c$var$xe.newFoundDocument(i, r, o), c = s.targetIds || [], a = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$Is(c, a, u.key, u);
    } else if ("documentDelete" in e) {
        e.documentDelete;
        const s = e.documentDelete;
        s.document;
        const i = $70fd6868680e912c$var$Fs(t, s.document), r = s.readTime ? $70fd6868680e912c$var$Ns(s.readTime) : $70fd6868680e912c$var$ct.min(), o = $70fd6868680e912c$var$xe.newNoDocument(i, r), u = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$Is([], u, o.key, o);
    } else if ("documentRemove" in e) {
        e.documentRemove;
        const s = e.documentRemove;
        s.document;
        const i = $70fd6868680e912c$var$Fs(t, s.document), r = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$Is([], r, i, null);
    } else {
        if (!("filter" in e)) return $70fd6868680e912c$var$L();
        {
            e.filter;
            const t = e.filter;
            t.targetId;
            const s = t.count || 0, i = new $70fd6868680e912c$var$Zn(s), r = t.targetId;
            n = new $70fd6868680e912c$var$Ts(r, i);
        }
    }
    return n;
}
function $70fd6868680e912c$var$js(t, e) {
    let n;
    if (e instanceof $70fd6868680e912c$var$jn) n = {
        update: $70fd6868680e912c$var$qs(t, e.key, e.value)
    };
    else if (e instanceof $70fd6868680e912c$var$Yn) n = {
        delete: $70fd6868680e912c$var$Ms(t, e.key)
    };
    else if (e instanceof $70fd6868680e912c$var$Wn) n = {
        update: $70fd6868680e912c$var$qs(t, e.key, e.data),
        updateMask: $70fd6868680e912c$var$oi(e.fieldMask)
    };
    else {
        if (!(e instanceof $70fd6868680e912c$var$Xn)) return $70fd6868680e912c$var$L();
        n = {
            verify: $70fd6868680e912c$var$Ms(t, e.key)
        };
    }
    return e.fieldTransforms.length > 0 && (n.updateTransforms = e.fieldTransforms.map((t)=>(function(t, e) {
            const n = e.transform;
            if (n instanceof $70fd6868680e912c$var$vn) return {
                fieldPath: e.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $70fd6868680e912c$var$Vn) return {
                fieldPath: e.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$Dn) return {
                fieldPath: e.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$xn) return {
                fieldPath: e.field.canonicalString(),
                increment: n._t
            };
            throw $70fd6868680e912c$var$L();
        })(0, t))), e.precondition.isNone || (n.currentDocument = function(t, e) {
        return void 0 !== e.updateTime ? {
            updateTime: $70fd6868680e912c$var$xs(t, e.updateTime)
        } : void 0 !== e.exists ? {
            exists: e.exists
        } : $70fd6868680e912c$var$L();
    }(t, e.precondition)), n;
}
function $70fd6868680e912c$var$Ws(t, e) {
    const n = e.currentDocument ? function(t) {
        return void 0 !== t.updateTime ? $70fd6868680e912c$var$$n.updateTime($70fd6868680e912c$var$Ns(t.updateTime)) : void 0 !== t.exists ? $70fd6868680e912c$var$$n.exists(t.exists) : $70fd6868680e912c$var$$n.none();
    }(e.currentDocument) : $70fd6868680e912c$var$$n.none(), s = e.updateTransforms ? e.updateTransforms.map((e)=>(function(t, e) {
            let n = null;
            if ("setToServerValue" in e) $70fd6868680e912c$var$U("REQUEST_TIME" === e.setToServerValue), n = new $70fd6868680e912c$var$vn;
            else if ("appendMissingElements" in e) {
                const t = e.appendMissingElements.values || [];
                n = new $70fd6868680e912c$var$Vn(t);
            } else if ("removeAllFromArray" in e) {
                const t = e.removeAllFromArray.values || [];
                n = new $70fd6868680e912c$var$Dn(t);
            } else "increment" in e ? n = new $70fd6868680e912c$var$xn(t, e.increment) : $70fd6868680e912c$var$L();
            const s = $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
            return new $70fd6868680e912c$var$On(s, n);
        })(t, e)) : [];
    if (e.update) {
        e.update.name;
        const i = $70fd6868680e912c$var$Fs(t, e.update.name), r = new $70fd6868680e912c$var$De({
            mapValue: {
                fields: e.update.fields
            }
        });
        if (e.updateMask) {
            const t = function(t) {
                const e = t.fieldPaths || [];
                return new $70fd6868680e912c$var$zt(e.map((t)=>$70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t)));
            }(e.updateMask);
            return new $70fd6868680e912c$var$Wn(i, r, t, n, s);
        }
        return new $70fd6868680e912c$var$jn(i, r, n, s);
    }
    if (e.delete) {
        const s = $70fd6868680e912c$var$Fs(t, e.delete);
        return new $70fd6868680e912c$var$Yn(s, n);
    }
    if (e.verify) {
        const s = $70fd6868680e912c$var$Fs(t, e.verify);
        return new $70fd6868680e912c$var$Xn(s, n);
    }
    return $70fd6868680e912c$var$L();
}
function $70fd6868680e912c$var$zs(t, e) {
    return t && t.length > 0 ? ($70fd6868680e912c$var$U(void 0 !== e), t.map((t)=>(function(t, e) {
            // NOTE: Deletes don't have an updateTime.
            let n = t.updateTime ? $70fd6868680e912c$var$Ns(t.updateTime) : $70fd6868680e912c$var$Ns(e);
            return n.isEqual($70fd6868680e912c$var$ct.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $70fd6868680e912c$var$Ns(e)), new $70fd6868680e912c$var$Fn(n, t.transformResults || []);
        })(t, e))) : [];
}
function $70fd6868680e912c$var$Hs(t, e) {
    return {
        documents: [
            $70fd6868680e912c$var$$s(t, e.path)
        ]
    };
}
function $70fd6868680e912c$var$Js(t, e) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, s = e.path;
    null !== e.collectionGroup ? (n.parent = $70fd6868680e912c$var$$s(t, s), n.structuredQuery.from = [
        {
            collectionId: e.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $70fd6868680e912c$var$$s(t, s.popLast()), n.structuredQuery.from = [
        {
            collectionId: s.lastSegment()
        }
    ]);
    const i = function(t) {
        if (0 === t.length) return;
        const e = t.map((t)=>// visible for testing
            (function(t) {
                if ("==" /* EQUAL */  === t.op) {
                    if ($70fd6868680e912c$var$Ee(t.value)) return {
                        unaryFilter: {
                            field: $70fd6868680e912c$var$ni(t.field),
                            op: "IS_NAN"
                        }
                    };
                    if ($70fd6868680e912c$var$Te(t.value)) return {
                        unaryFilter: {
                            field: $70fd6868680e912c$var$ni(t.field),
                            op: "IS_NULL"
                        }
                    };
                } else if ("!=" /* NOT_EQUAL */  === t.op) {
                    if ($70fd6868680e912c$var$Ee(t.value)) return {
                        unaryFilter: {
                            field: $70fd6868680e912c$var$ni(t.field),
                            op: "IS_NOT_NAN"
                        }
                    };
                    if ($70fd6868680e912c$var$Te(t.value)) return {
                        unaryFilter: {
                            field: $70fd6868680e912c$var$ni(t.field),
                            op: "IS_NOT_NULL"
                        }
                    };
                }
                return {
                    fieldFilter: {
                        field: $70fd6868680e912c$var$ni(t.field),
                        op: $70fd6868680e912c$var$ei(t.op),
                        value: t.value
                    }
                };
            })(t));
        if (1 === e.length) return e[0];
        return {
            compositeFilter: {
                op: "AND",
                filters: e
            }
        };
    }(e.filters);
    i && (n.structuredQuery.where = i);
    const r = function(t) {
        if (0 === t.length) return;
        return t.map((t)=>// visible for testing
            (function(t) {
                return {
                    field: $70fd6868680e912c$var$ni(t.field),
                    direction: $70fd6868680e912c$var$ti(t.dir)
                };
            })(t));
    }(e.orderBy);
    r && (n.structuredQuery.orderBy = r);
    const o = function(t, e) {
        return t.dt || $70fd6868680e912c$var$oe(e) ? e : {
            value: e
        };
    }(t, e.limit);
    var u;
    return null !== o && (n.structuredQuery.limit = o), e.startAt && (n.structuredQuery.startAt = {
        before: (u = e.startAt).inclusive,
        values: u.position
    }), e.endAt && (n.structuredQuery.endAt = function(t) {
        return {
            before: !t.inclusive,
            values: t.position
        };
    }(e.endAt)), n;
}
function $70fd6868680e912c$var$Ys(t) {
    let e = $70fd6868680e912c$var$Bs(t.parent);
    const n = t.structuredQuery, s = n.from ? n.from.length : 0;
    let i = null;
    if (s > 0) {
        $70fd6868680e912c$var$U(1 === s);
        const t = n.from[0];
        t.allDescendants ? i = t.collectionId : e = e.child(t.collectionId);
    }
    let r = [];
    n.where && (r = $70fd6868680e912c$var$Zs(n.where));
    let o = [];
    n.orderBy && (o = n.orderBy.map((t)=>(function(t) {
            return new $70fd6868680e912c$var$Xe($70fd6868680e912c$var$si(t.field), // visible for testing
            function(t) {
                switch(t){
                    case "ASCENDING":
                        return "asc" /* ASCENDING */ ;
                    case "DESCENDING":
                        return "desc" /* DESCENDING */ ;
                    default:
                        return;
                }
            }(t.direction));
        })(t)));
    let u = null;
    n.limit && (u = function(t) {
        let e;
        return e = "object" == typeof t ? t.value : t, $70fd6868680e912c$var$oe(e) ? null : e;
    }(n.limit));
    let c = null;
    n.startAt && (c = function(t) {
        const e = !!t.before, n = t.values || [];
        return new $70fd6868680e912c$var$Ye(n, e);
    }(n.startAt));
    let a = null;
    return n.endAt && (a = function(t) {
        const e = !t.before, n = t.values || [];
        return new $70fd6868680e912c$var$Ye(n, e);
    }(n.endAt)), $70fd6868680e912c$var$sn(e, i, o, r, u, "F" /* First */ , c, a);
}
function $70fd6868680e912c$var$Xs(t, e) {
    const n = function(t, e) {
        switch(e){
            case 0 /* Listen */ :
                return null;
            case 1 /* ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case 2 /* LimboResolution */ :
                return "limbo-document";
            default:
                return $70fd6868680e912c$var$L();
        }
    }(0, e.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $70fd6868680e912c$var$Zs(t) {
    return t ? void 0 !== t.unaryFilter ? [
        $70fd6868680e912c$var$ri(t)
    ] : void 0 !== t.fieldFilter ? [
        $70fd6868680e912c$var$ii(t)
    ] : void 0 !== t.compositeFilter ? t.compositeFilter.filters.map((t)=>$70fd6868680e912c$var$Zs(t)).reduce((t, e)=>t.concat(e)) : $70fd6868680e912c$var$L() : [];
}
function $70fd6868680e912c$var$ti(t) {
    return $70fd6868680e912c$var$vs[t];
}
function $70fd6868680e912c$var$ei(t) {
    return $70fd6868680e912c$var$Vs[t];
}
function $70fd6868680e912c$var$ni(t) {
    return {
        fieldPath: t.canonicalString()
    };
}
function $70fd6868680e912c$var$si(t) {
    return $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
}
function $70fd6868680e912c$var$ii(t) {
    return $70fd6868680e912c$var$qe.create($70fd6868680e912c$var$si(t.fieldFilter.field), function(t) {
        switch(t){
            case "EQUAL":
                return "==" /* EQUAL */ ;
            case "NOT_EQUAL":
                return "!=" /* NOT_EQUAL */ ;
            case "GREATER_THAN":
                return ">" /* GREATER_THAN */ ;
            case "GREATER_THAN_OR_EQUAL":
                return ">=" /* GREATER_THAN_OR_EQUAL */ ;
            case "LESS_THAN":
                return "<" /* LESS_THAN */ ;
            case "LESS_THAN_OR_EQUAL":
                return "<=" /* LESS_THAN_OR_EQUAL */ ;
            case "ARRAY_CONTAINS":
                return "array-contains" /* ARRAY_CONTAINS */ ;
            case "IN":
                return "in" /* IN */ ;
            case "NOT_IN":
                return "not-in" /* NOT_IN */ ;
            case "ARRAY_CONTAINS_ANY":
                return "array-contains-any" /* ARRAY_CONTAINS_ANY */ ;
            default:
                return $70fd6868680e912c$var$L();
        }
    }(t.fieldFilter.op), t.fieldFilter.value);
}
function $70fd6868680e912c$var$ri(t) {
    switch(t.unaryFilter.op){
        case "IS_NAN":
            const e = $70fd6868680e912c$var$si(t.unaryFilter.field);
            return $70fd6868680e912c$var$qe.create(e, "==" /* EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NULL":
            const n = $70fd6868680e912c$var$si(t.unaryFilter.field);
            return $70fd6868680e912c$var$qe.create(n, "==" /* EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        case "IS_NOT_NAN":
            const s = $70fd6868680e912c$var$si(t.unaryFilter.field);
            return $70fd6868680e912c$var$qe.create(s, "!=" /* NOT_EQUAL */ , {
                doubleValue: NaN
            });
        case "IS_NOT_NULL":
            const i = $70fd6868680e912c$var$si(t.unaryFilter.field);
            return $70fd6868680e912c$var$qe.create(i, "!=" /* NOT_EQUAL */ , {
                nullValue: "NULL_VALUE"
            });
        default:
            return $70fd6868680e912c$var$L();
    }
}
function $70fd6868680e912c$var$oi(t) {
    const e = [];
    return t.fields.forEach((t)=>e.push(t.canonicalString())), {
        fieldPaths: e
    };
}
function $70fd6868680e912c$var$ui(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $70fd6868680e912c$var$ci(t) {
    let e = "";
    for(let n = 0; n < t.length; n++)e.length > 0 && (e = $70fd6868680e912c$var$hi(e)), e = $70fd6868680e912c$var$ai(t.get(n), e);
    return $70fd6868680e912c$var$hi(e);
}
/** Encodes a single segment of a resource path into the given result */ function $70fd6868680e912c$var$ai(t, e) {
    let n = e;
    const s = t.length;
    for(let e = 0; e < s; e++){
        const s = t.charAt(e);
        switch(s){
            case "\0":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += s;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $70fd6868680e912c$var$hi(t) {
    return t + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $70fd6868680e912c$var$li(t) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const e = t.length;
    if ($70fd6868680e912c$var$U(e >= 2), 2 === e) return $70fd6868680e912c$var$U("\x01" === t.charAt(0) && "\x01" === t.charAt(1)), $70fd6868680e912c$var$ht.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const n = e - 2, s = [];
    let i = "";
    for(let r = 0; r < e;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const e = t.indexOf("\x01", r);
        (e < 0 || e > n) && $70fd6868680e912c$var$L();
        switch(t.charAt(e + 1)){
            case "\x01":
                const n1 = t.substring(r, e);
                let o;
                0 === i.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = n1 : (i += n1, o = i, i = ""), s.push(o);
                break;
            case "\x10":
                i += t.substring(r, e), i += "\0";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                i += t.substring(r, e + 1);
                break;
            default:
                $70fd6868680e912c$var$L();
        }
        r = e + 2;
    }
    return new $70fd6868680e912c$var$ht(s);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$fi = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $70fd6868680e912c$var$di(t, e) {
    return [
        t,
        $70fd6868680e912c$var$ci(e)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $70fd6868680e912c$var$_i(t, e, n) {
    return [
        t,
        $70fd6868680e912c$var$ci(e),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $70fd6868680e912c$var$wi = {}, $70fd6868680e912c$var$mi = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $70fd6868680e912c$var$gi = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $70fd6868680e912c$var$yi = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $70fd6868680e912c$var$pi = [
    "canonicalId",
    "targetId"
], $70fd6868680e912c$var$Ii = [
    "targetId",
    "path"
], $70fd6868680e912c$var$Ti = [
    "path",
    "targetId"
], $70fd6868680e912c$var$Ei = [
    "collectionId",
    "parent"
], $70fd6868680e912c$var$Ai = [
    "indexId",
    "uid"
], $70fd6868680e912c$var$Ri = [
    "uid",
    "sequenceNumber"
], $70fd6868680e912c$var$bi = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $70fd6868680e912c$var$Pi = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $70fd6868680e912c$var$vi = [
    "userId",
    "collectionPath",
    "documentId"
], $70fd6868680e912c$var$Vi = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $70fd6868680e912c$var$Si = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $70fd6868680e912c$var$Di = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $70fd6868680e912c$var$Ci = [
    ...$70fd6868680e912c$var$Di,
    "documentOverlays"
], $70fd6868680e912c$var$xi = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $70fd6868680e912c$var$Ni = $70fd6868680e912c$var$xi, $70fd6868680e912c$var$ki = [
    ...$70fd6868680e912c$var$Ni,
    "indexConfiguration",
    "indexState",
    "indexEntries"
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Oi extends $70fd6868680e912c$var$Rt {
    constructor(t, e){
        super(), this.ee = t, this.currentSequenceNumber = e;
    }
}
function $70fd6868680e912c$var$Mi(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    return $70fd6868680e912c$var$Vt.N(n.ee, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $70fd6868680e912c$var$Fi {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(t, e, n, s){
        this.batchId = t, this.localWriteTime = e, this.baseMutations = n, this.mutations = s;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(t, e) {
        const n = e.mutationResults;
        for(let e = 0; e < this.mutations.length; e++){
            const s = this.mutations[e];
            if (s.key.isEqual(t.key)) $70fd6868680e912c$var$qn(s, t, n[e]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(t, e) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(t.key) && (e = $70fd6868680e912c$var$Kn(n, t, e, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(t.key) && (e = $70fd6868680e912c$var$Kn(n, t, e, this.localWriteTime));
        return e;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(t, e) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $70fd6868680e912c$var$ls();
        return this.mutations.forEach((s)=>{
            const i = t.get(s.key), r = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(r, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = e.has(s.key) ? null : o;
            const u = $70fd6868680e912c$var$Un(r, o);
            null !== u && n.set(s.key, u), r.isValidDocument() || r.convertToNoDocument($70fd6868680e912c$var$ct.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((t, e)=>t.add(e.key), $70fd6868680e912c$var$ws());
    }
    isEqual(t) {
        return this.batchId === t.batchId && $70fd6868680e912c$var$rt(this.mutations, t.mutations, (t, e)=>$70fd6868680e912c$var$Qn(t, e)) && $70fd6868680e912c$var$rt(this.baseMutations, t.baseMutations, (t, e)=>$70fd6868680e912c$var$Qn(t, e));
    }
}
/** The result of applying a mutation batch to the backend. */ class $70fd6868680e912c$var$$i {
    constructor(t, e, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ s){
        this.batch = t, this.commitVersion = e, this.mutationResults = n, this.docVersions = s;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(t, e, n) {
        $70fd6868680e912c$var$U(t.mutations.length === n.length);
        let s = $70fd6868680e912c$var$ds;
        const i = t.mutations;
        for(let t = 0; t < i.length; t++)s = s.insert(i[t].key, n[t].version);
        return new $70fd6868680e912c$var$$i(t, e, n, s);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $70fd6868680e912c$var$Bi {
    constructor(t, e){
        this.largestBatchId = t, this.mutation = e;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(t) {
        return null !== t && this.mutation === t.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $70fd6868680e912c$var$Li {
    constructor(/** The target being listened to. */ t, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ e, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ s, /** The latest snapshot version seen for this target. */ i = $70fd6868680e912c$var$ct.min(), r = $70fd6868680e912c$var$ct.min(), o = $70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING){
        this.target = t, this.targetId = e, this.purpose = n, this.sequenceNumber = s, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = r, this.resumeToken = o;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(t) {
        return new $70fd6868680e912c$var$Li(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(t, e) {
        return new $70fd6868680e912c$var$Li(this.target, this.targetId, this.purpose, this.sequenceNumber, e, this.lastLimboFreeSnapshotVersion, t);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(t) {
        return new $70fd6868680e912c$var$Li(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $70fd6868680e912c$var$Ui {
    constructor(t){
        this.ne = t;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $70fd6868680e912c$var$qi(t, e) {
    let n;
    if (e.document) n = $70fd6868680e912c$var$Ks(t.ne, e.document, !!e.hasCommittedMutations);
    else if (e.noDocument) {
        const t = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.noDocument.path), s = $70fd6868680e912c$var$ji(e.noDocument.readTime);
        n = $70fd6868680e912c$var$xe.newNoDocument(t, s), e.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!e.unknownDocument) return $70fd6868680e912c$var$L();
        {
            const t = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path), s = $70fd6868680e912c$var$ji(e.unknownDocument.version);
            n = $70fd6868680e912c$var$xe.newUnknownDocument(t, s);
        }
    }
    return e.readTime && n.setReadTime(function(t) {
        const e = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t[0], t[1]);
        return $70fd6868680e912c$var$ct.fromTimestamp(e);
    }(e.readTime)), n;
}
/** Encodes a document for storage locally. */ function $70fd6868680e912c$var$Ki(t, e) {
    const n = e.key, s = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $70fd6868680e912c$var$Gi(e.readTime),
        hasCommittedMutations: e.hasCommittedMutations
    };
    if (e.isFoundDocument()) s.document = function(t, e) {
        return {
            name: $70fd6868680e912c$var$Ms(t, e.key),
            fields: e.data.value.mapValue.fields,
            updateTime: $70fd6868680e912c$var$Ds(t, e.version.toTimestamp())
        };
    }(t.ne, e);
    else if (e.isNoDocument()) s.noDocument = {
        path: n.path.toArray(),
        readTime: $70fd6868680e912c$var$Qi(e.version)
    };
    else {
        if (!e.isUnknownDocument()) return $70fd6868680e912c$var$L();
        s.unknownDocument = {
            path: n.path.toArray(),
            version: $70fd6868680e912c$var$Qi(e.version)
        };
    }
    return s;
}
function $70fd6868680e912c$var$Gi(t) {
    const e = t.toTimestamp();
    return [
        e.seconds,
        e.nanoseconds
    ];
}
function $70fd6868680e912c$var$Qi(t) {
    const e = t.toTimestamp();
    return {
        seconds: e.seconds,
        nanoseconds: e.nanoseconds
    };
}
function $70fd6868680e912c$var$ji(t) {
    const e = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanoseconds);
    return $70fd6868680e912c$var$ct.fromTimestamp(e);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $70fd6868680e912c$var$Wi(t, e) {
    const n = (e.baseMutations || []).map((e)=>$70fd6868680e912c$var$Ws(t.ne, e));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let t = 0; t < e.mutations.length - 1; ++t){
        const n = e.mutations[t];
        if (t + 1 < e.mutations.length && void 0 !== e.mutations[t + 1].transform) {
            const s = e.mutations[t + 1];
            n.updateTransforms = s.transform.fieldTransforms, e.mutations.splice(t + 1, 1), ++t;
        }
    }
    const s = e.mutations.map((e)=>$70fd6868680e912c$var$Ws(t.ne, e)), i = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(e.localWriteTimeMs);
    return new $70fd6868680e912c$var$Fi(e.batchId, i, n, s);
}
/** Decodes a DbTarget into TargetData */ function $70fd6868680e912c$var$zi(t) {
    const e = $70fd6868680e912c$var$ji(t.readTime), n = void 0 !== t.lastLimboFreeSnapshotVersion ? $70fd6868680e912c$var$ji(t.lastLimboFreeSnapshotVersion) : $70fd6868680e912c$var$ct.min();
    let s;
    var i;
    return void 0 !== t.query.documents ? ($70fd6868680e912c$var$U(1 === (i = t.query).documents.length), s = $70fd6868680e912c$var$ln($70fd6868680e912c$var$rn($70fd6868680e912c$var$Bs(i.documents[0])))) : s = function(t) {
        return $70fd6868680e912c$var$ln($70fd6868680e912c$var$Ys(t));
    }(t.query), new $70fd6868680e912c$var$Li(s, t.targetId, 0 /* Listen */ , t.lastListenSequenceNumber, e, n, $70fd6868680e912c$var$Jt.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $70fd6868680e912c$var$Hi(t, e) {
    const n = $70fd6868680e912c$var$Qi(e.snapshotVersion), s = $70fd6868680e912c$var$Qi(e.lastLimboFreeSnapshotVersion);
    let i;
    i = $70fd6868680e912c$var$$e(e.target) ? $70fd6868680e912c$var$Hs(t.ne, e.target) : $70fd6868680e912c$var$Js(t.ne, e.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const r = e.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: e.targetId,
        canonicalId: $70fd6868680e912c$var$Oe(e.target),
        readTime: n,
        resumeToken: r,
        lastListenSequenceNumber: e.sequenceNumber,
        lastLimboFreeSnapshotVersion: s,
        query: i
    };
}
/**
 * A helper function for figuring out what kind of query has been stored.
 */ /**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $70fd6868680e912c$var$Ji(t) {
    const e = $70fd6868680e912c$var$Ys({
        parent: t.parent,
        structuredQuery: t.structuredQuery
    });
    return "LAST" === t.limitType ? $70fd6868680e912c$var$fn(e, e.limit, "L" /* Last */ ) : e;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $70fd6868680e912c$var$Yi(t, e) {
    return new $70fd6868680e912c$var$Bi(e.largestBatchId, $70fd6868680e912c$var$Ws(t.ne, e.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $70fd6868680e912c$var$Xi(t, e) {
    const n = e.path.lastSegment();
    return [
        t,
        $70fd6868680e912c$var$ci(e.path.popLast()),
        n
    ];
}
function $70fd6868680e912c$var$Zi(t, e, n, s) {
    return {
        indexId: t,
        uid: e.uid || "",
        sequenceNumber: n,
        readTime: $70fd6868680e912c$var$Qi(s.readTime),
        documentKey: $70fd6868680e912c$var$ci(s.documentKey.path),
        largestBatchId: s.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$tr {
    getBundleMetadata(t, e) {
        return $70fd6868680e912c$var$er(t).get(e).next((t)=>{
            if (t) return {
                id: (e = t).bundleId,
                createTime: $70fd6868680e912c$var$ji(e.createTime),
                version: e.version
            };
            /** Encodes a DbBundle to a BundleMetadata object. */ var e;
        /** Encodes a BundleMetadata to a DbBundle. */ });
    }
    saveBundleMetadata(t, e) {
        var n;
        return $70fd6868680e912c$var$er(t).put({
            bundleId: (n = e).id,
            createTime: $70fd6868680e912c$var$Qi($70fd6868680e912c$var$Ns(n.createTime)),
            version: n.version
        });
    /** Encodes a DbNamedQuery to a NamedQuery. */ }
    getNamedQuery(t, e) {
        return $70fd6868680e912c$var$nr(t).get(e).next((t)=>{
            if (t) return {
                name: (e = t).name,
                query: $70fd6868680e912c$var$Ji(e.bundledQuery),
                readTime: $70fd6868680e912c$var$ji(e.readTime)
            };
            var e;
        /** Encodes a NamedQuery from a bundle proto to a DbNamedQuery. */ });
    }
    saveNamedQuery(t, e) {
        return $70fd6868680e912c$var$nr(t).put(function(t) {
            return {
                name: t.name,
                readTime: $70fd6868680e912c$var$Qi($70fd6868680e912c$var$Ns(t.readTime)),
                bundledQuery: t.bundledQuery
            };
        }(e));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $70fd6868680e912c$var$er(t) {
    return $70fd6868680e912c$var$Mi(t, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $70fd6868680e912c$var$nr(t) {
    return $70fd6868680e912c$var$Mi(t, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $70fd6868680e912c$var$sr {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(t, e){
        this.wt = t, this.userId = e;
    }
    static se(t, e) {
        const n = e.uid || "";
        return new $70fd6868680e912c$var$sr(t, n);
    }
    getOverlay(t, e) {
        return $70fd6868680e912c$var$ir(t).get($70fd6868680e912c$var$Xi(this.userId, e)).next((t)=>t ? $70fd6868680e912c$var$Yi(this.wt, t) : null);
    }
    getOverlays(t, e) {
        const n = $70fd6868680e912c$var$hs();
        return $70fd6868680e912c$var$Pt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        const s = [];
        return n.forEach((n, i)=>{
            const r = new $70fd6868680e912c$var$Bi(e, i);
            s.push(this.ie(t, r));
        }), $70fd6868680e912c$var$Pt.waitFor(s);
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = new Set;
        // Get the set of unique collection paths.
        e.forEach((t)=>s.add($70fd6868680e912c$var$ci(t.getCollectionPath())));
        const i = [];
        return s.forEach((e)=>{
            const s = IDBKeyRange.bound([
                this.userId,
                e,
                n
            ], [
                this.userId,
                e,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($70fd6868680e912c$var$ir(t).W("collectionPathOverlayIndex", s));
        }), $70fd6868680e912c$var$Pt.waitFor(i);
    }
    getOverlaysForCollection(t, e, n) {
        const s = $70fd6868680e912c$var$hs(), i = $70fd6868680e912c$var$ci(e), r = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$ir(t).K("collectionPathOverlayIndex", r).next((t)=>{
            for (const e of t){
                const t = $70fd6868680e912c$var$Yi(this.wt, e);
                s.set(t.getKey(), t);
            }
            return s;
        });
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        const i = $70fd6868680e912c$var$hs();
        let r;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            e,
            n
        ], [
            this.userId,
            e,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$ir(t).J({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (t, e, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $70fd6868680e912c$var$Yi(this.wt, e);
            i.size() < s || o.largestBatchId === r ? (i.set(o.getKey(), o), r = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    ie(t, e) {
        return $70fd6868680e912c$var$ir(t).put(function(t, e, n) {
            const [s, i, r] = $70fd6868680e912c$var$Xi(e, n.mutation.key);
            return {
                userId: e,
                collectionPath: i,
                documentId: r,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $70fd6868680e912c$var$js(t.ne, n.mutation)
            };
        }(this.wt, this.userId, e));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $70fd6868680e912c$var$ir(t) {
    return $70fd6868680e912c$var$Mi(t, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $70fd6868680e912c$var$rr {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ re(t, e) {
        this.oe(t, e), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        e.ue();
    }
    oe(t, e) {
        if ("nullValue" in t) this.ce(e, 5);
        else if ("booleanValue" in t) this.ce(e, 10), e.ae(t.booleanValue ? 1 : 0);
        else if ("integerValue" in t) this.ce(e, 15), e.ae($70fd6868680e912c$var$Zt(t.integerValue));
        else if ("doubleValue" in t) {
            const n = $70fd6868680e912c$var$Zt(t.doubleValue);
            isNaN(n) ? this.ce(e, 13) : (this.ce(e, 15), $70fd6868680e912c$var$ue(n) ? // -0.0, 0 and 0.0 are all considered the same
            e.ae(0) : e.ae(n));
        } else if ("timestampValue" in t) {
            const n = t.timestampValue;
            this.ce(e, 20), "string" == typeof n ? e.he(n) : (e.he(`${n.seconds || ""}`), e.ae(n.nanos || 0));
        } else if ("stringValue" in t) this.le(t.stringValue, e), this.fe(e);
        else if ("bytesValue" in t) this.ce(e, 30), e.de($70fd6868680e912c$var$te(t.bytesValue)), this.fe(e);
        else if ("referenceValue" in t) this._e(t.referenceValue, e);
        else if ("geoPointValue" in t) {
            const n = t.geoPointValue;
            this.ce(e, 45), e.ae(n.latitude || 0), e.ae(n.longitude || 0);
        } else "mapValue" in t ? $70fd6868680e912c$var$be(t) ? this.ce(e, Number.MAX_SAFE_INTEGER) : (this.we(t.mapValue, e), this.fe(e)) : "arrayValue" in t ? (this.me(t.arrayValue, e), this.fe(e)) : $70fd6868680e912c$var$L();
    }
    le(t, e) {
        this.ce(e, 25), this.ge(t, e);
    }
    ge(t, e) {
        e.he(t);
    }
    we(t, e) {
        const n = t.fields || {};
        this.ce(e, 55);
        for (const t of Object.keys(n))this.le(t, e), this.oe(n[t], e);
    }
    me(t, e) {
        const n = t.values || [];
        this.ce(e, 50);
        for (const t of n)this.oe(t, e);
    }
    _e(t, e) {
        this.ce(e, 37);
        $70fd6868680e912c$export$afc2e57c475b7810.fromName(t).path.forEach((t)=>{
            this.ce(e, 60), this.ge(t, e);
        });
    }
    ce(t, e) {
        t.ae(e);
    }
    fe(t) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        t.ae(2);
    }
}
$70fd6868680e912c$var$rr.ye = new $70fd6868680e912c$var$rr;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$or(t) {
    if (0 === t) return 8;
    let e = 0;
    return t >> 4 == 0 && // Test if the first four bits are zero.
    (e += 4, t <<= 4), t >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (e += 2, t <<= 2), t >> 7 == 0 && // Test if the remaining bit is zero.
    (e += 1), e;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $70fd6868680e912c$var$ur(t) {
    // This is just the number of bytes for the unsigned representation of the number.
    const e = 64 - function(t) {
        let e = 0;
        for(let n = 0; n < 8; ++n){
            const s = $70fd6868680e912c$var$or(255 & t[n]);
            if (e += s, 8 !== s) break;
        }
        return e;
    }(t);
    return Math.ceil(e / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $70fd6868680e912c$var$cr {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    pe(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.Ie(n.value), n = e.next();
        this.Te();
    }
    Ee(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.Ae(n.value), n = e.next();
        this.Re();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ be(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.Ie(t);
            else if (t < 2048) this.Ie(960 | t >>> 6), this.Ie(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.Ie(480 | t >>> 12), this.Ie(128 | 63 & t >>> 6), this.Ie(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.Ie(240 | t >>> 18), this.Ie(128 | 63 & t >>> 12), this.Ie(128 | 63 & t >>> 6), this.Ie(128 | 63 & t);
            }
        }
        this.Te();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Pe(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.Ae(t);
            else if (t < 2048) this.Ae(960 | t >>> 6), this.Ae(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.Ae(480 | t >>> 12), this.Ae(128 | 63 & t >>> 6), this.Ae(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.Ae(240 | t >>> 18), this.Ae(128 | 63 & t >>> 12), this.Ae(128 | 63 & t >>> 6), this.Ae(128 | 63 & t);
            }
        }
        this.Re();
    }
    ve(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const e = this.Ve(t), n = $70fd6868680e912c$var$ur(e);
        this.Se(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = 255 & e[t];
    }
    De(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const e = this.Ve(t), n = $70fd6868680e912c$var$ur(e);
        this.Se(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = ~(255 & e[t]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ Ce() {
        this.xe(255), this.xe(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ Ne() {
        this.ke(255), this.ke(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(t) {
        this.Se(t.length), this.buffer.set(t, this.position), this.position += t.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Oe() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Ve(t) {
        const e = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function(t) {
            const e = new DataView(new ArrayBuffer(8));
            return e.setFloat64(0, t, /* littleEndian= */ !1), new Uint8Array(e.buffer);
        }(t), n = 0 != (128 & e[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        e[0] ^= n ? 255 : 128;
        for(let t = 1; t < e.length; ++t)e[t] ^= n ? 255 : 0;
        return e;
    }
    /** Writes a single byte ascending to the buffer. */ Ie(t) {
        const e = 255 & t;
        0 === e ? (this.xe(0), this.xe(255)) : 255 === e ? (this.xe(255), this.xe(0)) : this.xe(e);
    }
    /** Writes a single byte descending to the buffer.  */ Ae(t) {
        const e = 255 & t;
        0 === e ? (this.ke(0), this.ke(255)) : 255 === e ? (this.ke(255), this.ke(0)) : this.ke(t);
    }
    Te() {
        this.xe(0), this.xe(1);
    }
    Re() {
        this.ke(0), this.ke(1);
    }
    xe(t) {
        this.Se(1), this.buffer[this.position++] = t;
    }
    ke(t) {
        this.Se(1), this.buffer[this.position++] = ~t;
    }
    Se(t) {
        const e = t + this.position;
        if (e <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < e && (n = e);
        // Create the new buffer.
        const s = new Uint8Array(n);
        s.set(this.buffer), this.buffer = s;
    }
}
class $70fd6868680e912c$var$ar {
    constructor(t){
        this.Me = t;
    }
    de(t) {
        this.Me.pe(t);
    }
    he(t) {
        this.Me.be(t);
    }
    ae(t) {
        this.Me.ve(t);
    }
    ue() {
        this.Me.Ce();
    }
}
class $70fd6868680e912c$var$hr {
    constructor(t){
        this.Me = t;
    }
    de(t) {
        this.Me.Ee(t);
    }
    he(t) {
        this.Me.Pe(t);
    }
    ae(t) {
        this.Me.De(t);
    }
    ue() {
        this.Me.Ne();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $70fd6868680e912c$var$lr {
    constructor(){
        this.Me = new $70fd6868680e912c$var$cr, this.Fe = new $70fd6868680e912c$var$ar(this.Me), this.$e = new $70fd6868680e912c$var$hr(this.Me);
    }
    seed(t) {
        this.Me.seed(t);
    }
    Be(t) {
        return 0 /* ASCENDING */  === t ? this.Fe : this.$e;
    }
    Oe() {
        return this.Me.Oe();
    }
    reset() {
        this.Me.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $70fd6868680e912c$var$fr {
    constructor(t, e, n, s){
        this.indexId = t, this.documentKey = e, this.arrayValue = n, this.directionalValue = s;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Le() {
        const t = this.directionalValue.length, e = 0 === t || 255 === this.directionalValue[t - 1] ? t + 1 : t, n = new Uint8Array(e);
        return n.set(this.directionalValue, 0), e !== t ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $70fd6868680e912c$var$fr(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $70fd6868680e912c$var$dr(t, e) {
    let n = t.indexId - e.indexId;
    return 0 !== n ? n : (n = $70fd6868680e912c$var$_r(t.arrayValue, e.arrayValue), 0 !== n ? n : (n = $70fd6868680e912c$var$_r(t.directionalValue, e.directionalValue), 0 !== n ? n : $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey)));
}
function $70fd6868680e912c$var$_r(t, e) {
    for(let n = 0; n < t.length && n < e.length; ++n){
        const s = t[n] - e[n];
        if (0 !== s) return s;
    }
    return t.length - e.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $70fd6868680e912c$var$wr {
    constructor(t){
        this.collectionId = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment(), this.Ue = t.orderBy, this.qe = [];
        for (const e of t.filters){
            const t = e;
            t.ht() ? this.Ke = t : this.qe.push(t);
        }
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ Ge(t) {
        // If there is an array element, find a matching filter.
        const e = $70fd6868680e912c$var$wt(t);
        if (void 0 !== e && !this.Qe(e)) return !1;
        const n = $70fd6868680e912c$var$mt(t);
        let s = 0, i = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; s < n.length && this.Qe(n[s]); ++s);
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (s === n.length) return !0;
        // If there is an inequality filter, the next segment must match both the
        // filter and the first orderBy clause.
        if (void 0 !== this.Ke) {
            const t = n[s];
            if (!this.je(this.Ke, t) || !this.We(this.Ue[i++], t)) return !1;
            ++s;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; s < n.length; ++s){
            const t = n[s];
            if (i >= this.Ue.length || !this.We(this.Ue[i++], t)) return !1;
        }
        return !0;
    }
    Qe(t) {
        for (const e of this.qe)if (this.je(e, t)) return !0;
        return !1;
    }
    je(t, e) {
        if (void 0 === t || !t.field.isEqual(e.fieldPath)) return !1;
        const n = "array-contains" /* ARRAY_CONTAINS */  === t.op || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === t.op;
        return 2 /* CONTAINS */  === e.kind === n;
    }
    We(t, e) {
        return !!t.field.isEqual(e.fieldPath) && (0 /* ASCENDING */  === e.kind && "asc" /* ASCENDING */  === t.dir || 1 /* DESCENDING */  === e.kind && "desc" /* DESCENDING */  === t.dir);
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $70fd6868680e912c$var$mr {
    constructor(){
        this.ze = new $70fd6868680e912c$var$gr;
    }
    addToCollectionParentIndex(t, e) {
        return this.ze.add(e), $70fd6868680e912c$var$Pt.resolve();
    }
    getCollectionParents(t, e) {
        return $70fd6868680e912c$var$Pt.resolve(this.ze.getEntries(e));
    }
    addFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve();
    }
    deleteFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve();
    }
    getDocumentsMatchingTarget(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve(null);
    }
    getIndexType(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve(0 /* NONE */ );
    }
    getFieldIndexes(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve([]);
    }
    getNextCollectionGroupToUpdate(t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve(null);
    }
    getMinOffset(t, e) {
        return $70fd6868680e912c$var$Pt.resolve($70fd6868680e912c$var$Tt.min());
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return $70fd6868680e912c$var$Pt.resolve($70fd6868680e912c$var$Tt.min());
    }
    updateCollectionGroup(t, e, n) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve();
    }
    updateIndexEntries(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Pt.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $70fd6868680e912c$var$gr {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e] || new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$ht.comparator), i = !s.has(n);
        return this.index[e] = s.add(n), i;
    }
    has(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e];
        return s && s.has(n);
    }
    getEntries(t) {
        return (this.index[t] || new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$ht.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$yr = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $70fd6868680e912c$var$pr {
    constructor(t, e){
        this.user = t, this.databaseId = e, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.He = new $70fd6868680e912c$var$gr, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Je = new $70fd6868680e912c$var$is((t)=>$70fd6868680e912c$var$Oe(t), (t, e)=>$70fd6868680e912c$var$Fe(t, e)), this.uid = t.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(t, e) {
        if (!this.He.has(e)) {
            const n = e.lastSegment(), s = e.popLast();
            t.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.He.add(e);
            });
            const i = {
                collectionId: n,
                parent: $70fd6868680e912c$var$ci(s)
            };
            return $70fd6868680e912c$var$Ir(t).put(i);
        }
        return $70fd6868680e912c$var$Pt.resolve();
    }
    getCollectionParents(t, e) {
        const n = [], s = IDBKeyRange.bound([
            e,
            ""
        ], [
            $70fd6868680e912c$var$ot(e),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $70fd6868680e912c$var$Ir(t).K(s).next((t)=>{
            for (const s of t){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (s.collectionId !== e) break;
                n.push($70fd6868680e912c$var$li(s.parent));
            }
            return n;
        });
    }
    addFieldIndex(t, e) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $70fd6868680e912c$var$Er(t), s = function(t) {
            return {
                indexId: t.indexId,
                collectionGroup: t.collectionGroup,
                fields: t.fields.map((t)=>[
                        t.fieldPath.canonicalString(),
                        t.kind
                    ])
            };
        }(e);
        delete s.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(s);
        if (e.indexState) {
            const n = $70fd6868680e912c$var$Ar(t);
            return i.next((t)=>{
                n.put($70fd6868680e912c$var$Zi(t, this.user, e.indexState.sequenceNumber, e.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(t, e) {
        const n = $70fd6868680e912c$var$Er(t), s = $70fd6868680e912c$var$Ar(t), i = $70fd6868680e912c$var$Tr(t);
        return n.delete(e.indexId).next(()=>s.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    getDocumentsMatchingTarget(t, e) {
        const n = $70fd6868680e912c$var$Tr(t);
        let s = !0;
        const i = new Map;
        return $70fd6868680e912c$var$Pt.forEach(this.Ye(e), (e)=>this.Xe(t, e).next((t)=>{
                s && (s = !!t), i.set(e, t);
            })).next(()=>{
            if (s) {
                let t = $70fd6868680e912c$var$ws();
                const s = [];
                return $70fd6868680e912c$var$Pt.forEach(i, (i, r)=>{
                    /** Returns a debug representation of the field index */ var o;
                    $70fd6868680e912c$var$M("IndexedDbIndexManager", `Using index ${(o = i, `id=${o.indexId}|cg=${o.collectionGroup}|f=${o.fields.map((t)=>`${t.fieldPath}:${t.kind}`).join(",")}`)} to execute ${$70fd6868680e912c$var$Oe(e)}`);
                    const u = function(t, e) {
                        const n = $70fd6868680e912c$var$wt(e);
                        if (void 0 === n) return null;
                        for (const e of $70fd6868680e912c$var$Be(t, n.fieldPath))switch(e.op){
                            case "array-contains-any" /* ARRAY_CONTAINS_ANY */ :
                                return e.value.arrayValue.values || [];
                            case "array-contains" /* ARRAY_CONTAINS */ :
                                return [
                                    e.value
                                ];
                        }
                        return null;
                    }(r, i), c = function(t, e) {
                        const n = new Map;
                        for (const s of $70fd6868680e912c$var$mt(e))for (const e of $70fd6868680e912c$var$Be(t, s.fieldPath))switch(e.op){
                            case "==" /* EQUAL */ :
                            case "in" /* IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(s.fieldPath.canonicalString(), e.value);
                                break;
                            case "not-in" /* NOT_IN */ :
                            case "!=" /* NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(s.fieldPath.canonicalString(), e.value), Array.from(n.values());
                        }
                        return null;
                    }(r, i), a = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $70fd6868680e912c$var$mt(e)){
                            const e = 0 /* ASCENDING */  === i.kind ? $70fd6868680e912c$var$Le(t, i.fieldPath, t.startAt) : $70fd6868680e912c$var$Ue(t, i.fieldPath, t.startAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $70fd6868680e912c$var$Ye(n, s);
                    }(r, i), h = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $70fd6868680e912c$var$mt(e)){
                            const e = 0 /* ASCENDING */  === i.kind ? $70fd6868680e912c$var$Ue(t, i.fieldPath, t.endAt) : $70fd6868680e912c$var$Le(t, i.fieldPath, t.endAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $70fd6868680e912c$var$Ye(n, s);
                    }(r, i), l = this.Ze(i, r, a), f = this.Ze(i, r, h), d = this.tn(i, r, c), _ = this.en(i.indexId, u, l, a.inclusive, f, h.inclusive, d);
                    return $70fd6868680e912c$var$Pt.forEach(_, (i)=>n.j(i, e.limit).next((e)=>{
                            e.forEach((e)=>{
                                const n = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.documentKey);
                                t.has(n) || (t = t.add(n), s.push(n));
                            });
                        }));
                }).next(()=>s);
            }
            return $70fd6868680e912c$var$Pt.resolve(null);
        });
    }
    Ye(t) {
        let e = this.Je.get(t);
        return e || // TODO(orquery): Implement DNF transform
        (e = [
            t
        ], this.Je.set(t, e), e);
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ en(t, e, n, s, i, r, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const u = (null != e ? e.length : 1) * Math.max(n.length, i.length), c = u / (null != e ? e.length : 1), a = [];
        for(let h = 0; h < u; ++h){
            const u = e ? this.nn(e[h / c]) : $70fd6868680e912c$var$yr, l = this.sn(t, u, n[h % c], s), f = this.rn(t, u, i[h % c], r), d = o.map((e)=>this.sn(t, u, e, /* inclusive= */ !0));
            a.push(...this.createRange(l, f, d));
        }
        return a;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ sn(t, e, n, s) {
        const i = new $70fd6868680e912c$var$fr(t, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e, n);
        return s ? i : i.Le();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ rn(t, e, n, s) {
        const i = new $70fd6868680e912c$var$fr(t, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e, n);
        return s ? i.Le() : i;
    }
    Xe(t, e) {
        const n = new $70fd6868680e912c$var$wr(e), s = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment();
        return this.getFieldIndexes(t, s).next((t)=>{
            // Return the index with the most number of segments.
            let e = null;
            for (const s of t)n.Ge(s) && (!e || s.fields.length > e.fields.length) && (e = s);
            return e;
        });
    }
    getIndexType(t, e) {
        let n = 2 /* FULL */ ;
        return $70fd6868680e912c$var$Pt.forEach(this.Ye(e), (e)=>this.Xe(t, e).next((t)=>{
                t ? 0 /* NONE */  !== n && t.fields.length < function(t) {
                    let e = new $70fd6868680e912c$var$Qt($70fd6868680e912c$export$b7871852b967eaf1.comparator), n = !1;
                    for (const s of t.filters){
                        // TODO(orquery): Use the flattened filters here
                        const t = s;
                        // __name__ is not an explicit segment of any index, so we don't need to
                        // count it.
                        t.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                        // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                        // though these are on the same field, they should be counted as two
                        // separate segments in an index.
                        ("array-contains" /* ARRAY_CONTAINS */  === t.op || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === t.op ? n = !0 : e = e.add(t.field));
                    }
                    for (const n of t.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (e = e.add(n.field));
                    return e.size + (n ? 1 : 0);
                }(e) && (n = 1 /* PARTIAL */ ) : n = 0 /* NONE */ ;
            })).next(()=>n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ on(t, e) {
        const n = new $70fd6868680e912c$var$lr;
        for (const s of $70fd6868680e912c$var$mt(t)){
            const t = e.data.field(s.fieldPath);
            if (null == t) return null;
            const i = n.Be(s.kind);
            $70fd6868680e912c$var$rr.ye.re(t, i);
        }
        return n.Oe();
    }
    /** Encodes a single value to the ascending index format. */ nn(t) {
        const e = new $70fd6868680e912c$var$lr;
        return $70fd6868680e912c$var$rr.ye.re(t, e.Be(0 /* ASCENDING */ )), e.Oe();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ un(t, e) {
        const n = new $70fd6868680e912c$var$lr;
        return $70fd6868680e912c$var$rr.ye.re($70fd6868680e912c$var$ye(this.databaseId, e), n.Be(function(t) {
            const e = $70fd6868680e912c$var$mt(t);
            return 0 === e.length ? 0 /* ASCENDING */  : e[e.length - 1].kind;
        }(t))), n.Oe();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ tn(t, e, n) {
        if (null === n) return [];
        let s = [];
        s.push(new $70fd6868680e912c$var$lr);
        let i = 0;
        for (const r of $70fd6868680e912c$var$mt(t)){
            const t = n[i++];
            for (const n of s)if (this.cn(e, r.fieldPath) && $70fd6868680e912c$var$Ie(t)) s = this.an(s, r, t);
            else {
                const e = n.Be(r.kind);
                $70fd6868680e912c$var$rr.ye.re(t, e);
            }
        }
        return this.hn(s);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ Ze(t, e, n) {
        return this.tn(t, e, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ hn(t) {
        const e = [];
        for(let n = 0; n < t.length; ++n)e[n] = t[n].Oe();
        return e;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ an(t, e, n) {
        const s = [
            ...t
        ], i = [];
        for (const t of n.arrayValue.values || [])for (const n of s){
            const s = new $70fd6868680e912c$var$lr;
            s.seed(n.Oe()), $70fd6868680e912c$var$rr.ye.re(t, s.Be(e.kind)), i.push(s);
        }
        return i;
    }
    cn(t, e) {
        return !!t.filters.find((t)=>t instanceof $70fd6868680e912c$var$qe && t.field.isEqual(e) && ("in" /* IN */  === t.op || "not-in" /* NOT_IN */  === t.op));
    }
    getFieldIndexes(t, e) {
        const n = $70fd6868680e912c$var$Er(t), s = $70fd6868680e912c$var$Ar(t);
        return (e ? n.K("collectionGroupIndex", IDBKeyRange.bound(e, e)) : n.K()).next((t)=>{
            const e = [];
            return $70fd6868680e912c$var$Pt.forEach(t, (t)=>s.get([
                    t.indexId,
                    this.uid
                ]).next((n)=>{
                    e.push(function(t, e) {
                        const n = e ? new $70fd6868680e912c$var$yt(e.sequenceNumber, new $70fd6868680e912c$var$Tt($70fd6868680e912c$var$ji(e.readTime), new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$li(e.documentKey)), e.largestBatchId)) : $70fd6868680e912c$var$yt.empty(), s = t.fields.map(([t, e])=>new $70fd6868680e912c$var$gt($70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t), e));
                        return new $70fd6868680e912c$var$_t(t.indexId, t.collectionGroup, s, n);
                    }(t, n));
                })).next(()=>e);
        });
    }
    getNextCollectionGroupToUpdate(t) {
        return this.getFieldIndexes(t).next((t)=>0 === t.length ? null : (t.sort((t, e)=>{
                const n = t.indexState.sequenceNumber - e.indexState.sequenceNumber;
                return 0 !== n ? n : $70fd6868680e912c$var$it(t.collectionGroup, e.collectionGroup);
            }), t[0].collectionGroup));
    }
    updateCollectionGroup(t, e, n) {
        const s = $70fd6868680e912c$var$Er(t), i = $70fd6868680e912c$var$Ar(t);
        return this.ln(t).next((t)=>s.K("collectionGroupIndex", IDBKeyRange.bound(e, e)).next((e)=>$70fd6868680e912c$var$Pt.forEach(e, (e)=>i.put($70fd6868680e912c$var$Zi(e.indexId, this.user, t, n)))));
    }
    updateIndexEntries(t, e) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $70fd6868680e912c$var$Pt.forEach(e, (e, s)=>{
            const i = n.get(e.collectionGroup);
            return (i ? $70fd6868680e912c$var$Pt.resolve(i) : this.getFieldIndexes(t, e.collectionGroup)).next((i)=>(n.set(e.collectionGroup, i), $70fd6868680e912c$var$Pt.forEach(i, (n)=>this.fn(t, e, n).next((e)=>{
                        const i = this.dn(s, n);
                        return e.isEqual(i) ? $70fd6868680e912c$var$Pt.resolve() : this._n(t, s, n, e, i);
                    }))));
        });
    }
    wn(t, e, n, s) {
        return $70fd6868680e912c$var$Tr(t).put({
            indexId: s.indexId,
            uid: this.uid,
            arrayValue: s.arrayValue,
            directionalValue: s.directionalValue,
            orderedDocumentKey: this.un(n, e.key),
            documentKey: e.key.path.toArray()
        });
    }
    mn(t, e, n, s) {
        return $70fd6868680e912c$var$Tr(t).delete([
            s.indexId,
            this.uid,
            s.arrayValue,
            s.directionalValue,
            this.un(n, e.key),
            e.key.path.toArray()
        ]);
    }
    fn(t, e, n) {
        const s = $70fd6868680e912c$var$Tr(t);
        let i = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$dr);
        return s.J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.un(n, e)
            ])
        }, (t, s)=>{
            i = i.add(new $70fd6868680e912c$var$fr(n.indexId, e, s.arrayValue, s.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ dn(t, e) {
        let n = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$dr);
        const s = this.on(e, t);
        if (null == s) return n;
        const i = $70fd6868680e912c$var$wt(e);
        if (null != i) {
            const r = t.data.field(i.fieldPath);
            if ($70fd6868680e912c$var$Ie(r)) for (const i of r.arrayValue.values || [])n = n.add(new $70fd6868680e912c$var$fr(e.indexId, t.key, this.nn(i), s));
        } else n = n.add(new $70fd6868680e912c$var$fr(e.indexId, t.key, $70fd6868680e912c$var$yr, s));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ _n(t, e, n, s, i) {
        $70fd6868680e912c$var$M("IndexedDbIndexManager", "Updating index entries for document '%s'", e.key);
        const r = [];
        return function(t, e, n, s, i) {
            const r = t.getIterator(), o = e.getIterator();
            let u = $70fd6868680e912c$var$Wt(r), c = $70fd6868680e912c$var$Wt(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; u || c;){
                let t = !1, e = !1;
                if (u && c) {
                    const s = n(u, c);
                    s < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    e = !0 : s > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (t = !0);
                } else null != u ? e = !0 : t = !0;
                t ? (s(c), c = $70fd6868680e912c$var$Wt(o)) : e ? (i(u), u = $70fd6868680e912c$var$Wt(r)) : (u = $70fd6868680e912c$var$Wt(r), c = $70fd6868680e912c$var$Wt(o));
            }
        }(s, i, $70fd6868680e912c$var$dr, /* onAdd= */ (s)=>{
            r.push(this.wn(t, e, n, s));
        }, /* onRemove= */ (s)=>{
            r.push(this.mn(t, e, n, s));
        }), $70fd6868680e912c$var$Pt.waitFor(r);
    }
    ln(t) {
        let e = 1;
        return $70fd6868680e912c$var$Ar(t).J({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (t, n, s)=>{
            s.done(), e = n.sequenceNumber + 1;
        }).next(()=>e);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(t, e, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((t, e)=>$70fd6868680e912c$var$dr(t, e)).filter((t, e, n)=>!e || 0 !== $70fd6868680e912c$var$dr(t, n[e - 1]));
        const s = [];
        s.push(t);
        for (const i of n){
            const n = $70fd6868680e912c$var$dr(i, t), r = $70fd6868680e912c$var$dr(i, e);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            s[0] = t.Le();
            else if (n > 0 && r < 0) // `notInValue` is in the middle of the range
            s.push(i), s.push(i.Le());
            else if (r > 0) break;
        }
        s.push(e);
        const i = [];
        for(let t = 0; t < s.length; t += 2)i.push(IDBKeyRange.bound([
            s[t].indexId,
            this.uid,
            s[t].arrayValue,
            s[t].directionalValue,
            $70fd6868680e912c$var$yr,
            []
        ], [
            s[t + 1].indexId,
            this.uid,
            s[t + 1].arrayValue,
            s[t + 1].directionalValue,
            $70fd6868680e912c$var$yr,
            []
        ]));
        return i;
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return this.getFieldIndexes(t, e).next($70fd6868680e912c$var$Rr);
    }
    getMinOffset(t, e) {
        return $70fd6868680e912c$var$Pt.mapArray(this.Ye(e), (e)=>this.Xe(t, e).next((t)=>t || $70fd6868680e912c$var$L())).next($70fd6868680e912c$var$Rr);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $70fd6868680e912c$var$Ir(t) {
    return $70fd6868680e912c$var$Mi(t, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $70fd6868680e912c$var$Tr(t) {
    return $70fd6868680e912c$var$Mi(t, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $70fd6868680e912c$var$Er(t) {
    return $70fd6868680e912c$var$Mi(t, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $70fd6868680e912c$var$Ar(t) {
    return $70fd6868680e912c$var$Mi(t, "indexState");
}
function $70fd6868680e912c$var$Rr(t) {
    $70fd6868680e912c$var$U(0 !== t.length);
    let e = t[0].indexState.offset, n = e.largestBatchId;
    for(let s = 1; s < t.length; s++){
        const i = t[s].indexState.offset;
        $70fd6868680e912c$var$Et(i, e) < 0 && (e = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $70fd6868680e912c$var$Tt(e.readTime, e.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$br = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $70fd6868680e912c$var$Pr {
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    t, // The percentage of sequence numbers that we will attempt to collect
    e, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = t, this.percentileToCollect = e, this.maximumSequenceNumbersToCollect = n;
    }
    static withCacheSize(t) {
        return new $70fd6868680e912c$var$Pr(t, $70fd6868680e912c$var$Pr.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $70fd6868680e912c$var$vr(t, e, n) {
    const s = t.store("mutations"), i = t.store("documentMutations"), r = [], o = IDBKeyRange.only(n.batchId);
    let u = 0;
    const c = s.J({
        range: o
    }, (t, e, n)=>(u++, n.delete()));
    r.push(c.next(()=>{
        $70fd6868680e912c$var$U(1 === u);
    }));
    const a = [];
    for (const t of n.mutations){
        const s = $70fd6868680e912c$var$_i(e, t.key.path, n.batchId);
        r.push(i.delete(s)), a.push(t.key);
    }
    return $70fd6868680e912c$var$Pt.waitFor(r).next(()=>a);
}
/**
 * Returns an approximate size for the given document.
 */ function $70fd6868680e912c$var$Vr(t) {
    if (!t) return 0;
    let e;
    if (t.document) e = t.document;
    else if (t.unknownDocument) e = t.unknownDocument;
    else {
        if (!t.noDocument) throw $70fd6868680e912c$var$L();
        e = t.noDocument;
    }
    return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $70fd6868680e912c$var$Pr.DEFAULT_COLLECTION_PERCENTILE = 10, $70fd6868680e912c$var$Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $70fd6868680e912c$var$Pr.DEFAULT = new $70fd6868680e912c$var$Pr(41943040, $70fd6868680e912c$var$Pr.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $70fd6868680e912c$var$Pr.DISABLED = new $70fd6868680e912c$var$Pr(-1, 0, 0);
class $70fd6868680e912c$var$Sr {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ t, e, n, s){
        this.userId = t, this.wt = e, this.indexManager = n, this.referenceDelegate = s, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.gn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static se(t, e, n, s) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $70fd6868680e912c$var$U("" !== t.uid);
        const i = t.isAuthenticated() ? t.uid : "";
        return new $70fd6868680e912c$var$Sr(i, e, n, s);
    }
    checkEmpty(t) {
        let e = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$Cr(t).J({
            index: "userMutationsIndex",
            range: n
        }, (t, n, s)=>{
            e = !1, s.done();
        }).next(()=>e);
    }
    addMutationBatch(t, e, n, s) {
        const i = $70fd6868680e912c$var$xr(t), r = $70fd6868680e912c$var$Cr(t);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return r.add({}).next((o)=>{
            $70fd6868680e912c$var$U("number" == typeof o);
            const u = new $70fd6868680e912c$var$Fi(o, e, n, s), c = function(t, e, n) {
                const s = n.baseMutations.map((e)=>$70fd6868680e912c$var$js(t.ne, e)), i = n.mutations.map((e)=>$70fd6868680e912c$var$js(t.ne, e));
                return {
                    userId: e,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: s,
                    mutations: i
                };
            }(this.wt, this.userId, u), a = [];
            let h = new $70fd6868680e912c$var$Qt((t, e)=>$70fd6868680e912c$var$it(t.canonicalString(), e.canonicalString()));
            for (const t of s){
                const e = $70fd6868680e912c$var$_i(this.userId, t.key.path, o);
                h = h.add(t.key.path.popLast()), a.push(r.put(c)), a.push(i.put(e, $70fd6868680e912c$var$wi));
            }
            return h.forEach((e)=>{
                a.push(this.indexManager.addToCollectionParentIndex(t, e));
            }), t.addOnCommittedListener(()=>{
                this.gn[o] = u.keys();
            }), $70fd6868680e912c$var$Pt.waitFor(a).next(()=>u);
        });
    }
    lookupMutationBatch(t, e) {
        return $70fd6868680e912c$var$Cr(t).get(e).next((t)=>t ? ($70fd6868680e912c$var$U(t.userId === this.userId), $70fd6868680e912c$var$Wi(this.wt, t)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    yn(t, e) {
        return this.gn[e] ? $70fd6868680e912c$var$Pt.resolve(this.gn[e]) : this.lookupMutationBatch(t, e).next((t)=>{
            if (t) {
                const n = t.keys();
                return this.gn[e] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $70fd6868680e912c$var$Cr(t).J({
            index: "userMutationsIndex",
            range: s
        }, (t, e, s)=>{
            e.userId === this.userId && ($70fd6868680e912c$var$U(e.batchId >= n), i = $70fd6868680e912c$var$Wi(this.wt, e)), s.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(t) {
        const e = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $70fd6868680e912c$var$Cr(t).J({
            index: "userMutationsIndex",
            range: e,
            reverse: !0
        }, (t, e, s)=>{
            n = e.batchId, s.done();
        }).next(()=>n);
    }
    getAllMutationBatches(t) {
        const e = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$Cr(t).K("userMutationsIndex", e).next((t)=>t.map((t)=>$70fd6868680e912c$var$Wi(this.wt, t)));
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $70fd6868680e912c$var$di(this.userId, e.path), s = IDBKeyRange.lowerBound(n), i = [];
        return $70fd6868680e912c$var$xr(t).J({
            range: s
        }, (n, s, r)=>{
            const [o, u, c] = n, a = $70fd6868680e912c$var$li(u);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && e.path.isEqual(a)) // Look up the mutation batch in the store.
            return $70fd6868680e912c$var$Cr(t).get(c).next((t)=>{
                if (!t) throw $70fd6868680e912c$var$L();
                $70fd6868680e912c$var$U(t.userId === this.userId), i.push($70fd6868680e912c$var$Wi(this.wt, t));
            });
            r.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it);
        const s = [];
        return e.forEach((e)=>{
            const i = $70fd6868680e912c$var$di(this.userId, e.path), r = IDBKeyRange.lowerBound(i), o = $70fd6868680e912c$var$xr(t).J({
                range: r
            }, (t, s, i)=>{
                const [r, o, u] = t, c = $70fd6868680e912c$var$li(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                r === this.userId && e.path.isEqual(c) ? n = n.add(u) : i.done();
            });
            s.push(o);
        }), $70fd6868680e912c$var$Pt.waitFor(s).next(()=>this.pn(t, n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        const n = e.path, s = n.length + 1, i = $70fd6868680e912c$var$di(this.userId, n), r = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it);
        return $70fd6868680e912c$var$xr(t).J({
            range: r
        }, (t, e, i)=>{
            const [r, u, c] = t, a = $70fd6868680e912c$var$li(u);
            r === this.userId && n.isPrefixOf(a) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            a.length === s && (o = o.add(c)) : i.done();
        }).next(()=>this.pn(t, o));
    }
    pn(t, e) {
        const n = [], s = [];
        // TODO(rockwood): Implement this using iterate.
        return e.forEach((e)=>{
            s.push($70fd6868680e912c$var$Cr(t).get(e).next((t)=>{
                if (null === t) throw $70fd6868680e912c$var$L();
                $70fd6868680e912c$var$U(t.userId === this.userId), n.push($70fd6868680e912c$var$Wi(this.wt, t));
            }));
        }), $70fd6868680e912c$var$Pt.waitFor(s).next(()=>n);
    }
    removeMutationBatch(t, e) {
        return $70fd6868680e912c$var$vr(t.ee, this.userId, e).next((n)=>(t.addOnCommittedListener(()=>{
                this.In(e.batchId);
            }), $70fd6868680e912c$var$Pt.forEach(n, (e)=>this.referenceDelegate.markPotentiallyOrphaned(t, e))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    In(t) {
        delete this.gn[t];
    }
    performConsistencyCheck(t) {
        return this.checkEmpty(t).next((e)=>{
            if (!e) return $70fd6868680e912c$var$Pt.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound([
                this.userId
            ]);
            const s = [];
            return $70fd6868680e912c$var$xr(t).J({
                range: n
            }, (t, e, n)=>{
                if (t[0] === this.userId) {
                    const e = $70fd6868680e912c$var$li(t[1]);
                    s.push(e);
                } else n.done();
            }).next(()=>{
                $70fd6868680e912c$var$U(0 === s.length);
            });
        });
    }
    containsKey(t, e) {
        return $70fd6868680e912c$var$Dr(t, this.userId, e);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Tn(t) {
        return $70fd6868680e912c$var$Nr(t).get(this.userId).next((t)=>t || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $70fd6868680e912c$var$Dr(t, e, n) {
    const s = $70fd6868680e912c$var$di(e, n.path), i = s[1], r = IDBKeyRange.lowerBound(s);
    let o = !1;
    return $70fd6868680e912c$var$xr(t).J({
        range: r,
        H: !0
    }, (t, n, s)=>{
        const [r, u, /*batchID*/ c] = t;
        r === e && u === i && (o = !0), s.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $70fd6868680e912c$var$Cr(t) {
    return $70fd6868680e912c$var$Mi(t, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$xr(t) {
    return $70fd6868680e912c$var$Mi(t, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$Nr(t) {
    return $70fd6868680e912c$var$Mi(t, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $70fd6868680e912c$var$kr {
    constructor(t){
        this.En = t;
    }
    next() {
        return this.En += 2, this.En;
    }
    static An() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $70fd6868680e912c$var$kr(0);
    }
    static Rn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $70fd6868680e912c$var$kr(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Or {
    constructor(t, e){
        this.referenceDelegate = t, this.wt = e;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(t) {
        return this.bn(t).next((e)=>{
            const n = new $70fd6868680e912c$var$kr(e.highestTargetId);
            return e.highestTargetId = n.next(), this.Pn(t, e).next(()=>e.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(t) {
        return this.bn(t).next((t)=>$70fd6868680e912c$var$ct.fromTimestamp(new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(t) {
        return this.bn(t).next((t)=>t.highestListenSequenceNumber);
    }
    setTargetsMetadata(t, e, n) {
        return this.bn(t).next((s)=>(s.highestListenSequenceNumber = e, n && (s.lastRemoteSnapshotVersion = n.toTimestamp()), e > s.highestListenSequenceNumber && (s.highestListenSequenceNumber = e), this.Pn(t, s)));
    }
    addTargetData(t, e) {
        return this.vn(t, e).next(()=>this.bn(t).next((n)=>(n.targetCount += 1, this.Vn(e, n), this.Pn(t, n))));
    }
    updateTargetData(t, e) {
        return this.vn(t, e);
    }
    removeTargetData(t, e) {
        return this.removeMatchingKeysForTargetId(t, e.targetId).next(()=>$70fd6868680e912c$var$Mr(t).delete(e.targetId)).next(()=>this.bn(t)).next((e)=>($70fd6868680e912c$var$U(e.targetCount > 0), e.targetCount -= 1, this.Pn(t, e)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return $70fd6868680e912c$var$Mr(t).J((r, o)=>{
            const u = $70fd6868680e912c$var$zi(o);
            u.sequenceNumber <= e && null === n.get(u.targetId) && (s++, i.push(this.removeTargetData(t, u)));
        }).next(()=>$70fd6868680e912c$var$Pt.waitFor(i)).next(()=>s);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(t, e) {
        return $70fd6868680e912c$var$Mr(t).J((t, n)=>{
            const s = $70fd6868680e912c$var$zi(n);
            e(s);
        });
    }
    bn(t) {
        return $70fd6868680e912c$var$Fr(t).get("targetGlobalKey").next((t)=>($70fd6868680e912c$var$U(null !== t), t));
    }
    Pn(t, e) {
        return $70fd6868680e912c$var$Fr(t).put("targetGlobalKey", e);
    }
    vn(t, e) {
        return $70fd6868680e912c$var$Mr(t).put($70fd6868680e912c$var$Hi(this.wt, e));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Vn(t, e) {
        let n = !1;
        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }
    getTargetCount(t) {
        return this.bn(t).next((t)=>t.targetCount);
    }
    getTargetData(t, e) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $70fd6868680e912c$var$Oe(e), s = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $70fd6868680e912c$var$Mr(t).J({
            range: s,
            index: "queryTargetsIndex"
        }, (t, n, s)=>{
            const r = $70fd6868680e912c$var$zi(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $70fd6868680e912c$var$Fe(e, r.target) && (i = r, s.done());
        }).next(()=>i);
    }
    addMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = [], i = $70fd6868680e912c$var$$r(t);
        return e.forEach((e)=>{
            const r = $70fd6868680e912c$var$ci(e.path);
            s.push(i.put({
                targetId: n,
                path: r
            })), s.push(this.referenceDelegate.addReference(t, n, e));
        }), $70fd6868680e912c$var$Pt.waitFor(s);
    }
    removeMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = $70fd6868680e912c$var$$r(t);
        return $70fd6868680e912c$var$Pt.forEach(e, (e)=>{
            const i = $70fd6868680e912c$var$ci(e.path);
            return $70fd6868680e912c$var$Pt.waitFor([
                s.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(t, n, e)
            ]);
        });
    }
    removeMatchingKeysForTargetId(t, e) {
        const n = $70fd6868680e912c$var$$r(t), s = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(s);
    }
    getMatchingKeysForTargetId(t, e) {
        const n = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), s = $70fd6868680e912c$var$$r(t);
        let i = $70fd6868680e912c$var$ws();
        return s.J({
            range: n,
            H: !0
        }, (t, e, n)=>{
            const s = $70fd6868680e912c$var$li(t[1]), r = new $70fd6868680e912c$export$afc2e57c475b7810(s);
            i = i.add(r);
        }).next(()=>i);
    }
    containsKey(t, e) {
        const n = $70fd6868680e912c$var$ci(e.path), s = IDBKeyRange.bound([
            n
        ], [
            $70fd6868680e912c$var$ot(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $70fd6868680e912c$var$$r(t).J({
            index: "documentTargetsIndex",
            H: !0,
            range: s
        }, ([t, e], n, s)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== t && (i++, s.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    te(t, e) {
        return $70fd6868680e912c$var$Mr(t).get(e).next((t)=>t ? $70fd6868680e912c$var$zi(t) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $70fd6868680e912c$var$Mr(t) {
    return $70fd6868680e912c$var$Mi(t, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $70fd6868680e912c$var$Fr(t) {
    return $70fd6868680e912c$var$Mi(t, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $70fd6868680e912c$var$$r(t) {
    return $70fd6868680e912c$var$Mi(t, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$Br([t, e], [n, s]) {
    const i = $70fd6868680e912c$var$it(t, n);
    return 0 === i ? $70fd6868680e912c$var$it(e, s) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $70fd6868680e912c$var$Lr {
    constructor(t){
        this.Sn = t, this.buffer = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$Br), this.Dn = 0;
    }
    Cn() {
        return ++this.Dn;
    }
    xn(t) {
        const e = [
            t,
            this.Cn()
        ];
        if (this.buffer.size < this.Sn) this.buffer = this.buffer.add(e);
        else {
            const t = this.buffer.last();
            $70fd6868680e912c$var$Br(e, t) < 0 && (this.buffer = this.buffer.delete(t).add(e));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $70fd6868680e912c$var$Ur {
    constructor(t, e, n){
        this.garbageCollector = t, this.asyncQueue = e, this.localStore = n, this.Nn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.kn(6e4);
    }
    stop() {
        this.Nn && (this.Nn.cancel(), this.Nn = null);
    }
    get started() {
        return null !== this.Nn;
    }
    kn(t) {
        $70fd6868680e912c$var$M("LruGarbageCollector", `Garbage collection scheduled in ${t}ms`), this.Nn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* LruGarbageCollection */ , t, async ()=>{
            this.Nn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (t) {
                $70fd6868680e912c$var$Ct(t) ? $70fd6868680e912c$var$M("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", t) : await $70fd6868680e912c$var$bt(t);
            }
            await this.kn(3e5);
        });
    }
}
/** Implements the steps for LRU garbage collection. */ class $70fd6868680e912c$var$qr {
    constructor(t, e){
        this.On = t, this.params = e;
    }
    calculateTargetCount(t, e) {
        return this.On.Mn(t).next((t)=>Math.floor(e / 100 * t));
    }
    nthSequenceNumber(t, e) {
        if (0 === e) return $70fd6868680e912c$var$Pt.resolve($70fd6868680e912c$var$$t.ot);
        const n = new $70fd6868680e912c$var$Lr(e);
        return this.On.forEachTarget(t, (t)=>n.xn(t.sequenceNumber)).next(()=>this.On.Fn(t, (t)=>n.xn(t))).next(()=>n.maxValue);
    }
    removeTargets(t, e, n) {
        return this.On.removeTargets(t, e, n);
    }
    removeOrphanedDocuments(t, e) {
        return this.On.removeOrphanedDocuments(t, e);
    }
    collect(t, e) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$M("LruGarbageCollector", "Garbage collection skipped; disabled"), $70fd6868680e912c$var$Pt.resolve($70fd6868680e912c$var$br)) : this.getCacheSize(t).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$M("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $70fd6868680e912c$var$br) : this.$n(t, e));
    }
    getCacheSize(t) {
        return this.On.getCacheSize(t);
    }
    $n(t, e) {
        let n, s, i, r, o, c, a;
        const h = Date.now();
        return this.calculateTargetCount(t, this.params.percentileToCollect).next((e)=>// Cap at the configured max
            (e > this.params.maximumSequenceNumbersToCollect ? ($70fd6868680e912c$var$M("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${e}`), s = this.params.maximumSequenceNumbersToCollect) : s = e, r = Date.now(), this.nthSequenceNumber(t, s))).next((s)=>(n = s, o = Date.now(), this.removeTargets(t, n, e))).next((e)=>(i = e, c = Date.now(), this.removeOrphanedDocuments(t, n))).next((t)=>{
            if (a = Date.now(), $70fd6868680e912c$var$k() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) $70fd6868680e912c$var$M("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${r - h}ms\n\tDetermined least recently used ${s} in ` + (o - r) + "ms\n" + `\tRemoved ${i} targets in ` + (c - o) + "ms\n" + `\tRemoved ${t} documents in ` + (a - c) + "ms\n" + `Total Duration: ${a - h}ms`);
            return $70fd6868680e912c$var$Pt.resolve({
                didRun: !0,
                sequenceNumbersCollected: s,
                targetsRemoved: i,
                documentsRemoved: t
            });
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $70fd6868680e912c$var$Kr {
    constructor(t, e){
        this.db = t, this.garbageCollector = function(t, e) {
            return new $70fd6868680e912c$var$qr(t, e);
        }(this, e);
    }
    Mn(t) {
        const e = this.Bn(t);
        return this.db.getTargetCache().getTargetCount(t).next((t)=>e.next((e)=>t + e));
    }
    Bn(t) {
        let e = 0;
        return this.Fn(t, (t)=>{
            e++;
        }).next(()=>e);
    }
    forEachTarget(t, e) {
        return this.db.getTargetCache().forEachTarget(t, e);
    }
    Fn(t, e) {
        return this.Ln(t, (t, n)=>e(n));
    }
    addReference(t, e, n) {
        return $70fd6868680e912c$var$Gr(t, n);
    }
    removeReference(t, e, n) {
        return $70fd6868680e912c$var$Gr(t, n);
    }
    removeTargets(t, e, n) {
        return this.db.getTargetCache().removeTargets(t, e, n);
    }
    markPotentiallyOrphaned(t, e) {
        return $70fd6868680e912c$var$Gr(t, e);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Un(t, e) {
        return function(t, e) {
            let n = !1;
            return $70fd6868680e912c$var$Nr(t).Y((s)=>$70fd6868680e912c$var$Dr(t, s, e).next((t)=>(t && (n = !0), $70fd6868680e912c$var$Pt.resolve(!t)))).next(()=>n);
        }(t, e);
    }
    removeOrphanedDocuments(t, e) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), s = [];
        let i = 0;
        return this.Ln(t, (r, o)=>{
            if (o <= e) {
                const e = this.Un(t, r).next((e)=>{
                    if (!e) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(t, r).next(()=>(n.removeEntry(r, $70fd6868680e912c$var$ct.min()), $70fd6868680e912c$var$$r(t).delete([
                            0,
                            $70fd6868680e912c$var$ci(r.path)
                        ])));
                });
                s.push(e);
            }
        }).next(()=>$70fd6868680e912c$var$Pt.waitFor(s)).next(()=>n.apply(t)).next(()=>i);
    }
    removeTarget(t, e) {
        const n = e.withSequenceNumber(t.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(t, n);
    }
    updateLimboDocument(t, e) {
        return $70fd6868680e912c$var$Gr(t, e);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Ln(t, e) {
        const n = $70fd6868680e912c$var$$r(t);
        let s, i = $70fd6868680e912c$var$$t.ot;
        return n.J({
            index: "documentTargetsIndex"
        }, ([t, n], { path: r, sequenceNumber: o })=>{
            0 === t ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $70fd6868680e912c$var$$t.ot && e(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$li(s)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, s = r) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $70fd6868680e912c$var$$t.ot;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $70fd6868680e912c$var$$t.ot && e(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$li(s)), i);
        });
    }
    getCacheSize(t) {
        return this.db.getRemoteDocumentCache().getSize(t);
    }
}
function $70fd6868680e912c$var$Gr(t, e) {
    return $70fd6868680e912c$var$$r(t).put(/**
 * @returns A value suitable for writing a sentinel row in the target-document
 * store.
 */ function(t, e) {
        return {
            targetId: 0,
            path: $70fd6868680e912c$var$ci(t.path),
            sequenceNumber: e
        };
    }(e, t.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $70fd6868680e912c$var$Qr {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $70fd6868680e912c$var$is((t)=>t.toString(), (t, e)=>t.isEqual(e)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(t) {
        this.assertNotApplied(), this.changes.set(t.key, t);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(t, e) {
        this.assertNotApplied(), this.changes.set(t, $70fd6868680e912c$var$xe.newInvalidDocument(t).setReadTime(e));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(t, e) {
        this.assertNotApplied();
        const n = this.changes.get(e);
        return void 0 !== n ? $70fd6868680e912c$var$Pt.resolve(n) : this.getFromCache(t, e);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(t, e) {
        return this.getAllFromCache(t, e);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(t) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$jr {
    constructor(t){
        this.wt = t;
    }
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(t, e, n) {
        return $70fd6868680e912c$var$Jr(t).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(t, e, n) {
        return $70fd6868680e912c$var$Jr(t).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function(t, e) {
            const n = t.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $70fd6868680e912c$var$Gi(e),
                /* document id */ n[n.length - 1]
            ];
        }(e, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(t, e) {
        return this.getMetadata(t).next((n)=>(n.byteSize += e, this.qn(t, n)));
    }
    getEntry(t, e) {
        let n = $70fd6868680e912c$var$xe.newInvalidDocument(e);
        return $70fd6868680e912c$var$Jr(t).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$Yr(e))
        }, (t, s)=>{
            n = this.Kn(e, s);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Gn(t, e) {
        let n = {
            size: 0,
            document: $70fd6868680e912c$var$xe.newInvalidDocument(e)
        };
        return $70fd6868680e912c$var$Jr(t).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$Yr(e))
        }, (t, s)=>{
            n = {
                document: this.Kn(e, s),
                size: $70fd6868680e912c$var$Vr(s)
            };
        }).next(()=>n);
    }
    getEntries(t, e) {
        let n = $70fd6868680e912c$var$os();
        return this.Qn(t, e, (t, e)=>{
            const s = this.Kn(t, e);
            n = n.insert(t, s);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ jn(t, e) {
        let n = $70fd6868680e912c$var$os(), s = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        return this.Qn(t, e, (t, e)=>{
            const i = this.Kn(t, e);
            n = n.insert(t, i), s = s.insert(t, $70fd6868680e912c$var$Vr(e));
        }).next(()=>({
                documents: n,
                Wn: s
            }));
    }
    Qn(t, e, n) {
        if (e.isEmpty()) return $70fd6868680e912c$var$Pt.resolve();
        let s = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$Zr);
        e.forEach((t)=>s = s.add(t));
        const i = IDBKeyRange.bound($70fd6868680e912c$var$Yr(s.first()), $70fd6868680e912c$var$Yr(s.last())), r = s.getIterator();
        let o = r.getNext();
        return $70fd6868680e912c$var$Jr(t).J({
            index: "documentKeyIndex",
            range: i
        }, (t, e, s)=>{
            const i = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments([
                ...e.prefixPath,
                e.collectionGroup,
                e.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $70fd6868680e912c$var$Zr(o, i) < 0;)n(o, null), o = r.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, e), o = r.hasNext() ? r.getNext() : null), // Skip to the next key (if there is one).
            o ? s.q($70fd6868680e912c$var$Yr(o)) : s.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = r.hasNext() ? r.getNext() : null;
        });
    }
    getAllFromCollection(t, e, n) {
        const s = [
            e.popLast().toArray(),
            e.lastSegment(),
            $70fd6868680e912c$var$Gi(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], i = [
            e.popLast().toArray(),
            e.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $70fd6868680e912c$var$Jr(t).K(IDBKeyRange.bound(s, i, !0)).next((t)=>{
            let e = $70fd6868680e912c$var$os();
            for (const n of t){
                const t = this.Kn($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(n.prefixPath.concat(n.collectionGroup, n.documentId)), n);
                e = e.insert(t.key, t);
            }
            return e;
        });
    }
    getAllFromCollectionGroup(t, e, n, s) {
        let i = $70fd6868680e912c$var$os();
        const r = $70fd6868680e912c$var$Xr(e, n), o = $70fd6868680e912c$var$Xr(e, $70fd6868680e912c$var$Tt.max());
        return $70fd6868680e912c$var$Jr(t).J({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(r, o, !0)
        }, (t, e, n)=>{
            const r = this.Kn($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.prefixPath.concat(e.collectionGroup, e.documentId)), e);
            i = i.insert(r.key, r), i.size === s && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(t) {
        return new $70fd6868680e912c$var$zr(this, !!t && t.trackRemovals);
    }
    getSize(t) {
        return this.getMetadata(t).next((t)=>t.byteSize);
    }
    getMetadata(t) {
        return $70fd6868680e912c$var$Hr(t).get("remoteDocumentGlobalKey").next((t)=>($70fd6868680e912c$var$U(!!t), t));
    }
    qn(t, e) {
        return $70fd6868680e912c$var$Hr(t).put("remoteDocumentGlobalKey", e);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Kn(t, e) {
        if (e) {
            const t = $70fd6868680e912c$var$qi(this.wt, e);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(t.isNoDocument() && t.version.isEqual($70fd6868680e912c$var$ct.min()))) return t;
        }
        return $70fd6868680e912c$var$xe.newInvalidDocument(t);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $70fd6868680e912c$var$Wr(t) {
    return new $70fd6868680e912c$var$jr(t);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $70fd6868680e912c$var$zr extends $70fd6868680e912c$var$Qr {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(t, e){
        super(), this.zn = t, this.trackRemovals = e, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Hn = new $70fd6868680e912c$var$is((t)=>t.toString(), (t, e)=>t.isEqual(e));
    }
    applyChanges(t) {
        const e = [];
        let n = 0, s = new $70fd6868680e912c$var$Qt((t, e)=>$70fd6868680e912c$var$it(t.canonicalString(), e.canonicalString()));
        return this.changes.forEach((i, r)=>{
            const o = this.Hn.get(i);
            if (e.push(this.zn.removeEntry(t, i, o.readTime)), r.isValidDocument()) {
                const u = $70fd6868680e912c$var$Ki(this.zn.wt, r);
                s = s.add(i.path.popLast());
                const c = $70fd6868680e912c$var$Vr(u);
                n += c - o.size, e.push(this.zn.addEntry(t, i, u));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $70fd6868680e912c$var$Ki(this.zn.wt, r.convertToNoDocument($70fd6868680e912c$var$ct.min()));
                e.push(this.zn.addEntry(t, i, n));
            }
        }), s.forEach((n)=>{
            e.push(this.zn.indexManager.addToCollectionParentIndex(t, n));
        }), e.push(this.zn.updateMetadata(t, n)), $70fd6868680e912c$var$Pt.waitFor(e);
    }
    getFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.zn.Gn(t, e).next((t)=>(this.Hn.set(e, {
                size: t.size,
                readTime: t.document.readTime
            }), t.document));
    }
    getAllFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.zn.jn(t, e).next(({ documents: t, Wn: e })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (e.forEach((e, n)=>{
                this.Hn.set(e, {
                    size: n,
                    readTime: t.get(e).readTime
                });
            }), t));
    }
}
function $70fd6868680e912c$var$Hr(t) {
    return $70fd6868680e912c$var$Mi(t, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $70fd6868680e912c$var$Jr(t) {
    return $70fd6868680e912c$var$Mi(t, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $70fd6868680e912c$var$Yr(t) {
    const e = t.path.toArray();
    return [
        /* prefix path */ e.slice(0, e.length - 2),
        /* collection id */ e[e.length - 2],
        /* document id */ e[e.length - 1]
    ];
}
function $70fd6868680e912c$var$Xr(t, e) {
    const n = e.documentKey.path.toArray();
    return [
        /* collection id */ t,
        $70fd6868680e912c$var$Gi(e.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$Zr(t, e) {
    const n = t.path.toArray(), s = e.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let t = 0; t < n.length - 2 && t < s.length - 2; ++t)if (i = $70fd6868680e912c$var$it(n[t], s[t]), i) return i;
    return i = $70fd6868680e912c$var$it(n.length, s.length), i || (i = $70fd6868680e912c$var$it(n[n.length - 2], s[s.length - 2]), i || $70fd6868680e912c$var$it(n[n.length - 1], s[s.length - 1]));
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $70fd6868680e912c$var$to {
    constructor(t, /**
     * The fields that are locally mutated by patch mutations. If the overlayed
     * document is from set or delete mutations, this returns null.
     */ e){
        this.overlayedDocument = t, this.mutatedFields = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $70fd6868680e912c$var$eo {
    constructor(t, e, n, s){
        this.remoteDocumentCache = t, this.mutationQueue = e, this.documentOverlayCache = n, this.indexManager = s;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(t, e) {
        let n = null;
        return this.documentOverlayCache.getOverlay(t, e).next((s)=>(n = s, this.getBaseDocument(t, e, n))).next((t)=>(null !== n && $70fd6868680e912c$var$Kn(n.mutation, t, $70fd6868680e912c$var$zt.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), t));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.getLocalViewOfDocuments(t, e, $70fd6868680e912c$var$ws()).next(()=>e));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(t, e, n = $70fd6868680e912c$var$ws()) {
        const s = $70fd6868680e912c$var$hs();
        return this.populateOverlays(t, s, e).next(()=>this.computeViews(t, e, s, n).next((t)=>{
                let e = $70fd6868680e912c$var$cs();
                return t.forEach((t, n)=>{
                    e = e.insert(t, n.overlayedDocument);
                }), e;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(t, e) {
        const n = $70fd6868680e912c$var$hs();
        return this.populateOverlays(t, n, e).next(()=>this.computeViews(t, e, n, $70fd6868680e912c$var$ws()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(t, e, n) {
        const s = [];
        return n.forEach((t)=>{
            e.has(t) || s.push(t);
        }), this.documentOverlayCache.getOverlays(t, s).next((t)=>{
            t.forEach((t, n)=>{
                e.set(t, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(t, e, n, s) {
        let i = $70fd6868680e912c$var$os();
        const r = $70fd6868680e912c$var$fs(), o = $70fd6868680e912c$var$fs();
        return e.forEach((t, e)=>{
            const o = n.get(e.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            s.has(e.key) && (void 0 === o || o.mutation instanceof $70fd6868680e912c$var$Wn) ? i = i.insert(e.key, e) : void 0 !== o && (r.set(e.key, o.mutation.getFieldMask()), $70fd6868680e912c$var$Kn(o.mutation, e, o.mutation.getFieldMask(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()));
        }), this.recalculateAndSaveOverlays(t, i).next((t)=>(t.forEach((t, e)=>r.set(t, e)), e.forEach((t, e)=>{
                var n;
                return o.set(t, new $70fd6868680e912c$var$to(e, null !== (n = r.get(t)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(t, e) {
        const n = $70fd6868680e912c$var$fs();
        // A reverse lookup map from batch id to the documents within that batch.
        let s = new $70fd6868680e912c$var$qt((t, e)=>t - e), i = $70fd6868680e912c$var$ws();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(t, e).next((t)=>{
            for (const i of t)i.keys().forEach((t)=>{
                const r = e.get(t);
                if (null === r) return;
                let o = n.get(t) || $70fd6868680e912c$var$zt.empty();
                o = i.applyToLocalView(r, o), n.set(t, o);
                const u = (s.get(i.batchId) || $70fd6868680e912c$var$ws()).add(t);
                s = s.insert(i.batchId, u);
            });
        }).next(()=>{
            const r = [], o = s.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const s = o.getNext(), u = s.key, c = s.value, a = $70fd6868680e912c$var$ls();
                c.forEach((t)=>{
                    if (!i.has(t)) {
                        const s = $70fd6868680e912c$var$Un(e.get(t), n.get(t));
                        null !== s && a.set(t, s), i = i.add(t);
                    }
                }), r.push(this.documentOverlayCache.saveOverlays(t, u, a));
            }
            return $70fd6868680e912c$var$Pt.waitFor(r);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.recalculateAndSaveOverlays(t, e));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     */ getDocumentsMatchingQuery(t, e, n) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function(t) {
            return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
        }(e) ? this.getDocumentsMatchingDocumentQuery(t, e.path) : $70fd6868680e912c$var$an(e) ? this.getDocumentsMatchingCollectionGroupQuery(t, e, n) : this.getDocumentsMatchingCollectionQuery(t, e, n);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(t, e, n, s) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(t, e, n, s).next((i)=>{
            const r = s - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(t, e, n.largestBatchId, s - i.size) : $70fd6868680e912c$var$Pt.resolve($70fd6868680e912c$var$hs());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, u = i;
            return r.next((e)=>$70fd6868680e912c$var$Pt.forEach(e, (e, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(e) ? $70fd6868680e912c$var$Pt.resolve() : this.getBaseDocument(t, e, n).next((t)=>{
                        u = u.insert(e, t);
                    }))).next(()=>this.populateOverlays(t, e, i)).next(()=>this.computeViews(t, u, e, $70fd6868680e912c$var$ws())).next((t)=>({
                        batchId: o,
                        changes: $70fd6868680e912c$var$as(t)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(t, e) {
        // Just do a simple document lookup.
        return this.getDocument(t, new $70fd6868680e912c$export$afc2e57c475b7810(e)).next((t)=>{
            let e = $70fd6868680e912c$var$cs();
            return t.isFoundDocument() && (e = e.insert(t.key, t)), e;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(t, e, n) {
        const s = e.collectionGroup;
        let i = $70fd6868680e912c$var$cs();
        return this.indexManager.getCollectionParents(t, s).next((r)=>$70fd6868680e912c$var$Pt.forEach(r, (r)=>{
                const o = function(t, e) {
                    return new $70fd6868680e912c$var$nn(e, /*collectionGroup=*/ null, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
                }(e, r.child(s));
                return this.getDocumentsMatchingCollectionQuery(t, o, n).next((t)=>{
                    t.forEach((t, e)=>{
                        i = i.insert(t, e);
                    });
                });
            }).next(()=>i));
    }
    getDocumentsMatchingCollectionQuery(t, e, n) {
        // Query the remote documents and overlay mutations.
        let s;
        return this.remoteDocumentCache.getAllFromCollection(t, e.path, n).next((i)=>(s = i, this.documentOverlayCache.getOverlaysForCollection(t, e.path, n.largestBatchId))).next((t)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            t.forEach((t, e)=>{
                const n = e.getKey();
                null === s.get(n) && (s = s.insert(n, $70fd6868680e912c$var$xe.newInvalidDocument(n)));
            });
            // Apply the overlays and match against the query.
            let n = $70fd6868680e912c$var$cs();
            return s.forEach((s, i)=>{
                const r = t.get(s);
                void 0 !== r && $70fd6868680e912c$var$Kn(r.mutation, i, $70fd6868680e912c$var$zt.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $70fd6868680e912c$var$mn(e, i) && (n = n.insert(s, i));
            }), n;
        });
    }
    /** Returns a base document that can be used to apply `overlay`. */ getBaseDocument(t, e, n) {
        return null === n || 1 /* Patch */  === n.mutation.type ? this.remoteDocumentCache.getEntry(t, e) : $70fd6868680e912c$var$Pt.resolve($70fd6868680e912c$var$xe.newInvalidDocument(e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$no {
    constructor(t){
        this.wt = t, this.Jn = new Map, this.Yn = new Map;
    }
    getBundleMetadata(t, e) {
        return $70fd6868680e912c$var$Pt.resolve(this.Jn.get(e));
    }
    saveBundleMetadata(t, e) {
        /** Decodes a BundleMetadata proto into a BundleMetadata object. */ var n;
        return this.Jn.set(e.id, {
            id: (n = e).id,
            version: n.version,
            createTime: $70fd6868680e912c$var$Ns(n.createTime)
        }), $70fd6868680e912c$var$Pt.resolve();
    }
    getNamedQuery(t, e) {
        return $70fd6868680e912c$var$Pt.resolve(this.Yn.get(e));
    }
    saveNamedQuery(t, e) {
        return this.Yn.set(e.name, function(t) {
            return {
                name: t.name,
                query: $70fd6868680e912c$var$Ji(t.bundledQuery),
                readTime: $70fd6868680e912c$var$Ns(t.readTime)
            };
        }(e)), $70fd6868680e912c$var$Pt.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $70fd6868680e912c$var$so {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator), this.Xn = new Map;
    }
    getOverlay(t, e) {
        return $70fd6868680e912c$var$Pt.resolve(this.overlays.get(e));
    }
    getOverlays(t, e) {
        const n = $70fd6868680e912c$var$hs();
        return $70fd6868680e912c$var$Pt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        return n.forEach((n, s)=>{
            this.ie(t, e, s);
        }), $70fd6868680e912c$var$Pt.resolve();
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = this.Xn.get(n);
        return void 0 !== s && (s.forEach((t)=>this.overlays = this.overlays.remove(t)), this.Xn.delete(n)), $70fd6868680e912c$var$Pt.resolve();
    }
    getOverlaysForCollection(t, e, n) {
        const s = $70fd6868680e912c$var$hs(), i = e.length + 1, r = new $70fd6868680e912c$export$afc2e57c475b7810(e.child("")), o = this.overlays.getIteratorFrom(r);
        for(; o.hasNext();){
            const t = o.getNext().value, r = t.getKey();
            if (!e.isPrefixOf(r.path)) break;
            // Documents from sub-collections
            r.path.length === i && t.largestBatchId > n && s.set(t.getKey(), t);
        }
        return $70fd6868680e912c$var$Pt.resolve(s);
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        let i = new $70fd6868680e912c$var$qt((t, e)=>t - e);
        const r = this.overlays.getIterator();
        for(; r.hasNext();){
            const t = r.getNext().value;
            if (t.getKey().getCollectionGroup() === e && t.largestBatchId > n) {
                let e = i.get(t.largestBatchId);
                null === e && (e = $70fd6868680e912c$var$hs(), i = i.insert(t.largestBatchId, e)), e.set(t.getKey(), t);
            }
        }
        const o = $70fd6868680e912c$var$hs(), u = i.getIterator();
        for(; u.hasNext();){
            if (u.getNext().value.forEach((t, e)=>o.set(t, e)), o.size() >= s) break;
        }
        return $70fd6868680e912c$var$Pt.resolve(o);
    }
    ie(t, e, n) {
        // Remove the association of the overlay to its batch id.
        const s = this.overlays.get(n.key);
        if (null !== s) {
            const t = this.Xn.get(s.largestBatchId).delete(n.key);
            this.Xn.set(s.largestBatchId, t);
        }
        this.overlays = this.overlays.insert(n.key, new $70fd6868680e912c$var$Bi(e, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Xn.get(e);
        void 0 === i && (i = $70fd6868680e912c$var$ws(), this.Xn.set(e, i)), this.Xn.set(e, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $70fd6868680e912c$var$io {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Zn = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$ro.ts), // A set of outstanding references to a document sorted by target id.
        this.es = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$ro.ns);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Zn.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(t, e) {
        const n = new $70fd6868680e912c$var$ro(t, e);
        this.Zn = this.Zn.add(n), this.es = this.es.add(n);
    }
    /** Add references to the given document keys for the given ID. */ ss(t, e) {
        t.forEach((t)=>this.addReference(t, e));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(t, e) {
        this.rs(new $70fd6868680e912c$var$ro(t, e));
    }
    os(t, e) {
        t.forEach((t)=>this.removeReference(t, e));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ us(t) {
        const e = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ht([])), n = new $70fd6868680e912c$var$ro(e, t), s = new $70fd6868680e912c$var$ro(e, t + 1), i = [];
        return this.es.forEachInRange([
            n,
            s
        ], (t)=>{
            this.rs(t), i.push(t.key);
        }), i;
    }
    cs() {
        this.Zn.forEach((t)=>this.rs(t));
    }
    rs(t) {
        this.Zn = this.Zn.delete(t), this.es = this.es.delete(t);
    }
    hs(t) {
        const e = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ht([])), n = new $70fd6868680e912c$var$ro(e, t), s = new $70fd6868680e912c$var$ro(e, t + 1);
        let i = $70fd6868680e912c$var$ws();
        return this.es.forEachInRange([
            n,
            s
        ], (t)=>{
            i = i.add(t.key);
        }), i;
    }
    containsKey(t) {
        const e = new $70fd6868680e912c$var$ro(t, 0), n = this.Zn.firstAfterOrEqual(e);
        return null !== n && t.isEqual(n.key);
    }
}
class $70fd6868680e912c$var$ro {
    constructor(t, e){
        this.key = t, this.ls = e;
    }
    /** Compare by key then by ID */ static ts(t, e) {
        return $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key) || $70fd6868680e912c$var$it(t.ls, e.ls);
    }
    /** Compare by ID then by key */ static ns(t, e) {
        return $70fd6868680e912c$var$it(t.ls, e.ls) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$oo {
    constructor(t, e){
        this.indexManager = t, this.referenceDelegate = e, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.fs = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.ds = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$ro.ts);
    }
    checkEmpty(t) {
        return $70fd6868680e912c$var$Pt.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(t, e, n, s) {
        const i = this.fs;
        this.fs++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const r = new $70fd6868680e912c$var$Fi(i, e, n, s);
        this.mutationQueue.push(r);
        // Track references by document key and index collection parents.
        for (const e of s)this.ds = this.ds.add(new $70fd6868680e912c$var$ro(e.key, i)), this.indexManager.addToCollectionParentIndex(t, e.key.path.popLast());
        return $70fd6868680e912c$var$Pt.resolve(r);
    }
    lookupMutationBatch(t, e) {
        return $70fd6868680e912c$var$Pt.resolve(this._s(e));
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = this.ws(n), i = s < 0 ? 0 : s;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $70fd6868680e912c$var$Pt.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $70fd6868680e912c$var$Pt.resolve(0 === this.mutationQueue.length ? -1 : this.fs - 1);
    }
    getAllMutationBatches(t) {
        return $70fd6868680e912c$var$Pt.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        const n = new $70fd6868680e912c$var$ro(e, 0), s = new $70fd6868680e912c$var$ro(e, Number.POSITIVE_INFINITY), i = [];
        return this.ds.forEachInRange([
            n,
            s
        ], (t)=>{
            const e = this._s(t.ls);
            i.push(e);
        }), $70fd6868680e912c$var$Pt.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it);
        return e.forEach((t)=>{
            const e = new $70fd6868680e912c$var$ro(t, 0), s = new $70fd6868680e912c$var$ro(t, Number.POSITIVE_INFINITY);
            this.ds.forEachInRange([
                e,
                s
            ], (t)=>{
                n = n.add(t.ls);
            });
        }), $70fd6868680e912c$var$Pt.resolve(this.gs(n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = e.path, s = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const r = new $70fd6868680e912c$var$ro(new $70fd6868680e912c$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it);
        return this.ds.forEachWhile((t)=>{
            const e = t.key.path;
            return !!n.isPrefixOf(e) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (e.length === s && (o = o.add(t.ls)), !0);
        }, r), $70fd6868680e912c$var$Pt.resolve(this.gs(o));
    }
    gs(t) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const e = [];
        return t.forEach((t)=>{
            const n = this._s(t);
            null !== n && e.push(n);
        }), e;
    }
    removeMutationBatch(t, e) {
        $70fd6868680e912c$var$U(0 === this.ys(e.batchId, "removed")), this.mutationQueue.shift();
        let n = this.ds;
        return $70fd6868680e912c$var$Pt.forEach(e.mutations, (s)=>{
            const i = new $70fd6868680e912c$var$ro(s.key, e.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(t, s.key);
        }).next(()=>{
            this.ds = n;
        });
    }
    In(t) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(t, e) {
        const n = new $70fd6868680e912c$var$ro(e, 0), s = this.ds.firstAfterOrEqual(n);
        return $70fd6868680e912c$var$Pt.resolve(e.isEqual(s && s.key));
    }
    performConsistencyCheck(t) {
        return this.mutationQueue.length, $70fd6868680e912c$var$Pt.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ys(t, e) {
        return this.ws(t);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ ws(t) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return t - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ _s(t) {
        const e = this.ws(t);
        if (e < 0 || e >= this.mutationQueue.length) return null;
        return this.mutationQueue[e];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$uo {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(t){
        this.ps = t, /** Underlying cache of documents and their read times. */ this.docs = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(t, e) {
        const n = e.key, s = this.docs.get(n), i = s ? s.size : 0, r = this.ps(e);
        return this.docs = this.docs.insert(n, {
            document: e.mutableCopy(),
            size: r
        }), this.size += r - i, this.indexManager.addToCollectionParentIndex(t, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(t) {
        const e = this.docs.get(t);
        e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }
    getEntry(t, e) {
        const n = this.docs.get(e);
        return $70fd6868680e912c$var$Pt.resolve(n ? n.document.mutableCopy() : $70fd6868680e912c$var$xe.newInvalidDocument(e));
    }
    getEntries(t, e) {
        let n = $70fd6868680e912c$var$os();
        return e.forEach((t)=>{
            const e = this.docs.get(t);
            n = n.insert(t, e ? e.document.mutableCopy() : $70fd6868680e912c$var$xe.newInvalidDocument(t));
        }), $70fd6868680e912c$var$Pt.resolve(n);
    }
    getAllFromCollection(t, e, n) {
        let s = $70fd6868680e912c$var$os();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const i = new $70fd6868680e912c$export$afc2e57c475b7810(e.child("")), r = this.docs.getIteratorFrom(i);
        for(; r.hasNext();){
            const { key: t, value: { document: i } } = r.getNext();
            if (!e.isPrefixOf(t.path)) break;
            t.path.length > e.length + 1 || $70fd6868680e912c$var$Et($70fd6868680e912c$var$It(i), n) <= 0 || (s = s.insert(i.key, i.mutableCopy()));
        }
        return $70fd6868680e912c$var$Pt.resolve(s);
    }
    getAllFromCollectionGroup(t, e, n, s) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $70fd6868680e912c$var$L();
    }
    Is(t, e) {
        return $70fd6868680e912c$var$Pt.forEach(this.docs, (t)=>e(t));
    }
    newChangeBuffer(t) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $70fd6868680e912c$var$co(this);
    }
    getSize(t) {
        return $70fd6868680e912c$var$Pt.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $70fd6868680e912c$var$co extends $70fd6868680e912c$var$Qr {
    constructor(t){
        super(), this.zn = t;
    }
    applyChanges(t) {
        const e = [];
        return this.changes.forEach((n, s)=>{
            s.isValidDocument() ? e.push(this.zn.addEntry(t, s)) : this.zn.removeEntry(n);
        }), $70fd6868680e912c$var$Pt.waitFor(e);
    }
    getFromCache(t, e) {
        return this.zn.getEntry(t, e);
    }
    getAllFromCache(t, e) {
        return this.zn.getEntries(t, e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ao {
    constructor(t){
        this.persistence = t, /**
         * Maps a target to the data about that target
         */ this.Ts = new $70fd6868680e912c$var$is((t)=>$70fd6868680e912c$var$Oe(t), $70fd6868680e912c$var$Fe), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $70fd6868680e912c$var$ct.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Es = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.As = new $70fd6868680e912c$var$io, this.targetCount = 0, this.Rs = $70fd6868680e912c$var$kr.An();
    }
    forEachTarget(t, e) {
        return this.Ts.forEach((t, n)=>e(n)), $70fd6868680e912c$var$Pt.resolve();
    }
    getLastRemoteSnapshotVersion(t) {
        return $70fd6868680e912c$var$Pt.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(t) {
        return $70fd6868680e912c$var$Pt.resolve(this.Es);
    }
    allocateTargetId(t) {
        return this.highestTargetId = this.Rs.next(), $70fd6868680e912c$var$Pt.resolve(this.highestTargetId);
    }
    setTargetsMetadata(t, e, n) {
        return n && (this.lastRemoteSnapshotVersion = n), e > this.Es && (this.Es = e), $70fd6868680e912c$var$Pt.resolve();
    }
    vn(t) {
        this.Ts.set(t.target, t);
        const e = t.targetId;
        e > this.highestTargetId && (this.Rs = new $70fd6868680e912c$var$kr(e), this.highestTargetId = e), t.sequenceNumber > this.Es && (this.Es = t.sequenceNumber);
    }
    addTargetData(t, e) {
        return this.vn(e), this.targetCount += 1, $70fd6868680e912c$var$Pt.resolve();
    }
    updateTargetData(t, e) {
        return this.vn(e), $70fd6868680e912c$var$Pt.resolve();
    }
    removeTargetData(t, e) {
        return this.Ts.delete(e.target), this.As.us(e.targetId), this.targetCount -= 1, $70fd6868680e912c$var$Pt.resolve();
    }
    removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return this.Ts.forEach((r, o)=>{
            o.sequenceNumber <= e && null === n.get(o.targetId) && (this.Ts.delete(r), i.push(this.removeMatchingKeysForTargetId(t, o.targetId)), s++);
        }), $70fd6868680e912c$var$Pt.waitFor(i).next(()=>s);
    }
    getTargetCount(t) {
        return $70fd6868680e912c$var$Pt.resolve(this.targetCount);
    }
    getTargetData(t, e) {
        const n = this.Ts.get(e) || null;
        return $70fd6868680e912c$var$Pt.resolve(n);
    }
    addMatchingKeys(t, e, n) {
        return this.As.ss(e, n), $70fd6868680e912c$var$Pt.resolve();
    }
    removeMatchingKeys(t, e, n) {
        this.As.os(e, n);
        const s = this.persistence.referenceDelegate, i = [];
        return s && e.forEach((e)=>{
            i.push(s.markPotentiallyOrphaned(t, e));
        }), $70fd6868680e912c$var$Pt.waitFor(i);
    }
    removeMatchingKeysForTargetId(t, e) {
        return this.As.us(e), $70fd6868680e912c$var$Pt.resolve();
    }
    getMatchingKeysForTargetId(t, e) {
        const n = this.As.hs(e);
        return $70fd6868680e912c$var$Pt.resolve(n);
    }
    containsKey(t, e) {
        return $70fd6868680e912c$var$Pt.resolve(this.As.containsKey(e));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $70fd6868680e912c$var$ho {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(t, e){
        this.bs = {}, this.overlays = {}, this.Ps = new $70fd6868680e912c$var$$t(0), this.vs = !1, this.vs = !0, this.referenceDelegate = t(this), this.Vs = new $70fd6868680e912c$var$ao(this);
        this.indexManager = new $70fd6868680e912c$var$mr, this.remoteDocumentCache = function(t) {
            return new $70fd6868680e912c$var$uo(t);
        }((t)=>this.referenceDelegate.Ss(t)), this.wt = new $70fd6868680e912c$var$Ui(e), this.Ds = new $70fd6868680e912c$var$no(this.wt);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.vs = !1, Promise.resolve();
    }
    get started() {
        return this.vs;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(t) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(t) {
        let e = this.overlays[t.toKey()];
        return e || (e = new $70fd6868680e912c$var$so, this.overlays[t.toKey()] = e), e;
    }
    getMutationQueue(t, e) {
        let n = this.bs[t.toKey()];
        return n || (n = new $70fd6868680e912c$var$oo(e, this.referenceDelegate), this.bs[t.toKey()] = n), n;
    }
    getTargetCache() {
        return this.Vs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Ds;
    }
    runTransaction(t, e, n) {
        $70fd6868680e912c$var$M("MemoryPersistence", "Starting transaction:", t);
        const s = new $70fd6868680e912c$var$lo(this.Ps.next());
        return this.referenceDelegate.Cs(), n(s).next((t)=>this.referenceDelegate.xs(s).next(()=>t)).toPromise().then((t)=>(s.raiseOnCommittedEvent(), t));
    }
    Ns(t, e) {
        return $70fd6868680e912c$var$Pt.or(Object.values(this.bs).map((n)=>()=>n.containsKey(t, e)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $70fd6868680e912c$var$lo extends $70fd6868680e912c$var$Rt {
    constructor(t){
        super(), this.currentSequenceNumber = t;
    }
}
class $70fd6868680e912c$var$fo {
    constructor(t){
        this.persistence = t, /** Tracks all documents that are active in Query views. */ this.ks = new $70fd6868680e912c$var$io, /** The list of documents that are potentially GCed after each transaction. */ this.Os = null;
    }
    static Ms(t) {
        return new $70fd6868680e912c$var$fo(t);
    }
    get Fs() {
        if (this.Os) return this.Os;
        throw $70fd6868680e912c$var$L();
    }
    addReference(t, e, n) {
        return this.ks.addReference(n, e), this.Fs.delete(n.toString()), $70fd6868680e912c$var$Pt.resolve();
    }
    removeReference(t, e, n) {
        return this.ks.removeReference(n, e), this.Fs.add(n.toString()), $70fd6868680e912c$var$Pt.resolve();
    }
    markPotentiallyOrphaned(t, e) {
        return this.Fs.add(e.toString()), $70fd6868680e912c$var$Pt.resolve();
    }
    removeTarget(t, e) {
        this.ks.us(e.targetId).forEach((t)=>this.Fs.add(t.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
            t.forEach((t)=>this.Fs.add(t.toString()));
        }).next(()=>n.removeTargetData(t, e));
    }
    Cs() {
        this.Os = new Set;
    }
    xs(t) {
        // Remove newly orphaned documents.
        const e = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $70fd6868680e912c$var$Pt.forEach(this.Fs, (n)=>{
            const s = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(n);
            return this.$s(t, s).next((t)=>{
                t || e.removeEntry(s, $70fd6868680e912c$var$ct.min());
            });
        }).next(()=>(this.Os = null, e.apply(t)));
    }
    updateLimboDocument(t, e) {
        return this.$s(t, e).next((t)=>{
            t ? this.Fs.delete(e.toString()) : this.Fs.add(e.toString());
        });
    }
    Ss(t) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    $s(t, e) {
        return $70fd6868680e912c$var$Pt.or([
            ()=>$70fd6868680e912c$var$Pt.resolve(this.ks.containsKey(e)),
            ()=>this.persistence.getTargetCache().containsKey(t, e),
            ()=>this.persistence.Ns(t, e)
        ]);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $70fd6868680e912c$var$_o {
    constructor(t){
        this.wt = t;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ O(t, e, n, s) {
        const i = new $70fd6868680e912c$var$vt("createOrUpgrade", e);
        n < 1 && s >= 1 && (function(t) {
            t.createObjectStore("owner");
        }(t), function(t) {
            t.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            t.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $70fd6868680e912c$var$fi, {
                unique: !0
            }), t.createObjectStore("documentMutations");
        }(t), $70fd6868680e912c$var$wo(t), function(t) {
            t.createObjectStore("remoteDocuments");
        }(t));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let r = $70fd6868680e912c$var$Pt.resolve();
        return n < 3 && s >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function(t) {
            t.deleteObjectStore("targetDocuments"), t.deleteObjectStore("targets"), t.deleteObjectStore("targetGlobal");
        }(t), $70fd6868680e912c$var$wo(t)), r = r.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function(t) {
                const e = t.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $70fd6868680e912c$var$ct.min().toTimestamp(),
                    targetCount: 0
                };
                return e.put("targetGlobalKey", n);
            })(i))), n < 4 && s >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (r = r.next(()=>(function(t, e) {
                return e.store("mutations").K().next((n)=>{
                    t.deleteObjectStore("mutations");
                    t.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $70fd6868680e912c$var$fi, {
                        unique: !0
                    });
                    const s = e.store("mutations"), i = n.map((t)=>s.put(t));
                    return $70fd6868680e912c$var$Pt.waitFor(i);
                });
            })(t, i))), r = r.next(()=>{
            !function(t) {
                t.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(t);
        })), n < 5 && s >= 5 && (r = r.next(()=>this.Bs(i))), n < 6 && s >= 6 && (r = r.next(()=>((function(t) {
                t.createObjectStore("remoteDocumentGlobal");
            })(t), this.Ls(i)))), n < 7 && s >= 7 && (r = r.next(()=>this.Us(i))), n < 8 && s >= 8 && (r = r.next(()=>this.qs(t, i))), n < 9 && s >= 9 && (r = r.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function(t) {
                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
            }(t);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && s >= 10 && (r = r.next(()=>this.Ks(i))), n < 11 && s >= 11 && (r = r.next(()=>{
            !function(t) {
                t.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(t), function(t) {
                t.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(t);
        })), n < 12 && s >= 12 && (r = r.next(()=>{
            !function(t) {
                const e = t.createObjectStore("documentOverlays", {
                    keyPath: $70fd6868680e912c$var$vi
                });
                e.createIndex("collectionPathOverlayIndex", $70fd6868680e912c$var$Vi, {
                    unique: !1
                }), e.createIndex("collectionGroupOverlayIndex", $70fd6868680e912c$var$Si, {
                    unique: !1
                });
            }(t);
        })), n < 13 && s >= 13 && (r = r.next(()=>(function(t) {
                const e = t.createObjectStore("remoteDocumentsV14", {
                    keyPath: $70fd6868680e912c$var$mi
                });
                e.createIndex("documentKeyIndex", $70fd6868680e912c$var$gi), e.createIndex("collectionGroupIndex", $70fd6868680e912c$var$yi);
            })(t)).next(()=>this.Gs(t, i)).next(()=>t.deleteObjectStore("remoteDocuments"))), n < 14 && s >= 14 && (r = r.next(()=>this.Qs(t, i))), n < 15 && s >= 15 && (r = r.next(()=>(function(t) {
                t.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                t.createObjectStore("indexState", {
                    keyPath: $70fd6868680e912c$var$Ai
                }).createIndex("sequenceNumberIndex", $70fd6868680e912c$var$Ri, {
                    unique: !1
                });
                t.createObjectStore("indexEntries", {
                    keyPath: $70fd6868680e912c$var$bi
                }).createIndex("documentKeyIndex", $70fd6868680e912c$var$Pi, {
                    unique: !1
                });
            })(t))), r;
    }
    Ls(t) {
        let e = 0;
        return t.store("remoteDocuments").J((t, n)=>{
            e += $70fd6868680e912c$var$Vr(n);
        }).next(()=>{
            const n = {
                byteSize: e
            };
            return t.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    Bs(t) {
        const e = t.store("mutationQueues"), n = t.store("mutations");
        return e.K().next((e)=>$70fd6868680e912c$var$Pt.forEach(e, (e)=>{
                const s = IDBKeyRange.bound([
                    e.userId,
                    -1
                ], [
                    e.userId,
                    e.lastAcknowledgedBatchId
                ]);
                return n.K("userMutationsIndex", s).next((n)=>$70fd6868680e912c$var$Pt.forEach(n, (n)=>{
                        $70fd6868680e912c$var$U(n.userId === e.userId);
                        const s = $70fd6868680e912c$var$Wi(this.wt, n);
                        return $70fd6868680e912c$var$vr(t, e.userId, s).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ Us(t) {
        const e = t.store("targetDocuments"), n = t.store("remoteDocuments");
        return t.store("targetGlobal").get("targetGlobalKey").next((t)=>{
            const s = [];
            return n.J((n, i)=>{
                const r = new $70fd6868680e912c$var$ht(n), o = function(t) {
                    return [
                        0,
                        $70fd6868680e912c$var$ci(t)
                    ];
                }(r);
                s.push(e.get(o).next((n)=>n ? $70fd6868680e912c$var$Pt.resolve() : ((n)=>e.put({
                            targetId: 0,
                            path: $70fd6868680e912c$var$ci(n),
                            sequenceNumber: t.highestListenSequenceNumber
                        }))(r)));
            }).next(()=>$70fd6868680e912c$var$Pt.waitFor(s));
        });
    }
    qs(t, e) {
        // Create the index.
        t.createObjectStore("collectionParents", {
            keyPath: $70fd6868680e912c$var$Ei
        });
        const n = e.store("collectionParents"), s = new $70fd6868680e912c$var$gr, i = (t)=>{
            if (s.add(t)) {
                const e = t.lastSegment(), s = t.popLast();
                return n.put({
                    collectionId: e,
                    parent: $70fd6868680e912c$var$ci(s)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return e.store("remoteDocuments").J({
            H: !0
        }, (t, e)=>{
            const n = new $70fd6868680e912c$var$ht(t);
            return i(n.popLast());
        }).next(()=>e.store("documentMutations").J({
                H: !0
            }, ([t, e, n], s)=>{
                const r = $70fd6868680e912c$var$li(e);
                return i(r.popLast());
            }));
    }
    Ks(t) {
        const e = t.store("targets");
        return e.J((t, n)=>{
            const s = $70fd6868680e912c$var$zi(n), i = $70fd6868680e912c$var$Hi(this.wt, s);
            return e.put(i);
        });
    }
    Gs(t, e) {
        const n = e.store("remoteDocuments"), s = [];
        return n.J((t, n)=>{
            const i = e.store("remoteDocumentsV14"), r = (o = n, o.document ? new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ht.fromString(o.document.name).popFirst(5)) : o.noDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(o.noDocument.path) : o.unknownDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(o.unknownDocument.path) : $70fd6868680e912c$var$L()).path.toArray();
            var o;
            /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const u = {
                prefixPath: r.slice(0, r.length - 2),
                collectionGroup: r[r.length - 2],
                documentId: r[r.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            s.push(i.put(u));
        }).next(()=>$70fd6868680e912c$var$Pt.waitFor(s));
    }
    Qs(t, e) {
        const n = e.store("mutations"), s = $70fd6868680e912c$var$Wr(this.wt), i = new $70fd6868680e912c$var$ho($70fd6868680e912c$var$fo.Ms, this.wt.ne);
        return n.K().next((t)=>{
            const n = new Map;
            return t.forEach((t)=>{
                var e;
                let s = null !== (e = n.get(t.userId)) && void 0 !== e ? e : $70fd6868680e912c$var$ws();
                $70fd6868680e912c$var$Wi(this.wt, t).keys().forEach((t)=>s = s.add(t)), n.set(t.userId, s);
            }), $70fd6868680e912c$var$Pt.forEach(n, (t, n)=>{
                const r = new $70fd6868680e912c$var$C(n), o = $70fd6868680e912c$var$sr.se(this.wt, r), u = i.getIndexManager(r), c = $70fd6868680e912c$var$Sr.se(r, this.wt, u, i.referenceDelegate);
                return new $70fd6868680e912c$var$eo(s, c, o, u).recalculateAndSaveOverlaysForDocumentKeys(new $70fd6868680e912c$var$Oi(e, $70fd6868680e912c$var$$t.ot), t).next();
            });
        });
    }
}
function $70fd6868680e912c$var$wo(t) {
    t.createObjectStore("targetDocuments", {
        keyPath: $70fd6868680e912c$var$Ii
    }).createIndex("documentTargetsIndex", $70fd6868680e912c$var$Ti, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    t.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $70fd6868680e912c$var$pi, {
        unique: !0
    }), t.createObjectStore("targetGlobal");
}
const $70fd6868680e912c$var$mo = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $70fd6868680e912c$var$go {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ t, e, n, s, i, r, o, u, c, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ a, h = 14){
        if (this.allowTabSynchronization = t, this.persistenceKey = e, this.clientId = n, this.js = i, this.window = r, this.document = o, this.Ws = c, this.zs = a, this.Hs = h, this.Ps = null, this.vs = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Js = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ys = null, /** The client metadata refresh task. */ this.Xs = null, /** The last time we garbage collected the client metadata object store. */ this.Zs = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.ti = (t)=>Promise.resolve(), !$70fd6868680e912c$var$go.V()) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $70fd6868680e912c$var$Kr(this, s), this.ei = e + "main", this.wt = new $70fd6868680e912c$var$Ui(u), this.ni = new $70fd6868680e912c$var$Vt(this.ei, this.Hs, new $70fd6868680e912c$var$_o(this.wt)), this.Vs = new $70fd6868680e912c$var$Or(this.referenceDelegate, this.wt), this.remoteDocumentCache = $70fd6868680e912c$var$Wr(this.wt), this.Ds = new $70fd6868680e912c$var$tr, this.window && this.window.localStorage ? this.si = this.window.localStorage : (this.si = null, !1 === a && $70fd6868680e912c$var$F("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.ii().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, $70fd6868680e912c$var$mo);
            return this.ri(), this.oi(), this.ui(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (t)=>this.Vs.getHighestSequenceNumber(t));
        }).then((t)=>{
            this.Ps = new $70fd6868680e912c$var$$t(t, this.Ws);
        }).then(()=>{
            this.vs = !0;
        }).catch((t)=>(this.ni && this.ni.close(), Promise.reject(t)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ ci(t) {
        return this.ti = async (e)=>{
            if (this.started) return t(e);
        }, t(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(t) {
        this.ni.F(async (e)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === e.newVersion && await t();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(t) {
        this.networkEnabled !== t && (this.networkEnabled = t, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.js.enqueueAndForget(async ()=>{
            this.started && await this.ii();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ ii() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (t)=>$70fd6868680e912c$var$po(t).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.ai(t).next((t)=>{
                    t || (this.isPrimary = !1, this.js.enqueueRetryable(()=>this.ti(!1)));
                });
            }).next(()=>this.hi(t)).next((e)=>this.isPrimary && !e ? this.li(t).next(()=>!1) : !!e && this.fi(t).next(()=>!0))).catch((t)=>{
            if ($70fd6868680e912c$var$Ct(t)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $70fd6868680e912c$var$M("IndexedDbPersistence", "Failed to extend owner lease: ", t), this.isPrimary;
            if (!this.allowTabSynchronization) throw t;
            return $70fd6868680e912c$var$M("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", t), /* isPrimary= */ !1;
        }).then((t)=>{
            this.isPrimary !== t && this.js.enqueueRetryable(()=>this.ti(t)), this.isPrimary = t;
        });
    }
    ai(t) {
        return $70fd6868680e912c$var$yo(t).get("owner").next((t)=>$70fd6868680e912c$var$Pt.resolve(this.di(t)));
    }
    _i(t) {
        return $70fd6868680e912c$var$po(t).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async wi() {
        if (this.isPrimary && !this.mi(this.Zs, 18e5)) {
            this.Zs = Date.now();
            const t = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (t)=>{
                const e = $70fd6868680e912c$var$Mi(t, "clientMetadata");
                return e.K().next((t)=>{
                    const n = this.gi(t, 18e5), s = t.filter((t)=>-1 === n.indexOf(t));
                    // Delete metadata for clients that are no longer considered active.
                    return $70fd6868680e912c$var$Pt.forEach(s, (t)=>e.delete(t.clientId)).next(()=>s);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.si) for (const e of t)this.si.removeItem(this.yi(e.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ ui() {
        this.Xs = this.js.enqueueAfterDelay("client_metadata_refresh" /* ClientMetadataRefresh */ , 4e3, ()=>this.ii().then(()=>this.wi()).then(()=>this.ui()));
    }
    /** Checks whether `client` is the local client. */ di(t) {
        return !!t && t.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ hi(t) {
        if (this.zs) return $70fd6868680e912c$var$Pt.resolve(!0);
        return $70fd6868680e912c$var$yo(t).get("owner").next((e)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== e && this.mi(e.leaseTimestampMs, 5e3) && !this.pi(e.ownerId)) {
                if (this.di(e) && this.networkEnabled) return !0;
                if (!this.di(e)) {
                    if (!e.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, $70fd6868680e912c$var$mo);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $70fd6868680e912c$var$po(t).K().next((t)=>void 0 === this.gi(t, 5e3).find((t)=>{
                    if (this.clientId !== t.clientId) {
                        const e = !this.networkEnabled && t.networkEnabled, n = !this.inForeground && t.inForeground, s = this.networkEnabled === t.networkEnabled;
                        if (e || n && s) return !0;
                    }
                    return !1;
                }));
        }).next((t)=>(this.isPrimary !== t && $70fd6868680e912c$var$M("IndexedDbPersistence", `Client ${t ? "is" : "is not"} eligible for a primary lease.`), t));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.vs = !1, this.Ii(), this.Xs && (this.Xs.cancel(), this.Xs = null), this.Ti(), this.Ei(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.ni.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (t)=>{
            const e = new $70fd6868680e912c$var$Oi(t, $70fd6868680e912c$var$$t.ot);
            return this.li(e).next(()=>this._i(e));
        }), this.ni.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Ai();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ gi(t, e) {
        return t.filter((t)=>this.mi(t.updateTimeMs, e) && !this.pi(t.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ri() {
        return this.runTransaction("getActiveClients", "readonly", (t)=>$70fd6868680e912c$var$po(t).K().next((t)=>this.gi(t, 18e5).map((t)=>t.clientId)));
    }
    get started() {
        return this.vs;
    }
    getMutationQueue(t, e) {
        return $70fd6868680e912c$var$Sr.se(t, this.wt, e, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Vs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(t) {
        return new $70fd6868680e912c$var$pr(t, this.wt.ne.databaseId);
    }
    getDocumentOverlayCache(t) {
        return $70fd6868680e912c$var$sr.se(this.wt, t);
    }
    getBundleCache() {
        return this.Ds;
    }
    runTransaction(t, e, n) {
        $70fd6868680e912c$var$M("IndexedDbPersistence", "Starting transaction:", t);
        const s = "readonly" === e ? "readonly" : "readwrite", i = 15 === (r = this.Hs) ? $70fd6868680e912c$var$ki : 14 === r ? $70fd6868680e912c$var$Ni : 13 === r ? $70fd6868680e912c$var$xi : 12 === r ? $70fd6868680e912c$var$Ci : 11 === r ? $70fd6868680e912c$var$Di : void $70fd6868680e912c$var$L();
        /** Returns the object stores for the provided schema. */ var r;
        let o;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.ni.runTransaction(t, s, i, (s)=>(o = new $70fd6868680e912c$var$Oi(s, this.Ps ? this.Ps.next() : $70fd6868680e912c$var$$t.ot), "readwrite-primary" === e ? this.ai(o).next((t)=>!!t || this.hi(o)).next((e)=>{
                if (!e) throw $70fd6868680e912c$var$F(`Failed to obtain primary lease for action '${t}'.`), this.isPrimary = !1, this.js.enqueueRetryable(()=>this.ti(!1)), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, $70fd6868680e912c$var$At);
                return n(o);
            }).next((t)=>this.fi(o).next(()=>t)) : this.bi(o).next(()=>n(o)))).then((t)=>(o.raiseOnCommittedEvent(), t));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    bi(t) {
        return $70fd6868680e912c$var$yo(t).get("owner").next((t)=>{
            if (null !== t && this.mi(t.leaseTimestampMs, 5e3) && !this.pi(t.ownerId) && !this.di(t) && !(this.zs || this.allowTabSynchronization && t.allowTabSynchronization)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, $70fd6868680e912c$var$mo);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ fi(t) {
        const e = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $70fd6868680e912c$var$yo(t).put("owner", e);
    }
    static V() {
        return $70fd6868680e912c$var$Vt.V();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ li(t) {
        const e = $70fd6868680e912c$var$yo(t);
        return e.get("owner").next((t)=>this.di(t) ? ($70fd6868680e912c$var$M("IndexedDbPersistence", "Releasing primary lease."), e.delete("owner")) : $70fd6868680e912c$var$Pt.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ mi(t, e) {
        const n = Date.now();
        return !(t < n - e) && (!(t > n) || ($70fd6868680e912c$var$F(`Detected an update time that is in the future: ${t} > ${n}`), !1));
    }
    ri() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ys = ()=>{
            this.js.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.ii()));
        }, this.document.addEventListener("visibilitychange", this.Ys), this.inForeground = "visible" === this.document.visibilityState);
    }
    Ti() {
        this.Ys && (this.document.removeEventListener("visibilitychange", this.Ys), this.Ys = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ oi() {
        var t;
        "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.Js = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Ii(), (0, $c38e0f42709c826a$export$95df08bae54cb4df)() && navigator.appVersion.match(/Version\/1[45]/) && // On Safari 14 and 15, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.js.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.js.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Js));
    }
    Ei() {
        this.Js && (this.window.removeEventListener("pagehide", this.Js), this.Js = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ pi(t) {
        var e;
        try {
            const n = null !== (null === (e = this.si) || void 0 === e ? void 0 : e.getItem(this.yi(t)));
            return $70fd6868680e912c$var$M("IndexedDbPersistence", `Client '${t}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (t) {
            // Gracefully handle if LocalStorage isn't working.
            return $70fd6868680e912c$var$F("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Ii() {
        if (this.si) try {
            this.si.setItem(this.yi(this.clientId), String(Date.now()));
        } catch (t) {
            // Gracefully handle if LocalStorage isn't available / working.
            $70fd6868680e912c$var$F("Failed to set zombie client id.", t);
        }
    }
    /** Removes the zombied client entry if it exists. */ Ai() {
        if (this.si) try {
            this.si.removeItem(this.yi(this.clientId));
        } catch (t) {
        // Ignore
        }
    }
    yi(t) {
        return `firestore_zombie_${this.persistenceKey}_${t}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $70fd6868680e912c$var$yo(t) {
    return $70fd6868680e912c$var$Mi(t, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $70fd6868680e912c$var$po(t) {
    return $70fd6868680e912c$var$Mi(t, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $70fd6868680e912c$var$Io(t, e) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = t.projectId;
    return t.isDefaultDatabase || (n += "." + t.database), "firestore/" + e + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $70fd6868680e912c$var$To {
    constructor(t, e, n, s){
        this.targetId = t, this.fromCache = e, this.Pi = n, this.vi = s;
    }
    static Vi(t, e) {
        let n = $70fd6868680e912c$var$ws(), s = $70fd6868680e912c$var$ws();
        for (const t of e.docChanges)switch(t.type){
            case 0 /* Added */ :
                n = n.add(t.doc.key);
                break;
            case 1 /* Removed */ :
                s = s.add(t.doc.key);
        }
        return new $70fd6868680e912c$var$To(t, e.fromCache, n, s);
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $70fd6868680e912c$var$Eo {
    constructor(){
        this.Si = !1;
    }
    /** Sets the document view to query against. */ initialize(t, e) {
        this.Di = t, this.indexManager = e, this.Si = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(t, e, n, s) {
        return this.Ci(t, e).next((i)=>i || this.xi(t, e, s, n)).next((n)=>n || this.Ni(t, e));
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Ci(t, e) {
        return $70fd6868680e912c$var$Pt.resolve(null);
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ xi(t, e, n, s) {
        return $70fd6868680e912c$var$on(e) || s.isEqual($70fd6868680e912c$var$ct.min()) ? this.Ni(t, e) : this.Di.getDocuments(t, n).next((i)=>{
            const r = this.ki(e, i);
            return this.Oi(e, r, n, s) ? this.Ni(t, e) : ($70fd6868680e912c$var$k() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$M("QueryEngine", "Re-using previous result from %s to execute query: %s", s.toString(), $70fd6868680e912c$var$wn(e)), this.Mi(t, r, e, $70fd6868680e912c$var$pt(s, -1)));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ ki(t, e) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$yn(t));
        return e.forEach((e, s)=>{
            $70fd6868680e912c$var$mn(t, s) && (n = n.add(s));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Oi(t, e, n, s) {
        if (null === t.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== e.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* First */  === t.limitType ? e.last() : e.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(s) > 0);
    }
    Ni(t, e) {
        return $70fd6868680e912c$var$k() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$M("QueryEngine", "Using full collection scan to execute query:", $70fd6868680e912c$var$wn(e)), this.Di.getDocumentsMatchingQuery(t, e, $70fd6868680e912c$var$Tt.min());
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Mi(t, e, n, s) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Di.getDocumentsMatchingQuery(t, n, s).next((t)=>// Merge with existing results
            (e.forEach((e)=>{
                t = t.insert(e.key, e);
            }), t));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$Ao {
    constructor(/** Manages our in-memory or durable persistence. */ t, e, n, s){
        this.persistence = t, this.Fi = e, this.wt = s, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.$i = new $70fd6868680e912c$var$qt($70fd6868680e912c$var$it), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Bi = new $70fd6868680e912c$var$is((t)=>$70fd6868680e912c$var$Oe(t), $70fd6868680e912c$var$Fe), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Li = new Map, this.Ui = t.getRemoteDocumentCache(), this.Vs = t.getTargetCache(), this.Ds = t.getBundleCache(), this.qi(n);
    }
    qi(t) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(t), this.indexManager = this.persistence.getIndexManager(t), this.mutationQueue = this.persistence.getMutationQueue(t, this.indexManager), this.localDocuments = new $70fd6868680e912c$var$eo(this.Ui, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Ui.setIndexManager(this.indexManager), this.Fi.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(t) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (e)=>t.collect(e, this.$i));
    }
}
function $70fd6868680e912c$var$Ro(/** Manages our in-memory or durable persistence. */ t, e, n, s) {
    return new $70fd6868680e912c$var$Ao(t, e, n, s);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $70fd6868680e912c$var$bo(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    return await n.persistence.runTransaction("Handle user change", "readonly", (t)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let s;
        return n.mutationQueue.getAllMutationBatches(t).next((i)=>(s = i, n.qi(e), n.mutationQueue.getAllMutationBatches(t))).next((e)=>{
            const i = [], r = [];
            // Union the old/new changed keys.
            let o = $70fd6868680e912c$var$ws();
            for (const t of s){
                i.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            for (const t of e){
                r.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(t, o).next((t)=>({
                    Ki: t,
                    removedBatchIds: i,
                    addedBatchIds: r
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $70fd6868680e912c$var$Po(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (t)=>{
        const s = e.batch.keys(), i = n.Ui.newChangeBuffer({
            trackRemovals: !0
        });
        return (function(t, e, n, s) {
            const i = n.batch, r = i.keys();
            let o = $70fd6868680e912c$var$Pt.resolve();
            return r.forEach((t)=>{
                o = o.next(()=>s.getEntry(e, t)).next((e)=>{
                    const r = n.docVersions.get(t);
                    $70fd6868680e912c$var$U(null !== r), e.version.compareTo(r) < 0 && (i.applyToRemoteDocument(e, n), e.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (e.setReadTime(n.commitVersion), s.addEntry(e)));
                });
            }), o.next(()=>t.mutationQueue.removeMutationBatch(e, i));
        })(n, t, e, i).next(()=>i.apply(t)).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, function(t) {
                let e = $70fd6868680e912c$var$ws();
                for(let n = 0; n < t.mutationResults.length; ++n)t.mutationResults[n].transformResults.length > 0 && (e = e.add(t.batch.mutations[n].key));
                return e;
            }(e))).next(()=>n.localDocuments.getDocuments(t, s));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $70fd6868680e912c$var$vo(t) {
    const e = $70fd6868680e912c$var$K(t);
    return e.persistence.runTransaction("Get last remote snapshot version", "readonly", (t)=>e.Vs.getLastRemoteSnapshotVersion(t));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $70fd6868680e912c$var$Vo(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = e.snapshotVersion;
    let i = n.$i;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (t)=>{
        const r = n.Ui.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.$i;
        const o = [];
        e.targetChanges.forEach((r, u)=>{
            const c = i.get(u);
            if (!c) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Vs.removeMatchingKeys(t, r.removedDocuments, u).next(()=>n.Vs.addMatchingKeys(t, r.addedDocuments, u)));
            let a = c.withSequenceNumber(t.currentSequenceNumber);
            e.targetMismatches.has(u) ? a = a.withResumeToken($70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING, $70fd6868680e912c$var$ct.min()).withLastLimboFreeSnapshotVersion($70fd6868680e912c$var$ct.min()) : r.resumeToken.approximateByteSize() > 0 && (a = a.withResumeToken(r.resumeToken, s)), i = i.insert(u, a), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function(t, e, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === t.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (e.snapshotVersion.toMicroseconds() - t.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(c, a, r) && o.push(n.Vs.updateTargetData(t, a));
        });
        let u = $70fd6868680e912c$var$os(), c = $70fd6868680e912c$var$ws();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (e.documentUpdates.forEach((s)=>{
            e.resolvedLimboDocuments.has(s) && o.push(n.persistence.referenceDelegate.updateLimboDocument(t, s));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($70fd6868680e912c$var$So(t, r, e.documentUpdates).next((t)=>{
            u = t.Gi, c = t.Qi;
        })), !s.isEqual($70fd6868680e912c$var$ct.min())) {
            const e = n.Vs.getLastRemoteSnapshotVersion(t).next((e)=>n.Vs.setTargetsMetadata(t, t.currentSequenceNumber, s));
            o.push(e);
        }
        return $70fd6868680e912c$var$Pt.waitFor(o).next(()=>r.apply(t)).next(()=>n.localDocuments.getLocalViewOfDocuments(t, u, c)).next(()=>u);
    }).then((t)=>(n.$i = i, t));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $70fd6868680e912c$var$So(t, e, n) {
    let s = $70fd6868680e912c$var$ws(), i = $70fd6868680e912c$var$ws();
    return n.forEach((t)=>s = s.add(t)), e.getEntries(t, s).next((t)=>{
        let s = $70fd6868680e912c$var$os();
        return n.forEach((n, r)=>{
            const o = t.get(n);
            // Check if see if there is a existence state change for this document.
            r.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            r.isNoDocument() && r.version.isEqual($70fd6868680e912c$var$ct.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (e.removeEntry(n, r.readTime), s = s.insert(n, r)) : !o.isValidDocument() || r.version.compareTo(o.version) > 0 || 0 === r.version.compareTo(o.version) && o.hasPendingWrites ? (e.addEntry(r), s = s.insert(n, r)) : $70fd6868680e912c$var$M("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", r.version);
        }), {
            Gi: s,
            Qi: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $70fd6868680e912c$var$Do(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (t)=>(void 0 === e && (e = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(t, e)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $70fd6868680e912c$var$Co(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    return n.persistence.runTransaction("Allocate target", "readwrite", (t)=>{
        let s;
        return n.Vs.getTargetData(t, e).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (s = i, $70fd6868680e912c$var$Pt.resolve(s)) : n.Vs.allocateTargetId(t).next((i)=>(s = new $70fd6868680e912c$var$Li(e, i, 0 /* Listen */ , t.currentSequenceNumber), n.Vs.addTargetData(t, s).next(()=>s))));
    }).then((t)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const s = n.$i.get(t.targetId);
        return (null === s || t.snapshotVersion.compareTo(s.snapshotVersion) > 0) && (n.$i = n.$i.insert(t.targetId, t), n.Bi.set(e, t.targetId)), t;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $70fd6868680e912c$var$xo(t, e, n) {
    const s = $70fd6868680e912c$var$K(t), i = s.$i.get(e), r = n ? "readwrite" : "readwrite-primary";
    try {
        n || await s.persistence.runTransaction("Release target", r, (t)=>s.persistence.referenceDelegate.removeTarget(t, i));
    } catch (t) {
        if (!$70fd6868680e912c$var$Ct(t)) throw t;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $70fd6868680e912c$var$M("LocalStore", `Failed to update sequence numbers for target ${e}: ${t}`);
    }
    s.$i = s.$i.remove(e), s.Bi.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $70fd6868680e912c$var$No(t, e, n) {
    const s = $70fd6868680e912c$var$K(t);
    let i = $70fd6868680e912c$var$ct.min(), r = $70fd6868680e912c$var$ws();
    return s.persistence.runTransaction("Execute query", "readonly", (t)=>(function(t, e, n) {
            const s = $70fd6868680e912c$var$K(t), i = s.Bi.get(n);
            return void 0 !== i ? $70fd6868680e912c$var$Pt.resolve(s.$i.get(i)) : s.Vs.getTargetData(e, n);
        })(s, t, $70fd6868680e912c$var$ln(e)).next((e)=>{
            if (e) return i = e.lastLimboFreeSnapshotVersion, s.Vs.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
                r = t;
            });
        }).next(()=>s.Fi.getDocumentsMatchingQuery(t, e, n ? i : $70fd6868680e912c$var$ct.min(), n ? r : $70fd6868680e912c$var$ws())).next((t)=>($70fd6868680e912c$var$Mo(s, $70fd6868680e912c$var$gn(e), t), {
                documents: t,
                ji: r
            })));
}
// PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$ko(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = $70fd6868680e912c$var$K(n.Vs), i = n.$i.get(e);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (t)=>s.te(t, e).next((t)=>t ? t.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$Oo(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = n.Li.get(e) || $70fd6868680e912c$var$ct.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (t)=>n.Ui.getAllFromCollectionGroup(t, e, $70fd6868680e912c$var$pt(s, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((t)=>($70fd6868680e912c$var$Mo(n, e, t), t));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$Mo(t, e, n) {
    let s = $70fd6868680e912c$var$ct.min();
    n.forEach((t, e)=>{
        e.readTime.compareTo(s) > 0 && (s = e.readTime);
    }), t.Li.set(e, s);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $70fd6868680e912c$var$Fo(t, e, n, s) {
    const i = $70fd6868680e912c$var$K(t);
    let r = $70fd6868680e912c$var$ws(), o = $70fd6868680e912c$var$os();
    for (const t of n){
        const n = e.Wi(t.metadata.name);
        t.document && (r = r.add(n));
        const s = e.zi(t);
        s.setReadTime(e.Hi(t.metadata.readTime)), o = o.insert(n, s);
    }
    const u = i.Ui.newChangeBuffer({
        trackRemovals: !0
    }), c = await $70fd6868680e912c$var$Co(i, function(t) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $70fd6868680e912c$var$ln($70fd6868680e912c$var$rn($70fd6868680e912c$var$ht.fromString(`__bundle__/docs/${t}`)));
    }(s));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (t)=>$70fd6868680e912c$var$So(t, u, o).next((e)=>(u.apply(t), e)).next((e)=>i.Vs.removeMatchingKeysForTargetId(t, c.targetId).next(()=>i.Vs.addMatchingKeys(t, r, c.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(t, e.Gi, e.Qi)).next(()=>e.Gi)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $70fd6868680e912c$var$$o(t, e, n = $70fd6868680e912c$var$ws()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const s = await $70fd6868680e912c$var$Co(t, $70fd6868680e912c$var$ln($70fd6868680e912c$var$Ji(e.bundledQuery))), i = $70fd6868680e912c$var$K(t);
    return i.persistence.runTransaction("Save named query", "readwrite", (t)=>{
        const r = $70fd6868680e912c$var$Ns(e.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (s.snapshotVersion.compareTo(r) >= 0) return i.Ds.saveNamedQuery(t, e);
        // Update existing target data because the query from the bundle is newer.
        const o = s.withResumeToken($70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING, r);
        return i.$i = i.$i.insert(o.targetId, o), i.Vs.updateTargetData(t, o).next(()=>i.Vs.removeMatchingKeysForTargetId(t, s.targetId)).next(()=>i.Vs.addMatchingKeys(t, n, s.targetId)).next(()=>i.Ds.saveNamedQuery(t, e));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
/** Assembles the key for a client state in WebStorage */ function $70fd6868680e912c$var$Bo(t, e) {
    return `firestore_clients_${t}_${e}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $70fd6868680e912c$var$Lo(t, e, n) {
    let s = `firestore_mutations_${t}_${n}`;
    return e.isAuthenticated() && (s += `_${e.uid}`), s;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $70fd6868680e912c$var$Uo(t, e) {
    return `firestore_targets_${t}_${e}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$qo {
    constructor(t, e, n, s){
        this.user = t, this.batchId = e, this.state = n, this.error = s;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t, e, n) {
        const s = JSON.parse(n);
        let i, r = "object" == typeof s && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(s.state) && (void 0 === s.error || "object" == typeof s.error);
        return r && s.error && (r = "string" == typeof s.error.message && "string" == typeof s.error.code, r && (i = new $70fd6868680e912c$export$8fada0bf726bf278(s.error.code, s.error.message))), r ? new $70fd6868680e912c$var$qo(t, e, s.state, i) : ($70fd6868680e912c$var$F("SharedClientState", `Failed to parse mutation state for ID '${e}': ${n}`), null);
    }
    Yi() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$Ko {
    constructor(t, e, n){
        this.targetId = t, this.state = e, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t, e) {
        const n = JSON.parse(e);
        let s, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (s = new $70fd6868680e912c$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $70fd6868680e912c$var$Ko(t, n.state, s) : ($70fd6868680e912c$var$F("SharedClientState", `Failed to parse target state for ID '${t}': ${e}`), null);
    }
    Yi() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $70fd6868680e912c$var$Go {
    constructor(t, e){
        this.clientId = t, this.activeTargetIds = e;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t, e) {
        const n = JSON.parse(e);
        let s = "object" == typeof n && n.activeTargetIds instanceof Array, i = $70fd6868680e912c$var$gs();
        for(let t = 0; s && t < n.activeTargetIds.length; ++t)s = $70fd6868680e912c$var$ce(n.activeTargetIds[t]), i = i.add(n.activeTargetIds[t]);
        return s ? new $70fd6868680e912c$var$Go(t, i) : ($70fd6868680e912c$var$F("SharedClientState", `Failed to parse client data for instance '${t}': ${e}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $70fd6868680e912c$var$Qo {
    constructor(t, e){
        this.clientId = t, this.onlineState = e;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ji(t) {
        const e = JSON.parse(t);
        return "object" == typeof e && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(e.onlineState) && "string" == typeof e.clientId ? new $70fd6868680e912c$var$Qo(e.clientId, e.onlineState) : ($70fd6868680e912c$var$F("SharedClientState", `Failed to parse online state: ${t}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $70fd6868680e912c$var$jo {
    constructor(){
        this.activeTargetIds = $70fd6868680e912c$var$gs();
    }
    Xi(t) {
        this.activeTargetIds = this.activeTargetIds.add(t);
    }
    Zi(t) {
        this.activeTargetIds = this.activeTargetIds.delete(t);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Yi() {
        const t = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(t);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $70fd6868680e912c$var$Wo {
    constructor(t, e, n, s, i){
        this.window = t, this.js = e, this.persistenceKey = n, this.tr = s, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.er = this.nr.bind(this), this.sr = new $70fd6868680e912c$var$qt($70fd6868680e912c$var$it), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.ir = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const r = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.rr = $70fd6868680e912c$var$Bo(this.persistenceKey, this.tr), this.ur = /** Assembles the key for the current sequence number. */ function(t) {
            return `firestore_sequence_number_${t}`;
        }(this.persistenceKey), this.sr = this.sr.insert(this.tr, new $70fd6868680e912c$var$jo), this.cr = new RegExp(`^firestore_clients_${r}_([^_]*)$`), this.ar = new RegExp(`^firestore_mutations_${r}_(\\d+)(?:_(.*))?$`), this.hr = new RegExp(`^firestore_targets_${r}_(\\d+)$`), this.lr = /** Assembles the key for the online state of the primary tab. */ function(t) {
            return `firestore_online_state_${t}`;
        }(this.persistenceKey), this.dr = function(t) {
            return `firestore_bundle_loaded_v2_${t}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.er);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static V(t) {
        return !(!t || !t.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const t = await this.syncEngine.Ri();
        for (const e of t){
            if (e === this.tr) continue;
            const t = this.getItem($70fd6868680e912c$var$Bo(this.persistenceKey, e));
            if (t) {
                const n = $70fd6868680e912c$var$Go.Ji(e, t);
                n && (this.sr = this.sr.insert(n.clientId, n));
            }
        }
        this._r();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const e = this.storage.getItem(this.lr);
        if (e) {
            const t = this.wr(e);
            t && this.mr(t);
        }
        for (const t of this.ir)this.nr(t);
        this.ir = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(t) {
        this.setItem(this.ur, JSON.stringify(t));
    }
    getAllActiveQueryTargets() {
        return this.gr(this.sr);
    }
    isActiveQueryTarget(t) {
        let e = !1;
        return this.sr.forEach((n, s)=>{
            s.activeTargetIds.has(t) && (e = !0);
        }), e;
    }
    addPendingMutation(t) {
        this.yr(t, "pending");
    }
    updateMutationState(t, e, n) {
        this.yr(t, e, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.pr(t);
    }
    addLocalQueryTarget(t) {
        let e = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(t)) {
            const n = this.storage.getItem($70fd6868680e912c$var$Uo(this.persistenceKey, t));
            if (n) {
                const s = $70fd6868680e912c$var$Ko.Ji(t, n);
                s && (e = s.state);
            }
        }
        return this.Ir.Xi(t), this._r(), e;
    }
    removeLocalQueryTarget(t) {
        this.Ir.Zi(t), this._r();
    }
    isLocalQueryTarget(t) {
        return this.Ir.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        this.removeItem($70fd6868680e912c$var$Uo(this.persistenceKey, t));
    }
    updateQueryState(t, e, n) {
        this.Tr(t, e, n);
    }
    handleUserChange(t, e, n) {
        e.forEach((t)=>{
            this.pr(t);
        }), this.currentUser = t, n.forEach((t)=>{
            this.addPendingMutation(t);
        });
    }
    setOnlineState(t) {
        this.Er(t);
    }
    notifyBundleLoaded(t) {
        this.Ar(t);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.er), this.removeItem(this.rr), this.started = !1);
    }
    getItem(t) {
        const e = this.storage.getItem(t);
        return $70fd6868680e912c$var$M("SharedClientState", "READ", t, e), e;
    }
    setItem(t, e) {
        $70fd6868680e912c$var$M("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }
    removeItem(t) {
        $70fd6868680e912c$var$M("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }
    nr(t) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const e = t;
        if (e.storageArea === this.storage) {
            if ($70fd6868680e912c$var$M("SharedClientState", "EVENT", e.key, e.newValue), e.key === this.rr) return void $70fd6868680e912c$var$F("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.js.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== e.key) {
                        if (this.cr.test(e.key)) {
                            if (null == e.newValue) {
                                const t = this.Rr(e.key);
                                return this.br(t, null);
                            }
                            {
                                const t = this.Pr(e.key, e.newValue);
                                if (t) return this.br(t.clientId, t);
                            }
                        } else if (this.ar.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.vr(e.key, e.newValue);
                                if (t) return this.Vr(t);
                            }
                        } else if (this.hr.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.Sr(e.key, e.newValue);
                                if (t) return this.Dr(t);
                            }
                        } else if (e.key === this.lr) {
                            if (null !== e.newValue) {
                                const t = this.wr(e.newValue);
                                if (t) return this.mr(t);
                            }
                        } else if (e.key === this.ur) {
                            const t = function(t) {
                                let e = $70fd6868680e912c$var$$t.ot;
                                if (null != t) try {
                                    const n = JSON.parse(t);
                                    $70fd6868680e912c$var$U("number" == typeof n), e = n;
                                } catch (t) {
                                    $70fd6868680e912c$var$F("SharedClientState", "Failed to read sequence number from WebStorage", t);
                                }
                                return e;
                            }(e.newValue);
                            t !== $70fd6868680e912c$var$$t.ot && this.sequenceNumberHandler(t);
                        } else if (e.key === this.dr) {
                            const t = this.Cr(e.newValue);
                            await Promise.all(t.map((t)=>this.syncEngine.Nr(t)));
                        }
                    }
                } else this.ir.push(e);
            });
        }
    }
    get Ir() {
        return this.sr.get(this.tr);
    }
    _r() {
        this.setItem(this.rr, this.Ir.Yi());
    }
    yr(t, e, n) {
        const s = new $70fd6868680e912c$var$qo(this.currentUser, t, e, n), i = $70fd6868680e912c$var$Lo(this.persistenceKey, this.currentUser, t);
        this.setItem(i, s.Yi());
    }
    pr(t) {
        const e = $70fd6868680e912c$var$Lo(this.persistenceKey, this.currentUser, t);
        this.removeItem(e);
    }
    Er(t) {
        const e = {
            clientId: this.tr,
            onlineState: t
        };
        this.storage.setItem(this.lr, JSON.stringify(e));
    }
    Tr(t, e, n) {
        const s = $70fd6868680e912c$var$Uo(this.persistenceKey, t), i = new $70fd6868680e912c$var$Ko(t, e, n);
        this.setItem(s, i.Yi());
    }
    Ar(t) {
        const e = JSON.stringify(Array.from(t));
        this.setItem(this.dr, e);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Rr(t) {
        const e = this.cr.exec(t);
        return e ? e[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Pr(t, e) {
        const n = this.Rr(t);
        return $70fd6868680e912c$var$Go.Ji(n, e);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ vr(t, e) {
        const n = this.ar.exec(t), s = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $70fd6868680e912c$var$qo.Ji(new $70fd6868680e912c$var$C(i), s, e);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Sr(t, e) {
        const n = this.hr.exec(t), s = Number(n[1]);
        return $70fd6868680e912c$var$Ko.Ji(s, e);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ wr(t) {
        return $70fd6868680e912c$var$Qo.Ji(t);
    }
    Cr(t) {
        return JSON.parse(t);
    }
    async Vr(t) {
        if (t.user.uid === this.currentUser.uid) return this.syncEngine.kr(t.batchId, t.state, t.error);
        $70fd6868680e912c$var$M("SharedClientState", `Ignoring mutation for non-active user ${t.user.uid}`);
    }
    Dr(t) {
        return this.syncEngine.Or(t.targetId, t.state, t.error);
    }
    br(t, e) {
        const n = e ? this.sr.insert(t, e) : this.sr.remove(t), s = this.gr(this.sr), i = this.gr(n), r = [], o = [];
        return i.forEach((t)=>{
            s.has(t) || r.push(t);
        }), s.forEach((t)=>{
            i.has(t) || o.push(t);
        }), this.syncEngine.Mr(r, o).then(()=>{
            this.sr = n;
        });
    }
    mr(t) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.sr.get(t.clientId) && this.onlineStateHandler(t.onlineState);
    }
    gr(t) {
        let e = $70fd6868680e912c$var$gs();
        return t.forEach((t, n)=>{
            e = e.unionWith(n.activeTargetIds);
        }), e;
    }
}
class $70fd6868680e912c$var$zo {
    constructor(){
        this.Fr = new $70fd6868680e912c$var$jo, this.$r = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(t) {
    // No op.
    }
    updateMutationState(t, e, n) {
    // No op.
    }
    addLocalQueryTarget(t) {
        return this.Fr.Xi(t), this.$r[t] || "not-current";
    }
    updateQueryState(t, e, n) {
        this.$r[t] = e;
    }
    removeLocalQueryTarget(t) {
        this.Fr.Zi(t);
    }
    isLocalQueryTarget(t) {
        return this.Fr.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        delete this.$r[t];
    }
    getAllActiveQueryTargets() {
        return this.Fr.activeTargetIds;
    }
    isActiveQueryTarget(t) {
        return this.Fr.activeTargetIds.has(t);
    }
    start() {
        return this.Fr = new $70fd6868680e912c$var$jo, Promise.resolve();
    }
    handleUserChange(t, e, n) {
    // No op.
    }
    setOnlineState(t) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(t) {}
    notifyBundleLoaded(t) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Ho {
    Br(t) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $70fd6868680e912c$var$Jo {
    constructor(){
        this.Lr = ()=>this.Ur(), this.qr = ()=>this.Kr(), this.Gr = [], this.Qr();
    }
    Br(t) {
        this.Gr.push(t);
    }
    shutdown() {
        window.removeEventListener("online", this.Lr), window.removeEventListener("offline", this.qr);
    }
    Qr() {
        window.addEventListener("online", this.Lr), window.addEventListener("offline", this.qr);
    }
    Ur() {
        $70fd6868680e912c$var$M("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const t of this.Gr)t(0 /* AVAILABLE */ );
    }
    Kr() {
        $70fd6868680e912c$var$M("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const t of this.Gr)t(1 /* UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static V() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Yo = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $70fd6868680e912c$var$Xo {
    constructor(t){
        this.jr = t.jr, this.Wr = t.Wr;
    }
    zr(t) {
        this.Hr = t;
    }
    Jr(t) {
        this.Yr = t;
    }
    onMessage(t) {
        this.Xr = t;
    }
    close() {
        this.Wr();
    }
    send(t) {
        this.jr(t);
    }
    Zr() {
        this.Hr();
    }
    eo(t) {
        this.Yr(t);
    }
    no(t) {
        this.Xr(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Zo extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class {
    constructor(t){
        this.databaseInfo = t, this.databaseId = t.databaseId;
        const e = t.ssl ? "https" : "http";
        this.so = e + "://" + t.host, this.io = "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database + "/documents";
    }
    ro(t, e, n, s, i) {
        const r = this.oo(t, e);
        $70fd6868680e912c$var$M("RestConnection", "Sending: ", r, n);
        const o = {};
        return this.uo(o, s, i), this.co(t, r, o, n).then((t)=>($70fd6868680e912c$var$M("RestConnection", "Received: ", t), t), (e)=>{
            throw $70fd6868680e912c$export$86cd73f49cc6e0bb("RestConnection", `${t} failed with error: `, e, "url: ", r, "request:", n), e;
        });
    }
    ao(t, e, n, s, i) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.ro(t, e, n, s, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ uo(t, e, n) {
        t["X-Goog-Api-Client"] = "gl-js/ fire/" + $70fd6868680e912c$var$x, // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), e && e.headers.forEach((e, n)=>t[n] = e), n && n.headers.forEach((e, n)=>t[n] = e);
    }
    oo(t, e) {
        const n = $70fd6868680e912c$var$Yo[t];
        return `${this.so}/v1/${e}:${n}`;
    }
} {
    constructor(t){
        super(t), this.forceLongPolling = t.forceLongPolling, this.autoDetectLongPolling = t.autoDetectLongPolling, this.useFetchStreams = t.useFetchStreams;
    }
    co(t, e, n, s) {
        return new Promise((i, r)=>{
            const o = new (0, $d286e426fc35c29d$export$26404658cda3ee02);
            o.listenOnce((0, $d286e426fc35c29d$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(o.getLastErrorCode()){
                        case (0, $d286e426fc35c29d$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const e = o.getResponseJson();
                            $70fd6868680e912c$var$M("Connection", "XHR received:", JSON.stringify(e)), i(e);
                            break;
                        case (0, $d286e426fc35c29d$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $70fd6868680e912c$var$M("Connection", 'RPC "' + t + '" timed out'), r(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $d286e426fc35c29d$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = o.getStatus();
                            if ($70fd6868680e912c$var$M("Connection", 'RPC "' + t + '" failed with status:', n, "response text:", o.getResponseText()), n > 0) {
                                const t = o.getResponseJson().error;
                                if (t && t.status && t.message) {
                                    const e = function(t) {
                                        const e = t.toLowerCase().replace(/_/g, "-");
                                        return Object.values($70fd6868680e912c$var$G).indexOf(e) >= 0 ? e : $70fd6868680e912c$var$G.UNKNOWN;
                                    }(t.status);
                                    r(new $70fd6868680e912c$export$8fada0bf726bf278(e, t.message));
                                } else r(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNKNOWN, "Server responded with status " + o.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            r(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $70fd6868680e912c$var$L();
                    }
                } finally{
                    $70fd6868680e912c$var$M("Connection", 'RPC "' + t + '" completed.');
                }
            });
            const u = JSON.stringify(s);
            o.send(e, "POST", u, n, 15);
        });
    }
    ho(t, e, n) {
        const s = [
            this.so,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            t,
            "/channel"
        ], i = (0, $d286e426fc35c29d$export$66869136fc133c3a)(), r = (0, $d286e426fc35c29d$export$888d0d9ab79d08fc)(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        };
        this.useFetchStreams && (o.xmlHttpFactory = new (0, $d286e426fc35c29d$export$ddb1030448106742)({})), this.uo(o.initMessageHeaders, e, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
        // doesn't have an Origin header. So we have to exclude a few browser environments that are
        // known to (sometimes) not include an Origin. See
        // https://github.com/firebase/firebase-js-sdk/issues/1491.
        (0, $c38e0f42709c826a$export$872f8323f01d7ae0)() || (0, $c38e0f42709c826a$export$f7a1e23e542d38e3)() || (0, $c38e0f42709c826a$export$f2f6a8999f8ebd30)() || (0, $c38e0f42709c826a$export$7e7b1a9668aaed8)() || (0, $c38e0f42709c826a$export$202944b2d2824246)() || (0, $c38e0f42709c826a$export$caa8774a9107a58e)() || (o.httpHeadersOverwriteParam = "$httpHeaders");
        const u = s.join("");
        $70fd6868680e912c$var$M("Connection", "Creating WebChannel: " + u, o);
        const c = i.createWebChannel(u, o);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let a = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const l = new $70fd6868680e912c$var$Xo({
            jr: (t)=>{
                h ? $70fd6868680e912c$var$M("Connection", "Not sending because WebChannel is closed:", t) : (a || ($70fd6868680e912c$var$M("Connection", "Opening WebChannel transport."), c.open(), a = !0), $70fd6868680e912c$var$M("Connection", "WebChannel sending:", t), c.send(t));
            },
            Wr: ()=>c.close()
        }), y = (t, e, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            t.listen(e, (t)=>{
                try {
                    n(t);
                } catch (t) {
                    setTimeout(()=>{
                        throw t;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return y(c, (0, $d286e426fc35c29d$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            h || $70fd6868680e912c$var$M("Connection", "WebChannel transport opened.");
        }), y(c, (0, $d286e426fc35c29d$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            h || (h = !0, $70fd6868680e912c$var$M("Connection", "WebChannel transport closed"), l.eo());
        }), y(c, (0, $d286e426fc35c29d$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            h || (h = !0, $70fd6868680e912c$export$86cd73f49cc6e0bb("Connection", "WebChannel transport errored:", t), l.eo(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNAVAILABLE, "The operation could not be completed")));
        }), y(c, (0, $d286e426fc35c29d$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            var e;
            if (!h) {
                const n = t.data[0];
                $70fd6868680e912c$var$U(!!n);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = n, i = s.error || (null === (e = s[0]) || void 0 === e ? void 0 : e.error);
                if (i) {
                    $70fd6868680e912c$var$M("Connection", "WebChannel received error:", i);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = i.status;
                    let e = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function(t) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const e = $70fd6868680e912c$var$ts[t];
                        if (void 0 !== e) return $70fd6868680e912c$var$ss(e);
                    }(t), n = i.message;
                    void 0 === e && (e = $70fd6868680e912c$var$G.INTERNAL, n = "Unknown error status: " + t + " with message " + i.message), // Mark closed so no further events are propagated
                    h = !0, l.eo(new $70fd6868680e912c$export$8fada0bf726bf278(e, n)), c.close();
                } else $70fd6868680e912c$var$M("Connection", "WebChannel received:", n), l.no(n);
            }
        }), y(r, (0, $d286e426fc35c29d$export$d61e24a684f9e51).STAT_EVENT, (t)=>{
            t.stat === (0, $d286e426fc35c29d$export$cbbc350c1dfc80cb).PROXY ? $70fd6868680e912c$var$M("Connection", "Detected buffering proxy") : t.stat === (0, $d286e426fc35c29d$export$cbbc350c1dfc80cb).NOPROXY && $70fd6868680e912c$var$M("Connection", "Detected no buffering proxy");
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            l.Zr();
        }, 0), l;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $70fd6868680e912c$var$tu() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $70fd6868680e912c$var$eu() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$nu(t) {
    return new $70fd6868680e912c$var$Ss(t, /* useProto3Json= */ !0);
}
/**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $70fd6868680e912c$var$su {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, s = 1.5, i = 6e4){
        this.js = t, this.timerId = e, this.lo = n, this.fo = s, this._o = i, this.wo = 0, this.mo = null, /** The last backoff attempt, as epoch milliseconds. */ this.yo = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.wo = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ po() {
        this.wo = this._o;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ Io(t) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const e = Math.floor(this.wo + this.To()), n = Math.max(0, Date.now() - this.yo), s = Math.max(0, e - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        s > 0 && $70fd6868680e912c$var$M("ExponentialBackoff", `Backing off for ${s} ms (base delay: ${this.wo} ms, delay with jitter: ${e} ms, last attempt: ${n} ms ago)`), this.mo = this.js.enqueueAfterDelay(this.timerId, s, ()=>(this.yo = Date.now(), t())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.wo *= this.fo, this.wo < this.lo && (this.wo = this.lo), this.wo > this._o && (this.wo = this._o);
    }
    Eo() {
        null !== this.mo && (this.mo.skipDelay(), this.mo = null);
    }
    cancel() {
        null !== this.mo && (this.mo.cancel(), this.mo = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ To() {
        return (Math.random() - .5) * this.wo;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $70fd6868680e912c$var$iu {
    constructor(t, e, n, s, i, r, o, u){
        this.js = t, this.Ao = n, this.Ro = s, this.bo = i, this.authCredentialsProvider = r, this.appCheckCredentialsProvider = o, this.listener = u, this.state = 0 /* Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Po = 0, this.vo = null, this.Vo = null, this.stream = null, this.So = new $70fd6868680e912c$var$su(t, e);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Do() {
        return 1 /* Starting */  === this.state || 5 /* Backoff */  === this.state || this.Co();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Co() {
        return 2 /* Open */  === this.state || 3 /* Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        4 /* Error */  !== this.state ? this.auth() : this.xo();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Do() && await this.close(0 /* Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ No() {
        this.state = 0 /* Initial */ , this.So.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ ko() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Co() && null === this.vo && (this.vo = this.js.enqueueAfterDelay(this.Ao, 6e4, ()=>this.Oo()));
    }
    /** Sends a message to the underlying stream. */ Mo(t) {
        this.Fo(), this.stream.send(t);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async Oo() {
        if (this.Co()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* Initial */ );
    }
    /** Marks the stream as active again. */ Fo() {
        this.vo && (this.vo.cancel(), this.vo = null);
    }
    /** Cancels the health check delayed operation. */ $o() {
        this.Vo && (this.Vo.cancel(), this.Vo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(t, e) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Fo(), this.$o(), this.So.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Po++, 4 /* Error */  !== t ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.So.reset() : e && e.code === $70fd6868680e912c$var$G.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($70fd6868680e912c$var$F(e.toString()), $70fd6868680e912c$var$F("Using maximum backoff delay to prevent overloading the backend."), this.So.po()) : e && e.code === $70fd6868680e912c$var$G.UNAUTHENTICATED && 3 /* Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.Bo(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = t, // Notify the listener that the stream closed.
        await this.listener.Jr(e);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ Bo() {}
    auth() {
        this.state = 1 /* Starting */ ;
        const t = this.Lo(this.Po), e = this.Po;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([t, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Po === e && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.Uo(t, n);
        }, (e)=>{
            t(()=>{
                const t = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNKNOWN, "Fetching auth token failed: " + e.message);
                return this.qo(t);
            });
        });
    }
    Uo(t, e) {
        const n = this.Lo(this.Po);
        this.stream = this.Ko(t, e), this.stream.zr(()=>{
            n(()=>(this.state = 2 /* Open */ , this.Vo = this.js.enqueueAfterDelay(this.Ro, 1e4, ()=>(this.Co() && (this.state = 3 /* Healthy */ ), Promise.resolve())), this.listener.zr()));
        }), this.stream.Jr((t)=>{
            n(()=>this.qo(t));
        }), this.stream.onMessage((t)=>{
            n(()=>this.onMessage(t));
        });
    }
    xo() {
        this.state = 5 /* Backoff */ , this.So.Io(async ()=>{
            this.state = 0 /* Initial */ , this.start();
        });
    }
    // Visible for tests
    qo(t) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $70fd6868680e912c$var$M("PersistentStream", `close with error: ${t}`), this.stream = null, this.close(4 /* Error */ , t);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Lo(t) {
        return (e)=>{
            this.js.enqueueAndForget(()=>this.Po === t ? e() : ($70fd6868680e912c$var$M("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $70fd6868680e912c$var$ru extends $70fd6868680e912c$var$iu {
    constructor(t, e, n, s, i, r){
        super(t, "listen_stream_connection_backoff" /* ListenStreamConnectionBackoff */ , "listen_stream_idle" /* ListenStreamIdle */ , "health_check_timeout" /* HealthCheckTimeout */ , e, n, s, r), this.wt = i;
    }
    Ko(t, e) {
        return this.bo.ho("Listen", t, e);
    }
    onMessage(t) {
        // A successful response means the stream is healthy
        this.So.reset();
        const e = $70fd6868680e912c$var$Qs(this.wt, t), n = function(t) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in t)) return $70fd6868680e912c$var$ct.min();
            const e = t.targetChange;
            return e.targetIds && e.targetIds.length ? $70fd6868680e912c$var$ct.min() : e.readTime ? $70fd6868680e912c$var$Ns(e.readTime) : $70fd6868680e912c$var$ct.min();
        }(t);
        return this.listener.Go(e, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ Qo(t) {
        const e = {};
        e.database = $70fd6868680e912c$var$Ls(this.wt), e.addTarget = function(t, e) {
            let n;
            const s = e.target;
            return n = $70fd6868680e912c$var$$e(s) ? {
                documents: $70fd6868680e912c$var$Hs(t, s)
            } : {
                query: $70fd6868680e912c$var$Js(t, s)
            }, n.targetId = e.targetId, e.resumeToken.approximateByteSize() > 0 ? n.resumeToken = $70fd6868680e912c$var$Cs(t, e.resumeToken) : e.snapshotVersion.compareTo($70fd6868680e912c$var$ct.min()) > 0 && // TODO(wuandy): Consider removing above check because it is most likely true.
            // Right now, many tests depend on this behaviour though (leaving min() out
            // of serialization).
            (n.readTime = $70fd6868680e912c$var$Ds(t, e.snapshotVersion.toTimestamp())), n;
        }(this.wt, t);
        const n = $70fd6868680e912c$var$Xs(this.wt, t);
        n && (e.labels = n), this.Mo(e);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ jo(t) {
        const e = {};
        e.database = $70fd6868680e912c$var$Ls(this.wt), e.removeTarget = t, this.Mo(e);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $70fd6868680e912c$var$ou extends $70fd6868680e912c$var$iu {
    constructor(t, e, n, s, i, r){
        super(t, "write_stream_connection_backoff" /* WriteStreamConnectionBackoff */ , "write_stream_idle" /* WriteStreamIdle */ , "health_check_timeout" /* HealthCheckTimeout */ , e, n, s, r), this.wt = i, this.Wo = !1;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get zo() {
        return this.Wo;
    }
    // Override of PersistentStream.start
    start() {
        this.Wo = !1, this.lastStreamToken = void 0, super.start();
    }
    Bo() {
        this.Wo && this.Ho([]);
    }
    Ko(t, e) {
        return this.bo.ho("Write", t, e);
    }
    onMessage(t) {
        if (// Always capture the last stream token.
        $70fd6868680e912c$var$U(!!t.streamToken), this.lastStreamToken = t.streamToken, this.Wo) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.So.reset();
            const e = $70fd6868680e912c$var$zs(t.writeResults, t.commitTime), n = $70fd6868680e912c$var$Ns(t.commitTime);
            return this.listener.Jo(n, e);
        }
        // The first response is always the handshake response
        return $70fd6868680e912c$var$U(!t.writeResults || 0 === t.writeResults.length), this.Wo = !0, this.listener.Yo();
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ Xo() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const t = {};
        t.database = $70fd6868680e912c$var$Ls(this.wt), this.Mo(t);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ Ho(t) {
        const e = {
            streamToken: this.lastStreamToken,
            writes: t.map((t)=>$70fd6868680e912c$var$js(this.wt, t))
        };
        this.Mo(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $70fd6868680e912c$var$uu extends class {
} {
    constructor(t, e, n, s){
        super(), this.authCredentials = t, this.appCheckCredentials = e, this.bo = n, this.wt = s, this.Zo = !1;
    }
    tu() {
        if (this.Zo) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ ro(t, e, n) {
        return this.tu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, i])=>this.bo.ro(t, e, n, s, i)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $70fd6868680e912c$var$G.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNKNOWN, t.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ ao(t, e, n) {
        return this.tu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, i])=>this.bo.ao(t, e, n, s, i)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $70fd6868680e912c$var$G.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNKNOWN, t.toString());
        });
    }
    terminate() {
        this.Zo = !0;
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $70fd6868680e912c$var$cu {
    constructor(t, e){
        this.asyncQueue = t, this.onlineStateHandler = e, /** The current OnlineState. */ this.state = "Unknown" /* Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.eu = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.nu = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.su = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ iu() {
        0 === this.eu && (this.ru("Unknown" /* Unknown */ ), this.nu = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* OnlineStateTimeout */ , 1e4, ()=>(this.nu = null, this.ou("Backend didn't respond within 10 seconds."), this.ru("Offline" /* Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ uu(t) {
        "Online" /* Online */  === this.state ? this.ru("Unknown" /* Unknown */ ) : (this.eu++, this.eu >= 1 && (this.cu(), this.ou(`Connection failed 1 times. Most recent error: ${t.toString()}`), this.ru("Offline" /* Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(t) {
        this.cu(), this.eu = 0, "Online" /* Online */  === t && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.su = !1), this.ru(t);
    }
    ru(t) {
        t !== this.state && (this.state = t, this.onlineStateHandler(t));
    }
    ou(t) {
        const e = `Could not reach Cloud Firestore backend. ${t}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.su ? ($70fd6868680e912c$var$F(e), this.su = !1) : $70fd6868680e912c$var$M("OnlineStateTracker", e);
    }
    cu() {
        null !== this.nu && (this.nu.cancel(), this.nu = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$au {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ t, /** The client-side proxy for interacting with the backend. */ e, n, s, i){
        this.localStore = t, this.datastore = e, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.au = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.hu = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.lu = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.fu = [], this.du = i, this.du.Br((t)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $70fd6868680e912c$var$yu(this) && ($70fd6868680e912c$var$M("RemoteStore", "Restarting streams for network reachability change."), await async function(t) {
                    const e = $70fd6868680e912c$var$K(t);
                    e.lu.add(4 /* ConnectivityChange */ ), await $70fd6868680e912c$var$lu(e), e._u.set("Unknown" /* Unknown */ ), e.lu.delete(4 /* ConnectivityChange */ ), await $70fd6868680e912c$var$hu(e);
                }(this));
            });
        }), this._u = new $70fd6868680e912c$var$cu(n, s);
    }
}
async function $70fd6868680e912c$var$hu(t) {
    if ($70fd6868680e912c$var$yu(t)) for (const e of t.fu)await e(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $70fd6868680e912c$var$lu(t) {
    for (const e of t.fu)await e(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $70fd6868680e912c$var$fu(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    n.hu.has(e.targetId) || // Mark this as something the client is currently listening for.
    (n.hu.set(e.targetId, e), $70fd6868680e912c$var$gu(n) ? // The listen will be sent in onWatchStreamOpen
    $70fd6868680e912c$var$mu(n) : $70fd6868680e912c$var$Mu(n).Co() && $70fd6868680e912c$var$_u(n, e));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $70fd6868680e912c$var$du(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = $70fd6868680e912c$var$Mu(n);
    n.hu.delete(e), s.Co() && $70fd6868680e912c$var$wu(n, e), 0 === n.hu.size && (s.Co() ? s.ko() : $70fd6868680e912c$var$yu(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n._u.set("Unknown" /* Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $70fd6868680e912c$var$_u(t, e) {
    t.wu.Nt(e.targetId), $70fd6868680e912c$var$Mu(t).Qo(e);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $70fd6868680e912c$var$wu(t, e) {
    t.wu.Nt(e), $70fd6868680e912c$var$Mu(t).jo(e);
}
function $70fd6868680e912c$var$mu(t) {
    t.wu = new $70fd6868680e912c$var$Rs({
        getRemoteKeysForTarget: (e)=>t.remoteSyncer.getRemoteKeysForTarget(e),
        te: (e)=>t.hu.get(e) || null
    }), $70fd6868680e912c$var$Mu(t).start(), t._u.iu();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $70fd6868680e912c$var$gu(t) {
    return $70fd6868680e912c$var$yu(t) && !$70fd6868680e912c$var$Mu(t).Do() && t.hu.size > 0;
}
function $70fd6868680e912c$var$yu(t) {
    return 0 === $70fd6868680e912c$var$K(t).lu.size;
}
function $70fd6868680e912c$var$pu(t) {
    t.wu = void 0;
}
async function $70fd6868680e912c$var$Iu(t) {
    t.hu.forEach((e, n)=>{
        $70fd6868680e912c$var$_u(t, e);
    });
}
async function $70fd6868680e912c$var$Tu(t, e) {
    $70fd6868680e912c$var$pu(t), // If we still need the watch stream, retry the connection.
    $70fd6868680e912c$var$gu(t) ? (t._u.uu(e), $70fd6868680e912c$var$mu(t)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    t._u.set("Unknown" /* Unknown */ );
}
async function $70fd6868680e912c$var$Eu(t, e, n) {
    if (// Mark the client as online since we got a message from the server
    t._u.set("Online" /* Online */ ), e instanceof $70fd6868680e912c$var$Es && 2 /* Removed */  === e.state && e.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function(t, e) {
            const n = e.cause;
            for (const s of e.targetIds)// A watched target might have been removed already.
            t.hu.has(s) && (await t.remoteSyncer.rejectListen(s, n), t.hu.delete(s), t.wu.removeTarget(s));
        }(t, e);
    } catch (n) {
        $70fd6868680e912c$var$M("RemoteStore", "Failed to remove targets %s: %s ", e.targetIds.join(","), n), await $70fd6868680e912c$var$Au(t, n);
    }
    else if (e instanceof $70fd6868680e912c$var$Is ? t.wu.Ut(e) : e instanceof $70fd6868680e912c$var$Ts ? t.wu.zt(e) : t.wu.Gt(e), !n.isEqual($70fd6868680e912c$var$ct.min())) try {
        const e = await $70fd6868680e912c$var$vo(t.localStore);
        n.compareTo(e) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function(t, e) {
            const n = t.wu.Yt(e);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, s)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = t.hu.get(s);
                    // A watched target might have been removed already.
                    i && t.hu.set(s, i.withResumeToken(n.resumeToken, e));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((e)=>{
                const n = t.hu.get(e);
                if (!n) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                t.hu.set(e, n.withResumeToken($70fd6868680e912c$var$Jt.EMPTY_BYTE_STRING, n.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $70fd6868680e912c$var$wu(t, e);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const s = new $70fd6868680e912c$var$Li(n.target, e, 1 /* ExistenceFilterMismatch */ , n.sequenceNumber);
                $70fd6868680e912c$var$_u(t, s);
            }), t.remoteSyncer.applyRemoteEvent(n);
        }(t, n);
    } catch (e) {
        $70fd6868680e912c$var$M("RemoteStore", "Failed to raise snapshot:", e), await $70fd6868680e912c$var$Au(t, e);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $70fd6868680e912c$var$Au(t, e, n) {
    if (!$70fd6868680e912c$var$Ct(e)) throw e;
    t.lu.add(1 /* IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $70fd6868680e912c$var$lu(t), t._u.set("Offline" /* Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$70fd6868680e912c$var$vo(t.localStore)), // Probe IndexedDB periodically and re-enable network
    t.asyncQueue.enqueueRetryable(async ()=>{
        $70fd6868680e912c$var$M("RemoteStore", "Retrying IndexedDB access"), await n(), t.lu.delete(1 /* IndexedDbFailed */ ), await $70fd6868680e912c$var$hu(t);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $70fd6868680e912c$var$Ru(t, e) {
    return e().catch((n)=>$70fd6868680e912c$var$Au(t, n, e));
}
async function $70fd6868680e912c$var$bu(t) {
    const e = $70fd6868680e912c$var$K(t), n = $70fd6868680e912c$var$Fu(e);
    let s = e.au.length > 0 ? e.au[e.au.length - 1].batchId : -1;
    for(; $70fd6868680e912c$var$Pu(e);)try {
        const t = await $70fd6868680e912c$var$Do(e.localStore, s);
        if (null === t) {
            0 === e.au.length && n.ko();
            break;
        }
        s = t.batchId, $70fd6868680e912c$var$vu(e, t);
    } catch (t) {
        await $70fd6868680e912c$var$Au(e, t);
    }
    $70fd6868680e912c$var$Vu(e) && $70fd6868680e912c$var$Su(e);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $70fd6868680e912c$var$Pu(t) {
    return $70fd6868680e912c$var$yu(t) && t.au.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $70fd6868680e912c$var$vu(t, e) {
    t.au.push(e);
    const n = $70fd6868680e912c$var$Fu(t);
    n.Co() && n.zo && n.Ho(e.mutations);
}
function $70fd6868680e912c$var$Vu(t) {
    return $70fd6868680e912c$var$yu(t) && !$70fd6868680e912c$var$Fu(t).Do() && t.au.length > 0;
}
function $70fd6868680e912c$var$Su(t) {
    $70fd6868680e912c$var$Fu(t).start();
}
async function $70fd6868680e912c$var$Du(t) {
    $70fd6868680e912c$var$Fu(t).Xo();
}
async function $70fd6868680e912c$var$Cu(t) {
    const e = $70fd6868680e912c$var$Fu(t);
    // Send the write pipeline now that the stream is established.
    for (const n of t.au)e.Ho(n.mutations);
}
async function $70fd6868680e912c$var$xu(t, e, n) {
    const s = t.au.shift(), i = $70fd6868680e912c$var$$i.from(s, e, n);
    await $70fd6868680e912c$var$Ru(t, ()=>t.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $70fd6868680e912c$var$bu(t);
}
async function $70fd6868680e912c$var$Nu(t, e) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    e && $70fd6868680e912c$var$Fu(t).zo && // This error affects the actual write.
    await async function(t, e) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (n = e.code, $70fd6868680e912c$var$ns(n) && n !== $70fd6868680e912c$var$G.ABORTED) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = t.au.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $70fd6868680e912c$var$Fu(t).No(), await $70fd6868680e912c$var$Ru(t, ()=>t.remoteSyncer.rejectFailedWrite(n.batchId, e)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $70fd6868680e912c$var$bu(t);
        }
        var n;
    }(t, e), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $70fd6868680e912c$var$Vu(t) && $70fd6868680e912c$var$Su(t);
}
async function $70fd6868680e912c$var$ku(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    n.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$M("RemoteStore", "RemoteStore received new credentials");
    const s = $70fd6868680e912c$var$yu(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.lu.add(3 /* CredentialChange */ ), await $70fd6868680e912c$var$lu(n), s && // Don't set the network status to Unknown if we are offline.
    n._u.set("Unknown" /* Unknown */ ), await n.remoteSyncer.handleCredentialChange(e), n.lu.delete(3 /* CredentialChange */ ), await $70fd6868680e912c$var$hu(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $70fd6868680e912c$var$Ou(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    e ? (n.lu.delete(2 /* IsSecondary */ ), await $70fd6868680e912c$var$hu(n)) : e || (n.lu.add(2 /* IsSecondary */ ), await $70fd6868680e912c$var$lu(n), n._u.set("Unknown" /* Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$Mu(t) {
    return t.mu || // Create stream (but note that it is not started yet).
    (t.mu = function(t, e, n) {
        const s = $70fd6868680e912c$var$K(t);
        return s.tu(), new $70fd6868680e912c$var$ru(e, s.bo, s.authCredentials, s.appCheckCredentials, s.wt, n);
    }(t.datastore, t.asyncQueue, {
        zr: $70fd6868680e912c$var$Iu.bind(null, t),
        Jr: $70fd6868680e912c$var$Tu.bind(null, t),
        Go: $70fd6868680e912c$var$Eu.bind(null, t)
    }), t.fu.push(async (e)=>{
        e ? (t.mu.No(), $70fd6868680e912c$var$gu(t) ? $70fd6868680e912c$var$mu(t) : t._u.set("Unknown" /* Unknown */ )) : (await t.mu.stop(), $70fd6868680e912c$var$pu(t));
    })), t.mu;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$Fu(t) {
    return t.gu || // Create stream (but note that it is not started yet).
    (t.gu = function(t, e, n) {
        const s = $70fd6868680e912c$var$K(t);
        return s.tu(), new $70fd6868680e912c$var$ou(e, s.bo, s.authCredentials, s.appCheckCredentials, s.wt, n);
    }(t.datastore, t.asyncQueue, {
        zr: $70fd6868680e912c$var$Du.bind(null, t),
        Jr: $70fd6868680e912c$var$Nu.bind(null, t),
        Yo: $70fd6868680e912c$var$Cu.bind(null, t),
        Jo: $70fd6868680e912c$var$xu.bind(null, t)
    }), t.fu.push(async (e)=>{
        e ? (t.gu.No(), // This will start the write stream if necessary.
        await $70fd6868680e912c$var$bu(t)) : (await t.gu.stop(), t.au.length > 0 && ($70fd6868680e912c$var$M("RemoteStore", `Stopping write stream with ${t.au.length} pending writes`), t.au = []));
    })), t.gu;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $70fd6868680e912c$var$$u {
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.timerId = e, this.targetTimeMs = n, this.op = s, this.removalCallback = i, this.deferred = new $70fd6868680e912c$var$j, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((t)=>{});
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(t, e, n, s, i) {
        const r = Date.now() + n, o = new $70fd6868680e912c$var$$u(t, e, r, s, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(t) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), t);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(t) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((t)=>this.deferred.resolve(t))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $70fd6868680e912c$var$Bu(t, e) {
    if ($70fd6868680e912c$var$F("AsyncQueue", `${e}: ${t}`), $70fd6868680e912c$var$Ct(t)) return new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNAVAILABLE, `${e}: ${t}`);
    throw t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $70fd6868680e912c$var$Lu {
    /** The default ordering is by key if the comparator is omitted */ constructor(t){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = t ? (e, n)=>t(e, n) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, n.key) : (t, e)=>$70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key), this.keyedMap = $70fd6868680e912c$var$cs(), this.sortedSet = new $70fd6868680e912c$var$qt(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(t) {
        return new $70fd6868680e912c$var$Lu(t.comparator);
    }
    has(t) {
        return null != this.keyedMap.get(t);
    }
    get(t) {
        return this.keyedMap.get(t);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(t) {
        const e = this.keyedMap.get(t);
        return e ? this.sortedSet.indexOf(e) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(t) {
        this.sortedSet.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Inserts or updates a document with the same key */ add(t) {
        // First remove the element if we have it.
        const e = this.delete(t.key);
        return e.copy(e.keyedMap.insert(t.key, t), e.sortedSet.insert(t, null));
    }
    /** Deletes a document with a given key */ delete(t) {
        const e = this.get(t);
        return e ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(e)) : this;
    }
    isEqual(t) {
        if (!(t instanceof $70fd6868680e912c$var$Lu)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.sortedSet.getIterator(), n = t.sortedSet.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (!t.isEqual(s)) return !1;
        }
        return !0;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e.toString());
        }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }
    copy(t, e) {
        const n = new $70fd6868680e912c$var$Lu;
        return n.comparator = this.comparator, n.keyedMap = t, n.sortedSet = e, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $70fd6868680e912c$var$Uu {
    constructor(){
        this.yu = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
    }
    track(t) {
        const e = t.doc.key, n = this.yu.get(e);
        n ? // Merge the new change with the existing change.
        0 /* Added */  !== t.type && 3 /* Metadata */  === n.type ? this.yu = this.yu.insert(e, t) : 3 /* Metadata */  === t.type && 1 /* Removed */  !== n.type ? this.yu = this.yu.insert(e, {
            type: n.type,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 2 /* Modified */  === n.type ? this.yu = this.yu.insert(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 0 /* Added */  === n.type ? this.yu = this.yu.insert(e, {
            type: 0 /* Added */ ,
            doc: t.doc
        }) : 1 /* Removed */  === t.type && 0 /* Added */  === n.type ? this.yu = this.yu.remove(e) : 1 /* Removed */  === t.type && 2 /* Modified */  === n.type ? this.yu = this.yu.insert(e, {
            type: 1 /* Removed */ ,
            doc: n.doc
        }) : 0 /* Added */  === t.type && 1 /* Removed */  === n.type ? this.yu = this.yu.insert(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $70fd6868680e912c$var$L() : this.yu = this.yu.insert(e, t);
    }
    pu() {
        const t = [];
        return this.yu.inorderTraversal((e, n)=>{
            t.push(n);
        }), t;
    }
}
class $70fd6868680e912c$var$qu {
    constructor(t, e, n, s, i, r, o, u){
        this.query = t, this.docs = e, this.oldDocs = n, this.docChanges = s, this.mutatedKeys = i, this.fromCache = r, this.syncStateChanged = o, this.excludesMetadataChanges = u;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(t, e, n, s) {
        const i = [];
        return e.forEach((t)=>{
            i.push({
                type: 0 /* Added */ ,
                doc: t
            });
        }), new $70fd6868680e912c$var$qu(t, e, $70fd6868680e912c$var$Lu.emptySet(e), i, n, s, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(t) {
        if (!(this.fromCache === t.fromCache && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && $70fd6868680e912c$var$dn(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs))) return !1;
        const e = this.docChanges, n = t.docChanges;
        if (e.length !== n.length) return !1;
        for(let t = 0; t < e.length; t++)if (e[t].type !== n[t].type || !e[t].doc.isEqual(n[t].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $70fd6868680e912c$var$Ku {
    constructor(){
        this.Iu = void 0, this.listeners = [];
    }
}
class $70fd6868680e912c$var$Gu {
    constructor(){
        this.queries = new $70fd6868680e912c$var$is((t)=>$70fd6868680e912c$var$_n(t), $70fd6868680e912c$var$dn), this.onlineState = "Unknown" /* Unknown */ , this.Tu = new Set;
    }
}
async function $70fd6868680e912c$var$Qu(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = e.query;
    let i = !1, r = n.queries.get(s);
    if (r || (i = !0, r = new $70fd6868680e912c$var$Ku), i) try {
        r.Iu = await n.onListen(s);
    } catch (t) {
        const n = $70fd6868680e912c$var$Bu(t, `Initialization of query '${$70fd6868680e912c$var$wn(e.query)}' failed`);
        return void e.onError(n);
    }
    if (n.queries.set(s, r), r.listeners.push(e), // Run global snapshot listeners if a consistent snapshot has been emitted.
    e.Eu(n.onlineState), r.Iu) e.Au(r.Iu) && $70fd6868680e912c$var$Hu(n);
}
async function $70fd6868680e912c$var$ju(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = e.query;
    let i = !1;
    const r = n.queries.get(s);
    if (r) {
        const t = r.listeners.indexOf(e);
        t >= 0 && (r.listeners.splice(t, 1), i = 0 === r.listeners.length);
    }
    if (i) return n.queries.delete(s), n.onUnlisten(s);
}
function $70fd6868680e912c$var$Wu(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    let s = !1;
    for (const t of e){
        const e = t.query, i = n.queries.get(e);
        if (i) {
            for (const e of i.listeners)e.Au(t) && (s = !0);
            i.Iu = t;
        }
    }
    s && $70fd6868680e912c$var$Hu(n);
}
function $70fd6868680e912c$var$zu(t, e, n) {
    const s = $70fd6868680e912c$var$K(t), i = s.queries.get(e);
    if (i) for (const t of i.listeners)t.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    s.queries.delete(e);
}
// Call all global snapshot listeners that have been set.
function $70fd6868680e912c$var$Hu(t) {
    t.Tu.forEach((t)=>{
        t.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $70fd6868680e912c$var$Ju {
    constructor(t, e, n){
        this.query = t, this.Ru = e, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.bu = !1, this.Pu = null, this.onlineState = "Unknown" /* Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Au(t) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const e = [];
            for (const n of t.docChanges)3 /* Metadata */  !== n.type && e.push(n);
            t = new $70fd6868680e912c$var$qu(t.query, t.docs, t.oldDocs, e, t.mutatedKeys, t.fromCache, t.syncStateChanged, /* excludesMetadataChanges= */ !0);
        }
        let e = !1;
        return this.bu ? this.vu(t) && (this.Ru.next(t), e = !0) : this.Vu(t, this.onlineState) && (this.Su(t), e = !0), this.Pu = t, e;
    }
    onError(t) {
        this.Ru.error(t);
    }
    /** Returns whether a snapshot was raised. */ Eu(t) {
        this.onlineState = t;
        let e = !1;
        return this.Pu && !this.bu && this.Vu(this.Pu, t) && (this.Su(this.Pu), e = !0), e;
    }
    Vu(t, e) {
        // Always raise the first event when we're synced
        if (!t.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* Offline */  !== e;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Du || !n) && (!t.docs.isEmpty() || "Offline" /* Offline */  === e);
    // Raise data from cache if we have any documents or we are offline
    }
    vu(t) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (t.docChanges.length > 0) return !0;
        const e = this.Pu && this.Pu.hasPendingWrites !== t.hasPendingWrites;
        return !(!t.syncStateChanged && !e) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    Su(t) {
        t = $70fd6868680e912c$var$qu.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache), this.bu = !0, this.Ru.next(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $70fd6868680e912c$var$Yu {
    constructor(t, // How many bytes this element takes to store in the bundle.
    e){
        this.payload = t, this.byteLength = e;
    }
    Cu() {
        return "metadata" in this.payload;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $70fd6868680e912c$var$Xu {
    constructor(t){
        this.wt = t;
    }
    Wi(t) {
        return $70fd6868680e912c$var$Fs(this.wt, t);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ zi(t) {
        return t.metadata.exists ? $70fd6868680e912c$var$Ks(this.wt, t.document, !1) : $70fd6868680e912c$var$xe.newNoDocument(this.Wi(t.metadata.name), this.Hi(t.metadata.readTime));
    }
    Hi(t) {
        return $70fd6868680e912c$var$Ns(t);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $70fd6868680e912c$var$Zu {
    constructor(t, e, n){
        this.xu = t, this.localStore = e, this.wt = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $70fd6868680e912c$var$tc(t);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Nu(t) {
        this.progress.bytesLoaded += t.byteLength;
        let e = this.progress.documentsLoaded;
        if (t.payload.namedQuery) this.queries.push(t.payload.namedQuery);
        else if (t.payload.documentMetadata) {
            this.documents.push({
                metadata: t.payload.documentMetadata
            }), t.payload.documentMetadata.exists || ++e;
            const n = $70fd6868680e912c$var$ht.fromString(t.payload.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else t.payload.document && (this.documents[this.documents.length - 1].document = t.payload.document, ++e);
        return e !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = e, Object.assign({}, this.progress)) : null;
    }
    ku(t) {
        const e = new Map, n = new $70fd6868680e912c$var$Xu(this.wt);
        for (const s of t)if (s.metadata.queries) {
            const t = n.Wi(s.metadata.name);
            for (const n of s.metadata.queries){
                const s = (e.get(n) || $70fd6868680e912c$var$ws()).add(t);
                e.set(n, s);
            }
        }
        return e;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const t = await $70fd6868680e912c$var$Fo(this.localStore, new $70fd6868680e912c$var$Xu(this.wt), this.documents, this.xu.id), e = this.ku(this.documents);
        for (const t of this.queries)await $70fd6868680e912c$var$$o(this.localStore, t, e.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ou: this.collectionGroups,
            Mu: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $70fd6868680e912c$var$tc(t) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: t.totalDocuments,
        totalBytes: t.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ec {
    constructor(t){
        this.key = t;
    }
}
class $70fd6868680e912c$var$nc {
    constructor(t){
        this.key = t;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $70fd6868680e912c$var$sc {
    constructor(t, /** Documents included in the remote target */ e){
        this.query = t, this.Fu = e, this.$u = null, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Bu = $70fd6868680e912c$var$ws(), /** Document Keys that have local changes */ this.mutatedKeys = $70fd6868680e912c$var$ws(), this.Lu = $70fd6868680e912c$var$yn(t), this.Uu = new $70fd6868680e912c$var$Lu(this.Lu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get qu() {
        return this.Fu;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ Ku(t, e) {
        const n = e ? e.Gu : new $70fd6868680e912c$var$Uu, s = e ? e.Uu : this.Uu;
        let i = e ? e.mutatedKeys : this.mutatedKeys, r = s, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const u = "F" /* First */  === this.query.limitType && s.size === this.query.limit ? s.last() : null, c = "L" /* Last */  === this.query.limitType && s.size === this.query.limit ? s.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (t.inorderTraversal((t, e)=>{
            const a = s.get(t), h = $70fd6868680e912c$var$mn(this.query, e) ? e : null, l = !!a && this.mutatedKeys.has(a.key), f = !!h && (h.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(h.key) && h.hasCommittedMutations);
            let d = !1;
            // Calculate change
            if (a && h) a.data.isEqual(h.data) ? l !== f && (n.track({
                type: 3 /* Metadata */ ,
                doc: h
            }), d = !0) : this.Qu(a, h) || (n.track({
                type: 2 /* Modified */ ,
                doc: h
            }), d = !0, (u && this.Lu(h, u) > 0 || c && this.Lu(h, c) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !a && h ? (n.track({
                type: 0 /* Added */ ,
                doc: h
            }), d = !0) : a && !h && (n.track({
                type: 1 /* Removed */ ,
                doc: a
            }), d = !0, (u || c) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            d && (h ? (r = r.add(h), i = f ? i.add(t) : i.delete(t)) : (r = r.delete(t), i = i.delete(t)));
        }), null !== this.query.limit) for(; r.size > this.query.limit;){
            const t = "F" /* First */  === this.query.limitType ? r.last() : r.first();
            r = r.delete(t.key), i = i.delete(t.key), n.track({
                type: 1 /* Removed */ ,
                doc: t
            });
        }
        return {
            Uu: r,
            Gu: n,
            Oi: o,
            mutatedKeys: i
        };
    }
    Qu(t, e) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return t.hasLocalMutations && e.hasCommittedMutations && !e.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(t, e, n) {
        const s = this.Uu;
        this.Uu = t.Uu, this.mutatedKeys = t.mutatedKeys;
        // Sort changes based on type and query comparator
        const i = t.Gu.pu();
        i.sort((t, e)=>(function(t, e) {
                const n = (t)=>{
                    switch(t){
                        case 0 /* Added */ :
                            return 1;
                        case 2 /* Modified */ :
                        case 3 /* Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* Removed */ :
                            return 0;
                        default:
                            return $70fd6868680e912c$var$L();
                    }
                };
                return n(t) - n(e);
            })(t.type, e.type) || this.Lu(t.doc, e.doc)), this.ju(n);
        const r = e ? this.Wu() : [], o = 0 === this.Bu.size && this.current ? 1 /* Synced */  : 0 /* Local */ , u = o !== this.$u;
        if (this.$u = o, 0 !== i.length || u) return {
            snapshot: new $70fd6868680e912c$var$qu(this.query, t.Uu, s, i, t.mutatedKeys, 0 /* Local */  === o, u, /* excludesMetadataChanges= */ !1),
            zu: r
        };
        // no changes
        return {
            zu: r
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Eu(t) {
        return this.current && "Offline" /* Offline */  === t ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            Uu: this.Uu,
            Gu: new $70fd6868680e912c$var$Uu,
            mutatedKeys: this.mutatedKeys,
            Oi: !1
        }, /* updateLimboDocuments= */ !1)) : {
            zu: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ Hu(t) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Fu.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.Uu.has(t) && !this.Uu.get(t).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ ju(t) {
        t && (t.addedDocuments.forEach((t)=>this.Fu = this.Fu.add(t)), t.modifiedDocuments.forEach((t)=>{}), t.removedDocuments.forEach((t)=>this.Fu = this.Fu.delete(t)), this.current = t.current);
    }
    Wu() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const t = this.Bu;
        this.Bu = $70fd6868680e912c$var$ws(), this.Uu.forEach((t)=>{
            this.Hu(t.key) && (this.Bu = this.Bu.add(t.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const e = [];
        return t.forEach((t)=>{
            this.Bu.has(t) || e.push(new $70fd6868680e912c$var$nc(t));
        }), this.Bu.forEach((n)=>{
            t.has(n) || e.push(new $70fd6868680e912c$var$ec(n));
        }), e;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    Ju(t) {
        this.Fu = t.ji, this.Bu = $70fd6868680e912c$var$ws();
        const e = this.Ku(t.documents);
        return this.applyChanges(e, /*updateLimboDocuments=*/ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Yu() {
        return $70fd6868680e912c$var$qu.fromInitialDocuments(this.query, this.Uu, this.mutatedKeys, 0 /* Local */  === this.$u);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $70fd6868680e912c$var$ic {
    constructor(/**
     * The query itself.
     */ t, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ e, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = t, this.targetId = e, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $70fd6868680e912c$var$rc {
    constructor(t){
        this.key = t, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Xu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$oc {
    constructor(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    s, i, r){
        this.localStore = t, this.remoteStore = e, this.eventManager = n, this.sharedClientState = s, this.currentUser = i, this.maxConcurrentLimboResolutions = r, this.Zu = {}, this.tc = new $70fd6868680e912c$var$is((t)=>$70fd6868680e912c$var$_n(t), $70fd6868680e912c$var$dn), this.ec = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.nc = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.sc = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.ic = new Map, this.rc = new $70fd6868680e912c$var$io, /** Stores user completion handlers, indexed by User and BatchId. */ this.oc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.uc = new Map, this.cc = $70fd6868680e912c$var$kr.Rn(), this.onlineState = "Unknown" /* Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.ac = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.ac;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $70fd6868680e912c$var$uc(t, e) {
    const n = $70fd6868680e912c$var$Mc(t);
    let s, i;
    const r = n.tc.get(e);
    if (r) // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    s = r.targetId, n.sharedClientState.addLocalQueryTarget(s), i = r.view.Yu();
    else {
        const t = await $70fd6868680e912c$var$Co(n.localStore, $70fd6868680e912c$var$ln(e));
        n.isPrimaryClient && $70fd6868680e912c$var$fu(n.remoteStore, t);
        const r = n.sharedClientState.addLocalQueryTarget(t.targetId);
        s = t.targetId, i = await $70fd6868680e912c$var$cc(n, e, s, "current" === r);
    }
    return i;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $70fd6868680e912c$var$cc(t, e, n, s) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    t.hc = (e, n, s)=>(async function(t, e, n, s) {
            let i = e.view.Ku(n);
            i.Oi && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $70fd6868680e912c$var$No(t.localStore, e.query, /* usePreviousResults= */ !1).then(({ documents: t })=>e.view.Ku(t, i)));
            const r = s && s.targetChanges.get(e.targetId), o = e.view.applyChanges(i, /* updateLimboDocuments= */ t.isPrimaryClient, r);
            return $70fd6868680e912c$var$Tc(t, e.targetId, o.zu), o.snapshot;
        })(t, e, n, s);
    const i = await $70fd6868680e912c$var$No(t.localStore, e, /* usePreviousResults= */ !0), r = new $70fd6868680e912c$var$sc(e, i.ji), o = r.Ku(i.documents), u = $70fd6868680e912c$var$ps.createSynthesizedTargetChangeForCurrentChange(n, s && "Offline" /* Offline */  !== t.onlineState), c = r.applyChanges(o, /* updateLimboDocuments= */ t.isPrimaryClient, u);
    $70fd6868680e912c$var$Tc(t, n, c.zu);
    const a = new $70fd6868680e912c$var$ic(e, n, r);
    return t.tc.set(e, a), t.ec.has(n) ? t.ec.get(n).push(e) : t.ec.set(n, [
        e
    ]), c.snapshot;
}
/** Stops listening to the query. */ async function $70fd6868680e912c$var$ac(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = n.tc.get(e), i = n.ec.get(s.targetId);
    if (i.length > 1) return n.ec.set(s.targetId, i.filter((t)=>!$70fd6868680e912c$var$dn(t, e))), void n.tc.delete(e);
    // No other queries are mapped to the target, clean up the query and the target.
    if (n.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        n.sharedClientState.removeLocalQueryTarget(s.targetId);
        n.sharedClientState.isActiveQueryTarget(s.targetId) || await $70fd6868680e912c$var$xo(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            n.sharedClientState.clearQueryState(s.targetId), $70fd6868680e912c$var$du(n.remoteStore, s.targetId), $70fd6868680e912c$var$pc(n, s.targetId);
        }).catch($70fd6868680e912c$var$bt);
    } else $70fd6868680e912c$var$pc(n, s.targetId), await $70fd6868680e912c$var$xo(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !0);
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $70fd6868680e912c$var$hc(t, e, n) {
    const s = $70fd6868680e912c$var$Fc(t);
    try {
        const t = await function(t, e) {
            const n = $70fd6868680e912c$var$K(t), s = $70fd6868680e912c$export$d9bcbd5e1ff81430.now(), i = e.reduce((t, e)=>t.add(e.key), $70fd6868680e912c$var$ws());
            let r, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (t)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let u = $70fd6868680e912c$var$os(), c = $70fd6868680e912c$var$ws();
                return n.Ui.getEntries(t, i).next((t)=>{
                    u = t, u.forEach((t, e)=>{
                        e.isValidDocument() || (c = c.add(t));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(t, u)).next((i)=>{
                    r = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const t of e){
                        const e = $70fd6868680e912c$var$Gn(t, r.get(t.key).overlayedDocument);
                        null != e && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $70fd6868680e912c$var$Wn(t.key, e, $70fd6868680e912c$var$Ce(e.value.mapValue), $70fd6868680e912c$var$$n.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(t, s, o, e);
                }).next((e)=>{
                    o = e;
                    const s = e.applyToLocalDocumentSet(r, c);
                    return n.documentOverlayCache.saveOverlays(t, e.batchId, s);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $70fd6868680e912c$var$as(r)
                }));
        }(s.localStore, e);
        s.sharedClientState.addPendingMutation(t.batchId), function(t, e, n) {
            let s = t.oc[t.currentUser.toKey()];
            s || (s = new $70fd6868680e912c$var$qt($70fd6868680e912c$var$it));
            s = s.insert(e, n), t.oc[t.currentUser.toKey()] = s;
        }(s, t.batchId, n), await $70fd6868680e912c$var$Rc(s, t.changes), await $70fd6868680e912c$var$bu(s.remoteStore);
    } catch (t) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const e = $70fd6868680e912c$var$Bu(t, "Failed to persist write");
        n.reject(e);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $70fd6868680e912c$var$lc(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    try {
        const t = await $70fd6868680e912c$var$Vo(n.localStore, e);
        // Update `receivedDocument` as appropriate for any limbo targets.
        e.targetChanges.forEach((t, e)=>{
            const s = n.ic.get(e);
            s && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($70fd6868680e912c$var$U(t.addedDocuments.size + t.modifiedDocuments.size + t.removedDocuments.size <= 1), t.addedDocuments.size > 0 ? s.Xu = !0 : t.modifiedDocuments.size > 0 ? $70fd6868680e912c$var$U(s.Xu) : t.removedDocuments.size > 0 && ($70fd6868680e912c$var$U(s.Xu), s.Xu = !1));
        }), await $70fd6868680e912c$var$Rc(n, t, e);
    } catch (t) {
        await $70fd6868680e912c$var$bt(t);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $70fd6868680e912c$var$fc(t, e, n) {
    const s = $70fd6868680e912c$var$K(t);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (s.isPrimaryClient && 0 /* RemoteStore */  === n || !s.isPrimaryClient && 1 /* SharedClientState */  === n) {
        const t = [];
        s.tc.forEach((n, s)=>{
            const i = s.view.Eu(e);
            i.snapshot && t.push(i.snapshot);
        }), function(t, e) {
            const n = $70fd6868680e912c$var$K(t);
            n.onlineState = e;
            let s = !1;
            n.queries.forEach((t, n)=>{
                for (const t of n.listeners)// Run global snapshot listeners if a consistent snapshot has been emitted.
                t.Eu(e) && (s = !0);
            }), s && $70fd6868680e912c$var$Hu(n);
        }(s.eventManager, e), t.length && s.Zu.Go(t), s.onlineState = e, s.isPrimaryClient && s.sharedClientState.setOnlineState(e);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $70fd6868680e912c$var$dc(t, e, n) {
    const s = $70fd6868680e912c$var$K(t);
    // PORTING NOTE: Multi-tab only.
    s.sharedClientState.updateQueryState(e, "rejected", n);
    const i = s.ic.get(e), r = i && i.key;
    if (r) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let t = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        t = t.insert(r, $70fd6868680e912c$var$xe.newNoDocument(r, $70fd6868680e912c$var$ct.min()));
        const n = $70fd6868680e912c$var$ws().add(r), i = new $70fd6868680e912c$var$ys($70fd6868680e912c$var$ct.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $70fd6868680e912c$var$Qt($70fd6868680e912c$var$it), t, n);
        await $70fd6868680e912c$var$lc(s, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        s.sc = s.sc.remove(r), s.ic.delete(e), $70fd6868680e912c$var$Ac(s);
    } else await $70fd6868680e912c$var$xo(s.localStore, e, /* keepPersistedTargetData */ !1).then(()=>$70fd6868680e912c$var$pc(s, e, n)).catch($70fd6868680e912c$var$bt);
}
async function $70fd6868680e912c$var$_c(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = e.batch.batchId;
    try {
        const t = await $70fd6868680e912c$var$Po(n.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $70fd6868680e912c$var$yc(n, s, /*error=*/ null), $70fd6868680e912c$var$gc(n, s), n.sharedClientState.updateMutationState(s, "acknowledged"), await $70fd6868680e912c$var$Rc(n, t);
    } catch (t) {
        await $70fd6868680e912c$var$bt(t);
    }
}
async function $70fd6868680e912c$var$wc(t, e, n) {
    const s = $70fd6868680e912c$var$K(t);
    try {
        const t = await function(t, e) {
            const n = $70fd6868680e912c$var$K(t);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (t)=>{
                let s;
                return n.mutationQueue.lookupMutationBatch(t, e).next((e)=>($70fd6868680e912c$var$U(null !== e), s = e.keys(), n.mutationQueue.removeMutationBatch(t, e))).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, s)).next(()=>n.localDocuments.getDocuments(t, s));
            });
        }(s.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $70fd6868680e912c$var$yc(s, e, n), $70fd6868680e912c$var$gc(s, e), s.sharedClientState.updateMutationState(e, "rejected", n), await $70fd6868680e912c$var$Rc(s, t);
    } catch (n) {
        await $70fd6868680e912c$var$bt(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $70fd6868680e912c$var$mc(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    $70fd6868680e912c$var$yu(n.remoteStore) || $70fd6868680e912c$var$M("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const t = await function(t) {
            const e = $70fd6868680e912c$var$K(t);
            return e.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (t)=>e.mutationQueue.getHighestUnacknowledgedBatchId(t));
        }(n.localStore);
        if (-1 === t) // Trigger the callback right away if there is no pending writes at the moment.
        return void e.resolve();
        const s = n.uc.get(t) || [];
        s.push(e), n.uc.set(t, s);
    } catch (t) {
        const n = $70fd6868680e912c$var$Bu(t, "Initialization of waitForPendingWrites() operation failed");
        e.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $70fd6868680e912c$var$gc(t, e) {
    (t.uc.get(e) || []).forEach((t)=>{
        t.resolve();
    }), t.uc.delete(e);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $70fd6868680e912c$var$yc(t, e, n) {
    const s = $70fd6868680e912c$var$K(t);
    let i = s.oc[s.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const t = i.get(e);
        t && (n ? t.reject(n) : t.resolve(), i = i.remove(e)), s.oc[s.currentUser.toKey()] = i;
    }
}
function $70fd6868680e912c$var$pc(t, e, n = null) {
    t.sharedClientState.removeLocalQueryTarget(e);
    for (const s of t.ec.get(e))t.tc.delete(s), n && t.Zu.lc(s, n);
    if (t.ec.delete(e), t.isPrimaryClient) t.rc.us(e).forEach((e)=>{
        t.rc.containsKey(e) || // We removed the last reference for this key
        $70fd6868680e912c$var$Ic(t, e);
    });
}
function $70fd6868680e912c$var$Ic(t, e) {
    t.nc.delete(e.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = t.sc.get(e);
    null !== n && ($70fd6868680e912c$var$du(t.remoteStore, n), t.sc = t.sc.remove(e), t.ic.delete(n), $70fd6868680e912c$var$Ac(t));
}
function $70fd6868680e912c$var$Tc(t, e, n) {
    for (const s of n)if (s instanceof $70fd6868680e912c$var$ec) t.rc.addReference(s.key, e), $70fd6868680e912c$var$Ec(t, s);
    else if (s instanceof $70fd6868680e912c$var$nc) {
        $70fd6868680e912c$var$M("SyncEngine", "Document no longer in limbo: " + s.key), t.rc.removeReference(s.key, e);
        t.rc.containsKey(s.key) || // We removed the last reference for this key
        $70fd6868680e912c$var$Ic(t, s.key);
    } else $70fd6868680e912c$var$L();
}
function $70fd6868680e912c$var$Ec(t, e) {
    const n = e.key, s = n.path.canonicalString();
    t.sc.get(n) || t.nc.has(s) || ($70fd6868680e912c$var$M("SyncEngine", "New document in limbo: " + n), t.nc.add(s), $70fd6868680e912c$var$Ac(t));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $70fd6868680e912c$var$Ac(t) {
    for(; t.nc.size > 0 && t.sc.size < t.maxConcurrentLimboResolutions;){
        const e = t.nc.values().next().value;
        t.nc.delete(e);
        const n = new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ht.fromString(e)), s = t.cc.next();
        t.ic.set(s, new $70fd6868680e912c$var$rc(n)), t.sc = t.sc.insert(n, s), $70fd6868680e912c$var$fu(t.remoteStore, new $70fd6868680e912c$var$Li($70fd6868680e912c$var$ln($70fd6868680e912c$var$rn(n.path)), s, 2 /* LimboResolution */ , $70fd6868680e912c$var$$t.ot));
    }
}
async function $70fd6868680e912c$var$Rc(t, e, n) {
    const s = $70fd6868680e912c$var$K(t), i = [], r = [], o = [];
    s.tc.isEmpty() || (s.tc.forEach((t, u)=>{
        o.push(s.hc(u, e, n).then((t)=>{
            if (t) {
                s.isPrimaryClient && s.sharedClientState.updateQueryState(u.targetId, t.fromCache ? "not-current" : "current"), i.push(t);
                const e = $70fd6868680e912c$var$To.Vi(u.targetId, t);
                r.push(e);
            }
        }));
    }), await Promise.all(o), s.Zu.Go(i), await async function(t, e) {
        const n = $70fd6868680e912c$var$K(t);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (t)=>$70fd6868680e912c$var$Pt.forEach(e, (e)=>$70fd6868680e912c$var$Pt.forEach(e.Pi, (s)=>n.persistence.referenceDelegate.addReference(t, e.targetId, s)).next(()=>$70fd6868680e912c$var$Pt.forEach(e.vi, (s)=>n.persistence.referenceDelegate.removeReference(t, e.targetId, s)))));
        } catch (t) {
            if (!$70fd6868680e912c$var$Ct(t)) throw t;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $70fd6868680e912c$var$M("LocalStore", "Failed to update sequence numbers: " + t);
        }
        for (const t of e){
            const e = t.targetId;
            if (!t.fromCache) {
                const t = n.$i.get(e), s = t.snapshotVersion, i = t.withLastLimboFreeSnapshotVersion(s);
                // Advance the last limbo free snapshot version
                n.$i = n.$i.insert(e, i);
            }
        }
    }(s.localStore, r));
}
async function $70fd6868680e912c$var$bc(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    if (!n.currentUser.isEqual(e)) {
        $70fd6868680e912c$var$M("SyncEngine", "User change. New user:", e.toKey());
        const t = await $70fd6868680e912c$var$bo(n.localStore, e);
        n.currentUser = e, // Fails tasks waiting for pending writes requested by previous user.
        function(t, e) {
            t.uc.forEach((t)=>{
                t.forEach((t)=>{
                    t.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.CANCELLED, e));
                });
            }), t.uc.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(e, t.removedBatchIds, t.addedBatchIds), await $70fd6868680e912c$var$Rc(n, t.Ki);
    }
}
function $70fd6868680e912c$var$Pc(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = n.ic.get(e);
    if (s && s.Xu) return $70fd6868680e912c$var$ws().add(s.key);
    {
        let t = $70fd6868680e912c$var$ws();
        const s = n.ec.get(e);
        if (!s) return t;
        for (const e of s){
            const s = n.tc.get(e);
            t = t.unionWith(s.view.qu);
        }
        return t;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $70fd6868680e912c$var$vc(t, e) {
    const n = $70fd6868680e912c$var$K(t), s = await $70fd6868680e912c$var$No(n.localStore, e.query, /* usePreviousResults= */ !0), i = e.view.Ju(s);
    return n.isPrimaryClient && $70fd6868680e912c$var$Tc(n, e.targetId, i.zu), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$Vc(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    return $70fd6868680e912c$var$Oo(n.localStore, e).then((t)=>$70fd6868680e912c$var$Rc(n, t));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$Sc(t, e, n, s) {
    const i = $70fd6868680e912c$var$K(t), r = await function(t, e) {
        const n = $70fd6868680e912c$var$K(t), s = $70fd6868680e912c$var$K(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (t)=>s.yn(t, e).next((e)=>e ? n.localDocuments.getDocuments(t, e) : $70fd6868680e912c$var$Pt.resolve(null)));
    }(i.localStore, e);
    null !== r ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $70fd6868680e912c$var$bu(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($70fd6868680e912c$var$yc(i, e, s || null), $70fd6868680e912c$var$gc(i, e), function(t, e) {
        $70fd6868680e912c$var$K($70fd6868680e912c$var$K(t).mutationQueue).In(e);
    }(i.localStore, e)) : $70fd6868680e912c$var$L(), await $70fd6868680e912c$var$Rc(i, r)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $70fd6868680e912c$var$M("SyncEngine", "Cannot apply mutation batch with id: " + e);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$Dc(t, e) {
    const n = $70fd6868680e912c$var$K(t);
    if ($70fd6868680e912c$var$Mc(n), $70fd6868680e912c$var$Fc(n), !0 === e && !0 !== n.ac) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const t = n.sharedClientState.getAllActiveQueryTargets(), e = await $70fd6868680e912c$var$Cc(n, t.toArray());
        n.ac = !0, await $70fd6868680e912c$var$Ou(n.remoteStore, !0);
        for (const t of e)$70fd6868680e912c$var$fu(n.remoteStore, t);
    } else if (!1 === e && !1 !== n.ac) {
        const t = [];
        let e = Promise.resolve();
        n.ec.forEach((s, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? t.push(i) : e = e.then(()=>($70fd6868680e912c$var$pc(n, i), $70fd6868680e912c$var$xo(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $70fd6868680e912c$var$du(n.remoteStore, i);
        }), await e, await $70fd6868680e912c$var$Cc(n, t), // PORTING NOTE: Multi-Tab only.
        function(t) {
            const e = $70fd6868680e912c$var$K(t);
            e.ic.forEach((t, n)=>{
                $70fd6868680e912c$var$du(e.remoteStore, n);
            }), e.rc.cs(), e.ic = new Map, e.sc = new $70fd6868680e912c$var$qt($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(n), n.ac = !1, await $70fd6868680e912c$var$Ou(n.remoteStore, !1);
    }
}
async function $70fd6868680e912c$var$Cc(t, e, n) {
    const s = $70fd6868680e912c$var$K(t), i = [], r = [];
    for (const t of e){
        let e;
        const n = s.ec.get(t);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            e = await $70fd6868680e912c$var$Co(s.localStore, $70fd6868680e912c$var$ln(n[0]));
            for (const t of n){
                const e = s.tc.get(t), n = await $70fd6868680e912c$var$vc(s, e);
                n.snapshot && r.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $70fd6868680e912c$var$ko(s.localStore, t);
            e = await $70fd6868680e912c$var$Co(s.localStore, n), await $70fd6868680e912c$var$cc(s, $70fd6868680e912c$var$xc(n), t, /*current=*/ !1);
        }
        i.push(e);
    }
    return s.Zu.Go(r), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$xc(t) {
    return $70fd6868680e912c$var$sn(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* First */ , t.startAt, t.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$Nc(t) {
    const e = $70fd6868680e912c$var$K(t);
    return $70fd6868680e912c$var$K($70fd6868680e912c$var$K(e.localStore).persistence).Ri();
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$kc(t, e, n, s) {
    const i = $70fd6868680e912c$var$K(t);
    if (i.ac) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $70fd6868680e912c$var$M("SyncEngine", "Ignoring unexpected query state notification.");
    const r = i.ec.get(e);
    if (r && r.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const t = await $70fd6868680e912c$var$Oo(i.localStore, $70fd6868680e912c$var$gn(r[0])), s = $70fd6868680e912c$var$ys.createSynthesizedRemoteEventForCurrentChange(e, "current" === n);
                await $70fd6868680e912c$var$Rc(i, t, s);
                break;
            }
        case "rejected":
            await $70fd6868680e912c$var$xo(i.localStore, e, /* keepPersistedTargetData */ !0), $70fd6868680e912c$var$pc(i, e, s);
            break;
        default:
            $70fd6868680e912c$var$L();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $70fd6868680e912c$var$Oc(t, e, n) {
    const s = $70fd6868680e912c$var$Mc(t);
    if (s.ac) {
        for (const t of e){
            if (s.ec.has(t)) {
                // A target might have been added in a previous attempt
                $70fd6868680e912c$var$M("SyncEngine", "Adding an already active target " + t);
                continue;
            }
            const e = await $70fd6868680e912c$var$ko(s.localStore, t), n = await $70fd6868680e912c$var$Co(s.localStore, e);
            await $70fd6868680e912c$var$cc(s, $70fd6868680e912c$var$xc(e), n.targetId, /*current=*/ !1), $70fd6868680e912c$var$fu(s.remoteStore, n);
        }
        for (const t of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        s.ec.has(t) && // Release queries that are still active.
        await $70fd6868680e912c$var$xo(s.localStore, t, /* keepPersistedTargetData */ !1).then(()=>{
            $70fd6868680e912c$var$du(s.remoteStore, t), $70fd6868680e912c$var$pc(s, t);
        }).catch($70fd6868680e912c$var$bt);
    }
}
function $70fd6868680e912c$var$Mc(t) {
    const e = $70fd6868680e912c$var$K(t);
    return e.remoteStore.remoteSyncer.applyRemoteEvent = $70fd6868680e912c$var$lc.bind(null, e), e.remoteStore.remoteSyncer.getRemoteKeysForTarget = $70fd6868680e912c$var$Pc.bind(null, e), e.remoteStore.remoteSyncer.rejectListen = $70fd6868680e912c$var$dc.bind(null, e), e.Zu.Go = $70fd6868680e912c$var$Wu.bind(null, e.eventManager), e.Zu.lc = $70fd6868680e912c$var$zu.bind(null, e.eventManager), e;
}
function $70fd6868680e912c$var$Fc(t) {
    const e = $70fd6868680e912c$var$K(t);
    return e.remoteStore.remoteSyncer.applySuccessfulWrite = $70fd6868680e912c$var$_c.bind(null, e), e.remoteStore.remoteSyncer.rejectFailedWrite = $70fd6868680e912c$var$wc.bind(null, e), e;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $70fd6868680e912c$var$$c(t, e, n) {
    const s = $70fd6868680e912c$var$K(t);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function(t, e, n) {
        try {
            const s = await e.getMetadata();
            if (await function(t, e) {
                const n = $70fd6868680e912c$var$K(t), s = $70fd6868680e912c$var$Ns(e.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (t)=>n.Ds.getBundleMetadata(t, e.id)).then((t)=>!!t && t.createTime.compareTo(s) >= 0);
            }(t.localStore, s)) return await e.close(), n._completeWith(function(t) {
                return {
                    taskState: "Success",
                    documentsLoaded: t.totalDocuments,
                    bytesLoaded: t.totalBytes,
                    totalDocuments: t.totalDocuments,
                    totalBytes: t.totalBytes
                };
            }(s)), Promise.resolve(new Set);
            n._updateProgress($70fd6868680e912c$var$tc(s));
            const i = new $70fd6868680e912c$var$Zu(s, t.localStore, e.wt);
            let r = await e.fc();
            for(; r;){
                const t = await i.Nu(r);
                t && n._updateProgress(t), r = await e.fc();
            }
            const o = await i.complete();
            return await $70fd6868680e912c$var$Rc(t, o.Mu, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function(t, e) {
                const n = $70fd6868680e912c$var$K(t);
                return n.persistence.runTransaction("Save bundle", "readwrite", (t)=>n.Ds.saveBundleMetadata(t, e));
            }(t.localStore, s), n._completeWith(o.progress), Promise.resolve(o.Ou);
        } catch (t) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${t}`), n._failWith(t), Promise.resolve(new Set);
        }
    })(s, e, n).then((t)=>{
        s.sharedClientState.notifyBundleLoaded(t);
    });
}
class $70fd6868680e912c$var$Bc {
    constructor(){
        this.synchronizeTabs = !1;
    }
    async initialize(t) {
        this.wt = $70fd6868680e912c$var$nu(t.databaseInfo.databaseId), this.sharedClientState = this.dc(t), this.persistence = this._c(t), await this.persistence.start(), this.localStore = this.wc(t), this.gcScheduler = this.mc(t, this.localStore), this.indexBackfillerScheduler = this.gc(t, this.localStore);
    }
    mc(t, e) {
        return null;
    }
    gc(t, e) {
        return null;
    }
    wc(t) {
        return $70fd6868680e912c$var$Ro(this.persistence, new $70fd6868680e912c$var$Eo, t.initialUser, this.wt);
    }
    _c(t) {
        return new $70fd6868680e912c$var$ho($70fd6868680e912c$var$fo.Ms, this.wt);
    }
    dc(t) {
        return new $70fd6868680e912c$var$zo;
    }
    async terminate() {
        this.gcScheduler && this.gcScheduler.stop(), await this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $70fd6868680e912c$var$Lc extends $70fd6868680e912c$var$Bc {
    constructor(t, e, n){
        super(), this.yc = t, this.cacheSizeBytes = e, this.forceOwnership = n, this.synchronizeTabs = !1;
    }
    async initialize(t) {
        await super.initialize(t), await this.yc.initialize(this, t), // Enqueue writes from a previous session
        await $70fd6868680e912c$var$Fc(this.yc.syncEngine), await $70fd6868680e912c$var$bu(this.yc.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ci(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    wc(t) {
        return $70fd6868680e912c$var$Ro(this.persistence, new $70fd6868680e912c$var$Eo, t.initialUser, this.wt);
    }
    mc(t, e) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$Ur(n, t.asyncQueue, e);
    }
    gc(t, e) {
        const n = new $70fd6868680e912c$var$Ft(e, this.persistence);
        return new $70fd6868680e912c$var$Mt(t.asyncQueue, n);
    }
    _c(t) {
        const e = $70fd6868680e912c$var$Io(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$Pr.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$Pr.DEFAULT;
        return new $70fd6868680e912c$var$go(this.synchronizeTabs, e, t.clientId, n, t.asyncQueue, $70fd6868680e912c$var$tu(), $70fd6868680e912c$var$eu(), this.wt, this.sharedClientState, !!this.forceOwnership);
    }
    dc(t) {
        return new $70fd6868680e912c$var$zo;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $70fd6868680e912c$var$Uc extends $70fd6868680e912c$var$Lc {
    constructor(t, e){
        super(t, e, /* forceOwnership= */ !1), this.yc = t, this.cacheSizeBytes = e, this.synchronizeTabs = !0;
    }
    async initialize(t) {
        await super.initialize(t);
        const e = this.yc.syncEngine;
        this.sharedClientState instanceof $70fd6868680e912c$var$Wo && (this.sharedClientState.syncEngine = {
            kr: $70fd6868680e912c$var$Sc.bind(null, e),
            Or: $70fd6868680e912c$var$kc.bind(null, e),
            Mr: $70fd6868680e912c$var$Oc.bind(null, e),
            Ri: $70fd6868680e912c$var$Nc.bind(null, e),
            Nr: $70fd6868680e912c$var$Vc.bind(null, e)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ci(async (t)=>{
            await $70fd6868680e912c$var$Dc(this.yc.syncEngine, t), this.gcScheduler && (t && !this.gcScheduler.started ? this.gcScheduler.start() : t || this.gcScheduler.stop()), this.indexBackfillerScheduler && (t && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : t || this.indexBackfillerScheduler.stop());
        });
    }
    dc(t) {
        const e = $70fd6868680e912c$var$tu();
        if (!$70fd6868680e912c$var$Wo.V(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $70fd6868680e912c$var$Io(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey);
        return new $70fd6868680e912c$var$Wo(e, t.asyncQueue, n, t.clientId, t.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $70fd6868680e912c$var$qc {
    async initialize(t, e) {
        this.localStore || (this.localStore = t.localStore, this.sharedClientState = t.sharedClientState, this.datastore = this.createDatastore(e), this.remoteStore = this.createRemoteStore(e), this.eventManager = this.createEventManager(e), this.syncEngine = this.createSyncEngine(e, /* startAsPrimary=*/ !t.synchronizeTabs), this.sharedClientState.onlineStateHandler = (t)=>$70fd6868680e912c$var$fc(this.syncEngine, t, 1 /* SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $70fd6868680e912c$var$bc.bind(null, this.syncEngine), await $70fd6868680e912c$var$Ou(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(t) {
        return new $70fd6868680e912c$var$Gu;
    }
    createDatastore(t) {
        const e = $70fd6868680e912c$var$nu(t.databaseInfo.databaseId), n = (s = t.databaseInfo, new $70fd6868680e912c$var$Zo(s));
        var s;
        /** Return the Platform-specific connectivity monitor. */ return function(t, e, n, s) {
            return new $70fd6868680e912c$var$uu(t, e, n, s);
        }(t.authCredentials, t.appCheckCredentials, n, e);
    }
    createRemoteStore(t) {
        var e, n, s, i, r;
        return e = this.localStore, n = this.datastore, s = t.asyncQueue, i = (t)=>$70fd6868680e912c$var$fc(this.syncEngine, t, 0 /* RemoteStore */ ), r = $70fd6868680e912c$var$Jo.V() ? new $70fd6868680e912c$var$Jo : new $70fd6868680e912c$var$Ho, new $70fd6868680e912c$var$au(e, n, s, i, r);
    /** Re-enables the network. Idempotent. */ }
    createSyncEngine(t, e) {
        return function(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        s, i, r, o) {
            const u = new $70fd6868680e912c$var$oc(t, e, n, s, i, r);
            return o && (u.ac = !0), u;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, e);
    }
    terminate() {
        return async function(t) {
            const e = $70fd6868680e912c$var$K(t);
            $70fd6868680e912c$var$M("RemoteStore", "RemoteStore shutting down."), e.lu.add(5 /* Shutdown */ ), await $70fd6868680e912c$var$lu(e), e.du.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            e._u.set("Unknown" /* Unknown */ );
        }(this.remoteStore);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $70fd6868680e912c$var$Kc(t, e = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < t.byteLength) {
                const s = {
                    value: t.slice(n, n + e),
                    done: !1
                };
                return n += e, s;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.reject("unimplemented")
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $70fd6868680e912c$var$Gc {
    constructor(t){
        this.observer = t, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(t) {
        this.observer.next && this.Ic(this.observer.next, t);
    }
    error(t) {
        this.observer.error ? this.Ic(this.observer.error, t) : console.error("Uncaught Error in snapshot listener:", t);
    }
    Tc() {
        this.muted = !0;
    }
    Ic(t, e) {
        this.muted || setTimeout(()=>{
            this.muted || t(e);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $70fd6868680e912c$var$Qc {
    constructor(/** The reader to read from underlying binary bundle data source. */ t, e){
        this.Ec = t, this.wt = e, /** Cached bundle metadata. */ this.metadata = new $70fd6868680e912c$var$j, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Ac = new TextDecoder("utf-8"), // Read the metadata (which is the first element).
        this.Rc().then((t)=>{
            t && t.Cu() ? this.metadata.resolve(t.payload.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == t ? void 0 : t.payload)}`));
        }, (t)=>this.metadata.reject(t));
    }
    close() {
        return this.Ec.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async fc() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.Rc();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async Rc() {
        const t = await this.bc();
        if (null === t) return null;
        const e = this.Ac.decode(t), n = Number(e);
        isNaN(n) && this.Pc(`length string (${e}) is not valid number`);
        const s = await this.vc(n);
        return new $70fd6868680e912c$var$Yu(JSON.parse(s), t.length + n);
    }
    /** First index of '{' from the underlying buffer. */ Vc() {
        return this.buffer.findIndex((t)=>t === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async bc() {
        for(; this.Vc() < 0;){
            if (await this.Sc()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const t = this.Vc();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        t < 0 && this.Pc("Reached the end of bundle when a length string is expected.");
        const e = this.buffer.slice(0, t);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(t), e;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async vc(t) {
        for(; this.buffer.length < t;)await this.Sc() && this.Pc("Reached the end of bundle when more is expected.");
        const e = this.Ac.decode(this.buffer.slice(0, t));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(t), e;
    }
    Pc(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Ec.cancel(), new Error(`Invalid bundle format: ${t}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Sc() {
        const t = await this.Ec.read();
        if (!t.done) {
            const e = new Uint8Array(this.buffer.length + t.value.length);
            e.set(this.buffer), e.set(t.value, this.buffer.length), this.buffer = e;
        }
        return t.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $70fd6868680e912c$var$jc {
    constructor(t){
        this.datastore = t, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastWriteError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(t) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
        const e = await async function(t, e) {
            const n = $70fd6868680e912c$var$K(t), s = $70fd6868680e912c$var$Ls(n.wt) + "/documents", i = {
                documents: e.map((t)=>$70fd6868680e912c$var$Ms(n.wt, t))
            }, r = await n.ao("BatchGetDocuments", s, i), o = new Map;
            r.forEach((t)=>{
                const e = $70fd6868680e912c$var$Gs(n.wt, t);
                o.set(e.key.toString(), e);
            });
            const u = [];
            return e.forEach((t)=>{
                const e = o.get(t.toString());
                $70fd6868680e912c$var$U(!!e), u.push(e);
            }), u;
        }(this.datastore, t);
        return e.forEach((t)=>this.recordVersion(t)), e;
    }
    set(t, e) {
        this.write(e.toMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    update(t, e) {
        try {
            this.write(e.toMutation(t, this.preconditionForUpdate(t)));
        } catch (t) {
            this.lastWriteError = t;
        }
        this.writtenDocs.add(t.toString());
    }
    delete(t) {
        this.write(new $70fd6868680e912c$var$Yn(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastWriteError) throw this.lastWriteError;
        const t = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((e)=>{
            t.delete(e.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        t.forEach((t, e)=>{
            const n = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(e);
            this.mutations.push(new $70fd6868680e912c$var$Xn(n, this.precondition(n)));
        }), await async function(t, e) {
            const n = $70fd6868680e912c$var$K(t), s = $70fd6868680e912c$var$Ls(n.wt) + "/documents", i = {
                writes: e.map((t)=>$70fd6868680e912c$var$js(n.wt, t))
            };
            await n.ro("Commit", s, i);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(t) {
        let e;
        if (t.isFoundDocument()) e = t.version;
        else {
            if (!t.isNoDocument()) throw $70fd6868680e912c$var$L();
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            e = $70fd6868680e912c$var$ct.min();
        }
        const n = this.readVersions.get(t.key.toString());
        if (n) {
            if (!e.isEqual(n)) // This transaction will fail no matter what.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(t.key.toString(), e);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(t) {
        const e = this.readVersions.get(t.toString());
        return !this.writtenDocs.has(t.toString()) && e ? $70fd6868680e912c$var$$n.updateTime(e) : $70fd6868680e912c$var$$n.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(t) {
        const e = this.readVersions.get(t.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(t.toString()) && e) {
            if (e.isEqual($70fd6868680e912c$var$ct.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $70fd6868680e912c$var$$n.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $70fd6868680e912c$var$$n.exists(!0);
    }
    write(t) {
        this.ensureCommitNotCalled(), this.mutations.push(t);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $70fd6868680e912c$var$Wc {
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.datastore = e, this.options = n, this.updateFunction = s, this.deferred = i, this.Dc = n.maxAttempts, this.So = new $70fd6868680e912c$var$su(this.asyncQueue, "transaction_retry" /* TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ run() {
        this.Dc -= 1, this.Cc();
    }
    Cc() {
        this.So.Io(async ()=>{
            const t = new $70fd6868680e912c$var$jc(this.datastore), e = this.xc(t);
            e && e.then((e)=>{
                this.asyncQueue.enqueueAndForget(()=>t.commit().then(()=>{
                        this.deferred.resolve(e);
                    }).catch((t)=>{
                        this.Nc(t);
                    }));
            }).catch((t)=>{
                this.Nc(t);
            });
        });
    }
    xc(t) {
        try {
            const e = this.updateFunction(t);
            return !$70fd6868680e912c$var$oe(e) && e.catch && e.then ? e : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(t), null;
        }
    }
    Nc(t) {
        this.Dc > 0 && this.kc(t) ? (this.Dc -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Cc(), Promise.resolve()))) : this.deferred.reject(t);
    }
    kc(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const e = t.code;
            return "aborted" === e || "failed-precondition" === e || !$70fd6868680e912c$var$ns(e);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */ class $70fd6868680e912c$var$zc {
    constructor(t, e, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, s){
        this.authCredentials = t, this.appCheckCredentials = e, this.asyncQueue = n, this.databaseInfo = s, this.user = $70fd6868680e912c$var$C.UNAUTHENTICATED, this.clientId = $70fd6868680e912c$var$st.I(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this.authCredentials.start(n, async (t)=>{
            $70fd6868680e912c$var$M("FirestoreClient", "Received user=", t.uid), await this.authCredentialListener(t), this.user = t;
        }), this.appCheckCredentials.start(n, (t)=>($70fd6868680e912c$var$M("FirestoreClient", "Received new app check token=", t), this.appCheckCredentialListener(t, this.user)));
    }
    async getConfiguration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(t) {
        this.authCredentialListener = t;
    }
    setAppCheckTokenChangeListener(t) {
        this.appCheckCredentialListener = t;
    }
    /**
     * Checks that the client has not been terminated. Ensures that other methods on
     * this class cannot be called after the client is terminated.
     */ verifyNotTerminated() {
        if (this.asyncQueue.isShuttingDown) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const t = new $70fd6868680e912c$var$j;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this.onlineComponents && await this.onlineComponents.terminate(), this.offlineComponents && await this.offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), t.resolve();
            } catch (e) {
                const n = $70fd6868680e912c$var$Bu(e, "Failed to shutdown persistence");
                t.reject(n);
            }
        }), t.promise;
    }
}
async function $70fd6868680e912c$var$Hc(t, e) {
    t.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$M("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = await t.getConfiguration();
    await e.initialize(n);
    let s = n.initialUser;
    t.setCredentialChangeListener(async (t)=>{
        s.isEqual(t) || (await $70fd6868680e912c$var$bo(e.localStore, t), s = t);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    e.persistence.setDatabaseDeletedListener(()=>t.terminate()), t.offlineComponents = e;
}
async function $70fd6868680e912c$var$Jc(t, e) {
    t.asyncQueue.verifyOperationInProgress();
    const n = await $70fd6868680e912c$var$Yc(t);
    $70fd6868680e912c$var$M("FirestoreClient", "Initializing OnlineComponentProvider");
    const s = await t.getConfiguration();
    await e.initialize(n, s), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    t.setCredentialChangeListener((t)=>$70fd6868680e912c$var$ku(e.remoteStore, t)), t.setAppCheckTokenChangeListener((t, n)=>$70fd6868680e912c$var$ku(e.remoteStore, n)), t.onlineComponents = e;
}
async function $70fd6868680e912c$var$Yc(t) {
    return t.offlineComponents || ($70fd6868680e912c$var$M("FirestoreClient", "Using default OfflineComponentProvider"), await $70fd6868680e912c$var$Hc(t, new $70fd6868680e912c$var$Bc)), t.offlineComponents;
}
async function $70fd6868680e912c$var$Xc(t) {
    return t.onlineComponents || ($70fd6868680e912c$var$M("FirestoreClient", "Using default OnlineComponentProvider"), await $70fd6868680e912c$var$Jc(t, new $70fd6868680e912c$var$qc)), t.onlineComponents;
}
function $70fd6868680e912c$var$Zc(t) {
    return $70fd6868680e912c$var$Yc(t).then((t)=>t.persistence);
}
function $70fd6868680e912c$var$ta(t) {
    return $70fd6868680e912c$var$Yc(t).then((t)=>t.localStore);
}
function $70fd6868680e912c$var$ea(t) {
    return $70fd6868680e912c$var$Xc(t).then((t)=>t.remoteStore);
}
function $70fd6868680e912c$var$na(t) {
    return $70fd6868680e912c$var$Xc(t).then((t)=>t.syncEngine);
}
async function $70fd6868680e912c$var$sa(t) {
    const e = await $70fd6868680e912c$var$Xc(t), n = e.eventManager;
    return n.onListen = $70fd6868680e912c$var$uc.bind(null, e.syncEngine), n.onUnlisten = $70fd6868680e912c$var$ac.bind(null, e.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $70fd6868680e912c$var$ia(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $70fd6868680e912c$var$Zc(t), n = await $70fd6868680e912c$var$ea(t);
        return e.setNetworkEnabled(!0), function(t) {
            const e = $70fd6868680e912c$var$K(t);
            return e.lu.delete(0 /* UserDisabled */ ), $70fd6868680e912c$var$hu(e);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $70fd6868680e912c$var$ra(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $70fd6868680e912c$var$Zc(t), n = await $70fd6868680e912c$var$ea(t);
        return e.setNetworkEnabled(!1), async function(t) {
            const e = $70fd6868680e912c$var$K(t);
            e.lu.add(0 /* UserDisabled */ ), await $70fd6868680e912c$var$lu(e), // Set the OnlineState to Offline so get()s return from cache, etc.
            e._u.set("Offline" /* Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $70fd6868680e912c$var$oa(t, e) {
    const n = new $70fd6868680e912c$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await function(t, e) {
                    const n = $70fd6868680e912c$var$K(t);
                    return n.persistence.runTransaction("read document", "readonly", (t)=>n.localDocuments.getDocument(t, e));
                }(t, e);
                s.isFoundDocument() ? n.resolve(s) : s.isNoDocument() ? n.resolve(null) : n.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (t) {
                const s = $70fd6868680e912c$var$Bu(t, `Failed to get document '${e} from cache`);
                n.reject(s);
            }
        })(await $70fd6868680e912c$var$ta(t), e, n)), n.promise;
}
function $70fd6868680e912c$var$ua(t, e, n = {}) {
    const s = new $70fd6868680e912c$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $70fd6868680e912c$var$Gc({
                next: (r)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$70fd6868680e912c$var$ju(t, o));
                    const u = r.docs.has(n);
                    !u && r.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && r.fromCache && s && "server" === s.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(r);
                },
                error: (t)=>i.reject(t)
            }), o = new $70fd6868680e912c$var$Ju($70fd6868680e912c$var$rn(n.path), r, {
                includeMetadataChanges: !0,
                Du: !0
            });
            return $70fd6868680e912c$var$Qu(t, o);
        })(await $70fd6868680e912c$var$sa(t), t.asyncQueue, e, n, s)), s.promise;
}
function $70fd6868680e912c$var$ca(t, e) {
    const n = new $70fd6868680e912c$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await $70fd6868680e912c$var$No(t, e, /* usePreviousResults= */ !0), i = new $70fd6868680e912c$var$sc(e, s.ji), r = i.Ku(s.documents), o = i.applyChanges(r, /* updateLimboDocuments= */ !1);
                n.resolve(o.snapshot);
            } catch (t) {
                const s = $70fd6868680e912c$var$Bu(t, `Failed to execute query '${e} against cache`);
                n.reject(s);
            }
        })(await $70fd6868680e912c$var$ta(t), e, n)), n.promise;
}
function $70fd6868680e912c$var$aa(t, e, n = {}) {
    const s = new $70fd6868680e912c$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $70fd6868680e912c$var$Gc({
                next: (n)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$70fd6868680e912c$var$ju(t, o)), n.fromCache && "server" === s.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (t)=>i.reject(t)
            }), o = new $70fd6868680e912c$var$Ju(n, r, {
                includeMetadataChanges: !0,
                Du: !0
            });
            return $70fd6868680e912c$var$Qu(t, o);
        })(await $70fd6868680e912c$var$sa(t), t.asyncQueue, e, n, s)), s.promise;
}
function $70fd6868680e912c$var$ha(t, e) {
    const n = new $70fd6868680e912c$var$Gc(e);
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
            $70fd6868680e912c$var$K(t).Tu.add(e), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            e.next();
        })(await $70fd6868680e912c$var$sa(t), n)), ()=>{
        n.Tc(), t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
                $70fd6868680e912c$var$K(t).Tu.delete(e);
            })(await $70fd6868680e912c$var$sa(t), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $70fd6868680e912c$var$la(t, e, n) {
    const s = new $70fd6868680e912c$var$j;
    return t.asyncQueue.enqueueAndForget(async ()=>{
        const i = await function(t) {
            return $70fd6868680e912c$var$Xc(t).then((t)=>t.datastore);
        }(t);
        new $70fd6868680e912c$var$Wc(t.asyncQueue, i, n, e, s).run();
    }), s.promise;
}
function $70fd6868680e912c$var$fa(t, e, n, s) {
    const i = function(t, e) {
        let n;
        n = "string" == typeof t ? (new TextEncoder).encode(t) : t;
        return function(t, e) {
            return new $70fd6868680e912c$var$Qc(t, e);
        }(function(t, e) {
            if (t instanceof Uint8Array) return $70fd6868680e912c$var$Kc(t, e);
            if (t instanceof ArrayBuffer) return $70fd6868680e912c$var$Kc(new Uint8Array(t), e);
            if (t instanceof ReadableStream) return t.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), e);
    }(n, $70fd6868680e912c$var$nu(e));
    t.asyncQueue.enqueueAndForget(async ()=>{
        $70fd6868680e912c$var$$c(await $70fd6868680e912c$var$na(t), i, s);
    });
}
function $70fd6868680e912c$var$da(t, e) {
    return t.asyncQueue.enqueue(async ()=>(function(t, e) {
            const n = $70fd6868680e912c$var$K(t);
            return n.persistence.runTransaction("Get named query", "readonly", (t)=>n.Ds.getNamedQuery(t, e));
        })(await $70fd6868680e912c$var$ta(t), e));
}
const $70fd6868680e912c$var$_a = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$wa(t, e, n) {
    if (!n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Function ${t}() cannot be called with an empty ${e}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $70fd6868680e912c$export$8731e8d1617cddb1(t, e, n, s) {
    if (!0 === e && !0 === s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `${t} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $70fd6868680e912c$var$ga(t) {
    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${t} has ${t.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $70fd6868680e912c$var$ya(t) {
    if ($70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${t} has ${t.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $70fd6868680e912c$var$pa(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = `${t.substring(0, 20)}...`), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        {
            const e = /** try to get the constructor name for an object. */ function(t) {
                if (t.constructor) return t.constructor.name;
                return null;
            }(t);
            return e ? `a custom ${e} object` : "an object";
        }
    }
    return "function" == typeof t ? "a function" : $70fd6868680e912c$var$L();
}
function $70fd6868680e912c$export$572106fb5803752c(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    if ("_delegate" in t && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t = t._delegate), !(t instanceof e)) {
        if (e.name === t.constructor.name) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $70fd6868680e912c$var$pa(t);
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Expected type '${e.name}', but it was: ${n}`);
        }
    }
    return t;
}
function $70fd6868680e912c$var$Ta(t, e) {
    if (e <= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Function ${t}() requires a positive number, but it was: ${e}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $70fd6868680e912c$var$Ea {
    constructor(t){
        var e;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = t.host, this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if (this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, void 0 === t.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.useFetchStreams = !!t.useFetchStreams, $70fd6868680e912c$export$8731e8d1617cddb1("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling);
    }
    isEqual(t) {
        return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link getFirestore}.
 */ class $70fd6868680e912c$var$Aa {
    /** @hideconstructor */ constructor(t, e, n){
        this._authCredentials = e, this._appCheckCredentials = n, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $70fd6868680e912c$var$Ea({}), this._settingsFrozen = !1, t instanceof $70fd6868680e912c$export$4c3ccc07620ae30a ? this._databaseId = t : (this._app = t, this._databaseId = function(t) {
            if (!Object.prototype.hasOwnProperty.apply(t.options, [
                "projectId"
            ])) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $70fd6868680e912c$export$4c3ccc07620ae30a(t.options.projectId);
        }(t));
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return void 0 !== this._terminateTask;
    }
    _setSettings(t) {
        if (this._settingsFrozen) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $70fd6868680e912c$var$Ea(t), void 0 !== t.credentials && (this._authCredentials = function(t) {
            if (!t) return new $70fd6868680e912c$export$65ffa50b6039c992;
            switch(t.type){
                case "gapi":
                    const e = t.client;
                    // Make sure this really is a Gapi client.
                    return $70fd6868680e912c$var$U(!("object" != typeof e || null === e || !e.auth || !e.auth.getAuthHeaderValueForFirstParty)), new $70fd6868680e912c$var$X(e, t.sessionIndex || "0", t.iamToken || null);
                case "provider":
                    return t.client;
                default:
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(t.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function(t) {
            const e = $70fd6868680e912c$var$_a.get(t);
            e && ($70fd6868680e912c$var$M("ComponentProvider", "Removing Datastore"), $70fd6868680e912c$var$_a.delete(t), e.terminate());
        }(this), Promise.resolve();
    }
}
function $70fd6868680e912c$export$966a03d25297d115(t, e, n, s = {}) {
    var i;
    const r = (t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$var$Aa))._getSettings();
    if ("firestore.googleapis.com" !== r.host && r.host !== e && $70fd6868680e912c$export$86cd73f49cc6e0bb("Host has been set in both settings() and useEmulator(), emulator host will be used"), t._setSettings(Object.assign(Object.assign({}, r), {
        host: `${e}:${n}`,
        ssl: !1
    })), s.mockUserToken) {
        let e, n;
        if ("string" == typeof s.mockUserToken) e = s.mockUserToken, n = $70fd6868680e912c$var$C.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            e = (0, $c38e0f42709c826a$export$367bf224123348f1)(s.mockUserToken, null === (i = t._app) || void 0 === i ? void 0 : i.options.projectId);
            const r = s.mockUserToken.sub || s.mockUserToken.user_id;
            if (!r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $70fd6868680e912c$var$C(r);
        }
        t._authCredentials = new $70fd6868680e912c$var$H(new $70fd6868680e912c$var$W(e, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $70fd6868680e912c$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = t;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, t, this._key);
    }
}
/**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $70fd6868680e912c$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = t;
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$62297b13309008b2(this.firestore, t, this._query);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link query}).
 */ class $70fd6868680e912c$export$ab5a1a47940a200e extends $70fd6868680e912c$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(t, e, n){
        super(t, e, $70fd6868680e912c$var$rn(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const t = this._path.popLast();
        return t.isEmpty() ? null : new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(t));
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, t, this._path);
    }
}
function $70fd6868680e912c$export$bf5175b0c24981cd(t, e, ...n) {
    if (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), $70fd6868680e912c$var$wa("collection", "path", e), t instanceof $70fd6868680e912c$var$Aa) {
        const s = $70fd6868680e912c$var$ht.fromString(e, ...n);
        return $70fd6868680e912c$var$ya(s), new $70fd6868680e912c$export$ab5a1a47940a200e(t, /* converter= */ null, s);
    }
    {
        if (!(t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($70fd6868680e912c$var$ht.fromString(e, ...n));
        return $70fd6868680e912c$var$ya(s), new $70fd6868680e912c$export$ab5a1a47940a200e(t.firestore, /* converter= */ null, s);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $70fd6868680e912c$export$473d82a73f88c107(t, e) {
    if (t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$var$Aa), $70fd6868680e912c$var$wa("collectionGroup", "collection id", e), e.indexOf("/") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid collection ID '${e}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $70fd6868680e912c$export$62297b13309008b2(t, /* converter= */ null, /**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ function(t) {
        return new $70fd6868680e912c$var$nn($70fd6868680e912c$var$ht.emptyPath(), t);
    }(e));
}
function $70fd6868680e912c$export$2a111da947c407d2(t, e, ...n) {
    if (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (e = $70fd6868680e912c$var$st.I()), $70fd6868680e912c$var$wa("doc", "path", e), t instanceof $70fd6868680e912c$var$Aa) {
        const s = $70fd6868680e912c$var$ht.fromString(e, ...n);
        return $70fd6868680e912c$var$ga(s), new $70fd6868680e912c$export$6be62b059fb12175(t, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
    {
        if (!(t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($70fd6868680e912c$var$ht.fromString(e, ...n));
        return $70fd6868680e912c$var$ga(s), new $70fd6868680e912c$export$6be62b059fb12175(t.firestore, t instanceof $70fd6868680e912c$export$ab5a1a47940a200e ? t.converter : null, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$62a32f2da6187d11(t, e) {
    return t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), (t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && (e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && t.firestore === e.firestore && t.path === e.path && t.converter === e.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$49b1d0de6ba30f41(t, e) {
    return t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t instanceof $70fd6868680e912c$export$62297b13309008b2 && e instanceof $70fd6868680e912c$export$62297b13309008b2 && t.firestore === e.firestore && $70fd6868680e912c$var$dn(t._query, e._query) && t.converter === e.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Na {
    constructor(){
        // The last promise in the queue.
        this.Oc = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Mc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Fc = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.$c = [], // visible for testing
        this.Bc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Lc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Uc = !1, // List of TimerIds to fast-forward delays for.
        this.qc = [], // Backoff timer used to schedule retries for retryable operations
        this.So = new $70fd6868680e912c$var$su(this, "async_queue_retry" /* AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Kc = ()=>{
            const t = $70fd6868680e912c$var$eu();
            t && $70fd6868680e912c$var$M("AsyncQueue", "Visibility state changed to " + t.visibilityState), this.So.Eo();
        };
        const t = $70fd6868680e912c$var$eu();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Kc);
    }
    get isShuttingDown() {
        return this.Fc;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }
    enqueueAndForgetEvenWhileRestricted(t) {
        this.Gc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Qc(t);
    }
    enterRestrictedMode(t) {
        if (!this.Fc) {
            this.Fc = !0, this.Uc = t || !1;
            const e = $70fd6868680e912c$var$eu();
            e && "function" == typeof e.removeEventListener && e.removeEventListener("visibilitychange", this.Kc);
        }
    }
    enqueue(t) {
        if (this.Gc(), this.Fc) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const e = new $70fd6868680e912c$var$j;
        return this.Qc(()=>this.Fc && this.Uc ? Promise.resolve() : (t().then(e.resolve, e.reject), e.promise)).then(()=>e.promise);
    }
    enqueueRetryable(t) {
        this.enqueueAndForget(()=>(this.Mc.push(t), this.jc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async jc() {
        if (0 !== this.Mc.length) {
            try {
                await this.Mc[0](), this.Mc.shift(), this.So.reset();
            } catch (t) {
                if (!$70fd6868680e912c$var$Ct(t)) throw t;
                // Failure will be handled by AsyncQueue
                $70fd6868680e912c$var$M("AsyncQueue", "Operation failed with retryable error: " + t);
            }
            this.Mc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.So.Io(()=>this.jc());
        }
    }
    Qc(t) {
        const e = this.Oc.then(()=>(this.Lc = !0, t().catch((t)=>{
                this.Bc = t, this.Lc = !1;
                const e = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function(t) {
                    let e = t.message || "";
                    t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack);
                    return e;
                }(t);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $70fd6868680e912c$var$F("INTERNAL UNHANDLED ERROR: ", e), t;
            }).then((t)=>(this.Lc = !1, t))));
        return this.Oc = e, e;
    }
    enqueueAfterDelay(t, e, n) {
        this.Gc(), // Fast-forward delays for timerIds that have been overriden.
        this.qc.indexOf(t) > -1 && (e = 0);
        const s = $70fd6868680e912c$var$$u.createAndSchedule(this, t, e, n, (t)=>this.Wc(t));
        return this.$c.push(s), s;
    }
    Gc() {
        this.Bc && $70fd6868680e912c$var$L();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async zc() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let t;
        do t = this.Oc, await t;
        while (t !== this.Oc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Hc(t) {
        for (const e of this.$c)if (e.timerId === t) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Jc(t) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.zc().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            this.$c.sort((t, e)=>t.targetTimeMs - e.targetTimeMs);
            for (const e of this.$c)if (e.skipDelay(), "all" /* All */  !== t && e.timerId === t) break;
            return this.zc();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Yc(t) {
        this.qc.push(t);
    }
    /** Called once a DelayedOperation is run or canceled. */ Wc(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const e = this.$c.indexOf(t);
        this.$c.splice(e, 1);
    }
}
function $70fd6868680e912c$var$ka(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
class $70fd6868680e912c$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $70fd6868680e912c$var$j, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(t, e, n) {
        this._progressObserver = {
            next: t,
            error: e,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(t) {
        return this._taskCompletionResolver.promise.catch(t);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(t, e) {
        return this._taskCompletionResolver.promise.then(t, e);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(t) {
        this._updateProgress(t), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(t);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(t) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(t), this._taskCompletionResolver.reject(t);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(t) {
        this._lastProgress = t, this._progressObserver.next && this._progressObserver.next(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** DOMException error code constants. */ const $70fd6868680e912c$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link getFirestore}.
 */ class $70fd6868680e912c$export$d0e2b3272814ce82 extends $70fd6868680e912c$var$Aa {
    /** @hideconstructor */ constructor(t, e, n){
        super(t, e, n), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $70fd6868680e912c$var$Na, this._persistenceKey = "name" in t ? t.name : "[DEFAULT]";
    }
    _terminate() {
        return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        $70fd6868680e912c$var$Ua(this), this._firestoreClient.terminate();
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link getFirestore}. If the custom settings are empty, this function is
 * equivalent to calling {@link getFirestore}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $70fd6868680e912c$export$9061557f3e3b42f9(t, e) {
    const n = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(t, "firestore");
    if (n.isInitialized()) {
        const t = n.getImmediate(), s = n.getOptions();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(s, e)) return t;
        throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== e.cacheSizeBytes && -1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return n.initialize({
        options: e
    });
}
/**
 * Returns the existing {@link Firestore} instance that is associated with the
 * provided {@link @firebase/app#FirebaseApp}. If no instance exists, initializes a new
 * instance with default settings.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned {@link Firestore}
 * instance is associated with.
 * @returns The {@link Firestore} instance of the provided app.
 */ function $70fd6868680e912c$export$f06a05d14c3a6678(e = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    return (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(e, "firestore").getImmediate();
}
/**
 * @internal
 */ function $70fd6868680e912c$export$8da5fbea04405656(t) {
    return t._firestoreClient || $70fd6868680e912c$var$Ua(t), t._firestoreClient.verifyNotTerminated(), t._firestoreClient;
}
function $70fd6868680e912c$var$Ua(t) {
    var e;
    const n = t._freezeSettings(), s = function(t, e, n, s) {
        return new $70fd6868680e912c$var$ie(t, e, n, s.host, s.ssl, s.experimentalForceLongPolling, s.experimentalAutoDetectLongPolling, s.useFetchStreams);
    }(t._databaseId, (null === (e = t._app) || void 0 === e ? void 0 : e.options.appId) || "", t._persistenceKey, n);
    t._firestoreClient = new $70fd6868680e912c$var$zc(t._authCredentials, t._appCheckCredentials, t._queue, s);
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link getFirestore} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 */ function $70fd6868680e912c$export$cebe3b626a79c5f3(t, e) {
    $70fd6868680e912c$var$Xa(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    const n = $70fd6868680e912c$export$8da5fbea04405656(t), s = t._freezeSettings(), i = new $70fd6868680e912c$var$qc;
    return $70fd6868680e912c$var$Ga(n, i, new $70fd6868680e912c$var$Lc(i, s.cacheSizeBytes, null == e ? void 0 : e.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * If this fails, `enableMultiTabIndexedDbPersistence()` will reject the promise
 * it returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 */ function $70fd6868680e912c$export$6d4c055e91302ab9(t) {
    $70fd6868680e912c$var$Xa(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    const e = $70fd6868680e912c$export$8da5fbea04405656(t), n = t._freezeSettings(), s = new $70fd6868680e912c$var$qc;
    return $70fd6868680e912c$var$Ga(e, s, new $70fd6868680e912c$var$Uc(s, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $70fd6868680e912c$var$Ga(t, e, n) {
    const s = new $70fd6868680e912c$var$j;
    return t.asyncQueue.enqueue(async ()=>{
        try {
            await $70fd6868680e912c$var$Hc(t, n), await $70fd6868680e912c$var$Jc(t, e), s.resolve();
        } catch (t) {
            if (!/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function(t) {
                if ("FirebaseError" === t.name) return t.code === $70fd6868680e912c$var$G.FAILED_PRECONDITION || t.code === $70fd6868680e912c$var$G.UNIMPLEMENTED;
                if ("undefined" != typeof DOMException && t instanceof DOMException) // There are a few known circumstances where we can open IndexedDb but
                // trying to read/write will fail (e.g. quota exceeded). For
                // well-understood cases, we attempt to detect these and then gracefully
                // fall back to memory persistence.
                // NOTE: Rather than continue to add to this list, we could decide to
                // always fall back, with the risk that we might accidentally hide errors
                // representing actual SDK bugs.
                // When the browser is out of quota we could get either quota exceeded
                // or an aborted error depending on whether the error happened during
                // schema migration.
                return 22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
                // INVALID_STATE for any usage.
                11 === t.code;
                return !0;
            }(t)) throw t;
            console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + t), s.reject(t);
        }
    }).then(()=>s.promise);
}
function $70fd6868680e912c$export$b4f5899b4e28cf7b(t) {
    if (t._initialized && !t._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const e = new $70fd6868680e912c$var$j;
    return t._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function(t) {
                if (!$70fd6868680e912c$var$Vt.V()) return Promise.resolve();
                const e = t + "main";
                await $70fd6868680e912c$var$Vt.delete(e);
            }($70fd6868680e912c$var$Io(t._databaseId, t._persistenceKey)), e.resolve();
        } catch (t) {
            e.reject(t);
        }
    }), e.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $70fd6868680e912c$export$50b5113fd6653025(t) {
    return function(t) {
        const e = new $70fd6868680e912c$var$j;
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$mc(await $70fd6868680e912c$var$na(t), e)), e.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $70fd6868680e912c$export$ee6bdee8287ecc5f(t) {
    return $70fd6868680e912c$var$ia($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $70fd6868680e912c$export$f35b708ad73d52eb(t) {
    return $70fd6868680e912c$var$ra($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link getFirestore}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $70fd6868680e912c$export$9aff22d1ec357a14(t) {
    return (0, $57d436074e210fb5$export$48d18de2ff1c45a5)(t.app, "firestore"), t._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $70fd6868680e912c$export$4b8b93c690c9810b(t, e) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), s = new $70fd6868680e912c$export$6cac12425252ec14;
    return $70fd6868680e912c$var$fa(n, t._databaseId, e, s), s;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $70fd6868680e912c$export$169d2c6fe0f7f4ea(t, e) {
    return $70fd6868680e912c$var$da($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), e).then((e)=>e ? new $70fd6868680e912c$export$62297b13309008b2(t, null, e.query) : null);
}
function $70fd6868680e912c$var$Xa(t) {
    if (t._initialized || t._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $70fd6868680e912c$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...t){
        for(let e = 0; e < t.length; ++e)if (0 === t[e].length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $70fd6868680e912c$export$b7871852b967eaf1(t);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(t) {
        return this._internalPath.isEqual(t._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $70fd6868680e912c$export$bf6e62266977b8eb() {
    return new $70fd6868680e912c$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $70fd6868680e912c$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(t){
        this._byteString = t;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(t) {
        try {
            return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$var$Jt.fromBase64String(t));
        } catch (t) {
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + t);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$var$Jt.fromUint8Array(t));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(t) {
        return this._byteString.isEqual(t._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $70fd6868680e912c$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(t){
        this._methodName = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $70fd6868680e912c$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(t, e){
        if (!isFinite(t) || t < -90 || t > 90) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
        this._lat = t, this._long = e;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(t) {
        return this._lat === t._lat && this._long === t._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(t) {
        return $70fd6868680e912c$var$it(this._lat, t._lat) || $70fd6868680e912c$var$it(this._long, t._long);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$ih = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $70fd6868680e912c$var$rh {
    constructor(t, e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    toMutation(t, e) {
        return null !== this.fieldMask ? new $70fd6868680e912c$var$Wn(t, this.data, this.fieldMask, e, this.fieldTransforms) : new $70fd6868680e912c$var$jn(t, this.data, e, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $70fd6868680e912c$var$oh {
    constructor(t, // The fieldMask does not include document transforms.
    e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    toMutation(t, e) {
        return new $70fd6868680e912c$var$Wn(t, this.data, this.fieldMask, e, this.fieldTransforms);
    }
}
function $70fd6868680e912c$var$uh(t) {
    switch(t){
        case 0 /* Set */ :
        // fall through
        case 2 /* MergeSet */ :
        // fall through
        case 1 /* Update */ :
            return !0;
        case 3 /* Argument */ :
        case 4 /* ArrayArgument */ :
            return !1;
        default:
            throw $70fd6868680e912c$var$L();
    }
}
/** A "context" object passed around while parsing user data. */ class $70fd6868680e912c$var$ch {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(t, e, n, s, i, r){
        this.settings = t, this.databaseId = e, this.wt = n, this.ignoreUndefinedProperties = s, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Xc(), this.fieldTransforms = i || [], this.fieldMask = r || [];
    }
    get path() {
        return this.settings.path;
    }
    get Zc() {
        return this.settings.Zc;
    }
    /** Returns a new context with the specified settings overwritten. */ ta(t) {
        return new $70fd6868680e912c$var$ch(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.wt, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    ea(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.ta({
            path: n,
            na: !1
        });
        return s.sa(t), s;
    }
    ia(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.ta({
            path: n,
            na: !1
        });
        return s.Xc(), s;
    }
    ra(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.ta({
            path: void 0,
            na: !0
        });
    }
    oa(t) {
        return $70fd6868680e912c$var$Vh(t, this.settings.methodName, this.settings.ua || !1, this.path, this.settings.ca);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(t) {
        return void 0 !== this.fieldMask.find((e)=>t.isPrefixOf(e)) || void 0 !== this.fieldTransforms.find((e)=>t.isPrefixOf(e.field));
    }
    Xc() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let t = 0; t < this.path.length; t++)this.sa(this.path.get(t));
    }
    sa(t) {
        if (0 === t.length) throw this.oa("Document fields must not be empty");
        if ($70fd6868680e912c$var$uh(this.Zc) && $70fd6868680e912c$var$ih.test(t)) throw this.oa('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $70fd6868680e912c$var$ah {
    constructor(t, e, n){
        this.databaseId = t, this.ignoreUndefinedProperties = e, this.wt = n || $70fd6868680e912c$var$nu(t);
    }
    /** Creates a new top-level parse context. */ aa(t, e, n, s = !1) {
        return new $70fd6868680e912c$var$ch({
            Zc: t,
            methodName: e,
            ca: n,
            path: $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(),
            na: !1,
            ua: s
        }, this.databaseId, this.wt, this.ignoreUndefinedProperties);
    }
}
function $70fd6868680e912c$var$hh(t) {
    const e = t._freezeSettings(), n = $70fd6868680e912c$var$nu(t._databaseId);
    return new $70fd6868680e912c$var$ah(t._databaseId, !!e.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $70fd6868680e912c$var$lh(t, e, n, s, i, r = {}) {
    const o = t.aa(r.merge || r.mergeFields ? 2 /* MergeSet */  : 0 /* Set */ , e, n, i);
    $70fd6868680e912c$var$Rh("Data must be an object, but it was:", o, s);
    const u = $70fd6868680e912c$var$Eh(s, o);
    let c, a;
    if (r.merge) c = new $70fd6868680e912c$var$zt(o.fieldMask), a = o.fieldTransforms;
    else if (r.mergeFields) {
        const t = [];
        for (const s of r.mergeFields){
            const i = $70fd6868680e912c$var$bh(e, s, n);
            if (!o.contains(i)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $70fd6868680e912c$var$Sh(t, i) || t.push(i);
        }
        c = new $70fd6868680e912c$var$zt(t), a = o.fieldTransforms.filter((t)=>c.covers(t.field));
    } else c = null, a = o.fieldTransforms;
    return new $70fd6868680e912c$var$rh(new $70fd6868680e912c$var$De(u), c, a);
}
class $70fd6868680e912c$var$fh extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        if (2 /* MergeSet */  !== t.Zc) throw 1 /* Update */  === t.Zc ? t.oa(`${this._methodName}() can only appear at the top level of your update data`) : t.oa(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.fieldMask.push(t.path), null;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$fh;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $70fd6868680e912c$var$dh(t, e, n) {
    return new $70fd6868680e912c$var$ch({
        Zc: 3 /* Argument */ ,
        ca: e.settings.ca,
        methodName: t._methodName,
        na: n
    }, e.databaseId, e.wt, e.ignoreUndefinedProperties);
}
class $70fd6868680e912c$var$_h extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        return new $70fd6868680e912c$var$On(t.path, new $70fd6868680e912c$var$vn);
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$_h;
    }
}
class $70fd6868680e912c$var$wh extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.ha = e;
    }
    _toFieldTransform(t) {
        const e = $70fd6868680e912c$var$dh(this, t, /*array=*/ !0), n = this.ha.map((t)=>$70fd6868680e912c$var$Th(t, e)), s = new $70fd6868680e912c$var$Vn(n);
        return new $70fd6868680e912c$var$On(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
class $70fd6868680e912c$var$mh extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.ha = e;
    }
    _toFieldTransform(t) {
        const e = $70fd6868680e912c$var$dh(this, t, /*array=*/ !0), n = this.ha.map((t)=>$70fd6868680e912c$var$Th(t, e)), s = new $70fd6868680e912c$var$Dn(n);
        return new $70fd6868680e912c$var$On(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
class $70fd6868680e912c$var$gh extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.la = e;
    }
    _toFieldTransform(t) {
        const e = new $70fd6868680e912c$var$xn(t.wt, $70fd6868680e912c$var$En(t.wt, this.la));
        return new $70fd6868680e912c$var$On(t.path, e);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
/** Parse update data from an update() call. */ function $70fd6868680e912c$var$yh(t, e, n, s) {
    const i = t.aa(1 /* Update */ , e, n);
    $70fd6868680e912c$var$Rh("Data must be an object, but it was:", i, s);
    const r = [], o = $70fd6868680e912c$var$De.empty();
    $70fd6868680e912c$var$Lt(s, (t, s)=>{
        const u = $70fd6868680e912c$var$vh(e, t, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        s = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(s);
        const c = i.ia(u);
        if (s instanceof $70fd6868680e912c$var$fh) // Add it to the field mask, but don't add anything to updateData.
        r.push(u);
        else {
            const t = $70fd6868680e912c$var$Th(s, c);
            null != t && (r.push(u), o.set(u, t));
        }
    });
    const u = new $70fd6868680e912c$var$zt(r);
    return new $70fd6868680e912c$var$oh(o, u, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $70fd6868680e912c$var$ph(t, e, n, s, i, r) {
    const o = t.aa(1 /* Update */ , e, n), u = [
        $70fd6868680e912c$var$bh(e, s, n)
    ], c = [
        i
    ];
    if (r.length % 2 != 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Function ${e}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let t = 0; t < r.length; t += 2)u.push($70fd6868680e912c$var$bh(e, r[t])), c.push(r[t + 1]);
    const a = [], h = $70fd6868680e912c$var$De.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let t = u.length - 1; t >= 0; --t)if (!$70fd6868680e912c$var$Sh(a, u[t])) {
        const e = u[t];
        let n = c[t];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n);
        const s = o.ia(e);
        if (n instanceof $70fd6868680e912c$var$fh) // Add it to the field mask, but don't add anything to updateData.
        a.push(e);
        else {
            const t = $70fd6868680e912c$var$Th(n, s);
            null != t && (a.push(e), h.set(e, t));
        }
    }
    const l = new $70fd6868680e912c$var$zt(a);
    return new $70fd6868680e912c$var$oh(h, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $70fd6868680e912c$var$Ih(t, e, n, s = !1) {
    return $70fd6868680e912c$var$Th(n, t.aa(s ? 4 /* ArrayArgument */  : 3 /* Argument */ , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $70fd6868680e912c$var$Th(t, e) {
    if ($70fd6868680e912c$var$Ah(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t))) return $70fd6868680e912c$var$Rh("Unsupported field value:", e, t), $70fd6868680e912c$var$Eh(t, e);
    if (t instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$70fd6868680e912c$var$uh(e.Zc)) throw e.oa(`${t._methodName}() can only be used with update() and set()`);
        if (!e.path) throw e.oa(`${t._methodName}() is not currently supported inside arrays`);
        const n = t._toFieldTransform(e);
        n && e.fieldTransforms.push(n);
    }(t, e), null;
    if (void 0 === t && e.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.fieldMask.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.na && 4 /* ArrayArgument */  !== e.Zc) throw e.oa("Nested arrays are not supported");
        return function(t, e) {
            const n = [];
            let s = 0;
            for (const i of t){
                let t = $70fd6868680e912c$var$Th(i, e.ra(s));
                null == t && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (t = {
                    nullValue: "NULL_VALUE"
                }), n.push(t), s++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(t, e);
    }
    return function(t, e) {
        if (null === (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return $70fd6868680e912c$var$En(e.wt, t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            const n = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromDate(t);
            return {
                timestampValue: $70fd6868680e912c$var$Ds(e.wt, n)
            };
        }
        if (t instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: $70fd6868680e912c$var$Ds(e.wt, n)
            };
        }
        if (t instanceof $70fd6868680e912c$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $70fd6868680e912c$var$Cs(e.wt, t._byteString)
        };
        if (t instanceof $70fd6868680e912c$export$6be62b059fb12175) {
            const n = e.databaseId, s = t.firestore._databaseId;
            if (!s.isEqual(n)) throw e.oa(`Document reference is for database ${s.projectId}/${s.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $70fd6868680e912c$var$ks(t.firestore._databaseId || e.databaseId, t._key.path)
            };
        }
        throw e.oa(`Unsupported field value: ${$70fd6868680e912c$var$pa(t)}`);
    }(t, e);
}
function $70fd6868680e912c$var$Eh(t, e) {
    const n = {};
    return $70fd6868680e912c$var$Ut(t) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.fieldMask.push(e.path) : $70fd6868680e912c$var$Lt(t, (t, s)=>{
        const i = $70fd6868680e912c$var$Th(s, e.ea(t));
        null != i && (n[t] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $70fd6868680e912c$var$Ah(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430 || t instanceof $70fd6868680e912c$export$f9f719d1b6419c4 || t instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1 || t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d);
}
function $70fd6868680e912c$var$Rh(t, e, n) {
    if (!$70fd6868680e912c$var$Ah(n) || !function(t) {
        return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
    }(n)) {
        const s = $70fd6868680e912c$var$pa(n);
        throw "an object" === s ? e.oa(t + " a custom object") : e.oa(t + " " + s);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $70fd6868680e912c$var$bh(t, e, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) instanceof $70fd6868680e912c$export$a1a8fea822d17659) return e._internalPath;
    if ("string" == typeof e) return $70fd6868680e912c$var$vh(t, e);
    throw $70fd6868680e912c$var$Vh("Field path arguments must be of type string or ", t, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $70fd6868680e912c$var$Ph = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $70fd6868680e912c$var$vh(t, e, n) {
    if (e.search($70fd6868680e912c$var$Ph) >= 0) throw $70fd6868680e912c$var$Vh(`Invalid field path (${e}). Paths must not contain '~', '*', '/', '[', or ']'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $70fd6868680e912c$export$a1a8fea822d17659(...e.split("."))._internalPath;
    } catch (s) {
        throw $70fd6868680e912c$var$Vh(`Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $70fd6868680e912c$var$Vh(t, e, n, s, i) {
    const r = s && !s.isEmpty(), o = void 0 !== i;
    let u = `Function ${e}() called with invalid data`;
    n && (u += " (via `toFirestore()`)"), u += ". ";
    let c = "";
    return (r || o) && (c += " (found", r && (c += ` in field ${s}`), o && (c += ` in document ${i}`), c += ")"), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, u + t + c);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $70fd6868680e912c$var$Sh(t, e) {
    return t.some((t)=>t.isEqual(e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$var$Dh {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, s, i){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = s, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $70fd6868680e912c$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $70fd6868680e912c$var$Ch(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field($70fd6868680e912c$var$xh("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$var$Ch extends $70fd6868680e912c$var$Dh {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $70fd6868680e912c$var$xh(t, e) {
    return "string" == typeof e ? $70fd6868680e912c$var$vh(t, e) : e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? e._internalPath : e._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $70fd6868680e912c$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$export$acab0e6ef25eb301 extends $70fd6868680e912c$var$Dh {
    /** @hideconstructor protected */ constructor(t, e, n, s, i, r){
        super(t, e, n, s, r), this._firestore = t, this._firestoreImpl = t, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field($70fd6868680e912c$var$xh("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$export$6d4d04e42af6b03c extends $70fd6868680e912c$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $70fd6868680e912c$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, s){
        this._firestore = t, this._userDataWriter = e, this._snapshot = s, this.metadata = new $70fd6868680e912c$export$99d61448206ab5cd(s.hasPendingWrites, s.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $70fd6868680e912c$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>({
                        type: "added",
                        doc: new $70fd6868680e912c$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $70fd6868680e912c$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter),
                        oldIndex: -1,
                        newIndex: e++
                    }));
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* Metadata */  !== t.type).map((e)=>{
                    const s = new $70fd6868680e912c$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $70fd6868680e912c$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let i = -1, r = -1;
                    return 0 /* Added */  !== e.type && (i = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* Removed */  !== e.type && (n = n.add(e.doc), r = n.indexOf(e.doc.key)), {
                        type: $70fd6868680e912c$var$Fh(e.type),
                        doc: s,
                        oldIndex: i,
                        newIndex: r
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
}
function $70fd6868680e912c$var$Fh(t) {
    switch(t){
        case 0 /* Added */ :
            return "added";
        case 2 /* Modified */ :
        case 3 /* Metadata */ :
            return "modified";
        case 1 /* Removed */ :
            return "removed";
        default:
            return $70fd6868680e912c$var$L();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $70fd6868680e912c$export$f243a5d948512846(t, e) {
    return t instanceof $70fd6868680e912c$export$acab0e6ef25eb301 && e instanceof $70fd6868680e912c$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $70fd6868680e912c$export$8f21149d8133945c && e instanceof $70fd6868680e912c$export$8f21149d8133945c && t._firestore === e._firestore && $70fd6868680e912c$export$49b1d0de6ba30f41(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$Bh(t) {
    if ("L" /* Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * endBefore:1}, {@link (endAt:1)}, {@link limit} or {@link limitToLast} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $70fd6868680e912c$export$b0e86f2c7431df4e {
}
/**
 * Creates a new immutable instance of {@link Query} that is extended to also include
 * additional query constraints.
 *
 * @param query - The {@link Query} instance to use as a base for the new constraints.
 * @param queryConstraints - The list of {@link QueryConstraint}s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $70fd6868680e912c$export$2fa187e846a241c4(t, ...e) {
    for (const n of e)t = n._apply(t);
    return t;
}
class $70fd6868680e912c$var$qh extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    constructor(t, e, n){
        super(), this.fa = t, this.da = e, this._a = n, this.type = "where";
    }
    _apply(t) {
        const e = $70fd6868680e912c$var$hh(t.firestore), n = function(t, e, n, s, i, r, o) {
            let u;
            if (i.isKeyField()) {
                if ("array-contains" /* ARRAY_CONTAINS */  === r || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid Query. You can't perform '${r}' queries on documentId().`);
                if ("in" /* IN */  === r || "not-in" /* NOT_IN */  === r) {
                    $70fd6868680e912c$var$sl(o, r);
                    const e = [];
                    for (const n of o)e.push($70fd6868680e912c$var$nl(s, t, n));
                    u = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else u = $70fd6868680e912c$var$nl(s, t, o);
            } else "in" /* IN */  !== r && "not-in" /* NOT_IN */  !== r && "array-contains-any" /* ARRAY_CONTAINS_ANY */  !== r || $70fd6868680e912c$var$sl(o, r), u = $70fd6868680e912c$var$Ih(n, e, o, /* allowArrays= */ "in" /* IN */  === r || "not-in" /* NOT_IN */  === r);
            const c = $70fd6868680e912c$var$qe.create(i, r, u);
            return function(t, e) {
                if (e.ht()) {
                    const n = $70fd6868680e912c$var$cn(t);
                    if (null !== n && !n.isEqual(e.field)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '${n.toString()}' and '${e.field.toString()}'`);
                    const s = $70fd6868680e912c$var$un(t);
                    null !== s && $70fd6868680e912c$var$il(t, e.field, s);
                }
                const n = function(t, e) {
                    for (const n of t.filters)if (e.indexOf(n.op) >= 0) return n.op;
                    return null;
                }(t, /**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one array operator is allowed.
 * 2. Only one disjunctive operator is allowed.
 * 3. `NOT_EQUAL` cannot be used with another `NOT_EQUAL` operator.
 * 4. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 *
 * Array operators: `ARRAY_CONTAINS`, `ARRAY_CONTAINS_ANY`
 * Disjunctive operators: `IN`, `ARRAY_CONTAINS_ANY`, `NOT_IN`
 */ function(t) {
                    switch(t){
                        case "!=" /* NOT_EQUAL */ :
                            return [
                                "!=" /* NOT_EQUAL */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "array-contains" /* ARRAY_CONTAINS */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "in" /* IN */ :
                            return [
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "array-contains-any" /* ARRAY_CONTAINS_ANY */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ 
                            ];
                        case "not-in" /* NOT_IN */ :
                            return [
                                "array-contains" /* ARRAY_CONTAINS */ ,
                                "array-contains-any" /* ARRAY_CONTAINS_ANY */ ,
                                "in" /* IN */ ,
                                "not-in" /* NOT_IN */ ,
                                "!=" /* NOT_EQUAL */ 
                            ];
                        default:
                            return [];
                    }
                }(e.op));
                if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
                throw n === e.op ? new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
            }(t, c), c;
        }(t._query, "where", e, t.firestore._databaseId, this.fa, this.da, this._a);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            const n = t.filters.concat([
                e
            ]);
            return new $70fd6868680e912c$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), n, t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, n));
    }
}
/**
 * Creates a {@link QueryConstraint} that enforces that documents must contain the
 * specified field and that the value should satisfy the relation constraint
 * provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link Query}.
 */ function $70fd6868680e912c$export$9c59b80dda569a6e(t, e, n) {
    const s = e, i = $70fd6868680e912c$var$xh("where", t);
    return new $70fd6868680e912c$var$qh(i, s, n);
}
class $70fd6868680e912c$var$Gh extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    constructor(t, e){
        super(), this.fa = t, this.wa = e, this.type = "orderBy";
    }
    _apply(t) {
        const e = function(t, e, n) {
            if (null !== t.startAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const s = new $70fd6868680e912c$var$Xe(e, n);
            return function(t, e) {
                if (null === $70fd6868680e912c$var$un(t)) {
                    // This is the first order by. It must match any inequality.
                    const n = $70fd6868680e912c$var$cn(t);
                    null !== n && $70fd6868680e912c$var$il(t, n, e.field);
                }
            }(t, s), s;
        }(t._query, this.fa, this.wa);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = t.explicitOrderBy.concat([
                e
            ]);
            return new $70fd6868680e912c$var$nn(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, e));
    }
}
/**
 * Creates a {@link QueryConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link Query}.
 */ function $70fd6868680e912c$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, s = $70fd6868680e912c$var$xh("orderBy", t);
    return new $70fd6868680e912c$var$Gh(s, n);
}
class $70fd6868680e912c$var$jh extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    constructor(t, e, n){
        super(), this.type = t, this.ma = e, this.ga = n;
    }
    _apply(t) {
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, $70fd6868680e912c$var$fn(t._query, this.ma, this.ga));
    }
}
/**
 * Creates a {@link QueryConstraint} that only returns the first matching documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link Query}.
 */ function $70fd6868680e912c$export$ee37e834aaad6f7e(t) {
    return $70fd6868680e912c$var$Ta("limit", t), new $70fd6868680e912c$var$jh("limit", t, "F" /* First */ );
}
/**
 * Creates a {@link QueryConstraint} that only returns the last matching documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link Query}.
 */ function $70fd6868680e912c$export$f823b3589f69d3b8(t) {
    return $70fd6868680e912c$var$Ta("limitToLast", t), new $70fd6868680e912c$var$jh("limitToLast", t, "L" /* Last */ );
}
class $70fd6868680e912c$var$Hh extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    constructor(t, e, n){
        super(), this.type = t, this.ya = e, this.pa = n;
    }
    _apply(t) {
        const e = $70fd6868680e912c$var$el(t, this.type, this.ya, this.pa);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $70fd6868680e912c$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, e, t.endAt);
        }(t._query, e));
    }
}
function $70fd6868680e912c$export$859941c5fc8eba6b(...t) {
    return new $70fd6868680e912c$var$Hh("startAt", t, /*inclusive=*/ !0);
}
function $70fd6868680e912c$export$dd8dee5f7b804673(...t) {
    return new $70fd6868680e912c$var$Hh("startAfter", t, /*inclusive=*/ !1);
}
class $70fd6868680e912c$var$Xh extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    constructor(t, e, n){
        super(), this.type = t, this.ya = e, this.pa = n;
    }
    _apply(t) {
        const e = $70fd6868680e912c$var$el(t, this.type, this.ya, this.pa);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $70fd6868680e912c$var$nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, e);
        }(t._query, e));
    }
}
function $70fd6868680e912c$export$57203950645b8b11(...t) {
    return new $70fd6868680e912c$var$Xh("endBefore", t, /*inclusive=*/ !1);
}
function $70fd6868680e912c$export$28ec54a8428bdb3f(...t) {
    return new $70fd6868680e912c$var$Xh("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $70fd6868680e912c$var$el(t, e, n, s) {
    if (n[0] = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $70fd6868680e912c$var$Dh) return function(t, e, n, s, i) {
        if (!s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const r = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $70fd6868680e912c$var$hn(t))if (n.field.isKeyField()) r.push($70fd6868680e912c$var$ye(e, s.key));
        else {
            const t = s.data.field(n.field);
            if ($70fd6868680e912c$var$ee(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            r.push(t);
        }
        return new $70fd6868680e912c$var$Ye(r, i);
    }(t._query, t.firestore._databaseId, e, n[0]._document, s);
    {
        const i = $70fd6868680e912c$var$hh(t.firestore);
        return function(t, e, n, s, i, r) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (i.length > o.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Too many arguments provided to ${s}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const u = [];
            for(let r = 0; r < i.length; r++){
                const c = i[r];
                if (o[r].field.isKeyField()) {
                    if ("string" != typeof c) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${s}(), but got a ${typeof c}`);
                    if (!$70fd6868680e912c$var$an(t) && -1 !== c.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${s}() must be a plain document ID, but '${c}' contains a slash.`);
                    const n = t.path.child($70fd6868680e912c$var$ht.fromString(c));
                    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(n)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${s}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $70fd6868680e912c$export$afc2e57c475b7810(n);
                    u.push($70fd6868680e912c$var$ye(e, i));
                } else {
                    const t = $70fd6868680e912c$var$Ih(n, s, c);
                    u.push(t);
                }
            }
            return new $70fd6868680e912c$var$Ye(u, r);
        }(t._query, t.firestore._databaseId, i, e, n, s);
    }
}
function $70fd6868680e912c$var$nl(t, e, n) {
    if ("string" == typeof (n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$70fd6868680e912c$var$an(e) && -1 !== n.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const s = e.path.child($70fd6868680e912c$var$ht.fromString(n));
        if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(s)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${s}' is not because it has an odd number of segments (${s.length}).`);
        return $70fd6868680e912c$var$ye(t, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
    if (n instanceof $70fd6868680e912c$export$6be62b059fb12175) return $70fd6868680e912c$var$ye(t, n._key);
    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$70fd6868680e912c$var$pa(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $70fd6868680e912c$var$sl(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
    if (t.length > 10) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid Query. '${e.toString()}' filters support a maximum of 10 elements in the value array.`);
}
function $70fd6868680e912c$var$il(t, e, n) {
    if (!n.isEqual(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, `Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '${e.toString()}' and so you must also use '${e.toString()}' as your first argument to orderBy(), but your first orderBy() is on field '${n.toString()}' instead.`);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$rl = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    convertValue(t, e = "none") {
        switch($70fd6868680e912c$var$le(t)){
            case 0 /* NullValue */ :
                return null;
            case 1 /* BooleanValue */ :
                return t.booleanValue;
            case 2 /* NumberValue */ :
                return $70fd6868680e912c$var$Zt(t.integerValue || t.doubleValue);
            case 3 /* TimestampValue */ :
                return this.convertTimestamp(t.timestampValue);
            case 4 /* ServerTimestampValue */ :
                return this.convertServerTimestamp(t, e);
            case 5 /* StringValue */ :
                return t.stringValue;
            case 6 /* BlobValue */ :
                return this.convertBytes($70fd6868680e912c$var$te(t.bytesValue));
            case 7 /* RefValue */ :
                return this.convertReference(t.referenceValue);
            case 8 /* GeoPointValue */ :
                return this.convertGeoPoint(t.geoPointValue);
            case 9 /* ArrayValue */ :
                return this.convertArray(t.arrayValue, e);
            case 10 /* ObjectValue */ :
                return this.convertObject(t.mapValue, e);
            default:
                throw $70fd6868680e912c$var$L();
        }
    }
    convertObject(t, e) {
        const n = {};
        return $70fd6868680e912c$var$Lt(t.fields, (t, s)=>{
            n[t] = this.convertValue(s, e);
        }), n;
    }
    convertGeoPoint(t) {
        return new $70fd6868680e912c$export$f9f719d1b6419c4($70fd6868680e912c$var$Zt(t.latitude), $70fd6868680e912c$var$Zt(t.longitude));
    }
    convertArray(t, e) {
        return (t.values || []).map((t)=>this.convertValue(t, e));
    }
    convertServerTimestamp(t, e) {
        switch(e){
            case "previous":
                const n = $70fd6868680e912c$var$ne(t);
                return null == n ? null : this.convertValue(n, e);
            case "estimate":
                return this.convertTimestamp($70fd6868680e912c$var$se(t));
            default:
                return null;
        }
    }
    convertTimestamp(t) {
        const e = $70fd6868680e912c$var$Xt(t);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }
    convertDocumentKey(t, e) {
        const n = $70fd6868680e912c$var$ht.fromString(t);
        $70fd6868680e912c$var$U($70fd6868680e912c$var$ui(n));
        const s = new $70fd6868680e912c$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $70fd6868680e912c$export$afc2e57c475b7810(n.popFirst(5));
        return s.isEqual(e) || // TODO(b/64130202): Somehow support foreign references.
        $70fd6868680e912c$var$F(`Document ${i} contains a document reference within a different database (${s.projectId}/${s.database}) which is not supported. It will be treated as a reference in the current database (${e.projectId}/${e.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $70fd6868680e912c$var$ul(t, e, n) {
    let s;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return s = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, s;
}
class $70fd6868680e912c$var$cl extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $70fd6868680e912c$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = $70fd6868680e912c$var$hh(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const s = $70fd6868680e912c$var$hl(t, this._firestore), i = $70fd6868680e912c$var$ul(s.converter, e, n), r = $70fd6868680e912c$var$lh(this._dataReader, "WriteBatch.set", s._key, i, null !== s.converter, n);
        return this._mutations.push(r.toMutation(s._key, $70fd6868680e912c$var$$n.none())), this;
    }
    update(t, e, n, ...s) {
        this._verifyNotCommitted();
        const i = $70fd6868680e912c$var$hl(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$ph(this._dataReader, "WriteBatch.update", i._key, e, n, s) : $70fd6868680e912c$var$yh(this._dataReader, "WriteBatch.update", i._key, e), this._mutations.push(r.toMutation(i._key, $70fd6868680e912c$var$$n.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $70fd6868680e912c$var$hl(t, this._firestore);
        return this._mutations = this._mutations.concat(new $70fd6868680e912c$var$Yn(e._key, $70fd6868680e912c$var$$n.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $70fd6868680e912c$var$hl(t, e) {
    if ((t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)).firestore !== e) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$11eb3b5ef9574821(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$ua($70fd6868680e912c$export$8da5fbea04405656(e), t._key).then((n)=>$70fd6868680e912c$var$bl(e, t, n));
}
class $70fd6868680e912c$var$fl extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$a58bd92642f7fb58(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$fl(e);
    return $70fd6868680e912c$var$oa(n, t._key).then((n)=>new $70fd6868680e912c$export$acab0e6ef25eb301(e, s, t._key, n, new $70fd6868680e912c$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$35dd759aed9686b4(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$ua($70fd6868680e912c$export$8da5fbea04405656(e), t._key, {
        source: "server"
    }).then((n)=>$70fd6868680e912c$var$bl(e, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$81d3477bd73c86ef(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$fl(e);
    return $70fd6868680e912c$var$Bh(t._query), $70fd6868680e912c$var$aa(n, t._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$3fd010f18eac1dd(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$fl(e);
    return $70fd6868680e912c$var$ca(n, t._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$ec7d9e44f349c77b(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$fl(e);
    return $70fd6868680e912c$var$aa(n, t._query, {
        source: "server"
    }).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
function $70fd6868680e912c$export$5ff77ddaff3c9e12(t, e, n) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const s = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), i = $70fd6868680e912c$var$ul(t.converter, e, n);
    return $70fd6868680e912c$export$1945f8fec9dda613(s, [
        $70fd6868680e912c$var$lh($70fd6868680e912c$var$hh(s), "setDoc", t._key, i, null !== t.converter, n).toMutation(t._key, $70fd6868680e912c$var$$n.none())
    ]);
}
function $70fd6868680e912c$export$22d1fdd1e73faff2(t, e, n, ...s) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const i = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$var$hh(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$ph(r, "updateDoc", t._key, e, n, s) : $70fd6868680e912c$var$yh(r, "updateDoc", t._key, e);
    return $70fd6868680e912c$export$1945f8fec9dda613(i, [
        o.toMutation(t._key, $70fd6868680e912c$var$$n.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a4f20481fae8f78b(t) {
    return $70fd6868680e912c$export$1945f8fec9dda613($70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), [
        new $70fd6868680e912c$var$Yn(t._key, $70fd6868680e912c$var$$n.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a13890143fb1c2dd(t, e) {
    const n = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$export$2a111da947c407d2(t), i = $70fd6868680e912c$var$ul(t.converter, e);
    return $70fd6868680e912c$export$1945f8fec9dda613(n, [
        $70fd6868680e912c$var$lh($70fd6868680e912c$var$hh(t.firestore), "addDoc", s._key, i, null !== t.converter, {}).toMutation(s._key, $70fd6868680e912c$var$$n.exists(!1))
    ]).then(()=>s);
}
function $70fd6868680e912c$export$d36370812fb26935(t, ...e) {
    var n, s, i;
    t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t);
    let r = {
        includeMetadataChanges: !1
    }, o = 0;
    "object" != typeof e[o] || $70fd6868680e912c$var$ka(e[o]) || (r = e[o], o++);
    const u = {
        includeMetadataChanges: r.includeMetadataChanges
    };
    if ($70fd6868680e912c$var$ka(e[o])) {
        const t = e[o];
        e[o] = null === (n = t.next) || void 0 === n ? void 0 : n.bind(t), e[o + 1] = null === (s = t.error) || void 0 === s ? void 0 : s.bind(t), e[o + 2] = null === (i = t.complete) || void 0 === i ? void 0 : i.bind(t);
    }
    let c, a, h;
    if (t instanceof $70fd6868680e912c$export$6be62b059fb12175) a = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), h = $70fd6868680e912c$var$rn(t._key.path), c = {
        next: (n)=>{
            e[o] && e[o]($70fd6868680e912c$var$bl(a, t, n));
        },
        error: e[o + 1],
        complete: e[o + 2]
    };
    else {
        const n = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
        a = $70fd6868680e912c$export$572106fb5803752c(n.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), h = n._query;
        const s = new $70fd6868680e912c$var$fl(a);
        c = {
            next: (t)=>{
                e[o] && e[o](new $70fd6868680e912c$export$8f21149d8133945c(a, s, n, t));
            },
            error: e[o + 1],
            complete: e[o + 2]
        }, $70fd6868680e912c$var$Bh(t._query);
    }
    return function(t, e, n, s) {
        const i = new $70fd6868680e912c$var$Gc(s), r = new $70fd6868680e912c$var$Ju(e, i, n);
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$Qu(await $70fd6868680e912c$var$sa(t), r)), ()=>{
            i.Tc(), t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$ju(await $70fd6868680e912c$var$sa(t), r));
        };
    }($70fd6868680e912c$export$8da5fbea04405656(a), h, u, c);
}
function $70fd6868680e912c$export$9dff4f5aba83e348(t, e) {
    return $70fd6868680e912c$var$ha($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), $70fd6868680e912c$var$ka(e) ? e : {
        next: e
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $70fd6868680e912c$export$1945f8fec9dda613(t, e) {
    return function(t, e) {
        const n = new $70fd6868680e912c$var$j;
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$hc(await $70fd6868680e912c$var$na(t), e, n)), n.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t), e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $70fd6868680e912c$var$bl(t, e, n) {
    const s = n.docs.get(e._key), i = new $70fd6868680e912c$var$fl(t);
    return new $70fd6868680e912c$export$acab0e6ef25eb301(t, i, e._key, s, new $70fd6868680e912c$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$export$febc5573c75cefb0 extends class {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = $70fd6868680e912c$var$hh(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $70fd6868680e912c$var$hl(t, this._firestore), n = new $70fd6868680e912c$var$cl(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return $70fd6868680e912c$var$L();
            const s = t[0];
            if (s.isFoundDocument()) return new $70fd6868680e912c$var$Dh(this._firestore, n, s.key, s, e.converter);
            if (s.isNoDocument()) return new $70fd6868680e912c$var$Dh(this._firestore, n, e._key, null, e.converter);
            throw $70fd6868680e912c$var$L();
        });
    }
    set(t, e, n) {
        const s = $70fd6868680e912c$var$hl(t, this._firestore), i = $70fd6868680e912c$var$ul(s.converter, e, n), r = $70fd6868680e912c$var$lh(this._dataReader, "Transaction.set", s._key, i, null !== s.converter, n);
        return this._transaction.set(s._key, r), this;
    }
    update(t, e, n, ...s) {
        const i = $70fd6868680e912c$var$hl(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$ph(this._dataReader, "Transaction.update", i._key, e, n, s) : $70fd6868680e912c$var$yh(this._dataReader, "Transaction.update", i._key, e), this._transaction.update(i._key, r), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $70fd6868680e912c$var$hl(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
} {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $70fd6868680e912c$var$hl(t, this._firestore), n = new $70fd6868680e912c$var$fl(this._firestore);
        return super.get(t).then((t)=>new $70fd6868680e912c$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $70fd6868680e912c$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $70fd6868680e912c$export$3c54e006bf9c93b7(t, e, n) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82);
    const s = Object.assign(Object.assign({}, $70fd6868680e912c$var$rl), n);
    !function(t) {
        if (t.maxAttempts < 1) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(s);
    return $70fd6868680e912c$var$la($70fd6868680e912c$export$8da5fbea04405656(t), (n)=>e(new $70fd6868680e912c$export$febc5573c75cefb0(t, n)), s);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $70fd6868680e912c$export$2bbad96c62fdba3e() {
    return new $70fd6868680e912c$var$fh("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $70fd6868680e912c$export$3ff8e7e00c3264b7() {
    return new $70fd6868680e912c$var$_h("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $70fd6868680e912c$export$f62af892fd92610c(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$wh("arrayUnion", t);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$30a014203d0d7e4f(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$mh("arrayRemove", t);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$a2647aa13413c947(t) {
    return new $70fd6868680e912c$var$gh("increment", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $70fd6868680e912c$export$44cd1c9d57edd9b1(t) {
    return $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), new $70fd6868680e912c$export$d94ed661b1cfd435(t, (e)=>$70fd6868680e912c$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$export$2862db5d92ff7996(t, e) {
    $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    const n = "string" == typeof e ? function(t) {
        try {
            return JSON.parse(t);
        } catch (t) {
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Failed to parse JSON:" + t.message);
        }
    }(e) : e, s = [];
    // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    if (Array.isArray(n.indexes)) for (const t of n.indexes){
        const e = $70fd6868680e912c$var$Ol(t, "collectionGroup"), n = [];
        if (Array.isArray(t.fields)) for (const e of t.fields){
            const t = $70fd6868680e912c$var$vh("setIndexConfiguration", $70fd6868680e912c$var$Ol(e, "fieldPath"));
            "CONTAINS" === e.arrayConfig ? n.push(new $70fd6868680e912c$var$gt(t, 2 /* CONTAINS */ )) : "ASCENDING" === e.order ? n.push(new $70fd6868680e912c$var$gt(t, 0 /* ASCENDING */ )) : "DESCENDING" === e.order && n.push(new $70fd6868680e912c$var$gt(t, 1 /* DESCENDING */ ));
        }
        s.push(new $70fd6868680e912c$var$_t($70fd6868680e912c$var$_t.UNKNOWN_ID, e, n, $70fd6868680e912c$var$yt.empty()));
    }
    // TODO(indexing): Configure indexes
    return Promise.resolve();
}
function $70fd6868680e912c$var$Ol(t, e) {
    if ("string" != typeof t[e]) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$G.INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function(t, e = !0) {
    !function(t) {
        $70fd6868680e912c$var$x = t;
    }((0, $57d436074e210fb5$export$31499a9cd224b78c)), (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("firestore", (t, { options: n })=>{
        const s = t.getProvider("app").getImmediate(), i = new $70fd6868680e912c$export$d0e2b3272814ce82(s, new $70fd6868680e912c$var$J(t.getProvider("auth-internal")), new $70fd6868680e912c$var$tt(t.getProvider("app-check-internal")));
        return n = Object.assign({
            useFetchStreams: e
        }, n), i._setSettings(n), i;
    }, "PUBLIC")), (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$D, "3.4.10", t), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$D, "3.4.10", "esm2017");
}();





var $f1q41 = parcelRequire("f1q41");

function $83e023b4e8d0ddda$export$257224358692d0e0(qs) {
    const d = [];
    qs.forEach((doc)=>{
        const data = doc.data();
        d.push({
            ...data,
            id: doc.id
        });
    });
    return d;
}




var $f1q41 = parcelRequire("f1q41");



const $b88c63f4bcc6d929$var$publicHost = "https://preview.fragorders.com";
class $b88c63f4bcc6d929$export$b9d66936ae1f2403 {
}
function $b88c63f4bcc6d929$export$f08daca113a61734() {
    return {
        showHidden: false,
        showHiddenOnMFD: false,
        showZones: false,
        showHiddenZones: false,
        showIndividualUnits: false,
        showGroups: true,
        showFriendlyGroups: true,
        showFriendlyUnits: false,
        showDrawing: true,
        showDrawingLayerAuthor: false,
        showDrawingLayerCommon: true,
        showDrawingLayerCoalition: true,
        allowPlannerRadioFreqs: false,
        allowPlannersLaserCodes: true,
        showOpforStatics: true
    };
}
function $b88c63f4bcc6d929$export$c84f019cbfe2bcc0(fragOrder, coalition, opts, t) {
    return {
        coalition: coalition,
        fragOrderID: fragOrder.id,
        // Keeping for backward compatibility
        taskingData: t ? JSON.stringify(t) : null,
        title: fragOrder.name,
        publishOpts: opts,
        discordGuildID: fragOrder.discordGuildID
    };
}
function $b88c63f4bcc6d929$export$ed3b4c70a756146(fragOrder, opts, coalition, ts) {
    const t = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(ts);
    if (opts.showGroups) {
        if (!opts.showHidden) {
            t.opforVehicles = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.opforVehicles, (g)=>!g.hidden);
            t.opforShips = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.opforShips, (g)=>!g.hidden);
            t.bluforShips = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.bluforShips, (g)=>!g.hidden);
        }
        if (!opts.showHiddenOnMFD) {
            t.opforVehicles = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.opforVehicles, (g)=>!g.hiddenOnMFD);
            t.opforShips = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.opforShips, (g)=>!g.hiddenOnMFD);
        }
        if (!opts.showHidden && !opts.showHiddenOnMFD) {
            t.opforVehicles = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.opforVehicles, (g)=>!g.hidden && !g.hiddenOnMFD);
            t.opforShips = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.opforShips, (g)=>!g.hidden && !g.hiddenOnMFD);
            t.bluforShips = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.bluforShips, (g)=>!g.hidden && !g.hiddenOnMFD);
        }
    } else {
        t.opforVehicles = [];
        t.opforShips = [];
    }
    t.plannedGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.plannedGroups, (g)=>!g.hidden && !g.hiddenOnPlanner);
    // if (!opts.showIndividualUnits) {
    //   _.each(t.opforVehicles, (g) => (g.units = []));
    // }
    if (!opts.showDrawing) t.drawingData = [];
    else {
        let drawing = [];
        if (opts.showDrawingLayerAuthor) {
            const author = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(ts.drawingData, {
                layerName: (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Author
            });
            drawing = drawing.concat(author);
        }
        if (opts.showDrawingLayerCommon) {
            const common = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(ts.drawingData, {
                layerName: (0, $5fc29812bef4ecf9$export$46cf917f0a794e7).Common
            });
            drawing = drawing.concat(common);
        }
        if (opts.showDrawingLayerCoalition) {
            const coa = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(ts.drawingData, (d)=>d.layerName === (0, $5fc29812bef4ecf9$export$46cf917f0a794e7)[(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(coalition)]);
            drawing = drawing.concat(coa);
        }
        t.drawingData = drawing;
    }
    if (opts.showZones) {
        let pred = (z)=>!z.hidden;
        if (opts.showHiddenZones) // return all zones
        pred = (z)=>!!z;
        t.zones = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(ts.zones, pred);
    } else t.zones = [];
    if (!opts.showOpforStatics) {
        t.opforStatics = [];
        t.opforAirbases = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(t.opforAirbases, (a)=>a.Type !== (0, $91a9098e14452db2$export$307b49132840b0da).FARP);
    }
    if (!opts.showFriendlyGroups) t.bluforVehicles = [];
    const hasPresetJob = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(fragOrder.jobs, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig) && fragOrder.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig];
    if (hasPresetJob) t.radioPresets = JSON.parse(fragOrder.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig]);
    return t;
}
function $b88c63f4bcc6d929$export$50c9eb25fb913588(pm) {
    return `${$b88c63f4bcc6d929$var$publicHost}${(0, $91a9098e14452db2$export$37d3279522fbf5e2).PublicFragOrder}/${pm.id}`;
}
function $b88c63f4bcc6d929$export$9ca7028c3a5b35c3(pm, user) {
    const formattedRules = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(pm.planningRules, (r)=>({
            ...r,
            discordUserID: r.discordUserID?.replace("u_", "")
        }));
    const ruleForUser = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(formattedRules, {
        discordUserID: user?.id
    });
    return ruleForUser?.plannableGroupNames || [];
}




var $f1q41 = parcelRequire("f1q41");




const $11a058875073ec02$export$6b34a4cca36bd0df = "PublishManifests";
class $11a058875073ec02$var$reader {
    async get(manifestID) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, manifestID);
        const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        const data = docSnap.data();
        if (!data) throw new Error("Frag Order not found");
        return {
            ...data,
            id: manifestID
        };
    }
}
class $11a058875073ec02$export$54b38e9a38acc6c7 {
    constructor(db){
        this.adminDB = db;
    }
    async get(manifestID) {
        const docRef = this.adminDB.doc(`${$11a058875073ec02$export$6b34a4cca36bd0df}/${manifestID}`);
        const docSnap = await docRef.get();
        const data = docSnap.data();
        if (!data) throw new Error("Frag Order not found");
        return {
            ...data,
            id: manifestID
        };
    }
}
class $11a058875073ec02$var$manager {
    async getTaskingState(fragOrder, coalition) {
        const miz = await this.ms.download(fragOrder.id);
        const [mission, dictionary, warehouses] = await (0, $0dc5bcacaa5e05aa$export$c05b9514531d5fff)(miz);
        // TODO: make an opt
        const ts = (0, $e1dc1ccf277543ba$export$1c86ec91605d839b)(coalition, mission, warehouses, (0, $0dc5bcacaa5e05aa$export$7f3b48ada48e33da)(dictionary));
        return ts;
    }
    async getPublishStatus(fragOrderID) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("fragOrderID", "==", fragOrderID));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const d = await (0, $83e023b4e8d0ddda$export$257224358692d0e0)(querySnapshot);
        return d;
    }
    async upsertPublishManifest(userID, coalition, fragOrder, opts) {
        const manifests = await this.getPublishStatus(fragOrder.id);
        const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
            coalition: coalition
        });
        const ts = await this.getTaskingState(fragOrder, coalition);
        const sanitized = (0, $b88c63f4bcc6d929$export$ed3b4c70a756146)(fragOrder, opts, coalition, ts);
        // Note we don't pass in sanitized here
        const nextManifest = (0, $b88c63f4bcc6d929$export$c84f019cbfe2bcc0)(fragOrder, coalition, opts);
        if (!existing) {
            const t = new Date().getTime();
            // No manifests exist yet. Creating for the first time.
            nextManifest.planningRules = [];
            const ref = (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df);
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(ref);
            const url = await this.bc.upsert(docRef.id, sanitized);
            const bundleAddress = url.toString();
            await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(docRef, {
                ...nextManifest,
                created_by_uid: userID,
                created_at_timestamp: t,
                updated_at_timestamp: t,
                version: 2,
                bundleAddress: bundleAddress
            });
            return;
        }
        const ref = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, existing.id);
        const combined = {
            ...existing,
            ...nextManifest,
            updated_at_timestamp: new Date().getTime()
        };
        if (existing.version >= 2) {
            const url = await this.bc.upsert(existing.id, sanitized);
            combined.bundleAddress = url.toString();
        } else combined.taskingData = JSON.stringify(sanitized);
        const p = (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(ref, combined);
        await this.am.updateGeneratedAssets(userID, existing.id, fragOrder.jobs, ts.plannedGroups, fragOrder.jobSettings);
        return p;
    }
    // @ts-ignore
    getConflictingRules(pm, planningRule) {
        const conflictingRules = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(pm.planningRules, (r)=>{
            if (r.discordUserID === planningRule.discordUserID) return false;
            const newGroups = planningRule.plannableGroupNames;
            const intersection = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).intersection(newGroups, r.plannableGroupNames);
            return intersection.length > 0;
        });
        if (conflictingRules.length > 0) {
            const users = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(conflictingRules.map((r)=>r.discordDisplayText));
            const groups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).flatten(conflictingRules.map((r)=>r.plannableGroupNames)));
            return {
                users: users,
                groups: groups
            };
        }
        return null;
    }
    async upsertPlanningRule(pm, planningRule) {
        // const conflicts = this.getConflictingRules(pm, planningRule);
        // if (conflicts) {
        //   throw new Error("Conflicting planning rules");
        // }
        const existingRule = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(pm.planningRules, {
            discordUserID: planningRule.discordUserID
        });
        if (existingRule) {
            const next = pm.planningRules.map((r)=>{
                if (r.discordUserID === planningRule.discordUserID) return planningRule;
                return r;
            });
            return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, pm.id), {
                ...pm,
                planningRules: next,
                updated_at_timestamp: new Date().getTime()
            });
        }
        const next = {
            ...pm,
            planningRules: [
                ...pm.planningRules,
                planningRule
            ],
            updated_at_timestamp: new Date().getTime()
        };
        if (!pm.id) throw new Error(`Invalid manifest id: ${pm.id}`);
        return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, pm.id), next);
    }
    removePlanningRule(pm, discordID) {
        const next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(pm.planningRules, (r)=>r.discordUserID !== discordID);
        return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, pm.id), {
            ...pm,
            planningRules: next,
            updated_at_timestamp: new Date().getTime()
        });
    }
    async upsertControlMeasureEditors(pm, editors) {
        let nextEditors;
        if (editors.length === 0) nextEditors = [];
        else {
            nextEditors = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniqBy(editors, "discordUserID");
            nextEditors = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(nextEditors, (e)=>{
                return e.discordUserID !== "" || e.displayName !== "";
            });
        }
        const next = {
            ...pm,
            controlMeasureEditors: nextEditors,
            updated_at_timestamp: new Date().getTime()
        };
        if (!pm.id) throw new Error(`Invalid manifest id: ${pm.id}`);
        return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, pm.id), next);
    }
    async upsertSignupRules(pm, rules) {
        if (!pm.id) throw new Error(`Invalid manifest id: ${pm.id}`);
        const next = [];
        for (const r of rules){
            const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(pm.signupRules, {
                missionRole: r.missionRole
            });
            if (existing) next.push({
                ...existing,
                ...r
            });
            else next.push(r);
        }
        return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, pm.id), {
            ...pm,
            signupRules: next,
            updated_at_timestamp: new Date().getTime()
        });
    }
    async toggleSignupsEnabled(pm, enabled) {
        if (!pm.id) throw new Error(`Invalid manifest id: ${pm.id}`);
        return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $11a058875073ec02$export$6b34a4cca36bd0df, pm.id), {
            ...pm,
            signupsEnabled: enabled,
            updated_at_timestamp: new Date().getTime()
        });
    }
}
function $11a058875073ec02$export$47748165199cad2c(db, bc) {
    const r = new $11a058875073ec02$var$reader();
    r.db = db;
    r.bc = bc;
    return r;
}
function $11a058875073ec02$export$34dc733d48e09033(db, ms, am, bc) {
    const m = new $11a058875073ec02$var$manager();
    m.db = db;
    m.ms = ms;
    m.am = am;
    m.bc = bc;
    return m;
}


const $50dfa3f756c4c37a$export$38accb2f941746a9 = "FragOrders";
const $50dfa3f756c4c37a$export$ae2ddee72efdd7 = {
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard]: {
        showTimeOnTarget: false,
        showDistance: false,
        showAltitude: true,
        showFreqs: true,
        showCoords: false,
        showSpeed: false
    },
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectAirbasesKneeboard]: {
        showAirbaseFreqs: true
    },
    // @ts-ignore
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ControlPointsCard]: {},
    // @ts-ignore
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).BriefingText]: {},
    // @ts-ignore
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectSupportAssetsKneeboard]: {},
    [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards]: {
        // @ts-ignore
        showBullsCompass: false,
        showDistances: true
    }
};
class $50dfa3f756c4c37a$var$client {
    async get(id) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $50dfa3f756c4c37a$export$38accb2f941746a9, id);
        const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        return {
            ...docSnap.data(),
            id: id
        };
    }
    async save(userID, name, miz, discordGuildID) {
        const t = new Date().getTime();
        const doc = {
            name: name,
            mizFileName: miz.file.name,
            created_by_uid: userID,
            created_at_timestamp: t,
            updated_at_timestamp: t,
            mizFileSize: miz.file.size,
            mizMetadata: miz.metadata,
            publishOpts: (0, $b88c63f4bcc6d929$export$f08daca113a61734)(),
            discordGuildID: discordGuildID
        };
        const docref = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $50dfa3f756c4c37a$export$38accb2f941746a9), doc);
        await this.ms.save(docref.id, miz.file);
        return {
            ...doc,
            id: docref.id
        };
    }
    async list(userID, count = 10, page) {
        const args = [
            (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $50dfa3f756c4c37a$export$38accb2f941746a9),
            (0, $70fd6868680e912c$export$9c59b80dda569a6e)("created_by_uid", "==", userID),
            (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("created_at_timestamp", "desc"),
            (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(count)
        ];
        if (page) {
            const lastSnap = this.pageSnaps[page];
            if (lastSnap) args.push((0, $70fd6868680e912c$export$859941c5fc8eba6b)(lastSnap));
        }
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4).call(this, ...args);
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        this.pageSnaps[page + 1] = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).last(querySnapshot.docs);
        return (0, $83e023b4e8d0ddda$export$257224358692d0e0)(querySnapshot);
    }
    async publish(userID, fragOrder, coalitions, opts) {
        await this.update(userID, coalitions, {
            ...fragOrder,
            publishOpts: opts,
            jobSettings: $50dfa3f756c4c37a$export$ae2ddee72efdd7
        });
    }
    async update(userID, coalitions, fragOrder, miz) {
        if (!coalitions) throw new Error("coaltions was undefined or not iterable");
        if (miz) await this.ms.save(fragOrder.id, miz.file);
        const next = {
            ...fragOrder,
            jobSettings: {
                ...$50dfa3f756c4c37a$export$ae2ddee72efdd7,
                ...fragOrder.jobSettings
            },
            updated_at_timestamp: (0, $63618293c58b5f80$exports.DateTime).now().toSeconds()
        };
        await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $50dfa3f756c4c37a$export$38accb2f941746a9, fragOrder.id), next);
        for (const coa of coalitions)await this.pub.upsertPublishManifest(userID, coa, next, next.publishOpts);
        // Note: optimistic update here
        return next;
    }
    async remove(d) {
        const manifests = await this.pub.getPublishStatus(d.id);
        for (const man of manifests)await (0, $70fd6868680e912c$export$a4f20481fae8f78b)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, (0, $11a058875073ec02$export$6b34a4cca36bd0df), man.id));
        return (0, $70fd6868680e912c$export$a4f20481fae8f78b)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $50dfa3f756c4c37a$export$38accb2f941746a9, d.id));
    }
    async addJob(userID, fragOrderID, jobType, settings) {
        const fo = await this.get(fragOrderID);
        if (!fo) throw new Error(`Frag Order ${fragOrderID} not found`);
        const next = {
            ...fo,
            jobs: [
                ...fo.jobs || [],
                jobType
            ],
            jobSettings: {
                ...fo.jobSettings,
                [jobType]: settings
            }
        };
        // No need to update manifests currently.
        // That will change if we want to render a kneeboard based on external data.
        return this.update(userID, [], next);
    }
    async removeJob(userID, fragOrderID, jobType) {
        const fo = await this.get(fragOrderID);
        if (!fo) throw new Error(`Frag Order ${fragOrderID} not found`);
        const next = {
            ...fo,
            jobs: fo.jobs.filter((j)=>j !== jobType),
            jobSettings: {
                ...fo.jobSettings,
                [jobType]: null
            }
        };
        return this.update(userID, [], next);
    }
    constructor(){
        this.pageSnaps = [];
    }
}
function $50dfa3f756c4c37a$export$db3faf3b9ad65b42(db, ms, pub) {
    const c = new $50dfa3f756c4c37a$var$client();
    c.db = db;
    c.ms = ms;
    c.pub = pub;
    return c;
}




function $60179128842288a4$export$26891d34a74e9060() {
    return new (0, $45164d3830ef5d35$export$9ed9e168ae73bd0e)();
}



// @ts-ignore



function $27d93e33897b2821$export$63b342d4aadcdcf7(zip, mission, dictionary, suffix = "updated") {
    zip.entries.file("mission", mission);
    if (dictionary) zip.entries.file("/l10n/DEFAULT/dictionary", dictionary);
    zip.entries.generateAsync({
        type: "blob"
    }).then((blob)=>{
        (0, $90f256c567e4c320$exports.saveAs)(blob, `${zip.name.replace(".miz", "")}_${suffix}.miz`);
    });
}
function $27d93e33897b2821$export$269b5c97958a4532(files, cb, errCb) {
    const file = files[0] || files;
    (0, (/*@__PURE__*/$parcel$interopDefault($950bc911f3ee385b$exports))).loadAsync(file).then((entries)=>{
        (0, $0dc5bcacaa5e05aa$export$c05b9514531d5fff)(entries, (miz, dict, warehouses)=>{
            cb(miz, dict, file.name, entries, warehouses);
        });
    }, (err)=>{
        if (errCb) errCb(err);
        else console.error(err);
    });
}
async function $27d93e33897b2821$export$81f0481d70653cd4(zip, mizName, suffix = "_updated.miz") {
    return zip.generateAsync({
        type: "blob"
    }).then((blob)=>{
        (0, $90f256c567e4c320$exports.saveAs)(blob, `${mizName.replace(".miz", "")}_${suffix}`);
    });
}



const $0a53c1f23450367c$export$16e811213eb2e34a = "FragOrders";
function $0a53c1f23450367c$export$eaf8f86643ed73f2(page) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const client = (0, $acw62.useContext)((0, $a7e8caa803539e5f$export$9daed425602f604d));
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $0a53c1f23450367c$export$16e811213eb2e34a,
        page
    ], ()=>client.list(currentUser.id, 10, page), {
        retry: false,
        cacheTime: Infinity,
        staleTime: Infinity
    });
}
function $0a53c1f23450367c$export$ca476617908cb2f8(id) {
    if (!id) throw new Error("FragOrder ID is required");
    const client = (0, $acw62.useContext)((0, $a7e8caa803539e5f$export$9daed425602f604d));
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $0a53c1f23450367c$export$16e811213eb2e34a,
        id
    ], ()=>client.get(id), {
        retry: false
    });
}
function $0a53c1f23450367c$export$afe74451a356b821() {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const client = (0, $acw62.useContext)((0, $a7e8caa803539e5f$export$9daed425602f604d));
    return (name, miz, discordGuildID)=>client.save(currentUser.id, name, miz, discordGuildID).then((result)=>{
            queryClient.invalidateQueries([
                $0a53c1f23450367c$export$16e811213eb2e34a
            ]);
            return result;
        });
}
function $0a53c1f23450367c$export$4f91b3529d70dcc2() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const client = (0, $acw62.useContext)((0, $a7e8caa803539e5f$export$9daed425602f604d));
    return (fo, coalitions, miz)=>client.update(currentUser.id, coalitions, fo, miz).then((next)=>{
            queryClient.invalidateQueries([
                $0a53c1f23450367c$export$16e811213eb2e34a,
                fo.id
            ]);
            queryClient.invalidateQueries([
                (0, $aae70ce689e02dd3$export$b34a6c5661fd52c4)
            ]);
            return next;
        });
}
function $0a53c1f23450367c$export$61c78d1b2fb7a89e() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const client = (0, $acw62.useContext)((0, $a7e8caa803539e5f$export$9daed425602f604d));
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (fragOrder, opts, coalitions)=>client.publish(currentUser.id, fragOrder, coalitions, opts).then(()=>{
            qc.invalidateQueries([
                $0a53c1f23450367c$export$16e811213eb2e34a
            ]);
            qc.invalidateQueries([
                (0, $aae70ce689e02dd3$export$b34a6c5661fd52c4)
            ]);
        });
}
function $0a53c1f23450367c$export$b2b4f9914c5f1de4() {
    const ms = (0, $acw62.useContext)((0, $38644a8687878cac$export$97cfa3fd2e8d725e));
    const mgr = (0, $92839c6c950486dc$export$b7eed842b7007476)();
    const pub = (0, $aae70ce689e02dd3$export$75b3d57a7e9ef3fe)();
    const am = (0, $de1274ee98092164$export$3748ec2d0288f7e5)();
    const bc = (0, $9fa5a1ec57c21134$export$84bdc398979fa84f)();
    const ed = (0, $6f6b89abe389e58a$export$f170a02a4314e0c9)();
    const pm2 = (0, $1ae4eb57bb4d8f1b$export$5020ca831ed7928a)();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    return async (fo)=>{
        if (!fo.jobSettings) fo.jobSettings = (0, $50dfa3f756c4c37a$export$ae2ddee72efdd7);
        const status = await pub.getPublishStatus(fo.id);
        const runner = (0, $b8845d04f48c0190$export$f72ab2bd281958c8)(ms, (0, $60179128842288a4$export$26891d34a74e9060));
        for (const j of fo.jobs){
            let job;
            let tasking;
            let data;
            let cfg;
            let planItems;
            for (const man of status){
                let plans;
                if (man.version >= 2) {
                    const res = await bc.get(man);
                    tasking = JSON.parse(res);
                } else tasking = JSON.parse(man.taskingData);
                if (man.version >= 3) {
                    const res = await pm2.list(man.id);
                    plans = $0a53c1f23450367c$export$d255ce3443702134(man.coalition, tasking.plannedGroups, res);
                } else {
                    const plansRes = await mgr.listPlans(fo.id);
                    plans = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(plansRes, {
                        status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
                    });
                }
                switch(j){
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyPlans:
                        job = {
                            description: j,
                            luaFunc: (0, $cf372e462d8c8894$export$c5b2025ae8c55e80)(plans)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectAirbasesKneeboard:
                        job = {
                            description: j,
                            zipFunc: (0, $70de41fa111b1925$export$9893a8e42f3f46ad)(tasking, fo.jobSettings[j])
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectSupportAssetsKneeboard:
                        job = {
                            description: j,
                            zipFunc: (0, $6128bf652491b016$export$39fa7f973321a045)(tasking)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard:
                        data = await ed.list(fo.id, man.coalition);
                        planItems = await pm2.list(man.id);
                        job = {
                            description: j,
                            zipFunc: (0, $0968f9878ed7a685$export$2c7aaff40fd6353a)(tasking, plans, fo.jobSettings[j], fo.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig], data, planItems)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard:
                        job = {
                            description: j,
                            zipFunc: (0, $033e320cfcdb0c59$export$365fc63a9dedb39e)(tasking, plans)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).BriefingText:
                        job = {
                            description: j,
                            zipFunc: (0, $5519ddab0bdd0a39$export$a838df5501834181)(tasking, man.title)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).Assets:
                        job = {
                            description: j,
                            zipFunc: (0, $5995d3bed1c2280a$export$2e2bcd8739ae039)(currentUser.id, man.id, am)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig:
                        cfg = JSON.parse(fo.jobSettings[j]);
                        job = {
                            description: j,
                            luaFunc: (0, $6c8a2b46ddfacc63$export$2e2bcd8739ae039)(cfg, {
                                coalition: man.coalition,
                                groups: tasking.plannedGroups
                            })
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard:
                        cfg = JSON.parse(fo.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig]);
                        job = {
                            description: j,
                            zipFunc: (0, $cb87d29c90c2795c$export$244734aa07496335)(cfg)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ControlPointsCard:
                        job = {
                            description: j,
                            zipFunc: (0, $a51434310f799586$export$d76af75bc24d9b45)(tasking)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyExternalData:
                        data = await ed.list(fo.id, man.coalition);
                        job = {
                            description: j,
                            luaFunc: (0, $a64d85b213a654e1$export$56cd21e080707bdd)(data)
                        };
                        break;
                    case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards:
                        job = {
                            description: j,
                            zipFunc: (0, $e1b7bdbadfaaf8ab$export$c982a37b93543cd9)(tasking, plans, fo.jobSettings[j])
                        };
                }
                runner.add(job);
            }
        }
        return runner.run(fo);
    };
}
function $0a53c1f23450367c$export$b0b83c3396e2dd0c() {
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const apply = $0a53c1f23450367c$export$b2b4f9914c5f1de4();
    return async (fo)=>{
        let zip;
        try {
            zip = await apply(fo);
        } catch (e) {
            error(e.message);
            throw e;
        }
        return (0, $27d93e33897b2821$export$81f0481d70653cd4)(zip, fo.mizFileName).then(()=>{
            success("Updated mission file downloaded.");
        }).catch((e)=>{
            error(e.message);
            throw e;
        });
    };
}
function $0a53c1f23450367c$export$6015579ffd8399e3(type) {
    const { state: state } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const { data: groups } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(state.manifest.fragOrderID, state.tasking.plannedGroups);
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(groups, (g)=>type === (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(g, [
            "units",
            0,
            "type"
        ]));
}
function $0a53c1f23450367c$export$b521134b1363f352(fragOrderID) {
    const { data: status } = (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(fragOrderID);
    // More than 1 coalition published. Prohibit.
    return status && status.length > 1;
}
function $0a53c1f23450367c$export$c68ca99b64ea1b7c() {
    const c = (0, $acw62.useContext)((0, $a7e8caa803539e5f$export$9daed425602f604d));
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (doc)=>c.remove(doc).then(()=>{
            qc.invalidateQueries([
                $0a53c1f23450367c$export$16e811213eb2e34a
            ]);
        });
}
function $0a53c1f23450367c$export$4bbd5a16ed9e7c94() {
    const match = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)(`${(0, $91a9098e14452db2$export$37d3279522fbf5e2).FragOrderDetail}/:id`);
    const { id: id } = match.params;
    return id;
}
function $0a53c1f23450367c$export$288de7ed5d6c5943() {
    const id = $0a53c1f23450367c$export$4bbd5a16ed9e7c94();
    return $0a53c1f23450367c$export$ca476617908cb2f8(id);
}
function $0a53c1f23450367c$export$6f9969a28801a496() {
    const id = $0a53c1f23450367c$export$4bbd5a16ed9e7c94();
    return (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(id);
}
function $0a53c1f23450367c$export$690fab4e9789b198() {
    let match = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)(`${(0, $91a9098e14452db2$export$37d3279522fbf5e2).PublicFragOrder}/:id`);
    if (!match) match = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)(`${(0, $91a9098e14452db2$export$37d3279522fbf5e2).StandaloneSignupsPage}/:id`);
    const { id: id } = match.params;
    return id;
}
function $0a53c1f23450367c$export$d58792fea78fddc6() {
    const { data: fo } = $0a53c1f23450367c$export$288de7ed5d6c5943();
    return (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(fo?.id);
}
function $0a53c1f23450367c$export$d255ce3443702134(coalition, groups, planItems) {
    const result = [];
    for (const group of groups){
        if (!group) continue;
        const waypointItems = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(planItems, {
            group: group?.name
        });
        const nextWaypoints = [
            ...group?.waypoints
        ];
        for (const item of waypointItems){
            const wp = JSON.parse(item.payload);
            const match = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(nextWaypoints, {
                number: wp.number
            });
            if (match) nextWaypoints.splice(nextWaypoints.indexOf(match), 1, wp);
        }
        const radioCfg = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
            group: group.name,
            type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).RadioPresets
        });
        const note = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
            group: group.name,
            type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).PlanNote
        });
        const laserConfg = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
            group: group.name,
            type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).LaserCodes
        });
        const laserPayload = JSON.parse(laserConfg?.payload || "{}");
        const navPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(planItems, {
            group: group.name,
            type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).NavPoint
        });
        const navPointPayloads = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(navPoints, (w)=>JSON.parse(w.payload));
        const plan = {
            coalition: coalition,
            fragOrderID: "",
            groupName: group.name,
            groupCategory: group.category,
            waypoints: nextWaypoints,
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted,
            radioOverrides: radioCfg?.payload,
            moduleName: (0, $b9c9d9c1adf94aca$export$f028d354b7025aa9)(group),
            plannerNotes: JSON.parse(note?.payload || "{}")?.text,
            laserConfig: laserPayload,
            navPoints: navPointPayloads,
            // TODO: Add annotations
            annotations: []
        };
        result.push(plan);
    }
    return result;
}



const $a10ff9c4760c9625$export$81d4983fce0f0c61 = /*#__PURE__*/ $acw62.createContext({});
function $a10ff9c4760c9625$export$39c9bd023eb21cf0({ reader: reader, children: children }) {
    const value = reader;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a10ff9c4760c9625$export$81d4983fce0f0c61.Provider, {
        value: value,
        children: children
    });
}
function $a10ff9c4760c9625$export$befe97f216af00b0() {
    return $acw62.useContext($a10ff9c4760c9625$export$81d4983fce0f0c61);
}
function $a10ff9c4760c9625$export$57d2af22cd01eebc(manifestID) {
    const reader = $a10ff9c4760c9625$export$befe97f216af00b0();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "manifests",
        manifestID
    ], ()=>reader.get(manifestID), {
        retry: false
    });
}
function $a10ff9c4760c9625$export$76eb408250802197() {
    const id = (0, $0a53c1f23450367c$export$690fab4e9789b198)();
    return $a10ff9c4760c9625$export$57d2af22cd01eebc(id);
}
function $a10ff9c4760c9625$export$5c900e05ff5ed627() {
    const { data: m } = $a10ff9c4760c9625$export$76eb408250802197();
    return (0, $aae70ce689e02dd3$export$f760ffd5af329347)(m);
}




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $25367fb5b82b75d2$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}


const $6400a94b66d5ff2d$var$DiscordClientContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $6400a94b66d5ff2d$export$2e2bcd8739ae039({ discord: discord, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6400a94b66d5ff2d$var$DiscordClientContext.Provider, {
        value: discord,
        children: children
    });
}
const $6400a94b66d5ff2d$export$59c0bf6324c586e9 = "guilds";
function $6400a94b66d5ff2d$export$c2cd3768171c4c0() {
    return $acw62.useContext($6400a94b66d5ff2d$var$DiscordClientContext);
}
const $6400a94b66d5ff2d$var$fetchOnceOpts = {
    retry: false,
    cacheTime: Infinity,
    staleTime: Infinity
};
function $6400a94b66d5ff2d$export$67c0493774f7721f() {
    const client = $6400a94b66d5ff2d$export$c2cd3768171c4c0();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $6400a94b66d5ff2d$export$59c0bf6324c586e9
    ], ()=>client.listGuilds(), $6400a94b66d5ff2d$var$fetchOnceOpts);
}
function $6400a94b66d5ff2d$export$3df55e34da63a51(guildID) {
    const client = $6400a94b66d5ff2d$export$c2cd3768171c4c0();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $6400a94b66d5ff2d$export$59c0bf6324c586e9,
        guildID
    ], ()=>client.listMembers(guildID), $6400a94b66d5ff2d$var$fetchOnceOpts);
}
function $6400a94b66d5ff2d$export$1217c50dac2ce8b8(guildID) {
    const client = $6400a94b66d5ff2d$export$c2cd3768171c4c0();
    const [value, setValue] = $acw62.useState("");
    const debouncedValue = (0, $25367fb5b82b75d2$export$21805fee57372823)(value, 500);
    const { data: data, isLoading: isLoading, error: error } = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $6400a94b66d5ff2d$export$59c0bf6324c586e9,
        guildID,
        debouncedValue
    ], ()=>{
        if (!value) return null;
        return client.searchMembers(guildID, debouncedValue);
    }, $6400a94b66d5ff2d$var$fetchOnceOpts);
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        value: value,
        setValue: setValue
    };
}




const $0ecfc9ca75a4d1c7$export$59c0bf6324c586e9 = "guilds";
function $0ecfc9ca75a4d1c7$export$95dec5704e27cc89(guildID) {
    const discord = (0, $6400a94b66d5ff2d$export$c2cd3768171c4c0)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $0ecfc9ca75a4d1c7$export$59c0bf6324c586e9,
        guildID
    ], ()=>discord.listMembers(guildID), {
        retry: false,
        cacheTime: Infinity,
        staleTime: Infinity
    });
}
function $0ecfc9ca75a4d1c7$export$1217c50dac2ce8b8(guildID) {
    const [value, setValue] = (0, $acw62.useState)("");
    const debouncedValue = (0, $25367fb5b82b75d2$export$21805fee57372823)(value, 500);
    const discord = (0, $6400a94b66d5ff2d$export$c2cd3768171c4c0)();
    const { data: data, isLoading: isLoading, error: error } = (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $0ecfc9ca75a4d1c7$export$59c0bf6324c586e9,
        guildID,
        debouncedValue
    ], ()=>{
        if (!value) return discord.listMembers(guildID);
        return discord.searchMembers(guildID, value);
    }, {
        retry: false,
        cacheTime: Infinity,
        staleTime: Infinity
    });
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        value: value,
        setValue: setValue
    };
}
function $0ecfc9ca75a4d1c7$export$414c514f075f4b0e(guildID, enabled = false) {
    const discord = (0, $6400a94b66d5ff2d$export$c2cd3768171c4c0)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $0ecfc9ca75a4d1c7$export$59c0bf6324c586e9,
        guildID,
        enabled
    ], ()=>{
        if (!enabled) return [];
        return discord.listGuildRoles(guildID);
    }, {
        retry: false,
        cacheTime: Infinity,
        staleTime: Infinity,
        enabled: enabled
    });
}
function $0ecfc9ca75a4d1c7$export$690569ca14db6e07() {
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "botAuthURL"
    ], ()=>(0, $5f078b543969ac27$export$1e0d7a6ccb38427f)());
}
function $0ecfc9ca75a4d1c7$export$ae03fe1e5a2b9fd6(guildID) {
    const c = (0, $6400a94b66d5ff2d$export$c2cd3768171c4c0)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "botCheck",
        guildID
    ], ()=>{
        if (!guildID) return;
        return c.checkBotStatus(guildID);
    }, {
        retry: false
    });
}
function $0ecfc9ca75a4d1c7$export$c4e92f8db4fb36b8(discordGuildID) {
    const { data: botPresent, isLoading: isLoadingBotCheck } = $0ecfc9ca75a4d1c7$export$ae03fe1e5a2b9fd6(discordGuildID);
    return !isLoadingBotCheck && !botPresent;
}
function $0ecfc9ca75a4d1c7$export$d7bd81cf9fcbd85a(guildID) {
    const discord = (0, $6400a94b66d5ff2d$export$c2cd3768171c4c0)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "membersAndRoles",
        guildID
    ], async ()=>{
        const [members, roles] = await Promise.all([
            discord.listMembers(guildID),
            discord.listGuildRoles(guildID)
        ]);
        const normalizedMembers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(members, (m)=>({
                id: `u_${m.user.id}`,
                name: m.nick || m.user.username
            }));
        const normalizedRoles = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(roles, (r)=>({
                id: `r_${r.id}`,
                name: r.name.includes("@") ? r.name : `@${r.name}`,
                color: r.color
            }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(normalizedRoles, normalizedMembers);
    });
}
function $0ecfc9ca75a4d1c7$export$2941e56b28ff590c(guildID) {
    const discord = (0, $6400a94b66d5ff2d$export$c2cd3768171c4c0)();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "guildMember",
        guildID
    ], ()=>{
        if (!guildID) return null;
        return discord.getGuildMemberForUser(guildID);
    }, {
        retry: false,
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $f1q41 = parcelRequire("f1q41");
var $cc7c21536f059c95$export$c75b72909fbb7204;
(function(SignupRoleType) {
    SignupRoleType["Aircrew"] = "Pilot/Crew";
    SignupRoleType["Controller"] = "Controller";
})($cc7c21536f059c95$export$c75b72909fbb7204 || ($cc7c21536f059c95$export$c75b72909fbb7204 = {}));


class $42e57f753198e6db$export$57a8fad6df7d0c40 {
    constructor(pub, discord, bc){
        this.pub = pub;
        this.discord = discord;
        this.bc = bc;
    }
    async getRuleData(userID, manifest) {
        if (!manifest) throw new Error("No manifest found");
        const res = await this.bc.get(manifest);
        const tasking = JSON.parse(res);
        const groups = tasking.plannedGroups;
        const rules = manifest.signupRules;
        const member = await this.discord.getGuildMemberForUser(manifest.discordGuildID);
        return {
            groups: groups,
            rules: rules,
            member: member
        };
    }
    async getAvailableRoles(userID, manifest) {
        const { groups: groups, rules: rules, member: member } = await this.getRuleData(userID, manifest);
        const availableGroups = [];
        for (const group of groups){
            const relevantRules = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(rules, (r)=>r.missionRole === group.name);
            const idMatch = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(relevantRules, (r)=>{
                if (r.discordID.startsWith("r_")) return false;
                return r.discordID.replace("u_", "") === member?.user?.id;
            });
            if (idMatch) {
                availableGroups.push(group.name);
                continue;
            }
            const roleMatch = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(relevantRules, (r)=>{
                if (r.discordID.startsWith("u_")) return false;
                if (r.discordLabel === "@everyone") return true;
                return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(member?.roles, r.discordID.replace("r_", ""));
            });
            if (roleMatch) {
                availableGroups.push(group.name);
                continue;
            }
        }
        const otherRules = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(rules, (r)=>r.signupRoleType !== (0, $cc7c21536f059c95$export$c75b72909fbb7204).Aircrew);
        for (const rule of otherRules){
            if (rule.discordLabel === "@everyone") {
                availableGroups.push(rule.missionRole);
                continue;
            }
            const idMatch = rule.discordID.replace("u_", "") === member?.user?.id;
            if (idMatch) {
                availableGroups.push(rule.missionRole);
                continue;
            }
            const roleMatch = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(member?.roles, rule.discordID.replace("r_", ""));
            if (roleMatch) {
                availableGroups.push(rule.missionRole);
                continue;
            }
        }
        return availableGroups;
    }
    async authorize(userID, manifest, record) {
        const groups = await this.getAvailableRoles(userID, manifest);
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(groups, record.missionRole);
    }
}


const $eb85d675c21bd358$var$SignupClientContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $eb85d675c21bd358$export$3171755586168afb() {
    return (0, $acw62.useContext)($eb85d675c21bd358$var$SignupClientContext);
}
function $eb85d675c21bd358$export$90cb89d094cdf2e0({ api: api, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eb85d675c21bd358$var$SignupClientContext.Provider, {
        value: api,
        children: children
    });
}
function $eb85d675c21bd358$export$617c26084be82b77() {
    const { data: m } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    return m?.signupsEnabled;
}
function $eb85d675c21bd358$export$e484248f751fe150() {
    const { data: m } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    return m?.signupRules;
}
const $eb85d675c21bd358$var$SignupsQueryKey = "signups";
function $eb85d675c21bd358$export$5708b7569edcff73(manifestID) {
    const api = $eb85d675c21bd358$export$3171755586168afb();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (record, discordNickName)=>api.signup(manifestID, record, discordNickName).then(()=>qc.invalidateQueries($eb85d675c21bd358$var$SignupsQueryKey));
}
function $eb85d675c21bd358$export$b3cf2d12e6d589ce() {
    const api = $eb85d675c21bd358$export$3171755586168afb();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (record)=>api.remove(record.id).then(()=>qc.invalidateQueries($eb85d675c21bd358$var$SignupsQueryKey));
}
function $eb85d675c21bd358$export$d349e2e73fd5535b() {
    const pub = (0, $a10ff9c4760c9625$export$befe97f216af00b0)();
    const discord = (0, $6400a94b66d5ff2d$export$c2cd3768171c4c0)();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const bc = (0, $9fa5a1ec57c21134$export$84bdc398979fa84f)();
    const { data: m } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    const authorizer = new (0, $42e57f753198e6db$export$57a8fad6df7d0c40)(pub, discord, bc);
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "signup-authorizer",
        m?.id
    ], ()=>{
        if (!m) return Promise.resolve([]);
        return authorizer.getAvailableRoles(currentUser?.id, m);
    });
}
function $eb85d675c21bd358$export$5bd67ab68a9b3858(manifestID) {
    const api = $eb85d675c21bd358$export$3171755586168afb();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $eb85d675c21bd358$var$SignupsQueryKey,
        manifestID
    ], ()=>{
        if (!manifestID) return Promise.resolve([]);
        return api.list(manifestID);
    });
}







var $ayMG0 = parcelRequire("ayMG0");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $89a1bb9709695920$export$f3b76d2cce458caa(slot) {
    return (0, $9XEW1.default)("MuiCard", slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $7u6PA.default)("MuiCard", [
    "root"
]);
var $89a1bb9709695920$export$2e2bcd8739ae039 = $89a1bb9709695920$var$cardClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $45313e7d506ce734$var$_excluded = [
    "className",
    "raised"
];
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9971e.default)(slots, (0, $89a1bb9709695920$export$f3b76d2cce458caa), classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $1En50.default)(props, $45313e7d506ce734$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        raised: raised
    });
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $45313e7d506ce734$export$2e2bcd8739ae039 = $45313e7d506ce734$var$Card;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $4c5dd21dca115198$export$2a5c27c211442e3c(slot) {
    return (0, $9XEW1.default)("MuiCardActions", slot);
}
const $4c5dd21dca115198$var$cardActionsClasses = (0, $7u6PA.default)("MuiCardActions", [
    "root",
    "spacing"
]);
var $4c5dd21dca115198$export$2e2bcd8739ae039 = $4c5dd21dca115198$var$cardActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $b46a5bcac23a5f99$var$_excluded = [
    "disableSpacing",
    "className"
];
const $b46a5bcac23a5f99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $9971e.default)(slots, (0, $4c5dd21dca115198$export$2a5c27c211442e3c), classes);
};
const $b46a5bcac23a5f99$var$CardActionsRoot = (0, $d8seH.default)("div", {
    name: "MuiCardActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        alignItems: "center",
        padding: 8
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $b46a5bcac23a5f99$var$CardActions = /*#__PURE__*/ $acw62.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiCardActions"
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $1En50.default)(props, $b46a5bcac23a5f99$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $b46a5bcac23a5f99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46a5bcac23a5f99$var$CardActionsRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b46a5bcac23a5f99$export$2e2bcd8739ae039 = $b46a5bcac23a5f99$var$CardActions;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $72f090ff2322b6ae$export$5f5333fe417019a7(slot) {
    return (0, $9XEW1.default)("MuiCardMedia", slot);
}
const $72f090ff2322b6ae$var$cardMediaClasses = (0, $7u6PA.default)("MuiCardMedia", [
    "root",
    "media",
    "img"
]);
var $72f090ff2322b6ae$export$2e2bcd8739ae039 = $72f090ff2322b6ae$var$cardMediaClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $891b59d4b36435bb$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $891b59d4b36435bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            "root",
            isMediaComponent && "media",
            isImageComponent && "img"
        ]
    };
    return (0, $9971e.default)(slots, (0, $72f090ff2322b6ae$export$5f5333fe417019a7), classes);
};
const $891b59d4b36435bb$var$CardMediaRoot = (0, $d8seH.default)("div", {
    name: "MuiCardMedia",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "block",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }, ownerState.isMediaComponent && {
        width: "100%"
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: "cover"
    }));
const $891b59d4b36435bb$var$MEDIA_COMPONENTS = [
    "video",
    "audio",
    "picture",
    "iframe",
    "img"
];
const $891b59d4b36435bb$var$IMAGE_COMPONENTS = [
    "picture",
    "img"
];
const $891b59d4b36435bb$var$CardMedia = /*#__PURE__*/ $acw62.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiCardMedia"
    });
    const { children: children, className: className, component: component = "div", image: image, src: src, style: style } = props, other = (0, $1En50.default)(props, $891b59d4b36435bb$var$_excluded);
    const isMediaComponent = $891b59d4b36435bb$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $8nd05.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $891b59d4b36435bb$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $891b59d4b36435bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($891b59d4b36435bb$var$CardMediaRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? "img" : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $891b59d4b36435bb$export$2e2bcd8739ae039 = $891b59d4b36435bb$var$CardMedia;



var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");





var $5affddf718831446$exports = {};
$5affddf718831446$exports = new URL("card_hornet.49eb0894.png", import.meta.url).toString();


var $b31e18205a0616c2$exports = {};
$b31e18205a0616c2$exports = new URL("card_viper.c7caaa09.png", import.meta.url).toString();


var $5d532102cd5ff5b0$exports = {};
$5d532102cd5ff5b0$exports = new URL("card_eagle.addc6692.png", import.meta.url).toString();


var $75110178cc3d8d96$exports = {};
$75110178cc3d8d96$exports = new URL("card_tomcat.9a93181e.jpg", import.meta.url).toString();


var $373989d79538081f$exports = {};
$373989d79538081f$exports = new URL("card_apache.fa051759.png", import.meta.url).toString();


var $b36e998986f7f9d3$exports = {};
$b36e998986f7f9d3$exports = new URL("card_hawg.c4d4f8df.jpg", import.meta.url).toString();


var $f84cd1f480a836e2$exports = {};
$f84cd1f480a836e2$exports = new URL("card_controller.3020b7b2.png", import.meta.url).toString();


var $523ab1400e01b33e$exports = {};
$523ab1400e01b33e$exports = new URL("card_unknown.0ad4752b.png", import.meta.url).toString();


const $9f2556238d8b8a31$var$cardImages = {
    "F-16C_50": (0, (/*@__PURE__*/$parcel$interopDefault($b31e18205a0616c2$exports))),
    "FA-18C_hornet": (0, (/*@__PURE__*/$parcel$interopDefault($5affddf718831446$exports))),
    "F-15ESE": (0, (/*@__PURE__*/$parcel$interopDefault($5d532102cd5ff5b0$exports))),
    "F-14B": (0, (/*@__PURE__*/$parcel$interopDefault($75110178cc3d8d96$exports))),
    "AH-64D_BLK_II": (0, (/*@__PURE__*/$parcel$interopDefault($373989d79538081f$exports))),
    "A-10C_2": (0, (/*@__PURE__*/$parcel$interopDefault($b36e998986f7f9d3$exports))),
    Controller: (0, (/*@__PURE__*/$parcel$interopDefault($f84cd1f480a836e2$exports)))
};
function $9f2556238d8b8a31$var$SignupCard({ className: className, rule: r, actions: actions, signups: signups }) {
    const isPilot = r.signupRoleType === (0, $cc7c21536f059c95$export$c75b72909fbb7204).Aircrew && r.module;
    let img = (0, (/*@__PURE__*/$parcel$interopDefault($523ab1400e01b33e$exports)));
    if (isPilot) img = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get($9f2556238d8b8a31$var$cardImages, r.module);
    else if (r.signupRoleType === (0, $cc7c21536f059c95$export$c75b72909fbb7204).Controller) img = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get($9f2556238d8b8a31$var$cardImages, "Controller");
    img = img || (0, (/*@__PURE__*/$parcel$interopDefault($523ab1400e01b33e$exports)));
    const m = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[r.module];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $45313e7d506ce734$export$2e2bcd8739ae039), {
        className: className,
        sx: {
            width: 360
        },
        elevation: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $891b59d4b36435bb$export$2e2bcd8739ae039), {
                sx: {
                    height: 140
                },
                image: img,
                title: "Fighter Jet"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                p: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        between: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    children: r.missionRole
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    children: (0, $b9c9d9c1adf94aca$export$f6f709ff2b245f60)(r.module)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        between: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            p: 1,
                            paddingLeft: 0,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    minHeight: "1em"
                                },
                                children: r.notes || " "
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                            columns: 2,
                            pairs: [
                                {
                                    key: "Role Type",
                                    value: r.signupRoleType
                                },
                                {
                                    key: "Discord Role",
                                    value: r.discordLabel
                                },
                                {
                                    key: "Signups",
                                    value: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(signups, (s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                s.discordNickname,
                                                " ",
                                                m?.hasMultiCrew && s.copilot ? "(Copilot)" : ""
                                            ]
                                        }, i))
                                }
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b46a5bcac23a5f99$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    between: true,
                    children: actions
                })
            })
        ]
    });
}
var $9f2556238d8b8a31$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($9f2556238d8b8a31$var$SignupCard).attrs({
    className: $9f2556238d8b8a31$var$SignupCard.name
})``;


function $429695e7699d8b8e$var$moduleHasMultiCrew(m) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, $b9c9d9c1adf94aca$export$cc2c248003684daa), [
        m,
        "hasMultiCrew"
    ], false);
}
function $429695e7699d8b8e$var$PublicSignup({ className: className }) {
    const { data: manifest } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const [submitting, setSubmitting] = $acw62.useState(null);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const { data: guildUser } = (0, $0ecfc9ca75a4d1c7$export$2941e56b28ff590c)(manifest?.discordGuildID);
    const { data: signups } = (0, $eb85d675c21bd358$export$5bd67ab68a9b3858)(manifest?.id);
    const submit = (0, $eb85d675c21bd358$export$5708b7569edcff73)(manifest?.id);
    const remove = (0, $eb85d675c21bd358$export$b3cf2d12e6d589ce)();
    const { data: availableGroups } = (0, $eb85d675c21bd358$export$d349e2e73fd5535b)();
    const handleSignup = (rule, copilot)=>{
        setSubmitting({
            rule: rule,
            copilot: copilot
        });
        const record = {
            missionRole: rule.missionRole,
            discordID: currentUser?.id,
            discordNickname: currentUser?.username,
            copilot: copilot,
            manifestID: manifest.id
        };
        submit(record, guildUser?.nick).then(()=>{
            success("Signup submitted");
        }).catch((e)=>{
            error("Error submitting signup: " + e.message);
        }).finally(()=>{
            setSubmitting(null);
        });
    };
    const handleRemove = (record)=>{
        const r = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifest?.signupRules, {
            missionRole: record.missionRole
        });
        setSubmitting({
            rule: r,
            copilot: record.copilot
        });
        remove(record).then(()=>{
            success("Signup removed");
        }).catch((e)=>{
            error("Error removing signup: " + e.message);
        }).finally(()=>{
            setSubmitting(null);
        });
    };
    const cardGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).groupBy(manifest?.signupRules, "module");
    const signupGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).groupBy(signups, "missionRole");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            p: 2,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    paddingLeft: 4,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(cardGroups, (rules, m)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    marginY: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            // sx={{ mt: 0.5, ml: 2 }}
                                            color: "text.secondary",
                                            display: "block",
                                            variant: "caption",
                                            fontWeight: 600,
                                            children: (0, $b9c9d9c1adf94aca$export$f6f709ff2b245f60)(m) || "Other Roles"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                    container: true,
                                    spacing: 2,
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rules, (r)=>{
                                        const signup = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(signups, {
                                            missionRole: r.missionRole,
                                            discordID: currentUser?.id
                                        });
                                        const userIsSignedUp = !!signup;
                                        const userIsCopilot = userIsSignedUp && signup?.copilot;
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9f2556238d8b8a31$export$2e2bcd8739ae039), {
                                                rule: r,
                                                signups: signupGroups[r.missionRole],
                                                actions: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                                            loading: submitting?.rule === r && !submitting?.copilot,
                                                            disabled: !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(availableGroups, r.missionRole),
                                                            onClick: ()=>userIsSignedUp ? handleRemove(signup) : handleSignup(r, false),
                                                            color: `${userIsSignedUp ? "error" : "info"}`,
                                                            children: userIsSignedUp ? "Remove Signup" : `Sign Up as ${r.signupRoleType === (0, $cc7c21536f059c95$export$c75b72909fbb7204).Aircrew ? "Pilot" : "Controller"}`
                                                        }),
                                                        !userIsSignedUp && $429695e7699d8b8e$var$moduleHasMultiCrew(r.module) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                                            loading: submitting?.rule === r && submitting?.copilot,
                                                            onClick: ()=>userIsSignedUp && userIsCopilot ? handleRemove(signup) : handleSignup(r, true),
                                                            disabled: !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(availableGroups, r.missionRole),
                                                            children: "Sign Up as Co-pilot"
                                                        })
                                                    ]
                                                })
                                            })
                                        }, r.missionRole);
                                    })
                                }, m)
                            ]
                        }, m);
                    })
                })
            })
        })
    });
}
var $429695e7699d8b8e$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($429695e7699d8b8e$var$PublicSignup).attrs({
    className: $429695e7699d8b8e$var$PublicSignup.name
})`
  background-color: #ecf1f5;
  /* height: 100%; */

  ${(0, $a0e83392a1945b28$export$2e2bcd8739ae039)} {
    .MuiGrid-item {
      display: flex;
      /* width: 99%; */
      justify-content: space-between;
      padding-left: 8px;
    }
  }
`;






class $d50b0bcc71cd47ca$var$fetcher {
    constructor(f){
        this.fetch = f.bind(window);
    }
    // eslint-disable-next-line
    async req(path, params) {
        const res = await this.fetch(path, params);
        if (!res.ok) {
            const b = await res.json();
            if (b.error) throw new Error(b.error);
            throw new Error(res.statusText);
        }
        if (res.headers.get("content-length") === "0") return Promise.resolve();
        return res.json();
    }
}
function $d50b0bcc71cd47ca$export$dc242f1fb6cc2e41(f) {
    return new $d50b0bcc71cd47ca$var$fetcher(f);
}



const $f9c437f0d6220302$var$fetcher = (0, $d50b0bcc71cd47ca$export$dc242f1fb6cc2e41)(fetch);
const $f9c437f0d6220302$var$contexts = [
    [
        (0, $e1f03c0083d00e9b$export$b0eb5dd44c72ef97),
        {
            subs: (0, $dbf86a8fe13ef9de$export$7540639e9eb63b3b)($f9c437f0d6220302$var$fetcher)
        }
    ],
    [
        (0, $5f078b543969ac27$export$88f24fd8fcfab6ca),
        {}
    ]
];
function $f9c437f0d6220302$var$wrapComponentWithProviders(providerPropsTuples, Component) {
    return providerPropsTuples.reduceRight((WrappedComponent, [Provider, providerProps])=>{
        return ({ children: children, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)(Provider, {
                ...providerProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(WrappedComponent, {
                    ...props,
                    children: children
                })
            });
    }, Component);
}
function $f9c437f0d6220302$var$MissionSignupsPage({ className: className }) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const { data: manifest, isLoading: isLoading } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        loading: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: `${manifest?.title} - Mission Signups`,
                children: [
                    !currentUser && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        severity: "info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                                children: "Please sign in to Discord to sign up for missions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5e8911e4b30dc90$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $429695e7699d8b8e$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}
const $f9c437f0d6220302$var$WrappedMissionSignupsPage = $f9c437f0d6220302$var$wrapComponentWithProviders($f9c437f0d6220302$var$contexts, $f9c437f0d6220302$var$MissionSignupsPage);
var $f9c437f0d6220302$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($f9c437f0d6220302$var$WrappedMissionSignupsPage).attrs({
    className: $f9c437f0d6220302$var$MissionSignupsPage.name
})`
  ${(0, $429695e7699d8b8e$export$2e2bcd8739ae039)} {
    background-color: white !important;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");




var $acw62 = parcelRequire("acw62");








function $65bf097f1591a9ef$var$RedeemSub({ className: className }) {
    const [errorMessage, setErrorMessage] = $acw62.useState(null);
    const [redeeming, setRedeeming] = $acw62.useState(false);
    const [redeemSuccess, setRedeemSuccess] = $acw62.useState(false);
    const { currentUser: currentUser, loading: isLoadingUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const { code: code } = (0, $3ecb7368762fc268$export$98e6a39c04603d36)(location.search);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const invalidCode = !code || Array.isArray(code);
    const { data: record, isLoading: isLoadingRecord } = (0, $3e8772b7528d3c44$export$53a848f107b70f44)(code);
    const redeem = (0, $3e8772b7528d3c44$export$f097d75c1f470982)();
    const handleRedeem = $acw62.useCallback(()=>{
        setRedeeming(true);
        redeem(record?.oneTimeCode).then(()=>{
            setRedeemSuccess(true);
            success("License redeemed successfully");
        }).catch((e)=>{
            switch(e.message){
                case "already_redeemed":
                    return setErrorMessage("This code has already been redeemed");
                case "not_found":
                    return setErrorMessage("Invalid code");
                case "already_subscribed":
                    return setErrorMessage("You already have a subscription. Please cancel it first.");
                default:
                    break;
            }
            error(e.message);
        }).finally(()=>{
            setRedeeming(false);
        });
    }, [
        record
    ]);
    const isAlreadyRedeemed = record && record.redeemedAt;
    const isRedeemable = record && !isAlreadyRedeemed;
    const isRecordFound = record && !isLoadingRecord;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
            title: "Redeem Group Subscription",
            children: [
                invalidCode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                    severity: "error",
                    children: "Invalid code"
                }),
                errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                    severity: "error",
                    children: errorMessage
                }),
                !isLoadingRecord && !record && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                    severity: "error",
                    children: "Code not found"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    center: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            isRecordFound && isRedeemable && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            record?.createdByDisplayName,
                                            " "
                                        ]
                                    }),
                                    "has invited you to redeem a group subscription license for Frag Orders"
                                ]
                            }),
                            !isLoadingUser && !currentUser && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5e8911e4b30dc90$export$2e2bcd8739ae039), {}),
                            isRedeemable && !redeemSuccess && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                wide: true,
                                center: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                    loading: redeeming,
                                    onClick: handleRedeem,
                                    size: "large",
                                    variant: "contained",
                                    color: "primary",
                                    children: "Redeem License"
                                })
                            }),
                            redeemSuccess && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                                severity: "success",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                                        children: "Success"
                                    }),
                                    "License redeemed successfully. You can now access Frag Orders Premium features.",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                        center: true,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                                href: "https://preview.fragorders.com",
                                                children: "Go To Frag Orders"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                                target: "_blank",
                                                href: "https://docs.fragorders.com",
                                                children: "Read the Docs"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !redeemSuccess && isAlreadyRedeemed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                                severity: "info",
                                children: "This code has already been redeemed."
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $65bf097f1591a9ef$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($65bf097f1591a9ef$var$RedeemSub).attrs({
    className: $65bf097f1591a9ef$var$RedeemSub.name
})`
  width: 100%;
`;




















var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $49b61c4bd4225956$var$UserPreferencesManagerContext = /*#__PURE__*/ $acw62.createContext(null);
function $49b61c4bd4225956$export$1ea71c1002a93812({ manager: manager, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($49b61c4bd4225956$var$UserPreferencesManagerContext.Provider, {
        value: manager,
        children: children
    });
}
function $49b61c4bd4225956$var$useUserPreferencesManager() {
    const manager = $acw62.useContext($49b61c4bd4225956$var$UserPreferencesManagerContext);
    if (!manager) throw new Error("useUserPreferencesManager must be used within a UserPreferencesManagerProvider");
    return manager;
}
const $49b61c4bd4225956$var$USER_PREFS_KEY = "userPreferences";
function $49b61c4bd4225956$export$764b58f9e83d22d4() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const manager = $49b61c4bd4225956$var$useUserPreferencesManager();
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        $49b61c4bd4225956$var$USER_PREFS_KEY
    ], ()=>manager.list(currentUser.id));
}
function $49b61c4bd4225956$export$6c3b0ebb69540b34() {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const manager = $49b61c4bd4225956$var$useUserPreferencesManager();
    return (name, type, payload)=>manager.upsert(currentUser.id, {
            name: name,
            type: type,
            payload: JSON.stringify(payload)
        }).then(()=>{
            qc.invalidateQueries($49b61c4bd4225956$var$USER_PREFS_KEY);
        });
}
function $49b61c4bd4225956$export$db878806a63245d5() {
    const qc = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const manager = $49b61c4bd4225956$var$useUserPreferencesManager();
    return (preference)=>manager.remove(preference).then(()=>{
            qc.invalidateQueries($49b61c4bd4225956$var$USER_PREFS_KEY);
        });
}




var $b9f389ba82d8f28a$var$name = "firebase";
var $b9f389ba82d8f28a$var$version = "9.8.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $57d436074e210fb5$export$d29d5299a7137abc)($b9f389ba82d8f28a$var$name, $b9f389ba82d8f28a$var$version, "app");




function $1d8101519e016e43$export$2cd8252107eb640b() {
    const params = {
        apiKey: "AIzaSyDh-zqijDA8fp29CyUIDBZuubri_LYiHiQ",
        authDomain: "fragorders-dev-8bb89.firebaseapp.com",
        projectId: "fragorders-dev-8bb89",
        storageBucket: "fragorders-dev-8bb89.appspot.com",
        messagingSenderId: "297795662040",
        appId: "1:297795662040:web:180ed4c090ec78964067ad"
    };
    const app = (0, $57d436074e210fb5$export$c55cfd413944906d)(params);
    const auth = (0, $8eace09cb4780ee7$export$7ccc53e8f1e7dfc5)(app);
    const db = (0, $70fd6868680e912c$export$f06a05d14c3a6678)(app);
    return {
        app: app,
        auth: auth,
        db: db
    };
}




var $f1q41 = parcelRequire("f1q41");




const $6992b055e10e3f03$var$re = /(?:\.([^.]+))?$/;
// https://stackoverflow.com/questions/680929/how-to-extract-extension-from-filename-string-in-javascript
function $6992b055e10e3f03$var$getExtention(filename) {
    const match = $6992b055e10e3f03$var$re.exec(filename);
    return match && match[1];
}
const $6992b055e10e3f03$export$ca0d173e26053f8c = "Assets";
class $6992b055e10e3f03$var$manager {
    constructor(f){
        this.fetch = f;
    }
    async fileUpload(asset, file) {
        const ext = $6992b055e10e3f03$var$getExtention(file?.name);
        const contentType = ext ? `image/${ext}` : "image";
        const { uploadURL: uploadURL } = await this.fetch.req("/.netlify/functions/asset_upload_url", {
            method: "POST",
            body: JSON.stringify({
                manifestID: asset.manifestID,
                filename: file?.name,
                contentType: contentType,
                asset: asset
            })
        });
        await this.fetch.req(uploadURL, {
            method: "PUT",
            // @ts-ignore
            body: file
        });
    }
    async upload(userID, asset, file) {
        if (asset.type !== (0, $8a132888bcd1c418$export$e57062a38354425e).GeneratedKneeboard) // We don't upload files for generated assets.
        // We render them on-request to make sure they have the current data.
        await this.fileUpload(asset, file);
        const t = new Date().getTime();
        let d = {
            ...asset,
            created_by_uid: userID,
            created_at_timestamp: t,
            updated_at_timestamp: t
        };
        const assetID = asset.id;
        let docRef = {
            id: assetID
        };
        if (assetID) await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $6992b055e10e3f03$export$ca0d173e26053f8c, assetID), d);
        else docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $6992b055e10e3f03$export$ca0d173e26053f8c), d);
        return {
            ...d,
            id: docRef.id
        };
    }
    async list(manifestID) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $6992b055e10e3f03$export$ca0d173e26053f8c), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("manifestID", "==", manifestID), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("name", "asc"));
        const snaps = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        return (0, $83e023b4e8d0ddda$export$257224358692d0e0)(snaps);
    }
    async getByName(manifestID, name) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $6992b055e10e3f03$export$ca0d173e26053f8c), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("manifestID", "==", manifestID), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("name", "==", name), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("name", "asc"));
        const snaps = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (snaps.docs.length > 1) throw new Error(`Found multiple assets with the name ${name}`);
        const doc = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(snaps, [
            "docs",
            0
        ]);
        return doc?.data();
    }
    async url(manifestUserID, asset) {
        const res = await this.fetch.req("/.netlify/functions/asset_url", {
            method: "POST",
            body: JSON.stringify({
                asset: asset,
                manifestUserID: manifestUserID
            })
        });
        if (res.status >= 400) throw new Error(res.statusText);
        return res.url;
    }
    async remove(asset) {
        try {
            await (0, $70fd6868680e912c$export$a4f20481fae8f78b)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $6992b055e10e3f03$export$ca0d173e26053f8c, asset.id));
        } catch (e) {
            console.trace();
            console.error("Error removing asset", e);
        }
    }
    async updateGeneratedAssets(userID, manifestID, desiredJobs = [], groups, settings) {
        const assets = await this.list(manifestID);
        const autoGend = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(assets, (a)=>{
            if (a.type === (0, $8a132888bcd1c418$export$e57062a38354425e).GeneratedKneeboard) {
                if (a.jobType !== (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard && a.jobType !== (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard && a.jobType !== (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards) return true;
            }
            return !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(desiredJobs, a.jobType);
        });
        // Special remove logic for group kneeboards
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(desiredJobs, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard)) {
            const lineupAssets = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(assets, {
                jobType: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard
            });
            for (const lineup of lineupAssets)await this.remove(lineup);
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(desiredJobs, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard)) {
            const commsCards = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(assets, {
                jobType: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard
            });
            for (const card of commsCards)await this.remove(card);
        }
        // Remove deselected auto-gen jobs
        for (const a of autoGend)// Avoiding removing an asset that has already been removed above.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(desiredJobs, a.jobType) && !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(autoGend, a)) await this.remove(a);
        for (const j of desiredJobs){
            let jobSettings = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(settings, j) || null;
            const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(assets, {
                jobType: j
            });
            if (existing.length > 0) {
                // Update with new settings
                for (const e of existing){
                    const d = JSON.parse(e.jobData || "{}");
                    const g = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groups, {
                        name: d.groupName
                    });
                    if (!g && (e.jobType === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard || e.jobType === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard)) {
                        // Group was deleted, remove asset
                        await this.remove(e);
                        continue;
                    }
                    // Special case where we want to store presets on the jobData field.
                    // This also copies the presets from the RadioConfig job to the kneeboard job.
                    if (e.jobType === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard) {
                        jobSettings = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(settings, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig);
                        await this.upload(userID, {
                            ...e,
                            jobData: JSON.stringify(jobSettings)
                        });
                        continue;
                    }
                    await this.upload(userID, {
                        ...e,
                        jobSettings: jobSettings
                    });
                }
                continue;
            }
            const name = (0, $b8845d04f48c0190$export$4f3f9abc0506b44c)[j];
            if (!name) continue;
            const displayName = (0, $b8845d04f48c0190$export$867e91a0c7aed7fd)[j];
            // Special logic for group-specific kneeboards.
            // We need one asset per group.
            if (j === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard || j === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard || j === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards) {
                for (const group of groups)await this.upload(userID, {
                    name: name(group.name),
                    type: (0, $8a132888bcd1c418$export$e57062a38354425e).GeneratedKneeboard,
                    manifestID: manifestID,
                    jobType: j,
                    jobData: JSON.stringify({
                        groupName: group.name
                    }),
                    displayName: displayName(group.name),
                    jobSettings: jobSettings
                });
                continue;
            }
            if (j === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard) {
                const s = settings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig];
                const jobData = JSON.stringify(s);
                await this.upload(userID, {
                    name: name(),
                    type: (0, $8a132888bcd1c418$export$e57062a38354425e).GeneratedKneeboard,
                    manifestID: manifestID,
                    jobType: j,
                    jobData: jobData,
                    displayName: displayName(),
                    jobSettings: null
                });
                continue;
            }
            const newAsset = {
                name: name(),
                type: (0, $8a132888bcd1c418$export$e57062a38354425e).GeneratedKneeboard,
                manifestID: manifestID,
                jobType: j,
                displayName: displayName(),
                jobSettings: jobSettings
            };
            await this.upload(userID, newAsset);
        }
    }
}
function $6992b055e10e3f03$export$2b7de4888b447519(fetch, db) {
    const m = new $6992b055e10e3f03$var$manager(fetch);
    m.db = db;
    return m;
}


const $3acbdcaf0de87f6a$var$cloudfrontDomain = "https://d1lw12zfwta4ws.cloudfront.net";
function $3acbdcaf0de87f6a$var$bundleURL(manifestID, hash) {
    return `${$3acbdcaf0de87f6a$var$cloudfrontDomain}/bundles/${manifestID}/${hash}.json`;
}
class $3acbdcaf0de87f6a$export$45c3e80f98926acf {
    constructor(f){
        if (typeof window !== "undefined") this.fetch = f.bind(window);
        else this.fetch = f;
    }
    async hash(str) {
        const encoder = new TextEncoder();
        const buf = encoder.encode(str);
        const bytes = await crypto.subtle.digest("SHA-1", buf);
        const hashArray = Array.from(new Uint8Array(bytes));
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
        return hashHex;
    }
    async get(manifest) {
        if (!manifest?.bundleAddress) return Promise.resolve(null);
        let res;
        try {
            res = await this.fetch(manifest.bundleAddress);
        } catch (e) {
            return Promise.resolve(null);
        }
        if (res) return res.text();
        return Promise.resolve(null);
    }
    async upsert(manifestID, ts) {
        if (!manifestID) throw new Error("Manifest ID is required");
        const serialized = JSON.stringify(ts);
        const contentHash = await this.hash(serialized);
        const { uploadURL: uploadURL } = await this.fetch("/.netlify/functions/bundle_upload_url", {
            method: "POST",
            body: JSON.stringify({
                manifestID: manifestID,
                contentHash: contentHash
            })
        }).then((res)=>{
            if (!res.ok) throw new Error(`Failed to get upload URL: ${res.statusText}`);
            return res.json();
        });
        try {
            await this.fetch(uploadURL, {
                method: "PUT",
                body: serialized,
                headers: {
                    "Content-Type": "application/json"
                }
            });
        } catch (e) {
            console.error(e);
            throw new Error(`Failed to upload bundle: ${e}`);
        }
        const addr = $3acbdcaf0de87f6a$var$bundleURL(manifestID, contentHash);
        const u = new URL(addr);
        return u;
    }
    delete() {
        throw new Error("Method not implemented.");
    }
}




var $f1q41 = parcelRequire("f1q41");

/**
 * @module ol/format/GeoJSON
 */ 
/**
 * @module ol/format/JSONFeature
 */ /**
 * @module ol/format/Feature
 */ 

/**
 * @module ol/geom/GeometryCollection
 */ 



/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class $0e4f3959219eede5$var$GeometryCollection extends (0, $50db89a00eb954f6$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, $d5bf8abd656a3cdc$export$b0a21c8b3c1c921));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, $d5bf8abd656a3cdc$export$63174c828edd6ff8)(geometries[i], (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */ clone() {
        const geometryCollection = new $0e4f3959219eede5$var$GeometryCollection($0e4f3959219eede5$var$cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $6da4c8ed3074c92b$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        (0, $6da4c8ed3074c92b$export$3e2152b047719fa1)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, $6da4c8ed3074c92b$export$8b58be045bf06082)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return $0e4f3959219eede5$var$cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new $0e4f3959219eede5$var$GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "GeometryCollection";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, $6da4c8ed3074c92b$export$c91255cadecfe081)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray($0e4f3959219eede5$var$cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $0e4f3959219eede5$var$cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
var $0e4f3959219eede5$export$2e2bcd8739ae039 = $0e4f3959219eede5$var$GeometryCollection;





/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {import('../Feature.js').FeatureLike} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @abstract
 * @api
 */ class $ec084d0ff9c13a22$var$FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {FeatureToFeatureClass<FeatureType>}
     */ this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */ (0, $9fd014ab6df63665$export$2e2bcd8739ae039);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === "tile-pixels") {
                dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeature(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */ readFeatures(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
}
var $ec084d0ff9c13a22$export$2e2bcd8739ae039 = $ec084d0ff9c13a22$var$FeatureFormat;
function $ec084d0ff9c13a22$export$7beeea566b560d4(geometry, write, options) {
    const featureProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === "tile-pixels") transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, $9c4744460e43e41b$export$fce0c6cfca85ed96)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $ec084d0ff9c13a22$export$d3e9e4b1c7f2405c(extent, options) {
    const featureProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $9c4744460e43e41b$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $9c4744460e43e41b$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    return extent;
}
const $ec084d0ff9c13a22$var$GeometryConstructor = {
    Point: (0, $6eced4c969949f6b$export$2e2bcd8739ae039),
    LineString: (0, $292e4002746c8223$export$2e2bcd8739ae039),
    Polygon: (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039),
    MultiPoint: (0, $e6080c63a9451eda$export$2e2bcd8739ae039),
    MultiLineString: (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039),
    MultiPolygon: (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)
};
function $ec084d0ff9c13a22$var$orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, $7892dc06ffd23218$export$a1d138f4bd85f4b4)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, $7892dc06ffd23218$export$ea9ed55fc2a85010)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, $7892dc06ffd23218$export$f27cd06e85f4ba28)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, $7892dc06ffd23218$export$b71b604ddfc778c7)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function $ec084d0ff9c13a22$export$f935e77582b330a(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>$ec084d0ff9c13a22$export$f935e77582b330a({
            ...object,
            geometry: geometry
        })).flat();
    const geometryType = geometry.type === "MultiPolygon" ? "Polygon" : geometry.type;
    if (geometryType === "GeometryCollection" || geometryType === "Circle") throw new Error("Unsupported geometry type: " + geometryType);
    const stride = geometry.layout.length;
    return $ec084d0ff9c13a22$export$7beeea566b560d4(new (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)(geometryType, geometryType === "Polygon" ? $ec084d0ff9c13a22$var$orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function $ec084d0ff9c13a22$export$322c9678d8c47bf(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>$ec084d0ff9c13a22$export$322c9678d8c47bf(geometry, options));
        return new (0, $0e4f3959219eede5$export$2e2bcd8739ae039)(geometries);
    }
    const Geometry = $ec084d0ff9c13a22$var$GeometryConstructor[object.type];
    return $ec084d0ff9c13a22$export$7beeea566b560d4(new Geometry(object.flatCoordinates, object.layout, object.ends), false, options);
}



/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {FeatureFormat<FeatureType>}
 * @abstract
 */ class $2f9f6f6b6e1ba437$var$JSONFeature extends (0, $ec084d0ff9c13a22$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return "json";
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromObject($2f9f6f6b6e1ba437$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromObject($2f9f6f6b6e1ba437$var$getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, $6c5e11070e371322$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $2f9f6f6b6e1ba437$var$getObject(source) {
    if (typeof source === "string") {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
var $2f9f6f6b6e1ba437$export$2e2bcd8739ae039 = $2f9f6f6b6e1ba437$var$JSONFeature;








/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {JSONFeature<FeatureType>}
 * @api
 */ class $f602cef51a2e6950$var$GeoJSON extends (0, $2f9f6f6b6e1ba437$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : "EPSG:4326");
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            "application/geo+json",
            "application/vnd.geo+json"
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object["type"] === "Feature") geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            "type": "Feature",
            "geometry": /** @type {GeoJSONGeometry} */ object,
            "properties": null
        };
        const geometry = $f602cef51a2e6950$var$readGeometryInternal(geoJSONFeature["geometry"], options);
        if (this.featureClass === (0, $36d6c36c1f9ad5d9$export$2e2bcd8739ae039)) return /** @type {FeatureType|Array<FeatureType>} */ (0, $ec084d0ff9c13a22$export$f935e77582b330a)({
            geometry: geometry,
            id: geoJSONFeature["id"],
            properties: geoJSONFeature["properties"]
        }, options);
        const feature = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature["geometry_name"]) feature.setGeometryName(geoJSONFeature["geometry_name"]);
        feature.setGeometry((0, $ec084d0ff9c13a22$export$322c9678d8c47bf)(geometry, options));
        if ("id" in geoJSONFeature) feature.setId(geoJSONFeature["id"]);
        if (geoJSONFeature["properties"]) feature.setProperties(geoJSONFeature["properties"], true);
        return /** @type {FeatureType|Array<FeatureType>} */ feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        let features = null;
        if (geoJSONObject["type"] === "FeatureCollection") {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection["features"];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return /** @type {Array<FeatureType>} */ features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromObject(object, options) {
        return $f602cef51a2e6950$var$readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */ readProjectionFromObject(object) {
        const crs = object["crs"];
        let projection;
        if (crs) {
            if (crs["type"] == "name") projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)(crs["properties"]["name"]);
            else if (crs["type"] === "EPSG") projection = (0, $9c4744460e43e41b$export$3988ae62b71be9a3)("EPSG:" + crs["properties"]["code"]);
            else throw new Error("Unknown SRS type");
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            "type": "Feature",
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $f602cef51a2e6950$var$writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $beaefe87199bb537$export$dd1bc94b04021eeb)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: "FeatureCollection",
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */ writeGeometryObject(geometry, options) {
        return $f602cef51a2e6950$var$writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function $f602cef51a2e6950$var$readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object["type"]){
        case "Point":
            geometry = $f602cef51a2e6950$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case "LineString":
            geometry = $f602cef51a2e6950$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case "Polygon":
            geometry = $f602cef51a2e6950$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case "MultiPoint":
            geometry = $f602cef51a2e6950$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case "MultiLineString":
            geometry = $f602cef51a2e6950$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case "MultiPolygon":
            geometry = $f602cef51a2e6950$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case "GeometryCollection":
            geometry = $f602cef51a2e6950$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error("Unsupported GeoJSON type: " + object["type"]);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $f602cef51a2e6950$var$readGeometry(object, options) {
    const geometryObject = $f602cef51a2e6950$var$readGeometryInternal(object, options);
    return (0, $ec084d0ff9c13a22$export$322c9678d8c47bf)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function $f602cef51a2e6950$var$readGeometryCollectionGeometry(object, options) {
    const geometries = object["geometries"].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return $f602cef51a2e6950$var$readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function $f602cef51a2e6950$var$readPointGeometry(object) {
    const flatCoordinates = object["coordinates"];
    return {
        type: "Point",
        flatCoordinates: flatCoordinates,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function $f602cef51a2e6950$var$readLineStringGeometry(object) {
    const coordinates = object["coordinates"];
    const flatCoordinates = coordinates.flat();
    return {
        type: "LineString",
        flatCoordinates: flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function $f602cef51a2e6950$var$readMultiLineStringGeometry(object) {
    const coordinates = object["coordinates"];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: "MultiLineString",
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function $f602cef51a2e6950$var$readMultiPointGeometry(object) {
    const coordinates = object["coordinates"];
    return {
        type: "MultiPoint",
        flatCoordinates: coordinates.flat(),
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function $f602cef51a2e6950$var$readMultiPolygonGeometry(object) {
    const coordinates = object["coordinates"];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, $6b086aa46281540d$export$f9f2bb59da4accd3)(flatCoordinates, 0, coordinates, stride);
    return {
        type: "MultiPolygon",
        flatCoordinates: flatCoordinates,
        ends: endss,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function $f602cef51a2e6950$var$readPolygonGeometry(object) {
    const coordinates = object["coordinates"];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, $6b086aa46281540d$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: "Polygon",
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $c76e993e57efc8c4$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeGeometry(geometry, options) {
    geometry = (0, $ec084d0ff9c13a22$export$7beeea566b560d4)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case "Point":
            geoJSON = $f602cef51a2e6950$var$writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case "LineString":
            geoJSON = $f602cef51a2e6950$var$writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case "Polygon":
            geoJSON = $f602cef51a2e6950$var$writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case "MultiPoint":
            geoJSON = $f602cef51a2e6950$var$writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case "MultiLineString":
            geoJSON = $f602cef51a2e6950$var$writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case "MultiPolygon":
            geoJSON = $f602cef51a2e6950$var$writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case "GeometryCollection":
            geoJSON = $f602cef51a2e6950$var$writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case "Circle":
            geoJSON = {
                type: "GeometryCollection",
                geometries: []
            };
            break;
        default:
            throw new Error("Unsupported geometry type: " + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $f602cef51a2e6950$var$writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return $f602cef51a2e6950$var$writeGeometry(geometry, options);
    });
    return {
        type: "GeometryCollection",
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeLineStringGeometry(geometry, options) {
    return {
        type: "LineString",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiLineStringGeometry(geometry, options) {
    return {
        type: "MultiLineString",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiPointGeometry(geometry, options) {
    return {
        type: "MultiPoint",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: "MultiPolygon",
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writePointGeometry(geometry, options) {
    return {
        type: "Point",
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $f602cef51a2e6950$var$writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: "Polygon",
        coordinates: geometry.getCoordinates(right)
    };
}
var $f602cef51a2e6950$export$2e2bcd8739ae039 = $f602cef51a2e6950$var$GeoJSON;


/**
 * @module ol/geom/Circle
 */ 



/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $f6170f1a08d72585$var$Circle extends (0, $c76e993e57efc8c4$export$2e2bcd8739ae039) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   * @override
   */ clone() {
        const circle = new $f6170f1a08d72585$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $6da4c8ed3074c92b$export$958e3e1a02eac4b6)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return "Circle";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $6da4c8ed3074c92b$export$7b0a31e10bbff018)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $6da4c8ed3074c92b$export$f9ed8a3d123a08e2)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $6b086aa46281540d$export$60815ead40ec79ab)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    /**
   * @override
   */ getCoordinates() {
        return null;
    }
    /**
   * @override
   */ setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $14c6e714516e527b$export$bb628a54ab399bc9)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $f6170f1a08d72585$var$Circle.prototype.transform;
var $f6170f1a08d72585$export$2e2bcd8739ae039 = $f6170f1a08d72585$var$Circle;



const $023ddb6726cc13b3$var$ControlMeasureCollection = "ControlMeasures";
class $023ddb6726cc13b3$export$7086111a3bcda9b5 {
    constructor(db){
        this.db = db;
    }
    async list(manifestID) {
        const ref = (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $023ddb6726cc13b3$var$ControlMeasureCollection);
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(ref, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("manifestID", "==", manifestID), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("name"));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const d = await (0, $83e023b4e8d0ddda$export$257224358692d0e0)(querySnapshot);
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(d, $023ddb6726cc13b3$export$119a3baa27ea67de);
    }
    async save(userID, cm) {
        const g = new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)();
        const t = (0, $63618293c58b5f80$exports.DateTime).now().toSeconds();
        let geometry;
        if (cm.geometry.getType() === "Circle") {
            const circle = cm.geometry;
            geometry = $023ddb6726cc13b3$var$convertCircleToJSON(circle);
        } else geometry = g.writeGeometry(cm.geometry);
        const next = {
            ...cm,
            geometry: geometry,
            updated_at_timestamp: t,
            created_at_timestamp: t,
            created_by_uid: userID
        };
        await (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $023ddb6726cc13b3$var$ControlMeasureCollection), next);
    }
    async delete(userID, cm) {
        await (0, $70fd6868680e912c$export$a4f20481fae8f78b)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $023ddb6726cc13b3$var$ControlMeasureCollection, cm.id));
    }
    async update(userID, cm) {
        const t = (0, $63618293c58b5f80$exports.DateTime).now().toSeconds();
        const g = new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)();
        let geometry;
        if (cm.geometry.getType() === "Circle") {
            const circle = cm.geometry;
            geometry = $023ddb6726cc13b3$var$convertCircleToJSON(circle);
        } else geometry = g.writeGeometry(cm.geometry);
        let next = {
            ...cm,
            geometry: geometry,
            updated_at_timestamp: t,
            updated_by_uid: userID
        };
        next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).omit(next, [
            "originalGeometry"
        ]);
        const ref = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $023ddb6726cc13b3$var$ControlMeasureCollection, cm.id);
        await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(ref, next);
    }
}
function $023ddb6726cc13b3$var$convertCircleToJSON(circle) {
    const g = new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)();
    const r = circle.getRadius();
    const point = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(circle.getCenter());
    point.set("radius", r);
    point.set("type", "Circle");
    const geom = g.writeGeometry(point);
    // Convert to JSON, set some extra properties,
    // and then write back to the geometry field.
    const j = JSON.parse(geom);
    j.radius = r;
    j.type = "Circle";
    return JSON.stringify(j);
}
function $023ddb6726cc13b3$export$119a3baa27ea67de(cm) {
    // @ts-ignore
    const f = JSON.parse(cm.geometry);
    if (f.type === "Circle") {
        // GeoJSON doesn't support circles, so we have to do this.
        const c = new (0, $f6170f1a08d72585$export$2e2bcd8739ae039)(f.coordinates, f.radius);
        return {
            ...cm,
            geometry: c
        };
    }
    const g = new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)();
    return {
        ...cm,
        geometry: g.readGeometry(f)
    };
}


const $65393fe344922b74$var$GUILD_PATH = "/.netlify/functions/discord_guilds";
const $65393fe344922b74$var$MEMBERS_PATH = "/.netlify/functions/discord_guild_members";
const $65393fe344922b74$var$MEMBERS_SEARCH_PATH = "/.netlify/functions/discord_guild_members_search";
const $65393fe344922b74$var$BOT_CHECK_PATH = "/.netlify/functions/discord_bot_check";
const $65393fe344922b74$var$ROLES_PATH = "/.netlify/functions/discord_guild_roles";
const $65393fe344922b74$var$USER_ROLES_PATH = "/.netlify/functions/discord_user_roles";
class $65393fe344922b74$var$discord {
    constructor(f){
        this.fetch = f.bind(window);
    }
    req(path, params) {
        return this.fetch(path, params).then((res)=>{
            if (!res.ok) throw new Error(res.statusText);
            return res.json();
        });
    }
    listGuilds() {
        return this.req($65393fe344922b74$var$GUILD_PATH);
    }
    listMembers(guildID) {
        return this.req($65393fe344922b74$var$MEMBERS_PATH, {
            method: "POST",
            body: JSON.stringify({
                guildID: guildID
            })
        });
    }
    searchMembers(guildID, query) {
        return this.req($65393fe344922b74$var$MEMBERS_SEARCH_PATH, {
            method: "POST",
            body: JSON.stringify({
                guildID: guildID,
                query: query
            })
        });
    }
    async checkBotStatus(guildID) {
        try {
            await this.req($65393fe344922b74$var$BOT_CHECK_PATH, {
                method: "POST",
                body: JSON.stringify({
                    guildID: guildID
                })
            });
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    }
    async listGuildRoles(guildID) {
        return this.req($65393fe344922b74$var$ROLES_PATH, {
            method: "POST",
            body: JSON.stringify({
                guildID: guildID
            })
        });
    }
    async getGuildMemberForUser(guildID) {
        return this.req($65393fe344922b74$var$USER_ROLES_PATH, {
            method: "POST",
            body: JSON.stringify({
                guildID: guildID
            })
        });
    }
}
function $65393fe344922b74$export$40e2ba5c7bbe50c4(f = window.fetch) {
    const d = new $65393fe344922b74$var$discord(f);
    return d;
}
class $65393fe344922b74$var$discordServerClient {
    constructor(f){
        this.fetch = f.bind(this);
    }
    async getGuildMemberForUser(guildID, token) {
        const guildMemberResult = await this.fetch(`https://discord.com/api/users/@me/guilds/${guildID}/member`, {
            headers: {
                authorization: `Bearer ${token}`
            }
        });
        const memberData = await guildMemberResult.json();
        if (memberData.code) throw new Error(memberData.message);
        return memberData;
    }
}
function $65393fe344922b74$export$599ddf10ae36f039(f) {
    const d = new $65393fe344922b74$var$discordServerClient(f);
    return d;
}





const $96428ae11b0a5fbb$var$ExternalDataRecordsCollection = "ExternalDataRecords";
class $96428ae11b0a5fbb$export$7f21f80a8d38e0d5 {
    constructor(db, fo){
        this.db = db;
        this.fo = fo;
    }
    async list(fragOrderID, coalition) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $96428ae11b0a5fbb$var$ExternalDataRecordsCollection), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("fragOrderID", "==", fragOrderID), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("coalition", "==", coalition));
        const qs = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        return (0, $83e023b4e8d0ddda$export$257224358692d0e0)(qs);
    }
    async get(id) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $96428ae11b0a5fbb$var$ExternalDataRecordsCollection, id);
        const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        return {
            ...docSnap.data(),
            id: id
        };
    }
    async getByType(fragOrderID, type) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $96428ae11b0a5fbb$var$ExternalDataRecordsCollection), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("fragOrderID", "==", fragOrderID), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("type", "==", type));
        return (await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q)).docs;
    }
    async delete(userID, record) {
        const existing = await this.getByType(record.fragOrderID, record.type);
        if (existing.length === 1) await this.fo.removeJob(userID, record.fragOrderID, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyExternalData);
        return await (0, $70fd6868680e912c$export$a4f20481fae8f78b)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $96428ae11b0a5fbb$var$ExternalDataRecordsCollection, record.id));
    }
    async upsert(userID, record) {
        const t = new Date().getTime();
        const existing = await this.getByType(record.fragOrderID, record.type);
        if (existing.length > 0) {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $96428ae11b0a5fbb$var$ExternalDataRecordsCollection, existing[0].id);
            return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(docRef, {
                ...record,
                created_by_uid: userID,
                updated_at_timestamp: t
            });
        }
        await this.fo.addJob(userID, record.fragOrderID, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyExternalData, null);
        const colRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $96428ae11b0a5fbb$var$ExternalDataRecordsCollection);
        return (0, $70fd6868680e912c$export$a13890143fb1c2dd)(colRef, {
            ...record,
            created_by_uid: userID,
            created_at_timestamp: t,
            updated_at_timestamp: t
        });
    }
}





class $4e742bcc5d262bd2$var$S3 {
    constructor(f){
        this.fetch = f.bind(window);
    }
    async save(docID, file) {
        const { uploadURL: uploadURL } = await fetch("/.netlify/functions/miz_upload_url", {
            method: "POST",
            body: JSON.stringify({
                docID: docID
            })
        }).then((res)=>res.json());
        return this.fetch(uploadURL, {
            method: "PUT",
            // @ts-ignore
            body: file
        });
    }
    async download(docID) {
        const { downloadURL: downloadURL } = await fetch("/.netlify/functions/miz_download_url", {
            method: "POST",
            body: JSON.stringify({
                docID: docID
            })
        }).then((res)=>res.json());
        const zip = await fetch(downloadURL, {
            headers: {
                "content-type": "application/zip"
            }
        }).then((res)=>res.blob());
        return await (0, (/*@__PURE__*/$parcel$interopDefault($950bc911f3ee385b$exports))).loadAsync(zip);
    }
}
function $4e742bcc5d262bd2$export$8d22906962e7fb92(f) {
    return new $4e742bcc5d262bd2$var$S3(f);
}




var $f1q41 = parcelRequire("f1q41");


const $c0b77a82ffc4d539$export$3fe666fca230c13f = "Plans";
class $c0b77a82ffc4d539$var$manager {
    async listPlans(fragOrderID) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $c0b77a82ffc4d539$export$3fe666fca230c13f), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("fragOrderID", "==", fragOrderID));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        return (0, $83e023b4e8d0ddda$export$257224358692d0e0)(querySnapshot);
    }
    async getPlanForGroup(fragOrderID, groupName, userID) {
        const plans = await this.listPlans(fragOrderID);
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(plans, {
            groupName: groupName,
            // status: PlanStatus.Submitted,
            created_by_uid: userID
        });
    }
    async upsertPlan(opts, waypoints, ovr, plannerNotes, laserConfig, navPoints) {
        const t = new Date().getTime();
        const existing = await this.getPlanForGroup(opts.fragOrderID, opts.groupName, opts.user.id);
        const nextDoc = existing ? {
            ...existing,
            updated_at_timestamp: t
        } : {
            id: null,
            coalition: opts.coalition,
            groupCategory: opts.category,
            groupName: opts.groupName,
            fragOrderID: opts.fragOrderID,
            created_by_uid: opts.user.id,
            created_at_timestamp: t,
            submitterDisplayText: opts.user.username,
            moduleName: opts.moduleName
        };
        nextDoc.updated_at_timestamp = t;
        nextDoc.status = (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted;
        if (ovr) nextDoc.radioOverrides = JSON.stringify(ovr);
        if (waypoints) nextDoc.waypoints = waypoints;
        if (laserConfig) nextDoc.laserConfig = laserConfig;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isUndefined(plannerNotes)) nextDoc.plannerNotes = plannerNotes;
        if (navPoints) nextDoc.navPoints = navPoints;
        if (existing) {
            await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $c0b77a82ffc4d539$export$3fe666fca230c13f, existing.id), nextDoc);
            return nextDoc;
        }
        const docref = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $c0b77a82ffc4d539$export$3fe666fca230c13f), nextDoc);
        return {
            ...nextDoc,
            id: docref.id
        };
    }
    async invalidatePlan(fragOrderID, plan) {
        const next = {
            ...plan,
            updated_at_timestamp: new Date().getTime(),
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Invalid
        };
        return this.fetcher.req("/.netlify/functions/admin_update_plan", {
            method: "POST",
            body: JSON.stringify({
                fragOrderID: fragOrderID,
                plan: next
            })
        });
    }
    async removePlan(fragOrderID, plan) {
        const next = {
            ...plan,
            updated_at_timestamp: new Date().getTime(),
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Deleted
        };
        return this.fetcher.req("/.netlify/functions/admin_update_plan", {
            method: "POST",
            body: JSON.stringify({
                fragOrderID: fragOrderID,
                plan: next
            })
        });
    }
}
function $c0b77a82ffc4d539$export$544da8ef3568537b(db, fetcher) {
    const mgr = new $c0b77a82ffc4d539$var$manager();
    mgr.db = db;
    mgr.fetcher = fetcher;
    return mgr;
}




const $504968b933aff167$export$dd51212b98dd8675 = "PlanItems";
class $504968b933aff167$export$2e2bcd8739ae039 {
    constructor(db, qc){
        this.db = db;
        this.qc = qc;
    }
    async list(manifestID, type, group) {
        const args = [
            (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $504968b933aff167$export$dd51212b98dd8675),
            (0, $70fd6868680e912c$export$9c59b80dda569a6e)("manifestID", "==", manifestID)
        ];
        if (type) args.push((0, $70fd6868680e912c$export$9c59b80dda569a6e)("type", "==", type));
        if (group) args.push((0, $70fd6868680e912c$export$9c59b80dda569a6e)("group", "==", group));
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4).call(this, ...args);
        return (0, $83e023b4e8d0ddda$export$257224358692d0e0)(await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q));
    }
    async get(manifestID, type, group, uniqID) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $504968b933aff167$export$dd51212b98dd8675), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("manifestID", "==", manifestID), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("group", "==", group), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("type", "==", type), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uniqID", "==", uniqID));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const items = (0, $83e023b4e8d0ddda$export$257224358692d0e0)(querySnapshot);
        if (items.length === 0) throw new Error("PlanItem not found");
        return items[0];
    }
    async add(user, item) {
        $504968b933aff167$var$validate(item);
        const t = new Date().getTime();
        const itemDoc = {
            ...item,
            created_at_timestamp: t,
            updated_at_timestamp: t,
            created_by_uid: user.id,
            createdByUserName: user.username,
            uniqID: item.uniqID
        };
        return (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $504968b933aff167$export$dd51212b98dd8675), itemDoc);
    }
    async update(item) {
        $504968b933aff167$var$validate(item);
        const t = new Date().getTime();
        item.updated_at_timestamp = t;
        const ref = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $504968b933aff167$export$dd51212b98dd8675, item.id);
        return await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(ref, item);
    }
    async remove(item) {
        const ref = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $504968b933aff167$export$dd51212b98dd8675, item.id);
        return (0, $70fd6868680e912c$export$a4f20481fae8f78b)(ref);
    }
}
const $504968b933aff167$var$validate = (item)=>{
    if (!item.manifestID) throw new Error("manifestID is required");
    if (!item.group) throw new Error("group is required");
    if (!item.type) throw new Error("type is required");
};



var $f1q41 = parcelRequire("f1q41");


class $96e88338c4df101c$export$2e2bcd8739ae039 extends (0, $504968b933aff167$export$2e2bcd8739ae039) {
    async listNavPoints(manifestID, group) {
        const items = await this.list(manifestID);
        const navPoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(items, {
            group: group,
            type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).NavPoint
        });
        const result = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(navPoints, (w)=>JSON.parse(w.payload));
        return result;
    }
    async upsertNavPoint(manifestID, user, group, navPoint) {
        $96e88338c4df101c$var$validateNavPoint(navPoint);
        try {
            const item = await this.get(manifestID, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).NavPoint, group, navPoint.index.toString());
            return this.update({
                ...item,
                payload: JSON.stringify(navPoint)
            });
        } catch (e) {
            return this.add(user, {
                group: group,
                manifestID: manifestID,
                type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).NavPoint,
                uniqID: navPoint.index.toString(),
                payload: JSON.stringify(navPoint),
                createdByUserName: user.username
            });
        }
    }
    async deleteNavPoint(manifestID, group, navPointIndex) {
        const existing = await this.get(manifestID, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).NavPoint, group, navPointIndex.toString());
        if (!existing) return;
        return this.remove(existing);
    }
}
function $96e88338c4df101c$var$validateNavPoint(navPoint) {
    if (!navPoint.textComment) throw new Error("NavPoint must have textComment");
    if (!navPoint.index) throw new Error("NavPoint must have index");
    if (!navPoint.x) throw new Error("NavPoint must have x");
    if (!navPoint.y) throw new Error("NavPoint must have y");
}



var $f1q41 = parcelRequire("f1q41");


class $02e6513a95c7c4f6$export$2e2bcd8739ae039 extends (0, $504968b933aff167$export$2e2bcd8739ae039) {
    async listWaypoints(manifestID, group) {
        const items = await this.list(manifestID);
        const waypoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(items, {
            group: group,
            type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint
        });
        const result = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(waypoints, (w)=>JSON.parse(w.payload));
        return result;
    }
    async getWaypoint(manifestID, group, waypointIndex) {
        const item = await this.get(manifestID, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint, group, waypointIndex.toString());
        if (!item) throw new Error("Waypoint not found");
        return JSON.parse(item.payload);
    }
    async upsertWaypoint(manifestID, user, group, waypoint) {
        let existing;
        try {
            existing = await this.get(manifestID, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint, group, waypoint.number.toString());
        } catch (e) {
            existing = null;
        }
        if (existing) return this.updateWaypoint(existing, group, waypoint);
        else return this.addWaypoint(manifestID, user, group, waypoint);
    }
    async addWaypoint(manifestID, user, group, waypoint) {
        const item = {
            group: group,
            type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint,
            manifestID: manifestID,
            uniqID: waypoint.number.toString(),
            payload: JSON.stringify(waypoint)
        };
        return this.add(user, item);
    }
    async updateWaypoint(existing, group, waypoint) {
        const item = {
            ...existing,
            payload: JSON.stringify(waypoint)
        };
        return this.update(item);
    }
    async removeWaypoint(manifestID, group, number) {
        const existing = await this.get(manifestID, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint, group, number.toString());
        // Renumber the rest of the waypoints
        const waypoints = await this.listWaypoints(manifestID, group);
        const toUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(waypoints, (w)=>w.number > number);
        for (const w of toUpdate){
            let item;
            try {
                item = await this.get(manifestID, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint, group, w.number.toString());
            } catch (e) {
                continue;
            }
            item.payload = JSON.stringify({
                ...JSON.parse(item.payload),
                number: w.number - 1
            });
            item.uniqID = (w.number - 1).toString();
            await this.update(item);
        }
        return this.remove(existing);
    }
}





const $b162211719c94af8$var$ADD_SIGNUP_PATH = "/.netlify/functions/add_signup";
const $b162211719c94af8$var$REMOVE_SIGNUP_PATH = "/.netlify/functions/remove_signup";
const $b162211719c94af8$export$1d6d710ae64ed5c4 = "SignupRecords";
class $b162211719c94af8$export$9aa66a1a3d88e97b {
    constructor(fetch, db){
        this.fetcher = fetch;
        this.db = db;
    }
    async signup(manifestID, record, discordNickname) {
        return this.fetcher.req($b162211719c94af8$var$ADD_SIGNUP_PATH, {
            method: "POST",
            body: JSON.stringify({
                manifestID: manifestID,
                record: record,
                discordNickname: discordNickname
            })
        });
    }
    async list(manifestID) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $b162211719c94af8$export$1d6d710ae64ed5c4), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("manifestID", "==", manifestID));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        return (0, $83e023b4e8d0ddda$export$257224358692d0e0)(querySnapshot);
    }
    async remove(signupID) {
        return this.fetcher.req($b162211719c94af8$var$REMOVE_SIGNUP_PATH, {
            method: "POST",
            body: JSON.stringify({
                signupID: signupID
            })
        });
    }
}





var $f1q41 = parcelRequire("f1q41");

const $40d859d8b2b40f24$var$UserPreferenceCollection = "UserPreferences";
class $40d859d8b2b40f24$export$9ce7d5e09dbc1d92 {
    constructor(db){
        this.db = db;
    }
    async list(userID) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $40d859d8b2b40f24$var$UserPreferenceCollection), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("created_by_uid", "==", userID));
        const snap = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const data = await (0, $83e023b4e8d0ddda$export$257224358692d0e0)(snap);
        return data;
    }
    async upsert(userID, preference) {
        const t = new Date().getTime();
        const newDoc = {
            ...preference,
            created_by_uid: userID,
            updated_at_timestamp: t
        };
        const rows = await this.list(userID);
        const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(rows, {
            name: preference.name
        });
        if (!existing) {
            newDoc.created_at_timestamp = t;
            return (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.db, $40d859d8b2b40f24$var$UserPreferenceCollection), newDoc);
        }
        const updated = {
            ...existing,
            ...preference,
            updated_at_timestamp: t
        };
        return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)((0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $40d859d8b2b40f24$var$UserPreferenceCollection, existing.id), updated);
    }
    async remove(preference) {
        const ref = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.db, $40d859d8b2b40f24$var$UserPreferenceCollection, preference.id);
        return (0, $70fd6868680e912c$export$a4f20481fae8f78b)(ref);
    }
}



var $ayMG0 = parcelRequire("ayMG0");
var $65822de42ac1fb15$exports = {};

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty($65822de42ac1fb15$exports, "__esModule", {
    value: true
});




/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Global context object for a collection of services using
 * a shared authentication state.
 *
 * marked as internal because it references internal types exported from @firebase/app
 * @internal
 */ class $62abbf54969a34e0$var$FirebaseAppImpl {
    constructor(_delegate, firebase){
        this._delegate = _delegate;
        this.firebase = firebase;
        // add itself to container
        (0, $57d436074e210fb5$export$fa5244b94c62d36a)(_delegate, new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("app-compat", ()=>this, "PUBLIC" /* PUBLIC */ ));
        this.container = _delegate.container;
    }
    get automaticDataCollectionEnabled() {
        return this._delegate.automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this._delegate.automaticDataCollectionEnabled = val;
    }
    get name() {
        return this._delegate.name;
    }
    get options() {
        return this._delegate.options;
    }
    delete() {
        return new Promise((resolve)=>{
            this._delegate.checkDestroyed();
            resolve();
        }).then(()=>{
            this.firebase.INTERNAL.removeApp(this.name);
            return (0, $57d436074e210fb5$export$6eec44aa53d5ea34)(this._delegate);
        });
    }
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */ _getService(name, instanceIdentifier = (0, $57d436074e210fb5$export$9f30fa0c10967f7f)) {
        var _a;
        this._delegate.checkDestroyed();
        // Initialize instance if InstatiationMode is `EXPLICIT`.
        const provider = this._delegate.container.getProvider(name);
        if (!provider.isInitialized() && ((_a = provider.getComponent()) === null || _a === void 0 ? void 0 : _a.instantiationMode) === "EXPLICIT" /* EXPLICIT */ ) provider.initialize();
        // getImmediate will always succeed because _getService is only called for registered components.
        return provider.getImmediate({
            identifier: instanceIdentifier
        });
    }
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get it again.
     *
     * NOTE: currently only firestore uses this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */ _removeServiceInstance(name, instanceIdentifier = (0, $57d436074e210fb5$export$9f30fa0c10967f7f)) {
        this._delegate.container// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .getProvider(name).clearInstance(instanceIdentifier);
    }
    /**
     * @param component the component being added to this app's container
     * @internal
     */ _addComponent(component) {
        (0, $57d436074e210fb5$export$fa5244b94c62d36a)(this._delegate, component);
    }
    _addOrOverwriteComponent(component) {
        (0, $57d436074e210fb5$export$4393112b42e2b41d)(this._delegate, component);
    }
    toJSON() {
        return {
            name: this.name,
            automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
            options: this.options
        };
    }
}
// TODO: investigate why the following needs to be commented out
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
// (FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
//   FirebaseAppImpl.prototype.delete ||
//   console.log('dc');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $62abbf54969a34e0$var$ERRORS = {
    ["no-app" /* NO_APP */ ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
    ["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance."
};
const $62abbf54969a34e0$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)("app-compat", "Firebase", $62abbf54969a34e0$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */ function $62abbf54969a34e0$var$createFirebaseNamespaceCore(firebaseAppImpl) {
    const apps = {};
    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const components = new Map<string, Component<any>>();
    // A namespace is a plain JavaScript Object.
    const namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeAppCompat,
        app: // @ts-ignore
        app,
        registerVersion: $57d436074e210fb5$export$d29d5299a7137abc,
        setLogLevel: $57d436074e210fb5$export$c622e99c0ce7b1c9,
        onLog: $57d436074e210fb5$export$a82ad227dc8163dc,
        // @ts-ignore
        apps: null,
        SDK_VERSION: $57d436074e210fb5$export$31499a9cd224b78c,
        INTERNAL: {
            registerComponent: registerComponentCompat,
            removeApp: removeApp,
            useAsService: useAsService,
            modularAPIs: $57d436074e210fb5$exports
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace["default"] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, "apps", {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */ function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */ function app(name) {
        name = name || $57d436074e210fb5$export$9f30fa0c10967f7f;
        if (!(0, $c38e0f42709c826a$export$2344b14b097df817)(apps, name)) throw $62abbf54969a34e0$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
            appName: name
        });
        return apps[name];
    }
    // @ts-ignore
    app["App"] = firebaseAppImpl;
    /**
     * Create a new App instance (name must be unique).
     *
     * This function is idempotent. It can be called more than once and return the same instance using the same options and config.
     */ function initializeAppCompat(options, rawConfig = {}) {
        const app = $57d436074e210fb5$export$c55cfd413944906d(options, rawConfig);
        if ((0, $c38e0f42709c826a$export$2344b14b097df817)(apps, app.name)) return apps[app.name];
        const appCompat = new firebaseAppImpl(app, namespace);
        apps[app.name] = appCompat;
        return appCompat;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */ function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map((name)=>apps[name]);
    }
    function registerComponentCompat(component) {
        const componentName = component.name;
        const componentNameWithoutCompat = componentName.replace("-compat", "");
        if ($57d436074e210fb5$export$c930050e7bb63965(component) && component.type === "PUBLIC" /* PUBLIC */ ) {
            // create service namespace for public components
            // The Service namespace is an accessor function ...
            const serviceNamespace = (appArg = app())=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentNameWithoutCompat] !== "function") // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw $62abbf54969a34e0$var$ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */ , {
                    appName: componentName
                });
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentNameWithoutCompat]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) (0, $c38e0f42709c826a$export$54e9fb29908872fa)(serviceNamespace, component.serviceProps);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentNameWithoutCompat] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentNameWithoutCompat] = // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function(...args) {
                const serviceFxn = this._getService.bind(this, componentName);
                return serviceFxn.apply(this, component.multipleInstances ? args : []);
            };
        }
        return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentNameWithoutCompat] : null;
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === "serverAuth") return null;
        const useService = name;
        return useService;
    }
    return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */ function $62abbf54969a34e0$var$createFirebaseNamespace() {
    const namespace = $62abbf54969a34e0$var$createFirebaseNamespaceCore($62abbf54969a34e0$var$FirebaseAppImpl);
    namespace.INTERNAL = Object.assign(Object.assign({}, namespace.INTERNAL), {
        createFirebaseNamespace: $62abbf54969a34e0$var$createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: $c38e0f42709c826a$export$364097d812234b3f,
        ErrorFactory: $c38e0f42709c826a$export$3fa6e1b18a3b2d40,
        deepExtend: $c38e0f42709c826a$export$54e9fb29908872fa
    });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */ function extendNamespace(props) {
        (0, $c38e0f42709c826a$export$54e9fb29908872fa)(namespace, props);
    }
    return namespace;
}
const $62abbf54969a34e0$var$firebase$1 = $62abbf54969a34e0$var$createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $62abbf54969a34e0$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/app-compat");
const $62abbf54969a34e0$var$name = "@firebase/app-compat";
const $62abbf54969a34e0$var$version = "0.1.27";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $62abbf54969a34e0$var$registerCoreComponents(variant) {
    // Register `app` package.
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($62abbf54969a34e0$var$name, $62abbf54969a34e0$var$version, variant);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Firebase Lite detection
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((0, $c38e0f42709c826a$export$4e09c449d6c407f7)() && self.firebase !== undefined) {
    $62abbf54969a34e0$var$logger.warn(`
    Warning: Firebase is already defined in the global scope. Please make sure
    Firebase library is only loaded once.
  `);
    // eslint-disable-next-line
    const sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf("LITE") >= 0) $62abbf54969a34e0$var$logger.warn(`
    Warning: You are trying to load Firebase while using Firebase Performance standalone script.
    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.
    `);
}
const $62abbf54969a34e0$export$2e2bcd8739ae039 = $62abbf54969a34e0$var$firebase$1;
$62abbf54969a34e0$var$registerCoreComponents();








var $hPtJY = parcelRequire("hPtJY");
const $da38ac6aa733c404$var$name = "@firebase/database";
const $da38ac6aa733c404$var$version = "0.13.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $da38ac6aa733c404$var$SDK_VERSION = "";
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $da38ac6aa733c404$export$c9fb972242fcb3c4(version) {
    $da38ac6aa733c404$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $da38ac6aa733c404$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = "firebase:";
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $c38e0f42709c826a$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $da38ac6aa733c404$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $c38e0f42709c826a$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $da38ac6aa733c404$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== "undefined" && typeof window[domStorageName] !== "undefined") {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem("firebase:sentinel", "cache");
            domStorage.removeItem("firebase:sentinel");
            return new $da38ac6aa733c404$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $da38ac6aa733c404$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $da38ac6aa733c404$var$PersistentStorage = $da38ac6aa733c404$var$createStoragefor("localStorage");
/** A storage object that only lasts one session */ const $da38ac6aa733c404$var$SessionStorage = $da38ac6aa733c404$var$createStoragefor("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/database");
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $da38ac6aa733c404$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $da38ac6aa733c404$var$sha1 = function(str) {
    const utf8Bytes = (0, $c38e0f42709c826a$export$655666783217a925)(str);
    const sha1 = new (0, $c38e0f42709c826a$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $c38e0f42709c826a$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $da38ac6aa733c404$var$buildLogMessage_ = function(...varArgs) {
    let message = "";
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === "number") message += $da38ac6aa733c404$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === "object") message += (0, $c38e0f42709c826a$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += " ";
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $da38ac6aa733c404$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $da38ac6aa733c404$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $da38ac6aa733c404$var$enableLogging$1 = function(logger_, persistent) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $da38ac6aa733c404$var$logClient.logLevel = (0, $45b460d9de9b230f$export$243e62d78d3b544d).VERBOSE;
        $da38ac6aa733c404$var$logger = $da38ac6aa733c404$var$logClient.log.bind($da38ac6aa733c404$var$logClient);
        if (persistent) $da38ac6aa733c404$var$SessionStorage.set("logging_enabled", true);
    } else if (typeof logger_ === "function") $da38ac6aa733c404$var$logger = logger_;
    else {
        $da38ac6aa733c404$var$logger = null;
        $da38ac6aa733c404$var$SessionStorage.remove("logging_enabled");
    }
};
const $da38ac6aa733c404$var$log = function(...varArgs) {
    if ($da38ac6aa733c404$var$firstLog_ === true) {
        $da38ac6aa733c404$var$firstLog_ = false;
        if ($da38ac6aa733c404$var$logger === null && $da38ac6aa733c404$var$SessionStorage.get("logging_enabled") === true) $da38ac6aa733c404$var$enableLogging$1(true);
    }
    if ($da38ac6aa733c404$var$logger) {
        const message = $da38ac6aa733c404$var$buildLogMessage_.apply(null, varArgs);
        $da38ac6aa733c404$var$logger(message);
    }
};
const $da38ac6aa733c404$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $da38ac6aa733c404$var$log(prefix, ...varArgs);
    };
};
const $da38ac6aa733c404$var$error = function(...varArgs) {
    const message = "FIREBASE INTERNAL ERROR: " + $da38ac6aa733c404$var$buildLogMessage_(...varArgs);
    $da38ac6aa733c404$var$logClient.error(message);
};
const $da38ac6aa733c404$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$da38ac6aa733c404$var$buildLogMessage_(...varArgs)}`;
    $da38ac6aa733c404$var$logClient.error(message);
    throw new Error(message);
};
const $da38ac6aa733c404$var$warn = function(...varArgs) {
    const message = "FIREBASE WARNING: " + $da38ac6aa733c404$var$buildLogMessage_(...varArgs);
    $da38ac6aa733c404$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $da38ac6aa733c404$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== "undefined" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1) $da38ac6aa733c404$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $da38ac6aa733c404$var$isInvalidJSONNumber = function(data) {
    return typeof data === "number" && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $da38ac6aa733c404$var$executeWhenDOMReady = function(fn) {
    if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)() || document.readyState === "complete") fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener("DOMContentLoaded", wrappedFn, false);
            // fallback to onload.
            window.addEventListener("load", wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent("onreadystatechange", ()=>{
                if (document.readyState === "complete") wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent("onload", wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $da38ac6aa733c404$var$MIN_NAME = "[MIN_NAME]";
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $da38ac6aa733c404$var$MAX_NAME = "[MAX_NAME]";
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $da38ac6aa733c404$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $da38ac6aa733c404$var$MIN_NAME || b === $da38ac6aa733c404$var$MAX_NAME) return -1;
    else if (b === $da38ac6aa733c404$var$MIN_NAME || a === $da38ac6aa733c404$var$MAX_NAME) return 1;
    else {
        const aAsInt = $da38ac6aa733c404$var$tryParseInt(a), bAsInt = $da38ac6aa733c404$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $da38ac6aa733c404$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $da38ac6aa733c404$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error("Missing required key (" + key + ") in object: " + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(obj));
};
const $da38ac6aa733c404$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== "object" || obj === null) return (0, $c38e0f42709c826a$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = "{";
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ",";
        key += (0, $c38e0f42709c826a$export$fac44ee5b035f737)(keys[i]);
        key += ":";
        key += $da38ac6aa733c404$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += "}";
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $da38ac6aa733c404$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $da38ac6aa733c404$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $da38ac6aa733c404$var$doubleToIEEE754String = function(v) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$isInvalidJSONNumber(v), "Invalid JSON number"); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join("");
    // Return the data as a hex string. --MJL
    let hexByteString = "";
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = "0" + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $da38ac6aa733c404$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === "object" && window["chrome"] && window["chrome"]["extension"] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $da38ac6aa733c404$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === "object" && typeof Windows.UI === "object";
};
/**
 * Converts a server error code to a Javascript Error
 */ function $da38ac6aa733c404$var$errorForServerCode(code, query) {
    let reason = "Unknown Error";
    if (code === "too_big") reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === "permission_denied") reason = "Client doesn't have permission to access the desired data.";
    else if (code === "unavailable") reason = "The service is unavailable";
    const error = new Error(code + " at " + query._path.toString() + ": " + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $da38ac6aa733c404$var$INTEGER_REGEXP_ = new RegExp("^-?(0*)\\d{1,10}$");
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $da38ac6aa733c404$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in kyes, the maximum possible 32-bit integer.
 */ const $da38ac6aa733c404$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $da38ac6aa733c404$var$tryParseInt = function(str) {
    if ($da38ac6aa733c404$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $da38ac6aa733c404$var$INTEGER_32_MIN && intVal <= $da38ac6aa733c404$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $da38ac6aa733c404$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || "";
            $da38ac6aa733c404$var$warn("Exception was thrown by user callback.", stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $da38ac6aa733c404$var$beingCrawled = function() {
    const userAgent = typeof window === "object" && window["navigator"] && window["navigator"]["userAgent"] || "";
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $da38ac6aa733c404$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof timeout === "object" && timeout["unref"]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout["unref"]();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $da38ac6aa733c404$var$AppCheckTokenProvider {
    constructor(appName_, appCheckProvider){
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $da38ac6aa733c404$var$warn(`Provided AppCheck credentials for the app named "${this.appName_}" ` + "are invalid. This usually indicates your app was not initialized correctly.");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $da38ac6aa733c404$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timoeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === "auth/token-not-initialized") {
                $da38ac6aa733c404$var$log("Got auth/token-not-initialized error.  Treating as null token.");
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + "initialized correctly. ";
        if ("credential" in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ("serviceAccount" in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $da38ac6aa733c404$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $da38ac6aa733c404$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $da38ac6aa733c404$var$EmulatorTokenProvider.OWNER = "owner";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$PROTOCOL_VERSION = "5";
const $da38ac6aa733c404$var$VERSION_PARAM = "v";
const $da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM = "s";
const $da38ac6aa733c404$var$REFERER_PARAM = "r";
const $da38ac6aa733c404$var$FORGE_REF = "f";
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $da38ac6aa733c404$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $da38ac6aa733c404$var$LAST_SESSION_PARAM = "ls";
const $da38ac6aa733c404$var$APPLICATION_ID_PARAM = "p";
const $da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM = "ac";
const $da38ac6aa733c404$var$WEBSOCKET = "websocket";
const $da38ac6aa733c404$var$LONG_POLLING = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $da38ac6aa733c404$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = "", includeNamespaceInQueryParams = false){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf(".") + 1);
        this.internalHost = $da38ac6aa733c404$var$PersistentStorage.get("host:" + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === "s-";
    }
    isCustomHost() {
        return this._domain !== "firebaseio.com" && this._domain !== "firebaseio-demo.com";
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $da38ac6aa733c404$var$PersistentStorage.set("host:" + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += "<" + this.persistenceKey + ">";
        return str;
    }
    toURLString() {
        const protocol = this.secure ? "https://" : "http://";
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : "";
        return `${protocol}${this.host}/${query}`;
    }
}
function $da38ac6aa733c404$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof type === "string", "typeof type must == string");
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof params === "object", "typeof params must == object");
    let connURL;
    if (type === $da38ac6aa733c404$var$WEBSOCKET) connURL = (repoInfo.secure ? "wss://" : "ws://") + repoInfo.internalHost + "/.ws?";
    else if (type === $da38ac6aa733c404$var$LONG_POLLING) connURL = (repoInfo.secure ? "https://" : "http://") + repoInfo.internalHost + "/.lp?";
    else throw new Error("Unknown connection type: " + type);
    if ($da38ac6aa733c404$var$repoInfoNeedsQueryParam(repoInfo)) params["ns"] = repoInfo.namespace;
    const pairs = [];
    $da38ac6aa733c404$var$each(params, (key, value)=>{
        pairs.push(key + "=" + value);
    });
    return connURL + pairs.join("&");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $da38ac6aa733c404$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $c38e0f42709c826a$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $c38e0f42709c826a$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$collections = {};
const $da38ac6aa733c404$var$reporters = {};
function $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$da38ac6aa733c404$var$collections[hashString]) $da38ac6aa733c404$var$collections[hashString] = new $da38ac6aa733c404$var$StatsCollection();
    return $da38ac6aa733c404$var$collections[hashString];
}
function $da38ac6aa733c404$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$da38ac6aa733c404$var$reporters[hashString]) $da38ac6aa733c404$var$reporters[hashString] = creatorFunction();
    return $da38ac6aa733c404$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $da38ac6aa733c404$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $da38ac6aa733c404$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM = "start";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = "close";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = "pLPCommand";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_CB_NAME = "pRTLPCB";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM = "id";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM = "pw";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM = "ser";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = "cb";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = "seg";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = "ts";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_PARAM = "d";
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = "dframe";
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $da38ac6aa733c404$var$MAX_URL_DATA_SIZE = 1870;
const $da38ac6aa733c404$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $da38ac6aa733c404$var$MAX_PAYLOAD_SIZE = $da38ac6aa733c404$var$MAX_URL_DATA_SIZE - $da38ac6aa733c404$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $da38ac6aa733c404$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $da38ac6aa733c404$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $da38ac6aa733c404$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $da38ac6aa733c404$var$logWrapper(connId);
        this.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, $da38ac6aa733c404$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $da38ac6aa733c404$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_("Timed out trying to connect.");
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($da38ac6aa733c404$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $da38ac6aa733c404$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $da38ac6aa733c404$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error("Unrecognized command received: " + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM] = "t";
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$da38ac6aa733c404$var$VERSION_PARAM] = $da38ac6aa733c404$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$da38ac6aa733c404$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$da38ac6aa733c404$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== "undefined" && location.hostname && $da38ac6aa733c404$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$da38ac6aa733c404$var$REFERER_PARAM] = $da38ac6aa733c404$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_("Connecting via long-poll to " + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $da38ac6aa733c404$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $da38ac6aa733c404$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) return false;
        else if ($da38ac6aa733c404$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$da38ac6aa733c404$var$BrowserPollConnection.forceDisallow_ && typeof document !== "undefined" && document.createElement != null && !$da38ac6aa733c404$var$isChromeExtensionContentScript() && !$da38ac6aa733c404$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_("Longpoll is closing itself");
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_("Longpoll is being closed.");
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $c38e0f42709c826a$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $da38ac6aa733c404$var$splitStringBySize(base64data, $da38ac6aa733c404$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement("iframe");
        const urlParams = {};
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = "t";
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = "none";
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter("bytes_received", bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $da38ac6aa733c404$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $da38ac6aa733c404$var$LUIDGenerator();
            window[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $da38ac6aa733c404$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = "";
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === "javascript:") {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = "<html><body>" + script + "</body></html>";
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $da38ac6aa733c404$var$log("frame writing exception");
                if (e.stack) $da38ac6aa733c404$var$log(e.stack);
                $da38ac6aa733c404$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $da38ac6aa733c404$var$log("No IE domain setting required");
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = "";
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = "";
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $da38ac6aa733c404$var$SEG_HEADER_SIZE + curDataString.length <= $da38ac6aa733c404$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + "&" + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + "=" + theSeg.seg + "&" + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + "=" + theSeg.ts + "&" + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_PARAM + i + "=" + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($da38ac6aa733c404$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement("script");
                newScript.type = "text/javascript";
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === "loaded" || rstate === "complete") {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $da38ac6aa733c404$var$log("Long-poll script failed to load: " + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $da38ac6aa733c404$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $da38ac6aa733c404$var$WebSocketImpl = null;
if (typeof MozWebSocket !== "undefined") $da38ac6aa733c404$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== "undefined") $da38ac6aa733c404$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $da38ac6aa733c404$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $da38ac6aa733c404$var$logWrapper(this.connId);
        this.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo);
        this.connURL = $da38ac6aa733c404$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$da38ac6aa733c404$var$VERSION_PARAM] = $da38ac6aa733c404$var$PROTOCOL_VERSION;
        if (!(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)() && typeof location !== "undefined" && location.hostname && $da38ac6aa733c404$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$da38ac6aa733c404$var$REFERER_PARAM] = $da38ac6aa733c404$var$FORGE_REF;
        if (transportSessionId) urlParams[$da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$da38ac6aa733c404$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$da38ac6aa733c404$var$APPLICATION_ID_PARAM] = applicationId;
        return $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, $da38ac6aa733c404$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_("Websocket connecting to " + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $da38ac6aa733c404$var$PersistentStorage.set("previous_websocket_failure", true);
        try {
            let options;
            if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? "AdminNode" : "Node";
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                const options = {
                    headers: {
                        "User-Agent": `Firebase/${$da38ac6aa733c404$var$PROTOCOL_VERSION}/${$da38ac6aa733c404$var$SDK_VERSION}/${$hPtJY.platform}/${device}`,
                        "X-Firebase-GMPID": this.applicationId || ""
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers["Authorization"] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers["X-Firebase-AppCheck"] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf("wss://") === 0 ? env["HTTPS_PROXY"] || env["https_proxy"] : env["HTTP_PROXY"] || env["http_proxy"];
                if (proxy) options["proxy"] = {
                    origin: proxy
                };
            }
            this.mySock = new $da38ac6aa733c404$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_("Error instantiating WebSocket.");
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_("Websocket connected.");
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_("Websocket connection was disconnected.");
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_("WebSocket error.  Closing connection.");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $da38ac6aa733c404$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== "undefined" && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $da38ac6aa733c404$var$WebSocketImpl !== null && !$da38ac6aa733c404$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $da38ac6aa733c404$var$PersistentStorage.isInMemoryStorage || $da38ac6aa733c404$var$PersistentStorage.get("previous_websocket_failure") === true;
    }
    markConnectionHealthy() {
        $da38ac6aa733c404$var$PersistentStorage.remove("previous_websocket_failure");
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join("");
            this.frames = null;
            const jsonMess = (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.frames === null, "We already have a frame buffer");
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess["data"];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter("bytes_received", data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter("bytes_sent", dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $da38ac6aa733c404$var$splitStringBySize(dataStr, $da38ac6aa733c404$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_("WebSocket is closing itself");
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_("WebSocket is being closed");
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_("0");
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($da38ac6aa733c404$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_("Exception thrown from WebSocket.send():", e.message || e.data, "Closing connection.");
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $da38ac6aa733c404$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $da38ac6aa733c404$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $da38ac6aa733c404$var$TransportManager {
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    static get ALL_TRANSPORTS() {
        return [
            $da38ac6aa733c404$var$BrowserPollConnection,
            $da38ac6aa733c404$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $da38ac6aa733c404$var$WebSocketConnection && $da38ac6aa733c404$var$WebSocketConnection["isAvailable"]();
        let isSkipPollConnection = isWebSocketsAvailable && !$da38ac6aa733c404$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $da38ac6aa733c404$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $da38ac6aa733c404$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $da38ac6aa733c404$var$TransportManager.ALL_TRANSPORTS)if (transport && transport["isAvailable"]()) transports.push(transport);
            $da38ac6aa733c404$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error("No transports available");
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$da38ac6aa733c404$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $da38ac6aa733c404$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $da38ac6aa733c404$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $da38ac6aa733c404$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $da38ac6aa733c404$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $da38ac6aa733c404$var$MESSAGE_TYPE = "t";
const $da38ac6aa733c404$var$MESSAGE_DATA = "d";
const $da38ac6aa733c404$var$CONTROL_SHUTDOWN = "s";
const $da38ac6aa733c404$var$CONTROL_RESET = "r";
const $da38ac6aa733c404$var$CONTROL_ERROR = "e";
const $da38ac6aa733c404$var$CONTROL_PONG = "o";
const $da38ac6aa733c404$var$SWITCH_ACK = "a";
const $da38ac6aa733c404$var$END_TRANSMISSION = "n";
const $da38ac6aa733c404$var$PING = "p";
const $da38ac6aa733c404$var$SERVER_HELLO = "h";
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $da38ac6aa733c404$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */ ;
        this.log_ = $da38ac6aa733c404$var$logWrapper("c:" + this.id + ":");
        this.transportManager_ = new $da38ac6aa733c404$var$TransportManager(repoInfo_);
        this.log_("Connection created");
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn["healthyTimeout"] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $da38ac6aa733c404$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_("Connection exceeded healthy timeout but has received " + this.conn_.bytesReceived + " bytes.  Marking connection healthy.");
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $da38ac6aa733c404$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_("Connection exceeded healthy timeout but has sent " + this.conn_.bytesSent + " bytes.  Leaving connection alive.");
                else {
                    this.log_("Closing unhealthy connection after timeout.");
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return "c:" + this.id + ":" + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_("Secondary connection lost.");
                this.onSecondaryConnectionLost_();
            } else this.log_("closing an old connection");
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_("message on old connection");
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: "d",
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($da38ac6aa733c404$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$da38ac6aa733c404$var$MESSAGE_TYPE];
            if (cmd === $da38ac6aa733c404$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $da38ac6aa733c404$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_("Got a reset on secondary, closing it");
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $da38ac6aa733c404$var$CONTROL_PONG) {
                this.log_("got pong on secondary.");
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $da38ac6aa733c404$var$requireKey("t", parsedData);
        const data = $da38ac6aa733c404$var$requireKey("d", parsedData);
        if (layer === "c") this.onSecondaryControl_(data);
        else if (layer === "d") // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error("Unknown protocol layer: " + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_("Secondary connection is healthy.");
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_("sending ping on secondary.");
            this.secondaryConn_.send({
                t: "c",
                d: {
                    t: $da38ac6aa733c404$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_("sending client ack on secondary");
        this.secondaryConn_.send({
            t: "c",
            d: {
                t: $da38ac6aa733c404$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_("Ending transmission on primary");
        this.conn_.send({
            t: "c",
            d: {
                t: $da38ac6aa733c404$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $da38ac6aa733c404$var$requireKey("t", parsedData);
        const data = $da38ac6aa733c404$var$requireKey("d", parsedData);
        if (layer === "c") this.onControl_(data);
        else if (layer === "d") this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_("Primary connection is healthy.");
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $da38ac6aa733c404$var$requireKey($da38ac6aa733c404$var$MESSAGE_TYPE, controlData);
        if ($da38ac6aa733c404$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$da38ac6aa733c404$var$MESSAGE_DATA];
            if (cmd === $da38ac6aa733c404$var$SERVER_HELLO) this.onHandshake_(payload);
            else if (cmd === $da38ac6aa733c404$var$END_TRANSMISSION) {
                this.log_("recvd end transmission on primary");
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $da38ac6aa733c404$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_ERROR) $da38ac6aa733c404$var$error("Server Error: " + payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_PONG) {
                this.log_("got pong on primary.");
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $da38ac6aa733c404$var$error("Unknown control packet command: " + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($da38ac6aa733c404$var$PROTOCOL_VERSION !== version) $da38ac6aa733c404$var$warn("Protocol version mismatch detected");
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_("Timed out trying to upgrade.");
                this.secondaryConn_.close();
            }
        }, Math.floor($da38ac6aa733c404$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_("Reset packet received.  New host: " + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_("Realtime connection established.");
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_("Primary connection is healthy.");
            this.isHealthy_ = true;
        } else $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($da38ac6aa733c404$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */ ) {
            this.log_("sending ping on primary.");
            this.sendData_({
                t: "c",
                d: {
                    t: $da38ac6aa733c404$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */ ) {
            this.log_("Realtime connection failed.");
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $da38ac6aa733c404$var$PersistentStorage.remove("host:" + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* CONNECTED */ ) this.log_("Realtime connection lost.");
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_("Connection shutdown command received. Shutting down...");
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* CONNECTED */ ) throw "Connection is not connected";
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* DISCONNECTED */ ) {
            this.log_("Closing realtime connection.");
            this.state_ = 2 /* DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_("Shutting down all connections");
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $da38ac6aa733c404$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $da38ac6aa733c404$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, "Requires a non-empty array");
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), "Unknown event: " + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $da38ac6aa733c404$var$OnlineMonitor extends $da38ac6aa733c404$var$EventEmitter {
    constructor(){
        super([
            "online"
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined" && !(0, $c38e0f42709c826a$export$872f8323f01d7ae0)()) {
            window.addEventListener("online", ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger("online", true);
                }
            }, false);
            window.addEventListener("offline", ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger("online", false);
                }
            }, false);
        }
    }
    static getInstance() {
        return new $da38ac6aa733c404$var$OnlineMonitor();
    }
    getInitialEvent(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventType === "online", "Unknown event type: " + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $da38ac6aa733c404$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $da38ac6aa733c404$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split("/");
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = "";
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== "") pathString += "/" + this.pieces_[i];
        return pathString || "/";
    }
}
function $da38ac6aa733c404$var$newEmptyPath() {
    return new $da38ac6aa733c404$var$Path("");
}
function $da38ac6aa733c404$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $da38ac6aa733c404$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $da38ac6aa733c404$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $da38ac6aa733c404$var$Path(path.pieces_, pieceNum);
}
function $da38ac6aa733c404$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $da38ac6aa733c404$var$pathToUrlEncodedString(path) {
    let pathString = "";
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== "") pathString += "/" + encodeURIComponent(String(path.pieces_[i]));
    return pathString || "/";
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $da38ac6aa733c404$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $da38ac6aa733c404$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $da38ac6aa733c404$var$Path(pieces, 0);
}
function $da38ac6aa733c404$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $da38ac6aa733c404$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split("/");
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $da38ac6aa733c404$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $da38ac6aa733c404$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $da38ac6aa733c404$var$newRelativePath(outerPath, innerPath) {
    const outer = $da38ac6aa733c404$var$pathGetFront(outerPath), inner = $da38ac6aa733c404$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $da38ac6aa733c404$var$newRelativePath($da38ac6aa733c404$var$pathPopFront(outerPath), $da38ac6aa733c404$var$pathPopFront(innerPath));
    else throw new Error("INTERNAL ERROR: innerPath (" + innerPath + ") is not within " + "outerPath (" + outerPath + ")");
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $da38ac6aa733c404$var$pathCompare(left, right) {
    const leftKeys = $da38ac6aa733c404$var$pathSlice(left, 0);
    const rightKeys = $da38ac6aa733c404$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $da38ac6aa733c404$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $da38ac6aa733c404$var$pathEquals(path, other) {
    if ($da38ac6aa733c404$var$pathGetLength(path) !== $da38ac6aa733c404$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent (or the same as) other
 */ function $da38ac6aa733c404$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($da38ac6aa733c404$var$pathGetLength(path) > $da38ac6aa733c404$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $da38ac6aa733c404$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $da38ac6aa733c404$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(this.parts_[i]);
        $da38ac6aa733c404$var$validationPathCheckValid(this);
    }
}
function $da38ac6aa733c404$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(child);
    $da38ac6aa733c404$var$validationPathCheckValid(validationPath);
}
function $da38ac6aa733c404$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $da38ac6aa733c404$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + "has a key path longer than " + $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES + " bytes (" + validationPath.byteLength_ + ").");
    if (validationPath.parts_.length > $da38ac6aa733c404$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + $da38ac6aa733c404$var$MAX_PATH_DEPTH + ") or object contains a cycle " + $da38ac6aa733c404$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $da38ac6aa733c404$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return "";
    return "in property '" + validationPath.parts_.join(".") + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$VisibilityMonitor extends $da38ac6aa733c404$var$EventEmitter {
    constructor(){
        super([
            "visible"
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== "undefined" && typeof document.addEventListener !== "undefined") {
            if (typeof document["hidden"] !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = "visibilitychange";
                hidden = "hidden";
            } else if (typeof document["mozHidden"] !== "undefined") {
                visibilityChange = "mozvisibilitychange";
                hidden = "mozHidden";
            } else if (typeof document["msHidden"] !== "undefined") {
                visibilityChange = "msvisibilitychange";
                hidden = "msHidden";
            } else if (typeof document["webkitHidden"] !== "undefined") {
                visibilityChange = "webkitvisibilitychange";
                hidden = "webkitHidden";
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger("visible", visible);
            }
        }, false);
    }
    static getInstance() {
        return new $da38ac6aa733c404$var$VisibilityMonitor();
    }
    getInitialEvent(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventType === "visible", "Unknown event type: " + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$RECONNECT_MIN_DELAY = 1000;
const $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $da38ac6aa733c404$var$GET_CONNECT_TIMEOUT = 3000;
const $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $da38ac6aa733c404$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $da38ac6aa733c404$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $da38ac6aa733c404$var$SERVER_KILL_INTERRUPT_REASON = "server_kill";
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $da38ac6aa733c404$var$PersistentConnection extends $da38ac6aa733c404$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $da38ac6aa733c404$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $da38ac6aa733c404$var$logWrapper("p:" + this.id + ":");
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
        $da38ac6aa733c404$var$VisibilityMonitor.getInstance().on("visible", this.onVisible_, this);
        if (repoInfo_.host.indexOf("fblocal") === -1) $da38ac6aa733c404$var$OnlineMonitor.getInstance().on("online", this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $c38e0f42709c826a$export$fac44ee5b035f737)(msg));
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: "g",
            request: request,
            onComplete: (message)=>{
                const payload = message["d"];
                if (message["s"] === "ok") {
                    this.onDataUpdate_(request["p"], payload, /*isMerge*/ false, /*tag*/ null);
                    deferred.resolve(payload);
                } else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (!this.connected_) setTimeout(()=>{
            const get = this.outstandingGets_[index];
            if (get === undefined || outstandingGet !== get) return;
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            this.log_("get " + index + " timed out on connection");
            deferred.reject(new Error("Client is offline."));
        }, $da38ac6aa733c404$var$GET_CONNECT_TIMEOUT);
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "listen() called for non-default but complete query");
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), "listen() called twice for same path/queryId.");
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest("g", get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_("Listen on " + pathString + " for " + queryId);
        const req = {
            p: pathString
        };
        const action = "q";
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req["q"] = query._queryObject;
            req["t"] = listenSpec.tag;
        }
        req[/*hash*/ "h"] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ "d"];
            const status = message[/*status*/ "s"];
            // print warnings in any case...
            $da38ac6aa733c404$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_("listen response", message);
                if (status !== "ok") this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === "object" && (0, $c38e0f42709c826a$export$2344b14b097df817)(payload, "w")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(payload, "w");
            if (Array.isArray(warnings) && ~warnings.indexOf("no_index")) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $da38ac6aa733c404$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_("Auth token refreshed");
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest("unauth", {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $c38e0f42709c826a$export$fc970ed23da99565)(credential)) {
            this.log_("Admin auth credential detected.  Reducing max reconnect time.");
            this.maxReconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_("App check token refreshed");
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest("unappeck", {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $c38e0f42709c826a$export$9565ca3d387f8aa0)(token) ? "auth" : "gauth";
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData["noauth"] = true;
            else if (typeof this.authOverride_ === "object") requestData["authvar"] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ "s"];
                const data = res[/*data*/ "d"] || "error";
                if (this.authToken_ === token) {
                    if (status === "ok") this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest("appcheck", {
            "token": this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ "s"];
            const data = res[/*data*/ "d"] || "error";
            if (status === "ok") this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_("Unlisten called for " + pathString + " " + queryId);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), "unlisten() called for non-default but complete query");
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_("Unlisten on " + pathString + " for " + queryId);
        const req = {
            p: pathString
        };
        const action = "n";
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req["q"] = queryObj;
            req["t"] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("o", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "o",
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("om", pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "om",
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_("oc", pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: "oc",
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_("onDisconnect " + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ "s"], response[/* data */ "d"]);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal("p", pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal("m", pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ "h"] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_("Buffering put: " + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + " response", message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ "s"], message[/* data */ "d"]);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_("reportStats", request);
            this.sendRequest(/*stats*/ "s", request, (result)=>{
                const status = result[/*status*/ "s"];
                if (status !== "ok") {
                    const errorReason = result[/* data */ "d"];
                    this.log_("reportStats", "Error sending stats: " + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ("r" in message) {
            // this is a response
            this.log_("from server: " + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(message));
            const reqNum = message["r"];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ "b"]);
            }
        } else if ("error" in message) throw "A server-side error has occurred: " + message["error"];
        else if ("a" in message) // a and b are action and body, respectively
        this.onDataPush_(message["a"], message["b"]);
    }
    onDataPush_(action, body) {
        this.log_("handleServerMessage", action, body);
        if (action === "d") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge*/ false, body["t"]);
        else if (action === "m") this.onDataUpdate_(body[/*path*/ "p"], body[/*data*/ "d"], /*isMerge=*/ true, body["t"]);
        else if (action === "c") this.onListenRevoked_(body[/*path*/ "p"], body[/*query*/ "q"]);
        else if (action === "ac") this.onAuthRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "apc") this.onAppCheckRevoked_(body[/*status code*/ "s"], body[/* explanation */ "d"]);
        else if (action === "sd") this.onSecurityDebugPacket_(body);
        else $da38ac6aa733c404$var$error("Unrecognized action received from server: " + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(action) + "\nAre you using the latest client?");
    }
    onReady_(timestamp, sessionId) {
        this.log_("connection ready");
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_("Window became visible.  Reducing delay.");
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_("Browser went online.");
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_("Browser went offline.  Killing connection.");
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_("data client disconnected");
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $da38ac6aa733c404$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_("Trying to reconnect in " + reconnectDelay + "ms");
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $da38ac6aa733c404$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_("Making a connection attempt");
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ":" + $da38ac6aa733c404$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $da38ac6aa733c404$var$log("getToken() completed. Creating connection.");
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $da38ac6aa733c404$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $da38ac6aa733c404$var$warn(reason + " (" + this.repoInfo_.toString() + ")");
                        this.interrupt($da38ac6aa733c404$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $da38ac6aa733c404$var$log("getToken() completed but was canceled");
            } catch (error) {
                this.log_("Failed to get token: " + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $da38ac6aa733c404$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $da38ac6aa733c404$var$log("Interrupting connection for reason: " + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $da38ac6aa733c404$var$log("Resuming connection for reason: " + reason);
        delete this.interruptReasons_[reason];
        if ((0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ "h" in put.request && put.queued) {
                if (put.onComplete) put.onComplete("disconnect");
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = "default";
        else queryId = query.map((q)=>$da38ac6aa733c404$var$ObjectToUniqueKey(q)).join("$");
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete("permission_denied");
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $da38ac6aa733c404$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $da38ac6aa733c404$var$log("Auth token revoked: " + statusCode + "/" + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $da38ac6aa733c404$var$log("App check token revoked: " + statusCode + "/" + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === "invalid_token" || statusCode === "permission_denied") {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ("msg" in body) console.log("FIREBASE: " + body["msg"].replace("\n", "\nFIREBASE: "));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = "js";
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = "admin_node";
            else clientName = "node";
        }
        stats["sdk." + clientName + "." + $da38ac6aa733c404$var$SDK_VERSION.replace(/\./g, "-")] = 1;
        if ((0, $c38e0f42709c826a$export$872f8323f01d7ae0)()) stats["framework.cordova"] = 1;
        else if ((0, $c38e0f42709c826a$export$f7a1e23e542d38e3)()) stats["framework.reactnative"] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $da38ac6aa733c404$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$da38ac6aa733c404$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $da38ac6aa733c404$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $da38ac6aa733c404$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, oldNode);
        const newWrapped = new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$__EMPTY_NODE;
class $da38ac6aa733c404$var$KeyIndex extends $da38ac6aa733c404$var$Index {
    static get __EMPTY_NODE() {
        return $da38ac6aa733c404$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $da38ac6aa733c404$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)("KeyIndex.isDefinedOn not expected to be called.");
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, $da38ac6aa733c404$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof indexValue === "string", "KeyIndex indexValue must always be a string.");
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $da38ac6aa733c404$var$NamedNode(indexValue, $da38ac6aa733c404$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".key";
    }
}
const $da38ac6aa733c404$var$KEY_INDEX = new $da38ac6aa733c404$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $da38ac6aa733c404$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $da38ac6aa733c404$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $da38ac6aa733c404$var$LLRBNode.RED;
        this.left = left != null ? left : $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $da38ac6aa733c404$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $da38ac6aa733c404$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $da38ac6aa733c404$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
        if (this.right.isRed_()) throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error("Black depths differ");
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$da38ac6aa733c404$var$LLRBNode.RED = true;
$da38ac6aa733c404$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $da38ac6aa733c404$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $da38ac6aa733c404$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $da38ac6aa733c404$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $da38ac6aa733c404$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $da38ac6aa733c404$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $da38ac6aa733c404$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $da38ac6aa733c404$var$SortedMap.EMPTY_NODE = new $da38ac6aa733c404$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$NAME_ONLY_COMPARATOR(left, right) {
    return $da38ac6aa733c404$var$nameCompare(left.name, right.name);
}
function $da38ac6aa733c404$var$NAME_COMPARATOR(left, right) {
    return $da38ac6aa733c404$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$MAX_NODE$2;
function $da38ac6aa733c404$var$setMaxNode$1(val) {
    $da38ac6aa733c404$var$MAX_NODE$2 = val;
}
const $da38ac6aa733c404$var$priorityHashText = function(priority) {
    if (typeof priority === "number") return "number:" + $da38ac6aa733c404$var$doubleToIEEE754String(priority);
    else return "string:" + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $da38ac6aa733c404$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof val === "string" || typeof val === "number" || typeof val === "object" && (0, $c38e0f42709c826a$export$2344b14b097df817)(val, ".sv"), "Priority must be a string or number.");
    } else (0, $c38e0f42709c826a$export$a7a9523472993e97)(priorityNode === $da38ac6aa733c404$var$MAX_NODE$2 || priorityNode.isEmpty(), "priority of unexpected type.");
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(priorityNode === $da38ac6aa733c404$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $da38ac6aa733c404$var$LeafNode {
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $da38ac6aa733c404$var$validatePriorityNode(this.priorityNode_);
    }
    static set __childrenNodeConstructor(val) {
        $da38ac6aa733c404$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $da38ac6aa733c404$var$__childrenNodeConstructor;
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $da38ac6aa733c404$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.priorityNode_;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($da38ac6aa733c404$var$pathIsEmpty(path)) return this;
        else if ($da38ac6aa733c404$var$pathGetFront(path) === ".priority") return this.priorityNode_;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== ".priority") return this;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== ".priority") return this;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(front !== ".priority" || $da38ac6aa733c404$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            return this.updateImmediateChild(front, $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($da38ac6aa733c404$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            ".value": this.getValue(),
            ".priority": this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = "";
            if (!this.priorityNode_.isEmpty()) toHash += "priority:" + $da38ac6aa733c404$var$priorityHashText(this.priorityNode_.val()) + ":";
            const type = typeof this.value_;
            toHash += type + ":";
            if (type === "number") toHash += $da38ac6aa733c404$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $da38ac6aa733c404$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(other.isLeafNode(), "Unknown node type");
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(otherIndex >= 0, "Unknown leaf type: " + otherLeafType);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(thisIndex >= 0, "Unknown leaf type: " + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === "object") // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER = [
    "object",
    "boolean",
    "number",
    "string"
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$nodeFromJSON$1;
let $da38ac6aa733c404$var$MAX_NODE$1;
function $da38ac6aa733c404$var$setNodeFromJSON(val) {
    $da38ac6aa733c404$var$nodeFromJSON$1 = val;
}
function $da38ac6aa733c404$var$setMaxNode(val) {
    $da38ac6aa733c404$var$MAX_NODE$1 = val;
}
class $da38ac6aa733c404$var$PriorityIndex extends $da38ac6aa733c404$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, new $da38ac6aa733c404$var$LeafNode("[PRIORITY-POST]", $da38ac6aa733c404$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $da38ac6aa733c404$var$nodeFromJSON$1(indexValue);
        return new $da38ac6aa733c404$var$NamedNode(name, new $da38ac6aa733c404$var$LeafNode("[PRIORITY-POST]", priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".priority";
    }
}
const $da38ac6aa733c404$var$PRIORITY_INDEX = new $da38ac6aa733c404$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$LOG_2 = Math.log(2);
class $da38ac6aa733c404$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $da38ac6aa733c404$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join("1"), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $da38ac6aa733c404$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, $da38ac6aa733c404$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $da38ac6aa733c404$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $da38ac6aa733c404$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$_defaultIndexMap;
const $da38ac6aa733c404$var$fallbackObject = {};
class $da38ac6aa733c404$var$IndexMap {
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$fallbackObject && $da38ac6aa733c404$var$PRIORITY_INDEX, "ChildrenNode.ts has not been loaded");
        $da38ac6aa733c404$var$_defaultIndexMap = $da38ac6aa733c404$var$_defaultIndexMap || new $da38ac6aa733c404$var$IndexMap({
            ".priority": $da38ac6aa733c404$var$fallbackObject
        }, {
            ".priority": $da38ac6aa733c404$var$PRIORITY_INDEX
        });
        return $da38ac6aa733c404$var$_defaultIndexMap;
    }
    get(indexKey) {
        const sortedMap = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error("No index defined for " + indexKey);
        if (sortedMap instanceof $da38ac6aa733c404$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $c38e0f42709c826a$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(indexDefinition !== $da38ac6aa733c404$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($da38ac6aa733c404$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $da38ac6aa733c404$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $da38ac6aa733c404$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(index, "Missing index implementation for " + indexName);
            if (indexedChildren === $da38ac6aa733c404$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($da38ac6aa733c404$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $da38ac6aa733c404$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $da38ac6aa733c404$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $da38ac6aa733c404$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $da38ac6aa733c404$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $da38ac6aa733c404$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $da38ac6aa733c404$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $da38ac6aa733c404$var$ChildrenNode {
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $da38ac6aa733c404$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
    }
    static get EMPTY_NODE() {
        return $da38ac6aa733c404$var$EMPTY_NODE || ($da38ac6aa733c404$var$EMPTY_NODE = new $da38ac6aa733c404$var$ChildrenNode(new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$NAME_COMPARATOR), null, $da38ac6aa733c404$var$IndexMap.Default));
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $da38ac6aa733c404$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $da38ac6aa733c404$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === ".priority") return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $da38ac6aa733c404$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($da38ac6aa733c404$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(newChildNode, "We should always be passing snapshot nodes");
        if (childName === ".priority") return this.updatePriority(newChildNode);
        else {
            const namedNode = new $da38ac6aa733c404$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $da38ac6aa733c404$var$EMPTY_NODE : this.priorityNode_;
            return new $da38ac6aa733c404$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(path) !== ".priority" || $da38ac6aa733c404$var$pathGetLength(path) === 1, ".priority must be the last token in a path");
            const newImmediateChild = this.getImmediateChild(front).updateChild($da38ac6aa733c404$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $da38ac6aa733c404$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj[".priority"] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = "";
            if (!this.getPriority().isEmpty()) toHash += "priority:" + $da38ac6aa733c404$var$priorityHashText(this.getPriority().val()) + ":";
            this.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== "") toHash += ":" + key + ":" + childHash;
            });
            this.lazyHash_ = toHash === "" ? "" : $da38ac6aa733c404$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $da38ac6aa733c404$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $da38ac6aa733c404$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $da38ac6aa733c404$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $da38ac6aa733c404$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $da38ac6aa733c404$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $da38ac6aa733c404$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $da38ac6aa733c404$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $da38ac6aa733c404$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $da38ac6aa733c404$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($da38ac6aa733c404$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($da38ac6aa733c404$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $da38ac6aa733c404$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$da38ac6aa733c404$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $da38ac6aa733c404$var$MaxNode extends $da38ac6aa733c404$var$ChildrenNode {
    constructor(){
        super(new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$NAME_COMPARATOR), $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, $da38ac6aa733c404$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $da38ac6aa733c404$var$MAX_NODE = new $da38ac6aa733c404$var$MaxNode();
Object.defineProperties($da38ac6aa733c404$var$NamedNode, {
    MIN: {
        value: new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, $da38ac6aa733c404$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $da38ac6aa733c404$var$KeyIndex.__EMPTY_NODE = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
$da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor = $da38ac6aa733c404$var$ChildrenNode;
$da38ac6aa733c404$var$setMaxNode$1($da38ac6aa733c404$var$MAX_NODE);
$da38ac6aa733c404$var$setMaxNode($da38ac6aa733c404$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $da38ac6aa733c404$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === "object" && ".priority" in json) priority = json[".priority"];
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(priority === null || typeof priority === "string" || typeof priority === "number" || typeof priority === "object" && ".sv" in priority, "Invalid priority type found: " + typeof priority);
    if (typeof json === "object" && ".value" in json && json[".value"] !== null) json = json[".value"];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== "object" || ".sv" in json) {
        const jsonLeaf = json;
        return new $da38ac6aa733c404$var$LeafNode(jsonLeaf, $da38ac6aa733c404$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $da38ac6aa733c404$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $da38ac6aa733c404$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== ".") {
                // Ignore metadata nodes
                const childNode = $da38ac6aa733c404$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $da38ac6aa733c404$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        const childSet = $da38ac6aa733c404$var$buildChildSet(children, $da38ac6aa733c404$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $da38ac6aa733c404$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $da38ac6aa733c404$var$buildChildSet(children, $da38ac6aa733c404$var$PRIORITY_INDEX.getCompare());
            return new $da38ac6aa733c404$var$ChildrenNode(childSet, $da38ac6aa733c404$var$nodeFromJSON(priority), new $da38ac6aa733c404$var$IndexMap({
                ".priority": sortedChildSet
            }, {
                ".priority": $da38ac6aa733c404$var$PRIORITY_INDEX
            }));
        } else return new $da38ac6aa733c404$var$ChildrenNode(childSet, $da38ac6aa733c404$var$nodeFromJSON(priority), $da38ac6aa733c404$var$IndexMap.Default);
    } else {
        let node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        $da38ac6aa733c404$var$each(json, (key, childData)=>{
            if ((0, $c38e0f42709c826a$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== ".") {
                    // ignore metadata nodes.
                    const childNode = $da38ac6aa733c404$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($da38ac6aa733c404$var$nodeFromJSON(priority));
    }
}
$da38ac6aa733c404$var$setNodeFromJSON($da38ac6aa733c404$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$PathIndex extends $da38ac6aa733c404$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$pathIsEmpty(indexPath_) && $da38ac6aa733c404$var$pathGetFront(indexPath_) !== ".priority", "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $da38ac6aa733c404$var$nodeFromJSON(indexValue);
        const node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $da38ac6aa733c404$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $da38ac6aa733c404$var$MAX_NODE);
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, node);
    }
    toString() {
        return $da38ac6aa733c404$var$pathSlice(this.indexPath_, 0).join("/");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ValueIndex extends $da38ac6aa733c404$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $da38ac6aa733c404$var$nodeFromJSON(indexValue);
        return new $da38ac6aa733c404$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return ".value";
    }
}
const $da38ac6aa733c404$var$VALUE_INDEX = new $da38ac6aa733c404$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $da38ac6aa733c404$var$PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
const $da38ac6aa733c404$var$MIN_PUSH_CHAR = "-";
const $da38ac6aa733c404$var$MAX_PUSH_CHAR = "z";
const $da38ac6aa733c404$var$MAX_KEY_LEN = 786;
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $da38ac6aa733c404$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $da38ac6aa733c404$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(now === 0, "Cannot push at time == 0");
        let id = timeStampChars.join("");
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $da38ac6aa733c404$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(id.length === 20, "nextPushId: Length should be 20.");
        return id;
    };
}();
const $da38ac6aa733c404$var$successor = function(key) {
    if (key === "" + $da38ac6aa733c404$var$INTEGER_32_MAX) // See https://firebase.google.com/docs/database/web/lists-of-data#data-order
    return $da38ac6aa733c404$var$MIN_PUSH_CHAR;
    const keyAsInt = $da38ac6aa733c404$var$tryParseInt(key);
    if (keyAsInt != null) return "" + (keyAsInt + 1);
    const next = new Array(key.length);
    for(let i = 0; i < next.length; i++)next[i] = key.charAt(i);
    if (next.length < $da38ac6aa733c404$var$MAX_KEY_LEN) {
        next.push($da38ac6aa733c404$var$MIN_PUSH_CHAR);
        return next.join("");
    }
    let i = next.length - 1;
    while(i >= 0 && next[i] === $da38ac6aa733c404$var$MAX_PUSH_CHAR)i--;
    // `successor` was called on the largest possible key, so return the
    // MAX_NAME, which sorts larger than all keys.
    if (i === -1) return $da38ac6aa733c404$var$MAX_NAME;
    const source = next[i];
    const sourcePlusOne = $da38ac6aa733c404$var$PUSH_CHARS.charAt($da38ac6aa733c404$var$PUSH_CHARS.indexOf(source) + 1);
    next[i] = sourcePlusOne;
    return next.slice(0, i + 1).join("");
};
// `key` is assumed to be non-empty.
const $da38ac6aa733c404$var$predecessor = function(key) {
    if (key === "" + $da38ac6aa733c404$var$INTEGER_32_MIN) return $da38ac6aa733c404$var$MIN_NAME;
    const keyAsInt = $da38ac6aa733c404$var$tryParseInt(key);
    if (keyAsInt != null) return "" + (keyAsInt - 1);
    const next = new Array(key.length);
    for(let i = 0; i < next.length; i++)next[i] = key.charAt(i);
    // If `key` ends in `MIN_PUSH_CHAR`, the largest key lexicographically
    // smaller than `key`, is `key[0:key.length - 1]`. The next key smaller
    // than that, `predecessor(predecessor(key))`, is
    //
    // `key[0:key.length - 2] + (key[key.length - 1] - 1) + \
    //   { MAX_PUSH_CHAR repeated MAX_KEY_LEN - (key.length - 1) times }
    //
    // analogous to increment/decrement for base-10 integers.
    //
    // This works because lexigographic comparison works character-by-character,
    // using length as a tie-breaker if one key is a prefix of the other.
    if (next[next.length - 1] === $da38ac6aa733c404$var$MIN_PUSH_CHAR) {
        if (next.length === 1) // See https://firebase.google.com/docs/database/web/lists-of-data#orderbykey
        return "" + $da38ac6aa733c404$var$INTEGER_32_MAX;
        delete next[next.length - 1];
        return next.join("");
    }
    // Replace the last character with it's immediate predecessor, and
    // fill the suffix of the key with MAX_PUSH_CHAR. This is the
    // lexicographically largest possible key smaller than `key`.
    next[next.length - 1] = $da38ac6aa733c404$var$PUSH_CHARS.charAt($da38ac6aa733c404$var$PUSH_CHARS.indexOf(next[next.length - 1]) - 1);
    return next.join("") + $da38ac6aa733c404$var$MAX_PUSH_CHAR.repeat($da38ac6aa733c404$var$MAX_KEY_LEN - next.length);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$changeValue(snapshotNode) {
    return {
        type: "value" /* VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $da38ac6aa733c404$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $da38ac6aa733c404$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $da38ac6aa733c404$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $da38ac6aa733c404$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $da38ac6aa733c404$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(snap.isIndexed(this.index_), "A node must be indexed if only a child is updated");
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(key, oldChild));
                else (0, $c38e0f42709c826a$export$a7a9523472993e97)(snap.isLeafNode(), "A child remove without an old child only makes sense on a leaf node");
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $da38ac6aa733c404$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $da38ac6aa733c404$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $da38ac6aa733c404$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $da38ac6aa733c404$var$RangedFilter.getEndPost_(params);
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        return this.index_.compare(this.getStartPost(), node) <= 0 && this.index_.compare(node, this.getEndPost()) <= 0;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $da38ac6aa733c404$var$NamedNode(key, newChild))) newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $da38ac6aa733c404$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $da38ac6aa733c404$var$LimitedFilter {
    constructor(params){
        this.rangedFilter_ = new $da38ac6aa733c404$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $da38ac6aa733c404$var$NamedNode(key, newChild))) newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                let inRange;
                if (this.reverse_) inRange = this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                else inRange = this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                if (inRange) {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                } else break;
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            let startPost;
            let endPost;
            let cmp;
            let iterator;
            if (this.reverse_) {
                iterator = filtered.getReverseIterator(this.index_);
                startPost = this.rangedFilter_.getEndPost();
                endPost = this.rangedFilter_.getStartPost();
                const indexCompare = this.index_.getCompare();
                cmp = (a, b)=>indexCompare(b, a);
            } else {
                iterator = filtered.getIterator(this.index_);
                startPost = this.rangedFilter_.getStartPost();
                endPost = this.rangedFilter_.getEndPost();
                cmp = this.index_.getCompare();
            }
            let count = 0;
            let foundStartPost = false;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                if (!foundStartPost && cmp(startPost, next) <= 0) // start adding
                foundStartPost = true;
                const inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, "");
        const newChildNamedNode = new $da38ac6aa733c404$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $da38ac6aa733c404$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = "";
        this.indexStartValue_ = null;
        this.indexStartName_ = "";
        this.indexEndValue_ = null;
        this.indexEndName_ = "";
        this.index_ = $da38ac6aa733c404$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    hasStartAfter() {
        return this.startAfterSet_;
    }
    hasEndBefore() {
        return this.endBeforeSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === "") // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.startSet_, "Only valid if start has been set");
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.startSet_, "Only valid if start has been set");
        if (this.startNameSet_) return this.indexStartName_;
        else return $da38ac6aa733c404$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.endSet_, "Only valid if end has been set");
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.endSet_, "Only valid if end has been set");
        if (this.endNameSet_) return this.indexEndName_;
        else return $da38ac6aa733c404$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== "";
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.limitSet_, "Only valid if limit has been set");
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $da38ac6aa733c404$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $da38ac6aa733c404$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $da38ac6aa733c404$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $da38ac6aa733c404$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $da38ac6aa733c404$var$LimitedFilter(queryParams);
    else return new $da38ac6aa733c404$var$RangedFilter(queryParams);
}
function $da38ac6aa733c404$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* VIEW_FROM_LEFT */ ;
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = "";
    }
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX) {
        if (typeof indexValue === "string") indexValue = $da38ac6aa733c404$var$successor(indexValue);
        params = $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, key);
    } else {
        let childKey;
        if (key == null) childKey = $da38ac6aa733c404$var$MAX_NAME;
        else childKey = $da38ac6aa733c404$var$successor(key);
        params = $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, childKey);
    }
    params.startAfterSet_ = true;
    return params;
}
function $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = "";
    }
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let childKey;
    let params;
    if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX) {
        if (typeof indexValue === "string") indexValue = $da38ac6aa733c404$var$predecessor(indexValue);
        params = $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, key);
    } else {
        if (key == null) childKey = $da38ac6aa733c404$var$MIN_NAME;
        else childKey = $da38ac6aa733c404$var$predecessor(key);
        params = $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, childKey);
    }
    params.endBeforeSet_ = true;
    return params;
}
function $da38ac6aa733c404$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $da38ac6aa733c404$var$PRIORITY_INDEX) orderBy = "$priority" /* PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $da38ac6aa733c404$var$VALUE_INDEX) orderBy = "$value" /* VALUE_INDEX */ ;
    else if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX) orderBy = "$key" /* KEY_INDEX */ ;
    else {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(queryParams.index_ instanceof $da38ac6aa733c404$var$PathIndex, "Unrecognized index type!");
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* ORDER_BY */ ] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        qs["startAt" /* START_AT */ ] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs["startAt" /* START_AT */ ] += "," + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        qs["endAt" /* END_AT */ ] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs["endAt" /* END_AT */ ] += "," + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $da38ac6aa733c404$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* INDEX_START_NAME */ ] = queryParams.indexStartName_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* INDEX_END_NAME */ ] = queryParams.indexEndName_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === "") {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $da38ac6aa733c404$var$PRIORITY_INDEX) obj["i" /* INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $da38ac6aa733c404$var$ReadonlyRestClient extends $da38ac6aa733c404$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $da38ac6aa733c404$var$logWrapper("p:rest:");
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    reportStats(stats) {
        throw new Error("Method not implemented.");
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return "tag$" + tag;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_("Listen called for " + pathString + " " + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $da38ac6aa733c404$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + ".json", queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = "ok";
                else if (error === 401) status = "permission_denied";
                else status = "rest_error:" + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $da38ac6aa733c404$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        this.restRequest_(pathString + ".json", queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters["format"] = "export";
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters["auth"] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters["ac"] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host + pathString + "?" + "ns=" + this.repoInfo_.namespace + (0, $c38e0f42709c826a$export$ac4103b836844853)(queryStringParameters);
            this.log_("Sending REST request for " + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_("REST Response for " + url + " received. status:", xhr.status, "response:", xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $da38ac6aa733c404$var$warn("Failed to parse JSON response for " + url + ": " + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $da38ac6aa733c404$var$warn("Got unsuccessful REST response for " + url + " Status: " + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open("GET", url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $da38ac6aa733c404$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $da38ac6aa733c404$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        $da38ac6aa733c404$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, tree)=>{
                    $da38ac6aa733c404$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $da38ac6aa733c404$var$Path(key), tree);
                });
                return $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $da38ac6aa733c404$var$pathGetFront(path);
            path = $da38ac6aa733c404$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $da38ac6aa733c404$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $da38ac6aa733c404$var$Path(prefixPath.toString() + "/" + key);
        $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $da38ac6aa733c404$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $da38ac6aa733c404$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME = 10000;
const $da38ac6aa733c404$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $da38ac6aa733c404$var$REPORT_STATS_INTERVAL = 300000;
class $da38ac6aa733c404$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $da38ac6aa733c404$var$StatsListener(collection);
        const timeout = $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME + ($da38ac6aa733c404$var$FIRST_STATS_MAX_TIME - $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME) * Math.random();
        $da38ac6aa733c404$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $da38ac6aa733c404$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $c38e0f42709c826a$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $da38ac6aa733c404$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $da38ac6aa733c404$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $da38ac6aa733c404$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($da38ac6aa733c404$var$OperationType || ($da38ac6aa733c404$var$OperationType = {}));
function $da38ac6aa733c404$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $da38ac6aa733c404$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $da38ac6aa733c404$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$da38ac6aa733c404$var$pathIsEmpty(this.path)) {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(this.path) === childName, "operationForChild called for unrelated child.");
            return new $da38ac6aa733c404$var$AckUserWrite($da38ac6aa733c404$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths.");
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $da38ac6aa733c404$var$Path(childName));
            return new $da38ac6aa733c404$var$AckUserWrite($da38ac6aa733c404$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) return new $da38ac6aa733c404$var$ListenComplete(this.source, $da38ac6aa733c404$var$newEmptyPath());
        else return new $da38ac6aa733c404$var$ListenComplete(this.source, $da38ac6aa733c404$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $da38ac6aa733c404$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $da38ac6aa733c404$var$Merge(this.source, $da38ac6aa733c404$var$newEmptyPath(), childTree);
        } else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $da38ac6aa733c404$var$Merge(this.source, $da38ac6aa733c404$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $da38ac6aa733c404$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($da38ac6aa733c404$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $da38ac6aa733c404$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $da38ac6aa733c404$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $da38ac6aa733c404$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($da38ac6aa733c404$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$da38ac6aa733c404$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $da38ac6aa733c404$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $da38ac6aa733c404$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === "value" || change.type === "child_removed") return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $da38ac6aa733c404$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)("Should only compare child_ events.");
    const aWrapped = new $da38ac6aa733c404$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $da38ac6aa733c404$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $da38ac6aa733c404$var$newViewCache(new $da38ac6aa733c404$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $da38ac6aa733c404$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $da38ac6aa733c404$var$newViewCache(viewCache.eventCache, new $da38ac6aa733c404$var$CacheNode(serverSnap, complete, filtered));
}
function $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $da38ac6aa733c404$var$EmptyChildren = ()=>{
    if (!$da38ac6aa733c404$var$emptyChildrenSingleton) $da38ac6aa733c404$var$emptyChildrenSingleton = new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$stringCompare);
    return $da38ac6aa733c404$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $da38ac6aa733c404$var$ImmutableTree {
    constructor(value, children = $da38ac6aa733c404$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    static fromObject(obj) {
        let tree = new $da38ac6aa733c404$var$ImmutableTree(null);
        $da38ac6aa733c404$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $da38ac6aa733c404$var$Path(childPath), childSnap);
        });
        return tree;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $da38ac6aa733c404$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($da38ac6aa733c404$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $da38ac6aa733c404$var$pathChild(new $da38ac6aa733c404$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($da38ac6aa733c404$var$pathPopFront(relativePath));
            else return new $da38ac6aa733c404$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return new $da38ac6aa733c404$var$ImmutableTree(toSet, this.children);
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $da38ac6aa733c404$var$ImmutableTree(null);
            const newChild = child.set($da38ac6aa733c404$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $da38ac6aa733c404$var$ImmutableTree(null);
            else return new $da38ac6aa733c404$var$ImmutableTree(null, this.children);
        } else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($da38ac6aa733c404$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $da38ac6aa733c404$var$ImmutableTree(null);
                else return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($da38ac6aa733c404$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $da38ac6aa733c404$var$ImmutableTree(null);
            const newChild = child.setTree($da38ac6aa733c404$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($da38ac6aa733c404$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($da38ac6aa733c404$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $da38ac6aa733c404$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($da38ac6aa733c404$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $da38ac6aa733c404$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($da38ac6aa733c404$var$pathPopFront(pathToFollow), $da38ac6aa733c404$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $da38ac6aa733c404$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($da38ac6aa733c404$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $da38ac6aa733c404$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($da38ac6aa733c404$var$pathPopFront(pathToFollow), $da38ac6aa733c404$var$pathChild(currentRelativePath, front), f);
            else return new $da38ac6aa733c404$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($da38ac6aa733c404$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($da38ac6aa733c404$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $da38ac6aa733c404$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(null));
    }
}
function $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $da38ac6aa733c404$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $da38ac6aa733c404$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $da38ac6aa733c404$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $da38ac6aa733c404$var$CompoundWrite(newWriteTree);
        }
    }
}
function $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $da38ac6aa733c404$var$each(updates, (childKey, node)=>{
        newWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(newWrite, $da38ac6aa733c404$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $da38ac6aa733c404$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return $da38ac6aa733c404$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $da38ac6aa733c404$var$ImmutableTree(null));
        return new $da38ac6aa733c404$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $da38ac6aa733c404$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($da38ac6aa733c404$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $da38ac6aa733c404$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $da38ac6aa733c404$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(shadowingNode));
        else return new $da38ac6aa733c404$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $da38ac6aa733c404$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $da38ac6aa733c404$var$compoundWriteApply(compoundWrite, node) {
    return $da38ac6aa733c404$var$applySubtreeWrite($da38ac6aa733c404$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $da38ac6aa733c404$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === ".priority") {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(childTree.value !== null, "Priority writes must always be leaf nodes");
                priorityWrite = childTree.value;
            } else node = $da38ac6aa733c404$var$applySubtreeWrite($da38ac6aa733c404$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($da38ac6aa733c404$var$pathChild(relativePath, ".priority"), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $da38ac6aa733c404$var$writeTreeChildWrites(writeTree, path) {
    return $da38ac6aa733c404$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $da38ac6aa733c404$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, "Stacking an older write on top of newer ones");
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $da38ac6aa733c404$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, "Stacking an older merge on top of newer ones");
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $da38ac6aa733c404$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $da38ac6aa733c404$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(idx >= 0, "removeWrite called with nonexistent writeId.");
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $da38ac6aa733c404$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($da38ac6aa733c404$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $da38ac6aa733c404$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $da38ac6aa733c404$var$each(children, (childName)=>{
                writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $da38ac6aa733c404$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $da38ac6aa733c404$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $da38ac6aa733c404$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $da38ac6aa733c404$var$pathContains($da38ac6aa733c404$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $da38ac6aa733c404$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $da38ac6aa733c404$var$writeTreeLayerTree_(writeTree.allWrites, $da38ac6aa733c404$var$writeTreeDefaultFilter_, $da38ac6aa733c404$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $da38ac6aa733c404$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $da38ac6aa733c404$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $da38ac6aa733c404$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($da38ac6aa733c404$var$pathContains(treeRoot, writePath)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($da38ac6aa733c404$var$pathContains(writePath, treeRoot)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($da38ac6aa733c404$var$pathContains(treeRoot, writePath)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($da38ac6aa733c404$var$pathContains(writePath, treeRoot)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(writePath, treeRoot);
                    if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(write.children, $da38ac6aa733c404$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($da38ac6aa733c404$var$pathPopFront(relativePath));
                            compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)("WriteRecord should have .snap or .children");
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($da38ac6aa733c404$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$da38ac6aa733c404$var$compoundWriteHasCompleteWrite(subMerge, $da38ac6aa733c404$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                return $da38ac6aa733c404$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $da38ac6aa733c404$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$da38ac6aa733c404$var$compoundWriteHasCompleteWrite(merge, $da38ac6aa733c404$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($da38ac6aa733c404$var$pathContains(write.path, treePath) || $da38ac6aa733c404$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $da38ac6aa733c404$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                return $da38ac6aa733c404$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $da38ac6aa733c404$var$compoundWriteApply($da38ac6aa733c404$var$compoundWriteChildCompoundWrite(merge, new $da38ac6aa733c404$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $da38ac6aa733c404$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, "Either existingEventSnap or existingServerSnap must exist");
    const path = $da38ac6aa733c404$var$pathChild(treePath, childPath);
    if ($da38ac6aa733c404$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($da38ac6aa733c404$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $da38ac6aa733c404$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $da38ac6aa733c404$var$pathChild(treePath, childKey);
    const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $da38ac6aa733c404$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $da38ac6aa733c404$var$writeTreeShadowingWrite(writeTree, path) {
    return $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $da38ac6aa733c404$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(merge, $da38ac6aa733c404$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $da38ac6aa733c404$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $da38ac6aa733c404$var$newWriteTree() {
    return {
        visibleWrites: $da38ac6aa733c404$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $da38ac6aa733c404$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $da38ac6aa733c404$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $da38ac6aa733c404$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $da38ac6aa733c404$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $da38ac6aa733c404$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $da38ac6aa733c404$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $da38ac6aa733c404$var$writeTreeRefChild(writeTreeRef, childName) {
    return $da38ac6aa733c404$var$newWriteTreeRef($da38ac6aa733c404$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $da38ac6aa733c404$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(type === "child_added" /* CHILD_ADDED */  || type === "child_changed" /* CHILD_CHANGED */  || type === "child_removed" /* CHILD_REMOVED */ , "Only child changes supported for tracking");
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(childKey !== ".priority", "Only non-priority child changes can be tracked.");
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* CHILD_ADDED */  && oldType === "child_removed" /* CHILD_REMOVED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* CHILD_REMOVED */  && oldType === "child_added" /* CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* CHILD_REMOVED */  && oldType === "child_changed" /* CHILD_CHANGED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* CHILD_CHANGED */  && oldType === "child_added" /* CHILD_ADDED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* CHILD_CHANGED */  && oldType === "child_changed" /* CHILD_CHANGED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)("Illegal combination of changes: " + change + " occurred after " + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $da38ac6aa733c404$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE = new $da38ac6aa733c404$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $da38ac6aa733c404$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $da38ac6aa733c404$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $da38ac6aa733c404$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $da38ac6aa733c404$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Event snap not indexed");
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), "Server snap not indexed");
}
function $da38ac6aa733c404$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $da38ac6aa733c404$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $da38ac6aa733c404$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(overwrite.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$da38ac6aa733c404$var$pathIsEmpty(overwrite.path);
            newViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(merge.source.fromServer, "Unknown source.");
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $da38ac6aa733c404$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $da38ac6aa733c404$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.LISTEN_COMPLETE) newViewCache = $da38ac6aa733c404$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)("Unknown operation type: " + operation.type);
    const changes = accumulator.getChanges();
    $da38ac6aa733c404$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $da38ac6aa733c404$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($da38ac6aa733c404$var$changeValue($da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), "If change path is empty, we must have complete server data");
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $da38ac6aa733c404$var$ChildrenNode ? serverCache : $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
            if (childKey === ".priority") {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $da38ac6aa733c404$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === ".priority") newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $da38ac6aa733c404$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
        if (childKey === ".priority") {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($da38ac6aa733c404$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($da38ac6aa733c404$var$pathGetBack(childChangePath) === ".priority" && childNode.getChild($da38ac6aa733c404$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $da38ac6aa733c404$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $da38ac6aa733c404$var$pathChild(path, relativePath);
        if ($da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, $da38ac6aa733c404$var$pathGetFront(writePath))) curViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $da38ac6aa733c404$var$pathChild(path, relativePath);
        if (!$da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, $da38ac6aa733c404$var$pathGetFront(writePath))) curViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $da38ac6aa733c404$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $da38ac6aa733c404$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === undefined;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $da38ac6aa733c404$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $da38ac6aa733c404$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($da38ac6aa733c404$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($da38ac6aa733c404$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $da38ac6aa733c404$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($da38ac6aa733c404$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $da38ac6aa733c404$var$Path(name), node);
            });
            return $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $da38ac6aa733c404$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $da38ac6aa733c404$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $da38ac6aa733c404$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $da38ac6aa733c404$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $da38ac6aa733c404$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($da38ac6aa733c404$var$pathIsEmpty(path) || $da38ac6aa733c404$var$pathGetFront(path) === ".priority") {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(serverChildren instanceof $da38ac6aa733c404$var$ChildrenNode, "serverChildren would be complete if leaf node");
                newNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $da38ac6aa733c404$var$pathGetFront(path);
            let newChild = $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $da38ac6aa733c404$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, $da38ac6aa733c404$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, $da38ac6aa733c404$var$newEmptyPath()) != null;
        return $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $da38ac6aa733c404$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $da38ac6aa733c404$var$IndexedFilter(params.getIndex());
        const filter = $da38ac6aa733c404$var$queryParamsGetNodeFilter(params);
        this.processor_ = $da38ac6aa733c404$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $da38ac6aa733c404$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $da38ac6aa733c404$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $da38ac6aa733c404$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $da38ac6aa733c404$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $da38ac6aa733c404$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $da38ac6aa733c404$var$viewGetCompleteNode(view) {
    return $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $da38ac6aa733c404$var$viewGetCompleteServerCache(view, path) {
    const cache = $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$da38ac6aa733c404$var$pathIsEmpty(path) && !cache.getImmediateChild($da38ac6aa733c404$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $da38ac6aa733c404$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $da38ac6aa733c404$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventRegistration == null, "A cancel should cancel all event registrations.");
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $da38ac6aa733c404$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(view.viewCache_), "We should always have a full cache before handling merges");
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(view.viewCache_), "Missing event cache, even though we have a server cache");
    }
    const oldViewCache = view.viewCache_;
    const result = $da38ac6aa733c404$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $da38ac6aa733c404$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), "Once a server snap is complete, it should never go back");
    view.viewCache_ = result.viewCache;
    return $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $da38ac6aa733c404$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($da38ac6aa733c404$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($da38ac6aa733c404$var$changeValue(eventSnap.getNode()));
    return $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $da38ac6aa733c404$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $da38ac6aa733c404$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $da38ac6aa733c404$var$syncPointSetReferenceConstructor(val) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$referenceConstructor$1, "__referenceConstructor has already been defined");
    $da38ac6aa733c404$var$referenceConstructor$1 = val;
}
function $da38ac6aa733c404$var$syncPointGetReferenceConstructor() {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$referenceConstructor$1, "Reference.ts has not been loaded");
    return $da38ac6aa733c404$var$referenceConstructor$1;
}
function $da38ac6aa733c404$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(view != null, "SyncTree gave us an op for an invalid query.");
        return $da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $da38ac6aa733c404$var$ChildrenNode) {
            eventCache = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $da38ac6aa733c404$var$newViewCache(new $da38ac6aa733c404$var$CacheNode(eventCache, eventCacheComplete, false), new $da38ac6aa733c404$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $da38ac6aa733c404$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $da38ac6aa733c404$var$viewAddEventRegistration(view, eventRegistration);
    return $da38ac6aa733c404$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $da38ac6aa733c404$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint);
    if (queryId === "default") // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($da38ac6aa733c404$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($da38ac6aa733c404$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($da38ac6aa733c404$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $da38ac6aa733c404$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $da38ac6aa733c404$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $da38ac6aa733c404$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint) {
    return $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint) != null;
}
function $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$referenceConstructor;
function $da38ac6aa733c404$var$syncTreeSetReferenceConstructor(val) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$referenceConstructor, "__referenceConstructor has already been defined");
    $da38ac6aa733c404$var$referenceConstructor = val;
}
function $da38ac6aa733c404$var$syncTreeGetReferenceConstructor() {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$referenceConstructor, "Reference.ts has not been loaded");
    return $da38ac6aa733c404$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $da38ac6aa733c404$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $da38ac6aa733c404$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $da38ac6aa733c404$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $da38ac6aa733c404$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $da38ac6aa733c404$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $da38ac6aa733c404$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $da38ac6aa733c404$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $da38ac6aa733c404$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $da38ac6aa733c404$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($da38ac6aa733c404$var$newEmptyPath(), true);
        else $da38ac6aa733c404$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $da38ac6aa733c404$var$Path(pathString), true);
        });
        return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyListenComplete(syncTree, path) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$ListenComplete($da38ac6aa733c404$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const op = new $da38ac6aa733c404$var$ListenComplete($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === "default" || $da38ac6aa733c404$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $da38ac6aa733c404$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($da38ac6aa733c404$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        // We may have just removed one of many listeners and can short-circuit this whole process
        // We may also not have removed a default listener, in which case all of the descendant listeners should already be
        // properly set up.
        //
        // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
        // queryId === 'default'
        const removingDefault = -1 !== removed.findIndex((query)=>{
            return query._queryParams.loadsAllData();
        });
        const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$da38ac6aa733c404$var$syncPointHasCompleteView(parentSyncPoint));
        if (removingDefault && !covered) {
            const subtree = syncTree.syncPointTree_.subtree(path);
            // There are potentially child listeners. Determine what if any listens we need to send before executing the
            // removal
            if (!subtree.isEmpty()) {
                // We need to fold over our subtree and collect the listeners to send
                const newViews = $da38ac6aa733c404$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                // Ok, we've collected all the listens we need. Set them up.
                for(let i = 0; i < newViews.length; ++i){
                    const view = newViews[i], newQuery = view.query;
                    const listener = $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view);
                    syncTree.listenProvider_.startListening($da38ac6aa733c404$var$syncTreeQueryForListening_(newQuery), $da38ac6aa733c404$var$syncTreeTagForQuery_(syncTree, newQuery), listener.hashFn, listener.onComplete);
                }
            }
        }
        // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
        // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
        // Also, note that if we have a cancelError, it's already been removed at the provider level.
        if (!covered && removed.length > 0 && !cancelError) {
            // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
            // default. Otherwise, we need to iterate through and cancel each individual query
            if (removingDefault) {
                // We don't tag default listeners
                const defaultTag = null;
                syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(query), defaultTag);
            } else removed.forEach((queryToRemove)=>{
                const tagToRemove = syncTree.queryToTagMap.get($da38ac6aa733c404$var$syncTreeMakeQueryKey_(queryToRemove));
                syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
            });
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $da38ac6aa733c404$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const op = new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
        const op = new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $da38ac6aa733c404$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $da38ac6aa733c404$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(childSyncPoint, $da38ac6aa733c404$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $da38ac6aa733c404$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), "View does not exist, but we have a tag");
        const tag = $da38ac6aa733c404$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $da38ac6aa733c404$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView) {
        const view = $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($da38ac6aa733c404$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathSoFar, path);
        const serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $da38ac6aa733c404$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $da38ac6aa733c404$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $da38ac6aa733c404$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $da38ac6aa733c404$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $da38ac6aa733c404$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($da38ac6aa733c404$var$pathIsEmpty(operation.path)) return $da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($da38ac6aa733c404$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
        let events = [];
        const childName = $da38ac6aa733c404$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $da38ac6aa733c404$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($da38ac6aa733c404$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($da38ac6aa733c404$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $da38ac6aa733c404$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $da38ac6aa733c404$var$syncTreeTagForQuery_(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $da38ac6aa733c404$var$viewGetServerCache(view) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === "ok") {
                if (tag) return $da38ac6aa733c404$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $da38ac6aa733c404$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $da38ac6aa733c404$var$errorForServerCode(status, query);
                return $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $da38ac6aa733c404$var$syncTreeTagForQuery_(syncTree, query) {
    const queryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + "$" + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf("$");
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, "Bad queryKey.");
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $da38ac6aa733c404$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $da38ac6aa733c404$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $da38ac6aa733c404$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $da38ac6aa733c404$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $da38ac6aa733c404$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $da38ac6aa733c404$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $da38ac6aa733c404$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($da38ac6aa733c404$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $da38ac6aa733c404$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $da38ac6aa733c404$var$syncTreeGetNextQueryTag_() {
    return $da38ac6aa733c404$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $da38ac6aa733c404$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $da38ac6aa733c404$var$syncTreeTagForQuery_(syncTree, query);
    const listener = $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($da38ac6aa733c404$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$da38ac6aa733c404$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $da38ac6aa733c404$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $da38ac6aa733c404$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($da38ac6aa733c404$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $da38ac6aa733c404$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(queryToStop), $da38ac6aa733c404$var$syncTreeTagForQuery_(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $da38ac6aa733c404$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $da38ac6aa733c404$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $da38ac6aa733c404$var$pathChild(this.path_, childName);
        return new $da38ac6aa733c404$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $da38ac6aa733c404$var$generateWithValues = function(values) {
    values = values || {};
    values["timestamp"] = values["timestamp"] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $da38ac6aa733c404$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== "object") return value;
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(".sv" in value, "Unexpected leaf node or priority contents");
    if (typeof value[".sv"] === "string") return $da38ac6aa733c404$var$resolveScalarDeferredValue(value[".sv"], existingVal, serverValues);
    else if (typeof value[".sv"] === "object") return $da38ac6aa733c404$var$resolveComplexDeferredValue(value[".sv"], existingVal);
    else (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, "Unexpected server value: " + JSON.stringify(value, null, 2));
};
const $da38ac6aa733c404$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case "timestamp":
            return serverValues["timestamp"];
        default:
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, "Unexpected server value: " + op);
    }
};
const $da38ac6aa733c404$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty("increment")) (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, "Unexpected server value: " + JSON.stringify(op, null, 2));
    const delta = op["increment"];
    if (typeof delta !== "number") (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, "Unexpected increment value: " + delta);
    const existingNode = existing.node();
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== "undefined", "Expected ChildrenNode.EMPTY_NODE for nulls");
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== "number") return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $da38ac6aa733c404$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $da38ac6aa733c404$var$resolveDeferredValue(node, new $da38ac6aa733c404$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $da38ac6aa733c404$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $da38ac6aa733c404$var$resolveDeferredValue(node, new $da38ac6aa733c404$var$ExistingValueProvider(existing), serverValues);
};
function $da38ac6aa733c404$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $da38ac6aa733c404$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild(".priority"), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $da38ac6aa733c404$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $da38ac6aa733c404$var$LeafNode(value, $da38ac6aa733c404$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $da38ac6aa733c404$var$LeafNode(priority));
        childrenNode.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $da38ac6aa733c404$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $da38ac6aa733c404$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = "", parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $da38ac6aa733c404$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $da38ac6aa733c404$var$Path ? pathObj : new $da38ac6aa733c404$var$Path(pathObj);
    let child = tree, next = $da38ac6aa733c404$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $da38ac6aa733c404$var$Tree(next, child, childNode);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        next = $da38ac6aa733c404$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $da38ac6aa733c404$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $da38ac6aa733c404$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $da38ac6aa733c404$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $da38ac6aa733c404$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whethe rthe tree is empty (no value or children).
 */ function $da38ac6aa733c404$var$treeIsEmpty(tree) {
    return $da38ac6aa733c404$var$treeGetValue(tree) === undefined && !$da38ac6aa733c404$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $da38ac6aa733c404$var$treeForEachChild(tree, action) {
    $da38ac6aa733c404$var$each(tree.node.children, (child, childTree)=>{
        action(new $da38ac6aa733c404$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $da38ac6aa733c404$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $da38ac6aa733c404$var$treeForEachChild(tree, (child)=>{
        $da38ac6aa733c404$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $da38ac6aa733c404$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $da38ac6aa733c404$var$treeGetPath(tree) {
    return new $da38ac6aa733c404$var$Path(tree.parent === null ? tree.name : $da38ac6aa733c404$var$treeGetPath(tree.parent) + "/" + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $da38ac6aa733c404$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $da38ac6aa733c404$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $da38ac6aa733c404$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $da38ac6aa733c404$var$treeIsEmpty(child);
    const childExists = (0, $c38e0f42709c826a$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $da38ac6aa733c404$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $da38ac6aa733c404$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $da38ac6aa733c404$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $da38ac6aa733c404$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $da38ac6aa733c404$var$MAX_LEAF_SIZE_ = 10485760;
const $da38ac6aa733c404$var$isValidKey = function(key) {
    return typeof key === "string" && key.length !== 0 && !$da38ac6aa733c404$var$INVALID_KEY_REGEX_.test(key);
};
const $da38ac6aa733c404$var$isValidPathString = function(pathString) {
    return typeof pathString === "string" && pathString.length !== 0 && !$da38ac6aa733c404$var$INVALID_PATH_REGEX_.test(pathString);
};
const $da38ac6aa733c404$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    return $da38ac6aa733c404$var$isValidPathString(pathString);
};
const $da38ac6aa733c404$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === "string" || typeof priority === "number" && !$da38ac6aa733c404$var$isInvalidJSONNumber(priority) || priority && typeof priority === "object" && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $c38e0f42709c826a$export$2344b14b097df817)(priority, ".sv");
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $da38ac6aa733c404$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $da38ac6aa733c404$var$validateFirebaseData((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, "value"), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $da38ac6aa733c404$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $da38ac6aa733c404$var$Path ? new $da38ac6aa733c404$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + "contains undefined " + $da38ac6aa733c404$var$validationPathToErrorString(path));
    if (typeof data === "function") throw new Error(errorPrefix + "contains a function " + $da38ac6aa733c404$var$validationPathToErrorString(path) + " with contents = " + data.toString());
    if ($da38ac6aa733c404$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + "contains " + data.toString() + " " + $da38ac6aa733c404$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === "string" && data.length > $da38ac6aa733c404$var$MAX_LEAF_SIZE_ / 3 && (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(data) > $da38ac6aa733c404$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + "contains a string greater than " + $da38ac6aa733c404$var$MAX_LEAF_SIZE_ + " utf8 bytes " + $da38ac6aa733c404$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === "object") {
        let hasDotValue = false;
        let hasActualChild = false;
        $da38ac6aa733c404$var$each(data, (key, value)=>{
            if (key === ".value") hasDotValue = true;
            else if (key !== ".priority" && key !== ".sv") {
                hasActualChild = true;
                if (!$da38ac6aa733c404$var$isValidKey(key)) throw new Error(errorPrefix + " contains an invalid key (" + key + ") " + $da38ac6aa733c404$var$validationPathToErrorString(path) + ".  Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $da38ac6aa733c404$var$validationPathPush(path, key);
            $da38ac6aa733c404$var$validateFirebaseData(errorPrefix, value, path);
            $da38ac6aa733c404$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + " in addition to actual children.");
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $da38ac6aa733c404$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $da38ac6aa733c404$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === ".priority" && j === keys.length - 1) ;
            else if (!$da38ac6aa733c404$var$isValidKey(keys[j])) throw new Error(errorPrefix + "contains an invalid key (" + keys[j] + ") in path " + curPath.toString() + ". Keys must be non-empty strings " + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($da38ac6aa733c404$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $da38ac6aa733c404$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + "contains a path " + prevPath.toString() + " that is ancestor of another path " + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $da38ac6aa733c404$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, "values");
    if (!(data && typeof data === "object") || Array.isArray(data)) throw new Error(errorPrefix$1 + " must be an object containing the children to replace.");
    const mergePaths = [];
    $da38ac6aa733c404$var$each(data, (key, value)=>{
        const curPath = new $da38ac6aa733c404$var$Path(key);
        $da38ac6aa733c404$var$validateFirebaseData(errorPrefix$1, value, $da38ac6aa733c404$var$pathChild(path, curPath));
        if ($da38ac6aa733c404$var$pathGetBack(curPath) === ".priority") {
            if (!$da38ac6aa733c404$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + "Firebase priority (a string, finite number, server value, or null).");
        }
        mergePaths.push(curPath);
    });
    $da38ac6aa733c404$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $da38ac6aa733c404$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($da38ac6aa733c404$var$isInvalidJSONNumber(priority)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, "priority") + "is " + priority.toString() + ", but must be a valid Firebase priority (a string, finite number, " + "server value, or null).");
    // Special case to allow importing data with a .sv.
    if (!$da38ac6aa733c404$var$isValidPriority(priority)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, "priority") + "must be a valid Firebase priority " + "(a string, finite number, server value, or null).");
};
const $da38ac6aa733c404$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$da38ac6aa733c404$var$isValidKey(key)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $da38ac6aa733c404$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$da38ac6aa733c404$var$isValidPathString(pathString)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $da38ac6aa733c404$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
    $da38ac6aa733c404$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $da38ac6aa733c404$export$8d83036122ae444e = function(fnName, path) {
    if ($da38ac6aa733c404$var$pathGetFront(path) === ".info") throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $da38ac6aa733c404$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === "string") || parsedUrl.repoInfo.host.length === 0 || !$da38ac6aa733c404$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(":")[0] !== "localhost" || pathString.length !== 0 && !$da38ac6aa733c404$var$isValidRootPathString(pathString)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, "url") + "must be a valid firebase URL and " + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $da38ac6aa733c404$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$da38ac6aa733c404$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$da38ac6aa733c404$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$da38ac6aa733c404$var$pathContains(eventPath, changedPath) || $da38ac6aa733c404$var$pathContains(changedPath, eventPath));
}
function $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $da38ac6aa733c404$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $da38ac6aa733c404$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($da38ac6aa733c404$var$logger) $da38ac6aa733c404$var$log("event: " + eventData.toString());
            $da38ac6aa733c404$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$INTERRUPT_REASON = "repo_interrupt";
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $da38ac6aa733c404$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $da38ac6aa733c404$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $da38ac6aa733c404$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $da38ac6aa733c404$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $da38ac6aa733c404$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
    }
}
function $da38ac6aa733c404$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $da38ac6aa733c404$var$beingCrawled()) {
        repo.server_ = new $da38ac6aa733c404$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$da38ac6aa733c404$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== "undefined" && authOverride !== null) {
            if (typeof authOverride !== "object") throw new Error("Only objects are supported for option databaseAuthVariableOverride");
            try {
                (0, $c38e0f42709c826a$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error("Invalid authOverride provided: " + e);
            }
        }
        repo.persistentConnection_ = new $da38ac6aa733c404$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $da38ac6aa733c404$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $da38ac6aa733c404$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $da38ac6aa733c404$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $da38ac6aa733c404$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $da38ac6aa733c404$var$SnapshotHolder();
    repo.infoSyncTree_ = new $da38ac6aa733c404$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete("ok");
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $da38ac6aa733c404$var$repoUpdateInfo(repo, "connected", false);
    repo.serverSyncTree_ = new $da38ac6aa733c404$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $da38ac6aa733c404$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $da38ac6aa733c404$var$Path(".info/serverTimeOffset"));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $da38ac6aa733c404$var$repoGenerateServerValues(repo) {
    return $da38ac6aa733c404$var$generateWithValues({
        timestamp: $da38ac6aa733c404$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $da38ac6aa733c404$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(data, (raw)=>$da38ac6aa733c404$var$nodeFromJSON(raw));
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $da38ac6aa733c404$var$nodeFromJSON(data);
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(data, (raw)=>$da38ac6aa733c404$var$nodeFromJSON(raw));
        events = $da38ac6aa733c404$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $da38ac6aa733c404$var$nodeFromJSON(data);
        events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $da38ac6aa733c404$var$repoRerunTransactions(repo, path);
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $da38ac6aa733c404$var$repoOnConnectStatus(repo, connectStatus) {
    $da38ac6aa733c404$var$repoUpdateInfo(repo, "connected", connectStatus);
    if (connectStatus === false) $da38ac6aa733c404$var$repoRunOnDisconnectEvents(repo);
}
function $da38ac6aa733c404$var$repoOnServerInfoUpdate(repo, updates) {
    $da38ac6aa733c404$var$each(updates, (key, value)=>{
        $da38ac6aa733c404$var$repoUpdateInfo(repo, key, value);
    });
}
function $da38ac6aa733c404$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $da38ac6aa733c404$var$Path("/.info/" + pathString);
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $da38ac6aa733c404$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will try to
 * establish a connection and request the value for `query`. If
 * the client is not able to retrieve the query result, it reports
 * an error.
 *
 * @param query - The query to surface a value for.
 */ function $da38ac6aa733c404$var$repoGetValue(repo, query) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $da38ac6aa733c404$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $da38ac6aa733c404$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        const events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
        return Promise.resolve(node);
    }, (err)=>{
        $da38ac6aa733c404$var$repoLog(repo, "get for query " + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(query) + " failed: " + err);
        return Promise.reject(new Error(err));
    });
}
function $da38ac6aa733c404$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $da38ac6aa733c404$var$repoLog(repo, "set", {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $da38ac6aa733c404$var$nodeFromJSON(newVal, newPriority);
    const existing = $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
    const events = $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $da38ac6aa733c404$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === "ok";
        if (!success) $da38ac6aa733c404$var$warn("set at " + path + " failed: " + status);
        const clearEvents = $da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, path);
    $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $da38ac6aa733c404$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $da38ac6aa733c404$var$repoLog(repo, "update", {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $da38ac6aa733c404$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $da38ac6aa733c404$var$resolveDeferredValueTree($da38ac6aa733c404$var$pathChild(path, changedKey), $da38ac6aa733c404$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
        const events = $da38ac6aa733c404$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $da38ac6aa733c404$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === "ok";
            if (!success) $da38ac6aa733c404$var$warn("update at " + path + " failed: " + status);
            const clearEvents = $da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $da38ac6aa733c404$var$repoRerunTransactions(repo, path) : path;
            $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $da38ac6aa733c404$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, $da38ac6aa733c404$var$pathChild(path, changedPath));
            $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $da38ac6aa733c404$var$log("update() called with empty data.  Don't do anything.");
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $da38ac6aa733c404$var$repoRunOnDisconnectEvents(repo) {
    $da38ac6aa733c404$var$repoLog(repo, "onDisconnectEvents");
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $da38ac6aa733c404$var$newSparseSnapshotTree();
    $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $da38ac6aa733c404$var$newEmptyPath(), (path, node)=>{
        const resolved = $da38ac6aa733c404$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $da38ac6aa733c404$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $da38ac6aa733c404$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, path);
        $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $da38ac6aa733c404$var$newSparseSnapshotTree();
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $da38ac6aa733c404$var$newEmptyPath(), events);
}
function $da38ac6aa733c404$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === "ok") $da38ac6aa733c404$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === "ok") $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === "ok") $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $da38ac6aa733c404$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, "ok", undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === "ok") $da38ac6aa733c404$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $da38ac6aa733c404$var$nodeFromJSON(childNode);
            $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $da38ac6aa733c404$var$pathChild(path, childName), newChildNode);
        });
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($da38ac6aa733c404$var$pathGetFront(query._path) === ".info") events = $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($da38ac6aa733c404$var$pathGetFront(query._path) === ".info") events = $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $da38ac6aa733c404$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($da38ac6aa733c404$var$INTERRUPT_REASON);
}
function $da38ac6aa733c404$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($da38ac6aa733c404$var$INTERRUPT_REASON);
}
function $da38ac6aa733c404$var$repoLog(repo, ...varArgs) {
    let prefix = "";
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ":";
    $da38ac6aa733c404$var$log(prefix, ...varArgs);
}
function $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $da38ac6aa733c404$var$exceptionGuard(()=>{
        if (status === "ok") callback(null);
        else {
            const code = (status || "error").toUpperCase();
            let message = code;
            if (errorReason) message += ": " + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $da38ac6aa733c404$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $da38ac6aa733c404$var$repoLog(repo, "transaction on " + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $da38ac6aa733c404$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $da38ac6aa733c404$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $da38ac6aa733c404$var$validateFirebaseData("transaction failed: Data returned ", newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* RUN */ ;
        const queueNode = $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $da38ac6aa733c404$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $da38ac6aa733c404$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === "object" && newVal !== null && (0, $c38e0f42709c826a$export$2344b14b097df817)(newVal, ".priority")) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(newVal, ".priority");
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $da38ac6aa733c404$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
        const events = $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $da38ac6aa733c404$var$repoGetLatestState(repo, path, excludeSets) {
    return $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $da38ac6aa733c404$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($da38ac6aa733c404$var$treeGetValue(node)) {
        const queue = $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, node);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(queue.length > 0, "Sending zero length transaction queue");
        const allRun = queue.every((transaction)=>transaction.status === 0 /* RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $da38ac6aa733c404$var$repoSendTransactionQueue(repo, $da38ac6aa733c404$var$treeGetPath(node), queue);
    } else if ($da38ac6aa733c404$var$treeHasChildren(node)) $da38ac6aa733c404$var$treeForEachChild(node, (childNode)=>{
        $da38ac6aa733c404$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $da38ac6aa733c404$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $da38ac6aa733c404$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(txn.status === 0 /* RUN */ , "tryToSendTransactionQueue_: items in queue should all be run.");
        txn.status = 1 /* SENT */ ;
        txn.retryCount++;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $da38ac6aa733c404$var$repoLog(repo, "transaction put response", {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === "ok") {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* COMPLETED */ ;
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === "datastale") {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* NEEDS_ABORT */ ;
                else queue[i].status = 0 /* RUN */ ;
            } else {
                $da38ac6aa733c404$var$warn("transaction at " + pathToSend.toString() + " failed: " + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $da38ac6aa733c404$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $da38ac6aa733c404$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $da38ac6aa733c404$var$treeGetPath(rootMostTransactionNode);
    const queue = $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $da38ac6aa733c404$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $da38ac6aa733c404$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $da38ac6aa733c404$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(relativePath !== null, "rerunTransactionsUnderNode_: relativePath should not be null.");
        if (transaction.status === 4 /* NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* RUN */ ) {
            if (transaction.retryCount >= $da38ac6aa733c404$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = "maxretry";
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $da38ac6aa733c404$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $da38ac6aa733c404$var$validateFirebaseData("transaction failed: Data returned ", newData, transaction.path);
                    let newDataNode = $da38ac6aa733c404$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === "object" && newData != null && (0, $c38e0f42709c826a$export$2344b14b097df817)(newData, ".priority");
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = "nodata";
                    events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === "nodata") callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $da38ac6aa733c404$var$pathGetFront(path);
    while(front !== null && $da38ac6aa733c404$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $da38ac6aa733c404$var$treeSubTree(transactionNode, front);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        front = $da38ac6aa733c404$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $da38ac6aa733c404$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $da38ac6aa733c404$var$treeForEachChild(node, (child)=>{
        $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $da38ac6aa733c404$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $da38ac6aa733c404$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $da38ac6aa733c404$var$treeForEachChild(node, (childNode)=>{
        $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $da38ac6aa733c404$var$repoAbortTransactions(repo, path) {
    const affectedPath = $da38ac6aa733c404$var$treeGetPath($da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path);
    $da38ac6aa733c404$var$treeForEachAncestor(transactionNode, (node)=>{
        $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node);
    });
    $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $da38ac6aa733c404$var$treeForEachDescendant(transactionNode, (node)=>{
        $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $da38ac6aa733c404$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* SENT */ ) {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(lastSent === i - 1, "All SENT items should be at beginning of queue.");
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = "set";
            } else {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(queue[i].status === 0 /* RUN */ , "Unexpected transaction status in abort");
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error("set"), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $da38ac6aa733c404$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $da38ac6aa733c404$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$decodePath(pathString) {
    let pathStringDecoded = "";
    const pieces = pathString.split("/");
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, " "));
        } catch (e) {}
        pathStringDecoded += "/" + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $da38ac6aa733c404$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === "?") queryString = queryString.substring(1);
    for (const segment of queryString.split("&")){
        if (segment.length === 0) continue;
        const kv = segment.split("=");
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $da38ac6aa733c404$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $da38ac6aa733c404$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $da38ac6aa733c404$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === "firebase.com") $da38ac6aa733c404$var$fatal(parsedUrl.host + " is no longer supported. " + "Please use <YOUR FIREBASE>.firebaseio.com instead");
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === "undefined") && parsedUrl.domain !== "localhost") $da38ac6aa733c404$var$fatal("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");
    if (!parsedUrl.secure) $da38ac6aa733c404$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === "ws" || parsedUrl.scheme === "wss";
    return {
        repoInfo: new $da38ac6aa733c404$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ "", /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $da38ac6aa733c404$var$Path(parsedUrl.pathString)
    };
};
const $da38ac6aa733c404$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = "", domain = "", subdomain = "", pathString = "", namespace = "";
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = "https", port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === "string") {
        // Parse scheme.
        let colonInd = dataURL.indexOf("//");
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf("/");
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf("?");
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $da38ac6aa733c404$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $da38ac6aa733c404$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(":");
        if (colonInd >= 0) {
            secure = scheme === "https" || scheme === "wss";
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === "localhost") domain = "localhost";
        else if (hostWithoutPort.split(".").length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf(".");
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ("ns" in queryParams) namespace = queryParams["ns"];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $da38ac6aa733c404$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === "value") return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ":" + this.eventType + ":" + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $da38ac6aa733c404$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return "cancel";
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ":cancel";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $da38ac6aa733c404$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.hasCancelCallback, "Raising a cancel event on a listener with no cancel callback");
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $da38ac6aa733c404$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $da38ac6aa733c404$export$8d83036122ae444e("OnDisconnect.remove", this._path);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $da38ac6aa733c404$export$8d83036122ae444e("OnDisconnect.set", this._path);
        $da38ac6aa733c404$var$validateFirebaseDataArg("OnDisconnect.set", value, this._path, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $da38ac6aa733c404$export$8d83036122ae444e("OnDisconnect.setWithPriority", this._path);
        $da38ac6aa733c404$var$validateFirebaseDataArg("OnDisconnect.setWithPriority", value, this._path, false);
        $da38ac6aa733c404$var$validatePriority("OnDisconnect.setWithPriority", priority, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $da38ac6aa733c404$export$8d83036122ae444e("OnDisconnect.update", this._path);
        $da38ac6aa733c404$var$validateFirebaseMergeDataArg("OnDisconnect.update", values, this._path, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $da38ac6aa733c404$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($da38ac6aa733c404$var$pathIsEmpty(this._path)) return null;
        else return $da38ac6aa733c404$var$pathGetBack(this._path);
    }
    get ref() {
        return new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $da38ac6aa733c404$var$queryParamsGetQueryObject(this._queryParams);
        const id = $da38ac6aa733c404$var$ObjectToUniqueKey(obj);
        return id === "{}" ? "default" : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $da38ac6aa733c404$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $da38ac6aa733c404$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $da38ac6aa733c404$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $da38ac6aa733c404$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $da38ac6aa733c404$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $da38ac6aa733c404$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $da38ac6aa733c404$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== "string") throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $da38ac6aa733c404$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== "string") throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $da38ac6aa733c404$var$PRIORITY_INDEX) {
        if (startNode != null && !$da38ac6aa733c404$var$isValidPriority(startNode) || endNode != null && !$da38ac6aa733c404$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(params.getIndex() instanceof $da38ac6aa733c404$var$PathIndex || params.getIndex() === $da38ac6aa733c404$var$VALUE_INDEX, "unknown index type.");
        if (startNode != null && typeof startNode === "object" || endNode != null && typeof endNode === "object") throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $da38ac6aa733c404$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $da38ac6aa733c404$export$35c3a5e7c9d1033c extends $da38ac6aa733c404$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $da38ac6aa733c404$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $da38ac6aa733c404$var$pathParent(this._path);
        return parentPath === null ? null : new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $da38ac6aa733c404$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $da38ac6aa733c404$var$Path(path);
        const childRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(this.ref, path);
        return new $da38ac6aa733c404$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $da38ac6aa733c404$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `DataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $da38ac6aa733c404$export$80b98bcbc246c942(node, $da38ac6aa733c404$export$f9574b70e1d95d9d(this.ref, key), $da38ac6aa733c404$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $da38ac6aa733c404$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $da38ac6aa733c404$export$eff4d24c3ff7876e(db, path) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("ref");
    return path !== undefined ? $da38ac6aa733c404$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $da38ac6aa733c404$export$291fc3c05735451(db, url) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("refFromURL");
    const parsedURL = $da38ac6aa733c404$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $da38ac6aa733c404$var$validateUrl("refFromURL", parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $da38ac6aa733c404$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + " but expected " + db._repo.repoInfo_.host + ")");
    return $da38ac6aa733c404$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(parent);
    if ($da38ac6aa733c404$var$pathGetFront(parent._path) === null) $da38ac6aa733c404$var$validateRootPathString("child", "path", path, false);
    else $da38ac6aa733c404$export$8637b026ace8abb1("child", "path", path, false);
    return new $da38ac6aa733c404$export$35c3a5e7c9d1033c(parent._repo, $da38ac6aa733c404$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $da38ac6aa733c404$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return new $da38ac6aa733c404$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}
 * </br>See {@link ttps://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $da38ac6aa733c404$export$4cbf152802aa238(parent, value) {
    parent = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(parent);
    $da38ac6aa733c404$export$8d83036122ae444e("push", parent._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg("push", value, parent._path, true);
    const now = $da38ac6aa733c404$var$repoServerTime(parent._repo);
    const name = $da38ac6aa733c404$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thennablePushRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $da38ac6aa733c404$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thennablePushRef.then = promise.then.bind(promise);
    thennablePushRef.catch = promise.then.bind(promise, undefined);
    return thennablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $da38ac6aa733c404$export$cd7f480d6b8286c3(ref) {
    $da38ac6aa733c404$export$8d83036122ae444e("remove", ref._path);
    return $da38ac6aa733c404$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e("set", ref._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg("set", value, ref._path, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e("setPriority", ref._path);
    $da38ac6aa733c404$var$validatePriority("setPriority", priority, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, $da38ac6aa733c404$var$pathChild(ref._path, ".priority"), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$1fa5d5bf488088f3(ref, value, priority) {
    $da38ac6aa733c404$export$8d83036122ae444e("setWithPriority", ref._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg("setWithPriority", value, ref._path, false);
    $da38ac6aa733c404$var$validatePriority("setWithPriority", priority, false);
    if (ref.key === ".length" || ref.key === ".keys") throw "setWithPriority failed: " + ref.key + " is a read-only object.";
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $da38ac6aa733c404$export$722fbec263ad908a(ref, values) {
    $da38ac6aa733c404$var$validateFirebaseMergeDataArg("update", values, ref._path, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $da38ac6aa733c404$export$3988ae62b71be9a3(query) {
    query = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(query);
    return $da38ac6aa733c404$var$repoGetValue(query._repo, query).then((node)=>{
        return new $da38ac6aa733c404$export$80b98bcbc246c942(node, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $da38ac6aa733c404$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === "value";
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $da38ac6aa733c404$var$DataEvent("value", this, new $da38ac6aa733c404$export$80b98bcbc246c942(change.snapshotNode, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === "cancel") return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $da38ac6aa733c404$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $da38ac6aa733c404$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $da38ac6aa733c404$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === "children_added" ? "child_added" : eventType;
        eventToCheck = eventToCheck === "children_removed" ? "child_removed" : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $da38ac6aa733c404$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(change.childName != null, "Child events should have a childName.");
        const childRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $da38ac6aa733c404$var$DataEvent(change.type, this, new $da38ac6aa733c404$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === "cancel") return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $da38ac6aa733c404$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $da38ac6aa733c404$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === "object") {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === "function") cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $da38ac6aa733c404$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === "value" ? new $da38ac6aa733c404$var$ValueEventRegistration(callbackContext) : new $da38ac6aa733c404$var$ChildEventRegistration(eventType, callbackContext);
    $da38ac6aa733c404$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $da38ac6aa733c404$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, "value", callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, "child_added", callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, "child_changed", callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, "child_moved", callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, "child_removed", callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with `on()`.
 *
 * Detach a callback previously attached with `on()`. Note that if `on()` was
 * called multiple times with the same eventType and callback, the callback
 * will be called multiple times for each event, and `off()` must be called
 * multiple times to remove the callback. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $da38ac6aa733c404$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $da38ac6aa733c404$var$CallbackContext(callback) : null;
    if (eventType === "value") container = new $da38ac6aa733c404$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $da38ac6aa733c404$var$ChildEventRegistration(eventType, expCallback);
    $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $da38ac6aa733c404$export$b0e86f2c7431df4e {
}
class $da38ac6aa733c404$var$QueryEndAtConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg("endAt", this._value, query._path, true);
        const newParams = $da38ac6aa733c404$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $da38ac6aa733c404$export$28ec54a8428bdb3f(value, key) {
    $da38ac6aa733c404$var$validateKey("endAt", "key", key, true);
    return new $da38ac6aa733c404$var$QueryEndAtConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryEndBeforeConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg("endBefore", this._value, query._path, false);
        const newParams = $da38ac6aa733c404$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value lesss than or equal
 * to the specified value and a a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $da38ac6aa733c404$export$57203950645b8b11(value, key) {
    $da38ac6aa733c404$var$validateKey("endBefore", "key", key, true);
    return new $da38ac6aa733c404$var$QueryEndBeforeConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryStartAtConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg("startAt", this._value, query._path, true);
        const newParams = $da38ac6aa733c404$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $da38ac6aa733c404$export$859941c5fc8eba6b(value = null, key) {
    $da38ac6aa733c404$var$validateKey("startAt", "key", key, true);
    return new $da38ac6aa733c404$var$QueryStartAtConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryStartAfterConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg("startAfter", this._value, query._path, false);
        const newParams = $da38ac6aa733c404$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $da38ac6aa733c404$export$dd8dee5f7b804673(value, key) {
    $da38ac6aa733c404$var$validateKey("startAfter", "key", key, true);
    return new $da38ac6aa733c404$var$QueryStartAfterConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryLimitToFirstConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, $da38ac6aa733c404$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $da38ac6aa733c404$export$9d02e839f813b99d(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToFirst: First argument must be a positive integer.");
    return new $da38ac6aa733c404$var$QueryLimitToFirstConstraint(limit);
}
class $da38ac6aa733c404$var$QueryLimitToLastConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, $da38ac6aa733c404$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $da38ac6aa733c404$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) throw new Error("limitToLast: First argument must be a positive integer.");
    return new $da38ac6aa733c404$var$QueryLimitToLastConstraint(limit);
}
class $da38ac6aa733c404$var$QueryOrderByChildConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, "orderByChild");
        const parsedPath = new $da38ac6aa733c404$var$Path(this._path);
        if ($da38ac6aa733c404$var$pathIsEmpty(parsedPath)) throw new Error("orderByChild: cannot pass in empty path. Use orderByValue() instead.");
        const index = new $da38ac6aa733c404$var$PathIndex(parsedPath);
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, index);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $da38ac6aa733c404$export$5162bd9025f8e144(path) {
    if (path === "$key") throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === "$priority") throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === "$value") throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $da38ac6aa733c404$export$8637b026ace8abb1("orderByChild", "path", path, false);
    return new $da38ac6aa733c404$var$QueryOrderByChildConstraint(path);
}
class $da38ac6aa733c404$var$QueryOrderByKeyConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, "orderByKey");
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$KEY_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $da38ac6aa733c404$export$d5ab8b3bbd8afbf8() {
    return new $da38ac6aa733c404$var$QueryOrderByKeyConstraint();
}
class $da38ac6aa733c404$var$QueryOrderByPriorityConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, "orderByPriority");
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$PRIORITY_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $da38ac6aa733c404$export$19e8ae5500cf2e55() {
    return new $da38ac6aa733c404$var$QueryOrderByPriorityConstraint();
}
class $da38ac6aa733c404$var$QueryOrderByValueConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, "orderByValue");
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$VALUE_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $da38ac6aa733c404$export$7f2f62793c39d0c0() {
    return new $da38ac6aa733c404$var$QueryOrderByValueConstraint();
}
class $da38ac6aa733c404$var$QueryEqualToValueConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg("equalTo", this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $da38ac6aa733c404$var$QueryEndAtConstraint(this._value, this._key)._apply(new $da38ac6aa733c404$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $da38ac6aa733c404$export$bdcdec1f91f16dff(value, key) {
    $da38ac6aa733c404$var$validateKey("equalTo", "key", key, true);
    return new $da38ac6aa733c404$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $da38ac6aa733c404$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $da38ac6aa733c404$var$syncPointSetReferenceConstructor($da38ac6aa733c404$export$35c3a5e7c9d1033c);
$da38ac6aa733c404$var$syncTreeSetReferenceConstructor($da38ac6aa733c404$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $da38ac6aa733c404$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = "FIREBASE_DATABASE_EMULATOR_HOST";
/**
 * Creates and caches `Repo` instances.
 */ const $da38ac6aa733c404$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $da38ac6aa733c404$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $da38ac6aa733c404$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $da38ac6aa733c404$var$RepoInfo(`${host}:${port}`, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $da38ac6aa733c404$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $da38ac6aa733c404$var$log("Using default host for project ", app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $da38ac6aa733c404$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (typeof $hPtJY !== "undefined" && $hPtJY.env) dbEmulatorHost = $hPtJY.env[$da38ac6aa733c404$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $da38ac6aa733c404$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $da38ac6aa733c404$var$EmulatorTokenProvider($da38ac6aa733c404$var$EmulatorTokenProvider.OWNER) : new $da38ac6aa733c404$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $da38ac6aa733c404$var$validateUrl("Invalid Firebase Database URL", parsedUrl);
    if (!$da38ac6aa733c404$var$pathIsEmpty(parsedUrl.path)) $da38ac6aa733c404$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $da38ac6aa733c404$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $da38ac6aa733c404$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $da38ac6aa733c404$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $da38ac6aa733c404$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $da38ac6aa733c404$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $da38ac6aa733c404$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $da38ac6aa733c404$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $da38ac6aa733c404$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $da38ac6aa733c404$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $da38ac6aa733c404$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $da38ac6aa733c404$var$fatal("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.");
    repo = new $da38ac6aa733c404$var$Repo(repoInfo, $da38ac6aa733c404$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $da38ac6aa733c404$var$repoManagerForceRestClient(forceRestClient) {
    $da38ac6aa733c404$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $da38ac6aa733c404$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this["type"] = "database";
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $da38ac6aa733c404$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options["databaseAuthVariableOverride"]);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, $da38ac6aa733c404$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $da38ac6aa733c404$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $da38ac6aa733c404$var$fatal("Cannot call " + apiName + " on a deleted database.");
    }
}
function $da38ac6aa733c404$var$checkTransportInit() {
    if ($da38ac6aa733c404$var$TransportManager.IS_TRANSPORT_INITIALIZED) $da38ac6aa733c404$var$warn("Transport has already been initialized. Please call this function before calling ref or setting up a listener");
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $da38ac6aa733c404$export$752b38c15a5377b6() {
    $da38ac6aa733c404$var$checkTransportInit();
    $da38ac6aa733c404$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $da38ac6aa733c404$export$387cff57f2608869() {
    $da38ac6aa733c404$var$checkTransportInit();
    $da38ac6aa733c404$var$WebSocketConnection.forceDisallow();
    $da38ac6aa733c404$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated
 * with the provided {@link @firebase/app#FirebaseApp}. Initializes a new instance with
 * with default settings if no instance exists or if the existing instance uses
 * a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $da38ac6aa733c404$export$d0dd861204d0bf72(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), url) {
    return (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, "database").getImmediate({
        identifier: url
    });
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $da38ac6aa733c404$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("useEmulator");
    if (db._instanceStarted) $da38ac6aa733c404$var$fatal("Cannot call useEmulator() after instance has already been initialized.");
    const repo = db._repoInternal;
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $da38ac6aa733c404$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $da38ac6aa733c404$var$EmulatorTokenProvider($da38ac6aa733c404$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === "string" ? options.mockUserToken : (0, $c38e0f42709c826a$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $da38ac6aa733c404$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $da38ac6aa733c404$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $da38ac6aa733c404$export$bee838355d017f0a(db) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("goOffline");
    $da38ac6aa733c404$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $da38ac6aa733c404$export$e0eecaabee32dd(db) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted("goOnline");
    $da38ac6aa733c404$var$repoResume(db._repo);
}
function $da38ac6aa733c404$export$4e1d237eb9e560af(logger, persistent) {
    $da38ac6aa733c404$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$registerDatabase(variant) {
    $da38ac6aa733c404$export$c9fb972242fcb3c4((0, $57d436074e210fb5$export$31499a9cd224b78c));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("database", (container, { instanceIdentifier: url })=>{
        const app = container.getProvider("app").getImmediate();
        const authProvider = container.getProvider("auth-internal");
        const appCheckProvider = container.getProvider("app-check-internal");
        return $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* PUBLIC */ ).setMultipleInstances(true));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($da38ac6aa733c404$var$name, $da38ac6aa733c404$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($da38ac6aa733c404$var$name, $da38ac6aa733c404$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$SERVER_TIMESTAMP = {
    ".sv": "timestamp"
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $da38ac6aa733c404$export$3ff8e7e00c3264b7() {
    return $da38ac6aa733c404$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $da38ac6aa733c404$export$a2647aa13413c947(delta) {
    return {
        ".sv": {
            "increment": delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $da38ac6aa733c404$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $da38ac6aa733c404$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e("Reference.transaction", ref._path);
    if (ref.key === ".length" || ref.key === ".keys") throw "Reference.transaction failed: " + ref.key + " is a read-only object.";
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $da38ac6aa733c404$export$80b98bcbc246c942(node, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(ref._repo, ref._path), $da38ac6aa733c404$var$PRIORITY_INDEX);
            deferred.resolve(new $da38ac6aa733c404$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $da38ac6aa733c404$export$ad30f661f41f4d90(ref, ()=>{});
    $da38ac6aa733c404$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $da38ac6aa733c404$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$da38ac6aa733c404$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest("q", {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$da38ac6aa733c404$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest("echo", {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$da38ac6aa733c404$var$Connection;
/**
 * @internal
 */ const $da38ac6aa733c404$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $da38ac6aa733c404$var$PersistentConnection.prototype.put;
    $da38ac6aa733c404$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $da38ac6aa733c404$var$PersistentConnection.prototype.put = oldPut;
    };
};
$da38ac6aa733c404$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $da38ac6aa733c404$export$868c9f20a76f0839 = function(forceRestClient) {
    $da38ac6aa733c404$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $da38ac6aa733c404$var$registerDatabase();




const $2c3f85fdcab9a2ed$var$name = "@firebase/database-compat";
const $2c3f85fdcab9a2ed$var$version = "0.2.1";
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2c3f85fdcab9a2ed$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/database-compat");
const $2c3f85fdcab9a2ed$var$warn = function(msg) {
    const message = "FIREBASE WARNING: " + msg;
    $2c3f85fdcab9a2ed$var$logClient.warn(message);
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2c3f85fdcab9a2ed$var$validateBoolean = function(fnName, argumentName, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== "boolean") throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, argumentName) + "must be a boolean.");
};
const $2c3f85fdcab9a2ed$var$validateEventType = function(fnName, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch(eventType){
        case "value":
        case "child_added":
        case "child_removed":
        case "child_changed":
        case "child_moved":
            break;
        default:
            throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, "eventType") + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2c3f85fdcab9a2ed$var$OnDisconnect {
    constructor(_delegate){
        this._delegate = _delegate;
    }
    cancel(onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("OnDisconnect.cancel", 0, 1, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("OnDisconnect.cancel", "onComplete", onComplete, true);
        const result = this._delegate.cancel();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("OnDisconnect.remove", 0, 1, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("OnDisconnect.remove", "onComplete", onComplete, true);
        const result = this._delegate.remove();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    set(value, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("OnDisconnect.set", 1, 2, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("OnDisconnect.set", "onComplete", onComplete, true);
        const result = this._delegate.set(value);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(value, priority, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("OnDisconnect.setWithPriority", 2, 3, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("OnDisconnect.setWithPriority", "onComplete", onComplete, true);
        const result = this._delegate.setWithPriority(value, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(objectToMerge, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("OnDisconnect.update", 1, 2, arguments.length);
        if (Array.isArray(objectToMerge)) {
            const newObjectToMerge = {};
            for(let i = 0; i < objectToMerge.length; ++i)newObjectToMerge["" + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $2c3f85fdcab9a2ed$var$warn("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("OnDisconnect.update", "onComplete", onComplete, true);
        const result = this._delegate.update(objectToMerge);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2c3f85fdcab9a2ed$var$TransactionResult {
    /**
     * A type for the resolve value of Firebase.transaction.
     */ constructor(committed, snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("TransactionResult.toJSON", 0, 1, arguments.length);
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */ class $2c3f85fdcab9a2ed$var$DataSnapshot {
    constructor(_database, _delegate){
        this._database = _database;
        this._delegate = _delegate;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ val() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.val", 0, 0, arguments.length);
        return this._delegate.val();
    }
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ exportVal() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.exportVal", 0, 0, arguments.length);
        return this._delegate.exportVal();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.toJSON", 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @returns Whether the snapshot contains a non-null value, or is empty.
     */ exists() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.exists", 0, 0, arguments.length);
        return this._delegate.exists();
    }
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param path - Path to a child.
     * @returns DataSnapshot for child node.
     */ child(path) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.child", 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        path = String(path);
        (0, $da38ac6aa733c404$export$8637b026ace8abb1)("DataSnapshot.child", "path", path, false);
        return new $2c3f85fdcab9a2ed$var$DataSnapshot(this._database, this._delegate.child(path));
    }
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param path - Path to a child.
     * @returns Whether the child exists.
     */ hasChild(path) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.hasChild", 1, 1, arguments.length);
        (0, $da38ac6aa733c404$export$8637b026ace8abb1)("DataSnapshot.hasChild", "path", path, false);
        return this._delegate.hasChild(path);
    }
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @returns The priority.
     */ getPriority() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.getPriority", 0, 0, arguments.length);
        return this._delegate.priority;
    }
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param action - Callback function to be called
     * for each child.
     * @returns True if forEach was canceled by action returning true for
     * one of the child nodes.
     */ forEach(action) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.forEach", 1, 1, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("DataSnapshot.forEach", "action", action, false);
        return this._delegate.forEach((expDataSnapshot)=>action(new $2c3f85fdcab9a2ed$var$DataSnapshot(this._database, expDataSnapshot)));
    }
    /**
     * Returns whether this DataSnapshot has children.
     * @returns True if the DataSnapshot contains 1 or more child nodes.
     */ hasChildren() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.hasChildren", 0, 0, arguments.length);
        return this._delegate.hasChildren();
    }
    get key() {
        return this._delegate.key;
    }
    /**
     * Returns the number of children for this DataSnapshot.
     * @returns The number of children that this DataSnapshot contains.
     */ numChildren() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.numChildren", 0, 0, arguments.length);
        return this._delegate.size;
    }
    /**
     * @returns The Firebase reference for the location this snapshot's data came
     * from.
     */ getRef() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("DataSnapshot.ref", 0, 0, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Reference(this._database, this._delegate.ref);
    }
    get ref() {
        return this.getRef();
    }
}
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */ class $2c3f85fdcab9a2ed$var$Query {
    constructor(database, _delegate){
        this.database = database;
        this._delegate = _delegate;
    }
    on(eventType, callback, cancelCallbackOrContext, context) {
        var _a;
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.on", 2, 4, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Query.on", "callback", callback, false);
        const ret = $2c3f85fdcab9a2ed$var$Query.getCancelAndContextArgs_("Query.on", cancelCallbackOrContext, context);
        const valueCallback = (expSnapshot, previousChildName)=>{
            callback.call(ret.context, new $2c3f85fdcab9a2ed$var$DataSnapshot(this.database, expSnapshot), previousChildName);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = (_a = ret.cancel) === null || _a === void 0 ? void 0 : _a.bind(ret.context);
        switch(eventType){
            case "value":
                (0, $da38ac6aa733c404$export$ad30f661f41f4d90)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_added":
                (0, $da38ac6aa733c404$export$fdc3e67b2775c753)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_removed":
                (0, $da38ac6aa733c404$export$8362b530316d1aba)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_changed":
                (0, $da38ac6aa733c404$export$a3fdf31223dcb03)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case "child_moved":
                (0, $da38ac6aa733c404$export$1b001b15904d2a7f)(this._delegate, valueCallback, cancelCallback);
                return callback;
            default:
                throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)("Query.on", "eventType") + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
    }
    off(eventType, callback, context) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.off", 0, 3, arguments.length);
        $2c3f85fdcab9a2ed$var$validateEventType("Query.off", eventType, true);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Query.off", "callback", callback, true);
        (0, $c38e0f42709c826a$export$df77539402cfb523)("Query.off", "context", context, true);
        if (callback) {
            const valueCallback = ()=>{};
            valueCallback.userCallback = callback;
            valueCallback.context = context;
            (0, $da38ac6aa733c404$export$8c8705df4a2dcec9)(this._delegate, eventType, valueCallback);
        } else (0, $da38ac6aa733c404$export$8c8705df4a2dcec9)(this._delegate, eventType);
    }
    /**
     * Get the server-value for this query, or return a cached value if not connected.
     */ get() {
        return (0, $da38ac6aa733c404$export$3988ae62b71be9a3)(this._delegate).then((expSnapshot)=>{
            return new $2c3f85fdcab9a2ed$var$DataSnapshot(this.database, expSnapshot);
        });
    }
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     */ once(eventType, callback, failureCallbackOrContext, context) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.once", 1, 4, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Query.once", "callback", callback, true);
        const ret = $2c3f85fdcab9a2ed$var$Query.getCancelAndContextArgs_("Query.once", failureCallbackOrContext, context);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        const valueCallback = (expSnapshot, previousChildName)=>{
            const result = new $2c3f85fdcab9a2ed$var$DataSnapshot(this.database, expSnapshot);
            if (callback) callback.call(ret.context, result, previousChildName);
            deferred.resolve(result);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = (error)=>{
            if (ret.cancel) ret.cancel.call(ret.context, error);
            deferred.reject(error);
        };
        switch(eventType){
            case "value":
                (0, $da38ac6aa733c404$export$ad30f661f41f4d90)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_added":
                (0, $da38ac6aa733c404$export$fdc3e67b2775c753)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_removed":
                (0, $da38ac6aa733c404$export$8362b530316d1aba)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_changed":
                (0, $da38ac6aa733c404$export$a3fdf31223dcb03)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case "child_moved":
                (0, $da38ac6aa733c404$export$1b001b15904d2a7f)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            default:
                throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)("Query.once", "eventType") + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
        return deferred.promise;
    }
    /**
     * Set a limit and anchor it to the start of the window.
     */ limitToFirst(limit) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.limitToFirst", 1, 1, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$9d02e839f813b99d)(limit)));
    }
    /**
     * Set a limit and anchor it to the end of the window.
     */ limitToLast(limit) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.limitToLast", 1, 1, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$f823b3589f69d3b8)(limit)));
    }
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     */ orderByChild(path) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.orderByChild", 1, 1, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$5162bd9025f8e144)(path)));
    }
    /**
     * Return a new query ordered by the KeyIndex
     */ orderByKey() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.orderByKey", 0, 0, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$d5ab8b3bbd8afbf8)()));
    }
    /**
     * Return a new query ordered by the PriorityIndex
     */ orderByPriority() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.orderByPriority", 0, 0, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$19e8ae5500cf2e55)()));
    }
    /**
     * Return a new query ordered by the ValueIndex
     */ orderByValue() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.orderByValue", 0, 0, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$7f2f62793c39d0c0)()));
    }
    startAt(value = null, name) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.startAt", 0, 2, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$859941c5fc8eba6b)(value, name)));
    }
    startAfter(value = null, name) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.startAfter", 0, 2, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$dd8dee5f7b804673)(value, name)));
    }
    endAt(value = null, name) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.endAt", 0, 2, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$28ec54a8428bdb3f)(value, name)));
    }
    endBefore(value = null, name) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.endBefore", 0, 2, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$57203950645b8b11)(value, name)));
    }
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     */ equalTo(value, name) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.equalTo", 1, 2, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Query(this.database, (0, $da38ac6aa733c404$export$2fa187e846a241c4)(this._delegate, (0, $da38ac6aa733c404$export$bdcdec1f91f16dff)(value, name)));
    }
    /**
     * @returns URL for this location.
     */ toString() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.toString", 0, 0, arguments.length);
        return this._delegate.toString();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    toJSON() {
        // An optional spacer argument is unnecessary for a string.
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.toJSON", 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     */ isEqual(other) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Query.isEqual", 1, 1, arguments.length);
        if (!(other instanceof $2c3f85fdcab9a2ed$var$Query)) {
            const error = "Query.isEqual failed: First argument must be an instance of firebase.database.Query.";
            throw new Error(error);
        }
        return this._delegate.isEqual(other._delegate);
    }
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param fnName - The function name (on or once)
     *
     */ static getCancelAndContextArgs_(fnName, cancelOrContext, context) {
        const ret = {
            cancel: undefined,
            context: undefined
        };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)(fnName, "cancel", ret.cancel, true);
            ret.context = context;
            (0, $c38e0f42709c826a$export$df77539402cfb523)(fnName, "context", ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === "object" && cancelOrContext !== null) // it's a context!
            ret.context = cancelOrContext;
            else if (typeof cancelOrContext === "function") ret.cancel = cancelOrContext;
            else throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, "cancelOrContext") + " must either be a cancel callback or a context object.");
        }
        return ret;
    }
    get ref() {
        return new $2c3f85fdcab9a2ed$var$Reference(this.database, new (0, $da38ac6aa733c404$export$35c3a5e7c9d1033c)(this._delegate._repo, this._delegate._path));
    }
}
class $2c3f85fdcab9a2ed$var$Reference extends $2c3f85fdcab9a2ed$var$Query {
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     */ constructor(database, _delegate){
        super(database, new (0, $da38ac6aa733c404$export$e79c8d837d2220a8)(_delegate._repo, _delegate._path, new (0, $da38ac6aa733c404$export$7ba287e361c94330)(), false));
        this.database = database;
        this._delegate = _delegate;
    }
    /** @returns {?string} */ getKey() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.key", 0, 0, arguments.length);
        return this._delegate.key;
    }
    child(pathString) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.child", 1, 1, arguments.length);
        if (typeof pathString === "number") pathString = String(pathString);
        return new $2c3f85fdcab9a2ed$var$Reference(this.database, (0, $da38ac6aa733c404$export$f9574b70e1d95d9d)(this._delegate, pathString));
    }
    /** @returns {?Reference} */ getParent() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.parent", 0, 0, arguments.length);
        const parent = this._delegate.parent;
        return parent ? new $2c3f85fdcab9a2ed$var$Reference(this.database, parent) : null;
    }
    /** @returns {!Reference} */ getRoot() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.root", 0, 0, arguments.length);
        return new $2c3f85fdcab9a2ed$var$Reference(this.database, this._delegate.root);
    }
    set(newVal, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.set", 1, 2, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.set", "onComplete", onComplete, true);
        const result = (0, $da38ac6aa733c404$export$adaa4cf7ef1b65be)(this._delegate, newVal);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(values, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.update", 1, 2, arguments.length);
        if (Array.isArray(values)) {
            const newObjectToMerge = {};
            for(let i = 0; i < values.length; ++i)newObjectToMerge["" + i] = values[i];
            values = newObjectToMerge;
            $2c3f85fdcab9a2ed$var$warn("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $da38ac6aa733c404$export$8d83036122ae444e)("Reference.update", this._delegate._path);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.update", "onComplete", onComplete, true);
        const result = (0, $da38ac6aa733c404$export$722fbec263ad908a)(this._delegate, values);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(newVal, newPriority, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.setWithPriority", 2, 3, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.setWithPriority", "onComplete", onComplete, true);
        const result = (0, $da38ac6aa733c404$export$1fa5d5bf488088f3)(this._delegate, newVal, newPriority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.remove", 0, 1, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.remove", "onComplete", onComplete, true);
        const result = (0, $da38ac6aa733c404$export$cd7f480d6b8286c3)(this._delegate);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    transaction(transactionUpdate, onComplete, applyLocally) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.transaction", 1, 3, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.transaction", "transactionUpdate", transactionUpdate, false);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.transaction", "onComplete", onComplete, true);
        $2c3f85fdcab9a2ed$var$validateBoolean("Reference.transaction", "applyLocally", applyLocally, true);
        const result = (0, $da38ac6aa733c404$export$3c54e006bf9c93b7)(this._delegate, transactionUpdate, {
            applyLocally: applyLocally
        }).then((transactionResult)=>new $2c3f85fdcab9a2ed$var$TransactionResult(transactionResult.committed, new $2c3f85fdcab9a2ed$var$DataSnapshot(this.database, transactionResult.snapshot)));
        if (onComplete) result.then((transactionResult)=>onComplete(null, transactionResult.committed, transactionResult.snapshot), (error)=>onComplete(error, false, null));
        return result;
    }
    setPriority(priority, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.setPriority", 1, 2, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.setPriority", "onComplete", onComplete, true);
        const result = (0, $da38ac6aa733c404$export$313bf5dbe7a1196e)(this._delegate, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    push(value, onComplete) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("Reference.push", 0, 2, arguments.length);
        (0, $c38e0f42709c826a$export$5bcd2a2eb6640dfa)("Reference.push", "onComplete", onComplete, true);
        const expPromise = (0, $da38ac6aa733c404$export$4cbf152802aa238)(this._delegate, value);
        const promise = expPromise.then((expRef)=>new $2c3f85fdcab9a2ed$var$Reference(this.database, expRef));
        if (onComplete) promise.then(()=>onComplete(null), (error)=>onComplete(error));
        const result = new $2c3f85fdcab9a2ed$var$Reference(this.database, expPromise);
        result.then = promise.then.bind(promise);
        result.catch = promise.catch.bind(promise, undefined);
        return result;
    }
    onDisconnect() {
        (0, $da38ac6aa733c404$export$8d83036122ae444e)("Reference.onDisconnect", this._delegate._path);
        return new $2c3f85fdcab9a2ed$var$OnDisconnect(new (0, $da38ac6aa733c404$export$95b7818b4ee6c2af)(this._delegate._repo, this._delegate._path));
    }
    get key() {
        return this.getKey();
    }
    get parent() {
        return this.getParent();
    }
    get root() {
        return this.getRoot();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase database.
 */ class $2c3f85fdcab9a2ed$var$Database {
    /**
     * The constructor should not be called by users of our public API.
     */ constructor(_delegate, app){
        this._delegate = _delegate;
        this.app = app;
        this.INTERNAL = {
            delete: ()=>this._delegate._delete(),
            forceWebSockets: $da38ac6aa733c404$export$752b38c15a5377b6,
            forceLongPolling: $da38ac6aa733c404$export$387cff57f2608869
        };
    }
    /**
     * Modify this instance to communicate with the Realtime Database emulator.
     *
     * <p>Note: This method must be called before performing any other operation.
     *
     * @param host - the emulator host (ex: localhost)
     * @param port - the emulator port (ex: 8080)
     * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
     */ useEmulator(host, port, options = {}) {
        (0, $da38ac6aa733c404$export$87f3cfc4a2e3958d)(this._delegate, host, port, options);
    }
    ref(path) {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("database.ref", 0, 1, arguments.length);
        if (path instanceof $2c3f85fdcab9a2ed$var$Reference) {
            const childRef = (0, $da38ac6aa733c404$export$291fc3c05735451)(this._delegate, path.toString());
            return new $2c3f85fdcab9a2ed$var$Reference(this, childRef);
        } else {
            const childRef = (0, $da38ac6aa733c404$export$eff4d24c3ff7876e)(this._delegate, path);
            return new $2c3f85fdcab9a2ed$var$Reference(this, childRef);
        }
    }
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @returns Firebase reference.
     */ refFromURL(url) {
        const apiName = "database.refFromURL";
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)(apiName, 1, 1, arguments.length);
        const childRef = (0, $da38ac6aa733c404$export$291fc3c05735451)(this._delegate, url);
        return new $2c3f85fdcab9a2ed$var$Reference(this, childRef);
    }
    // Make individual repo go offline.
    goOffline() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("database.goOffline", 0, 0, arguments.length);
        return (0, $da38ac6aa733c404$export$bee838355d017f0a)(this._delegate);
    }
    goOnline() {
        (0, $c38e0f42709c826a$export$20164226a0ed35c3)("database.goOnline", 0, 0, arguments.length);
        return (0, $da38ac6aa733c404$export$e0eecaabee32dd)(this._delegate);
    }
}
$2c3f85fdcab9a2ed$var$Database.ServerValue = {
    TIMESTAMP: (0, $da38ac6aa733c404$export$3ff8e7e00c3264b7)(),
    increment: (delta)=>(0, $da38ac6aa733c404$export$a2647aa13413c947)(delta)
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 *
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAuthImpl - custom auth implementation
 */ function $2c3f85fdcab9a2ed$var$initStandalone({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, namespace: namespace, nodeAdmin: nodeAdmin = false }) {
    (0, $da38ac6aa733c404$export$c9fb972242fcb3c4)(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const authProvider = new (0, $a83e7ccd68ca8d4e$export$2881499e37b75b9a)("auth-internal", new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)("database-standalone"));
    authProvider.setComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth-internal", ()=>customAuthImpl, "PRIVATE" /* PRIVATE */ ));
    return {
        instance: new $2c3f85fdcab9a2ed$var$Database((0, $da38ac6aa733c404$export$a248c1d2ea757674)(app, authProvider, /* appCheckProvider= */ undefined, url, nodeAdmin), app),
        namespace: namespace
    };
}
var $2c3f85fdcab9a2ed$var$INTERNAL = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    initStandalone: $2c3f85fdcab9a2ed$var$initStandalone
});
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2c3f85fdcab9a2ed$var$ServerValue = $2c3f85fdcab9a2ed$var$Database.ServerValue;
function $2c3f85fdcab9a2ed$export$44894f2caba7dc4c(instance) {
    // Register the Database Service with the 'firebase' namespace.
    instance.INTERNAL.registerComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("database-compat", (container, { instanceIdentifier: url })=>{
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider("app-compat").getImmediate();
        const databaseExp = container.getProvider("database").getImmediate({
            identifier: url
        });
        return new $2c3f85fdcab9a2ed$var$Database(databaseExp, app);
    }, "PUBLIC" /* PUBLIC */ ).setServiceProps(// firebase.database namespace properties
    {
        Reference: $2c3f85fdcab9a2ed$var$Reference,
        Query: $2c3f85fdcab9a2ed$var$Query,
        Database: $2c3f85fdcab9a2ed$var$Database,
        DataSnapshot: $2c3f85fdcab9a2ed$var$DataSnapshot,
        enableLogging: $da38ac6aa733c404$export$4e1d237eb9e560af,
        INTERNAL: $2c3f85fdcab9a2ed$var$INTERNAL,
        ServerValue: $2c3f85fdcab9a2ed$var$ServerValue
    }).setMultipleInstances(true));
    instance.registerVersion($2c3f85fdcab9a2ed$var$name, $2c3f85fdcab9a2ed$var$version);
}
$2c3f85fdcab9a2ed$export$44894f2caba7dc4c((0, $62abbf54969a34e0$export$2e2bcd8739ae039));








const $a0e6674a3bfddddb$var$name = "@firebase/firestore-compat";
const $a0e6674a3bfddddb$var$version = "0.1.19";
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0e6674a3bfddddb$var$validateSetOptions(methodName, options) {
    if (options === undefined) return {
        merge: false
    };
    if (options.mergeFields !== undefined && options.merge !== undefined) throw new (0, $70fd6868680e912c$export$8fada0bf726bf278)("invalid-argument", `Invalid options passed to function ${methodName}(): You cannot ` + 'specify both "merge" and "mergeFields".');
    return options;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Helper function to assert Uint8Array is available at runtime. */ function $a0e6674a3bfddddb$var$assertUint8ArrayAvailable() {
    if (typeof Uint8Array === "undefined") throw new (0, $70fd6868680e912c$export$8fada0bf726bf278)("unimplemented", "Uint8Arrays are not available in this environment.");
}
/** Helper function to assert Base64 functions are available at runtime. */ function $a0e6674a3bfddddb$var$assertBase64Available() {
    if (!(0, $70fd6868680e912c$export$cbfc1605afde699b)()) throw new (0, $70fd6868680e912c$export$8fada0bf726bf278)("unimplemented", "Blobs are unavailable in Firestore in this environment.");
}
/** Immutable class holding a blob (binary data) */ class $a0e6674a3bfddddb$var$Blob {
    constructor(_delegate){
        this._delegate = _delegate;
    }
    static fromBase64String(base64) {
        $a0e6674a3bfddddb$var$assertBase64Available();
        return new $a0e6674a3bfddddb$var$Blob((0, $70fd6868680e912c$export$9f55f2e2bf8c2fc1).fromBase64String(base64));
    }
    static fromUint8Array(array) {
        $a0e6674a3bfddddb$var$assertUint8ArrayAvailable();
        return new $a0e6674a3bfddddb$var$Blob((0, $70fd6868680e912c$export$9f55f2e2bf8c2fc1).fromUint8Array(array));
    }
    toBase64() {
        $a0e6674a3bfddddb$var$assertBase64Available();
        return this._delegate.toBase64();
    }
    toUint8Array() {
        $a0e6674a3bfddddb$var$assertUint8ArrayAvailable();
        return this._delegate.toUint8Array();
    }
    isEqual(other) {
        return this._delegate.isEqual(other._delegate);
    }
    toString() {
        return "Blob(base64: " + this.toBase64() + ")";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0e6674a3bfddddb$var$isPartialObserver(obj) {
    return $a0e6674a3bfddddb$var$implementsAnyMethods(obj, [
        "next",
        "error",
        "complete"
    ]);
}
/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ function $a0e6674a3bfddddb$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    const object = obj;
    for (const method of methods){
        if (method in object && typeof object[method] === "function") return true;
    }
    return false;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The persistence provider included with the full Firestore SDK.
 */ class $a0e6674a3bfddddb$var$IndexedDbPersistenceProvider {
    enableIndexedDbPersistence(firestore, forceOwnership) {
        return (0, $70fd6868680e912c$export$cebe3b626a79c5f3)(firestore._delegate, {
            forceOwnership: forceOwnership
        });
    }
    enableMultiTabIndexedDbPersistence(firestore) {
        return (0, $70fd6868680e912c$export$6d4c055e91302ab9)(firestore._delegate);
    }
    clearIndexedDbPersistence(firestore) {
        return (0, $70fd6868680e912c$export$b4f5899b4e28cf7b)(firestore._delegate);
    }
}
/**
 * Compat class for Firestore. Exposes Firestore Legacy API, but delegates
 * to the functional API of firestore-exp.
 */ class $a0e6674a3bfddddb$var$Firestore {
    constructor(databaseIdOrApp, _delegate, _persistenceProvider){
        this._delegate = _delegate;
        this._persistenceProvider = _persistenceProvider;
        this.INTERNAL = {
            delete: ()=>this.terminate()
        };
        if (!(databaseIdOrApp instanceof (0, $70fd6868680e912c$export$4c3ccc07620ae30a))) this._appCompat = databaseIdOrApp;
    }
    get _databaseId() {
        return this._delegate._databaseId;
    }
    settings(settingsLiteral) {
        const currentSettings = this._delegate._getSettings();
        if (!settingsLiteral.merge && currentSettings.host !== settingsLiteral.host) (0, $70fd6868680e912c$export$86cd73f49cc6e0bb)("You are overriding the original host. If you did not intend to override your settings, use {merge: true}.");
        if (settingsLiteral.merge) {
            settingsLiteral = Object.assign(Object.assign({}, currentSettings), settingsLiteral);
            // Remove the property from the settings once the merge is completed
            delete settingsLiteral.merge;
        }
        this._delegate._setSettings(settingsLiteral);
    }
    useEmulator(host, port, options = {}) {
        (0, $70fd6868680e912c$export$966a03d25297d115)(this._delegate, host, port, options);
    }
    enableNetwork() {
        return (0, $70fd6868680e912c$export$ee6bdee8287ecc5f)(this._delegate);
    }
    disableNetwork() {
        return (0, $70fd6868680e912c$export$f35b708ad73d52eb)(this._delegate);
    }
    enablePersistence(settings) {
        let synchronizeTabs = false;
        let experimentalForceOwningTab = false;
        if (settings) {
            synchronizeTabs = !!settings.synchronizeTabs;
            experimentalForceOwningTab = !!settings.experimentalForceOwningTab;
            (0, $70fd6868680e912c$export$8731e8d1617cddb1)("synchronizeTabs", synchronizeTabs, "experimentalForceOwningTab", experimentalForceOwningTab);
        }
        return synchronizeTabs ? this._persistenceProvider.enableMultiTabIndexedDbPersistence(this) : this._persistenceProvider.enableIndexedDbPersistence(this, experimentalForceOwningTab);
    }
    clearPersistence() {
        return this._persistenceProvider.clearIndexedDbPersistence(this);
    }
    terminate() {
        if (this._appCompat) {
            this._appCompat._removeServiceInstance("firestore-compat");
            this._appCompat._removeServiceInstance("firestore");
        }
        return this._delegate._delete();
    }
    waitForPendingWrites() {
        return (0, $70fd6868680e912c$export$50b5113fd6653025)(this._delegate);
    }
    onSnapshotsInSync(arg) {
        return (0, $70fd6868680e912c$export$9dff4f5aba83e348)(this._delegate, arg);
    }
    get app() {
        if (!this._appCompat) throw new (0, $70fd6868680e912c$export$8fada0bf726bf278)("failed-precondition", "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._appCompat;
    }
    collection(pathString) {
        try {
            return new $a0e6674a3bfddddb$var$CollectionReference(this, (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this._delegate, pathString));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "collection()", "Firestore.collection()");
        }
    }
    doc(pathString) {
        try {
            return new $a0e6674a3bfddddb$var$DocumentReference(this, (0, $70fd6868680e912c$export$2a111da947c407d2)(this._delegate, pathString));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "doc()", "Firestore.doc()");
        }
    }
    collectionGroup(collectionId) {
        try {
            return new $a0e6674a3bfddddb$var$Query(this, (0, $70fd6868680e912c$export$473d82a73f88c107)(this._delegate, collectionId));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "collectionGroup()", "Firestore.collectionGroup()");
        }
    }
    runTransaction(updateFunction) {
        return (0, $70fd6868680e912c$export$3c54e006bf9c93b7)(this._delegate, (transaction)=>updateFunction(new $a0e6674a3bfddddb$var$Transaction(this, transaction)));
    }
    batch() {
        (0, $70fd6868680e912c$export$8da5fbea04405656)(this._delegate);
        return new $a0e6674a3bfddddb$var$WriteBatch(new (0, $70fd6868680e912c$export$d94ed661b1cfd435)(this._delegate, (mutations)=>(0, $70fd6868680e912c$export$1945f8fec9dda613)(this._delegate, mutations)));
    }
    loadBundle(bundleData) {
        return (0, $70fd6868680e912c$export$4b8b93c690c9810b)(this._delegate, bundleData);
    }
    namedQuery(name) {
        return (0, $70fd6868680e912c$export$169d2c6fe0f7f4ea)(this._delegate, name).then((expQuery)=>{
            if (!expQuery) return null;
            return new $a0e6674a3bfddddb$var$Query(this, // We can pass `expQuery` here directly since named queries don't have a UserDataConverter.
            // Otherwise, we would have to create a new ExpQuery and pass the old UserDataConverter.
            expQuery);
        });
    }
}
class $a0e6674a3bfddddb$var$UserDataWriter extends (0, $70fd6868680e912c$export$2cd31cfe6f6866e9) {
    constructor(firestore){
        super();
        this.firestore = firestore;
    }
    convertBytes(bytes) {
        return new $a0e6674a3bfddddb$var$Blob(new (0, $70fd6868680e912c$export$9f55f2e2bf8c2fc1)(bytes));
    }
    convertReference(name) {
        const key = this.convertDocumentKey(name, this.firestore._databaseId);
        return $a0e6674a3bfddddb$var$DocumentReference.forKey(key, this.firestore, /* converter= */ null);
    }
}
function $a0e6674a3bfddddb$var$setLogLevel(level) {
    (0, $70fd6868680e912c$export$c622e99c0ce7b1c9)(level);
}
/**
 * A reference to a transaction.
 */ class $a0e6674a3bfddddb$var$Transaction {
    constructor(_firestore, _delegate){
        this._firestore = _firestore;
        this._delegate = _delegate;
        this._userDataWriter = new $a0e6674a3bfddddb$var$UserDataWriter(_firestore);
    }
    get(documentRef) {
        const ref = $a0e6674a3bfddddb$var$castReference(documentRef);
        return this._delegate.get(ref).then((result)=>new $a0e6674a3bfddddb$var$DocumentSnapshot(this._firestore, new (0, $70fd6868680e912c$export$acab0e6ef25eb301)(this._firestore._delegate, this._userDataWriter, result._key, result._document, result.metadata, ref.converter)));
    }
    set(documentRef, data, options) {
        const ref = $a0e6674a3bfddddb$var$castReference(documentRef);
        if (options) {
            $a0e6674a3bfddddb$var$validateSetOptions("Transaction.set", options);
            this._delegate.set(ref, data, options);
        } else this._delegate.set(ref, data);
        return this;
    }
    update(documentRef, dataOrField, value, ...moreFieldsAndValues) {
        const ref = $a0e6674a3bfddddb$var$castReference(documentRef);
        if (arguments.length === 2) this._delegate.update(ref, dataOrField);
        else this._delegate.update(ref, dataOrField, value, ...moreFieldsAndValues);
        return this;
    }
    delete(documentRef) {
        const ref = $a0e6674a3bfddddb$var$castReference(documentRef);
        this._delegate.delete(ref);
        return this;
    }
}
class $a0e6674a3bfddddb$var$WriteBatch {
    constructor(_delegate){
        this._delegate = _delegate;
    }
    set(documentRef, data, options) {
        const ref = $a0e6674a3bfddddb$var$castReference(documentRef);
        if (options) {
            $a0e6674a3bfddddb$var$validateSetOptions("WriteBatch.set", options);
            this._delegate.set(ref, data, options);
        } else this._delegate.set(ref, data);
        return this;
    }
    update(documentRef, dataOrField, value, ...moreFieldsAndValues) {
        const ref = $a0e6674a3bfddddb$var$castReference(documentRef);
        if (arguments.length === 2) this._delegate.update(ref, dataOrField);
        else this._delegate.update(ref, dataOrField, value, ...moreFieldsAndValues);
        return this;
    }
    delete(documentRef) {
        const ref = $a0e6674a3bfddddb$var$castReference(documentRef);
        this._delegate.delete(ref);
        return this;
    }
    commit() {
        return this._delegate.commit();
    }
}
/**
 * Wraps a `PublicFirestoreDataConverter` translating the types from the
 * experimental SDK into corresponding types from the Classic SDK before passing
 * them to the wrapped converter.
 */ class $a0e6674a3bfddddb$var$FirestoreDataConverter {
    constructor(_firestore, _userDataWriter, _delegate){
        this._firestore = _firestore;
        this._userDataWriter = _userDataWriter;
        this._delegate = _delegate;
    }
    fromFirestore(snapshot, options) {
        const expSnapshot = new (0, $70fd6868680e912c$export$6d4d04e42af6b03c)(this._firestore._delegate, this._userDataWriter, snapshot._key, snapshot._document, snapshot.metadata, /* converter= */ null);
        return this._delegate.fromFirestore(new $a0e6674a3bfddddb$var$QueryDocumentSnapshot(this._firestore, expSnapshot), options !== null && options !== void 0 ? options : {});
    }
    toFirestore(modelObject, options) {
        if (!options) return this._delegate.toFirestore(modelObject);
        else return this._delegate.toFirestore(modelObject, options);
    }
    // Use the same instance of `FirestoreDataConverter` for the given instances
    // of `Firestore` and `PublicFirestoreDataConverter` so that isEqual() will
    // compare equal for two objects created with the same converter instance.
    static getInstance(firestore, converter) {
        const converterMapByFirestore = $a0e6674a3bfddddb$var$FirestoreDataConverter.INSTANCES;
        let untypedConverterByConverter = converterMapByFirestore.get(firestore);
        if (!untypedConverterByConverter) {
            untypedConverterByConverter = new WeakMap();
            converterMapByFirestore.set(firestore, untypedConverterByConverter);
        }
        let instance = untypedConverterByConverter.get(converter);
        if (!instance) {
            instance = new $a0e6674a3bfddddb$var$FirestoreDataConverter(firestore, new $a0e6674a3bfddddb$var$UserDataWriter(firestore), converter);
            untypedConverterByConverter.set(converter, instance);
        }
        return instance;
    }
}
$a0e6674a3bfddddb$var$FirestoreDataConverter.INSTANCES = new WeakMap();
/**
 * A reference to a particular document in a collection in the database.
 */ class $a0e6674a3bfddddb$var$DocumentReference {
    constructor(firestore, _delegate){
        this.firestore = firestore;
        this._delegate = _delegate;
        this._userDataWriter = new $a0e6674a3bfddddb$var$UserDataWriter(firestore);
    }
    static forPath(path, firestore, converter) {
        if (path.length % 2 !== 0) throw new (0, $70fd6868680e912c$export$8fada0bf726bf278)("invalid-argument", "Invalid document reference. Document references must have an even number of segments, but " + `${path.canonicalString()} has ${path.length}`);
        return new $a0e6674a3bfddddb$var$DocumentReference(firestore, new (0, $70fd6868680e912c$export$6be62b059fb12175)(firestore._delegate, converter, new (0, $70fd6868680e912c$export$afc2e57c475b7810)(path)));
    }
    static forKey(key, firestore, converter) {
        return new $a0e6674a3bfddddb$var$DocumentReference(firestore, new (0, $70fd6868680e912c$export$6be62b059fb12175)(firestore._delegate, converter, key));
    }
    get id() {
        return this._delegate.id;
    }
    get parent() {
        return new $a0e6674a3bfddddb$var$CollectionReference(this.firestore, this._delegate.parent);
    }
    get path() {
        return this._delegate.path;
    }
    collection(pathString) {
        try {
            return new $a0e6674a3bfddddb$var$CollectionReference(this.firestore, (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this._delegate, pathString));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "collection()", "DocumentReference.collection()");
        }
    }
    isEqual(other) {
        other = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof (0, $70fd6868680e912c$export$6be62b059fb12175))) return false;
        return (0, $70fd6868680e912c$export$62a32f2da6187d11)(this._delegate, other);
    }
    set(value, options) {
        options = $a0e6674a3bfddddb$var$validateSetOptions("DocumentReference.set", options);
        try {
            if (options) return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(this._delegate, value, options);
            else return (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(this._delegate, value);
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "setDoc()", "DocumentReference.set()");
        }
    }
    update(fieldOrUpdateData, value, ...moreFieldsAndValues) {
        try {
            if (arguments.length === 1) return (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(this._delegate, fieldOrUpdateData);
            else return (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(this._delegate, fieldOrUpdateData, value, ...moreFieldsAndValues);
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "updateDoc()", "DocumentReference.update()");
        }
    }
    delete() {
        return (0, $70fd6868680e912c$export$a4f20481fae8f78b)(this._delegate);
    }
    onSnapshot(...args) {
        const options = $a0e6674a3bfddddb$var$extractSnapshotOptions(args);
        const observer = $a0e6674a3bfddddb$var$wrapObserver(args, (result)=>new $a0e6674a3bfddddb$var$DocumentSnapshot(this.firestore, new (0, $70fd6868680e912c$export$acab0e6ef25eb301)(this.firestore._delegate, this._userDataWriter, result._key, result._document, result.metadata, this._delegate.converter)));
        return (0, $70fd6868680e912c$export$d36370812fb26935)(this._delegate, options, observer);
    }
    get(options) {
        let snap;
        if ((options === null || options === void 0 ? void 0 : options.source) === "cache") snap = (0, $70fd6868680e912c$export$a58bd92642f7fb58)(this._delegate);
        else if ((options === null || options === void 0 ? void 0 : options.source) === "server") snap = (0, $70fd6868680e912c$export$35dd759aed9686b4)(this._delegate);
        else snap = (0, $70fd6868680e912c$export$11eb3b5ef9574821)(this._delegate);
        return snap.then((result)=>new $a0e6674a3bfddddb$var$DocumentSnapshot(this.firestore, new (0, $70fd6868680e912c$export$acab0e6ef25eb301)(this.firestore._delegate, this._userDataWriter, result._key, result._document, result.metadata, this._delegate.converter)));
    }
    withConverter(converter) {
        return new $a0e6674a3bfddddb$var$DocumentReference(this.firestore, converter ? this._delegate.withConverter($a0e6674a3bfddddb$var$FirestoreDataConverter.getInstance(this.firestore, converter)) : this._delegate.withConverter(null));
    }
}
/**
 * Replaces the function name in an error thrown by the firestore-exp API
 * with the function names used in the classic API.
 */ function $a0e6674a3bfddddb$var$replaceFunctionName(e, original, updated) {
    e.message = e.message.replace(original, updated);
    return e;
}
/**
 * Iterates the list of arguments from an `onSnapshot` call and returns the
 * first argument that may be an `SnapshotListenOptions` object. Returns an
 * empty object if none is found.
 */ function $a0e6674a3bfddddb$var$extractSnapshotOptions(args) {
    for (const arg of args){
        if (typeof arg === "object" && !$a0e6674a3bfddddb$var$isPartialObserver(arg)) return arg;
    }
    return {};
}
/**
 * Creates an observer that can be passed to the firestore-exp SDK. The
 * observer converts all observed values into the format expected by the classic
 * SDK.
 *
 * @param args - The list of arguments from an `onSnapshot` call.
 * @param wrapper - The function that converts the firestore-exp type into the
 * type used by this shim.
 */ function $a0e6674a3bfddddb$var$wrapObserver(args, wrapper) {
    var _a, _b;
    let userObserver;
    if ($a0e6674a3bfddddb$var$isPartialObserver(args[0])) userObserver = args[0];
    else if ($a0e6674a3bfddddb$var$isPartialObserver(args[1])) userObserver = args[1];
    else if (typeof args[0] === "function") userObserver = {
        next: args[0],
        error: args[1],
        complete: args[2]
    };
    else userObserver = {
        next: args[1],
        error: args[2],
        complete: args[3]
    };
    return {
        next: (val)=>{
            if (userObserver.next) userObserver.next(wrapper(val));
        },
        error: (_a = userObserver.error) === null || _a === void 0 ? void 0 : _a.bind(userObserver),
        complete: (_b = userObserver.complete) === null || _b === void 0 ? void 0 : _b.bind(userObserver)
    };
}
class $a0e6674a3bfddddb$var$DocumentSnapshot {
    constructor(_firestore, _delegate){
        this._firestore = _firestore;
        this._delegate = _delegate;
    }
    get ref() {
        return new $a0e6674a3bfddddb$var$DocumentReference(this._firestore, this._delegate.ref);
    }
    get id() {
        return this._delegate.id;
    }
    get metadata() {
        return this._delegate.metadata;
    }
    get exists() {
        return this._delegate.exists();
    }
    data(options) {
        return this._delegate.data(options);
    }
    get(fieldPath, options) {
        return this._delegate.get(fieldPath, options);
    }
    isEqual(other) {
        return (0, $70fd6868680e912c$export$f243a5d948512846)(this._delegate, other._delegate);
    }
}
class $a0e6674a3bfddddb$var$QueryDocumentSnapshot extends $a0e6674a3bfddddb$var$DocumentSnapshot {
    data(options) {
        const data = this._delegate.data(options);
        (0, $70fd6868680e912c$export$1d2b90eea9bba017)(data !== undefined, "Document in a QueryDocumentSnapshot should exist");
        return data;
    }
}
class $a0e6674a3bfddddb$var$Query {
    constructor(firestore, _delegate){
        this.firestore = firestore;
        this._delegate = _delegate;
        this._userDataWriter = new $a0e6674a3bfddddb$var$UserDataWriter(firestore);
    }
    where(fieldPath, opStr, value) {
        try {
            // The "as string" cast is a little bit of a hack. `where` accepts the
            // FieldPath Compat type as input, but is not typed as such in order to
            // not expose this via our public typings file.
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$9c59b80dda569a6e)(fieldPath, opStr, value)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, /(orderBy|where)\(\)/, "Query.$1()");
        }
    }
    orderBy(fieldPath, directionStr) {
        try {
            // The "as string" cast is a little bit of a hack. `orderBy` accepts the
            // FieldPath Compat type as input, but is not typed as such in order to
            // not expose this via our public typings file.
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)(fieldPath, directionStr)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, /(orderBy|where)\(\)/, "Query.$1()");
        }
    }
    limit(n) {
        try {
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(n)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "limit()", "Query.limit()");
        }
    }
    limitToLast(n) {
        try {
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$f823b3589f69d3b8)(n)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "limitToLast()", "Query.limitToLast()");
        }
    }
    startAt(...args) {
        try {
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$859941c5fc8eba6b)(...args)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "startAt()", "Query.startAt()");
        }
    }
    startAfter(...args) {
        try {
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(...args)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "startAfter()", "Query.startAfter()");
        }
    }
    endBefore(...args) {
        try {
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$57203950645b8b11)(...args)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "endBefore()", "Query.endBefore()");
        }
    }
    endAt(...args) {
        try {
            return new $a0e6674a3bfddddb$var$Query(this.firestore, (0, $70fd6868680e912c$export$2fa187e846a241c4)(this._delegate, (0, $70fd6868680e912c$export$28ec54a8428bdb3f)(...args)));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "endAt()", "Query.endAt()");
        }
    }
    isEqual(other) {
        return (0, $70fd6868680e912c$export$49b1d0de6ba30f41)(this._delegate, other._delegate);
    }
    get(options) {
        let query;
        if ((options === null || options === void 0 ? void 0 : options.source) === "cache") query = (0, $70fd6868680e912c$export$3fd010f18eac1dd)(this._delegate);
        else if ((options === null || options === void 0 ? void 0 : options.source) === "server") query = (0, $70fd6868680e912c$export$ec7d9e44f349c77b)(this._delegate);
        else query = (0, $70fd6868680e912c$export$81d3477bd73c86ef)(this._delegate);
        return query.then((result)=>new $a0e6674a3bfddddb$var$QuerySnapshot(this.firestore, new (0, $70fd6868680e912c$export$8f21149d8133945c)(this.firestore._delegate, this._userDataWriter, this._delegate, result._snapshot)));
    }
    onSnapshot(...args) {
        const options = $a0e6674a3bfddddb$var$extractSnapshotOptions(args);
        const observer = $a0e6674a3bfddddb$var$wrapObserver(args, (snap)=>new $a0e6674a3bfddddb$var$QuerySnapshot(this.firestore, new (0, $70fd6868680e912c$export$8f21149d8133945c)(this.firestore._delegate, this._userDataWriter, this._delegate, snap._snapshot)));
        return (0, $70fd6868680e912c$export$d36370812fb26935)(this._delegate, options, observer);
    }
    withConverter(converter) {
        return new $a0e6674a3bfddddb$var$Query(this.firestore, converter ? this._delegate.withConverter($a0e6674a3bfddddb$var$FirestoreDataConverter.getInstance(this.firestore, converter)) : this._delegate.withConverter(null));
    }
}
class $a0e6674a3bfddddb$var$DocumentChange {
    constructor(_firestore, _delegate){
        this._firestore = _firestore;
        this._delegate = _delegate;
    }
    get type() {
        return this._delegate.type;
    }
    get doc() {
        return new $a0e6674a3bfddddb$var$QueryDocumentSnapshot(this._firestore, this._delegate.doc);
    }
    get oldIndex() {
        return this._delegate.oldIndex;
    }
    get newIndex() {
        return this._delegate.newIndex;
    }
}
class $a0e6674a3bfddddb$var$QuerySnapshot {
    constructor(_firestore, _delegate){
        this._firestore = _firestore;
        this._delegate = _delegate;
    }
    get query() {
        return new $a0e6674a3bfddddb$var$Query(this._firestore, this._delegate.query);
    }
    get metadata() {
        return this._delegate.metadata;
    }
    get size() {
        return this._delegate.size;
    }
    get empty() {
        return this._delegate.empty;
    }
    get docs() {
        return this._delegate.docs.map((doc)=>new $a0e6674a3bfddddb$var$QueryDocumentSnapshot(this._firestore, doc));
    }
    docChanges(options) {
        return this._delegate.docChanges(options).map((docChange)=>new $a0e6674a3bfddddb$var$DocumentChange(this._firestore, docChange));
    }
    forEach(callback, thisArg) {
        this._delegate.forEach((snapshot)=>{
            callback.call(thisArg, new $a0e6674a3bfddddb$var$QueryDocumentSnapshot(this._firestore, snapshot));
        });
    }
    isEqual(other) {
        return (0, $70fd6868680e912c$export$f243a5d948512846)(this._delegate, other._delegate);
    }
}
class $a0e6674a3bfddddb$var$CollectionReference extends $a0e6674a3bfddddb$var$Query {
    constructor(firestore, _delegate){
        super(firestore, _delegate);
        this.firestore = firestore;
        this._delegate = _delegate;
    }
    get id() {
        return this._delegate.id;
    }
    get path() {
        return this._delegate.path;
    }
    get parent() {
        const docRef = this._delegate.parent;
        return docRef ? new $a0e6674a3bfddddb$var$DocumentReference(this.firestore, docRef) : null;
    }
    doc(documentPath) {
        try {
            if (documentPath === undefined) // Call `doc` without `documentPath` if `documentPath` is `undefined`
            // as `doc` validates the number of arguments to prevent users from
            // accidentally passing `undefined`.
            return new $a0e6674a3bfddddb$var$DocumentReference(this.firestore, (0, $70fd6868680e912c$export$2a111da947c407d2)(this._delegate));
            else return new $a0e6674a3bfddddb$var$DocumentReference(this.firestore, (0, $70fd6868680e912c$export$2a111da947c407d2)(this._delegate, documentPath));
        } catch (e) {
            throw $a0e6674a3bfddddb$var$replaceFunctionName(e, "doc()", "CollectionReference.doc()");
        }
    }
    add(data) {
        return (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this._delegate, data).then((docRef)=>new $a0e6674a3bfddddb$var$DocumentReference(this.firestore, docRef));
    }
    isEqual(other) {
        return (0, $70fd6868680e912c$export$62a32f2da6187d11)(this._delegate, other._delegate);
    }
    withConverter(converter) {
        return new $a0e6674a3bfddddb$var$CollectionReference(this.firestore, converter ? this._delegate.withConverter($a0e6674a3bfddddb$var$FirestoreDataConverter.getInstance(this.firestore, converter)) : this._delegate.withConverter(null));
    }
}
function $a0e6674a3bfddddb$var$castReference(documentRef) {
    return (0, $70fd6868680e912c$export$572106fb5803752c)(documentRef, (0, $70fd6868680e912c$export$6be62b059fb12175));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
/**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a list
 * of field names (referring to a nested field in the document).
 */ class $a0e6674a3bfddddb$var$FieldPath {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...fieldNames){
        this._delegate = new (0, $70fd6868680e912c$export$a1a8fea822d17659)(...fieldNames);
    }
    static documentId() {
        /**
         * Internal Note: The backend doesn't technically support querying by
         * document ID. Instead it queries by the entire document name (full path
         * included), but in the cases we currently support documentId(), the net
         * effect is the same.
         */ return new $a0e6674a3bfddddb$var$FieldPath((0, $70fd6868680e912c$export$b7871852b967eaf1).keyField().canonicalString());
    }
    isEqual(other) {
        other = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof (0, $70fd6868680e912c$export$a1a8fea822d17659))) return false;
        return this._delegate._internalPath.isEqual(other._internalPath);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0e6674a3bfddddb$var$FieldValue {
    constructor(_delegate){
        this._delegate = _delegate;
    }
    static serverTimestamp() {
        const delegate = (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)();
        delegate._methodName = "FieldValue.serverTimestamp";
        return new $a0e6674a3bfddddb$var$FieldValue(delegate);
    }
    static delete() {
        const delegate = (0, $70fd6868680e912c$export$2bbad96c62fdba3e)();
        delegate._methodName = "FieldValue.delete";
        return new $a0e6674a3bfddddb$var$FieldValue(delegate);
    }
    static arrayUnion(...elements) {
        const delegate = (0, $70fd6868680e912c$export$f62af892fd92610c)(...elements);
        delegate._methodName = "FieldValue.arrayUnion";
        return new $a0e6674a3bfddddb$var$FieldValue(delegate);
    }
    static arrayRemove(...elements) {
        const delegate = (0, $70fd6868680e912c$export$30a014203d0d7e4f)(...elements);
        delegate._methodName = "FieldValue.arrayRemove";
        return new $a0e6674a3bfddddb$var$FieldValue(delegate);
    }
    static increment(n) {
        const delegate = (0, $70fd6868680e912c$export$a2647aa13413c947)(n);
        delegate._methodName = "FieldValue.increment";
        return new $a0e6674a3bfddddb$var$FieldValue(delegate);
    }
    isEqual(other) {
        return this._delegate.isEqual(other._delegate);
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0e6674a3bfddddb$var$firestoreNamespace = {
    Firestore: $a0e6674a3bfddddb$var$Firestore,
    GeoPoint: $70fd6868680e912c$export$f9f719d1b6419c4,
    Timestamp: $70fd6868680e912c$export$d9bcbd5e1ff81430,
    Blob: $a0e6674a3bfddddb$var$Blob,
    Transaction: $a0e6674a3bfddddb$var$Transaction,
    WriteBatch: $a0e6674a3bfddddb$var$WriteBatch,
    DocumentReference: $a0e6674a3bfddddb$var$DocumentReference,
    DocumentSnapshot: $a0e6674a3bfddddb$var$DocumentSnapshot,
    Query: $a0e6674a3bfddddb$var$Query,
    QueryDocumentSnapshot: $a0e6674a3bfddddb$var$QueryDocumentSnapshot,
    QuerySnapshot: $a0e6674a3bfddddb$var$QuerySnapshot,
    CollectionReference: $a0e6674a3bfddddb$var$CollectionReference,
    FieldPath: $a0e6674a3bfddddb$var$FieldPath,
    FieldValue: $a0e6674a3bfddddb$var$FieldValue,
    setLogLevel: $a0e6674a3bfddddb$var$setLogLevel,
    CACHE_SIZE_UNLIMITED: $70fd6868680e912c$export$3e714f2ae27d2df4
};
/**
 * Configures Firestore as part of the Firebase SDK by calling registerComponent.
 *
 * @param firebase - The FirebaseNamespace to register Firestore with
 * @param firestoreFactory - A factory function that returns a new Firestore
 *    instance.
 */ function $a0e6674a3bfddddb$var$configureForFirebase(firebase, firestoreFactory) {
    firebase.INTERNAL.registerComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("firestore-compat", (container)=>{
        const app = container.getProvider("app-compat").getImmediate();
        const firestoreExp = container.getProvider("firestore").getImmediate();
        return firestoreFactory(app, firestoreExp);
    }, "PUBLIC").setServiceProps(Object.assign({}, $a0e6674a3bfddddb$var$firestoreNamespace)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Registers the main Firestore build with the components framework.
 * Persistence can be enabled via `firebase.firestore().enablePersistence()`.
 */ function $a0e6674a3bfddddb$export$d9d7c974c56fbaf7(instance) {
    $a0e6674a3bfddddb$var$configureForFirebase(instance, (app, firestoreExp)=>new $a0e6674a3bfddddb$var$Firestore(app, firestoreExp, new $a0e6674a3bfddddb$var$IndexedDbPersistenceProvider()));
    instance.registerVersion($a0e6674a3bfddddb$var$name, $a0e6674a3bfddddb$var$version);
}
$a0e6674a3bfddddb$export$d9d7c974c56fbaf7((0, $62abbf54969a34e0$export$2e2bcd8739ae039));








/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $df9a6d7fd06616c9$var$DEFAULT_HOST = "firebasestorage.googleapis.com";
/**
 * The key in Firebase config json for the storage bucket.
 */ const $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $df9a6d7fd06616c9$var$StorageError extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /**
     * @param code - A StorageErrorCode string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     */ constructor(code, message){
        super($df9a6d7fd06616c9$var$prependCode(code), `Firebase Storage: ${message} (${$df9a6d7fd06616c9$var$prependCode(code)})`);
        /**
         * Stores custom error data unque to StorageError.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $df9a6d7fd06616c9$var$StorageError.prototype);
    }
    /**
     * Compares a StorageErrorCode against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $df9a6d7fd06616c9$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
function $df9a6d7fd06616c9$var$prependCode(code) {
    return "storage/" + code;
}
function $df9a6d7fd06616c9$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $df9a6d7fd06616c9$var$StorageError("unknown" /* UNKNOWN */ , message);
}
function $df9a6d7fd06616c9$var$objectNotFound(path) {
    return new $df9a6d7fd06616c9$var$StorageError("object-not-found" /* OBJECT_NOT_FOUND */ , "Object '" + path + "' does not exist.");
}
function $df9a6d7fd06616c9$var$quotaExceeded(bucket) {
    return new $df9a6d7fd06616c9$var$StorageError("quota-exceeded" /* QUOTA_EXCEEDED */ , "Quota for bucket '" + bucket + "' exceeded, please view quota on " + "https://firebase.google.com/pricing/.");
}
function $df9a6d7fd06616c9$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $df9a6d7fd06616c9$var$StorageError("unauthenticated" /* UNAUTHENTICATED */ , message);
}
function $df9a6d7fd06616c9$var$unauthorizedApp() {
    return new $df9a6d7fd06616c9$var$StorageError("unauthorized-app" /* UNAUTHORIZED_APP */ , "This app does not have permission to access Firebase Storage on this project.");
}
function $df9a6d7fd06616c9$var$unauthorized(path) {
    return new $df9a6d7fd06616c9$var$StorageError("unauthorized" /* UNAUTHORIZED */ , "User does not have permission to access '" + path + "'.");
}
function $df9a6d7fd06616c9$var$retryLimitExceeded() {
    return new $df9a6d7fd06616c9$var$StorageError("retry-limit-exceeded" /* RETRY_LIMIT_EXCEEDED */ , "Max retry time for operation exceeded, please try again.");
}
function $df9a6d7fd06616c9$var$canceled() {
    return new $df9a6d7fd06616c9$var$StorageError("canceled" /* CANCELED */ , "User canceled the upload/download.");
}
function $df9a6d7fd06616c9$var$invalidUrl(url) {
    return new $df9a6d7fd06616c9$var$StorageError("invalid-url" /* INVALID_URL */ , "Invalid URL '" + url + "'.");
}
function $df9a6d7fd06616c9$var$invalidDefaultBucket(bucket) {
    return new $df9a6d7fd06616c9$var$StorageError("invalid-default-bucket" /* INVALID_DEFAULT_BUCKET */ , "Invalid default bucket '" + bucket + "'.");
}
function $df9a6d7fd06616c9$var$noDefaultBucket() {
    return new $df9a6d7fd06616c9$var$StorageError("no-default-bucket" /* NO_DEFAULT_BUCKET */ , "No default bucket found. Did you set the '" + $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $df9a6d7fd06616c9$var$cannotSliceBlob() {
    return new $df9a6d7fd06616c9$var$StorageError("cannot-slice-blob" /* CANNOT_SLICE_BLOB */ , "Cannot slice blob for upload. Please retry the upload.");
}
function $df9a6d7fd06616c9$var$serverFileWrongSize() {
    return new $df9a6d7fd06616c9$var$StorageError("server-file-wrong-size" /* SERVER_FILE_WRONG_SIZE */ , "Server recorded incorrect upload file size, please retry the upload.");
}
function $df9a6d7fd06616c9$var$noDownloadURL() {
    return new $df9a6d7fd06616c9$var$StorageError("no-download-url" /* NO_DOWNLOAD_URL */ , "The given file does not have any download URLs.");
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$8f74d9881d1936fd(message) {
    return new $df9a6d7fd06616c9$var$StorageError("invalid-argument" /* INVALID_ARGUMENT */ , message);
}
function $df9a6d7fd06616c9$var$appDeleted() {
    return new $df9a6d7fd06616c9$var$StorageError("app-deleted" /* APP_DELETED */ , "The Firebase app was deleted.");
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $df9a6d7fd06616c9$export$61f54cdc36500ad(name) {
    return new $df9a6d7fd06616c9$var$StorageError("invalid-root-operation" /* INVALID_ROOT_OPERATION */ , "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $df9a6d7fd06616c9$var$invalidFormat(format, message) {
    return new $df9a6d7fd06616c9$var$StorageError("invalid-format" /* INVALID_FORMAT */ , "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $df9a6d7fd06616c9$var$internalError(message) {
    throw new $df9a6d7fd06616c9$var$StorageError("internal-error" /* INTERNAL_ERROR */ , "Internal error: " + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o/" + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o";
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $df9a6d7fd06616c9$export$adb98fff6714334(bucketString, "");
        }
        if (bucketLocation.path === "") return bucketLocation;
        else throw $df9a6d7fd06616c9$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = "([A-Za-z0-9.\\-_]+)";
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === "/") loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = "(/(.*))?$";
        const gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = "v[A-Za-z0-9_]+";
        const firebaseStorageHost = host.replace(/[.]/g, "\\.");
        const firebaseStoragePath = "(/([^?#]*).*)?$";
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, "i");
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $df9a6d7fd06616c9$var$DEFAULT_HOST ? "(?:storage.googleapis.com|storage.cloud.google.com)" : host;
        const cloudStoragePath = "([^?#]*)";
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, "i");
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = "";
                location = new $df9a6d7fd06616c9$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $df9a6d7fd06616c9$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $df9a6d7fd06616c9$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */ function $df9a6d7fd06616c9$var$start(f, // eslint-disable-next-line @typescript-eslint/no-explicit-any
callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function handler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $df9a6d7fd06616c9$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$isFunction(p) {
    return typeof p === "function";
}
function $df9a6d7fd06616c9$var$isNonArrayObject(p) {
    return typeof p === "object" && !Array.isArray(p);
}
function $df9a6d7fd06616c9$var$isString(p) {
    return typeof p === "string" || p instanceof String;
}
function $df9a6d7fd06616c9$var$isNativeBlob(p) {
    return $df9a6d7fd06616c9$var$isNativeBlobDefined() && p instanceof Blob;
}
function $df9a6d7fd06616c9$var$isNativeBlobDefined() {
    return typeof Blob !== "undefined";
}
function $df9a6d7fd06616c9$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $df9a6d7fd06616c9$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = "?";
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + "=" + encode(params[key]);
        queryPart = queryPart + nextPart + "&";
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error codes for requests made by the the XhrIo wrapper.
 */ var $df9a6d7fd06616c9$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($df9a6d7fd06616c9$var$ErrorCode || ($df9a6d7fd06616c9$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $df9a6d7fd06616c9$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || this.isRetryStatusCode_(status)) {
                    const wasCanceled = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                    backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $df9a6d7fd06616c9$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($df9a6d7fd06616c9$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $df9a6d7fd06616c9$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $df9a6d7fd06616c9$var$appDeleted() : $df9a6d7fd06616c9$var$canceled();
                    reject(err);
                } else {
                    const err = $df9a6d7fd06616c9$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $df9a6d7fd06616c9$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $df9a6d7fd06616c9$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
    isRetryStatusCode_(status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        const isFiveHundredCode = status >= 500 && status < 600;
        const extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
        const isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $df9a6d7fd06616c9$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers["Authorization"] = "Firebase " + authToken;
}
function $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion) {
    headers["X-Firebase-Storage-Version"] = "webjs/" + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : "AppManager");
}
function $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId) {
    if (appId) headers["X-Firebase-GMPID"] = appId;
}
function $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers["X-Firebase-AppCheck"] = appCheckToken;
}
function $df9a6d7fd06616c9$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion) {
    const queryPart = $df9a6d7fd06616c9$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId);
    $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken);
    $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion);
    $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken);
    return new $df9a6d7fd06616c9$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$getBlobBuilder() {
    if (typeof BlobBuilder !== "undefined") return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== "undefined") return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $df9a6d7fd06616c9$var$getBlob$1(...args) {
    const BlobBuilder1 = $df9a6d7fd06616c9$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $df9a6d7fd06616c9$var$StorageError("unsupported-environment" /* UNSUPPORTED_ENVIRONMENT */ , "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $df9a6d7fd06616c9$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $df9a6d7fd06616c9$var$decodeBase64(encoded) {
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $df9a6d7fd06616c9$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: "raw",
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: "base64",
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: "base64url",
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: "data_url"
};
class $df9a6d7fd06616c9$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$utf8Bytes_(stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$base64Bytes_(format, stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$dataURLBytes_(stringData), $df9a6d7fd06616c9$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $df9a6d7fd06616c9$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, "Malformed data URL.");
    }
    return $df9a6d7fd06616c9$var$utf8Bytes_(decoded);
}
function $df9a6d7fd06616c9$var$base64Bytes_(format, value) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf("-") !== -1;
                const hasUnder = value.indexOf("_") !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? "-" : "_";
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf("+") !== -1;
                const hasSlash = value.indexOf("/") !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? "+" : "/";
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, "+").replace(/_/g, "/");
                break;
            }
    }
    let bytes;
    try {
        bytes = $df9a6d7fd06616c9$var$decodeBase64(value);
    } catch (e) {
        throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character found");
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $df9a6d7fd06616c9$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $df9a6d7fd06616c9$var$endsWith(middle, ";base64");
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
    }
}
function $df9a6d7fd06616c9$var$dataURLBytes_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    if (parts.base64) return $df9a6d7fd06616c9$var$base64Bytes_($df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $df9a6d7fd06616c9$var$percentEncodedBytes_(parts.rest);
}
function $df9a6d7fd06616c9$var$dataURLContentType_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $df9a6d7fd06616c9$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = "";
        if ($df9a6d7fd06616c9$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($df9a6d7fd06616c9$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $df9a6d7fd06616c9$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $df9a6d7fd06616c9$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7($df9a6d7fd06616c9$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($df9a6d7fd06616c9$var$isString(val)) return $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0($df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $df9a6d7fd06616c9$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($df9a6d7fd06616c9$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $df9a6d7fd06616c9$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf("/");
    if (index === -1) return "";
    const newPath = path.slice(0, index);
    return newPath;
}
function $df9a6d7fd06616c9$var$child(path, childPath) {
    const canonicalChildPath = childPath.split("/").filter((component)=>component.length > 0).join("/");
    if (path.length === 0) return canonicalChildPath;
    else return path + "/" + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $df9a6d7fd06616c9$var$lastComponent(path) {
    const index = path.lastIndexOf("/", path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$noXform_(metadata, value) {
    return value;
}
class $df9a6d7fd06616c9$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $df9a6d7fd06616c9$var$noXform_;
    }
}
let $df9a6d7fd06616c9$var$mappings_ = null;
function $df9a6d7fd06616c9$var$xformPath(fullPath) {
    if (!$df9a6d7fd06616c9$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $df9a6d7fd06616c9$var$lastComponent(fullPath);
}
function $df9a6d7fd06616c9$var$getMappings() {
    if ($df9a6d7fd06616c9$var$mappings_) return $df9a6d7fd06616c9$var$mappings_;
    const mappings = [];
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("bucket"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("generation"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("metageneration"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("name", "fullPath", true));
    function mappingsXformPath(_metadata, fullPath) {
        return $df9a6d7fd06616c9$var$xformPath(fullPath);
    }
    const nameMapping = new $df9a6d7fd06616c9$var$Mapping("name");
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $df9a6d7fd06616c9$var$Mapping("size");
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("timeCreated"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("updated"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("md5Hash", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("cacheControl", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentDisposition", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentEncoding", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentLanguage", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentType", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("metadata", "customMetadata", true));
    $df9a6d7fd06616c9$var$mappings_ = mappings;
    return $df9a6d7fd06616c9$var$mappings_;
}
function $df9a6d7fd06616c9$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const loc = new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, "ref", {
        get: generateRef
    });
}
function $df9a6d7fd06616c9$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata["type"] = "file";
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $df9a6d7fd06616c9$var$addRef(metadata, service);
    return metadata;
}
function $df9a6d7fd06616c9$var$fromResourceString(service, resourceString, mappings) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromResource(service, resource, mappings);
}
function $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$df9a6d7fd06616c9$var$isString(obj["downloadTokens"])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj["downloadTokens"];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(",");
    const urls = tokensList.map((token)=>{
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const urlPart = "/b/" + encode(bucket) + "/o/" + encode(path);
        const base = $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol);
        const queryString = $df9a6d7fd06616c9$var$makeQueryString({
            alt: "media",
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $df9a6d7fd06616c9$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $df9a6d7fd06616c9$var$PREFIXES_KEY = "prefixes";
const $df9a6d7fd06616c9$var$ITEMS_KEY = "items";
function $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource["nextPageToken"]
    };
    if (resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]) for (const path of resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, "");
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$df9a6d7fd06616c9$var$ITEMS_KEY]) for (const item of resource[$df9a6d7fd06616c9$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, item["name"]));
        listResult.items.push(reference);
    }
    return listResult;
}
function $df9a6d7fd06616c9$var$fromResponseString(service, bucket, resourceString) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $df9a6d7fd06616c9$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $df9a6d7fd06616c9$var$handlerCheck(cndn) {
    if (!cndn) throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $df9a6d7fd06616c9$var$fromResponseString(service, bucket, text);
        $df9a6d7fd06616c9$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $df9a6d7fd06616c9$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes("Firebase App Check token is invalid")) newErr = $df9a6d7fd06616c9$var$unauthorizedApp();
            else newErr = $df9a6d7fd06616c9$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $df9a6d7fd06616c9$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $df9a6d7fd06616c9$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$objectErrorHandler(location) {
    const shared = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $df9a6d7fd06616c9$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams["prefix"] = "";
    else urlParams["prefix"] = location.path + "/";
    if (delimiter && delimiter.length > 0) urlParams["delimiter"] = delimiter;
    if (pageToken) urlParams["pageToken"] = pageToken;
    if (maxResults) urlParams["maxResults"] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol) + "?alt=media";
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers["Range"] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "PATCH";
    const body = $df9a6d7fd06616c9$var$toResourceString(metadata, mappings);
    const headers = {
        "Content-Type": "application/json; charset=utf-8"
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "DELETE";
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$determineContentType_(metadata, blob) {
    return metadata && metadata["contentType"] || blob && blob.type() || "application/octet-stream";
}
function $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone["fullPath"] = location.path;
    metadataClone["size"] = blob.size();
    if (!metadataClone["contentType"]) metadataClone["contentType"] = $df9a6d7fd06616c9$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $df9a6d7fd06616c9$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        "X-Goog-Upload-Protocol": "multipart"
    };
    function genBoundary() {
        let str = "";
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers["Content-Type"] = "multipart/related; boundary=" + boundary;
    const metadata_ = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $df9a6d7fd06616c9$var$toResourceString(metadata_, mappings);
    const preBlobPart = "--" + boundary + "\r\n" + "Content-Type: application/json; charset=utf-8\r\n\r\n" + metadataString + "\r\n--" + boundary + "\r\n" + "Content-Type: " + metadata_["contentType"] + "\r\n\r\n";
    const postBlobPart = "\r\n--" + boundary + "--";
    const body = $df9a6d7fd06616c9$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_["fullPath"]
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $df9a6d7fd06616c9$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader("X-Goog-Upload-Status");
    } catch (e) {
        $df9a6d7fd06616c9$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        "active"
    ];
    $df9a6d7fd06616c9$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $df9a6d7fd06616c9$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload["fullPath"]
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const headers = {
        "X-Goog-Upload-Protocol": "resumable",
        "X-Goog-Upload-Command": "start",
        "X-Goog-Upload-Header-Content-Length": `${blob.size()}`,
        "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
        "Content-Type": "application/json; charset=utf-8"
    };
    const body = $df9a6d7fd06616c9$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $df9a6d7fd06616c9$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader("X-Goog-Upload-URL");
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        $df9a6d7fd06616c9$var$handlerCheck($df9a6d7fd06616c9$var$isString(url));
        return url;
    }
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $df9a6d7fd06616c9$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        "X-Goog-Upload-Command": "query"
    };
    function handler(xhr) {
        const status = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $df9a6d7fd06616c9$var$handlerCheck(false);
        const size = Number(sizeString);
        $df9a6d7fd06616c9$var$handlerCheck(!isNaN(size));
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(size, blob.size(), status === "final");
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $df9a6d7fd06616c9$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $df9a6d7fd06616c9$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $df9a6d7fd06616c9$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    const uploadCommand = bytesToUpload === bytesLeft ? "upload, finalize" : "upload";
    const headers = {
        "X-Goog-Upload-Command": uploadCommand,
        "X-Goog-Upload-Offset": `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === "final") metadata = $df9a6d7fd06616c9$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(newCurrent, size, uploadStatus === "final", metadata);
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $df9a6d7fd06616c9$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: "state_changed"
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $df9a6d7fd06616c9$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: "running",
    /** The task was paused by the user. */ PAUSED: "paused",
    /** The task completed successfully. */ SUCCESS: "success",
    /** The task was canceled. */ CANCELED: "canceled",
    /** The task failed with an error. */ ERROR: "error"
};
function $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* RUNNING */ :
        case "pausing" /* PAUSING */ :
        case "canceling" /* CANCELING */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* PAUSED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* SUCCESS */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* CANCELED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* ERROR */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $df9a6d7fd06616c9$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $df9a6d7fd06616c9$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $df9a6d7fd06616c9$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $df9a6d7fd06616c9$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener("abort", ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener("error", ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener("load", ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .send() more than once");
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getErrorCode() before sending");
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getStatus() before sending");
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getResponse() before sending");
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getErrorText() before sending");
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener("progress", listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener("progress", listener);
    }
}
class $df9a6d7fd06616c9$var$XhrTextConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "text";
    }
}
function $df9a6d7fd06616c9$var$newTextConnection() {
    return $df9a6d7fd06616c9$var$textFactoryOverride ? $df9a6d7fd06616c9$var$textFactoryOverride() : new $df9a6d7fd06616c9$var$XhrTextConnection();
}
class $df9a6d7fd06616c9$var$XhrBytesConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "arraybuffer";
    }
}
function $df9a6d7fd06616c9$var$newBytesConnection() {
    return new $df9a6d7fd06616c9$var$XhrBytesConnection();
}
class $df9a6d7fd06616c9$var$XhrBlobConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "blob";
    }
}
function $df9a6d7fd06616c9$var$newBlobConnection() {
    return new $df9a6d7fd06616c9$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $df9a6d7fd06616c9$export$86a2a9b92406a048 {
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $df9a6d7fd06616c9$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals("canceled" /* CANCELED */ )) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                this._error = error;
                this._transition("error" /* ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals("canceled" /* CANCELED */ )) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* ERROR */ );
            }
        };
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this._continueUpload();
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* CANCELING */ :
                    this._transition("canceled" /* CANCELED */ );
                    break;
                case "pausing" /* PAUSING */ :
                    this._transition("paused" /* PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $df9a6d7fd06616c9$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $df9a6d7fd06616c9$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* CANCELING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                break;
            case "pausing" /* PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                break;
            case "running" /* RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $df9a6d7fd06616c9$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* PAUSING */ :
                this._transition("paused" /* PAUSED */ );
                break;
            case "canceling" /* CANCELING */ :
                this._transition("canceled" /* CANCELED */ );
                break;
            case "running" /* RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        const observer = new $df9a6d7fd06616c9$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state)){
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                    $df9a6d7fd06616c9$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $df9a6d7fd06616c9$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $df9a6d7fd06616c9$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $df9a6d7fd06616c9$var$async(observer.complete.bind(observer))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* PAUSED */  || this._state === "pausing" /* PAUSING */ ;
        if (valid) this._transition("running" /* RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* RUNNING */ ;
        if (valid) this._transition("pausing" /* PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* RUNNING */  || this._state === "pausing" /* PAUSING */ ;
        if (valid) this._transition("canceling" /* CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $df9a6d7fd06616c9$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $df9a6d7fd06616c9$export$adb98fff6714334) this._location = location;
        else this._location = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return "gs://" + this._location.bucket + "/" + this._location.path;
    }
    _newRef(service, location) {
        return new $df9a6d7fd06616c9$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, "");
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $df9a6d7fd06616c9$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $df9a6d7fd06616c9$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, newPath);
        return new $df9a6d7fd06616c9$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === "") throw $df9a6d7fd06616c9$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBytes");
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBlob");
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytes");
    const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings(), new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytesResumable");
    return new $df9a6d7fd06616c9$export$86a2a9b92406a048(ref, new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadString$1(ref, value, format = $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot("uploadString");
    const data = $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone["contentType"] == null && data.contentType != null) metadataClone["contentType"] = data.contentType;
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $df9a6d7fd06616c9$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === "number") $df9a6d7fd06616c9$var$validateNumber("options.maxResults", /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $df9a6d7fd06616c9$var$list$2(ref.storage, ref._location, /*delimiter= */ "/", op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $df9a6d7fd06616c9$var$getMetadata$1(ref) {
    ref._throwIfRoot("getMetadata");
    const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot("updateMetadata");
    const requestInfo = $df9a6d7fd06616c9$var$updateMetadata$2(ref.storage, ref._location, metadata, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$var$getDownloadURL$1(ref) {
    ref._throwIfRoot("getDownloadURL");
    const requestInfo = $df9a6d7fd06616c9$var$getDownloadUrl(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((url)=>{
        if (url === null) throw $df9a6d7fd06616c9$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$var$deleteObject$1(ref) {
    ref._throwIfRoot("deleteObject");
    const requestInfo = $df9a6d7fd06616c9$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $df9a6d7fd06616c9$var$_getChild$1(ref, childPath) {
    const newPath = $df9a6d7fd06616c9$var$child(ref._location.path, childPath);
    const location = new $df9a6d7fd06616c9$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $df9a6d7fd06616c9$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $df9a6d7fd06616c9$var$refFromURL(service, url) {
    return new $df9a6d7fd06616c9$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $df9a6d7fd06616c9$var$refFromPath(ref, path) {
    if (ref instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $df9a6d7fd06616c9$var$noDefaultBucket();
        const reference = new $df9a6d7fd06616c9$var$Reference(service, service._bucket);
        if (path != null) return $df9a6d7fd06616c9$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $df9a6d7fd06616c9$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $df9a6d7fd06616c9$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) return $df9a6d7fd06616c9$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $df9a6d7fd06616c9$export$8f74d9881d1936fd("To use ref(service, url), the first argument must be a Storage instance.");
    } else return $df9a6d7fd06616c9$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $df9a6d7fd06616c9$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = "http";
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === "string" ? mockUserToken : (0, $c38e0f42709c826a$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $df9a6d7fd06616c9$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $df9a6d7fd06616c9$var$DEFAULT_HOST;
        this._protocol = "https";
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $df9a6d7fd06616c9$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken) {
        if (!this._deleted) {
            const request = $df9a6d7fd06616c9$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $df9a6d7fd06616c9$var$FailRequest($df9a6d7fd06616c9$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $df9a6d7fd06616c9$var$name = "@firebase/storage";
const $df9a6d7fd06616c9$var$version = "0.9.7";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $df9a6d7fd06616c9$var$STORAGE_TYPE = "storage";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $df9a6d7fd06616c9$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $df9a6d7fd06616c9$export$8548546c0aa631e6(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $df9a6d7fd06616c9$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$export$8837f4fc672e936d(ref, options) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$export$6a265a7d315dec03(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$export$39c5ed4ec960eade(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$deleteObject$1(ref);
}
function $df9a6d7fd06616c9$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(serviceOrRef);
    return $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$9acd24c0fce96a85(ref, childPath) {
    return $df9a6d7fd06616c9$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $df9a6d7fd06616c9$export$fbd9b57a66480737(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $df9a6d7fd06616c9$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $df9a6d7fd06616c9$export$9850e656f954b889(storage, host, port, options = {}) {
    $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $df9a6d7fd06616c9$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $df9a6d7fd06616c9$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error("getStream() is only supported by NodeJS builds");
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $df9a6d7fd06616c9$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider("app").getImmediate();
    const authProvider = container.getProvider("auth-internal");
    const appCheckProvider = container.getProvider("app-check-internal");
    return new $df9a6d7fd06616c9$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $57d436074e210fb5$export$31499a9cd224b78c));
}
function $df9a6d7fd06616c9$var$registerStorage() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($df9a6d7fd06616c9$var$STORAGE_TYPE, $df9a6d7fd06616c9$var$factory, "PUBLIC" /* PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, "");
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, "esm2017");
}
$df9a6d7fd06616c9$var$registerStorage();



/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0a89a187c20c32f$var$UploadTaskSnapshotCompat {
    constructor(_delegate, task, ref){
        this._delegate = _delegate;
        this.task = task;
        this.ref = ref;
    }
    get bytesTransferred() {
        return this._delegate.bytesTransferred;
    }
    get metadata() {
        return this._delegate.metadata;
    }
    get state() {
        return this._delegate.state;
    }
    get totalBytes() {
        return this._delegate.totalBytes;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0a89a187c20c32f$var$UploadTaskCompat {
    constructor(_delegate, _ref){
        this._delegate = _delegate;
        this._ref = _ref;
        this.cancel = this._delegate.cancel.bind(this._delegate);
        this.catch = this._delegate.catch.bind(this._delegate);
        this.pause = this._delegate.pause.bind(this._delegate);
        this.resume = this._delegate.resume.bind(this._delegate);
    }
    get snapshot() {
        return new $a0a89a187c20c32f$var$UploadTaskSnapshotCompat(this._delegate.snapshot, this, this._ref);
    }
    then(onFulfilled, onRejected) {
        return this._delegate.then((snapshot)=>{
            if (onFulfilled) return onFulfilled(new $a0a89a187c20c32f$var$UploadTaskSnapshotCompat(snapshot, this, this._ref));
        }, onRejected);
    }
    on(type, nextOrObserver, error, completed) {
        let wrappedNextOrObserver = undefined;
        if (!!nextOrObserver) {
            if (typeof nextOrObserver === "function") wrappedNextOrObserver = (taskSnapshot)=>nextOrObserver(new $a0a89a187c20c32f$var$UploadTaskSnapshotCompat(taskSnapshot, this, this._ref));
            else wrappedNextOrObserver = {
                next: !!nextOrObserver.next ? (taskSnapshot)=>nextOrObserver.next(new $a0a89a187c20c32f$var$UploadTaskSnapshotCompat(taskSnapshot, this, this._ref)) : undefined,
                complete: nextOrObserver.complete || undefined,
                error: nextOrObserver.error || undefined
            };
        }
        return this._delegate.on(type, wrappedNextOrObserver, error || undefined, completed || undefined);
    }
}
class $a0a89a187c20c32f$var$ListResultCompat {
    constructor(_delegate, _service){
        this._delegate = _delegate;
        this._service = _service;
    }
    get prefixes() {
        return this._delegate.prefixes.map((ref)=>new $a0a89a187c20c32f$var$ReferenceCompat(ref, this._service));
    }
    get items() {
        return this._delegate.items.map((ref)=>new $a0a89a187c20c32f$var$ReferenceCompat(ref, this._service));
    }
    get nextPageToken() {
        return this._delegate.nextPageToken || null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0a89a187c20c32f$var$ReferenceCompat {
    constructor(_delegate, storage){
        this._delegate = _delegate;
        this.storage = storage;
    }
    get name() {
        return this._delegate.name;
    }
    get bucket() {
        return this._delegate.bucket;
    }
    get fullPath() {
        return this._delegate.fullPath;
    }
    toString() {
        return this._delegate.toString();
    }
    /**
     * @returns A reference to the object obtained by
     * appending childPath, removing any duplicate, beginning, or trailing
     * slashes.
     */ child(childPath) {
        const reference = (0, $df9a6d7fd06616c9$export$9acd24c0fce96a85)(this._delegate, childPath);
        return new $a0a89a187c20c32f$var$ReferenceCompat(reference, this.storage);
    }
    get root() {
        return new $a0a89a187c20c32f$var$ReferenceCompat(this._delegate.root, this.storage);
    }
    /**
     * @returns A reference to the parent of the
     * current object, or null if the current object is the root.
     */ get parent() {
        const reference = this._delegate.parent;
        if (reference == null) return null;
        return new $a0a89a187c20c32f$var$ReferenceCompat(reference, this.storage);
    }
    /**
     * Uploads a blob to this object's location.
     * @param data - The blob to upload.
     * @returns An UploadTask that lets you control and
     * observe the upload.
     */ put(data, metadata) {
        this._throwIfRoot("put");
        return new $a0a89a187c20c32f$var$UploadTaskCompat((0, $df9a6d7fd06616c9$export$3895d39eb7ac9b25)(this._delegate, data, metadata), this);
    }
    /**
     * Uploads a string to this object's location.
     * @param value - The string to upload.
     * @param format - The format of the string to upload.
     * @returns An UploadTask that lets you control and
     * observe the upload.
     */ putString(value, format = (0, $df9a6d7fd06616c9$export$f22e7fe56db8ae03).RAW, metadata) {
        this._throwIfRoot("putString");
        const data = (0, $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0)(format, value);
        const metadataClone = Object.assign({}, metadata);
        if (metadataClone["contentType"] == null && data.contentType != null) metadataClone["contentType"] = data.contentType;
        return new $a0a89a187c20c32f$var$UploadTaskCompat(new (0, $df9a6d7fd06616c9$export$86a2a9b92406a048)(this._delegate, new (0, $df9a6d7fd06616c9$export$8deea8629ff0b8a7)(data.data, true), metadataClone), this);
    }
    /**
     * List all items (files) and prefixes (folders) under this storage reference.
     *
     * This is a helper method for calling list() repeatedly until there are
     * no more results. The default pagination size is 1000.
     *
     * Note: The results may not be consistent if objects are changed while this
     * operation is running.
     *
     * Warning: listAll may potentially consume too many resources if there are
     * too many results.
     *
     * @returns A Promise that resolves with all the items and prefixes under
     *  the current storage reference. `prefixes` contains references to
     *  sub-directories and `items` contains references to objects in this
     *  folder. `nextPageToken` is never returned.
     */ listAll() {
        return (0, $df9a6d7fd06616c9$export$6a265a7d315dec03)(this._delegate).then((r)=>new $a0a89a187c20c32f$var$ListResultCompat(r, this.storage));
    }
    /**
     * List items (files) and prefixes (folders) under this storage reference.
     *
     * List API is only available for Firebase Rules Version 2.
     *
     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
     * delimited folder structure. Refer to GCS's List API if you want to learn more.
     *
     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
     * support objects whose paths end with "/" or contain two consecutive
     * "/"s. Firebase Storage List API will filter these unsupported objects.
     * list() may fail if there are too many unsupported objects in the bucket.
     *
     * @param options - See ListOptions for details.
     * @returns A Promise that resolves with the items and prefixes.
     * `prefixes` contains references to sub-folders and `items`
     * contains references to objects in this folder. `nextPageToken`
     * can be used to get the rest of the results.
     */ list(options) {
        return (0, $df9a6d7fd06616c9$export$8837f4fc672e936d)(this._delegate, options || undefined).then((r)=>new $a0a89a187c20c32f$var$ListResultCompat(r, this.storage));
    }
    /**
     * A `Promise` that resolves with the metadata for this object. If this
     * object doesn't exist or metadata cannot be retreived, the promise is
     * rejected.
     */ getMetadata() {
        return (0, $df9a6d7fd06616c9$export$8548546c0aa631e6)(this._delegate);
    }
    /**
     * Updates the metadata for this object.
     * @param metadata - The new metadata for the object.
     * Only values that have been explicitly set will be changed. Explicitly
     * setting a value to null will remove the metadata.
     * @returns A `Promise` that resolves
     * with the new metadata for this object.
     * @see firebaseStorage.Reference.prototype.getMetadata
     */ updateMetadata(metadata) {
        return (0, $df9a6d7fd06616c9$export$f64791b2d30456a0)(this._delegate, metadata);
    }
    /**
     * @returns A `Promise` that resolves with the download
     * URL for this object.
     */ getDownloadURL() {
        return (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(this._delegate);
    }
    /**
     * Deletes the object at this location.
     * @returns A `Promise` that resolves if the deletion succeeds.
     */ delete() {
        this._throwIfRoot("delete");
        return (0, $df9a6d7fd06616c9$export$39c5ed4ec960eade)(this._delegate);
    }
    _throwIfRoot(name) {
        if (this._delegate._location.path === "") throw (0, $df9a6d7fd06616c9$export$61f54cdc36500ad)(name);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 */ class $a0a89a187c20c32f$var$StorageServiceCompat {
    constructor(app, _delegate){
        this.app = app;
        this._delegate = _delegate;
    }
    get maxOperationRetryTime() {
        return this._delegate.maxOperationRetryTime;
    }
    get maxUploadRetryTime() {
        return this._delegate.maxUploadRetryTime;
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */ ref(path) {
        if ($a0a89a187c20c32f$var$isUrl(path)) throw (0, $df9a6d7fd06616c9$export$8f74d9881d1936fd)("ref() expected a child path but got a URL, use refFromURL instead.");
        return new $a0a89a187c20c32f$var$ReferenceCompat((0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)(this._delegate, path), this);
    }
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */ refFromURL(url) {
        if (!$a0a89a187c20c32f$var$isUrl(url)) throw (0, $df9a6d7fd06616c9$export$8f74d9881d1936fd)("refFromURL() expected a full URL but got a child path, use ref() instead.");
        try {
            (0, $df9a6d7fd06616c9$export$adb98fff6714334).makeFromUrl(url, this._delegate.host);
        } catch (e) {
            throw (0, $df9a6d7fd06616c9$export$8f74d9881d1936fd)("refFromUrl() expected a valid full URL but got an invalid one.");
        }
        return new $a0a89a187c20c32f$var$ReferenceCompat((0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)(this._delegate, url), this);
    }
    setMaxUploadRetryTime(time) {
        this._delegate.maxUploadRetryTime = time;
    }
    setMaxOperationRetryTime(time) {
        this._delegate.maxOperationRetryTime = time;
    }
    useEmulator(host, port, options = {}) {
        (0, $df9a6d7fd06616c9$export$9850e656f954b889)(this._delegate, host, port, options);
    }
}
function $a0a89a187c20c32f$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
const $a0a89a187c20c32f$var$name = "@firebase/storage-compat";
const $a0a89a187c20c32f$var$version = "0.1.15";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $a0a89a187c20c32f$var$STORAGE_TYPE = "storage-compat";
function $a0a89a187c20c32f$var$factory(container, { instanceIdentifier: url }) {
    // Dependencies
    const app = container.getProvider("app-compat").getImmediate();
    const storageExp = container.getProvider("storage").getImmediate({
        identifier: url
    });
    const storageServiceCompat = new $a0a89a187c20c32f$var$StorageServiceCompat(app, storageExp);
    return storageServiceCompat;
}
function $a0a89a187c20c32f$export$ba90a1fa1905b39e(instance) {
    const namespaceExports = {
        // no-inline
        TaskState: (0, $df9a6d7fd06616c9$export$9dc4203728a9a7c9),
        TaskEvent: (0, $df9a6d7fd06616c9$export$2cf04e0422ce9b07),
        StringFormat: $df9a6d7fd06616c9$export$f22e7fe56db8ae03,
        Storage: $a0a89a187c20c32f$var$StorageServiceCompat,
        Reference: $a0a89a187c20c32f$var$ReferenceCompat
    };
    instance.INTERNAL.registerComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($a0a89a187c20c32f$var$STORAGE_TYPE, $a0a89a187c20c32f$var$factory, "PUBLIC" /* PUBLIC */ ).setServiceProps(namespaceExports).setMultipleInstances(true));
    instance.registerVersion($a0a89a187c20c32f$var$name, $a0a89a187c20c32f$var$version);
}
$a0a89a187c20c32f$export$ba90a1fa1905b39e((0, $62abbf54969a34e0$export$2e2bcd8739ae039));





var $fLVpN = parcelRequire("fLVpN");
var $6f599c36f4240fd6$exports = {};

$parcel$defineInteropFlag($6f599c36f4240fd6$exports);

$parcel$export($6f599c36f4240fd6$exports, "default", () => $62abbf54969a34e0$export$2e2bcd8739ae039);

var $6f599c36f4240fd6$var$name = "firebase";
var $6f599c36f4240fd6$var$version = "9.8.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $62abbf54969a34e0$export$2e2bcd8739ae039).registerVersion($6f599c36f4240fd6$var$name, $6f599c36f4240fd6$var$version, "app-compat");


function $65822de42ac1fb15$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $65822de42ac1fb15$var$fetch__default = /*#__PURE__*/ $65822de42ac1fb15$var$_interopDefaultLegacy($fLVpN);
var $65822de42ac1fb15$var$firebase__default = /*#__PURE__*/ $65822de42ac1fb15$var$_interopDefaultLegacy($6f599c36f4240fd6$exports);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $65822de42ac1fb15$var$__assign = function() {
    $65822de42ac1fb15$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $65822de42ac1fb15$var$__assign.apply(this, arguments);
};
function $65822de42ac1fb15$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $65822de42ac1fb15$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a connectable hostname, replacing wildcard 0.0.0.0 or :: with loopback
 * addresses 127.0.0.1 / ::1 correspondingly. See below for why this is needed:
 * https://github.com/firebase/firebase-tools-ui/issues/286
 *
 * This assumes emulators are running on the same device as fallbackHost (e.g.
 * hub), which should hold if both are started from the same CLI command.
 * @private
 */ function $65822de42ac1fb15$var$fixHostname(host, fallbackHost) {
    host = host.replace("[", "").replace("]", ""); // Remove IPv6 brackets
    if (host === "0.0.0.0") host = fallbackHost || "127.0.0.1";
    else if (host === "::") host = fallbackHost || "::1";
    return host;
}
/**
 * Create a URL with host, port, and path. Handles IPv6 bracketing correctly.
 * @private
 */ function $65822de42ac1fb15$var$makeUrl(hostAndPort, path) {
    if (typeof hostAndPort === "object") {
        var host = hostAndPort.host, port = hostAndPort.port;
        if (host.includes(":")) hostAndPort = "[".concat(host, "]:").concat(port);
        else hostAndPort = "".concat(host, ":").concat(port);
    }
    var url = new URL("http://".concat(hostAndPort, "/"));
    url.pathname = path;
    return url;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Use the Firebase Emulator hub to discover other running emulators.
 *
 * @param hub the host and port where the Emulator Hub is running
 * @private
 */ function $65822de42ac1fb15$var$discoverEmulators(hub, fetch) {
    if (fetch === void 0) fetch = $65822de42ac1fb15$var$fetch__default["default"];
    return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
        var res, emulators, data;
        return $65822de42ac1fb15$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        fetch($65822de42ac1fb15$var$makeUrl(hub, "/emulators"))
                    ];
                case 1:
                    res = _a.sent();
                    if (!res.ok) throw new Error("HTTP Error ".concat(res.status, " when attempting to reach Emulator Hub at ").concat(res.url, ", are you sure it is running?"));
                    emulators = {};
                    return [
                        4 /*yield*/ ,
                        res.json()
                    ];
                case 2:
                    data = _a.sent();
                    if (data.database) emulators.database = {
                        host: data.database.host,
                        port: data.database.port
                    };
                    if (data.firestore) emulators.firestore = {
                        host: data.firestore.host,
                        port: data.firestore.port
                    };
                    if (data.storage) emulators.storage = {
                        host: data.storage.host,
                        port: data.storage.port
                    };
                    if (data.hub) emulators.hub = {
                        host: data.hub.host,
                        port: data.hub.port
                    };
                    return [
                        2 /*return*/ ,
                        emulators
                    ];
            }
        });
    });
}
/**
 * @private
 */ function $65822de42ac1fb15$var$getEmulatorHostAndPort(emulator, conf, discovered) {
    var _a, _b;
    if (conf && ("host" in conf || "port" in conf)) {
        var host = conf.host, port = conf.port;
        if (host || port) {
            if (!host || !port) throw new Error("Invalid configuration ".concat(emulator, ".host=").concat(host, " and ").concat(emulator, ".port=").concat(port, ". ") + "If either parameter is supplied, both must be defined.");
            if (discovered && !discovered[emulator]) console.warn("Warning: config for the ".concat(emulator, " emulator is specified, but the Emulator hub ") + "reports it as not running. This may lead to errors such as connection refused.");
            return {
                host: $65822de42ac1fb15$var$fixHostname(conf.host, (_a = discovered === null || discovered === void 0 ? void 0 : discovered.hub) === null || _a === void 0 ? void 0 : _a.host),
                port: conf.port
            };
        }
    }
    var envVar = $65822de42ac1fb15$var$EMULATOR_HOST_ENV_VARS[emulator];
    var fallback = (discovered === null || discovered === void 0 ? void 0 : discovered[emulator]) || $65822de42ac1fb15$var$emulatorFromEnvVar(envVar);
    if (fallback) {
        if (discovered && !discovered[emulator]) console.warn("Warning: the environment variable ".concat(envVar, " is set, but the Emulator hub reports the ") + "".concat(emulator, " emulator as not running. This may lead to errors such as connection refused."));
        return {
            host: $65822de42ac1fb15$var$fixHostname(fallback.host, (_b = discovered === null || discovered === void 0 ? void 0 : discovered.hub) === null || _b === void 0 ? void 0 : _b.host),
            port: fallback.port
        };
    }
}
// Visible for testing.
var $65822de42ac1fb15$var$EMULATOR_HOST_ENV_VARS = {
    "database": "FIREBASE_DATABASE_EMULATOR_HOST",
    "firestore": "FIRESTORE_EMULATOR_HOST",
    "hub": "FIREBASE_EMULATOR_HUB",
    "storage": "FIREBASE_STORAGE_EMULATOR_HOST"
};
function $65822de42ac1fb15$var$emulatorFromEnvVar(envVar) {
    var hostAndPort = $hPtJY.env[envVar];
    if (!hostAndPort) return undefined;
    var parsed;
    try {
        parsed = new URL("http://".concat(hostAndPort));
    } catch (_a) {
        throw new Error("Invalid format in environment variable ".concat(envVar, "=").concat(hostAndPort, " (expected host:port)"));
    }
    var host = parsed.hostname;
    var port = Number(parsed.port || "80");
    if (!Number.isInteger(port)) throw new Error("Invalid port in environment variable ".concat(envVar, "=").concat(hostAndPort));
    return {
        host: host,
        port: port
    };
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of {@code RulesTestEnvironment}. This is private to hide the constructor,
 * which should never be directly called by the developer.
 * @private
 */ var $65822de42ac1fb15$var$RulesTestEnvironmentImpl = /** @class */ function() {
    function RulesTestEnvironmentImpl(projectId, emulators) {
        this.projectId = projectId;
        this.emulators = emulators;
        this.contexts = new Set();
        this.destroyed = false;
    }
    RulesTestEnvironmentImpl.prototype.authenticatedContext = function(user_id, tokenOptions) {
        this.checkNotDestroyed();
        return this.createContext($65822de42ac1fb15$var$__assign($65822de42ac1fb15$var$__assign({}, tokenOptions), {
            sub: user_id,
            user_id: user_id
        }));
    };
    RulesTestEnvironmentImpl.prototype.unauthenticatedContext = function() {
        this.checkNotDestroyed();
        return this.createContext(/* authToken = */ undefined);
    };
    RulesTestEnvironmentImpl.prototype.withSecurityRulesDisabled = function(callback) {
        return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
            var context;
            return $65822de42ac1fb15$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.checkNotDestroyed();
                        context = this.createContext("owner");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback(context)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        // We eagarly clean up this context to actively prevent misuse outside of the callback, e.g.
                        // storing the context in a variable.
                        context.cleanup();
                        this.contexts.delete(context);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RulesTestEnvironmentImpl.prototype.createContext = function(authToken) {
        var context = new $65822de42ac1fb15$var$RulesTestContextImpl(this.projectId, this.emulators, authToken);
        this.contexts.add(context);
        return context;
    };
    RulesTestEnvironmentImpl.prototype.clearDatabase = function() {
        this.checkNotDestroyed();
        return this.withSecurityRulesDisabled(function(context) {
            return context.database().ref("/").set(null);
        });
    };
    RulesTestEnvironmentImpl.prototype.clearFirestore = function() {
        return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
            var resp, _a;
            return $65822de42ac1fb15$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.checkNotDestroyed();
                        $65822de42ac1fb15$var$assertEmulatorRunning(this.emulators, "firestore");
                        return [
                            4 /*yield*/ ,
                            $65822de42ac1fb15$var$fetch__default["default"]($65822de42ac1fb15$var$makeUrl(this.emulators.firestore, "/emulator/v1/projects/".concat(this.projectId, "/databases/(default)/documents")), {
                                method: "DELETE"
                            })
                        ];
                    case 1:
                        resp = _b.sent();
                        if (!!resp.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        _a = Error.bind;
                        return [
                            4 /*yield*/ ,
                            resp.text()
                        ];
                    case 2:
                        throw new (_a.apply(Error, [
                            void 0,
                            _b.sent()
                        ]))();
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RulesTestEnvironmentImpl.prototype.clearStorage = function() {
        var _this = this;
        this.checkNotDestroyed();
        return this.withSecurityRulesDisabled(function(context) {
            return $65822de42ac1fb15$var$__awaiter(_this, void 0, void 0, function() {
                var items;
                return $65822de42ac1fb15$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                context.storage().ref().listAll()
                            ];
                        case 1:
                            items = _a.sent().items;
                            return [
                                4 /*yield*/ ,
                                Promise.all(items.map(function(item) {
                                    return item.delete();
                                }))
                            ];
                        case 2:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    RulesTestEnvironmentImpl.prototype.cleanup = function() {
        return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
            return $65822de42ac1fb15$var$__generator(this, function(_a) {
                this.destroyed = true;
                this.contexts.forEach(function(context) {
                    context.envDestroyed = true;
                    context.cleanup();
                });
                this.contexts.clear();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    RulesTestEnvironmentImpl.prototype.checkNotDestroyed = function() {
        if (this.destroyed) throw new Error("This RulesTestEnvironment has already been cleaned up. (This may indicate a leak or missing `await` in your test cases. If you do intend to perform more tests, please call cleanup() later or create another RulesTestEnvironment.)");
    };
    return RulesTestEnvironmentImpl;
}();
/**
 * An implementation of {@code RulesTestContext}. This is private to hide the constructor,
 * which should never be directly called by the developer.
 * @private
 */ var $65822de42ac1fb15$var$RulesTestContextImpl = /** @class */ function() {
    function RulesTestContextImpl(projectId, emulators, authToken) {
        this.projectId = projectId;
        this.emulators = emulators;
        this.authToken = authToken;
        this.destroyed = false;
        this.envDestroyed = false;
    }
    RulesTestContextImpl.prototype.cleanup = function() {
        var _a;
        this.destroyed = true;
        (_a = this.app) === null || _a === void 0 || _a.delete();
        this.app = undefined;
    };
    RulesTestContextImpl.prototype.firestore = function(settings) {
        $65822de42ac1fb15$var$assertEmulatorRunning(this.emulators, "firestore");
        var firestore = this.getApp().firestore();
        if (settings) firestore.settings(settings);
        firestore.useEmulator(this.emulators.firestore.host, this.emulators.firestore.port, {
            mockUserToken: this.authToken
        });
        return firestore;
    };
    RulesTestContextImpl.prototype.database = function(databaseURL) {
        $65822de42ac1fb15$var$assertEmulatorRunning(this.emulators, "database");
        if (!databaseURL) {
            var url = $65822de42ac1fb15$var$makeUrl(this.emulators.database, "");
            // Make sure to set the namespace equal to projectId -- otherwise the RTDB SDK will by default
            // use `${projectId}-default-rtdb`, which is treated as a different DB by the RTDB emulator
            // (and thus WON'T apply any rules set for the `projectId` DB during initialization).
            url.searchParams.append("ns", this.projectId);
            databaseURL = url.toString();
        }
        var database = this.getApp().database(databaseURL);
        database.useEmulator(this.emulators.database.host, this.emulators.database.port, {
            mockUserToken: this.authToken
        });
        return database;
    };
    RulesTestContextImpl.prototype.storage = function(bucketUrl) {
        if (bucketUrl === void 0) bucketUrl = "gs://".concat(this.projectId);
        $65822de42ac1fb15$var$assertEmulatorRunning(this.emulators, "storage");
        var storage = this.getApp().storage(bucketUrl);
        storage.useEmulator(this.emulators.storage.host, this.emulators.storage.port, {
            mockUserToken: this.authToken
        });
        return storage;
    };
    RulesTestContextImpl.prototype.getApp = function() {
        if (this.envDestroyed) throw new Error("This RulesTestContext is no longer valid because its RulesTestEnvironment has been cleaned up. (This may indicate a leak or missing `await` in your test cases.)");
        if (this.destroyed) throw new Error("This RulesTestContext is no longer valid. When using withSecurityRulesDisabled, make sure to perform all operations on the context within the callback function and return a Promise that resolves when the operations are done.");
        if (!this.app) this.app = $65822de42ac1fb15$var$firebase__default["default"].initializeApp({
            projectId: this.projectId
        }, "_Firebase_RulesUnitTesting_".concat(Date.now(), "_").concat(Math.random()));
        return this.app;
    };
    return RulesTestContextImpl;
}();
function $65822de42ac1fb15$var$assertEmulatorRunning(emulators, emulator) {
    if (!emulators[emulator]) {
        if (emulators.hub) throw new Error("The ".concat(emulator, " emulator is not running (according to Emulator hub). To force ") + "connecting anyway, please specify its host and port in initializeTestEnvironment({...}).");
        else throw new Error("The host and port of the ".concat(emulator, " emulator must be specified. (You may wrap the test ") + "script with `firebase emulators:exec './your-test-script'` to enable automatic " + "discovery, or specify manually via initializeTestEnvironment({".concat(emulator, ": {host, port}})."));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @private
 */ function $65822de42ac1fb15$var$loadDatabaseRules(hostAndPort, databaseName, rules) {
    return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
        var url, resp, _a;
        return $65822de42ac1fb15$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    url = $65822de42ac1fb15$var$makeUrl(hostAndPort, "/.settings/rules.json");
                    url.searchParams.append("ns", databaseName);
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$fetch__default["default"](url, {
                            method: "PUT",
                            headers: {
                                Authorization: "Bearer owner"
                            },
                            body: rules
                        })
                    ];
                case 1:
                    resp = _b.sent();
                    if (!!resp.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    _a = Error.bind;
                    return [
                        4 /*yield*/ ,
                        resp.text()
                    ];
                case 2:
                    throw new (_a.apply(Error, [
                        void 0,
                        _b.sent()
                    ]))();
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @private
 */ function $65822de42ac1fb15$var$loadFirestoreRules(hostAndPort, projectId, rules) {
    return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
        var resp, _a;
        return $65822de42ac1fb15$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$fetch__default["default"]($65822de42ac1fb15$var$makeUrl(hostAndPort, "/emulator/v1/projects/".concat(projectId, ":securityRules")), {
                            method: "PUT",
                            body: JSON.stringify({
                                rules: {
                                    files: [
                                        {
                                            content: rules
                                        }
                                    ]
                                }
                            })
                        })
                    ];
                case 1:
                    resp = _b.sent();
                    if (!!resp.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    _a = Error.bind;
                    return [
                        4 /*yield*/ ,
                        resp.text()
                    ];
                case 2:
                    throw new (_a.apply(Error, [
                        void 0,
                        _b.sent()
                    ]))();
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @private
 */ function $65822de42ac1fb15$var$loadStorageRules(hostAndPort, rules) {
    return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
        var resp, _a;
        return $65822de42ac1fb15$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$fetch__default["default"]($65822de42ac1fb15$var$makeUrl(hostAndPort, "/internal/setRules"), {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                rules: {
                                    files: [
                                        {
                                            name: "storage.rules",
                                            content: rules
                                        }
                                    ]
                                }
                            })
                        })
                    ];
                case 1:
                    resp = _b.sent();
                    if (!!resp.ok) return [
                        3 /*break*/ ,
                        3
                    ];
                    _a = Error.bind;
                    return [
                        4 /*yield*/ ,
                        resp.text()
                    ];
                case 2:
                    throw new (_a.apply(Error, [
                        void 0,
                        _b.sent()
                    ]))();
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes a test environment for rules unit testing. Call this function first for test setup.
 *
 * Requires emulators to be running. This function tries to discover those emulators via environment
 * variables or through the Firebase Emulator hub if hosts and ports are unspecified. It is strongly
 * recommended to specify security rules for emulators used for testing. See minimal example below.
 *
 * @param config - the configuration for emulators. Most fields are optional if they can be discovered
 * @returns a promise that resolves with an environment ready for testing, or rejects on error.
 * @public
 * @example
 * ```javascript
 * const testEnv = await initializeTestEnvironment({
 *   firestore: {
 *     rules: fs.readFileSync("/path/to/firestore.rules", "utf8"), // Load rules from file
 *     // host and port can be omitted if they can be discovered from the hub.
 *   },
 *   // ...
 * });
 * ```
 */ function $65822de42ac1fb15$var$initializeTestEnvironment(config) {
    var _a, _b, _c;
    return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
        var projectId, hub, discovered, _d, _e, emulators, _i, SUPPORTED_EMULATORS_1, emulator, hostAndPort;
        return $65822de42ac1fb15$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    projectId = config.projectId || undefined;
                    if (!projectId) throw new Error('Missing projectId option or env var GCLOUD_PROJECT! Please specify the projectId either way.\n(A demo-* projectId is strongly recommended for unit tests, such as "demo-test".)');
                    hub = $65822de42ac1fb15$var$getEmulatorHostAndPort("hub", config.hub);
                    if (!hub) return [
                        3 /*break*/ ,
                        2
                    ];
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$discoverEmulators(hub)
                    ];
                case 1:
                    _d = $65822de42ac1fb15$var$__assign.apply(void 0, [
                        $65822de42ac1fb15$var$__assign.apply(void 0, _e.concat([
                            _f.sent()
                        ])),
                        {
                            hub: hub
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    _d = undefined;
                    _f.label = 3;
                case 3:
                    discovered = _d;
                    emulators = {};
                    if (hub) emulators.hub = hub;
                    for(_i = 0, SUPPORTED_EMULATORS_1 = $65822de42ac1fb15$var$SUPPORTED_EMULATORS; _i < SUPPORTED_EMULATORS_1.length; _i++){
                        emulator = SUPPORTED_EMULATORS_1[_i];
                        hostAndPort = $65822de42ac1fb15$var$getEmulatorHostAndPort(emulator, config[emulator], discovered);
                        if (hostAndPort) emulators[emulator] = hostAndPort;
                    }
                    if (!((_a = config.database) === null || _a === void 0 ? void 0 : _a.rules)) return [
                        3 /*break*/ ,
                        5
                    ];
                    $65822de42ac1fb15$var$assertEmulatorRunning(emulators, "database");
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$loadDatabaseRules(emulators.database, projectId, config.database.rules)
                    ];
                case 4:
                    _f.sent();
                    _f.label = 5;
                case 5:
                    if (!((_b = config.firestore) === null || _b === void 0 ? void 0 : _b.rules)) return [
                        3 /*break*/ ,
                        7
                    ];
                    $65822de42ac1fb15$var$assertEmulatorRunning(emulators, "firestore");
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$loadFirestoreRules(emulators.firestore, projectId, config.firestore.rules)
                    ];
                case 6:
                    _f.sent();
                    _f.label = 7;
                case 7:
                    if (!((_c = config.storage) === null || _c === void 0 ? void 0 : _c.rules)) return [
                        3 /*break*/ ,
                        9
                    ];
                    $65822de42ac1fb15$var$assertEmulatorRunning(emulators, "storage");
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$loadStorageRules(emulators.storage, config.storage.rules)
                    ];
                case 8:
                    _f.sent();
                    _f.label = 9;
                case 9:
                    return [
                        2 /*return*/ ,
                        new $65822de42ac1fb15$var$RulesTestEnvironmentImpl(projectId, emulators)
                    ];
            }
        });
    });
}
var $65822de42ac1fb15$var$SUPPORTED_EMULATORS = [
    "database",
    "firestore",
    "storage"
];
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $65822de42ac1fb15$var$withFunctionTriggersDisabled(fnOrHub, maybeFn) {
    return $65822de42ac1fb15$var$__awaiter(this, void 0, void 0, function() {
        var hub, disableRes, result, enableRes;
        return $65822de42ac1fb15$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof fnOrHub === "function") {
                        maybeFn = fnOrHub;
                        hub = $65822de42ac1fb15$var$getEmulatorHostAndPort("hub");
                    } else {
                        hub = $65822de42ac1fb15$var$getEmulatorHostAndPort("hub", fnOrHub);
                        if (!maybeFn) throw new Error("The callback function must be specified!");
                    }
                    if (!hub) throw new Error("Please specify the Emulator Hub host and port via arguments or set the environment " + "varible ".concat($65822de42ac1fb15$var$EMULATOR_HOST_ENV_VARS.hub, "!"));
                    hub.host = $65822de42ac1fb15$var$fixHostname(hub.host);
                    $65822de42ac1fb15$var$makeUrl(hub, "/functions/disableBackgroundTriggers");
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$fetch__default["default"]($65822de42ac1fb15$var$makeUrl(hub, "/functions/disableBackgroundTriggers"), {
                            method: "PUT"
                        })
                    ];
                case 1:
                    disableRes = _a.sent();
                    if (!disableRes.ok) throw new Error("HTTP Error ".concat(disableRes.status, " when disabling functions triggers, are you using firebase-tools 8.13.0 or higher?"));
                    result = undefined;
                    _a.label = 2;
                case 2:
                    _a.trys.push([
                        2,
                        ,
                        4,
                        6
                    ]);
                    return [
                        4 /*yield*/ ,
                        maybeFn()
                    ];
                case 3:
                    result = _a.sent();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 4:
                    return [
                        4 /*yield*/ ,
                        $65822de42ac1fb15$var$fetch__default["default"]($65822de42ac1fb15$var$makeUrl(hub, "/functions/enableBackgroundTriggers"), {
                            method: "PUT"
                        })
                    ];
                case 5:
                    enableRes = _a.sent();
                    if (!enableRes.ok) throw new Error("HTTP Error ".concat(enableRes.status, " when enabling functions triggers, are you using firebase-tools 8.13.0 or higher?"));
                    return [
                        7 /*endfinally*/ 
                    ];
                case 6:
                    // Return the user's function result
                    return [
                        2 /*return*/ ,
                        result
                    ];
            }
        });
    });
}
/**
 * Assert the promise to be rejected with a "permission denied" error.
 *
 * Useful to assert a certain request to be denied by Security Rules. See example below.
 * This function recognizes permission-denied errors from Database, Firestore, and Storage JS SDKs.
 *
 * @param pr - the promise to be asserted
 * @returns a Promise that is fulfilled if pr is rejected with "permission denied". If pr is
 *          rejected with any other error or resolved, the returned promise rejects.
 * @public
 * @example
 * ```javascript
 * const unauthed = testEnv.unauthenticatedContext();
 * await assertFails(get(doc(unauthed.firestore(), '/private/doc'), { ... });
 * ```
 */ function $65822de42ac1fb15$var$assertFails(pr) {
    return pr.then(function() {
        return Promise.reject(new Error("Expected request to fail, but it succeeded."));
    }, function(err) {
        var _a, _b;
        var errCode = ((_a = err === null || err === void 0 ? void 0 : err.code) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
        var errMessage = ((_b = err === null || err === void 0 ? void 0 : err.message) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
        var isPermissionDenied = errCode === "permission-denied" || errCode === "permission_denied" || errMessage.indexOf("permission_denied") >= 0 || errMessage.indexOf("permission denied") >= 0 || // Storage permission errors contain message: (storage/unauthorized)
        errMessage.indexOf("unauthorized") >= 0;
        if (!isPermissionDenied) return Promise.reject(new Error("Expected PERMISSION_DENIED but got unexpected error: ".concat(err)));
        return err;
    });
}
/**
 * Assert the promise to be successful.
 *
 * This is a no-op function returning the passed promise as-is, but can be used for documentational
 * purposes in test code to emphasize that a certain request should succeed (e.g. allowed by rules).
 *
 * @public
 * @example
 * ```javascript
 * const alice = testEnv.authenticatedContext('alice');
 * await assertSucceeds(get(doc(alice.firestore(), '/doc/readable/by/alice'), { ... });
 * ```
 */ function $65822de42ac1fb15$var$assertSucceeds(pr) {
    return pr;
}
$65822de42ac1fb15$exports.assertFails = $65822de42ac1fb15$var$assertFails;
$65822de42ac1fb15$exports.assertSucceeds = $65822de42ac1fb15$var$assertSucceeds;
$65822de42ac1fb15$exports.initializeTestEnvironment = $65822de42ac1fb15$var$initializeTestEnvironment;
$65822de42ac1fb15$exports.withFunctionTriggersDisabled = $65822de42ac1fb15$var$withFunctionTriggersDisabled;





var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");








parcelRequire("kjyEk");
async function $45ac2aaecfc15258$export$7f7d45814fc23e4d(env, col, data) {
    let ref;
    await env.withSecurityRulesDisabled(async (ctx)=>{
        const db = ctx.firestore();
        ref = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)(db, col), data);
        return;
    });
    return ref;
}
async function $45ac2aaecfc15258$export$4f68a2f34a26b63c(env, col, id) {
    let d;
    await env.withSecurityRulesDisabled(async (ctx)=>{
        const db = ctx.firestore();
        const ref = (0, $70fd6868680e912c$export$2a111da947c407d2)(db, col, id);
        d = (await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(ref)).data();
        if (d) // @ts-ignore
        d.id = ref.id;
    });
    return d;
}
async function $45ac2aaecfc15258$export$41f2425ba69261c7(env, col, id) {
    await env.withSecurityRulesDisabled(async (ctx)=>{
        const db = ctx.firestore();
        const ref = (0, $70fd6868680e912c$export$2a111da947c407d2)(db, col, id);
        await (0, $70fd6868680e912c$export$a4f20481fae8f78b)(ref);
    });
}
async function $45ac2aaecfc15258$export$c8feba313feda821(ms) {
    const fo = {
        id: "src/lib/services/__tests__/fixtures/PlanningDemo.miz",
        name: "My Frag Order"
    };
    const miz = await ms.download(fo.id);
    const [mission, dictionary, warehouses] = await (0, $0dc5bcacaa5e05aa$export$c05b9514531d5fff)(miz);
    const metadata = (0, $e1dc1ccf277543ba$export$b0887be10c72f2f9)(mission, warehouses, (0, $0dc5bcacaa5e05aa$export$7f3b48ada48e33da)(dictionary));
    return {
        // @ts-ignore
        file: {
            name: "myfile.miz",
            size: 0
        },
        metadata: metadata
    };
}
const $45ac2aaecfc15258$var$projectId = "fragorders-dev-8bb89";
async function $45ac2aaecfc15258$export$677e1c108e85f4cf() {
    return (0, $65822de42ac1fb15$exports.initializeTestEnvironment)({
        projectId: $45ac2aaecfc15258$var$projectId,
        firestore: {
            host: "localhost",
            port: 8080,
            rules: 'rules_version = "2";\nservice cloud.firestore {\n  match /databases/{database}/documents {\n    // Allow public read access, but only content owners can write\n    match /manifests/{document} {\n      allow read: if true\n      allow create: if request.auth.uid == request.resource.data.created_by_uid;\n      allow update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n    \n    match /FragOrders/{document} {\n      // Allow creation if authenticated; read/write scoped to creator\n      allow create: if request.auth != null;\n      allow read, update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n    \n    match /PublishManifests/{document} {\n    	// Allow public read access, but only content owners can write\n      allow read: if true\n      allow create: if request.auth.uid == request.resource.data.created_by_uid;\n      allow update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n    \n    match /Plans/{document} {\n    	// Allow public read access, but only content owners can write\n      allow read: if true\n      allow create: if request.auth.uid == request.resource.data.created_by_uid;\n      allow update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n    \n    match /FeatureFlagRecords/{document} {\n    	// Admin client only.\n      allow read: if false\n    }\n\n    match /SuperAdmins/{document} {\n      // Admin client only.\n      allow read: if false\n    }\n\n    match /Subscriptions/{document} {\n      // Admin client only.\n      // We might store patreon IDs and such here, so let the backend decide which fields are exposed.\n      allow read: if false\n    }\n\n    match /Assets/{document} {\n      // Allow public read access, but only content owners can write\n      allow read: if true\n      allow create: if request.auth.uid == request.resource.data.created_by_uid;\n      allow update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n\n    match /ControlMeasures/{document} {\n      // Allow public read access, but only content owners can write\n      allow read: if true\n      allow create: if request.auth.uid == request.resource.data.created_by_uid;\n      allow update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n    \n    match /SignupRecords/{document} {\n      // Public read, but only the backend can write.\n      allow read: if true\n      allow create, update, delete: if false\n    }\n\n    match /ExternalDataRecords/{document} {\n      // Allow public read access, but only content owners can write\n      allow read: if true\n      allow create: if request.auth.uid == request.resource.data.created_by_uid;\n      allow update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n\n    match /UserPreferences/{document} {\n      // Allow creation if authenticated; read/write scoped to creator\n      allow create: if request.auth != null;\n      allow read, update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n\n    match /VolumeRedeemRecord/{document} {\n      // Allow read/write access to public if authenticated.\n      // These codes will be send to randos who will redeem them.\n      allow create: if request.auth != null;\n      allow read, update: if request.auth != null;\n      allow delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n\n    match /PlanItems/{document} {\n      // Allow public read access, but only content owners can write\n      allow read: if true\n      allow create: if request.auth.uid == request.resource.data.created_by_uid;\n      allow update, delete: if request.auth.uid == resource.data.created_by_uid;\n    }\n  }\n}'
        }
    });
}
async function $45ac2aaecfc15258$export$9e6c6c56eff6ed4(env, userID) {
    const t = new Date().getTime();
    return $45ac2aaecfc15258$export$7f7d45814fc23e4d(env, (0, $50dfa3f756c4c37a$export$38accb2f941746a9), {
        name: "myfo",
        mizFileName: "mymission.miz",
        created_by_uid: userID,
        created_at_timestamp: t,
        updated_at_timestamp: t,
        mizFileSize: 0,
        mizMetadata: {},
        publishOpts: (0, $b88c63f4bcc6d929$export$f08daca113a61734)(),
        discordGuildID: "999"
    });
}
function $45ac2aaecfc15258$export$2e2bcd8739ae039(props) {
    const { components: components = [], children: children } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: components.reduceRight((acc, Comp)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)(Comp, {
                children: acc
            });
        }, children)
    });
}
const $45ac2aaecfc15258$export$86775893490a9f43 = (contexts)=>{
    return (component)=>{
        const tree = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reduce(contexts, (r, c)=>{
            const [Ctx, props] = c;
            r.push((otherProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Ctx, {
                    ...props,
                    ...otherProps
                }));
            return r;
        }, []);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($45ac2aaecfc15258$export$2e2bcd8739ae039, {
            components: tree,
            children: component
        });
    };
};
function $45ac2aaecfc15258$export$5687544133e73fbd() {
    return [
        [
            (0, $ccb8f828cefd6075$export$45604f0cc8ae667b),
            {
                client: new (0, $13e074efb1ecf7c6$export$405d0624ed55a03f)()
            }
        ],
        [
            (0, $9e9e9cb50078a9ef$export$186b91822010e97f),
            {}
        ],
        [
            (0, $5f078b543969ac27$export$38ee920e59704589).Provider,
            {
                value: {
                    currentUser: {
                        id: "6868"
                    }
                }
            }
        ]
    ];
}
function $45ac2aaecfc15258$export$36935c0ca3039a8f(component, url, additionalContexts) {
    const history = (0, $2756f79476f0245f$export$2b76ad033c6e6d08)();
    history.push(url || "");
    return $45ac2aaecfc15258$export$86775893490a9f43([
        ...$45ac2aaecfc15258$export$5687544133e73fbd(),
        ...additionalContexts
    ])(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
        history: history,
        children: component
    }));
}
function $45ac2aaecfc15258$export$469967246971e2a9(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while(counter < length){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}



var $ijOKP = parcelRequire("ijOKP");
const $db2db21855bd19e8$export$bca14c5b3b88a9c9 = (0, $ijOKP.default)({
    palette: {
        background: {
            default: "#e3e3e3"
        }
    }
});




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







function $7066692e20f21333$export$2e2bcd8739ae039() {
    const { mode: mode } = $acw62.useContext((0, $84a59591ecbdf222$export$122994dc05ba4308));
    const { login: login } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($3ecb7368762fc268$exports))).parse(window.location.search);
    $acw62.useEffect(()=>{
        login(query.code).then(()=>{
            const next = localStorage.getItem("callbackNext");
            localStorage.removeItem("callbackNext");
            if (mode === (0, $cd93687958c8007e$export$e5d97828673c2a38).Admin) {
                history.push(next || (0, $91a9098e14452db2$export$37d3279522fbf5e2).Home);
                return;
            }
            if (mode === (0, $cd93687958c8007e$export$e5d97828673c2a38).Public) history.push(next);
        }).catch(()=>history.push((0, $91a9098e14452db2$export$37d3279522fbf5e2).Login));
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        title: "",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {})
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");
parcelRequire("c9Z8w");

var $kyRHb = parcelRequire("kyRHb");

var $d8seH = parcelRequire("d8seH");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $e8aa9eabd3007a18$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");




var $ayMG0 = parcelRequire("ayMG0");
const $ad5c6c214f96507f$var$BreadcrumbCollapsedButton = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039))(({ theme: theme })=>(0, $8nd05.default)({
        display: "flex",
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === "light" ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        "&:hover, &:focus": (0, $8nd05.default)({}, theme.palette.mode === "light" ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        "&:active": (0, $8nd05.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === "light" ? {
            backgroundColor: (0, $kyRHb.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $kyRHb.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $ad5c6c214f96507f$var$BreadcrumbCollapsedIcon = (0, $d8seH.default)((0, $e8aa9eabd3007a18$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $ad5c6c214f96507f$var$BreadcrumbCollapsed(props) {
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedButton, (0, $8nd05.default)({
            focusRipple: true
        }, props, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedIcon, {
                ownerState: ownerState
            })
        }))
    });
}
var $ad5c6c214f96507f$export$2e2bcd8739ae039 = $ad5c6c214f96507f$var$BreadcrumbCollapsed;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $3109febd55ba98e0$export$17261110b18c8084(slot) {
    return (0, $9XEW1.default)("MuiBreadcrumbs", slot);
}
const $3109febd55ba98e0$var$breadcrumbsClasses = (0, $7u6PA.default)("MuiBreadcrumbs", [
    "root",
    "ol",
    "li",
    "separator"
]);
var $3109febd55ba98e0$export$2e2bcd8739ae039 = $3109febd55ba98e0$var$breadcrumbsClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $3beee71e1808c2fa$var$_excluded = [
    "children",
    "className",
    "component",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $3beee71e1808c2fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        li: [
            "li"
        ],
        ol: [
            "ol"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $9971e.default)(slots, (0, $3109febd55ba98e0$export$17261110b18c8084), classes);
};
const $3beee71e1808c2fa$var$BreadcrumbsRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $3109febd55ba98e0$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $3beee71e1808c2fa$var$BreadcrumbsOl = (0, $d8seH.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles)=>styles.ol
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
const $3beee71e1808c2fa$var$BreadcrumbsSeparator = (0, $d8seH.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
});
function $3beee71e1808c2fa$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $3beee71e1808c2fa$var$Breadcrumbs = /*#__PURE__*/ $acw62.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiBreadcrumbs"
    });
    const { children: children, className: className, component: component = "nav", expandText: expandText = "Show path", itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = "/" } = props, other = (0, $1En50.default)(props, $3beee71e1808c2fa$var$_excluded);
    const [expanded, setExpanded] = $acw62.useState(false);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $3beee71e1808c2fa$var$useUtilityClasses(ownerState);
    const listRef = $acw62.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
            if (focusable) focusable.focus();
        }; // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ad5c6c214f96507f$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $acw62.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $acw62.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsRoot, (0, $8nd05.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $3beee71e1808c2fa$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $3beee71e1808c2fa$export$2e2bcd8739ae039 = $3beee71e1808c2fa$var$Breadcrumbs;



var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");

var $jTnBY = parcelRequire("jTnBY");


var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $9XEW1.default)("MuiSwitch", slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $7u6PA.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $56ccc0421702a0be$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $jTnBY.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $5f063e1b0f6d278b$export$39f6debbec19b3ba), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300],
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.palette.mode === "light" ? 0.12 : 0.2
        },
        [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        "&:hover": {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
            color: theme.palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (0, $kyRHb.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.palette.mode === "light" ? (0, $kyRHb.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $kyRHb.darken)(theme.palette[ownerState.color].main, 0.55)
            }
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: theme.palette[ownerState.color].main
        }
    }));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white,
        opacity: theme.palette.mode === "light" ? 0.38 : 0.3
    }));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: theme.shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $1En50.default)(props, $56ccc0421702a0be$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($56ccc0421702a0be$var$SwitchRoot, {
        className: (0, $1SA7b.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, (0, $8nd05.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $8nd05.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");
var $b342ef7cdf5e20bb$exports = {};
"use strict";

Object.defineProperty($b342ef7cdf5e20bb$exports, "__esModule", {
    value: true
});
$b342ef7cdf5e20bb$exports.default = void 0;

var $b342ef7cdf5e20bb$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b342ef7cdf5e20bb$var$_default = (0, $b342ef7cdf5e20bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
}), "HelpOutline");
$b342ef7cdf5e20bb$exports.default = $b342ef7cdf5e20bb$var$_default;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $jTnBY = parcelRequire("jTnBY");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $63302c123a5539bd$export$e7545bb336f9a5fc(slot) {
    return (0, $9XEW1.default)("MuiIcon", slot);
}
const $63302c123a5539bd$var$iconClasses = (0, $7u6PA.default)("MuiIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $63302c123a5539bd$export$2e2bcd8739ae039 = $63302c123a5539bd$var$iconClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $93c87ddcceadf9a1$var$_excluded = [
    "baseClassName",
    "className",
    "color",
    "component",
    "fontSize"
];
const $93c87ddcceadf9a1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $63302c123a5539bd$export$e7545bb336f9a5fc), classes);
};
const $93c87ddcceadf9a1$var$IconRoot = (0, $d8seH.default)("span", {
    name: "MuiIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>({
        userSelect: "none",
        width: "1em",
        height: "1em",
        // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
        // To remove at some point.
        overflow: "hidden",
        display: "inline-block",
        // allow overflow hidden to take action
        textAlign: "center",
        // support non-square icon
        flexShrink: 0,
        fontSize: ({
            inherit: "inherit",
            small: theme.typography.pxToRem(20),
            medium: theme.typography.pxToRem(24),
            large: theme.typography.pxToRem(36)
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: ({
            primary: theme.palette.primary.main,
            secondary: theme.palette.secondary.main,
            info: theme.palette.info.main,
            success: theme.palette.success.main,
            warning: theme.palette.warning.main,
            action: theme.palette.action.active,
            error: theme.palette.error.main,
            disabled: theme.palette.action.disabled,
            inherit: undefined
        })[ownerState.color]
    }));
const $93c87ddcceadf9a1$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function Icon(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiIcon"
    });
    const { baseClassName: baseClassName = "material-icons", className: className, color: color = "inherit", component: Component = "span", fontSize: fontSize = "medium" } = props, other = (0, $1En50.default)(props, $93c87ddcceadf9a1$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    });
    const classes = $93c87ddcceadf9a1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($93c87ddcceadf9a1$var$IconRoot, (0, $8nd05.default)({
        as: Component,
        className: (0, $1SA7b.default)(baseClassName, // The font relies on the exact text content to render the icon.
        "notranslate", classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref
    }, other));
});
$93c87ddcceadf9a1$var$Icon.muiName = "Icon";
var $93c87ddcceadf9a1$export$2e2bcd8739ae039 = $93c87ddcceadf9a1$var$Icon;


parcelRequire("acw62");


function $4add6e1ce5f07b5e$var$DocsHelpIcon({ className: className, to: to, tooltip: tooltip = "View the docs" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        title: tooltip,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                className: className,
                target: "_blank",
                href: to,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93c87ddcceadf9a1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b342ef7cdf5e20bb$exports))), {
                        fontSize: "small"
                    })
                })
            })
        })
    });
}
var $4add6e1ce5f07b5e$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($4add6e1ce5f07b5e$var$DocsHelpIcon).attrs({
    className: $4add6e1ce5f07b5e$var$DocsHelpIcon.name
})``;





var $ayMG0 = parcelRequire("ayMG0");




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




var $63d3b55e22230398$export$97e73da130bb747d;
(function(UserPreferenceType) {
    UserPreferenceType["RadioPresetConfig"] = "RadioPresetConfig";
})($63d3b55e22230398$export$97e73da130bb747d || ($63d3b55e22230398$export$97e73da130bb747d = {}));
class $63d3b55e22230398$export$9eb786c5fec4a558 {
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $3f760351092dabf5$var$FastForm = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, onSubmit: onSubmit }, ref)=>{
    const handleSubmit = (ev)=>{
        ev.preventDefault();
        const form = ev.target;
        const formData = new FormData(form);
        const formJson = Object.fromEntries(formData.entries());
        onSubmit(formJson);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
        ref: ref,
        className: className,
        onSubmit: handleSubmit,
        children: children
    });
});
var $3f760351092dabf5$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($3f760351092dabf5$var$FastForm).attrs({
    className: $3f760351092dabf5$var$FastForm.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

const $42b5433bd31e97b0$var$Label = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ className: className, children: children, name: name, required: required })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
        className: className,
        htmlFor: name,
        required: required,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
            children: children
        })
    }))`
  label {
    margin-bottom: 4px;
  }
`;
var $42b5433bd31e97b0$export$2e2bcd8739ae039 = $42b5433bd31e97b0$var$Label;


const $b7be4946a3739679$var$debounced = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce((fn, v)=>fn(v), 250);
function $b7be4946a3739679$var$FastInput({ className: className, component: component, label: label, formatter: formatter, name: name, defaultValue: defaultValue, validator: validator, ...props }) {
    const [value, setValue] = $acw62.useState({
        text: defaultValue,
        invalid: null
    });
    const Component = component || (0, $bd6dc24e79fec2ce$export$2e2bcd8739ae039);
    $acw62.useEffect(()=>{
        if (defaultValue !== value.text) setValue({
            ...value,
            text: defaultValue
        });
    }, [
        defaultValue
    ]);
    $acw62.useEffect(()=>{
        $b7be4946a3739679$var$debounced((v)=>{
            let nextValid = value.invalid;
            if (validator) nextValid = validator(v);
            setValue({
                ...value,
                invalid: nextValid
            });
        }, value.text);
    }, [
        value.text
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42b5433bd31e97b0$export$2e2bcd8739ae039), {
                name: name,
                required: props.required,
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                error: !!value.invalid,
                id: `${name}-input`,
                variant: "outlined",
                ...props,
                onChange: (val)=>{
                    setValue({
                        text: val,
                        invalid: value.invalid
                    });
                },
                onBlur: ()=>{
                    if (formatter) setValue({
                        ...value,
                        text: formatter(value.text)
                    });
                },
                value: value.text,
                inputProps: {
                    name: name,
                    ...props.inputProps
                }
            }, name),
            value.invalid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                error: true,
                children: value.invalid
            })
        ]
    });
}
var $b7be4946a3739679$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b7be4946a3739679$var$FastInput).attrs({
    className: $b7be4946a3739679$var$FastInput.name
})``;




var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");



function $0a911c9875f80b1b$var$ImportFromPrefs({ className: className, onSubmit: onSubmit }) {
    const { data: prefs } = (0, $49b61c4bd4225956$export$764b58f9e83d22d4)();
    const [importMenuOpen, setImportOpen] = $acw62.useState(false);
    const [importFrom, setImportFrom] = $acw62.useState(null);
    const opts = prefs || [];
    const handleSelect = (name)=>{
        setImportFrom(name);
    };
    const handleImport = ()=>{
        const pref = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(opts, {
            name: importFrom
        });
        if (importFrom) {
            const d = JSON.parse(pref.payload);
            onSubmit(d);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        align: true,
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                onClick: handleImport,
                style: {
                    marginRight: 4
                },
                variant: "contained",
                disabled: !importFrom,
                children: "Import"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                size: "small",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                        id: "demo-simple-select-label",
                        children: "Import from Saved"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                        open: importMenuOpen,
                        onOpen: ()=>setImportOpen(true),
                        variant: "outlined",
                        onClose: ()=>setImportOpen(false),
                        labelId: "demo-simple-select-label",
                        id: "demo-simple-select",
                        value: importFrom || "",
                        label: "Import from Saved",
                        onChange: (e)=>{
                            handleSelect(e.target.value);
                        },
                        placeholder: "Import from Saved",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(opts, (c)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                value: c.name,
                                children: c.name
                            }, c.name))
                    })
                ]
            })
        ]
    });
}
var $0a911c9875f80b1b$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($0a911c9875f80b1b$var$ImportFromPrefs).attrs({
    className: $0a911c9875f80b1b$var$ImportFromPrefs.name
})`
  .MuiFormControl-root {
    width: 280px;
    box-sizing: border-box;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




function $a1493b4a7ae9e496$var$RadioPreferenceDialog({ className: className, open: open, onClose: onClose, saving: saving, onSubmit: onSubmit }) {
    const { data: prefs } = (0, $49b61c4bd4225956$export$764b58f9e83d22d4)();
    const [prefName, setPrefName] = $acw62.useState("");
    const handleSubmit = ()=>{
        const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(prefs, {
            name: prefName
        });
        if (existing) {
            if (window.confirm("Overwrite existing preference?")) onSubmit(prefName, true);
        } else onSubmit(prefName, false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        className: className,
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
            style: {
                minWidth: 480
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: "Save Presets",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginBottom: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    required: true,
                                    value: prefName,
                                    onChange: (e)=>{
                                        setPrefName(e.target.value);
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                        loading: saving,
                        style: {
                            marginRight: 8
                        },
                        variant: "contained",
                        type: "submit",
                        onClick: ()=>handleSubmit(),
                        disabled: !prefName,
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        variant: "outlined",
                        children: "Cancel"
                    })
                ]
            })
        })
    });
}
var $a1493b4a7ae9e496$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a1493b4a7ae9e496$var$RadioPreferenceDialog).attrs({
    className: $a1493b4a7ae9e496$var$RadioPreferenceDialog.name
})``;


const $8f9b4e265a6779f7$export$5c804c2e8d591b25 = [
    [
        {
            frequency: "305.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "264.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "265.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "256.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "254.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "250.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "270.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "257.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "255.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "262.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "259.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "268.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "269.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "260.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "263.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "261.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "267.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "251.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "253.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "266.000",
            modulation: 0,
            description: ""
        }
    ],
    [
        {
            frequency: "127.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "135.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "136.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "127.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "125.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "121.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "141.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "128.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "126.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "133.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "130.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "139.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "140.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "131.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "134.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "132.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "138.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "122.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "124.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "137.000",
            modulation: 0,
            description: ""
        }
    ],
    [
        {
            frequency: "305.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "264.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "265.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "256.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "254.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "250.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "270.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "257.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "255.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "262.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "259.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "268.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "269.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "260.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "263.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "261.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "267.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "251.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "253.000",
            modulation: 0,
            description: ""
        },
        {
            frequency: "266.000",
            modulation: 0,
            description: ""
        }
    ]
];



var $f1q41 = parcelRequire("f1q41");
function $9da876b744e7e4d8$export$ef69ad65ba64d2ba(formState) {
    const presets = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(formState, (v, k)=>{
        let [radioIdx, chan, key] = k.split(".");
        if (!presets[radioIdx]) presets[radioIdx] = [];
        if (!presets[radioIdx][chan]) presets[radioIdx][chan] = {};
        if (key === "frequency") presets[radioIdx][chan]["frequency"] = v;
        if (key === "modulation") presets[radioIdx][chan]["modulation"] = v === "FM" ? 1 : 0;
        if (key === "description") presets[radioIdx][chan]["description"] = v;
    });
    return presets;
}


const $b63c5194bedfa40d$var$TableContainer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  max-height: 720px;
  overflow: auto;

  th {
    background-color: #fff;
  }
`;
function $b63c5194bedfa40d$var$RadioChannelInput({ className: className, onSubmit: onSubmit, radios: radios, presets: presets, disabled: disabled, enableUserPreferenceActions: enableUserPreferenceActions = false }) {
    const { data: fo } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const [submitting, setSubmitting] = $acw62.useState(false);
    const [prefDialogOpen, setPrefDialogOpen] = $acw62.useState(false);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const saveToPrefs = (0, $49b61c4bd4225956$export$6c3b0ebb69540b34)();
    const [savingPref, setSavingPref] = $acw62.useState(false);
    const fileInputRef = $acw62.useRef();
    const [, setImportOpen] = $acw62.useState(false);
    const [state, setState] = $acw62.useState($b63c5194bedfa40d$var$initialState(radios, presets));
    const handleSubmit = (vals)=>{
        setSubmitting(true);
        const p = (0, $9da876b744e7e4d8$export$ef69ad65ba64d2ba)(vals);
        return onSubmit(p).finally(()=>{
            setSubmitting(false);
        });
    };
    const handleImporFromFile = ()=>{
        setImportOpen(false);
        const inpt = fileInputRef?.current;
        inpt.onchange = ()=>{
            let files = Array.from(inpt.files);
            const f = files[0];
            f.text().then((val)=>{
                const p = JSON.parse(val);
                const next = $b63c5194bedfa40d$var$initialState(radios, p);
                setState(next);
                inpt.value = null;
            });
        };
        inpt.click();
    };
    const handleSave = ()=>{
        const b = new Blob([
            JSON.stringify((0, $9da876b744e7e4d8$export$ef69ad65ba64d2ba)(state), null, 2)
        ]);
        (0, $90f256c567e4c320$exports.saveAs)(b, `FragOrders_Presets_${fo.name}.json`);
    };
    const handleSaveToPrefs = async (prefName)=>{
        setSavingPref(true);
        return saveToPrefs(prefName, (0, $63d3b55e22230398$export$97e73da130bb747d).RadioPresetConfig, (0, $9da876b744e7e4d8$export$ef69ad65ba64d2ba)(state)).then(()=>{
            success("Saved preset configuration");
        }).catch((e)=>{
            console.error(e);
            error("Error saving preset configuration: " + e.message);
        }).finally(()=>{
            setSavingPref(false);
            setPrefDialogOpen(false);
        });
    };
    const handleImportFromPrefs = (chans)=>{
        const next = $b63c5194bedfa40d$var$initialState(radios, chans);
        setState(next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3f760351092dabf5$export$2e2bcd8739ae039), {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b63c5194bedfa40d$var$TableContainer, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            wide: true,
                            between: true,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(radios, (r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    paddingRight: 4,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                                        stickyHeader: true,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            colSpan: 4,
                                                            children: r.label
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    width: 10
                                                                },
                                                                children: "Chan"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    width: 90
                                                                },
                                                                children: "Freq"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    width: 10
                                                                },
                                                                children: "AM/FM"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    width: 120
                                                                },
                                                                children: "Description"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).times(r.presetCount || 20, (t)=>{
                                                    const radio = radios[i];
                                                    if (!radio) return;
                                                    const chan = radio[t];
                                                    let mod = chan?.modulation;
                                                    if (!mod) {
                                                        const band = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(r.bands);
                                                        if (band === (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM) mod = (0, $91a9098e14452db2$export$459e66e1d1ce05ca).FM;
                                                    }
                                                    const name = $b63c5194bedfa40d$var$toKey(i, t, "frequency");
                                                    const freqValue = state[name];
                                                    const descValue = state[$b63c5194bedfa40d$var$toKey(i, t, "description")];
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                children: t + 1
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7be4946a3739679$export$2e2bcd8739ae039), {
                                                                    name: name,
                                                                    type: "number",
                                                                    size: "small",
                                                                    step: "any",
                                                                    formatter: (v)=>(0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(v),
                                                                    defaultValue: freqValue,
                                                                    disabled: disabled
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7be4946a3739679$export$2e2bcd8739ae039), {
                                                                    disabled: disabled,
                                                                    inputProps: {
                                                                        readOnly: true
                                                                    },
                                                                    name: $b63c5194bedfa40d$var$toKey(i, t, "modulation"),
                                                                    defaultValue: mod === (0, $91a9098e14452db2$export$459e66e1d1ce05ca).FM ? "FM" : "AM"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7be4946a3739679$export$2e2bcd8739ae039), {
                                                                    name: $b63c5194bedfa40d$var$toKey(i, t, "description"),
                                                                    size: "small",
                                                                    defaultValue: descValue,
                                                                    disabled: disabled
                                                                })
                                                            })
                                                        ]
                                                    }, t);
                                                })
                                            })
                                        ]
                                    })
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginY: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            wide: true,
                            between: true,
                            align: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                            loading: submitting,
                                            variant: "contained",
                                            type: "submit",
                                            disabled: disabled,
                                            children: "Submit"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            onClick: handleSave,
                                            style: {
                                                marginLeft: 8
                                            },
                                            variant: "outlined",
                                            disabled: disabled,
                                            children: "Export to File"
                                        }),
                                        enableUserPreferenceActions && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            onClick: ()=>setPrefDialogOpen(true),
                                            variant: "outlined",
                                            style: {
                                                marginLeft: 8
                                            },
                                            children: "Save Presets"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                        align: true,
                                        wide: true,
                                        children: [
                                            enableUserPreferenceActions && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                marginRight: 2,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a911c9875f80b1b$export$2e2bcd8739ae039), {
                                                    onSubmit: handleImportFromPrefs
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                                    disabled: disabled,
                                                    onClick: handleImporFromFile,
                                                    variant: "outlined",
                                                    children: "Import from File"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: fileInputRef,
                type: "file",
                accept: ".json",
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1493b4a7ae9e496$export$2e2bcd8739ae039), {
                onClose: ()=>setPrefDialogOpen(false),
                open: prefDialogOpen,
                onSubmit: handleSaveToPrefs,
                saving: savingPref
            })
        ]
    });
}
var $b63c5194bedfa40d$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b63c5194bedfa40d$var$RadioChannelInput).attrs({
    className: $b63c5194bedfa40d$var$RadioChannelInput.name
})`
  box-sizing: border-box;

  .MuiTable-root {
    min-width: 360px;

    th {
      text-align: left;
      padding: 0 4px;
    }

    td {
      padding: 4px;
    }

    input {
      font-size: 14px;
      padding: 4px;
    }
  }
`;
function $b63c5194bedfa40d$var$toKey(radioIdx, chan, key) {
    return `${radioIdx}.${chan}.${key}`;
}
function $b63c5194bedfa40d$var$initialState(radios, overrides) {
    const s = {};
    if (!overrides) // Reordering here because V/UHF is second
    overrides = [
        (0, $8f9b4e265a6779f7$export$5c804c2e8d591b25)[0],
        (0, $8f9b4e265a6779f7$export$5c804c2e8d591b25)[2],
        (0, $8f9b4e265a6779f7$export$5c804c2e8d591b25)[1]
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(radios, (r, i)=>{
        const modulation = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(r?.bands) === (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM ? 1 : 0;
        const count = radios[i]?.presetCount || 20;
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).times(count, (t)=>{
            const k = $b63c5194bedfa40d$var$toKey(i, t, "frequency");
            const ovr = overrides && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(overrides, [
                i,
                t
            ]);
            s[k] = (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(ovr, "frequency") || r[t]?.frequency);
            const dKey = $b63c5194bedfa40d$var$toKey(i, t, "description");
            s[dKey] = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(ovr, "description") || "";
            const mKey = $b63c5194bedfa40d$var$toKey(i, t, "modulation");
            s[mKey] = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(ovr, "modulation") || modulation;
        });
    });
    return s;
}




var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");




function $7b15fdc44ec68ec3$var$RadioHelp({ className: className, onClose: onClose }) {
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map((0, $b9c9d9c1adf94aca$export$cc2c248003684daa), (v)=>{
        return {
            name: v.label,
            radios: v.radioPresetOrder.map((o)=>o.replace("MIXED", "V/UHF")).join(", ").replace(/^, /, "")
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        title: "Radio Preset Help",
        className: className,
        actions: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                onClick: onClose,
                children: "Close"
            })
        ],
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: 'Frag Orders does a "best effort" when setting radios for a module. It attempts to keep radios with similar frequecy band capabilities synchronized with each other.'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "The following table shows the order in which radios are set for each module. ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "V/UHF"
                    }),
                    " radios will recieve the ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "V/UHF"
                    }),
                    " radio frequencies. In modules with several V/UHF radios, the first V/UHF radio will recieve the UHF frequencies."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                columns: [
                    {
                        value: "name",
                        label: "Module"
                    },
                    {
                        value: "radios",
                        label: "Programmable Radios"
                    }
                ],
                rows: rows
            })
        ]
    });
}
var $7b15fdc44ec68ec3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($7b15fdc44ec68ec3$var$RadioHelp).attrs({
    className: $7b15fdc44ec68ec3$var$RadioHelp.name
})``;


function $2d18edc80ae035d4$var$AdminRadios({ className: className }) {
    const [, setSubmitting] = $acw62.useState(false);
    const [submittingPlanners, setSubmittingPlanners] = $acw62.useState(false);
    const [radioHelpOpen, setRadioHelpOpen] = $acw62.useState(false);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const { data: fo } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const update = (0, $0a53c1f23450367c$export$4f91b3529d70dcc2)();
    const handleSubmit = (vals)=>{
        const jobSettings = {
            UHF: vals[0],
            "V/UHF": vals[1],
            VHF: vals[2]
        };
        return update({
            ...fo,
            jobs: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq([
                ...fo?.jobs || [],
                (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig
            ]),
            // @ts-ignore
            jobSettings: {
                ...fo?.jobSettings || {},
                [(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig]: JSON.stringify(jobSettings)
            }
        }, [
            (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue
        ]).then(()=>{
            success("Radio frequencies submited");
        }).catch((e)=>{
            error("Error submitting radio frequencies: " + e.message);
        }).finally(()=>{
            setSubmitting(false);
        });
    };
    const handleAllowPlanners = (e)=>{
        setSubmittingPlanners(true);
        return update({
            ...fo,
            publishOpts: {
                ...fo.publishOpts,
                allowPlannerRadioFreqs: e.target.checked
            }
        }, [
            (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue
        ]).then(()=>{
            success("Planner radio frequency permissions updated");
        }).catch((e)=>{
            error("Error updating planner radio frequency permissions: " + e.message);
        }).finally(()=>{
            setSubmittingPlanners(false);
        });
    };
    const cfg = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(fo, `jobSettings.${(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig}`, null);
    const parsed = $acw62.useMemo(()=>cfg ? JSON.parse(cfg) : null, [
        cfg
    ]);
    const presets = parsed ? [
        parsed.UHF || [],
        parsed["V/UHF"] || [],
        parsed.VHF || []
    ] : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    align: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: "RadioPresets"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            ml: 1,
                            pt: "4px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4add6e1ce5f07b5e$export$2e2bcd8739ae039), {
                                tooltip: "Radio Presets Help",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setRadioHelpOpen(true);
                                },
                                to: ""
                            })
                        })
                    ]
                }),
                actions: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                        style: {
                            height: 24
                        },
                        control: submittingPlanners ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                            size: 24,
                            style: {
                                marginRight: 8
                            }
                        }, "submitting") : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                            disabled: submittingPlanners,
                            onChange: handleAllowPlanners,
                            checked: fo?.publishOpts?.allowPlannerRadioFreqs || false
                        }),
                        label: "Allow planners to set radio frequencies"
                    }, "allow-planner")
                ],
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b63c5194bedfa40d$export$2e2bcd8739ae039), {
                        disabled: !!fo?.publishOpts?.allowPlannerRadioFreqs,
                        radios: [
                            {
                                label: "UHF",
                                presetCount: 20,
                                bands: [
                                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF
                                ],
                                short: "UHF"
                            },
                            {
                                label: "V/UHF",
                                presetCount: 20,
                                bands: [
                                    (0, $91a9098e14452db2$export$381ac33b868f60a4).UHF,
                                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                                ],
                                short: "V/UHF"
                            },
                            {
                                label: "VHF",
                                presetCount: 20,
                                bands: [
                                    (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF
                                ],
                                short: "VHF"
                            }
                        ],
                        onSubmit: handleSubmit,
                        presets: presets,
                        enableUserPreferenceActions: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: radioHelpOpen,
                onClose: ()=>setRadioHelpOpen(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
                    style: {
                        maxHeight: "80vh",
                        overflowY: "auto"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b15fdc44ec68ec3$export$2e2bcd8739ae039), {
                        onClose: ()=>setRadioHelpOpen(false)
                    })
                })
            })
        ]
    });
}
var $2d18edc80ae035d4$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($2d18edc80ae035d4$var$AdminRadios).attrs({
    className: $2d18edc80ae035d4$var$AdminRadios.name
})`
  ${(0, $b63c5194bedfa40d$export$2e2bcd8739ae039)} {
    /* max-width: 1024px; */
  }
`;



var $ayMG0 = parcelRequire("ayMG0");
var $e6d7c02ec7f0f0df$exports = {};
"use strict";

Object.defineProperty($e6d7c02ec7f0f0df$exports, "__esModule", {
    value: true
});
$e6d7c02ec7f0f0df$exports.default = void 0;

var $e6d7c02ec7f0f0df$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e6d7c02ec7f0f0df$var$_default = (0, $e6d7c02ec7f0f0df$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), "AddCircle");
$e6d7c02ec7f0f0df$exports.default = $e6d7c02ec7f0f0df$var$_default;





var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");


var $9971e = parcelRequire("9971e");
var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

// Give up on IE11 support for this feature
function $e0445b03efdc5232$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $e0445b03efdc5232$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $e0445b03efdc5232$var$stripDiacritics(input);
        const filteredOptions = options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $e0445b03efdc5232$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
} // To replace with .findIndex() once we stop IE11 support.
function $e0445b03efdc5232$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $e0445b03efdc5232$var$defaultFilterOptions = $e0445b03efdc5232$export$f76f94b238d946d8(); // Number of options to jump in list box when pageup and pagedown keys are used.
const $e0445b03efdc5232$var$pageSize = 5;
function $e0445b03efdc5232$export$2e2bcd8739ae039(props) {
    const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, disabled: disabledProp, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $e0445b03efdc5232$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $f649782d844a38be$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $3b481a8630784b69$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $3b481a8630784b69$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const prevValue = $acw62.useRef();
    $acw62.useEffect(()=>{
        const valueChange = value !== prevValue.current;
        prevValue.current = value;
        if (focused && !valueChange) return;
         // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        prevValue,
        freeSolo
    ]);
    const [open, setOpenState] = (0, $3b481a8630784b69$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    }); // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === filteredOptions.length || direction === "previous" && nextFocus === -1) return -1;
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`); // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && !option.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const setHighlightedIndex = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index; // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector('[role="option"].Mui-focused');
        if (prev) {
            prev.classList.remove("Mui-focused");
            prev.classList.remove("Mui-focusVisible");
        }
        const listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add("Mui-focused");
        if (reason === "keyboard") option.classList.add("Mui-focusVisible");
         // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
        //
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        }); // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        const valueItem = multiple ? value[0] : value; // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
         // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
            if (multiple && currentOption && $e0445b03efdc5232$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $e0445b03efdc5232$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        } // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        } // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        }); // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filteredOptions.length,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)((node)=>{
        (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (Array.isArray(value)) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $e0445b03efdc5232$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && !event.ctrlKey && !event.metaKey) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`); // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            } // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$e0445b03efdc5232$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $e0445b03efdc5232$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false; // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption"); // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (listboxRef.current !== null && listboxRef.current.parentElement.contains(document.activeElement)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseOver = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = ()=>{
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    }; // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    }; // Focus the input when interacting with the combobox
    const handleClick = ()=>{
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (inputValue === "" || !open) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $8nd05.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperativeley so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox"
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $8nd05.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseOver: handleOptionMouseOver,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}



var $kyRHb = parcelRequire("kyRHb");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $jTnBY = parcelRequire("jTnBY");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $9XEW1.default)("MuiListSubheader", slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $7u6PA.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $5408b2039b9d572c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $9971e.default)(slots, (0, $d7f4cf29715b69dd$export$6816d4fc0981ec7), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: theme.palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: theme.palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: theme.palette.background.paper
    }));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $1En50.default)(props, $5408b2039b9d572c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $kyRHb = parcelRequire("kyRHb");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $jTnBY = parcelRequire("jTnBY");


var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $9XEW1.default)("MuiChip", slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $7u6PA.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorPrimary",
    "colorSecondary",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "focusVisible"
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $47d4f79319086dc5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant"
];
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(color)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIconOutlinedColor${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $9971e.default)(slots, (0, $db0771a9e6a32b1d$export$31444911e4ee6fdd), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconOutlinedColor${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            variant === "outlined" && styles[`outlined${(0, $jTnBY.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const deleteIconColor = (0, $kyRHb.alpha)(theme.palette.text.primary, 0.26);
    return (0, $8nd05.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // label will inherit this from root, then `clickable` class overrides this for both
        cursor: "default",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: theme.palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: (0, $8nd05.default)({
            color: theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.color !== "default" && {
            color: "inherit"
        }),
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: (0, $8nd05.default)({
            WebkitTapHighlightColor: "transparent",
            color: deleteIconColor,
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: (0, $kyRHb.alpha)(deleteIconColor, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: (0, $kyRHb.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: theme.palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: theme.shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.palette.action.hover
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.palette.action.focus
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: theme.palette[ownerState.color].main,
        border: `1px solid ${(0, $kyRHb.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (0, $kyRHb.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: (0, $kyRHb.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: theme.palette[ownerState.color].main
            }
        }
    }));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }));
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled" } = props, other = (0, $1En50.default)(props, $47d4f79319086dc5$var$_excluded);
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const small = size === "small";
    const component = clickable || onDelete ? (0, $4a35786d89db9dda$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $4a35786d89db9dda$export$2e2bcd8739ae039) ? (0, $8nd05.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) {
        const customClasses = (0, $1SA7b.default)(color !== "default" && (variant === "outlined" ? classes[`deleteIconOutlinedColor${(0, $jTnBY.default)(color)}`] : classes[`deleteIconColor${(0, $jTnBY.default)(color)}`]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
            className: (0, $1SA7b.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62d1787512a69c15$export$2e2bcd8739ae039), {
            className: (0, $1SA7b.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $1SA7b.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $1SA7b.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $1SA7b.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;









var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $9XEW1.default)("MuiAutocomplete", slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $7u6PA.default)("MuiAutocomplete", [
    "root",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;



var $jTnBY = parcelRequire("jTnBY");

var $ayMG0 = parcelRequire("ayMG0");
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "value"
];
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $9971e.default)(slots, (0, $723a67e53eb4dc4c$export$8ee01529667e66d9), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused} .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: (0, $8nd05.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}`]: {
            padding: 9,
            [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
                padding: "7.5px 4px 7.5px 6px"
            },
            [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
            padding: 6,
            [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px 2.5px 6px"
            }
        },
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: (0, $8nd05.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $8nd05.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        zIndex: theme.zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: theme.palette.text.secondary,
        padding: "14px 16px"
    }));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: theme.palette.text.secondary,
        padding: "14px 16px"
    }));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: theme.palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: theme.palette.action.selected
                    }
                },
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: (0, $kyRHb.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $5408b2039b9d572c$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: theme.palette.background.paper,
        top: -8
    }));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    var _componentsProps$clea, _componentsProps$pape;
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7280bbf95507cba$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $a4669aa090d445bd$export$2e2bcd8739ae039), popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium" } = props, other = (0, $1En50.default)(props, $9396253983985262$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $e0445b03efdc5232$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const ownerState = (0, $8nd05.default)({}, props, {
        disablePortal: disablePortal,
        focused: focused,
        fullWidth: fullWidth,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $8nd05.default)({
                className: (0, $1SA7b.default)(classes.tag),
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), (0, $8nd05.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", (0, $8nd05.default)({}, props2, {
            children: getOptionLabel(option)
        }));
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $8nd05.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            inputValue: inputValue
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, (0, $8nd05.default)({
                ref: ref,
                className: (0, $1SA7b.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, (0, $8nd05.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, componentsProps.clearIndicator, {
                                    className: (0, $1SA7b.default)(classes.clearIndicator, (_componentsProps$clea = componentsProps.clearIndicator) == null ? void 0 : _componentsProps$clea.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, (0, $8nd05.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    className: (0, $1SA7b.default)(classes.popupIndicator),
                                    ownerState: ownerState,
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    },
                    inputProps: (0, $8nd05.default)({
                        className: (0, $1SA7b.default)(classes.input),
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            popupOpen && anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, {
                as: PopperComponent,
                className: (0, $1SA7b.default)(classes.popper),
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, (0, $8nd05.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, componentsProps.paper, {
                    className: (0, $1SA7b.default)(classes.paper, (_componentsProps$pape = componentsProps.paper) == null ? void 0 : _componentsProps$pape.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteListbox, (0, $8nd05.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, getListboxProps(), ListboxProps, {
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            }) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;



var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");


function $b11e7d507ec13d1e$var$GuildMemberAutocomplete({ className: className, guildID: guildID, displayName: displayName, onChange: onChange }) {
    const { data: members, isLoading: isLoading, value: value, setValue: search } = (0, $0ecfc9ca75a4d1c7$export$1217c50dac2ce8b8)(guildID);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
                    loading: isLoading,
                    onChange: (ev, val)=>{
                        const u = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(members, (m)=>m.nick === val || m?.user?.username === val);
                        const discordUserID = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(u, [
                            "user",
                            "id"
                        ]);
                        const displayName = u?.nick || u?.user.username;
                        onChange({
                            displayName: displayName,
                            discordUserID: discordUserID
                        });
                    },
                    renderInput: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            style: {
                                width: 320
                            },
                            required: true,
                            onChange: (ev)=>{
                                search(ev.target.value);
                            },
                            value: displayName || value,
                            label: "Username",
                            InputProps: {
                                endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {})
                                })
                            },
                            ...p
                        }),
                    options: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(members, (m)=>m.nick || m?.user?.username))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                    children: "Type to search for Discord members"
                })
            ]
        })
    });
}
var $b11e7d507ec13d1e$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b11e7d507ec13d1e$var$GuildMemberAutocomplete).attrs({
    className: $b11e7d507ec13d1e$var$GuildMemberAutocomplete.name
})``;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


function $a8f1fff4e2132a65$var$DiscordGuildLabel({ className: className, guild: guild, size: size = 24 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        className: className,
        start: true,
        align: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                sx: {
                    width: size,
                    height: size
                },
                alt: guild?.name,
                src: `https://cdn.discordapp.com/icons/${guild?.id}/${guild?.icon}.png?size=$${size}`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginLeft: 4
                },
                children: guild?.name
            })
        ]
    });
}
var $a8f1fff4e2132a65$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a8f1fff4e2132a65$var$DiscordGuildLabel).attrs({
    className: $a8f1fff4e2132a65$var$DiscordGuildLabel.name
})`
  .MuiAvatar-root {
    padding-top: 0;
  }
`;


function $30c876a2e6222a65$var$DiscordGuildSelect({ className: className, value: value, onChange: onChange }) {
    const { data: guilds, isLoading: isLoading } = (0, $6400a94b66d5ff2d$export$67c0493774f7721f)();
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                    id: "demo-simple-select-label",
                    children: "Discord Server"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                    label: "Discord Server",
                    id: "server",
                    variant: "outlined",
                    value: value || "",
                    onChange: (ev)=>onChange(ev.target.value, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(guilds, {
                            id: ev.target.value
                        })),
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(guilds, (g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                            value: g.id,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8f1fff4e2132a65$export$2e2bcd8739ae039), {
                                guild: g
                            })
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                    children: "Associate this Frag Order with a Discord Server for planning and sharing integration"
                })
            ]
        })
    });
}
var $30c876a2e6222a65$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($30c876a2e6222a65$var$DiscordGuildSelect).attrs({
    className: $30c876a2e6222a65$var$DiscordGuildSelect.name
})``;



function $13f33801a95b7a8c$var$NoDiscordGuildCallToAction({ className: className }) {
    const [associating, setAssociating] = $acw62.useState(false);
    const [discordGuild, setDiscord] = $acw62.useState(null);
    const { data: botDetected, isLoading: isLoading } = (0, $0ecfc9ca75a4d1c7$export$ae03fe1e5a2b9fd6)(discordGuild?.id);
    const { data: botAuthURL } = (0, $0ecfc9ca75a4d1c7$export$690569ca14db6e07)();
    const { data: fragOrder } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const { data: manifests } = (0, $0a53c1f23450367c$export$6f9969a28801a496)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const update = (0, $0a53c1f23450367c$export$4f91b3529d70dcc2)();
    const handleAssociate = ()=>{
        setAssociating(true);
        const ok = ()=>success("Frag Order updated successfully");
        const errHandler = (err)=>error(err.message);
        const final = ()=>setAssociating(false);
        return update({
            ...fragOrder,
            discordGuildID: discordGuild.id
        }, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, "coalition")).then(ok).catch(errHandler).finally(final);
    // onAssociate(discordGuild.id).then(ok).catch(errHandler).finally(final);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        className: className,
        wide: true,
        center: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            m: 2,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    center: true,
                    children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        style: {
                            display: botDetected ? "none" : "flex"
                        },
                        severity: "warning",
                        children: "No Discord Server associated with this Frag Order."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        m: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            children: "Frag Order permissions are managed via Discord users and roles. Select one of your Discord Servers below to manage which users can interact with this Frag Order."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    m: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        center: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30c876a2e6222a65$export$2e2bcd8739ae039), {
                            value: discordGuild?.id,
                            onChange: (id, guild)=>setDiscord(guild)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    m: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        center: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    marginY: 2,
                                    children: [
                                        discordGuild && botDetected && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                                            severity: "success",
                                            children: [
                                                "Frag Orders Bot detected for server",
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("q", {
                                                    children: discordGuild?.name
                                                })
                                            ]
                                        }),
                                        discordGuild && !botDetected && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                                            severity: "error",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                                                    children: "No Frag Orders bot detected"
                                                }),
                                                "You will need admin permissions for this Discord Server to add the bot."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    wide: true,
                                    center: true,
                                    children: [
                                        discordGuild && botDetected && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                        children: "It looks like the Frag Orders bot has already been added to this Discord server. You can click the button below to associate this Frag Order with the selected Discord server."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    marginY: 2,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                                        wide: true,
                                                        center: true,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                                            loading: associating,
                                                            onClick: handleAssociate,
                                                            variant: "contained",
                                                            children: "Associate with Discord Server"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        discordGuild && !botDetected && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                        children: "The Frag Orders bot was not detected for the selected Discord server. Click the button below to add the bot to your server."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    marginY: 2,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                                        wide: true,
                                                        center: true,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                                            disabled: !discordGuild,
                                                            variant: "contained",
                                                            href: botAuthURL,
                                                            target: "_blank",
                                                            children: "Add Frag Orders Bot"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var $13f33801a95b7a8c$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($13f33801a95b7a8c$var$NoDiscordGuildCallToAction).attrs({
    className: $13f33801a95b7a8c$var$NoDiscordGuildCallToAction.name
})``;




var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");





function $693656d589a16c87$var$SubmittedDrawingList({ className: className }) {
    const { data: fragOrder } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const { data: manifests } = (0, $0a53c1f23450367c$export$6f9969a28801a496)();
    const { data: controlMeasures } = (0, $302106ffa43351a6$export$71ef0e0adb83665)(manifests);
    const { data: users } = (0, $0ecfc9ca75a4d1c7$export$95dec5704e27cc89)(fragOrder.discordGuildID);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            columns: [
                {
                    value: "name",
                    label: "Name"
                },
                {
                    value: (cm)=>cm.geometry.getType(),
                    label: "Geometry Type"
                },
                {
                    label: "Color",
                    value: (cm)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                width: 24,
                                height: 24,
                                backgroundColor: cm.color
                            }
                        })
                },
                {
                    label: "Last Edited By",
                    value: (cm)=>{
                        const user = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(users, (u)=>u.user.id === cm.created_by_uid);
                        return user?.nick || user?.user?.username || "-";
                    }
                }
            ],
            rows: controlMeasures || []
        })
    });
}
var $693656d589a16c87$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($693656d589a16c87$var$SubmittedDrawingList).attrs({
    className: $693656d589a16c87$var$SubmittedDrawingList.name
})``;


function $4efb1624e884cf13$var$DrawingEditors({ className: className }) {
    const [nextEditors, setNextEditors] = $acw62.useState([]);
    const [removing, setRemoving] = $acw62.useState(null);
    const [updating, setUpdating] = $acw62.useState(false);
    const update = (0, $aae70ce689e02dd3$export$1d63914b63ab258e)();
    const { data: fragOrder, isLoading: isLoading } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const { data: manifests } = (0, $0a53c1f23450367c$export$6f9969a28801a496)();
    const { error: error, success: success } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const showCTA = !isLoading && !fragOrder?.discordGuildID;
    const handleSubmit = (e)=>{
        e.preventDefault();
        setUpdating(true);
        const work = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, (manifest)=>{
            const editors = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(nextEditors, (ed)=>ed.discordUserID && ed.displayName && ed.coalition === manifest.coalition);
            if (editors.length === 0) return Promise.resolve();
            const p = update(manifest, [
                ...manifest?.controlMeasureEditors || [],
                ...editors
            ]);
            return p;
        });
        return Promise.all(work).then(()=>{
            success("Successfully updated drawing editors");
        }).catch((err)=>{
            console.error(err);
            error(err.message);
        }).finally(()=>{
            setUpdating(false);
            setNextEditors([]);
        });
    };
    const handleChangeEditor = (index, editor)=>{
        const next = [
            ...nextEditors
        ];
        next[index] = editor;
        setNextEditors(next);
    };
    const handleRemove = (manifest, editor)=>{
        setRemoving(editor);
        const next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reject(manifest.controlMeasureEditors, editor);
        return update(manifest, next).finally(()=>setRemoving(null));
    };
    if (showCTA) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        title: "Control Measure Editors",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            center: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "h6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13f33801a95b7a8c$export$2e2bcd8739ae039), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: "Control Measure Editors",
                children: [
                    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, (manifest)=>{
                        const nextEditorsForCoalition = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(nextEditors, {
                            coalition: manifest.coalition
                        });
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    color: manifest.coalition,
                                    fontSize: 18,
                                    fontWeight: 600,
                                    children: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(manifest.coalition),
                                        " Control Measure Editors"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                                    columns: [
                                        {
                                            label: "Name",
                                            value: "displayName"
                                        },
                                        {
                                            label: "",
                                            value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                                    loading: removing?.discordUserID === r.discordUserID && removing.coalition === manifest.coalition,
                                                    onClick: ()=>{
                                                        handleRemove(manifest, r);
                                                    },
                                                    variant: "outlined",
                                                    color: "error",
                                                    children: "Remove"
                                                })
                                        }
                                    ],
                                    rows: manifest.controlMeasureEditors
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: nextEditorsForCoalition.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(nextEditors, (editor, i)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            my: 2,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b11e7d507ec13d1e$export$2e2bcd8739ae039), {
                                                    displayName: editor.displayName,
                                                    discordID: editor.discordUserID,
                                                    onChange: (editor)=>handleChangeEditor(i, {
                                                            ...editor,
                                                            coalition: manifest.coalition
                                                        }),
                                                    guildID: fragOrder.discordGuildID
                                                })
                                            })
                                        }, i);
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        my: 2,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            variant: "outlined",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e6d7c02ec7f0f0df$exports))), {}),
                                            onClick: ()=>{
                                                const next = [
                                                    ...nextEditors
                                                ];
                                                next.push({
                                                    displayName: "",
                                                    discordUserID: null,
                                                    coalition: manifest.coalition
                                                });
                                                setNextEditors(next);
                                            },
                                            children: "Add Editor"
                                        })
                                    })
                                })
                            ]
                        }, manifest.id);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        my: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                            loading: updating,
                            type: "submit",
                            variant: "contained",
                            onClick: handleSubmit,
                            disabled: nextEditors.length === 0,
                            children: "Submit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                    title: "Submitted Control Measures",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $693656d589a16c87$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
}
var $4efb1624e884cf13$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($4efb1624e884cf13$var$DrawingEditors).attrs({
    className: $4efb1624e884cf13$var$DrawingEditors.name
})``;




var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");











var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $54f1185d5c2a9ece$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tabpanel",
        style: {
            width: "100%"
        },
        hidden: value !== index,
        id: `vertical-tabpanel-${index}`,
        "aria-labelledby": `vertical-tab-${index}`,
        ...other,
        children: value === index && children ? children : null
    });
}
var $54f1185d5c2a9ece$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($54f1185d5c2a9ece$var$TabPanel)``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");
var $79f00c956e46f4d6$exports = {};
"use strict";

Object.defineProperty($79f00c956e46f4d6$exports, "__esModule", {
    value: true
});
$79f00c956e46f4d6$exports.default = void 0;

var $79f00c956e46f4d6$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $79f00c956e46f4d6$var$_default = (0, $79f00c956e46f4d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
$79f00c956e46f4d6$exports.default = $79f00c956e46f4d6$var$_default;


var $ca4fd08777d4e412$exports = {};
"use strict";

Object.defineProperty($ca4fd08777d4e412$exports, "__esModule", {
    value: true
});
$ca4fd08777d4e412$exports.default = void 0;

var $ca4fd08777d4e412$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ca4fd08777d4e412$var$_default = (0, $ca4fd08777d4e412$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
$ca4fd08777d4e412$exports.default = $ca4fd08777d4e412$var$_default;


var $b7798996678e060e$exports = {};
"use strict";

Object.defineProperty($b7798996678e060e$exports, "__esModule", {
    value: true
});
$b7798996678e060e$exports.default = void 0;

var $b7798996678e060e$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b7798996678e060e$var$_default = (0, $b7798996678e060e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), "DeleteForever");
$b7798996678e060e$exports.default = $b7798996678e060e$var$_default;





var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


function $a3414cf9a8444960$var$EditableTable({ className: className, rows: rows, columns: columns, onSubmit: onSubmit, globalValidators: globalValidators, tableProps: tableProps = {} }) {
    const [invalidFields, setInvalidFields] = $acw62.useState([]);
    const [globalErrors, setGlobalErrors] = $acw62.useState([]);
    const [editingRows, setEditingRows] = $acw62.useState([]);
    const handleEditSubmit = (row, index)=>{
        setEditingRows((prev)=>prev.filter((i)=>i !== index));
        const updated = [
            ...rows
        ];
        updated[index] = editingRows[index];
        onSubmit(updated).then(()=>{
            setEditingRows((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(editingRows, (row, i)=>i !== index));
        });
    };
    const handleDeleteSubmit = (row, index)=>{
        if (window.confirm("Are you sure you want to delete this row?")) {
            setEditingRows((prev)=>prev.filter((i)=>i !== index));
            const updated = [
                ...rows
            ];
            updated.splice(index, 1);
            onSubmit(updated).then(()=>{
                setEditingRows((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(editingRows, (row, i)=>i !== index));
            });
        }
    };
    const validate = $acw62.useCallback((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce((er)=>{
        // Validate the rows
        const results = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(er, (row, index)=>{
            if (!row) return;
            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(columns, (col)=>{
                let val;
                if (typeof col.value === "function") val = col.value(row, index, index);
                else val = row[col.value];
                if (col.validators) (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(col.validators, (validator)=>{
                    const result = validator(val);
                    if (result) results.push({
                        fieldName: col.value,
                        errors: [
                            result
                        ],
                        rowIndex: index
                    });
                });
            });
        });
        setInvalidFields(results);
    }, 250), []);
    const globalValidate = $acw62.useCallback((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).debounce((rows)=>{
        const errors = [];
        if (rows.length === 0) return;
        // Run validators
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(globalValidators, (validator)=>{
            const result = validator(rows);
            if (result) errors.push(...result);
        });
        setGlobalErrors(errors);
    }, 500), []);
    $acw62.useEffect(()=>{
        if (editingRows.length === 0) return;
        validate(editingRows);
    }, [
        editingRows
    ]);
    $acw62.useEffect(()=>{
        globalValidate(rows);
    }, [
        rows
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            globalErrors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                severity: "warning",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                        children: "Validation Errors"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(globalErrors, (e, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: e.message
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                ...tableProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                            children: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(columns, (c, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        scope: "col",
                                        width: c.width,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: c.label
                                        })
                                    }, i)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    scope: "col"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                    scope: "col"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rows, (row, rowNum)=>{
                            const isEditing = !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(editingRows, rowNum);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                children: [
                                    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(columns, (col, colNum)=>{
                                        let val;
                                        const isEditable = col.editable !== false;
                                        if (isEditing) val = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(editingRows, [
                                            rowNum,
                                            col.value
                                        ]);
                                        else val = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isFunction(col.value) ? col.value(row, colNum, rowNum) : row[col.value];
                                        const Component = $a3414cf9a8444960$var$inputType(col.fieldType);
                                        const invalid = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(invalidFields, {
                                            fieldName: col.value,
                                            rowIndex: rowNum
                                        });
                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: isEditable && isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                                                variant: "outlined",
                                                value: val,
                                                error: invalid ? true : false,
                                                helperText: invalid ? invalid.errors.join(", ") : "",
                                                onChange: (e)=>{
                                                    const next = [
                                                        ...editingRows
                                                    ];
                                                    next[rowNum] = {
                                                        ...next[rowNum],
                                                        [col.value]: col.fieldType === "number" ? parseInt(e.target.value) : e.target.value
                                                    };
                                                    setEditingRows(next);
                                                }
                                            }) : val
                                        }, colNum);
                                    }),
                                    isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                        title: "Submit",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                            color: "success",
                                                            onClick: ()=>handleEditSubmit(row, rowNum),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca4fd08777d4e412$exports))), {})
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                        title: "Cancel",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                            onClick: ()=>setEditingRows((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(editingRows, (row, i)=>i !== rowNum)),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79f00c956e46f4d6$exports))), {})
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                    title: "Edit",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                        onClick: ()=>{
                                                            const next = [
                                                                ...editingRows
                                                            ];
                                                            next[rowNum] = row;
                                                            setEditingRows(next);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                    title: "Delete",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                        onClick: ()=>handleDeleteSubmit(row, rowNum),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b7798996678e060e$exports))), {})
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, rowNum);
                        })
                    })
                ]
            })
        ]
    });
}
function $a3414cf9a8444960$var$inputType(type) {
    switch(type){
        case "text":
            return 0, $d8826083c5af4ea7$export$2e2bcd8739ae039;
        case "number":
            return 0, $d8826083c5af4ea7$export$2e2bcd8739ae039;
        case "boolean":
            return 0, $56ccc0421702a0be$export$2e2bcd8739ae039;
        default:
            return 0, $d8826083c5af4ea7$export$2e2bcd8739ae039;
    }
}
var $a3414cf9a8444960$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a3414cf9a8444960$var$EditableTable).attrs({
    className: $a3414cf9a8444960$var$EditableTable.name
})`
  font-size: 10px;

  input {
    font-size: 14px;
  }
`;




var $f1q41 = parcelRequire("f1q41");
function $faac0aa1a6bd41f6$export$9709949495acb61b(tasking) {
    const rows = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(tasking.plannedGroups, (group)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(group.units, (unit, i)=>{
            rows.push({
                groupName: group.name,
                playerName: "",
                flightNumber: i + 1,
                type: unit.type,
                iffMode1: 11,
                iffMode3: 11,
                tailNumber: unit.tailNumber,
                laserCode: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).padStart((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact(unit.laserCode).join(""), 4, "1"),
                stn: unit.aircraftProps.STN_L16 || unit.aircraftProps.OwnshipCallSign,
                voiceCallsignLabel: unit.aircraftProps.VoiceCallsignLabel,
                VoiceCallsignNumber: unit.aircraftProps.VoiceCallsignNumber
            });
        });
    });
    return rows;
}
const $faac0aa1a6bd41f6$export$929c2d4e93746bc6 = (length)=>(value)=>{
        if (value.length !== length) return `Field must be ${length} characters`;
    };
const $faac0aa1a6bd41f6$export$6ebec162d5dc6fb8 = (value)=>{
    const str = value.toString();
    if ($faac0aa1a6bd41f6$export$929c2d4e93746bc6(4)(str)) return "Field must be 4 characters";
    // Check that the last digit is between 1 and 8
    const last = str.charAt(value.length - 1);
    if (last < "1" || last > "8") return "Last digit must be between 1 and 8";
};
const $faac0aa1a6bd41f6$export$1cc2c12670f4ba0a = (rows)=>{
    const laserCodes = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rows, "laserCode"));
    if (laserCodes.length !== (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(laserCodes).length) {
        // Find the values that are duplicated
        const duplicateGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).chain(laserCodes).countBy().pickBy((v)=>v > 1).keys().value();
        return [
            {
                severity: "warning",
                message: `Duplicate laser codes found: ${duplicateGroups.join(", ")}`
            }
        ];
    }
    return [];
};
const $faac0aa1a6bd41f6$export$ef3fd6f23120b089 = (rows)=>{
    const iffs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rows, (r)=>`${r.iffMode1}${r.iffMode3}`);
    if (iffs.length !== (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniq(iffs).length) {
        const duplicateGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).chain(iffs).countBy().pickBy((v)=>v > 1).keys().value();
        return [
            {
                severity: "warning",
                message: `Duplicate IFF Mode 3 codes found: ${duplicateGroups.join(", ")}`
            }
        ];
    }
    return [];
};


function $d850e5cd3862dbdc$var$DataView({ className: className, record: record, filter: filter }) {
    const fragOrderID = (0, $0a53c1f23450367c$export$4bbd5a16ed9e7c94)();
    const upsert = (0, $6f6b89abe389e58a$export$8df626c21f17201f)(fragOrderID);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const rows = JSON.parse(record.payload);
    const filteredRows = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(rows, (row)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(row.groupName.toLowerCase(), filter.toLowerCase());
    });
    const cols = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(rows));
    if (!rows || rows.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        wide: true,
        center: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
            style: {
                width: "100%"
            },
            severity: "info",
            children: "No records found."
        })
    });
    const formattedCols = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(cols, (col)=>({
            value: col,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).startCase(col),
            fieldType: $d850e5cd3862dbdc$var$formatType(typeof (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(rows), col)),
            editable: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes($d850e5cd3862dbdc$var$getEditableFields(record.type), col),
            validators: $d850e5cd3862dbdc$var$getValidators(col)
        }));
    const handleEdit = (rows)=>{
        return upsert(record.type, record.coalition, JSON.stringify(rows)).then(()=>{
            success("External data updated.");
        }).catch((err)=>{
            error(err.message);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3414cf9a8444960$export$2e2bcd8739ae039), {
            onSubmit: handleEdit,
            columns: formattedCols,
            rows: filteredRows || [],
            tableProps: {
                stickyHeader: true
            },
            globalValidators: [
                (0, $faac0aa1a6bd41f6$export$1cc2c12670f4ba0a),
                (0, $faac0aa1a6bd41f6$export$ef3fd6f23120b089)
            ]
        })
    });
}
var $d850e5cd3862dbdc$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($d850e5cd3862dbdc$var$DataView).attrs({
    className: $d850e5cd3862dbdc$var$DataView.name
})`
  tbody td {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  tbody td:last-child {
    max-width: 240px;
  }

  table thead .MuiTableCell-stickyHeader {
    background-color: #fff;
  }
`;
function $d850e5cd3862dbdc$var$formatType(type) {
    if (type === "string") return "text";
    return type;
}
function $d850e5cd3862dbdc$var$getEditableFields(recordType) {
    switch(recordType){
        case (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).GroupAdminDetails:
            return [
                "aux"
            ];
        case (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails:
            return [
                "playerName",
                "iffMode1",
                "iffMode3",
                "tailNumber",
                "laserCode",
                "stn",
                "voiceCallsignLabel",
                "voiceCallsignNumber"
            ];
    }
}
function $d850e5cd3862dbdc$var$getValidators(field) {
    switch(field){
        // case "iffMode1":
        //   return [validateIFFMode1];
        // case "iffMode3":
        //   return [validateIFFMode3];
        // case "tailNumber":
        //   return [validateTailNumber];
        case "laserCode":
            return [
                (0, $faac0aa1a6bd41f6$export$6ebec162d5dc6fb8)
            ];
        // case "stn":
        //   return [validateSTN];
        // case "voiceCallsignLabel":
        //   return [validateVoiceCallsignLabel];
        // case "voiceCallsignNumber":
        //   return [validateVoiceCallsignNumber];
        default:
            return [];
    }
}



var $ayMG0 = parcelRequire("ayMG0");


var $eJrNq = parcelRequire("eJrNq");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");






function $59091ab3bf0ffa92$var$DownloadTemplateButton({ className: className, coalition: coalition, recordType: recordType }) {
    const bc = (0, $9fa5a1ec57c21134$export$84bdc398979fa84f)();
    const { data: manifests } = (0, $0a53c1f23450367c$export$d58792fea78fddc6)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const handleDownloadTemplate = $acw62.useCallback(async ()=>{
        try {
            const manifest = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
                coalition: coalition
            });
            const bundle = await bc.get(manifest);
            const tasking = JSON.parse(bundle);
            if (!tasking) throw new Error("No tasking found");
            let rows = [];
            switch(recordType){
                case (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails:
                    rows = (0, $faac0aa1a6bd41f6$export$9709949495acb61b)(tasking);
                    break;
                case (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).GroupAdminDetails:
                    // Currently unused. Left over from external data
                    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(tasking.plannedGroups, (group)=>{
                        rows.push({
                            groupName: group.name,
                            auxFrequency: 251,
                            tacanChannelLow: "11X",
                            remarks: "Some remarks..."
                        });
                    });
                    break;
                default:
                    break;
            }
            const csv = (0, $eJrNq.stringify)(rows, {
                header: true
            });
            (0, $90f256c567e4c320$exports.saveAs)(new Blob([
                csv
            ], {
                type: "text/csv"
            }), `${recordType}Template.csv`);
            success("Downloaded template");
        } catch (e) {
            console.error(e);
            error(e.message);
        }
    }, [
        manifests,
        coalition,
        recordType
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
        className: className,
        onClick: handleDownloadTemplate,
        variant: "outlined",
        children: "Download CSV"
    });
}
var $59091ab3bf0ffa92$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($59091ab3bf0ffa92$var$DownloadTemplateButton).attrs({
    className: $59091ab3bf0ffa92$var$DownloadTemplateButton.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");


var $7d5e0210243299ed$export$d9d08b09962b4c23;
var $7d5e0210243299ed$export$7acfa6ed01010e37;
var $7d5e0210243299ed$export$98e6a39c04603d36;

var $6ZWSX = parcelRequire("6ZWSX");
var $7d5e0210243299ed$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $ioRHp = parcelRequire("ioRHp");
const $7d5e0210243299ed$var$is_object = function(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};
class $7d5e0210243299ed$var$CsvError extends Error {
    constructor(code, message, options, ...contexts){
        if (Array.isArray(message)) message = message.join(" ").trim();
        super(message);
        if (Error.captureStackTrace !== undefined) Error.captureStackTrace(this, $7d5e0210243299ed$var$CsvError);
        this.code = code;
        for (const context of contexts)for(const key in context){
            const value = context[key];
            this[key] = $7d5e0210243299ed$require$Buffer.isBuffer(value) ? value.toString(options.encoding) : value == null ? value : JSON.parse(JSON.stringify(value));
        }
    }
}
const $7d5e0210243299ed$var$normalize_columns_array = function(columns) {
    const normalizedColumns = [];
    for(let i = 0, l = columns.length; i < l; i++){
        const column = columns[i];
        if (column === undefined || column === null || column === false) normalizedColumns[i] = {
            disabled: true
        };
        else if (typeof column === "string") normalizedColumns[i] = {
            name: column
        };
        else if ($7d5e0210243299ed$var$is_object(column)) {
            if (typeof column.name !== "string") throw new $7d5e0210243299ed$var$CsvError("CSV_OPTION_COLUMNS_MISSING_NAME", [
                "Option columns missing name:",
                `property "name" is required at position ${i}`,
                "when column is an object literal"
            ]);
            normalizedColumns[i] = column;
        } else throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_COLUMN_DEFINITION", [
            "Invalid column definition:",
            "expect a string or a literal object,",
            `got ${JSON.stringify(column)} at position ${i}`
        ]);
    }
    return normalizedColumns;
};
class $7d5e0210243299ed$var$ResizeableBuffer {
    constructor(size = 100){
        this.size = size;
        this.length = 0;
        this.buf = $7d5e0210243299ed$require$Buffer.allocUnsafe(size);
    }
    prepend(val) {
        if ($7d5e0210243299ed$require$Buffer.isBuffer(val)) {
            const length = this.length + val.length;
            if (length >= this.size) {
                this.resize();
                if (length >= this.size) throw Error("INVALID_BUFFER_STATE");
            }
            const buf = this.buf;
            this.buf = $7d5e0210243299ed$require$Buffer.allocUnsafe(this.size);
            val.copy(this.buf, 0);
            buf.copy(this.buf, val.length);
            this.length += val.length;
        } else {
            const length = this.length++;
            if (length === this.size) this.resize();
            const buf = this.clone();
            this.buf[0] = val;
            buf.copy(this.buf, 1, 0, length);
        }
    }
    append(val) {
        const length = this.length++;
        if (length === this.size) this.resize();
        this.buf[length] = val;
    }
    clone() {
        return $7d5e0210243299ed$require$Buffer.from(this.buf.slice(0, this.length));
    }
    resize() {
        const length = this.length;
        this.size = this.size * 2;
        const buf = $7d5e0210243299ed$require$Buffer.allocUnsafe(this.size);
        this.buf.copy(buf, 0, 0, length);
        this.buf = buf;
    }
    toString(encoding) {
        if (encoding) return this.buf.slice(0, this.length).toString(encoding);
        else return Uint8Array.prototype.slice.call(this.buf.slice(0, this.length));
    }
    toJSON() {
        return this.toString("utf8");
    }
    reset() {
        this.length = 0;
    }
}
// white space characters
// https://en.wikipedia.org/wiki/Whitespace_character
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Character_Classes#Types
// \f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff
const $7d5e0210243299ed$var$np = 12;
const $7d5e0210243299ed$var$cr$1 = 13; // `\r`, carriage return, 0x0D in hexadécimal, 13 in decimal
const $7d5e0210243299ed$var$nl$1 = 10; // `\n`, newline, 0x0A in hexadecimal, 10 in decimal
const $7d5e0210243299ed$var$space = 32;
const $7d5e0210243299ed$var$tab = 9;
const $7d5e0210243299ed$var$init_state = function(options) {
    return {
        bomSkipped: false,
        bufBytesStart: 0,
        castField: options.cast_function,
        commenting: false,
        // Current error encountered by a record
        error: undefined,
        enabled: options.from_line === 1,
        escaping: false,
        escapeIsQuote: $7d5e0210243299ed$require$Buffer.isBuffer(options.escape) && $7d5e0210243299ed$require$Buffer.isBuffer(options.quote) && $7d5e0210243299ed$require$Buffer.compare(options.escape, options.quote) === 0,
        // columns can be `false`, `true`, `Array`
        expectedRecordLength: Array.isArray(options.columns) ? options.columns.length : undefined,
        field: new $7d5e0210243299ed$var$ResizeableBuffer(20),
        firstLineToHeaders: options.cast_first_line_to_header,
        needMoreDataSize: Math.max(// Skip if the remaining buffer smaller than comment
        options.comment !== null ? options.comment.length : 0, // Skip if the remaining buffer can be delimiter
        ...options.delimiter.map((delimiter)=>delimiter.length), // Skip if the remaining buffer can be escape sequence
        options.quote !== null ? options.quote.length : 0),
        previousBuf: undefined,
        quoting: false,
        stop: false,
        rawBuffer: new $7d5e0210243299ed$var$ResizeableBuffer(100),
        record: [],
        recordHasError: false,
        record_length: 0,
        recordDelimiterMaxLength: options.record_delimiter.length === 0 ? 0 : Math.max(...options.record_delimiter.map((v)=>v.length)),
        trimChars: [
            $7d5e0210243299ed$require$Buffer.from(" ", options.encoding)[0],
            $7d5e0210243299ed$require$Buffer.from("	", options.encoding)[0]
        ],
        wasQuoting: false,
        wasRowDelimiter: false,
        timchars: [
            $7d5e0210243299ed$require$Buffer.from($7d5e0210243299ed$require$Buffer.from([
                $7d5e0210243299ed$var$cr$1
            ], "utf8").toString(), options.encoding),
            $7d5e0210243299ed$require$Buffer.from($7d5e0210243299ed$require$Buffer.from([
                $7d5e0210243299ed$var$nl$1
            ], "utf8").toString(), options.encoding),
            $7d5e0210243299ed$require$Buffer.from($7d5e0210243299ed$require$Buffer.from([
                $7d5e0210243299ed$var$np
            ], "utf8").toString(), options.encoding),
            $7d5e0210243299ed$require$Buffer.from($7d5e0210243299ed$require$Buffer.from([
                $7d5e0210243299ed$var$space
            ], "utf8").toString(), options.encoding),
            $7d5e0210243299ed$require$Buffer.from($7d5e0210243299ed$require$Buffer.from([
                $7d5e0210243299ed$var$tab
            ], "utf8").toString(), options.encoding)
        ]
    };
};
const $7d5e0210243299ed$var$underscore = function(str) {
    return str.replace(/([A-Z])/g, function(_, match) {
        return "_" + match.toLowerCase();
    });
};
const $7d5e0210243299ed$var$normalize_options = function(opts) {
    const options = {};
    // Merge with user options
    for(const opt in opts)options[$7d5e0210243299ed$var$underscore(opt)] = opts[opt];
    // Normalize option `encoding`
    // Note: defined first because other options depends on it
    // to convert chars/strings into buffers.
    if (options.encoding === undefined || options.encoding === true) options.encoding = "utf8";
    else if (options.encoding === null || options.encoding === false) options.encoding = null;
    else if (typeof options.encoding !== "string" && options.encoding !== null) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_ENCODING", [
        "Invalid option encoding:",
        "encoding must be a string or null to return a buffer,",
        `got ${JSON.stringify(options.encoding)}`
    ], options);
    // Normalize option `bom`
    if (options.bom === undefined || options.bom === null || options.bom === false) options.bom = false;
    else if (options.bom !== true) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_BOM", [
        "Invalid option bom:",
        "bom must be true,",
        `got ${JSON.stringify(options.bom)}`
    ], options);
    // Normalize option `cast`
    options.cast_function = null;
    if (options.cast === undefined || options.cast === null || options.cast === false || options.cast === "") options.cast = undefined;
    else if (typeof options.cast === "function") {
        options.cast_function = options.cast;
        options.cast = true;
    } else if (options.cast !== true) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_CAST", [
        "Invalid option cast:",
        "cast must be true or a function,",
        `got ${JSON.stringify(options.cast)}`
    ], options);
    // Normalize option `cast_date`
    if (options.cast_date === undefined || options.cast_date === null || options.cast_date === false || options.cast_date === "") options.cast_date = false;
    else if (options.cast_date === true) options.cast_date = function(value) {
        const date = Date.parse(value);
        return !isNaN(date) ? new Date(date) : value;
    };
    else if (typeof options.cast_date !== "function") throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_CAST_DATE", [
        "Invalid option cast_date:",
        "cast_date must be true or a function,",
        `got ${JSON.stringify(options.cast_date)}`
    ], options);
    // Normalize option `columns`
    options.cast_first_line_to_header = null;
    if (options.columns === true) // Fields in the first line are converted as-is to columns
    options.cast_first_line_to_header = undefined;
    else if (typeof options.columns === "function") {
        options.cast_first_line_to_header = options.columns;
        options.columns = true;
    } else if (Array.isArray(options.columns)) options.columns = $7d5e0210243299ed$var$normalize_columns_array(options.columns);
    else if (options.columns === undefined || options.columns === null || options.columns === false) options.columns = false;
    else throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_COLUMNS", [
        "Invalid option columns:",
        "expect an array, a function or true,",
        `got ${JSON.stringify(options.columns)}`
    ], options);
    // Normalize option `group_columns_by_name`
    if (options.group_columns_by_name === undefined || options.group_columns_by_name === null || options.group_columns_by_name === false) options.group_columns_by_name = false;
    else if (options.group_columns_by_name !== true) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME", [
        "Invalid option group_columns_by_name:",
        "expect an boolean,",
        `got ${JSON.stringify(options.group_columns_by_name)}`
    ], options);
    else if (options.columns === false) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME", [
        "Invalid option group_columns_by_name:",
        "the `columns` mode must be activated."
    ], options);
    // Normalize option `comment`
    if (options.comment === undefined || options.comment === null || options.comment === false || options.comment === "") options.comment = null;
    else {
        if (typeof options.comment === "string") options.comment = $7d5e0210243299ed$require$Buffer.from(options.comment, options.encoding);
        if (!$7d5e0210243299ed$require$Buffer.isBuffer(options.comment)) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_COMMENT", [
            "Invalid option comment:",
            "comment must be a buffer or a string,",
            `got ${JSON.stringify(options.comment)}`
        ], options);
    }
    // Normalize option `delimiter`
    const delimiter_json = JSON.stringify(options.delimiter);
    if (!Array.isArray(options.delimiter)) options.delimiter = [
        options.delimiter
    ];
    if (options.delimiter.length === 0) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_DELIMITER", [
        "Invalid option delimiter:",
        "delimiter must be a non empty string or buffer or array of string|buffer,",
        `got ${delimiter_json}`
    ], options);
    options.delimiter = options.delimiter.map(function(delimiter) {
        if (delimiter === undefined || delimiter === null || delimiter === false) return $7d5e0210243299ed$require$Buffer.from(",", options.encoding);
        if (typeof delimiter === "string") delimiter = $7d5e0210243299ed$require$Buffer.from(delimiter, options.encoding);
        if (!$7d5e0210243299ed$require$Buffer.isBuffer(delimiter) || delimiter.length === 0) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_DELIMITER", [
            "Invalid option delimiter:",
            "delimiter must be a non empty string or buffer or array of string|buffer,",
            `got ${delimiter_json}`
        ], options);
        return delimiter;
    });
    // Normalize option `escape`
    if (options.escape === undefined || options.escape === true) options.escape = $7d5e0210243299ed$require$Buffer.from('"', options.encoding);
    else if (typeof options.escape === "string") options.escape = $7d5e0210243299ed$require$Buffer.from(options.escape, options.encoding);
    else if (options.escape === null || options.escape === false) options.escape = null;
    if (options.escape !== null) {
        if (!$7d5e0210243299ed$require$Buffer.isBuffer(options.escape)) throw new Error(`Invalid Option: escape must be a buffer, a string or a boolean, got ${JSON.stringify(options.escape)}`);
    }
    // Normalize option `from`
    if (options.from === undefined || options.from === null) options.from = 1;
    else {
        if (typeof options.from === "string" && /\d+/.test(options.from)) options.from = parseInt(options.from);
        if (Number.isInteger(options.from)) {
            if (options.from < 0) throw new Error(`Invalid Option: from must be a positive integer, got ${JSON.stringify(opts.from)}`);
        } else throw new Error(`Invalid Option: from must be an integer, got ${JSON.stringify(options.from)}`);
    }
    // Normalize option `from_line`
    if (options.from_line === undefined || options.from_line === null) options.from_line = 1;
    else {
        if (typeof options.from_line === "string" && /\d+/.test(options.from_line)) options.from_line = parseInt(options.from_line);
        if (Number.isInteger(options.from_line)) {
            if (options.from_line <= 0) throw new Error(`Invalid Option: from_line must be a positive integer greater than 0, got ${JSON.stringify(opts.from_line)}`);
        } else throw new Error(`Invalid Option: from_line must be an integer, got ${JSON.stringify(opts.from_line)}`);
    }
    // Normalize options `ignore_last_delimiters`
    if (options.ignore_last_delimiters === undefined || options.ignore_last_delimiters === null) options.ignore_last_delimiters = false;
    else if (typeof options.ignore_last_delimiters === "number") {
        options.ignore_last_delimiters = Math.floor(options.ignore_last_delimiters);
        if (options.ignore_last_delimiters === 0) options.ignore_last_delimiters = false;
    } else if (typeof options.ignore_last_delimiters !== "boolean") throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_IGNORE_LAST_DELIMITERS", [
        "Invalid option `ignore_last_delimiters`:",
        "the value must be a boolean value or an integer,",
        `got ${JSON.stringify(options.ignore_last_delimiters)}`
    ], options);
    if (options.ignore_last_delimiters === true && options.columns === false) throw new $7d5e0210243299ed$var$CsvError("CSV_IGNORE_LAST_DELIMITERS_REQUIRES_COLUMNS", [
        "The option `ignore_last_delimiters`",
        "requires the activation of the `columns` option"
    ], options);
    // Normalize option `info`
    if (options.info === undefined || options.info === null || options.info === false) options.info = false;
    else if (options.info !== true) throw new Error(`Invalid Option: info must be true, got ${JSON.stringify(options.info)}`);
    // Normalize option `max_record_size`
    if (options.max_record_size === undefined || options.max_record_size === null || options.max_record_size === false) options.max_record_size = 0;
    else if (Number.isInteger(options.max_record_size) && options.max_record_size >= 0) ;
    else if (typeof options.max_record_size === "string" && /\d+/.test(options.max_record_size)) options.max_record_size = parseInt(options.max_record_size);
    else throw new Error(`Invalid Option: max_record_size must be a positive integer, got ${JSON.stringify(options.max_record_size)}`);
    // Normalize option `objname`
    if (options.objname === undefined || options.objname === null || options.objname === false) options.objname = undefined;
    else if ($7d5e0210243299ed$require$Buffer.isBuffer(options.objname)) {
        if (options.objname.length === 0) throw new Error(`Invalid Option: objname must be a non empty buffer`);
        if (options.encoding === null) ;
        else options.objname = options.objname.toString(options.encoding);
    } else if (typeof options.objname === "string") {
        if (options.objname.length === 0) throw new Error(`Invalid Option: objname must be a non empty string`);
    // Great, nothing to do
    } else if (typeof options.objname === "number") ;
    else throw new Error(`Invalid Option: objname must be a string or a buffer, got ${options.objname}`);
    if (options.objname !== undefined) {
        if (typeof options.objname === "number") {
            if (options.columns !== false) throw Error("Invalid Option: objname index cannot be combined with columns or be defined as a field");
        } else {
            if (options.columns === false) throw Error("Invalid Option: objname field must be combined with columns or be defined as an index");
        }
    }
    // Normalize option `on_record`
    if (options.on_record === undefined || options.on_record === null) options.on_record = undefined;
    else if (typeof options.on_record !== "function") throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_ON_RECORD", [
        "Invalid option `on_record`:",
        "expect a function,",
        `got ${JSON.stringify(options.on_record)}`
    ], options);
    // Normalize option `quote`
    if (options.quote === null || options.quote === false || options.quote === "") options.quote = null;
    else {
        if (options.quote === undefined || options.quote === true) options.quote = $7d5e0210243299ed$require$Buffer.from('"', options.encoding);
        else if (typeof options.quote === "string") options.quote = $7d5e0210243299ed$require$Buffer.from(options.quote, options.encoding);
        if (!$7d5e0210243299ed$require$Buffer.isBuffer(options.quote)) throw new Error(`Invalid Option: quote must be a buffer or a string, got ${JSON.stringify(options.quote)}`);
    }
    // Normalize option `raw`
    if (options.raw === undefined || options.raw === null || options.raw === false) options.raw = false;
    else if (options.raw !== true) throw new Error(`Invalid Option: raw must be true, got ${JSON.stringify(options.raw)}`);
    // Normalize option `record_delimiter`
    if (options.record_delimiter === undefined) options.record_delimiter = [];
    else if (typeof options.record_delimiter === "string" || $7d5e0210243299ed$require$Buffer.isBuffer(options.record_delimiter)) {
        if (options.record_delimiter.length === 0) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a non empty string or buffer,",
            `got ${JSON.stringify(options.record_delimiter)}`
        ], options);
        options.record_delimiter = [
            options.record_delimiter
        ];
    } else if (!Array.isArray(options.record_delimiter)) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_RECORD_DELIMITER", [
        "Invalid option `record_delimiter`:",
        "value must be a string, a buffer or array of string|buffer,",
        `got ${JSON.stringify(options.record_delimiter)}`
    ], options);
    options.record_delimiter = options.record_delimiter.map(function(rd, i) {
        if (typeof rd !== "string" && !$7d5e0210243299ed$require$Buffer.isBuffer(rd)) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a string, a buffer or array of string|buffer",
            `at index ${i},`,
            `got ${JSON.stringify(rd)}`
        ], options);
        else if (rd.length === 0) throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a non empty string or buffer",
            `at index ${i},`,
            `got ${JSON.stringify(rd)}`
        ], options);
        if (typeof rd === "string") rd = $7d5e0210243299ed$require$Buffer.from(rd, options.encoding);
        return rd;
    });
    // Normalize option `relax_column_count`
    if (typeof options.relax_column_count === "boolean") ;
    else if (options.relax_column_count === undefined || options.relax_column_count === null) options.relax_column_count = false;
    else throw new Error(`Invalid Option: relax_column_count must be a boolean, got ${JSON.stringify(options.relax_column_count)}`);
    if (typeof options.relax_column_count_less === "boolean") ;
    else if (options.relax_column_count_less === undefined || options.relax_column_count_less === null) options.relax_column_count_less = false;
    else throw new Error(`Invalid Option: relax_column_count_less must be a boolean, got ${JSON.stringify(options.relax_column_count_less)}`);
    if (typeof options.relax_column_count_more === "boolean") ;
    else if (options.relax_column_count_more === undefined || options.relax_column_count_more === null) options.relax_column_count_more = false;
    else throw new Error(`Invalid Option: relax_column_count_more must be a boolean, got ${JSON.stringify(options.relax_column_count_more)}`);
    // Normalize option `relax_quotes`
    if (typeof options.relax_quotes === "boolean") ;
    else if (options.relax_quotes === undefined || options.relax_quotes === null) options.relax_quotes = false;
    else throw new Error(`Invalid Option: relax_quotes must be a boolean, got ${JSON.stringify(options.relax_quotes)}`);
    // Normalize option `skip_empty_lines`
    if (typeof options.skip_empty_lines === "boolean") ;
    else if (options.skip_empty_lines === undefined || options.skip_empty_lines === null) options.skip_empty_lines = false;
    else throw new Error(`Invalid Option: skip_empty_lines must be a boolean, got ${JSON.stringify(options.skip_empty_lines)}`);
    // Normalize option `skip_records_with_empty_values`
    if (typeof options.skip_records_with_empty_values === "boolean") ;
    else if (options.skip_records_with_empty_values === undefined || options.skip_records_with_empty_values === null) options.skip_records_with_empty_values = false;
    else throw new Error(`Invalid Option: skip_records_with_empty_values must be a boolean, got ${JSON.stringify(options.skip_records_with_empty_values)}`);
    // Normalize option `skip_records_with_error`
    if (typeof options.skip_records_with_error === "boolean") ;
    else if (options.skip_records_with_error === undefined || options.skip_records_with_error === null) options.skip_records_with_error = false;
    else throw new Error(`Invalid Option: skip_records_with_error must be a boolean, got ${JSON.stringify(options.skip_records_with_error)}`);
    // Normalize option `rtrim`
    if (options.rtrim === undefined || options.rtrim === null || options.rtrim === false) options.rtrim = false;
    else if (options.rtrim !== true) throw new Error(`Invalid Option: rtrim must be a boolean, got ${JSON.stringify(options.rtrim)}`);
    // Normalize option `ltrim`
    if (options.ltrim === undefined || options.ltrim === null || options.ltrim === false) options.ltrim = false;
    else if (options.ltrim !== true) throw new Error(`Invalid Option: ltrim must be a boolean, got ${JSON.stringify(options.ltrim)}`);
    // Normalize option `trim`
    if (options.trim === undefined || options.trim === null || options.trim === false) options.trim = false;
    else if (options.trim !== true) throw new Error(`Invalid Option: trim must be a boolean, got ${JSON.stringify(options.trim)}`);
    // Normalize options `trim`, `ltrim` and `rtrim`
    if (options.trim === true && opts.ltrim !== false) options.ltrim = true;
    else if (options.ltrim !== true) options.ltrim = false;
    if (options.trim === true && opts.rtrim !== false) options.rtrim = true;
    else if (options.rtrim !== true) options.rtrim = false;
    // Normalize option `to`
    if (options.to === undefined || options.to === null) options.to = -1;
    else {
        if (typeof options.to === "string" && /\d+/.test(options.to)) options.to = parseInt(options.to);
        if (Number.isInteger(options.to)) {
            if (options.to <= 0) throw new Error(`Invalid Option: to must be a positive integer greater than 0, got ${JSON.stringify(opts.to)}`);
        } else throw new Error(`Invalid Option: to must be an integer, got ${JSON.stringify(opts.to)}`);
    }
    // Normalize option `to_line`
    if (options.to_line === undefined || options.to_line === null) options.to_line = -1;
    else {
        if (typeof options.to_line === "string" && /\d+/.test(options.to_line)) options.to_line = parseInt(options.to_line);
        if (Number.isInteger(options.to_line)) {
            if (options.to_line <= 0) throw new Error(`Invalid Option: to_line must be a positive integer greater than 0, got ${JSON.stringify(opts.to_line)}`);
        } else throw new Error(`Invalid Option: to_line must be an integer, got ${JSON.stringify(opts.to_line)}`);
    }
    return options;
};
const $7d5e0210243299ed$var$isRecordEmpty = function(record) {
    return record.every((field)=>field == null || field.toString && field.toString().trim() === "");
};
const $7d5e0210243299ed$var$cr = 13; // `\r`, carriage return, 0x0D in hexadécimal, 13 in decimal
const $7d5e0210243299ed$var$nl = 10; // `\n`, newline, 0x0A in hexadecimal, 10 in decimal
const $7d5e0210243299ed$var$boms = {
    // Note, the following are equals:
    // Buffer.from("\ufeff")
    // Buffer.from([239, 187, 191])
    // Buffer.from('EFBBBF', 'hex')
    "utf8": $7d5e0210243299ed$require$Buffer.from([
        239,
        187,
        191
    ]),
    // Note, the following are equals:
    // Buffer.from "\ufeff", 'utf16le
    // Buffer.from([255, 254])
    "utf16le": $7d5e0210243299ed$require$Buffer.from([
        255,
        254
    ])
};
const $7d5e0210243299ed$var$transform = function(original_options = {}) {
    const info = {
        bytes: 0,
        comment_lines: 0,
        empty_lines: 0,
        invalid_field_length: 0,
        lines: 1,
        records: 0
    };
    const options = $7d5e0210243299ed$var$normalize_options(original_options);
    return {
        info: info,
        original_options: original_options,
        options: options,
        state: $7d5e0210243299ed$var$init_state(options),
        __needMoreData: function(i, bufLen, end) {
            if (end) return false;
            const { encoding: encoding, escape: escape, quote: quote } = this.options;
            const { quoting: quoting, needMoreDataSize: needMoreDataSize, recordDelimiterMaxLength: recordDelimiterMaxLength } = this.state;
            const numOfCharLeft = bufLen - i - 1;
            const requiredLength = Math.max(needMoreDataSize, // Skip if the remaining buffer smaller than record delimiter
            // If "record_delimiter" is yet to be discovered:
            // 1. It is equals to `[]` and "recordDelimiterMaxLength" equals `0`
            // 2. We set the length to windows line ending in the current encoding
            // Note, that encoding is known from user or bom discovery at that point
            // recordDelimiterMaxLength,
            recordDelimiterMaxLength === 0 ? $7d5e0210243299ed$require$Buffer.from("\r\n", encoding).length : recordDelimiterMaxLength, // Skip if remaining buffer can be an escaped quote
            quoting ? (escape === null ? 0 : escape.length) + quote.length : 0, // Skip if remaining buffer can be record delimiter following the closing quote
            quoting ? quote.length + recordDelimiterMaxLength : 0);
            return numOfCharLeft < requiredLength;
        },
        // Central parser implementation
        parse: function(nextBuf, end, push, close) {
            const { bom: bom, encoding: encoding, from_line: from_line, ltrim: ltrim, max_record_size: max_record_size, raw: raw, relax_quotes: relax_quotes, rtrim: rtrim, skip_empty_lines: skip_empty_lines, to: to, to_line: to_line } = this.options;
            let { comment: comment, escape: escape, quote: quote, record_delimiter: record_delimiter } = this.options;
            const { bomSkipped: bomSkipped, previousBuf: previousBuf, rawBuffer: rawBuffer, escapeIsQuote: escapeIsQuote } = this.state;
            let buf;
            if (previousBuf === undefined) {
                if (nextBuf === undefined) {
                    // Handle empty string
                    close();
                    return;
                } else buf = nextBuf;
            } else if (previousBuf !== undefined && nextBuf === undefined) buf = previousBuf;
            else buf = $7d5e0210243299ed$require$Buffer.concat([
                previousBuf,
                nextBuf
            ]);
            // Handle UTF BOM
            if (bomSkipped === false) {
                if (bom === false) this.state.bomSkipped = true;
                else if (buf.length < 3) // No enough data
                {
                    if (end === false) {
                        // Wait for more data
                        this.state.previousBuf = buf;
                        return;
                    }
                } else {
                    for(const encoding in $7d5e0210243299ed$var$boms)if ($7d5e0210243299ed$var$boms[encoding].compare(buf, 0, $7d5e0210243299ed$var$boms[encoding].length) === 0) {
                        // Skip BOM
                        const bomLength = $7d5e0210243299ed$var$boms[encoding].length;
                        this.state.bufBytesStart += bomLength;
                        buf = buf.slice(bomLength);
                        // Renormalize original options with the new encoding
                        this.options = $7d5e0210243299ed$var$normalize_options({
                            ...this.original_options,
                            encoding: encoding
                        });
                        // Options will re-evaluate the Buffer with the new encoding
                        ({ comment: comment, escape: escape, quote: quote } = this.options);
                        break;
                    }
                    this.state.bomSkipped = true;
                }
            }
            const bufLen = buf.length;
            let pos;
            for(pos = 0; pos < bufLen; pos++){
                // Ensure we get enough space to look ahead
                // There should be a way to move this out of the loop
                if (this.__needMoreData(pos, bufLen, end)) break;
                if (this.state.wasRowDelimiter === true) {
                    this.info.lines++;
                    this.state.wasRowDelimiter = false;
                }
                if (to_line !== -1 && this.info.lines > to_line) {
                    this.state.stop = true;
                    close();
                    return;
                }
                // Auto discovery of record_delimiter, unix, mac and windows supported
                if (this.state.quoting === false && record_delimiter.length === 0) {
                    const record_delimiterCount = this.__autoDiscoverRecordDelimiter(buf, pos);
                    if (record_delimiterCount) record_delimiter = this.options.record_delimiter;
                }
                const chr = buf[pos];
                if (raw === true) rawBuffer.append(chr);
                if ((chr === $7d5e0210243299ed$var$cr || chr === $7d5e0210243299ed$var$nl) && this.state.wasRowDelimiter === false) this.state.wasRowDelimiter = true;
                // Previous char was a valid escape char
                // treat the current char as a regular char
                if (this.state.escaping === true) this.state.escaping = false;
                else {
                    // Escape is only active inside quoted fields
                    // We are quoting, the char is an escape chr and there is a chr to escape
                    // if(escape !== null && this.state.quoting === true && chr === escape && pos + 1 < bufLen){
                    if (escape !== null && this.state.quoting === true && this.__isEscape(buf, pos, chr) && pos + escape.length < bufLen) {
                        if (escapeIsQuote) {
                            if (this.__isQuote(buf, pos + escape.length)) {
                                this.state.escaping = true;
                                pos += escape.length - 1;
                                continue;
                            }
                        } else {
                            this.state.escaping = true;
                            pos += escape.length - 1;
                            continue;
                        }
                    }
                    // Not currently escaping and chr is a quote
                    // TODO: need to compare bytes instead of single char
                    if (this.state.commenting === false && this.__isQuote(buf, pos)) {
                        if (this.state.quoting === true) {
                            const nextChr = buf[pos + quote.length];
                            const isNextChrTrimable = rtrim && this.__isCharTrimable(buf, pos + quote.length);
                            const isNextChrComment = comment !== null && this.__compareBytes(comment, buf, pos + quote.length, nextChr);
                            const isNextChrDelimiter = this.__isDelimiter(buf, pos + quote.length, nextChr);
                            const isNextChrRecordDelimiter = record_delimiter.length === 0 ? this.__autoDiscoverRecordDelimiter(buf, pos + quote.length) : this.__isRecordDelimiter(nextChr, buf, pos + quote.length);
                            // Escape a quote
                            // Treat next char as a regular character
                            if (escape !== null && this.__isEscape(buf, pos, chr) && this.__isQuote(buf, pos + escape.length)) pos += escape.length - 1;
                            else if (!nextChr || isNextChrDelimiter || isNextChrRecordDelimiter || isNextChrComment || isNextChrTrimable) {
                                this.state.quoting = false;
                                this.state.wasQuoting = true;
                                pos += quote.length - 1;
                                continue;
                            } else if (relax_quotes === false) {
                                const err = this.__error(new $7d5e0210243299ed$var$CsvError("CSV_INVALID_CLOSING_QUOTE", [
                                    "Invalid Closing Quote:",
                                    `got "${String.fromCharCode(nextChr)}"`,
                                    `at line ${this.info.lines}`,
                                    "instead of delimiter, record delimiter, trimable character",
                                    "(if activated) or comment"
                                ], this.options, this.__infoField()));
                                if (err !== undefined) return err;
                            } else {
                                this.state.quoting = false;
                                this.state.wasQuoting = true;
                                this.state.field.prepend(quote);
                                pos += quote.length - 1;
                            }
                        } else {
                            if (this.state.field.length !== 0) // In relax_quotes mode, treat opening quote preceded by chrs as regular
                            {
                                if (relax_quotes === false) {
                                    const info = this.__infoField();
                                    const bom = Object.keys($7d5e0210243299ed$var$boms).map((b)=>$7d5e0210243299ed$var$boms[b].equals(this.state.field.toString()) ? b : false).filter(Boolean)[0];
                                    const err = this.__error(new $7d5e0210243299ed$var$CsvError("INVALID_OPENING_QUOTE", [
                                        "Invalid Opening Quote:",
                                        `a quote is found on field ${JSON.stringify(info.column)} at line ${info.lines}, value is ${JSON.stringify(this.state.field.toString(encoding))}`,
                                        bom ? `(${bom} bom)` : undefined
                                    ], this.options, info, {
                                        field: this.state.field
                                    }));
                                    if (err !== undefined) return err;
                                }
                            } else {
                                this.state.quoting = true;
                                pos += quote.length - 1;
                                continue;
                            }
                        }
                    }
                    if (this.state.quoting === false) {
                        const recordDelimiterLength = this.__isRecordDelimiter(chr, buf, pos);
                        if (recordDelimiterLength !== 0) {
                            // Do not emit comments which take a full line
                            const skipCommentLine = this.state.commenting && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0;
                            if (skipCommentLine) this.info.comment_lines++;
                            else {
                                // Activate records emition if above from_line
                                if (this.state.enabled === false && this.info.lines + (this.state.wasRowDelimiter === true ? 1 : 0) >= from_line) {
                                    this.state.enabled = true;
                                    this.__resetField();
                                    this.__resetRecord();
                                    pos += recordDelimiterLength - 1;
                                    continue;
                                }
                                // Skip if line is empty and skip_empty_lines activated
                                if (skip_empty_lines === true && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0) {
                                    this.info.empty_lines++;
                                    pos += recordDelimiterLength - 1;
                                    continue;
                                }
                                this.info.bytes = this.state.bufBytesStart + pos;
                                const errField = this.__onField();
                                if (errField !== undefined) return errField;
                                this.info.bytes = this.state.bufBytesStart + pos + recordDelimiterLength;
                                const errRecord = this.__onRecord(push);
                                if (errRecord !== undefined) return errRecord;
                                if (to !== -1 && this.info.records >= to) {
                                    this.state.stop = true;
                                    close();
                                    return;
                                }
                            }
                            this.state.commenting = false;
                            pos += recordDelimiterLength - 1;
                            continue;
                        }
                        if (this.state.commenting) continue;
                        const commentCount = comment === null ? 0 : this.__compareBytes(comment, buf, pos, chr);
                        if (commentCount !== 0) {
                            this.state.commenting = true;
                            continue;
                        }
                        const delimiterLength = this.__isDelimiter(buf, pos, chr);
                        if (delimiterLength !== 0) {
                            this.info.bytes = this.state.bufBytesStart + pos;
                            const errField = this.__onField();
                            if (errField !== undefined) return errField;
                            pos += delimiterLength - 1;
                            continue;
                        }
                    }
                }
                if (this.state.commenting === false) {
                    if (max_record_size !== 0 && this.state.record_length + this.state.field.length > max_record_size) return this.__error(new $7d5e0210243299ed$var$CsvError("CSV_MAX_RECORD_SIZE", [
                        "Max Record Size:",
                        "record exceed the maximum number of tolerated bytes",
                        `of ${max_record_size}`,
                        `at line ${this.info.lines}`
                    ], this.options, this.__infoField()));
                }
                const lappend = ltrim === false || this.state.quoting === true || this.state.field.length !== 0 || !this.__isCharTrimable(buf, pos);
                // rtrim in non quoting is handle in __onField
                const rappend = rtrim === false || this.state.wasQuoting === false;
                if (lappend === true && rappend === true) this.state.field.append(chr);
                else if (rtrim === true && !this.__isCharTrimable(buf, pos)) return this.__error(new $7d5e0210243299ed$var$CsvError("CSV_NON_TRIMABLE_CHAR_AFTER_CLOSING_QUOTE", [
                    "Invalid Closing Quote:",
                    "found non trimable byte after quote",
                    `at line ${this.info.lines}`
                ], this.options, this.__infoField()));
                else {
                    if (lappend === false) pos += this.__isCharTrimable(buf, pos) - 1;
                    continue;
                }
            }
            if (end === true) {
                // Ensure we are not ending in a quoting state
                if (this.state.quoting === true) {
                    const err = this.__error(new $7d5e0210243299ed$var$CsvError("CSV_QUOTE_NOT_CLOSED", [
                        "Quote Not Closed:",
                        `the parsing is finished with an opening quote at line ${this.info.lines}`
                    ], this.options, this.__infoField()));
                    if (err !== undefined) return err;
                } else {
                    // Skip last line if it has no characters
                    if (this.state.wasQuoting === true || this.state.record.length !== 0 || this.state.field.length !== 0) {
                        this.info.bytes = this.state.bufBytesStart + pos;
                        const errField = this.__onField();
                        if (errField !== undefined) return errField;
                        const errRecord = this.__onRecord(push);
                        if (errRecord !== undefined) return errRecord;
                    } else if (this.state.wasRowDelimiter === true) this.info.empty_lines++;
                    else if (this.state.commenting === true) this.info.comment_lines++;
                }
            } else {
                this.state.bufBytesStart += pos;
                this.state.previousBuf = buf.slice(pos);
            }
            if (this.state.wasRowDelimiter === true) {
                this.info.lines++;
                this.state.wasRowDelimiter = false;
            }
        },
        __onRecord: function(push) {
            const { columns: columns, group_columns_by_name: group_columns_by_name, encoding: encoding, info: info, from: from, relax_column_count: relax_column_count, relax_column_count_less: relax_column_count_less, relax_column_count_more: relax_column_count_more, raw: raw, skip_records_with_empty_values: skip_records_with_empty_values } = this.options;
            const { enabled: enabled, record: record } = this.state;
            if (enabled === false) return this.__resetRecord();
            // Convert the first line into column names
            const recordLength = record.length;
            if (columns === true) {
                if (skip_records_with_empty_values === true && $7d5e0210243299ed$var$isRecordEmpty(record)) {
                    this.__resetRecord();
                    return;
                }
                return this.__firstLineToColumns(record);
            }
            if (columns === false && this.info.records === 0) this.state.expectedRecordLength = recordLength;
            if (recordLength !== this.state.expectedRecordLength) {
                const err = columns === false ? new $7d5e0210243299ed$var$CsvError("CSV_RECORD_INCONSISTENT_FIELDS_LENGTH", [
                    "Invalid Record Length:",
                    `expect ${this.state.expectedRecordLength},`,
                    `got ${recordLength} on line ${this.info.lines}`
                ], this.options, this.__infoField(), {
                    record: record
                }) : new $7d5e0210243299ed$var$CsvError("CSV_RECORD_INCONSISTENT_COLUMNS", [
                    "Invalid Record Length:",
                    `columns length is ${columns.length},`,
                    `got ${recordLength} on line ${this.info.lines}`
                ], this.options, this.__infoField(), {
                    record: record
                });
                if (relax_column_count === true || relax_column_count_less === true && recordLength < this.state.expectedRecordLength || relax_column_count_more === true && recordLength > this.state.expectedRecordLength) {
                    this.info.invalid_field_length++;
                    this.state.error = err;
                // Error is undefined with skip_records_with_error
                } else {
                    const finalErr = this.__error(err);
                    if (finalErr) return finalErr;
                }
            }
            if (skip_records_with_empty_values === true && $7d5e0210243299ed$var$isRecordEmpty(record)) {
                this.__resetRecord();
                return;
            }
            if (this.state.recordHasError === true) {
                this.__resetRecord();
                this.state.recordHasError = false;
                return;
            }
            this.info.records++;
            if (from === 1 || this.info.records >= from) {
                const { objname: objname } = this.options;
                // With columns, records are object
                if (columns !== false) {
                    const obj = {};
                    // Transform record array to an object
                    for(let i = 0, l = record.length; i < l; i++){
                        if (columns[i] === undefined || columns[i].disabled) continue;
                        // Turn duplicate columns into an array
                        if (group_columns_by_name === true && obj[columns[i].name] !== undefined) {
                            if (Array.isArray(obj[columns[i].name])) obj[columns[i].name] = obj[columns[i].name].concat(record[i]);
                            else obj[columns[i].name] = [
                                obj[columns[i].name],
                                record[i]
                            ];
                        } else obj[columns[i].name] = record[i];
                    }
                    // Without objname (default)
                    if (raw === true || info === true) {
                        const extRecord = Object.assign({
                            record: obj
                        }, raw === true ? {
                            raw: this.state.rawBuffer.toString(encoding)
                        } : {}, info === true ? {
                            info: this.__infoRecord()
                        } : {});
                        const err = this.__push(objname === undefined ? extRecord : [
                            obj[objname],
                            extRecord
                        ], push);
                        if (err) return err;
                    } else {
                        const err = this.__push(objname === undefined ? obj : [
                            obj[objname],
                            obj
                        ], push);
                        if (err) return err;
                    }
                // Without columns, records are array
                } else if (raw === true || info === true) {
                    const extRecord = Object.assign({
                        record: record
                    }, raw === true ? {
                        raw: this.state.rawBuffer.toString(encoding)
                    } : {}, info === true ? {
                        info: this.__infoRecord()
                    } : {});
                    const err = this.__push(objname === undefined ? extRecord : [
                        record[objname],
                        extRecord
                    ], push);
                    if (err) return err;
                } else {
                    const err = this.__push(objname === undefined ? record : [
                        record[objname],
                        record
                    ], push);
                    if (err) return err;
                }
            }
            this.__resetRecord();
        },
        __firstLineToColumns: function(record) {
            const { firstLineToHeaders: firstLineToHeaders } = this.state;
            try {
                const headers = firstLineToHeaders === undefined ? record : firstLineToHeaders.call(null, record);
                if (!Array.isArray(headers)) return this.__error(new $7d5e0210243299ed$var$CsvError("CSV_INVALID_COLUMN_MAPPING", [
                    "Invalid Column Mapping:",
                    "expect an array from column function,",
                    `got ${JSON.stringify(headers)}`
                ], this.options, this.__infoField(), {
                    headers: headers
                }));
                const normalizedHeaders = $7d5e0210243299ed$var$normalize_columns_array(headers);
                this.state.expectedRecordLength = normalizedHeaders.length;
                this.options.columns = normalizedHeaders;
                this.__resetRecord();
                return;
            } catch (err) {
                return err;
            }
        },
        __resetRecord: function() {
            if (this.options.raw === true) this.state.rawBuffer.reset();
            this.state.error = undefined;
            this.state.record = [];
            this.state.record_length = 0;
        },
        __onField: function() {
            const { cast: cast, encoding: encoding, rtrim: rtrim, max_record_size: max_record_size } = this.options;
            const { enabled: enabled, wasQuoting: wasQuoting } = this.state;
            // Short circuit for the from_line options
            if (enabled === false) return this.__resetField();
            let field = this.state.field.toString(encoding);
            if (rtrim === true && wasQuoting === false) field = field.trimRight();
            if (cast === true) {
                const [err, f] = this.__cast(field);
                if (err !== undefined) return err;
                field = f;
            }
            this.state.record.push(field);
            // Increment record length if record size must not exceed a limit
            if (max_record_size !== 0 && typeof field === "string") this.state.record_length += field.length;
            this.__resetField();
        },
        __resetField: function() {
            this.state.field.reset();
            this.state.wasQuoting = false;
        },
        __push: function(record, push) {
            const { on_record: on_record } = this.options;
            if (on_record !== undefined) {
                const info = this.__infoRecord();
                try {
                    record = on_record.call(null, record, info);
                } catch (err) {
                    return err;
                }
                if (record === undefined || record === null) return;
            }
            push(record);
        },
        // Return a tuple with the error and the casted value
        __cast: function(field) {
            const { columns: columns, relax_column_count: relax_column_count } = this.options;
            const isColumns = Array.isArray(columns);
            // Dont loose time calling cast
            // because the final record is an object
            // and this field can't be associated to a key present in columns
            if (isColumns === true && relax_column_count && this.options.columns.length <= this.state.record.length) return [
                undefined,
                undefined
            ];
            if (this.state.castField !== null) try {
                const info = this.__infoField();
                return [
                    undefined,
                    this.state.castField.call(null, field, info)
                ];
            } catch (err) {
                return [
                    err
                ];
            }
            if (this.__isFloat(field)) return [
                undefined,
                parseFloat(field)
            ];
            else if (this.options.cast_date !== false) {
                const info = this.__infoField();
                return [
                    undefined,
                    this.options.cast_date.call(null, field, info)
                ];
            }
            return [
                undefined,
                field
            ];
        },
        // Helper to test if a character is a space or a line delimiter
        __isCharTrimable: function(buf, pos) {
            const isTrim = (buf, pos)=>{
                const { timchars: timchars } = this.state;
                loop1: for(let i = 0; i < timchars.length; i++){
                    const timchar = timchars[i];
                    for(let j = 0; j < timchar.length; j++){
                        if (timchar[j] !== buf[pos + j]) continue loop1;
                    }
                    return timchar.length;
                }
                return 0;
            };
            return isTrim(buf, pos);
        },
        // Keep it in case we implement the `cast_int` option
        // __isInt(value){
        //   // return Number.isInteger(parseInt(value))
        //   // return !isNaN( parseInt( obj ) );
        //   return /^(\-|\+)?[1-9][0-9]*$/.test(value)
        // }
        __isFloat: function(value) {
            return value - parseFloat(value) + 1 >= 0; // Borrowed from jquery
        },
        __compareBytes: function(sourceBuf, targetBuf, targetPos, firstByte) {
            if (sourceBuf[0] !== firstByte) return 0;
            const sourceLength = sourceBuf.length;
            for(let i = 1; i < sourceLength; i++){
                if (sourceBuf[i] !== targetBuf[targetPos + i]) return 0;
            }
            return sourceLength;
        },
        __isDelimiter: function(buf, pos, chr) {
            const { delimiter: delimiter, ignore_last_delimiters: ignore_last_delimiters } = this.options;
            if (ignore_last_delimiters === true && this.state.record.length === this.options.columns.length - 1) return 0;
            else if (ignore_last_delimiters !== false && typeof ignore_last_delimiters === "number" && this.state.record.length === ignore_last_delimiters - 1) return 0;
            loop1: for(let i = 0; i < delimiter.length; i++){
                const del = delimiter[i];
                if (del[0] === chr) {
                    for(let j = 1; j < del.length; j++){
                        if (del[j] !== buf[pos + j]) continue loop1;
                    }
                    return del.length;
                }
            }
            return 0;
        },
        __isRecordDelimiter: function(chr, buf, pos) {
            const { record_delimiter: record_delimiter } = this.options;
            const recordDelimiterLength = record_delimiter.length;
            loop1: for(let i = 0; i < recordDelimiterLength; i++){
                const rd = record_delimiter[i];
                const rdLength = rd.length;
                if (rd[0] !== chr) continue;
                for(let j = 1; j < rdLength; j++){
                    if (rd[j] !== buf[pos + j]) continue loop1;
                }
                return rd.length;
            }
            return 0;
        },
        __isEscape: function(buf, pos, chr) {
            const { escape: escape } = this.options;
            if (escape === null) return false;
            const l = escape.length;
            if (escape[0] === chr) {
                for(let i = 0; i < l; i++){
                    if (escape[i] !== buf[pos + i]) return false;
                }
                return true;
            }
            return false;
        },
        __isQuote: function(buf, pos) {
            const { quote: quote } = this.options;
            if (quote === null) return false;
            const l = quote.length;
            for(let i = 0; i < l; i++){
                if (quote[i] !== buf[pos + i]) return false;
            }
            return true;
        },
        __autoDiscoverRecordDelimiter: function(buf, pos) {
            const { encoding: encoding } = this.options;
            // Note, we don't need to cache this information in state,
            // It is only called on the first line until we find out a suitable
            // record delimiter.
            const rds = [
                // Important, the windows line ending must be before mac os 9
                $7d5e0210243299ed$require$Buffer.from("\r\n", encoding),
                $7d5e0210243299ed$require$Buffer.from("\n", encoding),
                $7d5e0210243299ed$require$Buffer.from("\r", encoding)
            ];
            loop: for(let i = 0; i < rds.length; i++){
                const l = rds[i].length;
                for(let j = 0; j < l; j++){
                    if (rds[i][j] !== buf[pos + j]) continue loop;
                }
                this.options.record_delimiter.push(rds[i]);
                this.state.recordDelimiterMaxLength = rds[i].length;
                return rds[i].length;
            }
            return 0;
        },
        __error: function(msg) {
            const { encoding: encoding, raw: raw, skip_records_with_error: skip_records_with_error } = this.options;
            const err = typeof msg === "string" ? new Error(msg) : msg;
            if (skip_records_with_error) {
                this.state.recordHasError = true;
                if (this.options.on_skip !== undefined) this.options.on_skip(err, raw ? this.state.rawBuffer.toString(encoding) : undefined);
                // this.emit('skip', err, raw ? this.state.rawBuffer.toString(encoding) : undefined);
                return undefined;
            } else return err;
        },
        __infoDataSet: function() {
            return {
                ...this.info,
                columns: this.options.columns
            };
        },
        __infoRecord: function() {
            const { columns: columns, raw: raw, encoding: encoding } = this.options;
            return {
                ...this.__infoDataSet(),
                error: this.state.error,
                header: columns === true,
                index: this.state.record.length,
                raw: raw ? this.state.rawBuffer.toString(encoding) : undefined
            };
        },
        __infoField: function() {
            const { columns: columns } = this.options;
            const isColumns = Array.isArray(columns);
            return {
                ...this.__infoRecord(),
                column: isColumns === true ? columns.length > this.state.record.length ? columns[this.state.record.length].name : null : this.state.record.length,
                quoting: this.state.wasQuoting
            };
        }
    };
};
class $7d5e0210243299ed$var$Parser extends $ioRHp.Transform {
    constructor(opts = {}){
        super({
            readableObjectMode: true,
            ...opts,
            encoding: null
        });
        this.api = $7d5e0210243299ed$var$transform(opts);
        this.api.options.on_skip = (err, chunk)=>{
            this.emit("skip", err, chunk);
        };
        // Backward compatibility
        this.state = this.api.state;
        this.options = this.api.options;
        this.info = this.api.info;
    }
    // Implementation of `Transform._transform`
    _transform(buf, encoding, callback) {
        if (this.state.stop === true) return;
        const err = this.api.parse(buf, false, (record)=>{
            this.push(record);
        }, ()=>{
            this.push(null);
            this.on("end", this.destroy);
        });
        if (err !== undefined) this.state.stop = true;
        callback(err);
    }
    // Implementation of `Transform._flush`
    _flush(callback) {
        if (this.state.stop === true) return;
        const err = this.api.parse(undefined, true, (record)=>{
            this.push(record);
        }, ()=>{
            this.push(null);
            this.on("end", this.destroy);
        });
        callback(err);
    }
}
const $7d5e0210243299ed$var$parse = function() {
    let data, options, callback;
    for(const i in arguments){
        const argument = arguments[i];
        const type = typeof argument;
        if (data === undefined && (typeof argument === "string" || $7d5e0210243299ed$require$Buffer.isBuffer(argument))) data = argument;
        else if (options === undefined && $7d5e0210243299ed$var$is_object(argument)) options = argument;
        else if (callback === undefined && type === "function") callback = argument;
        else throw new $7d5e0210243299ed$var$CsvError("CSV_INVALID_ARGUMENT", [
            "Invalid argument:",
            `got ${JSON.stringify(argument)} at index ${i}`
        ], options || {});
    }
    const parser = new $7d5e0210243299ed$var$Parser(options);
    if (callback) {
        const records = options === undefined || options.objname === undefined ? [] : {};
        parser.on("readable", function() {
            let record;
            while((record = this.read()) !== null)if (options === undefined || options.objname === undefined) records.push(record);
            else records[record[0]] = record[1];
        });
        parser.on("error", function(err) {
            callback(err, undefined, parser.api.__infoDataSet());
        });
        parser.on("end", function() {
            callback(undefined, records, parser.api.__infoDataSet());
        });
    }
    if (data !== undefined) {
        const writer = function() {
            parser.write(data);
            parser.end();
        };
        // Support Deno, Rollup doesnt provide a shim for setImmediate
        if (typeof setImmediate === "function") setImmediate(writer);
        else setTimeout(writer, 0);
    }
    return parser;
};
$7d5e0210243299ed$export$d9d08b09962b4c23 = $7d5e0210243299ed$var$CsvError;
$7d5e0210243299ed$export$7acfa6ed01010e37 = $7d5e0210243299ed$var$Parser;
$7d5e0210243299ed$export$98e6a39c04603d36 = $7d5e0210243299ed$var$parse;



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




function $f61e7f58c3c92146$var$CSVImport({ className: className, onSubmit: onSubmit, onError: onError, children: children, additionalActions: additionalActions, style: style = {}, previewStyle: previewStyle = {} }) {
    const [busy, setBusy] = $acw62.useState(false);
    const [rows, setRows] = $acw62.useState([]);
    const handleSubmit = ()=>{
        setBusy(true);
        return onSubmit(rows).catch(onError).finally(()=>{
            setBusy(false);
        });
    };
    const handleFileDrop = async (files)=>{
        const file = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(files);
        if (!file) return;
        const txt = await file.text();
        (0, $7d5e0210243299ed$export$98e6a39c04603d36)(txt, {
            columns: true,
            cast: true
        }, (err, output)=>{
            if (err) {
                onError(err);
                return;
            }
            setRows(output);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                my: 2,
                children: [
                    children,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        my: 2,
                        children: [
                            rows.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $880d05f11d0a3304$export$2e2bcd8739ae039), {
                                text: "Drag and Drop your .csv file here",
                                onFileDrop: handleFileDrop
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                style: previewStyle,
                                children: rows.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                                    columns: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(rows)), (c)=>{
                                        return {
                                            label: c,
                                            value: c
                                        };
                                    }),
                                    rows: rows
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginTop: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    between: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                            loading: busy,
                            disabled: rows.length === 0,
                            variant: "contained",
                            onClick: handleSubmit,
                            children: "Import"
                        }),
                        additionalActions
                    ]
                })
            })
        ]
    });
}
var $f61e7f58c3c92146$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($f61e7f58c3c92146$var$CSVImport).attrs({
    className: $f61e7f58c3c92146$var$CSVImport.name
})`
  tbody td {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  tbody td:last-child {
    max-width: 80px;
  }
`;





function $ea65a8e5c205681d$var$ImportModal({ className: className, open: open, onClose: onClose }) {
    const fragOrderID = (0, $0a53c1f23450367c$export$4bbd5a16ed9e7c94)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const submit = (0, $6f6b89abe389e58a$export$8df626c21f17201f)(fragOrderID);
    const [formData, setFormData] = $acw62.useState({
        coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue,
        recordType: (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails
    });
    const handleSubmit = (rows)=>{
        return submit(formData.recordType, formData.coalition, JSON.stringify(rows)).then(()=>{
            onClose();
            success("Imported external data successfully");
        }).catch((e)=>{
            console.error(e);
            error(e.message);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        className: className,
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
            style: {
                minWidth: 600
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: "Import Batch Edit Data",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                mr: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ea65a8e5c205681d$var$CoalitionSelect, {
                                    onChange: (ev)=>setFormData({
                                            ...formData,
                                            coalition: ev.target.value
                                        }),
                                    value: formData.coalition
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61e7f58c3c92146$export$2e2bcd8739ae039), {
                        onSubmit: handleSubmit,
                        onError: (err)=>error(err.message),
                        additionalActions: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59091ab3bf0ffa92$export$2e2bcd8739ae039), {
                            ...formData
                        }),
                        style: {
                            maxHeight: "80vh"
                        },
                        previewStyle: {
                            maxHeight: "60vh",
                            overflowY: "auto"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Import data from a CSV file."
                            })
                        })
                    })
                ]
            })
        })
    });
}
function $ea65a8e5c205681d$var$CoalitionSelect({ value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                children: "Coalition"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                value: value,
                onChange: onChange,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue,
                        children: "Blue"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red,
                        children: "Red"
                    })
                ]
            })
        ]
    });
}
var $ea65a8e5c205681d$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ea65a8e5c205681d$var$ImportModal).attrs({
    className: $ea65a8e5c205681d$var$ImportModal.name
})`
  min-width: 400px;
`;



function $dadcf0039068e3f7$var$ExternalData({ className: className }) {
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const [busy, setBusy] = $acw62.useState(false);
    const [filter, setFilter] = $acw62.useState("");
    const [importOpen, setImportOpen] = $acw62.useState(false);
    // only blue supported for now
    const [formData /*, setFormData*/ ] = $acw62.useState({
        coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue,
        recordType: (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails
    });
    const fragOrderID = (0, $0a53c1f23450367c$export$4bbd5a16ed9e7c94)();
    const submit = (0, $6f6b89abe389e58a$export$8df626c21f17201f)(fragOrderID);
    const remove = (0, $6f6b89abe389e58a$export$d321df0b0928cdb4)(fragOrderID);
    const { data: data, isLoading: isLoading } = (0, $6f6b89abe389e58a$export$a71275835f6fa47f)(fragOrderID, (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue);
    const { data: manifests, isLoading: manifestsLoading } = (0, $0a53c1f23450367c$export$d58792fea78fddc6)();
    const manifest = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
        coalition: formData.coalition
    });
    const { data: tasking, isLoading: isLoadingBundle } = (0, $aae70ce689e02dd3$export$f760ffd5af329347)(manifest);
    const hasData = data && data.length > 0;
    const record = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(data, {
        type: (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails
    });
    const handleBatchEditToggle = ()=>{
        if (hasData) {
            if (window.confirm("Are you sure you want to remove all batch edit data?")) {
                setBusy(true);
                // Only working with AdminDetails for now
                const record = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(data, {
                    type: (0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails
                });
                return remove(record).then(()=>{
                    success("Disabled batch edit.");
                }).catch((e)=>{
                    console.error(e);
                    error(e.message);
                }).finally(()=>{
                    setBusy(false);
                });
            }
            return;
        }
        const rows = (0, $faac0aa1a6bd41f6$export$9709949495acb61b)(tasking);
        setBusy(true);
        return submit((0, $d639ce2b0593ab0e$export$2edcab8dd1869daa).AircraftAdminDetails, formData.coalition, JSON.stringify(rows)).then(()=>{
            success("Enabled batch edit.");
        }).catch((e)=>{
            console.error(e);
            error(e.message);
        }).finally(()=>{
            setBusy(false);
        });
    };
    const handleImportClick = ()=>{
        setImportOpen(true);
    };
    if (isLoading || manifestsLoading || isLoadingBundle) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${className} ${hasData ? "takeover" : ""}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: "Batch Edit",
                actions: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        align: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                align: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    mr: 2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            size: "small",
                                            placeholder: "Filter",
                                            onChange: (ev)=>setFilter(ev.target.value),
                                            value: filter
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59091ab3bf0ffa92$export$2e2bcd8739ae039), {
                                recordType: formData.recordType,
                                coalition: formData.coalition
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                ml: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    disabled: !hasData,
                                    onClick: handleImportClick,
                                    variant: "outlined",
                                    color: "primary",
                                    style: {
                                        marginRight: 16
                                    },
                                    children: "Import from CSV"
                                }, "import")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                loading: busy,
                                variant: "contained",
                                color: hasData ? "error" : "primary",
                                onClick: handleBatchEditToggle,
                                children: hasData ? "Remove all" : "Import from Miz File"
                            }, "button")
                        ]
                    }, "actions")
                ],
                children: [
                    !hasData && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        severity: "info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                                children: "No batch edit data"
                            }),
                            "No batch edit data has been added to this Frag Order. Click the",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Import from Miz File"
                            }),
                            " button to get started."
                        ]
                    }),
                    hasData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        center: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d850e5cd3862dbdc$export$2e2bcd8739ae039), {
                            record: record,
                            filter: filter
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea65a8e5c205681d$export$2e2bcd8739ae039), {
                open: importOpen,
                onClose: ()=>setImportOpen(false)
            })
        ]
    });
}
var $dadcf0039068e3f7$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($dadcf0039068e3f7$var$ExternalData).attrs({
    className: $dadcf0039068e3f7$var$ExternalData.name
})`
  ${(0, $54f1185d5c2a9ece$export$2e2bcd8739ae039)} .Flex {
    justify-content: center;
    margin: 0 auto;
    width: 100%;
  }

  .MuiTabs-root {
    width: 200px;
  }
  .MuiButtonBase-root {
    white-space: nowrap;
    justify-content: center;
    align-items: flex-start;
  }

  /* Full width takeover */
  padding: 0 24px;
  padding-bottom: 24px;

  &.takeover {
    position: absolute;
    left: 0;
    right: 0;
  }

  ${(0, $926fc19b1a64a878$export$2e2bcd8739ae039)} {
    box-sizing: border-box;
    overflow: auto;
  }
`;




const $be582a387d00e7dd$var$FlexChild = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  ${({ alignStart: alignStart })=>alignStart && "align-self: flex-start"};
  ${({ grow: grow })=>grow && `flex-grow: ${grow}`};
`;
var $be582a387d00e7dd$export$2e2bcd8739ae039 = $be582a387d00e7dd$var$FlexChild;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $bOOlK = parcelRequire("bOOlK");

var $17r9Q = parcelRequire("17r9Q");
function $7c3aede628aa278f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $17r9Q.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7c3aede628aa278f$export$2e2bcd8739ae039 = $7c3aede628aa278f$var$merge;




var $6IaFk = parcelRequire("6IaFk");


var $8nd05 = parcelRequire("8nd05");
parcelRequire("c9Z8w");

var $17r9Q = parcelRequire("17r9Q");

const $2c79a5510dec9b08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2c79a5510dec9b08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$2c79a5510dec9b08$export$68c286be0e7e55b7[key]}px)`
};
function $2c79a5510dec9b08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2c79a5510dec9b08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2c79a5510dec9b08$var$breakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2c79a5510dec9b08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2c79a5510dec9b08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $17r9Q.default)(prev, next), {});
    return $2c79a5510dec9b08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
} // compute base for responsive values; e.g.,
function $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2c79a5510dec9b08$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous] || breakpointValues;
            previous = breakpoint;
        }
        return acc;
    }, {});
}
var $2c79a5510dec9b08$export$2e2bcd8739ae039 = $2c79a5510dec9b08$var$breakpoints;


function $e901fa2f27580273$export$2aa3fd96c49a84a8(obj, path) {
    if (!path || typeof path !== "string") return null;
     // Check if CSS variables are used
    if (obj && obj.vars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e901fa2f27580273$var$getValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e901fa2f27580273$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value);
    return value;
}
function $e901fa2f27580273$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e901fa2f27580273$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e901fa2f27580273$var$getValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $e901fa2f27580273$var$getValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $6IaFk.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e901fa2f27580273$export$2e2bcd8739ae039 = $e901fa2f27580273$var$style;



function $beedfc9d7e65f133$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $beedfc9d7e65f133$export$2e2bcd8739ae039 = $beedfc9d7e65f133$var$compose;






function $cb619e97db430627$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $94935f79a2c44a85$var$properties = {
    m: "margin",
    p: "padding"
};
const $94935f79a2c44a85$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $94935f79a2c44a85$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $94935f79a2c44a85$var$getCssProperties = (0, $cb619e97db430627$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($94935f79a2c44a85$var$aliases[prop]) prop = $94935f79a2c44a85$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $94935f79a2c44a85$var$properties[a];
    const direction = $94935f79a2c44a85$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $94935f79a2c44a85$var$marginKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $94935f79a2c44a85$var$paddingKeys = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $94935f79a2c44a85$var$spacingKeys = [
    ...$94935f79a2c44a85$var$marginKeys,
    ...$94935f79a2c44a85$var$paddingKeys
];
function $94935f79a2c44a85$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $e901fa2f27580273$export$2aa3fd96c49a84a8)(theme, themeKey)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $94935f79a2c44a85$export$1def6f833384e3d1(theme) {
    return $94935f79a2c44a85$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $94935f79a2c44a85$var$getCssProperties(prop);
    const styleFromPropValue = $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $94935f79a2c44a85$var$style(props, keys) {
    const transformer = $94935f79a2c44a85$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $7c3aede628aa278f$export$2e2bcd8739ae039), {});
}
function $94935f79a2c44a85$export$7ede87f9b603dd3c(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$marginKeys);
}
$94935f79a2c44a85$export$7ede87f9b603dd3c.propTypes = {};
$94935f79a2c44a85$export$7ede87f9b603dd3c.filterProps = $94935f79a2c44a85$var$marginKeys;
function $94935f79a2c44a85$export$6f98e8eaf0be1996(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$paddingKeys);
}
$94935f79a2c44a85$export$6f98e8eaf0be1996.propTypes = {};
$94935f79a2c44a85$export$6f98e8eaf0be1996.filterProps = $94935f79a2c44a85$var$paddingKeys;
function $94935f79a2c44a85$var$spacing(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$spacingKeys);
}
$94935f79a2c44a85$var$spacing.propTypes = {};
$94935f79a2c44a85$var$spacing.filterProps = $94935f79a2c44a85$var$spacingKeys;
var $94935f79a2c44a85$export$2e2bcd8739ae039 = $94935f79a2c44a85$var$spacing;



function $e39f6794db8cf9ac$var$getBorder(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $e39f6794db8cf9ac$export$1edee58a52776cd9 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "border",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$f9a7b6bd24892946 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$5abca33e6be905d2 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$e2ce9f12a980a822 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$47658cca1a909427 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$e7fb0694ba2404fc = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$126a92c968acdb85 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$340b0327727f6d1a = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$60beef91a985b4bf = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.propTypes = {};
$e39f6794db8cf9ac$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $e39f6794db8cf9ac$var$borders = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($e39f6794db8cf9ac$export$1edee58a52776cd9, $e39f6794db8cf9ac$export$f9a7b6bd24892946, $e39f6794db8cf9ac$export$5abca33e6be905d2, $e39f6794db8cf9ac$export$e2ce9f12a980a822, $e39f6794db8cf9ac$export$47658cca1a909427, $e39f6794db8cf9ac$export$e7fb0694ba2404fc, $e39f6794db8cf9ac$export$126a92c968acdb85, $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e, $e39f6794db8cf9ac$export$340b0327727f6d1a, $e39f6794db8cf9ac$export$60beef91a985b4bf, $e39f6794db8cf9ac$export$7a57f79000377ca2);
var $e39f6794db8cf9ac$export$2e2bcd8739ae039 = $e39f6794db8cf9ac$var$borders;




const $313e0a591bf5b524$export$95a5c40fb210fe3e = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "displayPrint",
    cssProperty: false,
    transform: (value)=>({
            "@media print": {
                display: value
            }
        })
});
const $313e0a591bf5b524$export$e5efd59aba9975ad = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "display"
});
const $313e0a591bf5b524$export$f6530fb6e67e00bd = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "overflow"
});
const $313e0a591bf5b524$export$f00f69a6f0e8c5b6 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "textOverflow"
});
const $313e0a591bf5b524$export$91fa9ac3f4021ce4 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "visibility"
});
const $313e0a591bf5b524$export$9ef81298ca34ad41 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "whiteSpace"
});
var $313e0a591bf5b524$export$2e2bcd8739ae039 = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($313e0a591bf5b524$export$95a5c40fb210fe3e, $313e0a591bf5b524$export$e5efd59aba9975ad, $313e0a591bf5b524$export$f6530fb6e67e00bd, $313e0a591bf5b524$export$f00f69a6f0e8c5b6, $313e0a591bf5b524$export$91fa9ac3f4021ce4, $313e0a591bf5b524$export$9ef81298ca34ad41);




const $efe77942e9a45ffa$export$d2ad290394bbc49d = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "flexBasis"
});
const $efe77942e9a45ffa$export$84c3c16c9ed6c908 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "flexDirection"
});
const $efe77942e9a45ffa$export$9a4bcd01f5c204bc = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "flexWrap"
});
const $efe77942e9a45ffa$export$8dea3061ba53bfd1 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "justifyContent"
});
const $efe77942e9a45ffa$export$898d9006406726bd = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "alignItems"
});
const $efe77942e9a45ffa$export$38c32c6918694134 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "alignContent"
});
const $efe77942e9a45ffa$export$aaaeab0fac9a3ccb = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "order"
});
const $efe77942e9a45ffa$export$97691fbb80847c19 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "flex"
});
const $efe77942e9a45ffa$export$36c65c169152373d = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "flexGrow"
});
const $efe77942e9a45ffa$export$2670ac60b02109d2 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "flexShrink"
});
const $efe77942e9a45ffa$export$4545dd3632cb520b = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "alignSelf"
});
const $efe77942e9a45ffa$export$55e6b7a7f0eaa3ff = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "justifyItems"
});
const $efe77942e9a45ffa$export$d012640ac9a6446f = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "justifySelf"
});
const $efe77942e9a45ffa$var$flexbox = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($efe77942e9a45ffa$export$d2ad290394bbc49d, $efe77942e9a45ffa$export$84c3c16c9ed6c908, $efe77942e9a45ffa$export$9a4bcd01f5c204bc, $efe77942e9a45ffa$export$8dea3061ba53bfd1, $efe77942e9a45ffa$export$898d9006406726bd, $efe77942e9a45ffa$export$38c32c6918694134, $efe77942e9a45ffa$export$aaaeab0fac9a3ccb, $efe77942e9a45ffa$export$97691fbb80847c19, $efe77942e9a45ffa$export$36c65c169152373d, $efe77942e9a45ffa$export$2670ac60b02109d2, $efe77942e9a45ffa$export$4545dd3632cb520b, $efe77942e9a45ffa$export$55e6b7a7f0eaa3ff, $efe77942e9a45ffa$export$d012640ac9a6446f);
var $efe77942e9a45ffa$export$2e2bcd8739ae039 = $efe77942e9a45ffa$var$flexbox;







const $7844a3eb6e8d0ea5$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$7844a3eb6e8d0ea5$export$5df9adcb0db95e1e.propTypes = {};
$7844a3eb6e8d0ea5$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $7844a3eb6e8d0ea5$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$7844a3eb6e8d0ea5$export$ec60d70ff941a580.propTypes = {};
$7844a3eb6e8d0ea5$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $7844a3eb6e8d0ea5$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$7844a3eb6e8d0ea5$export$8a833ffa5f5dbeda.propTypes = {};
$7844a3eb6e8d0ea5$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $7844a3eb6e8d0ea5$export$baf44164ca3a34e8 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
const $7844a3eb6e8d0ea5$export$8f7213a1cd01e832 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
const $7844a3eb6e8d0ea5$export$b0e0abbc49ba668 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
const $7844a3eb6e8d0ea5$export$bcd8b929d4b4142 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
const $7844a3eb6e8d0ea5$export$e5039a674e14c828 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
const $7844a3eb6e8d0ea5$export$42bd9088661ffb03 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
const $7844a3eb6e8d0ea5$export$920682ae05b999bc = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
const $7844a3eb6e8d0ea5$export$1b88fbdd482fd33a = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
const $7844a3eb6e8d0ea5$export$bdb486e40d52d26f = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
const $7844a3eb6e8d0ea5$var$grid = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($7844a3eb6e8d0ea5$export$5df9adcb0db95e1e, $7844a3eb6e8d0ea5$export$ec60d70ff941a580, $7844a3eb6e8d0ea5$export$8a833ffa5f5dbeda, $7844a3eb6e8d0ea5$export$baf44164ca3a34e8, $7844a3eb6e8d0ea5$export$8f7213a1cd01e832, $7844a3eb6e8d0ea5$export$b0e0abbc49ba668, $7844a3eb6e8d0ea5$export$bcd8b929d4b4142, $7844a3eb6e8d0ea5$export$e5039a674e14c828, $7844a3eb6e8d0ea5$export$42bd9088661ffb03, $7844a3eb6e8d0ea5$export$920682ae05b999bc, $7844a3eb6e8d0ea5$export$1b88fbdd482fd33a, $7844a3eb6e8d0ea5$export$bdb486e40d52d26f);
var $7844a3eb6e8d0ea5$export$2e2bcd8739ae039 = $7844a3eb6e8d0ea5$var$grid;




const $4b1526a666784d7b$export$5880b8b5730aff45 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "position"
});
const $4b1526a666784d7b$export$56446adcecbeec34 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "zIndex",
    themeKey: "zIndex"
});
const $4b1526a666784d7b$export$1e95b668f3b82d = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "top"
});
const $4b1526a666784d7b$export$79ffe56a765070d2 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "right"
});
const $4b1526a666784d7b$export$40e543e69a8b3fbb = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "bottom"
});
const $4b1526a666784d7b$export$eabcd2c8791e7bf4 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "left"
});
var $4b1526a666784d7b$export$2e2bcd8739ae039 = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($4b1526a666784d7b$export$5880b8b5730aff45, $4b1526a666784d7b$export$56446adcecbeec34, $4b1526a666784d7b$export$1e95b668f3b82d, $4b1526a666784d7b$export$79ffe56a765070d2, $4b1526a666784d7b$export$40e543e69a8b3fbb, $4b1526a666784d7b$export$eabcd2c8791e7bf4);




const $625822e5d7cce21a$export$35e9368ef982300f = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette"
});
const $625822e5d7cce21a$export$2506f56c10355b33 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette"
});
const $625822e5d7cce21a$export$8c5a050822fd698c = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "backgroundColor",
    themeKey: "palette"
});
const $625822e5d7cce21a$var$palette = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($625822e5d7cce21a$export$35e9368ef982300f, $625822e5d7cce21a$export$2506f56c10355b33, $625822e5d7cce21a$export$8c5a050822fd698c);
var $625822e5d7cce21a$export$2e2bcd8739ae039 = $625822e5d7cce21a$var$palette;



const $f46243bac80ca856$var$boxShadow = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "boxShadow",
    themeKey: "shadows"
});
var $f46243bac80ca856$export$2e2bcd8739ae039 = $f46243bac80ca856$var$boxShadow;





function $d5d974b5976c38ad$var$transform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $d5d974b5976c38ad$export$7e3df82ee760448c = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $2c79a5510dec9b08$export$68c286be0e7e55b7)[propValue];
            return {
                maxWidth: breakpoint || $d5d974b5976c38ad$var$transform(propValue)
            };
        };
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$d5d974b5976c38ad$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $d5d974b5976c38ad$export$ee148fbbe8357dd2 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$ac607276a8fe9f0a = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$dc0d8bd0b94f8570 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$a43cf604e12f3b17 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$ffed9f14fb65e276 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$905076ed6620e671 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$6ccc93f785106a58 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
const $d5d974b5976c38ad$var$sizing = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($d5d974b5976c38ad$export$7e3df82ee760448c, $d5d974b5976c38ad$export$488fda99655ff65a, $d5d974b5976c38ad$export$ee148fbbe8357dd2, $d5d974b5976c38ad$export$ac607276a8fe9f0a, $d5d974b5976c38ad$export$dc0d8bd0b94f8570, $d5d974b5976c38ad$export$a43cf604e12f3b17, $d5d974b5976c38ad$export$6ccc93f785106a58);
var $d5d974b5976c38ad$export$2e2bcd8739ae039 = $d5d974b5976c38ad$var$sizing;





const $c84a9198f57b593d$export$a5975749f0374264 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "fontFamily",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$85e3c3ca0c6fb93 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "fontSize",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$a827189a08c5a3a3 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "fontStyle",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$bc0b29e67df3229e = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "fontWeight",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$3eb52878e4502ad1 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "letterSpacing"
});
const $c84a9198f57b593d$export$d1b52fec4405b471 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "textTransform"
});
const $c84a9198f57b593d$export$c9b91427b594e14 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "lineHeight"
});
const $c84a9198f57b593d$export$a87999391cd10ae9 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "textAlign"
});
const $c84a9198f57b593d$export$60b2982fc282cca6 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "typography",
    cssProperty: false,
    themeKey: "typography"
});
const $c84a9198f57b593d$var$typography = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($c84a9198f57b593d$export$60b2982fc282cca6, $c84a9198f57b593d$export$a5975749f0374264, $c84a9198f57b593d$export$85e3c3ca0c6fb93, $c84a9198f57b593d$export$a827189a08c5a3a3, $c84a9198f57b593d$export$bc0b29e67df3229e, $c84a9198f57b593d$export$3eb52878e4502ad1, $c84a9198f57b593d$export$c9b91427b594e14, $c84a9198f57b593d$export$a87999391cd10ae9, $c84a9198f57b593d$export$d1b52fec4405b471);
var $c84a9198f57b593d$export$2e2bcd8739ae039 = $c84a9198f57b593d$var$typography;


const $5cca20270cff5ebe$var$filterPropsMapping = {
    borders: (0, $e39f6794db8cf9ac$export$2e2bcd8739ae039).filterProps,
    display: (0, $313e0a591bf5b524$export$2e2bcd8739ae039).filterProps,
    flexbox: (0, $efe77942e9a45ffa$export$2e2bcd8739ae039).filterProps,
    grid: (0, $7844a3eb6e8d0ea5$export$2e2bcd8739ae039).filterProps,
    positions: (0, $4b1526a666784d7b$export$2e2bcd8739ae039).filterProps,
    palette: (0, $625822e5d7cce21a$export$2e2bcd8739ae039).filterProps,
    shadows: (0, $f46243bac80ca856$export$2e2bcd8739ae039).filterProps,
    sizing: (0, $d5d974b5976c38ad$export$2e2bcd8739ae039).filterProps,
    spacing: (0, $94935f79a2c44a85$export$2e2bcd8739ae039).filterProps,
    typography: (0, $c84a9198f57b593d$export$2e2bcd8739ae039).filterProps
};
const $5cca20270cff5ebe$export$40acc74e51be579a = {
    borders: $e39f6794db8cf9ac$export$2e2bcd8739ae039,
    display: $313e0a591bf5b524$export$2e2bcd8739ae039,
    flexbox: $efe77942e9a45ffa$export$2e2bcd8739ae039,
    grid: $7844a3eb6e8d0ea5$export$2e2bcd8739ae039,
    positions: $4b1526a666784d7b$export$2e2bcd8739ae039,
    palette: $625822e5d7cce21a$export$2e2bcd8739ae039,
    shadows: $f46243bac80ca856$export$2e2bcd8739ae039,
    sizing: $d5d974b5976c38ad$export$2e2bcd8739ae039,
    spacing: $94935f79a2c44a85$export$2e2bcd8739ae039,
    typography: $c84a9198f57b593d$export$2e2bcd8739ae039
};
const $5cca20270cff5ebe$export$2ec640062268c7c4 = Object.keys($5cca20270cff5ebe$var$filterPropsMapping).reduce((acc, styleFnName)=>{
    $5cca20270cff5ebe$var$filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = $5cca20270cff5ebe$export$40acc74e51be579a[styleFnName];
    });
    return acc;
}, {});
function $5cca20270cff5ebe$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $5cca20270cff5ebe$export$2ec640062268c7c4[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $5cca20270cff5ebe$export$2e2bcd8739ae039 = $5cca20270cff5ebe$var$getThemeValue;



function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
} // eslint-disable-next-line @typescript-eslint/naming-convention
function $6b750d631801d296$export$7d53d8bf2911e013(styleFunctionMapping = (0, $5cca20270cff5ebe$export$40acc74e51be579a)) {
    const propToStyleFunction = Object.keys(styleFunctionMapping).reduce((acc, styleFnName)=>{
        styleFunctionMapping[styleFnName].filterProps.forEach((propName)=>{
            acc[propName] = styleFunctionMapping[styleFnName];
        });
        return acc;
    }, {});
    function getThemeValue(prop, value, theme) {
        const inputProps = {
            [prop]: value,
            theme: theme
        };
        const styleFunction = propToStyleFunction[prop];
        return styleFunction ? styleFunction(inputProps) : {
            [prop]: value
        };
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // emotion & styled-components will neglect null
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $2c79a5510dec9b08$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (propToStyleFunction[styleKey]) css = (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme));
                        else {
                            const breakpointsValues = (0, $2c79a5510dec9b08$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme));
                }
            });
            return (0, $2c79a5510dec9b08$export$8922c90b6e020726)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    "sx"
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $17r9Q = parcelRequire("17r9Q");

const $c85eb76b78f8a14c$var$_excluded = [
    "sx"
];
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    Object.keys(props).forEach((prop)=>{
        if ((0, $5cca20270cff5ebe$export$2ec640062268c7c4)[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $c85eb76b78f8a14c$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $17r9Q.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $17r9Q = parcelRequire("17r9Q");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $a06500f70819ed69$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a06500f70819ed69$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $a06500f70819ed69$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || []; // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
}; // Keep in mind that @media is inclusive by the CSS specification.
function $a06500f70819ed69$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $a06500f70819ed69$var$_excluded);
    const sortedValues = $a06500f70819ed69$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}


const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;



function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    const transform = (0, $94935f79a2c44a85$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}


const $4a66cd95e497efc7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $4a66cd95e497efc7$var$_excluded);
    const breakpoints = (0, $a06500f70819ed69$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $1f392ba2ebd18096$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $17r9Q.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $8aecb04a157fa644$export$2e2bcd8739ae039), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $17r9Q.default)(acc, argument), muiTheme);
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;



var $lT1cX = parcelRequire("lT1cX");
function $1f701f7d1726bc9a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1f701f7d1726bc9a$var$useTheme(defaultTheme = null) {
    const contextTheme = (0, $lT1cX.default)();
    return !contextTheme || $1f701f7d1726bc9a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1f701f7d1726bc9a$export$2e2bcd8739ae039 = $1f701f7d1726bc9a$var$useTheme;


const $59c0686cf27fa016$export$35e57303dbd8a66 = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
function $59c0686cf27fa016$var$useTheme(defaultTheme = $59c0686cf27fa016$export$35e57303dbd8a66) {
    return (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)(defaultTheme);
}
var $59c0686cf27fa016$export$2e2bcd8739ae039 = $59c0686cf27fa016$var$useTheme;



var $ayMG0 = parcelRequire("ayMG0");
const $b85125360b778ad2$var$_excluded = [
    "className",
    "component"
];
function $b85125360b778ad2$export$2e2bcd8739ae039(options = {}) {
    const { defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName, styleFunctionSx: styleFunctionSx = (0, $6b750d631801d296$export$2e2bcd8739ae039) } = options;
    const BoxRoot = (0, $bOOlK.default)("div")(styleFunctionSx);
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $b85125360b778ad2$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $1SA7b.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: theme
        }, other));
    });
    return Box;
}


const $b5363c9a2f115365$var$Box = (0, $b85125360b778ad2$export$2e2bcd8739ae039)();
var $b5363c9a2f115365$export$2e2bcd8739ae039 = $b5363c9a2f115365$var$Box;


parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


function $154e117af2903f61$var$FormCheckbox({ label: label, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9924aff1dcc3644$export$2e2bcd8739ae039), {
        ...props,
        //   Covert to bool to satisfy mui Checkbox props
        component: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    ...p,
                    checked: p.checked === "true" || Boolean(p.checked)
                }),
                label: label
            }),
        valuePropName: "checked"
    });
}
var $154e117af2903f61$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($154e117af2903f61$var$FormCheckbox).attrs({
    className: $154e117af2903f61$var$FormCheckbox.name
})``;


function $75c345bba7d4353f$var$PublishOptionsForm({ className: className, onSubmit: onSubmit, children: children, initialState: initialState }) {
    const init = initialState || (0, $b88c63f4bcc6d929$export$f08daca113a61734)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $735a0bab243419cb$export$2e2bcd8739ae039), {
            initialState: init,
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show units marked as 'Hidden'",
                            name: "showHidden"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: 'Groups marked as "Hidden" in the miz file will be visible in the Frag Order'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show OPFOR Groups",
                            name: "showGroups"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: "Show enemy groups on the Frag Order map"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show groups marked as 'Hidden on MFD'",
                            name: "showHiddenOnMFD"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: 'Groups marked as "Hidden on MFD" in the miz file will be visible in the Frag Order'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show trigger zones",
                            name: "showZones"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: "Zones in the miz file will be visible on the Frag Order"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show trigger zones marked as 'Hidden'",
                            name: "showHiddenZones"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: 'Zones in the miz file marked as "Hidden" will appear in the Frag Order'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show drawing objects",
                            name: "showDrawing"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: "Show miz file drawings."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                            paddingLeft: 4,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                                    label: "Author",
                                    name: "showDrawingLayerAuthor"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                                    label: "Common",
                                    name: "showDrawingLayerCommon"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                                    label: "Coalition",
                                    name: "showDrawingLayerCoalition"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                component: "span",
                                fontWeight: 600,
                                children: [
                                    "Note: Only certain types of drawing objects are currently supported:",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Disk, Line, Polygon, Text"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show friendly groups",
                            name: "showFriendlyGroups"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: "Groups on friendly coalitions will be visible. Example: BLUE players cannot see RED units"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                            label: "Show OPFOR statics",
                            name: "showOpforStatics"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: "Show enemy static objects"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: "Published Coalitions"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                            children: "Publish separate Frag Orders for different coalitions"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                                    label: "Blue",
                                    name: "publishBlue"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $154e117af2903f61$export$2e2bcd8739ae039), {
                                    label: "Red",
                                    name: "publishRed"
                                })
                            ]
                        })
                    ]
                }),
                children
            ]
        })
    });
}
var $75c345bba7d4353f$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($75c345bba7d4353f$var$PublishOptionsForm).attrs({
    className: $75c345bba7d4353f$var$PublishOptionsForm.name
})`
  .MuiFormGroup-root {
    margin-bottom: 32px;
  }

  .MuiFormHelperText-root {
    font-size: 14px;
    color: ${(props)=>props.theme.palette.text.primary};
  }
`;



function $ccc04424d1078738$var$getCoalitions(fs) {
    const arr = [];
    if (fs.publishBlue) arr.push((0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue);
    if (fs.publishRed) arr.push((0, $91a9098e14452db2$export$193e4cdf5c5b208).Red);
    if (fs.publishNeutral) arr.push((0, $91a9098e14452db2$export$193e4cdf5c5b208).Neutrals);
    return arr;
}
function $ccc04424d1078738$var$PublishOptions({ className: className, manifests: manifests, fragOrder: fragOrder }) {
    const publish = (0, $0a53c1f23450367c$export$61c78d1b2fb7a89e)();
    const updateFO = (0, $0a53c1f23450367c$export$4f91b3529d70dcc2)();
    const [loading, setLoading] = $acw62.useState(false);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const isPublished = manifests && manifests.length > 0;
    const handlePublish = async (opts)=>{
        setLoading(true);
        const coalitions = $ccc04424d1078738$var$getCoalitions(opts);
        if (isPublished) updateFO({
            ...fragOrder,
            publishOpts: opts
        }, coalitions).then(()=>{
            success("Frag Order updated successfully");
        }).catch((e)=>{
            console.error(e);
            error(e.message);
        }).finally(()=>{
            setLoading(false);
        });
        else publish(fragOrder, opts, coalitions).then(()=>{
            success("Frag Order published successfully");
        }).catch((e)=>{
            console.error(e);
            error(e.message);
        }).finally(()=>{
            setLoading(false);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        className: className,
        title: "Publish Options",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75c345bba7d4353f$export$2e2bcd8739ae039), {
            initialState: {
                ...fragOrder?.publishOpts,
                publishBlue: true,
                publishRed: !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
                    coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red
                }),
                publishNeutral: false
            },
            onSubmit: handlePublish,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                loading: loading,
                variant: "contained",
                type: "submit",
                children: isPublished ? "Update" : "Publish"
            })
        })
    });
}
var $ccc04424d1078738$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ccc04424d1078738$var$PublishOptions).attrs({
    className: $ccc04424d1078738$var$PublishOptions.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");










function $613813714b5a49bd$var$PublishStatus({ className: className }) {
    const { success: success } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const { id: id } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const { data: manifests, isLoading: isLoading } = (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
        className: className,
        children: [
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {}),
            !isLoading && !manifests || manifests?.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        severity: "warning",
                        children: "This Frag Order has not been published"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginTop: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            wide: true,
                            center: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                                to: `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).FragOrderDetail}/${id}/publish`,
                                children: "View Publish Options"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontSize: 16,
                            fontWeight: 600,
                            children: "Publish Status"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                            size: "small",
                            columns: [
                                {
                                    value: (pm)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(pm.coalition),
                                    label: "Coalition"
                                },
                                {
                                    value: (m)=>`v${m.version}`,
                                    label: "Version"
                                },
                                {
                                    value: (pm)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            color: pm.coalition === "red" ? "error" : "primary",
                                            onClick: ()=>{
                                                navigator.clipboard.writeText((0, $b88c63f4bcc6d929$export$50c9eb25fb913588)(pm));
                                                success("Copied to clipboard");
                                            },
                                            variant: "outlined",
                                            size: "small",
                                            children: "Copy Link"
                                        }),
                                    label: ""
                                },
                                {
                                    value: (pm)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            color: pm.coalition === "red" ? "error" : "primary",
                                            variant: "contained",
                                            target: "_blank",
                                            href: (0, $b88c63f4bcc6d929$export$50c9eb25fb913588)(pm),
                                            children: "View"
                                        }),
                                    label: ""
                                }
                            ],
                            rows: manifests
                        })
                    ]
                })
            })
        ]
    });
}
var $613813714b5a49bd$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($613813714b5a49bd$var$PublishStatus).attrs({
    className: $613813714b5a49bd$var$PublishStatus.name
})`
  padding: 16px;
  thead {
    display: none;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");









function $de512c4eecec72c9$var$JobsPage({ className: className, id: id }) {
    const [running, setRunning] = $acw62.useState(false);
    const { data: fragOrder, isLoading: isLoading } = (0, $0a53c1f23450367c$export$ca476617908cb2f8)(id);
    const { data: plans } = (0, $92839c6c950486dc$export$aa3859200fac1b16)(id);
    const { data: assets } = (0, $de1274ee98092164$export$7744273c9977e539)();
    const apply = (0, $0a53c1f23450367c$export$b0b83c3396e2dd0c)();
    const update = (0, $0a53c1f23450367c$export$4f91b3529d70dcc2)();
    $acw62.useEffect(()=>{
        if (!plans) return;
        // We don't have a good way to automatically add a job to the frag order when someone submits a plan.
        // Check here and add the job if someone has submitted a plan.
        // This also allows for backwards compat.
        const hasPlansJob = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(fragOrder.jobs, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyPlans);
        const hasValidPlans = !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(plans, {
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
        });
        if (hasValidPlans && !hasPlansJob) {
            const jobs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(fragOrder.jobs || [], (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyPlans);
            update({
                ...fragOrder,
                jobs: jobs
            }, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(plans, "coaltion"));
        }
    }, [
        plans
    ]);
    $acw62.useEffect(()=>{
        if (!assets) return;
        const hasAssets = assets.length > 0;
        const hasAssetsJob = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(fragOrder.jobs, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ApplyPlans);
        if (hasAssets && !hasAssetsJob) {
            const jobs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(fragOrder.jobs || [], (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).Assets);
            update({
                ...fragOrder,
                jobs: jobs
            }, // We only do kneeboard injection on single-coalition manifests
            [
                (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue
            ]);
        }
    }, [
        assets
    ]);
    const handleRun = async ()=>{
        setRunning(true);
        await apply(fragOrder).finally(()=>setRunning(false));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        loading: isLoading,
        title: "Jobs",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "These jobs will be run on your mission and compiled into a new .miz file"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                    columns: [
                        {
                            value: (j)=>j,
                            label: "Description"
                        }
                    ],
                    rows: fragOrder?.jobs
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                disabled: !fragOrder?.jobs || fragOrder.jobs.length === 0,
                variant: "contained",
                loading: running,
                onClick: handleRun,
                children: "Run Jobs and Download"
            })
        ]
    });
}
var $de512c4eecec72c9$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($de512c4eecec72c9$var$JobsPage).attrs({
    className: $de512c4eecec72c9$var$JobsPage.name
})``;



var $ayMG0 = parcelRequire("ayMG0");
var $1466001c800d0f24$exports = {};
"use strict";

Object.defineProperty($1466001c800d0f24$exports, "__esModule", {
    value: true
});
$1466001c800d0f24$exports.default = void 0;

var $1466001c800d0f24$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1466001c800d0f24$var$_default = (0, $1466001c800d0f24$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
}), "Settings");
$1466001c800d0f24$exports.default = $1466001c800d0f24$var$_default;







var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");














var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

function $13123cf1aaadb36d$var$AirbaseNavCardSettings({ className: className, onChange: onChange, settings: settings }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                checked: settings?.showAirbaseFreqs,
                onChange: (ev)=>onChange({
                        ...settings,
                        showAirbaseFreqs: ev.target.checked
                    })
            }),
            label: "Display Airbase Frequencies"
        })
    });
}
var $13123cf1aaadb36d$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($13123cf1aaadb36d$var$AirbaseNavCardSettings).attrs({
    className: $13123cf1aaadb36d$var$AirbaseNavCardSettings.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

function $651dd8f962f7e5d3$var$RouteDetailSettings({ className: className, onChange: onChange, settings: settings }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showBullsCompass,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showBullsCompass: ev.target.checked
                        })
                }),
                label: "Display Bullseye Compass"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showDistances,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showDistances: ev.target.checked
                        })
                }),
                label: "Display Distances"
            })
        ]
    });
}
var $651dd8f962f7e5d3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($651dd8f962f7e5d3$var$RouteDetailSettings).attrs({
    className: $651dd8f962f7e5d3$var$RouteDetailSettings.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

function $82791e62f19bbc57$var$LineupCardSettings({ className: className, onChange: onChange, settings: settings }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showTimeOnTarget,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showTimeOnTarget: ev.target.checked
                        })
                }),
                label: "Display Time-on-Target"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showDistance,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showDistance: ev.target.checked
                        })
                }),
                label: "Display Distance"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showSpeed,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showSpeed: ev.target.checked
                        })
                }),
                label: "Display Ground Speed"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showAltitude,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showAltitude: ev.target.checked
                        })
                }),
                label: "Display Altitude"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showCoords,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showCoords: ev.target.checked
                        })
                }),
                label: "Display Coordinates"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                    checked: settings?.showFreqs,
                    onChange: (ev)=>onChange({
                            ...settings,
                            showFreqs: ev.target.checked
                        })
                }),
                label: "Display Comms Table"
            })
        ]
    });
}
var $82791e62f19bbc57$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($82791e62f19bbc57$var$LineupCardSettings).attrs({
    className: $82791e62f19bbc57$var$LineupCardSettings.name
})``;


function $b14f7219ed6d3db9$var$component(j, props) {
    switch(j){
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82791e62f19bbc57$export$2e2bcd8739ae039), {
                ...props,
                settings: props.settings
            });
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectAirbasesKneeboard:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13123cf1aaadb36d$export$2e2bcd8739ae039), {
                ...props,
                settings: props.settings
            });
        case (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $651dd8f962f7e5d3$export$2e2bcd8739ae039), {
                ...props,
                settings: props.settings
            });
        default:
            return null;
    }
}
function $b14f7219ed6d3db9$var$KneeboardSettings({ jobType: jobType, job: job, onSettingChange: onSettingChange, ...rest }) {
    const handleChange = (opts)=>{
        onSettingChange(jobType, opts);
    };
    if (!job) job = (0, $50dfa3f756c4c37a$export$ae2ddee72efdd7)[jobType];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        ...rest,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            p: 2,
            children: $b14f7219ed6d3db9$var$component(jobType, {
                onChange: handleChange,
                settings: job
            })
        })
    });
}
var $b14f7219ed6d3db9$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b14f7219ed6d3db9$var$KneeboardSettings).attrs({
    className: $b14f7219ed6d3db9$var$KneeboardSettings.name
})``;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


function $9377b6a19a671ff7$var$AssetViewer({ className: className, asset: asset, manifest: manifest, style: style }) {
    const { data: data, isLoading: isLoading, error: error } = (0, $de1274ee98092164$export$7b94101b3d766751)(asset, manifest);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: className,
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                severity: "error",
                children: error.message
            }),
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                style: {
                    position: "absolute",
                    top: 64
                }
            }),
            !isLoading && !error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: style,
                    src: data
                })
            })
        ]
    });
}
var $9377b6a19a671ff7$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($9377b6a19a671ff7$var$AssetViewer).attrs({
    className: $9377b6a19a671ff7$var$AssetViewer.name
})`
  position: relative;
`;


function $849dd2cc4f6dc3c2$var$AssetViewerModal({ className: className, asset: asset, open: open, onClose: onClose, manifest: manifest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        onClose: onClose,
        open: open,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
            style: {
                minHeight: 478.5,
                minWidth: 358.5
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                className: className,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9377b6a19a671ff7$export$2e2bcd8739ae039), {
                    asset: asset,
                    manifest: manifest
                })
            })
        })
    });
}
var $849dd2cc4f6dc3c2$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($849dd2cc4f6dc3c2$var$AssetViewerModal).attrs({
    className: $849dd2cc4f6dc3c2$var$AssetViewerModal.name
})``;


function $4d7e4ae0b21757e6$var$AssetTable({ className: className, assets: assets }) {
    const remove = (0, $de1274ee98092164$export$a2278b7b030e2078)();
    const [preview, setPreview] = $acw62.useState(null);
    const { success: success, rawError: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const { data: manifests } = (0, $0a53c1f23450367c$export$6f9969a28801a496)();
    const handlePreview = (a)=>{
        setPreview(a);
    };
    const handleRemove = (a)=>{
        remove(a).then(()=>success("Asset removed")).catch((err)=>error(err));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                columns: [
                    {
                        label: "Filename",
                        value: "name"
                    },
                    {
                        label: "Type",
                        value: "type"
                    },
                    {
                        label: "",
                        value: (a)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: ()=>handlePreview(a),
                                children: "Preview"
                            })
                    },
                    {
                        label: "",
                        value: (a)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                onClick: ()=>handleRemove(a),
                                variant: "text",
                                color: "error",
                                children: "Remove"
                            })
                    }
                ],
                rows: assets
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $849dd2cc4f6dc3c2$export$2e2bcd8739ae039), {
                open: !!preview,
                asset: preview,
                onClose: ()=>setPreview(null),
                manifest: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
                    coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue
                })
            })
        ]
    });
}
var $4d7e4ae0b21757e6$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($4d7e4ae0b21757e6$var$AssetTable).attrs({
    className: $4d7e4ae0b21757e6$var$AssetTable.name
})``;








// async function getImage(file: File): Promise<HTMLImageElement> {
//   return new Promise((accept) => {
//     const img = document.createElement("img");
//     const blob = URL.createObjectURL(file);
//     img.src = blob;
//     img.onload = function () {
//       accept(img);
//     };
//   });
// }
// https://stackoverflow.com/questions/1186414/whats-the-algorithm-to-calculate-aspect-ratio
// function greatestCommonDivisor(a, b) {
//   return b == 0 ? a : greatestCommonDivisor(b, a % b);
// }
// function aspectRatio(w, h) {
//   const r = greatestCommonDivisor(w, h);
//   const aspect = `${w / r}:${h / r}`;
//   return aspect;
// }
function $b59706e3033ef824$var$KneeboardUpload({ className: className, fragOrder: fragOrder }) {
    const { data: manifests } = (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(fragOrder.id);
    const [uploading, setUploading] = $acw62.useState(false);
    const [toBeUploaded, setToBeUploaded] = $acw62.useState([]);
    const [uploadOpen, setUploadOpen] = $acw62.useState(false);
    const [validationErrors, setErrors] = $acw62.useState({});
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const upload = (0, $de1274ee98092164$export$8b27c7f353a6101a)(fragOrder);
    const manifestID = manifests && manifests[0]?.id;
    const { data: assets } = (0, $de1274ee98092164$export$7744273c9977e539)(manifestID);
    $acw62.useEffect(()=>{
        if (toBeUploaded.length === 0) return;
        (async ()=>{
            const next = {
                ...validationErrors
            };
            for (const kneeboard of toBeUploaded){
                const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(assets, {
                    name: kneeboard.name
                });
                if (existing) next[kneeboard.name] = "Duplicate name";
                else delete next[kneeboard.name];
            }
            setErrors(next);
        })();
    }, [
        toBeUploaded
    ]);
    const submittable = toBeUploaded.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys(validationErrors).length === 0;
    const renderTable = toBeUploaded.length > 0;
    const handleKneeboardAdd = (files)=>{
        setToBeUploaded((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniqBy([
            ...toBeUploaded,
            ...files
        ], "name"));
    };
    const handleKneeboardRemove = (name)=>{
        setToBeUploaded((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(toBeUploaded, (f)=>f.name !== name));
        const next = {
            ...validationErrors
        };
        delete next[name];
        setErrors(next);
    };
    const handleKneeboardSubmit = ()=>{
        setUploading(true);
        upload(manifests, toBeUploaded).then(()=>success("Kneeboards Uploaded successfully")).catch((err)=>{
            error(err.message);
            console.error(err);
        }).finally(()=>{
            setUploading(false);
            setUploadOpen(false);
        });
    };
    const handleClose = ()=>{
        setUploadOpen(false);
        setToBeUploaded([]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d7e4ae0b21757e6$export$2e2bcd8739ae039), {
                assets: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(assets, {
                    type: (0, $8a132888bcd1c418$export$e57062a38354425e).Kneeboard
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: uploadOpen,
                onClose: handleClose,
                "aria-labelledby": "kneeboard-upload-modal",
                "aria-describedby": "Upload a kneeboard to this Frag Order",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
                    style: {
                        minWidth: "60vw"
                    },
                    padding: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                        title: "Upload Kneeboards",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $880d05f11d0a3304$export$2e2bcd8739ae039), {
                                text: "Drag and Drop a kneeboard to add it to the mission",
                                onFileDrop: (...args)=>{
                                    handleKneeboardAdd((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).flatten(args));
                                }
                            }),
                            renderTable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                marginTop: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                                    columns: [
                                        {
                                            label: "Filename",
                                            value: "name"
                                        },
                                        {
                                            label: "Type",
                                            value: "type"
                                        },
                                        {
                                            label: "Valid",
                                            value: (f)=>{
                                                const error = validationErrors[f.name];
                                                if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                                    align: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            marginRight: 1,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                                                                color: "red",
                                                                icon: (0, $8ef988b2cc978acd$export$13ff1290a9e22e77).Close
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                color: "red"
                                                            },
                                                            children: error
                                                        })
                                                    ]
                                                });
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ef988b2cc978acd$export$2e2bcd8739ae039), {
                                                    color: "green",
                                                    icon: (0, $8ef988b2cc978acd$export$13ff1290a9e22e77).Check
                                                });
                                            }
                                        },
                                        {
                                            label: "",
                                            value: (f)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                                    onClick: ()=>handleKneeboardRemove(f.name),
                                                    variant: "text",
                                                    color: "error",
                                                    children: "Remove"
                                                })
                                        }
                                    ],
                                    rows: toBeUploaded
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                marginTop: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            marginRight: 2,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                                loading: uploading,
                                                disabled: !submittable,
                                                variant: "contained",
                                                onClick: handleKneeboardSubmit,
                                                children: "Submit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            onClick: handleClose,
                                            variant: "outlined",
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginTop: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    onClick: ()=>setUploadOpen(true),
                    variant: "contained",
                    children: "Upload Kneeboards..."
                })
            })
        ]
    });
}
var $b59706e3033ef824$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b59706e3033ef824$var$KneeboardUpload).attrs({
    className: $b59706e3033ef824$var$KneeboardUpload.name
})``;




const $60570f6077788674$var$modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 0
};
function $60570f6077788674$var$KneeboardManagement({ className: className, manifests: manifests, fragOrder: fragOrder }) {
    const [preview, setPreview] = $acw62.useState({
        img: null,
        job: null
    });
    const [downloading, setDownloading] = $acw62.useState(false);
    const coas = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, "coalition");
    const hasBlue = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(coas, (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue);
    const hasRed = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(coas, (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red);
    const [selectedCoalition, setSelectedCoalition] = $acw62.useState(hasBlue ? (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue : (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red);
    const [generating, setGenerating] = $acw62.useState(null);
    const [updating, setUpdating] = $acw62.useState(null);
    const [carouselIndex, setCarouselIndex] = $acw62.useState(0);
    const [settings, setSettings] = $acw62.useState(null);
    const { rawError: rawError, success: success } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const update = (0, $0a53c1f23450367c$export$4f91b3529d70dcc2)();
    const isWarning = (0, $0a53c1f23450367c$export$b521134b1363f352)(fragOrder.id);
    const man = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
        coalition: selectedCoalition
    });
    const { data: tasking } = (0, $aae70ce689e02dd3$export$f760ffd5af329347)(man);
    const { data: externalData } = (0, $6f6b89abe389e58a$export$a71275835f6fa47f)(fragOrder.id, man?.coalition);
    const { data: planItems } = (0, $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f)(man?.id);
    const { data: groups } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(fragOrder.id, tasking?.plannedGroups);
    const previewGroup = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(groups, carouselIndex);
    const handlePreview = $acw62.useCallback(async (k)=>{
        setGenerating(k.job);
        let img;
        try {
            if (!previewGroup) throw new Error("No groups in mission");
            img = await (0, $e0c6a541dbb07ec6$export$41b3415e6330f1b5)(k.job, tasking, {
                title: man?.title,
                group: previewGroup,
                radioConfig: fragOrder.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig]
            }, fragOrder.jobSettings[k.job] || (0, $50dfa3f756c4c37a$export$ae2ddee72efdd7)[k.job], externalData, planItems);
            setPreview({
                img: img,
                job: k.job
            });
        } catch (e) {
            rawError(e);
        }
        setGenerating(null);
    }, [
        man,
        fragOrder,
        externalData,
        previewGroup
    ]);
    const handleAdd = async (k, jobSettings)=>{
        setUpdating(k.job);
        const next = {
            ...fragOrder,
            jobs: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat(fragOrder.jobs || [], k.job),
            jobSettings: {
                ...fragOrder.jobSettings,
                [k.job]: jobSettings || (0, $50dfa3f756c4c37a$export$ae2ddee72efdd7)[k.job]
            }
        };
        try {
            await update(next, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, "coalition"));
            success(`Added ${k.name} kneeboard to Frag Order`);
        } catch (e) {
            rawError(e);
        }
        setUpdating(null);
    };
    const handleRemove = async (k)=>{
        setUpdating(k.job);
        const jobs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(fragOrder.jobs || [], (j)=>j !== k.job);
        const next = {
            ...fragOrder,
            jobs: jobs
        };
        update(next, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, "coalition")).then(()=>{
            success(`Removed ${k.name} kneeboard from Frag Order`);
        }).catch(rawError).finally(()=>{
            setUpdating(null);
        });
    };
    const handleSettingChange = async (job, settings)=>{
        setUpdating(job);
        const next = {
            ...fragOrder,
            jobSettings: {
                ...fragOrder.jobSettings,
                [job]: settings
            }
        };
        try {
            await update(next, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, "coalition"));
            success(`Updated ${job} kneeboard settings`);
        } catch (e) {
            rawError(e);
        }
        setUpdating(null);
    };
    $acw62.useEffect(()=>{
        if (!preview?.img) return;
        (async ()=>{
            const img = await (0, $e0c6a541dbb07ec6$export$41b3415e6330f1b5)(preview.job, tasking, {
                group: previewGroup,
                title: man?.title,
                radioConfig: fragOrder.jobSettings[(0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig]
            }, fragOrder.jobSettings[preview.job], externalData, planItems);
            setPreview({
                ...preview,
                img: img
            });
        })();
    }, [
        carouselIndex,
        externalData,
        planItems
    ]);
    const handleDownloadKneeboardPack = $acw62.useCallback(async ()=>{
        setDownloading(true);
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($950bc911f3ee385b$exports)))();
        const taskingWithPlans = {
            ...tasking,
            plannedGroups: groups
        };
        await (0, $59e76ac65671d31b$export$8887fdde5f502e63)(fragOrder, selectedCoalition, man.title, taskingWithPlans, externalData, planItems, zip);
        zip.generateAsync({
            type: "blob"
        }).then((blob)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($90f256c567e4c320$exports)))(blob, `${fragOrder.name}_${man.coalition}_Kneeboards.zip`);
            success("Kneeboard pack downloaded");
        }).catch(rawError).finally(()=>{
            setDownloading(false);
        });
    }, [
        man,
        tasking,
        groups,
        externalData,
        fragOrder
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                    title: "Uploaded Kneeboards",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b59706e3033ef824$export$2e2bcd8739ae039), {
                        fragOrder: fragOrder
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                    title: "Generated Kneeboards",
                    actions: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            align: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                            id: "coalition-select-label",
                                            children: "Coalition"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                            size: "small",
                                            style: {
                                                minWidth: 160
                                            },
                                            label: "Coalition",
                                            value: selectedCoalition,
                                            onChange: (ev)=>setSelectedCoalition(ev.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                    disabled: !hasBlue,
                                                    value: "blue",
                                                    children: "Blue"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                    disabled: !hasRed,
                                                    value: "red",
                                                    children: "Red"
                                                })
                                            ]
                                        }, "coalition-select")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                    loading: downloading,
                                    style: {
                                        marginLeft: 8
                                    },
                                    size: "medium",
                                    variant: "outlined",
                                    onClick: handleDownloadKneeboardPack,
                                    children: "Download Kneeboards"
                                })
                            ]
                        }, "actions")
                    ],
                    children: [
                        isWarning && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                            severity: "warning",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                                    children: "Multiple Coalition Kneeboard Warning"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "DCS does not allow for coalition-specific kneeboards. Enabling injection could leak information to the opposing coalition."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                            columns: [
                                {
                                    label: "Name",
                                    value: "name"
                                },
                                {
                                    label: "",
                                    value: (k)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                            type: "button",
                                            loading: generating === k.job,
                                            onClick: ()=>handlePreview(k),
                                            variant: "outlined",
                                            color: "primary",
                                            disabled: $60570f6077788674$var$disableFreqJob(k, fragOrder) || $60570f6077788674$var$disablControlPoints(k, tasking),
                                            children: "Preview"
                                        })
                                },
                                {
                                    label: "Enabled",
                                    value: (k)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                            align: true,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    disabled: !!updating || $60570f6077788674$var$disableFreqJob(k, fragOrder) || $60570f6077788674$var$disablControlPoints(k, tasking),
                                                    onChange: (ev)=>{
                                                        ev.target.checked ? handleAdd(k, k.job === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard ? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(fragOrder.jobSettings, (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig) : null) : handleRemove(k);
                                                    },
                                                    inputProps: {
                                                        "aria-label": "Add to mission",
                                                        // @ts-ignore
                                                        "data-testid": `kneeboard-${k.job}`
                                                    },
                                                    checked: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(fragOrder?.jobs, k.job)
                                                }),
                                                updating === k.job && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                                                    size: 24
                                                })
                                            ]
                                        })
                                },
                                {
                                    label: "Settings",
                                    value: (k)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                            style: {
                                                display: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys((0, $50dfa3f756c4c37a$export$ae2ddee72efdd7)[k.job]).length === 0 ? "none" : "inherit"
                                            },
                                            onClick: (ev)=>setSettings({
                                                    el: ev.currentTarget,
                                                    job: k.job
                                                }),
                                            disabled: !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(fragOrder?.jobs, k.job),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1466001c800d0f24$exports))), {})
                                        })
                                }
                            ],
                            rows: [
                                {
                                    name: "Airfield Navigation Card",
                                    job: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectAirbasesKneeboard
                                },
                                {
                                    name: "Support Asset Navigation Card",
                                    job: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectSupportAssetsKneeboard
                                },
                                {
                                    name: "Lineup Cards",
                                    job: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard
                                },
                                // {
                                //   name: "Comms Cards",
                                //   job: JobType.GroupCommsCard,
                                // },
                                {
                                    name: "Briefing Text",
                                    job: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).BriefingText
                                },
                                {
                                    name: "Radio Preset Table",
                                    job: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard
                                },
                                {
                                    name: "Control Points Card",
                                    job: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ControlPointsCard
                                },
                                {
                                    name: "Route Detail",
                                    job: (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards
                                }
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: !!preview.img,
                onClose: ()=>setPreview({
                        img: null,
                        job: null
                    }),
                "aria-labelledby": "kneeboard-preview-modal",
                "aria-describedby": "A preview of automated kneeboard generation",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: $60570f6077788674$var$modalStyle,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            column: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: preview.img
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            style: {
                                borderTop: "1px solid black",
                                display: preview?.job === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupLineupCard || (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).InjectRouteDetailCards || preview?.job === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).GroupCommsCard ? "flex" : "none"
                            },
                            wide: true,
                            between: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    disabled: carouselIndex === 0,
                                    onClick: ()=>setCarouselIndex(carouselIndex - 1),
                                    children: "Prev"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    disabled: carouselIndex === groups?.length - 1,
                                    onClick: ()=>setCarouselIndex(carouselIndex + 1),
                                    children: "Next"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b14f7219ed6d3db9$export$2e2bcd8739ae039), {
                anchorEl: settings?.el,
                job: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(fragOrder, [
                    "jobSettings",
                    settings?.job
                ]),
                jobType: settings?.job,
                open: !!settings,
                onClose: ()=>setSettings(null),
                onSettingChange: handleSettingChange
            })
        ]
    });
}
var $60570f6077788674$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($60570f6077788674$var$KneeboardManagement).attrs({
    className: $60570f6077788674$var$KneeboardManagement.name
})``;
function $60570f6077788674$var$disableFreqJob(k, fragOrder) {
    if (k.job !== (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfigKneeboard) return false;
    return !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(fragOrder, [
        "jobSettings",
        (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).RadioPresetConfig
    ]);
}
function $60570f6077788674$var$disablControlPoints(k, tasking) {
    if (k.job === (0, $e46deec1d196b34c$export$608283ae8fe7f3eb).ControlPointsCard) return !tasking?.controlPoints || tasking?.controlPoints.length === 0;
    return false;
}




var $ayMG0 = parcelRequire("ayMG0");




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

function $2ab4f38e56e99e51$export$22d997cffb69b6c9() {
    const { download: download } = (0, $acw62.useContext)((0, $38644a8687878cac$export$97cfa3fd2e8d725e));
    return (fo)=>download(fo.id);
}





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





function $9563a3fbb18fea6b$var$MissionFileDrop({ className: className, onDrop: onDrop }) {
    const handleDrop = (fileData)=>{
        (0, $27d93e33897b2821$export$269b5c97958a4532)(fileData, (mission, dictionary, name, entries, warehouses)=>{
            const t = (0, $e1dc1ccf277543ba$export$b0887be10c72f2f9)(mission, warehouses, (0, $0dc5bcacaa5e05aa$export$7f3b48ada48e33da)(dictionary));
            onDrop(fileData, t);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $880d05f11d0a3304$export$2e2bcd8739ae039), {
            text: "Drag and drop a DCS .miz file",
            onFileDrop: (files)=>{
                handleDrop(files[0]);
            }
        })
    });
}
var $9563a3fbb18fea6b$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($9563a3fbb18fea6b$var$MissionFileDrop).attrs({
    className: $9563a3fbb18fea6b$var$MissionFileDrop.name
})`
  box-sizing: border-box;
`;




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

function $665d5b1998f592d3$var$Timestamp({ className: className, time: time, relative: relative = true, format: format = (0, $63618293c58b5f80$exports.DateTime).DATETIME_SHORT }) {
    const t = (0, $63618293c58b5f80$exports.DateTime).fromJSDate(new Date(time));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        title: t.toLocaleString((0, $63618293c58b5f80$exports.DateTime).DATETIME_SHORT),
        className: className,
        children: relative ? t.toRelative() : t.toLocaleString(format)
    });
}
var $665d5b1998f592d3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($665d5b1998f592d3$var$Timestamp)``;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");


const $537ff0a6203c2271$var$cols = [
    {
        value: "flyableBLUFOR",
        label: "Flyable BLUFOR Groups"
    },
    {
        value: "flyableREDFOR",
        label: "Flyable REDFOR Groups"
    },
    {
        value: "vehiclesBLUFOR",
        label: "BLUFOR Vehicle Groups"
    },
    {
        value: "vehiclesREDFOR",
        label: "REDFOR Vehicle Groups"
    },
    {
        value: "drawingObjects",
        label: "Drawing Objects"
    },
    {
        value: "zones",
        label: "Trigger Zones"
    }
];
const $537ff0a6203c2271$export$acaf96a27438246b = (object, base)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reduce(object, (result, value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isEqual(value, base[key])) result[key] = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isObject(value) && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isObject(base[key]) ? $537ff0a6203c2271$export$acaf96a27438246b(value, base[key]) : value;
        return result;
    }, {});
};
function $537ff0a6203c2271$var$Stats({ miz: miz, changed: changed }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: {
            xs: 1,
            md: 0
        },
        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map($537ff0a6203c2271$var$cols, (c)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                item: true,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                    "miz-stat-value": true,
                    changed: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(changed, c.value)
                }),
                "aria-label": c.label,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    column: true,
                    wide: true,
                    align: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontSize: 24,
                            fontWeight: 600,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(miz.metadata, c.value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                fontSize: 12,
                                children: c.label
                            })
                        })
                    ]
                })
            }, c.value))
    });
}
function $537ff0a6203c2271$var$MizFileStatistics({ className: className, miz: miz, diff: diff }) {
    const nameText = diff ? "Old Mission File: " : "";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontWeight: 600,
                            children: nameText
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($537ff0a6203c2271$var$Stats, {
                        miz: miz
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: diff ? "block" : "none"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    marginTop: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginTop: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    fontWeight: 600,
                                    color: "#ed6c02",
                                    children: [
                                        "New Mission File:",
                                        " "
                                    ]
                                }),
                                " ",
                                diff?.file.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            children: diff && /*#__PURE__*/ (0, $ayMG0.jsx)($537ff0a6203c2271$var$Stats, {
                                miz: diff,
                                changed: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys($537ff0a6203c2271$export$acaf96a27438246b(diff.metadata, miz.metadata))
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $537ff0a6203c2271$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($537ff0a6203c2271$var$MizFileStatistics).attrs({
    className: $537ff0a6203c2271$var$MizFileStatistics.name
})`
  .MuiBox-root {
    box-sizing: border-box;
  }

  .changed {
    color: ${(props)=>props.theme.palette.warning.main};
  }
`;


function $b8e7887d6b9f2ec2$var$MizFileDetails({ className: className, fragOrder: fragOrder }) {
    const download = (0, $2ab4f38e56e99e51$export$22d997cffb69b6c9)();
    const { data: publishStatus } = (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(fragOrder.id);
    const [isUpdateMode, setUpdateMode] = $acw62.useState(false);
    const [newMiz, setNewMiz] = $acw62.useState(null);
    const [updateFetching, setUpdateFetching] = $acw62.useState(false);
    const [downloading, setDownloading] = $acw62.useState(false);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const update = (0, $0a53c1f23450367c$export$4f91b3529d70dcc2)();
    const handleDownload = async (e)=>{
        e.preventDefault();
        setDownloading(true);
        const zip = await download(fragOrder);
        zip.generateAsync({
            type: "blob"
        }).then((blob)=>{
            (0, $90f256c567e4c320$exports.saveAs)(blob, fragOrder.mizFileName);
            success("Mission file downloaded.");
        }).finally(()=>setDownloading(false));
    };
    const handleUpdateClicked = ()=>{
        setUpdateMode(true);
    };
    const handleMizDropped = (file, metadata)=>{
        setNewMiz({
            file: file,
            metadata: metadata
        });
    };
    const handleUpdateMiz = ()=>{
        setUpdateFetching(true);
        const next = {
            ...fragOrder,
            mizFileName: newMiz.file.name,
            mizFileSize: newMiz.file.size,
            mizMetadata: newMiz.metadata
        };
        update(next, (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(publishStatus, "coalition"), newMiz).then(()=>success(`New Miz file ${newMiz.file.name}`)).catch((err)=>error(err.message)).finally(()=>{
            setUpdateMode(false);
            setUpdateFetching(false);
            setNewMiz(null);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        title: "Mission File Details",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginTop: 2,
                marginBottom: 2,
                style: {
                    borderBottom: "1px solid #b0b0b0"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                    columns: 3,
                    pairs: [
                        {
                            value: fragOrder?.id,
                            key: "ID"
                        },
                        {
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                                time: fragOrder?.created_at_timestamp
                            }),
                            key: "Created"
                        },
                        {
                            value: fragOrder?.mizFileName,
                            key: "Filename"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: !newMiz && isUpdateMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9563a3fbb18fea6b$export$2e2bcd8739ae039), {
                    onDrop: handleMizDropped
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $537ff0a6203c2271$export$2e2bcd8739ae039), {
                    miz: {
                        metadata: fragOrder?.mizMetadata,
                        file: {
                            name: fragOrder?.mizFileName
                        }
                    },
                    diff: newMiz
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    start: true,
                    children: [
                        isUpdateMode ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            align: true,
                            start: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                    loading: updateFetching,
                                    disabled: !newMiz,
                                    variant: "contained",
                                    onClick: handleUpdateMiz,
                                    children: "Update Frag Order"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    style: {
                                        marginLeft: 8
                                    },
                                    onClick: ()=>{
                                        setNewMiz(null);
                                        setUpdateMode(false);
                                    },
                                    variant: "outlined",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                                    style: {
                                        marginLeft: 8
                                    },
                                    severity: "warning",
                                    children: "Changing the mission file for this Frag Order may invalidate existing plans"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            style: {
                                marginRight: 8
                            },
                            onClick: handleUpdateClicked,
                            variant: "outlined",
                            type: "button",
                            children: "Update Mission File"
                        }),
                        !isUpdateMode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                            loading: downloading,
                            onClick: handleDownload,
                            variant: "outlined",
                            type: "button",
                            children: "Download Original"
                        })
                    ]
                })
            })
        ]
    });
}
var $b8e7887d6b9f2ec2$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($b8e7887d6b9f2ec2$var$MizFileDetails).attrs({
    className: $b8e7887d6b9f2ec2$var$MizFileDetails.name
})``;




var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");





var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


function $de0670fe9e1c7ea3$var$GroupSelect({ className: className, onChange: onChange, groups: groups, value: value }) {
    const [filter, setFilter] = $acw62.useState("");
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(groups, (g)=>g.toLowerCase().includes(filter.toLowerCase()));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                    children: "Groups"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mt: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), {
                    size: "small",
                    placeholder: "Filter",
                    onChange: (ev)=>{
                        setFilter(ev.target.value);
                    },
                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: ()=>setFilter(""),
                        children: "Clear"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                style: {
                    width: "100%"
                },
                component: "fieldset",
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        my: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            align: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    onClick: ()=>onChange([]),
                                    children: "Deselect All"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    onClick: ()=>onChange(groups),
                                    children: "Select All"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            minWidth: "100%",
                            overflowY: "auto"
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(filtered, (g)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    align: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                        label: g,
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                            checked: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(value, g),
                                            onChange: (ev)=>{
                                                if (ev.target.checked) onChange([
                                                    ...value,
                                                    g
                                                ]);
                                                else onChange((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).without(value, g));
                                            }
                                        })
                                    })
                                })
                            }, g))
                    })
                ]
            })
        ]
    });
}
var $de0670fe9e1c7ea3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($de0670fe9e1c7ea3$var$GroupSelect).attrs({
    className: $de0670fe9e1c7ea3$var$GroupSelect.name
})``;



function $09efccd7cc27f9d8$var$PlanningRuleModal({ className: className, open: open, onClose: onClose, rule: rule, actionType: actionType, onChange: onChange, onSubmit: onSubmit, groups: groups, updating: updating, guildID: guildID }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        className: className,
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
            style: {
                minWidth: 480
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: actionType === "create" ? "Create Planning Rule" : "Edit Planning Rule",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                mb: 2,
                                children: actionType === "create" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b11e7d507ec13d1e$export$2e2bcd8739ae039), {
                                    guildID: guildID,
                                    discordID: rule?.discordUserID,
                                    displayName: rule?.discordDisplayText,
                                    onChange: (user)=>onChange({
                                            ...rule,
                                            discordUserID: user.discordUserID,
                                            discordDisplayText: user.displayName
                                        })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                                            children: "Username"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: rule?.discordDisplayText
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                my: 1,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                                    severity: "warning",
                                    children: "A group can only be planned by one person at a time. Groups with existing planning rules have been removed from this list."
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de0670fe9e1c7ea3$export$2e2bcd8739ae039), {
                                onChange: (val)=>{
                                    onChange({
                                        ...rule,
                                        plannableGroupNames: val
                                    });
                                },
                                value: rule?.plannableGroupNames,
                                groups: groups
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        align: true,
                        wide: true,
                        between: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                disabled: !rule?.discordUserID,
                                loading: updating,
                                type: "submit",
                                variant: "contained",
                                onClick: onSubmit,
                                children: "Save"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: onClose,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $09efccd7cc27f9d8$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($09efccd7cc27f9d8$var$PlanningRuleModal).attrs({
    className: $09efccd7cc27f9d8$var$PlanningRuleModal.name
})`
  ${(0, $de0670fe9e1c7ea3$export$2e2bcd8739ae039)} {
    max-height: 640px;
  }
`;


// The move to PlanItems was a failure, so we need this to easily control if we can have multiple planners.
const $848b0287815001a2$var$ENABLE_MULTIPLE_PLANNERS = false;
function $848b0287815001a2$var$PlanningManagementForm({ className: className, manifest: manifest, fragOrderID: fragOrderID }) {
    const [removing, setRemoving] = $acw62.useState(null);
    const update = (0, $aae70ce689e02dd3$export$922bf4ca65b75c36)();
    const remove = (0, $aae70ce689e02dd3$export$6d3369aca4859529)();
    const [updating, setUpdating] = $acw62.useState(false);
    const [editing, setEditing] = $acw62.useState(null);
    const [creating, setCreating] = $acw62.useState(null);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const { data: tasking } = (0, $aae70ce689e02dd3$export$f760ffd5af329347)(manifest);
    const availableGroups = $848b0287815001a2$var$ENABLE_MULTIPLE_PLANNERS ? tasking?.plannedGroups : (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(tasking?.plannedGroups, (g)=>!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifest.planningRules, (rule)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(rule.plannableGroupNames, g.name)));
    if (!manifest) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        wide: true,
        center: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            column: true,
            align: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    children: "This Frag Order has not been published."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                    to: `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).FragOrderDetail}/${fragOrderID}/publish`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        variant: "contained",
                        children: "View Publish Options"
                    })
                })
            ]
        })
    });
    const handleRemove = (rule)=>{
        if (window.confirm("Are you sure you want to remove this rule?")) {
            setRemoving(rule);
            remove(manifest, rule).then(()=>setRemoving(null));
        }
    };
    const handleEditSubmit = ()=>{
        setUpdating(true);
        update(manifest, {
            ...editing
        }).then(()=>{
            success("Planning rules updated.");
            setEditing(null);
        }).catch((e)=>error(e.message)).finally(()=>setUpdating(false));
    };
    const handleCreateSubmit = ()=>{
        if (!creating.discordUserID) {
            error("You must select a user to create a planning rule.");
            return;
        }
        setUpdating(true);
        update(manifest, {
            ...creating
        }).then(()=>{
            success("Planning rules updated.");
            setCreating(null);
        }).catch((e)=>error(e.message)).finally(()=>setUpdating(false));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                columns: [
                    {
                        value: "discordDisplayText",
                        label: "Username"
                    },
                    {
                        value: (r)=>`${r.plannableGroupNames.length} groups`,
                        label: "Plannable Groups"
                    },
                    {
                        label: "",
                        width: 64,
                        value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: ()=>setEditing((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).cloneDeep(r)),
                                children: "Edit"
                            })
                    },
                    {
                        value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                loading: removing?.discordUserID === r.discordUserID || removing?.discordRoleID === r.discordRoleID,
                                onClick: ()=>handleRemove(r),
                                variant: "outlined",
                                color: "error",
                                children: "Remove"
                            }),
                        label: "",
                        width: 64
                    }
                ],
                rows: manifest.planningRules
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                    marginBottom: 4,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5363c9a2f115365$export$2e2bcd8739ae039), {
                        marginTop: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "outlined",
                            onClick: ()=>{
                                setCreating({
                                    discordDisplayText: "",
                                    discordUserID: null,
                                    plannableGroupNames: [],
                                    isRoleRule: false,
                                    discordRoleID: null
                                });
                            },
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e6d7c02ec7f0f0df$exports))), {}),
                            children: "Add Planning Rule"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09efccd7cc27f9d8$export$2e2bcd8739ae039), {
                open: !!editing,
                onClose: ()=>setEditing(null),
                actionType: "edit",
                updating: updating,
                onChange: (rule)=>setEditing({
                        ...editing,
                        ...rule
                    }),
                onSubmit: handleEditSubmit,
                rule: editing,
                groups: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(availableGroups, "name")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09efccd7cc27f9d8$export$2e2bcd8739ae039), {
                open: !!creating,
                onClose: ()=>setCreating(null),
                actionType: "create",
                updating: updating,
                onChange: (rule)=>setCreating({
                        ...editing,
                        ...rule
                    }),
                onSubmit: handleCreateSubmit,
                rule: creating,
                groups: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(availableGroups, "name"),
                guildID: manifest.discordGuildID
            })
        ]
    });
}
var $848b0287815001a2$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($848b0287815001a2$var$PlanningManagementForm).attrs({
    className: $848b0287815001a2$var$PlanningManagementForm.name
})`
  .MuiAutocomplete-root {
    min-width: 360px;
    /* margin-right: 36px; */
  }

  .MuiInputBase-root {
    min-width: 120px;
  }

  .MuiFormControl-root {
    box-sizing: border-box;
  }

  .MuiButton-root {
    text-decordation: none;
  }

  .MuiFormGroup-root .MuiBox-root {
    padding: 0;
  }
`;


function $5bb7b2aef9f9da41$var$PlanningManagement({ className: className, fragOrder: fragOrder }) {
    const showCTA = (0, $0ecfc9ca75a4d1c7$export$c4e92f8db4fb36b8)(fragOrder?.discordGuildID);
    const { data: manifests, isLoading: isLoading } = (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(fragOrder?.id);
    if (!isLoading && manifests.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        title: "Manage Planners",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            center: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                severity: "warning",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                        children: "Not published"
                    }),
                    "Publish this Frag Order to add planners"
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        title: "Manage Planners",
        children: showCTA ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13f33801a95b7a8c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, (pm)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    marginBottom: 6,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            color: pm.coalition,
                            fontSize: 18,
                            fontWeight: 600,
                            children: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(pm.coalition),
                                " Coalition Planners"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $848b0287815001a2$export$2e2bcd8739ae039), {
                                className: className,
                                fragOrderID: fragOrder?.id,
                                manifest: pm,
                                discordGuildID: fragOrder?.discordGuildID
                            })
                        })
                    ]
                }, pm.id);
            })
        })
    });
}
var $5bb7b2aef9f9da41$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($5bb7b2aef9f9da41$var$PlanningManagement).attrs({
    className: $5bb7b2aef9f9da41$var$PlanningManagement.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");
var $f5f3b43c43103337$export$44793fb586521995;
(function(PlanningManagementActionTypes) {
    PlanningManagementActionTypes[PlanningManagementActionTypes["loadManifests"] = 0] = "loadManifests";
    PlanningManagementActionTypes[PlanningManagementActionTypes["addNewRule"] = 1] = "addNewRule";
    PlanningManagementActionTypes[PlanningManagementActionTypes["removeNewRule"] = 2] = "removeNewRule";
    PlanningManagementActionTypes[PlanningManagementActionTypes["reset"] = 3] = "reset";
})($f5f3b43c43103337$export$44793fb586521995 || ($f5f3b43c43103337$export$44793fb586521995 = {}));
function $f5f3b43c43103337$export$ad1e71dc7802e1c9(state, action) {
    switch(action.type){
        case 0:
            return {
                ...state,
                manifests: action.manifests
            };
        case 1:
            return {
                ...state,
                newRules: [
                    ...state.newRules,
                    action.rule
                ]
            };
        case 2:
            return {
                ...state,
                newRules: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(state.newRules, (r, i)=>i !== action.index)
            };
        case 3:
            return {
                ...state,
                newRules: []
            };
        default:
            return state;
    }
}
const $f5f3b43c43103337$export$2e34b7184a88e2fc = /*#__PURE__*/ $acw62.createContext({});
function $f5f3b43c43103337$export$49d5fc8cba920a0() {
    return {
        manifests: [],
        newRules: []
    };
}
function $f5f3b43c43103337$export$c594b9a03bee95fd({ children: children }) {
    const initialState = $f5f3b43c43103337$export$49d5fc8cba920a0();
    const [state, dispatch] = $acw62.useReducer($f5f3b43c43103337$export$ad1e71dc7802e1c9, initialState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f5f3b43c43103337$export$2e34b7184a88e2fc.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $166ac195f7d2f6f7$exports = {};
"use strict";

Object.defineProperty($166ac195f7d2f6f7$exports, "__esModule", {
    value: true
});
$166ac195f7d2f6f7$exports.default = void 0;

var $166ac195f7d2f6f7$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $166ac195f7d2f6f7$var$_default = (0, $166ac195f7d2f6f7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
}), "Pending");
$166ac195f7d2f6f7$exports.default = $166ac195f7d2f6f7$var$_default;





var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");













function $8af4bba2ef1d811b$var$statusIcon(status) {
    switch(status){
        case (0, $319680b363c8af04$export$60715063f26dc4e3).Invalid:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($79f00c956e46f4d6$exports))), {
                color: "error"
            });
        case (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca4fd08777d4e412$exports))), {
                color: "success"
            });
        default:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($166ac195f7d2f6f7$exports))), {});
    }
}
function $8af4bba2ef1d811b$var$PlanningStatus({ className: className, fragOrder: fragOrder }) {
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    const manager = (0, $92839c6c950486dc$export$b7eed842b7007476)();
    const { data: plans } = (0, $92839c6c950486dc$export$aa3859200fac1b16)(fragOrder.id, {
        refetchOnWindowFocus: true,
        refetchInterval: 10000,
        refetchIntervalInBackground: true
    });
    const { error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const [invalidating, setInvalidating] = $acw62.useState(null);
    const [deleting, setDeleting] = $acw62.useState(null);
    const [details, setDetails] = $acw62.useState(null);
    const handleInvalidate = (p)=>{
        const ok = confirm(`Are you sure you want to invalidate this plan for group ${p.groupName}?`);
        if (!ok) return;
        setInvalidating(p.id);
        manager.invalidatePlan(fragOrder.id, p).catch((e)=>error(e.message)).finally(()=>{
            queryClient.invalidateQueries([
                (0, $92839c6c950486dc$export$2bc4a83296d7cbc4)
            ]);
            setInvalidating(null);
        });
    };
    const handleDelete = (p)=>{
        const ok = confirm(`Are you sure you want to invalidate this plan for group ${p.groupName}?`);
        if (!ok) return;
        setDeleting(p.id);
        manager.removePlan(fragOrder.id, p).catch((e)=>error(e.message)).finally(()=>{
            queryClient.invalidateQueries([
                (0, $92839c6c950486dc$export$2bc4a83296d7cbc4)
            ]);
            setDeleting(null);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: "Planning Status"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginLeft: 8,
                        paddingTop: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4add6e1ce5f07b5e$export$2e2bcd8739ae039), {
                        to: "https://docs.fragorders.com/docs/managing-planners#handling-multiple-planners-for-a-single-group"
                    })
                })
            ]
        }),
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                columns: [
                    {
                        label: "Group",
                        value: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                                to: "",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setDetails(p);
                                },
                                children: p.groupName
                            })
                    },
                    {
                        label: "Last Updated",
                        value: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                                time: p.updated_at_timestamp
                            })
                    },
                    {
                        label: "Status",
                        value: (p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                align: true,
                                children: [
                                    $8af4bba2ef1d811b$var$statusIcon(p.status),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        paddingX: 1,
                                        children: p.status
                                    })
                                ]
                            })
                    },
                    {
                        label: "Submitted By",
                        value: "submitterDisplayText"
                    },
                    {
                        value: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: p.coalition,
                                    fontWeight: 600
                                },
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(p.coalition)
                            }),
                        label: "Coalition"
                    },
                    {
                        label: "",
                        value: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                loading: invalidating === p.id,
                                onClick: ()=>handleInvalidate(p),
                                variant: "outlined",
                                color: "error",
                                disabled: p.status === (0, $319680b363c8af04$export$60715063f26dc4e3).Invalid,
                                children: "Invalidate"
                            })
                    },
                    {
                        label: "",
                        value: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                loading: deleting === p.id,
                                onClick: ()=>handleDelete(p),
                                variant: "contained",
                                color: "error",
                                children: "Delete"
                            })
                    }
                ],
                rows: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(plans, "groupName")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: !!details,
                onClose: ()=>{
                    setDetails(null);
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
                    style: {
                        width: 480
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: "Plan Details"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                                columns: 2,
                                pairs: [
                                    {
                                        key: "Group",
                                        value: details?.groupName
                                    },
                                    {
                                        key: "Submitted By",
                                        value: details?.submitterDisplayText
                                    },
                                    {
                                        key: "Waypoint Count",
                                        value: details?.waypoints?.length
                                    },
                                    {
                                        key: "Nav Point Count",
                                        value: details?.navPoints?.length
                                    },
                                    {
                                        key: "Radio Channels Set",
                                        value: details?.radioOverrides ? "Yes" : "No"
                                    },
                                    {
                                        key: "Remarks Length",
                                        value: details?.plannerNotes?.length
                                    }
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $8af4bba2ef1d811b$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($8af4bba2ef1d811b$var$PlanningStatus).attrs({
    className: $8af4bba2ef1d811b$var$PlanningStatus.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");









function $2daf37144f66011c$var$PlanStatusV2({ className: className }) {
    const { data: manifests, isLoading: isLoading } = (0, $0a53c1f23450367c$export$d58792fea78fddc6)();
    const blueMan = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
        coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue
    });
    const redMan = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
        coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red
    });
    const { data: blue, isLoading: blueLoading, error: blueError } = (0, $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f)(blueMan?.id, {
        refetchOnWindowFocus: true,
        refetchInterval: 10000
    });
    const { data: red, isLoading: redLoading, error: redError } = (0, $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f)(redMan?.id, {
        refetchOnWindowFocus: true,
        refetchInterval: 10000
    });
    if (isLoading || blueLoading || redLoading) return null;
    if (blueError || redError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
        severity: "error",
        children: blueError?.message || redError?.message
    });
    const all = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).concat([], (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(blue, (b)=>({
            ...b,
            coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue
        })), (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(red, (r)=>({
            ...r,
            coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Red
        }))));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        loading: blueLoading || redLoading,
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: "Planning Status"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginLeft: 8,
                        paddingTop: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4add6e1ce5f07b5e$export$2e2bcd8739ae039), {
                        to: "https://docs.fragorders.com/docs/managing-planners#handling-multiple-planners-for-a-single-group"
                    })
                })
            ]
        }),
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            columns: [
                {
                    value: "group",
                    label: "Group"
                },
                {
                    value: "type",
                    label: "Type"
                },
                {
                    value: "createdByUserName",
                    label: "Created By"
                },
                {
                    value: (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                            time: item.updated_at_timestamp
                        }),
                    label: "Last Updated"
                }
            ],
            rows: all
        })
    });
}
var $2daf37144f66011c$export$2e2bcd8739ae039 // Saving for when a conflict is actually possible
 // function findConflicts(arr: PlanItem[]) {
 //   const groupedItems = arr.reduce((acc, item) => {
 //     const key = `${item.group}-${item.uniqID}-${item.type}`;
 //     if (!acc[key]) {
 //       acc[key] = [];
 //     }
 //     acc[key].push(item);
 //     return acc;
 //   }, {} as Record<string, PlanItem[]>);
 //   const duplicates = Object.keys(groupedItems)
 //     .filter((key) => groupedItems[key].length > 1)
 //     .map((key) => ({
 //       key,
 //       count: groupedItems[key].length,
 //       items: groupedItems[key],
 //     }));
 //   return duplicates;
 // }
 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($2daf37144f66011c$var$PlanStatusV2).attrs({
    className: $2daf37144f66011c$var$PlanStatusV2.name
})``;


function $a94a71b4ebe4efe4$var$Wrapper(props) {
    const { data: fragOrder, isLoading: isLoading, error: error } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const { data: manifests, isLoading: manifestsLoading } = (0, $0a53c1f23450367c$export$d58792fea78fddc6)();
    if (isLoading || manifestsLoading) return null;
    if (error) {
        console.error(error);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
            severity: "error",
            children: error.message
        });
    }
    const isNewPlanItemSchema = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).some(manifests, (m)=>m.version >= 3);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f5f3b43c43103337$export$c594b9a03bee95fd), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: isNewPlanItemSchema ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2daf37144f66011c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8af4bba2ef1d811b$export$2e2bcd8739ae039), {
                    fragOrder: fragOrder
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginBottom: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bb7b2aef9f9da41$export$2e2bcd8739ae039), {
                    ...props,
                    fragOrder: fragOrder
                })
            })
        ]
    });
}
var $a94a71b4ebe4efe4$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a94a71b4ebe4efe4$var$Wrapper).attrs({
    className: $a94a71b4ebe4efe4$var$Wrapper.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $f1q41 = parcelRequire("f1q41");







var $ayMG0 = parcelRequire("ayMG0");




var $3JxLy = parcelRequire("3JxLy");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");









var $ayMG0 = parcelRequire("ayMG0");




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");








function $ad5b605de262ade3$var$CSVImportDialog({ className: className, modalProps: modalProps, onSubmit: onSubmit }) {
    const [busy, setBusy] = $acw62.useState(false);
    const [rows, setRows] = $acw62.useState([]);
    const { error: error, success: success } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const handleSubmit = ()=>{
        setBusy(true);
        onSubmit(rows).then(()=>{
            success("Imported roles from CSV");
        }).finally(()=>{
            setBusy(false);
            modalProps.onClose({}, "escapeKeyDown");
        });
    };
    const handleFileDrop = async (files)=>{
        const file = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(files);
        if (!file) return;
        const txt = await file.text();
        (0, $7d5e0210243299ed$export$98e6a39c04603d36)(txt, {
            columns: true
        }, (err, output)=>{
            if (err) {
                error("Error parsing CSV: " + err.message);
                return;
            }
            setRows(output);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            ...modalProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                    title: "Import Roles from CSV",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            my: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    children: "Importing roles from CSV will create a new signup rule for each row in the CSV file."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    my: 2,
                                    children: [
                                        rows.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $880d05f11d0a3304$export$2e2bcd8739ae039), {
                                            text: "Drag and Drop your .csv file here",
                                            onFileDrop: handleFileDrop
                                        }),
                                        rows.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                                            columns: [
                                                {
                                                    label: "Mission Role",
                                                    value: "missionRole"
                                                },
                                                {
                                                    label: "Role Type",
                                                    value: "signupRoleType"
                                                },
                                                {
                                                    label: "Allowed Discord Role",
                                                    value: "discordLabel"
                                                },
                                                {
                                                    value: (r)=>(0, $b9c9d9c1adf94aca$export$f6f709ff2b245f60)(r.module),
                                                    label: "Module"
                                                },
                                                {
                                                    value: "slotCount",
                                                    label: "Slot Count"
                                                }
                                            ],
                                            rows: rows
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginTop: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                wide: true,
                                between: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                        loading: busy,
                                        disabled: rows.length === 0,
                                        variant: "contained",
                                        onClick: handleSubmit,
                                        children: "Import"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        onClick: ()=>modalProps.onClose({}, "escapeKeyDown"),
                                        variant: "outlined",
                                        children: "Close"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
var $ad5b605de262ade3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ad5b605de262ade3$var$CSVImportDialog).attrs({
    className: $ad5b605de262ade3$var$CSVImportDialog.name
})``;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");








function $13d08f246da709ea$var$ImporGroupsDialog({ className: className, tasking: tasking, onImportSubmit: onImportSubmit, members: members, modalProps: modalProps }) {
    const [busy, setBusy] = $acw62.useState(false);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const [defaultDiscordRole, setRole] = $acw62.useState((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(members, {
        name: "@everyone"
    }));
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(tasking.plannedGroups, (group)=>({
            missionRole: group.name,
            discordID: `r_${defaultDiscordRole?.id}`,
            discordLabel: defaultDiscordRole?.name,
            signupRoleType: (0, $cc7c21536f059c95$export$c75b72909fbb7204).Aircrew,
            coalition: "Blue",
            module: (0, $b9c9d9c1adf94aca$export$f028d354b7025aa9)(group),
            slotCount: group.units.length
        }));
    const handleSubmit = ()=>{
        setBusy(true);
        onImportSubmit(rows).then(()=>{
            success("Signup rules imported successfully.");
            modalProps.onClose({}, "escapeKeyDown");
        }).catch((e)=>{
            error("Error importing signup rules: " + e.message);
        }).finally(()=>{
            setBusy(false);
        });
    };
    if (!members) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            ...modalProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                    title: "Import Roles from Miz",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            my: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                children: "Importing rules from Miz will create a new signup rule for each flyable group in the .miz file."
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginBottom: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                wide: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                    sx: {
                                        width: 480
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                            id: "role-select-label",
                                            children: "Discord Role"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                            labelId: "role-select-label",
                                            label: "Discord Role",
                                            variant: "outlined",
                                            style: {
                                                width: "50%"
                                            },
                                            value: defaultDiscordRole?.id,
                                            onChange: (e)=>{
                                                const m = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(members, {
                                                    id: e.target.value
                                                });
                                                setRole(m);
                                            },
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(members, (member)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                    value: member.id,
                                                    children: member.name
                                                }, member.id))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                                            children: "Select a signup role to limit signup access to these groups."
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                            columns: [
                                {
                                    value: "missionRole",
                                    label: "Group Name"
                                },
                                {
                                    value: "signupRoleType",
                                    label: "Role Type"
                                },
                                {
                                    value: ()=>defaultDiscordRole?.name,
                                    label: "Discord Role"
                                },
                                {
                                    value: (r)=>(0, $b9c9d9c1adf94aca$export$f6f709ff2b245f60)(r.module),
                                    label: "Module"
                                },
                                {
                                    value: "slotCount",
                                    label: "Slot Count"
                                },
                                {
                                    value: "coalition",
                                    label: "Coalition"
                                }
                            ],
                            rows: rows
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginTop: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                wide: true,
                                between: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                        loading: busy,
                                        variant: "contained",
                                        onClick: handleSubmit,
                                        children: "Import"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        onClick: ()=>modalProps.onClose({}, "escapeKeyDown"),
                                        variant: "outlined",
                                        children: "Close"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
var $13d08f246da709ea$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($13d08f246da709ea$var$ImporGroupsDialog).attrs({
    className: $13d08f246da709ea$var$ImporGroupsDialog.name
})``;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");






function $ce9fe29dd94639b7$var$SignupRuleForm({ className: className, members: members, onSubmit: onSubmit, modalProps: modalProps, rule: initialRule }) {
    const [busy, setBusy] = $acw62.useState(false);
    const [rule, setRule] = $acw62.useState(initialRule);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const handleSubmit = (e)=>{
        e.preventDefault();
        setBusy(true);
        onSubmit(rule).then(()=>{
            modalProps.onClose({}, "escapeKeyDown");
            success("Signup rule updated successfully");
        }).catch((e)=>{
            error("Error updating signup rule: " + e.message);
        }).finally(()=>{
            setBusy(false);
        });
    };
    if (!initialRule) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            ...modalProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35112c070f73202a$export$2e2bcd8739ae039), {
                style: {
                    width: 480
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                    title: "Add/Edit Signup Rule",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                className: className,
                                marginTop: 2,
                                paddingTop: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                        onChange: (ev)=>setRule({
                                                                ...rule,
                                                                missionRole: ev.target.value
                                                            }),
                                                        value: rule.missionRole,
                                                        style: {
                                                            width: 180
                                                        },
                                                        label: "Role Name",
                                                        required: true,
                                                        fullWidth: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                                            id: "role-type-select-label",
                                                            children: "Role Type"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                            onChange: (ev)=>setRule({
                                                                    ...rule,
                                                                    signupRoleType: ev.target.value
                                                                }),
                                                            value: rule.signupRoleType,
                                                            label: "Role Type",
                                                            required: true,
                                                            sx: {
                                                                width: 180
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                    value: (0, $cc7c21536f059c95$export$c75b72909fbb7204).Aircrew,
                                                                    children: (0, $cc7c21536f059c95$export$c75b72909fbb7204).Aircrew
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                    value: (0, $cc7c21536f059c95$export$c75b72909fbb7204).Controller,
                                                                    children: (0, $cc7c21536f059c95$export$c75b72909fbb7204).Controller
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                                            id: "discord-select-label",
                                                            children: "Discord Role"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                            onChange: (ev)=>setRule({
                                                                    ...rule,
                                                                    discordID: ev.target.value,
                                                                    discordLabel: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(members, {
                                                                        id: ev.target.value
                                                                    }).name
                                                                }),
                                                            value: rule.discordID,
                                                            label: "Discord Role",
                                                            sx: {
                                                                width: 180
                                                            },
                                                            required: true,
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(members, (m)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                    value: m.id,
                                                                    children: m.name
                                                                }, m.id))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        width: 180
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                        onChange: (ev)=>{
                                                            if (ev.target.value) setRule({
                                                                ...rule,
                                                                slotCount: parseInt(ev.target.value)
                                                            });
                                                        },
                                                        value: rule.slotCount,
                                                        style: {
                                                            width: 180
                                                        },
                                                        type: "number",
                                                        label: "Slot Count",
                                                        required: true,
                                                        placeholder: "Count"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        marginTop: 2,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                            wide: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                style: {
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    multiline: true,
                                                    fullWidth: true,
                                                    label: "Notes",
                                                    rows: 12,
                                                    onChange: (ev)=>setRule({
                                                            ...rule,
                                                            notes: ev.target.value
                                                        }),
                                                    value: rule.notes || ""
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                marginTop: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    wide: true,
                                    between: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                            loading: busy,
                                            variant: "contained",
                                            type: "submit",
                                            children: "Add/Edit Rule"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            onClick: ()=>modalProps.onClose({}, "escapeKeyDown"),
                                            variant: "outlined",
                                            children: "Close"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
var $ce9fe29dd94639b7$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ce9fe29dd94639b7$var$SignupRuleForm).attrs({
    className: $ce9fe29dd94639b7$var$SignupRuleForm.name
})``;


function $9c47cd5fd4dddec2$var$SignupManagementForm({ className: className, manifest: manifest }) {
    const { data: fragOrder } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const [updating, setUpdating] = $acw62.useState(false);
    const [newRules, setNewRules] = $acw62.useState([]);
    const [removing, setRemoving] = $acw62.useState(null);
    const [csvOpen, setCsvOpen] = $acw62.useState(false);
    const [editing, setEditing] = $acw62.useState(null);
    const [importOpen, setImportOpen] = $acw62.useState(false);
    const update = (0, $aae70ce689e02dd3$export$f598f7827181eec0)();
    const { error: error, success: success } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const { data: members } = (0, $0ecfc9ca75a4d1c7$export$414c514f075f4b0e)(fragOrder.discordGuildID, true);
    const everyoneRole = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(members, {
        name: "@everyone"
    });
    const { data: tasking } = (0, $aae70ce689e02dd3$export$f760ffd5af329347)(manifest);
    const formattedMembers = $acw62.useMemo(()=>{
        if (!members) return [];
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(members, (m)=>({
                ...m,
                id: `r_${m.id}`
            }));
    }, [
        members
    ]);
    const rulesSubmittable = newRules.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).every(newRules, (r)=>!!r.missionRole);
    const handleImportSubmit = (rules)=>{
        const manifestRules = manifest.signupRules || [];
        const u = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniqBy([
            ...rules,
            ...manifestRules
        ], "missionRole");
        return update(manifest, u);
    };
    const handleRemove = (rule)=>{
        setRemoving(rule);
        const next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(manifest.signupRules, (r)=>r.missionRole !== rule.missionRole);
        update(manifest, next).then(()=>{
            success("Signup rule removed successfully");
        }).catch((e)=>{
            error("Error removing signup rule: " + e.message);
        }).finally(()=>{
            setRemoving(null);
        });
    };
    const handleAdd = ()=>{
        setEditing({
            missionRole: "",
            discordID: `r_${everyoneRole.id}`,
            discordLabel: everyoneRole.name,
            signupRoleType: "",
            slotCount: 0
        });
    };
    const handleEdit = (r)=>{
        setEditing(r);
    };
    const handleSubmit = ()=>{
        setUpdating(true);
        const next = [
            ...manifest.signupRules || [],
            ...newRules
        ];
        const hasDuplicates = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).uniqBy(next, "missionRole").length !== next.length;
        if (hasDuplicates) {
            error("Role names must be unique");
            setUpdating(false);
            return;
        }
        update(manifest, next).then(()=>{
            success("Signup rules updated successfully");
            setNewRules([]);
        }).catch((e)=>{
            error("Error updating signup rules: " + e.message);
        }).finally(()=>{
            setUpdating(false);
        });
    };
    const handleCSVImportDialog = ()=>{
        setCsvOpen(true);
    };
    const handleCSVDownload = ()=>{
        (0, $3JxLy.stringify)(manifest.signupRules, {
            header: true
        }, (err, output)=>{
            if (err) {
                error(err.message);
                return;
            }
            (0, $90f256c567e4c320$exports.saveAs)(new Blob([
                output
            ]), `${fragOrder.name}_SignupRules.csv`);
        });
    };
    const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(manifest?.signupRules || [], "missionRole");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                columns: [
                    {
                        label: "Mission Role",
                        value: "missionRole"
                    },
                    {
                        label: "Role Type",
                        value: "signupRoleType"
                    },
                    {
                        label: "Allowed Discord Role",
                        value: "discordLabel"
                    },
                    {
                        value: (r)=>(0, $b9c9d9c1adf94aca$export$f6f709ff2b245f60)(r.module),
                        label: "Module"
                    },
                    {
                        value: "slotCount",
                        label: "Slot Count"
                    },
                    {
                        value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: ()=>handleEdit(r),
                                children: "Edit"
                            }),
                        label: ""
                    },
                    {
                        label: "",
                        value: (rule)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                onClick: ()=>handleRemove(rule),
                                variant: "outlined",
                                color: "error",
                                loading: removing?.missionRole === rule.missionRole,
                                children: "Remove"
                            })
                    }
                ],
                rows: sorted
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    marginTop: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            wide: true,
                            between: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e6d7c02ec7f0f0df$exports))), {}),
                                        variant: "outlined",
                                        color: "primary",
                                        onClick: handleAdd,
                                        children: "Add Role"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            style: {
                                                marginRight: 8
                                            },
                                            variant: "outlined",
                                            color: "primary",
                                            onClick: handleCSVImportDialog,
                                            children: "Import from CSV"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                            variant: "outlined",
                                            color: "primary",
                                            onClick: ()=>setImportOpen(true),
                                            children: "Import From Miz"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginTop: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                wide: true,
                                between: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                        loading: updating,
                                        disabled: !rulesSubmittable,
                                        type: "submit",
                                        variant: "contained",
                                        color: "primary",
                                        onClick: handleSubmit,
                                        children: "Submit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        disabled: !manifest.signupRules || manifest.signupRules.length === 0,
                                        onClick: handleCSVDownload,
                                        variant: "outlined",
                                        children: "Save CSV"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            members && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13d08f246da709ea$export$2e2bcd8739ae039), {
                onImportSubmit: handleImportSubmit,
                tasking: tasking,
                members: members,
                modalProps: {
                    open: importOpen,
                    onClose: ()=>setImportOpen(false)
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ad5b605de262ade3$export$2e2bcd8739ae039), {
                // @ts-ignore
                modalProps: {
                    open: csvOpen,
                    onClose: ()=>setCsvOpen(false)
                },
                onSubmit: handleImportSubmit
            }),
            editing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce9fe29dd94639b7$export$2e2bcd8739ae039), {
                // @ts-ignore
                modalProps: {
                    open: !!editing,
                    onClose: ()=>setEditing(null)
                },
                rule: editing,
                members: formattedMembers,
                onSubmit: (rule)=>handleImportSubmit([
                        rule
                    ])
            })
        ]
    });
}
var $9c47cd5fd4dddec2$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($9c47cd5fd4dddec2$var$SignupManagementForm).attrs({
    className: $9c47cd5fd4dddec2$var$SignupManagementForm.name
})`
  ${(0, $67963b09fdec1ded$export$2e2bcd8739ae039)} {
    th,
    td {
      padding: 4px;
    }
  }
`;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




function $e765ec290675e3f2$var$SignupTable({ className: className, manifest: manifest }) {
    const { data: signups } = (0, $eb85d675c21bd358$export$5bd67ab68a9b3858)(manifest?.id);
    if (!signups) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        title: "Signups",
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            columns: [
                {
                    label: "Mission Role",
                    value: "missionRole"
                },
                {
                    label: "Discord User",
                    value: "discordNickname"
                }
            ],
            rows: signups
        })
    });
}
var $e765ec290675e3f2$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($e765ec290675e3f2$var$SignupTable).attrs({
    className: $e765ec290675e3f2$var$SignupTable.name
})``;


function $0d87a5d7637bdd6a$var$SignupManagement({ className: className }) {
    const [busy, setBusy] = $acw62.useState(false);
    const { data: fragOrder } = (0, $0a53c1f23450367c$export$288de7ed5d6c5943)();
    const { data: manifests } = (0, $0a53c1f23450367c$export$d58792fea78fddc6)();
    const showCTA = (0, $0ecfc9ca75a4d1c7$export$c4e92f8db4fb36b8)(fragOrder?.discordGuildID);
    const update = (0, $aae70ce689e02dd3$export$9e1f293388361fee)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const signupsEnabled = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).every(manifests, {
        signupsEnabled: true
    });
    const handleSignupsEnabledChange = (event)=>{
        setBusy(true);
        Promise.all((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(manifests, (manifest)=>update(manifest, event.target.checked))).then(()=>{
            success("Frag Order updated successfully");
        }).catch((e)=>{
            error("Error enabling signups: " + e.message);
        }).finally(()=>{
            setBusy(false);
        });
    };
    const blueManifest = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(manifests, {
        coalition: (0, $91a9098e14452db2$export$193e4cdf5c5b208).Blue
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    between: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontSize: 24,
                            variant: "h3",
                            children: "Manage Signup Rules"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            align: true,
                            children: [
                                busy && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    marginLeft: 2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                disabled: busy,
                                                onChange: handleSignupsEnabledChange,
                                                checked: signupsEnabled || false,
                                                inputProps: {
                                                    "aria-label": "Enable Signups"
                                                }
                                            }),
                                            label: "Enable Signups"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                children: [
                    showCTA && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13f33801a95b7a8c$export$2e2bcd8739ae039), {}),
                    !showCTA && !signupsEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        center: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                            severity: "info",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                                    children: "Signups Disabled"
                                }),
                                "Enable signups to manage attendance via Frag Orders"
                            ]
                        })
                    }),
                    !showCTA && signupsEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginTop: 6,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c47cd5fd4dddec2$export$2e2bcd8739ae039), {
                                manifest: blueManifest
                            })
                        })
                    })
                ]
            }),
            signupsEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginY: 4,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e765ec290675e3f2$export$2e2bcd8739ae039), {
                    manifest: blueManifest
                })
            })
        ]
    });
}
var $0d87a5d7637bdd6a$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($0d87a5d7637bdd6a$var$SignupManagement).attrs({
    className: $0d87a5d7637bdd6a$var$SignupManagement.name
})``;







function $9f72663470074fe3$var$FragOrderDetail({ className: className }) {
    const { id: id } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const { data: fragOrder, isLoading: isLoading, error: error } = (0, $0a53c1f23450367c$export$ca476617908cb2f8)(id);
    const { data: publishStatus } = (0, $aae70ce689e02dd3$export$2ca11ab2ab0c6e67)(id);
    const { url: url } = (0, $ebf4c3fe5600f7ed$export$632be4bb944c1bc7)();
    const isInvalidPublishManfest = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).some(publishStatus, (p)=>p.version > 2);
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47b3c0eb5fee4469$export$2e2bcd8739ae039), {
        message: error.message
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3beee71e1808c2fa$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                    to: (0, $91a9098e14452db2$export$37d3279522fbf5e2).Home,
                    children: "Frag Orders"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        fontSize: "1.5em",
                        component: "h2",
                        children: fragOrder?.name
                    })
                })
            ]
        }),
        loading: isLoading,
        className: className,
        actions: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $613813714b5a49bd$export$2e2bcd8739ae039), {
            manifests: publishStatus
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $be582a387d00e7dd$export$2e2bcd8739ae039), {
                grow: 2,
                children: [
                    isInvalidPublishManfest && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        my: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                            severity: "error",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                                    children: "This Frag Order is broken"
                                }),
                                "Due to an internal Frag Orders bug, this Frag Order may not behave properly. If you are using planning features, you may need to re-create this Frag Order. Please consult the",
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "https://discord.gg/bt9MmAJJ",
                                    children: "Frag Orders Discord"
                                }),
                                " ",
                                "with any questions."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a6bef72edba85b27$export$2e2bcd8739ae039), {
                        rootPath: `${url}/details`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                name: "Miz File",
                                path: `${url}/details`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    marginBottom: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8e7887d6b9f2ec2$export$2e2bcd8739ae039), {
                                            fragOrder: fragOrder
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            marginTop: 2,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de512c4eecec72c9$export$2e2bcd8739ae039), {
                                                id: id
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                name: "Publish",
                                path: `${url}/publish`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    marginBottom: 2,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccc04424d1078738$export$2e2bcd8739ae039), {
                                        manifests: publishStatus,
                                        fragOrder: fragOrder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                subscriberOnly: true,
                                name: "Planning",
                                path: `${url}/planning`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a94a71b4ebe4efe4$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                subscriberOnly: true,
                                path: `${url}/kneeboards`,
                                name: "Kneeboards",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60570f6077788674$export$2e2bcd8739ae039), {
                                    fragOrder: fragOrder,
                                    manifests: publishStatus
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                subscriberOnly: true,
                                path: `${url}/radios`,
                                name: "Radios",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d18edc80ae035d4$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                subscriberOnly: true,
                                path: `${url}/drawing`,
                                name: "Control Measures",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4efb1624e884cf13$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                subscriberOnly: true,
                                path: `${url}/external-data`,
                                name: "Batch Edit",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dadcf0039068e3f7$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6bef72edba85b27$export$733ac94ecabeac6c), {
                                featureFlag: (0, $1bfb465a9f0e47a1$export$df35587a8f95f16f).Signups,
                                subscriberOnly: true,
                                path: `${url}/signups`,
                                name: "Signups",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d87a5d7637bdd6a$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $9f72663470074fe3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($9f72663470074fe3$var$FragOrderDetail).attrs({
    className: $9f72663470074fe3$var$FragOrderDetail.name
})`
  .MuiAvatar-root {
    height: 24px;
    width: 24px;

    padding-top: 6px;
  }

  .MuiBreadcrumbs-root {
    ${(0, $f167d3e4f22a6e20$export$2e2bcd8739ae039)} {
      font-size: 1.5em;
    }

    h2 {
      margin: 0;
    }
  }

  .MuiButton-root {
    white-space: nowrap;
  }

  @media only screen and (max-width: 600px) {
    .SubRouterTabs {
      max-width: 100%;
      overflow-y: auto;
    }

    .MuiContainer-root {
      padding-left: 0px;
    }

    .SubRouterTabs > .MuiBox-root,
    .SubRouterTabs > .MuiBox-root > .MuiBox-root {
      padding-left: 0px;
    }

    .MuiBox-root {
      padding: 12px;
    }
    h2 {
      font-size: 18px;
    }

    td,
    th {
      white-space: nowrap;
      padding: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .miz-stat-value {
      max-width: 64px;
    }

    .MuiAutocomplete-root {
      min-width: 240px;
    }

    .MuiOutlinedInput-root {
      max-width: 240px;
    }

    .MuiTabs-scroller .MuiButtonBase-root {
      max-width: 100%;
      /* padding: 4px; */
      /* font-size: 12px; */
    }

    .MizFileDetails > .Flex:first-child > .MuiBox-root {
      /* padding: 0; */
      overflow: hidden;
    }
  }
`;



var $ayMG0 = parcelRequire("ayMG0");




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bOOlK = parcelRequire("bOOlK");



var $1En50 = parcelRequire("1En50");

var $6IaFk = parcelRequire("6IaFk");
const $20be6fcb5f4e29cd$var$_excluded = [
    "variant"
];
function $20be6fcb5f4e29cd$var$isEmpty(string) {
    return string.length === 0;
}
function $20be6fcb5f4e29cd$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $1En50.default)(props, $20be6fcb5f4e29cd$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $20be6fcb5f4e29cd$var$isEmpty(classKey) ? props[key] : (0, $6IaFk.default)(props[key]);
        else classKey += `${$20be6fcb5f4e29cd$var$isEmpty(classKey) ? key : (0, $6IaFk.default)(key)}${(0, $6IaFk.default)(props[key].toString())}`;
    });
    return classKey;
}



const $a0abf5ad226c4fb0$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
], $a0abf5ad226c4fb0$var$_excluded2 = [
    "theme"
], $a0abf5ad226c4fb0$var$_excluded3 = [
    "theme"
];
function $a0abf5ad226c4fb0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
const $a0abf5ad226c4fb0$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $a0abf5ad226c4fb0$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $20be6fcb5f4e29cd$export$2e2bcd8739ae039)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $a0abf5ad226c4fb0$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $20be6fcb5f4e29cd$export$2e2bcd8739ae039)(themeVariant.props)]);
    });
    return variantsStyles;
}; // Update /system/styled/#api in case if this changes
function $a0abf5ad226c4fb0$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $a0abf5ad226c4fb0$export$35e57303dbd8a66 = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
const $a0abf5ad226c4fb0$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0abf5ad226c4fb0$export$2e2bcd8739ae039(input = {}) {
    const { defaultTheme: defaultTheme = $a0abf5ad226c4fb0$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, styleFunctionSx: styleFunctionSx = (0, $6b750d631801d296$export$2e2bcd8739ae039) } = input;
    return (tag, inputOptions = {})=>{
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: overridesResolver } = inputOptions, options = (0, $1En50.default)(inputOptions, $a0abf5ad226c4fb0$var$_excluded); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0abf5ad226c4fb0$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                // eslint-disable-next-line no-underscore-dangle
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (_ref)=>{
                    let { theme: themeInput } = _ref, other = (0, $1En50.default)(_ref, $a0abf5ad226c4fb0$var$_excluded2);
                    return stylesArg((0, $8nd05.default)({
                        theme: $a0abf5ad226c4fb0$var$isEmpty(themeInput) ? defaultTheme : themeInput
                    }, other));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                const styleOverrides = $a0abf5ad226c4fb0$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $8nd05.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                return $a0abf5ad226c4fb0$var$variantsResolver(props, $a0abf5ad226c4fb0$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                return styleFunctionSx((0, $8nd05.default)({}, props, {
                    theme: theme
                }));
            });
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill(""); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            // eslint-disable-next-line no-underscore-dangle
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (_ref2)=>{
                let { theme: themeInput } = _ref2, other = (0, $1En50.default)(_ref2, $a0abf5ad226c4fb0$var$_excluded3);
                return styleArg((0, $8nd05.default)({
                    theme: $a0abf5ad226c4fb0$var$isEmpty(themeInput) ? defaultTheme : themeInput
                }, other));
            };
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $0016d2a363b4c314$var$styled = (0, $a0abf5ad226c4fb0$export$2e2bcd8739ae039)();
var $0016d2a363b4c314$export$2e2bcd8739ae039 = $0016d2a363b4c314$var$styled;


parcelRequire("acw62");



var $ff3c59efeb22b231$exports = {};
$ff3c59efeb22b231$exports = new URL("fo_hero_3.64ac82fc.png", import.meta.url).toString();



var $d1a1ffcef019088a$exports = {};
$d1a1ffcef019088a$exports = new URL("showoff.22672bdf.png", import.meta.url).toString();



// function Copyright(props: any) {
//   return (
//     <Typography
//       variant="body2"
//       color="text.secondary"
//       align="center"
//       {...props}
//     >
//       {"Copyright © "}
//       <Link color="inherit" href="https://mui.com/">
//         Your Website
//       </Link>{" "}
//       {new Date().getFullYear()}
//       {"."}
//     </Typography>
//   );
// }
const $426e52f8305c025b$var$LoginHeader = (0, $0016d2a363b4c314$export$2e2bcd8739ae039)((0, $10469897db0fb9cc$export$2e2bcd8739ae039))`
  background-color: white;
  height: 64px;
  box-sizing: border-box;

  .MuiButton-root {
    margin: 0;
  }
`;
function $426e52f8305c025b$var$SignIn({ className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($426e52f8305c025b$var$LoginHeader, {
                align: true,
                wide: true,
                center: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginLeft: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                                to: (0, $91a9098e14452db2$export$37d3279522fbf5e2).Home,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed173ba6c38830a3$export$2e2bcd8739ae039), {
                                    variant: (0, $ed173ba6c38830a3$export$aadcd836922b29de).LeftAligned,
                                    width: 120
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        end: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            marginRight: 1,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5e8911e4b30dc90$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
                className: className,
                component: "main",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            p: 2,
                            sx: {
                                marginTop: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    column: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                            center: true,
                                            wide: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                children: "Visualize and Plan your Multiplayer DCS World Missions with Frag Orders"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                            center: true,
                                            wide: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "intro-img",
                                                height: 468,
                                                width: 768,
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d1a1ffcef019088a$exports)))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            m: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                    textAlign: "center",
                                                    fontWeight: 600,
                                                    fontSize: 18,
                                                    children: "For Mission Creators"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    m: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Publish your mission:"
                                                        }),
                                                        " Frag Orders extracts mission data and publishes to a hosted web page so that mission participants can see important information, such as waypoints, threat rings, and enemy locations."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    m: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Auto-generate kneeboards:"
                                                        }),
                                                        " Automatically create briefing materials using data extracted straight from the DCS .miz file with the press of a button."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    m: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Let the pilots plan:"
                                                        }),
                                                        " Mission participants will be able to drop waypoints, set radio frequencies, and add briefing notes to their in-game kneeboards."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    marginTop: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            textAlign: "center",
                                                            fontWeight: 600,
                                                            fontSize: 18,
                                                            children: "For Mission Participants"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Review the plan:"
                                                                }),
                                                                " Start building your situational awarness before the mission."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Collaborate with your wingmen: "
                                                                }),
                                                                " Frag Orders includes planning and drawing tools to help organize and communicate with your flight."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Plan your flight:"
                                                                }),
                                                                " Add and modify waypoints from the planning interface that will be written to the .miz file. Planners can also edit radio frequencies and add notes to their in-game kneeboard."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Watch the Tutorial"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    center: true,
                                    wide: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                        src: "https://www.youtube.com/embed/GquZeyn8qJs",
                                        title: "YouTube video player",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                        allowFullScreen: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    marginTop: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                            wide: true,
                                            center: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: "FAQ"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    m: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Q:"
                                                                }),
                                                                " What is Frag Orders?"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "A:"
                                                                }),
                                                                " Frag Orders is a visualization and mission planning tool for DCS World that focuses on planning multiplayer missions."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    m: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Q"
                                                                }),
                                                                ": How does Frag Orders work?"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "A:"
                                                                }),
                                                                " When a mission creator uploads their DCS World .miz file, Frag Orders parses the file and extracts the relevant data for the Frag Order visualization. This data is saved on the Frag Orders server. Once the Frag Order is published, a public URL is created that can be distributed to mission participants."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                    m: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Q:"
                                                                }),
                                                                " As the mission creator, can I control which items appear on the Frag Order map?"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            m: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "A:"
                                                                }),
                                                                ' Yes, the mission creator can choose which data is publish to the public Frag Order. For example, it is possible to hide enemy groups to provide a more dynamic experience for mission participants. Groups marked as "hidden" in the DCS World mission editor are hidden in the Frag Order map by default.'
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "background-container"
                    })
                ]
            })
        ]
    });
}
var $426e52f8305c025b$export$2e2bcd8739ae039 = (0, $0016d2a363b4c314$export$2e2bcd8739ae039)($426e52f8305c025b$var$SignIn)`
  .background-container {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4)),
      url(${(0, (/*@__PURE__*/$parcel$interopDefault($ff3c59efeb22b231$exports)))});
    /* background-repeat: no-repeat; */
    z-index: -1;
  }

  .intro-img,
  iframe {
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }

  @media only screen and (min-width: 600px) {
    iframe {
      height: 480px;
      width: 640px;
    }
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





function $55c366344d5ed0aa$export$2e2bcd8739ae039() {
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { logout: logout } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    $acw62.useEffect(()=>{
        logout().then(()=>{
            history.push((0, $91a9098e14452db2$export$37d3279522fbf5e2).Login);
        });
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {})
    });
}



var $ayMG0 = parcelRequire("ayMG0");






var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $jTnBY = parcelRequire("jTnBY");




var $6g9fa = parcelRequire("6g9fa");

var $d8seH = parcelRequire("d8seH");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $9XEW1.default)("MuiDialog", slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $7u6PA.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;





var $ayMG0 = parcelRequire("ayMG0");
const $4f13784bd714c44e$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $9971e.default)(slots, (0, $c5762e789acf7dcc$export$2177af0aa15c34c2), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $4f13784bd714c44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $f649782d844a38be$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        BackdropProps: (0, $8nd05.default)({
            transitionDuration: transitionDuration,
            as: BackdropComponent
        }, BackdropProps),
        closeAfterTransition: true,
        BackdropComponent: $4f13784bd714c44e$var$DialogBackdrop,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogContainer, {
                className: (0, $1SA7b.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogPaper, (0, $8nd05.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $1SA7b.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68187f174395cd28$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $9XEW1.default)("MuiDialogActions", slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $7u6PA.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $207bc6ab7c60f4b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $9971e.default)(slots, (0, $3a31c1516a2c01e5$export$5e57a444791c63be), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1En50.default)(props, $207bc6ab7c60f4b2$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");

var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $9XEW1.default)("MuiDialogContent", slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $7u6PA.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;



var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $9XEW1.default)("MuiDialogTitle", slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $7u6PA.default)("MuiDialogTitle", [
    "root"
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $4fa8e9c420cdee0a$var$_excluded = [
    "className",
    "dividers"
];
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $9971e.default)(slots, (0, $c877f2cebcabf5cb$export$61b0ee1f05fb344e), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`
    } : {
        [`.${(0, $f2e7257b2514744a$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1En50.default)(props, $4fa8e9c420cdee0a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        dividers: dividers
    });
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $9971e = parcelRequire("9971e");

var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");


var $9XEW1 = parcelRequire("9XEW1");
var $7u6PA = parcelRequire("7u6PA");
function $64180fe1152829a7$export$d9c6dc45f75b0e4f(slot) {
    return (0, $9XEW1.default)("MuiDialogContentText", slot);
}
const $64180fe1152829a7$var$dialogContentTextClasses = (0, $7u6PA.default)("MuiDialogContentText", [
    "root"
]);
var $64180fe1152829a7$export$2e2bcd8739ae039 = $64180fe1152829a7$var$dialogContentTextClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $aad93085434ac13f$var$_excluded = [
    "children"
];
const $aad93085434ac13f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $9971e.default)(slots, (0, $64180fe1152829a7$export$d9c6dc45f75b0e4f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $aad93085434ac13f$var$DialogContentTextRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $d8seH.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $aad93085434ac13f$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const ownerState = (0, $1En50.default)(props, $aad93085434ac13f$var$_excluded);
    const classes = $aad93085434ac13f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aad93085434ac13f$var$DialogContentTextRoot, (0, $8nd05.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState
    }, props, {
        classes: classes
    }));
});
var $aad93085434ac13f$export$2e2bcd8739ae039 = $aad93085434ac13f$var$DialogContentText;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
parcelRequire("c9Z8w");

var $1SA7b = parcelRequire("1SA7b");

var $9971e = parcelRequire("9971e");


var $d8seH = parcelRequire("d8seH");

var $6g9fa = parcelRequire("6g9fa");



var $ayMG0 = parcelRequire("ayMG0");
const $a6ac58aca374c76c$var$_excluded = [
    "className",
    "id"
];
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9971e.default)(slots, (0, $f2e7257b2514744a$export$f5d2ec7e4c47e088), classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $6g9fa.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $1En50.default)(props, $a6ac58aca374c76c$var$_excluded);
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: id = idProp } = $acw62.useContext((0, $68187f174395cd28$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, (0, $8nd05.default)({
        component: "h2",
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: id
    }, other));
});
var $a6ac58aca374c76c$export$2e2bcd8739ae039 = $a6ac58aca374c76c$var$DialogTitle;


parcelRequire("acw62");

function $60dc1b58cd8a3393$var$ConfirmationDialog({ className: className, onClose: onClose, open: open, children: children, message: message, title: title }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4f13784bd714c44e$export$2e2bcd8739ae039), {
            open: open,
            onClose: onClose,
            "aria-labelledby": "alert-dialog-title",
            "aria-describedby": "alert-dialog-description",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6ac58aca374c76c$export$2e2bcd8739ae039), {
                    id: "alert-dialog-title",
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fa8e9c420cdee0a$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aad93085434ac13f$export$2e2bcd8739ae039), {
                        id: "alert-dialog-description",
                        children: message
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $207bc6ab7c60f4b2$export$2e2bcd8739ae039), {
                    children: children
                })
            ]
        })
    });
}
var $60dc1b58cd8a3393$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($60dc1b58cd8a3393$var$ConfirmationDialog).attrs({
    className: $60dc1b58cd8a3393$var$ConfirmationDialog.name
})``;











function $1bebff9c945fc3b3$var$FragOrders({ className: className }) {
    const [page, setPage] = $acw62.useState(0);
    const [deleteDoc, setConfirmOpen] = $acw62.useState(null);
    const [removing, setRemoving] = $acw62.useState(null);
    const { data: data, isLoading: isLoading } = (0, $0a53c1f23450367c$export$eaf8f86643ed73f2)(page);
    const rm = (0, $0a53c1f23450367c$export$c68ca99b64ea1b7c)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const handleDelete = (doc)=>{
        setRemoving(doc.id);
        rm(doc).then(()=>{
            success(`${doc.name} removed successfully`);
            setConfirmOpen(null);
        }).catch((err)=>error(err.message)).finally(()=>{
            setRemoving(null);
        });
    };
    const handleConfirmOpen = (doc)=>{
        setConfirmOpen(doc);
    };
    const handleConfirmClose = ()=>{
        setConfirmOpen(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        className: className,
        title: "My Frag Orders",
        actions: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                component: /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                        innerRef: ref,
                        ...props
                    })),
                to: (0, $91a9098e14452db2$export$37d3279522fbf5e2).NewFragOrder,
                variant: "contained",
                children: "Create Frag Order"
            })
        }),
        loading: isLoading,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                        columns: [
                            {
                                label: "Name",
                                value: (f)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                                        to: `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).FragOrderDetail}/${f.id}/details`,
                                        children: f.name
                                    })
                            },
                            {
                                label: "ID",
                                value: "id"
                            },
                            {
                                label: "Created",
                                value: (f)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                                        time: f.created_at_timestamp
                                    })
                            },
                            {
                                label: "",
                                value: (f)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                        loading: removing === f.id,
                                        variant: "outlined",
                                        color: "error",
                                        onClick: ()=>handleConfirmOpen(f),
                                        children: "Delete"
                                    })
                            }
                        ],
                        rows: data
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        paddingY: 1,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            wide: true,
                            center: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                    disabled: page === 0,
                                    onClick: ()=>setPage(page - 1),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3e21277543f7c25a$exports))), {
                                        fontSize: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                    disabled: data?.length < 10,
                                    onClick: ()=>setPage(page + 1),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cbce43614cfca6bb$exports))), {
                                        fontSize: "small"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $60dc1b58cd8a3393$export$2e2bcd8739ae039), {
                title: "Delete Frag Order",
                message: `Are you sure you want to delete ${deleteDoc?.name}?`,
                onClose: handleConfirmClose,
                open: !!deleteDoc,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        onClick: handleConfirmClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                        loading: !!removing,
                        color: "error",
                        variant: "contained",
                        onClick: ()=>handleDelete(deleteDoc),
                        autoFocus: true,
                        children: [
                            "Delete ",
                            deleteDoc?.name
                        ]
                    })
                ]
            })
        ]
    });
}
var $1bebff9c945fc3b3$export$2e2bcd8739ae039 = (0, $0016d2a363b4c314$export$2e2bcd8739ae039)($1bebff9c945fc3b3$var$FragOrders)`
  margin-bottom: 16px;

  td {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  table {
    table-layout: fixed;
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    .MuiButton-root {
    }

    td:first-of-type {
      max-width: 16px;
    }

    td {
      padding: 8px;
    }

    h2 {
      font-size: 18px;
    }
  }
`;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");











class $d0e26efb9fd101dd$export$e16285ddc2811d4d {
}
class $d0e26efb9fd101dd$export$4724196114ecf0b5 {
}
function $d0e26efb9fd101dd$export$89fde14b759c4862(fo) {
    return `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).FragOrderDetail}/${fo.id}/publish`;
}


function $d160c7a664d63e0f$var$NewFragOrder({ className: className }) {
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const save = (0, $0a53c1f23450367c$export$afe74451a356b821)();
    const { isLoading: isLoading } = (0, $6400a94b66d5ff2d$export$67c0493774f7721f)();
    const [nameVal, setNameVal] = $acw62.useState("");
    const [mizDetails, setMizDetails] = $acw62.useState(null);
    const [discordServer, setDiscordServer] = $acw62.useState("");
    const [saving, setSaving] = $acw62.useState(false);
    const handleFragOrderSubmit = (e)=>{
        e.preventDefault();
        setSaving(true);
        save(nameVal, {
            metadata: mizDetails.data,
            file: mizDetails.file
        }, discordServer).then((fo)=>{
            history.push((0, $d0e26efb9fd101dd$export$89fde14b759c4862)(fo));
        });
    };
    const handleMizClear = (e)=>{
        e.preventDefault();
        setMizDetails(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        loading: isLoading,
        title: "New Frag Order",
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        paddingBottom: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            onChange: (e)=>setNameVal(e.target.value),
                            value: nameVal,
                            helperText: "The name of the Frag Order",
                            required: true,
                            id: "outlined-basic",
                            label: "Name",
                            variant: "outlined"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        paddingBottom: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30c876a2e6222a65$export$2e2bcd8739ae039), {
                            value: discordServer,
                            onChange: setDiscordServer
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        paddingBottom: 2,
                        children: mizDetails ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $537ff0a6203c2271$export$2e2bcd8739ae039), {
                            miz: {
                                metadata: mizDetails.data,
                                file: mizDetails.file
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9563a3fbb18fea6b$export$2e2bcd8739ae039), {
                            onDrop: (file, data)=>{
                                if (!nameVal) setNameVal(file.name);
                                setMizDetails({
                                    file: file,
                                    data: data
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                onClick: handleFragOrderSubmit,
                                disabled: !mizDetails,
                                variant: "contained",
                                type: "submit",
                                loading: saving,
                                children: "Submit"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                onClick: handleMizClear,
                                disabled: !mizDetails,
                                variant: "outlined",
                                type: "button",
                                children: "Clear Mission File"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $d160c7a664d63e0f$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($d160c7a664d63e0f$var$NewFragOrder).attrs({
    className: $d160c7a664d63e0f$var$NewFragOrder.name
})`
  .MuiInputBase-input {
    width: 320px;
  }

  .MuiButton-root {
    margin-right: 8px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");










var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$exports = {};
"use strict";

Object.defineProperty($14b4fcb0e549e7b0$exports, "__esModule", {
    value: true
});
$14b4fcb0e549e7b0$exports.default = void 0;

var $14b4fcb0e549e7b0$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$var$_default = (0, $14b4fcb0e549e7b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
$14b4fcb0e549e7b0$exports.default = $14b4fcb0e549e7b0$var$_default;


var $bf65d0cdcb730ab5$exports = {};
"use strict";

Object.defineProperty($bf65d0cdcb730ab5$exports, "__esModule", {
    value: true
});
$bf65d0cdcb730ab5$exports.default = void 0;

var $bf65d0cdcb730ab5$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $bf65d0cdcb730ab5$var$_default = (0, $bf65d0cdcb730ab5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
}), "Gesture");
$bf65d0cdcb730ab5$exports.default = $bf65d0cdcb730ab5$var$_default;


var $7c3495d857096b79$exports = {};
"use strict";

Object.defineProperty($7c3495d857096b79$exports, "__esModule", {
    value: true
});
$7c3495d857096b79$exports.default = void 0;

var $7c3495d857096b79$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7c3495d857096b79$var$_default = (0, $7c3495d857096b79$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), "LocationOn");
$7c3495d857096b79$exports.default = $7c3495d857096b79$var$_default;


var $675f2b16dc8ab273$exports = {};
"use strict";

Object.defineProperty($675f2b16dc8ab273$exports, "__esModule", {
    value: true
});
$675f2b16dc8ab273$exports.default = void 0;

var $675f2b16dc8ab273$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $675f2b16dc8ab273$var$_default = (0, $675f2b16dc8ab273$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m17.66 17.66-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
}), "SquareFoot");
$675f2b16dc8ab273$exports.default = $675f2b16dc8ab273$var$_default;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/*!
 * hotkeys-js v3.8.7
 * A simple micro-library for defining and dispatching keyboard shortcuts. It has no dependencies.
 * 
 * Copyright (c) 2021 kenny wong <wowohoo@qq.com>
 * http://jaywcjlove.github.io/hotkeys
 * 
 * Licensed under the MIT license.
 */ var $d949ebf04c50c323$var$isff = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : false; // 绑定事件
function $d949ebf04c50c323$var$addEvent(object, event, method) {
    if (object.addEventListener) object.addEventListener(event, method, false);
    else if (object.attachEvent) object.attachEvent("on".concat(event), function() {
        method(window.event);
    });
} // 修饰键转换成对应的键码
function $d949ebf04c50c323$var$getMods(modifier, key) {
    var mods = key.slice(0, key.length - 1);
    for(var i = 0; i < mods.length; i++)mods[i] = modifier[mods[i].toLowerCase()];
    return mods;
} // 处理传的key字符串转换成数组
function $d949ebf04c50c323$var$getKeys(key) {
    if (typeof key !== "string") key = "";
    key = key.replace(/\s/g, ""); // 匹配任何空白字符,包括空格、制表符、换页符等等
    var keys = key.split(","); // 同时设置多个快捷键，以','分割
    var index = keys.lastIndexOf(""); // 快捷键可能包含','，需特殊处理
    for(; index >= 0;){
        keys[index - 1] += ",";
        keys.splice(index, 1);
        index = keys.lastIndexOf("");
    }
    return keys;
} // 比较修饰键的数组
function $d949ebf04c50c323$var$compareArray(a1, a2) {
    var arr1 = a1.length >= a2.length ? a1 : a2;
    var arr2 = a1.length >= a2.length ? a2 : a1;
    var isIndex = true;
    for(var i = 0; i < arr1.length; i++)if (arr2.indexOf(arr1[i]) === -1) isIndex = false;
    return isIndex;
}
var $d949ebf04c50c323$var$_keyMap = {
    backspace: 8,
    tab: 9,
    clear: 12,
    enter: 13,
    return: 13,
    esc: 27,
    escape: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    del: 46,
    delete: 46,
    ins: 45,
    insert: 45,
    home: 36,
    end: 35,
    pageup: 33,
    pagedown: 34,
    capslock: 20,
    num_0: 96,
    num_1: 97,
    num_2: 98,
    num_3: 99,
    num_4: 100,
    num_5: 101,
    num_6: 102,
    num_7: 103,
    num_8: 104,
    num_9: 105,
    num_multiply: 106,
    num_add: 107,
    num_enter: 108,
    num_subtract: 109,
    num_decimal: 110,
    num_divide: 111,
    "\u21EA": 20,
    ",": 188,
    ".": 190,
    "/": 191,
    "`": 192,
    "-": $d949ebf04c50c323$var$isff ? 173 : 189,
    "=": $d949ebf04c50c323$var$isff ? 61 : 187,
    ";": $d949ebf04c50c323$var$isff ? 59 : 186,
    "'": 222,
    "[": 219,
    "]": 221,
    "\\": 220
}; // Modifier Keys
var $d949ebf04c50c323$var$_modifier = {
    // shiftKey
    "\u21E7": 16,
    shift: 16,
    // altKey
    "\u2325": 18,
    alt: 18,
    option: 18,
    // ctrlKey
    "\u2303": 17,
    ctrl: 17,
    control: 17,
    // metaKey
    "\u2318": 91,
    cmd: 91,
    command: 91
};
var $d949ebf04c50c323$var$modifierMap = {
    16: "shiftKey",
    18: "altKey",
    17: "ctrlKey",
    91: "metaKey",
    shiftKey: 16,
    ctrlKey: 17,
    altKey: 18,
    metaKey: 91
};
var $d949ebf04c50c323$var$_mods = {
    16: false,
    18: false,
    17: false,
    91: false
};
var $d949ebf04c50c323$var$_handlers = {}; // F1~F12 special key
for(var $d949ebf04c50c323$var$k = 1; $d949ebf04c50c323$var$k < 20; $d949ebf04c50c323$var$k++)$d949ebf04c50c323$var$_keyMap["f".concat($d949ebf04c50c323$var$k)] = 111 + $d949ebf04c50c323$var$k;
var $d949ebf04c50c323$var$_downKeys = []; // 记录摁下的绑定键
var $d949ebf04c50c323$var$_scope = "all"; // 默认热键范围
var $d949ebf04c50c323$var$elementHasBindEvent = []; // 已绑定事件的节点记录
// 返回键码
var $d949ebf04c50c323$var$code = function code(x) {
    return $d949ebf04c50c323$var$_keyMap[x.toLowerCase()] || $d949ebf04c50c323$var$_modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
}; // 设置获取当前范围（默认为'所有'）
function $d949ebf04c50c323$var$setScope(scope) {
    $d949ebf04c50c323$var$_scope = scope || "all";
} // 获取当前范围
function $d949ebf04c50c323$var$getScope() {
    return $d949ebf04c50c323$var$_scope || "all";
} // 获取摁下绑定键的键值
function $d949ebf04c50c323$var$getPressedKeyCodes() {
    return $d949ebf04c50c323$var$_downKeys.slice(0);
} // 表单控件控件判断 返回 Boolean
// hotkey is effective only when filter return true
function $d949ebf04c50c323$var$filter(event) {
    var target = event.target || event.srcElement;
    var tagName = target.tagName;
    var flag = true; // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>
    if (target.isContentEditable || (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT") && !target.readOnly) flag = false;
    return flag;
} // 判断摁下的键是否为某个键，返回true或者false
function $d949ebf04c50c323$var$isPressed(keyCode) {
    if (typeof keyCode === "string") keyCode = $d949ebf04c50c323$var$code(keyCode); // 转换成键码
    return $d949ebf04c50c323$var$_downKeys.indexOf(keyCode) !== -1;
} // 循环删除handlers中的所有 scope(范围)
function $d949ebf04c50c323$var$deleteScope(scope, newScope) {
    var handlers;
    var i; // 没有指定scope，获取scope
    if (!scope) scope = $d949ebf04c50c323$var$getScope();
    for(var key in $d949ebf04c50c323$var$_handlers)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_handlers, key)) {
        handlers = $d949ebf04c50c323$var$_handlers[key];
        for(i = 0; i < handlers.length;)if (handlers[i].scope === scope) handlers.splice(i, 1);
        else i++;
    }
     // 如果scope被删除，将scope重置为all
    if ($d949ebf04c50c323$var$getScope() === scope) $d949ebf04c50c323$var$setScope(newScope || "all");
} // 清除修饰键
function $d949ebf04c50c323$var$clearModifier(event) {
    var key = event.keyCode || event.which || event.charCode;
    var i = $d949ebf04c50c323$var$_downKeys.indexOf(key); // 从列表中清除按压过的键
    if (i >= 0) $d949ebf04c50c323$var$_downKeys.splice(i, 1);
     // 特殊处理 cmmand 键，在 cmmand 组合快捷键 keyup 只执行一次的问题
    if (event.key && event.key.toLowerCase() === "meta") $d949ebf04c50c323$var$_downKeys.splice(0, $d949ebf04c50c323$var$_downKeys.length);
     // 修饰键 shiftKey altKey ctrlKey (command||metaKey) 清除
    if (key === 93 || key === 224) key = 91;
    if (key in $d949ebf04c50c323$var$_mods) {
        $d949ebf04c50c323$var$_mods[key] = false; // 将修饰键重置为false
        for(var k in $d949ebf04c50c323$var$_modifier)if ($d949ebf04c50c323$var$_modifier[k] === key) $d949ebf04c50c323$var$hotkeys[k] = false;
    }
}
function $d949ebf04c50c323$var$unbind(keysInfo) {
    // unbind(), unbind all keys
    if (!keysInfo) Object.keys($d949ebf04c50c323$var$_handlers).forEach(function(key) {
        return delete $d949ebf04c50c323$var$_handlers[key];
    });
    else if (Array.isArray(keysInfo)) // support like : unbind([{key: 'ctrl+a', scope: 's1'}, {key: 'ctrl-a', scope: 's2', splitKey: '-'}])
    keysInfo.forEach(function(info) {
        if (info.key) $d949ebf04c50c323$var$eachUnbind(info);
    });
    else if (typeof keysInfo === "object") // support like unbind({key: 'ctrl+a, ctrl+b', scope:'abc'})
    {
        if (keysInfo.key) $d949ebf04c50c323$var$eachUnbind(keysInfo);
    } else if (typeof keysInfo === "string") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        // support old method
        // eslint-disable-line
        var scope = args[0], method = args[1];
        if (typeof scope === "function") {
            method = scope;
            scope = "";
        }
        $d949ebf04c50c323$var$eachUnbind({
            key: keysInfo,
            scope: scope,
            method: method,
            splitKey: "+"
        });
    }
} // 解除绑定某个范围的快捷键
var $d949ebf04c50c323$var$eachUnbind = function eachUnbind(_ref) {
    var key = _ref.key, scope = _ref.scope, method = _ref.method, _ref$splitKey = _ref.splitKey, splitKey = _ref$splitKey === void 0 ? "+" : _ref$splitKey;
    var multipleKeys = $d949ebf04c50c323$var$getKeys(key);
    multipleKeys.forEach(function(originKey) {
        var unbindKeys = originKey.split(splitKey);
        var len = unbindKeys.length;
        var lastKey = unbindKeys[len - 1];
        var keyCode = lastKey === "*" ? "*" : $d949ebf04c50c323$var$code(lastKey);
        if (!$d949ebf04c50c323$var$_handlers[keyCode]) return; // 判断是否传入范围，没有就获取范围
        if (!scope) scope = $d949ebf04c50c323$var$getScope();
        var mods = len > 1 ? $d949ebf04c50c323$var$getMods($d949ebf04c50c323$var$_modifier, unbindKeys) : [];
        $d949ebf04c50c323$var$_handlers[keyCode] = $d949ebf04c50c323$var$_handlers[keyCode].map(function(record) {
            // 通过函数判断，是否解除绑定，函数相等直接返回
            var isMatchingMethod = method ? record.method === method : true;
            if (isMatchingMethod && record.scope === scope && $d949ebf04c50c323$var$compareArray(record.mods, mods)) return {};
            return record;
        });
    });
}; // 对监听对应快捷键的回调函数进行处理
function $d949ebf04c50c323$var$eventHandler(event, handler, scope) {
    var modifiersMatch; // 看它是否在当前范围
    if (handler.scope === scope || handler.scope === "all") {
        // 检查是否匹配修饰符（如果有返回true）
        modifiersMatch = handler.mods.length > 0;
        for(var y in $d949ebf04c50c323$var$_mods){
            if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_mods, y)) {
                if (!$d949ebf04c50c323$var$_mods[y] && handler.mods.indexOf(+y) > -1 || $d949ebf04c50c323$var$_mods[y] && handler.mods.indexOf(+y) === -1) modifiersMatch = false;
            }
        } // 调用处理程序，如果是修饰键不做处理
        if (handler.mods.length === 0 && !$d949ebf04c50c323$var$_mods[16] && !$d949ebf04c50c323$var$_mods[18] && !$d949ebf04c50c323$var$_mods[17] && !$d949ebf04c50c323$var$_mods[91] || modifiersMatch || handler.shortcut === "*") {
            if (handler.method(event, handler) === false) {
                if (event.preventDefault) event.preventDefault();
                else event.returnValue = false;
                if (event.stopPropagation) event.stopPropagation();
                if (event.cancelBubble) event.cancelBubble = true;
            }
        }
    }
} // 处理keydown事件
function $d949ebf04c50c323$var$dispatch(event) {
    var asterisk = $d949ebf04c50c323$var$_handlers["*"];
    var key = event.keyCode || event.which || event.charCode; // 表单控件过滤 默认表单控件不触发快捷键
    if (!$d949ebf04c50c323$var$hotkeys.filter.call(this, event)) return; // Gecko(Firefox)的command键值224，在Webkit(Chrome)中保持一致
    // Webkit左右 command 键值不一样
    if (key === 93 || key === 224) key = 91;
    /**
   * Collect bound keys
   * If an Input Method Editor is processing key input and the event is keydown, return 229.
   * https://stackoverflow.com/questions/25043934/is-it-ok-to-ignore-keydown-events-with-keycode-229
   * http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
   */ if ($d949ebf04c50c323$var$_downKeys.indexOf(key) === -1 && key !== 229) $d949ebf04c50c323$var$_downKeys.push(key);
    /**
   * Jest test cases are required.
   * ===============================
   */ [
        "ctrlKey",
        "altKey",
        "shiftKey",
        "metaKey"
    ].forEach(function(keyName) {
        var keyNum = $d949ebf04c50c323$var$modifierMap[keyName];
        if (event[keyName] && $d949ebf04c50c323$var$_downKeys.indexOf(keyNum) === -1) $d949ebf04c50c323$var$_downKeys.push(keyNum);
        else if (!event[keyName] && $d949ebf04c50c323$var$_downKeys.indexOf(keyNum) > -1) $d949ebf04c50c323$var$_downKeys.splice($d949ebf04c50c323$var$_downKeys.indexOf(keyNum), 1);
        else if (keyName === "metaKey" && event[keyName] && $d949ebf04c50c323$var$_downKeys.length === 3) /**
       * Fix if Command is pressed:
       * ===============================
       */ {
            if (!(event.ctrlKey || event.shiftKey || event.altKey)) $d949ebf04c50c323$var$_downKeys = $d949ebf04c50c323$var$_downKeys.slice($d949ebf04c50c323$var$_downKeys.indexOf(keyNum));
        }
    });
    /**
   * -------------------------------
   */ if (key in $d949ebf04c50c323$var$_mods) {
        $d949ebf04c50c323$var$_mods[key] = true; // 将特殊字符的key注册到 hotkeys 上
        for(var k in $d949ebf04c50c323$var$_modifier)if ($d949ebf04c50c323$var$_modifier[k] === key) $d949ebf04c50c323$var$hotkeys[k] = true;
        if (!asterisk) return;
    } // 将 modifierMap 里面的修饰键绑定到 event 中
    for(var e in $d949ebf04c50c323$var$_mods)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_mods, e)) $d949ebf04c50c323$var$_mods[e] = event[$d949ebf04c50c323$var$modifierMap[e]];
    /**
   * https://github.com/jaywcjlove/hotkeys/pull/129
   * This solves the issue in Firefox on Windows where hotkeys corresponding to special characters would not trigger.
   * An example of this is ctrl+alt+m on a Swedish keyboard which is used to type μ.
   * Browser support: https://caniuse.com/#feat=keyboardevent-getmodifierstate
   */ if (event.getModifierState && !(event.altKey && !event.ctrlKey) && event.getModifierState("AltGraph")) {
        if ($d949ebf04c50c323$var$_downKeys.indexOf(17) === -1) $d949ebf04c50c323$var$_downKeys.push(17);
        if ($d949ebf04c50c323$var$_downKeys.indexOf(18) === -1) $d949ebf04c50c323$var$_downKeys.push(18);
        $d949ebf04c50c323$var$_mods[17] = true;
        $d949ebf04c50c323$var$_mods[18] = true;
    } // 获取范围 默认为 `all`
    var scope = $d949ebf04c50c323$var$getScope(); // 对任何快捷键都需要做的处理
    if (asterisk) {
        for(var i = 0; i < asterisk.length; i++)if (asterisk[i].scope === scope && (event.type === "keydown" && asterisk[i].keydown || event.type === "keyup" && asterisk[i].keyup)) $d949ebf04c50c323$var$eventHandler(event, asterisk[i], scope);
    } // key 不在 _handlers 中返回
    if (!(key in $d949ebf04c50c323$var$_handlers)) return;
    for(var _i = 0; _i < $d949ebf04c50c323$var$_handlers[key].length; _i++){
        if (event.type === "keydown" && $d949ebf04c50c323$var$_handlers[key][_i].keydown || event.type === "keyup" && $d949ebf04c50c323$var$_handlers[key][_i].keyup) {
            if ($d949ebf04c50c323$var$_handlers[key][_i].key) {
                var record = $d949ebf04c50c323$var$_handlers[key][_i];
                var splitKey = record.splitKey;
                var keyShortcut = record.key.split(splitKey);
                var _downKeysCurrent = []; // 记录当前按键键值
                for(var a = 0; a < keyShortcut.length; a++)_downKeysCurrent.push($d949ebf04c50c323$var$code(keyShortcut[a]));
                if (_downKeysCurrent.sort().join("") === $d949ebf04c50c323$var$_downKeys.sort().join("")) // 找到处理内容
                $d949ebf04c50c323$var$eventHandler(event, record, scope);
            }
        }
    }
} // 判断 element 是否已经绑定事件
function $d949ebf04c50c323$var$isElementBind(element) {
    return $d949ebf04c50c323$var$elementHasBindEvent.indexOf(element) > -1;
}
function $d949ebf04c50c323$var$hotkeys(key, option, method) {
    $d949ebf04c50c323$var$_downKeys = [];
    var keys = $d949ebf04c50c323$var$getKeys(key); // 需要处理的快捷键列表
    var mods = [];
    var scope = "all"; // scope默认为all，所有范围都有效
    var element = document; // 快捷键事件绑定节点
    var i = 0;
    var keyup = false;
    var keydown = true;
    var splitKey = "+"; // 对为设定范围的判断
    if (method === undefined && typeof option === "function") method = option;
    if (Object.prototype.toString.call(option) === "[object Object]") {
        if (option.scope) scope = option.scope; // eslint-disable-line
        if (option.element) element = option.element; // eslint-disable-line
        if (option.keyup) keyup = option.keyup; // eslint-disable-line
        if (option.keydown !== undefined) keydown = option.keydown; // eslint-disable-line
        if (typeof option.splitKey === "string") splitKey = option.splitKey; // eslint-disable-line
    }
    if (typeof option === "string") scope = option; // 对于每个快捷键进行处理
    for(; i < keys.length; i++){
        key = keys[i].split(splitKey); // 按键列表
        mods = []; // 如果是组合快捷键取得组合快捷键
        if (key.length > 1) mods = $d949ebf04c50c323$var$getMods($d949ebf04c50c323$var$_modifier, key); // 将非修饰键转化为键码
        key = key[key.length - 1];
        key = key === "*" ? "*" : $d949ebf04c50c323$var$code(key); // *表示匹配所有快捷键
        // 判断key是否在_handlers中，不在就赋一个空数组
        if (!(key in $d949ebf04c50c323$var$_handlers)) $d949ebf04c50c323$var$_handlers[key] = [];
        $d949ebf04c50c323$var$_handlers[key].push({
            keyup: keyup,
            keydown: keydown,
            scope: scope,
            mods: mods,
            shortcut: keys[i],
            method: method,
            key: keys[i],
            splitKey: splitKey
        });
    } // 在全局document上设置快捷键
    if (typeof element !== "undefined" && !$d949ebf04c50c323$var$isElementBind(element) && window) {
        $d949ebf04c50c323$var$elementHasBindEvent.push(element);
        $d949ebf04c50c323$var$addEvent(element, "keydown", function(e) {
            $d949ebf04c50c323$var$dispatch(e);
        });
        $d949ebf04c50c323$var$addEvent(window, "focus", function() {
            $d949ebf04c50c323$var$_downKeys = [];
        });
        $d949ebf04c50c323$var$addEvent(element, "keyup", function(e) {
            $d949ebf04c50c323$var$dispatch(e);
            $d949ebf04c50c323$var$clearModifier(e);
        });
    }
}
var $d949ebf04c50c323$var$_api = {
    setScope: $d949ebf04c50c323$var$setScope,
    getScope: $d949ebf04c50c323$var$getScope,
    deleteScope: $d949ebf04c50c323$var$deleteScope,
    getPressedKeyCodes: $d949ebf04c50c323$var$getPressedKeyCodes,
    isPressed: $d949ebf04c50c323$var$isPressed,
    filter: $d949ebf04c50c323$var$filter,
    unbind: $d949ebf04c50c323$var$unbind
};
for(var $d949ebf04c50c323$var$a in $d949ebf04c50c323$var$_api)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_api, $d949ebf04c50c323$var$a)) $d949ebf04c50c323$var$hotkeys[$d949ebf04c50c323$var$a] = $d949ebf04c50c323$var$_api[$d949ebf04c50c323$var$a];
if (typeof window !== "undefined") {
    var $d949ebf04c50c323$var$_hotkeys = window.hotkeys;
    $d949ebf04c50c323$var$hotkeys.noConflict = function(deep) {
        if (deep && window.hotkeys === $d949ebf04c50c323$var$hotkeys) window.hotkeys = $d949ebf04c50c323$var$_hotkeys;
        return $d949ebf04c50c323$var$hotkeys;
    };
    window.hotkeys = $d949ebf04c50c323$var$hotkeys;
}
var $d949ebf04c50c323$export$2e2bcd8739ae039 = $d949ebf04c50c323$var$hotkeys;



var $acw62 = parcelRequire("acw62");
/**
 * @deprecated Use isHotkeyPressed instead. Will be removed version 4.
 */ function $643289de0f480f5f$export$8117d1c774d4748d() {
    return (0, $d949ebf04c50c323$export$2e2bcd8739ae039).isPressed;
}
(0, $d949ebf04c50c323$export$2e2bcd8739ae039).filter = function() {
    return true;
};
var $643289de0f480f5f$var$tagFilter = function tagFilter(_ref, enableOnTags) {
    var target = _ref.target;
    var targetTagName = target && target.tagName;
    return Boolean(targetTagName && enableOnTags && enableOnTags.includes(targetTagName));
};
var $643289de0f480f5f$var$isKeyboardEventTriggeredByInput = function isKeyboardEventTriggeredByInput(ev) {
    return $643289de0f480f5f$var$tagFilter(ev, [
        "INPUT",
        "TEXTAREA",
        "SELECT"
    ]);
};
function $643289de0f480f5f$export$1b0c17123b4f3646(keys, callback, options, deps) {
    if (options instanceof Array) {
        deps = options;
        options = undefined;
    }
    var _ref2 = options || {}, enableOnTags = _ref2.enableOnTags, filter = _ref2.filter, keyup = _ref2.keyup, keydown = _ref2.keydown, _ref2$filterPreventDe = _ref2.filterPreventDefault, filterPreventDefault = _ref2$filterPreventDe === void 0 ? true : _ref2$filterPreventDe, _ref2$enabled = _ref2.enabled, enabled = _ref2$enabled === void 0 ? true : _ref2$enabled, _ref2$enableOnContent = _ref2.enableOnContentEditable, enableOnContentEditable = _ref2$enableOnContent === void 0 ? false : _ref2$enableOnContent;
    var ref = (0, $acw62.useRef)(null); // The return value of this callback determines if the browsers default behavior is prevented.
    var memoisedCallback = (0, $acw62.useCallback)(function(keyboardEvent, hotkeysEvent) {
        var _keyboardEvent$target;
        if (filter && !filter(keyboardEvent)) return !filterPreventDefault;
         // Check whether the hotkeys was triggered inside an input and that input is enabled or if it was triggered by a content editable tag and it is enabled.
        if ($643289de0f480f5f$var$isKeyboardEventTriggeredByInput(keyboardEvent) && !$643289de0f480f5f$var$tagFilter(keyboardEvent, enableOnTags) || (_keyboardEvent$target = keyboardEvent.target) != null && _keyboardEvent$target.isContentEditable && !enableOnContentEditable) return true;
        if (ref.current === null || document.activeElement === ref.current) {
            callback(keyboardEvent, hotkeysEvent);
            return true;
        }
        return false;
    }, deps ? [
        ref,
        enableOnTags,
        filter
    ].concat(deps) : [
        ref,
        enableOnTags,
        filter
    ]);
    (0, $acw62.useEffect)(function() {
        if (!enabled) {
            (0, $d949ebf04c50c323$export$2e2bcd8739ae039).unbind(keys, memoisedCallback);
            return;
        } // In this case keydown is likely undefined, so we set it to false, since hotkeys needs the `keydown` key to have a value.
        if (keyup && keydown !== true) options.keydown = false;
        (0, $d949ebf04c50c323$export$2e2bcd8739ae039)(keys, options || {}, memoisedCallback);
        return function() {
            return (0, $d949ebf04c50c323$export$2e2bcd8739ae039).unbind(keys, memoisedCallback);
        };
    }, [
        memoisedCallback,
        keys,
        enabled
    ]);
    return ref;
}
var $643289de0f480f5f$export$eae3d25ef8fab782 = (0, $d949ebf04c50c323$export$2e2bcd8739ae039).isPressed;





/**
 * @module ol/interaction/Draw
 */ 
























/**
 * @typedef {Object} Options
 * @property {import("../geom/Geometry.js").Type} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike} [style]
 * Style for sketch features. The draw interaction can have up to three sketch features, depending on the mode.
 * It will always contain a feature with a `Point` geometry that corresponds to the current cursor position.
 * If the mode is `LineString` or `Polygon`, and there is at least one drawn point, it will also contain a feature with
 * a `LineString` geometry that corresponds to the line between the already drawn points and the current cursor position.
 * If the mode is `Polygon`, and there is at least one drawn point, it will also contain a feature with a `Polygon`
 * geometry that corresponds to the polygon between the already drawn points and the current cursor position
 * (note that this polygon has only two points if only one point is drawn).
 * If the mode is `Circle`, and there is one point drawn, it will also contain a feature with a `Circle` geometry whose
 * center is the drawn point and the radius is determined by the distance between the drawn point and the cursor.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean|import("../events/condition.js").Condition} [trace=false] Trace a portion of another geometry.
 * Ignored when in freehand mode.
 * @property {VectorSource} [traceSource] Source for features to trace.  If tracing is active and a `traceSource` is
 * not provided, the interaction's `source` will be used.  Tracing requires that the interaction is configured with
 * either a `traceSource` or a `source`.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {import("../geom/Geometry.js").GeometryLayout} [geometryLayout='XY'] Layout of the
 * feature geometries created by the draw interaction.
 */ /**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */ /**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */ /**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */ /**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */ /**
 * @typedef {Object} TraceState
 * @property {boolean} active Tracing active.
 * @property {import("../pixel.js").Pixel} [startPx] The initially clicked pixel location.
 * @property {Array<TraceTarget>} [targets] Targets available for tracing.
 * @property {number} [targetIndex] The index of the currently traced target.  A value of -1 indicates
 * that no trace target is active.
 */ /**
 * @typedef {Object} TraceTarget
 * @property {Array<import("../coordinate.js").Coordinate>} coordinates Target coordinates.
 * @property {boolean} ring The target coordinates are a linear ring.
 * @property {number} startIndex The index of first traced coordinate.  A fractional index represents an
 * edge intersection.  Index values for rings will wrap (may be negative or larger than coordinates length).
 * @property {number} endIndex The index of last traced coordinate.  Details from startIndex also apply here.
 */ /**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */ /**
 * @typedef {'Point' | 'LineString' | 'Polygon' | 'Circle'} Mode
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 */ /**
 * @enum {string}
 */ const $55fa2487efb2d4e1$var$DrawEventType = {
    /**
   * Triggered upon feature draw start
   * @event DrawEvent#drawstart
   * @api
   */ DRAWSTART: "drawstart",
    /**
   * Triggered upon feature draw end
   * @event DrawEvent#drawend
   * @api
   */ DRAWEND: "drawend",
    /**
   * Triggered upon feature draw abortion
   * @event DrawEvent#drawabort
   * @api
   */ DRAWABORT: "drawabort"
};
class $55fa2487efb2d4e1$export$85a4910380d251a7 extends (0, $aeedce20e9577100$export$2e2bcd8739ae039) {
    /**
   * @param {DrawEventType} type Type.
   * @param {Feature} feature The feature drawn.
   */ constructor(type, feature){
        super(type);
        /**
     * The feature being drawn.
     * @type {Feature}
     * @api
     */ this.feature = feature;
    }
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {Array<Feature>} features The candidate features.
 * @return {Array<TraceTarget>} The trace targets.
 */ function $55fa2487efb2d4e1$var$getTraceTargets(coordinate, features) {
    /**
   * @type {Array<TraceTarget>}
   */ const targets = [];
    for(let i = 0; i < features.length; ++i){
        const feature = features[i];
        const geometry = feature.getGeometry();
        $55fa2487efb2d4e1$var$appendGeometryTraceTargets(coordinate, geometry, targets);
    }
    return targets;
}
/**
 * @param {import("../coordinate.js").Coordinate} a One coordinate.
 * @param {import("../coordinate.js").Coordinate} b Another coordinate.
 * @return {number} The squared distance between the two coordinates.
 */ function $55fa2487efb2d4e1$var$getSquaredDistance(a, b) {
    return (0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(a[0], a[1], b[0], b[1]);
}
/**
 * @param {LineCoordType} coordinates The ring coordinates.
 * @param {number} index The index.  May be wrapped.
 * @return {import("../coordinate.js").Coordinate} The coordinate.
 */ function $55fa2487efb2d4e1$var$getCoordinate(coordinates, index) {
    const count = coordinates.length;
    if (index < 0) return coordinates[index + count];
    if (index >= count) return coordinates[index - count];
    return coordinates[index];
}
/**
 * Get the cumulative squared distance along a ring path.  The end index index may be "wrapped" and it may
 * be less than the start index to indicate the direction of travel.  The start and end index may have
 * a fractional part to indicate a point between two coordinates.
 * @param {LineCoordType} coordinates Ring coordinates.
 * @param {number} startIndex The start index.
 * @param {number} endIndex The end index.
 * @return {number} The cumulative squared distance along the ring path.
 */ function $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex) {
    let lowIndex, highIndex;
    if (startIndex < endIndex) {
        lowIndex = startIndex;
        highIndex = endIndex;
    } else {
        lowIndex = endIndex;
        highIndex = startIndex;
    }
    const lowWholeIndex = Math.ceil(lowIndex);
    const highWholeIndex = Math.floor(highIndex);
    if (lowWholeIndex > highWholeIndex) {
        // both start and end are on the same segment
        const start = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, highIndex);
        return $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    let sd = 0;
    if (lowIndex < lowWholeIndex) {
        const start = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $55fa2487efb2d4e1$var$getCoordinate(coordinates, lowWholeIndex);
        sd += $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    if (highWholeIndex < highIndex) {
        const start = $55fa2487efb2d4e1$var$getCoordinate(coordinates, highWholeIndex);
        const end = $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, highIndex);
        sd += $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    for(let i = lowWholeIndex; i < highWholeIndex - 1; ++i){
        const start = $55fa2487efb2d4e1$var$getCoordinate(coordinates, i);
        const end = $55fa2487efb2d4e1$var$getCoordinate(coordinates, i + 1);
        sd += $55fa2487efb2d4e1$var$getSquaredDistance(start, end);
    }
    return sd;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {import("../geom/Geometry.js").default} geometry The candidate geometry.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $55fa2487efb2d4e1$var$appendGeometryTraceTargets(coordinate, geometry, targets) {
    if (geometry instanceof (0, $292e4002746c8223$export$2e2bcd8739ae039)) {
        $55fa2487efb2d4e1$var$appendTraceTarget(coordinate, geometry.getCoordinates(), false, targets);
        return;
    }
    if (geometry instanceof (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates[i], false, targets);
        return;
    }
    if (geometry instanceof (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates[i], true, targets);
        return;
    }
    if (geometry instanceof (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)) {
        const polys = geometry.getCoordinates();
        for(let i = 0, ii = polys.length; i < ii; ++i){
            const coordinates = polys[i];
            for(let j = 0, jj = coordinates.length; j < jj; ++j)$55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates[j], true, targets);
        }
        return;
    }
    if (geometry instanceof (0, $0e4f3959219eede5$export$2e2bcd8739ae039)) {
        const geometries = geometry.getGeometries();
        for(let i = 0; i < geometries.length; ++i)$55fa2487efb2d4e1$var$appendGeometryTraceTargets(coordinate, geometries[i], targets);
        return;
    }
// other types cannot be traced
}
/**
 * @typedef {Object} TraceTargetUpdateInfo
 * @property {number} index The new target index.
 * @property {number} endIndex The new segment end index.
 */ /**
 * @type {TraceTargetUpdateInfo}
 */ const $55fa2487efb2d4e1$var$sharedUpdateInfo = {
    index: -1,
    endIndex: NaN
};
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {TraceState} traceState The trace state.
 * @param {import("../Map.js").default} map The map.
 * @param {number} snapTolerance The snap tolerance.
 * @return {TraceTargetUpdateInfo} Information about the new trace target.  The returned
 * object is reused between calls and must not be modified by the caller.
 */ function $55fa2487efb2d4e1$var$getTraceTargetUpdate(coordinate, traceState, map, snapTolerance) {
    const x = coordinate[0];
    const y = coordinate[1];
    let closestTargetDistance = Infinity;
    let newTargetIndex = -1;
    let newEndIndex = NaN;
    for(let targetIndex = 0; targetIndex < traceState.targets.length; ++targetIndex){
        const target = traceState.targets[targetIndex];
        const coordinates = target.coordinates;
        let minSegmentDistance = Infinity;
        let endIndex;
        for(let coordinateIndex = 0; coordinateIndex < coordinates.length - 1; ++coordinateIndex){
            const start = coordinates[coordinateIndex];
            const end = coordinates[coordinateIndex + 1];
            const rel = $55fa2487efb2d4e1$var$getPointSegmentRelationship(x, y, start, end);
            if (rel.squaredDistance < minSegmentDistance) {
                minSegmentDistance = rel.squaredDistance;
                endIndex = coordinateIndex + rel.along;
            }
        }
        if (minSegmentDistance < closestTargetDistance) {
            closestTargetDistance = minSegmentDistance;
            if (target.ring && traceState.targetIndex === targetIndex) {
                // same target, maintain the same trace direction
                if (target.endIndex > target.startIndex) // forward trace
                {
                    if (endIndex < target.startIndex) endIndex += coordinates.length;
                } else if (target.endIndex < target.startIndex) // reverse trace
                {
                    if (endIndex > target.startIndex) endIndex -= coordinates.length;
                }
            }
            newEndIndex = endIndex;
            newTargetIndex = targetIndex;
        }
    }
    const newTarget = traceState.targets[newTargetIndex];
    let considerBothDirections = newTarget.ring;
    if (traceState.targetIndex === newTargetIndex && considerBothDirections) {
        // only consider switching trace direction if close to the start
        const newCoordinate = $55fa2487efb2d4e1$var$interpolateCoordinate(newTarget.coordinates, newEndIndex);
        const pixel = map.getPixelFromCoordinate(newCoordinate);
        if ((0, $1bd0a226f9a16141$export$9f17032d917177de)(pixel, traceState.startPx) > snapTolerance) considerBothDirections = false;
    }
    if (considerBothDirections) {
        const coordinates = newTarget.coordinates;
        const count = coordinates.length;
        const startIndex = newTarget.startIndex;
        const endIndex = newEndIndex;
        if (startIndex < endIndex) {
            const forwardDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const reverseDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex - count);
            if (reverseDistance < forwardDistance) newEndIndex -= count;
        } else {
            const reverseDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const forwardDistance = $55fa2487efb2d4e1$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex + count);
            if (forwardDistance < reverseDistance) newEndIndex += count;
        }
    }
    $55fa2487efb2d4e1$var$sharedUpdateInfo.index = newTargetIndex;
    $55fa2487efb2d4e1$var$sharedUpdateInfo.endIndex = newEndIndex;
    return $55fa2487efb2d4e1$var$sharedUpdateInfo;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The clicked coordinate.
 * @param {Array<import("../coordinate.js").Coordinate>} coordinates The geometry component coordinates.
 * @param {boolean} ring The coordinates represent a linear ring.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $55fa2487efb2d4e1$var$appendTraceTarget(coordinate, coordinates, ring, targets) {
    const x = coordinate[0];
    const y = coordinate[1];
    for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
        const start = coordinates[i];
        const end = coordinates[i + 1];
        const rel = $55fa2487efb2d4e1$var$getPointSegmentRelationship(x, y, start, end);
        if (rel.squaredDistance === 0) {
            const index = i + rel.along;
            targets.push({
                coordinates: coordinates,
                ring: ring,
                startIndex: index,
                endIndex: index
            });
            return;
        }
    }
}
/**
 * @typedef {Object} PointSegmentRelationship
 * @property {number} along The closest point expressed as a fraction along the segment length.
 * @property {number} squaredDistance The squared distance of the point to the segment.
 */ /**
 * @type {PointSegmentRelationship}
 */ const $55fa2487efb2d4e1$var$sharedRel = {
    along: 0,
    squaredDistance: 0
};
/**
 * @param {number} x The point x.
 * @param {number} y The point y.
 * @param {import("../coordinate.js").Coordinate} start The segment start.
 * @param {import("../coordinate.js").Coordinate} end The segment end.
 * @return {PointSegmentRelationship} The point segment relationship.  The returned object is
 * shared between calls and must not be modified by the caller.
 */ function $55fa2487efb2d4e1$var$getPointSegmentRelationship(x, y, start, end) {
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    let along = 0;
    let px = x1;
    let py = y1;
    if (dx !== 0 || dy !== 0) {
        along = (0, $6b000a049d919fe5$export$7d15b64cf5a3a4c4)(((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy), 0, 1);
        px += dx * along;
        py += dy * along;
    }
    $55fa2487efb2d4e1$var$sharedRel.along = along;
    $55fa2487efb2d4e1$var$sharedRel.squaredDistance = (0, $6b000a049d919fe5$export$a81f732198733497)((0, $6b000a049d919fe5$export$88e6ebb4fe54f538)(x, y, px, py), 10);
    return $55fa2487efb2d4e1$var$sharedRel;
}
/**
 * @param {LineCoordType} coordinates The coordinates.
 * @param {number} index The index.  May be fractional and may wrap.
 * @return {import("../coordinate.js").Coordinate} The interpolated coordinate.
 */ function $55fa2487efb2d4e1$var$interpolateCoordinate(coordinates, index) {
    const count = coordinates.length;
    let startIndex = Math.floor(index);
    const along = index - startIndex;
    if (startIndex >= count) startIndex -= count;
    else if (startIndex < 0) startIndex += count;
    let endIndex = startIndex + 1;
    if (endIndex >= count) endIndex -= count;
    const start = coordinates[startIndex];
    const x0 = start[0];
    const y0 = start[1];
    const end = coordinates[endIndex];
    const dx = end[0] - x0;
    const dy = end[1] - y0;
    return [
        x0 + dx * along,
        y0 + dy * along
    ];
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */ /**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */ class $55fa2487efb2d4e1$var$Draw extends (0, $cf1eb502962d87a8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $013a1733c226ec50$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DrawOnSignature<void>}
     */ this.un;
        /**
     * @type {boolean}
     * @private
     */ this.shouldHandle_ = false;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.downPx_ = null;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.downTimeout_;
        /**
     * @type {number|undefined}
     * @private
     */ this.lastDragTime_;
        /**
     * Pointer type of the last pointermove event
     * @type {string}
     * @private
     */ this.pointerType_;
        /**
     * @type {boolean}
     * @private
     */ this.freehand_ = false;
        /**
     * Target source for drawn features.
     * @type {VectorSource|null}
     * @private
     */ this.source_ = options.source ? options.source : null;
        /**
     * Target collection for drawn features.
     * @type {import("../Collection.js").default<Feature>|null}
     * @private
     */ this.features_ = options.features ? options.features : null;
        /**
     * Pixel distance for snapping.
     * @type {number}
     * @private
     */ this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
        /**
     * Geometry type.
     * @type {import("../geom/Geometry.js").Type}
     * @private
     */ this.type_ = /** @type {import("../geom/Geometry.js").Type} */ options.type;
        /**
     * Drawing mode (derived from geometry type.
     * @type {Mode}
     * @private
     */ this.mode_ = $55fa2487efb2d4e1$var$getMode(this.type_);
        /**
     * Stop click, singleclick, and doubleclick events from firing during drawing.
     * Default is `false`.
     * @type {boolean}
     * @private
     */ this.stopClick_ = !!options.stopClick;
        /**
     * The number of points that must be drawn before a polygon ring or line
     * string can be finished.  The default is 3 for polygon rings and 2 for
     * line strings.
     * @type {number}
     * @private
     */ this.minPoints_ = options.minPoints ? options.minPoints : this.mode_ === "Polygon" ? 3 : 2;
        /**
     * The number of points that can be drawn before a polygon ring or line string
     * is finished. The default is no restriction.
     * @type {number}
     * @private
     */ this.maxPoints_ = this.mode_ === "Circle" ? 2 : options.maxPoints ? options.maxPoints : Infinity;
        /**
     * A function to decide if a potential finish coordinate is permissible
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.finishCondition_ = options.finishCondition ? options.finishCondition : (0, $013a1733c226ec50$export$22e23a2304399231);
        /**
     * @private
     * @type {import("../geom/Geometry.js").GeometryLayout}
     */ this.geometryLayout_ = options.geometryLayout ? options.geometryLayout : "XY";
        let geometryFunction = options.geometryFunction;
        if (!geometryFunction) {
            const mode = this.mode_;
            if (mode === "Circle") /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                const circle = geometry ? /** @type {Circle} */ geometry : new (0, $f6170f1a08d72585$export$2e2bcd8739ae039)([
                    NaN,
                    NaN
                ]);
                const center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinates[0], projection);
                const squaredLength = (0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(center, (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinates[coordinates.length - 1], projection));
                circle.setCenterAndRadius(center, Math.sqrt(squaredLength), this.geometryLayout_);
                const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
                if (userProjection) circle.transform(projection, userProjection);
                return circle;
            };
            else {
                let Constructor;
                if (mode === "Point") Constructor = (0, $6eced4c969949f6b$export$2e2bcd8739ae039);
                else if (mode === "LineString") Constructor = (0, $292e4002746c8223$export$2e2bcd8739ae039);
                else if (mode === "Polygon") Constructor = (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039);
                /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                    if (geometry) {
                        if (mode === "Polygon") {
                            if (coordinates[0].length) // Add a closing coordinate to match the first
                            geometry.setCoordinates([
                                coordinates[0].concat([
                                    coordinates[0][0]
                                ])
                            ], this.geometryLayout_);
                            else geometry.setCoordinates([], this.geometryLayout_);
                        } else geometry.setCoordinates(coordinates, this.geometryLayout_);
                    } else geometry = new Constructor(coordinates, this.geometryLayout_);
                    return geometry;
                };
            }
        }
        /**
     * @type {GeometryFunction}
     * @private
     */ this.geometryFunction_ = geometryFunction;
        /**
     * @type {number}
     * @private
     */ this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
        /**
     * Finish coordinate for the feature (first point for polygons, last point for
     * linestrings).
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.finishCoordinate_ = null;
        /**
     * Sketch feature.
     * @type {Feature<import('../geom/SimpleGeometry.js').default>}
     * @private
     */ this.sketchFeature_ = null;
        /**
     * Sketch point.
     * @type {Feature<Point>}
     * @private
     */ this.sketchPoint_ = null;
        /**
     * Sketch coordinates. Used when drawing a line or polygon.
     * @type {SketchCoordType}
     * @private
     */ this.sketchCoords_ = null;
        /**
     * Sketch line. Used when drawing polygon.
     * @type {Feature<LineString>}
     * @private
     */ this.sketchLine_ = null;
        /**
     * Sketch line coordinates. Used when drawing a polygon or circle.
     * @type {LineCoordType}
     * @private
     */ this.sketchLineCoords_ = null;
        /**
     * Squared tolerance for handling up events.  If the squared distance
     * between a down and up event is greater than this tolerance, up events
     * will not be handled.
     * @type {number}
     * @private
     */ this.squaredClickTolerance_ = options.clickTolerance ? options.clickTolerance * options.clickTolerance : 36;
        /**
     * Draw overlay where our sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: options.wrapX ? options.wrapX : false
            }),
            style: options.style ? options.style : $55fa2487efb2d4e1$var$getDefaultStyleFunction(),
            updateWhileInteracting: true
        });
        /**
     * Name of the geometry attribute for newly created features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $edf87b50170125f7$export$fdc892d0d8fe3bfb);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.freehandCondition_;
        if (options.freehand) this.freehandCondition_ = (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        else this.freehandCondition_ = options.freehandCondition ? options.freehandCondition : (0, $edf87b50170125f7$export$5d31fe68a477cfbb);
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.traceCondition_;
        this.setTrace(options.trace || false);
        /**
     * @type {TraceState}
     * @private
     */ this.traceState_ = {
            active: false
        };
        /**
     * @type {VectorSource|null}
     * @private
     */ this.traceSource_ = options.traceSource || options.source || null;
        this.addChangeListener((0, $2c9e42723ccf2bfb$export$2e2bcd8739ae039).ACTIVE, this.updateState_);
    }
    /**
   * Toggle tracing mode or set a tracing condition.
   *
   * @param {boolean|import("../events/condition.js").Condition} trace A boolean to toggle tracing mode or an event
   *     condition that will be checked when a feature is clicked to determine if tracing should be active.
   */ setTrace(trace) {
        let condition;
        if (!trace) condition = (0, $edf87b50170125f7$export$b3e22bcfd64c1022);
        else if (trace === true) condition = (0, $edf87b50170125f7$export$ba9e5d519bc326ca);
        else condition = trace;
        this.traceCondition_ = condition;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        super.setMap(map);
        this.updateState_();
    }
    /**
   * Get the overlay layer that this interaction renders sketch features to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may actually draw or finish the drawing.
   * @param {import("../MapBrowserEvent.js").default} event Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(event) {
        if (event.originalEvent.type === (0, $294047c5e65f31a3$export$2e2bcd8739ae039).CONTEXTMENU) // Avoid context menu for long taps when drawing on mobile
        event.originalEvent.preventDefault();
        this.freehand_ = this.mode_ !== "Point" && this.freehandCondition_(event);
        let move = event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE;
        let pass = true;
        if (!this.freehand_ && this.lastDragTime_ && event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG) {
            const now = Date.now();
            if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
                this.downPx_ = event.pixel;
                this.shouldHandle_ = !this.freehand_;
                move = true;
            } else this.lastDragTime_ = undefined;
            if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
        }
        if (this.freehand_ && event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG && this.sketchFeature_ !== null) {
            this.addToDrawing_(event.coordinate);
            pass = false;
        } else if (this.freehand_ && event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDOWN) pass = false;
        else if (move && this.getPointerCount() < 2) {
            pass = event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE;
            if (pass && this.freehand_) {
                this.handlePointerMove_(event);
                if (this.shouldHandle_) // Avoid page scrolling when freehand drawing on mobile
                event.originalEvent.preventDefault();
            } else if (event.originalEvent.pointerType === "mouse" || event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERDRAG && this.downTimeout_ === undefined) this.handlePointerMove_(event);
        } else if (event.type === (0, $150f412a4a7fa263$export$2e2bcd8739ae039).DBLCLICK) pass = false;
        return super.handleEvent(event) && pass;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        this.shouldHandle_ = !this.freehand_;
        if (this.freehand_) {
            this.downPx_ = event.pixel;
            if (!this.finishCoordinate_) this.startDrawing_(event.coordinate);
            return true;
        }
        if (!this.condition_(event)) {
            this.lastDragTime_ = undefined;
            return false;
        }
        this.lastDragTime_ = Date.now();
        this.downTimeout_ = setTimeout(()=>{
            this.handlePointerMove_(new (0, $a1b91f073c6a6c43$export$2e2bcd8739ae039)((0, $150f412a4a7fa263$export$2e2bcd8739ae039).POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
        }, this.dragVertexDelay_);
        this.downPx_ = event.pixel;
        return true;
    }
    /**
   * @private
   */ deactivateTrace_() {
        this.traceState_ = {
            active: false
        };
    }
    /**
   * Activate or deactivate trace state based on a browser event.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ toggleTraceState_(event) {
        if (!this.traceSource_ || !this.traceCondition_(event)) return;
        if (this.traceState_.active) {
            this.deactivateTrace_();
            return;
        }
        const map = this.getMap();
        const lowerLeft = map.getCoordinateFromPixel([
            event.pixel[0] - this.snapTolerance_,
            event.pixel[1] + this.snapTolerance_
        ]);
        const upperRight = map.getCoordinateFromPixel([
            event.pixel[0] + this.snapTolerance_,
            event.pixel[1] - this.snapTolerance_
        ]);
        const extent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)([
            lowerLeft,
            upperRight
        ]);
        const features = this.traceSource_.getFeaturesInExtent(extent);
        if (features.length === 0) return;
        const targets = $55fa2487efb2d4e1$var$getTraceTargets(event.coordinate, features);
        if (targets.length) this.traceState_ = {
            active: true,
            startPx: event.pixel.slice(),
            targets: targets,
            targetIndex: -1
        };
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} endIndex The new end index of the trace.
   * @private
   */ addOrRemoveTracedCoordinates_(target, endIndex) {
        // three cases to handle:
        //  1. traced in the same direction and points need adding
        //  2. traced in the same direction and points need removing
        //  3. traced in a new direction
        const previouslyForward = target.startIndex <= target.endIndex;
        const currentlyForward = target.startIndex <= endIndex;
        if (previouslyForward === currentlyForward) {
            // same direction
            if (previouslyForward && endIndex > target.endIndex || !previouslyForward && endIndex < target.endIndex) // case 1 - add new points
            this.addTracedCoordinates_(target, target.endIndex, endIndex);
            else if (previouslyForward && endIndex < target.endIndex || !previouslyForward && endIndex > target.endIndex) // case 2 - remove old points
            this.removeTracedCoordinates_(endIndex, target.endIndex);
        } else {
            // case 3 - remove old points, add new points
            this.removeTracedCoordinates_(target.startIndex, target.endIndex);
            this.addTracedCoordinates_(target, target.startIndex, endIndex);
        }
    }
    /**
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ removeTracedCoordinates_(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        let remove = 0;
        if (fromIndex < toIndex) {
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) end -= 1;
            remove = end - start + 1;
        } else {
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            remove = start - end + 1;
        }
        if (remove > 0) this.removeLastPoints_(remove);
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ addTracedCoordinates_(target, fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const coordinates = [];
        if (fromIndex < toIndex) {
            // forward trace
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) // if end is snapped to a vertex, it will be added later
            end -= 1;
            for(let i = start; i <= end; ++i)coordinates.push($55fa2487efb2d4e1$var$getCoordinate(target.coordinates, i));
        } else {
            // reverse trace
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            for(let i = start; i >= end; --i)coordinates.push($55fa2487efb2d4e1$var$getCoordinate(target.coordinates, i));
        }
        if (coordinates.length) this.appendCoordinates(coordinates);
    }
    /**
   * Update the trace.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ updateTrace_(event) {
        const traceState = this.traceState_;
        if (!traceState.active) return;
        if (traceState.targetIndex === -1) {
            // check if we are ready to pick a target
            if ((0, $1bd0a226f9a16141$export$9f17032d917177de)(traceState.startPx, event.pixel) < this.snapTolerance_) return;
        }
        const updatedTraceTarget = $55fa2487efb2d4e1$var$getTraceTargetUpdate(event.coordinate, traceState, this.getMap(), this.snapTolerance_);
        if (traceState.targetIndex !== updatedTraceTarget.index) {
            // target changed
            if (traceState.targetIndex !== -1) {
                // remove points added during previous trace
                const oldTarget = traceState.targets[traceState.targetIndex];
                this.removeTracedCoordinates_(oldTarget.startIndex, oldTarget.endIndex);
            }
            // add points for the new target
            const newTarget = traceState.targets[updatedTraceTarget.index];
            this.addTracedCoordinates_(newTarget, newTarget.startIndex, updatedTraceTarget.endIndex);
        } else {
            // target stayed the same
            const target = traceState.targets[traceState.targetIndex];
            this.addOrRemoveTracedCoordinates_(target, updatedTraceTarget.endIndex);
        }
        // modify the state with updated info
        traceState.targetIndex = updatedTraceTarget.index;
        const target = traceState.targets[traceState.targetIndex];
        target.endIndex = updatedTraceTarget.endIndex;
        // update event coordinate and pixel to match end point of final segment
        const coordinate = $55fa2487efb2d4e1$var$interpolateCoordinate(target.coordinates, target.endIndex);
        const pixel = this.getMap().getPixelFromCoordinate(coordinate);
        event.coordinate = coordinate;
        event.pixel = [
            Math.round(pixel[0]),
            Math.round(pixel[1])
        ];
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        let pass = true;
        if (this.getPointerCount() === 0) {
            if (this.downTimeout_) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
            this.handlePointerMove_(event);
            const tracing = this.traceState_.active;
            this.toggleTraceState_(event);
            if (this.shouldHandle_) {
                const startingToDraw = !this.finishCoordinate_;
                if (startingToDraw) this.startDrawing_(event.coordinate);
                if (!startingToDraw && this.freehand_) this.finishDrawing();
                else if (!this.freehand_ && (!startingToDraw || this.mode_ === "Point")) {
                    if (this.atFinish_(event.pixel, tracing)) {
                        if (this.finishCondition_(event)) this.finishDrawing();
                    } else this.addToDrawing_(event.coordinate);
                }
                pass = false;
            } else if (this.freehand_) this.abortDrawing();
        }
        if (!pass && this.stopClick_) event.preventDefault();
        return pass;
    }
    /**
   * Handle move events.
   * @param {import("../MapBrowserEvent.js").default} event A move event.
   * @private
   */ handlePointerMove_(event) {
        this.pointerType_ = event.originalEvent.pointerType;
        if (this.downPx_ && (!this.freehand_ && this.shouldHandle_ || this.freehand_ && !this.shouldHandle_)) {
            const downPx = this.downPx_;
            const clickPx = event.pixel;
            const dx = downPx[0] - clickPx[0];
            const dy = downPx[1] - clickPx[1];
            const squaredDistance = dx * dx + dy * dy;
            this.shouldHandle_ = this.freehand_ ? squaredDistance > this.squaredClickTolerance_ : squaredDistance <= this.squaredClickTolerance_;
            if (!this.shouldHandle_) return;
        }
        if (!this.finishCoordinate_) {
            this.createOrUpdateSketchPoint_(event.coordinate.slice());
            return;
        }
        this.updateTrace_(event);
        this.modifyDrawing_(event.coordinate);
    }
    /**
   * Determine if an event is within the snapping tolerance of the start coord.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {boolean} [tracing] Drawing in trace mode (only stop if at the starting point).
   * @return {boolean} The event is within the snapping tolerance of the start.
   * @private
   */ atFinish_(pixel, tracing) {
        let at = false;
        if (this.sketchFeature_) {
            let potentiallyDone = false;
            let potentiallyFinishCoordinates = [
                this.finishCoordinate_
            ];
            const mode = this.mode_;
            if (mode === "Point") at = true;
            else if (mode === "Circle") at = this.sketchCoords_.length === 2;
            else if (mode === "LineString") potentiallyDone = !tracing && this.sketchCoords_.length > this.minPoints_;
            else if (mode === "Polygon") {
                const sketchCoords = /** @type {PolyCoordType} */ this.sketchCoords_;
                potentiallyDone = sketchCoords[0].length > this.minPoints_;
                potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
                if (tracing) potentiallyFinishCoordinates = [
                    sketchCoords[0][0]
                ];
                else potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
            }
            if (potentiallyDone) {
                const map = this.getMap();
                for(let i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++){
                    const finishCoordinate = potentiallyFinishCoordinates[i];
                    const finishPixel = map.getPixelFromCoordinate(finishCoordinate);
                    const dx = pixel[0] - finishPixel[0];
                    const dy = pixel[1] - finishPixel[1];
                    const snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
                    at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
                    if (at) {
                        this.finishCoordinate_ = finishCoordinate;
                        break;
                    }
                }
            }
        }
        return at;
    }
    /**
   * @param {import("../coordinate").Coordinate} coordinates Coordinate.
   * @private
   */ createOrUpdateSketchPoint_(coordinates) {
        if (!this.sketchPoint_) {
            this.sketchPoint_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(coordinates));
            this.updateSketchFeatures_();
        } else {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinates);
        }
    }
    /**
   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
   * @private
   */ createOrUpdateCustomSketchLine_(geometry) {
        if (!this.sketchLine_) this.sketchLine_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        const ring = geometry.getLinearRing(0);
        let sketchLineGeom = this.sketchLine_.getGeometry();
        if (!sketchLineGeom) {
            sketchLineGeom = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(ring.getFlatCoordinates(), ring.getLayout());
            this.sketchLine_.setGeometry(sketchLineGeom);
        } else {
            sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
            sketchLineGeom.changed();
        }
    }
    /**
   * Start the drawing.
   * @param {import("../coordinate.js").Coordinate} start Start coordinate.
   * @private
   */ startDrawing_(start) {
        const projection = this.getMap().getView().getProjection();
        const stride = (0, $c76e993e57efc8c4$export$6af0c1b4a8549a43)(this.geometryLayout_);
        while(start.length < stride)start.push(0);
        this.finishCoordinate_ = start;
        if (this.mode_ === "Point") this.sketchCoords_ = start.slice();
        else if (this.mode_ === "Polygon") {
            this.sketchCoords_ = [
                [
                    start.slice(),
                    start.slice()
                ]
            ];
            this.sketchLineCoords_ = this.sketchCoords_[0];
        } else this.sketchCoords_ = [
            start.slice(),
            start.slice()
        ];
        if (this.sketchLineCoords_) this.sketchLine_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $292e4002746c8223$export$2e2bcd8739ae039)(this.sketchLineCoords_));
        const geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
        this.sketchFeature_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)();
        if (this.geometryName_) this.sketchFeature_.setGeometryName(this.geometryName_);
        this.sketchFeature_.setGeometry(geometry);
        this.updateSketchFeatures_();
        this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Modify the drawing.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @private
   */ modifyDrawing_(coordinate) {
        const map = this.getMap();
        const geometry = this.sketchFeature_.getGeometry();
        const projection = map.getView().getProjection();
        const stride = (0, $c76e993e57efc8c4$export$6af0c1b4a8549a43)(this.geometryLayout_);
        let coordinates, last;
        while(coordinate.length < stride)coordinate.push(0);
        if (this.mode_ === "Point") last = this.sketchCoords_;
        else if (this.mode_ === "Polygon") {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            last = coordinates[coordinates.length - 1];
            if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) // snap to finish
            coordinate = this.finishCoordinate_.slice();
        } else {
            coordinates = this.sketchCoords_;
            last = coordinates[coordinates.length - 1];
        }
        last[0] = coordinate[0];
        last[1] = coordinate[1];
        this.geometryFunction_(/** @type {!LineCoordType} */ this.sketchCoords_, geometry, projection);
        if (this.sketchPoint_) {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinate);
        }
        if (geometry.getType() === "Polygon" && this.mode_ !== "Polygon") this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
        else if (this.sketchLineCoords_) {
            const sketchLineGeom = this.sketchLine_.getGeometry();
            sketchLineGeom.setCoordinates(this.sketchLineCoords_);
        }
        this.updateSketchFeatures_();
    }
    /**
   * Add a new coordinate to the drawing.
   * @param {!PointCoordType} coordinate Coordinate
   * @return {Feature<import("../geom/SimpleGeometry.js").default>} The sketch feature.
   * @private
   */ addToDrawing_(coordinate) {
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        let done;
        let coordinates;
        const mode = this.mode_;
        if (mode === "LineString" || mode === "Circle") {
            this.finishCoordinate_ = coordinate.slice();
            coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (mode === "Polygon") {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            if (done) this.finishCoordinate_ = coordinates[0];
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        this.createOrUpdateSketchPoint_(coordinate.slice());
        this.updateSketchFeatures_();
        if (done) return this.finishDrawing();
        return this.sketchFeature_;
    }
    /**
   * @param {number} n The number of points to remove.
   */ removeLastPoints_(n) {
        if (!this.sketchFeature_) return;
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        const mode = this.mode_;
        for(let i = 0; i < n; ++i){
            let coordinates;
            if (mode === "LineString" || mode === "Circle") {
                coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
                coordinates.splice(-2, 1);
                if (coordinates.length >= 2) {
                    this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
                    const finishCoordinate = this.finishCoordinate_.slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                this.geometryFunction_(coordinates, geometry, projection);
                if (geometry.getType() === "Polygon" && this.sketchLine_) this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
            } else if (mode === "Polygon") {
                coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
                coordinates.splice(-2, 1);
                const sketchLineGeom = this.sketchLine_.getGeometry();
                if (coordinates.length >= 2) {
                    const finishCoordinate = coordinates[coordinates.length - 2].slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                sketchLineGeom.setCoordinates(coordinates);
                this.geometryFunction_(this.sketchCoords_, geometry, projection);
            }
            if (coordinates.length === 1) {
                this.abortDrawing();
                break;
            }
        }
        this.updateSketchFeatures_();
    }
    /**
   * Remove last point of the feature currently being drawn. Does not do anything when
   * drawing POINT or MULTI_POINT geometries.
   * @api
   */ removeLastPoint() {
        this.removeLastPoints_(1);
    }
    /**
   * Stop drawing and add the sketch feature to the target layer.
   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
   * dispatched before inserting the feature.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The drawn feature.
   * @api
   */ finishDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (!sketchFeature) return null;
        let coordinates = this.sketchCoords_;
        const geometry = sketchFeature.getGeometry();
        const projection = this.getMap().getView().getProjection();
        if (this.mode_ === "LineString") {
            // remove the redundant last point
            coordinates.pop();
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (this.mode_ === "Polygon") {
            // remove the redundant last point in ring
            /** @type {PolyCoordType} */ coordinates[0].pop();
            this.geometryFunction_(coordinates, geometry, projection);
            coordinates = geometry.getCoordinates();
        }
        // cast multi-part geometries
        if (this.type_ === "MultiPoint") sketchFeature.setGeometry(new (0, $e6080c63a9451eda$export$2e2bcd8739ae039)([
            /** @type {PointCoordType} */ coordinates
        ]));
        else if (this.type_ === "MultiLineString") sketchFeature.setGeometry(new (0, $b4c0e2e13beea46e$export$2e2bcd8739ae039)([
            /** @type {LineCoordType} */ coordinates
        ]));
        else if (this.type_ === "MultiPolygon") sketchFeature.setGeometry(new (0, $f73f35eb6af8b987$export$2e2bcd8739ae039)([
            /** @type {PolyCoordType} */ coordinates
        ]));
        // First dispatch event to allow full set up of feature
        this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWEND, sketchFeature));
        // Then insert feature
        if (this.features_) this.features_.push(sketchFeature);
        if (this.source_) this.source_.addFeature(sketchFeature);
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The sketch feature (or null if none).
   * @private
   */ abortDrawing_() {
        this.finishCoordinate_ = null;
        const sketchFeature = this.sketchFeature_;
        this.sketchFeature_ = null;
        this.sketchPoint_ = null;
        this.sketchLine_ = null;
        this.overlay_.getSource().clear(true);
        this.deactivateTrace_();
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @api
   */ abortDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (sketchFeature) this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWABORT, sketchFeature));
    }
    /**
   * Append coordinates to the end of the geometry that is currently being drawn.
   * This can be used when drawing LineStrings or Polygons. Coordinates will
   * either be appended to the current LineString or the outer ring of the current
   * Polygon. If no geometry is being drawn, a new one will be created.
   * @param {!LineCoordType} coordinates Linear coordinates to be appended to
   * the coordinate array.
   * @api
   */ appendCoordinates(coordinates) {
        const mode = this.mode_;
        const newDrawing = !this.sketchFeature_;
        if (newDrawing) this.startDrawing_(coordinates[0]);
        /** @type {LineCoordType} */ let sketchCoords;
        if (mode === "LineString" || mode === "Circle") sketchCoords = /** @type {LineCoordType} */ this.sketchCoords_;
        else if (mode === "Polygon") sketchCoords = this.sketchCoords_ && this.sketchCoords_.length ? /** @type {PolyCoordType} */ this.sketchCoords_[0] : [];
        else return;
        if (newDrawing) sketchCoords.shift();
        // Remove last coordinate from sketch drawing (this coordinate follows cursor position)
        sketchCoords.pop();
        // Append coordinate list
        for(let i = 0; i < coordinates.length; i++)this.addToDrawing_(coordinates[i]);
        const ending = coordinates[coordinates.length - 1];
        // Duplicate last coordinate for sketch drawing (cursor position)
        this.sketchFeature_ = this.addToDrawing_(ending);
        this.modifyDrawing_(ending);
    }
    /**
   * Initiate draw mode by starting from an existing geometry which will
   * receive new additional points. This only works on features with
   * `LineString` geometries, where the interaction will extend lines by adding
   * points to the end of the coordinates array.
   * This will change the original feature, instead of drawing a copy.
   *
   * The function will dispatch a `drawstart` event.
   *
   * @param {!Feature<LineString>} feature Feature to be extended.
   * @api
   */ extend(feature) {
        const geometry = feature.getGeometry();
        const lineString = geometry;
        this.sketchFeature_ = feature;
        this.sketchCoords_ = lineString.getCoordinates();
        const last = this.sketchCoords_[this.sketchCoords_.length - 1];
        this.finishCoordinate_ = last.slice();
        this.sketchCoords_.push(last.slice());
        this.sketchPoint_ = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)(new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(last));
        this.updateSketchFeatures_();
        this.dispatchEvent(new $55fa2487efb2d4e1$export$85a4910380d251a7($55fa2487efb2d4e1$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Redraw the sketch features.
   * @private
   */ updateSketchFeatures_() {
        const sketchFeatures = [];
        if (this.sketchFeature_) sketchFeatures.push(this.sketchFeature_);
        if (this.sketchLine_) sketchFeatures.push(this.sketchLine_);
        if (this.sketchPoint_) sketchFeatures.push(this.sketchPoint_);
        const overlaySource = this.overlay_.getSource();
        overlaySource.clear(true);
        overlaySource.addFeatures(sketchFeatures);
    }
    /**
   * @private
   */ updateState_() {
        const map = this.getMap();
        const active = this.getActive();
        if (!map || !active) this.abortDrawing();
        this.overlay_.setMap(active ? map : null);
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $55fa2487efb2d4e1$var$getDefaultStyleFunction() {
    const styles = (0, $8c7f6dda98e8cb9c$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return styles[feature.getGeometry().getType()];
    };
}
function $55fa2487efb2d4e1$export$e636e17021965266(sides, angle) {
    return function(coordinates, geometry, projection) {
        const center = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[0], projection);
        const end = (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[coordinates.length - 1], projection);
        const radius = Math.sqrt((0, $1bd0a226f9a16141$export$88e6ebb4fe54f538)(center, end));
        geometry = geometry || (0, $40aa8d43bbe572bf$export$2451009d645fb8c2)(new (0, $f6170f1a08d72585$export$2e2bcd8739ae039)(center), sides);
        let internalAngle = angle;
        if (!angle && angle !== 0) {
            const x = end[0] - center[0];
            const y = end[1] - center[1];
            internalAngle = Math.atan2(y, x);
        }
        (0, $40aa8d43bbe572bf$export$87d6a1539a56e47f)(/** @type {Polygon} */ geometry, center, radius, internalAngle);
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
function $55fa2487efb2d4e1$export$6459fc9e86be362e() {
    return function(coordinates, geometry, projection) {
        const extent = (0, $6da4c8ed3074c92b$export$8aceca7c77505534)(/** @type {LineCoordType} */ [
            coordinates[0],
            coordinates[coordinates.length - 1]
        ].map(function(coordinate) {
            return (0, $9c4744460e43e41b$export$d4b8ec0b96db1ee2)(coordinate, projection);
        }));
        const boxCoordinates = [
            [
                (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent),
                (0, $6da4c8ed3074c92b$export$e77c1cf70445e168)(extent),
                (0, $6da4c8ed3074c92b$export$b84fa077c8b05295)(extent),
                (0, $6da4c8ed3074c92b$export$cb1538b07e6964ff)(extent),
                (0, $6da4c8ed3074c92b$export$8d09f5e2e1bf560d)(extent)
            ]
        ];
        if (geometry) geometry.setCoordinates(boxCoordinates);
        else geometry = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)(boxCoordinates);
        const userProjection = (0, $9c4744460e43e41b$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
/**
 * Get the drawing mode.  The mode for multi-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/Geometry.js").Type} type Geometry type.
 * @return {Mode} Drawing mode.
 */ function $55fa2487efb2d4e1$var$getMode(type) {
    switch(type){
        case "Point":
        case "MultiPoint":
            return "Point";
        case "LineString":
        case "MultiLineString":
            return "LineString";
        case "Polygon":
        case "MultiPolygon":
            return "Polygon";
        case "Circle":
            return "Circle";
        default:
            throw new Error("Invalid type: " + type);
    }
}
var $55fa2487efb2d4e1$export$2e2bcd8739ae039 = $55fa2487efb2d4e1$var$Draw;







const $d6ca6fbff46b9f88$var$style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: "rgba(0, 0, 0, 1)"
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: "rgba(0, 0, 0, 1)",
        width: 10
    }),
    image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
        radius: 5,
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 1)"
        })
    })
});
function $d6ca6fbff46b9f88$export$2e2bcd8739ae039(map) {
    const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)();
    const vector = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: source,
        style: $d6ca6fbff46b9f88$var$style,
        zIndex: 2
    });
    const draw = new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
        source: source,
        type: "LineString",
        style: $d6ca6fbff46b9f88$var$style,
        freehand: true,
        freehandCondition: (event)=>{
            if ((0, $edf87b50170125f7$export$e74de664a571d084)(event)) return true;
            return (0, $9c554d6df7d74017$export$d8dfe47506dd265c)(event) || (0, $9c554d6df7d74017$export$15fd6aa86c652915)(event);
        }
    });
    map.addLayer(vector);
    map.addInteraction(draw);
    return {
        draw: draw,
        clear: ()=>source.clear()
    };
}











function $d9c7bfbffe5b86fd$var$radians(n) {
    return n * (Math.PI / 180);
}
function $d9c7bfbffe5b86fd$var$degrees(n) {
    return n * (180 / Math.PI);
}
// https://gis.stackexchange.com/questions/29239/calculate-bearing-between-two-decimal-gps-coordinates
function $d9c7bfbffe5b86fd$var$getBearing(startLat, startLong, endLat, endLong) {
    startLat = $d9c7bfbffe5b86fd$var$radians(startLat);
    startLong = $d9c7bfbffe5b86fd$var$radians(startLong);
    endLat = $d9c7bfbffe5b86fd$var$radians(endLat);
    endLong = $d9c7bfbffe5b86fd$var$radians(endLong);
    var dLong = endLong - startLong;
    var dPhi = Math.log(Math.tan(endLat / 2.0 + Math.PI / 4.0) / Math.tan(startLat / 2.0 + Math.PI / 4.0));
    if (Math.abs(dLong) > Math.PI) {
        if (dLong > 0.0) dLong = -(2.0 * Math.PI - dLong);
        else dLong = 2.0 * Math.PI + dLong;
    }
    return ($d9c7bfbffe5b86fd$var$degrees(Math.atan2(dLong, dPhi)) + 360.0) % 360.0;
}
// https://openlayers.org/en/latest/examples/measure-style.html
const $d9c7bfbffe5b86fd$var$style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: "rgba(255, 255, 255, 0.2)"
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: "rgba(0, 0, 0, 1)",
        lineDash: [
            10,
            10
        ],
        width: 2
    }),
    image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 1)",
            width: 2
        }),
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        points: 4,
        radius: 10,
        radius2: 0,
        angle: 0
    })
});
const $d9c7bfbffe5b86fd$var$labelStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        font: "14px Roboto,sans-serif",
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        }),
        padding: [
            2,
            2,
            2,
            2
        ],
        textBaseline: "bottom",
        offsetY: -15
    }),
    image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        radius: 8,
        points: 3,
        angle: Math.PI,
        displacement: [
            0,
            10
        ],
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        })
    })
});
const $d9c7bfbffe5b86fd$var$tipStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        font: "12px Roboto,sans-serif",
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.4)"
        }),
        padding: [
            4,
            4,
            4,
            4
        ],
        textAlign: "left",
        offsetX: 15
    })
});
const $d9c7bfbffe5b86fd$var$modifyStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
        radius: 5,
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        }),
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.4)"
        })
    }),
    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        text: "Drag to modify",
        font: "12px Roboto,sans-serif",
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        }),
        padding: [
            2,
            2,
            2,
            2
        ],
        textAlign: "left",
        offsetX: 15
    })
});
const $d9c7bfbffe5b86fd$var$segmentStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        font: "12px Roboto,sans-serif",
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.4)"
        }),
        padding: [
            2,
            2,
            2,
            2
        ],
        textBaseline: "bottom",
        offsetY: -12
    }),
    image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        radius: 6,
        points: 3,
        angle: Math.PI,
        displacement: [
            0,
            8
        ],
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.4)"
        })
    })
});
const $d9c7bfbffe5b86fd$var$segmentStyles = [
    $d9c7bfbffe5b86fd$var$segmentStyle
];
const $d9c7bfbffe5b86fd$var$formatLength = function(line) {
    let az;
    const coords = line.getCoordinates();
    if (coords.length === 2) {
        const [startLon, startLat] = coords[0];
        const [endLon, endLat] = coords[1];
        az = $d9c7bfbffe5b86fd$var$getBearing(startLat, startLon, endLat, endLon);
    }
    const length = (0, $fb75384508533d8f$export$f0d11c074a923179)(line, {
        projection: "EPSG:4326"
    });
    const fixed = (length * (0, $91a9098e14452db2$export$a31389e164b90234)).toFixed(2);
    return az ? `${az.toFixed(0)}\xb0 for ${fixed}NM` : `${fixed}NM`;
};
const $d9c7bfbffe5b86fd$var$formatArea = function(polygon) {
    const area = (0, $fb75384508533d8f$export$520c40045967cb15)(polygon);
    let output;
    if (area > 10000) output = Math.round(area / 1000000 * 100) / 100 + " km\xb2";
    else output = Math.round(area * 100) / 100 + " m\xb2";
    return output;
};
const $d9c7bfbffe5b86fd$var$source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)();
const $d9c7bfbffe5b86fd$var$modify = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
    source: $d9c7bfbffe5b86fd$var$source,
    style: $d9c7bfbffe5b86fd$var$modifyStyle
});
let $d9c7bfbffe5b86fd$var$tipPoint;
function $d9c7bfbffe5b86fd$var$styleFunction(feature, segments, drawType, tip) {
    const styles = [
        $d9c7bfbffe5b86fd$var$style
    ];
    const geometry = feature.getGeometry();
    const type = geometry.getType();
    let point, label, line;
    if (!drawType || drawType === type) {
        if (type === "Polygon") {
            point = geometry.getInteriorPoint();
            label = $d9c7bfbffe5b86fd$var$formatArea(geometry);
            line = new (0, $292e4002746c8223$export$2e2bcd8739ae039)(geometry.getCoordinates()[0]);
        } else if (type === "LineString") {
            point = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(geometry.getLastCoordinate());
            label = $d9c7bfbffe5b86fd$var$formatLength(geometry);
            line = geometry;
        }
    }
    if (segments && line) {
        let count = 0;
        line.forEachSegment(function(a, b) {
            const segment = new (0, $292e4002746c8223$export$2e2bcd8739ae039)([
                a,
                b
            ]);
            const label = $d9c7bfbffe5b86fd$var$formatLength(segment);
            if ($d9c7bfbffe5b86fd$var$segmentStyles.length - 1 < count) $d9c7bfbffe5b86fd$var$segmentStyles.push($d9c7bfbffe5b86fd$var$segmentStyle.clone());
            const segmentPoint = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)(segment.getCoordinateAt(0.5));
            $d9c7bfbffe5b86fd$var$segmentStyles[count].setGeometry(segmentPoint);
            $d9c7bfbffe5b86fd$var$segmentStyles[count].getText().setText(label);
            styles.push($d9c7bfbffe5b86fd$var$segmentStyles[count]);
            count++;
        });
    }
    if (label) {
        $d9c7bfbffe5b86fd$var$labelStyle.setGeometry(point);
        $d9c7bfbffe5b86fd$var$labelStyle.getText().setText(label);
        styles.push($d9c7bfbffe5b86fd$var$labelStyle);
    }
    if (tip && type === "Point" && !$d9c7bfbffe5b86fd$var$modify.getOverlay().getSource().getFeatures().length) {
        $d9c7bfbffe5b86fd$var$tipPoint = geometry;
        $d9c7bfbffe5b86fd$var$tipStyle.getText().setText(tip);
        styles.push($d9c7bfbffe5b86fd$var$tipStyle);
    }
    return styles;
}
function $d9c7bfbffe5b86fd$export$2e2bcd8739ae039(map) {
    const vector = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: $d9c7bfbffe5b86fd$var$source,
        style: function(feature) {
            return $d9c7bfbffe5b86fd$var$styleFunction(feature, true);
        },
        zIndex: 2
    });
    const drawType = "LineString";
    const activeTip = "Click to continue drawing the line";
    const idleTip = "Click to start measuring";
    let tip = idleTip;
    let draw = new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
        source: $d9c7bfbffe5b86fd$var$source,
        type: "LineString",
        style: function(feature) {
            return $d9c7bfbffe5b86fd$var$styleFunction(feature, true, drawType, tip);
        },
        condition: (event)=>(0, $9c554d6df7d74017$export$15fd6aa86c652915)(event) || (0, $9c554d6df7d74017$export$d8dfe47506dd265c)(event)
    });
    draw.on("drawstart", function() {
        $d9c7bfbffe5b86fd$var$modify.setActive(false);
        tip = activeTip;
    });
    draw.on("drawend", function() {
        $d9c7bfbffe5b86fd$var$modifyStyle.setGeometry($d9c7bfbffe5b86fd$var$tipPoint);
        $d9c7bfbffe5b86fd$var$modify.setActive(true);
        map.once("pointermove", function() {
            // @ts-ignore
            $d9c7bfbffe5b86fd$var$modifyStyle.setGeometry();
        });
        tip = idleTip;
    });
    $d9c7bfbffe5b86fd$var$modify.setActive(true);
    map.addInteraction($d9c7bfbffe5b86fd$var$modify);
    map.addInteraction(draw);
    map.addLayer(vector);
    return {
        draw: draw,
        clear: ()=>$d9c7bfbffe5b86fd$var$source.clear()
    };
}









const $d2af19a51ae5f8f8$var$labelStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        font: "16px Courier New,sans-serif",
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        }),
        padding: [
            4,
            4,
            4,
            4
        ],
        textAlign: "left",
        textBaseline: "bottom",
        offsetY: -16,
        offsetX: -5
    }),
    image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        radius: 8,
        points: 3,
        angle: Math.PI,
        displacement: [
            0,
            10
        ],
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.7)"
        })
    })
});
const $d2af19a51ae5f8f8$var$stroke = new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
    color: "black",
    width: 2
});
const $d2af19a51ae5f8f8$var$fill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
    color: "red"
});
const $d2af19a51ae5f8f8$var$cursorStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        fill: $d2af19a51ae5f8f8$var$fill,
        stroke: $d2af19a51ae5f8f8$var$stroke,
        points: 4,
        radius: 10,
        radius2: 0,
        angle: Math.PI / 4
    })
});
const $d2af19a51ae5f8f8$var$styleFunc = (map)=>(feature)=>{
        const geometry = feature.getGeometry();
        const type = geometry.getType();
        const styles = [
            $d2af19a51ae5f8f8$var$style
        ];
        if (type === "Point") {
            $d2af19a51ae5f8f8$var$labelStyle.setGeometry(geometry);
            const coords = geometry.getCoordinates();
            const elevation = (0, $a48a327511f3c8e6$export$70467d14cb8c16f8)(map, coords);
            const txt = (0, $79e13355954d15ea$export$b2b002b78ef471ac)([
                coords[0],
                coords[1]
            ]);
            txt.push(`${(0, $79e13355954d15ea$export$d284c26147b5ca34)(elevation).toFixed(0)} FT`);
            $d2af19a51ae5f8f8$var$labelStyle.getText().setText(txt.join("\n"));
            styles.push($d2af19a51ae5f8f8$var$labelStyle);
        }
        return styles;
    };
const $d2af19a51ae5f8f8$var$svg = '<svg width="120" height="120" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="5"/></svg>';
const $d2af19a51ae5f8f8$var$style = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
        color: "rgba(0, 0, 0, 1)"
    }),
    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
        color: "rgba(0, 0, 0, 1)",
        width: 10
    }),
    image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
        opacity: 1,
        src: "data:image/svg+xml;utf8," + $d2af19a51ae5f8f8$var$svg,
        scale: 1
    })
});
function $d2af19a51ae5f8f8$export$2e2bcd8739ae039(map) {
    const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
        wrapX: false
    });
    const vector = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        source: source,
        style: $d2af19a51ae5f8f8$var$styleFunc(map),
        zIndex: 2
    });
    const draw = new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
        source: source,
        type: "Point",
        style: $d2af19a51ae5f8f8$var$cursorStyle
    });
    map.addLayer(vector);
    map.addInteraction(draw);
    return {
        draw: draw,
        clear: ()=>source.clear()
    };
}


function $6d97c29601edc344$export$2e2bcd8739ae039() {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const { state: { drawMode: drawMode } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const setDrawMode = (0, $99f46708ff5ed621$export$cce769050d8b552e)();
    const prev = $acw62.useRef();
    // const [colorPickActive, setColorPickActive] = React.useState(false);
    const measureRef = $acw62.useRef(null);
    const pointDropRef = $acw62.useRef(null);
    const freeHandRef = $acw62.useRef(null);
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)("esc", ()=>{
        prev.current = (0, $99f46708ff5ed621$export$bb7997377d28252d).None;
        // setColorPickActive(false);
        setDrawMode((0, $99f46708ff5ed621$export$bb7997377d28252d).None);
    });
    (0, $643289de0f480f5f$export$1b0c17123b4f3646)("space", (e)=>{
        // Pan on spacebar hold
        if (e.type === "keydown") setDrawMode((0, $99f46708ff5ed621$export$bb7997377d28252d).None);
        if (e.type === "keyup") setDrawMode(prev.current);
    }, {
        keydown: true,
        keyup: true
    });
    $acw62.useEffect(()=>{
        if (!map) return;
        const measure = (0, $d9c7bfbffe5b86fd$export$2e2bcd8739ae039)(map);
        measureRef.current = measure;
        measure.draw.setActive(false);
        const freeHand = (0, $d6ca6fbff46b9f88$export$2e2bcd8739ae039)(map);
        freeHandRef.current = freeHand;
        freeHand.draw.setActive(false);
        const pointDrop = (0, $d2af19a51ae5f8f8$export$2e2bcd8739ae039)(map);
        pointDropRef.current = pointDrop;
        pointDrop.draw.setActive(false);
    }, [
        map
    ]);
    $acw62.useEffect(()=>{
        switch(drawMode){
            case (0, $99f46708ff5ed621$export$bb7997377d28252d).Ruler:
                freeHandRef.current?.draw.setActive(false);
                pointDropRef.current?.draw.setActive(false);
                measureRef.current?.draw.setActive(true);
                break;
            case (0, $99f46708ff5ed621$export$bb7997377d28252d).Freehand:
                freeHandRef.current?.draw.setActive(true);
                pointDropRef.current?.draw.setActive(false);
                measureRef.current?.draw.setActive(false);
                break;
            case (0, $99f46708ff5ed621$export$bb7997377d28252d).PointDrop:
                freeHandRef.current?.draw.setActive(false);
                pointDropRef.current?.draw.setActive(true);
                measureRef.current?.draw.setActive(false);
                break;
            default:
                freeHandRef.current?.draw.setActive(false);
                pointDropRef.current?.draw.setActive(false);
                measureRef.current?.draw.finishDrawing();
                measureRef.current?.draw.setActive(false);
        }
    }, [
        drawMode
    ]);
    // React.useEffect(() => {
    //   freeHandRef.current?.setStyle({
    //     stroke: new Stroke({
    //       color: color,
    //       width: 10,
    //     }),
    //   });
    // }, [color]);
    return ()=>{
        freeHandRef.current?.clear();
        measureRef.current?.clear();
        pointDropRef.current?.clear();
    };
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

const $499d669e091e4996$var$LargeTooltip = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        arrow: true,
        placement: props.placement || "top",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            style: {
                fontSize: "16px"
            },
            children: props.title
        }),
        children: props.children
    });
var $499d669e091e4996$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($499d669e091e4996$var$LargeTooltip).attrs({
    className: $499d669e091e4996$var$LargeTooltip.name
})``;



const $18ad72aaccb3a4a7$var$DrawingTools = /*#__PURE__*/ $acw62.forwardRef(function MyInput(props, ref) {
    const { state: { drawMode: drawMode, disableUI: disableUI } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const setDrawMode = (0, $99f46708ff5ed621$export$cce769050d8b552e)();
    const handleDrawClick = (e, mode)=>{
        e.stopPropagation();
        setDrawMode(mode);
    };
    const clearDrawings = (0, $6d97c29601edc344$export$2e2bcd8739ae039)();
    if (disableUI) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ...props,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499d669e091e4996$export$2e2bcd8739ae039), {
                title: "Freehand Draw",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                    active: drawMode && drawMode === (0, $99f46708ff5ed621$export$bb7997377d28252d).Freehand,
                    onClick: (e)=>handleDrawClick(e, (0, $99f46708ff5ed621$export$bb7997377d28252d).Freehand),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf65d0cdcb730ab5$exports))), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499d669e091e4996$export$2e2bcd8739ae039), {
                title: "Measure",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                    active: drawMode && drawMode === (0, $99f46708ff5ed621$export$bb7997377d28252d).Ruler,
                    onClick: (e)=>handleDrawClick(e, (0, $99f46708ff5ed621$export$bb7997377d28252d).Ruler),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($675f2b16dc8ab273$exports))), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499d669e091e4996$export$2e2bcd8739ae039), {
                title: "Drop Point",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                    active: drawMode && drawMode === (0, $99f46708ff5ed621$export$bb7997377d28252d).PointDrop,
                    onClick: (e)=>handleDrawClick(e, (0, $99f46708ff5ed621$export$bb7997377d28252d).PointDrop),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7c3495d857096b79$exports))), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499d669e091e4996$export$2e2bcd8739ae039), {
                title: "Clear All Drawings",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                    onClick: (e)=>{
                        e.stopPropagation();
                        clearDrawings();
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {})
                })
            })
        ]
    });
});
var $18ad72aaccb3a4a7$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($18ad72aaccb3a4a7$var$DrawingTools).attrs({
    className: "DrawingTools"
})`
  ${(0, $3fe6920ef40d5760$export$2e2bcd8739ae039)}, .MuiIconButton-root {
    height: 48px;
    width: 48px;
  }

  .MuiIconButton-root svg {
    font-size: 32px;
  }

  @media only screen and (max-width: 1300px) {
    display: none;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");
var $fa1bd34af973acad$exports = {};
"use strict";

Object.defineProperty($fa1bd34af973acad$exports, "__esModule", {
    value: true
});
$fa1bd34af973acad$exports.default = void 0;

var $fa1bd34af973acad$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $fa1bd34af973acad$var$_default = (0, $fa1bd34af973acad$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], "AccessTime");
$fa1bd34af973acad$exports.default = $fa1bd34af973acad$var$_default;


var $ee6d6bcb1ef6fbe5$exports = {};
"use strict";

Object.defineProperty($ee6d6bcb1ef6fbe5$exports, "__esModule", {
    value: true
});
$ee6d6bcb1ef6fbe5$exports.default = void 0;

var $ee6d6bcb1ef6fbe5$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ee6d6bcb1ef6fbe5$var$_default = (0, $ee6d6bcb1ef6fbe5$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "12",
        cy: "12",
        r: "3.2"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }, "1")
], "CameraAlt");
$ee6d6bcb1ef6fbe5$exports.default = $ee6d6bcb1ef6fbe5$var$_default;


var $51e89b0c13e21577$exports = {};
"use strict";

Object.defineProperty($51e89b0c13e21577$exports, "__esModule", {
    value: true
});
$51e89b0c13e21577$exports.default = void 0;

var $51e89b0c13e21577$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $51e89b0c13e21577$var$_default = (0, $51e89b0c13e21577$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
}), "ContentPaste");
$51e89b0c13e21577$exports.default = $51e89b0c13e21577$var$_default;


var $a1d7752f49a1ccd3$exports = {};
"use strict";

Object.defineProperty($a1d7752f49a1ccd3$exports, "__esModule", {
    value: true
});
$a1d7752f49a1ccd3$exports.default = void 0;

var $a1d7752f49a1ccd3$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a1d7752f49a1ccd3$var$_default = (0, $a1d7752f49a1ccd3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), "GetApp");
$a1d7752f49a1ccd3$exports.default = $a1d7752f49a1ccd3$var$_default;


var $05cdb0e991cfb75f$exports = {};
"use strict";

Object.defineProperty($05cdb0e991cfb75f$exports, "__esModule", {
    value: true
});
$05cdb0e991cfb75f$exports.default = void 0;

var $05cdb0e991cfb75f$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $05cdb0e991cfb75f$var$_default = (0, $05cdb0e991cfb75f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
}), "List");
$05cdb0e991cfb75f$exports.default = $05cdb0e991cfb75f$var$_default;



parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");




function $d059b7c482dc88ca$var$NavButton({ className: className, children: children, foWindow: foWindow, tooltip: tooltip }) {
    const { handleClick: handleClick, windows: windows } = (0, $8396d1566d56485e$export$d3d0694a1d2def88)();
    const active = !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(windows, {
        id: foWindow
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499d669e091e4996$export$2e2bcd8739ae039), {
            placement: "right",
            title: tooltip,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                size: "small",
                active: active,
                onClick: ()=>handleClick(foWindow),
                children: children
            })
        })
    });
}
var $d059b7c482dc88ca$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($d059b7c482dc88ca$var$NavButton).attrs({
    className: $d059b7c482dc88ca$var$NavButton.name
})`
  margin-top: 16px;
`;


var $6c12fa5e0b6a42d2$exports = {};
"use strict";

Object.defineProperty($6c12fa5e0b6a42d2$exports, "__esModule", {
    value: true
});
$6c12fa5e0b6a42d2$exports.default = void 0;

var $6c12fa5e0b6a42d2$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6c12fa5e0b6a42d2$var$_default = (0, $6c12fa5e0b6a42d2$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m12 2-5.5 9h11z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "17.5",
        cy: "17.5",
        r: "4.5"
    }, "1"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M3 13.5h8v8H3z"
    }, "2")
], "Category");
$6c12fa5e0b6a42d2$exports.default = $6c12fa5e0b6a42d2$var$_default;



var $e05ccb3ca0c06c32$exports = {};
"use strict";

Object.defineProperty($e05ccb3ca0c06c32$exports, "__esModule", {
    value: true
});
$e05ccb3ca0c06c32$exports.default = void 0;

var $e05ccb3ca0c06c32$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e05ccb3ca0c06c32$var$_default = (0, $e05ccb3ca0c06c32$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM9.1 17H7v-2.14l5.96-5.96 2.12 2.12L9.1 17zm7.75-7.73-1.06 1.06-2.12-2.12 1.06-1.06c.2-.2.51-.2.71 0l1.41 1.41c.2.2.2.51 0 .71z"
}), "NoteAlt");
$e05ccb3ca0c06c32$exports.default = $e05ccb3ca0c06c32$var$_default;





function $bdd79db2b065dd58$export$ea18af249ae1fbd0(width, height, filename) {
    var mapCanvas = document.createElement("canvas");
    mapCanvas.width = width;
    mapCanvas.height = height;
    var mapContext = mapCanvas.getContext("2d");
    document.querySelectorAll(".ol-layer canvas").forEach((canvas)=>{
        if (canvas.width > 0) {
            var transform = canvas.style.transform;
            mapContext.fillStyle = "#525252";
            mapContext.fillRect(0, 0, canvas.width, canvas.height);
            // Get the transform parameters from the style's transform matrix
            var matrix = transform.match(/^matrix\(([^\\(]*)\)$/)[1].split(",").map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
            mapContext.drawImage(canvas, 0, 0);
        }
    });
    const img = mapCanvas.toDataURL("image/png");
    (0, $90f256c567e4c320$exports.saveAs)(img, `${filename}.png`);
}
function $bdd79db2b065dd58$export$cfcadda4907cb91f(map, filename) {
    return new Promise((resolve)=>{
        map.once("rendercomplete", function() {
            const mapCanvas = document.createElement("canvas");
            const size = map.getSize();
            mapCanvas.width = size[0];
            mapCanvas.height = size[1];
            const mapContext = mapCanvas.getContext("2d");
            Array.prototype.forEach.call(map.getViewport().querySelectorAll(".ol-layer canvas, canvas.ol-layer"), function(canvas) {
                if (canvas.width > 0) {
                    const opacity = canvas.parentNode.style.opacity || canvas.style.opacity;
                    mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);
                    let matrix;
                    const transform = canvas.style.transform;
                    if (transform) // Get the transform parameters from the style's transform matrix
                    matrix = transform.match(/^matrix\(([^(]*)\)$/)[1].split(",").map(Number);
                    else matrix = [
                        parseFloat(canvas.style.width) / canvas.width,
                        0,
                        0,
                        parseFloat(canvas.style.height) / canvas.height,
                        0,
                        0
                    ];
                    // Apply the transform to the export map context
                    CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
                    const backgroundColor = canvas.parentNode.style.backgroundColor;
                    if (backgroundColor) {
                        mapContext.fillStyle = backgroundColor;
                        mapContext.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    mapContext.drawImage(canvas, 0, 0);
                }
            });
            mapContext.globalAlpha = 1;
            mapContext.setTransform(1, 0, 0, 1, 0, 0);
            const img = mapCanvas.toDataURL("image/png");
            (0, $90f256c567e4c320$exports.saveAs)(img, `${filename}.png`);
            resolve(null);
        });
        map.renderSync();
    });
}








var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");
var $279a88221582c7c4$exports = {};
"use strict";
var $279a88221582c7c4$var$__extends = $279a88221582c7c4$exports && $279a88221582c7c4$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $279a88221582c7c4$var$__assign = $279a88221582c7c4$exports && $279a88221582c7c4$exports.__assign || function() {
    $279a88221582c7c4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $279a88221582c7c4$var$__assign.apply(this, arguments);
};
var $279a88221582c7c4$var$__createBinding = $279a88221582c7c4$exports && $279a88221582c7c4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $279a88221582c7c4$var$__setModuleDefault = $279a88221582c7c4$exports && $279a88221582c7c4$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $279a88221582c7c4$var$__importStar = $279a88221582c7c4$exports && $279a88221582c7c4$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $279a88221582c7c4$var$__createBinding(result, mod, k);
    }
    $279a88221582c7c4$var$__setModuleDefault(result, mod);
    return result;
};
var $279a88221582c7c4$var$__importDefault = $279a88221582c7c4$exports && $279a88221582c7c4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($279a88221582c7c4$exports, "__esModule", {
    value: true
});

var $ayMG0 = parcelRequire("ayMG0");

var $279a88221582c7c4$var$react_1 = $279a88221582c7c4$var$__importStar((parcelRequire("acw62")));

var $279a88221582c7c4$var$winbox_1 = $279a88221582c7c4$var$__importDefault((parcelRequire("eRV67")));

var $279a88221582c7c4$var$react_dom_1 = $279a88221582c7c4$var$__importDefault((parcelRequire("1u0KT")));
/**
 * # WinBox React Component
 *
 * @see https://github.com/rickonono3/react-winbox
 * @see https://github.com/nextapps-de/winbox
 */ var $279a88221582c7c4$var$WinBox = /** @class */ function(_super) {
    $279a88221582c7c4$var$__extends(WinBox, _super);
    function WinBox(props) {
        var _this = _super.call(this, props) || this;
        _this.cdmCount = 0;
        _this.checkReactVersionGE18 = function() {
            var a = parseInt($279a88221582c7c4$var$react_1.default.version.split(".")[0]);
            return a >= 18;
        };
        _this.getId = function() {
            var _a;
            return (_a = _this.winBoxObj) === null || _a === void 0 ? void 0 : _a.id;
        };
        _this.getIndex = function() {
            var _a;
            return (_a = _this.winBoxObj) === null || _a === void 0 ? void 0 : _a.index;
        };
        _this.getPosition = function() {
            if (_this.winBoxObj) return {
                x: _this.winBoxObj.x,
                y: _this.winBoxObj.y
            };
            return undefined;
        };
        _this.getSize = function() {
            if (_this.winBoxObj) return {
                width: _this.winBoxObj.width,
                height: _this.winBoxObj.height
            };
            return undefined;
        };
        _this.getSizeLimit = function() {
            if (_this.winBoxObj) return {
                minWidth: _this.winBoxObj.minwidth,
                minHeight: _this.winBoxObj.minheight,
                maxWidth: _this.winBoxObj.maxwidth,
                maxHeight: _this.winBoxObj.maxheight
            };
            return undefined;
        };
        _this.getViewportBoundary = function() {
            if (_this.winBoxObj) return {
                top: _this.winBoxObj.top,
                right: _this.winBoxObj.right,
                bottom: _this.winBoxObj.bottom,
                left: _this.winBoxObj.left
            };
            return undefined;
        };
        _this.isFocused = function() {
            var _a, _b;
            return (_b = (_a = _this.winBoxObj) === null || _a === void 0 ? void 0 : _a.focused) !== null && _b !== void 0 ? _b : false;
        };
        _this.isHidden = function() {
            var _a, _b;
            return (_b = (_a = _this.winBoxObj) === null || _a === void 0 ? void 0 : _a.hidden) !== null && _b !== void 0 ? _b : false;
        };
        _this.isMax = function() {
            var _a, _b;
            return (_b = (_a = _this.winBoxObj) === null || _a === void 0 ? void 0 : _a.max) !== null && _b !== void 0 ? _b : false;
        };
        _this.isMin = function() {
            var _a, _b;
            return (_b = (_a = _this.winBoxObj) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : false;
        };
        _this.isFullscreen = function() {
            var _a, _b;
            return (_b = (_a = _this.winBoxObj) === null || _a === void 0 ? void 0 : _a.full) !== null && _b !== void 0 ? _b : false;
        };
        _this.isClosed = function() {
            return _this.state.closed;
        };
        _this.focus = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.focus();
        };
        _this.blur = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.blur();
        };
        /** We suggest using `min` prop instead of this method. If you have to forcely refresh the winbox's state, may `forceUpdate` would be better?*/ _this.minimize = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.minimize();
        };
        /** We suggest using `max` prop instead of this method. If you have to forcely refresh the winbox's state, may `forceUpdate` would be better?*/ _this.maximize = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.maximize();
        };
        /** We suggest using `fullscreen` prop instead of this method. If you have to forcely refresh the winbox's state, may `forceUpdate` would be better?*/ _this.fullscreen = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.fullscreen();
        };
        /** We suggest using `max`/`min`/`fullscreen` props instead of this method. If you have to forcely refresh the winbox's state, may `forceUpdate` would be better?*/ _this.restore = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.restore();
        };
        /** We suggest using `hide` props instead of this method. If you have to forcely refresh the winbox's state, may `forceUpdate` would be better?*/ _this.hide = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.hide();
        };
        /** We suggest using `hide` props instead of this method. If you have to forcely refresh the winbox's state, may `forceUpdate` would be better?*/ _this.show = function() {
            var _a;
            (_a = _this.winBoxObj) === null || _a === void 0 || _a.show();
        };
        _this.maintainStyle = function() {
            if (!_this.winBoxObj) return;
            _this.winBoxObj[_this.props.noAnimation ? "addClass" : "removeClass"]("no-animation");
            _this.winBoxObj[_this.props.noClose ? "addClass" : "removeClass"]("no-close");
            _this.winBoxObj[_this.props.noFull ? "addClass" : "removeClass"]("no-full");
            _this.winBoxObj[_this.props.noMin ? "addClass" : "removeClass"]("no-min");
            _this.winBoxObj[_this.props.noMax ? "addClass" : "removeClass"]("no-max");
            _this.winBoxObj[_this.props.noMove ? "addClass" : "removeClass"]("no-move");
            _this.winBoxObj[_this.props.noHeader ? "addClass" : "removeClass"]("no-header");
            _this.winBoxObj[_this.props.noResize ? "addClass" : "removeClass"]("no-resize");
            _this.winBoxObj[_this.props.noShadow ? "addClass" : "removeClass"]("no-shadow");
            _this.winBoxObj[_this.props.modal ? "addClass" : "removeClass"]("modal");
            _this.winBoxObj[_this.props.hide ? "addClass" : "removeClass"]("hide");
        };
        _this.maintain = function(args) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            if (!_this.winBoxObj) return;
            var _o = args !== null && args !== void 0 ? args : {}, force = _o.force, prevProps = _o.prevProps;
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.title) !== _this.props.title) {
                if (typeof _this.props.title === "string") _this.winBoxObj.setTitle(_this.props.title);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.icon) !== _this.props.icon) {
                if (typeof _this.props.icon === "string") _this.winBoxObj.setIcon(_this.props.icon);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.url) !== _this.props.url) {
                if (_this.props.url != undefined) _this.winBoxObj.setUrl(_this.props.url);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.background) !== _this.props.background) {
                if (_this.props.background != undefined) _this.winBoxObj.setBackground(_this.props.background);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.minWidth) !== _this.props.minWidth || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.minHeight) !== _this.props.minHeight || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.maxWidth) !== _this.props.maxWidth || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.maxHeight) !== _this.props.maxHeight) {
                var minWidth = (_a = _this.props.minWidth) !== null && _a !== void 0 ? _a : _this.winBoxObj.minwidth;
                var minHeight = (_b = _this.props.minHeight) !== null && _b !== void 0 ? _b : _this.winBoxObj.minheight;
                var maxWidth = (_c = _this.props.maxWidth) !== null && _c !== void 0 ? _c : _this.winBoxObj.maxwidth;
                var maxHeight = (_d = _this.props.maxHeight) !== null && _d !== void 0 ? _d : _this.winBoxObj.maxheight;
                _this.winBoxObj.minwidth = minWidth;
                _this.winBoxObj.minheight = minHeight;
                _this.winBoxObj.maxwidth = maxWidth;
                _this.winBoxObj.maxheight = maxHeight;
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.width) !== _this.props.width || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.height) !== _this.props.height) {
                var width = (_e = _this.props.width) !== null && _e !== void 0 ? _e : _this.winBoxObj.width;
                var height = (_f = _this.props.height) !== null && _f !== void 0 ? _f : _this.winBoxObj.height;
                // use function params rather than assigning fields directly to avoid the 'just support numbers' feature
                // see https://github.com/nextapps-de/winbox#custom-position--size
                _this.winBoxObj.resize(width, height);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.x) !== _this.props.x || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.y) !== _this.props.y) {
                var x = (_g = _this.props.x) !== null && _g !== void 0 ? _g : _this.winBoxObj.x;
                var y = (_h = _this.props.y) !== null && _h !== void 0 ? _h : _this.winBoxObj.y;
                // use function params rather than assigning fields directly to avoid the 'just support numbers' feature
                // see https://github.com/nextapps-de/winbox#custom-position--size
                _this.winBoxObj.move(x, y);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.top) !== _this.props.top || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.right) !== _this.props.right || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.bottom) !== _this.props.bottom || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.left) !== _this.props.left) {
                _this.winBoxObj.top = (_j = _this.props.top) !== null && _j !== void 0 ? _j : _this.winBoxObj.top;
                _this.winBoxObj.right = (_k = _this.props.right) !== null && _k !== void 0 ? _k : _this.winBoxObj.right;
                _this.winBoxObj.bottom = (_l = _this.props.bottom) !== null && _l !== void 0 ? _l : _this.winBoxObj.bottom;
                _this.winBoxObj.left = (_m = _this.props.left) !== null && _m !== void 0 ? _m : _this.winBoxObj.left;
                _this.winBoxObj.move();
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.fullscreen) !== _this.props.fullscreen) {
                if (_this.props.fullscreen != undefined) _this.winBoxObj.fullscreen(_this.props.fullscreen);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.min) !== _this.props.min) {
                if (_this.props.min != undefined) _this.winBoxObj.minimize(_this.props.min);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.max) !== _this.props.max) {
                if (_this.props.max != undefined) _this.winBoxObj.maximize(_this.props.max);
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.className) !== _this.props.className) {
                if ((prevProps === null || prevProps === void 0 ? void 0 : prevProps.className) != undefined) {
                    var classes = prevProps.className.replaceAll(/\s+/g, " ").split(" ").filter(function(c) {
                        return c != "";
                    });
                    for(var _i = 0, classes_1 = classes; _i < classes_1.length; _i++){
                        var c = classes_1[_i];
                        if (_this.winBoxObj.hasClass(c)) _this.winBoxObj.removeClass(c);
                    }
                }
                if (_this.props.className != undefined) {
                    var classes = _this.props.className.replaceAll(/\s+/g, " ").split(" ").filter(function(c) {
                        return c != "";
                    });
                    for(var _p = 0, classes_2 = classes; _p < classes_2.length; _p++){
                        var c = classes_2[_p];
                        if (!_this.winBoxObj.hasClass(c)) _this.winBoxObj.addClass(c);
                    }
                }
            }
            if (force || (prevProps === null || prevProps === void 0 ? void 0 : prevProps.customControls) !== _this.props.customControls && !$279a88221582c7c4$var$deepEqual(prevProps === null || prevProps === void 0 ? void 0 : prevProps.customControls, _this.props.customControls)) {
                if ((prevProps === null || prevProps === void 0 ? void 0 : prevProps.customControls) != undefined) prevProps.customControls.filter(function(o) {
                    return typeof o === "object" && o.class;
                }).forEach(function(o) {
                    return _this.winBoxObj.removeControl(o.class);
                });
                if (_this.props.customControls != undefined) _this.props.customControls.filter(function(o) {
                    return typeof o === "object" && o.class;
                }).forEach(function(o) {
                    return _this.winBoxObj.addControl(o);
                });
            }
            _this.maintainStyle();
        };
        _this.handleClose = function() {
            _this.winBoxObj = undefined;
            _this.setState({
                closed: true
            });
        };
        _this.state = {
            closed: false
        };
        _this.winBoxObj = undefined;
        return _this;
    }
    WinBox.prototype.componentDidMount = function() {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.cdmCount++;
        if (this.checkReactVersionGE18()) {
            if (this.cdmCount >= 2) return;
        }
        try {
            if (this.props.id !== undefined && this.props.id !== null && document.getElementById(this.props.id)) throw "duplicated window id";
            this.winBoxObj = $279a88221582c7c4$var$winbox_1.default.new($279a88221582c7c4$var$__assign($279a88221582c7c4$var$__assign({
                width: 300,
                height: 200,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                hidden: this.props.hide
            }, this.props), {
                // 👇override values
                minwidth: (_a = this.props.minWidth) !== null && _a !== void 0 ? _a : 150,
                maxwidth: (_b = this.props.maxWidth) !== null && _b !== void 0 ? _b : 2147483647,
                minheight: (_c = this.props.minHeight) !== null && _c !== void 0 ? _c : 35,
                maxheight: (_d = this.props.maxHeight) !== null && _d !== void 0 ? _d : 2147483647,
                max: false,
                min: false,
                fullscreen: false,
                class: "" + ((_e = this.props.className) !== null && _e !== void 0 ? _e : ""),
                onclose: function(force) {
                    var _a, _b, _c, _d;
                    if ((_b = (_a = _this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, force !== null && force !== void 0 ? force : false)) return true;
                    else if ((_d = (_c = _this.props).onclose) === null || _d === void 0 ? void 0 : _d.call(_c, force !== null && force !== void 0 ? force : false)) return true;
                    _this.handleClose(); // only when false, run close process.
                    return false;
                },
                onmove: (_f = this.props.onMove) !== null && _f !== void 0 ? _f : this.props.onmove,
                onresize: (_g = this.props.onResize) !== null && _g !== void 0 ? _g : this.props.onresize,
                onblur: (_h = this.props.onBlur) !== null && _h !== void 0 ? _h : this.props.onblur,
                onfocus: (_j = this.props.onFocus) !== null && _j !== void 0 ? _j : this.props.onfocus,
                oncreate: this.props.onCreate,
                onfullscreen: this.props.onFullscreen,
                onminimize: this.props.onMinimize,
                onmaximize: this.props.onMaximize,
                onrestore: this.props.onRestore,
                onhide: this.props.onHide,
                onshow: this.props.onShow
            }));
            setTimeout(function() {
                _this.forceUpdate();
            });
        } catch (e) {
            console.error(e);
        //this.winBoxObj?.close(true);
        //this.setState({ closed: true });
        }
    };
    WinBox.prototype.componentDidUpdate = function(prevProps, prevState) {
        this.maintain({
            prevProps: prevProps
        });
    };
    WinBox.prototype.componentWillUnmount = function() {
        var _this = this;
        var _a, _b;
        try {
            if (this.checkReactVersionGE18()) {
                if (this.cdmCount <= 1) setTimeout(function() {
                    var _a;
                    if (_this.cdmCount <= 1) (_a = _this.winBoxObj) === null || _a === void 0 || _a.close(true);
                }, 100);
                else (_a = this.winBoxObj) === null || _a === void 0 || _a.close(true);
            } else (_b = this.winBoxObj) === null || _b === void 0 || _b.close(true);
        } catch (ignored) {}
    };
    WinBox.prototype.forceUpdate = function(callback) {
        try {
            this.maintain({
                force: true
            });
        } catch (e) {
            console.error(e);
        //this.winBoxObj?.close(true);
        //this.setState({ closed: true });
        }
        _super.prototype.forceUpdate.call(this, callback);
    };
    WinBox.prototype.render = function() {
        if (Object.keys(this.props).indexOf("url") !== -1 && this.props.url) return null; // do nothing if url is set.
        if (!this.winBoxObj || !this.winBoxObj.body) return null;
        return $279a88221582c7c4$var$react_dom_1.default.createPortal($ayMG0.jsx($ayMG0.Fragment, {
            children: this.props.children
        }, void 0), this.winBoxObj.body);
    };
    return WinBox;
}($279a88221582c7c4$var$react_1.Component);
$279a88221582c7c4$exports.default = $279a88221582c7c4$var$WinBox;
function $279a88221582c7c4$var$deepEqual(x, y) {
    var ok = Object.keys, tx = typeof x, ty = typeof y;
    return x && y && tx === "object" && tx === ty ? ok(x).length === ok(y).length && ok(x).every(function(key) {
        return $279a88221582c7c4$var$deepEqual(x[key], y[key]);
    }) : x === y;
}








var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




function $15725ec70269d49f$export$a79da0264a099529({ airbases: airbases, onClick: onClick, extra: extra }) {
    const cols = [
        {
            label: "Name",
            // value: (b: Airbase) => handleClick(b),
            value: (b)=>onClick ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    onClick: ()=>onClick(b),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            width: 96,
                            textAlign: "left",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        },
                        children: b.Name
                    })
                }) : "Name"
        },
        {
            label: "Frequency",
            value: (a)=>{
                const freq = a.UHF || a.VHF;
                return freq ? (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(freq) : "";
            }
        },
        {
            label: "TACAN",
            value: "TACAN"
        }
    ];
    if (extra) {
        cols.push({
            label: "Runways",
            value: "Runways"
        });
        cols.push({
            label: "ILS",
            value: (a)=>{
                const ils = a.ILS;
                const s = ils.map((r)=>r.replace(/RWY/g, "").replace("/", ":  ").replace(/\/\d*/g, ""));
                return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(s, (s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: s
                        }, i))
                });
            }
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
        stickyHeader: true,
        size: "small",
        columns: cols,
        rows: airbases
    });
}
var $15725ec70269d49f$export$2e2bcd8739ae039 = ()=>{
    const { state: state, dispatch: dispatch } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($15725ec70269d49f$export$a79da0264a099529, {
        airbases: state.tasking.airbases,
        onClick: (b)=>{
            dispatch({
                type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
                layerName: (0, $91a9098e14452db2$export$fb028bc55343bb1f).Bases,
                name: b.Name,
                otherFeatures: []
            });
        }
    });
};



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



function $3f418b8316ffcee8$var$AircraftList({ className: className }) {
    const { state: { tasking: { plannedGroups: plannedGroups } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const colors = (0, $99f46708ff5ed621$export$6af74cd118fd0c5d)();
    const rows = [];
    for (const group of plannedGroups)for(let index = 0; index < group.units.length; index++){
        const unit = group.units[index];
        rows.push({
            ...unit,
            groupName: group.name,
            index: index,
            color: colors[group.name]
        });
    }
    const elrows = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(rows, (u)=>{
        const rowSpan = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(plannedGroups, {
            name: u.groupName
        }).units.length;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
            children: [
                u.index === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                            style: {
                                color: u.color
                            },
                            rowSpan: rowSpan,
                            children: u.groupName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                            style: {
                                color: u.color
                            },
                            rowSpan: rowSpan,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, $b9c9d9c1adf94aca$export$cc2c248003684daa), [
                                u.type,
                                "label"
                            ]) || u.type
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                    style: {
                        color: u.color
                    },
                    children: [
                        u.groupName,
                        "-",
                        u.index + 1
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                    style: {
                        color: u.color
                    },
                    children: u?.aircraftProps?.STN_L16 || u?.aircraftProps?.OwnshipCallSign
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                    style: {
                        color: u.color
                    },
                    children: u.laserCode
                })
            ]
        }, u.name);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                children: "Group"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                children: "Type"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                children: "Flight Member"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                children: "Datalink STN"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                children: "Laser Code"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                    children: elrows
                })
            ]
        })
    });
}
var $3f418b8316ffcee8$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($3f418b8316ffcee8$var$AircraftList).attrs({
    className: $3f418b8316ffcee8$var$AircraftList.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");







function $57b9a223ad7c79e6$var$a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`
    };
}
function $57b9a223ad7c79e6$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tabpanel",
        style: {
            width: "100%",
            marginLeft: 8,
            marginTop: 8
        },
        hidden: value !== index,
        id: `vertical-tabpanel-${index}`,
        "aria-labelledby": `vertical-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            center: true,
            children: children
        })
    });
}
const $57b9a223ad7c79e6$var$StyledTab = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039))`
  &.MuiButtonBase-root {
    white-space: nowrap;
    justify-content: center;
    align-items: flex-start;
  }

  .tab-text {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;
function $57b9a223ad7c79e6$var$AssetPreview({ className: className }) {
    const { state: { manifest: manifest, assetViewer: { open: open } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const { data: assets } = (0, $de1274ee98092164$export$7744273c9977e539)(manifest.id);
    const [selected, setSelected] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        let params = new URLSearchParams(history.location.search);
        if (open) params.set((0, $91a9098e14452db2$export$895cfaa78f9f7717), "true");
        else params.delete((0, $91a9098e14452db2$export$895cfaa78f9f7717));
        history.replace({
            pathname: history.location.pathname,
            search: params.toString()
        });
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        p: 0,
        sx: {
            flexGrow: 1,
            display: "flex"
        },
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                column: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 1,
                        marginRight: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            align: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    marginRight: 1
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    style: {
                                        textAlign: "left"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Uploaded Kneeboards"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                        orientation: "vertical",
                        variant: "scrollable",
                        value: selected,
                        onChange: (ev, v)=>setSelected(v),
                        "aria-label": "Vertical tabs example",
                        sx: {
                            borderRight: 1,
                            borderColor: "divider",
                            overflow: "auto"
                        },
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(assets, (a, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($57b9a223ad7c79e6$var$StyledTab, {
                                value: i,
                                style: {
                                    textAlign: "left"
                                },
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tab-text",
                                    children: a.displayName
                                }),
                                ...$57b9a223ad7c79e6$var$a11yProps(i)
                            }, a.displayName))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(assets, (a, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($57b9a223ad7c79e6$var$TabPanel, {
                        value: selected,
                        index: i,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9377b6a19a671ff7$export$2e2bcd8739ae039), {
                            manifest: manifest,
                            style: {
                                border: "1px solid black"
                            },
                            asset: a
                        })
                    }, a.displayName))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexGrow: 2
                },
                children: assets?.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    center: true,
                    wide: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginTop: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            fontStyle: "italic",
                            children: "No Kneeboards Uploaded"
                        })
                    })
                })
            })
        ]
    });
}
var $57b9a223ad7c79e6$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($57b9a223ad7c79e6$var$AssetPreview).attrs({
    className: $57b9a223ad7c79e6$var$AssetPreview.name
})`
  ${(0, $9377b6a19a671ff7$export$2e2bcd8739ae039)} img {
    max-width: 100%;
  }

  height: 100%;
`;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
var $445092e407fd8a1c$exports = {};
"use strict";

Object.defineProperty($445092e407fd8a1c$exports, "__esModule", {
    value: true
});
$445092e407fd8a1c$exports.default = void 0;

var $445092e407fd8a1c$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $445092e407fd8a1c$var$_default = (0, $445092e407fd8a1c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
}), "Circle");
$445092e407fd8a1c$exports.default = $445092e407fd8a1c$var$_default;


var $87a7c79c2a1f59b1$exports = {};
"use strict";

Object.defineProperty($87a7c79c2a1f59b1$exports, "__esModule", {
    value: true
});
$87a7c79c2a1f59b1$exports.default = void 0;

var $87a7c79c2a1f59b1$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $87a7c79c2a1f59b1$var$_default = (0, $87a7c79c2a1f59b1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m2 9 4 12h12l4-12-10-7z"
}), "Pentagon");
$87a7c79c2a1f59b1$exports.default = $87a7c79c2a1f59b1$var$_default;


var $9c123eea4a9d405e$exports = {};
"use strict";

Object.defineProperty($9c123eea4a9d405e$exports, "__esModule", {
    value: true
});
$9c123eea4a9d405e$exports.default = void 0;

var $9c123eea4a9d405e$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c123eea4a9d405e$var$_default = (0, $9c123eea4a9d405e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 3h18v18H3z"
}), "Square");
$9c123eea4a9d405e$exports.default = $9c123eea4a9d405e$var$_default;


var $42a5c91e49557133$exports = {};
"use strict";

Object.defineProperty($42a5c91e49557133$exports, "__esModule", {
    value: true
});
$42a5c91e49557133$exports.default = void 0;

var $42a5c91e49557133$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $42a5c91e49557133$var$_default = (0, $42a5c91e49557133$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
}), "Timeline");
$42a5c91e49557133$exports.default = $42a5c91e49557133$var$_default;







var $acw62 = parcelRequire("acw62");



var $80a07fceae0f1fd4$export$d4d04d258ed667e3;
(function(ControlMeasureStatus) {
    ControlMeasureStatus["Draft"] = "draft";
    ControlMeasureStatus["Published"] = "published";
})($80a07fceae0f1fd4$export$d4d04d258ed667e3 || ($80a07fceae0f1fd4$export$d4d04d258ed667e3 = {}));
class $80a07fceae0f1fd4$export$d08309b3b3244f27 {
}





var $db8faf6665f46ff1$exports = {};
"use strict";

Object.defineProperty($db8faf6665f46ff1$exports, "__esModule", {
    value: true
});
$db8faf6665f46ff1$exports.default = void 0;

var $db8faf6665f46ff1$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $db8faf6665f46ff1$var$_default = (0, $db8faf6665f46ff1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), "Place");
$db8faf6665f46ff1$exports.default = $db8faf6665f46ff1$var$_default;


var $79198328c24eed20$var$ControlMeasureTool;
(function(ControlMeasureTool) {
    ControlMeasureTool["None"] = "None";
    ControlMeasureTool["Line"] = "LineString";
    ControlMeasureTool["Polygon"] = "Polygon";
    ControlMeasureTool["Circle"] = "Circle";
    ControlMeasureTool["Box"] = "Box";
    ControlMeasureTool["Point"] = "Point";
})($79198328c24eed20$var$ControlMeasureTool || ($79198328c24eed20$var$ControlMeasureTool = {}));
// Ensures that each control measure has a unique name
function $79198328c24eed20$var$makeID(length = 5) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while(counter < length){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}
function $79198328c24eed20$var$generateControlMeasureName() {
    const name = `Control Measure-${$79198328c24eed20$var$makeID()}`;
    return name;
}
function $79198328c24eed20$var$ControlMeasureInput({ className: className, onAddControlMeasure: onAddControlMeasure }) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const manifestID = (0, $0a53c1f23450367c$export$690fab4e9789b198)();
    const interaction = $acw62.useRef(null);
    const sourceRef = $acw62.useRef(null);
    const [selectedTool, setSelectedTool] = $acw62.useState("None");
    $acw62.useEffect(()=>{
        if (!map) return;
        if (selectedTool === "None") {
            map.removeInteraction(interaction.current);
            return;
        }
        const source = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)();
        let draw;
        if (selectedTool === "Box") // We want the resize behavior to be more like the circle tool
        // https://openlayers.org/en/latest/examples/draw-shapes.html
        draw = new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
            type: "Circle",
            source: source,
            geometryFunction: (0, $55fa2487efb2d4e1$export$6459fc9e86be362e)(),
            condition: (e)=>!(0, $9c554d6df7d74017$export$8a7ef89a0633946c)(e) || !e.dragging
        });
        else draw = new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
            type: selectedTool,
            source: source,
            condition: (e)=>!(0, $9c554d6df7d74017$export$8a7ef89a0633946c)(e) || !e.dragging
        });
        draw.on("drawend", (e)=>{
            const feature = e.feature;
            const cm = {
                manifestID: manifestID,
                name: $79198328c24eed20$var$generateControlMeasureName(),
                geometry: feature.getGeometry(),
                status: (0, $80a07fceae0f1fd4$export$d4d04d258ed667e3).Draft,
                color: "#000000",
                description: ""
            };
            onAddControlMeasure(cm);
        });
        map.addInteraction(draw);
        const modify = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
            source: source
        });
        map.addInteraction(modify);
        // @ts-ignore
        map.on("pointerup", (e)=>{
            if ((0, $9c554d6df7d74017$export$8a7ef89a0633946c)(e)) {
                map.removeInteraction(draw);
                map.removeInteraction(modify);
                setSelectedTool("None");
                return;
            }
        });
        interaction.current = draw;
        sourceRef.current = source;
    }, [
        selectedTool
    ]);
    const handleSelectTool = (tool)=>{
        if (tool === selectedTool) {
            setSelectedTool("None");
            return;
        }
        setSelectedTool(tool);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            align: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: "Draw Line",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                        active: selectedTool === "LineString",
                        onClick: ()=>handleSelectTool("LineString"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42a5c91e49557133$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: "Draw Polygon",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                        active: selectedTool === "Polygon",
                        onClick: ()=>handleSelectTool("Polygon"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87a7c79c2a1f59b1$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: "Draw Circle",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                        active: selectedTool === "Circle",
                        onClick: ()=>handleSelectTool("Circle"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($445092e407fd8a1c$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: "Draw Rectangle",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                        active: selectedTool === "Box",
                        onClick: ()=>handleSelectTool("Box"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c123eea4a9d405e$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                    title: "Draw Point",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                        active: selectedTool === "Point",
                        onClick: ()=>handleSelectTool("Point"),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($db8faf6665f46ff1$exports))), {})
                    })
                })
            ]
        })
    });
}
var $79198328c24eed20$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($79198328c24eed20$var$ControlMeasureInput).attrs({
    className: $79198328c24eed20$var$ControlMeasureInput.name
})`
  ${(0, $3fe6920ef40d5760$export$2e2bcd8739ae039)} {
    box-shadow: none;
    border: 1px solid #818080;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");







function $2b9540cb0c01452c$var$ControlMeasureList({ className: className }) {
    const isDrawingAllowed = (0, $99f46708ff5ed621$export$4221ea9241cbaab6)();
    const isOwner = (0, $302106ffa43351a6$export$be66956e5fa7746a)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const manifestID = (0, $0a53c1f23450367c$export$690fab4e9789b198)();
    const { state: { focusedFeature: focusedFeature } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const focus = (0, $99f46708ff5ed621$export$a1854f3defd0f515)();
    const blur = (0, $99f46708ff5ed621$export$19df1d269fc1c6e9)();
    const { data: controlMeasures } = (0, $302106ffa43351a6$export$5dad9a454d8c40c0)(manifestID);
    const [deleting, setDeleting] = $acw62.useState(null);
    const remove = (0, $302106ffa43351a6$export$b02902a51cce2283)();
    const handleDelete = (cm)=>{
        if (window.confirm("Are you sure you want to delete this control measure?")) {
            setDeleting(cm);
            remove(cm).then(()=>success(`${cm.name} deleted`)).catch((e)=>{
                console.error(e);
                error(`Error deleting control measure: ${e.message}`);
            }).finally(()=>{
                setDeleting(null);
            });
        }
        if (focusedFeature?.layerName === (0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlMeasures && focusedFeature?.name === cm.name) blur();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            columns: [
                {
                    label: "Name",
                    value: (cm)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            style: {
                                color: cm.color
                            },
                            onClick: ()=>{
                                focus((0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlMeasures, cm.name);
                            },
                            children: cm.name
                        })
                },
                {
                    value: (cm)=>isDrawingAllowed && isOwner(cm) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                            loading: deleting === cm,
                            color: "error",
                            onClick: ()=>handleDelete(cm),
                            variant: "outlined",
                            children: "Delete"
                        }) : null,
                    label: ""
                }
            ],
            rows: controlMeasures
        })
    });
}
var $2b9540cb0c01452c$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($2b9540cb0c01452c$var$ControlMeasureList).attrs({
    className: $2b9540cb0c01452c$var$ControlMeasureList.name
})``;


function $4d33bb5e5a628327$var$ControlMeasuresWindow({ className: className }) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const isLoggedIn = !!currentUser;
    const isDrawingAllowed = (0, $99f46708ff5ed621$export$4221ea9241cbaab6)();
    const add = (0, $302106ffa43351a6$export$598f3fe495c47e)();
    const { success: success } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const handleAdd = (cm)=>{
        add.mutateAsync(cm).then(()=>{
            success("Control Measure added successfully");
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            isDrawingAllowed && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $79198328c24eed20$export$2e2bcd8739ae039), {
                            onAddControlMeasure: handleAdd
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                p: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b9540cb0c01452c$export$2e2bcd8739ae039), {})
            }),
            !isLoggedIn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                m: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                    style: {
                        justifyContent: "center"
                    },
                    severity: "info",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe9496169f0560d$export$2e2bcd8739ae039), {
                            children: "Not Logged In"
                        }),
                        "You must be logged in to add control measures. The Frag Order admin must give permission for editing control measures.",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            wide: true,
                            center: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5e8911e4b30dc90$export$2e2bcd8739ae039), {
                                style: {
                                    maxWidth: 240
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $4d33bb5e5a628327$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($4d33bb5e5a628327$var$ControlMeasuresWindow).attrs({
    className: $4d33bb5e5a628327$var$ControlMeasuresWindow.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");



parcelRequire("acw62");



const $362645194f3afb6f$var$color = "#000";
const $362645194f3afb6f$var$styles = ()=>(feature)=>{
        return [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: 'bold 14px "Roboto", "Arial Unicode MS", "sans-serif"',
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: $362645194f3afb6f$var$color
                    }),
                    text: feature.get("elementNum"),
                    offsetY: 24,
                    backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: "#ffffffbd"
                    })
                })
            }),
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                    opacity: 1,
                    src: "data:image/svg+xml;utf8," + new (0, (/*@__PURE__*/$parcel$interopDefault($e786e20e25c5f221$exports))).Symbol((0, $75a1e531b08ffb65$export$af576a01257ae419)(false, feature.get("category")), {
                        size: 16
                    }, {
                        infoSize: 48
                    }).asSVG(),
                    scale: 1
                }),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: 'bold 14px "Roboto", "Arial Unicode MS", "sans-serif"',
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: $362645194f3afb6f$var$color
                    }),
                    text: feature.get("group"),
                    offsetY: -24,
                    backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: "#ffffffbd"
                    })
                })
            })
        ];
    };
function $362645194f3afb6f$export$2e2bcd8739ae039({ groups: groups, theater: theater, airbase: airbase }) {
    const features = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(groups, (group)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(group.units, (unit)=>{
            const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
                x: unit.x,
                y: unit.y
            });
            const geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                long,
                lat
            ]);
            const numbersRegex = /\d+/g;
            const [num] = unit.callsign.match(numbersRegex);
            const elementNum = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(num?.split(""), [
                1
            ]);
            const f = {
                geometry: geometry,
                name: unit.name,
                callsign: unit.callsign,
                type: unit.type,
                group: group.name,
                elementNum: elementNum,
                category: group.category
            };
            features.push(f);
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        style: $362645194f3afb6f$var$styles(),
        features: features,
        name: `${airbase.Name}/Parking`
    });
}



function $861fc78f813d6070$var$AirportDiagram({ className: className, theater: theater, airbase: airbase, groups: groups }) {
    const hasGroups = groups.length > 0;
    const extent = hasGroups ? (0, $1cf8f597a58d4025$export$aacd22ce05963fb1)(theater, groups) : (0, $1cf8f597a58d4025$export$e87e5ed6e6e32a15)(theater, [
        airbase
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49838b21bfe24b63$export$2e2bcd8739ae039), {
            zoomAdjust: hasGroups ? -0.2 : -14.5,
            extent: extent,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $362645194f3afb6f$export$2e2bcd8739ae039), {
                groups: groups,
                airbase: airbase,
                theater: theater
            })
        })
    });
}
function $861fc78f813d6070$var$WrappedAirportDiagram() {
    const { state: { tasking: tasking, focusedFeature: focusedFeature } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    // Set once on initial render
    const ab = $acw62.useRef((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(tasking.airbases, {
        Name: focusedFeature?.name
    }));
    const airbase = ab.current;
    if (!airbase) return null;
    const groups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(tasking.plannedGroups, {
        airdromeId: airbase?.AirdromeId
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($861fc78f813d6070$var$AirportDiagram, {
        airbase: airbase,
        groups: groups,
        theater: tasking.theater
    });
}
var $861fc78f813d6070$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($861fc78f813d6070$var$WrappedAirportDiagram).attrs({
    className: $861fc78f813d6070$var$AirportDiagram.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");

const $83cb3813968ffa14$var$LoadoutContainer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  padding-bottom: 36px;
`;
const $83cb3813968ffa14$var$InfoContainer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  padding-bottom: 8px;
`;
function $83cb3813968ffa14$var$Loadouts({ group: group, className: className }) {
    const maxPylons = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).max((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(group.units, (u)=>u.payload.length));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(group.units, (u, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($83cb3813968ffa14$var$LoadoutContainer, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($83cb3813968ffa14$var$InfoContainer, {
                        children: [
                            group.name,
                            " - ",
                            i + 1
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).times(maxPylons, (i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            align: "center",
                                            children: i + 1
                                        }, i))
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(u.payload, (weapon, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            align: "center",
                                            children: weapon
                                        }, i))
                                })
                            })
                        ]
                    })
                ]
            }, u.name))
    });
}
var $83cb3813968ffa14$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($83cb3813968ffa14$var$Loadouts)`
  td {
    font-size: 12px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");











function $170a3803c41b41f3$var$FuelPlanner({ className: className, groupName: groupName, readonly: readonly }) {
    const { state: { manifest: manifest, tasking: tasking } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const [saving, setSaving] = $acw62.useState(false);
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const add = (0, $1ae4eb57bb4d8f1b$export$f006ac3e7644ef4a)(manifest.id);
    const update = (0, $1ae4eb57bb4d8f1b$export$38a9b5ff2a6ec096)(manifest.id);
    const { data: groupsWithPlans } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest.fragOrderID, tasking?.plannedGroups);
    const { data: item } = (0, $1ae4eb57bb4d8f1b$export$8bbf2d825787d1a6)(manifest.id, groupName, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).FuelPlan);
    const existing = $acw62.useMemo(()=>{
        if (!item) return null;
        return JSON.parse(item.payload);
    }, [
        item?.payload
    ]);
    const isExisting = !!existing;
    const group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groupsWithPlans, {
        name: groupName
    });
    const t = (0, $b9c9d9c1adf94aca$export$f028d354b7025aa9)(group);
    const mod = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[t];
    const defaultVals = mod?.fuel?.defaultValues || {};
    const lastWP = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).last(group.waypoints);
    const [formState, setFormState] = $acw62.useState({
        groundSpeed: 0,
        fuelFlow: 0,
        bingo: 0,
        externalTanks: 0,
        ...defaultVals,
        targetWaypoint: lastWP.number
    });
    $acw62.useEffect(()=>{
        if (existing) setFormState(existing);
        else setFormState({
            ...defaultVals
        });
    }, [
        groupName,
        existing
    ]);
    const endWP = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(group.waypoints, {
        number: formState.targetWaypoint
    });
    const distanceToTarget = formState.targetWaypoint ? (0, $53c885ff43760466$export$c883c0766fae79f3)(tasking.theater, endWP || {}, group.waypoints) : 0;
    const firstUnitInternalFuel = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(group, [
        "units",
        0,
        "internalFuel"
    ]);
    const isWarnMismatchFuelLevels = !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).every(group.units, (u)=>u.internalFuel === firstUnitInternalFuel);
    const { time: time, totalFuel: totalFuel, fuelAtTarget: fuelAtTarget, loiterTime: loiterTime, fuelAtLanding: fuelAtLanding } = (0, $2af77d96514f3f21$export$f269fbe035abd952)(mod, tasking.theater, endWP, group.waypoints, formState, // DCS uses kilograms, we use pounds
    firstUnitInternalFuel * 2.205);
    const handleSave = ()=>{
        setSaving(true);
        const plan = {
            group: groupName,
            type: "FuelPlan",
            manifestID: manifest.id,
            payload: JSON.stringify(formState),
            uniqID: `${groupName}/FuelPlan`
        };
        const s = ()=>{
            success("Fuel Plan Saved");
        };
        const c = (e)=>{
            error(e.message);
        };
        const f = ()=>{
            setSaving(false);
        };
        if (!isExisting) return add(plan).then(s).catch(c).finally(f);
        return update({
            ...item,
            ...plan
        }).then(s).catch(c).finally(f);
    };
    if (readonly && !existing) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
        severity: "warning",
        children: "No fuel data found"
    });
    if (!mod?.fuel) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
        severity: "warning",
        children: "No fuel data found"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            p: 2,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                    style: {
                        margin: 0
                    },
                    children: [
                        groupName,
                        " - ",
                        mod?.label,
                        " Fuel Plan"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        my: 2,
                        children: [
                            isWarnMismatchFuelLevels && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                                severity: "warning",
                                children: "Warning: Mismatched fuel levels detected in group. Using first unit's fuel level for calculations."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                size: "small",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                        children: "Target Waypoint"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                        disabled: readonly,
                                        size: "small",
                                        style: {
                                            minWidth: 210
                                        },
                                        label: "Target Waypoint",
                                        value: formState.targetWaypoint,
                                        onChange: (ev)=>setFormState({
                                                ...formState,
                                                targetWaypoint: ev.target.value
                                            }),
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(group?.waypoints, (wp)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                value: wp.number,
                                                children: wp.name
                                            }, wp.number))
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                        columns: 2,
                        pairs: [
                            {
                                key: "Route Distance",
                                value: `${distanceToTarget.toFixed(2)} NM`
                            },
                            {
                                key: "Round Trip",
                                value: `${(distanceToTarget * 2).toFixed(2)} NM`
                            },
                            {
                                key: "Starting Fuel",
                                value: totalFuel?.toFixed(0)
                            },
                            {
                                key: "Engine Count",
                                value: mod?.fuel?.engineCount
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    mt: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                mb: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                disabled: readonly,
                                                label: "Ground Speed (knots)",
                                                size: "small",
                                                id: "outlined-basic",
                                                variant: "outlined",
                                                value: formState.groundSpeed,
                                                onChange: (ev)=>setFormState({
                                                        ...formState,
                                                        groundSpeed: parseFloat(ev.target.value)
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            ml: 2,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    disabled: readonly,
                                                    label: "Fuel Flow (PPH)",
                                                    size: "small",
                                                    id: "outlined-basic",
                                                    variant: "outlined",
                                                    type: "number",
                                                    value: formState.fuelFlow,
                                                    inputProps: {
                                                        step: 100
                                                    },
                                                    onChange: (ev)=>setFormState({
                                                            ...formState,
                                                            fuelFlow: parseFloat(ev.target.value)
                                                        })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                mb: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                disabled: readonly,
                                                label: "Bingo",
                                                size: "small",
                                                id: "outlined-basic",
                                                variant: "outlined",
                                                type: "number",
                                                value: formState.bingo,
                                                inputProps: {
                                                    step: 100
                                                },
                                                onChange: (ev)=>setFormState({
                                                        ...formState,
                                                        bingo: parseInt(ev.target.value)
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            ml: 2,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    disabled: readonly,
                                                    type: "number",
                                                    label: "External Tanks",
                                                    size: "small",
                                                    id: "outlined-basic",
                                                    variant: "outlined",
                                                    value: formState.externalTanks,
                                                    inputProps: {
                                                        max: mod?.fuel.maxExternalTanks || "3"
                                                    },
                                                    onChange: (ev)=>{
                                                        setFormState({
                                                            ...formState,
                                                            externalTanks: parseInt(ev.target.value)
                                                        });
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    mb: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                        columns: 4,
                        pairs: [
                            {
                                key: "Travel Time (minutes)",
                                value: time.toFixed(1)
                            },
                            {
                                key: "Fuel at Target (pounds)",
                                value: fuelAtTarget.toFixed(0)
                            },
                            {
                                key: "Loiter Time (minutes)",
                                value: loiterTime.toFixed(0)
                            },
                            {
                                key: "Fuel at Landing (pounds)",
                                value: fuelAtLanding.toFixed(0)
                            }
                        ]
                    })
                }),
                !readonly && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                    loading: saving,
                    onClick: handleSave,
                    variant: "contained",
                    children: "Save"
                })
            ]
        })
    });
}
var $170a3803c41b41f3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($170a3803c41b41f3$var$FuelPlanner).attrs({
    className: $170a3803c41b41f3$var$FuelPlanner.name
})``;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");

class $10aebb3d8b24eb72$export$510d6fc0e2816a6 {
    constructor(group){
        this.group = group;
    }
    laserCodes() {
        const arr = [];
        if (this.group.plan?.laserConfig) return this.group.plan.laserConfig;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).some(this.group.units, (u)=>u.aircraftProps)) {
            for (const u of this.group.units){
                const codes = {
                    LaserCode: u.laserCode.join("")
                };
                arr.push(codes);
            }
            return arr;
        }
        for (const unit of this.group.units){
            const t = unit.type;
            const m = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[t];
            if (!m) continue;
            const codes = {};
            for(const formatter in m.laserConfigFields){
                const f = m.laserConfigFields[formatter];
                const code = f.formatter(unit);
                if (code) codes[f.fieldName] = code;
            }
            arr.push(codes);
        }
        return arr;
    }
    dcsModule() {
        const unit = this.group.units[0];
        const t = unit.type;
        const m = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[t];
        if (!m) return null;
        return m;
    }
}



function $a7b4189a48fb0bc9$var$LaserConfigTable({ className: className, group: group }) {
    const g = new (0, $10aebb3d8b24eb72$export$510d6fc0e2816a6)(group);
    const m = g.dcsModule();
    const laser = g.laserCodes();
    if (!m) return null;
    const cols = [
        {
            label: "Flight Member",
            value: (l, c, r)=>`${group.name}-${r + 1}`
        }
    ];
    for(const field in m.laserConfigFields){
        const f = m.laserConfigFields[field];
        cols.push({
            label: field,
            value: (l)=>l[f.fieldName]
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
        className: className,
        columns: cols,
        rows: laser
    });
}
var $a7b4189a48fb0bc9$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a7b4189a48fb0bc9$var$LaserConfigTable).attrs({
    className: $a7b4189a48fb0bc9$var$LaserConfigTable.name
})``;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



function $65c5e7987dcd4c6b$var$RadioPresetTable({ className: className, group: group, presets: presets }) {
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(group.units).type;
    const module = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
    if (!module) return null;
    const plannedPresets = group.plan?.radioOverrides;
    const plannedOverrides = plannedPresets ? JSON.parse(plannedPresets) : null;
    const uhfIndex = module?.radioPresetOrder.indexOf((0, $b9c9d9c1adf94aca$export$cf0a21f30f3a5187).UHF);
    const vhfIndex = module?.radioPresetOrder.indexOf((0, $b9c9d9c1adf94aca$export$cf0a21f30f3a5187).VHF);
    const mixedIndex = module?.radioPresetOrder.indexOf((0, $b9c9d9c1adf94aca$export$cf0a21f30f3a5187).MIXED);
    let overrides = [];
    if (presets && uhfIndex !== -1) overrides[uhfIndex] = presets.UHF;
    if (presets && mixedIndex !== -1) overrides[mixedIndex] = presets["V/UHF"];
    if (presets && vhfIndex !== -1) overrides[vhfIndex] = presets.VHF;
    if (overrides.length === 0 && plannedOverrides?.length > 0) overrides = plannedOverrides;
    const radioRows = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(overrides, (radio, n)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(radio, (o, i)=>{
            if (!radioRows[i]) radioRows[i] = [];
            radioRows[i][n] = o;
        });
    });
    const cols = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(module.radios, (r)=>{
        cols.push({
            label: r.short,
            value: (o, colN)=>{
                const ov = o[colN - 1];
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        ov?.frequency || "",
                        "\xa0\xa0\xa0\xa0",
                        ov?.description || ""
                    ]
                });
            }
        });
    });
    // const comCols = _.map(module?.radios, (r) => ({
    //   label: r.short,
    //   value: (o: RadioChannelOverride[], colN: number) => {
    //     const ov = o[colN - 1];
    //     return ov?.description || ov?.frequency;
    //   },
    // }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            columns: [
                {
                    value: (o, colN, rowN)=>rowN + 1,
                    label: "Chan",
                    width: 1
                },
                ...cols
            ],
            rows: radioRows
        })
    });
}
var $65c5e7987dcd4c6b$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($65c5e7987dcd4c6b$var$RadioPresetTable).attrs({
    className: $65c5e7987dcd4c6b$var$RadioPresetTable.name
})`
  width: 100%;
`;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

parcelRequire("acw62");



function $e096496540292b25$var$WaypointTable({ className: className, tasking: tasking, waypoints: waypoints, onClick: onClick, styles: styles = {} }) {
    const cols = [
        {
            value: (wp)=>{
                if (onClick) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                    onClick: (e)=>{
                        e.preventDefault();
                        onClick(wp.number);
                    },
                    children: wp.number
                });
                return wp.number;
            },
            label: "#",
            style: {
                th: styles.th,
                td: styles.td
            }
        },
        {
            value: (wp)=>{
                const name = wp.name !== wp.number.toString() ? wp.name : "";
                if (onClick) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $731ce78e0c47d0a7$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        onClick(wp.number);
                    },
                    children: name
                });
                return name;
            },
            label: "Name",
            style: {
                th: styles.th,
                td: styles.td
            }
        },
        {
            value: (wp)=>(0, $53c885ff43760466$export$466569099c44c97b)(tasking, wp.ETA).toLocaleString((0, $63618293c58b5f80$exports.DateTime).TIME_24_WITH_SECONDS),
            label: "Time on Target (Zulu)",
            style: {
                th: styles.th,
                td: styles.td
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            stickyHeader: true,
            style: {
                ...styles.table
            },
            columns: cols,
            rows: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).tail(waypoints)
        })
    });
}
var $e096496540292b25$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($e096496540292b25$var$WaypointTable).attrs({
    className: $e096496540292b25$var$WaypointTable.name
})`
  .MuiLink-root {
    cursor: pointer;
  }

  td {
    padding: 8px;
  }
`;


const $6b5920881ecd250f$var$TabPanel = ({ val: val, index: index, children: children })=>{
    if (val !== index) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        children: children
    });
};
const $6b5920881ecd250f$var$GroupDataTabs = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ initialTab: initialTab = 0, group: group, tasking: tasking, onWaypointClick: onWaypointClick, className: className, planItems: planItems })=>{
    const [tab, setTab] = $acw62.useState(initialTab);
    const module = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[group?.units[0].type];
    // const isPlannable = userCanPlanGroup(group.name);
    $acw62.useEffect(()=>{
        if (!module?.laserConfigFields && tab === 3) setTab(0);
    }, [
        module
    ]);
    const remarks = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).PlanNote,
        group: group?.name
    });
    const channels = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).RadioPresets,
        group: group?.name
    }), (c)=>JSON.parse(c.payload)), [
        0
    ]);
    const parsedRemarks = remarks && (0, $3688fdfd7954d49f$export$7117fc57f3fba397)(remarks);
    // Handling both v2 and v3 plan notes
    const notes = parsedRemarks?.text || group?.plan?.plannerNotes;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                scrollButtons: true,
                value: tab,
                onChange: (e, val)=>setTab(val),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Waypoints"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Notes"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Comms"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Loadouts"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Laser"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Datalinks"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Fuel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$TabPanel, {
                index: 0,
                val: tab,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    paddingY: 1,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e096496540292b25$export$2e2bcd8739ae039), {
                        onClick: onWaypointClick,
                        tasking: tasking,
                        waypoints: group?.waypoints
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$TabPanel, {
                index: 1,
                val: tab,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    p: 1,
                    children: notes ? /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                        style: {
                            whiteSpace: "pre-wrap"
                        },
                        children: notes
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        fontStyle: "italic",
                        children: "No planner notes"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$TabPanel, {
                index: 2,
                val: tab,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65c5e7987dcd4c6b$export$2e2bcd8739ae039), {
                    group: group,
                    presets: tasking?.radioPresets || {
                        UHF: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(channels, [
                            0
                        ]),
                        VHF: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(channels, [
                            1
                        ]),
                        "V/UHF": (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(channels, [
                            2
                        ])
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$TabPanel, {
                index: 3,
                val: tab,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    p: 1,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83cb3813968ffa14$export$2e2bcd8739ae039), {
                        group: group
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$TabPanel, {
                index: 4,
                val: tab,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7b4189a48fb0bc9$export$2e2bcd8739ae039), {
                    group: group
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$TabPanel, {
                index: 5,
                val: tab,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                    columns: [
                        {
                            value: (u, col, row)=>{
                                return `${group.name}-${row + 1}`;
                            },
                            label: "Flight Member"
                        },
                        {
                            value: (u)=>u.aircraftProps.STN_L16,
                            label: "STN"
                        }
                    ],
                    rows: group.units
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$TabPanel, {
                index: 6,
                val: tab,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $170a3803c41b41f3$export$2e2bcd8739ae039), {
                    readonly: true,
                    groupName: group.name
                })
            })
        ]
    });
})`
  td {
    padding: 8px;
  }

  .laser-table th {
    padding: 4px 8px;
  }
`;
var $6b5920881ecd250f$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($6b5920881ecd250f$var$GroupDataTabs).attrs({
    className: $6b5920881ecd250f$var$GroupDataTabs.name
})``;
function $6b5920881ecd250f$export$5b1520aaea32716f({ name: name }) {
    const { state: { tasking: tasking, manifest: manifest } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const { data: groups } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest.fragOrderID, tasking.plannedGroups);
    const { data: planItems } = (0, $1ae4eb57bb4d8f1b$export$2e55148600f7bc1b)(manifest.id, name);
    const group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groups, {
        name: name
    });
    const select = (0, $99f46708ff5ed621$export$910c5181afa5ba66)();
    const handleWaypointClick = (n)=>{
        const wp = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(group.waypoints, {
            number: n
        });
        select(group.name, wp);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6b5920881ecd250f$var$GroupDataTabs, {
        group: group,
        tasking: tasking,
        onWaypointClick: handleWaypointClick,
        planItems: planItems
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");





function $664b36a50f9052f7$var$SelectedGroupDataTabs({ className: className }) {
    const { state: { tasking: tasking, manifest: manifest, focusedFeature: focusedFeature } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const { data: groups, isLoading: isLoading } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest.fragOrderID, tasking.plannedGroups);
    const name = focusedFeature.name;
    const { data: planItems } = (0, $1ae4eb57bb4d8f1b$export$2e55148600f7bc1b)(manifest.fragOrderID, name);
    const select = (0, $99f46708ff5ed621$export$910c5181afa5ba66)();
    let group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groups, {
        name: name
    });
    if (!group) group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groups, {
        name: focusedFeature.layerName
    });
    const handleWaypointClick = $acw62.useCallback((n)=>{
        const wp = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(group?.waypoints, {
            number: n
        });
        select(group?.name, wp);
    }, [
        group,
        select
    ]);
    if (isLoading || !focusedFeature) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b5920881ecd250f$export$2e2bcd8739ae039), {
        className: className,
        group: group,
        tasking: tasking,
        onWaypointClick: handleWaypointClick,
        planItems: planItems
    });
}
var $664b36a50f9052f7$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($664b36a50f9052f7$var$SelectedGroupDataTabs).attrs({
    className: $664b36a50f9052f7$var$SelectedGroupDataTabs.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






var $f1q41 = parcelRequire("f1q41");





var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");








function $44de7247194c5058$var$LaserCodeInput({ className: className, group: group, onSubmit: onSubmit }) {
    const [submittable, setSubmittable] = $acw62.useState(true);
    const [submitting, setSubmitting] = $acw62.useState(false);
    const { data: manifest } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    const { data: item } = (0, $1ae4eb57bb4d8f1b$export$8bbf2d825787d1a6)(manifest?.id, group.name, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).LaserCodes);
    const payload = JSON.parse(item?.payload || "{}");
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(group.units).type;
    const mod = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type];
    if (!mod) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
        severity: "warning",
        children: [
            "Module not found for type ",
            type,
            ". This module may not be supported by Frag Orders"
        ]
    });
    if (!mod.laserConfigFields) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        marginTop: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
            severity: "warning",
            children: [
                "Module ",
                mod.label,
                " does not have laser configuration fields."
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3f760351092dabf5$export$2e2bcd8739ae039), {
            onSubmit: (vals)=>{
                setSubmitting(true);
                const cfg = [];
                (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(vals, (v, k)=>{
                    const [, num, field] = k.split(".");
                    if (!cfg[num]) cfg[num] = {};
                    cfg[num][field] = v;
                });
                return onSubmit(cfg).finally(()=>{
                    setSubmitting(false);
                });
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        children: "Unit"
                                    }),
                                    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(mod.laserConfigFields, (num, k)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: k
                                        }, k))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(group.units, (u, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            width: 36,
                                            children: [
                                                group.name,
                                                "-",
                                                i + 1
                                            ]
                                        }, "name"),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(mod.laserConfigFields, (v, k)=>{
                                            const existing = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(group, [
                                                "plan",
                                                "laserConfig",
                                                i
                                            ]);
                                            let val = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toString((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(existing, v.fieldName));
                                            if (manifest.version >= 3) val = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).toString((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(payload[i], v.fieldName));
                                            if (!val) val = v.formatter(u);
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                style: {
                                                    width: 24
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                                    align: true,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7be4946a3739679$export$2e2bcd8739ae039), {
                                                        validator: (val)=>{
                                                            // Only allow exactly 3 digits
                                                            const t = /^\d{3}$/.test(val);
                                                            if (!t) {
                                                                // hack to disable submit button
                                                                setSubmittable(false);
                                                                return "Must be 3 digits";
                                                            }
                                                            setSubmittable(true);
                                                            return null;
                                                        },
                                                        size: "small",
                                                        name: `${group.name}.${i}.${v.fieldName}`,
                                                        defaultValue: val,
                                                        type: "number"
                                                    })
                                                })
                                            }, k);
                                        })
                                    ]
                                }, u.name))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    marginY: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        severity: "warning",
                        children: "Frag Orders does not validate laser codes. Please ensure the laser code that is used is valid for your aircraft."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                    disabled: !submittable,
                    loading: submitting,
                    type: "submit",
                    variant: "contained",
                    color: "primary",
                    children: "Submit"
                })
            ]
        })
    });
}
var $44de7247194c5058$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($44de7247194c5058$var$LaserCodeInput).attrs({
    className: $44de7247194c5058$var$LaserCodeInput.name
})`
  .MuiTable-root {
    table-layout: fixed;
  }

  ${(0, $b7be4946a3739679$export$2e2bcd8739ae039)} input {
    padding: 4px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");




function $c4e4e2fcb76260d6$var$MissionNotesInput({ className: className, onSubmit: onSubmit, plan: plan, groupName: groupName }) {
    const { state: { manifest: manifest } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const [submitting, setSubmitting] = $acw62.useState(false);
    const { data: item } = (0, $1ae4eb57bb4d8f1b$export$8bbf2d825787d1a6)(manifest.id, groupName, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).PlanNote);
    const [text, setText] = $acw62.useState("");
    $acw62.useEffect(()=>{
        if (manifest.version >= 3) {
            const p = JSON.parse(item?.payload || "{}");
            setText(p?.text || "");
            return;
        }
        setText(plan?.plannerNotes || "");
    }, [
        plan?.groupName,
        plan?.plannerNotes,
        item
    ]);
    const handleSubmit = ()=>{
        setSubmitting(true);
        onSubmit(text).finally(()=>setSubmitting(false));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Add notes that will be displayed in the Frag Order and generated kneeboards"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                multiline: true,
                fullWidth: true,
                rows: 12,
                onChange: (ev)=>setText(ev.target.value),
                value: text || ""
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                my: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                    loading: submitting,
                    onClick: handleSubmit,
                    variant: "contained",
                    children: "Submit"
                })
            })
        ]
    });
}
var $c4e4e2fcb76260d6$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c4e4e2fcb76260d6$var$MissionNotesInput).attrs({
    className: $c4e4e2fcb76260d6$var$MissionNotesInput.name
})`
  width: 100%;
  min-height: 820px;

  .MuiTextField-root {
    width: 100%;

    textarea {
      font-family: monospace;
    }
  }
`;



var $ayMG0 = parcelRequire("ayMG0");




var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");











function $f9196cb03820ae9e$var$toKey(radioIdx, chan, key) {
    return `${radioIdx}.${chan}.${key}`;
}
function $f9196cb03820ae9e$var$toPresets(formState) {
    const presets = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(formState, (v, k)=>{
        const [radioIdx, chan, key] = k.split(".");
        if (!presets[radioIdx]) presets[radioIdx] = [];
        if (!presets[radioIdx][chan]) presets[radioIdx][chan] = {};
        if (key === "frequency") presets[radioIdx][chan]["frequency"] = v;
        if (key === "modulation") presets[radioIdx][chan]["modulation"] = v;
        if (key === "description") presets[radioIdx][chan]["description"] = v;
    });
    return presets;
}
function $f9196cb03820ae9e$var$initialFormState(module, group, ovr) {
    const s = {};
    const radios = group.units[0].radios;
    let overrides = null;
    if (ovr) overrides = ovr;
    else if (group.plan && group.plan.radioOverrides) overrides = JSON.parse(group.plan.radioOverrides);
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(radios, (r, i)=>{
        const radios = module?.radios;
        if (!radios) return;
        const count = radios[i]?.presetCount || 20;
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).times(count, (t)=>{
            const k = $f9196cb03820ae9e$var$toKey(i, t, "frequency");
            const ovr = overrides && (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(overrides, [
                i,
                t
            ]);
            s[k] = (0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(ovr, "frequency") || r[t]?.frequency);
            const dKey = $f9196cb03820ae9e$var$toKey(i, t, "description");
            s[dKey] = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(ovr, "description") || "";
        });
    });
    return s;
}
function $f9196cb03820ae9e$var$RadioPresetForm({ className: className, group: group, onSubmit: onSubmit }) {
    const fileInputRef = $acw62.useRef();
    const { data: manifest } = (0, $a10ff9c4760c9625$export$76eb408250802197)();
    const m = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[group.units[0].type];
    const [submitting, setSubmitting] = $acw62.useState(false);
    const [importFrom, setImportFrom] = $acw62.useState(null);
    const [state, setState] = $acw62.useState(null);
    // We need to close the import menu on file upload
    const [importMenuOpen, setImportOpen] = $acw62.useState(false);
    const { data: planItem } = (0, $1ae4eb57bb4d8f1b$export$8bbf2d825787d1a6)(manifest.id, group.name, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).RadioPresets);
    $acw62.useEffect(()=>{
        if (!group) {
            setState(null);
            return;
        }
        if (manifest?.version >= 3 && planItem) {
            const p = JSON.parse(planItem.payload);
            setState($f9196cb03820ae9e$var$initialFormState(m, group, p));
            return;
        }
        setState($f9196cb03820ae9e$var$initialFormState(m, group));
    }, [
        group.name,
        manifest,
        planItem
    ]);
    const radios = group.units[0].radios;
    const common = (0, $0a53c1f23450367c$export$6015579ffd8399e3)(group?.units[0].type);
    // We can only import from groups that have a plan with radio overrides.
    // Also don't allow for us to import from the group we are currently looking at.
    const commonWithPlan = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(common, (c)=>!!c.plan && !!c.plan.radioOverrides && c.name !== group.name);
    if (!m || !m.radios || m.radios?.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        marginTop: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
            severity: "warning",
            children: [
                "Radio configuration not supported for",
                " ",
                m?.label || group.units[0].type
            ]
        })
    });
    const handleSubmit = ()=>{
        setSubmitting(true);
        const p = $f9196cb03820ae9e$var$toPresets(state);
        onSubmit(p).finally(()=>setSubmitting(false));
    };
    const handleImport = ()=>{
        const imp = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(commonWithPlan, {
            name: importFrom
        });
        const presets = JSON.parse(imp.plan?.radioOverrides);
        setState($f9196cb03820ae9e$var$initialFormState(m, group, presets));
    };
    const handleSave = ()=>{
        const b = new Blob([
            JSON.stringify($f9196cb03820ae9e$var$toPresets(state), null, 2)
        ]);
        (0, $90f256c567e4c320$exports.saveAs)(b, `FragOrders_RadioPreset_${group.name}.json`);
    };
    const handleImporFromFile = ()=>{
        setImportOpen(false);
        const inpt = fileInputRef?.current;
        inpt.onchange = ()=>{
            let files = Array.from(inpt.files);
            const f = files[0];
            f.text().then((val)=>{
                const presets = JSON.parse(val);
                setState($f9196cb03820ae9e$var$initialFormState(m, group, presets));
                inpt.value = null;
            });
        };
        inpt.click();
    };
    if (!m.radios) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: '"No programmable radios found"'
    });
    if (!state) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                end: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginRight: 4,
                        marginTop: 4
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $547acb6fe382aadd$export$2e2bcd8739ae039), {
                state: {
                    values: state
                },
                onChange: (name, value)=>{
                    const next = {
                        ...state,
                        [name]: value
                    };
                    setState(next);
                },
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        wide: true,
                        center: true,
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(m?.radios, (r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                paddingRight: 4,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        colSpan: 4,
                                                        children: r.label
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            style: {
                                                                width: 36
                                                            },
                                                            children: "Chan"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            style: {
                                                                width: 90
                                                            },
                                                            children: "Freq"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            style: {
                                                                width: 10
                                                            },
                                                            children: "AM/FM"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            style: {
                                                                width: 120
                                                            },
                                                            children: "Description"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).times(r.presetCount || 20, (t)=>{
                                                const radio = radios[i];
                                                if (!radio) return;
                                                const chan = radio[t];
                                                let mod = chan?.modulation;
                                                if (!mod) {
                                                    const band = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(r.bands);
                                                    if (band === (0, $91a9098e14452db2$export$381ac33b868f60a4).VHF_FM) mod = (0, $91a9098e14452db2$export$459e66e1d1ce05ca).FM;
                                                }
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            children: t + 1
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9924aff1dcc3644$export$2e2bcd8739ae039), {
                                                                name: $f9196cb03820ae9e$var$toKey(i, t, "frequency"),
                                                                type: "number",
                                                                size: "small",
                                                                step: "any",
                                                                formatter: (v)=>(0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(v)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            children: mod === (0, $91a9098e14452db2$export$459e66e1d1ce05ca).FM ? "FM" : "AM"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9924aff1dcc3644$export$2e2bcd8739ae039), {
                                                                name: $f9196cb03820ae9e$var$toKey(i, t, "description"),
                                                                size: "small"
                                                            })
                                                        })
                                                    ]
                                                }, t);
                                            })
                                        })
                                    ]
                                })
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginTop: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                            align: true,
                            between: true,
                            wide: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                    align: true,
                                    wide: true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                                            loading: submitting,
                                            type: "submit",
                                            variant: "contained",
                                            children: "Submit"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            marginLeft: 2,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                                onClick: handleSave,
                                                variant: "outlined",
                                                children: "Save to File"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    style: {
                                        minWidth: 400
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                        align: true,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                                onClick: handleImport,
                                                style: {
                                                    marginRight: 4
                                                },
                                                variant: "contained",
                                                disabled: submitting || !importFrom,
                                                children: "Import"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                size: "small",
                                                fullWidth: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                                        id: "demo-simple-select-label",
                                                        children: "Import"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                        open: importMenuOpen,
                                                        onOpen: ()=>setImportOpen(true),
                                                        onClose: ()=>setImportOpen(false),
                                                        labelId: "demo-simple-select-label",
                                                        id: "demo-simple-select",
                                                        value: importFrom || "",
                                                        label: "Import Presets",
                                                        onChange: (e)=>{
                                                            setImportFrom(e.target.value);
                                                        },
                                                        placeholder: "Import Presets",
                                                        children: [
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(commonWithPlan, (c)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                    value: c.name,
                                                                    children: c.name
                                                                }, c.name)),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {}),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                onClick: handleImporFromFile,
                                                                children: "Import from file"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                ref: fileInputRef,
                type: "file",
                style: {
                    display: "none"
                }
            })
        ]
    });
}
var $f9196cb03820ae9e$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($f9196cb03820ae9e$var$RadioPresetForm).attrs({
    className: $f9196cb03820ae9e$var$RadioPresetForm.name
})`
  box-sizing: border-box;

  .MuiTable-root {
    min-width: 360px;

    th {
      text-align: left;
      padding: 0 4px;
    }

    td {
      padding: 4px;
    }

    input {
      font-size: 14px;
      padding: 4px;
    }
  }
`;


const $3fd497fbfd581731$var$TabContent = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(({ children: children, value: value, index: index, className: className })=>{
    if (value !== index) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: children
    });
})``;
function $3fd497fbfd581731$var$PlanningDataEntry({ className: className, group: group }) {
    const [tab, setTab] = $acw62.useState(0);
    const { state: { manifest: manifest, tasking: tasking }, controller: controller } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const upsertPlanItem = (0, $1ae4eb57bb4d8f1b$export$d5a943bb2ea9518c)(manifest?.id);
    const type = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(group, [
        "units",
        0,
        "type"
    ]);
    const module = (0, $b9c9d9c1adf94aca$export$cc2c248003684daa)[type] || type;
    const label = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(module, [
        "label"
    ], type);
    const submitPlan = (0, $92839c6c950486dc$export$7c0965223e29d235)(manifest, tasking.theater, controller.current);
    const handleDataEntrySubmit = ({ group: group, radio: radio, notes: notes, laser: laser })=>{
        if (manifest && manifest.version >= 3) {
            let itemType;
            let payload;
            if (radio) {
                itemType = (0, $3688fdfd7954d49f$export$58047b57cdffebb3).RadioPresets;
                payload = JSON.stringify(radio);
            } else if (laser) {
                itemType = (0, $3688fdfd7954d49f$export$58047b57cdffebb3).LaserCodes;
                payload = JSON.stringify(laser);
            } else if (notes) {
                itemType = (0, $3688fdfd7954d49f$export$58047b57cdffebb3).PlanNote;
                payload = JSON.stringify({
                    text: notes
                });
            }
            const data = {
                type: itemType,
                group: group.name,
                manifestID: manifest.id,
                uniqID: group.name,
                payload: payload
            };
            return upsertPlanItem(data).then(()=>{
                success(`Data entry submitted for ${group.name} `);
            }).catch((err)=>{
                if ((0, $1ae4eb57bb4d8f1b$export$e11674744930cd15)(err.message)) {
                    error("This item has been submitted by another user");
                    return;
                }
                error(err.message);
                console.error(err);
            });
        }
        return submitPlan(group, radio, notes, laser).then(()=>{
            success(`Data entry submitted for ${group.name} `);
        }).catch((err)=>{
            error(err.message);
            console.error(err);
        });
    };
    if (!group) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            p: 2,
            // paddingLeft={2}
            style: {
                width: "100%",
                boxSizing: "border-box"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    wide: true,
                    between: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Data Entry for ",
                            group.name,
                            " - ",
                            label
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                    variant: "fullWidth",
                    onChange: (e, val)=>setTab(val),
                    value: tab,
                    indicatorColor: "primary",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                            label: "Notes"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                            disabled: !manifest?.publishOpts.allowPlannerRadioFreqs,
                            label: "Radios"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                            disabled: !manifest?.publishOpts.allowPlannersLaserCodes,
                            label: "Laser Codes"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                            label: "Fuel Planner"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($3fd497fbfd581731$var$TabContent, {
                    value: tab,
                    index: 0,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4e4e2fcb76260d6$export$2e2bcd8739ae039), {
                        plan: group?.plan,
                        groupName: group.name,
                        onSubmit: (notes)=>handleDataEntrySubmit({
                                group: group,
                                radio: null,
                                notes: notes,
                                laser: null
                            })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($3fd497fbfd581731$var$TabContent, {
                    value: tab,
                    index: 1,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9196cb03820ae9e$export$2e2bcd8739ae039), {
                        onSubmit: (ovr)=>handleDataEntrySubmit({
                                group: group,
                                radio: ovr,
                                notes: null,
                                laser: null
                            }),
                        group: group
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($3fd497fbfd581731$var$TabContent, {
                    value: tab,
                    index: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44de7247194c5058$export$2e2bcd8739ae039), {
                        onSubmit: (laser)=>handleDataEntrySubmit({
                                group: group,
                                radio: null,
                                notes: null,
                                laser: laser
                            }),
                        group: group
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($3fd497fbfd581731$var$TabContent, {
                    value: tab,
                    index: 3,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $170a3803c41b41f3$export$2e2bcd8739ae039), {
                        groupName: group.name
                    })
                })
            ]
        })
    });
}
var $3fd497fbfd581731$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($3fd497fbfd581731$var$PlanningDataEntry).attrs({
    className: $3fd497fbfd581731$var$PlanningDataEntry.name
})`
  width: 100%;

  .MuiTabs-root,
  .MuiTabs-scroller {
    min-width: 640px !important;
  }

  ${(0, $f9196cb03820ae9e$export$2e2bcd8739ae039)} {
    overflow: auto;
  }
`;


const $d2246b069085bbc3$var$StyledTab = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039))`
  &.MuiButtonBase-root {
    white-space: nowrap;
    justify-content: center;
    align-items: flex-start;
  }

  .tab-text {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;
function $d2246b069085bbc3$var$a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`
    };
}
function $d2246b069085bbc3$var$DataEntryWindow({ className: className }) {
    const { state: { tasking: tasking, manifest: manifest } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const { data: groups, isLoading: isLoading } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest.fragOrderID, tasking.plannedGroups, {
        status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
    });
    const plannable = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(groups, (g)=>(0, $99f46708ff5ed621$export$9e53ded791f25835)(g.name));
    const q = new URLSearchParams(window.location.search);
    const groupName = decodeURIComponent(q.get("group"));
    const initialGroup = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).findIndex(plannable, {
        name: groupName
    });
    const [selected, setSelected] = $acw62.useState(initialGroup === -1 ? 0 : initialGroup);
    if (isLoading) return null;
    const currentGroup = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(plannable, {
        name: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(plannable, [
            selected,
            "name"
        ])
    });
    if (plannable.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        wide: true,
        center: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            marginTop: 4,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                fontStyle: "italic",
                children: "You currently not permitted to plan any groups"
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                orientation: "vertical",
                variant: "scrollable",
                value: selected,
                onChange: (ev, v)=>setSelected(v),
                "aria-label": "Vertical tabs example",
                sx: {
                    borderRight: 1,
                    borderColor: "divider",
                    overflow: "auto"
                },
                children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(plannable, (a, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d2246b069085bbc3$var$StyledTab, {
                        value: i,
                        style: {
                            textAlign: "left"
                        },
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "tab-text",
                            children: a.name
                        }),
                        ...$d2246b069085bbc3$var$a11yProps(i)
                    }, a.name))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fd497fbfd581731$export$2e2bcd8739ae039), {
                group: currentGroup
            })
        ]
    });
}
var $d2246b069085bbc3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($d2246b069085bbc3$var$DataEntryWindow).attrs({
    className: $d2246b069085bbc3$var$DataEntryWindow.name
})`
  display: flex;

  .MuiTabs-root {
    min-width: 200px;
    width: 200px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");









var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");









var $ayMG0 = parcelRequire("ayMG0");
var $4746b46c9ce21ad5$exports = {};
"use strict";

Object.defineProperty($4746b46c9ce21ad5$exports, "__esModule", {
    value: true
});
$4746b46c9ce21ad5$exports.default = void 0;

var $4746b46c9ce21ad5$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4746b46c9ce21ad5$var$_default = (0, $4746b46c9ce21ad5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
}), "Layers");
$4746b46c9ce21ad5$exports.default = $4746b46c9ce21ad5$var$_default;


var $ef6cf5694ef7c853$exports = {};
"use strict";

Object.defineProperty($ef6cf5694ef7c853$exports, "__esModule", {
    value: true
});
$ef6cf5694ef7c853$exports.default = void 0;

var $ef6cf5694ef7c853$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ef6cf5694ef7c853$var$_default = (0, $ef6cf5694ef7c853$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m19.81 14.99 1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1 2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"
}), "LayersClear");
$ef6cf5694ef7c853$exports.default = $ef6cf5694ef7c853$var$_default;




var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");





function $06ec70603924c88d$var$PlayerLayerControlButton({ className: className, group: group }) {
    const { state: state } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const toggle = (0, $99f46708ff5ed621$export$90155930613bed46)();
    const handleClick = ()=>{
        toggle([
            (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                group.name
            ])
        ]);
    };
    const isVisible = !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(state.disabledLayers, (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
        group.name
    ]));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        title: `${isVisible ? "Hide" : "Show"} Route`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            className: className,
            active: !isVisible,
            onClick: handleClick,
            children: !isVisible ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4746b46c9ce21ad5$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ef6cf5694ef7c853$exports))), {})
        })
    });
}
var $06ec70603924c88d$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($06ec70603924c88d$var$PlayerLayerControlButton).attrs({
    className: $06ec70603924c88d$var$PlayerLayerControlButton.name
})``;




var $ayMG0 = parcelRequire("ayMG0");




var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");





function $8fccdabd4395afcc$var$TogglePlayerLayersButton({ className: className }) {
    const { state: { disabledLayers: disabledLayers, tasking: { plannedGroups: plannedGroups } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const toggle = (0, $99f46708ff5ed621$export$90155930613bed46)();
    const handleToggleAll = ()=>{
        const allChecked = relevantLayers?.length === 0;
        const layers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(plannedGroups, (g)=>{
            return (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                g.name
            ]);
        });
        toggle(layers, !allChecked);
    };
    const relevantLayers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(disabledLayers, (l)=>{
        return (0, $3f9383da7c35acdb$export$ec0b75c3939f59b7)(l) === (0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
        title: "Toggle All Routes",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a532efbc490c445$export$2e2bcd8739ae039), {
            className: className,
            onClick: handleToggleAll,
            children: relevantLayers.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4746b46c9ce21ad5$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ef6cf5694ef7c853$exports))), {})
        })
    });
}
var $8fccdabd4395afcc$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($8fccdabd4395afcc$var$TogglePlayerLayersButton).attrs({
    className: $8fccdabd4395afcc$var$TogglePlayerLayersButton.name
})``;


function $24d3babfc5e3eec0$export$aa736ab11ea602ae({ className: className, groups: groups, onLinkClick: onLinkClick }) {
    const colorMap = (0, $99f46708ff5ed621$export$6af74cd118fd0c5d)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            stickyHeader: true,
            size: "small",
            columns: [
                {
                    label: "Name",
                    // width: 25,
                    value: (g)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                            to: "",
                            onClick: (ev)=>{
                                ev.preventDefault();
                                onLinkClick(ev, g.name);
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                variant: "text",
                                style: {
                                    textAlign: "left"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    style: {
                                        width: 96,
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden"
                                    },
                                    fontSize: 12,
                                    fontWeight: 500,
                                    component: "span",
                                    color: colorMap[g.name],
                                    children: g.name
                                })
                            })
                        })
                },
                {
                    label: "Type",
                    value: (g)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, $b9c9d9c1adf94aca$export$cc2c248003684daa), [
                            g.units[0].type,
                            "label"
                        ])
                },
                {
                    label: "",
                    value: (g)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e4775d1707ca58d$export$2e2bcd8739ae039), {
                            group: g
                        }),
                    width: 25
                },
                {
                    label: "",
                    value: (g)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $26d69e06ab13261e$export$2e2bcd8739ae039), {
                            group: g
                        }),
                    width: 25
                },
                {
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8fccdabd4395afcc$export$2e2bcd8739ae039), {}),
                    value: (g)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $06ec70603924c88d$export$2e2bcd8739ae039), {
                            group: g
                        }),
                    width: 25
                }
            ],
            rows: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(groups, "name")
        })
    });
}
function $24d3babfc5e3eec0$var$PlayerGroupsContainer({ className: className }) {
    const { state: { disabledLayers: disabledLayers, tasking: { plannedGroups: plannedGroups } } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const toggle = (0, $99f46708ff5ed621$export$90155930613bed46)();
    const handleLinkClick = (0, $99f46708ff5ed621$export$a1854f3defd0f515)();
    const handleGroupSelect = (g)=>{
        toggle([
            (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                g.name
            ])
        ]);
    };
    const handleToggleAll = (checked)=>{
        const layers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(plannedGroups, (g)=>{
            return (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                g.name
            ]);
        });
        toggle(layers, !checked);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($24d3babfc5e3eec0$export$aa736ab11ea602ae, {
        onLinkClick: (ev, name)=>handleLinkClick("Player Groups", name),
        onToggleAll: handleToggleAll,
        onGroupSelect: handleGroupSelect,
        disabledLayers: disabledLayers,
        groups: plannedGroups,
        layerName: (0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups,
        className: className
    });
}
var $24d3babfc5e3eec0$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($24d3babfc5e3eec0$var$PlayerGroupsContainer).attrs({
    className: $24d3babfc5e3eec0$export$aa736ab11ea602ae.name
})`
  ${(0, $f167d3e4f22a6e20$export$2e2bcd8739ae039)} {
    text-decoration: none;
  }

  thead th:nth-child(5) {
    padding-left: 4px;
    text-align: left;
  }

  td {
    button {
      margin-right: 0;
    }

    padding: 8px 4px;
  }
`;


function $f63a128fb7948aa3$var$PlanningMenu({ className: className }) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const plan = (0, $99f46708ff5ed621$export$635e5f346bd462a6)();
    const { state: { manifest: manifest, userPlannableGroups: userPlannableGroups, disabledLayers: disabledLayers, tasking: { plannedGroups: plannedGroups } } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const focus = (0, $99f46708ff5ed621$export$a1854f3defd0f515)();
    const toggle = (0, $99f46708ff5ed621$export$90155930613bed46)();
    $acw62.useEffect(()=>{
        // Enable planning mode on window open
        plan(true);
        return ()=>{
            plan(false);
        };
    }, []);
    const { data: groups, isLoading: isLoading } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest.fragOrderID, plannedGroups, {
        user: currentUser
    });
    if (isLoading) return null;
    const handleLinkClick = (ev, group)=>{
        ev.preventDefault();
        focus("Player Groups", group);
    };
    const handleToggle = (group)=>{
        toggle([
            (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                group.name
            ])
        ]);
    };
    const handleToggleAll = (checked)=>{
        const layers = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>{
            return [
                (0, $3f9383da7c35acdb$export$b1b72b1c509ed03d)((0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups, [
                    g.name
                ])
            ];
        });
        toggle((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).flatten(layers), !checked);
    };
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(groups, (g)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(userPlannableGroups, g.name)), "name");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                align: true,
                between: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    p: 2,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        variant: "h6",
                        children: "Plannable Groups"
                    })
                })
            }),
            !currentUser && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                p: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    wide: true,
                    center: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5e8911e4b30dc90$export$2e2bcd8739ae039), {})
                })
            }),
            currentUser && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24d3babfc5e3eec0$export$aa736ab11ea602ae), {
                disabledLayers: disabledLayers,
                onGroupSelect: handleToggle,
                onLinkClick: handleLinkClick,
                onToggleAll: handleToggleAll,
                groups: rows,
                layerName: (0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups
            })
        ]
    });
}
var $f63a128fb7948aa3$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($f63a128fb7948aa3$var$PlanningMenu).attrs({
    className: $f63a128fb7948aa3$var$PlanningMenu.name
})`
  .diff {
    font-weight: 600;
    color: ${(props)=>props.theme.palette.success.main};
  }

  .row-selected {
    td,
    .MuiButton-root,
    .MuiButton-textPrimary p {
      color: white !important;
    }

    background: ${(props)=>props.theme.palette.grey[400]};
  }
`;




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $7f3998d7204fe0e2$var$SupportAssetsTable({ className: className, assets: assets, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
        size: "small",
        stickyHeader: true,
        className: className,
        columns: [
            {
                label: "Name",
                value: onClick ? (b)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        style: {
                            textAlign: "left"
                        },
                        onClick: (e)=>{
                            e.preventDefault();
                            onClick(b);
                        },
                        children: b.name
                    }) : "name"
            },
            {
                label: "Frequency",
                value: (g)=>(0, $165c1a1c0f22e853$export$3ecc6c0c07998cb5)(g.channel.frequency)
            },
            {
                label: "TACAN",
                value: (g)=>(0, $c255bc447a24c026$export$1cc6625bb95a1f24)(g.units[0], g)
            }
        ],
        rows: assets
    });
}
const $7f3998d7204fe0e2$var$wrapped = (...props)=>{
    const { state: state, dispatch: dispatch } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7f3998d7204fe0e2$var$SupportAssetsTable, {
        assets: state.tasking.supportAssets,
        onClick: (a)=>{
            dispatch({
                type: (0, $99f46708ff5ed621$export$159e21535af98b26).focusFeature,
                layerName: (0, $91a9098e14452db2$export$fb028bc55343bb1f).SupportAssets,
                name: a.name,
                otherFeatures: []
            });
        },
        ...props
    });
};
var $7f3998d7204fe0e2$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($7f3998d7204fe0e2$var$wrapped).attrs({
    className: $7f3998d7204fe0e2$var$SupportAssetsTable.name
})``;




function $c85127b4fb8041f0$var$SearchWindow({ className: className }) {
    const [selected, setSelected] = $acw62.useState(0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                value: selected,
                onChange: (event, val)=>setSelected(val),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Player Groups"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Support Assets"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        label: "Airbases"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54f1185d5c2a9ece$export$2e2bcd8739ae039), {
                value: selected,
                index: 0,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24d3babfc5e3eec0$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54f1185d5c2a9ece$export$2e2bcd8739ae039), {
                value: selected,
                index: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f3998d7204fe0e2$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54f1185d5c2a9ece$export$2e2bcd8739ae039), {
                value: selected,
                index: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15725ec70269d49f$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $c85127b4fb8041f0$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c85127b4fb8041f0$var$SearchWindow).attrs({
    className: $c85127b4fb8041f0$var$SearchWindow.name
})`
  padding: 0;
`;




var $ayMG0 = parcelRequire("ayMG0");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");






var $ab4935ac8ee9025c$exports = {};
/*jslint node:true */ var $7de0f1800c3a1686$exports = {};
var $a39a5ccf1aa3cd6a$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a39a5ccf1aa3cd6a$require$Buffer = $6ZWSX.Buffer;


(function(sax) {
    sax.parser = function(strict, opt) {
        return new SAXParser(strict, opt);
    };
    sax.SAXParser = SAXParser;
    sax.SAXStream = SAXStream;
    sax.createStream = createStream;
    // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
    // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
    // since that's the earliest that a buffer overrun could occur.  This way, checks are
    // as rare as required, but as often as necessary to ensure never crossing this bound.
    // Furthermore, buffers are only tested at most once per write(), so passing a very
    // large string into write() might have undesirable effects, but this is manageable by
    // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
    // edge case, result in creating at most one complete copy of the string passed in.
    // Set to Infinity to have unlimited buffers.
    sax.MAX_BUFFER_LENGTH = 65536;
    var buffers = [
        "comment",
        "sgmlDecl",
        "textNode",
        "tagName",
        "doctype",
        "procInstName",
        "procInstBody",
        "entity",
        "attribName",
        "attribValue",
        "cdata",
        "script"
    ];
    sax.EVENTS = [
        "text",
        "processinginstruction",
        "sgmldeclaration",
        "doctype",
        "comment",
        "opentagstart",
        "attribute",
        "opentag",
        "closetag",
        "opencdata",
        "cdata",
        "closecdata",
        "error",
        "end",
        "ready",
        "script",
        "opennamespace",
        "closenamespace"
    ];
    function SAXParser(strict, opt) {
        if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
        var parser = this;
        clearBuffers(parser);
        parser.q = parser.c = "";
        parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
        parser.opt = opt || {};
        parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
        parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase";
        parser.tags = [];
        parser.closed = parser.closedRoot = parser.sawRoot = false;
        parser.tag = parser.error = null;
        parser.strict = !!strict;
        parser.noscript = !!(strict || parser.opt.noscript);
        parser.state = S.BEGIN;
        parser.strictEntities = parser.opt.strictEntities;
        parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
        parser.attribList = [];
        // namespaces form a prototype chain.
        // it always points at the current tag,
        // which protos to its parent tag.
        if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
        // mostly just for error reporting
        parser.trackPosition = parser.opt.position !== false;
        if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
        emit(parser, "onready");
    }
    if (!Object.create) Object.create = function(o) {
        function F() {}
        F.prototype = o;
        var newf = new F();
        return newf;
    };
    if (!Object.keys) Object.keys = function(o) {
        var a = [];
        for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
        return a;
    };
    function checkBufferLength(parser) {
        var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
        var maxActual = 0;
        for(var i = 0, l = buffers.length; i < l; i++){
            var len = parser[buffers[i]].length;
            if (len > maxAllowed) // Text/cdata nodes can get big, and since they're buffered,
            // we can get here under normal conditions.
            // Avoid issues by emitting the text node now,
            // so at least it won't get any bigger.
            switch(buffers[i]){
                case "textNode":
                    closeText(parser);
                    break;
                case "cdata":
                    emitNode(parser, "oncdata", parser.cdata);
                    parser.cdata = "";
                    break;
                case "script":
                    emitNode(parser, "onscript", parser.script);
                    parser.script = "";
                    break;
                default:
                    error(parser, "Max buffer length exceeded: " + buffers[i]);
            }
            maxActual = Math.max(maxActual, len);
        }
        // schedule the next check for the earliest possible buffer overrun.
        var m = sax.MAX_BUFFER_LENGTH - maxActual;
        parser.bufferCheckPosition = m + parser.position;
    }
    function clearBuffers(parser) {
        for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = "";
    }
    function flushBuffers(parser) {
        closeText(parser);
        if (parser.cdata !== "") {
            emitNode(parser, "oncdata", parser.cdata);
            parser.cdata = "";
        }
        if (parser.script !== "") {
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
    }
    SAXParser.prototype = {
        end: function() {
            end(this);
        },
        write: write,
        resume: function() {
            this.error = null;
            return this;
        },
        close: function() {
            return this.write(null);
        },
        flush: function() {
            flushBuffers(this);
        }
    };
    var Stream;
    try {
        Stream = (parcelRequire("ioRHp")).Stream;
    } catch (ex) {
        Stream = function() {};
    }
    var streamWraps = sax.EVENTS.filter(function(ev) {
        return ev !== "error" && ev !== "end";
    });
    function createStream(strict, opt) {
        return new SAXStream(strict, opt);
    }
    function SAXStream(strict, opt) {
        if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
        Stream.apply(this);
        this._parser = new SAXParser(strict, opt);
        this.writable = true;
        this.readable = true;
        var me = this;
        this._parser.onend = function() {
            me.emit("end");
        };
        this._parser.onerror = function(er) {
            me.emit("error", er);
            // if didn't throw, then means error was handled.
            // go ahead and clear error, so we can write again.
            me._parser.error = null;
        };
        this._decoder = null;
        streamWraps.forEach(function(ev) {
            Object.defineProperty(me, "on" + ev, {
                get: function() {
                    return me._parser["on" + ev];
                },
                set: function(h) {
                    if (!h) {
                        me.removeAllListeners(ev);
                        me._parser["on" + ev] = h;
                        return h;
                    }
                    me.on(ev, h);
                },
                enumerable: true,
                configurable: false
            });
        });
    }
    SAXStream.prototype = Object.create(Stream.prototype, {
        constructor: {
            value: SAXStream
        }
    });
    SAXStream.prototype.write = function(data) {
        if (typeof $a39a5ccf1aa3cd6a$require$Buffer === "function" && typeof $a39a5ccf1aa3cd6a$require$Buffer.isBuffer === "function" && $a39a5ccf1aa3cd6a$require$Buffer.isBuffer(data)) {
            if (!this._decoder) {
                var SD = (parcelRequire("eNRCS")).StringDecoder;
                this._decoder = new SD("utf8");
            }
            data = this._decoder.write(data);
        }
        this._parser.write(data.toString());
        this.emit("data", data);
        return true;
    };
    SAXStream.prototype.end = function(chunk) {
        if (chunk && chunk.length) this.write(chunk);
        this._parser.end();
        return true;
    };
    SAXStream.prototype.on = function(ev, handler) {
        var me = this;
        if (!me._parser["on" + ev] && streamWraps.indexOf(ev) !== -1) me._parser["on" + ev] = function() {
            var args = arguments.length === 1 ? [
                arguments[0]
            ] : Array.apply(null, arguments);
            args.splice(0, 0, ev);
            me.emit.apply(me, args);
        };
        return Stream.prototype.on.call(me, ev, handler);
    };
    // this really needs to be replaced with character classes.
    // XML allows all manner of ridiculous numbers and digits.
    var CDATA = "[CDATA[";
    var DOCTYPE = "DOCTYPE";
    var XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
    var XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
    var rootNS = {
        xml: XML_NAMESPACE,
        xmlns: XMLNS_NAMESPACE
    };
    // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
    // This implementation works on strings, a single character at a time
    // as such, it cannot ever support astral-plane characters (10000-EFFFF)
    // without a significant breaking change to either this  parser, or the
    // JavaScript language.  Implementation of an emoji-capable xml parser
    // is left as an exercise for the reader.
    var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function isWhitespace(c) {
        return c === " " || c === "\n" || c === "\r" || c === "	";
    }
    function isQuote(c) {
        return c === '"' || c === "'";
    }
    function isAttribEnd(c) {
        return c === ">" || isWhitespace(c);
    }
    function isMatch(regex, c) {
        return regex.test(c);
    }
    function notMatch(regex, c) {
        return !isMatch(regex, c);
    }
    var S = 0;
    sax.STATE = {
        BEGIN: S++,
        BEGIN_WHITESPACE: S++,
        TEXT: S++,
        TEXT_ENTITY: S++,
        OPEN_WAKA: S++,
        SGML_DECL: S++,
        SGML_DECL_QUOTED: S++,
        DOCTYPE: S++,
        DOCTYPE_QUOTED: S++,
        DOCTYPE_DTD: S++,
        DOCTYPE_DTD_QUOTED: S++,
        COMMENT_STARTING: S++,
        COMMENT: S++,
        COMMENT_ENDING: S++,
        COMMENT_ENDED: S++,
        CDATA: S++,
        CDATA_ENDING: S++,
        CDATA_ENDING_2: S++,
        PROC_INST: S++,
        PROC_INST_BODY: S++,
        PROC_INST_ENDING: S++,
        OPEN_TAG: S++,
        OPEN_TAG_SLASH: S++,
        ATTRIB: S++,
        ATTRIB_NAME: S++,
        ATTRIB_NAME_SAW_WHITE: S++,
        ATTRIB_VALUE: S++,
        ATTRIB_VALUE_QUOTED: S++,
        ATTRIB_VALUE_CLOSED: S++,
        ATTRIB_VALUE_UNQUOTED: S++,
        ATTRIB_VALUE_ENTITY_Q: S++,
        ATTRIB_VALUE_ENTITY_U: S++,
        CLOSE_TAG: S++,
        CLOSE_TAG_SAW_WHITE: S++,
        SCRIPT: S++,
        SCRIPT_ENDING: S++ // <script> ... <
    };
    sax.XML_ENTITIES = {
        "amp": "&",
        "gt": ">",
        "lt": "<",
        "quot": '"',
        "apos": "'"
    };
    sax.ENTITIES = {
        "amp": "&",
        "gt": ">",
        "lt": "<",
        "quot": '"',
        "apos": "'",
        "AElig": 198,
        "Aacute": 193,
        "Acirc": 194,
        "Agrave": 192,
        "Aring": 197,
        "Atilde": 195,
        "Auml": 196,
        "Ccedil": 199,
        "ETH": 208,
        "Eacute": 201,
        "Ecirc": 202,
        "Egrave": 200,
        "Euml": 203,
        "Iacute": 205,
        "Icirc": 206,
        "Igrave": 204,
        "Iuml": 207,
        "Ntilde": 209,
        "Oacute": 211,
        "Ocirc": 212,
        "Ograve": 210,
        "Oslash": 216,
        "Otilde": 213,
        "Ouml": 214,
        "THORN": 222,
        "Uacute": 218,
        "Ucirc": 219,
        "Ugrave": 217,
        "Uuml": 220,
        "Yacute": 221,
        "aacute": 225,
        "acirc": 226,
        "aelig": 230,
        "agrave": 224,
        "aring": 229,
        "atilde": 227,
        "auml": 228,
        "ccedil": 231,
        "eacute": 233,
        "ecirc": 234,
        "egrave": 232,
        "eth": 240,
        "euml": 235,
        "iacute": 237,
        "icirc": 238,
        "igrave": 236,
        "iuml": 239,
        "ntilde": 241,
        "oacute": 243,
        "ocirc": 244,
        "ograve": 242,
        "oslash": 248,
        "otilde": 245,
        "ouml": 246,
        "szlig": 223,
        "thorn": 254,
        "uacute": 250,
        "ucirc": 251,
        "ugrave": 249,
        "uuml": 252,
        "yacute": 253,
        "yuml": 255,
        "copy": 169,
        "reg": 174,
        "nbsp": 160,
        "iexcl": 161,
        "cent": 162,
        "pound": 163,
        "curren": 164,
        "yen": 165,
        "brvbar": 166,
        "sect": 167,
        "uml": 168,
        "ordf": 170,
        "laquo": 171,
        "not": 172,
        "shy": 173,
        "macr": 175,
        "deg": 176,
        "plusmn": 177,
        "sup1": 185,
        "sup2": 178,
        "sup3": 179,
        "acute": 180,
        "micro": 181,
        "para": 182,
        "middot": 183,
        "cedil": 184,
        "ordm": 186,
        "raquo": 187,
        "frac14": 188,
        "frac12": 189,
        "frac34": 190,
        "iquest": 191,
        "times": 215,
        "divide": 247,
        "OElig": 338,
        "oelig": 339,
        "Scaron": 352,
        "scaron": 353,
        "Yuml": 376,
        "fnof": 402,
        "circ": 710,
        "tilde": 732,
        "Alpha": 913,
        "Beta": 914,
        "Gamma": 915,
        "Delta": 916,
        "Epsilon": 917,
        "Zeta": 918,
        "Eta": 919,
        "Theta": 920,
        "Iota": 921,
        "Kappa": 922,
        "Lambda": 923,
        "Mu": 924,
        "Nu": 925,
        "Xi": 926,
        "Omicron": 927,
        "Pi": 928,
        "Rho": 929,
        "Sigma": 931,
        "Tau": 932,
        "Upsilon": 933,
        "Phi": 934,
        "Chi": 935,
        "Psi": 936,
        "Omega": 937,
        "alpha": 945,
        "beta": 946,
        "gamma": 947,
        "delta": 948,
        "epsilon": 949,
        "zeta": 950,
        "eta": 951,
        "theta": 952,
        "iota": 953,
        "kappa": 954,
        "lambda": 955,
        "mu": 956,
        "nu": 957,
        "xi": 958,
        "omicron": 959,
        "pi": 960,
        "rho": 961,
        "sigmaf": 962,
        "sigma": 963,
        "tau": 964,
        "upsilon": 965,
        "phi": 966,
        "chi": 967,
        "psi": 968,
        "omega": 969,
        "thetasym": 977,
        "upsih": 978,
        "piv": 982,
        "ensp": 8194,
        "emsp": 8195,
        "thinsp": 8201,
        "zwnj": 8204,
        "zwj": 8205,
        "lrm": 8206,
        "rlm": 8207,
        "ndash": 8211,
        "mdash": 8212,
        "lsquo": 8216,
        "rsquo": 8217,
        "sbquo": 8218,
        "ldquo": 8220,
        "rdquo": 8221,
        "bdquo": 8222,
        "dagger": 8224,
        "Dagger": 8225,
        "bull": 8226,
        "hellip": 8230,
        "permil": 8240,
        "prime": 8242,
        "Prime": 8243,
        "lsaquo": 8249,
        "rsaquo": 8250,
        "oline": 8254,
        "frasl": 8260,
        "euro": 8364,
        "image": 8465,
        "weierp": 8472,
        "real": 8476,
        "trade": 8482,
        "alefsym": 8501,
        "larr": 8592,
        "uarr": 8593,
        "rarr": 8594,
        "darr": 8595,
        "harr": 8596,
        "crarr": 8629,
        "lArr": 8656,
        "uArr": 8657,
        "rArr": 8658,
        "dArr": 8659,
        "hArr": 8660,
        "forall": 8704,
        "part": 8706,
        "exist": 8707,
        "empty": 8709,
        "nabla": 8711,
        "isin": 8712,
        "notin": 8713,
        "ni": 8715,
        "prod": 8719,
        "sum": 8721,
        "minus": 8722,
        "lowast": 8727,
        "radic": 8730,
        "prop": 8733,
        "infin": 8734,
        "ang": 8736,
        "and": 8743,
        "or": 8744,
        "cap": 8745,
        "cup": 8746,
        "int": 8747,
        "there4": 8756,
        "sim": 8764,
        "cong": 8773,
        "asymp": 8776,
        "ne": 8800,
        "equiv": 8801,
        "le": 8804,
        "ge": 8805,
        "sub": 8834,
        "sup": 8835,
        "nsub": 8836,
        "sube": 8838,
        "supe": 8839,
        "oplus": 8853,
        "otimes": 8855,
        "perp": 8869,
        "sdot": 8901,
        "lceil": 8968,
        "rceil": 8969,
        "lfloor": 8970,
        "rfloor": 8971,
        "lang": 9001,
        "rang": 9002,
        "loz": 9674,
        "spades": 9824,
        "clubs": 9827,
        "hearts": 9829,
        "diams": 9830
    };
    Object.keys(sax.ENTITIES).forEach(function(key) {
        var e = sax.ENTITIES[key];
        var s = typeof e === "number" ? String.fromCharCode(e) : e;
        sax.ENTITIES[key] = s;
    });
    for(var s in sax.STATE)sax.STATE[sax.STATE[s]] = s;
    // shorthand
    S = sax.STATE;
    function emit(parser, event, data) {
        parser[event] && parser[event](data);
    }
    function emitNode(parser, nodeType, data) {
        if (parser.textNode) closeText(parser);
        emit(parser, nodeType, data);
    }
    function closeText(parser) {
        parser.textNode = textopts(parser.opt, parser.textNode);
        if (parser.textNode) emit(parser, "ontext", parser.textNode);
        parser.textNode = "";
    }
    function textopts(opt, text) {
        if (opt.trim) text = text.trim();
        if (opt.normalize) text = text.replace(/\s+/g, " ");
        return text;
    }
    function error(parser, er) {
        closeText(parser);
        if (parser.trackPosition) er += "\nLine: " + parser.line + "\nColumn: " + parser.column + "\nChar: " + parser.c;
        er = new Error(er);
        parser.error = er;
        emit(parser, "onerror", er);
        return parser;
    }
    function end(parser) {
        if (parser.sawRoot && !parser.closedRoot) strictFail(parser, "Unclosed root tag");
        if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, "Unexpected end");
        closeText(parser);
        parser.c = "";
        parser.closed = true;
        emit(parser, "onend");
        SAXParser.call(parser, parser.strict, parser.opt);
        return parser;
    }
    function strictFail(parser, message) {
        if (typeof parser !== "object" || !(parser instanceof SAXParser)) throw new Error("bad call to strictFail");
        if (parser.strict) error(parser, message);
    }
    function newTag(parser) {
        if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
        var parent = parser.tags[parser.tags.length - 1] || parser;
        var tag = parser.tag = {
            name: parser.tagName,
            attributes: {}
        };
        // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
        if (parser.opt.xmlns) tag.ns = parent.ns;
        parser.attribList.length = 0;
        emitNode(parser, "onopentagstart", tag);
    }
    function qname(name, attribute) {
        var i = name.indexOf(":");
        var qualName = i < 0 ? [
            "",
            name
        ] : name.split(":");
        var prefix = qualName[0];
        var local = qualName[1];
        // <x "xmlns"="http://foo">
        if (attribute && name === "xmlns") {
            prefix = "xmlns";
            local = "";
        }
        return {
            prefix: prefix,
            local: local
        };
    }
    function attrib(parser) {
        if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
        if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
            parser.attribName = parser.attribValue = "";
            return;
        }
        if (parser.opt.xmlns) {
            var qn = qname(parser.attribName, true);
            var prefix = qn.prefix;
            var local = qn.local;
            if (prefix === "xmlns") {
                // namespace binding attribute. push the binding into scope
                if (local === "xml" && parser.attribValue !== XML_NAMESPACE) strictFail(parser, "xml: prefix must be bound to " + XML_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n" + "Actual: " + parser.attribValue);
                else {
                    var tag = parser.tag;
                    var parent = parser.tags[parser.tags.length - 1] || parser;
                    if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                    tag.ns[local] = parser.attribValue;
                }
            }
            // defer onattribute events until all attributes have been seen
            // so any new bindings can take effect. preserve attribute order
            // so deferred events can be emitted in document order
            parser.attribList.push([
                parser.attribName,
                parser.attribValue
            ]);
        } else {
            // in non-xmlns mode, we can emit the event right away
            parser.tag.attributes[parser.attribName] = parser.attribValue;
            emitNode(parser, "onattribute", {
                name: parser.attribName,
                value: parser.attribValue
            });
        }
        parser.attribName = parser.attribValue = "";
    }
    function openTag(parser, selfClosing) {
        if (parser.opt.xmlns) {
            // emit namespace binding events
            var tag = parser.tag;
            // add namespace info to tag
            var qn = qname(parser.tagName);
            tag.prefix = qn.prefix;
            tag.local = qn.local;
            tag.uri = tag.ns[qn.prefix] || "";
            if (tag.prefix && !tag.uri) {
                strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(parser.tagName));
                tag.uri = qn.prefix;
            }
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                emitNode(parser, "onopennamespace", {
                    prefix: p,
                    uri: tag.ns[p]
                });
            });
            // handle deferred onattribute events
            // Note: do not apply default ns to attributes:
            //   http://www.w3.org/TR/REC-xml-names/#defaulting
            for(var i = 0, l = parser.attribList.length; i < l; i++){
                var nv = parser.attribList[i];
                var name = nv[0];
                var value = nv[1];
                var qualName = qname(name, true);
                var prefix = qualName.prefix;
                var local = qualName.local;
                var uri = prefix === "" ? "" : tag.ns[prefix] || "";
                var a = {
                    name: name,
                    value: value,
                    prefix: prefix,
                    local: local,
                    uri: uri
                };
                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (prefix && prefix !== "xmlns" && !uri) {
                    strictFail(parser, "Unbound namespace prefix: " + JSON.stringify(prefix));
                    a.uri = prefix;
                }
                parser.tag.attributes[name] = a;
                emitNode(parser, "onattribute", a);
            }
            parser.attribList.length = 0;
        }
        parser.tag.isSelfClosing = !!selfClosing;
        // process the tag
        parser.sawRoot = true;
        parser.tags.push(parser.tag);
        emitNode(parser, "onopentag", parser.tag);
        if (!selfClosing) {
            // special case for <script> in non-strict mode.
            if (!parser.noscript && parser.tagName.toLowerCase() === "script") parser.state = S.SCRIPT;
            else parser.state = S.TEXT;
            parser.tag = null;
            parser.tagName = "";
        }
        parser.attribName = parser.attribValue = "";
        parser.attribList.length = 0;
    }
    function closeTag(parser) {
        if (!parser.tagName) {
            strictFail(parser, "Weird empty close tag.");
            parser.textNode += "</>";
            parser.state = S.TEXT;
            return;
        }
        if (parser.script) {
            if (parser.tagName !== "script") {
                parser.script += "</" + parser.tagName + ">";
                parser.tagName = "";
                parser.state = S.SCRIPT;
                return;
            }
            emitNode(parser, "onscript", parser.script);
            parser.script = "";
        }
        // first make sure that the closing tag actually exists.
        // <a><b></c></b></a> will close everything, otherwise.
        var t = parser.tags.length;
        var tagName = parser.tagName;
        if (!parser.strict) tagName = tagName[parser.looseCase]();
        var closeTo = tagName;
        while(t--){
            var close = parser.tags[t];
            if (close.name !== closeTo) // fail the first time in strict mode
            strictFail(parser, "Unexpected close tag");
            else break;
        }
        // didn't find it.  we already failed for strict, so just abort.
        if (t < 0) {
            strictFail(parser, "Unmatched closing tag: " + parser.tagName);
            parser.textNode += "</" + parser.tagName + ">";
            parser.state = S.TEXT;
            return;
        }
        parser.tagName = tagName;
        var s = parser.tags.length;
        while(s-- > t){
            var tag = parser.tag = parser.tags.pop();
            parser.tagName = parser.tag.name;
            emitNode(parser, "onclosetag", parser.tagName);
            var x = {};
            for(var i in tag.ns)x[i] = tag.ns[i];
            var parent = parser.tags[parser.tags.length - 1] || parser;
            if (parser.opt.xmlns && tag.ns !== parent.ns) // remove namespace bindings introduced by tag
            Object.keys(tag.ns).forEach(function(p) {
                var n = tag.ns[p];
                emitNode(parser, "onclosenamespace", {
                    prefix: p,
                    uri: n
                });
            });
        }
        if (t === 0) parser.closedRoot = true;
        parser.tagName = parser.attribValue = parser.attribName = "";
        parser.attribList.length = 0;
        parser.state = S.TEXT;
    }
    function parseEntity(parser) {
        var entity = parser.entity;
        var entityLC = entity.toLowerCase();
        var num;
        var numStr = "";
        if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
        if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
        entity = entityLC;
        if (entity.charAt(0) === "#") {
            if (entity.charAt(1) === "x") {
                entity = entity.slice(2);
                num = parseInt(entity, 16);
                numStr = num.toString(16);
            } else {
                entity = entity.slice(1);
                num = parseInt(entity, 10);
                numStr = num.toString(10);
            }
        }
        entity = entity.replace(/^0+/, "");
        if (isNaN(num) || numStr.toLowerCase() !== entity) {
            strictFail(parser, "Invalid character entity");
            return "&" + parser.entity + ";";
        }
        return String.fromCodePoint(num);
    }
    function beginWhiteSpace(parser, c) {
        if (c === "<") {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
        } else if (!isWhitespace(c)) {
            // have to process this as a text node.
            // weird, but happens.
            strictFail(parser, "Non-whitespace before first tag.");
            parser.textNode = c;
            parser.state = S.TEXT;
        }
    }
    function charAt(chunk, i) {
        var result = "";
        if (i < chunk.length) result = chunk.charAt(i);
        return result;
    }
    function write(chunk) {
        var parser = this;
        if (this.error) throw this.error;
        if (parser.closed) return error(parser, "Cannot write after close. Assign an onready handler.");
        if (chunk === null) return end(parser);
        if (typeof chunk === "object") chunk = chunk.toString();
        var i = 0;
        var c = "";
        while(true){
            c = charAt(chunk, i++);
            parser.c = c;
            if (!c) break;
            if (parser.trackPosition) {
                parser.position++;
                if (c === "\n") {
                    parser.line++;
                    parser.column = 0;
                } else parser.column++;
            }
            switch(parser.state){
                case S.BEGIN:
                    parser.state = S.BEGIN_WHITESPACE;
                    if (c === "\uFEFF") continue;
                    beginWhiteSpace(parser, c);
                    continue;
                case S.BEGIN_WHITESPACE:
                    beginWhiteSpace(parser, c);
                    continue;
                case S.TEXT:
                    if (parser.sawRoot && !parser.closedRoot) {
                        var starti = i - 1;
                        while(c && c !== "<" && c !== "&"){
                            c = charAt(chunk, i++);
                            if (c && parser.trackPosition) {
                                parser.position++;
                                if (c === "\n") {
                                    parser.line++;
                                    parser.column = 0;
                                } else parser.column++;
                            }
                        }
                        parser.textNode += chunk.substring(starti, i - 1);
                    }
                    if (c === "<" && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                        parser.state = S.OPEN_WAKA;
                        parser.startTagPosition = parser.position;
                    } else {
                        if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, "Text data outside of root node.");
                        if (c === "&") parser.state = S.TEXT_ENTITY;
                        else parser.textNode += c;
                    }
                    continue;
                case S.SCRIPT:
                    // only non-strict
                    if (c === "<") parser.state = S.SCRIPT_ENDING;
                    else parser.script += c;
                    continue;
                case S.SCRIPT_ENDING:
                    if (c === "/") parser.state = S.CLOSE_TAG;
                    else {
                        parser.script += "<" + c;
                        parser.state = S.SCRIPT;
                    }
                    continue;
                case S.OPEN_WAKA:
                    // either a /, ?, !, or text is coming next.
                    if (c === "!") {
                        parser.state = S.SGML_DECL;
                        parser.sgmlDecl = "";
                    } else if (isWhitespace(c)) ;
                    else if (isMatch(nameStart, c)) {
                        parser.state = S.OPEN_TAG;
                        parser.tagName = c;
                    } else if (c === "/") {
                        parser.state = S.CLOSE_TAG;
                        parser.tagName = "";
                    } else if (c === "?") {
                        parser.state = S.PROC_INST;
                        parser.procInstName = parser.procInstBody = "";
                    } else {
                        strictFail(parser, "Unencoded <");
                        // if there was some whitespace, then add that in.
                        if (parser.startTagPosition + 1 < parser.position) {
                            var pad = parser.position - parser.startTagPosition;
                            c = new Array(pad).join(" ") + c;
                        }
                        parser.textNode += "<" + c;
                        parser.state = S.TEXT;
                    }
                    continue;
                case S.SGML_DECL:
                    if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                        emitNode(parser, "onopencdata");
                        parser.state = S.CDATA;
                        parser.sgmlDecl = "";
                        parser.cdata = "";
                    } else if (parser.sgmlDecl + c === "--") {
                        parser.state = S.COMMENT;
                        parser.comment = "";
                        parser.sgmlDecl = "";
                    } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                        parser.state = S.DOCTYPE;
                        if (parser.doctype || parser.sawRoot) strictFail(parser, "Inappropriately located doctype declaration");
                        parser.doctype = "";
                        parser.sgmlDecl = "";
                    } else if (c === ">") {
                        emitNode(parser, "onsgmldeclaration", parser.sgmlDecl);
                        parser.sgmlDecl = "";
                        parser.state = S.TEXT;
                    } else if (isQuote(c)) {
                        parser.state = S.SGML_DECL_QUOTED;
                        parser.sgmlDecl += c;
                    } else parser.sgmlDecl += c;
                    continue;
                case S.SGML_DECL_QUOTED:
                    if (c === parser.q) {
                        parser.state = S.SGML_DECL;
                        parser.q = "";
                    }
                    parser.sgmlDecl += c;
                    continue;
                case S.DOCTYPE:
                    if (c === ">") {
                        parser.state = S.TEXT;
                        emitNode(parser, "ondoctype", parser.doctype);
                        parser.doctype = true // just remember that we saw it.
                        ;
                    } else {
                        parser.doctype += c;
                        if (c === "[") parser.state = S.DOCTYPE_DTD;
                        else if (isQuote(c)) {
                            parser.state = S.DOCTYPE_QUOTED;
                            parser.q = c;
                        }
                    }
                    continue;
                case S.DOCTYPE_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.q = "";
                        parser.state = S.DOCTYPE;
                    }
                    continue;
                case S.DOCTYPE_DTD:
                    parser.doctype += c;
                    if (c === "]") parser.state = S.DOCTYPE;
                    else if (isQuote(c)) {
                        parser.state = S.DOCTYPE_DTD_QUOTED;
                        parser.q = c;
                    }
                    continue;
                case S.DOCTYPE_DTD_QUOTED:
                    parser.doctype += c;
                    if (c === parser.q) {
                        parser.state = S.DOCTYPE_DTD;
                        parser.q = "";
                    }
                    continue;
                case S.COMMENT:
                    if (c === "-") parser.state = S.COMMENT_ENDING;
                    else parser.comment += c;
                    continue;
                case S.COMMENT_ENDING:
                    if (c === "-") {
                        parser.state = S.COMMENT_ENDED;
                        parser.comment = textopts(parser.opt, parser.comment);
                        if (parser.comment) emitNode(parser, "oncomment", parser.comment);
                        parser.comment = "";
                    } else {
                        parser.comment += "-" + c;
                        parser.state = S.COMMENT;
                    }
                    continue;
                case S.COMMENT_ENDED:
                    if (c !== ">") {
                        strictFail(parser, "Malformed comment");
                        // allow <!-- blah -- bloo --> in non-strict mode,
                        // which is a comment of " blah -- bloo "
                        parser.comment += "--" + c;
                        parser.state = S.COMMENT;
                    } else parser.state = S.TEXT;
                    continue;
                case S.CDATA:
                    if (c === "]") parser.state = S.CDATA_ENDING;
                    else parser.cdata += c;
                    continue;
                case S.CDATA_ENDING:
                    if (c === "]") parser.state = S.CDATA_ENDING_2;
                    else {
                        parser.cdata += "]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.CDATA_ENDING_2:
                    if (c === ">") {
                        if (parser.cdata) emitNode(parser, "oncdata", parser.cdata);
                        emitNode(parser, "onclosecdata");
                        parser.cdata = "";
                        parser.state = S.TEXT;
                    } else if (c === "]") parser.cdata += "]";
                    else {
                        parser.cdata += "]]" + c;
                        parser.state = S.CDATA;
                    }
                    continue;
                case S.PROC_INST:
                    if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                    else parser.procInstName += c;
                    continue;
                case S.PROC_INST_BODY:
                    if (!parser.procInstBody && isWhitespace(c)) continue;
                    else if (c === "?") parser.state = S.PROC_INST_ENDING;
                    else parser.procInstBody += c;
                    continue;
                case S.PROC_INST_ENDING:
                    if (c === ">") {
                        emitNode(parser, "onprocessinginstruction", {
                            name: parser.procInstName,
                            body: parser.procInstBody
                        });
                        parser.procInstName = parser.procInstBody = "";
                        parser.state = S.TEXT;
                    } else {
                        parser.procInstBody += "?" + c;
                        parser.state = S.PROC_INST_BODY;
                    }
                    continue;
                case S.OPEN_TAG:
                    if (isMatch(nameBody, c)) parser.tagName += c;
                    else {
                        newTag(parser);
                        if (c === ">") openTag(parser);
                        else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                        else {
                            if (!isWhitespace(c)) strictFail(parser, "Invalid character in tag name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.OPEN_TAG_SLASH:
                    if (c === ">") {
                        openTag(parser, true);
                        closeTag(parser);
                    } else {
                        strictFail(parser, "Forward-slash in opening tag not followed by >");
                        parser.state = S.ATTRIB;
                    }
                    continue;
                case S.ATTRIB:
                    // haven't read the attribute name yet.
                    if (isWhitespace(c)) continue;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (c === ">") {
                        strictFail(parser, "Attribute without value");
                        parser.attribValue = parser.attribName;
                        attrib(parser);
                        openTag(parser);
                    } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                    else if (isMatch(nameBody, c)) parser.attribName += c;
                    else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_NAME_SAW_WHITE:
                    if (c === "=") parser.state = S.ATTRIB_VALUE;
                    else if (isWhitespace(c)) continue;
                    else {
                        strictFail(parser, "Attribute without value");
                        parser.tag.attributes[parser.attribName] = "";
                        parser.attribValue = "";
                        emitNode(parser, "onattribute", {
                            name: parser.attribName,
                            value: ""
                        });
                        parser.attribName = "";
                        if (c === ">") openTag(parser);
                        else if (isMatch(nameStart, c)) {
                            parser.attribName = c;
                            parser.state = S.ATTRIB_NAME;
                        } else {
                            strictFail(parser, "Invalid attribute name");
                            parser.state = S.ATTRIB;
                        }
                    }
                    continue;
                case S.ATTRIB_VALUE:
                    if (isWhitespace(c)) continue;
                    else if (isQuote(c)) {
                        parser.q = c;
                        parser.state = S.ATTRIB_VALUE_QUOTED;
                    } else {
                        strictFail(parser, "Unquoted attribute value");
                        parser.state = S.ATTRIB_VALUE_UNQUOTED;
                        parser.attribValue = c;
                    }
                    continue;
                case S.ATTRIB_VALUE_QUOTED:
                    if (c !== parser.q) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    parser.q = "";
                    parser.state = S.ATTRIB_VALUE_CLOSED;
                    continue;
                case S.ATTRIB_VALUE_CLOSED:
                    if (isWhitespace(c)) parser.state = S.ATTRIB;
                    else if (c === ">") openTag(parser);
                    else if (c === "/") parser.state = S.OPEN_TAG_SLASH;
                    else if (isMatch(nameStart, c)) {
                        strictFail(parser, "No whitespace between attributes");
                        parser.attribName = c;
                        parser.attribValue = "";
                        parser.state = S.ATTRIB_NAME;
                    } else strictFail(parser, "Invalid attribute name");
                    continue;
                case S.ATTRIB_VALUE_UNQUOTED:
                    if (!isAttribEnd(c)) {
                        if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U;
                        else parser.attribValue += c;
                        continue;
                    }
                    attrib(parser);
                    if (c === ">") openTag(parser);
                    else parser.state = S.ATTRIB;
                    continue;
                case S.CLOSE_TAG:
                    if (!parser.tagName) {
                        if (isWhitespace(c)) continue;
                        else if (notMatch(nameStart, c)) {
                            if (parser.script) {
                                parser.script += "</" + c;
                                parser.state = S.SCRIPT;
                            } else strictFail(parser, "Invalid tagname in closing tag.");
                        } else parser.tagName = c;
                    } else if (c === ">") closeTag(parser);
                    else if (isMatch(nameBody, c)) parser.tagName += c;
                    else if (parser.script) {
                        parser.script += "</" + parser.tagName;
                        parser.tagName = "";
                        parser.state = S.SCRIPT;
                    } else {
                        if (!isWhitespace(c)) strictFail(parser, "Invalid tagname in closing tag");
                        parser.state = S.CLOSE_TAG_SAW_WHITE;
                    }
                    continue;
                case S.CLOSE_TAG_SAW_WHITE:
                    if (isWhitespace(c)) continue;
                    if (c === ">") closeTag(parser);
                    else strictFail(parser, "Invalid characters in closing tag");
                    continue;
                case S.TEXT_ENTITY:
                case S.ATTRIB_VALUE_ENTITY_Q:
                case S.ATTRIB_VALUE_ENTITY_U:
                    var returnState;
                    var buffer;
                    switch(parser.state){
                        case S.TEXT_ENTITY:
                            returnState = S.TEXT;
                            buffer = "textNode";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_Q:
                            returnState = S.ATTRIB_VALUE_QUOTED;
                            buffer = "attribValue";
                            break;
                        case S.ATTRIB_VALUE_ENTITY_U:
                            returnState = S.ATTRIB_VALUE_UNQUOTED;
                            buffer = "attribValue";
                            break;
                    }
                    if (c === ";") {
                        parser[buffer] += parseEntity(parser);
                        parser.entity = "";
                        parser.state = returnState;
                    } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                    else {
                        strictFail(parser, "Invalid character in entity name");
                        parser[buffer] += "&" + parser.entity + c;
                        parser.entity = "";
                        parser.state = returnState;
                    }
                    continue;
                default:
                    throw new Error(parser, "Unknown state: " + parser.state);
            }
        } // while
        if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
        return parser;
    }
    /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ /* istanbul ignore next */ if (!String.fromCodePoint) (function() {
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        var fromCodePoint = function() {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) return "";
            var result = "";
            while(++index < length){
                var codePoint = Number(arguments[index]);
                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                codePoint < 0 || // not a valid Unicode code point
                codePoint > 0x10FFFF || // not a valid Unicode code point
                floor(codePoint) !== codePoint // not an integer
                ) throw RangeError("Invalid code point: " + codePoint);
                if (codePoint <= 0xFFFF) codeUnits.push(codePoint);
                else {
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xD800;
                    lowSurrogate = codePoint % 0x400 + 0xDC00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        /* istanbul ignore next */ if (Object.defineProperty) Object.defineProperty(String, "fromCodePoint", {
            value: fromCodePoint,
            configurable: true,
            writable: true
        });
        else String.fromCodePoint = fromCodePoint;
    })();
})($a39a5ccf1aa3cd6a$exports);


var $7de0f1800c3a1686$var$expat /*= require('node-expat');*/  = {
    on: function() {},
    parse: function() {}
};
var $6714637a19f5917f$exports = {};
var $d2fbd6afa0ccfad3$exports = {};
$d2fbd6afa0ccfad3$exports = {
    isArray: function(value) {
        if (Array.isArray) return Array.isArray(value);
        // fallback for older browsers like  IE 8
        return Object.prototype.toString.call(value) === "[object Array]";
    }
};


var $6714637a19f5917f$require$isArray = $d2fbd6afa0ccfad3$exports.isArray;
$6714637a19f5917f$exports = {
    copyOptions: function(options) {
        var key, copy = {};
        for(key in options)if (options.hasOwnProperty(key)) copy[key] = options[key];
        return copy;
    },
    ensureFlagExists: function(item, options) {
        if (!(item in options) || typeof options[item] !== "boolean") options[item] = false;
    },
    ensureSpacesExists: function(options) {
        if (!("spaces" in options) || typeof options.spaces !== "number" && typeof options.spaces !== "string") options.spaces = 0;
    },
    ensureAlwaysArrayExists: function(options) {
        if (!("alwaysArray" in options) || typeof options.alwaysArray !== "boolean" && !$6714637a19f5917f$require$isArray(options.alwaysArray)) options.alwaysArray = false;
    },
    ensureKeyExists: function(key, options) {
        if (!(key + "Key" in options) || typeof options[key + "Key"] !== "string") options[key + "Key"] = options.compact ? "_" + key : key;
    },
    checkFnExists: function(key, options) {
        return key + "Fn" in options;
    }
};



var $7de0f1800c3a1686$require$isArray = $d2fbd6afa0ccfad3$exports.isArray;
var $7de0f1800c3a1686$var$options;
var $7de0f1800c3a1686$var$pureJsParser = true;
var $7de0f1800c3a1686$var$currentElement;
function $7de0f1800c3a1686$var$validateOptions(userOptions) {
    $7de0f1800c3a1686$var$options = $6714637a19f5917f$exports.copyOptions(userOptions);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreDeclaration", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreInstruction", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreAttributes", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreText", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreComment", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreCdata", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreDoctype", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("compact", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("alwaysChildren", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("addParent", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("trim", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("nativeType", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("nativeTypeAttributes", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("sanitize", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("instructionHasAttributes", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureFlagExists("captureSpacesBetweenElements", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureAlwaysArrayExists($7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("declaration", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("instruction", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("attributes", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("text", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("comment", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("cdata", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("doctype", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("type", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("name", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("elements", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.ensureKeyExists("parent", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("doctype", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("instruction", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("cdata", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("comment", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("text", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("instructionName", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("elementName", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("attributeName", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("attributeValue", $7de0f1800c3a1686$var$options);
    $6714637a19f5917f$exports.checkFnExists("attributes", $7de0f1800c3a1686$var$options);
    return $7de0f1800c3a1686$var$options;
}
function $7de0f1800c3a1686$var$nativeType(value) {
    var nValue = Number(value);
    if (!isNaN(nValue)) return nValue;
    var bValue = value.toLowerCase();
    if (bValue === "true") return true;
    else if (bValue === "false") return false;
    return value;
}
function $7de0f1800c3a1686$var$addField(type, value) {
    var key;
    if ($7de0f1800c3a1686$var$options.compact) {
        if (!$7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]] && ($7de0f1800c3a1686$require$isArray($7de0f1800c3a1686$var$options.alwaysArray) ? $7de0f1800c3a1686$var$options.alwaysArray.indexOf($7de0f1800c3a1686$var$options[type + "Key"]) !== -1 : $7de0f1800c3a1686$var$options.alwaysArray)) $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]] = [];
        if ($7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]] && !$7de0f1800c3a1686$require$isArray($7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]])) $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]] = [
            $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]]
        ];
        if (type + "Fn" in $7de0f1800c3a1686$var$options && typeof value === "string") value = $7de0f1800c3a1686$var$options[type + "Fn"](value, $7de0f1800c3a1686$var$currentElement);
        if (type === "instruction" && ("instructionFn" in $7de0f1800c3a1686$var$options || "instructionNameFn" in $7de0f1800c3a1686$var$options)) {
            for(key in value)if (value.hasOwnProperty(key)) {
                if ("instructionFn" in $7de0f1800c3a1686$var$options) value[key] = $7de0f1800c3a1686$var$options.instructionFn(value[key], key, $7de0f1800c3a1686$var$currentElement);
                else {
                    var temp = value[key];
                    delete value[key];
                    value[$7de0f1800c3a1686$var$options.instructionNameFn(key, temp, $7de0f1800c3a1686$var$currentElement)] = temp;
                }
            }
        }
        if ($7de0f1800c3a1686$require$isArray($7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]])) $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]].push(value);
        else $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options[type + "Key"]] = value;
    } else {
        if (!$7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.elementsKey]) $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.elementsKey] = [];
        var element = {};
        element[$7de0f1800c3a1686$var$options.typeKey] = type;
        if (type === "instruction") {
            for(key in value){
                if (value.hasOwnProperty(key)) break;
            }
            element[$7de0f1800c3a1686$var$options.nameKey] = "instructionNameFn" in $7de0f1800c3a1686$var$options ? $7de0f1800c3a1686$var$options.instructionNameFn(key, value, $7de0f1800c3a1686$var$currentElement) : key;
            if ($7de0f1800c3a1686$var$options.instructionHasAttributes) {
                element[$7de0f1800c3a1686$var$options.attributesKey] = value[key][$7de0f1800c3a1686$var$options.attributesKey];
                if ("instructionFn" in $7de0f1800c3a1686$var$options) element[$7de0f1800c3a1686$var$options.attributesKey] = $7de0f1800c3a1686$var$options.instructionFn(element[$7de0f1800c3a1686$var$options.attributesKey], key, $7de0f1800c3a1686$var$currentElement);
            } else {
                if ("instructionFn" in $7de0f1800c3a1686$var$options) value[key] = $7de0f1800c3a1686$var$options.instructionFn(value[key], key, $7de0f1800c3a1686$var$currentElement);
                element[$7de0f1800c3a1686$var$options.instructionKey] = value[key];
            }
        } else {
            if (type + "Fn" in $7de0f1800c3a1686$var$options) value = $7de0f1800c3a1686$var$options[type + "Fn"](value, $7de0f1800c3a1686$var$currentElement);
            element[$7de0f1800c3a1686$var$options[type + "Key"]] = value;
        }
        if ($7de0f1800c3a1686$var$options.addParent) element[$7de0f1800c3a1686$var$options.parentKey] = $7de0f1800c3a1686$var$currentElement;
        $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.elementsKey].push(element);
    }
}
function $7de0f1800c3a1686$var$manipulateAttributes(attributes) {
    if ("attributesFn" in $7de0f1800c3a1686$var$options && attributes) attributes = $7de0f1800c3a1686$var$options.attributesFn(attributes, $7de0f1800c3a1686$var$currentElement);
    if (($7de0f1800c3a1686$var$options.trim || "attributeValueFn" in $7de0f1800c3a1686$var$options || "attributeNameFn" in $7de0f1800c3a1686$var$options || $7de0f1800c3a1686$var$options.nativeTypeAttributes) && attributes) {
        var key;
        for(key in attributes)if (attributes.hasOwnProperty(key)) {
            if ($7de0f1800c3a1686$var$options.trim) attributes[key] = attributes[key].trim();
            if ($7de0f1800c3a1686$var$options.nativeTypeAttributes) attributes[key] = $7de0f1800c3a1686$var$nativeType(attributes[key]);
            if ("attributeValueFn" in $7de0f1800c3a1686$var$options) attributes[key] = $7de0f1800c3a1686$var$options.attributeValueFn(attributes[key], key, $7de0f1800c3a1686$var$currentElement);
            if ("attributeNameFn" in $7de0f1800c3a1686$var$options) {
                var temp = attributes[key];
                delete attributes[key];
                attributes[$7de0f1800c3a1686$var$options.attributeNameFn(key, attributes[key], $7de0f1800c3a1686$var$currentElement)] = temp;
            }
        }
    }
    return attributes;
}
function $7de0f1800c3a1686$var$onInstruction(instruction) {
    var attributes = {};
    if (instruction.body && (instruction.name.toLowerCase() === "xml" || $7de0f1800c3a1686$var$options.instructionHasAttributes)) {
        var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
        var match;
        while((match = attrsRegExp.exec(instruction.body)) !== null)attributes[match[1]] = match[2] || match[3] || match[4];
        attributes = $7de0f1800c3a1686$var$manipulateAttributes(attributes);
    }
    if (instruction.name.toLowerCase() === "xml") {
        if ($7de0f1800c3a1686$var$options.ignoreDeclaration) return;
        $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.declarationKey] = {};
        if (Object.keys(attributes).length) $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.declarationKey][$7de0f1800c3a1686$var$options.attributesKey] = attributes;
        if ($7de0f1800c3a1686$var$options.addParent) $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.declarationKey][$7de0f1800c3a1686$var$options.parentKey] = $7de0f1800c3a1686$var$currentElement;
    } else {
        if ($7de0f1800c3a1686$var$options.ignoreInstruction) return;
        if ($7de0f1800c3a1686$var$options.trim) instruction.body = instruction.body.trim();
        var value = {};
        if ($7de0f1800c3a1686$var$options.instructionHasAttributes && Object.keys(attributes).length) {
            value[instruction.name] = {};
            value[instruction.name][$7de0f1800c3a1686$var$options.attributesKey] = attributes;
        } else value[instruction.name] = instruction.body;
        $7de0f1800c3a1686$var$addField("instruction", value);
    }
}
function $7de0f1800c3a1686$var$onStartElement(name, attributes) {
    var element;
    if (typeof name === "object") {
        attributes = name.attributes;
        name = name.name;
    }
    attributes = $7de0f1800c3a1686$var$manipulateAttributes(attributes);
    if ("elementNameFn" in $7de0f1800c3a1686$var$options) name = $7de0f1800c3a1686$var$options.elementNameFn(name, $7de0f1800c3a1686$var$currentElement);
    if ($7de0f1800c3a1686$var$options.compact) {
        element = {};
        if (!$7de0f1800c3a1686$var$options.ignoreAttributes && attributes && Object.keys(attributes).length) {
            element[$7de0f1800c3a1686$var$options.attributesKey] = {};
            var key;
            for(key in attributes)if (attributes.hasOwnProperty(key)) element[$7de0f1800c3a1686$var$options.attributesKey][key] = attributes[key];
        }
        if (!(name in $7de0f1800c3a1686$var$currentElement) && ($7de0f1800c3a1686$require$isArray($7de0f1800c3a1686$var$options.alwaysArray) ? $7de0f1800c3a1686$var$options.alwaysArray.indexOf(name) !== -1 : $7de0f1800c3a1686$var$options.alwaysArray)) $7de0f1800c3a1686$var$currentElement[name] = [];
        if ($7de0f1800c3a1686$var$currentElement[name] && !$7de0f1800c3a1686$require$isArray($7de0f1800c3a1686$var$currentElement[name])) $7de0f1800c3a1686$var$currentElement[name] = [
            $7de0f1800c3a1686$var$currentElement[name]
        ];
        if ($7de0f1800c3a1686$require$isArray($7de0f1800c3a1686$var$currentElement[name])) $7de0f1800c3a1686$var$currentElement[name].push(element);
        else $7de0f1800c3a1686$var$currentElement[name] = element;
    } else {
        if (!$7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.elementsKey]) $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.elementsKey] = [];
        element = {};
        element[$7de0f1800c3a1686$var$options.typeKey] = "element";
        element[$7de0f1800c3a1686$var$options.nameKey] = name;
        if (!$7de0f1800c3a1686$var$options.ignoreAttributes && attributes && Object.keys(attributes).length) element[$7de0f1800c3a1686$var$options.attributesKey] = attributes;
        if ($7de0f1800c3a1686$var$options.alwaysChildren) element[$7de0f1800c3a1686$var$options.elementsKey] = [];
        $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.elementsKey].push(element);
    }
    element[$7de0f1800c3a1686$var$options.parentKey] = $7de0f1800c3a1686$var$currentElement; // will be deleted in onEndElement() if !options.addParent
    $7de0f1800c3a1686$var$currentElement = element;
}
function $7de0f1800c3a1686$var$onText(text) {
    if ($7de0f1800c3a1686$var$options.ignoreText) return;
    if (!text.trim() && !$7de0f1800c3a1686$var$options.captureSpacesBetweenElements) return;
    if ($7de0f1800c3a1686$var$options.trim) text = text.trim();
    if ($7de0f1800c3a1686$var$options.nativeType) text = $7de0f1800c3a1686$var$nativeType(text);
    if ($7de0f1800c3a1686$var$options.sanitize) text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    $7de0f1800c3a1686$var$addField("text", text);
}
function $7de0f1800c3a1686$var$onComment(comment) {
    if ($7de0f1800c3a1686$var$options.ignoreComment) return;
    if ($7de0f1800c3a1686$var$options.trim) comment = comment.trim();
    $7de0f1800c3a1686$var$addField("comment", comment);
}
function $7de0f1800c3a1686$var$onEndElement(name) {
    var parentElement = $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.parentKey];
    if (!$7de0f1800c3a1686$var$options.addParent) delete $7de0f1800c3a1686$var$currentElement[$7de0f1800c3a1686$var$options.parentKey];
    $7de0f1800c3a1686$var$currentElement = parentElement;
}
function $7de0f1800c3a1686$var$onCdata(cdata) {
    if ($7de0f1800c3a1686$var$options.ignoreCdata) return;
    if ($7de0f1800c3a1686$var$options.trim) cdata = cdata.trim();
    $7de0f1800c3a1686$var$addField("cdata", cdata);
}
function $7de0f1800c3a1686$var$onDoctype(doctype) {
    if ($7de0f1800c3a1686$var$options.ignoreDoctype) return;
    doctype = doctype.replace(/^ /, "");
    if ($7de0f1800c3a1686$var$options.trim) doctype = doctype.trim();
    $7de0f1800c3a1686$var$addField("doctype", doctype);
}
function $7de0f1800c3a1686$var$onError(error) {
    error.note = error; //console.error(error);
}
$7de0f1800c3a1686$exports = function(xml, userOptions) {
    var parser = $7de0f1800c3a1686$var$pureJsParser ? $a39a5ccf1aa3cd6a$exports.parser(true, {}) : parser = new $7de0f1800c3a1686$var$expat.Parser("UTF-8");
    var result = {};
    $7de0f1800c3a1686$var$currentElement = result;
    $7de0f1800c3a1686$var$options = $7de0f1800c3a1686$var$validateOptions(userOptions);
    if ($7de0f1800c3a1686$var$pureJsParser) {
        parser.opt = {
            strictEntities: true
        };
        parser.onopentag = $7de0f1800c3a1686$var$onStartElement;
        parser.ontext = $7de0f1800c3a1686$var$onText;
        parser.oncomment = $7de0f1800c3a1686$var$onComment;
        parser.onclosetag = $7de0f1800c3a1686$var$onEndElement;
        parser.onerror = $7de0f1800c3a1686$var$onError;
        parser.oncdata = $7de0f1800c3a1686$var$onCdata;
        parser.ondoctype = $7de0f1800c3a1686$var$onDoctype;
        parser.onprocessinginstruction = $7de0f1800c3a1686$var$onInstruction;
    } else {
        parser.on("startElement", $7de0f1800c3a1686$var$onStartElement);
        parser.on("text", $7de0f1800c3a1686$var$onText);
        parser.on("comment", $7de0f1800c3a1686$var$onComment);
        parser.on("endElement", $7de0f1800c3a1686$var$onEndElement);
        parser.on("error", $7de0f1800c3a1686$var$onError);
    //parser.on('startCdata', onStartCdata);
    //parser.on('endCdata', onEndCdata);
    //parser.on('entityDecl', onEntityDecl);
    }
    if ($7de0f1800c3a1686$var$pureJsParser) parser.write(xml).close();
    else {
        if (!parser.parse(xml)) throw new Error("XML parsing error: " + parser.getError());
    }
    if (result[$7de0f1800c3a1686$var$options.elementsKey]) {
        var temp = result[$7de0f1800c3a1686$var$options.elementsKey];
        delete result[$7de0f1800c3a1686$var$options.elementsKey];
        result[$7de0f1800c3a1686$var$options.elementsKey] = temp;
        delete result.text;
    }
    return result;
};


var $1c4abbdb3a3a61ac$exports = {};


function $1c4abbdb3a3a61ac$var$validateOptions(userOptions) {
    var options = $6714637a19f5917f$exports.copyOptions(userOptions);
    $6714637a19f5917f$exports.ensureSpacesExists(options);
    return options;
}
$1c4abbdb3a3a61ac$exports = function(xml, userOptions) {
    var options, js, json, parentKey;
    options = $1c4abbdb3a3a61ac$var$validateOptions(userOptions);
    js = $7de0f1800c3a1686$exports(xml, options);
    parentKey = "compact" in options && options.compact ? "_parent" : "parent";
    // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
    if ("addParent" in options && options.addParent) json = JSON.stringify(js, function(k, v) {
        return k === parentKey ? "_" : v;
    }, options.spaces);
    else json = JSON.stringify(js, null, options.spaces);
    return json.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
};


var $0e37643ddda5f2e6$exports = {};


var $0e37643ddda5f2e6$require$isArray = $d2fbd6afa0ccfad3$exports.isArray;
var $0e37643ddda5f2e6$var$currentElement, $0e37643ddda5f2e6$var$currentElementName;
function $0e37643ddda5f2e6$var$validateOptions(userOptions) {
    var options = $6714637a19f5917f$exports.copyOptions(userOptions);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreDeclaration", options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreInstruction", options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreAttributes", options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreText", options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreComment", options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreCdata", options);
    $6714637a19f5917f$exports.ensureFlagExists("ignoreDoctype", options);
    $6714637a19f5917f$exports.ensureFlagExists("compact", options);
    $6714637a19f5917f$exports.ensureFlagExists("indentText", options);
    $6714637a19f5917f$exports.ensureFlagExists("indentCdata", options);
    $6714637a19f5917f$exports.ensureFlagExists("indentAttributes", options);
    $6714637a19f5917f$exports.ensureFlagExists("indentInstruction", options);
    $6714637a19f5917f$exports.ensureFlagExists("fullTagEmptyElement", options);
    $6714637a19f5917f$exports.ensureFlagExists("noQuotesForNativeAttributes", options);
    $6714637a19f5917f$exports.ensureSpacesExists(options);
    if (typeof options.spaces === "number") options.spaces = Array(options.spaces + 1).join(" ");
    $6714637a19f5917f$exports.ensureKeyExists("declaration", options);
    $6714637a19f5917f$exports.ensureKeyExists("instruction", options);
    $6714637a19f5917f$exports.ensureKeyExists("attributes", options);
    $6714637a19f5917f$exports.ensureKeyExists("text", options);
    $6714637a19f5917f$exports.ensureKeyExists("comment", options);
    $6714637a19f5917f$exports.ensureKeyExists("cdata", options);
    $6714637a19f5917f$exports.ensureKeyExists("doctype", options);
    $6714637a19f5917f$exports.ensureKeyExists("type", options);
    $6714637a19f5917f$exports.ensureKeyExists("name", options);
    $6714637a19f5917f$exports.ensureKeyExists("elements", options);
    $6714637a19f5917f$exports.checkFnExists("doctype", options);
    $6714637a19f5917f$exports.checkFnExists("instruction", options);
    $6714637a19f5917f$exports.checkFnExists("cdata", options);
    $6714637a19f5917f$exports.checkFnExists("comment", options);
    $6714637a19f5917f$exports.checkFnExists("text", options);
    $6714637a19f5917f$exports.checkFnExists("instructionName", options);
    $6714637a19f5917f$exports.checkFnExists("elementName", options);
    $6714637a19f5917f$exports.checkFnExists("attributeName", options);
    $6714637a19f5917f$exports.checkFnExists("attributeValue", options);
    $6714637a19f5917f$exports.checkFnExists("attributes", options);
    $6714637a19f5917f$exports.checkFnExists("fullTagEmptyElement", options);
    return options;
}
function $0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine) {
    return (!firstLine && options.spaces ? "\n" : "") + Array(depth + 1).join(options.spaces);
}
function $0e37643ddda5f2e6$var$writeAttributes(attributes, options, depth) {
    if (options.ignoreAttributes) return "";
    if ("attributesFn" in options) attributes = options.attributesFn(attributes, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement);
    var key, attr, attrName, quote, result = [];
    for(key in attributes)if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
        quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== "string" ? "" : '"';
        attr = "" + attributes[key]; // ensure number and boolean are converted to String
        attr = attr.replace(/"/g, "&quot;");
        attrName = "attributeNameFn" in options ? options.attributeNameFn(key, attr, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement) : key;
        result.push(options.spaces && options.indentAttributes ? $0e37643ddda5f2e6$var$writeIndentation(options, depth + 1, false) : " ");
        result.push(attrName + "=" + quote + ("attributeValueFn" in options ? options.attributeValueFn(attr, key, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement) : attr) + quote);
    }
    if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) result.push($0e37643ddda5f2e6$var$writeIndentation(options, depth, false));
    return result.join("");
}
function $0e37643ddda5f2e6$var$writeDeclaration(declaration, options, depth) {
    $0e37643ddda5f2e6$var$currentElement = declaration;
    $0e37643ddda5f2e6$var$currentElementName = "xml";
    return options.ignoreDeclaration ? "" : "<?xml" + $0e37643ddda5f2e6$var$writeAttributes(declaration[options.attributesKey], options, depth) + "?>";
}
function $0e37643ddda5f2e6$var$writeInstruction(instruction, options, depth) {
    if (options.ignoreInstruction) return "";
    var key;
    for(key in instruction){
        if (instruction.hasOwnProperty(key)) break;
    }
    var instructionName = "instructionNameFn" in options ? options.instructionNameFn(key, instruction[key], $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement) : key;
    if (typeof instruction[key] === "object") {
        $0e37643ddda5f2e6$var$currentElement = instruction;
        $0e37643ddda5f2e6$var$currentElementName = instructionName;
        return "<?" + instructionName + $0e37643ddda5f2e6$var$writeAttributes(instruction[key][options.attributesKey], options, depth) + "?>";
    } else {
        var instructionValue = instruction[key] ? instruction[key] : "";
        if ("instructionFn" in options) instructionValue = options.instructionFn(instructionValue, key, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement);
        return "<?" + instructionName + (instructionValue ? " " + instructionValue : "") + "?>";
    }
}
function $0e37643ddda5f2e6$var$writeComment(comment, options) {
    return options.ignoreComment ? "" : "<!--" + ("commentFn" in options ? options.commentFn(comment, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement) : comment) + "-->";
}
function $0e37643ddda5f2e6$var$writeCdata(cdata, options) {
    return options.ignoreCdata ? "" : "<![CDATA[" + ("cdataFn" in options ? options.cdataFn(cdata, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement) : cdata.replace("]]>", "]]]]><![CDATA[>")) + "]]>";
}
function $0e37643ddda5f2e6$var$writeDoctype(doctype, options) {
    return options.ignoreDoctype ? "" : "<!DOCTYPE " + ("doctypeFn" in options ? options.doctypeFn(doctype, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement) : doctype) + ">";
}
function $0e37643ddda5f2e6$var$writeText(text, options) {
    if (options.ignoreText) return "";
    text = "" + text; // ensure Number and Boolean are converted to String
    text = text.replace(/&amp;/g, "&"); // desanitize to avoid double sanitization
    text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return "textFn" in options ? options.textFn(text, $0e37643ddda5f2e6$var$currentElementName, $0e37643ddda5f2e6$var$currentElement) : text;
}
function $0e37643ddda5f2e6$var$hasContent(element, options) {
    var i;
    if (element.elements && element.elements.length) for(i = 0; i < element.elements.length; ++i)switch(element.elements[i][options.typeKey]){
        case "text":
            if (options.indentText) return true;
            break; // skip to next key
        case "cdata":
            if (options.indentCdata) return true;
            break; // skip to next key
        case "instruction":
            if (options.indentInstruction) return true;
            break; // skip to next key
        case "doctype":
        case "comment":
        case "element":
            return true;
        default:
            return true;
    }
    return false;
}
function $0e37643ddda5f2e6$var$writeElement(element, options, depth) {
    $0e37643ddda5f2e6$var$currentElement = element;
    $0e37643ddda5f2e6$var$currentElementName = element.name;
    var xml = [], elementName = "elementNameFn" in options ? options.elementNameFn(element.name, element) : element.name;
    xml.push("<" + elementName);
    if (element[options.attributesKey]) xml.push($0e37643ddda5f2e6$var$writeAttributes(element[options.attributesKey], options, depth));
    var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]["xml:space"] === "preserve";
    if (!withClosingTag) {
        if ("fullTagEmptyElementFn" in options) withClosingTag = options.fullTagEmptyElementFn(element.name, element);
        else withClosingTag = options.fullTagEmptyElement;
    }
    if (withClosingTag) {
        xml.push(">");
        if (element[options.elementsKey] && element[options.elementsKey].length) {
            xml.push($0e37643ddda5f2e6$var$writeElements(element[options.elementsKey], options, depth + 1));
            $0e37643ddda5f2e6$var$currentElement = element;
            $0e37643ddda5f2e6$var$currentElementName = element.name;
        }
        xml.push(options.spaces && $0e37643ddda5f2e6$var$hasContent(element, options) ? "\n" + Array(depth + 1).join(options.spaces) : "");
        xml.push("</" + elementName + ">");
    } else xml.push("/>");
    return xml.join("");
}
function $0e37643ddda5f2e6$var$writeElements(elements, options, depth, firstLine) {
    return elements.reduce(function(xml, element) {
        var indent = $0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine && !xml);
        switch(element.type){
            case "element":
                return xml + indent + $0e37643ddda5f2e6$var$writeElement(element, options, depth);
            case "comment":
                return xml + indent + $0e37643ddda5f2e6$var$writeComment(element[options.commentKey], options);
            case "doctype":
                return xml + indent + $0e37643ddda5f2e6$var$writeDoctype(element[options.doctypeKey], options);
            case "cdata":
                return xml + (options.indentCdata ? indent : "") + $0e37643ddda5f2e6$var$writeCdata(element[options.cdataKey], options);
            case "text":
                return xml + (options.indentText ? indent : "") + $0e37643ddda5f2e6$var$writeText(element[options.textKey], options);
            case "instruction":
                var instruction = {};
                instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
                return xml + (options.indentInstruction ? indent : "") + $0e37643ddda5f2e6$var$writeInstruction(instruction, options, depth);
        }
    }, "");
}
function $0e37643ddda5f2e6$var$hasContentCompact(element, options, anyContent) {
    var key;
    for(key in element)if (element.hasOwnProperty(key)) switch(key){
        case options.parentKey:
        case options.attributesKey:
            break; // skip to next key
        case options.textKey:
            if (options.indentText || anyContent) return true;
            break; // skip to next key
        case options.cdataKey:
            if (options.indentCdata || anyContent) return true;
            break; // skip to next key
        case options.instructionKey:
            if (options.indentInstruction || anyContent) return true;
            break; // skip to next key
        case options.doctypeKey:
        case options.commentKey:
            return true;
        default:
            return true;
    }
    return false;
}
function $0e37643ddda5f2e6$var$writeElementCompact(element, name, options, depth, indent) {
    $0e37643ddda5f2e6$var$currentElement = element;
    $0e37643ddda5f2e6$var$currentElementName = name;
    var elementName = "elementNameFn" in options ? options.elementNameFn(name, element) : name;
    if (typeof element === "undefined" || element === null || element === "") return "fullTagEmptyElementFn" in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? "<" + elementName + "></" + elementName + ">" : "<" + elementName + "/>";
    var xml = [];
    if (name) {
        xml.push("<" + elementName);
        if (typeof element !== "object") {
            xml.push(">" + $0e37643ddda5f2e6$var$writeText(element, options) + "</" + elementName + ">");
            return xml.join("");
        }
        if (element[options.attributesKey]) xml.push($0e37643ddda5f2e6$var$writeAttributes(element[options.attributesKey], options, depth));
        var withClosingTag = $0e37643ddda5f2e6$var$hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]["xml:space"] === "preserve";
        if (!withClosingTag) {
            if ("fullTagEmptyElementFn" in options) withClosingTag = options.fullTagEmptyElementFn(name, element);
            else withClosingTag = options.fullTagEmptyElement;
        }
        if (withClosingTag) xml.push(">");
        else {
            xml.push("/>");
            return xml.join("");
        }
    }
    xml.push($0e37643ddda5f2e6$var$writeElementsCompact(element, options, depth + 1, false));
    $0e37643ddda5f2e6$var$currentElement = element;
    $0e37643ddda5f2e6$var$currentElementName = name;
    if (name) xml.push((indent ? $0e37643ddda5f2e6$var$writeIndentation(options, depth, false) : "") + "</" + elementName + ">");
    return xml.join("");
}
function $0e37643ddda5f2e6$var$writeElementsCompact(element, options, depth, firstLine) {
    var i, key, nodes, xml = [];
    for(key in element)if (element.hasOwnProperty(key)) {
        nodes = $0e37643ddda5f2e6$require$isArray(element[key]) ? element[key] : [
            element[key]
        ];
        for(i = 0; i < nodes.length; ++i){
            switch(key){
                case options.declarationKey:
                    xml.push($0e37643ddda5f2e6$var$writeDeclaration(nodes[i], options, depth));
                    break;
                case options.instructionKey:
                    xml.push((options.indentInstruction ? $0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine) : "") + $0e37643ddda5f2e6$var$writeInstruction(nodes[i], options, depth));
                    break;
                case options.attributesKey:
                case options.parentKey:
                    break; // skip
                case options.textKey:
                    xml.push((options.indentText ? $0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine) : "") + $0e37643ddda5f2e6$var$writeText(nodes[i], options));
                    break;
                case options.cdataKey:
                    xml.push((options.indentCdata ? $0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine) : "") + $0e37643ddda5f2e6$var$writeCdata(nodes[i], options));
                    break;
                case options.doctypeKey:
                    xml.push($0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine) + $0e37643ddda5f2e6$var$writeDoctype(nodes[i], options));
                    break;
                case options.commentKey:
                    xml.push($0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine) + $0e37643ddda5f2e6$var$writeComment(nodes[i], options));
                    break;
                default:
                    xml.push($0e37643ddda5f2e6$var$writeIndentation(options, depth, firstLine) + $0e37643ddda5f2e6$var$writeElementCompact(nodes[i], key, options, depth, $0e37643ddda5f2e6$var$hasContentCompact(nodes[i], options)));
            }
            firstLine = firstLine && !xml.length;
        }
    }
    return xml.join("");
}
$0e37643ddda5f2e6$exports = function(js, options) {
    options = $0e37643ddda5f2e6$var$validateOptions(options);
    var xml = [];
    $0e37643ddda5f2e6$var$currentElement = js;
    $0e37643ddda5f2e6$var$currentElementName = "_root_";
    if (options.compact) xml.push($0e37643ddda5f2e6$var$writeElementsCompact(js, options, 0, true));
    else {
        if (js[options.declarationKey]) xml.push($0e37643ddda5f2e6$var$writeDeclaration(js[options.declarationKey], options, 0));
        if (js[options.elementsKey] && js[options.elementsKey].length) xml.push($0e37643ddda5f2e6$var$writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
    return xml.join("");
};


var $32ea7ed75dc1e992$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $32ea7ed75dc1e992$require$Buffer = $6ZWSX.Buffer;

$32ea7ed75dc1e992$exports = function(json, options) {
    if (json instanceof $32ea7ed75dc1e992$require$Buffer) json = json.toString();
    var js = null;
    if (typeof json === "string") try {
        js = JSON.parse(json);
    } catch (e) {
        throw new Error("The JSON structure is invalid");
    }
    else js = json;
    return $0e37643ddda5f2e6$exports(js, options);
};


$ab4935ac8ee9025c$exports = {
    xml2js: $7de0f1800c3a1686$exports,
    xml2json: $1c4abbdb3a3a61ac$exports,
    js2xml: $0e37643ddda5f2e6$exports,
    json2xml: $32ea7ed75dc1e992$exports
};



function $0d3c49026c835652$export$dd4e6449ed131650(theater, groups, colorMap, controlMeasures) {
    const tree = {
        Objects: {
            Object: [],
            Waypoints: {
                Waypoint: []
            },
            Border: []
        }
    };
    for (const group of groups)for (const waypoint of group.waypoints){
        const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, waypoint);
        const Color = colorMap[group.name];
        tree.Objects.Waypoints.Waypoint.push({
            Name: `${group.name} - ${waypoint.name}`,
            ShortName: `${group.name} - ${waypoint.name}`,
            Color: Color,
            Position: {
                Latitude: lat,
                Longitude: long,
                Altitude: waypoint.alt
            }
        });
    }
    if (controlMeasures) for (const cm of controlMeasures){
        const geomType = cm.geometry.getType();
        if (geomType === "LineString") {
            const points = [];
            const line = cm.geometry;
            for (const coord of line.getCoordinates()){
                const [long, lat] = coord;
                points.push({
                    Position: {
                        Latitude: lat,
                        Longitude: long,
                        Altitude: 0
                    }
                });
            }
            tree.Objects.Border.push({
                Color: cm.color,
                Height: 10000,
                Point: points
            });
            // Add a label
            tree.Objects.Object.push({
                Name: cm.name,
                Color: cm.color,
                Position: {
                    Latitude: line.getCoordinateAt(0.5)[1],
                    Longitude: line.getCoordinateAt(0.5)[0],
                    Altitude: 10000
                },
                Altitude: 10000
            });
        }
        if (geomType === "Polygon") {
            const points = [];
            const poly = cm.geometry;
            for (const ring of poly.getCoordinates())for (const coord of ring){
                const [long, lat] = coord;
                points.push({
                    Position: {
                        Latitude: lat,
                        Longitude: long,
                        Altitude: 0
                    }
                });
            }
            const centroid = poly.getInteriorPoint().getCoordinates();
            // Add a label
            tree.Objects.Object.push({
                Name: cm.name,
                Color: colorMap[cm.name],
                Position: {
                    Latitude: centroid[1],
                    Longitude: centroid[0],
                    Altitude: 10000
                },
                Altitude: 10000
            });
            tree.Objects.Border.push({
                Color: cm.color,
                Height: 10000,
                Point: points
            });
        }
        if (geomType === "Circle") {
            const circ = cm.geometry;
            const [long, lat] = circ.getCenter();
            const center = circ.getCenter();
            const rad = circ.getRadius();
            const edge = [
                center[0] + rad,
                center[1]
            ];
            // meters
            const radius = (0, $fb75384508533d8f$export$79376507b09a66f)(center, edge);
            tree.Objects.Object.push({
                Name: cm.name,
                Shape: "Tube",
                //   Add opacity
                Color: `${cm.color}79`,
                Position: {
                    Latitude: lat,
                    Longitude: long,
                    Altitude: 0
                },
                Size: {
                    Width: radius * 2,
                    Height: radius * 2,
                    Length: 10000
                },
                Orientation: {
                    Pitch: 90
                },
                BaseSize: {
                    Width: radius * 2,
                    Height: radius * 2,
                    Length: 10000
                }
            });
            // Add a label
            tree.Objects.Object.push({
                Name: cm.name,
                Color: colorMap[cm.name],
                Position: {
                    Latitude: center[1],
                    Longitude: center[0],
                    Altitude: 10000
                },
                Altitude: 10000
            });
        }
        if (geomType === "Point") {
            const point = cm.geometry;
            const [long, lat] = point.getCoordinates();
            tree.Objects.Object.push({
                Name: cm.name,
                Color: cm.color,
                Position: {
                    Latitude: lat,
                    Longitude: long,
                    Altitude: 0
                },
                Altitude: 1000
            });
        }
    }
    let result = (0, (/*@__PURE__*/$parcel$interopDefault($ab4935ac8ee9025c$exports))).js2xml(tree, {
        compact: true,
        spaces: 4
    });
    result = `<?xml version="1.0" encoding="utf-8" standalone="yes"?>\n${result}`;
    return result;
}



function $4a36d5c2e33ea5e7$var$TacviewExport({ className: className }) {
    const { state: { manifest: manifest } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const { data: data } = (0, $a10ff9c4760c9625$export$5c900e05ff5ed627)();
    const { data: controlMeasures } = (0, $302106ffa43351a6$export$5dad9a454d8c40c0)(manifest.id);
    const { success: success } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const [formState, setFormState] = $acw62.useState({
        groups: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reduce(data?.plannedGroups, (acc, group)=>{
            acc[group.name] = true;
            return acc;
        }, {}),
        controlMeasures: true
    });
    const colorMap = (0, $99f46708ff5ed621$export$6af74cd118fd0c5d)();
    const handleExport = $acw62.useCallback(()=>{
        const filteredGroups = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(data?.plannedGroups, (g)=>formState.groups[g.name]);
        const result = (0, $0d3c49026c835652$export$dd4e6449ed131650)(data.theater, filteredGroups, colorMap, formState.controlMeasures ? controlMeasures : null);
        (0, (/*@__PURE__*/$parcel$interopDefault($90f256c567e4c320$exports)))(new Blob([
            result
        ], {
            type: "text/xml"
        }), `${manifest.title}_TacviewObjects.xml`);
        success("Tacview Objects XML downloaded");
    }, [
        data,
        controlMeasures,
        formState
    ]);
    const handleFormChange = (e)=>{
        setFormState({
            ...formState,
            [e.target.name]: e.target.checked
        });
    };
    const selectValue = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).keys(formState.groups), (g)=>formState.groups[g]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
        p: 2,
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                mb: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: handleExport,
                    children: "Download Tacview Objects XML"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de0670fe9e1c7ea3$export$2e2bcd8739ae039), {
                            value: selectValue,
                            groups: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(data?.plannedGroups, "name"),
                            onChange: (groups)=>{
                                const next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reduce(groups, (acc, group)=>{
                                    acc[group] = true;
                                    return acc;
                                }, {});
                                setFormState({
                                    ...formState,
                                    groups: next
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            ml: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
                                    component: "legend",
                                    children: "Objects"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                        name: "controlMeasures",
                                        checked: formState.controlMeasures,
                                        onChange: handleFormChange
                                    }),
                                    label: "Include Control Measures"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $4a36d5c2e33ea5e7$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($4a36d5c2e33ea5e7$var$TacviewExport).attrs({
    className: $4a36d5c2e33ea5e7$var$TacviewExport.name
})``;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $f1q41 = parcelRequire("f1q41");

parcelRequire("5z5Bz");




var $5z5Bz = parcelRequire("5z5Bz");









var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $1af476759d0284c5$var$TimelineStyleWrapper({ className: className, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: children
    });
}
var $1af476759d0284c5$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($1af476759d0284c5$var$TimelineStyleWrapper).attrs({
    className: $1af476759d0284c5$var$TimelineStyleWrapper.name
})`
  ${({ colorMap: colorMap })=>Object.keys(colorMap).map((key)=>`
        .${key} .vis-inner {
            color: ${colorMap[key]};
        }

        .${key} .vis-item {
            border-color: ${colorMap[key]};
        }

        .${key} .vis-range {
            background-color: ${colorMap[key]};
            color: white;
        }
    `).join("\n")}
`;


function $dfce1bb4ee3240f0$var$TimelineEditor({ className: className }) {
    const { controller: controller } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const { state: { userPlannableGroups: userPlannableGroups, planningMode: planningMode } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const timelineRef = $acw62.useRef(null);
    const containerRef = $acw62.useRef(null);
    const { data: tasking } = (0, $a10ff9c4760c9625$export$5c900e05ff5ed627)();
    const { data: groups } = (0, $92839c6c950486dc$export$53040a172a7e0d87)();
    // Make the group names work as CSS classes
    const colorMap = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).reduce((0, $99f46708ff5ed621$export$6af74cd118fd0c5d)(), (acc, value, key)=>{
        acc[(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).kebabCase(key)] = value;
        return acc;
    }, {});
    const focus = (0, $99f46708ff5ed621$export$910c5181afa5ba66)();
    const offset = (0, $e1dc1ccf277543ba$export$59c99f3515d3493f)(tasking.theater);
    const start = (0, $53c885ff43760466$export$ee1d6d1eff24dd98)(tasking.time).minus({
        hours: offset
    });
    $acw62.useEffect(()=>{
        const tl = timelineRef.current;
        if (!tl) return;
        tl.setItems(new (0, $5z5Bz.DataSet)($dfce1bb4ee3240f0$var$createItemsList(groups, start, colorMap, userPlannableGroups, planningMode, tasking.theater)));
    }, [
        groups,
        planningMode
    ]);
    $acw62.useEffect(()=>{
        if (!containerRef.current) return;
        if (timelineRef.current) return;
        const items = $dfce1bb4ee3240f0$var$createItemsList(groups, start, colorMap, userPlannableGroups, planningMode, tasking.theater);
        const groupNames = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>({
                id: g.name,
                content: g.name,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).kebabCase(g.name)
            }));
        const ds = new (0, $5z5Bz.DataSet)(items);
        const timeline = new (0, $5z5Bz.Timeline)(containerRef.current, ds, groupNames, {
            start: start.toJSDate(),
            editable: {
                add: false,
                updateTime: planningMode,
                updateGroup: false,
                remove: false
            },
            template: (item, ele)=>{
                const parent = ele.parentElement;
                parent.style.borderColor = item.color;
                const d = (0, $63618293c58b5f80$exports.DateTime).fromJSDate(item.start);
                const utc = d.toUTC();
                const el = document.createElement("div");
                // el.className = "vis-item";
                el.style.padding = `4px`;
                el.appendChild(document.createTextNode(item.label));
                el.appendChild(document.createElement("br"));
                if (!item.isDuration) {
                    el.style.color = item.color;
                    el.appendChild(document.createTextNode(utc.toFormat("HH:mm:ss")));
                }
                return el;
            },
            format: {
                majorLabels: (date)=>// This is a moment object, which is a bug in the lib
                    // @ts-ignore
                    (0, $63618293c58b5f80$exports.DateTime).fromJSDate(date.toDate()).toUTC().toFormat("HH:mm:ss"),
                minorLabels: (date)=>// This is a moment object, which is a bug in the lib
                    // @ts-ignore
                    (0, $63618293c58b5f80$exports.DateTime).fromJSDate(date.toDate()).toUTC().toFormat("HH:mm:ss")
            },
            snap: null,
            autoResize: true,
            onMove: (item, cb)=>{
                const dt = (0, $63618293c58b5f80$exports.DateTime).fromJSDate(item.start);
                const existing = controller.current?.getWaypoint(item.group, item.number)?.getProperties();
                const nextETA = dt.diff(start).as("seconds");
                controller.current?.setWaypointDetails(item.group, item.number, {
                    altitude: existing?.altitude || 0,
                    text: existing?.name || item.number.toString(),
                    altitudeType: existing?.altitudeType || "AGL",
                    eta: nextETA
                });
                cb(item);
            }
        });
        timeline.on("select", function(properties) {
            const item = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(properties.items);
            if (!item || item.includes("-dur")) return;
            const [group, number] = item.split("/");
            const wp = controller.current?.findWaypointForGroup(group, parseInt(number));
            if (!wp) {
                // Controller could not find the waypoint
                // The user probably cannot plan this group.
                // Focus the normal map layer group instead
                const g = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(groups, {
                    name: group
                });
                const unplannableWP = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(g?.waypoints, {
                    number: parseInt(number)
                });
                if (!unplannableWP) {
                    (0, $f2b90654edf2c0a1$export$45654777c133ae80)(`Could not find waypoint ${number} for group ${group}`);
                    return;
                }
                focus(group, unplannableWP);
                return;
            }
            focus(group, wp.getProperties());
        });
        timelineRef.current = timeline;
    }, [
        containerRef.current
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                p: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    wide: true,
                    end: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mr: 2,
                            children: [
                                "Mode: ",
                                planningMode ? "Planning" : "Viewing"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $900511af1dc92622$export$2e2bcd8739ae039), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1af476759d0284c5$export$2e2bcd8739ae039), {
                colorMap: colorMap,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ref: containerRef
                })
            })
        ]
    });
}
var $dfce1bb4ee3240f0$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($dfce1bb4ee3240f0$var$TimelineEditor).attrs({
    className: $dfce1bb4ee3240f0$var$TimelineEditor.name
})`
  .vis-item {
    background-color: white;
  }
  .vis-selected {
    background-color: #fff785;
    border-color: #ffc200;
  }
`;
function $dfce1bb4ee3240f0$var$createItemsList(groups, start, colorMap, userPlannableGroups, planningMode, theater) {
    const items = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        for(let w = 0; w < group.waypoints.length; w++){
            const wp = group.waypoints[w];
            const eta = start.plus({
                seconds: wp.ETA
            });
            const color = colorMap[(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).kebabCase(group.name)];
            if (wp.number === 0) continue;
            const prev = group.waypoints[w - 1];
            const dur = (0, $53c885ff43760466$export$45bc8b206e259390)(prev, wp);
            const coord1 = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, prev);
            const coord2 = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, wp);
            const distance = (0, $53c885ff43760466$export$7aff669504c23062)(coord1, coord2);
            // Get ground speed based on distance and duration
            const speed = distance / dur.as("hours");
            const durItem = {
                id: `${group.name}/${wp.number}-dur`,
                label: `${dur.toFormat("mm:ss")} - ${distance.toFixed(1)}nm @ ${speed.toFixed()} knots`,
                start: start.plus({
                    seconds: prev.ETA
                }).toJSDate(),
                end: eta.toJSDate(),
                isDuration: true,
                color: color,
                group: group.name,
                editable: false,
                selectable: false
            };
            items.push(durItem);
            const editable = planningMode && userPlannableGroups.includes(group.name);
            items.push({
                id: `${group.name}/${wp.number}`,
                number: wp.number,
                label: wp.name && wp.name !== wp.number.toString() ? `${wp.number}: ${wp.name}` : wp.number.toString(),
                color: color,
                start: eta.toJSDate(),
                group: group.name,
                editable: {
                    add: false,
                    updateTime: editable,
                    remove: false
                }
            });
        }
    }
    return items;
}


function $7132d3e310ba48f8$var$moduleName(group) {
    if (!group) return "";
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get((0, $b9c9d9c1adf94aca$export$cc2c248003684daa), [
        group.units[0].type,
        "label"
    ], group.units[0].type);
}
function $7132d3e310ba48f8$var$windowData(w, index) {
    switch(w.type){
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Signups:
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).DataEntry:
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Assets:
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).AircraftData:
            return {
                height: 720,
                width: 1280
            };
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).FlyableGroup:
            return {
                height: 300,
                width: document.body.clientWidth / 2,
                x: 32 + (index + 1) * 16,
                y: document.body.clientHeight - 500 + (index + 1) * 16,
                title: `${w.props?.group?.name} - ${$7132d3e310ba48f8$var$moduleName(w.props?.group)}`
            };
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).SelectedFeature:
            return {
                height: 300,
                width: document.body.clientWidth,
                x: 32,
                y: document.body.clientHeight - 500,
                title: `${w.props?.group?.name} - ${$7132d3e310ba48f8$var$moduleName(w.props?.group)}`
            };
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).AirportDiagram:
            return {
                height: 480,
                width: 480,
                title: `${w.props.name} - Parking Diagram`
            };
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Planning:
            return {
                height: 540,
                width: 480
            };
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).TimelineEditor:
            return {
                height: 400,
                width: document.body.clientWidth - 64,
                x: 32,
                y: document.body.clientHeight - 500
            };
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).TacviewExport:
            return {
                height: 540,
                width: 640
            };
        default:
            return {
                height: 300,
                width: 500
            };
    }
}
function $7132d3e310ba48f8$var$NavWindow({ children: children, index: index, ...rest }) {
    const offset = 64 + (index + 1) * 16;
    // Using a ref to prevent the window from re-positioning on re-render
    const initialPos = $acw62.useRef(offset);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($279a88221582c7c4$exports))), {
        x: initialPos.current,
        y: initialPos.current / 2,
        background: "black",
        ...rest,
        children: children
    });
}
function $7132d3e310ba48f8$var$cmp(w, props) {
    switch(w){
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Players:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24d3babfc5e3eec0$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).SupportAssets:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f3998d7204fe0e2$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Bases:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15725ec70269d49f$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Assets:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57b9a223ad7c79e6$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).DataEntry:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2246b069085bbc3$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).SelectedFeature:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $664b36a50f9052f7$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).AirportDiagram:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $861fc78f813d6070$export$2e2bcd8739ae039), {
                ...props
            });
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Planning:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f63a128fb7948aa3$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).FlyableGroup:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b5920881ecd250f$export$5b1520aaea32716f), {
                name: props.group?.name
            });
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).AircraftData:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3f418b8316ffcee8$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).ControlMeasures:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d33bb5e5a628327$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Signups:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $429695e7699d8b8e$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).TacviewExport:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a36d5c2e33ea5e7$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).Search:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c85127b4fb8041f0$export$2e2bcd8739ae039), {});
        case (0, $8396d1566d56485e$export$988a21494ff06fc5).TimelineEditor:
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfce1bb4ee3240f0$export$2e2bcd8739ae039), {});
        default:
            return null;
    }
}
function $7132d3e310ba48f8$var$WindowManager({ className: className }) {
    const { state: state } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const { windows: windows, handleClose: handleClose } = (0, $8396d1566d56485e$export$d3d0694a1d2def88)();
    let group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(state?.tasking?.plannedGroups, {
        name: state.focusedFeature?.name
    });
    if (!group) group = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(state?.tasking?.plannedGroups, {
        name: state?.focusedFeature?.layerName
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(windows, (w, i)=>{
            const data = $7132d3e310ba48f8$var$windowData(w, i);
            return /*#__PURE__*/ (0, $ayMG0.jsx)($7132d3e310ba48f8$var$NavWindow, {
                index: i,
                title: w.id,
                ...data,
                onClose: ()=>{
                    handleClose(w);
                },
                children: $7132d3e310ba48f8$var$cmp(w.type, w.props)
            }, w.id);
        })
    });
}
var $7132d3e310ba48f8$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($7132d3e310ba48f8$var$WindowManager).attrs({
    className: $7132d3e310ba48f8$var$WindowManager.name
})``;



var $de3716a7fbcda421$exports = {};
"use strict";

Object.defineProperty($de3716a7fbcda421$exports, "__esModule", {
    value: true
});
$de3716a7fbcda421$exports.default = void 0;

var $de3716a7fbcda421$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $de3716a7fbcda421$var$_default = (0, $de3716a7fbcda421$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    fillRule: "evenodd",
    d: "m9 17 3-2.94c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m4.47 8.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z"
}), "HowToReg");
$de3716a7fbcda421$exports.default = $de3716a7fbcda421$var$_default;



/**
 * @module ol/source/OSM
 */ 
const $6c8498cc816f2362$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class $6c8498cc816f2362$var$OSM extends (0, $963a7ef65488964c$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $6c8498cc816f2362$export$4de8a5e77eb994ad
        ];
        const crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : "anonymous";
        const url = options.url !== undefined ? options.url : "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
var $6c8498cc816f2362$export$2e2bcd8739ae039 = $6c8498cc816f2362$var$OSM;



const $81ef60e3f0a87a39$var$NavContainer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $10469897db0fb9cc$export$2e2bcd8739ae039))`
  position: absolute;
  top: 96px;
  left: 0;
  bottom: 0;
  z-index: 2;

  padding: 8px;
`;
function $81ef60e3f0a87a39$var$Navigation({ className: className }) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const { state: state } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const hasSignups = (0, $eb85d675c21bd358$export$617c26084be82b77)();
    const handleDownloadMap = async ()=>{
        const l = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
            source: new (0, $6c8498cc816f2362$export$2e2bcd8739ae039)()
        });
        l.setZIndex(-1);
        map.addLayer(l);
        await (0, $bdd79db2b065dd58$export$cfcadda4907cb91f)(map, state.manifest.title);
        map.removeLayer(l);
    };
    if (state.disableUI) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($81ef60e3f0a87a39$var$NavContainer, {
                column: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                        foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).Search,
                        tooltip: "Search",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($20e4b243ccff587b$exports))), {
                            fontSize: "large"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 0,
                        marginTop: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499d669e091e4996$export$2e2bcd8739ae039), {
                            placement: "right",
                            title: "Download Map as Image",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fe6920ef40d5760$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: handleDownloadMap,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ee6d6bcb1ef6fbe5$exports))), {
                                    fontSize: "large"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 0,
                        marginTop: 4,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                                tooltip: "Planning",
                                foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).Planning,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8993172cb7bc25ee$exports))), {
                                    fontSize: "large"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                                tooltip: "Kneeboards",
                                foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).Assets,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51e89b0c13e21577$exports))), {
                                    fontSize: "large"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                                tooltip: "Data Entry",
                                foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).DataEntry,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e05ccb3ca0c06c32$exports))), {
                                    fontSize: "large"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                                tooltip: "Aircraft Data",
                                foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).AircraftData,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($05cdb0e991cfb75f$exports))), {
                                    fontSize: "large"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                                tooltip: "Control Measures",
                                foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).ControlMeasures,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6c12fa5e0b6a42d2$exports))), {
                                    fontSize: "large"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                                tooltip: "Timeline Editor",
                                foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).TimelineEditor,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fa1bd34af973acad$exports))), {
                                    fontSize: "large"
                                })
                            })
                        ]
                    }),
                    hasSignups && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        p: 0,
                        marginTop: 4,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                            tooltip: "Signup",
                            foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).Signups,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($de3716a7fbcda421$exports))), {
                                fontSize: "large"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d059b7c482dc88ca$export$2e2bcd8739ae039), {
                        tooltip: "Tacview Export",
                        foWindow: (0, $8396d1566d56485e$export$988a21494ff06fc5).TacviewExport,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1d7752f49a1ccd3$exports))), {
                            fontSize: "large"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7132d3e310ba48f8$export$2e2bcd8739ae039), {})
        ]
    });
}
var $81ef60e3f0a87a39$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($81ef60e3f0a87a39$var$Navigation).attrs({
    className: $81ef60e3f0a87a39$var$Navigation.name
})`
  position: relative;

  ${(0, $ed173ba6c38830a3$export$2e2bcd8739ae039)} {
    position: absolute;
    left: 0;
    top: 0;
    background: transparent;
    z-index: 3;
  }

  @media only screen and (max-width: 700px) {
    display: none;
  }

  @media only screen and (max-height: 700px) {
    display: none;
  }
`;




var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");







var $acw62 = parcelRequire("acw62");







function $b6221a2138ef0f90$var$hexToRgb(hex) {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = bigint >> 16 & 255;
    const g = bigint >> 8 & 255;
    const b = bigint & 255;
    return [
        r,
        g,
        b
    ];
}
const $b6221a2138ef0f90$var$style = ()=>(feature)=>{
        const color = $b6221a2138ef0f90$var$hexToRgb(feature.get("color"));
        let textColor = "#fff";
        let textOffset = 0;
        let geom = feature.getGeometry();
        const styles = [];
        if (geom.getType() === "LineString") textColor = "#000";
        if (geom.getType() === "Point") {
            textColor = "#000";
            textOffset = 24;
            const iconStr = feature.get("icon");
            if (iconStr) {
                const icon = "data:image/svg+xml;utf8," + new (0, (/*@__PURE__*/$parcel$interopDefault($e786e20e25c5f221$exports))).Symbol(iconStr, {
                    size: 20
                }).asSVG();
                styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                    image: new (0, $8463d325b53eeb0c$export$2e2bcd8739ae039)({
                        src: icon,
                        scale: 1
                    })
                }));
            } else styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                    radius: 10,
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: color
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: color,
                        width: 2
                    })
                })
            }));
        } else {
            const color = $b6221a2138ef0f90$var$hexToRgb(feature.get("color"));
            const transparent = color.concat([
                0.5
            ]);
            styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: transparent
                }),
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: color,
                    width: 2
                })
            }));
        }
        const ident = feature.get("ident");
        const free = feature.get("free");
        if (ident || free) styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                font: "16px Calibri,sans-serif",
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: textColor
                }),
                text: `${ident} ${free}`,
                offsetY: -textOffset
            })
        }));
        styles.push(new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                font: "16px Calibri,sans-serif",
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: textColor
                }),
                text: feature.get("name"),
                offsetY: textOffset
            })
        }));
        return styles;
    };
const $b6221a2138ef0f90$export$2176ae367e27d883 = ({ measures: measures })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        features: measures,
        style: $b6221a2138ef0f90$var$style(),
        name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlMeasures
    });
};
function $b6221a2138ef0f90$export$2e2bcd8739ae039() {
    const { registerLayer: registerLayer } = (0, $051196b900f7d6e0$export$b2bdaef0c871405f)();
    const sourceRef = $acw62.useRef();
    const manifestID = (0, $0a53c1f23450367c$export$690fab4e9789b198)();
    const { data: controlMeasures } = (0, $302106ffa43351a6$export$5dad9a454d8c40c0)(manifestID);
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    $acw62.useEffect(()=>{
        if (!map) return;
        if (!sourceRef.current) sourceRef.current = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)();
        const layer = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
            source: sourceRef.current,
            style: $b6221a2138ef0f90$var$style()
        });
        layer.set("name", (0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlMeasures);
        layer.set("hideable", true);
        map.addLayer(layer);
        registerLayer(layer);
        return ()=>{
            map.removeLayer(layer);
        };
    }, [
        map
    ]);
    $acw62.useEffect(()=>{
        if (!map) return;
        if (controlMeasures.length === 0) {
            sourceRef.current.clear();
            return;
        }
        if (!sourceRef.current) sourceRef.current = new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)();
        const rings = [];
        const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(controlMeasures, (cm)=>{
            if (cm.ring) rings.push(new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                filterTag: (0, $91a9098e14452db2$export$fb028bc55343bb1f).ControlMeasures,
                color: cm.color,
                unselectable: true,
                geometry: (0, $40aa8d43bbe572bf$export$f99d756c6d81ae3f)(cm.geometry.getCoordinates(), (0, $79e13355954d15ea$export$f855e4255431a6a0)(cm.ring))
            }));
            return new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                ...cm,
                geometry: cm.geometry,
                featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).ControlMeasure,
                originalGeometry: cm.geometry.clone()
            });
        });
        sourceRef.current.clear(true);
        sourceRef.current.addFeatures([
            ...rings,
            ...features
        ]);
    }, [
        map,
        controlMeasures
    ]);
    return null;
}




var $acw62 = parcelRequire("acw62");


function $b3281a17204bf93b$export$2e2bcd8739ae039({ groups: groups, theater: theater }) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const layer = (0, $c5dd9f05f83ae634$export$2d46b8799829d984)(theater, groups, true);
        layer.set("hideable", true);
        layer.set("name", "Friendly SAMs");
        map.addLayer(layer);
    }, [
        map
    ]);
    return null;
}







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $75805bbbe267c6b2$export$2e2bcd8739ae039({ theater: theater, groups: groups }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5404f6a81ab6ced0$export$2e2bcd8739ae039), {
        size: 24,
        name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).OPFORGroups,
        theater: theater,
        groups: groups,
        isOpfor: true,
        titleOverride: "Enemy Group"
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

parcelRequire("acw62");





function $2f3f079e0bcbf250$export$2e2bcd8739ae039({ theater: theater, groups: groups }) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(groups, (g)=>{
        const { long: long, lat: lat } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, {
            x: g.x,
            y: g.y
        });
        const sidc = (0, $75a1e531b08ffb65$export$edaef53a74a5ccc9)(true);
        return {
            name: g.name,
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                long,
                lat
            ]),
            featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).Static,
            sidc: sidc,
            group: g
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3c93492c01c66a$export$2e2bcd8739ae039), {
        features: features,
        displayName: "Statics",
        name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).OPFORStatics,
        style: (0, $5404f6a81ab6ced0$export$18237acf550aab6a)(24),
        hideable: true
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");


parcelRequire("acw62");





function $3859dfdbaccd3932$export$2e2bcd8739ae039({ groups: groups, theater: theater }) {
    const features = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(groups, (g)=>{
        const u = g.units[0];
        const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, u);
        features.push(new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            geometry: new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                long,
                lat
            ]),
            featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).OPFORGroups,
            sidc: (0, $75a1e531b08ffb65$export$af576a01257ae419)(true, (0, $91a9098e14452db2$export$cd15daf6ba4f571c).Ship, null, u.type),
            name: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(u, "name"),
            threatRing: (0, $ac2178c3fe9853aa$export$668bd77d4f78425a)[(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(u, "type")]
        }));
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5404f6a81ab6ced0$export$2e2bcd8739ae039), {
        name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).OPFORShips,
        groups: groups,
        isOpfor: true,
        theater: theater,
        size: 18
    });
}


var $0a06c4d6833722ed$exports = {};
/**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v4.6.0/LICENSE.txt
 */ (function(global, factory) {
    $0a06c4d6833722ed$exports = factory();
})($0a06c4d6833722ed$exports, function() {
    "use strict";
    /* eslint-disable */ var maplibregl = {};
    var modules = {};
    function define(moduleName, _dependencies, moduleFactory) {
        modules[moduleName] = moduleFactory;
        // to get the list of modules see generated dist/maplibre-gl-dev.js file (look for `define(` calls)
        if (moduleName !== "index") return;
        // we assume that when an index module is initializing then other modules are loaded already
        var workerBundleString = "var sharedModule = {}; (" + modules.shared + ")(sharedModule); (" + modules.worker + ")(sharedModule);";
        var sharedModule = {};
        // the order of arguments of a module factory depends on rollup (it decides who is whose dependency)
        // to check the correct order, see dist/maplibre-gl-dev.js file (look for `define(` calls)
        // we assume that for our 3 chunks it will generate 3 modules and their order is predefined like the following
        modules.shared(sharedModule);
        modules.index(maplibregl, sharedModule);
        if (typeof window !== "undefined") maplibregl.setWorkerUrl(window.URL.createObjectURL(new Blob([
            workerBundleString
        ], {
            type: "text/javascript"
        })));
        return maplibregl;
    }
    define("shared", [
        "exports"
    ], function(t) {
        "use strict";
        function e(t, e, r, n) {
            return new (r || (r = Promise))(function(i, s) {
                function a(t) {
                    try {
                        l(n.next(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function o(t) {
                    try {
                        l(n.throw(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function l(t) {
                    var e;
                    t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                        t(e);
                    })).then(a, o);
                }
                l((n = n.apply(t, e || [])).next());
            });
        }
        function r(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        "function" == typeof SuppressedError && SuppressedError;
        var n = i;
        function i(t, e) {
            this.x = t, this.y = e;
        }
        i.prototype = {
            clone: function() {
                return new i(this.x, this.y);
            },
            add: function(t) {
                return this.clone()._add(t);
            },
            sub: function(t) {
                return this.clone()._sub(t);
            },
            multByPoint: function(t) {
                return this.clone()._multByPoint(t);
            },
            divByPoint: function(t) {
                return this.clone()._divByPoint(t);
            },
            mult: function(t) {
                return this.clone()._mult(t);
            },
            div: function(t) {
                return this.clone()._div(t);
            },
            rotate: function(t) {
                return this.clone()._rotate(t);
            },
            rotateAround: function(t, e) {
                return this.clone()._rotateAround(t, e);
            },
            matMult: function(t) {
                return this.clone()._matMult(t);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t) {
                return this.x === t.x && this.y === t.y;
            },
            dist: function(t) {
                return Math.sqrt(this.distSqr(t));
            },
            distSqr: function(t) {
                var e = t.x - this.x, r = t.y - this.y;
                return e * e + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t) {
                return Math.atan2(this.y - t.y, this.x - t.x);
            },
            angleWith: function(t) {
                return this.angleWithSep(t.x, t.y);
            },
            angleWithSep: function(t, e) {
                return Math.atan2(this.x * e - this.y * t, this.x * t + this.y * e);
            },
            _matMult: function(t) {
                var e = t[2] * this.x + t[3] * this.y;
                return this.x = t[0] * this.x + t[1] * this.y, this.y = e, this;
            },
            _add: function(t) {
                return this.x += t.x, this.y += t.y, this;
            },
            _sub: function(t) {
                return this.x -= t.x, this.y -= t.y, this;
            },
            _mult: function(t) {
                return this.x *= t, this.y *= t, this;
            },
            _div: function(t) {
                return this.x /= t, this.y /= t, this;
            },
            _multByPoint: function(t) {
                return this.x *= t.x, this.y *= t.y, this;
            },
            _divByPoint: function(t) {
                return this.x /= t.x, this.y /= t.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t = this.y;
                return this.y = this.x, this.x = -t, this;
            },
            _rotate: function(t) {
                var e = Math.cos(t), r = Math.sin(t), n = r * this.x + e * this.y;
                return this.x = e * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t, e) {
                var r = Math.cos(t), n = Math.sin(t), i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
                return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, i.convert = function(t) {
            return t instanceof i ? t : Array.isArray(t) ? new i(t[0], t[1]) : t;
        };
        var s = r(n), a = o;
        function o(t, e, r, n) {
            this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e, this.p2x = r, this.p2y = n;
        }
        o.prototype = {
            sampleCurveX: function(t) {
                return ((this.ax * t + this.bx) * t + this.cx) * t;
            },
            sampleCurveY: function(t) {
                return ((this.ay * t + this.by) * t + this.cy) * t;
            },
            sampleCurveDerivativeX: function(t) {
                return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
            },
            solveCurveX: function(t, e) {
                if (void 0 === e && (e = 1e-6), t < 0) return 0;
                if (t > 1) return 1;
                for(var r = t, n = 0; n < 8; n++){
                    var i = this.sampleCurveX(r) - t;
                    if (Math.abs(i) < e) return r;
                    var s = this.sampleCurveDerivativeX(r);
                    if (Math.abs(s) < 1e-6) break;
                    r -= i / s;
                }
                var a = 0, o = 1;
                for(r = t, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t) < e)); n++)t > i ? a = r : o = r, r = .5 * (o - a) + a;
                return r;
            },
            solve: function(t, e) {
                return this.sampleCurveY(this.solveCurveX(t, e));
            }
        };
        var l = r(a);
        let u, c;
        function h() {
            return null == u && (u = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), u;
        }
        function p() {
            if (null == c && (c = !1, h())) {
                const t = 5, e = new OffscreenCanvas(t, t).getContext("2d", {
                    willReadFrequently: !0
                });
                if (e) {
                    for(let r = 0; r < t * t; r++){
                        const n = 4 * r;
                        e.fillStyle = `rgb(${n},${n + 1},${n + 2})`, e.fillRect(r % t, Math.floor(r / t), 1, 1);
                    }
                    const r = e.getImageData(0, 0, t, t).data;
                    for(let e = 0; e < t * t * 4; e++)if (e % 4 != 3 && r[e] !== e) {
                        c = !0;
                        break;
                    }
                }
            }
            return c || !1;
        }
        function f(t, e, r, n) {
            const i = new l(t, e, r, n);
            return (t)=>i.solve(t);
        }
        const d = f(.25, .1, .25, 1);
        function y(t, e, r) {
            return Math.min(r, Math.max(e, t));
        }
        function m(t, e, r) {
            const n = r - e, i = ((t - e) % n + n) % n + e;
            return i === e ? r : i;
        }
        function g(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        let x = 1;
        function v(t, e, r) {
            const n = {};
            for(const r in t)n[r] = e.call(this, t[r], r, t);
            return n;
        }
        function b(t, e, r) {
            const n = {};
            for(const r in t)e.call(this, t[r], r, t) && (n[r] = t[r]);
            return n;
        }
        function w(t) {
            return Array.isArray(t) ? t.map(w) : "object" == typeof t && t ? v(t, w) : t;
        }
        const _ = {};
        function A(t) {
            _[t] || ("undefined" != typeof console && console.warn(t), _[t] = !0);
        }
        function S(t, e, r) {
            return (r.y - t.y) * (e.x - t.x) > (e.y - t.y) * (r.x - t.x);
        }
        function k(t) {
            return "undefined" != typeof WorkerGlobalScope && void 0 !== t && t instanceof WorkerGlobalScope;
        }
        let M = null;
        function I(t) {
            return "undefined" != typeof ImageBitmap && t instanceof ImageBitmap;
        }
        const z = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function P(t, r, n, i, s) {
            return e(this, void 0, void 0, function*() {
                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                const e = new VideoFrame(t, {
                    timestamp: 0
                });
                try {
                    const a = null == e ? void 0 : e.format;
                    if (!a || !a.startsWith("BGR") && !a.startsWith("RGB")) throw new Error(`Unrecognized format ${a}`);
                    const o = a.startsWith("BGR"), l = new Uint8ClampedArray(i * s * 4);
                    if (yield e.copyTo(l, function(t, e, r, n, i) {
                        const s = 4 * Math.max(-e, 0), a = (Math.max(0, r) - r) * n * 4 + s, o = 4 * n, l = Math.max(0, e), u = Math.max(0, r);
                        return {
                            rect: {
                                x: l,
                                y: u,
                                width: Math.min(t.width, e + n) - l,
                                height: Math.min(t.height, r + i) - u
                            },
                            layout: [
                                {
                                    offset: a,
                                    stride: o
                                }
                            ]
                        };
                    }(t, r, n, i, s)), o) for(let t = 0; t < l.length; t += 4){
                        const e = l[t];
                        l[t] = l[t + 2], l[t + 2] = e;
                    }
                    return l;
                } finally{
                    e.close();
                }
            });
        }
        let C, B;
        const V = "AbortError";
        function E() {
            return new Error(V);
        }
        const F = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        function T(t) {
            return F.REGISTERED_PROTOCOLS[t.substring(0, t.indexOf("://"))];
        }
        const $ = "global-dispatcher";
        class L extends Error {
            constructor(t, e, r, n){
                super(`AJAXError: ${e} (${t}): ${r}`), this.status = t, this.statusText = e, this.url = r, this.body = n;
            }
        }
        const D = ()=>k(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, O = function(t, r) {
            if (/:\/\//.test(t.url) && !/^https?:|^file:/.test(t.url)) {
                const e = T(t.url);
                if (e) return e(t, r);
                if (k(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: t,
                    targetMapId: $
                }, r);
            }
            if (!(/^file:/.test(n = t.url) || /^file:/.test(D()) && !/^\w+:/.test(n))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(t, r) {
                    return e(this, void 0, void 0, function*() {
                        const e = new Request(t.url, {
                            method: t.method || "GET",
                            body: t.body,
                            credentials: t.credentials,
                            headers: t.headers,
                            cache: t.cache,
                            referrer: D(),
                            signal: r.signal
                        });
                        "json" !== t.type || e.headers.has("Accept") || e.headers.set("Accept", "application/json");
                        const n = yield fetch(e);
                        if (!n.ok) {
                            const e = yield n.blob();
                            throw new L(n.status, n.statusText, t.url, e);
                        }
                        let i;
                        i = "arrayBuffer" === t.type || "image" === t.type ? n.arrayBuffer() : "json" === t.type ? n.json() : n.text();
                        const s = yield i;
                        if (r.signal.aborted) throw E();
                        return {
                            data: s,
                            cacheControl: n.headers.get("Cache-Control"),
                            expires: n.headers.get("Expires")
                        };
                    });
                }(t, r);
                if (k(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: t,
                    mustQueue: !0,
                    targetMapId: $
                }, r);
            }
            var n;
            return function(t, e) {
                return new Promise((r, n)=>{
                    var i;
                    const s = new XMLHttpRequest;
                    s.open(t.method || "GET", t.url, !0), "arrayBuffer" !== t.type && "image" !== t.type || (s.responseType = "arraybuffer");
                    for(const e in t.headers)s.setRequestHeader(e, t.headers[e]);
                    "json" === t.type && (s.responseType = "text", (null === (i = t.headers) || void 0 === i ? void 0 : i.Accept) || s.setRequestHeader("Accept", "application/json")), s.withCredentials = "include" === t.credentials, s.onerror = ()=>{
                        n(new Error(s.statusText));
                    }, s.onload = ()=>{
                        if (!e.signal.aborted) {
                            if ((s.status >= 200 && s.status < 300 || 0 === s.status) && null !== s.response) {
                                let e = s.response;
                                if ("json" === t.type) try {
                                    e = JSON.parse(s.response);
                                } catch (t) {
                                    return void n(t);
                                }
                                r({
                                    data: e,
                                    cacheControl: s.getResponseHeader("Cache-Control"),
                                    expires: s.getResponseHeader("Expires")
                                });
                            } else {
                                const e = new Blob([
                                    s.response
                                ], {
                                    type: s.getResponseHeader("Content-Type")
                                });
                                n(new L(s.status, s.statusText, t.url, e));
                            }
                        }
                    }, e.signal.addEventListener("abort", ()=>{
                        s.abort(), n(E());
                    }), s.send(t.body);
                });
            }(t, r);
        };
        function j(t) {
            if (!t || t.indexOf("://") <= 0 || 0 === t.indexOf("data:image/") || 0 === t.indexOf("blob:")) return !0;
            const e = new URL(t), r = window.location;
            return e.protocol === r.protocol && e.host === r.host;
        }
        function R(t, e, r) {
            r[t] && -1 !== r[t].indexOf(e) || (r[t] = r[t] || [], r[t].push(e));
        }
        function U(t, e, r) {
            if (r && r[t]) {
                const n = r[t].indexOf(e);
                -1 !== n && r[t].splice(n, 1);
            }
        }
        class q {
            constructor(t, e = {}){
                g(this, e), this.type = t;
            }
        }
        class N extends q {
            constructor(t, e = {}){
                super("error", g({
                    error: t
                }, e));
            }
        }
        class Z {
            on(t, e) {
                return this._listeners = this._listeners || {}, R(t, e, this._listeners), this;
            }
            off(t, e) {
                return U(t, e, this._listeners), U(t, e, this._oneTimeListeners), this;
            }
            once(t, e) {
                return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, R(t, e, this._oneTimeListeners), this) : new Promise((e)=>this.once(t, e));
            }
            fire(t, e) {
                "string" == typeof t && (t = new q(t, e || {}));
                const r = t.type;
                if (this.listens(r)) {
                    t.target = this;
                    const e = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e)r.call(this, t);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e of n)U(r, e, this._oneTimeListeners), e.call(this, t);
                    const i = this._eventedParent;
                    i && (g(t, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t));
                } else t instanceof N && console.error(t.error);
                return this;
            }
            listens(t) {
                return this._listeners && this._listeners[t] && this._listeners[t].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t] && this._oneTimeListeners[t].length > 0 || this._eventedParent && this._eventedParent.listens(t);
            }
            setEventedParent(t, e) {
                return this._eventedParent = t, this._eventedParentData = e, this;
            }
        }
        var G = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                sky: {
                    type: "sky"
                },
                projection: {
                    type: "projection"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {},
                        custom: {}
                    },
                    default: "mapbox"
                },
                redFactor: {
                    type: "number",
                    default: 1
                },
                blueFactor: {
                    type: "number",
                    default: 1
                },
                greenFactor: {
                    type: "number",
                    default: 1
                },
                baseShift: {
                    type: "number",
                    default: 0
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-variable-anchor-offset": {
                    type: "variableAnchorOffsetCollection",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            sky: {
                "sky-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#88C6FC",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-ground-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-fog-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "sky-horizon-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "atmosphere-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            projection: {
                type: {
                    type: "enum",
                    default: "mercator",
                    values: {
                        mercator: {},
                        globe: {}
                    }
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        };
        const K = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function X(t, e) {
            const r = {};
            for(const e in t)"ref" !== e && (r[e] = t[e]);
            return K.forEach((t)=>{
                t in e && (r[t] = e[t]);
            }), r;
        }
        function H(t, e) {
            if (Array.isArray(t)) {
                if (!Array.isArray(e) || t.length !== e.length) return !1;
                for(let r = 0; r < t.length; r++)if (!H(t[r], e[r])) return !1;
                return !0;
            }
            if ("object" == typeof t && null !== t && null !== e) {
                if ("object" != typeof e) return !1;
                if (Object.keys(t).length !== Object.keys(e).length) return !1;
                for(const r in t)if (!H(t[r], e[r])) return !1;
                return !0;
            }
            return t === e;
        }
        function Y(t, e) {
            t.push(e);
        }
        function J(t, e, r) {
            Y(r, {
                command: "addSource",
                args: [
                    t,
                    e[t]
                ]
            });
        }
        function W(t, e, r) {
            Y(e, {
                command: "removeSource",
                args: [
                    t
                ]
            }), r[t] = !0;
        }
        function Q(t, e, r, n) {
            W(t, r, n), J(t, e, r);
        }
        function tt(t, e, r) {
            let n;
            for(n in t[r])if (Object.prototype.hasOwnProperty.call(t[r], n) && "data" !== n && !H(t[r][n], e[r][n])) return !1;
            for(n in e[r])if (Object.prototype.hasOwnProperty.call(e[r], n) && "data" !== n && !H(t[r][n], e[r][n])) return !1;
            return !0;
        }
        function et(t, e, r, n, i, s) {
            t = t || {}, e = e || {};
            for(const a in t)Object.prototype.hasOwnProperty.call(t, a) && (H(t[a], e[a]) || r.push({
                command: s,
                args: [
                    n,
                    a,
                    e[a],
                    i
                ]
            }));
            for(const a in e)Object.prototype.hasOwnProperty.call(e, a) && !Object.prototype.hasOwnProperty.call(t, a) && (H(t[a], e[a]) || r.push({
                command: s,
                args: [
                    n,
                    a,
                    e[a],
                    i
                ]
            }));
        }
        function rt(t) {
            return t.id;
        }
        function nt(t, e) {
            return t[e.id] = e, t;
        }
        class it {
            constructor(t, e, r, n){
                this.message = (t ? `${t}: ` : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
            }
        }
        function st(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        class at extends Error {
            constructor(t, e){
                super(e), this.message = e, this.key = t;
            }
        }
        class ot {
            constructor(t, e = []){
                this.parent = t, this.bindings = {};
                for (const [t, r] of e)this.bindings[t] = r;
            }
            concat(t) {
                return new ot(this, t);
            }
            get(t) {
                if (this.bindings[t]) return this.bindings[t];
                if (this.parent) return this.parent.get(t);
                throw new Error(`${t} not found in scope.`);
            }
            has(t) {
                return !!this.bindings[t] || !!this.parent && this.parent.has(t);
            }
        }
        const lt = {
            kind: "null"
        }, ut = {
            kind: "number"
        }, ct = {
            kind: "string"
        }, ht = {
            kind: "boolean"
        }, pt = {
            kind: "color"
        }, ft = {
            kind: "object"
        }, dt = {
            kind: "value"
        }, yt = {
            kind: "collator"
        }, mt = {
            kind: "formatted"
        }, gt = {
            kind: "padding"
        }, xt = {
            kind: "resolvedImage"
        }, vt = {
            kind: "variableAnchorOffsetCollection"
        };
        function bt(t, e) {
            return {
                kind: "array",
                itemType: t,
                N: e
            };
        }
        function wt(t) {
            if ("array" === t.kind) {
                const e = wt(t.itemType);
                return "number" == typeof t.N ? `array<${e}, ${t.N}>` : "value" === t.itemType.kind ? "array" : `array<${e}>`;
            }
            return t.kind;
        }
        const _t = [
            lt,
            ut,
            ct,
            ht,
            pt,
            mt,
            ft,
            bt(dt),
            gt,
            xt,
            vt
        ];
        function At(t, e) {
            if ("error" === e.kind) return null;
            if ("array" === t.kind) {
                if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !At(t.itemType, e.itemType)) && ("number" != typeof t.N || t.N === e.N)) return null;
            } else {
                if (t.kind === e.kind) return null;
                if ("value" === t.kind) {
                    for (const t of _t)if (!At(t, e)) return null;
                }
            }
            return `Expected ${wt(t)} but found ${wt(e)} instead.`;
        }
        function St(t, e) {
            return e.some((e)=>e.kind === t.kind);
        }
        function kt(t, e) {
            return e.some((e)=>"null" === e ? null === t : "array" === e ? Array.isArray(t) : "object" === e ? t && !Array.isArray(t) && "object" == typeof t : e === typeof t);
        }
        function Mt(t, e) {
            return "array" === t.kind && "array" === e.kind ? t.itemType.kind === e.itemType.kind && "number" == typeof t.N : t.kind === e.kind;
        }
        const It = .96422, zt = .82521, Pt = 4 / 29, Ct = 6 / 29, Bt = 3 * Ct * Ct, Vt = Ct * Ct * Ct, Et = Math.PI / 180, Ft = 180 / Math.PI;
        function Tt(t) {
            return (t %= 360) < 0 && (t += 360), t;
        }
        function $t([t, e, r, n]) {
            let i, s;
            const a = Dt((.2225045 * (t = Lt(t)) + .7168786 * (e = Lt(e)) + .0606169 * (r = Lt(r))) / 1);
            t === e && e === r ? i = s = a : (i = Dt((.4360747 * t + .3850649 * e + .1430804 * r) / It), s = Dt((.0139322 * t + .0971045 * e + .7141733 * r) / zt));
            const o = 116 * a - 16;
            return [
                o < 0 ? 0 : o,
                500 * (i - a),
                200 * (a - s),
                n
            ];
        }
        function Lt(t) {
            return t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }
        function Dt(t) {
            return t > Vt ? Math.pow(t, 1 / 3) : t / Bt + Pt;
        }
        function Ot([t, e, r, n]) {
            let i = (t + 16) / 116, s = isNaN(e) ? i : i + e / 500, a = isNaN(r) ? i : i - r / 200;
            return i = 1 * Rt(i), s = It * Rt(s), a = zt * Rt(a), [
                jt(3.1338561 * s - 1.6168667 * i - .4906146 * a),
                jt(-0.9787684 * s + 1.9161415 * i + .033454 * a),
                jt(.0719453 * s - .2289914 * i + 1.4052427 * a),
                n
            ];
        }
        function jt(t) {
            return (t = t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function Rt(t) {
            return t > Ct ? t * t * t : Bt * (t - Pt);
        }
        function Ut(t) {
            return parseInt(t.padEnd(2, t), 16) / 255;
        }
        function qt(t, e) {
            return Nt(e ? t / 100 : t, 0, 1);
        }
        function Nt(t, e, r) {
            return Math.min(Math.max(e, t), r);
        }
        function Zt(t) {
            return !t.some(Number.isNaN);
        }
        const Gt = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        class Kt {
            constructor(t, e, r, n = 1, i = !0){
                this.r = t, this.g = e, this.b = r, this.a = n, i || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
                    t,
                    e,
                    r,
                    n
                ]));
            }
            static parse(t) {
                if (t instanceof Kt) return t;
                if ("string" != typeof t) return;
                const e = function(t) {
                    if ("transparent" === (t = t.toLowerCase().trim())) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const e = Gt[t];
                    if (e) {
                        const [t, r, n] = e;
                        return [
                            t / 255,
                            r / 255,
                            n / 255,
                            1
                        ];
                    }
                    if (t.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t)) {
                        const e = t.length < 6 ? 1 : 2;
                        let r = 1;
                        return [
                            Ut(t.slice(r, r += e)),
                            Ut(t.slice(r, r += e)),
                            Ut(t.slice(r, r += e)),
                            Ut(t.slice(r, r + e) || "ff")
                        ];
                    }
                    if (t.startsWith("rgb")) {
                        const e = t.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                        if (e) {
                            const [t, r, n, i, s, a, o, l, u, c, h, p] = e, f = [
                                i || " ",
                                o || " ",
                                c
                            ].join("");
                            if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                const t = [
                                    n,
                                    a,
                                    u
                                ].join(""), e = "%%%" === t ? 100 : "" === t ? 255 : 0;
                                if (e) {
                                    const t = [
                                        Nt(+r / e, 0, 1),
                                        Nt(+s / e, 0, 1),
                                        Nt(+l / e, 0, 1),
                                        h ? qt(+h, p) : 1
                                    ];
                                    if (Zt(t)) return t;
                                }
                            }
                            return;
                        }
                    }
                    const r = t.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                    if (r) {
                        const [t, e, n, i, s, a, o, l, u] = r, c = [
                            n || " ",
                            s || " ",
                            o
                        ].join("");
                        if ("  " === c || "  /" === c || ",," === c || ",,," === c) {
                            const t = [
                                +e,
                                Nt(+i, 0, 100),
                                Nt(+a, 0, 100),
                                l ? qt(+l, u) : 1
                            ];
                            if (Zt(t)) return function([t, e, r, n]) {
                                function i(n) {
                                    const i = (n + t / 30) % 12, s = e * Math.min(r, 1 - r);
                                    return r - s * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                }
                                return t = Tt(t), e /= 100, r /= 100, [
                                    i(0),
                                    i(8),
                                    i(4),
                                    n
                                ];
                            }(t);
                        }
                    }
                }(t);
                return e ? new Kt(...e, !1) : void 0;
            }
            get rgb() {
                const { r: t, g: e, b: r, a: n } = this, i = n || 1 / 0;
                return this.overwriteGetter("rgb", [
                    t / i,
                    e / i,
                    r / i,
                    n
                ]);
            }
            get hcl() {
                return this.overwriteGetter("hcl", function(t) {
                    const [e, r, n, i] = $t(t), s = Math.sqrt(r * r + n * n);
                    return [
                        Math.round(1e4 * s) ? Tt(Math.atan2(n, r) * Ft) : NaN,
                        s,
                        e,
                        i
                    ];
                }(this.rgb));
            }
            get lab() {
                return this.overwriteGetter("lab", $t(this.rgb));
            }
            overwriteGetter(t, e) {
                return Object.defineProperty(this, t, {
                    value: e
                }), e;
            }
            toString() {
                const [t, e, r, n] = this.rgb;
                return `rgba(${[
                    t,
                    e,
                    r
                ].map((t)=>Math.round(255 * t)).join(",")},${n})`;
            }
        }
        Kt.black = new Kt(0, 0, 0, 1), Kt.white = new Kt(1, 1, 1, 1), Kt.transparent = new Kt(0, 0, 0, 0), Kt.red = new Kt(1, 0, 0, 1);
        class Xt {
            constructor(t, e, r){
                this.sensitivity = t ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t, e) {
                return this.collator.compare(t, e);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Ht {
            constructor(t, e, r, n, i){
                this.text = t, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Yt {
            constructor(t){
                this.sections = t;
            }
            static fromString(t) {
                return new Yt([
                    new Ht(t, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t)=>0 !== t.text.length || t.image && 0 !== t.image.name.length);
            }
            static factory(t) {
                return t instanceof Yt ? t : Yt.fromString(t);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t)=>t.text).join("");
            }
        }
        class Jt {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof Jt) return t;
                if ("number" == typeof t) return new Jt([
                    t,
                    t,
                    t,
                    t
                ]);
                if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
                    for (const e of t)if ("number" != typeof e) return;
                    switch(t.length){
                        case 1:
                            t = [
                                t[0],
                                t[0],
                                t[0],
                                t[0]
                            ];
                            break;
                        case 2:
                            t = [
                                t[0],
                                t[1],
                                t[0],
                                t[1]
                            ];
                            break;
                        case 3:
                            t = [
                                t[0],
                                t[1],
                                t[2],
                                t[1]
                            ];
                    }
                    return new Jt(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
        }
        const Wt = new Set([
            "center",
            "left",
            "right",
            "top",
            "bottom",
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]);
        class Qt {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof Qt) return t;
                if (Array.isArray(t) && !(t.length < 1) && t.length % 2 == 0) {
                    for(let e = 0; e < t.length; e += 2){
                        const r = t[e], n = t[e + 1];
                        if ("string" != typeof r || !Wt.has(r)) return;
                        if (!Array.isArray(n) || 2 !== n.length || "number" != typeof n[0] || "number" != typeof n[1]) return;
                    }
                    return new Qt(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
        }
        class te {
            constructor(t){
                this.name = t.name, this.available = t.available;
            }
            toString() {
                return this.name;
            }
            static fromString(t) {
                return t ? new te({
                    name: t,
                    available: !1
                }) : null;
            }
        }
        function ee(t, e, r, n) {
            return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t,
                e,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t,
                e,
                r,
                n
            ] : [
                t,
                e,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function re(t) {
            if (null === t || "string" == typeof t || "boolean" == typeof t || "number" == typeof t || t instanceof Kt || t instanceof Xt || t instanceof Yt || t instanceof Jt || t instanceof Qt || t instanceof te) return !0;
            if (Array.isArray(t)) {
                for (const e of t)if (!re(e)) return !1;
                return !0;
            }
            if ("object" == typeof t) {
                for(const e in t)if (!re(t[e])) return !1;
                return !0;
            }
            return !1;
        }
        function ne(t) {
            if (null === t) return lt;
            if ("string" == typeof t) return ct;
            if ("boolean" == typeof t) return ht;
            if ("number" == typeof t) return ut;
            if (t instanceof Kt) return pt;
            if (t instanceof Xt) return yt;
            if (t instanceof Yt) return mt;
            if (t instanceof Jt) return gt;
            if (t instanceof Qt) return vt;
            if (t instanceof te) return xt;
            if (Array.isArray(t)) {
                const e = t.length;
                let r;
                for (const e of t){
                    const t = ne(e);
                    if (r) {
                        if (r === t) continue;
                        r = dt;
                        break;
                    }
                    r = t;
                }
                return bt(r || dt, e);
            }
            return ft;
        }
        function ie(t) {
            const e = typeof t;
            return null === t ? "" : "string" === e || "number" === e || "boolean" === e ? String(t) : t instanceof Kt || t instanceof Yt || t instanceof Jt || t instanceof Qt || t instanceof te ? t.toString() : JSON.stringify(t);
        }
        class se {
            constructor(t, e){
                this.type = t, this.value = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'literal' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (!re(t[1])) return e.error("invalid value");
                const r = t[1];
                let n = ne(r);
                const i = e.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new se(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class ae {
            constructor(t){
                this.name = "ExpressionEvaluationError", this.message = t;
            }
            toJSON() {
                return this.message;
            }
        }
        const oe = {
            string: ct,
            number: ut,
            boolean: ht,
            object: ft
        };
        class le {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                let r, n = 1;
                const i = t[0];
                if ("array" === i) {
                    let i, s;
                    if (t.length > 2) {
                        const r = t[1];
                        if ("string" != typeof r || !(r in oe) || "object" === r) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = oe[r], n++;
                    } else i = dt;
                    if (t.length > 3) {
                        if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                        s = t[2], n++;
                    }
                    r = bt(i, s);
                } else {
                    if (!oe[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    r = oe[i];
                }
                const s = [];
                for(; n < t.length; n++){
                    const r = e.parse(t[n], n, dt);
                    if (!r) return null;
                    s.push(r);
                }
                return new le(r, s);
            }
            evaluate(t) {
                for(let e = 0; e < this.args.length; e++){
                    const r = this.args[e].evaluate(t);
                    if (!At(this.type, ne(r))) return r;
                    if (e === this.args.length - 1) throw new ae(`Expected value to be of type ${wt(this.type)}, but found ${wt(ne(r))} instead.`);
                }
                throw new Error;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const ue = {
            "to-boolean": ht,
            "to-color": pt,
            "to-number": ut,
            "to-string": ct
        };
        class ce {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[0];
                if (!ue[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                if (("to-boolean" === r || "to-string" === r) && 2 !== t.length) return e.error("Expected one argument.");
                const n = ue[r], i = [];
                for(let r = 1; r < t.length; r++){
                    const n = e.parse(t[r], r, dt);
                    if (!n) return null;
                    i.push(n);
                }
                return new ce(n, i);
            }
            evaluate(t) {
                switch(this.type.kind){
                    case "boolean":
                        return Boolean(this.args[0].evaluate(t));
                    case "color":
                        {
                            let e, r;
                            for (const n of this.args){
                                if (e = n.evaluate(t), r = null, e instanceof Kt) return e;
                                if ("string" == typeof e) {
                                    const r = t.parseColor(e);
                                    if (r) return r;
                                } else if (Array.isArray(e) && (r = e.length < 3 || e.length > 4 ? `Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.` : ee(e[0], e[1], e[2], e[3]), !r)) return new Kt(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
                            }
                            throw new ae(r || `Could not parse color from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "padding":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = Jt.parse(e);
                                if (n) return n;
                            }
                            throw new ae(`Could not parse padding from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "variableAnchorOffsetCollection":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = Qt.parse(e);
                                if (n) return n;
                            }
                            throw new ae(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "number":
                        {
                            let e = null;
                            for (const r of this.args){
                                if (e = r.evaluate(t), null === e) return 0;
                                const n = Number(e);
                                if (!isNaN(n)) return n;
                            }
                            throw new ae(`Could not convert ${JSON.stringify(e)} to number.`);
                        }
                    case "formatted":
                        return Yt.fromString(ie(this.args[0].evaluate(t)));
                    case "resolvedImage":
                        return te.fromString(ie(this.args[0].evaluate(t)));
                    default:
                        return ie(this.args[0].evaluate(t));
                }
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const he = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class pe {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
            }
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? he[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(t) {
                let e = this._parseColorCache[t];
                return e || (e = this._parseColorCache[t] = Kt.parse(t)), e;
            }
        }
        class fe {
            constructor(t, e, r = [], n, i = new ot, s = []){
                this.registry = t, this.path = r, this.key = r.map((t)=>`[${t}]`).join(""), this.scope = i, this.errors = s, this.expectedType = n, this._isConstant = e;
            }
            parse(t, e, r, n, i = {}) {
                return e ? this.concat(e, r, n)._parse(t, i) : this._parse(t, i);
            }
            _parse(t, e) {
                function r(t, e, r) {
                    return "assert" === r ? new le(e, [
                        t
                    ]) : "coerce" === r ? new ce(e, [
                        t
                    ]) : t;
                }
                if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = [
                    "literal",
                    t
                ]), Array.isArray(t)) {
                    if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t = this.expectedType, i = n.type;
                            if ("string" !== t.kind && "number" !== t.kind && "boolean" !== t.kind && "object" !== t.kind && "array" !== t.kind || "value" !== i.kind) {
                                if ("color" !== t.kind && "formatted" !== t.kind && "resolvedImage" !== t.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if ("padding" !== t.kind || "value" !== i.kind && "number" !== i.kind && "array" !== i.kind) {
                                        if ("variableAnchorOffsetCollection" !== t.kind || "value" !== i.kind && "array" !== i.kind) {
                                            if (this.checkSubtype(t, i)) return null;
                                        } else n = r(n, t, e.typeAnnotation || "coerce");
                                    } else n = r(n, t, e.typeAnnotation || "coerce");
                                } else n = r(n, t, e.typeAnnotation || "coerce");
                            } else n = r(n, t, e.typeAnnotation || "assert");
                        }
                        if (!(n instanceof se) && "resolvedImage" !== n.type.kind && this._isConstant(n)) {
                            const t = new pe;
                            try {
                                n = new se(n.type, n.evaluate(t));
                            } catch (t) {
                                return this.error(t.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t ? "'undefined' value invalid. Use null instead." : "object" == typeof t ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t} instead.`);
            }
            concat(t, e, r) {
                const n = "number" == typeof t ? this.path.concat(t) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new fe(this.registry, this._isConstant, n, e || null, i, this.errors);
            }
            error(t, ...e) {
                const r = `${this.key}${e.map((t)=>`[${t}]`).join("")}`;
                this.errors.push(new at(r, t));
            }
            checkSubtype(t, e) {
                const r = At(t, e);
                return r && this.error(r), r;
            }
        }
        class de {
            constructor(t, e){
                this.type = e.type, this.bindings = [].concat(t), this.result = e;
            }
            evaluate(t) {
                return this.result.evaluate(t);
            }
            eachChild(t) {
                for (const e of this.bindings)t(e[1]);
                t(this.result);
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found ${t.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t.length - 1; n += 2){
                    const i = t[n];
                    if ("string" != typeof i) return e.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = e.parse(t[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = e.parse(t[t.length - 1], t.length - 1, e.expectedType, r);
                return n ? new de(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
        }
        class ye {
            constructor(t, e){
                this.type = e.type, this.name = t, this.boundExpression = e;
            }
            static parse(t, e) {
                if (2 !== t.length || "string" != typeof t[1]) return e.error("'var' expression requires exactly one string literal argument.");
                const r = t[1];
                return e.scope.has(r) ? new ye(r, e.scope.get(r)) : e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t) {
                return this.boundExpression.evaluate(t);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        class me {
            constructor(t, e, r){
                this.type = t, this.index = e, this.input = r;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, ut), n = e.parse(t[2], 2, bt(e.expectedType || dt));
                return r && n ? new me(n.type.itemType, r, n) : null;
            }
            evaluate(t) {
                const e = this.index.evaluate(t), r = this.input.evaluate(t);
                if (e < 0) throw new ae(`Array index out of bounds: ${e} < 0.`);
                if (e >= r.length) throw new ae(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e !== Math.floor(e)) throw new ae(`Array index must be an integer, but found ${e} instead.`);
                return r[e];
            }
            eachChild(t) {
                t(this.index), t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class ge {
            constructor(t, e){
                this.type = ht, this.needle = t, this.haystack = e;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, dt), n = e.parse(t[2], 2, dt);
                return r && n ? St(r.type, [
                    ht,
                    ct,
                    ut,
                    lt,
                    dt
                ]) ? new ge(r, n) : e.error(`Expected first argument to be of type boolean, string, number or null, but found ${wt(r.type)} instead`) : null;
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!r) return !1;
                if (!kt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ae(`Expected first argument to be of type boolean, string, number or null, but found ${wt(ne(e))} instead.`);
                if (!kt(r, [
                    "string",
                    "array"
                ])) throw new ae(`Expected second argument to be of type array or string, but found ${wt(ne(r))} instead.`);
                return r.indexOf(e) >= 0;
            }
            eachChild(t) {
                t(this.needle), t(this.haystack);
            }
            outputDefined() {
                return !0;
            }
        }
        class xe {
            constructor(t, e, r){
                this.type = ut, this.needle = t, this.haystack = e, this.fromIndex = r;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, dt), n = e.parse(t[2], 2, dt);
                if (!r || !n) return null;
                if (!St(r.type, [
                    ht,
                    ct,
                    ut,
                    lt,
                    dt
                ])) return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${wt(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, ut);
                    return i ? new xe(r, n, i) : null;
                }
                return new xe(r, n);
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!kt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ae(`Expected first argument to be of type boolean, string, number or null, but found ${wt(ne(e))} instead.`);
                let n;
                if (this.fromIndex && (n = this.fromIndex.evaluate(t)), kt(r, [
                    "string"
                ])) {
                    const t = r.indexOf(e, n);
                    return -1 === t ? -1 : [
                        ...r.slice(0, t)
                    ].length;
                }
                if (kt(r, [
                    "array"
                ])) return r.indexOf(e, n);
                throw new ae(`Expected second argument to be of type array or string, but found ${wt(ne(r))} instead.`);
            }
            eachChild(t) {
                t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        class ve {
            constructor(t, e, r, n, i, s){
                this.inputType = t, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(t, e) {
                if (t.length < 5) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 1) return e.error("Expected an even number of arguments.");
                let r, n;
                e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
                const i = {}, s = [];
                for(let a = 2; a < t.length - 1; a += 2){
                    let o = t[a];
                    const l = t[a + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e.concat(a);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t of o){
                        if ("number" != typeof t && "string" != typeof t) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t && Math.abs(t) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t && Math.floor(t) !== t) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, ne(t))) return null;
                        } else r = ne(t);
                        if (void 0 !== i[String(t)]) return u.error("Branch labels must be unique.");
                        i[String(t)] = s.length;
                    }
                    const c = e.parse(l, a, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const a = e.parse(t[1], 1, dt);
                if (!a) return null;
                const o = e.parse(t[t.length - 1], t.length - 1, n);
                return o ? "value" !== a.type.kind && e.concat(1).checkSubtype(r, a.type) ? null : new ve(r, n, a, i, s, o) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                return (ne(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t);
            }
            eachChild(t) {
                t(this.input), this.outputs.forEach(t), t(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class be {
            constructor(t, e, r){
                this.type = t, this.branches = e, this.otherwise = r;
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 0) return e.error("Expected an odd number of arguments.");
                let r;
                e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
                const n = [];
                for(let i = 1; i < t.length - 1; i += 2){
                    const s = e.parse(t[i], i, ht);
                    if (!s) return null;
                    const a = e.parse(t[i + 1], i + 1, r);
                    if (!a) return null;
                    n.push([
                        s,
                        a
                    ]), r = r || a.type;
                }
                const i = e.parse(t[t.length - 1], t.length - 1, r);
                if (!i) return null;
                if (!r) throw new Error("Can't infer output type");
                return new be(r, n, i);
            }
            evaluate(t) {
                for (const [e, r] of this.branches)if (e.evaluate(t)) return r.evaluate(t);
                return this.otherwise.evaluate(t);
            }
            eachChild(t) {
                for (const [e, r] of this.branches)t(e), t(r);
                t(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t, e])=>e.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class we {
            constructor(t, e, r, n){
                this.type = t, this.input = e, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, dt), n = e.parse(t[2], 2, ut);
                if (!r || !n) return null;
                if (!St(r.type, [
                    bt(dt),
                    ct,
                    dt
                ])) return e.error(`Expected first argument to be of type array or string, but found ${wt(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, ut);
                    return i ? new we(r.type, r, n, i) : null;
                }
                return new we(r.type, r, n);
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = this.beginIndex.evaluate(t);
                let n;
                if (this.endIndex && (n = this.endIndex.evaluate(t)), kt(e, [
                    "string"
                ])) return [
                    ...e
                ].slice(r, n).join("");
                if (kt(e, [
                    "array"
                ])) return e.slice(r, n);
                throw new ae(`Expected first argument to be of type array or string, but found ${wt(ne(e))} instead.`);
            }
            eachChild(t) {
                t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        function _e(t, e) {
            const r = t.length - 1;
            let n, i, s = 0, a = r, o = 0;
            for(; s <= a;)if (o = Math.floor((s + a) / 2), n = t[o], i = t[o + 1], n <= e) {
                if (o === r || e < i) return o;
                s = o + 1;
            } else {
                if (!(n > e)) throw new ae("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        class Ae {
            constructor(t, e, r){
                this.type = t, this.input = e, this.labels = [], this.outputs = [];
                for (const [t, e] of r)this.labels.push(t), this.outputs.push(e);
            }
            static parse(t, e) {
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                const r = e.parse(t[1], 1, ut);
                if (!r) return null;
                const n = [];
                let i = null;
                e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
                for(let r = 1; r < t.length; r += 2){
                    const s = 1 === r ? -1 / 0 : t[r], a = t[r + 1], o = r, l = r + 1;
                    if ("number" != typeof s) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= s) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e.parse(a, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new Ae(i, r, n);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                return n >= e[i - 1] ? r[i - 1].evaluate(t) : r[_e(e, n)].evaluate(t);
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function Se(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var ke = Me;
        function Me(t, e, r, n) {
            this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e, this.p2x = r, this.p2y = n;
        }
        Me.prototype = {
            sampleCurveX: function(t) {
                return ((this.ax * t + this.bx) * t + this.cx) * t;
            },
            sampleCurveY: function(t) {
                return ((this.ay * t + this.by) * t + this.cy) * t;
            },
            sampleCurveDerivativeX: function(t) {
                return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
            },
            solveCurveX: function(t, e) {
                if (void 0 === e && (e = 1e-6), t < 0) return 0;
                if (t > 1) return 1;
                for(var r = t, n = 0; n < 8; n++){
                    var i = this.sampleCurveX(r) - t;
                    if (Math.abs(i) < e) return r;
                    var s = this.sampleCurveDerivativeX(r);
                    if (Math.abs(s) < 1e-6) break;
                    r -= i / s;
                }
                var a = 0, o = 1;
                for(r = t, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t) < e)); n++)t > i ? a = r : o = r, r = .5 * (o - a) + a;
                return r;
            },
            solve: function(t, e) {
                return this.sampleCurveY(this.solveCurveX(t, e));
            }
        };
        var Ie = Se(ke);
        function ze(t, e, r) {
            return t + r * (e - t);
        }
        function Pe(t, e, r) {
            return t.map((t, n)=>ze(t, e[n], r));
        }
        const Ce = {
            number: ze,
            color: function(t, e, r, n = "rgb") {
                switch(n){
                    case "rgb":
                        {
                            const [n, i, s, a] = Pe(t.rgb, e.rgb, r);
                            return new Kt(n, i, s, a, !1);
                        }
                    case "hcl":
                        {
                            const [n, i, s, a] = t.hcl, [o, l, u, c] = e.hcl;
                            let h, p;
                            if (isNaN(n) || isNaN(o)) isNaN(n) ? isNaN(o) ? h = NaN : (h = o, 1 !== s && 0 !== s || (p = l)) : (h = n, 1 !== u && 0 !== u || (p = i));
                            else {
                                let t = o - n;
                                o > n && t > 180 ? t -= 360 : o < n && n - o > 180 && (t += 360), h = n + r * t;
                            }
                            const [f, d, y, m] = function([t, e, r, n]) {
                                return t = isNaN(t) ? 0 : t * Et, Ot([
                                    r,
                                    Math.cos(t) * e,
                                    Math.sin(t) * e,
                                    n
                                ]);
                            }([
                                h,
                                null != p ? p : ze(i, l, r),
                                ze(s, u, r),
                                ze(a, c, r)
                            ]);
                            return new Kt(f, d, y, m, !1);
                        }
                    case "lab":
                        {
                            const [n, i, s, a] = Ot(Pe(t.lab, e.lab, r));
                            return new Kt(n, i, s, a, !1);
                        }
                }
            },
            array: Pe,
            padding: function(t, e, r) {
                return new Jt(Pe(t.values, e.values, r));
            },
            variableAnchorOffsetCollection: function(t, e, r) {
                const n = t.values, i = e.values;
                if (n.length !== i.length) throw new ae(`Cannot interpolate values of different length. from: ${t.toString()}, to: ${e.toString()}`);
                const s = [];
                for(let t = 0; t < n.length; t += 2){
                    if (n[t] !== i[t]) throw new ae(`Cannot interpolate values containing mismatched anchors. from[${t}]: ${n[t]}, to[${t}]: ${i[t]}`);
                    s.push(n[t]);
                    const [e, a] = n[t + 1], [o, l] = i[t + 1];
                    s.push([
                        ze(e, o, r),
                        ze(a, l, r)
                    ]);
                }
                return new Qt(s);
            }
        };
        class Be {
            constructor(t, e, r, n, i){
                this.type = t, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t, e] of i)this.labels.push(t), this.outputs.push(e);
            }
            static interpolationFactor(t, e, r, n) {
                let i = 0;
                if ("exponential" === t.name) i = Ve(e, t.base, r, n);
                else if ("linear" === t.name) i = Ve(e, 1, r, n);
                else if ("cubic-bezier" === t.name) {
                    const s = t.controlPoints;
                    i = new Ie(s[0], s[1], s[2], s[3]).solve(Ve(e, 1, r, n));
                }
                return i;
            }
            static parse(t, e) {
                let [r, n, i, ...s] = t;
                if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t = n[1];
                    if ("number" != typeof t) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t = n.slice(1);
                        if (4 !== t.length || t.some((t)=>"number" != typeof t || t < 0 || t > 1)) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t
                        };
                    }
                }
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                if (i = e.parse(i, 2, ut), !i) return null;
                const a = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = pt : e.expectedType && "value" !== e.expectedType.kind && (o = e.expectedType);
                for(let t = 0; t < s.length; t += 2){
                    const r = s[t], n = s[t + 1], i = t + 3, l = t + 4;
                    if ("number" != typeof r) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (a.length && a[a.length - 1][0] >= r) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, a.push([
                        r,
                        u
                    ]);
                }
                return Mt(o, ut) || Mt(o, pt) || Mt(o, gt) || Mt(o, vt) || Mt(o, bt(ut)) ? new Be(o, r, n, i, a) : e.error(`Type ${wt(o)} is not interpolatable.`);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                if (n >= e[i - 1]) return r[i - 1].evaluate(t);
                const s = _e(e, n), a = Be.interpolationFactor(this.interpolation, n, e[s], e[s + 1]), o = r[s].evaluate(t), l = r[s + 1].evaluate(t);
                switch(this.operator){
                    case "interpolate":
                        return Ce[this.type.kind](o, l, a);
                    case "interpolate-hcl":
                        return Ce.color(o, l, a, "hcl");
                    case "interpolate-lab":
                        return Ce.color(o, l, a, "lab");
                }
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function Ve(t, e, r, n) {
            const i = n - r, s = t - r;
            return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
        }
        class Ee {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expectected at least one argument.");
                let r = null;
                const n = e.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t.slice(1)){
                    const t = e.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t) return null;
                    r = r || t.type, i.push(t);
                }
                if (!r) throw new Error("No output type");
                const s = n && i.some((t)=>At(n, t.type));
                return new Ee(s ? dt : r, i);
            }
            evaluate(t) {
                let e, r = null, n = 0;
                for (const i of this.args)if (n++, r = i.evaluate(t), r && r instanceof te && !r.available && (e || (e = r.name), r = null, n === this.args.length && (r = e)), null !== r) break;
                return r;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        function Fe(t, e) {
            return "==" === t || "!=" === t ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
        }
        function Te(t, e, r, n) {
            return 0 === n.compare(e, r);
        }
        function $e(t, e, r) {
            const n = "==" !== t && "!=" !== t;
            return class i {
                constructor(t, e, r){
                    this.type = ht, this.lhs = t, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t.type.kind || "value" === e.type.kind;
                }
                static parse(t, e) {
                    if (3 !== t.length && 4 !== t.length) return e.error("Expected two or three arguments.");
                    const r = t[0];
                    let s = e.parse(t[1], 1, dt);
                    if (!s) return null;
                    if (!Fe(r, s.type)) return e.concat(1).error(`"${r}" comparisons are not supported for type '${wt(s.type)}'.`);
                    let a = e.parse(t[2], 2, dt);
                    if (!a) return null;
                    if (!Fe(r, a.type)) return e.concat(2).error(`"${r}" comparisons are not supported for type '${wt(a.type)}'.`);
                    if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error(`Cannot compare types '${wt(s.type)}' and '${wt(a.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new le(a.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new le(s.type, [
                        a
                    ])));
                    let o = null;
                    if (4 === t.length) {
                        if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error("Cannot use collator to compare non-string types.");
                        if (o = e.parse(t[3], 3, yt), !o) return null;
                    }
                    return new i(s, a, o);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), a = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e = ne(s), r = ne(a);
                        if (e.kind !== r.kind || "string" !== e.kind && "number" !== e.kind) throw new ae(`Expected arguments for "${t}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t = ne(s), r = ne(a);
                        if ("string" !== t.kind || "string" !== r.kind) return e(i, s, a);
                    }
                    return this.collator ? r(i, s, a, this.collator.evaluate(i)) : e(i, s, a);
                }
                eachChild(t) {
                    t(this.lhs), t(this.rhs), this.collator && t(this.collator);
                }
                outputDefined() {
                    return !0;
                }
            };
        }
        const Le = $e("==", function(t, e, r) {
            return e === r;
        }, Te), De = $e("!=", function(t, e, r) {
            return e !== r;
        }, function(t, e, r, n) {
            return !Te(0, e, r, n);
        }), Oe = $e("<", function(t, e, r) {
            return e < r;
        }, function(t, e, r, n) {
            return n.compare(e, r) < 0;
        }), je = $e(">", function(t, e, r) {
            return e > r;
        }, function(t, e, r, n) {
            return n.compare(e, r) > 0;
        }), Re = $e("<=", function(t, e, r) {
            return e <= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) <= 0;
        }), Ue = $e(">=", function(t, e, r) {
            return e >= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) >= 0;
        });
        class qe {
            constructor(t, e, r){
                this.type = yt, this.locale = r, this.caseSensitive = t, this.diacriticSensitive = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected one argument.");
                const r = t[1];
                if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
                const n = e.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, ht);
                if (!n) return null;
                const i = e.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, ht);
                if (!i) return null;
                let s = null;
                return r.locale && (s = e.parse(r.locale, 1, ct), !s) ? null : new qe(n, i, s);
            }
            evaluate(t) {
                return new Xt(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
            }
            eachChild(t) {
                t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
            }
            outputDefined() {
                return !1;
            }
        }
        class Ne {
            constructor(t, e, r, n, i){
                this.type = ct, this.number = t, this.locale = e, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, ut);
                if (!r) return null;
                const n = t[2];
                if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e.parse(n.locale, 1, ct), !i)) return null;
                let s = null;
                if (n.currency && (s = e.parse(n.currency, 1, ct), !s)) return null;
                let a = null;
                if (n["min-fraction-digits"] && (a = e.parse(n["min-fraction-digits"], 1, ut), !a)) return null;
                let o = null;
                return n["max-fraction-digits"] && (o = e.parse(n["max-fraction-digits"], 1, ut), !o) ? null : new Ne(r, i, s, a, o);
            }
            evaluate(t) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
                    style: this.currency ? "currency" : "decimal",
                    currency: this.currency ? this.currency.evaluate(t) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
                }).format(this.number.evaluate(t));
            }
            eachChild(t) {
                t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
        }
        class Ze {
            constructor(t){
                this.type = mt, this.sections = t;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[1];
                if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t.length - 1; ++r){
                    const s = t[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let t = null;
                        if (s["font-scale"] && (t = e.parse(s["font-scale"], 1, ut), !t)) return null;
                        let r = null;
                        if (s["text-font"] && (r = e.parse(s["text-font"], 1, bt(ct)), !r)) return null;
                        let a = null;
                        if (s["text-color"] && (a = e.parse(s["text-color"], 1, pt), !a)) return null;
                        const o = n[n.length - 1];
                        o.scale = t, o.font = r, o.textColor = a;
                    } else {
                        const s = e.parse(t[r], 1, dt);
                        if (!s) return null;
                        const a = s.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Ze(n);
            }
            evaluate(t) {
                return new Yt(this.sections.map((e)=>{
                    const r = e.content.evaluate(t);
                    return ne(r) === xt ? new Ht("", r, null, null, null) : new Ht(ie(r), null, e.scale ? e.scale.evaluate(t) : null, e.font ? e.font.evaluate(t).join(",") : null, e.textColor ? e.textColor.evaluate(t) : null);
                }));
            }
            eachChild(t) {
                for (const e of this.sections)t(e.content), e.scale && t(e.scale), e.font && t(e.font), e.textColor && t(e.textColor);
            }
            outputDefined() {
                return !1;
            }
        }
        class Ge {
            constructor(t){
                this.type = xt, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, ct);
                return r ? new Ge(r) : e.error("No image name provided.");
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = te.fromString(e);
                return r && t.availableImages && (r.available = t.availableImages.indexOf(e) > -1), r;
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class Ke {
            constructor(t){
                this.type = ut, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error(`Expected argument of type string or array, but found ${wt(r.type)} instead.`) : new Ke(r) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                if ("string" == typeof e) return [
                    ...e
                ].length;
                if (Array.isArray(e)) return e.length;
                throw new ae(`Expected value to be of type string or array, but found ${wt(ne(e))} instead.`);
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        const Xe = 8192;
        function He(t, e) {
            const r = (180 + t[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t[1] * Math.PI / 360))) / 360, i = Math.pow(2, e.z);
            return [
                Math.round(r * i * Xe),
                Math.round(n * i * Xe)
            ];
        }
        function Ye(t, e) {
            const r = Math.pow(2, e.z);
            var n, i;
            return [
                (i = (t[0] / Xe + e.x) / r, 360 * i - 180),
                (n = (t[1] / Xe + e.y) / r, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * n) * Math.PI / 180)) - 90)
            ];
        }
        function Je(t, e) {
            t[0] = Math.min(t[0], e[0]), t[1] = Math.min(t[1], e[1]), t[2] = Math.max(t[2], e[0]), t[3] = Math.max(t[3], e[1]);
        }
        function We(t, e) {
            return !(t[0] <= e[0] || t[2] >= e[2] || t[1] <= e[1] || t[3] >= e[3]);
        }
        function Qe(t, e, r) {
            const n = t[0] - e[0], i = t[1] - e[1], s = t[0] - r[0], a = t[1] - r[1];
            return n * a - s * i == 0 && n * s <= 0 && i * a <= 0;
        }
        function tr(t, e, r, n) {
            var i, s;
            return 0 != (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                e[0] - t[0],
                e[1] - t[1]
            ])[1] - i[1] * s[0] && !(!ar(t, e, r, n) || !ar(r, n, t, e));
        }
        function er(t, e, r) {
            for (const n of r)for(let r = 0; r < n.length - 1; ++r)if (tr(t, e, n[r], n[r + 1])) return !0;
            return !1;
        }
        function rr(t, e, r = !1) {
            let n = !1;
            for (const o of e)for(let e = 0; e < o.length - 1; e++){
                if (Qe(t, o[e], o[e + 1])) return r;
                (s = o[e])[1] > (i = t)[1] != (a = o[e + 1])[1] > i[1] && i[0] < (a[0] - s[0]) * (i[1] - s[1]) / (a[1] - s[1]) + s[0] && (n = !n);
            }
            var i, s, a;
            return n;
        }
        function nr(t, e) {
            for (const r of e)if (rr(t, r)) return !0;
            return !1;
        }
        function ir(t, e) {
            for (const r of t)if (!rr(r, e)) return !1;
            for(let r = 0; r < t.length - 1; ++r)if (er(t[r], t[r + 1], e)) return !1;
            return !0;
        }
        function sr(t, e) {
            for (const r of e)if (ir(t, r)) return !0;
            return !1;
        }
        function ar(t, e, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], a = (t[0] - r[0]) * s - i * (t[1] - r[1]), o = (e[0] - r[0]) * s - i * (e[1] - r[1]);
            return a > 0 && o < 0 || a < 0 && o > 0;
        }
        function or(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const s = [];
                for(let n = 0; n < t[i].length; n++){
                    const a = He(t[i][n], r);
                    Je(e, a), s.push(a);
                }
                n.push(s);
            }
            return n;
        }
        function lr(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const s = or(t[i], e, r);
                n.push(s);
            }
            return n;
        }
        function ur(t, e, r, n) {
            if (t[0] < r[0] || t[0] > r[2]) {
                const e = .5 * n;
                let i = t[0] - r[0] > e ? -n : r[0] - t[0] > e ? n : 0;
                0 === i && (i = t[0] - r[2] > e ? -n : r[2] - t[0] > e ? n : 0), t[0] += i;
            }
            Je(e, t);
        }
        function cr(t, e, r, n) {
            const i = Math.pow(2, n.z) * Xe, s = [
                n.x * Xe,
                n.y * Xe
            ], a = [];
            for (const n of t)for (const t of n){
                const n = [
                    t.x + s[0],
                    t.y + s[1]
                ];
                ur(n, e, r, i), a.push(n);
            }
            return a;
        }
        function hr(t, e, r, n) {
            const i = Math.pow(2, n.z) * Xe, s = [
                n.x * Xe,
                n.y * Xe
            ], a = [];
            for (const r of t){
                const t = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    Je(e, r), t.push(r);
                }
                a.push(t);
            }
            if (e[2] - e[0] <= i / 2) {
                (o = e)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t of a)for (const n of t)ur(n, e, r, i);
            }
            var o;
            return a;
        }
        class pr {
            constructor(t, e){
                this.type = ht, this.geojson = t, this.geometries = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'within' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (re(t[1])) {
                    const e = t[1];
                    if ("FeatureCollection" === e.type) {
                        const t = [];
                        for (const r of e.features){
                            const { type: e, coordinates: n } = r.geometry;
                            "Polygon" === e && t.push(n), "MultiPolygon" === e && t.push(...n);
                        }
                        if (t.length) return new pr(e, {
                            type: "MultiPolygon",
                            coordinates: t
                        });
                    } else if ("Feature" === e.type) {
                        const t = e.geometry.type;
                        if ("Polygon" === t || "MultiPolygon" === t) return new pr(e, e.geometry);
                    } else if ("Polygon" === e.type || "MultiPolygon" === e.type) return new pr(e, e);
                }
                return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const s = or(e.coordinates, n, i), a = cr(t.geometry(), r, n, i);
                            if (!We(r, n)) return !1;
                            for (const t of a)if (!rr(t, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = lr(e.coordinates, n, i), a = cr(t.geometry(), r, n, i);
                            if (!We(r, n)) return !1;
                            for (const t of a)if (!nr(t, s)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const s = or(e.coordinates, n, i), a = hr(t.geometry(), r, n, i);
                            if (!We(r, n)) return !1;
                            for (const t of a)if (!ir(t, s)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const s = lr(e.coordinates, n, i), a = hr(t.geometry(), r, n, i);
                            if (!We(r, n)) return !1;
                            for (const t of a)if (!sr(t, s)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        let fr = class {
            constructor(t = [], e = (t, e)=>t < e ? -1 : t > e ? 1 : 0){
                if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e = this.data.pop();
                return --this.length > 0 && (this.data[0] = e, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e, compare: r } = this, n = e[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, s = e[i];
                    if (r(n, s) >= 0) break;
                    e[t] = s, t = i;
                }
                e[t] = n;
            }
            _down(t) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t];
                for(; t < n;){
                    let n = 1 + (t << 1);
                    const s = n + 1;
                    if (s < this.length && r(e[s], e[n]) < 0 && (n = s), r(e[n], i) >= 0) break;
                    e[t] = e[n], t = n;
                }
                e[t] = i;
            }
        };
        function dr(t, e, r, n, i) {
            yr(t, e, r, n || t.length - 1, i || gr);
        }
        function yr(t, e, r, n, i) {
            for(; n > r;){
                if (n - r > 600) {
                    var s = n - r + 1, a = e - r + 1, o = Math.log(s), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (s - l) / s) * (a - s / 2 < 0 ? -1 : 1);
                    yr(t, e, Math.max(r, Math.floor(e - a * l / s + u)), Math.min(n, Math.floor(e + (s - a) * l / s + u)), i);
                }
                var c = t[e], h = r, p = n;
                for(mr(t, r, e), i(t[n], c) > 0 && mr(t, r, n); h < p;){
                    for(mr(t, h, p), h++, p--; i(t[h], c) < 0;)h++;
                    for(; i(t[p], c) > 0;)p--;
                }
                0 === i(t[r], c) ? mr(t, r, p) : mr(t, ++p, n), p <= e && (r = p + 1), e <= p && (n = p - 1);
            }
        }
        function mr(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function gr(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function xr(t, e) {
            if (t.length <= 1) return [
                t
            ];
            const r = [];
            let n, i;
            for (const e of t){
                const t = br(e);
                0 !== t && (e.area = Math.abs(t), void 0 === i && (i = t < 0), i === t < 0 ? (n && r.push(n), n = [
                    e
                ]) : n.push(e));
            }
            if (n && r.push(n), e > 1) for(let t = 0; t < r.length; t++)r[t].length <= e || (dr(r[t], e, 1, r[t].length - 1, vr), r[t] = r[t].slice(0, e));
            return r;
        }
        function vr(t, e) {
            return e.area - t.area;
        }
        function br(t) {
            let e = 0;
            for(let r, n, i = 0, s = t.length, a = s - 1; i < s; a = i++)r = t[i], n = t[a], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        const wr = 1 / 298.257223563, _r = wr * (2 - wr), Ar = Math.PI / 180;
        class Sr {
            constructor(t){
                const e = 6378.137 * Ar * 1e3, r = Math.cos(t * Ar), n = 1 / (1 - _r * (1 - r * r)), i = Math.sqrt(n);
                this.kx = e * i * r, this.ky = e * i * n * (1 - _r);
            }
            distance(t, e) {
                const r = this.wrap(t[0] - e[0]) * this.kx, n = (t[1] - e[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            pointOnLine(t, e) {
                let r, n, i, s, a = 1 / 0;
                for(let o = 0; o < t.length - 1; o++){
                    let l = t[o][0], u = t[o][1], c = this.wrap(t[o + 1][0] - l) * this.kx, h = (t[o + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (this.wrap(e[0] - l) * this.kx * c + (e[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = t[o + 1][0], u = t[o + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = this.wrap(e[0] - l) * this.kx, h = (e[1] - u) * this.ky;
                    const f = c * c + h * h;
                    f < a && (a = f, r = l, n = u, i = o, s = p);
                }
                return {
                    point: [
                        r,
                        n
                    ],
                    index: i,
                    t: Math.max(0, Math.min(1, s))
                };
            }
            wrap(t) {
                for(; t < -180;)t += 360;
                for(; t > 180;)t -= 360;
                return t;
            }
        }
        function kr(t, e) {
            return e[0] - t[0];
        }
        function Mr(t) {
            return t[1] - t[0] + 1;
        }
        function Ir(t, e) {
            return t[1] >= t[0] && t[1] < e;
        }
        function zr(t, e) {
            if (t[0] > t[1]) return [
                null,
                null
            ];
            const r = Mr(t);
            if (e) {
                if (2 === r) return [
                    t,
                    null
                ];
                const e = Math.floor(r / 2);
                return [
                    [
                        t[0],
                        t[0] + e
                    ],
                    [
                        t[0] + e,
                        t[1]
                    ]
                ];
            }
            if (1 === r) return [
                t,
                null
            ];
            const n = Math.floor(r / 2) - 1;
            return [
                [
                    t[0],
                    t[0] + n
                ],
                [
                    t[0] + n + 1,
                    t[1]
                ]
            ];
        }
        function Pr(t, e) {
            if (!Ir(e, t.length)) return [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let n = e[0]; n <= e[1]; ++n)Je(r, t[n]);
            return r;
        }
        function Cr(t) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for (const r of t)for (const t of r)Je(e, t);
            return e;
        }
        function Br(t) {
            return t[0] !== -1 / 0 && t[1] !== -1 / 0 && t[2] !== 1 / 0 && t[3] !== 1 / 0;
        }
        function Vr(t, e, r) {
            if (!Br(t) || !Br(e)) return NaN;
            let n = 0, i = 0;
            return t[2] < e[0] && (n = e[0] - t[2]), t[0] > e[2] && (n = t[0] - e[2]), t[1] > e[3] && (i = t[1] - e[3]), t[3] < e[1] && (i = e[1] - t[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function Er(t, e, r) {
            const n = r.pointOnLine(e, t);
            return r.distance(t, n.point);
        }
        function Fr(t, e, r, n, i) {
            const s = Math.min(Er(t, [
                r,
                n
            ], i), Er(e, [
                r,
                n
            ], i)), a = Math.min(Er(r, [
                t,
                e
            ], i), Er(n, [
                t,
                e
            ], i));
            return Math.min(s, a);
        }
        function Tr(t, e, r, n, i) {
            if (!Ir(e, t.length) || !Ir(n, r.length)) return 1 / 0;
            let s = 1 / 0;
            for(let a = e[0]; a < e[1]; ++a){
                const e = t[a], o = t[a + 1];
                for(let t = n[0]; t < n[1]; ++t){
                    const n = r[t], a = r[t + 1];
                    if (tr(e, o, n, a)) return 0;
                    s = Math.min(s, Fr(e, o, n, a, i));
                }
            }
            return s;
        }
        function $r(t, e, r, n, i) {
            if (!Ir(e, t.length) || !Ir(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let a = e[0]; a <= e[1]; ++a)for(let e = n[0]; e <= n[1]; ++e)if (s = Math.min(s, i.distance(t[a], r[e])), 0 === s) return s;
            return s;
        }
        function Lr(t, e, r) {
            if (rr(t, e, !0)) return 0;
            let n = 1 / 0;
            for (const i of e){
                const e = i[0], s = i[i.length - 1];
                if (e !== s && (n = Math.min(n, Er(t, [
                    s,
                    e
                ], r)), 0 === n)) return n;
                const a = r.pointOnLine(i, t);
                if (n = Math.min(n, r.distance(t, a.point)), 0 === n) return n;
            }
            return n;
        }
        function Dr(t, e, r, n) {
            if (!Ir(e, t.length)) return NaN;
            for(let n = e[0]; n <= e[1]; ++n)if (rr(t[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let s = e[0]; s < e[1]; ++s){
                const e = t[s], a = t[s + 1];
                for (const t of r)for(let r = 0, s = t.length, o = s - 1; r < s; o = r++){
                    const s = t[o], l = t[r];
                    if (tr(e, a, s, l)) return 0;
                    i = Math.min(i, Fr(e, a, s, l, n));
                }
            }
            return i;
        }
        function Or(t, e) {
            for (const r of t)for (const t of r)if (rr(t, e, !0)) return !0;
            return !1;
        }
        function jr(t, e, r, n = 1 / 0) {
            const i = Cr(t), s = Cr(e);
            if (n !== 1 / 0 && Vr(i, s, r) >= n) return n;
            if (We(i, s)) {
                if (Or(t, e)) return 0;
            } else if (Or(e, t)) return 0;
            let a = 1 / 0;
            for (const n of t)for(let t = 0, i = n.length, s = i - 1; t < i; s = t++){
                const i = n[s], o = n[t];
                for (const t of e)for(let e = 0, n = t.length, s = n - 1; e < n; s = e++){
                    const n = t[s], l = t[e];
                    if (tr(i, o, n, l)) return 0;
                    a = Math.min(a, Fr(i, o, n, l, r));
                }
            }
            return a;
        }
        function Rr(t, e, r, n, i, s) {
            if (!s) return;
            const a = Vr(Pr(n, s), i, r);
            a < e && t.push([
                a,
                s,
                [
                    0,
                    0
                ]
            ]);
        }
        function Ur(t, e, r, n, i, s, a) {
            if (!s || !a) return;
            const o = Vr(Pr(n, s), Pr(i, a), r);
            o < e && t.push([
                o,
                s,
                a
            ]);
        }
        function qr(t, e, r, n, i = 1 / 0) {
            let s = Math.min(n.distance(t[0], r[0][0]), i);
            if (0 === s) return s;
            const a = new fr([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ], kr), o = Cr(r);
            for(; a.length > 0;){
                const i = a.pop();
                if (i[0] >= s) continue;
                const l = i[1], u = e ? 50 : 100;
                if (Mr(l) <= u) {
                    if (!Ir(l, t.length)) return NaN;
                    if (e) {
                        const e = Dr(t, l, r, n);
                        if (isNaN(e) || 0 === e) return e;
                        s = Math.min(s, e);
                    } else for(let e = l[0]; e <= l[1]; ++e){
                        const i = Lr(t[e], r, n);
                        if (s = Math.min(s, i), 0 === s) return 0;
                    }
                } else {
                    const r = zr(l, e);
                    Rr(a, s, n, t, o, r[0]), Rr(a, s, n, t, o, r[1]);
                }
            }
            return s;
        }
        function Nr(t, e, r, n, i, s = 1 / 0) {
            let a = Math.min(s, i.distance(t[0], r[0]));
            if (0 === a) return a;
            const o = new fr([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        r.length - 1
                    ]
                ]
            ], kr);
            for(; o.length > 0;){
                const s = o.pop();
                if (s[0] >= a) continue;
                const l = s[1], u = s[2], c = e ? 50 : 100, h = n ? 50 : 100;
                if (Mr(l) <= c && Mr(u) <= h) {
                    if (!Ir(l, t.length) && Ir(u, r.length)) return NaN;
                    let s;
                    if (e && n) s = Tr(t, l, r, u, i), a = Math.min(a, s);
                    else if (e && !n) {
                        const e = t.slice(l[0], l[1] + 1);
                        for(let t = u[0]; t <= u[1]; ++t)if (s = Er(r[t], e, i), a = Math.min(a, s), 0 === a) return a;
                    } else if (!e && n) {
                        const e = r.slice(u[0], u[1] + 1);
                        for(let r = l[0]; r <= l[1]; ++r)if (s = Er(t[r], e, i), a = Math.min(a, s), 0 === a) return a;
                    } else s = $r(t, l, r, u, i), a = Math.min(a, s);
                } else {
                    const s = zr(l, e), c = zr(u, n);
                    Ur(o, a, i, t, r, s[0], c[0]), Ur(o, a, i, t, r, s[0], c[1]), Ur(o, a, i, t, r, s[1], c[0]), Ur(o, a, i, t, r, s[1], c[1]);
                }
            }
            return a;
        }
        function Zr(t) {
            return "MultiPolygon" === t.type ? t.coordinates.map((t)=>({
                    type: "Polygon",
                    coordinates: t
                })) : "MultiLineString" === t.type ? t.coordinates.map((t)=>({
                    type: "LineString",
                    coordinates: t
                })) : "MultiPoint" === t.type ? t.coordinates.map((t)=>({
                    type: "Point",
                    coordinates: t
                })) : [
                t
            ];
        }
        class Gr {
            constructor(t, e){
                this.type = ut, this.geojson = t, this.geometries = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'distance' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (re(t[1])) {
                    const e = t[1];
                    if ("FeatureCollection" === e.type) return new Gr(e, e.features.map((t)=>Zr(t.geometry)).flat());
                    if ("Feature" === e.type) return new Gr(e, Zr(e.geometry));
                    if ("type" in e && "coordinates" in e) return new Gr(e, Zr(e));
                }
                return e.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e) {
                        const r = t.geometry(), n = r.flat().map((e)=>Ye([
                                e.x,
                                e.y
                            ], t.canonical));
                        if (0 === r.length) return NaN;
                        const i = new Sr(n[0][1]);
                        let s = 1 / 0;
                        for (const t of e){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, Nr(n, !1, [
                                        t.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, Nr(n, !1, t.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, qr(n, !1, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e) {
                        const r = t.geometry(), n = r.flat().map((e)=>Ye([
                                e.x,
                                e.y
                            ], t.canonical));
                        if (0 === r.length) return NaN;
                        const i = new Sr(n[0][1]);
                        let s = 1 / 0;
                        for (const t of e){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, Nr(n, !0, [
                                        t.coordinates
                                    ], !1, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, Nr(n, !0, t.coordinates, !0, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, qr(n, !0, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                    if ("Polygon" === t.geometryType()) return function(t, e) {
                        const r = t.geometry();
                        if (0 === r.length || 0 === r[0].length) return NaN;
                        const n = xr(r, 0).map((e)=>e.map((e)=>e.map((e)=>Ye([
                                        e.x,
                                        e.y
                                    ], t.canonical)))), i = new Sr(n[0][0][0][1]);
                        let s = 1 / 0;
                        for (const t of e)for (const e of n){
                            switch(t.type){
                                case "Point":
                                    s = Math.min(s, qr([
                                        t.coordinates
                                    ], !1, e, i, s));
                                    break;
                                case "LineString":
                                    s = Math.min(s, qr(t.coordinates, !0, e, i, s));
                                    break;
                                case "Polygon":
                                    s = Math.min(s, jr(e, t.coordinates, i, s));
                            }
                            if (0 === s) return s;
                        }
                        return s;
                    }(t, this.geometries);
                }
                return NaN;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        const Kr = {
            "==": Le,
            "!=": De,
            ">": je,
            "<": Oe,
            ">=": Ue,
            "<=": Re,
            array: le,
            at: me,
            boolean: le,
            case: be,
            coalesce: Ee,
            collator: qe,
            format: Ze,
            image: Ge,
            in: ge,
            "index-of": xe,
            interpolate: Be,
            "interpolate-hcl": Be,
            "interpolate-lab": Be,
            length: Ke,
            let: de,
            literal: se,
            match: ve,
            number: le,
            "number-format": Ne,
            object: le,
            slice: we,
            step: Ae,
            string: le,
            "to-boolean": ce,
            "to-color": ce,
            "to-number": ce,
            "to-string": ce,
            var: ye,
            within: pr,
            distance: Gr
        };
        class Xr {
            constructor(t, e, r, n){
                this.name = t, this.type = e, this._evaluate = r, this.args = n;
            }
            evaluate(t) {
                return this._evaluate(t, this.args);
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return !1;
            }
            static parse(t, e) {
                const r = t[0], n = Xr.definitions[r];
                if (!n) return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = s.filter(([e])=>!Array.isArray(e) || e.length === t.length - 1);
                let o = null;
                for (const [n, s] of a){
                    o = new fe(e.registry, Qr, e.path, null, e.scope);
                    const a = [];
                    let l = !1;
                    for(let e = 1; e < t.length; e++){
                        const r = t[e], i = Array.isArray(n) ? n[e - 1] : n.type, s = o.parse(r, 1 + a.length, i);
                        if (!s) {
                            l = !0;
                            break;
                        }
                        a.push(s);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== a.length) o.error(`Expected ${n.length} arguments, but found ${a.length} instead.`);
                        else {
                            for(let t = 0; t < a.length; t++){
                                const e = Array.isArray(n) ? n[t] : n.type, r = a[t];
                                o.concat(t + 1).checkSubtype(e, r.type);
                            }
                            if (0 === o.errors.length) return new Xr(r, i, s, a);
                        }
                    }
                }
                if (1 === a.length) e.errors.push(...o.errors);
                else {
                    const r = (a.length ? a : s).map(([t])=>{
                        var e;
                        return e = t, Array.isArray(e) ? `(${e.map(wt).join(", ")})` : `(${wt(e.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t.length; r++){
                        const i = e.parse(t[r], 1 + n.length);
                        if (!i) return null;
                        n.push(wt(i.type));
                    }
                    e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t, e) {
                Xr.definitions = e;
                for(const r in e)t[r] = Xr;
            }
        }
        function Hr(t, [e, r, n, i]) {
            e = e.evaluate(t), r = r.evaluate(t), n = n.evaluate(t);
            const s = i ? i.evaluate(t) : 1, a = ee(e, r, n, s);
            if (a) throw new ae(a);
            return new Kt(e / 255, r / 255, n / 255, s, !1);
        }
        function Yr(t, e) {
            return t in e;
        }
        function Jr(t, e) {
            const r = e[t];
            return void 0 === r ? null : r;
        }
        function Wr(t) {
            return {
                type: t
            };
        }
        function Qr(t) {
            if (t instanceof ye) return Qr(t.boundExpression);
            if (t instanceof Xr && "error" === t.name) return !1;
            if (t instanceof qe) return !1;
            if (t instanceof pr) return !1;
            if (t instanceof Gr) return !1;
            const e = t instanceof ce || t instanceof le;
            let r = !0;
            return t.eachChild((t)=>{
                r = e ? r && Qr(t) : r && t instanceof se;
            }), !!r && tn(t) && rn(t, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function tn(t) {
            if (t instanceof Xr) {
                if ("get" === t.name && 1 === t.args.length) return !1;
                if ("feature-state" === t.name) return !1;
                if ("has" === t.name && 1 === t.args.length) return !1;
                if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
                if (/^filter-/.test(t.name)) return !1;
            }
            if (t instanceof pr) return !1;
            if (t instanceof Gr) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !tn(t) && (e = !1);
            }), e;
        }
        function en(t) {
            if (t instanceof Xr && "feature-state" === t.name) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !en(t) && (e = !1);
            }), e;
        }
        function rn(t, e) {
            if (t instanceof Xr && e.indexOf(t.name) >= 0) return !1;
            let r = !0;
            return t.eachChild((t)=>{
                r && !rn(t, e) && (r = !1);
            }), r;
        }
        function nn(t) {
            return {
                result: "success",
                value: t
            };
        }
        function sn(t) {
            return {
                result: "error",
                value: t
            };
        }
        function an(t) {
            return "data-driven" === t["property-type"] || "cross-faded-data-driven" === t["property-type"];
        }
        function on(t) {
            return !!t.expression && t.expression.parameters.indexOf("zoom") > -1;
        }
        function ln(t) {
            return !!t.expression && t.expression.interpolated;
        }
        function un(t) {
            return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : typeof t;
        }
        function cn(t) {
            return "object" == typeof t && null !== t && !Array.isArray(t);
        }
        function hn(t) {
            return t;
        }
        function pn(t, e) {
            const r = "color" === e.type, n = t.stops && "object" == typeof t.stops[0][0], i = n || !(n || void 0 !== t.property), s = t.type || (ln(e) ? "exponential" : "interval");
            if (r || "padding" === e.type) {
                const n = r ? Kt.parse : Jt.parse;
                (t = st({}, t)).stops && (t.stops = t.stops.map((t)=>[
                        t[0],
                        n(t[1])
                    ])), t.default = n(t.default ? t.default : e.default);
            }
            if (t.colorSpace && "rgb" !== (a = t.colorSpace) && "hcl" !== a && "lab" !== a) throw new Error(`Unknown color space: "${t.colorSpace}"`);
            var a;
            let o, l, u;
            if ("exponential" === s) o = mn;
            else if ("interval" === s) o = yn;
            else if ("categorical" === s) {
                o = dn, l = Object.create(null);
                for (const e of t.stops)l[e[0]] = e[1];
                u = typeof t.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                o = gn;
            }
            if (n) {
                const r = {}, n = [];
                for(let e = 0; e < t.stops.length; e++){
                    const i = t.stops[e], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: t.type,
                        property: t.property,
                        default: t.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t of n)i.push([
                    r[t].zoom,
                    pn(r[t], e)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: Be.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((t)=>t[0]),
                    evaluate: ({ zoom: r }, n)=>mn({
                            stops: i,
                            base: t.base
                        }, e, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== t.base ? t.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: Be.interpolationFactor.bind(void 0, r),
                    zoomStops: t.stops.map((t)=>t[0]),
                    evaluate: ({ zoom: r })=>o(t, e, r, l, u)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t.property] : void 0;
                    return void 0 === i ? fn(t.default, e.default) : o(t, e, i, l, u);
                }
            };
        }
        function fn(t, e, r) {
            return void 0 !== t ? t : void 0 !== e ? e : void 0 !== r ? r : void 0;
        }
        function dn(t, e, r, n, i) {
            return fn(typeof r === i ? n[r] : void 0, t.default, e.default);
        }
        function yn(t, e, r) {
            if ("number" !== un(r)) return fn(t.default, e.default);
            const n = t.stops.length;
            if (1 === n) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[n - 1][0]) return t.stops[n - 1][1];
            const i = _e(t.stops.map((t)=>t[0]), r);
            return t.stops[i][1];
        }
        function mn(t, e, r) {
            const n = void 0 !== t.base ? t.base : 1;
            if ("number" !== un(r)) return fn(t.default, e.default);
            const i = t.stops.length;
            if (1 === i) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[i - 1][0]) return t.stops[i - 1][1];
            const s = _e(t.stops.map((t)=>t[0]), r), a = function(t, e, r, n) {
                const i = n - r, s = t - r;
                return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t.stops[s][0], t.stops[s + 1][0]), o = t.stops[s][1], l = t.stops[s + 1][1], u = Ce[e.type] || hn;
            return "function" == typeof o.evaluate ? {
                evaluate (...e) {
                    const r = o.evaluate.apply(void 0, e), n = l.evaluate.apply(void 0, e);
                    if (void 0 !== r && void 0 !== n) return u(r, n, a, t.colorSpace);
                }
            } : u(o, l, a, t.colorSpace);
        }
        function gn(t, e, r) {
            switch(e.type){
                case "color":
                    r = Kt.parse(r);
                    break;
                case "formatted":
                    r = Yt.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = te.fromString(r.toString());
                    break;
                case "padding":
                    r = Jt.parse(r);
                    break;
                default:
                    un(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0);
            }
            return fn(r, t.default, e.default);
        }
        Xr.register(Kr, {
            error: [
                {
                    kind: "error"
                },
                [
                    ct
                ],
                (t, [e])=>{
                    throw new ae(e.evaluate(t));
                }
            ],
            typeof: [
                ct,
                [
                    dt
                ],
                (t, [e])=>wt(ne(e.evaluate(t)))
            ],
            "to-rgba": [
                bt(ut, 4),
                [
                    pt
                ],
                (t, [e])=>{
                    const [r, n, i, s] = e.evaluate(t).rgb;
                    return [
                        255 * r,
                        255 * n,
                        255 * i,
                        s
                    ];
                }
            ],
            rgb: [
                pt,
                [
                    ut,
                    ut,
                    ut
                ],
                Hr
            ],
            rgba: [
                pt,
                [
                    ut,
                    ut,
                    ut,
                    ut
                ],
                Hr
            ],
            has: {
                type: ht,
                overloads: [
                    [
                        [
                            ct
                        ],
                        (t, [e])=>Yr(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            ct,
                            ft
                        ],
                        (t, [e, r])=>Yr(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            get: {
                type: dt,
                overloads: [
                    [
                        [
                            ct
                        ],
                        (t, [e])=>Jr(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            ct,
                            ft
                        ],
                        (t, [e, r])=>Jr(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            "feature-state": [
                dt,
                [
                    ct
                ],
                (t, [e])=>Jr(e.evaluate(t), t.featureState || {})
            ],
            properties: [
                ft,
                [],
                (t)=>t.properties()
            ],
            "geometry-type": [
                ct,
                [],
                (t)=>t.geometryType()
            ],
            id: [
                dt,
                [],
                (t)=>t.id()
            ],
            zoom: [
                ut,
                [],
                (t)=>t.globals.zoom
            ],
            "heatmap-density": [
                ut,
                [],
                (t)=>t.globals.heatmapDensity || 0
            ],
            "line-progress": [
                ut,
                [],
                (t)=>t.globals.lineProgress || 0
            ],
            accumulated: [
                dt,
                [],
                (t)=>void 0 === t.globals.accumulated ? null : t.globals.accumulated
            ],
            "+": [
                ut,
                Wr(ut),
                (t, e)=>{
                    let r = 0;
                    for (const n of e)r += n.evaluate(t);
                    return r;
                }
            ],
            "*": [
                ut,
                Wr(ut),
                (t, e)=>{
                    let r = 1;
                    for (const n of e)r *= n.evaluate(t);
                    return r;
                }
            ],
            "-": {
                type: ut,
                overloads: [
                    [
                        [
                            ut,
                            ut
                        ],
                        (t, [e, r])=>e.evaluate(t) - r.evaluate(t)
                    ],
                    [
                        [
                            ut
                        ],
                        (t, [e])=>-e.evaluate(t)
                    ]
                ]
            },
            "/": [
                ut,
                [
                    ut,
                    ut
                ],
                (t, [e, r])=>e.evaluate(t) / r.evaluate(t)
            ],
            "%": [
                ut,
                [
                    ut,
                    ut
                ],
                (t, [e, r])=>e.evaluate(t) % r.evaluate(t)
            ],
            ln2: [
                ut,
                [],
                ()=>Math.LN2
            ],
            pi: [
                ut,
                [],
                ()=>Math.PI
            ],
            e: [
                ut,
                [],
                ()=>Math.E
            ],
            "^": [
                ut,
                [
                    ut,
                    ut
                ],
                (t, [e, r])=>Math.pow(e.evaluate(t), r.evaluate(t))
            ],
            sqrt: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.sqrt(e.evaluate(t))
            ],
            log10: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN10
            ],
            ln: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.log(e.evaluate(t))
            ],
            log2: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN2
            ],
            sin: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.sin(e.evaluate(t))
            ],
            cos: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.cos(e.evaluate(t))
            ],
            tan: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.tan(e.evaluate(t))
            ],
            asin: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.asin(e.evaluate(t))
            ],
            acos: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.acos(e.evaluate(t))
            ],
            atan: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.atan(e.evaluate(t))
            ],
            min: [
                ut,
                Wr(ut),
                (t, e)=>Math.min(...e.map((e)=>e.evaluate(t)))
            ],
            max: [
                ut,
                Wr(ut),
                (t, e)=>Math.max(...e.map((e)=>e.evaluate(t)))
            ],
            abs: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.abs(e.evaluate(t))
            ],
            round: [
                ut,
                [
                    ut
                ],
                (t, [e])=>{
                    const r = e.evaluate(t);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.floor(e.evaluate(t))
            ],
            ceil: [
                ut,
                [
                    ut
                ],
                (t, [e])=>Math.ceil(e.evaluate(t))
            ],
            "filter-==": [
                ht,
                [
                    ct,
                    dt
                ],
                (t, [e, r])=>t.properties()[e.value] === r.value
            ],
            "filter-id-==": [
                ht,
                [
                    dt
                ],
                (t, [e])=>t.id() === e.value
            ],
            "filter-type-==": [
                ht,
                [
                    ct
                ],
                (t, [e])=>t.geometryType() === e.value
            ],
            "filter-<": [
                ht,
                [
                    ct,
                    dt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                ht,
                [
                    dt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                ht,
                [
                    ct,
                    dt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                ht,
                [
                    dt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                ht,
                [
                    ct,
                    dt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                ht,
                [
                    dt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                ht,
                [
                    ct,
                    dt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                ht,
                [
                    dt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                ht,
                [
                    dt
                ],
                (t, [e])=>e.value in t.properties()
            ],
            "filter-has-id": [
                ht,
                [],
                (t)=>null !== t.id() && void 0 !== t.id()
            ],
            "filter-type-in": [
                ht,
                [
                    bt(ct)
                ],
                (t, [e])=>e.value.indexOf(t.geometryType()) >= 0
            ],
            "filter-id-in": [
                ht,
                [
                    bt(dt)
                ],
                (t, [e])=>e.value.indexOf(t.id()) >= 0
            ],
            "filter-in-small": [
                ht,
                [
                    ct,
                    bt(dt)
                ],
                (t, [e, r])=>r.value.indexOf(t.properties()[e.value]) >= 0
            ],
            "filter-in-large": [
                ht,
                [
                    ct,
                    bt(dt)
                ],
                (t, [e, r])=>(function(t, e, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e[i] === t) return !0;
                            e[i] > t ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t.properties()[e.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: ht,
                overloads: [
                    [
                        [
                            ht,
                            ht
                        ],
                        (t, [e, r])=>e.evaluate(t) && r.evaluate(t)
                    ],
                    [
                        Wr(ht),
                        (t, e)=>{
                            for (const r of e)if (!r.evaluate(t)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: ht,
                overloads: [
                    [
                        [
                            ht,
                            ht
                        ],
                        (t, [e, r])=>e.evaluate(t) || r.evaluate(t)
                    ],
                    [
                        Wr(ht),
                        (t, e)=>{
                            for (const r of e)if (r.evaluate(t)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                ht,
                [
                    ht
                ],
                (t, [e])=>!e.evaluate(t)
            ],
            "is-supported-script": [
                ht,
                [
                    ct
                ],
                (t, [e])=>{
                    const r = t.globals && t.globals.isSupportedScript;
                    return !r || r(e.evaluate(t));
                }
            ],
            upcase: [
                ct,
                [
                    ct
                ],
                (t, [e])=>e.evaluate(t).toUpperCase()
            ],
            downcase: [
                ct,
                [
                    ct
                ],
                (t, [e])=>e.evaluate(t).toLowerCase()
            ],
            concat: [
                ct,
                Wr(dt),
                (t, e)=>e.map((e)=>ie(e.evaluate(t))).join("")
            ],
            "resolved-locale": [
                ct,
                [
                    yt
                ],
                (t, [e])=>e.evaluate(t).resolvedLocale()
            ]
        });
        class xn {
            constructor(t, e){
                var r;
                this.expression = t, this._warningHistory = {}, this._evaluator = new pe, this._defaultValue = e ? "color" === (r = e).type && cn(r.default) ? new Kt(0, 0, 0, 0) : "color" === r.type ? Kt.parse(r.default) || null : "padding" === r.type ? Jt.parse(r.default) || null : "variableAnchorOffsetCollection" === r.type ? Qt.parse(r.default) || null : void 0 === r.default ? null : r.default : null, this._enumValues = e && "enum" === e.type ? e.values : null;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, s) {
                return this._evaluator.globals = t, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this.expression.evaluate(this._evaluator);
            }
            evaluate(t, e, r, n, i, s) {
                this._evaluator.globals = t, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null;
                try {
                    const t = this.expression.evaluate(this._evaluator);
                    if (null == t || "number" == typeof t && t != t) return this._defaultValue;
                    if (this._enumValues && !(t in this._enumValues)) throw new ae(`Expected value to be one of ${Object.keys(this._enumValues).map((t)=>JSON.stringify(t)).join(", ")}, but found ${JSON.stringify(t)} instead.`);
                    return t;
                } catch (t) {
                    return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn(t.message)), this._defaultValue;
                }
            }
        }
        function vn(t) {
            return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in Kr;
        }
        function bn(t, e) {
            const r = new fe(Kr, Qr, [], e ? function(t) {
                const e = {
                    color: pt,
                    string: ct,
                    number: ut,
                    enum: ct,
                    boolean: ht,
                    formatted: mt,
                    padding: gt,
                    resolvedImage: xt,
                    variableAnchorOffsetCollection: vt
                };
                return "array" === t.type ? bt(e[t.value] || dt, t.length) : e[t.type];
            }(e) : void 0), n = r.parse(t, void 0, void 0, void 0, e && "string" === e.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? nn(new xn(n, e)) : sn(r.errors);
        }
        class wn {
            constructor(t, e){
                this.kind = t, this._styleExpression = e, this.isStateDependent = "constant" !== t && !en(e.expression);
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, s);
            }
            evaluate(t, e, r, n, i, s) {
                return this._styleExpression.evaluate(t, e, r, n, i, s);
            }
        }
        class _n {
            constructor(t, e, r, n){
                this.kind = t, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t && !en(e.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, s);
            }
            evaluate(t, e, r, n, i, s) {
                return this._styleExpression.evaluate(t, e, r, n, i, s);
            }
            interpolationFactor(t, e, r) {
                return this.interpolationType ? Be.interpolationFactor(this.interpolationType, t, e, r) : 0;
            }
        }
        function An(t, e) {
            const r = bn(t, e);
            if ("error" === r.result) return r;
            const n = r.value.expression, i = tn(n);
            if (!i && !an(e)) return sn([
                new at("", "data expressions not supported")
            ]);
            const s = rn(n, [
                "zoom"
            ]);
            if (!s && !on(e)) return sn([
                new at("", "zoom expressions not supported")
            ]);
            const a = kn(n);
            return a || s ? a instanceof at ? sn([
                a
            ]) : a instanceof Be && !ln(e) ? sn([
                new at("", '"interpolate" expressions cannot be used with this property')
            ]) : nn(a ? new _n(i ? "camera" : "composite", r.value, a.labels, a instanceof Be ? a.interpolation : void 0) : new wn(i ? "constant" : "source", r.value)) : sn([
                new at("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class Sn {
            constructor(t, e){
                this._parameters = t, this._specification = e, st(this, pn(this._parameters, this._specification));
            }
            static deserialize(t) {
                return new Sn(t._parameters, t._specification);
            }
            static serialize(t) {
                return {
                    _parameters: t._parameters,
                    _specification: t._specification
                };
            }
        }
        function kn(t) {
            let e = null;
            if (t instanceof de) e = kn(t.result);
            else if (t instanceof Ee) {
                for (const r of t.args)if (e = kn(r), e) break;
            } else (t instanceof Ae || t instanceof Be) && t.input instanceof Xr && "zoom" === t.input.name && (e = t);
            return e instanceof at || t.eachChild((t)=>{
                const r = kn(t);
                r instanceof at ? e = r : !e && r ? e = new at("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e && r && e !== r && (e = new at("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e;
        }
        function Mn(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch(t[0]){
                case "has":
                    return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
                case "in":
                    return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
                case "any":
                case "all":
                    for (const e of t.slice(1))if (!Mn(e) && "boolean" != typeof e) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const In = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function zn(t) {
            if (null == t) return {
                filter: ()=>!0,
                needGeometry: !1
            };
            Mn(t) || (t = Bn(t));
            const e = bn(t, In);
            if ("error" === e.result) throw new Error(e.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
            return {
                filter: (t, r, n)=>e.value.evaluate(t, r, {}, n),
                needGeometry: Cn(t)
            };
        }
        function Pn(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Cn(t) {
            if (!Array.isArray(t)) return !1;
            if ("within" === t[0] || "distance" === t[0]) return !0;
            for(let e = 1; e < t.length; e++)if (Cn(t[e])) return !0;
            return !1;
        }
        function Bn(t) {
            if (!t) return !0;
            const e = t[0];
            var r;
            return t.length <= 1 ? "any" !== e : "==" === e ? Vn(t[1], t[2], "==") : "!=" === e ? Tn(Vn(t[1], t[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? Vn(t[1], t[2], e) : "any" === e ? (r = t.slice(1), [
                "any"
            ].concat(r.map(Bn))) : "all" === e ? [
                "all"
            ].concat(t.slice(1).map(Bn)) : "none" === e ? [
                "all"
            ].concat(t.slice(1).map(Bn).map(Tn)) : "in" === e ? En(t[1], t.slice(2)) : "!in" === e ? Tn(En(t[1], t.slice(2))) : "has" === e ? Fn(t[1]) : "!has" !== e || Tn(Fn(t[1]));
        }
        function Vn(t, e, r) {
            switch(t){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t,
                        e
                    ];
            }
        }
        function En(t, e) {
            if (0 === e.length) return !1;
            switch(t){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                default:
                    return e.length > 200 && !e.some((t)=>typeof t != typeof e[0]) ? [
                        "filter-in-large",
                        t,
                        [
                            "literal",
                            e.sort(Pn)
                        ]
                    ] : [
                        "filter-in-small",
                        t,
                        [
                            "literal",
                            e
                        ]
                    ];
            }
        }
        function Fn(t) {
            switch(t){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t
                    ];
            }
        }
        function Tn(t) {
            return [
                "!",
                t
            ];
        }
        function $n(t) {
            const e = typeof t;
            if ("number" === e || "boolean" === e || "string" === e || null == t) return JSON.stringify(t);
            if (Array.isArray(t)) {
                let e = "[";
                for (const r of t)e += `${$n(r)},`;
                return `${e}]`;
            }
            const r = Object.keys(t).sort();
            let n = "{";
            for(let e = 0; e < r.length; e++)n += `${JSON.stringify(r[e])}:${$n(t[r[e]])},`;
            return `${n}}`;
        }
        function Ln(t) {
            let e = "";
            for (const r of K)e += `/${$n(t[r])}`;
            return e;
        }
        function Dn(t) {
            const e = t.value;
            return e ? [
                new it(t.key, e, "constants have been deprecated as of v8")
            ] : [];
        }
        function On(t) {
            return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
        }
        function jn(t) {
            if (Array.isArray(t)) return t.map(jn);
            if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
                const e = {};
                for(const r in t)e[r] = jn(t[r]);
                return e;
            }
            return On(t);
        }
        function Rn(t) {
            const e = t.key, r = t.value, n = t.valueSpec || {}, i = t.objectElementValidators || {}, s = t.style, a = t.styleSpec, o = t.validateSpec;
            let l = [];
            const u = un(r);
            if ("object" !== u) return [
                new it(e, r, `object expected, ${u} found`)
            ];
            for(const t in r){
                const u = t.split(".")[0], c = n[u] || n["*"];
                let h;
                if (i[u]) h = i[u];
                else if (n[u]) h = o;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        l.push(new it(e, r[t], `unknown property "${t}"`));
                        continue;
                    }
                    h = o;
                }
                l = l.concat(h({
                    key: (e ? `${e}.` : e) + t,
                    value: r[t],
                    valueSpec: c,
                    style: s,
                    styleSpec: a,
                    object: r,
                    objectKey: t,
                    validateSpec: o
                }, r));
            }
            for(const t in n)i[t] || n[t].required && void 0 === n[t].default && void 0 === r[t] && l.push(new it(e, r, `missing required property "${t}"`));
            return l;
        }
        function Un(t) {
            const e = t.value, r = t.valueSpec, n = t.style, i = t.styleSpec, s = t.key, a = t.arrayElementValidator || t.validateSpec;
            if ("array" !== un(e)) return [
                new it(s, e, `array expected, ${un(e)} found`)
            ];
            if (r.length && e.length !== r.length) return [
                new it(s, e, `array length ${r.length} expected, length ${e.length} found`)
            ];
            if (r["min-length"] && e.length < r["min-length"]) return [
                new it(s, e, `array length at least ${r["min-length"]} expected, length ${e.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (o.function = r.function), "object" === un(r.value) && (o = r.value);
            let l = [];
            for(let r = 0; r < e.length; r++)l = l.concat(a({
                array: e,
                arrayIndex: r,
                value: e[r],
                valueSpec: o,
                validateSpec: t.validateSpec,
                style: n,
                styleSpec: i,
                key: `${s}[${r}]`
            }));
            return l;
        }
        function qn(t) {
            const e = t.key, r = t.value, n = t.valueSpec;
            let i = un(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new it(e, r, `number expected, ${i} found`)
            ] : "minimum" in n && r < n.minimum ? [
                new it(e, r, `${r} is less than the minimum value ${n.minimum}`)
            ] : "maximum" in n && r > n.maximum ? [
                new it(e, r, `${r} is greater than the maximum value ${n.maximum}`)
            ] : [];
        }
        function Nn(t) {
            const e = t.valueSpec, r = On(t.value.type);
            let n, i, s, a = {};
            const o = "categorical" !== r && void 0 === t.value.property, l = !o, u = "array" === un(t.value.stops) && "array" === un(t.value.stops[0]) && "object" === un(t.value.stops[0][0]), c = Rn({
                key: t.key,
                value: t.value,
                valueSpec: t.styleSpec.function,
                validateSpec: t.validateSpec,
                style: t.style,
                styleSpec: t.styleSpec,
                objectElementValidators: {
                    stops: function(t) {
                        if ("identity" === r) return [
                            new it(t.key, t.value, 'identity function may not have a "stops" property')
                        ];
                        let e = [];
                        const n = t.value;
                        return e = e.concat(Un({
                            key: t.key,
                            value: n,
                            valueSpec: t.valueSpec,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            arrayElementValidator: h
                        })), "array" === un(n) && 0 === n.length && e.push(new it(t.key, n, "array must have at least one stop")), e;
                    },
                    default: function(t) {
                        return t.validateSpec({
                            key: t.key,
                            value: t.value,
                            valueSpec: e,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new it(t.key, t.value, 'missing required property "property"')), "identity" === r || t.value.stops || c.push(new it(t.key, t.value, 'missing required property "stops"')), "exponential" === r && t.valueSpec.expression && !ln(t.valueSpec) && c.push(new it(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (l && !an(t.valueSpec) ? c.push(new it(t.key, t.value, "property functions not supported")) : o && !on(t.valueSpec) && c.push(new it(t.key, t.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t.value.property || c.push(new it(t.key, t.value, '"property" property is required')), c;
            function h(t) {
                let r = [];
                const n = t.value, o = t.key;
                if ("array" !== un(n)) return [
                    new it(o, n, `array expected, ${un(n)} found`)
                ];
                if (2 !== n.length) return [
                    new it(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== un(n[0])) return [
                        new it(o, n, `object expected, ${un(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new it(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new it(o, n, "object stop key must have value")
                    ];
                    if (s && s > On(n[0].zoom)) return [
                        new it(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    On(n[0].zoom) !== s && (s = On(n[0].zoom), i = void 0, a = {}), r = r.concat(Rn({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: t.validateSpec,
                        style: t.style,
                        styleSpec: t.styleSpec,
                        objectElementValidators: {
                            zoom: qn,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    valueSpec: {},
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }, n));
                return vn(jn(n[1])) ? r.concat([
                    new it(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(t.validateSpec({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e,
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }));
            }
            function p(t, s) {
                const o = un(t.value), l = On(t.value), u = null !== t.value ? t.value : s;
                if (n) {
                    if (o !== n) return [
                        new it(t.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o) return [
                    new it(t.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return an(e) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new it(t.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && void 0 !== i && l < i ? [
                    new it(t.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in a ? [
                    new it(t.key, u, "stop domain values must be unique")
                ] : (a[l] = !0, [])) : [
                    new it(t.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function Zn(t) {
            const e = ("property" === t.expressionContext ? An : bn)(jn(t.value), t.valueSpec);
            if ("error" === e.result) return e.value.map((e)=>new it(`${t.key}${e.key}`, t.value, e.message));
            const r = e.value.expression || e.value._styleExpression.expression;
            if ("property" === t.expressionContext && "text-font" === t.propertyKey && !r.outputDefined()) return [
                new it(t.key, t.value, `Invalid data expression for "${t.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t.expressionContext && "layout" === t.propertyType && !en(r)) return [
                new it(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t.expressionContext && !en(r)) return [
                new it(t.key, t.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
                if (!rn(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new it(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t.expressionContext && !tn(r)) return [
                    new it(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Gn(t) {
            const e = t.key, r = t.value, n = t.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(On(r)) && i.push(new it(e, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(On(r)) && i.push(new it(e, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function Kn(t) {
            return Mn(jn(t.value)) ? Zn(st({}, t, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : Xn(t);
        }
        function Xn(t) {
            const e = t.value, r = t.key;
            if ("array" !== un(e)) return [
                new it(r, e, `array expected, ${un(e)} found`)
            ];
            const n = t.styleSpec;
            let i, s = [];
            if (e.length < 1) return [
                new it(r, e, "filter array must have at least 1 element")
            ];
            switch(s = s.concat(Gn({
                key: `${r}[0]`,
                value: e[0],
                valueSpec: n.filter_operator,
                style: t.style,
                styleSpec: t.styleSpec
            })), On(e[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e.length >= 2 && "$type" === On(e[1]) && s.push(new it(r, e, `"$type" cannot be use with operator "${e[0]}"`));
                case "==":
                case "!=":
                    3 !== e.length && s.push(new it(r, e, `filter array for operator "${e[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e.length >= 2 && (i = un(e[1]), "string" !== i && s.push(new it(`${r}[1]`, e[1], `string expected, ${i} found`)));
                    for(let a = 2; a < e.length; a++)i = un(e[a]), "$type" === On(e[1]) ? s = s.concat(Gn({
                        key: `${r}[${a}]`,
                        value: e[a],
                        valueSpec: n.geometry_type,
                        style: t.style,
                        styleSpec: t.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && s.push(new it(`${r}[${a}]`, e[a], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e.length; n++)s = s.concat(Xn({
                        key: `${r}[${n}]`,
                        value: e[n],
                        style: t.style,
                        styleSpec: t.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = un(e[1]), 2 !== e.length ? s.push(new it(r, e, `filter array for "${e[0]}" operator must have 2 elements`)) : "string" !== i && s.push(new it(`${r}[1]`, e[1], `string expected, ${i} found`));
            }
            return s;
        }
        function Hn(t, e) {
            const r = t.key, n = t.validateSpec, i = t.style, s = t.styleSpec, a = t.value, o = t.objectKey, l = s[`${e}_${t.layerType}`];
            if (!l) return [];
            const u = o.match(/^(.*)-transition$/);
            if ("paint" === e && u && l[u[1]] && l[u[1]].transition) return n({
                key: r,
                value: a,
                valueSpec: s.transition,
                style: i,
                styleSpec: s
            });
            const c = t.valueSpec || l[o];
            if (!c) return [
                new it(r, a, `unknown property "${o}"`)
            ];
            let h;
            if ("string" === un(a) && an(c) && !c.tokens && (h = /^{([^}]+)}$/.exec(a))) return [
                new it(r, a, `"${o}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
            ];
            const p = [];
            return "symbol" === t.layerType && ("text-field" === o && i && !i.glyphs && p.push(new it(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && cn(jn(a)) && "identity" === On(a.type) && p.push(new it(r, a, '"text-font" does not support identity functions'))), p.concat(n({
                key: t.key,
                value: a,
                valueSpec: c,
                style: i,
                styleSpec: s,
                expressionContext: "property",
                propertyType: e,
                propertyKey: o
            }));
        }
        function Yn(t) {
            return Hn(t, "paint");
        }
        function Jn(t) {
            return Hn(t, "layout");
        }
        function Wn(t) {
            let e = [];
            const r = t.value, n = t.key, i = t.style, s = t.styleSpec;
            r.type || r.ref || e.push(new it(n, r, 'either "type" or "ref" is required'));
            let a = On(r.type);
            const o = On(r.ref);
            if (r.id) {
                const s = On(r.id);
                for(let a = 0; a < t.arrayIndex; a++){
                    const t = i.layers[a];
                    On(t.id) === s && e.push(new it(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t)=>{
                    t in r && e.push(new it(n, r[t], `"${t}" is prohibited for ref layers`));
                }), i.layers.forEach((e)=>{
                    On(e.id) === o && (t = e);
                }), t ? t.ref ? e.push(new it(n, r.ref, "ref cannot reference another ref layer")) : a = On(t.type) : e.push(new it(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== a) {
                if (r.source) {
                    const t = i.sources && i.sources[r.source], s = t && On(t.type);
                    t ? "vector" === s && "raster" === a ? e.push(new it(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster-dem" !== s && "hillshade" === a ? e.push(new it(n, r.source, `layer "${r.id}" requires a raster-dem source`)) : "raster" === s && "raster" !== a ? e.push(new it(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== s || r["source-layer"] ? "raster-dem" === s && "hillshade" !== a ? e.push(new it(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== a || !r.paint || !r.paint["line-gradient"] || "geojson" === s && t.lineMetrics || e.push(new it(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e.push(new it(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e.push(new it(n, r.source, `source "${r.source}" not found`));
                } else e.push(new it(n, r, 'missing required property "source"'));
            }
            return e = e.concat(Rn({
                key: n,
                value: r,
                valueSpec: s.layer,
                style: t.style,
                styleSpec: t.styleSpec,
                validateSpec: t.validateSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>t.validateSpec({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: s.layer.type,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: Kn,
                    layout: (t)=>Rn({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>Jn(st({
                                        layerType: a
                                    }, t))
                            }
                        }),
                    paint: (t)=>Rn({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>Yn(st({
                                        layerType: a
                                    }, t))
                            }
                        })
                }
            })), e;
        }
        function Qn(t) {
            const e = t.value, r = t.key, n = un(e);
            return "string" !== n ? [
                new it(r, e, `string expected, ${n} found`)
            ] : [];
        }
        const ti = {
            promoteId: function({ key: t, value: e }) {
                if ("string" === un(e)) return Qn({
                    key: t,
                    value: e
                });
                {
                    const r = [];
                    for(const n in e)r.push(...Qn({
                        key: `${t}.${n}`,
                        value: e[n]
                    }));
                    return r;
                }
            }
        };
        function ei(t) {
            const e = t.value, r = t.key, n = t.styleSpec, i = t.style, s = t.validateSpec;
            if (!e.type) return [
                new it(r, e, '"type" is required')
            ];
            const a = On(e.type);
            let o;
            switch(a){
                case "vector":
                case "raster":
                    return o = Rn({
                        key: r,
                        value: e,
                        valueSpec: n[`source_${a.replace("-", "_")}`],
                        style: t.style,
                        styleSpec: n,
                        objectElementValidators: ti,
                        validateSpec: s
                    }), o;
                case "raster-dem":
                    return o = function(t) {
                        var e;
                        const r = null !== (e = t.sourceName) && void 0 !== e ? e : "", n = t.value, i = t.styleSpec, s = i.source_raster_dem, a = t.style;
                        let o = [];
                        const l = un(n);
                        if (void 0 === n) return o;
                        if ("object" !== l) return o.push(new it("source_raster_dem", n, `object expected, ${l} found`)), o;
                        const u = "custom" === On(n.encoding), c = [
                            "redFactor",
                            "greenFactor",
                            "blueFactor",
                            "baseShift"
                        ], h = t.value.encoding ? `"${t.value.encoding}"` : "Default";
                        for(const e in n)!u && c.includes(e) ? o.push(new it(e, n[e], `In "${r}": "${e}" is only valid when "encoding" is set to "custom". ${h} encoding found`)) : s[e] ? o = o.concat(t.validateSpec({
                            key: e,
                            value: n[e],
                            valueSpec: s[e],
                            validateSpec: t.validateSpec,
                            style: a,
                            styleSpec: i
                        })) : o.push(new it(e, n[e], `unknown property "${e}"`));
                        return o;
                    }({
                        sourceName: r,
                        value: e,
                        style: t.style,
                        styleSpec: n,
                        validateSpec: s
                    }), o;
                case "geojson":
                    if (o = Rn({
                        key: r,
                        value: e,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        validateSpec: s,
                        objectElementValidators: ti
                    }), e.cluster) for(const t in e.clusterProperties){
                        const [n, i] = e.clusterProperties[t], a = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t
                            ]
                        ] : n;
                        o.push(...Zn({
                            key: `${r}.${t}.map`,
                            value: i,
                            validateSpec: s,
                            expressionContext: "cluster-map"
                        })), o.push(...Zn({
                            key: `${r}.${t}.reduce`,
                            value: a,
                            validateSpec: s,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return o;
                case "video":
                    return Rn({
                        key: r,
                        value: e,
                        valueSpec: n.source_video,
                        style: i,
                        validateSpec: s,
                        styleSpec: n
                    });
                case "image":
                    return Rn({
                        key: r,
                        value: e,
                        valueSpec: n.source_image,
                        style: i,
                        validateSpec: s,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new it(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Gn({
                        key: `${r}.type`,
                        value: e.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        validateSpec: s,
                        styleSpec: n
                    });
            }
        }
        function ri(t) {
            const e = t.value, r = t.styleSpec, n = r.light, i = t.style;
            let s = [];
            const a = un(e);
            if (void 0 === e) return s;
            if ("object" !== a) return s = s.concat([
                new it("light", e, `object expected, ${a} found`)
            ]), s;
            for(const a in e){
                const o = a.match(/^(.*)-transition$/);
                s = s.concat(o && n[o[1]] && n[o[1]].transition ? t.validateSpec({
                    key: a,
                    value: e[a],
                    valueSpec: r.transition,
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : n[a] ? t.validateSpec({
                    key: a,
                    value: e[a],
                    valueSpec: n[a],
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : [
                    new it(a, e[a], `unknown property "${a}"`)
                ]);
            }
            return s;
        }
        function ni(t) {
            const e = t.value, r = t.styleSpec, n = r.sky, i = t.style, s = un(e);
            if (void 0 === e) return [];
            if ("object" !== s) return [
                new it("sky", e, `object expected, ${s} found`)
            ];
            let a = [];
            for(const s in e)a = a.concat(n[s] ? t.validateSpec({
                key: s,
                value: e[s],
                valueSpec: n[s],
                style: i,
                styleSpec: r
            }) : [
                new it(s, e[s], `unknown property "${s}"`)
            ]);
            return a;
        }
        function ii(t) {
            const e = t.value, r = t.styleSpec, n = r.terrain, i = t.style;
            let s = [];
            const a = un(e);
            if (void 0 === e) return s;
            if ("object" !== a) return s = s.concat([
                new it("terrain", e, `object expected, ${a} found`)
            ]), s;
            for(const a in e)s = s.concat(n[a] ? t.validateSpec({
                key: a,
                value: e[a],
                valueSpec: n[a],
                validateSpec: t.validateSpec,
                style: i,
                styleSpec: r
            }) : [
                new it(a, e[a], `unknown property "${a}"`)
            ]);
            return s;
        }
        function si(t) {
            let e = [];
            const r = t.value, n = t.key;
            if (Array.isArray(r)) {
                const i = [], s = [];
                for(const a in r)r[a].id && i.includes(r[a].id) && e.push(new it(n, r, `all the sprites' ids must be unique, but ${r[a].id} is duplicated`)), i.push(r[a].id), r[a].url && s.includes(r[a].url) && e.push(new it(n, r, `all the sprites' URLs must be unique, but ${r[a].url} is duplicated`)), s.push(r[a].url), e = e.concat(Rn({
                    key: `${n}[${a}]`,
                    value: r[a],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: t.validateSpec
                }));
                return e;
            }
            return Qn({
                key: n,
                value: r
            });
        }
        const ai = {
            "*": ()=>[],
            array: Un,
            boolean: function(t) {
                const e = t.value, r = t.key, n = un(e);
                return "boolean" !== n ? [
                    new it(r, e, `boolean expected, ${n} found`)
                ] : [];
            },
            number: qn,
            color: function(t) {
                const e = t.key, r = t.value, n = un(r);
                return "string" !== n ? [
                    new it(e, r, `color expected, ${n} found`)
                ] : Kt.parse(String(r)) ? [] : [
                    new it(e, r, `color expected, "${r}" found`)
                ];
            },
            constants: Dn,
            enum: Gn,
            filter: Kn,
            function: Nn,
            layer: Wn,
            object: Rn,
            source: ei,
            light: ri,
            sky: ni,
            terrain: ii,
            projection: function(t) {
                const e = t.value, r = t.styleSpec, n = r.projection, i = t.style, s = un(e);
                if (void 0 === e) return [];
                if ("object" !== s) return [
                    new it("projection", e, `object expected, ${s} found`)
                ];
                let a = [];
                for(const s in e)a = a.concat(n[s] ? t.validateSpec({
                    key: s,
                    value: e[s],
                    valueSpec: n[s],
                    style: i,
                    styleSpec: r
                }) : [
                    new it(s, e[s], `unknown property "${s}"`)
                ]);
                return a;
            },
            string: Qn,
            formatted: function(t) {
                return 0 === Qn(t).length ? [] : Zn(t);
            },
            resolvedImage: function(t) {
                return 0 === Qn(t).length ? [] : Zn(t);
            },
            padding: function(t) {
                const e = t.key, r = t.value;
                if ("array" === un(r)) {
                    if (r.length < 1 || r.length > 4) return [
                        new it(e, r, `padding requires 1 to 4 values; ${r.length} values found`)
                    ];
                    const n = {
                        type: "number"
                    };
                    let i = [];
                    for(let s = 0; s < r.length; s++)i = i.concat(t.validateSpec({
                        key: `${e}[${s}]`,
                        value: r[s],
                        validateSpec: t.validateSpec,
                        valueSpec: n
                    }));
                    return i;
                }
                return qn({
                    key: e,
                    value: r,
                    valueSpec: {}
                });
            },
            variableAnchorOffsetCollection: function(t) {
                const e = t.key, r = t.value, n = un(r), i = t.styleSpec;
                if ("array" !== n || r.length < 1 || r.length % 2 != 0) return [
                    new it(e, r, "variableAnchorOffsetCollection requires a non-empty array of even length")
                ];
                let s = [];
                for(let n = 0; n < r.length; n += 2)s = s.concat(Gn({
                    key: `${e}[${n}]`,
                    value: r[n],
                    valueSpec: i.layout_symbol["text-anchor"]
                })), s = s.concat(Un({
                    key: `${e}[${n + 1}]`,
                    value: r[n + 1],
                    valueSpec: {
                        length: 2,
                        value: "number"
                    },
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: i
                }));
                return s;
            },
            sprite: si
        };
        function oi(t) {
            const e = t.value, r = t.valueSpec, n = t.styleSpec;
            return t.validateSpec = oi, r.expression && cn(On(e)) ? Nn(t) : r.expression && vn(jn(e)) ? Zn(t) : r.type && ai[r.type] ? ai[r.type](t) : Rn(st({}, t, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function li(t) {
            const e = t.value, r = t.key, n = Qn(t);
            return n.length || (-1 === e.indexOf("{fontstack}") && n.push(new it(r, e, '"glyphs" url must include a "{fontstack}" token')), -1 === e.indexOf("{range}") && n.push(new it(r, e, '"glyphs" url must include a "{range}" token'))), n;
        }
        function ui(t, e = G) {
            let r = [];
            return r = r.concat(oi({
                key: "",
                value: t,
                valueSpec: e.$root,
                styleSpec: e,
                style: t,
                validateSpec: oi,
                objectElementValidators: {
                    glyphs: li,
                    "*": ()=>[]
                }
            })), t.constants && (r = r.concat(Dn({
                key: "constants",
                value: t.constants,
                style: t,
                styleSpec: e,
                validateSpec: oi
            }))), hi(r);
        }
        function ci(t) {
            return function(e) {
                return t({
                    ...e,
                    validateSpec: oi
                });
            };
        }
        function hi(t) {
            return [].concat(t).sort((t, e)=>t.line - e.line);
        }
        function pi(t) {
            return function(...e) {
                return hi(t.apply(this, e));
            };
        }
        ui.source = pi(ci(ei)), ui.sprite = pi(ci(si)), ui.glyphs = pi(ci(li)), ui.light = pi(ci(ri)), ui.sky = pi(ci(ni)), ui.terrain = pi(ci(ii)), ui.layer = pi(ci(Wn)), ui.filter = pi(ci(Kn)), ui.paintProperty = pi(ci(Yn)), ui.layoutProperty = pi(ci(Jn));
        const fi = ui, di = fi.light, yi = fi.sky, mi = fi.paintProperty, gi = fi.layoutProperty;
        function xi(t, e) {
            let r = !1;
            if (e && e.length) for (const n of e)t.fire(new N(new Error(n.message))), r = !0;
            return r;
        }
        class vi {
            constructor(t, e, r){
                const n = this.cells = [];
                if (t instanceof ArrayBuffer) {
                    this.arrayBuffer = t;
                    const i = new Int32Array(this.arrayBuffer);
                    t = i[0], this.d = (e = i[1]) + 2 * (r = i[2]);
                    for(let t = 0; t < this.d * this.d; t++){
                        const e = i[3 + t], r = i[3 + t + 1];
                        n.push(e === r ? null : i.subarray(e, r));
                    }
                    const s = i[3 + n.length + 1];
                    this.keys = i.subarray(i[3 + n.length], s), this.bboxes = i.subarray(s), this.insert = this._insertReadonly;
                } else {
                    this.d = e + 2 * r;
                    for(let t = 0; t < this.d * this.d; t++)n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e, this.extent = t, this.padding = r, this.scale = e / t, this.uid = 0;
                const i = r / e * t;
                this.min = -i, this.max = t + i;
            }
            insert(t, e, r, n, i) {
                this._forEachCell(e, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(t, e, r, n, i, s) {
                this.cells[i].push(s);
            }
            query(t, e, r, n, i) {
                const s = this.min, a = this.max;
                if (t <= s && e <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
                {
                    const s = [];
                    return this._forEachCell(t, e, r, n, this._queryCell, s, {}, i), s;
                }
            }
            _queryCell(t, e, r, n, i, s, a, o) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for(let c = 0; c < l.length; c++){
                        const h = l[c];
                        if (void 0 === a[h]) {
                            const l = 4 * h;
                            (o ? o(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : t <= u[l + 2] && e <= u[l + 3] && r >= u[l + 0] && n >= u[l + 1]) ? (a[h] = !0, s.push(i[h])) : a[h] = !1;
                        }
                    }
                }
            }
            _forEachCell(t, e, r, n, i, s, a, o) {
                const l = this._convertToCellCoord(t), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t, e, r, n, u, s, a, o)) return;
                }
            }
            _convertFromCellCoord(t) {
                return (t - this.padding) / this.scale;
            }
            _convertToCellCoord(t) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const t = this.cells, e = 3 + this.cells.length + 1 + 1;
                let r = 0;
                for(let t = 0; t < this.cells.length; t++)r += this.cells[t].length;
                const n = new Int32Array(e + r + this.keys.length + this.bboxes.length);
                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                let i = e;
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    n[3 + e] = i, n.set(r, i), i += r.length;
                }
                return n[3 + t.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + t.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
            }
            static serialize(t, e) {
                const r = t.toArrayBuffer();
                return e && e.push(r), {
                    buffer: r
                };
            }
            static deserialize(t) {
                return new vi(t.buffer);
            }
        }
        const bi = {};
        function wi(t, e, r = {}) {
            if (bi[t]) throw new Error(`${t} is already registered.`);
            Object.defineProperty(e, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), bi[t] = {
                klass: e,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        wi("Object", Object), wi("TransferableGridIndex", vi), wi("Color", Kt), wi("Error", Error), wi("AJAXError", L), wi("ResolvedImage", te), wi("StylePropertyFunction", Sn), wi("StyleExpression", xn, {
            omit: [
                "_evaluator"
            ]
        }), wi("ZoomDependentExpression", _n), wi("ZoomConstantExpression", wn), wi("CompoundExpression", Xr, {
            omit: [
                "_evaluate"
            ]
        });
        for(const t in Kr)Kr[t]._classRegistryKey || wi(`Expression_${t}`, Kr[t]);
        function _i(t) {
            return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || t.constructor && "ArrayBuffer" === t.constructor.name);
        }
        function Ai(t) {
            return t.$name || t.constructor._classRegistryKey;
        }
        function Si(t) {
            return !function(t) {
                if (null === t || "object" != typeof t) return !1;
                const e = Ai(t);
                return !(!e || "Object" === e);
            }(t) && (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob || t instanceof Error || _i(t) || I(t) || ArrayBuffer.isView(t) || t instanceof ImageData);
        }
        function ki(t, e) {
            if (Si(t)) return (_i(t) || I(t)) && e && e.push(t), ArrayBuffer.isView(t) && e && e.push(t.buffer), t instanceof ImageData && e && e.push(t.data.buffer), t;
            if (Array.isArray(t)) {
                const r = [];
                for (const n of t)r.push(ki(n, e));
                return r;
            }
            if ("object" != typeof t) throw new Error("can't serialize object of type " + typeof t);
            const r = Ai(t);
            if (!r) throw new Error(`can't serialize object of unregistered class ${t.constructor.name}`);
            if (!bi[r]) throw new Error(`${r} is not registered.`);
            const { klass: n } = bi[r], i = n.serialize ? n.serialize(t, e) : {};
            if (n.serialize) {
                if (e && i === e[e.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
            } else {
                for(const n in t){
                    if (!t.hasOwnProperty(n)) continue;
                    if (bi[r].omit.indexOf(n) >= 0) continue;
                    const s = t[n];
                    i[n] = bi[r].shallow.indexOf(n) >= 0 ? s : ki(s, e);
                }
                t instanceof Error && (i.message = t.message);
            }
            if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== r && (i.$name = r), i;
        }
        function Mi(t) {
            if (Si(t)) return t;
            if (Array.isArray(t)) return t.map(Mi);
            if ("object" != typeof t) throw new Error("can't deserialize object of type " + typeof t);
            const e = Ai(t) || "Object";
            if (!bi[e]) throw new Error(`can't deserialize unregistered class ${e}`);
            const { klass: r } = bi[e];
            if (!r) throw new Error(`can't deserialize unregistered class ${e}`);
            if (r.deserialize) return r.deserialize(t);
            const n = Object.create(r.prototype);
            for (const r of Object.keys(t)){
                if ("$name" === r) continue;
                const i = t[r];
                n[r] = bi[e].shallow.indexOf(r) >= 0 ? i : Mi(i);
            }
            return n;
        }
        class Ii {
            constructor(){
                this.first = !0;
            }
            update(t, e) {
                const r = Math.floor(t);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e), t !== this.lastZoom && (this.lastZoom = t, this.lastFloorZoom = r, !0));
            }
        }
        const zi = {
            "Latin-1 Supplement": (t)=>t >= 128 && t <= 255,
            "Hangul Jamo": (t)=>t >= 4352 && t <= 4607,
            Khmer: (t)=>t >= 6016 && t <= 6143,
            "General Punctuation": (t)=>t >= 8192 && t <= 8303,
            "Letterlike Symbols": (t)=>t >= 8448 && t <= 8527,
            "Number Forms": (t)=>t >= 8528 && t <= 8591,
            "Miscellaneous Technical": (t)=>t >= 8960 && t <= 9215,
            "Control Pictures": (t)=>t >= 9216 && t <= 9279,
            "Optical Character Recognition": (t)=>t >= 9280 && t <= 9311,
            "Enclosed Alphanumerics": (t)=>t >= 9312 && t <= 9471,
            "Geometric Shapes": (t)=>t >= 9632 && t <= 9727,
            "Miscellaneous Symbols": (t)=>t >= 9728 && t <= 9983,
            "Miscellaneous Symbols and Arrows": (t)=>t >= 11008 && t <= 11263,
            "Ideographic Description Characters": (t)=>t >= 12272 && t <= 12287,
            "CJK Symbols and Punctuation": (t)=>t >= 12288 && t <= 12351,
            Katakana: (t)=>t >= 12448 && t <= 12543,
            Kanbun: (t)=>t >= 12688 && t <= 12703,
            "CJK Strokes": (t)=>t >= 12736 && t <= 12783,
            "Enclosed CJK Letters and Months": (t)=>t >= 12800 && t <= 13055,
            "CJK Compatibility": (t)=>t >= 13056 && t <= 13311,
            "Yijing Hexagram Symbols": (t)=>t >= 19904 && t <= 19967,
            "Private Use Area": (t)=>t >= 57344 && t <= 63743,
            "Vertical Forms": (t)=>t >= 65040 && t <= 65055,
            "CJK Compatibility Forms": (t)=>t >= 65072 && t <= 65103,
            "Small Form Variants": (t)=>t >= 65104 && t <= 65135,
            "Halfwidth and Fullwidth Forms": (t)=>t >= 65280 && t <= 65519
        };
        function Pi(t) {
            for (const e of t)if (Ti(e.charCodeAt(0))) return !0;
            return !1;
        }
        function Ci(t) {
            for (const e of t)if (!Ei(e.charCodeAt(0))) return !1;
            return !0;
        }
        function Bi(t) {
            const e = t.map((t)=>{
                try {
                    return new RegExp(`\\p{sc=${t}}`, "u").source;
                } catch (t) {
                    return null;
                }
            }).filter((t)=>t);
            return new RegExp(e.join("|"), "u");
        }
        const Vi = Bi([
            "Arab",
            "Dupl",
            "Mong",
            "Ougr",
            "Syrc"
        ]);
        function Ei(t) {
            return !Vi.test(String.fromCodePoint(t));
        }
        const Fi = Bi([
            "Bopo",
            "Hani",
            "Hira",
            "Kana",
            "Kits",
            "Nshu",
            "Tang",
            "Yiii"
        ]);
        function Ti(t) {
            return !(746 !== t && 747 !== t && (t < 4352 || !(zi["CJK Compatibility Forms"](t) && !(t >= 65097 && t <= 65103) || zi["CJK Compatibility"](t) || zi["CJK Strokes"](t) || !(!zi["CJK Symbols and Punctuation"](t) || t >= 12296 && t <= 12305 || t >= 12308 && t <= 12319 || 12336 === t) || zi["Enclosed CJK Letters and Months"](t) || zi["Ideographic Description Characters"](t) || zi.Kanbun(t) || zi.Katakana(t) && 12540 !== t || !(!zi["Halfwidth and Fullwidth Forms"](t) || 65288 === t || 65289 === t || 65293 === t || t >= 65306 && t <= 65310 || 65339 === t || 65341 === t || 65343 === t || t >= 65371 && t <= 65503 || 65507 === t || t >= 65512 && t <= 65519) || !(!zi["Small Form Variants"](t) || t >= 65112 && t <= 65118 || t >= 65123 && t <= 65126) || zi["Vertical Forms"](t) || zi["Yijing Hexagram Symbols"](t) || /\p{sc=Cans}/u.test(String.fromCodePoint(t)) || /\p{sc=Hang}/u.test(String.fromCodePoint(t)) || Fi.test(String.fromCodePoint(t)))));
        }
        function $i(t) {
            return !(Ti(t) || function(t) {
                return !!(zi["Latin-1 Supplement"](t) && (167 === t || 169 === t || 174 === t || 177 === t || 188 === t || 189 === t || 190 === t || 215 === t || 247 === t) || zi["General Punctuation"](t) && (8214 === t || 8224 === t || 8225 === t || 8240 === t || 8241 === t || 8251 === t || 8252 === t || 8258 === t || 8263 === t || 8264 === t || 8265 === t || 8273 === t) || zi["Letterlike Symbols"](t) || zi["Number Forms"](t) || zi["Miscellaneous Technical"](t) && (t >= 8960 && t <= 8967 || t >= 8972 && t <= 8991 || t >= 8996 && t <= 9e3 || 9003 === t || t >= 9085 && t <= 9114 || t >= 9150 && t <= 9165 || 9167 === t || t >= 9169 && t <= 9179 || t >= 9186 && t <= 9215) || zi["Control Pictures"](t) && 9251 !== t || zi["Optical Character Recognition"](t) || zi["Enclosed Alphanumerics"](t) || zi["Geometric Shapes"](t) || zi["Miscellaneous Symbols"](t) && !(t >= 9754 && t <= 9759) || zi["Miscellaneous Symbols and Arrows"](t) && (t >= 11026 && t <= 11055 || t >= 11088 && t <= 11097 || t >= 11192 && t <= 11243) || zi["CJK Symbols and Punctuation"](t) || zi.Katakana(t) || zi["Private Use Area"](t) || zi["CJK Compatibility Forms"](t) || zi["Small Form Variants"](t) || zi["Halfwidth and Fullwidth Forms"](t) || 8734 === t || 8756 === t || 8757 === t || t >= 9984 && t <= 10087 || t >= 10102 && t <= 10131 || 65532 === t || 65533 === t);
            }(t));
        }
        const Li = Bi([
            "Adlm",
            "Arab",
            "Armi",
            "Avst",
            "Chrs",
            "Cprt",
            "Egyp",
            "Elym",
            "Gara",
            "Hatr",
            "Hebr",
            "Hung",
            "Khar",
            "Lydi",
            "Mand",
            "Mani",
            "Mend",
            "Merc",
            "Mero",
            "Narb",
            "Nbat",
            "Nkoo",
            "Orkh",
            "Palm",
            "Phli",
            "Phlp",
            "Phnx",
            "Prti",
            "Rohg",
            "Samr",
            "Sarb",
            "Sogo",
            "Syrc",
            "Thaa",
            "Todr",
            "Yezi"
        ]);
        function Di(t) {
            return Li.test(String.fromCodePoint(t));
        }
        function Oi(t, e) {
            return !(!e && Di(t) || t >= 2304 && t <= 3583 || t >= 3840 && t <= 4255 || zi.Khmer(t));
        }
        function ji(t) {
            for (const e of t)if (Di(e.charCodeAt(0))) return !0;
            return !1;
        }
        const Ri = new class {
            constructor(){
                this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null;
            }
            setState(t) {
                this.pluginStatus = t.pluginStatus, this.pluginURL = t.pluginURL;
            }
            getState() {
                return {
                    pluginStatus: this.pluginStatus,
                    pluginURL: this.pluginURL
                };
            }
            setMethods(t) {
                this.applyArabicShaping = t.applyArabicShaping, this.processBidirectionalText = t.processBidirectionalText, this.processStyledBidirectionalText = t.processStyledBidirectionalText;
            }
            isParsed() {
                return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
            }
            getPluginURL() {
                return this.pluginURL;
            }
            getRTLTextPluginStatus() {
                return this.pluginStatus;
            }
        };
        class Ui {
            constructor(t, e){
                this.zoom = t, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.zoomHistory = e.zoomHistory, this.transition = e.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Ii, this.transition = {});
            }
            isSupportedScript(t) {
                return function(t, e) {
                    for (const r of t)if (!Oi(r.charCodeAt(0), e)) return !1;
                    return !0;
                }(t, "loaded" === Ri.getRTLTextPluginStatus());
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t = this.zoom, e = t - Math.floor(t), r = this.crossFadingFactor();
                return t > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e + (1 - e) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * e
                };
            }
        }
        class qi {
            constructor(t, e){
                this.property = t, this.value = e, this.expression = function(t, e) {
                    if (cn(t)) return new Sn(t, e);
                    if (vn(t)) {
                        const r = An(t, e);
                        if ("error" === r.result) throw new Error(r.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t;
                        return "color" === e.type && "string" == typeof t ? r = Kt.parse(t) : "padding" !== e.type || "number" != typeof t && !Array.isArray(t) ? "variableAnchorOffsetCollection" === e.type && Array.isArray(t) && (r = Qt.parse(t)) : r = Jt.parse(t), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e ? t.specification.default : e, t.specification);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t, e, r) {
                return this.property.possiblyEvaluate(this, t, e, r);
            }
        }
        class Ni {
            constructor(t){
                this.property = t, this.value = new qi(t, void 0);
            }
            transitioned(t, e) {
                return new Gi(this.property, this.value, e, g({}, t.transition, this.transition), t.now);
            }
            untransitioned() {
                return new Gi(this.property, this.value, null, {}, 0);
            }
        }
        class Zi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues);
            }
            getValue(t) {
                return w(this._values[t].value.value);
            }
            setValue(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new Ni(this._values[t].property)), this._values[t].value = new qi(this._values[t].property, null === e ? void 0 : w(e));
            }
            getTransition(t) {
                return w(this._values[t].transition);
            }
            setTransition(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new Ni(this._values[t].property)), this._values[t].transition = w(e) || void 0;
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                    const n = this.getTransition(e);
                    void 0 !== n && (t[`${e}-transition`] = n);
                }
                return t;
            }
            transitioned(t, e) {
                const r = new Ki(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t, e._values[n]);
                return r;
            }
            untransitioned() {
                const t = new Ki(this._properties);
                for (const e of Object.keys(this._values))t._values[e] = this._values[e].untransitioned();
                return t;
            }
        }
        class Gi {
            constructor(t, e, r, n, i){
                this.property = t, this.value = e, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t, e, r) {
                const n = t.now || 0, i = this.value.possiblyEvaluate(t, e, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(t, e, r);
                    {
                        const a = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(t, e, r), i, function(t) {
                            if (t <= 0) return 0;
                            if (t >= 1) return 1;
                            const e = t * t, r = e * t;
                            return 4 * (t < .5 ? r : 3 * (t - e) + r - .75);
                        }(a));
                    }
                }
                return i;
            }
        }
        class Ki {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t, e, r) {
                const n = new Yi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
            hasTransition() {
                for (const t of Object.keys(this._values))if (this._values[t].prior) return !0;
                return !1;
            }
        }
        class Xi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPropertyValues);
            }
            hasValue(t) {
                return void 0 !== this._values[t].value;
            }
            getValue(t) {
                return w(this._values[t].value);
            }
            setValue(t, e) {
                this._values[t] = new qi(this._values[t].property, null === e ? void 0 : w(e));
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                }
                return t;
            }
            possiblyEvaluate(t, e, r) {
                const n = new Yi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
        }
        class Hi {
            constructor(t, e, r){
                this.property = t, this.value = e, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t) {
                return "constant" === this.value.kind ? this.value.value : t;
            }
            evaluate(t, e, r, n) {
                return this.property.evaluate(this.value, this.parameters, t, e, r, n);
            }
        }
        class Yi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
            }
            get(t) {
                return this._values[t];
            }
        }
        class Ji {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e) {
                if (t.isDataDriven()) throw new Error("Value should not be data driven");
                return t.expression.evaluate(e);
            }
            interpolate(t, e, r) {
                const n = Ce[this.specification.type];
                return n ? n(t, e, r) : t;
            }
        }
        class Wi {
            constructor(t, e){
                this.specification = t, this.overrides = e;
            }
            possiblyEvaluate(t, e, r, n) {
                return new Hi(this, "constant" === t.expression.kind || "camera" === t.expression.kind ? {
                    kind: "constant",
                    value: t.expression.evaluate(e, null, {}, r, n)
                } : t.expression, e);
            }
            interpolate(t, e, r) {
                if ("constant" !== t.value.kind || "constant" !== e.value.kind) return t;
                if (void 0 === t.value.value || void 0 === e.value.value) return new Hi(this, {
                    kind: "constant",
                    value: void 0
                }, t.parameters);
                const n = Ce[this.specification.type];
                if (n) {
                    const i = n(t.value.value, e.value.value, r);
                    return new Hi(this, {
                        kind: "constant",
                        value: i
                    }, t.parameters);
                }
                return t;
            }
            evaluate(t, e, r, n, i, s) {
                return "constant" === t.kind ? t.value : t.evaluate(e, r, n, i, s);
            }
        }
        class Qi extends Wi {
            possiblyEvaluate(t, e, r, n) {
                if (void 0 === t.value) return new Hi(this, {
                    kind: "constant",
                    value: void 0
                }, e);
                if ("constant" === t.expression.kind) {
                    const i = t.expression.evaluate(e, null, {}, r, n), s = "resolvedImage" === t.property.specification.type && "string" != typeof i ? i.name : i, a = this._calculate(s, s, s, e);
                    return new Hi(this, {
                        kind: "constant",
                        value: a
                    }, e);
                }
                if ("camera" === t.expression.kind) {
                    const r = this._calculate(t.expression.evaluate({
                        zoom: e.zoom - 1
                    }), t.expression.evaluate({
                        zoom: e.zoom
                    }), t.expression.evaluate({
                        zoom: e.zoom + 1
                    }), e);
                    return new Hi(this, {
                        kind: "constant",
                        value: r
                    }, e);
                }
                return new Hi(this, t.expression, e);
            }
            evaluate(t, e, r, n, i, s) {
                if ("source" === t.kind) {
                    const a = t.evaluate(e, r, n, i, s);
                    return this._calculate(a, a, a, e);
                }
                return "composite" === t.kind ? this._calculate(t.evaluate({
                    zoom: Math.floor(e.zoom) - 1
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom)
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom) + 1
                }, r, n), e) : t.value;
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class ts {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                if (void 0 !== t.value) {
                    if ("constant" === t.expression.kind) {
                        const i = t.expression.evaluate(e, null, {}, r, n);
                        return this._calculate(i, i, i, e);
                    }
                    return this._calculate(t.expression.evaluate(new Ui(Math.floor(e.zoom - 1), e)), t.expression.evaluate(new Ui(Math.floor(e.zoom), e)), t.expression.evaluate(new Ui(Math.floor(e.zoom + 1), e)), e);
                }
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class es {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                return !!t.expression.evaluate(e, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class rs {
            constructor(t){
                this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const e in t){
                    const r = t[e];
                    r.specification.overridable && this.overridableProperties.push(e);
                    const n = this.defaultPropertyValues[e] = new qi(r, void 0), i = this.defaultTransitionablePropertyValues[e] = new Ni(r);
                    this.defaultTransitioningPropertyValues[e] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e] = n.possiblyEvaluate({});
                }
            }
        }
        wi("DataDrivenProperty", Wi), wi("DataConstantProperty", Ji), wi("CrossFadedDataDrivenProperty", Qi), wi("CrossFadedProperty", ts), wi("ColorRampProperty", es);
        const ns = "-transition";
        class is extends Z {
            constructor(t, e){
                if (super(), this.id = t.id, this.type = t.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1
                }, "custom" !== t.type && (this.metadata = t.metadata, this.minzoom = t.minzoom, this.maxzoom = t.maxzoom, "background" !== t.type && (this.source = t.source, this.sourceLayer = t["source-layer"], this.filter = t.filter), e.layout && (this._unevaluatedLayout = new Xi(e.layout)), e.paint)) {
                    this._transitionablePaint = new Zi(e.paint);
                    for(const e in t.paint)this.setPaintProperty(e, t.paint[e], {
                        validate: !1
                    });
                    for(const e in t.layout)this.setLayoutProperty(e, t.layout[e], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Yi(e.paint);
                }
            }
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t) {
                return "visibility" === t ? this.visibility : this._unevaluatedLayout.getValue(t);
            }
            setLayoutProperty(t, e, r = {}) {
                null != e && this._validate(gi, `layers.${this.id}.layout.${t}`, t, e, r) || ("visibility" !== t ? this._unevaluatedLayout.setValue(t, e) : this.visibility = e);
            }
            getPaintProperty(t) {
                return t.endsWith(ns) ? this._transitionablePaint.getTransition(t.slice(0, -11)) : this._transitionablePaint.getValue(t);
            }
            setPaintProperty(t, e, r = {}) {
                if (null != e && this._validate(mi, `layers.${this.id}.paint.${t}`, t, e, r)) return !1;
                if (t.endsWith(ns)) return this._transitionablePaint.setTransition(t.slice(0, -11), e || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), s = r.value;
                    this._transitionablePaint.setValue(t, e), this._handleSpecialPaintPropertyUpdate(t);
                    const a = this._transitionablePaint._values[t].value;
                    return a.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t, s, a);
                }
            }
            _handleSpecialPaintPropertyUpdate(t) {}
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !1;
            }
            isHidden(t) {
                return !!(this.minzoom && t < this.minzoom) || !!(this.maxzoom && t >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t, e) {
                t.getCrossfadeParameters && (this._crossfadeParameters = t.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e);
            }
            serialize() {
                const t = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t.layout = t.layout || {}, t.layout.visibility = this.visibility), b(t, (t, e)=>!(void 0 === t || "layout" === e && !Object.keys(t).length || "paint" === e && !Object.keys(t).length));
            }
            _validate(t, e, r, n, i = {}) {
                return (!i || !1 !== i.validate) && xi(this, t.call(fi, {
                    key: e,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: G,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t in this.paint._values){
                    const e = this.paint.get(t);
                    if (e instanceof Hi && an(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
                }
                return !1;
            }
        }
        const ss = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class as {
            constructor(t, e){
                this._structArray = t, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class os {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t, e) {
                return t._trim(), e && (t.isTransferred = !0, e.push(t.arrayBuffer)), {
                    length: t.length,
                    arrayBuffer: t.arrayBuffer
                };
            }
            static deserialize(t) {
                const e = Object.create(this.prototype);
                return e.arrayBuffer = t.arrayBuffer, e.length = t.length, e.capacity = t.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t) {
                this.reserve(t), this.length = t;
            }
            reserve(t) {
                if (t > this.capacity) {
                    this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e = this.uint8;
                    this._refreshViews(), e && this.uint8.set(e);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
        }
        function ls(t, e = 1) {
            let r = 0, n = 0;
            return {
                members: t.map((t)=>{
                    const i = ss[t.type].BYTES_PER_ELEMENT, s = r = us(r, Math.max(e, i)), a = t.components || 1;
                    return n = Math.max(n, i), r += i * a, {
                        name: t.name,
                        type: t.type,
                        components: a,
                        offset: s
                    };
                }),
                size: us(r, Math.max(n, e)),
                alignment: e
            };
        }
        function us(t, e) {
            return Math.ceil(t / e) * e;
        }
        class cs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.int16[n + 0] = e, this.int16[n + 1] = r, t;
            }
        }
        cs.prototype.bytesPerElement = 4, wi("StructArrayLayout2i4", cs);
        class hs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t;
            }
        }
        hs.prototype.bytesPerElement = 6, wi("StructArrayLayout3i6", hs);
        class ps extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const s = 4 * t;
                return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t;
            }
        }
        ps.prototype.bytesPerElement = 8, wi("StructArrayLayout4i8", ps);
        class fs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t;
            }
        }
        fs.prototype.bytesPerElement = 12, wi("StructArrayLayout2i4i12", fs);
        class ds extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 4 * t, l = 8 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = s, this.uint8[l + 7] = a, t;
            }
        }
        ds.prototype.bytesPerElement = 8, wi("StructArrayLayout2i4ub8", ds);
        class ys extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.float32[n + 0] = e, this.float32[n + 1] = r, t;
            }
        }
        ys.prototype.bytesPerElement = 8, wi("StructArrayLayout2f8", ys);
        class ms extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t, e, r, n, i, s, a, o, l, u);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c) {
                const h = 10 * t;
                return this.uint16[h + 0] = e, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = s, this.uint16[h + 5] = a, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t;
            }
        }
        ms.prototype.bytesPerElement = 20, wi("StructArrayLayout10ui20", ms);
        class gs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t, e, r, n, i, s, a, o, l, u, c, h);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c, h, p) {
                const f = 12 * t;
                return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = a, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t;
            }
        }
        gs.prototype.bytesPerElement = 24, wi("StructArrayLayout4i4ui4i24", gs);
        class xs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        xs.prototype.bytesPerElement = 12, wi("StructArrayLayout3f12", xs);
        class vs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint32[1 * t + 0] = e, t;
            }
        }
        vs.prototype.bytesPerElement = 4, wi("StructArrayLayout1ul4", vs);
        class bs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t, e, r, n, i, s, a, o, l);
            }
            emplace(t, e, r, n, i, s, a, o, l, u) {
                const c = 10 * t, h = 5 * t;
                return this.int16[c + 0] = e, this.int16[c + 1] = r, this.int16[c + 2] = n, this.int16[c + 3] = i, this.int16[c + 4] = s, this.int16[c + 5] = a, this.uint32[h + 3] = o, this.uint16[c + 8] = l, this.uint16[c + 9] = u, t;
            }
        }
        bs.prototype.bytesPerElement = 20, wi("StructArrayLayout6i1ul2ui20", bs);
        class ws extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t;
            }
        }
        ws.prototype.bytesPerElement = 12, wi("StructArrayLayout2i2i2i12", ws);
        class _s extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i);
            }
            emplace(t, e, r, n, i, s) {
                const a = 4 * t, o = 8 * t;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, t;
            }
        }
        _s.prototype.bytesPerElement = 16, wi("StructArrayLayout2f1f2i16", _s);
        class As extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
            }
            emplace(t, e, r, n, i, s, a) {
                const o = 16 * t, l = 4 * t, u = 8 * t;
                return this.uint8[o + 0] = e, this.uint8[o + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.int16[u + 6] = s, this.int16[u + 7] = a, t;
            }
        }
        As.prototype.bytesPerElement = 16, wi("StructArrayLayout2ub2f2i16", As);
        class Ss extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t;
            }
        }
        Ss.prototype.bytesPerElement = 6, wi("StructArrayLayout3ui6", Ss);
        class ks extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * t, v = 12 * t, b = 48 * t;
                return this.int16[x + 0] = e, this.int16[x + 1] = r, this.uint16[x + 2] = n, this.uint16[x + 3] = i, this.uint32[v + 2] = s, this.uint32[v + 3] = a, this.uint32[v + 4] = o, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, t;
            }
        }
        ks.prototype.bytesPerElement = 48, wi("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", ks);
        class Ms extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, M, I) {
                const z = this.length;
                return this.resize(z + 1), this.emplace(z, t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, M, I);
            }
            emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, M, I, z) {
                const P = 32 * t, C = 16 * t;
                return this.int16[P + 0] = e, this.int16[P + 1] = r, this.int16[P + 2] = n, this.int16[P + 3] = i, this.int16[P + 4] = s, this.int16[P + 5] = a, this.int16[P + 6] = o, this.int16[P + 7] = l, this.uint16[P + 8] = u, this.uint16[P + 9] = c, this.uint16[P + 10] = h, this.uint16[P + 11] = p, this.uint16[P + 12] = f, this.uint16[P + 13] = d, this.uint16[P + 14] = y, this.uint16[P + 15] = m, this.uint16[P + 16] = g, this.uint16[P + 17] = x, this.uint16[P + 18] = v, this.uint16[P + 19] = b, this.uint16[P + 20] = w, this.uint16[P + 21] = _, this.uint16[P + 22] = A, this.uint32[C + 12] = S, this.float32[C + 13] = k, this.float32[C + 14] = M, this.uint16[P + 30] = I, this.uint16[P + 31] = z, t;
            }
        }
        Ms.prototype.bytesPerElement = 64, wi("StructArrayLayout8i15ui1ul2f2ui64", Ms);
        class Is extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.float32[1 * t + 0] = e, t;
            }
        }
        Is.prototype.bytesPerElement = 4, wi("StructArrayLayout1f4", Is);
        class zs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[6 * t + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        zs.prototype.bytesPerElement = 12, wi("StructArrayLayout1ui2f12", zs);
        class Ps extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 4 * t;
                return this.uint32[2 * t + 0] = e, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t;
            }
        }
        Ps.prototype.bytesPerElement = 8, wi("StructArrayLayout1ul2ui8", Ps);
        class Cs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t;
            }
        }
        Cs.prototype.bytesPerElement = 4, wi("StructArrayLayout2ui4", Cs);
        class Bs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint16[1 * t + 0] = e, t;
            }
        }
        Bs.prototype.bytesPerElement = 2, wi("StructArrayLayout1ui2", Bs);
        class Vs extends os {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const s = 4 * t;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t;
            }
        }
        Vs.prototype.bytesPerElement = 16, wi("StructArrayLayout4f16", Vs);
        class Es extends as {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new s(this.anchorPointX, this.anchorPointY);
            }
        }
        Es.prototype.size = 20;
        class Fs extends bs {
            get(t) {
                return new Es(this, t);
            }
        }
        wi("CollisionBoxArray", Fs);
        class Ts extends as {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(t) {
                this._structArray.uint8[this._pos1 + 37] = t;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(t) {
                this._structArray.uint8[this._pos1 + 38] = t;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 10] = t;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        Ts.prototype.size = 48;
        class $s extends ks {
            get(t) {
                return new Ts(this, t);
            }
        }
        wi("PlacedSymbolArray", $s);
        class Ls extends as {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 12] = t;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textAnchorOffsetStartIndex() {
                return this._structArray.uint16[this._pos2 + 30];
            }
            get textAnchorOffsetEndIndex() {
                return this._structArray.uint16[this._pos2 + 31];
            }
        }
        Ls.prototype.size = 64;
        class Ds extends Ms {
            get(t) {
                return new Ls(this, t);
            }
        }
        wi("SymbolInstanceArray", Ds);
        class Os extends Is {
            getoffsetX(t) {
                return this.float32[1 * t + 0];
            }
        }
        wi("GlyphOffsetArray", Os);
        class js extends hs {
            getx(t) {
                return this.int16[3 * t + 0];
            }
            gety(t) {
                return this.int16[3 * t + 1];
            }
            gettileUnitDistanceFromAnchor(t) {
                return this.int16[3 * t + 2];
            }
        }
        wi("SymbolLineVertexArray", js);
        class Rs extends as {
            get textAnchor() {
                return this._structArray.uint16[this._pos2 + 0];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 2];
            }
        }
        Rs.prototype.size = 12;
        class Us extends zs {
            get(t) {
                return new Rs(this, t);
            }
        }
        wi("TextAnchorOffsetArray", Us);
        class qs extends as {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        qs.prototype.size = 8;
        class Ns extends Ps {
            get(t) {
                return new qs(this, t);
            }
        }
        wi("FeatureIndexArray", Ns);
        class Zs extends cs {
        }
        class Gs extends cs {
        }
        class Ks extends cs {
        }
        class Xs extends fs {
        }
        class Hs extends ds {
        }
        class Ys extends ys {
        }
        class Js extends ms {
        }
        class Ws extends gs {
        }
        class Qs extends xs {
        }
        class ta extends vs {
        }
        class ea extends ws {
        }
        class ra extends As {
        }
        class na extends Ss {
        }
        class ia extends Cs {
        }
        const sa = ls([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: aa } = sa;
        class oa {
            constructor(t = []){
                this.segments = t;
            }
            prepareSegment(t, e, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t > oa.MAX_VERTEX_ARRAY_LENGTH && A(`Max vertices per segment is ${oa.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}`), (!i || i.vertexLength + t > oa.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e.length,
                    primitiveOffset: r.length,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t of this.segments)for(const e in t.vaos)t.vaos[e].destroy();
            }
            static simpleSegment(t, e, r, n) {
                return new oa([
                    {
                        vertexOffset: t,
                        primitiveOffset: e,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function la(t, e) {
            return 256 * (t = y(Math.floor(t), 0, 255)) + y(Math.floor(e), 0, 255);
        }
        oa.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, wi("SegmentVector", oa);
        const ua = ls([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]);
        var ca = {
            exports: {}
        }, ha = {
            exports: {}
        };
        ha.exports = function(t, e) {
            var r, n, i, s, a, o, l, u;
            for(n = t.length - (r = 3 & t.length), i = e, a = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t.charCodeAt(u) | (255 & t.charCodeAt(++u)) << 8 | (255 & t.charCodeAt(++u)) << 16 | (255 & t.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
            switch(l = 0, r){
                case 3:
                    l ^= (255 & t.charCodeAt(u + 2)) << 16;
                case 2:
                    l ^= (255 & t.charCodeAt(u + 1)) << 8;
                case 1:
                    i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
            }
            return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
        };
        var pa = ha.exports, fa = {
            exports: {}
        };
        fa.exports = function(t, e) {
            for(var r, n = t.length, i = e ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t.charCodeAt(s) | (255 & t.charCodeAt(++s)) << 8 | (255 & t.charCodeAt(++s)) << 16 | (255 & t.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
            switch(n){
                case 3:
                    i ^= (255 & t.charCodeAt(s + 2)) << 16;
                case 2:
                    i ^= (255 & t.charCodeAt(s + 1)) << 8;
                case 1:
                    i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
            }
            return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
        };
        var da = pa, ya = fa.exports;
        ca.exports = da, ca.exports.murmur3 = da, ca.exports.murmur2 = ya;
        var ma = r(ca.exports);
        class ga {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(t, e, r, n) {
                this.ids.push(xa(t)), this.positions.push(e, r, n);
            }
            getPositions(t) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const e = xa(t);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t = r + n >> 1;
                    this.ids[t] >= e ? n = t : r = t + 1;
                }
                const i = [];
                for(; this.ids[r] === e;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t, e) {
                const r = new Float64Array(t.ids), n = new Uint32Array(t.positions);
                return va(r, n, 0, r.length - 1), e && e.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t) {
                const e = new ga;
                return e.ids = t.ids, e.positions = t.positions, e.indexed = !0, e;
            }
        }
        function xa(t) {
            const e = +t;
            return !isNaN(e) && e <= Number.MAX_SAFE_INTEGER ? e : ma(String(t));
        }
        function va(t, e, r, n) {
            for(; r < n;){
                const i = t[r + n >> 1];
                let s = r - 1, a = n + 1;
                for(;;){
                    do s++;
                    while (t[s] < i);
                    do a--;
                    while (t[a] > i);
                    if (s >= a) break;
                    ba(t, s, a), ba(e, 3 * s, 3 * a), ba(e, 3 * s + 1, 3 * a + 1), ba(e, 3 * s + 2, 3 * a + 2);
                }
                a - r < n - a ? (va(t, e, r, a), r = a + 1) : (va(t, e, a + 1, n), n = a);
            }
        }
        function ba(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        wi("FeaturePositionMap", ga);
        class wa {
            constructor(t, e){
                this.gl = t.gl, this.location = e;
            }
        }
        class _a extends wa {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1f(this.location, t));
            }
        }
        class Aa extends wa {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] && t[3] === this.current[3] || (this.current = t, this.gl.uniform4f(this.location, t[0], t[1], t[2], t[3]));
            }
        }
        class Sa extends wa {
            constructor(t, e){
                super(t, e), this.current = Kt.transparent;
            }
            set(t) {
                t.r === this.current.r && t.g === this.current.g && t.b === this.current.b && t.a === this.current.a || (this.current = t, this.gl.uniform4f(this.location, t.r, t.g, t.b, t.a));
            }
        }
        const ka = new Float32Array(16);
        function Ma(t) {
            return [
                la(255 * t.r, 255 * t.g),
                la(255 * t.b, 255 * t.a)
            ];
        }
        class Ia {
            constructor(t, e, r){
                this.value = t, this.uniformNames = e.map((t)=>`u_${t}`), this.type = r;
            }
            setUniform(t, e, r) {
                t.set(r.constantOr(this.value));
            }
            getBinding(t, e, r) {
                return "color" === this.type ? new Sa(t, e) : new _a(t, e);
            }
        }
        class za {
            constructor(t, e){
                this.uniformNames = e.map((t)=>`u_${t}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            setConstantPatternPositions(t, e) {
                this.pixelRatioFrom = e.pixelRatio, this.pixelRatioTo = t.pixelRatio, this.patternFrom = e.tlbr, this.patternTo = t.tlbr;
            }
            setUniform(t, e, r, n) {
                const i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                i && t.set(i);
            }
            getBinding(t, e, r) {
                return "u_pattern" === r.substr(0, 9) ? new Aa(t, e) : new _a(t, e);
            }
        }
        class Pa {
            constructor(t, e, r, n){
                this.expression = t, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t, e, r, n, i) {
                const s = this.paintVertexArray.length, a = this.expression.evaluate(new Ui(0), e, {}, n, [], i);
                this.paintVertexArray.resize(t), this._setPaintValue(s, t, a);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: 0
                }, r, n);
                this._setPaintValue(t, e, i);
            }
            _setPaintValue(t, e, r) {
                if ("color" === this.type) {
                    const n = Ma(r);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t; n < e; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Ca {
            constructor(t, e, r, n, i, s){
                this.expression = t, this.uniformNames = e.map((t)=>`u_${t}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(t, e, r, n, i) {
                const s = this.expression.evaluate(new Ui(this.zoom), e, {}, n, [], i), a = this.expression.evaluate(new Ui(this.zoom + 1), e, {}, n, [], i), o = this.paintVertexArray.length;
                this.paintVertexArray.resize(t), this._setPaintValue(o, t, s, a);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n), s = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n);
                this._setPaintValue(t, e, i, s);
            }
            _setPaintValue(t, e, r, n) {
                if ("color" === this.type) {
                    const i = Ma(r), s = Ma(n);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, i[0], i[1], s[0], s[1]);
                } else {
                    for(let i = t; i < e; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t, e) {
                const r = this.useIntegerZoom ? Math.floor(e.zoom) : e.zoom, n = y(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                t.set(n);
            }
            getBinding(t, e, r) {
                return new _a(t, e);
            }
        }
        class Ba {
            constructor(t, e, r, n, i, s){
                this.expression = t, this.type = e, this.useIntegerZoom = r, this.zoom = n, this.layerId = s, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            populatePaintArray(t, e, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t), this.zoomOutPaintVertexArray.resize(t), this._setPaintValues(n, t, e.patterns && e.patterns[this.layerId], r);
            }
            updatePaintArray(t, e, r, n, i) {
                this._setPaintValues(t, e, r.patterns && r.patterns[this.layerId], i);
            }
            _setPaintValues(t, e, r, n) {
                if (!n || !r) return;
                const { min: i, mid: s, max: a } = r, o = n[i], l = n[s], u = n[a];
                if (o && l && u) for(let r = t; r < e; r++)this.zoomInPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], l.pixelRatio, o.pixelRatio), this.zoomOutPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], u.tl[0], u.tl[1], u.br[0], u.br[1], l.pixelRatio, u.pixelRatio);
            }
            upload(t) {
                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t.createVertexBuffer(this.zoomInPaintVertexArray, ua.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t.createVertexBuffer(this.zoomOutPaintVertexArray, ua.members, this.expression.isStateDependent));
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
        }
        class Va {
            constructor(t, e, r){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t.paint._values){
                    if (!r(i)) continue;
                    const s = t.paint.get(i);
                    if (!(s instanceof Hi && an(s.property.specification))) continue;
                    const a = Fa(i, t.type), o = s.value, l = s.property.specification.type, u = s.property.useIntegerZoom, c = s.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === o.kind) this.binders[i] = h ? new za(o.value, a) : new Ia(o.value, a, l), n.push(`/u_${i}`);
                    else if ("source" === o.kind || h) {
                        const r = Ta(i, l, "source");
                        this.binders[i] = h ? new Ba(o, l, u, e, r, t.id) : new Pa(o, a, l, r), n.push(`/a_${i}`);
                    } else {
                        const t = Ta(i, l, "composite");
                        this.binders[i] = new Ca(o, a, l, u, e, t), n.push(`/z_${i}`);
                    }
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t) {
                const e = this.binders[t];
                return e instanceof Pa || e instanceof Ca ? e.maxValue : 0;
            }
            populatePaintArrays(t, e, r, n, i) {
                for(const s in this.binders){
                    const a = this.binders[s];
                    (a instanceof Pa || a instanceof Ca || a instanceof Ba) && a.populatePaintArray(t, e, r, n, i);
                }
            }
            setConstantPatternPositions(t, e) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof za && n.setConstantPatternPositions(t, e);
                }
            }
            updatePaintArrays(t, e, r, n, i) {
                let s = !1;
                for(const a in t){
                    const o = e.getPositions(a);
                    for (const e of o){
                        const o = r.feature(e.index);
                        for(const r in this.binders){
                            const l = this.binders[r];
                            if ((l instanceof Pa || l instanceof Ca || l instanceof Ba) && !0 === l.expression.isStateDependent) {
                                const u = n.paint.get(r);
                                l.expression = u.value, l.updatePaintArray(e.start, e.end, o, t[a], i), s = !0;
                            }
                        }
                    }
                }
                return s;
            }
            defines() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Ia || r instanceof za) && t.push(...r.uniformNames.map((t)=>`#define HAS_UNIFORM_${t}`));
                }
                return t;
            }
            getBinderAttributes() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Pa || r instanceof Ca) for(let e = 0; e < r.paintVertexAttributes.length; e++)t.push(r.paintVertexAttributes[e].name);
                    else if (r instanceof Ba) for(let e = 0; e < ua.members.length; e++)t.push(ua.members[e].name);
                }
                return t;
            }
            getBinderUniforms() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Ia || r instanceof za || r instanceof Ca) for (const e of r.uniformNames)t.push(e);
                }
                return t;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t, e) {
                const r = [];
                for(const n in this.binders){
                    const i = this.binders[n];
                    if (i instanceof Ia || i instanceof za || i instanceof Ca) {
                        for (const s of i.uniformNames)if (e[s]) {
                            const a = i.getBinding(t, e[s], s);
                            r.push({
                                name: s,
                                property: n,
                                binding: a
                            });
                        }
                    }
                }
                return r;
            }
            setUniforms(t, e, r, n) {
                for (const { name: t, property: i, binding: s } of e)this.binders[i].setUniform(s, n, r.get(i), t);
            }
            updatePaintBuffers(t) {
                this._buffers = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (t && r instanceof Ba) {
                        const e = 2 === t.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        e && this._buffers.push(e);
                    } else (r instanceof Pa || r instanceof Ca) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(t) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Pa || r instanceof Ca || r instanceof Ba) && r.upload(t);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t in this.binders){
                    const e = this.binders[t];
                    (e instanceof Pa || e instanceof Ca || e instanceof Ba) && e.destroy();
                }
            }
        }
        class Ea {
            constructor(t, e, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t)this.programConfigurations[n.id] = new Va(n, e, r);
                this.needsUpload = !1, this._featureMap = new ga, this._bufferOffset = 0;
            }
            populatePaintArrays(t, e, r, n, i, s) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t, e, n, i, s);
                void 0 !== e.id && this._featureMap.add(e.id, r, this._bufferOffset, t), this._bufferOffset = t, this.needsUpload = !0;
            }
            updatePaintArrays(t, e, r, n) {
                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t, this._featureMap, e, i, n) || this.needsUpload;
            }
            get(t) {
                return this.programConfigurations[t];
            }
            upload(t) {
                if (this.needsUpload) {
                    for(const e in this.programConfigurations)this.programConfigurations[e].upload(t);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t in this.programConfigurations)this.programConfigurations[t].destroy();
            }
        }
        function Fa(t, e) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t] || [
                t.replace(`${e}-`, "").replace(/-/g, "_")
            ];
        }
        function Ta(t, e, r) {
            const n = {
                color: {
                    source: ys,
                    composite: Vs
                },
                number: {
                    source: Is,
                    composite: ys
                }
            }, i = function(t) {
                return ({
                    "line-pattern": {
                        source: Js,
                        composite: Js
                    },
                    "fill-pattern": {
                        source: Js,
                        composite: Js
                    },
                    "fill-extrusion-pattern": {
                        source: Js,
                        composite: Js
                    }
                })[t];
            }(t);
            return i && i[r] || n[e][r];
        }
        wi("ConstantBinder", Ia), wi("CrossFadedConstantBinder", za), wi("SourceExpressionBinder", Pa), wi("CrossFadedCompositeBinder", Ba), wi("CompositeExpressionBinder", Ca), wi("ProgramConfiguration", Va, {
            omit: [
                "_buffers"
            ]
        }), wi("ProgramConfigurationSet", Ea);
        const $a = 8192, La = Math.pow(2, 14) - 1, Da = -La - 1;
        function Oa(t) {
            const e = $a / t.extent, r = t.loadGeometry();
            for(let t = 0; t < r.length; t++){
                const n = r[t];
                for(let t = 0; t < n.length; t++){
                    const r = n[t], i = Math.round(r.x * e), s = Math.round(r.y * e);
                    r.x = y(i, Da, La), r.y = y(s, Da, La), (i < r.x || i > r.x + 1 || s < r.y || s > r.y + 1) && A("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return r;
        }
        function ja(t, e) {
            return {
                type: t.type,
                id: t.id,
                properties: t.properties,
                geometry: e ? Oa(t) : []
            };
        }
        function Ra(t, e, r, n, i) {
            t.emplaceBack(2 * e + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        class Ua {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new Gs, this.indexArray = new na, this.segments = new oa, this.programConfigurations = new Ea(t.layers, t.zoom), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                const n = this.layers[0], i = [];
                let s = null, a = !1;
                "circle" === n.type && (s = n.layout.get("circle-sort-key"), a = !s.isConstant());
                for (const { feature: e, id: n, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ja(e, t);
                    if (!this.layers[0]._featureFilter.filter(new Ui(this.zoom), u, r)) continue;
                    const c = a ? s.evaluate(u, {}, r) : void 0, h = {
                        id: n,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : Oa(e),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                a && i.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of i){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n, o = t[s].feature;
                    this.addFeature(n, i, s, r), e.featureIndex.insert(o, i, s, a, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, aa), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t, e, r, n) {
                for (const r of e)for (const e of r){
                    const r = e.x, n = e.y;
                    if (r < 0 || r >= $a || n < 0 || n >= $a) continue;
                    const i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t.sortKey), s = i.vertexLength;
                    Ra(this.layoutVertexArray, r, n, -1, -1), Ra(this.layoutVertexArray, r, n, 1, -1), Ra(this.layoutVertexArray, r, n, 1, 1), Ra(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(s, s + 1, s + 2), this.indexArray.emplaceBack(s, s + 3, s + 2), i.vertexLength += 4, i.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {}, n);
            }
        }
        function qa(t, e) {
            for(let r = 0; r < t.length; r++)if (Wa(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (Wa(t, e[r])) return !0;
            return !!Ka(t, e);
        }
        function Na(t, e, r) {
            return !!Wa(t, e) || !!Ha(e, t, r);
        }
        function Za(t, e) {
            if (1 === t.length) return Ja(e, t[0]);
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                for(let e = 0; e < n.length; e++)if (Wa(t, n[e])) return !0;
            }
            for(let r = 0; r < t.length; r++)if (Ja(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (Ka(t, e[r])) return !0;
            return !1;
        }
        function Ga(t, e, r) {
            if (t.length > 1) {
                if (Ka(t, e)) return !0;
                for(let n = 0; n < e.length; n++)if (Ha(e[n], t, r)) return !0;
            }
            for(let n = 0; n < t.length; n++)if (Ha(t[n], e, r)) return !0;
            return !1;
        }
        function Ka(t, e) {
            if (0 === t.length || 0 === e.length) return !1;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1];
                for(let t = 0; t < e.length - 1; t++)if (Xa(n, i, e[t], e[t + 1])) return !0;
            }
            return !1;
        }
        function Xa(t, e, r, n) {
            return S(t, r, n) !== S(e, r, n) && S(t, e, r) !== S(t, e, n);
        }
        function Ha(t, e, r) {
            const n = r * r;
            if (1 === e.length) return t.distSqr(e[0]) < n;
            for(let r = 1; r < e.length; r++)if (Ya(t, e[r - 1], e[r]) < n) return !0;
            return !1;
        }
        function Ya(t, e, r) {
            const n = e.distSqr(r);
            if (0 === n) return t.distSqr(e);
            const i = ((t.x - e.x) * (r.x - e.x) + (t.y - e.y) * (r.y - e.y)) / n;
            return t.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
        }
        function Ja(t, e) {
            let r, n, i, s = !1;
            for(let a = 0; a < t.length; a++){
                r = t[a];
                for(let t = 0, a = r.length - 1; t < r.length; a = t++)n = r[t], i = r[a], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function Wa(t, e) {
            let r = !1;
            for(let n = 0, i = t.length - 1; n < t.length; i = n++){
                const s = t[n], a = t[i];
                s.y > e.y != a.y > e.y && e.x < (a.x - s.x) * (e.y - s.y) / (a.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function Qa(t, e, r) {
            const n = r[0], i = r[2];
            if (t.x < n.x && e.x < n.x || t.x > i.x && e.x > i.x || t.y < n.y && e.y < n.y || t.y > i.y && e.y > i.y) return !1;
            const s = S(t, e, r[0]);
            return s !== S(t, e, r[1]) || s !== S(t, e, r[2]) || s !== S(t, e, r[3]);
        }
        function to(t, e, r) {
            const n = e.paint.get(t).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t);
        }
        function eo(t) {
            return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
        }
        function ro(t, e, r, n, i) {
            if (!e[0] && !e[1]) return t;
            const a = s.convert(e)._mult(i);
            "viewport" === r && a._rotate(-n);
            const o = [];
            for(let e = 0; e < t.length; e++)o.push(t[e].sub(a));
            return o;
        }
        let no, io;
        wi("CircleBucket", Ua, {
            omit: [
                "layers"
            ]
        });
        var so = {
            get paint () {
                return io = io || new rs({
                    "circle-radius": new Wi(G.paint_circle["circle-radius"]),
                    "circle-color": new Wi(G.paint_circle["circle-color"]),
                    "circle-blur": new Wi(G.paint_circle["circle-blur"]),
                    "circle-opacity": new Wi(G.paint_circle["circle-opacity"]),
                    "circle-translate": new Ji(G.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new Ji(G.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new Ji(G.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new Ji(G.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new Wi(G.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new Wi(G.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new Wi(G.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return no = no || new rs({
                    "circle-sort-key": new Wi(G.layout_circle["circle-sort-key"])
                });
            }
        }, ao = 1e-6, oo = "undefined" != typeof Float32Array ? Float32Array : Array;
        function lo(t) {
            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }
        function uo(t, e, r) {
            var n = e[0], i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], y = e[12], m = e[13], g = e[14], x = e[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t[0] = v * n + b * o + w * h + _ * y, t[1] = v * i + b * l + w * p + _ * m, t[2] = v * s + b * u + w * f + _ * g, t[3] = v * a + b * c + w * d + _ * x, t[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * y, t[5] = v * i + b * l + w * p + _ * m, t[6] = v * s + b * u + w * f + _ * g, t[7] = v * a + b * c + w * d + _ * x, t[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * y, t[9] = v * i + b * l + w * p + _ * m, t[10] = v * s + b * u + w * f + _ * g, t[11] = v * a + b * c + w * d + _ * x, t[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * y, t[13] = v * i + b * l + w * p + _ * m, t[14] = v * s + b * u + w * f + _ * g, t[15] = v * a + b * c + w * d + _ * x, t;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t = 0, e = arguments.length; e--;)t += arguments[e] * arguments[e];
            return Math.sqrt(t);
        });
        var co, ho = uo;
        function po(t, e, r) {
            var n = e[0], i = e[1], s = e[2], a = e[3];
            return t[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * a, t[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * a, t[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * a, t[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * a, t;
        }
        co = new oo(4), oo != Float32Array && (co[0] = 0, co[1] = 0, co[2] = 0, co[3] = 0);
        class fo extends is {
            constructor(t){
                super(t, so);
            }
            createBucket(t) {
                return new Ua(t);
            }
            queryRadius(t) {
                const e = t;
                return to("circle-radius", this, e) + to("circle-stroke-width", this, e) + eo(this.paint.get("circle-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, s, a, o) {
                const l = ro(t, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, a), u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r), c = "map" === this.paint.get("circle-pitch-alignment"), h = c ? l : function(t, e) {
                    return t.map((t)=>yo(t, e));
                }(l, o), p = c ? u * a : u;
                for (const t of n)for (const e of t){
                    const t = c ? e : yo(e, o);
                    let r = p;
                    const n = po([], [
                        e.x,
                        e.y,
                        0,
                        1
                    ], o);
                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? r *= n[3] / s.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (r *= s.cameraToCenterDistance / n[3]), Na(h, t, r)) return !0;
                }
                return !1;
            }
        }
        function yo(t, e) {
            const r = po([], [
                t.x,
                t.y,
                0,
                1
            ], e);
            return new s(r[0] / r[3], r[1] / r[3]);
        }
        class mo extends Ua {
        }
        let go;
        wi("HeatmapBucket", mo, {
            omit: [
                "layers"
            ]
        });
        var xo = {
            get paint () {
                return go = go || new rs({
                    "heatmap-radius": new Wi(G.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new Wi(G.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new Ji(G.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new es(G.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new Ji(G.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function vo(t, { width: e, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e * r * n}`);
            } else i = new Uint8Array(e * r * n);
            return t.width = e, t.height = r, t.data = i, t;
        }
        function bo(t, { width: e, height: r }, n) {
            if (e === t.width && r === t.height) return;
            const i = vo({}, {
                width: e,
                height: r
            }, n);
            wo(t, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t.width, e),
                height: Math.min(t.height, r)
            }, n), t.width = e, t.height = r, t.data = i.data;
        }
        function wo(t, e, r, n, i, s) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const a = t.data, o = e.data;
            if (a === o) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t.width + r.x) * s, c = ((n.y + l) * e.width + n.x) * s;
                for(let t = 0; t < i.width * s; t++)o[c + t] = a[u + t];
            }
            return e;
        }
        class _o {
            constructor(t, e){
                vo(this, t, 1, e);
            }
            resize(t) {
                bo(this, t, 1);
            }
            clone() {
                return new _o({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                wo(t, e, r, n, i, 1);
            }
        }
        class Ao {
            constructor(t, e){
                vo(this, t, 4, e);
            }
            resize(t) {
                bo(this, t, 4);
            }
            replace(t, e) {
                e ? this.data.set(t) : this.data = t instanceof Uint8ClampedArray ? new Uint8Array(t.buffer) : t;
            }
            clone() {
                return new Ao({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                wo(t, e, r, n, i, 4);
            }
        }
        function So(t) {
            const e = {}, r = t.resolution || 256, n = t.clips ? t.clips.length : 1, i = t.image || new Ao({
                width: r,
                height: n
            });
            if (Math.log(r) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
            const s = (r, n, s)=>{
                e[t.evaluationKey] = s;
                const a = t.expression.evaluate(e);
                i.data[r + n + 0] = Math.floor(255 * a.r / a.a), i.data[r + n + 1] = Math.floor(255 * a.g / a.a), i.data[r + n + 2] = Math.floor(255 * a.b / a.a), i.data[r + n + 3] = Math.floor(255 * a.a);
            };
            if (t.clips) for(let e = 0, i = 0; e < n; ++e, i += 4 * r)for(let n = 0, a = 0; n < r; n++, a += 4){
                const o = n / (r - 1), { start: l, end: u } = t.clips[e];
                s(i, a, l * (1 - o) + u * o);
            }
            else for(let t = 0, e = 0; t < r; t++, e += 4)s(0, e, t / (r - 1));
            return i;
        }
        wi("AlphaImage", _o), wi("RGBAImage", Ao);
        class ko extends is {
            createBucket(t) {
                return new mo(t);
            }
            constructor(t){
                super(t, xo), this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(t) {
                "heatmap-color" === t && this._updateColorRamp();
            }
            _updateColorRamp() {
                this.colorRamp = So({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }
            resize() {
                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }
        }
        let Mo;
        var Io = {
            get paint () {
                return Mo = Mo || new rs({
                    "hillshade-illumination-direction": new Ji(G.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-anchor": new Ji(G.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new Ji(G.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new Ji(G.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new Ji(G.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new Ji(G.paint_hillshade["hillshade-accent-color"])
                });
            }
        };
        class zo extends is {
            constructor(t){
                super(t, Io);
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }
        }
        const Po = ls([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Co } = Po;
        function Bo(t, e, r = 2) {
            const n = e && e.length, i = n ? e[0] * r : t.length;
            let s = Vo(t, 0, i, r, !0);
            const a = [];
            if (!s || s.next === s.prev) return a;
            let o, l, u;
            if (n && (s = function(t, e, r, n) {
                const i = [];
                for(let r = 0, s = e.length; r < s; r++){
                    const a = Vo(t, e[r] * n, r < s - 1 ? e[r + 1] * n : t.length, n, !1);
                    a === a.next && (a.steiner = !0), i.push(qo(a));
                }
                i.sort(Oo);
                for(let t = 0; t < i.length; t++)r = jo(i[t], r);
                return r;
            }(t, e, s, r)), t.length > 80 * r) {
                o = 1 / 0, l = 1 / 0;
                let e = -1 / 0, n = -1 / 0;
                for(let s = r; s < i; s += r){
                    const r = t[s], i = t[s + 1];
                    r < o && (o = r), i < l && (l = i), r > e && (e = r), i > n && (n = i);
                }
                u = Math.max(e - o, n - l), u = 0 !== u ? 32767 / u : 0;
            }
            return Fo(s, a, r, o, l, u, 0), a;
        }
        function Vo(t, e, r, n, i) {
            let s;
            if (i === function(t, e, r, n) {
                let i = 0;
                for(let s = e, a = r - n; s < r; s += n)i += (t[a] - t[s]) * (t[s + 1] + t[a + 1]), a = s;
                return i;
            }(t, e, r, n) > 0) for(let i = e; i < r; i += n)s = Qo(i / n | 0, t[i], t[i + 1], s);
            else for(let i = r - n; i >= e; i -= n)s = Qo(i / n | 0, t[i], t[i + 1], s);
            return s && Ko(s, s.next) && (tl(s), s = s.next), s;
        }
        function Eo(t, e) {
            if (!t) return t;
            e || (e = t);
            let r, n = t;
            do if (r = !1, n.steiner || !Ko(n, n.next) && 0 !== Go(n.prev, n, n.next)) n = n.next;
            else {
                if (tl(n), n = e = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== e);
            return e;
        }
        function Fo(t, e, r, n, i, s, a) {
            if (!t) return;
            !a && s && function(t, e, r, n) {
                let i = t;
                do 0 === i.z && (i.z = Uo(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== t);
                i.prevZ.nextZ = null, i.prevZ = null, function(t) {
                    let e, r = 1;
                    do {
                        let n, i = t;
                        t = null;
                        let s = null;
                        for(e = 0; i;){
                            e++;
                            let a = i, o = 0;
                            for(let t = 0; t < r && (o++, a = a.nextZ, a); t++);
                            let l = r;
                            for(; o > 0 || l > 0 && a;)0 !== o && (0 === l || !a || i.z <= a.z) ? (n = i, i = i.nextZ, o--) : (n = a, a = a.nextZ, l--), s ? s.nextZ = n : t = n, n.prevZ = s, s = n;
                            i = a;
                        }
                        s.nextZ = null, r *= 2;
                    }while (e > 1);
                }(i);
            }(t, n, i, s);
            let o = t;
            for(; t.prev !== t.next;){
                const l = t.prev, u = t.next;
                if (s ? $o(t, n, i, s) : To(t)) e.push(l.i, t.i, u.i), tl(t), t = u.next, o = u.next;
                else if ((t = u) === o) {
                    a ? 1 === a ? Fo(t = Lo(Eo(t), e), e, r, n, i, s, 2) : 2 === a && Do(t, e, r, n, i, s) : Fo(Eo(t), e, r, n, i, s, 1);
                    break;
                }
            }
        }
        function To(t) {
            const e = t.prev, r = t, n = t.next;
            if (Go(e, r, n) >= 0) return !1;
            const i = e.x, s = r.x, a = n.x, o = e.y, l = r.y, u = n.y, c = i < s ? i < a ? i : a : s < a ? s : a, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > s ? i > a ? i : a : s > a ? s : a, f = o > l ? o > u ? o : u : l > u ? l : u;
            let d = n.next;
            for(; d !== e;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && No(i, o, s, l, a, u, d.x, d.y) && Go(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function $o(t, e, r, n) {
            const i = t.prev, s = t, a = t.next;
            if (Go(i, s, a) >= 0) return !1;
            const o = i.x, l = s.x, u = a.x, c = i.y, h = s.y, p = a.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, y = o > l ? o > u ? o : u : l > u ? l : u, m = c > h ? c > p ? c : p : h > p ? h : p, g = Uo(f, d, e, r, n), x = Uo(y, m, e, r, n);
            let v = t.prevZ, b = t.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && No(o, c, l, h, u, p, v.x, v.y) && Go(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && No(o, c, l, h, u, p, b.x, b.y) && Go(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== a && No(o, c, l, h, u, p, v.x, v.y) && Go(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== a && No(o, c, l, h, u, p, b.x, b.y) && Go(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function Lo(t, e) {
            let r = t;
            do {
                const n = r.prev, i = r.next.next;
                !Ko(n, i) && Xo(n, r, r.next, i) && Jo(n, i) && Jo(i, n) && (e.push(n.i, r.i, i.i), tl(r), tl(r.next), r = t = i), r = r.next;
            }while (r !== t);
            return Eo(r);
        }
        function Do(t, e, r, n, i, s) {
            let a = t;
            do {
                let t = a.next.next;
                for(; t !== a.prev;){
                    if (a.i !== t.i && Zo(a, t)) {
                        let o = Wo(a, t);
                        return a = Eo(a, a.next), o = Eo(o, o.next), Fo(a, e, r, n, i, s, 0), void Fo(o, e, r, n, i, s, 0);
                    }
                    t = t.next;
                }
                a = a.next;
            }while (a !== t);
        }
        function Oo(t, e) {
            return t.x - e.x;
        }
        function jo(t, e) {
            const r = function(t, e) {
                let r = e;
                const n = t.x, i = t.y;
                let s, a = -1 / 0;
                do {
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const t = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (t <= n && t > a && (a = t, s = r.x < r.next.x ? r : r.next, t === n)) return s;
                    }
                    r = r.next;
                }while (r !== e);
                if (!s) return null;
                const o = s, l = s.x, u = s.y;
                let c = 1 / 0;
                r = s;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && No(i < u ? n : a, i, l, u, i < u ? a : n, i, r.x, r.y)) {
                        const e = Math.abs(i - r.y) / (n - r.x);
                        Jo(r, t) && (e < c || e === c && (r.x > s.x || r.x === s.x && Ro(s, r))) && (s = r, c = e);
                    }
                    r = r.next;
                }while (r !== o);
                return s;
            }(t, e);
            if (!r) return e;
            const n = Wo(r, t);
            return Eo(n, n.next), Eo(r, r.next);
        }
        function Ro(t, e) {
            return Go(t.prev, t, e.prev) < 0 && Go(e.next, t, t.next) < 0;
        }
        function Uo(t, e, r, n, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function qo(t) {
            let e = t, r = t;
            do (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            while (e !== t);
            return r;
        }
        function No(t, e, r, n, i, s, a, o) {
            return (i - a) * (e - o) >= (t - a) * (s - o) && (t - a) * (n - o) >= (r - a) * (e - o) && (r - a) * (s - o) >= (i - a) * (n - o);
        }
        function Zo(t, e) {
            return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
                let r = t;
                do {
                    if (r.i !== t.i && r.next.i !== t.i && r.i !== e.i && r.next.i !== e.i && Xo(r, r.next, t, e)) return !0;
                    r = r.next;
                }while (r !== t);
                return !1;
            }(t, e) && (Jo(t, e) && Jo(e, t) && function(t, e) {
                let r = t, n = !1;
                const i = (t.x + e.x) / 2, s = (t.y + e.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t);
                return n;
            }(t, e) && (Go(t.prev, t, e.prev) || Go(t, e.prev, e)) || Ko(t, e) && Go(t.prev, t, t.next) > 0 && Go(e.prev, e, e.next) > 0);
        }
        function Go(t, e, r) {
            return (e.y - t.y) * (r.x - e.x) - (e.x - t.x) * (r.y - e.y);
        }
        function Ko(t, e) {
            return t.x === e.x && t.y === e.y;
        }
        function Xo(t, e, r, n) {
            const i = Yo(Go(t, e, r)), s = Yo(Go(t, e, n)), a = Yo(Go(r, n, t)), o = Yo(Go(r, n, e));
            return i !== s && a !== o || !(0 !== i || !Ho(t, r, e)) || !(0 !== s || !Ho(t, n, e)) || !(0 !== a || !Ho(r, t, n)) || !(0 !== o || !Ho(r, e, n));
        }
        function Ho(t, e, r) {
            return e.x <= Math.max(t.x, r.x) && e.x >= Math.min(t.x, r.x) && e.y <= Math.max(t.y, r.y) && e.y >= Math.min(t.y, r.y);
        }
        function Yo(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
        function Jo(t, e) {
            return Go(t.prev, t, t.next) < 0 ? Go(t, e, t.next) >= 0 && Go(t, t.prev, e) >= 0 : Go(t, e, t.prev) < 0 || Go(t, t.next, e) < 0;
        }
        function Wo(t, e) {
            const r = el(t.i, t.x, t.y), n = el(e.i, e.x, e.y), i = t.next, s = e.prev;
            return t.next = e, e.prev = t, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function Qo(t, e, r, n) {
            const i = el(t, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function tl(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }
        function el(t, e, r) {
            return {
                i: t,
                x: e,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function rl(t, e, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e){
                const e = r.paint.get(`${t}-pattern`);
                e.isConstant() || (i = !0);
                const s = e.constantOr(null);
                s && (i = !0, n[s.to] = !0, n[s.from] = !0);
            }
            return i;
        }
        function nl(t, e, r, n, i) {
            const s = i.patternDependencies;
            for (const a of e){
                const e = a.paint.get(`${t}-pattern`).value;
                if ("constant" !== e.kind) {
                    let t = e.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), o = e.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), l = e.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    t = t && t.name ? t.name : t, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, s[t] = !0, s[o] = !0, s[l] = !0, r.patterns[a.id] = {
                        min: t,
                        mid: o,
                        max: l
                    };
                }
            }
            return r;
        }
        class il {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Ks, this.indexArray = new na, this.indexArray2 = new ia, this.programConfigurations = new Ea(t.layers, t.zoom), this.segments = new oa, this.segments2 = new oa, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = rl("fill", this.layers, e);
                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), s = [];
                for (const { feature: a, id: o, index: l, sourceLayerIndex: u } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, c = ja(a, t);
                    if (!this.layers[0]._featureFilter.filter(new Ui(this.zoom), c, r)) continue;
                    const h = i ? n.evaluate(c, {}, r, e.availableImages) : void 0, p = {
                        id: o,
                        properties: a.properties,
                        type: a.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t ? c.geometry : Oa(a),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const t = nl("fill", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, s, r, {});
                    e.featureIndex.insert(t[s].feature, i, s, a, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const t of this.patternFeatures)this.addFeature(t, t.geometry, t.index, e, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Co), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t, e, r, n, i) {
                for (const t of xr(e, 500)){
                    let e = 0;
                    for (const r of t)e += r.length;
                    const r = this.segments.prepareSegment(e, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], s = [];
                    for (const e of t){
                        if (0 === e.length) continue;
                        e !== t[0] && s.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e[0].x, e[0].y), this.indexArray2.emplaceBack(n + e.length - 1, n), i.push(e[0].x), i.push(e[0].y);
                        for(let t = 1; t < e.length; t++)this.layoutVertexArray.emplaceBack(e[t].x, e[t].y), this.indexArray2.emplaceBack(n + t - 1, n + t), i.push(e[t].x), i.push(e[t].y);
                        r.vertexLength += e.length, r.primitiveLength += e.length;
                    }
                    const a = Bo(i, s);
                    for(let t = 0; t < a.length; t += 3)this.indexArray.emplaceBack(n + a[t], n + a[t + 1], n + a[t + 2]);
                    r.vertexLength += e, r.primitiveLength += a.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
        }
        let sl, al;
        wi("FillBucket", il, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var ol = {
            get paint () {
                return al = al || new rs({
                    "fill-antialias": new Ji(G.paint_fill["fill-antialias"]),
                    "fill-opacity": new Wi(G.paint_fill["fill-opacity"]),
                    "fill-color": new Wi(G.paint_fill["fill-color"]),
                    "fill-outline-color": new Wi(G.paint_fill["fill-outline-color"]),
                    "fill-translate": new Ji(G.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new Ji(G.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new Qi(G.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return sl = sl || new rs({
                    "fill-sort-key": new Wi(G.layout_fill["fill-sort-key"])
                });
            }
        };
        class ll extends is {
            constructor(t){
                super(t, ol);
            }
            recalculate(t, e) {
                super.recalculate(t, e);
                const r = this.paint._values["fill-outline-color"];
                "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }
            createBucket(t) {
                return new il(t);
            }
            queryRadius() {
                return eo(this.paint.get("fill-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, s, a) {
                return Za(ro(t, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, a), n);
            }
            isTileClipped() {
                return !0;
            }
        }
        const ul = ls([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), cl = ls([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: hl } = ul;
        var pl = {}, fl = n, dl = yl;
        function yl(t, e, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t, this._geometry = -1, this._keys = n, this._values = i, t.readFields(ml, this, e);
        }
        function ml(t, e, r) {
            1 == t ? e.id = r.readVarint() : 2 == t ? function(t, e) {
                for(var r = t.readVarint() + t.pos; t.pos < r;){
                    var n = e._keys[t.readVarint()], i = e._values[t.readVarint()];
                    e.properties[n] = i;
                }
            }(r, e) : 3 == t ? e.type = r.readVarint() : 4 == t && (e._geometry = r.pos);
        }
        function gl(t) {
            for(var e, r, n = 0, i = 0, s = t.length, a = s - 1; i < s; a = i++)n += ((r = t[a]).x - (e = t[i]).x) * (e.y + r.y);
            return n;
        }
        yl.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], yl.prototype.loadGeometry = function() {
            var t = this._pbf;
            t.pos = this._geometry;
            for(var e, r = t.readVarint() + t.pos, n = 1, i = 0, s = 0, a = 0, o = []; t.pos < r;){
                if (i <= 0) {
                    var l = t.readVarint();
                    n = 7 & l, i = l >> 3;
                }
                if (i--, 1 === n || 2 === n) s += t.readSVarint(), a += t.readSVarint(), 1 === n && (e && o.push(e), e = []), e.push(new fl(s, a));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e && e.push(e[0].clone());
                }
            }
            return e && o.push(e), o;
        }, yl.prototype.bbox = function() {
            var t = this._pbf;
            t.pos = this._geometry;
            for(var e = t.readVarint() + t.pos, r = 1, n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t.pos < e;){
                if (n <= 0) {
                    var c = t.readVarint();
                    r = 7 & c, n = c >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t.readSVarint()) < a && (a = i), i > o && (o = i), (s += t.readSVarint()) < l && (l = s), s > u && (u = s);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                a,
                l,
                o,
                u
            ];
        }, yl.prototype.toGeoJSON = function(t, e, r) {
            var n, i, s = this.extent * Math.pow(2, r), a = this.extent * t, o = this.extent * e, l = this.loadGeometry(), u = yl.types[this.type];
            function c(t) {
                for(var e = 0; e < t.length; e++){
                    var r = t[e];
                    t[e] = [
                        360 * (r.x + a) / s - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / s) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var h = [];
                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                    c(l = h);
                    break;
                case 2:
                    for(n = 0; n < l.length; n++)c(l[n]);
                    break;
                case 3:
                    for(l = function(t) {
                        var e = t.length;
                        if (e <= 1) return [
                            t
                        ];
                        for(var r, n, i = [], s = 0; s < e; s++){
                            var a = gl(t[s]);
                            0 !== a && (void 0 === n && (n = a < 0), n === a < 0 ? (r && i.push(r), r = [
                                t[s]
                            ]) : r.push(t[s]));
                        }
                        return r && i.push(r), i;
                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)c(l[n][i]);
            }
            1 === l.length ? l = l[0] : u = "Multi" + u;
            var p = {
                type: "Feature",
                geometry: {
                    type: u,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (p.id = this.id), p;
        };
        var xl = dl, vl = bl;
        function bl(t, e) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(wl, this, e), this.length = this._features.length;
        }
        function wl(t, e, r) {
            15 === t ? e.version = r.readVarint() : 1 === t ? e.name = r.readString() : 5 === t ? e.extent = r.readVarint() : 2 === t ? e._features.push(r.pos) : 3 === t ? e._keys.push(r.readString()) : 4 === t && e._values.push(function(t) {
                for(var e = null, r = t.readVarint() + t.pos; t.pos < r;){
                    var n = t.readVarint() >> 3;
                    e = 1 === n ? t.readString() : 2 === n ? t.readFloat() : 3 === n ? t.readDouble() : 4 === n ? t.readVarint64() : 5 === n ? t.readVarint() : 6 === n ? t.readSVarint() : 7 === n ? t.readBoolean() : null;
                }
                return e;
            }(r));
        }
        bl.prototype.feature = function(t) {
            if (t < 0 || t >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t];
            var e = this._pbf.readVarint() + this._pbf.pos;
            return new xl(this._pbf, e, this.extent, this._keys, this._values);
        };
        var _l = vl;
        function Al(t, e, r) {
            if (3 === t) {
                var n = new _l(r, r.readVarint() + r.pos);
                n.length && (e[n.name] = n);
            }
        }
        pl.VectorTile = function(t, e) {
            this.layers = t.readFields(Al, {}, e);
        }, pl.VectorTileFeature = dl, pl.VectorTileLayer = vl;
        const Sl = pl.VectorTileFeature.types, kl = Math.pow(2, 13);
        function Ml(t, e, r, n, i, s, a, o) {
            t.emplaceBack(e, r, 2 * Math.floor(n * kl) + a, i * kl * 2, s * kl * 2, Math.round(o));
        }
        class Il {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new Xs, this.centroidVertexArray = new Zs, this.indexArray = new na, this.programConfigurations = new Ea(t.layers, t.zoom), this.segments = new oa, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.features = [], this.hasPattern = rl("fill-extrusion", this.layers, e);
                for (const { feature: n, id: i, index: s, sourceLayerIndex: a } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, o = ja(n, t);
                    if (!this.layers[0]._featureFilter.filter(new Ui(this.zoom), o, r)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: a,
                        index: s,
                        geometry: t ? o.geometry : Oa(n),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(nl("fill-extrusion", this.layers, l, this.zoom, e)) : this.addFeature(l, l.geometry, s, r, {}), e.featureIndex.insert(n, l.geometry, s, a, this.index, !0);
                }
            }
            addFeatures(t, e, r) {
                for (const t of this.features){
                    const { geometry: n } = t;
                    this.addFeature(t, n, t.index, e, r);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, hl), this.centroidVertexBuffer = t.createVertexBuffer(this.centroidVertexArray, cl.members, !0), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(t, e, r, n, i) {
                for (const r of xr(e, 500)){
                    const e = {
                        x: 0,
                        y: 0,
                        vertexCount: 0
                    };
                    let n = 0;
                    for (const t of r)n += t.length;
                    let i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                    for (const t of r){
                        if (0 === t.length) continue;
                        if (Pl(t)) continue;
                        let r = 0;
                        for(let n = 0; n < t.length; n++){
                            const s = t[n];
                            if (n >= 1) {
                                const a = t[n - 1];
                                if (!zl(s, a)) {
                                    i.vertexLength + 4 > oa.MAX_VERTEX_ARRAY_LENGTH && (i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                    const t = s.sub(a)._perp()._unit(), n = a.dist(s);
                                    r + n > 32768 && (r = 0), Ml(this.layoutVertexArray, s.x, s.y, t.x, t.y, 0, 0, r), Ml(this.layoutVertexArray, s.x, s.y, t.x, t.y, 0, 1, r), e.x += 2 * s.x, e.y += 2 * s.y, e.vertexCount += 2, r += n, Ml(this.layoutVertexArray, a.x, a.y, t.x, t.y, 0, 0, r), Ml(this.layoutVertexArray, a.x, a.y, t.x, t.y, 0, 1, r), e.x += 2 * a.x, e.y += 2 * a.y, e.vertexCount += 2;
                                    const o = i.vertexLength;
                                    this.indexArray.emplaceBack(o, o + 2, o + 1), this.indexArray.emplaceBack(o + 1, o + 2, o + 3), i.vertexLength += 4, i.primitiveLength += 2;
                                }
                            }
                        }
                    }
                    if (i.vertexLength + n > oa.MAX_VERTEX_ARRAY_LENGTH && (i = this.segments.prepareSegment(n, this.layoutVertexArray, this.indexArray)), "Polygon" !== Sl[t.type]) continue;
                    const s = [], a = [], o = i.vertexLength;
                    for (const t of r)if (0 !== t.length) {
                        t !== r[0] && a.push(s.length / 2);
                        for(let r = 0; r < t.length; r++){
                            const n = t[r];
                            Ml(this.layoutVertexArray, n.x, n.y, 0, 0, 1, 1, 0), e.x += n.x, e.y += n.y, e.vertexCount += 1, s.push(n.x), s.push(n.y);
                        }
                    }
                    const l = Bo(s, a);
                    for(let t = 0; t < l.length; t += 3)this.indexArray.emplaceBack(o + l[t], o + l[t + 2], o + l[t + 1]);
                    i.primitiveLength += l.length / 3, i.vertexLength += n;
                    for(let t = 0; t < e.vertexCount; t++){
                        const t = Math.floor(e.x / e.vertexCount), r = Math.floor(e.y / e.vertexCount);
                        this.centroidVertexArray.emplaceBack(t, r);
                    }
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
        }
        function zl(t, e) {
            return t.x === e.x && (t.x < 0 || t.x > $a) || t.y === e.y && (t.y < 0 || t.y > $a);
        }
        function Pl(t) {
            return t.every((t)=>t.x < 0) || t.every((t)=>t.x > $a) || t.every((t)=>t.y < 0) || t.every((t)=>t.y > $a);
        }
        let Cl;
        wi("FillExtrusionBucket", Il, {
            omit: [
                "layers",
                "features"
            ]
        });
        var Bl = {
            get paint () {
                return Cl = Cl || new rs({
                    "fill-extrusion-opacity": new Ji(G["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new Wi(G["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new Ji(G["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new Ji(G["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new Qi(G["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new Wi(G["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new Wi(G["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new Ji(G["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        class Vl extends is {
            constructor(t){
                super(t, Bl);
            }
            createBucket(t) {
                return new Il(t);
            }
            queryRadius() {
                return eo(this.paint.get("fill-extrusion-translate"));
            }
            is3D() {
                return !0;
            }
            queryIntersectsFeature(t, e, r, n, i, a, o, l) {
                const u = ro(t, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a.angle, o), c = this.paint.get("fill-extrusion-height").evaluate(e, r), h = this.paint.get("fill-extrusion-base").evaluate(e, r), p = function(t, e, r, n) {
                    const i = [];
                    for (const r of t){
                        const t = [
                            r.x,
                            r.y,
                            0,
                            1
                        ];
                        po(t, t, e), i.push(new s(t[0] / t[3], t[1] / t[3]));
                    }
                    return i;
                }(u, l), f = function(t, e, r, n) {
                    const i = [], a = [], o = n[8] * e, l = n[9] * e, u = n[10] * e, c = n[11] * e, h = n[8] * r, p = n[9] * r, f = n[10] * r, d = n[11] * r;
                    for (const e of t){
                        const t = [], r = [];
                        for (const i of e){
                            const e = i.x, a = i.y, y = n[0] * e + n[4] * a + n[12], m = n[1] * e + n[5] * a + n[13], g = n[2] * e + n[6] * a + n[14], x = n[3] * e + n[7] * a + n[15], v = g + u, b = x + c, w = y + h, _ = m + p, A = g + f, S = x + d, k = new s((y + o) / b, (m + l) / b);
                            k.z = v / b, t.push(k);
                            const M = new s(w / S, _ / S);
                            M.z = A / S, r.push(M);
                        }
                        i.push(t), a.push(r);
                    }
                    return [
                        i,
                        a
                    ];
                }(n, h, c, l);
                return function(t, e, r) {
                    let n = 1 / 0;
                    Za(r, e) && (n = Fl(r, e[0]));
                    for(let i = 0; i < e.length; i++){
                        const s = e[i], a = t[i];
                        for(let t = 0; t < s.length - 1; t++){
                            const e = s[t], i = [
                                e,
                                s[t + 1],
                                a[t + 1],
                                a[t],
                                e
                            ];
                            qa(r, i) && (n = Math.min(n, Fl(r, i)));
                        }
                    }
                    return n !== 1 / 0 && n;
                }(f[0], f[1], p);
            }
        }
        function El(t, e) {
            return t.x * e.x + t.y * e.y;
        }
        function Fl(t, e) {
            if (1 === t.length) {
                let r = 0;
                const n = e[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e[r++], !i) return 1 / 0;
                for(; r < e.length; r++){
                    const s = e[r], a = t[0], o = i.sub(n), l = s.sub(n), u = a.sub(n), c = El(o, o), h = El(o, l), p = El(l, l), f = El(u, o), d = El(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t = 1 / 0;
                for (const r of e)t = Math.min(t, r.z);
                return t;
            }
        }
        const Tl = ls([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: $l } = Tl, Ll = ls([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: Dl } = Ll, Ol = pl.VectorTileFeature.types, jl = Math.cos(Math.PI / 180 * 37.5), Rl = Math.pow(2, 14) / .5;
        class Ul {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t)=>{
                    this.gradients[t.id] = {};
                }), this.layoutVertexArray = new Hs, this.layoutVertexArray2 = new Ys, this.indexArray = new na, this.programConfigurations = new Ea(t.layers, t.zoom), this.segments = new oa, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = rl("line", this.layers, e);
                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), s = [];
                for (const { feature: e, id: a, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ja(e, t);
                    if (!this.layers[0]._featureFilter.filter(new Ui(this.zoom), u, r)) continue;
                    const c = i ? n.evaluate(u, {}, r) : void 0, h = {
                        id: a,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : Oa(e),
                        patterns: {},
                        sortKey: c
                    };
                    s.push(h);
                }
                i && s.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const t = nl("line", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, s, r, {});
                    e.featureIndex.insert(t[s].feature, i, s, a, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const t of this.patternFeatures)this.addFeature(t, t.geometry, t.index, e, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t.createVertexBuffer(this.layoutVertexArray2, Dl)), this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, $l), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t) {
                if (t.properties && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_end")) return {
                    start: +t.properties.mapbox_clip_start,
                    end: +t.properties.mapbox_clip_end
                };
            }
            addFeature(t, e, r, n, i) {
                const s = this.layers[0].layout, a = s.get("line-join").evaluate(t, {}), o = s.get("line-cap"), l = s.get("line-miter-limit"), u = s.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t);
                for (const r of e)this.addLine(r, t, a, o, l, u);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
            addLine(t, e, r, n, i, s) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e = 0; e < t.length - 1; e++)this.totalDistance += t[e].dist(t[e + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const a = "Polygon" === Ol[e.type];
                let o = t.length;
                for(; o >= 2 && t[o - 1].equals(t[o - 2]);)o--;
                let l = 0;
                for(; l < o - 1 && t[l].equals(t[l + 1]);)l++;
                if (o < (a ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const u = this.overscaling <= 16 ? 15 * $a / (512 * this.overscaling) : 0, c = this.segments.prepareSegment(10 * o, this.layoutVertexArray, this.indexArray);
                let h, p, f, d, y;
                this.e1 = this.e2 = -1, a && (h = t[o - 2], y = t[l].sub(h)._unit()._perp());
                for(let e = l; e < o; e++){
                    if (f = e === o - 1 ? a ? t[l + 1] : void 0 : t[e + 1], f && t[e].equals(f)) continue;
                    y && (d = y), h && (p = h), h = t[e], y = f ? f.sub(h)._unit()._perp() : d, d = d || y;
                    let m = d.add(y);
                    0 === m.x && 0 === m.y || m._unit();
                    const g = d.x * y.x + d.y * y.y, x = m.x * y.x + m.y * y.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < jl && p && f, _ = d.x * y.y - d.y * y.x > 0;
                    if (w && e > l) {
                        const t = h.dist(p);
                        if (t > 2 * u) {
                            const e = h.sub(h.sub(p)._mult(u / t)._round());
                            this.updateDistance(p, e), this.addCurrentVertex(e, d, 0, 0, c), p = e;
                        }
                    }
                    const A = p && f;
                    let S = A ? r : a ? "butt" : n;
                    if (A && "round" === S && (v < s ? S = "miter" : v <= 2 && (S = "fakeround")), "miter" === S && v > i && (S = "bevel"), "bevel" === S && (v > 2 && (S = "flipbevel"), v < i && (S = "miter")), p && this.updateDistance(p, h), "miter" === S) m._mult(v), this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("flipbevel" === S) {
                        if (v > 100) m = y.mult(-1);
                        else {
                            const t = v * d.add(y).mag() / d.sub(y).mag();
                            m._perp()._mult(t * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(h, m, 0, 0, c), this.addCurrentVertex(h, m.mult(-1), 0, 0, c);
                    } else if ("bevel" === S || "fakeround" === S) {
                        const t = -Math.sqrt(v * v - 1), e = _ ? t : 0, r = _ ? 0 : t;
                        if (p && this.addCurrentVertex(h, d, e, r, c), "fakeround" === S) {
                            const t = Math.round(180 * b / Math.PI / 20);
                            for(let e = 1; e < t; e++){
                                let r = e / t;
                                if (.5 !== r) {
                                    const t = r - .5;
                                    r += r * t * (r - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * t * t + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const n = y.sub(d)._mult(r)._add(d)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(h, n.x, n.y, !1, _, 0, c);
                            }
                        }
                        f && this.addCurrentVertex(h, y, -e, -r, c);
                    } else if ("butt" === S) this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("square" === S) {
                        const t = p ? 1 : -1;
                        this.addCurrentVertex(h, m, t, t, c);
                    } else "round" === S && (p && (this.addCurrentVertex(h, d, 0, 0, c), this.addCurrentVertex(h, d, 1, 1, c, !0)), f && (this.addCurrentVertex(h, y, -1, -1, c, !0), this.addCurrentVertex(h, y, 0, 0, c)));
                    if (w && e < o - 1) {
                        const t = h.dist(f);
                        if (t > 2 * u) {
                            const e = h.add(f.sub(h)._mult(u / t)._round());
                            this.updateDistance(h, e), this.addCurrentVertex(e, y, 0, 0, c), h = e;
                        }
                    }
                }
            }
            addCurrentVertex(t, e, r, n, i, s = !1) {
                const a = e.y * n - e.x, o = -e.y - e.x * n;
                this.addHalfVertex(t, e.x + e.y * r, e.y - e.x * r, s, !1, r, i), this.addHalfVertex(t, a, o, s, !0, -n, i), this.distance > Rl / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t, e, r, n, i, s));
            }
            addHalfVertex({ x: t, y: e }, r, n, i, s, a, o) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (Rl - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((t << 1) + (i ? 1 : 0), (e << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), s ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(t, e) {
                this.distance += t.dist(e), this.updateScaledDistance();
            }
        }
        let ql, Nl;
        wi("LineBucket", Ul, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var Zl = {
            get paint () {
                return Nl = Nl || new rs({
                    "line-opacity": new Wi(G.paint_line["line-opacity"]),
                    "line-color": new Wi(G.paint_line["line-color"]),
                    "line-translate": new Ji(G.paint_line["line-translate"]),
                    "line-translate-anchor": new Ji(G.paint_line["line-translate-anchor"]),
                    "line-width": new Wi(G.paint_line["line-width"]),
                    "line-gap-width": new Wi(G.paint_line["line-gap-width"]),
                    "line-offset": new Wi(G.paint_line["line-offset"]),
                    "line-blur": new Wi(G.paint_line["line-blur"]),
                    "line-dasharray": new ts(G.paint_line["line-dasharray"]),
                    "line-pattern": new Qi(G.paint_line["line-pattern"]),
                    "line-gradient": new es(G.paint_line["line-gradient"])
                });
            },
            get layout () {
                return ql = ql || new rs({
                    "line-cap": new Ji(G.layout_line["line-cap"]),
                    "line-join": new Wi(G.layout_line["line-join"]),
                    "line-miter-limit": new Ji(G.layout_line["line-miter-limit"]),
                    "line-round-limit": new Ji(G.layout_line["line-round-limit"]),
                    "line-sort-key": new Wi(G.layout_line["line-sort-key"])
                });
            }
        };
        class Gl extends Wi {
            possiblyEvaluate(t, e) {
                return e = new Ui(Math.floor(e.zoom), {
                    now: e.now,
                    fadeDuration: e.fadeDuration,
                    zoomHistory: e.zoomHistory,
                    transition: e.transition
                }), super.possiblyEvaluate(t, e);
            }
            evaluate(t, e, r, n) {
                return e = g({}, e, {
                    zoom: Math.floor(e.zoom)
                }), super.evaluate(t, e, r, n);
            }
        }
        let Kl;
        class Xl extends is {
            constructor(t){
                super(t, Zl), this.gradientVersion = 0, Kl || (Kl = new Gl(Zl.paint.properties["line-width"].specification), Kl.useIntegerZoom = !0);
            }
            _handleSpecialPaintPropertyUpdate(t) {
                if ("line-gradient" === t) {
                    const t = this.gradientExpression();
                    this.stepInterpolant = !!function(t) {
                        return void 0 !== t._styleExpression;
                    }(t) && t._styleExpression.expression instanceof Ae, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                }
            }
            gradientExpression() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }
            recalculate(t, e) {
                super.recalculate(t, e), this.paint._values["line-floorwidth"] = Kl.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t);
            }
            createBucket(t) {
                return new Ul(t);
            }
            queryRadius(t) {
                const e = t, r = Hl(to("line-width", this, e), to("line-gap-width", this, e)), n = to("line-offset", this, e);
                return r / 2 + Math.abs(n) + eo(this.paint.get("line-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, a, o) {
                const l = ro(t, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), a.angle, o), u = o / 2 * Hl(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)), c = this.paint.get("line-offset").evaluate(e, r);
                return c && (n = function(t, e) {
                    const r = [];
                    for(let n = 0; n < t.length; n++){
                        const i = t[n], a = [];
                        for(let t = 0; t < i.length; t++){
                            const r = i[t - 1], n = i[t], o = i[t + 1], l = 0 === t ? new s(0, 0) : n.sub(r)._unit()._perp(), u = t === i.length - 1 ? new s(0, 0) : o.sub(n)._unit()._perp(), c = l._add(u)._unit(), h = c.x * u.x + c.y * u.y;
                            0 !== h && c._mult(1 / h), a.push(c._mult(e)._add(n));
                        }
                        r.push(a);
                    }
                    return r;
                }(n, c * o)), function(t, e, r) {
                    for(let n = 0; n < e.length; n++){
                        const i = e[n];
                        if (t.length >= 3) {
                            for(let e = 0; e < i.length; e++)if (Wa(t, i[e])) return !0;
                        }
                        if (Ga(t, i, r)) return !0;
                    }
                    return !1;
                }(l, n, u);
            }
            isTileClipped() {
                return !0;
            }
        }
        function Hl(t, e) {
            return e > 0 ? e + 2 * t : t;
        }
        const Yl = ls([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), Jl = ls([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        ls([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const Wl = ls([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_box_real",
                components: 2,
                type: "Int16"
            }
        ]);
        ls([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Ql = ls([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), tu = ls([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function eu(t, e, r) {
            return t.sections.forEach((t)=>{
                t.text = function(t, e, r) {
                    const n = e.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t = t.toLocaleUpperCase() : "lowercase" === n && (t = t.toLocaleLowerCase()), Ri.applyArabicShaping && (t = Ri.applyArabicShaping(t)), t;
                }(t.text, e, r);
            }), t;
        }
        ls([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), ls([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), ls([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetStartIndex"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetEndIndex"
            }
        ]), ls([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), ls([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]), ls([
            {
                type: "Uint16",
                name: "textAnchor"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            }
        ]);
        const ru = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        var nu = 24, iu = ou, su = function(t, e, r, n, i) {
            var s, a, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t[e + h];
            for(h += p, s = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; s = 256 * s + t[e + h], h += p, c -= 8);
            for(a = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; a = 256 * a + t[e + h], h += p, c -= 8);
            if (0 === s) s = 1 - u;
            else {
                if (s === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
                a += Math.pow(2, n), s -= u;
            }
            return (f ? -1 : 1) * a * Math.pow(2, s - n);
        }, au = function(t, e, r, n, i, s) {
            var a, o, l, u = 8 * s - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : s - 1, d = n ? 1 : -1, y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
            for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (e += a + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (a++, l /= 2), a + h >= c ? (o = 0, a = c) : a + h >= 1 ? (o = (e * l - 1) * Math.pow(2, i), a += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + f] = 255 & o, f += d, o /= 256, i -= 8);
            for(a = a << i | o, u += i; u > 0; t[r + f] = 255 & a, f += d, a /= 256, u -= 8);
            t[r + f - d] |= 128 * y;
        };
        function ou(t) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t) ? t : new Uint8Array(t || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        ou.Varint = 0, ou.Fixed64 = 1, ou.Bytes = 2, ou.Fixed32 = 5;
        var lu = 4294967296, uu = 1 / lu, cu = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        function hu(t) {
            return t.type === ou.Bytes ? t.readVarint() + t.pos : t.pos + 1;
        }
        function pu(t, e, r) {
            return r ? 4294967296 * e + (t >>> 0) : 4294967296 * (e >>> 0) + (t >>> 0);
        }
        function fu(t, e, r) {
            var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t; i--)r.buf[i + n] = r.buf[i];
        }
        function du(t, e) {
            for(var r = 0; r < t.length; r++)e.writeVarint(t[r]);
        }
        function yu(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSVarint(t[r]);
        }
        function mu(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFloat(t[r]);
        }
        function gu(t, e) {
            for(var r = 0; r < t.length; r++)e.writeDouble(t[r]);
        }
        function xu(t, e) {
            for(var r = 0; r < t.length; r++)e.writeBoolean(t[r]);
        }
        function vu(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFixed32(t[r]);
        }
        function bu(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSFixed32(t[r]);
        }
        function wu(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFixed64(t[r]);
        }
        function _u(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSFixed64(t[r]);
        }
        function Au(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + 16777216 * t[e + 3];
        }
        function Su(t, e, r) {
            t[r] = e, t[r + 1] = e >>> 8, t[r + 2] = e >>> 16, t[r + 3] = e >>> 24;
        }
        function ku(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + (t[e + 3] << 24);
        }
        ou.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t, e, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, s = this.pos;
                    this.type = 7 & n, t(i, e, this), this.pos === s && this.skip(n);
                }
                return e;
            },
            readMessage: function(t, e) {
                return this.readFields(t, e, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t = Au(this.buf, this.pos);
                return this.pos += 4, t;
            },
            readSFixed32: function() {
                var t = ku(this.buf, this.pos);
                return this.pos += 4, t;
            },
            readFixed64: function() {
                var t = Au(this.buf, this.pos) + Au(this.buf, this.pos + 4) * lu;
                return this.pos += 8, t;
            },
            readSFixed64: function() {
                var t = Au(this.buf, this.pos) + ku(this.buf, this.pos + 4) * lu;
                return this.pos += 8, t;
            },
            readFloat: function() {
                var t = su(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t;
            },
            readDouble: function() {
                var t = su(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t;
            },
            readVarint: function(t) {
                var e, r, n = this.buf;
                return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function(t, e, r) {
                    var n, i, s = r.buf;
                    if (n = (112 & (i = s[r.pos++])) >> 4, i < 128) return pu(t, n, e);
                    if (n |= (127 & (i = s[r.pos++])) << 3, i < 128) return pu(t, n, e);
                    if (n |= (127 & (i = s[r.pos++])) << 10, i < 128) return pu(t, n, e);
                    if (n |= (127 & (i = s[r.pos++])) << 17, i < 128) return pu(t, n, e);
                    if (n |= (127 & (i = s[r.pos++])) << 24, i < 128) return pu(t, n, e);
                    if (n |= (1 & (i = s[r.pos++])) << 31, i < 128) return pu(t, n, e);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e |= (15 & (r = n[this.pos])) << 28, t, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t = this.readVarint();
                return t % 2 == 1 ? (t + 1) / -2 : t / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t = this.readVarint() + this.pos, e = this.pos;
                return this.pos = t, t - e >= 12 && cu ? function(t, e, r) {
                    return cu.decode(t.subarray(e, r));
                }(this.buf, e, t) : function(t, e, r) {
                    for(var n = "", i = e; i < r;){
                        var s, a, o, l = t[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (i + c > r) break;
                        1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (s = t[i + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === c ? (a = t[i + 2], 128 == (192 & (s = t[i + 1])) && 128 == (192 & a) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & a) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (a = t[i + 2], o = t[i + 3], 128 == (192 & (s = t[i + 1])) && 128 == (192 & a) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                    }
                    return n;
                }(this.buf, e, t);
            },
            readBytes: function() {
                var t = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t);
                return this.pos = t, e;
            },
            readPackedVarint: function(t, e) {
                if (this.type !== ou.Bytes) return t.push(this.readVarint(e));
                var r = hu(this);
                for(t = t || []; this.pos < r;)t.push(this.readVarint(e));
                return t;
            },
            readPackedSVarint: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readSVarint());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readSVarint());
                return t;
            },
            readPackedBoolean: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readBoolean());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readBoolean());
                return t;
            },
            readPackedFloat: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readFloat());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readFloat());
                return t;
            },
            readPackedDouble: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readDouble());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readDouble());
                return t;
            },
            readPackedFixed32: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readFixed32());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readFixed32());
                return t;
            },
            readPackedSFixed32: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readSFixed32());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readSFixed32());
                return t;
            },
            readPackedFixed64: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readFixed64());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readFixed64());
                return t;
            },
            readPackedSFixed64: function(t) {
                if (this.type !== ou.Bytes) return t.push(this.readSFixed64());
                var e = hu(this);
                for(t = t || []; this.pos < e;)t.push(this.readSFixed64());
                return t;
            },
            skip: function(t) {
                var e = 7 & t;
                if (e === ou.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e === ou.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e === ou.Fixed32) this.pos += 4;
                else {
                    if (e !== ou.Fixed64) throw new Error("Unimplemented type: " + e);
                    this.pos += 8;
                }
            },
            writeTag: function(t, e) {
                this.writeVarint(t << 3 | e);
            },
            realloc: function(t) {
                for(var e = this.length || 16; e < this.pos + t;)e *= 2;
                if (e !== this.length) {
                    var r = new Uint8Array(e);
                    r.set(this.buf), this.buf = r, this.length = e;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t) {
                this.realloc(4), Su(this.buf, t, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t) {
                this.realloc(4), Su(this.buf, t, this.pos), this.pos += 4;
            },
            writeFixed64: function(t) {
                this.realloc(8), Su(this.buf, -1 & t, this.pos), Su(this.buf, Math.floor(t * uu), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t) {
                this.realloc(8), Su(this.buf, -1 & t, this.pos), Su(this.buf, Math.floor(t * uu), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t) {
                (t = +t || 0) > 268435455 || t < 0 ? function(t, e) {
                    var r, n;
                    if (t >= 0 ? (r = t % 4294967296 | 0, n = t / 4294967296 | 0) : (n = ~(-t / 4294967296), 4294967295 ^ (r = ~(-t % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t >= 0x10000000000000000 || t < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e.realloc(10), function(t, e, r) {
                        r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, r.buf[r.pos] = 127 & (t >>>= 7);
                    }(r, 0, e), function(t, e) {
                        var r = (7 & t) << 4;
                        e.buf[e.pos++] |= r | ((t >>>= 3) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t)))));
                    }(n, e);
                }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
            },
            writeSVarint: function(t) {
                this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
            },
            writeBoolean: function(t) {
                this.writeVarint(Boolean(t));
            },
            writeString: function(t) {
                t = String(t), this.realloc(4 * t.length), this.pos++;
                var e = this.pos;
                this.pos = function(t, e, r) {
                    for(var n, i, s = 0; s < e.length; s++){
                        if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || s + 1 === e.length ? (t[r++] = 239, t[r++] = 191, t[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t[r++] = 239, t[r++] = 191, t[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t[r++] = 239, t[r++] = 191, t[r++] = 189, i = null);
                        n < 128 ? t[r++] = n : (n < 2048 ? t[r++] = n >> 6 | 192 : (n < 65536 ? t[r++] = n >> 12 | 224 : (t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128), t[r++] = n >> 6 & 63 | 128), t[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t, this.pos);
                var r = this.pos - e;
                r >= 128 && fu(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t) {
                this.realloc(4), au(this.buf, t, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t) {
                this.realloc(8), au(this.buf, t, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t) {
                var e = t.length;
                this.writeVarint(e), this.realloc(e);
                for(var r = 0; r < e; r++)this.buf[this.pos++] = t[r];
            },
            writeRawMessage: function(t, e) {
                this.pos++;
                var r = this.pos;
                t(e, this);
                var n = this.pos - r;
                n >= 128 && fu(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t, e, r) {
                this.writeTag(t, ou.Bytes), this.writeRawMessage(e, r);
            },
            writePackedVarint: function(t, e) {
                e.length && this.writeMessage(t, du, e);
            },
            writePackedSVarint: function(t, e) {
                e.length && this.writeMessage(t, yu, e);
            },
            writePackedBoolean: function(t, e) {
                e.length && this.writeMessage(t, xu, e);
            },
            writePackedFloat: function(t, e) {
                e.length && this.writeMessage(t, mu, e);
            },
            writePackedDouble: function(t, e) {
                e.length && this.writeMessage(t, gu, e);
            },
            writePackedFixed32: function(t, e) {
                e.length && this.writeMessage(t, vu, e);
            },
            writePackedSFixed32: function(t, e) {
                e.length && this.writeMessage(t, bu, e);
            },
            writePackedFixed64: function(t, e) {
                e.length && this.writeMessage(t, wu, e);
            },
            writePackedSFixed64: function(t, e) {
                e.length && this.writeMessage(t, _u, e);
            },
            writeBytesField: function(t, e) {
                this.writeTag(t, ou.Bytes), this.writeBytes(e);
            },
            writeFixed32Field: function(t, e) {
                this.writeTag(t, ou.Fixed32), this.writeFixed32(e);
            },
            writeSFixed32Field: function(t, e) {
                this.writeTag(t, ou.Fixed32), this.writeSFixed32(e);
            },
            writeFixed64Field: function(t, e) {
                this.writeTag(t, ou.Fixed64), this.writeFixed64(e);
            },
            writeSFixed64Field: function(t, e) {
                this.writeTag(t, ou.Fixed64), this.writeSFixed64(e);
            },
            writeVarintField: function(t, e) {
                this.writeTag(t, ou.Varint), this.writeVarint(e);
            },
            writeSVarintField: function(t, e) {
                this.writeTag(t, ou.Varint), this.writeSVarint(e);
            },
            writeStringField: function(t, e) {
                this.writeTag(t, ou.Bytes), this.writeString(e);
            },
            writeFloatField: function(t, e) {
                this.writeTag(t, ou.Fixed32), this.writeFloat(e);
            },
            writeDoubleField: function(t, e) {
                this.writeTag(t, ou.Fixed64), this.writeDouble(e);
            },
            writeBooleanField: function(t, e) {
                this.writeVarintField(t, Boolean(e));
            }
        };
        var Mu = r(iu);
        const Iu = 3;
        function zu(t, e, r) {
            1 === t && r.readMessage(Pu, e);
        }
        function Pu(t, e, r) {
            if (3 === t) {
                const { id: t, bitmap: n, width: i, height: s, left: a, top: o, advance: l } = r.readMessage(Cu, {});
                e.push({
                    id: t,
                    bitmap: new _o({
                        width: i + 2 * Iu,
                        height: s + 2 * Iu
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: a,
                        top: o,
                        advance: l
                    }
                });
            }
        }
        function Cu(t, e, r) {
            1 === t ? e.id = r.readVarint() : 2 === t ? e.bitmap = r.readBytes() : 3 === t ? e.width = r.readVarint() : 4 === t ? e.height = r.readVarint() : 5 === t ? e.left = r.readSVarint() : 6 === t ? e.top = r.readSVarint() : 7 === t && (e.advance = r.readVarint());
        }
        const Bu = Iu;
        function Vu(t) {
            let e = 0, r = 0;
            for (const n of t)e += n.w * n.h, r = Math.max(r, n.w);
            t.sort((t, e)=>e.h - t.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const e of t)for(let t = n.length - 1; t >= 0; t--){
                const r = n[t];
                if (!(e.w > r.w || e.h > r.h)) {
                    if (e.x = r.x, e.y = r.y, s = Math.max(s, e.y + e.h), i = Math.max(i, e.x + e.w), e.w === r.w && e.h === r.h) {
                        const e = n.pop();
                        t < n.length && (n[t] = e);
                    } else e.h === r.h ? (r.x += e.w, r.w -= e.w) : e.w === r.w ? (r.y += e.h, r.h -= e.h) : (n.push({
                        x: r.x + e.w,
                        y: r.y,
                        w: r.w - e.w,
                        h: e.h
                    }), r.y += e.h, r.h -= e.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: e / (i * s) || 0
            };
        }
        const Eu = 1;
        class Fu {
            constructor(t, { pixelRatio: e, version: r, stretchX: n, stretchY: i, content: s, textFitWidth: a, textFitHeight: o }){
                this.paddedRect = t, this.pixelRatio = e, this.stretchX = n, this.stretchY = i, this.content = s, this.version = r, this.textFitWidth = a, this.textFitHeight = o;
            }
            get tl() {
                return [
                    this.paddedRect.x + Eu,
                    this.paddedRect.y + Eu
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - Eu,
                    this.paddedRect.y + this.paddedRect.h - Eu
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * Eu) / this.pixelRatio,
                    (this.paddedRect.h - 2 * Eu) / this.pixelRatio
                ];
            }
        }
        class Tu {
            constructor(t, e){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t, r, i), this.addImages(e, n, i);
                const { w: s, h: a } = Vu(i), o = new Ao({
                    width: s || 1,
                    height: a || 1
                });
                for(const e in t){
                    const n = t[e], i = r[e].paddedRect;
                    Ao.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + Eu,
                        y: i.y + Eu
                    }, n.data);
                }
                for(const t in e){
                    const r = e[t], i = n[t].paddedRect, s = i.x + Eu, a = i.y + Eu, l = r.data.width, u = r.data.height;
                    Ao.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a
                    }, r.data), Ao.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: s,
                        y: a - 1
                    }, {
                        width: l,
                        height: 1
                    }), Ao.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: a + u
                    }, {
                        width: l,
                        height: 1
                    }), Ao.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    }), Ao.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + l,
                        y: a
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
            addImages(t, e, r) {
                for(const n in t){
                    const i = t[n], s = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2 * Eu,
                        h: i.data.height + 2 * Eu
                    };
                    r.push(s), e[n] = new Fu(s, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t, e) {
                t.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t.getImage(r), e), this.patchUpdatedImage(this.patternPositions[r], t.getImage(r), e);
            }
            patchUpdatedImage(t, e, r) {
                if (!t || !e) return;
                if (t.version === e.version) return;
                t.version = e.version;
                const [n, i] = t.tl;
                r.update(e.data, void 0, {
                    x: n,
                    y: i
                });
            }
        }
        var $u;
        wi("ImagePosition", Fu), wi("ImageAtlas", Tu), t.ah = void 0, ($u = t.ah || (t.ah = {}))[$u.none = 0] = "none", $u[$u.horizontal = 1] = "horizontal", $u[$u.vertical = 2] = "vertical", $u[$u.horizontalOnly = 3] = "horizontalOnly";
        const Lu = -17;
        class Du {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
            static forText(t, e) {
                const r = new Du;
                return r.scale = t || 1, r.fontStack = e, r;
            }
            static forImage(t) {
                const e = new Du;
                return e.imageName = t, e;
            }
        }
        class Ou {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t, e) {
                const r = new Ou;
                for(let n = 0; n < t.sections.length; n++){
                    const i = t.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t) {
                return this.sections[this.sectionIndex[t]];
            }
            getSectionIndex(t) {
                return this.sectionIndex[t];
            }
            getCharCode(t) {
                return this.text.charCodeAt(t);
            }
            verticalizePunctuation() {
                this.text = function(t) {
                    let e = "";
                    for(let r = 0; r < t.length; r++){
                        const n = t.charCodeAt(r + 1) || null, i = t.charCodeAt(r - 1) || null;
                        e += n && $i(n) && !ru[t[r + 1]] || i && $i(i) && !ru[t[r - 1]] || !ru[t[r]] ? t[r] : ru[t[r]];
                    }
                    return e;
                }(this.text);
            }
            trim() {
                let t = 0;
                for(let e = 0; e < this.text.length && Ru[this.text.charCodeAt(e)]; e++)t++;
                let e = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t && Ru[this.text.charCodeAt(r)]; r--)e--;
                this.text = this.text.substring(t, e), this.sectionIndex = this.sectionIndex.slice(t, e);
            }
            substring(t, e) {
                const r = new Ou;
                return r.text = this.text.substring(t, e), r.sectionIndex = this.sectionIndex.slice(t, e), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t, e)=>Math.max(t, this.sections[e].scale), 0);
            }
            addTextSection(t, e) {
                this.text += t.text, this.sections.push(Du.forText(t.scale, t.fontStack || e));
                const r = this.sections.length - 1;
                for(let e = 0; e < t.text.length; ++e)this.sectionIndex.push(r);
            }
            addImageSection(t) {
                const e = t.image ? t.image.name : "";
                if (0 === e.length) return void A("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(Du.forImage(e)), this.sectionIndex.push(this.sections.length - 1)) : A("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function ju(e, r, n, i, s, a, o, l, u, c, h, p, f, d, y) {
            const m = Ou.fromFeature(e, s);
            let g;
            p === t.ah.vertical && m.verticalizePunctuation();
            const { processBidirectionalText: x, processStyledBidirectionalText: v } = Ri;
            if (x && 1 === m.sections.length) {
                g = [];
                const t = x(m.toString(), Hu(m, c, a, r, i, d));
                for (const e of t){
                    const t = new Ou;
                    t.text = e, t.sections = m.sections;
                    for(let r = 0; r < e.length; r++)t.sectionIndex.push(0);
                    g.push(t);
                }
            } else if (v) {
                g = [];
                const t = v(m.text, m.sectionIndex, Hu(m, c, a, r, i, d));
                for (const e of t){
                    const t = new Ou;
                    t.text = e[0], t.sectionIndex = e[1], t.sections = m.sections, g.push(t);
                }
            } else g = function(t, e) {
                const r = [], n = t.text;
                let i = 0;
                for (const n of e)r.push(t.substring(i, n)), i = n;
                return i < n.length && r.push(t.substring(i, n.length)), r;
            }(m, Hu(m, c, a, r, i, d));
            const b = [], w = {
                positionedLines: b,
                text: m.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(e, r, n, i, s, a, o, l, u, c, h, p) {
                let f = 0, d = Lu, y = 0, m = 0;
                const g = "right" === l ? 1 : "left" === l ? 0 : .5;
                let x = 0;
                for (const o of s){
                    o.trim();
                    const s = o.getMaxScale(), l = (s - 1) * nu, b = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e.positionedLines[x] = b;
                    const w = b.positionedGlyphs;
                    let _ = 0;
                    if (!o.length()) {
                        d += a, ++x;
                        continue;
                    }
                    for(let a = 0; a < o.length(); a++){
                        const y = o.getSection(a), m = o.getSectionIndex(a), g = o.getCharCode(a);
                        let x = 0, b = null, A = null, S = null, k = nu;
                        const M = !(u === t.ah.horizontal || !h && !Ti(g) || h && (Ru[g] || (v = g, /\p{sc=Arab}/u.test(String.fromCodePoint(v)))));
                        if (y.imageName) {
                            const t = i[y.imageName];
                            if (!t) continue;
                            S = y.imageName, e.iconsInText = e.iconsInText || !0, A = t.paddedRect;
                            const r = t.displaySize;
                            y.scale = y.scale * nu / p, b = {
                                width: r[0],
                                height: r[1],
                                left: Eu,
                                top: -Bu,
                                advance: M ? r[1] : r[0]
                            }, x = l + (nu - r[1] * y.scale), k = b.advance;
                            const n = M ? r[0] * y.scale - nu * s : r[1] * y.scale - nu * s;
                            n > 0 && n > _ && (_ = n);
                        } else {
                            const t = n[y.fontStack], e = t && t[g];
                            if (e && e.rect) A = e.rect, b = e.metrics;
                            else {
                                const t = r[y.fontStack], e = t && t[g];
                                if (!e) continue;
                                b = e.metrics;
                            }
                            x = (s - y.scale) * nu;
                        }
                        M ? (e.verticalizable = !0, w.push({
                            glyph: g,
                            imageName: S,
                            x: f,
                            y: d + x,
                            vertical: M,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += k * y.scale + c) : (w.push({
                            glyph: g,
                            imageName: S,
                            x: f,
                            y: d + x,
                            vertical: M,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += b.advance * y.scale + c);
                    }
                    0 !== w.length && (y = Math.max(f - c, y), Ju(w, 0, w.length - 1, g, _)), f = 0;
                    const A = a * s + _;
                    b.lineOffset = Math.max(_, l), d += A, m = Math.max(A, m), ++x;
                }
                var v;
                const b = d - Lu, { horizontalAlign: w, verticalAlign: _ } = Yu(o);
                (function(t, e, r, n, i, s, a, o, l) {
                    const u = (e - r) * i;
                    let c = 0;
                    c = s !== a ? -o * n - Lu : (-n * l + .5) * a;
                    for (const e of t)for (const t of e.positionedGlyphs)t.x += u, t.y += c;
                })(e.positionedLines, g, w, _, y, m, a, b, s.length), e.top += -_ * b, e.bottom = e.top + b, e.left += -w * y, e.right = e.left + y;
            }(w, r, n, i, g, o, l, u, p, c, f, y), !function(t) {
                for (const e of t)if (0 !== e.positionedGlyphs.length) return !1;
                return !0;
            }(b) && w;
        }
        const Ru = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Uu = {
            10: !0,
            32: !0,
            38: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        }, qu = {
            40: !0
        };
        function Nu(t, e, r, n, i, s) {
            if (e.imageName) {
                const t = n[e.imageName];
                return t ? t.displaySize[0] * e.scale * nu / s + i : 0;
            }
            {
                const n = r[e.fontStack], s = n && n[t];
                return s ? s.metrics.advance * e.scale + i : 0;
            }
        }
        function Zu(t, e, r, n) {
            const i = Math.pow(t - e, 2);
            return n ? t < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function Gu(t, e, r) {
            let n = 0;
            return 10 === t && (n -= 1e4), r && (n += 150), 40 !== t && 65288 !== t || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
        }
        function Ku(t, e, r, n, i, s) {
            let a = null, o = Zu(e, r, i, s);
            for (const t of n){
                const n = Zu(e - t.x, r, i, s) + t.badness;
                n <= o && (a = t, o = n);
            }
            return {
                index: t,
                x: e,
                priorBreak: a,
                badness: o
            };
        }
        function Xu(t) {
            return t ? Xu(t.priorBreak).concat(t.index) : [];
        }
        function Hu(t, e, r, n, i, s) {
            if (!t) return [];
            const a = [], o = function(t, e, r, n, i, s) {
                let a = 0;
                for(let r = 0; r < t.length(); r++){
                    const o = t.getSection(r);
                    a += Nu(t.getCharCode(r), o, n, i, e, s);
                }
                return a / Math.max(1, Math.ceil(a / r));
            }(t, e, r, n, i, s), l = t.text.indexOf("\u200B") >= 0;
            let u = 0;
            for(let r = 0; r < t.length(); r++){
                const h = t.getSection(r), p = t.getCharCode(r);
                if (Ru[p] || (u += Nu(p, h, n, i, e, s)), r < t.length() - 1) {
                    const e = !((c = p) < 11904) && (!!zi["CJK Compatibility Forms"](c) || !!zi["CJK Compatibility"](c) || !!zi["CJK Strokes"](c) || !!zi["CJK Symbols and Punctuation"](c) || !!zi["Enclosed CJK Letters and Months"](c) || !!zi["Halfwidth and Fullwidth Forms"](c) || !!zi["Ideographic Description Characters"](c) || !!zi["Vertical Forms"](c) || Fi.test(String.fromCodePoint(c)));
                    (Uu[p] || e || h.imageName || r !== t.length() - 2 && qu[t.getCharCode(r + 1)]) && a.push(Ku(r + 1, u, o, a, Gu(p, t.getCharCode(r + 1), e && l), !1));
                }
            }
            var c;
            return Xu(Ku(t.length(), u, o, a, 0, !0));
        }
        function Yu(t) {
            let e = .5, r = .5;
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e = 0;
            }
            switch(t){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e,
                verticalAlign: r
            };
        }
        function Ju(t, e, r, n, i) {
            if (!n && !i) return;
            const s = t[r], a = (t[r].x + s.metrics.advance * s.scale) * n;
            for(let n = e; n <= r; n++)t[n].x -= a, t[n].y += i;
        }
        function Wu(t, e, r) {
            const { horizontalAlign: n, verticalAlign: i } = Yu(r), s = e[0] - t.displaySize[0] * n, a = e[1] - t.displaySize[1] * i;
            return {
                image: t,
                top: a,
                bottom: a + t.displaySize[1],
                left: s,
                right: s + t.displaySize[0]
            };
        }
        function Qu(t) {
            var e, r;
            let n = t.left, i = t.top, s = t.right - n, a = t.bottom - i;
            const o = null !== (e = t.image.textFitWidth) && void 0 !== e ? e : "stretchOrShrink", l = null !== (r = t.image.textFitHeight) && void 0 !== r ? r : "stretchOrShrink", u = (t.image.content[2] - t.image.content[0]) / (t.image.content[3] - t.image.content[1]);
            if ("proportional" === l) {
                if ("stretchOnly" === o && s / a < u || "proportional" === o) {
                    const t = Math.ceil(a * u);
                    n *= t / s, s = t;
                }
            } else if ("proportional" === o && "stretchOnly" === l && 0 !== u && s / a > u) {
                const t = Math.ceil(s / u);
                i *= t / a, a = t;
            }
            return {
                x1: n,
                y1: i,
                x2: n + s,
                y2: i + a
            };
        }
        function tc(t, e, r, n, i, s) {
            const a = t.image;
            let o;
            if (a.content) {
                const t = a.content, e = a.pixelRatio || 1;
                o = [
                    t[0] / e,
                    t[1] / e,
                    a.displaySize[0] - t[2] / e,
                    a.displaySize[1] - t[3] / e
                ];
            }
            const l = e.left * s, u = e.right * s;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
            const d = e.top * s, y = e.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - a.displaySize[1]) / 2, p = c + a.displaySize[1]), {
                image: a,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        const ec = 255, rc = 128, nc = ec * rc;
        function ic(t, e) {
            const { expression: r } = e;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Ui(t + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e, interpolationType: n } = r;
                let i = 0;
                for(; i < e.length && e[i] <= t;)i++;
                i = Math.max(0, i - 1);
                let s = i;
                for(; s < e.length && e[s] < t + 1;)s++;
                s = Math.min(e.length - 1, s);
                const a = e[i], o = e[s];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: a,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: a,
                    maxZoom: o,
                    minSize: r.evaluate(new Ui(a)),
                    maxSize: r.evaluate(new Ui(o)),
                    interpolationType: n
                };
            }
        }
        function sc(t, e, r) {
            let n = "never";
            const i = t.get(e);
            return i ? n = i : t.get(r) && (n = "always"), n;
        }
        const ac = pl.VectorTileFeature.types, oc = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function lc(t, e, r, n, i, s, a, o, l, u, c, h, p) {
            const f = o ? Math.min(nc, Math.round(o[0])) : 0, d = o ? Math.min(nc, Math.round(o[1])) : 0;
            t.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), s, a, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function uc(t, e, r) {
            t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r);
        }
        function cc(t) {
            for (const e of t.sections)if (ji(e.text)) return !0;
            return !1;
        }
        class hc {
            constructor(t){
                this.layoutVertexArray = new Ws, this.indexArray = new na, this.programConfigurations = t, this.segments = new oa, this.dynamicLayoutVertexArray = new Qs, this.opacityVertexArray = new ta, this.hasVisibleVertices = !1, this.placedSymbolArray = new $s;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t, e, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Yl.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, Jl.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, oc, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
        }
        wi("SymbolBuffers", hc);
        class pc {
            constructor(t, e, r){
                this.layoutVertexArray = new t, this.layoutAttributes = e, this.indexArray = new r, this.segments = new oa, this.collisionVertexArray = new ra;
            }
            upload(t) {
                this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, Wl.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
        }
        wi("CollisionBuffers", pc);
        class fc {
            constructor(e){
                this.collisionBoxArray = e.collisionBoxArray, this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = e.index, this.pixelRatio = e.pixelRatio, this.sourceLayerIndex = e.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = lo([]), this.placementViewportMatrix = lo([]);
                const r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = ic(this.zoom, r["text-size"]), this.iconSizeData = ic(this.zoom, r["icon-size"]);
                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), s = n.get("symbol-z-order");
                this.canOverlap = "never" !== sc(n, "text-overlap", "text-allow-overlap") || "never" !== sc(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === s || "auto" === s && !this.sortFeaturesByKey) && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((e)=>t.ah[e])), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id), this.sourceID = e.sourceID;
            }
            createArrays() {
                this.text = new hc(new Ea(this.layers, this.zoom, (t)=>/^text/.test(t))), this.icon = new hc(new Ea(this.layers, this.zoom, (t)=>/^icon/.test(t))), this.glyphOffsetArray = new Os, this.lineVertexArray = new js, this.symbolInstances = new Ds, this.textAnchorOffsets = new Us;
            }
            calculateGlyphDependencies(t, e, r, n, i) {
                for(let s = 0; s < t.length; s++)if (e[t.charCodeAt(s)] = !0, (r || n) && i) {
                    const r = ru[t.charAt(s)];
                    r && (e[r.charCodeAt(0)] = !0);
                }
            }
            populate(e, r, n) {
                const i = this.layers[0], s = i.layout, a = s.get("text-font"), o = s.get("text-field"), l = s.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof Yt && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = s.get("symbol-sort-key");
                if (this.features = [], !u && !c) return;
                const p = r.iconDependencies, f = r.glyphDependencies, d = r.availableImages, y = new Ui(this.zoom);
                for (const { feature: r, id: o, index: l, sourceLayerIndex: m } of e){
                    const e = i._featureFilter.needGeometry, g = ja(r, e);
                    if (!i._featureFilter.filter(y, g, n)) continue;
                    let x, v;
                    if (e || (g.geometry = Oa(r)), u) {
                        const t = i.getValueAndResolveTokens("text-field", g, n, d), e = Yt.factory(t), r = this.hasRTLText = this.hasRTLText || cc(e);
                        (!r || "unavailable" === Ri.getRTLTextPluginStatus() || r && Ri.isParsed()) && (x = eu(e, i, g));
                    }
                    if (c) {
                        const t = i.getValueAndResolveTokens("icon-image", g, n, d);
                        v = t instanceof te ? t : te.fromString(t);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? h.evaluate(g, {}, n) : void 0;
                    if (this.features.push({
                        id: o,
                        text: x,
                        icon: v,
                        index: l,
                        sourceLayerIndex: m,
                        geometry: g.geometry,
                        properties: r.properties,
                        type: ac[r.type],
                        sortKey: b
                    }), v && (p[v.name] = !0), x) {
                        const e = a.evaluate(g, {}, n).join(","), r = "viewport" !== s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t.ah.vertical) >= 0;
                        for (const t of x.sections)if (t.image) p[t.image.name] = !0;
                        else {
                            const n = Pi(x.toString()), i = t.fontStack || e, s = f[i] = f[i] || {};
                            this.calculateGlyphDependencies(t.text, s, r, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === s.get("symbol-placement") && (this.features = function(t) {
                    const e = {}, r = {}, n = [];
                    let i = 0;
                    function s(e) {
                        n.push(t[e]), i++;
                    }
                    function a(t, e, i) {
                        const s = r[t];
                        return delete r[t], r[e] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function o(t, r, i) {
                        const s = e[r];
                        return delete e[r], e[t] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(t, e, r) {
                        const n = r ? e[0][e[0].length - 1] : e[0][0];
                        return `${t}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t.length; u++){
                        const c = t[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e && r[f] !== e[d]) {
                            const t = o(f, d, h), i = a(f, d, n[t].geometry);
                            delete e[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t].geometry = null;
                        } else f in r ? a(f, d, h) : d in e ? o(f, d, h) : (s(u), e[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t)=>t.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t, e)=>t.sortKey - e.sortKey);
            }
            update(t, e, r) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t, e, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t, e, this.layers, r));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t, e) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t.segment) {
                    let r = t.dist(e[t.segment + 1]), n = t.dist(e[t.segment]);
                    const i = {};
                    for(let n = t.segment + 1; n < e.length; n++)i[n] = {
                        x: e[n].x,
                        y: e[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n < e.length - 1 && (r += e[n + 1].dist(e[n]));
                    for(let r = t.segment || 0; r >= 0; r--)i[r] = {
                        x: e[r].x,
                        y: e[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r > 0 && (n += e[r - 1].dist(e[r]));
                    for(let t = 0; t < e.length; t++){
                        const e = i[t];
                        this.lineVertexArray.emplaceBack(e.x, e.y, e.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e, r, n, i, s, a, o, l, u, c, h, p) {
                const f = e.indexArray, d = e.layoutVertexArray, y = e.segments.prepareSegment(4 * r.length, d, f, this.canOverlap ? a.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && o === t.ah.vertical ? Math.PI / 2 : 0, v = a.text && a.text.sections;
                for(let t = 0; t < r.length; t++){
                    const { tl: i, tr: s, bl: o, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: A } = r[t], S = y.vertexLength, k = w[1];
                    lc(d, l.x, l.y, i.x, k + i.y, c.x, c.y, n, _, h.x, h.y, g, b), lc(d, l.x, l.y, s.x, k + s.y, c.x + c.w, c.y, n, _, m.x, h.y, g, b), lc(d, l.x, l.y, o.x, k + o.y, c.x, c.y + c.h, n, _, h.x, m.y, g, b), lc(d, l.x, l.y, u.x, k + u.y, c.x + c.w, c.y + c.h, n, _, m.x, m.y, g, b), uc(e.dynamicLayoutVertexArray, l, x), f.emplaceBack(S, S + 1, S + 2), f.emplaceBack(S + 1, S + 2, S + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), t !== r.length - 1 && A === r[t + 1].sectionIndex || e.programConfigurations.populatePaintArrays(d.length, a, a.index, {}, p, v && v[A]);
                }
                e.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], o, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(t, e, r, n, i, s) {
                return e.emplaceBack(0, 0), t.emplaceBack(r.x, r.y, n, i, Math.round(s.x), Math.round(s.y));
            }
            addCollisionDebugVertices(t, e, r, n, i, a, o) {
                const l = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), u = l.vertexLength, c = i.layoutVertexArray, h = i.collisionVertexArray, p = o.anchorX, f = o.anchorY;
                this._addCollisionDebugVertex(c, h, a, p, f, new s(t, e)), this._addCollisionDebugVertex(c, h, a, p, f, new s(r, e)), this._addCollisionDebugVertex(c, h, a, p, f, new s(r, n)), this._addCollisionDebugVertex(c, h, a, p, f, new s(t, n)), l.vertexLength += 4;
                const d = i.indexArray;
                d.emplaceBack(u, u + 1), d.emplaceBack(u + 1, u + 2), d.emplaceBack(u + 2, u + 3), d.emplaceBack(u + 3, u), l.primitiveLength += 4;
            }
            addDebugCollisionBoxes(t, e, r, n) {
                for(let i = t; i < e; i++){
                    const t = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(t.x1, t.y1, t.x2, t.y2, n ? this.textCollisionBox : this.iconCollisionBox, t.anchorPoint, r);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new pc(ea, Ql.members, ia), this.iconCollisionBox = new pc(ea, Ql.members, ia);
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const e = this.symbolInstances.get(t);
                    this.addDebugCollisionBoxes(e.textBoxStartIndex, e.textBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex, e.verticalTextBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.iconBoxStartIndex, e.iconBoxEndIndex, e, !1), this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex, e.verticalIconBoxEndIndex, e, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(t, e, r, n, i, s, a, o, l) {
                const u = {};
                for(let n = e; n < r; n++){
                    const e = t.get(n);
                    u.textBox = {
                        x1: e.x1,
                        y1: e.y1,
                        x2: e.x2,
                        y2: e.y2,
                        anchorPointX: e.anchorPointX,
                        anchorPointY: e.anchorPointY
                    }, u.textFeatureIndex = e.featureIndex;
                    break;
                }
                for(let e = n; e < i; e++){
                    const r = t.get(e);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = s; e < a; e++){
                    const r = t.get(e);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = o; e < l; e++){
                    const r = t.get(e);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t) {
                this.collisionArrays = [];
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const r = this.symbolInstances.get(e);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t, e) {
                const r = t.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e = r.vertexStartIndex; e < n; e += 4)t.indexArray.emplaceBack(e, e + 1, e + 2), t.indexArray.emplaceBack(e + 1, e + 2, e + 3);
            }
            getSortedSymbolIndexes(t) {
                if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e = Math.sin(t), r = Math.cos(t), n = [], i = [], s = [];
                for(let t = 0; t < this.symbolInstances.length; ++t){
                    s.push(t);
                    const a = this.symbolInstances.get(t);
                    n.push(0 | Math.round(e * a.anchorX + r * a.anchorY)), i.push(a.featureIndex);
                }
                return s.sort((t, e)=>n[t] - n[e] || i[e] - i[t]), s;
            }
            addToSortKeyRanges(t, e) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e ? r.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
                    sortKey: e,
                    symbolInstanceStart: t,
                    symbolInstanceEnd: t + 1
                });
            }
            sortFeatures(t) {
                if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t of this.symbolInstanceIndexes){
                        const e = this.symbolInstances.get(t);
                        this.featureSortOrder.push(e.featureIndex), [
                            e.rightJustifiedTextSymbolIndex,
                            e.centerJustifiedTextSymbolIndex,
                            e.leftJustifiedTextSymbolIndex
                        ].forEach((t, e, r)=>{
                            t >= 0 && r.indexOf(t) === e && this.addIndicesForPlacedSymbol(this.text, t);
                        }), e.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e.verticalPlacedTextSymbolIndex), e.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.placedIconSymbolIndex), e.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let dc, yc;
        wi("SymbolBucket", fc, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), fc.MAX_GLYPHS = 65535, fc.addDynamicAttributes = uc;
        var mc = {
            get paint () {
                return yc = yc || new rs({
                    "icon-opacity": new Wi(G.paint_symbol["icon-opacity"]),
                    "icon-color": new Wi(G.paint_symbol["icon-color"]),
                    "icon-halo-color": new Wi(G.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new Wi(G.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new Wi(G.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new Ji(G.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new Ji(G.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new Wi(G.paint_symbol["text-opacity"]),
                    "text-color": new Wi(G.paint_symbol["text-color"], {
                        runtimeType: pt,
                        getOverride: (t)=>t.textColor,
                        hasOverride: (t)=>!!t.textColor
                    }),
                    "text-halo-color": new Wi(G.paint_symbol["text-halo-color"]),
                    "text-halo-width": new Wi(G.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new Wi(G.paint_symbol["text-halo-blur"]),
                    "text-translate": new Ji(G.paint_symbol["text-translate"]),
                    "text-translate-anchor": new Ji(G.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return dc = dc || new rs({
                    "symbol-placement": new Ji(G.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new Ji(G.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new Ji(G.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new Wi(G.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new Ji(G.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new Ji(G.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new Ji(G.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new Ji(G.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new Ji(G.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new Ji(G.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new Wi(G.layout_symbol["icon-size"]),
                    "icon-text-fit": new Ji(G.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new Ji(G.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new Wi(G.layout_symbol["icon-image"]),
                    "icon-rotate": new Wi(G.layout_symbol["icon-rotate"]),
                    "icon-padding": new Wi(G.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new Ji(G.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new Wi(G.layout_symbol["icon-offset"]),
                    "icon-anchor": new Wi(G.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new Ji(G.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new Ji(G.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new Ji(G.layout_symbol["text-rotation-alignment"]),
                    "text-field": new Wi(G.layout_symbol["text-field"]),
                    "text-font": new Wi(G.layout_symbol["text-font"]),
                    "text-size": new Wi(G.layout_symbol["text-size"]),
                    "text-max-width": new Wi(G.layout_symbol["text-max-width"]),
                    "text-line-height": new Ji(G.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new Wi(G.layout_symbol["text-letter-spacing"]),
                    "text-justify": new Wi(G.layout_symbol["text-justify"]),
                    "text-radial-offset": new Wi(G.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new Ji(G.layout_symbol["text-variable-anchor"]),
                    "text-variable-anchor-offset": new Wi(G.layout_symbol["text-variable-anchor-offset"]),
                    "text-anchor": new Wi(G.layout_symbol["text-anchor"]),
                    "text-max-angle": new Ji(G.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new Ji(G.layout_symbol["text-writing-mode"]),
                    "text-rotate": new Wi(G.layout_symbol["text-rotate"]),
                    "text-padding": new Ji(G.layout_symbol["text-padding"]),
                    "text-keep-upright": new Ji(G.layout_symbol["text-keep-upright"]),
                    "text-transform": new Wi(G.layout_symbol["text-transform"]),
                    "text-offset": new Wi(G.layout_symbol["text-offset"]),
                    "text-allow-overlap": new Ji(G.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new Ji(G.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new Ji(G.layout_symbol["text-ignore-placement"]),
                    "text-optional": new Ji(G.layout_symbol["text-optional"])
                });
            }
        };
        class gc {
            constructor(t){
                if (void 0 === t.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t.property.overrides ? t.property.overrides.runtimeType : lt, this.defaultValue = t;
            }
            evaluate(t) {
                if (t.formattedSection) {
                    const e = this.defaultValue.property.overrides;
                    if (e && e.hasOverride(t.formattedSection)) return e.getOverride(t.formattedSection);
                }
                return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t) {
                this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        wi("FormatSectionOverride", gc, {
            omit: [
                "defaultValue"
            ]
        });
        class xc extends is {
            constructor(t){
                super(t, mc);
            }
            recalculate(t, e) {
                if (super.recalculate(t, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const t = this.layout.get("text-writing-mode");
                    if (t) {
                        const e = [];
                        for (const r of t)e.indexOf(r) < 0 && e.push(r);
                        this.layout._values["text-writing-mode"] = e;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t, e, r, n) {
                const i = this.layout.get(t).evaluate(e, {}, r, n), s = this._unevaluatedLayout._values[t];
                return s.isDataDriven() || vn(s.value) || !i ? i : function(t, e) {
                    return e.replace(/{([^{}]+)}/g, (e, r)=>t && r in t ? String(t[r]) : "");
                }(e.properties, i);
            }
            createBucket(t) {
                return new fc(t);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const t of mc.paint.overridableProperties){
                    if (!xc.hasPaintOverride(this.layout, t)) continue;
                    const e = this.paint.get(t), r = new gc(e), n = new xn(r, e.property.specification);
                    let i = null;
                    i = "constant" === e.value.kind || "source" === e.value.kind ? new wn("source", n) : new _n("composite", n, e.value.zoomStops), this.paint._values[t] = new Hi(e.property, i, e.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && xc.hasPaintOverride(this.layout, t);
            }
            static hasPaintOverride(t, e) {
                const r = t.get("text-field"), n = mc.paint.properties[e];
                let i = !1;
                const s = (t)=>{
                    for (const e of t)if (n.overrides && n.overrides.hasOverride(e)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Yt) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t = (e)=>{
                        i || (e instanceof se && ne(e.value) === mt ? s(e.value.sections) : e instanceof Ze ? s(e.sections) : e.eachChild(t));
                    }, e = r.value;
                    e._styleExpression && t(e._styleExpression.expression);
                }
                return i;
            }
        }
        let vc;
        var bc = {
            get paint () {
                return vc = vc || new rs({
                    "background-color": new Ji(G.paint_background["background-color"]),
                    "background-pattern": new ts(G.paint_background["background-pattern"]),
                    "background-opacity": new Ji(G.paint_background["background-opacity"])
                });
            }
        };
        class wc extends is {
            constructor(t){
                super(t, bc);
            }
        }
        let _c;
        var Ac = {
            get paint () {
                return _c = _c || new rs({
                    "raster-opacity": new Ji(G.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new Ji(G.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new Ji(G.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new Ji(G.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new Ji(G.paint_raster["raster-saturation"]),
                    "raster-contrast": new Ji(G.paint_raster["raster-contrast"]),
                    "raster-resampling": new Ji(G.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new Ji(G.paint_raster["raster-fade-duration"])
                });
            }
        };
        class Sc extends is {
            constructor(t){
                super(t, Ac);
            }
        }
        class kc extends is {
            constructor(t){
                super(t, {}), this.onAdd = (t)=>{
                    this.implementation.onAdd && this.implementation.onAdd(t, t.painter.context.gl);
                }, this.onRemove = (t)=>{
                    this.implementation.onRemove && this.implementation.onRemove(t, t.painter.context.gl);
                }, this.implementation = t;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
        }
        class Mc {
            constructor(t){
                this._methodToThrottle = t, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._methodToThrottle();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._methodToThrottle();
                }, 0));
            }
            remove() {
                delete this._channel, this._methodToThrottle = ()=>{};
            }
        }
        const Ic = 6371008.8;
        class zc {
            constructor(t, e){
                if (isNaN(t) || isNaN(e)) throw new Error(`Invalid LngLat object: (${t}, ${e})`);
                if (this.lng = +t, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new zc(m(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t) {
                const e = Math.PI / 180, r = this.lat * e, n = t.lat * e, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t.lng - this.lng) * e);
                return Ic * Math.acos(Math.min(i, 1));
            }
            static convert(t) {
                if (t instanceof zc) return t;
                if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new zc(Number(t[0]), Number(t[1]));
                if (!Array.isArray(t) && "object" == typeof t && null !== t) return new zc(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        const Pc = 2 * Math.PI * Ic;
        function Cc(t) {
            return Pc * Math.cos(t * Math.PI / 180);
        }
        function Bc(t) {
            return (180 + t) / 360;
        }
        function Vc(t) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
        }
        function Ec(t, e) {
            return t / Cc(e);
        }
        function Fc(t) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
        }
        class Tc {
            constructor(t, e, r = 0){
                this.x = +t, this.y = +e, this.z = +r;
            }
            static fromLngLat(t, e = 0) {
                const r = zc.convert(t);
                return new Tc(Bc(r.lng), Vc(r.lat), Ec(e, r.lat));
            }
            toLngLat() {
                return new zc(360 * this.x - 180, Fc(this.y));
            }
            toAltitude() {
                return this.z * Cc(Fc(this.y));
            }
            meterInMercatorCoordinateUnits() {
                var t;
                return 1 / Pc * (t = Fc(this.y), 1 / Math.cos(t * Math.PI / 180));
            }
        }
        function $c(t, e, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t * n - 2 * Math.PI * 6378137 / 2,
                e * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class Lc {
            constructor(t, e, r){
                if (!function(t, e, r) {
                    return !(t < 0 || t > 25 || r < 0 || r >= Math.pow(2, t) || e < 0 || e >= Math.pow(2, t));
                }(t, e, r)) throw new Error(`x=${e}, y=${r}, z=${t} outside of bounds. 0<=x<${Math.pow(2, t)}, 0<=y<${Math.pow(2, t)} 0<=z<=25 `);
                this.z = t, this.x = e, this.y = r, this.key = jc(0, t, t, e, r);
            }
            equals(t) {
                return this.z === t.z && this.x === t.x && this.y === t.y;
            }
            url(t, e, r) {
                const n = (s = this.y, a = this.z, o = $c(256 * (i = this.x), 256 * (s = Math.pow(2, a) - s - 1), a), l = $c(256 * (i + 1), 256 * (s + 1), a), o[0] + "," + o[1] + "," + l[0] + "," + l[1]);
                var i, s, a, o, l;
                const u = function(t, e, r) {
                    let n, i = "";
                    for(let s = t; s > 0; s--)n = 1 << s - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t[(this.x + this.y) % t.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, n);
            }
            isChildOf(t) {
                const e = this.z - t.z;
                return e > 0 && t.x === this.x >> e && t.y === this.y >> e;
            }
            getTilePoint(t) {
                const e = Math.pow(2, this.z);
                return new s((t.x * e - this.x) * $a, (t.y * e - this.y) * $a);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Dc {
            constructor(t, e){
                this.wrap = t, this.canonical = e, this.key = jc(t, e.z, e.z, e.x, e.y);
            }
        }
        class Oc {
            constructor(t, e, r, n, i){
                if (t < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t}; z = ${r}`);
                this.overscaledZ = t, this.wrap = e, this.canonical = new Lc(r, +n, +i), this.key = jc(e, t, r, n, i);
            }
            clone() {
                return new Oc(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(t) {
                return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
            }
            scaledTo(t) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const e = this.canonical.z - t;
                return t > this.canonical.z ? new Oc(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Oc(t, this.wrap, t, this.canonical.x >> e, this.canonical.y >> e);
            }
            calculateScaledKey(t, e) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const r = this.canonical.z - t;
                return t > this.canonical.z ? jc(this.wrap * +e, t, this.canonical.z, this.canonical.x, this.canonical.y) : jc(this.wrap * +e, t, t, this.canonical.x >> r, this.canonical.y >> r);
            }
            isChildOf(t) {
                if (t.wrap !== this.wrap) return !1;
                const e = this.canonical.z - t.canonical.z;
                return 0 === t.overscaledZ || t.overscaledZ < this.overscaledZ && t.canonical.x === this.canonical.x >> e && t.canonical.y === this.canonical.y >> e;
            }
            children(t) {
                if (this.overscaledZ >= t) return [
                    new Oc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new Oc(e, this.wrap, e, r, n),
                    new Oc(e, this.wrap, e, r + 1, n),
                    new Oc(e, this.wrap, e, r, n + 1),
                    new Oc(e, this.wrap, e, r + 1, n + 1)
                ];
            }
            isLessThan(t) {
                return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
            }
            wrapped() {
                return new Oc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t) {
                return new Oc(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Dc(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(t) {
                return this.canonical.getTilePoint(new Tc(t.x - this.wrap, t.y));
            }
        }
        function jc(t, e, r, n, i) {
            (t *= 2) < 0 && (t = -1 * t - 1);
            const s = 1 << r;
            return (s * s * t + s * i + n).toString(36) + r.toString(36) + e.toString(36);
        }
        wi("CanonicalTileID", Lc), wi("OverscaledTileID", Oc, {
            omit: [
                "posMatrix"
            ]
        });
        class Rc {
            constructor(t, e, r, n = 1, i = 1, s = 1, a = 0){
                if (this.uid = t, e.height !== e.width) throw new RangeError("DEM tiles must be square");
                if (r && ![
                    "mapbox",
                    "terrarium",
                    "custom"
                ].includes(r)) return void A(`"${r}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                this.stride = e.height;
                const o = this.dim = e.height - 2;
                switch(this.data = new Uint32Array(e.data.buffer), r){
                    case "terrarium":
                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                        break;
                    case "custom":
                        this.redFactor = n, this.greenFactor = i, this.blueFactor = s, this.baseShift = a;
                        break;
                    default:
                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                }
                for(let t = 0; t < o; t++)this.data[this._idx(-1, t)] = this.data[this._idx(0, t)], this.data[this._idx(o, t)] = this.data[this._idx(o - 1, t)], this.data[this._idx(t, -1)] = this.data[this._idx(t, 0)], this.data[this._idx(t, o)] = this.data[this._idx(t, o - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(o, -1)] = this.data[this._idx(o - 1, 0)], this.data[this._idx(-1, o)] = this.data[this._idx(0, o - 1)], this.data[this._idx(o, o)] = this.data[this._idx(o - 1, o - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let t = 0; t < o; t++)for(let e = 0; e < o; e++){
                    const r = this.get(t, e);
                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                }
            }
            get(t, e) {
                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t, e);
                return this.unpack(r[n], r[n + 1], r[n + 2]);
            }
            getUnpackVector() {
                return [
                    this.redFactor,
                    this.greenFactor,
                    this.blueFactor,
                    this.baseShift
                ];
            }
            _idx(t, e) {
                if (t < -1 || t >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e + 1) * this.stride + (t + 1);
            }
            unpack(t, e, r) {
                return t * this.redFactor + e * this.greenFactor + r * this.blueFactor - this.baseShift;
            }
            getPixels() {
                return new Ao({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(t, e, r) {
                if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
                let n = e * this.dim, i = e * this.dim + this.dim, s = r * this.dim, a = r * this.dim + this.dim;
                switch(e){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = a - 1;
                        break;
                    case 1:
                        a = s + 1;
                }
                const o = -e * this.dim, l = -r * this.dim;
                for(let e = s; e < a; e++)for(let r = n; r < i; r++)this.data[this._idx(r, e)] = t.data[this._idx(r + o, e + l)];
            }
        }
        wi("DEMData", Rc);
        class Uc {
            constructor(t){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    this._stringToNumber[r] = e, this._numberToString[e] = r;
                }
            }
            encode(t) {
                return this._stringToNumber[t];
            }
            decode(t) {
                if (t >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[t];
            }
        }
        class qc {
            constructor(t, e, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t, t._z = e, t._x = r, t._y = n, this.properties = t.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
            }
            set geometry(t) {
                this._geometry = t;
            }
            toJSON() {
                const t = {
                    geometry: this.geometry
                };
                for(const e in this)"_geometry" !== e && "_vectorTileFeature" !== e && (t[e] = this[e]);
                return t;
            }
        }
        class Nc {
            constructor(t, e){
                this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new vi($a, 16, 0), this.grid3D = new vi($a, 16, 0), this.featureIndexArray = new Ns, this.promoteId = e;
            }
            insert(t, e, r, n, i, s) {
                const a = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i);
                const o = s ? this.grid3D : this.grid;
                for(let t = 0; t < e.length; t++){
                    const r = e[t], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t = 0; t < r.length; t++){
                        const e = r[t];
                        n[0] = Math.min(n[0], e.x), n[1] = Math.min(n[1], e.y), n[2] = Math.max(n[2], e.x), n[3] = Math.max(n[3], e.y);
                    }
                    n[0] < $a && n[1] < $a && n[2] >= 0 && n[3] >= 0 && o.insert(a, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = new pl.VectorTile(new Mu(this.rawTileData)).layers, this.sourceLayerCoder = new Uc(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    "_geojsonTileLayer"
                ])), this.vtLayers;
            }
            query(t, e, r, n) {
                this.loadVTLayers();
                const i = t.params || {}, a = $a / t.tileSize / t.scale, o = zn(i.filter), l = t.queryGeometry, u = t.queryPadding * a, c = Gc(l), h = this.grid.query(c.minX - u, c.minY - u, c.maxX + u, c.maxY + u), p = Gc(t.cameraQueryGeometry), f = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, (e, r, n, i)=>(function(t, e, r, n, i) {
                        for (const s of t)if (e <= s.x && r <= s.y && n >= s.x && i >= s.y) return !0;
                        const a = [
                            new s(e, r),
                            new s(e, i),
                            new s(n, i),
                            new s(n, r)
                        ];
                        if (t.length > 2) {
                            for (const e of a)if (Wa(t, e)) return !0;
                        }
                        for(let e = 0; e < t.length - 1; e++)if (Qa(t[e], t[e + 1], a)) return !0;
                        return !1;
                    })(t.cameraQueryGeometry, e - u, r - u, n + u, i + u));
                for (const t of f)h.push(t);
                h.sort(Kc);
                const d = {};
                let y;
                for(let s = 0; s < h.length; s++){
                    const u = h[s];
                    if (u === y) continue;
                    y = u;
                    const c = this.featureIndexArray.get(u);
                    let p = null;
                    this.loadMatchingFeature(d, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, o, i.layers, i.availableImages, e, r, n, (e, r, n)=>(p || (p = Oa(e)), r.queryIntersectsFeature(l, e, n, p, this.z, t.transform, a, t.pixelPosMatrix)));
                }
                return d;
            }
            loadMatchingFeature(t, e, r, n, i, s, a, o, l, u, c) {
                const h = this.bucketLayerIDs[e];
                if (s && !function(t, e) {
                    for(let r = 0; r < t.length; r++)if (e.indexOf(t[r]) >= 0) return !0;
                    return !1;
                }(s, h)) return;
                const p = this.sourceLayerCoder.decode(r), f = this.vtLayers[p].feature(n);
                if (i.needGeometry) {
                    const t = ja(f, !0);
                    if (!i.filter(new Ui(this.tileID.overscaledZ), t, this.tileID.canonical)) return;
                } else if (!i.filter(new Ui(this.tileID.overscaledZ), f)) return;
                const d = this.getId(f, p);
                for(let e = 0; e < h.length; e++){
                    const r = h[e];
                    if (s && s.indexOf(r) < 0) continue;
                    const i = o[r];
                    if (!i) continue;
                    let p = {};
                    d && u && (p = u.getState(i.sourceLayer || "_geojsonTileLayer", d));
                    const y = g({}, l[r]);
                    y.paint = Zc(y.paint, i.paint, f, p, a), y.layout = Zc(y.layout, i.layout, f, p, a);
                    const m = !c || c(f, i, p);
                    if (!m) continue;
                    const x = new qc(f, this.z, this.x, this.y, d);
                    x.layer = y;
                    let v = t[r];
                    void 0 === v && (v = t[r] = []), v.push({
                        featureIndex: n,
                        feature: x,
                        intersectionZ: m
                    });
                }
            }
            lookupSymbolFeatures(t, e, r, n, i, s, a, o) {
                const l = {};
                this.loadVTLayers();
                const u = zn(i);
                for (const i of t)this.loadMatchingFeature(l, r, n, i, u, s, a, o, e);
                return l;
            }
            hasLayer(t) {
                for (const e of this.bucketLayerIDs)for (const r of e)if (t === r) return !0;
                return !1;
            }
            getId(t, e) {
                let r = t.id;
                return this.promoteId && (r = t.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e]], "boolean" == typeof r && (r = Number(r))), r;
            }
        }
        function Zc(t, e, r, n, i) {
            return v(t, (t, s)=>{
                const a = e instanceof Yi ? e.get(s) : null;
                return a && a.evaluate ? a.evaluate(r, n, i) : a;
            });
        }
        function Gc(t) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of t)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return {
                minX: e,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function Kc(t, e) {
            return e - t;
        }
        function Xc(t, e, r, n, i) {
            const a = [];
            for(let o = 0; o < t.length; o++){
                const l = t[o];
                let u;
                for(let t = 0; t < l.length - 1; t++){
                    let o = l[t], c = l[t + 1];
                    o.x < e && c.x < e || (o.x < e ? o = new s(e, o.y + (e - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x < e && (c = new s(e, o.y + (e - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y < r && c.y < r || (o.y < r ? o = new s(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round() : c.y < r && (c = new s(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round()), o.x >= n && c.x >= n || (o.x >= n ? o = new s(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x >= n && (c = new s(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y >= i && c.y >= i || (o.y >= i ? o = new s(o.x + (i - o.y) / (c.y - o.y) * (c.x - o.x), i)._round() : c.y >= i && (c = new s(o.x + (i - o.y) / (c.y - o.y) * (c.x - o.x), i)._round()), u && o.equals(u[u.length - 1]) || (u = [
                        o
                    ], a.push(u)), u.push(c)))));
                }
            }
            return a;
        }
        wi("FeatureIndex", Nc, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class Hc extends s {
            constructor(t, e, r, n){
                super(t, e), this.angle = r, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new Hc(this.x, this.y, this.angle, this.segment);
            }
        }
        function Yc(t, e, r, n, i) {
            if (void 0 === e.segment || 0 === r) return !0;
            let s = e, a = e.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (a--, a < 0) return !1;
                o -= t[a].dist(s), s = t[a];
            }
            o += t[a].dist(t[a + 1]), a++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e = t[a], r = t[a + 1];
                if (!r) return !1;
                let s = t[a - 1].angleTo(e) - e.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: s
                }), u += s; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                a++, o += e.dist(r);
            }
            return !0;
        }
        function Jc(t) {
            let e = 0;
            for(let r = 0; r < t.length - 1; r++)e += t[r].dist(t[r + 1]);
            return e;
        }
        function Wc(t, e, r) {
            return t ? .6 * e * r : 0;
        }
        function Qc(t, e) {
            return Math.max(t ? t.right - t.left : 0, e ? e.right - e.left : 0);
        }
        function th(t, e, r, n, i, s) {
            const a = Wc(r, i, s), o = Qc(r, n) * s;
            let l = 0;
            const u = Jc(t) / 2;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = Ce.number(n.x, i.x, c), p = Ce.number(n.y, i.y, c), f = new Hc(h, p, i.angleTo(n), r);
                    return f._round(), !a || Yc(t, f, o, a, e) ? f : void 0;
                }
                l += s;
            }
        }
        function eh(t, e, r, n, i, s, a, o, l) {
            const u = Wc(n, s, a), c = Qc(n, i), h = c * a, p = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
            return e - h < e / 4 && (e = h + e / 4), rh(t, p ? e / 2 * o % e : (c / 2 + 2 * s) * a * o % e, e, u, r, h, p, !1, l);
        }
        function rh(t, e, r, n, i, s, a, o, l) {
            const u = s / 2, c = Jc(t);
            let h = 0, p = e - r, f = [];
            for(let e = 0; e < t.length - 1; e++){
                const a = t[e], o = t[e + 1], d = a.dist(o), y = o.angleTo(a);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = Ce.number(a.x, o.x, m), x = Ce.number(a.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new Hc(g, x, y, e);
                        r._round(), n && !Yc(t, r, s, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || a || (f = rh(t, h / 2, r, n, i, s, a, !0, l)), f;
        }
        wi("Anchor", Hc);
        const nh = Eu;
        function ih(t, e, r, n) {
            const i = [], a = t.image, o = a.pixelRatio, l = a.paddedRect.w - 2 * nh, u = a.paddedRect.h - 2 * nh;
            let c = {
                x1: t.left,
                y1: t.top,
                x2: t.right,
                y2: t.bottom
            };
            const h = a.stretchX || [
                [
                    0,
                    l
                ]
            ], p = a.stretchY || [
                [
                    0,
                    u
                ]
            ], f = (t, e)=>t + e[1] - e[0], d = h.reduce(f, 0), y = p.reduce(f, 0), m = l - d, g = u - y;
            let x = 0, v = d, b = 0, w = y, _ = 0, A = m, S = 0, k = g;
            if (a.content && n) {
                const e = a.content, r = e[2] - e[0], n = e[3] - e[1];
                (a.textFitWidth || a.textFitHeight) && (c = Qu(t)), x = sh(h, 0, e[0]), b = sh(p, 0, e[1]), v = sh(h, e[0], e[2]), w = sh(p, e[1], e[3]), _ = e[0] - x, S = e[1] - b, A = r - v, k = n - w;
            }
            const M = c.x1, I = c.y1, z = c.x2 - M, P = c.y2 - I, C = (t, n, i, l)=>{
                const u = oh(t.stretch - x, v, z, M), c = lh(t.fixed - _, A, t.stretch, d), h = oh(n.stretch - b, w, P, I), p = lh(n.fixed - S, k, n.stretch, y), f = oh(i.stretch - x, v, z, M), m = lh(i.fixed - _, A, i.stretch, d), g = oh(l.stretch - b, w, P, I), C = lh(l.fixed - S, k, l.stretch, y), B = new s(u, h), V = new s(f, h), E = new s(f, g), F = new s(u, g), T = new s(c / o, p / o), $ = new s(m / o, C / o), L = e * Math.PI / 180;
                if (L) {
                    const t = Math.sin(L), e = Math.cos(L), r = [
                        e,
                        -t,
                        t,
                        e
                    ];
                    B._matMult(r), V._matMult(r), F._matMult(r), E._matMult(r);
                }
                const D = t.stretch + t.fixed, O = n.stretch + n.fixed;
                return {
                    tl: B,
                    tr: V,
                    bl: F,
                    br: E,
                    tex: {
                        x: a.paddedRect.x + nh + D,
                        y: a.paddedRect.y + nh + O,
                        w: i.stretch + i.fixed - D,
                        h: l.stretch + l.fixed - O
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: T,
                    pixelOffsetBR: $,
                    minFontScaleX: A / o / z,
                    minFontScaleY: k / o / P,
                    isSDF: r
                };
            };
            if (n && (a.stretchX || a.stretchY)) {
                const t = ah(h, m, d), e = ah(p, g, y);
                for(let r = 0; r < t.length - 1; r++){
                    const n = t[r], s = t[r + 1];
                    for(let t = 0; t < e.length - 1; t++)i.push(C(n, e[t], s, e[t + 1]));
                }
            } else i.push(C({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return i;
        }
        function sh(t, e, r) {
            let n = 0;
            for (const i of t)n += Math.max(e, Math.min(r, i[1])) - Math.max(e, Math.min(r, i[0]));
            return n;
        }
        function ah(t, e, r) {
            const n = [
                {
                    fixed: -nh,
                    stretch: 0
                }
            ];
            for (const [e, r] of t){
                const t = n[n.length - 1];
                n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch
                }), n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch + (r - e)
                });
            }
            return n.push({
                fixed: e + nh,
                stretch: r
            }), n;
        }
        function oh(t, e, r, n) {
            return t / e * r + n;
        }
        function lh(t, e, r, n) {
            return t - e * r / n;
        }
        class uh {
            constructor(t, e, r, n, i, a, o, l, u, c){
                var h;
                if (this.boxStartIndex = t.length, u) {
                    let t = a.top, e = a.bottom;
                    const r = a.collisionPadding;
                    r && (t -= r[1], e += r[3]);
                    let n = e - t;
                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                } else {
                    const u = (null === (h = a.image) || void 0 === h ? void 0 : h.content) && (a.image.textFitWidth || a.image.textFitHeight) ? Qu(a) : {
                        x1: a.left,
                        y1: a.top,
                        x2: a.right,
                        y2: a.bottom
                    };
                    u.y1 = u.y1 * o - l[0], u.y2 = u.y2 * o + l[2], u.x1 = u.x1 * o - l[3], u.x2 = u.x2 * o + l[1];
                    const p = a.collisionPadding;
                    if (p && (u.x1 -= p[0] * o, u.y1 -= p[1] * o, u.x2 += p[2] * o, u.y2 += p[3] * o), c) {
                        const t = new s(u.x1, u.y1), e = new s(u.x2, u.y1), r = new s(u.x1, u.y2), n = new s(u.x2, u.y2), i = c * Math.PI / 180;
                        t._rotate(i), e._rotate(i), r._rotate(i), n._rotate(i), u.x1 = Math.min(t.x, e.x, r.x, n.x), u.x2 = Math.max(t.x, e.x, r.x, n.x), u.y1 = Math.min(t.y, e.y, r.y, n.y), u.y2 = Math.max(t.y, e.y, r.y, n.y);
                    }
                    t.emplaceBack(e.x, e.y, u.x1, u.y1, u.x2, u.y2, r, n, i);
                }
                this.boxEndIndex = t.length;
            }
        }
        class ch {
            constructor(t = [], e = (t, e)=>t < e ? -1 : t > e ? 1 : 0){
                if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e = this.data.pop();
                return --this.length > 0 && (this.data[0] = e, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e, compare: r } = this, n = e[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, s = e[i];
                    if (r(n, s) >= 0) break;
                    e[t] = s, t = i;
                }
                e[t] = n;
            }
            _down(t) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t];
                for(; t < n;){
                    let n = 1 + (t << 1);
                    const s = n + 1;
                    if (s < this.length && r(e[s], e[n]) < 0 && (n = s), r(e[n], i) >= 0) break;
                    e[t] = e[n], t = n;
                }
                e[t] = i;
            }
        }
        function hh(t, e = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, a = -1 / 0, o = -1 / 0;
            const l = t[0];
            for(let t = 0; t < l.length; t++){
                const e = l[t];
                (!t || e.x < n) && (n = e.x), (!t || e.y < i) && (i = e.y), (!t || e.x > a) && (a = e.x), (!t || e.y > o) && (o = e.y);
            }
            const u = Math.min(a - n, o - i);
            let c = u / 2;
            const h = new ch([], ph);
            if (0 === u) return new s(n, i);
            for(let e = n; e < a; e += u)for(let r = i; r < o; r += u)h.push(new fh(e + c, r + c, c, t));
            let p = function(t) {
                let e = 0, r = 0, n = 0;
                const i = t[0];
                for(let t = 0, s = i.length, a = s - 1; t < s; a = t++){
                    const s = i[t], o = i[a], l = s.x * o.y - o.x * s.y;
                    r += (s.x + o.x) * l, n += (s.y + o.y) * l, e += 3 * l;
                }
                return new fh(r / e, n / e, 0, t);
            }(t), f = h.length;
            for(; h.length;){
                const n = h.pop();
                (n.d > p.d || !p.d) && (p = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, f)), n.max - p.d <= e || (c = n.h / 2, h.push(new fh(n.p.x - c, n.p.y - c, c, t)), h.push(new fh(n.p.x + c, n.p.y - c, c, t)), h.push(new fh(n.p.x - c, n.p.y + c, c, t)), h.push(new fh(n.p.x + c, n.p.y + c, c, t)), f += 4);
            }
            return r && (console.log(`num probes: ${f}`), console.log(`best distance: ${p.d}`)), p.p;
        }
        function ph(t, e) {
            return e.max - t.max;
        }
        function fh(t, e, r, n) {
            this.p = new s(t, e), this.h = r, this.d = function(t, e) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e.length; i++){
                    const s = e[i];
                    for(let e = 0, i = s.length, a = i - 1; e < i; a = e++){
                        const i = s[e], o = s[a];
                        i.y > t.y != o.y > t.y && t.x < (o.x - i.x) * (t.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, Ya(t, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        var dh;
        t.aq = void 0, (dh = t.aq || (t.aq = {}))[dh.center = 1] = "center", dh[dh.left = 2] = "left", dh[dh.right = 3] = "right", dh[dh.top = 4] = "top", dh[dh.bottom = 5] = "bottom", dh[dh["top-left"] = 6] = "top-left", dh[dh["top-right"] = 7] = "top-right", dh[dh["bottom-left"] = 8] = "bottom-left", dh[dh["bottom-right"] = 9] = "bottom-right";
        const yh = 7, mh = Number.POSITIVE_INFINITY;
        function gh(t, e) {
            return e[1] !== mh ? function(t, e, r) {
                let n = 0, i = 0;
                switch(e = Math.abs(e), r = Math.abs(r), t){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - yh;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = -r + yh;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e;
                }
                return [
                    n,
                    i
                ];
            }(t, e[0], e[1]) : function(t, e) {
                let r = 0, n = 0;
                e < 0 && (e = 0);
                const i = e / Math.SQRT2;
                switch(t){
                    case "top-right":
                    case "top-left":
                        n = i - yh;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = -i + yh;
                        break;
                    case "bottom":
                        n = -e + yh;
                        break;
                    case "top":
                        n = e - yh;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e;
                        break;
                    case "right":
                        r = -e;
                }
                return [
                    r,
                    n
                ];
            }(t, e[0]);
        }
        function xh(t, e, r) {
            var n;
            const i = t.layout, s = null === (n = i.get("text-variable-anchor-offset")) || void 0 === n ? void 0 : n.evaluate(e, {}, r);
            if (s) {
                const t = s.values, e = [];
                for(let r = 0; r < t.length; r += 2){
                    const n = e[r] = t[r], i = t[r + 1].map((t)=>t * nu);
                    n.startsWith("top") ? i[1] -= yh : n.startsWith("bottom") && (i[1] += yh), e[r + 1] = i;
                }
                return new Qt(e);
            }
            const a = i.get("text-variable-anchor");
            if (a) {
                let n;
                n = void 0 !== t._unevaluatedLayout.getValue("text-radial-offset") ? [
                    i.get("text-radial-offset").evaluate(e, {}, r) * nu,
                    mh
                ] : i.get("text-offset").evaluate(e, {}, r).map((t)=>t * nu);
                const s = [];
                for (const t of a)s.push(t, gh(t, n));
                return new Qt(s);
            }
            return null;
        }
        function vh(t) {
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function bh(e, r, n, i, s, a, o, l, u, c, h) {
            let p = a.textMaxSize.evaluate(r, {});
            void 0 === p && (p = o);
            const f = e.layers[0].layout, d = f.get("icon-offset").evaluate(r, {}, h), y = _h(n.horizontal), m = o / 24, g = e.tilePixelRatio * m, x = e.tilePixelRatio * p / 24, v = e.tilePixelRatio * l, b = e.tilePixelRatio * f.get("symbol-spacing"), w = f.get("text-padding") * e.tilePixelRatio, _ = function(t, e, r, n = 1) {
                const i = t.get("icon-padding").evaluate(e, {}, r), s = i && i.values;
                return [
                    s[0] * n,
                    s[1] * n,
                    s[2] * n,
                    s[3] * n
                ];
            }(f, r, h, e.tilePixelRatio), S = f.get("text-max-angle") / 180 * Math.PI, k = "viewport" !== f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), M = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement"), I = f.get("symbol-placement"), z = b / 2, P = f.get("icon-text-fit");
            let C;
            i && "none" !== P && (e.allowVerticalPlacement && n.vertical && (C = tc(i, n.vertical, P, f.get("icon-text-fit-padding"), d, m)), y && (i = tc(i, y, P, f.get("icon-text-fit-padding"), d, m)));
            const B = (l, p)=>{
                p.x < 0 || p.x >= $a || p.y < 0 || p.y >= $a || function(e, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, k, M) {
                    const I = e.addToLineVertexArray(r, n);
                    let z, P, C, B, V = 0, E = 0, F = 0, T = 0, $ = -1, L = -1;
                    const D = {};
                    let O = ma("");
                    if (e.allowVerticalPlacement && i.vertical) {
                        const t = l.layout.get("text-rotate").evaluate(w, {}, k) + 90;
                        C = new uh(u, r, c, h, p, i.vertical, f, d, y, t), o && (B = new uh(u, r, c, h, p, o, g, x, y, t));
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(w, {}), i = "none" !== l.layout.get("icon-text-fit"), a = ih(s, n, S, i), f = o ? ih(o, n, S, i) : void 0;
                        P = new uh(u, r, c, h, p, s, g, x, !1, n), V = 4 * a.length;
                        const d = e.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            rc * l.layout.get("icon-size").evaluate(w, {})
                        ], y[0] > nc && A(`${e.layerIds[0]}: Value for "icon-size" is >= ${ec}. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            rc * _.compositeIconSizes[0].evaluate(w, {}, k),
                            rc * _.compositeIconSizes[1].evaluate(w, {}, k)
                        ], (y[0] > nc || y[1] > nc) && A(`${e.layerIds[0]}: Value for "icon-size" is >= ${ec}. Reduce your "icon-size".`)), e.addSymbols(e.icon, a, y, b, v, w, t.ah.none, r, I.lineStartIndex, I.lineLength, -1, k), $ = e.icon.placedSymbolArray.length - 1, f && (E = 4 * f.length, e.addSymbols(e.icon, f, y, b, v, w, t.ah.vertical, r, I.lineStartIndex, I.lineLength, -1, k), L = e.icon.placedSymbolArray.length - 1);
                    }
                    const j = Object.keys(i.horizontal);
                    for (const n of j){
                        const s = i.horizontal[n];
                        if (!z) {
                            O = ma(s.text);
                            const t = l.layout.get("text-rotate").evaluate(w, {}, k);
                            z = new uh(u, r, c, h, p, s, f, d, y, t);
                        }
                        const o = 1 === s.positionedLines.length;
                        if (F += wh(e, r, s, a, l, y, w, m, I, i.vertical ? t.ah.horizontal : t.ah.horizontalOnly, o ? j : [
                            n
                        ], D, $, _, k), o) break;
                    }
                    i.vertical && (T += wh(e, r, i.vertical, a, l, y, w, m, I, t.ah.vertical, [
                        "vertical"
                    ], D, L, _, k));
                    const R = z ? z.boxStartIndex : e.collisionBoxArray.length, U = z ? z.boxEndIndex : e.collisionBoxArray.length, q = C ? C.boxStartIndex : e.collisionBoxArray.length, N = C ? C.boxEndIndex : e.collisionBoxArray.length, Z = P ? P.boxStartIndex : e.collisionBoxArray.length, G = P ? P.boxEndIndex : e.collisionBoxArray.length, K = B ? B.boxStartIndex : e.collisionBoxArray.length, X = B ? B.boxEndIndex : e.collisionBoxArray.length;
                    let H = -1;
                    const Y = (t, e)=>t && t.circleDiameter ? Math.max(t.circleDiameter, e) : e;
                    H = Y(z, H), H = Y(C, H), H = Y(P, H), H = Y(B, H);
                    const J = H > -1 ? 1 : 0;
                    J && (H *= M / nu), e.glyphOffsetArray.length >= fc.MAX_GLYPHS && A("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w.sortKey && e.addToSortKeyRanges(e.symbolInstances.length, w.sortKey);
                    const W = xh(l, w, k), [Q, tt] = function(e, r) {
                        const n = e.length, i = null == r ? void 0 : r.values;
                        if ((null == i ? void 0 : i.length) > 0) for(let r = 0; r < i.length; r += 2){
                            const n = i[r + 1];
                            e.emplaceBack(t.aq[i[r]], n[0], n[1]);
                        }
                        return [
                            n,
                            e.length
                        ];
                    }(e.textAnchorOffsets, W);
                    e.symbolInstances.emplaceBack(r.x, r.y, D.right >= 0 ? D.right : -1, D.center >= 0 ? D.center : -1, D.left >= 0 ? D.left : -1, D.vertical || -1, $, L, O, R, U, q, N, Z, G, K, X, c, F, T, V, E, J, 0, f, H, Q, tt);
                }(e, p, l, n, i, s, C, e.layers[0], e.collisionBoxArray, r.index, r.sourceLayerIndex, e.index, g, [
                    w,
                    w,
                    w,
                    w
                ], k, u, v, _, M, d, r, a, c, h, o);
            };
            if ("line" === I) for (const t of Xc(r.geometry, 0, 0, $a, $a)){
                const r = eh(t, b, S, n.vertical || y, i, 24, x, e.overscaling, $a);
                for (const n of r)y && Ah(e, y.text, z, n) || B(t, n);
            }
            else if ("line-center" === I) {
                for (const t of r.geometry)if (t.length > 1) {
                    const e = th(t, S, n.vertical || y, i, 24, x);
                    e && B(t, e);
                }
            } else if ("Polygon" === r.type) for (const t of xr(r.geometry, 0)){
                const e = hh(t, 16);
                B(t[0], new Hc(e.x, e.y, 0));
            }
            else if ("LineString" === r.type) for (const t of r.geometry)B(t, new Hc(t[0].x, t[0].y, 0));
            else if ("Point" === r.type) for (const t of r.geometry)for (const e of t)B([
                e
            ], new Hc(e.x, e.y, 0));
        }
        function wh(t, e, r, n, i, a, o, l, u, c, h, p, f, d, y) {
            const m = function(t, e, r, n, i, a, o, l) {
                const u = n.layout.get("text-rotate").evaluate(a, {}) * Math.PI / 180, c = [];
                for (const t of e.positionedLines)for (const n of t.positionedGlyphs){
                    if (!n.rect) continue;
                    const a = n.rect || {};
                    let h = Bu + 1, p = !0, f = 1, d = 0;
                    const y = (i || l) && n.vertical, m = n.metrics.advance * n.scale / 2;
                    if (l && e.verticalizable && (d = t.lineOffset / 2 - (n.imageName ? -(nu - n.metrics.width * n.scale) / 2 : (n.scale - 1) * nu)), n.imageName) {
                        const t = o[n.imageName];
                        p = t.sdf, f = t.pixelRatio, h = Eu / f;
                    }
                    const g = i ? [
                        n.x + m,
                        n.y
                    ] : [
                        0,
                        0
                    ];
                    let x = i ? [
                        0,
                        0
                    ] : [
                        n.x + m + r[0],
                        n.y + r[1] - d
                    ], v = [
                        0,
                        0
                    ];
                    y && (v = x, x = [
                        0,
                        0
                    ]);
                    const b = n.metrics.isDoubleResolution ? 2 : 1, w = (n.metrics.left - h) * n.scale - m + x[0], _ = (-n.metrics.top - h) * n.scale + x[1], A = w + a.w / b * n.scale / f, S = _ + a.h / b * n.scale / f, k = new s(w, _), M = new s(A, _), I = new s(w, S), z = new s(A, S);
                    if (y) {
                        const t = new s(-m, m - Lu), e = -Math.PI / 2, r = nu / 2 - m, i = new s(5 - Lu - r, -(n.imageName ? r : 0)), a = new s(...v);
                        k._rotateAround(e, t)._add(i)._add(a), M._rotateAround(e, t)._add(i)._add(a), I._rotateAround(e, t)._add(i)._add(a), z._rotateAround(e, t)._add(i)._add(a);
                    }
                    if (u) {
                        const t = Math.sin(u), e = Math.cos(u), r = [
                            e,
                            -t,
                            t,
                            e
                        ];
                        k._matMult(r), M._matMult(r), I._matMult(r), z._matMult(r);
                    }
                    const P = new s(0, 0), C = new s(0, 0);
                    c.push({
                        tl: k,
                        tr: M,
                        bl: I,
                        br: z,
                        tex: a,
                        writingMode: e.writingMode,
                        glyphOffset: g,
                        sectionIndex: n.sectionIndex,
                        isSDF: p,
                        pixelOffsetTL: P,
                        pixelOffsetBR: C,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return c;
            }(0, r, l, i, a, o, n, t.allowVerticalPlacement), g = t.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                rc * i.layout.get("text-size").evaluate(o, {})
            ], x[0] > nc && A(`${t.layerIds[0]}: Value for "text-size" is >= ${ec}. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                rc * d.compositeTextSizes[0].evaluate(o, {}, y),
                rc * d.compositeTextSizes[1].evaluate(o, {}, y)
            ], (x[0] > nc || x[1] > nc) && A(`${t.layerIds[0]}: Value for "text-size" is >= ${ec}. Reduce your "text-size".`)), t.addSymbols(t.text, m, x, l, a, o, c, e, u.lineStartIndex, u.lineLength, f, y);
            for (const e of h)p[e] = t.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function _h(t) {
            for(const e in t)return t[e];
            return null;
        }
        function Ah(t, e, r, n) {
            const i = t.compareText;
            if (e in i) {
                const t = i[e];
                for(let e = t.length - 1; e >= 0; e--)if (n.dist(t[e]) < r) return !0;
            } else i[e] = [];
            return i[e].push(n), !1;
        }
        const Sh = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class kh {
            static from(t) {
                if (!(t instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e, r] = new Uint8Array(t, 0, 2);
                if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = Sh[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(t, 2, 1), [a] = new Uint32Array(t, 4, 1);
                return new kh(a, s, i, t);
            }
            constructor(t, e = 64, r = Float64Array, n){
                if (isNaN(t) || t < 0) throw new Error(`Unpexpected numItems value: ${t}.`);
                this.numItems = +t, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
                const i = Sh.indexOf(this.ArrayType), s = 2 * t * this.ArrayType.BYTES_PER_ELEMENT, a = t * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - a % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 2 * t, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + a + o), this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t);
            }
            add(t, e) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t, this.coords[this._pos++] = e, r;
            }
            finish() {
                const t = this._pos >> 1;
                if (t !== this.numItems) throw new Error(`Added ${t} items when expected ${this.numItems}.`);
                return Mh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t, e, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: a } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= a) {
                        for(let a = h; a <= c; a++){
                            const o = s[2 * a], u = s[2 * a + 1];
                            o >= t && o <= r && u >= e && u <= n && l.push(i[a]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = s[2 * p], d = s[2 * p + 1];
                    f >= t && f <= r && d >= e && d <= n && l.push(i[p]), (0 === u ? t <= f : e <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(t, e, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: s } = this, a = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= s) {
                        for(let r = h; r <= c; r++)Ch(i[2 * r], i[2 * r + 1], t, e) <= l && o.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    Ch(f, d, t, e) <= l && o.push(n[p]), (0 === u ? t - r <= f : e - r <= d) && (a.push(h), a.push(p - 1), a.push(1 - u)), (0 === u ? t + r >= f : e + r >= d) && (a.push(p + 1), a.push(c), a.push(1 - u));
                }
                return o;
            }
        }
        function Mh(t, e, r, n, i, s) {
            if (i - n <= r) return;
            const a = n + i >> 1;
            Ih(t, e, a, n, i, s), Mh(t, e, r, n, a - 1, 1 - s), Mh(t, e, r, a + 1, i, 1 - s);
        }
        function Ih(t, e, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    const a = i - n + 1, o = r - n + 1, l = Math.log(a), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (a - u) / a) * (o - a / 2 < 0 ? -1 : 1);
                    Ih(t, e, r, Math.max(n, Math.floor(r - o * u / a + c)), Math.min(i, Math.floor(r + (a - o) * u / a + c)), s);
                }
                const a = e[2 * r + s];
                let o = n, l = i;
                for(zh(t, e, n, r), e[2 * i + s] > a && zh(t, e, n, i); o < l;){
                    for(zh(t, e, o, l), o++, l--; e[2 * o + s] < a;)o++;
                    for(; e[2 * l + s] > a;)l--;
                }
                e[2 * n + s] === a ? zh(t, e, n, l) : (l++, zh(t, e, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function zh(t, e, r, n) {
            Ph(t, r, n), Ph(e, 2 * r, 2 * n), Ph(e, 2 * r + 1, 2 * n + 1);
        }
        function Ph(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function Ch(t, e, r, n) {
            const i = t - r, s = e - n;
            return i * i + s * s;
        }
        var Bh;
        t.bf = void 0, (Bh = t.bf || (t.bf = {})).create = "create", Bh.load = "load", Bh.fullLoad = "fullLoad";
        let Vh = null, Eh = [];
        const Fh = 1e3 / 60, Th = "loadTime", $h = "fullLoadTime", Lh = {
            mark (t) {
                performance.mark(t);
            },
            frame (t) {
                const e = t;
                null != Vh && Eh.push(e - Vh), Vh = e;
            },
            clearMetrics () {
                Vh = null, Eh = [], performance.clearMeasures(Th), performance.clearMeasures($h);
                for(const e in t.bf)performance.clearMarks(t.bf[e]);
            },
            getPerformanceMetrics () {
                performance.measure(Th, t.bf.create, t.bf.load), performance.measure($h, t.bf.create, t.bf.fullLoad);
                const e = performance.getEntriesByName(Th)[0].duration, r = performance.getEntriesByName($h)[0].duration, n = Eh.length, i = 1 / (Eh.reduce((t, e)=>t + e, 0) / n / 1e3), s = Eh.filter((t)=>t > Fh).reduce((t, e)=>t + (e - Fh) / Fh, 0);
                return {
                    loadTime: e,
                    fullLoadTime: r,
                    fps: i,
                    percentDroppedFrames: s / (n + s) * 100,
                    totalFrames: n
                };
            }
        };
        t.$ = class extends ps {
        }, t.A = oo, t.B = yi, t.C = function(t) {
            if (null == M) {
                const e = t.navigator ? t.navigator.userAgent : null;
                M = !!t.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
            }
            return M;
        }, t.D = Ji, t.E = Z, t.F = class {
            constructor(t, e){
                this.target = t, this.mapId = e, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new Mc(()=>this.process()), this.subscription = function(t, e, r, n) {
                    return t.addEventListener(e, r, !1), {
                        unsubscribe: ()=>{
                            t.removeEventListener(e, r, !1);
                        }
                    };
                }(this.target, "message", (t)=>this.receive(t)), this.globalScope = k(self) ? t : window;
            }
            registerMessageHandler(t, e) {
                this.messageHandlers[t] = e;
            }
            sendAsync(t, e) {
                return new Promise((r, n)=>{
                    const i = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                    this.resolveRejects[i] = {
                        resolve: r,
                        reject: n
                    }, e && e.signal.addEventListener("abort", ()=>{
                        delete this.resolveRejects[i];
                        const e = {
                            id: i,
                            type: "<cancel>",
                            origin: location.origin,
                            targetMapId: t.targetMapId,
                            sourceMapId: this.mapId
                        };
                        this.target.postMessage(e);
                    }, {
                        once: !0
                    });
                    const s = [], a = Object.assign(Object.assign({}, t), {
                        id: i,
                        sourceMapId: this.mapId,
                        origin: location.origin,
                        data: ki(t.data, s)
                    });
                    this.target.postMessage(a, {
                        transfer: s
                    });
                });
            }
            receive(t) {
                const e = t.data, r = e.id;
                if (!("file://" !== e.origin && "file://" !== location.origin && "resource://android" !== e.origin && "resource://android" !== location.origin && e.origin !== location.origin || e.targetMapId && this.mapId !== e.targetMapId)) {
                    if ("<cancel>" === e.type) {
                        delete this.tasks[r];
                        const t = this.abortControllers[r];
                        return delete this.abortControllers[r], void (t && t.abort());
                    }
                    if (k(self) || e.mustQueue) return this.tasks[r] = e, this.taskQueue.push(r), void this.invoker.trigger();
                    this.processTask(r, e);
                }
            }
            process() {
                if (0 === this.taskQueue.length) return;
                const t = this.taskQueue.shift(), e = this.tasks[t];
                delete this.tasks[t], this.taskQueue.length > 0 && this.invoker.trigger(), e && this.processTask(t, e);
            }
            processTask(t, r) {
                return e(this, void 0, void 0, function*() {
                    if ("<response>" === r.type) {
                        const e = this.resolveRejects[t];
                        if (delete this.resolveRejects[t], !e) return;
                        return void (r.error ? e.reject(Mi(r.error)) : e.resolve(Mi(r.data)));
                    }
                    if (!this.messageHandlers[r.type]) return void this.completeTask(t, new Error(`Could not find a registered handler for ${r.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                    const e = Mi(r.data), n = new AbortController;
                    this.abortControllers[t] = n;
                    try {
                        const i = yield this.messageHandlers[r.type](r.sourceMapId, e, n);
                        this.completeTask(t, null, i);
                    } catch (e) {
                        this.completeTask(t, e);
                    }
                });
            }
            completeTask(t, e, r) {
                const n = [];
                delete this.abortControllers[t];
                const i = {
                    id: t,
                    type: "<response>",
                    sourceMapId: this.mapId,
                    origin: location.origin,
                    error: e ? ki(e) : null,
                    data: ki(r, n)
                };
                this.target.postMessage(i, {
                    transfer: n
                });
            }
            remove() {
                this.invoker.remove(), this.subscription.unsubscribe();
            }
        }, t.G = $, t.H = function() {
            var t = new oo(16);
            return oo != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
        }, t.I = Fu, t.J = function(t, e, r) {
            var n, i, s, a, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e === t ? (t[12] = e[0] * y + e[4] * m + e[8] * g + e[12], t[13] = e[1] * y + e[5] * m + e[9] * g + e[13], t[14] = e[2] * y + e[6] * m + e[10] * g + e[14], t[15] = e[3] * y + e[7] * m + e[11] * g + e[15]) : (i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t[0] = n = e[0], t[1] = i, t[2] = s, t[3] = a, t[4] = o, t[5] = l, t[6] = u, t[7] = c, t[8] = h, t[9] = p, t[10] = f, t[11] = d, t[12] = n * y + o * m + h * g + e[12], t[13] = i * y + l * m + p * g + e[13], t[14] = s * y + u * m + f * g + e[14], t[15] = a * y + c * m + d * g + e[15]), t;
        }, t.K = function(t, e, r) {
            var n = r[0], i = r[1], s = r[2];
            return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * s, t[9] = e[9] * s, t[10] = e[10] * s, t[11] = e[11] * s, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.L = uo, t.M = function(t, e) {
            const r = {};
            for(let n = 0; n < e.length; n++){
                const i = e[n];
                i in t && (r[i] = t[i]);
            }
            return r;
        }, t.N = zc, t.O = Bc, t.P = s, t.Q = Vc, t.R = Ao, t.S = Oc, t.T = Zi, t.U = h, t.V = p, t.W = P, t.X = $a, t.Y = ls, t.Z = Tc, t._ = e, t.a = F, t.a$ = function(t, e) {
            return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.a0 = oa, t.a1 = Lc, t.a2 = it, t.a3 = (t)=>{
            const e = window.document.createElement("video");
            return e.muted = !0, new Promise((r)=>{
                e.onloadstart = ()=>{
                    r(e);
                };
                for (const r of t){
                    const t = window.document.createElement("source");
                    j(r) || (e.crossOrigin = "Anonymous"), t.src = r, e.appendChild(t);
                }
            });
        }, t.a4 = function() {
            return x++;
        }, t.a5 = Fs, t.a6 = fc, t.a7 = zn, t.a8 = ja, t.a9 = qc, t.aA = function(t) {
            if ("custom" === t.type) return new kc(t);
            switch(t.type){
                case "background":
                    return new wc(t);
                case "circle":
                    return new fo(t);
                case "fill":
                    return new ll(t);
                case "fill-extrusion":
                    return new Vl(t);
                case "heatmap":
                    return new ko(t);
                case "hillshade":
                    return new zo(t);
                case "line":
                    return new Xl(t);
                case "raster":
                    return new Sc(t);
                case "symbol":
                    return new xc(t);
            }
        }, t.aB = w, t.aC = function(t, e) {
            if (!t) return [
                {
                    command: "setStyle",
                    args: [
                        e
                    ]
                }
            ];
            let r = [];
            try {
                if (!H(t.version, e.version)) return [
                    {
                        command: "setStyle",
                        args: [
                            e
                        ]
                    }
                ];
                H(t.center, e.center) || r.push({
                    command: "setCenter",
                    args: [
                        e.center
                    ]
                }), H(t.zoom, e.zoom) || r.push({
                    command: "setZoom",
                    args: [
                        e.zoom
                    ]
                }), H(t.bearing, e.bearing) || r.push({
                    command: "setBearing",
                    args: [
                        e.bearing
                    ]
                }), H(t.pitch, e.pitch) || r.push({
                    command: "setPitch",
                    args: [
                        e.pitch
                    ]
                }), H(t.sprite, e.sprite) || r.push({
                    command: "setSprite",
                    args: [
                        e.sprite
                    ]
                }), H(t.glyphs, e.glyphs) || r.push({
                    command: "setGlyphs",
                    args: [
                        e.glyphs
                    ]
                }), H(t.transition, e.transition) || r.push({
                    command: "setTransition",
                    args: [
                        e.transition
                    ]
                }), H(t.light, e.light) || r.push({
                    command: "setLight",
                    args: [
                        e.light
                    ]
                }), H(t.terrain, e.terrain) || r.push({
                    command: "setTerrain",
                    args: [
                        e.terrain
                    ]
                }), H(t.sky, e.sky) || r.push({
                    command: "setSky",
                    args: [
                        e.sky
                    ]
                }), H(t.projection, e.projection) || r.push({
                    command: "setProjection",
                    args: [
                        e.projection
                    ]
                });
                const n = {}, i = [];
                !function(t, e, r, n) {
                    let i;
                    for(i in e = e || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e, i) || W(i, r, n));
                    for(i in e)Object.prototype.hasOwnProperty.call(e, i) && (Object.prototype.hasOwnProperty.call(t, i) ? H(t[i], e[i]) || ("geojson" === t[i].type && "geojson" === e[i].type && tt(t, e, i) ? Y(r, {
                        command: "setGeoJSONSourceData",
                        args: [
                            i,
                            e[i].data
                        ]
                    }) : Q(i, e, r, n)) : J(i, e, r));
                }(t.sources, e.sources, i, n);
                const s = [];
                t.layers && t.layers.forEach((t)=>{
                    "source" in t && n[t.source] ? r.push({
                        command: "removeLayer",
                        args: [
                            t.id
                        ]
                    }) : s.push(t);
                }), r = r.concat(i), function(t, e, r) {
                    e = e || [];
                    const n = (t = t || []).map(rt), i = e.map(rt), s = t.reduce(nt, {}), a = e.reduce(nt, {}), o = n.slice(), l = Object.create(null);
                    let u, c, h, p, f;
                    for(let t = 0, e = 0; t < n.length; t++)u = n[t], Object.prototype.hasOwnProperty.call(a, u) ? e++ : (Y(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), o.splice(o.indexOf(u, e), 1));
                    for(let t = 0, e = 0; t < i.length; t++)u = i[i.length - 1 - t], o[o.length - 1 - t] !== u && (Object.prototype.hasOwnProperty.call(s, u) ? (Y(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), o.splice(o.lastIndexOf(u, o.length - e), 1)) : e++, p = o[o.length - t], Y(r, {
                        command: "addLayer",
                        args: [
                            a[u],
                            p
                        ]
                    }), o.splice(o.length - t, 0, u), l[u] = !0);
                    for(let t = 0; t < i.length; t++)if (u = i[t], c = s[u], h = a[u], !l[u] && !H(c, h)) {
                        if (H(c.source, h.source) && H(c["source-layer"], h["source-layer"]) && H(c.type, h.type)) {
                            for(f in et(c.layout, h.layout, r, u, null, "setLayoutProperty"), et(c.paint, h.paint, r, u, null, "setPaintProperty"), H(c.filter, h.filter) || Y(r, {
                                command: "setFilter",
                                args: [
                                    u,
                                    h.filter
                                ]
                            }), H(c.minzoom, h.minzoom) && H(c.maxzoom, h.maxzoom) || Y(r, {
                                command: "setLayerZoomRange",
                                args: [
                                    u,
                                    h.minzoom,
                                    h.maxzoom
                                ]
                            }), c)Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? et(c[f], h[f], r, u, f.slice(6), "setPaintProperty") : H(c[f], h[f]) || Y(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                            for(f in h)Object.prototype.hasOwnProperty.call(h, f) && !Object.prototype.hasOwnProperty.call(c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? et(c[f], h[f], r, u, f.slice(6), "setPaintProperty") : H(c[f], h[f]) || Y(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    h[f]
                                ]
                            }));
                        } else Y(r, {
                            command: "removeLayer",
                            args: [
                                u
                            ]
                        }), p = o[o.lastIndexOf(u) + 1], Y(r, {
                            command: "addLayer",
                            args: [
                                h,
                                p
                            ]
                        });
                    }
                }(s, e.layers, r);
            } catch (t) {
                console.warn("Unable to compute style diff:", t), r = [
                    {
                        command: "setStyle",
                        args: [
                            e
                        ]
                    }
                ];
            }
            return r;
        }, t.aD = function(t) {
            const e = [], r = t.id;
            return void 0 === r && e.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t.render && e.push({
                message: `layers.${r}: missing required method "render"`
            }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && e.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e;
        }, t.aE = function t(e, r) {
            if (Array.isArray(e)) {
                if (!Array.isArray(r) || e.length !== r.length) return !1;
                for(let n = 0; n < e.length; n++)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof e && null !== e && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(e).length !== Object.keys(r).length) return !1;
                for(const n in e)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            return e === r;
        }, t.aF = v, t.aG = b, t.aH = class extends wa {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1i(this.location, t));
            }
        }, t.aI = _a, t.aJ = class extends wa {
            constructor(t, e){
                super(t, e), this.current = ka;
            }
            set(t) {
                if (t[12] !== this.current[12] || t[0] !== this.current[0]) return this.current = t, void this.gl.uniformMatrix4fv(this.location, !1, t);
                for(let e = 1; e < 16; e++)if (t[e] !== this.current[e]) {
                    this.current = t, this.gl.uniformMatrix4fv(this.location, !1, t);
                    break;
                }
            }
        }, t.aK = Aa, t.aL = Sa, t.aM = Kt, t.aN = class extends wa {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] || (this.current = t, this.gl.uniform3f(this.location, t[0], t[1], t[2]));
            }
        }, t.aO = class extends wa {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] || (this.current = t, this.gl.uniform2f(this.location, t[0], t[1]));
            }
        }, t.aP = function(t, e, r, n, i, s, a) {
            var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (s - a);
            return t[0] = -2 * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * u, t[11] = 0, t[12] = (e + r) * o, t[13] = (i + n) * l, t[14] = (a + s) * u, t[15] = 1, t;
        }, t.aQ = ho, t.aR = class extends _s {
        }, t.aS = tu, t.aT = class extends Ss {
        }, t.aU = function(t) {
            return t <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
        }, t.aV = So, t.aW = Zs, t.aX = na, t.aY = class extends Bs {
        }, t.aZ = function(t, e) {
            return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8] && t[9] === e[9] && t[10] === e[10] && t[11] === e[11] && t[12] === e[12] && t[13] === e[13] && t[14] === e[14] && t[15] === e[15];
        }, t.a_ = function(t, e) {
            var r = t[0], n = t[1], i = t[2], s = t[3], a = t[4], o = t[5], l = t[6], u = t[7], c = t[8], h = t[9], p = t[10], f = t[11], d = t[12], y = t[13], m = t[14], g = t[15], x = e[0], v = e[1], b = e[2], w = e[3], _ = e[4], A = e[5], S = e[6], k = e[7], M = e[8], I = e[9], z = e[10], P = e[11], C = e[12], B = e[13], V = e[14], E = e[15];
            return Math.abs(r - x) <= ao * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - v) <= ao * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(i - b) <= ao * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(s - w) <= ao * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(a - _) <= ao * Math.max(1, Math.abs(a), Math.abs(_)) && Math.abs(o - A) <= ao * Math.max(1, Math.abs(o), Math.abs(A)) && Math.abs(l - S) <= ao * Math.max(1, Math.abs(l), Math.abs(S)) && Math.abs(u - k) <= ao * Math.max(1, Math.abs(u), Math.abs(k)) && Math.abs(c - M) <= ao * Math.max(1, Math.abs(c), Math.abs(M)) && Math.abs(h - I) <= ao * Math.max(1, Math.abs(h), Math.abs(I)) && Math.abs(p - z) <= ao * Math.max(1, Math.abs(p), Math.abs(z)) && Math.abs(f - P) <= ao * Math.max(1, Math.abs(f), Math.abs(P)) && Math.abs(d - C) <= ao * Math.max(1, Math.abs(d), Math.abs(C)) && Math.abs(y - B) <= ao * Math.max(1, Math.abs(y), Math.abs(B)) && Math.abs(m - V) <= ao * Math.max(1, Math.abs(m), Math.abs(V)) && Math.abs(g - E) <= ao * Math.max(1, Math.abs(g), Math.abs(E));
        }, t.aa = function(t) {
            const e = {};
            if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t, r, n, i)=>{
                const s = n || i;
                return e[r] = !s || s.toLowerCase(), "";
            }), e["max-age"]) {
                const t = parseInt(e["max-age"], 10);
                isNaN(t) ? delete e["max-age"] : e["max-age"] = t;
            }
            return e;
        }, t.ab = function(t, e) {
            const r = [];
            for(const n in t)n in e || r.push(n);
            return r;
        }, t.ac = y, t.ad = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[0], a = e[1], o = e[2], l = e[3], u = e[4], c = e[5], h = e[6], p = e[7];
            return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = s * i + u * n, t[1] = a * i + c * n, t[2] = o * i + h * n, t[3] = l * i + p * n, t[4] = u * i - s * n, t[5] = c * i - a * n, t[6] = h * i - o * n, t[7] = p * i - l * n, t;
        }, t.ae = function(t) {
            var e = new oo(16);
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
        }, t.af = po, t.ag = function(t, e) {
            let r = 0, n = 0;
            if ("constant" === t.kind) n = t.layoutSize;
            else if ("source" !== t.kind) {
                const { interpolationType: i, minZoom: s, maxZoom: a } = t, o = i ? y(Be.interpolationFactor(i, e, s, a), 0, 1) : 0;
                "camera" === t.kind ? n = Ce.number(t.minSize, t.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }, t.ai = function(t, { uSize: e, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t.kind ? n / rc : "composite" === t.kind ? Ce.number(n / rc, i / rc, r) : e;
        }, t.aj = uc, t.ak = function(t, e, r, n) {
            const i = e.y - t.y, a = e.x - t.x, o = n.y - r.y, l = n.x - r.x, u = o * a - l * i;
            if (0 === u) return null;
            const c = (l * (t.y - r.y) - o * (t.x - r.x)) / u;
            return new s(t.x + c * a, t.y + c * i);
        }, t.al = Xc, t.am = qa, t.an = lo, t.ao = function(t) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of t)e = Math.min(e, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return [
                e,
                r,
                n,
                i
            ];
        }, t.ap = nu, t.ar = sc, t.as = function(t, e) {
            var r = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], y = e[13], m = e[14], g = e[15], x = r * o - n * a, v = r * l - i * a, b = r * u - s * a, w = n * l - i * o, _ = n * u - s * o, A = i * u - s * l, S = c * y - h * d, k = c * m - p * d, M = c * g - f * d, I = h * m - p * y, z = h * g - f * y, P = p * g - f * m, C = x * P - v * z + b * I + w * M - _ * k + A * S;
            return C ? (t[0] = (o * P - l * z + u * I) * (C = 1 / C), t[1] = (i * z - n * P - s * I) * C, t[2] = (y * A - m * _ + g * w) * C, t[3] = (p * _ - h * A - f * w) * C, t[4] = (l * M - a * P - u * k) * C, t[5] = (r * P - i * M + s * k) * C, t[6] = (m * b - d * A - g * v) * C, t[7] = (c * A - p * b + f * v) * C, t[8] = (a * z - o * M + u * S) * C, t[9] = (n * M - r * z - s * S) * C, t[10] = (d * _ - y * b + g * x) * C, t[11] = (h * b - c * _ - f * x) * C, t[12] = (o * k - a * I - l * S) * C, t[13] = (r * I - n * k + i * S) * C, t[14] = (y * v - d * w - m * x) * C, t[15] = (c * w - h * v + p * x) * C, t) : null;
        }, t.at = vh, t.au = Yu, t.av = kh, t.aw = function() {
            const t = {}, e = G.$version;
            for(const r in G.$root){
                const n = G.$root[r];
                if (n.required) {
                    let i = null;
                    i = "version" === r ? e : "array" === n.type ? [] : {}, null != i && (t[r] = i);
                }
            }
            return t;
        }, t.ax = Ii, t.ay = D, t.az = function(t) {
            t = t.slice();
            const e = Object.create(null);
            for(let r = 0; r < t.length; r++)e[t[r].id] = t[r];
            for(let r = 0; r < t.length; r++)"ref" in t[r] && (t[r] = X(t[r], e[t[r].ref]));
            return t;
        }, t.b = I, t.b0 = function(t, e, r) {
            return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t[3] = e[3] * r[3], t;
        }, t.b1 = function(t, e) {
            return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
        }, t.b2 = m, t.b3 = Dc, t.b4 = Ec, t.b5 = function(t, e, r, n, i) {
            var s, a = 1 / Math.tan(e / 2);
            return t[0] = a / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = a, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0 ? (t[10] = (i + n) * (s = 1 / (n - i)), t[14] = 2 * i * n * s) : (t[10] = -1, t[14] = -2 * n), t;
        }, t.b6 = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), s = e[4], a = e[5], o = e[6], l = e[7], u = e[8], c = e[9], h = e[10], p = e[11];
            return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = s * i + u * n, t[5] = a * i + c * n, t[6] = o * i + h * n, t[7] = l * i + p * n, t[8] = u * i - s * n, t[9] = c * i - a * n, t[10] = h * i - o * n, t[11] = p * i - l * n, t;
        }, t.b7 = f, t.b8 = d, t.b9 = function(t) {
            return t * Math.PI / 180;
        }, t.bA = function(t) {
            return t.message === V;
        }, t.bB = bn, t.bC = Ri, t.ba = function(t, e) {
            const { x: r, y: n } = Tc.fromLngLat(e);
            return !(t < 0 || t > 25 || n < 0 || n >= 1 || r < 0 || r >= 1);
        }, t.bb = function(t, e) {
            return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }, t.bc = class extends hs {
        }, t.bd = Ic, t.be = Lh, t.bg = L, t.bh = function(t, e) {
            F.REGISTERED_PROTOCOLS[t] = e;
        }, t.bi = function(t) {
            delete F.REGISTERED_PROTOCOLS[t];
        }, t.bj = function(t, e) {
            const r = {};
            for(let n = 0; n < t.length; n++){
                const i = e && e[t[n].id] || Ln(t[n]);
                e && (e[t[n].id] = i);
                let s = r[i];
                s || (s = r[i] = []), s.push(t[n]);
            }
            const n = [];
            for(const t in r)n.push(r[t]);
            return n;
        }, t.bk = wi, t.bl = Uc, t.bm = Nc, t.bn = Tu, t.bo = function(e) {
            e.bucket.createArrays(), e.bucket.tilePixelRatio = $a / (512 * e.bucket.overscaling), e.bucket.compareText = {}, e.bucket.iconsNeedLinear = !1;
            const r = e.bucket.layers[0], n = r.layout, i = r._unevaluatedLayout._values, s = {
                layoutIconSize: i["icon-size"].possiblyEvaluate(new Ui(e.bucket.zoom + 1), e.canonical),
                layoutTextSize: i["text-size"].possiblyEvaluate(new Ui(e.bucket.zoom + 1), e.canonical),
                textMaxSize: i["text-size"].possiblyEvaluate(new Ui(18))
            };
            if ("composite" === e.bucket.textSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.textSizeData;
                s.compositeTextSizes = [
                    i["text-size"].possiblyEvaluate(new Ui(t), e.canonical),
                    i["text-size"].possiblyEvaluate(new Ui(r), e.canonical)
                ];
            }
            if ("composite" === e.bucket.iconSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.iconSizeData;
                s.compositeIconSizes = [
                    i["icon-size"].possiblyEvaluate(new Ui(t), e.canonical),
                    i["icon-size"].possiblyEvaluate(new Ui(r), e.canonical)
                ];
            }
            const a = n.get("text-line-height") * nu, o = "viewport" !== n.get("text-rotation-alignment") && "point" !== n.get("symbol-placement"), l = n.get("text-keep-upright"), u = n.get("text-size");
            for (const i of e.bucket.features){
                const c = n.get("text-font").evaluate(i, {}, e.canonical).join(","), h = u.evaluate(i, {}, e.canonical), p = s.layoutTextSize.evaluate(i, {}, e.canonical), f = s.layoutIconSize.evaluate(i, {}, e.canonical), d = {
                    horizontal: {},
                    vertical: void 0
                }, y = i.text;
                let m, g = [
                    0,
                    0
                ];
                if (y) {
                    const s = y.toString(), u = n.get("text-letter-spacing").evaluate(i, {}, e.canonical) * nu, f = Ci(s) ? u : 0, m = n.get("text-anchor").evaluate(i, {}, e.canonical), x = xh(r, i, e.canonical);
                    if (!x) {
                        const t = n.get("text-radial-offset").evaluate(i, {}, e.canonical);
                        g = t ? gh(m, [
                            t * nu,
                            mh
                        ]) : n.get("text-offset").evaluate(i, {}, e.canonical).map((t)=>t * nu);
                    }
                    let v = o ? "center" : n.get("text-justify").evaluate(i, {}, e.canonical);
                    const b = "point" === n.get("symbol-placement") ? n.get("text-max-width").evaluate(i, {}, e.canonical) * nu : 1 / 0, w = ()=>{
                        e.bucket.allowVerticalPlacement && Pi(s) && (d.vertical = ju(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, m, "left", f, g, t.ah.vertical, !0, p, h));
                    };
                    if (!o && x) {
                        const r = new Set;
                        if ("auto" === v) for(let t = 0; t < x.values.length; t += 2)r.add(vh(x.values[t]));
                        else r.add(v);
                        let n = !1;
                        for (const i of r)if (!d.horizontal[i]) {
                            if (n) d.horizontal[i] = d.horizontal[0];
                            else {
                                const r = ju(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, "center", i, f, g, t.ah.horizontal, !1, p, h);
                                r && (d.horizontal[i] = r, n = 1 === r.positionedLines.length);
                            }
                        }
                        w();
                    } else {
                        "auto" === v && (v = vh(m));
                        const r = ju(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, m, v, f, g, t.ah.horizontal, !1, p, h);
                        r && (d.horizontal[v] = r), w(), Pi(s) && o && l && (d.vertical = ju(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, b, a, m, v, f, g, t.ah.vertical, !1, p, h));
                    }
                }
                let x = !1;
                if (i.icon && i.icon.name) {
                    const t = e.imageMap[i.icon.name];
                    t && (m = Wu(e.imagePositions[i.icon.name], n.get("icon-offset").evaluate(i, {}, e.canonical), n.get("icon-anchor").evaluate(i, {}, e.canonical)), x = !!t.sdf, void 0 === e.bucket.sdfIcons ? e.bucket.sdfIcons = x : e.bucket.sdfIcons !== x && A("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t.pixelRatio !== e.bucket.pixelRatio || 0 !== n.get("icon-rotate").constantOr(1)) && (e.bucket.iconsNeedLinear = !0));
                }
                const v = _h(d.horizontal) || d.vertical;
                e.bucket.iconsInText = !!v && v.iconsInText, (v || m) && bh(e.bucket, i, d, m, e.imageMap, s, p, f, g, x, e.canonical);
            }
            e.showCollisionBoxes && e.bucket.generateCollisionDebugBuffers();
        }, t.bp = Ul, t.bq = il, t.br = Il, t.bs = pl, t.bt = Mu, t.bu = class {
            constructor(t){
                this._marks = {
                    start: [
                        t.url,
                        "start"
                    ].join("#"),
                    end: [
                        t.url,
                        "end"
                    ].join("#"),
                    measure: t.url.toString()
                }, performance.mark(this._marks.start);
            }
            finish() {
                performance.mark(this._marks.end);
                let t = performance.getEntriesByName(this._marks.measure);
                return 0 === t.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t;
            }
        }, t.bv = function(t, r, n, i, s) {
            return e(this, void 0, void 0, function*() {
                if (p()) try {
                    return yield P(t, r, n, i, s);
                } catch (t) {}
                return function(t, e, r, n, i) {
                    const s = t.width, a = t.height;
                    C && B || (C = new OffscreenCanvas(s, a), B = C.getContext("2d", {
                        willReadFrequently: !0
                    })), C.width = s, C.height = a, B.drawImage(t, 0, 0, s, a);
                    const o = B.getImageData(e, r, n, i);
                    return B.clearRect(0, 0, s, a), o.data;
                }(t, r, n, i, s);
            });
        }, t.bw = Rc, t.bx = r, t.by = n, t.bz = iu, t.c = E, t.d = (t)=>e(void 0, void 0, void 0, function*() {
                if (0 === t.byteLength) return createImageBitmap(new ImageData(1, 1));
                const e = new Blob([
                    new Uint8Array(t)
                ], {
                    type: "image/png"
                });
                try {
                    return createImageBitmap(e);
                } catch (t) {
                    throw new Error(`Could not load image because of ${t.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                }
            }), t.e = g, t.f = (t)=>new Promise((e, r)=>{
                const n = new Image;
                n.onload = ()=>{
                    e(n), URL.revokeObjectURL(n.src), n.onload = null, window.requestAnimationFrame(()=>{
                        n.src = z;
                    });
                }, n.onerror = ()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                const i = new Blob([
                    new Uint8Array(t)
                ], {
                    type: "image/png"
                });
                n.src = t.byteLength ? URL.createObjectURL(i) : z;
            }), t.g = T, t.h = (t, e)=>O(g(t, {
                type: "json"
            }), e), t.i = k, t.j = N, t.k = q, t.l = (t, e)=>O(g(t, {
                type: "arrayBuffer"
            }), e), t.m = O, t.n = function(t) {
            return new Mu(t).readFields(zu, []);
        }, t.o = _o, t.p = Vu, t.q = rs, t.r = di, t.s = j, t.t = xi, t.u = fi, t.v = G, t.w = A, t.x = function([t, e, r]) {
            return e += 90, e *= Math.PI / 180, r *= Math.PI / 180, {
                x: t * Math.cos(e) * Math.sin(r),
                y: t * Math.sin(e) * Math.sin(r),
                z: t * Math.cos(r)
            };
        }, t.y = Ce, t.z = Ui;
    });
    define("worker", [
        "./shared"
    ], function(e) {
        "use strict";
        class t {
            constructor(e){
                this.keyCache = {}, e && this.replace(e);
            }
            replace(e) {
                this._layerConfigs = {}, this._layers = {}, this.update(e, []);
            }
            update(t, o) {
                for (const o of t){
                    this._layerConfigs[o.id] = o;
                    const t = this._layers[o.id] = e.aA(o);
                    t._featureFilter = e.a7(t.filter), this.keyCache[o.id] && delete this.keyCache[o.id];
                }
                for (const e of o)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = {};
                const i = e.bj(Object.values(this._layerConfigs), this.keyCache);
                for (const e of i){
                    const t = e.map((e)=>this._layers[e.id]), o = t[0];
                    if ("none" === o.visibility) continue;
                    const i = o.source || "";
                    let s = this.familiesBySource[i];
                    s || (s = this.familiesBySource[i] = {});
                    const r = o.sourceLayer || "_geojsonTileLayer";
                    let n = s[r];
                    n || (n = s[r] = []), n.push(t);
                }
            }
        }
        class o {
            constructor(t){
                const o = {}, i = [];
                for(const e in t){
                    const s = t[e], r = o[e] = {};
                    for(const e in s){
                        const t = s[+e];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const o = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2,
                            h: t.bitmap.height + 2
                        };
                        i.push(o), r[e] = {
                            rect: o,
                            metrics: t.metrics
                        };
                    }
                }
                const { w: s, h: r } = e.p(i), n = new e.o({
                    width: s || 1,
                    height: r || 1
                });
                for(const i in t){
                    const s = t[i];
                    for(const t in s){
                        const r = s[+t];
                        if (!r || 0 === r.bitmap.width || 0 === r.bitmap.height) continue;
                        const a = o[i][t].rect;
                        e.o.copy(r.bitmap, n, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, r.bitmap);
                    }
                }
                this.image = n, this.positions = o;
            }
        }
        e.bk("GlyphAtlas", o);
        class i {
            constructor(t){
                this.tileID = new e.S(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.uid = t.uid, this.zoom = t.zoom, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.returnDependencies = !!t.returnDependencies, this.promoteId = t.promoteId, this.inFlightDependencies = [];
            }
            parse(t, i, r, n) {
                return e._(this, void 0, void 0, function*() {
                    this.status = "parsing", this.data = t, this.collisionBoxArray = new e.a5;
                    const a = new e.bl(Object.keys(t.layers).sort()), l = new e.bm(this.tileID, this.promoteId);
                    l.bucketLayerIDs = [];
                    const c = {}, u = {
                        featureIndex: l,
                        iconDependencies: {},
                        patternDependencies: {},
                        glyphDependencies: {},
                        availableImages: r
                    }, h = i.familiesBySource[this.source];
                    for(const o in h){
                        const i = t.layers[o];
                        if (!i) continue;
                        1 === i.version && e.w(`Vector tile source "${this.source}" layer "${o}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                        const n = a.encode(o), d = [];
                        for(let e = 0; e < i.length; e++){
                            const t = i.feature(e), s = l.getId(t, o);
                            d.push({
                                feature: t,
                                id: s,
                                index: e,
                                sourceLayerIndex: n
                            });
                        }
                        for (const t of h[o]){
                            const o = t[0];
                            o.source !== this.source && e.w(`layer.source = ${o.source} does not equal this.source = ${this.source}`), o.minzoom && this.zoom < Math.floor(o.minzoom) || o.maxzoom && this.zoom >= o.maxzoom || "none" !== o.visibility && (s(t, this.zoom, r), (c[o.id] = o.createBucket({
                                index: l.bucketLayerIDs.length,
                                layers: t,
                                zoom: this.zoom,
                                pixelRatio: this.pixelRatio,
                                overscaling: this.overscaling,
                                collisionBoxArray: this.collisionBoxArray,
                                sourceLayerIndex: n,
                                sourceID: this.source
                            })).populate(d, u, this.tileID.canonical), l.bucketLayerIDs.push(t.map((e)=>e.id)));
                        }
                    }
                    const d = e.aF(u.glyphDependencies, (e)=>Object.keys(e).map(Number));
                    this.inFlightDependencies.forEach((e)=>null == e ? void 0 : e.abort()), this.inFlightDependencies = [];
                    let f = Promise.resolve({});
                    if (Object.keys(d).length) {
                        const e = new AbortController;
                        this.inFlightDependencies.push(e), f = n.sendAsync({
                            type: "GG",
                            data: {
                                stacks: d,
                                source: this.source,
                                tileID: this.tileID,
                                type: "glyphs"
                            }
                        }, e);
                    }
                    const g = Object.keys(u.iconDependencies);
                    let p = Promise.resolve({});
                    if (g.length) {
                        const e = new AbortController;
                        this.inFlightDependencies.push(e), p = n.sendAsync({
                            type: "GI",
                            data: {
                                icons: g,
                                source: this.source,
                                tileID: this.tileID,
                                type: "icons"
                            }
                        }, e);
                    }
                    const m = Object.keys(u.patternDependencies);
                    let y = Promise.resolve({});
                    if (m.length) {
                        const e = new AbortController;
                        this.inFlightDependencies.push(e), y = n.sendAsync({
                            type: "GI",
                            data: {
                                icons: m,
                                source: this.source,
                                tileID: this.tileID,
                                type: "patterns"
                            }
                        }, e);
                    }
                    const [v, w, x] = yield Promise.all([
                        f,
                        p,
                        y
                    ]), b = new o(v), S = new e.bn(w, x);
                    for(const t in c){
                        const o = c[t];
                        o instanceof e.a6 ? (s(o.layers, this.zoom, r), e.bo({
                            bucket: o,
                            glyphMap: v,
                            glyphPositions: b.positions,
                            imageMap: w,
                            imagePositions: S.iconPositions,
                            showCollisionBoxes: this.showCollisionBoxes,
                            canonical: this.tileID.canonical
                        })) : o.hasPattern && (o instanceof e.bp || o instanceof e.bq || o instanceof e.br) && (s(o.layers, this.zoom, r), o.addFeatures(u, this.tileID.canonical, S.patternPositions));
                    }
                    return this.status = "done", {
                        buckets: Object.values(c).filter((e)=>!e.isEmpty()),
                        featureIndex: l,
                        collisionBoxArray: this.collisionBoxArray,
                        glyphAtlasImage: b.image,
                        imageAtlas: S,
                        glyphMap: this.returnDependencies ? v : null,
                        iconMap: this.returnDependencies ? w : null,
                        glyphPositions: this.returnDependencies ? b.positions : null
                    };
                });
            }
        }
        function s(t, o, i) {
            const s = new e.z(o);
            for (const e of t)e.recalculate(s, i);
        }
        class r {
            constructor(e, t, o){
                this.actor = e, this.layerIndex = t, this.availableImages = o, this.fetching = {}, this.loading = {}, this.loaded = {};
            }
            loadVectorTile(t, o) {
                return e._(this, void 0, void 0, function*() {
                    const i = yield e.l(t.request, o);
                    try {
                        return {
                            vectorTile: new e.bs.VectorTile(new e.bt(i.data)),
                            rawData: i.data,
                            cacheControl: i.cacheControl,
                            expires: i.expires
                        };
                    } catch (e) {
                        const o = new Uint8Array(i.data);
                        let s = `Unable to parse the tile at ${t.request.url}, `;
                        throw s += 31 === o[0] && 139 === o[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${e.message}`, new Error(s);
                    }
                });
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const o = t.uid, s = !!(t && t.request && t.request.collectResourceTiming) && new e.bu(t.request), r = new i(t);
                    this.loading[o] = r;
                    const n = new AbortController;
                    r.abort = n;
                    try {
                        const i = yield this.loadVectorTile(t, n);
                        if (delete this.loading[o], !i) return null;
                        const a = i.rawData, l = {};
                        i.expires && (l.expires = i.expires), i.cacheControl && (l.cacheControl = i.cacheControl);
                        const c = {};
                        if (s) {
                            const e = s.finish();
                            e && (c.resourceTiming = JSON.parse(JSON.stringify(e)));
                        }
                        r.vectorTile = i.vectorTile;
                        const u = r.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor);
                        this.loaded[o] = r, this.fetching[o] = {
                            rawTileData: a,
                            cacheControl: l,
                            resourceTiming: c
                        };
                        try {
                            const t = yield u;
                            return e.e({
                                rawTileData: a.slice(0)
                            }, t, l, c);
                        } finally{
                            delete this.fetching[o];
                        }
                    } catch (e) {
                        throw delete this.loading[o], r.status = "done", this.loaded[o] = r, e;
                    }
                });
            }
            reloadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const o = t.uid;
                    if (!this.loaded || !this.loaded[o]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                    const i = this.loaded[o];
                    if (i.showCollisionBoxes = t.showCollisionBoxes, "parsing" === i.status) {
                        const t = yield i.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor);
                        let s;
                        if (this.fetching[o]) {
                            const { rawTileData: i, cacheControl: r, resourceTiming: n } = this.fetching[o];
                            delete this.fetching[o], s = e.e({
                                rawTileData: i.slice(0)
                            }, t, r, n);
                        } else s = t;
                        return s;
                    }
                    if ("done" === i.status && i.vectorTile) return i.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor);
                });
            }
            abortTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const e = this.loading, o = t.uid;
                    e && e[o] && e[o].abort && (e[o].abort.abort(), delete e[o]);
                });
            }
            removeTile(t) {
                return e._(this, void 0, void 0, function*() {
                    this.loaded && this.loaded[t.uid] && delete this.loaded[t.uid];
                });
            }
        }
        class n {
            constructor(){
                this.loaded = {};
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const { uid: o, encoding: i, rawImageData: s, redFactor: r, greenFactor: n, blueFactor: a, baseShift: l } = t, c = s.width + 2, u = s.height + 2, h = e.b(s) ? new e.R({
                        width: c,
                        height: u
                    }, (yield e.bv(s, -1, -1, c, u))) : s, d = new e.bw(o, h, i, r, n, a, l);
                    return this.loaded = this.loaded || {}, this.loaded[o] = d, d;
                });
            }
            removeTile(e) {
                const t = this.loaded, o = e.uid;
                t && t[o] && delete t[o];
            }
        }
        function a(e, t) {
            if (0 !== e.length) {
                l(e[0], t);
                for(var o = 1; o < e.length; o++)l(e[o], !t);
            }
        }
        function l(e, t) {
            for(var o = 0, i = 0, s = 0, r = e.length, n = r - 1; s < r; n = s++){
                var a = (e[s][0] - e[n][0]) * (e[n][1] + e[s][1]), l = o + a;
                i += Math.abs(o) >= Math.abs(a) ? o - l + a : a - l + o, o = l;
            }
            o + i >= 0 != !!t && e.reverse();
        }
        var c = e.bx(function e(t, o) {
            var i, s = t && t.type;
            if ("FeatureCollection" === s) for(i = 0; i < t.features.length; i++)e(t.features[i], o);
            else if ("GeometryCollection" === s) for(i = 0; i < t.geometries.length; i++)e(t.geometries[i], o);
            else if ("Feature" === s) e(t.geometry, o);
            else if ("Polygon" === s) a(t.coordinates, o);
            else if ("MultiPolygon" === s) for(i = 0; i < t.coordinates.length; i++)a(t.coordinates[i], o);
            return t;
        });
        const u = e.bs.VectorTileFeature.prototype.toGeoJSON;
        var h = {
            exports: {}
        }, d = e.by, f = e.bs.VectorTileFeature, g = p;
        function p(e, t) {
            this.options = t || {}, this.features = e, this.length = e.length;
        }
        function m(e, t) {
            this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [
                e.geometry
            ] : e.geometry, this.properties = e.tags, this.extent = t || 4096;
        }
        p.prototype.feature = function(e) {
            return new m(this.features[e], this.options.extent);
        }, m.prototype.loadGeometry = function() {
            var e = this.rawGeometry;
            this.geometry = [];
            for(var t = 0; t < e.length; t++){
                for(var o = e[t], i = [], s = 0; s < o.length; s++)i.push(new d(o[s][0], o[s][1]));
                this.geometry.push(i);
            }
            return this.geometry;
        }, m.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e = this.geometry, t = 1 / 0, o = -1 / 0, i = 1 / 0, s = -1 / 0, r = 0; r < e.length; r++)for(var n = e[r], a = 0; a < n.length; a++){
                var l = n[a];
                t = Math.min(t, l.x), o = Math.max(o, l.x), i = Math.min(i, l.y), s = Math.max(s, l.y);
            }
            return [
                t,
                i,
                o,
                s
            ];
        }, m.prototype.toGeoJSON = f.prototype.toGeoJSON;
        var y = e.bz, v = g;
        function w(e) {
            var t = new y;
            return function(e, t) {
                for(var o in e.layers)t.writeMessage(3, x, e.layers[o]);
            }(e, t), t.finish();
        }
        function x(e, t) {
            var o;
            t.writeVarintField(15, e.version || 1), t.writeStringField(1, e.name || ""), t.writeVarintField(5, e.extent || 4096);
            var i = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(o = 0; o < e.length; o++)i.feature = e.feature(o), t.writeMessage(2, b, i);
            var s = i.keys;
            for(o = 0; o < s.length; o++)t.writeStringField(3, s[o]);
            var r = i.values;
            for(o = 0; o < r.length; o++)t.writeMessage(4, P, r[o]);
        }
        function b(e, t) {
            var o = e.feature;
            void 0 !== o.id && t.writeVarintField(1, o.id), t.writeMessage(2, S, e), t.writeVarintField(3, o.type), t.writeMessage(4, I, o);
        }
        function S(e, t) {
            var o = e.feature, i = e.keys, s = e.values, r = e.keycache, n = e.valuecache;
            for(var a in o.properties){
                var l = o.properties[a], c = r[a];
                if (null !== l) {
                    void 0 === c && (i.push(a), r[a] = c = i.length - 1), t.writeVarint(c);
                    var u = typeof l;
                    "string" !== u && "boolean" !== u && "number" !== u && (l = JSON.stringify(l));
                    var h = u + ":" + l, d = n[h];
                    void 0 === d && (s.push(l), n[h] = d = s.length - 1), t.writeVarint(d);
                }
            }
        }
        function _(e, t) {
            return (t << 3) + (7 & e);
        }
        function M(e) {
            return e << 1 ^ e >> 31;
        }
        function I(e, t) {
            for(var o = e.loadGeometry(), i = e.type, s = 0, r = 0, n = o.length, a = 0; a < n; a++){
                var l = o[a], c = 1;
                1 === i && (c = l.length), t.writeVarint(_(1, c));
                for(var u = 3 === i ? l.length - 1 : l.length, h = 0; h < u; h++){
                    1 === h && 1 !== i && t.writeVarint(_(2, u - 1));
                    var d = l[h].x - s, f = l[h].y - r;
                    t.writeVarint(M(d)), t.writeVarint(M(f)), s += d, r += f;
                }
                3 === i && t.writeVarint(_(7, 1));
            }
        }
        function P(e, t) {
            var o = typeof e;
            "string" === o ? t.writeStringField(1, e) : "boolean" === o ? t.writeBooleanField(7, e) : "number" === o && (e % 1 != 0 ? t.writeDoubleField(3, e) : e < 0 ? t.writeSVarintField(6, e) : t.writeVarintField(5, e));
        }
        h.exports = w, h.exports.fromVectorTileJs = w, h.exports.fromGeojsonVt = function(e, t) {
            t = t || {};
            var o = {};
            for(var i in e)o[i] = new v(e[i].features, t), o[i].name = i, o[i].version = t.version, o[i].extent = t.extent;
            return w({
                layers: o
            });
        }, h.exports.GeoJSONWrapper = v;
        var k = e.bx(h.exports);
        const T = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, D = Math.fround || (C = new Float32Array(1), (e)=>(C[0] = +e, C[0]));
        var C;
        const L = 3, O = 5, F = 6;
        class z {
            constructor(e){
                this.options = Object.assign(Object.create(T), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e) {
                const { log: t, minZoom: o, maxZoom: i } = this.options;
                t && console.time("total time");
                const s = `prepare ${e.length} points`;
                t && console.time(s), this.points = e;
                const r = [];
                for(let t = 0; t < e.length; t++){
                    const o = e[t];
                    if (!o.geometry) continue;
                    const [i, s] = o.geometry.coordinates, n = D(G(i)), a = D(j(s));
                    r.push(n, a, 1 / 0, t, -1, 1), this.options.reduce && r.push(0);
                }
                let n = this.trees[i + 1] = this._createTree(r);
                t && console.timeEnd(s);
                for(let e = i; e >= o; e--){
                    const o = +Date.now();
                    n = this.trees[e] = this._createTree(this._cluster(n, e)), t && console.log("z%d: %d clusters in %dms", e, n.numItems, +Date.now() - o);
                }
                return t && console.timeEnd("total time"), this;
            }
            getClusters(e, t) {
                let o = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e[1]));
                let s = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const r = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) o = -180, s = 180;
                else if (o > s) {
                    const e = this.getClusters([
                        o,
                        i,
                        180,
                        r
                    ], t), n = this.getClusters([
                        -180,
                        i,
                        s,
                        r
                    ], t);
                    return e.concat(n);
                }
                const n = this.trees[this._limitZoom(t)], a = n.range(G(o), j(r), G(s), j(i)), l = n.data, c = [];
                for (const e of a){
                    const t = this.stride * e;
                    c.push(l[t + O] > 1 ? A(l, t, this.clusterProps) : this.points[l[t + L]]);
                }
                return c;
            }
            getChildren(e) {
                const t = this._getOriginId(e), o = this._getOriginZoom(e), i = "No cluster with the specified id.", s = this.trees[o];
                if (!s) throw new Error(i);
                const r = s.data;
                if (t * this.stride >= r.length) throw new Error(i);
                const n = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = s.within(r[t * this.stride], r[t * this.stride + 1], n), l = [];
                for (const t of a){
                    const o = t * this.stride;
                    r[o + 4] === e && l.push(r[o + O] > 1 ? A(r, o, this.clusterProps) : this.points[r[o + L]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e, t, o) {
                const i = [];
                return this._appendLeaves(i, e, t = t || 10, o = o || 0, 0), i;
            }
            getTile(e, t, o) {
                const i = this.trees[this._limitZoom(e)], s = Math.pow(2, e), { extent: r, radius: n } = this.options, a = n / r, l = (o - a) / s, c = (o + 1 + a) / s, u = {
                    features: []
                };
                return this._addTileFeatures(i.range((t - a) / s, l, (t + 1 + a) / s, c), i.data, t, o, s, u), 0 === t && this._addTileFeatures(i.range(1 - a / s, l, 1, c), i.data, s, o, s, u), t === s - 1 && this._addTileFeatures(i.range(0, l, a / s, c), i.data, -1, o, s, u), u.features.length ? u : null;
            }
            getClusterExpansionZoom(e) {
                let t = this._getOriginZoom(e) - 1;
                for(; t <= this.options.maxZoom;){
                    const o = this.getChildren(e);
                    if (t++, 1 !== o.length) break;
                    e = o[0].properties.cluster_id;
                }
                return t;
            }
            _appendLeaves(e, t, o, i, s) {
                const r = this.getChildren(t);
                for (const t of r){
                    const r = t.properties;
                    if (r && r.cluster ? s + r.point_count <= i ? s += r.point_count : s = this._appendLeaves(e, r.cluster_id, o, i, s) : s < i ? s++ : e.push(t), e.length === o) break;
                }
                return s;
            }
            _createTree(t) {
                const o = new e.av(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t.length; e += this.stride)o.add(t[e], t[e + 1]);
                return o.finish(), o.data = t, o;
            }
            _addTileFeatures(e, t, o, i, s, r) {
                for (const n of e){
                    const e = n * this.stride, a = t[e + O] > 1;
                    let l, c, u;
                    if (a) l = E(t, e, this.clusterProps), c = t[e], u = t[e + 1];
                    else {
                        const o = this.points[t[e + L]];
                        l = o.properties;
                        const [i, s] = o.geometry.coordinates;
                        c = G(i), u = j(s);
                    }
                    const h = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * s - o)),
                                Math.round(this.options.extent * (u * s - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t[e + L] : this.points[t[e + L]].id, void 0 !== d && (h.id = d), r.features.push(h);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t) {
                const { radius: o, extent: i, reduce: s, minPoints: r } = this.options, n = o / (i * Math.pow(2, t)), a = e.data, l = [], c = this.stride;
                for(let o = 0; o < a.length; o += c){
                    if (a[o + 2] <= t) continue;
                    a[o + 2] = t;
                    const i = a[o], u = a[o + 1], h = e.within(a[o], a[o + 1], n), d = a[o + O];
                    let f = d;
                    for (const e of h){
                        const o = e * c;
                        a[o + 2] > t && (f += a[o + O]);
                    }
                    if (f > d && f >= r) {
                        let e, r = i * d, n = u * d, g = -1;
                        const p = ((o / c | 0) << 5) + (t + 1) + this.points.length;
                        for (const i of h){
                            const l = i * c;
                            if (a[l + 2] <= t) continue;
                            a[l + 2] = t;
                            const u = a[l + O];
                            r += a[l] * u, n += a[l + 1] * u, a[l + 4] = p, s && (e || (e = this._map(a, o, !0), g = this.clusterProps.length, this.clusterProps.push(e)), s(e, this._map(a, l)));
                        }
                        a[o + 4] = p, l.push(r / f, n / f, 1 / 0, p, -1, f), s && l.push(g);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[o + e]);
                        if (f > 1) for (const e of h){
                            const o = e * c;
                            if (!(a[o + 2] <= t)) {
                                a[o + 2] = t;
                                for(let e = 0; e < c; e++)l.push(a[o + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t, o) {
                if (e[t + O] > 1) {
                    const i = this.clusterProps[e[t + F]];
                    return o ? Object.assign({}, i) : i;
                }
                const i = this.points[e[t + L]].properties, s = this.options.map(i);
                return o && s === i ? Object.assign({}, s) : s;
            }
        }
        function A(e, t, o) {
            var i;
            return {
                type: "Feature",
                id: e[t + L],
                properties: E(e, t, o),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e[t], 360 * (i - .5)),
                        R(e[t + 1])
                    ]
                }
            };
        }
        function E(e, t, o) {
            const i = e[t + O], s = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, r = e[t + F], n = -1 === r ? {} : Object.assign({}, o[r]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e[t + L],
                point_count: i,
                point_count_abbreviated: s
            });
        }
        function G(e) {
            return e / 360 + .5;
        }
        function j(e) {
            const t = Math.sin(e * Math.PI / 180), o = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function R(e) {
            const t = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        function Z(e, t, o, i) {
            let s = i;
            const r = t + (o - t >> 1);
            let n, a = o - t;
            const l = e[t], c = e[t + 1], u = e[o], h = e[o + 1];
            for(let i = t + 3; i < o; i += 3){
                const t = N(e[i], e[i + 1], l, c, u, h);
                if (t > s) n = i, s = t;
                else if (t === s) {
                    const e = Math.abs(i - r);
                    e < a && (n = i, a = e);
                }
            }
            s > i && (n - t > 3 && Z(e, t, n, i), e[n + 2] = s, o - n > 3 && Z(e, n, o, i));
        }
        function N(e, t, o, i, s, r) {
            let n = s - o, a = r - i;
            if (0 !== n || 0 !== a) {
                const l = ((e - o) * n + (t - i) * a) / (n * n + a * a);
                l > 1 ? (o = s, i = r) : l > 0 && (o += n * l, i += a * l);
            }
            return n = e - o, a = t - i, n * n + a * a;
        }
        function J(e, t, o, i) {
            const s = {
                id: null == e ? null : e,
                type: t,
                geometry: o,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t || "MultiPoint" === t || "LineString" === t) W(s, o);
            else if ("Polygon" === t) W(s, o[0]);
            else if ("MultiLineString" === t) for (const e of o)W(s, e);
            else if ("MultiPolygon" === t) for (const e of o)W(s, e[0]);
            return s;
        }
        function W(e, t) {
            for(let o = 0; o < t.length; o += 3)e.minX = Math.min(e.minX, t[o]), e.minY = Math.min(e.minY, t[o + 1]), e.maxX = Math.max(e.maxX, t[o]), e.maxY = Math.max(e.maxY, t[o + 1]);
        }
        function Y(e, t, o, i) {
            if (!t.geometry) return;
            const s = t.geometry.coordinates;
            if (s && 0 === s.length) return;
            const r = t.geometry.type, n = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2);
            let a = [], l = t.id;
            if (o.promoteId ? l = t.properties[o.promoteId] : o.generateId && (l = i || 0), "Point" === r) V(s, a);
            else if ("MultiPoint" === r) for (const e of s)V(e, a);
            else if ("LineString" === r) X(s, a, n, !1);
            else if ("MultiLineString" === r) {
                if (o.lineMetrics) {
                    for (const o of s)a = [], X(o, a, n, !1), e.push(J(l, "LineString", a, t.properties));
                    return;
                }
                q(s, a, n, !1);
            } else if ("Polygon" === r) q(s, a, n, !0);
            else {
                if ("MultiPolygon" !== r) {
                    if ("GeometryCollection" === r) {
                        for (const s of t.geometry.geometries)Y(e, {
                            id: l,
                            geometry: s,
                            properties: t.properties
                        }, o, i);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e of s){
                    const t = [];
                    q(e, t, n, !0), a.push(t);
                }
            }
            e.push(J(l, r, a, t.properties));
        }
        function V(e, t) {
            t.push(B(e[0]), H(e[1]), 0);
        }
        function X(e, t, o, i) {
            let s, r, n = 0;
            for(let o = 0; o < e.length; o++){
                const a = B(e[o][0]), l = H(e[o][1]);
                t.push(a, l, 0), o > 0 && (n += i ? (s * l - a * r) / 2 : Math.sqrt(Math.pow(a - s, 2) + Math.pow(l - r, 2))), s = a, r = l;
            }
            const a = t.length - 3;
            t[2] = 1, Z(t, 0, a, o), t[a + 2] = 1, t.size = Math.abs(n), t.start = 0, t.end = t.size;
        }
        function q(e, t, o, i) {
            for(let s = 0; s < e.length; s++){
                const r = [];
                X(e[s], r, o, i), t.push(r);
            }
        }
        function B(e) {
            return e / 360 + .5;
        }
        function H(e) {
            const t = Math.sin(e * Math.PI / 180), o = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function U(e, t, o, i, s, r, n, a) {
            if (i /= t, r >= (o /= t) && n < i) return e;
            if (n < o || r >= i) return null;
            const l = [];
            for (const t of e){
                const e = t.geometry;
                let r = t.type;
                const n = 0 === s ? t.minX : t.minY, c = 0 === s ? t.maxX : t.maxY;
                if (n >= o && c < i) {
                    l.push(t);
                    continue;
                }
                if (c < o || n >= i) continue;
                let u = [];
                if ("Point" === r || "MultiPoint" === r) $(e, u, o, i, s);
                else if ("LineString" === r) K(e, u, o, i, s, !1, a.lineMetrics);
                else if ("MultiLineString" === r) ee(e, u, o, i, s, !1);
                else if ("Polygon" === r) ee(e, u, o, i, s, !0);
                else if ("MultiPolygon" === r) for (const t of e){
                    const e = [];
                    ee(t, e, o, i, s, !0), e.length && u.push(e);
                }
                if (u.length) {
                    if (a.lineMetrics && "LineString" === r) {
                        for (const e of u)l.push(J(t.id, r, e, t.tags));
                        continue;
                    }
                    "LineString" !== r && "MultiLineString" !== r || (1 === u.length ? (r = "LineString", u = u[0]) : r = "MultiLineString"), "Point" !== r && "MultiPoint" !== r || (r = 3 === u.length ? "Point" : "MultiPoint"), l.push(J(t.id, r, u, t.tags));
                }
            }
            return l.length ? l : null;
        }
        function $(e, t, o, i, s) {
            for(let r = 0; r < e.length; r += 3){
                const n = e[r + s];
                n >= o && n <= i && te(t, e[r], e[r + 1], e[r + 2]);
            }
        }
        function K(e, t, o, i, s, r, n) {
            let a = Q(e);
            const l = 0 === s ? oe : ie;
            let c, u, h = e.start;
            for(let d = 0; d < e.length - 3; d += 3){
                const f = e[d], g = e[d + 1], p = e[d + 2], m = e[d + 3], y = e[d + 4], v = 0 === s ? f : g, w = 0 === s ? m : y;
                let x = !1;
                n && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(g - y, 2))), v < o ? w > o && (u = l(a, f, g, m, y, o), n && (a.start = h + c * u)) : v > i ? w < i && (u = l(a, f, g, m, y, i), n && (a.start = h + c * u)) : te(a, f, g, p), w < o && v >= o && (u = l(a, f, g, m, y, o), x = !0), w > i && v <= i && (u = l(a, f, g, m, y, i), x = !0), !r && x && (n && (a.end = h + c * u), t.push(a), a = Q(e)), n && (h += c);
            }
            let d = e.length - 3;
            const f = e[d], g = e[d + 1], p = 0 === s ? f : g;
            p >= o && p <= i && te(a, f, g, e[d + 2]), d = a.length - 3, r && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && te(a, a[0], a[1], a[2]), a.length && t.push(a);
        }
        function Q(e) {
            const t = [];
            return t.size = e.size, t.start = e.start, t.end = e.end, t;
        }
        function ee(e, t, o, i, s, r) {
            for (const n of e)K(n, t, o, i, s, r, !1);
        }
        function te(e, t, o, i) {
            e.push(t, o, i);
        }
        function oe(e, t, o, i, s, r) {
            const n = (r - t) / (i - t);
            return te(e, r, o + (s - o) * n, 1), n;
        }
        function ie(e, t, o, i, s, r) {
            const n = (r - o) / (s - o);
            return te(e, t + (i - t) * n, r, 1), n;
        }
        function se(e, t) {
            const o = [];
            for(let i = 0; i < e.length; i++){
                const s = e[i], r = s.type;
                let n;
                if ("Point" === r || "MultiPoint" === r || "LineString" === r) n = re(s.geometry, t);
                else if ("MultiLineString" === r || "Polygon" === r) {
                    n = [];
                    for (const e of s.geometry)n.push(re(e, t));
                } else if ("MultiPolygon" === r) {
                    n = [];
                    for (const e of s.geometry){
                        const o = [];
                        for (const i of e)o.push(re(i, t));
                        n.push(o);
                    }
                }
                o.push(J(s.id, r, n, s.tags));
            }
            return o;
        }
        function re(e, t) {
            const o = [];
            o.size = e.size, void 0 !== e.start && (o.start = e.start, o.end = e.end);
            for(let i = 0; i < e.length; i += 3)o.push(e[i] + t, e[i + 1], e[i + 2]);
            return o;
        }
        function ne(e, t) {
            if (e.transformed) return e;
            const o = 1 << e.z, i = e.x, s = e.y;
            for (const r of e.features){
                const e = r.geometry, n = r.type;
                if (r.geometry = [], 1 === n) for(let n = 0; n < e.length; n += 2)r.geometry.push(ae(e[n], e[n + 1], t, o, i, s));
                else for(let n = 0; n < e.length; n++){
                    const a = [];
                    for(let r = 0; r < e[n].length; r += 2)a.push(ae(e[n][r], e[n][r + 1], t, o, i, s));
                    r.geometry.push(a);
                }
            }
            return e.transformed = !0, e;
        }
        function ae(e, t, o, i, s, r) {
            return [
                Math.round(o * (e * i - s)),
                Math.round(o * (t * i - r))
            ];
        }
        function le(e, t, o, i, s) {
            const r = t === s.maxZoom ? 0 : s.tolerance / ((1 << t) * s.extent), n = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e.length,
                source: null,
                x: o,
                y: i,
                z: t,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t of e)ce(n, t, r, s);
            return n;
        }
        function ce(e, t, o, i) {
            const s = t.geometry, r = t.type, n = [];
            if (e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), "Point" === r || "MultiPoint" === r) for(let t = 0; t < s.length; t += 3)n.push(s[t], s[t + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === r) ue(n, s, e, o, !1, !1);
            else if ("MultiLineString" === r || "Polygon" === r) for(let t = 0; t < s.length; t++)ue(n, s[t], e, o, "Polygon" === r, 0 === t);
            else if ("MultiPolygon" === r) for(let t = 0; t < s.length; t++){
                const i = s[t];
                for(let t = 0; t < i.length; t++)ue(n, i[t], e, o, !0, 0 === t);
            }
            if (n.length) {
                let o = t.tags || null;
                if ("LineString" === r && i.lineMetrics) {
                    o = {};
                    for(const e in t.tags)o[e] = t.tags[e];
                    o.mapbox_clip_start = s.start / s.size, o.mapbox_clip_end = s.end / s.size;
                }
                const a = {
                    geometry: n,
                    type: "Polygon" === r || "MultiPolygon" === r ? 3 : "LineString" === r || "MultiLineString" === r ? 2 : 1,
                    tags: o
                };
                null !== t.id && (a.id = t.id), e.features.push(a);
            }
        }
        function ue(e, t, o, i, s, r) {
            const n = i * i;
            if (i > 0 && t.size < (s ? n : i)) return void (o.numPoints += t.length / 3);
            const a = [];
            for(let e = 0; e < t.length; e += 3)(0 === i || t[e + 2] > n) && (o.numSimplified++, a.push(t[e], t[e + 1])), o.numPoints++;
            s && function(e, t) {
                let o = 0;
                for(let t = 0, i = e.length, s = i - 2; t < i; s = t, t += 2)o += (e[t] - e[s]) * (e[t + 1] + e[s + 1]);
                if (o > 0 === t) for(let t = 0, o = e.length; t < o / 2; t += 2){
                    const i = e[t], s = e[t + 1];
                    e[t] = e[o - 2 - t], e[t + 1] = e[o - 1 - t], e[o - 2 - t] = i, e[o - 1 - t] = s;
                }
            }(a, r), e.push(a);
        }
        const he = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class de {
            constructor(e, t){
                const o = (t = this.options = function(e, t) {
                    for(const o in t)e[o] = t[o];
                    return e;
                }(Object.create(he), t)).debug;
                if (o && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let i = function(e, t) {
                    const o = [];
                    if ("FeatureCollection" === e.type) for(let i = 0; i < e.features.length; i++)Y(o, e.features[i], t, i);
                    else Y(o, "Feature" === e.type ? e : {
                        geometry: e
                    }, t);
                    return o;
                }(e, t);
                this.tiles = {}, this.tileCoords = [], o && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e, t) {
                    const o = t.buffer / t.extent;
                    let i = e;
                    const s = U(e, 1, -1 - o, o, 0, -1, 2, t), r = U(e, 1, 1 - o, 2 + o, 0, -1, 2, t);
                    return (s || r) && (i = U(e, 1, -o, 1 + o, 0, -1, 2, t) || [], s && (i = se(s, 1).concat(i)), r && (i = i.concat(se(r, -1)))), i;
                }(i, t), i.length && this.splitTile(i, 0, 0, 0), o && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e, t, o, i, s, r, n) {
                const a = [
                    e,
                    t,
                    o,
                    i
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    i = a.pop(), o = a.pop(), t = a.pop(), e = a.pop();
                    const u = 1 << t, h = fe(t, o, i);
                    let d = this.tiles[h];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[h] = le(e, t, o, i, l), this.tileCoords.push({
                        z: t,
                        x: o,
                        y: i
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, o, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e = `z${t}`;
                        this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
                    }
                    if (d.source = e, null == s) {
                        if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t === l.maxZoom || t === s) continue;
                        if (null != s) {
                            const e = s - t;
                            if (o !== r >> e || i !== n >> e) continue;
                        }
                    }
                    if (d.source = null, 0 === e.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, g = .5 - f, p = .5 + f, m = 1 + f;
                    let y = null, v = null, w = null, x = null, b = U(e, u, o - f, o + p, 0, d.minX, d.maxX, l), S = U(e, u, o + g, o + m, 0, d.minX, d.maxX, l);
                    e = null, b && (y = U(b, u, i - f, i + p, 1, d.minY, d.maxY, l), v = U(b, u, i + g, i + m, 1, d.minY, d.maxY, l), b = null), S && (w = U(S, u, i - f, i + p, 1, d.minY, d.maxY, l), x = U(S, u, i + g, i + m, 1, d.minY, d.maxY, l), S = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t + 1, 2 * o, 2 * i), a.push(v || [], t + 1, 2 * o, 2 * i + 1), a.push(w || [], t + 1, 2 * o + 1, 2 * i), a.push(x || [], t + 1, 2 * o + 1, 2 * i + 1);
                }
            }
            getTile(e, t, o) {
                e = +e, t = +t, o = +o;
                const i = this.options, { extent: s, debug: r } = i;
                if (e < 0 || e > 24) return null;
                const n = 1 << e, a = fe(e, t = t + n & n - 1, o);
                if (this.tiles[a]) return ne(this.tiles[a], s);
                r > 1 && console.log("drilling down to z%d-%d-%d", e, t, o);
                let l, c = e, u = t, h = o;
                for(; !l && c > 0;)c--, u >>= 1, h >>= 1, l = this.tiles[fe(c, u, h)];
                return l && l.source ? (r > 1 && (console.log("found parent tile z%d-%d-%d", c, u, h), console.time("drilling down")), this.splitTile(l.source, c, u, h, e, t, o), r > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ne(this.tiles[a], s) : null) : null;
            }
        }
        function fe(e, t, o) {
            return 32 * ((1 << e) * o + t) + e;
        }
        function ge(e, t) {
            return t ? e.properties[t] : e.id;
        }
        function pe(e, t) {
            if (null == e) return !0;
            if ("Feature" === e.type) return null != ge(e, t);
            if ("FeatureCollection" === e.type) {
                const o = new Set;
                for (const i of e.features){
                    const e = ge(i, t);
                    if (null == e) return !1;
                    if (o.has(e)) return !1;
                    o.add(e);
                }
                return !0;
            }
            return !1;
        }
        function me(e, t) {
            const o = new Map;
            if (null == e) ;
            else if ("Feature" === e.type) o.set(ge(e, t), e);
            else for (const i of e.features)o.set(ge(i, t), i);
            return o;
        }
        class ye extends r {
            constructor(){
                super(...arguments), this._dataUpdateable = new Map;
            }
            loadVectorTile(t, o) {
                return e._(this, void 0, void 0, function*() {
                    const o = t.tileID.canonical;
                    if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                    const i = this._geoJSONIndex.getTile(o.z, o.x, o.y);
                    if (!i) return null;
                    const s = new class {
                        constructor(t){
                            this.layers = {
                                _geojsonTileLayer: this
                            }, this.name = "_geojsonTileLayer", this.extent = e.X, this.length = t.length, this._features = t;
                        }
                        feature(t) {
                            return new class {
                                constructor(t){
                                    this._feature = t, this.extent = e.X, this.type = t.type, this.properties = t.tags, "id" in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10));
                                }
                                loadGeometry() {
                                    if (1 === this._feature.type) {
                                        const t = [];
                                        for (const o of this._feature.geometry)t.push([
                                            new e.P(o[0], o[1])
                                        ]);
                                        return t;
                                    }
                                    {
                                        const t = [];
                                        for (const o of this._feature.geometry){
                                            const i = [];
                                            for (const t of o)i.push(new e.P(t[0], t[1]));
                                            t.push(i);
                                        }
                                        return t;
                                    }
                                }
                                toGeoJSON(e, t, o) {
                                    return u.call(this, e, t, o);
                                }
                            }(this._features[t]);
                        }
                    }(i.features);
                    let r = k(s);
                    return 0 === r.byteOffset && r.byteLength === r.buffer.byteLength || (r = new Uint8Array(r)), {
                        vectorTile: s,
                        rawData: r.buffer
                    };
                });
            }
            loadData(t) {
                return e._(this, void 0, void 0, function*() {
                    var o;
                    null === (o = this._pendingRequest) || void 0 === o || o.abort();
                    const i = !!(t && t.request && t.request.collectResourceTiming) && new e.bu(t.request);
                    this._pendingRequest = new AbortController;
                    try {
                        this._pendingData = this.loadAndProcessGeoJSON(t, this._pendingRequest), this._geoJSONIndex = t.cluster ? new z(function({ superclusterOptions: t, clusterProperties: o }) {
                            if (!o || !t) return t;
                            const i = {}, s = {}, r = {
                                accumulated: null,
                                zoom: 0
                            }, n = {
                                properties: null
                            }, a = Object.keys(o);
                            for (const t of a){
                                const [r, n] = o[t], a = e.bB(n), l = e.bB("string" == typeof r ? [
                                    r,
                                    [
                                        "accumulated"
                                    ],
                                    [
                                        "get",
                                        t
                                    ]
                                ] : r);
                                i[t] = a.value, s[t] = l.value;
                            }
                            return t.map = (e)=>{
                                n.properties = e;
                                const t = {};
                                for (const e of a)t[e] = i[e].evaluate(r, n);
                                return t;
                            }, t.reduce = (e, t)=>{
                                n.properties = t;
                                for (const t of a)r.accumulated = e[t], e[t] = s[t].evaluate(r, n);
                            }, t;
                        }(t)).load((yield this._pendingData).features) : (s = yield this._pendingData, new de(s, t.geojsonVtOptions)), this.loaded = {};
                        const o = {};
                        if (i) {
                            const e = i.finish();
                            e && (o.resourceTiming = {}, o.resourceTiming[t.source] = JSON.parse(JSON.stringify(e)));
                        }
                        return o;
                    } catch (t) {
                        if (delete this._pendingRequest, e.bA(t)) return {
                            abandoned: !0
                        };
                        throw t;
                    }
                    var s;
                });
            }
            getData() {
                return e._(this, void 0, void 0, function*() {
                    return this._pendingData;
                });
            }
            reloadTile(e) {
                const t = this.loaded;
                return t && t[e.uid] ? super.reloadTile(e) : this.loadTile(e);
            }
            loadAndProcessGeoJSON(t, o) {
                return e._(this, void 0, void 0, function*() {
                    let i = yield this.loadGeoJSON(t, o);
                    if (delete this._pendingRequest, "object" != typeof i) throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                    if (c(i, !0), t.filter) {
                        const o = e.bB(t.filter, {
                            type: "boolean",
                            "property-type": "data-driven",
                            overridable: !1,
                            transition: !1
                        });
                        if ("error" === o.result) throw new Error(o.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                        const s = i.features.filter((e)=>o.value.evaluate({
                                zoom: 0
                            }, e));
                        i = {
                            type: "FeatureCollection",
                            features: s
                        };
                    }
                    return i;
                });
            }
            loadGeoJSON(t, o) {
                return e._(this, void 0, void 0, function*() {
                    const { promoteId: i } = t;
                    if (t.request) {
                        const s = yield e.h(t.request, o);
                        return this._dataUpdateable = pe(s.data, i) ? me(s.data, i) : void 0, s.data;
                    }
                    if ("string" == typeof t.data) try {
                        const e = JSON.parse(t.data);
                        return this._dataUpdateable = pe(e, i) ? me(e, i) : void 0, e;
                    } catch (e) {
                        throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                    }
                    if (!t.dataDiff) throw new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`);
                    if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${t.source}`);
                    return function(e, t, o) {
                        var i, s, r, n;
                        if (t.removeAll && e.clear(), t.remove) for (const o of t.remove)e.delete(o);
                        if (t.add) for (const i of t.add){
                            const t = ge(i, o);
                            null != t && e.set(t, i);
                        }
                        if (t.update) for (const o of t.update){
                            let t = e.get(o.id);
                            if (null == t) continue;
                            const a = !o.removeAllProperties && ((null === (i = o.removeProperties) || void 0 === i ? void 0 : i.length) > 0 || (null === (s = o.addOrUpdateProperties) || void 0 === s ? void 0 : s.length) > 0);
                            if ((o.newGeometry || o.removeAllProperties || a) && (t = Object.assign({}, t), e.set(o.id, t), a && (t.properties = Object.assign({}, t.properties))), o.newGeometry && (t.geometry = o.newGeometry), o.removeAllProperties) t.properties = {};
                            else if ((null === (r = o.removeProperties) || void 0 === r ? void 0 : r.length) > 0) for (const e of o.removeProperties)Object.prototype.hasOwnProperty.call(t.properties, e) && delete t.properties[e];
                            if ((null === (n = o.addOrUpdateProperties) || void 0 === n ? void 0 : n.length) > 0) for (const { key: e, value: i } of o.addOrUpdateProperties)t.properties[e] = i;
                        }
                    }(this._dataUpdateable, t.dataDiff, i), {
                        type: "FeatureCollection",
                        features: Array.from(this._dataUpdateable.values())
                    };
                });
            }
            removeSource(t) {
                return e._(this, void 0, void 0, function*() {
                    this._pendingRequest && this._pendingRequest.abort();
                });
            }
            getClusterExpansionZoom(e) {
                return this._geoJSONIndex.getClusterExpansionZoom(e.clusterId);
            }
            getClusterChildren(e) {
                return this._geoJSONIndex.getChildren(e.clusterId);
            }
            getClusterLeaves(e) {
                return this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset);
            }
        }
        class ve {
            constructor(t){
                this.self = t, this.actor = new e.F(t), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.self.registerWorkerSource = (e, t)=>{
                    if (this.externalWorkerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.externalWorkerSourceTypes[e] = t;
                }, this.self.addProtocol = e.bh, this.self.removeProtocol = e.bi, this.self.registerRTLTextPlugin = (t)=>{
                    if (e.bC.isParsed()) throw new Error("RTL text plugin already registered.");
                    e.bC.setMethods(t);
                }, this.actor.registerMessageHandler("LDT", (e, t)=>this._getDEMWorkerSource(e, t.source).loadTile(t)), this.actor.registerMessageHandler("RDT", (t, o)=>e._(this, void 0, void 0, function*() {
                        this._getDEMWorkerSource(t, o.source).removeTile(o);
                    })), this.actor.registerMessageHandler("GCEZ", (t, o)=>e._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, o.type, o.source).getClusterExpansionZoom(o);
                    })), this.actor.registerMessageHandler("GCC", (t, o)=>e._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, o.type, o.source).getClusterChildren(o);
                    })), this.actor.registerMessageHandler("GCL", (t, o)=>e._(this, void 0, void 0, function*() {
                        return this._getWorkerSource(t, o.type, o.source).getClusterLeaves(o);
                    })), this.actor.registerMessageHandler("LD", (e, t)=>this._getWorkerSource(e, t.type, t.source).loadData(t)), this.actor.registerMessageHandler("GD", (e, t)=>this._getWorkerSource(e, t.type, t.source).getData()), this.actor.registerMessageHandler("LT", (e, t)=>this._getWorkerSource(e, t.type, t.source).loadTile(t)), this.actor.registerMessageHandler("RT", (e, t)=>this._getWorkerSource(e, t.type, t.source).reloadTile(t)), this.actor.registerMessageHandler("AT", (e, t)=>this._getWorkerSource(e, t.type, t.source).abortTile(t)), this.actor.registerMessageHandler("RMT", (e, t)=>this._getWorkerSource(e, t.type, t.source).removeTile(t)), this.actor.registerMessageHandler("RS", (t, o)=>e._(this, void 0, void 0, function*() {
                        if (!this.workerSources[t] || !this.workerSources[t][o.type] || !this.workerSources[t][o.type][o.source]) return;
                        const e = this.workerSources[t][o.type][o.source];
                        delete this.workerSources[t][o.type][o.source], void 0 !== e.removeSource && e.removeSource(o);
                    })), this.actor.registerMessageHandler("RM", (t)=>e._(this, void 0, void 0, function*() {
                        delete this.layerIndexes[t], delete this.availableImages[t], delete this.workerSources[t], delete this.demWorkerSources[t];
                    })), this.actor.registerMessageHandler("SR", (t, o)=>e._(this, void 0, void 0, function*() {
                        this.referrer = o;
                    })), this.actor.registerMessageHandler("SRPS", (e, t)=>this._syncRTLPluginState(e, t)), this.actor.registerMessageHandler("IS", (t, o)=>e._(this, void 0, void 0, function*() {
                        this.self.importScripts(o);
                    })), this.actor.registerMessageHandler("SI", (e, t)=>this._setImages(e, t)), this.actor.registerMessageHandler("UL", (t, o)=>e._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).update(o.layers, o.removedIds);
                    })), this.actor.registerMessageHandler("SL", (t, o)=>e._(this, void 0, void 0, function*() {
                        this._getLayerIndex(t).replace(o);
                    }));
            }
            _setImages(t, o) {
                return e._(this, void 0, void 0, function*() {
                    this.availableImages[t] = o;
                    for(const e in this.workerSources[t]){
                        const i = this.workerSources[t][e];
                        for(const e in i)i[e].availableImages = o;
                    }
                });
            }
            _syncRTLPluginState(t, o) {
                return e._(this, void 0, void 0, function*() {
                    if (e.bC.isParsed()) return e.bC.getState();
                    if ("loading" !== o.pluginStatus) return e.bC.setState(o), o;
                    const t = o.pluginURL;
                    if (this.self.importScripts(t), e.bC.isParsed()) {
                        const o = {
                            pluginStatus: "loaded",
                            pluginURL: t
                        };
                        return e.bC.setState(o), o;
                    }
                    throw e.bC.setState({
                        pluginStatus: "error",
                        pluginURL: ""
                    }), new Error(`RTL Text Plugin failed to import scripts from ${t}`);
                });
            }
            _getAvailableImages(e) {
                let t = this.availableImages[e];
                return t || (t = []), t;
            }
            _getLayerIndex(e) {
                let o = this.layerIndexes[e];
                return o || (o = this.layerIndexes[e] = new t), o;
            }
            _getWorkerSource(e, t, o) {
                if (this.workerSources[e] || (this.workerSources[e] = {}), this.workerSources[e][t] || (this.workerSources[e][t] = {}), !this.workerSources[e][t][o]) {
                    const i = {
                        sendAsync: (t, o)=>(t.targetMapId = e, this.actor.sendAsync(t, o))
                    };
                    switch(t){
                        case "vector":
                            this.workerSources[e][t][o] = new r(i, this._getLayerIndex(e), this._getAvailableImages(e));
                            break;
                        case "geojson":
                            this.workerSources[e][t][o] = new ye(i, this._getLayerIndex(e), this._getAvailableImages(e));
                            break;
                        default:
                            this.workerSources[e][t][o] = new this.externalWorkerSourceTypes[t](i, this._getLayerIndex(e), this._getAvailableImages(e));
                    }
                }
                return this.workerSources[e][t][o];
            }
            _getDEMWorkerSource(e, t) {
                return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}), this.demWorkerSources[e][t] || (this.demWorkerSources[e][t] = new n), this.demWorkerSources[e][t];
            }
        }
        return e.i(self) && (self.worker = new ve(self)), ve;
    });
    define("index", [
        "exports",
        "./shared"
    ], function(t, e) {
        "use strict";
        var i = "4.6.0";
        let a, s;
        const o = {
            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
            frameAsync: (t)=>new Promise((i, a)=>{
                    const s = requestAnimationFrame(i);
                    t.signal.addEventListener("abort", ()=>{
                        cancelAnimationFrame(s), a(e.c());
                    });
                }),
            getImageData (t, e = 0) {
                return this.getImageCanvasContext(t).getImageData(-e, -e, t.width + 2 * e, t.height + 2 * e);
            },
            getImageCanvasContext (t) {
                const e = window.document.createElement("canvas"), i = e.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return e.width = t.width, e.height = t.height, i.drawImage(t, 0, 0, t.width, t.height), i;
            },
            resolveURL: (t)=>(a || (a = document.createElement("a")), a.href = t, a.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return !!matchMedia && (null == s && (s = matchMedia("(prefers-reduced-motion: reduce)")), s.matches);
            }
        };
        class r {
            static testProp(t) {
                if (!r.docStyle) return t[0];
                for(let e = 0; e < t.length; e++)if (t[e] in r.docStyle) return t[e];
                return t[0];
            }
            static create(t, e, i) {
                const a = window.document.createElement(t);
                return void 0 !== e && (a.className = e), i && i.appendChild(a), a;
            }
            static createNS(t, e) {
                return window.document.createElementNS(t, e);
            }
            static disableDrag() {
                r.docStyle && r.selectProp && (r.userSelect = r.docStyle[r.selectProp], r.docStyle[r.selectProp] = "none");
            }
            static enableDrag() {
                r.docStyle && r.selectProp && (r.docStyle[r.selectProp] = r.userSelect);
            }
            static setTransform(t, e) {
                t.style[r.transformProp] = e;
            }
            static addEventListener(t, e, i, a = {}) {
                t.addEventListener(e, i, "passive" in a ? a : a.capture);
            }
            static removeEventListener(t, e, i, a = {}) {
                t.removeEventListener(e, i, "passive" in a ? a : a.capture);
            }
            static suppressClickInternal(t) {
                t.preventDefault(), t.stopPropagation(), window.removeEventListener("click", r.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", r.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", r.suppressClickInternal, !0);
                }, 0);
            }
            static getScale(t) {
                const e = t.getBoundingClientRect();
                return {
                    x: e.width / t.offsetWidth || 1,
                    y: e.height / t.offsetHeight || 1,
                    boundingClientRect: e
                };
            }
            static getPoint(t, i, a) {
                const s = i.boundingClientRect;
                return new e.P((a.clientX - s.left) / i.x - t.clientLeft, (a.clientY - s.top) / i.y - t.clientTop);
            }
            static mousePos(t, e) {
                const i = r.getScale(t);
                return r.getPoint(t, i, e);
            }
            static touchPos(t, e) {
                const i = [], a = r.getScale(t);
                for(let s = 0; s < e.length; s++)i.push(r.getPoint(t, a, e[s]));
                return i;
            }
            static mouseButton(t) {
                return t.button;
            }
            static remove(t) {
                t.parentNode && t.parentNode.removeChild(t);
            }
        }
        r.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, r.selectProp = r.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), r.transformProp = r.testProp([
            "transform",
            "WebkitTransform"
        ]);
        const n = {
            supported: !1,
            testSupport: function(t) {
                !c && h && (u ? d(t) : l = t);
            }
        };
        let l, h, c = !1, u = !1;
        function d(t) {
            const e = t.createTexture();
            t.bindTexture(t.TEXTURE_2D, e);
            try {
                if (t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, h), t.isContextLost()) return;
                n.supported = !0;
            } catch (t) {}
            t.deleteTexture(e), c = !0;
        }
        var _;
        "undefined" != typeof document && (h = document.createElement("img"), h.onload = ()=>{
            l && d(l), l = null, u = !0;
        }, h.onerror = ()=>{
            c = !0, l = null;
        }, h.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(t) {
            let i, a, s, o;
            t.resetRequestQueue = ()=>{
                i = [], a = 0, s = 0, o = {};
            }, t.addThrottleControl = (t)=>{
                const e = s++;
                return o[e] = t, e;
            }, t.removeThrottleControl = (t)=>{
                delete o[t], l();
            }, t.getImage = (t, a, s = !0)=>new Promise((o, r)=>{
                    n.supported && (t.headers || (t.headers = {}), t.headers.accept = "image/webp,*/*"), e.e(t, {
                        type: "image"
                    }), i.push({
                        abortController: a,
                        requestParameters: t,
                        supportImageRefresh: s,
                        state: "queued",
                        onError: (t)=>{
                            r(t);
                        },
                        onSuccess: (t)=>{
                            o(t);
                        }
                    }), l();
                });
            const r = (t)=>e._(this, void 0, void 0, function*() {
                    t.state = "running";
                    const { requestParameters: i, supportImageRefresh: s, onError: o, onSuccess: r, abortController: n } = t, c = !1 === s && !e.i(self) && !e.g(i.url) && (!i.headers || Object.keys(i.headers).reduce((t, e)=>t && "accept" === e, !0));
                    a++;
                    const u = c ? h(i, n) : e.m(i, n);
                    try {
                        const i = yield u;
                        delete t.abortController, t.state = "completed", i.data instanceof HTMLImageElement || e.b(i.data) ? r(i) : i.data && r({
                            data: yield (d = i.data, "function" == typeof createImageBitmap ? e.d(d) : e.f(d)),
                            cacheControl: i.cacheControl,
                            expires: i.expires
                        });
                    } catch (e) {
                        delete t.abortController, o(e);
                    } finally{
                        a--, l();
                    }
                    var d;
                }), l = ()=>{
                const t = (()=>{
                    for (const t of Object.keys(o))if (o[t]()) return !0;
                    return !1;
                })() ? e.a.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : e.a.MAX_PARALLEL_IMAGE_REQUESTS;
                for(let e = a; e < t && i.length > 0; e++){
                    const t = i.shift();
                    t.abortController.signal.aborted ? e-- : r(t);
                }
            }, h = (t, i)=>new Promise((a, s)=>{
                    const o = new Image, r = t.url, n = t.credentials;
                    n && "include" === n ? o.crossOrigin = "use-credentials" : (n && "same-origin" === n || !e.s(r)) && (o.crossOrigin = "anonymous"), i.signal.addEventListener("abort", ()=>{
                        o.src = "", s(e.c());
                    }), o.fetchPriority = "high", o.onload = ()=>{
                        o.onerror = o.onload = null, a({
                            data: o
                        });
                    }, o.onerror = ()=>{
                        o.onerror = o.onload = null, i.signal.aborted || s(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    }, o.src = r;
                });
        }(_ || (_ = {})), _.resetRequestQueue();
        class p {
            constructor(t){
                this._transformRequestFn = t;
            }
            transformRequest(t, e) {
                return this._transformRequestFn && this._transformRequestFn(t, e) || {
                    url: t
                };
            }
            setTransformRequest(t) {
                this._transformRequestFn = t;
            }
        }
        function m(t) {
            var i = new e.A(3);
            return i[0] = t[0], i[1] = t[1], i[2] = t[2], i;
        }
        var f, g = function(t, e, i) {
            return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t;
        };
        f = new e.A(3), e.A != Float32Array && (f[0] = 0, f[1] = 0, f[2] = 0);
        var v = function(t) {
            var e = t[0], i = t[1];
            return e * e + i * i;
        };
        function x(t) {
            const e = [];
            if ("string" == typeof t) e.push({
                id: "default",
                url: t
            });
            else if (t && t.length > 0) {
                const i = [];
                for (const { id: a, url: s } of t){
                    const t = `${a}${s}`;
                    -1 === i.indexOf(t) && (i.push(t), e.push({
                        id: a,
                        url: s
                    }));
                }
            }
            return e;
        }
        function y(t, e, i) {
            const a = t.split("?");
            return a[0] += `${e}${i}`, a.join("?");
        }
        !function() {
            var t = new e.A(2);
            e.A != Float32Array && (t[0] = 0, t[1] = 0);
        }();
        class b {
            constructor(t, e, i, a){
                this.context = t, this.format = i, this.texture = t.gl.createTexture(), this.update(e, a);
            }
            update(t, i, a) {
                const { width: s, height: o } = t, r = !(this.size && this.size[0] === s && this.size[1] === o || a), { context: n } = this, { gl: l } = n;
                if (this.useMipmap = Boolean(i && i.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), n.pixelStoreUnpackFlipY.set(!1), n.pixelStoreUnpack.set(1), n.pixelStoreUnpackPremultiplyAlpha.set(this.format === l.RGBA && (!i || !1 !== i.premultiply)), r) this.size = [
                    s,
                    o
                ], t instanceof HTMLImageElement || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement || t instanceof ImageData || e.b(t) ? l.texImage2D(l.TEXTURE_2D, 0, this.format, this.format, l.UNSIGNED_BYTE, t) : l.texImage2D(l.TEXTURE_2D, 0, this.format, s, o, 0, this.format, l.UNSIGNED_BYTE, t.data);
                else {
                    const { x: i, y: r } = a || {
                        x: 0,
                        y: 0
                    };
                    t instanceof HTMLImageElement || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement || t instanceof ImageData || e.b(t) ? l.texSubImage2D(l.TEXTURE_2D, 0, i, r, l.RGBA, l.UNSIGNED_BYTE, t) : l.texSubImage2D(l.TEXTURE_2D, 0, i, r, s, o, l.RGBA, l.UNSIGNED_BYTE, t.data);
                }
                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D);
            }
            bind(t, e, i) {
                const { context: a } = this, { gl: s } = a;
                s.bindTexture(s.TEXTURE_2D, this.texture), i !== s.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (i = s.LINEAR), t !== this.filter && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, t), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, i || t), this.filter = t), e !== this.wrap && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, e), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, e), this.wrap = e);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t } = this.context;
                t.deleteTexture(this.texture), this.texture = null;
            }
        }
        function w(t) {
            const { userImage: e } = t;
            return !!(e && e.render && e.render()) && (t.data.replace(new Uint8Array(e.data.buffer)), !0);
        }
        class T extends e.E {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new e.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(t) {
                if (this.loaded !== t && (this.loaded = t, t)) {
                    for (const { ids: t, promiseResolve: e } of this.requestors)e(this._getImagesForIds(t));
                    this.requestors = [];
                }
            }
            getImage(t) {
                const i = this.images[t];
                if (i && !i.data && i.spriteData) {
                    const t = i.spriteData;
                    i.data = new e.R({
                        width: t.width,
                        height: t.height
                    }, t.context.getImageData(t.x, t.y, t.width, t.height).data), i.spriteData = null;
                }
                return i;
            }
            addImage(t, e) {
                if (this.images[t]) throw new Error(`Image id ${t} already exist, use updateImage instead`);
                this._validate(t, e) && (this.images[t] = e);
            }
            _validate(t, i) {
                let a = !0;
                const s = i.data || i.spriteData;
                return this._validateStretch(i.stretchX, s && s.width) || (this.fire(new e.j(new Error(`Image "${t}" has invalid "stretchX" value`))), a = !1), this._validateStretch(i.stretchY, s && s.height) || (this.fire(new e.j(new Error(`Image "${t}" has invalid "stretchY" value`))), a = !1), this._validateContent(i.content, i) || (this.fire(new e.j(new Error(`Image "${t}" has invalid "content" value`))), a = !1), a;
            }
            _validateStretch(t, e) {
                if (!t) return !0;
                let i = 0;
                for (const a of t){
                    if (a[0] < i || a[1] < a[0] || e < a[1]) return !1;
                    i = a[1];
                }
                return !0;
            }
            _validateContent(t, e) {
                if (!t) return !0;
                if (4 !== t.length) return !1;
                const i = e.spriteData, a = i && i.width || e.data.width, s = i && i.height || e.data.height;
                return !(t[0] < 0 || a < t[0] || t[1] < 0 || s < t[1] || t[2] < 0 || a < t[2] || t[3] < 0 || s < t[3] || t[2] < t[0] || t[3] < t[1]);
            }
            updateImage(t, e, i = !0) {
                const a = this.getImage(t);
                if (i && (a.data.width !== e.data.width || a.data.height !== e.data.height)) throw new Error(`size mismatch between old image (${a.data.width}x${a.data.height}) and new image (${e.data.width}x${e.data.height}).`);
                e.version = a.version + 1, this.images[t] = e, this.updatedImages[t] = !0;
            }
            removeImage(t) {
                const e = this.images[t];
                delete this.images[t], delete this.patterns[t], e.userImage && e.userImage.onRemove && e.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(t) {
                return new Promise((e, i)=>{
                    let a = !0;
                    if (!this.isLoaded()) for (const e of t)this.images[e] || (a = !1);
                    this.isLoaded() || a ? e(this._getImagesForIds(t)) : this.requestors.push({
                        ids: t,
                        promiseResolve: e
                    });
                });
            }
            _getImagesForIds(t) {
                const i = {};
                for (const a of t){
                    let t = this.getImage(a);
                    t || (this.fire(new e.k("styleimagemissing", {
                        id: a
                    })), t = this.getImage(a)), t ? i[a] = {
                        data: t.data.clone(),
                        pixelRatio: t.pixelRatio,
                        sdf: t.sdf,
                        version: t.version,
                        stretchX: t.stretchX,
                        stretchY: t.stretchY,
                        content: t.content,
                        textFitWidth: t.textFitWidth,
                        textFitHeight: t.textFitHeight,
                        hasRenderCallback: Boolean(t.userImage && t.userImage.render)
                    } : e.w(`Image "${a}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                return i;
            }
            getPixelSize() {
                const { width: t, height: e } = this.atlasImage;
                return {
                    width: t,
                    height: e
                };
            }
            getPattern(t) {
                const i = this.patterns[t], a = this.getImage(t);
                if (!a) return null;
                if (i && i.position.version === a.version) return i.position;
                if (i) i.position.version = a.version;
                else {
                    const i = {
                        w: a.data.width + 2,
                        h: a.data.height + 2,
                        x: 0,
                        y: 0
                    }, s = new e.I(i, a);
                    this.patterns[t] = {
                        bin: i,
                        position: s
                    };
                }
                return this._updatePatternAtlas(), this.patterns[t].position;
            }
            bind(t) {
                const e = t.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new b(t, this.atlasImage, e.RGBA), this.atlasTexture.bind(e.LINEAR, e.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const t = [];
                for(const e in this.patterns)t.push(this.patterns[e].bin);
                const { w: i, h: a } = e.p(t), s = this.atlasImage;
                s.resize({
                    width: i || 1,
                    height: a || 1
                });
                for(const t in this.patterns){
                    const { bin: i } = this.patterns[t], a = i.x + 1, o = i.y + 1, r = this.getImage(t).data, n = r.width, l = r.height;
                    e.R.copy(r, s, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: o
                    }, {
                        width: n,
                        height: l
                    }), e.R.copy(r, s, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: a,
                        y: o - 1
                    }, {
                        width: n,
                        height: 1
                    }), e.R.copy(r, s, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: o + l
                    }, {
                        width: n,
                        height: 1
                    }), e.R.copy(r, s, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: a - 1,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    }), e.R.copy(r, s, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + n,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(t) {
                for (const i of t){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const t = this.getImage(i);
                    t || e.w(`Image with ID: "${i}" was not found`), w(t) && this.updateImage(i, t);
                }
            }
        }
        const I = 1e20;
        function E(t, e, i, a, s, o, r, n, l) {
            for(let h = e; h < e + a; h++)P(t, i * o + h, o, s, r, n, l);
            for(let h = i; h < i + s; h++)P(t, h * o + e, 1, a, r, n, l);
        }
        function P(t, e, i, a, s, o, r) {
            o[0] = 0, r[0] = -I, r[1] = I, s[0] = t[e];
            for(let n = 1, l = 0, h = 0; n < a; n++){
                s[n] = t[e + n * i];
                const a = n * n;
                do {
                    const t = o[l];
                    h = (s[n] - s[t] + a - t * t) / (n - t) / 2;
                }while (h <= r[l] && --l > -1);
                l++, o[l] = n, r[l] = h, r[l + 1] = I;
            }
            for(let n = 0, l = 0; n < a; n++){
                for(; r[l + 1] < n;)l++;
                const a = o[l], h = n - a;
                t[e + n * i] = s[a] + h * h;
            }
        }
        class C {
            constructor(t, e){
                this.requestManager = t, this.localIdeographFontFamily = e, this.entries = {};
            }
            setURL(t) {
                this.url = t;
            }
            getGlyphs(t) {
                return e._(this, void 0, void 0, function*() {
                    const e = [];
                    for(const i in t)for (const a of t[i])e.push(this._getAndCacheGlyphsPromise(i, a));
                    const i = yield Promise.all(e), a = {};
                    for (const { stack: t, id: e, glyph: s } of i)a[t] || (a[t] = {}), a[t][e] = s && {
                        id: s.id,
                        bitmap: s.bitmap.clone(),
                        metrics: s.metrics
                    };
                    return a;
                });
            }
            _getAndCacheGlyphsPromise(t, i) {
                return e._(this, void 0, void 0, function*() {
                    let e = this.entries[t];
                    e || (e = this.entries[t] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    let a = e.glyphs[i];
                    if (void 0 !== a) return {
                        stack: t,
                        id: i,
                        glyph: a
                    };
                    if (a = this._tinySDF(e, t, i), a) return e.glyphs[i] = a, {
                        stack: t,
                        id: i,
                        glyph: a
                    };
                    const s = Math.floor(i / 256);
                    if (256 * s > 65535) throw new Error("glyphs > 65535 not supported");
                    if (e.ranges[s]) return {
                        stack: t,
                        id: i,
                        glyph: a
                    };
                    if (!this.url) throw new Error("glyphsUrl is not set");
                    if (!e.requests[s]) {
                        const i = C.loadGlyphRange(t, s, this.url, this.requestManager);
                        e.requests[s] = i;
                    }
                    const o = yield e.requests[s];
                    for(const t in o)this._doesCharSupportLocalGlyph(+t) || (e.glyphs[+t] = o[+t]);
                    return e.ranges[s] = !0, {
                        stack: t,
                        id: i,
                        glyph: o[i] || null
                    };
                });
            }
            _doesCharSupportLocalGlyph(t) {
                return !!this.localIdeographFontFamily && /\p{Ideo}|\p{sc=Hang}|\p{sc=Hira}|\p{sc=Kana}/u.test(String.fromCodePoint(t));
            }
            _tinySDF(t, i, a) {
                const s = this.localIdeographFontFamily;
                if (!s) return;
                if (!this._doesCharSupportLocalGlyph(a)) return;
                let o = t.tinySDF;
                if (!o) {
                    let e = "400";
                    /bold/i.test(i) ? e = "900" : /medium/i.test(i) ? e = "500" : /light/i.test(i) && (e = "200"), o = t.tinySDF = new C.TinySDF({
                        fontSize: 48,
                        buffer: 6,
                        radius: 16,
                        cutoff: .25,
                        fontFamily: s,
                        fontWeight: e
                    });
                }
                const r = o.draw(String.fromCharCode(a));
                return {
                    id: a,
                    bitmap: new e.o({
                        width: r.width || 60,
                        height: r.height || 60
                    }, r.data),
                    metrics: {
                        width: r.glyphWidth / 2 || 24,
                        height: r.glyphHeight / 2 || 24,
                        left: r.glyphLeft / 2 + .5 || 0,
                        top: r.glyphTop / 2 - 27.5 || -8,
                        advance: r.glyphAdvance / 2 || 24,
                        isDoubleResolution: !0
                    }
                };
            }
        }
        C.loadGlyphRange = function(t, i, a, s) {
            return e._(this, void 0, void 0, function*() {
                const o = 256 * i, r = o + 255, n = s.transformRequest(a.replace("{fontstack}", t).replace("{range}", `${o}-${r}`), "Glyphs"), l = yield e.l(n, new AbortController);
                if (!l || !l.data) throw new Error(`Could not load glyph range. range: ${i}, ${o}-${r}`);
                const h = {};
                for (const t of e.n(l.data))h[t.id] = t;
                return h;
            });
        }, C.TinySDF = class {
            constructor({ fontSize: t = 24, buffer: e = 3, radius: i = 8, cutoff: a = .25, fontFamily: s = "sans-serif", fontWeight: o = "normal", fontStyle: r = "normal" } = {}){
                this.buffer = e, this.cutoff = a, this.radius = i;
                const n = this.size = t + 4 * e, l = this._createCanvas(n), h = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                h.font = `${r} ${o} ${t}px ${s}`, h.textBaseline = "alphabetic", h.textAlign = "left", h.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Uint16Array(n);
            }
            _createCanvas(t) {
                const e = document.createElement("canvas");
                return e.width = e.height = t, e;
            }
            draw(t) {
                const { width: e, actualBoundingBoxAscent: i, actualBoundingBoxDescent: a, actualBoundingBoxLeft: s, actualBoundingBoxRight: o } = this.ctx.measureText(t), r = Math.ceil(i), n = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - s))), l = Math.min(this.size - this.buffer, r + Math.ceil(a)), h = n + 2 * this.buffer, c = l + 2 * this.buffer, u = Math.max(h * c, 0), d = new Uint8ClampedArray(u), _ = {
                    data: d,
                    width: h,
                    height: c,
                    glyphWidth: n,
                    glyphHeight: l,
                    glyphTop: r,
                    glyphLeft: 0,
                    glyphAdvance: e
                };
                if (0 === n || 0 === l) return _;
                const { ctx: p, buffer: m, gridInner: f, gridOuter: g } = this;
                p.clearRect(m, m, n, l), p.fillText(t, m, m + r);
                const v = p.getImageData(m, m, n, l);
                g.fill(I, 0, u), f.fill(0, 0, u);
                for(let t = 0; t < l; t++)for(let e = 0; e < n; e++){
                    const i = v.data[4 * (t * n + e) + 3] / 255;
                    if (0 === i) continue;
                    const a = (t + m) * h + e + m;
                    if (1 === i) g[a] = 0, f[a] = I;
                    else {
                        const t = .5 - i;
                        g[a] = t > 0 ? t * t : 0, f[a] = t < 0 ? t * t : 0;
                    }
                }
                E(g, 0, 0, h, c, h, this.f, this.v, this.z), E(f, m, m, n, l, h, this.f, this.v, this.z);
                for(let t = 0; t < u; t++){
                    const e = Math.sqrt(g[t]) - Math.sqrt(f[t]);
                    d[t] = Math.round(255 - 255 * (e / this.radius + this.cutoff));
                }
                return _;
            }
        };
        class S {
            constructor(){
                this.specification = e.v.light.position;
            }
            possiblyEvaluate(t, i) {
                return e.x(t.expression.evaluate(i));
            }
            interpolate(t, i, a) {
                return {
                    x: e.y.number(t.x, i.x, a),
                    y: e.y.number(t.y, i.y, a),
                    z: e.y.number(t.z, i.z, a)
                };
            }
        }
        let z;
        class D extends e.E {
            constructor(t){
                super(), z = z || new e.q({
                    anchor: new e.D(e.v.light.anchor),
                    position: new S,
                    color: new e.D(e.v.light.color),
                    intensity: new e.D(e.v.light.intensity)
                }), this._transitionable = new e.T(z), this.setLight(t), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(t, i = {}) {
                if (!this._validate(e.r, t, i)) for(const e in t){
                    const i = t[e];
                    e.endsWith("-transition") ? this._transitionable.setTransition(e.slice(0, -11), i) : this._transitionable.setValue(e, i);
                }
            }
            updateTransitions(t) {
                this._transitioning = this._transitionable.transitioned(t, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(t) {
                this.properties = this._transitioning.possiblyEvaluate(t);
            }
            _validate(t, i, a) {
                return (!a || !1 !== a.validate) && e.t(this, t.call(e.u, {
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.v
                }));
            }
        }
        const M = new e.q({
            "sky-color": new e.D(e.v.sky["sky-color"]),
            "horizon-color": new e.D(e.v.sky["horizon-color"]),
            "fog-color": new e.D(e.v.sky["fog-color"]),
            "fog-ground-blend": new e.D(e.v.sky["fog-ground-blend"]),
            "horizon-fog-blend": new e.D(e.v.sky["horizon-fog-blend"]),
            "sky-horizon-blend": new e.D(e.v.sky["sky-horizon-blend"]),
            "atmosphere-blend": new e.D(e.v.sky["atmosphere-blend"])
        });
        class A extends e.E {
            constructor(t){
                super(), this._transitionable = new e.T(M), this.setSky(t), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new e.z(0));
            }
            setSky(t, i = {}) {
                if (!this._validate(e.B, t, i)) {
                    t || (t = {
                        "sky-color": "transparent",
                        "horizon-color": "transparent",
                        "fog-color": "transparent"
                    });
                    for(const e in t){
                        const i = t[e];
                        e.endsWith("-transition") ? this._transitionable.setTransition(e.slice(0, -11), i) : this._transitionable.setValue(e, i);
                    }
                }
            }
            getSky() {
                return this._transitionable.serialize();
            }
            updateTransitions(t) {
                this._transitioning = this._transitionable.transitioned(t, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(t) {
                this.properties = this._transitioning.possiblyEvaluate(t);
            }
            _validate(t, i, a = {}) {
                return !1 !== (null == a ? void 0 : a.validate) && e.t(this, t.call(e.u, e.e({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.v
                })));
            }
            calculateFogBlendOpacity(t) {
                return t < 60 ? 0 : t < 70 ? (t - 60) / 10 : 1;
            }
        }
        class R {
            constructor(t, e){
                this.width = t, this.height = e, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            getDash(t, e) {
                const i = t.join(",") + String(e);
                return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(t, e)), this.dashEntry[i];
            }
            getDashRanges(t, e, i) {
                const a = [];
                let s = t.length % 2 == 1 ? -t[t.length - 1] * i : 0, o = t[0] * i, r = !0;
                a.push({
                    left: s,
                    right: o,
                    isDash: r,
                    zeroLength: 0 === t[0]
                });
                let n = t[0];
                for(let e = 1; e < t.length; e++){
                    r = !r;
                    const l = t[e];
                    s = n * i, n += l, o = n * i, a.push({
                        left: s,
                        right: o,
                        isDash: r,
                        zeroLength: 0 === l
                    });
                }
                return a;
            }
            addRoundDash(t, e, i) {
                const a = e / 2;
                for(let e = -i; e <= i; e++){
                    const s = this.width * (this.nextRow + i + e);
                    let o = 0, r = t[o];
                    for(let n = 0; n < this.width; n++){
                        n / r.right > 1 && (r = t[++o]);
                        const l = Math.abs(n - r.left), h = Math.abs(n - r.right), c = Math.min(l, h);
                        let u;
                        const d = e / i * (a + 1);
                        if (r.isDash) {
                            const t = a - Math.abs(d);
                            u = Math.sqrt(c * c + t * t);
                        } else u = a - Math.sqrt(c * c + d * d);
                        this.data[s + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(t) {
                for(let e = t.length - 1; e >= 0; --e){
                    const i = t[e], a = t[e + 1];
                    i.zeroLength ? t.splice(e, 1) : a && a.isDash === i.isDash && (a.left = i.left, t.splice(e, 1));
                }
                const e = t[0], i = t[t.length - 1];
                e.isDash === i.isDash && (e.left = i.left - this.width, i.right = e.right + this.width);
                const a = this.width * this.nextRow;
                let s = 0, o = t[s];
                for(let e = 0; e < this.width; e++){
                    e / o.right > 1 && (o = t[++s]);
                    const i = Math.abs(e - o.left), r = Math.abs(e - o.right), n = Math.min(i, r);
                    this.data[a + e] = Math.max(0, Math.min(255, (o.isDash ? n : -n) + 128));
                }
            }
            addDash(t, i) {
                const a = i ? 7 : 0, s = 2 * a + 1;
                if (this.nextRow + s > this.height) return e.w("LineAtlas out of space"), null;
                let o = 0;
                for(let e = 0; e < t.length; e++)o += t[e];
                if (0 !== o) {
                    const e = this.width / o, s = this.getDashRanges(t, this.width, e);
                    i ? this.addRoundDash(s, e, a) : this.addRegularDash(s);
                }
                const r = {
                    y: (this.nextRow + a + .5) / this.height,
                    height: 2 * a / this.height,
                    width: o
                };
                return this.nextRow += s, this.dirty = !0, r;
            }
            bind(t) {
                const e = t.gl;
                this.texture ? (e.bindTexture(e.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, this.width, this.height, e.ALPHA, e.UNSIGNED_BYTE, this.data))) : (this.texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this.texture), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texImage2D(e.TEXTURE_2D, 0, e.ALPHA, this.width, this.height, 0, e.ALPHA, e.UNSIGNED_BYTE, this.data));
            }
        }
        const k = "maplibre_preloaded_worker_pool";
        class L {
            constructor(){
                this.active = {};
            }
            acquire(t) {
                if (!this.workers) for(this.workers = []; this.workers.length < L.workerCount;)this.workers.push(new Worker(e.a.WORKER_URL));
                return this.active[t] = !0, this.workers.slice();
            }
            release(t) {
                delete this.active[t], 0 === this.numActive() && (this.workers.forEach((t)=>{
                    t.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[k];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        const F = Math.floor(o.hardwareConcurrency / 2);
        let B, O;
        function N() {
            return B || (B = new L), B;
        }
        L.workerCount = e.C(globalThis) ? Math.max(Math.min(F, 3), 1) : 1;
        class j {
            constructor(t, i){
                this.workerPool = t, this.actors = [], this.currentActor = 0, this.id = i;
                const a = this.workerPool.acquire(i);
                for(let t = 0; t < a.length; t++){
                    const s = new e.F(a[t], i);
                    s.name = `Worker ${t}`, this.actors.push(s);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            broadcast(t, e) {
                const i = [];
                for (const a of this.actors)i.push(a.sendAsync({
                    type: t,
                    data: e
                }));
                return Promise.all(i);
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove(t = !0) {
                this.actors.forEach((t)=>{
                    t.remove();
                }), this.actors = [], t && this.workerPool.release(this.id);
            }
            registerMessageHandler(t, e) {
                for (const i of this.actors)i.registerMessageHandler(t, e);
            }
        }
        function U() {
            return O || (O = new j(N(), e.G), O.registerMessageHandler("GR", (t, i, a)=>e.m(i, a))), O;
        }
        function Z(t, i) {
            const a = e.H();
            return e.J(a, a, [
                1,
                1,
                0
            ]), e.K(a, a, [
                .5 * t.width,
                .5 * t.height,
                1
            ]), e.L(a, a, t.calculatePosMatrix(i.toUnwrapped()));
        }
        function q(t, e, i, a, s, o) {
            const r = function(t, e, i) {
                if (t) for (const a of t){
                    const t = e[a];
                    if (t && t.source === i && "fill-extrusion" === t.type) return !0;
                }
                else for(const t in e){
                    const a = e[t];
                    if (a.source === i && "fill-extrusion" === a.type) return !0;
                }
                return !1;
            }(s && s.layers, e, t.id), n = o.maxPitchScaleFactor(), l = t.tilesIn(a, n, r);
            l.sort(V);
            const h = [];
            for (const a of l)h.push({
                wrappedTileID: a.tileID.wrapped().key,
                queryResults: a.tile.queryRenderedFeatures(e, i, t._state, a.queryGeometry, a.cameraQueryGeometry, a.scale, s, o, n, Z(t.transform, a.tileID))
            });
            const c = function(t) {
                const e = {}, i = {};
                for (const a of t){
                    const t = a.queryResults, s = a.wrappedTileID, o = i[s] = i[s] || {};
                    for(const i in t){
                        const a = t[i], s = o[i] = o[i] || {}, r = e[i] = e[i] || [];
                        for (const t of a)s[t.featureIndex] || (s[t.featureIndex] = !0, r.push(t));
                    }
                }
                return e;
            }(h);
            for(const e in c)c[e].forEach((e)=>{
                const i = e.feature, a = t.getFeatureState(i.layer["source-layer"], i.id);
                i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = a;
            });
            return c;
        }
        function V(t, e) {
            const i = t.tileID, a = e.tileID;
            return i.overscaledZ - a.overscaledZ || i.canonical.y - a.canonical.y || i.wrap - a.wrap || i.canonical.x - a.canonical.x;
        }
        function G(t, i, a) {
            return e._(this, void 0, void 0, function*() {
                let s = t;
                if (t.url ? s = (yield e.h(i.transformRequest(t.url, "Source"), a)).data : yield o.frameAsync(a), !s) return null;
                const r = e.M(e.e(s, t), [
                    "tiles",
                    "minzoom",
                    "maxzoom",
                    "attribution",
                    "bounds",
                    "scheme",
                    "tileSize",
                    "encoding"
                ]);
                return "vector_layers" in s && s.vector_layers && (r.vectorLayerIds = s.vector_layers.map((t)=>t.id)), r;
            });
        }
        class H {
            constructor(t, e){
                t && (e ? this.setSouthWest(t).setNorthEast(e) : Array.isArray(t) && (4 === t.length ? this.setSouthWest([
                    t[0],
                    t[1]
                ]).setNorthEast([
                    t[2],
                    t[3]
                ]) : this.setSouthWest(t[0]).setNorthEast(t[1])));
            }
            setNorthEast(t) {
                return this._ne = t instanceof e.N ? new e.N(t.lng, t.lat) : e.N.convert(t), this;
            }
            setSouthWest(t) {
                return this._sw = t instanceof e.N ? new e.N(t.lng, t.lat) : e.N.convert(t), this;
            }
            extend(t) {
                const i = this._sw, a = this._ne;
                let s, o;
                if (t instanceof e.N) s = t, o = t;
                else {
                    if (!(t instanceof H)) return Array.isArray(t) ? 4 === t.length || t.every(Array.isArray) ? this.extend(H.convert(t)) : this.extend(e.N.convert(t)) : t && ("lng" in t || "lon" in t) && "lat" in t ? this.extend(e.N.convert(t)) : this;
                    if (s = t._sw, o = t._ne, !s || !o) return this;
                }
                return i || a ? (i.lng = Math.min(s.lng, i.lng), i.lat = Math.min(s.lat, i.lat), a.lng = Math.max(o.lng, a.lng), a.lat = Math.max(o.lat, a.lat)) : (this._sw = new e.N(s.lng, s.lat), this._ne = new e.N(o.lng, o.lat)), this;
            }
            getCenter() {
                return new e.N((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new e.N(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new e.N(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(t) {
                const { lng: i, lat: a } = e.N.convert(t);
                let s = this._sw.lng <= i && i <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (s = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= a && a <= this._ne.lat && s;
            }
            static convert(t) {
                return t instanceof H ? t : t ? new H(t) : t;
            }
            static fromLngLat(t, i = 0) {
                const a = 360 * i / 40075017, s = a / Math.cos(Math.PI / 180 * t.lat);
                return new H(new e.N(t.lng - s, t.lat - a), new e.N(t.lng + s, t.lat + a));
            }
        }
        class W {
            constructor(t, e, i){
                this.bounds = H.convert(this.validateBounds(t)), this.minzoom = e || 0, this.maxzoom = i || 24;
            }
            validateBounds(t) {
                return Array.isArray(t) && 4 === t.length ? [
                    Math.max(-180, t[0]),
                    Math.max(-90, t[1]),
                    Math.min(180, t[2]),
                    Math.min(90, t[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(t) {
                const i = Math.pow(2, t.z), a = Math.floor(e.O(this.bounds.getWest()) * i), s = Math.floor(e.Q(this.bounds.getNorth()) * i), o = Math.ceil(e.O(this.bounds.getEast()) * i), r = Math.ceil(e.Q(this.bounds.getSouth()) * i);
                return t.x >= a && t.x < o && t.y >= s && t.y < r;
            }
        }
        class $ extends e.E {
            constructor(t, i, a, s){
                if (super(), this.id = t, this.dispatcher = a, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, e.e(this, e.M(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = e.e({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(s);
            }
            load() {
                return e._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new e.k("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const t = yield G(this._options, this.map._requestManager, this._tileJSONRequest);
                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), t && (e.e(this, t), t.bounds && (this.tileBounds = new W(t.bounds, this.minzoom, this.maxzoom)), this.fire(new e.k("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.k("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        })));
                    } catch (t) {
                        this._tileJSONRequest = null, this.fire(new e.j(t));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(t) {
                return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            setSourceProperty(t) {
                this._tileJSONRequest && this._tileJSONRequest.abort(), t(), this.load();
            }
            setTiles(t) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t;
                }), this;
            }
            setUrl(t) {
                return this.setSourceProperty(()=>{
                    this.url = t, this._options.url = t;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            serialize() {
                return e.e({}, this._options);
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const e = t.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i = {
                        request: this.map._requestManager.transformRequest(e, "Tile"),
                        uid: t.uid,
                        tileID: t.tileID,
                        zoom: t.tileID.overscaledZ,
                        tileSize: this.tileSize * t.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId
                    };
                    i.request.collectResourceTiming = this._collectResourceTiming;
                    let a = "RT";
                    if (t.actor && "expired" !== t.state) {
                        if ("loading" === t.state) return new Promise((e, i)=>{
                            t.reloadPromise = {
                                resolve: e,
                                reject: i
                            };
                        });
                    } else t.actor = this.dispatcher.getActor(), a = "LT";
                    t.abortController = new AbortController;
                    try {
                        const e = yield t.actor.sendAsync({
                            type: a,
                            data: i
                        }, t.abortController);
                        if (delete t.abortController, t.aborted) return;
                        this._afterTileLoadWorkerResponse(t, e);
                    } catch (e) {
                        if (delete t.abortController, t.aborted) return;
                        if (e && 404 !== e.status) throw e;
                        this._afterTileLoadWorkerResponse(t, null);
                    }
                });
            }
            _afterTileLoadWorkerResponse(t, e) {
                if (e && e.resourceTiming && (t.resourceTiming = e.resourceTiming), e && this.map._refreshExpiredTiles && t.setExpiryData(e), t.loadVectorData(e, this.map.painter), t.reloadPromise) {
                    const e = t.reloadPromise;
                    t.reloadPromise = null, this.loadTile(t).then(e.resolve).catch(e.reject);
                }
            }
            abortTile(t) {
                return e._(this, void 0, void 0, function*() {
                    t.abortController && (t.abortController.abort(), delete t.abortController), t.actor && (yield t.actor.sendAsync({
                        type: "AT",
                        data: {
                            uid: t.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            unloadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    t.unloadVectorData(), t.actor && (yield t.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: t.uid,
                            type: this.type,
                            source: this.id
                        }
                    }));
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class X extends e.E {
            constructor(t, i, a, s){
                super(), this.id = t, this.dispatcher = a, this.setEventedParent(s), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = e.e({
                    type: "raster"
                }, i), e.e(this, e.M(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load() {
                return e._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new e.k("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = new AbortController;
                    try {
                        const t = yield G(this._options, this.map._requestManager, this._tileJSONRequest);
                        this._tileJSONRequest = null, this._loaded = !0, t && (e.e(this, t), t.bounds && (this.tileBounds = new W(t.bounds, this.minzoom, this.maxzoom)), this.fire(new e.k("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.k("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        })));
                    } catch (t) {
                        this._tileJSONRequest = null, this.fire(new e.j(t));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
            }
            setSourceProperty(t) {
                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), t(), this.load();
            }
            setTiles(t) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t;
                }), this;
            }
            setUrl(t) {
                return this.setSourceProperty(()=>{
                    this.url = t, this._options.url = t;
                }), this;
            }
            serialize() {
                return e.e({}, this._options);
            }
            hasTile(t) {
                return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const e = t.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                    t.abortController = new AbortController;
                    try {
                        const i = yield _.getImage(this.map._requestManager.transformRequest(e, "Tile"), t.abortController, this.map._refreshExpiredTiles);
                        if (delete t.abortController, t.aborted) return void (t.state = "unloaded");
                        if (i && i.data) {
                            this.map._refreshExpiredTiles && i.cacheControl && i.expires && t.setExpiryData({
                                cacheControl: i.cacheControl,
                                expires: i.expires
                            });
                            const e = this.map.painter.context, a = e.gl, s = i.data;
                            t.texture = this.map.painter.getTileTexture(s.width), t.texture ? t.texture.update(s, {
                                useMipmap: !0
                            }) : (t.texture = new b(e, s, a.RGBA, {
                                useMipmap: !0
                            }), t.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST)), t.state = "loaded";
                        }
                    } catch (e) {
                        if (delete t.abortController, t.aborted) t.state = "unloaded";
                        else if (e) throw t.state = "errored", e;
                    }
                });
            }
            abortTile(t) {
                return e._(this, void 0, void 0, function*() {
                    t.abortController && (t.abortController.abort(), delete t.abortController);
                });
            }
            unloadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    t.texture && this.map.painter.saveTileTexture(t.texture);
                });
            }
            hasTransition() {
                return !1;
            }
        }
        class K extends X {
            constructor(t, i, a, s){
                super(t, i, a, s), this.type = "raster-dem", this.maxzoom = 22, this._options = e.e({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox", this.redFactor = i.redFactor, this.greenFactor = i.greenFactor, this.blueFactor = i.blueFactor, this.baseShift = i.baseShift;
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const i = t.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), a = this.map._requestManager.transformRequest(i, "Tile");
                    t.neighboringTiles = this._getNeighboringTiles(t.tileID), t.abortController = new AbortController;
                    try {
                        const i = yield _.getImage(a, t.abortController, this.map._refreshExpiredTiles);
                        if (delete t.abortController, t.aborted) return void (t.state = "unloaded");
                        if (i && i.data) {
                            const a = i.data;
                            this.map._refreshExpiredTiles && i.cacheControl && i.expires && t.setExpiryData({
                                cacheControl: i.cacheControl,
                                expires: i.expires
                            });
                            const s = e.b(a) && e.U() ? a : yield this.readImageNow(a), o = {
                                type: this.type,
                                uid: t.uid,
                                source: this.id,
                                rawImageData: s,
                                encoding: this.encoding,
                                redFactor: this.redFactor,
                                greenFactor: this.greenFactor,
                                blueFactor: this.blueFactor,
                                baseShift: this.baseShift
                            };
                            if (!t.actor || "expired" === t.state) {
                                t.actor = this.dispatcher.getActor();
                                const e = yield t.actor.sendAsync({
                                    type: "LDT",
                                    data: o
                                });
                                t.dem = e, t.needsHillshadePrepare = !0, t.needsTerrainPrepare = !0, t.state = "loaded";
                            }
                        }
                    } catch (e) {
                        if (delete t.abortController, t.aborted) t.state = "unloaded";
                        else if (e) throw t.state = "errored", e;
                    }
                });
            }
            readImageNow(t) {
                return e._(this, void 0, void 0, function*() {
                    if ("undefined" != typeof VideoFrame && e.V()) {
                        const i = t.width + 2, a = t.height + 2;
                        try {
                            return new e.R({
                                width: i,
                                height: a
                            }, (yield e.W(t, -1, -1, i, a)));
                        } catch (t) {}
                    }
                    return o.getImageData(t, 1);
                });
            }
            _getNeighboringTiles(t) {
                const i = t.canonical, a = Math.pow(2, i.z), s = (i.x - 1 + a) % a, o = 0 === i.x ? t.wrap - 1 : t.wrap, r = (i.x + 1 + a) % a, n = i.x + 1 === a ? t.wrap + 1 : t.wrap, l = {};
                return l[new e.S(t.overscaledZ, o, i.z, s, i.y).key] = {
                    backfilled: !1
                }, l[new e.S(t.overscaledZ, n, i.z, r, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new e.S(t.overscaledZ, o, i.z, s, i.y - 1).key] = {
                    backfilled: !1
                }, l[new e.S(t.overscaledZ, t.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new e.S(t.overscaledZ, n, i.z, r, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < a && (l[new e.S(t.overscaledZ, o, i.z, s, i.y + 1).key] = {
                    backfilled: !1
                }, l[new e.S(t.overscaledZ, t.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new e.S(t.overscaledZ, n, i.z, r, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    t.demTexture && this.map.painter.saveTileTexture(t.demTexture), t.fbo && (t.fbo.destroy(), delete t.fbo), t.dem && delete t.dem, delete t.neighboringTiles, t.state = "unloaded", t.actor && (yield t.actor.sendAsync({
                        type: "RDT",
                        data: {
                            type: this.type,
                            uid: t.uid,
                            source: this.id
                        }
                    }));
                });
            }
        }
        class J extends e.E {
            constructor(t, i, a, s){
                super(), this.id = t, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = a.getActor(), this.setEventedParent(s), this._data = i.data, this._options = e.e({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                const o = e.X / this.tileSize;
                this.workerOptions = e.e({
                    source: this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: (void 0 !== i.buffer ? i.buffer : 128) * o,
                        tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * o,
                        extent: e.X,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: e.X,
                        radius: (i.clusterRadius || 50) * o,
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
            }
            load() {
                return e._(this, void 0, void 0, function*() {
                    yield this._updateWorkerData();
                });
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            setData(t) {
                return this._data = t, this._updateWorkerData(), this;
            }
            updateData(t) {
                return this._updateWorkerData(t), this;
            }
            getData() {
                return e._(this, void 0, void 0, function*() {
                    const t = e.e({
                        type: this.type
                    }, this.workerOptions);
                    return this.actor.sendAsync({
                        type: "GD",
                        data: t
                    });
                });
            }
            setClusterOptions(t) {
                return this.workerOptions.cluster = t.cluster, t && (void 0 !== t.clusterRadius && (this.workerOptions.superclusterOptions.radius = t.clusterRadius), void 0 !== t.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = t.clusterMaxZoom)), this._updateWorkerData(), this;
            }
            getClusterExpansionZoom(t) {
                return this.actor.sendAsync({
                    type: "GCEZ",
                    data: {
                        type: this.type,
                        clusterId: t,
                        source: this.id
                    }
                });
            }
            getClusterChildren(t) {
                return this.actor.sendAsync({
                    type: "GCC",
                    data: {
                        type: this.type,
                        clusterId: t,
                        source: this.id
                    }
                });
            }
            getClusterLeaves(t, e, i) {
                return this.actor.sendAsync({
                    type: "GCL",
                    data: {
                        type: this.type,
                        source: this.id,
                        clusterId: t,
                        limit: e,
                        offset: i
                    }
                });
            }
            _updateWorkerData(t) {
                return e._(this, void 0, void 0, function*() {
                    const i = e.e({
                        type: this.type
                    }, this.workerOptions);
                    t ? i.dataDiff = t : "string" == typeof this._data ? (i.request = this.map._requestManager.transformRequest(o.resolveURL(this._data), "Source"), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new e.k("dataloading", {
                        dataType: "source"
                    }));
                    try {
                        const t = yield this.actor.sendAsync({
                            type: "LD",
                            data: i
                        });
                        if (this._pendingLoads--, this._removed || t.abandoned) return void this.fire(new e.k("dataabort", {
                            dataType: "source"
                        }));
                        let a = null;
                        t.resourceTiming && t.resourceTiming[this.id] && (a = t.resourceTiming[this.id].slice(0));
                        const s = {
                            dataType: "source"
                        };
                        this._collectResourceTiming && a && a.length > 0 && e.e(s, {
                            resourceTiming: a
                        }), this.fire(new e.k("data", Object.assign(Object.assign({}, s), {
                            sourceDataType: "metadata"
                        }))), this.fire(new e.k("data", Object.assign(Object.assign({}, s), {
                            sourceDataType: "content"
                        })));
                    } catch (t) {
                        if (this._pendingLoads--, this._removed) return void this.fire(new e.k("dataabort", {
                            dataType: "source"
                        }));
                        this.fire(new e.j(t));
                    }
                });
            }
            loaded() {
                return 0 === this._pendingLoads;
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    const e = t.actor ? "RT" : "LT";
                    t.actor = this.actor;
                    const i = {
                        type: this.type,
                        uid: t.uid,
                        tileID: t.tileID,
                        zoom: t.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        pixelRatio: this.map.getPixelRatio(),
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId
                    };
                    t.abortController = new AbortController;
                    const a = yield this.actor.sendAsync({
                        type: e,
                        data: i
                    }, t.abortController);
                    delete t.abortController, t.unloadVectorData(), t.aborted || t.loadVectorData(a, this.map.painter, "RT" === e);
                });
            }
            abortTile(t) {
                return e._(this, void 0, void 0, function*() {
                    t.abortController && (t.abortController.abort(), delete t.abortController), t.aborted = !0;
                });
            }
            unloadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    t.unloadVectorData(), yield this.actor.sendAsync({
                        type: "RMT",
                        data: {
                            uid: t.uid,
                            type: this.type,
                            source: this.id
                        }
                    });
                });
            }
            onRemove() {
                this._removed = !0, this.actor.sendAsync({
                    type: "RS",
                    data: {
                        type: this.type,
                        source: this.id
                    }
                });
            }
            serialize() {
                return e.e({}, this._options, {
                    type: this.type,
                    data: this._data
                });
            }
            hasTransition() {
                return !1;
            }
        }
        var Y = e.Y([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class Q extends e.E {
            constructor(t, e, i, a){
                super(), this.id = t, this.dispatcher = i, this.coordinates = e.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(a), this.options = e;
            }
            load(t) {
                return e._(this, void 0, void 0, function*() {
                    this._loaded = !1, this.fire(new e.k("dataloading", {
                        dataType: "source"
                    })), this.url = this.options.url, this._request = new AbortController;
                    try {
                        const e = yield _.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                        this._request = null, this._loaded = !0, e && e.data && (this.image = e.data, t && (this.coordinates = t), this._finishLoading());
                    } catch (t) {
                        this._request = null, this._loaded = !0, this.fire(new e.j(t));
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t) {
                return t.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = t.url, this.load(t.coordinates).finally(()=>{
                    this.texture = null;
                }), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new e.k("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            onRemove() {
                this._request && (this._request.abort(), this._request = null);
            }
            setCoordinates(t) {
                this.coordinates = t;
                const i = t.map(e.Z.fromLngLat);
                this.tileID = function(t) {
                    let i = 1 / 0, a = 1 / 0, s = -1 / 0, o = -1 / 0;
                    for (const e of t)i = Math.min(i, e.x), a = Math.min(a, e.y), s = Math.max(s, e.x), o = Math.max(o, e.y);
                    const r = Math.max(s - i, o - a), n = Math.max(0, Math.floor(-Math.log(r) / Math.LN2)), l = Math.pow(2, n);
                    return new e.a1(n, Math.floor((i + s) / 2 * l), Math.floor((a + o) / 2 * l));
                }(i), this.minzoom = this.maxzoom = this.tileID.z;
                const a = i.map((t)=>this.tileID.getTilePoint(t)._round());
                return this._boundsArray = new e.$, this._boundsArray.emplaceBack(a[0].x, a[0].y, 0, 0), this._boundsArray.emplaceBack(a[1].x, a[1].y, e.X, 0), this._boundsArray.emplaceBack(a[3].x, a[3].y, 0, e.X), this._boundsArray.emplaceBack(a[2].x, a[2].y, e.X, e.X), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new e.k("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || !this.image) return;
                const t = this.map.painter.context, i = t.gl;
                this.boundsBuffer || (this.boundsBuffer = t.createVertexBuffer(this._boundsArray, Y.members)), this.boundsSegments || (this.boundsSegments = e.a0.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new b(t, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let a = !1;
                for(const t in this.tiles){
                    const e = this.tiles[t];
                    "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, a = !0);
                }
                a && this.fire(new e.k("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            loadTile(t) {
                return e._(this, void 0, void 0, function*() {
                    this.tileID && this.tileID.equals(t.tileID.canonical) ? (this.tiles[String(t.tileID.wrap)] = t, t.buckets = {}) : t.state = "errored";
                });
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
        }
        class tt extends Q {
            constructor(t, e, i, a){
                super(t, e, i, a), this.roundZoom = !0, this.type = "video", this.options = e;
            }
            load() {
                return e._(this, void 0, void 0, function*() {
                    this._loaded = !1;
                    const t = this.options;
                    this.urls = [];
                    for (const e of t.urls)this.urls.push(this.map._requestManager.transformRequest(e, "Source").url);
                    try {
                        const t = yield e.a3(this.urls);
                        if (this._loaded = !0, !t) return;
                        this.video = t, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading();
                    } catch (t) {
                        this.fire(new e.j(t));
                    }
                });
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(t) {
                if (this.video) {
                    const i = this.video.seekable;
                    t < i.start(0) || t > i.end(0) ? this.fire(new e.j(new e.a2(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(t) {
                this.map || (this.map = t, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            prepare() {
                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                const t = this.map.painter.context, i = t.gl;
                this.boundsBuffer || (this.boundsBuffer = t.createVertexBuffer(this._boundsArray, Y.members)), this.boundsSegments || (this.boundsSegments = e.a0.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new b(t, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                let a = !1;
                for(const t in this.tiles){
                    const e = this.tiles[t];
                    "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, a = !0);
                }
                a && this.fire(new e.k("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "video",
                    urls: this.urls,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
        }
        class et extends Q {
            constructor(t, i, a, s){
                super(t, i, a, s), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((t)=>!Array.isArray(t) || 2 !== t.length || t.some((t)=>"number" != typeof t)) || this.fire(new e.j(new e.a2(`sources.${t}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.j(new e.a2(`sources.${t}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e.j(new e.a2(`sources.${t}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e.j(new e.a2(`sources.${t}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.j(new e.a2(`sources.${t}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
            load() {
                return e._(this, void 0, void 0, function*() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.j(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                });
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(t) {
                this.map = t, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            prepare() {
                let t = !1;
                if (this.canvas.width !== this.width && (this.width = this.canvas.width, t = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t = !0), this._hasInvalidDimensions()) return;
                if (0 === Object.keys(this.tiles).length) return;
                const i = this.map.painter.context, a = i.gl;
                this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, Y.members)), this.boundsSegments || (this.boundsSegments = e.a0.simpleSegment(0, 0, 4, 2)), this.texture ? (t || this._playing) && this.texture.update(this.canvas, {
                    premultiply: !0
                }) : this.texture = new b(i, this.canvas, a.RGBA, {
                    premultiply: !0
                });
                let s = !1;
                for(const t in this.tiles){
                    const e = this.tiles[t];
                    "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, s = !0);
                }
                s && this.fire(new e.k("data", {
                    dataType: "source",
                    sourceDataType: "idle",
                    sourceId: this.id
                }));
            }
            serialize() {
                return {
                    type: "canvas",
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const t of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(t) || t <= 0) return !0;
                return !1;
            }
        }
        const it = {}, at = (t)=>{
            switch(t){
                case "geojson":
                    return J;
                case "image":
                    return Q;
                case "raster":
                    return X;
                case "raster-dem":
                    return K;
                case "vector":
                    return $;
                case "video":
                    return tt;
                case "canvas":
                    return et;
            }
            return it[t];
        }, st = "RTLPluginLoaded";
        class ot extends e.E {
            constructor(){
                super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = U();
            }
            _syncState(t) {
                return this.status = t, this.dispatcher.broadcast("SRPS", {
                    pluginStatus: t,
                    pluginURL: this.url
                }).catch((t)=>{
                    throw this.status = "error", t;
                });
            }
            getRTLTextPluginStatus() {
                return this.status;
            }
            clearRTLTextPlugin() {
                this.status = "unavailable", this.url = null;
            }
            setRTLTextPlugin(t) {
                return e._(this, arguments, void 0, function*(t, e = !1) {
                    if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                    if (this.url = o.resolveURL(t), !this.url) throw new Error(`requested url ${t} is invalid`);
                    if ("unavailable" === this.status) {
                        if (!e) return this._requestImport();
                        this.status = "deferred", this._syncState(this.status);
                    } else if ("requested" === this.status) return this._requestImport();
                });
            }
            _requestImport() {
                return e._(this, void 0, void 0, function*() {
                    yield this._syncState("loading"), this.status = "loaded", this.fire(new e.k(st));
                });
            }
            lazyLoad() {
                "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
            }
        }
        let rt = null;
        function nt() {
            return rt || (rt = new ot), rt;
        }
        class lt {
            constructor(t, i){
                this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = t, this.uid = e.a4(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            registerFadeDuration(t) {
                const e = t + this.timeAdded;
                e < this.fadeEndTime || (this.fadeEndTime = e);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(t) {
                this.demTexture && t.saveTileTexture(this.demTexture), this.demTexture = null;
            }
            loadVectorData(t, i, a) {
                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", t) {
                    t.featureIndex && (this.latestFeatureIndex = t.featureIndex, t.rawTileData ? (this.latestRawTileData = t.rawTileData, this.latestFeatureIndex.rawTileData = t.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t.collisionBoxArray, this.buckets = function(t, e) {
                        const i = {};
                        if (!e) return i;
                        for (const a of t){
                            const t = a.layerIds.map((t)=>e.getLayer(t)).filter(Boolean);
                            if (0 !== t.length) {
                                a.layers = t, a.stateDependentLayerIds && (a.stateDependentLayers = a.stateDependentLayerIds.map((e)=>t.filter((t)=>t.id === e)[0]));
                                for (const e of t)i[e.id] = a;
                            }
                        }
                        return i;
                    }(t.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const t in this.buckets){
                        const i = this.buckets[t];
                        if (i instanceof e.a6) {
                            if (this.hasSymbolBuckets = !0, !a) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t in this.buckets){
                        const i = this.buckets[t];
                        if (i instanceof e.a6 && i.hasRTLText) {
                            this.hasRTLText = !0, nt().lazyLoad();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const t in this.buckets){
                        const e = this.buckets[t];
                        this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(t).queryRadius(e));
                    }
                    t.imageAtlas && (this.imageAtlas = t.imageAtlas), t.glyphAtlasImage && (this.glyphAtlasImage = t.glyphAtlasImage);
                } else this.collisionBoxArray = new e.a5;
            }
            unloadVectorData() {
                for(const t in this.buckets)this.buckets[t].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(t) {
                return this.buckets[t.id];
            }
            upload(t) {
                for(const e in this.buckets){
                    const i = this.buckets[e];
                    i.uploadPending() && i.upload(t);
                }
                const e = t.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new b(t, this.imageAtlas.image, e.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new b(t, this.glyphAtlasImage, e.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(t) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t, this.imageAtlasTexture);
            }
            queryRenderedFeatures(t, e, i, a, s, o, r, n, l, h) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    queryGeometry: a,
                    cameraQueryGeometry: s,
                    scale: o,
                    tileSize: this.tileSize,
                    pixelPosMatrix: h,
                    transform: n,
                    params: r,
                    queryPadding: this.queryPadding * l
                }, t, e, i) : {};
            }
            querySourceFeatures(t, i) {
                const a = this.latestFeatureIndex;
                if (!a || !a.rawTileData) return;
                const s = a.loadVTLayers(), o = i && i.sourceLayer ? i.sourceLayer : "", r = s._geojsonTileLayer || s[o];
                if (!r) return;
                const n = e.a7(i && i.filter), { z: l, x: h, y: c } = this.tileID.canonical, u = {
                    z: l,
                    x: h,
                    y: c
                };
                for(let i = 0; i < r.length; i++){
                    const s = r.feature(i);
                    if (n.needGeometry) {
                        const t = e.a8(s, !0);
                        if (!n.filter(new e.z(this.tileID.overscaledZ), t, this.tileID.canonical)) continue;
                    } else if (!n.filter(new e.z(this.tileID.overscaledZ), s)) continue;
                    const d = a.getId(s, o), _ = new e.a9(s, l, h, c, d);
                    _.tile = u, t.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(t) {
                const i = this.expirationTime;
                if (t.cacheControl) {
                    const i = e.aa(t.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else t.expires && (this.expirationTime = new Date(t.expires).getTime());
                if (this.expirationTime) {
                    const t = Date.now();
                    let e = !1;
                    if (this.expirationTime > t) e = !1;
                    else if (i) {
                        if (this.expirationTime < i) e = !0;
                        else {
                            const a = this.expirationTime - i;
                            a ? this.expirationTime = t + Math.max(a, 3e4) : e = !0;
                        }
                    } else e = !0;
                    e ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(t, e) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t).length) return;
                const i = this.latestFeatureIndex.loadVTLayers();
                for(const a in this.buckets){
                    if (!e.style.hasLayer(a)) continue;
                    const s = this.buckets[a], o = s.layers[0].sourceLayer || "_geojsonTileLayer", r = i[o], n = t[o];
                    if (!r || !n || 0 === Object.keys(n).length) continue;
                    s.update(n, r, this.imageAtlas && this.imageAtlas.patternPositions || {});
                    const l = e && e.style && e.style.getLayer(a);
                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(s)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < o.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t) {
                this.symbolFadeHoldUntil = o.now() + t;
            }
            setDependencies(t, e) {
                const i = {};
                for (const t of e)i[t] = !0;
                this.dependencies[t] = i;
            }
            hasDependency(t, e) {
                for (const i of t){
                    const t = this.dependencies[i];
                    if (t) {
                        for (const i of e)if (t[i]) return !0;
                    }
                }
                return !1;
            }
        }
        class ht {
            constructor(t, e){
                this.max = t, this.onRemove = e, this.reset();
            }
            reset() {
                for(const t in this.data)for (const e of this.data[t])e.timeout && clearTimeout(e.timeout), this.onRemove(e.value);
                return this.data = {}, this.order = [], this;
            }
            add(t, e, i) {
                const a = t.wrapped().key;
                void 0 === this.data[a] && (this.data[a] = []);
                const s = {
                    value: e,
                    timeout: void 0
                };
                if (void 0 !== i && (s.timeout = setTimeout(()=>{
                    this.remove(t, s);
                }, i)), this.data[a].push(s), this.order.push(a), this.order.length > this.max) {
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            has(t) {
                return t.wrapped().key in this.data;
            }
            getAndRemove(t) {
                return this.has(t) ? this._getAndRemoveByKey(t.wrapped().key) : null;
            }
            _getAndRemoveByKey(t) {
                const e = this.data[t].shift();
                return e.timeout && clearTimeout(e.timeout), 0 === this.data[t].length && delete this.data[t], this.order.splice(this.order.indexOf(t), 1), e.value;
            }
            getByKey(t) {
                const e = this.data[t];
                return e ? e[0].value : null;
            }
            get(t) {
                return this.has(t) ? this.data[t.wrapped().key][0].value : null;
            }
            remove(t, e) {
                if (!this.has(t)) return this;
                const i = t.wrapped().key, a = void 0 === e ? 0 : this.data[i].indexOf(e), s = this.data[i][a];
                return this.data[i].splice(a, 1), s.timeout && clearTimeout(s.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(s.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(t) {
                for(this.max = t; this.order.length > this.max;){
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            filter(t) {
                const e = [];
                for(const i in this.data)for (const a of this.data[i])t(a.value) || e.push(a);
                for (const t of e)this.remove(t.value.tileID, t);
            }
        }
        class ct {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(t, i, a) {
                const s = String(i);
                if (this.stateChanges[t] = this.stateChanges[t] || {}, this.stateChanges[t][s] = this.stateChanges[t][s] || {}, e.e(this.stateChanges[t][s], a), null === this.deletedStates[t]) {
                    this.deletedStates[t] = {};
                    for(const e in this.state[t])e !== s && (this.deletedStates[t][e] = null);
                } else if (this.deletedStates[t] && null === this.deletedStates[t][s]) {
                    this.deletedStates[t][s] = {};
                    for(const e in this.state[t][s])a[e] || (this.deletedStates[t][s][e] = null);
                } else for(const e in a)this.deletedStates[t] && this.deletedStates[t][s] && null === this.deletedStates[t][s][e] && delete this.deletedStates[t][s][e];
            }
            removeFeatureState(t, e, i) {
                if (null === this.deletedStates[t]) return;
                const a = String(e);
                if (this.deletedStates[t] = this.deletedStates[t] || {}, i && void 0 !== e) null !== this.deletedStates[t][a] && (this.deletedStates[t][a] = this.deletedStates[t][a] || {}, this.deletedStates[t][a][i] = null);
                else if (void 0 !== e) {
                    if (this.stateChanges[t] && this.stateChanges[t][a]) for(i in this.deletedStates[t][a] = {}, this.stateChanges[t][a])this.deletedStates[t][a][i] = null;
                    else this.deletedStates[t][a] = null;
                } else this.deletedStates[t] = null;
            }
            getState(t, i) {
                const a = String(i), s = e.e({}, (this.state[t] || {})[a], (this.stateChanges[t] || {})[a]);
                if (null === this.deletedStates[t]) return {};
                if (this.deletedStates[t]) {
                    const e = this.deletedStates[t][i];
                    if (null === e) return {};
                    for(const t in e)delete s[t];
                }
                return s;
            }
            initializeTileState(t, e) {
                t.setFeatureState(this.state, e);
            }
            coalesceChanges(t, i) {
                const a = {};
                for(const t in this.stateChanges){
                    this.state[t] = this.state[t] || {};
                    const i = {};
                    for(const a in this.stateChanges[t])this.state[t][a] || (this.state[t][a] = {}), e.e(this.state[t][a], this.stateChanges[t][a]), i[a] = this.state[t][a];
                    a[t] = i;
                }
                for(const t in this.deletedStates){
                    this.state[t] = this.state[t] || {};
                    const i = {};
                    if (null === this.deletedStates[t]) for(const e in this.state[t])i[e] = {}, this.state[t][e] = {};
                    else for(const e in this.deletedStates[t]){
                        if (null === this.deletedStates[t][e]) this.state[t][e] = {};
                        else for (const i of Object.keys(this.deletedStates[t][e]))delete this.state[t][e][i];
                        i[e] = this.state[t][e];
                    }
                    a[t] = a[t] || {}, e.e(a[t], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(a).length) for(const e in t)t[e].setFeatureState(a, i);
            }
        }
        class ut extends e.E {
            constructor(t, e, i){
                super(), this.id = t, this.dispatcher = i, this.on("data", (t)=>this._dataHandler(t)), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = ((t, e, i, a)=>{
                    const s = new (at(e.type))(t, e, i, a);
                    if (s.id !== t) throw new Error(`Expected Source id to be ${t} instead of ${s.id}`);
                    return s;
                })(t, e, i, this), this._tiles = {}, this._cache = new ht(0, (t)=>this._unloadTile(t)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new ct, this._didEmitContent = !1, this._updated = !1;
            }
            onAdd(t) {
                this.map = t, this._maxTileCacheSize = t ? t._maxTileCacheSize : null, this._maxTileCacheZoomLevels = t ? t._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(t);
            }
            onRemove(t) {
                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(t);
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                if (!this._updated) return !1;
                for(const t in this._tiles){
                    const e = this._tiles[t];
                    if ("loaded" !== e.state && "errored" !== e.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const t = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(t, i, a) {
                return e._(this, void 0, void 0, function*() {
                    try {
                        yield this._source.loadTile(t), this._tileLoaded(t, i, a);
                    } catch (i) {
                        t.state = "errored", 404 !== i.status ? this._source.fire(new e.j(i, {
                            tile: t
                        })) : this.update(this.transform, this.terrain);
                    }
                });
            }
            _unloadTile(t) {
                this._source.unloadTile && this._source.unloadTile(t);
            }
            _abortTile(t) {
                this._source.abortTile && this._source.abortTile(t), this._source.fire(new e.k("dataabort", {
                    tile: t,
                    coord: t.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(t) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const e in this._tiles){
                    const i = this._tiles[e];
                    i.upload(t), i.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((t)=>t.tileID).sort(dt).map((t)=>t.key);
            }
            getRenderableIds(t) {
                const i = [];
                for(const e in this._tiles)this._isIdRenderable(e, t) && i.push(this._tiles[e]);
                return t ? i.sort((t, i)=>{
                    const a = t.tileID, s = i.tileID, o = new e.P(a.canonical.x, a.canonical.y)._rotate(this.transform.angle), r = new e.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle);
                    return a.overscaledZ - s.overscaledZ || r.y - o.y || r.x - o.x;
                }).map((t)=>t.tileID.key) : i.map((t)=>t.tileID).sort(dt).map((t)=>t.key);
            }
            hasRenderableParent(t) {
                const e = this.findLoadedParent(t, 0);
                return !!e && this._isIdRenderable(e.tileID.key);
            }
            _isIdRenderable(t, e) {
                return this._tiles[t] && this._tiles[t].hasData() && !this._coveredTiles[t] && (e || !this._tiles[t].holdingForFade());
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t in this._tiles)"errored" !== this._tiles[t].state && this._reloadTile(t, "reloading");
                }
            }
            _reloadTile(t, i) {
                return e._(this, void 0, void 0, function*() {
                    const e = this._tiles[t];
                    e && ("loading" !== e.state && (e.state = i), yield this._loadTile(e, t, i));
                });
            }
            _tileLoaded(t, i, a) {
                t.timeAdded = o.now(), "expired" === a && (t.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t), "raster-dem" === this.getSource().type && t.dem && this._backfillDEM(t), this._state.initializeTileState(t, this.map ? this.map.painter : null), t.aborted || this._source.fire(new e.k("data", {
                    dataType: "source",
                    tile: t,
                    coord: t.tileID
                }));
            }
            _backfillDEM(t) {
                const e = this.getRenderableIds();
                for(let a = 0; a < e.length; a++){
                    const s = e[a];
                    if (t.neighboringTiles && t.neighboringTiles[s]) {
                        const e = this.getTileByID(s);
                        i(t, e), i(e, t);
                    }
                }
                function i(t, e) {
                    t.needsHillshadePrepare = !0, t.needsTerrainPrepare = !0;
                    let i = e.tileID.canonical.x - t.tileID.canonical.x;
                    const a = e.tileID.canonical.y - t.tileID.canonical.y, s = Math.pow(2, t.tileID.canonical.z), o = e.tileID.key;
                    0 === i && 0 === a || Math.abs(a) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + s) ? i += s : 1 === Math.abs(i - s) && (i -= s)), e.dem && t.dem && (t.dem.backfillBorder(e.dem, i, a), t.neighboringTiles && t.neighboringTiles[o] && (t.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(t) {
                return this.getTileByID(t.key);
            }
            getTileByID(t) {
                return this._tiles[t];
            }
            _retainLoadedChildren(t, e, i, a) {
                for(const s in this._tiles){
                    let o = this._tiles[s];
                    if (a[s] || !o.hasData() || o.tileID.overscaledZ <= e || o.tileID.overscaledZ > i) continue;
                    let r = o.tileID;
                    for(; o && o.tileID.overscaledZ > e + 1;){
                        const t = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                        o = this._tiles[t.key], o && o.hasData() && (r = t);
                    }
                    let n = r;
                    for(; n.overscaledZ > e;)if (n = n.scaledTo(n.overscaledZ - 1), t[n.key]) {
                        a[r.key] = r;
                        break;
                    }
                }
            }
            findLoadedParent(t, e) {
                if (t.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[t.key];
                    return i && i.tileID.overscaledZ >= e ? i : null;
                }
                for(let i = t.overscaledZ - 1; i >= e; i--){
                    const e = t.scaledTo(i), a = this._getLoadedTile(e);
                    if (a) return a;
                }
            }
            findLoadedSibling(t) {
                return this._getLoadedTile(t);
            }
            _getLoadedTile(t) {
                const e = this._tiles[t.key];
                return e && e.hasData() ? e : this._cache.getByKey(t.wrapped().key);
            }
            updateCacheSize(t) {
                const i = Math.ceil(t.width / this._source.tileSize) + 1, a = Math.ceil(t.height / this._source.tileSize) + 1, s = Math.floor(i * a * (null === this._maxTileCacheZoomLevels ? e.a.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), o = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, s) : s;
                this._cache.setMaxSize(o);
            }
            handleWrapJump(t) {
                const e = Math.round((t - (void 0 === this._prevLng ? t : this._prevLng)) / 360);
                if (this._prevLng = t, e) {
                    const t = {};
                    for(const i in this._tiles){
                        const a = this._tiles[i];
                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + e), t[a.tileID.key] = a;
                    }
                    this._tiles = t;
                    for(const t in this._timers)clearTimeout(this._timers[t]), delete this._timers[t];
                    for(const t in this._tiles)this._setTileReloadTimer(t, this._tiles[t]);
                }
            }
            _updateCoveredAndRetainedTiles(t, e, i, a, s, r) {
                const n = {}, l = {}, h = Object.keys(t), c = o.now();
                for (const i of h){
                    const a = t[i], s = this._tiles[i];
                    if (!s || 0 !== s.fadeEndTime && s.fadeEndTime <= c) continue;
                    const o = this.findLoadedParent(a, e), r = this.findLoadedSibling(a), h = o || r || null;
                    h && (this._addTile(h.tileID), n[h.tileID.key] = h.tileID), l[i] = a;
                }
                this._retainLoadedChildren(l, a, i, t);
                for(const e in n)t[e] || (this._coveredTiles[e] = !0, t[e] = n[e]);
                if (r) {
                    const e = {}, i = {};
                    for (const t of s)this._tiles[t.key].hasData() ? e[t.key] = t : i[t.key] = t;
                    for(const a in i){
                        const s = i[a].children(this._source.maxzoom);
                        this._tiles[s[0].key] && this._tiles[s[1].key] && this._tiles[s[2].key] && this._tiles[s[3].key] && (e[s[0].key] = t[s[0].key] = s[0], e[s[1].key] = t[s[1].key] = s[1], e[s[2].key] = t[s[2].key] = s[2], e[s[3].key] = t[s[3].key] = s[3], delete i[a]);
                    }
                    for(const a in i){
                        const s = i[a], o = this.findLoadedParent(s, this._source.minzoom), r = this.findLoadedSibling(s), n = o || r || null;
                        if (n) {
                            e[n.tileID.key] = t[n.tileID.key] = n.tileID;
                            for(const t in e)e[t].isChildOf(n.tileID) && delete e[t];
                        }
                    }
                    for(const t in this._tiles)e[t] || (this._coveredTiles[t] = !0);
                }
            }
            update(t, i) {
                if (!this._sourceLoaded || this._paused) return;
                let a;
                this.transform = t, this.terrain = i, this.updateCacheSize(t), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? a = t.getVisibleUnwrappedCoordinates(this._source.tileID).map((t)=>new e.S(t.canonical.z, t.wrap, t.canonical.z, t.canonical.x, t.canonical.y)) : (a = t.coveringTiles({
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i
                }), this._source.hasTile && (a = a.filter((t)=>this._source.hasTile(t)))) : a = [];
                const s = t.coveringZoomLevel(this._source), o = Math.max(s - ut.maxOverzooming, this._source.minzoom), r = Math.max(s + ut.maxUnderzooming, this._source.minzoom);
                if (this.usedForTerrain) {
                    const t = {};
                    for (const e of a)if (e.canonical.z > this._source.minzoom) {
                        const i = e.scaledTo(e.canonical.z - 1);
                        t[i.key] = i;
                        const a = e.scaledTo(Math.max(this._source.minzoom, Math.min(e.canonical.z, 5)));
                        t[a.key] = a;
                    }
                    a = a.concat(Object.values(t));
                }
                const n = 0 === a.length && !this._updated && this._didEmitContent;
                this._updated = !0, n && this.fire(new e.k("data", {
                    sourceDataType: "idle",
                    dataType: "source",
                    sourceId: this.id
                }));
                const l = this._updateRetainedTiles(a, s);
                _t(this._source.type) && this._updateCoveredAndRetainedTiles(l, o, r, s, a, i);
                for(const t in l)this._tiles[t].clearFadeHold();
                const h = e.ab(this._tiles, l);
                for (const t of h){
                    const e = this._tiles[t];
                    e.hasSymbolBuckets && !e.holdingForFade() ? e.setHoldDuration(this.map._fadeDuration) : e.hasSymbolBuckets && !e.symbolFadeFinished() || this._removeTile(t);
                }
                this._updateLoadedParentTileCache(), this._updateLoadedSiblingTileCache();
            }
            releaseSymbolFadeTiles() {
                for(const t in this._tiles)this._tiles[t].holdingForFade() && this._removeTile(t);
            }
            _updateRetainedTiles(t, e) {
                var i;
                const a = {}, s = {}, o = Math.max(e - ut.maxOverzooming, this._source.minzoom), r = Math.max(e + ut.maxUnderzooming, this._source.minzoom), n = {};
                for (const i of t){
                    const t = this._addTile(i);
                    a[i.key] = i, t.hasData() || e < this._source.maxzoom && (n[i.key] = i);
                }
                this._retainLoadedChildren(n, e, r, a);
                for (const r of t){
                    let t = this._tiles[r.key];
                    if (t.hasData()) continue;
                    if (e + 1 > this._source.maxzoom) {
                        const t = r.children(this._source.maxzoom)[0], e = this.getTile(t);
                        if (e && e.hasData()) {
                            a[t.key] = t;
                            continue;
                        }
                    } else {
                        const t = r.children(this._source.maxzoom);
                        if (a[t[0].key] && a[t[1].key] && a[t[2].key] && a[t[3].key]) continue;
                    }
                    let n = t.wasRequested();
                    for(let e = r.overscaledZ - 1; e >= o; --e){
                        const o = r.scaledTo(e);
                        if (s[o.key]) break;
                        if (s[o.key] = !0, t = this.getTile(o), !t && n && (t = this._addTile(o)), t) {
                            const e = t.hasData();
                            if ((e || !(null === (i = this.map) || void 0 === i ? void 0 : i.cancelPendingTileRequestsWhileZooming) || n) && (a[o.key] = o), n = t.wasRequested(), e) break;
                        }
                    }
                }
                return a;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const t in this._tiles){
                    const e = [];
                    let i, a = this._tiles[t].tileID;
                    for(; a.overscaledZ > 0;){
                        if (a.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[a.key];
                            break;
                        }
                        e.push(a.key);
                        const t = a.scaledTo(a.overscaledZ - 1);
                        if (i = this._getLoadedTile(t), i) break;
                        a = t;
                    }
                    for (const t of e)this._loadedParentTiles[t] = i;
                }
            }
            _updateLoadedSiblingTileCache() {
                this._loadedSiblingTiles = {};
                for(const t in this._tiles){
                    const e = this._tiles[t].tileID, i = this._getLoadedTile(e);
                    this._loadedSiblingTiles[e.key] = i;
                }
            }
            _addTile(t) {
                let i = this._tiles[t.key];
                if (i) return i;
                i = this._cache.getAndRemove(t), i && (this._setTileReloadTimer(t.key, i), i.tileID = t, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[t.key] && (clearTimeout(this._cacheTimers[t.key]), delete this._cacheTimers[t.key], this._setTileReloadTimer(t.key, i)));
                const a = i;
                return i || (i = new lt(t, this._source.tileSize * t.overscaleFactor()), this._loadTile(i, t.key, i.state)), i.uses++, this._tiles[t.key] = i, a || this._source.fire(new e.k("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(t, e) {
                t in this._timers && (clearTimeout(this._timers[t]), delete this._timers[t]);
                const i = e.getExpiryTimeout();
                i && (this._timers[t] = setTimeout(()=>{
                    this._reloadTile(t, "expired"), delete this._timers[t];
                }, i));
            }
            _removeTile(t) {
                const e = this._tiles[t];
                e && (e.uses--, delete this._tiles[t], this._timers[t] && (clearTimeout(this._timers[t]), delete this._timers[t]), e.uses > 0 || (e.hasData() && "reloading" !== e.state ? this._cache.add(e.tileID, e, e.getExpiryTimeout()) : (e.aborted = !0, this._abortTile(e), this._unloadTile(e))));
            }
            _dataHandler(t) {
                const e = t.sourceDataType;
                "source" === t.dataType && "metadata" === e && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t.dataType && "content" === e && (this.reload(), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const t in this._tiles)this._removeTile(t);
                this._cache.reset();
            }
            tilesIn(t, i, a) {
                const s = [], o = this.transform;
                if (!o) return s;
                const r = a ? o.getCameraQueryGeometry(t) : t, n = t.map((t)=>o.pointCoordinate(t, this.terrain)), l = r.map((t)=>o.pointCoordinate(t, this.terrain)), h = this.getIds();
                let c = 1 / 0, u = 1 / 0, d = -1 / 0, _ = -1 / 0;
                for (const t of l)c = Math.min(c, t.x), u = Math.min(u, t.y), d = Math.max(d, t.x), _ = Math.max(_, t.y);
                for(let t = 0; t < h.length; t++){
                    const a = this._tiles[h[t]];
                    if (a.holdingForFade()) continue;
                    const r = a.tileID, p = Math.pow(2, o.zoom - a.tileID.overscaledZ), m = i * a.queryPadding * e.X / a.tileSize / p, f = [
                        r.getTilePoint(new e.Z(c, u)),
                        r.getTilePoint(new e.Z(d, _))
                    ];
                    if (f[0].x - m < e.X && f[0].y - m < e.X && f[1].x + m >= 0 && f[1].y + m >= 0) {
                        const t = n.map((t)=>r.getTilePoint(t)), e = l.map((t)=>r.getTilePoint(t));
                        s.push({
                            tile: a,
                            tileID: r,
                            queryGeometry: t,
                            cameraQueryGeometry: e,
                            scale: p
                        });
                    }
                }
                return s;
            }
            getVisibleCoordinates(t) {
                const e = this.getRenderableIds(t).map((t)=>this._tiles[t].tileID);
                for (const t of e)t.posMatrix = this.transform.calculatePosMatrix(t.toUnwrapped());
                return e;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (_t(this._source.type)) {
                    const t = o.now();
                    for(const e in this._tiles)if (this._tiles[e].fadeEndTime >= t) return !0;
                }
                return !1;
            }
            setFeatureState(t, e, i) {
                this._state.updateState(t = t || "_geojsonTileLayer", e, i);
            }
            removeFeatureState(t, e, i) {
                this._state.removeFeatureState(t = t || "_geojsonTileLayer", e, i);
            }
            getFeatureState(t, e) {
                return this._state.getState(t = t || "_geojsonTileLayer", e);
            }
            setDependencies(t, e, i) {
                const a = this._tiles[t];
                a && a.setDependencies(e, i);
            }
            reloadTilesForDependencies(t, e) {
                for(const i in this._tiles)this._tiles[i].hasDependency(t, e) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(t, e));
            }
        }
        function dt(t, e) {
            const i = Math.abs(2 * t.wrap) - +(t.wrap < 0), a = Math.abs(2 * e.wrap) - +(e.wrap < 0);
            return t.overscaledZ - e.overscaledZ || a - i || e.canonical.y - t.canonical.y || e.canonical.x - t.canonical.x;
        }
        function _t(t) {
            return "raster" === t || "image" === t || "video" === t;
        }
        ut.maxOverzooming = 10, ut.maxUnderzooming = 3;
        class pt {
            constructor(t, e){
                this.reset(t, e);
            }
            reset(t, e) {
                this.points = t || [], this._distances = [
                    0
                ];
                for(let t = 1; t < this.points.length; t++)this._distances[t] = this._distances[t - 1] + this.points[t].dist(this.points[t - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t) {
                if (1 === this.points.length) return this.points[0];
                t = e.ac(t, 0, 1);
                let i = 1, a = this._distances[i];
                const s = t * this.paddedLength + this.padding;
                for(; a < s && i < this._distances.length;)a = this._distances[++i];
                const o = i - 1, r = this._distances[o], n = a - r, l = n > 0 ? (s - r) / n : 0;
                return this.points[o].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        function mt(t, e) {
            let i = !0;
            return "always" === t || "never" !== t && "never" !== e || (i = !1), i;
        }
        class ft {
            constructor(t, e, i){
                const a = this.boxCells = [], s = this.circleCells = [];
                this.xCellCount = Math.ceil(t / i), this.yCellCount = Math.ceil(e / i);
                for(let t = 0; t < this.xCellCount * this.yCellCount; t++)a.push([]), s.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t, this.height = e, this.xScale = this.xCellCount / t, this.yScale = this.yCellCount / e, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(t, e, i, a, s) {
                this._forEachCell(e, i, a, s, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t), this.bboxes.push(e), this.bboxes.push(i), this.bboxes.push(a), this.bboxes.push(s);
            }
            insertCircle(t, e, i, a) {
                this._forEachCell(e - a, i - a, e + a, i + a, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t), this.circles.push(e), this.circles.push(i), this.circles.push(a);
            }
            _insertBoxCell(t, e, i, a, s, o) {
                this.boxCells[s].push(o);
            }
            _insertCircleCell(t, e, i, a, s, o) {
                this.circleCells[s].push(o);
            }
            _query(t, e, i, a, s, o, r) {
                if (i < 0 || t > this.width || a < 0 || e > this.height) return [];
                const n = [];
                if (t <= 0 && e <= 0 && this.width <= i && this.height <= a) {
                    if (s) return [
                        {
                            key: null,
                            x1: t,
                            y1: e,
                            x2: i,
                            y2: a
                        }
                    ];
                    for(let t = 0; t < this.boxKeys.length; t++)n.push({
                        key: this.boxKeys[t],
                        x1: this.bboxes[4 * t],
                        y1: this.bboxes[4 * t + 1],
                        x2: this.bboxes[4 * t + 2],
                        y2: this.bboxes[4 * t + 3]
                    });
                    for(let t = 0; t < this.circleKeys.length; t++){
                        const e = this.circles[3 * t], i = this.circles[3 * t + 1], a = this.circles[3 * t + 2];
                        n.push({
                            key: this.circleKeys[t],
                            x1: e - a,
                            y1: i - a,
                            x2: e + a,
                            y2: i + a
                        });
                    }
                } else this._forEachCell(t, e, i, a, this._queryCell, n, {
                    hitTest: s,
                    overlapMode: o,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r);
                return n;
            }
            query(t, e, i, a) {
                return this._query(t, e, i, a, !1, null);
            }
            hitTest(t, e, i, a, s, o) {
                return this._query(t, e, i, a, !0, s, o).length > 0;
            }
            hitTestCircle(t, e, i, a, s) {
                const o = t - i, r = t + i, n = e - i, l = e + i;
                if (r < 0 || o > this.width || l < 0 || n > this.height) return !1;
                const h = [];
                return this._forEachCell(o, n, r, l, this._queryCellCircle, h, {
                    hitTest: !0,
                    overlapMode: a,
                    circle: {
                        x: t,
                        y: e,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s), h.length > 0;
            }
            _queryCell(t, e, i, a, s, o, r, n) {
                const { seenUids: l, hitTest: h, overlapMode: c } = r, u = this.boxCells[s];
                if (null !== u) {
                    const s = this.bboxes;
                    for (const r of u)if (!l.box[r]) {
                        l.box[r] = !0;
                        const u = 4 * r, d = this.boxKeys[r];
                        if (t <= s[u + 2] && e <= s[u + 3] && i >= s[u + 0] && a >= s[u + 1] && (!n || n(d)) && (!h || !mt(c, d.overlapMode)) && (o.push({
                            key: d,
                            x1: s[u],
                            y1: s[u + 1],
                            x2: s[u + 2],
                            y2: s[u + 3]
                        }), h)) return !0;
                    }
                }
                const d = this.circleCells[s];
                if (null !== d) {
                    const s = this.circles;
                    for (const r of d)if (!l.circle[r]) {
                        l.circle[r] = !0;
                        const u = 3 * r, d = this.circleKeys[r];
                        if (this._circleAndRectCollide(s[u], s[u + 1], s[u + 2], t, e, i, a) && (!n || n(d)) && (!h || !mt(c, d.overlapMode))) {
                            const t = s[u], e = s[u + 1], i = s[u + 2];
                            if (o.push({
                                key: d,
                                x1: t - i,
                                y1: e - i,
                                x2: t + i,
                                y2: e + i
                            }), h) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(t, e, i, a, s, o, r, n) {
                const { circle: l, seenUids: h, overlapMode: c } = r, u = this.boxCells[s];
                if (null !== u) {
                    const t = this.bboxes;
                    for (const e of u)if (!h.box[e]) {
                        h.box[e] = !0;
                        const i = 4 * e, a = this.boxKeys[e];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, t[i + 0], t[i + 1], t[i + 2], t[i + 3]) && (!n || n(a)) && !mt(c, a.overlapMode)) return o.push(!0), !0;
                    }
                }
                const d = this.circleCells[s];
                if (null !== d) {
                    const t = this.circles;
                    for (const e of d)if (!h.circle[e]) {
                        h.circle[e] = !0;
                        const i = 3 * e, a = this.circleKeys[e];
                        if (this._circlesCollide(t[i], t[i + 1], t[i + 2], l.x, l.y, l.radius) && (!n || n(a)) && !mt(c, a.overlapMode)) return o.push(!0), !0;
                    }
                }
            }
            _forEachCell(t, e, i, a, s, o, r, n) {
                const l = this._convertToXCellCoord(t), h = this._convertToYCellCoord(e), c = this._convertToXCellCoord(i), u = this._convertToYCellCoord(a);
                for(let d = l; d <= c; d++)for(let l = h; l <= u; l++)if (s.call(this, t, e, i, a, this.xCellCount * l + d, o, r, n)) return;
            }
            _convertToXCellCoord(t) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t * this.xScale)));
            }
            _convertToYCellCoord(t) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t * this.yScale)));
            }
            _circlesCollide(t, e, i, a, s, o) {
                const r = a - t, n = s - e, l = i + o;
                return l * l > r * r + n * n;
            }
            _circleAndRectCollide(t, e, i, a, s, o, r) {
                const n = (o - a) / 2, l = Math.abs(t - (a + n));
                if (l > n + i) return !1;
                const h = (r - s) / 2, c = Math.abs(e - (s + h));
                if (c > h + i) return !1;
                if (l <= n || c <= h) return !0;
                const u = l - n, d = c - h;
                return u * u + d * d <= i * i;
            }
        }
        function gt(t, i, a, s, o) {
            const r = e.H();
            return i ? (e.K(r, r, [
                1 / o,
                1 / o,
                1
            ]), a || e.ad(r, r, s.angle)) : e.L(r, s.labelPlaneMatrix, t), r;
        }
        function vt(t, i, a, s, o) {
            if (i) {
                const i = e.ae(t);
                return e.K(i, i, [
                    o,
                    o,
                    1
                ]), a || e.ad(i, i, -s.angle), i;
            }
            return s.glCoordMatrix;
        }
        function xt(t, i, a) {
            let s;
            a ? (s = [
                t.x,
                t.y,
                a(t.x, t.y),
                1
            ], e.af(s, s, i)) : (s = [
                t.x,
                t.y,
                0,
                1
            ], function(t, e, i) {
                const a = e[0], s = e[1];
                t[0] = i[0] * a + i[4] * s + i[12], t[1] = i[1] * a + i[5] * s + i[13], t[3] = i[3] * a + i[7] * s + i[15];
            }(s, s, i));
            const o = s[3];
            return {
                point: new e.P(s[0] / o, s[1] / o),
                signedDistanceFromCamera: o,
                isOccluded: !1
            };
        }
        function yt(t, e) {
            return .5 + t / e * .5;
        }
        function bt(t, e) {
            return t.x >= -e[0] && t.x <= e[0] && t.y >= -e[1] && t.y <= e[1];
        }
        function wt(t, i, a, s, o, r, n, l, h, c, u, d, _, p, m) {
            const f = s ? t.textSizeData : t.iconSizeData, g = e.ag(f, a.transform.zoom), v = [
                256 / a.width * 2 + 1,
                256 / a.height * 2 + 1
            ], x = s ? t.text.dynamicLayoutVertexArray : t.icon.dynamicLayoutVertexArray;
            x.clear();
            const y = t.lineVertexArray, b = s ? t.text.placedSymbolArray : t.icon.placedSymbolArray, w = a.transform.width / a.transform.height;
            let T = !1;
            for(let s = 0; s < b.length; s++){
                const I = b.get(s);
                if (I.hidden || I.writingMode === e.ah.vertical && !T) {
                    Rt(I.numGlyphs, x);
                    continue;
                }
                T = !1;
                const E = xt(new e.P(I.anchorX, I.anchorY), i, m);
                if (!bt(E.point, v)) {
                    Rt(I.numGlyphs, x);
                    continue;
                }
                const P = yt(a.transform.cameraToCenterDistance, E.signedDistanceFromCamera), C = e.ai(f, g, I), S = n ? C / P : C * P, z = {
                    getElevation: m,
                    labelPlaneMatrix: o,
                    lineVertexArray: y,
                    pitchWithMap: n,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    projection: c,
                    tileAnchorPoint: new e.P(I.anchorX, I.anchorY),
                    unwrappedTileID: u,
                    width: d,
                    height: _,
                    translation: p
                }, D = Et(z, I, S, !1, l, i, r, t.glyphOffsetArray, x, w, h);
                T = D.useVertical, (D.notEnoughRoom || T || D.needsFlipping && Et(z, I, S, !0, l, i, r, t.glyphOffsetArray, x, w, h).notEnoughRoom) && Rt(I.numGlyphs, x);
            }
            s ? t.text.dynamicLayoutVertexBuffer.updateData(x) : t.icon.dynamicLayoutVertexBuffer.updateData(x);
        }
        function Tt(t, e, i, a, s, o, r, n) {
            const l = o.glyphStartIndex + o.numGlyphs, h = o.lineStartIndex, c = o.lineStartIndex + o.lineLength, u = e.getoffsetX(o.glyphStartIndex), d = e.getoffsetX(l - 1), _ = Mt(t * u, i, a, s, o.segment, h, c, n, r);
            if (!_) return null;
            const p = Mt(t * d, i, a, s, o.segment, h, c, n, r);
            return p ? n.projectionCache.anyProjectionOccluded ? null : {
                first: _,
                last: p
            } : null;
        }
        function It(t, i, a, s) {
            return t === e.ah.horizontal && Math.abs(a.y - i.y) > Math.abs(a.x - i.x) * s ? {
                useVertical: !0
            } : (t === e.ah.vertical ? i.y < a.y : i.x > a.x) ? {
                needsFlipping: !0
            } : null;
        }
        function Et(t, i, a, s, o, r, n, l, h, c, u) {
            const d = a / 24, _ = i.lineOffsetX * d, p = i.lineOffsetY * d;
            let m;
            if (i.numGlyphs > 1) {
                const e = i.glyphStartIndex + i.numGlyphs, a = i.lineStartIndex, r = i.lineStartIndex + i.lineLength, h = Tt(d, l, _, p, s, i, u, t);
                if (!h) return {
                    notEnoughRoom: !0
                };
                const f = xt(h.first.point, n, t.getElevation).point, g = xt(h.last.point, n, t.getElevation).point;
                if (o && !s) {
                    const t = It(i.writingMode, f, g, c);
                    if (t) return t;
                }
                m = [
                    h.first
                ];
                for(let o = i.glyphStartIndex + 1; o < e - 1; o++)m.push(Mt(d * l.getoffsetX(o), _, p, s, i.segment, a, r, t, u));
                m.push(h.last);
            } else {
                if (o && !s) {
                    const a = xt(t.tileAnchorPoint, r, t.getElevation).point, s = i.lineStartIndex + i.segment + 1, o = new e.P(t.lineVertexArray.getx(s), t.lineVertexArray.gety(s)), n = xt(o, r, t.getElevation), l = n.signedDistanceFromCamera > 0 ? n.point : function(t, e, i, a, s, o) {
                        return Pt(t, e, i, 1, s, o);
                    }(t.tileAnchorPoint, o, a, 0, r, t), h = It(i.writingMode, a, l, c);
                    if (h) return h;
                }
                const a = Mt(d * l.getoffsetX(i.glyphStartIndex), _, p, s, i.segment, i.lineStartIndex, i.lineStartIndex + i.lineLength, t, u);
                if (!a || t.projectionCache.anyProjectionOccluded) return {
                    notEnoughRoom: !0
                };
                m = [
                    a
                ];
            }
            for (const t of m)e.aj(h, t.point, t.angle);
            return {};
        }
        function Pt(t, e, i, a, s, o) {
            const r = t.add(t.sub(e)._unit()), n = void 0 !== s ? xt(r, s, o.getElevation).point : St(r.x, r.y, o).point, l = i.sub(n);
            return i.add(l._mult(a / l.mag()));
        }
        function Ct(t, i, a) {
            const s = i.projectionCache;
            if (s.projections[t]) return s.projections[t];
            const o = new e.P(i.lineVertexArray.getx(t), i.lineVertexArray.gety(t)), r = St(o.x, o.y, i);
            if (r.signedDistanceFromCamera > 0) return s.projections[t] = r.point, s.anyProjectionOccluded = s.anyProjectionOccluded || r.isOccluded, r.point;
            const n = t - a.direction;
            return function(t, e, i, a, s) {
                return Pt(t, e, i, a, void 0, s);
            }(0 === a.distanceFromAnchor ? i.tileAnchorPoint : new e.P(i.lineVertexArray.getx(n), i.lineVertexArray.gety(n)), o, a.previousVertex, a.absOffsetX - a.distanceFromAnchor + 1, i);
        }
        function St(t, i, a) {
            const s = t + a.translation[0], o = i + a.translation[1];
            let r;
            return !a.pitchWithMap && a.projection.useSpecialProjectionForSymbols ? (r = a.projection.projectTileCoordinates(s, o, a.unwrappedTileID, a.getElevation), r.point.x = (.5 * r.point.x + .5) * a.width, r.point.y = (.5 * -r.point.y + .5) * a.height) : (r = xt(new e.P(s, o), a.labelPlaneMatrix, a.getElevation), r.isOccluded = !1), r;
        }
        function zt(t, e, i) {
            return t._unit()._perp()._mult(e * i);
        }
        function Dt(t, i, a, s, o, r, n, l, h) {
            if (l.projectionCache.offsets[t]) return l.projectionCache.offsets[t];
            const c = a.add(i);
            if (t + h.direction < s || t + h.direction >= o) return l.projectionCache.offsets[t] = c, c;
            const u = Ct(t + h.direction, l, h), d = zt(u.sub(a), n, h.direction), _ = a.add(d), p = u.add(d);
            return l.projectionCache.offsets[t] = e.ak(r, c, _, p) || c, l.projectionCache.offsets[t];
        }
        function Mt(t, e, i, a, s, o, r, n, l) {
            const h = a ? t - e : t + e;
            let c = h > 0 ? 1 : -1, u = 0;
            a && (c *= -1, u = Math.PI), c < 0 && (u += Math.PI);
            let d, _ = c > 0 ? o + s : o + s + 1;
            n.projectionCache.cachedAnchorPoint ? d = n.projectionCache.cachedAnchorPoint : (d = St(n.tileAnchorPoint.x, n.tileAnchorPoint.y, n).point, n.projectionCache.cachedAnchorPoint = d);
            let p, m, f = d, g = d, v = 0, x = 0;
            const y = Math.abs(h), b = [];
            let w;
            for(; v + x <= y;){
                if (_ += c, _ < o || _ >= r) return null;
                v += x, g = f, m = p;
                const t = {
                    absOffsetX: y,
                    direction: c,
                    distanceFromAnchor: v,
                    previousVertex: g
                };
                if (f = Ct(_, n, t), 0 === i) b.push(g), w = f.sub(g);
                else {
                    let e;
                    const a = f.sub(g);
                    e = 0 === a.mag() ? zt(Ct(_ + c, n, t).sub(f), i, c) : zt(a, i, c), m || (m = g.add(e)), p = Dt(_, e, f, o, r, m, i, n, t), b.push(m), w = p.sub(m);
                }
                x = w.mag();
            }
            const T = w._mult((y - v) / x)._add(m || g), I = u + Math.atan2(f.y - g.y, f.x - g.x);
            return b.push(T), {
                point: T,
                angle: l ? I : 0,
                path: b
            };
        }
        const At = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function Rt(t, e) {
            for(let i = 0; i < t; i++){
                const t = e.length;
                e.resize(t + 4), e.float32.set(At, 3 * t);
            }
        }
        const kt = 100;
        class Lt {
            constructor(t, e, i = new ft(t.width + 200, t.height + 200, 25), a = new ft(t.width + 200, t.height + 200, 25)){
                this.transform = t, this.mapProjection = e, this.grid = i, this.ignoredGrid = a, this.pitchFactor = Math.cos(t._pitch) * t.cameraToCenterDistance, this.screenRightBoundary = t.width + kt, this.screenBottomBoundary = t.height + kt, this.gridRightBoundary = t.width + 200, this.gridBottomBoundary = t.height + 200, this.perspectiveRatioCutoff = .6;
            }
            placeCollisionBox(t, e, i, a, s, o, r, n, l, h, c) {
                const u = t.anchorPointX + n[0], d = t.anchorPointY + n[1], _ = this.projectAndGetPerspectiveRatio(a, u, d, s, h), p = this._projectCollisionBox(t, i, a, s, o, r, n, _, h, c), [m, f, g, v] = p.box;
                return this.mapProjection.useSpecialProjectionForSymbols && (o ? p.allPointsOccluded : this.mapProjection.isOccluded(u, d, s)) || _.perspectiveRatio < this.perspectiveRatioCutoff || !this.isInsideGrid(m, f, g, v) || "always" !== e && this.grid.hitTest(m, f, g, v, e, l) ? {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !1,
                    offscreen: !1
                } : {
                    box: [
                        m,
                        f,
                        g,
                        v
                    ],
                    placeable: !0,
                    offscreen: this.isOffscreen(m, f, g, v)
                };
            }
            placeCollisionCircles(t, i, a, s, o, r, n, l, h, c, u, d, _, p, m, f) {
                const g = [], v = new e.P(i.anchorX, i.anchorY), x = this.getPerspectiveRatio(r, v.x, v.y, n, f), y = (u ? o / x : o * x) / e.ap, b = {
                    getElevation: f,
                    labelPlaneMatrix: l,
                    lineVertexArray: a,
                    pitchWithMap: u,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    projection: this.mapProjection,
                    tileAnchorPoint: v,
                    unwrappedTileID: n,
                    width: this.transform.width,
                    height: this.transform.height,
                    translation: m
                }, w = Tt(y, s, i.lineOffsetX * y, i.lineOffsetY * y, !1, i, !1, b);
                let T = !1, I = !1, E = !0;
                if (w) {
                    const i = .5 * _ * x + p, a = new e.P(-100, -100), s = new e.P(this.screenRightBoundary, this.screenBottomBoundary), o = new pt, r = w.first, n = w.last;
                    let l = [];
                    for(let t = r.path.length - 1; t >= 1; t--)l.push(r.path[t]);
                    for(let t = 1; t < n.path.length; t++)l.push(n.path[t]);
                    const u = 2.5 * i;
                    if (h) {
                        const t = this.projectPathToScreenSpace(l, b, h);
                        l = t.some((t)=>t.signedDistanceFromCamera <= 0) ? [] : t.map((t)=>t.point);
                    }
                    let m = [];
                    if (l.length > 0) {
                        const t = l[0].clone(), i = l[0].clone();
                        for(let e = 1; e < l.length; e++)t.x = Math.min(t.x, l[e].x), t.y = Math.min(t.y, l[e].y), i.x = Math.max(i.x, l[e].x), i.y = Math.max(i.y, l[e].y);
                        m = t.x >= a.x && i.x <= s.x && t.y >= a.y && i.y <= s.y ? [
                            l
                        ] : i.x < a.x || t.x > s.x || i.y < a.y || t.y > s.y ? [] : e.al([
                            l
                        ], a.x, a.y, s.x, s.y);
                    }
                    for (const e of m){
                        o.reset(e, .25 * i);
                        let a = 0;
                        a = o.length <= .5 * i ? 1 : Math.ceil(o.paddedLength / u) + 1;
                        for(let e = 0; e < a; e++){
                            const s = e / Math.max(a - 1, 1), r = o.lerp(s), n = r.x + kt, l = r.y + kt;
                            g.push(n, l, i, 0);
                            const h = n - i, u = l - i, _ = n + i, p = l + i;
                            if (E = E && this.isOffscreen(h, u, _, p), I = I || this.isInsideGrid(h, u, _, p), "always" !== t && this.grid.hitTestCircle(n, l, i, t, d) && (T = !0, !c)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: T
                            };
                        }
                    }
                }
                return {
                    circles: !c && T || !I || x < this.perspectiveRatioCutoff ? [] : g,
                    offscreen: E,
                    collisionDetected: T
                };
            }
            projectPathToScreenSpace(t, e, i) {
                return t.map((t)=>xt(t, i, e.getElevation));
            }
            queryRenderedSymbols(t) {
                if (0 === t.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let a = 1 / 0, s = 1 / 0, o = -1 / 0, r = -1 / 0;
                for (const n of t){
                    const t = new e.P(n.x + kt, n.y + kt);
                    a = Math.min(a, t.x), s = Math.min(s, t.y), o = Math.max(o, t.x), r = Math.max(r, t.y), i.push(t);
                }
                const n = this.grid.query(a, s, o, r).concat(this.ignoredGrid.query(a, s, o, r)), l = {}, h = {};
                for (const t of n){
                    const a = t.key;
                    if (void 0 === l[a.bucketInstanceId] && (l[a.bucketInstanceId] = {}), l[a.bucketInstanceId][a.featureIndex]) continue;
                    const s = [
                        new e.P(t.x1, t.y1),
                        new e.P(t.x2, t.y1),
                        new e.P(t.x2, t.y2),
                        new e.P(t.x1, t.y2)
                    ];
                    e.am(i, s) && (l[a.bucketInstanceId][a.featureIndex] = !0, void 0 === h[a.bucketInstanceId] && (h[a.bucketInstanceId] = []), h[a.bucketInstanceId].push(a.featureIndex));
                }
                return h;
            }
            insertCollisionBox(t, e, i, a, s, o) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: a,
                    featureIndex: s,
                    collisionGroupID: o,
                    overlapMode: e
                }, t[0], t[1], t[2], t[3]);
            }
            insertCollisionCircles(t, e, i, a, s, o) {
                const r = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: a,
                    featureIndex: s,
                    collisionGroupID: o,
                    overlapMode: e
                };
                for(let e = 0; e < t.length; e += 4)r.insertCircle(n, t[e], t[e + 1], t[e + 2]);
            }
            projectAndGetPerspectiveRatio(t, i, a, s, o) {
                const r = this.mapProjection.useSpecialProjectionForSymbols ? this.mapProjection.projectTileCoordinates(i, a, s, o) : xt(new e.P(i, a), t, o);
                return {
                    point: new e.P((r.point.x + 1) / 2 * this.transform.width + kt, (1 - r.point.y) / 2 * this.transform.height + kt),
                    perspectiveRatio: .5 + this.transform.cameraToCenterDistance / r.signedDistanceFromCamera * .5,
                    isOccluded: r.isOccluded,
                    signedDistanceFromCamera: r.signedDistanceFromCamera
                };
            }
            getPerspectiveRatio(t, i, a, s, o) {
                const r = this.mapProjection.useSpecialProjectionForSymbols ? this.mapProjection.projectTileCoordinates(i, a, s, o) : xt(new e.P(i, a), t, o);
                return .5 + this.transform.cameraToCenterDistance / r.signedDistanceFromCamera * .5;
            }
            isOffscreen(t, e, i, a) {
                return i < kt || t >= this.screenRightBoundary || a < kt || e > this.screenBottomBoundary;
            }
            isInsideGrid(t, e, i, a) {
                return i >= 0 && t < this.gridRightBoundary && a >= 0 && e < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t = e.an([]);
                return e.J(t, t, [
                    -100,
                    -100,
                    0
                ]), t;
            }
            _projectCollisionBox(t, i, a, s, o, r, n, l, h, c) {
                const u = i * l.perspectiveRatio;
                let d = new e.P(1, 0), _ = new e.P(0, 1);
                const p = new e.P(t.anchorPointX + n[0], t.anchorPointY + n[1]);
                if (r && !o) {
                    const t = this.projectAndGetPerspectiveRatio(a, p.x + 1, p.y, s, h).point.sub(l.point).unit(), i = Math.atan(t.y / t.x) + (t.x < 0 ? Math.PI : 0), o = Math.sin(i), r = Math.cos(i);
                    d = new e.P(r, o), _ = new e.P(-o, r);
                } else if (!r && o) {
                    const t = -this.transform.angle, i = Math.sin(t), a = Math.cos(t);
                    d = new e.P(a, i), _ = new e.P(-i, a);
                }
                let m = l.point, f = u;
                if (o) {
                    m = p;
                    const t = this.transform.zoom - Math.floor(this.transform.zoom);
                    f = Math.pow(2, -t), f *= this.mapProjection.getPitchedTextCorrection(this.transform, p, s), c || (f *= e.ac(.5 + l.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4));
                }
                c && (m = m.add(d.mult(c.x * f)).add(_.mult(c.y * f)));
                const g = t.x1 * f, v = t.x2 * f, x = (g + v) / 2, y = t.y1 * f, b = t.y2 * f, w = (y + b) / 2, T = [
                    {
                        offsetX: g,
                        offsetY: y
                    },
                    {
                        offsetX: x,
                        offsetY: y
                    },
                    {
                        offsetX: v,
                        offsetY: y
                    },
                    {
                        offsetX: v,
                        offsetY: w
                    },
                    {
                        offsetX: v,
                        offsetY: b
                    },
                    {
                        offsetX: x,
                        offsetY: b
                    },
                    {
                        offsetX: g,
                        offsetY: b
                    },
                    {
                        offsetX: g,
                        offsetY: w
                    }
                ];
                let I = [];
                for (const { offsetX: t, offsetY: i } of T)I.push(new e.P(m.x + d.x * t + _.x * i, m.y + d.y * t + _.y * i));
                let E = !1;
                if (o) {
                    const t = I.map((t)=>this.projectAndGetPerspectiveRatio(a, t.x, t.y, s, h));
                    E = t.some((t)=>!t.isOccluded), I = t.map((t)=>t.point);
                } else E = !0;
                return {
                    box: e.ao(I),
                    allPointsOccluded: !E
                };
            }
        }
        function Ft(t, i, a) {
            return i * (e.X / (t.tileSize * Math.pow(2, a - t.tileID.overscaledZ)));
        }
        class Bt {
            constructor(t, e, i, a){
                this.opacity = t ? Math.max(0, Math.min(1, t.opacity + (t.placed ? e : -e))) : a && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class Ot {
            constructor(t, e, i, a, s){
                this.text = new Bt(t ? t.text : null, e, i, s), this.icon = new Bt(t ? t.icon : null, e, a, s);
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class Nt {
            constructor(t, e, i){
                this.text = t, this.icon = e, this.skipFade = i;
            }
        }
        class jt {
            constructor(){
                this.invProjMatrix = e.H(), this.viewportMatrix = e.H(), this.circles = [];
            }
        }
        class Ut {
            constructor(t, e, i, a, s){
                this.bucketInstanceId = t, this.featureIndex = e, this.sourceLayerIndex = i, this.bucketIndex = a, this.tileID = s;
            }
        }
        class Zt {
            constructor(t){
                this.crossSourceCollisions = t, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(t) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[t]) {
                    const e = ++this.maxGroupID;
                    this.collisionGroups[t] = {
                        ID: e,
                        predicate: (t)=>t.collisionGroupID === e
                    };
                }
                return this.collisionGroups[t];
            }
        }
        function qt(t, i, a, s, o) {
            const { horizontalAlign: r, verticalAlign: n } = e.au(t);
            return new e.P(-(r - .5) * i + s[0] * o, -(n - .5) * a + s[1] * o);
        }
        class Vt {
            constructor(t, e, i, a, s, o){
                this.transform = t.clone(), this.terrain = i, this.collisionIndex = new Lt(this.transform, e), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = a, this.retainedQueryData = {}, this.collisionGroups = new Zt(s), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
            }
            _getTerrainElevationFunc(t) {
                const e = this.terrain;
                return e ? (i, a)=>e.getElevation(t, i, a) : null;
            }
            getBucketParts(t, i, a, s) {
                const o = a.getBucket(i), r = a.latestFeatureIndex;
                if (!o || !r || i.id !== o.layerIds[0]) return;
                const n = a.collisionBoxArray, l = o.layers[0].layout, h = o.layers[0].paint, c = Math.pow(2, this.transform.zoom - a.tileID.overscaledZ), u = a.tileSize / e.X, d = a.tileID.toUnwrapped(), _ = this.transform.calculatePosMatrix(d), p = "map" === l.get("text-pitch-alignment"), m = "map" === l.get("text-rotation-alignment"), f = Ft(a, 1, this.transform.zoom), g = this.collisionIndex.mapProjection.translatePosition(this.transform, a, h.get("text-translate"), h.get("text-translate-anchor")), v = this.collisionIndex.mapProjection.translatePosition(this.transform, a, h.get("icon-translate"), h.get("icon-translate-anchor")), x = gt(_, p, m, this.transform, f);
                let y = null;
                if (p) {
                    const t = vt(_, p, m, this.transform, f);
                    y = e.L([], this.transform.labelPlaneMatrix, t);
                }
                this.retainedQueryData[o.bucketInstanceId] = new Ut(o.bucketInstanceId, r, o.sourceLayerIndex, o.index, a.tileID);
                const b = {
                    bucket: o,
                    layout: l,
                    translationText: g,
                    translationIcon: v,
                    posMatrix: _,
                    unwrappedTileID: d,
                    textLabelPlaneMatrix: x,
                    labelToScreenMatrix: y,
                    scale: c,
                    textPixelRatio: u,
                    holdingForFade: a.holdingForFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: e.ag(o.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(o.sourceID)
                };
                if (s) for (const e of o.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: a, symbolInstanceEnd: s } = e;
                    t.push({
                        sortKey: i,
                        symbolInstanceStart: a,
                        symbolInstanceEnd: s,
                        parameters: b
                    });
                }
                else t.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: o.symbolInstances.length,
                    parameters: b
                });
            }
            attemptAnchorPlacement(t, i, a, s, o, r, n, l, h, c, u, d, _, p, m, f, g, v, x) {
                const y = e.aq[t.textAnchor], b = [
                    t.textOffset0,
                    t.textOffset1
                ], w = qt(y, a, s, b, o), T = this.collisionIndex.placeCollisionBox(i, d, l, h, c, n, r, f, u.predicate, x, w);
                if ((!v || this.collisionIndex.placeCollisionBox(v, d, l, h, c, n, r, g, u.predicate, x, w).placeable) && T.placeable) {
                    let t;
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[_.crossTileID] && this.prevPlacement.placements[_.crossTileID] && this.prevPlacement.placements[_.crossTileID].text && (t = this.prevPlacement.variableOffsets[_.crossTileID].anchor), 0 === _.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[_.crossTileID] = {
                        textOffset: b,
                        width: a,
                        height: s,
                        anchor: y,
                        textBoxScale: o,
                        prevAnchor: t
                    }, this.markUsedJustification(p, y, _, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, _), this.placedOrientations[_.crossTileID] = m), {
                        shift: w,
                        placedGlyphBoxes: T
                    };
                }
            }
            placeLayerBucketPart(t, i, a) {
                const { bucket: s, layout: o, translationText: r, translationIcon: n, posMatrix: l, unwrappedTileID: h, textLabelPlaneMatrix: c, labelToScreenMatrix: u, textPixelRatio: d, holdingForFade: _, collisionBoxArray: p, partiallyEvaluatedTextSize: m, collisionGroup: f } = t.parameters, g = o.get("text-optional"), v = o.get("icon-optional"), x = e.ar(o, "text-overlap", "text-allow-overlap"), y = "always" === x, b = e.ar(o, "icon-overlap", "icon-allow-overlap"), w = "always" === b, T = "map" === o.get("text-rotation-alignment"), I = "map" === o.get("text-pitch-alignment"), E = "none" !== o.get("icon-text-fit"), P = "viewport-y" === o.get("symbol-z-order"), C = y && (w || !s.hasIconData() || v), S = w && (y || !s.hasTextData() || g);
                !s.collisionArrays && p && s.deserializeCollisionBoxes(p);
                const z = this._getTerrainElevationFunc(this.retainedQueryData[s.bucketInstanceId].tileID), D = (t, p, w)=>{
                    var P, D;
                    if (i[t.crossTileID]) return;
                    if (_) return void (this.placements[t.crossTileID] = new Nt(!1, !1, !1));
                    let M = !1, A = !1, R = !0, k = null, L = {
                        box: null,
                        placeable: !1,
                        offscreen: null
                    }, F = {
                        box: null,
                        placeable: !1,
                        offscreen: null
                    }, B = null, O = null, N = null, j = 0, U = 0, Z = 0;
                    p.textFeatureIndex ? j = p.textFeatureIndex : t.useRuntimeCollisionCircles && (j = t.featureIndex), p.verticalTextFeatureIndex && (U = p.verticalTextFeatureIndex);
                    const q = p.textBox;
                    if (q) {
                        const i = (i)=>{
                            let a = e.ah.horizontal;
                            if (s.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e = this.prevPlacement.placedOrientations[t.crossTileID];
                                e && (this.placedOrientations[t.crossTileID] = e, a = e, this.markUsedOrientation(s, a, t));
                            }
                            return a;
                        }, o = (i, a)=>{
                            if (s.allowVerticalPlacement && t.numVerticalGlyphVertices > 0 && p.verticalTextBox) {
                                for (const t of s.writingModes)if (t === e.ah.vertical ? (L = a(), F = L) : L = i(), L && L.placeable) break;
                            } else L = i();
                        }, c = t.textAnchorOffsetStartIndex, u = t.textAnchorOffsetEndIndex;
                        if (u === c) {
                            const a = (e, i)=>{
                                const a = this.collisionIndex.placeCollisionBox(e, x, d, l, h, I, T, r, f.predicate, z);
                                return a && a.placeable && (this.markUsedOrientation(s, i, t), this.placedOrientations[t.crossTileID] = i), a;
                            };
                            o(()=>a(q, e.ah.horizontal), ()=>{
                                const i = p.verticalTextBox;
                                return s.allowVerticalPlacement && t.numVerticalGlyphVertices > 0 && i ? a(i, e.ah.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(L && L.placeable);
                        } else {
                            let _ = e.aq[null === (D = null === (P = this.prevPlacement) || void 0 === P ? void 0 : P.variableOffsets[t.crossTileID]) || void 0 === D ? void 0 : D.anchor];
                            const m = (i, o, p)=>{
                                const m = i.x2 - i.x1, g = i.y2 - i.y1, v = t.textBoxScale, y = E && "never" === b ? o : null;
                                let w = null, P = "never" === x ? 1 : 2, C = "never";
                                _ && P++;
                                for(let e = 0; e < P; e++){
                                    for(let e = c; e < u; e++){
                                        const a = s.textAnchorOffsets.get(e);
                                        if (_ && a.textAnchor !== _) continue;
                                        const o = this.attemptAnchorPlacement(a, i, m, g, v, T, I, d, l, h, f, C, t, s, p, r, n, y, z);
                                        if (o && (w = o.placedGlyphBoxes, w && w.placeable)) return M = !0, k = o.shift, w;
                                    }
                                    _ ? _ = null : C = x;
                                }
                                return a && !w && (w = {
                                    box: this.collisionIndex.placeCollisionBox(q, "always", d, l, h, I, T, r, f.predicate, z, new e.P(0, 0)).box,
                                    offscreen: !1,
                                    placeable: !1
                                }), w;
                            };
                            o(()=>m(q, p.iconBox, e.ah.horizontal), ()=>{
                                const i = p.verticalTextBox;
                                return s.allowVerticalPlacement && (!L || !L.placeable) && t.numVerticalGlyphVertices > 0 && i ? m(i, p.verticalIconBox, e.ah.vertical) : {
                                    box: null,
                                    occluded: !0,
                                    offscreen: null
                                };
                            }), L && (M = L.placeable, R = L.offscreen);
                            const g = i(L && L.placeable);
                            if (!M && this.prevPlacement) {
                                const e = this.prevPlacement.variableOffsets[t.crossTileID];
                                e && (this.variableOffsets[t.crossTileID] = e, this.markUsedJustification(s, e.anchor, t, g));
                            }
                        }
                    }
                    if (B = L, M = B && B.placeable, R = B && B.offscreen, t.useRuntimeCollisionCircles) {
                        const i = s.text.placedSymbolArray.get(t.centerJustifiedTextSymbolIndex), n = e.ai(s.textSizeData, m, i), d = o.get("text-padding");
                        O = this.collisionIndex.placeCollisionCircles(x, i, s.lineVertexArray, s.glyphOffsetArray, n, l, h, c, u, a, I, f.predicate, t.collisionCircleDiameter, d, r, z), O.circles.length && O.collisionDetected && !a && e.w("Collisions detected, but collision boxes are not shown"), M = y || O.circles.length > 0 && !O.collisionDetected, R = R && O.offscreen;
                    }
                    if (p.iconFeatureIndex && (Z = p.iconFeatureIndex), p.iconBox) {
                        const t = (t)=>this.collisionIndex.placeCollisionBox(t, b, d, l, h, I, T, n, f.predicate, z, E && k ? k : void 0);
                        F && F.placeable && p.verticalIconBox ? (N = t(p.verticalIconBox), A = N.placeable) : (N = t(p.iconBox), A = N.placeable), R = R && N.offscreen;
                    }
                    const V = g || 0 === t.numHorizontalGlyphVertices && 0 === t.numVerticalGlyphVertices, G = v || 0 === t.numIconVertices;
                    V || G ? G ? V || (A = A && M) : M = A && M : A = M = A && M;
                    const H = A && N.placeable;
                    if (M && B.placeable && this.collisionIndex.insertCollisionBox(B.box, x, o.get("text-ignore-placement"), s.bucketInstanceId, F && F.placeable && U ? U : j, f.ID), H && this.collisionIndex.insertCollisionBox(N.box, b, o.get("icon-ignore-placement"), s.bucketInstanceId, Z, f.ID), O && M && this.collisionIndex.insertCollisionCircles(O.circles, x, o.get("text-ignore-placement"), s.bucketInstanceId, j, f.ID), a && this.storeCollisionData(s.bucketInstanceId, w, p, B, N, O), 0 === t.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === s.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[t.crossTileID] = new Nt(M || C, A || S, R || s.justReloaded), i[t.crossTileID] = !0;
                };
                if (P) {
                    if (0 !== t.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const e = s.getSortedSymbolIndexes(this.transform.angle);
                    for(let t = e.length - 1; t >= 0; --t){
                        const i = e[t];
                        D(s.symbolInstances.get(i), s.collisionArrays[i], i);
                    }
                } else for(let e = t.symbolInstanceStart; e < t.symbolInstanceEnd; e++)D(s.symbolInstances.get(e), s.collisionArrays[e], e);
                if (a && s.bucketInstanceId in this.collisionCircleArrays) {
                    const t = this.collisionCircleArrays[s.bucketInstanceId];
                    e.as(t.invProjMatrix, l), t.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                s.justReloaded = !1;
            }
            storeCollisionData(t, e, i, a, s, o) {
                if (i.textBox || i.iconBox) {
                    let o, r;
                    this.collisionBoxArrays.has(t) ? o = this.collisionBoxArrays.get(t) : (o = new Map, this.collisionBoxArrays.set(t, o)), o.has(e) ? r = o.get(e) : (r = {
                        text: null,
                        icon: null
                    }, o.set(e, r)), i.textBox && (r.text = a.box), i.iconBox && (r.icon = s.box);
                }
                if (o) {
                    let e = this.collisionCircleArrays[t];
                    void 0 === e && (e = this.collisionCircleArrays[t] = new jt);
                    for(let t = 0; t < o.circles.length; t += 4)e.circles.push(o.circles[t + 0]), e.circles.push(o.circles[t + 1]), e.circles.push(o.circles[t + 2]), e.circles.push(o.collisionDetected ? 1 : 0);
                }
            }
            markUsedJustification(t, i, a, s) {
                let o;
                o = s === e.ah.vertical ? a.verticalPlacedTextSymbolIndex : ({
                    left: a.leftJustifiedTextSymbolIndex,
                    center: a.centerJustifiedTextSymbolIndex,
                    right: a.rightJustifiedTextSymbolIndex
                })[e.at(i)];
                const r = [
                    a.leftJustifiedTextSymbolIndex,
                    a.centerJustifiedTextSymbolIndex,
                    a.rightJustifiedTextSymbolIndex,
                    a.verticalPlacedTextSymbolIndex
                ];
                for (const e of r)e >= 0 && (t.text.placedSymbolArray.get(e).crossTileID = o >= 0 && e !== o ? 0 : a.crossTileID);
            }
            markUsedOrientation(t, i, a) {
                const s = i === e.ah.horizontal || i === e.ah.horizontalOnly ? i : 0, o = i === e.ah.vertical ? i : 0, r = [
                    a.leftJustifiedTextSymbolIndex,
                    a.centerJustifiedTextSymbolIndex,
                    a.rightJustifiedTextSymbolIndex
                ];
                for (const e of r)t.text.placedSymbolArray.get(e).placedOrientation = s;
                a.verticalPlacedTextSymbolIndex && (t.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).placedOrientation = o);
            }
            commit(t) {
                this.commitTime = t, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const e = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = e ? e.zoomAdjustment(this.transform.zoom) : 0;
                const a = e ? e.symbolFadeChange(t) : 1, s = e ? e.opacities : {}, o = e ? e.variableOffsets : {}, r = e ? e.placedOrientations : {};
                for(const t in this.placements){
                    const e = this.placements[t], o = s[t];
                    o ? (this.opacities[t] = new Ot(o, a, e.text, e.icon), i = i || e.text !== o.text.placed || e.icon !== o.icon.placed) : (this.opacities[t] = new Ot(null, a, e.text, e.icon, e.skipFade), i = i || e.text || e.icon);
                }
                for(const t in s){
                    const e = s[t];
                    if (!this.opacities[t]) {
                        const s = new Ot(e, a, !1, !1);
                        s.isHidden() || (this.opacities[t] = s, i = i || e.text.placed || e.icon.placed);
                    }
                }
                for(const t in o)this.variableOffsets[t] || !this.opacities[t] || this.opacities[t].isHidden() || (this.variableOffsets[t] = o[t]);
                for(const t in r)this.placedOrientations[t] || !this.opacities[t] || this.opacities[t].isHidden() || (this.placedOrientations[t] = r[t]);
                if (e && void 0 === e.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = t : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e ? e.lastPlacementChangeTime : t);
            }
            updateLayerOpacities(t, e) {
                const i = {};
                for (const a of e){
                    const e = a.getBucket(t);
                    e && a.latestFeatureIndex && t.id === e.layerIds[0] && this.updateBucketOpacities(e, a.tileID, i, a.collisionBoxArray);
                }
            }
            updateBucketOpacities(t, i, a, s) {
                t.hasTextData() && (t.text.opacityVertexArray.clear(), t.text.hasVisibleVertices = !1), t.hasIconData() && (t.icon.opacityVertexArray.clear(), t.icon.hasVisibleVertices = !1), t.hasIconCollisionBoxData() && t.iconCollisionBox.collisionVertexArray.clear(), t.hasTextCollisionBoxData() && t.textCollisionBox.collisionVertexArray.clear();
                const o = t.layers[0], r = o.layout, n = new Ot(null, 0, !1, !1, !0), l = r.get("text-allow-overlap"), h = r.get("icon-allow-overlap"), c = o._unevaluatedLayout.hasValue("text-variable-anchor") || o._unevaluatedLayout.hasValue("text-variable-anchor-offset"), u = "map" === r.get("text-rotation-alignment"), d = "map" === r.get("text-pitch-alignment"), _ = "none" !== r.get("icon-text-fit"), p = new Ot(null, 0, l && (h || !t.hasIconData() || r.get("icon-optional")), h && (l || !t.hasTextData() || r.get("text-optional")), !0);
                !t.collisionArrays && s && (t.hasIconCollisionBoxData() || t.hasTextCollisionBoxData()) && t.deserializeCollisionBoxes(s);
                const m = (t, e, i)=>{
                    for(let a = 0; a < e / 4; a++)t.opacityVertexArray.emplaceBack(i);
                    t.hasVisibleVertices = t.hasVisibleVertices || i !== te;
                }, f = this.collisionBoxArrays.get(t.bucketInstanceId);
                for(let i = 0; i < t.symbolInstances.length; i++){
                    const s = t.symbolInstances.get(i), { numHorizontalGlyphVertices: o, numVerticalGlyphVertices: r, crossTileID: l } = s;
                    let h = this.opacities[l];
                    a[l] ? h = n : h || (h = p, this.opacities[l] = h), a[l] = !0;
                    const g = s.numIconVertices > 0, v = this.placedOrientations[s.crossTileID], x = v === e.ah.vertical, y = v === e.ah.horizontal || v === e.ah.horizontalOnly;
                    if (o > 0 || r > 0) {
                        const e = Qt(h.text);
                        m(t.text, o, x ? te : e), m(t.text, r, y ? te : e);
                        const i = h.text.isHidden();
                        [
                            s.rightJustifiedTextSymbolIndex,
                            s.centerJustifiedTextSymbolIndex,
                            s.leftJustifiedTextSymbolIndex
                        ].forEach((e)=>{
                            e >= 0 && (t.text.placedSymbolArray.get(e).hidden = i || x ? 1 : 0);
                        }), s.verticalPlacedTextSymbolIndex >= 0 && (t.text.placedSymbolArray.get(s.verticalPlacedTextSymbolIndex).hidden = i || y ? 1 : 0);
                        const a = this.variableOffsets[s.crossTileID];
                        a && this.markUsedJustification(t, a.anchor, s, v);
                        const n = this.placedOrientations[s.crossTileID];
                        n && (this.markUsedJustification(t, "left", s, n), this.markUsedOrientation(t, n, s));
                    }
                    if (g) {
                        const e = Qt(h.icon), i = !(_ && s.verticalPlacedIconSymbolIndex && x);
                        s.placedIconSymbolIndex >= 0 && (m(t.icon, s.numIconVertices, i ? e : te), t.icon.placedSymbolArray.get(s.placedIconSymbolIndex).hidden = h.icon.isHidden()), s.verticalPlacedIconSymbolIndex >= 0 && (m(t.icon, s.numVerticalIconVertices, i ? te : e), t.icon.placedSymbolArray.get(s.verticalPlacedIconSymbolIndex).hidden = h.icon.isHidden());
                    }
                    const b = f && f.has(i) ? f.get(i) : {
                        text: null,
                        icon: null
                    };
                    if (t.hasIconCollisionBoxData() || t.hasTextCollisionBoxData()) {
                        const a = t.collisionArrays[i];
                        if (a) {
                            let i = new e.P(0, 0);
                            if (a.textBox || a.verticalTextBox) {
                                let e = !0;
                                if (c) {
                                    const t = this.variableOffsets[l];
                                    t ? (i = qt(t.anchor, t.width, t.height, t.textOffset, t.textBoxScale), u && i._rotate(d ? this.transform.angle : -this.transform.angle)) : e = !1;
                                }
                                if (a.textBox || a.verticalTextBox) {
                                    let s;
                                    a.textBox && (s = x), a.verticalTextBox && (s = y), Gt(t.textCollisionBox.collisionVertexArray, h.text.placed, !e || s, b.text, i.x, i.y);
                                }
                            }
                            if (a.iconBox || a.verticalIconBox) {
                                const e = Boolean(!y && a.verticalIconBox);
                                let s;
                                a.iconBox && (s = e), a.verticalIconBox && (s = !e), Gt(t.iconCollisionBox.collisionVertexArray, h.icon.placed, s, b.icon, _ ? i.x : 0, _ ? i.y : 0);
                            }
                        }
                    }
                }
                if (t.sortFeatures(this.transform.angle), this.retainedQueryData[t.bucketInstanceId] && (this.retainedQueryData[t.bucketInstanceId].featureSortOrder = t.featureSortOrder), t.hasTextData() && t.text.opacityVertexBuffer && t.text.opacityVertexBuffer.updateData(t.text.opacityVertexArray), t.hasIconData() && t.icon.opacityVertexBuffer && t.icon.opacityVertexBuffer.updateData(t.icon.opacityVertexArray), t.hasIconCollisionBoxData() && t.iconCollisionBox.collisionVertexBuffer && t.iconCollisionBox.collisionVertexBuffer.updateData(t.iconCollisionBox.collisionVertexArray), t.hasTextCollisionBoxData() && t.textCollisionBox.collisionVertexBuffer && t.textCollisionBox.collisionVertexBuffer.updateData(t.textCollisionBox.collisionVertexArray), t.text.opacityVertexArray.length !== t.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${t.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${t.text.layoutVertexArray.length}) / 4`);
                if (t.icon.opacityVertexArray.length !== t.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${t.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${t.icon.layoutVertexArray.length}) / 4`);
                if (t.bucketInstanceId in this.collisionCircleArrays) {
                    const e = this.collisionCircleArrays[t.bucketInstanceId];
                    t.placementInvProjMatrix = e.invProjMatrix, t.placementViewportMatrix = e.viewportMatrix, t.collisionCircleArray = e.circles, delete this.collisionCircleArrays[t.bucketInstanceId];
                }
            }
            symbolFadeChange(t) {
                return 0 === this.fadeDuration ? 1 : (t - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(t) {
                return Math.max(0, (this.transform.zoom - t) / 1.5);
            }
            hasTransitions(t) {
                return this.stale || t - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(t, e) {
                const i = this.zoomAtLastRecencyCheck === e ? 1 - this.zoomAdjustment(e) : 1;
                return this.zoomAtLastRecencyCheck = e, this.commitTime + this.fadeDuration * i > t;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function Gt(t, e, i, a, s, o) {
            a && 0 !== a.length || (a = [
                0,
                0,
                0,
                0
            ]);
            const r = a[0] - kt, n = a[1] - kt, l = a[2] - kt, h = a[3] - kt;
            t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, o || 0, r, n), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, o || 0, l, n), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, o || 0, l, h), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, o || 0, r, h);
        }
        const Ht = Math.pow(2, 25), Wt = Math.pow(2, 24), $t = Math.pow(2, 17), Xt = Math.pow(2, 16), Kt = Math.pow(2, 9), Jt = Math.pow(2, 8), Yt = Math.pow(2, 1);
        function Qt(t) {
            if (0 === t.opacity && !t.placed) return 0;
            if (1 === t.opacity && t.placed) return 4294967295;
            const e = t.placed ? 1 : 0, i = Math.floor(127 * t.opacity);
            return i * Ht + e * Wt + i * $t + e * Xt + i * Kt + e * Jt + i * Yt + e;
        }
        const te = 0;
        function ee() {
            return {
                isOccluded: (t, e, i)=>!1,
                getPitchedTextCorrection: (t, e, i)=>1,
                get useSpecialProjectionForSymbols () {
                    return !1;
                },
                projectTileCoordinates (t, e, i, a) {
                    throw new Error("Not implemented.");
                },
                translatePosition: (t, e, i, a)=>(function(t, e, i, a, s = !1) {
                        if (!i[0] && !i[1]) return [
                            0,
                            0
                        ];
                        const o = s ? "map" === a ? t.angle : 0 : "viewport" === a ? -t.angle : 0;
                        if (o) {
                            const t = Math.sin(o), e = Math.cos(o);
                            i = [
                                i[0] * e - i[1] * t,
                                i[0] * t + i[1] * e
                            ];
                        }
                        return [
                            s ? i[0] : Ft(e, i[0], t.zoom),
                            s ? i[1] : Ft(e, i[1], t.zoom)
                        ];
                    })(t, e, i, a),
                getCircleRadiusCorrection: (t)=>1
            };
        }
        class ie {
            constructor(t){
                this._sortAcrossTiles = "viewport-y" !== t.layout.get("symbol-z-order") && !t.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(t, e, i, a, s) {
                const o = this._bucketParts;
                for(; this._currentTileIndex < t.length;)if (e.getBucketParts(o, a, t[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, s()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort((t, e)=>t.sortKey - e.sortKey)); this._currentPartIndex < o.length;)if (e.placeLayerBucketPart(o[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, s()) return !0;
                return !1;
            }
        }
        class ae {
            constructor(t, e, i, a, s, o, r, n){
                this.placement = new Vt(t, ee(), e, o, r, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = a, this._showCollisionBoxes = s, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t, e, i) {
                const a = o.now(), s = ()=>!this._forceFullPlacement && o.now() - a > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const a = e[t[this._currentPlacementIndex]], o = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === a.type && (!a.minzoom || a.minzoom <= o) && (!a.maxzoom || a.maxzoom > o)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new ie(a)), this._inProgressLayer.continuePlacement(i[a.source], this.placement, this._showCollisionBoxes, a, s)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(t) {
                return this.placement.commit(t), this.placement;
            }
        }
        const se = 512 / e.X / 2;
        class oe {
            constructor(t, i, a){
                this.tileID = t, this.bucketInstanceId = a, this._symbolsByKey = {};
                const s = new Map;
                for(let t = 0; t < i.length; t++){
                    const e = i.get(t), a = e.key, o = s.get(a);
                    o ? o.push(e) : s.set(a, [
                        e
                    ]);
                }
                for (const [t, i] of s){
                    const a = {
                        positions: i.map((t)=>({
                                x: Math.floor(t.anchorX * se),
                                y: Math.floor(t.anchorY * se)
                            })),
                        crossTileIDs: i.map((t)=>t.crossTileID)
                    };
                    if (a.positions.length > 128) {
                        const t = new e.av(a.positions.length, 16, Uint16Array);
                        for (const { x: e, y: i } of a.positions)t.add(e, i);
                        t.finish(), delete a.positions, a.index = t;
                    }
                    this._symbolsByKey[t] = a;
                }
            }
            getScaledCoordinates(t, i) {
                const { x: a, y: s, z: o } = this.tileID.canonical, { x: r, y: n, z: l } = i.canonical, h = se / Math.pow(2, l - o), c = (n * e.X + t.anchorY) * h, u = s * e.X * se;
                return {
                    x: Math.floor((r * e.X + t.anchorX) * h - a * e.X * se),
                    y: Math.floor(c - u)
                };
            }
            findMatches(t, e, i) {
                const a = this.tileID.canonical.z < e.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e.canonical.z);
                for(let s = 0; s < t.length; s++){
                    const o = t.get(s);
                    if (o.crossTileID) continue;
                    const r = this._symbolsByKey[o.key];
                    if (!r) continue;
                    const n = this.getScaledCoordinates(o, e);
                    if (r.index) {
                        const t = r.index.range(n.x - a, n.y - a, n.x + a, n.y + a).sort();
                        for (const e of t){
                            const t = r.crossTileIDs[e];
                            if (!i[t]) {
                                i[t] = !0, o.crossTileID = t;
                                break;
                            }
                        }
                    } else if (r.positions) for(let t = 0; t < r.positions.length; t++){
                        const e = r.positions[t], s = r.crossTileIDs[t];
                        if (Math.abs(e.x - n.x) <= a && Math.abs(e.y - n.y) <= a && !i[s]) {
                            i[s] = !0, o.crossTileID = s;
                            break;
                        }
                    }
                }
            }
            getCrossTileIDsLists() {
                return Object.values(this._symbolsByKey).map(({ crossTileIDs: t })=>t);
            }
        }
        class re {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class ne {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(t) {
                const e = Math.round((t - this.lng) / 360);
                if (0 !== e) for(const t in this.indexes){
                    const i = this.indexes[t], a = {};
                    for(const t in i){
                        const s = i[t];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + e), a[s.tileID.key] = s;
                    }
                    this.indexes[t] = a;
                }
                this.lng = t;
            }
            addBucket(t, e, i) {
                if (this.indexes[t.overscaledZ] && this.indexes[t.overscaledZ][t.key]) {
                    if (this.indexes[t.overscaledZ][t.key].bucketInstanceId === e.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(t.overscaledZ, this.indexes[t.overscaledZ][t.key]);
                }
                for(let t = 0; t < e.symbolInstances.length; t++)e.symbolInstances.get(t).crossTileID = 0;
                this.usedCrossTileIDs[t.overscaledZ] || (this.usedCrossTileIDs[t.overscaledZ] = {});
                const a = this.usedCrossTileIDs[t.overscaledZ];
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    if (Number(i) > t.overscaledZ) for(const i in s){
                        const o = s[i];
                        o.tileID.isChildOf(t) && o.findMatches(e.symbolInstances, t, a);
                    }
                    else {
                        const o = s[t.scaledTo(Number(i)).key];
                        o && o.findMatches(e.symbolInstances, t, a);
                    }
                }
                for(let t = 0; t < e.symbolInstances.length; t++){
                    const s = e.symbolInstances.get(t);
                    s.crossTileID || (s.crossTileID = i.generate(), a[s.crossTileID] = !0);
                }
                return void 0 === this.indexes[t.overscaledZ] && (this.indexes[t.overscaledZ] = {}), this.indexes[t.overscaledZ][t.key] = new oe(t, e.symbolInstances, e.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(t, e) {
                for (const i of e.getCrossTileIDsLists())for (const e of i)delete this.usedCrossTileIDs[t][e];
            }
            removeStaleBuckets(t) {
                let e = !1;
                for(const i in this.indexes){
                    const a = this.indexes[i];
                    for(const s in a)t[a[s].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, a[s]), delete a[s], e = !0);
                }
                return e;
            }
        }
        class le {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new re, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(t, e, i) {
                let a = this.layerIndexes[t.id];
                void 0 === a && (a = this.layerIndexes[t.id] = new ne);
                let s = !1;
                const o = {};
                a.handleWrapJump(i);
                for (const i of e){
                    const e = i.getBucket(t);
                    e && t.id === e.layerIds[0] && (e.bucketInstanceId || (e.bucketInstanceId = ++this.maxBucketInstanceId), a.addBucket(i.tileID, e, this.crossTileIDs) && (s = !0), o[e.bucketInstanceId] = !0);
                }
                return a.removeStaleBuckets(o) && (s = !0), s;
            }
            pruneUnusedLayers(t) {
                const e = {};
                t.forEach((t)=>{
                    e[t] = !0;
                });
                for(const t in this.layerIndexes)e[t] || delete this.layerIndexes[t];
            }
        }
        const he = (t, i)=>e.t(t, i && i.filter((t)=>"source.canvas" !== t.identifier)), ce = e.aw();
        class ue extends e.E {
            constructor(t, i = {}){
                super(), this._rtlPluginLoaded = ()=>{
                    for(const t in this.sourceCaches){
                        const e = this.sourceCaches[t].getSource().type;
                        "vector" !== e && "geojson" !== e || this.sourceCaches[t].reload();
                    }
                }, this.map = t, this.dispatcher = new j(N(), t._getMapId()), this.dispatcher.registerMessageHandler("GG", (t, e)=>this.getGlyphs(t, e)), this.dispatcher.registerMessageHandler("GI", (t, e)=>this.getImages(t, e)), this.imageManager = new T, this.imageManager.setEventedParent(this), this.glyphManager = new C(t._requestManager, i.localIdeographFontFamily), this.lineAtlas = new R(256, 512), this.crossTileSymbolIndex = new le, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new e.ax, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("SR", e.ay()), nt().on(st, this._rtlPluginLoaded), this.on("data", (t)=>{
                    if ("source" !== t.dataType || "metadata" !== t.sourceDataType) return;
                    const e = this.sourceCaches[t.sourceId];
                    if (!e) return;
                    const i = e.getSource();
                    if (i && i.vectorLayerIds) for(const t in this._layers){
                        const e = this._layers[t];
                        e.source === i.id && this._validateLayer(e);
                    }
                });
            }
            loadURL(t, i = {}, a) {
                this.fire(new e.k("dataloading", {
                    dataType: "style"
                })), i.validate = "boolean" != typeof i.validate || i.validate;
                const s = this.map._requestManager.transformRequest(t, "Style");
                this._loadStyleRequest = new AbortController;
                const o = this._loadStyleRequest;
                e.h(s, this._loadStyleRequest).then((t)=>{
                    this._loadStyleRequest = null, this._load(t.data, i, a);
                }).catch((t)=>{
                    this._loadStyleRequest = null, t && !o.signal.aborted && this.fire(new e.j(t));
                });
            }
            loadJSON(t, i = {}, a) {
                this.fire(new e.k("dataloading", {
                    dataType: "style"
                })), this._frameRequest = new AbortController, o.frameAsync(this._frameRequest).then(()=>{
                    this._frameRequest = null, i.validate = !1 !== i.validate, this._load(t, i, a);
                }).catch(()=>{});
            }
            loadEmpty() {
                this.fire(new e.k("dataloading", {
                    dataType: "style"
                })), this._load(ce, {
                    validate: !1
                });
            }
            _load(t, i, a) {
                var s;
                const o = i.transformStyle ? i.transformStyle(a, t) : t;
                if (!i.validate || !he(this, e.u(o))) {
                    this._loaded = !0, this.stylesheet = o;
                    for(const t in o.sources)this.addSource(t, o.sources[t], {
                        validate: !1
                    });
                    o.sprite ? this._loadSprite(o.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(o.glyphs), this._createLayers(), this.light = new D(this.stylesheet.light), this.sky = new A(this.stylesheet.sky), this.map.setTerrain(null !== (s = this.stylesheet.terrain) && void 0 !== s ? s : null), this.fire(new e.k("data", {
                        dataType: "style"
                    })), this.fire(new e.k("style.load"));
                }
            }
            _createLayers() {
                const t = e.az(this.stylesheet.layers);
                this.dispatcher.broadcast("SL", t), this._order = t.map((t)=>t.id), this._layers = {}, this._serializedLayers = null;
                for (const i of t){
                    const t = e.aA(i);
                    t.setEventedParent(this, {
                        layer: {
                            id: i.id
                        }
                    }), this._layers[i.id] = t;
                }
            }
            _loadSprite(t, i = !1, a) {
                let s;
                this.imageManager.setLoaded(!1), this._spriteRequest = new AbortController, (function(t, i, a, s) {
                    return e._(this, void 0, void 0, function*() {
                        const r = x(t), n = a > 1 ? "@2x" : "", l = {}, h = {};
                        for (const { id: t, url: a } of r){
                            const o = i.transformRequest(y(a, n, ".json"), "SpriteJSON");
                            l[t] = e.h(o, s);
                            const r = i.transformRequest(y(a, n, ".png"), "SpriteImage");
                            h[t] = _.getImage(r, s);
                        }
                        return yield Promise.all([
                            ...Object.values(l),
                            ...Object.values(h)
                        ]), function(t, i) {
                            return e._(this, void 0, void 0, function*() {
                                const e = {};
                                for(const a in t){
                                    e[a] = {};
                                    const s = o.getImageCanvasContext((yield i[a]).data), r = (yield t[a]).data;
                                    for(const t in r){
                                        const { width: i, height: o, x: n, y: l, sdf: h, pixelRatio: c, stretchX: u, stretchY: d, content: _, textFitWidth: p, textFitHeight: m } = r[t];
                                        e[a][t] = {
                                            data: null,
                                            pixelRatio: c,
                                            sdf: h,
                                            stretchX: u,
                                            stretchY: d,
                                            content: _,
                                            textFitWidth: p,
                                            textFitHeight: m,
                                            spriteData: {
                                                width: i,
                                                height: o,
                                                x: n,
                                                y: l,
                                                context: s
                                            }
                                        };
                                    }
                                }
                                return e;
                            });
                        }(l, h);
                    });
                })(t, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((t)=>{
                    if (this._spriteRequest = null, t) for(const e in t){
                        this._spritesImagesIds[e] = [];
                        const a = this._spritesImagesIds[e] ? this._spritesImagesIds[e].filter((e)=>!(e in t)) : [];
                        for (const t of a)this.imageManager.removeImage(t), this._changedImages[t] = !0;
                        for(const a in t[e]){
                            const s = "default" === e ? a : `${e}:${a}`;
                            this._spritesImagesIds[e].push(s), s in this.imageManager.images ? this.imageManager.updateImage(s, t[e][a], !1) : this.imageManager.addImage(s, t[e][a]), i && (this._changedImages[s] = !0);
                        }
                    }
                }).catch((t)=>{
                    this._spriteRequest = null, s = t, this.fire(new e.j(s));
                }).finally(()=>{
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), i && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e.k("data", {
                        dataType: "style"
                    })), a && a(s);
                });
            }
            _unloadSprite() {
                for (const t of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(t), this._changedImages[t] = !0;
                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e.k("data", {
                    dataType: "style"
                }));
            }
            _validateLayer(t) {
                const i = this.sourceCaches[t.source];
                if (!i) return;
                const a = t.sourceLayer;
                if (!a) return;
                const s = i.getSource();
                ("geojson" === s.type || s.vectorLayerIds && -1 === s.vectorLayerIds.indexOf(a)) && this.fire(new e.j(new Error(`Source layer "${a}" does not exist on source "${s.id}" as specified by style layer "${t.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const t in this.sourceCaches)if (!this.sourceCaches[t].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeByIds(t, i = !1) {
                const a = this._serializedAllLayers();
                if (!t || 0 === t.length) return Object.values(i ? e.aB(a) : a);
                const s = [];
                for (const o of t)if (a[o]) {
                    const t = i ? e.aB(a[o]) : a[o];
                    s.push(t);
                }
                return s;
            }
            _serializedAllLayers() {
                let t = this._serializedLayers;
                if (t) return t;
                t = this._serializedLayers = {};
                const e = Object.keys(this._layers);
                for (const i of e){
                    const e = this._layers[i];
                    "custom" !== e.type && (t[i] = e.serialize());
                }
                return t;
            }
            hasTransitions() {
                if (this.light && this.light.hasTransition()) return !0;
                if (this.sky && this.sky.hasTransition()) return !0;
                for(const t in this.sourceCaches)if (this.sourceCaches[t].hasTransition()) return !0;
                for(const t in this._layers)if (this._layers[t].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(t) {
                if (!this._loaded) return;
                const i = this._changed;
                if (i) {
                    const e = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (e.length || i.length) && this._updateWorkerLayers(e, i);
                    for(const t in this._updatedSources){
                        const e = this._updatedSources[t];
                        if ("reload" === e) this._reloadSource(t);
                        else {
                            if ("clear" !== e) throw new Error(`Invalid action ${e}`);
                            this._clearSource(t);
                        }
                    }
                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                    for(const e in this._updatedPaintProps)this._layers[e].updateTransitions(t);
                    this.light.updateTransitions(t), this.sky.updateTransitions(t), this._resetUpdates();
                }
                const a = {};
                for(const t in this.sourceCaches){
                    const e = this.sourceCaches[t];
                    a[t] = e.used, e.used = !1;
                }
                for (const e of this._order){
                    const i = this._layers[e];
                    i.recalculate(t, this._availableImages), !i.isHidden(t.zoom) && i.source && (this.sourceCaches[i.source].used = !0);
                }
                for(const t in a){
                    const i = this.sourceCaches[t];
                    !!a[t] != !!i.used && i.fire(new e.k("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: t
                    }));
                }
                this.light.recalculate(t), this.sky.recalculate(t), this.z = t.zoom, i && this.fire(new e.k("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const t = Object.keys(this._changedImages);
                if (t.length) {
                    for(const e in this.sourceCaches)this.sourceCaches[e].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], t);
                    this._changedImages = {};
                }
            }
            _updateTilesForChangedGlyphs() {
                if (this._glyphsDidChange) {
                    for(const t in this.sourceCaches)this.sourceCaches[t].reloadTilesForDependencies([
                        "glyphs"
                    ], [
                        ""
                    ]);
                    this._glyphsDidChange = !1;
                }
            }
            _updateWorkerLayers(t, e) {
                this.dispatcher.broadcast("UL", {
                    layers: this._serializeByIds(t, !1),
                    removedIds: e
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
            }
            setState(t, i = {}) {
                var a;
                this._checkLoaded();
                const s = this.serialize();
                if (t = i.transformStyle ? i.transformStyle(s, t) : t, (null === (a = i.validate) || void 0 === a || a) && he(this, e.u(t))) return !1;
                (t = e.aB(t)).layers = e.az(t.layers);
                const o = e.aC(s, t), r = this._getOperationsToPerform(o);
                if (r.unimplemented.length > 0) throw new Error(`Unimplemented: ${r.unimplemented.join(", ")}.`);
                if (0 === r.operations.length) return !1;
                for (const t of r.operations)t();
                return this.stylesheet = t, this._serializedLayers = null, !0;
            }
            _getOperationsToPerform(t) {
                const e = [], i = [];
                for (const a of t)switch(a.command){
                    case "setCenter":
                    case "setZoom":
                    case "setBearing":
                    case "setPitch":
                        continue;
                    case "addLayer":
                        e.push(()=>this.addLayer.apply(this, a.args));
                        break;
                    case "removeLayer":
                        e.push(()=>this.removeLayer.apply(this, a.args));
                        break;
                    case "setPaintProperty":
                        e.push(()=>this.setPaintProperty.apply(this, a.args));
                        break;
                    case "setLayoutProperty":
                        e.push(()=>this.setLayoutProperty.apply(this, a.args));
                        break;
                    case "setFilter":
                        e.push(()=>this.setFilter.apply(this, a.args));
                        break;
                    case "addSource":
                        e.push(()=>this.addSource.apply(this, a.args));
                        break;
                    case "removeSource":
                        e.push(()=>this.removeSource.apply(this, a.args));
                        break;
                    case "setLayerZoomRange":
                        e.push(()=>this.setLayerZoomRange.apply(this, a.args));
                        break;
                    case "setLight":
                        e.push(()=>this.setLight.apply(this, a.args));
                        break;
                    case "setGeoJSONSourceData":
                        e.push(()=>this.setGeoJSONSourceData.apply(this, a.args));
                        break;
                    case "setGlyphs":
                        e.push(()=>this.setGlyphs.apply(this, a.args));
                        break;
                    case "setSprite":
                        e.push(()=>this.setSprite.apply(this, a.args));
                        break;
                    case "setSky":
                        e.push(()=>this.setSky.apply(this, a.args));
                        break;
                    case "setTerrain":
                        e.push(()=>this.map.setTerrain.apply(this, a.args));
                        break;
                    case "setTransition":
                        e.push(()=>{});
                        break;
                    default:
                        i.push(a.command);
                }
                return {
                    operations: e,
                    unimplemented: i
                };
            }
            addImage(t, i) {
                if (this.getImage(t)) return this.fire(new e.j(new Error(`An image named "${t}" already exists.`)));
                this.imageManager.addImage(t, i), this._afterImageUpdated(t);
            }
            updateImage(t, e) {
                this.imageManager.updateImage(t, e);
            }
            getImage(t) {
                return this.imageManager.getImage(t);
            }
            removeImage(t) {
                if (!this.getImage(t)) return this.fire(new e.j(new Error(`An image named "${t}" does not exist.`)));
                this.imageManager.removeImage(t), this._afterImageUpdated(t);
            }
            _afterImageUpdated(t) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[t] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e.k("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(t, i, a = {}) {
                if (this._checkLoaded(), void 0 !== this.sourceCaches[t]) throw new Error(`Source "${t}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(e.u.source, `sources.${t}`, i, null, a)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const s = this.sourceCaches[t] = new ut(t, i, this.dispatcher);
                s.style = this, s.setEventedParent(this, ()=>({
                        isSourceLoaded: s.loaded(),
                        source: s.serialize(),
                        sourceId: t
                    })), s.onAdd(this.map), this._changed = !0;
            }
            removeSource(t) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[t]) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t) return this.fire(new e.j(new Error(`Source "${t}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.sourceCaches[t];
                delete this.sourceCaches[t], delete this._updatedSources[t], i.fire(new e.k("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: t
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(t, e) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[t]) throw new Error(`There is no source with this ID=${t}`);
                const i = this.sourceCaches[t].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(e), this._changed = !0;
            }
            getSource(t) {
                return this.sourceCaches[t] && this.sourceCaches[t].getSource();
            }
            addLayer(t, i, a = {}) {
                this._checkLoaded();
                const s = t.id;
                if (this.getLayer(s)) return void this.fire(new e.j(new Error(`Layer "${s}" already exists on this map.`)));
                let o;
                if ("custom" === t.type) {
                    if (he(this, e.aD(t))) return;
                    o = e.aA(t);
                } else {
                    if ("source" in t && "object" == typeof t.source && (this.addSource(s, t.source), t = e.aB(t), t = e.e(t, {
                        source: s
                    })), this._validate(e.u.layer, `layers.${s}`, t, {
                        arrayIndex: -1
                    }, a)) return;
                    o = e.aA(t), this._validateLayer(o), o.setEventedParent(this, {
                        layer: {
                            id: s
                        }
                    });
                }
                const r = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === r) this.fire(new e.j(new Error(`Cannot add layer "${s}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(r, 0, s), this._layerOrderChanged = !0, this._layers[s] = o, this._removedLayers[s] && o.source && "custom" !== o.type) {
                        const t = this._removedLayers[s];
                        delete this._removedLayers[s], t.type !== o.type ? this._updatedSources[o.source] = "clear" : (this._updatedSources[o.source] = "reload", this.sourceCaches[o.source].pause());
                    }
                    this._updateLayer(o), o.onAdd && o.onAdd(this.map);
                }
            }
            moveLayer(t, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[t]) return void this.fire(new e.j(new Error(`The layer '${t}' does not exist in the map's style and cannot be moved.`)));
                if (t === i) return;
                const a = this._order.indexOf(t);
                this._order.splice(a, 1);
                const s = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === s ? this.fire(new e.j(new Error(`Cannot move layer "${t}" before non-existing layer "${i}".`))) : (this._order.splice(s, 0, t), this._layerOrderChanged = !0);
            }
            removeLayer(t) {
                this._checkLoaded();
                const i = this._layers[t];
                if (!i) return void this.fire(new e.j(new Error(`Cannot remove non-existing layer "${t}".`)));
                i.setEventedParent(null);
                const a = this._order.indexOf(t);
                this._order.splice(a, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[t] = i, delete this._layers[t], this._serializedLayers && delete this._serializedLayers[t], delete this._updatedLayers[t], delete this._updatedPaintProps[t], i.onRemove && i.onRemove(this.map);
            }
            getLayer(t) {
                return this._layers[t];
            }
            getLayersOrder() {
                return [
                    ...this._order
                ];
            }
            hasLayer(t) {
                return t in this._layers;
            }
            setLayerZoomRange(t, i, a) {
                this._checkLoaded();
                const s = this.getLayer(t);
                s ? s.minzoom === i && s.maxzoom === a || (null != i && (s.minzoom = i), null != a && (s.maxzoom = a), this._updateLayer(s)) : this.fire(new e.j(new Error(`Cannot set the zoom range of non-existing layer "${t}".`)));
            }
            setFilter(t, i, a = {}) {
                this._checkLoaded();
                const s = this.getLayer(t);
                if (s) {
                    if (!e.aE(s.filter, i)) return null == i ? (s.filter = void 0, void this._updateLayer(s)) : void (this._validate(e.u.filter, `layers.${s.id}.filter`, i, null, a) || (s.filter = e.aB(i), this._updateLayer(s)));
                } else this.fire(new e.j(new Error(`Cannot filter non-existing layer "${t}".`)));
            }
            getFilter(t) {
                return e.aB(this.getLayer(t).filter);
            }
            setLayoutProperty(t, i, a, s = {}) {
                this._checkLoaded();
                const o = this.getLayer(t);
                o ? e.aE(o.getLayoutProperty(i), a) || (o.setLayoutProperty(i, a, s), this._updateLayer(o)) : this.fire(new e.j(new Error(`Cannot style non-existing layer "${t}".`)));
            }
            getLayoutProperty(t, i) {
                const a = this.getLayer(t);
                if (a) return a.getLayoutProperty(i);
                this.fire(new e.j(new Error(`Cannot get style of non-existing layer "${t}".`)));
            }
            setPaintProperty(t, i, a, s = {}) {
                this._checkLoaded();
                const o = this.getLayer(t);
                o ? e.aE(o.getPaintProperty(i), a) || (o.setPaintProperty(i, a, s) && this._updateLayer(o), this._changed = !0, this._updatedPaintProps[t] = !0, this._serializedLayers = null) : this.fire(new e.j(new Error(`Cannot style non-existing layer "${t}".`)));
            }
            getPaintProperty(t, e) {
                return this.getLayer(t).getPaintProperty(e);
            }
            setFeatureState(t, i) {
                this._checkLoaded();
                const a = t.source, s = t.sourceLayer, o = this.sourceCaches[a];
                if (void 0 === o) return void this.fire(new e.j(new Error(`The source '${a}' does not exist in the map's style.`)));
                const r = o.getSource().type;
                "geojson" === r && s ? this.fire(new e.j(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== r || s ? (void 0 === t.id && this.fire(new e.j(new Error("The feature id parameter must be provided."))), o.setFeatureState(s, t.id, i)) : this.fire(new e.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(t, i) {
                this._checkLoaded();
                const a = t.source, s = this.sourceCaches[a];
                if (void 0 === s) return void this.fire(new e.j(new Error(`The source '${a}' does not exist in the map's style.`)));
                const o = s.getSource().type, r = "vector" === o ? t.sourceLayer : void 0;
                "vector" !== o || r ? i && "string" != typeof t.id && "number" != typeof t.id ? this.fire(new e.j(new Error("A feature id is required to remove its specific state property."))) : s.removeFeatureState(r, t.id, i) : this.fire(new e.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(t) {
                this._checkLoaded();
                const i = t.source, a = t.sourceLayer, s = this.sourceCaches[i];
                if (void 0 !== s) return "vector" !== s.getSource().type || a ? (void 0 === t.id && this.fire(new e.j(new Error("The feature id parameter must be provided."))), s.getFeatureState(a, t.id)) : void this.fire(new e.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new e.j(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return e.e({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                if (!this._loaded) return;
                const t = e.aF(this.sourceCaches, (t)=>t.serialize()), i = this._serializeByIds(this._order, !0), a = this.map.getTerrain() || void 0, s = this.stylesheet;
                return e.aG({
                    version: s.version,
                    name: s.name,
                    metadata: s.metadata,
                    light: s.light,
                    sky: s.sky,
                    center: s.center,
                    zoom: s.zoom,
                    bearing: s.bearing,
                    pitch: s.pitch,
                    sprite: s.sprite,
                    glyphs: s.glyphs,
                    transition: s.transition,
                    sources: t,
                    layers: i,
                    terrain: a
                }, (t)=>void 0 !== t);
            }
            _updateLayer(t) {
                this._updatedLayers[t.id] = !0, t.source && !this._updatedSources[t.source] && "raster" !== this.sourceCaches[t.source].getSource().type && (this._updatedSources[t.source] = "reload", this.sourceCaches[t.source].pause()), this._serializedLayers = null, this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(t) {
                const e = (t)=>"fill-extrusion" === this._layers[t].type, i = {}, a = [];
                for(let s = this._order.length - 1; s >= 0; s--){
                    const o = this._order[s];
                    if (e(o)) {
                        i[o] = s;
                        for (const e of t){
                            const t = e[o];
                            if (t) for (const e of t)a.push(e);
                        }
                    }
                }
                a.sort((t, e)=>e.intersectionZ - t.intersectionZ);
                const s = [];
                for(let o = this._order.length - 1; o >= 0; o--){
                    const r = this._order[o];
                    if (e(r)) for(let t = a.length - 1; t >= 0; t--){
                        const e = a[t].feature;
                        if (i[e.layer.id] < o) break;
                        s.push(e), a.pop();
                    }
                    else for (const e of t){
                        const t = e[r];
                        if (t) for (const e of t)s.push(e.feature);
                    }
                }
                return s;
            }
            queryRenderedFeatures(t, i, a) {
                i && i.filter && this._validate(e.u.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const s = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e.j(new Error("parameters.layers must be an Array."))), [];
                    for (const t of i.layers){
                        const i = this._layers[t];
                        if (!i) return this.fire(new e.j(new Error(`The layer '${t}' does not exist in the map's style and cannot be queried for features.`))), [];
                        s[i.source] = !0;
                    }
                }
                const o = [];
                i.availableImages = this._availableImages;
                const r = this._serializedAllLayers();
                for(const e in this.sourceCaches)i.layers && !s[e] || o.push(q(this.sourceCaches[e], this._layers, r, t, i, a));
                return this.placement && o.push(function(t, e, i, a, s, o, r) {
                    const n = {}, l = o.queryRenderedSymbols(a), h = [];
                    for (const t of Object.keys(l).map(Number))h.push(r[t]);
                    h.sort(V);
                    for (const i of h){
                        const a = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], e, i.bucketIndex, i.sourceLayerIndex, s.filter, s.layers, s.availableImages, t);
                        for(const t in a){
                            const e = n[t] = n[t] || [], s = a[t];
                            s.sort((t, e)=>{
                                const a = i.featureSortOrder;
                                if (a) {
                                    const i = a.indexOf(t.featureIndex);
                                    return a.indexOf(e.featureIndex) - i;
                                }
                                return e.featureIndex - t.featureIndex;
                            });
                            for (const t of s)e.push(t);
                        }
                    }
                    for(const e in n)n[e].forEach((a)=>{
                        const s = a.feature, o = i[t[e].source].getFeatureState(s.layer["source-layer"], s.id);
                        s.source = s.layer.source, s.layer["source-layer"] && (s.sourceLayer = s.layer["source-layer"]), s.state = o;
                    });
                    return n;
                }(this._layers, r, this.sourceCaches, t, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(o);
            }
            querySourceFeatures(t, i) {
                i && i.filter && this._validate(e.u.filter, "querySourceFeatures.filter", i.filter, null, i);
                const a = this.sourceCaches[t];
                return a ? function(t, e) {
                    const i = t.getRenderableIds().map((e)=>t.getTileByID(e)), a = [], s = {};
                    for(let t = 0; t < i.length; t++){
                        const o = i[t], r = o.tileID.canonical.key;
                        s[r] || (s[r] = !0, o.querySourceFeatures(a, e));
                    }
                    return a;
                }(a, i) : [];
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(t, i = {}) {
                this._checkLoaded();
                const a = this.light.getLight();
                let s = !1;
                for(const i in t)if (!e.aE(t[i], a[i])) {
                    s = !0;
                    break;
                }
                if (!s) return;
                const r = {
                    now: o.now(),
                    transition: e.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(t, i), this.light.updateTransitions(r);
            }
            getSky() {
                var t;
                return null === (t = this.stylesheet) || void 0 === t ? void 0 : t.sky;
            }
            setSky(t, i = {}) {
                const a = this.getSky();
                let s = !1;
                if (!t && !a) return;
                if (t && !a) s = !0;
                else if (!t && a) s = !0;
                else for(const i in t)if (!e.aE(t[i], a[i])) {
                    s = !0;
                    break;
                }
                if (!s) return;
                const r = {
                    now: o.now(),
                    transition: e.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.stylesheet.sky = t, this.sky.setSky(t, i), this.sky.updateTransitions(r);
            }
            _validate(t, i, a, s, o = {}) {
                return (!o || !1 !== o.validate) && he(this, t.call(e.u, e.e({
                    key: i,
                    style: this.serialize(),
                    value: a,
                    styleSpec: e.v
                }, s)));
            }
            _remove(t = !0) {
                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), nt().off(st, this._rtlPluginLoaded);
                for(const t in this._layers)this._layers[t].setEventedParent(null);
                for(const t in this.sourceCaches){
                    const e = this.sourceCaches[t];
                    e.setEventedParent(null), e.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), t && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(t);
            }
            _clearSource(t) {
                this.sourceCaches[t].clearTiles();
            }
            _reloadSource(t) {
                this.sourceCaches[t].resume(), this.sourceCaches[t].reload();
            }
            _updateSources(t) {
                for(const e in this.sourceCaches)this.sourceCaches[e].update(t, this.map.terrain);
            }
            _generateCollisionBoxes() {
                for(const t in this.sourceCaches)this._reloadSource(t);
            }
            _updatePlacement(t, e, i, a, s = !1) {
                let r = !1, n = !1;
                const l = {};
                for (const e of this._order){
                    const i = this._layers[e];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const t = this.sourceCaches[i.source];
                        l[i.source] = t.getRenderableIds(!0).map((e)=>t.getTileByID(e)).sort((t, e)=>e.tileID.overscaledZ - t.tileID.overscaledZ || (t.tileID.isLessThan(e.tileID) ? -1 : 1));
                    }
                    const a = this.crossTileSymbolIndex.addLayer(i, l[i.source], t.center.lng);
                    r = r || a;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((s = s || this._layerOrderChanged || 0 === i) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(o.now(), t.zoom)) && (this.pauseablePlacement = new ae(t, this.map.terrain, this._order, s, e, i, a, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(o.now()), n = !0), r && this.pauseablePlacement.placement.setStale()), n || r) for (const t of this._order){
                    const e = this._layers[t];
                    "symbol" === e.type && this.placement.updateLayerOpacities(e, l[e.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(o.now());
            }
            _releaseSymbolFadeTiles() {
                for(const t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();
            }
            getImages(t, i) {
                return e._(this, void 0, void 0, function*() {
                    const t = yield this.imageManager.getImages(i.icons);
                    this._updateTilesForChangedImages();
                    const e = this.sourceCaches[i.source];
                    return e && e.setDependencies(i.tileID.key, i.type, i.icons), t;
                });
            }
            getGlyphs(t, i) {
                return e._(this, void 0, void 0, function*() {
                    const t = yield this.glyphManager.getGlyphs(i.stacks), e = this.sourceCaches[i.source];
                    return e && e.setDependencies(i.tileID.key, i.type, [
                        ""
                    ]), t;
                });
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs || null;
            }
            setGlyphs(t, i = {}) {
                this._checkLoaded(), t && this._validate(e.u.glyphs, "glyphs", t, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = t, this.glyphManager.entries = {}, this.glyphManager.setURL(t));
            }
            addSprite(t, i, a = {}, s) {
                this._checkLoaded();
                const o = [
                    {
                        id: t,
                        url: i
                    }
                ], r = [
                    ...x(this.stylesheet.sprite),
                    ...o
                ];
                this._validate(e.u.sprite, "sprite", r, null, a) || (this.stylesheet.sprite = r, this._loadSprite(o, !0, s));
            }
            removeSprite(t) {
                this._checkLoaded();
                const i = x(this.stylesheet.sprite);
                if (i.find((e)=>e.id === t)) {
                    if (this._spritesImagesIds[t]) for (const e of this._spritesImagesIds[t])this.imageManager.removeImage(e), this._changedImages[e] = !0;
                    i.splice(i.findIndex((e)=>e.id === t), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[t], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e.k("data", {
                        dataType: "style"
                    }));
                } else this.fire(new e.j(new Error(`Sprite "${t}" doesn't exists on this map.`)));
            }
            getSprite() {
                return x(this.stylesheet.sprite);
            }
            setSprite(t, i = {}, a) {
                this._checkLoaded(), t && this._validate(e.u.sprite, "sprite", t, null, i) || (this.stylesheet.sprite = t, t ? this._loadSprite(t, !0, a) : (this._unloadSprite(), a && a(null)));
            }
        }
        var de = e.Y([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const _e = {
            prelude: pe("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\n", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}"),
            background: pe("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            backgroundPattern: pe("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: pe("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: pe("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: pe("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),
            heatmapTexture: pe("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: pe("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_anchor_pos;attribute vec2 a_placed;attribute vec2 a_box_real;uniform mat4 u_matrix;uniform vec2 u_pixel_extrude_scale;varying float v_placed;varying float v_notUsed;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: pe("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: pe("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"),
            fill: pe("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),
            fillOutline: pe("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillOutlinePattern: pe("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillPattern: pe("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: pe("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: pe("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: pe("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: pe("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
            line: pe("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: pe("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: pe("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: pe("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
            raster: pe("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: pe("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_tex;varying float v_fade_opacity;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: pe("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_data0;varying vec3 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: pe("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec4 v_data0;varying vec4 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: pe("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;varying vec2 v_texture_pos;varying float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture2D(u_texture,v_texture_pos);if (v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);gl_FragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {gl_FragColor=surface_color;}}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform mat4 u_fog_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
            terrainDepth: pe("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}"),
            terrainCoords: pe("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);}"),
            sky: pe("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform float u_horizon;uniform float u_sky_horizon_blend;void main() {float y=gl_FragCoord.y;if (y > u_horizon) {float blend=y-u_horizon;if (blend < u_sky_horizon_blend) {gl_FragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {gl_FragColor=u_sky_color;}}}", "attribute vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
        };
        function pe(t, e) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, a = e.match(/attribute ([\w]+) ([\w]+)/g), s = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = e.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), r = o ? o.concat(s) : s, n = {};
            return {
                fragmentSource: t = t.replace(i, (t, e, i, a, s)=>(n[s] = !0, "define" === e ? `\n#ifndef HAS_UNIFORM_u_${s}\nvarying ${i} ${a} ${s};\n#else\nuniform ${i} ${a} u_${s};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${s}\n    ${i} ${a} ${s} = u_${s};\n#endif\n`)),
                vertexSource: e = e.replace(i, (t, e, i, a, s)=>{
                    const o = "float" === a ? "vec2" : "vec4", r = s.match(/color/) ? "color" : o;
                    return n[s] ? "define" === e ? `\n#ifndef HAS_UNIFORM_u_${s}\nuniform lowp float u_${s}_t;\nattribute ${i} ${o} a_${s};\nvarying ${i} ${a} ${s};\n#else\nuniform ${i} ${a} u_${s};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${s}\n    ${s} = a_${s};\n#else\n    ${i} ${a} ${s} = u_${s};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${s}\n    ${s} = unpack_mix_${r}(a_${s}, u_${s}_t);\n#else\n    ${i} ${a} ${s} = u_${s};\n#endif\n` : "define" === e ? `\n#ifndef HAS_UNIFORM_u_${s}\nuniform lowp float u_${s}_t;\nattribute ${i} ${o} a_${s};\n#else\nuniform ${i} ${a} u_${s};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${s}\n    ${i} ${a} ${s} = a_${s};\n#else\n    ${i} ${a} ${s} = u_${s};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${s}\n    ${i} ${a} ${s} = unpack_mix_${r}(a_${s}, u_${s}_t);\n#else\n    ${i} ${a} ${s} = u_${s};\n#endif\n`;
                }),
                staticAttributes: a,
                staticUniforms: r
            };
        }
        class me {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            bind(t, e, i, a, s, o, r, n, l) {
                this.context = t;
                let h = this.boundPaintVertexBuffers.length !== a.length;
                for(let t = 0; !h && t < a.length; t++)this.boundPaintVertexBuffers[t] !== a[t] && (h = !0);
                !this.vao || this.boundProgram !== e || this.boundLayoutVertexBuffer !== i || h || this.boundIndexBuffer !== s || this.boundVertexOffset !== o || this.boundDynamicVertexBuffer !== r || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(e, i, a, s, o, r, n, l) : (t.bindVertexArray.set(this.vao), r && r.bind(), s && s.dynamicDraw && s.bind(), n && n.bind(), l && l.bind());
            }
            freshBind(t, e, i, a, s, o, r, n) {
                const l = t.numAttributes, h = this.context, c = h.gl;
                this.vao && this.destroy(), this.vao = h.createVertexArray(), h.bindVertexArray.set(this.vao), this.boundProgram = t, this.boundLayoutVertexBuffer = e, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = a, this.boundVertexOffset = s, this.boundDynamicVertexBuffer = o, this.boundDynamicVertexBuffer2 = r, this.boundDynamicVertexBuffer3 = n, e.enableAttributes(c, t);
                for (const e of i)e.enableAttributes(c, t);
                o && o.enableAttributes(c, t), r && r.enableAttributes(c, t), n && n.enableAttributes(c, t), e.bind(), e.setVertexAttribPointers(c, t, s);
                for (const e of i)e.bind(), e.setVertexAttribPointers(c, t, s);
                o && (o.bind(), o.setVertexAttribPointers(c, t, s)), a && a.bind(), r && (r.bind(), r.setVertexAttribPointers(c, t, s)), n && (n.bind(), n.setVertexAttribPointers(c, t, s)), h.currentNumAttributes = l;
            }
            destroy() {
                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        const fe = (t, i, a, s, o)=>({
                u_matrix: t,
                u_texture: 0,
                u_ele_delta: i,
                u_fog_matrix: a,
                u_fog_color: s ? s.properties.get("fog-color") : e.aM.white,
                u_fog_ground_blend: s ? s.properties.get("fog-ground-blend") : 1,
                u_fog_ground_blend_opacity: s ? s.calculateFogBlendOpacity(o) : 0,
                u_horizon_color: s ? s.properties.get("horizon-color") : e.aM.white,
                u_horizon_fog_blend: s ? s.properties.get("horizon-fog-blend") : 1
            });
        function ge(t) {
            const e = [];
            for(let i = 0; i < t.length; i++){
                if (null === t[i]) continue;
                const a = t[i].split(" ");
                e.push(a.pop());
            }
            return e;
        }
        class ve {
            constructor(t, i, a, s, o, r){
                const n = t.gl;
                this.program = n.createProgram();
                const l = ge(i.staticAttributes), h = a ? a.getBinderAttributes() : [], c = l.concat(h), u = _e.prelude.staticUniforms ? ge(_e.prelude.staticUniforms) : [], d = i.staticUniforms ? ge(i.staticUniforms) : [], _ = a ? a.getBinderUniforms() : [], p = u.concat(d).concat(_), m = [];
                for (const t of p)m.indexOf(t) < 0 && m.push(t);
                const f = a ? a.defines() : [];
                o && f.push("#define OVERDRAW_INSPECTOR;"), r && f.push("#define TERRAIN3D;");
                const g = f.concat(_e.prelude.fragmentSource, i.fragmentSource).join("\n"), v = f.concat(_e.prelude.vertexSource, i.vertexSource).join("\n"), x = n.createShader(n.FRAGMENT_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                if (n.shaderSource(x, g), n.compileShader(x), !n.getShaderParameter(x, n.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${n.getShaderInfoLog(x)}`);
                n.attachShader(this.program, x);
                const y = n.createShader(n.VERTEX_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                if (n.shaderSource(y, v), n.compileShader(y), !n.getShaderParameter(y, n.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${n.getShaderInfoLog(y)}`);
                n.attachShader(this.program, y), this.attributes = {};
                const b = {};
                this.numAttributes = c.length;
                for(let t = 0; t < this.numAttributes; t++)c[t] && (n.bindAttribLocation(this.program, t, c[t]), this.attributes[c[t]] = t);
                if (n.linkProgram(this.program), !n.getProgramParameter(this.program, n.LINK_STATUS)) throw new Error(`Program failed to link: ${n.getProgramInfoLog(this.program)}`);
                n.deleteShader(y), n.deleteShader(x);
                for(let t = 0; t < m.length; t++){
                    const e = m[t];
                    if (e && !b[e]) {
                        const t = n.getUniformLocation(this.program, e);
                        t && (b[e] = t);
                    }
                }
                this.fixedUniforms = s(t, b), this.terrainUniforms = ((t, i)=>({
                        u_depth: new e.aH(t, i.u_depth),
                        u_terrain: new e.aH(t, i.u_terrain),
                        u_terrain_dim: new e.aI(t, i.u_terrain_dim),
                        u_terrain_matrix: new e.aJ(t, i.u_terrain_matrix),
                        u_terrain_unpack: new e.aK(t, i.u_terrain_unpack),
                        u_terrain_exaggeration: new e.aI(t, i.u_terrain_exaggeration)
                    }))(t, b), this.binderUniforms = a ? a.getUniforms(t, b) : [];
            }
            draw(t, e, i, a, s, o, r, n, l, h, c, u, d, _, p, m, f, g) {
                const v = t.gl;
                if (this.failedToCreate) return;
                if (t.program.set(this.program), t.setDepthMode(i), t.setStencilMode(a), t.setColorMode(s), t.setCullFace(o), n) {
                    t.activeTexture.set(v.TEXTURE2), v.bindTexture(v.TEXTURE_2D, n.depthTexture), t.activeTexture.set(v.TEXTURE3), v.bindTexture(v.TEXTURE_2D, n.texture);
                    for(const t in this.terrainUniforms)this.terrainUniforms[t].set(n[t]);
                }
                for(const t in this.fixedUniforms)this.fixedUniforms[t].set(r[t]);
                p && p.setUniforms(t, this.binderUniforms, d, {
                    zoom: _
                });
                let x = 0;
                switch(e){
                    case v.LINES:
                        x = 2;
                        break;
                    case v.TRIANGLES:
                        x = 3;
                        break;
                    case v.LINE_STRIP:
                        x = 1;
                }
                for (const i of u.get()){
                    const a = i.vaos || (i.vaos = {});
                    (a[l] || (a[l] = new me)).bind(t, this, h, p ? p.getPaintVertexBuffers() : [], c, i.vertexOffset, m, f, g), v.drawElements(e, i.primitiveLength * x, v.UNSIGNED_SHORT, i.primitiveOffset * x * 2);
                }
            }
        }
        function xe(t, e, i) {
            const a = 1 / Ft(i, 1, e.transform.tileZoom), s = Math.pow(2, i.tileID.overscaledZ), o = i.tileSize * Math.pow(2, e.transform.tileZoom) / s, r = o * (i.tileID.canonical.x + i.tileID.wrap * s), n = o * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    a,
                    t.fromScale,
                    t.toScale
                ],
                u_fade: t.t,
                u_pixel_coord_upper: [
                    r >> 16,
                    n >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & r,
                    65535 & n
                ]
            };
        }
        const ye = (t, i, a, s)=>{
            const o = i.style.light, r = o.properties.get("position"), n = [
                r.x,
                r.y,
                r.z
            ], l = function() {
                var t = new e.A(9);
                return e.A != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[0] = 1, t[4] = 1, t[8] = 1, t;
            }();
            "viewport" === o.properties.get("anchor") && function(t, e) {
                var i = Math.sin(e), a = Math.cos(e);
                t[0] = a, t[1] = i, t[2] = 0, t[3] = -i, t[4] = a, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1;
            }(l, -i.transform.angle), function(t, e, i) {
                var a = e[0], s = e[1], o = e[2];
                t[0] = a * i[0] + s * i[3] + o * i[6], t[1] = a * i[1] + s * i[4] + o * i[7], t[2] = a * i[2] + s * i[5] + o * i[8];
            }(n, n, l);
            const h = o.properties.get("color");
            return {
                u_matrix: t,
                u_lightpos: n,
                u_lightintensity: o.properties.get("intensity"),
                u_lightcolor: [
                    h.r,
                    h.g,
                    h.b
                ],
                u_vertical_gradient: +a,
                u_opacity: s
            };
        }, be = (t, i, a, s, o, r, n)=>e.e(ye(t, i, a, s), xe(r, i, n), {
                u_height_factor: -Math.pow(2, o.overscaledZ) / n.tileSize / 8
            }), we = (t)=>({
                u_matrix: t
            }), Te = (t, i, a, s)=>e.e(we(t), xe(a, i, s)), Ie = (t, e)=>({
                u_matrix: t,
                u_world: e
            }), Ee = (t, i, a, s, o)=>e.e(Te(t, i, a, s), {
                u_world: o
            }), Pe = (t, e, i, a)=>{
            const s = t.transform;
            let o, r;
            if ("map" === a.paint.get("circle-pitch-alignment")) {
                const t = Ft(i, 1, s.zoom);
                o = !0, r = [
                    t,
                    t
                ];
            } else o = !1, r = s.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_scale_with_map: +("map" === a.paint.get("circle-pitch-scale")),
                u_matrix: t.translatePosMatrix(e.posMatrix, i, a.paint.get("circle-translate"), a.paint.get("circle-translate-anchor")),
                u_pitch_with_map: +o,
                u_device_pixel_ratio: t.pixelRatio,
                u_extrude_scale: r
            };
        }, Ce = (t, e, i)=>({
                u_matrix: t,
                u_inv_matrix: e,
                u_camera_to_center_distance: i.cameraToCenterDistance,
                u_viewport_size: [
                    i.width,
                    i.height
                ]
            }), Se = (t, e, i = 1)=>({
                u_matrix: t,
                u_color: e,
                u_overlay: 0,
                u_overlay_scale: i
            }), ze = (t)=>({
                u_matrix: t
            }), De = (t, e, i, a)=>({
                u_matrix: t,
                u_extrude_scale: Ft(e, 1, i),
                u_intensity: a
            });
        function Me(t, i) {
            const a = Math.pow(2, i.canonical.z), s = i.canonical.y;
            return [
                new e.Z(0, s / a).toLngLat().lat,
                new e.Z(0, (s + 1) / a).toLngLat().lat
            ];
        }
        const Ae = (t, e, i, a)=>{
            const s = t.transform;
            return {
                u_matrix: Be(t, e, i, a),
                u_ratio: 1 / Ft(e, 1, s.zoom),
                u_device_pixel_ratio: t.pixelRatio,
                u_units_to_pixels: [
                    1 / s.pixelsToGLUnits[0],
                    1 / s.pixelsToGLUnits[1]
                ]
            };
        }, Re = (t, i, a, s, o)=>e.e(Ae(t, i, a, o), {
                u_image: 0,
                u_image_height: s
            }), ke = (t, e, i, a, s)=>{
            const o = t.transform, r = Fe(e, o);
            return {
                u_matrix: Be(t, e, i, s),
                u_texsize: e.imageAtlasTexture.size,
                u_ratio: 1 / Ft(e, 1, o.zoom),
                u_device_pixel_ratio: t.pixelRatio,
                u_image: 0,
                u_scale: [
                    r,
                    a.fromScale,
                    a.toScale
                ],
                u_fade: a.t,
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ]
            };
        }, Le = (t, i, a, s, o, r)=>{
            const n = t.lineAtlas, l = Fe(i, t.transform), h = "round" === a.layout.get("line-cap"), c = n.getDash(s.from, h), u = n.getDash(s.to, h), d = c.width * o.fromScale, _ = u.width * o.toScale;
            return e.e(Ae(t, i, a, r), {
                u_patternscale_a: [
                    l / d,
                    -c.height / 2
                ],
                u_patternscale_b: [
                    l / _,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(d, _) * t.pixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: c.y,
                u_tex_y_b: u.y,
                u_mix: o.t
            });
        };
        function Fe(t, e) {
            return 1 / Ft(t, 1, e.tileZoom);
        }
        function Be(t, e, i, a) {
            return t.translatePosMatrix(a ? a.posMatrix : e.tileID.posMatrix, e, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        const Oe = (t, e, i, a, s)=>{
            var o, r;
            return {
                u_matrix: t,
                u_tl_parent: e,
                u_scale_parent: i,
                u_buffer_scale: 1,
                u_fade_t: a.mix,
                u_opacity: a.opacity * s.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: s.paint.get("raster-brightness-min"),
                u_brightness_high: s.paint.get("raster-brightness-max"),
                u_saturation_factor: (r = s.paint.get("raster-saturation"), r > 0 ? 1 - 1 / (1.001 - r) : -r),
                u_contrast_factor: (o = s.paint.get("raster-contrast"), o > 0 ? 1 / (1 - o) : 1 + o),
                u_spin_weights: Ne(s.paint.get("raster-hue-rotate"))
            };
        };
        function Ne(t) {
            t *= Math.PI / 180;
            const e = Math.sin(t), i = Math.cos(t);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * e - i + 1) / 3,
                (Math.sqrt(3) * e - i + 1) / 3
            ];
        }
        const je = (t, e, i, a, s, o, r, n, l, h, c, u, d, _)=>{
            const p = r.transform;
            return {
                u_is_size_zoom_constant: +("constant" === t || "source" === t),
                u_is_size_feature_constant: +("constant" === t || "camera" === t),
                u_size_t: e ? e.uSizeT : 0,
                u_size: e ? e.uSize : 0,
                u_camera_to_center_distance: p.cameraToCenterDistance,
                u_pitch: p.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: p.width / p.height,
                u_fade_change: r.options.fadeDuration ? r.symbolFadeChange : 1,
                u_matrix: n,
                u_label_plane_matrix: l,
                u_coord_matrix: h,
                u_is_text: +u,
                u_pitch_with_map: +a,
                u_is_along_line: s,
                u_is_variable_anchor: o,
                u_texsize: d,
                u_texture: 0,
                u_translation: c,
                u_pitched_scale: _
            };
        }, Ue = (t, i, a, s, o, r, n, l, h, c, u, d, _, p, m)=>{
            const f = n.transform;
            return e.e(je(t, i, a, s, o, r, n, l, h, c, u, d, _, m), {
                u_gamma_scale: s ? Math.cos(f._pitch) * f.cameraToCenterDistance : 1,
                u_device_pixel_ratio: n.pixelRatio,
                u_is_halo: +p
            });
        }, Ze = (t, i, a, s, o, r, n, l, h, c, u, d, _, p)=>e.e(Ue(t, i, a, s, o, r, n, l, h, c, u, !0, d, !0, p), {
                u_texsize_icon: _,
                u_texture_icon: 1
            }), qe = (t, e, i)=>({
                u_matrix: t,
                u_opacity: e,
                u_color: i
            }), Ve = (t, i, a, s, o, r)=>e.e(function(t, e, i, a) {
                const s = i.imageManager.getPattern(t.from.toString()), o = i.imageManager.getPattern(t.to.toString()), { width: r, height: n } = i.imageManager.getPixelSize(), l = Math.pow(2, a.tileID.overscaledZ), h = a.tileSize * Math.pow(2, i.transform.tileZoom) / l, c = h * (a.tileID.canonical.x + a.tileID.wrap * l), u = h * a.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: s.tl,
                    u_pattern_br_a: s.br,
                    u_pattern_tl_b: o.tl,
                    u_pattern_br_b: o.br,
                    u_texsize: [
                        r,
                        n
                    ],
                    u_mix: e.t,
                    u_pattern_size_a: s.displaySize,
                    u_pattern_size_b: o.displaySize,
                    u_scale_a: e.fromScale,
                    u_scale_b: e.toScale,
                    u_tile_units_to_pixels: 1 / Ft(a, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        c >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & c,
                        65535 & u
                    ]
                };
            }(s, r, a, o), {
                u_matrix: t,
                u_opacity: i
            }), Ge = {
            fillExtrusion: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_lightpos: new e.aN(t, i.u_lightpos),
                    u_lightintensity: new e.aI(t, i.u_lightintensity),
                    u_lightcolor: new e.aN(t, i.u_lightcolor),
                    u_vertical_gradient: new e.aI(t, i.u_vertical_gradient),
                    u_opacity: new e.aI(t, i.u_opacity)
                }),
            fillExtrusionPattern: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_lightpos: new e.aN(t, i.u_lightpos),
                    u_lightintensity: new e.aI(t, i.u_lightintensity),
                    u_lightcolor: new e.aN(t, i.u_lightcolor),
                    u_vertical_gradient: new e.aI(t, i.u_vertical_gradient),
                    u_height_factor: new e.aI(t, i.u_height_factor),
                    u_image: new e.aH(t, i.u_image),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_pixel_coord_upper: new e.aO(t, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new e.aO(t, i.u_pixel_coord_lower),
                    u_scale: new e.aN(t, i.u_scale),
                    u_fade: new e.aI(t, i.u_fade),
                    u_opacity: new e.aI(t, i.u_opacity)
                }),
            fill: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix)
                }),
            fillPattern: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_image: new e.aH(t, i.u_image),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_pixel_coord_upper: new e.aO(t, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new e.aO(t, i.u_pixel_coord_lower),
                    u_scale: new e.aN(t, i.u_scale),
                    u_fade: new e.aI(t, i.u_fade)
                }),
            fillOutline: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_world: new e.aO(t, i.u_world)
                }),
            fillOutlinePattern: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_world: new e.aO(t, i.u_world),
                    u_image: new e.aH(t, i.u_image),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_pixel_coord_upper: new e.aO(t, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new e.aO(t, i.u_pixel_coord_lower),
                    u_scale: new e.aN(t, i.u_scale),
                    u_fade: new e.aI(t, i.u_fade)
                }),
            circle: (t, i)=>({
                    u_camera_to_center_distance: new e.aI(t, i.u_camera_to_center_distance),
                    u_scale_with_map: new e.aH(t, i.u_scale_with_map),
                    u_pitch_with_map: new e.aH(t, i.u_pitch_with_map),
                    u_extrude_scale: new e.aO(t, i.u_extrude_scale),
                    u_device_pixel_ratio: new e.aI(t, i.u_device_pixel_ratio),
                    u_matrix: new e.aJ(t, i.u_matrix)
                }),
            collisionBox: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_pixel_extrude_scale: new e.aO(t, i.u_pixel_extrude_scale)
                }),
            collisionCircle: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_inv_matrix: new e.aJ(t, i.u_inv_matrix),
                    u_camera_to_center_distance: new e.aI(t, i.u_camera_to_center_distance),
                    u_viewport_size: new e.aO(t, i.u_viewport_size)
                }),
            debug: (t, i)=>({
                    u_color: new e.aL(t, i.u_color),
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_overlay: new e.aH(t, i.u_overlay),
                    u_overlay_scale: new e.aI(t, i.u_overlay_scale)
                }),
            clippingMask: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix)
                }),
            heatmap: (t, i)=>({
                    u_extrude_scale: new e.aI(t, i.u_extrude_scale),
                    u_intensity: new e.aI(t, i.u_intensity),
                    u_matrix: new e.aJ(t, i.u_matrix)
                }),
            heatmapTexture: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_world: new e.aO(t, i.u_world),
                    u_image: new e.aH(t, i.u_image),
                    u_color_ramp: new e.aH(t, i.u_color_ramp),
                    u_opacity: new e.aI(t, i.u_opacity)
                }),
            hillshade: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_image: new e.aH(t, i.u_image),
                    u_latrange: new e.aO(t, i.u_latrange),
                    u_light: new e.aO(t, i.u_light),
                    u_shadow: new e.aL(t, i.u_shadow),
                    u_highlight: new e.aL(t, i.u_highlight),
                    u_accent: new e.aL(t, i.u_accent)
                }),
            hillshadePrepare: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_image: new e.aH(t, i.u_image),
                    u_dimension: new e.aO(t, i.u_dimension),
                    u_zoom: new e.aI(t, i.u_zoom),
                    u_unpack: new e.aK(t, i.u_unpack)
                }),
            line: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_ratio: new e.aI(t, i.u_ratio),
                    u_device_pixel_ratio: new e.aI(t, i.u_device_pixel_ratio),
                    u_units_to_pixels: new e.aO(t, i.u_units_to_pixels)
                }),
            lineGradient: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_ratio: new e.aI(t, i.u_ratio),
                    u_device_pixel_ratio: new e.aI(t, i.u_device_pixel_ratio),
                    u_units_to_pixels: new e.aO(t, i.u_units_to_pixels),
                    u_image: new e.aH(t, i.u_image),
                    u_image_height: new e.aI(t, i.u_image_height)
                }),
            linePattern: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_ratio: new e.aI(t, i.u_ratio),
                    u_device_pixel_ratio: new e.aI(t, i.u_device_pixel_ratio),
                    u_image: new e.aH(t, i.u_image),
                    u_units_to_pixels: new e.aO(t, i.u_units_to_pixels),
                    u_scale: new e.aN(t, i.u_scale),
                    u_fade: new e.aI(t, i.u_fade)
                }),
            lineSDF: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_ratio: new e.aI(t, i.u_ratio),
                    u_device_pixel_ratio: new e.aI(t, i.u_device_pixel_ratio),
                    u_units_to_pixels: new e.aO(t, i.u_units_to_pixels),
                    u_patternscale_a: new e.aO(t, i.u_patternscale_a),
                    u_patternscale_b: new e.aO(t, i.u_patternscale_b),
                    u_sdfgamma: new e.aI(t, i.u_sdfgamma),
                    u_image: new e.aH(t, i.u_image),
                    u_tex_y_a: new e.aI(t, i.u_tex_y_a),
                    u_tex_y_b: new e.aI(t, i.u_tex_y_b),
                    u_mix: new e.aI(t, i.u_mix)
                }),
            raster: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_tl_parent: new e.aO(t, i.u_tl_parent),
                    u_scale_parent: new e.aI(t, i.u_scale_parent),
                    u_buffer_scale: new e.aI(t, i.u_buffer_scale),
                    u_fade_t: new e.aI(t, i.u_fade_t),
                    u_opacity: new e.aI(t, i.u_opacity),
                    u_image0: new e.aH(t, i.u_image0),
                    u_image1: new e.aH(t, i.u_image1),
                    u_brightness_low: new e.aI(t, i.u_brightness_low),
                    u_brightness_high: new e.aI(t, i.u_brightness_high),
                    u_saturation_factor: new e.aI(t, i.u_saturation_factor),
                    u_contrast_factor: new e.aI(t, i.u_contrast_factor),
                    u_spin_weights: new e.aN(t, i.u_spin_weights)
                }),
            symbolIcon: (t, i)=>({
                    u_is_size_zoom_constant: new e.aH(t, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new e.aH(t, i.u_is_size_feature_constant),
                    u_size_t: new e.aI(t, i.u_size_t),
                    u_size: new e.aI(t, i.u_size),
                    u_camera_to_center_distance: new e.aI(t, i.u_camera_to_center_distance),
                    u_pitch: new e.aI(t, i.u_pitch),
                    u_rotate_symbol: new e.aH(t, i.u_rotate_symbol),
                    u_aspect_ratio: new e.aI(t, i.u_aspect_ratio),
                    u_fade_change: new e.aI(t, i.u_fade_change),
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_label_plane_matrix: new e.aJ(t, i.u_label_plane_matrix),
                    u_coord_matrix: new e.aJ(t, i.u_coord_matrix),
                    u_is_text: new e.aH(t, i.u_is_text),
                    u_pitch_with_map: new e.aH(t, i.u_pitch_with_map),
                    u_is_along_line: new e.aH(t, i.u_is_along_line),
                    u_is_variable_anchor: new e.aH(t, i.u_is_variable_anchor),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_texture: new e.aH(t, i.u_texture),
                    u_translation: new e.aO(t, i.u_translation),
                    u_pitched_scale: new e.aI(t, i.u_pitched_scale)
                }),
            symbolSDF: (t, i)=>({
                    u_is_size_zoom_constant: new e.aH(t, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new e.aH(t, i.u_is_size_feature_constant),
                    u_size_t: new e.aI(t, i.u_size_t),
                    u_size: new e.aI(t, i.u_size),
                    u_camera_to_center_distance: new e.aI(t, i.u_camera_to_center_distance),
                    u_pitch: new e.aI(t, i.u_pitch),
                    u_rotate_symbol: new e.aH(t, i.u_rotate_symbol),
                    u_aspect_ratio: new e.aI(t, i.u_aspect_ratio),
                    u_fade_change: new e.aI(t, i.u_fade_change),
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_label_plane_matrix: new e.aJ(t, i.u_label_plane_matrix),
                    u_coord_matrix: new e.aJ(t, i.u_coord_matrix),
                    u_is_text: new e.aH(t, i.u_is_text),
                    u_pitch_with_map: new e.aH(t, i.u_pitch_with_map),
                    u_is_along_line: new e.aH(t, i.u_is_along_line),
                    u_is_variable_anchor: new e.aH(t, i.u_is_variable_anchor),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_texture: new e.aH(t, i.u_texture),
                    u_gamma_scale: new e.aI(t, i.u_gamma_scale),
                    u_device_pixel_ratio: new e.aI(t, i.u_device_pixel_ratio),
                    u_is_halo: new e.aH(t, i.u_is_halo),
                    u_translation: new e.aO(t, i.u_translation),
                    u_pitched_scale: new e.aI(t, i.u_pitched_scale)
                }),
            symbolTextAndIcon: (t, i)=>({
                    u_is_size_zoom_constant: new e.aH(t, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new e.aH(t, i.u_is_size_feature_constant),
                    u_size_t: new e.aI(t, i.u_size_t),
                    u_size: new e.aI(t, i.u_size),
                    u_camera_to_center_distance: new e.aI(t, i.u_camera_to_center_distance),
                    u_pitch: new e.aI(t, i.u_pitch),
                    u_rotate_symbol: new e.aH(t, i.u_rotate_symbol),
                    u_aspect_ratio: new e.aI(t, i.u_aspect_ratio),
                    u_fade_change: new e.aI(t, i.u_fade_change),
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_label_plane_matrix: new e.aJ(t, i.u_label_plane_matrix),
                    u_coord_matrix: new e.aJ(t, i.u_coord_matrix),
                    u_is_text: new e.aH(t, i.u_is_text),
                    u_pitch_with_map: new e.aH(t, i.u_pitch_with_map),
                    u_is_along_line: new e.aH(t, i.u_is_along_line),
                    u_is_variable_anchor: new e.aH(t, i.u_is_variable_anchor),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_texsize_icon: new e.aO(t, i.u_texsize_icon),
                    u_texture: new e.aH(t, i.u_texture),
                    u_texture_icon: new e.aH(t, i.u_texture_icon),
                    u_gamma_scale: new e.aI(t, i.u_gamma_scale),
                    u_device_pixel_ratio: new e.aI(t, i.u_device_pixel_ratio),
                    u_is_halo: new e.aH(t, i.u_is_halo),
                    u_translation: new e.aO(t, i.u_translation),
                    u_pitched_scale: new e.aI(t, i.u_pitched_scale)
                }),
            background: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_opacity: new e.aI(t, i.u_opacity),
                    u_color: new e.aL(t, i.u_color)
                }),
            backgroundPattern: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_opacity: new e.aI(t, i.u_opacity),
                    u_image: new e.aH(t, i.u_image),
                    u_pattern_tl_a: new e.aO(t, i.u_pattern_tl_a),
                    u_pattern_br_a: new e.aO(t, i.u_pattern_br_a),
                    u_pattern_tl_b: new e.aO(t, i.u_pattern_tl_b),
                    u_pattern_br_b: new e.aO(t, i.u_pattern_br_b),
                    u_texsize: new e.aO(t, i.u_texsize),
                    u_mix: new e.aI(t, i.u_mix),
                    u_pattern_size_a: new e.aO(t, i.u_pattern_size_a),
                    u_pattern_size_b: new e.aO(t, i.u_pattern_size_b),
                    u_scale_a: new e.aI(t, i.u_scale_a),
                    u_scale_b: new e.aI(t, i.u_scale_b),
                    u_pixel_coord_upper: new e.aO(t, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new e.aO(t, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new e.aI(t, i.u_tile_units_to_pixels)
                }),
            terrain: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_texture: new e.aH(t, i.u_texture),
                    u_ele_delta: new e.aI(t, i.u_ele_delta),
                    u_fog_matrix: new e.aJ(t, i.u_fog_matrix),
                    u_fog_color: new e.aL(t, i.u_fog_color),
                    u_fog_ground_blend: new e.aI(t, i.u_fog_ground_blend),
                    u_fog_ground_blend_opacity: new e.aI(t, i.u_fog_ground_blend_opacity),
                    u_horizon_color: new e.aL(t, i.u_horizon_color),
                    u_horizon_fog_blend: new e.aI(t, i.u_horizon_fog_blend)
                }),
            terrainDepth: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_ele_delta: new e.aI(t, i.u_ele_delta)
                }),
            terrainCoords: (t, i)=>({
                    u_matrix: new e.aJ(t, i.u_matrix),
                    u_texture: new e.aH(t, i.u_texture),
                    u_terrain_coords_id: new e.aI(t, i.u_terrain_coords_id),
                    u_ele_delta: new e.aI(t, i.u_ele_delta)
                }),
            sky: (t, i)=>({
                    u_sky_color: new e.aL(t, i.u_sky_color),
                    u_horizon_color: new e.aL(t, i.u_horizon_color),
                    u_horizon: new e.aI(t, i.u_horizon),
                    u_sky_horizon_blend: new e.aI(t, i.u_sky_horizon_blend)
                })
        };
        class He {
            constructor(t, e, i){
                this.context = t;
                const a = t.gl;
                this.buffer = a.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), t.bindElementBuffer.set(this.buffer), a.bufferData(a.ELEMENT_ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(t) {
                const e = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), e.bufferSubData(e.ELEMENT_ARRAY_BUFFER, 0, t.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const We = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class $e {
            constructor(t, e, i, a){
                this.length = e.length, this.attributes = i, this.itemSize = e.bytesPerElement, this.dynamicDraw = a, this.context = t;
                const s = t.gl;
                this.buffer = s.createBuffer(), t.bindVertexBuffer.set(this.buffer), s.bufferData(s.ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(t) {
                if (t.length !== this.length) throw new Error(`Length of new data is ${t.length}, which doesn't match current length of ${this.length}`);
                const e = this.context.gl;
                this.bind(), e.bufferSubData(e.ARRAY_BUFFER, 0, t.arrayBuffer);
            }
            enableAttributes(t, e) {
                for(let i = 0; i < this.attributes.length; i++){
                    const a = e.attributes[this.attributes[i].name];
                    void 0 !== a && t.enableVertexAttribArray(a);
                }
            }
            setVertexAttribPointers(t, e, i) {
                for(let a = 0; a < this.attributes.length; a++){
                    const s = this.attributes[a], o = e.attributes[s.name];
                    void 0 !== o && t.vertexAttribPointer(o, s.components, t[We[s.type]], !1, this.itemSize, s.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const Xe = new WeakMap;
        function Ke(t) {
            var e;
            if (Xe.has(t)) return Xe.get(t);
            {
                const i = null === (e = t.getParameter(t.VERSION)) || void 0 === e ? void 0 : e.startsWith("WebGL 2.0");
                return Xe.set(t, i), i;
            }
        }
        class Je {
            constructor(t){
                this.gl = t.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(t) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class Ye extends Je {
            getDefault() {
                return e.aM.transparent;
            }
            set(t) {
                const e = this.current;
                (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.clearColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }
        }
        class Qe extends Je {
            getDefault() {
                return 1;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.clearDepth(t), this.current = t, this.dirty = !1);
            }
        }
        class ti extends Je {
            getDefault() {
                return 0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.clearStencil(t), this.current = t, this.dirty = !1);
            }
        }
        class ei extends Je {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.colorMask(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }
        }
        class ii extends Je {
            getDefault() {
                return !0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.depthMask(t), this.current = t, this.dirty = !1);
            }
        }
        class ai extends Je {
            getDefault() {
                return 255;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.stencilMask(t), this.current = t, this.dirty = !1);
            }
        }
        class si extends Je {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(t) {
                const e = this.current;
                (t.func !== e.func || t.ref !== e.ref || t.mask !== e.mask || this.dirty) && (this.gl.stencilFunc(t.func, t.ref, t.mask), this.current = t, this.dirty = !1);
            }
        }
        class oi extends Je {
            getDefault() {
                const t = this.gl;
                return [
                    t.KEEP,
                    t.KEEP,
                    t.KEEP
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || this.dirty) && (this.gl.stencilOp(t[0], t[1], t[2]), this.current = t, this.dirty = !1);
            }
        }
        class ri extends Je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.STENCIL_TEST) : e.disable(e.STENCIL_TEST), this.current = t, this.dirty = !1;
            }
        }
        class ni extends Je {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.depthRange(t[0], t[1]), this.current = t, this.dirty = !1);
            }
        }
        class li extends Je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.DEPTH_TEST) : e.disable(e.DEPTH_TEST), this.current = t, this.dirty = !1;
            }
        }
        class hi extends Je {
            getDefault() {
                return this.gl.LESS;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.depthFunc(t), this.current = t, this.dirty = !1);
            }
        }
        class ci extends Je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.BLEND) : e.disable(e.BLEND), this.current = t, this.dirty = !1;
            }
        }
        class ui extends Je {
            getDefault() {
                const t = this.gl;
                return [
                    t.ONE,
                    t.ZERO
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.blendFunc(t[0], t[1]), this.current = t, this.dirty = !1);
            }
        }
        class di extends Je {
            getDefault() {
                return e.aM.transparent;
            }
            set(t) {
                const e = this.current;
                (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.blendColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }
        }
        class _i extends Je {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.blendEquation(t), this.current = t, this.dirty = !1);
            }
        }
        class pi extends Je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.CULL_FACE) : e.disable(e.CULL_FACE), this.current = t, this.dirty = !1;
            }
        }
        class mi extends Je {
            getDefault() {
                return this.gl.BACK;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.cullFace(t), this.current = t, this.dirty = !1);
            }
        }
        class fi extends Je {
            getDefault() {
                return this.gl.CCW;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.frontFace(t), this.current = t, this.dirty = !1);
            }
        }
        class gi extends Je {
            getDefault() {
                return null;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.useProgram(t), this.current = t, this.dirty = !1);
            }
        }
        class vi extends Je {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.activeTexture(t), this.current = t, this.dirty = !1);
            }
        }
        class xi extends Je {
            getDefault() {
                const t = this.gl;
                return [
                    0,
                    0,
                    t.drawingBufferWidth,
                    t.drawingBufferHeight
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.viewport(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }
        }
        class yi extends Je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindFramebuffer(e.FRAMEBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class bi extends Je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindRenderbuffer(e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class wi extends Je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindTexture(e.TEXTURE_2D, t), this.current = t, this.dirty = !1;
            }
        }
        class Ti extends Je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindBuffer(e.ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ii extends Je {
            getDefault() {
                return null;
            }
            set(t) {
                const e = this.gl;
                e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ei extends Je {
            getDefault() {
                return null;
            }
            set(t) {
                var e;
                if (t === this.current && !this.dirty) return;
                const i = this.gl;
                Ke(i) ? i.bindVertexArray(t) : null === (e = i.getExtension("OES_vertex_array_object")) || void 0 === e || e.bindVertexArrayOES(t), this.current = t, this.dirty = !1;
            }
        }
        class Pi extends Je {
            getDefault() {
                return 4;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_ALIGNMENT, t), this.current = t, this.dirty = !1;
            }
        }
        class Ci extends Je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t), this.current = t, this.dirty = !1;
            }
        }
        class Si extends Je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, t), this.current = t, this.dirty = !1;
            }
        }
        class zi extends Je {
            constructor(t, e){
                super(t), this.context = t, this.parent = e;
            }
            getDefault() {
                return null;
            }
        }
        class Di extends zi {
            setDirty() {
                this.dirty = !0;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0), this.current = t, this.dirty = !1;
            }
        }
        class Mi extends zi {
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ai extends zi {
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ri {
            constructor(t, e, i, a, s){
                this.context = t, this.width = e, this.height = i;
                const o = t.gl, r = this.framebuffer = o.createFramebuffer();
                if (this.colorAttachment = new Di(t, r), a) this.depthAttachment = s ? new Ai(t, r) : new Mi(t, r);
                else if (s) throw new Error("Stencil cannot be set without depth");
                if (o.checkFramebufferStatus(o.FRAMEBUFFER) !== o.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
            }
            destroy() {
                const t = this.context.gl, e = this.colorAttachment.get();
                if (e && t.deleteTexture(e), this.depthAttachment) {
                    const e = this.depthAttachment.get();
                    e && t.deleteRenderbuffer(e);
                }
                t.deleteFramebuffer(this.framebuffer);
            }
        }
        class ki {
            constructor(t, e, i){
                this.blendFunction = t, this.blendColor = e, this.mask = i;
            }
        }
        ki.Replace = [
            1,
            0
        ], ki.disabled = new ki(ki.Replace, e.aM.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), ki.unblended = new ki(ki.Replace, e.aM.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ki.alphaBlended = new ki([
            1,
            771
        ], e.aM.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Li {
            constructor(t){
                var e, i;
                if (this.gl = t, this.clearColor = new Ye(this), this.clearDepth = new Qe(this), this.clearStencil = new ti(this), this.colorMask = new ei(this), this.depthMask = new ii(this), this.stencilMask = new ai(this), this.stencilFunc = new si(this), this.stencilOp = new oi(this), this.stencilTest = new ri(this), this.depthRange = new ni(this), this.depthTest = new li(this), this.depthFunc = new hi(this), this.blend = new ci(this), this.blendFunc = new ui(this), this.blendColor = new di(this), this.blendEquation = new _i(this), this.cullFace = new pi(this), this.cullFaceSide = new mi(this), this.frontFace = new fi(this), this.program = new gi(this), this.activeTexture = new vi(this), this.viewport = new xi(this), this.bindFramebuffer = new yi(this), this.bindRenderbuffer = new bi(this), this.bindTexture = new wi(this), this.bindVertexBuffer = new Ti(this), this.bindElementBuffer = new Ii(this), this.bindVertexArray = new Ei(this), this.pixelStoreUnpack = new Pi(this), this.pixelStoreUnpackPremultiplyAlpha = new Ci(this), this.pixelStoreUnpackFlipY = new Si(this), this.extTextureFilterAnisotropic = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = t.getParameter(t.MAX_TEXTURE_SIZE), Ke(t)) {
                    this.HALF_FLOAT = t.HALF_FLOAT;
                    const a = t.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (e = t.RGBA16F) && void 0 !== e ? e : null == a ? void 0 : a.RGBA16F_EXT, this.RGB16F = null !== (i = t.RGB16F) && void 0 !== i ? i : null == a ? void 0 : a.RGB16F_EXT, t.getExtension("EXT_color_buffer_float");
                } else {
                    t.getExtension("EXT_color_buffer_half_float"), t.getExtension("OES_texture_half_float_linear");
                    const e = t.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == e ? void 0 : e.HALF_FLOAT_OES;
                }
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(t, e) {
                return new He(this, t, e);
            }
            createVertexBuffer(t, e, i) {
                return new $e(this, t, e, i);
            }
            createRenderbuffer(t, e, i) {
                const a = this.gl, s = a.createRenderbuffer();
                return this.bindRenderbuffer.set(s), a.renderbufferStorage(a.RENDERBUFFER, t, e, i), this.bindRenderbuffer.set(null), s;
            }
            createFramebuffer(t, e, i, a) {
                return new Ri(this, t, e, i, a);
            }
            clear({ color: t, depth: e, stencil: i }) {
                const a = this.gl;
                let s = 0;
                t && (s |= a.COLOR_BUFFER_BIT, this.clearColor.set(t), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== e && (s |= a.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(e), this.depthMask.set(!0)), void 0 !== i && (s |= a.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), a.clear(s);
            }
            setCullFace(t) {
                !1 === t.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t.mode), this.frontFace.set(t.frontFace));
            }
            setDepthMode(t) {
                t.func !== this.gl.ALWAYS || t.mask ? (this.depthTest.set(!0), this.depthFunc.set(t.func), this.depthMask.set(t.mask), this.depthRange.set(t.range)) : this.depthTest.set(!1);
            }
            setStencilMode(t) {
                t.test.func !== this.gl.ALWAYS || t.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t.mask), this.stencilOp.set([
                    t.fail,
                    t.depthFail,
                    t.pass
                ]), this.stencilFunc.set({
                    func: t.test.func,
                    ref: t.ref,
                    mask: t.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t) {
                e.aE(t.blendFunction, ki.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t.blendFunction), this.blendColor.set(t.blendColor)), this.colorMask.set(t.mask);
            }
            createVertexArray() {
                var t;
                return Ke(this.gl) ? this.gl.createVertexArray() : null === (t = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t ? void 0 : t.createVertexArrayOES();
            }
            deleteVertexArray(t) {
                var e;
                return Ke(this.gl) ? this.gl.deleteVertexArray(t) : null === (e = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e ? void 0 : e.deleteVertexArrayOES(t);
            }
            unbindVAO() {
                this.bindVertexArray.set(null);
            }
        }
        class Fi {
            constructor(t, e, i){
                this.func = t, this.mask = e, this.range = i;
            }
        }
        Fi.ReadOnly = !1, Fi.ReadWrite = !0, Fi.disabled = new Fi(519, Fi.ReadOnly, [
            0,
            1
        ]);
        const Bi = 7680;
        class Oi {
            constructor(t, e, i, a, s, o){
                this.test = t, this.ref = e, this.mask = i, this.fail = a, this.depthFail = s, this.pass = o;
            }
        }
        Oi.disabled = new Oi({
            func: 519,
            mask: 0
        }, 0, 0, Bi, Bi, Bi);
        class Ni {
            constructor(t, e, i){
                this.enable = t, this.mode = e, this.frontFace = i;
            }
        }
        let ji;
        function Ui(t, i, a, s, o) {
            const r = t.context, n = r.gl, l = t.useProgram("collisionBox"), h = [];
            let c = 0, u = 0;
            for(let _ = 0; _ < s.length; _++){
                const p = s[_], m = i.getTile(p).getBucket(a);
                if (!m) continue;
                const f = o ? m.textCollisionBox : m.iconCollisionBox, g = m.collisionCircleArray;
                if (g.length > 0) {
                    const i = e.H();
                    e.aQ(i, m.placementInvProjMatrix, t.transform.glCoordMatrix), e.aQ(i, i, m.placementViewportMatrix), h.push({
                        circleArray: g,
                        circleOffset: u,
                        transform: p.posMatrix,
                        invTransform: i,
                        coord: p
                    }), c += g.length / 4, u = c;
                }
                f && l.draw(r, n.LINES, Fi.disabled, Oi.disabled, t.colorModeForRenderPass(), Ni.disabled, {
                    u_matrix: p.posMatrix,
                    u_pixel_extrude_scale: [
                        1 / (d = t.transform).width,
                        1 / d.height
                    ]
                }, t.style.map.terrain && t.style.map.terrain.getTerrainData(p), a.id, f.layoutVertexBuffer, f.indexBuffer, f.segments, null, t.transform.zoom, null, null, f.collisionVertexBuffer);
            }
            var d;
            if (!o || !h.length) return;
            const _ = t.useProgram("collisionCircle"), p = new e.aR;
            p.resize(4 * c), p._trim();
            let m = 0;
            for (const t of h)for(let e = 0; e < t.circleArray.length / 4; e++){
                const i = 4 * e, a = t.circleArray[i + 0], s = t.circleArray[i + 1], o = t.circleArray[i + 2], r = t.circleArray[i + 3];
                p.emplace(m++, a, s, o, r, 0), p.emplace(m++, a, s, o, r, 1), p.emplace(m++, a, s, o, r, 2), p.emplace(m++, a, s, o, r, 3);
            }
            (!ji || ji.length < 2 * c) && (ji = function(t) {
                const i = 2 * t, a = new e.aT;
                a.resize(i), a._trim();
                for(let t = 0; t < i; t++){
                    const e = 6 * t;
                    a.uint16[e + 0] = 4 * t + 0, a.uint16[e + 1] = 4 * t + 1, a.uint16[e + 2] = 4 * t + 2, a.uint16[e + 3] = 4 * t + 2, a.uint16[e + 4] = 4 * t + 3, a.uint16[e + 5] = 4 * t + 0;
                }
                return a;
            }(c));
            const f = r.createIndexBuffer(ji, !0), g = r.createVertexBuffer(p, e.aS.members, !0);
            for (const i of h){
                const s = Ce(i.transform, i.invTransform, t.transform);
                _.draw(r, n.TRIANGLES, Fi.disabled, Oi.disabled, t.colorModeForRenderPass(), Ni.disabled, s, t.style.map.terrain && t.style.map.terrain.getTerrainData(i.coord), a.id, g, f, e.a0.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, t.transform.zoom, null, null, null);
            }
            g.destroy(), f.destroy();
        }
        Ni.disabled = new Ni(!1, 1029, 2305), Ni.backCCW = new Ni(!0, 1029, 2305);
        const Zi = e.an(new Float32Array(16));
        function qi(t, i, a, s, o, r) {
            const { horizontalAlign: n, verticalAlign: l } = e.au(t);
            return new e.P((-(n - .5) * i / o + s[0]) * r, (-(l - .5) * a / o + s[1]) * r);
        }
        function Vi(t, i, a, s, o, r) {
            const n = i.tileAnchorPoint.add(new e.P(i.translation[0], i.translation[1]));
            if (i.pitchWithMap) {
                let t = s.mult(r);
                return a || (t = t.rotate(-o)), xt(n.add(t), i.labelPlaneMatrix, i.getElevation).point;
            }
            if (a) {
                const e = St(i.tileAnchorPoint.x + 1, i.tileAnchorPoint.y, i).point.sub(t), a = Math.atan(e.y / e.x) + (e.x < 0 ? Math.PI : 0);
                return t.add(s.rotate(a));
            }
            return t.add(s);
        }
        function Gi(t, i, a, s, o, r, n, l, h, c, u, d, _, p) {
            const m = t.text.placedSymbolArray, f = t.text.dynamicLayoutVertexArray, g = t.icon.dynamicLayoutVertexArray, v = {};
            f.clear();
            for(let g = 0; g < m.length; g++){
                const x = m.get(g), y = x.hidden || !x.crossTileID || t.allowVerticalPlacement && !x.placedOrientation ? null : s[x.crossTileID];
                if (y) {
                    const s = new e.P(x.anchorX, x.anchorY), m = {
                        getElevation: p,
                        width: o.width,
                        height: o.height,
                        labelPlaneMatrix: r,
                        lineVertexArray: null,
                        pitchWithMap: a,
                        projection: u,
                        projectionCache: null,
                        tileAnchorPoint: s,
                        translation: d,
                        unwrappedTileID: _
                    }, g = a ? xt(s, n, p) : St(s.x, s.y, m), b = yt(o.cameraToCenterDistance, g.signedDistanceFromCamera);
                    let w = e.ai(t.textSizeData, h, x) * b / e.ap;
                    a && (w *= t.tilePixelRatio / l);
                    const { width: T, height: I, anchor: E, textOffset: P, textBoxScale: C } = y, S = qi(E, T, I, P, C, w), z = u.getPitchedTextCorrection(o, s.add(new e.P(d[0], d[1])), _), D = Vi(g.point, m, i, S, o.angle, z), M = t.allowVerticalPlacement && x.placedOrientation === e.ah.vertical ? Math.PI / 2 : 0;
                    for(let t = 0; t < x.numGlyphs; t++)e.aj(f, D, M);
                    c && x.associatedIconIndex >= 0 && (v[x.associatedIconIndex] = {
                        shiftedAnchor: D,
                        angle: M
                    });
                } else Rt(x.numGlyphs, f);
            }
            if (c) {
                g.clear();
                const i = t.icon.placedSymbolArray;
                for(let t = 0; t < i.length; t++){
                    const a = i.get(t);
                    if (a.hidden) Rt(a.numGlyphs, g);
                    else {
                        const i = v[t];
                        if (i) for(let t = 0; t < a.numGlyphs; t++)e.aj(g, i.shiftedAnchor, i.angle);
                        else Rt(a.numGlyphs, g);
                    }
                }
                t.icon.dynamicLayoutVertexBuffer.updateData(g);
            }
            t.text.dynamicLayoutVertexBuffer.updateData(f);
        }
        function Hi(t, e, i) {
            return i.iconsInText && e ? "symbolTextAndIcon" : t ? "symbolSDF" : "symbolIcon";
        }
        function Wi(t, i, a, s, o, r, n, l, h, c, u, d) {
            const _ = t.context, p = _.gl, m = t.transform, f = ee(), g = "map" === l, v = "map" === h, x = "viewport" !== l && "point" !== a.layout.get("symbol-placement"), y = g && !v && !x, b = !v && x, w = !a.layout.get("symbol-sort-key").isConstant();
            let T = !1;
            const I = t.depthModeForSublayer(0, Fi.ReadOnly), E = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), P = [], C = f.getCircleRadiusCorrection(m);
            for (const l of s){
                const s = i.getTile(l), h = s.getBucket(a);
                if (!h) continue;
                const u = o ? h.text : h.icon;
                if (!u || !u.segments.get().length || !u.hasVisibleVertices) continue;
                const d = u.programConfigurations.get(a.id), _ = o || h.sdfIcons, I = o ? h.textSizeData : h.iconSizeData, S = v || 0 !== m.pitch, z = t.useProgram(Hi(_, o, h), d), D = e.ag(I, m.zoom), M = t.style.map.terrain && t.style.map.terrain.getTerrainData(l);
                let A, R, k, L, F = [
                    0,
                    0
                ], B = null;
                if (o) R = s.glyphAtlasTexture, k = p.LINEAR, A = s.glyphAtlasTexture.size, h.iconsInText && (F = s.imageAtlasTexture.size, B = s.imageAtlasTexture, L = S || t.options.rotating || t.options.zooming || "composite" === I.kind || "camera" === I.kind ? p.LINEAR : p.NEAREST);
                else {
                    const e = 1 !== a.layout.get("icon-size").constantOr(0) || h.iconsNeedLinear;
                    R = s.imageAtlasTexture, k = _ || t.options.rotating || t.options.zooming || e || S ? p.LINEAR : p.NEAREST, A = s.imageAtlasTexture.size;
                }
                const O = Ft(s, 1, t.transform.zoom), N = b ? l.posMatrix : Zi, j = gt(N, v, g, t.transform, O), U = vt(N, v, g, t.transform, O), Z = vt(l.posMatrix, v, g, t.transform, O), q = f.translatePosition(t.transform, s, r, n), V = E && h.hasTextData(), G = "none" !== a.layout.get("icon-text-fit") && V && h.hasIconData();
                if (x) {
                    const e = t.style.map.terrain ? (e, i)=>t.style.map.terrain.getElevation(l, e, i) : null, i = "map" === a.layout.get("text-rotation-alignment");
                    wt(h, l.posMatrix, t, o, j, Z, v, c, i, f, l.toUnwrapped(), m.width, m.height, q, e);
                }
                const H = l.posMatrix, W = o && E || G, $ = x || W ? Zi : j, X = U, K = _ && 0 !== a.paint.get(o ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let J;
                J = _ ? h.iconsInText ? Ze(I.kind, D, y, v, x, W, t, H, $, X, q, A, F, C) : Ue(I.kind, D, y, v, x, W, t, H, $, X, q, o, A, !0, C) : je(I.kind, D, y, v, x, W, t, H, $, X, q, o, A, C);
                const Y = {
                    program: z,
                    buffers: u,
                    uniformValues: J,
                    atlasTexture: R,
                    atlasTextureIcon: B,
                    atlasInterpolation: k,
                    atlasInterpolationIcon: L,
                    isSDF: _,
                    hasHalo: K
                };
                if (w && h.canOverlap) {
                    T = !0;
                    const t = u.segments.get();
                    for (const i of t)P.push({
                        segments: new e.a0([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: Y,
                        terrainData: M
                    });
                } else P.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: Y,
                    terrainData: M
                });
            }
            T && P.sort((t, e)=>t.sortKey - e.sortKey);
            for (const e of P){
                const i = e.state;
                if (_.activeTexture.set(p.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, p.CLAMP_TO_EDGE), i.atlasTextureIcon && (_.activeTexture.set(p.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, p.CLAMP_TO_EDGE)), i.isSDF) {
                    const s = i.uniformValues;
                    i.hasHalo && (s.u_is_halo = 1, $i(i.buffers, e.segments, a, t, i.program, I, u, d, s, e.terrainData)), s.u_is_halo = 0;
                }
                $i(i.buffers, e.segments, a, t, i.program, I, u, d, i.uniformValues, e.terrainData);
            }
        }
        function $i(t, e, i, a, s, o, r, n, l, h) {
            const c = a.context;
            s.draw(c, c.gl.TRIANGLES, o, r, n, Ni.disabled, l, h, i.id, t.layoutVertexBuffer, t.indexBuffer, e, i.paint, a.transform.zoom, t.programConfigurations.get(i.id), t.dynamicLayoutVertexBuffer, t.opacityVertexBuffer);
        }
        function Xi(t, e, i, a, s) {
            if (!i || !a || !a.imageAtlas) return;
            const o = a.imageAtlas.patternPositions;
            let r = o[i.to.toString()], n = o[i.from.toString()];
            if (!r && n && (r = n), !n && r && (n = r), !r || !n) {
                const t = s.getPaintProperty(e);
                r = o[t], n = o[t];
            }
            r && n && t.setConstantPatternPositions(r, n);
        }
        function Ki(t, e, i, a, s, o, r) {
            const n = t.context.gl, l = "fill-pattern", h = i.paint.get(l), c = h && h.constantOr(1), u = i.getCrossfadeParameters();
            let d, _, p, m, f;
            r ? (_ = c && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", d = n.LINES) : (_ = c ? "fillPattern" : "fill", d = n.TRIANGLES);
            const g = h.constantOr(null);
            for (const h of a){
                const a = e.getTile(h);
                if (c && !a.patternsLoaded()) continue;
                const v = a.getBucket(i);
                if (!v) continue;
                const x = v.programConfigurations.get(i.id), y = t.useProgram(_, x), b = t.style.map.terrain && t.style.map.terrain.getTerrainData(h);
                c && (t.context.activeTexture.set(n.TEXTURE0), a.imageAtlasTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), x.updatePaintBuffers(u)), Xi(x, l, g, a, i);
                const w = b ? h : null, T = t.translatePosMatrix(w ? w.posMatrix : h.posMatrix, a, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                if (r) {
                    m = v.indexBuffer2, f = v.segments2;
                    const e = [
                        n.drawingBufferWidth,
                        n.drawingBufferHeight
                    ];
                    p = "fillOutlinePattern" === _ && c ? Ee(T, t, u, a, e) : Ie(T, e);
                } else m = v.indexBuffer, f = v.segments, p = c ? Te(T, t, u, a) : we(T);
                y.draw(t.context, d, s, t.stencilModeForClipping(h), o, Ni.disabled, p, b, i.id, v.layoutVertexBuffer, m, f, i.paint, t.transform.zoom, x);
            }
        }
        function Ji(t, e, i, a, s, o, r) {
            const n = t.context, l = n.gl, h = "fill-extrusion-pattern", c = i.paint.get(h), u = c.constantOr(1), d = i.getCrossfadeParameters(), _ = i.paint.get("fill-extrusion-opacity"), p = c.constantOr(null);
            for (const c of a){
                const a = e.getTile(c), m = a.getBucket(i);
                if (!m) continue;
                const f = t.style.map.terrain && t.style.map.terrain.getTerrainData(c), g = m.programConfigurations.get(i.id), v = t.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", g);
                u && (t.context.activeTexture.set(l.TEXTURE0), a.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), g.updatePaintBuffers(d)), Xi(g, h, p, a, i);
                const x = t.translatePosMatrix(c.posMatrix, a, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), y = i.paint.get("fill-extrusion-vertical-gradient"), b = u ? be(x, t, y, _, c, d, a) : ye(x, t, y, _);
                v.draw(n, n.gl.TRIANGLES, s, o, r, Ni.backCCW, b, f, i.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, i.paint, t.transform.zoom, g, t.style.map.terrain && m.centroidVertexBuffer);
            }
        }
        function Yi(t, e, i, a, s, o, r) {
            const n = t.context, l = n.gl, h = i.fbo;
            if (!h) return;
            const c = t.useProgram("hillshade"), u = t.style.map.terrain && t.style.map.terrain.getTerrainData(e);
            n.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, h.colorAttachment.get()), c.draw(n, l.TRIANGLES, s, o, r, Ni.disabled, ((t, e, i, a)=>{
                const s = i.paint.get("hillshade-shadow-color"), o = i.paint.get("hillshade-highlight-color"), r = i.paint.get("hillshade-accent-color");
                let n = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === i.paint.get("hillshade-illumination-anchor") && (n -= t.transform.angle);
                const l = !t.options.moving;
                return {
                    u_matrix: a ? a.posMatrix : t.transform.calculatePosMatrix(e.tileID.toUnwrapped(), l),
                    u_image: 0,
                    u_latrange: Me(0, e.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        n
                    ],
                    u_shadow: s,
                    u_highlight: o,
                    u_accent: r
                };
            })(t, i, a, u ? e : null), u, a.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
        }
        function Qi(t, i, a, s, o, r) {
            const n = t.context, l = n.gl, h = i.dem;
            if (h && h.data) {
                const c = h.dim, u = h.stride, d = h.getPixels();
                if (n.activeTexture.set(l.TEXTURE1), n.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t.getTileTexture(u), i.demTexture) {
                    const t = i.demTexture;
                    t.update(d, {
                        premultiply: !1
                    }), t.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                } else i.demTexture = new b(n, d, l.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                n.activeTexture.set(l.TEXTURE0);
                let _ = i.fbo;
                if (!_) {
                    const t = new b(n, {
                        width: c,
                        height: c,
                        data: null
                    }, l.RGBA);
                    t.bind(l.LINEAR, l.CLAMP_TO_EDGE), _ = i.fbo = n.createFramebuffer(c, c, !0, !1), _.colorAttachment.set(t.texture);
                }
                n.bindFramebuffer.set(_.framebuffer), n.viewport.set([
                    0,
                    0,
                    c,
                    c
                ]), t.useProgram("hillshadePrepare").draw(n, l.TRIANGLES, s, o, r, Ni.disabled, ((t, i)=>{
                    const a = i.stride, s = e.H();
                    return e.aP(s, 0, e.X, -e.X, 0, 0, 1), e.J(s, s, [
                        0,
                        -e.X,
                        0
                    ]), {
                        u_matrix: s,
                        u_image: 1,
                        u_dimension: [
                            a,
                            a
                        ],
                        u_zoom: t.overscaledZ,
                        u_unpack: i.getUnpackVector()
                    };
                })(i.tileID, h), null, a.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        }
        function ta(t, i, a, s, r, n) {
            const l = s.paint.get("raster-fade-duration");
            if (!n && l > 0) {
                const s = o.now(), n = (s - t.timeAdded) / l, h = i ? (s - i.timeAdded) / l : -1, c = a.getSource(), u = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), d = !i || Math.abs(i.tileID.overscaledZ - u) > Math.abs(t.tileID.overscaledZ - u), _ = d && t.refreshedUponExpiration ? 1 : e.ac(d ? n : 1 - h, 0, 1);
                return t.refreshedUponExpiration && n >= 1 && (t.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - _
                } : {
                    opacity: _,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        const ea = new e.aM(1, 0, 0, 1), ia = new e.aM(0, 1, 0, 1), aa = new e.aM(0, 0, 1, 1), sa = new e.aM(1, 0, 1, 1), oa = new e.aM(0, 1, 1, 1);
        function ra(t, e, i, a) {
            la(t, 0, e + i / 2, t.transform.width, i, a);
        }
        function na(t, e, i, a) {
            la(t, e - i / 2, 0, i, t.transform.height, a);
        }
        function la(t, e, i, a, s, o) {
            const r = t.context, n = r.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(e * t.pixelRatio, i * t.pixelRatio, a * t.pixelRatio, s * t.pixelRatio), r.clear({
                color: o
            }), n.disable(n.SCISSOR_TEST);
        }
        function ha(t, i, a) {
            const s = t.context, o = s.gl, r = a.posMatrix, n = t.useProgram("debug"), l = Fi.disabled, h = Oi.disabled, c = t.colorModeForRenderPass(), u = "$debug", d = t.style.map.terrain && t.style.map.terrain.getTerrainData(a);
            s.activeTexture.set(o.TEXTURE0);
            const _ = i.getTileByID(a.key).latestRawTileData, p = Math.floor((_ && _.byteLength || 0) / 1024), m = i.getTile(a).tileSize, f = 512 / Math.min(m, 512) * (a.overscaledZ / t.transform.zoom) * .5;
            let g = a.canonical.toString();
            a.overscaledZ !== a.canonical.z && (g += ` => ${a.overscaledZ}`), function(t, e) {
                t.initDebugOverlayCanvas();
                const i = t.debugOverlayCanvas, a = t.context.gl, s = t.debugOverlayCanvas.getContext("2d");
                s.clearRect(0, 0, i.width, i.height), s.shadowColor = "white", s.shadowBlur = 2, s.lineWidth = 1.5, s.strokeStyle = "white", s.textBaseline = "top", s.font = "bold 36px Open Sans, sans-serif", s.fillText(e, 5, 5), s.strokeText(e, 5, 5), t.debugOverlayTexture.update(i), t.debugOverlayTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
            }(t, `${g} ${p}kB`), n.draw(s, o.TRIANGLES, l, h, ki.alphaBlended, Ni.disabled, Se(r, e.aM.transparent, f), null, u, t.debugBuffer, t.quadTriangleIndexBuffer, t.debugSegments), n.draw(s, o.LINE_STRIP, l, h, c, Ni.disabled, Se(r, e.aM.red), d, u, t.debugBuffer, t.tileBorderIndexBuffer, t.debugSegments);
        }
        function ca(t, e, i) {
            const a = t.context, s = a.gl, o = t.colorModeForRenderPass(), r = new Fi(s.LEQUAL, Fi.ReadWrite, t.depthRangeFor3D), n = t.useProgram("terrain"), l = e.getTerrainMesh();
            a.bindFramebuffer.set(null), a.viewport.set([
                0,
                0,
                t.width,
                t.height
            ]);
            for (const h of i){
                const i = t.renderToTexture.getTexture(h), c = e.getTerrainData(h.tileID);
                a.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, i.texture);
                const u = t.transform.calculatePosMatrix(h.tileID.toUnwrapped()), d = e.getMeshFrameDelta(t.transform.zoom), _ = t.transform.calculateFogMatrix(h.tileID.toUnwrapped()), p = fe(u, d, _, t.style.sky, t.transform.pitch);
                n.draw(a, s.TRIANGLES, r, Oi.disabled, o, Ni.backCCW, p, c, "terrain", l.vertexBuffer, l.indexBuffer, l.segments);
            }
        }
        class ua {
            constructor(t, e, i){
                this.vertexBuffer = t, this.indexBuffer = e, this.segments = i;
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
            }
        }
        class da {
            constructor(t, i){
                this.context = new Li(t), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: e.an(new Float64Array(16)),
                    renderTime: 0
                }, this.setup(), this.numSublayers = ut.maxUnderzooming + ut.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new le;
            }
            resize(t, e, i) {
                if (this.width = Math.floor(t * i), this.height = Math.floor(e * i), this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const t of this.style._order)this.style._layers[t].resize();
            }
            setup() {
                const t = this.context, i = new e.aW;
                i.emplaceBack(0, 0), i.emplaceBack(e.X, 0), i.emplaceBack(0, e.X), i.emplaceBack(e.X, e.X), this.tileExtentBuffer = t.createVertexBuffer(i, de.members), this.tileExtentSegments = e.a0.simpleSegment(0, 0, 4, 2);
                const a = new e.aW;
                a.emplaceBack(0, 0), a.emplaceBack(e.X, 0), a.emplaceBack(0, e.X), a.emplaceBack(e.X, e.X), this.debugBuffer = t.createVertexBuffer(a, de.members), this.debugSegments = e.a0.simpleSegment(0, 0, 4, 5);
                const s = new e.$;
                s.emplaceBack(0, 0, 0, 0), s.emplaceBack(e.X, 0, e.X, 0), s.emplaceBack(0, e.X, 0, e.X), s.emplaceBack(e.X, e.X, e.X, e.X), this.rasterBoundsBuffer = t.createVertexBuffer(s, Y.members), this.rasterBoundsSegments = e.a0.simpleSegment(0, 0, 4, 2);
                const o = new e.aW;
                o.emplaceBack(0, 0), o.emplaceBack(1, 0), o.emplaceBack(0, 1), o.emplaceBack(1, 1), this.viewportBuffer = t.createVertexBuffer(o, de.members), this.viewportSegments = e.a0.simpleSegment(0, 0, 4, 2);
                const r = new e.aY;
                r.emplaceBack(0), r.emplaceBack(1), r.emplaceBack(3), r.emplaceBack(2), r.emplaceBack(0), this.tileBorderIndexBuffer = t.createIndexBuffer(r);
                const n = new e.aX;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t.createIndexBuffer(n);
                const l = this.context.gl;
                this.stencilClearMode = new Oi({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
            }
            clearStencil() {
                const t = this.context, i = t.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const a = e.H();
                e.aP(a, 0, this.width, this.height, 0, 0, 1), e.K(a, a, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]), this.useProgram("clippingMask").draw(t, i.TRIANGLES, Fi.disabled, this.stencilClearMode, ki.disabled, Ni.disabled, ze(a), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(t, e) {
                if (this.currentStencilSource === t.source || !t.isTileClipped() || !e || !e.length) return;
                this.currentStencilSource = t.source;
                const i = this.context, a = i.gl;
                this.nextStencilID + e.length > 256 && this.clearStencil(), i.setColorMode(ki.disabled), i.setDepthMode(Fi.disabled);
                const s = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t of e){
                    const e = this._tileClippingMaskIDs[t.key] = this.nextStencilID++, o = this.style.map.terrain && this.style.map.terrain.getTerrainData(t);
                    s.draw(i, a.TRIANGLES, Fi.disabled, new Oi({
                        func: a.ALWAYS,
                        mask: 0
                    }, e, 255, a.KEEP, a.KEEP, a.REPLACE), ki.disabled, Ni.disabled, ze(t.posMatrix), o, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t = this.nextStencilID++, e = this.context.gl;
                return new Oi({
                    func: e.NOTEQUAL,
                    mask: 255
                }, t, 255, e.KEEP, e.KEEP, e.REPLACE);
            }
            stencilModeForClipping(t) {
                const e = this.context.gl;
                return new Oi({
                    func: e.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t.key], 0, e.KEEP, e.KEEP, e.REPLACE);
            }
            stencilConfigForOverlap(t) {
                const e = this.context.gl, i = t.sort((t, e)=>e.overscaledZ - t.overscaledZ), a = i[i.length - 1].overscaledZ, s = i[0].overscaledZ - a + 1;
                if (s > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + s > 256 && this.clearStencil();
                    const t = {};
                    for(let i = 0; i < s; i++)t[i + a] = new Oi({
                        func: e.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, e.KEEP, e.KEEP, e.REPLACE);
                    return this.nextStencilID += s, [
                        t,
                        i
                    ];
                }
                return [
                    {
                        [a]: Oi.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const t = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new ki([
                        t.CONSTANT_COLOR,
                        t.ONE
                    ], new e.aM(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? ki.unblended : ki.alphaBlended;
            }
            depthModeForSublayer(t, e, i) {
                if (!this.opaquePassEnabledForLayer()) return Fi.disabled;
                const a = 1 - ((1 + this.currentLayer) * this.numSublayers + t) * this.depthEpsilon;
                return new Fi(i || this.context.gl.LEQUAL, e, [
                    a,
                    a
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(t, i) {
                this.style = t, this.options = i, this.lineAtlas = t.lineAtlas, this.imageManager = t.imageManager, this.glyphManager = t.glyphManager, this.symbolFadeChange = t.placement.symbolFadeChange(o.now()), this.imageManager.beginFrame();
                const a = this.style._order, s = this.style.sourceCaches, r = {}, n = {}, l = {};
                for(const t in s){
                    const e = s[t];
                    e.used && e.prepare(this.context), r[t] = e.getVisibleCoordinates(), n[t] = r[t].slice().reverse(), l[t] = e.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let t = 0; t < a.length; t++)if (this.style._layers[a[t]].is3D()) {
                    this.opaquePassCutoff = t;
                    break;
                }
                this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                for (const t of a){
                    const e = this.style._layers[t];
                    if (!e.hasOffscreenPass() || e.isHidden(this.transform.zoom)) continue;
                    const i = n[e.source];
                    ("custom" === e.type || i.length) && this.renderLayer(this, s[e.source], e, i);
                }
                if (this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? e.aM.black : e.aM.transparent,
                    depth: 1
                }), this.clearStencil(), this.style.sky && function(t, i) {
                    const a = t.context, s = a.gl, o = ((t, e, i)=>({
                            u_sky_color: t.properties.get("sky-color"),
                            u_horizon_color: t.properties.get("horizon-color"),
                            u_horizon: (e.height / 2 + e.getHorizon()) * i,
                            u_sky_horizon_blend: t.properties.get("sky-horizon-blend") * e.height / 2 * i
                        }))(i, t.style.map.transform, t.pixelRatio), r = new Fi(s.LEQUAL, Fi.ReadWrite, [
                        0,
                        1
                    ]), n = Oi.disabled, l = t.colorModeForRenderPass(), h = t.useProgram("sky");
                    if (!i.mesh) {
                        const t = new e.aW;
                        t.emplaceBack(-1, -1), t.emplaceBack(1, -1), t.emplaceBack(1, 1), t.emplaceBack(-1, 1);
                        const s = new e.aX;
                        s.emplaceBack(0, 1, 2), s.emplaceBack(0, 2, 3), i.mesh = new ua(a.createVertexBuffer(t, de.members), a.createIndexBuffer(s), e.a0.simpleSegment(0, 0, t.length, s.length));
                    }
                    h.draw(a, s.TRIANGLES, r, n, l, Ni.disabled, o, void 0, "sky", i.mesh.vertexBuffer, i.mesh.indexBuffer, i.mesh.segments);
                }(this, this.style.sky), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (t._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = a.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const t = this.style._layers[a[this.currentLayer]], e = s[t.source], i = r[t.source];
                    this._renderTileClippingMasks(t, i), this.renderLayer(this, e, t, i);
                }
                for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < a.length; this.currentLayer++){
                    const t = this.style._layers[a[this.currentLayer]], e = s[t.source];
                    if (this.renderToTexture && this.renderToTexture.renderLayer(t)) continue;
                    const i = ("symbol" === t.type ? l : n)[t.source];
                    this._renderTileClippingMasks(t, r[t.source]), this.renderLayer(this, e, t, i);
                }
                if (this.options.showTileBoundaries) {
                    const t = function(t, e) {
                        let i = null;
                        const a = Object.values(t._layers).flatMap((i)=>i.source && !i.isHidden(e) ? [
                                t.sourceCaches[i.source]
                            ] : []), s = a.filter((t)=>"vector" === t.getSource().type), o = a.filter((t)=>"vector" !== t.getSource().type), r = (t)=>{
                            (!i || i.getSource().maxzoom < t.getSource().maxzoom) && (i = t);
                        };
                        return s.forEach((t)=>r(t)), i || o.forEach((t)=>r(t)), i;
                    }(this.style, this.transform.zoom);
                    t && function(t, e, i) {
                        for(let a = 0; a < i.length; a++)ha(t, e, i[a]);
                    }(this, t, t.getVisibleCoordinates());
                }
                this.options.showPadding && function(t) {
                    const e = t.transform.padding;
                    ra(t, t.transform.height - (e.top || 0), 3, ea), ra(t, e.bottom || 0, 3, ia), na(t, e.left || 0, 3, aa), na(t, t.transform.width - (e.right || 0), 3, sa);
                    const i = t.transform.centerPoint;
                    !function(t, e, i, a) {
                        la(t, e - 1, i - 10, 2, 20, a), la(t, e - 10, i - 1, 20, 2, a);
                    }(t, i.x, t.transform.height - i.y, oa);
                }(this), this.context.setDefault();
            }
            maybeDrawDepthAndCoords(t) {
                if (!this.style || !this.style.map || !this.style.map.terrain) return;
                const i = this.terrainFacilitator.matrix, a = this.transform.modelViewProjectionMatrix;
                let s = this.terrainFacilitator.dirty;
                s || (s = t ? !e.aZ(i, a) : !e.a_(i, a)), s || (s = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime).length > 0), s && (e.a$(i, a), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(t, i) {
                    const a = t.context, s = a.gl, o = ki.unblended, r = new Fi(s.LEQUAL, Fi.ReadWrite, [
                        0,
                        1
                    ]), n = i.getTerrainMesh(), l = i.sourceCache.getRenderableTiles(), h = t.useProgram("terrainDepth");
                    a.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), a.viewport.set([
                        0,
                        0,
                        t.width / devicePixelRatio,
                        t.height / devicePixelRatio
                    ]), a.clear({
                        color: e.aM.transparent,
                        depth: 1
                    });
                    for (const e of l){
                        const l = i.getTerrainData(e.tileID), c = {
                            u_matrix: t.transform.calculatePosMatrix(e.tileID.toUnwrapped()),
                            u_ele_delta: i.getMeshFrameDelta(t.transform.zoom)
                        };
                        h.draw(a, s.TRIANGLES, r, Oi.disabled, o, Ni.backCCW, c, l, "terrain", n.vertexBuffer, n.indexBuffer, n.segments);
                    }
                    a.bindFramebuffer.set(null), a.viewport.set([
                        0,
                        0,
                        t.width,
                        t.height
                    ]);
                }(this, this.style.map.terrain), function(t, i) {
                    const a = t.context, s = a.gl, o = ki.unblended, r = new Fi(s.LEQUAL, Fi.ReadWrite, [
                        0,
                        1
                    ]), n = i.getTerrainMesh(), l = i.getCoordsTexture(), h = i.sourceCache.getRenderableTiles(), c = t.useProgram("terrainCoords");
                    a.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), a.viewport.set([
                        0,
                        0,
                        t.width / devicePixelRatio,
                        t.height / devicePixelRatio
                    ]), a.clear({
                        color: e.aM.transparent,
                        depth: 1
                    }), i.coordsIndex = [];
                    for (const e of h){
                        const h = i.getTerrainData(e.tileID);
                        a.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, l.texture);
                        const u = {
                            u_matrix: t.transform.calculatePosMatrix(e.tileID.toUnwrapped()),
                            u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                            u_texture: 0,
                            u_ele_delta: i.getMeshFrameDelta(t.transform.zoom)
                        };
                        c.draw(a, s.TRIANGLES, r, Oi.disabled, o, Ni.backCCW, u, h, "terrain", n.vertexBuffer, n.indexBuffer, n.segments), i.coordsIndex.push(e.tileID.key);
                    }
                    a.bindFramebuffer.set(null), a.viewport.set([
                        0,
                        0,
                        t.width,
                        t.height
                    ]);
                }(this, this.style.map.terrain));
            }
            renderLayer(t, i, a, s) {
                if (!a.isHidden(this.transform.zoom) && ("background" === a.type || "custom" === a.type || (s || []).length)) switch(this.id = a.id, a.type){
                    case "symbol":
                        !function(t, i, a, s, o) {
                            if ("translucent" !== t.renderPass) return;
                            const r = Oi.disabled, n = t.colorModeForRenderPass();
                            (a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(t, i, a, s, o, r, n, l, h) {
                                const c = i.transform, u = ee(), d = "map" === o, _ = "map" === r;
                                for (const o of t){
                                    const t = s.getTile(o), r = t.getBucket(a);
                                    if (!r || !r.text || !r.text.segments.get().length) continue;
                                    const p = e.ag(r.textSizeData, c.zoom), m = Ft(t, 1, i.transform.zoom), f = gt(o.posMatrix, _, d, i.transform, m), g = "none" !== a.layout.get("icon-text-fit") && r.hasIconData();
                                    if (p) {
                                        const e = Math.pow(2, c.zoom - t.tileID.overscaledZ), a = i.style.map.terrain ? (t, e)=>i.style.map.terrain.getElevation(o, t, e) : null, s = u.translatePosition(c, t, n, l);
                                        Gi(r, d, _, h, c, f, o.posMatrix, e, p, g, u, s, o.toUnwrapped(), a);
                                    }
                                }
                            }(s, t, a, i, a.layout.get("text-rotation-alignment"), a.layout.get("text-pitch-alignment"), a.paint.get("text-translate"), a.paint.get("text-translate-anchor"), o), 0 !== a.paint.get("icon-opacity").constantOr(1) && Wi(t, i, a, s, !1, a.paint.get("icon-translate"), a.paint.get("icon-translate-anchor"), a.layout.get("icon-rotation-alignment"), a.layout.get("icon-pitch-alignment"), a.layout.get("icon-keep-upright"), r, n), 0 !== a.paint.get("text-opacity").constantOr(1) && Wi(t, i, a, s, !0, a.paint.get("text-translate"), a.paint.get("text-translate-anchor"), a.layout.get("text-rotation-alignment"), a.layout.get("text-pitch-alignment"), a.layout.get("text-keep-upright"), r, n), i.map.showCollisionBoxes && (Ui(t, i, a, s, !0), Ui(t, i, a, s, !1));
                        }(t, i, a, s, this.style.placement.variableOffsets);
                        break;
                    case "circle":
                        !function(t, i, a, s) {
                            if ("translucent" !== t.renderPass) return;
                            const o = a.paint.get("circle-opacity"), r = a.paint.get("circle-stroke-width"), n = a.paint.get("circle-stroke-opacity"), l = !a.layout.get("circle-sort-key").isConstant();
                            if (0 === o.constantOr(1) && (0 === r.constantOr(1) || 0 === n.constantOr(1))) return;
                            const h = t.context, c = h.gl, u = t.depthModeForSublayer(0, Fi.ReadOnly), d = Oi.disabled, _ = t.colorModeForRenderPass(), p = [];
                            for(let o = 0; o < s.length; o++){
                                const r = s[o], n = i.getTile(r), h = n.getBucket(a);
                                if (!h) continue;
                                const c = h.programConfigurations.get(a.id), u = t.useProgram("circle", c), d = h.layoutVertexBuffer, _ = h.indexBuffer, m = t.style.map.terrain && t.style.map.terrain.getTerrainData(r), f = {
                                    programConfiguration: c,
                                    program: u,
                                    layoutVertexBuffer: d,
                                    indexBuffer: _,
                                    uniformValues: Pe(t, r, n, a),
                                    terrainData: m
                                };
                                if (l) {
                                    const t = h.segments.get();
                                    for (const i of t)p.push({
                                        segments: new e.a0([
                                            i
                                        ]),
                                        sortKey: i.sortKey,
                                        state: f
                                    });
                                } else p.push({
                                    segments: h.segments,
                                    sortKey: 0,
                                    state: f
                                });
                            }
                            l && p.sort((t, e)=>t.sortKey - e.sortKey);
                            for (const e of p){
                                const { programConfiguration: i, program: s, layoutVertexBuffer: o, indexBuffer: r, uniformValues: n, terrainData: l } = e.state;
                                s.draw(h, c.TRIANGLES, u, d, _, Ni.disabled, n, l, a.id, o, r, e.segments, a.paint, t.transform.zoom, i);
                            }
                        }(t, i, a, s);
                        break;
                    case "heatmap":
                        !function(t, i, a, s) {
                            if (0 !== a.paint.get("heatmap-opacity")) {
                                if ("offscreen" === t.renderPass) {
                                    const o = t.context, r = o.gl, n = Oi.disabled, l = new ki([
                                        r.ONE,
                                        r.ONE
                                    ], e.aM.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    !function(t, e, i) {
                                        const a = t.gl;
                                        t.activeTexture.set(a.TEXTURE1), t.viewport.set([
                                            0,
                                            0,
                                            e.width / 4,
                                            e.height / 4
                                        ]);
                                        let s = i.heatmapFbo;
                                        if (s) a.bindTexture(a.TEXTURE_2D, s.colorAttachment.get()), t.bindFramebuffer.set(s.framebuffer);
                                        else {
                                            const o = a.createTexture();
                                            a.bindTexture(a.TEXTURE_2D, o), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.LINEAR), s = i.heatmapFbo = t.createFramebuffer(e.width / 4, e.height / 4, !1, !1), function(t, e, i, a) {
                                                var s, o;
                                                const r = t.gl, n = null !== (s = t.HALF_FLOAT) && void 0 !== s ? s : r.UNSIGNED_BYTE, l = null !== (o = t.RGBA16F) && void 0 !== o ? o : r.RGBA;
                                                r.texImage2D(r.TEXTURE_2D, 0, l, e.width / 4, e.height / 4, 0, r.RGBA, n, null), a.colorAttachment.set(i);
                                            }(t, e, o, s);
                                        }
                                    }(o, t, a), o.clear({
                                        color: e.aM.transparent
                                    });
                                    for(let e = 0; e < s.length; e++){
                                        const h = s[e];
                                        if (i.hasRenderableParent(h)) continue;
                                        const c = i.getTile(h), u = c.getBucket(a);
                                        if (!u) continue;
                                        const d = u.programConfigurations.get(a.id), _ = t.useProgram("heatmap", d), { zoom: p } = t.transform;
                                        _.draw(o, r.TRIANGLES, Fi.disabled, n, l, Ni.disabled, De(h.posMatrix, c, p, a.paint.get("heatmap-intensity")), null, a.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, a.paint, t.transform.zoom, d);
                                    }
                                    o.viewport.set([
                                        0,
                                        0,
                                        t.width,
                                        t.height
                                    ]);
                                } else "translucent" === t.renderPass && (t.context.setColorMode(t.colorModeForRenderPass()), function(t, i) {
                                    const a = t.context, s = a.gl, o = i.heatmapFbo;
                                    if (!o) return;
                                    a.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, o.colorAttachment.get()), a.activeTexture.set(s.TEXTURE1);
                                    let r = i.colorRampTexture;
                                    r || (r = i.colorRampTexture = new b(a, i.colorRamp, s.RGBA)), r.bind(s.LINEAR, s.CLAMP_TO_EDGE), t.useProgram("heatmapTexture").draw(a, s.TRIANGLES, Fi.disabled, Oi.disabled, t.colorModeForRenderPass(), Ni.disabled, ((t, i, a, s)=>{
                                        const o = e.H();
                                        e.aP(o, 0, t.width, t.height, 0, 0, 1);
                                        const r = t.context.gl;
                                        return {
                                            u_matrix: o,
                                            u_world: [
                                                r.drawingBufferWidth,
                                                r.drawingBufferHeight
                                            ],
                                            u_image: 0,
                                            u_color_ramp: 1,
                                            u_opacity: i.paint.get("heatmap-opacity")
                                        };
                                    })(t, i), null, i.id, t.viewportBuffer, t.quadTriangleIndexBuffer, t.viewportSegments, i.paint, t.transform.zoom);
                                }(t, a));
                            }
                        }(t, i, a, s);
                        break;
                    case "line":
                        !function(t, i, a, s) {
                            if ("translucent" !== t.renderPass) return;
                            const o = a.paint.get("line-opacity"), r = a.paint.get("line-width");
                            if (0 === o.constantOr(1) || 0 === r.constantOr(1)) return;
                            const n = t.depthModeForSublayer(0, Fi.ReadOnly), l = t.colorModeForRenderPass(), h = a.paint.get("line-dasharray"), c = a.paint.get("line-pattern"), u = c.constantOr(1), d = a.paint.get("line-gradient"), _ = a.getCrossfadeParameters(), p = u ? "linePattern" : h ? "lineSDF" : d ? "lineGradient" : "line", m = t.context, f = m.gl;
                            let g = !0;
                            for (const o of s){
                                const s = i.getTile(o);
                                if (u && !s.patternsLoaded()) continue;
                                const r = s.getBucket(a);
                                if (!r) continue;
                                const v = r.programConfigurations.get(a.id), x = t.context.program.get(), y = t.useProgram(p, v), w = g || y.program !== x, T = t.style.map.terrain && t.style.map.terrain.getTerrainData(o), I = c.constantOr(null);
                                if (I && s.imageAtlas) {
                                    const t = s.imageAtlas, e = t.patternPositions[I.to.toString()], i = t.patternPositions[I.from.toString()];
                                    e && i && v.setConstantPatternPositions(e, i);
                                }
                                const E = T ? o : null, P = u ? ke(t, s, a, _, E) : h ? Le(t, s, a, h, _, E) : d ? Re(t, s, a, r.lineClipsArray.length, E) : Ae(t, s, a, E);
                                if (u) m.activeTexture.set(f.TEXTURE0), s.imageAtlasTexture.bind(f.LINEAR, f.CLAMP_TO_EDGE), v.updatePaintBuffers(_);
                                else if (h && (w || t.lineAtlas.dirty)) m.activeTexture.set(f.TEXTURE0), t.lineAtlas.bind(m);
                                else if (d) {
                                    const s = r.gradients[a.id];
                                    let n = s.texture;
                                    if (a.gradientVersion !== s.version) {
                                        let l = 256;
                                        if (a.stepInterpolant) {
                                            const a = i.getSource().maxzoom, s = o.canonical.z === a ? Math.ceil(1 << t.transform.maxZoom - o.canonical.z) : 1;
                                            l = e.ac(e.aU(r.maxLineLength / e.X * 1024 * s), 256, m.maxTextureSize);
                                        }
                                        s.gradient = e.aV({
                                            expression: a.gradientExpression(),
                                            evaluationKey: "lineProgress",
                                            resolution: l,
                                            image: s.gradient || void 0,
                                            clips: r.lineClipsArray
                                        }), s.texture ? s.texture.update(s.gradient) : s.texture = new b(m, s.gradient, f.RGBA), s.version = a.gradientVersion, n = s.texture;
                                    }
                                    m.activeTexture.set(f.TEXTURE0), n.bind(a.stepInterpolant ? f.NEAREST : f.LINEAR, f.CLAMP_TO_EDGE);
                                }
                                y.draw(m, f.TRIANGLES, n, t.stencilModeForClipping(o), l, Ni.disabled, P, T, a.id, r.layoutVertexBuffer, r.indexBuffer, r.segments, a.paint, t.transform.zoom, v, r.layoutVertexBuffer2), g = !1;
                            }
                        }(t, i, a, s);
                        break;
                    case "fill":
                        !function(t, i, a, s) {
                            const o = a.paint.get("fill-color"), r = a.paint.get("fill-opacity");
                            if (0 === r.constantOr(1)) return;
                            const n = t.colorModeForRenderPass(), l = a.paint.get("fill-pattern"), h = t.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === o.constantOr(e.aM.transparent).a && 1 === r.constantOr(0) ? "opaque" : "translucent";
                            if (t.renderPass === h) {
                                const e = t.depthModeForSublayer(1, "opaque" === t.renderPass ? Fi.ReadWrite : Fi.ReadOnly);
                                Ki(t, i, a, s, e, n, !1);
                            }
                            if ("translucent" === t.renderPass && a.paint.get("fill-antialias")) {
                                const e = t.depthModeForSublayer(a.getPaintProperty("fill-outline-color") ? 2 : 0, Fi.ReadOnly);
                                Ki(t, i, a, s, e, n, !0);
                            }
                        }(t, i, a, s);
                        break;
                    case "fill-extrusion":
                        !function(t, e, i, a) {
                            const s = i.paint.get("fill-extrusion-opacity");
                            if (0 !== s && "translucent" === t.renderPass) {
                                const o = new Fi(t.context.gl.LEQUAL, Fi.ReadWrite, t.depthRangeFor3D);
                                if (1 !== s || i.paint.get("fill-extrusion-pattern").constantOr(1)) Ji(t, e, i, a, o, Oi.disabled, ki.disabled), Ji(t, e, i, a, o, t.stencilModeFor3D(), t.colorModeForRenderPass());
                                else {
                                    const s = t.colorModeForRenderPass();
                                    Ji(t, e, i, a, o, Oi.disabled, s);
                                }
                            }
                        }(t, i, a, s);
                        break;
                    case "hillshade":
                        !function(t, e, i, a) {
                            if ("offscreen" !== t.renderPass && "translucent" !== t.renderPass) return;
                            const s = t.context, o = t.depthModeForSublayer(0, Fi.ReadOnly), r = t.colorModeForRenderPass(), [n, l] = "translucent" === t.renderPass ? t.stencilConfigForOverlap(a) : [
                                {},
                                a
                            ];
                            for (const a of l){
                                const s = e.getTile(a);
                                void 0 !== s.needsHillshadePrepare && s.needsHillshadePrepare && "offscreen" === t.renderPass ? Qi(t, s, i, o, Oi.disabled, r) : "translucent" === t.renderPass && Yi(t, a, s, i, o, n[a.overscaledZ], r);
                            }
                            s.viewport.set([
                                0,
                                0,
                                t.width,
                                t.height
                            ]);
                        }(t, i, a, s);
                        break;
                    case "raster":
                        !function(t, e, i, a) {
                            if ("translucent" !== t.renderPass) return;
                            if (0 === i.paint.get("raster-opacity")) return;
                            if (!a.length) return;
                            const s = t.context, o = s.gl, r = e.getSource(), n = t.useProgram("raster"), l = t.colorModeForRenderPass(), [h, c] = r instanceof Q ? [
                                {},
                                a
                            ] : t.stencilConfigForOverlap(a), u = c[c.length - 1].overscaledZ, d = !t.options.moving;
                            for (const a of c){
                                const c = t.depthModeForSublayer(a.overscaledZ - u, 1 === i.paint.get("raster-opacity") ? Fi.ReadWrite : Fi.ReadOnly, o.LESS), _ = e.getTile(a);
                                _.registerFadeDuration(i.paint.get("raster-fade-duration"));
                                const p = e.findLoadedParent(a, 0), m = e.findLoadedSibling(a), f = ta(_, p || m || null, e, i, t.transform, t.style.map.terrain);
                                let g, v;
                                const x = "nearest" === i.paint.get("raster-resampling") ? o.NEAREST : o.LINEAR;
                                s.activeTexture.set(o.TEXTURE0), _.texture.bind(x, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), s.activeTexture.set(o.TEXTURE1), p ? (p.texture.bind(x, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), g = Math.pow(2, p.tileID.overscaledZ - _.tileID.overscaledZ), v = [
                                    _.tileID.canonical.x * g % 1,
                                    _.tileID.canonical.y * g % 1
                                ]) : _.texture.bind(x, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), _.texture.useMipmap && s.extTextureFilterAnisotropic && t.transform.pitch > 20 && o.texParameterf(o.TEXTURE_2D, s.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, s.extTextureFilterAnisotropicMax);
                                const y = t.style.map.terrain && t.style.map.terrain.getTerrainData(a), b = y ? a : null, w = b ? b.posMatrix : t.transform.calculatePosMatrix(a.toUnwrapped(), d), T = Oe(w, v || [
                                    0,
                                    0
                                ], g || 1, f, i);
                                r instanceof Q ? n.draw(s, o.TRIANGLES, c, Oi.disabled, l, Ni.disabled, T, y, i.id, r.boundsBuffer, t.quadTriangleIndexBuffer, r.boundsSegments) : n.draw(s, o.TRIANGLES, c, h[a.overscaledZ], l, Ni.disabled, T, y, i.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
                            }
                        }(t, i, a, s);
                        break;
                    case "background":
                        !function(t, e, i, a) {
                            const s = i.paint.get("background-color"), o = i.paint.get("background-opacity");
                            if (0 === o) return;
                            const r = t.context, n = r.gl, l = t.transform, h = l.tileSize, c = i.paint.get("background-pattern");
                            if (t.isPatternMissing(c)) return;
                            const u = !c && 1 === s.a && 1 === o && t.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                            if (t.renderPass !== u) return;
                            const d = Oi.disabled, _ = t.depthModeForSublayer(0, "opaque" === u ? Fi.ReadWrite : Fi.ReadOnly), p = t.colorModeForRenderPass(), m = t.useProgram(c ? "backgroundPattern" : "background"), f = a || l.coveringTiles({
                                tileSize: h,
                                terrain: t.style.map.terrain
                            });
                            c && (r.activeTexture.set(n.TEXTURE0), t.imageManager.bind(t.context));
                            const g = i.getCrossfadeParameters();
                            for (const e of f){
                                const l = a ? e.posMatrix : t.transform.calculatePosMatrix(e.toUnwrapped()), u = c ? Ve(l, o, t, c, {
                                    tileID: e,
                                    tileSize: h
                                }, g) : qe(l, o, s), f = t.style.map.terrain && t.style.map.terrain.getTerrainData(e);
                                m.draw(r, n.TRIANGLES, _, d, p, Ni.disabled, u, f, i.id, t.tileExtentBuffer, t.quadTriangleIndexBuffer, t.tileExtentSegments);
                            }
                        }(t, 0, a, s);
                        break;
                    case "custom":
                        !function(t, e, i) {
                            const a = t.context, s = i.implementation;
                            if ("offscreen" === t.renderPass) {
                                const e = s.prerender;
                                e && (t.setCustomLayerDefaults(), a.setColorMode(t.colorModeForRenderPass()), e.call(s, a.gl, t.transform.customLayerMatrix()), a.setDirty(), t.setBaseState());
                            } else if ("translucent" === t.renderPass) {
                                t.setCustomLayerDefaults(), a.setColorMode(t.colorModeForRenderPass()), a.setStencilMode(Oi.disabled);
                                const e = "3d" === s.renderingMode ? new Fi(t.context.gl.LEQUAL, Fi.ReadWrite, t.depthRangeFor3D) : t.depthModeForSublayer(0, Fi.ReadOnly);
                                a.setDepthMode(e), s.render(a.gl, t.transform.customLayerMatrix(), {
                                    farZ: t.transform.farZ,
                                    nearZ: t.transform.nearZ,
                                    fov: t.transform._fov,
                                    modelViewProjectionMatrix: t.transform.modelViewProjectionMatrix,
                                    projectionMatrix: t.transform.projectionMatrix
                                }), a.setDirty(), t.setBaseState(), a.bindFramebuffer.set(null);
                            }
                        }(t, 0, a);
                }
            }
            translatePosMatrix(t, i, a, s, o) {
                if (!a[0] && !a[1]) return t;
                const r = o ? "map" === s ? this.transform.angle : 0 : "viewport" === s ? -this.transform.angle : 0;
                if (r) {
                    const t = Math.sin(r), e = Math.cos(r);
                    a = [
                        a[0] * e - a[1] * t,
                        a[0] * t + a[1] * e
                    ];
                }
                const n = [
                    o ? a[0] : Ft(i, a[0], this.transform.zoom),
                    o ? a[1] : Ft(i, a[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e.J(l, t, n), l;
            }
            saveTileTexture(t) {
                const e = this._tileTextures[t.size[0]];
                e ? e.push(t) : this._tileTextures[t.size[0]] = [
                    t
                ];
            }
            getTileTexture(t) {
                const e = this._tileTextures[t];
                return e && e.length > 0 ? e.pop() : null;
            }
            isPatternMissing(t) {
                if (!t) return !1;
                if (!t.from || !t.to) return !0;
                const e = this.imageManager.getPattern(t.from.toString()), i = this.imageManager.getPattern(t.to.toString());
                return !e || !i;
            }
            useProgram(t, e) {
                this.cache = this.cache || {};
                const i = t + (e ? e.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.map.terrain ? "/terrain" : "");
                return this.cache[i] || (this.cache[i] = new ve(this.context, _e[t], e, Ge[t], this._showOverdrawInspector, this.style.map.terrain)), this.cache[i];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const t = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(t.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new b(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this.debugOverlayTexture && this.debugOverlayTexture.destroy();
            }
            overLimit() {
                const { drawingBufferWidth: t, drawingBufferHeight: e } = this.context.gl;
                return this.width !== t || this.height !== e;
            }
        }
        class _a {
            constructor(t, e){
                this.points = t, this.planes = e;
            }
            static fromInvProjectionMatrix(t, i, a) {
                const s = Math.pow(2, a), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((a)=>{
                    const o = 1 / (a = e.af([], a, t))[3] / i * s;
                    return e.b0(a, a, [
                        o,
                        o,
                        1 / a[3],
                        o
                    ]);
                }), r = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t)=>{
                    const e = function(t, e) {
                        var i = e[0], a = e[1], s = e[2], o = i * i + a * a + s * s;
                        return o > 0 && (o = 1 / Math.sqrt(o)), t[0] = e[0] * o, t[1] = e[1] * o, t[2] = e[2] * o, t;
                    }([], function(t, e, i) {
                        var a = e[0], s = e[1], o = e[2], r = i[0], n = i[1], l = i[2];
                        return t[0] = s * l - o * n, t[1] = o * r - a * l, t[2] = a * n - s * r, t;
                    }([], g([], o[t[0]], o[t[1]]), g([], o[t[2]], o[t[1]]))), i = -((a = e)[0] * (s = o[t[1]])[0] + a[1] * s[1] + a[2] * s[2]);
                    var a, s;
                    return e.concat(i);
                });
                return new _a(o, r);
            }
        }
        class pa {
            constructor(t, e){
                this.min = t, this.max = e, this.center = function(t, e, i) {
                    return t[0] = .5 * e[0], t[1] = .5 * e[1], t[2] = .5 * e[2], t;
                }([], function(t, e, i) {
                    return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t;
                }([], this.min, this.max));
            }
            quadrant(t) {
                const e = [
                    t % 2 == 0,
                    t < 2
                ], i = m(this.min), a = m(this.max);
                for(let t = 0; t < e.length; t++)i[t] = e[t] ? this.min[t] : this.center[t], a[t] = e[t] ? this.center[t] : this.max[t];
                return a[2] = this.max[2], new pa(i, a);
            }
            distanceX(t) {
                return Math.max(Math.min(this.max[0], t[0]), this.min[0]) - t[0];
            }
            distanceY(t) {
                return Math.max(Math.min(this.max[1], t[1]), this.min[1]) - t[1];
            }
            intersects(t) {
                const i = [
                    [
                        this.min[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.max[2],
                        1
                    ]
                ];
                let a = !0;
                for(let s = 0; s < t.planes.length; s++){
                    const o = t.planes[s];
                    let r = 0;
                    for(let t = 0; t < i.length; t++)e.b1(o, i[t]) >= 0 && r++;
                    if (0 === r) return 0;
                    r !== i.length && (a = !1);
                }
                if (a) return 2;
                for(let e = 0; e < 3; e++){
                    let i = Number.MAX_VALUE, a = -Number.MAX_VALUE;
                    for(let s = 0; s < t.points.length; s++){
                        const o = t.points[s][e] - this.min[e];
                        i = Math.min(i, o), a = Math.max(a, o);
                    }
                    if (a < 0 || i > this.max[e] - this.min[e]) return 0;
                }
                return 1;
            }
        }
        class ma {
            constructor(t = 0, e = 0, i = 0, a = 0){
                if (isNaN(t) || t < 0 || isNaN(e) || e < 0 || isNaN(i) || i < 0 || isNaN(a) || a < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = t, this.bottom = e, this.left = i, this.right = a;
            }
            interpolate(t, i, a) {
                return null != i.top && null != t.top && (this.top = e.y.number(t.top, i.top, a)), null != i.bottom && null != t.bottom && (this.bottom = e.y.number(t.bottom, i.bottom, a)), null != i.left && null != t.left && (this.left = e.y.number(t.left, i.left, a)), null != i.right && null != t.right && (this.right = e.y.number(t.right, i.right, a)), this;
            }
            getCenter(t, i) {
                const a = e.ac((this.left + t - this.right) / 2, 0, t), s = e.ac((this.top + i - this.bottom) / 2, 0, i);
                return new e.P(a, s);
            }
            equals(t) {
                return this.top === t.top && this.bottom === t.bottom && this.left === t.left && this.right === t.right;
            }
            clone() {
                return new ma(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        const fa = 85.051129;
        class ga {
            constructor(t, i, a, s, o){
                this.tileSize = 512, this._renderWorldCopies = void 0 === o || !!o, this._minZoom = t || 0, this._maxZoom = i || 22, this._minPitch = null == a ? 0 : a, this._maxPitch = null == s ? 60 : s, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new e.N(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new ma, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._fogMatrixCache = {}, this.minElevationForCurrentTile = 0;
            }
            clone() {
                const t = new ga(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                return t.apply(this), t;
            }
            apply(t) {
                this.tileSize = t.tileSize, this.latRange = t.latRange, this.width = t.width, this.height = t.height, this._center = t._center, this._elevation = t._elevation, this.minElevationForCurrentTile = t.minElevationForCurrentTile, this.zoom = t.zoom, this.angle = t.angle, this._fov = t._fov, this._pitch = t._pitch, this._unmodified = t._unmodified, this._edgeInsets = t._edgeInsets.clone(), this._calcMatrices();
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(t) {
                this._minZoom !== t && (this._minZoom = t, this.zoom = Math.max(this.zoom, t));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(t) {
                this._maxZoom !== t && (this._maxZoom = t, this.zoom = Math.min(this.zoom, t));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(t) {
                this._minPitch !== t && (this._minPitch = t, this.pitch = Math.max(this.pitch, t));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(t) {
                this._maxPitch !== t && (this._maxPitch = t, this.pitch = Math.min(this.pitch, t));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            set renderWorldCopies(t) {
                void 0 === t ? t = !0 : null === t && (t = !1), this._renderWorldCopies = t;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e.P(this.width, this.height);
            }
            get bearing() {
                return -this.angle / Math.PI * 180;
            }
            set bearing(t) {
                const i = -e.b2(t, -180, 180) * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = function() {
                    var t = new e.A(4);
                    return e.A != Float32Array && (t[1] = 0, t[2] = 0), t[0] = 1, t[3] = 1, t;
                }(), function(t, e, i) {
                    var a = e[0], s = e[1], o = e[2], r = e[3], n = Math.sin(i), l = Math.cos(i);
                    t[0] = a * l + o * n, t[1] = s * l + r * n, t[2] = a * -n + o * l, t[3] = s * -n + r * l;
                }(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t) {
                const i = e.ac(t, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t) {
                t = Math.max(.01, Math.min(60, t)), this._fov !== t && (this._unmodified = !1, this._fov = t / 180 * Math.PI, this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(t) {
                const e = Math.min(Math.max(t, this.minZoom), this.maxZoom);
                this._zoom !== e && (this._unmodified = !1, this._zoom = e, this.tileZoom = Math.max(0, Math.floor(e)), this.scale = this.zoomScale(e), this._constrain(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            set center(t) {
                t.lat === this._center.lat && t.lng === this._center.lng || (this._unmodified = !1, this._center = t, this._constrain(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(t) {
                t !== this._elevation && (this._elevation = t, this._constrain(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(t) {
                this._edgeInsets.equals(t) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            isPaddingEqual(t) {
                return this._edgeInsets.equals(t);
            }
            interpolatePadding(t, e, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(t, e, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(t) {
                const e = (t.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t.tileSize));
                return Math.max(0, e);
            }
            getVisibleUnwrappedCoordinates(t) {
                const i = [
                    new e.b3(0, t)
                ];
                if (this._renderWorldCopies) {
                    const a = this.pointCoordinate(new e.P(0, 0)), s = this.pointCoordinate(new e.P(this.width, 0)), o = this.pointCoordinate(new e.P(this.width, this.height)), r = this.pointCoordinate(new e.P(0, this.height)), n = Math.floor(Math.min(a.x, s.x, o.x, r.x)), l = Math.floor(Math.max(a.x, s.x, o.x, r.x)), h = 1;
                    for(let a = n - h; a <= l + h; a++)0 !== a && i.push(new e.b3(a, t));
                }
                return i;
            }
            coveringTiles(t) {
                var i, a;
                let s = this.coveringZoomLevel(t);
                const o = s;
                if (void 0 !== t.minzoom && s < t.minzoom) return [];
                void 0 !== t.maxzoom && s > t.maxzoom && (s = t.maxzoom);
                const r = this.pointCoordinate(this.getCameraPoint()), n = e.Z.fromLngLat(this.center), l = Math.pow(2, s), h = [
                    l * r.x,
                    l * r.y,
                    0
                ], c = [
                    l * n.x,
                    l * n.y,
                    0
                ], u = _a.fromInvProjectionMatrix(this.invModelViewProjectionMatrix, this.worldSize, s);
                let d = t.minzoom || 0;
                !t.terrain && this.pitch <= 60 && this._edgeInsets.top < .1 && (d = s);
                const _ = t.terrain ? 2 / Math.min(this.tileSize, t.tileSize) * this.tileSize : 3, p = (t)=>({
                        aabb: new pa([
                            t * l,
                            0,
                            0
                        ], [
                            (t + 1) * l,
                            l,
                            0
                        ]),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        wrap: t,
                        fullyVisible: !1
                    }), m = [], f = [], g = s, x = t.reparseOverscaled ? o : s;
                if (this._renderWorldCopies) for(let t = 1; t <= 3; t++)m.push(p(-t)), m.push(p(t));
                for(m.push(p(0)); m.length > 0;){
                    const s = m.pop(), o = s.x, r = s.y;
                    let n = s.fullyVisible;
                    if (!n) {
                        const t = s.aabb.intersects(u);
                        if (0 === t) continue;
                        n = 2 === t;
                    }
                    const l = t.terrain ? h : c, p = s.aabb.distanceX(l), y = s.aabb.distanceY(l), b = Math.max(Math.abs(p), Math.abs(y));
                    if (s.zoom === g || b > _ + (1 << g - s.zoom) - 2 && s.zoom >= d) {
                        const t = g - s.zoom, i = h[0] - .5 - (o << t), a = h[1] - .5 - (r << t);
                        f.push({
                            tileID: new e.S(s.zoom === g ? x : s.zoom, s.wrap, s.zoom, o, r),
                            distanceSq: v([
                                c[0] - .5 - o,
                                c[1] - .5 - r
                            ]),
                            tileDistanceToCamera: Math.sqrt(i * i + a * a)
                        });
                    } else for(let l = 0; l < 4; l++){
                        const h = (o << 1) + l % 2, c = (r << 1) + (l >> 1), u = s.zoom + 1;
                        let d = s.aabb.quadrant(l);
                        if (t.terrain) {
                            const o = new e.S(u, s.wrap, u, h, c), r = t.terrain.getMinMaxElevation(o), n = null !== (i = r.minElevation) && void 0 !== i ? i : this.elevation, l = null !== (a = r.maxElevation) && void 0 !== a ? a : this.elevation;
                            d = new pa([
                                d.min[0],
                                d.min[1],
                                n
                            ], [
                                d.max[0],
                                d.max[1],
                                l
                            ]);
                        }
                        m.push({
                            aabb: d,
                            zoom: u,
                            x: h,
                            y: c,
                            wrap: s.wrap,
                            fullyVisible: n
                        });
                    }
                }
                return f.sort((t, e)=>t.distanceSq - e.distanceSq).map((t)=>t.tileID);
            }
            resize(t, e) {
                this.width = t, this.height = e, this.pixelsToGLUnits = [
                    2 / t,
                    -2 / e
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(t) {
                return Math.pow(2, t);
            }
            scaleZoom(t) {
                return Math.log(t) / Math.LN2;
            }
            project(t) {
                const i = e.ac(t.lat, -85.051129, fa);
                return new e.P(e.O(t.lng) * this.worldSize, e.Q(i) * this.worldSize);
            }
            unproject(t) {
                return new e.Z(t.x / this.worldSize, t.y / this.worldSize).toLngLat();
            }
            get point() {
                return this.project(this.center);
            }
            getCameraPosition() {
                return {
                    lngLat: this.pointLocation(this.getCameraPoint()),
                    altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation
                };
            }
            recalculateZoom(t) {
                const i = this.elevation, a = Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter, s = this.pointLocation(this.centerPoint, t), o = t.getElevationForLngLatZoom(s, this.tileZoom);
                if (!(this.elevation - o)) return;
                const r = a + i - o, n = Math.cos(this._pitch) * this.cameraToCenterDistance / r / e.b4(1, s.lat), l = this.scaleZoom(n / this.tileSize);
                this._elevation = o, this._center = s, this.zoom = l;
            }
            setLocationAtPoint(t, i) {
                const a = this.pointCoordinate(i), s = this.pointCoordinate(this.centerPoint), o = this.locationCoordinate(t), r = new e.Z(o.x - (a.x - s.x), o.y - (a.y - s.y));
                this.center = this.coordinateLocation(r), this._renderWorldCopies && (this.center = this.center.wrap());
            }
            locationPoint(t, e) {
                return e ? this.coordinatePoint(this.locationCoordinate(t), e.getElevationForLngLatZoom(t, this.tileZoom), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(t));
            }
            pointLocation(t, e) {
                return this.coordinateLocation(this.pointCoordinate(t, e));
            }
            locationCoordinate(t) {
                return e.Z.fromLngLat(t);
            }
            coordinateLocation(t) {
                return t && t.toLngLat();
            }
            pointCoordinate(t, i) {
                if (i) {
                    const e = i.pointCoordinate(t);
                    if (null != e) return e;
                }
                const a = [
                    t.x,
                    t.y,
                    0,
                    1
                ], s = [
                    t.x,
                    t.y,
                    1,
                    1
                ];
                e.af(a, a, this.pixelMatrixInverse), e.af(s, s, this.pixelMatrixInverse);
                const o = a[3], r = s[3], n = a[1] / o, l = s[1] / r, h = a[2] / o, c = s[2] / r, u = h === c ? 0 : (0 - h) / (c - h);
                return new e.Z(e.y.number(a[0] / o, s[0] / r, u) / this.worldSize, e.y.number(n, l, u) / this.worldSize);
            }
            coordinatePoint(t, i = 0, a = this.pixelMatrix) {
                const s = [
                    t.x * this.worldSize,
                    t.y * this.worldSize,
                    i,
                    1
                ];
                return e.af(s, s, a), new e.P(s[0] / s[3], s[1] / s[3]);
            }
            getBounds() {
                const t = Math.max(0, this.height / 2 - this.getHorizon());
                return (new H).extend(this.pointLocation(new e.P(0, t))).extend(this.pointLocation(new e.P(this.width, t))).extend(this.pointLocation(new e.P(this.width, this.height))).extend(this.pointLocation(new e.P(0, this.height)));
            }
            getMaxBounds() {
                return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new H([
                    this.lngRange[0],
                    this.latRange[0]
                ], [
                    this.lngRange[1],
                    this.latRange[1]
                ]) : null;
            }
            getHorizon() {
                return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * .85;
            }
            setMaxBounds(t) {
                t ? (this.lngRange = [
                    t.getWest(),
                    t.getEast()
                ], this.latRange = [
                    t.getSouth(),
                    t.getNorth()
                ], this._constrain()) : (this.lngRange = null, this.latRange = [
                    -85.051129,
                    fa
                ]);
            }
            calculateTileMatrix(t) {
                const i = t.canonical, a = this.worldSize / this.zoomScale(i.z), s = i.x + Math.pow(2, i.z) * t.wrap, o = e.an(new Float64Array(16));
                return e.J(o, o, [
                    s * a,
                    i.y * a,
                    0
                ]), e.K(o, o, [
                    a / e.X,
                    a / e.X,
                    1
                ]), o;
            }
            calculatePosMatrix(t, i = !1) {
                const a = t.key, s = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (s[a]) return s[a];
                const o = this.calculateTileMatrix(t);
                return e.L(o, i ? this.alignedModelViewProjectionMatrix : this.modelViewProjectionMatrix, o), s[a] = new Float32Array(o), s[a];
            }
            calculateFogMatrix(t) {
                const i = t.key, a = this._fogMatrixCache;
                if (a[i]) return a[i];
                const s = this.calculateTileMatrix(t);
                return e.L(s, this.fogMatrix, s), a[i] = new Float32Array(s), a[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            getConstrained(t, i) {
                i = e.ac(+i, this.minZoom, this.maxZoom);
                const a = {
                    center: new e.N(t.lng, t.lat),
                    zoom: i
                };
                let s = this.lngRange;
                if (!this._renderWorldCopies && null === s) {
                    const t = 180 - 1e-10;
                    s = [
                        -t,
                        t
                    ];
                }
                const o = this.tileSize * this.zoomScale(a.zoom);
                let r = 0, n = o, l = 0, h = o, c = 0, u = 0;
                const { x: d, y: _ } = this.size;
                if (this.latRange) {
                    const t = this.latRange;
                    r = e.Q(t[1]) * o, n = e.Q(t[0]) * o, n - r < _ && (c = _ / (n - r));
                }
                s && (l = e.b2(e.O(s[0]) * o, 0, o), h = e.b2(e.O(s[1]) * o, 0, o), h < l && (h += o), h - l < d && (u = d / (h - l)));
                const { x: p, y: m } = this.project.call({
                    worldSize: o
                }, t);
                let f, g;
                const v = Math.max(u || 0, c || 0);
                if (v) {
                    const t = new e.P(u ? (h + l) / 2 : p, c ? (n + r) / 2 : m);
                    return a.center = this.unproject.call({
                        worldSize: o
                    }, t).wrap(), a.zoom += this.scaleZoom(v), a;
                }
                if (this.latRange) {
                    const t = _ / 2;
                    m - t < r && (g = r + t), m + t > n && (g = n - t);
                }
                if (s) {
                    const t = (l + h) / 2;
                    let i = p;
                    this._renderWorldCopies && (i = e.b2(p, t - o / 2, t + o / 2));
                    const a = d / 2;
                    i - a < l && (f = l + a), i + a > h && (f = h - a);
                }
                if (void 0 !== f || void 0 !== g) {
                    const t = new e.P(null != f ? f : p, null != g ? g : m);
                    a.center = this.unproject.call({
                        worldSize: o
                    }, t).wrap();
                }
                return a;
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t = this._unmodified, { center: e, zoom: i } = this.getConstrained(this.center, this.zoom);
                this.center = e, this.zoom = i, this._unmodified = t, this._constraining = !1;
            }
            _calcMatrices() {
                if (!this.height) return;
                const t = this.centerOffset, i = this.point.x, a = this.point.y;
                this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height, this._pixelPerMeter = e.b4(1, this.center.lat) * this.worldSize;
                let s = e.an(new Float64Array(16));
                e.K(s, s, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e.J(s, s, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = s, s = e.an(new Float64Array(16)), e.K(s, s, [
                    1,
                    -1,
                    1
                ]), e.J(s, s, [
                    -1,
                    -1,
                    0
                ]), e.K(s, s, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = s;
                const o = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch), r = Math.min(this.elevation, this.minElevationForCurrentTile), n = o - r * this._pixelPerMeter / Math.cos(this._pitch), l = r < 0 ? n : o, h = Math.PI / 2 + this._pitch, c = this._fov * (.5 + t.y / this.height), u = Math.sin(c) * l / Math.sin(e.ac(Math.PI - h - c, .01, Math.PI - .01)), d = this.getHorizon(), _ = 2 * Math.atan(d / this.cameraToCenterDistance) * (.5 + t.y / (2 * d)), p = Math.sin(_) * l / Math.sin(e.ac(Math.PI - h - _, .01, Math.PI - .01)), m = Math.min(u, p);
                this.farZ = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * m + l), this.nearZ = this.height / 50, s = new Float64Array(16), e.b5(s, this._fov, this.width / this.height, this.nearZ, this.farZ), s[8] = 2 * -t.x / this.width, s[9] = 2 * t.y / this.height, this.projectionMatrix = e.ae(s), e.K(s, s, [
                    1,
                    -1,
                    1
                ]), e.J(s, s, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), e.b6(s, s, this._pitch), e.ad(s, s, this.angle), e.J(s, s, [
                    -i,
                    -a,
                    0
                ]), this.mercatorMatrix = e.K([], s, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), e.K(s, s, [
                    1,
                    1,
                    this._pixelPerMeter
                ]), this.pixelMatrix = e.L(new Float64Array(16), this.labelPlaneMatrix, s), e.J(s, s, [
                    0,
                    0,
                    -this.elevation
                ]), this.modelViewProjectionMatrix = s, this.invModelViewProjectionMatrix = e.as([], s), this.fogMatrix = new Float64Array(16), e.b5(this.fogMatrix, this._fov, this.width / this.height, o, this.farZ), this.fogMatrix[8] = 2 * -t.x / this.width, this.fogMatrix[9] = 2 * t.y / this.height, e.K(this.fogMatrix, this.fogMatrix, [
                    1,
                    -1,
                    1
                ]), e.J(this.fogMatrix, this.fogMatrix, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), e.b6(this.fogMatrix, this.fogMatrix, this._pitch), e.ad(this.fogMatrix, this.fogMatrix, this.angle), e.J(this.fogMatrix, this.fogMatrix, [
                    -i,
                    -a,
                    0
                ]), e.K(this.fogMatrix, this.fogMatrix, [
                    1,
                    1,
                    this._pixelPerMeter
                ]), e.J(this.fogMatrix, this.fogMatrix, [
                    0,
                    0,
                    -this.elevation
                ]), this.pixelMatrix3D = e.L(new Float64Array(16), this.labelPlaneMatrix, s);
                const f = this.width % 2 / 2, g = this.height % 2 / 2, v = Math.cos(this.angle), x = Math.sin(this.angle), y = i - Math.round(i) + v * f + x * g, b = a - Math.round(a) + v * g + x * f, w = new Float64Array(s);
                if (e.J(w, w, [
                    y > .5 ? y - 1 : y,
                    b > .5 ? b - 1 : b,
                    0
                ]), this.alignedModelViewProjectionMatrix = w, s = e.as(new Float64Array(16), this.pixelMatrix), !s) throw new Error("failed to invert matrix");
                this.pixelMatrixInverse = s, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._fogMatrixCache = {};
            }
            maxPitchScaleFactor() {
                if (!this.pixelMatrixInverse) return 1;
                const t = this.pointCoordinate(new e.P(0, 0)), i = [
                    t.x * this.worldSize,
                    t.y * this.worldSize,
                    0,
                    1
                ];
                return e.af(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance;
            }
            getCameraPoint() {
                const t = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new e.P(0, t));
            }
            getCameraQueryGeometry(t) {
                const i = this.getCameraPoint();
                if (1 === t.length) return [
                    t[0],
                    i
                ];
                {
                    let a = i.x, s = i.y, o = i.x, r = i.y;
                    for (const e of t)a = Math.min(a, e.x), s = Math.min(s, e.y), o = Math.max(o, e.x), r = Math.max(r, e.y);
                    return [
                        new e.P(a, s),
                        new e.P(o, s),
                        new e.P(o, r),
                        new e.P(a, r),
                        new e.P(a, s)
                    ];
                }
            }
            lngLatToCameraDepth(t, i) {
                const a = this.locationCoordinate(t), s = [
                    a.x * this.worldSize,
                    a.y * this.worldSize,
                    i,
                    1
                ];
                return e.af(s, s, this.modelViewProjectionMatrix), s[2] / s[3];
            }
        }
        function va(t, e) {
            let i, a = !1, s = null, o = null;
            const r = ()=>{
                s = null, a && (t.apply(o, i), s = setTimeout(r, e), a = !1);
            };
            return (...t)=>(a = !0, o = this, i = t, s || r(), s);
        }
        class xa {
            constructor(t){
                this._getCurrentHash = ()=>{
                    const t = window.location.hash.replace("#", "");
                    if (this._hashName) {
                        let e;
                        return t.split("&").map((t)=>t.split("=")).forEach((t)=>{
                            t[0] === this._hashName && (e = t);
                        }), (e && e[1] || "").split("/");
                    }
                    return t.split("/");
                }, this._onHashChange = ()=>{
                    const t = this._getCurrentHash();
                    if (t.length >= 3 && !t.some((t)=>isNaN(t))) {
                        const e = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t[3] || 0) : this._map.getBearing();
                        return this._map.jumpTo({
                            center: [
                                +t[2],
                                +t[1]
                            ],
                            zoom: +t[0],
                            bearing: e,
                            pitch: +(t[4] || 0)
                        }), !0;
                    }
                    return !1;
                }, this._updateHashUnthrottled = ()=>{
                    const t = window.location.href.replace(/(#.+)?$/, this.getHashString());
                    window.history.replaceState(window.history.state, null, t);
                }, this._removeHash = ()=>{
                    const t = this._getCurrentHash();
                    if (0 === t.length) return;
                    const e = t.join("/");
                    let i = e;
                    i.split("&").length > 0 && (i = i.split("&")[0]), this._hashName && (i = `${this._hashName}=${e}`);
                    let a = window.location.hash.replace(i, "");
                    a.startsWith("#&") ? a = a.slice(0, 1) + a.slice(2) : "#" === a && (a = "");
                    let s = window.location.href.replace(/(#.+)?$/, a);
                    s = s.replace("&&", "&"), window.history.replaceState(window.history.state, null, s);
                }, this._updateHash = va(this._updateHashUnthrottled, 300), this._hashName = t && encodeURIComponent(t);
            }
            addTo(t) {
                return this._map = t, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
            }
            getHashString(t) {
                const e = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, a = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), s = Math.pow(10, a), o = Math.round(e.lng * s) / s, r = Math.round(e.lat * s) / s, n = this._map.getBearing(), l = this._map.getPitch();
                let h = "";
                if (h += t ? `/${o}/${r}/${i}` : `${i}/${r}/${o}`, (n || l) && (h += "/" + Math.round(10 * n) / 10), l && (h += `/${Math.round(l)}`), this._hashName) {
                    const t = this._hashName;
                    let e = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const a = i.split("=")[0];
                        return a === t ? (e = !0, `${a}=${h}`) : i;
                    }).filter((t)=>t);
                    return e || i.push(`${t}=${h}`), `#${i.join("&")}`;
                }
                return `#${h}`;
            }
        }
        const ya = {
            linearity: .3,
            easing: e.b7(0, 0, .3, 1)
        }, ba = e.e({
            deceleration: 2500,
            maxSpeed: 1400
        }, ya), wa = e.e({
            deceleration: 20,
            maxSpeed: 1400
        }, ya), Ta = e.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, ya), Ia = e.e({
            deceleration: 1e3,
            maxSpeed: 90
        }, ya);
        class Ea {
            constructor(t){
                this._map = t, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: o.now(),
                    settings: t
                });
            }
            _drainInertiaBuffer() {
                const t = this._inertiaBuffer, e = o.now();
                for(; t.length > 0 && e - t[0].time > 160;)t.shift();
            }
            _onMoveEnd(t) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: t } of this._inertiaBuffer)i.zoom += t.zoomDelta || 0, i.bearing += t.bearingDelta || 0, i.pitch += t.pitchDelta || 0, t.panDelta && i.pan._add(t.panDelta), t.around && (i.around = t.around), t.pinchAround && (i.pinchAround = t.pinchAround);
                const a = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                if (i.pan.mag()) {
                    const o = Ca(i.pan.mag(), a, e.e({}, ba, t || {}));
                    s.offset = i.pan.mult(o.amount / i.pan.mag()), s.center = this._map.transform.center, Pa(s, o);
                }
                if (i.zoom) {
                    const t = Ca(i.zoom, a, wa);
                    s.zoom = this._map.transform.zoom + t.amount, Pa(s, t);
                }
                if (i.bearing) {
                    const t = Ca(i.bearing, a, Ta);
                    s.bearing = this._map.transform.bearing + e.ac(t.amount, -179, 179), Pa(s, t);
                }
                if (i.pitch) {
                    const t = Ca(i.pitch, a, Ia);
                    s.pitch = this._map.transform.pitch + t.amount, Pa(s, t);
                }
                if (s.zoom || s.bearing) {
                    const t = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    s.around = t ? this._map.unproject(t) : this._map.getCenter();
                }
                return this.clear(), e.e(s, {
                    noMoveStart: !0
                });
            }
        }
        function Pa(t, e) {
            (!t.duration || t.duration < e.duration) && (t.duration = e.duration, t.easing = e.easing);
        }
        function Ca(t, i, a) {
            const { maxSpeed: s, linearity: o, deceleration: r } = a, n = e.ac(t * o / (i / 1e3), -s, s), l = Math.abs(n) / (r * o);
            return {
                easing: a.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class Sa extends e.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t, i, a, s = {}){
                const o = r.mousePos(i.getCanvas(), a), n = i.unproject(o);
                super(t, e.e({
                    point: o,
                    lngLat: n,
                    originalEvent: a
                }, s)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class za extends e.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t, i, a){
                const s = "touchend" === t ? a.changedTouches : a.touches, o = r.touchPos(i.getCanvasContainer(), s), n = o.map((t)=>i.unproject(t)), l = o.reduce((t, e, i, a)=>t.add(e.div(a.length)), new e.P(0, 0));
                super(t, {
                    points: o,
                    point: l,
                    lngLats: n,
                    lngLat: i.unproject(l),
                    originalEvent: a
                }), this._defaultPrevented = !1;
            }
        }
        class Da extends e.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t, e, i){
                super(t, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class Ma {
            constructor(t, e){
                this._map = t, this._clickTolerance = e.clickTolerance;
            }
            reset() {
                delete this._mousedownPos;
            }
            wheel(t) {
                return this._firePreventable(new Da(t.type, this._map, t));
            }
            mousedown(t, e) {
                return this._mousedownPos = e, this._firePreventable(new Sa(t.type, this._map, t));
            }
            mouseup(t) {
                this._map.fire(new Sa(t.type, this._map, t));
            }
            click(t, e) {
                this._mousedownPos && this._mousedownPos.dist(e) >= this._clickTolerance || this._map.fire(new Sa(t.type, this._map, t));
            }
            dblclick(t) {
                return this._firePreventable(new Sa(t.type, this._map, t));
            }
            mouseover(t) {
                this._map.fire(new Sa(t.type, this._map, t));
            }
            mouseout(t) {
                this._map.fire(new Sa(t.type, this._map, t));
            }
            touchstart(t) {
                return this._firePreventable(new za(t.type, this._map, t));
            }
            touchmove(t) {
                this._map.fire(new za(t.type, this._map, t));
            }
            touchend(t) {
                this._map.fire(new za(t.type, this._map, t));
            }
            touchcancel(t) {
                this._map.fire(new za(t.type, this._map, t));
            }
            _firePreventable(t) {
                if (this._map.fire(t), t.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Aa {
            constructor(t){
                this._map = t;
            }
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(t) {
                this._map.fire(new Sa(t.type, this._map, t));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Sa("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(t) {
                this._delayContextMenu ? this._contextMenuEvent = t : this._ignoreContextMenu || this._map.fire(new Sa(t.type, this._map, t)), this._map.listens("contextmenu") && t.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Ra {
            constructor(t){
                this._map = t;
            }
            get transform() {
                return this._map._requestedCameraState || this._map.transform;
            }
            get center() {
                return {
                    lng: this.transform.center.lng,
                    lat: this.transform.center.lat
                };
            }
            get zoom() {
                return this.transform.zoom;
            }
            get pitch() {
                return this.transform.pitch;
            }
            get bearing() {
                return this.transform.bearing;
            }
            unproject(t) {
                return this.transform.pointLocation(e.P.convert(t), this._map.terrain);
            }
        }
        class ka {
            constructor(t, e){
                this._map = t, this._tr = new Ra(t), this._el = t.getCanvasContainer(), this._container = t.getContainer(), this._clickTolerance = e.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(t, e) {
                this.isEnabled() && t.shiftKey && 0 === t.button && (r.disableDrag(), this._startPos = this._lastPos = e, this._active = !0);
            }
            mousemoveWindow(t, e) {
                if (!this._active) return;
                const i = e;
                if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
                const a = this._startPos;
                this._lastPos = i, this._box || (this._box = r.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", t));
                const s = Math.min(a.x, i.x), o = Math.max(a.x, i.x), n = Math.min(a.y, i.y), l = Math.max(a.y, i.y);
                r.setTransform(this._box, `translate(${s}px,${n}px)`), this._box.style.width = o - s + "px", this._box.style.height = l - n + "px";
            }
            mouseupWindow(t, i) {
                if (!this._active) return;
                if (0 !== t.button) return;
                const a = this._startPos, s = i;
                if (this.reset(), r.suppressClick(), a.x !== s.x || a.y !== s.y) return this._map.fire(new e.k("boxzoomend", {
                    originalEvent: t
                })), {
                    cameraAnimation: (t)=>t.fitScreenCoordinates(a, s, this._tr.bearing, {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", t);
            }
            keydown(t) {
                this._active && 27 === t.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (r.remove(this._box), this._box = null), r.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t, i) {
                return this._map.fire(new e.k(t, {
                    originalEvent: i
                }));
            }
        }
        function La(t, e) {
            if (t.length !== e.length) throw new Error(`The number of touches and points are not equal - touches ${t.length}, points ${e.length}`);
            const i = {};
            for(let a = 0; a < t.length; a++)i[t[a].identifier] = e[a];
            return i;
        }
        class Fa {
            constructor(t){
                this.reset(), this.numTouches = t.numTouches;
            }
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(t, i, a) {
                (this.centroid || a.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = t.timeStamp), a.length === this.numTouches && (this.centroid = function(t) {
                    const i = new e.P(0, 0);
                    for (const e of t)i._add(e);
                    return i.div(t.length);
                }(i), this.touches = La(a, i)));
            }
            touchmove(t, e, i) {
                if (this.aborted || !this.centroid) return;
                const a = La(i, e);
                for(const t in this.touches){
                    const e = a[t];
                    (!e || e.dist(this.touches[t]) > 30) && (this.aborted = !0);
                }
            }
            touchend(t, e, i) {
                if ((!this.centroid || t.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const t = !this.aborted && this.centroid;
                    if (this.reset(), t) return t;
                }
            }
        }
        class Ba {
            constructor(t){
                this.singleTap = new Fa(t), this.numTaps = t.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(t, e, i) {
                this.singleTap.touchstart(t, e, i);
            }
            touchmove(t, e, i) {
                this.singleTap.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                const a = this.singleTap.touchend(t, e, i);
                if (a) {
                    const e = t.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(a) < 30;
                    if (e && i || this.reset(), this.count++, this.lastTime = t.timeStamp, this.lastTap = a, this.count === this.numTaps) return this.reset(), a;
                }
            }
        }
        class Oa {
            constructor(t){
                this._tr = new Ra(t), this._zoomIn = new Ba({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Ba({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(t, e, i) {
                this._zoomIn.touchstart(t, e, i), this._zoomOut.touchstart(t, e, i);
            }
            touchmove(t, e, i) {
                this._zoomIn.touchmove(t, e, i), this._zoomOut.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                const a = this._zoomIn.touchend(t, e, i), s = this._zoomOut.touchend(t, e, i), o = this._tr;
                return a ? (this._active = !0, t.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e)=>e.easeTo({
                            duration: 300,
                            zoom: o.zoom + 1,
                            around: o.unproject(a)
                        }, {
                            originalEvent: t
                        })
                }) : s ? (this._active = !0, t.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e)=>e.easeTo({
                            duration: 300,
                            zoom: o.zoom - 1,
                            around: o.unproject(s)
                        }, {
                            originalEvent: t
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Na {
            constructor(t){
                this._enabled = !!t.enable, this._moveStateManager = t.moveStateManager, this._clickTolerance = t.clickTolerance || 1, this._moveFunction = t.move, this._activateOnStart = !!t.activateOnStart, t.assignEvents(this), this.reset();
            }
            reset(t) {
                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(t);
            }
            _move(...t) {
                const e = this._moveFunction(...t);
                if (e.bearingDelta || e.pitchDelta || e.around || e.panDelta) return this._active = !0, e;
            }
            dragStart(t, e) {
                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(t) && (this._moveStateManager.startMove(t), this._lastPoint = e.length ? e[0] : e, this._activateOnStart && this._lastPoint && (this._active = !0));
            }
            dragMove(t, e) {
                if (!this.isEnabled()) return;
                const i = this._lastPoint;
                if (!i) return;
                if (t.preventDefault(), !this._moveStateManager.isValidMoveEvent(t)) return void this.reset(t);
                const a = e.length ? e[0] : e;
                return !this._moved && a.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = a, this._move(i, a));
            }
            dragEnd(t) {
                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(t) && (this._moved && r.suppressClick(), this.reset(t));
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            getClickTolerance() {
                return this._clickTolerance;
            }
        }
        const ja = {
            0: 1,
            2: 2
        };
        class Ua {
            constructor(t){
                this._correctEvent = t.checkCorrectEvent;
            }
            startMove(t) {
                const e = r.mouseButton(t);
                this._eventButton = e;
            }
            endMove(t) {
                delete this._eventButton;
            }
            isValidStartEvent(t) {
                return this._correctEvent(t);
            }
            isValidMoveEvent(t) {
                return !function(t, e) {
                    const i = ja[e];
                    return void 0 === t.buttons || (t.buttons & i) !== i;
                }(t, this._eventButton);
            }
            isValidEndEvent(t) {
                return r.mouseButton(t) === this._eventButton;
            }
        }
        class Za {
            constructor(){
                this._firstTouch = void 0;
            }
            _isOneFingerTouch(t) {
                return 1 === t.targetTouches.length;
            }
            _isSameTouchEvent(t) {
                return t.targetTouches[0].identifier === this._firstTouch;
            }
            startMove(t) {
                this._firstTouch = t.targetTouches[0].identifier;
            }
            endMove(t) {
                delete this._firstTouch;
            }
            isValidStartEvent(t) {
                return this._isOneFingerTouch(t);
            }
            isValidMoveEvent(t) {
                return this._isOneFingerTouch(t) && this._isSameTouchEvent(t);
            }
            isValidEndEvent(t) {
                return this._isOneFingerTouch(t) && this._isSameTouchEvent(t);
            }
        }
        const qa = (t)=>{
            t.mousedown = t.dragStart, t.mousemoveWindow = t.dragMove, t.mouseup = t.dragEnd, t.contextmenu = (t)=>{
                t.preventDefault();
            };
        }, Va = ({ enable: t, clickTolerance: e, bearingDegreesPerPixelMoved: i = .8 })=>{
            const a = new Ua({
                checkCorrectEvent: (t)=>0 === r.mouseButton(t) && t.ctrlKey || 2 === r.mouseButton(t)
            });
            return new Na({
                clickTolerance: e,
                move: (t, e)=>({
                        bearingDelta: (e.x - t.x) * i
                    }),
                moveStateManager: a,
                enable: t,
                assignEvents: qa
            });
        }, Ga = ({ enable: t, clickTolerance: e, pitchDegreesPerPixelMoved: i = -0.5 })=>{
            const a = new Ua({
                checkCorrectEvent: (t)=>0 === r.mouseButton(t) && t.ctrlKey || 2 === r.mouseButton(t)
            });
            return new Na({
                clickTolerance: e,
                move: (t, e)=>({
                        pitchDelta: (e.y - t.y) * i
                    }),
                moveStateManager: a,
                enable: t,
                assignEvents: qa
            });
        };
        class Ha {
            constructor(t, e){
                this._clickTolerance = t.clickTolerance || 1, this._map = e, this.reset();
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e.P(0, 0);
            }
            _shouldBePrevented(t) {
                return t < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
            }
            touchstart(t, e, i) {
                return this._calculateTransform(t, e, i);
            }
            touchmove(t, e, i) {
                if (this._active) {
                    if (!this._shouldBePrevented(i.length)) return t.preventDefault(), this._calculateTransform(t, e, i);
                    this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", t);
                }
            }
            touchend(t, e, i) {
                this._calculateTransform(t, e, i), this._active && this._shouldBePrevented(i.length) && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t, i, a) {
                a.length > 0 && (this._active = !0);
                const s = La(a, i), o = new e.P(0, 0), r = new e.P(0, 0);
                let n = 0;
                for(const t in s){
                    const e = s[t], i = this._touches[t];
                    i && (o._add(e), r._add(e.sub(i)), n++, s[t] = e);
                }
                if (this._touches = s, this._shouldBePrevented(n) || !r.mag()) return;
                const l = r.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: o.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Wa {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            touchstart(t, e, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    e[0],
                    e[1]
                ]));
            }
            touchmove(t, e, i) {
                if (!this._firstTwoTouches) return;
                t.preventDefault();
                const [a, s] = this._firstTwoTouches, o = $a(i, e, a), r = $a(i, e, s);
                if (!o || !r) return;
                const n = this._aroundCenter ? null : o.add(r).div(2);
                return this._move([
                    o,
                    r
                ], n, t);
            }
            touchend(t, e, i) {
                if (!this._firstTwoTouches) return;
                const [a, s] = this._firstTwoTouches, o = $a(i, e, a), n = $a(i, e, s);
                o && n || (this._active && r.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(t) {
                this._enabled = !0, this._aroundCenter = !!t && "center" === t.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
        }
        function $a(t, e, i) {
            for(let a = 0; a < t.length; a++)if (t[a].identifier === i) return e[a];
        }
        function Xa(t, e) {
            return Math.log(t / e) / Math.LN2;
        }
        class Ka extends Wa {
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(t) {
                this._startDistance = this._distance = t[0].dist(t[1]);
            }
            _move(t, e) {
                const i = this._distance;
                if (this._distance = t[0].dist(t[1]), this._active || !(Math.abs(Xa(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Xa(this._distance, i),
                    pinchAround: e
                };
            }
        }
        function Ja(t, e) {
            return 180 * t.angleWith(e) / Math.PI;
        }
        class Ya extends Wa {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(t) {
                this._startVector = this._vector = t[0].sub(t[1]), this._minDiameter = t[0].dist(t[1]);
            }
            _move(t, e, i) {
                const a = this._vector;
                if (this._vector = t[0].sub(t[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: Ja(this._vector, a),
                    pinchAround: e
                };
            }
            _isBelowThreshold(t) {
                this._minDiameter = Math.min(this._minDiameter, t.mag());
                const e = 25 / (Math.PI * this._minDiameter) * 360, i = Ja(t, this._startVector);
                return Math.abs(i) < e;
            }
        }
        function Qa(t) {
            return Math.abs(t.y) > Math.abs(t.x);
        }
        class ts extends Wa {
            constructor(t){
                super(), this._currentTouchCount = 0, this._map = t;
            }
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(t, e, i) {
                super.touchstart(t, e, i), this._currentTouchCount = i.length;
            }
            _start(t) {
                this._lastPoints = t, Qa(t[0].sub(t[1])) && (this._valid = !1);
            }
            _move(t, e, i) {
                if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                const a = t[0].sub(this._lastPoints[0]), s = t[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(a, s, i.timeStamp), this._valid ? (this._lastPoints = t, this._active = !0, {
                    pitchDelta: (a.y + s.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(t, e, i) {
                if (void 0 !== this._valid) return this._valid;
                const a = t.mag() >= 2, s = e.mag() >= 2;
                if (!a && !s) return;
                if (!a || !s) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const o = t.y > 0 == e.y > 0;
                return Qa(t) && Qa(e) && o;
            }
        }
        const es = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class is {
            constructor(t){
                this._tr = new Ra(t);
                const e = es;
                this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
            }
            reset() {
                this._active = !1;
            }
            keydown(t) {
                if (t.altKey || t.ctrlKey || t.metaKey) return;
                let e = 0, i = 0, a = 0, s = 0, o = 0;
                switch(t.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        e = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        e = -1;
                        break;
                    case 37:
                        t.shiftKey ? i = -1 : (t.preventDefault(), s = -1);
                        break;
                    case 39:
                        t.shiftKey ? i = 1 : (t.preventDefault(), s = 1);
                        break;
                    case 38:
                        t.shiftKey ? a = 1 : (t.preventDefault(), o = -1);
                        break;
                    case 40:
                        t.shiftKey ? a = -1 : (t.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, a = 0), {
                    cameraAnimation: (r)=>{
                        const n = this._tr;
                        r.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: as,
                            zoom: e ? Math.round(n.zoom) + e * (t.shiftKey ? 2 : 1) : n.zoom,
                            bearing: n.bearing + i * this._bearingStep,
                            pitch: n.pitch + a * this._pitchStep,
                            offset: [
                                -s * this._panStep,
                                -o * this._panStep
                            ],
                            center: n.center
                        }, {
                            originalEvent: t
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function as(t) {
            return t * (2 - t);
        }
        const ss = 4.000244140625;
        class os {
            constructor(t, e){
                this._onTimeout = (t)=>{
                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t);
                }, this._map = t, this._tr = new Ra(t), this._triggerRenderFrame = e, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
            }
            setZoomRate(t) {
                this._defaultZoomRate = t;
            }
            setWheelZoomRate(t) {
                this._wheelZoomRate = t;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(t) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!t && "center" === t.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            _shouldBePrevented(t) {
                return !!this._map.cooperativeGestures.isEnabled() && !(t.ctrlKey || this._map.cooperativeGestures.isBypassed(t));
            }
            wheel(t) {
                if (!this.isEnabled()) return;
                if (this._shouldBePrevented(t)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", t);
                let e = t.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t.deltaY : t.deltaY;
                const i = o.now(), a = i - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = i, 0 !== e && e % ss == 0 ? this._type = "wheel" : 0 !== e && Math.abs(e) < 4 ? this._type = "trackpad" : a > 400 ? (this._type = null, this._lastValue = e, this._timeout = setTimeout(this._onTimeout, 40, t)) : this._type || (this._type = Math.abs(a * e) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, e += this._lastValue)), t.shiftKey && e && (e /= 4), this._type && (this._lastWheelEvent = t, this._delta -= e, this._active || this._start(t)), t.preventDefault();
            }
            _start(t) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const i = r.mousePos(this._map.getCanvas(), t), a = this._tr;
                this._around = i.y > a.transform.height / 2 - a.transform.getHorizon() ? e.N.convert(this._aroundCenter ? a.center : a.unproject(i)) : e.N.convert(a.center), this._aroundPoint = a.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t = this._tr.transform;
                if (0 !== this._delta) {
                    const e = "wheel" === this._type && Math.abs(this._delta) > ss ? this._wheelZoomRate : this._defaultZoomRate;
                    let i = 2 / (1 + Math.exp(-Math.abs(this._delta * e)));
                    this._delta < 0 && 0 !== i && (i = 1 / i);
                    const a = "number" == typeof this._targetZoom ? t.zoomScale(this._targetZoom) : t.scale;
                    this._targetZoom = Math.min(t.maxZoom, Math.max(t.minZoom, t.scaleZoom(a * i))), "wheel" === this._type && (this._startZoom = t.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" == typeof this._targetZoom ? this._targetZoom : t.zoom, a = this._startZoom, s = this._easing;
                let r, n = !1;
                const l = o.now() - this._lastWheelEventTime;
                if ("wheel" === this._type && a && s && l) {
                    const t = Math.min(l / 200, 1), o = s(t);
                    r = e.y.number(a, i, o), t < 1 ? this._frameId || (this._frameId = !0) : n = !0;
                } else r = i, n = !0;
                return this._active = !0, n && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !n,
                    zoomDelta: r - t.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t) {
                let i = e.b8;
                if (this._prevEase) {
                    const t = this._prevEase, a = (o.now() - t.start) / t.duration, s = t.easing(a + .01) - t.easing(a), r = .27 / Math.sqrt(s * s + 1e-4) * .01, n = Math.sqrt(.0729 - r * r);
                    i = e.b7(r, n, .25, 1);
                }
                return this._prevEase = {
                    start: o.now(),
                    duration: t,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1, this._zooming = !1, delete this._targetZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            }
        }
        class rs {
            constructor(t, e){
                this._clickZoom = t, this._tapZoom = e;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class ns {
            constructor(t){
                this._tr = new Ra(t), this.reset();
            }
            reset() {
                this._active = !1;
            }
            dblclick(t, e) {
                return t.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: this._tr.zoom + (t.shiftKey ? -1 : 1),
                            around: this._tr.unproject(e)
                        }, {
                            originalEvent: t
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class ls {
            constructor(){
                this._tap = new Ba({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
            }
            touchstart(t, e, i) {
                if (!this._swipePoint) {
                    if (this._tapTime) {
                        const a = e[0], s = t.timeStamp - this._tapTime < 500, o = this._tapPoint.dist(a) < 30;
                        s && o ? i.length > 0 && (this._swipePoint = a, this._swipeTouch = i[0].identifier) : this.reset();
                    } else this._tap.touchstart(t, e, i);
                }
            }
            touchmove(t, e, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const a = e[0], s = a.y - this._swipePoint.y;
                        return this._swipePoint = a, t.preventDefault(), this._active = !0, {
                            zoomDelta: s / 128
                        };
                    }
                } else this._tap.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
                else {
                    const a = this._tap.touchend(t, e, i);
                    a && (this._tapTime = t.timeStamp, this._tapPoint = a);
                }
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class hs {
            constructor(t, e, i){
                this._el = t, this._mousePan = e, this._touchPan = i;
            }
            enable(t) {
                this._inertiaOptions = t || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class cs {
            constructor(t, e, i){
                this._pitchWithRotate = t.pitchWithRotate, this._mouseRotate = e, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class us {
            constructor(t, e, i, a){
                this._el = t, this._touchZoom = e, this._touchRotate = i, this._tapDragZoom = a, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(t) {
                this._touchZoom.enable(t), this._rotationDisabled || this._touchRotate.enable(t), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        class ds {
            constructor(t, e){
                this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = t, this._options = e, this._enabled = !1;
            }
            isActive() {
                return !1;
            }
            reset() {}
            _setupUI() {
                if (this._container) return;
                const t = this._map.getCanvasContainer();
                t.classList.add("maplibregl-cooperative-gestures"), this._container = r.create("div", "maplibregl-cooperative-gesture-screen", t);
                let e = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                "metaKey" === this._bypassKey && (e = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                const i = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), a = document.createElement("div");
                a.className = "maplibregl-desktop-message", a.textContent = e, this._container.appendChild(a);
                const s = document.createElement("div");
                s.className = "maplibregl-mobile-message", s.textContent = i, this._container.appendChild(s), this._container.setAttribute("aria-hidden", "true");
            }
            _destroyUI() {
                this._container && (r.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
            }
            enable() {
                this._setupUI(), this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this._destroyUI();
            }
            isEnabled() {
                return this._enabled;
            }
            isBypassed(t) {
                return t[this._bypassKey];
            }
            notifyGestureBlocked(t, i) {
                this._enabled && (this._map.fire(new e.k("cooperativegestureprevented", {
                    gestureType: t,
                    originalEvent: i
                })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                    this._container.classList.remove("maplibregl-show");
                }, 100));
            }
        }
        const _s = (t)=>t.zoom || t.drag || t.pitch || t.rotate;
        class ps extends e.k {
        }
        function ms(t) {
            return t.panDelta && t.panDelta.mag() || t.zoomDelta || t.bearingDelta || t.pitchDelta;
        }
        class fs {
            constructor(t, e){
                this.handleWindowEvent = (t)=>{
                    this.handleEvent(t, `${t.type}Window`);
                }, this.handleEvent = (t, e)=>{
                    if ("blur" === t.type) return void this.stop(!0);
                    this._updatingCamera = !0;
                    const i = "renderFrame" === t.type ? void 0 : t, a = {
                        needsRenderFrame: !1
                    }, s = {}, o = {}, n = t.touches, l = n ? this._getMapTouches(n) : void 0, h = l ? r.touchPos(this._map.getCanvas(), l) : r.mousePos(this._map.getCanvas(), t);
                    for (const { handlerName: r, handler: n, allowed: c } of this._handlers){
                        if (!n.isEnabled()) continue;
                        let u;
                        this._blockedByActive(o, c, r) ? n.reset() : n[e || t.type] && (u = n[e || t.type](t, h, l), this.mergeHandlerResult(a, s, u, r, i), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || n.isActive()) && (o[r] = n);
                    }
                    const c = {};
                    for(const t in this._previousActiveHandlers)o[t] || (c[t] = i);
                    this._previousActiveHandlers = o, (Object.keys(c).length || ms(a)) && (this._changes.push([
                        a,
                        s,
                        c
                    ]), this._triggerRenderFrame()), (Object.keys(o).length || ms(a)) && this._map._stop(!0), this._updatingCamera = !1;
                    const { cameraAnimation: u } = a;
                    u && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], u(this._map));
                }, this._map = t, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Ea(t), this._bearingSnap = e.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(e);
                const i = this._el;
                this._listeners = [
                    [
                        i,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        i,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        i,
                        "touchend",
                        void 0
                    ],
                    [
                        i,
                        "touchcancel",
                        void 0
                    ],
                    [
                        i,
                        "mousedown",
                        void 0
                    ],
                    [
                        i,
                        "mousemove",
                        void 0
                    ],
                    [
                        i,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        i,
                        "mouseover",
                        void 0
                    ],
                    [
                        i,
                        "mouseout",
                        void 0
                    ],
                    [
                        i,
                        "dblclick",
                        void 0
                    ],
                    [
                        i,
                        "click",
                        void 0
                    ],
                    [
                        i,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        i,
                        "keyup",
                        void 0
                    ],
                    [
                        i,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        i,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [t, e, i] of this._listeners)r.addEventListener(t, e, t === document ? this.handleWindowEvent : this.handleEvent, i);
            }
            destroy() {
                for (const [t, e, i] of this._listeners)r.removeEventListener(t, e, t === document ? this.handleWindowEvent : this.handleEvent, i);
            }
            _addDefaultHandlers(t) {
                const e = this._map, i = e.getCanvasContainer();
                this._add("mapEvent", new Ma(e, t));
                const a = e.boxZoom = new ka(e, t);
                this._add("boxZoom", a), t.interactive && t.boxZoom && a.enable();
                const s = e.cooperativeGestures = new ds(e, t.cooperativeGestures);
                this._add("cooperativeGestures", s), t.cooperativeGestures && s.enable();
                const o = new Oa(e), n = new ns(e);
                e.doubleClickZoom = new rs(n, o), this._add("tapZoom", o), this._add("clickZoom", n), t.interactive && t.doubleClickZoom && e.doubleClickZoom.enable();
                const l = new ls;
                this._add("tapDragZoom", l);
                const h = e.touchPitch = new ts(e);
                this._add("touchPitch", h), t.interactive && t.touchPitch && e.touchPitch.enable(t.touchPitch);
                const c = Va(t), u = Ga(t);
                e.dragRotate = new cs(t, c, u), this._add("mouseRotate", c, [
                    "mousePitch"
                ]), this._add("mousePitch", u, [
                    "mouseRotate"
                ]), t.interactive && t.dragRotate && e.dragRotate.enable();
                const d = (({ enable: t, clickTolerance: e })=>{
                    const i = new Ua({
                        checkCorrectEvent: (t)=>0 === r.mouseButton(t) && !t.ctrlKey
                    });
                    return new Na({
                        clickTolerance: e,
                        move: (t, e)=>({
                                around: e,
                                panDelta: e.sub(t)
                            }),
                        activateOnStart: !0,
                        moveStateManager: i,
                        enable: t,
                        assignEvents: qa
                    });
                })(t), _ = new Ha(t, e);
                e.dragPan = new hs(i, d, _), this._add("mousePan", d), this._add("touchPan", _, [
                    "touchZoom",
                    "touchRotate"
                ]), t.interactive && t.dragPan && e.dragPan.enable(t.dragPan);
                const p = new Ya, m = new Ka;
                e.touchZoomRotate = new us(i, m, p, l), this._add("touchRotate", p, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", m, [
                    "touchPan",
                    "touchRotate"
                ]), t.interactive && t.touchZoomRotate && e.touchZoomRotate.enable(t.touchZoomRotate);
                const f = e.scrollZoom = new os(e, ()=>this._triggerRenderFrame());
                this._add("scrollZoom", f, [
                    "mousePan"
                ]), t.interactive && t.scrollZoom && e.scrollZoom.enable(t.scrollZoom);
                const g = e.keyboard = new is(e);
                this._add("keyboard", g), t.interactive && t.keyboard && e.keyboard.enable(), this._add("blockableMapEvent", new Aa(e));
            }
            _add(t, e, i) {
                this._handlers.push({
                    handlerName: t,
                    handler: e,
                    allowed: i
                }), this._handlersById[t] = e;
            }
            stop(t) {
                if (!this._updatingCamera) {
                    for (const { handler: t } of this._handlers)t.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, t), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: t } of this._handlers)if (t.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(_s(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(t, e, i) {
                for(const a in t)if (a !== i && (!e || e.indexOf(a) < 0)) return !0;
                return !1;
            }
            _getMapTouches(t) {
                const e = [];
                for (const i of t)this._el.contains(i.target) && e.push(i);
                return e;
            }
            mergeHandlerResult(t, i, a, s, o) {
                if (!a) return;
                e.e(t, a);
                const r = {
                    handlerName: s,
                    originalEvent: a.originalEvent || o
                };
                void 0 !== a.zoomDelta && (i.zoom = r), void 0 !== a.panDelta && (i.drag = r), void 0 !== a.pitchDelta && (i.pitch = r), void 0 !== a.bearingDelta && (i.rotate = r);
            }
            _applyChanges() {
                const t = {}, i = {}, a = {};
                for (const [s, o, r] of this._changes)s.panDelta && (t.panDelta = (t.panDelta || new e.P(0, 0))._add(s.panDelta)), s.zoomDelta && (t.zoomDelta = (t.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (t.bearingDelta = (t.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (t.pitchDelta = (t.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (t.around = s.around), void 0 !== s.pinchAround && (t.pinchAround = s.pinchAround), s.noInertia && (t.noInertia = s.noInertia), e.e(i, o), e.e(a, r);
                this._updateMapTransform(t, i, a), this._changes = [];
            }
            _updateMapTransform(t, e, i) {
                const a = this._map, s = a._getTransformForUpdate(), o = a.terrain;
                if (!(ms(t) || o && this._terrainMovement)) return this._fireEvents(e, i, !0);
                let { panDelta: r, zoomDelta: n, bearingDelta: l, pitchDelta: h, around: c, pinchAround: u } = t;
                void 0 !== u && (c = u), a._stop(!0), c = c || a.transform.centerPoint;
                const d = s.pointLocation(r ? c.sub(r) : c);
                l && (s.bearing += l), h && (s.pitch += h), n && (s.zoom += n), o ? this._terrainMovement || !e.drag && !e.zoom ? e.drag && this._terrainMovement ? s.center = s.pointLocation(s.centerPoint.sub(r)) : s.setLocationAtPoint(d, c) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, s.setLocationAtPoint(d, c)) : s.setLocationAtPoint(d, c), a._applyUpdatedTransform(s), this._map._update(), t.noInertia || this._inertia.record(t), this._fireEvents(e, i, !0);
            }
            _fireEvents(t, i, a) {
                const s = _s(this._eventsInProgress), r = _s(t), n = {};
                for(const e in t){
                    const { originalEvent: i } = t[e];
                    this._eventsInProgress[e] || (n[`${e}start`] = i), this._eventsInProgress[e] = t[e];
                }
                !s && r && this._fireEvent("movestart", r.originalEvent);
                for(const t in n)this._fireEvent(t, n[t]);
                r && this._fireEvent("move", r.originalEvent);
                for(const e in t){
                    const { originalEvent: i } = t[e];
                    this._fireEvent(e, i);
                }
                const l = {};
                let h;
                for(const t in this._eventsInProgress){
                    const { handlerName: e, originalEvent: a } = this._eventsInProgress[t];
                    this._handlersById[e].isActive() || (delete this._eventsInProgress[t], h = i[e] || a, l[`${t}end`] = h);
                }
                for(const t in l)this._fireEvent(t, l[t]);
                const c = _s(this._eventsInProgress), u = (s || r) && !c;
                if (u && this._terrainMovement) {
                    this._map._elevationFreeze = !1, this._terrainMovement = !1;
                    const t = this._map._getTransformForUpdate();
                    t.recalculateZoom(this._map.terrain), this._map._applyUpdatedTransform(t);
                }
                if (a && u) {
                    this._updatingCamera = !0;
                    const t = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (t)=>0 !== t && -this._bearingSnap < t && t < this._bearingSnap;
                    !t || !t.essential && o.prefersReducedMotion ? (this._map.fire(new e.k("moveend", {
                        originalEvent: h
                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(t.bearing || this._map.getBearing()) && (t.bearing = 0), t.freezeElevation = !0, this._map.easeTo(t, {
                        originalEvent: h
                    })), this._updatingCamera = !1;
                }
            }
            _fireEvent(t, i) {
                this._map.fire(new e.k(t, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((t)=>{
                    delete this._frameId, this.handleEvent(new ps("renderFrame", {
                        timeStamp: t
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        class gs extends e.E {
            constructor(t, e){
                super(), this._renderFrameCallback = ()=>{
                    const t = Math.min((o.now() - this._easeStart) / this._easeOptions.duration, 1);
                    this._onEaseFrame(this._easeOptions.easing(t)), t < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                }, this._moving = !1, this._zooming = !1, this.transform = t, this._bearingSnap = e.bearingSnap, this.on("moveend", ()=>{
                    delete this._requestedCameraState;
                });
            }
            getCenter() {
                return new e.N(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(t, e) {
                return this.jumpTo({
                    center: t
                }, e);
            }
            panBy(t, i, a) {
                return t = e.P.convert(t).mult(-1), this.panTo(this.transform.center, e.e({
                    offset: t
                }, i), a);
            }
            panTo(t, i, a) {
                return this.easeTo(e.e({
                    center: t
                }, i), a);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(t, e) {
                return this.jumpTo({
                    zoom: t
                }, e), this;
            }
            zoomTo(t, i, a) {
                return this.easeTo(e.e({
                    zoom: t
                }, i), a);
            }
            zoomIn(t, e) {
                return this.zoomTo(this.getZoom() + 1, t, e), this;
            }
            zoomOut(t, e) {
                return this.zoomTo(this.getZoom() - 1, t, e), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(t, e) {
                return this.jumpTo({
                    bearing: t
                }, e), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(t, e) {
                return this.jumpTo({
                    padding: t
                }, e), this;
            }
            rotateTo(t, i, a) {
                return this.easeTo(e.e({
                    bearing: t
                }, i), a);
            }
            resetNorth(t, i) {
                return this.rotateTo(0, e.e({
                    duration: 1e3
                }, t), i), this;
            }
            resetNorthPitch(t, i) {
                return this.easeTo(e.e({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, t), i), this;
            }
            snapToNorth(t, e) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t, e) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(t, e) {
                return this.jumpTo({
                    pitch: t
                }, e), this;
            }
            cameraForBounds(t, e) {
                t = H.convert(t);
                const i = e && e.bearing || 0;
                return this._cameraForBoxAndBearing(t.getNorthWest(), t.getSouthEast(), i, e);
            }
            _cameraForBoxAndBearing(t, i, a, s) {
                const o = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (s = e.e({
                    padding: o,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, s)).padding) {
                    const t = s.padding;
                    s.padding = {
                        top: t,
                        bottom: t,
                        right: t,
                        left: t
                    };
                }
                s.padding = e.e(o, s.padding);
                const r = this.transform, n = r.padding, l = new H(t, i), h = r.project(l.getNorthWest()), c = r.project(l.getNorthEast()), u = r.project(l.getSouthEast()), d = r.project(l.getSouthWest()), _ = e.b9(-a), p = h.rotate(_), m = c.rotate(_), f = u.rotate(_), g = d.rotate(_), v = new e.P(Math.max(p.x, m.x, g.x, f.x), Math.max(p.y, m.y, g.y, f.y)), x = new e.P(Math.min(p.x, m.x, g.x, f.x), Math.min(p.y, m.y, g.y, f.y)), y = v.sub(x), b = (r.width - (n.left + n.right + s.padding.left + s.padding.right)) / y.x, w = (r.height - (n.top + n.bottom + s.padding.top + s.padding.bottom)) / y.y;
                if (w < 0 || b < 0) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                const T = Math.min(r.scaleZoom(r.scale * Math.min(b, w)), s.maxZoom), I = e.P.convert(s.offset), E = new e.P((s.padding.left - s.padding.right) / 2, (s.padding.top - s.padding.bottom) / 2).rotate(e.b9(a)), P = I.add(E).mult(r.scale / r.zoomScale(T));
                return {
                    center: r.unproject(h.add(u).div(2).sub(P)),
                    zoom: T,
                    bearing: a
                };
            }
            fitBounds(t, e, i) {
                return this._fitInternal(this.cameraForBounds(t, e), e, i);
            }
            fitScreenCoordinates(t, i, a, s, o) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(e.P.convert(t)), this.transform.pointLocation(e.P.convert(i)), a, s), s, o);
            }
            _fitInternal(t, i, a) {
                return t ? (delete (i = e.e(t, i)).padding, i.linear ? this.easeTo(i, a) : this.flyTo(i, a)) : this;
            }
            jumpTo(t, i) {
                this.stop();
                const a = this._getTransformForUpdate();
                let s = !1, o = !1, r = !1;
                return "zoom" in t && a.zoom !== +t.zoom && (s = !0, a.zoom = +t.zoom), void 0 !== t.center && (a.center = e.N.convert(t.center)), "bearing" in t && a.bearing !== +t.bearing && (o = !0, a.bearing = +t.bearing), "pitch" in t && a.pitch !== +t.pitch && (r = !0, a.pitch = +t.pitch), null == t.padding || a.isPaddingEqual(t.padding) || (a.padding = t.padding), this._applyUpdatedTransform(a), this.fire(new e.k("movestart", i)).fire(new e.k("move", i)), s && this.fire(new e.k("zoomstart", i)).fire(new e.k("zoom", i)).fire(new e.k("zoomend", i)), o && this.fire(new e.k("rotatestart", i)).fire(new e.k("rotate", i)).fire(new e.k("rotateend", i)), r && this.fire(new e.k("pitchstart", i)).fire(new e.k("pitch", i)).fire(new e.k("pitchend", i)), this.fire(new e.k("moveend", i));
            }
            calculateCameraOptionsFromTo(t, i, a, s = 0) {
                const o = e.Z.fromLngLat(t, i), r = e.Z.fromLngLat(a, s), n = r.x - o.x, l = r.y - o.y, h = r.z - o.z, c = Math.hypot(n, l, h);
                if (0 === c) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = this.transform.scaleZoom(this.transform.cameraToCenterDistance / c / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                let p = 180 * Math.acos(u / c) / Math.PI;
                return p = h < 0 ? 90 - p : 90 + p, {
                    center: r.toLngLat(),
                    zoom: d,
                    pitch: p,
                    bearing: _
                };
            }
            easeTo(t, i) {
                var a;
                this._stop(!1, t.easeId), (!1 === (t = e.e({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e.b8
                }, t)).animate || !t.essential && o.prefersReducedMotion) && (t.duration = 0);
                const s = this._getTransformForUpdate(), r = s.zoom, n = s.bearing, l = s.pitch, h = s.padding, c = "bearing" in t ? this._normalizeBearing(t.bearing, n) : n, u = "pitch" in t ? +t.pitch : l, d = "padding" in t ? t.padding : s.padding, _ = e.P.convert(t.offset);
                let p = s.centerPoint.add(_);
                const m = s.pointLocation(p), { center: f, zoom: g } = s.getConstrained(e.N.convert(t.center || m), null !== (a = t.zoom) && void 0 !== a ? a : r);
                this._normalizeCenter(f, s);
                const v = s.project(m), x = s.project(f).sub(v), y = s.zoomScale(g - r);
                let b, w;
                t.around && (b = e.N.convert(t.around), w = s.locationPoint(b));
                const T = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = this._zooming || g !== r, this._rotating = this._rotating || n !== c, this._pitching = this._pitching || u !== l, this._padding = !s.isPaddingEqual(d), this._easeId = t.easeId, this._prepareEase(i, t.noMoveStart, T), this.terrain && this._prepareElevation(f), this._ease((a)=>{
                    if (this._zooming && (s.zoom = e.y.number(r, g, a)), this._rotating && (s.bearing = e.y.number(n, c, a)), this._pitching && (s.pitch = e.y.number(l, u, a)), this._padding && (s.interpolatePadding(h, d, a), p = s.centerPoint.add(_)), this.terrain && !t.freezeElevation && this._updateElevation(a), b) s.setLocationAtPoint(b, w);
                    else {
                        const t = s.zoomScale(s.zoom - r), e = g > r ? Math.min(2, y) : Math.max(.5, y), i = Math.pow(e, 1 - a), o = s.unproject(v.add(x.mult(a * i)).mult(t));
                        s.setLocationAtPoint(s.renderWorldCopies ? o.wrap() : o, p);
                    }
                    this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, (e)=>{
                    this.terrain && t.freezeElevation && this._finalizeElevation(), this._afterEase(i, e);
                }, t), this;
            }
            _prepareEase(t, i, a = {}) {
                this._moving = !0, i || a.moving || this.fire(new e.k("movestart", t)), this._zooming && !a.zooming && this.fire(new e.k("zoomstart", t)), this._rotating && !a.rotating && this.fire(new e.k("rotatestart", t)), this._pitching && !a.pitching && this.fire(new e.k("pitchstart", t));
            }
            _prepareElevation(t) {
                this._elevationCenter = t, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(t, this.transform.tileZoom), this._elevationFreeze = !0;
            }
            _updateElevation(t) {
                this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                const i = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                if (t < 1 && i !== this._elevationTarget) {
                    const e = this._elevationTarget - this._elevationStart;
                    this._elevationStart += t * (e - (i - (e * t + this._elevationStart)) / (1 - t)), this._elevationTarget = i;
                }
                this.transform.elevation = e.y.number(this._elevationStart, this._elevationTarget, t);
            }
            _finalizeElevation() {
                this._elevationFreeze = !1, this.transform.recalculateZoom(this.terrain);
            }
            _getTransformForUpdate() {
                return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
            }
            _elevateCameraIfInsideTerrain(t) {
                const e = t.getCameraPosition(), i = this.terrain.getElevationForLngLatZoom(e.lngLat, t.zoom);
                if (e.altitude < i) {
                    const a = this.calculateCameraOptionsFromTo(e.lngLat, i, t.center, t.elevation);
                    return {
                        pitch: a.pitch,
                        zoom: a.zoom
                    };
                }
                return {};
            }
            _applyUpdatedTransform(t) {
                const e = [];
                if (this.terrain && e.push((t)=>this._elevateCameraIfInsideTerrain(t)), this.transformCameraUpdate && e.push((t)=>this.transformCameraUpdate(t)), !e.length) return;
                const i = t.clone();
                for (const t of e){
                    const e = i.clone(), { center: a, zoom: s, pitch: o, bearing: r, elevation: n } = t(e);
                    a && (e.center = a), void 0 !== s && (e.zoom = s), void 0 !== o && (e.pitch = o), void 0 !== r && (e.bearing = r), void 0 !== n && (e.elevation = n), i.apply(e);
                }
                this.transform.apply(i);
            }
            _fireMoveEvents(t) {
                this.fire(new e.k("move", t)), this._zooming && this.fire(new e.k("zoom", t)), this._rotating && this.fire(new e.k("rotate", t)), this._pitching && this.fire(new e.k("pitch", t));
            }
            _afterEase(t, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId;
                const a = this._zooming, s = this._rotating, o = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, a && this.fire(new e.k("zoomend", t)), s && this.fire(new e.k("rotateend", t)), o && this.fire(new e.k("pitchend", t)), this.fire(new e.k("moveend", t));
            }
            flyTo(t, i) {
                var a;
                if (!t.essential && o.prefersReducedMotion) {
                    const a = e.M(t, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(a, i);
                }
                this.stop(), t = e.e({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e.b8
                }, t);
                const s = this._getTransformForUpdate(), r = s.zoom, n = s.bearing, l = s.pitch, h = s.padding, c = "bearing" in t ? this._normalizeBearing(t.bearing, n) : n, u = "pitch" in t ? +t.pitch : l, d = "padding" in t ? t.padding : s.padding, _ = e.P.convert(t.offset);
                let p = s.centerPoint.add(_);
                const m = s.pointLocation(p), { center: f, zoom: g } = s.getConstrained(e.N.convert(t.center || m), null !== (a = t.zoom) && void 0 !== a ? a : r);
                this._normalizeCenter(f, s);
                const v = s.zoomScale(g - r), x = s.project(m), y = s.project(f).sub(x);
                let b = t.curve;
                const w = Math.max(s.width, s.height), T = w / v, I = y.mag();
                if ("minZoom" in t) {
                    const i = e.ac(Math.min(t.minZoom, r, g), s.minZoom, s.maxZoom), a = w / s.zoomScale(i - r);
                    b = Math.sqrt(a / I * 2);
                }
                const E = b * b;
                function P(t) {
                    const e = (T * T - w * w + (t ? -1 : 1) * E * E * I * I) / (2 * (t ? T : w) * E * I);
                    return Math.log(Math.sqrt(e * e + 1) - e);
                }
                function C(t) {
                    return (Math.exp(t) - Math.exp(-t)) / 2;
                }
                function S(t) {
                    return (Math.exp(t) + Math.exp(-t)) / 2;
                }
                const z = P(!1);
                let D = function(t) {
                    return S(z) / S(z + b * t);
                }, M = function(t) {
                    var e;
                    return w * ((S(z) * (C(e = z + b * t) / S(e)) - C(z)) / E) / I;
                }, A = (P(!0) - z) / b;
                if (Math.abs(I) < 1e-6 || !isFinite(A)) {
                    if (Math.abs(w - T) < 1e-6) return this.easeTo(t, i);
                    const e = T < w ? -1 : 1;
                    A = Math.abs(Math.log(T / w)) / b, M = ()=>0, D = (t)=>Math.exp(e * b * t);
                }
                return t.duration = "duration" in t ? +t.duration : 1e3 * A / ("screenSpeed" in t ? +t.screenSpeed / b : +t.speed), t.maxDuration && t.duration > t.maxDuration && (t.duration = 0), this._zooming = !0, this._rotating = n !== c, this._pitching = u !== l, this._padding = !s.isPaddingEqual(d), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f), this._ease((a)=>{
                    const o = a * A, m = 1 / D(o);
                    s.zoom = 1 === a ? g : r + s.scaleZoom(m), this._rotating && (s.bearing = e.y.number(n, c, a)), this._pitching && (s.pitch = e.y.number(l, u, a)), this._padding && (s.interpolatePadding(h, d, a), p = s.centerPoint.add(_)), this.terrain && !t.freezeElevation && this._updateElevation(a);
                    const v = 1 === a ? f : s.unproject(x.add(y.mult(M(o))).mult(m));
                    s.setLocationAtPoint(s.renderWorldCopies ? v.wrap() : v, p), this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, ()=>{
                    this.terrain && t.freezeElevation && this._finalizeElevation(), this._afterEase(i);
                }, t), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(t, e) {
                var i;
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const t = this._onEaseEnd;
                    delete this._onEaseEnd, t.call(this, e);
                }
                return t || null === (i = this.handlers) || void 0 === i || i.stop(!1), this;
            }
            _ease(t, e, i) {
                !1 === i.animate || 0 === i.duration ? (t(1), e()) : (this._easeStart = o.now(), this._easeOptions = i, this._onEaseFrame = t, this._onEaseEnd = e, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _normalizeBearing(t, i) {
                t = e.b2(t, -180, 180);
                const a = Math.abs(t - i);
                return Math.abs(t - 360 - i) < a && (t -= 360), Math.abs(t + 360 - i) < a && (t += 360), t;
            }
            _normalizeCenter(t, e) {
                if (!e.renderWorldCopies || e.lngRange) return;
                const i = t.lng - e.center.lng;
                t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            queryTerrainElevation(t) {
                return this.terrain ? this.terrain.getElevationForLngLatZoom(e.N.convert(t), this.transform.tileZoom) - this.transform.elevation : null;
            }
        }
        const vs = {
            compact: !0,
            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
        };
        class xs {
            constructor(t = vs){
                this._toggleAttribution = ()=>{
                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                }, this._updateData = (t)=>{
                    !t || "metadata" !== t.sourceDataType && "visibility" !== t.sourceDataType && "style" !== t.dataType && "terrain" !== t.type || this._updateAttributions();
                }, this._updateCompact = ()=>{
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                }, this._updateCompactMinimize = ()=>{
                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                }, this.options = t;
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(t) {
                return this._map = t, this._compact = this.options.compact, this._container = r.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = r.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = r.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                r.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(t, e) {
                const i = this._map._getUIString(`AttributionControl.${e}`);
                t.title = i, t.setAttribute("aria-label", i);
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let t = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t = t.concat(this.options.customAttribution.map((t)=>"string" != typeof t ? "" : t)) : "string" == typeof this.options.customAttribution && t.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const t = this._map.style.stylesheet;
                    this.styleOwner = t.owner, this.styleId = t.id;
                }
                const e = this._map.style.sourceCaches;
                for(const i in e){
                    const a = e[i];
                    if (a.used || a.usedForTerrain) {
                        const e = a.getSource();
                        e.attribution && t.indexOf(e.attribution) < 0 && t.push(e.attribution);
                    }
                }
                t = t.filter((t)=>String(t).trim()), t.sort((t, e)=>t.length - e.length), t = t.filter((e, i)=>{
                    for(let a = i + 1; a < t.length; a++)if (t[a].indexOf(e) >= 0) return !1;
                    return !0;
                });
                const i = t.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, t.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
        }
        class ys {
            constructor(t = {}){
                this._updateCompact = ()=>{
                    const t = this._container.children;
                    if (t.length) {
                        const e = t[0];
                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && e.classList.add("maplibregl-compact") : e.classList.remove("maplibregl-compact");
                    }
                }, this.options = t;
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t) {
                this._map = t, this._compact = this.options && this.options.compact, this._container = r.create("div", "maplibregl-ctrl");
                const e = r.create("a", "maplibregl-ctrl-logo");
                return e.target = "_blank", e.rel = "noopener nofollow", e.href = "https://maplibre.org/", e.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                r.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
        }
        class bs {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(t) {
                const e = ++this._id;
                return this._queue.push({
                    callback: t,
                    id: e,
                    cancelled: !1
                }), e;
            }
            remove(t) {
                const e = this._currentlyRunning, i = e ? this._queue.concat(e) : this._queue;
                for (const e of i)if (e.id === t) return void (e.cancelled = !0);
            }
            run(t = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const e = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of e)if (!i.cancelled && (i.callback(t), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        var ws = e.Y([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        class Ts extends e.E {
            constructor(t){
                super(), this.sourceCache = t, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, t.usedForTerrain = !0, t.tileSize = this.tileSize * 2 ** this.deltaZoom;
            }
            destruct() {
                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
            }
            update(t, i) {
                this.sourceCache.update(t, i), this._renderableTilesKeys = [];
                const a = {};
                for (const s of t.coveringTiles({
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i
                }))a[s.key] = !0, this._renderableTilesKeys.push(s.key), this._tiles[s.key] || (s.posMatrix = new Float64Array(16), e.aP(s.posMatrix, 0, e.X, 0, e.X, 0, 1), this._tiles[s.key] = new lt(s, this.tileSize));
                for(const t in this._tiles)a[t] || delete this._tiles[t];
            }
            freeRtt(t) {
                for(const e in this._tiles){
                    const i = this._tiles[e];
                    (!t || i.tileID.equals(t) || i.tileID.isChildOf(t) || t.isChildOf(i.tileID)) && (i.rtt = []);
                }
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((t)=>this.getTileByID(t));
            }
            getTileByID(t) {
                return this._tiles[t];
            }
            getTerrainCoords(t) {
                const i = {};
                for (const a of this._renderableTilesKeys){
                    const s = this._tiles[a].tileID;
                    if (s.canonical.equals(t.canonical)) {
                        const s = t.clone();
                        s.posMatrix = new Float64Array(16), e.aP(s.posMatrix, 0, e.X, 0, e.X, 0, 1), i[a] = s;
                    } else if (s.canonical.isChildOf(t.canonical)) {
                        const o = t.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = s.canonical.z - t.canonical.z, n = s.canonical.x - (s.canonical.x >> r << r), l = s.canonical.y - (s.canonical.y >> r << r), h = e.X >> r;
                        e.aP(o.posMatrix, 0, h, 0, h, 0, 1), e.J(o.posMatrix, o.posMatrix, [
                            -n * h,
                            -l * h,
                            0
                        ]), i[a] = o;
                    } else if (t.canonical.isChildOf(s.canonical)) {
                        const o = t.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = t.canonical.z - s.canonical.z, n = t.canonical.x - (t.canonical.x >> r << r), l = t.canonical.y - (t.canonical.y >> r << r), h = e.X >> r;
                        e.aP(o.posMatrix, 0, e.X, 0, e.X, 0, 1), e.J(o.posMatrix, o.posMatrix, [
                            n * h,
                            l * h,
                            0
                        ]), e.K(o.posMatrix, o.posMatrix, [
                            1 / 2 ** r,
                            1 / 2 ** r,
                            0
                        ]), i[a] = o;
                    }
                }
                return i;
            }
            getSourceTile(t, e) {
                const i = this.sourceCache._source;
                let a = t.overscaledZ - this.deltaZoom;
                if (a > i.maxzoom && (a = i.maxzoom), a < i.minzoom) return null;
                this._sourceTileCache[t.key] || (this._sourceTileCache[t.key] = t.scaledTo(a).key);
                let s = this.sourceCache.getTileByID(this._sourceTileCache[t.key]);
                if ((!s || !s.dem) && e) for(; a >= i.minzoom && (!s || !s.dem);)s = this.sourceCache.getTileByID(t.scaledTo(a--).key);
                return s;
            }
            tilesAfterTime(t = Date.now()) {
                return Object.values(this._tiles).filter((e)=>e.timeAdded >= t);
            }
        }
        class Is {
            constructor(t, e, i){
                this.painter = t, this.sourceCache = new Ts(e), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            getDEMElevation(t, i, a, s = e.X) {
                var o;
                if (!(i >= 0 && i < s && a >= 0 && a < s)) return 0;
                const r = this.getTerrainData(t), n = null === (o = r.tile) || void 0 === o ? void 0 : o.dem;
                if (!n) return 0;
                const l = function(t, e, i) {
                    var a = e[0], s = e[1];
                    return t[0] = i[0] * a + i[4] * s + i[12], t[1] = i[1] * a + i[5] * s + i[13], t;
                }([], [
                    i / s * e.X,
                    a / s * e.X
                ], r.u_terrain_matrix), h = [
                    l[0] * n.dim,
                    l[1] * n.dim
                ], c = Math.floor(h[0]), u = Math.floor(h[1]), d = h[0] - c, _ = h[1] - u;
                return n.get(c, u) * (1 - d) * (1 - _) + n.get(c + 1, u) * d * (1 - _) + n.get(c, u + 1) * (1 - d) * _ + n.get(c + 1, u + 1) * d * _;
            }
            getElevationForLngLatZoom(t, i) {
                if (!e.ba(i, t.wrap())) return 0;
                const { tileID: a, mercatorX: s, mercatorY: o } = this._getOverscaledTileIDFromLngLatZoom(t, i);
                return this.getElevation(a, s % e.X, o % e.X, e.X);
            }
            getElevation(t, i, a, s = e.X) {
                return this.getDEMElevation(t, i, a, s) * this.exaggeration;
            }
            getTerrainData(t) {
                if (!this._emptyDemTexture) {
                    const t = this.painter.context, i = new e.R({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new b(t, i, t.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new b(t, new e.R({
                        width: 1,
                        height: 1
                    }), t.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(t.gl.NEAREST, t.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = e.an([]);
                }
                const i = this.sourceCache.getSourceTile(t, !0);
                if (i && i.dem && (!i.demTexture || i.needsTerrainPrepare)) {
                    const t = this.painter.context;
                    i.demTexture = this.painter.getTileTexture(i.dem.stride), i.demTexture ? i.demTexture.update(i.dem.getPixels(), {
                        premultiply: !1
                    }) : i.demTexture = new b(t, i.dem.getPixels(), t.gl.RGBA, {
                        premultiply: !1
                    }), i.demTexture.bind(t.gl.NEAREST, t.gl.CLAMP_TO_EDGE), i.needsTerrainPrepare = !1;
                }
                const a = i && i + i.tileID.key + t.key;
                if (a && !this._demMatrixCache[a]) {
                    const a = this.sourceCache.sourceCache._source.maxzoom;
                    let s = t.canonical.z - i.tileID.canonical.z;
                    t.overscaledZ > t.canonical.z && (t.canonical.z >= a ? s = t.canonical.z - a : e.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const o = t.canonical.x - (t.canonical.x >> s << s), r = t.canonical.y - (t.canonical.y >> s << s), n = e.bb(new Float64Array(16), [
                        1 / (e.X << s),
                        1 / (e.X << s),
                        0
                    ]);
                    e.J(n, n, [
                        o * e.X,
                        r * e.X,
                        0
                    ]), this._demMatrixCache[t.key] = {
                        matrix: n,
                        coord: t
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: i && i.dem && i.dem.dim || 1,
                    u_terrain_matrix: a ? this._demMatrixCache[t.key].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: i && i.dem && i.dem.getUnpackVector() || this._emptyDemUnpack,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: (i && i.demTexture || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: i
                };
            }
            getFramebuffer(t) {
                const e = this.painter, i = e.width / devicePixelRatio, a = e.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === i && this._fbo.height === a || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new b(e.context, {
                    width: i,
                    height: a,
                    data: null
                }, e.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(e.context.gl.NEAREST, e.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new b(e.context, {
                    width: i,
                    height: a,
                    data: null
                }, e.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(e.context.gl.NEAREST, e.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e.context.createFramebuffer(i, a, !0, !1), this._fbo.depthAttachment.set(e.context.createRenderbuffer(e.context.gl.DEPTH_COMPONENT16, i, a))), this._fbo.colorAttachment.set("coords" === t ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const t = this.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let t = 0, e = 0; t < this._coordsTextureSize; t++)for(let a = 0; a < this._coordsTextureSize; a++, e += 4)i[e + 0] = 255 & a, i[e + 1] = 255 & t, i[e + 2] = a >> 8 << 4 | t >> 8, i[e + 3] = 0;
                const a = new e.R({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), s = new b(t, a, t.gl.RGBA, {
                    premultiply: !1
                });
                return s.bind(t.gl.NEAREST, t.gl.CLAMP_TO_EDGE), this._coordsTexture = s, s;
            }
            pointCoordinate(t) {
                this.painter.maybeDrawDepthAndCoords(!0);
                const i = new Uint8Array(4), a = this.painter.context, s = a.gl, o = Math.round(t.x * this.painter.pixelRatio / devicePixelRatio), r = Math.round(t.y * this.painter.pixelRatio / devicePixelRatio), n = Math.round(this.painter.height / devicePixelRatio);
                a.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), s.readPixels(o, n - r - 1, 1, 1, s.RGBA, s.UNSIGNED_BYTE, i), a.bindFramebuffer.set(null);
                const l = i[0] + (i[2] >> 4 << 8), h = i[1] + ((15 & i[2]) << 8), c = this.coordsIndex[255 - i[3]], u = c && this.sourceCache.getTileByID(c);
                if (!u) return null;
                const d = this._coordsTextureSize, _ = (1 << u.tileID.canonical.z) * d;
                return new e.Z((u.tileID.canonical.x * d + l) / _ + u.tileID.wrap, (u.tileID.canonical.y * d + h) / _, this.getElevation(u.tileID, l, h, d));
            }
            depthAtPoint(t) {
                const e = new Uint8Array(4), i = this.painter.context, a = i.gl;
                return i.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), a.readPixels(t.x, this.painter.height / devicePixelRatio - t.y - 1, 1, 1, a.RGBA, a.UNSIGNED_BYTE, e), i.bindFramebuffer.set(null), (e[0] / 16777216 + e[1] / 65536 + e[2] / 256 + e[3]) / 256;
            }
            getTerrainMesh() {
                if (this._mesh) return this._mesh;
                const t = this.painter.context, i = new e.bc, a = new e.aX, s = this.meshSize, o = e.X / s, r = s * s;
                for(let t = 0; t <= s; t++)for(let e = 0; e <= s; e++)i.emplaceBack(e * o, t * o, 0);
                for(let t = 0; t < r; t += s + 1)for(let e = 0; e < s; e++)a.emplaceBack(e + t, s + e + t + 1, s + e + t + 2), a.emplaceBack(e + t, s + e + t + 2, e + t + 1);
                const n = i.length, l = n + 2 * (s + 1);
                for (const t of [
                    0,
                    1
                ])for(let a = 0; a <= s; a++)for (const s of [
                    0,
                    1
                ])i.emplaceBack(a * o, t * e.X, s);
                for(let t = 0; t < 2 * s; t += 2)a.emplaceBack(l + t, l + t + 1, l + t + 3), a.emplaceBack(l + t, l + t + 3, l + t + 2), a.emplaceBack(n + t, n + t + 3, n + t + 1), a.emplaceBack(n + t, n + t + 2, n + t + 3);
                const h = i.length, c = h + 2 * (s + 1);
                for (const t of [
                    0,
                    1
                ])for(let a = 0; a <= s; a++)for (const s of [
                    0,
                    1
                ])i.emplaceBack(t * e.X, a * o, s);
                for(let t = 0; t < 2 * s; t += 2)a.emplaceBack(h + t, h + t + 1, h + t + 3), a.emplaceBack(h + t, h + t + 3, h + t + 2), a.emplaceBack(c + t, c + t + 3, c + t + 1), a.emplaceBack(c + t, c + t + 2, c + t + 3);
                return this._mesh = new ua(t.createVertexBuffer(i, ws.members), t.createIndexBuffer(a), e.a0.simpleSegment(0, 0, i.length, a.length)), this._mesh;
            }
            getMeshFrameDelta(t) {
                return 2 * Math.PI * e.bd / Math.pow(2, t) / 5;
            }
            getMinTileElevationForLngLatZoom(t, e) {
                var i;
                const { tileID: a } = this._getOverscaledTileIDFromLngLatZoom(t, e);
                return null !== (i = this.getMinMaxElevation(a).minElevation) && void 0 !== i ? i : 0;
            }
            getMinMaxElevation(t) {
                const e = this.getTerrainData(t).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return e && e.dem && (i.minElevation = e.dem.min * this.exaggeration, i.maxElevation = e.dem.max * this.exaggeration), i;
            }
            _getOverscaledTileIDFromLngLatZoom(t, i) {
                const a = e.Z.fromLngLat(t.wrap()), s = (1 << i) * e.X, o = a.x * s, r = a.y * s, n = Math.floor(o / e.X), l = Math.floor(r / e.X);
                return {
                    tileID: new e.S(i, 0, i, n, l),
                    mercatorX: o,
                    mercatorY: r
                };
            }
        }
        class Es {
            constructor(t, e, i){
                this._context = t, this._size = e, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            destruct() {
                for (const t of this._objects)t.texture.destroy(), t.fbo.destroy();
            }
            _createObject(t) {
                const e = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), i = new b(this._context, {
                    width: this._tileSize,
                    height: this._tileSize,
                    data: null
                }, this._context.gl.RGBA);
                return i.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), e.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), e.colorAttachment.set(i.texture), {
                    id: t,
                    fbo: e,
                    texture: i,
                    stamp: -1,
                    inUse: !1
                };
            }
            getObjectForId(t) {
                return this._objects[t];
            }
            useObject(t) {
                t.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((e)=>t.id !== e), this._recentlyUsed.push(t.id);
            }
            stampObject(t) {
                t.stamp = ++this._stamp;
            }
            getOrCreateFreeObject() {
                for (const t of this._recentlyUsed)if (!this._objects[t].inUse) return this._objects[t];
                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                const t = this._createObject(this._objects.length);
                return this._objects.push(t), t;
            }
            freeObject(t) {
                t.inUse = !1;
            }
            freeAllObjects() {
                for (const t of this._objects)this.freeObject(t);
            }
            isFull() {
                return !(this._objects.length < this._size) && !1 === this._objects.some((t)=>!t.inUse);
            }
        }
        const Ps = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0
        };
        class Cs {
            constructor(t, e){
                this.painter = t, this.terrain = e, this.pool = new Es(t.context, 30, e.sourceCache.tileSize * e.qualityFactor);
            }
            destruct() {
                this.pool.destruct();
            }
            getTexture(t) {
                return this.pool.getObjectForId(t.rtt[this._stacks.length - 1].id).texture;
            }
            prepareForRender(t, e) {
                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = t._order.filter((i)=>!t._layers[i].isHidden(e)), this._coordsDescendingInv = {};
                for(const e in t.sourceCaches){
                    this._coordsDescendingInv[e] = {};
                    const i = t.sourceCaches[e].getVisibleCoordinates();
                    for (const t of i){
                        const i = this.terrain.sourceCache.getTerrainCoords(t);
                        for(const t in i)this._coordsDescendingInv[e][t] || (this._coordsDescendingInv[e][t] = []), this._coordsDescendingInv[e][t].push(i[t]);
                    }
                }
                this._coordsDescendingInvStr = {};
                for (const e of t._order){
                    const i = t._layers[e], a = i.source;
                    if (Ps[i.type] && !this._coordsDescendingInvStr[a]) {
                        this._coordsDescendingInvStr[a] = {};
                        for(const t in this._coordsDescendingInv[a])this._coordsDescendingInvStr[a][t] = this._coordsDescendingInv[a][t].map((t)=>t.key).sort().join();
                    }
                }
                for (const t of this._renderableTiles)for(const e in this._coordsDescendingInvStr){
                    const i = this._coordsDescendingInvStr[e][t.tileID.key];
                    i && i !== t.rttCoords[e] && (t.rtt = []);
                }
            }
            renderLayer(t) {
                if (t.isHidden(this.painter.transform.zoom)) return !1;
                const i = t.type, a = this.painter, s = this._renderableLayerIds[this._renderableLayerIds.length - 1] === t.id;
                if (Ps[i] && (this._prevType && Ps[this._prevType] || this._stacks.push([]), this._prevType = i, this._stacks[this._stacks.length - 1].push(t.id), !s)) return !0;
                if (Ps[this._prevType] || Ps[i] && s) {
                    this._prevType = i;
                    const t = this._stacks.length - 1, s = this._stacks[t] || [];
                    for (const i of this._renderableTiles){
                        if (this.pool.isFull() && (ca(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(i), i.rtt[t]) {
                            const e = this.pool.getObjectForId(i.rtt[t].id);
                            if (e.stamp === i.rtt[t].stamp) {
                                this.pool.useObject(e);
                                continue;
                            }
                        }
                        const o = this.pool.getOrCreateFreeObject();
                        this.pool.useObject(o), this.pool.stampObject(o), i.rtt[t] = {
                            id: o.id,
                            stamp: o.stamp
                        }, a.context.bindFramebuffer.set(o.fbo.framebuffer), a.context.clear({
                            color: e.aM.transparent,
                            stencil: 0
                        }), a.currentStencilSource = void 0;
                        for(let t = 0; t < s.length; t++){
                            const e = a.style._layers[s[t]], r = e.source ? this._coordsDescendingInv[e.source][i.tileID.key] : [
                                i.tileID
                            ];
                            a.context.viewport.set([
                                0,
                                0,
                                o.fbo.width,
                                o.fbo.height
                            ]), a._renderTileClippingMasks(e, r), a.renderLayer(a, a.style.sourceCaches[e.source], e, r), e.source && (i.rttCoords[e.source] = this._coordsDescendingInvStr[e.source][i.tileID.key]);
                        }
                    }
                    return ca(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects(), Ps[i];
                }
                return !1;
            }
        }
        const Ss = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "MapLibre logo",
            "Map.Title": "Map",
            "Marker.Title": "Map marker",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "Popup.Close": "Close popup",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "TerrainControl.Enable": "Enable terrain",
            "TerrainControl.Disable": "Disable terrain",
            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
        }, zs = i, Ds = {
            hash: !1,
            interactive: !0,
            bearingSnap: 7,
            attributionControl: vs,
            maplibreLogo: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            refreshExpiredTiles: !0,
            scrollZoom: !0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            trackResize: !0,
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            renderWorldCopies: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: e.a.MAX_TILE_CACHE_ZOOM_LEVELS,
            transformRequest: null,
            transformCameraUpdate: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            clickTolerance: 3,
            localIdeographFontFamily: "sans-serif",
            pitchWithRotate: !0,
            validateStyle: !0,
            maxCanvasSize: [
                4096,
                4096
            ],
            cancelPendingTileRequestsWhileZooming: !0
        }, Ms = (t)=>{
            t.touchstart = t.dragStart, t.touchmoveWindow = t.dragMove, t.touchend = t.dragEnd;
        }, As = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class Rs {
            constructor(t, i, a = !1){
                this.mousedown = (t)=>{
                    this.startMouse(e.e({}, t, {
                        ctrlKey: !0,
                        preventDefault: ()=>t.preventDefault()
                    }), r.mousePos(this.element, t)), r.addEventListener(window, "mousemove", this.mousemove), r.addEventListener(window, "mouseup", this.mouseup);
                }, this.mousemove = (t)=>{
                    this.moveMouse(t, r.mousePos(this.element, t));
                }, this.mouseup = (t)=>{
                    this.mouseRotate.dragEnd(t), this.mousePitch && this.mousePitch.dragEnd(t), this.offTemp();
                }, this.touchstart = (t)=>{
                    1 !== t.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = r.touchPos(this.element, t.targetTouches)[0], this.startTouch(t, this._startPos), r.addEventListener(window, "touchmove", this.touchmove, {
                        passive: !1
                    }), r.addEventListener(window, "touchend", this.touchend));
                }, this.touchmove = (t)=>{
                    1 !== t.targetTouches.length ? this.reset() : (this._lastPos = r.touchPos(this.element, t.targetTouches)[0], this.moveTouch(t, this._lastPos));
                }, this.touchend = (t)=>{
                    0 === t.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this.reset = ()=>{
                    this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), this.touchRotate.reset(), this.touchPitch && this.touchPitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this._clickTolerance = 10;
                const s = t.dragRotate._mouseRotate.getClickTolerance(), o = t.dragRotate._mousePitch.getClickTolerance();
                this.element = i, this.mouseRotate = Va({
                    clickTolerance: s,
                    enable: !0
                }), this.touchRotate = (({ enable: t, clickTolerance: e, bearingDegreesPerPixelMoved: i = .8 })=>{
                    const a = new Za;
                    return new Na({
                        clickTolerance: e,
                        move: (t, e)=>({
                                bearingDelta: (e.x - t.x) * i
                            }),
                        moveStateManager: a,
                        enable: t,
                        assignEvents: Ms
                    });
                })({
                    clickTolerance: s,
                    enable: !0
                }), this.map = t, a && (this.mousePitch = Ga({
                    clickTolerance: o,
                    enable: !0
                }), this.touchPitch = (({ enable: t, clickTolerance: e, pitchDegreesPerPixelMoved: i = -0.5 })=>{
                    const a = new Za;
                    return new Na({
                        clickTolerance: e,
                        move: (t, e)=>({
                                pitchDelta: (e.y - t.y) * i
                            }),
                        moveStateManager: a,
                        enable: t,
                        assignEvents: Ms
                    });
                })({
                    clickTolerance: o,
                    enable: !0
                })), r.addEventListener(i, "mousedown", this.mousedown), r.addEventListener(i, "touchstart", this.touchstart, {
                    passive: !1
                }), r.addEventListener(i, "touchcancel", this.reset);
            }
            startMouse(t, e) {
                this.mouseRotate.dragStart(t, e), this.mousePitch && this.mousePitch.dragStart(t, e), r.disableDrag();
            }
            startTouch(t, e) {
                this.touchRotate.dragStart(t, e), this.touchPitch && this.touchPitch.dragStart(t, e), r.disableDrag();
            }
            moveMouse(t, e) {
                const i = this.map, { bearingDelta: a } = this.mouseRotate.dragMove(t, e) || {};
                if (a && i.setBearing(i.getBearing() + a), this.mousePitch) {
                    const { pitchDelta: a } = this.mousePitch.dragMove(t, e) || {};
                    a && i.setPitch(i.getPitch() + a);
                }
            }
            moveTouch(t, e) {
                const i = this.map, { bearingDelta: a } = this.touchRotate.dragMove(t, e) || {};
                if (a && i.setBearing(i.getBearing() + a), this.touchPitch) {
                    const { pitchDelta: a } = this.touchPitch.dragMove(t, e) || {};
                    a && i.setPitch(i.getPitch() + a);
                }
            }
            off() {
                const t = this.element;
                r.removeEventListener(t, "mousedown", this.mousedown), r.removeEventListener(t, "touchstart", this.touchstart, {
                    passive: !1
                }), r.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), r.removeEventListener(window, "touchend", this.touchend), r.removeEventListener(t, "touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                r.enableDrag(), r.removeEventListener(window, "mousemove", this.mousemove), r.removeEventListener(window, "mouseup", this.mouseup), r.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), r.removeEventListener(window, "touchend", this.touchend);
            }
        }
        let ks;
        function Ls(t, i, a) {
            const s = new e.N(t.lng, t.lat);
            if (t = new e.N(t.lng, t.lat), i) {
                const s = new e.N(t.lng - 360, t.lat), o = new e.N(t.lng + 360, t.lat), r = a.locationPoint(t).distSqr(i);
                a.locationPoint(s).distSqr(i) < r ? t = s : a.locationPoint(o).distSqr(i) < r && (t = o);
            }
            for(; Math.abs(t.lng - a.center.lng) > 180;){
                const e = a.locationPoint(t);
                if (e.x >= 0 && e.y >= 0 && e.x <= a.width && e.y <= a.height) break;
                t.lng > a.center.lng ? t.lng -= 360 : t.lng += 360;
            }
            return t.lng !== s.lng && a.locationPoint(t).y > a.height / 2 - a.getHorizon() ? t : s;
        }
        const Fs = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function Bs(t, e, i) {
            const a = t.classList;
            for(const t in Fs)a.remove(`maplibregl-${i}-anchor-${t}`);
            a.add(`maplibregl-${i}-anchor-${e}`);
        }
        class Os extends e.E {
            constructor(t){
                if (super(), this._onKeyPress = (t)=>{
                    const e = t.code, i = t.charCode || t.keyCode;
                    "Space" !== e && "Enter" !== e && 32 !== i && 13 !== i || this.togglePopup();
                }, this._onMapClick = (t)=>{
                    const e = t.originalEvent.target, i = this._element;
                    this._popup && (e === i || i.contains(e)) && this.togglePopup();
                }, this._update = (t)=>{
                    var e;
                    if (!this._map) return;
                    const i = this._map.loaded() && !this._map.isMoving();
                    ("terrain" === (null == t ? void 0 : t.type) || "render" === (null == t ? void 0 : t.type) && !i) && this._map.once("render", this._update), this._lngLat = this._map.transform.renderWorldCopies ? Ls(this._lngLat, this._flatPos, this._map.transform) : null === (e = this._lngLat) || void 0 === e ? void 0 : e.wrap(), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationPoint(this._lngLat)._add(this._offset));
                    let a = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? a = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (a = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                    let s = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? s = "rotateX(0deg)" : "map" === this._pitchAlignment && (s = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || t && "moveend" !== t.type || (this._pos = this._pos.round()), r.setTransform(this._element, `${Fs[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${s} ${a}`), o.frameAsync(new AbortController).then(()=>{
                        this._updateOpacity(t && "moveend" === t.type);
                    }).catch(()=>{});
                }, this._onMove = (t)=>{
                    if (!this._isDragging) {
                        const e = this._clickTolerance || this._map._clickTolerance;
                        this._isDragging = t.point.dist(this._pointerdownPos) >= e;
                    }
                    this._isDragging && (this._pos = t.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.k("dragstart"))), this.fire(new e.k("drag")));
                }, this._onUp = ()=>{
                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new e.k("dragend")), this._state = "inactive";
                }, this._addDragHandler = (t)=>{
                    this._element.contains(t.originalEvent.target) && (t.preventDefault(), this._positionDelta = t.point.sub(this._pos).add(this._offset), this._pointerdownPos = t.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                }, this._anchor = t && t.anchor || "center", this._color = t && t.color || "#3FB1CE", this._scale = t && t.scale || 1, this._draggable = t && t.draggable || !1, this._clickTolerance = t && t.clickTolerance || 0, this._subpixelPositioning = t && t.subpixelPositioning || !1, this._isDragging = !1, this._state = "inactive", this._rotation = t && t.rotation || 0, this._rotationAlignment = t && t.rotationAlignment || "auto", this._pitchAlignment = t && t.pitchAlignment && "auto" !== t.pitchAlignment ? t.pitchAlignment : this._rotationAlignment, this.setOpacity(), this.setOpacity(null == t ? void 0 : t.opacity, null == t ? void 0 : t.opacityWhenCovered), t && t.element) this._element = t.element, this._offset = e.P.convert(t && t.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = r.create("div");
                    const i = r.createNS("http://www.w3.org/2000/svg", "svg"), a = 41, s = 27;
                    i.setAttributeNS(null, "display", "block"), i.setAttributeNS(null, "height", `${a}px`), i.setAttributeNS(null, "width", `${s}px`), i.setAttributeNS(null, "viewBox", `0 0 ${s} ${a}`);
                    const o = r.createNS("http://www.w3.org/2000/svg", "g");
                    o.setAttributeNS(null, "stroke", "none"), o.setAttributeNS(null, "stroke-width", "1"), o.setAttributeNS(null, "fill", "none"), o.setAttributeNS(null, "fill-rule", "evenodd");
                    const n = r.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "fill-rule", "nonzero");
                    const l = r.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    const h = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const t of h){
                        const e = r.createNS("http://www.w3.org/2000/svg", "ellipse");
                        e.setAttributeNS(null, "opacity", "0.04"), e.setAttributeNS(null, "cx", "10.5"), e.setAttributeNS(null, "cy", "5.80029008"), e.setAttributeNS(null, "rx", t.rx), e.setAttributeNS(null, "ry", t.ry), l.appendChild(e);
                    }
                    const c = r.createNS("http://www.w3.org/2000/svg", "g");
                    c.setAttributeNS(null, "fill", this._color);
                    const u = r.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), c.appendChild(u);
                    const d = r.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    const _ = r.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(_);
                    const p = r.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p.setAttributeNS(null, "fill", "#FFFFFF");
                    const m = r.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = r.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = r.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), m.appendChild(f), m.appendChild(g), n.appendChild(l), n.appendChild(c), n.appendChild(d), n.appendChild(p), n.appendChild(m), i.appendChild(n), i.setAttributeNS(null, "height", a * this._scale + "px"), i.setAttributeNS(null, "width", s * this._scale + "px"), this._element.appendChild(i), this._offset = e.P.convert(t && t.offset || [
                        0,
                        -14
                    ]);
                }
                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (t)=>{
                    t.preventDefault();
                }), this._element.addEventListener("mousedown", (t)=>{
                    t.preventDefault();
                }), Bs(this._element, this._anchor, "marker"), t && t.className) for (const e of t.className.split(" "))this._element.classList.add(e);
                this._popup = null;
            }
            addTo(t) {
                return this.remove(), this._map = t, this._element.setAttribute("aria-label", t._getUIString("Marker.Title")), t.getCanvasContainer().appendChild(this._element), t.on("move", this._update), t.on("moveend", this._update), t.on("terrain", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), r.remove(this._element), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t) {
                return this._lngLat = e.N.convert(t), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(t) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t) {
                    if (!("offset" in t.options)) {
                        const e = 38.1, i = 13.5, a = Math.abs(i) / Math.SQRT2;
                        t.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -e
                            ],
                            "bottom-left": [
                                a,
                                -1 * (e - i + a)
                            ],
                            "bottom-right": [
                                -a,
                                -1 * (e - i + a)
                            ],
                            left: [
                                i,
                                -1 * (e - i)
                            ],
                            right: [
                                -i,
                                -1 * (e - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = t, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            setSubpixelPositioning(t) {
                return this._subpixelPositioning = t, this;
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const t = this._popup;
                return this._element.style.opacity === this._opacityWhenCovered ? this : t ? (t.isOpen() ? t.remove() : (t.setLngLat(this._lngLat), t.addTo(this._map)), this) : this;
            }
            _updateOpacity(t = !1) {
                var i, a;
                if (!(null === (i = this._map) || void 0 === i ? void 0 : i.terrain)) return void (this._element.style.opacity !== this._opacity && (this._element.style.opacity = this._opacity));
                if (t) this._opacityTimeout = null;
                else {
                    if (this._opacityTimeout) return;
                    this._opacityTimeout = setTimeout(()=>{
                        this._opacityTimeout = null;
                    }, 100);
                }
                const s = this._map, o = s.terrain.depthAtPoint(this._pos), r = s.terrain.getElevationForLngLatZoom(this._lngLat, s.transform.tileZoom);
                if (s.transform.lngLatToCameraDepth(this._lngLat, r) - o < .006) return void (this._element.style.opacity = this._opacity);
                const n = -this._offset.y / s.transform._pixelPerMeter, l = Math.sin(s.getPitch() * Math.PI / 180) * n, h = s.terrain.depthAtPoint(new e.P(this._pos.x, this._pos.y - this._offset.y)), c = s.transform.lngLatToCameraDepth(this._lngLat, r + l) - h > .006;
                (null === (a = this._popup) || void 0 === a ? void 0 : a.isOpen()) && c && this._popup.remove(), this._element.style.opacity = c ? this._opacityWhenCovered : this._opacity;
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t) {
                return this._offset = e.P.convert(t), this._update(), this;
            }
            addClassName(t) {
                this._element.classList.add(t);
            }
            removeClassName(t) {
                this._element.classList.remove(t);
            }
            toggleClassName(t) {
                return this._element.classList.toggle(t);
            }
            setDraggable(t) {
                return this._draggable = !!t, this._map && (t ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(t) {
                return this._rotation = t || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(t) {
                return this._rotationAlignment = t || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(t) {
                return this._pitchAlignment = t && "auto" !== t ? t : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
            setOpacity(t, e) {
                return void 0 === t && void 0 === e && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== t && (this._opacity = t), void 0 !== e && (this._opacityWhenCovered = e), this._map && this._updateOpacity(!0), this;
            }
        }
        const Ns = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let js = 0, Us = !1;
        const Zs = {
            maxWidth: 100,
            unit: "metric"
        };
        function qs(t, e, i) {
            const a = i && i.maxWidth || 100, s = t._container.clientHeight / 2, o = t.unproject([
                0,
                s
            ]), r = t.unproject([
                a,
                s
            ]), n = o.distanceTo(r);
            if (i && "imperial" === i.unit) {
                const i = 3.2808 * n;
                i > 5280 ? Vs(e, a, i / 5280, t._getUIString("ScaleControl.Miles")) : Vs(e, a, i, t._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? Vs(e, a, n / 1852, t._getUIString("ScaleControl.NauticalMiles")) : n >= 1e3 ? Vs(e, a, n / 1e3, t._getUIString("ScaleControl.Kilometers")) : Vs(e, a, n, t._getUIString("ScaleControl.Meters"));
        }
        function Vs(t, e, i, a) {
            const s = function(t) {
                const e = Math.pow(10, `${Math.floor(t)}`.length - 1);
                let i = t / e;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(t) {
                    const e = Math.pow(10, Math.ceil(-Math.log(t) / Math.LN10));
                    return Math.round(t * e) / e;
                }(i), e * i;
            }(i);
            t.style.width = e * (s / i) + "px", t.innerHTML = `${s}&nbsp;${a}`;
        }
        const Gs = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            subpixelPositioning: !1
        }, Hs = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Ws(t) {
            if (t) {
                if ("number" == typeof t) {
                    const i = Math.round(Math.abs(t) / Math.SQRT2);
                    return {
                        center: new e.P(0, 0),
                        top: new e.P(0, t),
                        "top-left": new e.P(i, i),
                        "top-right": new e.P(-i, i),
                        bottom: new e.P(0, -t),
                        "bottom-left": new e.P(i, -i),
                        "bottom-right": new e.P(-i, -i),
                        left: new e.P(t, 0),
                        right: new e.P(-t, 0)
                    };
                }
                if (t instanceof e.P || Array.isArray(t)) {
                    const i = e.P.convert(t);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: e.P.convert(t.center || [
                        0,
                        0
                    ]),
                    top: e.P.convert(t.top || [
                        0,
                        0
                    ]),
                    "top-left": e.P.convert(t["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": e.P.convert(t["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: e.P.convert(t.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": e.P.convert(t["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": e.P.convert(t["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: e.P.convert(t.left || [
                        0,
                        0
                    ]),
                    right: e.P.convert(t.right || [
                        0,
                        0
                    ])
                };
            }
            return Ws(new e.P(0, 0));
        }
        const $s = i;
        t.AJAXError = e.bg, t.Evented = e.E, t.LngLat = e.N, t.MercatorCoordinate = e.Z, t.Point = e.P, t.addProtocol = e.bh, t.config = e.a, t.removeProtocol = e.bi, t.AttributionControl = xs, t.BoxZoomHandler = ka, t.CanvasSource = et, t.CooperativeGesturesHandler = ds, t.DoubleClickZoomHandler = rs, t.DragPanHandler = hs, t.DragRotateHandler = cs, t.EdgeInsets = ma, t.FullscreenControl = class extends e.E {
            constructor(t = {}){
                super(), this._onFullscreenChange = ()=>{
                    var t;
                    let e = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                    for(; null === (t = null == e ? void 0 : e.shadowRoot) || void 0 === t ? void 0 : t.fullscreenElement;)e = e.shadowRoot.fullscreenElement;
                    e === this._container !== this._fullscreen && this._handleFullscreenChange();
                }, this._onClickFullscreen = ()=>{
                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                }, this._fullscreen = !1, t && t.container && (t.container instanceof HTMLElement ? this._container = t.container : e.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
            }
            onAdd(t) {
                return this._map = t, this._container || (this._container = this._map.getContainer()), this._controlContainer = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
            }
            onRemove() {
                r.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _setupUI() {
                const t = this._fullscreenButton = r.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                r.create("span", "maplibregl-ctrl-icon", t).setAttribute("aria-hidden", "true"), t.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _updateTitle() {
                const t = this._getTitle();
                this._fullscreenButton.setAttribute("aria-label", t), this._fullscreenButton.title = t;
            }
            _getTitle() {
                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
            _isFullscreen() {
                return this._fullscreen;
            }
            _handleFullscreenChange() {
                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new e.k("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new e.k("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
            }
            _exitFullscreen() {
                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
            }
            _requestFullscreen() {
                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
            }
            _togglePseudoFullScreen() {
                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
            }
        }, t.GeoJSONSource = J, t.GeolocateControl = class extends e.E {
            constructor(t){
                super(), this._onSuccess = (t)=>{
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(t)) return this._setErrorState(), this.fire(new e.k("outofmaxbounds", t)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new e.k("geolocate", t)), this._finish();
                    }
                }, this._updateCamera = (t)=>{
                    const i = new e.N(t.coords.longitude, t.coords.latitude), a = t.coords.accuracy, s = this._map.getBearing(), o = e.e({
                        bearing: s
                    }, this.options.fitBoundsOptions), r = H.fromLngLat(i, a);
                    this._map.fitBounds(r, o, {
                        geolocateSource: !0
                    });
                }, this._updateMarker = (t)=>{
                    if (t) {
                        const i = new e.N(t.coords.longitude, t.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }, this._onZoom = ()=>{
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }, this._onError = (t)=>{
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === t.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const t = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.title = t, this._geolocateButton.setAttribute("aria-label", t), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t.code && Us) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new e.k("error", t)), this._finish();
                    }
                }, this._finish = ()=>{
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }, this._setupUI = ()=>{
                    this._map && (this._container.addEventListener("contextmenu", (t)=>t.preventDefault()), this._geolocateButton = r.create("button", "maplibregl-ctrl-geolocate", this._container), r.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                }, this._finishSetupUI = (t)=>{
                    if (this._map) {
                        if (!1 === t) {
                            e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const t = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.title = t, this._geolocateButton.setAttribute("aria-label", t);
                        } else {
                            const t = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.disabled = !1, this._geolocateButton.title = t, this._geolocateButton.setAttribute("aria-label", t);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = r.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new Os({
                            element: this._dotElement
                        }), this._circleElement = r.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Os({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (t)=>{
                            t.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t.originalEvent && "resize" === t.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new e.k("trackuserlocationend")), this.fire(new e.k("userlocationlostfocus")));
                        });
                    }
                }, this.options = e.e({}, Ns, t);
            }
            onAdd(t) {
                return this._map = t, this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                    return e._(this, arguments, void 0, function*(t = !1) {
                        if (void 0 !== ks && !t) return ks;
                        if (void 0 === window.navigator.permissions) return ks = !!window.navigator.geolocation, ks;
                        try {
                            const t = yield window.navigator.permissions.query({
                                name: "geolocation"
                            });
                            ks = "denied" !== t.state;
                        } catch (t) {
                            ks = !!window.navigator.geolocation;
                        }
                        return ks;
                    });
                })().then((t)=>this._finishSetupUI(t)), this._container;
            }
            onRemove() {
                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), r.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, js = 0, Us = !1;
            }
            _isOutOfMapMaxBounds(t) {
                const e = this._map.getMaxBounds(), i = t.coords;
                return e && (i.longitude < e.getWest() || i.longitude > e.getEast() || i.latitude < e.getSouth() || i.latitude > e.getNorth());
            }
            _setErrorState() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "ACTIVE_ERROR":
                        break;
                    default:
                        throw new Error(`Unexpected watchState ${this._watchState}`);
                }
            }
            _updateCircleRadius() {
                const t = this._map.getBounds(), e = t.getSouthEast(), i = t.getNorthEast(), a = e.distanceTo(i), s = Math.ceil(this._accuracy / (a / this._map._container.clientHeight) * 2);
                this._circleElement.style.width = `${s}px`, this._circleElement.style.height = `${s}px`;
            }
            trigger() {
                if (!this._setup) return e.w("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new e.k("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            js--, Us = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new e.k("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.k("trackuserlocationstart")), this.fire(new e.k("userlocationfocus"));
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "OFF":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        let t;
                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), js++, js > 1 ? (t = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, Us = !0) : (t = this.options.positionOptions, Us = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, t);
                    }
                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }
            _clearWatch() {
                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
        }, t.Hash = xa, t.ImageSource = Q, t.KeyboardHandler = is, t.LngLatBounds = H, t.LogoControl = ys, t.Map = class extends gs {
            constructor(t){
                e.be.mark(e.bf.create);
                const i = Object.assign(Object.assign({}, Ds), t);
                if (null != i.minZoom && null != i.maxZoom && i.minZoom > i.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != i.minPitch && null != i.maxPitch && i.minPitch > i.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != i.minPitch && i.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != i.maxPitch && i.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                if (super(new ga(i.minZoom, i.maxZoom, i.minPitch, i.maxPitch, i.renderWorldCopies), {
                    bearingSnap: i.bearingSnap
                }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new bs, this._controls = [], this._mapId = e.a4(), this._contextLost = (t)=>{
                    t.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.fire(new e.k("webglcontextlost", {
                        originalEvent: t
                    }));
                }, this._contextRestored = (t)=>{
                    this._setupPainter(), this.resize(), this._update(), this.fire(new e.k("webglcontextrestored", {
                        originalEvent: t
                    }));
                }, this._onMapScroll = (t)=>{
                    if (t.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }, this._onWindowOnline = ()=>{
                    this._update();
                }, this._interactive = i.interactive, this._maxTileCacheSize = i.maxTileCacheSize, this._maxTileCacheZoomLevels = i.maxTileCacheZoomLevels, this._failIfMajorPerformanceCaveat = !0 === i.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = !0 === i.preserveDrawingBuffer, this._antialias = !0 === i.antialias, this._trackResize = !0 === i.trackResize, this._bearingSnap = i.bearingSnap, this._refreshExpiredTiles = !0 === i.refreshExpiredTiles, this._fadeDuration = i.fadeDuration, this._crossSourceCollisions = !0 === i.crossSourceCollisions, this._collectResourceTiming = !0 === i.collectResourceTiming, this._locale = Object.assign(Object.assign({}, Ss), i.locale), this._clickTolerance = i.clickTolerance, this._overridePixelRatio = i.pixelRatio, this._maxCanvasSize = i.maxCanvasSize, this.transformCameraUpdate = i.transformCameraUpdate, this.cancelPendingTileRequestsWhileZooming = !0 === i.cancelPendingTileRequestsWhileZooming, this._imageQueueHandle = _.addThrottleControl(()=>this.isMoving()), this._requestManager = new p(i.transformRequest), "string" == typeof i.container) {
                    if (this._container = document.getElementById(i.container), !this._container) throw new Error(`Container '${i.container}' not found.`);
                } else {
                    if (!(i.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    this._container = i.container;
                }
                if (i.maxBounds && this.setMaxBounds(i.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)).on("moveend", ()=>this._update(!1)).on("zoom", ()=>this._update(!0)).on("terrain", ()=>{
                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                }).once("idle", ()=>{
                    this._idleTriggered = !0;
                }), "undefined" != typeof window) {
                    addEventListener("online", this._onWindowOnline, !1);
                    let t = !1;
                    const e = va((t)=>{
                        this._trackResize && !this._removed && this.resize(t)._update();
                    }, 50);
                    this._resizeObserver = new ResizeObserver((i)=>{
                        t ? e(i) : t = !0;
                    }), this._resizeObserver.observe(this._container);
                }
                this.handlers = new fs(this, i), this._hash = i.hash && new xa("string" == typeof i.hash && i.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                    center: i.center,
                    zoom: i.zoom,
                    bearing: i.bearing,
                    pitch: i.pitch
                }), i.bounds && (this.resize(), this.fitBounds(i.bounds, e.e({}, i.fitBoundsOptions, {
                    duration: 0
                })))), this.resize(), this._localIdeographFontFamily = i.localIdeographFontFamily, this._validateStyle = i.validateStyle, i.style && this.setStyle(i.style, {
                    localIdeographFontFamily: i.localIdeographFontFamily
                }), i.attributionControl && this.addControl(new xs("boolean" == typeof i.attributionControl ? void 0 : i.attributionControl)), i.maplibreLogo && this.addControl(new ys, i.logoPosition), this.on("style.load", ()=>{
                    this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                }), this.on("data", (t)=>{
                    this._update("style" === t.dataType), this.fire(new e.k(`${t.dataType}data`, t));
                }), this.on("dataloading", (t)=>{
                    this.fire(new e.k(`${t.dataType}dataloading`, t));
                }), this.on("dataabort", (t)=>{
                    this.fire(new e.k("sourcedataabort", t));
                });
            }
            _getMapId() {
                return this._mapId;
            }
            addControl(t, i) {
                if (void 0 === i && (i = t.getDefaultPosition ? t.getDefaultPosition() : "top-right"), !t || !t.onAdd) return this.fire(new e.j(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                const a = t.onAdd(this);
                this._controls.push(t);
                const s = this._controlPositions[i];
                return -1 !== i.indexOf("bottom") ? s.insertBefore(a, s.firstChild) : s.appendChild(a), this;
            }
            removeControl(t) {
                if (!t || !t.onRemove) return this.fire(new e.j(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                const i = this._controls.indexOf(t);
                return i > -1 && this._controls.splice(i, 1), t.onRemove(this), this;
            }
            hasControl(t) {
                return this._controls.indexOf(t) > -1;
            }
            calculateCameraOptionsFromTo(t, e, i, a) {
                return null == a && this.terrain && (a = this.terrain.getElevationForLngLatZoom(i, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(t, e, i, a);
            }
            resize(t) {
                var i;
                const a = this._containerDimensions(), s = a[0], o = a[1], r = this._getClampedPixelRatio(s, o);
                if (this._resizeCanvas(s, o, r), this.painter.resize(s, o, r), this.painter.overLimit()) {
                    const t = this.painter.context.gl;
                    this._maxCanvasSize = [
                        t.drawingBufferWidth,
                        t.drawingBufferHeight
                    ];
                    const e = this._getClampedPixelRatio(s, o);
                    this._resizeCanvas(s, o, e), this.painter.resize(s, o, e);
                }
                this.transform.resize(s, o), null === (i = this._requestedCameraState) || void 0 === i || i.resize(s, o);
                const n = !this._moving;
                return n && (this.stop(), this.fire(new e.k("movestart", t)).fire(new e.k("move", t))), this.fire(new e.k("resize", t)), n && this.fire(new e.k("moveend", t)), this;
            }
            _getClampedPixelRatio(t, e) {
                const { 0: i, 1: a } = this._maxCanvasSize, s = this.getPixelRatio(), o = t * s, r = e * s;
                return Math.min(o > i ? i / o : 1, r > a ? a / r : 1) * s;
            }
            getPixelRatio() {
                var t;
                return null !== (t = this._overridePixelRatio) && void 0 !== t ? t : devicePixelRatio;
            }
            setPixelRatio(t) {
                this._overridePixelRatio = t, this.resize();
            }
            getBounds() {
                return this.transform.getBounds();
            }
            getMaxBounds() {
                return this.transform.getMaxBounds();
            }
            setMaxBounds(t) {
                return this.transform.setMaxBounds(H.convert(t)), this._update();
            }
            setMinZoom(t) {
                if ((t = null == t ? -2 : t) >= -2 && t <= this.transform.maxZoom) return this.transform.minZoom = t, this._update(), this.getZoom() < t && this.setZoom(t), this;
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
            getMinZoom() {
                return this.transform.minZoom;
            }
            setMaxZoom(t) {
                if ((t = null == t ? 22 : t) >= this.transform.minZoom) return this.transform.maxZoom = t, this._update(), this.getZoom() > t && this.setZoom(t), this;
                throw new Error("maxZoom must be greater than the current minZoom");
            }
            getMaxZoom() {
                return this.transform.maxZoom;
            }
            setMinPitch(t) {
                if ((t = null == t ? 0 : t) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (t >= 0 && t <= this.transform.maxPitch) return this.transform.minPitch = t, this._update(), this.getPitch() < t && this.setPitch(t), this;
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
            getMinPitch() {
                return this.transform.minPitch;
            }
            setMaxPitch(t) {
                if ((t = null == t ? 60 : t) > 85) throw new Error("maxPitch must be less than or equal to 85");
                if (t >= this.transform.minPitch) return this.transform.maxPitch = t, this._update(), this.getPitch() > t && this.setPitch(t), this;
                throw new Error("maxPitch must be greater than the current minPitch");
            }
            getMaxPitch() {
                return this.transform.maxPitch;
            }
            getRenderWorldCopies() {
                return this.transform.renderWorldCopies;
            }
            setRenderWorldCopies(t) {
                return this.transform.renderWorldCopies = t, this._update();
            }
            project(t) {
                return this.transform.locationPoint(e.N.convert(t), this.style && this.terrain);
            }
            unproject(t) {
                return this.transform.pointLocation(e.P.convert(t), this.terrain);
            }
            isMoving() {
                var t;
                return this._moving || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isMoving());
            }
            isZooming() {
                var t;
                return this._zooming || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isZooming());
            }
            isRotating() {
                var t;
                return this._rotating || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isRotating());
            }
            _createDelegatedListener(t, e, i) {
                if ("mouseenter" === t || "mouseover" === t) {
                    let a = !1;
                    const s = (s)=>{
                        const o = this.getLayer(e) ? this.queryRenderedFeatures(s.point, {
                            layers: [
                                e
                            ]
                        }) : [];
                        o.length ? a || (a = !0, i.call(this, new Sa(t, this, s.originalEvent, {
                            features: o
                        }))) : a = !1;
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            mousemove: s,
                            mouseout: ()=>{
                                a = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === t || "mouseout" === t) {
                    let a = !1;
                    const s = (s)=>{
                        (this.getLayer(e) ? this.queryRenderedFeatures(s.point, {
                            layers: [
                                e
                            ]
                        }) : []).length ? a = !0 : a && (a = !1, i.call(this, new Sa(t, this, s.originalEvent)));
                    }, o = (e)=>{
                        a && (a = !1, i.call(this, new Sa(t, this, e.originalEvent)));
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            mousemove: s,
                            mouseout: o
                        }
                    };
                }
                {
                    const a = (t)=>{
                        const a = this.getLayer(e) ? this.queryRenderedFeatures(t.point, {
                            layers: [
                                e
                            ]
                        }) : [];
                        a.length && (t.features = a, i.call(this, t), delete t.features);
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            [t]: a
                        }
                    };
                }
            }
            on(t, e, i) {
                if (void 0 === i) return super.on(t, e);
                const a = this._createDelegatedListener(t, e, i);
                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t] = this._delegatedListeners[t] || [], this._delegatedListeners[t].push(a);
                for(const t in a.delegates)this.on(t, a.delegates[t]);
                return this;
            }
            once(t, e, i) {
                if (void 0 === i) return super.once(t, e);
                const a = this._createDelegatedListener(t, e, i);
                for(const t in a.delegates)this.once(t, a.delegates[t]);
                return this;
            }
            off(t, e, i) {
                return void 0 === i ? super.off(t, e) : (this._delegatedListeners && this._delegatedListeners[t] && ((a)=>{
                    const s = this._delegatedListeners[t];
                    for(let t = 0; t < s.length; t++){
                        const a = s[t];
                        if (a.layer === e && a.listener === i) {
                            for(const t in a.delegates)this.off(t, a.delegates[t]);
                            return s.splice(t, 1), this;
                        }
                    }
                })(), this);
            }
            queryRenderedFeatures(t, i) {
                if (!this.style) return [];
                let a;
                const s = t instanceof e.P || Array.isArray(t), o = s ? t : [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ];
                if (i = i || (s ? {} : t) || {}, o instanceof e.P || "number" == typeof o[0]) a = [
                    e.P.convert(o)
                ];
                else {
                    const t = e.P.convert(o[0]), i = e.P.convert(o[1]);
                    a = [
                        t,
                        new e.P(i.x, t.y),
                        i,
                        new e.P(t.x, i.y),
                        t
                    ];
                }
                return this.style.queryRenderedFeatures(a, i, this.transform);
            }
            querySourceFeatures(t, e) {
                return this.style.querySourceFeatures(t, e);
            }
            setStyle(t, i) {
                return !1 !== (i = e.e({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily,
                    validate: this._validateStyle
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && t ? (this._diffStyle(t, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(t, i));
            }
            setTransformRequest(t) {
                return this._requestManager.setTransformRequest(t), this;
            }
            _getUIString(t) {
                const e = this._locale[t];
                if (null == e) throw new Error(`Missing UI string '${t}'`);
                return e;
            }
            _updateStyle(t, e) {
                if (e.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(t, e));
                const i = this.style && e.transformStyle ? this.style.serialize() : void 0;
                return this.style && (this.style.setEventedParent(null), this.style._remove(!t)), t ? (this.style = new ue(this, e || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof t ? this.style.loadURL(t, e, i) : this.style.loadJSON(t, e, i), this) : (delete this.style, this);
            }
            _lazyInitEmptyStyle() {
                this.style || (this.style = new ue(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }
            _diffStyle(t, i) {
                if ("string" == typeof t) {
                    const a = this._requestManager.transformRequest(t, "Style");
                    e.h(a, new AbortController).then((t)=>{
                        this._updateDiff(t.data, i);
                    }).catch((t)=>{
                        t && this.fire(new e.j(t));
                    });
                } else "object" == typeof t && this._updateDiff(t, i);
            }
            _updateDiff(t, i) {
                try {
                    this.style.setState(t, i) && this._update(!0);
                } catch (a) {
                    e.w(`Unable to perform style diff: ${a.message || a.error || a}.  Rebuilding the style from scratch.`), this._updateStyle(t, i);
                }
            }
            getStyle() {
                if (this.style) return this.style.serialize();
            }
            isStyleLoaded() {
                return this.style ? this.style.loaded() : e.w("There is no style added to the map.");
            }
            addSource(t, e) {
                return this._lazyInitEmptyStyle(), this.style.addSource(t, e), this._update(!0);
            }
            isSourceLoaded(t) {
                const i = this.style && this.style.sourceCaches[t];
                if (void 0 !== i) return i.loaded();
                this.fire(new e.j(new Error(`There is no source with ID '${t}'`)));
            }
            setTerrain(t) {
                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), t) {
                    const i = this.style.sourceCaches[t.source];
                    if (!i) throw new Error(`cannot load terrain, because there exists no source with ID: ${t.source}`);
                    null === this.terrain && i.reload();
                    for(const i in this.style._layers){
                        const a = this.style._layers[i];
                        "hillshade" === a.type && a.source === t.source && e.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                    }
                    this.terrain = new Is(this.painter, i, t), this.painter.renderToTexture = new Cs(this.painter, this.terrain), this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._terrainDataCallback = (e)=>{
                        "style" === e.dataType ? this.terrain.sourceCache.freeRtt() : "source" === e.dataType && e.tile && (e.sourceId !== t.source || this._elevationFreeze || (this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.terrain.sourceCache.freeRtt(e.tile.tileID));
                    }, this.style.on("data", this._terrainDataCallback);
                } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.minElevationForCurrentTile = 0, this.transform.elevation = 0;
                return this.fire(new e.k("terrain", {
                    terrain: t
                })), this;
            }
            getTerrain() {
                var t, e;
                return null !== (e = null === (t = this.terrain) || void 0 === t ? void 0 : t.options) && void 0 !== e ? e : null;
            }
            areTilesLoaded() {
                const t = this.style && this.style.sourceCaches;
                for(const e in t){
                    const i = t[e]._tiles;
                    for(const t in i){
                        const e = i[t];
                        if ("loaded" !== e.state && "errored" !== e.state) return !1;
                    }
                }
                return !0;
            }
            removeSource(t) {
                return this.style.removeSource(t), this._update(!0);
            }
            getSource(t) {
                return this.style.getSource(t);
            }
            addImage(t, i, a = {}) {
                const { pixelRatio: s = 1, sdf: r = !1, stretchX: n, stretchY: l, content: h, textFitWidth: c, textFitHeight: u } = a;
                if (this._lazyInitEmptyStyle(), !(i instanceof HTMLImageElement || e.b(i))) {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new e.j(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    {
                        const { width: a, height: o, data: d } = i, _ = i;
                        return this.style.addImage(t, {
                            data: new e.R({
                                width: a,
                                height: o
                            }, new Uint8Array(d)),
                            pixelRatio: s,
                            stretchX: n,
                            stretchY: l,
                            content: h,
                            textFitWidth: c,
                            textFitHeight: u,
                            sdf: r,
                            version: 0,
                            userImage: _
                        }), _.onAdd && _.onAdd(this, t), this;
                    }
                }
                {
                    const { width: a, height: d, data: _ } = o.getImageData(i);
                    this.style.addImage(t, {
                        data: new e.R({
                            width: a,
                            height: d
                        }, _),
                        pixelRatio: s,
                        stretchX: n,
                        stretchY: l,
                        content: h,
                        textFitWidth: c,
                        textFitHeight: u,
                        sdf: r,
                        version: 0
                    });
                }
            }
            updateImage(t, i) {
                const a = this.style.getImage(t);
                if (!a) return this.fire(new e.j(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                const s = i instanceof HTMLImageElement || e.b(i) ? o.getImageData(i) : i, { width: r, height: n, data: l } = s;
                if (void 0 === r || void 0 === n) return this.fire(new e.j(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                if (r !== a.data.width || n !== a.data.height) return this.fire(new e.j(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                const h = !(i instanceof HTMLImageElement || e.b(i));
                return a.data.replace(l, h), this.style.updateImage(t, a), this;
            }
            getImage(t) {
                return this.style.getImage(t);
            }
            hasImage(t) {
                return t ? !!this.style.getImage(t) : (this.fire(new e.j(new Error("Missing required image id"))), !1);
            }
            removeImage(t) {
                this.style.removeImage(t);
            }
            loadImage(t) {
                return _.getImage(this._requestManager.transformRequest(t, "Image"), new AbortController);
            }
            listImages() {
                return this.style.listImages();
            }
            addLayer(t, e) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(t, e), this._update(!0);
            }
            moveLayer(t, e) {
                return this.style.moveLayer(t, e), this._update(!0);
            }
            removeLayer(t) {
                return this.style.removeLayer(t), this._update(!0);
            }
            getLayer(t) {
                return this.style.getLayer(t);
            }
            getLayersOrder() {
                return this.style.getLayersOrder();
            }
            setLayerZoomRange(t, e, i) {
                return this.style.setLayerZoomRange(t, e, i), this._update(!0);
            }
            setFilter(t, e, i = {}) {
                return this.style.setFilter(t, e, i), this._update(!0);
            }
            getFilter(t) {
                return this.style.getFilter(t);
            }
            setPaintProperty(t, e, i, a = {}) {
                return this.style.setPaintProperty(t, e, i, a), this._update(!0);
            }
            getPaintProperty(t, e) {
                return this.style.getPaintProperty(t, e);
            }
            setLayoutProperty(t, e, i, a = {}) {
                return this.style.setLayoutProperty(t, e, i, a), this._update(!0);
            }
            getLayoutProperty(t, e) {
                return this.style.getLayoutProperty(t, e);
            }
            setGlyphs(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setGlyphs(t, e), this._update(!0);
            }
            getGlyphs() {
                return this.style.getGlyphsUrl();
            }
            addSprite(t, e, i = {}) {
                return this._lazyInitEmptyStyle(), this.style.addSprite(t, e, i, (t)=>{
                    t || this._update(!0);
                }), this;
            }
            removeSprite(t) {
                return this._lazyInitEmptyStyle(), this.style.removeSprite(t), this._update(!0);
            }
            getSprite() {
                return this.style.getSprite();
            }
            setSprite(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSprite(t, e, (t)=>{
                    t || this._update(!0);
                }), this;
            }
            setLight(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setLight(t, e), this._update(!0);
            }
            getLight() {
                return this.style.getLight();
            }
            setSky(t) {
                return this._lazyInitEmptyStyle(), this.style.setSky(t), this._update(!0);
            }
            getSky() {
                return this.style.getSky();
            }
            setFeatureState(t, e) {
                return this.style.setFeatureState(t, e), this._update();
            }
            removeFeatureState(t, e) {
                return this.style.removeFeatureState(t, e), this._update();
            }
            getFeatureState(t) {
                return this.style.getFeatureState(t);
            }
            getContainer() {
                return this._container;
            }
            getCanvasContainer() {
                return this._canvasContainer;
            }
            getCanvas() {
                return this._canvas;
            }
            _containerDimensions() {
                let t = 0, e = 0;
                return this._container && (t = this._container.clientWidth || 400, e = this._container.clientHeight || 300), [
                    t,
                    e
                ];
            }
            _setupContainer() {
                const t = this._container;
                t.classList.add("maplibregl-map");
                const e = this._canvasContainer = r.create("div", "maplibregl-canvas-container", t);
                this._interactive && e.classList.add("maplibregl-interactive"), this._canvas = r.create("canvas", "maplibregl-canvas", e), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                const i = this._containerDimensions(), a = this._getClampedPixelRatio(i[0], i[1]);
                this._resizeCanvas(i[0], i[1], a);
                const s = this._controlContainer = r.create("div", "maplibregl-control-container", t), o = this._controlPositions = {};
                [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ].forEach((t)=>{
                    o[t] = r.create("div", `maplibregl-ctrl-${t} `, s);
                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }
            _resizeCanvas(t, e, i) {
                this._canvas.width = Math.floor(i * t), this._canvas.height = Math.floor(i * e), this._canvas.style.width = `${t}px`, this._canvas.style.height = `${e}px`;
            }
            _setupPainter() {
                const t = {
                    alpha: !0,
                    stencil: !0,
                    depth: !0,
                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                    antialias: this._antialias || !1
                };
                let e = null;
                this._canvas.addEventListener("webglcontextcreationerror", (i)=>{
                    e = {
                        requestedAttributes: t
                    }, i && (e.statusMessage = i.statusMessage, e.type = i.type);
                }, {
                    once: !0
                });
                const i = this._canvas.getContext("webgl2", t) || this._canvas.getContext("webgl", t);
                if (!i) {
                    const t = "Failed to initialize WebGL";
                    throw e ? (e.message = t, new Error(JSON.stringify(e))) : new Error(t);
                }
                this.painter = new da(i, this.transform), n.testSupport(i);
            }
            loaded() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
            _update(t) {
                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || t, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }
            _requestRenderFrame(t) {
                return this._update(), this._renderTaskQueue.add(t);
            }
            _cancelRenderFrame(t) {
                this._renderTaskQueue.remove(t);
            }
            _render(t) {
                const i = this._idleTriggered ? this._fadeDuration : 0;
                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(t), this._removed) return;
                let a = !1;
                if (this.style && this._styleDirty) {
                    this._styleDirty = !1;
                    const t = this.transform.zoom, s = o.now();
                    this.style.zoomHistory.update(t, s);
                    const r = new e.z(t, {
                        now: s,
                        fadeDuration: i,
                        zoomHistory: this.style.zoomHistory,
                        transition: this.style.getTransition()
                    }), n = r.crossFadingFactor();
                    1 === n && n === this._crossFadingFactor || (a = !0, this._crossFadingFactor = n), this.style.update(r);
                }
                this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.sourceCache.update(this.transform, this.terrain), this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._elevationFreeze || (this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.minElevationForCurrentTile = 0, this.transform.elevation = 0), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, i, this._crossSourceCollisions), this.painter.render(this.style, {
                    showTileBoundaries: this.showTileBoundaries,
                    showOverdrawInspector: this._showOverdrawInspector,
                    rotating: this.isRotating(),
                    zooming: this.isZooming(),
                    moving: this.isMoving(),
                    fadeDuration: i,
                    showPadding: this.showPadding
                }), this.fire(new e.k("render")), this.loaded() && !this._loaded && (this._loaded = !0, e.be.mark(e.bf.load), this.fire(new e.k("load"))), this.style && (this.style.hasTransitions() || a) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                const s = this._sourcesDirty || this._styleDirty || this._placementDirty;
                return s || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new e.k("idle")), !this._loaded || this._fullyLoaded || s || (this._fullyLoaded = !0, e.be.mark(e.bf.fullLoad)), this;
            }
            redraw() {
                return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
            }
            remove() {
                var t;
                this._hash && this._hash.remove();
                for (const t of this._controls)t.onRemove(this);
                this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), _.removeThrottleControl(this._imageQueueHandle), null === (t = this._resizeObserver) || void 0 === t || t.disconnect();
                const i = this.painter.context.gl.getExtension("WEBGL_lose_context");
                (null == i ? void 0 : i.loseContext) && i.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), r.remove(this._canvasContainer), r.remove(this._controlContainer), this._container.classList.remove("maplibregl-map"), e.be.clearMetrics(), this._removed = !0, this.fire(new e.k("remove"));
            }
            triggerRepaint() {
                this.style && !this._frameRequest && (this._frameRequest = new AbortController, o.frameAsync(this._frameRequest).then((t)=>{
                    e.be.frame(t), this._frameRequest = null, this._render(t);
                }).catch(()=>{}));
            }
            get showTileBoundaries() {
                return !!this._showTileBoundaries;
            }
            set showTileBoundaries(t) {
                this._showTileBoundaries !== t && (this._showTileBoundaries = t, this._update());
            }
            get showPadding() {
                return !!this._showPadding;
            }
            set showPadding(t) {
                this._showPadding !== t && (this._showPadding = t, this._update());
            }
            get showCollisionBoxes() {
                return !!this._showCollisionBoxes;
            }
            set showCollisionBoxes(t) {
                this._showCollisionBoxes !== t && (this._showCollisionBoxes = t, t ? this.style._generateCollisionBoxes() : this._update());
            }
            get showOverdrawInspector() {
                return !!this._showOverdrawInspector;
            }
            set showOverdrawInspector(t) {
                this._showOverdrawInspector !== t && (this._showOverdrawInspector = t, this._update());
            }
            get repaint() {
                return !!this._repaint;
            }
            set repaint(t) {
                this._repaint !== t && (this._repaint = t, this.triggerRepaint());
            }
            get vertices() {
                return !!this._vertices;
            }
            set vertices(t) {
                this._vertices = t, this._update();
            }
            get version() {
                return zs;
            }
            getCameraTargetElevation() {
                return this.transform.elevation;
            }
        }, t.MapMouseEvent = Sa, t.MapTouchEvent = za, t.MapWheelEvent = Da, t.Marker = Os, t.NavigationControl = class {
            constructor(t){
                this._updateZoomButtons = ()=>{
                    const t = this._map.getZoom(), e = t === this._map.getMaxZoom(), i = t === this._map.getMinZoom();
                    this._zoomInButton.disabled = e, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", e.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }, this._rotateCompassArrow = ()=>{
                    const t = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
                    this._compassIcon.style.transform = t;
                }, this._setButtonTitle = (t, e)=>{
                    const i = this._map._getUIString(`NavigationControl.${e}`);
                    t.title = i, t.setAttribute("aria-label", i);
                }, this.options = e.e({}, As, t), this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (t)=>t.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (t)=>this._map.zoomIn({}, {
                        originalEvent: t
                    })), r.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (t)=>this._map.zoomOut({}, {
                        originalEvent: t
                    })), r.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (t)=>{
                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                        originalEvent: t
                    }) : this._map.resetNorth({}, {
                        originalEvent: t
                    });
                }), this._compassIcon = r.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            onAdd(t) {
                return this._map = t, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Rs(this._map, this._compass, this.options.visualizePitch)), this._container;
            }
            onRemove() {
                r.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
            }
            _createButton(t, e) {
                const i = r.create("button", t, this._container);
                return i.type = "button", i.addEventListener("click", e), i;
            }
        }, t.Popup = class extends e.E {
            constructor(t){
                super(), this.remove = ()=>(this._content && r.remove(this._content), this._container && (r.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new e.k("close"))), this), this._onMouseUp = (t)=>{
                    this._update(t.point);
                }, this._onMouseMove = (t)=>{
                    this._update(t.point);
                }, this._onDrag = (t)=>{
                    this._update(t.point);
                }, this._update = (t)=>{
                    var e;
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (!this._container) {
                        if (this._container = r.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = r.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const t of this.options.className.split(" "))this._container.classList.add(t);
                        this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                    }
                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = this._map.transform.renderWorldCopies && !this._trackPointer ? Ls(this._lngLat, this._flatPos, this._map.transform) : null === (e = this._lngLat) || void 0 === e ? void 0 : e.wrap(), this._trackPointer && !t) return;
                    const i = this._flatPos = this._pos = this._trackPointer && t ? t : this._map.project(this._lngLat);
                    this._map.terrain && (this._flatPos = this._trackPointer && t ? t : this._map.transform.locationPoint(this._lngLat));
                    let a = this.options.anchor;
                    const s = Ws(this.options.offset);
                    if (!a) {
                        const t = this._container.offsetWidth, e = this._container.offsetHeight;
                        let o;
                        o = i.y + s.bottom.y < e ? [
                            "top"
                        ] : i.y > this._map.transform.height - e ? [
                            "bottom"
                        ] : [], i.x < t / 2 ? o.push("left") : i.x > this._map.transform.width - t / 2 && o.push("right"), a = 0 === o.length ? "bottom" : o.join("-");
                    }
                    let o = i.add(s[a]);
                    this.options.subpixelPositioning || (o = o.round()), r.setTransform(this._container, `${Fs[a]} translate(${o.x}px,${o.y}px)`), Bs(this._container, a, "popup");
                }, this._onClose = ()=>{
                    this.remove();
                }, this.options = e.e(Object.create(Gs), t);
            }
            addTo(t) {
                return this._map && this.remove(), this._map = t, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new e.k("open")), this;
            }
            isOpen() {
                return !!this._map;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t) {
                return this._lngLat = e.N.convert(t), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
            }
            trackPointer() {
                return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
            }
            getElement() {
                return this._container;
            }
            setText(t) {
                return this.setDOMContent(document.createTextNode(t));
            }
            setHTML(t) {
                const e = document.createDocumentFragment(), i = document.createElement("body");
                let a;
                for(i.innerHTML = t; a = i.firstChild, a;)e.appendChild(a);
                return this.setDOMContent(e);
            }
            getMaxWidth() {
                var t;
                return null === (t = this._container) || void 0 === t ? void 0 : t.style.maxWidth;
            }
            setMaxWidth(t) {
                return this.options.maxWidth = t, this._update(), this;
            }
            setDOMContent(t) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = r.create("div", "maplibregl-popup-content", this._container);
                return this._content.appendChild(t), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }
            addClassName(t) {
                return this._container && this._container.classList.add(t), this;
            }
            removeClassName(t) {
                return this._container && this._container.classList.remove(t), this;
            }
            setOffset(t) {
                return this.options.offset = t, this._update(), this;
            }
            toggleClassName(t) {
                if (this._container) return this._container.classList.toggle(t);
            }
            setSubpixelPositioning(t) {
                this.options.subpixelPositioning = t;
            }
            _createCloseButton() {
                this.options.closeButton && (this._closeButton = r.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }
            _focusFirstElement() {
                if (!this.options.focusAfterOpen || !this._container) return;
                const t = this._container.querySelector(Hs);
                t && t.focus();
            }
        }, t.RasterDEMTileSource = K, t.RasterTileSource = X, t.ScaleControl = class {
            constructor(t){
                this._onMove = ()=>{
                    qs(this._map, this._container, this.options);
                }, this.setUnit = (t)=>{
                    this.options.unit = t, qs(this._map, this._container, this.options);
                }, this.options = Object.assign(Object.assign({}, Zs), t);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t) {
                return this._map = t, this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", t.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
            }
            onRemove() {
                r.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
            }
        }, t.ScrollZoomHandler = os, t.Style = ue, t.TerrainControl = class {
            constructor(t){
                this._toggleTerrain = ()=>{
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }, this._updateTerrainIcon = ()=>{
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                }, this.options = t;
            }
            onAdd(t) {
                return this._map = t, this._container = r.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = r.create("button", "maplibregl-ctrl-terrain", this._container), r.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
            }
            onRemove() {
                r.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
            }
        }, t.TwoFingersTouchPitchHandler = ts, t.TwoFingersTouchRotateHandler = Ya, t.TwoFingersTouchZoomHandler = Ka, t.TwoFingersTouchZoomRotateHandler = us, t.VectorTileSource = $, t.VideoSource = tt, t.addSourceType = (t, i)=>e._(void 0, void 0, void 0, function*() {
                if (at(t)) throw new Error(`A source type called "${t}" already exists.`);
                ((t, e)=>{
                    it[t] = e;
                })(t, i);
            }), t.clearPrewarmedResources = function() {
            const t = B;
            t && (t.isPreloaded() && 1 === t.numActive() ? (t.release(k), B = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, t.getMaxParallelImageRequests = function() {
            return e.a.MAX_PARALLEL_IMAGE_REQUESTS;
        }, t.getRTLTextPluginStatus = function() {
            return nt().getRTLTextPluginStatus();
        }, t.getVersion = function() {
            return $s;
        }, t.getWorkerCount = function() {
            return L.workerCount;
        }, t.getWorkerUrl = function() {
            return e.a.WORKER_URL;
        }, t.importScriptInWorkers = function(t) {
            return U().broadcast("IS", t);
        }, t.prewarm = function() {
            N().acquire(k);
        }, t.setMaxParallelImageRequests = function(t) {
            e.a.MAX_PARALLEL_IMAGE_REQUESTS = t;
        }, t.setRTLTextPlugin = function(t, e) {
            return nt().setRTLTextPlugin(t, e);
        }, t.setWorkerCount = function(t) {
            L.workerCount = t;
        }, t.setWorkerUrl = function(t) {
            e.a.WORKER_URL = t;
        };
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});


// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: "text/javascript"
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err["code"] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$i32 = Int32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a.b, $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b.b, $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $461bf5d8bd29e0d8$var$u8(v.subarray(s, e));
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $461bf5d8bd29e0d8$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $461bf5d8bd29e0d8$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $461bf5d8bd29e0d8$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $461bf5d8bd29e0d8$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, sym >> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
            var dst = sym & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, sym >> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
        } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $461bf5d8bd29e0d8$var$u16(32768), head = st.h || new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $461bf5d8bd29e0d8$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf("[") + 1, st.lastIndexOf("]")).replace(/\s+/g, "").split(",");
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == "function") {
            fnStr += ";" + k + "=";
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf("[native code]") != -1) {
                    var spInd = st_1.indexOf(" ", 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf("(", spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ";" + k + ".prototype." + t + "=" + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = "", td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1);
        $461bf5d8bd29e0d8$var$ch[id] = {
            c: $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id].e);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id].c + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + init.toString() + "}", id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gopt
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zls
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $461bf5d8bd29e0d8$var$gopt = function(o) {
    return o && {
        out: o.size && new $461bf5d8bd29e0d8$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, "invalid gzip data");
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $461bf5d8bd29e0d8$var$adler();
        h.p(o.dictionary);
        $461bf5d8bd29e0d8$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $461bf5d8bd29e0d8$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, "invalid zlib data");
    if ((d[1] >> 5 & 1) == +!dict) $461bf5d8bd29e0d8$var$err(6, "invalid zlib data: " + (d[1] & 32 ? "need" : "unexpected") + " dictionary");
    return (d[1] >> 3 & 4) + 2;
};
function $461bf5d8bd29e0d8$var$StrmOpt(opts, cb) {
    if (typeof opts == "function") cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == "function") cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $461bf5d8bd29e0d8$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $461bf5d8bd29e0d8$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == "function") cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $461bf5d8bd29e0d8$var$u8(32768);
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.s, this.o);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $461bf5d8bd29e0d8$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $461bf5d8bd29e0d8$var$u8(0);
            this.push(new $461bf5d8bd29e0d8$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) {
    var st = $461bf5d8bd29e0d8$var$gzs(data);
    if (st + 8 > data.length) $461bf5d8bd29e0d8$var$err(6, "invalid gzip data");
    return $461bf5d8bd29e0d8$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($461bf5d8bd29e0d8$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, "invalid zlib data");
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += "/"] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != "undefined" && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != "undefined" && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = "", i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $461bf5d8bd29e0d8$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = "";
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $461bf5d8bd29e0d8$var$err(8);
        return s;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, "", r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, "", r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, "unknown compression type " + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == "function" ? queueMicrotask : typeof setTimeout == "function" ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
                o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, {
                            out: new $461bf5d8bd29e0d8$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, "unknown compression type " + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $461bf5d8bd29e0d8$var$u8(su)
            });
            else $461bf5d8bd29e0d8$var$err(14, "unknown compression type " + c_2);
        }
    }
    return files;
}




const $3e9250cdc5ab47c1$export$fba63a578e423eb = (n, shift)=>{
    return n * 2 ** shift;
};
const $3e9250cdc5ab47c1$export$37cdb546b806ae87 = (n, shift)=>{
    return Math.floor(n / 2 ** shift);
};
const $3e9250cdc5ab47c1$export$32b2c839ee319ab6 = (view, pos)=>{
    return $3e9250cdc5ab47c1$export$fba63a578e423eb(view.getUint16(pos + 1, true), 8) + view.getUint8(pos);
};
const $3e9250cdc5ab47c1$export$6c733861f07a5da7 = (view, pos)=>{
    return $3e9250cdc5ab47c1$export$fba63a578e423eb(view.getUint32(pos + 2, true), 16) + view.getUint16(pos, true);
};
const $3e9250cdc5ab47c1$var$compare = (tz, tx, ty, view, i)=>{
    if (tz !== view.getUint8(i)) return tz - view.getUint8(i);
    const x = $3e9250cdc5ab47c1$export$32b2c839ee319ab6(view, i + 1);
    if (tx !== x) return tx - x;
    const y = $3e9250cdc5ab47c1$export$32b2c839ee319ab6(view, i + 4);
    if (ty !== y) return ty - y;
    return 0;
};
const $3e9250cdc5ab47c1$export$dc5dd5235b829b37 = (view, z, x, y)=>{
    const offsetLen = $3e9250cdc5ab47c1$var$queryView(view, z | 0x80, x, y);
    if (offsetLen) return {
        z: z,
        x: x,
        y: y,
        offset: offsetLen[0],
        length: offsetLen[1],
        isDir: true
    };
    return null;
};
const $3e9250cdc5ab47c1$export$5f28eab38cddfe99 = (view, z, x, y)=>{
    const offsetLen = $3e9250cdc5ab47c1$var$queryView(view, z, x, y);
    if (offsetLen) return {
        z: z,
        x: x,
        y: y,
        offset: offsetLen[0],
        length: offsetLen[1],
        isDir: false
    };
    return null;
};
const $3e9250cdc5ab47c1$var$queryView = (view, z, x, y)=>{
    let m = 0;
    let n = view.byteLength / 17 - 1;
    while(m <= n){
        const k = n + m >> 1;
        const cmp = $3e9250cdc5ab47c1$var$compare(z, x, y, view, k * 17);
        if (cmp > 0) m = k + 1;
        else if (cmp < 0) n = k - 1;
        else return [
            $3e9250cdc5ab47c1$export$6c733861f07a5da7(view, k * 17 + 7),
            view.getUint32(k * 17 + 13, true)
        ];
    }
    return null;
};
const $3e9250cdc5ab47c1$var$entrySort = (a, b)=>{
    if (a.isDir && !b.isDir) return 1;
    if (!a.isDir && b.isDir) return -1;
    if (a.z !== b.z) return a.z - b.z;
    if (a.x !== b.x) return a.x - b.x;
    return a.y - b.y;
};
const $3e9250cdc5ab47c1$export$44447c9aca07af0b = (dataview, i)=>{
    const zRaw = dataview.getUint8(i * 17);
    const z = zRaw & 127;
    return {
        z: z,
        x: $3e9250cdc5ab47c1$export$32b2c839ee319ab6(dataview, i * 17 + 1),
        y: $3e9250cdc5ab47c1$export$32b2c839ee319ab6(dataview, i * 17 + 4),
        offset: $3e9250cdc5ab47c1$export$6c733861f07a5da7(dataview, i * 17 + 7),
        length: dataview.getUint32(i * 17 + 13, true),
        isDir: zRaw >> 7 === 1
    };
};
const $3e9250cdc5ab47c1$export$26024f251b35868a = (a)=>{
    const entries = [];
    const view = new DataView(a);
    for(let i = 0; i < view.byteLength / 17; i++)entries.push($3e9250cdc5ab47c1$export$44447c9aca07af0b(view, i));
    return $3e9250cdc5ab47c1$export$ec6cea1e356a6713(entries);
};
const $3e9250cdc5ab47c1$export$ec6cea1e356a6713 = (entries)=>{
    entries.sort($3e9250cdc5ab47c1$var$entrySort);
    const buffer = new ArrayBuffer(17 * entries.length);
    const arr = new Uint8Array(buffer);
    for(let i = 0; i < entries.length; i++){
        const entry = entries[i];
        let z = entry.z;
        if (entry.isDir) z = z | 0x80;
        arr[i * 17] = z;
        arr[i * 17 + 1] = entry.x & 0xff;
        arr[i * 17 + 2] = entry.x >> 8 & 0xff;
        arr[i * 17 + 3] = entry.x >> 16 & 0xff;
        arr[i * 17 + 4] = entry.y & 0xff;
        arr[i * 17 + 5] = entry.y >> 8 & 0xff;
        arr[i * 17 + 6] = entry.y >> 16 & 0xff;
        arr[i * 17 + 7] = entry.offset & 0xff;
        arr[i * 17 + 8] = $3e9250cdc5ab47c1$export$37cdb546b806ae87(entry.offset, 8) & 0xff;
        arr[i * 17 + 9] = $3e9250cdc5ab47c1$export$37cdb546b806ae87(entry.offset, 16) & 0xff;
        arr[i * 17 + 10] = $3e9250cdc5ab47c1$export$37cdb546b806ae87(entry.offset, 24) & 0xff;
        arr[i * 17 + 11] = $3e9250cdc5ab47c1$export$37cdb546b806ae87(entry.offset, 32) & 0xff;
        arr[i * 17 + 12] = $3e9250cdc5ab47c1$export$37cdb546b806ae87(entry.offset, 48) & 0xff;
        arr[i * 17 + 13] = entry.length & 0xff;
        arr[i * 17 + 14] = entry.length >> 8 & 0xff;
        arr[i * 17 + 15] = entry.length >> 16 & 0xff;
        arr[i * 17 + 16] = entry.length >> 24 & 0xff;
    }
    return buffer;
};
const $3e9250cdc5ab47c1$export$a82110d5300cd337 = (view, tile)=>{
    if (view.byteLength < 17) return null;
    const numEntries = view.byteLength / 17;
    const entry = $3e9250cdc5ab47c1$export$44447c9aca07af0b(view, numEntries - 1);
    if (entry.isDir) {
        const leafLevel = entry.z;
        const levelDiff = tile.z - leafLevel;
        const leafX = Math.trunc(tile.x / (1 << levelDiff));
        const leafY = Math.trunc(tile.y / (1 << levelDiff));
        return {
            z: leafLevel,
            x: leafX,
            y: leafY
        };
    }
    return null;
};
async function $3e9250cdc5ab47c1$var$getHeader(source) {
    const resp = await source.getBytes(0, 512000);
    const dataview = new DataView(resp.data);
    const jsonSize = dataview.getUint32(4, true);
    const rootEntries = dataview.getUint16(8, true);
    const dec = new TextDecoder("utf-8");
    const jsonMetadata = JSON.parse(dec.decode(new DataView(resp.data, 10, jsonSize)));
    let tileCompression = (0, $74bf0ef92a95cdcb$export$6a00d17b5aff0af).Unknown;
    if (jsonMetadata.compression === "gzip") tileCompression = (0, $74bf0ef92a95cdcb$export$6a00d17b5aff0af).Gzip;
    let minzoom = 0;
    if ("minzoom" in jsonMetadata) minzoom = +jsonMetadata.minzoom;
    let maxzoom = 0;
    if ("maxzoom" in jsonMetadata) maxzoom = +jsonMetadata.maxzoom;
    let centerLon = 0;
    let centerLat = 0;
    let centerZoom = 0;
    let minLon = -180;
    let minLat = -85;
    let maxLon = 180.0;
    let maxLat = 85.0;
    if (jsonMetadata.bounds) {
        const split = jsonMetadata.bounds.split(",");
        minLon = +split[0];
        minLat = +split[1];
        maxLon = +split[2];
        maxLat = +split[3];
    }
    if (jsonMetadata.center) {
        const split = jsonMetadata.center.split(",");
        centerLon = +split[0];
        centerLat = +split[1];
        centerZoom = +split[2];
    }
    const header = {
        specVersion: dataview.getUint16(2, true),
        rootDirectoryOffset: 10 + jsonSize,
        rootDirectoryLength: rootEntries * 17,
        jsonMetadataOffset: 10,
        jsonMetadataLength: jsonSize,
        leafDirectoryOffset: 0,
        leafDirectoryLength: undefined,
        tileDataOffset: 0,
        tileDataLength: undefined,
        numAddressedTiles: 0,
        numTileEntries: 0,
        numTileContents: 0,
        clustered: false,
        internalCompression: (0, $74bf0ef92a95cdcb$export$6a00d17b5aff0af).None,
        tileCompression: tileCompression,
        tileType: (0, $74bf0ef92a95cdcb$export$b58a0cc33096f1fb).Mvt,
        minZoom: minzoom,
        maxZoom: maxzoom,
        minLon: minLon,
        minLat: minLat,
        maxLon: maxLon,
        maxLat: maxLat,
        centerZoom: centerZoom,
        centerLon: centerLon,
        centerLat: centerLat,
        etag: resp.etag
    };
    return header;
}
async function $3e9250cdc5ab47c1$var$getZxy(header, source, cache, z, x, y, signal) {
    let rootDir = await cache.getArrayBuffer(source, header.rootDirectoryOffset, header.rootDirectoryLength, header);
    if (header.specVersion === 1) rootDir = $3e9250cdc5ab47c1$export$26024f251b35868a(rootDir);
    const entry = $3e9250cdc5ab47c1$export$5f28eab38cddfe99(new DataView(rootDir), z, x, y);
    if (entry) {
        const resp = await source.getBytes(entry.offset, entry.length, signal);
        let tileData = resp.data;
        const view = new DataView(tileData);
        if (view.getUint8(0) === 0x1f && view.getUint8(1) === 0x8b) tileData = (0, $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe)(new Uint8Array(tileData));
        return {
            data: tileData
        };
    }
    const leafcoords = $3e9250cdc5ab47c1$export$a82110d5300cd337(new DataView(rootDir), {
        z: z,
        x: x,
        y: y
    });
    if (leafcoords) {
        const leafdirEntry = $3e9250cdc5ab47c1$export$dc5dd5235b829b37(new DataView(rootDir), leafcoords.z, leafcoords.x, leafcoords.y);
        if (leafdirEntry) {
            let leafDir = await cache.getArrayBuffer(source, leafdirEntry.offset, leafdirEntry.length, header);
            if (header.specVersion === 1) leafDir = $3e9250cdc5ab47c1$export$26024f251b35868a(leafDir);
            const tileEntry = $3e9250cdc5ab47c1$export$5f28eab38cddfe99(new DataView(leafDir), z, x, y);
            if (tileEntry) {
                const resp = await source.getBytes(tileEntry.offset, tileEntry.length, signal);
                let tileData = resp.data;
                const view = new DataView(tileData);
                if (view.getUint8(0) === 0x1f && view.getUint8(1) === 0x8b) tileData = (0, $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe)(new Uint8Array(tileData));
                return {
                    data: tileData
                };
            }
        }
    }
    return undefined;
}
var $3e9250cdc5ab47c1$export$2e2bcd8739ae039 = {
    getHeader: $3e9250cdc5ab47c1$var$getHeader,
    getZxy: $3e9250cdc5ab47c1$var$getZxy
};


// biome-ignore lint: needed for Leaflet + IIFE to work

const $397222bd36cfb217$export$e27b8fc6d70762a3 = (source, options)=>{
    let loaded = false;
    let mimeType = "";
    const cls = L.GridLayer.extend({
        createTile: (coord, done)=>{
            const el = document.createElement("img");
            const controller = new AbortController();
            const signal = controller.signal;
            el.cancel = ()=>{
                controller.abort();
            };
            if (!loaded) {
                source.getHeader().then((header)=>{
                    if (header.tileType === (0, $74bf0ef92a95cdcb$export$b58a0cc33096f1fb).Mvt) console.error("Error: archive contains MVT vector tiles, but leafletRasterLayer is for displaying raster tiles. See https://github.com/protomaps/PMTiles/tree/main/js for details.");
                    else if (header.tileType === 2) mimeType = "image/png";
                    else if (header.tileType === 3) mimeType = "image/jpeg";
                    else if (header.tileType === 4) mimeType = "image/webp";
                    else if (header.tileType === 5) mimeType = "image/avif";
                });
                loaded = true;
            }
            source.getZxy(coord.z, coord.x, coord.y, signal).then((arr)=>{
                if (arr) {
                    const blob = new Blob([
                        arr.data
                    ], {
                        type: mimeType
                    });
                    const imageUrl = window.URL.createObjectURL(blob);
                    el.src = imageUrl;
                    el.cancel = undefined;
                    done(undefined, el);
                }
            }).catch((e)=>{
                if (e.name !== "AbortError") throw e;
            });
            return el;
        },
        _removeTile: function(key) {
            const tile = this._tiles[key];
            if (!tile) return;
            if (tile.el.cancel) tile.el.cancel();
            tile.el.width = 0;
            tile.el.height = 0;
            tile.el.deleted = true;
            L.DomUtil.remove(tile.el);
            delete this._tiles[key];
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        }
    });
    return new cls(options);
};
const $397222bd36cfb217$var$v3compat = (v4)=>(requestParameters, arg2)=>{
        if (arg2 instanceof AbortController) // biome-ignore lint: overloading return type not handled by compiler
        return v4(requestParameters, arg2);
        const abortController = new AbortController();
        v4(requestParameters, abortController).then((result)=>{
            return arg2(undefined, result.data, result.cacheControl || "", result.expires || "");
        }, (err)=>{
            return arg2(err);
        }).catch((e)=>{
            return arg2(e);
        });
        return {
            cancel: ()=>abortController.abort()
        };
    };
class $397222bd36cfb217$export$377bbedb5576dfa8 {
    constructor(){
        this.tilev4 = async (params, abortController)=>{
            if (params.type === "json") {
                const pmtilesUrl = params.url.substr(10);
                let instance = this.tiles.get(pmtilesUrl);
                if (!instance) {
                    instance = new (0, $74bf0ef92a95cdcb$export$f5df01c0ebe55344)(pmtilesUrl);
                    this.tiles.set(pmtilesUrl, instance);
                }
                const h = await instance.getHeader();
                return {
                    data: {
                        tiles: [
                            `${params.url}/{z}/{x}/{y}`
                        ],
                        minzoom: h.minZoom,
                        maxzoom: h.maxZoom,
                        bounds: [
                            h.minLon,
                            h.minLat,
                            h.maxLon,
                            h.maxLat
                        ]
                    }
                };
            }
            const re = new RegExp(/pmtiles:\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/);
            const result = params.url.match(re);
            if (!result) throw new Error("Invalid PMTiles protocol URL");
            const pmtilesUrl = result[1];
            let instance = this.tiles.get(pmtilesUrl);
            if (!instance) {
                instance = new (0, $74bf0ef92a95cdcb$export$f5df01c0ebe55344)(pmtilesUrl);
                this.tiles.set(pmtilesUrl, instance);
            }
            const z = result[2];
            const x = result[3];
            const y = result[4];
            const header = await instance.getHeader();
            const resp = await instance?.getZxy(+z, +x, +y, abortController.signal);
            if (resp) return {
                data: new Uint8Array(resp.data),
                cacheControl: resp.cacheControl,
                expires: resp.expires
            };
            if (header.tileType === (0, $74bf0ef92a95cdcb$export$b58a0cc33096f1fb).Mvt) return {
                data: new Uint8Array()
            };
            return {
                data: null
            };
        };
        this.tile = $397222bd36cfb217$var$v3compat(this.tilev4);
        this.tiles = new Map();
    }
    add(p) {
        this.tiles.set(p.source.getKey(), p);
    }
    get(url) {
        return this.tiles.get(url);
    }
}


function $74bf0ef92a95cdcb$var$toNum(low, high) {
    return (high >>> 0) * 0x100000000 + (low >>> 0);
}
function $74bf0ef92a95cdcb$var$readVarintRemainder(l, p) {
    const buf = p.buf;
    let b = buf[p.pos++];
    let h = (b & 0x70) >> 4;
    if (b < 0x80) return $74bf0ef92a95cdcb$var$toNum(l, h);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 3;
    if (b < 0x80) return $74bf0ef92a95cdcb$var$toNum(l, h);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 10;
    if (b < 0x80) return $74bf0ef92a95cdcb$var$toNum(l, h);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 17;
    if (b < 0x80) return $74bf0ef92a95cdcb$var$toNum(l, h);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 24;
    if (b < 0x80) return $74bf0ef92a95cdcb$var$toNum(l, h);
    b = buf[p.pos++];
    h |= (b & 0x01) << 31;
    if (b < 0x80) return $74bf0ef92a95cdcb$var$toNum(l, h);
    throw new Error("Expected varint not more than 10 bytes");
}
function $74bf0ef92a95cdcb$export$6669f4ec4862dba6(p) {
    const buf = p.buf;
    let b = buf[p.pos++];
    let val = b & 0x7f;
    if (b < 0x80) return val;
    b = buf[p.pos++];
    val |= (b & 0x7f) << 7;
    if (b < 0x80) return val;
    b = buf[p.pos++];
    val |= (b & 0x7f) << 14;
    if (b < 0x80) return val;
    b = buf[p.pos++];
    val |= (b & 0x7f) << 21;
    if (b < 0x80) return val;
    b = buf[p.pos];
    val |= (b & 0x0f) << 28;
    return $74bf0ef92a95cdcb$var$readVarintRemainder(val, p);
}
function $74bf0ef92a95cdcb$var$rotate(n, xy, rx, ry) {
    if (ry === 0) {
        if (rx === 1) {
            xy[0] = n - 1 - xy[0];
            xy[1] = n - 1 - xy[1];
        }
        const t = xy[0];
        xy[0] = xy[1];
        xy[1] = t;
    }
}
function $74bf0ef92a95cdcb$var$idOnLevel(z, pos) {
    const n = 2 ** z;
    let rx = pos;
    let ry = pos;
    let t = pos;
    const xy = [
        0,
        0
    ];
    let s = 1;
    while(s < n){
        rx = 1 & t / 2;
        ry = 1 & (t ^ rx);
        $74bf0ef92a95cdcb$var$rotate(s, xy, rx, ry);
        xy[0] += s * rx;
        xy[1] += s * ry;
        t = t / 4;
        s *= 2;
    }
    return [
        z,
        xy[0],
        xy[1]
    ];
}
const $74bf0ef92a95cdcb$var$tzValues = [
    0,
    1,
    5,
    21,
    85,
    341,
    1365,
    5461,
    21845,
    87381,
    349525,
    1398101,
    5592405,
    22369621,
    89478485,
    357913941,
    1431655765,
    5726623061,
    22906492245,
    91625968981,
    366503875925,
    1466015503701,
    5864062014805,
    23456248059221,
    93824992236885,
    375299968947541,
    1501199875790165
];
function $74bf0ef92a95cdcb$export$188cd6f16dbcbc(z, x, y) {
    if (z > 26) throw Error("Tile zoom level exceeds max safe number limit (26)");
    if (x > 2 ** z - 1 || y > 2 ** z - 1) throw Error("tile x/y outside zoom level bounds");
    const acc = $74bf0ef92a95cdcb$var$tzValues[z];
    const n = 2 ** z;
    let rx = 0;
    let ry = 0;
    let d = 0;
    const xy = [
        x,
        y
    ];
    let s = n / 2;
    while(s > 0){
        rx = (xy[0] & s) > 0 ? 1 : 0;
        ry = (xy[1] & s) > 0 ? 1 : 0;
        d += s * s * (3 * rx ^ ry);
        $74bf0ef92a95cdcb$var$rotate(s, xy, rx, ry);
        s = s / 2;
    }
    return acc + d;
}
function $74bf0ef92a95cdcb$export$5bc688871d8d5aab(i) {
    let acc = 0;
    const z = 0;
    for(let z = 0; z < 27; z++){
        const numTiles = (0x1 << z) * (0x1 << z);
        if (acc + numTiles > i) return $74bf0ef92a95cdcb$var$idOnLevel(z, i - acc);
        acc += numTiles;
    }
    throw Error("Tile zoom level exceeds max safe number limit (26)");
}
var $74bf0ef92a95cdcb$export$6a00d17b5aff0af;
(function(Compression) {
    Compression[Compression["Unknown"] = 0] = "Unknown";
    Compression[Compression["None"] = 1] = "None";
    Compression[Compression["Gzip"] = 2] = "Gzip";
    Compression[Compression["Brotli"] = 3] = "Brotli";
    Compression[Compression["Zstd"] = 4] = "Zstd";
})($74bf0ef92a95cdcb$export$6a00d17b5aff0af || ($74bf0ef92a95cdcb$export$6a00d17b5aff0af = {}));
async function $74bf0ef92a95cdcb$var$defaultDecompress(buf, compression) {
    if (compression === 1 || compression === 0) return buf;
    if (compression === 2) {
        // biome-ignore lint: needed to detect DecompressionStream in browser+node+cloudflare workers
        if (typeof globalThis.DecompressionStream === "undefined") return (0, $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe)(new Uint8Array(buf));
        const stream = new Response(buf).body;
        if (!stream) throw Error("Failed to read response stream");
        const result = stream.pipeThrough(// biome-ignore lint: needed to detect DecompressionStream in browser+node+cloudflare workers
        new globalThis.DecompressionStream("gzip"));
        return new Response(result).arrayBuffer();
    }
    throw Error("Compression method not supported");
}
var $74bf0ef92a95cdcb$export$b58a0cc33096f1fb;
(function(TileType) {
    TileType[TileType["Unknown"] = 0] = "Unknown";
    TileType[TileType["Mvt"] = 1] = "Mvt";
    TileType[TileType["Png"] = 2] = "Png";
    TileType[TileType["Jpeg"] = 3] = "Jpeg";
    TileType[TileType["Webp"] = 4] = "Webp";
    TileType[TileType["Avif"] = 5] = "Avif";
})($74bf0ef92a95cdcb$export$b58a0cc33096f1fb || ($74bf0ef92a95cdcb$export$b58a0cc33096f1fb = {}));
const $74bf0ef92a95cdcb$var$HEADER_SIZE_BYTES = 127;
function $74bf0ef92a95cdcb$export$5675963e3644b4b5(entries, tileId) {
    let m = 0;
    let n = entries.length - 1;
    while(m <= n){
        const k = n + m >> 1;
        const cmp = tileId - entries[k].tileId;
        if (cmp > 0) m = k + 1;
        else if (cmp < 0) n = k - 1;
        else return entries[k];
    }
    // at this point, m > n
    if (n >= 0) {
        if (entries[n].runLength === 0) return entries[n];
        if (tileId - entries[n].tileId < entries[n].runLength) return entries[n];
    }
    return null;
}
class $74bf0ef92a95cdcb$export$27a4864e1e35718c {
    constructor(file){
        this.file = file;
    }
    getKey() {
        return this.file.name;
    }
    async getBytes(offset, length) {
        const blob = this.file.slice(offset, offset + length);
        const a = await blob.arrayBuffer();
        return {
            data: a
        };
    }
}
class $74bf0ef92a95cdcb$export$da55bbd2ae5caa76 {
    constructor(url, customHeaders = new Headers()){
        this.url = url;
        this.customHeaders = customHeaders;
        this.mustReload = false;
    }
    getKey() {
        return this.url;
    }
    setHeaders(customHeaders) {
        this.customHeaders = customHeaders;
    }
    async getBytes(offset, length, passedSignal, etag) {
        let controller;
        let signal;
        if (passedSignal) signal = passedSignal;
        else {
            controller = new AbortController();
            signal = controller.signal;
        }
        const requestHeaders = new Headers(this.customHeaders);
        requestHeaders.set("range", `bytes=${offset}-${offset + length - 1}`);
        // we don't send if match because:
        // * it disables browser caching completely (Chromium)
        // * it requires a preflight request for every tile request
        // * it requires CORS configuration becasue If-Match is not a CORs-safelisted header
        // CORs configuration should expose ETag.
        // if any etag mismatch is detected, we need to ignore the browser cache
        let cache;
        if (this.mustReload) cache = "reload";
        let resp = await fetch(this.url, {
            signal: signal,
            cache: cache,
            headers: requestHeaders
        });
        // handle edge case where the archive is < 16384 kb total.
        if (offset === 0 && resp.status === 416) {
            const contentRange = resp.headers.get("Content-Range");
            if (!contentRange || !contentRange.startsWith("bytes */")) throw Error("Missing content-length on 416 response");
            const actualLength = +contentRange.substr(8);
            resp = await fetch(this.url, {
                signal: signal,
                cache: "reload",
                headers: {
                    range: `bytes=0-${actualLength - 1}`
                }
            });
        }
        // if it's a weak etag, it's not useful for us, so ignore it.
        let newEtag = resp.headers.get("Etag");
        if (newEtag?.startsWith("W/")) newEtag = null;
        // some storage systems are misbehaved (Cloudflare R2)
        if (resp.status === 416 || etag && newEtag && newEtag !== etag) {
            this.mustReload = true;
            throw new $74bf0ef92a95cdcb$export$6c82150b8b13aae7(`Server returned non-matching ETag ${etag} after one retry. Check browser extensions and servers for issues that may affect correct ETag headers.`);
        }
        if (resp.status >= 300) throw Error(`Bad response code: ${resp.status}`);
        // some well-behaved backends, e.g. DigitalOcean CDN, respond with 200 instead of 206
        // but we also need to detect no support for Byte Serving which is returning the whole file
        const contentLength = resp.headers.get("Content-Length");
        if (resp.status === 200 && (!contentLength || +contentLength > length)) {
            if (controller) controller.abort();
            throw Error("Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving.");
        }
        const a = await resp.arrayBuffer();
        return {
            data: a,
            etag: newEtag || undefined,
            cacheControl: resp.headers.get("Cache-Control") || undefined,
            expires: resp.headers.get("Expires") || undefined
        };
    }
}
function $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, offset) {
    const wh = v.getUint32(offset + 4, true);
    const wl = v.getUint32(offset + 0, true);
    return wh * 2 ** 32 + wl;
}
function $74bf0ef92a95cdcb$export$47afd0f2e060142c(bytes, etag) {
    const v = new DataView(bytes);
    const specVersion = v.getUint8(7);
    if (specVersion > 3) throw Error(`Archive is spec version ${specVersion} but this library supports up to spec version 3`);
    return {
        specVersion: specVersion,
        rootDirectoryOffset: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 8),
        rootDirectoryLength: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 16),
        jsonMetadataOffset: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 24),
        jsonMetadataLength: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 32),
        leafDirectoryOffset: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 40),
        leafDirectoryLength: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 48),
        tileDataOffset: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 56),
        tileDataLength: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 64),
        numAddressedTiles: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 72),
        numTileEntries: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 80),
        numTileContents: $74bf0ef92a95cdcb$export$59a2dbf579ff9568(v, 88),
        clustered: v.getUint8(96) === 1,
        internalCompression: v.getUint8(97),
        tileCompression: v.getUint8(98),
        tileType: v.getUint8(99),
        minZoom: v.getUint8(100),
        maxZoom: v.getUint8(101),
        minLon: v.getInt32(102, true) / 10000000,
        minLat: v.getInt32(106, true) / 10000000,
        maxLon: v.getInt32(110, true) / 10000000,
        maxLat: v.getInt32(114, true) / 10000000,
        centerZoom: v.getUint8(118),
        centerLon: v.getInt32(119, true) / 10000000,
        centerLat: v.getInt32(123, true) / 10000000,
        etag: etag
    };
}
function $74bf0ef92a95cdcb$var$deserializeIndex(buffer) {
    const p = {
        buf: new Uint8Array(buffer),
        pos: 0
    };
    const numEntries = $74bf0ef92a95cdcb$export$6669f4ec4862dba6(p);
    const entries = [];
    let lastId = 0;
    for(let i = 0; i < numEntries; i++){
        const v = $74bf0ef92a95cdcb$export$6669f4ec4862dba6(p);
        entries.push({
            tileId: lastId + v,
            offset: 0,
            length: 0,
            runLength: 1
        });
        lastId += v;
    }
    for(let i = 0; i < numEntries; i++)entries[i].runLength = $74bf0ef92a95cdcb$export$6669f4ec4862dba6(p);
    for(let i = 0; i < numEntries; i++)entries[i].length = $74bf0ef92a95cdcb$export$6669f4ec4862dba6(p);
    for(let i = 0; i < numEntries; i++){
        const v = $74bf0ef92a95cdcb$export$6669f4ec4862dba6(p);
        if (v === 0 && i > 0) entries[i].offset = entries[i - 1].offset + entries[i - 1].length;
        else entries[i].offset = v - 1;
    }
    return entries;
}
function $74bf0ef92a95cdcb$var$detectVersion(a) {
    const v = new DataView(a);
    if (v.getUint16(2, true) === 2) {
        console.warn("PMTiles spec version 2 has been deprecated; please see github.com/protomaps/PMTiles for tools to upgrade");
        return 2;
    }
    if (v.getUint16(2, true) === 1) {
        console.warn("PMTiles spec version 1 has been deprecated; please see github.com/protomaps/PMTiles for tools to upgrade");
        return 1;
    }
    return 3;
}
class $74bf0ef92a95cdcb$export$6c82150b8b13aae7 extends Error {
}
async function $74bf0ef92a95cdcb$var$getHeaderAndRoot(source, decompress) {
    const resp = await source.getBytes(0, 16384);
    const v = new DataView(resp.data);
    if (v.getUint16(0, true) !== 0x4d50) throw new Error("Wrong magic number for PMTiles archive");
    // V2 COMPATIBILITY
    if ($74bf0ef92a95cdcb$var$detectVersion(resp.data) < 3) return [
        await (0, $3e9250cdc5ab47c1$export$2e2bcd8739ae039).getHeader(source)
    ];
    const headerData = resp.data.slice(0, $74bf0ef92a95cdcb$var$HEADER_SIZE_BYTES);
    const header = $74bf0ef92a95cdcb$export$47afd0f2e060142c(headerData, resp.etag);
    // optimistically set the root directory
    // TODO check root bounds
    const rootDirData = resp.data.slice(header.rootDirectoryOffset, header.rootDirectoryOffset + header.rootDirectoryLength);
    const dirKey = `${source.getKey()}|${header.etag || ""}|${header.rootDirectoryOffset}|${header.rootDirectoryLength}`;
    const rootDir = $74bf0ef92a95cdcb$var$deserializeIndex(await decompress(rootDirData, header.internalCompression));
    return [
        header,
        [
            dirKey,
            rootDir.length,
            rootDir
        ]
    ];
}
async function $74bf0ef92a95cdcb$var$getDirectory(source, decompress, offset, length, header) {
    const resp = await source.getBytes(offset, length, undefined, header.etag);
    const data = await decompress(resp.data, header.internalCompression);
    const directory = $74bf0ef92a95cdcb$var$deserializeIndex(data);
    if (directory.length === 0) throw new Error("Empty directory is invalid");
    return directory;
}
class $74bf0ef92a95cdcb$export$85b5382c5bd98023 {
    constructor(maxCacheEntries = 100, prefetch = true, decompress = $74bf0ef92a95cdcb$var$defaultDecompress){
        this.cache = new Map();
        this.maxCacheEntries = maxCacheEntries;
        this.counter = 1;
        this.decompress = decompress;
    }
    async getHeader(source) {
        const cacheKey = source.getKey();
        const cacheValue = this.cache.get(cacheKey);
        if (cacheValue) {
            cacheValue.lastUsed = this.counter++;
            const data = cacheValue.data;
            return data;
        }
        const res = await $74bf0ef92a95cdcb$var$getHeaderAndRoot(source, this.decompress);
        if (res[1]) this.cache.set(res[1][0], {
            lastUsed: this.counter++,
            data: res[1][2]
        });
        this.cache.set(cacheKey, {
            lastUsed: this.counter++,
            data: res[0]
        });
        this.prune();
        return res[0];
    }
    async getDirectory(source, offset, length, header) {
        const cacheKey = `${source.getKey()}|${header.etag || ""}|${offset}|${length}`;
        const cacheValue = this.cache.get(cacheKey);
        if (cacheValue) {
            cacheValue.lastUsed = this.counter++;
            const data = cacheValue.data;
            return data;
        }
        const directory = await $74bf0ef92a95cdcb$var$getDirectory(source, this.decompress, offset, length, header);
        this.cache.set(cacheKey, {
            lastUsed: this.counter++,
            data: directory
        });
        this.prune();
        return directory;
    }
    // for v2 backwards compatibility
    async getArrayBuffer(source, offset, length, header) {
        const cacheKey = `${source.getKey()}|${header.etag || ""}|${offset}|${length}`;
        const cacheValue = this.cache.get(cacheKey);
        if (cacheValue) {
            cacheValue.lastUsed = this.counter++;
            const data = await cacheValue.data;
            return data;
        }
        const resp = await source.getBytes(offset, length, undefined, header.etag);
        this.cache.set(cacheKey, {
            lastUsed: this.counter++,
            data: resp.data
        });
        this.prune();
        return resp.data;
    }
    prune() {
        if (this.cache.size > this.maxCacheEntries) {
            let minUsed = Infinity;
            let minKey = undefined;
            this.cache.forEach((cacheValue, key)=>{
                if (cacheValue.lastUsed < minUsed) {
                    minUsed = cacheValue.lastUsed;
                    minKey = key;
                }
            });
            if (minKey) this.cache.delete(minKey);
        }
    }
    async invalidate(source) {
        this.cache.delete(source.getKey());
    }
}
class $74bf0ef92a95cdcb$export$a73e3869eeeadfd6 {
    constructor(maxCacheEntries = 100, prefetch = true, decompress = $74bf0ef92a95cdcb$var$defaultDecompress){
        this.cache = new Map();
        this.invalidations = new Map();
        this.maxCacheEntries = maxCacheEntries;
        this.counter = 1;
        this.decompress = decompress;
    }
    async getHeader(source) {
        const cacheKey = source.getKey();
        const cacheValue = this.cache.get(cacheKey);
        if (cacheValue) {
            cacheValue.lastUsed = this.counter++;
            const data = await cacheValue.data;
            return data;
        }
        const p = new Promise((resolve, reject)=>{
            $74bf0ef92a95cdcb$var$getHeaderAndRoot(source, this.decompress).then((res)=>{
                if (res[1]) this.cache.set(res[1][0], {
                    lastUsed: this.counter++,
                    data: Promise.resolve(res[1][2])
                });
                resolve(res[0]);
                this.prune();
            }).catch((e)=>{
                reject(e);
            });
        });
        this.cache.set(cacheKey, {
            lastUsed: this.counter++,
            data: p
        });
        return p;
    }
    async getDirectory(source, offset, length, header) {
        const cacheKey = `${source.getKey()}|${header.etag || ""}|${offset}|${length}`;
        const cacheValue = this.cache.get(cacheKey);
        if (cacheValue) {
            cacheValue.lastUsed = this.counter++;
            const data = await cacheValue.data;
            return data;
        }
        const p = new Promise((resolve, reject)=>{
            $74bf0ef92a95cdcb$var$getDirectory(source, this.decompress, offset, length, header).then((directory)=>{
                resolve(directory);
                this.prune();
            }).catch((e)=>{
                reject(e);
            });
        });
        this.cache.set(cacheKey, {
            lastUsed: this.counter++,
            data: p
        });
        return p;
    }
    // for v2 backwards compatibility
    async getArrayBuffer(source, offset, length, header) {
        const cacheKey = `${source.getKey()}|${header.etag || ""}|${offset}|${length}`;
        const cacheValue = this.cache.get(cacheKey);
        if (cacheValue) {
            cacheValue.lastUsed = this.counter++;
            const data = await cacheValue.data;
            return data;
        }
        const p = new Promise((resolve, reject)=>{
            source.getBytes(offset, length, undefined, header.etag).then((resp)=>{
                resolve(resp.data);
                this.cache.has(cacheKey);
                this.prune();
            }).catch((e)=>{
                reject(e);
            });
        });
        this.cache.set(cacheKey, {
            lastUsed: this.counter++,
            data: p
        });
        return p;
    }
    prune() {
        if (this.cache.size >= this.maxCacheEntries) {
            let minUsed = Infinity;
            let minKey = undefined;
            this.cache.forEach((cacheValue, key)=>{
                if (cacheValue.lastUsed < minUsed) {
                    minUsed = cacheValue.lastUsed;
                    minKey = key;
                }
            });
            if (minKey) this.cache.delete(minKey);
        }
    }
    async invalidate(source) {
        const key = source.getKey();
        if (this.invalidations.get(key)) return await this.invalidations.get(key);
        this.cache.delete(source.getKey());
        const p = new Promise((resolve, reject)=>{
            this.getHeader(source).then((h)=>{
                resolve();
                this.invalidations.delete(key);
            }).catch((e)=>{
                reject(e);
            });
        });
        this.invalidations.set(key, p);
    }
}
class $74bf0ef92a95cdcb$export$f5df01c0ebe55344 {
    constructor(source, cache, decompress){
        if (typeof source === "string") this.source = new $74bf0ef92a95cdcb$export$da55bbd2ae5caa76(source);
        else this.source = source;
        if (decompress) this.decompress = decompress;
        else this.decompress = $74bf0ef92a95cdcb$var$defaultDecompress;
        if (cache) this.cache = cache;
        else this.cache = new $74bf0ef92a95cdcb$export$a73e3869eeeadfd6();
    }
    /**
   * Return the header of the archive,
   * including information such as tile type, min/max zoom, bounds, and summary statistics.
   */ async getHeader() {
        return await this.cache.getHeader(this.source);
    }
    /** @hidden */ async getZxyAttempt(z, x, y, signal) {
        const tileId = $74bf0ef92a95cdcb$export$188cd6f16dbcbc(z, x, y);
        const header = await this.cache.getHeader(this.source);
        // V2 COMPATIBILITY
        if (header.specVersion < 3) return (0, $3e9250cdc5ab47c1$export$2e2bcd8739ae039).getZxy(header, this.source, this.cache, z, x, y, signal);
        if (z < header.minZoom || z > header.maxZoom) return undefined;
        let dO = header.rootDirectoryOffset;
        let dL = header.rootDirectoryLength;
        for(let depth = 0; depth <= 3; depth++){
            const directory = await this.cache.getDirectory(this.source, dO, dL, header);
            const entry = $74bf0ef92a95cdcb$export$5675963e3644b4b5(directory, tileId);
            if (entry) {
                if (entry.runLength > 0) {
                    const resp = await this.source.getBytes(header.tileDataOffset + entry.offset, entry.length, signal, header.etag);
                    return {
                        data: await this.decompress(resp.data, header.tileCompression),
                        cacheControl: resp.cacheControl,
                        expires: resp.expires
                    };
                }
                dO = header.leafDirectoryOffset + entry.offset;
                dL = entry.length;
            } else // TODO: We should in fact return a valid RangeResponse
            // with empty data, but filled in cache control / expires headers
            return undefined;
        }
        throw Error("Maximum directory depth exceeded");
    }
    /**
   * Primary method to get a single tile bytes from an archive.
   *
   * Returns undefined if the tile does not exist in the archive.
   */ async getZxy(z, x, y, signal) {
        try {
            return await this.getZxyAttempt(z, x, y, signal);
        } catch (e) {
            if (e instanceof $74bf0ef92a95cdcb$export$6c82150b8b13aae7) {
                this.cache.invalidate(this.source);
                return await this.getZxyAttempt(z, x, y, signal);
            }
            throw e;
        }
    }
    /** @hidden */ async getMetadataAttempt() {
        const header = await this.cache.getHeader(this.source);
        const resp = await this.source.getBytes(header.jsonMetadataOffset, header.jsonMetadataLength, undefined, header.etag);
        const decompressed = await this.decompress(resp.data, header.internalCompression);
        const dec = new TextDecoder("utf-8");
        return JSON.parse(dec.decode(decompressed));
    }
    /**
   * Return the arbitrary JSON metadata of the archive.
   */ async getMetadata() {
        try {
            return await this.getMetadataAttempt();
        } catch (e) {
            if (e instanceof $74bf0ef92a95cdcb$export$6c82150b8b13aae7) {
                this.cache.invalidate(this.source);
                return await this.getMetadataAttempt();
            }
            throw e;
        }
    }
}



var $acw62 = parcelRequire("acw62");











const $b8cefafe0c10a151$var$VECTOR_TILE_FEATURE_PROPERTY = "vectorTileFeature";
const $b8cefafe0c10a151$var$formats = {
    "EPSG:3857": new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)({
        featureProjection: "EPSG:3857"
    })
};
class $b8cefafe0c10a151$export$2e2bcd8739ae039 extends (0, $cb18cdefd702a327$export$2e2bcd8739ae039) {
    getFeaturesAtCoordinate(coordinate, hitTolerance = 5) {
        const pixels = this.getMapLibrePixels(coordinate, hitTolerance);
        if (!pixels) return [];
        const queryRenderedFeaturesOptions = this.getLayer().get("queryRenderedFeaturesOptions") || {};
        // At this point we get GeoJSON MapLibre feature, we transform it to an OpenLayers
        // feature to be consistent with other layers.
        const features = this.getLayer().mapLibreMap?.queryRenderedFeatures(pixels, queryRenderedFeaturesOptions).map((feature)=>{
            return this.toOlFeature(feature);
        });
        return features || [];
    }
    prepareFrame() {
        return true;
    }
    renderFrame(frameState) {
        const layer = this.getLayer();
        const { mapLibreMap: mapLibreMap } = layer;
        const map = layer.getMapInternal();
        if (!layer || !map || !mapLibreMap) return null;
        const mapLibreCanvas = mapLibreMap.getCanvas();
        const { viewState: viewState } = frameState;
        // adjust view parameters in MapLibre
        mapLibreMap.jumpTo({
            center: (0, $9c4744460e43e41b$export$3fb495868742d370)(viewState.center),
            zoom: viewState.zoom - 1,
            bearing: (0, $6b000a049d919fe5$export$56cb859c01fa134d)(-viewState.rotation)
        });
        const opacity = layer.getOpacity().toString();
        if (mapLibreCanvas && opacity !== mapLibreCanvas.style.opacity) mapLibreCanvas.style.opacity = opacity;
        if (!mapLibreCanvas.isConnected) // The canvas is not connected to the DOM, request a map rendering at the next animation frame
        // to set the canvas size.
        map.render();
        else if (!$b8cefafe0c10a151$var$sameSize(mapLibreCanvas, frameState)) mapLibreMap.resize();
        mapLibreMap.redraw();
        return mapLibreMap.getContainer();
    }
    getFeatures(pixel) {
        const coordinate = this.getLayer().getMapInternal()?.getCoordinateFromPixel(pixel);
        return Promise.resolve(this.getFeaturesAtCoordinate(coordinate));
    }
    forEachFeatureAtCoordinate(coordinate, _frameState, hitTolerance, callback) {
        const features = this.getFeaturesAtCoordinate(coordinate, hitTolerance);
        features.forEach((feature)=>{
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $c76e993e57efc8c4$export$2e2bcd8739ae039)) callback(feature, this.getLayer(), geometry);
        });
        return features?.[0];
    }
    getMapLibrePixels(coordinate, hitTolerance) {
        if (!coordinate) return undefined;
        const pixel = this.getLayer().mapLibreMap?.project((0, $9c4744460e43e41b$export$3fb495868742d370)(coordinate));
        if (pixel?.x === undefined || pixel?.y === undefined) return undefined;
        let pixels = [
            pixel.x,
            pixel.y
        ];
        if (hitTolerance) {
            const [x, y] = pixels;
            pixels = [
                [
                    x - hitTolerance,
                    y - hitTolerance
                ],
                [
                    x + hitTolerance,
                    y + hitTolerance
                ]
            ];
        }
        return pixels;
    }
    toOlFeature(feature) {
        const layer = this.getLayer();
        const map = layer.getMapInternal();
        const projection = map?.getView()?.getProjection()?.getCode() || "EPSG:3857";
        if (!$b8cefafe0c10a151$var$formats[projection]) $b8cefafe0c10a151$var$formats[projection] = new (0, $f602cef51a2e6950$export$2e2bcd8739ae039)({
            featureProjection: projection
        });
        const olFeature = $b8cefafe0c10a151$var$formats[projection].readFeature(feature);
        if (olFeature) // We save the original MapLibre feature to avoid losing information
        // potentially needed for others functionalities like highlighting
        // (id, layer id, source, sourceLayer ...)
        olFeature.set($b8cefafe0c10a151$var$VECTOR_TILE_FEATURE_PROPERTY, feature, true);
        return olFeature;
    }
}
function $b8cefafe0c10a151$var$sameSize(canvas, frameState) {
    return canvas.width === Math.floor(frameState.size[0] * frameState.pixelRatio) && canvas.height === Math.floor(frameState.size[1] * frameState.pixelRatio);
}


/**
 * Return the copyright a MapLibre map.
 * @param map A MapLibre map
 */ const $37835bbe72b75303$var$getMapLibreAttributions = (map)=>{
    if (!map) return [];
    const { style: style } = map;
    if (!style) return [];
    const { sourceCaches: sourceCaches } = style;
    let copyrights = [];
    Object.values(sourceCaches).forEach((value)=>{
        if (value.used) {
            const { attribution: attribution } = value.getSource();
            if (attribution) copyrights = copyrights.concat(attribution.replace(/&copy;/g, "\xa9").split(/(<a.*?<\/a>)/));
        }
    });
    return $37835bbe72b75303$export$ec05a79d47b373aa(copyrights);
};
const $37835bbe72b75303$export$ec05a79d47b373aa = (array)=>{
    const arrWithoutEmptyValues = array.filter((val)=>val !== undefined && val !== null && val.trim && val.trim());
    const lowerCasesValues = arrWithoutEmptyValues.map((str)=>str.toLowerCase());
    // Use of Set removes duplicates
    const uniqueLowerCaseValues = [
        ...new Set(lowerCasesValues)
    ];
    return uniqueLowerCaseValues.map((uniqueStr)=>arrWithoutEmptyValues.find((str)=>str.toLowerCase() === uniqueStr));
};
var $37835bbe72b75303$export$2e2bcd8739ae039 = $37835bbe72b75303$var$getMapLibreAttributions;


class $239cc95b6be8028a$export$2e2bcd8739ae039 extends (0, $534f30fce11effcd$export$2e2bcd8739ae039) {
    mapLibreMap;
    loaded = false;
    olListenersKeys = [];
    constructor(options){
        super({
            source: new (0, $ed6dc99f268f3882$export$2e2bcd8739ae039)({
                attributions: ()=>{
                    return (0, $37835bbe72b75303$export$2e2bcd8739ae039)(this.mapLibreMap);
                }
            }),
            ...options
        });
    }
    disposeInternal() {
        (0, $1f093ab5083c8a1f$export$b7ef3f8527533384)(this.olListenersKeys);
        this.loaded = false;
        if (this.mapLibreMap) {
            // Some asynchronous repaints are triggered even if the MapLibreMap has been removed,
            // to avoid display of errors we set an empty function.
            this.mapLibreMap.triggerRepaint = ()=>{};
            this.mapLibreMap.remove();
        }
        super.disposeInternal();
    }
    setMapInternal(map) {
        super.setMapInternal(map);
        if (map) this.loadMapLibreMap();
        else // TODO: I'm not sure if it's the right call
        this.dispose();
    }
    loadMapLibreMap() {
        this.loaded = false;
        const map = this.getMapInternal();
        if (map) this.olListenersKeys.push(map.on("change:target", this.loadMapLibreMap.bind(this)));
        if (!map?.getTargetElement()) return;
        if (!this.getVisible()) {
            // On next change of visibility we load the map
            this.olListenersKeys.push(this.once("change:visible", this.loadMapLibreMap.bind(this)));
            return;
        }
        const container = document.createElement("div");
        container.style.position = "absolute";
        container.style.width = "100%";
        container.style.height = "100%";
        const mapLibreOptions = this.get("mapLibreOptions");
        this.mapLibreMap = new (0, $0a06c4d6833722ed$exports.Map)(Object.assign({}, mapLibreOptions, {
            container: container,
            attributionControl: false,
            interactive: false,
            trackResize: false
        }));
        this.mapLibreMap.on("sourcedata", ()=>{
            this.getSource()?.refresh(); // Refresh attribution
        });
        this.mapLibreMap.once("load", ()=>{
            this.loaded = true;
            this.dispatchEvent(new (0, $aeedce20e9577100$export$2e2bcd8739ae039)("load"));
        });
    }
    createRenderer() {
        return new (0, $b8cefafe0c10a151$export$2e2bcd8739ae039)(this);
    }
}







const $9260f76837d4afd6$export$c257b8322d472a42 = "https://d1ofmpho8aplip.cloudfront.net";
const $9260f76837d4afd6$var$url = `${$9260f76837d4afd6$export$c257b8322d472a42}/test.json`;
const $9260f76837d4afd6$export$9cee85af3dc875f1 = (pmtiles)=>{
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)([
        "map_styles"
    ], async ()=>{
        const response = await fetch($9260f76837d4afd6$var$url);
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        data.sources.protomaps.url = `pmtiles://${pmtiles}`;
        return data;
    });
};


const $d01ea076d3638331$var$PMTILES_URL = `${(0, $9260f76837d4afd6$export$c257b8322d472a42)}/20230918.pmtiles`;
function $d01ea076d3638331$export$2e2bcd8739ae039() {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const { data: style } = (0, $9260f76837d4afd6$export$9cee85af3dc875f1)($d01ea076d3638331$var$PMTILES_URL);
    (0, $acw62.useEffect)(()=>{
        if (!map || !style) return;
        (async ()=>{
            const protocol = new (0, $397222bd36cfb217$export$377bbedb5576dfa8)();
            (0, (/*@__PURE__*/$parcel$interopDefault($0a06c4d6833722ed$exports))).addProtocol("pmtiles", protocol.tile);
            const p = new (0, $74bf0ef92a95cdcb$export$f5df01c0ebe55344)($d01ea076d3638331$var$PMTILES_URL);
            protocol.add(p);
            const layer = new (0, $239cc95b6be8028a$export$2e2bcd8739ae039)({
                opacity: 0.7,
                mapLibreOptions: {
                    style: style
                }
            });
            layer.set("name", "PMTiles");
            layer.set("hideable", true);
            layer.setZIndex(-1);
            map.addLayer(layer);
        })();
    }, [
        map,
        style
    ]);
    return null;
}



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");







var $f1q41 = parcelRequire("f1q41");









const $c5fc096bd6b39220$var$sourceNameKey = "navSource";
class $c5fc096bd6b39220$export$b110defd32f23aa0 {
    constructor(map, dispatch, colorMap, manifest, manager, user, theater, onSuccess, onError){
        this.sources = [];
        this.layers = [];
        this.map = map;
        this.dispatch = dispatch;
        this.colorMap = colorMap;
        this.manifest = manifest;
        this.mgr = manager;
        this.user = user;
        this.theater = theater;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
    init(groups) {
        if (!this.map) return;
        const mapLayers = this.map.getLayers().getArray();
        for (const group of groups){
            const layer = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(mapLayers, (layer)=>layer.get("name") === (0, $6a33db4e41351fb9$export$d03821c02d9d2c2f)(group.name));
            if (!layer) continue;
            const source = layer.getSource();
            source.set($c5fc096bd6b39220$var$sourceNameKey, group.name);
            this.sources.push(source);
            this.layers.push(layer);
            layer.setStyle($c5fc096bd6b39220$var$navPointModifyStyle(this.colorMap));
        }
        this.refreshModify();
    }
    refreshModify() {
        if (this.modify) {
            this.map.removeInteraction(this.modify);
            delete this.modify;
        }
        const features = [];
        for (const source of this.sources)features.push(...source.getFeatures());
        const collection = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(features);
        this.modify = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
            features: collection,
            style: $c5fc096bd6b39220$var$modifyText
        });
        this.modify.on("modifyend", (e)=>{
            const feature = e.features.getArray()[0];
            const groupName = feature?.get("group");
            this.handlePlanUpdate(groupName, feature);
        });
        this.map.addInteraction(this.modify);
    }
    getPlannedNavPoints(groupName) {
        const source = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(this.sources, (source)=>source.get($c5fc096bd6b39220$var$sourceNameKey) === groupName);
        if (!source) return [];
        return source.getFeatures();
    }
    toggleModify(enabled) {
        if (this.modify) this.modify.setActive(enabled);
        for (const layer of this.layers){
            const groupName = layer.getSource().get($c5fc096bd6b39220$var$sourceNameKey);
            const color = this.colorMap[groupName];
            const style = enabled ? $c5fc096bd6b39220$var$navPointModifyStyle(this.colorMap) : (0, $6a33db4e41351fb9$export$6106ebb8e8b4f99d)(color);
            layer.setStyle(style);
        }
    }
    findSource(groupName) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(this.sources, (source)=>source.get($c5fc096bd6b39220$var$sourceNameKey) === groupName);
    }
    findFeature(groupName, index) {
        const source = this.findSource(groupName);
        if (!source) return;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(source.getFeatures(), (feature)=>feature.get("point").index === index);
    }
    toggleAddMode(enabled, group) {
        if (!enabled && this.draw) {
            this.map.removeInteraction(this.draw);
            delete this.draw;
            this.refreshModify();
            return;
        }
        if (enabled) this.dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).toggleNavPointMode,
            enabled: true,
            group: group
        });
        if (enabled && !this.draw) {
            const source = this.findSource(group);
            if (!source) throw new Error("No source found for group");
            const draw = new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
                source: source,
                type: "Point",
                condition: (e)=>{
                    if ((0, $9c554d6df7d74017$export$8a7ef89a0633946c)(e)) return false;
                    return true;
                },
                style: $c5fc096bd6b39220$var$drawTipStyle
            });
            draw.on("drawstart", (e)=>{
                const indexes = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(source.getFeatures(), (f)=>f.get("point").index);
                const next = indexes.length === 0 ? 1 : (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).max(indexes) + 1;
                e.feature.setProperties({
                    name: `${group} - Nav Point ${next}`,
                    featureClass: (0, $91a9098e14452db2$export$589bf38da6f496d9).NavPoint,
                    group: group,
                    point: {
                        index: next,
                        textComment: next.toString()
                    }
                });
            });
            draw.on("drawend", (e)=>{
                this.handlePlanUpdate(group, e.feature);
            });
            // @ts-ignore
            this.map.on("pointerup", (e)=>{
                if ((0, $9c554d6df7d74017$export$8a7ef89a0633946c)(e)) {
                    this.map.removeInteraction(draw);
                    this.dispatch({
                        type: (0, $99f46708ff5ed621$export$159e21535af98b26).toggleNavPointMode,
                        enabled: false,
                        group: group
                    });
                    this.refreshModify();
                    return;
                }
            });
            this.map.addInteraction(draw);
        }
    }
    updateNavPointText(groupName, index, text) {
        const feature = this.findFeature(groupName, index);
        if (!feature) return;
        feature.setProperties({
            point: {
                ...feature.get("point"),
                textComment: text
            }
        });
        this.handlePlanUpdate(groupName, feature);
    }
    async deleteNavPoint(groupName, index) {
        const feature = this.findFeature(groupName, index);
        if (!feature) return;
        const source = this.findSource(groupName);
        if (!source) return;
        source.removeFeature(feature);
        if (this.manifest.version >= 3) await this.mgr.deleteNavPoint(this.manifest.id, groupName, index);
        else this.handlePlanUpdate(groupName, feature);
    }
    async handlePlanUpdate(groupName, feature) {
        // V2 and lower use central state
        this.dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).setPlanStatus,
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Draft,
            groupName: groupName
        });
        // V3 and higher use PlanManagerV2
        if (this.manifest.version >= 3) {
            const point = feature.get("point");
            const [long, lat] = feature.getGeometry().getCoordinates();
            const coords = (0, $79e13355954d15ea$export$43105f50ad4fdfb0)(this.theater, {
                lat: lat,
                long: long
            });
            feature.get("point").x = coords.x;
            feature.get("point").y = coords.y;
            await this.mgr.upsertNavPoint(this.manifest.id, this.user, groupName, point);
            this.onSuccess();
        }
    }
}
const $c5fc096bd6b39220$var$navPointModifyStyle = (colorMap)=>(feature)=>{
        const groupName = feature.get("group");
        const comment = feature.get("point")?.textComment?.toString() || "";
        const text = (0, $6a33db4e41351fb9$export$957d7daebd899f12)(comment);
        return [
            new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: colorMap[groupName]
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: "black"
                    }),
                    points: 4,
                    radius: 12,
                    angle: 0
                }),
                text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                    overflow: true,
                    font: 'bold 18px "Roboto", "Arial Unicode MS", "sans-serif"',
                    placement: "point",
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: colorMap[groupName]
                    }),
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: "black",
                        width: 2
                    }),
                    text: text,
                    offsetY: 20
                })
            })
        ];
    };
const $c5fc096bd6b39220$var$modifyText = (f)=>{
    const v = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(f.get("features"));
    const comment = v.get("point")?.textComment?.toString();
    const text = (0, $6a33db4e41351fb9$export$957d7daebd899f12)(comment);
    const group = v.get("group");
    return [
        new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
            image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
                radius: 5,
                stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                    color: "rgba(0, 0, 0, 0.7)"
                }),
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: "rgba(0, 0, 0, 0.4)"
                })
            }),
            text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                text: `${group}/${text} - Drag to move`,
                font: "14px Roboto,sans-serif",
                fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: "rgba(255, 255, 255, 1)"
                }),
                backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                    color: "rgba(0, 0, 0, 0.7)"
                }),
                padding: [
                    2,
                    2,
                    2,
                    2
                ],
                textAlign: "left",
                offsetX: 15
            })
        })
    ];
};
const $c5fc096bd6b39220$var$drawTipStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 1)",
            width: 2
        }),
        points: 4,
        radius: 10,
        rotation: Math.PI / 2,
        angle: 0
    }),
    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        text: "Click to drop Nav Target Point. Right-click to cancel",
        font: "12px Roboto,sans-serif",
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.4)"
        }),
        padding: [
            4,
            4,
            4,
            4
        ],
        textAlign: "left",
        offsetX: 15
    })
});



var $f1q41 = parcelRequire("f1q41");








var $f1q41 = parcelRequire("f1q41");





const $6b95cf800967d277$var$tipStyle = new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
    image: new (0, $3e99c452138b2224$export$2e2bcd8739ae039)({
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 1)",
            width: 2
        }),
        points: 4,
        radius: 10,
        rotation: Math.PI / 2,
        angle: 0
    }),
    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
        text: "Click to drop waypoint. Esc exit to drop mode",
        font: "12px Roboto,sans-serif",
        fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(255, 255, 255, 1)"
        }),
        backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
            color: "rgba(0, 0, 0, 0.4)"
        }),
        padding: [
            4,
            4,
            4,
            4
        ],
        textAlign: "left",
        offsetX: 15
    })
});
function $6b95cf800967d277$export$b72d6d1e426d510e(map, source, groupName, originWP, theater) {
    let origin = originWP;
    const draw = new (0, $55fa2487efb2d4e1$export$2e2bcd8739ae039)({
        source: source,
        type: "Point",
        style: $6b95cf800967d277$var$tipStyle,
        condition: (e)=>{
            if ((0, $9c554d6df7d74017$export$8a7ef89a0633946c)(e)) return false;
            return true;
        }
    });
    draw.on("drawstart", (e)=>{
        e.feature.set("group", groupName);
        const num = origin + 1;
        e.feature.set("number", num);
        const all = source.getFeatures();
        (0, $967f9b29a6c2cdaa$export$5489fcd5d633b171)(groupName, theater)(e.feature, num, all);
        const after = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(all, (f)=>f.get("number") >= num);
        if (after) (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(after, (f, i, ary)=>(0, $967f9b29a6c2cdaa$export$5489fcd5d633b171)(groupName, theater)(f, f.get("number") + 1, ary));
        origin = num;
    });
    map.addInteraction(draw);
    return draw;
}










function $967f9b29a6c2cdaa$var$calcETA(f, speed, ary) {
    const num = f.get("number");
    const prev = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(ary, (f2)=>f2.get("number") === num - 1);
    if (!prev) return 0;
    const [long, lat] = f.getGeometry().getCoordinates();
    const p1 = {
        long: long,
        lat: lat
    };
    const [prevLong, prevLat] = prev?.getGeometry()?.getCoordinates();
    const dist = (0, $53c885ff43760466$export$7aff669504c23062)(p1, {
        long: prevLong,
        lat: prevLat
    });
    const defaultSpeed = speed;
    const hour = dist / defaultSpeed;
    const d = (0, $63618293c58b5f80$exports.Duration).fromObject({
        hour: hour
    });
    return d.toMillis() / 1000 + prev.get("eta");
}
const $967f9b29a6c2cdaa$var$DEFAULT_FIXED_WING_SPEED = 270;
function $967f9b29a6c2cdaa$export$c999f2d6f6786ad6(theater, f, i, ary) {
    const eta = $967f9b29a6c2cdaa$var$calcETA(f, $967f9b29a6c2cdaa$var$DEFAULT_FIXED_WING_SPEED, ary);
    const [long, lat] = f.getGeometry().getCoordinates();
    const coords = (0, $79e13355954d15ea$export$43105f50ad4fdfb0)(theater, {
        long: long,
        lat: lat
    });
    const all = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(ary, (p)=>{
        const props = p.getProperties();
        const [long, lat] = p.getGeometry().getCoordinates();
        const { x: x, y: y } = (0, $79e13355954d15ea$export$43105f50ad4fdfb0)(theater, {
            long: long,
            lat: lat
        });
        return {
            ...props,
            x: x,
            y: y
        };
    });
    const fakeWP = {
        number: i,
        ...coords
    };
    const { leg: leg, total: total } = (0, $a48a327511f3c8e6$export$1b3e02615f43c5ec)(theater, fakeWP, all);
    f.set("legDistance", leg);
    f.set("totalDistance", total);
    f.set("eta", eta);
}
const $967f9b29a6c2cdaa$export$5489fcd5d633b171 = (group, theater)=>(f, i, ary)=>{
        f.set("number", i);
        f.set("group", group);
        f.set("alt", 0);
        f.set("featureClass", (0, $91a9098e14452db2$export$589bf38da6f496d9).Waypoint);
        const name = f.get("name");
        const nameIsNumber = !(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).isNaN(parseInt(name));
        if (nameIsNumber || !name) f.set("name", i.toString());
        f.set("title", `${group} Waypoint ${i}`);
        $967f9b29a6c2cdaa$export$c999f2d6f6786ad6(theater, f, i, ary);
    };
const $967f9b29a6c2cdaa$var$sourceNameKey = "sourceName";
class $967f9b29a6c2cdaa$export$94f9ebee7391203a {
    constructor(mgr, manifest, onSuccess, onError){
        this.mgr = mgr;
        this.manifest = manifest;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
    init(theater, groups) {
        if (!this.map) // Handle when the user clicks "planning mode" before the map is ready
        return;
        this.sources = [];
        this.layers = [];
        this.theater = theater;
        const mapLayers = this.map.getLayers().getArray();
        for (const g of groups){
            const layer = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(mapLayers, (l)=>l.get("name") === g.name);
            if (layer) {
                const source = layer.getSource();
                source.set($967f9b29a6c2cdaa$var$sourceNameKey, g.name);
                this.sources.push(source);
                this.layers.push(layer);
                layer.setStyle((0, $a3631ef098ab8d4c$export$c692a1d3c0fd781b)(this.colorMap[g.name], 10, "diamond"));
            }
        }
        this.refreshModify();
    }
    toggleAddMode(enabled, group, origin) {
        // Toggling addMode comes from an external source, so we need a public API.
        if (!enabled && this.draw) {
            this.map.removeInteraction(this.draw);
            delete this.draw;
            this.inAddMode = false;
            this.refreshModify();
            return;
        }
        if (enabled) this.dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).enableWaypointDropMode
        });
        if (enabled && !this.draw) {
            const source = this.findSource(group);
            if (!source) throw new Error("no source found");
            this.draw = (0, $6b95cf800967d277$export$b72d6d1e426d510e)(this.map, source, group, origin, this.theater);
            this.inAddMode = true;
            this.draw.on("drawend", (e)=>{
                if (this.manifest.version < 3) this.handlePlanModified(e.feature.get("group"), e.feature.get("number"));
                else // Special case for PlanManagerV2
                this.handleWaypointAdded(e.feature);
            });
        }
    }
    getWaypoint(group, number) {
        const source = this.findSource(group);
        if (!source) throw new Error(`No source found for ${group}`);
        return this.findWaypoint(source, number);
    }
    findSource(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(this.sources, (s)=>s.get($967f9b29a6c2cdaa$var$sourceNameKey) === group);
    }
    findWaypoint(source, number) {
        if (!source) return null;
        const features = source.getFeatures();
        const feature = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(features, (f)=>f.get("number") === number);
        return feature;
    }
    findWaypointForGroup(group, number) {
        return this.findWaypoint(this.findSource(group), number);
    }
    getWaypointsForGroup(group) {
        const s = this.findSource(group);
        if (!s) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(s.getFeatures(), (f)=>f.getProperties());
    }
    async removeWaypoint(group, number) {
        if (this.manifest.version >= 3) try {
            await this.mgr.removeWaypoint(this.manifest.id, group, number);
            this.onSuccess();
        } catch (e) {
            this.onError(e.message);
            return;
        }
        else this.handlePlanModified(group, number);
        // Waypoints will be removed externally
        const source = this.findSource(group);
        const feature = this.findWaypoint(source, number);
        const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sortBy(source.getFeatures(), (f)=>f.get("number"));
        (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).each(sorted, $967f9b29a6c2cdaa$export$5489fcd5d633b171(group, this.theater));
        source.removeFeature(feature);
    }
    setWaypointDetails(group, number, details) {
        const source = this.findSource(group);
        if (!source) throw new Error(`source undefined for ${group}`);
        const feature = this.findWaypoint(source, number);
        if (!feature) throw new Error(`Waypoint feature ${number} not found`);
        feature.set("name", details.text);
        feature.set("altitude", details.altitude);
        feature.set("altitudeType", details.altitudeType);
        feature.set("eta", details.eta);
        // Handling a weird bug where the state gets stale.
        // Not sure why we store the whole waypoint...
        feature.set("waypoint", {
            ...feature.get("waypoint"),
            ETA: details.eta
        });
        this.handlePlanModified(group, number);
    }
    toggleModify(enabled) {
        if (this.modify) this.modify.setActive(enabled);
        for (const layer of this.layers){
            const color = this.colorMap[layer.get("name")];
            const style = enabled ? (0, $a3631ef098ab8d4c$export$c692a1d3c0fd781b)(color, 10, "diamond") : (0, $a3631ef098ab8d4c$export$c692a1d3c0fd781b)(color, 5);
            layer.setStyle(style);
        }
    }
    refreshModify() {
        // When a waypoint is added, modified or removed,
        // remove modify from the map and add a new interaction with the current features.
        if (this.modify) {
            this.map.removeInteraction(this.modify);
            delete this.modify;
        }
        let features = [];
        for (const source of this.sources){
            for (const feature of source.getFeatures())if (feature.get("number") !== 0) features.push(feature);
        }
        const featuresCollection = new (0, $931ffc4e747c14db$export$2e2bcd8739ae039)(features);
        this.modify = new (0, $8c24f34a0807f744$export$2e2bcd8739ae039)({
            style: $967f9b29a6c2cdaa$export$fa3c645580ddb473,
            features: featuresCollection
        });
        this.modify.on("modifyend", (e)=>{
            const f = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(e.features.getArray());
            const source = this.findSource(f.get("group"));
            const allFeatures = source.getFeatures();
            const prev = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(allFeatures, (w)=>w.get("number") === f.get("number") - 1);
            if (prev) {
                const d = (0, $53c885ff43760466$export$7aff669504c23062)({
                    long: prev.getGeometry().getCoordinates()[0],
                    lat: prev.getGeometry().getCoordinates()[1]
                }, {
                    long: f.getGeometry().getCoordinates()[0],
                    lat: f.getGeometry().getCoordinates()[1]
                });
                f.set("legDistance", d);
            }
            const next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(allFeatures, (w)=>w.get("number") === f.get("number") + 1);
            if (next) {
                const d = (0, $53c885ff43760466$export$7aff669504c23062)({
                    long: f.getGeometry().getCoordinates()[0],
                    lat: f.getGeometry().getCoordinates()[1]
                }, {
                    long: next.getGeometry().getCoordinates()[0],
                    lat: next.getGeometry().getCoordinates()[1]
                });
                next.set("legDistance", d);
            }
            this.handlePlanModified(f.get("group"), f.get("number"));
        });
        this.map.addInteraction(this.modify);
    }
    async v2UpdateWaypoint(groupName, feature) {
        // V3 and higher uses the PlanManagerV2 to auto submit waypoints.
        if (this.manifest.version >= 3) try {
            await this.mgr.upsertWaypoint(this.manifest.id, this.user, groupName, (0, $92839c6c950486dc$export$38c4cb5fbd3d765a)(this.theater)(feature));
        } catch (e) {
            const isPlanningConflict = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(e.message, "Missing or insufficient permissions");
            if (isPlanningConflict) {
                const existing = await this.mgr.get(this.manifest.id, (0, $3688fdfd7954d49f$export$58047b57cdffebb3).Waypoint, groupName, feature.get("number").toString());
                this.onError("This waypoint has already been planned by another user: " + existing?.createdByUserName);
                return;
            }
            this.onError(e.message);
        }
    }
    handlePlanModified(groupName, number) {
        this.dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).setPlanStatus,
            groupName: groupName,
            status: (0, $319680b363c8af04$export$60715063f26dc4e3).Draft
        });
        if (number !== null) {
            const f = this.findWaypointForGroup(groupName, number);
            if (f) this.v2UpdateWaypoint(groupName, f);
        } else {
            // Need to update all waypoints in the group
            const source = this.findSource(groupName);
            const features = source.getFeatures();
            for (const f of features)this.v2UpdateWaypoint(groupName, f);
        }
        this.onSuccess();
    }
    handleWaypointAdded(feature) {
        this.v2UpdateWaypoint(feature.get("group"), feature);
        this.onSuccess();
    }
    getPlanningLayers() {
        return this.layers;
    }
    copyWaypoints(fromGroup, toGroup, unplannableGroups) {
        const fromSource = this.findSource(fromGroup);
        let wps = [];
        if (fromSource) wps = fromSource.getFeatures();
        else {
            const waypoints = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(unplannableGroups, {
                name: fromGroup
            }).waypoints;
            wps = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(waypoints, (w)=>{
                const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(this.theater, w);
                const geometry = new (0, $6eced4c969949f6b$export$2e2bcd8739ae039)([
                    long,
                    lat
                ]);
                return new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
                    ...w,
                    geometry: geometry
                });
            });
        }
        const toGroupSource = this.findSource(toGroup);
        if (!toGroupSource) throw new Error(`No source found for ${toGroup}`);
        toGroupSource.forEachFeature((f)=>{
            toGroupSource.removeFeature(f);
        });
        const next = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(wps, (f)=>f.clone());
        for (const f of next){
            f.set("group", toGroup);
            toGroupSource.addFeature(f);
        }
        const layer = this.getLayerForGroup(toGroup);
        layer.setStyle((0, $a3631ef098ab8d4c$export$c692a1d3c0fd781b)(this.colorMap[toGroup], 10, "diamond"));
        this.handlePlanModified(toGroup, null);
        this.refreshModify();
    }
    getLayerForGroup(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).find(this.layers, (l)=>l.get("name") === group);
    }
    setWaypointCoords(group, number, coords) {
        const source = this.findSource(group);
        const feature = this.findWaypoint(source, number);
        feature.getGeometry().setCoordinates(coords);
        this.handlePlanModified(group, number);
    }
}
function $967f9b29a6c2cdaa$export$f148cdf633173803(map, dispatch, colorMap, manifest, mgr, user, onSuccess, onError) {
    const c = new $967f9b29a6c2cdaa$export$94f9ebee7391203a(mgr, manifest, onSuccess, onError);
    c.inAddMode = false;
    c.dispatch = dispatch;
    c.map = map;
    c.colorMap = colorMap;
    c.user = user;
    return c;
}
const $967f9b29a6c2cdaa$export$fa3c645580ddb473 = (f)=>{
    const v = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).first(f.get("features"));
    const g = v.get("group");
    return new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
        image: new (0, $06150d8570b7481b$export$2e2bcd8739ae039)({
            radius: 5,
            stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.7)"
            }),
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.4)"
            })
        }),
        text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
            text: `${g} - Drag to modify`,
            font: "12px Roboto,sans-serif",
            fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "rgba(255, 255, 255, 1)"
            }),
            backgroundFill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: "rgba(0, 0, 0, 0.7)"
            }),
            padding: [
                2,
                2,
                2,
                2
            ],
            textAlign: "left",
            offsetX: 15
        })
    });
};



function $fb934c810b967226$export$2e2bcd8739ae039() {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const { state: state, controller: controller, dispatch: dispatch, navPointController: navPointController } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const waypointManager = (0, $1ae4eb57bb4d8f1b$export$7a90b43b29d22817)();
    const navPointManager = (0, $1ae4eb57bb4d8f1b$export$352d37a1384d31c3)();
    // If the plan has been invalidated, we don't want to show it to most users.
    // We only want to sho invalidated plans to the plan submitter so they can resubmit.
    const planOpts = state.planningMode ? {
        user: currentUser
    } : {
        status: (0, $319680b363c8af04$export$60715063f26dc4e3).Submitted
    };
    const { data: groups } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(state.manifest.fragOrderID, state.tasking.plannedGroups, planOpts);
    $acw62.useEffect(()=>{
        if (!map) return;
        if (!state.planningMode) {
            controller.current?.toggleModify(false);
            navPointController.current?.toggleModify(false);
            return;
        } else {
            controller.current?.toggleModify(true);
            navPointController.current?.toggleModify(true);
        }
        const userPlannable = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(groups, (g)=>(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes(state.userPlannableGroups, g.name));
        if (!controller.current || groups.length === 0) {
            controller.current = (0, $967f9b29a6c2cdaa$export$f148cdf633173803)(map, dispatch, state.colorMap, state.manifest, waypointManager, currentUser, ()=>success("Plan saved"), (e)=>error(e));
            controller.current.init(state.tasking.theater, userPlannable);
        }
        if (!navPointController.current) {
            navPointController.current = new (0, $c5fc096bd6b39220$export$b110defd32f23aa0)(map, dispatch, state.colorMap, state.manifest, navPointManager, currentUser, state.tasking.theater, ()=>success("Plan saved"), (e)=>error(e));
            navPointController.current.init(userPlannable);
        }
    }, [
        map,
        groups,
        state.planningMode
    ]);
    $acw62.useEffect(()=>{
        if (!state.waypointDropMode && controller.current?.inAddMode) controller.current.toggleAddMode(false);
    }, [
        state.waypointDropMode
    ]);
    return null;
}








var $acw62 = parcelRequire("acw62");

function $32369d0622d1e6d2$export$2e2bcd8739ae039() {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const layer = new (0, $32e67a4d3559554a$export$2e2bcd8739ae039)({
            source: new (0, $492792e764651581$export$2e2bcd8739ae039)({
                url: "https://api.maptiler.com/tiles/hillshades/tiles.json?key=FjTRMbK3Ct060QVlsxbx",
                tileSize: 256,
                crossOrigin: "anonymous"
            })
        });
        layer.set("name", "Terrain");
        layer.set("hideable", true);
        map.addLayer(layer);
    }, [
        map
    ]);
    return null;
}




var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");








function $e6ccfa64233a83e0$export$12687aa6aa744dfc(theater, zones) {
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(zones, (zone)=>{
        const { lat: lat, long: long } = (0, $79e13355954d15ea$export$7d61ade677ae99ee)(theater, zone.origin);
        const point = [
            long,
            lat
        ];
        let geometry = (0, $40aa8d43bbe572bf$export$f99d756c6d81ae3f)(point, zone.radius);
        if (zone.type === (0, $91a9098e14452db2$export$36336b2cf50fd5df).Quad) {
            const zoneCoords = (0, $79e13355954d15ea$export$b668502fb6da9201)(theater, zone.verticies);
            geometry = new (0, $40aa8d43bbe572bf$export$2e2bcd8739ae039)([
                zoneCoords
            ]);
        }
        const f = new (0, $9fd014ab6df63665$export$2e2bcd8739ae039)({
            type: "Polygon",
            geometry: geometry,
            color: zone.color,
            name: zone.name
        });
        return f;
    });
    const layer = new (0, $82a68515bd6ef378$export$2e2bcd8739ae039)({
        declutter: true,
        source: new (0, $84888e4daf3fdf44$export$2e2bcd8739ae039)({
            features: features
        }),
        style: (feature)=>{
            const [r, g, b, a] = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).map(feature.get("color"), (c)=>{
                const k = c * 255;
                return k;
            });
            const colorFill = new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                color: `rgb(${r},${g},${b}, 1)`
            });
            return [
                new (0, $8c7f6dda98e8cb9c$export$2e2bcd8739ae039)({
                    stroke: new (0, $f9d0329c5c745263$export$2e2bcd8739ae039)({
                        color: `rgb(${r},${g},${b}, 1)`,
                        width: 2
                    }),
                    fill: new (0, $d61d1dcaf3c44610$export$2e2bcd8739ae039)({
                        color: `rgb(${r},${g},${b}, ${a / 255})`
                    }),
                    text: new (0, $944be50faeff5321$export$2e2bcd8739ae039)({
                        overflow: true,
                        font: 'bold 14px "Arial", "Arial Unicode MS", "sans-serif"',
                        placement: "point",
                        fill: colorFill,
                        text: feature.get("name")
                    })
                })
            ];
        }
    });
    layer.set("name", "Zones");
    return layer;
}



function $f6d40296e641c071$export$2e2bcd8739ae039({ theater: theater, zones: zones }) {
    const map = (0, $5790baaab4a6e44c$export$86f8f9f08863e403)();
    (0, $acw62.useEffect)(()=>{
        if (!map) return;
        const layer = (0, $e6ccfa64233a83e0$export$12687aa6aa744dfc)(theater, zones);
        layer.set("hideable", true);
        map.addLayer(layer);
    }, [
        map
    ]);
    return null;
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");










var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

parcelRequire("acw62");





function $9314f40b18413625$var$MapTitle({ className: className }) {
    const { state: { manifest: manifest, tasking: tasking } } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    let d = (0, $63618293c58b5f80$exports.DateTime).fromISO(tasking.time.toString(), {
        zone: "utc"
    });
    const zulu = d.minus({
        hour: (0, $e1dc1ccf277543ba$export$59c99f3515d3493f)(tasking.theater)
    }).toLocaleString((0, $63618293c58b5f80$exports.DateTime).TIME_24_SIMPLE);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                padding: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                    align: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            mr: 4,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                fontSize: 24,
                                children: manifest.title
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                            columns: 3,
                            pairs: [
                                {
                                    key: "Coalition",
                                    value: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: manifest.coalition
                                        },
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(manifest.coalition)
                                    })
                                },
                                {
                                    key: "Theater",
                                    value: (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).upperCase((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).lowerCase(tasking.theater))
                                },
                                {
                                    key: "Start Time (zulu/local)",
                                    value: `${zulu}/${d.toLocaleString((0, $63618293c58b5f80$exports.DateTime).TIME_24_SIMPLE)}`
                                }
                            ]
                        })
                    ]
                })
            })
        })
    });
}
var $9314f40b18413625$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($9314f40b18413625$var$MapTitle).attrs({
    className: $9314f40b18413625$var$MapTitle.name
})`
  opacity: 0.8;

  ${(0, $a0e83392a1945b28$export$2e2bcd8739ae039)} {
    .MuiTableCell-root {
      padding: 4px 6px;
      border-bottom: 0;
    }
  }

  @media only screen and (max-width: 844px) {
    .KeyValueTable {
      display: none;
    }
  }
`;


function $7cd9fcb3274b71ea$var$PublicHeader({ className: className }) {
    const { currentUser: currentUser, logout: logout } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const isUIDisabled = (0, $99f46708ff5ed621$export$b4f230b1bcff1dd6)();
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleLogout = ()=>{
        handleClose();
        logout();
        history.push((0, $91a9098e14452db2$export$37d3279522fbf5e2).Login);
    };
    if (isUIDisabled) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
        className: className,
        wide: true,
        between: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            between: true,
            align: true,
            className: "grid-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    mr: 1,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f167d3e4f22a6e20$export$2e2bcd8739ae039), {
                        to: (0, $91a9098e14452db2$export$37d3279522fbf5e2).Home,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed173ba6c38830a3$export$2e2bcd8739ae039), {
                                className: "full-logo",
                                width: 140,
                                height: 84
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed173ba6c38830a3$export$2e2bcd8739ae039), {
                                className: "mobile-logo",
                                variant: (0, $ed173ba6c38830a3$export$aadcd836922b29de).Solo,
                                height: 56
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9314f40b18413625$export$2e2bcd8739ae039), {
                    className: "item1"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "item2",
                    children: currentUser ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                        onClick: handleClick,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {
                            alt: currentUser.username,
                            src: `https://cdn.discordapp.com/avatars/${currentUser?.id}/${currentUser.avatar}.png`
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5e8911e4b30dc90$export$2e2bcd8739ae039), {
                        style: {
                            display: isUIDisabled ? "none" : "block"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), {
                    id: "demo-positioned-menu",
                    "aria-labelledby": "demo-positioned-button",
                    anchorEl: anchorEl,
                    open: Boolean(anchorEl),
                    onClose: handleClose,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                history.push((0, $91a9098e14452db2$export$37d3279522fbf5e2).UserSettings);
                                handleClose();
                            },
                            children: "Settings"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                            onClick: handleLogout,
                            children: "Logout"
                        })
                    ]
                })
            ]
        })
    });
}
var $7cd9fcb3274b71ea$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($7cd9fcb3274b71ea$var$PublicHeader).attrs({
    className: $7cd9fcb3274b71ea$var$PublicHeader.name
})`
  position: absolute;
  top: 0;
  height: 96px;
  width: 100%;
  z-index: 2;

  ${(0, $e5e8911e4b30dc90$export$2e2bcd8739ae039)} {
    margin-right: 16px;

    @media only screen and (max-width: 1300px) {
      display: none;
    }
  }

  ${(0, $e5e8911e4b30dc90$export$2e2bcd8739ae039)} .MuiButton-root {
    margin: 0 auto;
    background-color: white;
  }

  .mobile-logo {
    display: none;
  }

  @media only screen and (max-width: 1300px) {
    .full-logo {
      display: none;
    }

    .mobile-logo {
      display: block;
    }
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



function $cf7846394063c848$var$VizControls({ className: className }) {
    const { state: state, dispatch: dispatch } = (0, $99f46708ff5ed621$export$3120560bb593c233)();
    const handleDistancesClick = ()=>{
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).disableDistances,
            enabled: !state.disableDistances
        });
    };
    const handleWaypointLabelsClick = ()=>{
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).disableWaypointLabels,
            enabled: !state.disableWaypointLabels
        });
    };
    const handleToggleCompass = ()=>{
        dispatch({
            type: (0, $99f46708ff5ed621$export$159e21535af98b26).toggleCompassViz,
            enabled: !state.compassVisible
        });
    };
    if (state.disableUI) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                p: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: 0
                            },
                            fontSize: 16,
                            children: "Map Controls"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                        column: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                        checked: !state.disableDistances,
                                        onChange: handleDistancesClick
                                    }),
                                    label: "Show Distances"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                        checked: !state.disableWaypointLabels,
                                        onChange: handleWaypointLabelsClick
                                    }),
                                    label: "Show Waypoint Labels"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                        checked: state.compassVisible,
                                        onChange: handleToggleCompass
                                    }),
                                    label: "Show Bulls Compass"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $cf7846394063c848$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($cf7846394063c848$var$VizControls).attrs({
    className: $cf7846394063c848$var$VizControls.name
})`
  position: absolute;
  left: 64px;
  bottom: 48px;
  z-index: 1;

  opacity: 0.8;

  @media only screen and (max-width: 1300px) {
    display: none;
  }

  @media only screen and (max-height: 700px) {
    left: 32px;
  }
`;


// Just an empty wrapper so we can introspect child props and organize layer controls.
function $036f68940bac4849$var$LayerControlGroup({ children: children }) {
    return children;
}
function $036f68940bac4849$var$TaskingMap({ className: className, navWidth: navWidth }) {
    const { state: { tasking: tasking, planningMode: planningMode, manifest: manifest, disableDistances: disableDistances, disableWaypointLabels: disableWaypointLabels } } = $acw62.useContext((0, $99f46708ff5ed621$export$c9b1963ef22ba7a5));
    (0, $99f46708ff5ed621$export$4448fc5d2712794a)();
    const { data: planItems } = (0, $1ae4eb57bb4d8f1b$export$3831e5e3bab5431f)(manifest?.id);
    const navPointPlanItems = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(planItems, {
        type: (0, $3688fdfd7954d49f$export$58047b57cdffebb3).NavPoint
    });
    if (!tasking.plannedGroups || !tasking.theater) return null;
    const { theater: theater } = tasking;
    const extent = (0, $79e13355954d15ea$export$7ed87cae1557ab30)(theater);
    const { isLoading: isLoading, data: groups } = (0, $92839c6c950486dc$export$eb9ef5d0eda4b7a6)(manifest.fragOrderID, tasking.plannedGroups);
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, {
            "planning-mode": planningMode
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cd9fcb3274b71ea$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                between: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8396d1566d56485e$export$79de27f3d89caa16), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5790baaab4a6e44c$export$2e2bcd8739ae039), {
                            offsetLeft: navWidth,
                            theater: theater,
                            initialExtent: extent,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81ef60e3f0a87a39$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $18ad72aaccb3a4a7$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($036f68940bac4849$var$LayerControlGroup, {
                                    name: "Layers",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d01ea076d3638331$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32369d0622d1e6d2$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48252d8bfb57141$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6221a2138ef0f90$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bf64f63e772c9ba$export$2e2bcd8739ae039), {
                                            theater: tasking.theater,
                                            bases: tasking.airbases,
                                            isOpfor: false
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bf64f63e772c9ba$export$2e2bcd8739ae039), {
                                            theater: tasking.theater,
                                            bases: tasking.opforAirbases,
                                            isOpfor: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5404f6a81ab6ced0$export$2e2bcd8739ae039), {
                                            name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).Friendlies,
                                            theater: theater,
                                            groups: tasking.bluforVehicles,
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5404f6a81ab6ced0$export$2e2bcd8739ae039), {
                                            name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).FriendlyShips,
                                            theater: theater,
                                            groups: tasking.bluforShips,
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3859dfdbaccd3932$export$2e2bcd8739ae039), {
                                            name: (0, $91a9098e14452db2$export$fb028bc55343bb1f).OPFORShips,
                                            theater: theater,
                                            groups: tasking.opforShips
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26edd936cfd125a0$export$2e2bcd8739ae039), {
                                            theater: theater,
                                            groups: tasking.supportAssets
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75805bbbe267c6b2$export$2e2bcd8739ae039), {
                                            theater: theater,
                                            groups: tasking.opforVehicles
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f3f079e0bcbf250$export$2e2bcd8739ae039), {
                                            theater: theater,
                                            groups: tasking.opforStatics
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53941ccde1a78f2f$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d49379707a571fbc$export$2e2bcd8739ae039), {
                                            theater: theater,
                                            groups: [
                                                ...tasking.opforVehicles,
                                                ...tasking.opforShips || []
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3281a17204bf93b$export$2e2bcd8739ae039), {
                                            theater: theater,
                                            groups: tasking.bluforVehicles
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6d40296e641c071$export$2e2bcd8739ae039), {
                                            theater: theater,
                                            zones: tasking.zones
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef857df75211522c$export$2e2bcd8739ae039), {
                                            theater: theater,
                                            bullseye: tasking.bullseye
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50f4a82b70a68396$export$2e2bcd8739ae039), {
                                            theater: tasking.theater,
                                            points: tasking.controlPoints
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bc458713ae03df2$export$2e2bcd8739ae039), {
                                    layerName: (0, $91a9098e14452db2$export$fb028bc55343bb1f).PlayerGroups,
                                    theater: theater,
                                    groups: groups,
                                    disableDistanceLabels: disableDistances,
                                    disableWaypointLabels: disableWaypointLabels,
                                    planItemNavPoints: navPointPlanItems
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fb934c810b967226$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf7846394063c848$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                })
            })
        ]
    });
}
var $036f68940bac4849$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($036f68940bac4849$var$TaskingMap).attrs({
    className: $036f68940bac4849$var$TaskingMap.name
})`
  position: relative;

  ${(0, $18ad72aaccb3a4a7$export$2e2bcd8739ae039)} {
    position: fixed;
    left: 50%;
    bottom: 48px;
    transform: translateX(-50%);
    z-index: 1;
  }
`;








function $5a5fe601f9b9e371$var$PublicFragOrder({ className: className }) {
    const { currentUser: currentUser } = (0, $5f078b543969ac27$export$23bbbc4533528f03)();
    const { id: id } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const { embed: embed } = (0, $3ecb7368762fc268$export$98e6a39c04603d36)(window.location.search);
    const { data: manifest, isLoading: isLoading, error: error } = (0, $a10ff9c4760c9625$export$57d2af22cd01eebc)(id);
    const { data: tasking, isLoading: isLoadingBundle } = (0, $aae70ce689e02dd3$export$f760ffd5af329347)(manifest);
    const isLoadingTasking = !tasking || isLoadingBundle;
    const { data: controlMeasures, isLoading: isLoadingControlMeasures } = (0, $302106ffa43351a6$export$5dad9a454d8c40c0)(id);
    if (isLoading || isLoadingControlMeasures || isLoadingTasking) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $049080dc6d82c9d7$export$2e2bcd8739ae039), {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47b3c0eb5fee4469$export$2e2bcd8739ae039), {
        message: error.message
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99f46708ff5ed621$export$6b4e12d920b219ca), {
            tasking: tasking,
            publish: manifest,
            plannableGroups: (0, $b88c63f4bcc6d929$export$9ca7028c3a5b35c3)(manifest, currentUser),
            controlMeasures: controlMeasures,
            disableUI: !!embed,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $036f68940bac4849$export$2e2bcd8739ae039), {})
        })
    });
}
var $5a5fe601f9b9e371$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($5a5fe601f9b9e371$var$PublicFragOrder)`
  margin: 0;
  padding: 0;
  overflow: hidden;
`;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");







function $ccb644a00c554876$var$StripeCallback({ className: className }) {
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [error, setError] = $acw62.useState(null);
    const { session_id: session_id } = (0, (/*@__PURE__*/$parcel$interopDefault($3ecb7368762fc268$exports))).parse(window.location.search);
    const mgr = (0, $e1f03c0083d00e9b$export$b20e0e0e34545542)();
    $acw62.useEffect(()=>{
        mgr.recordSessionResult(session_id).then(()=>{
            history.push((0, $91a9098e14452db2$export$37d3279522fbf5e2).UserSettings);
        }).catch((err)=>setError(err));
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
            wide: true,
            center: true,
            children: error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47b3c0eb5fee4469$export$2e2bcd8739ae039), {
                message: error.message
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {})
        })
    });
}
var $ccb644a00c554876$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($ccb644a00c554876$var$StripeCallback)``;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");

parcelRequire("acw62");







function $a1a4213617c9b931$var$SubscriptionManagement({ className: className, subscription: sub, stripeDetails: details }) {
    const portalURL = (0, $3e8772b7528d3c44$export$ebbade5b631a7d1)();
    const priceID = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(details, "items.data[0].price.id");
    const lookup = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).invert((0, $dbf86a8fe13ef9de$export$6ea95f79cb07057b));
    const priceDisplayText = lookup[priceID];
    const subFields = [
        {
            key: "Subscription Status",
            value: sub?.enabled ? "Active" : "Inactive"
        },
        {
            key: "Plan",
            value: sub?.parentID ? "Group Volume License" : (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).capitalize(priceDisplayText)
        },
        {
            key: "Message",
            value: sub?.message || null
        }
    ];
    if (details?.current_period_end) subFields.push({
        key: "Billing Period Ends",
        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
            relative: false,
            format: (0, $63618293c58b5f80$exports.DateTime).DATE_SHORT,
            time: details?.current_period_end * 1000
        })
    });
    if (details?.trial_end && details?.status === "trialing") subFields.push({
        key: "Trial Ends",
        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
            relative: false,
            format: (0, $63618293c58b5f80$exports.DateTime).DATE_SHORT,
            time: details?.trial_end * 1000
        })
    });
    const handleManageClick = async ()=>{
        const u = await portalURL(sub?.stripeCustomerID);
        window.location.href = u;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                wide: true,
                center: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0e83392a1945b28$export$2e2bcd8739ae039), {
                    columns: 3,
                    pairs: subFields
                })
            }),
            details && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginTop: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    onClick: handleManageClick,
                    variant: "outlined",
                    children: "Manage Subscription"
                })
            }),
            !sub?.enabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41706c3e03419308$export$2e2bcd8739ae039), {
                trialUnavailable: sub?.trialCompleted
            })
        ]
    });
}
var $a1a4213617c9b931$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a1a4213617c9b931$var$SubscriptionManagement).attrs({
    className: $a1a4213617c9b931$var$SubscriptionManagement.name
})``;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");








function $d6937b09f7ac867c$var$VolumeLicense({ className: className, parent: parent }) {
    const [creating, setCreating] = $acw62.useState(false);
    const [revoking, setRevoking] = $acw62.useState(null);
    const { data: subs, isLoading: isLoading } = (0, $3e8772b7528d3c44$export$dad3cdff3edc5a39)(parent);
    const addSub = (0, $3e8772b7528d3c44$export$1e8ac4b0c4da1373)();
    const revoke = (0, $3e8772b7528d3c44$export$f4757fa847ff3a94)();
    const { success: success, error: error } = (0, $9e9e9cb50078a9ef$export$9949bd9c713ba425)();
    const handleAdd = ()=>{
        setCreating(true);
        return addSub(parent).then(()=>{
            success("License added successfully");
        }).catch((e)=>{
            error(e.message);
        }).finally(()=>{
            setCreating(false);
        });
    };
    const handleRevoke = (r)=>{
        setRevoking(r);
        return revoke(r.subscriptionID).then(()=>{
            success("License revoked successfully");
        }).catch((e)=>{
            error(e.message);
        }).finally(()=>{
            setRevoking(null);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
        className: className,
        loading: isLoading,
        title: "Group Licenses",
        actions: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                align: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        mr: 2,
                        children: [
                            "Usage: ",
                            subs?.length,
                            " / 4 "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                        loading: creating,
                        variant: "contained",
                        onClick: handleAdd,
                        disabled: subs?.length >= 4,
                        children: "Add License"
                    }, "add")
                ]
            }, "usage")
        ],
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
            columns: [
                {
                    label: "Claimed By",
                    value: (v)=>v.redeemedByDisplayName || "Unclaimed"
                },
                {
                    label: "Claimed At",
                    value: (v)=>v.redeemedAt ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                            time: v.redeemedAt
                        }) : "-"
                },
                {
                    label: "Redeem Link",
                    value: (v)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            disabled: !!v.redeemedAt,
                            onClick: ()=>{
                                const url = `${window.location.origin}${(0, $91a9098e14452db2$export$37d3279522fbf5e2).RedeemCode}?code=${v.oneTimeCode}`;
                                navigator.clipboard.writeText(url);
                                success("Link copied to clipboard");
                            },
                            size: "small",
                            children: "Copy Link"
                        })
                },
                {
                    value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                            time: r.createdAt
                        }),
                    label: "Created At"
                },
                {
                    value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6139cb5be32bc930$export$2e2bcd8739ae039), {
                            loading: revoking?.id === r.id,
                            onClick: ()=>handleRevoke(r),
                            variant: "outlined",
                            color: "error",
                            disabled: !r.subscriptionID,
                            children: "Revoke"
                        }),
                    label: ""
                }
            ],
            rows: subs || []
        })
    });
}
var $d6937b09f7ac867c$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($d6937b09f7ac867c$var$VolumeLicense).attrs({
    className: $d6937b09f7ac867c$var$VolumeLicense.name
})``;



var $ayMG0 = parcelRequire("ayMG0");


var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");






function $41d8ae07d4a2f554$var$SavedRadioConfigs({ className: className }) {
    const { data: data, isLoading: isLoading, error: error } = (0, $49b61c4bd4225956$export$764b58f9e83d22d4)();
    const remove = (0, $49b61c4bd4225956$export$db878806a63245d5)();
    const radioConfigs = (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).filter(data, {
        type: (0, $63d3b55e22230398$export$97e73da130bb747d).RadioPresetConfig
    });
    const columns = [
        {
            value: "name",
            label: "Name"
        },
        {
            value: "type",
            label: "Type"
        },
        {
            value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                    time: r.created_at_timestamp
                }),
            label: "Created"
        },
        {
            value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $665d5b1998f592d3$export$2e2bcd8739ae039), {
                    time: r.updated_at_timestamp
                }),
            label: "Updated At"
        },
        {
            label: "",
            value: (r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    variant: "outlined",
                    color: "error",
                    onClick: ()=>{
                        if (window.confirm("Are you sure you want to delete this?")) remove(r);
                    },
                    children: "Delete"
                })
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        loading: isLoading,
        className: className,
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                severity: "error",
                children: "There was an error loading your saved radio configurations."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67963b09fdec1ded$export$2e2bcd8739ae039), {
                columns: columns,
                rows: radioConfigs
            })
        ]
    });
}
var $41d8ae07d4a2f554$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($41d8ae07d4a2f554$var$SavedRadioConfigs).attrs({
    className: $41d8ae07d4a2f554$var$SavedRadioConfigs.name
})``;




function $c5389d9d58bbc4b2$var$UserSettings({ className: className }) {
    const { data: sub, isLoading: isLoading, error: error, isError: isError } = (0, $3e8772b7528d3c44$export$58321a13afb85c65)();
    const grantedByAdmin = sub && sub?.subscription?.origin === (0, $49e655d557af2da9$export$6f169d678831145).SuperAdmin;
    const is404 = error?.message.includes("not_found") || error?.message.includes("Not Found");
    const isExistingCustomer = !is404;
    const renderCTA = grantedByAdmin || !sub?.subscription?.enabled || is404;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $89e98e2acd277cd3$export$2e2bcd8739ae039), {
        loading: isLoading && !isError,
        title: "Settings",
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                title: "Subscription",
                children: [
                    grantedByAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7b9f0ef25189a24$export$2e2bcd8739ae039), {
                        severity: "info",
                        children: "Your subscription has been granted by a Frag Orders site admin. No payment is required at this time. Enjoy!"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        marginTop: 2,
                        children: !isExistingCustomer && renderCTA ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41706c3e03419308$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1a4213617c9b931$export$2e2bcd8739ae039), {
                            subscription: sub?.subscription,
                            stripeDetails: sub?.details
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginTop: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926fc19b1a64a878$export$2e2bcd8739ae039), {
                    title: "Preferences",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41d8ae07d4a2f554$export$2e2bcd8739ae039), {})
                })
            }),
            sub?.subscription?.isVolume && sub?.subscription.enabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                marginTop: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6937b09f7ac867c$export$2e2bcd8739ae039), {
                    parent: sub?.subscription
                })
            })
        ]
    });
}
var $c5389d9d58bbc4b2$export$2e2bcd8739ae039 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c5389d9d58bbc4b2$var$UserSettings).attrs({
    className: $c5389d9d58bbc4b2$var$UserSettings.name
})``;


$07b303fd558e140e$export$2cd8252107eb640b({
    enabled: true,
    dsn: "https://0bd7aacb110bb168950d0876b2e3b632@o4507952514531328.ingest.us.sentry.io/4507952517414912",
    integrations: [
        $400f75f99113439b$export$b4109253475213e9(),
        $0ca4f63b79e931bd$export$d7706faf7ab354bf(),
        $9d8f9caef3f3d2e5$export$71ba62165d5c834d()
    ],
    // Tracing
    tracesSampleRate: 1.0,
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
});
var $cd93687958c8007e$export$e5d97828673c2a38;
(function(AppMode) {
    AppMode["Admin"] = "admin";
    AppMode["Public"] = "public";
})($cd93687958c8007e$export$e5d97828673c2a38 || ($cd93687958c8007e$export$e5d97828673c2a38 = {}));
const $cd93687958c8007e$var$fetcher = (0, $d50b0bcc71cd47ca$export$dc242f1fb6cc2e41)(fetch);
const { app: $cd93687958c8007e$var$app, auth: $cd93687958c8007e$var$auth, db: $cd93687958c8007e$var$db } = (0, $1d8101519e016e43$export$2cd8252107eb640b)();
const $cd93687958c8007e$var$ms = (0, $4e742bcc5d262bd2$export$8d22906962e7fb92)(fetch);
const $cd93687958c8007e$var$queryClient = new (0, $13e074efb1ecf7c6$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: Infinity,
            cacheTime: Infinity
        }
    }
});
const $cd93687958c8007e$var$bc = new (0, $3acbdcaf0de87f6a$export$45c3e80f98926acf)(fetch);
const $cd93687958c8007e$var$am = (0, $6992b055e10e3f03$export$2b7de4888b447519)($cd93687958c8007e$var$fetcher, $cd93687958c8007e$var$db);
const $cd93687958c8007e$var$cm = new (0, $023ddb6726cc13b3$export$7086111a3bcda9b5)($cd93687958c8007e$var$db);
const $cd93687958c8007e$var$pub = (0, $11a058875073ec02$export$34dc733d48e09033)($cd93687958c8007e$var$db, $cd93687958c8007e$var$ms, $cd93687958c8007e$var$am, $cd93687958c8007e$var$bc);
const $cd93687958c8007e$var$reader = (0, $11a058875073ec02$export$47748165199cad2c)($cd93687958c8007e$var$db, $cd93687958c8007e$var$bc);
const $cd93687958c8007e$var$discord = (0, $65393fe344922b74$export$40e2ba5c7bbe50c4)(fetch);
const $cd93687958c8007e$var$signups = new (0, $b162211719c94af8$export$9aa66a1a3d88e97b)($cd93687958c8007e$var$fetcher, $cd93687958c8007e$var$db);
const $cd93687958c8007e$var$fo = (0, $50dfa3f756c4c37a$export$db3faf3b9ad65b42)($cd93687958c8007e$var$db, $cd93687958c8007e$var$ms, $cd93687958c8007e$var$pub);
const $cd93687958c8007e$var$external = new (0, $96428ae11b0a5fbb$export$7f21f80a8d38e0d5)($cd93687958c8007e$var$db, $cd93687958c8007e$var$fo);
const $cd93687958c8007e$var$prefs = new (0, $40d859d8b2b40f24$export$9ce7d5e09dbc1d92)($cd93687958c8007e$var$db);
const $cd93687958c8007e$var$planMgrV2 = new (0, $504968b933aff167$export$2e2bcd8739ae039)($cd93687958c8007e$var$db, $cd93687958c8007e$var$queryClient);
const $cd93687958c8007e$var$waypointManager = new (0, $02e6513a95c7c4f6$export$2e2bcd8739ae039)($cd93687958c8007e$var$db, $cd93687958c8007e$var$queryClient);
const $cd93687958c8007e$var$navPointManager = new (0, $96e88338c4df101c$export$2e2bcd8739ae039)($cd93687958c8007e$var$db, $cd93687958c8007e$var$queryClient);
function $cd93687958c8007e$var$Public() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8921079907ea55d7$export$e926676385687eaf, {
        fallback: ({ error: error })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $47b3c0eb5fee4469$export$2e2bcd8739ae039), {
                message: error.message,
                stack: error.stack
            }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d99e0e9b4d6f6228$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                        path: `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).PublicFragOrder}/:id`,
                        component: (0, $5a5fe601f9b9e371$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).DiscordOauth,
                        component: (0, $7066692e20f21333$export$2e2bcd8739ae039)
                    })
                ]
            })
        ]
    });
}
const $cd93687958c8007e$var$WrappedPublic = (0, $45ac2aaecfc15258$export$86775893490a9f43)([
    [
        (0, $12433c9be3a4ac8d$export$2e2bcd8739ae039),
        {
            theme: (0, $db2db21855bd19e8$export$bca14c5b3b88a9c9)
        }
    ],
    [
        (0, $f8dbcd8598db1f0b$export$d8964aec282183a3),
        {
            theme: (0, $db2db21855bd19e8$export$bca14c5b3b88a9c9)
        }
    ],
    [
        (0, $9e9e9cb50078a9ef$export$186b91822010e97f),
        {}
    ],
    [
        (0, $3090f115e7fbf8a2$export$2e2bcd8739ae039),
        {
            app: $cd93687958c8007e$var$app,
            auth: $cd93687958c8007e$var$auth,
            db: $cd93687958c8007e$var$db
        }
    ],
    [
        (0, $ccb8f828cefd6075$export$45604f0cc8ae667b),
        {
            client: $cd93687958c8007e$var$queryClient
        }
    ],
    [
        (0, $5f078b543969ac27$export$88f24fd8fcfab6ca),
        {}
    ],
    [
        (0, $1bfb465a9f0e47a1$export$6d7e43f2d6e1c7c6),
        {
            db: $cd93687958c8007e$var$db
        }
    ],
    [
        (0, $a10ff9c4760c9625$export$39c9bd023eb21cf0),
        {
            reader: $cd93687958c8007e$var$reader
        }
    ],
    [
        (0, $a6d9669b5694b4b9$export$a9089b66d078b0e4),
        {
            manager: $cd93687958c8007e$var$external
        }
    ],
    [
        (0, $92839c6c950486dc$export$ee75abe092c19c2),
        {
            manager: (0, $c0b77a82ffc4d539$export$544da8ef3568537b)($cd93687958c8007e$var$db, $cd93687958c8007e$var$fetcher)
        }
    ],
    [
        (0, $de1274ee98092164$export$51d3d37f5897afd5),
        {
            manager: $cd93687958c8007e$var$am
        }
    ],
    [
        (0, $9fa5a1ec57c21134$export$871d43b949ab7987),
        {
            client: $cd93687958c8007e$var$bc
        }
    ],
    [
        (0, $9e79ec4b86b0bc11$export$c82639dc638c4e5),
        {
            manager: $cd93687958c8007e$var$cm
        }
    ],
    [
        (0, $eb85d675c21bd358$export$90cb89d094cdf2e0),
        {
            api: $cd93687958c8007e$var$signups
        }
    ],
    [
        (0, $1ae4eb57bb4d8f1b$export$4cd335292efb4883),
        {
            manager: $cd93687958c8007e$var$planMgrV2,
            waypointManager: $cd93687958c8007e$var$waypointManager,
            navPointManager: $cd93687958c8007e$var$navPointManager
        }
    ]
])(/*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$Public, {}));
const $cd93687958c8007e$var$WrappedAdmin = (0, $45ac2aaecfc15258$export$86775893490a9f43)([
    [
        (0, $12433c9be3a4ac8d$export$2e2bcd8739ae039),
        {
            theme: (0, $db2db21855bd19e8$export$bca14c5b3b88a9c9)
        }
    ],
    [
        (0, $f8dbcd8598db1f0b$export$d8964aec282183a3),
        {
            theme: (0, $db2db21855bd19e8$export$bca14c5b3b88a9c9)
        }
    ],
    [
        (0, $9e9e9cb50078a9ef$export$186b91822010e97f),
        {}
    ],
    [
        (0, $6400a94b66d5ff2d$export$2e2bcd8739ae039),
        {
            discord: $cd93687958c8007e$var$discord
        }
    ],
    [
        (0, $3090f115e7fbf8a2$export$2e2bcd8739ae039),
        {
            app: $cd93687958c8007e$var$app,
            auth: $cd93687958c8007e$var$auth,
            db: $cd93687958c8007e$var$db
        }
    ],
    [
        (0, $ccb8f828cefd6075$export$45604f0cc8ae667b),
        {
            client: $cd93687958c8007e$var$queryClient
        }
    ],
    [
        (0, $5f078b543969ac27$export$88f24fd8fcfab6ca),
        {}
    ],
    [
        (0, $1bfb465a9f0e47a1$export$6d7e43f2d6e1c7c6),
        {
            db: $cd93687958c8007e$var$db
        }
    ],
    [
        (0, $a7e8caa803539e5f$export$cd94e60a17ee9cf7),
        {
            client: $cd93687958c8007e$var$fo
        }
    ],
    [
        (0, $e1f03c0083d00e9b$export$b0eb5dd44c72ef97),
        {
            subs: (0, $dbf86a8fe13ef9de$export$7540639e9eb63b3b)($cd93687958c8007e$var$fetcher)
        }
    ],
    [
        (0, $aae70ce689e02dd3$export$a98e73a25480d7d3),
        {
            manager: $cd93687958c8007e$var$pub
        }
    ],
    [
        (0, $a10ff9c4760c9625$export$39c9bd023eb21cf0),
        {
            reader: $cd93687958c8007e$var$reader
        }
    ],
    [
        (0, $a6d9669b5694b4b9$export$a9089b66d078b0e4),
        {
            manager: $cd93687958c8007e$var$external
        }
    ],
    [
        (0, $9fa5a1ec57c21134$export$871d43b949ab7987),
        {
            client: $cd93687958c8007e$var$bc
        }
    ],
    [
        (0, $9e79ec4b86b0bc11$export$c82639dc638c4e5),
        {
            manager: $cd93687958c8007e$var$cm
        }
    ],
    [
        (0, $92839c6c950486dc$export$ee75abe092c19c2),
        {
            manager: (0, $c0b77a82ffc4d539$export$544da8ef3568537b)($cd93687958c8007e$var$db, $cd93687958c8007e$var$fetcher)
        }
    ],
    [
        (0, $de1274ee98092164$export$51d3d37f5897afd5),
        {
            manager: $cd93687958c8007e$var$am
        }
    ],
    [
        (0, $eb85d675c21bd358$export$90cb89d094cdf2e0),
        {
            api: $cd93687958c8007e$var$signups
        }
    ],
    [
        (0, $38644a8687878cac$export$426775f502b733a5),
        {
            storer: $cd93687958c8007e$var$ms
        }
    ],
    [
        (0, $76177b68db1e554f$export$64b5917bffaa59c2),
        {
            fetch: fetch
        }
    ],
    [
        (0, $49b61c4bd4225956$export$1ea71c1002a93812),
        {
            manager: $cd93687958c8007e$var$prefs
        }
    ],
    [
        (0, $1ae4eb57bb4d8f1b$export$4cd335292efb4883),
        {
            manager: $cd93687958c8007e$var$planMgrV2,
            waypointManager: $cd93687958c8007e$var$waypointManager,
            navPointManager: $cd93687958c8007e$var$navPointManager
        }
    ]
])(/*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$Admin, {}));
function $cd93687958c8007e$var$Admin() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d99e0e9b4d6f6228$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ec614839e381234a$export$2e2bcd8739ae039), {
                mode: "admin"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8921079907ea55d7$export$e926676385687eaf, {
                fallback: ({ error: error })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $47b3c0eb5fee4469$export$2e2bcd8739ae039), {
                        message: error.message,
                        stack: error.stack
                    }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84a93f03d5e878eb$export$2e2bcd8739ae039), {
                            exact: true,
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).Home,
                            component: (0, $1bebff9c945fc3b3$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84a93f03d5e878eb$export$2e2bcd8739ae039), {
                            exact: true,
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).NewFragOrder,
                            component: (0, $d160c7a664d63e0f$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84a93f03d5e878eb$export$2e2bcd8739ae039), {
                            path: `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).FragOrderDetail}/:id`,
                            component: (0, $9f72663470074fe3$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).RedeemCode,
                            component: (0, $65bf097f1591a9ef$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).Login,
                            component: (0, $426e52f8305c025b$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).DiscordOauth,
                            component: (0, $7066692e20f21333$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            exact: true,
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).Logout,
                            component: (0, $55c366344d5ed0aa$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84a93f03d5e878eb$export$2e2bcd8739ae039), {
                            exact: true,
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).UserSettings,
                            component: (0, $c5389d9d58bbc4b2$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            path: `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).PublicFragOrder}/:id`,
                            component: (0, $5a5fe601f9b9e371$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).StandaloneSignupsPage,
                            component: (0, $f9c437f0d6220302$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            path: (0, $91a9098e14452db2$export$37d3279522fbf5e2).StripeCallback,
                            component: (0, $ccb644a00c554876$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76177b68db1e554f$export$64b5917bffaa59c2), {
                            fetch: window.fetch,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                path: `${(0, $91a9098e14452db2$export$37d3279522fbf5e2).SuperAdmin}`,
                                component: (0, $b92f5c3ae8797ac1$export$2e2bcd8739ae039)
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                            path: "*",
                            component: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10469897db0fb9cc$export$2e2bcd8739ae039), {
                                        center: true,
                                        children: "404"
                                    })
                                })
                        })
                    ]
                })
            })
        ]
    });
}
function $cd93687958c8007e$export$2e2bcd8739ae039({ mode: mode }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8921079907ea55d7$export$e926676385687eaf, {
        fallback: ({ error: error })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $47b3c0eb5fee4469$export$2e2bcd8739ae039), {
                message: error.message,
                stack: error.stack
            }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3189c83282a9a1c6$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84a59591ecbdf222$export$2e2bcd8739ae039), {
                mode: mode,
                children: mode === "admin" ? $cd93687958c8007e$var$WrappedAdmin : $cd93687958c8007e$var$WrappedPublic
            })
        })
    });
}


const $2b6e161c9edcf319$var$history = (0, $2756f79476f0245f$export$719fc203c4e16dee)();
const $2b6e161c9edcf319$var$container = document.getElementById("app");
const $2b6e161c9edcf319$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($2b6e161c9edcf319$var$container);
$2b6e161c9edcf319$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {
    history: $2b6e161c9edcf319$var$history,
    mode: "admin"
}));


//# sourceMappingURL=index.b42468d6.js.map
